(function ()
{
    'use strict';

    angular
        .module('app.e-commerce',
            [
                'app.settings.roomLockEncoder',
                // 3rd Party Dependencies
                'wipImageZoom',
                'datatables',
                'flow',
                'nvd3',
                'uiGmapgoogle-maps',
                'xeditable',
                'ngMaterial',
                'mdDataTable',
                'ui.sortable',
                'angAccordion',
                'ngFileUpload',
                'ui.sortable',
                'credit-cards',
                'color.picker',
                'uiCropper'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider){
        // State
        $stateProvider
            .state('app.e-commerce', {
                abstract: true,
                url     : '/e-commerce',
                title   : 'E-commerce',
            })
            .state('app.e-commerce.dashboard', {
                url      : '/dashboard',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/dashboard/dashboard.html',
                        controller : 'DashboardEcommerceController as vm'
                    }
                },
                resolve  : {
                    Dashboard: function (msApi){
                        return msApi.resolve('e-commerce.dashboard@get');
                    }
                },
                bodyClass: 'ecommerce'
            })
            .state('app.e-commerce.productsDel', {
                url      : '/productsDel',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/products/products.html',
                        controller : 'ProductsController as vm'
                    }
                },
                permission: 'rooms',
                resolve  : {
                    Types: function (eCommerceService){
                        return eCommerceService.getProductTypes();
                    }
                },
                bodyClass: 'e-commerce'
            }).
            state('app.e-commerce.taxes', {
                url      : '/tax',
                title   : 'Taxes and Fees',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/taxes/taxes.html',
                        controller : 'taxesController as vm'
                    }
                },
                resolve  : {
                    CurrentTax: function (eCommerceService){
                        return eCommerceService.getDefaultTaxData();
                    }
                },
                permission: 'taxes',
                bodyClass: 'e-commerce'
            }).state('app.e-commerce.products.add', {
                url      : '/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/product/product.html',
                        controller : 'ProductController as vm'
                    }
                },
                resolve: {
                    Product: function (eCommerceService,$rootScope,$localStorage){
                        return eCommerceService.newProduct({'hotel_ids':$localStorage.hotels[$localStorage.selectedHotel].hotel_id,'category_type':'Room'});
                    }
                },
                permission: 'add_room',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.products.detail', {
                url      	: '/:id',
                views    	: {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/product/product.html',
                        controller : 'ProductController as vm'
                    }
                },
                resolve  : {
                    Product: function ($stateParams,eCommerceService)
                    {
						return eCommerceService.getProduct($stateParams.id);                      
                    }
                },
                permission: 'update_room',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.orders', {
                url      : '/orders',
                title    : 'Reservations',
                params   : {toast_message:false,page_type:'reservation'},
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/orders/orders.html',
                        controller : 'OrdersController as vm'
                    }
                },
                permission: 'reservations',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.black-listed-orders', {
                url      : '/black-listed-orders',
                title    : 'Black Listed Reservations',
                params   : {toast_message:false,page_type:'reservation', black_listed_reservations: true},
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/orders/orders.html',
                        controller : 'OrdersController as vm'
                    }
                },
                permission: 'reservations',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.boatRoomOrders', {
                url      : '/boat-room-orders',
                title    : 'Boot And Room Resvs',
                params   : {toast_message:false,page_type:'boat+room'},
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/orders/orders.html',
                        controller : 'OrdersController as vm'
                    }
                },
                permission: 'reservations',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.boatOrders', {
                url      : '/boat-orders',
                title    : 'Boat Reservations',
                params   : {toast_message:false,page_type:'boat'},
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/orders/orders.html',
                        controller : 'OrdersController as vm'
                    }
                },
                // params   : {page_type:'boat'},
                permission: 'boats',
                bodyClass: 'e-commerce'
            }).state('app.e-commerce.rentOrders', {
                url      : '/rent-orders',
                title    : 'Rental Reservations',
                params	 : {toast_message:false,page_type:'rent'},
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/orders/orders.html',
                        controller : 'OrdersController as vm'
                    }
                },
                // params   : {page_type:'boat'},
                permission: 'boats',
                bodyClass: 'e-commerce'
            }).state('app.e-commerce.orders.detail', {
                url      : '/:id',
                title    : 'Reservation',
                params      : {confirmation_number:'',changeStatusData:''},
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/orders/order/order.html',
                        controller : 'OrderController as vm'
                    }
                },
                resolve  : {
                    Order : function ($stateParams, eCommerceService){
                        if($stateParams.changeStatusData == '')
                            var changeStatusData = false;
                        else
                            var changeStatusData = true;
                        return eCommerceService.getOrder($stateParams.id,$stateParams.confirmation_number,changeStatusData);
                    },
                    Reservation_id : function ($stateParams){
                        return $stateParams.id;
                    }
                },
                permission: 'reservations',
                bodyClass: 'e-commerce'
            }).state('app.e-commerce.boatOrders.detail', {
                url      : '/:id',
                title    : 'Boat Reservation',
                params      : {confirmation_number:'',changeStatusData:''},
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/orders/order/order.html',
                        controller : 'OrderController as vm'
                    }
                },
                resolve  : {
                    Order : function ($stateParams, eCommerceService){
                        if($stateParams.changeStatusData == '')
                            var changeStatusData = false;
                        else
                            var changeStatusData = true;
                        return eCommerceService.getOrder($stateParams.id,$stateParams.confirmation_number,changeStatusData);
                    },
                    Reservation_id : function ($stateParams){
                        return $stateParams.id;
                    }
                },
                permission: 'reservations',
                bodyClass: 'e-commerce'
            }).state('app.e-commerce.rentOrders.detail', {
                url      : '/:id',
                title    : 'Rental Reservation',
                params		: {confirmation_number:'',changeStatusData:''},
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/orders/order/order.html',
                        controller : 'OrderController as vm'
                    }
                },
                resolve  : {
                    Order : function ($stateParams, eCommerceService){
						if($stateParams.changeStatusData == '')
							var changeStatusData = false;
						else
							var changeStatusData = true;
						return eCommerceService.getOrder($stateParams.id,$stateParams.confirmation_number,changeStatusData);
                    },
                    Reservation_id : function ($stateParams){
                        return $stateParams.id;
                    }
                },
                permission: 'reservations',
                bodyClass: 'e-commerce'
            }).state('app.e-commerce.amenities', {
                url      : '/property-amenities',
                title    : 'Property Amenities',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/amenities/property_amenities/property_amenities.html',
                        controller : 'PropertyAmenitiesController as vm'
                    }
                },
                resolve  : {
                    Amenities : function (amenitiesService){
                        return amenitiesService.getAllPropertyAmenities();
                    }
                },
                permission: 'property_amenities',
                bodyClass: 'e-commerce'
			})
            .state('app.e-commerce.hotelamenities', {
                url      : '/room-amenities',
                title    : 'Room Amenities',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/amenities/amenities.html',
                        controller : 'AmenitiesController as vm'
                    }
                },
                resolve  : {
                    Amenities : function (amenitiesService){
                        var data = {dataType: 'Rooms'};
                        return amenitiesService.getAllHotelAmenities(data);
                    }
                },
                params   : {page_type:'Rooms'},
				permission: 'all_room_amenities',
                bodyClass: 'e-commerce'
			})
            .state('app.e-commerce.boatamenities', {
                url      : '/boat-amenities',
                title    : 'Boat Amenities',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/amenities/amenities.html',
                        controller : 'AmenitiesController as vm'
                    }
                },
                resolve  : {
                    Amenities : function (amenitiesService){
                        var data = {dataType: 'Boats'};
                        return amenitiesService.getAllHotelAmenities(data);
                    }
                },
                params   : {page_type:'Boats'},
                permission: 'boats',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.roomtypes', {
                url      : '/roomtypes',
                title    : 'Rooms',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/roomtypes/roomtypes.html',
                        controller : 'RoomtypesController as vm'
                    }
                },
                params   : {page_type:'Rooms'},
                permission: 'rooms',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.boattypes', {
                url      : '/boattypes',
                title    : 'Boats',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/roomtypes/roomtypes.html',
                        controller : 'RoomtypesController as vm'
                    }
                },
                params   : {page_type:'Boats'},
                permission: 'boats',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.roomtypes.add', {
                url      : '/add',
                title    : 'Rooms',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/roomtype/roomtype.html',
                        controller : 'RoomtypeController as vm'
                    }
                },
                resolve  : {
                    roomTypeComponentData: function (roomTypeService, $localStorage,$stateParams){
                        var hotelID = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
                        var type = $stateParams.page_type;
                        return roomTypeService.roomTypeComponentData(hotelID,'',type);
                    },
                    roomTypeData: function() {
                        return {};
                    },
                    tabMode: function(){
                        return 'add';
                    }
                },
                permission: 'add_room',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.boattypes.add', {
                url      : '/add',
                title    : 'Boats',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/roomtype/roomtype.html',
                        controller : 'RoomtypeController as vm'
                    }
                },
                resolve  : {
                    roomTypeComponentData: function (roomTypeService, $localStorage, $stateParams){
                        var hotelID = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
                        var type = $stateParams.page_type;
                        return roomTypeService.roomTypeComponentData(hotelID,'',type);
                    },
                    roomTypeData: function() {
                        return {};
                    },
                    tabMode: function(){
                        return 'add';
                    }
                },
                permission: 'add_room',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.roomtypes.update', {
                url      : '/:roomTypeID',
                title    : 'Rooms',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/roomtype/roomtype.html',
                        controller : 'RoomtypeController as vm'
                    }
                },
                resolve  : {
                    roomTypeComponentData: function (roomTypeService, $localStorage, $stateParams){
                        var hotelID = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
                        var roomTypeID = $stateParams.roomTypeID;
                        var type = $stateParams.page_type;
                        return roomTypeService.roomTypeComponentData(hotelID,roomTypeID,type);
                    },
                    roomTypeData: function (roomTypeService,$stateParams){
                        return roomTypeService.roomTypeData($stateParams.roomTypeID);
                    },
                    tabMode: function(){
                        return 'edit';
                    }
                },
                permission: 'update_room',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.boattypes.update', {
                url      : '/:roomTypeID',
                title    : 'Boats',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/roomtype/roomtype.html',
                        controller : 'RoomtypeController as vm'
                    }
                },
                resolve  : {
                    roomTypeComponentData: function (roomTypeService, $localStorage, $stateParams){
                        var hotelID = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
                        var roomTypeID = $stateParams.roomTypeID;
                        var type = $stateParams.page_type;
                        return roomTypeService.roomTypeComponentData(hotelID,roomTypeID,type);
                    },
                    roomTypeData: function (roomTypeService,$stateParams){
                        return roomTypeService.roomTypeData($stateParams.roomTypeID);
                    },
                    tabMode: function(){
                        return 'edit';
                    }
                },
                permission: 'update_room',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.activities', {
                url      : '/products',
                title    : 'Products',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/activities/activities.html',
                        controller : 'ActivitiesController as vm'
                    }
                },
                params   : {page_type:'Rooms'},
                permission: 'products',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.boat-activities', {
                url      : '/boat-products',
                title    : 'Boat Products',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/activities/activities.html',
                        controller : 'ActivitiesController as vm'
                    }
                },
                params   : {page_type:'Boats'},
                permission: 'products',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.activities.add', {
                url      : '/add',
                title    : 'Products',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/activities/activity/activity.html',
                        controller : 'ActivityController as vm'
                    }
                },
                resolve  : {
                    activityComponentData : function(activityService, $localStorage) {
                        var hotelID = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
                        return activityService.activityComponentData(hotelID)
                    },
                    activityData: function() {
                        return {};
                    }
                },
                params   : {page_type:'Rooms'},
                permission: 'add_product',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.boat-activities.add', {
                url      : '/add',
                title    : 'Boat Products',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/activities/activity/activity.html',
                        controller : 'ActivityController as vm'
                    }
                },
                resolve  : {
                    activityComponentData : function(activityService, $localStorage) {
                        var hotelID = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
                        return activityService.activityComponentData(hotelID)
                    },
                    activityData: function() {
                        return {};
                    }
                },
                params   : {page_type:'Boats'},
                permission: 'add_product',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.activities.update', {
                url      : '/:productID',
                title    : 'Products',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/activities/activity/activity.html',
                        controller : 'ActivityController as vm'
                    }
                },
                resolve  : {
                    activityComponentData : function(activityService, $localStorage, $stateParams) {
                        var hotelID = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
                        return activityService.activityComponentData(hotelID,null,$stateParams.productID)
                    },
                    activityData: function (activityService,$stateParams){
                        return activityService.activityData($stateParams.productID);
                    }
                },
                params   : {page_type:'Rooms'},
                permission: 'update_product',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.boat-activities.update', {
                url      : '/:productID',
                title    : 'Boat Products',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/activities/activity/activity.html',
                        controller : 'ActivityController as vm'
                    }
                },
                resolve  : {
                    activityComponentData : function(activityService, $localStorage, $stateParams) {
                        var hotelID = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
                        return activityService.activityComponentData(hotelID,null,$stateParams.productID)
                    },
                    activityData: function (activityService,$stateParams){
                        return activityService.activityData($stateParams.productID);
                    }
                },
                params   : {page_type:'Boats'},
                permission: 'update_product',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.bundlerooms', {
                url      : '/bundlerooms',
                title    : 'Bundle Rooms',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/bundlerooms/bundlerooms.html',
                        controller : 'BundleroomsController as vm'
                    }
                },
                params   : {page_type:'bundleRooms'},
                permission: 'bundle_rooms',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.bundleboats', {
                url      : '/bundleboats',
                title    : 'Bundle Boats',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/bundlerooms/bundlerooms.html',
                        controller : 'BundleroomsController as vm'
                    }
                },
                params   : {page_type:'bundleBoats'},
                permission: 'bundle_rooms',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.bundlerooms.bundleroomadd', {
                url      : '/bundleroom/add',
                title    : 'Bundle Rooms',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/bundlerooms/bundleroom/bundleroom.html',
                        controller : 'BundleroomController as vm'
                    }
                },
                resolve  : {
                    RoomsList: function (bundleRoomsService){
                        var data = {
                            pageType: 'room'
                        };
                        return bundleRoomsService.getRoomsList(data);
                    },
                    BundleData: function (bundleRoomsService,$stateParams){
                        if($stateParams.hasOwnProperty('id') && $stateParams.id > 0){
                            return bundleRoomsService.getBundleInfo({id:$stateParams.id});
                        } else {
                            return [];
                        }
                    }
                },
                params   : {page_type:'bundleRooms'},
                permission: 'add_bundle',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.bundleboats.bundleboatadd', {
                url      : '/bundleboat/add',
                title    : 'Bundle Boats',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/bundlerooms/bundleroom/bundleroom.html',
                        controller : 'BundleroomController as vm'
                    }
                },
                resolve  : {
                    RoomsList: function (bundleRoomsService){
                        var data = {
                            pageType: 'boat'
                        };
                        return bundleRoomsService.getRoomsList(data);
                    },
                    BundleData: function (bundleRoomsService,$stateParams){
                        if($stateParams.hasOwnProperty('id') && $stateParams.id > 0){
                            return bundleRoomsService.getBundleInfo({id:$stateParams.id});
                        } else {
                            return [];
                        }
                    }
                },
                params   : {page_type:'bundleBoats'},
                permission: 'add_bundle',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.bundlerooms.bundleroomupdate', {
                url      : '/bundleroom/:id',
                title    : 'Bundle Rooms',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/bundlerooms/bundleroom/bundleroom.html',
                        controller : 'BundleroomController as vm'
                    }
                },
                resolve  : {
                    RoomsList: function (bundleRoomsService){
                        var data = {
                            pageType: 'room'
                        };
                        return bundleRoomsService.getRoomsList(data);
                    },
                    BundleData: function (bundleRoomsService,$stateParams){
                        if($stateParams.hasOwnProperty('id') && $stateParams.id > 0){
                            return bundleRoomsService.getBundleInfo({id:$stateParams.id});
                        } else {
                            return [];
                        }
                    }
                },
                params   : {page_type:'bundleRooms'},
                permission: 'update_bundle',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.bundleboats.bundleboatupdate', {
                url      : '/bundleboat/:id',
                title    : 'Bundle Boats',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/bundlerooms/bundleroom/bundleroom.html',
                        controller : 'BundleroomController as vm'
                    }
                },
                resolve  : {
                    RoomsList: function (bundleRoomsService){
                        var data = {
                            pageType: 'boat'
                        };
                        return bundleRoomsService.getRoomsList(data);
                    },
                    BundleData: function (bundleRoomsService,$stateParams){
                        if($stateParams.hasOwnProperty('id') && $stateParams.id > 0){
                            return bundleRoomsService.getBundleInfo({id:$stateParams.id});
                        } else {
                            return [];
                        }
                    }
                },
                params   : {page_type:'bundleBoats'},
                permission: 'update_bundle',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.giftcards', {
                url      : '/giftcards',
                title    : 'Gift Cards',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/giftcards/giftcard.html',
                        controller : 'GiftcardController as vm'
                    }
                },
                resolve  : {
                    getGiftCard: function (giftCardService, $localStorage){
                        var hotelID = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
                        return giftCardService.getGiftCard(hotelID);
                    },
                    taxData: function (giftCardService, $localStorage, $stateParams){
                        var hotelID = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
                        return giftCardService.taxData(hotelID);
                    }
                },
                permission: 'gift_card_settings',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.gcadmins', {
                url      : '/gcadmins',
                title    : 'Gift Cards',  
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/gcadmins/gcadmins.html',
                        controller : 'GcadminsController as vm'
                    }
                },
                permission: 'gift_cards',
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.gcadmins.add', {
                url      : '/add',
                title    : 'Gift Cards',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/gcadmin/gcadmin.html',
                        controller : 'GcadminController as vm'
                    }
                },
                permission: 'add_gift_card',
                resolve  : {
                    getGiftCard: function (){
                        return {};
                    }
                },
                bodyClass: 'e-commerce'
            })
            .state('app.e-commerce.gcadmins.update', {
                url      : '/:giftCardID',
                title    : 'Gift Cards',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/e-commerce/views/gcadmin/gcadmin.html',
                        controller : 'GcadminController as vm'
                    }
                },
                resolve  : {
                    getGiftCard: function (gcAdminService, $localStorage, $stateParams){
                        var hotelID = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
                        var giftCardID = $stateParams.giftCardID;
                        var data = {
                            hotelID: hotelID,
                            giftCardID: giftCardID
                        };
                        return gcAdminService.getGiftCard(data);
                    }
                },
                permission: 'update_gift_card',
                bodyClass: 'e-commerce'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/e-commerce');

        // Api
        msApiProvider.register('e-commerce.dashboard', ['app/data/e-commerce/dashboard.json']);
        msApiProvider.register('e-commerce.orders', ['app/data/e-commerce/orders.json']);
        msApiProvider.register('e-commerce.order-statuses', ['app/data/e-commerce/order-statuses.json']);
    }
})();

(function ()
{
    'use strict';

    angular
    .module('app.e-commerce')
    .controller('RoomtypeDialogController', RoomtypeDialogController);
    /** @ngInject */  
    function RoomtypeDialogController($mdDialog, Image, originalImage, type, pageType, imageIndex, coverPhoto, typeId, toastMessage, $scope, EnvironmentConfig, $sce, Upload, $timeout, $rootScope,$cookies){        
        var vm = this;
        vm.type = '';
        vm.pdfPath = '';
        // Data
        vm.feBaseUrl=EnvironmentConfig.feBase_url;
        if(Object.getPrototypeOf(Image) === Object.prototype && Image.type != undefined && Image.type == 'pdf') {
            vm.type = 'pdf';
            vm.pdfPath = Image.path;
        } else {
            vm.image = Image; 
            $cookies.put('myFavorite', Image);                       
        }
        vm.closeImage = EnvironmentConfig.app+'src/assets/angular-material-assets/img/icons/facebook.svg';
        
        // Methods
        vm.closeDialog = closeDialog;
        
        /**
        * Close dialog
        */
        vm.progressnum1=0;
        vm.progress1=false;
        vm.feBaseUrl=EnvironmentConfig.feBase_url;
        $scope.blockingObject = {block: true};
        $scope.myImage=vm.image;  
        $scope.originalImage=originalImage;  
        $scope.myCroppedImage='';
        $scope.finalImage="";
        $scope.angleInDegrees=0;
        vm.imageRotation=false;
        vm.imageCropping=false;
        $scope.saveRotatedImageangle=0;
        $scope.clockwise=function(){
            $scope.angleInDegrees+=90;
            $scope.drawRotated();
            $scope.saveRotatedImageangle+=270;
        }
        $scope.counterclockwise=function(){
            $scope.angleInDegrees-=90;
            $scope.drawRotated();
            $scope.saveRotatedImageangle+=90;
        };
        $scope.imageName='';
        $scope.drawRotated=function(){
            document.getElementById("imageForRotation").style.transform="rotate("+$scope.angleInDegrees+"deg)";
            var url = vm.image;
            var parts = url.split("/");
            var last_part = parts[parts.length-1];
            $scope.imageName=last_part;
        }




        $scope.saveRotatedImage =function (deg) {
            Upload.upload({
                url: EnvironmentConfig.api + 'roomtypes/saveRotatedImage',
                data: {
                    roomTypeID: typeId,
                    pageType: pageType,
                    catalog_product_media_id:$scope.originalImage,
                    angleInDegrees:deg,
                    fileName:$scope.imageName,
                    imageIndex:imageIndex,
                    coverPhoto:coverPhoto
                },
            }).then(function (response) {
                $scope.errorMsg = response.data.message;
                if (response.data.status == "success"){ 
                    vm.image=response.data.data.new_image;
                    $rootScope.imageData = response.data.files;
                    $rootScope.$broadcast('uploadedImages', { data: response.data.data.files,index:imageIndex ,crop:false});  
                    $timeout(function() {
                        vm.imageRotation=false;
                        $mdDialog.hide();
                    }, 100);
                } else {
                }
            });
        };
        
        function closeDialog(){

            if($scope.saveRotatedImageangle>360){
                while($scope.saveRotatedImageangle>360){
                    $scope.saveRotatedImageangle-=360;
                    console.log($scope.saveRotatedImageangle);
                }
            } else if($scope.saveRotatedImageangle==360 || $scope.saveRotatedImageangle==0){
                $mdDialog.hide();
            } else {
                console.log($scope.saveRotatedImageangle);
            }
            vm.imageRotation=true;
            $scope.saveRotatedImage($scope.saveRotatedImageangle);
        }

        $scope.trustSrc = function(src) {
            return $sce.trustAsResourceUrl(src);
        }

        $scope.showMsg = false;
        $scope.saveCropImage = function () {
            vm.progress1 = true;
            $("#cropArea").css('pointer-events',"none");
            $scope.blockingObject.render(function (dataURL) {
                Upload.upload({
                    url: EnvironmentConfig.api + 'roomtypes/product_coverImage',
                    data: {
                        file: $scope.originalImage,
                        cropImg: Upload.dataUrltoBlob(dataURL),
                        roomTypeID: typeId,
                        pageType: pageType
                    },
                    uploadEventHandlers: { progress: function(evt){
                        if (evt.lengthComputable) {
                            vm.progressnum1 = Math.round(evt.loaded * 100 / evt.total)
                        } else {
                            vm.progressnum1 = 'unable to compute'
                        }
                        if(vm.progressnum1 >= 100){
                            vm.progress1 = false;
                            $timeout(function() {
                                vm.imageCropping =true;
                            },100);
                        }
                    }}
                }).then(function (response) {
                    $scope.errorMsg = response.data.message;
                    if (response.data.status == "success"){ 
                        $rootScope.imageData = response.data.files;
                        $rootScope.$broadcast('uploadedImages', { data: response.data.data.files,index:'',crop:true });
                        $scope.showMsg = true;
                        vm.imageCropping =false;
                        $timeout(function() {
                            $mdDialog.hide();
                        }, 500);
                    } else {
                        $scope.showMsg = false;
                    }
                });
            });
        };

        if(type != undefined && type == "cropping"){
            vm.requestType = "cropImg";
        } else {
            vm.requestType = "viewImg";
        }
    }
})();

(function ()
{
    'use strict';
    angular.module('app.e-commerce')
        .controller('printInvoiceController', printInvoiceController);

    /** @ngInject */
    function printInvoiceController(
    	$mdDialog,
    	$rootScope,
    	resvId,
    	confNo,
    	travellInfo,
    	typePrint
    ) {
		var vm = this;
		vm.travellerInfo = (travellInfo != undefined && travellInfo.length) ? travellInfo : [];
		vm.customer = true;
		vm.traveller = false;
		vm.disableButton = false;
		vm.subTravellers = {};
		if (vm.travellerInfo.length > 0) {
			angular.forEach(vm.travellerInfo, function(value, key) {
				vm.subTravellers['_'+value.travellerId] = false;
			});
		}
		vm.typePrint = typePrint;
		vm.changeOption = function(type) {
			if (type == 'traveller' && vm.travellerInfo.length) {
				vm.changeSubTravellers(vm.traveller);
			}
			if (!vm.customer && !vm.traveller) {
				vm.disableButton = true;
			} else {
				vm.disableButton = false;
			}
		};

		vm.printInvoice = function() {
			$rootScope.$broadcast('printInvoiceType',{customer: vm.customer, traveller: vm.traveller, resvId: resvId, confNo: confNo, subTravellers: vm.subTravellers,typePrint:vm.typePrint});
			$mdDialog.hide();
		};

		vm.changeSubTravellers = function(selectAllVal) {
			var checked = 0;
			angular.forEach(vm.travellerInfo, function(value, key) {
				if (selectAllVal != undefined) {
					vm.subTravellers['_'+value.travellerId] = selectAllVal;
				}
				if (vm.subTravellers['_'+value.travellerId]) {
					checked++;
				}
			});

			if (checked == 0) {
				vm.traveller = false;
			} else {
				vm.traveller = true;
			}
			vm.changeOption();
		};

		vm.closeDialog = function() {
			$mdDialog.hide();
		};
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('OrderController', OrderController);

    /** @ngInject */
    function OrderController(
    	Order,
    	Reservation_id,
    	toastMessage,
    	$mdSidenav,
    	$state,
    	eCommerceService,
    	$scope,
    	$window,
    	$mdDialog,
    	ganttChartService,
    	$timeout,
    	$document,
    	commonService,
    	EnvironmentConfig,
    	$translate,
    	createResService,
    	$stateParams,
    	$location,
    	$sessionStorage,
    	$anchorScroll,
		$rootScope,
		userService,
		$q,
		$http,
		commonDailog,
		$localStorage,
		Upload,
		$compile
	){
		/* Variables & initializations */
		
		var vm = this;
		var customFlag = true;

		vm.resortFeeAppliedVisible = true;

		var autoFillData = {};
		vm.baseUrl = EnvironmentConfig.api;
		
		vm.superAdmin = false;
		vm.autoFillOff =true;
		if($localStorage.roleId == 1){
		vm.superAdmin = true;
		}

		vm.pageType = $stateParams['page_type'];
		if(vm.pageType == 'boat'){
			vm.title = 'ADD_BOAT_PLUS';
		} else {
			vm.title = 'ADD_ROOM_PLUS';
		}
		vm.stateStatus = false;
		vm.processRequest = false;
		vm.processRequest = true
        vm.reservation_id = Reservation_id;
        vm.statuses = {'Active':'Active','Checked-In':'Check-In','Checked-Out':'Check-Out','Closed':'Close','Canceled':'Cancel'};
        vm.pos_status = [];
        vm.dates_option = EnvironmentConfig.cc_dates_option;
        vm.yrs_option = commonService.calculateExpirationYears();
        vm.roomCount = 1;
        vm.ct = '';
        vm.trigDivStatus = true;
        vm.boatType = [{'name' : 'Power Boat', 'value' : 'powerboat'},{'name' : 'Sailboat', 'value' : 'sailboat'}];
        //~ var Order = {};
        vm.modify_request = false;
		vm.refundStart = false;
        vm.myDate = new Date();
		vm.minDate = new Date(
			vm.myDate.getFullYear(),
			vm.myDate.getMonth(),
			vm.myDate.getDate()
		);
		vm.endDateMin = new Date(
			vm.myDate.getFullYear(),
			vm.myDate.getMonth(),
			vm.myDate.getDate()
		);
        vm.dtOptionsForPayment = {
            autoWidth : false,
            responsive: true,
            paging: false,
            searching: false,
            order: [8, "asc"],
            oLanguage: {"sEmptyTable": "No installments paid yet."},
            columnDefs: [
                {
                    // Target the Action column
                    targets   : 7,
                    filterable: false,
                    responsivePriority: 1,
                    sortable  : false
                },
                {
					// Target the paid date column
					 targets   	: 1,
					 type		: 'date',
					 render   	: function( data, type, row, meta){
						var ThisDate = moment(new Date(data)).format("MM-DD-YYYY hh:mm:ss A");
						return ThisDate;
					 }
				}
            ]
        };

        vm.customerSameAsTraveller = false;
        vm.commentsSpecial = {};
        vm.masonryOptions = {
			columnCount     : 3,
			responsive      : {
				sm: 2,
				xs: 1
			}
		}

		vm.resortFeeApplied = {};

		vm.allRoomCancelled = false;
		var cancelledCount = 0;
		vm.selectedIndex = 0;
		vm.use_existingcard = '';
		vm.notCardType = '';
		vm.payingFromGC = {};
		vm.innerSlectedIndex = 0;
		vm.customeropened = false;
		vm.traveleropened = false;
		vm.incidentalrequestGoing = false;
		vm.showDiscountEdit = false;
        vm.tempData      = {0:'data'};
        vm.comment = vm.request = '';
        vm.isloading = true;
        vm.changingStatus = false;
        vm.changeStatusData = {};
        vm.print_data = false;
		vm.print_show_div = false;
		vm.showModifyBtn = false;
		vm.modificationComments = [];
		vm.paymentrequestGoing = false;
		vm.gcrequestGoing = false;
		vm.mainTabChangedAuto = false;
		vm.orderEmailUpdated = false;
		vm.reservationEmailUpdated = false;
		var simulateQuery = false;
		var countryList = [];
		var userPermissions = [];
		var originalOrderData = {};
		vm.parking_access = false;
		vm.print_registration = false;
		vm.showSliderControlls = false;
		var left = 0;
		var width;
		var tabsCount;
		var visibleOnScreen;
		var maxLeftAssign;
		vm.documents = [];
		vm.emptyDocs = false;
		/* Variables & initializations */
		
		/* Permissions Checks */
		if (typeof $rootScope.userPermissions != 'undefined') {
			userPermissions = $rootScope.userPermissions;
			if (userPermissions.indexOf('timebound_parking') != -1) {
				vm.parking_access = true;
			}
			if (userPermissions.indexOf('registration_card') != -1) {
				vm.print_registration = true;
			}
		}
		/* Permissions Checks */
		
		
		/* Initial Data for view page */
		if(Order.success && Order.response && Order.response.itinerary_number && Order.response.itinerary_number != 'undefined'){
			if(Order['response']['reservation_customer']['customer_id'] == Order['response']['reservations']['customer_id']){
	        	vm.customerSameAsTraveller = true;
	        }
			Order.response.tabs_data.forEach(function(element, index){
				if(element['room_stay_status'] == 'Canceled'){
					cancelledCount ++;
				}
			});
			if(cancelledCount == Order.response.tabs_data.length){
				vm.allRoomCancelled = true;
			}
			vm.roomCount = Order.response.room_stay_reservation;
			vm.extraPersonPos = Order['response']['extraPersonPos'];
			vm.is_child_allowed = Order['response']['is_child_allowed'];
			vm.order = Order.response.reservations;
			vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];	
			monthlyWeeklyNight(vm.order);
			

			if(vm.order.hasOwnProperty('boat_data') && Object.keys(vm.order.boat_data).length > 0){
				vm.boatData = vm.order.boat_data;
			}
			vm.order['extraPersonPos'] = Order['response']['extraPersonPos'];
			// vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];


			vm.resortFeeApplied[vm.selectedIndex] = Order['response']['reservations']['resortFeeApplied'];
			vm.resortFeeAppliedVisible = Order['response']['reservations']['resortFeeAppliedVisible'];
			
			vm.order.send_email_indicator = vm.order.send_email_indicator == 1 ?true:false;
			vm.allowed_card_types = Order.response.allowed_card_types;
			vm.statuses[vm.order.show_status] = vm.order.show_status;
			setAllStatuses();
			vm.tabs_data = Order.response.tabs_data;
			if($stateParams.confirmation_number != ''){
				var confirmation_number = $stateParams.confirmation_number;
				angular.forEach(vm.tabs_data, function (value, key)
				{
					if(value.confirmation_number == $stateParams.confirmation_number){
						vm.selectedIndex = key;
						vm.resortFeeApplied[vm.selectedIndex] = Order['response']['reservations']['resortFeeApplied'];
						vm.mainTabChangedAuto = true;
						if($stateParams.changeStatusData == ''){
							vm.showPaymentsLoader = true;
							$timeout(function() {
								vm.isloading = false;
								fetchPaymentsInformation(confirmation_number,vm.order.first_name,vm.order.last_name,vm.order.total_amount,vm.order.overalltotals.remaining_amount);
								originalOrderData = angular.copy(vm.order);
							},2000);
						} else {
							vm.changingStatus = true;
							vm.changeStatusData = $stateParams.changeStatusData;
							vm.showPaymentsLoader = true;
							$location.hash('data-table-' + key);
							$mdDialog.hide();
							$timeout(function(){
								$window.location.hash='';
								vm.isloading = false;
								fetchPaymentsInformation(confirmation_number,vm.order.first_name,vm.order.last_name,vm.order.total_amount,vm.order.overalltotals.remaining_amount);
								originalOrderData = angular.copy(vm.order);
							},2000);
						}
					}
				});
			} else {
				var confirmation_number = vm.order.confirmation_number;
				vm.showPaymentsLoader = true;
				$timeout(function() {
					vm.isloading = false;
					fetchPaymentsInformation(confirmation_number,vm.order.first_name,vm.order.last_name,vm.order.total_amount,vm.order.overalltotals.remaining_amount);
					originalOrderData = angular.copy(vm.order);
				},2000);
			}
			var Country = Order.response.countries;
			Country.forEach(function(element) {
				countryList.push(element.name);
			});
			var myCountryArr = loadAll();
			var testData = angular.copy(Order.response.reservation_customer);
			vm.all_payment_methods = Order.response.payment_methods;
			vm.reservation_customer = Order.response.reservation_customer;
			vm.orig_reservation_customer = angular.copy(Order.response.reservation_customer);

			if(vm.reservation_customer.country){
				vm.selectedCountry = {value:vm.reservation_customer.country.toLowerCase(),display:vm.reservation_customer.country};
			}
			$timeout(function(){
				vm.reservation_customer.state = testData.state;
				if(vm.reservation_customer.state){
					vm.selectedState = vm.reservation_customer.state;
					var test12 = angular.copy(vm.reservation_customer.state);
					updateCustomer('state', '');
				}
				vm.stateStatus = true;
				vm.reservation_customer.state = testData.state;
				vm.reservation_customer.send_email_indicator = vm.reservation_customer.send_email_indicator == 1 ?true:false;
				
				if(typeof Order['response']['reservations'] != 'undefined'){
					vm.adultRange = vm.getRangeArray(1, (parseInt(Order['response']['reservations']['max_occupancy'])-vm.order.room_stay_child_count));
					vm.childRange = vm.getRangeArray(0,( parseInt(Order['response']['reservations']['max_occupancy']) - vm.order.room_stay_guest_count));
				}
				/* code for top tabs slider */
				width = jQuery('.labels-blockclick-outer').width() - 60;
				tabsCount = parseInt(Object.keys(vm.tabs_data).length);
				visibleOnScreen = Math.ceil(parseInt(width) / parseInt(90));
				maxLeftAssign = parseInt(parseInt(tabsCount) - parseInt(visibleOnScreen)) * 90;
				maxLeftAssign = parseInt(parseInt(maxLeftAssign) + 30);
				if(visibleOnScreen < tabsCount){
					vm.showSliderControlls = true;
				} else {
					vm.showSliderControlls = false;
				}
				if(vm.selectedIndex > visibleOnScreen){
					left = -parseInt(parseInt(parseInt(vm.selectedIndex) - parseInt(visibleOnScreen)) + 1 ) * 90;
					left = parseInt(left - 50);
					jQuery('.labels-blockclick').css('left',left+'px');
				}
				/* code for top tabs slider */
			},3000);

			vm.arrival_departure_time = Order.response.arrival_departure_time;
			vm.itinerary_number = Order.response.itinerary_number;
			vm.payment_method = {};
			var count = 0;
			vm.fieldsIsReadOnly = false;

			vm.source_of_creation = (vm.order.source_of_creation == 'FE' || vm.order.source_of_creation == 'PMS')? '':vm.order.source_of_creation;
			vm.siteminder_id = vm.order.siteminder_id;
			if(vm.source_of_creation == 'FE' || vm.source_of_creation == "PMS" || typeof vm.source_of_creation == 'undefined' || typeof vm.siteminder_id == 'undefined'){
				vm.headerPart = '';
			} else {
				vm.headerPart = vm.source_of_creation == ''?'':' (' + vm.source_of_creation + ' '+vm.siteminder_id+') ';

			}
		} else {
			if(Order.success)
				Order.errorMsg = "Reservation doesn't exist";
			else
				Order.errorMsg = "Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.";
			// if(Order.type_of_reservation == 'boat'){
				$state.go('app.e-commerce.boatOrders',{toast_message:Order.errorMsg});
			// }else{
				// $state.go('app.e-commerce.orders',{toast_message:Order.errorMsg});
			// }
		}

		angular.element($window).on('resize', function () {
			/* code for top tabs slider */
			width = jQuery('.labels-blockclick-outer').width();
			visibleOnScreen = Math.ceil(parseInt(width) / parseInt(90));
			maxLeftAssign = parseInt(parseInt(tabsCount) - parseInt(visibleOnScreen)) * 90;
			maxLeftAssign = parseInt(parseInt(maxLeftAssign) + 30);
			if(visibleOnScreen < tabsCount){
				vm.showSliderControlls = true;
			} else {
				vm.showSliderControlls = false;
			}
			if(vm.selectedIndex > visibleOnScreen){
				left = -parseInt(parseInt(parseInt(vm.selectedIndex) - parseInt(visibleOnScreen)) + 1 ) * 90;
				left = parseInt(left - 50);
				jQuery('.labels-blockclick').css('left',left+'px');
			} else {
				left = 0;
				jQuery('.labels-blockclick').css('left',left+'px');
			}
			/* code for top tabs slider */
		});
		/* Initial Data for view page */
		
		
		
		/* Methods */
		vm.slideLeft = slideLeft;
		vm.slideRight = slideRight;
		vm.saveEmailCustomer = saveEmailCustomer;
		vm.opencommentboxNight = opencommentboxNight;
		vm.opencommentboxNightPOS = opencommentboxNightPOS;
		vm.opencommentbox = opencommentbox;
		vm.sumnightlyDisc = sumnightlyDisc;
		vm.sumnightlyDiscPOS = sumnightlyDiscPOS;
		vm.toggleReservationCustomer = toggleReservationCustomer;
		vm.editOrderDates = editOrderDates;
		vm.editParkingDates = editParkingDates;
		vm.saveCommentReq = saveCommentReq;
		vm.payInstallment = payInstallment;
		vm.updateReservationValues = updateReservationValues;
		vm.fetchOrder = fetchOrder;
		vm.fetchOrderInformation = fetchOrderInformation;
		vm.fetchOrderHistory = fetchOrderHistory;
		vm.fetchPaymentsInformation = fetchPaymentsInformation;
		vm.fetchOrderCommentsRequests = fetchOrderCommentsRequests;
		vm.roomMoveStart = roomMoveStart;
		vm.back = back;
		vm.sendinvoice = sendinvoice;
		vm.sendorderinvoice = sendorderinvoice;
		vm.changeStatus = changeStatus;
		vm.changeStatusForService = changeStatusForService;
		vm.cancelChangeStatus = cancelChangeStatus;
		vm.mainTabChanged = mainTabChanged;
		vm.changeStatusAfterPayment = changeStatusAfterPayment;
		vm.changeStatusWithoutPayment = changeStatusWithoutPayment;
		vm.refundInstallmentFinally = refundInstallmentFinally;
		vm.printinvoice = printinvoice;
		vm.printorderinvoice = printorderinvoice;
		vm.setShowModifyBtn = setShowModifyBtn;
		vm.completeModification = completeModification;
		vm.cancelModification = cancelModification;
		vm.calculateOrderTotals = calculateOrderTotals;
		vm.breakIntoNights = breakIntoNights;
		vm.roomovebreakIntoNights = roomovebreakIntoNights;
		vm.changeDiscAmt = changeDiscAmt;
		vm.changeDiscAmtPOS = changeDiscAmtPOS;
		vm.refundInstallment = refundInstallment;
		vm.sumNights = sumNights;
		vm.setAdults = setAdults;
		vm.roomovesetAdults = roomovesetAdults;
		vm.creditCardChanged = creditCardChanged;
		vm.checkValidExpDate = checkValidExpDate;
		vm.calculatePOSTotals = calculatePOSTotals;
		vm.changeActiveCard = changeActiveCard;
		vm.checkremainingAmount = checkremainingAmount;
		vm.changeProductDiscount = changeProductDiscount;
		vm.emptythisPayment = emptythisPayment;
		vm.setasincidental = setasincidental;
		vm.validateGCCode = validateGCCode;
		vm.addroomincart = addroomincart;
		vm.calculatesubtotal = calculatesubtotal;
		vm.calculatesubtotalPos = calculatesubtotalPos;
		vm.gotoCheckoutFromEditOrder = gotoCheckoutFromEditOrder;
		vm.roomovesumNights = roomovesumNights;
		vm.roomovechangeDiscAmt = roomovechangeDiscAmt;
		vm.updateCustomer = updateCustomer;
		vm.startDateModified = startDateModified;
		vm.endDateModified = endDateModified;
		vm.triggerdiv = triggerdiv;
		vm.queryCountrySearch = queryCountrySearch;
		vm.selectedItemChange = selectedItemChange;
		vm.selectedItemChangeState = selectedItemChangeState;
		vm.selectedItemChangeForTraveller = selectedItemChangeForTraveller;
		vm.closeDialog = closeDialog;
		vm.triggerDiscountEdit = triggerDiscountEdit;
		vm.triggerDiscountEditClose = triggerDiscountEditClose;
		vm.calculateDiscount = calculateDiscount;
		vm.updateEmailSatus = updateEmailSatus;
		vm.manageAdultChild = manageAdultChild;
		vm.getRangeArray = getRangeArray;
		vm.createFilterForCountry = createFilterForCountry;
		vm.addParking = addParking;
		vm.addBoatPos = addBoatPos;
		vm.cancelThisNight = cancelThisNight;
		vm.undoCancelThisNight = undoCancelThisNight;
		vm.refundEmail = refundEmail;
		vm.sumOfVals = sumOfVals;
		vm.toggle = toggle;
		/* Methods */
		
		/* functions for top tabs slider */
		function slideLeft(){
			if(left < 0){
				if(parseInt(parseInt(left) + 50) == 0){
					left = 0;
				} else {
					left = left + 90;
				}
				jQuery('.labels-blockclick').css('left',left+'px');
			}
		}
		function slideRight(){
			if(parseInt(left) > -parseInt(maxLeftAssign)){
				var maxLeft = maxLeftAssign - 30;
				if(parseInt(left) == -parseInt(maxLeft)){
					left = left - 50;
				} else {
					left = left - 90;
				}
				jQuery('.labels-blockclick').css('left',left+'px');
			}
		}
		/* functions for top tabs slider */
		function getRangeArray(start, end){
			var tempArray = [];
			for(var i=start ; i <= end;i++){
				tempArray.push(i);
			}
			return tempArray;

		}
		function manageAdultChild(calledFrom){
			if(typeof vm.order == 'undefined') return;
			$timeout(function() {
				var sum = parseInt(vm.order.room_stay_guest_count) + parseInt(vm.order.room_stay_child_count);
				if(calledFrom == 'adult'){
					vm.childRange = getRangeArray(0, (parseInt(vm.order['max_occupancy']) - vm.order.room_stay_guest_count));

					if(sum > parseInt(Order['response']['reservations']['max_occupancy'])){
						vm.order.room_stay_child_count = 0;
					}
				} else {
					vm.adultRange = getRangeArray(1, (parseInt(vm.order['max_occupancy']) -vm.order.room_stay_child_count));
					if(sum > parseInt(Order['response']['reservations']['max_occupancy'])){
						vm.order.room_stay_guest_count = 1;
					}
				}
			},1000);
		}
		function updateEmailSatus(id, status, type){
			var status = status?1:0;
			var data = {customer_id:id,status:status };
			eCommerceService.updateSendEmailIndicator(data).then(function(response){
				if(!response['error'] && vm.customerSameAsTraveller){
					if(type == 'customer'){
						vm.order['send_email_indicator'] = vm.reservation_customer['send_email_indicator'];
					}else{
						vm.reservation_customer['send_email_indicator'] = vm.order['send_email_indicator'];
					}
				}
			});
		}

		function saveEmailCustomer(customer_id,email,action){
			if(action=='customer'){
				eCommerceService.saveEmailCustomer(customer_id,email,'',vm.reservation_id).then(function(response) {
					if(response.success){
						vm.reservationEmailUpdated = true;
						vm.orig_reservation_customer.customer_email = angular.copy(email);
					}else if(response.errorMsg && response.errorMsg!=''){
						vm.reservation_customer.customer_email = angular.copy(vm.orig_reservation_customer.customer_email);
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					}else{
						vm.reservation_customer.customer_email = angular.copy(vm.orig_reservation_customer.customer_email);
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');

					}
				});
			}else{
				if(email!=originalOrderData.customer_email){
					eCommerceService.saveEmailCustomer(customer_id,email,vm.order.confirmation_number,vm.reservation_id).then(function(response) {
						if(response.success){
							vm.orderEmailUpdated = true;
							originalOrderData.customer_email = angular.copy(email);
						}else if(response.errorMsg && response.errorMsg!=''){
							vm.order.customer_email = angular.copy(originalOrderData.customer_email);
							toastMessage.showSimpleToast(response.errorMsg,'error-toast');
						}else{
							vm.order.customer_email = angular.copy(originalOrderData.customer_email);
							toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
						}
					});
				}
			}
		}
		function opencommentboxNight(index,nightIndex,type){
			var event = '';
			var answer = '';
			$mdDialog.show({
				controller: 'discountCommentController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/create-res/dialogs/discount-comment/discount-comment.html',
				parent: angular.element(document.body),
				targetEvent: event,
				clickOutsideToClose:true,
				locals             : {
					oldcomment   : vm.order.prices.nightlydiscountcomment[nightIndex],
					oldAmount    : vm.order.prices.nightlydiscount[nightIndex],
					type         : type,
					price        : vm.order.prices.rates[nightIndex]
				}
			}).then(function(answer) {
				if(answer != undefined) {
					vm.order.prices.nightlydiscountcomment[nightIndex] = answer.comment;
				}
				if(answer != undefined && type == 'nightly_discount') {
					vm.order.prices.nightlydiscount[nightIndex] = answer.amount;					
					vm.order.product_discount_comment = vm.order.prices.nightlydiscountcomment.join('_&_');
					vm.setShowModifyBtn('Night-'+nightIndex,'nightlydiscount',vm.order.room_stay_id,undefined,undefined,'nightly_discount');
					// return;
					vm.sumnightlyDisc(nightIndex);
				}
				var data = {confirmation_number:vm.order.confirmation_number,nightlydiscountcomment:vm.order.prices.nightlydiscountcomment,nontimebound:false};
				/*eCommerceService.saveDiscountComment(data).then(function(response){
					try{
						if(response.success || response.data){
							vm.order.prices.nightlydiscountcomment = response.data;
							originalOrderData.prices.nightlydiscountcomment = angular.copy(response.data);
						}else{
							vm.order.prices.nightlydiscountcomment = angular.copy(originalOrderData.prices.nightlydiscountcomment);
							toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.', 'error-toast');
						}
					}
					catch(err) {
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.', 'error-toast');
						vm.order.prices.nightlydiscountcomment = angular.copy(originalOrderData.prices.nightlydiscountcomment);
					}
				});*/
			}, function() {});
		}
		function opencommentboxNightPOS(poskey,datekey,action,nightIndex){
			var event = '';
			var thisCart = angular.copy(vm.order.pos[poskey]);
			if(thisCart.prices.nightlydiscountcomment) var comment = thisCart.prices.nightlydiscountcomment[nightIndex];
			else var comment = '';
			$mdDialog.show({
				controller: 'discountCommentController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/create-res/dialogs/discount-comment/discount-comment.html',
				parent: angular.element(document.body),
				targetEvent: event,
				clickOutsideToClose:true,
				locals             : {
					oldcomment   : comment,
					oldAmount    : '',
					type         : '',
					price        : ''
				}
			})
			.then(function(answer) {
				if(!thisCart.prices.nightlydiscountcomment){
					thisCart.prices.nightlydiscountcomment = {};
				}
				thisCart.prices.nightlydiscountcomment[nightIndex] = answer.comment;
				vm.order.pos[poskey] = thisCart;
				var data = {confirmation_number:thisCart.confirmation_number,nightlydiscountcomment:thisCart.prices.nightlydiscountcomment,nontimebound:false};
				eCommerceService.saveDiscountComment(data).then(function(response){
					if(response.success || response.data){
						thisCart.prices.nightlydiscountcomment = response.data;
						vm.order.pos[poskey] = thisCart;
					}
				});
			}, function() {});
		}
		function opencommentbox(posIndex){
			vm.event = '';
			$mdDialog.show({
				controller: 'discountCommentController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/create-res/dialogs/discount-comment/discount-comment.html',
				parent: angular.element(document.body),
				targetEvent: event,
				clickOutsideToClose:true,
				locals             : {
					oldcomment   : vm.order.pos[posIndex].product_discount_comment,
					oldAmount    : '',
					type         : '',
					price        : ''
				}
			})
			.then(function(answer) {
				vm.order.pos[posIndex].product_discount_comment = answer.comment;
				var data = {confirmation_number:vm.order.pos[posIndex].confirmation_number,nightlydiscountcomment:vm.order.pos[posIndex].product_discount_comment,nontimebound:true};
				eCommerceService.saveDiscountComment(data).then(function(response){
					if(response.success || response.data){
						vm.order.pos[posIndex].prices.product_discount_comment = response.data;
					}
				});
			}, function() {});
		}
		function calculateDiscount(){
			if(vm.discount_type == 'percent'){
				if(parseFloat(vm.newDiscount) > 100) vm.newDiscount = 100;
				var discount_amount = (parseFloat(parseFloat(vm.order.nightlySum) + parseFloat(vm.order.additional_guest_amounts) ) * parseFloat(vm.newDiscount))/100;

				vm.order.discount_percentage = commonService.roundnum(vm.newDiscount,2);
				vm.order.discount_amount = commonService.roundnum(discount_amount,2);
				var POS =  vm.order.pos;
				if((typeof POS != 'undefined' || POS)){
					vm.order.pos.forEach(function(element, key){
						if(element.room_stay_status == 'Active' && parseFloat(element.nightlySum) > 0){
							var discount_amount = parseFloat(element.nightlySum * vm.newDiscount)/100;
							vm.order.pos[key].discountAmt = commonService.roundnum(discount_amount,2);
							vm.order.pos[key].discountPer = commonService.roundnum(vm.newDiscount,2);
							vm.calculatePOSTotals(key,'');
							vm.setShowModifyBtn('discountPerpos'+key,'discountPer',element.room_stay_id,'pos',key);
						}
					});
				}
				vm.setShowModifyBtn('DiscountPercent','discount_percentage',vm.order.room_stay_id);
			} else {
				if(parseFloat(vm.newDiscount) > parseFloat(vm.order.overalltotals.subtotal)) vm.newDiscount = vm.order.overalltotals.subtotal;
				var discount_amount = vm.newDiscount;
				if(parseFloat(vm.order.nightlySum) > 0){
					if(parseFloat(discount_amount) <= parseFloat(vm.order.nightlySum)){
						vm.order.discount_amount = commonService.roundnum(discount_amount,2);
						discount_amount = 0;
					} else if(discount_amount > vm.order.nightlySum){
						vm.order.discount_amount = commonService.roundnum(parseFloat(parseFloat(vm.order.nightlySum) + parseFloat(vm.order.additional_guest_amounts)),2);
						discount_amount = parseFloat(parseFloat(discount_amount)-vm.order.discount_amount);
					}
					var newDiscPer = (parseFloat(vm.order.discount_amount)*100)/parseFloat(parseFloat(vm.order.nightlySum) + parseFloat(vm.order.additional_guest_amounts));

					newDiscPer = commonService.roundnum(newDiscPer,2);
					vm.order.discount_percentage = commonService.roundnum(newDiscPer,2);
				}
				var POS =  vm.order.pos;
				if(parseFloat(discount_amount) > 0 && (typeof POS != 'undefined' || POS)){
					vm.order.pos.forEach(function(element, key){
						if(element.room_stay_status == 'Active' && parseFloat(element.nightlySum) > 0 && parseFloat(discount_amount) > 0){
							var nightlySum = parseFloat(element.nightlySum);
							if(parseFloat(discount_amount) <= nightlySum){
								vm.order.pos[key].discountAmt = commonService.roundnum(discount_amount,2);
								discount_amount = 0;
							} else if(parseFloat(discount_amount) > nightlySum){
								vm.order.pos[key].discountAmt = commonService.roundnum(nightlySum,2);
								discount_amount = parseFloat(parseFloat(discount_amount)-nightlySum);
							}
							var newDiscPer = (parseFloat(vm.order.pos[key].discountAmt)*100)/parseFloat(nightlySum);

							newDiscPer = commonService.roundnum(newDiscPer,2);
							vm.order.pos[key].discountPer = commonService.roundnum(newDiscPer,2);
							vm.calculatePOSTotals(key,'');
							vm.setShowModifyBtn('discountAmtpos'+key,'discountAmt',element.room_stay_id,'pos',key);
						} else if(element.room_stay_status == 'Active' && parseFloat(element.nightlySum) > 0){
							vm.order.pos[key].discountAmt = 0.00;
							vm.order.pos[key].discountPer = 0.00;
							vm.calculatePOSTotals(key,'');
							vm.setShowModifyBtn('discountAmtpos'+key,'discountAmt',element.room_stay_id,'pos',key);
						}
					});
				}
				vm.setShowModifyBtn('DiscountAmount','discount_amount',vm.order.room_stay_id);
			}

			vm.order = commonService.calculateTotals(vm.order,false, []);

		}

		function triggerDiscountEdit(){
			vm.showDiscountEdit = true;
		}

		function triggerDiscountEditClose(){
			vm.showDiscountEdit = false;
		}

		function selectedItemChangeState(state){
			if(customFlag) {
				if(typeof state != 'undefined' ){
					if(typeof state != 'string')
						vm.reservation_customer.state = state.name;
					else
					vm.reservation_customer.state = state;
				} else {
					vm.reservation_customer.state = '';
				}
				updateCustomer('state', '');
			}
		}

		function closeDialog(){
			$mdDialog.hide();
		}


		function selectedItemChange(item){
			if(customFlag) {
				if(typeof item != 'undefined'){
					vm.reservation_customer.country = item.display;
				} else {
					vm.reservation_customer.country = '';
				}
				updateCustomer('country', '');
			}
		}

		function selectedItemChangeForTraveller(item){
			if(customFlag) {
				if(typeof item != 'undefined'){
					vm.order.country = item.display;
				} else {
					vm.order.country = '';
				}
				updateCustomer('country', vm.order.confirmation_number);
			}
		}
		vm.selectedItemChangeStateForTraveller = selectedItemChangeStateForTraveller;
		function selectedItemChangeStateForTraveller(state){
			if(customFlag) {
				vm.tempstate = state;
				if(typeof state != 'undefined'){
					vm.order.state = state.name;
				} else {
					vm.order.state = '';
				}
				updateCustomer('state', vm.order.confirmation_number);
			}
		}

		function queryCountrySearch(query) {
            var results = query ? myCountryArr.filter(createFilterForCountry(query)) : myCountryArr,
                deferred;
            //~ if (simulateQuery) {
                //~ deferred = $q.defer();
                //~ $timeout(function() {
                    //~ deferred.resolve(results);
                //~ }, Math.random() * 1000, false);
                //~ return deferred.promise;
            //~ } else {
                return results;
            //~ }
		}
		vm.queryStateSearch = queryStateSearch;
		function queryStateSearch(query){
			if(vm.searchTxtCountry.length > 0){
				var deferred = $q.defer();
				createResService.getAllStates({state:query,country:vm.searchTxtCountry})
				.then(function(response) {
				deferred.resolve(response.states);
				});
				return deferred.promise;
			} else {
				return [];
			}
		}

		vm.queryStateSearchForTraveller =queryStateSearchForTraveller;
		function queryStateSearchForTraveller(query){
			if(vm.searchTxtCountryForTraveller.length > 0 ){
				var deferred = $q.defer();
				createResService.getAllStates({state:query,country:vm.searchTxtCountryForTraveller})
				.then(function(response) {
				deferred.resolve(response.states);
				});
				return deferred.promise;
			} else {
				return [];
			}

		}

		

		function createFilterForCountry(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };
        }

		function loadAll() {
            var allStates = countryList;
            return allStates.map(function(state) {
                return {
                    value: state.toLowerCase(),
                    display: state
                };
            });
        }
        
		function updateCustomer(column, confirmation_number, type) {
			if(vm.stateStatus){
				var email = vm.order['customer_email'];
				var value = vm.order[column];

				if(column == 'state' && typeof value == 'undefined' && typeof vm.tempState != 'undefined' && vm.tempState != ''){
					vm.order.state = vm.tempstate;
				}
				if(confirmation_number == ''){
					value = vm.reservation_customer[column];
					email = vm.reservation_customer['customer_email'];
				}
				if(typeof value != 'undefined'){
					var data = {
						'customer_id' 		 	: vm.reservation_customer['customer_id'],
						'reservation_id'		: vm.reservation_id,
						'itinerary_number'		: vm.itinerary_number,
						'column' 				: column,
						'value' 				: value,
						'confirmation_number' 	: confirmation_number,
						'first_name' 			: vm.order.first_name,
						'last_name' 			: vm.order.last_name,
						'email'					: email,
						'product_id' 			: vm.order['product_id']
					};
					eCommerceService.updateCustomer(data).then(function(response){
						if(!response.status && vm.stateStatus){
							toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
						}
						else if(vm.customerSameAsTraveller){
							// if(type == 'customer'){
							// 	vm.order[column] = vm.reservation_customer[column];
							// }else{
							// 	vm.reservation_customer[column] = vm.order[column];
							// }
						}
					});
				}
			}
		}

		function triggerdiv(ev, type){
			vm.trigDivStatus = false;
			if(type == 'Traveller'){
				vm.order.send_email_indicator = vm.order.send_email_indicator == 1 ?true:false;
				if(vm.order.country){
					vm.selectedCountryForTraveller = {value:vm.order.country.toLowerCase(),display:vm.order.country};
				}
				$timeout(function(){
					if(vm.order.state){
						vm.selectedStateForTraveller = vm.order.state;
					}
				},1000);
			}
			vm.tempState = vm.order.state;


			var popUpId = '#my'+type;
				$mdDialog.show({
				  contentElement: popUpId,
				  parent: angular.element(document.body),
				  targetEvent: ev,
				  clickOutsideToClose: true
				});
		}

		function checkifCustomerPlus(){

		}

		function startDateModified(posIdx){
			var startDate = moment(vm.order.pos[posIdx].room_stay_from).format("MM/DD/YYYY");
			var endDate = moment(vm.order.pos[posIdx].room_stay_to);
			if(endDate.isSameOrBefore(startDate)){
				endDate = new Date(moment(vm.order.pos[posIdx].room_stay_from, "DD-MM-YYYY").add(1, 'days'));
				vm.endDateMin = new Date(moment(vm.order.pos[posIdx].room_stay_from, "DD-MM-YYYY").add(1, 'days'));
				vm.order.pos[posIdx].room_stay_to = moment(endDate).format ('MM/DD/YYYY');
			}
			vm.order.pos[posIdx].room_stay_from = moment(vm.order.pos[posIdx].room_stay_from).format('MM/DD/YYYY');
		}

		function endDateModified(room_stay_to,posIdx,event){
			var endDate = moment(room_stay_to).format("MM/DD/YYYY");
			var startDate = new Date(moment(vm.order.pos[posIdx].room_stay_from).format());
			endDate = moment(endDate);
			startDate = moment(startDate);
			vm.order.pos[posIdx].room_stay_to = moment(room_stay_to).format('MM/DD/YYYY');
			if(endDate.isBefore(startDate)){
				toastMessage.showSimpleToast('Checkout date cannot be less than checkin date.','error-toast');
				vm.order.pos[posIdx].room_stay_to = originalOrderData.pos[posIdx].room_stay_to;
				event.preventDefault();
			}
		}

		function gotoCheckoutFromEditOrder(){
			$sessionStorage['editReservationOrder'] = angular.copy(Order.response.reservations);
			var tax_status = Order.response.reservation_customer['tax_exempt_indicator'] == 1?true:false;

            var params = {
                checkin:vm.order.room_stay_from,
                checkout: vm.order.room_stay_to,
                product_id:vm.order.reserv_id,
                product_name:vm.order.product_name,
                product_room_number: vm.order.product_room_number || '',
                cartIndex:vm.selectedIndex,
                addServiceForRoom: true,
                taxValue:tax_status,
                pageFrom : 'order',
                itinerary_number:Order.response['itinerary_number'],
                confirmation_number:vm.order.confirmation_number
                };
            $sessionStorage['pageDetails_' + $localStorage['preHotelId']] = params;
            $state.go('app.resCheckout',params);
		}
		


		function calculatesubtotal(ec,rate){
			return commonService.calculatesubtotal(ec,rate);
		}
		function calculatesubtotalPos(qty,rate){
			return commonService.calculatesubtotalPos(qty,rate);
		}
		function creditCardChanged(event,cardType,payment_method){
			var result = commonService.creditCardChanged(event,cardType,payment_method,vm.allowed_card_types);
			vm.notCardType = result.notCardType;
			if(!result.notCardType) vm.payment_method = result.payment_method;
		}
		function checkValidExpDate(){
			var obj = {'method':vm.payment_method['payment_method'],'cc_exp_year':vm.payment_method['cc_exp_year'],'cc_exp_date':vm.payment_method['cc_exp_month']};
			var result = commonService.checkValidExpDate(obj);
			vm.exp_date = result.exp_date;
			vm.exp_date_err = result.exp_date_err;
		}
		function back(){
			if($rootScope.previousUrl && $rootScope.previousUrl != 'app.resCheckout' && $rootScope.previousUrl != 'app.pages_auth_login' ){
				$state.go($rootScope.previousUrl);
			} else{
				$state.go('app.e-commerce.orders');
			}
		}

		function calculateOrderTotals(){
			vm.order = commonService.calculateTotals(vm.order,false, []);
			completeModification();
		}

		function calculatePOSTotals(posIndex,action){
			if(vm.order.pos[posIndex].nightlySum == '' || typeof vm.order.pos[posIndex].nightlySum == 'undefined'){
				vm.order.pos[posIndex].nightlySum = 0.00;
			}
			if(vm.order.pos[posIndex].quantity == '' || vm.order.pos[posIndex].quantity == 0 || typeof vm.order.pos[posIndex].quantity == 'undefined'){
				vm.order.pos[posIndex].quantity = 1;
			}
			vm.order.pos[posIndex] = commonService.calculatePOSTotals(posIndex,false,vm.order);
			if(action == 'call')
				calculateOrderTotals();
		}
		function changeProductDiscount(posIndex,action){
			if(vm.order.pos[posIndex].product_discount=='' || typeof vm.order.pos[posIndex].product_discount=='undefined'){
				vm.order.pos[posIndex].product_discount = 0.00;
			}
			vm.order.pos[posIndex].product_discount = parseFloat(vm.order.pos[posIndex].product_discount);
			if(vm.order.pos[posIndex].product_is_timebound == 1)
				var checkAmount = vm.order.pos[posIndex].nightlySum;
			else
				var checkAmount = parseFloat(vm.order.pos[posIndex].nightlySum) * parseInt(vm.order.pos[posIndex].quantity);
			if(parseFloat(vm.order.pos[posIndex].product_discount)>parseFloat(checkAmount)){
				vm.order.pos[posIndex].product_discount = checkAmount;
			}
			calculatePOSTotals(posIndex,action);
		}
		function sumnightlyDisc(index){
			if(vm.order.prices.nightlydiscount[index]=='' || typeof vm.order.prices.nightlydiscount[index]=='undefined'){
				vm.order.prices.nightlydiscount[index] = 0.00;
			}
			if(parseFloat(vm.order.prices.nightlydiscount[index])>parseFloat(vm.order.prices.rates[index])){
				vm.order.prices.nightlydiscount[index] = commonService.roundnum(vm.order.prices.rates[index],2);
			}
			var returnObj = commonService.sumnightlyDisc(vm.order);
			
			vm.order.product_discount = returnObj.product_discount;
			vm.order.prices.nightlydiscount = returnObj.nightlydiscount;
			calculateOrderTotals();
		}
		function sumnightlyDiscPOS(index,poskey,datekey,action,nightIndex){
			// vm.processRequest = false;
			var thisCart = angular.copy(vm.order.pos[poskey]);
			if(thisCart.prices.nightlydiscount[nightIndex]=='' || typeof thisCart.prices.nightlydiscount[nightIndex]=='undefined'){
				// vm.processRequest = false;
				thisCart.prices.nightlydiscount[nightIndex] = 0.00;
			}
			if(parseFloat(thisCart.prices.nightlydiscount[nightIndex])>parseFloat(thisCart.prices.rates[nightIndex])){
				thisCart.prices.nightlydiscount[nightIndex] = thisCart.prices.rates[nightIndex];
			}
			if(thisCart.prices.nightlydiscount[nightIndex]==0){
				// vm.processRequest = false;
				thisCart.prices.nightlydiscountcomment[nightIndex] = '';
			}
			var returnObj = commonService.sumnightlyDisc(thisCart);
			thisCart.product_discount = returnObj.product_discount;
			thisCart.prices.nightlydiscount = returnObj.nightlydiscount;
			vm.order.pos[poskey] = thisCart;
			calculatePOSTotals(poskey,action);
		}
		function setAdults(){

			if(originalOrderData['room_stay_child_count'] != vm.order['room_stay_child_count'] || originalOrderData['room_stay_guest_count'] != vm.order['room_stay_guest_count']){
				vm.order = commonService.setAdults(vm.order,'',[],vm.is_child_allowed);
				vm.order['extraPersonPos'] = Order['response']['extraPersonPos'];
				calculateOrderTotals();
			}else{
				vm.order = angular.copy(originalOrderData);
				vm.order['extraPersonPos'] = Order['response']['extraPersonPos'];
			}
		}

		function roomovesetAdults(roomMoveIndex){
			vm.order.room_moves[roomMoveIndex] = commonService.setAdults(vm.order.room_moves[roomMoveIndex]);
			calculateOrderTotals();
		}

		function breakIntoNights(){
			vm.order = commonService.breakIntoNights(vm.order);
			calculateOrderTotals();
		}

		function roomovebreakIntoNights(roomMoveIndex){
			vm.order.room_moves[roomMoveIndex] = commonService.breakIntoNights(vm.order.room_moves[roomMoveIndex]);
			calculateOrderTotals();
		}

		function roomovechangeDiscAmt(roomMoveIndex){
			var returnedObj = commonService.changeDiscAmt(vm.order.room_moves[roomMoveIndex]);
			vm.order.room_moves[roomMoveIndex].discount_amount = returnedObj.discount_amount;
			vm.order.room_moves[roomMoveIndex].discount_percentage = returnedObj.discount_percentage;
			calculateOrderTotals();
		}

		function changeDiscAmtPOS(poskey, action){
            var thisCart = angular.copy(vm.order.pos[poskey]);
            var newDiscPer = (parseFloat(thisCart.discountAmt)*100)/parseFloat(thisCart.nightlySum * thisCart.quantity);
            newDiscPer = commonService.roundnum(newDiscPer,2);
            thisCart.discountPer = newDiscPer;
            vm.order.pos[poskey] = angular.copy(thisCart);
            calculatePOSTotals(poskey,'call');
        };

		function changeDiscAmt(){
			var returnedObj = commonService.changeDiscAmt(vm.order);
			vm.order.discount_amount = returnedObj.discount_amount;
			vm.order.discount_percentage = returnedObj.discount_percentage;
			calculateOrderTotals();
		}

		function roomovesumNights(){
			vm.order.room_moves[roomMoveIndex].nightlySum = commonService.sumNights(vm.order.room_moves[roomMoveIndex]);
			calculateOrderTotals();
		}

		function sumNights(index){
			if(parseFloat(vm.order.prices.nightlydiscount[index])>parseFloat(vm.order.prices.rates[index])){
				vm.order.prices.nightlydiscount[index] = commonService.roundnum(vm.order.prices.rates[index],2);
				var returnObj = commonService.sumnightlyDisc(vm.order);
				vm.order.product_discount = returnObj.product_discount;
				vm.order.prices.nightlydiscount = returnObj.nightlydiscount;
			}
			var returnObj = commonService.sumNights(vm.order);
			vm.order.nightlySum = returnObj.nightlySum;
			vm.order.prices.rates = returnObj.rates;
			calculateOrderTotals();
		}
		vm.modificationComment = '';
		vm.changedColumn = '';
		function completeModification(){
			vm.isloading = false;
			if(vm.processRequest){

			angular.forEach($http.pendingRequests, function(request) {
				if (request.cancel && request.timeout) {
				   request.cancel.resolve();
				}
			 });

			vm.isloading = true;
			var requestData = angular.copy(vm.order);
			requestData['order_history_comment'] = "AMOUNTS_MODIFED_MANUALLY_FROM_PMS";
			var data = {'order_info':requestData,'id':Reservation_id,'additional_data':vm.modificationComments,'dateKey':vm.dateKey,'modification_comment':vm.modificationComment,changed_column:vm.changedColumn};
			vm.modify_request = true;
			
			eCommerceService.modifyOrderAmounts(data).then(function(response){
				try{
					vm.modify_request = false;
					vm.isloading = false;
					vm.showModifyBtn = false;
					vm.showDiscountEdit = false;
					if(typeof response != 'undefined' && response != ''  && response.order_info){
						vm.order = response.order_info.reservations[0];
						vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];
						vm.room_stay_status = angular.copy(vm.order.room_stay_status);
						vm.statuses = {'Active':'Active','Checked-In':'Check-In','Checked-Out':'Check-Out','Closed':'Close','Canceled':'Cancel'};
						vm.statuses[vm.room_stay_status] = vm.room_stay_status;
						setAllStatuses();
						originalOrderData = angular.copy(vm.order);
						vm.showModifyBtn = false;
						vm.showPaymentsLoader = true;
						$timeout(function(){
							fetchPaymentsInformation(vm.order.confirmation_number,vm.order.first_name,vm.order.last_name,vm.order.total_amount,vm.order.overalltotals.remaining_amount);
						},100);

					}else{
						vm.modify_request = false;
						vm.isloading = false;
						vm.showDiscountEdit = true;
						vm.order = angular.copy(originalOrderData);
						vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];
					}
				}
				catch(err) {
					vm.modify_request = false;
					vm.isloading = false;
					vm.showDiscountEdit = true;
					vm.order = angular.copy(originalOrderData);
					vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];
				}
			});
		} else {
			vm.isloading = false;
			vm.showModifyBtn = false;
			vm.showDiscountEdit = false;
			vm.isloading = false;
		}

		}
		/*Divide nightly Sum*/
        vm.sumNightsPOS = sumNightsPOS;
        vm.datesChanged = datesChanged;
        function sumNightsPOS(poskey,action){
            var thisCart = angular.copy(vm.order.pos[poskey]);
            var nightlyAll = thisCart.prices.rates;
            var nightlySum = 0;
            var discountAmt = thisCart.discountAmt;
            for(var i=0;i<nightlyAll.length;i++){
                nightlySum+= parseFloat(nightlyAll[i]);
                thisCart.prices.rates[i] = commonService.roundnum(nightlyAll[i],2);
            }
            thisCart.nightlySum = commonService.roundnum(nightlySum,2);
            vm.order.pos[poskey] = thisCart;
            vm.order.pos[poskey] = commonService.calculatePOSTotals(poskey,true,vm.order);
            if(action == 'call')
				calculateOrderTotals();
        }

        function datesChanged(posIdx){
			var thisCart = vm.order.pos[posIdx];
			var origCart = originalOrderData.pos[posIdx];
			var new_room_stay_to = moment(thisCart.room_stay_to);
			var new_room_stay_from = moment(thisCart.room_stay_from);
			var old_room_stay_to = moment(origCart.room_stay_to);
			var old_room_stay_from = moment(origCart.room_stay_from);
			var nightly = thisCart.prices.rates;
			var dates = [];
			var rates = [];
			if(new_room_stay_to != old_room_stay_to || new_room_stay_from != old_room_stay_from){
				var nights = new_room_stay_to.diff(new_room_stay_from, 'days');
				var last_rate = 0;
				for (var m = moment(new_room_stay_from),k=0; m.isBefore(new_room_stay_to); m.add('days', 1),k++) {
					if(m.format('MM-DD-YYYY') == new_room_stay_to.format('MM-DD-YYYY'))
						break;
					dates.push(m.format('MM-DD-YYYY'));
					if(nightly[k] !== undefined){
						rates.push(nightly[k]);
						last_rate = nightly[k];
					}else{
						rates.push(last_rate);
					}
				}
			}
			vm.order.pos[posIdx].prices.rates = rates;
			vm.order.pos[posIdx].prices.dates = dates;
			sumNightsPOS(posIdx);
			calculatePOSTotals(posIdx,'call');
		}
		
		function setShowModifyBtn(changedColumn,columnName,room_stay_id,type,posIdx,from){
			vm.processRequest = true;
			vm.modificationComments = [];
			vm.dateKey = -1;
			vm.modificationComments.push(room_stay_id);
			if(columnName == 'additional_guest_amounts' && (/[a-zA-Z]/.test(vm.order.additional_guest_amounts) || vm.order.additional_guest_amounts < 0 || isNaN(vm.order.additional_guest_amounts))){
				vm.order.additional_guest_amounts =  commonService.roundnum(originalOrderData.additional_guest_amounts,2);
				vm.processRequest = false;
				return;
			}

			if((typeof type == 'undefined' || type == 'undefined') && (columnName == 'prices' || columnName == 'nightlydiscount')) {
				var ind = changedColumn.split('-');
				vm.dateKey = ind[1];

				if(columnName == 'prices'){
					var tempNumber = parseFloat(vm.order.prices.rates[ind[1]]);
					if( /[a-zA-Z]/.test(vm.order.prices.rates[ind[1]]) || tempNumber < 0 || isNaN(tempNumber) || (commonService.roundnum(originalOrderData.prices.rates[ind[1]],2) == commonService.roundnum(tempNumber,2) && (typeof from == 'undefined' || from != 'nightly_discount')) ) {
						vm.order.prices.rates[ind[1]] =  commonService.roundnum(originalOrderData.prices.rates[ind[1]],2);
						vm.processRequest = false;
						return;
					}

					if(vm.order.prices.rates[ind[1]] < 0){
						vm.order.prices.rates[ind[1]] = commonService.roundnum(originalOrderData.prices.rates[ind[1]],2);
					}else{
						vm.order.prices.rates[ind[1]] = commonService.roundnum(vm.order.prices.rates[ind[1]], 2);
					}
					
					vm.modificationComment  = 'Price of night '+ (parseFloat(ind[1]) + parseFloat(1))+' changed from '+commonService.roundnum(originalOrderData.prices.rates[ind[1]],2)+' to '+commonService.roundnum(vm.order.prices.rates[ind[1]],2);
				}else{

					var tempNumber = parseFloat(vm.order.prices.nightlydiscount[ind[1]]);
					if(/[a-zA-Z]/.test(tempNumber) || tempNumber < 0 || isNaN(tempNumber) || (commonService.roundnum(originalOrderData.prices.nightlydiscount[ind[1]],2) == commonService.roundnum(tempNumber,2) && (typeof from == 'undefined' || from != 'nightly_discount')) ) {
						vm.order.prices.nightlydiscount[ind[1]] = commonService.roundnum(originalOrderData.prices.nightlydiscount[ind[1]], 2);
						vm.processRequest = false;
						return;
					}

					if(tempNumber < 0){
						vm.order.prices.nightlydiscount[ind[1]] = commonService.roundnum(originalOrderData.prices.nightlydiscount[ind[1]], 2);

					}else{
						vm.order.prices.nightlydiscount[ind[1]] = commonService.roundnum(vm.order.prices.nightlydiscount[ind[1]], 2);

					}
					vm.modificationComment  = 'Discount of night '+ (parseFloat(ind[1]) + parseFloat(1))+' changed from '+commonService.roundnum(originalOrderData.prices.nightlydiscount[ind[1]],2)+' to '+commonService.roundnum(vm.order.prices.nightlydiscount[ind[1]],2);
				}
			} else if(type == 'pos'){

				if(columnName == 'product_discount' || columnName == 'quantity'){
					var tempNumber = parseFloat(vm.order.pos[posIdx][columnName]);
					if(/[a-zA-Z]/.test(vm.order.pos[posIdx][columnName]) || tempNumber < 0 || isNaN(tempNumber) ||  commonService.roundnum(vm.order.pos[posIdx][columnName],2) == commonService.roundnum(originalOrderData.pos[posIdx][columnName],2)){
						vm.processRequest = false;
					}					
				}
				if(columnName == 'nightlydiscount'){
					var ind = changedColumn.split('-');
					vm.dateKey = ind[1];
					vm.modificationComment  = originalOrderData.pos[posIdx]['product_name']+' discount for night '+ind[1]+' changed  from '+originalOrderData.pos[posIdx]['prices']['nightlydiscount'][parseFloat(ind[1]) - parseFloat(1)]+' to '+ commonService.roundnum(vm.order.pos[posIdx]['prices']['nightlydiscount'][parseFloat(ind[1]) - parseFloat(1)],2);
				} else if(columnName == 'product_discount'){					
					vm.modificationComment  = originalOrderData.pos[posIdx]['product_name']+' discount changed  from '+originalOrderData.pos[posIdx][columnName]+' to '+ commonService.roundnum(vm.order.pos[posIdx][columnName],2);
				} else if(columnName == 'subtotal'){
					vm.modificationComment  = originalOrderData.pos[posIdx]['product_name']+' price changed  from '+originalOrderData.pos[posIdx][columnName]+' to '+ commonService.roundnum(vm.order.pos[posIdx][columnName], 2);

				}else if(columnName == 'quantity'){
					vm.modificationComment  = originalOrderData.pos[posIdx]['product_name']+' quantity changed  from '+originalOrderData.pos[posIdx][columnName]+' to '+ vm.order.pos[posIdx][columnName];
				}else if(columnName == 'room_stay_to'){
					vm.modificationComment  = originalOrderData.pos[posIdx]['product_name']+' end date changed  from '+originalOrderData.pos[posIdx][columnName]+' to '+ vm.order.pos[posIdx][columnName];
				}else if(columnName == 'room_stay_from'){
					vm.modificationComment  = originalOrderData.pos[posIdx]['product_name']+' start date changed from '+originalOrderData.pos[posIdx][columnName]+' to '+ vm.order.pos[posIdx][columnName];
				}else{
					var ind = changedColumn.split('-');
					vm.dateKey = ind[1];
					vm.modificationComment  = originalOrderData.pos[posIdx]['product_name']+' price for night '+ind[1]+' changed  from '+ commonService.roundnum(originalOrderData.pos[posIdx]['prices']['rates'][parseFloat(ind[1]) - parseFloat(1)],2)+' to '+ commonService.roundnum(vm.order.pos[posIdx]['prices']['rates'][parseFloat(ind[1]) - parseFloat(1)],2);
				}
			}else{
				if(changedColumn == 'ExtraCharges')
					changedColumn = 'Extra charges';
				vm.modificationComment  = changedColumn+' changed from '+commonService.roundnum(originalOrderData[columnName], 2)+' to '+ commonService.roundnum(vm.order[columnName], 2);
			}
			vm.changedColumn = columnName;
			monthlyWeeklyNight(vm.order);
		}

		function cancelModification(){
			vm.showModifyBtn = false;
			vm.endDateMin = new Date(
				vm.myDate.getFullYear(),
				vm.myDate.getMonth(),
				vm.myDate.getDate()
			);
			vm.showDiscountEdit = false;
			vm.order = angular.copy(originalOrderData);
			vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];
		}

		function mainTabChanged(ev,orderIndex){
			vm.selectedIndex = orderIndex;
			if(!vm.mainTabChangedAuto){
				cancelChangeStatus();
				cancelModification();
			}
			vm.mainTabChangedAuto = false;
			vm.customeropened = false;
			vm.traveleropened = false;
			vm.commentsSpecial = {};
			vm.showDiscountEdit = false;
		}
		function changeStatusForService(ev,confirmation_number,oldStatus,newStatus,rmMvIdx,grand_total,room_confirmation_number,paidAmount,total_amount,type, posValue){
			var event = '';

			if(newStatus=='Canceled'){
				var label = 'Cancel';
			} else {
				var label = 'Active';
			}
			$mdDialog.show({
				controller: 'confirmController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
				parent: angular.element(document.body),
				targetEvent: event,
				clickOutsideToClose:true ,
				locals: {
					title: label+' order',
					htmlContent:"Are you sure want to change status of #"+confirmation_number+" to "+newStatus+"?",
					cancelBtn:'No',
					OkBtn:'Yes'
				}
			}).then(function(answer) {
				if(typeof answer != 'undefined' && answer == 'update'){
					$mdDialog.hide();
					changeStatusForServiceFinally(
						oldStatus,newStatus,confirmation_number,grand_total,
						room_confirmation_number,paidAmount,total_amount,rmMvIdx ,
						posValue.room_stay_from,posValue.room_stay_to,posValue.product_id,posValue.is_timebound_with_availability);
				} else if(typeof answer != 'undefined' && answer == 'close'){
					vm.pos_status[rmMvIdx] = oldStatus;
					$mdDialog.hide();
				}
			}, function(dialogText) {
				vm.pos_status[rmMvIdx] = oldStatus;
				$mdDialog.hide();
			});
		}

		function changeStatusForServiceFinally(oldStatus,newStatus,confirmation_number,grand_total,room_confirmation_number,paidAmount,total_amount,rmMvIdx,room_stay_from,room_stay_to,product_id,is_timebound_with_availability){
			vm.isloading = true;
			ganttChartService.changeStatusForService({
													 'confirmation_number':confirmation_number,
													 'room_stay_status':newStatus,
													 'grand_total':grand_total,
													 'paidAmount':paidAmount,
													 'total_amount':total_amount,
													 'room_confirmation_number':room_confirmation_number,
													 'room_stay_from': room_stay_from,
													 'room_stay_to': room_stay_to, 
													 'product_id': product_id,
													 'is_timebound_with_availability': is_timebound_with_availability
													}).then(function(response){
				if(response.success ){
					vm.order = response.order_info.reservations[0];
					vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];
					originalOrderData = angular.copy(vm.order);
					vm.room_stay_status = angular.copy(vm.order.room_stay_status);
					vm.statuses = {'Active':'Active','Checked-In':'Check-In','Checked-Out':'Check-Out','Closed':'Close','Canceled':'Cancel'};
					vm.statuses[vm.room_stay_status] = vm.room_stay_status;
					vm.showModifyBtn = false;
					vm.showPaymentsLoader = true;
					
					if(response.statusMsg != ''){
						toastMessage.showSimpleToast(response.statusMsg,'error-toast');
					}
					setAllStatuses();
					$timeout(function(){
						vm.isloading = false;
						fetchPaymentsInformation(room_confirmation_number,vm.order.first_name,vm.order.last_name,vm.order.total_amount,vm.order.overalltotals.remaining_amount);
					},100);
				} else {
					vm.isloading = false;
					var message = 'Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.';
					if(typeof response.errorMsg != 'undefined' &&  response.errorMsg != '')
						message = response.errorMsg;
					toastMessage.showSimpleToast(message,'error-toast');
					vm.pos_status[rmMvIdx] = oldStatus;
				}
			});
		}

		function changeStatus(ev, idx, room_stay_id, confirmation_number, oldStatus, newStatus, remainingBalance, paidAmount, policy_id, room_stay_from, first_name, customer_email, total_amount){
			if(newStatus=='Canceled'){
				vm.isloading = true;
				ganttChartService.getCancelOrderData({'confirmation_number':confirmation_number,'policy_id':policy_id,'room_stay_from':room_stay_from,'room_stay_to':vm.order.room_stay_to}).then(function(response){
					vm.isloading = false;
					if(response.success && response.statusMsg == ''){
						var days_free_cancellation = response.days_free_cancellation;
						var payments = response.payments;
						var refund_type = response.refund_type;
						var policy_name = response.policy_name;
						var payment_exists = response.payment_exists;
						var cancellation_charges = response.cancellation_charges;
						var if_cancelled_period = response.if_cancelled_period;
						$mdDialog.show({
							clickOutsideToClose	: false,
							parent             	: angular.element($document.body),
							scope				: $scope,
							preserveScope		: true,
							locals				: {
								localData :{
									oldStatus: oldStatus,
									room_stay_id: room_stay_id,
									newStatus: newStatus,
									confirmation_number: confirmation_number,
									days_free_cancellation:days_free_cancellation,
									payments:payments,
									room_stay_from:room_stay_from,
									refund_type:refund_type,
									customer_name:first_name,
									customer_email:customer_email,
									paidAmount:paidAmount,
									total_amount:total_amount,
									payment_exists:payment_exists,
									cancellation_charges:cancellation_charges,
									if_cancelled_period:if_cancelled_period,
									policy_name:policy_name,
									send_email_indicator: vm.order.send_email_indicator
								}
							},
							templateUrl        	: 'app/main/apps/e-commerce/views/orders/dialogs/status/cancel.html',
							controller			: CancelController
						});
						function CancelController($scope, $mdDialog, localData) {
							$scope.oldStatus = localData.oldStatus;
							$scope.room_stay_id = localData.room_stay_id;
							$scope.confirmation_number = localData.confirmation_number;
							$scope.newStatus = localData.newStatus;
							$scope.send_email_indicator = localData.send_email_indicator == 1?true:false;
							$scope.refund_type = localData.refund_type;
							$scope.show_refund_type = localData.refund_type;
							$scope.policy_name = localData.policy_name;
							$scope.days_free_cancellation = localData.days_free_cancellation;
							$scope.payments = localData.payments;
							$scope.customer_name = localData.customer_name;
							$scope.customer_email = localData.customer_email;
							$scope.paidAmount = localData.paidAmount;
							$scope.total_amount = localData.total_amount;
							$scope.payment_exists = localData.payment_exists;
							$scope.cancellation_charges = localData.cancellation_charges;
							$scope.if_cancelled_period = localData.if_cancelled_period;
							if($scope.if_cancelled_period == "0" && $scope.cancellation_charges > 0)
								vm.keepCancelCharges = true;
							else
								vm.keepCancelCharges = false;
							$scope.takeChargesInstallment = {};
							$scope.cancel_order_comment = "";
							$scope.showSubmit = true;
							$scope.closeDialog = function(){
								vm.room_stay_status = $scope.oldStatus;
								vm.statuses = {'Active':'Active','Checked-In':'Check-In','Checked-Out':'Check-Out','Closed':'Close','Canceled':'Cancel'};
								vm.statuses[vm.room_stay_status] = vm.room_stay_status;
								$mdDialog.hide();
							};
							$scope.changeKeepCharges = function(idx,old_value){
								if(old_value == 1)
									$scope.payments[idx].keep_charges = false;
								else
									$scope.payments[idx].keep_charges = true;
								if(vm.keepCancelCharges){
									var keep_amount = 0;
									$timeout(function ()
									{
										angular.forEach($scope.payments, function(value,key) {
											var intallmentId = value.installment_id;
											if($scope.takeChargesInstallment[intallmentId] != 'undefined' && $scope.takeChargesInstallment[intallmentId]){
												keep_amount = parseFloat(keep_amount) + parseFloat(value.installment_amount);
											}
											if( parseFloat(keep_amount) >= parseFloat($scope.cancellation_charges) ){
												$scope.showSubmit = true;
											} else {
												$scope.showSubmit = false;
											}
										});
									});
								} else {
									$scope.showSubmit = true;
								}
							};
							$scope.cancelFinally = function(sendEmail){
								vm.isloading = true;
								$scope.showSubmit = false;
								if($scope.refund_type == 0 || $scope.refund_type == 1){
									var data = {refund_type:$scope.refund_type,room_stay_id:$scope.room_stay_id,confirmation_number:$scope.confirmation_number,reservation_id:Reservation_id,cancel_order_comment:$scope.cancel_order_comment,total_amount:$scope.total_amount,keepCancelCharges:vm.keepCancelCharges,takeChargesInstallment:$scope.takeChargesInstallment,cancellation_charges:$scope.cancellation_charges,location:'PMS (View screen)',sendEmail:sendEmail};
								} else {
									var data = {refund_type:$scope.refund_type,room_stay_id:$scope.room_stay_id,paidAmount:$scope.paidAmount,customer_name:$scope.customer_name,customer_email:$scope.customer_email,confirmation_number:$scope.confirmation_number,reservation_id:Reservation_id,cancel_order_comment:$scope.cancel_order_comment,total_amount:$scope.total_amount,keepCancelCharges:vm.keepCancelCharges,takeChargesInstallment:$scope.takeChargesInstallment,cancellation_charges:$scope.cancellation_charges,location:'PMS (View screen)',sendEmail:sendEmail};
								}
								ganttChartService.cancelOrder(data).then(function(response){
									vm.isloading = false;
									if(response.success){

										eCommerceService.getOrder($stateParams.id,confirmation_number,false).then(function(response){
											var cancelledCount = 0;
											response['response']['tabs_data'].forEach(function(element, index){
												if(element['room_stay_status'] == 'Canceled'){
													cancelledCount ++;
												}
											});
											if(cancelledCount == Order.response.tabs_data.length){
												vm.allRoomCancelled = true;
											}
											vm.order = response.response.reservations;
											vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];
											//~ vm.order.show_status = "Canceled";
											vm.room_stay_status = 'Canceled';
											vm.statuses = {'Active':'Active','Checked-In':'Check-In','Checked-Out':'Check-Out','Closed':'Close','Canceled':'Cancel'};
											vm.statuses[vm.room_stay_status] = vm.room_stay_status;
											setAllStatuses();
											//~ vm.order.overalltotals.paid_amount = response.amount_paid;
											//~ vm.order.overalltotals.remaining_amount = response.amount_remaining;
											originalOrderData = angular.copy(vm.order);
											if(response.mail_error)
												toastMessage.showSimpleToast('Reservation canceled successfully but there was some error in sending email to the customer.','error-toast');
											if(response.refund_error)
												toastMessage.showSimpleToast(response.errorMsg,'error-toast');
											$timeout(function() {
												fetchPaymentsInformation(confirmation_number,vm.order.first_name,vm.order.last_name,vm.order.total_amount,vm.order.overalltotals.remaining_amount);
											},1000);
										});
										$mdDialog.hide();
									} else {
										vm.room_stay_status = $scope.oldStatus;
										toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
									}
								});
							};
						}
					}else if(response.statusMsg != ''){
						toastMessage.showSimpleToast(response.statusMsg,'error-toast');
						eCommerceService.getOrder($stateParams.id,confirmation_number,false).then(function(response){
							var cancelledCount = 0;
							response['response']['tabs_data'].forEach(function(element, index){
								if(element['room_stay_status'] == 'Canceled'){
									cancelledCount ++;
								}
							});
							if(cancelledCount == Order.response.tabs_data.length){
								vm.allRoomCancelled = true;
							}
							vm.order = response.response.reservations;
							vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];
							//~ vm.order.show_status = "Canceled";
							vm.room_stay_status = 'Canceled';
							vm.statuses = {'Active':'Active','Checked-In':'Check-In','Checked-Out':'Check-Out','Closed':'Close','Canceled':'Cancel'};
							vm.statuses[vm.room_stay_status] = vm.room_stay_status;
							setAllStatuses();
							originalOrderData = angular.copy(vm.order);
							$timeout(function() {
								fetchPaymentsInformation(confirmation_number,vm.order.first_name,vm.order.last_name,vm.order.total_amount,vm.order.overalltotals.remaining_amount);
							},1000);
						});
					}else{
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
						vm.room_stay_status = oldStatus;
						$mdDialog.hide();
					}
				});
			}else{
				if(newStatus!='Active' && remainingBalance > 0){
					$mdDialog.show({
						clickOutsideToClose	: false,
						parent             	: angular.element($document.body),
						scope				: $scope,
						preserveScope		: true,
						locals				: { oldStatus: oldStatus, room_stay_id: room_stay_id, newStatus: newStatus, remainingBalance: remainingBalance,confirmation_number: confirmation_number,idx: idx,send_email_indicator: vm.order.send_email_indicator },
						templateUrl        	: 'app/main/apps/e-commerce/views/orders/dialogs/status/checkin-out.html',
						controller			: StatusController
					});
					function StatusController($scope, $mdDialog, oldStatus, idx, room_stay_id, newStatus, remainingBalance, confirmation_number, send_email_indicator) {
						$scope.oldStatus = oldStatus;
						$scope.idx = idx;
						$scope.room_stay_id = room_stay_id;
						$scope.confirmation_number = confirmation_number;
						$scope.newStatus = newStatus;
						$scope.send_email_indicator = send_email_indicator == 1?true:false;
						$scope.remainingBalance = remainingBalance;
						if(newStatus == 'Checked-In')
							$scope.showStatus = 'Check-in';
						else if(newStatus == 'Checked-Out')
							$scope.showStatus = 'Check-out';
						else if(newStatus == 'Closed')
							$scope.showStatus = 'Close';
						else
							$scope.showStatus = newStatus;
						$scope.closeDialog = function(){
							vm.room_stay_status = $scope.oldStatus;
							$mdDialog.hide();
						};
					}
				}else{
					var html='Are you sure you want to change status of reservation "'+confirmation_number +'" from '+oldStatus+' to '+newStatus+'.';
					var title = "Change Status";
					var event = '';
					$mdDialog.show({
						controller: 'confirmPageController',
						controllerAs: 'vm',
						templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
						parent: angular.element(document.body),
						targetEvent: event,
						clickOutsideToClose:true ,
						locals: {
							title: title,
							htmlContent:html,
							btnTxt: 'Continue',
							cancelTxt: 'Cancel',
							localData: {
								newStatus: newStatus,
								send_email_indicator: vm.order.send_email_indicator
							}
						}
					}).then(function(response) {
					   if(typeof response.answer != 'undefined' && response.answer == 'update'){
						changeStatusFinally(confirmation_number,newStatus,oldStatus,'',response.email_indicator);
					   }
					}, function() {
						vm.room_stay_status = oldStatus;
					});
				}
			}
		}

		function refundInstallment(installment,type){
			$mdDialog.show({
				clickOutsideToClose	: false,
				parent             	: angular.element($document.body),
				scope				: $scope,
				preserveScope		: true,
				locals				: {
										localData :{
											installment_id:installment.installment_id,
											installment_amount:installment.installment_amount,
											refund_by_check:installment.refund_by_check,
											type:type,
											payment:installment.payment
										}
									},
				templateUrl        	: 'app/main/apps/e-commerce/views/orders/dialogs/payments/refund.html',
				controller			: RefundController
			});
			function RefundController($scope, $mdDialog, localData) {
				$scope.installment_id = localData.installment_id;
				$scope.refund_amount = localData.installment_amount;
				$scope.installment_amount = localData.installment_amount;
				$scope.refund_by_check = localData.refund_by_check;
				$scope.type = localData.type;
				$scope.check_number = '';
				$scope.payment = localData.payment;
				$scope.closeDialog = function(){
					$mdDialog.hide();
				};
				$scope.checkRefundAmount = function(){
					if(parseFloat($scope.refund_amount) < 0){
						$scope.refund_amount = -($scope.refund_amount);
					}
					if(parseFloat($scope.refund_amount) > parseFloat($scope.installment_amount)){
						$scope.refund_amount = $scope.installment_amount;
					}
				};
			}
		}

		function refundInstallmentFinally(installment_id,amount,refund_using,check_number,send_email_indicator){
			vm.isloading = true;
			vm.refundStart = true;
			if(refund_using == 'original' || refund_using == 'check'){
				var data = {installment_id:installment_id,amount:amount,refund_using:refund_using,confirmation_number:vm.order.confirmation_number,roomTotal:vm.order.total_amount,paid_amount:vm.order.overalltotals.paid_amount,traveler_fname:vm.order.first_name,traveler_lname:vm.order.last_name,remaining_amount:vm.order.remaining_amount,reservation_id:vm.reservation_id,check_number:check_number};
			} else {
				var data = {installment_id:installment_id,amount:amount,refund_using:refund_using,confirmation_number:vm.order.confirmation_number,roomTotal:vm.order.total_amount,paid_amount:vm.order.overalltotals.paid_amount,traveler_fname:vm.order.first_name,traveler_lname:vm.order.last_name,remaining_amount:vm.order.remaining_amount,customer_email:vm.order.customer_email,reservation_id:vm.reservation_id};
			}
			
			eCommerceService.customRefundInstallment(data).then(function(response){
				vm.isloading = false;
				vm.refundStart = false;
				$mdDialog.hide();
				if(response.success){
					vm.payingFromGC = {};
					vm.installments = [];
					vm.installments = response.data.installments;
					vm.allcardsInfo = response.data.allcardsInfo;
					vm.payment_info_email = response.payment_info_email;
					vm.installment_amount = angular.copy(vm.installments['remaining'].origremainingamt);
					vm.order = response.reservation;
					vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];
					originalOrderData = angular.copy(vm.order);
					vm.room_stay_status = angular.copy(vm.order.room_stay_status);
					vm.statuses = {'Active':'Active','Checked-In':'Check-In','Checked-Out':'Check-Out','Closed':'Close','Canceled':'Cancel'};
					vm.statuses[vm.room_stay_status] = vm.room_stay_status;
					setAllStatuses();
					if(Object.keys(response.data.allcardsInfo).length > 0){
						var size = response.data.allcardsInfo.length;
						vm.payment_method = response.data.allcardsInfo[(parseInt(size)-1)];
						if(response.data.allcardsInfo[(parseInt(size)-1)].cc_number!=''){
							vm.fieldsIsReadOnly = true;
						}
					} else {
						vm.payment_method.payment_method = response.data.selectedPaymentMethod;
						if(response.data.selectedPaymentMethod == ""){
							vm.payment_method.payment_method = "Cash";
						}
					}

					// Refund Reason Code Start 
					if(response.last_id != undefined && response.last_id != 0) {
						$mdDialog.show({
							clickOutsideToClose	: false,
							parent             	: angular.element($document.body),
							scope				: $scope,
							preserveScope		: true,
							locals				: {
													localData :{}
												},
							templateUrl        	: 'app/main/apps/e-commerce/views/orders/dialogs/payments/refundReason.html',
							controller			: AskReason
						});
						function AskReason($scope, $mdDialog, localData) {
							$scope.voidReason = '';
							$scope.closeDialog = function(){
								$mdDialog.hide();
							};
							$scope.submitReason = function(){
								if($scope.voidReason != '') {
									var giftcardParams = {
										payment_info_email : vm.payment_info_email,
										amount : amount,
										refund_using :refund_using
									}
									vm.saveRefundReason(response.last_id, $scope.voidReason, giftcardParams);
								}
							};
						}        	
					} else if(giftcardParams.refund_using != 'giftcard') {
						var giftcardParams = {
							payment_info_email : vm.payment_info_email,
							amount : amount,
							refund_using :refund_using
						}
        				vm.refundEmailPopup(giftcardParams);
					}
					// Refund Reason Code End 

					/*if(refund_using != 'giftcard'){
						$mdDialog.show({
							clickOutsideToClose	: false,
							parent             	: angular.element($document.body),
							scope				: $scope,
							preserveScope		: true,
							locals				: {
													localData :{
														payment_info_email: vm.payment_info_email,
														refunded_amount: amount
													}
												},
							templateUrl        	: 'app/main/apps/e-commerce/views/orders/dialogs/payments/refundEmail.html',
							controller			: RefundEmailController
						});
						function RefundEmailController($scope, $mdDialog, localData) {
							$scope.payment_info_email = localData.payment_info_email;
							$scope.refund_amount = localData.refunded_amount;
							$scope.closeDialog = function(){
								$mdDialog.hide();
							};
						}
					}*/
				} else {
					if(response.errorMsg)
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					else
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
				}
			});
		}

		$scope.isProcessing = false;
		function refundEmail(payment_info_email,refund_amount){
			$scope.isProcessing = true;
			vm.isloading = true;
			var data = {confirmation_number:vm.order.confirmation_number,payment_info_email:payment_info_email,refund_amount:refund_amount};	
			eCommerceService.customRefundEmail(data).then(function(response){
				vm.isloading = false;
				$mdDialog.hide();
			});
		}

		function changeStatusAfterPayment(idx,room_stay_id,oldStatus,newStatus,sendEmail){
			vm.changingStatus = true;
			vm.changeStatusData = {newStatus:newStatus,oldStatus:oldStatus,sendEmail:sendEmail};
			vm.room_stay_status = oldStatus;
			$location.hash('data-table-' + idx);
			$mdDialog.hide();
			$timeout(function() {
				$window.location.hash='';
			},2000);
		}
		function changeStatusWithoutPayment(idx,confirmation_number,oldStatus,newStatus,sendEmail){
			changeStatusFinally(confirmation_number,newStatus,oldStatus,idx,sendEmail);
			$mdDialog.hide();
		}
		function changeStatusFinally(confirmation_number,newStatus,oldStatus,idx,sendEmail){
			vm.changingStatus = false;
			vm.changeStatusData = {};
			vm.isloading = true;
			ganttChartService.changeReservationStatus({'confirmation_number':confirmation_number,'room_stay_status':newStatus,'oldStatus':oldStatus,'room_stay_from':vm.order.room_stay_from,'room_stay_to':vm.order.room_stay_to,'product_id':vm.order.product_id,'reservation_id':vm.reservation_id,'sendEmail':sendEmail}).then(function(response){
				vm.isloading = false;
				if(response.success ){
					if(response.hasOwnProperty('mail_error') && response.mail_error && response.errorMsg != '')
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					if(newStatus != 'Canceled' && vm.allRoomCancelled) vm.allRoomCancelled = false;
					if(response.order_info){
						vm.order = response.order_info.reservations[0];
						vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];
						vm.room_stay_status = angular.copy(vm.order.room_stay_status);
						vm.statuses = {'Active':'Active','Checked-In':'Check-In','Checked-Out':'Check-Out','Closed':'Close','Canceled':'Cancel'};
						vm.statuses[vm.room_stay_status] = vm.room_stay_status;
						setAllStatuses();
						originalOrderData = angular.copy(vm.order);
						vm.showModifyBtn = false;
						vm.showPaymentsLoader = true;
						$timeout(function(){
							fetchPaymentsInformation(vm.order.confirmation_number,vm.order.first_name,vm.order.last_name,vm.order.total_amount,vm.order.overalltotals.remaining_amount);
						},100);
					}
				}else{
					if(response.errorMsg != '')
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					else
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
					vm.room_stay_status = oldStatus;
				}
			});
		}

		function cancelChangeStatus(){
			vm.changingStatus = false;
			vm.changeStatusData = {};
		}

		function fetchOrderInformation(confirmation_number){
			if((!vm.order.hasOwnProperty('customer_id') || (vm.order.hasOwnProperty('customer_id') && vm.order.customer_id > 0)) && confirmation_number != ''){
				vm.isloading = true;
				var data = {confirmation_number:confirmation_number};
				eCommerceService.fetchOrder(data).then(function(response){
					if(!response.success){
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
					} else {
						var order_info = response.reservation;
						vm.order = angular.merge(vm.order, order_info);
						vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];

						


						originalOrderData = angular.copy(vm.order);
						vm.room_stay_status = angular.copy(vm.order.room_stay_status);
						vm.statuses = {'Active':'Active','Checked-In':'Check-In','Checked-Out':'Check-Out','Closed':'Close','Canceled':'Cancel'};
						vm.statuses[vm.room_stay_status] = vm.room_stay_status;
					}
					vm.isloading = false;
				});
			}
		}

		function fetchOrder(confirmation_number){
			vm.payment_method = {};
			if(confirmation_number != '' && vm.order.confirmation_number != confirmation_number){
				vm.isloading = true;
				vm.showPaymentsLoader = true;
				var data = {confirmation_number:confirmation_number};
				eCommerceService.fetchOrder(data).then(function(response){
					if(!response.success){
						vm.isloading = false;
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
					} else {
						vm.order = {};
						vm.order = response.reservation;
						vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];
						originalOrderData = angular.copy(response.reservation);
						vm.room_stay_status = angular.copy(vm.order.room_stay_status);
						vm.statuses = {'Active':'Active','Checked-In':'Check-In','Checked-Out':'Check-Out','Closed':'Close','Canceled':'Cancel'};
						vm.statuses[vm.room_stay_status] = vm.room_stay_status;
						var changeloader = true;


						vm.adultRange = vm.getRangeArray(1, (parseInt(vm.order['max_occupancy'])- parseInt(vm.order.room_stay_child_count)));
						vm.childRange = vm.getRangeArray(0,( parseInt(vm.order['max_occupancy']) - parseInt(vm.order.room_stay_guest_count)));

						vm.resortFeeApplied[vm.selectedIndex] = response.reservation['resortFeeApplied'];
						vm.resortFeeAppliedVisible = response.reservation['resortFeeAppliedVisible'];

						if(vm.order.hasOwnProperty('pos') && parseInt(Object.keys(vm.order.pos).length) > 0){
							changeloader = false;
							vm.statusesPos = {};
							var itemsInPos = vm.order.pos.length;
							angular.forEach(vm.order.pos, function (value, key)
							{
								vm.statusesPos[key] = {'Active':'Active','Canceled':'Cancel'};
								vm.statusesPos[key][value.room_stay_status] = value.room_stay_status;
								vm.pos_status[key] = value.room_stay_status;
								if(itemsInPos == (parseInt(key) + 1))
									vm.isloading = false;
							});
						}

						vm.innerSlectedIndex = 0;
						vm.showPaymentsLoader = true;
						$timeout(function() {
							if(changeloader)
								vm.isloading = false;
							fetchPaymentsInformation(confirmation_number,vm.order.first_name,vm.order.last_name,vm.order.total_amount,vm.order.overalltotals.remaining_amount);
						},1000);
					}
				});
			}
		}

		function fetchOrderHistory(confirmation_number){
			if(!vm.order.hasOwnProperty('order_history') && confirmation_number != ''){
				vm.isloading = true;
				var data = {confirmation_number:confirmation_number};
				eCommerceService.fetchOrderHistory(data).then(function(response){
					if(!response.success){
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
						vm.no_found = true;
					} else if(response.history_found) {
						vm.no_found = false;
						vm.order.order_history = response.order_history;
					} else {
						vm.no_found = true;
					}
					vm.isloading = false;
				});
			}
		}
		vm.cartType = '';

		function fetchPaymentsInformation(confirmation_number,first_name,last_name,total_amount,remaining_amount){
			angular.forEach($http.pendingRequests, function(request) {
				if (request.cancel && request.timeout) {
				   request.cancel.resolve();
				}
			 });
			if(!vm.order.hasOwnProperty('installments') && confirmation_number != ''){
				var data  = {confirmation_number:confirmation_number,first_name:first_name,last_name:last_name,total_amount:total_amount,remaining_amount:remaining_amount};
				eCommerceService.fetchPaymentsInformation(data).then(function(response){
					if(!response.success){
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
					} else {
						if(response.allcardsInfo.length > 0 && response.allcardsInfo != '' ){
							vm.ct = response['allcardsInfo']['cc_type'];
						}
						vm.installments = [];
						vm.installments = response.installments;
						vm.allcardsInfo = response.allcardsInfo;
						vm.customer_profile = response.customer_profile;
						vm.paid_hotel_id  = response.paid_hotel_id;
						vm.fieldsIsReadOnly = false;
						if(Object.keys(response.allcardsInfo).length > 0){
							vm.payment_method = response.allcardsInfo[0];
							let savedYear = parseInt(vm.payment_method.cc_exp_year);
							let currentYear = new Date().getFullYear();
							
							if (savedYear && savedYear < currentYear && !vm.yrs_option.includes(savedYear)) {
								vm.yrs_option.unshift(savedYear);
							}
							if(response.allcardsInfo[0].cc_number!=''){
								vm.fieldsIsReadOnly = true;
								vm.use_existingcard = 0;
							}
						}
						vm.installment_amount=vm.installments['remaining'].balance;

						vm.payment_method.payment_method = response.selectedPaymentMethod;
						if(response.selectedPaymentMethod == ""){
							vm.payment_method.payment_method = "Cash";

						}
					}
					vm.showPaymentsLoader = false;
				});
			}
		}

		function fetchOrderCommentsRequests(confirmation_number){
			//~ if((!vm.commentsSpecial.hasOwnProperty('comment') || !vm.commentsSpecial.hasOwnProperty('special_request')) && confirmation_number != ''){
			if(confirmation_number != ''){
				vm.isloading = true;
				var data = {confirmation_number:confirmation_number};
				eCommerceService.fetchOrderCommentsRequests(data).then(function(response){
					if(!response.success){
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
					} else {
						vm.commentsSpecial.comment = response.comments;
						vm.commentsSpecial.special_request = response.requests;
					}
					vm.isloading = false;
				});
			}
		}

		function roomMoveStartFinally(ev,checkin,checkout,adult,child,room_stay_id,product_id,product_name,policy_id,confirmation_number,reservation_id,itinerary_number){

			$mdDialog.show({
				controller         : 'rooomMoveController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/apps/e-commerce/views/orders/dialogs/room-move/room-move.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					checkin: checkin,
					checkout: checkout,
					adult: adult,
					child: child,
					product_id: product_id,
					product_name: product_name,
					reservation_id: reservation_id,
					itinerary_number: itinerary_number,
					room_stay_id: room_stay_id,
					confirmation_number: confirmation_number,
					policy_id: policy_id,
					reservation_type : vm.order.type_of_reservation
				}
			});
		}

		function roomMoveStart(ev,checkin,checkout,adult,child,room_stay_id,product_id,product_name,policy_id,confirmation_number,reservation_id,itinerary_number){
			if(vm.order.room_number_locked_indicator == 1){
				var confirm = $mdDialog.confirm()
								.title('Do not move')
								.htmlContent('<div class="md-padding custom-common-dailog">Do not move is set for this reservation. Do you want to continue?</div>')
								.ariaLabel('Do not move')
								.targetEvent(ev)
								.ok('YES')
								.cancel('NO');
				$mdDialog.show(confirm).then(function ()
				{
					roomMoveStartFinally(ev,checkin,checkout,adult,child,room_stay_id,product_id,product_name,policy_id,confirmation_number,reservation_id,itinerary_number);
				});
			} else {
				roomMoveStartFinally(ev,checkin,checkout,adult,child,room_stay_id,product_id,product_name,policy_id,confirmation_number,reservation_id,itinerary_number);
			}
		}

		function toggleReservationCustomer(){
			$mdSidenav('reservation-customer-sidenav').toggle();
		}

		function sendinvoice(type_of_order) {
			vm.isloading = true;
			var from_backend = 1;
            eCommerceService.sendInvoice(vm.reservation_id,vm.itinerary_number,type_of_order,from_backend).then(function(response) {
            	vm.isloading = false
                if(!response.success) {
                    toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                }
            })
        }

        function sendorderinvoice(confirmation_number) {
            eCommerceService.sendOrderInvoice(confirmation_number,vm.reservation_id,vm.order.room_stay_status).then(function(response) {
                if(!response.success) {
                    toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                }
            })
        }
        
        function printinvoice(reservation_id) {
        	vm.isloading = true;
            eCommerceService.printInvoice(reservation_id).then(function(response) {
            	vm.isloading = false;
                if(!response.success) {
                    toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                } else {
				    vm.isloading = false;
					vm.print_invoice_data = '';
                    vm.print_invoice_data = response.data;
                    var myWindow=window.open('','','', '');
                    myWindow.document.write(response.data);
                    myWindow.document.close();
                    myWindow.focus();
                }

            })
        }
        function printorderinvoice(confirmation_number) {
        	var response = [];
            eCommerceService.printOrderInvoice(confirmation_number).then(function(response) {
                if(!response.success) {
                    toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                } else {
					vm.print_data = '';
					vm.print_data = response.data;
					var myWindow=window.open('','','','');
					myWindow.document.write(vm.print_data);
					myWindow.document.close();
					myWindow.focus();
                }

            });
        }

		function editOrderDates(ev,checkin,checkout,adult,child,confirmation_number,product_id,product_name,policy_id){
			var localData = {
								checkin:checkin,
								checkout:checkout,
								adult:adult,
								child:child,
								confirmation_number:confirmation_number,
								product_id:product_id,
								product_name:product_name,
								reservation_id:Reservation_id,
								policy_id:policy_id,
								requestFor:vm.pageType,
								tax_exempt_indicator: Order['response']['reservation_customer']['tax_exempt_indicator'],
							};
			eCommerceService.editDatesDialog(ev,localData);
		}
		
		function editParkingDates(ev,checkin,checkout,adult,child,confirmation_number,product_id,product_name,policy_id, posValue){
			if(typeof posValue != 'undefined' && typeof posValue.room_stay_status != 'undefined'  && posValue.room_stay_status != "Canceled"){
				var localData = {
					checkin:checkin,
					checkout:checkout,
					adult:adult,
					child:child,
					confirmation_number:confirmation_number,
					room_confirmation_number:vm.order.confirmation_number,
					product_id:product_id,
					product_name:product_name,
					reservation_id:Reservation_id,
					policy_id:policy_id};
				eCommerceService.editPDatesDialog(ev,localData);
			}
		}
		
		function addParking(ev,checkin,checkout,confirmation_number){
			var localData = {checkin:checkin,checkout:checkout,confirmation_number:confirmation_number,reservation_id:Reservation_id,parking:true,itinerary_number:vm.itinerary_number,add_screen:'view'};
			eCommerceService.editPDatesDialog(ev,localData);
		}
		
		function addBoatPos(ev,checkin,checkout,confirmation_number){
			var localData = {checkin:checkin,checkout:checkout,confirmation_number:confirmation_number,reservation_id:Reservation_id,parking:false,itinerary_number:vm.itinerary_number,add_screen:'view',type:'boat',product_id:vm.order.product_id,type_id:vm.order.type_id};
			eCommerceService.editPDatesDialog(ev,localData);
		}

		function updateReservationValues(confirmation_number,column_name,value){
			if(value != ""){
				vm.isloading = true;
				var data = {reservation_id:vm.reservation_id,confirmation_number:confirmation_number,column_name:column_name,value:value};
				eCommerceService.updateReservationValues(data).then(function(response){
					vm.isloading = false;
					if(!response.success){
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
					}
				});
			}
		}

		function saveCommentReq(idx,confirmation_number){
			if(vm.comm_req_value != ""){
				vm.isloading = true;
				var data = {comm_req_type:vm.comm_req_type,comm_req_value:vm.comm_req_value,confirmation_number:confirmation_number,room_stay_from:vm.order.room_stay_from,room_stay_to:vm.order.room_stay_to,product_id:vm.order.product_id};
				eCommerceService.saveCommentReq(data).then(function(response){
					vm.isloading = false;
					if(response.success){
						var new_comment = {description:response.created_by_user,title:response.comm_req_value,time:moment().format('lll')};
						vm.commentsSpecial[vm.comm_req_type].unshift(new_comment);
						vm.comm_req_value = "";
					}else{
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
					}
				});
			}
		}

		function payInstallment(conf_number,orderIndex,traveler_fname,traveler_lname){
			vm.addNewCard = false;
			vm.paymentrequestGoing = true;
			if(vm.changingStatus){
				var changeStatusData = {
					confirmation_number:conf_number,
					remaining_amount:vm.installment_amount,
					payment_method:vm.payment_method,
					traveler_fname:traveler_fname,
					traveler_lname:traveler_lname,
					customer_profile:vm.customer_profile,
					paid_hotel_id:vm.paid_hotel_id,
					itinerary_number:vm.itinerary_number,
					payingFromGC:vm.payingFromGC
				};
				vm.changeStatusData = angular.merge(vm.changeStatusData, changeStatusData);
				vm.changingStatus = false;
			} else {
				vm.changeStatusData = {
					confirmation_number:conf_number,
					remaining_amount:vm.installment_amount,
					payment_method:vm.payment_method,
					traveler_fname:traveler_fname,
					traveler_lname:traveler_lname,
					customer_profile:vm.customer_profile,
					paid_hotel_id:vm.paid_hotel_id,
					itinerary_number:vm.itinerary_number,
					payingFromGC:vm.payingFromGC
				};
			}

			// return;

			eCommerceService.payInstallment(vm.changeStatusData).then(function(response){
				vm.paymentrequestGoing = false;
				if(!response.success && response.errorMsg!='undefined'){
					toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
				}else if(!response.success){
					toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.', 'error-toast');
				}else if(response.success){
					vm.payingFromGC = {};
					vm.installments = response.data.installments;
					vm.allcardsInfo = response.data.allcardsInfo;
					vm.customer_profile = response.data.customer_profile;
					vm.paid_hotel_id = response.data.hotel_id;
					vm.installment_amount = angular.copy(vm.installments['remaining'].origremainingamt);
					vm.order = response.reservation;
					vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];
					originalOrderData = angular.copy(response.reservation);
					vm.room_stay_status = angular.copy(vm.order.room_stay_status);
					vm.statuses = {'Active':'Active','Checked-In':'Check-In','Checked-Out':'Check-Out','Closed':'Close','Canceled':'Cancel'};
					vm.statuses[vm.room_stay_status] = vm.room_stay_status;
					setAllStatuses();
					monthlyWeeklyNight(vm.order);
					if(response.available_error != ''){
						toastMessage.showSimpleToast(response.available_error, 'error-toast');
					}
					if(Object.keys(response.data.allcardsInfo).length > 0){
						var size = response.data.allcardsInfo.length;
						vm.payment_method = response.data.allcardsInfo[(parseInt(size)-1)];
						if(response.data.allcardsInfo[(parseInt(size)-1)].cc_number!=''){
							vm.fieldsIsReadOnly = true;
						}
					} else {
						vm.payment_method.payment_method = response.data.selectedPaymentMethod;
						if(response.data.selectedPaymentMethod == ""){
							vm.payment_method.payment_method = "Cash";
						}
					}
				}
			});
		}

		function changeActiveCard(orderIndex){
			vm.addNewCard = false;
			var count = vm.use_existingcard;
			vm.payment_method = vm.allcardsInfo[count];
			vm.fieldsIsReadOnly = true;
		}

		function checkremainingAmount(orderIndex){
			if(parseFloat(vm.installments['remaining'].origremainingamt)<parseFloat(vm.installment_amount)){
				vm.installment_amount = vm.installments['remaining'].origremainingamt;
				toastMessage.showSimpleToast($translate.instant('CREATE_RES.PAYNOW_ERROR'), 'error-toast');
			}else if(parseFloat(vm.payingFromGC.gcCardOrigPrice)>0){
				var adjustedGCPrice = commonService.calculateGCValue(vm.installment_amount,vm.payingFromGC.gcCardOrigPrice);
				vm.payingFromGC.price = adjustedGCPrice;
			}
		}

		vm.addNewCard = false;
		function emptythisPayment(){
			vm.addNewCard = true;
			var oldPaymentmethod = angular.copy(vm.payment_method.payment_method);
			vm.payment_method = {};
			vm.payment_method.payment_method = oldPaymentmethod;
			vm.fieldsIsReadOnly = false;
			vm.use_existingcard = '';
			vm.ct = '';
			setTimeout(function(){
				vm.readySwipe();
				vm.swipeNow();
			},100);			
			
		}
		vm.not_incidental = false;

		function setasincidental(conf_number,orderIndex,traveler_fname,traveler_lname, type){
			// return;
			var payment_method = angular.copy(vm.payment_method);
			var setting_as_inc = true;
			if(type == 'is_incidental'){
				payment_method.cc_is_incidental = 1;
				vm.incidentalrequestGoing = true;
			}else{
				payment_method.cc_is_incidental = 0;
				vm.not_incidental = true;
				setting_as_inc = false;
			}
			var data = {
				confirmation_number:conf_number,
				reservation_id:vm.reservation_id,
				remaining_amount:0,
				payment_method:payment_method,
				traveler_fname:traveler_fname,
				traveler_lname:traveler_lname,
				customer_profile:vm.customer_profile,
				itinerary_number:vm.itinerary_number,
				payingFromGC:0,
				setting_as_inc:setting_as_inc,
				save_card:type,
				paid_hotel_id:vm.order.sub_hotel_id

			};
			
			//var oldExisting = angular.copy(vm.use_existingcard);
			eCommerceService.payInstallment(data).then(function(response){
				vm.addNewCard = false;
				vm.incidentalrequestGoing = false;
				vm.not_incidental = false;
				if(!response.success && response.errorMsg!='undefined'){
					toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
				}else if(!response.success){
					toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.', 'error-toast');
				}else if(response.success){
					vm.use_existingcard = '';
					vm.payingFromGC = {};
					vm.allcardsInfo = response.data.allcardsInfo;
					vm.customer_profile = response.data.customer_profile;
					vm.payment_method = response.data.allcardsInfo[0];
					vm.fieldsIsReadOnly = true;
					$timeout(function() {
						vm.use_existingcard = 0;
					},200);
				}
			});
		}

        function validateGCCode(){
			 vm.gcrequestGoing = true;
             createResService.validateGCC({GCC:vm.giftCardCode}).then(function(response){
				vm.gcrequestGoing = false;
				if(response.success && !response.data.length == 0){

					if(parseFloat(response.data[0]['gift_card_price']) == 0){
                        vm.giftCardErrro = 'No amount left for this gift card.';
                    }else{
						var adjustedGCPrice = commonService.calculateGCValue(vm.installment_amount,response.data[0]['gift_card_price']);
						vm.payingFromGC = {};
						vm.payingFromGC.price = adjustedGCPrice;
						vm.payingFromGC.gcCode = response.data[0]['gift_card_code'];
						vm.payingFromGC.gcCardOrigPrice = response.data[0]['gift_card_price'];
						vm.giftCardErrro = '';
						vm.giftCardCode = '';
						$location.hash('focus-cccode');
							$timeout(function() {
								$window.location.hash='';
							},2000);
					}


				}else if(!response.success && response.errorMsg!=''){
					vm.payingFromGC = {};
                    vm.giftCardErrro = response.errorMsg;
				}else if(response.data.length == 0){
					vm.payingFromGC = {};
					vm.giftCardErrro = $translate.instant('CREATE_RES.INVALID_GC');
				}else{
					vm.payingFromGC = {};
					vm.giftCardErrro = $translate.instant('CREATE_RES.SERVER_ERROR');
				}
            });
        }
        function addroomincart(ev){
        	// product_type = 'room';
        	var additionalParams = {
        		'reservation_type' : vm.order['type_of_reservation']
        	}
        	
			createResService.addRoom(
					ev,
					vm.order.room_stay_from,
					vm.order.room_stay_to,
					vm.order['room_stay_guest_count'],
					vm.order['room_stay_child_count'],
					'',
					'currentorder',
					vm.itinerary_number,
					'',
					'',
					additionalParams
				);
		}
		function cancelThisNight(nightDate){
			$mdDialog.show({
				controller: 'confirmController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
				parent: angular.element(document.body),
				targetEvent: event,
				clickOutsideToClose:true ,
				locals: {
					title: 'Cancel Night',
					htmlContent:"Are you sure you want to cancel this night without issuing a refund to the customer?",
					cancelBtn:'No',
					OkBtn:'Yes'
				}
			}).then(function(answer) {
				if(typeof answer != 'undefined' && answer == 'update'){
				vm.isloading = true;
				createResService.cancelThisNight({
								confirmation_number :vm.order.confirmation_number,
								date:nightDate
					}).then(function(response){
						vm.isloading = false;
						if(response.success){
							vm.order = response.order_info.reservations[0];
							vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];
							originalOrderData = angular.copy(vm.order);
						}else if(!response.success && response.errorMsg){
							toastMessage.showSimpleToast(response.errorMsg,'error-toast');
						}else if(!response.success && response.server_error){
							toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'),'error-toast');
						}else{
							toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'),'error-toast');
						}
				});
			}
				}, function(dialogText) {				
			});
		}

		vm.cancelThisNightPOS = cancelThisNightPOS;

		function cancelThisNightPOS(date,posValue){
			$mdDialog.show({
				controller: 'confirmController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
				parent: angular.element(document.body),
				targetEvent: event,
				clickOutsideToClose:true ,
				locals: {
					title: 'Cancel Night',
					htmlContent:"Are you sure you want to cancel this night without issuing a refund to the customer?",
					cancelBtn:'No',
					OkBtn:'Yes'
				}
			}).then(function(answer) {
				if(typeof answer != 'undefined' && answer == 'update'){
					vm.isloading = true;
					createResService.cancelThisNightPOS({room_confirmation_number :vm.order.confirmation_number,date:date, cancelNight:'service', pos_Confirmation_number:posValue['confirmation_number']}).then(function(response){
						vm.isloading = false;
						if(response.success){
							vm.order = response.order_info.reservations[0];
							vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];
							originalOrderData = angular.copy(vm.order);
						}else if(!response.success && response.errorMsg){
							toastMessage.showSimpleToast(response.errorMsg,'error-toast');
						}else if(!response.success && response.server_error){
							toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'),'error-toast');
						}else{
							toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'),'error-toast');
						}
					});
				}
					}, function(dialogText) {				
			});

		}

		vm.undoCancelThisNightPOS = undoCancelThisNightPOS;
		function undoCancelThisNightPOS(date, posValue){

				
			vm.isloading = true;
			createResService.undoCancelThisNight({room_confirmation_number :vm.order.confirmation_number,date:date, cancelNight:'service', pos_Confirmation_number:posValue['confirmation_number']}).then(function(response){
				vm.isloading = false;
				if(response.success){
					vm.order = response.order_info.reservations[0];
					vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];
					originalOrderData = angular.copy(vm.order);
				}else if(!response.success && response.errorMsg){
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				}else if(!response.success && response.server_error){
					toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'),'error-toast');
				}else{
					toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'),'error-toast');
				}
			});			
			

			
		}

		// vm.posNoRefundCancel = posNoRefundCancel;
		// function posNoRefundCancel(dateKey, posValue){
		// 	return (dateKey == 0 || dateKey == (posValue.prices.dates.length - 1)) ? true:false;
		// }
		function undoCancelThisNight(nightDate){
			vm.isloading = true;
			createResService.undoCancelThisNight({confirmation_number :vm.order.confirmation_number,date:nightDate}).then(function(response){
				vm.isloading = false;
				if(response.success){
					vm.order = response.order_info.reservations[0];
					vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];
					originalOrderData = angular.copy(vm.order);
				}else if(!response.success && response.errorMsg){
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				}else if(!response.success && response.server_error){
					toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'),'error-toast');
				}else{
					toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'),'error-toast');
				}
			});
		}

		$scope.$on('update_order_data', function(event,data) {
			vm.order = data.reservations;
			vm.order['tax_exempt_indicator'] = Order['response']['reservation_customer']['tax_exempt_indicator'];
			monthlyWeeklyNight(vm.order);

			originalOrderData = angular.copy(vm.order);
			setAllStatuses();
			vm.showModifyBtn = false;
			vm.showPaymentsLoader = true;
			$timeout(function(){
				monthlyWeeklyNight(vm.order);
				fetchPaymentsInformation(vm.order.confirmation_number,vm.order.first_name,vm.order.last_name,vm.order.total_amount,vm.order.overalltotals.remaining_amount);
			},100);
		});

		vm.monthlyWeeklyNight = monthlyWeeklyNight;
		function monthlyWeeklyNight(orderData){
			if(orderData.hasOwnProperty('prices') && orderData.prices.hasOwnProperty('dates') && Object.keys(orderData.prices.dates).length > 31){
				var monthNames = [ 
									'January', 
									'February', 
									'March', 
									'April', 
									'May', 
									'June',
									'July', 
									'August', 
									'September', 
									'October', 
									'November', 
									'December' ];
				vm.dates = {};
				angular.forEach(orderData.prices.dates, function (value, key){
					var monthArr = value.split("-");
					var date = new Date(value);
					var month = monthNames[date.getMonth()];
					var weekofmonth = date.getDay();
					var year = monthArr[2];
					var month_year = month+" "+year;

					if(typeof vm.dates[month_year] == 'undefined'){
						vm.dates[month_year] = {};
					}

					vm.dates[month_year][key] = value;
				});	

				vm.newArray = {};
				angular.forEach(vm.dates, function (monthvalue, monthkey){
					var monthLength = Object.keys(monthvalue).length;
					var first = Object.keys(monthvalue)[0];
					var last = Object.keys(monthvalue)[monthLength-1];
					var wkey = 0;
					for(var i = parseInt(first); i <= parseInt(last); i++){
						if(typeof vm.newArray[monthkey] == 'undefined')
						vm.newArray[monthkey] = {};

						if(typeof vm.newArray[monthkey][wkey] == 'undefined')
						vm.newArray[monthkey][wkey] = {};
					   
						vm.newArray[monthkey][wkey][i] = monthvalue[i];

						if(Object.keys(vm.newArray[monthkey][wkey]).length > 6 && Object.keys(vm.newArray[monthkey][wkey]).length < 31){
							first += 7;
							wkey++;
							continue;
						}					
					}
				});	

				angular.forEach(vm.newArray, function (value, key){
					var yearmonthLength = Object.keys(vm.newArray).length;
					var firstofmonth = Object.keys(vm.newArray)[1];
					var lastofmonth = Object.keys(vm.newArray)[yearmonthLength-2];
					var weekmonthLength = Object.keys(vm.newArray[lastofmonth]).length;
					var firstofweek = Object.keys(vm.newArray[lastofmonth])[0];
					var lastofweek = Object.keys(vm.newArray[lastofmonth])[weekmonthLength-1];

					if(Object.keys(value).length == 1 && Object.keys(vm.newArray[Object.keys(vm.newArray)[0]][0]).length == 1){
						var monthattributes = Object.keys(vm.newArray[key][0]);
						for (var i = 0; i < monthattributes.length; i++) {
						  	vm.newArray[firstofmonth][firstofweek][monthattributes[i]] = vm.newArray[key][0][monthattributes[i]];
						}
						delete vm.newArray[key]; 
					} else if(Object.keys(value).length == 1 && Object.keys(vm.newArray[Object.keys(vm.newArray)[yearmonthLength-1]][0]).length == 1){
						var monthattributes = Object.keys(vm.newArray[key][0]);
						for (var i = 0; i < monthattributes.length; i++) {
						  	vm.newArray[lastofmonth][lastofweek][monthattributes[i]] = vm.newArray[key][0][monthattributes[i]];
						}
						delete vm.newArray[key]; 
					} else {
						angular.forEach(value, function (weekvalue, weekkey){
							if(Object.keys(weekvalue).length == 1 || (Object.keys(weekvalue).length == 1 && Object.keys(vm.newArray[Object.keys(vm.newArray)[yearmonthLength-1]][weekkey]).length == 1)){
								var attributes = Object.keys(vm.newArray[key][weekkey]);
	 							// if(Object.keys(vm.newArray[key][weekkey]).length > 1){
									for (var i = 0; i < attributes.length; i++) {
									  vm.newArray[key][weekkey-1][attributes[i]] = vm.newArray[key][weekkey][attributes[i]]
									}
									delete vm.newArray[key][weekkey]; 
								// }
							}
						});
					}					
				});	

				// Monthly/Weekly overall total and paid amount start
				vm.weekOverallTotal = {};
				vm.weekPaidValues = {};
				vm.weekOwesValues = {};
				vm.monthOverallTotal = {};
				vm.PaidValues = {};
				vm.owesValues = {};
				vm.monthly_paid_amount  = vm.order.overalltotals.paid_amount;
				vm.total_paid_amount  = vm.order.overalltotals.paid_amount;
				angular.forEach(vm.newArray, function (monthlyvalue, monthlykey){
					if(typeof vm.monthOverallTotal[monthlykey] == 'undefined')
						vm.monthOverallTotal[monthlykey] = {};
					vm.monthOverallTotal[monthlykey]['discount'] = 0;
					vm.monthOverallTotal[monthlykey]['price'] = 0;
					angular.forEach(monthlyvalue, function (value, key){
						angular.forEach(value, function (weekData, weekSkey){
							vm.monthOverallTotal[monthlykey]['discount'] += parseFloat(vm.order.prices.nightlydiscount[weekSkey]);
							vm.monthOverallTotal[monthlykey]['price'] += parseFloat(vm.order.prices.rates[weekSkey]);
						});
					});

					vm.monthOverallTotal[monthlykey]['discount'] = commonService.roundnum(vm.monthOverallTotal[monthlykey]['discount'],2);
					vm.monthOverallTotal[monthlykey]['price'] = commonService.roundnum(vm.monthOverallTotal[monthlykey]['price'],2);

					//Monthly paid amount start
					vm.monthly_paid_amount = 0;

					if(parseFloat(vm.monthOverallTotal[monthlykey]['price']) <= parseFloat(vm.total_paid_amount)){
						vm.total_paid_amount = parseFloat(vm.total_paid_amount) - parseFloat(vm.monthOverallTotal[monthlykey]['price']);
						vm.monthly_paid_amount = vm.monthOverallTotal[monthlykey]['price'];
					} else if (parseFloat(vm.monthOverallTotal[monthlykey]['price']) > parseFloat(vm.total_paid_amount)){
						var temp_paid_amount = angular.copy(vm.total_paid_amount);
						vm.total_paid_amount = 0;
						vm.monthly_paid_amount = commonService.roundnum(temp_paid_amount,2);
					}
					if(typeof vm.PaidValues[monthlykey] == 'undefined')
						vm.PaidValues[monthlykey] = angular.copy(vm.monthly_paid_amount);

					if(typeof vm.owesValues[monthlykey] == 'undefined')
						vm.owesValues[monthlykey] = vm.monthOverallTotal[monthlykey]['price'] - vm.PaidValues[monthlykey];

					vm.owesValues[monthlykey] = commonService.roundnum(vm.owesValues[monthlykey],2);
					//Monthly paid amount end

					angular.forEach(monthlyvalue, function (weeklyvalue, weeklykey){

						//Week Overall Total start
						var weekkey = monthlykey + weeklykey;
						if(typeof vm.weekOverallTotal[weekkey] == 'undefined')
							vm.weekOverallTotal[weekkey] = {};
						var myKeys = Object.keys(weeklyvalue);
						vm.weekOverallTotal[weekkey]['discount'] = 0;
						vm.weekOverallTotal[weekkey]['price'] = 0;
						angular.forEach(myKeys, function (wkey){
							vm.weekOverallTotal[weekkey]['discount'] += parseFloat(vm.order.prices.nightlydiscount[wkey]);
							vm.weekOverallTotal[weekkey]['price'] += parseFloat(vm.order.prices.rates[wkey]);
						});
						
						vm.weekOverallTotal[weekkey]['discount'] = commonService.roundnum(vm.weekOverallTotal[weekkey]['discount'],2);
						vm.weekOverallTotal[weekkey]['price'] = commonService.roundnum(vm.weekOverallTotal[weekkey]['price'],2);
						
						vm.weekly_paid_amount = 0;
						if(parseFloat(vm.weekOverallTotal[weekkey]['price']) <= parseFloat(vm.monthly_paid_amount)){
							vm.monthly_paid_amount = parseFloat(vm.monthly_paid_amount) - parseFloat(vm.weekOverallTotal[weekkey]['price']);
							vm.weekly_paid_amount = vm.weekOverallTotal[weekkey]['price'];
						} else if (parseFloat(vm.weekOverallTotal[weekkey]['price']) > parseFloat(vm.monthly_paid_amount)){
							var temp_paid_amount = angular.copy(vm.monthly_paid_amount);
							vm.monthly_paid_amount = 0;
							vm.weekly_paid_amount = commonService.roundnum(temp_paid_amount,2);
						}
						if(typeof vm.weekPaidValues[weekkey] == 'undefined')
							vm.weekPaidValues[weekkey] = angular.copy(vm.weekly_paid_amount);

						if(typeof vm.weekOwesValues[weekkey] == 'undefined')
							vm.weekOwesValues[weekkey] = vm.weekOverallTotal[weekkey]['price'] - vm.weekPaidValues[weekkey];

						vm.weekPaidValues[weekkey] = commonService.roundnum(vm.weekPaidValues[weekkey],2);
						vm.weekOwesValues[weekkey] = commonService.roundnum(vm.weekOwesValues[weekkey],2);	
					});
				});	
				// Monthly/Weekly overall total and paid amount end
			} else if(Object.keys(orderData.prices.dates).length >= 7 && Object.keys(orderData.prices.dates).length < 31) {
				vm.newArray = {};
				var monthLength = Object.keys(orderData.prices.dates).length;
				var first = Object.keys(orderData.prices.dates)[0];
				var last = Object.keys(orderData.prices.dates)[monthLength-1];
				var wkey = 0;
				var rem = 0;
				for(var i = first; i <= last; i++){
					if(typeof vm.newArray[wkey] == 'undefined')
					vm.newArray[wkey] = {};
				   
					vm.newArray[wkey][i] = orderData.prices.dates[i];
					if(Object.keys(vm.newArray[wkey]).length > 6 && Object.keys(vm.newArray[wkey]).length < 31){
						first += 7;
						wkey++;
						continue;
					}
				}
				
				angular.forEach(vm.newArray, function (weekvalue, weekkey){
					if(Object.keys(weekvalue).length == 1){
						var attributes = Object.keys(vm.newArray[weekkey]);

						for (var i = 0; i < attributes.length; i++) {
						  vm.newArray[weekkey-1][attributes[i]] = vm.newArray[weekkey][attributes[i]]
						}
						delete vm.newArray[weekkey]; 
					}
					
				});

				vm.weekOverallTotal = {};
				vm.weekPaidValues = {};
				vm.weekOwesValues = {};
				vm.monthly_paid_amount  = vm.order.overalltotals.paid_amount;
				angular.forEach(vm.newArray, function (weeksvalue, weekskey){
					//weekly overall total and paid amount start
					if(typeof vm.weekOverallTotal[weekskey] == 'undefined')
						vm.weekOverallTotal[weekskey] = {};
					var myKeys = Object.keys(weeksvalue);
					vm.weekOverallTotal[weekskey]['discount'] = 0;
					vm.weekOverallTotal[weekskey]['price'] = 0;
					angular.forEach(myKeys, function (key){
						vm.weekOverallTotal[weekskey]['discount'] += parseFloat(vm.order.prices.nightlydiscount[key]);
						vm.weekOverallTotal[weekskey]['price'] += parseFloat(vm.order.prices.rates[key]);
					});
					
					vm.weekOverallTotal[weekskey]['discount'] = commonService.roundnum(vm.weekOverallTotal[weekskey]['discount'],2);
					vm.weekOverallTotal[weekskey]['price'] = commonService.roundnum(vm.weekOverallTotal[weekskey]['price'],2);
					

					vm.weekly_paid_amount = 0;
					
					if(parseFloat(vm.weekOverallTotal[weekskey]['price']) <= parseFloat(vm.monthly_paid_amount)){
						vm.monthly_paid_amount = parseFloat(vm.monthly_paid_amount) - parseFloat(vm.weekOverallTotal[weekskey]['price']);
						vm.weekly_paid_amount = vm.weekOverallTotal[weekskey]['price'];
					} else if (parseFloat(vm.weekOverallTotal[weekskey]['price']) > parseFloat(vm.monthly_paid_amount)){
						var temp_paid_amount = angular.copy(vm.monthly_paid_amount);
						vm.monthly_paid_amount = 0;
						vm.weekly_paid_amount = commonService.roundnum(temp_paid_amount,2);
					}
					if(typeof vm.weekPaidValues[weekskey] == 'undefined')
						vm.weekPaidValues[weekskey] = angular.copy(vm.weekly_paid_amount);

					if(typeof vm.weekOwesValues[weekskey] == 'undefined')
						vm.weekOwesValues[weekskey] = vm.weekOverallTotal[weekskey]['price'] - vm.weekPaidValues[weekskey];

					vm.weekPaidValues[weekskey] = commonService.roundnum(vm.weekPaidValues[weekskey],2);
					vm.weekOwesValues[weekskey] = commonService.roundnum(vm.weekOwesValues[weekskey],2);
					//weekly overall total and paid amount end
				});
			}
		}

		vm.getWeekHeaderName = function(items,weekName){			
			var l = Object.keys(items).length;
			var first = items[Object.keys(items)[0]];
			var last = items[Object.keys(items)[l-1]];
			var html="<span>"+first+"<span class='to' >  To  </span>"+last+"</span>";
			return html;
		}


		/*Print Registration Card*/
		vm.printRegistrationCard = function(){
			vm.isloading = true;
			createResService.printRegistrationCard({confirmation_number :vm.order.confirmation_number}).then(function(response){
				vm.print_invoice_data = '';
                vm.print_invoice_data = response['data'];
				vm.isloading = false;
				var myWindow=window.open('','','', '');
				myWindow.document.write(response['data']);
				myWindow.document.close();
				myWindow.focus();
			});
		}
		/*Function to print the parking pass*/
		vm.printParkingPass = printParkingPass;
		function printParkingPass(posValue){
			vm.isloading = true;
			var data = {
				conf : posValue['confirmation_number'],
				from : posValue['room_stay_from'],
				to 	 : posValue['room_stay_to']
			}
			createResService.printParkingPass(data).then(function(response){
				vm.isloading = false;
				var myWindow=window.open('','','', '');
				myWindow.document.write(response['data']);
				myWindow.document.close();
				myWindow.focus();
				$timeout(function() {
					myWindow.print();
					myWindow.close();
				},500);
			});

		}
		vm.getOTADetails = getOTADetails;
		function getOTADetails(){
			$mdDialog.show({
				controller: 'otaController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/e-commerce/views/orders/dialogs/OTA/ota.html',
				parent: angular.element(document.body),
				targetEvent: event,
				clickOutsideToClose:true ,
				locals: {
					orderDetails: vm.order
				}
			}).then(function(answer) {
				vm.order.collect_which = answer.collect_which;
				vm.order.siteminder_id = answer.siteminder_id;
				vm.order.source_of_creation = answer.source_of_creation;
			}, function(dialogText) {
			});
		}
		function sumOfVals(a,b){
			return (parseFloat(a)+parseFloat(b));
		}
		vm.checValue = checValue;
		function checValue(amountEntered, type,poskey, event, column_name){
			vm.processRequest = true;
			var tempNumber = parseFloat(amountEntered);
			if(/[a-zA-Z]/.test(amountEntered) || tempNumber < 0 || isNaN(tempNumber) || commonService.roundnum(vm.order.pos[poskey][column_name],2) == commonService.roundnum(originalOrderData.pos[poskey][column_name],2)){
				vm.order.pos[poskey][column_name] = originalOrderData.pos[poskey][column_name]
				vm.processRequest = false;
				return;
			}else{
				console.log("request processed");
			}
		}
		function setAllStatuses(){
			if(vm.order.hasOwnProperty('pos') && parseInt(Object.keys(vm.order.pos).length) > 0){
				vm.statusesPos = {};
				var itemsInPos = vm.order.pos.length;
				var anyPosActive = false;
				angular.forEach(vm.order.pos, function (value, key)
				{
					vm.statusesPos[key] = {'Active':'Active','Canceled':'Cancel'};
					if(value.room_stay_status == 'Active') anyPosActive = true;
					vm.statusesPos[key][value.room_stay_status] = value.room_stay_status;
					vm.pos_status[key] = value.room_stay_status;
					if(itemsInPos == (parseInt(key) + 1))
						vm.isloading = false;
				});
				if(vm.roomCount == 0 && !anyPosActive){
					vm.allRoomCancelled = true;
				} else if(vm.roomCount == 0 && anyPosActive){
					vm.allRoomCancelled = false;
				}
			}
		}


		/*****************************************/
        /***** Geolocation autocomplete form *****/
        /*****************************************/

        var fullAddress = '';
        var result = '';

        initAutocomplete();
        function initAutocomplete() {
            setTimeout(function(){
                var autocomplete = new google.maps.places.Autocomplete(
                    (document.getElementById('autocomplete')),
                    {types: ['geocode']}
                );
                autocomplete.addListener('place_changed', function() {
                    result = autocomplete.getPlace();
                    getGeoData(result, 0);
                });
            }, 50); 
        }


        /*****************************************/
        /***** Geolocation autocomplete form *****/
        /*****************************************/
        initAutocompleteZip();
        function initAutocompleteZip() {
            setTimeout(function(){
                var autocompletezip = new google.maps.places.Autocomplete(
                    (document.getElementById('autocompletezip')),
                    {types: ['geocode']}
                );
                autocompletezip.addListener('place_changed', function() {
                    result = autocompletezip.getPlace();
                    getGeoData(result, 0);
                });
            }, 50); 
        }

        initAutocompleteTraveller();
        function initAutocompleteTraveller() {
            setTimeout(function(){
                var autocompleteTraveller = new google.maps.places.Autocomplete(
                    (document.getElementById('autocompleteTraveller')),
                    {types: ['geocode']}
                );
                autocompleteTraveller.addListener('place_changed', function() {
                    result = autocompleteTraveller.getPlace();
                    getGeoData(result, 1);
                });
            }, 50); 
        }

        /*****************************************/
        /***** Geolocation autocomplete form *****/
        /*****************************************/
        initAutocompleteZipTraveller();
        function initAutocompleteZipTraveller() {
            setTimeout(function(){
                var autocompletezipTraveller = new google.maps.places.Autocomplete(
                    (document.getElementById('autocompletezipTraveller')),
                    {types: ['geocode']}
                );
                autocompletezipTraveller.addListener('place_changed', function() {
                    result = autocompletezipTraveller.getPlace();
                    getGeoData(result, 1);
                });
            }, 50); 
        }

        // vm.resortFeeAppliedVisible = vm.cartdetails['resortFeeAppliedVisible'];
		
		vm.updateResortFee = updateResortFee;

        function updateResortFee(index){
        	/*false If applied and vice-versa*/        	
        	vm.order['resortFeeApplied'] = vm.resortFeeApplied[index];
			vm.order = commonService.calculateTotals(vm.order,false,[]);
			vm.modificationComment  = vm.resortFeeApplied[index]?'Resort fee added in order with confirmation number '+ vm.order.confirmation_number :'Resort fee removed from order with confirmation number ' + vm.order.confirmation_number;
			// vm.modificationComments = [];

			vm.modificationComments.push(vm.order.room_stay_id);
			if(!vm.resortFeeApplied[index]){
				angular.forEach(vm.order['taxes'], function(element, index){
					if(element['applied_on_field'] != ''){
						vm.order['taxes'][index]['tax_amt'] = '0.00';
						vm.order['taxes'][index]['tax_value'] = '0.00';
					}
					
				});
			}
			$timeout(function(){
				calculateOrderTotals();
			}, 0);
        }


        var addressData = {}; 
        function getGeoData(result, value) {
            var country = '';
            var state = '';
            var city = '';
            var postal_code = '';
            var street = '';
            var street_number = '';
            var sublocality = '';
            var sublocality2 = '';
            var neighborhood = '';
            if(result && result.address_components && result.address_components.length != 0) {
                for(var i = 0; i<result.address_components.length; i += 1) { 
                    var addressObj = result.address_components[i];
                    for(var j = 0; j < addressObj.types.length; j += 1) {
                        switch(addressObj.types[j]){
                            case "country":                     country = addressObj.long_name;         break;  //Country
                            case "administrative_area_level_1" : state  = addressObj.long_name;         break;  //State
                            case "administrative_area_level_2" : country = addressObj.long_name;        break;  //County
                            case "locality" :                   city    = addressObj.long_name;         break;  //City
                            case "route":                       street = addressObj.long_name;          break;  //street
                            case "neighborhood":                neighborhood = addressObj.long_name;    break;  //street
                            case "sublocality_level_2":         sublocality2 = addressObj.long_name;    break;  //street
                            case "sublocality_level_1":         sublocality = addressObj.long_name;     break;  //street
                            case "sublocality":                 sublocality = addressObj.long_name;     break;  //street
                            case "street_number":               street_number =  addressObj.long_name;  break;  //street number
                            case "postal_code":                 postal_code = addressObj.long_name;     break;  //Postal Code
                        }
                    }
                }
                addressData.zip_code = postal_code;
                addressData.address  = street_number + " " + sublocality + " " + sublocality2 + " " + street;
                addressData.city     = city ;
                addressData.state    = state;
                addressData.country  = country;
            }
            if(!postal_code) {
            	var data = { 
                    address: result.name  
                };
                userService.getZipCode(data).then(function(res) {
                    addressData.country = res.country; 
                    addressData.state = res.administrative_area_level_1;
                    addressData.city = res.locality;
                    street_number = res.street_number ? res.street_number : ''; 
                    street = res.route ? res.route : '';
                    addressData.address = street_number + ' ' + street;
                    addressData.zip_code = res.postal_code;
                });
            } else {
                addressData.zip_code = postal_code ? postal_code : ''; 
            }
			customFlag = false;
            $timeout(function() {   
                if(value) {
	            	vm.order.country = addressData.country;
		            vm.order.state = addressData.state;
		            vm.order.city = addressData.city;
		            vm.order.address = addressData.address ? addressData.address.trim() : '';
		            vm.order.zip_code = addressData.zip_code ? addressData.zip_code : '';;
		            vm.selectedCountryForTraveller = addressData.country;
		            vm.searchTxtCountryForTraveller = addressData.country;
		            vm.searchTxtStateForTraveller = addressData.state;
		            $timeout(function() {
		                angular.element('#autocompleteTraveller').val(vm.order.address);
		                angular.element('#autocompletezipTraveller').val(vm.order.zip_code);
		            }, 500);
		            autoFillData.address = vm.order.address;
		            autoFillData.city = vm.order.city;
		            autoFillData.state = vm.order.state;
		            autoFillData.country = vm.order.country;
		            autoFillData.zip_code = vm.order.zip_code;
		            autoFillData.confirmation_number = vm.order.confirmation_number;
	            } else {
	            	vm.reservation_customer.country = addressData.country;
		            vm.reservation_customer.state = addressData.state;
		            vm.reservation_customer.city = addressData.city;
		            vm.reservation_customer.address = addressData.address ? addressData.address.trim() : '';
		            vm.reservation_customer.zip_code = addressData.zip_code ? addressData.zip_code : '';
		            vm.selectedCountry = addressData.country; 
		            vm.searchTxtCountry = addressData.country;
		            vm.searchTxtState = addressData.state;
		            $timeout(function() {   
		                angular.element('#autocompletezip').val(vm.reservation_customer.zip_code);
		                angular.element('#autocomplete').val(vm.reservation_customer.address);
		            }, 500);
		            autoFillData.address = vm.reservation_customer.address;
		            autoFillData.city = vm.reservation_customer.city;
		            autoFillData.state = vm.reservation_customer.state;
		            autoFillData.country = vm.reservation_customer.country;
		            autoFillData.zip_code = vm.reservation_customer.zip_code;
		            autoFillData.confirmation_number = '';
	            }
	            autoFillData.reservation_id = vm.reservation_id;
				eCommerceService.updateReservationData(autoFillData).then(function(response){
					if(response.status === 'error') {
						toastMessage.showSimpleToast('Something wrong','error-toast');
					}
					customFlag = true;
				});
            }, 1000);
        }

        function toggle(key,type){ 
        	if(type == 'month'){
        		angular.element(document.getElementsByClassName('months'+key)).siblings().slideToggle();
	        	angular.element(document.getElementsByClassName('months'+key)).addClass("accordian-title-minus");
	            // angular.element(document.getElementsByClassName('months'+key)).parent().siblings().each(function(index,element){
	            //     angular.element(element).find(".dropdown-container:visible").slideToggle(500);
	            //     // angular.element(element).find('.months'+key).removeClass("accordian-title-minus");
	            // });
        	} else {
        		angular.element(document.getElementsByClassName('weeks'+key)).siblings().slideToggle(1000);
	        	angular.element(document.getElementsByClassName('weeks'+key)).addClass("accordian-title-minus");
	        	angular.element(document.getElementsByClassName('weeks'+key)).toggleClass("open");
	            // angular.element(document.getElementsByClassName('weeks'+key)).parent().siblings().each(function(index,element){
	            //     angular.element(element).find(".dropdown-container1:visible").slideToggle(500);
	            //     angular.element(element).removeClass("open");
	            // });
        	}
        }

        /*
        **  Save the refund reason after refund is completed
        */
        vm.saveRefundReason = function(installmentId, reason, giftcardParams) {
        	if(installmentId != undefined && reason != undefined) {
        		var postData = {
        			installmentId : installmentId,
        			reason : reason
        		}
        		
        		eCommerceService.saveRefundReason(postData).then(function(response){
        			if(response.status != undefined && response.status == "success") {        				
						$mdDialog.hide();
        				Object.keys(vm.installments).forEach(function(key) { 
			    			if(key != 'remaining' && vm.installments[key].installment_id == installmentId){
			    				console.log(vm.installments[key]);
			    				vm.installments[key].reason = reason;
			    			}
			    		});
			    		if(giftcardParams.refund_using != 'giftcard') {
	        				vm.refundEmailPopup(giftcardParams);
	        			}
        			}
        		});

        	}
        }

 		/*
        **  Show send refund email confirmation popup
        */
        vm.refundEmailPopup = function(giftcardParams) {
			$mdDialog.show({
				clickOutsideToClose	: false,
				parent             	: angular.element($document.body),
				scope				: $scope,
				preserveScope		: true,
				locals				: {
										localData :{
											payment_info_email: vm.payment_info_email,
											refunded_amount: giftcardParams.amount
										}
									},
				templateUrl        	: 'app/main/apps/e-commerce/views/orders/dialogs/payments/refundEmail.html',
				controller			: RefundEmailController
			});
			function RefundEmailController($scope, $mdDialog, localData) {
				$scope.payment_info_email = localData.payment_info_email;
				$scope.refund_amount = localData.refunded_amount;
				$scope.closeDialog = function(){
					$mdDialog.hide();
				};
			}
        }
		
		// vm.allowedFiles = ["png", "jpg", "jpeg","heic", "doc", "docx", "pdf", "xls", "xlsx", "txt", "bmp", "rtf", "ott", "odt", "ods","svg"];

		vm.allowedFiles  = "image/*,.doc,.docx,.pdf,.xls,.xlsx,.txt,.bmp,.rtf,.ott,.odt,.ods,.svg";

    	/*
        ** Uses to upload the documents
        */
        vm.uploadDoc = function(files, errFiles) {
        	vm.progressnum = 0;
        	
        	var hotelId = 0;
        	if($localStorage['preHotelId'] != undefined && $localStorage['preHotelId'] != '') {
        		hotelId = $localStorage['preHotelId']        		
        	}

        	if (errFiles.length > 0) {
                angular.forEach(errFiles, function(value, index) {
                    switch (value.$error) {
                        case 'pattern':
                            vm.fileError = 'FILE TYPE NOT SUPPORTED';
                            break;
                        case 'maxSize':
                            vm.fileError = 'FILE SIZE EXCEEDS';
                            break;
                        case 'minWidth':
                            vm.fileError = 'MIN SIZE MESSAGE';
                            break;
                        case 'minHeight':
                            vm.fileError = 'MIN SIZE MESSAGE';
                            break;
                        default:
                            vm.fileError = 'COMMON IMAGE MESSAGE';
                    }
                    toastMessage.showSimpleToast(vm.fileError, 'error-toast');
                });
            }

        	if (files.length > 0) {        	
	        	files.upload = Upload.upload({
	                url: EnvironmentConfig.api + 'reservations/upload_document',
	                data: {
	                    file: files[0],
	                    data: {
	                    	confirmation_number : vm.order.confirmation_number,
	                    	hotel_id : hotelId,
	                    	type : 'update'
	                    }
	                },
	                uploadEventHandlers: { progress: function(evt){
	                	// console.log("event : ", evt);
	                    if (evt.lengthComputable) {
	                        vm.progressnum = Math.round(evt.loaded * 100 / evt.total)
	                    } else {
	                        vm.progressnum = 'unable to compute'
	                    }
	                    // console.log("progressnum : ",vm.progressnum);
	                    if(vm.progressnum >= 100){
	                        // vm.progress = false;
	                        // $timeout(function() {
	                        //     vm.processing = true;
	                        // },100);
	                    }
	                }}
	            });

	            files.upload.then(function(response) {
	            	console.log("Then response : ",response);
	            	if(response.data.status == 'success') {
	            		var docData = {
	            			'doc_name' : response.data.data.fileName,
	            			'id' : response.data.data.last_id,
	            			'type' : response.data.data.type
	            		}
		            	vm.documents.push(docData);	            		
	            		vm.emptyDocs = (vm.documents.length > 0) ? false : true;
	            	}
	            });
	        }
    	}

		/*
        ** Fetch the attached documents
        */
    	vm.fetchDocs = function(confirmationNumber) {
    		console.log(confirmationNumber);
        	var hotelId = 0;
    		if($localStorage['preHotelId'] != undefined && $localStorage['preHotelId'] != '') {
        		hotelId = $localStorage['preHotelId']        		
        	}
    		var postData = {
    			confirmationNumber : confirmationNumber,
    			hotelId : hotelId
    		}

    		eCommerceService.fetchAttachmentDocs(postData).then(function(response){
    			console.log(response);
    			if(response.status == 'success' && Object.keys(response.documents).length > 0) {
    				vm.documents = response.documents;
    				vm.emptyDocs = false;
    			} else {
    				vm.emptyDocs = true;
    			}
    		});
    	}

    	/*
    	** Delete attachment documents
    	*/
    	vm.deleteDocument = function(docData, index, evt) {
            var confirm = $mdDialog.confirm()
                .htmlContent('<div class="md-padding custom-common-dailog">Are you sure, you want to delete this attachment?</div>')
                .title('Delete Attachment')
                .targetEvent(evt)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function() {                
            	docData.src = 'update';
                eCommerceService.deleteDoc(docData).then(function(response) {
                    if (response.status === 'success') {
                        vm.documents.splice(index,1);
	            		vm.emptyDocs = (vm.documents.length > 0) ? false : true;
                    } else {
                        toastMessage.showSimpleToast($translate.instant(response.message), 'error-toast');
                    }
                });
            }).catch(function(err) {            	
            });
        };

        /*
        ** Open attachments images and pdfs in popup
        */
        vm.documentViewer = function(ev, docName, type) {
            var documentData;
            if(type != undefined && type == 'image'){
				documentData = EnvironmentConfig.api + 'assets/uploads/documents/' + docName;
            } else {
            	if(docName.indexOf('.pdf') > -1) {
            		documentData = {
            			path : EnvironmentConfig.api + 'assets/uploads/documents/' + docName,
            			type : "pdf"
            		}
            	} else {
					documentData = EnvironmentConfig.api + 'assets/uploads/documents/' + docName;
            		window.open(documentData,'_self');
            		return false;
            	}
            }
            $mdDialog.show({
                controller: 'RoomtypeDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/e-commerce/views/roomtype/dialogs/roomtype/roomtype-dialog.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Image: documentData
                }
            });
        }


        /* Card Swiper code starts */
        function trimNumber(s) {
            while (s.substr(0, 1) == '0' && s.length > 1) {
                s = s.substr(1, 9999);
            }
            return s;
        }

        function parseSwiperData(value) {
            if (value.charAt(0) !== '%') {
                return -1;
            }
            var p = new SwipeParserObj(value);
            var result = new Array();
            if (p.hasTrack1) {
                if (p.surname != null)
                    result[0] = p.surname + ' ' + p.firstname;
                else
                    result[0] = p.account_name;
                result[1] = p.account;
                result[2] = p.exp_month;
                result[3] = p.exp_year;
            }
            return result;
        }
        window.parseSwiperData = parseSwiperData;

        var method = 'authorizenet';
        vm.swipeText = 'Click here to swipe';

        vm.swipeNow = function() {
            if (angular.element('#authorizenet-swiper-data')) {
                angular.element('#authorizenet-swiper-data').val(' ');
                angular.element('#authorizenet-swiper-data').select();
            }
        }

        vm.readySwipe = function() {
            vm.swipeText = 'Ready to swipe';
        }

        vm.resetSwipe = function() {
            vm.swipeText = 'Click here to swipe';
        }       

        vm.keyupfunction = function(event) {
            if (event.keyCode == 13) { // was: event.keyCode == 13
                var ccinfo = parseSwiperData(vm.ccinfo_a);
                var errorFound = false;
                if (ccinfo === -1) {} else {
                    if (ccinfo != null && ccinfo.length > 0) {
                        vm.payment_method.cc_fname = '';
                        vm.payment_method.cc_lname = '';
                        vm.payment_method.cc_number = '';
                        vm.payment_method.cc_number_mask = '';
                        vm.payment_method.cc_type = '';
                        vm.payment_method.cc_exp_month = '';
                        vm.payment_method.cc_exp_year = '';
                        
                        var owner = ccinfo[0].trim().replace(/\s\s+/g, ' ');
                        var cc_owner = owner.split(" ");

                        if (cc_owner.length > 1) {
                            vm.payment_method.cc_fname = cc_owner[0];
                            vm.payment_method.cc_lname = cc_owner[cc_owner.length -1];
                        } else {
                            vm.payment_method.cc_fname = cc_owner[0];
                        }
                        if (ccinfo[1] == null) {
                            alert('Card number not detected!');
                            errorFound = true;
                        } else {
                            vm.payment_method.cc_number = ccinfo[1];
                            vm.payment_method.cc_number_mask = ccinfo[1].replace(/.*(\d{4})$/, "xxxxxxxxxxxx$1");
                            var startdigit = parseInt(ccinfo[1].charAt(0));
                            if (startdigit == 3)
                                vm.payment_method.cc_type = 'American Express';
                            if (startdigit == 4)
                                vm.payment_method.cc_type = 'Visa';
                            if (startdigit == 5)
                                vm.payment_method.cc_type = 'MasterCard';
                            if (startdigit == 6)
                                vm.payment_method.cc_type = 'Discover';
                            if (jQuery('select#' + method + '_cc_type').val() == "") {
                                alert('Card type not detected!');
                                errorFound = true;
                            }
                        }
                        if (ccinfo[2] == null) {
                            alert('Expiration month not detected!');
                            errorFound = true;
                        } else {
                            vm.payment_method.cc_exp_month = trimNumber(ccinfo[2]);
                        }
                        if (ccinfo[3] == null) {
                            alert('Expiration year not detected!');
                            errorFound = true;
                        } else {
                            vm.payment_method.cc_exp_year = ccinfo[3];
                            if (jQuery('#' + method + '_expiration_yr').val() == "") {
                                alert("The card might be expired!");
                                errorFound = true;
                            }
                        }
                        
                        $timeout(function() {
                            angular.element('#authorizenet_cc_number_label').trigger('click');
                        }, 0);
                    } else {
                        alert("Cannot read the data!");
                        errorFound = true;
                    }
                    if (!errorFound) {
                        //~ onBlurCheckForm();
                    }
                    vm.ccinfo_a = "";
                    jQuery('#loading-mask').hide();                    
                }
            }
        }
        jQuery(document).on("click", '.payment-methods input[type=radio]', function() {
            vm.swipeNow(jQuery('.payment-methods input[type=radio]:checked').val());
        });
        vm.swipeNow(jQuery('input[name="payment[method]"]:checked').val());
        /* Card Swiper code ends */

        vm.onPaymentMethodSelect = function(method){
        	if(method != undefined && method.toLowerCase() == 'credit card') {
        		setTimeout(function(){
        			vm.swipeNow();
					vm.readySwipe();
				},100);
        	}
        }

        setTimeout(function() {
           vm.autoFillOff = false;
       	}, 1500); 

    }
})();

(function() {
    'use strict';

    angular.module('app.e-commerce')
        .controller('rooomMoveController', rooomMoveController);

    /** @ngInject */
    function rooomMoveController(
        EnvironmentConfig,
        $mdDialog,
        toastMessage,
        $translate,
        checkin,
        checkout,
        adult,
        child,
        $document,
        $scope,
        room_stay_id,
        product_id,
        product_name,
        reservation_id,
        policy_id,
        confirmation_number,
        tax_exempt_indicator,
        customerTaxExempt,
        travellerTaxExempt,
        itinerary_number,
        eCommerceService,
        $rootScope,
        createResService,
        $state,
        $timeout,
        reservation_type,
        $stateParams,
        moveType,
        negotiatedCust,
        selectedRatePlanId,
        siteminderId) {
        var vm = this;
        // Data

        vm.oldRoomMoveData = [];
        vm.reservation_type = reservation_type;
        vm.isDayReservation = (reservation_type === 'day_reservation');
        vm.pageType = moveType != undefined ? moveType : 'split';
        if(reservation_type == 'boat'){
            vm.page = 'boat';
        	vm.pagetitle = 'Slips';
        }
        else{
            vm.page = 'room';
        	vm.pagetitle = 'room';
        }

        var OrgCheckIn = angular.copy(checkin);
        var OrgCheckout = angular.copy(checkout);
        
        checkin = moment(checkin);
        vm.original_room_stay_from = angular.copy(checkin);
        vm.original_room_stay_to = angular.copy(checkout);
        
        vm.checkin = new Date(checkin.format('YYYY'), checkin.format('MM') - 1, checkin.format('DD'));
        vm.myDate = new Date();
        vm.mindate = new Date(
            vm.myDate.getFullYear(),
            vm.myDate.getMonth(),
            vm.myDate.getDate()
        );
        vm.minCheckInDate = new Date(OrgCheckIn);
        vm.minCheckOutDate = new Date(OrgCheckIn);
        if(!vm.isDayReservation){
            vm.minCheckOutDate.setDate(vm.minCheckOutDate.getDate() + 1);
        }
        var dateForNewDate = moment(checkin, 'YYYY/MM/DD').add(vm.isDayReservation ? 0 : 1, 'days');
        var day = dateForNewDate.format('DD');
        var month = dateForNewDate.format('MM');
        var year = dateForNewDate.format('YYYY');
        vm.mindateforcheckout = vm.isDayReservation ? null : new Date(year, month - 1, day);
        vm.minDateCheckout = vm.mindateforcheckout;
        vm.checkout = new Date(moment(checkout).format());
        if(vm.isDayReservation){
            vm.checkout = angular.copy(vm.checkin);
        }
        vm.maxdateforcheckin = '';
        vm.maxdateforcheckout = '';
        vm.adult = adult;
        vm.child = child;

        vm.room_stay_id = room_stay_id;
        vm.product_id = product_id;
        vm.product_name = product_name;
        vm.reservation_id = reservation_id;
        vm.confirmation_number = confirmation_number;
        vm.show_rooms = false;
        vm.selectedRoom = "";
        vm.available_rooms = {};
        vm.isloading = false;
        vm.baseUrl = EnvironmentConfig.api;
        //Methods
        vm.checkoutModified = checkoutModified;
        vm.checkinModified = checkinModified;
        vm.getAvailableRooms = getAvailableRooms;
        vm.roomMoveFinally1 = roomMoveFinally1;
        vm.roomMoveFinally = roomMoveFinally;
        vm.closeDialog = closeDialog;
        vm.readDescription = readDescription;
        vm.show_continue = true;
        vm.readText = 'Readmore...';
        vm.description = false;


        vm.oldRoomMoveData = {
            'old_product_id': vm.product_id,
            'confirmation_number': vm.confirmation_number,
        };

        function checkinModified() {
            if(vm.isDayReservation){
                vm.minDateCheckout = null;
                vm.mindateforcheckout = null;
                vm.minCheckOutDate = angular.copy(vm.checkin);
                vm.checkout = angular.copy(vm.checkin);
                return;
            }
            var dateForNewDate = moment(vm.original_room_stay_from, 'YYYY/MM/DD').add(1, 'days');
            var day = dateForNewDate.format('DD');
            var month = dateForNewDate.format('MM');
            var year = dateForNewDate.format('YYYY');
            vm.mindateforcheckout = new Date(year, month - 1, day);
            // vm.mindateforcheckout = new Date(moment(, "DD-MM-YYYY").add(1, 'days'));
            var endDate = moment(vm.checkout);
            var startDate = moment(vm.checkin);
            if (endDate.isBefore(startDate) || endDate.isSame(startDate)) {
                var dateForNewDate = moment(moment(vm.checkin), 'YYYY/MM/DD').add(1, 'days');
                var day = dateForNewDate.format('DD');
                var month = dateForNewDate.format('MM');
                var year = dateForNewDate.format('YYYY');
                vm.checkout = new Date(year, month - 1, day);
                vm.mindateforcheckout = new Date(year, month - 1, day);
                // vm.checkout = new Date(moment(vm.checkin, "DD-MM-YYYY").add(1, 'days'));
            }
            if (moment(vm.checkin).isBefore(moment(vm.original_room_stay_from))) {
                // var dateForNewDate = moment(vm.original_room_stay_from, 'YYYY/MM/DD').subtract(1, 'days');
                var dateForNewDate = moment(vm.original_room_stay_from, 'YYYY/MM/DD');
                var day = dateForNewDate.format('DD');
                var month = dateForNewDate.format('MM');
                var year = dateForNewDate.format('YYYY');
                vm.maxdateforcheckout = new Date(year, month - 1, day);
                // vm.maxdateforcheckout = new Date(moment(vm.original_room_stay_to, "DD-MM-YYYY").subtract(1, 'days'));
                vm.checkout = new Date(year, month - 1, day);

                var dateForNewDate = moment(moment(vm.checkin), 'YYYY/MM/DD').add(1, 'days');
                var day = dateForNewDate.format('DD');
                var month = dateForNewDate.format('MM');
                var year = dateForNewDate.format('YYYY');
                vm.mindateforcheckout = new Date(year, month - 1, day);
                // vm.mindateforcheckout = new Date(moment(vm.checkin, "DD-MM-YYYY").add(1, 'days'));
            } else {
                vm.maxdateforcheckout = '';
            }
            vm.minCheckOutDate.setDate(vm.checkin.getDate() + 1);
        }

        function checkoutModified() {
            if (moment(vm.checkin).isBefore(moment(vm.original_room_stay_from)) && moment(vm.checkout).isAfter(moment(vm.original_room_stay_to))) {
                vm.mindate = new Date(moment(vm.original_room_stay_from, "DD-MM-YYYY").add(1, 'days'));
                vm.maxdateforcheckin = new Date(moment(vm.original_room_stay_to, "DD-MM-YYYY").add(1, 'days'));
                vm.checkin = new Date(moment(vm.original_room_stay_from, "DD-MM-YYYY").add(1, 'days'));
            }

        }
        vm.dateError = false;        
        vm.extraPersonApplicable = false;
        vm.resortFeeApplicable = false;
        function getAvailableRooms() {
            vm.dateError = false;        
            if(vm.checkin !== '' && vm.checkout !== ''){
                vm.checkin = moment(vm.checkin).format('MM/DD/YYYY');
                vm.checkout = moment(vm.checkout).format('MM/DD/YYYY');
                var OrgtimeIn = moment(OrgCheckIn).format('X');
                var OrgTimeOut = moment(OrgCheckout).format('X');
                var CurTimeIn = moment(vm.checkin).format('X');
                var CurTimeOut = moment(vm.checkout).format('X');
                var startDateRangeCheck = true;
                var endDateRangeCheck = true;
                vm.show_rooms = false;
                vm.selectedRoom = "";
                vm.available_rooms = {};
                if(CurTimeOut < OrgtimeIn && CurTimeIn < OrgtimeIn && startDateRangeCheck){
                    vm.dateError = true;
                    vm.dateErrorMsg = 'Your end date should be within reservation date range.';
                }else if(CurTimeIn > OrgTimeOut && CurTimeOut > OrgTimeOut && endDateRangeCheck){
                    vm.dateError = true;
                    vm.dateErrorMsg = 'Your start date should be within reservation date range.';
                }else{
                    var productIdsInCart = [product_id];
                    // vm.checkin = moment(vm.checkin).format('MM/DD/YYYY');
                    // vm.checkout = moment(vm.checkout).format('MM/DD/YYYY');
                    var availRequest = {
                        new_checkin: vm.checkin,
                        new_checkout: vm.checkout,
                        new_adult: vm.adult,
                        new_child: vm.child,
                        policy_id: policy_id,
                        requestFor:vm.page,
                        ratePlanId: selectedRatePlanId,
                        negotiatedCustId: negotiatedCust
                    };
                    if(vm.isDayReservation){
                        availRequest.cart_type = 'day_reservation';
                        availRequest.type_of_reservation = 'day_reservation';
                        availRequest.new_checkout = availRequest.new_checkin;
                    }
                    createResService.getAvailableRooms(availRequest).then(function(response) {
                        if (response.success) {
                            vm.show_rooms = true;
                            vm.original_room_stay_from = angular.copy(vm.checkin);
                            vm.original_room_stay_to = angular.copy(vm.checkout);
                            vm.available_rooms = response.available_rooms;
                            vm.extraPersonApplicable = response.extraPersonApplicable;
                            vm.resortFeeApplicable = response.resortFeeApplicable;
                        } else if (response.errorMsg != 'undefined') {
                            vm.show_rooms = false;
                            toastMessage.showSimpleToast(response.errorMsg, 'error- toast');
                        } else {
                            vm.show_rooms = false;
                            toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'), 'error-toast');
                        }
                    });
                }
            }            
        }

        function roomMoveFinally() {
            var product = {};
            product[vm.available_rooms[vm.selectedRoom]['product_id']] = policy_id;
            var product_id = vm.available_rooms[vm.selectedRoom].product_id;
            var product_name = vm.available_rooms[vm.selectedRoom].product_name;
            vm.checkin = moment(vm.original_room_stay_from).format('MM/DD/YYYY');
            vm.checkout = moment(vm.original_room_stay_to).format('MM/DD/YYYY');

            // Room move data
            vm.oldRoomMoveData.new_product_id = vm.available_rooms[vm.selectedRoom].product_id;
            vm.oldRoomMoveData.new_room_stay_from = vm.checkin;

            var roomData = {
                fields                : 'total_remaining_amount,fe_display_product_name, room_stay_from, room_stay_to, total_paid_amount, total_amount, product_id, policy_id, product_name',
                prod_id               : product,
                adult                 : 2,
                child                 : 0,
                from                  : vm.checkin,
                to                    : vm.checkout,

                new_checkin           : vm.checkin,
                new_checkout          : vm.checkout,
                policy_id: policy_id,
                product_id: product_id,
                product_name: product_name,
                reservation_id: reservation_id,
                confirmation_number: vm.confirmation_number,
                itinerary_number: itinerary_number,
                keepSameRates: vm.keepSameRates,
                negotiatedCustId: negotiatedCust,
                selectedRatePlanId: selectedRatePlanId,
                adjustPayment: true
            };

            eCommerceService.checkRoomAmounts(roomData).then(function(response){
                if (response.success && response.data.isAmountTransferable) {
                    var roomDataTransferTo = response['data']['product_data'];
                    var roomDataTransferFrom = {
                        // fe_display_product_name     : response['data']['fe_display_product_name'],
                        fe_display_product_name     : response['data']['product_name'],
                        room_stay_from              : response['data']['room_stay_from'],
                        room_stay_to                : response['data']['room_stay_to'],
                        total_remaining_amount      : response['data']['total_remaining_amount'],
                        total_paid_amount           : response['data']['total_paid_amount'],
                        confirmation_number         : vm.confirmation_number
                    };
                    $mdDialog.show({
                        controller: 'amountTransfer',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/apps/e-commerce/views/orders/dialogs/transfer/transfer.html',
                        parent: angular.element(document.body),
                        targetEvent: event,
                        clickOutsideToClose:false ,
                        locals: {
                            roomDataTransferTo: roomDataTransferTo,
                            roomDataTransferFrom:roomDataTransferFrom
                        }                
                    })
                    .then(function(answer) {
                        if(typeof answer != 'undefined' && answer == 'ok'){
                           vm.adjustRoomPayment = true;
                           roomMoveFinally1();
                        }else if(typeof answer != 'undefined' && answer == 'no'){
                           vm.adjustRoomPayment = false;
                           roomMoveFinally1();
                        }
                    }, function() {});
                } else {
                    /*Control measures*/
                    vm.adjustRoomPayment = false;
                    roomMoveFinally1();
                }   
            });
        }

        function roomMoveFinally1() {
            if (vm.checkin !== '' && vm.checkout !== '' && vm.selectedRoom !== '') {
                vm.isloading = true;

                /*Get the confirmation for amount to be split among rooms*/

                vm.show_continue = false;
                var product_id = vm.available_rooms[vm.selectedRoom].product_id;
                var product_name = vm.available_rooms[vm.selectedRoom].product_name;
                vm.checkin = moment(vm.original_room_stay_from).format('MM/DD/YYYY');
                vm.checkout = moment(vm.original_room_stay_to).format('MM/DD/YYYY');
                //~ vm.checkin = vm.original_room_stay_from;
                //~ vm.checkout = vm.original_room_stay_to;
                eCommerceService.roomMove({
                    new_checkin: vm.checkin,
                    new_checkout: vm.checkout,
                    policy_id: policy_id,
                    product_id: product_id,
                    product_name: product_name,
                    reservation_id: reservation_id,
                    confirmation_number: vm.confirmation_number,
                    itinerary_number: itinerary_number,
                    keepSameRates: vm.keepSameRates,
                    adjustPayment: vm.adjustRoomPayment !== undefined ? vm.adjustRoomPayment : false,
                    oldData: vm.oldRoomMoveData,
                    negotiatedCustId: negotiatedCust,
                    selectedRatePlanId: selectedRatePlanId
                }).then(function(response) {
                    vm.show_continue = true;
                    vm.isloading = false;
                    if (response.success) {
                        $state.go($state.current, {
                            id: reservation_id,
                            confirmation_number: vm.confirmation_number
                        }, {
                            reload: true
                        });
                        //~ $state.reload("app.e-commerce.orders.detail",);
                        closeDialog();
                    } else if (response.errorMsg != 'undefined') {
                        toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                    } else {
                        toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'), 'error-toast');
                    }
                });
            }
        }

        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        function readDescription() {
            if (vm.readText == 'Readmore...') {
                vm.readText = 'Readless...';
                vm.description = true;
            } else {
                vm.readText = 'Readmore...';
                vm.description = false;
            }

        }

        /*Code For Room Change In Split */

        vm.show_rooms_for_room_move = false;
        vm.available_rooms_for_room_move = {};

        vm.changeTab = changeTab;
        function changeTab(pageType){
            vm.pageType = pageType;

            $timeout(function(){
                vm.show_rooms_for_room_move = false;
                vm.available_rooms_for_room_move = {};
                vm.show_rooms = false;
                vm.selectedRoom = "";
                vm.available_rooms = {};
            }, 1500);
        }

        vm.changeDatesForRes = changeDatesForRes;

        function changeDatesForRes(){
            vm.isloading = true;
            if(vm.isDayReservation){
                vm.checkout = angular.copy(vm.checkin);
            }
            vm.checkin = moment(vm.checkin).format("MM/DD/YYYY");
            vm.checkout = moment(vm.checkout).format("MM/DD/YYYY");

            var data = {
                room_stay_from          : vm.checkin,
                room_stay_to            : vm.checkout,
                adult                   : adult,
                child                   : child,
                product_id              : product_id,
                product_name            : product_name,
                confirmation_number     : confirmation_number,
                id                      : reservation_id,
                policy_id               : policy_id,
                keepSameRates           : vm.keepSameRates,
                order_history_comment   : 'DATES',
                location                : 'view_order',
                changed_type            : 'Dates',
                requestFor              : vm.page,
                tax_exempt_indicator    : tax_exempt_indicator,
                customerTaxExempt       : customerTaxExempt,
                travellerTaxExempt      : travellerTaxExempt,
                original_room_stay_from : checkin,
                original_room_stay_to   : checkout,
                roomChange              : true,
                negotiatedCustId        : negotiatedCust,
                selectedRatePlanId      : selectedRatePlanId,
                siteminderId      		: siteminderId
            };
            if(vm.isDayReservation){
                data.type_of_reservation = 'day_reservation';
                data.cart_type = 'day_reservation';
                data.room_stay_to = data.room_stay_from;
            }

            var submitMoveDates = function(ignoreEarlyLate){
                if(ignoreEarlyLate){
                    data.ignore_early_late = true;
                }
                vm.isloading = true;
                eCommerceService.changeDatesForRes(data)
                .then(function(response) {
                    vm.isloading = false;
                    if(response.success && !response.availablity_error){
                        $rootScope.$broadcast('update_order_data',{reservations:response.order_info.reservations[0]});
                        closeDialog();
                    } else if(response.availablity_error){
                        vm.available_rooms_for_room_move = response.available_rooms;
                        vm.extraPersonApplicable = response.extraPersonApplicable;
                        vm.resortFeeApplicable = response.resortFeeApplicable;
                        vm.show_rooms_for_room_move = true;
                    } else if(response.canOverride && (response.errorTitle === 'Late checkout' || response.errorTitle === 'Early check-in')){
                        $mdDialog.show({
                            controller: 'confirmController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            locals: {
                                title: response.errorTitle || 'Confirm',
                                htmlContent: response.errorMsg || 'Are you sure you want to create a day reservation on this room?',
                                cancelBtn: 'Cancel',
                                OkBtn: 'Yes, Continue'
                            }
                        }).then(function(answer) {
                            if (typeof answer != 'undefined' && answer == 'update') {
                                submitMoveDates(true);
                            }
                        });
                    } else {
                        toastMessage.showSimpleToast(response.errorMsg,'error-toast', false, response.errorTitle || null);
                    }
                });
            };
            submitMoveDates(false);
        }

        vm.changeRoomForRes = changeRoomForRes;
        function changeRoomForRes(){
            vm.isloading = true;
            var product_id = vm.available_rooms_for_room_move[vm.selectedRoom].product_id;
            var product_name = vm.available_rooms_for_room_move[vm.selectedRoom].product_name;
            if(vm.isDayReservation){
                vm.checkout = angular.copy(vm.checkin);
            }
            vm.checkin = moment(vm.checkin).format("MM/DD/YYYY");
            vm.checkout = moment(vm.checkout).format("MM/DD/YYYY");

            // Room move data
            vm.oldRoomMoveData.new_product_id = vm.available_rooms_for_room_move[vm.selectedRoom].product_id;
            vm.oldRoomMoveData.new_room_stay_from = vm.checkin;
            var isDatesChanged = (vm.checkin != moment(checkin).format("MM/DD/YYYY")) || (vm.checkout != moment(checkout).format("MM/DD/YYYY"));
            
            var changed_type = 'Room';
            var order_history_comment = 'ROOM';
            if (isDatesChanged) {
                changed_type = 'Room & Dates';
                order_history_comment = 'DATES_&_ROOM_AVAILABILITY_ERROR';
            }

            var data = {
                room_stay_from          :vm.checkin,
                room_stay_to            :vm.checkout,
                adult                   :adult,
                child                   :child,
                product_id              :product_id,
                product_name            :product_name,
                confirmation_number     :confirmation_number,
                id                      :reservation_id,
                policy_id               :policy_id,
                keepSameRates           :vm.keepSameRates,
                order_history_comment   :order_history_comment,
                'location'              :'view_order',
                'changed_type'          :changed_type,
                requestFor              :vm.requestFor,
                'oldData'               :vm.oldRoomMoveData,
                tax_exempt_indicator    : tax_exempt_indicator,
                customerTaxExempt       : customerTaxExempt,
                travellerTaxExempt      : travellerTaxExempt,
                negotiatedCustId        : negotiatedCust,
                selectedRatePlanId      : selectedRatePlanId
            };
            if(vm.isDayReservation){
                data.type_of_reservation = 'day_reservation';
                data.cart_type = 'day_reservation';
                data.room_stay_to = data.room_stay_from;
            }
    
            var submitRoomPick = function(ignoreEarlyLate){
                if(ignoreEarlyLate){
                    data.ignore_early_late = true;
                }
                vm.isloading = true;
                eCommerceService.changeDatesForRes(data)
                .then(function(response) {
                    vm.isloading = false;
                    if (response.success && response.roomMerged != undefined && response.roomMerged != '') {
                        $stateParams.confirmation_number = response.roomMerged;
                        $state.transitionTo($state.current, $stateParams, {
                            reload: true,
                            inherit: false,
                            notify: true
                        });
                    } else if(response.success && !response.availablity_error){
                        $rootScope.$broadcast('update_order_data',{reservations:response.order_info.reservations[0]});
                        closeDialog();
                    } else if(response.availablity_error){
                        vm.available_rooms = response.available_rooms;
                        vm.show_rooms = true;
                    } else if(response.canOverride && (response.errorTitle === 'Late checkout' || response.errorTitle === 'Early check-in')){
                        $mdDialog.show({
                            controller: 'confirmController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                            parent: angular.element(document.body),
                            clickOutsideToClose: true,
                            locals: {
                                title: response.errorTitle || 'Confirm',
                                htmlContent: response.errorMsg || 'Are you sure you want to create a day reservation on this room?',
                                cancelBtn: 'Cancel',
                                OkBtn: 'Yes, Continue'
                            }
                        }).then(function(answer) {
                            if (typeof answer != 'undefined' && answer == 'update') {
                                submitRoomPick(true);
                            }
                        });
                    } else {
                        toastMessage.showSimpleToast(response.errorMsg,'error-toast', false, response.errorTitle || null);
                    }
                });
            };
            submitRoomPick(false);
        }


         //Code     to conditionaly run click event
        vm.runClickEvent = false;
        if($( window ).width() <= 1020){
            vm.runClickEvent = true;
        };


        vm.showBlock = [];
        vm.showRateDesc = [];
        vm.showOverlay = false;
        // function to close all details popup
        vm.closeAllDetails = function(){
            angular.forEach(vm.showBlock,function(rval,rkey){
                angular.forEach(rval,function(pval,pkey){
                    vm.showBlock[rkey][pkey] = false;
                    vm.showOverlay = false;
                });
            });
        }

        // function to show hide detail popup
        vm.showDetailBlock = function(roomkey,policyKey){
            angular.forEach(vm.showBlock,function(rval,rkey){
                angular.forEach(rval,function(pval,pkey){
                    if(rkey == roomkey && pkey == policyKey){
                        vm.showBlock[rkey][pkey] = !vm.showBlock[rkey][pkey];
                        if(vm.showBlock[rkey][pkey]){
                            vm.showOverlay = true;
                        } else {
                            vm.showOverlay = false;
                        }
                    } else {
                        vm.showBlock[rkey][pkey] = false;
                    }
                });
            });
        }

        vm.closeAllRateDetails = function(){
            angular.forEach(vm.showRateDesc,function(rval,rkey){
                angular.forEach(rval,function(pval,pkey){
                    vm.showRateDesc[rkey][pkey] = false;
                    vm.showOverlay = false;
                });
            });
        }

        // function to show hide detail popup
        vm.showDetailRateBlock = function(roomkey,policyKey){
            angular.forEach(vm.showRateDesc,function(rval,rkey){
                angular.forEach(rval,function(pval,pkey){
                    if(rkey == roomkey && pkey == policyKey){
                        vm.showRateDesc[rkey][pkey] = !vm.showRateDesc[rkey][pkey];
                        if(vm.showRateDesc[rkey][pkey]){
                            vm.showOverlay = true;
                        } else {
                            vm.showOverlay = false;
                        }
                    } else {
                        vm.showRateDesc[rkey][pkey] = false;
                    }
                });
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts',
            [
                // 3rd Party Dependencies
                'xeditable',
                'ngMaterial'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.contacts', {
            url    : '/customers/',
            title  : 'Customers',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/contacts/contacts.html',
                    controller : 'ContactsController as vm'
                }
            },
            resolve: {
                customerList: function (){
                    return [];
                }
            },
            permission: 'customers',
        }).state('app.customer_add', {
            url    : '/customer/add',
            title  : 'Customers',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/contacts/contact/contact.html',
                    controller : 'ContactController as vm'
                }
			},
			resolve: {
                Contact: function (userService) {
                    return [];
                },
                Country:function (userService){
                    return userService.getCountries();
                }
            },
            permission: 'add_customer',
        }).state('app.customer_update', {
			cache: false,
            title  : 'Customers',
            url: "/customer/:customer_id?from",
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/contacts/contact/contact.html',
                    controller : 'ContactController as vm'
                }
            },
            resolve: {
                Contact: function (userService,$stateParams){
                    var data = {customer_id: $stateParams.customer_id};
					return userService.getSingleEdit(data);
                },
                Country:function (userService){
                         return userService.getCountries();
                    }
            },
            permission: 'update_customer'
        }).state('app.negotiatedCustomers', {
            url    : '/negotiatedCustomers/',
            title  : 'Negotiated Customers',
            params : {type: 'negotiated'},
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/contacts/contacts.html',
                    controller : 'ContactsController as vm'
                }
            },
            resolve: {
                customerList: function (){
                    return [];
                }
            },
            permission: 'customers',
        }).state('app.nego_customer_add', {
            url    : '/negotiatedCustomer/add',
            title  : 'Add Negotiated Customer',
            params : {type: 'negotiated'},
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/contacts/contact/contact.html',
                    controller : 'ContactController as vm'
                }
            },
            resolve: {
                Contact: function (userService) {
                    return userService.getNegotiatedCustomers();
                },
                Country:function (userService){
                    return userService.getCountries();
                }
            },
            permission: 'add_customer',
        }).state('app.nego_customer_update', {
            cache: false,
            title  : 'Edit Negotiated Customers',
            url    : '/negotiatedCustomer/:customer_id',
            params : {type: 'negotiated'},
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/contacts/contact/contact.html',
                    controller : 'ContactController as vm'
                }
            },
            resolve: {
                Contact: function (userService,$stateParams){
                    var data = {customer_id: $stateParams.customer_id, customerType: 'negotiated'};
                    return userService.getSingleEdit(data);
                },
                Country:function (userService){
                    return userService.getCountries();
                }
            },
            permission: 'update_customer'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/contacts');

        // Api
    }

})();

(function ()
{
    'use strict';

    angular.module('app.contacts')
        .controller('amountTransfer', amountTransfer);

    /** @ngInject */
    function amountTransfer(
        $mdDialog, 
        roomDataTransferTo,
        $scope,
        roomDataTransferFrom)
    {
        var vm = this;
        $scope.roomDataTransferTo = roomDataTransferTo;
        $scope.roomDataTransferFrom = roomDataTransferFrom;
        $scope.hasInstallment = false;
        $scope.automaticTransfer = true;

        vm.closeDialog = closeDialog;

        function closeDialog(param){
           $mdDialog.hide(param);
        }

        $scope.closeDialog = function(){
           $mdDialog.hide('close');
        }
        
    }

})();

(function ()
{
    'use strict';
	
    angular.module('app.e-commerce')
        .controller('parkingController', parkingController);

    /** @ngInject */
    function parkingController($mdDialog, toastMessage, $translate, eCommerceService, checkoutService, $rootScope, localData, EnvironmentConfig, commonService)
    {
		var vm = this;
		// Data
		vm.selectedParking = localData.hasOwnProperty('selectedParking')?localData.selectedParking:[];
		vm.checkin = localData.hasOwnProperty('checkin')?localData.checkin:'';
		vm.checkout = localData.hasOwnProperty('checkout')?localData.checkout:'';
		vm.searchType = localData.hasOwnProperty('type')?localData.type:'';
		vm.type_id = localData.hasOwnProperty('type_id')?localData.type_id:'';
		vm.adult = localData.hasOwnProperty('adult')?localData.adult:2;
		vm.child = localData.hasOwnProperty('child')?localData.child:0;
		vm.confirmation_number = localData.hasOwnProperty('confirmation_number')?localData.confirmation_number:'';
		vm.room_confirmation_number = localData.hasOwnProperty('room_confirmation_number')?localData.room_confirmation_number:'';
		vm.product_id = localData.hasOwnProperty('product_id')?localData.product_id:'';
		vm.productIdsInCart = localData.hasOwnProperty('productIdsInCart')?localData.productIdsInCart:[];
		vm.product_name = localData.hasOwnProperty('product_name')?localData.product_name:'';
		vm.reservation_id = localData.hasOwnProperty('reservation_id')?localData.reservation_id:'';
		vm.policy_id = localData.hasOwnProperty('policy_id')?localData.policy_id:'';
		vm.itinerary_number = localData.hasOwnProperty('itinerary_number')?localData.itinerary_number:'';
		vm.parking = localData.hasOwnProperty('parking')?localData.parking:false; /* Add parking in a reservation */
		vm.change_index = localData.hasOwnProperty('change_index')?localData.change_index:''; /* Add parking in create reservation */
		vm.pos_index = localData.hasOwnProperty('pos_index')?localData.pos_index:''; /* Add parking in create reservation */
		vm.one_go_id = localData.hasOwnProperty('one_go_id')?localData.one_go_id:''; /* Edit parking dates from view bar order */
		vm.tax_exempt_indicator = localData.hasOwnProperty('tax_exempt_indicator') ? localData.tax_exempt_indicator:'';
		vm.associatedWithCustTrav = localData.hasOwnProperty('associatedWithCustTrav') ? localData.associatedWithCustTrav: 0;

		vm.create_parking = false;
		if(localData.hasOwnProperty('add_screen') && localData.add_screen == 'create'){
			vm.create_parking = true;/* Add parking in create reservation */
			vm.addParkingView = false;
		} else if(localData.hasOwnProperty('add_screen') && localData.add_screen == 'view') {
			vm.create_parking = false;/* Add parking in create reservation */
			vm.addParkingView = true;
		}
		
		vm.selectedRoom = "";
		vm.selectedRoomAdd = [];

		if(vm.addParkingView || (vm.create_parking && typeof vm.pos_index == 'string'))
			vm.adding = true;
		else
			vm.adding = false;
		if(vm.adding){
			vm.editing = false;
			if(vm.searchType == 'boat'){
				vm.title = "EC.POS_TITLE";
				vm.type = "AVAILABLE_BOATS";
			} else {
				vm.title = "EC.PARKING_TITLE";
				vm.type = "AVAILABLE_PARK";
			}
			
			vm.media_path = '/assets/uploads/activities/thumbnail/';
		}else{
			vm.editing = true;
			vm.no_avail = "EC.NO_P_AVAIL";
			vm.title = "EC.EDIT_P_TITLE";
			vm.media_path = '/assets/uploads/activities/thumbnail/';
		}
		vm.show_rooms = false;
		vm.enableAdd = false;
		vm.baseUrl = EnvironmentConfig.api;
		vm.available_rooms = {};
		vm.isloading = false;
		vm.disable_datepicker = false;
		vm.myDate = new Date();
		vm.minDate = new Date(
			vm.myDate.getFullYear(),
			vm.myDate.getMonth(),
			vm.myDate.getDate()
		);
		vm.minDateCheckout = moment(vm.checkin).add(1, 'days');
		vm.minDateCheckout = new Date(
            vm.minDateCheckout.year(),
            vm.minDateCheckout.month(),
            vm.minDateCheckout.date()
          );

		vm.pos_deposit_type_indicator = '';
		//Methods
		vm.checkinModified = checkinModified;
		vm.changeDatesForRes = changeDatesForRes;
		vm.changeRoomForRes = changeRoomForRes;
		vm.searchParkingProducts = searchParkingProducts;
		vm.saveParkingCreateProducts = saveParkingCreateProducts;
		vm.addParkingProduct = addParkingProduct;
		vm.selectingroom = selectingroom;
		vm.closeDialog = closeDialog;
		
		vm.original_room_stay_from = angular.copy(vm.checkin);
		vm.original_room_stay_to = angular.copy(vm.checkout);
		vm.old_room_stay_from = angular.copy(vm.checkin);
		vm.old_room_stay_to = angular.copy(vm.checkout);
		vm.original_product_name = vm.product_name;
		vm.productIsAvailable = true;
		function selectingroom(){
			vm.enableAdd = false;
			angular.forEach(vm.selectedRoomAdd,function(value, key){
				if(value == true){
					vm.enableAdd = true;
				}
			});
		}
		
		function checkinModified(){
			var startDate = moment(vm.checkin);
			var endDate = moment(vm.checkout);
			vm.minDateCheckout = new Date(moment(startDate, "DD-MM-YYYY").add(1, 'days'));
			if(endDate.isBefore(startDate) || endDate.isSame(startDate)){
				vm.checkout = new Date(moment(startDate, "DD-MM-YYYY").add(2, 'days'));
			}
		}

		function changeRoomForRes(){
			vm.isloading = true;
			var product_id = vm.available_rooms[vm.selectedRoom].product_id;
			var product_name = vm.available_rooms[vm.selectedRoom].product_name;
			vm.checkin = moment(vm.checkin).format("MM/DD/YYYY");
			vm.checkout = moment(vm.checkout).format("MM/DD/YYYY");
			if(localData.hasOwnProperty('FromPage') && localData.FromPage == 'bar-view'){
				var data = {room_stay_from:vm.checkin,room_stay_to:vm.checkout,adult:vm.adult,child:vm.child,product_id:product_id,product_name:product_name,confirmation_number:vm.confirmation_number,id:vm.reservation_id,policy_id:vm.policy_id,keepSameRates:vm.keepSameRates,order_history_comment:'DATES_&_PARKING_AVAILABILITY_ERROR','location':'view_order','changed_type':'Parking & Dates',type:'parking',one_go_id:vm.one_go_id, tax_exempt_indicator: vm.tax_exempt_indicator};
				checkoutService.changeDatesForParking(data)
				.then(function(response) {
					vm.isloading = false;
					if(response.success && !response.availablity_error){
						$rootScope.$broadcast('update_order_data',{order_info:response.response.order_data});
						closeDialog();
					} else if(response.availablity_error){
						vm.available_rooms = response.available_rooms;
						vm.show_rooms = true;
					} else {
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					}
				});
			} else {
				var data = {room_stay_from:vm.checkin,room_stay_to:vm.checkout,adult:vm.adult,child:vm.child,product_id:product_id,product_name:product_name,confirmation_number:vm.confirmation_number,id:vm.reservation_id,policy_id:vm.policy_id,keepSameRates:vm.keepSameRates,order_history_comment:'DATES_&_PARKING_AVAILABILITY_ERROR','location':'view_order','changed_type':'Parking & Dates',type:'parking',room_confirmation_number:vm.room_confirmation_number, original_room_stay_from: vm.old_room_stay_from, original_room_stay_to : vm.old_room_stay_to, original_product_name: vm.original_product_name, tax_exempt_indicator: vm.tax_exempt_indicator};
				eCommerceService.changeDatesForRes(data)
				.then(function(response) {
					vm.isloading = false;
					if(response.success && !response.availablity_error){
						$rootScope.$broadcast('update_order_data',{reservations:response.order_info.reservations[0]});
						//broadcast new data
						closeDialog();
					} else if(response.availablity_error){
						vm.available_rooms = response.available_rooms;
						vm.show_rooms = true;
					} else {
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					}
				});
			}
				
		}

		function changeDatesForRes(){
			vm.isloading = true;
			vm.checkin = moment(vm.checkin).format("MM/DD/YYYY");
			vm.checkout = moment(vm.checkout).format("MM/DD/YYYY");
			if(localData.hasOwnProperty('FromPage') && localData.FromPage == 'bar-view'){
				var data = {room_stay_from:vm.checkin,room_stay_to:vm.checkout,adult:vm.adult,child:vm.child,product_id:vm.product_id,product_name:vm.product_name,confirmation_number:vm.confirmation_number,id:vm.reservation_id,policy_id:vm.policy_id,keepSameRates:vm.keepSameRates,order_history_comment:'DATES','location':'view_order','changed_type':'Dates',type:'parking',one_go_id:vm.one_go_id, tax_exempt_indicator: vm.tax_exempt_indicator};
				checkoutService.changeDatesForParking(data)
				.then(function(response) {
					vm.isloading = false;
					if(response.success && !response.availablity_error){
						$rootScope.$broadcast('update_order_data',{order_info:response.response.order_data});
						closeDialog();
					} else if(response.availablity_error){
						vm.available_rooms = response.available_rooms;
						vm.show_rooms = true;
					} else {
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					}
				});
			} else {
				var data = {room_stay_from:vm.checkin,room_stay_to:vm.checkout,adult:vm.adult,child:vm.child,product_id:vm.product_id,product_name:vm.product_name,confirmation_number:vm.confirmation_number,id:vm.reservation_id,policy_id:vm.policy_id,keepSameRates:vm.keepSameRates,order_history_comment:'DATES','location':'view_order','changed_type':'Dates',type:'parking',room_confirmation_number:vm.room_confirmation_number, original_room_stay_from: vm.old_room_stay_from, original_room_stay_to : vm.old_room_stay_to, tax_exempt_indicator: vm.tax_exempt_indicator};
				eCommerceService.changeDatesForRes(data)
				.then(function(response) {
					vm.isloading = false;
					if(response.success && !response.availablity_error){
						$rootScope.$broadcast('update_order_data',{reservations:response.order_info.reservations[0]});
						//broadcast new data
						closeDialog();
					} else if(response.availablity_error){
						vm.available_rooms = response.available_rooms;
						vm.show_rooms = true;
					} else {
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					}
				});
			}
		}

		// if(dateCheck("02/05/2013","02/09/2013","02/07/2013"))
		// 	    alert("Availed");
		// 	else
		// 	    alert("Not Availed");

		vm.dateCheck = dateCheck;
		function dateCheck(from,to,check) {
		    var fDate,lDate,cDate;
		    fDate = Date.parse(from);
		    lDate = Date.parse(to);
		    cDate = Date.parse(check);
		    if((cDate <= lDate && cDate >= fDate)) {
		        return true;
		    }
		    return false;
		}


		
		function searchParkingProducts(){
			vm.selectedRoomAdd = [];
			vm.enableAdd = false;
			vm.isloading = true;
			vm.checkin = moment(vm.checkin).format("MM/DD/YYYY");
			vm.checkout = moment(vm.checkout).format("MM/DD/YYYY");
			vm.productIsAvailable = false;
			var data = {
				room_stay_from:vm.checkin,
				room_stay_to:vm.checkout,
				productIdsInCart:vm.productIdsInCart,
				searchType: vm.searchType,
				product_id: vm.product_id,
				type_id: vm.type_id,
				createdFrom: 'PMS'
			};
			eCommerceService.searchParking(data).then(function(response) {
				vm.isloading = false;
				if(response.success && response.products.length > 0){
					vm.available_rooms = response.products;
					vm.pos_deposit_type_indicator = response.pos_deposit_type_indicator;
					vm.show_rooms = true;
					vm.original_room_stay_from = angular.copy(vm.checkin);
					vm.original_room_stay_to = angular.copy(vm.checkout);
					vm.selectedRoom = "";
					angular.forEach(vm.available_rooms, function(value, key) {
						if(value.product_id == data.product_id) {
							vm.productIsAvailable = true;
						}
					});
				} else if(response.success) {
					// No parking slots are available
					vm.show_rooms = true;
					vm.available_rooms = [];
					vm.selectedRoom = "";
					vm.original_room_stay_from = angular.copy(vm.checkin);
					vm.original_room_stay_to = angular.copy(vm.checkout);
				} else {
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				}
			});
		}
		
		function saveParkingCreateProducts(){
			vm.isloading = true;
			vm.checkin = moment(vm.checkin).format("MM/DD/YYYY");
			vm.checkout = moment(vm.checkout).format("MM/DD/YYYY");
			var data = {room_stay_from:vm.checkin,room_stay_to:vm.checkout,product_id:vm.product_id};
			eCommerceService.searchParking(data).then(function(response) {
				vm.isloading = false;
				if(response.success && response.products.length > 0 && response.hasOwnProperty('product_available') && response.product_available){
					vm.available_rooms = response.products;
					vm.selectedRoom = 0;
					vm.original_room_stay_from = angular.copy(vm.checkin);
					vm.original_room_stay_to = angular.copy(vm.checkout);
					addParkingProduct();
					closeDialog();
				} else if(response.success && response.products.length > 0){
					vm.available_rooms = response.products;
					vm.pos_deposit_type_indicator = response.pos_deposit_type_indicator;
					vm.show_rooms = true;
					vm.original_room_stay_from = angular.copy(vm.checkin);
					vm.original_room_stay_to = angular.copy(vm.checkout);
					vm.selectedRoom = "";
				} else if(response.success) {
					// No parking slots are available
				} else {
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				}
			});
		}
		
		function addParkingProduct(){
			var cartDetailsForParking = {};
			cartDetailsForParking['payment_method_common'] = 1;
			cartDetailsForParking['product_id'] = 0;
			cartDetailsForParking['normal_occupancy'] = 0;
			cartDetailsForParking['per_night_additional_amount'] = 0;
			cartDetailsForParking['product_name'] = '';
			cartDetailsForParking['room_type_id'] = 0;
			cartDetailsForParking['additional_guest_amounts'] = 0;
			cartDetailsForParking['from'] = '';
			cartDetailsForParking['to'] = '';
			cartDetailsForParking['nights'] = 0;
			cartDetailsForParking['room_stay_guest_count'] = 0;
			cartDetailsForParking['room_stay_child_count'] = 0;
			cartDetailsForParking['discount_percentage'] = 0;
			cartDetailsForParking['taxes'] = null;
			cartDetailsForParking['grand_total'] = 0.00;
			cartDetailsForParking['other_rate_policies'] = null;
			cartDetailsForParking['selelected_policy'] = null;
			cartDetailsForParking['selelected_policy_id'] = 0;
			cartDetailsForParking['nightlySum'] = 0.00;
			cartDetailsForParking['discount_amount'] = 0.00;
			cartDetailsForParking['prices'] = [];
			cartDetailsForParking['room_deposit_type_indicator'] = vm.pos_deposit_type_indicator;
			cartDetailsForParking['room_deposit_percentage'] = 0;
			cartDetailsForParking['room_deposit_amount'] = 0;
			cartDetailsForParking['deposit_amount'] = 0.00;
			cartDetailsForParking['remaining_amount'] = 0.00;
			cartDetailsForParking['original_deposit_amt'] = 0.00;
			
			if(vm.editing){
				vm.selectedRoomAdd = [];
				vm.selectedRoomAdd[vm.selectedRoom] = true;
			}
			
			if (typeof vm.associatedWithCustTrav != 'undefined' && vm.associatedWithCustTrav != 0) {
				cartDetailsForParking.associatedWithCustTrav = vm.associatedWithCustTrav;
			}
			var subtotalTotal = 0,taxAmountTotal = 0,grandTotal = 0;
			var pos = [];	
			angular.forEach(vm.selectedRoomAdd,function(value, key){
				if(value){
					var posData = {};
					posData['product_id'] = vm.available_rooms[key].product_id;
					posData['media'] = vm.available_rooms[key].image;
					posData['product_name'] = vm.available_rooms[key].product_name;
					posData['product_price'] = vm.available_rooms[key].product_price;
					posData['particularCustomPrice'] = vm.available_rooms[key].product_price;
					posData['product_is_timebound'] = vm.available_rooms[key].product_is_timebound;
					posData.taxes = [];
					var taxNotExist = true;
					if (vm.available_rooms[key].taxes !== undefined && vm.available_rooms[key].taxes.length > 0) {
						var taxNotExist = false;
						angular.forEach(vm.available_rooms[key].taxes, function(taxValue, taxkey) {
							var taxData = {
								'tax_id': taxValue['tax_id'],
								'tax_name': taxValue['tax_name'],
								'tax_value': taxValue['tax_value'],
								'orig_tax_value': taxValue['tax_value']
							};
							posData.taxes.push(taxData);
						});
					}
					/*else {
						posData.taxes[0] = [];
						posData.taxes[0]['tax_id'] = 0;
						posData.taxes[0]['tax_name'] = ''
						posData.taxes[0]['tax_value'] = 0;
						posData.taxes[0]['orig_tax_value'] = 0;
						posData.taxes[0]['tax'] = 0;
					}*/
					
					posData['quantity'] = 1;
					posData['product_discount'] = 0;
					posData['discountPer'] = 0;
					posData['from'] = new Date(moment(vm.original_room_stay_from).format('YYYY-MM-DD'));
					posData['to'] = new Date(moment(vm.original_room_stay_to).format('YYYY-MM-DD'));
					posData['prices'] = vm.available_rooms[key].prices;
					posData['fe_display_product_name'] = vm.available_rooms[key].fe_display_product_name;

					/*For Auto Update*/
					posData['pos_auto_sync_dates'] = vm.available_rooms[key].pos_auto_sync_dates;
					/*For Auto Update*/

					/*Start*/
					posData['customDiscount'] = 0;
					posData['customDiscountPercentage'] = 0;
					// posData['customPrice'] = parseFloat(vm.available_rooms[key].product_price);
					posData['customPrice'] = 0.00;
					posData['particularCustomPrice'] = 0.00;

					/* Code for parking rate*/	                    
                    posData['prices']['rates'].forEach(function(p_value, p_index) {
                        posData['customPrice'] += parseFloat(p_value);
						posData['particularCustomPrice'] += parseFloat(p_value);
                    });

					posData['discountAmt'] = 0;
					posData['discountPer'] = "0.00";
					if(vm.searchType == 'boat'){
						posData['cart_type'] = 'boat_service';
						posData['is_parking'] = 0;
					} else {
						posData['product_type'] = 'pos';
						posData['is_parking'] = 1;
					}

					var subtotal = 0,tax_amount = 0,grand_total = 0;					
					subtotal = commonService.roundnum(parseFloat(vm.available_rooms[key].subtotal),2);
					if (!taxNotExist) {
						angular.forEach(posData.taxes, function(taxValue, taxkey) {
							vm.taxAmt = 0;
							vm.taxAmt = commonService.roundnum(parseFloat((parseFloat(subtotal) * parseFloat(taxValue['tax_value']) ) / 100),2);

							vm.taxAmt = vm.tax_exempt_indicator ? 0 : vm.taxAmt;
							posData.taxes[taxkey]['tax'] = vm.taxAmt;
							tax_amount = commonService.roundnum(parseFloat(vm.taxAmt) + parseFloat(tax_amount),2);
						});
					}
					grand_total = commonService.roundnum(parseFloat(subtotal) + parseFloat(tax_amount),2);
					
					subtotalTotal = commonService.roundnum(parseFloat(subtotal) + parseFloat(subtotalTotal),2);
					taxAmountTotal = commonService.roundnum(parseFloat(tax_amount) + parseFloat(taxAmountTotal),2);
					grandTotal = commonService.roundnum(parseFloat(grand_total) + parseFloat(grandTotal),2);
					
					posData['pos_deposit_type_indicator'] = vm.pos_deposit_type_indicator;
					if(vm.pos_deposit_type_indicator != 'full')
						posData['original_deposit_amt'] = commonService.roundnum(grand_total,2);
					else
						posData['original_deposit_amt'] = 0.00;
					if(vm.create_parking && vm.pos_deposit_type_indicator=='full'){
						posData['pos_deposit_amount'] = parseFloat(grand_total);
						posData['remaining_amount'] = 0.00;
					} else {
						posData['pos_deposit_amount'] = 0.00;
						posData['remaining_amount'] = parseFloat(grand_total);
					}
					
					posData['tax'] = tax_amount;
					posData['total'] = grand_total;
					posData['nightlySum'] = subtotal;
					posData['grand_total'] = grand_total;
					posData['original_deposit_amt'] = grand_total;
					posData['is_timebound_with_availability'] = vm.available_rooms[key].is_timebound_with_availability;
					pos.push(posData);
				}
			});

			var overalltotals = {'subtotal':subtotalTotal,'discount':0,'tax':taxAmountTotal,'grand_total':grandTotal,'deposit_amount':0.00,'remaining_amount':grandTotal};
			cartDetailsForParking['overalltotals'] = overalltotals;
			cartDetailsForParking['pos'] = pos;

			if(!vm.create_parking){
				var cartDetails = [];
				cartDetails.push(cartDetailsForParking);
				var data = {'cartDetails':cartDetails,'confirmation_number':vm.confirmation_number,'itinerary_number':vm.itinerary_number};
				vm.isloading = true;
				eCommerceService.addParking(data).then(function(response) {
					vm.isloading = false;
					if(response.success){
						$rootScope.$broadcast('update_order_data',{reservations:response.order_info.reservations[0]});
						//broadcast new data
						closeDialog();
					} else {
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					}
				});
			} else {
				if(typeof vm.pos_index != 'string' && vm.pos_index >= 0){
					$rootScope.$broadcast('update_cart_data',{posData:pos[0],change_index:vm.change_index,pos_index:vm.pos_index});
				}else{
					if(localData.hasOwnProperty('FromPage') && localData.FromPage == 'bar-checkout'){
						$rootScope.$broadcast('addParkingProductToCart',{pos:pos});
					}else{
						$rootScope.$broadcast('update_cart_data',{posData:pos,change_index:vm.change_index});
					}
				}
				// $rootScope.$broadcast('addParkingProductToCart',{pos:pos});
				closeDialog();
			}
		}
 
		/**
		* Close dialog
		*/
		function closeDialog()
		{
		   $mdDialog.hide();
		}
	}
})();

(function ()
{
    'use strict';
	
    angular.module('app.e-commerce')
        .controller('getcsvController', getcsvController);

    /** @ngInject */
    function getcsvController($translate,  $scope, $mdDialog)
    {
		var vm = this;
		vm.getselectedDAteRange = getselectedDAteRange;

		function getselectedDAteRange(){
			 var endDate = new Date(moment(vm.endDate).format('YYYY-MM-DD'));
	         var startDate = new Date(moment(vm.startDate).format('YYYY-MM-DD'));
	         vm.csvName =  'income-reports'+startDate+'-to-'+endDate+'.csv';
	         var data = { 'startDate':startDate,'endDate':endDate };
	         $scope.$parent.downloadCsv(data); 
	         $mdDialog.hide();
		}

	}
})();

(function ()
{
    'use strict';
	
    angular.module('app.e-commerce')
        .controller('editDatesController', editDatesController);

    /** @ngInject */
    function editDatesController(
    	$mdDialog, 
    	toastMessage, 
    	$translate, 
    	eCommerceService, 
    	$rootScope, 
    	localData, 
    	EnvironmentConfig,
    	$stateParams,
    	$state)
    {
		var vm = this;
		// Data
		vm.checkin = localData.hasOwnProperty('checkin')?localData.checkin:'';
		vm.checkout = localData.hasOwnProperty('checkout')?localData.checkout:'';
		vm.adult = localData.hasOwnProperty('adult')?localData.adult:2;
		vm.child = localData.hasOwnProperty('child')?localData.child:0;
		vm.confirmation_number = localData.hasOwnProperty('confirmation_number')?localData.confirmation_number:'';
		vm.product_id = localData.hasOwnProperty('product_id')?localData.product_id:'';
		vm.product_name = localData.hasOwnProperty('product_name')?localData.product_name:'';
		vm.reservation_id = localData.hasOwnProperty('reservation_id')?localData.reservation_id:'';
		vm.policy_id = localData.hasOwnProperty('policy_id')?localData.policy_id:'';
		vm.itinerary_number = localData.hasOwnProperty('itinerary_number')?localData.itinerary_number:'';

		vm.requestFor = localData.hasOwnProperty('requestFor')?localData.requestFor:'';
		vm.type_of_reservation = localData.hasOwnProperty('type_of_reservation') ? localData.type_of_reservation : '';
		vm.isDayReservation = (vm.type_of_reservation === 'day_reservation');
		vm.tax_exempt_indicator = localData.hasOwnProperty('tax_exempt_indicator')?localData.tax_exempt_indicator:false;
		console.log(vm.requestFor);
		vm.customerTaxExempt = localData.hasOwnProperty('customerTaxExempt') ? localData.customerTaxExempt : false;
		vm.travellerTaxExempt = localData.hasOwnProperty('travellerTaxExempt') ? localData.travellerTaxExempt : false;
		vm.negotiatedCustId = localData.hasOwnProperty('negotiatedCust') ? localData.negotiatedCust : 0;
		vm.selectedRatePlanId = localData.hasOwnProperty('selectedRatePlanId') ? localData.selectedRatePlanId : 0;
		vm.show_rooms = false;
		vm.baseUrl = EnvironmentConfig.api;
		vm.selectedRoom = "";
		vm.available_rooms = {};
		vm.isloading = false;
		vm.disable_datepicker = false;
		vm.minDateCheckout = vm.isDayReservation
			? null
			: new Date(moment(vm.checkin, "MM/DD/YYYY").add(1, 'days'));
		vm.pos_deposit_type_indicator = '';
		//Methods
		vm.checkinModified = checkinModified;
		vm.changeDatesForRes = changeDatesForRes;
		vm.changeRoomForRes = changeRoomForRes;
		vm.closeDialog = closeDialog;
		
		vm.original_room_stay_from = angular.copy(vm.checkin);
		vm.original_room_stay_to = angular.copy(vm.checkout);
		if(vm.isDayReservation){
			vm.checkout = angular.copy(vm.checkin);
			vm.original_room_stay_to = angular.copy(vm.checkin);
		}


		function checkinModified(){
			if(vm.isDayReservation){
				vm.minDateCheckout = null;
				vm.checkout = angular.copy(vm.checkin);
				return;
			}
			vm.minDateCheckout = new Date(moment(vm.checkin, "MM/DD/YYYY").add(1, 'days'));
			var endDate = moment(vm.checkout);
			var startDate = moment(vm.checkin);
			if(endDate.isBefore(startDate) || endDate.isSame(startDate)){
				vm.checkout = new Date(moment(startDate, "MM/DD/YYYY").add(2, 'days'));
			}
		}

		function applyDayReservationFlags(data){
			if(vm.isDayReservation){
				data.type_of_reservation = 'day_reservation';
				data.cart_type = 'day_reservation';
				data.room_stay_to = data.room_stay_from;
			}
			return data;
		}

		/** Tape Chart parity: Late checkout / Early check-in → Yes/Cancel, then retry with ignore_early_late */
		function handleDayEarlyLateOverride(response, retryFn){
			if(!(response && response.canOverride && (response.errorTitle === 'Late checkout' || response.errorTitle === 'Early check-in'))){
				return false;
			}
			$mdDialog.show({
				controller: 'confirmController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
				parent: angular.element(document.body),
				clickOutsideToClose: true,
				locals: {
					title: response.errorTitle || 'Confirm',
					htmlContent: response.errorMsg || 'Are you sure you want to create a day reservation on this room?',
					cancelBtn: 'Cancel',
					OkBtn: 'Yes, Continue'
				}
			}).then(function(answer) {
				if (typeof answer != 'undefined' && answer == 'update') {
					retryFn();
				}
			});
			return true;
		}

		function handleChangeDatesResponse(response, retryFn){
			vm.isloading = false;
			if (response.success && response.roomMerged != undefined && response.roomMerged != '') {
				reloadState(response.roomMerged);
			} else if(response.success && !response.availablity_error){
				$rootScope.$broadcast('update_order_data',{reservations:response.order_info.reservations[0]});
				closeDialog();
			} else if(response.availablity_error){
				vm.available_rooms = response.available_rooms;
				vm.extraPersonApplicable = response.extraPersonApplicable !== undefined ? response.extraPersonApplicable : false;
				vm.resortFeeApplicable = response.resortFeeApplicable ? response.resortFeeApplicable : false;
				vm.show_rooms = true;
			} else if(handleDayEarlyLateOverride(response, retryFn)){
				return;
			} else {
				toastMessage.showSimpleToast(response.errorMsg,'error-toast', false, response.errorTitle || null);
			}
		}

		function changeRoomForRes(){
			vm.isloading = true;
			var product_id = vm.available_rooms[vm.selectedRoom].product_id;
			var product_name = vm.available_rooms[vm.selectedRoom].product_name;
			vm.checkin = moment(vm.checkin).format("MM/DD/YYYY");
			vm.checkout = moment(vm.checkout).format("MM/DD/YYYY");
			var isDatesChanged = (vm.checkin != moment(vm.original_room_stay_from).format("MM/DD/YYYY")) || (vm.checkout != moment(vm.original_room_stay_to).format("MM/DD/YYYY"));
			var isRoomChanged = (product_name != vm.product_name);
			
			var changed_type = 'Room';
			var order_history_comment = 'ROOM';
			if (isDatesChanged && isRoomChanged) {
				changed_type = 'Room & Dates';
				order_history_comment = 'DATES_&_ROOM_AVAILABILITY_ERROR';
			} else if (isDatesChanged) {
				changed_type = 'Dates';
				order_history_comment = 'DATES';
			}

			var data = applyDayReservationFlags({
				room_stay_from 			:vm.checkin,
				room_stay_to 			:vm.checkout,
				adult 					:vm.adult,
				child 					:vm.child,
				product_id 				:product_id,
				product_name 			:product_name,
				confirmation_number 	:vm.confirmation_number,
				id 						:vm.reservation_id,
				policy_id 				:vm.policy_id,
				keepSameRates 			:vm.keepSameRates,
				order_history_comment 	:order_history_comment,
				'location' 				:'view_order',
				'changed_type' 			:changed_type,
				requestFor 				:vm.requestFor,
				tax_exempt_indicator 	:vm.tax_exempt_indicator,
				customerTaxExempt 		:vm.customerTaxExempt,
				travellerTaxExempt 		:vm.travellerTaxExempt,
				negotiatedCustId        : vm.negotiatedCustId,
				selectedRatePlanId      : vm.selectedRatePlanId
			});
			var submitRoomChange = function(ignoreEarlyLate){
				if(ignoreEarlyLate){
					data.ignore_early_late = true;
				}
				vm.isloading = true;
				eCommerceService.changeDatesForRes(data)
				.then(function(response) {
					handleChangeDatesResponse(response, function(){ submitRoomChange(true); });
				});
			};
			submitRoomChange(false);
		}

		function changeDatesForRes(){
			vm.isloading = true;
			if(vm.isDayReservation){
				vm.checkout = angular.copy(vm.checkin);
			}
			vm.checkin = moment(vm.checkin).format("MM/DD/YYYY");
			vm.checkout = moment(vm.checkout).format("MM/DD/YYYY");

			var data = applyDayReservationFlags({
				room_stay_from 			:vm.checkin,
				room_stay_to 			:vm.checkout,
				adult 					:vm.adult,
				child 					:vm.child,
				product_id 				:vm.product_id,
				product_name 			:vm.product_name,
				confirmation_number 	:vm.confirmation_number,
				id 						:vm.reservation_id,
				policy_id 				:vm.policy_id,
				keepSameRates 			:vm.keepSameRates,
				order_history_comment 	:'DATES',
				location 				:'view_order',
				changed_type 			:'Dates',
				requestFor 				:vm.requestFor,
				tax_exempt_indicator 	:vm.tax_exempt_indicator,
				customerTaxExempt 		:vm.customerTaxExempt,
				travellerTaxExempt 		:vm.travellerTaxExempt,
				original_room_stay_from : vm.original_room_stay_from,
				original_room_stay_to	: vm.original_room_stay_to,
				reservation_status_type : 'reservation_dates_changed',
				negotiatedCustId        : vm.negotiatedCustId,
				selectedRatePlanId      : vm.selectedRatePlanId
			});

			var submitDateChange = function(ignoreEarlyLate){
				if(ignoreEarlyLate){
					data.ignore_early_late = true;
				}
				vm.isloading = true;
				eCommerceService.changeDatesForRes(data)
				.then(function(response) {
					handleChangeDatesResponse(response, function(){ submitDateChange(true); });
				});
			};
			submitDateChange(false);
		}

		function reloadState(confNo) {
			$stateParams.confirmation_number = confNo;
            $state.transitionTo($state.current, $stateParams, {
                reload: true,
                inherit: false,
                notify: true
            });
		}
 
		/**
		* Close dialog
		*/
		function closeDialog()
		{
		   $mdDialog.hide();
		}



         //Code     to conditionaly run click event
        vm.runClickEvent = false;
        if($( window ).width() <= 1020){
            vm.runClickEvent = true;
        };


        vm.showBlock = [];
        vm.showRateDesc = [];
        vm.showOverlay = false;
        // function to close all details popup
        vm.closeAllDetails = function(){
            angular.forEach(vm.showBlock,function(rval,rkey){
                angular.forEach(rval,function(pval,pkey){
                    vm.showBlock[rkey][pkey] = false;
                    vm.showOverlay = false;
                });
            });
        }

        // function to show hide detail popup
        vm.showDetailBlock = function(roomkey,policyKey){
            angular.forEach(vm.showBlock,function(rval,rkey){
                angular.forEach(rval,function(pval,pkey){
                    if(rkey == roomkey && pkey == policyKey){
                        vm.showBlock[rkey][pkey] = !vm.showBlock[rkey][pkey];
                        if(vm.showBlock[rkey][pkey]){
                            vm.showOverlay = true;
                        } else {
                            vm.showOverlay = false;
                        }
                    } else {
                        vm.showBlock[rkey][pkey] = false;
                    }
                });
            });
        }

        vm.closeAllRateDetails = function(){
            angular.forEach(vm.showRateDesc,function(rval,rkey){
                angular.forEach(rval,function(pval,pkey){
                    vm.showRateDesc[rkey][pkey] = false;
                });
            });
        }

        // function to show hide detail popup
        vm.showDetailRateBlock = function(roomkey,policyKey){
            angular.forEach(vm.showRateDesc,function(rval,rkey){
                angular.forEach(rval,function(pval,pkey){
                    if(rkey == roomkey && pkey == policyKey){
                        vm.showRateDesc[rkey][pkey] = !vm.showRateDesc[rkey][pkey];                        
                    } else {
                        vm.showRateDesc[rkey][pkey] = false;
                    }
                });
            });
        }
	}
})();

(function ()
{
    'use strict';
	
    angular.module('app.e-commerce')
        .controller('editPosDatesController', editPosDatesController);

    /** @ngInject */
    function editPosDatesController(
    	$mdDialog, 
    	toastMessage, 
    	$translate, 
    	eCommerceService, 
    	$rootScope, 
    	localData, 
    	EnvironmentConfig)
    {
		var vm = this;
		// Data
		vm.checkin = localData.hasOwnProperty('checkin')?localData.checkin:'';
		vm.checkout = localData.hasOwnProperty('checkout')?localData.checkout:'';
		vm.posIdx = localData.hasOwnProperty('poskey')?localData.poskey:'';
		vm.baseUrl = EnvironmentConfig.api;
		//Methods
		vm.closeDialog = closeDialog;
		vm.changeDatesForPos = changeDatesForPos;
		
 
		/**
		* Change dates for POS
		*/
		function changeDatesForPos() {
			vm.checkin = moment(vm.checkin).format("MM/DD/YYYY");
			vm.checkout = moment(vm.checkout).format("MM/DD/YYYY");
			closeDialog(vm.checkin, vm.checkout, vm.posIdx);
		}

		/**
		* Close dialog
		*/
		function closeDialog(checkin, checkout, posIdx)
		{
			var data = {
				checkin: checkin,
				checkout: checkout,
				posIdx: posIdx
			};
		   $mdDialog.hide(data);
		}
	}
})();

(function ()
{
    'use strict';

    angular
    .module('app.e-commerce')
    .controller('DocumentViewerController', DocumentViewerController);

    /** @ngInject */
    function DocumentViewerController($mdDialog, toastMessage, $scope, EnvironmentConfig, $sce, Documents){        
        var vm = this;
        vm.type = '';
        vm.pdfPath = '';
        vm.baseUrl = EnvironmentConfig.api;
        // vm.pdfPath = 'http://localhost/lodgingsystem/ls-api/assets/uploads/documents/1542804733bef.pdf';
        $(document).ready(function(){
            $('.slider11').bxSlider({pager: false, minSlides: 1, maxSlides: 1});
        });
        console.log(Documents);
        vm.documents = (Documents != undefined && Documents.length > 0) ? Documents : [];
       
        vm.closeImage = EnvironmentConfig.app+'src/assets/angular-material-assets/img/icons/facebook.svg';
                
        /**
        * Close dialog
        */
        vm.closeDialog= function(){
            $mdDialog.hide();
        }

        $scope.trustSrc = function(docName) {
            return $sce.trustAsResourceUrl(vm.baseUrl + 'assets/uploads/documents/' + docName);
        }
    }
})();

(function ()
{
    'use strict';
	
    angular.module('app.e-commerce')
        .controller('otaController', otaController);

    /** @ngInject */
    function otaController(locals, $mdDialog, createResService)
    {
		var vm = this;
		console.log(locals['orderDetails']);
		vm.channels = {PMS:'PMS', Expedia:'Expedia',Booking:'Booking.com',Hoteltonight:'Hoteltonight',Priceline:'Priceline.com', Airbnb: 'Airbnb', Getaroom: 'Getaroom.com' , Agoda:'Agoda' , Hotwire:'Hotwire' , Travelzoo:'Travelzoo' , 'GuestCentric Channels':'GuestCentric Channels'};	
		vm.paymentType = {channel_collect:'Channel collect',hotel_collect:'Hotel collect', airbnb_collect: 'Airbnb Collect'};
		vm.orderData = {
			siteminder_id:locals['orderDetails']['siteminder_id'], 
			source_of_creation:locals['orderDetails']['source_of_creation'], 
			collect_which:locals['orderDetails']['collect_which']
		};
		vm.autoFillOff = true;
		vm.saveOTADetails = saveOTADetails;
		function saveOTADetails(){
			console.log(vm.orderData);
			var data = {
				confirmation_number:locals['orderDetails']['confirmation_number'],
				resData:vm.orderData
			};
			createResService.OTADetails(data).then(function(response){
				if(response['success']){
					hideDialog();
				}else{
					alert('error occured');
				}
			});
			
		}		
 
		//Methods
		vm.closeDialog = closeDialog;
		vm.hideDialog = hideDialog;
       /**
	   * Close dialog
	   */
	   function hideDialog(){
           $mdDialog.hide(vm.orderData);
       }
	   function closeDialog(){
           $mdDialog.hide();
       }

        setTimeout(function() {
	        vm.autoFillOff = false;
	    }, 1500); 
	}
})();

(function ()
{
    'use strict';

    angular
    .module('app.e-commerce')
    .controller('PostTypeController', PostTypeController);

    /** @ngInject */
    function PostTypeController(
    	activityService,
    	$localStorage,
        $translate,
        $state,
    	$scope,
    	EnvironmentConfig,
    	toastMessage,
        $mdDialog,
        $document,
        $rootScope,
        $timeout,
        dialogData,
        $http
    )
    {
    	var vm = this;
        
        vm.pos_flag = 'add'; 
        vm.checkPosUniqueName = checkPosUniqueName;
        vm.nameError = false;
        vm.isloading = false;
        vm.posTypes = {};
         vm.autoFillOff = true;
        vm.posTypeButton = false;
        vm.pos_types = {};
        vm.parentPosTypes = {};
        vm.pos_types.pos_type = 'activity';
        vm.status = [{'value':'1', 'name':'Active'}, {'value':'0', 'name':'Inactive'}]
        vm.pop_header = $translate.instant('POS_TYPE.NEW_POS_TYPE_HEAD');
        vm.posProductTypes = dialogData.posProductTypes;
        var hotelID = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
        vm.hotel_id = hotelID;
        vm.profilePicStatus = false;
        vm.imageStatus = true;
        vm.show_listing = false;
        vm.previousPicture = EnvironmentConfig.api+'assets/uploads/defaultimage/act_postype.jpg';
        if(dialogData.action=='calllisting'){
			vm.isloading = false;
			vm.PosTypes = dialogData.PosTypes;
			vm.show_listing = true;
			vm.pos_flag = 'add';
			vm.pop_header = $translate.instant('POS_TYPE.LIST');
           
		}
        vm.updateParentData = function(){
            vm.parentPosTypes =  dialogData['PosTypes'][vm.pos_types.pos_type];
        }
        vm.closeDialog  = function() {
           $mdDialog.hide(); 
        }

        vm.deltePosType  = function(postypeId,ev) {
			$mdDialog.hide();
			$timeout(function ()
			{
                var html = 'Are you sure you want to delete this POS type?';              
                $mdDialog.show({
                              controller: 'confirmController',
                              controllerAs: 'vm',
                              templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                              parent: angular.element(document.body),
                              targetEvent: event,
                              clickOutsideToClose:true ,
                              locals: {
                                    title: 'Delete POS type',
                                    htmlContent:html,
                                    cancelBtn:'Cancel',
                                    OkBtn:'Ok'
                                }                
                            })
                            .then(function(answer) {
                                
                               if(typeof answer != 'undefined' && answer == 'update'){
                               vm.isloading = true;
                                 activityService.deletePosType(postypeId,dialogData.selectedCategory,vm.hotel_id)
                                 .then(function(response) {
                                    $rootScope.$broadcast('openAgainPopup',{selected:postypeId,result:response.result});
                                 });
                               }
                            }, function() {
                                    $rootScope.$broadcast('openAgainPopup',{selected:''});
                            }); 
			});	
		}
		vm.showListing  = function(ev) {
            var allCategory = [];
            if(typeof dialogData.allCategory != 'undefined' && dialogData.selectedCategory.length != 0){
                dialogData.allCategory.forEach(function(element,index){
                    allCategory[index] = element['hidename'];
                });
            }
			vm.isloading = true;
            activityService.PosTypes(allCategory,vm.hotel_id)
                .then(function(response) {
                    vm.isloading = false;
                    vm.PosTypes = response.result;
                    vm.show_listing = true;
                    vm.pos_flag = 'add';
                    vm.pop_header = $translate.instant('POS_TYPE.LIST');
             });
        }
        vm.hideListing  = function(ev) {
            vm.show_listing = false;
            vm.pos_types = {};
            vm.pop_header = $translate.instant('POS_TYPE.NEW_POS_TYPE_HEAD');
        }
        /************************************/
        /********* Add new Room Type ********/
        /************************************/
        vm.addNewPosType = function() {
            vm.pos_flag = 'add';
            var fd = new FormData();
            vm.pos_types.hotel_id = vm.hotel_id;
            vm.pos_types.created_by_user = $localStorage.userId;
            vm.pos_types.pos_type_id = vm.pos_types.pos_type_id;
            if (vm.file != undefined) {
                fd.append('file',vm.file);
            }
            var pos_types = JSON.stringify(vm.pos_types);
            fd.append('pos_types',pos_types);
            activityService.addPosType(fd)
                .then(function(response) {
                    if(response.status === 'error') {
                        if(response.errorType == 'image'){
                            toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                            vm.pictures = null;
                            vm.imageStatus = true;
                            vm.file =null;
                            vm.selectFile =false;
                        }
                    }
                    if(response.last_id!=undefined)
						vm.selectedPOS = response.last_id;
                    activityService.PosTypes(dialogData.selectedCategory,vm.hotel_id)
                        .then(function(response) {
                            if(response.status === 'error') {

                            } else {
                                $rootScope.$broadcast('pos_types', {result:response.result,product_pos_type:vm.pos_types.pos_type});
                            }
                            $mdDialog.hide();
                        });
                    
                    //$state.go('app.e-commerce.roomtypes');
                });
            
        };

        vm.deletePosType = function(pos_type_id) {
            vm.delete_popup = true;
            vm.show_listing = false;
            vm.delete_pos_type_id = pos_type_id;
        };

        vm.cancelDelete = function(pos_type_id) {
            vm.delete_popup = false;
            vm.show_listing = true;
        };

        vm.confirmDelete = function() {
            vm.delete_popup = false;
            vm.show_listing = true;
            activityService.deletePosType(vm.delete_pos_type_id)
                .then(function(response) {
                    vm.showListing();
                });
        };

        vm.getPosType = function(pos_type_id) {
            vm.show_listing = false;
            activityService.getPosType(pos_type_id)
                .then(function(response) {
                    if(response.status === 'error') {
                        if(response.errorType == 'image'){
                            toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                            vm.pictures = null;
                            vm.imageStatus = true;
                            vm.file =null;
                            vm.selectFile =false;
                        }
        			} else {
                        vm.pos_types = response.result;
                        vm.updateParentData();
                        vm.pos_flag = 'edit';
                        vm.pop_header = vm.pos_types.pos_type_name;
                        if(vm.pos_types['pos_type_media'] != '') {
                            vm.previousPicture = EnvironmentConfig.api+'assets/uploads/activities/'+vm.pos_types['pos_type_media'];
                        } else {
                            vm.previousPicture = EnvironmentConfig.api+'assets/uploads/defaultimage/act_postype.jpg';
                        }
                    }

                    vm.posTypeButton = true;
                });
            
        };

        

        /************************************/
        /********* Check Room Name to be unique *********/
        /************************************/
        function checkPosUniqueName() {
            var hotel_id = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
            var data = {
                pos_type_name : vm.pos_types.pos_type_name,
                pos_type : vm.pos_types.pos_type,
                hotel_id : hotel_id,
                pos_type_id : vm.pos_types.pos_type_id
            };
            activityService.checkPosTypeName(data).then(function(response){
                if(response.status === 'error'){
                    vm.nameError = true;
                } else {
                    vm.nameError = false;
                }
            });
        }

        $scope.upload = function(file,errFiles) {
            if(file){
                vm.imageStatus= false;
                vm.file = file;
                //vm.selectFile = true;
            } else {
                //vm.profilePicStatus = false;
                vm.file = null;
                vm.isloading = false;
                if(errFiles.length > 0) {
                    angular.forEach(errFiles, function (value, index){                    
                        switch(value.$error) {
                            case 'pattern': vm.fileError = 'FILE_TYPE_NOT_SUPPORTED';
                                break;
                            case 'maxSize': vm.fileError = 'FILE_SIZE_EXCEEDS';
                                break;
                            case 'minWidth' : vm.fileError = 'MIN_SIZE_MESSAGE';
                                break;
                            case 'minHeight' : vm.fileError = 'MIN_SIZE_MESSAGE';
                                break;                                
                            default: vm.fileError = 'COMMON_IMAGE_MESSAGE';  
                        }
                        toastMessage.showSimpleToast($translate.instant('POS_TYPE.'+ vm.fileError),'error-toast');
                    });
                }

            }
        }

        setTimeout(function() {
           vm.autoFillOff = false;
        }, 1500); 
        
       }
})();

(function ()
{
    'use strict';

    angular
    .module('app.e-commerce')
    .controller('PostypeImageController', PostypeImageController);

    /** @ngInject */
    function PostypeImageController($mdDialog, Image, toastMessage, $scope, EnvironmentConfig){

        var vm = this;
        // Data
        vm.image = Image;
        
        // Methods
        //vm.saveContact = saveContact;
        vm.closeDialog = closeDialog;
        
        /**
        * Close dialog
        */
        function closeDialog(){
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.settings.emails',
            [
                // 3rd Party Dependencies,
                'ckeditor'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $stateProvider.state('app.settings_emails', {
            url    : '/email-templates',
            title  : 'Templates',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/settings/emails/templates/templates.html',
                    controller : 'TemplatesController as vm'
                }
            },
            resolve: {
                Organizations: function (organizationsservice){
                    return organizationsservice.getorganizations();
                },
                Settings: function (emailsservice,$localStorage){
					var data = {selectedHotel:$localStorage.hotels[$localStorage.selectedHotel].hotel_id};
                    return emailsservice.getEmailSettings(data);
                },
                Templates: function (emailsservice,$localStorage){
					var data = {selectedHotel:$localStorage.hotels[$localStorage.selectedHotel].hotel_id};
                    return emailsservice.getTemplates(data);
                }
            },
            permission: 'email_templates'
        }).state('app.settings_email',{
			url    : '/email-template/:edit_template_id',
            title  : 'Templates',
			views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/settings/emails/templates/template/template.html',
                    controller : 'TemplateController as vm'
                }
            },
            resolve: {
				Template: function (emailsservice,$stateParams){
                    var data = {'template_id' : $stateParams.edit_template_id};
                    return emailsservice.getTemplate(data);
                },
                Organizations: function (organizationsservice){
                    return organizationsservice.getorganizations();
                },
			},
            permission: 'update_email_template'
		}).state('app.settings_email_add',{
            url    : '/email-template/:edit_template_id',
            title  : 'Templates',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/settings/emails/templates/template/template.html',
                    controller : 'TemplateController as vm'
                }
            },
            resolve: {
                Template: function (emailsservice){
                    return emailsservice.getTemplate();
                },
                Organizations: function (organizationsservice){
                    return organizationsservice.getorganizations();
                },
            },
            permission: 'add_email_template'
        }).state('app.config_email',{
			url    : '/email-config',
            title  : 'Configuration',
			views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/settings/emails/configuration/config.html',
                    controller : 'TemplatesController as vm'
                }
            },
            resolve: {
				Organizations: function (organizationsservice){
					var data = {getDefault: true};
                    return organizationsservice.getorganizations(data);
                },
                Settings: function (emailsservice,$localStorage){
					var data = {selectedHotel:$localStorage.hotels[$localStorage.selectedHotel].hotel_id};
                    return emailsservice.getEmailSettings(data);
                },
                Templates: function (emailsservice,$localStorage){
					var data = {selectedHotel:$localStorage.hotels[$localStorage.selectedHotel].hotel_id,'allTemplate':true};
                    return emailsservice.getTemplates(data);
                }
			},
            permission: 'configuration'
		});

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/settings');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.settings.emails')
        .controller('TemplateController', TemplateController);

    /** @ngInject */
    function TemplateController($document, $state, Template, Organizations, emailsservice, toastMessage, $mdDialog, $localStorage, EnvironmentConfig, $window, $timeout)
    {
        var vm = this;
        vm.isloading = false;
        vm.template = Template.templates;
        vm.websites = Organizations.organizations;
		vm.hotel_id = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
		vm.uniqueError = false;
		vm.gotoTemplates = gotoTemplates;
		vm.actionType = 'edit';
        // Data
        vm.api = EnvironmentConfig.api;
        vm.autoFillOff = true;
        // Methods
        var edit_template_id = $state.params.edit_template_id;
        if(edit_template_id != "add" && edit_template_id > 0){

			
        }else if(edit_template_id != "add"){
			$state.go('app.settings_emails');
		}else{
			vm.template = {};
			vm.actionType = 'add';
			vm.title = 'New Template';
		}
        vm.saveTemplate = saveTemplate;
        vm.updateTemplate = updateTemplate;
        vm.gotoTemplates = gotoTemplates;
        vm.uniqueTemplateName = uniqueTemplateName;
        vm.showInfo = showInfo;
		
		function ckeditorReplace() {
			CKEDITOR.removeAllListeners();;
			CKEDITOR.removeListener();
			CKEDITOR.env.isCompatible = true;
			CKEDITOR.replace('desc', {
	        	language: 'en',
		        allowedContent: true,
		        'skin': 'moono',
		        width:900,
		        filebrowserImageUploadUrl : vm.api+'emailtemplates/upload_files/type/image',
		        toolbar: 'Basic'
			});
		}
		ckeditorReplace();
		$timeout(function() {
			CKEDITOR.on( 'instanceReady', function( evt ) {
			    evt.editor.on( 'change', function( evt1 ) {
			    	/*evt.editor.removeAllListeners();
					evt.removeListener();*/
					//evt.destroy(true);
					//ckeditorReplace();
					vm.template.template_content = this.getData();
			       	updateTemplate(this.getData());
			        return false;
			    } );
			    var $height = ($window.innerHeight)/1.5;
			    console.log("height",$height);
			    angular.element(document.getElementsByClassName('cke_contents')).css('height',$height);
			    //to remove \r\n
			    /*this.dataProcessor.writer.setRules( 'p',
	            {
	                indent : false,
	                breakBeforeOpen : true,
	                breakAfterOpen : false, breakBeforeClose : false,
	                breakAfterClose : true
	            });*/
			} );
		}, 10);
		
		function showInfo(){
			alert = $mdDialog.alert({
						title: 'Email Variables',
						template: '<p class="md-margin spacing-block-main"><b>Note:</b> These are the variables that can be used in email templates by enclosing with {{}}for dynamic values</p><p class="md-margin spacing-block-main">In case of dynamic attributes of product replace space with _. For example if dynamic attribute is "Arrival Date" then use here <code ng-non-bindable> {{Arrival_Date}} </code></p><ul class="listing-ul-main"><li>customer_name</li><li>customer_email</li><li>customer_contact</li><li>customer_address</li><li>increment_id</li><li>check-in</li><li>checkin</li><li>checkout</li><li>itinerary</li><li>itinerary_no</li><li>confirmation_no</li><li>confirmation_number</li><li>invoice_data</li><li>comment</li><li>current_balance</li><li>manage_bookings_url</li><li>admin_email</li><li>site_url</li><li>hotel_name</li><li>hotel_phone</li><li>service_booked</li><li>grand_total</li><li>booking_status</li><li>product_name</li><li>hold_duration</li><li>create_reservation_url</li><li>create_reservation_button</li><li>first_name</li><li>last_name</li></ul>',
						ok: 'Close',
						clickOutsideToClose: true
					 });
			$mdDialog.show( alert );
		}
		
        function gotoTemplates(){
			$state.go('app.settings_emails');
		}
        function updateTemplate(input_value){
        	if(input_value !== undefined){
				uniqueTemplateName();
				setTimeout(function(){
					if(vm.uniqueError){
						//~ toastMessage.showSimpleToast('Template name already exists. Please change your template name.','error-toast');
						return false;
					}
					if(vm.actionType == 'edit'){
						saveTemplate()
					}
				},500);
			}
		}
        function saveTemplate(){
			vm.isloading = true;
			vm.template.hotel_id = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;

			emailsservice.updateTemplate(vm.template).then(function(response){
				if(response.success != false){
					vm.isloading = false;
					vm.title = vm.template.template_name;
					if(vm.actionType == 'add'){
						$state.go('app.settings_emails');
					}
				}else{
					toastMessage.showSimpleToast('There is some error. Please check','error-toast');
				}
			});
		}
        function uniqueTemplateName(){
        	if(vm.template.hasOwnProperty('template_name')){
				if(vm.template.hasOwnProperty('template_id')){
					var template_id = vm.template.template_id;
				}else{
					var template_id = "";
				}
				if(vm.template.hasOwnProperty('website_id')){
					var hotel_id = vm.template.website_id;
				}else{
					var hotel_id = vm.hotel_id;
				}
				var template_name = {"template_name":vm.template.template_name,"template_id":template_id,"hotel_id":hotel_id};
				emailsservice.uniqueTemplateName(template_name).then(function(response){
					if(response.response == false){
						vm.uniqueError = true;
					}else{
						vm.uniqueError = false;
					}
				});
			}
		}

		setTimeout(function() {
		   vm.autoFillOff = false;
		}, 1500); 

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.permissions.roles',
            [
                // 3rd Party Dependencies
                'xeditable',
                'ngMaterial',
                 'mdDataTable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider){

        $stateProvider.state('app.roles_detail', {
			url    : '/roles/:id',
            title  : 'Roles',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/permissions/roles/rolePermission.html',
                    controller : 'rolesEditPermissionController as vm'
                }
            },resolve :{
                rolePermissionModule: function (roleService, $stateParams, $localStorage){
                    return roleService.getRolePermissions($stateParams.id,$localStorage.hotels[$localStorage.selectedHotel].hotel_id);
                }
            },
            permission: 'update_role',
            bodyClass: 'roles'
        }).state('app.roles_add', {
            url    : '/add_roles',
            title  : 'Roles',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/permissions/roles/rolePermission.html',
                    controller : 'rolesAddPermissionController as vm'
                }
            },
            resolve :{

                rolePermissionModule: function (roleService){
                    return roleService.currentUserPermission();
                }
            },
            permission: 'add_role',
            bodyClass: 'roles'
        }).state('app.roles', {
            url    : '/roles',
            title  : 'Roles',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/permissions/roles/roles.html',
                    controller : 'rolesController as vm'
                }
            },
            permission: 'roles',
            bodyClass: 'roles'
        });
    }
})();

(function ()
{
	'use strict';

	angular
	.module('app.permissions.roles')
	.controller('roleControllers', roleControllers);

	/** @ngInject */
	function roleControllers($mdDialog, Contact, Contacts, User, msUtils, roleService, toastMessage, $localStorage, $scope, organizationsservice, HotelId){
		var vm = this;
		var organizationdata = {onlyOrganizations:true,id:HotelId,getsubHotels:true};
		
        organizationsservice.getorganizations(organizationdata)
		.then(function(response){
			vm.websites = response.organizations;
		});

		// Data
		vm.title = 'Edit Role';
		vm.contact = angular.copy(Contact);
		vm.contacts = Contacts;
		vm.user = User;
		vm.newContact = false;
		vm.allFields = false;
		vm.showOrganisationDropDown = $localStorage.roleId;
		vm.autoFillOff = true;
		if ( !vm.contact )
		{
			vm.contact = {};
			vm.title = 'New Role';
			vm.newContact = true;
			var selectOrg = [];
			selectOrg[0] = {'hotel_id':HotelId};
			vm.contact.role_websites = selectOrg;
			
		} else {
			if(vm.contact.hotel_ids){
				var selectedOrg = vm.contact.hotel_ids.split(',');
				var selectOrg = [];
				for(var i=0;i<selectedOrg.length; i++){
					selectOrg[i] = {'hotel_id':selectedOrg[i]};
				}
				vm.contact.role_websites= selectOrg;
			}
		}
		vm.contact.hotel_parent_id = HotelId;

		// Methods
		vm.addNewRole = addNewRole;
		vm.saveContact = saveContact;
		vm.deleteContactConfirm = deleteContactConfirm;
		vm.closeDialog = closeDialog;
		vm.toggleInArray = msUtils.toggleInArray;
		vm.exists = msUtils.exists;

		//////////

		/**
		 * Add new contact
		 */
		 function addNewRole()
		 {
			roleService.addRole(vm.contact)
			.then(function(response){
				if(response.status){
					toastMessage.showSimpleToast('Role has been created successfully.','success-toast');
					$mdDialog.hide();
					$scope.updateTable();
				} else if(response.errorMsg) {
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				}else {
					toastMessage.showSimpleToast('There was some error in saving role.','error-toast');
				}
			});
		 }

		/**
		 * Save contact
		 */
		 function saveContact()
		 {
			roleService.UpdateRoles(vm.contact)
			.then(function(response){
				if(response.status){
					closeDialog();
					toastMessage.showSimpleToast('Role has been updated successfully.','success-toast');
					$scope.updateTable();
				} else if(response.errorMsg) {
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				}else{
					toastMessage.showSimpleToast('There was some error in saving role.','error-toast');
				}
			});
		}

		/**
		 * Delete Contact Confirm Dialog
		 */
		 function deleteContactConfirm(ev)
		 {
		 	var confirm = $mdDialog.confirm()
		 	.title('Are you sure want to delete the role?')
		 	.htmlContent('<b>' + vm.contact.role_title+ '</b>' + ' will be deleted.')
		 	.ariaLabel('delete role')
		 	.targetEvent(ev)
		 	.ok('OK')
		 	.cancel('CANCEL');

		 	$mdDialog.show(confirm).then(function ()
		 	{

		 		vm.contacts.splice(vm.contacts.indexOf(Contact), 1);

		 	});
		 }

		/**
		 * Close dialog
		 */
		 function closeDialog()
		 {
		 	$mdDialog.hide();
		 }

		setTimeout(function() {
           vm.autoFillOff = false;
       	}, 1500); 

		}
	})();

(function ()
{
    'use strict';

    angular
        .module('app.permissions.organizations',
            [
                // 3rd Party Dependencies
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $stateProvider.state('app.permissions_organizations', {
            url    : '/hotels',
            title  : 'Hotels',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/permissions/organizations/organizations.html',
                    controller : 'OrganizationsController as vm'
                }
            },
            permission: 'hotels'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/permissions/organizations');
    }
})();

(function ()
{
	'use strict';

	angular
		.module('app.permissions.organizations')
		.controller('OrganizationDialogController', OrganizationDialogController);

	/** @ngInject */
	function OrganizationDialogController($mdDialog, Organization, Organizations, Categories, msUtils,organizationsservice,toastMessage, $scope, ParentOrg){
		var vm = this;
		
		vm.title         = 'Edit Hotel';
		vm.organization  = angular.copy(Organization);
		vm.organizations = Organizations;
		vm.categories    = Categories;
		vm.newOrganization  = false;
		vm.success       = false;
		if ( !vm.organization ){
			vm.title            = 'New Hotel';
			vm.newOrganization  = true;
			vm.organization = {hotel_parent_id : ParentOrg};
		}

		// Methods
		vm.addNewOrganization   = addNewOrganization;
		vm.saveOrganization     = saveOrganization;
		vm.deleteOrganizationConfirm = deleteOrganizationConfirm;
		vm.closeDialog          = closeDialog;
		vm.toggleInArray        = msUtils.toggleInArray;
		vm.exists               = msUtils.exists;
		vm.uniqueOrgName   		= uniqueOrgName;
		 vm.autoFillOff = true;
		/**
		 * Add new organization
		 */
		function addNewOrganization(){
			if(vm.uniqueError){return false;}
			organizationsservice.addNewOrganization(vm.organization).then(function(resposen){
				if(resposen.success){
					toastMessage.showSimpleToast('Hotel has been created successfully.','success-toast');
					vm.success = true;
					$scope.updateTable();
					closeDialog();
				}else if(resposen.errorMsg){
					toastMessage.showSimpleToast(resposen.errorMsg,'error-toast');
				}else{
					toastMessage.showSimpleToast('There was some error in creating hotel.','error-toast');
				}
			});
		}

		/**
		 * Save organization
		 */
		function saveOrganization(){
			organizationsservice.updateOrganization(vm.organization).then(function(resposen){
				if(resposen.success){
					closeDialog();
					vm.success = true;
					toastMessage.showSimpleToast('Hotel has been updated successfully.','success-toast');
					$scope.updateTable();
				}else if(resposen.errorMsg){
					toastMessage.showSimpleToast(resposen.errorMsg,'error-toast');
				}else{
					toastMessage.showSimpleToast('There was some error in creating hotel.','error-toast');
				}
			});
		}

		/**
		 * Save organization
		 */
		function uniqueOrgName(value,column){

			if(value){
				
				vm.orgInfo = {'value':value,'column':column,'hotel_id':vm.organization.hotel_id};
				organizationsservice.checkUnique(vm.orgInfo).then(function(response){
					if(response.success === true){
						vm.uniqueError = true;
						vm.uniqueName = true;
					}else{
						vm.uniqueError 	= false;
						vm.uniqueName = false;
					}
				});    
			}
		}
		/*function uniqueOrgCode(value,column){

			if(value){
				vm.orgInfo = {'value':value,'column':column,'website_id':vm.organization.website_id};
				organizationsservice.checkUnique(vm.orgInfo).then(function(response){
					if(response.success === true){
						vm.uniqueError 	= true;
						vm.codeError 	= true;
					}else{
						vm.uniqueError 	= false;
						vm.codeError 	= false;
					}
				});    
			}
		}*/


		/**
		 * Delete Organization Confirm Dialog
		 */
		function deleteOrganizationConfirm(ev){

			var confirm = $mdDialog.confirm()
				.title('Are you sure want to delete this hotel?')
				.htmlContent('<b>' + vm.organization.hotel_title + '</b>' + ' will be deleted.')
				.ariaLabel('delete hotel')
				.targetEvent(ev)
				.ok('OK')
				.cancel('CANCEL');

			$mdDialog.show(confirm).then(function (){
				vm.organizations.splice(vm.organizations.indexOf(Organization), 1);
				var data = {hotel_id:vm.organization.hotel_id};
				organizationsservice.deleteOrganization(data)
				.then(function(response){
					if(response.errorMsg ){
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					}else{
						toastMessage.showSimpleToast('Hotel has been deleted successfully.','success-toast');
						vm.organizations.splice(vm.organizations.indexOf(Organization), 1);
						closeDialog();
					}
				});
			});
		}

		/**
		 * Close dialog
		 */
		function closeDialog(){
			$mdDialog.hide();
		}
		 setTimeout(function() {
           vm.autoFillOff = false;
       }, 1500); 
	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center', [
            'ngMaterial'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // Unified Message Center is the primary screen. Dedicated direct and
        // ota aliases keep working and only pick the initially active tab.
        $stateProvider
            .state('app.guest-message-center', {
                abstract: true,
                url: '/message-center'
            })
            .state('app.guest-message-center.messages', {
                url: '/messages/?confirmation_number',
                title: 'Messages',
                bodyClass: 'message-center-no-transition',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/guest-message-center/inbox/inbox.html',
                        controller: 'InboxMessageCenterController as vm'
                    }
                },
                data: {
                    initialTab: 'all'
                },
                permission: 'messages'
            })
            .state('app.guest-message-center.archive', {
                url: '/archive/?confirmation_number',
                title: 'Archive',
                bodyClass: 'message-center-no-transition gmc-archive-view',
                views: {
                    'content@app': {
                        // Shared guest inbox; archive mode via data.isArchiveView (no duplicated controller).
                        templateUrl: 'app/main/apps/guest-message-center/inbox/inbox.html',
                        controller: 'InboxMessageCenterController as vm'
                    }
                },
                data: {
                    initialTab: 'all',
                    isArchiveView: true
                },
                permission: 'messages'
            })
            .state('app.guest-message-center.group-messages', {
                url: '/group-messages',
                title: 'Group message',
                bodyClass: 'message-center-no-transition',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/guest-message-center/inbox/inbox.html',
                        controller: 'InboxMessageCenterController as vm'
                    }
                },
                data: {
                    initialTab: 'group_msg'
                },
                permission: 'messages'
            })
            .state('app.guest-message-center.direct-messages', {
                url: '/direct/?conversation_sid',
                title: 'Direct',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/guest-message-center/inbox/inbox.html',
                        controller: 'InboxMessageCenterController as vm'
                    }
                },
                data: {
                    initialTab: 'all'
                },
                permission: 'direct'
            })
            .state('app.guest-message-center.ota-messages', {
                url: '/ota/',
                title: 'OTA',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/guest-message-center/inbox/inbox.html',
                        controller: 'InboxMessageCenterController as vm'
                    }
                },
                data: {
                    initialTab: 'all'
                },
                permission: 'ota'
            })
            .state('app.guest-message-center.staff-messages', {
                url: '/staff/?confirmation_number',
                title: 'Staff messages',
                bodyClass: 'message-center-no-transition',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/guest-message-center/staff-messages/staff-inbox.html',
                        controller: 'StaffMessageCenterController as vm'
                    }
                },
                data: {
                    initialTab: 'all'
                },
                permission: 'messages'
            })
            .state('app.guest-message-center.staff-group-messages', {
                url: '/staff-group-messages/',
                title: 'Staff Group message',
                bodyClass: 'message-center-no-transition',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/guest-message-center/staff-messages/staff-inbox.html',
                        controller: 'StaffMessageCenterController as vm'
                    }
                },
                data: {
                    initialTab: 'group_msg'
                },
                permission: 'messages'
            })
            .state('app.guest-message-center.templates', {
                url: '/templates',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/guest-message-center/templates/message-templates/message-templates.html',
                        controller: 'MessageTemplatesController as vm'
                    }
                }
            })
            .state('app.guest-message-center.quick-replies', {
                url: '/quick-replies/',
                title: 'Quick Replies',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/guest-message-center/templates/quick-replies/quick-replies.html',
                        controller: 'QuickRepliesController as vm'
                    }
                },
                permission: 'mc_templates'
            })
            .state('app.guest-message-center.group-message-logs', {
                url: '/group-msg-logs/',
                title: 'Group message',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/guest-message-center/group-messages/group-message-logs.html',
                        controller: 'GroupMessageLogsController as vm'
                    }
                },
                permission: 'messages'
            })
            .state('app.guest-message-center.settings', {
                url: '/settings/',
                title: 'Message Center Config',
                permission: 'mc_settings',
                onEnter: ['$state', function ($state) {
                    $state.go('app.settings_message_center');
                }]
            });

        $translatePartialLoaderProvider.addPart('app/main/apps/guest-message-center');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .controller(
            'McTemplateDialogController',
            McTemplateDialogController
        );

    /** @ngInject */
    function McTemplateDialogController(
        $mdDialog,
        toastMessage,
        messageCenterService,
        category,
        template,
        templates
    )
    {
        var vm = this;

        var TOKENS = [
            '#{greeting}',
            '#{honorific}',
            '#{firstName}',
            '#{lastName}',
            '#{roomNumber}',
            '#{confirmationNumber}',
            '#{hotelName}',
            '#{googleReviewLink}',
            '#{tripAdvisorReviewLink}'
        ];

        vm.isEdit = !!(template && template.id);
        vm.saving = false;
        vm.errorMessage = '';

        // Current selected category ke templates
        vm.templates = templates || [];

        vm.tokens = TOKENS;
        vm.duplicateTemplateName = false;

        vm.form = {
            category_id: (category && category.id) || '',
            name: (template && template.name) || '',
            body: (template && template.body) || '',
            is_active: 1
        };

        vm.validateTemplateName = validateTemplateName;
        vm.insertToken = insertToken;
        vm.canSave = canSave;
        vm.save = save;
        vm.cancel = cancel;


        function normalizeName(value)
        {
            return String(value || '')
                .replace(/\s+/g, ' ')
                .trim()
                .toLowerCase();
        }


        function validateTemplateName()
        {
            var enteredName = normalizeName(vm.form.name);

            vm.duplicateTemplateName = false;

            if (!enteredName) {
                return;
            }

            for (var i = 0; i < vm.templates.length; i++) {

                var currentTemplate = vm.templates[i];

                // Edit ke time current template ko ignore karo
                if (
                    vm.isEdit &&
                    String(currentTemplate.id) === String(template.id)
                ) {
                    continue;
                }

                var existingName = normalizeName(
                    currentTemplate && currentTemplate.name
                );

                if (
                    existingName &&
                    existingName === enteredName
                ) {
                    vm.duplicateTemplateName = true;
                    return;
                }
            }
        }


        function canSave()
        {
            if (vm.saving) {
                return false;
            }

            if (!String(vm.form.name || '').trim()) {
                return false;
            }

            if (!String(vm.form.body || '').trim()) {
                return false;
            }

            if (!vm.form.category_id) {
                return false;
            }

            if (vm.duplicateTemplateName) {
                return false;
            }

            return true;
        }


        function insertToken(token)
        {
            var textarea =
                document.getElementById('gmc-qr-body-input');

            var body = String(vm.form.body || '');

            var start;
            var end;

            if (
                textarea &&
                typeof textarea.selectionStart === 'number'
            ) {
                start = textarea.selectionStart;
                end = textarea.selectionEnd;

                vm.form.body =
                    body.slice(0, start) +
                    token +
                    body.slice(end);

                setTimeout(function ()
                {
                    textarea.focus();

                    textarea.selectionStart =
                        textarea.selectionEnd =
                        start + token.length;

                }, 0);

                return;
            }

            vm.form.body = body + token;
        }


        function save()
        {
            var name =
                String(vm.form.name || '').trim();

            var body =
                String(vm.form.body || '').trim();

            // Save ke time bhi dobara check karo
            validateTemplateName();

            if (vm.duplicateTemplateName) {

                vm.errorMessage =
                    'Template name already exists in this category.';

                return;
            }

            if (!canSave()) {

                vm.errorMessage =
                    'Please fill all required fields.';

                return;
            }

            vm.saving = true;
            vm.errorMessage = '';

            var requestData = {
                category_id: parseInt(vm.form.category_id, 10),
                name: name,
                body: body,
                is_active: 1
            };

            var request;

            if (vm.isEdit) {

                requestData.id =
                    parseInt(template.id, 10);

                request =
                    messageCenterService.updateTemplate(
                        requestData
                    );

            } else {

                request =
                    messageCenterService.createTemplate(
                        requestData
                    );
            }

            request.then(function (response)
            {
                vm.saving = false;

                if (
                    !response ||
                    response.success === false
                ) {
                    vm.errorMessage =
                        (response && response.message) ||
                        'Unable to save template.';

                    toastMessage.showSimpleToast(
                        vm.errorMessage,
                        'error-toast'
                    );

                    return;
                }

                $mdDialog.hide(response.data);

            }, function ()
            {
                vm.saving = false;

                vm.errorMessage =
                    'Unable to save template.';

                toastMessage.showSimpleToast(
                    vm.errorMessage,
                    'error-toast'
                );
            });
        }


        function cancel()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .controller('McTemplateCategoryDialogController', McTemplateCategoryDialogController);

    /** @ngInject */
    function McTemplateCategoryDialogController(
        $mdDialog,
        toastMessage,
        messageCenterService,
        category,
        templateType
    )
    {
        var vm = this;

        vm.isEdit = !!(category && category.id);
        vm.saving = false;
        vm.errorMessage = '';
        vm.duplicateCategoryName = false;
        vm.form = {
            name: (category && category.name) || '',
            is_active: category && (category.is_active === 0 || category.is_active === '0') ? 0 : 1
        };

        vm.save = save;
        vm.cancel = cancel;
        vm.validateCategoryName = validateCategoryName;


        /**
         * Check category name while typing
         */
        function validateCategoryName()
        {
            var name = String(vm.form.name || '')
                .replace(/^\s+|\s+$/g, '')
                .toLowerCase();

            vm.duplicateCategoryName = false;

            if (!name) {
                return;
            }

            messageCenterService.getTemplateCategories({
                template_type: templateType
            }).then(function (response)
            {
                var categories = [];

                if (response && response.data) {
                    categories = response.data;
                }

                vm.duplicateCategoryName = categories.some(function (item)
                {
                    /*
                     * While editing, ignore current category itself.
                     */
                    if (
                        vm.isEdit &&
                        String(item.id) === String(category.id)
                    ) {
                        return false;
                    }

                    var existingName = String(item.name || '')
                        .replace(/^\s+|\s+$/g, '')
                        .toLowerCase();

                    return existingName === name;
                });
            });
        }


        function save()
        {
            var name = String(vm.form.name || '').replace(/^\s+|\s+$/g, '');

            if (!name) {
                vm.errorMessage = 'Name is required.';
                return;
            }

            /*
             * Check duplicate once again before saving.
             * This prevents save even if validation was not triggered.
             */
            vm.saving = true;
            vm.errorMessage = '';
            vm.duplicateCategoryName = false;

            messageCenterService.getTemplateCategories({
                template_type: templateType
            }).then(function (response)
            {
                var categories = response && response.data
                    ? response.data
                    : [];

                var duplicate = categories.some(function (item)
                {
                    if (
                        vm.isEdit &&
                        String(item.id) === String(category.id)
                    ) {
                        return false;
                    }

                    var existingName = String(item.name || '')
                        .replace(/^\s+|\s+$/g, '')
                        .toLowerCase();

                    return existingName === name.toLowerCase();
                });

                if (duplicate) {
                    vm.saving = false;
                    vm.duplicateCategoryName = true;
                    vm.errorMessage = 'Category already exists.';
                    return;
                }

                saveCategory(name);
            }, function ()
            {
                vm.saving = false;
                vm.errorMessage = 'Unable to validate category name.';
                toastMessage.showSimpleToast(
                    vm.errorMessage,
                    'error-toast'
                );
            });
        }


        function saveCategory(name)
        {
            var request = vm.isEdit
                ? messageCenterService.updateTemplateCategory({
                    id: parseInt(category.id, 10),
                    name: name,
                    template_type: templateType,
                    is_active: vm.form.is_active
                })
                : messageCenterService.createTemplateCategory({
                    name: name,
                    template_type: templateType,
                    is_active: vm.form.is_active
                });

            request.then(function (response) {
                vm.saving = false;

                if (!response || response.success === false) {
                    vm.errorMessage = (response && response.message) || 'Unable to save category.';
                    toastMessage.showSimpleToast(vm.errorMessage, 'error-toast');
                    return;
                }

                $mdDialog.hide(response.data);
            }, function () {
                vm.saving = false;
                vm.errorMessage = 'Unable to save category.';
                toastMessage.showSimpleToast(vm.errorMessage, 'error-toast');
            });
        }

        function cancel()
        {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .controller('NewStaffConversationDialogController', NewStaffConversationDialogController);

    /** @ngInject */
    function NewStaffConversationDialogController(
        $mdDialog,
        toastMessage,
        messageCenterService,
        phoneFormatService,
        subHotelId,
        smsEnabled,
        whatsappEnabled
    )
    {
        var vm = this;

        vm.searchText = '';
        vm.loading = false;
        vm.staffMembers = [];
        vm.smsEnabled = smsEnabled !== false;
        vm.whatsappEnabled = whatsappEnabled !== false;
        vm.channel = vm.smsEnabled ? 'sms' : (vm.whatsappEnabled ? 'whatsapp' : 'sms');
        vm.creatingId = '';
        vm.errorMessage = '';
        vm.step = 'list';
        vm.selectedStaff = null;
        vm.customPhone = '';

        vm.onSearchChange = search;
        vm.selectStaff = selectStaff;
        vm.backToList = backToList;
        vm.setChannel = setChannel;
        vm.canStart = canStart;
        vm.startConversation = startConversation;
        vm.getStaffName = getStaffName;
        vm.getStaffInitials = getStaffInitials;
        vm.formatPhoneNumber = formatPhoneNumber;
        vm.updatePhoneWithCountryCode = updatePhoneWithCountryCode;
        vm.close = close;

        phoneFormatService.ensureUtilsLoaded();
        search();

        function formatPhoneNumber(phoneNumber)
        {
            return phoneFormatService.format(phoneNumber);
        }

        function updatePhoneWithCountryCode(fieldName)
        {
            phoneFormatService.updateValidity(fieldName);
        }

        function setChannel(channel)
        {
            if (channel === 'whatsapp' && !vm.whatsappEnabled) {
                return;
            }

            if (channel === 'sms' && !vm.smsEnabled) {
                return;
            }

            vm.channel = channel === 'whatsapp' ? 'whatsapp' : 'sms';
            vm.errorMessage = '';
        }

        function search()
        {
            if (vm.step !== 'list') {
                return;
            }

            vm.loading = true;
            vm.errorMessage = '';

            var params = {
                q: vm.searchText || ''
            };

            if (subHotelId) {
                params.sub_hotel_id = subHotelId;
            }

            messageCenterService.searchStaffRecipients(params).then(function (response) {
                vm.loading = false;

                if (!response || response.success === false) {
                    vm.staffMembers = [];
                    vm.errorMessage = (response && response.message) || 'Unable to search staff members.';
                    return;
                }

                vm.staffMembers = response.data || [];
            }, function () {
                vm.loading = false;
                vm.staffMembers = [];
                vm.errorMessage = 'Unable to search staff members.';
            });
        }

        function getStaffInitials(staff)
        {
            if (!staff) {
                return '?';
            }

            var first = (staff.first_name || '').charAt(0);
            var last = (staff.last_name || '').charAt(0);
            var initials = (first + last).toUpperCase();

            if (initials) {
                return initials;
            }

            var fallback = getStaffName(staff);
            return fallback ? fallback.charAt(0).toUpperCase() : '?';
        }

        function selectStaff(staff)
        {
            if (!staff || vm.creatingId) {
                return;
            }

            vm.errorMessage = '';
            vm.selectedStaff = staff;

            // Prefer the phone already bound to an existing conversation, then the
            // staff member's phone on file. Always show the confirm step so the user
            // can pick channel / edit phone and click Start conversation.
            var knownPhone = staff.existing_phone || staff.phone_number || '';

            if (staff.existing_channel === 'whatsapp' && vm.whatsappEnabled) {
                vm.channel = 'whatsapp';
            } else if (staff.existing_channel === 'sms' && vm.smsEnabled) {
                vm.channel = 'sms';
            }

            vm.customPhone = knownPhone;
            vm.step = 'phone';
        }

        function getStaffName(staff)
        {
            if (!staff) {
                return '';
            }

            var name = ((staff.first_name || '') + ' ' + (staff.last_name || '')).trim();
            return name || staff.existing_phone || staff.phone_number || staff.confirmation_number || '';
        }

        function startConversationWithPhone(staff, phone)
        {
            if (!staff || !phone || vm.creatingId) {
                return;
            }

            vm.errorMessage = '';
            vm.creatingId = staff.user_id || staff.confirmation_number;
            vm.step = 'phone';

            var payload = {
                staff_user_id: staff.user_id,
                guest_phone: phone,
                channel: vm.channel === 'whatsapp' ? 'whatsapp' : 'sms'
            };

            if (subHotelId) {
                payload.sub_hotel_id = subHotelId;
            }

            messageCenterService.startStaffConversation(payload).then(function (response) {
                vm.creatingId = '';

                if (!response || response.success === false) {
                    vm.errorMessage = (response && response.message) || 'Unable to start conversation.';
                    toastMessage.showSimpleToast(vm.errorMessage, 'error-toast');
                    return;
                }

                $mdDialog.hide({
                    thread: response.data && response.data.thread,
                    message: response.data && response.data.message,
                    confirmation_number: (response.data && response.data.thread && response.data.thread.confirmation_number) || staff.confirmation_number
                });
            }, function (error) {
                vm.creatingId = '';
                var response = (error && error.data) ? error.data : null;
                vm.errorMessage = (response && response.message) || 'Unable to start conversation.';
                toastMessage.showSimpleToast(vm.errorMessage, 'error-toast');
            });
        }

        function backToList()
        {
            vm.step = 'list';
            vm.selectedStaff = null;
            vm.errorMessage = '';
            vm.creatingId = '';
        }

        function canStart()
        {
            return !!(
                vm.selectedStaff &&
                phoneFormatService.getValidE164('gmc_new_staff_phone', vm.customPhone) &&
                !vm.creatingId
            );
        }

        function startConversation()
        {
            var staff = vm.selectedStaff;
            var phone = phoneFormatService.getValidE164('gmc_new_staff_phone', vm.customPhone);

            if (!staff || !phone || vm.creatingId) {
                phoneFormatService.updateValidity('gmc_new_staff_phone');
                vm.errorMessage = 'Enter a valid phone number with country code.';
                return;
            }

            vm.customPhone = phone;
            startConversationWithPhone(staff, phone);
        }

        function close()
        {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .controller('PhonePickerDialogController', PhonePickerDialogController);

    /** @ngInject */
    function PhonePickerDialogController($mdDialog, phoneFormatService, phoneOptions, channel, confirmationNumber)
    {
        var vm = this;
        var options = phoneOptions || {};

        vm.channel = channel || 'sms';
        vm.confirmationNumber = confirmationNumber || '';
        vm.phoneOptions = {
            customer: String(options.customer || '').replace(/^\s+|\s+$/g, ''),
            traveler: String(options.traveler || '').replace(/^\s+|\s+$/g, '')
        };
        vm.sendToSource = '';
        vm.customPhone = '';
        vm.errorMessage = '';

        vm.setSendToSource = setSendToSource;
        vm.getSelectedPhone = getSelectedPhone;
        vm.canConfirm = canConfirm;
        vm.confirm = confirm;
        vm.cancel = cancel;
        vm.formatPhoneNumber = formatPhoneNumber;
        vm.updatePhoneWithCountryCode = updatePhoneWithCountryCode;

        phoneFormatService.ensureUtilsLoaded();

        if (vm.phoneOptions.customer && !vm.phoneOptions.traveler) {
            vm.sendToSource = 'customer';
        } else if (vm.phoneOptions.traveler && !vm.phoneOptions.customer) {
            vm.sendToSource = 'traveler';
        }

        function formatPhoneNumber(phoneNumber)
        {
            return phoneFormatService.format(phoneNumber);
        }

        function updatePhoneWithCountryCode(fieldName)
        {
            phoneFormatService.updateValidity(fieldName);
        }

        function setSendToSource(source)
        {
            vm.sendToSource = source;
            vm.errorMessage = '';
        }

        function getSelectedPhone()
        {
            if (vm.sendToSource === 'customer') {
                return vm.phoneOptions.customer;
            }

            if (vm.sendToSource === 'traveler') {
                return vm.phoneOptions.traveler;
            }

            if (vm.sendToSource === 'custom') {
                return phoneFormatService.getValidE164(
                    'gmc_phone_picker_custom',
                    vm.customPhone
                );
            }

            return '';
        }

        function canConfirm()
        {
            return !!getSelectedPhone();
        }

        function confirm()
        {
            var phone = getSelectedPhone();

            if (!phone) {
                if (vm.sendToSource === 'custom') {
                    phoneFormatService.updateValidity('gmc_phone_picker_custom');
                    vm.errorMessage = 'Enter a valid phone number with country code.';
                } else {
                    vm.errorMessage = 'Pick a phone number to continue.';
                }
                return;
            }

            $mdDialog.hide({
                guest_phone: phone,
                source: vm.sendToSource
            });
        }

        function cancel()
        {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .controller('NewSmsConversationDialogController', NewSmsConversationDialogController);

    /** @ngInject */
    function NewSmsConversationDialogController(
        $mdDialog,
        toastMessage,
        messageCenterService,
        phoneFormatService,
        subHotelId,
        smsEnabled,
        whatsappEnabled
    )
    {
        var vm = this;

        vm.searchText = '';
        vm.loading = false;
        vm.reservations = [];
        vm.smsEnabled = smsEnabled !== false;
        vm.whatsappEnabled = whatsappEnabled !== false;
        vm.channel = vm.smsEnabled ? 'sms' : (vm.whatsappEnabled ? 'whatsapp' : 'sms');
        vm.creatingConfirmation = '';
        vm.errorMessage = '';
        vm.step = 'list';
        vm.selectedReservation = null;
        vm.phoneOptions = { customer: '', traveler: '' };
        vm.sendToSource = '';
        vm.customPhone = '';
        vm.loadingPhoneOptions = false;

        vm.onSearchChange = search;
        vm.selectReservation = selectReservation;
        vm.backToList = backToList;
        vm.setChannel = setChannel;
        vm.setSendToSource = setSendToSource;
        vm.getSelectedPhone = getSelectedPhone;
        vm.canStart = canStart;
        vm.startConversation = startConversation;
        vm.getGuestName = getGuestName;
        vm.getGuestInitials = getGuestInitials;
        vm.getStatusClass = getStatusClass;
        vm.formatPhoneNumber = formatPhoneNumber;
        vm.formatStayDateRange = formatStayDateRange;
        vm.updatePhoneWithCountryCode = updatePhoneWithCountryCode;
        vm.close = close;

        phoneFormatService.ensureUtilsLoaded();
        search();

        function formatPhoneNumber(phoneNumber)
        {
            return phoneFormatService.format(phoneNumber);
        }

        function updatePhoneWithCountryCode(fieldName)
        {
            phoneFormatService.updateValidity(fieldName);
        }

        function parseStayDate(value)
        {
            if (!value) {
                return null;
            }

            var trimmed = String(value).trim();
            if (!trimmed) {
                return null;
            }

            var parsed = moment(trimmed, [
                'MM/DD/YYYY',
                'M/D/YYYY',
                'MM/DD/YYYY HH:mm:ss',
                'M/D/YYYY HH:mm:ss',
                'YYYY-MM-DD',
                'YYYY-MM-DD HH:mm:ss',
                'YYYY/MM/DD',
                'DD-MM-YYYY',
                'DD/MM/YYYY',
                moment.ISO_8601
            ], true);

            if (parsed.isValid()) {
                return parsed;
            }

            parsed = moment(trimmed);

            return parsed.isValid() ? parsed : null;
        }

        function formatStayDateRange(checkIn, checkOut)
        {
            var inParsed = parseStayDate(checkIn);
            var outParsed = parseStayDate(checkOut);

            if (inParsed && outParsed) {
                if (inParsed.year() === outParsed.year()) {
                    return inParsed.format('MMM D') + ' \u2013 ' + outParsed.format('MMM D, YYYY');
                }

                return inParsed.format('MMM D, YYYY') + ' \u2013 ' + outParsed.format('MMM D, YYYY');
            }

            if (inParsed) {
                return inParsed.format('MMM D, YYYY');
            }

            if (outParsed) {
                return outParsed.format('MMM D, YYYY');
            }

            return '';
        }

        function setChannel(channel)
        {
            if (channel === 'whatsapp' && !vm.whatsappEnabled) {
                return;
            }

            if (channel === 'sms' && !vm.smsEnabled) {
                return;
            }

            vm.channel = channel === 'whatsapp' ? 'whatsapp' : 'sms';
            vm.errorMessage = '';
        }

        function search()
        {
            if (vm.step !== 'list') {
                return;
            }

            vm.loading = true;
            vm.errorMessage = '';

            var params = {
                q: vm.searchText || '',
                limit: 30
            };

            if (subHotelId) {
                params.sub_hotel_id = subHotelId;
            }

            messageCenterService.searchSmsRecipients(params).then(function (response) {
                vm.loading = false;

                if (!response || response.success === false) {
                    vm.reservations = [];
                    vm.errorMessage = (response && response.message) || 'Unable to search reservations.';
                    return;
                }

                vm.reservations = response.data || [];
            }, function () {
                vm.loading = false;
                vm.reservations = [];
                vm.errorMessage = 'Unable to search reservations.';
            });
        }

        function getGuestName(reservation)
        {
            if (!reservation) {
                return '';
            }

            var name = ((reservation.first_name || '') + ' ' + (reservation.last_name || '')).trim();
            return name || reservation.guest_phone || reservation.confirmation_number || '';
        }

        function getGuestInitials(reservation)
        {
            if (!reservation) {
                return '?';
            }

            var first = (reservation.first_name || '').charAt(0);
            var last = (reservation.last_name || '').charAt(0);
            var initials = (first + last).toUpperCase();

            if (initials) {
                return initials;
            }

            var fallback = getGuestName(reservation);
            return fallback ? fallback.charAt(0).toUpperCase() : '?';
        }

        function getStatusClass(status)
        {
            var value = String(status || '').toLowerCase().replace(/\s+/g, '-');

            if (value.indexOf('check') !== -1 && value.indexOf('in') !== -1) {
                return 'is-checked-in';
            }

            if (value.indexOf('check') !== -1 && value.indexOf('out') !== -1) {
                return 'is-checked-out';
            }

            if (value.indexOf('cancel') !== -1) {
                return 'is-canceled';
            }

            if (value.indexOf('active') !== -1 || value.indexOf('in-house') !== -1 || value.indexOf('arrive') !== -1) {
                return 'is-active';
            }

            return '';
        }

        function selectReservation(reservation)
        {
            if (!reservation || vm.creatingConfirmation || vm.loadingPhoneOptions) {
                return;
            }

            vm.errorMessage = '';
            vm.selectedReservation = reservation;
            vm.phoneOptions = { customer: '', traveler: '' };
            vm.sendToSource = '';
            vm.customPhone = '';
            vm.loadingPhoneOptions = true;
            vm.step = 'phone';

            var params = {
                confirmation_number: reservation.confirmation_number
            };

            if (subHotelId) {
                params.sub_hotel_id = subHotelId;
            }

            messageCenterService.getReservationMessagingContext(params).then(function (response) {
                vm.loadingPhoneOptions = false;

                if (!response || response.success === false) {
                    applyFallbackPhoneOptions(reservation);
                    return;
                }

                var data = response.data || {};
                var options = data.phone_options || response.phone_options || {};
                vm.phoneOptions = {
                    customer: String(options.customer || '').replace(/^\s+|\s+$/g, ''),
                    traveler: String(options.traveler || '').replace(/^\s+|\s+$/g, '')
                };

                // Reuse a number already linked to SMS/WhatsApp for this stay.
                var existingPhone = getExistingDirectPhoneFromContext(data, vm.channel);

                if (existingPhone) {
                    startConversationWithPhone(reservation, existingPhone);
                    return;
                }

                if (!vm.phoneOptions.customer && !vm.phoneOptions.traveler) {
                    applyFallbackPhoneOptions(reservation);
                } else {
                    autoSelectSinglePhone();
                }
            }, function () {
                vm.loadingPhoneOptions = false;
                applyFallbackPhoneOptions(reservation);
            });
        }

        function getExistingDirectPhoneFromContext(data, preferredChannel)
        {
            data = data || {};
            var channels = data.channels || {};
            var preferred = preferredChannel === 'whatsapp' ? 'whatsapp' : 'sms';
            var other = preferred === 'whatsapp' ? 'sms' : 'whatsapp';
            var phone = '';

            if (channels[preferred] && channels[preferred].guest_phone_e164) {
                phone = channels[preferred].guest_phone_e164;
            } else if (channels[other] && channels[other].guest_phone_e164) {
                phone = channels[other].guest_phone_e164;
            } else if ((channels.sms && channels.sms.conversation_sid) ||
                (channels.whatsapp && channels.whatsapp.conversation_sid)) {
                phone = data.guest_phone || '';
            }

            return String(phone || '').replace(/^\s+|\s+$/g, '');
        }

        function startConversationWithPhone(reservation, guestPhone)
        {
            if (!reservation || !guestPhone || vm.creatingConfirmation) {
                return;
            }

            vm.errorMessage = '';
            vm.creatingConfirmation = reservation.confirmation_number;
            vm.step = 'phone';
            vm.loadingPhoneOptions = false;

            var payload = {
                confirmation_number: reservation.confirmation_number,
                guest_phone: guestPhone,
                channel: vm.channel === 'whatsapp' ? 'whatsapp' : 'sms'
            };

            if (subHotelId) {
                payload.sub_hotel_id = subHotelId;
            }

            messageCenterService.startSmsConversation(payload).then(function (response) {
                vm.creatingConfirmation = '';

                if (!response || response.success === false) {
                    vm.errorMessage = (response && response.message) || 'Unable to start conversation.';
                    toastMessage.showSimpleToast(vm.errorMessage, 'error-toast');
                    // Keep phone step so staff can pick another number if auto-reuse failed.
                    if (!vm.phoneOptions.customer && !vm.phoneOptions.traveler) {
                        applyFallbackPhoneOptions(reservation);
                    } else {
                        autoSelectSinglePhone();
                    }
                    return;
                }

                $mdDialog.hide({
                    thread: response.data && response.data.thread,
                    message: response.data && response.data.message,
                    confirmation_number: reservation.confirmation_number
                });
            }, function (error) {
                vm.creatingConfirmation = '';
                var response = (error && error.data) ? error.data : null;
                vm.errorMessage = (response && response.message) || 'Unable to start conversation.';
                toastMessage.showSimpleToast(vm.errorMessage, 'error-toast');

                if (!vm.phoneOptions.customer && !vm.phoneOptions.traveler) {
                    applyFallbackPhoneOptions(reservation);
                } else {
                    autoSelectSinglePhone();
                }
            });
        }

        function applyFallbackPhoneOptions(reservation)
        {
            var phone = reservation && reservation.guest_phone
                ? String(reservation.guest_phone).replace(/^\s+|\s+$/g, '')
                : '';

            vm.phoneOptions = {
                customer: phone,
                traveler: ''
            };
            autoSelectSinglePhone();
        }

        function autoSelectSinglePhone()
        {
            if (vm.phoneOptions.customer && !vm.phoneOptions.traveler) {
                vm.sendToSource = 'customer';
            } else if (vm.phoneOptions.traveler && !vm.phoneOptions.customer) {
                vm.sendToSource = 'traveler';
            }
        }

        function backToList()
        {
            vm.step = 'list';
            vm.selectedReservation = null;
            vm.errorMessage = '';
            vm.creatingConfirmation = '';
        }

        function setSendToSource(source)
        {
            vm.sendToSource = source;
            vm.errorMessage = '';
        }

        function getSelectedPhone()
        {
            if (vm.sendToSource === 'customer') {
                return vm.phoneOptions.customer;
            }

            if (vm.sendToSource === 'traveler') {
                return vm.phoneOptions.traveler;
            }

            if (vm.sendToSource === 'custom') {
                return phoneFormatService.getValidE164(
                    'gmc_new_sms_custom_phone',
                    vm.customPhone
                );
            }

            return '';
        }

        function canStart()
        {
            return !!(vm.selectedReservation && getSelectedPhone() && !vm.creatingConfirmation && !vm.loadingPhoneOptions);
        }

        function isPhoneLinkedError(response)
        {
            if (!response) {
                return false;
            }

            return response.code === 'phone_linked_to_other_reservation' ||
                response.code === 'phone_linked_to_staff_contact' ||
                (response.data && (
                    response.data.code === 'phone_linked_to_other_reservation' ||
                    response.data.code === 'phone_linked_to_staff_contact'
                ));
        }

        function startConversation()
        {
            var reservation = vm.selectedReservation;
            var guestPhone = getSelectedPhone();

            if (!reservation || !guestPhone || vm.creatingConfirmation) {
                if (vm.sendToSource === 'custom') {
                    phoneFormatService.updateValidity('gmc_new_sms_custom_phone');
                    vm.errorMessage = 'Enter a valid phone number with country code.';
                } else if (!guestPhone) {
                    vm.errorMessage = 'Pick a phone number to continue.';
                }
                return;
            }

            startConversationWithPhone(reservation, guestPhone);
        }

        function close()
        {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
	'use strict';

	angular
	.module('app.permissions.roles')
	.controller('ProductControllers', ProductControllers);

	/** @ngInject */
	function ProductControllers($mdDialog, Product, Products, Types, toastMessage, $localStorage, $scope, eCommerceService){
		var vm = this;
		// Data
		vm.title = 'edit';
		vm.product	= angular.copy(Product);
		vm.products = Products;
		vm.newproduct = false;
		vm.isloading = false;
		vm.uniqueName = false;
		vm.types = Types;
		vm.autoFillOff = true;
		vm.showOrganisationDropDown = $localStorage.roleId;
		if ( Object.keys(vm.product).length == 0 )
		{
			vm.product = {};
			vm.title = 'add';
			vm.newproduct = true;
		}
		

		// Methods
		vm.saveProduct = saveProduct;
		vm.updateProduct = updateProduct;
		vm.closeDialog = closeDialog;
		vm.checkUniqueNameWithCheck = checkUniqueNameWithCheck;
		vm.checkUniqueName = checkUniqueName;

		//////////

		/**
		 * Add new contact
		 */
		 function saveProduct()
		 {
			 if(vm.uniqueName == true){
                toastMessage.showSimpleToast('Category name already exists. Pease try another.','error-toast');
            }else{
            	vm.product.product_type = 'room';
            	vm.product.product_is_timebound = 1;
				 vm.isloading = true;
				 var data = {selectedHotel: $localStorage.hotels[$localStorage.selectedHotel].hotel_id,product:vm.product};
				eCommerceService.saveProduct(data)
				.then(function(response){
					vm.isloading = false;
					if(response.success){
						$mdDialog.hide();
						$scope.updateTable();
					}else {
						toastMessage.showSimpleToast('There was some error in saving product.','error-toast');
					}
				});
			}
		 }

		 function updateProduct()
		 {
			 if(vm.uniqueName == true){
                toastMessage.showSimpleToast('Category name already exists. Pease try another.','error-toast');
            }else{
			 if(!vm.newproduct){
				 vm.isloading = true;
				eCommerceService.updateProduct(vm.product)
				.then(function(response){
					vm.isloading = false;
					if(response.success){
						$scope.updateTable();
					}else {
						toastMessage.showSimpleToast('There was some error in saving product.','error-toast');
					}
				}); 
			 }
			}
		 }
		function checkUniqueNameWithCheck(){
			if(!vm.newproduct){
				checkUniqueName();
				setTimeout(function(){
					if(vm.uniqueName){
						return false;
					}
					updateProduct();
				},500);
			}
		}
		function checkUniqueName(){

            if(vm.product.product_name){
				if(vm.product.product_id){
					var data = {'product_id':vm.product.product_id,'product_name':vm.product.product_name,'hotel_id':$localStorage.hotels[$localStorage.selectedHotel].hotel_id};
				}else{
					var data = {'product_name':vm.product.product_name,'hotel_id':$localStorage.hotels[$localStorage.selectedHotel].hotel_id};
				}
                vm.uniqueName = false;
                eCommerceService.checkUnique(data)
                .then(function(response){
                    if(response.exists){
                        vm.uniqueName = true;
                    }else{
						vm.uniqueName = false;
					}
                });
            }
        }
		/**
		 * Close dialog
		 */
		 function closeDialog()
		 {
		 	$mdDialog.hide();
		 }

		setTimeout(function() {
           vm.autoFillOff = false;
       	}, 1500); 
		}
	})();

(function () {
  "use strict";

  angular
    .module("app.e-commerce")
    .controller("OrderController", OrderController);

  /** @ngInject */
  function OrderController(
    Order,
    Reservation_id,
    toastMessage,
    $mdSidenav,
    $state,
    eCommerceService,
    $scope,
    $window,
    $mdDialog,
    ganttChartService,
    checkoutService,
    $timeout,
    $document,
    commonService,
    EnvironmentConfig,
    $translate,
    createResService,
    $stateParams,
    $location,
    $sessionStorage,
    $anchorScroll,
    $rootScope,
    userService,
    $q,
    $http,
    commonDailog,
    $localStorage,
    Upload,
    $compile,
    ganttChartServiceNew,
    messageCenterService
  ) {
    /* Variables & initializations */

    var vm = this;

        vm.isBorrowedItemsEnabled = function () {
            if ($localStorage && $localStorage.hotelgeneralsetting && typeof $localStorage.hotelgeneralsetting.enableBorrowedItems !== 'undefined') {
                return $localStorage.hotelgeneralsetting.enableBorrowedItems == '1';
            }
            return false;
        };

    // vm.emailFormat = /^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/;
    vm.showCustomerTravellerBillInfo = false;
    vm.abc = false;
    vm.posweekOverallTotalArray = [];
    vm.posweekPaidValuesArray = [];
    vm.posweekOwesValuesArray = [];
    vm.posmonthOverallTotalArray = [];
    vm.loader = [];
    var customFlag = true;

    vm.resortFeeAppliedVisible = true;
    vm.autoFillOff = true;
    var autoFillData = {};
    vm.baseUrl = EnvironmentConfig.api;

    vm.superAdmin = false;
    vm.showPaymentOptions =
      Order.response != undefined &&
      Order.response.showPaymentOptions !== undefined
        ? Order.response.showPaymentOptions
        : true;

    if ($localStorage.roleId == 1) {
      vm.superAdmin = true;
    }

    vm.phoneDisplay = {
      customer_phone:
        Order.response && Order.response.reservation_customer
          ? Order.response.reservation_customer.phone_number || ""
          : "",
      customer_secondary_phone:
        Order.response && Order.response.reservation_customer
          ? Order.response.reservation_customer.secondary_phone_number || ""
          : "",
      traveller_phone:
        Order.response && Order.response.reservations
          ? Order.response.reservations.phone_number || ""
          : "",
      traveller_secondary_phone:
        Order.response && Order.response.reservations
          ? Order.response.reservations.secondary_phone_number || ""
          : "",
    };

    vm.saveReservationColor = saveReservationColor;
    vm.colorPickerApi = {};
    vm.options = {
      restrictToFormat: true,
      format: 'hexString',
      hue: true,
      saturation: true,
      lightness: true,
      disabled: vm.disableColorPicker
    };

    vm.eventApi = {
      onChange: function(api, color, $event) {
          vm.order.color_code = color;
          vm.saveReservationColor();
      }
    };

    function saveReservationColor() {
        var data = {
            reservation_id: vm.order.reserv_id,
            color_code: vm.order.color_code
        };

        eCommerceService.saveReservationColor(data).then(function(response) {
            if (response && response.success) {
              // vm.colorPickerApi.close();
              return;
            } else {
              toastMessage.showSimpleToast(
                  "Unable to save color.",
                  "error-toast"
              );
            }
        });
    }

    /* Open Message Center for this room — MC opens existing chat or handles new. */

    vm.canMessageGuest = canMessageGuest;
    vm.messageGuest = messageGuest;

    var messageCenterPhoneSyncPromptOpen = false;

    function canMessageGuest() {
      // Same gate as sidebar Message Center → Messages (index.route.js).
      // Permissions are hotel-scoped, so this is hotel-wise + permission-wise.
      var perms = $rootScope.userPermissions || "";

      if (!perms) {
        return false;
      }

      return (
        perms.indexOf("All") !== -1 ||
        perms.indexOf("messages") !== -1
      );
    }

    function normalizePhoneDigits(phone) {
      return String(phone || "").replace(/\D+/g, "");
    }

    function phonesAreSame(phoneA, phoneB) {
      var a = normalizePhoneDigits(phoneA);
      var b = normalizePhoneDigits(phoneB);

      if (!a || !b) {
        return false;
      }

      if (a === b) {
        return true;
      }

      // Match local vs E.164 when one side has a country code.
      if (a.length >= 10 && b.length >= 10) {
        return a.slice(-10) === b.slice(-10);
      }

      return false;
    }

    function getOpenDirectChatPhones(context) {
      var channels = (context && context.channels) || {};
      var phones = [];
      var keys = ["sms", "whatsapp"];
      var i;
      var channel;
      var phone;

      for (i = 0; i < keys.length; i++) {
        channel = channels[keys[i]];
        if (!channel || channel.is_closed) {
          continue;
        }

        phone = String(channel.guest_phone_e164 || "").trim();
        if (phone) {
          phones.push(phone);
        }
      }

      return phones;
    }

    function updateMessageCenterGuestPhone(confirmationNumber, guestPhone) {
      return messageCenterService
        .updateGuestPhone({
          confirmation_number: confirmationNumber,
          guest_phone: guestPhone,
          source: 'reservation_detail'
        })
        .then(function (response) {
          if (!response || response.success === false) {
            if (isPhoneLinkedError(response)) {
              toastMessage.showSimpleToast(
                (response && response.message) ||
                  "This phone number is already linked to another conversation.",
                "error-toast"
              );
              return $q.reject(response);
            }

            toastMessage.showSimpleToast(
              (response && response.message) ||
                "Unable to update phone in Message Center.",
              "error-toast"
            );
            return $q.reject(response);
          }

          toastMessage.showSimpleToast(
            "Message Center chat phone updated.",
            "success-toast"
          );
          return response;
        });
    }

    function confirmUpdateMessageCenterChatPhone(chatPhone, newPhone) {
      var currentLabel = vm.formatPhoneNumber
        ? vm.formatPhoneNumber(chatPhone)
        : chatPhone;
      var newLabel = vm.formatPhoneNumber
        ? vm.formatPhoneNumber(newPhone)
        : newPhone;
      var html =
        "This guest has an active Message Center chat on <b>" +
        (currentLabel || chatPhone) +
        "</b>.<br/><br/>" +
        "Do you want to update the Message Center chat phone to <b>" +
        (newLabel || newPhone) +
        "</b>?";

      return $mdDialog.show({
        controller: "confirmController",
        controllerAs: "vm",
        templateUrl:
          "app/main/apps/contacts/confirmationPopUp/confirmation.html",
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          title: "Update Message Center phone?",
          htmlContent: html,
          cancelBtn: "No",
          OkBtn: "Yes, update",
        },
      });
    }

    /**
     * After reservation guest phone save: if an open SMS/WhatsApp chat uses a
     * different number, ask whether to sync Message Center too.
     */
    function maybePromptUpdateMessageCenterChatPhone(confirmationNumber, newPhone) {
      var conf = String(confirmationNumber || "").trim();
      var phone = String(newPhone || "").trim();

      if (
        !conf ||
        !phone ||
        !canMessageGuest() ||
        messageCenterPhoneSyncPromptOpen
      ) {
        return;
      }

      messageCenterPhoneSyncPromptOpen = true;

      messageCenterService
        .getReservationMessagingContext({
          confirmation_number: conf,
        })
        .then(function (response) {
          var context =
            response && response.success !== false && response.data
              ? response.data
              : null;
          var openPhones = getOpenDirectChatPhones(context);
          var mismatchedPhone = "";
          var i;

          if (!openPhones.length) {
            return;
          }

          for (i = 0; i < openPhones.length; i++) {
            if (!phonesAreSame(openPhones[i], phone)) {
              mismatchedPhone = openPhones[i];
              break;
            }
          }

          if (!mismatchedPhone) {
            return;
          }

          return confirmUpdateMessageCenterChatPhone(
            mismatchedPhone,
            phone
          ).then(function (answer) {
            if (answer === "update") {
              return updateMessageCenterGuestPhone(conf, phone);
            }
          });
        })
        .catch(function () {
          // Ignore cancel / context failures — reservation phone already saved.
        })
        .finally(function () {
          messageCenterPhoneSyncPromptOpen = false;
        });
    }

    function isPhoneLinkedError(response) {
      if (!response) {
        return false;
      }

      return (
        response.code === "phone_linked_to_other_reservation" ||
        (response.data &&
          response.data.code === "phone_linked_to_other_reservation")
      );
    }

    function messageGuest(confirmationNumber) {
      confirmationNumber = String(
        confirmationNumber ||
          (vm.order && vm.order.confirmation_number) ||
          ""
      ).trim();

      if (!confirmationNumber) {
        toastMessage.showSimpleToast(
          "No confirmation number found for this room.",
          "error-toast"
        );
        return;
      }

      var url = $state.href("app.guest-message-center.messages", {
        confirmation_number: confirmationNumber,
      });
      $window.open(url, "_blank");
    }

    vm.initializeOrderPosData = initializeOrderPosData;
    vm.dateModifiedBoth = dateModifiedBoth;

    vm.pageType = $stateParams["page_type"];
    if (vm.pageType == "boat") {
      vm.title = "ADD_BOAT_PLUS";
    } else {
      vm.title = "ADD_ROOM_PLUS";
    }
    vm.currentHotelId = $localStorage.preHotelId;

    vm.boatArrayFinal = [];
    vm.posArrayFinal = [];
    vm.stateStatus = false;
    vm.processRequest = false;
    vm.processRequest = true;
    vm.reservation_id = Reservation_id;
    vm.resvStatus = {
      Active: "Active",
      "Waiting for Room": "Waiting for Room",
      "Checked-In": "Check-In",
      "Checked-Out": "Check-Out",
      Closed: "Close",
      Canceled: "Cancel",
      "No Show": "No Show",
    };
    vm.statuses = vm.resvStatus;
    vm.pos_status = [];
    vm.dates_option = EnvironmentConfig.cc_dates_option;
    // vm.yrs_option = EnvironmentConfig.cc_yrs_option;
    vm.roomCount = 1;
    vm.ct = "";
    vm.trigDivStatus = true;
    vm.boatType = [
      { name: "Power Boat", value: "powerboat" },
      { name: "Sailboat", value: "sailboat" },
    ];
    //~ var Order = {};
    vm.modify_request = false;
    vm.refundStart = false;
    vm.myDate = new Date();
    vm.minDate = new Date(
      vm.myDate.getFullYear(),
      vm.myDate.getMonth(),
      vm.myDate.getDate()
    );
    vm.endDateMin = new Date(
      vm.myDate.getFullYear(),
      vm.myDate.getMonth(),
      vm.myDate.getDate()
    );
    vm.dtOptionsForPayment = {
      autoWidth: false,
      responsive: true,
      paging: false,
      searching: false,
      order: [8, "asc"],
      oLanguage: { sEmptyTable: "No installments paid yet." },
      columnDefs: [
        {
          // Target the Action column
          targets: 7,
          filterable: false,
          responsivePriority: 1,
          sortable: false,
        },
        {
          // Target the paid date column
          targets: 1,
          type: "date",
          sortable: true,
          render: function (data, type, row, meta) {
            var formattedDate = {
              newDate: data.split(" ")[0],
              newTime: data.split(" ")[1],
              newSession: data.split(" ")[2],
            };
            var newDateFormatted =
              formattedDate.newDate.split("-")[2] +
              "-" +
              formattedDate.newDate.split("-")[0] +
              "-" +
              formattedDate.newDate.split("-")[1];

            var newTimeFormatted = {
              Hours:
                parseInt(formattedDate.newTime.split(":")[0]) < 10
                  ? "0" + parseInt(formattedDate.newTime.split(":")[0])
                  : parseInt(formattedDate.newTime.split(":")[0]),
              Minutes:
                parseInt(formattedDate.newTime.split(":")[1]) < 10
                  ? "0" + parseInt(formattedDate.newTime.split(":")[1])
                  : parseInt(formattedDate.newTime.split(":")[1]),
              Sec:
                parseInt(formattedDate.newTime.split(":")[2]) < 10
                  ? "0" + parseInt(formattedDate.newTime.split(":")[2])
                  : parseInt(formattedDate.newTime.split(":")[2]),
            };
            var ThisDate = moment(
              newDateFormatted +
                " " +
                newTimeFormatted.Hours +
                ":" +
                newTimeFormatted.Minutes +
                ":" +
                newTimeFormatted.Sec +
                " " +
                formattedDate.newSession
            ).format("MM-DD-YYYY hh:mm:ss A");
            return ThisDate;
          },
        },
      ],
    };

    $timeout(function () {
      if (
        vm.order != undefined &&
        typeof vm.order.reserv_id != "undefined" &&
        typeof $localStorage[
          $localStorage.preHotelId + vm.order.reserv_id + "splitPopUp"
        ] != "undefined" &&
        $localStorage[
          $localStorage.preHotelId + vm.order.reserv_id + "splitPopUp"
        ]
      ) {
        vm.roomMoveStart(
          "",
          vm.order.room_stay_from,
          vm.order.room_stay_to,
          vm.order.room_stay_guest_count,
          vm.order.room_stay_child_count,
          vm.order.room_stay_id,
          vm.order.product_id,
          vm.order.product_name,
          vm.order.policy_id,
          vm.order.confirmation_number,
          vm.reservation_id,
          vm.itinerary_number
        );
      } else if (
        vm.order != undefined &&
        typeof vm.order.reserv_id != "undefined" &&
        typeof $localStorage[
          $localStorage.preHotelId + vm.order.reserv_id + "consolidatePopup"
        ] != "undefined" &&
        $localStorage[
          $localStorage.preHotelId + vm.order.reserv_id + "consolidatePopup"
        ]
      ) {
        vm.consolidateButtons();
      }

      if (vm.order != undefined) {
        $localStorage[
          $localStorage.preHotelId + vm.order.reserv_id + "splitPopUp"
        ] = false;
        $localStorage[
          $localStorage.preHotelId + vm.order.reserv_id + "consolidatePopup"
        ] = false;
      }
    }, 0);

    vm.getReservationsPromoList = function (promotionAppliedProducts) {
      if (
        !Array.isArray(promotionAppliedProducts) ||
        promotionAppliedProducts.length === 0
      ) {
        return {};
      }

      const reservationProduct = promotionAppliedProducts.find(
        (element) => element && element.name === "reservation"
      );

      return reservationProduct && reservationProduct.list
        ? reservationProduct.list
        : {};
    };

    vm.customerSameAsTraveller = false;
    vm.commentsSpecial = {
      comment: [],
      special_request: [],
      posComment: [],
    };
    vm.masonryOptions = {
      columnCount: 3,
      responsive: {
        sm: 2,
        xs: 1,
      },
    };

    vm.resortFeeApplied = {};

    vm.allRoomCancelled = false;
    var cancelledCount = 0;
    vm.selectedIndex = 0;
    vm.use_existingcard = "";
    vm.notCardType = "";
    vm.payingFromGC = {};
    vm.innerSlectedIndex = 0;
    vm.customeropened = false;
    vm.customerCardExpanded = false;
    vm.customerCardTabIndex = 0;
    vm.customerCardReservations = {
      heading: ["Room", "Checkin", "Checkout", "Total", "ADR", "Created Date", "Source"],
      data: [],
      totalResv: 0,
      isloading: false,
      loadedForId: null,
    };
    vm.customerCardNotes = {
      data: [],
      isloading: false,
      loadedForId: null,
    };
    vm.newCustomerNoteText = "";
    vm.traveleropened = false;
    vm.incidentalrequestGoing = false;
    vm.removeCcProcessingFeeRoom = false;
    vm.ccProcessingFeeRemovingRoom = false;
    vm.removeCcProcessingFeePos = {};
    vm.ccProcessingFeeRemovingPos = {};
    vm.roundUpForCharityDeletingPos = {};
    vm.ccProcessingFeeApplicableByConfirmation = {};
    vm.previousPaymentMethod = "";
    vm.handlingPaymentMethodChange = false;
    vm.showDiscountEdit = false;
    vm.tempData = { 0: "data" };
    vm.comment = vm.request = "";
    vm.isloading = true;
    vm.changingStatus = false;
    vm.changeStatusData = {};
    vm.print_data = false;
    vm.print_show_div = false;
    vm.showModifyBtn = false;
    vm.modificationComments = [];
    vm.paymentrequestGoing = false;
    vm.gcrequestGoing = false;
    vm.promoRequestGoing = false;
    vm.mainTabChangedAuto = false;
    vm.orderEmailUpdated = false;
    vm.reservationEmailUpdated = false;
    vm.latestPaymentMethod = "";
    var simulateQuery = false;
    var countryList = [];
    var userPermissions = [];
    var originalOrderData = {};
    vm.parking_access = false;
    vm.print_registration = false;
    vm.showSliderControlls = false;
    var left = 0;
    var width;
    var tabsCount;
    var visibleOnScreen;
    var maxLeftAssign;
    vm.documents = [];
    vm.emptyDocs = false;
    vm.progress = false;
    vm.uploading = false;
    vm.systemTags = [];
    vm.hotelTags = [];
    vm.assignedTags = [];
    vm.tempAssignedTags = [];
    vm.billingAssignedTags = [];
    vm.travellerAssignedTags = [];
    vm.systemTagSearch = '';
    vm.hotelTagSearch = '';
    vm.isCustomerTagsLoading = true;

    // Customer Family Members
    vm.maxDateOfBirth = new Date();
    vm.customerFamilyMembers = {
      isloading: false,
      data: []
    };
    vm.familyMemberForm = {
      first_name: '',
      last_name: '',
      customer_email: '',
      phone_number: '',
      date_of_birth: null,
      relationship_status: '',
      other_relationship: ''
    };
    vm.isSavingFamilyMember = false;
    vm.editingFamilyMember = null;
    vm.isUpdatingFamilyMember = false;
    vm.showFamilyMemberForm = false;
    vm.relationshipTypes = [];
    vm.familyMemberSearch = {
        first_name: '',
        last_name: '',
        customer_email: ''
    };
    vm.selectedFamilyMemberSearch = {
        first_name: null,
        last_name: null,
        customer_email: null
    };

    // Customer Pets
    vm.customerPets = {
      isloading: false,
      data: []
    };
    vm.customerPetForm = {
      name: '',
      pet_type_id: null,
      other_pet_type: '',
      date_of_birth: null
    };
    vm.petTypes = {
      isloading: false,
      data: []
    };
    vm.otherPetTypeId = null;
    vm.editingCustomerPet = null;
    vm.isSavingCustomerPet = false;
    vm.isUpdatingCustomerPet = false;

    vm.getCustomerTags = getCustomerTags;
    vm.unassignedTagsFilter = unassignedTagsFilter;
    vm.tagDialogTarget = null;

    /* Variables & initializations */

    /* Permissions Checks */
    if (typeof $rootScope.userPermissions != "undefined") {
      userPermissions = $rootScope.userPermissions;
      if (userPermissions.indexOf("timebound_parking") != -1) {
        vm.parking_access = true;
      }
      if (userPermissions.indexOf("registration_card") != -1) {
        vm.print_registration = true;
      }
    }
    /* Permissions Checks */

    /* Initial Data for view page */
    if (
      Order.success &&
      Order.response &&
      Order.response.itinerary_number &&
      Order.response.itinerary_number != "undefined"
    ) {
      if (
        Order["response"]["reservation_customer"]["customer_id"] ==
        Order["response"]["reservations"]["customer_id"]
      ) {
        vm.customerSameAsTraveller = true;
      }
      Order.response.tabs_data.forEach(function (element, index) {
        if (element["room_stay_status"] == "Canceled") {
          cancelledCount++;
        }
      });
      if (cancelledCount == Order.response.tabs_data.length) {
        vm.allRoomCancelled = true;
      }

      vm.roomCount = Order.response.room_stay_reservation;
      vm.extraPersonPos = Order["response"]["extraPersonPos"];
      vm.is_child_allowed = Order["response"]["is_child_allowed"];
      vm.order = Order.response.reservations;
      angular.forEach(vm.order && vm.order.pos, function (pos) {
        if (pos.extra_settings && typeof pos.extra_settings === "string") {
          pos.extra_settings = JSON.parse(pos.extra_settings);
        }
      });

      vm.initializeOrderPosData(vm.order);
      syncCcProcessingFeeCheckboxes();

      if (
        vm.order.hasOwnProperty("boat_data") &&
        Object.keys(vm.order.boat_data).length > 0
      ) {
        vm.boatData = vm.order.boat_data;
      }
      vm.order["extraPersonPos"] = Order["response"]["extraPersonPos"];
      vm.order["tax_exempt_indicator"] =
        Order["response"]["reservations"]["tax_exempt_status"] == 1
          ? true
          : false;

      vm.resortFeeApplied[vm.selectedIndex] =
        Order["response"]["reservations"]["resortFeeApplied"];
      vm.resortFeeAppliedVisible =
        Order["response"]["reservations"]["resortFeeAppliedVisible"];

      vm.order.send_email_indicator =
        vm.order.send_email_indicator == 1 ? true : false;
      vm.allowed_card_types = Order.response.allowed_card_types;
      applyWaitingDisplayStatus();
      if (vm.order && vm.order.show_status) {
        vm.statuses[vm.order.show_status] = vm.order.show_status;
      }
      setAllStatuses();
      vm.tabs_data = Order.response.tabs_data;
      if ($stateParams.confirmation_number != "") {
        var confirmation_number = $stateParams.confirmation_number;
        angular.forEach(vm.tabs_data, function (value, key) {
          if (value.confirmation_number == $stateParams.confirmation_number) {
            vm.selectedIndex = key;
            vm.resortFeeApplied[vm.selectedIndex] =
              Order["response"]["reservations"]["resortFeeApplied"];
            vm.mainTabChangedAuto = true;
            if ($stateParams.changeStatusData == "") {
              vm.showPaymentsLoader = true;
              $timeout(function () {
                vm.isloading = false;
                fetchPaymentsInformation(
                  confirmation_number,
                  vm.order.first_name,
                  vm.order.last_name,
                  vm.order.total_amount,
                  vm.order.overalltotals.remaining_amount
                );
                originalOrderData = angular.copy(vm.order);
              }, 2000);
            } else {
              vm.changingStatus = true;
              vm.changeStatusData = $stateParams.changeStatusData;
              vm.showPaymentsLoader = true;
              $location.hash("data-table-" + key);
              $mdDialog.hide();
              $timeout(function () {
                $window.location.hash = "";
                vm.isloading = false;
                fetchPaymentsInformation(
                  confirmation_number,
                  vm.order.first_name,
                  vm.order.last_name,
                  vm.order.total_amount,
                  vm.order.overalltotals.remaining_amount
                );
                originalOrderData = angular.copy(vm.order);
              }, 2000);
            }
          }
          if (value.product_name.toLowerCase().includes("walk")) {
            vm.tabs_data[key]["product_room_number"] = value.product_name;
          }
        });
      } else {
        var confirmation_number = vm.order.confirmation_number;
        vm.showPaymentsLoader = true;
        $timeout(function () {
          vm.isloading = false;
          fetchPaymentsInformation(
            confirmation_number,
            vm.order.first_name,
            vm.order.last_name,
            vm.order.total_amount,
            vm.order.overalltotals.remaining_amount
          );
          originalOrderData = angular.copy(vm.order);
        }, 2000);
      }
      var Country = Order.response.countries;
      Country.forEach(function (element) {
        countryList.push(element.name);
      });
      var myCountryArr = loadAll();
      var testData = angular.copy(Order.response.reservation_customer);
      vm.all_payment_methods = Order.response.payment_methods;
      vm.reservation_customer = Order.response.reservation_customer;
      vm.orig_reservation_customer = angular.copy(
        Order.response.reservation_customer
      );
      vm.isCustomerTagsLoading = true;
      loadBillingAndTravellerTags().finally(function () {
        vm.isCustomerTagsLoading = false;
      });

      if (vm.reservation_customer.country) {
        vm.selectedCountry = {
          value: vm.reservation_customer.country.toLowerCase(),
          display: vm.reservation_customer.country,
        };
      }
      $timeout(function () {
        vm.reservation_customer.state = testData.state;
        if (vm.reservation_customer.state) {
          vm.selectedState = vm.reservation_customer.state;
          var test12 = angular.copy(vm.reservation_customer.state);
          updateCustomer("state", "");
        }
        vm.stateStatus = true;
        vm.reservation_customer.state = testData.state;
        vm.reservation_customer.send_email_indicator =
          vm.reservation_customer.send_email_indicator == 1 ? true : false;
        vm.reservation_customer.tax_exempt_indicator =
          Order["response"]["reservations"]["tax_exempt_status"] == 1
            ? true
            : false;

        if (typeof Order["response"]["reservations"] != "undefined") {
          vm.adultRange = vm.getRangeArray(
            1,
            parseInt(Order["response"]["reservations"]["max_occupancy"]) -
              vm.order.room_stay_child_count
          );
          vm.childRange = vm.getRangeArray(
            0,
            parseInt(Order["response"]["reservations"]["max_occupancy"]) -
              vm.order.room_stay_guest_count
          );
        }
        /* code for top tabs slider */
        width = jQuery(".labels-blockclick-outer").width() - 60;
        tabsCount = parseInt(Object.keys(vm.tabs_data).length);
        visibleOnScreen = Math.ceil(parseInt(width) / parseInt(90));
        maxLeftAssign =
          parseInt(parseInt(tabsCount) - parseInt(visibleOnScreen)) * 90;
        maxLeftAssign = parseInt(parseInt(maxLeftAssign) + 30);
        if (visibleOnScreen < tabsCount) {
          vm.showSliderControlls = true;
        } else {
          vm.showSliderControlls = false;
        }
        if (vm.selectedIndex > visibleOnScreen) {
          left =
            -parseInt(
              parseInt(parseInt(vm.selectedIndex) - parseInt(visibleOnScreen)) +
                1
            ) * 90;
          left = parseInt(left - 50);
          jQuery(".labels-blockclick").css("left", left + "px");
        }
        /* code for top tabs slider */
      }, 3000);

      vm.arrival_departure_time = Order.response.arrival_departure_time;
      vm.itinerary_number = Order.response.itinerary_number;
      vm.payment_method = {};
      var count = 0;
      vm.fieldsIsReadOnly = false;

      vm.source_of_creation =
        vm.order.source_of_creation == "FE" ||
        vm.order.source_of_creation == "PMS"
          ? ""
          : vm.order.source_of_creation;
      vm.siteminder_id = vm.order.siteminder_id;
      if (
        vm.source_of_creation == "FE" ||
        vm.source_of_creation == "PMS" ||
        typeof vm.source_of_creation == "undefined" ||
        typeof vm.siteminder_id == "undefined"
      ) {
        vm.headerPart = "";
      } else {
        vm.headerPart =
          vm.source_of_creation == ""
            ? ""
            : vm.source_of_creation + " " + vm.siteminder_id;
      }
    } else {
      if (Order.success) Order.errorMsg = "Reservation doesn't exist";
      else
        Order.errorMsg =
          "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.";
      // if(Order.type_of_reservation == 'boat'){
      $state.go("app.e-commerce.orders", { toast_message: Order.errorMsg });
      // }else{
      // $state.go('app.e-commerce.orders',{toast_message:Order.errorMsg});
      // }
    }

    angular.element($window).on("resize", function () {
      /* code for top tabs slider */
      width = jQuery(".labels-blockclick-outer").width();
      visibleOnScreen = Math.ceil(parseInt(width) / parseInt(90));
      maxLeftAssign =
        parseInt(parseInt(tabsCount) - parseInt(visibleOnScreen)) * 90;
      maxLeftAssign = parseInt(parseInt(maxLeftAssign) + 30);
      if (visibleOnScreen < tabsCount) {
        vm.showSliderControlls = true;
      } else {
        vm.showSliderControlls = false;
      }
      if (vm.selectedIndex > visibleOnScreen) {
        left =
          -parseInt(
            parseInt(parseInt(vm.selectedIndex) - parseInt(visibleOnScreen)) + 1
          ) * 90;
        left = parseInt(left - 50);
        jQuery(".labels-blockclick").css("left", left + "px");
      } else {
        left = 0;
        jQuery(".labels-blockclick").css("left", left + "px");
      }
      /* code for top tabs slider */
    });
    /* Initial Data for view page */

    /* Methods */
    vm.slideLeft = slideLeft;
    vm.slideRight = slideRight;
    vm.saveEmailCustomer = saveEmailCustomer;
    vm.opencommentboxNight = opencommentboxNight;
    vm.opencommentboxNightPOS = opencommentboxNightPOS;
    vm.getNightlyDiscountPercent = getNightlyDiscountPercent;
    vm.opencommentbox = opencommentbox;
    vm.sumnightlyDisc = sumnightlyDisc;
    vm.sumnightlyDiscPOS = sumnightlyDiscPOS;
    vm.toggleReservationCustomer = toggleReservationCustomer;
    vm.toggleCustomerCard = toggleCustomerCard;
    vm.customerCardInitials = customerCardInitials;
    vm.customerCardLocation = customerCardLocation;
    vm.customerCardAbout = customerCardAbout;
    vm.customerCardGender = customerCardGender;
    vm.customerCardDateOfBirth = customerCardDateOfBirth;
    vm.customerCardPreferredLanguages = customerCardPreferredLanguages;
    vm.enableCustomerProfileEdit = enableCustomerProfileEdit;
    vm.cancelCustomerProfileEdit = cancelCustomerProfileEdit;
    vm.saveCustomerProfileEdit = saveCustomerProfileEdit;
    vm.getCustomerTagStyle = getCustomerTagStyle;
    vm.goToCustomerCardReservation = goToCustomerCardReservation;
    vm.loadCustomerCardNotes = loadCustomerCardNotes;
    vm.addCustomerNote = addCustomerNote;
    vm.editCustomerNote = editCustomerNote;
    vm.cancelEditCustomerNote = cancelEditCustomerNote;
    vm.updateCustomerNote = updateCustomerNote;
    vm.deleteCustomerNote = deleteCustomerNote;
    vm.togglePostToAllReservations = togglePostToAllReservations;
    vm.editOrderDates = editOrderDates;
    vm.editPosDates = editPosDates;
    vm.editParkingDates = editParkingDates;
    vm.saveCommentReq = saveCommentReq;
    vm.payInstallment = payInstallment;
    vm.updateReservationValues = updateReservationValues;
    vm.fetchOrder = fetchOrder;
    vm.fetchOrderInformation = fetchOrderInformation;
    vm.openBorrowedItems = openBorrowedItems;
    vm.fetchOrderHistory = fetchOrderHistory;
    vm.fetchPaymentsInformation = fetchPaymentsInformation;
    vm.fetchOrderCommentsRequests = fetchOrderCommentsRequests;
    vm.roomMoveStart = roomMoveStart;
    vm.back = back;
    vm.sendinvoice = sendinvoice;
    vm.sendConfirmationEmail = sendConfirmationEmail;
    vm.sendorderinvoice = sendorderinvoice;
    vm.openKeyCardDialog = openKeyCardDialog;
    vm.isRoomLockEncoderVisible = function () {
      return $rootScope.isRoomLockEncoderVisible();
    };
    vm.changeStatus = changeStatus;
    vm.getDisplayStatus = getDisplayStatus;
    vm.changeStatusForService = changeStatusForService;
    vm.cancelChangeStatus = cancelChangeStatus;
    vm.mainTabChanged = mainTabChanged;
    // vm.changeStatusAfterPayment = changeStatusAfterPayment;
    // vm.changeStatusWithoutPayment = changeStatusWithoutPayment;
    vm.refundInstallmentFinally = refundInstallmentFinally;
    vm.printinvoice = printinvoice;
    vm.printorderinvoice = printorderinvoice;
    vm.setShowModifyBtn = setShowModifyBtn;
    vm.completeModification = completeModification;
    vm.cancelModification = cancelModification;
    vm.calculateOrderTotals = calculateOrderTotals;
    vm.shouldShowRoundUp = shouldShowRoundUp;
    vm.isRoundUpEnable = isRoundUpEnable;
    vm.applyRemainingRoundUp = applyRemainingRoundUp;
    vm.getRoundUpForCharityAmount = getRoundUpForCharityAmount;
    vm.breakIntoNights = breakIntoNights;
    vm.roomovebreakIntoNights = roomovebreakIntoNights;
    vm.changeDiscAmt = changeDiscAmt;
    vm.changeDiscAmtPOS = changeDiscAmtPOS;
    vm.refundInstallment = refundInstallment;
    vm.sumNights = sumNights;
    vm.setAdults = setAdults;
    vm.roomovesetAdults = roomovesetAdults;
    vm.creditCardChanged = creditCardChanged;
    vm.checkValidExpDate = checkValidExpDate;
    vm.calculatePOSTotals = calculatePOSTotals;
    vm.changeActiveCard = changeActiveCard;
    vm.checkremainingAmount = checkremainingAmount;
    vm.changeProductDiscount = changeProductDiscount;
    vm.emptythisPayment = emptythisPayment;
    vm.setasincidental = setasincidental;
    vm.toggleRemoveCcProcessingFee = toggleRemoveCcProcessingFee;
    vm.isCcProcessingFeeApplicable = isCcProcessingFeeApplicable;
    vm.isRoundUpForCharityPos = isRoundUpForCharityPos;
    vm.deleteRoundUpForCharityPos = deleteRoundUpForCharityPos;
    vm.isPassOnlyDayShell = isPassOnlyDayShell;
    vm.isDailyPassPos = isDailyPassPos;
    vm.getDailyPassDate = getDailyPassDate;
    vm.getStayUnitLabel = getStayUnitLabel;
    vm.getStayPriceHeading = getStayPriceHeading;
    vm.validateGCCode = validateGCCode;
    vm.addroomincart = addroomincart;
    vm.calculatesubtotal = calculatesubtotal;
    vm.calculatesubtotalPos = calculatesubtotalPos;
    vm.gotoCheckoutFromEditOrder = gotoCheckoutFromEditOrder;
    vm.roomovesumNights = roomovesumNights;
    vm.roomovechangeDiscAmt = roomovechangeDiscAmt;
    vm.updateCustomer = updateCustomer;
    vm.startDateModified = startDateModified;
    vm.endDateModified = endDateModified;
    vm.triggerdiv = triggerdiv;
    vm.queryCountrySearch = queryCountrySearch;
    vm.selectedItemChange = selectedItemChange;
    vm.selectedItemChangeState = selectedItemChangeState;
    vm.selectedItemChangeForTraveller = selectedItemChangeForTraveller;
    vm.closeDialog = closeDialog;
    vm.triggerDiscountEdit = triggerDiscountEdit;
    vm.triggerDiscountEditClose = triggerDiscountEditClose;
    vm.calculateDiscount = calculateDiscount;
    vm.updateEmailSatus = updateEmailSatus;
    vm.manageAdultChild = manageAdultChild;
    vm.getRangeArray = getRangeArray;
    vm.createFilterForCountry = createFilterForCountry;
    vm.addParking = addParking;
    vm.addBoatPos = addBoatPos;
    vm.cancelThisNight = cancelThisNight;
    vm.undoCancelThisNight = undoCancelThisNight;
    vm.refundEmail = refundEmail;
    vm.sumOfVals = sumOfVals;
    vm.toggle = toggle;
    vm.monthlyWeeklyNight = monthlyWeeklyNight;
    vm.monthlyWeeklyPos = monthlyWeeklyNightPos;
    vm.yrs_option = commonService.calculateExpirationYears();
    vm.isPosNonCancellable = isPosNonCancellable;
    vm.isPosQuantityLocked = isPosQuantityLocked;
    vm.openCustomerTags = openCustomerTags;
    vm.getCustomerInitials = getCustomerInitials;
    vm.saveCustomerTags = saveCustomerTags;
    vm.assignTag = assignTag;
    vm.clearAllTags = clearAllTags; 
    vm.removeAssignedTag = removeAssignedTag;
    vm.loadCustomerFamilyMembers = loadCustomerFamilyMembers;
    vm.saveFamilyMember = saveFamilyMember;
    vm.openAddFamilyMemberForm = openAddFamilyMemberForm;
    vm.editFamilyMember = editFamilyMember;
    vm.cancelEditFamilyMember = cancelEditFamilyMember;
    vm.updateFamilyMember = updateFamilyMember;
    vm.deleteFamilyMember = deleteFamilyMember;
    vm.getRelationshipTypes = getRelationshipTypes;
    vm.goToFamilyMember = goToFamilyMember;
    vm.loadCustomerPets = loadCustomerPets;
    vm.loadPetTypes = loadPetTypes;
    vm.saveCustomerPet = saveCustomerPet;
    vm.editCustomerPet = editCustomerPet;
    vm.cancelEditCustomerPet = cancelEditCustomerPet;
    vm.updateCustomerPet = updateCustomerPet;
    vm.deleteCustomerPet = deleteCustomerPet;
    vm.openPrecheckinDialog = openPrecheckinDialog;
    vm.canShowPrecheckinIcon = canShowPrecheckinIcon;
    vm.queryFamilyMemberSearch = function (query, field) {      
      if (!query) {
        return $q.when([]);
      }

      return createResService.getCustomers({
        search: query,
        field: field,
        pageFrom: 'reservation'
      }).then(function (response) {
        if (
          response &&
          response[0] &&
          response[0].customerList
        ) {
          return response[0].customerList;
        }

        return [];
      });
    };

    vm.selectFamilyMemberCustomer = function(item) {

        if (!item) {
            return;
        }

        vm.familyMemberForm.customer_id = item.customer_id;

        vm.familyMemberForm.first_name = item.first_name || '';
        vm.familyMemberForm.last_name = item.last_name || '';
        vm.familyMemberForm.customer_email = item.customer_email || '';
        // md-datepicker treats '' as invalid; keep empty DOB as null
        vm.familyMemberForm.date_of_birth = parseFamilyMemberDob(item.date_of_birth);

        vm.familyMemberSearch.first_name = item.first_name || '';
        vm.familyMemberSearch.last_name = item.last_name || '';
        vm.familyMemberSearch.customer_email = item.customer_email || '';

        vm.selectedFamilyMemberSearch.first_name = item;
        vm.selectedFamilyMemberSearch.last_name = item;
        vm.selectedFamilyMemberSearch.customer_email = item;
        $timeout(function() {

            var phoneInput = document.getElementById(
                'familyMemberPhoneNumber'
            );

            if (!phoneInput || !item.phone_number) {
                return;
            }

            // Get the intl-tel-input instance
            var iti = null;

            if (
                window.intlTelInputGlobals &&
                window.intlTelInputGlobals.getInstance
            ) {
                iti = window.intlTelInputGlobals.getInstance(phoneInput);
            }

            if (iti) {
                iti.setNumber(item.phone_number);
                vm.familyMemberForm.phone_number = iti.getNumber();

            } else {
                vm.familyMemberForm.phone_number = item.phone_number;
            }
            $scope.$applyAsync();

        });
    };
    vm.openBillingTags = openBillingTags;
    vm.openTravellerTags = openTravellerTags;
    vm.getTagDialogPersonName = getTagDialogPersonName;
    vm.getTagDialogPersonEmail = getTagDialogPersonEmail;
    vm.getTagDialogPersonInitials = getTagDialogPersonInitials;
    
    /* Methods */

    /*** initializeOrderPosData ***/
    function initializeOrderPosData(orderData) {
      vm.posArrayFinal = [];
      vm.posweekOverallTotalArray = [];
      vm.posweekPaidValuesArray = [];
      vm.posweekOwesValuesArray = [];
      vm.posmonthOverallTotalArray = [];
      vm.monthly_paid_amount =
        orderData.overalltotals.paid_amount - orderData.subtotal;
      vm.total_paid_amount =
        orderData.overalltotals.paid_amount - orderData.subtotal;
      vm.monthly_paid_amount =
        vm.monthly_paid_amount < 0 ? 0 : vm.monthly_paid_amount;

      vm.boatArrayFinal = monthlyWeeklyNight(orderData);
      angular.forEach(orderData.pos, function (value, key) {
        vm.posArrayFinal[key] = [];
        vm.posArrayFinal[key].push(monthlyWeeklyNightPos(value, key));
        $timeout(function () {
          vm.loader[key] = "false";
        }, 3000);
      });
    }

    /* functions for top tabs slider */
    function slideLeft() {
      if (left < 0) {
        if (parseInt(parseInt(left) + 50) == 0) {
          left = 0;
        } else {
          left = left + 90;
        }
        jQuery(".labels-blockclick").css("left", left + "px");
      }
    }
    function slideRight() {
      if (parseInt(left) > -parseInt(maxLeftAssign)) {
        var maxLeft = maxLeftAssign - 30;
        if (parseInt(left) == -parseInt(maxLeft)) {
          left = left - 50;
        } else {
          left = left - 90;
        }
        jQuery(".labels-blockclick").css("left", left + "px");
      }
    }
    /* functions for top tabs slider */
    function getRangeArray(start, end) {
      var tempArray = [];
      for (var i = start; i <= end; i++) {
        tempArray.push(i);
      }
      return tempArray;
    }
    function manageAdultChild(calledFrom) {
      if (typeof vm.order == "undefined") return;
      $timeout(function () {
        var sum =
          parseInt(vm.order.room_stay_guest_count) +
          parseInt(vm.order.room_stay_child_count);
        if (calledFrom == "adult") {
          vm.childRange = getRangeArray(
            0,
            parseInt(vm.order["max_occupancy"]) - vm.order.room_stay_guest_count
          );

          if (
            sum > parseInt(Order["response"]["reservations"]["max_occupancy"])
          ) {
            vm.order.room_stay_child_count = 0;
          }
        } else {
          vm.adultRange = getRangeArray(
            1,
            parseInt(vm.order["max_occupancy"]) - vm.order.room_stay_child_count
          );
          if (
            sum > parseInt(Order["response"]["reservations"]["max_occupancy"])
          ) {
            vm.order.room_stay_guest_count = 1;
          }
        }
      }, 1000);
    }
    function updateEmailSatus(id, status, type) {
      var status = status ? 1 : 0;
      var data = { customer_id: id, status: status };
      eCommerceService.updateSendEmailIndicator(data).then(function (response) {
        if (!response["error"] && vm.customerSameAsTraveller) {
          if (type == "customer") {
            vm.order["send_email_indicator"] =
              vm.reservation_customer["send_email_indicator"];
          } else {
            vm.reservation_customer["send_email_indicator"] =
              vm.order["send_email_indicator"];
          }
        }
      });
    }

    function saveEmailCustomer(customer_id, email, action) {
      if (!email) {
        if (action == "customer") {
          vm.reservation_customer.customer_email = angular.copy(
            vm.orig_reservation_customer.customer_email
          );
        } else {
          vm.order.customer_email = angular.copy(
            originalOrderData.customer_email
          );
        }
        return;
      }
      var tempconfNo = action == "customer" ? "" : vm.order.confirmation_number;
      var prevEmail =
        action == "customer"
          ? vm.orig_reservation_customer.customer_email
          : originalOrderData.customer_email;

      var travCust =
        vm.order.customerTravelSame !== undefined
          ? vm.order.customerTravelSame
          : false;
      if (email != prevEmail || prevEmail == "" || prevEmail == undefined) {
        var data = {
          selectedHotel:
            $localStorage.hotels[$localStorage.selectedHotel].hotel_id,
          customer_id: customer_id,
          email: email,
          confirmation_number: tempconfNo,
          reservation_id: vm.reservation_id,
          order_confirmation_number: vm.order.confirmation_number,
          customerTravelSame: travCust,
          type: action,
          roomType: vm.pageType,
          customerId: vm.order.customerId,
          travellerId: vm.order.travellerId,
          first_name:
            action == "customer"
              ? vm.reservation_customer.first_name
              : vm.order.first_name,
          last_name:
            action == "customer"
              ? vm.reservation_customer.last_name
              : vm.order.last_name,
          address:
            action == "customer"
              ? vm.reservation_customer.address
              : vm.order.address,
          city:
            action == "customer" ? vm.reservation_customer.city : vm.order.city,
          state:
            action == "customer"
              ? vm.reservation_customer.state
              : vm.order.state,
          zip_code:
            action == "customer"
              ? vm.reservation_customer.zip_code
              : vm.order.zip_code,
          country:
            action == "customer"
              ? vm.reservation_customer.country
              : vm.order.country,
          phone_number:
            action == "customer"
              ? vm.reservation_customer.phone_number
              : vm.order.phone_number,
          secondary_phone_number:
            action == "customer"
              ? vm.reservation_customer.secondary_phone_number
              : vm.order.secondary_phone_number,
        };

        eCommerceService.saveEmailCustomer(data).then(function (response) {
          if (response.success) {
            if (action == "customer") {
              vm.orig_reservation_customer.customer_email = angular.copy(email);
            } else {
              originalOrderData.customer_email = angular.copy(email);
            }
          } else if (
            response.errorMsg &&
            response.errorMsg != "" &&
            response.newUser
          ) {
            if (action == "customer") {
              vm.orig_reservation_customer.customer_email = angular.copy(email);
            } else {
              originalOrderData.customer_email = angular.copy(email);
            }

            vm.reservation_customer = response.res_data.reservation_customer;

            if (
              response["res_data"]["reservation_customer"]["customer_id"] ==
              response["res_data"]["reservations"]["customer_id"]
            ) {
              vm.customerSameAsTraveller = true;
            }
            vm.checkCustomerTravellerSame();
            vm.order = response.res_data.reservations;
            vm.boatArrayFinal = monthlyWeeklyNight(vm.order);
          } else if (response.errorMsg && response.errorMsg != "") {
            vm.reservation_customer.customer_email = angular.copy(
              vm.orig_reservation_customer.customer_email
            );
            toastMessage.showSimpleToast(response.errorMsg, "error-toast");
          } else {
            vm.reservation_customer.customer_email = angular.copy(
              vm.orig_reservation_customer.customer_email
            );
            toastMessage.showSimpleToast(
              "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.",
              "error-toast"
            );
          }
        });
      }
    }

    function getNightlyDiscountPercent(discount, rate) {
      var discountAmount = parseFloat(discount) || 0;
      var nightRate = parseFloat(rate) || 0;
      if (discountAmount <= 0 || nightRate <= 0) {
        return "";
      }
      var percent = parseFloat(
        commonService.roundnum((discountAmount / nightRate) * 100, 2)
      );
      return percent % 1 === 0 ? percent.toFixed(0) : percent.toFixed(2);
    }

    function opencommentboxNight(index, nightIndex, type) {
      if (
        vm.order.promotion_applied != undefined &&
        vm.order.promotion_applied == 1
      ) {
        // if promo code applied then don't allow discount window to open
        // toastMessage.showSimpleToast("You can either give the discount manually or by applying promo code. So please remove promo code if you want to give the discount manually.",'warning-toast');
        return false;
      } else {
        var event = "";
        var answer = "";
        $mdDialog
          .show({
            controller: "discountCommentController",
            controllerAs: "vm",
            templateUrl:
              "app/main/apps/create-res/dialogs/discount-comment/discount-comment.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            // binds nights/currentNightIndex onto the dialog vm so other callers need not pass them
            bindToController: true,
            locals: {
              oldcomment: vm.order.prices.nightlydiscountcomment[nightIndex],
              oldAmount: vm.order.prices.nightlydiscount[nightIndex],
              type: type,
              price: vm.order.prices.rates[nightIndex],
              nights:
                type === "nightly_discount"
                  ? getDiscountNights(vm.order.prices)
                  : [],
              currentNightIndex: parseInt(nightIndex),
              nightGroups: vm.boatArrayFinal,
              getWeekHeaderName: vm.getWeekHeaderName,
              getNightlyDiscountPercent: getNightlyDiscountPercent,
              stayUnitLabel: getStayUnitLabel(),
              showSource: !!vm.order.showOtaPmsNightsFlag,
            },
          })
          .then(
            function (response) {
              if (response != undefined && response.nights) {
                applyDiscountToNights(response);
              } else if (response != undefined) {
                if (type === "nightly_discount") {
                  vm.order.prices.nightlydiscount[nightIndex] = response.amount;
                }
                vm.order.prices.nightlydiscountcomment[nightIndex] =
                  response.comment;
                var index = parseInt(nightIndex) + 1;
                vm.setShowModifyBtn(
                  "Night-" + nightIndex,
                  "nightlydiscount",
                  vm.order.room_stay_id,
                  "",
                  "",
                  "nightly_discount"
                );
                vm.sumnightlyDisc(nightIndex);
              }
            },
            function () {}
          );
      }
    }

    /**
     * Nights of the room shown in the discount dialog to pick where the discount applies
     */
    function getDiscountNights(prices) {
      // the order page reads the source from the room for POS rows too
      var sources = vm.order.prices.otaDirectNight || {};
      return commonService
        .getDiscountNights(prices, getStayUnitLabel())
        .map(function (night) {
          night.source = sources[night.index] || "";
          return night;
        });
    }

    /**
     * Apply the discount returned by the dialog to every selected night and save once
     */
    function applyDiscountToNights(response) {
      var changes = [];
      angular.forEach(response.nights, function (night) {
        var oldAmount = commonService.roundnum(
          parseFloat(originalOrderData.prices.nightlydiscount[night.index]) || 0,
          2
        );
        var newAmount = commonService.roundnum(night.amount, 2);
        vm.order.prices.nightlydiscount[night.index] = newAmount;
        vm.order.prices.nightlydiscountcomment[night.index] = response.comment;
        if (parseFloat(oldAmount) != parseFloat(newAmount)) {
          changes.push(
            "night " +
              (night.index + 1) +
              " changed from " +
              oldAmount +
              " to " +
              newAmount
          );
        }
      });

      var firstIndex = response.nights[0].index;
      vm.setShowModifyBtn(
        "Night-" + firstIndex,
        "nightlydiscount",
        vm.order.room_stay_id,
        "",
        "",
        "nightly_discount"
      );
      // setShowModifyBtn only describes one night, so describe every changed night
      if (vm.processRequest && changes.length > 0) {
        vm.modificationComment = "Discount of " + changes.join(", ");
      }
      vm.sumnightlyDisc(firstIndex);
    }

    function opencommentboxNightPOS(poskey, datekey, action, nightIndex) {
      var event = "";
      var thisCart = angular.copy(vm.order.pos[poskey]);
      if (pos.promotion_applied != undefined && pos.promotion_applied == 1) {
        // if promo code applied then don't allow discount window to open
        return false;
      } else {
        if (thisCart.prices.nightlydiscountcomment)
          var comment = thisCart.prices.nightlydiscountcomment[nightIndex];
        else var comment = "";
        $mdDialog
          .show({
            controller: "discountCommentController",
            controllerAs: "vm",
            templateUrl:
              "app/main/apps/create-res/dialogs/discount-comment/discount-comment.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
              oldcomment: comment,
              oldAmount: thisCart.prices.nightlydiscount[nightIndex],
              type: "nightly_discount",
              price: thisCart.prices.rates[nightIndex],
            },
          })
          .then(
            function (answer) {
              if (!thisCart.prices.nightlydiscountcomment) {
                thisCart.prices.nightlydiscountcomment = {};
              }
              if (answer != undefined) {
                thisCart.prices.nightlydiscountcomment[nightIndex] =
                  answer.comment;
                if (answer.amount != undefined) {
                  thisCart.prices.nightlydiscount[nightIndex] = answer.amount;
                }
              }
              vm.order.pos[poskey] = thisCart;
              var data = {
                confirmation_number: thisCart.confirmation_number,
                nightlydiscountcomment: thisCart.prices.nightlydiscountcomment,
                nontimebound: false,
              };
              eCommerceService
                .saveDiscountComment(data)
                .then(function (response) {
                  if (response.success || response.data) {
                    thisCart.prices.nightlydiscountcomment = response.data;
                    vm.order.pos[poskey] = thisCart;
                  }
                });
            },
            function () {}
          );
      }
    }

    function opencommentbox(posIndex) {
      vm.event = "";
      $mdDialog
        .show({
          controller: "discountCommentController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/create-res/dialogs/discount-comment/discount-comment.html",
          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: true,
          locals: {
            oldcomment: vm.order.pos[posIndex].product_discount_comment,
            oldAmount: "",
            type: "",
            price: "",
          },
        })
        .then(
          function (answer) {
            if (answer != undefined) {
              vm.order.pos[posIndex].product_discount_comment = answer.comment;
              var data = {
                confirmation_number: vm.order.pos[posIndex].confirmation_number,
                nightlydiscountcomment:
                  vm.order.pos[posIndex].product_discount_comment,
                nontimebound: true,
              };
              eCommerceService
                .saveDiscountComment(data)
                .then(function (response) {
                  if (response.success || response.data) {
                    vm.order.pos[posIndex].prices.product_discount_comment =
                      response.data;
                  }
                });
            }
          },
          function () {}
        );
    }

    /************************************************************/
    /*********** Open comment discount popup for POS ************/
    /************************************************************/
    vm.discountCommentPopUp = discountCommentPopUp;
    function discountCommentPopUp(selectedIndex, poskey, type, datekey, mykey) {
      var posData = vm.order.pos[poskey];
      if (
        posData.promotion_applied != undefined &&
        posData.promotion_applied == 1
      ) {
        // dont allow discount if promo code is applied
        return false;
      } else {
        $mdDialog
          .show({
            controller: "discountCommentController",
            controllerAs: "vm",
            templateUrl:
              "app/main/apps/create-res/dialogs/discount-comment/discount-comment.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            // binds nights/currentNightIndex onto the dialog vm so other callers need not pass them
            bindToController: true,
            locals: {
              nights:
                type === "nightly_discount"
                  ? getDiscountNights(posData.prices)
                  : [],
              currentNightIndex: parseInt(selectedIndex),
              nightGroups: vm.posArrayFinal[poskey]
                ? vm.posArrayFinal[poskey][0]
                : null,
              getWeekHeaderName: vm.getWeekHeaderName,
              getNightlyDiscountPercent: getNightlyDiscountPercent,
              stayUnitLabel: getStayUnitLabel(),
              // same rule as the POS rows on the order page
              showSource:
                !!vm.order.showOtaPmsNightsFlag &&
                posData.extra_attribute === "resort_fee",
              oldcomment:
                vm.order.pos[poskey].prices.nightlydiscountcomment[
                  selectedIndex
                ],
              oldAmount:
                vm.order.pos[poskey].prices.nightlydiscount[selectedIndex],
              price: vm.order.pos[poskey].prices.rates[selectedIndex],
              type: type,
            },
          })
          .then(
            function (response) {
              if (response != undefined && response.nights) {
                applyDiscountToPosNights(response, poskey, datekey, mykey);
              } else if (response != undefined) {
                if (type === "nightly_discount") {
                  vm.order.pos[poskey].prices.nightlydiscount[selectedIndex] =
                    response.amount;
                }
                vm.order.pos[poskey].prices.nightlydiscountcomment[
                  selectedIndex
                ] = response.comment;
                var index = parseInt(selectedIndex) + 1;
                vm.order.pos[poskey].reservation_status_type =
                  "Pos-night-" + index + "-discount";
                vm.setShowModifyBtn(
                  "night-" + index,
                  "nightlydiscount",
                  vm.order.pos[poskey].room_stay_id,
                  "pos",
                  poskey,
                  "nightly_discount"
                );
                var tempIndex = index - 1;
                vm.sumnightlyDiscPOS(mykey, poskey, datekey, "call", tempIndex);
              }
            },
            function () {}
          );
      }
    }

    /**
     * Apply the discount returned by the dialog to every selected night of a POS product and save once
     */
    function applyDiscountToPosNights(response, poskey, datekey, mykey) {
      var posData = vm.order.pos[poskey];
      var originalDiscounts =
        originalOrderData.pos[poskey].prices.nightlydiscount;
      var changes = [];
      angular.forEach(response.nights, function (night) {
        var oldAmount = commonService.roundnum(
          parseFloat(originalDiscounts[night.index]) || 0,
          2
        );
        var newAmount = commonService.roundnum(night.amount, 2);
        posData.prices.nightlydiscount[night.index] = newAmount;
        // sumnightlyDiscPOS only clears the comment of the night it is given
        posData.prices.nightlydiscountcomment[night.index] =
          parseFloat(newAmount) === 0 ? "" : response.comment;
        if (parseFloat(oldAmount) != parseFloat(newAmount)) {
          changes.push(
            "night " +
              (night.index + 1) +
              " changed from " +
              oldAmount +
              " to " +
              newAmount
          );
        }
      });

      var firstIndex = response.nights[0].index;
      vm.setShowModifyBtn(
        "night-" + (firstIndex + 1),
        "nightlydiscount",
        posData.room_stay_id,
        "pos",
        poskey,
        "nightly_discount"
      );
      // setShowModifyBtn only describes one night, so describe every changed night
      if (vm.processRequest && changes.length > 0) {
        vm.modificationComment =
          originalOrderData.pos[poskey].product_name +
          " discount for " +
          changes.join(", ");
      }
      vm.sumnightlyDiscPOS(mykey, poskey, datekey, "call", firstIndex);
    }

    function calculateDiscount() {
      if (vm.discount_type == "percent") {
        if (parseFloat(vm.newDiscount) > 100) vm.newDiscount = 100;
        var discount_amount =
          (parseFloat(
            parseFloat(vm.order.nightlySum) +
              parseFloat(vm.order.additional_guest_amounts)
          ) *
            parseFloat(vm.newDiscount)) /
          100;

        vm.order.discount_percentage = commonService.roundnum(
          vm.newDiscount,
          2
        );
        vm.order.discount_amount = commonService.roundnum(discount_amount, 2);
        var POS = vm.order.pos;
        if (typeof POS != "undefined" || POS) {
          vm.order.pos.forEach(function (element, key) {
            if (
              element.room_stay_status == "Active" &&
              parseFloat(element.nightlySum) > 0
            ) {
              var discount_amount =
                parseFloat(element.nightlySum * vm.newDiscount) / 100;
              vm.order.pos[key].discountAmt = commonService.roundnum(
                discount_amount,
                2
              );
              vm.order.pos[key].discountPer = commonService.roundnum(
                vm.newDiscount,
                2
              );
              vm.calculatePOSTotals(key, "");
              vm.setShowModifyBtn(
                "discountPerpos" + key,
                "discountPer",
                element.room_stay_id,
                "pos",
                key
              );
            }
          });
        }
        vm.setShowModifyBtn(
          "DiscountPercent",
          "discount_percentage",
          vm.order.room_stay_id
        );
      } else {
        if (
          parseFloat(vm.newDiscount) >
          parseFloat(vm.order.overalltotals.subtotal)
        )
          vm.newDiscount = vm.order.overalltotals.subtotal;
        var discount_amount = vm.newDiscount;
        if (parseFloat(vm.order.nightlySum) > 0) {
          if (parseFloat(discount_amount) <= parseFloat(vm.order.nightlySum)) {
            vm.order.discount_amount = commonService.roundnum(
              discount_amount,
              2
            );
            discount_amount = 0;
          } else if (discount_amount > vm.order.nightlySum) {
            vm.order.discount_amount = commonService.roundnum(
              parseFloat(
                parseFloat(vm.order.nightlySum) +
                  parseFloat(vm.order.additional_guest_amounts)
              ),
              2
            );
            discount_amount = parseFloat(
              parseFloat(discount_amount) - vm.order.discount_amount
            );
          }
          var newDiscPer =
            (parseFloat(vm.order.discount_amount) * 100) /
            parseFloat(
              parseFloat(vm.order.nightlySum) +
                parseFloat(vm.order.additional_guest_amounts)
            );

          newDiscPer = commonService.roundnum(newDiscPer, 2);
          vm.order.discount_percentage = commonService.roundnum(newDiscPer, 2);
        }
        var POS = vm.order.pos;
        if (
          parseFloat(discount_amount) > 0 &&
          (typeof POS != "undefined" || POS)
        ) {
          vm.order.pos.forEach(function (element, key) {
            if (
              element.room_stay_status == "Active" &&
              parseFloat(element.nightlySum) > 0 &&
              parseFloat(discount_amount) > 0
            ) {
              var nightlySum = parseFloat(element.nightlySum);
              if (parseFloat(discount_amount) <= nightlySum) {
                vm.order.pos[key].discountAmt = commonService.roundnum(
                  discount_amount,
                  2
                );
                discount_amount = 0;
              } else if (parseFloat(discount_amount) > nightlySum) {
                vm.order.pos[key].discountAmt = commonService.roundnum(
                  nightlySum,
                  2
                );
                discount_amount = parseFloat(
                  parseFloat(discount_amount) - nightlySum
                );
              }
              var newDiscPer =
                (parseFloat(vm.order.pos[key].discountAmt) * 100) /
                parseFloat(nightlySum);

              newDiscPer = commonService.roundnum(newDiscPer, 2);
              vm.order.pos[key].discountPer = commonService.roundnum(
                newDiscPer,
                2
              );
              vm.calculatePOSTotals(key, "");
              vm.setShowModifyBtn(
                "discountAmtpos" + key,
                "discountAmt",
                element.room_stay_id,
                "pos",
                key
              );
            } else if (
              element.room_stay_status == "Active" &&
              parseFloat(element.nightlySum) > 0
            ) {
              vm.order.pos[key].discountAmt = 0.0;
              vm.order.pos[key].discountPer = 0.0;
              vm.calculatePOSTotals(key, "");
              vm.setShowModifyBtn(
                "discountAmtpos" + key,
                "discountAmt",
                element.room_stay_id,
                "pos",
                key
              );
            }
          });
        }
        vm.setShowModifyBtn(
          "DiscountAmount",
          "discount_amount",
          vm.order.room_stay_id
        );
      }

      vm.order = commonService.calculateTotals(vm.order, false, []);
    }

    function triggerDiscountEdit() {
      vm.showDiscountEdit = true;
    }

    function triggerDiscountEditClose() {
      vm.showDiscountEdit = false;
    }

    function selectedItemChangeState(state) {
      if (customFlag && state != undefined && state != "") {
        if (typeof state != "undefined") {
          if (typeof state != "string")
            vm.reservation_customer.state = state.name;
          else vm.reservation_customer.state = state;
        } else {
          vm.reservation_customer.state = "";
        }
        updateCustomer("state", "", "customer");
      }
    }

    function closeDialog() {
      $mdDialog.hide();
    }

    function selectedItemChange(item) {
      if (customFlag && item != undefined && item != "") {
        if (typeof item != "undefined") {
          vm.reservation_customer.country = item.display;
        } else {
          vm.reservation_customer.country = "";
        }
        updateCustomer("country", "", "customer");
      }
    }

    function selectedItemChangeForTraveller(item) {
      if (customFlag && item != undefined && item != "") {
        if (typeof item != "undefined") {
          vm.order.country = item.display;
        } else {
          vm.order.country = "";
        }
        updateCustomer("country", vm.order.confirmation_number, "traveller");
      }
    }
    vm.selectedItemChangeStateForTraveller =
      selectedItemChangeStateForTraveller;
    function selectedItemChangeStateForTraveller(state) {
      if (customFlag && state != undefined && state != "") {
        vm.tempstate = state;
        if (typeof state != "undefined") {
          vm.order.state = state.name;
        } else {
          vm.order.state = "";
        }
        updateCustomer("state", vm.order.confirmation_number, "traveller");
      }
    }

    function queryCountrySearch(query) {
      var results = query
          ? myCountryArr.filter(createFilterForCountry(query))
          : myCountryArr,
        deferred;
      //~ if (simulateQuery) {
      //~ deferred = $q.defer();
      //~ $timeout(function() {
      //~ deferred.resolve(results);
      //~ }, Math.random() * 1000, false);
      //~ return deferred.promise;
      //~ } else {
      return results;
      //~ }
    }
    vm.queryStateSearch = queryStateSearch;
    function queryStateSearch(query) {
      if (vm.searchTxtCountry.length > 0) {
        var deferred = $q.defer();
        createResService
          .getAllStates({ state: query, country: vm.searchTxtCountry })
          .then(function (response) {
            deferred.resolve(response.states);
          });
        return deferred.promise;
      } else {
        return [];
      }
    }

    vm.queryStateSearchForTraveller = queryStateSearchForTraveller;
    function queryStateSearchForTraveller(query) {
      if (vm.searchTxtCountryForTraveller.length > 0) {
        var deferred = $q.defer();
        createResService
          .getAllStates({
            state: query,
            country: vm.searchTxtCountryForTraveller,
          })
          .then(function (response) {
            deferred.resolve(response.states);
          });
        return deferred.promise;
      } else {
        return [];
      }
    }

    function createFilterForCountry(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(state) {
        return state.value.indexOf(lowercaseQuery) === 0;
      };
    }

    function loadAll() {
      var allStates = countryList;
      return allStates.map(function (state) {
        return {
          value: state.toLowerCase(),
          display: state,
        };
      });
    }
    vm.taxExemptRequest = false;

    function updateCustomer(column, confirmation_number, type) {
      if (vm.stateStatus) {
        if (column === 'phone_number' || column === 'secondary_phone_number') {
          var phoneSelector = (type === 'customer')
            ? 'input[name="reservation_' + column + '"]'
            : 'input[name="' + column + '[vm.selectedIndex]"]';


          var phoneInvalid = Array.from(document.querySelectorAll(phoneSelector)).some(function (el) {
            var iti = angular.element(el).data('iti');
            if (!iti) return false;
            var val = el.value.trim();
            if (!val) return false;
            return !iti.isValidNumberPrecise();
          });

          if (phoneInvalid) {
            vm.isloading = false;
            return;
          }
        }
        vm.isloading = true;

        var email = vm.order["customer_email"];
        var value = vm.order[column];

        if (column === 'phone_number' || column === 'secondary_phone_number') {
          var phoneSelector = (type === 'customer')
            ? 'input[name="reservation_' + column + '"]'
            : 'input[name="' + column + '[vm.selectedIndex]"]';
          var phoneInputs = document.querySelectorAll(phoneSelector);
          for (var i = 0; i < phoneInputs.length; i++) {
              var phoneInput = phoneInputs[i];
              var iti = angular.element(phoneInput).data('iti');
              if (iti) {
                  var val = (phoneInput.value || '').trim();
                  if (val && iti.isValidNumberPrecise()) {
                      value = iti.getNumber();
                      break;
                  } else if (!val) {
                      value = '';
                  }
              }
          }
        }

        if (
          column == "state" &&
          typeof value == "undefined" &&
          typeof vm.tempState != "undefined" &&
          vm.tempState != ""
        ) {
          vm.order.state = vm.tempstate;
        }

        if (
          confirmation_number == "" &&
          column != "customerTaxExempt" &&
          column != "travellerTaxExempt"
        ) {
          value = vm.reservation_customer[column];
          email = vm.reservation_customer["customer_email"];
        }



        var first_name =
          type !== undefined && type !== null && type == "customer"
            ? vm.reservation_customer.first_name
            : vm.order.first_name;
        var last_name =
          type !== undefined && type !== null && type == "customer"
            ? vm.reservation_customer.last_name
            : vm.order.last_name;

        if (typeof value != "undefined") {
          var data = {
            reservation_id: vm.reservation_id,
            itinerary_number: vm.itinerary_number,
            column: column,
            value: value,
            confirmation_number: confirmation_number,
            room_confirmation_number: vm.order.confirmation_number,
            first_name: first_name,
            last_name: last_name,
            email: email,
            customer_gender: type === "customer"
              ? vm.reservation_customer.customer_gender
              : vm.order.customer_gender,
            about: type === "customer"
              ? vm.reservation_customer.about
              : vm.order.about,
            date_of_birth: type === "customer"
              ? vm.reservation_customer.date_of_birth
              : vm.order.date_of_birth,
            product_id: vm.order["product_id"],
            customerTravelSame: vm.order.customerTravelSame,
            roomType: vm.pageType,
          };

          var customerId =
            type != undefined && type == "customer"
              ? vm.order.customerId
              : vm.order.travellerId;
          data.customer_id = customerId;

          if (column == "customerTaxExempt" || column == "travellerTaxExempt") {
            vm.taxExemptRequest = true;
            var taxExemptIndicator =
              type == "customer"
                ? vm.order.customerTaxExempt
                : vm.order.travellerTaxExempt;
            data.value = taxExemptIndicator;
            data.type = type;
            data.customerId = vm.order.customerId;
            data.travellerId = vm.order.travellerId;
          }

          eCommerceService.updateCustomer(data).then(function (response) {
            if (!response.status && vm.stateStatus) {
              toastMessage.showSimpleToast(
                "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.",
                "error-toast"
              );
            } else if (vm.customerSameAsTraveller) {
              // if(type == 'customer'){
              // 	vm.order[column] = vm.reservation_customer[column];
              // }else{
              // 	vm.reservation_customer[column] = vm.order[column];
              // }
            }

            if (
              response.status &&
              (column == "customerTaxExempt" || column == "travellerTaxExempt")
            ) {
              vm.changedColumn = column;
              var customer_status = vm.order[column] ? "true." : "false.";
              if (column == "customerTaxExempt") {
                vm.modificationComment =
                  "Customer tax extempt status changed to " + customer_status;
              } else {
                vm.modificationComment =
                  "Traveller tax extempt status changed to " + customer_status;
              }
              // calculateOrderTotals();
              vm.fetchOrder(vm.order.confirmation_number, "hitRequest");
            } else {
              vm.taxExemptRequest = false;
            }

            /*if (vm.order.customerTravelSame && type == 'customer') {
							console.log("custravsame type==cust");
							console.log("Before vm.order[column] ==> ",vm.order[column]);
							vm.order[column] = vm.reservation_customer[column];
							console.log("After vm.order[column] ==> ",vm.order[column]);
						}*/
            // vm.taxExemptRequest = false;
            if (response.status) {

              if (
                  column === 'phone_number' ||
                  column === 'secondary_phone_number'
              ) {

                  var displayKey =
                      type === 'customer'
                          ? (
                              column === 'phone_number'
                                  ? 'customer_phone'
                                  : 'customer_secondary_phone'
                          )
                          : (
                              column === 'phone_number'
                                  ? 'traveller_phone'
                                  : 'traveller_secondary_phone'
                          );

                  vm.phoneDisplay[displayKey] =
                      value ||
                      (type === 'customer'
                          ? vm.reservation_customer[column]
                          : vm.order[column]) ||
                      '';
              }

              if (column === 'phone_number') {
                maybePromptUpdateMessageCenterChatPhone(
                  confirmation_number ||
                    (vm.order && vm.order.confirmation_number) ||
                    '',
                  value
                );
              }
            }
            vm.isloading = false;
          });
        }
      }
    }

    function getCustomerCardPersonId() {
      if (vm.order && vm.order.customer_id) {
        return vm.order.customer_id;
      }
      if (vm.reservation_customer && vm.reservation_customer.customer_id) {
        return vm.reservation_customer.customer_id;
      }
      return null;
    }

    function stableSortTags(tags) {
      if (!tags || !tags.length) return tags;
      var mapped = tags.map(function (el, i) {
        return { index: i, value: el };
      });
      mapped.sort(function (a, b) {
        var aVal = a.value;
        var bVal = b.value;
        var aSort = (aVal.sort_order !== null && aVal.sort_order !== undefined && aVal.sort_order !== '') ? parseInt(aVal.sort_order, 10) : 0;
        var bSort = (bVal.sort_order !== null && bVal.sort_order !== undefined && bVal.sort_order !== '') ? parseInt(bVal.sort_order, 10) : 0;
        var hasA = aSort > 0;
        var hasB = bSort > 0;
        if (hasA && hasB) {
          if (aSort !== bSort) {
            return aSort - bSort;
          }
          return a.index - b.index;
        }
        if (hasA) return -1;
        if (hasB) return 1;
        return a.index - b.index;
      });
      return mapped.map(function (el) {
        return el.value;
      });
    }

    function getCustomerTags() {
      var customerId = getCustomerCardPersonId();
      if (!customerId) {
        return $q.resolve();
      }
      return eCommerceService
        .getCustomerTags(customerId)
        .then(function (response) {

          if (!response.success) {
            return;
          }

          // System Tags
          angular.forEach(response.data.systemTags, function (tag) {

            tag.type = 'system';

            if (!vm.systemTags.some(function (t) {
              return t.id === tag.id;
            })) {
              vm.systemTags.push(tag);
            }

            if (tag.selected) {
              if (!vm.assignedTags.some(function (t) {
                return t.id === tag.id;
              })) {
                vm.assignedTags.push(tag);
              }
            }

          });

          // Hotel Tags
          angular.forEach(response.data.hotelTags, function (tag) {

            tag.type = 'hotel';

            if (!vm.hotelTags.some(function (t) {
              return t.id === tag.id;
            })) {
              vm.hotelTags.push(tag);
            }

            if (tag.selected) {
              if (!vm.assignedTags.some(function (t) {
                return t.id === tag.id;
              })) {
                vm.assignedTags.push(tag);
              }
            }

          });

          vm.assignedTags = stableSortTags(vm.assignedTags);

        });
    }

    function saveCustomerTags() {
      var target = vm.tagDialogTarget;
      var customerId;
      if (target === 'billing') {
        customerId = vm.reservation_customer && vm.reservation_customer.customer_id;
      } else if (target === 'traveller') {
        customerId = vm.order && vm.order.customer_id;
      } else {
        customerId = getCustomerCardPersonId();
      }
      if (!customerId) {
        return;
      }
      var payload = {
        customer_id: customerId,
        tag_ids: vm.tempAssignedTags.map(function (tag) {
          return parseInt(tag.id);
        })
      };
      vm.isSavingCustomerTags = true;
      eCommerceService.saveCustomerTags(payload)
        .then(function (response) {
          if (response.success) {
            var sortedTags = stableSortTags(angular.copy(vm.tempAssignedTags));
            // Update the correct tag array based on target
            if (target === 'billing') {
              vm.billingAssignedTags = sortedTags;
              // If billing customer is same as traveller, sync traveller tags too
              var billingId = vm.reservation_customer && vm.reservation_customer.customer_id;
              var travellerId = vm.order && vm.order.customer_id;
              if (billingId && travellerId && String(billingId) === String(travellerId)) {
                vm.travellerAssignedTags = sortedTags;
                vm.assignedTags = sortedTags;
              }
            } else if (target === 'traveller') {
              vm.travellerAssignedTags = sortedTags;
              // If traveller is same as billing customer, sync billing tags too
              var billingId2 = vm.reservation_customer && vm.reservation_customer.customer_id;
              var travellerId2 = vm.order && vm.order.customer_id;
              if (billingId2 && travellerId2 && String(billingId2) === String(travellerId2)) {
                vm.billingAssignedTags = sortedTags;
                vm.assignedTags = sortedTags;
              }
            } else {
              // Opened from Customer Stay Card (target is null).
              // The stay card shows traveller data, so sync traveller tags.
              vm.travellerAssignedTags = sortedTags;
              // Also sync billing tags if both customers share the same ID
              var billingCustId = vm.reservation_customer && vm.reservation_customer.customer_id;
              if (billingCustId && String(customerId) === String(billingCustId)) {
                vm.billingAssignedTags = sortedTags;
              }
            }
            // Also update the main assignedTags (for customer stay card) if IDs match
            var stayCardId = getCustomerCardPersonId();
            if (String(customerId) === String(stayCardId)) {
              vm.assignedTags = sortedTags;
            }
            // If customer and traveller are the same person, sync all
            if (vm.order && vm.order.customerTravelSame) {
              vm.billingAssignedTags = sortedTags;
              vm.travellerAssignedTags = sortedTags;
              vm.assignedTags = sortedTags;
            }
            vm.closeDialog();
          }
        })
        .finally(function () {
          vm.isSavingCustomerTags = false;
          vm.tagDialogTarget = null;
        });
    }

    function openCustomerTags($event) {
      vm.tagDialogTarget = null;
      vm.tempAssignedTags = angular.copy(vm.assignedTags);
      vm.triggerdiv($event, 'CustomerTags');
    }

    function openBillingTags($event) {
      vm.tagDialogTarget = 'billing';
      vm.tempAssignedTags = angular.copy(vm.billingAssignedTags);
      vm.triggerdiv($event, 'CustomerTags');
    }

    function openTravellerTags($event) {
      vm.tagDialogTarget = 'traveller';
      vm.tempAssignedTags = angular.copy(vm.travellerAssignedTags);
      vm.triggerdiv($event, 'CustomerTags');
    }

    function getTagDialogPersonName() {
      if (vm.tagDialogTarget === 'billing') {
        return (vm.reservation_customer.first_name || '') + ' ' + (vm.reservation_customer.last_name || '');
      }
      if (vm.tagDialogTarget === 'traveller') {
        return (vm.order.first_name || '') + ' ' + (vm.order.last_name || '');
      }
      return (vm.order.first_name || '') + ' ' + (vm.order.last_name || '');
    }

    function getTagDialogPersonEmail() {
      if (vm.tagDialogTarget === 'billing') {
        return vm.reservation_customer.customer_email || '';
      }
      if (vm.tagDialogTarget === 'traveller') {
        return vm.order.customer_email || '';
      }
      return vm.order.customer_email || '';
    }

    function getTagDialogPersonInitials() {
      var first, last;
      if (vm.tagDialogTarget === 'billing') {
        first = (vm.reservation_customer && vm.reservation_customer.first_name) || '';
        last = (vm.reservation_customer && vm.reservation_customer.last_name) || '';
      } else if (vm.tagDialogTarget === 'traveller') {
        first = (vm.order && vm.order.first_name) || '';
        last = (vm.order && vm.order.last_name) || '';
      } else {
        first = (vm.order && vm.order.first_name) || (vm.reservation_customer && vm.reservation_customer.first_name) || '';
        last = (vm.order && vm.order.last_name) || (vm.reservation_customer && vm.reservation_customer.last_name) || '';
      }
      var initials = '';
      if (first.length) initials += first.charAt(0);
      if (last.length) initials += last.charAt(0);
      return initials.toUpperCase();
    }

    function loadBillingAndTravellerTags() {
      var travellerCustomerId = vm.order && vm.order.customer_id;
      var billingCustomerId = vm.reservation_customer && vm.reservation_customer.customer_id;
      var promises = [];

      // Load traveller tags (also populates customer stay card & system/hotel tag lists)
      if (travellerCustomerId) {
        var travellerPromise = eCommerceService.getCustomerTags(travellerCustomerId)
          .then(function (response) {
            if (!response || !response.success) return;
            var tags = [];

            // Populate system tags list (for tag dialog)
            angular.forEach(response.data.systemTags, function (tag) {
              tag.type = 'system';
              if (tag.selected) tags.push(tag);
              if (!vm.systemTags.some(function (t) { return t.id === tag.id; })) {
                vm.systemTags.push(tag);
              }
            });

            // Populate hotel tags list (for tag dialog)
            angular.forEach(response.data.hotelTags, function (tag) {
              tag.type = 'hotel';
              if (tag.selected) tags.push(tag);
              if (!vm.hotelTags.some(function (t) { return t.id === tag.id; })) {
                vm.hotelTags.push(tag);
              }
            });

            var sortedTags = stableSortTags(tags);
            vm.travellerAssignedTags = sortedTags;

            // Customer stay card shows traveller tags
            vm.assignedTags = sortedTags;

            // If same person, billing tags = traveller tags (no extra API call)
            if (billingCustomerId && String(billingCustomerId) === String(travellerCustomerId)) {
              vm.billingAssignedTags = sortedTags;
            }
          });
        promises.push(travellerPromise);
      }

      // Load billing customer tags only if different from traveller
      if (billingCustomerId && String(billingCustomerId) !== String(travellerCustomerId)) {
        var billingPromise = eCommerceService.getCustomerTags(billingCustomerId)
          .then(function (response) {
            if (!response || !response.success) return;
            var tags = [];
            angular.forEach(response.data.systemTags, function (tag) {
              tag.type = 'system';
              if (tag.selected) tags.push(tag);
            });
            angular.forEach(response.data.hotelTags, function (tag) {
              tag.type = 'hotel';
              if (tag.selected) tags.push(tag);
            });
            vm.billingAssignedTags = stableSortTags(tags);
          });
        promises.push(billingPromise);
      }

      return $q.all(promises);
    }

    function getCustomerInitials() {
      var first = (vm.order && vm.order.first_name) || (vm.reservation_customer && vm.reservation_customer.first_name) || '';
      var last = (vm.order && vm.order.last_name) || (vm.reservation_customer && vm.reservation_customer.last_name) || '';

      var initials = '';

      if (first.length) {
        initials += first.charAt(0);
      }

      if (last.length) {
        initials += last.charAt(0);
      }

      return initials.toUpperCase();

    };

    function assignTag(tag, type) {
      if (!vm.tempAssignedTags.some(function (t) {
        return t.id === tag.id;
      })) {
        vm.tempAssignedTags.push(tag);
      }
    }

    function removeAssignedTag(tag) {
      var index = vm.tempAssignedTags.findIndex(function (t) {
        return t.id === tag.id;
      });
      if (index > -1) {
        vm.tempAssignedTags.splice(index, 1);
      }
    }

    function clearAllTags() {
      vm.tempAssignedTags = [];
    }

    function unassignedTagsFilter(tag) {
      if (!vm.tempAssignedTags) return true;
      return !vm.tempAssignedTags.some(function(t) { return t.id === tag.id; });
    }


    /**
     * Whether the Pre-Check-in action icon should render on the order page.
     */
    function canShowPrecheckinIcon() {
      var generalSettings =
        $rootScope.hotelInformation &&
        $rootScope.hotelInformation.settings &&
        $rootScope.hotelInformation.settings.general_settings;

      if (!generalSettings || !generalSettings.is_precheckin_enabled) {
        return false;
      }

      if (vm.room_stay_status !== "Active") {
        return false;
      }

      if (vm.order.type_of_reservation == 'day_reservation') {
        return false;
      }

      return true;
    }

    function openPrecheckinDialog(ev) {
      var confirmationNumber = vm.order.confirmation_number;
      if (!confirmationNumber) {
        toastMessage.showSimpleToast("Confirmation number is missing. Cannot open pre-checkin options.", "error-toast");
        return;
      }
      
      vm.isloading = true;
      eCommerceService.getPrecheckinStatus({ confirmation_number: confirmationNumber })
        .then(function (response) {
          vm.isloading = false;
          if (response && response.success) {
            var availableChannels = [];
            var source = response.source_of_creation ? response.source_of_creation.toLowerCase() : '';
            var emailOptions = (response.email_options || {});
            emailOptions = {
              customer: String(emailOptions.customer || "").trim().toLowerCase(),
              traveler: String(emailOptions.traveler || "").trim().toLowerCase()
            };
            var askEmailChoice = !!response.ask_email_choice &&
              !!emailOptions.traveler &&
              !!emailOptions.customer &&
              emailOptions.traveler !== emailOptions.customer;
            
            if (['pms', 'fe'].indexOf(source) > -1) {
              availableChannels = ['email'];
              if (response.can_send_sms) {
                availableChannels.push('message');
              }
            } else if (['expedia', 'airbnb', 'booking.com'].indexOf(source) > -1) {
              if (response.can_send_email) {
                availableChannels = ['email', 'ota_message'];
                if (response.can_send_sms) {
                  availableChannels.push('message');
                }
              } else {
                availableChannels = ['ota_message'];
              }
            }
            
            if (availableChannels.length === 0) {
              toastMessage.showSimpleToast("No pre-checkin options available for this reservation source.", "error-toast");
              return;
            }

            if (response.precheckin_url) {
              availableChannels.push('copy_link');
            }

            $mdDialog.show({
              controller: function($scope, $mdDialog) {
                $scope.availableChannels = availableChannels;
                $scope.selectedChannel = availableChannels[0] || '';
                $scope.emailOptions = emailOptions;
                $scope.askEmailChoice = askEmailChoice;
                $scope.emailSource = askEmailChoice ? 'traveler' : '';

                $scope.onChannelChange = function() {
                  if ($scope.selectedChannel === 'email' && $scope.askEmailChoice && !$scope.emailSource) {
                    $scope.emailSource = 'traveler';
                  }
                };

                $scope.setEmailSource = function(sourceKey) {
                  $scope.emailSource = sourceKey;
                };

                $scope.canSend = function() {
                  if (!$scope.selectedChannel) {
                    return false;
                  }
                  if ($scope.selectedChannel === 'email' && $scope.askEmailChoice) {
                    return $scope.emailSource === 'traveler' || $scope.emailSource === 'customer';
                  }
                  return true;
                };
                
                $scope.closeDialog = function() {
                  $mdDialog.cancel();
                };
                
                $scope.sendNotification = function() {
                  if (!$scope.canSend()) {
                    return;
                  }

                  if ($scope.selectedChannel === 'email') {
                    var payload = { channel: 'email' };
                    if ($scope.askEmailChoice) {
                      payload.email_source = $scope.emailSource;
                      payload.recipient_email = $scope.emailSource === 'customer'
                        ? emailOptions.customer
                        : emailOptions.traveler;
                    }
                    $mdDialog.hide(payload);
                    return;
                  }

                  $mdDialog.hide({
                    channel: $scope.selectedChannel
                  });
                };
              },
              templateUrl: 'app/main/apps/e-commerce/views/orders/order/precheckin-dialog.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose: true
            }).then(function(result) {
              var channel = result && result.channel ? result.channel : result;
              if (channel) {
                if (channel === 'copy_link') {
                  var tempInput = document.createElement("input");
                  tempInput.style = "position: absolute; left: -1000px; top: -1000px";
                  tempInput.value = response.precheckin_url;
                  document.body.appendChild(tempInput);
                  tempInput.select();
                  document.execCommand("copy");
                  document.body.removeChild(tempInput);
                  toastMessage.showSimpleToast("Pre-checkin link copied to clipboard.", "success-toast");
                  return;
                }

                var payload = {
                  confirmation_number: confirmationNumber,
                  channel: channel
                };
                if (channel === 'email') {
                  if (result && result.email_source) {
                    payload.email_source = result.email_source;
                  }
                  if (result && result.recipient_email) {
                    payload.recipient_email = result.recipient_email;
                  }
                }

                vm.isloading = true;
                eCommerceService.sendPrecheckinLink(payload).then(function (resp) {
                  vm.isloading = false;
                  if (resp.success) {
                    toastMessage.showSimpleToast(resp.message || "Pre-checkin link sent successfully.", "success-toast");
                  } else {
                    toastMessage.showSimpleToast(resp.message || "Failed to send pre-checkin link.", "error-toast");
                  }
                });
              }
            }).catch(function() {
              // Dialog cancelled
            });
            
          } else {
            toastMessage.showSimpleToast("Failed to fetch pre-checkin status.", "error-toast");
          }
        });
    }

    function updateNegotiatedCustomer(column, confirmation_number, type) {
      if (vm.stateStatus) {
        vm.isloading = true;
        var email = vm.order["customer_email"];
        var value = vm.order[column];
        if (
          column == "state" &&
          typeof value == "undefined" &&
          typeof vm.tempState != "undefined" &&
          vm.tempState != ""
        ) {
          vm.order.state = vm.tempstate;
        }

        if (
          confirmation_number == "" &&
          column != "customerTaxExempt" &&
          column != "travellerTaxExempt"
        ) {
          value = vm.reservation_customer[column];
          email = vm.reservation_customer["customer_email"];
        }

        var first_name =
          type !== undefined && type !== null && type == "customer"
            ? vm.reservation_customer.first_name
            : vm.order.first_name;
        var last_name =
          type !== undefined && type !== null && type == "customer"
            ? vm.reservation_customer.last_name
            : vm.order.last_name;

        if (typeof value != "undefined") {
          var data = {
            reservation_id: vm.reservation_id,
            itinerary_number: vm.itinerary_number,
            column: column,
            value: value,
            confirmation_number: confirmation_number,
            room_confirmation_number: vm.order.confirmation_number,
            first_name: first_name,
            last_name: last_name,
            email: email,
            product_id: vm.order["product_id"],
            customerTravelSame: vm.order.customerTravelSame,
            roomType: vm.pageType,
          };

          var customerId =
            type != undefined && type == "customer"
              ? vm.order.customerId
              : vm.order.travellerId;
          data.customer_id = customerId;

          if (column == "customerTaxExempt" || column == "travellerTaxExempt") {
            vm.taxExemptRequest = true;
            var taxExemptIndicator =
              type == "customer"
                ? vm.order.customerTaxExempt
                : vm.order.travellerTaxExempt;
            data.value = taxExemptIndicator;
            data.type = type;
            data.customerId = vm.order.customerId;
            data.travellerId = vm.order.travellerId;
          }

          eCommerceService
            .updateCustomerReservation(data)
            .then(function (response) {
              if (!response.status && vm.stateStatus) {
                toastMessage.showSimpleToast(
                  "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.",
                  "error-toast"
                );
              } else if (vm.customerSameAsTraveller) {
                // if(type == 'customer'){
                // 	vm.order[column] = vm.reservation_customer[column];
                // }else{
                // 	vm.reservation_customer[column] = vm.order[column];
                // }
              }

              if (
                response.status &&
                (column == "customerTaxExempt" ||
                  column == "travellerTaxExempt")
              ) {
                vm.changedColumn = column;
                var customer_status = vm.order[column] ? "true." : "false.";
                if (column == "customerTaxExempt") {
                  vm.modificationComment =
                    "Customer tax extempt status changed to " + customer_status;
                } else {
                  vm.modificationComment =
                    "Traveller tax extempt status changed to " +
                    customer_status;
                }
                // calculateOrderTotals();
                vm.fetchOrder(vm.order.confirmation_number, "hitRequest");
              } else {
                vm.taxExemptRequest = false;
              }
              vm.isloading = false;
            });
        }
      }
    }

    vm.updateNegotiatedCustomer = updateNegotiatedCustomer;

    function triggerdiv(ev, type) {
      if (type == "Customer" && vm.checkCustomerTravellerSame()) {
        vm.travelCustSame = true;
      }

      if (type == "Traveller") {
        vm.order.send_email_indicator =
          vm.order.send_email_indicator == 1 ? true : false;
        if (vm.order.country) {
          vm.selectedCountryForTraveller = {
            value: vm.order.country.toLowerCase(),
            display: vm.order.country,
          };
        }
        $timeout(function () {
          if (vm.order.state) {
            vm.selectedStateForTraveller = vm.order.state;
          }
        }, 1000);
      }
      vm.tempState = vm.order.state;

      var popUpId = "#my" + type;
      $mdDialog.show({
        contentElement: popUpId,
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
      });
    }

    function checkifCustomerPlus() {}

    function startDateModified(room_stay_from, posIdx) {
      vm.loader[posIdx] = "true";
      var startDate = moment(room_stay_from).format("MM/DD/YYYY");
      var oldStartDate = startDate;
      var endDate = moment(vm.order.pos[posIdx].room_stay_to).format(
        "MM/DD/YYYY"
      );
      /********************************/
      var compareStartDate = new Date(moment(startDate).format());
      var compareEndDate = new Date(moment(endDate).format());
      /********************************/
      startDate = moment.utc(startDate);
      endDate = moment.utc(endDate);
      if (compareEndDate <= compareStartDate) {
        var endNewDate = moment(oldStartDate).add(2, "days");
        vm.order.pos[posIdx].room_stay_to =
          moment(endNewDate).format("MM/DD/YYYY");
      }
      vm.order.pos[posIdx].room_stay_from =
        moment(oldStartDate).format("MM/DD/YYYY");
    }

    function endDateModified(room_stay_to, posIdx, event) {
      vm.loader[posIdx] = "true";
      var endDate = moment(room_stay_to).format("MM/DD/YYYY");
      var startDate = new Date(
        moment(vm.order.pos[posIdx].room_stay_from).format()
      );
      endDate = moment(endDate);
      startDate = moment(startDate);
      vm.order.pos[posIdx].room_stay_to =
        moment(room_stay_to).format("MM/DD/YYYY");
      if (endDate.isBefore(startDate)) {
        toastMessage.showSimpleToast(
          "Checkout date cannot be less than checkin date.",
          "error-toast"
        );
        vm.order.pos[posIdx].room_stay_to =
          originalOrderData.pos[posIdx].room_stay_to;
        // event.preventDefault();
      }
    }

    /************************************************/
    /************** Both date modified ***************/
    /************************************************/
    function dateModifiedBoth(fromDate, toDate, posIdx) {
      var startDate = new Date(moment(fromDate).format());
      var endDate = new Date(moment(toDate).format());
      if (startDate >= endDate) {
        toastMessage.showSimpleToast(
          "Checkin date cannot be greater than or equal to checkout date.",
          "error-toast"
        );
        var oldDate = vm.order.pos[posIdx].to;
        oldDate = moment(oldDate).format("MM/DD/YYYY");
        vm.order.pos[posIdx].room_stay_to = oldDate;
      } else if (endDate <= startDate) {
        toastMessage.showSimpleToast(
          "Checkout date cannot be less than or equal to checkin date.",
          "error-toast"
        );
        var oldDate = vm.order.pos[posIdx].room_stay_to;
        oldDate = moment(oldDate).format("MM/DD/YYYY");
        vm.order.pos[posIdx].room_stay_to = oldDate;
      } else {
        vm.order.pos[posIdx].room_stay_from = fromDate;
        vm.order.pos[posIdx].room_stay_to = toDate;
      }
    }

    function gotoCheckoutFromEditOrder() {
      $sessionStorage["editReservationOrder"] = angular.copy(
        Order.response.reservations
      );
      var tax_status =
        vm.order.currentBilling == "customer"
          ? vm.order.customerTaxExempt
          : vm.order.travellerTaxExempt;
      var associatedWithCustTrav =
        vm.order.currentBilling == "customer"
          ? vm.order.customerId
          : vm.order.travellerId;
      var params = {
        checkin: vm.order.room_stay_from,
        checkout: vm.order.room_stay_to,
        product_id: vm.order.reserv_id,
        product_name: vm.order.product_name,
        product_room_number: vm.order.product_room_number || (vm.tabs_data[vm.selectedIndex] && vm.tabs_data[vm.selectedIndex].product_room_number) || '',
        cartIndex: vm.selectedIndex,
        addServiceForRoom: true,
        taxValue: tax_status,
        pageFrom: "order",
        itinerary_number: Order.response["itinerary_number"],
        confirmation_number: vm.order.confirmation_number,
        associatedWithCustTrav: associatedWithCustTrav,
      };
      $sessionStorage["pageDetails_" + $localStorage["preHotelId"]] = params;
      $state.go("app.resCheckout", params);
    }

    function calculatesubtotal(ec, rate) {
      return commonService.calculatesubtotal(ec, rate);
    }
    function calculatesubtotalPos(qty, rate) {
      return commonService.calculatesubtotalPos(qty, rate);
    }
    function creditCardChanged(event, cardType, payment_method) {
      var result = commonService.creditCardChanged(
        event,
        cardType,
        payment_method,
        vm.allowed_card_types
      );
      vm.notCardType = result.notCardType;
      if (!result.notCardType) vm.payment_method = result.payment_method;
    }
    function checkValidExpDate() {
      if (vm.fieldsIsReadOnly) {
          vm.exp_date_err = false;
          return;
      }
      var obj = {
        method: vm.payment_method["payment_method"],
        cc_exp_year: vm.payment_method["cc_exp_year"],
        cc_exp_date: vm.payment_method["cc_exp_month"],
      };
      var result = commonService.checkValidExpDate(obj);
      vm.exp_date = result.exp_date;
      vm.exp_date_err = result.exp_date_err;
    }
    function back() {
      if (
        $rootScope.previousUrl &&
        $rootScope.previousUrl != "app.resCheckout" &&
        $rootScope.previousUrl != "app.pages_auth_login"
      ) {
        $state.go($rootScope.previousUrl);
      } else {
        $state.go("app.e-commerce.orders");
      }
    }

    function calculateOrderTotals() {
      vm.order = commonService.calculateTotals(vm.order, false, []);
      completeModification();
    }

    function isRoundUpEnable() {
      var settings = $localStorage.hotelgeneralsetting;
      if (!settings || typeof settings !== "object") {
        return false;
      }
      var value = settings.isRoundUpEnable;
      return value === true || value === 1 || value === "1";
    }

    function shouldShowRoundUp() {
      if (!isRoundUpEnable()) {
        return false;
      }
      if (!vm.order || !vm.order.overalltotals) {
        return false;
      }
      var remaining = parseFloat(vm.order.overalltotals.remaining_amount);
      if (isNaN(remaining) || remaining <= 0.01) {
        return false;
      }

      // If remaining is effectively a whole number, no need to add Round Up.
      // (Using tolerance to avoid float issues.)
      return Math.abs(remaining - Math.round(remaining)) >= 0.009;
    }

    function getRoundUpForCharityAmount() {
      if (!isRoundUpEnable()) {
        return 0;
      }
      if (!vm.order || !vm.order.pos) {
        return 0;
      }
      var posList = Array.isArray(vm.order.pos)
        ? vm.order.pos
        : Object.keys(vm.order.pos).map(function (k) {
            return vm.order.pos[k];
          });
      if (!posList.length) {
        return 0;
      }
      var total = 0;
      posList.forEach(function (p) {
        if (!p) {
          return;
        }
        var nameNorm = String(p.product_name || p.fe_display_product_name || "")
          .toLowerCase()
          .replace(/\s+/g, " ")
          .trim();
        if (nameNorm !== "round up for charity") {
          return;
        }
        if (String(p.room_stay_status || "").toLowerCase() === "canceled") {
          return;
        }
        var amt =
          parseFloat(p.subtotal) ||
          parseFloat(p.nightlySum) ||
          0;
        if (!isNaN(amt)) {
          total += amt;
        }
      });
      return total;
    }

    function applyRemainingRoundUp() {
      if (!vm.order || vm.modify_request || vm.isloading) {
        return;
      }
      if (vm.autoFillOff) {
        toastMessage.showSimpleToast(
          "Amounts cannot be modified in the current view.",
          "warning-toast"
        );
        return;
      }

      var remaining = parseFloat(vm.order.overalltotals.remaining_amount);
      if (isNaN(remaining)) {
        return;
      }

      // Round UP to the next whole number.
      var fractional = Math.abs(remaining) % 1;
      if (fractional < 0.000001) {
        return;
      }

      var roundUpAmount = commonService.roundnum(1 - fractional, 2); // returns string
      var roundUpAmountNum = parseFloat(roundUpAmount);
      if (isNaN(roundUpAmountNum) || roundUpAmountNum <= 0) {
        return;
      }

      var associatedWithCustTrav =
        vm.order.currentBilling == "customer"
          ? vm.order.customerId
          : vm.order.travellerId;

      var existingRoundUpPos = null;
      var posList = [];
      if (vm.order && vm.order.pos) {
        posList = Array.isArray(vm.order.pos)
          ? vm.order.pos
          : Object.keys(vm.order.pos).map(function (k) {
              return vm.order.pos[k];
            });
      }
      if (Array.isArray(posList) && posList.length) {
        existingRoundUpPos = posList.find(function (p) {
          return (
            p &&
            p.product_name &&
            String(p.product_name).toLowerCase() === "round up for charity" &&
            (p.room_stay_status ? p.room_stay_status !== "Canceled" : true)
          );
        });
      }

      var existingRoundUpPosIndex = -1;
      if (Array.isArray(vm.order.pos) && existingRoundUpPos) {
        // Use room_stay_id matching (not object identity) to ensure correct posIdx.
        existingRoundUpPosIndex = vm.order.pos.findIndex(function (p) {
          return (
            p &&
            existingRoundUpPos.room_stay_id != undefined &&
            String(p.room_stay_id) === String(existingRoundUpPos.room_stay_id)
          );
        });
      }

      // If "Round UP" POS already exists, update its price using modify_order_amounts
      // (via calculateOrderTotals -> completeModification), instead of creating a new POS
      // reservation row (which causes MySQL paid_amount NULL insert errors).
      if (existingRoundUpPos) {
        var roundUpPosToUpdate =
          existingRoundUpPosIndex >= 0 && Array.isArray(vm.order.pos)
            ? vm.order.pos[existingRoundUpPosIndex]
            : existingRoundUpPos;

        // Add this click's increment (to next whole dollar on current remaining) on top
        // of the existing Round Up line, instead of replacing with a recomputed ≤$1 cap.
        var existingRoundUpCharge =
          parseFloat(roundUpPosToUpdate.subtotal) ||
          parseFloat(roundUpPosToUpdate.product_price) ||
          parseFloat(roundUpPosToUpdate.customPrice) ||
          parseFloat(roundUpPosToUpdate.grand_total) ||
          0;
        roundUpAmountNum = parseFloat(
          commonService.roundnum(existingRoundUpCharge + roundUpAmountNum, 2)
        );
        if (isNaN(roundUpAmountNum) || roundUpAmountNum <= 0) {
          return;
        }

        // Note: we intentionally do not overwrite paid/remaining amounts here,
        // because backend accounting rules may derive those fields.
        roundUpPosToUpdate.product_name = "Round Up For Charity";
        roundUpPosToUpdate.product_price = roundUpAmountNum;
        roundUpPosToUpdate.customPrice = roundUpAmountNum;
        roundUpPosToUpdate.particularCustomPrice = roundUpAmountNum;
        roundUpPosToUpdate.subtotal = roundUpAmountNum;
        roundUpPosToUpdate.grand_total = roundUpAmountNum;
        roundUpPosToUpdate.nightlySum = roundUpAmountNum;
        roundUpPosToUpdate.quantity = 1;
        roundUpPosToUpdate.customDiscount = 0;
        roundUpPosToUpdate.product_discount = "0.00";
        roundUpPosToUpdate.tax_value = 0;
        roundUpPosToUpdate.tax = "0.00";
        roundUpPosToUpdate.addOnPrice = 0;

        if (Array.isArray(roundUpPosToUpdate.taxes)) {
          roundUpPosToUpdate.taxes.forEach(function (t) {
            if (!t) return;
            t.tax_value = 0;
            t.tax_amount = 0;
            t.tax_amt = 0;
            t.tax = 0;
          });
        }
        if (existingRoundUpPosIndex >= 0) {
          // Use the same update flow as normal POS subtotal edits.
          // This sets processRequest, modificationComments, and reservation_status_type properly.
          vm.setShowModifyBtn(
            "RoundUp",
            "subtotal",
              roundUpPosToUpdate.room_stay_id,
            "pos",
            existingRoundUpPosIndex
          );
        } else {
          // Fallback: backend still needs the correct POS room_stay_id in additional_data.
          vm.processRequest = true;
          vm.modificationComments = existingRoundUpPos.room_stay_id
            ? [existingRoundUpPos.room_stay_id]
            : [];
          vm.dateKey = -1;
          vm.modificationComment = "Round UP price updated";
          vm.changedColumn = "subtotal";
        }

        // Then recalc + submit modifyOrderAmounts
        calculateOrderTotals();
        return;
      }

      var customProductId =
        "round_up_" +
        (vm.order.confirmation_number || "") +
        "_" +
        Date.now();

      // If "Round UP" POS already exists, reuse its product_id and update only values.
      // Otherwise, create a new custom POS product entry.
      var posItem = existingRoundUpPos
        ? angular.copy(existingRoundUpPos)
        : {
            room_stay_status: "Active",
            customDiscount: 0,
            customPrice: roundUpAmountNum,
            media: "",
            product_id: customProductId,
            product_is_timebound: "0",
            product_name: "Round Up For Charity",
            product_price: roundUpAmountNum,
            product_type: "pos",
            quantity: 1,
            tax_value: 0,
            tax_name: "",
            tax_id: "",
            total: 0,
            product_discount: "0.00",
            is_custom_product: true,
            taxes: [
              {
                tax_id: "",
                tax_name: "",
                tax_value: 0,
                tax_amount: 0,
                tax_amt: 0,
                tax: 0,
              },
            ],
            addOnPrice: 0,
            customDiscountPercentage: 0,
            particularCustomPrice: roundUpAmountNum,
            tax: "0.00",
            product_discount_comment: "",
            pos_deposit_type_indicator: "full",
            pos_deposit_amount: 0,
            remaining_amount: roundUpAmountNum,
            additional_guest_amounts: 0,
            grand_total: roundUpAmountNum,
            original_deposit_amt: "0.00",
            orig_tax_value: 0,
            nightlySum: roundUpAmountNum,
          };

      posItem.product_id = existingRoundUpPos ? existingRoundUpPos.product_id : posItem.product_id;
      posItem.product_name = "Round Up For Charity";
      posItem.product_price = roundUpAmountNum;
      posItem.customPrice = roundUpAmountNum;
      posItem.particularCustomPrice = roundUpAmountNum;
      posItem.remaining_amount = roundUpAmountNum;
      posItem.grand_total = roundUpAmountNum;
      posItem.nightlySum = roundUpAmountNum;
      posItem.quantity = 1;
      posItem.is_custom_product = true;
      posItem.tax_value = 0;
      posItem.tax = "0.00";
      if (Array.isArray(posItem.taxes)) {
        posItem.taxes.forEach(function (t) {
          if (!t) return;
          t.tax_value = 0;
          t.tax_amount = 0;
          t.tax_amt = 0;
          t.tax = 0;
        });
      }

      var cartDetails = {
        overalltotals: {
          totalTip: "0.00",
          subtotal: roundUpAmountNum.toFixed(2),
          discount: "0.00",
          tax: "0.00",
          grand_total: roundUpAmountNum.toFixed(2),
          discount_amount: "0.00",
          product_discount: "0.00",
          remaining_amount: roundUpAmountNum.toFixed(2),
          deposit_amount: "0.00",
        },
        payment_method_common: 1,
        product_id: 0,
        normal_occupancy: 0,
        per_night_additional_amount: 0,
        product_name: "",
        room_type_id: 0,
        additional_guest_amounts: 0,
        from: "",
        to: "",
        nights: 0,
        room_stay_guest_count: 0,
        room_stay_child_count: 0,
        discount_percentage: 0,
        taxes: [],
        grand_total: roundUpAmountNum,
        other_rate_policies: null,
        selelected_policy: null,
        selelected_policy_id: 0,
        nightlySum: roundUpAmountNum,
        discount_amount: 0,
        prices: [],
        room_deposit_type_indicator: 0,
        room_deposit_percentage: 0,
        room_deposit_amount: 0,
        deposit_amount: 0,
        remaining_amount: roundUpAmountNum,
        original_deposit_amt: 0,
        comment: "",
        cust_info: vm.reservation_customer,
        product_discount: "0.00",
        product_discount_comment: [],
        pos: {
          0: posItem
        },
        associatedWithCustTrav: associatedWithCustTrav
      };

      vm.modify_request = true;
      vm.isloading = true;

      createResService
        .createReservation({
          cartdetails: {
            0: cartDetails,
          },
          paymentMethod: vm.payment_method,
          payment_method_common: null,
          customer_info: vm.reservation_customer,
          itinerary_number: vm.itinerary_number,
          confirmation_number: vm.order.confirmation_number,
          onlyPos: false,
          fuctionType: "addingExtraServices",
        })
        .then(function (response) {
          vm.modify_request = false;
          vm.isloading = false;

          if (!response) {
            toastMessage.showSimpleToast(
              "No response from server. Please try again.",
              "error-toast"
            );
            return;
          }

          if (response.server_error) {
            toastMessage.showSimpleToast(
              response.server_error,
              "error-toast"
            );
            return;
          }

          if (response.errorMsg) {
            toastMessage.showSimpleToast(response.errorMsg, "error-toast");
            return;
          }

          if (response.success) {
            vm.showModifyBtn = false;
            vm.showPaymentsLoader = true;
            fetchOrder(vm.order.confirmation_number, "hitRequest");
          } else {
            toastMessage.showSimpleToast(
              response.errorMsg || "Round Up failed. Please try again.",
              "error-toast"
            );
          }
        })
        .catch(function () {
          vm.modify_request = false;
          vm.isloading = false;
          toastMessage.showSimpleToast(
            "Round Up failed. Please try again.",
            "error-toast"
          );
        });
    }

    function calculatePOSTotals(posIndex, action) {
      if (
        vm.order.pos[posIndex].nightlySum == "" ||
        typeof vm.order.pos[posIndex].nightlySum == "undefined"
      ) {
        vm.order.pos[posIndex].nightlySum = 0.0;
      }
      if (
        vm.order.pos[posIndex].quantity == "" ||
        vm.order.pos[posIndex].quantity == 0 ||
        typeof vm.order.pos[posIndex].quantity == "undefined"
      ) {
        vm.order.pos[posIndex].quantity = 1;
      }
      vm.order.pos[posIndex] = commonService.calculatePOSTotals(
        posIndex,
        false,
        vm.order
      );
      if (action == "call") calculateOrderTotals();
    }
    function changeProductDiscount(posIndex, action) {
      if (
        vm.order.pos[posIndex].product_discount == "" ||
        typeof vm.order.pos[posIndex].product_discount == "undefined"
      ) {
        vm.order.pos[posIndex].product_discount = 0.0;
      }
      vm.order.pos[posIndex].product_discount = parseFloat(
        vm.order.pos[posIndex].product_discount
      );
      if (vm.order.pos[posIndex].product_is_timebound == 1)
        var checkAmount = vm.order.pos[posIndex].nightlySum;
      else
        var checkAmount =
          parseFloat(vm.order.pos[posIndex].nightlySum) *
          parseInt(vm.order.pos[posIndex].quantity);
      if (
        parseFloat(vm.order.pos[posIndex].product_discount) >
        parseFloat(checkAmount)
      ) {
        vm.order.pos[posIndex].product_discount = checkAmount;
      }
      calculatePOSTotals(posIndex, action);
    }
    function sumnightlyDisc(index) {
      if (
        vm.order.prices.nightlydiscount[index] == "" ||
        typeof vm.order.prices.nightlydiscount[index] == "undefined"
      ) {
        vm.order.prices.nightlydiscount[index] = 0.0;
      }
      if (
        parseFloat(vm.order.prices.nightlydiscount[index]) >
        parseFloat(vm.order.prices.rates[index])
      ) {
        vm.order.prices.nightlydiscount[index] = commonService.roundnum(
          vm.order.prices.rates[index],
          2
        );
      }
      var returnObj = commonService.sumnightlyDisc(vm.order);

      vm.order.product_discount = returnObj.product_discount;
      vm.order.prices.nightlydiscount = returnObj.nightlydiscount;
      calculateOrderTotals();
    }
    function sumnightlyDiscPOS(index, poskey, datekey, action, nightIndex) {
      // vm.processRequest = false;
      var thisCart = angular.copy(vm.order.pos[poskey]);
      if (
        thisCart.prices.nightlydiscount[nightIndex] == "" ||
        typeof thisCart.prices.nightlydiscount[nightIndex] == "undefined"
      ) {
        // vm.processRequest = false;
        thisCart.prices.nightlydiscount[nightIndex] = 0.0;
      }
      if (
        parseFloat(thisCart.prices.nightlydiscount[nightIndex]) >
        parseFloat(thisCart.prices.rates[nightIndex])
      ) {
        thisCart.prices.nightlydiscount[nightIndex] =
          thisCart.prices.rates[nightIndex];
      }
      if (thisCart.prices.nightlydiscount[nightIndex] == 0) {
        // vm.processRequest = false;
        thisCart.prices.nightlydiscountcomment[nightIndex] = "";
      }
      var returnObj = commonService.sumnightlyDisc(thisCart);
      thisCart.product_discount = returnObj.product_discount;
      thisCart.prices.nightlydiscount = returnObj.nightlydiscount;
      vm.order.pos[poskey] = thisCart;
      calculatePOSTotals(poskey, action);
    }
    function setAdults() {
      if (
        originalOrderData["room_stay_child_count"] !=
          vm.order["room_stay_child_count"] ||
        originalOrderData["room_stay_guest_count"] !=
          vm.order["room_stay_guest_count"]
      ) {
        vm.order = commonService.setAdults(
          vm.order,
          "",
          [],
          vm.is_child_allowed
        );
        vm.order["extraPersonPos"] = Order["response"]["extraPersonPos"];
        calculateOrderTotals();
      } else {
        vm.order = angular.copy(originalOrderData);
        vm.order["extraPersonPos"] = Order["response"]["extraPersonPos"];
      }
    }

    function roomovesetAdults(roomMoveIndex) {
      vm.order.room_moves[roomMoveIndex] = commonService.setAdults(
        vm.order.room_moves[roomMoveIndex]
      );
      calculateOrderTotals();
    }

    function breakIntoNights() {
      vm.order = commonService.breakIntoNights(vm.order);
      calculateOrderTotals();
    }

    function roomovebreakIntoNights(roomMoveIndex) {
      vm.order.room_moves[roomMoveIndex] = commonService.breakIntoNights(
        vm.order.room_moves[roomMoveIndex]
      );
      calculateOrderTotals();
    }

    function roomovechangeDiscAmt(roomMoveIndex) {
      var returnedObj = commonService.changeDiscAmt(
        vm.order.room_moves[roomMoveIndex]
      );
      vm.order.room_moves[roomMoveIndex].discount_amount =
        returnedObj.discount_amount;
      vm.order.room_moves[roomMoveIndex].discount_percentage =
        returnedObj.discount_percentage;
      calculateOrderTotals();
    }

    function changeDiscAmtPOS(poskey, action) {
      var thisCart = angular.copy(vm.order.pos[poskey]);
      var newDiscPer =
        (parseFloat(thisCart.discountAmt) * 100) /
        parseFloat(thisCart.nightlySum * thisCart.quantity);
      newDiscPer = commonService.roundnum(newDiscPer, 2);
      thisCart.discountPer = newDiscPer;
      vm.order.pos[poskey] = angular.copy(thisCart);
      calculatePOSTotals(poskey, "call");
    }

    function changeDiscAmt() {
      var returnedObj = commonService.changeDiscAmt(vm.order);
      vm.order.discount_amount = returnedObj.discount_amount;
      vm.order.discount_percentage = returnedObj.discount_percentage;
      calculateOrderTotals();
    }

    function roomovesumNights() {
      vm.order.room_moves[roomMoveIndex].nightlySum = commonService.sumNights(
        vm.order.room_moves[roomMoveIndex]
      );
      calculateOrderTotals();
    }

    function sumNights(index) {
      if (
        parseFloat(vm.order.prices.nightlydiscount[index]) >
        parseFloat(vm.order.prices.rates[index])
      ) {
        vm.order.prices.nightlydiscount[index] = commonService.roundnum(
          vm.order.prices.rates[index],
          2
        );
        var returnObj = commonService.sumnightlyDisc(vm.order);
        vm.order.product_discount = returnObj.product_discount;
        vm.order.prices.nightlydiscount = returnObj.nightlydiscount;
      }
      var returnObj = commonService.sumNights(vm.order);
      vm.order.nightlySum = returnObj.nightlySum;
      vm.order.prices.rates = returnObj.rates;
      calculateOrderTotals();
    }
    vm.modificationComment = "";
    vm.changedColumn = "";
    function completeModification() {
      vm.isloading = false;
      if (vm.processRequest) {
        angular.forEach($http.pendingRequests, function (request) {
          if (request.cancel && request.timeout) {
            request.cancel.resolve();
          }
        });
        vm.modificationComments.push(vm.order.room_stay_id);
        vm.isloading = true;
        var requestData = angular.copy(vm.order);
        delete requestData.skipResortFeeRecalc;
        delete vm.order.skipResortFeeRecalc;
        requestData["order_history_comment"] =
          "AMOUNTS_MODIFED_MANUALLY_FROM_PMS";
        var data = {
          order_info: requestData,
          id: Reservation_id,
          additional_data: vm.modificationComments,
          dateKey: vm.dateKey,
          modification_comment: vm.modificationComment,
          changed_column: vm.changedColumn,
        };
        vm.modify_request = true;
        // Add flag for email
        if (vm.changedColumn == "resort_fee") {
          data.sendPosEmail = $scope.conSendEmailIndicator;
        }
        eCommerceService.modifyOrderAmounts(data).then(function (response) {
          try {
            vm.modify_request = false;
            vm.isloading = false;
            vm.showModifyBtn = false;
            vm.showDiscountEdit = false;
            if (
              response != undefined &&
              response.roomMerged != undefined &&
              response.roomMerged != ""
            ) {
              $stateParams.confirmation_number = response.roomMerged;
              $state.transitionTo($state.current, $stateParams, {
                reload: true,
                inherit: false,
                notify: true,
              });
            } else {
              if (
                typeof response != "undefined" &&
                response != "" &&
                response.order_info
              ) {
                vm.order = response.order_info.reservations[0];
                vm.resortFeeApplied[vm.selectedIndex] =
                  vm.order.resortFeeApplied;
                applyWaitingDisplayStatus();
                setAllStatuses();
                originalOrderData = angular.copy(vm.order);
                vm.showModifyBtn = false;
                vm.showPaymentsLoader = true;
                $timeout(function () {
                  fetchPaymentsInformation(
                    vm.order.confirmation_number,
                    vm.order.first_name,
                    vm.order.last_name,
                    vm.order.total_amount,
                    vm.order.overalltotals.remaining_amount
                  );
                }, 100);
                vm.initializeOrderPosData(vm.order);
              } else {
                vm.modify_request = false;
                vm.isloading = false;
                vm.showDiscountEdit = true;
                vm.order = angular.copy(originalOrderData);
              }
            }
          } catch (err) {
            vm.modify_request = false;
            vm.isloading = false;
            vm.showDiscountEdit = true;
            vm.order = angular.copy(originalOrderData);
          }
        });
      } else {
        vm.isloading = false;
        vm.showModifyBtn = false;
        vm.showDiscountEdit = false;
        vm.isloading = false;
      }
    }
    /*Divide nightly Sum*/
    vm.sumNightsPOS = sumNightsPOS;
    vm.datesChanged = datesChanged;
    function sumNightsPOS(poskey, action) {
      var thisCart = angular.copy(vm.order.pos[poskey]);
      var nightlyAll = thisCart.prices.rates;
      var nightlySum = 0;
      var discountAmt = thisCart.discountAmt;
      for (var i = 0; i < nightlyAll.length; i++) {
        nightlySum += parseFloat(nightlyAll[i]);
        thisCart.prices.rates[i] = commonService.roundnum(nightlyAll[i], 2);
      }
      thisCart.nightlySum = commonService.roundnum(nightlySum, 2);
      vm.order.pos[poskey] = thisCart;
      vm.order.pos[poskey] = commonService.calculatePOSTotals(
        poskey,
        true,
        vm.order
      );
      if (action == "call") calculateOrderTotals();
    }

    function datesChanged(posIdx) {
      var thisCart = vm.order.pos[posIdx];
      var origCart = originalOrderData.pos[posIdx];
      var new_room_stay_to = moment(thisCart.room_stay_to);
      var new_room_stay_from = moment(thisCart.room_stay_from);
      var old_room_stay_to = moment(origCart.room_stay_to);
      var old_room_stay_from = moment(origCart.room_stay_from);
      var nightly = thisCart.prices.rates;
      var dates = [];
      var rates = [];
      if (
        new_room_stay_to != old_room_stay_to ||
        new_room_stay_from != old_room_stay_from
      ) {
        var nights = new_room_stay_to.diff(new_room_stay_from, "days");
        var last_rate = 0;
        for (
          var m = moment(new_room_stay_from), k = 0;
          m.isBefore(new_room_stay_to);
          m.add("days", 1), k++
        ) {
          if (m.format("MM-DD-YYYY") == new_room_stay_to.format("MM-DD-YYYY"))
            break;
          dates.push(m.format("MM-DD-YYYY"));
          if (nightly[k] !== undefined) {
            rates.push(nightly[k]);
            last_rate = nightly[k];
          } else {
            rates.push(last_rate);
          }
        }
      }
      vm.order.pos[posIdx].prices.rates = rates;
      vm.order.pos[posIdx].prices.dates = dates;
      sumNightsPOS(posIdx);
      calculatePOSTotals(posIdx, "call");
    }

    function setShowModifyBtn(
      changedColumn,
      columnName,
      room_stay_id,
      type,
      posIdx,
      from
    ) {
      vm.processRequest = true;
      vm.modificationComments = [];
      vm.dateKey = -1;
      vm.modificationComments.push(room_stay_id);
      if (
        vm.order.resortFeePos != undefined &&
        vm.order.resortFeePos.room_stay_id != undefined
      ) {
        vm.modificationComments.push(vm.order.resortFeePos.room_stay_id);
      }

      if (
        columnName == "additional_guest_amounts" &&
        (/[a-zA-Z]/.test(vm.order.additional_guest_amounts) ||
          vm.order.additional_guest_amounts < 0 ||
          isNaN(vm.order.additional_guest_amounts))
      ) {
        vm.order.additional_guest_amounts = commonService.roundnum(
          originalOrderData.additional_guest_amounts,
          2
        );
        vm.processRequest = false;
        return;
      }
      if (
        (typeof type == "undefined" || type == "undefined" || type == "") &&
        (columnName == "prices" || columnName == "nightlydiscount")
      ) {
        var ind = changedColumn.split("-");
        vm.dateKey = ind[1];
        if (columnName == "prices") {
          var tempNumber = (vm.order.prices.rates[ind[1]] = parseFloat(
            vm.order.prices.rates[ind[1]]
          ));
          if (
            /[a-zA-Z]/.test(vm.order.prices.rates[ind[1]]) ||
            tempNumber < 0 ||
            isNaN(tempNumber) ||
            (commonService.roundnum(
              originalOrderData.prices.rates[ind[1]],
              2
            ) == commonService.roundnum(tempNumber, 2) &&
              (typeof from == "undefined" || from != "nightly_discount"))
          ) {
            vm.order.prices.rates[ind[1]] = commonService.roundnum(
              originalOrderData.prices.rates[ind[1]],
              2
            );
            vm.processRequest = false;
            return;
          }

          if (vm.order.prices.rates[ind[1]] < 0) {
            vm.order.prices.rates[ind[1]] = commonService.roundnum(
              originalOrderData.prices.rates[ind[1]],
              2
            );
          } else {
            vm.order.prices.rates[ind[1]] = commonService.roundnum(
              vm.order.prices.rates[ind[1]],
              2
            );
          }
          vm.order.reservation_status_type =
            "Room-" + changedColumn + "-" + columnName;
          vm.modificationComment =
            "Price of night " +
            (parseFloat(ind[1]) + parseFloat(1)) +
            " changed from " +
            commonService.roundnum(originalOrderData.prices.rates[ind[1]], 2) +
            " to " +
            commonService.roundnum(vm.order.prices.rates[ind[1]], 2);
        } else {
          var tempNumber = parseFloat(vm.order.prices.nightlydiscount[ind[1]]);
          if (
            /[a-zA-Z]/.test(tempNumber) ||
            tempNumber < 0 ||
            isNaN(tempNumber) ||
            (commonService.roundnum(
              originalOrderData.prices.nightlydiscount[ind[1]],
              2
            ) == commonService.roundnum(tempNumber, 2) &&
              (typeof from == "undefined" || from != "nightly_discount"))
          ) {
            vm.order.prices.nightlydiscount[ind[1]] = commonService.roundnum(
              originalOrderData.prices.nightlydiscount[ind[1]],
              2
            );
            vm.processRequest = false;
            return;
          }

          if (tempNumber < 0) {
            vm.order.prices.nightlydiscount[ind[1]] = commonService.roundnum(
              originalOrderData.prices.nightlydiscount[ind[1]],
              2
            );
          } else {
            vm.order.prices.nightlydiscount[ind[1]] = commonService.roundnum(
              vm.order.prices.nightlydiscount[ind[1]],
              2
            );
          }
          vm.modificationComment =
            "Discount of night " +
            (parseFloat(ind[1]) + parseFloat(1)) +
            " changed from " +
            commonService.roundnum(
              originalOrderData.prices.nightlydiscount[ind[1]],
              2
            ) +
            " to " +
            commonService.roundnum(vm.order.prices.nightlydiscount[ind[1]], 2);
          vm.order.reservation_status_type =
            "Room-" + changedColumn + "-" + columnName;
        }
      } else if (type == "pos") {
        if (columnName == "product_discount" || columnName == "quantity") {
          var tempNumber = parseFloat(vm.order.pos[posIdx][columnName]);
          if (
            /[a-zA-Z]/.test(vm.order.pos[posIdx][columnName]) ||
            tempNumber < 0 ||
            isNaN(tempNumber) ||
            commonService.roundnum(vm.order.pos[posIdx][columnName], 2) ==
              commonService.roundnum(
                originalOrderData.pos[posIdx][columnName],
                2
              )
          ) {
            vm.processRequest = false;
          }
        }
        if (columnName == "nightlydiscount") {
          var ind = changedColumn.split("-");
          vm.dateKey = ind[1];
          vm.modificationComment =
            originalOrderData.pos[posIdx]["product_name"] +
            " discount for night " +
            ind[1] +
            " changed  from " +
            originalOrderData.pos[posIdx]["prices"]["nightlydiscount"][
              parseFloat(ind[1]) - parseFloat(1)
            ] +
            " to " +
            commonService.roundnum(
              vm.order.pos[posIdx]["prices"]["nightlydiscount"][
                parseFloat(ind[1]) - parseFloat(1)
              ],
              2
            );
          vm.order.pos[posIdx].reservation_status_type =
            "Pos-" + changedColumn + "-" + columnName;
        } else if (columnName == "product_discount") {
          vm.modificationComment =
            originalOrderData.pos[posIdx]["product_name"] +
            " discount changed  from " +
            originalOrderData.pos[posIdx][columnName] +
            " to " +
            commonService.roundnum(vm.order.pos[posIdx][columnName], 2);
          vm.order.pos[posIdx].reservation_status_type =
            "Pos-" + posIdx + "-" + columnName;
        } else if (columnName == "subtotal") {
          vm.modificationComment =
            originalOrderData.pos[posIdx]["product_name"] +
            " price changed  from " +
            originalOrderData.pos[posIdx][columnName] +
            " to " +
            commonService.roundnum(vm.order.pos[posIdx][columnName], 2);
          vm.order.pos[posIdx].reservation_status_type =
            "Pos-" + posIdx + "-" + columnName;
        } else if (columnName == "quantity") {
          vm.modificationComment =
            originalOrderData.pos[posIdx]["product_name"] +
            " quantity changed  from " +
            originalOrderData.pos[posIdx][columnName] +
            " to " +
            vm.order.pos[posIdx][columnName];
          vm.order.pos[posIdx].reservation_status_type =
            "Pos-" + posIdx + "-" + columnName;
        } else if (columnName == "room_stay_to") {
          vm.modificationComment =
            originalOrderData.pos[posIdx]["product_name"] +
            " end date changed  from " +
            originalOrderData.pos[posIdx][columnName] +
            " to " +
            vm.order.pos[posIdx][columnName];
          vm.order.pos[posIdx].reservation_status_type =
            "Pos-" + posIdx + "-" + columnName;
        } else if (columnName == "room_stay_from") {
          vm.modificationComment =
            originalOrderData.pos[posIdx]["product_name"] +
            " start date changed from " +
            originalOrderData.pos[posIdx][columnName] +
            " to " +
            vm.order.pos[posIdx][columnName];
          vm.order.pos[posIdx].reservation_status_type =
            "Pos-" + posIdx + "-" + columnName;
        } else if (columnName == "room_stay_from-room_stay_to") {
          var columnArr = columnName.split("-");
          vm.modificationComment =
            originalOrderData.pos[posIdx]["product_name"] +
            " start-end dates changed from " +
            originalOrderData.pos[posIdx][columnArr[0]] +
            " - " +
            originalOrderData.pos[posIdx][columnArr[1]] +
            " to " +
            vm.order.pos[posIdx][columnArr[0]] +
            " - " +
            vm.order.pos[posIdx][columnArr[1]];
          vm.order.pos[posIdx].reservation_status_type =
            "Pos-" + posIdx + "-" + columnName;
        } else {
          var ind = changedColumn.split("-");
          vm.dateKey = ind[1];
          vm.modificationComment =
            originalOrderData.pos[posIdx]["product_name"] +
            " price for night " +
            ind[1] +
            " changed  from " +
            commonService.roundnum(
              originalOrderData.pos[posIdx]["prices"]["rates"][
                parseFloat(ind[1]) - parseFloat(1)
              ],
              2
            ) +
            " to " +
            commonService.roundnum(
              vm.order.pos[posIdx]["prices"]["rates"][
                parseFloat(ind[1]) - parseFloat(1)
              ],
              2
            );
          vm.order.pos[posIdx].reservation_status_type =
            "Pos-" + changedColumn + "-" + columnName;
        }
      } else {
        if (changedColumn == "ExtraCharges") changedColumn = "Extra charges";
        vm.modificationComment =
          changedColumn +
          " changed from " +
          commonService.roundnum(originalOrderData[columnName], 2) +
          " to " +
          commonService.roundnum(vm.order[columnName], 2);
      }
      vm.changedColumn = columnName;
      vm.initializeOrderPosData(vm.order);
    }

    function cancelModification() {
      vm.showModifyBtn = false;
      vm.endDateMin = new Date(
        vm.myDate.getFullYear(),
        vm.myDate.getMonth(),
        vm.myDate.getDate()
      );
      vm.showDiscountEdit = false;
      vm.order = angular.copy(originalOrderData);
    }

    function mainTabChanged(ev, orderIndex) {
      vm.showCustomerTravellerBillInfo = false;
      vm.selectedIndex = orderIndex;
      if (!vm.mainTabChangedAuto) {
        cancelChangeStatus();
        cancelModification();
      }
      vm.mainTabChangedAuto = false;
      vm.customeropened = false;
      vm.traveleropened = false;
      vm.commentsSpecial = {
        comment: [],
        special_request: [],
        posComment: [],
      };
      vm.showDiscountEdit = false;
    }
    function changeStatusForService(
      ev,
      confirmation_number,
      oldStatus,
      newStatus,
      rmMvIdx,
      grand_total,
      room_confirmation_number,
      paidAmount,
      total_amount,
      type,
      posValue
    ) {
      var event = "";
      if (newStatus == "Canceled") {
        var label = "Cancel";
      } else {
        var label = "Active";
      }
      var showStatus = newStatus;
      if (
        posValue.extra_attribute != undefined &&
        posValue.extra_attribute == "resort_fee"
      ) {
        showStatus = showStatus == "Active" ? "Applied" : "Cancel";
      }
      $mdDialog.show({
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: false,
        scope: $scope,
        preserveScope: true,
        locals: {
          data: {
            title: label + " order",
            htmlContent:
              "Are you sure want to change status of #" +
              confirmation_number +
              " to " +
              showStatus +
              "?",
            cancelBtn: "No",
            OkBtn: "Yes",
            sendEmailIndicator: vm.order.send_email_indicator,
          },
        },
        templateUrl:
          "app/main/apps/e-commerce/views/orders/dialogs/status/pos-confirm.html",
        controller: ConfirmPosController,
      });
      // .then(function(answer) {
      // 	if(typeof answer != 'undefined' && answer == 'update'){
      // 		$mdDialog.hide();
      // 		if(posValue.extra_attribute != undefined && posValue.extra_attribute == 'resort_fee') {
      // 			vm.updateResortFeeNew(0, 'status', newStatus);
      // 		} else {
      // 			changeStatusForServiceFinally(
      // 				oldStatus,newStatus,confirmation_number,grand_total,
      // 				room_confirmation_number,paidAmount,total_amount,rmMvIdx ,
      // 				posValue.room_stay_from,posValue.room_stay_to,posValue.product_id,posValue.is_timebound_with_availability);
      // 		}
      // 	} else if(typeof answer != 'undefined' && (answer == 'close' || answer == 'no')){
      // 		if(posValue.extra_attribute != undefined && posValue.extra_attribute == 'resort_fee') {
      // 			// vm.pos_status[rmMvIdx] = (parseFloat(posValue.nightlySum) > 0 && posValue.room_stay_status == "Active") ? 'Active' : 'Canceled';
      // 			vm.pos_status[rmMvIdx] = (parseFloat(posValue.nightlySum) > 0) ? 'Applied' : 'Removed';

      // 		} else {
      // 			vm.pos_status[rmMvIdx] = oldStatus;
      // 		}
      // 		$mdDialog.hide();
      // 	}
      // 	vm.initializeOrderPosData(vm.order);
      // }, function(dialogText) {
      // 	vm.pos_status[rmMvIdx] = oldStatus;
      // 	$mdDialog.hide();
      // })

      function ConfirmPosController($mdDialog, data) {
        $scope.conTitle = data.title;
        $scope.conHtmlContent = data.htmlContent;
        // $scope.conSendEmailIndicator = (data.sendEmailIndicator) ? true :false;
        $scope.conSendEmailIndicator = false;
        $scope.CancelbtnTxt = "Cancel";
        $scope.OkbtnTxt = "Ok";
        $scope.onGoingRequest = false;
        if (data.cancelBtn != "") {
          $scope.CancelbtnTxt = data.cancelBtn;
        }

        if (data.OkBtn != "") {
          $scope.OkbtnTxt = data.OkBtn;
        }
        // Close pos
        $scope.closePosDialog = function () {
          if (
            posValue.extra_attribute != undefined &&
            posValue.extra_attribute == "resort_fee"
          ) {
            // vm.pos_status[rmMvIdx] = (parseFloat(posValue.nightlySum) > 0 && posValue.room_stay_status == "Active") ? 'Active' : 'Canceled';
            vm.pos_status[rmMvIdx] =
              parseFloat(posValue.nightlySum) > 0 ? "Applied" : "Removed";
          } else {
            vm.pos_status[rmMvIdx] = oldStatus;
          }
          $mdDialog.hide();
          vm.initializeOrderPosData(vm.order);
        };

        // Confirm
        $scope.confirmPosAction = function () {
          this.onGoingRequest = true;
          $mdDialog.hide();
          if (
            posValue.extra_attribute != undefined &&
            posValue.extra_attribute == "resort_fee"
          ) {
            vm.updateResortFeeNew(0, "status", newStatus);
          } else {
            changeStatusForServiceFinally(
              oldStatus,
              newStatus,
              confirmation_number,
              grand_total,
              room_confirmation_number,
              paidAmount,
              total_amount,
              rmMvIdx,
              posValue.room_stay_from,
              posValue.room_stay_to,
              posValue.product_id,
              posValue.is_timebound_with_availability,
              $scope.conSendEmailIndicator
            );
          }
          vm.initializeOrderPosData(vm.order);
        };
      }
    }

    function changeStatusForServiceFinally(
      oldStatus,
      newStatus,
      confirmation_number,
      grand_total,
      room_confirmation_number,
      paidAmount,
      total_amount,
      rmMvIdx,
      room_stay_from,
      room_stay_to,
      product_id,
      is_timebound_with_availability,
      conSendEmailIndicator
    ) {
      vm.isloading = true;
      var requestDataForCancel = {
        confirmation_number: confirmation_number,
        room_stay_status: newStatus,
        grand_total: grand_total,
        paidAmount: paidAmount,
        total_amount: total_amount,
        room_confirmation_number: room_confirmation_number,
        room_stay_from: room_stay_from,
        room_stay_to: room_stay_to,
        product_id: product_id,
        is_timebound_with_availability: is_timebound_with_availability,
        sendPosEmail: conSendEmailIndicator,
      };

      ganttChartService
        .changeStatusForService(requestDataForCancel)
        .then(function (response) {
          if (response.success) {
            vm.order = response.order_info.reservations[0];
            originalOrderData = angular.copy(vm.order);
            vm.room_stay_status = angular.copy(vm.order.room_stay_status);
            vm.statuses = vm.resvStatus;
            vm.statuses[vm.room_stay_status] = vm.room_stay_status;
            vm.showModifyBtn = false;
            vm.showPaymentsLoader = true;

            if (response.statusMsg != "") {
              toastMessage.showSimpleToast(response.statusMsg, "error-toast");
            }
            setAllStatuses();
            $timeout(function () {
              vm.isloading = false;
              fetchPaymentsInformation(
                room_confirmation_number,
                vm.order.first_name,
                vm.order.last_name,
                vm.order.total_amount,
                vm.order.overalltotals.remaining_amount
              );
            }, 100);
            requestDataForCancel["requestFrom"] = "order";
            vm.processAutomaticRefund(requestDataForCancel);
          } else {
            vm.isloading = false;
            var message =
              "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.";
            if (
              typeof response.errorMsg != "undefined" &&
              response.errorMsg != ""
            )
              message = response.errorMsg;
            toastMessage.showSimpleToast(message, "error-toast");
            vm.pos_status[rmMvIdx] = oldStatus;
          }
        });
    }

    function getAllowCheckoutWithPendingDuesSetting() {
      var hotelId =
        vm.currentHotelId ||
        ($localStorage.hotels &&
          $localStorage.hotels[$localStorage.selectedHotel] &&
          $localStorage.hotels[$localStorage.selectedHotel].hotel_id);
      var data = {
        hotel_id: hotelId,
        attribute_code: "allowCheckoutWithPendingDues",
        setting_type: "general",
      };

      return eCommerceService.getGeneralSettings(data).then(
        function (payload) {
          var settings =
            payload && payload.settings ? payload.settings : payload || {};
          var hotelSettings = settings[hotelId] || settings[String(hotelId)];
          var parentSettings = settings[1] || settings["1"];
          var settingValue = readSettingValue(hotelSettings);

          // If child-hotel entry is null/missing, try parent/global value.
          if (isEmptyValue(settingValue)) {
            settingValue = readSettingValue(parentSettings);
          }

          return toBooleanOrDefault(settingValue, true);
        },
        function () {
          // Keep existing checkout flow if settings call fails.
          return true;
        }
      );

      function readSettingValue(settingsObj) {
        if (!settingsObj || typeof settingsObj !== "object") {
          return undefined;
        }
        return settingsObj.allowCheckoutWithPendingDues;
      }

      function isEmptyValue(value) {
        return typeof value === "undefined" || value === null || value === "";
      }

      function toBooleanOrDefault(value, defaultValue) {
        if (value === true || value === 1 || value === "1") {
          return true;
        }
        if (value === false || value === 0 || value === "0") {
          return false;
        }
        return defaultValue;
      }
    }

    function showPendingCheckoutBlockedPopup() {
      var html = 'This reservation still has an unpaid balance. Collect or adjust the remaining amount before you can check out.';
      $mdDialog.show({
        controller: "confirmController",
        controllerAs: "vm",
        templateUrl:
          "app/main/apps/contacts/confirmationPopUp/confirmation.html",
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          title: "Outstanding balance",
          htmlContent: html,
          cancelBtn: "none",
          OkBtn: "OK"
        },
      });
    }

    function isWaitingForRoom(order) {
      return eCommerceService.isWaitingForRoom(order);
    }

    function getDisplayStatus(order) {
      if (isWaitingForRoom(order)) {
        return "Waiting for Room";
      }
      return order && order.show_status
        ? order.show_status
        : order
        ? order.room_stay_status
        : "";
    }

    function applyWaitingDisplayStatus() {
      if (!vm.order) {
        return;
      }
      if (isWaitingForRoom(vm.order)) {
        vm.order.show_status = "Waiting for Room";
        vm.room_stay_status = "Waiting for Room";
      } else {
        vm.order.show_status = vm.order.room_stay_status;
        vm.room_stay_status = vm.order.room_stay_status;
      }
      vm.statuses = angular.copy(vm.resvStatus);
      if (vm.order.show_status) {
        vm.statuses[vm.order.show_status] = vm.order.show_status;
      }
    }

    function updateWaitingStatus(confirmation_number, waitingValue, previousDisplayStatus) {
      var runUpdate = function () {
        vm.isloading = true;
        return eCommerceService
          .setWaitingStatus({
            confirmation_number: confirmation_number,
            waiting: waitingValue,
          })
          .then(
            function (response) {
              vm.isloading = false;
              if (response && response.success) {
                vm.order.is_waiting_for_room = waitingValue;
                if (waitingValue == 1) {
                  vm.order.room_stay_status = "Active";
                }
                applyWaitingDisplayStatus();
                setAllStatuses();
                originalOrderData = angular.copy(vm.order);
              } else {
                vm.room_stay_status = previousDisplayStatus;
                toastMessage.showSimpleToast(
                  (response && response.errorMsg) ||
                    "Unable to update Waiting for Room status.",
                  "error-toast"
                );
              }
            },
            function () {
              vm.isloading = false;
              vm.room_stay_status = previousDisplayStatus;
              toastMessage.showSimpleToast(
                "Unable to update Waiting for Room status.",
                "error-toast"
              );
            }
          );
      };

      if (waitingValue == 1) {
        $mdDialog
          .show({
            controller: "confirmController",
            controllerAs: "vm",
            templateUrl:
              "app/main/apps/contacts/confirmationPopUp/confirmation.html",
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            locals: {
              title: "Waiting for Room",
              htmlContent:
                "Are you sure you want to change status to Waiting for Room?",
              cancelBtn: "Cancel",
              OkBtn: "Ok",
            },
          })
          .then(function (answer) {
            if (typeof answer != "undefined" && answer == "update") {
              runUpdate();
            } else {
              vm.room_stay_status = previousDisplayStatus;
            }
          }, function () {
            vm.room_stay_status = previousDisplayStatus;
          });
        return;
      }

      return runUpdate();
    }

    function changeStatus(
      ev,
      idx,
      room_stay_id,
      confirmation_number,
      oldStatus,
      newStatus,
      remainingBalance,
      paidAmount,
      policy_id,
      room_stay_from,
      first_name,
      customer_email,
      total_amount
    ) {
      var displayOldStatus = getDisplayStatus(vm.order) || oldStatus;

      if (newStatus === "Waiting for Room") {
        if (displayOldStatus === "Waiting for Room") {
          vm.room_stay_status = "Waiting for Room";
          $mdDialog.show({
            controller: "confirmController",
            controllerAs: "vm",
            templateUrl:
              "app/main/apps/contacts/confirmationPopUp/confirmation.html",
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            locals: {
              title: "Change Status",
              htmlContent:
                'This reservation is already in state "Waiting for Room".',
              cancelBtn: "Cancel",
              OkBtn: "Continue",
            },
          });
          return;
        }
        updateWaitingStatus(confirmation_number, 1, displayOldStatus);
        return;
      }

      if (displayOldStatus === "Waiting for Room" && newStatus === "Active") {
        updateWaitingStatus(confirmation_number, 0, displayOldStatus);
        return;
      }

      // Keep is_waiting_for_room until user confirms status change so dialog shows
      // "from Waiting for Room to ..." (Waiting has display priority over Active).
      continueAfterWaitingCleared();

      function continueAfterWaitingCleared() {
      var isCheckoutStatus =
        String(newStatus || "").toLowerCase() === "checked-out";
      var pendingAmount = parseFloat(remainingBalance);

      if (isCheckoutStatus) {
        ganttChartServiceNew
          .blockCheckoutIfBorrowedItems(vm.order)
          .then(function (result) {
            if (result && result.blocked) {
              vm.isloading = false;
              vm.room_stay_status = displayOldStatus;
              if (result.openBorrowedItems) {
                openBorrowedItems();
              }
              return;
            }
            continueAfterBorrowedItemsCheck();
          });
        return;
      }

      continueAfterBorrowedItemsCheck();

      function continueAfterBorrowedItemsCheck() {
      if (isCheckoutStatus && !isNaN(pendingAmount) && pendingAmount > 0) {
        vm.isloading = true;
        getAllowCheckoutWithPendingDuesSetting().then(function (allowCheckout) {
          if (!allowCheckout) {
            vm.isloading = false;
            vm.room_stay_status = displayOldStatus;
            showPendingCheckoutBlockedPopup();
            return;
          }

          proceedStatusChange();
        });
        return;
      }

      proceedStatusChange();
      }
      }

      function proceedStatusChange() {
      vm.isloading = true;
      ganttChartServiceNew
        .processStatusRequest(
          vm.order,
          newStatus,
          remainingBalance,
          "reservationDetail"
        )
        .then(function (result) {
          vm.isloading = false;
          if (result && result.openBorrowedItems) {
            openBorrowedItems();
            return;
          }
          if (result.response !== undefined) {
            // status changed without payment
            vm.changingStatus = false;
            if (result.response.success) {
              if (
                result.response.hasOwnProperty("mail_error") &&
                result.response.mail_error &&
                result.response.errorMsg != ""
              ) {
                toastMessage.showSimpleToast(
                  result.response.errorMsg,
                  "error-toast"
                );
              }

              if (newStatus != "Canceled" && vm.allRoomCancelled)
                vm.allRoomCancelled = false;

              if (result.response.order_info) {
                vm.order = result.response.order_info.reservations[0];
                applyWaitingDisplayStatus();
                setAllStatuses();
                originalOrderData = angular.copy(vm.order);
                vm.showModifyBtn = false;
                vm.showPaymentsLoader = true;
                $timeout(function () {
                  fetchPaymentsInformation(
                    vm.order.confirmation_number,
                    vm.order.first_name,
                    vm.order.last_name,
                    vm.order.total_amount,
                    vm.order.overalltotals.remaining_amount
                  );
                }, 100);
              }
            } else {
              if (response.errorMsg != "")
                toastMessage.showSimpleToast(response.errorMsg, "error-toast");
              else
                toastMessage.showSimpleToast(
                  "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.",
                  "error-toast"
                );
              vm.room_stay_status = displayOldStatus;
            }
          }

          if (!result.hitRequest && result.processPayment !== undefined) {
            //status change process payment
            vm.changingStatus = true;
            vm.changeStatusData = {
              newStatus: newStatus,
              oldStatus: displayOldStatus === "Waiting for Room"
                ? (vm.order.room_stay_status || "Active")
                : displayOldStatus,
              sendEmail: result.send_email_indicator,
            };
            vm.room_stay_status = displayOldStatus;
            $location.hash("data-table-" + vm.selectedIndex);
            $timeout(function () {
              $window.location.hash = "";
            }, 1000);
          } else if (
            result.alreadyCanceled !== undefined ||
            result.reservationCanceled !== undefined
          ) {
            // resv already canceled or reservation canceled successfully
            eCommerceService
              .getOrder($stateParams.id, confirmation_number, false)
              .then(function (response) {
                var cancelledCount = 0;
                response["response"]["tabs_data"].forEach(function (
                  element,
                  index
                ) {
                  if (element["room_stay_status"] == "Canceled") {
                    cancelledCount++;
                  }
                });
                if (cancelledCount == Order.response.tabs_data.length) {
                  vm.allRoomCancelled = true;
                }
                vm.order = response.response.reservations;
                vm.room_stay_status = newStatus;
                vm.statuses = vm.resvStatus;
                vm.statuses[vm.room_stay_status] = vm.room_stay_status;
                setAllStatuses();
                originalOrderData = angular.copy(vm.order);

                $timeout(function () {
                  fetchPaymentsInformation(
                    confirmation_number,
                    vm.order.first_name,
                    vm.order.last_name,
                    vm.order.total_amount,
                    vm.order.overalltotals.remaining_amount
                  );
                }, 1000);
              });
          } else if (!result.hitRequest) {
            //no action triggered
            vm.room_stay_status = displayOldStatus;
            if (newStatus == "Canceled" || newStatus == "No Show") {
              vm.statuses = vm.resvStatus;
              vm.statuses[vm.room_stay_status] = vm.room_stay_status;
            }
          }
        });
      }
    }

    vm.processAutomaticRefund = function (data) {
      if (
        vm.order.overalltotals.remaining_amount < 0 &&
        data["room_stay_status"] == "Canceled"
      ) {
        vm.isloading = true;
        var html =
          "Do you want to initiate an automatic refund by the system.</br>";
        // html = html + '<b>Or you want to refund manually.</b>';
        $mdDialog
          .show({
            controller: "confirmController",
            controllerAs: "vm",
            templateUrl:
              "app/main/apps/contacts/confirmationPopUp/confirmation.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
              title: "Initiate Automatic Refund.",
              htmlContent: html,
              cancelBtn: "No",
              OkBtn: "Yes",
            },
          })
          .then(
            function (answer) {
              if (typeof answer != "undefined" && answer == "update") {
                vm.showPaymentsLoader = true;
                checkoutService
                  .processAutomaticRefund(data)
                  .then(function (response) {
                    if (!response.success) {
                      vm.isloading = false;
                      toastMessage.showSimpleToast(
                        response.statusMsg,
                        "error-toast"
                      );
                    } else {
                      setAllStatuses();

                      vm.order = response.order_info.reservations[0];
                      originalOrderData = angular.copy(vm.order);
                      vm.room_stay_status = angular.copy(
                        vm.order.room_stay_status
                      );

                      $timeout(function () {
                        vm.isloading = false;
                        fetchPaymentsInformation(
                          vm.order.confirmation_number,
                          vm.order.first_name,
                          vm.order.last_name,
                          vm.order.total_amount,
                          vm.order.overalltotals.remaining_amount
                        );
                      }, 100);
                    }
                  });
              }
            },
            function () {}
          );
      }
    };

    function refundInstallment(installment, type) {
      if (type == "void") {
        eCommerceService
          .moreTransactionExists({ installment: installment, type: type })
          .then(function (response) {
            if (response["success"] == "true" || response["success"] == true) {
              /*Show Some Alert*/
              var html =
                "This transaction is present in " +
                response.name +
                ". Do you still want to Void?";
              $mdDialog
                .show({
                  controller: "confirmController",
                  controllerAs: "vm",
                  templateUrl:
                    "app/main/apps/contacts/confirmationPopUp/confirmation.html",
                  parent: angular.element(document.body),
                  targetEvent: event,
                  clickOutsideToClose: true,
                  locals: {
                    title: "Void All Transaction",
                    htmlContent: html,
                    cancelBtn: "No",
                    OkBtn: "Ok",
                  },
                })
                .then(
                  function (answer) {
                    if (typeof answer != "undefined" && answer == "update") {
                      vm.voidTransaction(
                        installment.installment_id,
                        installment.installment_amount,
                        type,
                        installment.payment
                      );
                    }
                  },
                  function () {}
                );
            } else {
              /*Continue Normally As Usual*/
              // refundInstallmentPre(installment,type);
              vm.voidTransPopup(
                installment.installment_id,
                installment.installment_amount,
                type,
                installment.payment
              );
            }
          });
      } else if (type == "void-refunded" || type == "void-giftCard") {
        vm.voidTransPopup(
          installment.installment_id,
          installment.installment_amount,
          type,
          installment.payment
        );
      } else {
        refundInstallmentPre(installment, type);
      }
    }

    /*This*/

    vm.refundInstallmentPre = refundInstallmentPre;
    function refundInstallmentPre(installment, type) {
      var expirationGiftCard = "";
      if (installment.gift_card_expiry_date) {
        expirationGiftCard = true;
      } else {
        expirationGiftCard = false;
      }
      $mdDialog.show({
        clickOutsideToClose: false,
        parent: angular.element($document.body),
        scope: $scope,
        preserveScope: true,
        locals: {
          localData: {
            installment_id: installment.installment_id,
            installment_amount: installment.installment_amount,
            refund_by_check: installment.refund_by_check,
            type: type,
            payment: installment.payment,
            expiry: expirationGiftCard,
          },
        },
        templateUrl:
          "app/main/apps/e-commerce/views/orders/dialogs/payments/refund.html",
        controller: RefundController,
      });
      function RefundController($scope, $mdDialog, localData) {
        $scope.installment_id = localData.installment_id;
        $scope.refund_amount = localData.installment_amount;
        $scope.installment_amount = localData.installment_amount;
        $scope.refund_by_check = localData.refund_by_check;
        $scope.type = localData.type;
        $scope.check_number = "";
        $scope.payment = localData.payment;
        $scope.giftCardExpiry = localData.expiry;
        $scope.closeDialog = function () {
          $mdDialog.hide();
        };
        $scope.checkRefundAmount = function () {
          if (parseFloat($scope.refund_amount) < 0) {
            $scope.refund_amount = -$scope.refund_amount;
          }
          if (
            parseFloat($scope.refund_amount) >
            parseFloat($scope.installment_amount)
          ) {
            $scope.refund_amount = $scope.installment_amount;
          }
        };
      }
    }

    function refundInstallmentFinally(
      installment_id,
      amount,
      refund_using,
      check_number,
      send_email_indicator
    ) {
      vm.isloading = true;
      vm.refundStart = true;
      if (refund_using == "original" || refund_using == "check") {
        var data = {
          installment_id: installment_id,
          amount: amount,
          refund_using: refund_using,
          confirmation_number: vm.order.confirmation_number,
          roomTotal: vm.order.total_amount,
          paid_amount: vm.order.overalltotals.paid_amount,
          traveler_fname: vm.order.first_name,
          traveler_lname: vm.order.last_name,
          remaining_amount: vm.order.remaining_amount,
          reservation_id: vm.reservation_id,
          check_number: check_number,
        };
      } else {
        var data = {
          installment_id: installment_id,
          amount: amount,
          refund_using: refund_using,
          confirmation_number: vm.order.confirmation_number,
          roomTotal: vm.order.total_amount,
          paid_amount: vm.order.overalltotals.paid_amount,
          traveler_fname: vm.order.first_name,
          traveler_lname: vm.order.last_name,
          remaining_amount: vm.order.remaining_amount,
          customer_email: vm.order.customer_email,
          reservation_id: vm.reservation_id,
        };
      }

      eCommerceService.customRefundInstallment(data).then(function (response) {
        vm.isloading = false;
        vm.refundStart = false;
        $mdDialog.hide();
        if (response.success) {
          vm.payingFromGC = {};
          vm.installments = [];
          vm.installments = response.data.installments;
          vm.allcardsInfo = response.data.allcardsInfo;
          vm.payment_info_email = response.payment_info_email;
          vm.installment_amount = angular.copy(
            vm.installments["remaining"].origremainingamt
          );
          vm.order = response.reservation;
          originalOrderData = angular.copy(vm.order);
          vm.room_stay_status = angular.copy(vm.order.room_stay_status);
          vm.statuses = vm.resvStatus;
          vm.statuses[vm.room_stay_status] = vm.room_stay_status;
          setAllStatuses();
          if (Object.keys(response.data.allcardsInfo).length > 0) {
            var size = response.data.allcardsInfo.length;
            vm.payment_method = response.data.allcardsInfo[parseInt(size) - 1];
            if (
              response.data.allcardsInfo[parseInt(size) - 1].cc_number != ""
            ) {
              vm.fieldsIsReadOnly = true;
            }
          } else {
            vm.payment_method.payment_method =
              response.data.selectedPaymentMethod;
            if (response.data.selectedPaymentMethod == "") {
              vm.payment_method.payment_method = "Cash";
            }
          }

          vm.initializeOrderPosData(vm.order);

          // Refund Reason Code Start
          if (response.last_id != undefined && response.last_id != 0) {
            $mdDialog.show({
              clickOutsideToClose: false,
              parent: angular.element($document.body),
              scope: $scope,
              preserveScope: true,
              locals: {
                localData: {},
              },
              templateUrl:
                "app/main/apps/e-commerce/views/orders/dialogs/payments/refundReason.html",
              controller: AskReason,
            });
            function AskReason($scope, $mdDialog, localData) {
              $scope.voidReason = "";
              $scope.closeDialog = function () {
                $mdDialog.hide();
              };
              $scope.submitReason = function () {
                if ($scope.voidReason != "") {
                  var giftcardParams = {
                    payment_info_email: vm.payment_info_email,
                    amount: amount,
                    refund_using: refund_using,
                  };
                  vm.saveRefundReason(
                    response.last_id,
                    $scope.voidReason,
                    giftcardParams
                  );
                }
              };
            }
          } else if (giftcardParams.refund_using != "giftcard") {
            var giftcardParams = {
              payment_info_email: vm.payment_info_email,
              amount: amount,
              refund_using: refund_using,
            };
            vm.refundEmailPopup(giftcardParams);
          }
          // Refund Reason Code End

          /*if(refund_using != 'giftcard'){
						$mdDialog.show({
							clickOutsideToClose	: false,
							parent             	: angular.element($document.body),
							scope				: $scope,
							preserveScope		: true,
							locals				: {
													localData :{
														payment_info_email: vm.payment_info_email,
														refunded_amount: amount
													}
												},
							templateUrl        	: 'app/main/apps/e-commerce/views/orders/dialogs/payments/refundEmail.html',
							controller			: RefundEmailController
						});
						function RefundEmailController($scope, $mdDialog, localData) {
							$scope.payment_info_email = localData.payment_info_email;
							$scope.refund_amount = localData.refunded_amount;
							$scope.closeDialog = function(){
								$mdDialog.hide();
							};
						}
					}*/
        } else {
          if (response.errorMsg)
            toastMessage.showSimpleToast(response.errorMsg, "error-toast");
          else
            toastMessage.showSimpleToast(
              "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.",
              "error-toast"
            );
        }
      });
    }

    vm.voidTransPopup = function (installment_id, amount, type, paymentMethod) {
      var html =
        type == "void-giftCard"
          ? "Are you sure you want to void this gift card?"
          : "Are you sure you want to void this transaction?";
      $mdDialog
        .show({
          controller: "confirmController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/contacts/confirmationPopUp/confirmation.html",
          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: true,
          locals: {
            title:
              type == "void-giftCard" ? "Void Gift Card" : "Void Transaction",
            htmlContent: html,
            cancelBtn: "No",
            OkBtn: "Yes",
          },
        })
        .then(
          function (answer) {
            if (typeof answer != "undefined" && answer == "update") {
              vm.voidTransaction(installment_id, amount, type, paymentMethod);
            }
          },
          function () {}
        );
    };

    vm.voidTransaction = function (
      installment_id,
      amount,
      type,
      paymentMethod,
      checkValue
    ) {
      vm.isloading = true;
      vm.refundStart = true;
      checkValue =
        checkValue != undefined && checkValue != "" ? checkValue : false;
      var data = {
        installment_id: installment_id,
        amount: amount,
        refund_using:
          type == "void-refunded"
            ? "voided"
            : type == "void-giftCard"
            ? "giftCardRefund"
            : "original",
        confirmation_number: vm.order.confirmation_number,
        roomTotal: vm.order.total_amount,
        paid_amount: vm.order.overalltotals.paid_amount,
        traveler_fname: vm.order.first_name,
        traveler_lname: vm.order.last_name,
        remaining_amount: vm.order.remaining_amount,
        reservation_id: vm.reservation_id,
        paymentMethod: paymentMethod,
        checkValue: checkValue,
      };

      eCommerceService.customRefundInstallment(data).then(function (response) {
        vm.isloading = false;
        vm.refundStart = false;
        $mdDialog.hide();
        if (response.success) {
          vm.payingFromGC = {};
          vm.installments = [];
          vm.installments = response.data.installments;
          vm.allcardsInfo = response.data.allcardsInfo;
          vm.payment_info_email = response.payment_info_email;
          vm.installment_amount = angular.copy(
            vm.installments["remaining"].origremainingamt
          );
          vm.order = response.reservation;
          vm.order["tax_exempt_indicator"] =
            vm.reservation_customer.tax_exempt_indicator;
          originalOrderData = angular.copy(vm.order);
          vm.room_stay_status = angular.copy(vm.order.room_stay_status);
          vm.statuses = vm.resvStatus;
          vm.statuses[vm.room_stay_status] = vm.room_stay_status;
          setAllStatuses();
          if (Object.keys(response.data.allcardsInfo).length > 0) {
            var size = response.data.allcardsInfo.length;
            vm.payment_method = response.data.allcardsInfo[parseInt(size) - 1];
            if (
              response.data.allcardsInfo[parseInt(size) - 1].cc_number != ""
            ) {
              vm.fieldsIsReadOnly = true;
            }
          } else {
            vm.payment_method.payment_method =
              response.data.selectedPaymentMethod;
            if (response.data.selectedPaymentMethod == "") {
              vm.payment_method.payment_method = "Cash";
            }
          }

          vm.initializeOrderPosData(vm.order);
        } else if (
          response.giftAmountChange != undefined &&
          response.giftAmountChange
        ) {
          $mdDialog
            .show({
              controller: "confirmController",
              controllerAs: "vm",
              templateUrl:
                "app/main/apps/contacts/confirmationPopUp/confirmation.html",
              parent: angular.element(document.body),
              targetEvent: event,
              clickOutsideToClose: true,
              locals: {
                title: "Void Gift Card",
                htmlContent: response.errorMsg,
                cancelBtn: "No",
                OkBtn: "Yes",
              },
            })
            .then(
              function (answer) {
                if (typeof answer != "undefined" && answer == "update") {
                  vm.voidTransaction(
                    installment_id,
                    response.giftCardRemAmount,
                    type,
                    paymentMethod,
                    true
                  );
                }
              },
              function () {}
            );
        } else {
          if (response.errorMsg)
            toastMessage.showSimpleToast(response.errorMsg, "error-toast");
          else
            toastMessage.showSimpleToast(
              "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.",
              "error-toast"
            );
        }
      });
    };

    $scope.isProcessing = false;
    function refundEmail(payment_info_email, refund_amount) {
      $scope.isProcessing = true;
      vm.isloading = true;
      var data = {
        confirmation_number: vm.order.confirmation_number,
        payment_info_email: payment_info_email,
        refund_amount: refund_amount,
      };
      eCommerceService.customRefundEmail(data).then(function (response) {
        vm.isloading = false;
        $mdDialog.hide();
      });
    }

    function cancelChangeStatus() {
      vm.changingStatus = false;
      vm.changeStatusData = {};
    }

    function fetchOrderInformation(confirmation_number) {
      if (
        (!vm.order.hasOwnProperty("customer_id") ||
          (vm.order.hasOwnProperty("customer_id") &&
            vm.order.customer_id > 0)) &&
        confirmation_number != ""
      ) {
        vm.isloading = true;
        var data = { confirmation_number: confirmation_number };
        eCommerceService.fetchOrder(data).then(function (response) {
          if (!response.success) {
            toastMessage.showSimpleToast(
              "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.",
              "error-toast"
            );
          } else {
            var order_info = response.reservation;
            vm.order = angular.merge(vm.order, order_info);
            originalOrderData = angular.copy(vm.order);
            applyWaitingDisplayStatus();
            setAllStatuses();
            syncCcProcessingFeeCheckboxes();
          }
          vm.isloading = false;
        });
      }
    }

    var borrowedItemsDialogOpening = false;

    function openBorrowedItems($event) {
      if (!vm.order || !vm.order.confirmation_number) {
        return;
      }

      if (
        !ganttChartServiceNew ||
        typeof ganttChartServiceNew.openBorrowedItemsDialog !== "function"
      ) {
        toastMessage.showSimpleToast(
          "Borrowed items is unavailable right now.",
          "error-toast"
        );
        return;
      }

      ganttChartServiceNew
        .openBorrowedItemsDialog(vm.order, $event)
        .then(function (result) {
          if (!result || !result.changed) {
            return;
          }

          vm.order.borrowed_item = result.borrowed_item;
          vm.order.borrowed_count = result.borrowed_count;

          if (result.orderChanged && vm.order.confirmation_number) {
            fetchOrder(vm.order.confirmation_number, "hitRequest");
          }
        });
    }

    function openPendingBorrowedItemsDialog() {
      var pendingConfirmation = $sessionStorage["open_borrowed_items_for"];
      if (
        borrowedItemsDialogOpening ||
        !pendingConfirmation ||
        !vm.order ||
        !vm.order.confirmation_number ||
        String(pendingConfirmation) !== String(vm.order.confirmation_number)
      ) {
        return;
      }

      borrowedItemsDialogOpening = true;

      // Wait for route transition + view paint so dialog styles match icon-click flow.
      $timeout(function () {
        if (
          String($sessionStorage["open_borrowed_items_for"]) !==
          String(vm.order.confirmation_number)
        ) {
          borrowedItemsDialogOpening = false;
          return;
        }

        delete $sessionStorage["open_borrowed_items_for"];
        openBorrowedItems();
        borrowedItemsDialogOpening = false;
      }, 250);
    }

    $scope.$on("$viewContentLoaded", function () {
      openPendingBorrowedItemsDialog();
    });

    $scope.$on("openBorrowedItemsDialog", function () {
      if (
        vm.order &&
        vm.order.confirmation_number &&
        String($sessionStorage["open_borrowed_items_for"]) ===
          String(vm.order.confirmation_number)
      ) {
        delete $sessionStorage["open_borrowed_items_for"];
      }
      openBorrowedItems();
    });

    function fetchOrder(confirmation_number, parm) {
      vm.showCustomerTravellerBillInfo = false;
      vm.payment_method = {};
      if (
        (confirmation_number != "" &&
          vm.order.confirmation_number != confirmation_number) ||
        (parm != undefined && parm == "hitRequest")
      ) {
        vm.isloading = true;
        vm.showPaymentsLoader = true;
        var data = { confirmation_number: confirmation_number };
        eCommerceService.fetchOrder(data).then(function (response) {
          if (!response.success) {
            vm.isloading = false;
            vm.taxExemptRequest = false;
            toastMessage.showSimpleToast(
              "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.",
              "error-toast"
            );
          } else {
            vm.order = {};
            vm.order = response.reservation;
            openPendingBorrowedItemsDialog();
            if (vm.reservation_customer && vm.order) {
              vm.reservation_customer["tax_exempt_indicator"] =
                vm.order.customerTaxExempt;
            }
            originalOrderData = angular.copy(response.reservation);
            applyWaitingDisplayStatus();
            var changeloader = true;
            vm.initializeOrderPosData(vm.order);
            syncCcProcessingFeeCheckboxes();

            vm.source_of_creation =
              vm.order.source_of_creation == "FE" ||
              vm.order.source_of_creation == "PMS"
                ? ""
                : vm.order.source_of_creation;
            vm.siteminder_id = vm.order.siteminder_id;
            if (
              vm.source_of_creation == "FE" ||
              vm.source_of_creation == "PMS" ||
              typeof vm.source_of_creation == "undefined" ||
              typeof vm.siteminder_id == "undefined"
            ) {
              vm.headerPart = "";
            } else {
              vm.headerPart =
                vm.source_of_creation == ""
                  ? ""
                  : vm.source_of_creation + " " + vm.siteminder_id;
            }
            vm.adultRange = vm.getRangeArray(
              1,
              parseInt(vm.order["max_occupancy"]) -
                parseInt(vm.order.room_stay_child_count)
            );
            vm.childRange = vm.getRangeArray(
              0,
              parseInt(vm.order["max_occupancy"]) -
                parseInt(vm.order.room_stay_guest_count)
            );

            vm.resortFeeApplied[vm.selectedIndex] =
              response.reservation["resortFeeApplied"];
            vm.resortFeeAppliedVisible =
              response.reservation["resortFeeAppliedVisible"];

            if (
              vm.order.hasOwnProperty("pos") &&
              parseInt(Object.keys(vm.order.pos).length) > 0
            ) {
              changeloader = false;
              vm.statusesPos = {};
              vm.statusesResort = {};
              var itemsInPos = vm.order.pos.length;
              angular.forEach(vm.order.pos, function (value, key) {
                vm.statusesPos[key] = { Active: "Active", Canceled: "Cancel" };
                vm.statusesResort[key] = {
                  Applied: "Apply",
                  Removed: "Cancel",
                };
                vm.statusesPos[key][value.room_stay_status] =
                  value.room_stay_status;
                vm.pos_status[key] = value.room_stay_status;
                if (
                  value.extra_attribute != undefined &&
                  value.extra_attribute == "resort_fee"
                ) {
                  vm.pos_status[key] =
                    parseFloat(value.nightlySum) > 0 ? "Applied" : "Removed";
                  vm.statusesResort[key][vm.pos_status[key]] =
                    vm.pos_status[key];
                }
                if (itemsInPos == parseInt(key) + 1) vm.isloading = false;
              });
            }

            vm.innerSlectedIndex = 0;
            vm.showPaymentsLoader = true;
            $timeout(function () {
              if (changeloader) vm.isloading = false;
              fetchPaymentsInformation(
                confirmation_number,
                vm.order.first_name,
                vm.order.last_name,
                vm.order.total_amount,
                vm.order.overalltotals.remaining_amount
              );
            }, 1000);
            vm.taxExemptRequest = false;
          }
        });
      }
    }

    function fetchOrderHistory(confirmation_number) {
      vm.showCustomerTravellerBillInfo = false;
      if (
        !vm.order.hasOwnProperty("order_history") &&
        confirmation_number != ""
      ) {
        vm.isloading = true;
        var data = { confirmation_number: confirmation_number };
        eCommerceService.fetchOrderHistory(data).then(function (response) {
          if (!response.success) {
            toastMessage.showSimpleToast(
              "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.",
              "error-toast"
            );
            vm.no_found = true;
          } else if (response.history_found) {
            vm.no_found = false;
            vm.order.order_history = response.order_history;
          } else {
            vm.no_found = true;
          }
          vm.isloading = false;
        });
      }
    }

    vm.cartType = "";
    var canceller,
      isSending = false;
    var cancelSearch = $q.defer(); //defer object
    var searchResolve = false; //status of a request

    function fetchPaymentsInformation(
      confirmation_number,
      first_name,
      last_name,
      total_amount,
      remaining_amount
    ) {
      angular.forEach($http.pendingRequests, function (request) {
        if (request.cancel && request.timeout) {
          request.cancel.resolve();
        }
      });
      if (
        !vm.order.hasOwnProperty("installments") &&
        confirmation_number != ""
      ) {
        var data = {
          confirmation_number: confirmation_number,
          first_name: first_name,
          last_name: last_name,
          total_amount: total_amount,
          remaining_amount: remaining_amount,
        };

        if (searchResolve) {
          cancelSearch.resolve("search aborted");
        }

        cancelSearch = $q.defer(); //create new defer for new request
        searchResolve = true; //set the request status to true/ongoing

        $http
          .post(
            EnvironmentConfig.api + "reservations/fetch_payments_information",
            data,
            { timeout: cancelSearch.promise }
          )
          .then(
            function (response) {
              response = response.data;
              if (!response.success) {
                isSending = false;
                toastMessage.showSimpleToast(
                  "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.",
                  "error-toast"
                );
              } else {
                isSending = false;
                if (
                  response.allcardsInfo.length > 0 &&
                  response.allcardsInfo != ""
                ) {
                  vm.ct = response["allcardsInfo"]["cc_type"];
                }

                vm.installments = [];
                vm.installments = response.installments;
                vm.allcardsInfo = response.allcardsInfo;
                vm.customer_profile = response.customer_profile;
                vm.paid_hotel_id = response.paid_hotel_id;
                vm.fieldsIsReadOnly = false;

                if (Object.keys(response.allcardsInfo).length > 0) {
                  vm.payment_method = response.allcardsInfo[0];
                  let savedYear = parseInt(vm.payment_method.cc_exp_year);
                  let currentYear = new Date().getFullYear();

                  if (savedYear && savedYear < currentYear && !vm.yrs_option.includes(savedYear)) {
                      vm.yrs_option.unshift(savedYear);
                  }
                  if (response.allcardsInfo[0].cc_number != "") {
                    vm.fieldsIsReadOnly = true;
                    vm.use_existingcard = 0;
                  }
                }
                vm.installment_amount = vm.installments["remaining"].balance;
                vm.payment_method.payment_method = vm.latestPaymentMethod
                  ? vm.latestPaymentMethod
                  : (response.selectedPaymentMethod || "Cash");
                if (!vm.previousPaymentMethod) {
                  vm.previousPaymentMethod = vm.payment_method.payment_method;
                }

              }
              isSending = false;
              vm.showPaymentsLoader = false;
            },
            function (response2) {
              console.log(response2, "response2");
              //error callback
            }
          );
      }
    }

    function fetchOrderCommentsRequests(confirmation_number) {
      vm.showCustomerTravellerBillInfo = false;
      if (confirmation_number != "") {
        vm.isloading = true;
        var data = { confirmation_number: confirmation_number };
        eCommerceService
          .fetchOrderCommentsRequests(data)
          .then(function (response) {
            if (!response.success) {
              toastMessage.showSimpleToast(
                "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.",
                "error-toast"
              );
            } else {
              vm.commentsSpecial.comment = response.comments || [];
              vm.commentsSpecial.special_request = response.requests || [];
              vm.commentsSpecial.posComment = response.posComment || [];
            }
            vm.isloading = false;
          });
      }
    }

    function roomMoveStartFinally(
      ev,
      checkin,
      checkout,
      adult,
      child,
      room_stay_id,
      product_id,
      product_name,
      policy_id,
      confirmation_number,
      reservation_id,
      itinerary_number
    ) {
      var taxExempt = false;
      if (
        vm.order.customerTaxExempt !== undefined &&
        vm.order.customerTaxExempt
      ) {
        // room is associated with customer
        taxExempt = true;
      }

      $mdDialog.show({
        controller: "rooomMoveController",
        controllerAs: "vm",
        templateUrl:
          "app/main/apps/e-commerce/views/orders/dialogs/room-move/room-move.html",
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          checkin: checkin,
          checkout: checkout,
          adult: adult,
          child: child,
          product_id: product_id,
          product_name: product_name,
          reservation_id: reservation_id,
          itinerary_number: itinerary_number,
          room_stay_id: room_stay_id,
          confirmation_number: confirmation_number,
          policy_id: policy_id,
          reservation_type: vm.order.type_of_reservation,
          tax_exempt_indicator: taxExempt,
          customerTaxExempt: vm.order.customerTaxExempt,
          travellerTaxExempt: vm.order.travellerTaxExempt,
          moveType:
            vm.consolidateType != undefined && vm.consolidateType != ""
              ? vm.consolidateType
              : "split",
          negotiatedCust:
            vm.order.negotiated_rate_resv != undefined
              ? vm.order.negotiated_rate_resv
              : 0,
          selectedRatePlanId:
            vm.order.selectedRatePlanId != undefined
              ? vm.order.selectedRatePlanId
              : 0,
          siteminderId:
            vm.order.siteminder_id != undefined ? vm.order.siteminder_id : 0,
        },
      });
    }

    function roomMoveStart(
      ev,
      checkin,
      checkout,
      adult,
      child,
      room_stay_id,
      product_id,
      product_name,
      policy_id,
      confirmation_number,
      reservation_id,
      itinerary_number
    ) {
      if (vm.order.room_number_locked_indicator == 1) {
        var confirm = $mdDialog
          .confirm()
          .title("Do not move")
          .htmlContent(
            '<div class="md-padding custom-common-dailog">Do not move is set for this reservation. Do you want to continue?</div>'
          )
          .ariaLabel("Do not move")
          .targetEvent(ev)
          .ok("YES")
          .cancel("NO");
        $mdDialog.show(confirm).then(function () {
          roomMoveStartFinally(
            ev,
            checkin,
            checkout,
            adult,
            child,
            room_stay_id,
            product_id,
            product_name,
            policy_id,
            confirmation_number,
            reservation_id,
            itinerary_number
          );
        });
      } else {
        roomMoveStartFinally(
          ev,
          checkin,
          checkout,
          adult,
          child,
          room_stay_id,
          product_id,
          product_name,
          policy_id,
          confirmation_number,
          reservation_id,
          itinerary_number
        );
      }
    }

    function toggleReservationCustomer() {
      $mdSidenav("reservation-customer-sidenav").toggle();
    }

    function toggleCustomerCard(ev) {
      if (ev) {
        ev.preventDefault();
        ev.stopPropagation();
      }
      var nextExpanded = !vm.customerCardExpanded;
      vm.customerCardExpanded = nextExpanded;
      if (!nextExpanded) {
        $timeout(function () {
          if (!vm.customerCardExpanded) {
            vm.customerCardTabIndex = 0;
          }
        }, 420);
      } else {
        loadCustomerCardReservations();
      }
    }

    function loadCustomerCardReservations() {
      var traveller = vm.order || {};
      var customerId = traveller.customer_id;
      if (!customerId) {
        vm.customerCardReservations.data = [];
        vm.customerCardReservations.totalResv = 0;
        vm.customerCardReservations.isloading = false;
        return;
      }

      // Avoid re-fetch if already loaded for this traveller
      if (
        vm.customerCardReservations.loadedForId === customerId &&
        !vm.customerCardReservations.isloading
      ) {
        return;
      }

      vm.customerCardReservations.isloading = true;
      userService
        .getSingleCustomerReservations(customerId)
        .then(function (response) {
          var list =
            response && angular.isArray(response.reservations)
              ? response.reservations
              : [];
          vm.customerCardReservations.data = list;
          vm.customerCardReservations.totalResv = list.length;
          vm.customerCardReservations.loadedForId = customerId;
          vm.customerCardReservations.isloading = false;
        })
        .catch(function () {
          vm.customerCardReservations.data = [];
          vm.customerCardReservations.totalResv = 0;
          vm.customerCardReservations.isloading = false;
        });
    }

    function goToCustomerCardReservation(reservation) {
      if (!reservation || !reservation.confirmation_number) {
        return;
      }
      var id = reservation.reservation_id;
      if (!id) {
        return;
      }
      var url = $state.href("app.e-commerce.orders.detail", {
        id: id,
        confirmation_number: reservation.confirmation_number,
      });
      $window.open(url, "_blank");
    }

    function loadCustomerCardNotes() {
      var traveller = vm.order || {};
      var customerId = traveller.customer_id;
      if (!customerId) {
        vm.customerCardNotes.data = [];
        vm.customerCardNotes.isloading = false;
        return;
      }

      // Avoid re-fetch if already loaded for this traveller
      if (
        vm.customerCardNotes.loadedForId === customerId &&
        !vm.customerCardNotes.isloading
      ) {
        return;
      }

      vm.customerCardNotes.isloading = true;
      userService
        .getCustomerNotes(customerId)
        .then(function (response) {
          var list =
            response && response.success && angular.isArray(response.data)
              ? response.data
              : [];
          vm.customerCardNotes.data = list;
          vm.customerCardNotes.loadedForId = customerId;
          vm.customerCardNotes.isloading = false;
        })
        .catch(function () {
          vm.customerCardNotes.data = [];
          vm.customerCardNotes.isloading = false;
        });
    }

    function addCustomerNote() {
      var traveller = vm.order || {};
      var customerId = traveller.customer_id;
      if (!customerId) {
        toastMessage.showSimpleToast("Invalid customer.", "error-toast");
        return;
      }

      var noteText = (vm.newCustomerNoteText || "").trim();
      if (!noteText) {
        toastMessage.showSimpleToast("Note text cannot be empty.", "error-toast");
        return;
      }

      var noteData = {
        customer_id: customerId,
        note: noteText,
        post_to_all_reservation: vm.postNoteToAllReservations ? 1 : 0
      };

      userService
        .addCustomerNote(noteData)
        .then(function (response) {
          if (response && response.success) {

            vm.newCustomerNoteText = "";
            vm.postNoteToAllReservations = false;
            vm.customerCardNotes.data.unshift(response.data);

          } else {
            toastMessage.showSimpleToast(
              (response && response.message) || "Unable to add customer note.",
              "error-toast"
            );
          }
        })
        .catch(function () {
          toastMessage.showSimpleToast(
            "Unable to add customer note.",
            "error-toast"
          );
        });
    }

    function editCustomerNote(note) {
      if (!note) return;
      note.isEditing = true;
      note.editText = note.note || '';
    }

    function cancelEditCustomerNote(note) {
      if (!note) return;
      note.isEditing = false;
    }

    function updateCustomerNote(note) {
      if (!note) {
        return;
      }

      var traveller = vm.order || {};
      var customerId = traveller.customer_id;

      if (!customerId) {
        toastMessage.showSimpleToast(
          "Invalid customer.",
          "error-toast"
        );
        return;
      }

      var noteText = (note.editText || "").trim();

      if (!noteText) {
        toastMessage.showSimpleToast(
          "Note text cannot be empty.",
          "error-toast"
        );
        return;
      }

      var noteData = {
        id: note.id,
        customer_id: customerId,
        note: noteText,

        post_to_all_reservation:
          Number(note.post_to_all_reservation) === 1 ? 1 : 0
      };

      note.isSaving = true;

      userService
        .updateCustomerNote(noteData)
        .then(function (response) {

          if (response && response.success) {
            note.note = noteText;
            note.post_to_all_reservation =
              noteData.post_to_all_reservation;

            note.isEditing = false;
            note.editText = '';


          } else {

            toastMessage.showSimpleToast(
              (response && response.message) ||
              "Unable to update customer note.",
              "error-toast"
            );
          }
        })
        .catch(function () {

          toastMessage.showSimpleToast(
            "Unable to update customer note.",
            "error-toast"
          );
        })
        .finally(function () {
          note.isSaving = false;
        });
    }

    function deleteCustomerNote(ev, note) {
      if (!note) return;
      var traveller = vm.order || {};
      var customerId = traveller.customer_id;
      if (!customerId) {
        toastMessage.showSimpleToast("Invalid customer.", "error-toast");
        return;
      }

      var confirm = $mdDialog
        .confirm()
        .title("Delete Note")
        .htmlContent(
          '<div class="md-padding custom-common-dailog">Are you sure you want to delete this customer note?</div>'
        )
        .ariaLabel("Delete customer note")
        .targetEvent(ev)
        .ok("DELETE")
        .cancel("CANCEL");

      $mdDialog.show(confirm).then(function () {
        var noteData = {
          id: note.id,
          customer_id: customerId
        };

        userService
          .deleteCustomerNote(noteData)
          .then(function (response) {
            if (response && response.success) {
              vm.customerCardNotes.data = vm.customerCardNotes.data.filter(
                (item) => item.id !== note.id
              );
            } else {
              toastMessage.showSimpleToast(
                (response && response.message) || "Unable to delete customer note.",
                "error-toast"
              );
            }
          })
          .catch(function () {
            toastMessage.showSimpleToast("Unable to delete customer note.", "error-toast");
          });
      });
    }

    function togglePostToAllReservations(note) {
      if (!note || !note.id) {
        return;
      }

      var traveller = vm.order || {};
      var customerId = traveller.customer_id;

      if (!customerId) {
        toastMessage.showSimpleToast(
          "Invalid customer.",
          "error-toast"
        );
        return;
      }

      var currentValue = Number(note.post_to_all_reservation) === 1;
      var newValue = currentValue ? 0 : 1;

      note.post_to_all_reservation = newValue;

      var data = {
        id: note.id,
        customer_id: customerId,
        note: note.note,
        post_to_all_reservation: newValue
      };

      userService.updateCustomerNote(data)
        .then(function (response) {
          if (response && response.success) {
            toastMessage.showSimpleToast(
              newValue
                ? "Note is now posted to all reservations related to this customer."
                : "Note will no longer be added to new reservations.",
              "success-toast"
            );
          } else {
            // Revert
            note.post_to_all_reservation = currentValue ? 1 : 0;

            toastMessage.showSimpleToast(
              (response && response.message) ||
              "Unable to update note.",
              "error-toast"
            );
          }
        })
        .catch(function () {
          // Revert
          note.post_to_all_reservation = currentValue ? 1 : 0;

          toastMessage.showSimpleToast(
            "Unable to update note.",
            "error-toast"
          );
        });
    }

    function customerCardInitials() {
      var traveller = vm.order || {};
      var first = (traveller.first_name || "").charAt(0);
      var last = (traveller.last_name || "").charAt(0);
      var initials = (first + last).toUpperCase();
      return initials || "?";
    }

    function customerCardLocation() {
      var traveller = vm.order || {};
      var city = (traveller.city || "").toString().trim();
      var state = (traveller.state || "").toString().trim();
      var country = (traveller.country || "").toString().trim();
      var parts = [];
      if (city) {
        parts.push(city);
      }
      if (state) {
        parts.push(state);
      }
      if (country) {
        parts.push(country);
      }
      return parts.join(", ");
    }

    function customerCardAbout() {
      var traveller = vm.order || {};
      var about = (traveller.about || "").toString().trim();
      return about || "—";
    }

    function customerCardGender() {
      var traveller = vm.order || {};
      var gender = traveller.customer_gender || traveller.gender;
      return gender || "—";
    }

    vm.formatDateOfBirth = function (dob) {
      if (!dob) {
        return "";
      }

      var date = new Date(dob);

      if (isNaN(date.getTime())) {
        return "";
      }

      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var year = date.getFullYear();

      return month + "-" + day + "-" + year;
    }

    function customerCardDateOfBirth() {
      var traveller = vm.order || {};

      return vm.formatDateOfBirth(traveller.date_of_birth) || "—";
    }

    function customerCardPreferredLanguages() {
      var traveller = vm.order || {};
      var languages = traveller.preferred_languages;
      return languages || "—";
    }

    vm.editingCustomerProfile = false;
    vm.editableCustomerProfile = {};
    vm.isSavingCustomerProfile = false;

    function enableCustomerProfileEdit() {
      vm.editableCustomerProfile = angular.copy(vm.order);
      vm.editableCustomerProfile.date_of_birth = vm.order.date_of_birth || null;

      /*
      * Enable edit mode first.
      * The phone inputs use ng-if, so they don't exist
      * in the DOM until Angular renders this.
      */
      vm.editingCustomerProfile = true;

      $timeout(function () {

        initAutocompleteCustomerProfile();
        initAutocompleteZipCustomerProfile();

        /*
        * Sync PHONE with intl-tel-input.
        */
        var phoneInput =
          document.getElementById('travellerPhoneNumber');

        if (phoneInput) {

          var phoneIti =
            angular.element(phoneInput).data('iti');

          if (
            phoneIti &&
            vm.editableCustomerProfile.phone_number
          ) {
            phoneIti.setNumber(
              vm.editableCustomerProfile.phone_number
            );
          }
        }

        /*
        * Sync SECONDARY PHONE with intl-tel-input.
        */
        var secondaryPhoneInput =
          document.getElementById(
            'travellerSecondaryPhoneNumber'
          );

        if (secondaryPhoneInput) {

          var secondaryPhoneIti =
            angular.element(
              secondaryPhoneInput
            ).data('iti');

          if (
            secondaryPhoneIti &&
            vm.editableCustomerProfile.secondary_phone_number
          ) {
            secondaryPhoneIti.setNumber(
              vm.editableCustomerProfile.secondary_phone_number
            );
          }
        }

        /*
        * Focus the first empty field.
        */
        var focusFields = [
          {
            value: vm.editableCustomerProfile.first_name,
            selector: 'input[aria-label="First name"]'
          },
          {
            value: vm.editableCustomerProfile.last_name,
            selector: 'input[aria-label="Last name"]'
          },
          {
            value: vm.editableCustomerProfile.customer_email,
            selector: 'input[type="email"]'
          },
          {
            value: vm.editableCustomerProfile.phone_number,
            selector: '#travellerPhoneNumber'
          },
          {
            value: vm.editableCustomerProfile.secondary_phone_number,
            selector: '#travellerSecondaryPhoneNumber'
          },
          {
            value: vm.editableCustomerProfile.customer_gender,
            selector: '.customer-inline-select'
          },
          {
            value: vm.editableCustomerProfile.date_of_birth,
            selector: 'md-datepicker input'
          },
          {
            value: vm.editableCustomerProfile.about,
            selector: 'textarea[aria-label="About"]'
          },
          {
            value: vm.editableCustomerProfile.address,
            selector: '#autocompleteCustomerProfile'
          },
          {
            value: vm.editableCustomerProfile.city,
            selector: 'input[aria-label="City"]'
          },
          {
            value: vm.editableCustomerProfile.state,
            selector: 'input[aria-label="State"]'
          },
          {
            value: vm.editableCustomerProfile.zip_code,
            selector: '#autocompletezipCustomerProfile'
          },
          {
            value: vm.editableCustomerProfile.country,
            selector: 'input[aria-label="Country"]'
          }
        ];

        for (var i = 0; i < focusFields.length; i++) {

          var field = focusFields[i];

          var isEmpty =
            field.value === null ||
            field.value === undefined ||
            String(field.value).trim() === '';

          if (isEmpty) {

            var element =
              document.querySelector(field.selector);

            if (element) {
              element.focus();
              break;
            }
          }
        }

      }, 300);
    }

    function cancelCustomerProfileEdit() {
      vm.editingCustomerProfile = false;
      vm.editableCustomerProfile = {};
    }

    function saveCustomerProfileEdit() {

      vm.isSavingCustomerProfile = true;

      var columns = [
        'first_name',
        'last_name',
        'customer_email',
        'phone_number',
        'secondary_phone_number',
        'customer_gender',
        'address',
        'city',
        'state',
        'zip_code',
        'country',
        'about',
        'preferred_languages'
      ];
      var phoneNumber = getPhoneNumber('travellerPhoneNumber', vm.editableCustomerProfile.phone_number);
      var secondaryPhoneNumber = getPhoneNumber('travellerSecondaryPhoneNumber', vm.editableCustomerProfile.secondary_phone_number);

      if (phoneNumber === null || (vm.editableCustomerProfile.phone_number && phoneNumber === '')) {
        vm.isSavingCustomerProfile = false;
        toastMessage.showSimpleToast('Please enter a valid phone number.', 'error-toast');
        return;
      }

      if (secondaryPhoneNumber === null || (vm.editableCustomerProfile.secondary_phone_number && secondaryPhoneNumber === '')) {
        vm.isSavingCustomerProfile = false;
        toastMessage.showSimpleToast('Please enter a valid secondary phone number.', 'error-toast');
        return;
      }

      var profileToSave =
        angular.copy(vm.editableCustomerProfile);

      profileToSave.phone_number = phoneNumber;
      profileToSave.secondary_phone_number = secondaryPhoneNumber;


      /*
       * Date
       */
      var dateVal = profileToSave.date_of_birth;

      if (dateVal instanceof Date && !isNaN(dateVal.getTime())) {

          var m = dateVal.getMonth() + 1;
          var d = dateVal.getDate();
          var y = dateVal.getFullYear();

          profileToSave.date_of_birth =
              (m < 10 ? '0' + m : m) +
              '-' +
              (d < 10 ? '0' + d : d) +
              '-' +
              y;

      } else if (!dateVal) {
          profileToSave.date_of_birth = '';
      }

      columns.push('date_of_birth');

      angular.forEach(columns, function (column) {

        if (
          vm.order[column] !==
          profileToSave[column]
        ) {
          vm.order[column] =
            profileToSave[column];

          if (column === 'phone_number') {
            vm.phoneDisplay.traveller_phone = profileToSave[column];
          }

          if (column === 'secondary_phone_number') {
            vm.phoneDisplay.traveller_secondary_phone = profileToSave[column];
          }

          vm.updateCustomer(
            column,
            vm.order.confirmation_number,
            'traveller'
          );
        }
      });

      $timeout(function () {

        vm.isSavingCustomerProfile = false;
        vm.editingCustomerProfile = false;
        vm.editableCustomerProfile = {};

      }, 1000);
    }

    // Color by tag color code
    function getCustomerTagStyle(color) {
      if (!color) {
        color = '#00a3bd';
      }
      return {
        color: color,
        background: "color-mix(in srgb, " + color + " 12%, transparent)",
        border: "1px solid color-mix(in srgb, " + color + " 35%, transparent)",
      };
    }

    function focusField(fieldName) {
      $timeout(function () {
        var element = document.querySelector(
          '[name="' + fieldName + '"]'
        );

        if (!element) {
          return;
        }

        // Angular Material md-select
        if (fieldName === 'familyRelationship' || fieldName === 'petType') {
          element.click();
          return;
        }

        // Angular Material md-datepicker
        if (fieldName === 'petDob' || fieldName === 'familyDateOfBirth') {
          var dateInput = element.querySelector('input');

          if (dateInput) {
            dateInput.focus();
            dateInput.click();
          }

          return;
        }

        // Angular Material md-autocomplete (input is nested)
        if (
          fieldName === 'familyFirstName' ||
          fieldName === 'familyLastName' ||
          fieldName === 'familyEmail'
        ) {
          var autoInput = element.querySelector('input');

          if (autoInput) {
            autoInput.focus();
          }

          return;
        }

        element.focus();
      }, 100);
    }

    function loadCustomerFamilyMembers() {

      if (vm.customerFamilyMembers.isloading) {
        return;
      }

      /*
       * Don't interrupt add/edit form with the full-tab loader.
       * Refresh data silently in the background while the form is open.
       */
      var showLoader = !vm.showFamilyMemberForm;

      if (showLoader) {
        vm.customerFamilyMembers.isloading = true;
      }

      eCommerceService.getCustomerFamilyMembers(vm.order.customer_id).then(function(response) {

        if (
          response.data &&
          response.success
        ) {
          vm.customerFamilyMembers.data =
            response.data || [];
        } else {
          vm.customerFamilyMembers.data = [];
        }

      }).catch(function(error) {

        toastMessage.showSimpleToast(
          error.message ||
          'Unable to load family members.',
          "error-toast"
        );

        vm.customerFamilyMembers.data = [];

      }).finally(function() {

        vm.customerFamilyMembers.isloading = false;

      });
    };

    /*
     * Shared phone validation used by customer profile + family member.
     * Returns '' when empty, E.164 when valid, null when invalid.
     */
    function getPhoneNumber(inputId, fallbackValue) {
      var input = document.getElementById(inputId);
      if (!input) return fallbackValue;
      var iti = angular.element(input).data('iti');
      var val = (input.value || '').trim();
      if (!val) return '';
      if (iti) {
        if (iti.isValidNumberPrecise()) {
          return iti.getNumber();
        } else {
          return null;
        }
      }
      return fallbackValue;
    }

    function saveFamilyMember() {
      if (vm.isSavingFamilyMember) {
        return;
      }

      var form = vm.familyMemberForm;

      if (!form.first_name || !form.relationship_id) {
        return;
      }

      var phoneNumber = getPhoneNumber(
        'familyMemberPhoneNumber',
        form.phone_number
      );

      if (phoneNumber === null || (form.phone_number && phoneNumber === '')) {
        toastMessage.showSimpleToast(
          'Please enter a valid phone number.',
          'error-toast'
        );
        return;
      }

      vm.isSavingFamilyMember = true;
      vm.familyMemberForm.phone_number = phoneNumber;

      var dobString = '';
      if (form.date_of_birth) {
        if (form.date_of_birth instanceof Date) {
          dobString = moment(form.date_of_birth).format('MM-DD-YYYY');
        } else {
          dobString = form.date_of_birth;
        }
      }

      var data = {
        customer_id: vm.order.customer_id,

        first_name: String(
          form.first_name || ''
        ).trim(),

        last_name: String(
          form.last_name || ''
        ).trim(),

        customer_email: String(
          form.customer_email || ''
        ).trim(),

        phone_number: phoneNumber,

        relationship_id: parseInt(
          form.relationship_id,
          10
        ),

        date_of_birth: dobString
      };

      eCommerceService.addFamilyMember(data)
        .then(function(response) {

          if (response && response.success) {

            if (!vm.customerFamilyMembers.data) {
              vm.customerFamilyMembers.data = [];
            }

            vm.customerFamilyMembers.data.unshift(
              response.data
            );

            vm.showFamilyMemberForm = false;
            resetFamilyMemberForm();

          } else {

            toastMessage.showSimpleToast(
              (response && response.message) ||
              'Unable to add family member.',
              "error-toast"
            );
          }

        })
        .catch(function(error) {

          toastMessage.showSimpleToast(
            (
              error &&
              error.message
            ) ||
            'Unable to add family member.',
            'error-toast'
          );

        })
        .finally(function() {

          vm.isSavingFamilyMember = false;

        });
    }

    /*
     * Parse family-member DOB for md-datepicker.
     * Empty / invalid values must be null (not '') or the
     * datepicker shows an error state.
     */
    function parseFamilyMemberDob(value) {
      if (!value || value === '0000-00-00' || value === 'Invalid Date') {
        return null;
      }

      var familyDob = null;

      if (value instanceof Date) {
        familyDob = value;
      } else {
        var dob = String(value).trim();

        if (!dob) {
          return null;
        }

        if (/^\d{4}-\d{2}-\d{2}/.test(dob)) {
          var parts = dob.substring(0, 10).split('-');

          familyDob = new Date(
            parseInt(parts[0], 10),
            parseInt(parts[1], 10) - 1,
            parseInt(parts[2], 10),
            12,
            0,
            0
          );
        } else if (/^\d{2}-\d{2}-\d{4}$/.test(dob)) {
          var usParts = dob.split('-');

          familyDob = new Date(
            parseInt(usParts[2], 10),
            parseInt(usParts[0], 10) - 1,
            parseInt(usParts[1], 10),
            12,
            0,
            0
          );
        } else {
          familyDob = new Date(dob);
        }
      }

      if (familyDob instanceof Date && isNaN(familyDob.getTime())) {
        return null;
      }

      return familyDob;
    }

    function openAddFamilyMemberForm() {
      vm.editingFamilyMember = null;
      vm.customerFamilyMembers.isloading = false;
      resetFamilyMemberForm();
      vm.showFamilyMemberForm = true;

      $timeout(function () {
        focusField('familyFirstName');
      }, 0);
    }

    function editFamilyMember(member) {
      if (!member) {
        return;
      }

      vm.customerFamilyMembers.isloading = false;
      vm.editingFamilyMember = member;
      vm.showFamilyMemberForm = true;

      vm.familyMemberSearch = {
        first_name: member.first_name || '',
        last_name: member.last_name || '',
        customer_email: member.customer_email || ''
      };

      vm.selectedFamilyMemberSearch = {
        first_name: member,
        last_name: member,
        customer_email: member
      };

      vm.familyMemberForm = {
        customer_id: member.customer_id,

        first_name: member.first_name || '',

        last_name: member.last_name || '',

        customer_email: member.customer_email || '',

        phone_number: '',

        date_of_birth: parseFamilyMemberDob(member.date_of_birth),

        relationship_id: member.relationship_id
          ? parseInt(member.relationship_id, 10)
          : null
      };

      $timeout(function () {

        var phoneInput = document.getElementById(
          'familyMemberPhoneNumber'
        );
        var iti = null;

        if (phoneInput) {
          vm.isSettingFamilyMemberPhone = true;

          iti = angular.element(phoneInput).data('iti');

          if (
            !iti &&
            window.intlTelInputGlobals &&
            window.intlTelInputGlobals.getInstance
          ) {
            iti =
              window.intlTelInputGlobals.getInstance(
                phoneInput
              );
          }

          if (iti) {

            phoneInput.value = '';

            iti.setNumber(
              member.phone_number || ''
            );

            vm.familyMemberForm.phone_number =
              iti.getNumber();

          } else {
            vm.familyMemberForm.phone_number =
              member.phone_number || '';

            phoneInput.value =
              member.phone_number || '';
          }
        } else {
          vm.familyMemberForm.phone_number =
            member.phone_number || '';
        }

        $timeout(function () {

          vm.isSettingFamilyMemberPhone = false;
          if (iti) {
            vm.familyMemberForm.phone_number =
              iti.getNumber();
          }
          $scope.$applyAsync();

          // Focus first empty field (same pattern as pets)
          if (!vm.familyMemberForm.first_name) {
            focusField('familyFirstName');
            return;
          }

          if (!vm.familyMemberForm.last_name) {
            focusField('familyLastName');
            return;
          }

          if (!vm.familyMemberForm.customer_email) {
            focusField('familyEmail');
            return;
          }

          if (!vm.familyMemberForm.phone_number) {
            focusField('family_member_phone');
            return;
          }

          if (!vm.familyMemberForm.date_of_birth) {
            focusField('familyDateOfBirth');
            return;
          }

          if (!vm.familyMemberForm.relationship_id) {
            focusField('familyRelationship');
            return;
          }

          focusField('familyFirstName');

        }, 0);

      }, 0);
    }

    function cancelEditFamilyMember() {
      vm.editingFamilyMember = null;
      vm.showFamilyMemberForm = false;
      resetFamilyMemberForm();
    }

    function updateFamilyMember() {
      if (
        vm.isUpdatingFamilyMember ||
        !vm.editingFamilyMember
      ) {
        return;
      }

      var form = vm.familyMemberForm;

      if (
        !form.first_name ||
        !form.relationship_id
      ) {
        return;
      }

      var customerId = parseInt(
        vm.order.customer_id,
        10
      );

      var relatedCustomerId = parseInt(
        vm.editingFamilyMember.customer_id,
        10
      );

      if (!customerId || !relatedCustomerId) {
        toastMessage.showSimpleToast(
          'Invalid family relationship.',
          'error-toast'
        );

        return;
      }

      var phoneNumber = getPhoneNumber(
        'familyMemberPhoneNumber',
        form.phone_number
      );

      if (phoneNumber === null || (form.phone_number && phoneNumber === '')) {
        toastMessage.showSimpleToast(
          'Please enter a valid phone number.',
          'error-toast'
        );
        return;
      }

      var dobString = '';

      if (form.date_of_birth) {

        var dobMoment = moment(
          form.date_of_birth
        );

        if (dobMoment.isValid()) {
          dobString = dobMoment.format(
            'MM-DD-YYYY'
          );
        }
      }

      /*
      * Make sure relationship_id is numeric.
      */
      var relationshipId = parseInt(
        form.relationship_id,
        10
      );

      if (!relationshipId) {
        toastMessage.showSimpleToast(
          'Please select a relationship.',
          'error-toast'
        );

        return;
      }

      vm.familyMemberForm.phone_number = phoneNumber;

      var data = {
        customer_id: customerId,
        related_customer_id: relatedCustomerId,

        first_name: String(
          form.first_name || ''
        ).trim(),

        last_name: String(
          form.last_name || ''
        ).trim(),

        customer_email: String(
          form.customer_email || ''
        ).trim(),

        phone_number: phoneNumber,

        date_of_birth: dobString,

        relationship_id: relationshipId
      };

      vm.isUpdatingFamilyMember = true;

      eCommerceService
        .updateFamilyMember(data)

        .then(function(response) {

          if (
            response &&
            response.success === true
          ) {

            if (
              response.data &&
              vm.customerFamilyMembers.data
            ) {

              var index =
                vm.customerFamilyMembers.data.findIndex(
                  function(member) {

                    return parseInt(
                      member.customer_id,
                      10
                    ) === relatedCustomerId;
                  }
                );

              if (index !== -1) {

                vm.customerFamilyMembers.data[index] =
                  response.data;
              }
            }

            /*
            * Exit edit mode.
            */
            vm.editingFamilyMember = null;
            vm.showFamilyMemberForm = false;
            resetFamilyMemberForm();


          } else {

            toastMessage.showSimpleToast(
              (
                response &&
                response.message
              ) ||
              'Unable to update family member.',
              'error-toast'
            );
          }

        })

        .catch(function(error) {

          console.error(
            'Update family member error:',
            error
          );

          toastMessage.showSimpleToast(
            (
              error &&
              error.message
            ) ||
            'Unable to update family member.',
            'error-toast'
          );

        })

        .finally(function() {

          vm.isUpdatingFamilyMember = false;

        });
    }

    function resetFamilyMemberForm() {

      vm.familyMemberForm = {
        customer_id: null,
        first_name: '',
        last_name: '',
        customer_email: '',
        phone_number: '',
        date_of_birth: null,
        relationship_id: null
      };

      vm.familyMemberSearch = {
        first_name: '',
        last_name: '',
        customer_email: ''
      };

      vm.selectedFamilyMemberSearch = {
        first_name: null,
        last_name: null,
        customer_email: null
      };

      var phoneInput =
        document.getElementById(
          'familyMemberPhoneNumber'
        );

      if (phoneInput) {

        phoneInput.value = '';

        var iti = angular.element(
          phoneInput
        ).data('iti');

        if (!iti &&
            window.intlTelInputGlobals &&
            window.intlTelInputGlobals.getInstance) {

          iti =
            window.intlTelInputGlobals.getInstance(
              phoneInput
            );
        }

        if (iti) {
          iti.setNumber('');
        }
      }
    }

    function deleteFamilyMember(ev, member) {
      if (!member) {
        return;
      }

      var traveller = vm.order || {};
      var customerId = traveller.customer_id;

      if (!customerId) {
        toastMessage.showSimpleToast(
          "Invalid customer.",
          "error-toast"
        );
        return;
      }

      var confirm = $mdDialog
        .confirm()
        .title("Delete Family Member")
        .htmlContent(
          '<div class="md-padding custom-common-dailog">' +
          'Are you sure you want to delete this family member?' +
          '</div>'
        )
        .ariaLabel("Delete family member")
        .targetEvent(ev)
        .ok("DELETE")
        .cancel("CANCEL");

      $mdDialog.show(confirm).then(function () {

        /*
        * If this member is currently being edited,
        * cancel the edit first.
        */
        if (
          vm.editingFamilyMember &&
          vm.editingFamilyMember.customer_id === member.customer_id
        ) {
          vm.cancelEditFamilyMember();
        }

        member.isDeleting = true;

        var memberData = {
          customer_id: customerId,
          related_customer_id: member.customer_id
        };

        eCommerceService
          .deleteFamilyMember(memberData)
          .then(function (response) {

            if (response && response.data && response.success) {

              vm.customerFamilyMembers.data =
                vm.customerFamilyMembers.data.filter(function (item) {
                  return item.customer_id !== member.customer_id;
                });

            } else {

              toastMessage.showSimpleToast(
                (response &&
                  response.data &&
                  response.data.message) ||
                "Unable to delete family member.",
                "error-toast"
              );
            }

          })
          .catch(function () {

            toastMessage.showSimpleToast(
              "Unable to delete family member.",
              "error-toast"
            );

          })
          .finally(function () {

            member.isDeleting = false;

          });

      });
    }

    function getRelationshipTypes() {
      eCommerceService
        .getRelationshipTypes()
        .then(function(response) {

          if (response) {

            vm.relationshipTypes = response.data;

          } else {

            toastMessage.showSimpleToast(
              (response &&
                response.data &&
                response.data.message) ||
              'Unable to fetch relationship types.',
              'error-toast'
            );
          }

        })
        .catch(function() {

          toastMessage.showSimpleToast(
            'Unable to fetch relationship types.',
            'error-toast'
          );
        });
    }

    function goToFamilyMember(customerId) {
        if (!customerId) {
            return;
        }
        var url = $state.href('app.customer_update', {
            customer_id: customerId
        });

        $window.open(url, '_blank');
    };

    function loadCustomerPets() {

      if (vm.customerPets.isloading) {
        return;
      }

      var customerId =
        vm.order && vm.order.customer_id;

      if (!customerId) {
        toastMessage.showSimpleToast(
          'Invalid customer.',
          'error-toast'
        );
        return;
      }

      vm.customerPets.isloading = true;

      eCommerceService
        .getCustomerPets(customerId)
        .then(function(response) {

          if (response && response.success) {

            vm.customerPets.data =
              response.data || [];

          } else {

            vm.customerPets.data = [];

            toastMessage.showSimpleToast(
              (response && response.message) ||
              'Unable to load pets.',
              'error-toast'
            );
          }

        })
        .catch(function(error) {

          console.error(
            'Unable to load customer pets:',
            error
          );

          vm.customerPets.data = [];

          toastMessage.showSimpleToast(
            (error && error.message) ||
            'Unable to load pets.',
            'error-toast'
          );

        })
        .finally(function() {

          vm.customerPets.isloading = false;

        });
    }

    function loadPetTypes() {
      if (vm.petTypes.isloading) {
        return;
      }

      vm.petTypes.isloading = true;

      eCommerceService
        .getPetTypes()
        .then(function (response) {

          if (response && response.success) {

            vm.petTypes.data = response.data || [];

            /*
            * Get the ID of the "Other" pet type
            * from the database-driven pet types.
            */
            var otherType = vm.petTypes.data.find(function (type) {
              return type.name === 'Other';
            });

            vm.otherPetTypeId = otherType
              ? parseInt(otherType.id, 10)
              : null;

          } else {

            vm.petTypes.data = [];

            vm.otherPetTypeId = null;

            toastMessage.showSimpleToast(
              (response && response.message) ||
              'Unable to load pet types.',
              'error-toast'
            );
          }

        })
        .catch(function (error) {

          console.error(
            'Unable to load pet types:',
            error
          );

          vm.petTypes.data = [];

          vm.otherPetTypeId = null;

          toastMessage.showSimpleToast(
            (error && error.message) ||
            'Unable to load pet types.',
            'error-toast'
          );

        })
        .finally(function () {

          vm.petTypes.isloading = false;

        });
    }

    function saveCustomerPet() {
      if (vm.isSavingCustomerPet) {
        return;
      }

      var form = vm.customerPetForm;

      if (!form.name || !form.pet_type_id) {
        return;
      }

      if (
        form.pet_type_id == vm.otherPetTypeId &&
        !String(form.other_pet_type || '').trim()
      ) {
        return;
      }

      vm.isSavingCustomerPet = true;

      var dobString = '';

      if (form.date_of_birth) {
        if (form.date_of_birth instanceof Date) {
          dobString = moment(form.date_of_birth).format('MM-DD-YYYY');
        } else {
          dobString = form.date_of_birth;
        }
      }

      var data = {
        customer_id: vm.order.customer_id,
        name: String(form.name || '').trim(),
        pet_type_id: parseInt(form.pet_type_id, 10),

        other_pet_type:
          form.pet_type_id == vm.otherPetTypeId
            ? String(form.other_pet_type || '').trim()
            : null,

        date_of_birth: dobString
      };

      eCommerceService.addCustomerPet(data)
        .then(function (response) {

          if (response && response.success) {

            if (!vm.customerPets.data) {
              vm.customerPets.data = [];
            }

            vm.customerPets.data.unshift(response.data);

            vm.customerPetForm = {
              name: '',
              pet_type_id: null,
              other_pet_type: '',
              date_of_birth: null
            };

          } else {

            toastMessage.showSimpleToast(
              (response && response.message) ||
              'Unable to add pet.',
              'error-toast'
            );
          }

        })
        .catch(function (error) {

          console.error(
            'Unable to add customer pet:',
            error
          );

          toastMessage.showSimpleToast(
            (error && error.message) ||
            'Unable to add pet.',
            'error-toast'
          );

        })
        .finally(function () {
          vm.isSavingCustomerPet = false;
        });
    }
    
    function editCustomerPet(pet) {

      if (!pet) {
        return;
      }

      vm.editingCustomerPet = pet;

      var petDob = null;
      if (pet.date_of_birth) {
        if (typeof pet.date_of_birth === 'string') {
          var parts = pet.date_of_birth.split('-');
          if (parts.length === 3) {
            petDob = new Date(parts[0], parts[1] - 1, parts[2], 12, 0, 0);
          } else {
            petDob = new Date(pet.date_of_birth);
          }
        } else {
          petDob = new Date(pet.date_of_birth);
        }
      }

      vm.customerPetForm = {
        name: pet.name || '',
        pet_type_id: pet.pet_type_id
          ? parseInt(pet.pet_type_id, 10)
          : null,
        date_of_birth: petDob,
        other_pet_type: pet.other_pet_type || ''
      };
      // Wait for Angular to update the DOM
      $timeout(function () {

        // 1. Name is empty
        if (!vm.customerPetForm.name) {
          focusField('petName');
          return;
        }

        // 2. Pet type is empty
        if (!vm.customerPetForm.pet_type_id) {
          focusField('petType');
          return;
        }

        // 3. "Other" is selected but value is empty
        if (
          vm.customerPetForm.pet_type_id == vm.otherPetTypeId &&
          !vm.customerPetForm.other_pet_type
        ) {
          focusField('otherPetType');
          return;
        }

        // 4. Date of Birth is empty
        if (!vm.customerPetForm.date_of_birth) {
          focusField('petDob');
          return;
        }

        // 5. Everything is filled → focus Pet Name
        focusField('petName');

      }, 0);
    }

    function cancelEditCustomerPet() {
      vm.editingCustomerPet = null;
      vm.customerPetForm = {
        name: '',
        pet_type_id: null,
        other_pet_type: '',
        date_of_birth: null
      };
    }

    function updateCustomerPet() {
      if (
        vm.isUpdatingCustomerPet ||
        !vm.editingCustomerPet
      ) {
        return;
      }

      var form = vm.customerPetForm;

      if (!form.name) {
        return;
      }

      if (!form.pet_type_id) {
        return;
      }

      if (
        form.pet_type_id == vm.otherPetTypeId &&
        !form.other_pet_type
      ) {
        return;
      }

      vm.isUpdatingCustomerPet = true;

      var dobString = '';
      if (form.date_of_birth) {
        if (form.date_of_birth instanceof Date) {
          dobString = moment(form.date_of_birth).format('MM-DD-YYYY');
        } else {
          var parsedDob = moment(
            form.date_of_birth,
            [
              'MM/DD/YYYY',
              'YYYY-MM-DD',
              'MM-DD-YYYY'
            ],
            true
          );

          if (parsedDob.isValid()) {
            dobString = parsedDob.format('MM-DD-YYYY');
          }
        }
      }

      var data = {
        pet_id: vm.editingCustomerPet.id,
        customer_id: vm.order.customer_id,
        name: form.name.trim(),
        pet_type_id: form.pet_type_id,
        other_pet_type:
          form.pet_type_id == vm.otherPetTypeId
            ? form.other_pet_type.trim()
            : null,
        date_of_birth: dobString
      };

      eCommerceService.updateCustomerPet(data)
        .then(function(response) {

          if (
            response.data &&
            response.success
          ) {

            var updatedPet =
              response.data;

            /*
            * Update the existing row in the table.
            */
            var index =
              vm.customerPets.data
                .findIndex(function(pet) {
                  return (
                    pet.id ===
                    updatedPet.id
                  );
                });

            if (index !== -1) {
              vm.customerPets.data[index] =
                updatedPet;
            }

            /*
            * Exit edit mode.
            */
            vm.editingCustomerPet = null;

            /*
            * Reset form.
            */
            vm.customerPetForm = {
              name: '',
              pet_type_id: null,
              other_pet_type: '',
              date_of_birth: null
            };

          } else {
            toastMessage.showSimpleToast(
              response.data.message ||
              'Unable to update pet.',
              "error-toast"
            );
          }

        })
        .catch(function(error) {

          toastMessage.showSimpleToast(
            error.message ||
            'Unable to update pet.',
            "error-toast"
          );

        })
        .finally(function() {

          vm.isUpdatingCustomerPet = false;

        });
    };

    function deleteCustomerPet(ev, pet) {
      if (!pet) {
        return;
      }

      var traveller = vm.order || {};
      var customerId = traveller.customer_id;

      if (!customerId) {
        toastMessage.showSimpleToast(
          "Invalid customer.",
          "error-toast"
        );
        return;
      }

      var confirm = $mdDialog
        .confirm()
        .title("Delete Pet")
        .htmlContent(
          '<div class="md-padding custom-common-dailog">' +
          'Are you sure you want to delete this pet?' +
          '</div>'
        )
        .ariaLabel("Delete pet")
        .targetEvent(ev)
        .ok("DELETE")
        .cancel("CANCEL");

      $mdDialog.show(confirm).then(function () {

        /*
        * If this pet is currently being edited,
        * cancel the edit first.
        */
        if (
          vm.editingCustomerPet &&
          vm.editingCustomerPet.id === pet.id
        ) {
          vm.cancelEditCustomerPet();
        }

        pet.isDeleting = true;

        var petData = {
          pet_id: pet.id,
          customer_id: customerId
        };

        eCommerceService
          .deleteCustomerPet(petData)
          .then(function (response) {

            if (response && response.data && response.success) {

              vm.customerPets.data =
                vm.customerPets.data.filter(function (item) {
                  return item.id !== pet.id;
                });

            } else {

              toastMessage.showSimpleToast(
                (response &&
                  response.data &&
                  response.data.message) ||
                "Unable to delete pet.",
                "error-toast"
              );
            }

          })
          .catch(function () {

            toastMessage.showSimpleToast(
              "Unable to delete pet.",
              "error-toast"
            );

          })
          .finally(function () {

            pet.isDeleting = false;

          });

      });
    }

    function sendinvoice(type_of_order) {

      var vm = this;
      var fullName = (vm.order.first_name || '') + ' ' + (vm.order.last_name || '');
      var email = vm.order.customer_email || '';

      var html = 'Are you sure you want to send invoice to "' + fullName + ' - ' + email + '"?';

      $mdDialog
        .show({
          controller: "confirmController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/contacts/confirmationPopUp/confirmation.html",
          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: true,
          locals: {
            title: "Send Invoice",
            htmlContent: html,
            cancelBtn: "No",
            OkBtn: "Send",
          },
        })
        .then(function (answer) {
          if(typeof answer != "undefined" && answer == "update") {
            vm.isloading = true;
            var from_backend = 1;
            eCommerceService
              .sendInvoice(
                vm.reservation_id,
                vm.itinerary_number,
                type_of_order,
                from_backend
              )
              .then(function (response) {
                vm.isloading = false;
                if (!response.success) {
                    toastMessage.showSimpleToast(response.errorMsg, "error-toast");
                }
            }).catch(function(err){
                vm.isloading = false;
                toastMessage.showSimpleToast("Something went wrong", "error-toast");
            });
        }
        })
        .catch(function () {
          console.log("Invoice sending canceled.");
        });
    }

    function sendorderinvoice(confirmation_number) {
      eCommerceService
        .sendOrderInvoice(
          confirmation_number,
          vm.reservation_id,
          vm.order.room_stay_status
        )
        .then(function (response) {
          if (!response.success) {
            toastMessage.showSimpleToast(response.errorMsg, "error-toast");
          }
        });
    }

    function sendConfirmationEmail() {

      var fullName = (vm.order.first_name || '') + ' ' + (vm.order.last_name || '');
      var email = vm.order.customer_email || '';

      var html = '';
      if (!vm.order.send_email_indicator) {
          html =
              'Email sending is currently disabled for this guest.<br>' +
              'Do you still want to send the confirmation email to "' +
              fullName + ' - ' + email + '"?';
      } else {
          html =
              'Are you sure you want to send the confirmation email to "' +
              fullName + ' - ' + email + '"?';
      }

      $mdDialog.show({
          controller: "confirmController",
          controllerAs: "vm",
          templateUrl: "app/main/apps/contacts/confirmationPopUp/confirmation.html",
          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: true,
          locals: {
              title: "Send Confirmation Email",
              htmlContent: html,
              cancelBtn: "No",
              OkBtn: "Send"
          }
      }).then(function (answer) {

          if (answer === "update") {

              vm.isloading = true;
              eCommerceService.sendConfirmationEmail(
                confirmation_number,
                vm.reservation_id)
                  .then(function (response) {

                      vm.isloading = false;

                      if (!response.success) {
                          toastMessage.showSimpleToast(response.errorMsg, "error-toast");
                      }

                  }).catch(function () {

                      vm.isloading = false;
                      toastMessage.showSimpleToast("Something went wrong", "error-toast");

                  });
          }
      }).catch(function () {
          console.log("Confirmation email sending canceled.");
      });
    }

    function openKeyCardDialog(ev) {
      eCommerceService.openKeyCardDialog(ev, vm.order, 'reservation-detail');
    }

    function printinvoice(reservation_id) {
      if (vm.tabs_data.length > 1) {
        vm.isloading = true;
        eCommerceService
          .checkCustomerTravellerInfo(reservation_id)
          .then(function (response) {
            vm.isloading = false;
            if (response.custTravSame != undefined && response.custTravSame) {
              var tempData = {
                customer: true,
                traveller: true,
                resvId: reservation_id,
                confNo: "",
              };
              vm.printInvoiceInfo(tempData);
            } else if (
              response.travelInfo != undefined &&
              response.travelInfo.length
            ) {
              vm.showPrintInvoiceCustTravlSelection(
                "",
                response.travelInfo,
                "invoice"
              );
            }
          });
      } else if (vm.order.customerTravelSame) {
        /*vm.isloading = true;
	            eCommerceService.printInvoice(reservation_id).then(function(response) {
	            	vm.isloading = false;
	                if(!response.success) {
	                    toastMessage.showSimpleToast(response.errorMsg,'error-toast');
	                } else {
					    vm.isloading = false;
						vm.print_invoice_data = '';
	                    vm.print_invoice_data = response.data;
	                    var myWindow=window.open('','','', '');
	                    myWindow.document.write(response.data);
	                    myWindow.document.close();
	                    myWindow.focus();
	                }
	            });*/
        var tempData = {
          customer: true,
          traveller: true,
          resvId: reservation_id,
          confNo: "",
        };
        vm.printInvoiceInfo(tempData);
      } else {
        vm.showPrintInvoiceCustTravlSelection("", [], "invoice");
      }
    }

    vm.showPrintInvoiceCustTravlSelection = function (
      confNo,
      travellInfo,
      type
    ) {
      $mdDialog
        .show({
          controller: "printInvoiceController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/e-commerce/views/orders/order/printInvoice/printInvoice.html",
          parent: angular.element($document.body),
          clickOutsideToClose: true,
          locals: {
            resvId: vm.reservation_id,
            confNo: confNo,
            travellInfo: travellInfo,
            typePrint: type,
          },
        })
        .then(
          function (res) {},
          function (dialogText) {}
        );
    };

    $scope.$on("printInvoiceType", function (event, data) {
      vm.printInvoiceInfo(data);
    });

    /**
     * Print order invoice
     */
    vm.printInvoiceInfo = function (data) {
      vm.isloading = true;
      if (
        data.typePrint != undefined &&
        data.typePrint === "registrationcard"
      ) {
        data.confirmation_number = vm.order.confirmation_number;
        data.reservation_id = vm.order.reserv_id;
        createResService.printRegistrationCard(data).then(function (response) {
          vm.print_invoice_data = "";
          vm.print_invoice_data = response["data"];
          vm.isloading = false;
          var myWindow = window.open("", "", "", "");
          myWindow.document.write(response["data"]);
          myWindow.document.close();
          myWindow.focus();
        });
      } else {
        eCommerceService.printInvoiceInfo(data).then(function (response) {
          vm.isloading = false;
          if (!response.success) {
            toastMessage.showSimpleToast(response.errorMsg, "error-toast");
          } else {
            vm.isloading = false;
            vm.print_invoice_data = "";
            vm.print_invoice_data = response.data;
            var myWindow = window.open("", "", "", "");
            myWindow.document.write(response.data);
            myWindow.document.close();
            myWindow.focus();
          }
        });
      }
    };

    function printorderinvoice(confirmation_number) {
      if (vm.order.customerTravelSame) {
        var tempData = {
          customer: true,
          traveller: true,
          resvId: vm.reservation_id,
          confNo: confirmation_number,
        };
        vm.printInvoiceInfo(tempData);
      } else {
        vm.showPrintInvoiceCustTravlSelection(
          confirmation_number,
          [],
          "invoice"
        );
      }
      /*var response = [];
            eCommerceService.printOrderInvoice(confirmation_number).then(function(response) {
                if(!response.success) {
                    toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                } else {
					vm.print_data = '';
					vm.print_data = response.data;
					var myWindow=window.open('','','','');
					myWindow.document.write(vm.print_data);
					myWindow.document.close();
					myWindow.focus();
                }
            });*/
    }

    function editOrderDates(
      ev,
      checkin,
      checkout,
      adult,
      child,
      confirmation_number,
      product_id,
      product_name,
      policy_id
    ) {
      var taxExempt = false;
      if (
        vm.order.customerTaxExempt !== undefined &&
        vm.order.customerTaxExempt
      ) {
        // room is associated with customer
        taxExempt = true;
      }

      var localData = {
        checkin: checkin,
        checkout: checkout,
        adult: adult,
        child: child,
        confirmation_number: confirmation_number,
        product_id: product_id,
        product_name: product_name,
        reservation_id: Reservation_id,
        policy_id: policy_id,
        requestFor: vm.pageType,
        type_of_reservation: vm.order.type_of_reservation || "",
        tax_exempt_indicator: taxExempt,
        customerTaxExempt: vm.order.customerTaxExempt,
        travellerTaxExempt: vm.order.travellerTaxExempt,
        negotiatedCust:
          vm.order.negotiated_rate_resv != undefined
            ? vm.order.negotiated_rate_resv
            : 0,
        selectedRatePlanId:
          vm.order.selectedRatePlanId != undefined
            ? vm.order.selectedRatePlanId
            : 0,
      };

      eCommerceService.editDatesDialog(ev, localData);
    }

    function editParkingDates(
      ev,
      checkin,
      checkout,
      adult,
      child,
      confirmation_number,
      product_id,
      product_name,
      policy_id,
      posValue,
      poskey
    ) {
      if (
        typeof posValue != "undefined" &&
        typeof posValue.room_stay_status != "undefined" &&
        posValue.room_stay_status != "Canceled"
      ) {
        var localData = {
          checkin: checkin,
          checkout: checkout,
          adult: adult,
          child: child,
          confirmation_number: confirmation_number,
          room_confirmation_number: vm.order.confirmation_number,
          product_id: product_id,
          product_name: product_name,
          reservation_id: Reservation_id,
          policy_id: policy_id,
          parking: true,
          tax_exempt_indicator: vm.order.travellerTaxExempt,
        };
        // eCommerceService.editPDatesDialog(ev,localData);
        $mdDialog
          .show({
            controller: "parkingController",
            controllerAs: "vm",
            templateUrl:
              "app/main/apps/e-commerce/views/orders/dialogs/parking/parking.html",
            parent: angular.element($document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
              localData: localData,
            },
          })
          .then(
            function (res) {
              vm.loader[poskey] = "true";
              vm.initializeOrderPosData(vm.order);
            },
            function (dialogText) {}
          );
      }
    }

    function addParking(ev, checkin, checkout, confirmation_number) {
      var localData = {
        checkin: checkin,
        checkout: checkout,
        confirmation_number: confirmation_number,
        reservation_id: Reservation_id,
        parking: true,
        itinerary_number: vm.itinerary_number,
        add_screen: "view",
        tax_exempt_indicator: vm.order.travellerTaxExempt,
      };
      $mdDialog
        .show({
          controller: "parkingController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/e-commerce/views/orders/dialogs/parking/parking.html",
          parent: angular.element($document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          locals: {
            localData: localData,
          },
        })
        .then(
          function (res) {
            vm.initializeOrderPosData(vm.order);
          },
          function (dialogText) {}
        );
      // eCommerceService.editPDatesDialog(ev,localData);
    }

    function addBoatPos(ev, checkin, checkout, confirmation_number) {
      var localData = {
        checkin: checkin,
        checkout: checkout,
        confirmation_number: confirmation_number,
        reservation_id: Reservation_id,
        parking: false,
        itinerary_number: vm.itinerary_number,
        add_screen: "view",
        type: "boat",
        product_id: vm.order.product_id,
        type_id: vm.order.type_id,
        tax_exempt_indicator: vm.order.customerTaxExempt,
        associatedWithCustTrav:
          vm.order.current_billing != undefined ? vm.order.current_billing : 0,
      };
      $mdDialog
        .show({
          controller: "parkingController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/e-commerce/views/orders/dialogs/parking/parking.html",
          parent: angular.element($document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          locals: {
            localData: localData,
          },
        })
        .then(
          function (res) {
            vm.initializeOrderPosData(vm.order);
          },
          function (dialogText) {}
        );
    }

    function updateReservationValues(confirmation_number, column_name, value, comment) {
      if (value != "") {
        vm.isloading = true;
        var data = {
          reservation_id: vm.reservation_id,
          confirmation_number: confirmation_number,
          column_name: column_name,
          value: value,
        };
        if (comment) {
            data.modification_comment = comment;
        }

        eCommerceService
          .updateReservationValues(data)
          .then(function (response) {
            vm.isloading = false;
            if (!response.success) {
              toastMessage.showSimpleToast(
                "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.",
                "error-toast"
              );
            }
          });
      }
    }

    function saveCommentReq(idx, confirmation_number) {
      if (vm.comm_req_value != "") {
        vm.isloading = true;
        var data = {
          comm_req_type: vm.comm_req_type,
          comm_req_value: vm.comm_req_value,
          confirmation_number: confirmation_number,
          room_stay_from: vm.order.room_stay_from,
          room_stay_to: vm.order.room_stay_to,
          product_id: vm.order.product_id,
        };
        eCommerceService.saveCommentReq(data).then(function (response) {
          vm.isloading = false;
          if (response.success) {
            var new_comment = {
              description: response.created_by_user,
              title: response.comm_req_value,
              time: moment().format("lll"),
            };
            var listKey =
              vm.comm_req_type === "pos_comment"
                ? "posComment"
                : vm.comm_req_type;
            if (!Array.isArray(vm.commentsSpecial[listKey])) {
              vm.commentsSpecial[listKey] = [];
            }
            vm.commentsSpecial[listKey].unshift(new_comment);
            vm.comm_req_value = "";
          } else {
            toastMessage.showSimpleToast(
              "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.",
              "error-toast"
            );
          }
        });
      }
    }

    function payInstallment(
      conf_number,
      orderIndex,
      traveler_fname,
      traveler_lname
    ) {
      vm.addNewCard = false;
      vm.paymentrequestGoing = true;
      if (vm.changingStatus) {
        var changeStatusData = {
          confirmation_number: conf_number,
          remaining_amount: vm.installment_amount,
          payment_method: vm.payment_method,
          traveler_fname: traveler_fname,
          traveler_lname: traveler_lname,
          customer_profile: vm.customer_profile,
          paid_hotel_id: vm.paid_hotel_id,
          itinerary_number: vm.itinerary_number,
          payingFromGC: vm.payingFromGC,
        };
        vm.changeStatusData = angular.merge(
          vm.changeStatusData,
          changeStatusData
        );
        vm.changingStatus = false;
      } else {
        vm.changeStatusData = {
          confirmation_number: conf_number,
          remaining_amount: vm.installment_amount,
          payment_method: vm.payment_method,
          traveler_fname: traveler_fname,
          traveler_lname: traveler_lname,
          customer_profile: vm.customer_profile,
          paid_hotel_id: vm.paid_hotel_id,
          itinerary_number: vm.itinerary_number,
          payingFromGC: vm.payingFromGC,
        };
      }

      vm.changeStatusData.currentBilling = vm.order.currentBilling;
      if (
        vm.payment_method.payment_method != undefined &&
        vm.payment_method.payment_method == "Credit Card"
      ) {
        vm.changeStatusData.associatedWithCustTrav =
          vm.allcardsInfo[vm.use_existingcard] != undefined
            ? vm.allcardsInfo[vm.use_existingcard].custTravellerCard
            : vm.order.current_billing;
      } else {
        vm.changeStatusData.associatedWithCustTrav =
          vm.order.current_billing != undefined ? vm.order.current_billing : 0;
      }

      eCommerceService
        .payInstallment(vm.changeStatusData)
        .then(function (response) {
          vm.paymentrequestGoing = false;
          if (!response.success && response.errorMsg != "undefined") {
            toastMessage.showSimpleToast(response.errorMsg, "error-toast");
          } else if (!response.success) {
            toastMessage.showSimpleToast(
              "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.",
              "error-toast"
            );
          } else if (response.success) {
            if (response.errorMessageData != "") {
              toastMessage.showSimpleToast(
                response.errorMessageData,
                "error-toast"
              );
            }
            vm.payingFromGC = {};
            vm.installments = response.data.installments;
            vm.allcardsInfo = response.data.allcardsInfo;
            vm.customer_profile = response.data.customer_profile;
            vm.paid_hotel_id = response.data.hotel_id;
            vm.installment_amount = angular.copy(
              vm.installments["remaining"].origremainingamt
            );
            vm.order = response.reservation;
            originalOrderData = angular.copy(response.reservation);
            applyWaitingDisplayStatus();
            setAllStatuses();
            vm.initializeOrderPosData(vm.order);
            if (response.available_error != "") {
              toastMessage.showSimpleToast(
                response.available_error,
                "error-toast"
              );
            }
            if (Object.keys(response.data.allcardsInfo).length > 0) {
              var size = response.data.allcardsInfo.length;
              vm.payment_method =
                response.data.allcardsInfo[parseInt(size) - 1];
              if (
                response.data.allcardsInfo[parseInt(size) - 1].cc_number != ""
              ) {
                vm.fieldsIsReadOnly = true;
              }
            }

            vm.payment_method.payment_method =
              response.data.selectedPaymentMethod || "Cash";
            if (!vm.previousPaymentMethod) {
              vm.previousPaymentMethod = vm.payment_method.payment_method;
            }
          }
        });
    }

    function changeActiveCard(orderIndex) {
      vm.addNewCard = false;
      var count = vm.use_existingcard;
      vm.payment_method = vm.allcardsInfo[count];
      vm.fieldsIsReadOnly = true;
    }

    function checkremainingAmount(orderIndex) {
      if (
        parseFloat(vm.installments["remaining"].origremainingamt) <
        parseFloat(vm.installment_amount)
      ) {
        vm.installment_amount = vm.installments["remaining"].origremainingamt;
        toastMessage.showSimpleToast(
          $translate.instant("CREATE_RES.PAYNOW_ERROR"),
          "error-toast"
        );
      } else if (parseFloat(vm.payingFromGC.gcCardOrigPrice) > 0) {
        var adjustedGCPrice = commonService.calculateGCValue(
          vm.installment_amount,
          vm.payingFromGC.gcCardOrigPrice
        );
        vm.payingFromGC.price = adjustedGCPrice;
      }
    }

    vm.addNewCard = false;
    function emptythisPayment() {
      vm.addNewCard = true;
      var oldPaymentmethod = angular.copy(vm.payment_method.payment_method);
      vm.payment_method = {};
      vm.payment_method.payment_method = oldPaymentmethod;
      vm.fieldsIsReadOnly = false;
      vm.use_existingcard = "";
      vm.ct = "";
      setTimeout(function () {
        vm.readySwipe();
        vm.swipeNow();
      }, 100);
    }
    vm.not_incidental = false;

    function setasincidental(
      conf_number,
      orderIndex,
      traveler_fname,
      traveler_lname,
      type
    ) {
      var payment_method = angular.copy(vm.payment_method);
      var setting_as_inc = true;
      if (type == "is_incidental") {
        payment_method.cc_is_incidental = 1;
        vm.incidentalrequestGoing = true;
      } else {
        payment_method.cc_is_incidental = 0;
        vm.not_incidental = true;
        setting_as_inc = false;
      }
      var data = {
        confirmation_number: conf_number,
        reservation_id: vm.reservation_id,
        remaining_amount: 0,
        payment_method: payment_method,
        traveler_fname: traveler_fname,
        traveler_lname: traveler_lname,
        customer_profile: vm.customer_profile,
        itinerary_number: vm.itinerary_number,
        payingFromGC: 0,
        setting_as_inc: setting_as_inc,
        save_card: type,
        paid_hotel_id: vm.order.sub_hotel_id,
        associatedWithCustTrav:
          vm.order.current_billing != undefined ? vm.order.current_billing : 0,
        currentBilling: vm.order.currentBilling,
      };

      var oldExisting = angular.copy(vm.use_existingcard);
      eCommerceService.payInstallment(data).then(function (response) {
        vm.addNewCard = false;
        vm.incidentalrequestGoing = false;
        vm.not_incidental = false;
        if (!response.success && response.errorMsg != "undefined") {
          toastMessage.showSimpleToast(response.errorMsg, "error-toast");
        } else if (!response.success) {
          toastMessage.showSimpleToast(
            "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.",
            "error-toast"
          );
        } else if (response.success) {
          if (response.errorMessageData != "") {
            toastMessage.showSimpleToast(
              response.errorMessageData,
              "error-toast"
            );
          }
          vm.use_existingcard = "";
          vm.payingFromGC = {};
          vm.allcardsInfo = response.data.allcardsInfo;
          vm.customer_profile = response.data.customer_profile;
          vm.payment_method = response.data.allcardsInfo[0];
          vm.fieldsIsReadOnly = true;
          $timeout(function () {
            vm.use_existingcard = 0;
          }, 200);
        }
      });
    }

    function toBoolean(val) {
      if (typeof val === "string") {
        var normalized = val.trim().toLowerCase();
        if (normalized === "true" || normalized === "1" || normalized === "yes")
          return true;
        if (normalized === "false" || normalized === "0" || normalized === "no")
          return false;
      }
      if (val === true || val === 1 || val === "1" || val === "true") return true;
      if (val === false || val === 0 || val === "0" || val === "false")
        return false;
      return !!val;
    }

    function getDefinedValue(obj, keys) {
      if (!obj || !keys || !keys.length) return undefined;
      for (var i = 0; i < keys.length; i++) {
        if (obj[keys[i]] !== undefined) return obj[keys[i]];
      }
      return undefined;
    }

    function hasCcProcessingAppliedField(item) {
      return (
        getDefinedValue(item, [
          "ccProcessingFeeApplied",
          "cc_processing_fee_applied",
        ]) !== undefined
      );
    }

    function isCcProcessingFeeApplicable(item) {
      if (!item) return false;
      var explicitApplicable = getDefinedValue(item, [
        "ccProcessingFeeApplicable",
        "cc_processing_fee_applicable",
      ]);
      if (explicitApplicable !== undefined) {
        return toBoolean(explicitApplicable);
      }
      var key = item.confirmation_number || "";
      if (
        key &&
        vm.ccProcessingFeeApplicableByConfirmation.hasOwnProperty(key)
      ) {
        return !!vm.ccProcessingFeeApplicableByConfirmation[key];
      }
      // Some payloads omit "applicable" but still include "applied".
      // If "applied" exists, the CC processing fee feature is applicable.
      if (hasCcProcessingAppliedField(item)) return true;
      return false;
    }

    function isPosNonCancellable(pos) {
      if (!pos) return false;
      try {
        var extraSettings = typeof pos.extra_settings === 'string'
          ? JSON.parse(pos.extra_settings)
          : pos.extra_settings;
        return !!(extraSettings && extraSettings.is_non_cancellable === true);
      } catch(e) {
        return false;
      }
    }

    function isPosQuantityLocked(pos) {
      if (!pos) return false;
      try {
        var extraSettings = typeof pos.extra_settings === 'string'
          ? JSON.parse(pos.extra_settings)
          : pos.extra_settings;
        return !!(extraSettings && extraSettings.is_quantity_locked === true);
      } catch(e) {
        return false;
      }
    }

    vm.hasNonCancellablePos = function(order) {
      if (!order || !order.pos || !order.pos.length) return false;
      return order.pos.some(function(pos) {
          return isPosNonCancellable(pos);
      });
    };

    vm.hasPosQuantityLocked = function(order) {
      if (!order || !order.pos || !order.pos.length) return false;
      return order.pos.some(function(pos) {
          return isPosQuantityLocked(pos);
      });
    };

    function isRoundUpForCharityPos(pos) {
      if (!pos) return false;
      var nameNorm = String(
        pos.product_name || pos.fe_display_product_name || ""
      )
        .toLowerCase()
        .replace(/\s+/g, " ")
        .trim();
      return nameNorm === "round up for charity";
    }

    /** Pass-only day_reservation parent (no real Day Room product). */
    function isPassOnlyDayShell() {
      if (!vm.order || vm.order.type_of_reservation !== "day_reservation") {
        return false;
      }
      var pid = vm.order.product_id;
      return pid === 0 || pid === "0" || pid === null || pid === undefined || pid === "";
    }

    /** Day Room uses Day / Day-price; overnight stays use Night / Nightly-price. */
    function getStayUnitLabel() {
      return vm.order && vm.order.type_of_reservation === "day_reservation"
        ? "Day"
        : "Night";
    }

    function getStayPriceHeading() {
      return vm.order && vm.order.type_of_reservation === "day_reservation"
        ? "Day-price"
        : "Nightly-price";
    }

    /** Day Pass / Beach Pass / Private Beach Pass POS line. */
    function isDailyPassPos(pos) {
      if (!pos) return false;
      var slug = String(pos.product_slug || "")
        .toLowerCase()
        .trim();
      if (
        slug === "day_pass" ||
        slug === "daypass" ||
        slug === "beach_pass" ||
        slug === "private_beach_pass"
      ) {
        return true;
      }
      var name = String(pos.product_name || pos.fe_display_product_name || "")
        .toLowerCase()
        .replace(/\s+/g, " ")
        .trim();
      return (
        name.indexOf("day pass") !== -1 || name.indexOf("beach pass") !== -1
      );
    }

    function getDailyPassDate(pos) {
      // New bookings store date on the service row; ignore invalid / blank values.
      var from = pos && pos.room_stay_from;
      if (!from || from === "0000-00-00" || from === "Invalid Date") {
        return "";
      }
      if (typeof from === "object" && from instanceof Date) {
        if (isNaN(from.getTime())) {
          return "";
        }
        var m = from.getMonth() + 1;
        var d = from.getDate();
        return (
          from.getFullYear() +
          "-" +
          (m < 10 ? "0" + m : m) +
          "-" +
          (d < 10 ? "0" + d : d)
        );
      }
      return from;
    }

    function deleteRoundUpForCharityPos(pos, posKey, $event) {
      if ($event && $event.stopPropagation) {
        $event.stopPropagation();
      }
      if (!pos || !isRoundUpForCharityPos(pos)) {
        return;
      }
      if (vm.roundUpForCharityDeletingPos[posKey]) {
        return;
      }

      var payload = {
        confirmation_number: pos.confirmation_number || "",
      };
      if (
        pos.room_confirmation_number ||
        (vm.order && vm.order.confirmation_number)
      ) {
        payload.room_confirmation_number =
          pos.room_confirmation_number || vm.order.confirmation_number;
      }

      if (!payload.confirmation_number) {
        toastMessage.showSimpleToast(
          "Please provide POS confirmation number.",
          "error-toast"
        );
        return;
      }

      var html = "Are you sure you want to delete this POS product?";
      $mdDialog
        .show({
          controller: "confirmController",
          controllerAs: "vm",
          templateUrl: "app/main/apps/contacts/confirmationPopUp/confirmation.html",
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          targetEvent: $event,
          locals: {
            title: "Delete POS Product",
            htmlContent: html,
            cancelBtn: "No",
            OkBtn: "Yes",
          },
        })
        .then(function (action) {
          if (action !== "update") {
            return;
          }
        vm.roundUpForCharityDeletingPos[posKey] = true;
        eCommerceService
          .deletePosFromReservation(payload)
          .then(function (response) {
            vm.roundUpForCharityDeletingPos[posKey] = false;
            if (response && response.success === true) {
              var refreshConfirmationNumber =
                vm.order && vm.order.confirmation_number
                  ? vm.order.confirmation_number
                  : payload.room_confirmation_number || payload.confirmation_number;
              vm.fetchOrder(refreshConfirmationNumber, "hitRequest");
            } else {
              toastMessage.showSimpleToast(
                (response && response.errorMsg) ||
                  "Unable to delete Round Up For Charity. Please try again.",
                "error-toast"
              );
            }
          })
          .catch(function (error) {
            vm.roundUpForCharityDeletingPos[posKey] = false;
            toastMessage.showSimpleToast(
              (error && error.errorMsg) ||
                "Unable to delete Round Up For Charity. Please try again.",
              "error-toast"
            );
          });
        });
    }

    /**
     * Sync CC processing fee checkbox state with server payload.
     * The checkbox represents "Remove CC processing fee" => checked means the fee is currently removed.
     */
    function syncCcProcessingFeeCheckboxes() {
      if (!vm || !vm.order) return;

      // Persist applicability from payload so UI remains stable even when
      // some refresh responses omit ccProcessingFeeApplicable.
      var roomApplicable = getDefinedValue(vm.order, [
        "ccProcessingFeeApplicable",
        "cc_processing_fee_applicable",
      ]);
      if (vm.order.confirmation_number && roomApplicable !== undefined) {
        vm.ccProcessingFeeApplicableByConfirmation[
          vm.order.confirmation_number
        ] = toBoolean(roomApplicable);
      }

      // Main reservation (room) checkbox
      var roomApplied = getDefinedValue(vm.order, [
        "ccProcessingFeeApplied",
        "cc_processing_fee_applied",
      ]);
      vm.removeCcProcessingFeeRoom = isCcProcessingFeeApplicable(vm.order)
        ? !toBoolean(roomApplied)
        : false;

      // POS checkboxes
      if (vm.order.pos && vm.order.pos.length !== undefined) {
        angular.forEach(vm.order.pos, function (posValue, posKey) {
          var posApplicable = getDefinedValue(posValue, [
            "ccProcessingFeeApplicable",
            "cc_processing_fee_applicable",
          ]);
          if (posValue && posValue.confirmation_number && posApplicable !== undefined) {
            vm.ccProcessingFeeApplicableByConfirmation[
              posValue.confirmation_number
            ] = toBoolean(posApplicable);
          }
          var applied = posValue
            ? toBoolean(
                getDefinedValue(posValue, [
                  "ccProcessingFeeApplied",
                  "cc_processing_fee_applied",
                ])
              )
            : false;
          vm.removeCcProcessingFeePos[posKey] = isCcProcessingFeeApplicable(posValue)
            ? !applied
            : false;
        });
      }
    }

    function toggleRemoveCcProcessingFee(context, posKey, confirmationNumberOverride) {
      if (
        (context === "room" && !isCcProcessingFeeApplicable(vm.order)) ||
        (context === "pos" &&
          (!vm.order ||
            !vm.order.pos ||
            !isCcProcessingFeeApplicable(vm.order.pos[posKey])))
      ) {
        return;
      }

      var apiConfirmationNumber =
        confirmationNumberOverride ||
        (vm.order && vm.order.confirmation_number
          ? vm.order.confirmation_number
          : "");

      if (!apiConfirmationNumber) {
        toastMessage.showSimpleToast(
          "Missing confirmation number.",
          "error-toast"
        );
        return;
      }

      var isChecked =
        context === "room"
          ? !!vm.removeCcProcessingFeeRoom
          : !!vm.removeCcProcessingFeePos[posKey];
      var action = isChecked ? "remove" : "add";

      if (context === "room") {
        if (vm.ccProcessingFeeRemovingRoom) return;
        vm.ccProcessingFeeRemovingRoom = true;
      } else {
        if (vm.ccProcessingFeeRemovingPos[posKey]) return;
        vm.ccProcessingFeeRemovingPos[posKey] = true;
      }

      // Backend contract for `change_cc_processing_fee_tax_post()`:
      // camelCase only + multi-action payload (add/remove lists).
      var payload = {
        itemsToAddCcProcessingFeeTax: action === "add" ? [apiConfirmationNumber] : [],
        itemsToRemoveCcProcessingFeeTax:
          action === "remove" ? [apiConfirmationNumber] : [],
        parentConfirmationNumber:
          vm.order && vm.order.confirmation_number
            ? vm.order.confirmation_number
            : undefined,
      };

      eCommerceService.changeCCProcessingFeeTax(payload).then(function (response) {
        if (context === "room") {
          vm.ccProcessingFeeRemovingRoom = false;
        } else {
          vm.ccProcessingFeeRemovingPos[posKey] = false;
        }

        if (response && response.success === true) {
          // Important: always refresh the page using the room confirmation number,
          // because fetchOrder() expects the main reservation object.
          var refreshConfirmationNumber =
            vm.order && vm.order.confirmation_number
              ? vm.order.confirmation_number
              : apiConfirmationNumber;
          vm.fetchOrder(refreshConfirmationNumber, "hitRequest");
        } else {
          var revertVal = action === "remove" ? false : true;
          if (context === "room") {
            vm.removeCcProcessingFeeRoom = revertVal;
          } else {
            vm.removeCcProcessingFeePos[posKey] = revertVal;
          }
          var toastMsg =
            "Oops! - We've encountered an error. Please try again.";
          if (response) {
            // New backend failure shape:
            // - top-level message is empty string on failure
            // - failure details are in `failed[]`
            if (response.message) toastMsg = response.message;
            else if (Array.isArray(response.failed) && response.failed.length) {
              toastMsg =
                response.failed[0].errorMsg ||
                response.failed[0].reason ||
                "Some updates failed.";
            }
          }
          toastMessage.showSimpleToast(toastMsg, "error-toast");
        }
      }).catch(function () {
        if (context === "room") {
          vm.ccProcessingFeeRemovingRoom = false;
        } else {
          vm.ccProcessingFeeRemovingPos[posKey] = false;
        }
        var revertVal = action === "remove" ? false : true;
        if (context === "room") {
          vm.removeCcProcessingFeeRoom = revertVal;
        } else {
          vm.removeCcProcessingFeePos[posKey] = revertVal;
        }
      });
    }

    function validateGCCode() {
      vm.gcrequestGoing = true;
      createResService
        .validateGCC({ GCC: vm.giftCardCode })
        .then(function (response) {
          vm.gcrequestGoing = false;
          if (response.success && !response.data.length == 0) {
            if (parseFloat(response.data[0]["gift_card_price"]) == 0) {
              vm.giftCardErrro = "No amount left for this gift card.";
            } else {
              var adjustedGCPrice = commonService.calculateGCValue(
                vm.installment_amount,
                response.data[0]["gift_card_price"]
              );
              vm.payingFromGC = {};
              vm.payingFromGC.price = adjustedGCPrice;
              vm.payingFromGC.gcCode = response.data[0]["gift_card_code"];
              vm.payingFromGC.gcCardOrigPrice =
                response.data[0]["gift_card_price"];
              vm.giftCardErrro = "";
              vm.giftCardCode = "";
              $location.hash("focus-cccode");
              $timeout(function () {
                $window.location.hash = "";
              }, 2000);
            }
          } else if (!response.success && response.errorMsg != "") {
            vm.payingFromGC = {};
            vm.giftCardErrro = response.errorMsg;
          } else if (response.data.length == 0) {
            vm.payingFromGC = {};
            vm.giftCardErrro = $translate.instant("CREATE_RES.INVALID_GC");
          } else {
            vm.payingFromGC = {};
            vm.giftCardErrro = $translate.instant("CREATE_RES.SERVER_ERROR");
          }
        });
    }
    function addroomincart(ev) {
      // product_type = 'room';
      var isDayOrder = vm.order && vm.order.type_of_reservation === "day_reservation";
      var additionalParams = {
        reservation_type: isDayOrder
          ? "day_reservation"
          : vm.order["type_of_reservation"],
        negotiatedCust:
          vm.order.negotiated_rate_resv != undefined
            ? vm.order.negotiated_rate_resv
            : 0,
      };
      // pageFrom must be day_reservation so Add Room search sends day flags (not overnight rates)
      var pageFrom = isDayOrder ? "day_reservation" : vm.pageType;

      createResService.addRoom(
        ev,
        vm.order.room_stay_from,
        vm.order.room_stay_to,
        vm.order["room_stay_guest_count"],
        vm.order["room_stay_child_count"],
        "",
        "currentorder",
        vm.itinerary_number,
        pageFrom,
        "",
        additionalParams
      );
    }
    function cancelThisNight(nightDate) {
      $mdDialog
        .show({
          controller: "confirmController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/contacts/confirmationPopUp/confirmation.html",
          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: true,
          locals: {
            title: "No show night",
            // htmlContent:"Are you sure you want to cancel this night without issuing a refund to the customer?",
            htmlContent:
              "By continuing and clicking yes, this room night will not be refunded.",
            cancelBtn: "No",
            OkBtn: "Yes",
          },
        })
        .then(
          function (answer) {
            if (typeof answer != "undefined" && answer == "update") {
              vm.cancelNoShowNight(nightDate, "no");
            }
          },
          function (dialogText) {}
        );
    }

    vm.cancelNoShowNight = function (nightDate, refundAmount) {
      vm.isloading = true;
      createResService
        .cancelThisNight({
          confirmation_number: vm.order.confirmation_number,
          date: nightDate,
          refundAmount: refundAmount,
        })
        .then(function (response) {
          vm.isloading = false;
          if (response.success) {
            vm.order = response.order_info.reservations[0];
            originalOrderData = angular.copy(vm.order);
          } else if (!response.success && response.errorMsg) {
            toastMessage.showSimpleToast(response.errorMsg, "error-toast");
          } else if (!response.success && response.server_error) {
            toastMessage.showSimpleToast(
              $translate.instant("CREATE_RES.SERVER_ERROR"),
              "error-toast"
            );
          } else {
            toastMessage.showSimpleToast(
              $translate.instant("CREATE_RES.SERVER_ERROR"),
              "error-toast"
            );
          }
        });
    };

    vm.cancelThisNightPOS = cancelThisNightPOS;

    function cancelThisNightPOS(date, posValue) {
      $mdDialog
        .show({
          controller: "confirmController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/contacts/confirmationPopUp/confirmation.html",
          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: true,
          locals: {
            title: "Cancel Night",
            htmlContent:
              "Are you sure you want to cancel this night without issuing a refund to the customer?",
            cancelBtn: "No",
            OkBtn: "Yes",
          },
        })
        .then(
          function (answer) {
            if (typeof answer != "undefined" && answer == "update") {
              vm.isloading = true;
              createResService
                .cancelThisNightPOS({
                  room_confirmation_number: vm.order.confirmation_number,
                  date: date,
                  cancelNight: "service",
                  pos_Confirmation_number: posValue["confirmation_number"],
                })
                .then(function (response) {
                  vm.isloading = false;
                  if (response.success) {
                    vm.order = response.order_info.reservations[0];
                    originalOrderData = angular.copy(vm.order);
                  } else if (!response.success && response.errorMsg) {
                    toastMessage.showSimpleToast(
                      response.errorMsg,
                      "error-toast"
                    );
                  } else if (!response.success && response.server_error) {
                    toastMessage.showSimpleToast(
                      $translate.instant("CREATE_RES.SERVER_ERROR"),
                      "error-toast"
                    );
                  } else {
                    toastMessage.showSimpleToast(
                      $translate.instant("CREATE_RES.SERVER_ERROR"),
                      "error-toast"
                    );
                  }
                });
            }
          },
          function (dialogText) {}
        );
    }

    vm.undoCancelThisNightPOS = undoCancelThisNightPOS;
    function undoCancelThisNightPOS(date, posValue) {
      vm.isloading = true;
      createResService
        .undoCancelThisNight({
          room_confirmation_number: vm.order.confirmation_number,
          date: date,
          cancelNight: "service",
          pos_Confirmation_number: posValue["confirmation_number"],
        })
        .then(function (response) {
          vm.isloading = false;
          if (response.success) {
            vm.order = response.order_info.reservations[0];
            originalOrderData = angular.copy(vm.order);
          } else if (!response.success && response.errorMsg) {
            toastMessage.showSimpleToast(response.errorMsg, "error-toast");
          } else if (!response.success && response.server_error) {
            toastMessage.showSimpleToast(
              $translate.instant("CREATE_RES.SERVER_ERROR"),
              "error-toast"
            );
          } else {
            toastMessage.showSimpleToast(
              $translate.instant("CREATE_RES.SERVER_ERROR"),
              "error-toast"
            );
          }
        });
    }

    // vm.posNoRefundCancel = posNoRefundCancel;
    // function posNoRefundCancel(dateKey, posValue){
    // 	return (dateKey == 0 || dateKey == (posValue.prices.dates.length - 1)) ? true:false;
    // }
    function undoCancelThisNight(nightDate) {
      vm.isloading = true;
      createResService
        .undoCancelThisNight({
          confirmation_number: vm.order.confirmation_number,
          date: nightDate,
        })
        .then(function (response) {
          vm.isloading = false;
          if (response.success) {
            vm.order = response.order_info.reservations[0];
            originalOrderData = angular.copy(vm.order);
          } else if (!response.success && response.errorMsg) {
            toastMessage.showSimpleToast(response.errorMsg, "error-toast");
          } else if (!response.success && response.server_error) {
            toastMessage.showSimpleToast(
              $translate.instant("CREATE_RES.SERVER_ERROR"),
              "error-toast"
            );
          } else {
            toastMessage.showSimpleToast(
              $translate.instant("CREATE_RES.SERVER_ERROR"),
              "error-toast"
            );
          }
        });
    }

    $scope.$on("update_order_data", function (event, data) {
      vm.order = data.reservations;
      vm.tabs_data[vm.selectedIndex]["tab_name"] = vm.tabs_data[
        vm.selectedIndex
      ]["product_room_number"] = vm.order["product_room_number"];
      vm.tabs_data[vm.selectedIndex]["tab_date"] =
        moment(vm.order["room_stay_from"]).format("MM/DD") +
        "-" +
        moment(vm.order["room_stay_to"]).format("MM/DD");
      vm.order["tax_exempt_indicator"] =
        vm.reservation_customer.tax_exempt_indicator;
      vm.boatArrayFinal = monthlyWeeklyNight(vm.order);

      originalOrderData = angular.copy(vm.order);
      setAllStatuses();
      vm.showModifyBtn = false;
      vm.showPaymentsLoader = true;
      $timeout(function () {
        vm.boatArrayFinal = monthlyWeeklyNight(vm.order);
        fetchPaymentsInformation(
          vm.order.confirmation_number,
          vm.order.first_name,
          vm.order.last_name,
          vm.order.total_amount,
          vm.order.overalltotals.remaining_amount
        );
      }, 100);
      initializeOrderPosData(vm.order);
    });

    function monthlyWeeklyNight(orderData) {
      if (
        orderData.hasOwnProperty("prices") &&
        orderData.prices.hasOwnProperty("dates") &&
        Object.keys(orderData.prices.dates).length > 31
      ) {
        var monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        vm.dates = {};
        angular.forEach(orderData.prices.dates, function (value, key) {
          var monthArr = value.split("-");
          var date = new Date(value);
          var month = monthNames[date.getMonth()];
          var weekofmonth = date.getDay();
          var year = monthArr[2];
          var month_year = month + " " + year;

          if (typeof vm.dates[month_year] == "undefined") {
            vm.dates[month_year] = {};
          }

          vm.dates[month_year][key] = value;
        });

        vm.newArray = {};
        angular.forEach(vm.dates, function (monthvalue, monthkey) {
          var monthLength = Object.keys(monthvalue).length;
          var first = Object.keys(monthvalue)[0];
          var last = Object.keys(monthvalue)[monthLength - 1];
          var wkey = 0;
          for (var i = parseInt(first); i <= parseInt(last); i++) {
            if (typeof vm.newArray[monthkey] == "undefined")
              vm.newArray[monthkey] = {};

            if (typeof vm.newArray[monthkey][wkey] == "undefined")
              vm.newArray[monthkey][wkey] = {};

            vm.newArray[monthkey][wkey][i] = monthvalue[i];

            if (
              Object.keys(vm.newArray[monthkey][wkey]).length > 6 &&
              Object.keys(vm.newArray[monthkey][wkey]).length < 31
            ) {
              first += 7;
              wkey++;
              continue;
            }
          }
        });

        angular.forEach(vm.newArray, function (value, key) {
          var yearmonthLength = Object.keys(vm.newArray).length;
          var firstofmonth = Object.keys(vm.newArray)[1];
          var lastofmonth = Object.keys(vm.newArray)[yearmonthLength - 2];
          var weekmonthLength = Object.keys(vm.newArray[lastofmonth]).length;
          var firstofweek = Object.keys(vm.newArray[lastofmonth])[0];
          var lastofweek = Object.keys(vm.newArray[lastofmonth])[
            weekmonthLength - 1
          ];

          if (
            Object.keys(value).length == 1 &&
            Object.keys(vm.newArray[Object.keys(vm.newArray)[0]][0]).length == 1
          ) {
            var monthattributes = Object.keys(vm.newArray[key][0]);
            for (var i = 0; i < monthattributes.length; i++) {
              vm.newArray[firstofmonth][firstofweek][monthattributes[i]] =
                vm.newArray[key][0][monthattributes[i]];
            }
            // delete vm.newArray[key];
          } else if (
            Object.keys(value).length == 1 &&
            Object.keys(
              vm.newArray[Object.keys(vm.newArray)[yearmonthLength - 1]][0]
            ).length == 1
          ) {
            var monthattributes = Object.keys(vm.newArray[key][0]);
            for (var i = 0; i < monthattributes.length; i++) {
              vm.newArray[lastofmonth][lastofweek][monthattributes[i]] =
                vm.newArray[key][0][monthattributes[i]];
            }
            // delete vm.newArray[key];
          } else {
            angular.forEach(value, function (weekvalue, weekkey) {
              if (
                Object.keys(weekvalue).length == 1 ||
                (Object.keys(weekvalue).length == 1 &&
                  Object.keys(
                    vm.newArray[Object.keys(vm.newArray)[yearmonthLength - 1]][
                      weekkey
                    ]
                  ).length == 1)
              ) {
                var attributes = Object.keys(vm.newArray[key][weekkey]);
                if (Object.keys(vm.newArray[key][weekkey]).length > 1) {
                  for (var i = 0; i < attributes.length; i++) {
                    vm.newArray[key][weekkey - 1][attributes[i]] =
                      vm.newArray[key][weekkey][attributes[i]];
                  }
                  delete vm.newArray[key][weekkey];
                }
              }
            });
          }
        });

        // Monthly/Weekly overall total and paid amount start
        vm.weekOverallTotal = {};
        vm.weekPaidValues = {};
        vm.weekOwesValues = {};
        vm.monthOverallTotal = {};
        vm.PaidValues = {};
        vm.owesValues = {};
        vm.monthly_paid_amount = vm.order.overalltotals.paid_amount;
        vm.total_paid_amount = vm.order.overalltotals.paid_amount;

        angular.forEach(vm.newArray, function (monthlyvalue, monthlykey) {
          if (typeof vm.monthOverallTotal[monthlykey] == "undefined")
            vm.monthOverallTotal[monthlykey] = {};
          vm.monthOverallTotal[monthlykey]["discount"] = 0;
          vm.monthOverallTotal[monthlykey]["price"] = 0;
          angular.forEach(monthlyvalue, function (value, key) {
            angular.forEach(value, function (weekData, weekSkey) {
              vm.monthOverallTotal[monthlykey]["discount"] += parseFloat(
                vm.order.prices.nightlydiscount[weekSkey]
              );
              vm.monthOverallTotal[monthlykey]["price"] += parseFloat(
                vm.order.prices.rates[weekSkey]
              );
            });
          });

          vm.monthOverallTotal[monthlykey]["discount"] = commonService.roundnum(
            vm.monthOverallTotal[monthlykey]["discount"],
            2
          );
          vm.monthOverallTotal[monthlykey]["price"] = commonService.roundnum(
            vm.monthOverallTotal[monthlykey]["price"],
            2
          );
          vm.monthOverallTotal[monthlykey]["discountedPrice"] =
            vm.monthOverallTotal[monthlykey]["price"] -
            vm.monthOverallTotal[monthlykey]["discount"];

          //Monthly paid amount start
          vm.monthly_paid_amount = 0;

          if (
            parseFloat(vm.monthOverallTotal[monthlykey]["discountedPrice"]) <=
            parseFloat(vm.total_paid_amount)
          ) {
            vm.total_paid_amount =
              parseFloat(vm.total_paid_amount) -
              parseFloat(vm.monthOverallTotal[monthlykey]["discountedPrice"]);
            vm.monthly_paid_amount = commonService.roundnum(
              vm.monthOverallTotal[monthlykey]["discountedPrice"],
              2
            );
          } else if (
            parseFloat(vm.monthOverallTotal[monthlykey]["discountedPrice"]) >
            parseFloat(vm.total_paid_amount)
          ) {
            var temp_paid_amount = angular.copy(vm.total_paid_amount);
            vm.total_paid_amount = 0;
            vm.monthly_paid_amount = commonService.roundnum(
              temp_paid_amount,
              2
            );
          }
          if (typeof vm.PaidValues[monthlykey] == "undefined")
            vm.PaidValues[monthlykey] = angular.copy(vm.monthly_paid_amount);

          if (typeof vm.owesValues[monthlykey] == "undefined") {
            vm.owesValues[monthlykey] =
              vm.monthOverallTotal[monthlykey]["price"] -
              vm.PaidValues[monthlykey];
            vm.owesValues[monthlykey] = commonService.roundnum(
              vm.owesValues[monthlykey],
              2
            );
          }

          if (vm.monthOverallTotal[monthlykey]["discount"] != undefined) {
            vm.owesValues[monthlykey] =
              parseFloat(vm.owesValues[monthlykey]) -
              parseFloat(vm.monthOverallTotal[monthlykey]["discount"]);
            vm.owesValues[monthlykey] = commonService.roundnum(
              vm.owesValues[monthlykey],
              2
            );
          }

          vm.owesValues[monthlykey] = commonService.roundnum(
            vm.owesValues[monthlykey],
            2
          );
          vm.PaidValues[monthlykey] = commonService.roundnum(
            vm.PaidValues[monthlykey],
            2
          );
          //Monthly paid amount end

          angular.forEach(monthlyvalue, function (weeklyvalue, weeklykey) {
            //Week Overall Total start
            var weekkey = monthlykey + weeklykey;
            if (typeof vm.weekOverallTotal[weekkey] == "undefined")
              vm.weekOverallTotal[weekkey] = {};
            var myKeys = Object.keys(weeklyvalue);
            vm.weekOverallTotal[weekkey]["discount"] = 0;
            vm.weekOverallTotal[weekkey]["price"] = 0;
            angular.forEach(myKeys, function (wkey) {
              vm.weekOverallTotal[weekkey]["discount"] += parseFloat(
                vm.order.prices.nightlydiscount[wkey]
              );
              vm.weekOverallTotal[weekkey]["price"] += parseFloat(
                vm.order.prices.rates[wkey]
              );
            });

            vm.weekOverallTotal[weekkey]["discount"] = commonService.roundnum(
              vm.weekOverallTotal[weekkey]["discount"],
              2
            );
            vm.weekOverallTotal[weekkey]["price"] = commonService.roundnum(
              vm.weekOverallTotal[weekkey]["price"],
              2
            );
            vm.weekOverallTotal[weekkey]["discountedPrice"] =
              vm.weekOverallTotal[weekkey]["price"] -
              vm.weekOverallTotal[weekkey]["discount"];
            vm.weekly_paid_amount = 0;
            if (
              parseFloat(vm.weekOverallTotal[weekkey]["discountedPrice"]) <=
              parseFloat(vm.monthly_paid_amount)
            ) {
              vm.monthly_paid_amount =
                parseFloat(vm.monthly_paid_amount) -
                parseFloat(vm.weekOverallTotal[weekkey]["discountedPrice"]);
              vm.weekly_paid_amount = commonService.roundnum(
                vm.weekOverallTotal[weekkey]["discountedPrice"],
                2
              );
            } else if (
              parseFloat(vm.weekOverallTotal[weekkey]["discountedPrice"]) >
              parseFloat(vm.monthly_paid_amount)
            ) {
              var temp_paid_amount = angular.copy(vm.monthly_paid_amount);
              vm.monthly_paid_amount = 0;
              vm.weekly_paid_amount = commonService.roundnum(
                temp_paid_amount,
                2
              );
            }
            if (typeof vm.weekPaidValues[weekkey] == "undefined")
              vm.weekPaidValues[weekkey] = angular.copy(vm.weekly_paid_amount);

            if (typeof vm.weekOwesValues[weekkey] == "undefined") {
              vm.weekOwesValues[weekkey] =
                vm.weekOverallTotal[weekkey]["price"] -
                vm.weekPaidValues[weekkey];
              vm.weekOwesValues[weekkey] = commonService.roundnum(
                vm.weekOwesValues[weekkey],
                2
              );
            }

            if (vm.weekOverallTotal[weekkey]["discount"] != undefined) {
              vm.weekOwesValues[weekkey] =
                parseFloat(vm.weekOwesValues[weekkey]) -
                parseFloat(vm.weekOverallTotal[weekkey]["discount"]);
              vm.weekOwesValues[weekkey] = commonService.roundnum(
                vm.weekOwesValues[weekkey],
                2
              );
            }

            vm.weekPaidValues[weekkey] = commonService.roundnum(
              vm.weekPaidValues[weekkey],
              2
            );
            vm.weekOwesValues[weekkey] = commonService.roundnum(
              vm.weekOwesValues[weekkey],
              2
            );
          });
        });
        // Monthly/Weekly overall total and paid amount end
      } else if (
        Object.keys(orderData.prices.dates).length >= 7 &&
        Object.keys(orderData.prices.dates).length <= 31
      ) {
        vm.newArray = {};
        var monthLength = Object.keys(orderData.prices.dates).length;
        var first = Object.keys(orderData.prices.dates)[0];
        var last = Object.keys(orderData.prices.dates)[monthLength - 1];
        var wkey = 0;
        var rem = 0;
        for (var i = first; i <= last; i++) {
          if (typeof vm.newArray[wkey] == "undefined") vm.newArray[wkey] = {};

          vm.newArray[wkey][i] = orderData.prices.dates[i];
          if (
            Object.keys(vm.newArray[wkey]).length > 6 &&
            Object.keys(vm.newArray[wkey]).length < 31
          ) {
            first += 7;
            wkey++;
            continue;
          }
        }

        angular.forEach(vm.newArray, function (weekvalue, weekkey) {
          if (Object.keys(weekvalue).length == 1) {
            var attributes = Object.keys(vm.newArray[weekkey]);

            for (var i = 0; i < attributes.length; i++) {
              vm.newArray[weekkey - 1][attributes[i]] =
                vm.newArray[weekkey][attributes[i]];
            }
            delete vm.newArray[weekkey];
          }
        });

        vm.weekOverallTotal = {};
        vm.weekPaidValues = {};
        vm.weekOwesValues = {};
        vm.monthly_paid_amount = vm.order.overalltotals.paid_amount;
        vm.total_paid_amount = vm.order.overalltotals.paid_amount;
        angular.forEach(vm.newArray, function (weeksvalue, weekskey) {
          //weekly overall total and paid amount start
          if (typeof vm.weekOverallTotal[weekskey] == "undefined")
            vm.weekOverallTotal[weekskey] = {};
          var myKeys = Object.keys(weeksvalue);
          vm.weekOverallTotal[weekskey]["discount"] = 0;
          vm.weekOverallTotal[weekskey]["price"] = 0;
          angular.forEach(myKeys, function (key) {
            vm.weekOverallTotal[weekskey]["discount"] += parseFloat(
              vm.order.prices.nightlydiscount[key]
            );
            vm.weekOverallTotal[weekskey]["price"] += parseFloat(
              vm.order.prices.rates[key]
            );
          });

          vm.weekOverallTotal[weekskey]["discount"] = commonService.roundnum(
            vm.weekOverallTotal[weekskey]["discount"],
            2
          );
          vm.weekOverallTotal[weekskey]["price"] = commonService.roundnum(
            vm.weekOverallTotal[weekskey]["price"],
            2
          );
          vm.weekOverallTotal[weekskey]["discountedPrice"] =
            vm.weekOverallTotal[weekskey]["price"] -
            vm.weekOverallTotal[weekskey]["discount"];
          vm.weekly_paid_amount = 0;

          if (
            parseFloat(vm.weekOverallTotal[weekskey]["discountedPrice"]) <=
            parseFloat(vm.monthly_paid_amount)
          ) {
            vm.monthly_paid_amount =
              parseFloat(vm.monthly_paid_amount) -
              parseFloat(vm.weekOverallTotal[weekskey]["discountedPrice"]);
            vm.weekly_paid_amount = commonService.roundnum(
              vm.weekOverallTotal[weekskey]["discountedPrice"],
              2
            );
          } else if (
            parseFloat(vm.weekOverallTotal[weekskey]["discountedPrice"]) >
            parseFloat(vm.monthly_paid_amount)
          ) {
            var temp_paid_amount = angular.copy(vm.monthly_paid_amount);
            vm.monthly_paid_amount = 0;
            vm.weekly_paid_amount = commonService.roundnum(temp_paid_amount, 2);
          }
          if (typeof vm.weekPaidValues[weekskey] == "undefined")
            vm.weekPaidValues[weekskey] = angular.copy(vm.weekly_paid_amount);

          if (typeof vm.weekOwesValues[weekskey] == "undefined") {
            vm.weekOwesValues[weekskey] =
              vm.weekOverallTotal[weekskey]["price"] -
              vm.weekPaidValues[weekskey];
            vm.weekOwesValues[weekskey] = commonService.roundnum(
              vm.weekOwesValues[weekskey],
              2
            );
          }

          if (vm.weekOverallTotal[weekskey]["discount"] != undefined) {
            vm.weekOwesValues[weekskey] =
              commonService.roundnum(
                parseFloat(vm.weekOwesValues[weekskey]),
                2
              ) -
              commonService.roundnum(
                parseFloat(vm.weekOverallTotal[weekskey]["discount"]),
                2
              );
            vm.weekOwesValues[weekskey] = commonService.roundnum(
              vm.weekOwesValues[weekskey],
              2
            );
          }

          vm.weekPaidValues[weekskey] = commonService.roundnum(
            vm.weekPaidValues[weekskey],
            2
          );
          vm.weekOwesValues[weekskey] = commonService.roundnum(
            vm.weekOwesValues[weekskey],
            2
          );
          //weekly overall total and paid amount end
        });
      }
      return vm.newArray;
    }

    /*********** Monthly weekly night *******************/
    function monthlyWeeklyNightPos(orderData, postKeyIndexId) {
      if (orderData.product_is_timebound == 1) {
        if (
          orderData.hasOwnProperty("prices") &&
          orderData.prices.hasOwnProperty("dates") &&
          Object.keys(orderData.prices.dates).length > 31
        ) {
          var monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];

          /*******************************************/
          /*********** Get month wise dates **********/
          /*******************************************/
          vm.posdates = {};
          angular.forEach(orderData.prices.dates, function (value, key) {
            var monthArr = value.split("-");
            var date = new Date(value);
            var month = monthNames[date.getMonth()];
            var weekofmonth = date.getDay();
            var year = monthArr[2];
            var month_year = month + " " + year;

            if (typeof vm.posdates[month_year] == "undefined") {
              vm.posdates[month_year] = {};
            }

            vm.posdates[month_year][key] = value;
          });

          /*******************************************/
          /******** Get month/week wise dates ********/
          /*******************************************/
          vm.newArray = {};
          angular.forEach(vm.posdates, function (monthvalue, monthkey) {
            var monthLength = Object.keys(monthvalue).length;
            var first = Object.keys(monthvalue)[0];
            var last = Object.keys(monthvalue)[monthLength - 1];
            var wkey = 0;
            for (var i = parseInt(first); i <= parseInt(last); i++) {
              if (typeof vm.newArray[monthkey] == "undefined")
                vm.newArray[monthkey] = {};

              if (typeof vm.newArray[monthkey][wkey] == "undefined")
                vm.newArray[monthkey][wkey] = {};

              vm.newArray[monthkey][wkey][i] = monthvalue[i];

              if (
                Object.keys(vm.newArray[monthkey][wkey]).length > 6 &&
                Object.keys(vm.newArray[monthkey][wkey]).length < 31
              ) {
                first += 7;
                wkey++;
                continue;
              }
            }
          });

          /*******************************************/
          /******** Get month/week wise dates ********/
          /*******************************************/
          angular.forEach(vm.newArray, function (value, key) {
            var yearmonthLength = Object.keys(vm.newArray).length;
            var firstofmonth = Object.keys(vm.newArray)[1];
            var lastofmonth = Object.keys(vm.newArray)[yearmonthLength - 2];
            var weekmonthLength = Object.keys(vm.newArray[lastofmonth]).length;
            var firstofweek = Object.keys(vm.newArray[lastofmonth])[0];
            var lastofweek = Object.keys(vm.newArray[lastofmonth])[
              weekmonthLength - 1
            ];

            if (
              Object.keys(value).length == 1 &&
              Object.keys(vm.newArray[Object.keys(vm.newArray)[0]][0]).length ==
                1
            ) {
              var monthattributes = Object.keys(vm.newArray[key][0]);
              for (var i = 0; i < monthattributes.length; i++) {
                vm.newArray[firstofmonth][firstofweek][monthattributes[i]] =
                  vm.newArray[key][0][monthattributes[i]];
              }
              delete vm.newArray[key];
            } else if (
              Object.keys(value).length == 1 &&
              Object.keys(
                vm.newArray[Object.keys(vm.newArray)[yearmonthLength - 1]][0]
              ).length == 1
            ) {
              var monthattributes = Object.keys(vm.newArray[key][0]);
              for (var i = 0; i < monthattributes.length; i++) {
                vm.newArray[lastofmonth][lastofweek][monthattributes[i]] =
                  vm.newArray[key][0][monthattributes[i]];
              }
              delete vm.newArray[key];
            } else {
              angular.forEach(value, function (weekvalue, weekkey) {
                if (
                  Object.keys(weekvalue).length == 1 ||
                  (Object.keys(weekvalue).length == 1 &&
                    Object.keys(
                      vm.newArray[
                        Object.keys(vm.newArray)[yearmonthLength - 1]
                      ][weekkey]
                    ).length == 1)
                ) {
                  var attributes = Object.keys(vm.newArray[key][weekkey]);
                  // if(Object.keys(vm.newArray[key][weekkey]).length > 1){
                  for (var i = 0; i < attributes.length; i++) {
                    vm.newArray[key][weekkey - 1][attributes[i]] =
                      vm.newArray[key][weekkey][attributes[i]];
                  }
                  delete vm.newArray[key][weekkey];
                  // }
                }
              });
            }
          });

          /*******************************************/
          /******** initialize logical part **********/
          /*******************************************/
          vm.posweekOverallTotal = {};
          vm.posweekPaidValues = {};
          vm.posweekOwesValues = {};
          vm.posmonthOverallTotal = {};
          vm.posPaidValues = {};
          vm.posowesValues = {};
          // vm.pos_monthly_paid_amount  = vm.monthly_paid_amount;
          // vm.pos_total_paid_amount  = vm.monthly_paid_amount;
          vm.pos_monthly_paid_amount = orderData.single_paid_amount;
          vm.pos_total_paid_amount = orderData.single_paid_amount;

          var monthlyAmount = 0;

          angular.forEach(vm.newArray, function (monthlyvalue, monthlykey) {
            if (typeof vm.posmonthOverallTotal[monthlykey] == "undefined") {
              vm.posmonthOverallTotal[monthlykey] = {};
            }
            vm.posmonthOverallTotal[monthlykey]["discount"] = 0;
            vm.posmonthOverallTotal[monthlykey]["price"] = 0;
            vm.posmonthOverallTotal[monthlykey]["paid"] = 0;
            vm.posmonthOverallTotal[monthlykey]["owes"] = 0;
            angular.forEach(monthlyvalue, function (value, key) {
              angular.forEach(value, function (weekData, weekSkey) {
                vm.posmonthOverallTotal[monthlykey]["discount"] += parseFloat(
                  orderData.prices.nightlydiscount[weekSkey]
                );
                vm.posmonthOverallTotal[monthlykey]["price"] += parseFloat(
                  orderData.prices.rates[weekSkey]
                );
              });
            });

            vm.posmonthOverallTotal[monthlykey]["discount"] =
              commonService.roundnum(
                vm.posmonthOverallTotal[monthlykey]["discount"],
                2
              );
            vm.posmonthOverallTotal[monthlykey]["price"] =
              commonService.roundnum(
                vm.posmonthOverallTotal[monthlykey]["price"],
                2
              );

            vm.posmonthOverallTotal[monthlykey]["discountedPrice"] =
              vm.posmonthOverallTotal[monthlykey]["price"] -
              vm.posmonthOverallTotal[monthlykey]["discount"];
            if (
              parseFloat(
                vm.posmonthOverallTotal[monthlykey]["discountedPrice"]
              ) <= parseFloat(vm.pos_total_paid_amount)
            ) {
              vm.pos_total_paid_amount =
                parseFloat(vm.pos_total_paid_amount) -
                parseFloat(
                  vm.posmonthOverallTotal[monthlykey]["discountedPrice"]
                );
              monthlyAmount =
                vm.posmonthOverallTotal[monthlykey]["discountedPrice"];
            } else if (
              parseFloat(
                vm.posmonthOverallTotal[monthlykey]["discountedPrice"]
              ) > parseFloat(vm.pos_total_paid_amount)
            ) {
              var temp_paid_amount = angular.copy(vm.pos_total_paid_amount);
              vm.pos_total_paid_amount = 0;
              monthlyAmount = commonService.roundnum(temp_paid_amount, 2);
            }

            if (typeof vm.posPaidValues[monthlykey] == "undefined")
              vm.posPaidValues[monthlykey] = angular.copy(
                commonService.roundnum(monthlyAmount, 2)
              );

            if (typeof vm.posowesValues[monthlykey] == "undefined") {
              vm.posowesValues[monthlykey] =
                vm.posmonthOverallTotal[monthlykey]["price"] -
                vm.posPaidValues[monthlykey];
              vm.posowesValues[monthlykey] = commonService.roundnum(
                vm.posowesValues[monthlykey],
                2
              );
            }

            if (vm.posmonthOverallTotal[monthlykey]["discount"] != undefined) {
              vm.posowesValues[monthlykey] =
                parseFloat(vm.posowesValues[monthlykey]) -
                parseFloat(vm.posmonthOverallTotal[monthlykey]["discount"]);
              vm.posowesValues[monthlykey] = commonService.roundnum(
                vm.posowesValues[monthlykey],
                2
              );
            }

            vm.posowesValues[monthlykey] = commonService.roundnum(
              vm.posowesValues[monthlykey],
              2
            );
            vm.posPaidValues[monthlykey] = commonService.roundnum(
              vm.posPaidValues[monthlykey],
              2
            );
            vm.posmonthOverallTotal[monthlykey]["paid"] =
              vm.posPaidValues[monthlykey];
            vm.posmonthOverallTotal[monthlykey]["owes"] =
              vm.posowesValues[monthlykey];

            // Weekly record get
            angular.forEach(monthlyvalue, function (weeklyvalue, weeklykey) {
              var weekkey = monthlykey + weeklykey;
              if (typeof vm.posweekOverallTotal[weekkey] == "undefined") {
                vm.posweekOverallTotal[weekkey] = {};
              }
              var myKeys = Object.keys(weeklyvalue);
              vm.posweekOverallTotal[weekkey]["discount"] = 0;
              vm.posweekOverallTotal[weekkey]["price"] = 0;
              angular.forEach(myKeys, function (wkey) {
                vm.posweekOverallTotal[weekkey]["discount"] += parseFloat(
                  orderData.prices.nightlydiscount[wkey]
                );
                vm.posweekOverallTotal[weekkey]["price"] += parseFloat(
                  orderData.prices.rates[wkey]
                );
              });

              vm.posweekOverallTotal[weekkey]["discount"] =
                commonService.roundnum(
                  vm.posweekOverallTotal[weekkey]["discount"],
                  2
                );

              vm.posweekOverallTotal[weekkey]["price"] = commonService.roundnum(
                vm.posweekOverallTotal[weekkey]["price"],
                2
              );

              vm.posweekOverallTotal[weekkey]["discountedPrice"] =
                vm.posweekOverallTotal[weekkey]["price"] -
                vm.posweekOverallTotal[weekkey]["discount"];

              vm.pos_weekly_paid_amount = 0;

              if (
                parseFloat(
                  vm.posweekOverallTotal[weekkey]["discountedPrice"]
                ) <= parseFloat(vm.pos_monthly_paid_amount)
              ) {
                vm.pos_monthly_paid_amount =
                  parseFloat(vm.pos_monthly_paid_amount) -
                  parseFloat(
                    vm.posweekOverallTotal[weekkey]["discountedPrice"]
                  );
                vm.pos_weekly_paid_amount =
                  vm.posweekOverallTotal[weekkey]["discountedPrice"];
              } else if (
                parseFloat(vm.posweekOverallTotal[weekkey]["discountedPrice"]) >
                parseFloat(vm.pos_monthly_paid_amount)
              ) {
                var temp_paid_amount = angular.copy(vm.pos_monthly_paid_amount);
                vm.pos_monthly_paid_amount = 0;
                vm.pos_weekly_paid_amount = commonService.roundnum(
                  temp_paid_amount,
                  2
                );
              }
              if (typeof vm.posweekPaidValues[weekkey] == "undefined")
                vm.posweekPaidValues[weekkey] = angular.copy(
                  vm.pos_weekly_paid_amount
                );

              if (typeof vm.posweekOwesValues[weekkey] == "undefined") {
                vm.posweekOwesValues[weekkey] =
                  vm.posweekOverallTotal[weekkey]["price"] -
                  vm.posweekPaidValues[weekkey];
                vm.posweekOwesValues[weekkey] = commonService.roundnum(
                  vm.posweekOwesValues[weekkey],
                  2
                );
              }

              if (vm.posweekOverallTotal[weekkey]["discount"] != undefined) {
                vm.posweekOwesValues[weekkey] =
                  parseFloat(vm.posweekOwesValues[weekkey]) -
                  parseFloat(vm.posweekOverallTotal[weekkey]["discount"]);
                vm.posweekOwesValues[weekkey] = commonService.roundnum(
                  vm.posweekOwesValues[weekkey],
                  2
                );
              }

              vm.posweekPaidValues[weekkey] = commonService.roundnum(
                vm.posweekPaidValues[weekkey],
                2
              );
              vm.posweekOwesValues[weekkey] = commonService.roundnum(
                vm.posweekOwesValues[weekkey],
                2
              );
            });
          });
          vm.posweekOverallTotalArray[postKeyIndexId] = vm.posweekOverallTotal;
          vm.posweekPaidValuesArray[postKeyIndexId] = vm.posweekPaidValues;
          vm.posweekOwesValuesArray[postKeyIndexId] = vm.posweekOwesValues;
          vm.posmonthOverallTotalArray[postKeyIndexId] =
            vm.posmonthOverallTotal;
        } else if (
          Object.keys(orderData.prices.dates).length >= 7 &&
          Object.keys(orderData.prices.dates).length <= 31
        ) {
          vm.newArray = {};
          var monthLength = Object.keys(orderData.prices.dates).length;
          var first = Object.keys(orderData.prices.dates)[0];
          var last = Object.keys(orderData.prices.dates)[monthLength - 1];
          var wkey = 0;
          var rem = 0;
          for (var i = first; i <= last; i++) {
            if (typeof vm.newArray[wkey] == "undefined") vm.newArray[wkey] = {};

            vm.newArray[wkey][i] = orderData.prices.dates[i];
            if (
              Object.keys(vm.newArray[wkey]).length > 6 &&
              Object.keys(vm.newArray[wkey]).length < 31
            ) {
              first += 7;
              wkey++;
              continue;
            }
          }

          angular.forEach(vm.newArray, function (weekvalue, weekkey) {
            if (Object.keys(weekvalue).length == 1) {
              var attributes = Object.keys(vm.newArray[weekkey]);

              for (var i = 0; i < attributes.length; i++) {
                vm.newArray[weekkey - 1][attributes[i]] =
                  vm.newArray[weekkey][attributes[i]];
              }
              delete vm.newArray[weekkey];
            }
          });

          vm.posweekOverallTotal = {};
          vm.posweekPaidValues = {};
          vm.posweekOwesValues = {};
          vm.pos_monthly_paid_amount = vm.monthly_paid_amount;
          vm.pos_total_paid_amount = vm.monthly_paid_amount;
          var monthlyAmount = 0;

          angular.forEach(vm.newArray, function (weeksvalue, weekskey) {
            //weekly overall total and paid amount start
            if (typeof vm.posweekOverallTotal[weekskey] == "undefined") {
              vm.posweekOverallTotal[weekskey] = {};
            }
            var myKeys = Object.keys(weeksvalue);
            vm.posweekOverallTotal[weekskey]["discount"] = 0;
            vm.posweekOverallTotal[weekskey]["price"] = 0;
            angular.forEach(myKeys, function (key) {
              vm.posweekOverallTotal[weekskey]["discount"] += parseFloat(
                orderData.prices.nightlydiscount[key]
              );
              vm.posweekOverallTotal[weekskey]["price"] += parseFloat(
                orderData.prices.rates[key]
              );
            });

            vm.posweekOverallTotal[weekskey]["discount"] =
              commonService.roundnum(
                vm.posweekOverallTotal[weekskey]["discount"],
                2
              );
            vm.posweekOverallTotal[weekskey]["price"] = commonService.roundnum(
              vm.posweekOverallTotal[weekskey]["price"],
              2
            );
            vm.posweekOverallTotal[weekskey]["discountedPrice"] =
              vm.posweekOverallTotal[weekskey]["price"] -
              vm.posweekOverallTotal[weekskey]["discount"];

            vm.weekly_paid_amount = 0;

            if (
              parseFloat(vm.posweekOverallTotal[weekskey]["discountedPrice"]) <=
              parseFloat(vm.pos_monthly_paid_amount)
            ) {
              vm.pos_monthly_paid_amount =
                parseFloat(vm.pos_monthly_paid_amount) -
                parseFloat(vm.posweekOverallTotal[weekskey]["discountedPrice"]);
              vm.weekly_paid_amount =
                vm.posweekOverallTotal[weekskey]["discountedPrice"];
            } else if (
              parseFloat(vm.posweekOverallTotal[weekskey]["discountedPrice"]) >
              parseFloat(vm.pos_monthly_paid_amount)
            ) {
              var temp_paid_amount = angular.copy(vm.pos_monthly_paid_amount);
              vm.pos_monthly_paid_amount = 0;
              vm.weekly_paid_amount = commonService.roundnum(
                temp_paid_amount,
                2
              );
            }
            if (typeof vm.posweekPaidValues[weekskey] == "undefined")
              vm.posweekPaidValues[weekskey] = angular.copy(
                vm.weekly_paid_amount
              );

            if (typeof vm.posweekOwesValues[weekskey] == "undefined") {
              vm.posweekOwesValues[weekskey] =
                vm.posweekOverallTotal[weekskey]["price"] -
                vm.posweekPaidValues[weekskey];
              vm.posweekOwesValues[weekskey] = commonService.roundnum(
                vm.posweekOwesValues[weekskey],
                2
              );
            }

            if (vm.posweekOverallTotal[weekskey]["discount"] != undefined) {
              vm.posweekOwesValues[weekskey] =
                parseFloat(vm.posweekOwesValues[weekskey]) -
                parseFloat(vm.posweekOverallTotal[weekskey]["discount"]);
              vm.posweekOwesValues[weekskey] = commonService.roundnum(
                vm.posweekOwesValues[weekskey],
                2
              );
            }

            vm.posweekPaidValues[weekskey] = commonService.roundnum(
              vm.posweekPaidValues[weekskey],
              2
            );
            vm.posweekOwesValues[weekskey] = commonService.roundnum(
              vm.posweekOwesValues[weekskey],
              2
            );
            //weekly overall total and paid amount end
          });
          vm.posweekOverallTotalArray[postKeyIndexId] = vm.posweekOverallTotal;
          vm.posweekPaidValuesArray[postKeyIndexId] = vm.posweekPaidValues;
          vm.posweekOwesValuesArray[postKeyIndexId] = vm.posweekOwesValues;
        }
        vm.monthly_paid_amount = vm.pos_monthly_paid_amount;
        // vm.total_paid_amount = vm.pos_total_paid_amount;
        return vm.newArray;
      } else {
        vm.newArray = [];
        return vm.newArray;
      }
    }
    /*********** Monthly weekly night *******************/

    vm.getWeekHeaderName = function (items, weekName) {
      var l = Object.keys(items).length;
      var first = items[Object.keys(items)[0]];
      var last = items[Object.keys(items)[l - 1]];
      var html =
        "<span>" + first + "<span class='to' >  To  </span>" + last + "</span>";
      return html;
    };

    /*Print Registration Card*/
    vm.printRegistrationCard = function () {
      if (vm.order.customerTravelSame) {
        vm.isloading = true;
        createResService
          .printRegistrationCard({
            confirmation_number: vm.order.confirmation_number,
            traveller_id: vm.order.travellerId,
            customer_id: vm.order.customerId,
            reservation_id: vm.order.reserv_id,
          })
          .then(function (response) {
            vm.print_invoice_data = "";
            vm.print_invoice_data = response["data"];
            vm.isloading = false;
            var myWindow = window.open("", "", "", "");
            myWindow.document.write(response["data"]);
            myWindow.document.close();
            myWindow.focus();
          });
      } else {
        vm.showPrintInvoiceCustTravlSelection("", [], "registrationcard");
      }
    };
    /*Function to print the parking pass*/
    vm.printParkingPass = printParkingPass;
    function printParkingPass(posValue) {
      vm.isloading = true;
      var data = {
        conf: posValue["confirmation_number"],
        from: posValue["room_stay_from"],
        to: posValue["room_stay_to"],
      };
      createResService.printParkingPass(data).then(function (response) {
        vm.isloading = false;
        var myWindow = window.open("", "", "", "");
        myWindow.document.write(response["data"]);
        myWindow.document.close();
        myWindow.focus();
        $timeout(function () {
          myWindow.print();
          myWindow.close();
        }, 500);
      });
    }
    vm.getOTADetails = getOTADetails;
    function getOTADetails() {
      $mdDialog
        .show({
          controller: "otaController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/e-commerce/views/orders/dialogs/OTA/ota.html",
          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: true,
          locals: {
            orderDetails: vm.order,
          },
        })
        .then(
          function (answer) {
            vm.order.collect_which = answer.collect_which;
            vm.order.siteminder_id = answer.siteminder_id;
            vm.order.source_of_creation = answer.source_of_creation;
          },
          function (dialogText) {}
        );
    }
    function sumOfVals(a, b) {
      return parseFloat(a) + parseFloat(b);
    }
    vm.checValue = checValue;
    function checValue(amountEntered, type, poskey, event, column_name) {
      vm.processRequest = true;
      var tempNumber = parseFloat(amountEntered);
      if (
        /[a-zA-Z]/.test(amountEntered) ||
        tempNumber < 0 ||
        isNaN(tempNumber) ||
        commonService.roundnum(vm.order.pos[poskey][column_name], 2) ==
          commonService.roundnum(originalOrderData.pos[poskey][column_name], 2)
      ) {
        vm.order.pos[poskey][column_name] =
          originalOrderData.pos[poskey][column_name];
        vm.processRequest = false;
        return;
      } else {
        console.log("request processed");
      }
    }
    function setAllStatuses() {
      if (
        vm.order.hasOwnProperty("pos") &&
        parseInt(Object.keys(vm.order.pos).length) > 0
      ) {
        vm.statusesPos = {};
        vm.statusesResort = {};
        var itemsInPos = vm.order.pos.length;
        var anyPosActive = false;
        angular.forEach(vm.order.pos, function (value, key) {
          vm.statusesPos[key] = { Active: "Active", Canceled: "Cancel" };
          vm.statusesResort[key] = { Applied: "Apply", Removed: "Cancel" };
          if (value.room_stay_status == "Active") anyPosActive = true;
          vm.statusesPos[key][value.room_stay_status] = value.room_stay_status;
          if (
            value.extra_attribute != undefined &&
            value.extra_attribute == "resort_fee"
          ) {
            // vm.pos_status[key] = (parseFloat(value.nightlySum) > 0 && value.room_stay_status == "Active") ? 'Active' : 'Canceled';
            vm.pos_status[key] =
              parseFloat(value.nightlySum) > 0 ? "Applied" : "Removed";
            vm.statusesResort[key][vm.pos_status[key]] = vm.pos_status[key];
          } else {
            vm.pos_status[key] = value.room_stay_status;
          }
          if (itemsInPos == parseInt(key) + 1) vm.isloading = false;
        });
        if (vm.roomCount == 0 && !anyPosActive) {
          vm.allRoomCancelled = true;
        } else if (vm.roomCount == 0 && anyPosActive) {
          vm.allRoomCancelled = false;
        }
      }
    }

    /*****************************************/
    /***** Geolocation autocomplete form *****/
    /*****************************************/

    var fullAddress = "";
    var result = "";

    initAutocomplete();
    function initAutocomplete() {
      setTimeout(function () {
        var autocomplete = new google.maps.places.Autocomplete(
          document.getElementById("autocomplete"),
          { types: ["geocode"] }
        );
        autocomplete.addListener("place_changed", function () {
          result = autocomplete.getPlace();
          getGeoData(result, 0, "address");
        });
      }, 50);
    }

    /*****************************************/
    /***** Geolocation autocomplete form *****/
    /*****************************************/
    initAutocompleteZip();
    function initAutocompleteZip() {
      setTimeout(function () {
        var autocompletezip = new google.maps.places.Autocomplete(
          document.getElementById("autocompletezip"),
          { types: ["(regions)"] }
        );
        autocompletezip.addListener("place_changed", function () {
          result = autocompletezip.getPlace();
          getGeoData(result, 0, "zip");
        });
      }, 50);
    }

    initAutocompleteTraveller();
    function initAutocompleteTraveller() {
      setTimeout(function () {
        var autocompleteTraveller = new google.maps.places.Autocomplete(
          document.getElementById("autocompleteTraveller"),
          { types: ["geocode"] }
        );
        autocompleteTraveller.addListener("place_changed", function () {
          result = autocompleteTraveller.getPlace();
          getGeoData(result, 1, "address");
        });
      }, 50);
    }

    /*****************************************/
    /***** Geolocation autocomplete form *****/
    /*****************************************/
    initAutocompleteZipTraveller();
    function initAutocompleteZipTraveller() {
      setTimeout(function () {
        var autocompletezipTraveller = new google.maps.places.Autocomplete(
          document.getElementById("autocompletezipTraveller"),
          { types: ["(regions)"] }
        );
        autocompletezipTraveller.addListener("place_changed", function () {
          result = autocompletezipTraveller.getPlace();
          getGeoData(result, 1, "zip");
        });
      }, 50);
    }

    /*****************************************/
    /***** Customer Profile autocomplete *****/
    /*****************************************/

    var customerProfileAutocomplete = null;

    function initAutocompleteCustomerProfile() {

        $timeout(function () {

            var addressInput = document.getElementById(
                "autocompleteCustomerProfile"
            );

            if (!addressInput) {
                return;
            }

            // IMPORTANT:
            // Do not initialize Google Autocomplete more than once
            if (customerProfileAutocomplete) {
                return;
            }

            customerProfileAutocomplete =
                new google.maps.places.Autocomplete(
                    addressInput,
                    {
                        types: ["geocode"]
                    }
                );

            customerProfileAutocomplete.addListener(
                "place_changed",
                function () {

                    var place =
                        customerProfileAutocomplete.getPlace();

                    if (!place || !place.address_components) {
                        return;
                    }

                    var address = "";
                    var city = "";
                    var state = "";
                    var zipCode = "";
                    var country = "";

                    angular.forEach(
                        place.address_components,
                        function (component) {

                            if (
                                component.types.indexOf(
                                    "street_number"
                                ) !== -1
                            ) {
                                address = component.long_name;
                            }

                            if (
                                component.types.indexOf("route") !== -1
                            ) {
                                address = address
                                    ? address + " " + component.long_name
                                    : component.long_name;
                            }

                            if (
                                component.types.indexOf("locality") !== -1
                            ) {
                                city = component.long_name;
                            }

                            if (
                                component.types.indexOf(
                                    "administrative_area_level_1"
                                ) !== -1
                            ) {
                                state = component.long_name;
                            }

                            if (
                                component.types.indexOf(
                                    "postal_code"
                                ) !== -1
                            ) {
                                zipCode = component.long_name;
                            }

                            if (
                                component.types.indexOf("country") !== -1
                            ) {
                                country = component.long_name;
                            }
                        }
                    );

                    $scope.$applyAsync(function () {

                        vm.editableCustomerProfile.address =
                            address ||
                            place.formatted_address ||
                            "";

                        vm.editableCustomerProfile.city = city;
                        vm.editableCustomerProfile.state = state;
                        vm.editableCustomerProfile.zip_code = zipCode;
                        vm.editableCustomerProfile.country = country;

                    });
                }
            );

        }, 100);
    }


    /*****************************************/
    /***** Customer Profile ZIP autocomplete */
    /*****************************************/

    var customerProfileZipAutocomplete = null;

    function initAutocompleteZipCustomerProfile() {

        $timeout(function () {

            var zipInput = document.getElementById(
                "autocompletezipCustomerProfile"
            );

            if (!zipInput) {
                return;
            }

            // Prevent multiple Google Autocomplete instances
            if (customerProfileZipAutocomplete) {
                return;
            }

            customerProfileZipAutocomplete =
                new google.maps.places.Autocomplete(
                    zipInput,
                    {
                        types: ["(regions)"]
                    }
                );

            customerProfileZipAutocomplete.addListener(
                "place_changed",
                function () {

                    var place =
                        customerProfileZipAutocomplete.getPlace();

                    if (!place || !place.address_components) {
                        return;
                    }

                    var city = "";
                    var state = "";
                    var zipCode = "";
                    var country = "";

                    angular.forEach(
                        place.address_components,
                        function (component) {

                            if (
                                component.types.indexOf("locality") !== -1
                            ) {
                                city = component.long_name;
                            }

                            if (
                                component.types.indexOf(
                                    "administrative_area_level_1"
                                ) !== -1
                            ) {
                                state = component.long_name;
                            }

                            if (
                                component.types.indexOf("postal_code") !== -1
                            ) {
                                zipCode = component.long_name;
                            }

                            if (
                                component.types.indexOf("country") !== -1
                            ) {
                                country = component.long_name;
                            }
                        }
                    );

                    $scope.$applyAsync(function () {

                        vm.editableCustomerProfile.city = city;
                        vm.editableCustomerProfile.state = state;
                        vm.editableCustomerProfile.zip_code = zipCode;
                        vm.editableCustomerProfile.country = country;

                    });
                }
            );

        }, 100);
    }

    // vm.resortFeeAppliedVisible = vm.cartdetails['resortFeeAppliedVisible'];

    vm.updateResortFee = updateResortFee;

    function updateResortFee(index) {
      /*false If applied and vice-versa*/
      vm.order["resortFeeApplied"] = vm.resortFeeApplied[index];
      vm.order = commonService.calculateTotals(vm.order, false, []);
      vm.modificationComment = vm.resortFeeApplied[index]
        ? "Resort fee added in order with confirmation number " +
          vm.order.confirmation_number
        : "Resort fee removed from order with confirmation number " +
          vm.order.confirmation_number;

      vm.modificationComments.push(vm.order.room_stay_id);
      if (!vm.resortFeeApplied[index]) {
        angular.forEach(vm.order["taxes"], function (element, index) {
          if (element["applied_on_field"] != "") {
            vm.order["taxes"][index]["tax_amt"] = "0.00";
            vm.order["taxes"][index]["tax_value"] = "0.00";
          }
        });
      }
      $timeout(function () {
        calculateOrderTotals();
      }, 0);
    }

    /*
     ** On toggle of resort fee apply switch
     */
    vm.updateResortFeeNew = function (index, type, answer) {
      /*false If applied and vice-versa*/
      if (type != undefined && type == "status") {
        vm.order["resortFeeApplied"] =
          answer != undefined && answer.toLowerCase() == "removed"
            ? false
            : true;
        vm.order.resortFeeCanceled =
          answer != undefined && answer.toLowerCase() == "removed"
            ? true
            : false;
      } else {
        vm.order["resortFeeApplied"] = vm.resortFeeApplied[index];
      }
      var promise = commonService.recalculateResortFeePos(vm.order);
      promise.then(
        function (response) {
          vm.order = response;

          vm.changedColumn = "resort_fee";
          // vm.order = commonService.calculateTotals(vm.order,false,[]);
          vm.modificationComment = !vm.resortFeeApplied[index]
            ? "Resort fee added in order with confirmation number " +
              vm.order.confirmation_number
            : "Resort fee removed from order with confirmation number " +
              vm.order.confirmation_number;
          if (
            vm.order.resortFeePos != undefined &&
            vm.order.resortFeePos.room_stay_id != undefined
          ) {
            vm.modificationComments.push(vm.order.resortFeePos.room_stay_id);
            vm.modificationComments.push(vm.order.room_stay_id);
          }

          calculateOrderTotals();
        },
        function (errorPayload) {
          console.error("failure : ", errorPayload);
        }
      );
    };

    var addressData = {};
    function getGeoData(result, value, origin) {
      var country = "";
      var state = "";
      var city = "";
      var postal_code = "";
      var street = "";
      var street_number = "";
      var sublocality = "";
      var sublocality2 = "";
      var neighborhood = "";
      if (
        result &&
        result.address_components &&
        result.address_components.length != 0
      ) {
        for (var i = 0; i < result.address_components.length; i += 1) {
          var addressObj = result.address_components[i];
          for (var j = 0; j < addressObj.types.length; j += 1) {
            switch (addressObj.types[j]) {
              case "country":
                country = addressObj.long_name;
                break; //Country
              case "administrative_area_level_1":
                state = addressObj.long_name;
                break; //State
              case "administrative_area_level_2":
                country = addressObj.long_name;
                break; //County
              case "locality":
                city = addressObj.long_name;
                break; //City
              case "route":
                street = addressObj.long_name;
                break; //street
              case "neighborhood":
                neighborhood = addressObj.long_name;
                break; //street
              case "sublocality_level_2":
                sublocality2 = addressObj.long_name;
                break; //street
              case "sublocality_level_1":
                sublocality = addressObj.long_name;
                break; //street
              case "sublocality":
                sublocality = addressObj.long_name;
                break; //street
              case "street_number":
                street_number = addressObj.long_name;
                break; //street number
              case "postal_code":
                postal_code = addressObj.long_name;
                break; //Postal Code
            }
          }
        }
        addressData.zip_code = postal_code;
        addressData.address =
          street_number + " " + sublocality + " " + sublocality2 + " " + street;
        addressData.city = city;
        addressData.state = state;
        addressData.country = country;
      }
      if (!postal_code) {
        var data = {
          address: result.name,
        };
        userService.getZipCode(data).then(function (res) {
          addressData.country = res.country;
          addressData.state = res.administrative_area_level_1;
          addressData.city = res.locality;
          street_number = res.street_number ? res.street_number : "";
          street = res.route ? res.route : "";
          addressData.address = street_number + " " + street;
          addressData.zip_code = res.postal_code;
        });
      } else {
        addressData.zip_code = postal_code ? postal_code : "";
      }
      customFlag = false;
      $timeout(function () {
        if (value) {
          vm.order.country = addressData.country;
          vm.order.state = addressData.state;
          vm.order.city = addressData.city;
          // vm.order.address = addressData.address ? addressData.address.trim() : '';
          if (addressData.address) {
            vm.order.address =
              vm.order.address != "" && origin == "zip"
                ? vm.order.address
                : addressData.address.trim();
          } else {
            vm.order.address =
              vm.order.address != "" && origin == "zip" ? vm.order.address : "";
          }
          vm.order.zip_code = addressData.zip_code ? addressData.zip_code : "";
          vm.selectedCountryForTraveller = addressData.country;
          vm.searchTxtCountryForTraveller = addressData.country;
          vm.searchTxtStateForTraveller = addressData.state;
          $timeout(function () {
            angular.element("#autocompleteTraveller").val(vm.order.address);
            angular.element("#autocompletezipTraveller").val(vm.order.zip_code);
          }, 500);
          autoFillData.address = vm.order.address;
          autoFillData.city = vm.order.city;
          autoFillData.state = vm.order.state;
          autoFillData.country = vm.order.country;
          autoFillData.zip_code = vm.order.zip_code;
          autoFillData.confirmation_number = vm.order.confirmation_number;
        } else {
          vm.reservation_customer.country = addressData.country;
          vm.reservation_customer.state = addressData.state;
          vm.reservation_customer.city = addressData.city;
          // vm.reservation_customer.address = addressData.address ? addressData.address.trim() : '';
          if (addressData.address) {
            vm.reservation_customer.address =
              vm.reservation_customer.address != "" && origin == "zip"
                ? vm.reservation_customer.address
                : addressData.address.trim();
          } else {
            vm.reservation_customer.address =
              vm.reservation_customer.address != "" && origin == "zip"
                ? vm.reservation_customer.address
                : "";
          }
          vm.reservation_customer.zip_code = addressData.zip_code
            ? addressData.zip_code
            : "";
          vm.selectedCountry = addressData.country;
          vm.searchTxtCountry = addressData.country;
          vm.searchTxtState = addressData.state;
          $timeout(function () {
            angular
              .element("#autocompletezip")
              .val(vm.reservation_customer.zip_code);
            angular
              .element("#autocomplete")
              .val(vm.reservation_customer.address);
          }, 500);
          autoFillData.address = vm.reservation_customer.address;
          autoFillData.city = vm.reservation_customer.city;
          autoFillData.state = vm.reservation_customer.state;
          autoFillData.country = vm.reservation_customer.country;
          autoFillData.zip_code = vm.reservation_customer.zip_code;
          autoFillData.confirmation_number = "";
        }
        autoFillData.reservation_id = vm.reservation_id;
        autoFillData.room_confirmation_number = vm.order.confirmation_number;
        autoFillData.customerTravelSame = vm.travelCustSame;

        eCommerceService
          .updateReservationData(autoFillData)
          .then(function (response) {
            if (response.status === "error") {
              toastMessage.showSimpleToast("Something wrong", "error-toast");
            } else {
              if (autoFillData.confirmation_number == "" && vm.travelCustSame) {
                vm.order.address = vm.reservation_customer.address;
                vm.order.city = vm.reservation_customer.city;
                vm.order.state = vm.reservation_customer.state;
                vm.order.country = vm.reservation_customer.country;
                vm.order.zip_code = vm.reservation_customer.zip_code;
              }
            }
            customFlag = true;
          });
      }, 1000);
    }

    function toggle(key, type, flag, posIndex) {
      var id = "";
      if (type == "month") {
        if (flag === "boat") {
          id = "months" + key;
        } else {
          id = "posmonths" + key + posIndex;
        }
        angular
          .element(document.getElementsByClassName(id))
          .siblings()
          .slideToggle();
        angular
          .element(document.getElementsByClassName(id))
          .addClass("accordian-title-minus");
        // angular.element(document.getElementsByClassName('months'+key)).parent().siblings().each(function(index,element){
        //     angular.element(element).find(".dropdown-container:visible").slideToggle(500);
        //     // angular.element(element).find('.months'+key).removeClass("accordian-title-minus");
        // });
      } else {
        if (flag === "boat") {
          id = "weeks" + key + posIndex;
        } else {
          id = "posweeks" + key + posIndex;
        }
        angular
          .element(document.getElementsByClassName(id))
          .siblings()
          .slideToggle(1000);
        angular
          .element(document.getElementsByClassName(id))
          .addClass("accordian-title-minus");
        angular
          .element(document.getElementsByClassName(id))
          .toggleClass("open");
        // angular.element(document.getElementsByClassName('weeks'+key)).parent().siblings().each(function(index,element){
        //     angular.element(element).find(".dropdown-container1:visible").slideToggle(500);
        //     angular.element(element).removeClass("open");
        // });
      }
    }

    /*
     **  Save the refund reason after refund is completed
     */
    vm.saveRefundReason = function (installmentId, reason, giftcardParams) {
      if (installmentId != undefined && reason != undefined) {
        var postData = {
          installmentId: installmentId,
          reason: reason,
        };

        eCommerceService.saveRefundReason(postData).then(function (response) {
          if (response.status != undefined && response.status == "success") {
            $mdDialog.hide();
            Object.keys(vm.installments).forEach(function (key) {
              if (
                key != "remaining" &&
                vm.installments[key].installment_id == installmentId
              ) {
                vm.installments[key].reason = reason;
              }
            });
            if (giftcardParams.refund_using != "giftcard") {
              vm.refundEmailPopup(giftcardParams);
            }
          }
        });
      }
    };

    /*
     **  Show send refund email confirmation popup
     */
    vm.refundEmailPopup = function (giftcardParams) {
      $mdDialog.show({
        clickOutsideToClose: false,
        parent: angular.element($document.body),
        scope: $scope,
        preserveScope: true,
        locals: {
          localData: {
            payment_info_email: vm.payment_info_email,
            refunded_amount: giftcardParams.amount,
          },
        },
        templateUrl:
          "app/main/apps/e-commerce/views/orders/dialogs/payments/refundEmail.html",
        controller: RefundEmailController,
      });
      function RefundEmailController($scope, $mdDialog, localData) {
        $scope.payment_info_email = localData.payment_info_email;
        $scope.refund_amount = localData.refunded_amount;
        $scope.closeDialog = function () {
          $mdDialog.hide();
        };
      }
    };

    // vm.allowedFiles = ["png", "jpg", "jpeg","heic", "doc", "docx", "pdf", "xls", "xlsx", "txt", "bmp", "rtf", "ott", "odt", "ods","svg"];

    vm.allowedFiles =
      "image/*,.doc,.docx,.pdf,.xls,.xlsx,.txt,.bmp,.rtf,.ott,.odt,.ods,.svg";

    /*
     ** Uses to upload the documents
     */
    vm.uploadDoc = function (files, errFiles) {
      vm.progressnum = 0;
      var hotelId = 0;
      if (
        $localStorage["preHotelId"] != undefined &&
        $localStorage["preHotelId"] != ""
      ) {
        hotelId = $localStorage["preHotelId"];
      }

      if (errFiles.length > 0) {
        angular.forEach(errFiles, function (value, index) {
          switch (value.$error) {
            case "pattern":
              vm.fileError = "FILE TYPE NOT SUPPORTED";
              break;
            case "maxSize":
              vm.fileError = "FILE SIZE EXCEEDS";
              break;
            case "minWidth":
              vm.fileError = "MIN SIZE MESSAGE";
              break;
            case "minHeight":
              vm.fileError = "MIN SIZE MESSAGE";
              break;
            default:
              vm.fileError = "COMMON IMAGE MESSAGE";
          }
          toastMessage.showSimpleToast(vm.fileError, "error-toast");
        });
      }
      if (files.length > 0) {
        if (vm.innerSlectedIndex != 3) {
          vm.innerSlectedIndex = 3;
          vm.fetchDocs(vm.order.confirmation_number);
        }
        vm.uploading = true;
        files.upload = Upload.upload({
          url: EnvironmentConfig.api + "reservations/upload_document",
          data: {
            file: files[0],
            data: {
              confirmation_number: vm.order.confirmation_number,
              hotel_id: hotelId,
              type: "update",
            },
          },
          uploadEventHandlers: {
            progress: function (evt) {
              if (evt.lengthComputable) {
                vm.progressnum = Math.round((evt.loaded * 100) / evt.total);
              } else {
                vm.progressnum = "unable to compute";
              }

              if (vm.progressnum >= 100) {
                // vm.progress = false;
                // $timeout(function() {
                //     vm.processing = true;
                // },100);
              }
            },
          },
        });

        files.upload.then(function (response) {
          if (response.data.status == "success") {
            vm.progress = false;
            var docData = {
              doc_name: response.data.data.fileName,
              id: response.data.data.last_id,
              type: response.data.data.type,
              created_on: response.data.data.created_on,
              thumbnail: response.data.data.thumbnail,
            };
            vm.documents.push(docData);
            vm.emptyDocs = vm.documents.length > 0 ? false : true;
          } else if (
            response.data.status == "error" &&
            response.data.error != undefined &&
            response.data.error != ""
          ) {
            toastMessage.showSimpleToast(response.data.error, "error-toast");
          }
          vm.uploading = false;
          // $mdToast.hide();
        });
      }
    };

    /*
     ** Fetch the attached documents
     */
    vm.fetchDocs = function (confirmationNumber) {
      vm.showCustomerTravellerBillInfo = false;
      vm.isloading = true;
      var hotelId = 0;
      if (
        $localStorage["preHotelId"] != undefined &&
        $localStorage["preHotelId"] != ""
      ) {
        hotelId = $localStorage["preHotelId"];
      }
      var postData = {
        confirmationNumber: confirmationNumber,
        hotelId: hotelId,
      };

      eCommerceService.fetchAttachmentDocs(postData).then(function (response) {
        if (
          response.status == "success" &&
          Object.keys(response.documents).length > 0
        ) {
          vm.documents = response.documents;
          vm.emptyDocs = false;
        } else {
          vm.emptyDocs = true;
        }
        vm.isloading = false;
      });
    };

    /*
     ** Delete attachment documents
     */
    vm.deleteDocument = function (docData, index, evt) {
      var confirm = $mdDialog
        .confirm()
        .htmlContent(
          '<div class="md-padding custom-common-dailog">Are you sure, you want to delete this attachment?</div>'
        )
        .title("Delete Attachment")
        .targetEvent(evt)
        .ok("Yes")
        .cancel("No");

      $mdDialog
        .show(confirm)
        .then(function () {
          vm.isloading = true;
          docData.src = "update";
          eCommerceService.deleteDoc(docData).then(function (response) {
            if (response.status === "success") {
              vm.documents.splice(index, 1);
              vm.emptyDocs = vm.documents.length > 0 ? false : true;
            } else {
              toastMessage.showSimpleToast(
                $translate.instant(response.message),
                "error-toast"
              );
            }
            vm.isloading = false;
          });
        })
        .catch(function (err) {});
    };

    /*
     ** Open attachments images and pdfs in popup
     */
    vm.documentViewer = function (ev, docName, type) {
      var documentData;
      if (type != undefined && type == "image") {
        documentData =
          EnvironmentConfig.api + "assets/uploads/documents/" + docName;
      } else {
        if (docName.indexOf(".pdf") > -1) {
          documentData = {
            path: EnvironmentConfig.api + "assets/uploads/documents/" + docName,
            type: "pdf",
          };
        } else {
          documentData =
            EnvironmentConfig.api + "assets/uploads/documents/" + docName;
          window.open(documentData, "_self");
          return false;
        }
      }
      $mdDialog.show({
        controller: "RoomtypeDialogController",
        controllerAs: "vm",
        templateUrl:
          "app/main/apps/e-commerce/views/roomtype/dialogs/roomtype/roomtype-dialog.html",
        parent: angular.element($document.find("#content-container")),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          Image: documentData,
        },
      });
    };

    /*vm.lastTarget = null;

		window.addEventListener("dragenter", function(e)
		{
			if(vm.isFile(e)) {
				vm.lastTarget = e.target; // cache the last target here
			    // unhide our dropzone overlay
			    e.preventDefault();
			    document.querySelector(".dropzone").style.visibility = "";
			    document.querySelector(".dropzone").style.opacity = 1;
			}
		});

		window.addEventListener("dragleave", function(e)
		{
			// this is the magic part. when leaving the window,
		    // e.target happens to be exactly what we want: what we cached
		    // at the start, the dropzone we dragged into.
		    // so..if dragleave target matches our cache, we hide the dropzone.
		    if(e.target === vm.lastTarget || e.target === document)
		    {
		        document.querySelector(".dropzone").style.visibility = "hidden";
		        document.querySelector(".dropzone").style.opacity = 0;
		    }
		});

		window.addEventListener("dragover", function (e) {
			 e.preventDefault();
		});

		vm.isFile = function(evt) {
		    var dt = evt.dataTransfer;

		    for (var i = 0; i < dt.types.length; i++) {
		        if (dt.types[i] === "Files") {
		            return true;
		        }
		    }
		    return false;
		}*/

    /*
     ** Open attachments images and pdfs in popup
     */
    vm.downloadDocuments = function (doc) {
      if (doc.doc_name != undefined) {
        eCommerceService.downloadDocument(doc.doc_name);
      }
    };

    /* Card Swiper code starts */
    function trimNumber(s) {
      while (s.substr(0, 1) == "0" && s.length > 1) {
        s = s.substr(1, 9999);
      }
      return s;
    }

    function parseSwiperData(value) {
      if (value.charAt(0) !== "%") {
        return -1;
      }
      var p = new SwipeParserObj(value);
      var result = new Array();
      if (p.hasTrack1) {
        if (p.surname != null) result[0] = p.surname + " " + p.firstname;
        else result[0] = p.account_name;
        result[1] = p.account;
        result[2] = p.exp_month;
        result[3] = p.exp_year;
      }
      return result;
    }
    window.parseSwiperData = parseSwiperData;

    var method = "authorizenet";
    vm.swipeText = "Click here to swipe";

    vm.swipeNow = function () {
      if (angular.element("#authorizenet-swiper-data")) {
        angular.element("#authorizenet-swiper-data").val(" ");
        angular.element("#authorizenet-swiper-data").select();
      }
    };

    vm.readySwipe = function () {
      vm.swipeText = "Ready to swipe";
    };

    vm.resetSwipe = function () {
      vm.swipeText = "Click here to swipe";
    };

    vm.keyupfunction = function (event) {
      if (event.keyCode == 13) {
        // was: event.keyCode == 13
        var ccinfo = parseSwiperData(vm.ccinfo_a);
        var errorFound = false;
        if (ccinfo === -1) {
        } else {
          if (ccinfo != null && ccinfo.length > 0) {
            vm.payment_method.cc_fname = "";
            vm.payment_method.cc_lname = "";
            vm.payment_method.cc_number = "";
            vm.payment_method.cc_number_mask = "";
            vm.payment_method.cc_type = "";
            vm.payment_method.cc_exp_month = "";
            vm.payment_method.cc_exp_year = "";

            var owner = ccinfo[0].trim().replace(/\s\s+/g, " ");
            var cc_owner = owner.split(" ");

            if (cc_owner.length > 1) {
              vm.payment_method.cc_fname = cc_owner[0];
              vm.payment_method.cc_lname = cc_owner[cc_owner.length - 1];
            } else {
              vm.payment_method.cc_fname = cc_owner[0];
            }
            if (ccinfo[1] == null) {
              alert("Card number not detected!");
              errorFound = true;
            } else {
              vm.payment_method.cc_number = ccinfo[1];
              vm.payment_method.cc_number_mask = ccinfo[1].replace(
                /.*(\d{4})$/,
                "xxxxxxxxxxxx$1"
              );
              var startdigit = parseInt(ccinfo[1].charAt(0));
              if (startdigit == 3)
                vm.payment_method.cc_type = "American Express";
              if (startdigit == 4) vm.payment_method.cc_type = "Visa";
              if (startdigit == 5) vm.payment_method.cc_type = "MasterCard";
              if (startdigit == 6) vm.payment_method.cc_type = "Discover";
              if (jQuery("select#" + method + "_cc_type").val() == "") {
                alert("Card type not detected!");
                errorFound = true;
              }
            }
            if (ccinfo[2] == null) {
              alert("Expiration month not detected!");
              errorFound = true;
            } else {
              vm.payment_method.cc_exp_month = trimNumber(ccinfo[2]);
            }
            if (ccinfo[3] == null) {
              alert("Expiration year not detected!");
              errorFound = true;
            } else {
              vm.payment_method.cc_exp_year = ccinfo[3];
              if (jQuery("#" + method + "_expiration_yr").val() == "") {
                alert("The card might be expired!");
                errorFound = true;
              }
            }

            $timeout(function () {
              angular.element("#authorizenet_cc_number_label").trigger("click");
            }, 0);
          } else {
            alert("Cannot read the data!");
            errorFound = true;
          }
          if (!errorFound) {
            //~ onBlurCheckForm();
          }
          vm.ccinfo_a = "";
          jQuery("#loading-mask").hide();
        }
      }
    };
    jQuery(document).on(
      "click",
      ".payment-methods input[type=radio]",
      function () {
        vm.swipeNow(jQuery(".payment-methods input[type=radio]:checked").val());
      }
    );
    vm.swipeNow(jQuery('input[name="payment[method]"]:checked').val());
    /* Card Swiper code ends */

    function getCcFeeAppliedItems() {
      var items = [];
      if (!vm || !vm.order) return items;

      var roomRemoveChecked = !!vm.removeCcProcessingFeeRoom;
      if (
        vm.order &&
        vm.order.confirmation_number &&
        isCcProcessingFeeApplicable(vm.order) &&
        String(vm.order.show_status || "").toLowerCase() !== "canceled" &&
        String(vm.order.room_stay_status || "").toLowerCase() !== "canceled"
      ) {
        items.push({
          label:
            (vm.order.product_name || "Room") +
            " (" +
            (vm.order.confirmation_number || "") +
            ")",
          confirmation_number: vm.order.confirmation_number,
          applicable: true,
          // Always preselect all entries when popup opens.
          checked: true,
          originalChecked: roomRemoveChecked,
        });
      }

      if (vm.order.pos) {
        angular.forEach(vm.order.pos, function (posValue, posKey) {
          if (!posValue) return;
          if (
            posValue.confirmation_number &&
            isCcProcessingFeeApplicable(posValue) &&
            String(posValue.room_stay_status || "").toLowerCase() !==
              "canceled" &&
            !isRoundUpForCharityPos(posValue) && !isPosNonCancellable(posValue)
          ) {
            items.push({
              label:
                (posValue.product_name || "Product") +
                " (" +
                (posValue.confirmation_number || "") +
                ")",
              confirmation_number: posValue.confirmation_number,
              applicable: true,
              checked: true,
              originalChecked: !!vm.removeCcProcessingFeePos[posKey],
            });
          }
        });
      }

      return items;
    }

    function promptCashCcFeeRemoval() {
      var items = getCcFeeAppliedItems();
      if (!items.length) return $q.resolve("no_change");
      // If everything is already in the desired state ("remove" checked),
      // skip opening the dialog to avoid unnecessary API calls.
      var hasAnyChange = items.some(function (item) {
        // In this popup, checked => remove fee.
        return item.checked !== item.originalChecked;
      });
      if (!hasAnyChange) return $q.resolve("no_change");

      return $mdDialog
        .show({
          parent: angular.element(document.body),
          clickOutsideToClose: false,
          escapeToClose: true,
          locals: { ccFeeItems: items },
          template:
            '<md-dialog aria-label="Remove CC Processing Fee" style="width:640px; max-width:95vw;">' +
            '  <md-toolbar class="md-accent" style="min-height:46px;">' +
            '    <div class="md-toolbar-tools">' +
            '      <h2 style="color: #fff; font-size:17px; font-weight:500;">CC processing fee removal</h2>' +
            '      <span flex></span>' +
            '      <md-button class="md-icon-button" aria-label="Close" ng-click="dlg.cancel()">' +
            '        <md-icon md-font-icon="icon-close" style="font-size:17px;color: #fff;"></md-icon>' +
            "      </md-button>" +
            "    </div>" +
            "  </md-toolbar>" +
            '  <md-dialog-content style="max-width:640px; padding: 0">' +
            '    <div class="md-dialog-content" style="padding:24px;">' +
            '      <div layout="row" layout-align="space-between center" style="margin-bottom:10px; font-size:13px;">' +
            '        <span>Are you sure you want to remove CC processing fee from below products?</span>' +
            '        <span style="color:#444;">Selected: {{dlg.selectedCount()}} / {{dlg.items.length}}</span>' +
            "      </div>" +
            '      <div style="max-height:250px; overflow:auto; border:1px solid #e3e3e3; border-radius:2px; padding:8px 12px;">' +
            '        <md-checkbox ng-repeat="item in dlg.items track by $index" ng-model="item.checked" class="no-margin" style="display:block; padding:5px 0;">' +
            "          {{item.label}}" +
            "        </md-checkbox>" +
            "      </div>" +
            "    </div>" +
            "  </md-dialog-content>" +
            '  <md-dialog-actions layout="row" layout-align="end center" style="padding:8px 12px 10px; min-height:46px; background: rgba(0, 0, 0, 0.03);">' +
            '    <md-button ng-click="dlg.toggleAll(true)" style="margin-right:auto;">Select all</md-button>' +
            '    <md-button class="md-button md-raised md-warn" ng-click="dlg.cancel()">Cancel</md-button>' +
            '    <md-button class="md-button md-raised md-primary md-green-500-bg" ng-click="dlg.confirm()">Confirm</md-button>' +
            "  </md-dialog-actions>" +
            "</md-dialog>",
          controllerAs: "dlg",
          controller: function ($mdDialog, ccFeeItems) {
            var dlg = this;
            dlg.items = ccFeeItems;
            dlg.toggleAll = function (value) {
              angular.forEach(dlg.items, function (item) {
                item.checked = value;
              });
            };
            dlg.selectedCount = function () {
              var count = 0;
              angular.forEach(dlg.items, function (item) {
                if (item.checked) count++;
              });
              return count;
            };
            dlg.cancel = function () {
              $mdDialog.cancel();
            };
            dlg.confirm = function () {
              $mdDialog.hide(dlg.items);
            };
          },
        })
        .then(function (selectedItems) {
          var itemsToAdd = [];
          var itemsToRemove = [];

          angular.forEach(selectedItems || [], function (item) {
            if (!item || !item.applicable || !item.confirmation_number) return;

            // checked => remove fee
            if (item.checked && !item.originalChecked) {
              itemsToRemove.push(item.confirmation_number);
              return;
            }

            // unchecked => add fee (only if it was originally removed)
            if (!item.checked && item.originalChecked) {
              itemsToAdd.push(item.confirmation_number);
              return;
            }
          });

          if (!itemsToAdd.length && !itemsToRemove.length) return "no_change";

          // Single API call for all state changes (add + remove).
          return eCommerceService
            .changeCCProcessingFeeTax({
              itemsToAddCcProcessingFeeTax: itemsToAdd,
              itemsToRemoveCcProcessingFeeTax: itemsToRemove,
              parentConfirmationNumber:
                vm.order && vm.order.confirmation_number
                  ? vm.order.confirmation_number
                  : undefined,
            })
            .then(function (response) {
              if (!response || response.success !== true) {
                var toastMsg =
                  "Unable to update CC processing fee for selected products.";
                if (
                  response &&
                  Array.isArray(response.failed) &&
                  response.failed.length
                ) {
                  toastMsg =
                    response.failed[0].errorMsg ||
                    response.failed[0].reason ||
                    toastMsg;
                } else if (response && response.message) {
                  toastMsg = response.message;
                }
                toastMessage.showSimpleToast(
                  toastMsg,
                  "error-toast"
                );
                return false;
              }
              return true;
            })
            .catch(function () {
              toastMessage.showSimpleToast(
                "Unable to update CC processing fee for selected products.",
                "error-toast"
              );
              return false;
          });
        });
    }

    function promptNonCashCcFeeApply() {
      var items = getCcFeeAppliedItems();
      if (!items.length) return $q.resolve("no_change");

      // For non-cash flow: checked means apply CC processing fee again.
      angular.forEach(items, function (item) {
        item.checked = true;
      });

      // Only items that currently have fee removed can be changed to "applied again".
      var hasAnyChange = items.some(function (item) {
        return !!item.originalChecked;
      });
      if (!hasAnyChange) return $q.resolve("no_change");

      return $mdDialog
        .show({
          parent: angular.element(document.body),
          clickOutsideToClose: false,
          escapeToClose: true,
          locals: { ccFeeItems: items },
          template:
            '<md-dialog aria-label="Apply CC Processing Fee" style="width:640px; max-width:95vw;">' +
            '  <md-toolbar class="md-accent" style="min-height:46px;">' +
            '    <div class="md-toolbar-tools">' +
            '      <h2 style="color: #fff; font-size:17px; font-weight:500;">Apply CC processing fee</h2>' +
            '      <span flex></span>' +
            '      <md-button class="md-icon-button" aria-label="Close" ng-click="dlg.cancel()">' +
            '        <md-icon md-font-icon="icon-close" style="font-size:17px;color: #fff;"></md-icon>' +
            "      </md-button>" +
            "    </div>" +
            "  </md-toolbar>" +
            '  <md-dialog-content style="max-width:640px; padding: 0">' +
            '    <div class="md-dialog-content" style="padding:24px;">' +
            '      <div layout="row" layout-align="space-between center" style="margin-bottom:10px; font-size:13px;">' +
            '        <span>Are you sure you want to apply CC processing fee on below products?</span>' +
            '        <span style="color:#444;">Selected: {{dlg.selectedCount()}} / {{dlg.items.length}}</span>' +
            "      </div>" +
            '      <div style="max-height:250px; overflow:auto; border:1px solid #e3e3e3; border-radius:2px; padding:8px 12px;">' +
            '        <md-checkbox ng-repeat="item in dlg.items track by $index" ng-model="item.checked" class="no-margin" style="display:block; padding:5px 0;">' +
            "          {{item.label}}" +
            "        </md-checkbox>" +
            "      </div>" +
            "    </div>" +
            "  </md-dialog-content>" +
            '  <md-dialog-actions layout="row" layout-align="end center" style="padding:8px 12px 10px; min-height:46px; background: rgba(0, 0, 0, 0.03);">' +
            '    <md-button ng-click="dlg.toggleAll(true)" style="margin-right:auto;">Select all</md-button>' +
            '    <md-button class="md-button md-raised md-warn" ng-click="dlg.cancel()">Cancel</md-button>' +
            '    <md-button class="md-button md-raised md-primary md-green-500-bg" ng-click="dlg.confirm()">Confirm</md-button>' +
            "  </md-dialog-actions>" +
            "</md-dialog>",
          controllerAs: "dlg",
          controller: function ($mdDialog, ccFeeItems) {
            var dlg = this;
            dlg.items = ccFeeItems;
            dlg.toggleAll = function (value) {
              angular.forEach(dlg.items, function (item) {
                item.checked = value;
              });
            };
            dlg.selectedCount = function () {
              var count = 0;
              angular.forEach(dlg.items, function (item) {
                if (item.checked) count++;
              });
              return count;
            };
            dlg.cancel = function () {
              $mdDialog.cancel();
            };
            dlg.confirm = function () {
              $mdDialog.hide(dlg.items);
            };
          },
        })
        .then(function (selectedItems) {
          var itemsToAdd = [];
          var itemsToRemove = [];
          angular.forEach(selectedItems || [], function (item) {
            if (!item || !item.applicable || !item.confirmation_number) return;
            var currentlyApplied = !item.originalChecked;
            var shouldApply = !!item.checked;

            if (shouldApply && !currentlyApplied) {
              itemsToAdd.push(item.confirmation_number);
              return;
            }

            if (!shouldApply && currentlyApplied) {
              itemsToRemove.push(item.confirmation_number);
            }
          });

          if (!itemsToAdd.length && !itemsToRemove.length) return "no_change";

          return eCommerceService
            .changeCCProcessingFeeTax({
              itemsToAddCcProcessingFeeTax: itemsToAdd,
              itemsToRemoveCcProcessingFeeTax: itemsToRemove,
              parentConfirmationNumber:
                vm.order && vm.order.confirmation_number
                  ? vm.order.confirmation_number
                  : undefined,
            })
            .then(function (response) {
              if (!response || response.success !== true) {
                var toastMsg =
                  "Unable to update CC processing fee for selected products.";
                if (
                  response &&
                  Array.isArray(response.failed) &&
                  response.failed.length
                ) {
                  toastMsg =
                    response.failed[0].errorMsg ||
                    response.failed[0].reason ||
                    toastMsg;
                } else if (response && response.message) {
                  toastMsg = response.message;
                }
                toastMessage.showSimpleToast(toastMsg, "error-toast");
                return false;
              }
              return true;
            })
            .catch(function () {
              toastMessage.showSimpleToast(
                "Unable to update CC processing fee for selected products.",
                "error-toast"
              );
              return false;
            });
        });
    }

    vm.onPaymentMethodSelect = function (method) {
      if (vm.handlingPaymentMethodChange) return;
      vm.latestPaymentMethod = method;
      var normalizedMethod = (method || "").toLowerCase();
      var priorPaymentMethod = vm.previousPaymentMethod || "Credit Card";
      vm.pendingSelectedPaymentMethod = method;

      if (normalizedMethod === "cash") {
        vm.handlingPaymentMethodChange = true;
        promptCashCcFeeRemoval()
          .then(function (updated) {
            if (updated === true) {
              var refreshConfirmationNumber =
                vm.order && vm.order.confirmation_number
                  ? vm.order.confirmation_number
                  : "";
              if (refreshConfirmationNumber) {
                vm.fetchOrder(refreshConfirmationNumber, "hitRequest");
              }
              vm.previousPaymentMethod = method;
            } else if (updated === "no_change") {
              vm.payment_method.payment_method = method;
              vm.pendingSelectedPaymentMethod = method;
              vm.previousPaymentMethod = method;
            } else {
              vm.payment_method.payment_method = priorPaymentMethod;
              vm.pendingSelectedPaymentMethod = priorPaymentMethod;
            }
          })
          .catch(function () {
            vm.payment_method.payment_method = method;
            vm.pendingSelectedPaymentMethod = method;
            vm.previousPaymentMethod = method;
          })
          .finally(function () {
            vm.handlingPaymentMethodChange = false;
          });
        return;
      }

      if (
        String(priorPaymentMethod || "").toLowerCase() === "cash" &&
        normalizedMethod !== "cash"
      ) {
        vm.handlingPaymentMethodChange = true;
        promptNonCashCcFeeApply()
          .then(function (updated) {
            if (updated === true) {
              var refreshConfirmationNumber =
                vm.order && vm.order.confirmation_number
                  ? vm.order.confirmation_number
                  : "";
              if (refreshConfirmationNumber) {
                vm.fetchOrder(refreshConfirmationNumber, "hitRequest");
              }
              vm.previousPaymentMethod = method;
            } else if (updated === "no_change") {
              vm.payment_method.payment_method = method;
              vm.pendingSelectedPaymentMethod = method;
              vm.previousPaymentMethod = method;
            } else {
              vm.payment_method.payment_method = priorPaymentMethod;
              vm.pendingSelectedPaymentMethod = priorPaymentMethod;
            }
          })
          .catch(function () {
            vm.payment_method.payment_method = method;
            vm.pendingSelectedPaymentMethod = method;
            vm.previousPaymentMethod = method;
          })
          .finally(function () {
            vm.handlingPaymentMethodChange = false;
          });
        return;
      }

      vm.previousPaymentMethod = method;
      if (normalizedMethod == "credit card") {
        setTimeout(function () {
          vm.swipeNow();
          vm.readySwipe();
        }, 100);
      }
    };

    vm.onPaymentMethodClick = function (method) {
      var clickedMethod = (method || "").toLowerCase();
      var selectedMethod = ((vm.payment_method && vm.payment_method.payment_method) || "").toLowerCase();
      if (clickedMethod === "cash" && selectedMethod === "cash" && !vm.handlingPaymentMethodChange) {
        vm.onPaymentMethodSelect(method);
      }
    };
    vm.transferAmount = transferAmount;
    function transferAmount(confirmation_number, installment_id) {
      eCommerceService
        .transferAmount({
          confirmation_number: confirmation_number,
          installment_id: installment_id,
        })
        .then(function (response) {
          if (response.success) {
            $mdDialog.show({
              clickOutsideToClose: false,
              parent: angular.element($document.body),
              scope: $scope,
              preserveScope: true,
              locals: {
                localData: {
                  transaction_details: response.transaction_details,
                  roomDataTransferFrom: response.roomDataTransferFrom,
                  roomDataTransferTo: response.roomDataTransferTo,
                },
              },
              templateUrl:
                "app/main/apps/e-commerce/views/orders/dialogs/transfer/transfer.html",
              controller: transferController,
            });
            function transferController($scope, $mdDialog, localData) {
              $scope.transaction_details = localData.transaction_details;
              vm.totalTransferableAmount =
                $scope.transaction_details["installment_amount"];
              vm.staticTotalTransferableAmount =
                $scope.transaction_details["installment_amount"];
              $scope.roomDataTransferFrom = localData.roomDataTransferFrom;
              $scope.roomDataTransferTo = localData.roomDataTransferTo;
              $scope.currentRoom = localData.currentRoom;
              $scope.hasInstallment = true;
              $scope.automaticTransfer = false;
              $scope.adjustedAmountInCurrentRoom =
                localData.roomDataTransferFrom.total_remaining_amount;
              $scope.fixedDdjustedAmountInCurrentRoom =
                localData.roomDataTransferFrom.total_remaining_amount;

              $scope.orginalTotalAmount = angular.copy(
                $scope.roomDataTransferFrom["total_remaining_amount"]
              );

              $scope.selectedRooms = {};
              $scope.amountToTransfer = {};
              $scope.previousAmountToTransfer = {};

              $scope.closeDialog = function () {
                $mdDialog.hide();
              };

              $scope.validEntries = false;

              $scope.updateAmount = false;

              $scope.updateAmount = function (conf) {
                $scope.validEntries = false;
                var orginalAmount = $scope.amountToTransfer[conf];
                var curAmount = $scope.amountToTransfer[conf];
                var tempTotalAmount =
                  $scope.transaction_details["installment_amount"];
                $scope.roomDataTransferFrom["total_remaining_amount"] =
                  angular.copy($scope.orginalTotalAmount);

                /*Check If Valid Amounts is Entered Start*/
                if (Object.keys($scope.amountToTransfer).length > 0) {
                  angular.forEach(
                    $scope.amountToTransfer,
                    function (element, index) {
                      if (element != null) $scope.validEntries = true;
                    }
                  );
                }
                /*Check If Valid Amounts is Entered End*/

                $scope.roomDataTransferTo.forEach(function (element, index) {
                  curAmount =
                    $scope.amountToTransfer[element.confirmation_number];
                  if (
                    typeof curAmount != "undefined" &&
                    (curAmount != "undefined") != "" &&
                    curAmount != null
                  ) {
                    tempTotalAmount =
                      tempTotalAmount -
                      $scope.amountToTransfer[element.confirmation_number];
                  }
                });

                if (tempTotalAmount < 0) {
                  $scope.amountToTransfer[conf] = angular.copy(
                    $scope.previousAmountToTransfer[conf]
                  );
                  return;
                }

                tempTotalAmount =
                  $scope.transaction_details["installment_amount"];

                $scope.roomDataTransferTo.forEach(function (element, index) {
                  curAmount =
                    $scope.amountToTransfer[element.confirmation_number];
                  if (
                    typeof curAmount != "undefined" &&
                    (curAmount != "undefined") != "" &&
                    curAmount != null
                  ) {
                    tempTotalAmount =
                      tempTotalAmount -
                      $scope.amountToTransfer[element.confirmation_number];
                    $scope.roomDataTransferFrom["total_remaining_amount"] =
                      parseFloat(
                        $scope.roomDataTransferFrom["total_remaining_amount"]
                      ) +
                      parseFloat(
                        $scope.amountToTransfer[element.confirmation_number]
                      );
                    $scope.roomDataTransferFrom["total_remaining_amount"] =
                      commonService.roundnum(
                        $scope.roomDataTransferFrom["total_remaining_amount"],
                        2
                      );
                  }
                  $scope.previousAmountToTransfer[element.confirmation_number] =
                    angular.copy(
                      $scope.amountToTransfer[element.confirmation_number]
                    );
                });

                // $scope.adjustedAmountInCurrentRoom = $scope.fixedDdjustedAmountInCurrentRoom -vm.totalTransferableAmount;

                vm.totalTransferableAmount = tempTotalAmount;
              };
            }
          } else {
            alert("Show error message");
          }
        });
    }
    vm.initiateTransfer = initiateTransfer;

    function initiateTransfer() {
      var data = {
        fundTransferToRoom: $scope.amountToTransfer,
        transactionFrom: $scope.transaction_details,
        room_stay_id: $scope.roomDataTransferFrom["room_stay_id"],
      };
      eCommerceService.inititateFundTransfer(data).then(function (response) {
        if (response.success) {
          fetchOrderInformation(
            $scope.roomDataTransferFrom["confirmation_number"]
          );
        }
        $mdDialog.hide();
      });
    }

    /*
     ** Used to edit pos product dates
     */
    function editPosDates(
      event,
      room_stay_from,
      room_stay_to,
      poskey,
      pos,
      room_stay_id
    ) {
      var localData = {
        checkin: room_stay_from,
        checkout: room_stay_to,
        poskey: poskey,
      };
      $mdDialog
        .show({
          controller: "editPosDatesController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/e-commerce/views/orders/dialogs/edit-pos-dates/edit-pos-dates.html",
          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: true,
          locals: {
            localData: localData,
          },
        })
        .then(
          function (response) {
            if (
              response.checkin === undefined &&
              response.checkout === undefined
            ) {
              console.log("nothing change");
            } else if (
              room_stay_from != response.checkin &&
              room_stay_to != response.checkout
            ) {
              vm.dateModifiedBoth(
                response.checkin,
                response.checkout,
                response.posIdx
              );
              vm.setShowModifyBtn(
                "Both Date",
                "room_stay_from-room_stay_to",
                room_stay_id,
                "pos",
                response.posIdx
              );
              vm.datesChanged(response.posIdx);
            } else if (room_stay_from != response.checkin) {
              vm.startDateModified(response.checkin, response.posIdx);
              vm.setShowModifyBtn(
                "Start Date",
                "room_stay_from",
                room_stay_id,
                "pos",
                response.posIdx
              );
              vm.datesChanged(response.posIdx);
            } else if (room_stay_to != response.checkout) {
              vm.endDateModified(response.checkout, response.posIdx);
              vm.setShowModifyBtn(
                "End Date",
                "room_stay_to",
                room_stay_id,
                "pos",
                response.posIdx
              );
              vm.datesChanged(response.posIdx);
            }
          },
          function (error) {
            console.log("Error while update dates");
          }
        );
    }

    /*
     ** Used to subtract value for showing in summary table
     */
    vm.subtractSubtotal = function (cartSub, extraPersonSub, resortSub) {
      var subtotal = 0;
      subtotal = parseFloat(cartSub);
      if (
        extraPersonSub != undefined &&
        extraPersonSub != "" &&
        vm.order.extraPersonProduct.room_stay_status != "Canceled"
      ) {
        subtotal = subtotal - parseFloat(extraPersonSub);
      }
      if (resortSub != undefined && resortSub != "") {
        subtotal = subtotal - parseFloat(resortSub);
      }
      return subtotal;
    };

    vm.updateTaxExemptStatus = function (column, confirmation_number, type) {
      var taxExemptIndicator =
        type == "customer"
          ? vm.order.customerTaxExempt
          : vm.order.travellerTaxExempt;
      var customerId =
        type == "customer" ? vm.order.customerId : vm.order.travellerId;
      vm.taxExemptRequest = true;
      var data = {
        customer_id: customerId,
        tax_exempt_indicator: taxExemptIndicator,
        reservation_id: vm.reservation_id,
        confirmation_number: confirmation_number,
        type: type,
      };
      if (
        vm.reservation_customer.negotiated_customer !== undefined &&
        vm.reservation_customer.negotiated_customer &&
        type == "customer"
      ) {
        vm.updateNegotiatedCustomer(column, confirmation_number, type);
      } else {
        eCommerceService.getUserResevations(data).then(function (response) {
          if (response.success) {
            var allLinks = "";
            response["reservationDetails"].forEach(function (element, index) {
              allLinks +=
                "<b class='onlycursorPointer' ng-click='vm.goToReservaion(" +
                element.reservation_id +
                ", " +
                element.confirmation_number +
                ")' > -- " +
                element.itinerary_number +
                ".</b></br>";
            });
            var html =
              "Updating user's tax exempt status will update tax from user's ongoing and future reservations as well.</br></br>";
            html = html + allLinks;
            $mdDialog
              .show({
                controller: "confirmController",
                controllerAs: "vm",
                templateUrl:
                  "app/main/apps/contacts/confirmationPopUp/confirmation.html",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                  title: type + " has existing reservations.",
                  htmlContent: html,
                  cancelBtn: "Cancel",
                  OkBtn: "Proceed",
                },
              })
              .then(
                function (answer) {
                  if (typeof answer != "undefined" && answer == "update") {
                    vm.updateCustomer(column, confirmation_number, type);
                  } else {
                    if (type == "customer") {
                      vm.order.customerTaxExempt = !vm.order.customerTaxExempt;
                    } else {
                      vm.order.travellerTaxExempt =
                        !vm.order.travellerTaxExempt;
                    }
                    vm.taxExemptRequest = false;
                  }
                },
                function () {
                  if (type == "customer") {
                    vm.order.customerTaxExempt = !vm.order.customerTaxExempt;
                  } else {
                    vm.order.travellerTaxExempt = !vm.order.travellerTaxExempt;
                  }
                  vm.taxExemptRequest = false;
                }
              );
          } else {
            vm.updateCustomer(column, confirmation_number, type);
          }
        });
      }
    };

    // Consolidates three buttons add new room, change date and split reservation
    vm.consolidateButtons = function () {
      if (
        vm.order.room_stay_status != "Canceled" ||
        vm.order.room_stay_status != "No Show"
      ) {
        var consolidateDisabled = true;
        if (
          (vm.order.show_status == "Active" ||
            vm.order.show_status == "Waiting for Room" ||
            vm.order.show_status == "Checked-In") &&
          (vm.order.room_moved_to === null ||
            vm.order.room_moved_to === "" ||
            vm.order.room_moved_to === undefined) &&
          vm.room_stay_status != "Canceled" &&
          vm.order.type_of_reservation != "rent" &&
          vm.order.nights > 1
        ) {
          consolidateDisabled = false;
        }
        $mdDialog
          .show({
            controller: "consolidateController",
            controllerAs: "vm",
            templateUrl:
              "app/main/apps/create-res/dialogs/consolidate/consolidate.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
              type: vm.pageType,
              consolidateDisabled: consolidateDisabled,
            },
          })
          .then(
            function (response) {
              console.log("Consolidate Response ===> ", response);
            },
            function () {}
          );
      }
    };

    $scope.$on("consolidateType", function (event, data) {
      vm.consolidateType = data.type;
      if (vm.consolidateType == "split") {
        if (
          (vm.order.show_status == "Active" ||
            vm.order.show_status == "Waiting for Room" ||
            vm.order.show_status == "Checked-In") &&
          (vm.order.room_moved_to == null ||
            vm.order.room_moved_to == "" ||
            vm.order.room_moved_to == undefined) &&
          vm.room_stay_status != "Canceled" &&
          vm.order.type_of_reservation != "rent"
        ) {
          vm.roomMoveStart(
            event,
            vm.order.room_stay_from,
            vm.order.room_stay_to,
            vm.order.room_stay_guest_count,
            vm.order.room_stay_child_count,
            vm.order.room_stay_id,
            vm.order.product_id,
            vm.order.product_name,
            vm.order.policy_id,
            vm.order.confirmation_number,
            vm.reservation_id,
            vm.itinerary_number
          );
        }
      } else if (
        vm.consolidateType == "roomChange" &&
        vm.order.type_of_reservation != "rent"
      ) {
        vm.roomMoveStart(
          event,
          vm.order.room_stay_from,
          vm.order.room_stay_to,
          vm.order.room_stay_guest_count,
          vm.order.room_stay_child_count,
          vm.order.room_stay_id,
          vm.order.product_id,
          vm.order.product_name,
          vm.order.policy_id,
          vm.order.confirmation_number,
          vm.reservation_id,
          vm.itinerary_number
        );
      } else if (vm.consolidateType == "dates" && vm.roomCount > 0) {
        vm.editOrderDates(
          event,
          vm.order.room_stay_from,
          vm.order.room_stay_to,
          vm.order.room_stay_guest_count,
          vm.order.room_stay_child_count,
          vm.order.confirmation_number,
          vm.order.product_id,
          vm.order.product_name,
          vm.order.policy_id
        );
      } else if (vm.consolidateType == "new" && vm.roomCount > 0) {
        vm.addroomincart();
      }
    });

    vm.updateTravellerSameAsCustomer = function () {
      if (vm.travelCustSame) {
        var tempData = {
          confNo: vm.order.confirmation_number,
          resvId: vm.reservation_id,
          customerTaxExempt: vm.order.customerTaxExempt,
          customerId: vm.order.customerId,
          travellerId: vm.order.travellerId,
        };
        eCommerceService
          .updateTravellerAsCustomer(tempData)
          .then(function (response) {
            if (response.success) {
              vm.order.first_name = vm.reservation_customer.first_name;
              vm.order.last_name = vm.reservation_customer.last_name;
              vm.order.city = vm.reservation_customer.city;
              vm.order.state = vm.reservation_customer.state;
              vm.order.zip_code = vm.reservation_customer.zip_code;
              vm.order.country = vm.reservation_customer.country;
              vm.order.phone_number = vm.reservation_customer.phone_number;
              vm.order.secondary_phone_number =
                vm.reservation_customer.secondary_phone_number;
              vm.order.customer_email = vm.reservation_customer.customer_email;
              vm.order.customer_id = vm.reservation_customer.customer_id;
              vm.order.travellerTaxExempt = vm.order.customerTaxExempt;
              vm.order.customerTravelSame = true;
              originalOrderData.customer_email =
                vm.reservation_customer.customer_email;
              vm.fetchOrder(vm.order.confirmation_number, "hitRequest");
            } else if (!response.success) {
              vm.travelCustSame = false;
              toastMessage.showSimpleToast(
                "Some error occured please try later.",
                "error-toast"
              );
            }
          });
      }
    };

    /*userService.getCountries().then(function(response){
			vm.Country = response;
		});
		vm.addCustomerTravellor = function(ev,typeOfCust) {
			console.log(vm.order);
			var tmpTraveller = {
				first_name: vm.order.first_name,
				last_name: vm.order.last_name,
				city: vm.order.city,
				state: vm.order.state,
				zip_code: vm.order.zip_code,
				country: vm.order.country,
				phone_number: vm.order.phone_number,
				secondary_phone_number: vm.order.secondary_phone_number,
				customer_email: vm.order.customer_email,
				customer_id: vm.order.customer_id
			};

			$mdDialog.show({
				controller		 : 'editCustController',
				controllerAs	   : 'vm',
				templateUrl		: 'app/main/apps/e-commerce/views/orders/order/edit-customer/edit-customer.html',
				parent			 : angular.element($document.body),
				targetEvent		: ev,
				scope			  : $scope.$new(),
				clickOutsideToClose: true,
				locals			 : {
					customerIndex   : 0,
					typeOfCust	   : typeOfCust,
					Country		   : vm.Country,
					allTabs		   : vm.tabsData,
					commonCustomer : vm.reservation_customer,
					travellerInfo  : tmpTraveller,
					pageType	    : vm.pageType
				}
			});
		};*/

    vm.checkCustomerTravellerSame = function () {
      var count = 0;
      if (
        vm.order != undefined &&
        vm.order.first_name != undefined &&
        vm.reservation_customer.first_name != undefined &&
        vm.order.first_name.toLowerCase() ==
          vm.reservation_customer.first_name.toLowerCase()
      ) {
        count++;
      }

      if (
        vm.order != undefined &&
        vm.order.last_name != undefined &&
        vm.reservation_customer.last_name != undefined &&
        vm.order.last_name.toLowerCase() ==
          vm.reservation_customer.last_name.toLowerCase()
      ) {
        count++;
      }

      if (
        vm.order != undefined &&
        vm.order.customer_email != undefined &&
        vm.reservation_customer.customer_email != undefined &&
        vm.order.customer_email.toLowerCase() ==
          vm.reservation_customer.customer_email.toLowerCase()
      ) {
        count++;
      }

      if (
        vm.order != undefined &&
        vm.order.city != undefined &&
        vm.reservation_customer.city != undefined &&
        vm.order.city.toLowerCase() ==
          vm.reservation_customer.city.toLowerCase()
      ) {
        count++;
      }

      if (
        vm.order != undefined &&
        vm.order.state != undefined &&
        vm.reservation_customer.state != undefined &&
        vm.order.state.toLowerCase() ==
          vm.reservation_customer.state.toLowerCase()
      ) {
        count++;
      }

      if (
        vm.order != undefined &&
        vm.order.zip_code != undefined &&
        vm.reservation_customer.zip_code != undefined &&
        vm.order.zip_code.toLowerCase() ==
          vm.reservation_customer.zip_code.toLowerCase()
      ) {
        count++;
      }

      if (
        vm.order != undefined &&
        vm.order.country != undefined &&
        vm.reservation_customer.country != undefined &&
        vm.order.country.toLowerCase() ==
          vm.reservation_customer.country.toLowerCase()
      ) {
        count++;
      }

      if (
        vm.order != undefined &&
        vm.order.phone_number != undefined &&
        vm.reservation_customer.phone_number != undefined &&
        vm.order.phone_number.toLowerCase() ==
          vm.reservation_customer.phone_number.toLowerCase()
      ) {
        count++;
      }

      if (count == 8) {
        vm.travelCustSame = true;
        return true;
      } else {
        vm.travelCustSame = false;
        return false;
      }
    };

    vm.checkCustomerTravellerSame();

    // Check Walk Rooms
    vm.includedWalk = false;
    if (
      vm.order != undefined &&
      vm.order.product_name.toLowerCase().includes("walk")
    ) {
      vm.includedWalk = true;
    }

    setTimeout(function () {
      vm.autoFillOff = false;
    }, 1500);

    vm.updatePhoneWithCountryCode = function (fieldName, $event) {
      if (vm.isSettingFamilyMemberPhone) {
        return;
      }

      var inputName = fieldName;

      var inputElement = document.querySelector(
        'input[name="' + inputName + '"]'
      );

      if (!inputElement) {
        return;
      }

      var iti =
        angular.element(inputElement).data('iti');

      if (
        !iti &&
        window.intlTelInputGlobals &&
        window.intlTelInputGlobals.getInstance
      ) {
        iti = window.intlTelInputGlobals.getInstance(
          inputElement
        );
      }

      if (!iti) {
        return;
      }

      var inputValue =
        inputElement.value.trim();

      var isValid =
        !inputValue ||
        iti.isValidNumberPrecise();

      angular.element(inputElement)
        .toggleClass('ng-invalid', !isValid)
        .toggleClass('ng-valid', isValid);

      /*
       * Show Material invalid state on the phone container
       * (same pattern as contacts family-member phone).
       */
      if (inputName === 'family_member_phone') {
        var phoneContainer =
          inputElement.closest
            ? inputElement.closest('md-input-container')
            : null;

        if (phoneContainer) {
          angular.element(phoneContainer)
            .toggleClass('md-input-invalid', !isValid);
        }
      }

      if (!inputValue) {
        return;
      }
    };

    /**
     * Changing billing option from traveller to customer
     */
    vm.changeBillingOption = function (type) {
      vm.showCustomerTravellerBillInfo = false;
      if (vm.order.currentBilling != type && !vm.order.customerTravelSame) {
        vm.order.currentBilling = type;
        var comment =
          vm.order.currentBilling == "customer"
            ? "Billing is changed to customer from traveller"
            : "Billing is changed to traveller from customer";
        var currentBilling =
          vm.order.currentBilling == "customer"
            ? vm.order.customerId
            : vm.order.travellerId;
        var tempData = {
          resvId: vm.reservation_id,
          confNo: vm.order.confirmation_number,
          current_billing: currentBilling,
          comment: comment,
        };

        eCommerceService
          .updateBillingOption(tempData)
          .then(function (response) {
            if (response.success) {
              vm.order.current_billing = currentBilling;
            }
          });
      }
    };

    vm.showHideCustTravBillInfo = function () {
      $window.onclick = null;
      vm.showCustomerTravellerBillInfo = !vm.showCustomerTravellerBillInfo;
    };

    vm.showSurchargeDescTooltip = false;
    vm.showSurchargeTooltip = function (value) {
      vm.showSurchargeDescTooltip = value;
    };

    /**
     * @param: String type
     * Comment: Check if promo code is valid or not and apply or remove depending on type
     */
    vm.applyRemoveValidPromoCode = function (type) {
      if (type == "remove") {
        var html = "Are you sure you want to remove the promo code?";
        $mdDialog
          .show({
            controller: "confirmController",
            controllerAs: "vm",
            templateUrl:
              "app/main/apps/contacts/confirmationPopUp/confirmation.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
              title: "Promo Code",
              htmlContent: html,
              cancelBtn: "No",
              OkBtn: "Yes",
            },
          })
          .then(
            function (answer) {
              if (typeof answer != "undefined" && answer == "update") {
                vm.processPromoCode(type);
              }
            },
            function () {}
          );
      } else {
        vm.promoRequestGoing = true;
        vm.processPromoCode(type);
      }
    };

    /**
     * @param: String type
     * Comment: Check if promo code is valid or not and apply or remove depending on type
     */
    vm.processPromoCode = function (type) {
      vm.isloading = true;
      eCommerceService
        .validatePromoCode({
          promoCode: vm.order.promoCodeName,
          confNo: vm.order.confirmation_number,
          roomStayFrom: vm.order.room_stay_from,
          roomStayTo: vm.order.room_stay_to,
          roomTypeId: vm.order.type_id,
          promo: type,
          resvProcess: "modify",
        })
        .then(function (response) {
          vm.promoRequestGoing = false;
          vm.isloading = false;
          if (
            response != undefined &&
            !response.status &&
            response.errorMsg != ""
          ) {
            toastMessage.showSimpleToast(response.errorMsg, "error-toast");
            vm.order.promoCodeName = "";
          } else if (
            response != undefined &&
            !response.status &&
            response.warningMsg != ""
          ) {
            toastMessage.showSimpleToast(response.warningMsg, "warning-toast");
            vm.order.promoCodeName = "";
          } else if (
            response.order != undefined &&
            Object.keys(response.order).length > 0
          ) {
            if (response.warningMsg != "") {
              toastMessage.showSimpleToast(
                response.warningMsg,
                "warning-toast"
              );
            }
            vm.order = response.order;
          }
        });
    };

    vm.formatPhoneNumber = function(phoneNumber) {
        if (!phoneNumber) {
            return phoneNumber;
        }

        if (window.intlTelInput && window.intlTelInput.utils) {
            return window.intlTelInput.utils.formatNumber(
                phoneNumber,
                undefined,
                'INTERNATIONAL'
            );
        }

        return phoneNumber;
    };

    vm.isValidEmail = function (email) {
        if (!email) {
            return false;
        }
        var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    };
  }
})();

(function() {
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('BundleroomController', BundleroomController);

    /** @ngInject */
    function BundleroomController($scope, $stateParams, RoomsList, bundleRoomsService, toastMessage, $state, BundleData, $timeout, $rootScope
    ) {
        var vm = this;
        vm.isloading = false;
        vm.reload = false;
        vm.uniqueError = false;
        vm.userPermissions = $rootScope.userPermissions;
        vm.pageType = $stateParams['page_type'];
        if(vm.pageType == 'bundleRooms'){
            $scope.bundletype = 'BUNDLE';
        } else {
            $scope.bundletype = 'BUNDLEBOAT';
        }

        if(RoomsList.success){
        	vm.roomslist = RoomsList.rooms_list;
        }
        if($stateParams.hasOwnProperty('id') && $stateParams.id > 0){
        	vm.flag = 'edit';
        	if(BundleData.success && BundleData.hasOwnProperty('bundle'))
        		vm.bundle = BundleData.bundle;
        	else
        		$state.go('app.e-commerce.bundlerooms');
        } else {
        	vm.flag = 'add';
        	vm.bundle_id = $stateParams.id;
        }

        vm.addBundleRoom = addBundleRoom;
        vm.uniqueBundle = uniqueBundle;
        vm.updateBundleRoom = updateBundleRoom;

        function addBundleRoom(){
            if(!vm.reload) return;
            vm.isloading = true;
            var data = {bundle_data:vm.bundle};
            bundleRoomsService.addBundleRoom(data).then(function(response){
                vm.isloading = false;
                if (response.success) {
                    if(vm.pageType == 'bundleRooms'){
                        $state.go('app.e-commerce.bundlerooms');
                    } else {
                        $state.go('app.e-commerce.bundleboats');
                    }
                } else {
                    toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
                }
            });
        }
        function uniqueBundle(){
        	if(!vm.reload) return;
        	vm.isloading = true;
        	var data = {product_id:vm.bundle.product_id};
			bundleRoomsService.uniqueBundleRoom(data).then(function(response){
				vm.isloading = false;
				if(!response.unique){
                    vm.uniqueError = true;
                } else {
                    vm.uniqueError = false;
                }
			});
        }
		function updateBundleRoom(){
			if(vm.flag == 'add' || !vm.reload || vm.bundle.group_rooms.length < 2) return;
            /*angular.forEach(vm.roomslist, function(value,key){
                if(value.room_type_id == vm.bundle.room_type_id){
                    vm.bundle.page_title = value.room_type_name;
                }
            });*/
            
			vm.isloading = true;
        	var data = {bundle_data:vm.bundle};
			bundleRoomsService.updateBundleRoom(data).then(function(response){
				vm.isloading = false;
				if (!response.success) {
                	toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
				}
			});
        }
        vm.updateStatus = function(){
            $timeout(function() {
                vm.reload = true;
            },1000);
        }

        vm.goBack = function(){
            if(vm.pageType == 'bundleRooms'){
                $state.go('app.e-commerce.bundlerooms');
            } else {
                $state.go('app.e-commerce.bundleboats');
            }
        } 
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('PropertyAmenitiesController', PropertyAmenitiesController);

    /** @ngInject */
    function PropertyAmenitiesController($state, $scope, $http, EnvironmentConfig, $mdDialog, Amenities, amenitiesService, toastMessage, $localStorage, $document, organizationsservice)
    {
        var vm = this;
        var websites;
        var organizationdata = {onlyOrganizations:true};
        organizationsservice.getorganizations(organizationdata)
		.then(function(response){
			websites = response.organizations;
		});
		vm.isloading = false;
		vm.loggedinUserRole = $localStorage.roleId;
		vm.amenities = Amenities.amenitiesdata;
		vm.saveAssignedAmenity 	= saveAssignedAmenity;
		vm.assignedAmenities = {};
		vm.selectedHotel = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
		vm.feBaseUrl = EnvironmentConfig.feBase_url;

		vm.focus = focus;
		function focus(id){
			var id = '#'+id.split(' ').join('_');
			$(id).focus();
			window.location.hash = id;
		}
		
		function saveAssignedAmenity(value,hotel_amenity_id){
			vm.isloading = true;
			if(vm.assignedAmenities.hasOwnProperty(value) && vm.assignedAmenities[value]){
				var amenityStatus = false;
			}else{
				var amenityStatus = true;
			}
			var data = {amenityStatus: amenityStatus,amenity_id:value,amenity_type:'property',hotel_amenity_id:hotel_amenity_id};
			amenitiesService.savePropertyAmenity(data).then(function(response){
				vm.isloading = false;
				if(response.amenitiesdata){
					vm.amenities = response.amenitiesdata;
				}else{
					toastMessage.showSimpleToast('There was some error in saving details.','error-toast');
				}
			});
		}
		
        
        if(vm.loggedinUserRole == 1){
			vm.website_id = "";
		}else{
			vm.website_id = $localStorage.website_id;
		}
		
		  
    }
})();

(function() {
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('ActivityController', ActivityController);

    /** @ngInject */
    function ActivityController(
        activityService,
        activityData,
        $localStorage,
        activityComponentData,
        $state,
        Upload,
        $scope,
        EnvironmentConfig,
        $timeout,
        toastMessage,
        $mdDialog,
        $document,
        $translate,
        $interval,
        $q,
        commonService,
        $stateParams,
        $rootScope
    ) {
        var vm = this;
        var progress = '';
        var load = false
        vm.flag = 'add';
        vm.isDailyRentalsAvailable = function () {
            return typeof $rootScope.isDailyRentalsAvailable === 'function'
                ? $rootScope.isDailyRentalsAvailable()
                : false;
        };
        vm.activityData = {};
        vm.roomType = {};
        vm.uploadedFiles = [];
        vm.failedFiles = [];
        vm.checkUniqueActivity = checkUniqueActivity;
        vm.loadTypesPos = loadTypesPos;
        vm.getRoomsTypes = getRoomsTypes;
        vm.getPosTypes = getPosTypes;
        vm.nameError = false;
        vm.posTypes = {};
        vm.ingredientTags =[];
        vm.posProductTypes = {};
        vm.addNewPosType = addNewPosType;
        vm.feBaseUrl = EnvironmentConfig.feBase_url;
        vm.isloading = false;
        vm.activityData.allowed_for_all_rooms = true;
        vm.happyHoursPercentage = 0;
        vm.happyHoursAmount = 0;
        vm.pageType = $stateParams['page_type'];
        vm.autoFillOff = true;
        if(vm.pageType == 'Rooms'){
            $scope.posType = 'POS_TYPE';
        } else {
            $scope.posType = 'BOAT_POS_TYPE';
        }
        vm.showResAtrribs = false;
        vm.restaurantAttributes = {};
        vm.activityData.selectedTags = [];

        vm.readonly = false;
        vm.searchTags = null;
        vm.querySearchTags = querySearchTags;
        vm.mytags = loadTags();
        
        vm.numberChips = [];
        vm.numberChips2 = [];
        vm.numberBuffer = '';
        vm.autocompleteDemoRequireMatch = false;
        vm.transformChip = transformChip;

        vm.showInfoPop = false;

        vm.selectedTag = [];

        vm.resortFeeType = 'Flat Rate';
        vm.isResortFeeProduct = false;
        vm.isExtraPersonProduct = false;
        vm.activityData.is_ota_value_same = false;
        vm.last_type_ids = [];
        vm.orginalSelectedTypeIds = [];
        vm.selectedTag = [];
        vm.resortFeeTypeId = 0;
        vm.extraPersonTypeId = 0;
        vm.productTypeError = false;
        vm.productTypeName = '';

        /**** $scope.$on('pos_types') is used to update pos type values on add post types******/
        $scope.$on('pos_types', function(response, args) {
            // if(args.product_pos_type==vm.activityData.product_pos_type);
                vm.posTypes = args.result;
        })
        $scope.$on('openAgainPopup', function(event,args) {
            if(args.selected!=''){
                vm.posTypes = args.result;
            }
            vm.addNewPosType(event,'calllisting');
        })
        vm.status = [{
            'value': '1',
            'name': 'Active'
        }, {
            'value': '0',
            'name': 'Inactive'
        }]

        const EXTRA_SETTINGS = [
            {
                key: "price_type",
                label: "Price Type",
                type: "enum",
                values: [
                    { label: "Flat Rate", value: "flat_rate" },
                    { label: "Percentage", value: "percentage" }
                ]
            },
            {
                key: "percentage_of",
                label: "Percentage Of",
                type: "enum",
                values: [
                    // Temporarily commented out since these options are not functioning
                    // { label: "Subtotal", value: "subtotal" },
                    // { label: "Grand Total", value: "grand_total" },
                    { label: "Per Room Subtotal", value: "per_room_subtotal" },
                    { label: "Per Room Grand Total", value: "per_room_grand_total" }
                ]
            },
            {
                key: "separate_card",
                label: "Separate Card",
                type: "boolean",
                values: [
                    { label: "Yes", value: true },
                    { label: "No", value: false }
                ]
            },
            {
                key: "applied_by_default",
                label: "Applied By Default",
                type: "boolean",
                values: [
                    { label: "Yes", value: true },
                    { label: "No", value: false }
                ]
            },
            {
                key: "is_quantity_locked",
                label: "Quantity Locked",
                type: "boolean",
                values: [
                    { label: "Yes", value: true },
                    { label: "No", value: false }
                ]
            },
            {
                key: "is_non_cancellable",
                label: "Non-Cancellable",
                type: "boolean",
                values: [
                    { label: "Yes", value: true },
                    { label: "No", value: false }
                ]
            },
            {
                key: "is_borrowable",
                label: "Borrowable",
                type: "boolean",
                values: [
                    { label: "Yes", value: true },
                    { label: "No", value: false }
                ]
            },
            {
                key: "is_available_with_daily_rentals",
                label: "Available with Daily Rentals",
                type: "boolean",
                values: [
                    { label: "Yes", value: true },
                    { label: "No", value: false }
                ]
            }
        ];

        vm.EXTRA_SETTINGS = EXTRA_SETTINGS;

        vm.getSetting = function (key) {
            return vm.EXTRA_SETTINGS.find(s => s.key === key);
        };
        vm.activityData.product_status = 'active';
        vm.activityData.product_pos_type = [];
        vm.activityData.dynamic_attribute = false;
        vm.activityData.send_external_email = false;
        vm.activityData.addPosComment = false;
        vm.activityData.extra_settings = parseExtraSettings(vm.activityData.extra_settings);
        vm.activityData.dynamicAttributes = [{
            field: '',
            type: 'text',
            new: ''
        }];
        vm.activityData.restaurant_attributes = [];
        $timeout(function() {
            vm.reload = true;
        }, 2000);
        var hotelID = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
        vm.hotel_id = hotelID;

        function parseExtraSettings(extraSettings) {
            if (!angular.isDefined(extraSettings) || extraSettings === null || extraSettings === '') {
                return {};
            }
            if (angular.isObject(extraSettings)) {
                return extraSettings;
            }
            if (angular.isString(extraSettings)) {
                try {
                    return JSON.parse(extraSettings) || {};
                } catch (e) {
                    return {};
                }
            }
            return {};
        }

        function mergeExtraSettings(existingSettings, patchSettings) {
            return angular.extend({}, parseExtraSettings(existingSettings), patchSettings || {});
        }

        if (activityData.status === 'success') {
            vm.flag = 'edit';
            vm.activityData = activityData.data.activityData;
            vm.uploadedFiles = activityData.data.activityImages;
            vm.activityData.type_id = activityData.data.activityTypes;
            vm.associated_room_id = activityData.data.activityData.associate_with_rooms;
            vm.associated_pos_id = activityData.data.activityData.associate_with_pos;
            vm.activityData.product_is_timebound = vm.activityData.product_is_timebound == 1? true:false;
            vm.activityData.pos_display_tax_indicator = vm.activityData.pos_display_tax_indicator == 1? true:false;
            vm.activityData.pos_display_price_int_only_indicator = vm.activityData.pos_display_price_int_only_indicator == 1? true:false;
            vm.activityData.available_on_fe = vm.activityData.available_on_fe == 1? true:false;
            vm.activityData.display_on_cart = vm.activityData.display_on_cart == 1? true:false;
            vm.activityData.display_on_pms = vm.activityData.display_on_pms == 1? true:false;
            vm.activityData.is_timebound_with_availability = vm.activityData.is_timebound_with_availability == 1? true:false;
            vm.activityData.allowed_for_all_rooms = vm.activityData.allowed_for_all_rooms == 1? true:false;
            vm.activityData.pos_auto_sync_dates = vm.activityData.pos_auto_sync_dates == 1? true:false;
            vm.activityData.associate_with_other_pos = vm.activityData.associate_with_other_pos == 1? true:false;
            vm.activityData.dynamic_attribute = vm.activityData.dynamic_attribute == 1? true:false;
            vm.activityData.send_external_email = vm.activityData.send_external_email == 1? true:false;
            vm.activityData.extra_settings = parseExtraSettings(vm.activityData.extra_settings);
            vm.activityData.addPosComment = !!vm.activityData.extra_settings.auto_pos_comment;
            vm.activityData.isParkingProduct = (vm.activityData.isParkingProduct != undefined) ? vm.activityData.isParkingProduct : false;
            vm.isResortFeeProduct = (vm.activityData.extra_attribute != undefined && vm.activityData.extra_attribute == 'resort_fee') ? true : false;
            vm.isExtraPersonProduct = (vm.activityData.extra_attribute != undefined && vm.activityData.extra_attribute == 'extra_person') ? true : false;
            vm.activityData.is_ota_value_same = (vm.activityData.is_ota_value_same != undefined && vm.activityData.is_ota_value_same == '0') ? true : false;
            vm.resort_fee_type = (vm.activityData.extra_attribute_type != undefined && vm.activityData.extra_attribute_type == 'flat_rate') ? false : true;
            vm.activityData.extra_attribute_value = (vm.activityData.extra_attribute_value != undefined) ? parseFloat(vm.activityData.extra_attribute_value) : 0;
            vm.activityData.extra_attribute_ota_value = (vm.activityData.extra_attribute_ota_value != undefined) ? parseFloat(vm.activityData.extra_attribute_ota_value) : 0;

            if(vm.activityData.hasOwnProperty('dynamic_attributes')){
                if(activityData.data.activityData.dynamic_attributes.length == 0 ){
                vm.activityData.dynamic_attribute = 0;
                }
            }

            if (!vm.activityData.extra_settings.price_type) {
                
                if (vm.activityData.product_price) {
                    vm.activityData.extra_settings.price_type = 'flat_rate';
                } else {
                    vm.activityData.extra_settings.price_type = 'percentage';
                }
            }

            vm.activityData.happy_hours = vm.activityData.happy_hours == 1 ? true:false;
            vm.happyHoursAmount = parseFloat(vm.activityData.happyhour_price);
            if(vm.happyHoursAmount > 0){
                vm.happyHoursPercentage = parseFloat(((vm.activityData.product_price - vm.happyHoursAmount)/vm.activityData.product_price)*100);
                vm.happyHoursPercentage =  parseFloat(commonService.roundnum(vm.happyHoursPercentage ,2));
            }        

            if(activityData.data.activityData.associate_with_pos.length == 0 ){
                vm.activityData.associate_with_other_pos = 0;
            }
            if(vm.activityData.product_pos_type.indexOf(',') != -1){
                vm.activityData.product_pos_type = vm.activityData.product_pos_type.split(',');
            }else{
                vm.activityData.product_pos_type = [vm.activityData.product_pos_type];
            }
            if(vm.activityData.hasOwnProperty('restaurant_attributes') &&  typeof vm.activityData.restaurant_attributes!='undefined'){
                if(vm.activityData.restaurant_attributes.indexOf(',') != -1){
                    vm.activityData.restaurant_attributes = vm.activityData.restaurant_attributes.split(',');
                }else{
                    vm.activityData.restaurant_attributes = [vm.activityData.restaurant_attributes];
                }
            }
            if(vm.pageType == 'Rooms'){
                vm.RoomData = activityData.data.rooms_data;
            } else {
                vm.RoomData = activityData.data.products_data;
            }
            vm.PosData = activityData.data.pos_data;
            vm.activityData.dynamicAttributes = vm.activityData.dynamic_attributes;
        }else if(activityData.status === 'error'){
            if(vm.pageType == 'Rooms'){
                $state.go('app.e-commerce.activities');
            } else {
                $state.go('app.e-commerce.boat-activities');
            }            
        }

        vm.oldTaxArray = vm.activityData.product_tax;
        if (activityComponentData.status === 'success') {
            vm.posTypes = activityComponentData.data.posTypes;
            if(vm.pageType == 'Rooms'){
                vm.posProductTypes = activityComponentData.data.posProductTypes;
                angular.forEach(vm.posProductTypes, function(value, index) {
                    if(value.showname === 'Boat'){
                        vm.posProductTypes.splice(index, 1);
                    }
                });
            } else {
                vm.posProductTypes = activityComponentData.data.posProductTypes;
                angular.forEach(vm.posProductTypes, function(value, index) {
                    if(value.showname !== 'Boat'){
                        vm.posProductTypes.splice(index, 1);
                    }
                });
            }
            vm.actTaxData = activityComponentData.data.actTaxData;
            vm.templates = activityComponentData.data.templates;
            vm.restaurantAttributes = activityComponentData.data.restaurantAttributes;
            vm.ingredientTags = activityComponentData.data.ingredients;
            vm.mytags = loadTags();
        }
        function getRoomsTypes(data){
            if(!vm.activityData.allowed_for_all_rooms){
                vm.activityData.associate_with_rooms = [];
            }
            if(data != true){     
                activityService.getRoomTypeData({'hotel_id':hotelID,'dataType':vm.pageType}).then(function(response) {
                    if(response.success){
                        vm.RoomData = response.data;
                    }else{
                        vm.RoomData = [];
                    }
                });
            }
        }

        function getPosTypes(data,product_id){
            if(vm.activityData.associate_with_other_pos){
                vm.activityData.associate_with_pos = [];
            }
            if(data == true){     
                activityService.getPosTypeData({'hotel_id':hotelID,'product_id':product_id}).then(function(response) {
                    if(response.success){
                        vm.PosData = response.data;
                    }else{
                        vm.PosData = [];
                    }
                });
            }
        }

        function loadTypesPos(posType){
            activityService.getPosTypesOnly({'posType':posType,'hotel_id':vm.hotel_id})
                .then(function(response) {
                    if(response.success){
                        vm.posTypes = response.result;
                    }else{
                        vm.posTypes = [];
                    }
             });
        }
        function addNewPosType(ev,action) {
            var allCategory = [];
            if(typeof vm.posProductTypes != 'undefined' && vm.posProductTypes.length != 0){
                vm.posProductTypes.forEach(function(element,index){
                    allCategory[index] = element['hidename'];
                });
            }
            activityService.PosTypes(allCategory,vm.hotel_id)
                .then(function(response) {
                    $mdDialog.show({
                    controller: 'PostTypeController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/e-commerce/views/activities/activity/dialog/posttype-dialog.html',
                    parent: angular.element($document.find('#content-container')),
                    targetEvent: ev,
                    scope: $scope.$new(),
                    clickOutsideToClose: true,
                    locals: {
                        dialogData: {
                            action      : action,
                            posProductTypes: vm.posProductTypes,
                            PosTypes    : response.result,
                            selectedCategory: vm.activityData.product_pos_type,
                            allCategory: vm.posProductTypes
                        }
                    }
                });
                jQuery('.sec-contact-tab').css('display', 'none');
                jQuery('.third-contact-tab').css('display', 'none');
             });
           
        }
        /**
         * imageViewer will show image in popup
         * @param ev
         */
        vm.imageViewer = function(ev, image) {
            var imageFullPath = EnvironmentConfig.api + 'assets/uploads/activities/org/' + image;
            $mdDialog.show({
                controller: 'PostypeImageController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/e-commerce/views/activities/activity/dialog/postype-image.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Image: imageFullPath
                }
            });
        }

        /************************************/
        /********* Add new Room Type ********/
        /************************************/
        vm.addActivity = function(data) {
            var saveData = angular.copy(data);
            if(vm.isResortFeeProduct) {
                saveData.extra_attribute = 'resort_fee';
                saveData.extra_attribute_type = (saveData.extra_attribute_type) ? 'percentage' : 'flat_rate';
                saveData.extra_attribute_value = saveData.product_price;
                saveData.is_ota_value_same = (saveData.is_ota_value_same) ? false : true;
                if(saveData.is_ota_value_same) {
                    saveData.extra_attribute_ota_value = saveData.extra_attribute_value;
                }
            } else if(vm.isExtraPersonProduct){
                saveData.extra_attribute = 'extra_person';
                saveData.extra_attribute_value = saveData.product_price;
            }
            saveData.hotel_id = vm.hotel_id;
            saveData.created_by_user = $localStorage.userId;
            saveData.extra_settings = JSON.stringify(
                mergeExtraSettings(saveData.extra_settings, {
                    auto_pos_comment: !!saveData.addPosComment
                })
            );
            delete saveData.addPosComment;
            saveData.images = vm.uploadedFiles;
            activityService.addActivity(saveData)
                .then(function(response) {
                    if (response.status === 'error') {

                    }
                    if(vm.pageType == 'Rooms'){
                        $state.go('app.e-commerce.activities');
                    } else {
                        $state.go('app.e-commerce.boat-activities');
                    }
                    
                });
        };

        /************************************/
        /*********** Upload Images **********/
        /************************************/
        vm.progressnum = 0;
        vm.uploadProductImages = function(files, errFiles) {
            if((files == null || files.length == 0) && errFiles.length == 0) {
                return;
            }
            if (errFiles.length > 0) {
                angular.forEach(errFiles, function(value, index) {
                    switch (value.$error) {
                        case 'pattern':
                            vm.fileError = 'FILE_TYPE_NOT_SUPPORTED';
                            break;
                        case 'maxSize':
                            vm.fileError = 'FILE_SIZE_EXCEEDS';
                            break;
                        case 'minWidth':
                            vm.fileError = 'MIN_SIZE_MESSAGE';
                            break;
                        case 'minHeight':
                            vm.fileError = 'MIN_SIZE_MESSAGE';
                            break;
                        default:
                            vm.fileError = 'COMMON_IMAGE_MESSAGE';
                    }
                    toastMessage.showSimpleToast($translate.instant('ROOM_TYPE.' + vm.fileError), 'error-toast');
                });
            }
            vm.progress = true;
            vm.progressnum = 0;
            if (vm.flag === 'add') {
                files.upload = Upload.upload({
                    url: EnvironmentConfig.api + 'Activities/product_images',
                    data: {
                        file: files,
                        mode: 'add'
                    },
                    uploadEventHandlers: { progress: function(evt){
                        if (evt.lengthComputable) {
                            vm.progressnum = Math.round(evt.loaded * 100 / evt.total)
                        } else {
                            vm.progressnum = 'unable to compute'
                        }
                        if(vm.progressnum >= 100){
                            vm.progress = false;
                            $timeout(function() {
                                vm.processing = true;
                            },100);
                        }
                    }}
                });

                files.upload.then(function(response) {
                    var loopPromises = [];
                    vm.uploadedFiles = [];
                    angular.forEach(response.data.files, function(value, index) {
                        var deferred = $q.defer();
                        loopPromises.push(deferred.promise);
                        vm.uploadedFiles.push(value);
                        deferred.resolve();
                    });
                    vm.failedFiles = typeof response.data.error != 'undefined' ? response.data.error : '';
                    $q.all(loopPromises).then(function () {
                        vm.processing = false;
                    });
                }, function(response) {
                    if (response.status > 0)
                        $scope.errorMsg = response.status + ': ' + response.data;
                });
            } else {
                files.upload = Upload.upload({
                    url: EnvironmentConfig.api + 'Activities/product_images',
                    data: {
                        file: files,
                        mode: 'edit',
                        productID: vm.activityData.product_id
                    },
                    uploadEventHandlers: { progress: function(evt){
                        if (evt.lengthComputable) {
                            vm.progressnum = Math.round(evt.loaded * 100 / evt.total)
                        } else {
                            vm.progressnum = 'unable to compute'
                        }
                        if(vm.progressnum >= 100){
                            vm.progress = false;
                            $timeout(function() {
                                vm.processing = true;
                            },100);
                        }
                    }}
                });

                files.upload.then(function(response) {
                    var loopPromises = [];
                    vm.uploadedFiles = [];
                    angular.forEach(response.data.data.files, function(value, index) {
                        var deferred = $q.defer();
                        loopPromises.push(deferred.promise);
                        vm.uploadedFiles.push(value);
                        deferred.resolve();
                    });

                    
                    vm.failedFiles = typeof response.data.error != 'undefined' ? response.data.error : '';
                    $q.all(loopPromises).then(function () {
                        vm.processing = false;
                    });
                }, function(response) {
                    if (response.status > 0)
                        $scope.errorMsg = response.status + ': ' + response.data;
                });
            }
        };

        vm.updateExtraSetting = function (key, value) {

            const payload = {};
            payload[key] = value;

            vm.saveEachField(payload, 'extra_settings');
        };

        /************************************/
        /********* Update Room type *********/
        /************************************/
        vm.saveEachField = function(value, field) {
            if(load) {
                if (field !== undefined && field === 'product_tax') {
                    var diff = $rootScope.arr_diff(value, vm.oldTaxArray);
                    if(diff.indexOf('0') > -1) {
                        vm.activityData.product_tax = ['0'];
                    } else {
                        var index = value.indexOf('0');
                        if (index > -1) {
                          value.splice(index, 1);
                        }
                        vm.activityData.product_tax = value;
                    }
                    vm.oldTaxArray = vm.activityData.product_tax;
                    value = vm.activityData.product_tax;
                }

                var extraField  = '';
                var extraValue  = '';
                if(field != undefined && value != undefined && field == 'extra_attribute_type') {
                    vm.resortFeeType = (value) ? 'Percentage' : 'Flat Rate';
                }
                
                var hotel_id = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
                    vm.isloading=true;
                    if (vm.flag == 'edit') {
                        if(field == 'allowed_for_all_rooms' && value == 1){
                            vm.associated_room_id = [];
                        }
                        if(field == 'associate_with_other_pos' && value == false){
                            vm.associated_pos_id = [];
                        } 

                        if(field == 'dynamic_attribute' && value == 1){
                            vm.activityData.dynamicAttributes =[{}];
                        }
                        if(field == 'send_external_email' && value == 1){
                            vm.activityData.external_email_receiver = '';
                            vm.activityData.external_email_template_id = 0;
                        }
                        if(field == 'extra_attribute_type') {
                            value = (value == true) ? 'percentage' : 'flat_rate';                        
                        }
                        if(field == 'resort_fee') {
                            field = 'extra_attribute';
                            value = (value == true) ? 'resort_fee' : '';                        
                        }
                        if(field == 'extra_person') {
                            field = 'extra_attribute';
                            value = (value == true) ? 'extra_person' : '';
                        }
                        if(field == 'is_ota_value_same') {
                            value = (value == true) ? false : true;
                        }
                        if(field == 'add_pos_comment') {
                            field = 'extra_settings';
                            value = {
                                auto_pos_comment: !!value
                            };
                        }
                        if(field == 'type_id' && vm.isResortFeeProduct) {
                            extraField = 'extra_attribute';
                            extraValue = 'resort_fee';
                        } else if (field == 'type_id' && vm.isExtraPersonProduct){
                            extraField = 'extra_attribute';
                            extraValue = 'extra_person';
                        } else if(field == 'type_id') {
                            extraField = 'extra_attribute';
                            extraValue = '';
                        }
                        if(field == 'product_price' && (vm.isExtraPersonProduct || vm.isResortFeeProduct) ) {
                            extraField = 'extra_attribute_value';
                            extraValue = value;
                        }


                    if (vm.reload) {
                        if(field == 'pos_display_tax_indicator' || field == 'product_is_timebound'){
                            if(value){
                                value = 1;
                            }else{
                                value = 0;
                            }
                        }

                        var newData = {
                            field: field,
                            value: value,
                            hotel_id: hotel_id,
                            productID: vm.activityData.product_id,
                            extraField : extraField,
                            extraValue : extraValue
                        };
                        
                        if((field == 'extra_attribute_value' || field =='extra_attribute_ota_value') && value == '' || value == undefined) {
                            vm.isloading = false; return false;
                        }

                        activityService.updateActivity(newData).then(function(response) {
                            vm.nameError = false;

                            if (response.status) {
                                if (response.status == 'duplicateName') {                                    
                                    //toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                                    vm.nameError = true;
                                }
                            } else {
                                toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                            }
                        });
                    }
                    vm.isloading = false;
                } else {
                    if (field == 'product_name') {
                        checkUniqueActivity();
                    }
                    vm.isloading = false;
                }
            }
        };

        vm.updateDependentFields = updateDependentFields;
        function updateDependentFields(){
            if(!vm.activityData.available_on_fe){
                        vm.activityData.allowed_for_all_rooms = true;
                        vm.activityData.associate_with_rooms = [];

            }
        }

        /************************************/
        /********* Check Room Name to be unique *********/
        /************************************/
        function checkUniqueActivity() {
            var hotel_id = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
            var data = {
                product_name: vm.activityData.product_name,
                hotel_id: hotel_id,
                product_id: ''
            };
            activityService.checkActivityName(data).then(function(response) {
                if (response.status == 'error') {
                    vm.nameError = true;
                } else {
                    vm.nameError = false;
                }
            });
        }


        /************************************/
        /***** Delete uploaded images *******/
        /************************************/
        vm.deleteUploadedImage = function(imageID, productID, filename, evt) {
            var confirm = $mdDialog.confirm()
                .htmlContent('<div class="md-padding custom-common-dailog">Are you sure, you want to delete this image?</div>')
                .title('Delete Image')
                .targetEvent(evt)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function() {
                var data = {
                    imageID: imageID,
                    productID: productID,
                    filename: filename
                };
                activityService.deleteImage(data).then(function(response) {
                    if (response.status === 'success') {
                        vm.uploadedFiles = response.files;
                    } else {
                        toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                    }
                });
            }).catch(function(e) {

            });
        };


        /************************************/
        /********* Delete images ************/
        /************************************/
        vm.deleteAddImage = function(image) {
            var obj = [];
            angular.forEach(vm.uploadedFiles, function(value, index) {
                if (value.filename === image) {
                    vm.uploadedFiles.splice(index, 1);
                    activityService.unlinkImage(value['filename']).then(function(response) {

                    });
                }
            });
        };

        /************************************/
        /********* Sorted images ************/
        /************************************/

        vm.addField = function() {
            var show_msg = false;
            angular.forEach(vm.activityData.dynamicAttributes, function(fields, key) {
                if (fields.field == '') {
                    show_msg = true;
                    toastMessage.showSimpleToast($translate.instant('POS_TYPE.ADD_FIELD_ERROR'), 'error-toast');
                }
            });
            if (!show_msg) {
                vm.activityData.dynamicAttributes.push({
                    field: '',
                    type: 'text',
                    new: ''
                });
            }

        };

            vm.deleteField = function(key, field, newField, evt) {
            if (newField === '') {
                vm.activityData.dynamicAttributes.splice(key, 1);
                return;
            }
            else {
                vm.activityData.dynamicAttributes.splice(key, 1);
                vm.saveEachField(vm.activityData.dynamicAttributes, 'dynamic_attributes')
                return;
            }
            // var confirm = $mdDialog.confirm()
            //     .title('Are you sure, you want to delete this price?')
            //     .ariaLabel('delete image')
            //     .targetEvent(evt)
            //     .ok('OK')
            //     .cancel('CANCEL');

            // $mdDialog.show(confirm).then(function() {
            //     angular.forEach(vm.giftCardData.prices, function(value, index) {
            //         if (key === index && value.new == 1) {
            //             vm.giftCardData.prices.splice(index, 1);
            //         } else {
            //             if (key === index) {
            //                 var data = {
            //                     price: price,
            //                     productID: vm.giftCardData.product_id
            //                 };
            //                 giftCardService.removePrice(data).then(function(response) {
            //                     if (response.status === 'success') {
            //                         vm.giftCardData.prices.splice(index, 1);
            //                         vm.submittedPriceCount = response.data.submittedPriceCount;
            //                     } else {
            //                         toastMessage.showSimpleToast($translate.instant('COMMON_ERROR'), 'error-toast');
            //                     }
            //                 });
            //             }
            //         }
            //     });
            // }).catch(function(e) {

            // });
        }; 

        vm.goBack = function(){
            if(vm.pageType == 'Rooms'){
                $state.go('app.e-commerce.activities');
            } else {
                $state.go('app.e-commerce.boat-activities');
            }
        }

        $scope.sortableOptions = {
            activate: function() {
            },
            beforeStop: function() {
            },
            change: function() {
            },
            create: function() {
            },
            deactivate: function() {
            },
            out: function() {
            },
            over: function() {
            },
            receive: function() {
            },
            remove: function() {
            },
            sort: function() {
            },
            start: function() {
            },
            update: function(e, ui) {
            },
            stop: function(e, ui) {
                if (vm.reload) {
                    var newSortImages = vm.uploadedFiles;
                    activityService.sortActivityImages(newSortImages).then(function(response) {
                        if (response.status === 'success') {
                            vm.nameError = true;
                        } else {
                            vm.nameError = false;
                        }
                    });
                }
            }
        };


        vm.calculateHappyHoursPrice = calculateHappyHoursPrice;
        function calculateHappyHoursPrice(type){
            if(type == 'amt'){
                vm.happyHoursPercentage = ((vm.activityData.product_price - vm.happyHoursAmount)/vm.activityData.product_price)*100;
            }else if(type == 'per'){
                vm.happyHoursAmount = vm.activityData.product_price - ((vm.activityData.product_price * vm.happyHoursPercentage)/100);
            }
            vm.happyHoursPercentage =  parseFloat(commonService.roundnum(vm.happyHoursPercentage ,2));
            vm.activityData.happyhour_price = vm.happyHoursAmount;
        }

        vm.checkIfRestaurant = function() {
                if(vm.activityData.product_pos_type.indexOf('restaurant') != -1){
                    vm.showResAtrribs = true;
                }
                else{
                    vm.showResAtrribs = false;
                }
            };   

            vm.notFound = function(key) {
            transformChip(key);
          }
          /**
           * Return the proper object when the append is called.
           */
        function transformChip(chip) {
          // If it is an object, it's already a known chip
          if (angular.isObject(chip)) {
            return {
            name: chip.name,
            type: 'old',
            id: chip.id
          };
          }

          // Otherwise, create a new one
          return {
            name: chip,
            type: 'new'
          }
        }


        /**
         * Search for mytags.
         */
        function querySearchTags(query) {
          var results = query ? vm.mytags.filter(createFilterFor(query)) : [];
          return results;
        }

        /**
         * Create filter function for a query string
         */
        function createFilterFor(query) {
          var lowercaseQuery = angular.lowercase(query);

          return function filterFn(vegetable) {
            return (vegetable._lowername.indexOf(lowercaseQuery) === 0) ;
          };

        }

        function loadTags() {
          var getTags = vm.ingredientTags;//[];//ModalData['tags']
          return getTags.map(function(veg) {
            veg._lowername = veg.name.toLowerCase();
            return veg;
          });
        }
        /*For tags end*/

        /************************************/
        /********* Update product ingredients ********/
        /************************************/
        vm.updateIngredients = function() {
            if(vm.flag == 'edit'){
                vm.saveEachField(vm.activityData.selectedTags,'selectedTags')
            }
            return;
        };    
        
        /*
        ** On change of product type
        */
        vm.onChangeProductType = function(value, field) {
            vm.resortFeeTypeId = 0;
            vm.extraPersonTypeId = 0;
            vm.orginalSelectedTypeIds = vm.last_type_ids;
            vm.productTypeError = false;
            if(vm.posTypes.retail != undefined ) {
                angular.forEach(vm.posTypes.retail, function(type, index) {
                    if(type.pos_type_name == "Resort Fee") {
                        vm.resortFeeTypeId = type.pos_type_id;
                    }
                    if(type.pos_type_name == "Extra Person") {
                        vm.extraPersonTypeId = type.pos_type_id;
                    }
                });
                if( (vm.last_type_ids.indexOf(vm.resortFeeTypeId) >= 0 || vm.last_type_ids.indexOf(vm.extraPersonTypeId) >= 0) && value.length > 1 ) {
                    var newIds = vm.differenceOf2Arrays(vm.last_type_ids, value);
                    vm.activityData.type_id = [];
                    angular.forEach(newIds, function(newId, i) {
                        vm.activityData.type_id.push(newId.toString());                        
                    });
                    vm.isExtraPersonProduct = false;
                    vm.isResortFeeProduct = false;
                    if(vm.activityData.type_id.indexOf(vm.resortFeeTypeId) >= 0) {
                        vm.isResortFeeProduct = true;
                    }
                    if(vm.activityData.type_id.indexOf(vm.extraPersonTypeId) >= 0) {
                        vm.isExtraPersonProduct = true;
                    }
                } else if(value.indexOf(vm.resortFeeTypeId) >= 0) {
                    vm.activityData.type_id = [];
                    vm.activityData.type_id.push(vm.resortFeeTypeId.toString());
                    vm.isResortFeeProduct = true;
                    vm.isExtraPersonProduct = false;
                }  else if(value.indexOf(vm.extraPersonTypeId) >= 0) {
                    vm.isExtraPersonProduct = true;
                    vm.isResortFeeProduct = false;
                    vm.activityData.type_id = [];
                    vm.activityData.type_id.push(vm.extraPersonTypeId.toString());
                } else if (value.length == 0) {
                    vm.isExtraPersonProduct = false;
                    vm.isResortFeeProduct = false;
                } else {
                    vm.isExtraPersonProduct = false;
                    vm.isResortFeeProduct = false;
                }
                vm.last_type_ids = vm.activityData.type_id;
            }

            if((vm.isResortFeeProduct || vm.isExtraPersonProduct) && vm.reload && field == 'type_id') {
                var productType = '';
                if(vm.isResortFeeProduct) {
                    productType = 'resort_fee';
                    vm.productTypeName = 'Resort fee';
                } else if(vm.isExtraPersonProduct) {
                    productType = 'extra_person';
                    vm.productTypeName = 'Extra person';
                }
                var hotel_id = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
                var data = {
                    productType : productType,
                    hotel_id    : hotel_id
                };
                if(productType != '') {
                    activityService.checkActivityType(data).then(function(response) {
                        if (response.status == 'product_type_dont_exist' && vm.flag == 'edit' && !$scope.activityForm.$invalid) {
                            vm.saveEachField(vm.activityData.type_id, field);
                            vm.productTypeError = false;
                        } else if(response.status == 'product_type_exist'){
                            vm.productTypeError = true;
                            vm.activityData.type_id = vm.orginalSelectedTypeIds;
                            vm.last_type_ids = vm.orginalSelectedTypeIds;
                            vm.isExtraPersonProduct = false;
                            vm.isResortFeeProduct = false;
                        }
                    });
                }
            } else if(vm.flag == 'edit' && !$scope.activityForm.$invalid && vm.reload){
                vm.saveEachField(vm.activityData.type_id, field);
                // vm.productTypeError = false;
            }
        }

        /*
        ** To get the difference of 2 arrays
        */
        vm.differenceOf2Arrays = function(array1, array2) {
            var temp = [];
            array1 = array1.toString().split(',').map(Number);
            array2 = array2.toString().split(',').map(Number);

            for (var i in array1) {
                if(array2.indexOf(array1[i]) === -1) { temp.push(array1[i]); }
            }
            for(i in array2) {
                if(array1.indexOf(array2[i]) === -1) { temp.push(array2[i]); }
            }
            return temp.sort(function(a,b) { return a-b });
        }

        angular.element(function () {
            $timeout(function() {
               load = true;
            }, 400);
        });  

        setTimeout(function() {
           vm.autoFillOff = false;
        }, 1500);       
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.dashboards.modified-gantt-chart',
            [
                // 3rd Party Dependencies
                'gantt',
                'gantt.sortable',
                'gantt.movable',
                'gantt.drawtask',
                'gantt.tooltips',
                'gantt.bounds',
                'gantt.progress',
                'gantt.table',
                'gantt.tree',
                'gantt.groups',
                'gantt.dependencies',
                'gantt.overlap',
                'gantt.resizeSensor'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider){

        $stateProvider.state('app.newGanttChart', {
            url    : '/hotelchart',
            title  : 'Tape Chart',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/modified-gantt-chart/gantt-chart.html',
                    controller : 'NewGanttChartController as vm'
                }
            },
            resolve: {
                ganttData: function ($localStorage,ganttChartServiceNew,$sessionStorage){
                    var data = {};
                    var hotel_id = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
                    if(typeof $sessionStorage[hotel_id] != 'undefined' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_from') && $sessionStorage[hotel_id]['gantt_chart_from'] != '' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_to') && $sessionStorage[hotel_id]['gantt_chart_to'] != '' ){
                        data = {
                                    start:$sessionStorage[hotel_id]['gantt_chart_from'],
                                    end:$sessionStorage[hotel_id]['gantt_chart_to'],
                                    requestFor: 'room'
                        };
                    }

                    var roomsExpanded = [];
                    if (typeof $localStorage[hotel_id+'_condos_expanded'] != 'undefined') {
                        angular.forEach($localStorage[hotel_id+'_condos_expanded'], function(value, key) {
                            roomsExpanded.push(value);
                        });
                    } 
                    data['requestFor'] = 'room';
                    data['newChart'] = true;
                    data['roomTypes'] = 'condos';
                    data['hotelId'] = hotel_id;
                    data['roomsExpanded'] = roomsExpanded;
                    return ganttChartServiceNew.getGanttData(data);
                },
                requestFor: function(){
                    return 'room';
                }
            },
            permission: 'tape_chart'
        }).state('app.villasGanttChart', {
            url    : '/villaschart',
            title  : 'Tape Chart',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/modified-gantt-chart/gantt-chart.html',
                    controller : 'NewGanttChartController as vm'
                }
            },
            resolve: {
                ganttData: function ($localStorage,ganttChartServiceNew,$sessionStorage){
                    var data = {};
                    var hotel_id = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
                    if(typeof $sessionStorage[hotel_id] != 'undefined' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_from') && $sessionStorage[hotel_id]['gantt_chart_from'] != '' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_to') && $sessionStorage[hotel_id]['gantt_chart_to'] != '' ){
                        data = {
                                    start:$sessionStorage[hotel_id]['gantt_chart_from'],
                                    end:$sessionStorage[hotel_id]['gantt_chart_to'],
                                    requestFor: 'room'
                                };
                    }

                    var roomsExpanded = [];
                    if (typeof $localStorage[hotel_id+'_villas_expanded'] != 'undefined') {
                        angular.forEach($localStorage[hotel_id+'_villas_expanded'], function(value, key) {
                            roomsExpanded.push(value);
                        });
                    }
                    data['requestFor'] = 'room';
                    data['newChart'] = true;
                    data['roomTypes'] = 'villas';
                    data['hotelId'] = hotel_id;
                    data['roomsExpanded'] = roomsExpanded;
                    return ganttChartServiceNew.getGanttData(data);
                },
                requestFor: function(){
                    return 'room';
                }
            },
            permission: 'tape_chart'
        }).state('app.boat_gannChartNew', {
            url    : '/marinachart',
            title  : 'Marina Tape Chart',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/modified-gantt-chart/gantt-chart.html',
                    controller : 'NewGanttChartController as vm'
                }
            },
            resolve: {
                ganttData: function ($localStorage,ganttChartServiceNew,$sessionStorage){
                    var data = {};
                    var hotel_id = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];

                    if (typeof $localStorage['boatFilterDefaultType'] == 'undefined' || $localStorage['boatFilterDefaultType'] == null) {
                        $localStorage['boatFilterDefaultType'] = 'month';
                        $localStorage['boatFilterType'] = 'month';
                    }

                    var boatDispType = typeof $localStorage['boatFilterType'] != 'undefined' ? $localStorage['boatFilterType'] : 'month';
                    if (boatDispType == 'year') { // year is removed from dropdown list
                        boatDispType = 'quarter';
                    }
                    // if(typeof $sessionStorage[hotel_id] != 'undefined' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_from') && $sessionStorage[hotel_id]['gantt_chart_from'] != '' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_to') && $sessionStorage[hotel_id]['gantt_chart_to'] != '' ){
                    if(typeof $sessionStorage['boat'] != 'undefined' && $sessionStorage['boat'].hasOwnProperty('gantt_chart_from') && $sessionStorage['boat']['gantt_chart_from'] != '' && $sessionStorage['boat'].hasOwnProperty('gantt_chart_to') && $sessionStorage['boat']['gantt_chart_to'] != '' ){
                        data = {
                                    start:$sessionStorage['boat']['gantt_chart_from'],
                                    end:$sessionStorage['boat']['gantt_chart_to'],
                                    requestFor: 'boat'
                                };
                    }

                    var roomsExpanded = [];
                    if (typeof $localStorage[hotel_id+'_boat_expanded'] != 'undefined') {
                        angular.forEach($localStorage[hotel_id+'_boat_expanded'], function(value, key) {
                            roomsExpanded.push(value);
                        });
                    }
                    data['requestFor'] = 'boat';
                    data['roomTypes'] = 'boat';
                    data['newChart'] = true;
                    data['boatDispType'] = boatDispType;
                    data['hotelId'] = hotel_id;
                    data['roomsExpanded'] = roomsExpanded;
                    return ganttChartServiceNew.getGanttData(data);
                },
                requestFor: function(){
                    return 'boat';
                }
            },
            permission: 'boats'
        }).state('app.rentGanttchartNew', {
            url    : '/residencechart',
            title  : 'Residence Tape Chart',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/modified-gantt-chart/gantt-chart.html',
                    controller : 'NewGanttChartController as vm'
                }
            },
            resolve: {
                ganttData: function ($localStorage,ganttChartServiceNew,$sessionStorage){
                    var data = {};
                    var hotel_id = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
                    if (typeof $localStorage['rentFilterDefaultType'] == 'undefined' || $localStorage['rentFilterDefaultType'] == null) {
                        $localStorage['rentFilterDefaultType'] = 'month';
                        $localStorage['rentFilterType'] = 'month';
                    }

                    var rentDispType = typeof $localStorage['rentFilterType'] != 'undefined' ? $localStorage['rentFilterType'] : 'month';
                    
                    if(typeof $sessionStorage[hotel_id] != 'undefined' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_from') && $sessionStorage[hotel_id]['gantt_chart_from'] != '' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_to') && $sessionStorage[hotel_id]['gantt_chart_to'] != '' ){
                        data = {
                                    start:$sessionStorage[hotel_id]['gantt_chart_from'],
                                    end:$sessionStorage[hotel_id]['gantt_chart_to'],
                                    requestFor: 'rent'
                                };
                    }
                    data['requestFor'] = 'rent';
                    data['rentDispType'] = rentDispType;
                    data['hotelId'] = hotel_id;
                    return ganttChartServiceNew.getGanttData(data);
                },
                requestFor: function(){
                    return 'rent';
                }
            },
            permission: 'boats'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/dashboards/modified-gantt-chart');
    }

})();

(function () {

    'use strict';

    angular
        .module('app.dashboards.modified-gantt-chart')
        .controller(
            'BorrowedItemsController',
            BorrowedItemsController
        );

    /** @ngInject */
    function BorrowedItemsController(
        $mdDialog,
        $q,
        value,
        dashboardGraphService,
        toastMessage
    ) {

        var vm = this;

        vm.value = value;
        vm.isSaving = false;
        vm.isLoading = true;
        vm.addingProductId = null;
        vm.items = [];
        vm.originalItems = [];
        vm.orderChanged = false;

        loadBorrowedItems();

        function getRemaining(item) {
            var borrowed = parseInt(item.borrowed, 10) || 0;
            var returned = parseInt(item.returned, 10) || 0;
            var purchased = parseInt(item.purchased, 10) || 0;
            return Math.max(0, borrowed - returned - purchased);
        }

        function normalizeSavedEntry(entry) {
            var borrowed = 0;
            var returned = 0;
            var purchased = 0;

            if (entry) {
                if (angular.isDefined(entry.borrowed)) {
                    borrowed = parseInt(entry.borrowed, 10) || 0;
                } else if (angular.isDefined(entry.quantity)) {
                    borrowed = parseInt(entry.quantity, 10) || 0;
                }
                returned = parseInt(entry.returned, 10) || 0;
                if (angular.isDefined(entry.purchased)) {
                    purchased = parseInt(entry.purchased, 10) || 0;
                } else if (angular.isDefined(entry.charged)) {
                    purchased = parseInt(entry.charged, 10) || 0;
                }
            }

            if (returned > borrowed) {
                returned = borrowed;
            }
            if ((returned + purchased) > borrowed) {
                purchased = Math.max(0, borrowed - returned);
            }

            return {
                borrowed: borrowed,
                returned: returned,
                purchased: purchased,
                remaining: Math.max(0, borrowed - returned - purchased)
            };
        }

        function syncItemsFromResponse(res) {
            var savedByProductId = {};
        
            angular.forEach(res.borrowed_item || [], function (entry) {
                if (entry && entry.product_id) {
                    savedByProductId[String(entry.product_id)] =
                        normalizeSavedEntry(entry);
                }
            });
        
            vm.items = (res.products || []).map(function (product) {
        
                var productId = String(product.product_id);
        
                var saved = savedByProductId[productId] || {
                    borrowed: 0,
                    returned: 0,
                    purchased: 0,
                    remaining: 0
                };


                var images = product.images || [];
                var isDefaultImage = !(images.length > 0 && images[0].url);

                var productImage = isDefaultImage
                    ? 'assets/angular-material-assets/img/icons/defaultpos.png'
                    : images[0].url;

                return {
                    product_id: parseInt(product.product_id, 10),
                    name: product.product_name,
                    image: productImage,
                    isDefaultImage: isDefaultImage,
                    images: images,
                    key: 'product_' + productId,
        
                    borrowed: saved.borrowed,
                    returned: saved.returned,
                    purchased: saved.purchased,
                    remaining: saved.remaining
                };
            });
        
            vm.originalItems = angular.copy(vm.items);
        
            if (angular.isDefined(res.borrowed_count)) {
                value.borrowed_count =
                    parseInt(res.borrowed_count, 10) || 0;
            }
        
            if (angular.isDefined(res.borrowed_item)) {
                value.borrowed_item = res.borrowed_item;
            }
        }

        function loadBorrowedItems() {
            vm.isLoading = true;

            return dashboardGraphService.getBorrowedItems({
                confirmation_number: value.confirmation_number
            }).then(function (res) {
                vm.isLoading = false;

                // Empty product list is valid — show in-dialog message, not error toast.
                if (!res || !res.success) {
                    vm.items = [];
                    vm.originalItems = [];
                    return res;
                }

                syncItemsFromResponse(res);
                return res;
            }, function () {
                vm.isLoading = false;
                vm.items = [];
                vm.originalItems = [];
                return null;
            });
        }

        function saveBorrowedCounts() {
            var borrowedItem = vm.items
                .filter(function (item) {
                    return (parseInt(item.borrowed, 10) || 0) > 0;
                })
                .map(function (item) {
                    var borrowed = parseInt(item.borrowed, 10) || 0;
                    var returned = parseInt(item.returned, 10) || 0;
                    var purchased = parseInt(item.purchased, 10) || 0;
                    if (returned > borrowed) {
                        returned = borrowed;
                    }
                    if ((returned + purchased) > borrowed) {
                        purchased = Math.max(0, borrowed - returned);
                    }
                    return {
                        product_id: item.product_id,
                        borrowed: borrowed,
                        returned: returned,
                        purchased: purchased
                    };
                });

            return dashboardGraphService.updateBorrowedItems({
                confirmation_number: value.confirmation_number,
                borrowed_item: borrowedItem
            }).then(function (res) {
                if (!res || !res.success) {
                    return $q.reject(res);
                }

                value.borrowed_item = res.borrowed_item;
                value.borrowed_count = parseInt(res.borrowed_count, 10) || 0;
                vm.originalItems = angular.copy(vm.items);
                return res;
            });
        }

        // + lends more, - marks one as returned
        vm.changeCount = function (item, change) {
            if (!item || vm.addingProductId) {
                return;
            }

            if (change > 0) {
                item.borrowed = (parseInt(item.borrowed, 10) || 0) + change;
            } else if (change < 0) {
                if (getRemaining(item) <= 0) {
                    return;
                }
                item.returned = (parseInt(item.returned, 10) || 0) + Math.abs(change);
            }

            if (item.returned > item.borrowed) {
                item.returned = item.borrowed;
            }
            if ((item.returned + (parseInt(item.purchased, 10) || 0)) > item.borrowed) {
                item.returned = Math.max(
                    0,
                    (parseInt(item.borrowed, 10) || 0) - (parseInt(item.purchased, 10) || 0)
                );
            }

            item.remaining = getRemaining(item);
        };

        vm.hasChanges = function () {
            if (!vm.items.length || vm.items.length !== vm.originalItems.length) {
                return false;
            }

            return vm.items.some(function (item, index) {
                var original = vm.originalItems[index];
                return item.borrowed !== original.borrowed ||
                    item.returned !== original.returned;
            });
        };

        vm.addToReservation = function (item) {
            if (!item || vm.addingProductId || vm.isSaving) {
                return;
            }

            var quantity = getRemaining(item);
            if (quantity <= 0) {
                return;
            }

            vm.addingProductId = item.product_id;

            var prepare = vm.hasChanges()
                ? saveBorrowedCounts()
                : $q.when({ success: true });

            prepare
                .then(function () {
                    // FE only: confirmation_number, product_id, quantity
                    // Server validates max remaining and creates POS charge
                    return dashboardGraphService.addBorrowedItemToReservation({
                        confirmation_number: value.confirmation_number,
                        product_id: item.product_id,
                        quantity: quantity
                    });
                })
                .then(function (res) {
                    if (!res || !res.success) {
                        return $q.reject(res);
                    }

                    vm.orderChanged = true;

                    // Close so parent can refresh reservation details.
                    $mdDialog.hide({
                        changed: true,
                        orderChanged: true,
                        borrowed_item: res.borrowed_item,
                        borrowed_count: res.borrowed_count
                    });
                })
                .catch(function (err) {
                    vm.addingProductId = null;
                    if (err && err.errorMsg) {
                        toastMessage.showSimpleToast(err.errorMsg, 'error-toast');
                    }
                });
        };

        function closeDialog(changed) {
            if (changed || vm.orderChanged) {
                $mdDialog.hide({
                    changed: true,
                    orderChanged: vm.orderChanged,
                    borrowed_item: value.borrowed_item,
                    borrowed_count: value.borrowed_count
                });
                return;
            }
            $mdDialog.cancel();
        }

        vm.ok = function () {
            closeDialog(false);
        };

        vm.save = function () {
            if (vm.isSaving || !vm.hasChanges() || vm.addingProductId) {
                return;
            }

            vm.isSaving = true;

            saveBorrowedCounts()
                .then(function () {
                    vm.isSaving = false;
                    closeDialog(true);
                })
                .catch(function (err) {
                    vm.isSaving = false;
                    toastMessage.showSimpleToast(
                        (err && err.errorMsg) || 'Unable to update borrowed items',
                        'error-toast'
                    );
                });
        };

        vm.cancel = function () {
            closeDialog(false);
        };

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.gantt-chart',
            [
                // 3rd Party Dependencies
                'gantt',
                'gantt.sortable',
                'gantt.movable',
                'gantt.drawtask',
                'gantt.tooltips',
                'gantt.bounds',
                'gantt.progress',
                'gantt.table',
                'gantt.tree',
                'gantt.groups',
                'gantt.dependencies',
                'gantt.overlap',
                'gantt.resizeSensor'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider){

         $stateProvider.state('app.dashboards_project', {
            url    : '/gantt-chart',
            title  : 'Tape Chart',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/gantt-chart/gantt-chart.html',
                    controller : 'GanttChartController as vm'
                }
            },
            resolve: {
                ganttData: function ($localStorage,ganttChartService,$sessionStorage){
                    var data = {};
                    var hotel_id = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
                    if(typeof $sessionStorage[hotel_id] != 'undefined' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_from') && $sessionStorage[hotel_id]['gantt_chart_from'] != '' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_to') && $sessionStorage[hotel_id]['gantt_chart_to'] != '' ){
                        data = {
                                    start:$sessionStorage[hotel_id]['gantt_chart_from'],
                                    end:$sessionStorage[hotel_id]['gantt_chart_to'],
                                    requestFor : 'room'
                                };

                    }
                     data['requestFor'] = 'room';
                    return ganttChartService.getGanttData(data);
                },
                requestFor: function(){
                    return 'room';
                }
            },
            permission: 'tape_chart'
        }).state('app.boat_gannChart', {
            url    : '/boat-gantt-chart',
            title  : 'Marina Tape Chart',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/gantt-chart/gantt-chart.html',
                    controller : 'GanttChartController as vm'
                }
            },
            resolve: {
                ganttData: function ($localStorage,ganttChartService,$sessionStorage){
                    var data = {};
                    var hotel_id = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
                    if(typeof $sessionStorage[hotel_id] != 'undefined' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_from') && $sessionStorage[hotel_id]['gantt_chart_from'] != '' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_to') && $sessionStorage[hotel_id]['gantt_chart_to'] != '' ){
                        data = {
                                    start:$sessionStorage[hotel_id]['gantt_chart_from'],
                                    end:$sessionStorage[hotel_id]['gantt_chart_to'],
                                    requestFor: 'boat'
                                };
                    }
                    data['requestFor'] = 'boat';
                    return ganttChartService.getGanttData(data);
                },
                requestFor: function(){
                    return 'boat';
                }
            },
            permission: 'boats'
        }).state('app.rentGanttchart', {
            url    : '/rent-gantt-chart',
            title  : 'Residence Tape Chart',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/gantt-chart/gantt-chart.html',
                    controller : 'GanttChartController as vm'
                }
            },
            resolve: {
                ganttData: function ($localStorage,ganttChartService,$sessionStorage){
                    var data = {};
                    var hotel_id = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
                    if(typeof $sessionStorage[hotel_id] != 'undefined' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_from') && $sessionStorage[hotel_id]['gantt_chart_from'] != '' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_to') && $sessionStorage[hotel_id]['gantt_chart_to'] != '' ){
                        data = {
                                    start:$sessionStorage[hotel_id]['gantt_chart_from'],
                                    end:$sessionStorage[hotel_id]['gantt_chart_to'],
                                    requestFor: 'rent'
                                };
                    }
                    data['requestFor'] = 'rent';
                    return ganttChartService.getGanttData(data);
				},
                requestFor: function(){
                    return 'rent';
                }
            },
            permission: 'boats'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/dashboards/gantt-chart');
    }

})();

(function ()
{
    'use strict';

    angular.module('app.dashboards.gantt-chart')
        .controller('GanttChartEditDialogController', GanttChartEditDialogController);

    /** @ngInject */
    function GanttChartEditDialogController($mdDialog, $rootScope, dialogData, toastMessage, ganttChartService)
    {
        var vm = this;

        // Data
		vm.orderModifying = dialogData.formData;
		vm.currentTask = dialogData.currentTask;
		console.log("orderModifying", vm.orderModifying);
		vm.is_walk = parseInt(vm.currentTask.row.model.is_walk);
		vm.orderModifying.new_room_stay_from 	= moment(vm.orderModifying.new_room_stay_from).format('MM/DD/YYYY');
		vm.orderModifying.new_room_stay_to 		= moment(vm.orderModifying.new_room_stay_to).format('MM/DD/YYYY');
		vm.isloading = false;

		// Methods
		vm.saveReservation = saveReservation;
		vm.reloadGantt = reloadGantt;
		vm.closeDialog = closeDialog;

		function saveReservation(){
			vm.isloading = true;
			var isDatesChanged = (vm.orderModifying.new_room_stay_from != vm.orderModifying.old_room_stay_from) || (vm.orderModifying.new_room_stay_to != vm.orderModifying.old_room_stay_to);
			var isRoomChanged = (vm.orderModifying.new_product_name != vm.orderModifying.old_product_name);

			if (isDatesChanged && isRoomChanged) {
				var order_history_comment = 'BOTH';
				var changed_type = 'Room and dates were';
			} else if (isDatesChanged) {
				var order_history_comment = 'DATES';
				var changed_type = 'Dates were';
			} else {
				var order_history_comment = 'ROOM';
				var changed_type = 'Room was';
			}
			var data = {'product_id':vm.orderModifying.new_product_id,'product_name':vm.orderModifying.new_product_name,'room_stay_from':vm.orderModifying.new_room_stay_from,'room_stay_to':vm.orderModifying.new_room_stay_to,'confirmation_number':vm.orderModifying.confirmation_number,'keepSameRates':vm.keepSameRates,'location':'dashboard',order_history_comment:order_history_comment,changed_type:changed_type, 'oldData' : vm.orderModifying};
			ganttChartService.saveModifiedReservation(data).then(function(response){
				vm.isloading = false;
				if(response.success){
					$rootScope.$broadcast('done_modification', {productId : vm.orderModifying.new_product_id});
				} else {
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					$rootScope.$broadcast('cancel_modification', {productId : vm.orderModifying.new_product_id});
				}
				vm.closeDialog();
			});
		}

		function reloadGantt() {
			$rootScope.$broadcast('cancel_modification', {productId : vm.orderModifying.new_product_id});
		}

        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_theme-colors', {
            url      : '/ui/theme-colors',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/theme-colors/theme-colors.html',
                    controller : 'ThemeColorsController as vm'
                }
            },
            bodyClass: 'theme-colors'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors')
        .controller('CustomThemeDialogController', CustomThemeDialogController);

    /** @ngInject */
    function CustomThemeDialogController(fuseTheming, $mdDialog, fuseGenerator, $cookies, $window)
    {
        // Data
        var vm = this;
        vm.palettes = fuseTheming.getRegisteredPalettes();
        vm.themes = fuseTheming.getRegisteredThemes();

        // Delete Unnecessary hue value
        delete vm.palettes.grey['1000'];

        // Methods
        vm.rgba = fuseGenerator.rgba;
        vm.setTheme = setTheme;
        vm.closeDialog = closeDialog;

        //////////

        // If custom theme exist keep using it otherwise set default as a custom
        if ( !vm.themes.custom )
        {
            vm.theme = angular.copy(vm.themes['default'].colors);
        }
        else
        {
            vm.theme = vm.themes.custom.colors;
        }

        /**
         * Put custom theme into the cookies
         * and reload for generate styles
         */
        function setTheme()
        {
            $cookies.putObject('customTheme', vm.theme);
            $cookies.put('selectedTheme', 'custom');
            $window.location.reload();
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.tabbed', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_tabbed', {
            url  : '/ui/page-layouts/simple/tabbed',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/tabbed/tabbed.html',
                    controller : 'SimpleTabbedController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.tabbed')
        .controller('SimpleTabbedController', SimpleTabbedController);

    /** @ngInject */
    function SimpleTabbedController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-iii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav-iii', {
            url  : '/ui/page-layouts/simple/right-sidenav-iii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav-iii/right-sidenav-iii.html',
                    controller : 'SimpleRightSidenavIIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-iii')
        .controller('SimpleRightSidenavIIIController', SimpleRightSidenavIIIController);

    /** @ngInject */
    function SimpleRightSidenavIIIController($mdSidenav)
    {

        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav-ii', {
            url  : '/ui/page-layouts/simple/right-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav-ii/right-sidenav-ii.html',
                    controller : 'SimpleRightSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-ii')
        .controller('SimpleRightSidenavIIController', SimpleRightSidenavIIController);

    /** @ngInject */
    function SimpleRightSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav', {
            url  : '/ui/page-layouts/simple/right-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav/right-sidenav.html',
                    controller : 'SimpleRightSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav')
        .controller('SimpleRightSidenavController', SimpleRightSidenavController);

    /** @ngInject */
    function SimpleRightSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-iii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav-iii', {
            url  : '/ui/page-layouts/simple/left-sidenav-iii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav-iii/left-sidenav-iii.html',
                    controller : 'SimpleLeftSidenavIIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-iii')
        .controller('SimpleLeftSidenavIIIController', SimpleLeftSidenavIIIController);

    /** @ngInject */
    function SimpleLeftSidenavIIIController($mdSidenav)
    {

        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav-ii', {
            url  : '/ui/page-layouts/simple/left-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav-ii/left-sidenav-ii.html',
                    controller : 'SimpleLeftSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-ii')
        .controller('SimpleLeftSidenavIIController', SimpleLeftSidenavIIController);

    /** @ngInject */
    function SimpleLeftSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav', {
            url  : '/ui/page-layouts/simple/left-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav/left-sidenav.html',
                    controller : 'SimpleLeftSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav')
        .controller('SimpleLeftSidenavController', SimpleLeftSidenavController);

    /** @ngInject */
    function SimpleLeftSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.fullwidth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_fullwidth', {
            url  : '/ui/page-layouts/simple/fullwidth',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/fullwidth/fullwidth.html',
                    controller : 'SimpleFullwidthController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.fullwidth')
        .controller('SimpleFullwidthController', SimpleFullwidthController);

    /** @ngInject */
    function SimpleFullwidthController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_right-sidenav-ii', {
            url  : '/ui/page-layouts/carded/right-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/right-sidenav-ii/right-sidenav-ii.html',
                    controller : 'CardedRightSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav-ii')
        .controller('CardedRightSidenavIIController', CardedRightSidenavIIController);

    /** @ngInject */
    function CardedRightSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_right-sidenav', {
            url  : '/ui/page-layouts/carded/right-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/right-sidenav/right-sidenav.html',
                    controller : 'CardedRightSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav')
        .controller('CardedRightSidenavController', CardedRightSidenavController);

    /** @ngInject */
    function CardedRightSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_left-sidenav-ii', {
            url  : '/ui/page-layouts/carded/left-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/left-sidenav-ii/left-sidenav-ii.html',
                    controller : 'CardedLeftSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav-ii')
        .controller('CardedLeftSidenavIIController', CardedLeftSidenavIIController);

    /** @ngInject */
    function CardedLeftSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_left-sidenav', {
            url  : '/ui/page-layouts/carded/left-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/left-sidenav/left-sidenav.html',
                    controller : 'CardedLeftSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav')
        .controller('CardedLeftSidenavController', CardedLeftSidenavController);

    /** @ngInject */
    function CardedLeftSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_fullwidth', {
            url  : '/ui/page-layouts/carded/fullwidth',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/fullwidth/fullwidth.html',
                    controller : 'CardedFullwidthController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth')
        .controller('CardedFullwidthController', CardedFullwidthController);

    /** @ngInject */
    function CardedFullwidthController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_fullwidth-ii', {
            url  : '/ui/page-layouts/carded/fullwidth-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/fullwidth-ii/fullwidth-ii.html',
                    controller : 'CardedFullwidthIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth-ii')
        .controller('CardedFullwidthIIController', CardedFullwidthIIController);

    /** @ngInject */
    function CardedFullwidthIIController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.todo',
            [
                // 3rd Party Dependencies
                'ng-sortable',
                'textAngular'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.to-do', {
            url      : '/to-do/?:param',
            title    : 'Todo',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/todo/todo.html',
                    controller : 'TodoController as vm'
                }
            },
            params:      {showaddDialog:''},
            resolve  : {
                toDoTasks: function (todoService, $stateParams){
                        var qstr = "";
                        if ($stateParams.param != undefined) {
                            qstr = "?"+$stateParams.param;
                        }
                        return todoService.getAllTasks(qstr);
                    }
            },
            permission: 'tasks',
            bodyClass: 'todo'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/todo');
    }

})();

(function () {
    'use strict';

    angular
        .module('app.todo')
        .controller('TaskLogsDialogController', TaskLogsDialogController);

    /** @ngInject */
    function TaskLogsDialogController($mdDialog, todoService, taskId, taskMeta) {
        var vm = this;
        vm.loading = true;
        vm.logs = [];
        vm.activity = [];
        vm.workflow = [];
        vm.doneCount = 0;
        vm.taskTitle = '';
        vm.task = {};

        var shortLabels = {
            created: 'Created',
            assigned: 'Assigned',
            started: 'Started',
            finished: 'Finished',
            inspected: 'Inspected'
        };

        if (taskMeta) {
            var roomLabel = '';
            if (taskMeta.product_room_number) {
                if (angular.isArray(taskMeta.product_room_number)) {
                    roomLabel = taskMeta.product_room_number.join(', ');
                } else {
                    roomLabel = taskMeta.product_room_number;
                }
            }
            vm.taskTitle = (roomLabel ? ('Room ' + roomLabel + ' · ') : '') + (taskMeta.task_title || '');
        }

        function formatDateTime(value) {
            if (!value || value === '0000-00-00 00:00:00') {
                return '';
            }
            var date = new Date(String(value).replace(/-/g, '/'));
            if (isNaN(date.getTime())) {
                return value;
            }
            var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            return months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear() + ' ' + hours + ':' + minutes + ' ' + ampm;
        }

        function getInitials(name) {
            var parts = String(name || '').trim().split(/\s+/).filter(Boolean);
            if (!parts.length) {
                return '';
            }
            if (parts.length === 1) {
                return parts[0].charAt(0).toUpperCase();
            }
            return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
        }

        function loadLogs() {
            vm.loading = true;
            todoService.getTaskLogs(taskId).then(function (response) {
                vm.loading = false;
                if (!response || !response.success) {
                    vm.logs = [];
                    vm.activity = [];
                    vm.workflow = [];
                    vm.doneCount = 0;
                    return;
                }
                vm.task = response.task || {};
                if (!vm.taskTitle && vm.task.task_title) {
                    var room = vm.task.product_room_number || '';
                    vm.taskTitle = (room ? ('Room ' + room + ' · ') : '') + vm.task.task_title;
                }

                var lastDoneIndex = -1;
                vm.workflow = (response.workflow || []).map(function (step, index) {
                    var done = !!step.done;
                    if (done) {
                        lastDoneIndex = index;
                    }
                    return angular.extend({}, step, {
                        shortLabel: step.shortLabel || shortLabels[step.key] || step.label,
                        displayAt: formatDateTime(step.at),
                        isCurrent: false
                    });
                });
                if (lastDoneIndex > -1 && vm.workflow[lastDoneIndex]) {
                    vm.workflow[lastDoneIndex].isCurrent = true;
                }
                vm.doneCount = vm.workflow.filter(function (step) {
                    return step.done;
                }).length;

                var sourceActivity = response.activity && response.activity.length
                    ? response.activity
                    : (response.logs || []);

                vm.activity = sourceActivity.map(function (item) {
                    var createdBy = (item.created_by_name || '').replace(/\s+/g, ' ').trim();
                    return {
                        data: item.data || '',
                        displayAt: formatDateTime(item.created_date),
                        createdByLabel: createdBy,
                        createdByInitials: getInitials(createdBy),
                        type: item.type || 'log'
                    };
                });
                vm.logs = vm.activity;
            }, function () {
                vm.loading = false;
                vm.logs = [];
                vm.activity = [];
                vm.workflow = [];
                vm.doneCount = 0;
            });
        }

        vm.closeDialog = function () {
            $mdDialog.hide();
        };

        loadLogs();
    }
})();

(function() {
    'use strict';

    angular
        .module('app.todo')
        .controller('TaskDialogController', TaskDialogController);

    /** @ngInject */
    function TaskDialogController($mdDialog, Task, Tasks, event, $q, $timeout,ModalData, task_category, todoService, $rootScope, $scope) {
        var vm = this;

        // Data
        vm.title = 'Edit Task';
        vm.pageStatus = 'edit';
        vm.task = angular.copy(Task);

        vm.comments = [];
       
        vm.type = '';
        vm.selectedUserId = '';
        vm.subType = '';
        vm.tasks = Tasks;
        vm.newTask = false;
        vm.searchText = null;
        vm.selectedTag = [];
        vm.selectedItem = null;      
        vm.autoFillOff = true;

        vm.myDate = new Date();
        vm.minDate = new Date(
            this.myDate.getFullYear(),
            this.myDate.getMonth(),
            this.myDate.getDate()
          );

        if (!vm.task) {
            vm.task = {};

            vm.title = 'New Task';
            vm.pageStatus = 'add';

            vm.newTask = true;
            // vm.task.tags = [];
        } else {
          vm.searchText = vm.task['user_name'];
          if(vm.task['tag_id'] != null){
              vm.task['tag_id'].split(',').forEach(function(element, index){
                var tag_title = vm.task['tag_title'].split(','); 
                vm.selectedTag.push({'name':tag_title[index],'id':element,'type': 'old'})
              });
          } 
        }

        // Methods
        vm.addNewTask = addNewTask;
        vm.saveTask = saveTask;
        vm.deleteTask = deleteTask;
        vm.newTag = newTag;
        vm.closeDialog = closeDialog;
        vm.states = loadAll();
        // vm.searchText = null;
        vm.querySearch = querySearch;
        vm.rooms = ModalData['rooms'];
        vm.priority = [
        {
          name:'Lower',
          value:'lower'
        },{
          name:'Medium',
          value:'medium'
        },{
          name:'Higher',
          value:'higher'
        }]

        //////////

        /**
         * Add new task
         */
        function addNewTask() {
      			vm.task['selectedTags'] = vm.selectedTag;
            vm.task['task_to_user'] = 0;  
            if(vm.selectedItem != null ){
              vm.task['task_to_user'] = vm.selectedItem['value'];  
            }
            vm.task['task_category'] = task_category;
            
           if( vm.type === 'houseKeep') {
                vm.task.product_id = vm.productId
                vm.task.type = 'user';
                todoService.updateUserOrPriorty(vm.task).then(function(res){
                    closeDialog();
                });
            } else {
                todoService.addTask(vm.task).then(function(response){
                });
                vm.tasks.unshift(vm.task);
                closeDialog();
            }
        }

        vm.prioritySelected = function(value) {
              var saveData = {
                  product_id: vm.productId,
                  type: 'priority',
                  priority: value
              };
              todoService.updateUserOrPriorty(saveData).then(function(res){
                  closeDialog();
              });
        };

        /**
         * Save task
         */
        function saveTask() {
            // Dummy save action
            // if(vm.selectedItem){
            // vm.task['task_to_user'] = vm.selectedItem['value'];
            // }
            vm.task['task_to_user'] = 0;  
            if(vm.selectedItem != null ){
              vm.task['task_to_user'] = vm.selectedItem['value'];  
            }
            vm.task['selectedTags'] = vm.selectedTag;
            vm.task['task_category'] = task_category;

            todoService.updateTask(vm.task).then(function(response){
                
            });            
            closeDialog();
        }

        /**
         * Delete task
         */
        function deleteTask() {
           // new
            var html = 'Are you sure?</br>';
            html = html + 'The task will be deleted.'
              
                $mdDialog.show({
                              controller: 'confirmController',
                              controllerAs: 'vm',
                              templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                              parent: angular.element(document.body),
                              targetEvent: event,
                              clickOutsideToClose:true ,
                              locals: {
                                    title: 'Delete Task',
                                    htmlContent:html,
                                    cancelBtn:'Cancel',
                                    OkBtn:'Ok'
                                }                
                            })
                            .then(function(answer) {
                               if(typeof answer != 'undefined' && answer == 'update'){
                               todoService.deleteTask({'task_id':vm.task['task_id']}).then(function(response){
                                if(response.success)
                                 $rootScope.$emit("updateTaskList", {});
                              
                                });
                               }
                            }, function() {}); 
            //Old
        }


        /**
         * New tag
         *
         * @param chip
         * @returns {{label: *, color: string}}
         */
        function newTag(chip) {
            var tagColors = ['#388E3C', '#F44336', '#FF9800', '#0091EA', '#9C27B0'];
            return {
                name: chip,
                label: chip,
                color: tagColors[Math.floor(Math.random() * (tagColors.length))]
            };
        }

        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /*Code for auto search*/

        /**
         * Search for users... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            var results = query ? vm.states.filter(createFilterForUser(query)) : vm.states;
            var deferred = $q.defer();
            $timeout(function() {
              console.log(results);
                deferred.resolve(results);
            }, Math.random() * 1000, false);
            return deferred.promise;

        }

        /**
         * Build `states` list of key/value pairs
         */
        function loadAll() {

            var allUsers = ModalData['users'];
            return allUsers.map(function(state) {
                return {
                    display: state['display'].toLowerCase(),
                    value: state['value']
                };
            });
        }

        /**
         * Create filter function for a query string
         */
        function createFilterForUser(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(state) {
                return (state['display'].indexOf(lowercaseQuery) === 0);
            };
        }
        /*Code for auto search*/

        /*For tags start*/
        vm.readonly = false;
        vm.searchTags = null;
        vm.querySearchTags = querySearchTags;
        vm.mytags = loadTags();
        
        vm.numberChips = [];
        vm.numberChips2 = [];
        vm.numberBuffer = '';
        vm.autocompleteDemoRequireMatch = false;
        vm.transformChip = transformChip;

    vm.notFound = function(key) {
        transformChip(key);
      }
      /**
       * Return the proper object when the append is called.
       */
    function transformChip(chip) {
      // If it is an object, it's already a known chip
      if (angular.isObject(chip)) {
        return {
        name: chip.name,
        type: 'old',
        id: chip.id
      };
      }

      // Otherwise, create a new one
      return {
        name: chip,
        type: 'new'
      }
    }

    /**
     * Search for mytags.
     */
    function querySearchTags(query) {
      var results = query ? vm.mytags.filter(createFilterFor(query)) : [];
      return results;
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(vegetable) {
        return (vegetable._lowername.indexOf(lowercaseQuery) === 0) ;
      };

    }

    function loadTags() {
      var getTags = ModalData['tags']

      return getTags.map(function(veg) {
        veg._lowername = veg.name.toLowerCase();
        return veg;
      });
    }
        /*For tags end*/
    setTimeout(function() {
       vm.autoFillOff = false;
    }, 1500); 

    }
})();

(function() {
    'use strict';

    angular
        .module('app.todo')
        .controller('HousekeepTaskDialogController', HousekeepTaskDialogController);

    /** @ngInject */
    function HousekeepTaskDialogController($mdDialog, data, task_category, type, selectedCategory, todoService, $localStorage, $rootScope, EnvironmentConfig, $scope, $timeout) {
        var vm = this;

        vm.taskCategory    = task_category;
        vm.modeType        = type || 'add';
        vm.title           = (vm.modeType === 'edit') ? data.taskDetail.task_title : 'Add New Task';
        vm.comments        = data.taskComments || [];
        vm.users           = data.adminUsers;
        vm.task            = vm.modeType === 'edit' ? data.taskDetail : {};
        vm.selectedUser    = [];
        vm.rooms           = (data.roomsList !== undefined) ? data.roomsList : [];
        if(data.roomsList !== undefined) {
          vm.roomsKey        = Object.keys(data.roomsList);
        }
        vm.hotelID         = $localStorage.preHotelId;
        var commentObject  = {};
        vm.loggedUserId    = $localStorage.userId;
        vm.audioPath       = EnvironmentConfig.api + "uploads/commentaudio/";
        vm.uploading       = false;
        $rootScope.audioFilesAdded = [];
        vm.record = 'stop';
        vm.showMicErr = false;
        vm.autoFillOff = true;
        var taskChatChannel = null;
        var taskChatPubnub = null;
        var taskChatListener = null;

        vm.oldHousekeeperAssign = vm.task.task_to_user;

        if (vm.task.task_due_date != undefined) {
            var taskDate = new Date(vm.task.task_due_date.split(' ')[0]);
            taskDate.setMinutes(taskDate.getMinutes() + taskDate.getTimezoneOffset() );
            vm.task.task_due_date = taskDate;
        }
        
        vm.commentInput = '';
        vm.audioState = {};

        function formatCommentTime(value) {
            if (!value) {
                return '';
            }
            return moment(value).format('MMM DD, YYYY, hh:mm a');
        }

        function formatAudioClock(seconds) {
            seconds = Math.max(0, Math.floor(seconds || 0));
            var mins = Math.floor(seconds / 60);
            var secs = seconds % 60;
            return mins + ':' + (secs < 10 ? '0' : '') + secs;
        }

        function scrollCommentsToEnd() {
            $timeout(function() {
                var thread = document.getElementById('commentThread');
                if (thread) {
                    thread.scrollTop = thread.scrollHeight;
                }
            }, 0);
        }

        vm.ensureAudioState = function(index) {
            if (!vm.audioState[index]) {
                vm.audioState[index] = { playing: false, progress: 0, label: '0:00' };
            }
            return vm.audioState[index];
        };

        vm.toggleCommentAudio = function(index, event) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            var audio = document.getElementById('audio_' + index);
            if (!audio) {
                return;
            }
            angular.forEach(vm.audioState, function(state, key) {
                if (String(key) === String(index)) {
                    return;
                }
                var other = document.getElementById('audio_' + key);
                if (other && !other.paused) {
                    other.pause();
                }
                state.playing = false;
            });
            var current = vm.ensureAudioState(index);
            if (audio.paused) {
                var playPromise = audio.play();
                current.playing = true;
                if (playPromise && playPromise.catch) {
                    playPromise.catch(function() {
                        current.playing = false;
                    });
                }
            } else {
                audio.pause();
                current.playing = false;
            }
        };

        vm.onAudioMeta = function(audio) {
            var index = audio.getAttribute('data-index');
            var state = vm.ensureAudioState(index);
            var duration = isFinite(audio.duration) ? audio.duration : 0;
            state.label = '0:00 / ' + formatAudioClock(duration);
            $scope.$applyAsync();
        };

        vm.onAudioTick = function(audio) {
            var index = audio.getAttribute('data-index');
            var state = vm.ensureAudioState(index);
            var duration = isFinite(audio.duration) ? audio.duration : 0;
            state.progress = duration ? (audio.currentTime / duration) * 100 : 0;
            state.label = formatAudioClock(audio.currentTime) + (duration ? (' / ' + formatAudioClock(duration)) : '');
            state.playing = !audio.paused && !audio.ended;
            $scope.$applyAsync();
        };

        vm.onAudioEnded = function(audio) {
            var index = audio.getAttribute('data-index');
            var state = vm.ensureAudioState(index);
            state.playing = false;
            state.progress = 0;
            $scope.$applyAsync();
        };

        vm.seekCommentAudio = function(index, event) {
            var audio = document.getElementById('audio_' + index);
            if (!audio || !isFinite(audio.duration) || !audio.duration) {
                return;
            }
            var rect = event.currentTarget.getBoundingClientRect();
            var ratio = (event.clientX - rect.left) / rect.width;
            ratio = Math.max(0, Math.min(1, ratio));
            audio.currentTime = ratio * audio.duration;
        };

        $scope.$watchCollection('vm.comments', scrollCommentsToEnd);
        $timeout(scrollCommentsToEnd, 50);
        $timeout(scrollCommentsToEnd, 350);

        if (vm.modeType === 'edit' && vm.task !== undefined && vm.task.task_to_user !== undefined && vm.task.task_to_user !== '') {
            if (vm.users !== undefined && vm.users.length) {
                vm.users.forEach(function(value, key){
                    if (vm.task.task_to_user.includes(value.value) ) {
                        vm.selectedUser.push(value);
                    }
                });
            }
        }

        vm.task.task_to_user = vm.selectedUser;
        if (vm.comments.length) {
            vm.comments.forEach(function(value,key){
                value.created_time = formatCommentTime(value.created_time);
            });
        }

        function commentAlreadyExists(commentId, text, commentBy, mediaName) {
            return (vm.comments || []).some(function(existing) {
                if (commentId && existing.task_comment_id && String(existing.task_comment_id) === String(commentId)) {
                    return true;
                }
                // A comment typed in this dialog has no id until the live echo arrives.
                // Match that local bubble only, so a later identical message still shows.
                if (!text || existing.media || existing.media_url || mediaName) {
                    return false;
                }
                if (existing.comment !== text || String(existing.comment_by) !== String(commentBy)) {
                    return false;
                }
                if (commentId && !existing.task_comment_id) {
                    existing.task_comment_id = commentId;
                    return true;
                }
                return !commentId && !existing.task_comment_id;
            });
        }

        function appendLiveComment(message) {
            if (!message || !message.data) {
                return;
            }
            var sender = message.sender || {};
            var senderId = (sender.uuid || '').toString().replace('user-', '');
            var text = message.data.text || '';
            var commentId = message.data.task_comment_id || '';
            var mediaName = message.data.media_name || '';
            var mediaType = message.data.media_type || '';
            var commentType = message.data.type || 'text';
            if (commentType === 'text' && mediaType.indexOf('image') > -1) {
                commentType = 'image';
            } else if (commentType === 'text' && mediaType.indexOf('audio') > -1) {
                commentType = 'audio';
            }
            if (commentAlreadyExists(commentId, text, senderId, mediaName)) {
                return;
            }
            vm.comments.push({
                task_comment_id: commentId,
                task_id: vm.task.task_id,
                comment: text,
                comment_by: senderId ? parseInt(senderId, 10) : 0,
                username: (sender.state && sender.state.username) ? sender.state.username : (sender.name || ''),
                created_time: moment().format('MMM DD, YYYY, hh:mm a'),
                type: commentType,
                media: mediaName,
                media_type: mediaType,
                media_url: message.data.mediaUrl || message.data.media_url || ''
            });
            scrollCommentsToEnd();
            if (!$scope.$$phase) {
                $scope.$applyAsync();
            }
        }

        function initTaskChatRealtime() {
            if (vm.modeType !== 'edit' || !vm.task || !vm.task.task_id) {
                return;
            }
            if (typeof PubNub === 'undefined' || !EnvironmentConfig.pubnubSubscribeKey) {
                return;
            }
            taskChatChannel = 'task-chat-' + vm.task.task_id;
            taskChatPubnub = new PubNub({
                subscribeKey: EnvironmentConfig.pubnubSubscribeKey,
                userId: 'ls-admin-' + String(vm.loggedUserId || 'guest')
            });
            taskChatListener = {
                message: function(event) {
                    if (!event) {
                        return;
                    }
                    if (event.channel === taskChatChannel) {
                        appendLiveComment(event.message);
                        return;
                    }
                    if (event.channel === 'task-updates' && event.message && vm.task && String(event.message.taskId) === String(vm.task.task_id)) {
                        var msg = event.message;
                        $scope.$applyAsync(function() {
                            if (msg.type === 'task_status' && msg.status) {
                                vm.task.task_status = msg.status;
                            } else if (msg.type === 'task_accept_reject' && msg.status) {
                                vm.task.task_inspected = msg.status;
                                if (msg.status === 'rejected') {
                                    vm.task.task_rejected = '1';
                                    vm.task.task_status = 'undone';
                                } else if (msg.status === 'accepted') {
                                    vm.task.task_rejected = '0';
                                    vm.task.task_status = 'done';
                                } else {
                                    vm.task.task_rejected = '0';
                                }
                            }
                        });
                    }
                }
            };
            taskChatPubnub.addListener(taskChatListener);
            taskChatPubnub.subscribe({ channels: [taskChatChannel, 'task-updates'] });
        }

        function destroyTaskChatRealtime() {
            if (taskChatPubnub && taskChatChannel) {
                if (taskChatListener) {
                    taskChatPubnub.removeListener(taskChatListener);
                }
                taskChatPubnub.unsubscribe({ channels: [taskChatChannel, 'task-updates'] });
            }
            taskChatPubnub = null;
            taskChatListener = null;
            taskChatChannel = null;
        }

        initTaskChatRealtime();
        $scope.$on('$destroy', destroyTaskChatRealtime);
        
        vm.closeDialog = closeDialog;
        
        /**
        * update task
        */
        vm.updateRequest = false;
        vm.updateTask = function(ev) {          
          if (vm.modeType === 'add') {
              vm.task.task_category = selectedCategory;
              vm.task.comment = vm.comments;
              todoService.checkIfTaskExistForRoom({'task_product_id': vm.task.task_product_id}).then(function(response){
                  if(response.status != undefined && response.status == 'exist') {
                    var html = 'Houskeeping task already exist.</br> Are you sure you want to update the existing task?';
                    var audioFiles = $rootScope.audioFilesAdded;
                    $rootScope.audioFilesAdded = [];

                    $mdDialog.show({
                      controller: 'confirmController',
                      controllerAs: 'vm',
                      templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                      parent: angular.element(document.body),
                      targetEvent: event,
                      clickOutsideToClose: false,
                      locals: {
                            title: 'Update existing task',
                            htmlContent: html,
                            cancelBtn: 'Cancel',
                            OkBtn: 'Ok'
                        }                
                    })
                    .then(function(answer) {
                        if(typeof answer != 'undefined' && answer == 'update'){
                          if(vm.hotelID == 122) {

                            vm.task.modeType = 'add';
                            todoService.getCategoryRooms(vm.task).then(function(response){
                              if(response.status === 'success') {
                                vm.roomsData = response.data;
                                if(vm.roomsData.length > 0) {
                                  var proceed = false;
                                  if(vm.task.task_to_user.length > 0) {
                                    angular.forEach(vm.task.task_to_user, function(res,index) {
                                      if(res.value !== vm.defaultHousekeeper.value ) {
                                        proceed = true;
                                      }
                                    });
                                  }
                                  if(proceed) {
                                    // Logic for housekeeper update for all task havng category room
                                    
                                    $mdDialog.show({
                                        controller: 'ConfirmHousekeeperController',
                                        controllerAs: 'vm',
                                        templateUrl: 'app/main/apps/todo/dialogs/confirmhousekeeper/confirmhousekeeper.html',
                                        clickOutsideToClose: true,
                                        locals: {
                                            title: 'Confirm Changes',
                                            data: vm.task,
                                            roomsData:vm.roomsData
                                        },
                                        onRemoving:function(res){
                                            // todoService.addHouseKeepTask(vm.task).then(function(response){
                                            //     $rootScope.$emit("updateTaskList", {});
                                            //     closeDialog('add');
                                            // });
                                        }
                                    }).then(function(response) {
                                        vm.task.updateallRoom = false;
                                        if(typeof response != 'undefined' && response.length > 0){
                                          vm.task.selectedRoom = response;
                                        }
                                        todoService.addHouseKeepTask(vm.task).then(function(response){
                                          $rootScope.$emit("updateTaskList", {});
                                          closeDialog('add');
                                        });
                                    });
                                  } else {
                                    todoService.addHouseKeepTask(vm.task).then(function(response){
                                      $rootScope.$emit("updateTaskList", {});
                                      closeDialog('add');
                                    });
                                  }
                                } else {
                                    todoService.addHouseKeepTask(vm.task).then(function(response){
                                      $rootScope.$emit("updateTaskList", {});
                                      closeDialog('add');
                                    });
                                }
                              } else {
                                vm.roomsData = [];
                                vm.callAddHousekeeperTask(vm.task);
                              }
                            });
                          } else {
                              todoService.addHouseKeepTask(vm.task).then(function(response){
                                  $rootScope.$emit("updateTaskList", {});
                                  closeDialog('add');
                              });
                          }
                        } else {
                           todoService.deleteAudio({files : audioFiles});
                        }
                    }, function() {});                      
                  } else {
                      if(vm.hotelID == 122) {
                        // get category rooms
                        vm.selectedRoom = [];
                        vm.task.modeType = 'add';
                        todoService.getCategoryRooms(vm.task).then(function(response){
                          if(response.status === 'success') {
                            vm.roomsData = response.data;
                            // Logic for housekeeper update for all task havng category room
                            if(vm.roomsData.length > 0) {
                              $mdDialog.show({
                                  controller: 'ConfirmHousekeeperController',
                                  controllerAs: 'vm',
                                  templateUrl: 'app/main/apps/todo/dialogs/confirmhousekeeper/confirmhousekeeper.html',
                                  clickOutsideToClose: true,
                                  locals: {
                                      title: 'Confirm Changes',
                                      data: vm.task,
                                      roomsData:vm.roomsData
                                  },
                                  onRemoving:function(res){
                                      // todoService.addHouseKeepTask(vm.task).then(function(response){
                                      //     $rootScope.$emit("updateTaskList", {});
                                      //     closeDialog('add');
                                      // });
                                  }
                              }).then(function(response) {
                                  vm.task.updateallRoom = false;
                                  if(typeof response != 'undefined' && response.length > 0){
                                    vm.task.selectedRoom = response;
                                  }
                                  todoService.addHouseKeepTask(vm.task).then(function(response){
                                      $rootScope.$emit("updateTaskList", {});
                                      closeDialog('add');
                                  });
                              });
                            } else {
                              vm.callAddHousekeeperTask(vm.task);
                              closeDialog('add');
                            } 
                          } else {
                            vm.roomsData = [];
                            vm.callAddHousekeeperTask(vm.task);
                            closeDialog('add');
                          }
                        });
                      } else {
                        vm.callAddHousekeeperTask(vm.task);
                        closeDialog('add');
                      }
                  }
              });
              
          } else if (vm.modeType === 'edit') {
              if(vm.hotelID == 122) {
                vm.task.modeType = 'edit';
                var oldArr = vm.oldHousekeeperAssign.split(',');
                var netHousekeeper = [];
                angular.forEach(oldArr, function(val,index) {
                  var count = 0;
                  angular.forEach(vm.task.task_to_user, function(keeper,key) {
                    if(count == 0) {
                      if(keeper.value !== val) {
                        netHousekeeper.push(val);
                      } else {
                        count++;
                      }
                    }
                  });
                });
                var finalHouse = [];
                angular.forEach(netHousekeeper, function(res, k) {
                  if(finalHouse.indexOf(res) === -1) {
                    finalHouse.push(res);
                  }
                });
               vm.task.oldhousekeeper = finalHouse;
                todoService.getCategoryRooms(vm.task).then(function(response){
                  if(response.status === 'success') {
                    vm.roomsData = response.data;
                    if(vm.roomsData.length > 0) {
                      var proceed = false;
                      if(vm.task.task_to_user.length > 0) {
                        angular.forEach(vm.task.task_to_user, function(res,index) {
                          if(res.value !== vm.defaultHousekeeper.value ) {
                            proceed = true;
                          }
                        });
                      }
                      if(proceed) {
                        // Logic for housekeeper update for all task havng category room
                        
                        $mdDialog.show({
                            controller: 'ConfirmHousekeeperController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/apps/todo/dialogs/confirmhousekeeper/confirmhousekeeper.html',
                            // targetEvent: ev,
                            clickOutsideToClose: true,
                            locals: {
                                title: 'Confirm Changes',
                                data: vm.task,
                                roomsData:vm.roomsData
                            },
                            onRemoving:function(res){
                                // todoService.addHouseKeepTask(vm.task).then(function(response){
                                //     $rootScope.$emit("updateTaskList", {});
                                //     closeDialog('add');
                                // });
                            }
                        }).then(function(response) {
                            vm.task.updateallRoom = false;
                            if(typeof response != 'undefined' && response.length > 0){
                              vm.task.selectedRoom = response;
                            }
                            todoService.updateHouseKeepTask(vm.task).then(function(response){
                              $rootScope.$emit("updateTaskList", {});
                              closeDialog('edit');        
                            }); 
                        });
                      } else {
                        todoService.updateHouseKeepTask(vm.task).then(function(response){
                          $rootScope.$emit("updateTaskList", {});
                          closeDialog('edit');        
                        }); 
                      }
                    } else {
                        todoService.updateHouseKeepTask(vm.task).then(function(response){
                          $rootScope.$emit("updateTaskList", {});
                          closeDialog('edit');        
                        }); 
                    }
                  } else {
                    vm.roomsData = [];
                    todoService.updateHouseKeepTask(vm.task).then(function(response){
                      $rootScope.$emit("updateTaskList", {});
                      closeDialog('edit');        
                    }); 
                  }
                });
              } else {
                vm.updateRequest = true;
                todoService.updateHouseKeepTask(vm.task).then(function(response){
                    vm.updateRequest = false;
                    $rootScope.$emit("updateTaskList", {});
                    closeDialog('edit');        
                });
              }       
          }
        };

        /**
        * Save the comments
        */

        vm.saveComments = function() {
            if (vm.commentInput !== '') {
                commentObject = {
                    task_id: vm.task.task_id,
                    comment: vm.commentInput,
                    comment_by: vm.loggedUserId,
                    username: ($localStorage.firstName || '') + (($localStorage.lastName) ? (' ' + $localStorage.lastName) : ''),
                    created_time: moment().format('MMM DD, YYYY, hh:mm a'),
                    created_time_org: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
                };
                vm.comments.push(commentObject);    
                vm.commentInput = '';
            
                if(vm.modeType === 'edit') {
                    todoService.addComment(commentObject);
                }
            }
        };

        /**
        * Delete task
        */
        vm.deleteTask = function() {
            var html = '<div class="form-title no-padding mb-10">Are you sure?</div>';
            html = html + 'The task will be deleted.'
              
            $mdDialog.show({
              controller: 'confirmController',
              controllerAs: 'vm',
              templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
              parent: angular.element(document.body),
              targetEvent: event,
              clickOutsideToClose:true ,
              locals: {
                    title: 'Delete Task',
                    htmlContent:html,
                    cancelBtn:'Cancel',
                    OkBtn:'Ok'
                }                
            })
            .then(function(answer) {
              if(typeof answer != 'undefined' && answer == 'update'){
                todoService.deleteTask({'task_id':vm.task['task_id']}).then(function(response){
                  if(response.success) {
                    var emitData = {
                      type : 'deleted',
                      task_id : vm.task.task_id
                    };
                    $rootScope.$emit("updateTaskList", emitData);
                  }
                });
              }
            }, function() {}); 
        }

        vm.acceptRejectTasks = function(taskId, status) {
            $rootScope.$broadcast('approveRejTask', {taskId: taskId, status: status});
            closeDialog('acceptReject');
        };
        
        /**
         * Close dialog
         */
        function closeDialog(from) {
            destroyTaskChatRealtime();
            if(vm.modeType == 'add' && from != 'close') {
                $rootScope.audioFilesAdded = [];
            }
            var data = {
                from : from,
                task : vm.task
            }
            $mdDialog.hide(data);
        }

        vm.recorderConfig = {
            type: 'audio',
            mimeType: 'audio/ogg'
        }

        /*
        ** To start audio recording using webRTC
        */
        vm.startRecording = function() {
            vm.record = 'start';
            navigator.mediaDevices.getUserMedia({
              audio: true
            }).then(function(stream) {
                window.streamReference = stream;
                vm.recorder = RecordRTC(stream, vm.recorderConfig);
                vm.recorder.startRecording();                
            }).catch(function(error) {
                vm.record = 'stop';
                console.log("We can't find your microphone.");
                vm.showMicErr = true;
                console.log(vm.showMicErr);
                setTimeout(function() {
                    vm.showMicErr = false;
                    console.log("Close error : ",vm.showMicErr);
                },3000);
            });
        }

        /*
        ** To stop recording and save recorded audio
        */
        vm.stopRecording = function() {
            vm.record = 'stop';
            if(vm.recorder !== undefined) {
              vm.uploading = true;
              vm.recorder.stopRecording(function() {
                  var blob = vm.recorder.getBlob();
                  vm.recorder.getDataURL(function(dataURL) {
                      var date = new Date();
                      var timestamp = date.getTime();
                      var ext = 'webm';
                      if (blob.type) {
                          ext = (blob.type.split('/')[1] || 'webm').split(';')[0];
                          ext = ext.replace(/[^a-z0-9]/gi, '') || 'webm';
                      }
                      commentObject = {
                          task_id: vm.task.task_id,
                          comment: '',
                          comment_by: vm.loggedUserId,
                          created_time: moment().format('MMM DD, YYYY, hh:mm a'),
                          created_time_org: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
                          type: 'audio',
                          media_data: dataURL,
                          media_type: blob.type,
                          media_name: timestamp + '.' + ext,
                          media: timestamp + '.mp3',
                          base_name: timestamp,
                          extension: ext
                      };
                      vm.commentInput = '';
                      if(vm.modeType === 'edit') {
                          todoService.addComment(commentObject).then(function(response) {
                              if (response && response.status) {
                                  if (response.audioName) {
                                      commentObject.media = response.audioName;
                                      commentObject.media_name = response.audioName;
                                  }
                                  vm.comments.push(commentObject);
                              }
                              vm.uploading = false;
                              scrollCommentsToEnd();
                          });
                      } else {
                          todoService.uploadAudio(commentObject).then(function(response) {
                            if(response.status != undefined && response.status) {
                              $rootScope.audioFilesAdded.push(response.audioName);
                              vm.comments.push(commentObject);
                            }
                            vm.uploading = false;
                          });
                      }

                      // Close the MIC
                      setTimeout(function() {
                        if (!window.streamReference) {
                        } else {
                            window.streamReference.getAudioTracks().forEach(function(track) {
                                track.stop();
                            });
                            window.streamReference = null;
                        }
                        var destroy = vm.recorder.reset();
                      },1000);
                  });
              });
            }
       }

      setTimeout(function() {
         vm.autoFillOff = false;
      }, 1500); 

       vm.defaultHousekeeper = {};
       vm.selectedUser = function(productID) {
        if (vm.modeType === 'add') {
            angular.forEach(vm.roomsKey, function(subhotel, key) {
              angular.forEach(vm.rooms[subhotel], function(record, index) {
                if(parseInt(productID) === parseInt(record.product_id)) {
                  var data = {
                    'value': record.housekeeper_id,
                    'display': record.housekeeper_name
                  };
                  vm.defaultHousekeeper = data; 
                }
              });
            });
            vm.task.task_to_user = vm.defaultHousekeeper.value;
            var string = vm.task.task_to_user;
            vm.selectedUserID = [];
            vm.task.task_to_user = vm.defaultHousekeeper;
            if (vm.users !== undefined && vm.users.length) {
                vm.users.forEach(function(value, key){
                  if (string.indexOf(value.value) !== -1) {
                      vm.selectedUserID.push(value);
                  }
                });
            }
            vm.task.task_to_user = vm.selectedUserID;
        }
       }


       vm.callAddHousekeeperTask = function(taskParams) {
          todoService.addHouseKeepTask(vm.task).then(function(response){
            closeDialog('add');
          });
       }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.todo')
        .controller('ConfirmHousekeeperController', ConfirmHousekeeperController);

    /** @ngInject */
    function ConfirmHousekeeperController($mdDialog, $localStorage, $rootScope, EnvironmentConfig, title, data, todoService, roomsData) {
        var vm = this;
        vm.title = title;
        vm.requestData = data;
        vm.roomsData = roomsData;
        vm.selectedRoom = [];
        vm.roomTask = [];
        vm.selectAllRooms = true;

        angular.forEach(vm.roomsData, function(val,index) {
          vm.roomTask[index] = true; 
          var data = {
            'room' : val.room_number,
            'product_id' : val.product_id,
            'value': true
          };
          vm.selectedRoom.push(data);             
        });

        vm.selectRoomsForUpdate = function(roomObj, value) {
          if(value) {
            var data = {
              'room' : roomObj.room_number,
              'product_id' : roomObj.product_id,
              'value': true
            };
            vm.selectedRoom.push(data);
          } else {
            vm.selectAllRooms = false;
            angular.forEach(vm.selectedRoom, function(val,index) {
              if(val['room'] == roomObj['room_number']) {
                vm.selectedRoom.splice(index, 1);
              }
            });
          }
        }

        vm.saveHouskeeperData = function() {
          $mdDialog.hide(vm.selectedRoom);
        }

        vm.closeDialog = function() {
          $mdDialog.hide();
        }

        vm.selectAllRoomsCategory = function(value) {
          if(value){
            angular.forEach(vm.roomsData, function(val,index) {
              vm.roomTask[index] = true; 

              var data = {
                'room' : val.room_number,
                'product_id' : val.product_id,
                'value': true
              };
              vm.selectedRoom.push(data);             
            });
          } else {
            angular.forEach(vm.roomsData, function(val,index) {
              vm.roomTask[index] = false;
              vm.selectedRoom.splice(index,1);             
            });
          }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings.triggers', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.settings_triggers', {
            url: '/message-center-triggers',
            title: 'Triggers',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/settings/triggers/triggers.html',
                    controller: 'MessageCenterTriggersController as vm'
                }
            },
            permission: 'mc_settings'
        }).state('app.settings_trigger', {
            url: '/message-center-triggers/trigger/:id',
            title: 'Trigger',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/settings/triggers/trigger/trigger.html',
                    controller: 'MessageCenterTriggerDetailController as vm'
                }
            },
            permission: 'mc_settings'
        });

        $translatePartialLoaderProvider.addPart('app/main/apps/settings/triggers');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings.triggers')
        .controller('MessageCenterTriggerDetailController', MessageCenterTriggerDetailController);

    /** @ngInject */
    function MessageCenterTriggerDetailController(
        $scope,
        $document,
        $timeout,
        triggersService,
        $state,
        $stateParams,
        toastMessage
    ) {
        var vm = this;
        var id = $stateParams.id;
        vm.isEdit = (id && id !== 'new');
        vm.isLoading = true;

        vm.subHotels = [];
        vm.templates = [];

        vm.eventOptions = [];
        vm.timingOptions = [];
        vm.scheduleTypes = [];
        vm.unitOptions = [];
        vm.channelOptions = [];
        vm.recipientTypeOptions = [];
        vm.tokens = [];

        vm.gotoTriggers = gotoTriggers;
        vm.save = save;

        vm.promoteReplyOpen = false;
        vm.promoteReplyLoading = false;
        vm.promoteReplySearch = '';
        vm.promoteReplyCategories = [];
        vm.promoteReplyFiltered = [];

        vm.quickReplyOpen = false;
        vm.quickReplyLoading = false;
        vm.quickReplySearch = '';
        vm.quickReplyCategories = [];
        vm.quickReplyFiltered = [];

        var promoteReplyCache = null;
        var quickReplyCache = null;
        var promoteReplyDocClickHandler = null;
        var quickReplyDocClickHandler = null;

        vm.togglePromoteReplyPicker = togglePromoteReplyPicker;
        vm.filterPromoteReplies = filterPromoteReplies;
        vm.applyPromoteReply = applyPromoteReply;

        vm.toggleQuickReplyPicker = toggleQuickReplyPicker;
        vm.filterQuickReplies = filterQuickReplies;
        vm.applyQuickReply = applyQuickReply;

        vm.insertToken = insertToken;
        vm.getTemplatePreview = getTemplatePreview;
        vm.getTemplateName = getTemplateName;
        vm.addEmail = addEmail;
        vm.removeEmail = removeEmail;
        vm.canAddEmail = canAddEmail;
        vm.addPhone = addPhone;
        vm.removePhone = removePhone;
        vm.canAddPhone = canAddPhone;
        vm.updatePhoneWithCountryCode = updatePhoneWithCountryCode;
        vm.isPhoneDuplicate = isPhoneDuplicate;
        vm.isEmailDuplicate = isEmailDuplicate;
        vm.isEmailInvalid = isEmailInvalid;
        vm.canSave = canSave;
        vm.conditionTypes = [];
        vm.fixedTimeDayOffsets = { before: [], after: [] };
        vm.fixedTimeDayLabels = {
            before: 'Day / Days Before Event',
            after: 'Day / Days After Event'
        };
        var operatorsByCondition = {};

        vm.getConditionOperators = function(conditionType) {
            return operatorsByCondition[conditionType] || [];
        };

        vm.getFixedTimeDayOptions = function() {
            var rel = (vm.form && vm.form.timing_relation === 'before') ? 'before' : 'after';
            return (vm.fixedTimeDayOffsets && vm.fixedTimeDayOffsets[rel]) ? vm.fixedTimeDayOffsets[rel] : [];
        };

        vm.getFixedTimeDayLabel = function() {
            var rel = (vm.form && vm.form.timing_relation === 'before') ? 'before' : 'after';
            if (vm.fixedTimeDayLabels && vm.fixedTimeDayLabels[rel]) {
                return vm.fixedTimeDayLabels[rel];
            }
            return rel === 'before' ? 'Day / Days Before Event' : 'Day / Days After Event';
        };

        vm.addCondition = function() {
            if (!vm.form.conditions) {
                vm.form.conditions = [];
            }
            var defType = vm.conditionTypes.length > 0 ? vm.conditionTypes[0].id : '';
            var defOps = vm.getConditionOperators(defType);
            var defOp = defOps.length > 0 ? defOps[0].id : '';
            
            vm.form.conditions.push({
                condition_type: defType,
                operator: defOp,
                value: '',
                value_to: ''
            });
        };

        vm.removeCondition = function(index) {
            if (vm.form.conditions && vm.form.conditions.length > index) {
                vm.form.conditions.splice(index, 1);
            }
        };
        
        vm.onConditionTypeChange = function(cond) {
            var ops = vm.getConditionOperators(cond.condition_type);
            if (ops && ops.length > 0) {
                cond.operator = ops[0].id;
            } else {
                cond.operator = 'eq';
            }
            cond.value = '';
            cond.value_to = '';
        };

        init();

        function init() {
            triggersService.getTriggerOptions().then(function (res) {
                var opts = res.data || {};
                vm.subHotels = opts.sub_hotels || [];
                vm.templates = opts.templates || [];
                vm.eventOptions = opts.events || [];
                vm.timingOptions = opts.timing_relations || [];
                vm.scheduleTypes = opts.schedule_types || [];
                vm.unitOptions = opts.units || [];
                vm.channelOptions = opts.channels || [];
                vm.recipientTypeOptions = opts.recipient_types || [];
                vm.tokens = opts.tokens || [];
                vm.conditionTypes = opts.condition_types || [];
                operatorsByCondition = opts.condition_operators || {};
                vm.fixedTimeDayOffsets = opts.fixed_time_day_offsets || { before: [], after: [] };
                if (opts.fixed_time_day_labels) {
                    vm.fixedTimeDayLabels = opts.fixed_time_day_labels;
                }

                if (vm.isEdit) {
                    triggersService.getTrigger(id).then(function (triggerRes) {
                        if (triggerRes && triggerRes.success && triggerRes.data) {
                            setupForm(triggerRes.data);
                        } else {
                            toastMessage.showSimpleToast('Failed to load trigger', 'error-toast');
                            gotoTriggers();
                        }
                        vm.isLoading = false;
                    });
                } else {
                    setupForm(null);
                    vm.isLoading = false;
                }
            });
        }

        function setupForm(trigger) {
            var timingType = (trigger && trigger.timing_type) || 'relative';
            
            var offsetValue = null;
            var offsetUnit = 'minutes';
            var timingFixedTimeModel = null;
            
            if (timingType === 'relative') {
                if (trigger && typeof trigger.timing_offset_value !== 'undefined') {
                    offsetValue = parseInt(trigger.timing_offset_value, 10);
                    offsetUnit = trigger.timing_offset_unit || 'minutes';
                } else {
                    var initialOffsetMinutes = (trigger && typeof trigger.timing_offset_minutes !== 'undefined')
                        ? parseInt(trigger.timing_offset_minutes, 10)
                        : ((trigger && trigger.offsetValue) ? parseInt(trigger.offsetValue, 10) : 0);
                        
                    if (trigger) {
                        if (initialOffsetMinutes > 0 && initialOffsetMinutes % 1440 === 0) {
                            offsetValue = initialOffsetMinutes / 1440;
                            offsetUnit = 'days';
                        } else if (initialOffsetMinutes > 0 && initialOffsetMinutes % 60 === 0) {
                            offsetValue = initialOffsetMinutes / 60;
                            offsetUnit = 'hours';
                        } else {
                            offsetValue = initialOffsetMinutes;
                            offsetUnit = 'minutes';
                        }
                    }
                }
            } else if (timingType === 'fixed_time') {
                offsetValue = (trigger && typeof trigger.timing_offset_value !== 'undefined') ? parseInt(trigger.timing_offset_value, 10) : 0;
                offsetUnit = 'days';
                
                var timeStr = trigger && trigger.timing_fixed_time ? trigger.timing_fixed_time : '00:00:00';
                var d = new Date();
                d.setHours(0,0,0,0);
                var parts = timeStr.split(':');
                if (parts.length >= 2) {
                    d.setHours(parseInt(parts[0], 10), parseInt(parts[1], 10), 0);
                }
                timingFixedTimeModel = d;
            }

            var conditions = [];
            if (trigger && trigger.conditions && angular.isArray(trigger.conditions)) {
                conditions = angular.copy(trigger.conditions);
            }

            var messageSource = (trigger && trigger.template_id) ? 'template' : 'custom';
            var recipientMeta = (trigger && trigger.recipient_meta) ? trigger.recipient_meta : {};

            function initRecipientArray(arr) {
                if (angular.isArray(arr) && arr.length > 0) {
                    return angular.copy(arr);
                }
                if (typeof arr === 'string' && arr.trim() !== '') {
                    var split = arr.split(/[\n,;]+/).map(function (s) { return s.trim(); }).filter(function (s) { return s.length > 0; });
                    if (split.length > 0) return split;
                }
                return [''];
            }

            vm.recipientEmails = initRecipientArray(recipientMeta.to);
            vm.recipientCcEmails = initRecipientArray(recipientMeta.cc);
            vm.recipientBccEmails = initRecipientArray(recipientMeta.bcc);
            vm.recipientPhones = initRecipientArray(recipientMeta.phone_numbers);

            vm.form = {
                id: (trigger && trigger.id) || null,
                name: (trigger && trigger.name) || '',
                sub_hotel_id: (trigger && typeof trigger.sub_hotel_id !== 'undefined') ? trigger.sub_hotel_id : null,
                event_type: (trigger && (trigger.event_type || trigger.event)) || null,
                timing_relation: (trigger && (trigger.timing_relation || trigger.timing)) || null,
                timing_type: timingType,
                offsetValue: offsetValue,
                offsetUnit: offsetUnit,
                timing_fixed_time_model: timingFixedTimeModel,
                conditions: conditions,
                channel_type: (trigger && (trigger.channel_type || trigger.channel)) || null,
                recipient_type: (trigger && trigger.recipient_type) || null,
                messageSource: messageSource,
                template_id: (trigger && trigger.template_id) ? parseInt(trigger.template_id, 10) : null,
                custom_message: (trigger && (trigger.custom_message || trigger.body)) || '',
                is_active: (trigger && typeof trigger.is_active !== 'undefined') ? !!trigger.is_active : ((trigger && typeof trigger.enabled !== 'undefined') ? !!trigger.enabled : true)
            };
        }

        $scope.$watch('vm.form.channel_type', function (newVal, oldVal) {
            if (newVal === oldVal || typeof oldVal === 'undefined') return;

            if (newVal === 'email') {
                vm.recipientPhones = [''];
            } else if (newVal === 'sms' || newVal === 'whatsapp') {
                vm.recipientEmails = [''];
                vm.recipientCcEmails = [''];
                vm.recipientBccEmails = [''];
            }
        });

        $scope.$watch('vm.form.recipient_type', function (newVal, oldVal) {
            if (newVal === oldVal || typeof oldVal === 'undefined') return;

            if (newVal === 'customer') {
                vm.recipientEmails = [''];
                vm.recipientCcEmails = [''];
                vm.recipientBccEmails = [''];
                vm.recipientPhones = [''];
            }
        });

        function gotoTriggers() {
            $state.go('app.settings_triggers');
        }

        function getEmailList(type) {
            if (type === 'cc') return vm.recipientCcEmails;
            if (type === 'bcc') return vm.recipientBccEmails;
            return vm.recipientEmails;
        }

        function addEmail(type) {
            var list = getEmailList(type);
            list.push('');
        }

        function removeEmail(type, idx) {
            var list = getEmailList(type);
            if (list.length > 1) {
                list.splice(idx, 1);
            } else {
                list[0] = '';
            }
        }

        function isValidEmail(email) {
            if (!email) return false;
            var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(String(email).trim().toLowerCase());
        }

        function canAddEmail(type) {
            var list = getEmailList(type);
            if (!list || list.length === 0) return true;
            var last = (list[list.length - 1] || '').trim();
            return last !== '' && isValidEmail(last);
        }

        function addPhone() {
            vm.recipientPhones.push('');
        }

        function removePhone(idx) {
            if (vm.recipientPhones.length > 1) {
                vm.recipientPhones.splice(idx, 1);
            } else {
                vm.recipientPhones[0] = '';
            }
        }

        function getIntlNumber(inputName) {
            var inputElement = document.querySelector('input[name="' + inputName + '"]');
            if (inputElement) {
                var iti = angular.element(inputElement).data('iti');
                if (iti && iti.isValidNumberPrecise()) {
                    return iti.getNumber();
                }
            }
            return null;
        }

        function updatePhoneWithCountryCode(fieldName, arrayIndex) {
            var inputElement = document.querySelector('input[name="' + fieldName + '"]');
            if (!inputElement) {
                return;
            }

            var iti = angular.element(inputElement).data('iti');
            if (!iti) {
                return;
            }

            var inputValue = inputElement.value.trim();
            var isValid = !inputValue || iti.isValidNumberPrecise();

            angular.element(inputElement).toggleClass('ng-invalid', !isValid);
            angular.element(inputElement).toggleClass('has-error', !isValid);

            var wrapElement = inputElement.closest('.gmc-trigger-input-wrap');
            if (wrapElement) {
                angular.element(wrapElement).toggleClass('has-error', !isValid);
            }

            if (isValid && iti.isValidNumberPrecise() && arrayIndex !== undefined) {
                vm.recipientPhones[arrayIndex] = iti.getNumber();
            }
        }

        function canAddPhone() {
            var list = vm.recipientPhones;
            if (!list || list.length === 0) return true;
            var lastIdx = list.length - 1;
            var lastE164 = getIntlNumber('triggerPhone_' + lastIdx);
            var lastRaw = (list[lastIdx] || '').trim();
            if (!lastRaw) return false;
            if (!lastE164) return false;
            return true;
        }

        function isPhoneDuplicate(idx) {
            var list = vm.recipientPhones;
            var val = getIntlNumber('triggerPhone_' + idx) || (list[idx] || '').trim();
            if (!val) return false;
            for (var i = 0; i < list.length; i++) {
                if (i !== idx) {
                    var other = getIntlNumber('triggerPhone_' + i) || (list[i] || '').trim();
                    if (other && other === val) return true;
                }
            }
            return false;
        }

        function isEmailDuplicate(type, idx) {
            var list = getEmailList(type);
            var val = (list[idx] || '').trim().toLowerCase();
            if (!val) return false;
            for (var i = 0; i < list.length; i++) {
                if (i !== idx && (list[i] || '').trim().toLowerCase() === val) {
                    return true;
                }
            }
            return false;
        }

        function isEmailInvalid(type, idx) {
            var list = getEmailList(type);
            var val = (list[idx] || '').trim();
            if (!val) return false;
            return !isValidEmail(val);
        }

        function insertToken(token) {
            var textarea = document.getElementById('gmc-trigger-body-input');
            var body = String(vm.form.custom_message || '');
            var start;
            var end;

            if (textarea && typeof textarea.selectionStart === 'number') {
                start = textarea.selectionStart;
                end = textarea.selectionEnd;

                vm.form.custom_message = body.slice(0, start) + token + body.slice(end);

                setTimeout(function () {
                    textarea.focus();
                    textarea.selectionStart = textarea.selectionEnd = start + token.length;
                }, 0);

                return;
            }

            vm.form.custom_message = body + token;
        }

        function getTemplateObject(templateId) {
            if (!templateId) return null;
            var targetId = parseInt(templateId, 10);

            if (vm.selectedTemplate && parseInt(vm.selectedTemplate.id, 10) === targetId) {
                return vm.selectedTemplate;
            }

            var i, j, cat;
            if (vm.templates && vm.templates.length) {
                for (i = 0; i < vm.templates.length; i++) {
                    if (parseInt(vm.templates[i].id, 10) === targetId) {
                        return vm.templates[i];
                    }
                }
            }

            if (promoteReplyCache && promoteReplyCache.length) {
                for (i = 0; i < promoteReplyCache.length; i++) {
                    cat = promoteReplyCache[i];
                    for (j = 0; j < (cat.templates || []).length; j++) {
                        if (parseInt(cat.templates[j].id, 10) === targetId) {
                            return cat.templates[j];
                        }
                    }
                }
            }

            if (quickReplyCache && quickReplyCache.length) {
                for (i = 0; i < quickReplyCache.length; i++) {
                    cat = quickReplyCache[i];
                    for (j = 0; j < (cat.templates || []).length; j++) {
                        if (parseInt(cat.templates[j].id, 10) === targetId) {
                            return cat.templates[j];
                        }
                    }
                }
            }

            return null;
        }

        function getTemplatePreview(templateId) {
            var tmpl = getTemplateObject(templateId);
            return tmpl ? (tmpl.body || '') : '';
        }

        function getTemplateName(templateId) {
            var tmpl = getTemplateObject(templateId);
            return tmpl ? (tmpl.name || '') : '';
        }

        function canSave() {
            if (!vm.form) return false;
            if (!String(vm.form.name || '').trim()) {
                return false;
            }
            if (!vm.form.event_type || !vm.form.timing_relation || !vm.form.channel_type || !vm.form.recipient_type) {
                return false;
            }

            if (vm.form.timing_relation !== 'at') {
                var value = parseInt(vm.form.offsetValue, 10);
                if (isNaN(value) || value < 0) {
                    return false;
                }
            }

            if (vm.form.recipient_type === 'user') {
                var hasTo = vm.recipientEmails.some(function (s) { return String(s || '').trim() !== ''; });
                var hasCc = vm.recipientCcEmails.some(function (s) { return String(s || '').trim() !== ''; });
                var hasBcc = vm.recipientBccEmails.some(function (s) { return String(s || '').trim() !== ''; });
                var hasEmail = hasTo || hasCc || hasBcc;

                var hasPhone = vm.recipientPhones.some(function (s) { return String(s || '').trim() !== ''; });

                if (vm.form.channel_type === 'email' && !hasEmail) {
                    return false;
                }
                if ((vm.form.channel_type === 'sms' || vm.form.channel_type === 'whatsapp') && !hasPhone) {
                    return false;
                }

                if (vm.form.channel_type === 'sms' || vm.form.channel_type === 'whatsapp') {
                    for (var p = 0; p < vm.recipientPhones.length; p++) {
                        var rawP = (vm.recipientPhones[p] || '').trim();
                        if (!rawP) continue;
                        var e164 = getIntlNumber('triggerPhone_' + p);
                        if (!e164) return false;
                        if (isPhoneDuplicate(p)) return false;
                    }
                }

                if (vm.form.channel_type === 'email') {
                    for (var e = 0; e < vm.recipientEmails.length; e++) {
                        var rawE = (vm.recipientEmails[e] || '').trim();
                        if (!rawE) continue;
                        if (!isValidEmail(rawE) || isEmailDuplicate('to', e)) return false;
                    }
                    for (var c = 0; c < vm.recipientCcEmails.length; c++) {
                        var rawC = (vm.recipientCcEmails[c] || '').trim();
                        if (!rawC) continue;
                        if (!isValidEmail(rawC) || isEmailDuplicate('cc', c)) return false;
                    }
                    for (var b = 0; b < vm.recipientBccEmails.length; b++) {
                        var rawB = (vm.recipientBccEmails[b] || '').trim();
                        if (!rawB) continue;
                        if (!isValidEmail(rawB) || isEmailDuplicate('bcc', b)) return false;
                    }
                }
            }

            if (vm.form.messageSource === 'template') {
                if (!vm.form.template_id) {
                    return false;
                }
            } else {
                if (!String(vm.form.custom_message || '').trim()) {
                    return false;
                }
            }

            return true;
        }

        function save() {
            if (!canSave()) {
                return;
            }
            vm.isLoading = true;

            var offsetMins = 0;
            if (vm.form.timing_relation !== 'at') {
                var val = parseInt(vm.form.offsetValue, 10) || 0;
                if (vm.form.offsetUnit === 'days') {
                    offsetMins = val * 1440;
                } else if (vm.form.offsetUnit === 'hours') {
                    offsetMins = val * 60;
                } else {
                    offsetMins = val;
                }
            }

            var cleanTo = [];
            var cleanCc = [];
            var cleanBcc = [];
            var cleanPhones = [];

            if (vm.form.recipient_type === 'user') {
                if (vm.form.channel_type === 'email') {
                    cleanTo = vm.recipientEmails.map(function (s) { return String(s || '').trim(); }).filter(function (s) { return s.length > 0; });
                    cleanCc = vm.recipientCcEmails.map(function (s) { return String(s || '').trim(); }).filter(function (s) { return s.length > 0; });
                    cleanBcc = vm.recipientBccEmails.map(function (s) { return String(s || '').trim(); }).filter(function (s) { return s.length > 0; });
                } else if (vm.form.channel_type === 'sms' || vm.form.channel_type === 'whatsapp') {
                    cleanPhones = vm.recipientPhones.map(function (phone, idx) {
                        var e164 = getIntlNumber('triggerPhone_' + idx);
                        return (e164 || phone || '').trim();
                    }).filter(function (s) { return s.length > 0; });
                }
            }

            var recipientMetaObj = {
                to: cleanTo,
                cc: cleanCc,
                bcc: cleanBcc,
                phone_numbers: cleanPhones
            };

            var payload = {
                id: vm.form.id || null,
                name: String(vm.form.name).trim(),
                sub_hotel_id: vm.form.sub_hotel_id ? parseInt(vm.form.sub_hotel_id, 10) : null,
                event_type: vm.form.event_type,
                timing_relation: vm.form.timing_relation,
                timing_type: vm.form.timing_relation === 'at' ? 'relative' : vm.form.timing_type,
                timing_offset_value: parseInt(vm.form.offsetValue, 10) || 0,
                timing_offset_unit: vm.form.offsetUnit || 'minutes',
                channel_type: vm.form.channel_type,
                recipient_type: vm.form.recipient_type,
                recipient_meta: recipientMetaObj,
                template_id: vm.form.messageSource === 'template' ? parseInt(vm.form.template_id, 10) : null,
                custom_message: vm.form.messageSource === 'custom' ? String(vm.form.custom_message).trim() : null,
                is_active: !!vm.form.is_active
            };

            if (payload.timing_type === 'fixed_time') {
                var d = vm.form.timing_fixed_time_model;
                if (d) {
                    var hr = d.getHours().toString().padStart(2, '0');
                    var min = d.getMinutes().toString().padStart(2, '0');
                    payload.timing_fixed_time = hr + ':' + min + ':00';
                }
                payload.timing_offset_unit = 'days';
            }
            
            var finalConditions = [];
            if (vm.form.conditions && vm.form.conditions.length > 0) {
                finalConditions = vm.form.conditions.map(function(c) {
                    return {
                        condition_type: c.condition_type,
                        operator: c.operator,
                        value: String(c.value).trim(),
                        value_to: c.operator === 'between' ? String(c.value_to).trim() : null
                    };
                });
            }
            
            payload.conditions = finalConditions;

            triggersService.saveTrigger(payload).then(function (res) {
                vm.isLoading = false;
                if (res && res.success) {
                    toastMessage.showSimpleToast(vm.isEdit ? 'Trigger updated successfully.' : 'Trigger added successfully.', 'success-toast');
                    gotoTriggers();
                } else {
                    toastMessage.showSimpleToast((res && res.message) ? res.message : 'Failed to save trigger.', 'error-toast');
                }
            });
        }

        $scope.$on('$destroy', function () {
            unbindPromoteReplyDocClick();
            unbindQuickReplyDocClick();
        });

        function togglePromoteReplyPicker($event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            if (vm.promoteReplyOpen) {
                closePromoteReplyPicker();
                return;
            }

            openPromoteReplyPicker();
        }

        function openPromoteReplyPicker() {
            if (vm.quickReplyOpen) closeQuickReplyPicker();
            vm.promoteReplyOpen = true;
            vm.promoteReplySearch = '';
            bindPromoteReplyDocClick();
            loadPromoteReplies();
        }

        function closePromoteReplyPicker() {
            vm.promoteReplyOpen = false;
            vm.promoteReplySearch = '';
            unbindPromoteReplyDocClick();
        }

        function bindPromoteReplyDocClick() {
            unbindPromoteReplyDocClick();

            promoteReplyDocClickHandler = function () {
                $scope.$applyAsync(function () {
                    closePromoteReplyPicker();
                });
            };

            $timeout(function () {
                $document.on('click', promoteReplyDocClickHandler);
            }, 0);
        }

        function unbindPromoteReplyDocClick() {
            if (promoteReplyDocClickHandler) {
                $document.off('click', promoteReplyDocClickHandler);
                promoteReplyDocClickHandler = null;
            }
        }

        function loadPromoteReplies() {
            if (promoteReplyCache) {
                vm.promoteReplyCategories = promoteReplyCache;
                filterPromoteReplies();
                return;
            }

            vm.promoteReplyLoading = true;
            vm.promoteReplyFiltered = [];

            triggersService.getTemplatesGrouped({
                template_type: 'promote_reply'
            }).then(function (response) {
                vm.promoteReplyLoading = false;

                if (!response || response.success === false) {
                    vm.promoteReplyCategories = [];
                    vm.promoteReplyFiltered = [];
                    return;
                }

                promoteReplyCache = normalizeCategories(response.data || []);
                vm.promoteReplyCategories = promoteReplyCache;
                filterPromoteReplies();
            }, function () {
                vm.promoteReplyLoading = false;
                vm.promoteReplyCategories = [];
                vm.promoteReplyFiltered = [];
            });
        }

        function filterPromoteReplies() {
            var query = String(vm.promoteReplySearch || '').toLowerCase().trim();
            var categories = vm.promoteReplyCategories || [];
            var filtered = [];
            var i, j;

            if (!query) {
                vm.promoteReplyFiltered = categories;
                return;
            }

            for (i = 0; i < categories.length; i++) {
                var category = categories[i];
                var matchedTemplates = [];

                if (String(category.name || '').toLowerCase().indexOf(query) !== -1) {
                    filtered.push(category);
                    continue;
                }

                for (j = 0; j < (category.templates || []).length; j++) {
                    var template = category.templates[j];
                    var name = String(template.name || '').toLowerCase();
                    var body = String(template.body || '').toLowerCase();

                    if (name.indexOf(query) !== -1 || body.indexOf(query) !== -1) {
                        matchedTemplates.push(template);
                    }
                }

                if (matchedTemplates.length) {
                    filtered.push({
                        id: category.id,
                        name: category.name,
                        templates: matchedTemplates
                    });
                }
            }

            vm.promoteReplyFiltered = filtered;
        }

        function applyPromoteReply(template) {
            if (!template) return;
            if (template.id) {
                vm.form.template_id = parseInt(template.id, 10);
                vm.selectedTemplate = template;
            }
            closePromoteReplyPicker();
        }

        function toggleQuickReplyPicker($event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            if (vm.quickReplyOpen) {
                closeQuickReplyPicker();
                return;
            }

            openQuickReplyPicker();
        }

        function openQuickReplyPicker() {
            if (vm.promoteReplyOpen) closePromoteReplyPicker();
            vm.quickReplyOpen = true;
            vm.quickReplySearch = '';
            bindQuickReplyDocClick();
            loadQuickReplies();
        }

        function closeQuickReplyPicker() {
            vm.quickReplyOpen = false;
            vm.quickReplySearch = '';
            unbindQuickReplyDocClick();
        }

        function bindQuickReplyDocClick() {
            unbindQuickReplyDocClick();

            quickReplyDocClickHandler = function () {
                $scope.$applyAsync(function () {
                    closeQuickReplyPicker();
                });
            };

            $timeout(function () {
                $document.on('click', quickReplyDocClickHandler);
            }, 0);
        }

        function unbindQuickReplyDocClick() {
            if (quickReplyDocClickHandler) {
                $document.off('click', quickReplyDocClickHandler);
                quickReplyDocClickHandler = null;
            }
        }

        function loadQuickReplies() {
            if (quickReplyCache) {
                vm.quickReplyCategories = quickReplyCache;
                filterQuickReplies();
                return;
            }

            vm.quickReplyLoading = true;
            vm.quickReplyFiltered = [];

            triggersService.getTemplatesGrouped({
                template_type: 'quick_reply'
            }).then(function (response) {
                vm.quickReplyLoading = false;

                if (!response || response.success === false) {
                    vm.quickReplyCategories = [];
                    vm.quickReplyFiltered = [];
                    return;
                }

                quickReplyCache = normalizeCategories(response.data || []);
                vm.quickReplyCategories = quickReplyCache;
                filterQuickReplies();
            }, function () {
                vm.quickReplyLoading = false;
                vm.quickReplyCategories = [];
                vm.quickReplyFiltered = [];
            });
        }

        function filterQuickReplies() {
            var query = String(vm.quickReplySearch || '').toLowerCase().trim();
            var categories = vm.quickReplyCategories || [];
            var filtered = [];
            var i, j;

            if (!query) {
                vm.quickReplyFiltered = categories;
                return;
            }

            for (i = 0; i < categories.length; i++) {
                var category = categories[i];
                var matchedTemplates = [];

                if (String(category.name || '').toLowerCase().indexOf(query) !== -1) {
                    filtered.push(category);
                    continue;
                }

                for (j = 0; j < (category.templates || []).length; j++) {
                    var template = category.templates[j];
                    var name = String(template.name || '').toLowerCase();
                    var body = String(template.body || '').toLowerCase();

                    if (name.indexOf(query) !== -1 || body.indexOf(query) !== -1) {
                        matchedTemplates.push(template);
                    }
                }

                if (matchedTemplates.length) {
                    filtered.push({
                        id: category.id,
                        name: category.name,
                        templates: matchedTemplates
                    });
                }
            }

            vm.quickReplyFiltered = filtered;
        }

        function applyQuickReply(template) {
            if (!template) return;
            if (template.id) {
                vm.form.template_id = parseInt(template.id, 10);
                vm.selectedTemplate = template;
            }
            closeQuickReplyPicker();
        }

        function normalizeCategories(categories) {
            var result = [];
            var i, j;

            for (i = 0; i < categories.length; i++) {
                var category = categories[i] || {};
                var templates = category.templates || [];
                var items = [];

                for (j = 0; j < templates.length; j++) {
                    var template = templates[j] || {};

                    if (String(template.is_active) === '0') {
                        continue;
                    }

                    items.push({
                        id: String(template.id),
                        name: template.name || '',
                        body: template.body || ''
                    });
                }

                if (!items.length) {
                    continue;
                }

                result.push({
                    id: String(category.id),
                    name: category.name || '',
                    templates: items
                });
            }

            return result;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.settings.triggers')
        .controller('MessageCenterTriggerDeleteDialogController', MessageCenterTriggerDeleteDialogController);

    /** @ngInject */
    function MessageCenterTriggerDeleteDialogController($mdDialog)
    {
        var vm = this;

        vm.confirm = confirm;
        vm.cancel = cancel;

        function confirm()
        {
            $mdDialog.hide(true);
        }

        function cancel()
        {
            $mdDialog.cancel();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings.roomLockEncoder', [])
        .directive('roomLockFileChange', function () {
            return {
                restrict: 'A',
                scope: { onFile: '&roomLockFileChange' },
                link: function (scope, element) {
                    element.on('change', function (event) {
                        var file = event.target.files && event.target.files[0];
                        scope.$apply(function () {
                            scope.onFile({ file: file });
                        });
                    });
                    scope.$on('$destroy', function () {
                        element.off('change');
                    });
                }
            };
        })
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.settings_room_lock_encoder', {
            url: '/room-lock-encoder-configuration',
            title: 'Room Lock Encoder Configuration',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/settings/roomLockEncoder/roomLockEncoder.html',
                    controller: 'RoomLockEncoderController as vm'
                }
            },
            resolve: {
                RoomLockEncoderSettings: function (roomLockEncoderService, $localStorage) {
                    return roomLockEncoderService.getSettings({
                        hotel_id: $localStorage.hotels[$localStorage.selectedHotel].hotel_id
                    });
                }
            },
            permission: 'room_lock_encoder'
        });

        $translatePartialLoaderProvider.addPart('app/main/apps/settings/roomLockEncoder');
    }
})();

"use strict";

angular
  .module("app.settings.roomLockEncoder")
  .factory("roomLockEncoderService", RoomLockEncoderService);

RoomLockEncoderService.$inject = [
  "$http",
  "EnvironmentConfig",
  "storageService",
  "$localStorage",
];

function RoomLockEncoderService(
  $http,
  EnvironmentConfig,
  storageService,
  $localStorage
) {
  var STORAGE_SECTION = "room_lock_encoder";
  var LEGACY_ROOM_LOCK_ENCODER_MACHINE_KEY = "room_lock_encoder_machine";
  var migrated = false;

  function getDataFailed(error) {
    return error.data;
  }

  function getDataComplete(response) {
    return response.data;
  }

  function getSettings(data) {
    return $http({
      url:
        EnvironmentConfig.api +
        "RoomLockEncoderSetting/room_lock_encoder_settings",
      method: "POST",
      data: data,
    })
      .then(getDataComplete)
      .catch(getDataFailed);
  }

  function saveSettings(data) {
    return $http({
      url: EnvironmentConfig.api + "RoomLockEncoderSetting/update_settings",
      method: "POST",
      data: data,
    })
      .then(getDataComplete)
      .catch(getDataFailed);
  }

  function migrateRoomLockEncoderStorage() {
    if (migrated) {
      return;
    }
    migrated = true;

    var legacyMachine = $localStorage[LEGACY_ROOM_LOCK_ENCODER_MACHINE_KEY];
    if (legacyMachine === undefined || legacyMachine === null || legacyMachine === "") return;

    storageService.createStorage(STORAGE_SECTION, "machine", legacyMachine);
    delete $localStorage[LEGACY_ROOM_LOCK_ENCODER_MACHINE_KEY];
  }

  function getRoomLockEncoder() {
    migrateRoomLockEncoderStorage();
    var machine = storageService.getStorage(STORAGE_SECTION, "machine");
    var overrideOld = storageService.getStorage(STORAGE_SECTION, "override_old");
    return {
      machine: machine || null,
      override_old: overrideOld === true,
    };
  }

  function setRoomLockEncoderMachine(machine) {
    migrateRoomLockEncoderStorage();
    storageService.updateStorage(STORAGE_SECTION, "machine", machine);
  }

  function setRoomLockEncoderOverrideOld(overrideOld) {
    migrateRoomLockEncoderStorage();
    storageService.updateStorage(
      STORAGE_SECTION,
      "override_old",
      !!overrideOld
    );
  }

  function readCommonDoors(hotelId, file) {
    var formData = new FormData();
    formData.append("hotel_id", hotelId);
    formData.append("db_file", file);

    return $http({
      url: EnvironmentConfig.api + "RoomLockEncoderSetting/read_common_doors",
      method: "POST",
      data: formData,
      headers: { "Content-Type": undefined },
      transformRequest: angular.identity,
    })
      .then(getDataComplete)
      .catch(getDataFailed);
  }

  return {
    getSettings: getSettings,
    saveSettings: saveSettings,
    getRoomLockEncoder: getRoomLockEncoder,
    setRoomLockEncoderMachine: setRoomLockEncoderMachine,
    setRoomLockEncoderOverrideOld: setRoomLockEncoderOverrideOld,
    readCommonDoors: readCommonDoors,
  };
}

(function ()
{
    'use strict';

    angular
        .module('app.settings.paymentmethod',
            [
                // 3rd Party Dependencies
                'angular-timezone-selector'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $stateProvider.state('app.settings_paymentmethod', {
            url    : '/paymentmethod',
            title  : 'Payment Methods',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/settings/paymentMethods/paymentMethod.html',
                    controller : 'paymentmethodController as vm'
                }
            },
            resolve: {
                PaymentMethods: function (paymentmethodsservice){
                    return paymentmethodsservice.getPaymentMethods();
                },
                CardTypes: function (paymentmethodsservice){
                    return paymentmethodsservice.getCardTypes();
                },
                AuthorizeSettings: function (paymentmethodsservice,$localStorage){
                    return paymentmethodsservice.getAuthorizeSettings({hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id});
                },
                PaymentMethodsSelected: function (paymentmethodsservice,$localStorage){
                    return paymentmethodsservice.getPaymentMethodsSelected({hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id});
                }
            },
            permission: 'payment_methods'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/settings/paymentMethods');
    }
})();

'use strict';

angular
	.module('app.settings.paymentmethod')
	.factory('paymentmethodsservice', PaymentmethodsService);

function PaymentmethodsService($http, EnvironmentConfig){
	
	function getDataFailed(error) {
			return error.data;
	}

	function getDataComplete(response) {
 		return response.data;
 	}
 	
	function getPaymentMethods(){
		return $http({
			url:EnvironmentConfig.api+'paymentMethods/get_payment_methods',
			method:'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	
	function getCardTypes(){
		return $http({
			url:EnvironmentConfig.api+'paymentMethods/get_card_types',
			method:'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
	function setPaymentMethodsForHotel(data){
		return $http({
			url:EnvironmentConfig.api+'paymentMethods/save_payment_methods_selected',
			method:'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
	function getAuthorizeSettings(data){
		return $http({
			url:EnvironmentConfig.api+'paymentMethods/get_authorize_settings',
			method:'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
	function getPaymentMethodsSelected(data){
		return $http({
			url:EnvironmentConfig.api+'paymentMethods/get_payment_methods_selected',
			method:'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
	
	function saveAuthorizeSettings(data){
		return $http({
			url:EnvironmentConfig.api+'paymentMethods/save_authorize_settings',
			method:'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
	var service = {
		getPaymentMethods: getPaymentMethods,
		getCardTypes: getCardTypes,
		saveAuthorizeSettings: saveAuthorizeSettings,
		getAuthorizeSettings: getAuthorizeSettings,
		getPaymentMethodsSelected: getPaymentMethodsSelected,
		setPaymentMethodsForHotel: setPaymentMethodsForHotel
	};
	return service;
}

(function ()
{
    'use strict';

    angular
        .module('app.settings.general',
            [
                // 3rd Party Dependencies
                'angular-timezone-selector'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $stateProvider.state('app.settings_general', {
            url    : '/settings',
            title  : 'General Settings',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/settings/general/general.html',
                    controller : 'GeneralController as vm'
                }
            },
            resolve: {
                Organizations: function (organizationsservice){
					var data = {getDefault: true};
                    return organizationsservice.getorganizations(data);
                },
                Settings: function (generalsservice){
					var data = {setting_type: 'general'};
                    return generalsservice.getSettings(data);
                },
                Templates: function (emailsservice){
                    return emailsservice.getTemplates();
                }
            },
            permission: 'general_settings'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/settings/general');
    }
})();

'use strict';

angular
	.module('app.settings.general')
	.factory('generalsservice', GeneralService);

function GeneralService($http, EnvironmentConfig){
	
	function getDataFailed(error) {
			return error.data;
	}

	function getDataComplete(response) {
 		return response.data;
 	}
	function getSettings(data){
		return $http({
			url:EnvironmentConfig.api+'general/general_settings',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function updateSettings(data){
		return $http({
			url:EnvironmentConfig.api+'general/update_settings',
			method:'POST',
			data:data,
			headers: { 'Content-Type': undefined },
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	var service = {
		updateSettings: updateSettings,
		getSettings: getSettings
	};
	return service;
}

(function ()
{
    'use strict';

    angular
        .module('app.settings.emails')
        .controller('TemplatesController', TemplatesController);

    /** @ngInject */
    function TemplatesController($mdDialog, $state, $localStorage, Organizations, $scope, EnvironmentConfig, $http, roleService, emailsservice,toastMessage, Templates, Settings, $rootScope, $sessionStorage)
    {
        var vm = this;

        if(!$rootScope.backButtonPressed){
          $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = {};
          $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] = 1;
          $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'] = 50;
        }

        vm.userPermissions = $rootScope.userPermissions;
        vm.isDeletedAllowed = false;
        if(vm.userPermissions.indexOf('delete_email_template') != -1) {
			     vm.isDeletedAllowed = true;
        }
        vm.gotoAddEditTemplate 	= gotoAddEditTemplate;
        vm.saveGeneral          = saveGeneral;
        vm.hotel_id = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
        vm.showSettings			= {};
        vm.canUpdate = false;
        vm.settingsTitles = {
  				'newaccountemail':'Email template for new account create',
  				'updatecustomerpassword':'Email template for update customer password',
  				'createreservation':'Email template for new reservation',
  				'holdreservation':'Email template for hold / quote reservation',
  				'checkinreservation':'Email template for checked-in reservation',
  				'checkoutreservation':'Email template for checked-out reservation',
          'closereservation':'Email template for close reservation',
  				'cancelreservation':'Email template for cancel reservation',
  				'hotelcredit':'Email template for adding hotel credits',
  				'sendinvoice':'Email template for sending invoice',
          'sendorderinvoice':'Email template for sending reservation invoice',
          'resetpassword':'Email template for sending reset password email',
          'gitftcardemail':'Email template for sending gift card email during cancellation',
          'giftcardfeemail':'Email template for gift card create',
          'updateFeReservation':'Email template for modify reservation for frontend',
          'customRefundEmail':'Email template for custom refund',
          'createservice':'Email template for creating service',
          'checkoutSecondEmail':'Email template for after checkout second email',
          'checkoutThirdEmail':'Email template for after checkout third email',
  				'checkoutFourthEmail':'Email template for after checkout fourth email',
          'newMailchimpSubscriberEmail':'Email template to create MailChimp Subscriber',
          'preCheckinEmail':'Email template for pre check-in',
          'preRegistrationEmail':'Email template for pre registration',
        };
        function saveGeneral(settingCode){
    			if(vm.canUpdate){
    				if(settingCode !== null){
    					vm.isloading = true;
    					var seting_code = {};
    					seting_code[settingCode] = vm.showSettings[settingCode];
    					var data = {'setting':seting_code,'selectedHotel':vm.hotel_id};
    					emailsservice.updateSettings(data).then(function(response){
    						vm.isloading = false;
    						if(response){
    							for ( var i = 0; i < response.settings.length; i++ ){
    								var attr_code = response.settings[i].attribute_code;
    								vm.showSettings[attr_code] = {
    												value:response.settings[i].attribute_value,
    												hotel_id:response.settings[i].hotel_id,
    												setting_id:response.settings[i].setting_id,
    												setting_title:vm.settingsTitles[attr_code]
    											};
    							}
    						}else{
    							toastMessage.showSimpleToast('There is some error. Please check','error-toast');
    						}
    					});
    				}
    			}
    		}
        /*Start*/
    		$scope.paginatorCallback = paginatorCallback;
    		$scope.getLoadResultsCallback = getLoadResultsCallback;

    		$scope.selectedRowCallback = function(rows){
    			vm.selectedUserId = rows;
    		};

        vm.websites = Organizations.organizations;
        /**
         * Initialize settings
         */
    		vm.templates = Templates.allTemplates;
    		for ( var i = 0; i < Settings.settings.length; i++ ){
    			var attr_code = Settings.settings[i].attribute_code;
    			vm.showSettings[attr_code] = {
    							value:Settings.settings[i].attribute_value,
    							hotel_id:Settings.settings[i].hotel_id,
    							setting_id:Settings.settings[i].setting_id,
    							setting_title:vm.settingsTitles[attr_code]
    						};
    		}

    		$scope.$on('$viewContentLoaded', function(){
    			vm.canUpdate = true;
    		});

        if(Templates.hasOwnProperty('prefix_Settings') && Object.keys(Templates.prefix_Settings).length > 0){
    			vm.prefix_Settings = Templates.prefix_Settings;
    			for ( var i = 0; i < vm.templates.length; i++ )
    			{
    				var website = vm.templates[i].hotel_id;
    				vm.templates[i].orgprefix = vm.prefix_Settings[website].orgprefix;
    			}
    		}

        var loadPageCallbackWithDebounce;

        $scope.$watch('filterText', function(){

          if(loadPageCallbackWithDebounce){
            loadPageCallbackWithDebounce();
          }
        });
        $scope.showTabDialog = function(ev, id) {
          roleService.getRolePermissions(id).then(function(response){
            if(response.listData.length ==0){
              toastMessage.showSimpleToast('This role has no module assigned.','error-toast');
            } else {
              $state.go('app.rolesPermission',{id:id});

            }
          });
        };
        $scope.updateTable= function() {
          loadPageCallbackWithDebounce();
        };

        $scope.toggleAll = function() {
            var toggleStatus = !$scope.isAllSelected;
            $scope.ChangeAll = toggleStatus;
        }


          $scope.checkBox = function(value) {
            if (vm.selectedUserId.indexOf(value) > -1 )
            {
              vm.selectedUserId.splice(vm.selectedUserId.indexOf(value), 1);
            }
            else
            {
              vm.selectedUserId.push(value);
            }
            if(vm.selectedUserId.length > 0){
              vm.getNumberOfSelectedRows = vm.selectedUserId.length;
              vm.checkDelete = true;
            } else {
              vm.checkDelete = false;
            }
          };

        vm.loggedinUserRole = $localStorage.roleId;

        function getLoadResultsCallback(loadPageCallback){
			    loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
        }
        vm.UserColumns = ['template_name', 'template_subject', 'EditId' ];

        function paginatorCallback(page, pageSize,option){
            if(typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] != 'undefined'){

              var page =  $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
              var pageSize = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'];
            }
            vm.page = page;
            vm.pageSize = pageSize;
            vm.checkDelete = false;
            vm.selectedUserId = [];
            var sort = {};
            for(var i=0; i<option.columnSort.length; i++){
                if(option.columnSort[i]['sort']){
                    sort['column']= vm.UserColumns[i];
                    sort['order']= option.columnSort[i]['sort'];
                }
            }

            var offset = (page-1) * pageSize;
            var query = $scope.filterText ? $scope.filterText : '';
            var filterData = {'offset':offset , 'pageSize': pageSize, 'search':$scope.filterText , 'sort':sort, 'hotel_id':vm.hotel_id};

            return $http({
                url: EnvironmentConfig.api+'emailtemplates/get_templates',
                method:'POST',
                data:filterData
            }).then(function(result){
              vm.templates =result.data['allTemplates'];
              vm.totalTemplates =result.data['totalTemplates'];
              return {
                results: result.data['allTemplates'],
                totalResultCount: result.data['totalTemplates']
              }
            });
          }
          /*End*/




		 /**
         * Delete Selected Users
         */
         $scope.deleteSelectedItem = function(ev){
			var confirm = $mdDialog.confirm()
			.title('Are you sure, you want to delete the selected template(s)?')
			.htmlContent('<b>' + vm.selectedUserId.length + ' template(s)</b>' + ' will be deleted.')
			.ariaLabel('delete users')
			.targetEvent(ev)
			.ok('OK')
			.cancel('CANCEL');

			$mdDialog.show(confirm).then(function ()
			{
				emailsservice.deleteTemplate(vm.selectedUserId).then(function(response){
					if(response.errorMsg){
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					}else{
						vm.selectedUserId = [];
						toastMessage.showSimpleToast('Templates(s) deleted successfully.','success-toast');
						loadPageCallbackWithDebounce();
					}
				});
			});
        }

		$scope.addmodel = function (ev, template_id)
        {
          if(vm.userPermissions.indexOf('update_email_template') != -1) {
            $state.go('app.settings_email',{"edit_template_id" : template_id});
          }

        }

    function gotoAddEditTemplate(){
			$state.go('app.settings_email_add',{"edit_template_id" : "add"});
		}
    }
})();

'use strict';

angular
	.module('app.settings.emails')
	.factory('emailsservice', EmailsService);

function EmailsService($http, EnvironmentConfig){
	
	function getDataFailed(error) {
			return error.data;
	}

	function getDataComplete(response) {
 		return response.data;
 	}
	function getTemplates(data){
		return $http({
			url:EnvironmentConfig.api+'emailtemplates/get_templates',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getEmailSettings(data){
		return $http({
			url:EnvironmentConfig.api+'emailtemplates/get_email_settings',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function updateSettings(data){
		return $http({
			url:EnvironmentConfig.api+'emailtemplates/update_settings',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getTemplate(data){
		return $http({
			url:EnvironmentConfig.api+'emailtemplates/get_template',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function uniqueTemplateName(data){
		return $http({
			url:EnvironmentConfig.api+'emailtemplates/unique_template_name',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function updateTemplate(data){
		return $http({
			url:EnvironmentConfig.api+'emailtemplates/update_template',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function deleteTemplate(data){
		return $http({
			url:EnvironmentConfig.api+'emailtemplates/delete_template',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	var service = {
		getTemplate: getTemplate,
		uniqueTemplateName: uniqueTemplateName,
		updateSettings: updateSettings,
		deleteTemplate: deleteTemplate,
		getEmailSettings: getEmailSettings,
		updateTemplate: updateTemplate,
		getTemplates: getTemplates
	};
	return service;
}

(function () {
    'use strict';

    angular
        .module('app.settings.dailyRentals', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.settings_daily_rentals', {
            url: '/daily-rentals-settings',
            title: 'Daily Rentals Settings',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/settings/dailyRentals/dailyRentals.html',
                    controller: 'DailyRentalsController as vm'
                }
            },
            resolve: {
                DailyRentalsSettings: function (dailyRentalsService, $localStorage) {
                    return dailyRentalsService.getSettings({
                        hotel_id: $localStorage.hotels[$localStorage.selectedHotel].hotel_id
                    });
                }
            },
            permission: 'daily_rentals'
        });

        $translatePartialLoaderProvider.addPart('app/main/apps/settings/dailyRentals');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings.dailyRentals')
        .factory('dailyRentalsService', DailyRentalsService);

    /** @ngInject */
    function DailyRentalsService($http, EnvironmentConfig) {
        return {
            getSettings: getSettings,
            saveSettings: saveSettings
        };

        function getDataComplete(response) {
            return response.data;
        }

        function getDataFailed(error) {
            return error.data;
        }

        function getSettings(data) {
            return $http({
                url: EnvironmentConfig.api + 'DailyRentalsSetting/daily_rentals_settings',
                method: 'POST',
                data: data
            })
                .then(getDataComplete)
                .catch(getDataFailed);
        }

        function saveSettings(data) {
            return $http({
                url: EnvironmentConfig.api + 'DailyRentalsSetting/update_settings',
                method: 'POST',
                data: data
            })
                .then(getDataComplete)
                .catch(getDataFailed);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.restaurant',
            [
                // 3rd Party Dependencies
                'xeditable',
                'credit-cards'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.restaurant', {
            url    : '/restaurant',
            title  : 'Restaurant',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/checkout/checkout.html',
                    controller : 'checkoutController as vm'
                }
            },
            params:{
                checkin: '',
                checkout: '',
                cartIndex:0,
                product_id:'',
                product_name:'',
                addServiceForRoom: false,
                showaddDialog: false,
                typeofService: 'restaurant'

            },
             resolve  : {
                productData: function (checkoutService,$stateParams, $localStorage){
                     var happy_hours = false;
                    if(typeof $localStorage['restaurant' + $localStorage['preHotelId']] != 'undefined' && $localStorage['restaurant' + $localStorage['preHotelId']]){
                       happy_hours =  $localStorage['restaurant' + $localStorage['preHotelId']]?true:false;
                    }
                    return checkoutService.getCheckoutCategory($stateParams.typeofService, happy_hours);
                }
            },
			permission: 'restaurant'
        }).state('app.restaurant-settings', {
            url    : '/restaurant-settings',
            title  : 'Restaurant Settings',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/restaurant/settings/restaurant-settings.html',
                    controller : 'restaurantSettingsController as vm'
                }
            },
            resolve  : {
                restaurantData: function (restaurantSettingsService){
                    return restaurantSettingsService.getRestaurantSettings();
                }
            }
        }).state('app.restaurant-orders', {
            url    : '/restaurant-orders',
            title  : 'Restaurant Orders',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/checkout/posorders/posorders.html',
                    controller : 'posOrdersController as vm'
                }
            },
            params   : {toast_message:false, typeofService: 'restaurant'},
            /*resolve  : {
                restaurantData: function (restaurantSettingsService){
                    return restaurantSettingsService.getRestaurantSettings();
                }
            }*/
        }).state('app.restaurant-order', {
            url    : '/restaurant-order/:one_go_id',
            title  : 'Restaurant Orders',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/checkout/posorders/order/posorder.html',
                    controller : 'posOrderController as vm'
                }
            },
            resolve  : {
                Order: function (checkoutService, $stateParams){
                    return checkoutService.getOrderInfo({'one_go_id':$stateParams.one_go_id});
                }
            },
            permission: 'bar_orders'
        }).state('app.restaurantCheckout', {
            url    : '/add-restaurant-in-create-order',
            title  : 'Restaurant Orders',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/checkout/checkout.html',
                    controller : 'checkoutController as vm'
                }
            },
            params:{
                checkin: '',
                checkout: '',
                cartIndex:0,
                product_id:'',
                product_name:'',
                product_room_number:'',
                addServiceForRoom: true,
                typeofService: 'restaurant',
                taxValue:false,
                pageFrom: '',
                itinerary_number:'',
                policy_id:'',
                confirmation_number:'',
                one_go_id:''
            },
            resolve  : {
                productData: function (checkoutService,$stateParams){
                    return checkoutService.getCheckoutCategory($stateParams.typeofService);
                }
            }
        }).state('app.cook-dashboard', {
            url    : '/cook-dashboard',
            title  : 'Cook Dashboard',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/restaurant/cooks/cook-dashboard.html',
                    // templateUrl: 'app/main/apps/restaurant/orderDetail/restaurant-detail.html',
                    controller : 'restaurantCookController as vm'
                }
            },
            resolve  : {
                cookData: function (restaurantService){
                    return restaurantService.fetchRestaurantCookOrders();
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/restaurant');

    }

})();

(function() {
    'use strict';

    angular
        .module('app.restaurant')
        .controller('RestaurantDialogController', RestaurantDialogController);

    /** @ngInject */
    function RestaurantDialogController($mdDialog, data, restaurantSettingsService) {
        var vm = this;
        vm.title       = Object.keys(data).length > 0 ? 'Edit Setting' : 'Add Setting';
        vm.settings    = data;
        vm.settings.has_cost = (data.has_cost !== undefined && data.has_cost === '1') ? true : false;
        vm.optionTypes = [{'id': 'dropdown', 'name': 'Drop down'}, {'id': 'multichoice', 'name': 'Multi Choice'}, {'id': 'text', 'name': 'text'}];
        vm.showAlreadyExistError = false;
        vm.autoFillOff = true;
        /**
         * Save setting
         */
        vm.saveTask = function() {
            if (!vm.showAlreadyExistError) {
                restaurantSettingsService.addUpdateSetting(vm.settings).then(function(response){
                    vm.closeDialog();
                });
            }
        }

        /**
        * check same name already exist
        */
        vm.checkSameNameExist = function() {
            if (vm.settings.field_name !== undefined && vm.settings.field_name !== '') {
                restaurantSettingsService.checkNameAlreadyExist({'field_name': vm.settings.field_name, 'field_id': vm.settings.field_id}).then(function(response){
                    if (response !== undefined && response.trim() === "false") {
                       vm.showAlreadyExistError = true;
                    } else {
                        vm.showAlreadyExistError = false;
                    }
                });
            } else {
                vm.showAlreadyExistError = false;
            }
        }

        /**
         * Close dialog
         */
        vm.closeDialog = function() {
            $mdDialog.hide();
        }
        setTimeout(function() {
           vm.autoFillOff = false;
        }, 1500); 
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.rateRule',
            [
                // 3rd Party Dependencies
                'gantt',
                'gantt.sortable',
                'gantt.movable',
                'gantt.drawtask',
                'gantt.tooltips',
                'gantt.bounds',
                'gantt.progress',
                'gantt.table',
                'gantt.tree',
                'gantt.groups',
                'gantt.dependencies',
                'gantt.overlap',
                'gantt.resizeSensor'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.rateRule', {
            url    : '/rateRule',
            title  : 'Rate Calender',
            views  : {
                /*'content@app': {
                    templateUrl: 'app/main/apps/rateRule/rateRule.html',
                    controller : 'rateRuleController as vm'
                }*/
                'content@app': {
                    templateUrl: 'app/main/apps/rateRule/rateCustomCalendar.html',
                    controller : 'rateCustomCalendarController as vm'
                }
            },            
            resolve  : {
                RateRule: function ($localStorage,rateRuleService){
                    return rateRuleService.getCustomRateRuleData({hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id});
                }
            },
			/*resolve  : {
                RateRule: function ($localStorage,rateRuleService){
					return rateRuleService.getRateRuleData({hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id});
				}
			 },*/
			 permission: 'rate_calendar'
        })
        .state('app.rateCalOld', {
            url    : '/revenue-management/rateCalendarOld',
            title  : 'Rate Calender',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/rateRule/rateRule.html',
                    controller : 'rateRuleController as vm'
                }
            },
            resolve  : {
                RateRule: function ($localStorage,rateRuleService){
                    return rateRuleService.getRateRuleData({hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id});
                }
            },
            permission: 'rate_calendar'
        })
        .state('app.negotiatedRateRule', {
            url    : '/negotiatedRateRule',
            title  : 'Negotiated Rate Calender',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/rateRule/negotiatedRateRule/negotiatedRateRule.html',
                    controller : 'negotiatedRateRuleController as vm'
                }
            },
            resolve  : {
                RateRule: function ($localStorage,negotiatedRateService){
                    return negotiatedRateService.getNegotiatedRateRuleData({hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id});
                }
             },
             permission: 'rate_calendar'
        }).state('app.rateCal', {
            url    : '/revenue-management/rateCalendar',
            title  : 'Rate Calender',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/rateRule/rateCustomCalendar.html',
                    controller : 'rateCustomCalendarController as vm'
                }
            },
            resolve  : {
                RateRule: function ($localStorage,rateRuleService){
                    return rateRuleService.getCustomRateRuleData({hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id});
                }
            },
            permission: 'rate_calendar'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/rateRule');

    }

})();

(function ()
{
	'use strict';
	angular
	.module('app.rateRule')
	.controller('NegoRateDialogController', NegoRateDialogController);

	/** @ngInject */
	function NegoRateDialogController($mdDialog, Ratedata, toastMessage, $localStorage, $scope, negotiatedRateService, $rootScope,$translate,optionsSel) {
		var vm = this;
		// Data
		vm.title = $translate.instant('RATERULE.QUICK_ROW_UPDATE');
		vm.rateMaxError = false;
		vm.showLoader = false;
		vm.currentDateValue = new Date();
		vm.selectedDays = ['1', '2', '3', '4', '5', '6', '0'];
		vm.daysWeek = {1:$translate.instant('RATERULE.MONDAY'), 2:$translate.instant('RATERULE.TUESDAY'), 3:$translate.instant('RATERULE.WEDNESDAY'), 4:$translate.instant('RATERULE.THURSDAY'), 5:$translate.instant('RATERULE.FRIDAY'), 6:$translate.instant('RATERULE.SATURDAY'), 0:$translate.instant('RATERULE.SUNDAY')};
		var dataRate = Ratedata;
		vm.autoFillOff = true;
		if(!dataRate.room_type_id || !dataRate.rate_plan_id || !dataRate.channel_id || !dataRate.date || !dataRate.current_val){
			toastMessage.showSimpleToast('There was some error in fetching prices for selected range.','error-toast');
			$mdDialog.hide();
		}else{
			vm.indexTask = dataRate.index;
			vm.raterule = {};
			vm.raterule.negotiated_rate_type_id = dataRate.negotiated_rate_type_id;
			vm.raterule.sub_hotel_id        = dataRate.sub_hotel_id;
			vm.raterule.rate_plan_id        = dataRate.rate_plan_id;
			vm.raterule.channel_id          = dataRate.channel_id;
			vm.raterule.date                = dataRate.date;
			vm.optionsSel 					= optionsSel;
			vm.raterule.room_type_price     = dataRate.current_val;
			vm.raterule.hotel_id            = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
		}
		
		//Methods
		vm.closeDialog = closeDialog;
		vm.saveRowPrice= saveRowPrice;
		vm.addSelectedDays= addSelectedDays;
		$scope.checkList = function() {
			$scope.user.roles.splice(0, $scope.user.roles.length); 
			$scope.user.roles.push('guest');
		};

		function addSelectedDays(dayWeek){
			if(vm.selectedDays.indexOf(dayWeek) === -1){//adding a day
				vm.selectedDays.push(dayWeek);
			}else{//removing a day
				vm.selectedDays.splice(vm.selectedDays.indexOf(dayWeek), 1);
			}
		}

		vm.requestProgressing = false;
		function saveRowPrice(){
			var data = {
				data: vm.raterule,
				from_range: moment(vm.from_range).format('YYYY-MM-DD'),
				to_range: moment(vm.to_range).format('YYYY-MM-DD'),
				selectedDays: vm.selectedDays,
				pageView: optionsSel
			};
			vm.showLoader = true;
			vm.requestProgressing = true;
			negotiatedRateService.setRateRuleBatch(data).then(function(response){
				vm.showLoader = false;
				if(response.success){
					vm.closeDialog();
					$rootScope.$broadcast('update_full_ganttchart');
				}else if(response.errorMsg){
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				} else{
					toastMessage.showSimpleToast('There was some error in updating prices.','error-toast');
				}
				vm.requestProgressing = false;
			});
		}

		function closeDialog() {
			$mdDialog.hide();
		}

		setTimeout(function() {
           vm.autoFillOff = false;
        }, 1500); 
	}
})();

(function ()
{
	'use strict';

	angular
	.module('app.rateRule')
	.controller('NegoBulkUpdateDialogCont', NegoBulkUpdateDialogCont);

	/** @ngInject */
	function NegoBulkUpdateDialogCont(
		$mdDialog, 
		RoomsRateChannel, 
		RateData, 
		channelsData, 
		Rooms_sub_hotel_ids,
		pageFrom, 
		toastMessage, 
		$localStorage, 
		$scope, 
		negotiatedRateService, 
		$rootScope,
		extraParams,
		$translate,
		$timeout,
		$httpParamSerializer,
		dashboardGraphService,
		casitas_data,
		negotiatedRates
		){
		var vm = this;
		console.log("extraParams", extraParams);
		// Data
		if(pageFrom == "dashboard"){
			vm.title = $translate.instant('RATERULE.EDIT_MLS_SMALL');
		} else {
			vm.title = $translate.instant('RATERULE.BULK_UPDATE_SMALL');
		}
		vm.rateMaxError = false;
		vm.ratebulk = [];
		vm.currentTab = 'room';
		vm.previousRecords = {};
		vm.autoFillOff = true;
		if (extraParams !== undefined && extraParams != null) {
			vm.previousRecords = angular.copy(extraParams); 
		}

		vm.ratebulk.selectedDays = ['1', '2', '3', '4', '5', '6', '0'];
		vm.daysWeek = {1:$translate.instant('RATERULE.MONDAY'), 2:$translate.instant('RATERULE.TUESDAY'), 3:$translate.instant('RATERULE.WEDNESDAY'), 4:$translate.instant('RATERULE.THURSDAY'), 5:$translate.instant('RATERULE.FRIDAY'), 6:$translate.instant('RATERULE.SATURDAY'), 0:$translate.instant('RATERULE.SUNDAY')};
		/*if(pageFrom == "dashboard"){
			if(extraParams.min_stay) {
				vm.optionsAvail = {5:$translate.instant('RATERULE.MIN_STAY')};
			} else if(extraParams.max_stay) {
				vm.optionsAvail = {6:$translate.instant('RATERULE.MAX_STAY')};
			} else if(extraParams.is_stop_sell) {
				vm.optionsAvail = {2:$translate.instant('RATERULE.STOP_SELL')};
			} else if(extraParams.is_cta) {
				vm.optionsAvail = {3:$translate.instant('RATERULE.CTA')};
			} else if(extraParams.is_ctd) {
				vm.optionsAvail = {4:$translate.instant('RATERULE.CTD')};
			}
		} else {*/
			// vm.optionsAvail = {1:$translate.instant('RATERULE.RATES'), 2:$translate.instant('RATERULE.STOP_SELL'), 3:$translate.instant('RATERULE.CTA'), 4:$translate.instant('RATERULE.CTD'), 5:$translate.instant('RATERULE.MIN_STAY'), 6:$translate.instant('RATERULE.MAX_STAY')};
			vm.optionsAvail = {1:$translate.instant('RATERULE.RATES')};
		// }

		vm.optionsSel = 1;
        vm.selectRate = 'new';
        vm.rate_plan_adjust_indicator = '1';
        vm.rate_plan_percentage = '0';
		vm.ratebulk.seleRates = [];
		vm.roomsRates = [];
		vm.showRoomBoatsBulk = false;
		vm.type = 'rooms';
		vm.hotelID = $localStorage.preHotelId;
		var roomIDs;
		vm.roomcasitas = [];
		vm.parentRoom = [];



		
		for(var key in RoomsRateChannel){
		    if(key !== 'Boat'){
		        vm.roomsRates = vm.roomsRates.concat(RoomsRateChannel[key]);
		    }
		}
		vm.ratesData = RateData['room'];
		vm.channelsData = channelsData;

		// Code For Boat
		vm.userPermissions = $rootScope.userPermissions;
		/*if (vm.userPermissions.indexOf('boats') != -1) {
			vm.showRoomBoatsBulk = true;
			if(pageFrom == "dashboard"){
				vm.showRoomBoatsBulk = false;
			}
		} */ 
		// Code For Boat
		vm.currentDateValue = new Date();
		vm.ratebulk.seleRates.rate = [];
		vm.ratebulk.seleRates.channels = [];
		vm.ratebulk.seleRates.rooms = [];
		vm.ratebulk.seleRates.negotiatedRates = [];
		//Methods
		vm.closeDialog = closeDialog;
		vm.addSelectedDays= addSelectedDays;
		vm.checkRange= checkRange;
		vm.saveBulkPrice= saveBulkPrice;
		vm.addSelectedData= addSelectedData;
		vm.addSelectedDataRoom= addSelectedDataRoom;
		vm.showRooms = showRooms;
		vm.toggle = toggle;
		vm.selectall= selectall;
		vm.selectAll = [];
		vm.selectAll['rate'] = false;
		vm.selectAll['channels'] = false;
		vm.selectAll['rooms'] = false;
		vm.selectAll['negotiatedRates'] = false;
		vm.showLoader = false;

		vm.negotiatedRates = negotiatedRates;
		function selectall(type, array, idname, roomData){
			if(vm.hotelID != 128 || type != 'rooms') {
				if(vm.ratebulk.seleRates[type].length==array.length){
					vm.ratebulk.seleRates[type] = [];
					vm.selectAll[type] = true;
				}else{
					vm.ratebulk.seleRates[type] = [];	
					for(var i=0; i<=array.length-1; i++){
						vm.ratebulk.seleRates[type].push(array[i][idname]);
						vm.selectAll[type] = false;
					}
				}
			} else {
				angular.forEach(roomData, function(val, key) {
					if(!vm.selectAll['rooms']) {
						if(vm.casitasRooms.indexOf(val) === -1) {
							vm.casitasRooms.push(val.room_type_id);
						}
						var roomIDs = val.room_type_refs_id.split(',');
						angular.forEach(roomIDs, function(value, key) {
							if(vm.ratebulk.seleRates.rooms.indexOf(value) === -1) {
								vm.ratebulk.seleRates.rooms.push(value);
							}
						});						
					} else {
						vm.casitasRooms.filter(function(value, index){ return vm.casitasRooms.indexOf(value) == index });
						var index = vm.casitasRooms.indexOf(val.room_type_id);
						vm.casitasRooms.splice(index,1);
						var roomIDs = val.room_type_refs_id.split(',');
						angular.forEach(roomIDs, function(value, key) {
							var roomInd = vm.ratebulk.seleRates.rooms.indexOf(value);
							vm.ratebulk.seleRates.rooms.splice(roomInd, 1);
						});
					}
					vm.ratebulk.seleRates.rooms = removeDuplicates(vm.ratebulk.seleRates.rooms);
					vm.casitasRooms = removeDuplicates(vm.casitasRooms);
				});
			}
		}
		// Select all rooms of same type
		function addSelectedDataRoom(type, room_ref_ids, outerRoomID, event){
			if(vm.casitasRooms.indexOf(outerRoomID) === -1) {
				if(vm.casitasRooms.indexOf(outerRoomID) === -1) {
					vm.casitasRooms.push(outerRoomID);
				}
				var roomIDs = room_ref_ids.split(',');
				angular.forEach(roomIDs, function(val, key) {
					if(vm.ratebulk.seleRates.rooms.indexOf(val) === -1) {
						vm.ratebulk.seleRates.rooms.push(val);
					}
				});
				if(vm.casitasRooms.length == 4){
					vm.selectAll['rooms'] = true;
				}
			} else {
				var ind = vm.casitasRooms.indexOf(outerRoomID);
				vm.casitasRooms.splice(ind,1);
				var roomIDs = room_ref_ids.split(',');
				angular.forEach(roomIDs, function(val, key) {
					var roomInd = vm.ratebulk.seleRates.rooms.indexOf(val);
					vm.ratebulk.seleRates.rooms.splice(roomInd, 1);
				});
				vm.selectAll['rooms'] = false;

			}
			vm.ratebulk.seleRates.rooms = removeDuplicates(vm.ratebulk.seleRates.rooms);
			vm.casitasRooms = removeDuplicates(vm.casitasRooms);
			event.stopPropagation();
		}


		function addSelectedData(type,id,array,roomRateID, event){
			if(!vm.ratebulk.seleRates[type]) vm.ratebulk.seleRates[type] = [];
			if(vm.ratebulk.seleRates[type].indexOf(id)===-1){
				vm.ratebulk.seleRates[type].push(id);
			} else {
				vm.ratebulk.seleRates[type].splice(vm.ratebulk.seleRates[type].indexOf(id), 1);
				if(vm.hotelID == 128) {
					if(vm.casitasRooms.indexOf(roomRateID) > -1) {
						var ind = vm.casitasRooms.indexOf(roomRateID);
						vm.casitasRooms.splice(ind,1);
						vm.selectAll['rooms'] = false;
					}
				}
			}
			if(vm.hotelID == 128 && type == 'rooms') {
				angular.forEach(array, function(val, index) {
					var arr = val.room_type_refs_id.split(",");
					var counter = 0;
					angular.forEach(vm.ratebulk.seleRates.rooms, function(value, index) {
						if(arr.indexOf(value) !== -1) {
							counter++;
						}
					});
					if(parseInt(counter) == parseInt(arr.length)) {
						vm.casitasRooms.push(val.room_type_id);
					}
				});				
			} else {
				if(vm.ratebulk.seleRates[type].length==array.length) {
					vm.selectAll[type] = true;
				} else {
					vm.selectAll[type] = false;
				}
			}
			event.stopPropagation();
		}
		function addSelectedDays(dayWeek){
			if(vm.ratebulk.selectedDays.indexOf(dayWeek) === -1){//adding a day
				vm.ratebulk.selectedDays.push(dayWeek);
			}else{//removing a day
				vm.ratebulk.selectedDays.splice(vm.ratebulk.selectedDays.indexOf(dayWeek), 1);
			}
		}
		vm.queryRunning = false;
		function saveBulkPrice(){
			vm.queryRunning = true;
			vm.showLoader = true;
			
			if (vm.optionsSel > 1) {
				vm.selectAll['rate'] = false;
				vm.selectall('rate',vm.ratesData,'rate_plan_id');
			}
			
			vm.ratebulk.seleRates['room_sub_hotel_id'] = Rooms_sub_hotel_ids;
			var converted = Object.assign({}, vm.ratebulk.seleRates);
			var data = {
				seleRates 	 	: 	converted,
				selectedDays 	: 	vm.ratebulk.selectedDays,
				hotel_id 	 	: 	$localStorage.hotels[$localStorage.selectedHotel]['hotel_id'],
				from_range 	 	: 	new Date(moment(vm.from_range).format('YYYY-MM-DD')),
				to_range	 	: 	new Date(moment(vm.to_range).format('YYYY-MM-DD')),
				pageView	 	: 	vm.optionsSel,
				selectRate   	: 	vm.selectRate,
				rate_plan_adjust_indicator : vm.rate_plan_adjust_indicator,
				rate_plan_percentage       : vm.rate_plan_percentage,
				room_type_price : vm.ratebulk.room_type_price
			};
			
			
			data.type = vm.type;
			console.log("Option Sel ----> ", data);
			console.log("vm.previousRecords ----> ", vm.previousRecords);
			vm.updateBulkChanges(data);
		}


		vm.updateBulkChanges = function(data) {
			negotiatedRateService.setBulkRateRule(data).then(function(response){
				vm.showLoader = false;
				if(response.success){
					if(response.message){
						toastMessage.showSimpleToast(response.message,'success-toast');
					} else {
						vm.closeDialog();
					}
					if (pageFrom == 'dashboard') {
						$rootScope.$broadcast('updateMLS');
					} else {
						$rootScope.$broadcast('update_full_ganttchart');
					}
				} else if (response.errorMsg){
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				} else{
					toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
				}
				vm.queryRunning = false;
			});
		};

		function checkRange(){
			vm.rateMaxError = false;
			if(vm.ratebulk.room_type_price>1000){
				vm.rateMaxError = true;
			}
		}
		function closeDialog()
		{
			$mdDialog.hide();
		}
		
		function showRooms(){
			if(vm.type == 'rooms'){
				vm.currentTab = 'room';
				vm.roomsRates = RoomsRateChannel['Room'];
				vm.ratesData = RateData['room'];
			} else {
				vm.type = 'boats';
				vm.currentTab = 'boat';
				vm.roomsRates = RoomsRateChannel['Boat'];
				vm.ratesData = RateData['boat'];
			}
		}

		function removeDuplicates(arr){
		    var unique_array = []
		    for(var i = 0;i < arr.length; i++){
		        if(unique_array.indexOf(arr[i]) == -1){
		            unique_array.push(arr[i])
		        }
		    }
		    return unique_array
		}

		function toggle(id) {
			var innerID = 'innerroom'+id;
			var ele = angular.element(document.getElementById(innerID));
			ele.slideToggle();
			var outerID = 'outerroom'+id;
			var outerEle = angular.element(document.getElementById(outerID));
			outerEle.toggleClass('show-md-icon');
		}

		setTimeout(function() {
           vm.autoFillOff = false;
       	}, 1500); 
	}
})();

'use strict';

angular
	.module('app.permissions.organizations')
	.factory('organizationsservice', OrganizationsService);

function OrganizationsService($http, EnvironmentConfig){
	
	function getDataFailed(error) {
			return error.data;
	}

	function getDataComplete(response) {
 		return response.data;
 	}

	function getorganizations(data){
		return $http({
			url:EnvironmentConfig.api+'organizations/organizations',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
	function getorganizationsbulk(){
		return $http({
			url:EnvironmentConfig.api+'organizations/skipAcl_get_all_org',
			method:'POST'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function addNewOrganization(data){
		return $http({
			url:EnvironmentConfig.api+'organizations/add_organization',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function deleteOrganization(data){
		return $http({
			url:EnvironmentConfig.api+'organizations/delete_organization',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getModules(data){
		return $http({
			url:EnvironmentConfig.api+'acl/skipAcl_module_get',
			method:'GET',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
	var service = {
		getorganizations: getorganizations,
		getorganizationsbulk: getorganizationsbulk,
		addNewOrganization: addNewOrganization,
		deleteOrganization: deleteOrganization,
		getModules: getModules
	};
	return service;
}

(function ()
{
    'use strict';

    angular
        .module('app.permissions.organization',
            [
                // 3rd Party Dependencies
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $stateProvider.state('app.permissions_organization_add', {
            url    : '/hotel/add',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/permissions/organization/organization.html',
                    controller : 'OrganizationController as vm'
                }
            },
            resolve: {
                Organization: function (organizationservice,$stateParams){
                    return organizationservice.getorganization('add');
                },
                Organizations: function (organizationservice,$stateParams){
                    return organizationservice.getorganizations();
                }
            },
            permission: 'add_hotel'
        }).state('app.permissions_organization_edit', {
            url    : '/hotel/:id',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/permissions/organization/organization.html',
                    controller : 'OrganizationController as vm'
                }
            },
            resolve: {
                Organization: function (organizationservice,$stateParams){
                    return organizationservice.getorganization($stateParams.id);
                },
                Organizations: function (organizationservice,$stateParams){
                    return organizationservice.getorganizations();
                }
            },
            permission: 'update_hotel'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/permissions/organization');
    }
})();

'use strict';

angular
	.module('app.permissions.organization')
	.factory('organizationservice', OrganizationService);

function OrganizationService($http, EnvironmentConfig){
	
	function getDataFailed(error) {
			return error.data;
	}

	function getDataComplete(response) {
 		return response.data;
 	}

	function getorganization(id){
		var data = {id:id,getsubHotels:true};
		return $http({
			url:EnvironmentConfig.api+'organizations/organizations',
			method:'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getorganizations(onlyOrganizations){
		var data = {onlyOrganizations:onlyOrganizations};
		return $http({
			url:EnvironmentConfig.api+'organizations/organizations',
			method:'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getrolesWiseNav(userId){
		var data = {user_id:userId};
		return $http({
			url:EnvironmentConfig.api+'organizations/getrolesWiseNav',
			method:'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function deleteSelectedModule(orgId,actionid){
		var data = {hotel_id:orgId,action_id:actionid};
		return $http({
			url:EnvironmentConfig.api+'organizations/skipAcl_remove_action_website',
			method:'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function addSelectedModule(orgId,actionid){
		var data = {hotel_id:orgId,action_id:actionid};
		return $http({
			url:EnvironmentConfig.api+'organizations/skipAcl_add_action_website',
			method:'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function deleteAllModule(orgId,allmodules){
		var data = {hotel_id:orgId,allmodules:allmodules};
		return $http({
			url:EnvironmentConfig.api+'organizations/skipAcl_remove_action_website',
			method:'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function addAllModule(orgId,allmodules){
		var data = {hotel_id:orgId,allmodules:allmodules};
		return $http({
			url:EnvironmentConfig.api+'organizations/skipAcl_add_action_website',
			method:'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function addSingleRoom(data){
		return $http({
			url:EnvironmentConfig.api+'organizations/addSingleRoom',
			method:'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function addUpdateSingleBoat(data){
		return $http({
			url:EnvironmentConfig.api+'organizations/addUpdateSingleBoat',
			method:'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function checkUnique(data){

		return $http({
			url:EnvironmentConfig.api+'organizations/skipAcl_check_unique',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
		
	}
	function changeStatusRooms(data){
		return $http({
			url:EnvironmentConfig.api+'organizations/changeStatusRooms',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
		
	}
	function changeStatusBoat(data){
		return $http({
			url:EnvironmentConfig.api+'organizations/changeStatusBoat',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
		
	}
	function updateOrganization(orgdata,selMods,selRooms, selBoats){
		return $http({
			url:EnvironmentConfig.api+'organizations/update_organization',
			method:'POST',
			data:{orgdata:orgdata,selMods:selMods,selRooms:selRooms, selBoats:selBoats}
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	var service = {
		getorganization: getorganization,
		changeStatusRooms: changeStatusRooms,
		changeStatusBoat: changeStatusBoat,
		getorganizations: getorganizations,
		deleteSelectedModule: deleteSelectedModule,
		addSelectedModule: addSelectedModule,
		deleteAllModule: deleteAllModule,
		addAllModule: addAllModule,
		updateOrganization: updateOrganization,
		addSingleRoom: addSingleRoom,
		addUpdateSingleBoat: addUpdateSingleBoat,
		checkUnique: checkUnique
	};
	return service;
}

(function () {

    'use strict';

    angular
        .module('app.guest-message-center')
        .controller(
            'MessageTemplatesController',
            MessageTemplatesController
        );

    /** @ngInject */
    function MessageTemplatesController(
        messageCenterService,
        $mdDialog,
        toastMessage
    ) {

        var vm = this;
        vm.templateTypes = [];
        vm.categories = [];
        vm.templates = [];

        vm.totalTemplates = 0;

        vm.selectedTemplateType = null;
        vm.selectedCategory = null;

        vm.loading = false;
        vm.categoryLoading = false;
        vm.templateLoading = false;

        vm.init = function () {
            vm.getMessageTemplateTypes();
        };

        vm.getMessageTemplateTypes = function () {

            vm.loading = true;

            messageCenterService
                .getMessageTemplateTypes()
                .then(function (response) {

                    if (
                        response &&
                        response.success !== false
                    ) {

                        vm.templateTypes =
                            response.data || [];

                        vm.totalTemplates =
                            vm.templateTypes.length;

                    } else {

                        vm.templateTypes = [];
                        vm.totalTemplates = 0;

                    }

                })
                .catch(function (error) {

                    console.error(
                        'getMessageTemplateTypes error:',
                        error
                    );

                    vm.templateTypes = [];
                    vm.totalTemplates = 0;

                })
                .finally(function () {

                    vm.loading = false;

                });

        };

        vm.selectTemplateType = function (templateType) {

            if (!templateType) {
                return;
            }

            if (
                vm.selectedTemplateType &&
                vm.selectedTemplateType.template_type ===
                    templateType.template_type
            ) {
                return;
            }

            vm.selectedTemplateType = templateType;

            vm.categories = [];
            vm.templates = [];

            vm.selectedCategory = null;

            vm.getTemplatesGrouped(
                templateType.template_type
            );

        };

        vm.getTemplatesGrouped = function (templateType) {

            if (!templateType) {
                return;
            }

            vm.categoryLoading = true;

            messageCenterService
                .getTemplatesGrouped({
                    template_type: templateType
                })
                .then(function (response) {

                    if (
                        response &&
                        response.success !== false
                    ) {

                        vm.categories =
                            response.data || [];

                    } else {

                        vm.categories = [];

                    }

                })
                .catch(function (error) {

                    console.error(
                        'getTemplatesGrouped error:',
                        error
                    );
                    vm.categories = [];

                })
                .finally(function () {
                    vm.categoryLoading = false;
                });

        };

        vm.selectCategory = function (category) {

            if (!category) {
                return;
            }

            if (
                vm.selectedCategory &&
                String(vm.selectedCategory.id) === String(category.id)
            ) {
                return;
            }

            vm.selectedCategory = category;
            vm.templates = [];
            vm.getTemplates(category.id);

        };

        vm.openAddCategory = function ($event) {
            vm.openCategoryDialog($event, null);
        };

        vm.openEditCategory = function ($event, category) {

            if (!category || !category.id) {
                return;
            }

            if ($event) {
                $event.stopPropagation();
            }

            vm.openCategoryDialog($event, category);
        };

        vm.openCategoryDialog = function ($event, category) {

            if (!vm.selectedTemplateType) {
                return;
            }

            $mdDialog.show({
                controller: 'McTemplateCategoryDialogController',
                controllerAs: 'vm',

                templateUrl: 'app/main/apps/guest-message-center/templates/message-templates/dialogs/category-dialog.html',

                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: false,

                resolve: {
                    category: function () {
                        return category || null;
                    },

                    templateType: function () {
                        return vm.selectedTemplateType.template_type;
                    }
                }

            }).then(function (result) {

                if (result) {
                    vm.getTemplatesGrouped(
                        vm.selectedTemplateType.template_type
                    );
                }

            });

        };

        vm.deleteCategory = function ($event, category) {

            if (!category || !category.id) {
                return;
            }

            if ($event) {
                $event.stopPropagation();
            }

            $mdDialog.show({
                controller: 'confirmController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    title: 'Delete Category',
                    htmlContent: 'Are you sure you want to delete "' +
                        (category.name || 'this category') +
                        '"? All message templates in this category will also be deleted.',
                    cancelBtn: 'Cancel',
                    OkBtn: 'Delete'
                }
            }).then(function (answer) {

                if (answer !== 'update') {
                    return;
                }

                messageCenterService
                    .deleteTemplateCategory({
                        id: parseInt(category.id, 10)
                    })
                    .then(function (response) {

                        if (!response || response.success === false) {
                            toastMessage.showSimpleToast(
                                (response && response.message) ||
                                    'Unable to delete category.',
                                'error-toast'
                            );
                            return;
                        }

                        if (
                            vm.selectedCategory &&
                            String(vm.selectedCategory.id) ===
                                String(category.id)
                        ) {
                            vm.selectedCategory = null;
                            vm.templates = [];
                        }

                        vm.getTemplatesGrouped(
                            vm.selectedTemplateType.template_type
                        );

                    })
                    .catch(function () {
                        toastMessage.showSimpleToast(
                            'Unable to delete category.',
                            'error-toast'
                        );
                    });

            });

        };

        vm.getTemplates = function (categoryId) {

            if (!categoryId) {
                vm.templates = [];
                return;
            }

            vm.templateLoading = true;

            messageCenterService
                .getTemplates({
                    category_id: categoryId
                })
                .then(function (response) {

                    if (
                        response &&
                        response.success !== false
                    ) {
                        vm.templates = response.data || [];
                    } else {
                        vm.templates = [];
                    }
                })
                .catch(function (error) {
                    console.error(
                        'getTemplates error:',
                        error
                    );
                    vm.templates = [];
                })
                .finally(function () {
                    vm.templateLoading = false;
                });
        };

        vm.openAddTemplate = function ($event) {

            if (!vm.selectedCategory) {
                return;
            }

            vm.openTemplateDialog($event, null);
        };

        vm.openEditTemplate = function ($event, template) {

            if (!template || !template.id) {
                return;
            }

            vm.openTemplateDialog($event, template);
        };

        vm.deleteTemplate = function ($event, template) {

            if (!template || !template.id) {
                return;
            }

            if ($event) {
                $event.stopPropagation();
            }

            $mdDialog.show({
                controller: 'confirmController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                locals: {
                    title: 'Delete Template',
                    htmlContent: 'Are you sure you want to delete "' +
                        (template.name || 'this template') +
                        '"?',
                    cancelBtn: 'Cancel',
                    OkBtn: 'Delete'
                }
            }).then(function (answer) {

                if (answer !== 'update') {
                    return;
                }

                messageCenterService
                    .deleteTemplate({
                        id: parseInt(template.id, 10)
                    })
                    .then(function (response) {

                        if (!response || response.success === false) {
                            toastMessage.showSimpleToast(
                                (response && response.message) ||
                                    'Unable to delete template.',
                                'error-toast'
                            );
                            return;
                        }

                        if (vm.selectedCategory) {
                            vm.getTemplates(vm.selectedCategory.id);
                        }

                    })
                    .catch(function () {
                        toastMessage.showSimpleToast(
                            'Unable to delete template.',
                            'error-toast'
                        );
                    });

            });

        };

        vm.openTemplateDialog = function ($event, template) {

            $mdDialog.show({
                controller: 'McTemplateDialogController',
                controllerAs: 'vm',

                templateUrl:
                    'app/main/apps/guest-message-center/templates/message-templates/dialogs/template-dialog.html',

                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: false,

                resolve: {

                    category: function () {
                        return vm.selectedCategory;
                    },

                    templateType: function () {
                        return vm.selectedTemplateType;
                    },

                    template: function () {
                        return template || null;
                    },

                    templates: function () {
                        return vm.templates;
                    }
                }

            }).then(function (result) {

                if (result) {
                    vm.getTemplates(vm.selectedCategory.id);
                }

            });

        };

        vm.init();
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .controller('GroupMessageLogDialogController', GroupMessageLogDialogController);

    /** @ngInject */
    function GroupMessageLogDialogController(
        $mdDialog,
        messageCenterService,
        broadcastLogId,
        propertyLabel,
        propertyLabels,
        getReasonLabelFn
    )
    {
        var vm = this;
        var reasonLabelFn = getReasonLabelFn || function (reason) { return reason || ''; };

        vm.loading = true;
        vm.errorMessage = '';
        vm.log = null;
        vm.propertyLabel = propertyLabel || 'All hotels';
        vm.propertyLabels = (propertyLabels && propertyLabels.length)
            ? propertyLabels
            : [vm.propertyLabel];
        vm.results = [];
        vm.filteredResults = [];
        vm.statusFilter = 'all';
        vm.counts = { sent: 0, skipped: 0, failed: 0 };

        vm.close = close;
        vm.setStatusFilter = setStatusFilter;
        vm.getChannelLabel = getChannelLabel;
        vm.getStatusLabel = getStatusLabel;
        vm.getDetailLabel = getDetailLabel;
        vm.formatSentAt = formatSentAt;

        load();

        function load()
        {
            vm.loading = true;
            vm.errorMessage = '';

            messageCenterService.getBroadcastLog({ id: broadcastLogId }).then(function (response) {
                if (!response || response.success === false || !response.data) {
                    vm.errorMessage = (response && response.message) || 'Unable to load group message details.';
                    return;
                }

                vm.log = response.data;
                vm.results = (vm.log.details && vm.log.details.results) || [];
                refreshCounts();
                applyFilter();
            }).catch(function () {
                vm.errorMessage = 'Unable to load group message details.';
            }).finally(function () {
                vm.loading = false;
            });
        }

        function refreshCounts()
        {
            var i;
            var status;
            var counts = { sent: 0, skipped: 0, failed: 0 };

            for (i = 0; i < vm.results.length; i++) {
                status = (vm.results[i].status || '').toLowerCase();
                if (counts[status] !== undefined) {
                    counts[status] += 1;
                }
            }

            vm.counts = counts;
        }

        function setStatusFilter(filter)
        {
            vm.statusFilter = filter || 'all';
            applyFilter();
        }

        function applyFilter()
        {
            var i;
            var row;
            var filtered = [];

            if (vm.statusFilter === 'all') {
                vm.filteredResults = vm.results.slice();
                return;
            }

            for (i = 0; i < vm.results.length; i++) {
                row = vm.results[i];
                if ((row.status || '').toLowerCase() === vm.statusFilter) {
                    filtered.push(row);
                }
            }

            vm.filteredResults = filtered;
        }

        function getChannelLabel(channel)
        {
            var value = (channel || '').toLowerCase();

            if (value === 'whatsapp') {
                return 'WhatsApp';
            }

            if (value === 'sms') {
                return 'SMS';
            }

            if (value === 'default') {
                return 'Default';
            }

            return channel || '—';
        }

        function getStatusLabel(status)
        {
            var value = (status || '').toLowerCase();

            if (value === 'sent') {
                return 'Sent';
            }

            if (value === 'skipped') {
                return 'Skipped';
            }

            if (value === 'failed') {
                return 'Failed';
            }

            return status || '—';
        }

        function getDetailLabel(row)
        {
            var status = ((row && row.status) || '').toLowerCase();
            var reason = reasonLabelFn(row && row.reason);

            if (status === 'sent') {
                return reason || 'Delivered';
            }

            return reason || '—';
        }

        function formatSentAt(value)
        {
            if (!value) {
                return '';
            }

            // API returns hotel-local created_at as YYYY-MM-DD HH:mm:ss.
            if (typeof moment === 'function') {
                var m = moment(value, ['YYYY-MM-DD HH:mm:ss', moment.ISO_8601], true);
                if (m.isValid()) {
                    return m.format('MM-DD-YYYY HH:mm:ss');
                }
            }

            return String(value).replace(/\//g, '-');
        }

        function close()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .controller('GmcMediaPreviewDialogController', GmcMediaPreviewDialogController);

    /** @ngInject */
    function GmcMediaPreviewDialogController($mdDialog, Image)
    {
        var vm = this;

        vm.image = Image;
        vm.closeDialog = closeDialog;

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
	'use strict';

	angular
	.module('app.e-commerce')
	.controller('taxesController', taxesController);

	/** @ngInject */
	function taxesController($document, $rootScope, $state, $scope, $http, EnvironmentConfig, $mdDialog, eCommerceService, toastMessage, $localStorage,organizationsservice,CurrentTax)
	{
		var vm = this;

		vm.tax = [];
		vm.tax.currenttaxdata = CurrentTax.taxDetail;
		vm.tax.currentWebsite = 0;
		vm.isloading = false;
		vm.notGoodPercent = {};
		vm.loggedinUserRole = $localStorage.roleId;
		vm.autoFillOff = true;
        // Methods
        vm.addNewTax = addNewTax;
        vm.updateTax = updateTax;
        vm.updateTaxList = updateTaxList;
        
        eCommerceService.getTaxNames().then(function(response){
			vm.defalutTaxName = response;
		});


        /**
         * Go to add product
         */
         function addNewTax(ev)
         {
         	$mdDialog.show({
         		controller         : 'taxDialogControllers',
         		controllerAs       : 'vm',
         		templateUrl        : 'app/main/apps/e-commerce/views/tax/tax-dialog.html',
         		parent             : angular.element($document.find('#content-container')),
         		targetEvent        : ev,
         		scope:$scope.$new(),
         		clickOutsideToClose: true,
         		locals             : {
         			Tax : {},
         			DefaultTax: vm.defalutTaxName,
         			Websites: vm.websites
         		}
         	});
         	jQuery('.sec-contact-tab').css('display','none');
         	jQuery('.third-contact-tab').css('display','none');
         }

			function updateTax(id,value,tax_name,hotel_id){
				if(value < 0 || value > 100){
					vm.notGoodPercent[id] = true;
					return;
				}else{
					var reg = new RegExp("^[a-z A-Z]+$");
					if(reg.test(value)){
						vm.notGoodPercent[id] = true;
						return;
					}
					vm.notGoodPercent[id] = false;
				}
				vm.isloading = true;
				var data = {'id':id,'tax_value':value,'tax_name':tax_name,'old_hotel_id':hotel_id};
				if(id && value){
					eCommerceService.updateTax(data).then(function(response){
						vm.isloading = false;
						vm.tax.currenttaxdata = response.taxDetail;
						vm.notGoodPercent={};
					});
				}
			}

         function updateTaxList(){
         	eCommerceService.updateTaxList(vm.hotel).then(function(response){
         		vm.tax.currenttaxdata = response.taxDetail;
         		vm.notGoodPercent={};
         	});


         }

        setTimeout(function() {
           vm.autoFillOff = false;
       	}, 1500); 
     }
 })();

(function ()
{
	'use strict';

	angular
	.module('app.e-commerce')
	.controller('taxDialogControllers', taxDialogControllers);

	/** @ngInject */
	function taxDialogControllers($state, $mdDialog, Tax, msUtils, roleService, toastMessage, $localStorage, $scope, eCommerceService, DefaultTax, Websites){
		
		var vm = this;
		// Data
		vm.tax_exists = false;
		vm.tax 		= angular.copy(Tax);
		vm.websites = Websites;
		vm.defaultTax = DefaultTax;
		vm.autoFillOff = true;
		if(Object.keys(Tax).length === 0){
			vm.title = 'Add Tax Type';
			vm.taxButton = false;
			vm.tax = Tax;
			vm.tax.websites = [];
		} else {
			vm.title 		= 'Edit tax type';
			vm.taxButton 	= true;
			vm.tax 			= Tax.data;
			vm.tax.tax_value = parseInt(vm.tax.tax_value);
		}
		vm.autocompleteDemoRequireMatch = true;
		vm.selectedItem 	= null;
		vm.searchText 		= null;
		vm.notGoodPercent 	= false;


		// Methods
		vm.addNewTax 		= addNewTax;
		vm.closeDialog 		= closeDialog;
		vm.saveTax 			= saveTax;
		vm.checkTaxExists	= checkTaxExists;

		/*Search*/
		var pendingSearch, cancelSearch = angular.noop;
		var lastSearch;

		vm.asyncContacts = [];
		vm.filterSelected = true;
		vm.querySearch = querySearch;
		vm.delayedQuerySearch = delayedQuerySearch;
   	/**
    * Search for UserData; use a random delay to simulate a remote call
    */
    function querySearch (criteria) {
    	return criteria ? vm.allWebsites.filter(createFilterFor(criteria)) : [];
    }
    
    function checkTaxExists () {
		var data = {'tax_name':vm.tax.tax_name};
    	eCommerceService.checkTaxExists(data)
		 	.then(function(response){
				if(response.exists){
					vm.tax_exists = true;
				}else{
		 			vm.tax_exists = false;
		 		}
			});
    }

   	/**
    * Async search for UserData
    * Also debounce the queries; since the md-contact-chips does not support this
    */
    function delayedQuerySearch(criteria) {
    	if ( !pendingSearch || !debounceSearch() )  {
    		cancelSearch();

    		return pendingSearch = $q(function(resolve, reject) {
         // Simulate async search... (after debouncing)
         cancelSearch = reject;
         $timeout(function() {

         	resolve( vm.querySearch(criteria) );

         	refreshDebounce();
         }, Math.random() * 500, true)
     });
    	}

    	return pendingSearch;
    }

    function refreshDebounce() {
    	lastSearch = 0;
    	pendingSearch = null;
    	cancelSearch = angular.noop;
    }

   	/**
    * Debounce if querying faster than 300ms
    */
    function debounceSearch() {
    	var now = new Date().getMilliseconds();
    	lastSearch = lastSearch || now;

    	return ((now - lastSearch) < 300);
    }

   	/**
    * Create filter function for a query string
    */
    function createFilterFor(query) {
    	var lowercaseQuery = angular.lowercase(query);

    	return function filterFn(contact) {
    		return (contact._lowername.indexOf(lowercaseQuery) != -1);
    	};
    }

	/**
	* Add Tax
	*/
		function addNewTax(){
			if(vm.tax_exists){
				toastMessage.showSimpleToast('This tax type already exists.','error-toast');
			}else{
				if(vm.tax.tax_value < 0 || vm.tax.tax_value > 100){
					vm.notGoodPercent = true;
					return;
				}else{
					if(/[a-zA-Z]/.test(vm.tax.tax_value)){
						vm.notGoodPercent[id] = true;
						return;
					}
					vm.notGoodPercent = false;
				}
				eCommerceService.addTax(vm.tax)
				.then(function(response){
					if(response.errorMsg){
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					} else if(response.sucess){
						$state.reload();
						$mdDialog.hide();
					}else{
						toastMessage.showSimpleToast('There was some error in creating tax type.','error-toast');
					}
				});
			}
		}
		
		/**
		* Save Tax
		*/
		function saveTax(){

		 	eCommerceService.UpdateTax(vm.tax)
		 	.then(function(response){
		 		
		 		if(response.error){
		 			if(response.type == 'exists'){
		 				toastMessage.showSimpleToast('Tax with same name and value already exists','error-toast');
		 			} else {
		 				toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
		 			} 
		 		}else {
		 			toastMessage.showSimpleToast('Tax updated successfully','success-toast');
		 			$scope.updateTable();
		 			$mdDialog.hide();
		 		}
		 	});
		 }

		/**
		* Close dialog
		*/
		function closeDialog(){
		 	$mdDialog.hide();
		}

		setTimeout(function() {
           vm.autoFillOff = false;
       	}, 1500); 
		}
	})();

(function() {
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('RoomtypesController', RoomtypesController);

    /** @ngInject */
    function RoomtypesController(
        $state,
        $scope,
        $localStorage,
        EnvironmentConfig,
        $http,
        $mdDialog,
        roomTypeService,
        toastMessage,
        $sessionStorage,
        $rootScope,
        $stateParams
    ) {
        var vm = this;

        if (!$rootScope.backButtonPressed) {
            $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']] = {};
            $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']]['currentPage'] = 1;
            $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']]['pageSize'] = 50;
        }

        vm.pageType = $stateParams['page_type'];  
        if(vm.pageType == 'Rooms'){
            $scope.addtype = 'ROOM_TYPE';
            $scope.headers = {
                'table-row-id-key': 'room_type_id',
                'column-keys': [
                'room_type_name',
                'max_occupancy',
                'room_type_description',
                'status_type',
                'room_type_id'
                ],
            };
        } else {
            $scope.addtype = 'BOAT_TYPE';
            $scope.headers = {
                'table-row-id-key': 'room_type_id',
                'column-keys': [
                'room_type_name',
                'boat_length',
                'room_type_description',
                'status_type',
                'room_type_id'
                ],
            };
        } 

        $scope.paginatorCallback = paginatorCallback;
        $scope.LoadAllData = LoadAllData;
        $scope.getLoadResultsCallback = getLoadResultsCallback;
        $scope.editType = editType;
        vm.loggedinUserRole = $localStorage.roleId;
        vm.hotelID = $rootScope.hotels[$rootScope.selectedHotel].hotel_id;
        vm.deSelectRoomTypes = deSelectRoomTypes;
        vm.SelectRoomTypes = SelectRoomTypes;
        vm.userPermissions = $rootScope.userPermissions;
        vm.prodId = [];
        vm.isDeleteAllowed = false;
        if (vm.userPermissions.indexOf('delete_room') != -1) vm.isDeleteAllowed = true;
        /*********************************/
        /**** Paginate Room type data ****/
        /*********************************/
        $scope.selectedRowCallback = function(rows, id) {
            vm.selectedProdIds = rows;
        };

        function getLoadResultsCallback(loadPageCallback) {
            loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
        }
        vm.UserColumns = ['r.room_type_name', 'r.max_occupancy', 'r.room_type_description', 'r.status_type', 'r.room_type_id'];


        vm.onLoad = true;
        vm.requestGoing = false;

        function paginatorCallback(page, pageSize, option) {
            if (vm.requestGoing) return;
            if (vm.onLoad == true) {
                if (typeof $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']]['currentPage'] != 'undefined') {

                    var page1 = $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']]['currentPage'];
                    var pageSize1 = $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']]['pageSize'];
                    vm.onLoad = false;
                    return LoadAllData(page1, pageSize1, option);
                } else {
                    vm.onLoad = false;
                    return LoadAllData(page, pageSize, option);
                }
            } else {
                if (typeof page == 'undefined') {
                    page = $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']]['currentPage'];
                }
                return LoadAllData(page, pageSize, option);
            }

        }

        function LoadAllData(page, pageSize, option) {

            vm.requestGoing = true;
            var pageDetail = {
                'currentPage': page,
                'pageSize': pageSize
            };
            $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']] = pageDetail;


            vm.page = page;
            vm.pageSize = pageSize;
            vm.checkDelete = false;
            vm.selectedProdIds = [];
            var sort = {};
            for (var i = 0; i < option.columnSort.length; i++) {
                if (option.columnSort[i]['sort']) {
                    sort['column'] = vm.UserColumns[i];
                    sort['order'] = option.columnSort[i]['sort'];
                }
            }
            var offset = (page - 1) * pageSize;
            var query = $scope.filterText ? $scope.filterText : '';
            var filterData = {
                'offset': offset,
                'pageSize': pageSize,
                'search': $scope.filterText,
                'sort': sort,
                'hotel_id': vm.hotelID,
                'dataType':vm.pageType
            };
            return $http({
                url: EnvironmentConfig.api + 'roomtypes/room_types',
                method: 'POST',
                data: filterData
            }).then(function(result) {
                vm.requestGoing = false;
                if (result.data.status === 'success') {
                    vm.RoomTypes = result.data.data.roomTypes;
                    vm.totalRoomTypes = result.data.data.totalRoomType;
                    return {
                        results: result.data.data.roomTypes,
                        totalResultCount: result.data.data.totalRoomType
                    }
                } else {
                    toastMessage.showSimpleToast(result.data.errorMsg, 'error-toast');
                }
            });
        }

        /*********************************/
        /******* Delete Room type **********/
        /*********************************/

        $scope.deleteSelectedItem = function(ev) {


            // new
            var html = ' Are you sure, you want to delete the selected room(s)? </br>';
            html = html + '<b>' + vm.selectedProdIds.length + ' room type(s)</b>' + ' will be deleted.';

            $mdDialog.show({
                    controller: 'confirmController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: true,
                    locals: {
                        title: 'Delete Room',
                        htmlContent: html,
                        cancelBtn: 'Cancel',
                        OkBtn: 'Ok'
                    }
                })
                .then(function(answer) {
                    if (typeof answer != 'undefined' && answer == 'update') {
                        roomTypeService.deleteSelectedRoomTypes(vm.selectedProdIds, vm.hotelID)
                            .then(function(response) {
                                if (!response.error) {
                                    //toastMessage.showSimpleToast('Customer has been deleted successfully.','success-toast');
                                    vm.selectedProdIds = [];
                                    vm.checkDelete = false;
                                    loadPageCallbackWithDebounce();

                                } else {
                                    toastMessage.showSimpleToast('There was some error in deleting customers.', 'error-toast');
                                }
                            });
                    }
                }, function() {});
            //Old
        };

        /**
         * Dselect room types
         */
        function deSelectRoomTypes() {
            vm.selectedProdIds = [];
            vm.prodId = [];
        }

        /**
         * Select all room types
         */
        function SelectRoomTypes() {
            if (vm.checkAll) {
                vm.selectedProdIds = [];
                vm.prodId = [];
                for (var i = 0; i < vm.RoomTypes.length; i++) {
                    vm.selectedProdIds.push(vm.RoomTypes[i].room_type_id);
                }
                //  angular.forEach($scope.Items, function (item) {
                //     item.Selected = $scope.selectedAll;
                // });
                vm.deleteCheckbox = true;
            } else {
                vm.deleteCheckbox = false;
                vm.selectedProdIds = [];
            }
        }

        /*********************************/
        /******* Edit Room type **********/
        /*********************************/
        $scope.editRoomType = function(value) {
            if (vm.userPermissions.indexOf('update_room') != -1) {
                if(vm.pageType == 'Rooms'){
                    $state.go("app.e-commerce.roomtypes.update", {
                        roomTypeID: value
                    });
                } else {
                    $state.go("app.e-commerce.boattypes.update", {
                        roomTypeID: value
                    });
                }
            }
        };

        function editType(value) {
            if(vm.pageType == 'Rooms'){
                $state.go("app.e-commerce.roomtypes.update", {
                    roomTypeID: value
                });
            } else {
                $state.go("app.e-commerce.boattypes.update", {
                    roomTypeID: value
                });
            }
        };
        var loadPageCallbackWithDebounce;
        $scope.$watch('filterText', function() {
            if (loadPageCallbackWithDebounce) {
                loadPageCallbackWithDebounce();
            }
        });

        vm.GotoAddUpdatePage = GotoAddUpdatePage;
        function GotoAddUpdatePage(){
            if(vm.pageType == 'Rooms')
                $state.go("app.e-commerce.roomtypes.add");
            else
                $state.go("app.e-commerce.boattypes.add");
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('RoomtypeController', RoomtypeController);

    /** @ngInject */
    function RoomtypeController(
        roomTypeService,
        roomTypeComponentData,
        roomTypeData,
        $localStorage,
        $state,
        Upload,
        $scope,
        EnvironmentConfig,
        $timeout,
        toastMessage,
        $mdDialog,
        $document,
        $translate,
        $rootScope,
        $interval,
        $stateParams,
        tabMode,
        $q
    ) {

        var vm = this;
        var progress = '';
        vm.flag = tabMode;
        vm.pageType = $stateParams['page_type'];
        vm.setIndex=0;
        vm.rentType = false;
        vm.options = {
            id: 'srp_card_color',
            name: 'srp_card_color',
            inputClass: 'srp_card_color',
            restrictToFormat: true,
            format: 'hexString', 
            hue: true,
            saturation: true,
            lightness: true,
        };
        vm.autoFillOff = true;
        $scope.eventApi = {
            onChange:  function(api, color, $event) {
                vm.saveEachField(color, 'srp_card_color');
            },
        };

        $rootScope.$on('uploadedImages', function (event, args) {
            vm.imageData = args.data;
            var index=args.index;
            var crop=args.crop
            console.log("data===",vm.imageData);
            var loopPromises = [];
            if(vm.flag == 'edit'){
                vm.uploadedFiles = [];
                angular.forEach(vm.imageData, function(value, index) {
                    var deferred = $q.defer();
                    loopPromises.push(deferred.promise);
                    vm.uploadedFiles.push(value);
                    console.log("uploadedFiles=====",vm.uploadedFiles);
                });
            } else{
                if(crop){
                    angular.forEach(vm.imageData, function(value, index) {
                        var deferred = $q.defer();
                        loopPromises.push(deferred.promise);
                        vm.uploadedFiles.push(value);
                        console.log("uploadedFiles=====",vm.uploadedFiles);
                    }); 
                    vm.setIndex = vm.uploadedFiles.length -1;
                    console.log(vm.setIndex);
                } else {    
                    angular.forEach(vm.uploadedFiles, function(fileValue, fileindex) {
                        angular.forEach(vm.imageData, function(value, index) {
                            if(fileindex == index){
                                vm.uploadedFiles[fileindex] =value;
                            }
                            var deferred = $q.defer();
                            loopPromises.push(deferred.promise);
                            console.log("uploadedFiles=====",vm.uploadedFiles);
                        });
                    });
                }
                
            }
            
        });

        vm.sec_color_options = {
            id: 'srp_card_color_sec',
            name: 'srp_card_color_sec',
            inputClass: 'srp_card_color',
            restrictToFormat: true,
            format: 'hexString', 
            hue: true,
            saturation: true,
            lightness: true, 
        };
        $scope.eventApi1 = {
            onChange:  function(api, color, $event) {
                vm.saveEachField(color, 'srp_card_color_sec');
            },
        };

        vm.loggedInUserRole = angular.copy(parseInt($localStorage.roleId));

        vm.roomTypeData = {};
        vm.userPermissions = $rootScope.userPermissions;
        vm.roomTypeData.nbr_of_bedrooms = 1;
        vm.roomType = {};
        vm.uploadedFiles = [];
        vm.failedFiles = [];
        vm.checkUniqueRoom = checkUniqueRoom;
        vm.reload = false;
        vm.nameError = false;
        vm.updateSubHotel = false;
        vm.nameRoomError = false;
        vm.guestAmountError = false;
        vm.feBaseUrl = EnvironmentConfig.feBase_url;
        vm.progress = false;
        vm.status = [{
            'value': 'active',
            'name': 'Active'
        }, {
            'value': 'inactive',
            'name': 'Inactive'
        }];
        vm.roomTypeData.non_smoking_ind = 1;
        vm.roomTypeData.status_type = 'active';
        // $timeout(function() {
        //     vm.reload = true;
        // }, 4000);
        var hotelID = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
        vm.hotel_id = hotelID;
        vm.tax_id = [];

        if(vm.pageType == 'Rooms'){
            $scope.addtype = 'ROOM_TYPE';
            vm.roomTypeData.room_type = 'room';
        } else {
            $scope.addtype = 'BOAT_TYPE';
            vm.roomTypeData.room_type = 'boat';
        } 
        if (roomTypeComponentData.status === 'success') {
            vm.roomType.bedTypeData = roomTypeComponentData.data.bedTypeData;
            vm.roomType.roomLocationData = roomTypeComponentData.data.roomLocationData;
            vm.roomType.roomQualityData = roomTypeComponentData.data.roomQualityData;
            vm.roomType.RoomTypeData = roomTypeComponentData.data.RoomTypeData;
            vm.roomType.additionalProducts = roomTypeComponentData.data.additionalProducts;
            vm.roomType.roomViewData = roomTypeComponentData.data.roomViewData;
            vm.roomType.roomTaxData = roomTypeComponentData.data.roomTaxData;
            vm.roomType.room_numbers = Object.assign({}, roomTypeComponentData.data.hotel_rooms);
            vm.roomType.childHotels = roomTypeComponentData.data.childHotels;
        }
         
        if (roomTypeData.status === 'success') {
            // vm.flag = 'edit';
            vm.roomTypeData = roomTypeData.data.roomTypeData;
            if(vm.roomTypeData.room_type == "rent_type"){
                vm.rentType=true;
            }
            vm.rooms = vm.roomTypeData.nbr_of_bedrooms;
            vm.pagetitle = vm.roomTypeData.room_type_name;
            vm.tax_id = vm.roomTypeData.tax_id;
            vm.roomTypeData.product_room_number=[];
            vm.roomTypeData.product_room_bundle=[];
            for(var i=0;i<Object.keys(vm.roomType.room_numbers).length;i++){
                if(vm.pageType == 'Rooms'){
                    if(vm.roomTypeData.hasOwnProperty('room_number_sel') && vm.roomTypeData.room_number_sel.indexOf(vm.roomType.room_numbers[i].room_no)>=0){
                        vm.roomTypeData.product_room_number[i]=i;
                    }
                    if(vm.roomTypeData.hasOwnProperty('room_number_sel_bundle') && vm.roomTypeData.room_number_sel_bundle.indexOf(vm.roomType.room_numbers[i].room_no)>=0){
                        vm.roomTypeData.product_room_bundle[i]=i;
                    }
                } else {
                    if(vm.roomTypeData.hasOwnProperty('room_number_sel') && vm.roomTypeData.room_number_sel.indexOf(vm.roomType.room_numbers[i].boat_no)>=0){
                        vm.roomTypeData.product_room_number[i]=i;
                    }
                    if(vm.roomTypeData.hasOwnProperty('room_number_sel_bundle') && vm.roomTypeData.room_number_sel_bundle.indexOf(vm.roomType.room_numbers[i].boat_no)>=0){
                        vm.roomTypeData.product_room_bundle[i]=i;
                    }
                }
            }
            if(vm.roomTypeData.hasOwnProperty('is_bundle')){
                vm.roomTypeData.is_bundle = vm.roomTypeData.is_bundle == 1? true:false;
            }
            vm.uploadedFiles = roomTypeData.data.roomImages;
            if(vm.uploadedFiles.length==0){
                vm.doCrop=true;
                $("#my").css("display","block");
            }else{
                vm.doCrop=false;
                // $("#my").css("display","none");
            }
            
        } else if (roomTypeData.status === 'error') {
            if(vm.pageType == 'Boats'){
                $state.go('app.e-commerce.boattypes');
            } else {
                $state.go('app.e-commerce.roomtypes');
            }
        }
        vm.checkIfRoomTypeCodeExists = checkIfRoomTypeCodeExists;

        function checkIfRoomTypeCodeExists(){
            if(vm.flag === 'add'){
               var data = {'room_type_code':vm.roomTypeData.room_type_code};
            }else{
                var data = {'room_type_code':vm.roomTypeData.room_type_code,type_id:vm.roomTypeData.room_type_id};
            }
             roomTypeService.checkRoomTypeCode(data)
                .then(function(response) {
                    if(response.codeExists){
                        vm.roomCodeExists = response.codeExists;
                    } else {
                        vm.roomCodeExists = response.codeExists;
                        vm.saveEachField(vm.roomTypeData.room_type_code, 'room_type_code');
                    }
                });
        }
       
        vm.goBack = function(){
            if(vm.pageType == 'Boats'){
                $state.go('app.e-commerce.boattypes');
            } else {
                $state.go('app.e-commerce.roomtypes');
            }
        }    
       
        /**
         * imageViewer will show image in popup
         * @param ev
         */
        vm.imageViewer = function(ev, image,catalog_product_media_id,imgIndex,cover_photo) {
            var url = cover_photo;
            var parts = url.split("/");
            var last_part = parts[parts.length-1];
            var imageName=last_part;
            var imageFullPath = EnvironmentConfig.api + 'assets/uploads/hotels/org/' + image;
            $mdDialog.show({
                controller: 'RoomtypeDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/e-commerce/views/roomtype/dialogs/roomtype/roomtype-dialog.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    Image: imageFullPath,
                    originalImage: catalog_product_media_id,
                    typeId: vm.roomTypeData.room_type_id,
                    type : "",
                    pageType:vm.flag,
                    imageIndex:imgIndex,
                    coverPhoto:imageName
                }
            });
        }

        vm.handleFileSelect=function(evt) {
          var file=evt.currentTarget.files[0];
          console.log(evt.currentTarget.files);
          var reader = new FileReader();
          reader.onload = function (evt) {
            $scope.$apply(function($scope){
              var myImage=evt.target.result;
              vm.imageCrop(evt, myImage,file);
              console.log(myImage);
            });
          };
          reader.readAsDataURL(file);
        };

        vm.imageCrop = function(ev, image, imageData) {
           var imageFullPath = EnvironmentConfig.api + 'assets/uploads/hotels/org/' + image;
           $mdDialog.show({
               controller: 'RoomtypeDialogController',
               controllerAs: 'vm',
               templateUrl: 'app/main/apps/e-commerce/views/roomtype/dialogs/roomtype/roomtype-dialog.html',
               parent: angular.element($document.find('#content-container')),
               targetEvent: ev,
               clickOutsideToClose: true,
               locals: {
                   Image: image,
                   originalImage: imageData,
                   typeId: vm.roomTypeData.room_type_id,
                   type : "cropping",
                   pageType:vm.flag,
                   imageIndex:"",
                   coverPhoto:""
               }
           });
       }

        /************************************/
        /********* Add new Room Type ********/
        /************************************/

        // vm.flag 
        vm.addRoomType = function(data) {
            data.hotel_id = vm.hotel_id;
            data.created_by_user = $localStorage.userId;
            vm.uploadedFilesfinal=[];
            var loopPromises = [];
            // angular.forEach(vm.uploadedFiles, function(value, index) {
            //     var deferred = $q.defer();
            //     loopPromises.push(deferred.promise);
            //     vm.uploadedFilesfinal.push(value);
            //     deferred.resolve();
            // });
            // angular.forEach(vm.uploadedFilesfinal, function(value, index) {
            //     var url = value.cover_photo;
            //     var parts = url.split("/");
            //     var last_part = parts[parts.length-1];
            //     var imageName=last_part;
            //     vm.uploadedFilesfinal[index].cover_photo= imageName;
            // });
            
            console.log(vm.uploadedFiles);
            data.images = vm.uploadedFiles;
            var setIndex=vm.setIndex;
            if(vm.rentType){
                data.room_type = 'rent';                    
            }
            var roomNumbers = angular.copy(vm.roomTypeData.product_room_number);
            if(roomNumbers.length > 1){
                if(vm.pageType == 'Rooms'){
                    data.room_type = 'room_type';
                } else {
                    data.room_type = 'boat_type';
                }
                if(vm.rentType){
                    data.room_type = 'rent_type';                    
                }
            }
            var product_room_bundle = [];
            if(vm.roomTypeData.hasOwnProperty('product_room_bundle'))
                product_room_bundle = angular.copy(vm.roomTypeData.product_room_bundle);
            var key = 0;
            // data.product_room_number = {};
            data.product_room_bundle = {};
            data.hotel_room_id = {};
            for(var i=0;i<roomNumbers.length;i++){
                key = roomNumbers[i];
                if(product_room_bundle.indexOf(key) != -1){
                    data.product_room_bundle[i] = 1;
                } else {
                    data.product_room_bundle[i] = 0;
                }
                if(vm.pageType == 'Rooms')
                    data.product_room_number[i] = vm.roomType.room_numbers[key].room_no;
                else
                    data.product_room_number[i] = vm.roomType.room_numbers[key].boat_no;
                data.hotel_room_id[i] = vm.roomType.room_numbers[key].id;
            }
            roomTypeService.addRoomType(data,setIndex)
                .then(function(response) {
                if (response.status === 'error') {
                    toastMessage.showSimpleToast($translate.instant('COMMON_ERROR'), 'error-toast');
                }
                if(vm.pageType == 'Boats'){
                $state.go('app.e-commerce.boattypes');
                } else {
                    $state.go('app.e-commerce.roomtypes');
                }
            });
        };

        /************************************/
        /*********** Upload Images **********/
        /************************************/
        vm.progressnum = 0;
       
       $scope.uploadFxn=function(){
            $timeout(function() {
                angular.element('#uploadImg').triggerHandler('click');
            }, 2000);
       }
        vm.uploadProductImages = function(files, errFiles, croppedDataUrl) {
            console.log(files);
            errFiles=[];
            $timeout(function() {
            console.log("croppedDataUrl====",croppedDataUrl);
            if((files == null || files.length == 0) && errFiles.length == 0) {
                return;
            }
            if (errFiles.length > 0) {
                angular.forEach(errFiles, function(value, index) {
                    switch (value.$error) {
                        case 'pattern':
                            vm.fileError = 'FILE_TYPE_NOT_SUPPORTED';
                            break;
                        case 'maxSize':
                            vm.fileError = 'FILE_SIZE_EXCEEDS';
                            break;
                        case 'minWidth':
                            vm.fileError = 'MIN_SIZE_MESSAGE';
                            break;
                        case 'minHeight':
                            vm.fileError = 'MIN_SIZE_MESSAGE';
                            break;
                        default:
                            vm.fileError = 'COMMON_IMAGE_MESSAGE';
                    }
                    toastMessage.showSimpleToast($translate.instant('ROOM_TYPE.' + vm.fileError), 'error-toast');
                });
            }
            vm.progress = true;
            vm.progressnum = 0;
            if (vm.flag === 'add') {
                files.upload = Upload.upload({
                    url: EnvironmentConfig.api + 'roomtypes/product_images',
                    data: {
                        file: files,
                        cropImg: Upload.dataUrltoBlob(croppedDataUrl),
                        mode: 'add',
                        roomTypeID: vm.roomTypeData.room_type_id
                    },
                    uploadEventHandlers: { progress: function(evt){
                        if (evt.lengthComputable) {
                            vm.progressnum = Math.round(evt.loaded * 100 / evt.total)
                        } else {
                            vm.progressnum = 'unable to compute'
                        }
                        if(vm.progressnum >= 100){
                            vm.progress = false;
                            $timeout(function() {
                                vm.processing = true;
                            },100);
                        }
                    }}
                });

                files.upload.then(function(response) {
                    $timeout(function() {
                        var loopPromises = [];
                        angular.forEach(response.data.files, function(value, index) {
                            var deferred = $q.defer();
                            loopPromises.push(deferred.promise);
                            vm.uploadedFiles.push(value);
                            deferred.resolve();
                            vm.doCrop=false;
                            // $("#my").css("display","none");
                        });
                        $q.all(loopPromises).then(function () {
                            vm.processing = false;
                            // $interval.cancel(progress);
                        });
                        vm.failedFiles = response.data.error;
                    });
                }, function(response) {
                    if (response.status > 0)
                        $scope.errorMsg = response.status + ': ' + response.data;
                }, function(evt) {
                    //vm.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            } else {
                if(croppedDataUrl!='false'){
                    files.upload = Upload.upload({
                        url: EnvironmentConfig.api + 'roomtypes/product_images',
                        data: {
                            file: files,
                            cropImg: Upload.dataUrltoBlob(croppedDataUrl),
                            mode: 'edit',
                            roomTypeID: vm.roomTypeData.room_type_id
                        },
                        uploadEventHandlers: { progress: function(evt){
                            console.log("evt : ",evt);
                            vm.doCrop=false;
                            // $("#my").css("display","none");
                            if (evt.lengthComputable) {
                                vm.progressnum = Math.round(evt.loaded * 100 / evt.total)
                            } else {
                                vm.progressnum = 'unable to compute'
                            }
                            if(vm.progressnum >= 100){
                                vm.progress = false;
                                $timeout(function() {
                                    vm.processing = true;
                                },100);
                            }
                        }}
                    });
                } else {
                    files.upload = Upload.upload({
                        url: EnvironmentConfig.api + 'roomtypes/product_images',
                        data: {
                            file: files,
                            mode: 'edit',
                            roomTypeID: vm.roomTypeData.room_type_id
                        },
                        uploadEventHandlers: { progress: function(evt){
                            console.log("evt : ",evt);
                            if (evt.lengthComputable) {
                                vm.progressnum = Math.round(evt.loaded * 100 / evt.total)
                            } else {
                                vm.progressnum = 'unable to compute'
                            }
                            if(vm.progressnum >= 100){
                                vm.progress = false;
                                $timeout(function() {
                                    vm.processing = true;
                                },100);
                            }
                        }}
                    });
                }

                files.upload.then(function(response) {
                    var loopPromises = [];
                    vm.uploadedFiles = [];
                    angular.forEach(response.data.data.files, function(value, index) {
                        var deferred = $q.defer();
                        loopPromises.push(deferred.promise);
                        vm.uploadedFiles.push(value);
                        deferred.resolve();
                    });
                    console.log(vm.uploadedFiles);
                    vm.failedFiles = response.data.data.error;
                    $q.all(loopPromises).then(function () {
                        vm.processing = false;
                    });
                }, function(response) {
                    if (response.status > 0)
                        $scope.errorMsg = response.status + ': ' + response.data;
                });
            }
            }, 1000);
        };
        /************************************/
        /********* Update Boat type *********/
        /************************************/

        vm.saveEachBoatField = function(value, field) {
            console.log(value, field);
            vm.guestAmountError = false;
            if (field == 'additional_guest_amounts' && vm.roomTypeData.additional_guest_amounts > 50) {
                vm.guestAmountError = true;
                return false;
            }
            if (vm.flag == 'edit') {
                if(field == 'accessible_ind' && value == 0){
                    vm.roomTypeData.accessible_front_door = '';
                    vm.roomTypeData.accessible_front_door_step = '';
                    vm.roomTypeData.accessible_bathroom_door = '';
                    vm.roomTypeData.accessible_closet_to_counter = '';
                    vm.roomTypeData.accessible_shower_handle = '';
                    vm.roomTypeData.accessible_toilet_handle = '';
                    vm.roomTypeData.accessible_sink_height = '';
                }
                if (vm.reload) {
                    if(field == 'is_bundle'){
                        if(vm.roomTypeData.roomData.length == 1){
                            var newData = {
                                    field: field,
                                    value: value,
                                    product_id: vm.roomTypeData.roomData[0].product_id
                                };
                        }
                    } else if(field == 'room_type_name') {
                        var newData = {
                                field: field,
                                value: value,
                                roomTypeID: vm.roomTypeData.room_type_id
                            };
                        if (vm.roomTypeData.sub_hotel_id){
                            newData.sub_hotel_id = vm.roomTypeData.sub_hotel_id;
                            }
                    } else {
                        var newData = {
                                field: field,
                                value: value,
                                roomTypeID: vm.roomTypeData.room_type_id
                            };
                    }                    
                    roomTypeService.updateBoatType(newData).then(function(response) {
                        vm.nameError = false;
                        if (response.status) {
                            vm.pagetitle = vm.roomTypeData.room_type_name;
                            if (response.status == 'duplicateName') {
                                //toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                                vm.nameRoomError = true;
                            }
                        } else {
                            toastMessage.showSimpleToast($translate.instant(response.message), 'error-toast');
                        }
                    });
                }
            } else {
                if (field == 'room_type_name' && vm.pageType == 'Rooms') {
                    checkUniqueRoom();
                }
                // if (field == 'room_type_code') {
                //     checkIfRoomTypeCodeExist();
                // }                
            }
        };

        vm.saveAdditionalProducts = function(value,field) {
            var products = value.join(',');
            vm.saveEachField(products,field);
        }

        /************************************/
        /********* Update Room type *********/
        /************************************/
        vm.saveEachField = function(value, field) {
            vm.guestAmountError = false;
            if (field == 'additional_guest_amounts' && vm.roomTypeData.additional_guest_amounts > 50) {
                vm.guestAmountError = true;
                return false;
            }
            if (vm.flag == 'edit') {
                if(field == 'accessible_ind' && value == 0){
                    vm.roomTypeData.accessible_front_door = '';
                    vm.roomTypeData.accessible_front_door_step = '';
                    vm.roomTypeData.accessible_bathroom_door = '';
                    vm.roomTypeData.accessible_closet_to_counter = '';
                    vm.roomTypeData.accessible_shower_handle = '';
                    vm.roomTypeData.accessible_toilet_handle = '';
                    vm.roomTypeData.accessible_sink_height = '';
                }
                if (vm.reload) {
                    if(field == 'is_bundle'){
                        if(vm.roomTypeData.roomData.length == 1){
                            var newData = {
                                    field: field,
                                    value: value,
                                    product_id: vm.roomTypeData.roomData[0].product_id
                                };
                        }
                    } else if(field == 'room_type_name') {
                        var newData = {
                                field: field,
                                value: value,
                                roomTypeID: vm.roomTypeData.room_type_id
                            };
                        if (vm.roomTypeData.sub_hotel_id){
                            newData.sub_hotel_id = vm.roomTypeData.sub_hotel_id;
                            }
                    } else {
                        var newData = {
                                field: field,
                                value: value,
                                roomTypeID: vm.roomTypeData.room_type_id
                            };
                    }                    
                    roomTypeService.updateRoomType(newData).then(function(response) {
                        vm.nameError = false;
                        if (response.status) {
                            vm.pagetitle = vm.roomTypeData.room_type_name;
                            if (response.status == 'duplicateName') {
                                //toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                                vm.nameRoomError = true;
                            }
                        } else {
                            toastMessage.showSimpleToast($translate.instant(response.message), 'error-toast');
                        }
                    });
                }
            } else {
                if (field == 'room_type_name') {
                    checkUniqueRoom();
                }
                // if (field == 'room_type_code') {
                //     checkIfRoomTypeCodeExist();
                // }                
            }
        };

        /************************************************/
        /********* Check Room Name to be unique *********/
        /************************************************/
        function checkUniqueRoom() {
            var hotel_id = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
            var data = {
                room_type_name: vm.roomTypeData.room_type_name,
                hotel_id: hotel_id,
                room_type_id: ''
            };
               if (vm.roomTypeData.sub_hotel_id){
                data.sub_hotel_id = vm.roomTypeData.sub_hotel_id;
            }
            if(vm.roomType.childHotels.length==0 || vm.roomTypeData.sub_hotel_id){
            roomTypeService.checkRoomTypeName(data).then(function(response) {
                if (response.status === 'error') {
                    vm.nameRoomError = true;
                } else {
                    vm.nameRoomError = false;
                }
            });
            }
        }


        /************************************/
        /***** Delete uploaded images *******/
        /************************************/
        vm.deleteUploadedImage = function(imageID, roomTypeID, filename, evt) {
            var confirm = $mdDialog.confirm()
                .htmlContent('<div class="md-padding custom-common-dailog">Are you sure, you want to delete this image?</div>')
                .title('Delete Image')
                .targetEvent(evt)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function() {
                var data = {
                    imageID: imageID,
                    roomTypeID: roomTypeID,
                    filename: filename
                };
                roomTypeService.deleteImage(data).then(function(response) {
                    if (response.status === 'success') {

                        vm.uploadedFiles = response.files;
                        if(vm.uploadedFiles.length==0){
                            vm.doCrop=true;
                            $("#my").css("display","block");
                        }else{
                            vm.doCrop=false;
                            // $("#my").css("display","none");
                        }
                    } else {
                        toastMessage.showSimpleToast($translate.instant(response.message), 'error-toast');
                    }
                });
            }).catch(function(e) {

            });
        };

        /************************************/
        /********* Delete images ************/
        /************************************/
        vm.deleteAddImage = function(image) {
            var obj = [];
            angular.forEach(vm.uploadedFiles, function(value, index) {
                if (value.filename === image) {
                    vm.uploadedFiles.splice(index, 1);
                    if(vm.setIndex!=0 && index<=vm.setIndex){
                        vm.setIndex-=1;console.log(vm.setIndex);
                    }
                }
            });
        };

        /************************************/
        /********* Sorted images ************/
        /************************************/
        $scope.sortableOptions = {
            activate: function() {
            },
            beforeStop: function() {
            },
            change: function() {
            },
            create: function() {
            },
            deactivate: function() {
            },
            out: function() {
            },
            over: function() {
            },
            receive: function() {
            },
            remove: function() {
            },
            sort: function() {
            },
            start: function() {
            },
            update: function(e, ui) {
            },
            stop: function(e, ui) {
                if (vm.reload) {
                    var newSortImages = vm.uploadedFiles;
                    roomTypeService.sortRoomImages(newSortImages).then(function(response) {
                        if (response.status === 'success') {
                            vm.nameError = true;
                        } else {
                            vm.nameError = false;
                        }
                    });
                }
            }
        };

        /************************************/
        /****** Save new room product *******/
        /************************************/
        vm.changeBedrooms = function() {
            if(typeof vm.roomTypeData.product_room_number != 'undefined'){
                 vm.roomTypeData.nbr_of_bedrooms = vm.roomTypeData.product_room_number.length;
            }
        }
        vm.saveEachBundleProduct = function() {
            if(vm.reload){
                var data = {type_id: vm.roomTypeData.room_type_id};
                if(typeof vm.roomTypeData.product_room_bundle == 'undefined')
                    vm.roomTypeData.is_bundle = 0;
                else {
                    var roomNumbers = angular.copy(vm.roomTypeData.product_room_bundle);
                    var key = 0;
                    data.product_room_bundle = {};
                    data.hotel_room_id = {};
                    for(var i=0;i<roomNumbers.length;i++){
                        key = roomNumbers[i]; 
                        data.product_room_bundle[i] = vm.roomType.room_numbers[key].room_no;
                        data.hotel_room_id[i] = vm.roomType.room_numbers[key].id;
                    }
                }
                roomTypeService.editBundleRooms(data).then(function(response) {
                    if (!response.success) {
                        toastMessage.showSimpleToast($translate.instant(response.message), 'error-toast');
                    }
                });
            }
        };
        vm.saveEachProduct = function(product_name, productID, index, product_room_number) {

            if(vm.reload){
                var data = {
                    product_status: 1,
                    hotel_id: vm.roomTypeData.hotel_id,
                    type_id: vm.roomTypeData.room_type_id,
                    created_by_user: vm.roomTypeData.created_by_user,
                };
                if(vm.pageType == 'Rooms'){
                    data.product_type = 'room';
                    data.room_type = 'room';
                } else {
                    data.product_type = 'boat';
                    data.room_type = 'boat';
                }
                var roomNumbers = angular.copy(vm.roomTypeData.product_room_number);
                if(roomNumbers.length > 1){
                    if(vm.pageType == 'Rooms'){
                        data.room_type = 'room_type';
                    } else {
                        data.room_type = 'boat_type';
                    }
                }
                var key = 0;
                data.product_room_number = {};
                data.hotel_room_id = {};
                if(vm.roomTypeData.sub_hotel_id)
                     data.sub_hotel_id = vm.roomTypeData.sub_hotel_id;
                if(typeof roomNumbers != 'undefined'){
                    for(var i=0;i<roomNumbers.length;i++){
                        key = roomNumbers[i]; 
                        if(vm.pageType == 'Rooms'){
                            data.product_room_number[i] = vm.roomType.room_numbers[key].room_no;
                        } else {
                            data.product_room_number[i] = vm.roomType.room_numbers[key].boat_no;
                        }
                        
                        data.hotel_room_id[i] = vm.roomType.room_numbers[key].id;
                    }                    
                }

                
                if (productID !== undefined) {
                    data.product_id = productID;
                    data.product_name = vm.roomTypeData.product_name;
                }else{
                    data.product_name = vm.roomTypeData.room_type_name;
                }
                roomTypeService.addRoomProduct(data).then(function(response) {
                    if (response.status != 'success') {
                         if (response.message !== 'ROOM_NAME_EXIST') {
                            toastMessage.showSimpleToast($translate.instant(response.message), 'error-toast');
                        }
                    }else{
                        if(response.room_type_name && response.room_type_name!=''){
                            vm.roomTypeData.room_type_name = response.room_type_name;
                        }
                        if(response.room_name && response.room_name!=''){
                          vm.roomTypeData.product_name = response.room_name;
                        } 
                    }
                });
            }
        };

        /************************************/
        /****** Save room product order *****/
        /************************************/
        vm.saveProductSortOrder = function(room_sort_order) {
            var data = {
                product_sort_order: room_sort_order,
                hotel_id: vm.roomTypeData.hotel_id,
                type_id: vm.roomTypeData.room_type_id
            };
            roomTypeService.saveProductSortOrder(data).then(function(response) {
                if (response.status === 'success') {
                } else {
                    toastMessage.showSimpleToast($translate.instant(response.message), 'error-toast');
                }
            });
        };


        /************************************/
        /*** get room product on chnage *****/
        /************************************/
        vm.getRoomProduct = function(room_type) {
            if (vm.reload && room_type === 'room_type') {
                var data = {
                    hotel_id: vm.roomTypeData.hotel_id,
                    type_id: vm.roomTypeData.room_type_id
                }
                roomTypeService.getRoomProduct(data).then(function(response) {
                    if (response.status != 'success') {
                        toastMessage.showSimpleToast($translate.instant(response.message), 'error-toast');
                    }
                });
            }
        };
        /************************************/
        /********* Slip Boat Name *********/
        /************************************/
        vm.saveBoatProductName = function(roomName, productID,sub_hotel_id) {
            console.log(roomName, productID,sub_hotel_id);
            if(roomName == '' || typeof roomName == 'undefined'){ return; }
            var data = {
                hotelID: $localStorage.hotels[$localStorage.selectedHotel].hotel_id,
                roomName: roomName,
                type_id: vm.roomTypeData.room_type_id
            };
            if (productID) {
                data.productID = productID;
            }
            if (sub_hotel_id){
                data.sub_hotel_id = sub_hotel_id;
            }
            if(vm.roomType.childHotels.length==0 || vm.roomTypeData.sub_hotel_id){
                roomTypeService.SaveBoatProductName(data).then(function(response){
                    if(response.status === 'success'){
                        vm.nameError = false;
                        vm.roomTypeData.room_type_name = roomName;
                         vm.saveEachField(vm.roomTypeData.sub_hotel_id, 'sub_hotel_id');
                    } else if(response.errorMsg && response.errorMsg!=''){
                        toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                    }else {
                        vm.nameError = true;
                    }
                });
            }
        };

        /************************************/
        /********* Unique room name *********/
        /************************************/
        vm.uniqueProductName = function(roomName, productID,sub_hotel_id) {
            if(roomName == '' || typeof roomName == 'undefined'){ return; }
            var data = {
                hotelID: $localStorage.hotels[$localStorage.selectedHotel].hotel_id,
                roomName: roomName,
                type_id: vm.roomTypeData.room_type_id
            };
            if (productID) {
                data.productID = productID;
            }
            if (sub_hotel_id){
                data.sub_hotel_id = sub_hotel_id;
            }
            if(vm.roomType.childHotels.length==0 || vm.roomTypeData.sub_hotel_id){
            roomTypeService.UniqueProductName(data).then(function(response){
                if(response.status === 'success'){
                    vm.nameError = false;
                    vm.roomTypeData.room_type_name = roomName;
                     vm.saveEachField(vm.roomTypeData.sub_hotel_id, 'sub_hotel_id');
                } else if(response.errorMsg && response.errorMsg!=''){
                    toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                }else {
                    vm.nameError = true;
                }
            });
            }
        };
        vm.updateStatus = function(){
            $timeout(function() {
                vm.reload = true;
            },1000);
        }
          vm.checkSubHotelUniqueAndSave = function(roomName,productID,sub_hotel_id,nmbr_of_bedrooms) {
            vm.updateSubHotel = true;
            if(nmbr_of_bedrooms==1)
            vm.uniqueProductName(roomName,productID,sub_hotel_id);
            else if (nmbr_of_bedrooms>1 && vm.flag == 'edit'){
                vm.saveEachField(vm.roomTypeData.room_type_name, 'room_type_name');
            }
            else{
            vm.checkUniqueRoom();
            }
            };

            vm.getRoomsOfSubHotel = function(sub_hotel_id) {
                var data = {
                    sub_hotel_id: sub_hotel_id,
                    type: vm.pageType
                };
                roomTypeService.getRoomsOfSubHotel(data).then(function(response){
                if(response.data.status == 'success'){
                    vm.roomType.room_numbers = response.data.hotel_rooms;
                    vm.roomTypeData.product_room_number = '';
                    vm.roomTypeData.room_type_name = '';
                    vm.roomTypeData.product_name = '';
                    }
                 else {
                    vm.roomType.room_numbers = [];
                    vm.roomTypeData.product_room_number = '';
                    vm.roomTypeData.room_type_name = '';
                    vm.roomTypeData.product_name = '';
                    toastMessage.showSimpleToast(response.data.message, 'error-toast');
                }
            });
            };

            setTimeout(function() {
               vm.autoFillOff = false;
            }, 1500); 
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('ProductsController', ProductsController);

    /** @ngInject */
    function ProductsController($state, $rootScope, $scope, $http, EnvironmentConfig, $mdDialog, eCommerceService, toastMessage, $localStorage, Types, $document)
    {
        var vm = this;
		vm.loggedinUserRole = $localStorage.roleId;
        if(vm.loggedinUserRole == 4){
			vm.hotel_id = "";
		}else{
			vm.hotel_id = $rootScope.hotels[$rootScope.selectedHotel].hotel_id;
		}
        // Data
         /*Start*/
		  $scope.paginatorCallback = paginatorCallback;
		  $scope.getLoadResultsCallback = getLoadResultsCallback;
		  $scope.selectedRowCallback = function(rows){
			  vm.selectedprodId = rows;
		  };
		  vm.userPermissions = $rootScope.userPermissions;
		  if(vm.userPermissions.indexOf('delete_room') != -1){
			  $scope.delete_product=true;
		  }else{
			  $scope.delete_product=false;
		  }
		  vm.Types = Types.types;
		  var loadPageCallbackWithDebounce;
		  $scope.$watch('filterText', function(){
			if(loadPageCallbackWithDebounce){
			  loadPageCallbackWithDebounce();  
			}
		  });
		  $scope.showTabDialog = function(ev, id) {
		   roleService.getRolePermissions(id).then(function(response){
			if(response.listData.length ==0){
			  toastMessage.showSimpleToast('This role has no module assigned.','error-toast');
			} else {
			  $state.go('app.rolesPermission',{id:id});

			}
		  });
		 };
		 $scope.userPermissions = vm.userPermissions;
		 $scope.updateTable= function() {
		  loadPageCallbackWithDebounce();
		 };

		 $scope.toggleAll = function() {
			var toggleStatus = !$scope.isAllSelected;
			$scope.ChangeAll = toggleStatus;
		 }
		 $scope.gotoProductDetail = function(id) {
			$state.go('app.e-commerce.products.detail', {id: id});
		 }
		 $scope.deleteSelectedItem = function(ev){
			  var confirm = $mdDialog.confirm()
			  .title('Are you sure, you want to delete the selected room(s)?')
			  .htmlContent('<b>' + vm.selectedprodId.length + ' room(s)</b>' + ' will be deleted.')
			  .ariaLabel('delete products')
			  .targetEvent(ev)
			  .ok('OK')
			  .cancel('CANCEL');

			  $mdDialog.show(confirm).then(function ()
			  {
			  	eCommerceService.deleteSelProd(vm.selectedprodId)
				.then(function(response){
					if(response.errorMsg){
					  toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					}else{
					  loadPageCallbackWithDebounce();  
					  vm.selectedprodId = [];
					}
				});
			  });
		 };
		function getLoadResultsCallback(loadPageCallback){
		  loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
		}
		vm.UserColumns = [
		'product_name',
		'room_type_name',
		'product_status',
		'productId'
		];

		function paginatorCallback(page, pageSize,option){
	  
		  vm.page 		= page;
		  vm.pageSize 	= pageSize;
		  vm.checkDelete = false;
		  vm.selectedprodId = [];
		  var sort 		= {};

		  for(var i=0; i < option.columnSort.length; i++){

			if(option.columnSort[i]['sort']){
			  sort['column']= vm.UserColumns[i];
			  sort['order']= option.columnSort[i]['sort'];
			}
		  }
			var offset = (page-1) * pageSize;
			var query = $scope.filterText ? $scope.filterText : '';
			var filterData = {'offset':offset , 'pageSize': pageSize, 'search':$scope.filterText , 'sort':sort, 'hotel_id': vm.hotel_id,selectedHotel: $localStorage.hotels[$localStorage.selectedHotel].hotel_id};
			
			return $http({
				url:EnvironmentConfig.api+'product/skipAcl_getallproductdata',
				method:'POST',
				data:filterData
			}).then(function(result){
				if(result.data){
					vm.totalProducts = result.data.count;
					vm.Products = result.data.products;
					  return {
						results: result.data.products,
						totalResultCount: result.data.count
					  }
				  }else{ 
					toastMessage.showSimpleToast(result.data.errorMsg,'error-toast');
				  }
			});
		  }
		  /*End*/
        // Methods
		vm.deleteSelectedProds 		= deleteSelectedProds;

      
        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
         $scope.openAddProductDialog = function (ev, contact){
			 if(contact != 'add'){
				for ( var i = 0; i < vm.Products.length; i++ )
				{
					if ( vm.Products[i].product_id == parseInt(contact) )
					{
						vm.product = vm.Products[i];
						break;
					}
				}
			 }else{
				 vm.product = [];
			 }
			$mdDialog.show({
				controller         : 'ProductControllers',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/apps/e-commerce/views/products/dialogs/product-dialog.html',
				parent             : angular.element($document.find('#product-container')),
				targetEvent        : ev,
				scope:$scope.$new(),
				clickOutsideToClose: true,
				locals             : {
					Products	: vm.Products,
					Product		: vm.product,
					Types   	: vm.Types
				}
			});
			jQuery('.sec-contact-tab').css('display','none');
			jQuery('.third-contact-tab').css('display','none');
        }

        
        /**
        * Delete Selected Users
        */
        function deleteSelectedProds(ev){}
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('OrdersController', OrdersController);

    /** @ngInject */
    function OrdersController(
    	$state, 
    	toastMessage, 
    	$scope, 
    	$http, 
    	EnvironmentConfig, 
    	$q, 
    	moment, 
    	$mdDialog, 
    	eCommerceService, 
    	$stateParams,
    	$rootScope,
    	$sessionStorage,
    	$timeout,
    	$window,
    	$translate,
    	$localStorage,
		_)
    {
		var vm = this;

		vm.filterData = [];
		vm.pageType = $stateParams['page_type'];
		vm.blackListedReservations = ($stateParams['black_listed_reservations']) ? $stateParams['black_listed_reservations'] : false;
		vm.currentUser = $localStorage.userId;
		vm.reservationFilter = 'all';
		if(vm.pageType == 'boat'){
			vm.title = 'Boat reservations';
		} else if(vm.pageType == 'rent') {
			vm.title = 'Rental Reservations';
		}else {
			vm.title = 'Reservations';
		}

		vm.currentHotel = ($localStorage['preHotelId'] !== undefined && $localStorage['preHotelId'] !== null) ? $localStorage['preHotelId'] : '';
		vm.isDailyRentalsAvailable = function () {
			return typeof $rootScope.isDailyRentalsAvailable === 'function'
				? $rootScope.isDailyRentalsAvailable()
				: false;
		};
		if (!vm.isDailyRentalsAvailable()) {
			vm.reservationFilter = 'all';
		}

		if(!$rootScope.backButtonPressed){
			$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = {};
			$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] = 1;
        	$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'] = 50;
		}
		vm.requestGoing = false;
		vm.canDelete = false;
        vm.UserColumns = ['itinerary_number', 'confirmation_number', 'product_name', 'created_date', 'customer_name', 'traveler', 'grand_total', 'paid_amount', 'remaining_amount', 'room_stay_status', 'room_stay_from', 'room_stay_to', 'source_of_creation', 'created_by_user' ];

        /*Start*/
		$scope.paginatorCallback = paginatorCallback;
		$scope.LoadAllData = LoadAllData;
		$scope.getLoadResultsCallback = getLoadResultsCallback;

		$scope.selectedRowCallback = function(rows){
			vm.selectedUserId = rows;
		};
		var loadPageCallbackWithDebounce;
		var goToFirstPageCallback;
		$scope.statusValuesCallback = statusValuesCallback;
		$scope.createdValuesCallback = createdValuesCallback;
		$scope.checkinValuesCallback = checkinValuesCallback;
		$scope.checkoutValuesCallback = checkoutValuesCallback;
		$scope.statusValuesTransformer = statusValuesTransformer;

		$scope.$watch('filterText', function(){
			if(loadPageCallbackWithDebounce){
				loadPageCallbackWithDebounce();
			}
		});

		$scope.toggleAll = function() {
			var toggleStatus = !$scope.isAllSelected;
			$scope.ChangeAll = toggleStatus;
		}
		$scope.checkBox = function(value) {
            if (vm.selectedUserId.indexOf(value) > -1 )
            {
				vm.selectedUserId.splice(vm.selectedUserId.indexOf(value), 1);
            }
            else
            {
				vm.selectedUserId.push(value);
            }
            if(vm.selectedUserId.length > 0){
				vm.getNumberOfSelectedRows = vm.selectedUserId.length;
				vm.checkDelete = true;
            } else {
				vm.checkDelete = false;
            }
		};

        function getLoadResultsCallback(loadPageCallback, goToFirstPage){
			goToFirstPageCallback = goToFirstPage;
			loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
        }

        vm.onLoad = true;
        function paginatorCallback(page, pageSize,option){
        	if(vm.requestGoing) return;
        	if(vm.onLoad == true){
        		if(typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] != 'undefined'){

        			var page1 =  $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
        			var pageSize1 = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'];
  					vm.onLoad = false;
        			return LoadAllData(page1, pageSize1,option);
        		}else{
	        		vm.onLoad = false;
	        		return LoadAllData(page, pageSize,option);		
        		}
        	}else{
        		if(typeof page == 'undefined'){
        			page = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
        		}
        		return LoadAllData(page, pageSize,option);
        	}


		}
		function LoadAllData(page, pageSize,option){
			vm.requestGoing = true;
			var pageDetail = {'currentPage':page,'pageSize':pageSize};
        	$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = pageDetail;
            vm.page = page;
            vm.pageSize = pageSize;
            vm.checkDelete = false;
            vm.selectedUserId = [];
            vm.search = [];
            var filtersApplied = option.columnFilter;
            angular.forEach(filtersApplied, function(filter,key) {
				if(key == 3 && filter.length > 0){
					filter = moment(filter[0]).format('YYYY-MM-DD');
					this.push('created_date:'+filter);
				}else if(key == 9 && filter.length > 0){
					this.push('room_stay_status:'+filter[0].name);
				}else if(key == 10 && filter.length > 0){
					filter = moment(filter[0]).format('YYYY-MM-DD');
					this.push('room_stay_from:'+filter);
				}else if(key == 11 && filter.length > 0){
					filter = moment(filter[0]).format('YYYY-MM-DD');
					this.push('room_stay_to:'+filter);
				}else{
					if(filter.length > 0 && filter[0].name != 'All'){
						this.push(filter[0].fieldValue + ':' + filter[0].name);
					}
				}
			}, vm.search);
            var sort = {};
            for(var i=0; i<option.columnSort.length; i++){
                if(option.columnSort[i]['sort']){
                    sort['column']= vm.UserColumns[i];
                    sort['order']= option.columnSort[i]['sort'];
                }
            }

            var offset = (page-1) * pageSize;
            var query = $scope.filterText ? $scope.filterText : '';
            var filterData = {'offset':offset , 'pageSize': pageSize, 'search':$scope.filterText , 'sort':sort, 'customSearch':vm.search,'pageType':vm.pageType, 'blackListedReservations': vm.blackListedReservations, 'reservationFilter': vm.reservationFilter || 'all'};
            vm.filterData = filterData;
            
            return $http({
                url: EnvironmentConfig.api+'reservations/get_orders_list',
                method:'POST',
                data:filterData
            }).then(function(result){
				vm.templates =result.data['reservations'];
				vm.totalReservations =result.data['totalReservations'];
				vm.requestGoing = false;
				if($stateParams.toast_message){
					toastMessage.showSimpleToast($stateParams.toast_message,'error-toast');
					$stateParams.toast_message = false;
				}
				return {
					results: result.data['reservations'],
					totalResultCount: result.data['totalReservations']
				}
            });

		}

		function statusValuesCallback(){
			return $q.resolve([
			{
				name: 'All',fieldValue: 'room_stay_status'
			}, {
				name: 'Checked-In',fieldValue: 'room_stay_status'
			}, {
				name: 'Checked-Out',fieldValue: 'room_stay_status'
			}, {
				name: 'Closed',fieldValue: 'room_stay_status'
			}, {
				name: 'Active',fieldValue: 'room_stay_status'
			}, {
				name: 'Canceled',fieldValue: 'room_stay_status'
			}]);
		}
		function createdValuesCallback(){
			return $q.resolve('created_date');
		}
		function checkinValuesCallback(){
			return $q.resolve('room_stay_from');
		}
		function checkoutValuesCallback(){
			return $q.resolve('room_stay_to');
		}
		function statusValuesTransformer(statusObject){
			return statusObject.name;
		}
		/*End*/




		 /**
         * Delete Selected Users
         */
         $scope.deleteSelectedItem = function(ev){
			var confirm = $mdDialog.confirm()
			.title('Are you sure, you want to delete the selected reservations(s)?')
			.htmlContent('<b>' + vm.selectedUserId.length + ' reservation(s)</b>' + ' will be deleted.')
			.ariaLabel('delete users')
			.targetEvent(ev)
			.ok('OK')
			.cancel('CANCEL');

			$mdDialog.show(confirm).then(function ()
			{
				eCommerceService.deleteSelOrder(vm.selectedUserId).then(function(response){
					if(response.success){
						vm.selectedUserId = [];
						loadPageCallbackWithDebounce();
					}else{
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					}
				});
			});
        }
        /**
         * Go to product detail
         *
         * @param id
         */
		$scope.goToEditPage= function(value) {
			value = value.split("-");
			
			var resPageType = '';
			if (vm.pageType != 'rent') {
				if (value[2] != undefined && value[2] != '') {
					if (value[2] == 'boat' || value[2] == 'boat_service') {
						resPageType = 'boat';
					} else {
						resPageType = 'room';
					}
				}
			} else {
				resPageType = vm.pageType != undefined ? vm.pageType : '';
			}

			if(resPageType == 'boat'){
				var url = $state.href("app.e-commerce.boatOrders.detail",{id:value[0],confirmation_number:value[1]});
				$window.open(url, '_blank');
			}else if(resPageType == 'rent'){
				var url = $state.href("app.e-commerce.rentOrders.detail",{id:value[0],confirmation_number:value[1]});
				$window.open(url, '_blank');
				// $state.go("app.e-commerce.rentOrders.detail",{id:value[0],confirmation_number:value[1]});
			} else {
				var url = $state.href("app.e-commerce.orders.detail",{id:value[0],confirmation_number:value[1]});
				$window.open(url, '_blank');
			}
		};

		vm.onReservationFilterChange = onReservationFilterChange;
		function onReservationFilterChange(){
			var sessionKey = $state['current']['name'] + '_' + $localStorage['preHotelId'];
			var pageSize = (typeof $sessionStorage[sessionKey] != 'undefined' && $sessionStorage[sessionKey]['pageSize'])
				? $sessionStorage[sessionKey]['pageSize']
				: (vm.pageSize || 50);
			$sessionStorage[sessionKey] = {'currentPage': 1, 'pageSize': pageSize};
			if(goToFirstPageCallback){
				goToFirstPageCallback();
			} else if(loadPageCallbackWithDebounce){
				loadPageCallbackWithDebounce();
			}
		}

		/*Export as csv*/
		vm.exportCsvData = exportCsvData;

		vm.exportInProgress = false;
		function exportCsvData(){
			vm.exportInProgress = true;
			var fileName = 'reservations.csv';
			var header = [
			'Itinerary Number',
			'Confirmation Number',
			'Product Name',
			'Created Date',
			'Customer Name',
			'Traveler',
			'Email',
			'Grand Total',
			'Paid Amount',
			'Remaining Amount',
			'Room StayStatus',
			'Checkin',
			'Checkout',
			'Source',
			'Created By'];

			var offset = 0;
			var j = 0;
			// for(i = 0,vm.offset = 0; i <= vm.totalReservations/5000; i++,vm.offset+=5000){
			for(i = 0; i <= vm.totalReservations/5000; i++){
				(function (i) {
    				setTimeout(function () {
						eCommerceService.exportCsvData({'customSearch': vm.search,
														'search': $scope.filterText,
														'offset': offset,
														'pageSize': 5000,
														'pageType': 'reservation',
														'reservationFilter': vm.reservationFilter || 'all',
														'i':i

						}).then(function(response){
							var order = 'itinerary_number,confirmation_number,product_name,created_date,customer_name,traveler,customer_email,grand_total,paid_amount,remaining_amount,room_stay_status,room_stay_from,room_stay_to,source_of_creation,created_by_user';
							 $rootScope.downloadFile(header, response['reservations'], 'reservations-'+j+'.csv', order);
						});
						offset+=5000;
						j = j+1;
					}, 3000*i);
  				})(i);
			}
			vm.exportInProgress = false;
			// eCommerceService.exportCsvData(vm.filterData).then(function(response){
			// 	var order = 'itinerary_number,confirmation_number,product_name,created_date,customer_name,traveler,customer_email,grand_total,paid_amount,remaining_amount,room_stay_status,room_stay_from,room_stay_to,source_of_creation,created_by_user';
			// 	 $rootScope.downloadFile(header, response['reservations'], fileName, order);
			// 	 vm.exportInProgress = false;
			// });
		}

		$scope.downloadCsv = function(dateRange){
			vm.allData = [];
			eCommerceService.exportCsvData(dateRange).then(function(response){
				 for (var key in response['reservations']) {                  
                   vm.allData = vm.allData.concat(response['reservations'][key]);
                   if((response['reservations'].length - 1) == key){
                   	$timeout(function() {
                   	angular.element('#downloadCsv').triggerHandler('click');
                   },100);
                   }
                  }
			});
		}

		$translate.refresh();
    }
})();

(function() {
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('GiftcardController', GiftcardController);

    /** @ngInject */
    function GiftcardController(
        $localStorage,
        $state,
        Upload,
        $scope,
        EnvironmentConfig,
        $timeout,
        toastMessage,
        $translate,
        giftCardService,
        getGiftCard,
        $mdDialog,
        taxData,
        $sce,
        $rootScope
    ) {
        var vm = this;
        vm.flag = 'add';
        vm.editForm = false;
        vm.giftCardData = {};
        vm.priceAjaxStart = false;
        vm.giftCardData.product_status = 1;
        vm.giftCardData.p_gc_open_price = 1;
        vm.giftCardData.prices = [{
            price: '',
            new: 1
        }];
        vm.uploadedFiles = [];
        vm.autoFillOff = true;

        var hotelID = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
        vm.previousPicture = EnvironmentConfig.api + 'assets/uploads/defaultimage/giftcard.jpg';
        /************************************/
        /********* Get Giftcard Info ********/
        /************************************/
        if (getGiftCard.status === 'success') {
            vm.flag = 'edit';
            vm.giftCardData = getGiftCard.data;
            vm.submittedPriceCount = vm.giftCardData.prices.length;
            angular.forEach(vm.giftCardData.prices, function(prices, key) {
                prices.new = 0;
            });
            vm.giftCardData.p_gc_open_price_min = parseFloat(vm.giftCardData.p_gc_open_price_min).toFixed(2);
            vm.giftCardData.p_gc_open_price_max = parseFloat(vm.giftCardData.p_gc_open_price_max).toFixed(2);
            vm.uploadedFiles = getGiftCard.data.giftCardImages;
            if(vm.giftCardData.url != '' && vm.giftCardData.url.length > 5){
                vm.previousPicture = vm.giftCardData.url;

            }

           
            
        }

        vm.oldTaxArray = vm.giftCardData.product_tax;
        /************************************/
        /********* Get Tax Data Info ********/
        /************************************/
        if (taxData.status === 'success') {
            vm.taxData = taxData.data;
        }
        
        /************************************/
        /********* Add new Gift card ********/
        /************************************/
        vm.addGiftCard = function(data) {
            data.hotelID = hotelID;
            data.created_by_user = $localStorage.userId;
            
            var fd = new FormData();
            if (vm.file != undefined) {
                fd.append('file', vm.file);
            }

            data = JSON.stringify(data);
            fd.append('data', data);

            giftCardService.addGiftCard(fd)
                .then(function(response) {
                    if (response.status == 'success') {
                        // toastMessage.showSimpleToast($translate.instant('GIFTCARD.GIFT_CARD_SUBMITTED'), 'success-toast');
                       
                    } else {
                        toastMessage.showSimpleToast($translate.instant('GIFTCARD.COMMON_ERROR'), 'error-toast');
                    }
                    $state.reload();
                   
                });
        };


        /************************************/
        /********* Add new Gift card ********/
        /************************************/
        vm.addPrice = function() {
			if(vm.priceAjaxStart) return;
            var show_msg = false;
            angular.forEach(vm.giftCardData.prices, function(prices, key) {
                if (prices.price == '') {
                    show_msg = true;
                    toastMessage.showSimpleToast($translate.instant('GIFTCARD.ADD_PRICE_ERROR'), 'error-toast');
                }
            });
            if (!show_msg) {
                vm.giftCardData.prices.push({
                    price: '',
                    new: 1
                });
            }

        };


        /************************************/
        /********* Add new Gift card ********/
        /************************************/
        vm.deletePrice = function(key, price, newPrice, evt) {
            if (newPrice === 1) {
                vm.giftCardData.prices.splice(key, 1);
                return;
            }
            var confirm = $mdDialog.confirm()
                .title('Are you sure, you want to delete this price?')
                .ariaLabel('delete image')
                .targetEvent(evt)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function() {
                angular.forEach(vm.giftCardData.prices, function(value, index) {
                    if (key === index && value.new == 1) {
                        vm.giftCardData.prices.splice(index, 1);
                    } else {
                        if (key === index) {
                            var data = {
                                price: price,
                                productID: vm.giftCardData.product_id
                            };
                            giftCardService.removePrice(data).then(function(response) {
                                if (response.status === 'success') {
                                    vm.giftCardData.prices.splice(index, 1);
                                    vm.submittedPriceCount = response.data.submittedPriceCount;
                                } else {
                                    toastMessage.showSimpleToast($translate.instant('COMMON_ERROR'), 'error-toast');
                                }
                            });
                        }
                    }
                });
            }).catch(function(e) {

            });
        };

        /************************************/
        /*********** Upload Images **********/
        /************************************/
        vm.uploadGiftCardImages = function(files, errFiles) {
            if (errFiles.length > 0) {
                angular.forEach(errFiles, function(value, index) {
                    switch (value.$error) {
                        case 'pattern':
                            vm.fileError = 'FILE_TYPE_NOT_SUPPORTED';
                            break;
                        case 'maxSize':
                            vm.fileError = 'FILE_SIZE_EXCEEDS';
                            break;
                        case 'minWidth':
                            vm.fileError = 'MIN_SIZE_MESSAGE';
                            break;
                        case 'minHeight':
                            vm.fileError = 'MIN_SIZE_MESSAGE';
                            break;
                        default:
                            vm.fileError = 'COMMON_IMAGE_MESSAGE';
                    }
                    toastMessage.showSimpleToast($translate.instant('ROOM_TYPE.' + vm.fileError), 'error-toast');
                });
            }
            $scope.files = files;
            $scope.errFiles = errFiles;
            if (vm.flag === 'add') {
                files.upload = Upload.upload({
                    url: EnvironmentConfig.api + 'giftcards/addGiftCardImages',
                    data: {
                        file: files,
                        mode: 'add'
                    }
                });

                files.upload.then(function(response) {
                    $timeout(function() {
                        vm.uploadedFiles = [];
                        angular.forEach(response.data.files, function(value, index) {
                            vm.uploadedFiles.push(value);
                        });
                        vm.failedFiles = response.data.error;
                    });
                }, function(response) {
                    if (response.status > 0)
                        $scope.errorMsg = response.status + ': ' + response.data;
                }, function(evt) {
                    vm.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            } else {
                files.upload = Upload.upload({
                    url: EnvironmentConfig.api + 'giftcards/addGiftCardImages',
                    data: {
                        file: files[0],
                        mode: 'edit',
                        productID: vm.giftCardData.product_id
                    }
                });

                files.upload.then(function(response) {
                    $timeout(function() {
                        vm.uploadedFiles = [];
                        if (response.data.data.error != 'file not selected') {
                            var filename = {
                                'filename': response.data.data.files.media,
                                'catalog_product_media_id': response.data.data.files.catalog_product_media_id,
                                'type_id': response.data.data.files.type_id,
                                'url': response.data.data.files.url
                            };
                            vm.uploadedFiles.push(filename);
                            //vm.uploadedFiles.push(response.data.data.files);
                            vm.failedFiles = response.data.data.error;
                        }
                    });
                }, function(response) {
                    if (response.status > 0)
                        $scope.errorMsg = response.status + ': ' + response.data;
                }, function(evt) {
                    vm.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            }
        };

        /************************************/
        /***** Delete uploaded images *******/
        /************************************/
        vm.deleteUploadedImage = function(imageID, productID, evt) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure, you want to delete this image?')
                .ariaLabel('delete image')
                .targetEvent(evt)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function() {
                var data = {
                    imageID: imageID,
                    productID: vm.giftCardData.product_id
                };
                giftCardService.deleteImage(data).then(function(response) {
                    if (response.status === 'success') {
                        vm.uploadedFiles = [];
                        //vm.uploadedFiles = response.files;
                    } else {
                        toastMessage.showSimpleToast($translate.instant(response.message), 'error-toast');
                    }
                });
            }).catch(function(e) {

            });
        };

        vm.deleteAddImage = function(filename) {
            vm.uploadedFiles = [];
        };

        /************************************/
        /******** Save card detail ********/
        /************************************/
        vm.saveCardDetail = function(field, value) {
            if (vm.editForm) {
                var data = {};
                var fd = new FormData();
                var update_fn = false;
               
                if (field == 'product_tax') {
                    var diff = $rootScope.arr_diff(value, vm.oldTaxArray);
                    if(diff.indexOf('0') > -1) {
                        vm.giftCardData.product_tax = ['0'];
                    } else {
                        var index = value.indexOf('0');
                        if (index > -1) {
                          value.splice(index, 1);
                        }
                        vm.giftCardData.product_tax = value;
                    }
                    vm.oldTaxArray = vm.giftCardData.product_tax;
                    value = vm.giftCardData.product_tax;

                    data = {
                        field: field,
                        value: value,
                        product_id: vm.giftCardData.product_id
                    }
                    update_fn = true;
                } else if (field != 'file') {
                    data = {
                        field: field,
                        value: value,
                        product_id: vm.giftCardData.product_id
                    };
                    update_fn = true;
                } else {
                    data = {
                        product_id: vm.giftCardData.product_id
                    };
                    if (vm.file != undefined) {
                        fd.append('file', vm.file);
                        update_fn = true;
                    } else {
                        return false;
                    }
                }

                if(update_fn) {
                    data = JSON.stringify(data);
                    fd.append('data', data);

                    giftCardService.updateProductDetail(fd).then(function(response) {
                        if (response.status === 'success') {
                            //vm.giftCardData.prices = response.data;
                            if (field == 'file' && response.data.files.url && response.data.files.url.length > 4) {
                                vm.previousPicture = response.data.files.url;
                            }
                        } else if (response.status === 'error') {
                            toastMessage.showSimpleToast($sce.trustAsHtml(response.message), 'error-toast');
                        }
                    });
                }
            }
        };

        /************************************/
        /******** Save product price ********/
        /************************************/
        vm.saveEachPrice = function(price, priceID, index) {
            angular.forEach(vm.giftCardData.prices, function(prices, key) {
				if(prices.price=='' || typeof prices.price == "undefined")
					prices.price = 0;
                vm.giftCardData.prices[key].price = parseFloat(prices.price).toFixed(2);
            });
            var data = {
                priceList: vm.giftCardData.prices,
                productID: vm.giftCardData.product_id
            };
            vm.priceAjaxStart = true;
            giftCardService.addGiftPrice(data).then(function(response) {
				vm.priceAjaxStart = false;
                if (response.status === 'success') {
                    vm.giftCardData.prices = response.data;
                    angular.forEach(vm.giftCardData.prices, function(prices, key) {
                        prices.new = 0;
                    });
                    vm.submittedPriceCount = vm.giftCardData.prices.length;
                }
            });
        };

        /************************************/
        /******** Save product price ********/
        /************************************/
        vm.UpdatePriceDetail = function(value) {
            if (value == 0) {
                var data = {
                    p_gc_open_price: value,
                    p_gc_open_price_min: 0,
                    p_gc_open_price_max: 0
                };
            } else {
                var data = {
                    p_gc_open_price: value,
                    p_gc_open_price_min: vm.giftCardData.p_gc_open_price_min,
                    p_gc_open_price_max: vm.giftCardData.p_gc_open_price_max
                };
            }
            data.product_id = vm.giftCardData.product_id;
            giftCardService.updateAllowAmount(data).then(function(response) {
                if (response.status === 'success') {
                    vm.giftCardData.p_gc_open_price_min = parseFloat(vm.giftCardData.p_gc_open_price_min).toFixed(2);
                    vm.giftCardData.p_gc_open_price_max = parseFloat(vm.giftCardData.p_gc_open_price_max).toFixed(2);
                }
            });
        };

        $scope.upload = function(file, errFiles) {
            if (file) {
                vm.imageStatus = false;
                vm.file = file;
            } else {
                vm.file = null;
                vm.imageStatus = true;
                vm.isloading = false;
                if (errFiles.length > 0) {
                    angular.forEach(errFiles, function(value, index) {
                        switch (value.$error) {
                            case 'pattern':
                                vm.fileError = 'FILE_TYPE_NOT_SUPPORTED';
                                break;
                            case 'maxSize':
                                vm.fileError = 'FILE_SIZE_EXCEEDS';
                                break;
                            case 'minWidth':
                                vm.fileError = 'MIN_SIZE_MESSAGE';
                                break;
                            case 'minHeight':
                                vm.fileError = 'MIN_SIZE_MESSAGE';
                                break;
                            default:
                                vm.fileError = 'COMMON_IMAGE_MESSAGE';
                        }
                        toastMessage.showSimpleToast($translate.instant('POS_TYPE.' + vm.fileError), 'error-toast');
                    });
                }

            }
        }

        angular.element(function () {
            $timeout(function() {
                vm.editForm = true;
            }, 400);
        });

        setTimeout(function() {
           vm.autoFillOff = false;
        }, 1500); 

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('GcadminsController', GcadminsController);

    /** @ngInject */
    function GcadminsController(
    	$state, 
        $scope,
        $rootScope, 
        $localStorage,
        EnvironmentConfig,
        $http,
        $mdDialog,
        toastMessage,
        gcAdminService,
        $sessionStorage,
        $q
    )
    {
        var vm = this;

        if(!$rootScope.backButtonPressed){
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = {};
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] = 1;
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'] = 50;
        }
        
        $scope.paginatorCallback = paginatorCallback;
        $scope.LoadAllData = LoadAllData;
        $scope.getLoadResultsCallback = getLoadResultsCallback;
        $scope.statusValuesCallback = statusValuesCallback;
        $scope.statusValuesTransformer = statusValuesTransformer;
        vm.loggedinUserRole = $localStorage.roleId;
        vm.hotelID = $rootScope.hotels[$rootScope.selectedHotel].hotel_id;
        vm.deSelectGiftCards = deSelectGiftCards;
        vm.SelectGiftCards = SelectGiftCards;
        vm.userPermissions = $rootScope.userPermissions;
        vm.prodId = [];
        vm.isDeleteAllowed = false;
        if(vm.userPermissions.indexOf('delete_gift_card')!=-1) vm.isDeleteAllowed = true;
        
        function statusValuesCallback(){
            return $q.resolve([
                {name: 'All', fieldValue: 'gift_card_status'},
                {name: 'Available', fieldValue: 'gift_card_status'},
                {name: 'Consumed', fieldValue: 'gift_card_status'},
                {name: 'Expired', fieldValue: 'gift_card_status'},
                {name: 'Inactive', fieldValue: 'gift_card_status'}
            ]);
        }
        function statusValuesTransformer(statusObject){
            return statusObject.name;
        }

        /*********************************/
        /**** Paginate gift card data ****/
        /*********************************/
        $scope.selectedRowCallback = function(rows, id){
            vm.selectedProdIds = rows;
        };
        function getLoadResultsCallback(loadPageCallback){
            loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
        }

        vm.UserColumns = ['gift_card_code',
        'gift_card_sender_name',
        'gift_card_sender_email',
        'gift_card_receiver_name',
        'gift_card_receiver_email',
        'gift_card_price',
        'gift_card_expiration',
        'gift_card_status',
        'gift_card_id'];

        vm.onLoad = true;
        vm.requestGoing = false;
        function paginatorCallback(page, pageSize, option) {
            if(vm.requestGoing) return;
            if(vm.onLoad == true){
                if(typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] != 'undefined'){

                    var page1 =  $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
                    var pageSize1 = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'];
                    vm.onLoad = false;
                    return LoadAllData(page1, pageSize1,option);
                }else{
                    vm.onLoad = false;
                    return LoadAllData(page, pageSize,option);      
                }
            }else{
                if(typeof page == 'undefined'){
                    page = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
                }
                return LoadAllData(page, pageSize,option);
            }            
        }
        function LoadAllData(page, pageSize,option){
            vm.requestGoing = true;
            var pageDetail = {'currentPage':page,'pageSize':pageSize};
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = pageDetail;

            vm.page = page;
            vm.pageSize = pageSize;
            vm.checkDelete = false;
            vm.selectedProdIds = [];
            var sort = {};
            var len = (option && option.columnSort) ? option.columnSort.length : 0;
            for (var i = 0; i < len; i++) {
                if (option.columnSort[i]['sort']) {
                    sort['column'] = vm.UserColumns[i];
                    sort['order'] = option.columnSort[i]['sort'];
                }
            }
            var offset = (page - 1) * pageSize;
            var query = $scope.filterText ? $scope.filterText : '';
            // status column filter: nothing applied (or All) means every status
            var statusFilter = option && option.columnFilter && option.columnFilter[7] && option.columnFilter[7].length ? option.columnFilter[7][0].name : 'All';
            var filterData = {'offset': offset, 'pageSize': pageSize, 'search': $scope.filterText, 
                'sort': sort, 'status': statusFilter == 'All' ? '' : statusFilter, 'hotel_id': vm.hotelID };
            vm.currentFilter = filterData;
            return $http({
                url: EnvironmentConfig.api + 'gcadmins/admin_gift_cards',
                method: 'POST',
                data: filterData
            }).then(function(result) {
                vm.requestGoing = false;
                var res = (result && result.data) ? result.data : null;
                if (res && (res.status === 'success')) {

                    var data = res.data ? res.data : null; 
                    vm.giftCards = (data && data.giftCards) ? data.giftCards : [];
                    vm.totalgiftCards = (data && data.totalgiftCards) ? data.totalgiftCards : 0;
                    return {
                        results: vm.giftCards,
                        totalResultCount: vm.totalgiftCards
                    }

                } else {
                    toastMessage.showSimpleToast((res && res.errorMsg) ? res.errorMsg : '', 'error-toast');
                }
            });
        }

       
        /*********************************/
        /******** Export as CSV **********/
        /*********************************/
        vm.exportCsvData = exportCsvData;
        vm.exportInProgress = false;

        // Exports every card matching the search, status and sort currently on screen
        function exportCsvData(){
            vm.exportInProgress = true;
            var header = ['Code', 'Customer Name', 'Customer Email', 'Recipient Name', 'Recipient Email', 'Price', 'Expiration', 'Status'];
            var order = 'gift_card_code,gift_card_sender_name,gift_card_sender_email,gift_card_receiver_name,gift_card_receiver_email,gift_card_price,gift_card_expiration,gift_card_status';
            var batchSize = 5000;
            var rows = [];

            function fetchBatch(offset){
                var request = angular.extend({}, vm.currentFilter, {'offset': offset, 'pageSize': batchSize});
                return gcAdminService.gcadmins(request).then(function(response){
                    if(!response || response.status !== 'success' || !response.data){
                        vm.exportInProgress = false;
                        toastMessage.showSimpleToast('COMMON_ERROR', 'error-toast');
                        return;
                    }
                    var batch = response.data.giftCards || [];
                    rows = rows.concat(batch);
                    if(batch.length === batchSize){
                        return fetchBatch(offset + batchSize);
                    }
                    vm.exportInProgress = false;
                    if(rows.length){
                        $rootScope.downloadFile(header, rows, 'gift-cards.csv', order, 'gift_card_id');
                    } else {
                        toastMessage.showSimpleToast('No gift cards to export.', 'error-toast');
                    }
                });
            }
            fetchBatch(0);
        }

        /*********************************/
        /******* Delete gift card ********/
        /*********************************/

        $scope.deleteSelectedItem = function(ev){
            var confirm = $mdDialog.confirm()
            .title('Are you sure, you want to delete the selected admin gift card(s)?')
            .htmlContent('<b>' + vm.selectedProdIds.length + ' admin gift card(s)</b>' + ' will be deleted.')
            .ariaLabel('delete gift cards')
            .targetEvent(ev)
            .ok('OK')
            .cancel('CANCEL');
            
            $mdDialog.show(confirm).then(function ()
            {
                gcAdminService.deleteSelectedGiftCards(vm.selectedProdIds,vm.hotelID)
                .then(function(response){
                    if(response.status === 'success'){
                        vm.selectedProdIds = [];
                        vm.checkDelete = false;
                        loadPageCallbackWithDebounce();  
                    } else {
                        toastMessage.showSimpleToast('COMMON_ERROR','error-toast');
                    }
                });
            });
        };

        /**
         * Dselect gift cards
         */
        function deSelectGiftCards()
        {
            vm.selectedProdIds = [];
            vm.prodId = [];
        }

        /**
         * Select all gift cards
         */
        function SelectGiftCards()
        {
            if(vm.checkAll){
                vm.selectedProdIds = [];
                vm.prodId = [];
                var len = vm.giftCards ? vm.giftCards.length : 0;
                for(var i=0 ; i< len; i++){
                    vm.selectedProdIds.push(vm.giftCards[i].gift_card_id);
                }
                vm.deleteCheckbox = true;
            } else {
                vm.deleteCheckbox = false;
                vm.selectedProdIds = [];
            }
        }

        /*********************************/
        /******* Edit Gift Card **********/
        /*********************************/
        $scope.editGiftCard = function(value) {
			if(vm.userPermissions.indexOf('update_gift_card')!=-1){
				$state.go("app.e-commerce.gcadmins.update",{giftCardID : value});
			}
        };
        
        var loadPageCallbackWithDebounce;
        $scope.$watch('filterText', function(){
            if(loadPageCallbackWithDebounce){
                loadPageCallbackWithDebounce();  
            }
        });

    }
})();

(function ()
{
    'use strict';

    angular
    .module('app.e-commerce')
    .controller('GcadminController', GcadminController);

    /** @ngInject */
    function GcadminController(
    	$state, 
        $scope,
        $rootScope, 
        $localStorage,
        EnvironmentConfig,
        $http,
        $mdDialog,
        gcAdminService,
        toastMessage,
        getGiftCard,
        $translate,
        $timeout,
        moment
    )
    {
    	var vm = this;
        vm.flag = 'add';
        vm.reload = false;

        // 'available','expired','used','active','inactive'
        vm.autoFillOff = true;
        vm.status = [
                        {'value':'active', 'name':'Active'}, 
                        {'value':'inactive', 'name':'Inactive'},
                        {'value':'expired', 'name':'Expired'},
                        {'value':'available', 'name':'Available'},
                        {'value':'used', 'name':'Used'}];
        vm.state = [
            {'value':'available', 'name':'Available'}, 
            {'value':'expired', 'name':'Expired'},
            {'value':'used', 'name':'Used'}
        ];
        vm.giftCardData = {};
        vm.giftCardData.gift_card_status = '1';
        vm.giftCardData.gift_card_state = 'available';
        var hotelID = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
        vm.hotel_id = hotelID;
        $timeout(function () {
            vm.reload = true;
        }, 2000);
        var date = new Date();
        vm.minDate = new Date(date.getTime() + 24 * 60 * 60 * 1000);

        /************************************/
        /*********** Get Gift Card **********/
        /************************************/

        if(getGiftCard.status === 'success') {
            vm.flag = 'edit';
            vm.giftCardData = getGiftCard.data;
            vm.giftCardData.gift_card_status =  vm.giftCardData.gift_card_status == 1? true : false;
            vm.pagetitle = vm.giftCardData.gift_card_code;
        } else if(getGiftCard.status === 'error') {
            $state.go('app.e-commerce.gcadmins');
        }

        /************************************/
        /********* Add new Gift Card ********/
        /************************************/

        vm.addGiftCard = function(data) {
            data.hotel_id = vm.hotel_id;
            data.gift_card_expiration = new Date(moment(data.gift_card_expiration).format('YYYY-MM-DD'));
            gcAdminService.addGiftCard(data)
                .then(function(response) {
                    if(response.status === 'error') {
                        toastMessage.showSimpleToast($translate.instant('COMMON_ERROR'),'error-toast');
        			}
        			$state.go('app.e-commerce.gcadmins');
                });
        };

        /************************************/
        /********* Update Room type *********/
        /************************************/
        
        vm.saveEachField = function(value, field) {
            if(field == 'gift_card_status'){
                if(value)
                    value = 1;
                else
                    value = 0;
            }
            var hotel_id = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
            if(vm.flag == 'edit') {
                if(vm.reload) {
                    var newData = {
                        field : field,
                        value : value,
                        hotel_id : hotel_id,
                        giftCardID: vm.giftCardData.gift_card_id
                    };
                    gcAdminService.updateGiftCard(newData).then(function(response){
                        if(response.status === 'success') {
                             if(newData.field === 'gift_card_price') {
                                vm.giftCardData.cardHistory = response.data;
                             }
                        } else {
                            toastMessage.showSimpleToast($translate.instant(response.message),'error-toast');
                        }
                    });
                }
            }
        };

        /************************************/
        /********** Gift Code Exist *********/
        /************************************/

        vm.checkGiftCardCodeExist = function(code) {
            var data = {
                hotel_id : $localStorage.hotels[$localStorage.selectedHotel].hotel_id,
                gift_card_code : code
            };
            if(vm.giftCardData.gift_card_id) {
                data.gift_card_id = vm.giftCardData.gift_card_id;
            }
            gcAdminService.checkGiftCardCodeExist(data).then(function(response){
                if(response.status === 'success') {
                    // toastMessage.showSimpleToast($translate.instant(response.message),'success-toast');  
                } else {
                    toastMessage.showSimpleToast($translate.instant(response.message),'error-toast');
                }
            });
        };

        /************************************/
        /********** Gift Card Staus *********/
        /************************************/

        vm.getcardStatus = function(gift_card_expiration){
            var myDate = new Date();
            var currentDate = moment(myDate).format('YYYY-MM-DD');
            var expiryDate = moment(gift_card_expiration).format('YYYY-MM-DD');
            if(vm.giftCardData.gift_card_status){
                if (moment(currentDate).isSameOrAfter(moment(expiryDate))) {
                    return 'Expired';
                   } else {
                     if(vm.giftCardData.gift_card_price <= 0){
                         return 'Consumed';
                     }else{
                         return 'Available';
                     }
                   }
            } else {
                return 'Inactive';
            }
        }

        setTimeout(function() {
           vm.autoFillOff = false;
        }, 1500); 
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('DashboardEcommerceController', DashboardEcommerceController);

    /** @ngInject */
    function DashboardEcommerceController(Dashboard)
    {
        var vm = this;

        // Data
        vm.dashboard = Dashboard;

        vm.widget1 = vm.dashboard.widget1;
        vm.widget2 = vm.dashboard.widget2;
        vm.widget3 = vm.dashboard.widget3;
        vm.widget4 = vm.dashboard.widget4;
        vm.widget5 = {
            title       : vm.dashboard.widget5.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'multiBarChart',
                        color       : ['#03a9f4', '#b3e5fc'],
                        height      : 420,
                        margin      : {
                            top   : 8,
                            right : 16,
                            bottom: 32,
                            left  : 32
                        },
                        clipEdge    : true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked     : true,
                        duration    : 250,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yAxis       : {
                            tickFormat: function (d)
                            {
                                return d;
                            }
                        },
                        legend      : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        controls    : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboard.widget5.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboard.widget5.mainChart, function (chartData, index)
                {
                    vm.widget5.mainChart.data[index] = {
                        key   : chartData.key,
                        values: chartData.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget5.changeRange('TW');
            }
        };

        // Widget 6
        vm.widget6 = {
            title       : vm.dashboard.widget6.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'pieChart',
                        color       : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height      : 400,
                        margin      : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        donut       : true,
                        clipEdge    : true,
                        cornerRadius: 0,
                        labelType   : 'percent',
                        padAngle    : 0.02,
                        x           : function (d)
                        {
                            return d.label;
                        },
                        y           : function (d)
                        {
                            return d.value;
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            footerLeft  : vm.dashboard.widget6.footerLeft,
            footerRight : vm.dashboard.widget6.footerRight,
            ranges      : vm.dashboard.widget6.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboard.widget6.mainChart, function (data, index)
                {
                    vm.widget6.mainChart.data[index] = {
                        label: data.label,
                        value: data.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };

        // Widget 7
        vm.widget7 = {
            title       : vm.dashboard.widget7.title,
            ranges      : vm.dashboard.widget7.ranges,
            customers   : vm.dashboard.widget7.customers,
            currentRange: 'T'
        };

        // Methods

        //////////

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('BundleroomsController', BundleroomsController);

    /** @ngInject */
    function BundleroomsController(
        $state, 
        $scope,
        $localStorage,
        EnvironmentConfig,
        $http,
        $mdDialog,
        roomTypeService,
        bundleRoomsService,
        toastMessage,
        $sessionStorage,
        $rootScope,
        $stateParams
    )
    {
        var vm = this;
        if(!$rootScope.backButtonPressed){
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = {};
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] = 1;
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'] = 50;
        }

        vm.pageType = $stateParams['page_type'];
        if(vm.pageType == 'bundleRooms'){
            $scope.bundletype = 'BUNDLE';
        } else {
            $scope.bundletype = 'BUNDLEBOAT';
        }
        
        $scope.paginatorCallback = paginatorCallback;
        $scope.LoadAllData = LoadAllData;
        $scope.getLoadResultsCallback = getLoadResultsCallback;
        vm.loggedinUserRole = $localStorage.roleId;
        vm.hotelID = $rootScope.hotels[$rootScope.selectedHotel].hotel_id;
        vm.deSelectRoomTypes = deSelectRoomTypes;
        vm.SelectRoomTypes = SelectRoomTypes;
        vm.userPermissions = $rootScope.userPermissions;
        vm.prodId = [];
        vm.isDeleteAllowed = false;
        if(vm.userPermissions.indexOf('delete_bundle')!=-1) vm.isDeleteAllowed = true;
        /*********************************/
        /**** Paginate Room type data ****/
        /*********************************/
        $scope.selectedRowCallback = function(rows, id){
            vm.selectedProdIds = rows;
        };
        function getLoadResultsCallback(loadPageCallback){
            loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
        }
        vm.UserColumns = ['r.room_type_name','r.max_occupancy','r.room_type_description','r.status_type','r.room_type_id'];

            
        vm.onLoad = true;
        vm.requestGoing = false;
        function paginatorCallback(page, pageSize, option) {
            if(vm.requestGoing) return;
            if(vm.onLoad == true){
                if(typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] != 'undefined'){

                    var page1 =  $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
                    var pageSize1 = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'];
                    vm.onLoad = false;
                    return LoadAllData(page1, pageSize1,option);
                }else{
                    vm.onLoad = false;
                    return LoadAllData(page, pageSize,option);      
                }
            }else{
                if(typeof page == 'undefined'){
                    page = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
                }
                return LoadAllData(page, pageSize,option);
            }
            
        }
        function LoadAllData(page, pageSize, option){

            vm.requestGoing = true;
            var pageDetail = {'currentPage':page,'pageSize':pageSize};
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = pageDetail;


            vm.page = page;
            vm.pageSize = pageSize;
            vm.checkDelete = false;
            vm.selectedProdIds = [];
            var sort = {};
            for (var i = 0; i < option.columnSort.length; i++) {
                if (option.columnSort[i]['sort']) {
                    sort['column'] = vm.UserColumns[i];
                    sort['order'] = option.columnSort[i]['sort'];
                }
            }
            var offset = (page - 1) * pageSize;
            var query = $scope.filterText ? $scope.filterText : '';
            var filterData = {
                'offset': offset,
                'pageSize': pageSize,
                'search': $scope.filterText,
                'sort': sort,
                'dataType':vm.pageType
            };
            return $http({
                url: EnvironmentConfig.api + 'bundleRooms/bundlerooms_list',
                method: 'POST',
                data: filterData
            }).then(function(result) {
                vm.requestGoing = false;
                if (result.status === 200) {
                    vm.bundleRooms = result.data.bundlerooms;
                    vm.totalbundleRooms = result.data.totalBundlerooms;
                    return {
                        results: result.data.bundlerooms,
                        totalResultCount: result.data.totalBundlerooms
                    }
                } else {
                    toastMessage.showSimpleToast(result.data.errorMsg, 'error-toast');
                }
            });
        }

        /*********************************/
        /******* Delete Room type **********/
        /*********************************/

        $scope.deleteSelectedItem = function(ev){
            
            
            // new
            var html = ' Are you sure, you want to delete the selected bundle room(s)? </br>';
            html = html + '<b>' + vm.selectedProdIds.length + ' bundle room(s)</b>' + ' will be deleted.';
              
                $mdDialog.show({
                    controller: 'confirmController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose:true ,
                    locals: {
                        title: 'Delete Bundle',
                        htmlContent:html,
                        cancelBtn:'No',
                        OkBtn:'Yes'
                    }                
                })
                .then(function(answer) {
                    if(typeof answer != 'undefined' && answer == 'update'){
                        bundleRoomsService.deleteSelectedBundles({'ids':vm.selectedProdIds})
                            .then(function(response){
                                if(response.success){
                                    vm.selectedProdIds = [];
                                    vm.checkDelete = false;
                                    loadPageCallbackWithDebounce();  

                                } else {
                                    toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
                                }
                        });
                    }
                }, function() {}); 
            //Old
        };

        /**
         * Dselect room types
         */
        function deSelectRoomTypes()
        {
            vm.selectedProdIds = [];
            vm.prodId = [];
        }

        /**
         * Select all room types
         */
        function SelectRoomTypes()
        {
            if(vm.checkAll){
                vm.selectedProdIds = [];
                vm.prodId = [];
                for(var i=0 ; i< vm.bundleRooms.length; i++){
                    vm.selectedProdIds.push(vm.bundleRooms[i].room_type_id);
                }
                //  angular.forEach($scope.Items, function (item) {
                //     item.Selected = $scope.selectedAll;
                // });
                vm.deleteCheckbox = true;
            } else {
                vm.deleteCheckbox = false;
                vm.selectedProdIds = [];
            }
        }

        /*********************************/
        /******* Edit Room type **********/
        /*********************************/
        $scope.editBundle = function(value) {
            if(vm.userPermissions.indexOf('update_bundle')!=-1){
                if(vm.pageType == 'bundleRooms'){
                    $state.go("app.e-commerce.bundlerooms.bundleroomupdate",{id : value});
                } else {
                   $state.go("app.e-commerce.bundleboats.bundleboatupdate",{id : value});
                }

            }
        };
        var loadPageCallbackWithDebounce;
        $scope.$watch('filterText', function(){
            if(loadPageCallbackWithDebounce){
                loadPageCallbackWithDebounce();  
            }
        });

        vm.GotoAddUpdatePage = GotoAddUpdatePage;
        function GotoAddUpdatePage(){
            if(vm.pageType == 'bundleRooms')
                $state.go("app.e-commerce.bundlerooms.bundleroomadd");
            else
                $state.go("app.e-commerce.bundleboats.bundleboatadd");
        }
    }
})();

(function ()
{
  'use strict';

  angular
  .module('app.e-commerce')
  .controller('AttributesController', AttributesController);

  /** @ngInject */
  function AttributesController($mdToast, $scope, $mdSidenav,msUtils, $mdDialog, $document, attributeService, $localStorage, $state, toastMessage, $http, EnvironmentConfig)
  {

    var vm        = this;

    vm.tempContact  = [];
    vm.selectedAttributeId = [];
    vm.checkDelete  = false;
    vm.page         = 1;
    vm.pageSize     = 1;



    /*Start*/
    $scope.paginatorCallback = paginatorCallback;
    $scope.getLoadResultsCallback = getLoadResultsCallback;

    $scope.selectedRowCallback = function(rows){
      vm.selectedAttributeId = rows;


    };

    $scope.deleteSelectedItem = function(ev){
            
            var confirm = $mdDialog.confirm()
            .title('Are you sure want to delete the selected sttribute?')
            .htmlContent('<b>' + vm.selectedAttributeId.length + ' attribute</b>' + ' will be deleted.')
            .ariaLabel('delete contacts')
            .targetEvent(ev)
            .ok('OK')
            .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                attributeService.deleteSelectedAttributes(vm.selectedAttributeId)
                .then(function(response){
                  
                    if(!response.error){
                        toastMessage.showSimpleToast('Attribute successfully deleted.','success-toast');
                        vm.selectedAttributeId = [];
                        vm.checkDelete = false;
                        loadPageCallbackWithDebounce();  

                    } else {
                        toastMessage.showSimpleToast('Some error occured.Please try again.','error-toast');
                    }
                });
            });
        };


    var loadPageCallbackWithDebounce;

    $scope.$watch('filterText', function(){

      if(loadPageCallbackWithDebounce){
        loadPageCallbackWithDebounce();  
      }
    });
    $scope.showTabDialog = function(ev, id) {
     roleService.getRolePermissions(id).then(function(response){
      if(response.listData.length ==0){
        toastMessage.showSimpleToast('This role has no module assigned.','error-toast');
      } else {
        $state.go('app.rolesPermission',{id:id});

      }
    });
   };
   $scope.updateTable= function() {
    loadPageCallbackWithDebounce();  

  };

  $scope.checkBox = function(value) {
    if (vm.selectedRoleId.indexOf(value) > -1 )
    {
      vm.selectedRoleId.splice(vm.selectedRoleId.indexOf(value), 1);
    }
    else
    {
      vm.selectedRoleId.push(value);
    }
    if(vm.selectedRoleId.length > 0){
      vm.getNumberOfSelectedRows = vm.selectedRoleId.length;
      vm.checkDelete = true;
    } else {
      vm.checkDelete = false;
    } 
  };

  function getLoadResultsCallback(loadPageCallback){
    loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
  }
  vm.myColumns = ['attribute_heading','attribute_code','default_value','field_options','field_type','attribute_id'];

  
  function paginatorCallback(page, pageSize, op){
    vm.page = page;
    vm.pageSize = pageSize;

            var offset = (page-1) * pageSize;
            var query = $scope.filterText ? $scope.filterText : '';

            var sort = {};
            for(var i=0; i<op.columnSort.length; i++){
                if(op.columnSort[i]['sort']){
                    sort['column']= vm.myColumns[i];
                    sort['order']= op.columnSort[i]['sort'];
                }
            }
            var filterData = {'offset':offset , 'pageSize': pageSize, 'search':$scope.filterText, 'sort':sort };
            
            return $http({
              url: EnvironmentConfig.api+'attribute/attribute_list',
              method:'POST',
              data:filterData
            }).then(function(result){
              return {
                results: result.data[0]['attributeList'],
                totalResultCount: result.data[0]['attributeCount']
              }
            });
          }
          /*End*/

        // Data
        
        vm.user = [];
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'name';
        vm.listOrderAsc = false;
        vm.newGroupName = '';
        vm.myRoleId = $localStorage.roleId;
        // Methods
      }
    })();

(function ()
{
  'use strict';

  angular
  .module('app.e-commerce')
  .controller('AttributeController', AttributeController);
  /** @ngInject */
  function AttributeController($mdToast, $scope, $mdSidenav,msUtils, $document, attributeService, $localStorage, $state, toastMessage, $http, EnvironmentConfig,attribute){

    var vm          = this;
    vm.tempContact  = [];
    
    vm.attribute    = attribute[0];
    vm.showOption   = false;
    vm.uniqueHeading   = false;
    vm.uniqueCode   = false;

    // Methods
    vm.saveAttribute          = saveAttribute;
    vm.cehckFieldType         = cehckFieldType;
    vm.checkUniqueHeading     = checkUniqueHeading;
    vm.checkUniqueCode        = checkUniqueCode;


    function saveAttribute(){
      attributeService.saveAttribute(vm.attribute).then(function(response){});
    }

    function cehckFieldType(){

      vm.showOption = false;
      if(vm.attribute.field_type == 'dropdown' || vm.attribute.field_type == 'multiselect'){
        vm.showOption = true;
      }
    }

    function checkUniqueHeading(){

      var data = {'column':'attribute_code','heading':vm.attribute.attribute_code,'id':vm.attribute.attribute_id};
      vm.uniqueHeading   = false;
      attributeService.checkUniqueHeading(data).then(function(response){
        
        if(response.success ==1 ){
          vm.uniqueHeading   = true;
        }
      });
    }

    function checkUniqueCode(){

      var data = {'column':'attribute_code','heading':vm.attribute.attribute_code,'id':vm.attribute.attribute_id};

      vm.uniqueCode   = false;
      attributeService.checkUniqueHeading(data).then(function(response){
        if(response.success ==1 ){
          vm.uniqueCode   = true;
      }
    });
    }

    /*Start*/
    // $scope.paginatorCallback = paginatorCallback;
   /* $scope.getLoadResultsCallback = getLoadResultsCallback;

    $scope.selectedRowCallback = function(rows){
    };

    var loadPageCallbackWithDebounce;

    
    $scope.updateTable= function() {
      loadPageCallbackWithDebounce();  
    };

  $scope.checkBox = function(value) {
    if (vm.selectedRoleId.indexOf(value) > -1 )
    {
      vm.selectedRoleId.splice(vm.selectedRoleId.indexOf(value), 1);
    }
    else
    {
      vm.selectedRoleId.push(value);
    }
    if(vm.selectedRoleId.length > 0){
      vm.getNumberOfSelectedRows = vm.selectedRoleId.length;
      vm.checkDelete = true;
    } else {
      vm.checkDelete = false;
    } 
  };

  $scope.checkIt = function(){
    alert('pre');
  }


  function getLoadResultsCallback(loadPageCallback){
    loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
  }

  vm.myColumns = ['attribute_id','attribute_code','attribute_heading'];
  vm.user = [];
  vm.filterIds = null;
  vm.listType = 'all';
  vm.listOrder = 'name';
  vm.listOrderAsc = false;
  vm.newGroupName = '';
  vm.myRoleId = $localStorage.roleId;*/

}
})();

(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('AmenitiesController', AmenitiesController);

    /** @ngInject */
    function AmenitiesController($http, Amenities, toastMessage, amenitiesService, $location, $stateParams)
    {
    	var vm = this;
    	console.log("$stateParams",$stateParams);
    	vm.pageType = $stateParams['page_type'];
    	if(vm.pageType == 'Rooms'){
    		vm.mainHeading = 'Rooms Amenities';
    	} else {
    		vm.mainHeading = 'Boats Amenities';
    	}
    	vm.isloading = false;
		document.getElementById("amenity_data").innerHTML = Amenities.amenity_data;
		jQuery(document).on('click','.selected-room',function(){
			var data_key = jQuery(this).data( "key" );
			if(jQuery(this).is(":checked")){
				jQuery('#selected-rooms-list-'+data_key).removeClass('ng-hide');
			} else {
				jQuery('#selected-rooms-list-'+data_key).addClass('ng-hide');
				jQuery('.selected-room-key-'+data_key).prop("checked", false);vm.isloading = true;
				var data = {amenityStatus: false, amenity_id: data_key, amenity_type: 'all_rooms',dataType: vm.pageType};
				amenitiesService.saveAllRoomAmenity(data).then(function(response){
					vm.isloading = false;
					if(!response.success){
						document.getElementById("amenity_data").innerHTML = response.amenity_data;
					}
				});
			}
		});
  		jQuery(document).on('click','.all-room',function(){
			var data_key = jQuery(this).data( "key" );
			var amenityStatus = false;
			if(jQuery(this).is(":checked")){
				amenityStatus = true;
				jQuery('#selected-rooms-list-'+data_key).addClass('ng-hide');
				jQuery('#selected-rooms-'+data_key).prop('checked', false);
				jQuery('.selected-room-key-'+data_key).prop("checked", false);
			}
			vm.isloading = true;
			var data = {amenityStatus: amenityStatus, amenity_id: data_key, amenity_type: 'all_rooms',dataType: vm.pageType};
			amenitiesService.saveAllRoomAmenity(data).then(function(response){
				vm.isloading = false;
				if(!response.success){
					document.getElementById("amenity_data").innerHTML = response.amenity_data;
				}
			});
		});
		jQuery(document).on('click','.selected-room-key',function(){
			var data_key = jQuery(this).data("key");
			var data_roomkey = jQuery(this).data("roomkey");
			var amenityStatus = false;
			if(jQuery(this).is(":checked")){
				amenityStatus = true;
				jQuery('#all-rooms-'+data_key).prop('checked', false);
			}
			if(jQuery('.selected-room-key-'+data_key+':checked').length == 0){
				jQuery('#selected-rooms-'+data_key).prop('checked', false);
			} else {
				jQuery('#selected-rooms-'+data_key).prop('checked', true);
			}
			vm.isloading = true;
			var data = {amenityStatus: amenityStatus, amenity_id: data_key, room_type_id: data_roomkey, amenity_type: 'all_rooms', dataType: vm.pageType};
			amenitiesService.saveSelectedRoomAmenity(data).then(function(response){
				vm.isloading = false;
				if(!response.success){
					toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
					document.getElementById("amenity_data").innerHTML = response.amenity_data;
				}
			});
		});
		jQuery(document).on('click','.parent-amenity',function(){
			var data_key = jQuery(this).data("key");
			if(jQuery("#amenity-data-"+data_key).html().trim().length == 0){
				vm.isloading = true;
				var data = {room_amenity_type_id: data_key,dataType: vm.pageType};
				amenitiesService.getAllHotelAmenities(data).then(function(response){
					console.log("response",response);
					vm.isloading = false;
					if(!response.success){
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
					} else {
						document.getElementById("amenity_data").innerHTML = response.amenity_data;
						$location.hash('amenity-data-'+data_key);
					}
				});
			} else {
				document.getElementById("amenity-data-"+data_key).innerHTML = '';
			}
		});
    }
})();

(function() {
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('ActivitiesController', ActivitiesController);

    /** @ngInject */
    function ActivitiesController(
        $state,
        $scope,
        $rootScope,
        $localStorage,
        EnvironmentConfig,
        $http,
        $mdDialog,
        activityService,
        toastMessage,
        $sessionStorage,
        $stateParams
    ) {
        var vm = this;
        var vm = this;
        if(!$rootScope.backButtonPressed){
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = {};
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] = 1;
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'] = 50;
        }
        vm.pageType = $stateParams['page_type']; 
        $scope.paginatorCallback = paginatorCallback;
        $scope.LoadAllData = LoadAllData;
        $scope.getLoadResultsCallback = getLoadResultsCallback;
        vm.loggedinUserRole = $localStorage.roleId;
        vm.hotelID = $rootScope.hotels[$rootScope.selectedHotel].hotel_id;
        vm.deSelectActivites = deSelectActivites;
        vm.SelectActivites = SelectActivites;
        vm.goToAddProduct = goToAddProduct; 

        vm.prodId = [];
        vm.userPermissions = $rootScope.userPermissions;
		vm.isDeleteAllowed = false;
        if(vm.userPermissions.indexOf('delete_product')!=-1) vm.isDeleteAllowed = true;
        /*********************************/
        /**** Paginate Room type data ****/
        /*********************************/
        $scope.selectedRowCallback = function(rows, id) {
            vm.selectedProdIds = rows;
        };

        function getLoadResultsCallback(loadPageCallback) {
            loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
        }
        vm.UserColumns = ['product_name','product_pos_type','pt.pos_type_name', 'product_price', 'product_status', 'product_id'];

        vm.onLoad = true;
        vm.requestGoing = false;
        function paginatorCallback(page, pageSize, option) {
            if(vm.requestGoing) return;
            if(vm.onLoad == true){
                if(typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] != 'undefined'){

                    var page1 =  $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
                    var pageSize1 = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'];
                    vm.onLoad = false;
                    return LoadAllData(page1, pageSize1,option);
                }else{
                    vm.onLoad = false;
                    return LoadAllData(page, pageSize,option);      
                }
            }else{
                if(typeof page == 'undefined'){
                    page = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
                }
                return LoadAllData(page, pageSize,option);
            }
        }
        function LoadAllData(page, pageSize,option){

            vm.requestGoing = true;
            var pageDetail = {'currentPage':page,'pageSize':pageSize};
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = pageDetail;

            vm.page = page;
            vm.pageSize = pageSize;
            vm.checkDelete = false;
            vm.selectedProdIds = [];
            var sort = {};
            for (var i = 0; i < option.columnSort.length; i++) {
                if (option.columnSort[i]['sort']) {
                    sort['column'] = vm.UserColumns[i];
                    sort['order'] = option.columnSort[i]['sort'];
                }
            }
            var offset = (page - 1) * pageSize;
            var query = $scope.filterText ? $scope.filterText : '';
            var filterData = {
                'offset': offset,
                'pageSize': pageSize,
                //'search': $scope.filterText,
                'search': query,
                'sort': sort,
                'hotel_id': vm.hotelID,
                'dataType':vm.pageType
            };
            return $http({
                url: EnvironmentConfig.api + 'Activities/activities',
                method: 'POST',
                data: filterData
            }).then(function(result) {
                vm.requestGoing = false;
                if (result.data.status === 'success') {
                    vm.activities = result.data.data.activities;
                    vm.totalActivities = result.data.data.totalActivities;
                    return {
                        results: result.data.data.activities,
                        totalResultCount: result.data.data.totalActivities
                    }
                } else {
                    toastMessage.showSimpleToast(result.data.errorMsg, 'error-toast');
                }
            });
        }

        /*********************************/
        /******* Delete Room type **********/
        /*********************************/

        $scope.deleteSelectedItem = function(ev) {
            var del_txt = vm.selectedProdIds.length > 1 ? 'products' : 'product';

            // new
            var html = 'Are you sure, you want to delete the selected ' + del_txt + '?</br>';
            html = html + '<b>' + vm.selectedProdIds.length + ' ' + del_txt + ' </b>' + ' will be deleted.';
              
                $mdDialog.show({
                              controller: 'confirmController',
                              controllerAs: 'vm',
                              templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                              parent: angular.element(document.body),
                              targetEvent: event,
                              clickOutsideToClose:true ,
                              locals: {
                                    title: 'Delete Product',
                                    htmlContent:html,
                                    cancelBtn:'Cancel',
                                    OkBtn:'Ok'
                                }                
                            })
                            .then(function(answer) {
                               if(typeof answer != 'undefined' && answer == 'update'){
                                      activityService.deleteSelectedActivities(vm.selectedProdIds, vm.hotelID)
                                        .then(function(response) {
                                            if (!response.error) {
                                                //toastMessage.showSimpleToast('Customer has been deleted successfully.','success-toast');
                                                vm.selectedProdIds = [];
                                                vm.checkDelete = false;
                                                loadPageCallbackWithDebounce();

                                            } else {
                                                toastMessage.showSimpleToast('There was some error in deleting activities.', 'error-toast');
                                            }
                                        });
                               }
                            }, function() {}); 
            //Old
        };

        /**
         * Dselect room types
         */
        function deSelectActivites() {
            vm.selectedProdIds = [];
            vm.prodId = [];
        }

        /**
         * Select all Activites
         */
        function SelectActivites() {
            if (vm.checkAll) {
                vm.selectedProdIds = [];
                vm.prodId = [];
                for (var i = 0; i < vm.activities.length; i++) {
                    vm.selectedProdIds.push(vm.activities[i].product_id);
                }
                //  angular.forEach($scope.Items, function (item) {
                //     item.Selected = $scope.selectedAll;
                // });
                vm.deleteCheckbox = true;
            } else {
                vm.deleteCheckbox = false;
                vm.selectedProdIds = [];
            }
        }

        function goToAddProduct(pageType) {
            if(pageType == 'Rooms') {
                $state.go("app.e-commerce.activities.add");
            } else {
                $state.go("app.e-commerce.boat-activities.add");
            }
        }

        /*********************************/
        /******* Edit Activity **********/
        /*********************************/
        $scope.editActivity = function(value) {
			if(vm.userPermissions.indexOf('update_product')!=-1){
                if(vm.pageType == 'Rooms'){
                    $state.go("app.e-commerce.activities.update", {
                        productID: value
                    });
                } else {
                    $state.go("app.e-commerce.boat-activities.update", {
                        productID: value
                    });
                }
			}
        };

        var loadPageCallbackWithDebounce;
        $scope.$watch('filterText', function() {
            if (loadPageCallbackWithDebounce) {
                loadPageCallbackWithDebounce();
            }
        });

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('msNoteItemController', msNoteItemController)
        .directive('msNoteItem', msNoteItemDirective);

    /** @ngInject */
    function msNoteItemController($document)
    {
        var vm = this;
        var fontSizes = {
            '1': {
                fontSize  : 14,
                lineHeight: 19
            },
            '2': {
                fontSize  : 18,
                lineHeight: 28
            },
            '3': {
                fontSize  : 24,
                lineHeight: 36
            },
            '4': {
                fontSize  : 36,
                lineHeight: 48
            },
            '5': {
                fontSize  : 48,
                lineHeight: 60
            }
        };

        vm.element = [];
        vm.noFontResize = false;

        // Methods
        vm.updateDescriptionFontSize = updateDescriptionFontSize;

        //////

        function updateDescriptionFontSize()
        {
            if ( vm.noFontResize || !vm.note.description || vm.note.description === '' )
            {
                return;
            }

            var fontSize = '';
            var descWidth = Math.floor(vm.columnWidth - 52); // 48px paddings, + 4px tolerance
            var tmp = angular.element('<div style="visibility:hidden; font-size:10px;line-height: 10px;position:absolute;z-index:-1;white-space:pre-wrap;word-wrap: break-word;"></div>');
            tmp.appendTo($document.find('body'));

            fontSize = checkLineCount(sizeFromMaxWordCount());

            angular.element(vm.element).find('md-description').attr('font-size', fontSize);

            tmp.remove();

            function sizeFromMaxWordCount()
            {
                var words = vm.note.description.split(' ');

                var wordLengths = words.map(function (word)
                {
                    return tmp.text(word)[0].clientWidth;
                });

                var maxWordLength = Math.max.apply(Math, wordLengths);

                var maxPx = Math.floor((descWidth * 10) / maxWordLength);

                if ( maxPx < 18 )
                {
                    fontSize = 1;
                }
                else if ( 18 <= maxPx && maxPx < 24 )
                {
                    fontSize = 2;
                }
                else if ( 24 <= maxPx && maxPx < 36 )
                {
                    fontSize = 3;
                }
                else if ( 36 <= maxPx && maxPx < 48 )
                {
                    fontSize = 4;

                }
                else if ( maxPx >= 48 )
                {
                    fontSize = 5;
                }
                return fontSize;
            }

            function checkLineCount(sizeFromMaxWord)
            {
                var size = fontSizes[sizeFromMaxWord];
                var result;

                tmp.text(vm.note.description);
                tmp.width(descWidth);
                tmp.css({
                    'line-height': size.lineHeight + 'px',
                    'font-size'  : size.fontSize + 'px'
                });

                var lineCount = tmp[0].clientHeight / size.lineHeight;

                if ( 4 < lineCount && lineCount < 6 )
                {
                    result = 4;
                }
                else if ( 6 <= lineCount && lineCount < 9 )
                {
                    result = 3;
                }
                else if ( 9 <= lineCount && lineCount < 11 )
                {
                    result = 2;
                }
                else if ( 11 <= lineCount )
                {
                    result = 1;
                }
                else
                {
                    result = sizeFromMaxWord;
                }
                return result;
            }
        }
    }

    /** @ngInject */
    function msNoteItemDirective()
    {
        return {
            restrict        : 'A',
            controller      : 'msNoteItemController as MsNoteItem',
            templateUrl     : 'app/main/apps/e-commerce/directives/ms-note-item/ms-note-item.html',
            require         : ['msNoteItem', '^msMasonry'],
            bindToController: {
                msNoteItem: '='
            },
            link            : function (scope, element, attributes, controllers)
            {

                var MsNoteItem = controllers[0];
                var msMasonry = controllers[1];

                MsNoteItem.element = element;
                MsNoteItem.note = MsNoteItem.msNoteItem;


                if ( angular.isDefined(attributes.noFontResize) )
                {
                    MsNoteItem.noFontResize = true;
                }

                scope.$watch('MsNoteItem.msNoteItem', function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        MsNoteItem.note = newVal;
                    }
                });

                scope.$on('msMasonryItem:startReLayout', function ()
                {
                    if ( MsNoteItem.noFontResize || MsNoteItem.columnWidth === msMasonry.columnWidth )
                    {
                        return;
                    }

                    MsNoteItem.columnWidth = msMasonry.columnWidth;

                    MsNoteItem.updateDescriptionFontSize();
                });
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('msNoteFormController', msNoteFormController)
        .directive('msNoteForm', msNoteFormDirective);

    /** @ngInject */
    function msNoteFormController($scope, NotesService, msUtils, $mdDialog, $timeout, LabelsService)
    {
        var MsNoteForm = this;
        var notes = NotesService.data;

        //Data
        MsNoteForm.type = '';
        MsNoteForm.defaultNote = {
            'id'         : '',
            'title'      : '',
            'description': '',
            'archive'    : false,
            'image'      : '',
            'color'      : '',
            'time'       : new Date().toISOString(),
            'reminder'   : null,
            'checklist'  : [],
            'labels'     : []
        };
        MsNoteForm.noteId = '';
        MsNoteForm.editNode = {};
        MsNoteForm.newCheckListItem = '';
        MsNoteForm.checkListForm = false;
        MsNoteForm.labels = LabelsService.data;

        MsNoteForm.ngFlowOptions = {
            singleFile: true
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        MsNoteForm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };

        //Methods
        MsNoteForm.init = init;
        MsNoteForm.submit = submit;
        MsNoteForm.isNotValid = isNotValid;
        MsNoteForm.deleteNote = deleteNote;
        MsNoteForm.deleteImage = deleteImage;
        MsNoteForm.addChecklistItem = addChecklistItem;
        MsNoteForm.checklistFormToggle = checklistFormToggle;
        MsNoteForm.deleteCheckItem = deleteCheckItem;
        MsNoteForm.toggleArchive = toggleArchive;
        MsNoteForm.toggleInArray = msUtils.toggleInArray;
        MsNoteForm.exists = msUtils.exists;
        MsNoteForm.upload = upload;
        MsNoteForm.imageSuccess = imageSuccess;

        //////

        /**
         * Initialize
         */
        function init()
        {
            // If form type edit
            if ( MsNoteForm.type === 'edit' )
            {
                MsNoteForm.editNode = notes.getById(MsNoteForm.noteId);
                MsNoteForm.note = angular.copy(MsNoteForm.editNode);
            }
            // If form type new
            else
            {
                resetForm();
            }
        }

        /**
         * Watch New Note Form, reset form if it is closed
         */
        $scope.$on('MsNewNote:closed', function ()
        {
            resetForm();
        });

        /**
         * Reset Form
         */
        function resetForm()
        {
            $scope.$evalAsync(function ()
            {
                MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);
                MsNoteForm.checkListForm = false;
            });
        }

        /**
         * Submit Form
         */
        function submit()
        {
            if ( MsNoteForm.type === 'new' )
            {
                add();
            }
            else if ( MsNoteForm.type === 'edit' )
            {
                save();
            }
        }

        /**
         * Add new note
         */
        function add()
        {
            if ( isNotValid() )
            {
                return;
            }

            MsNoteForm.note.id = msUtils.guidGenerator();
            MsNoteForm.note.time = new Date().toISOString();

            NotesService.addNote(angular.copy(MsNoteForm.note));

            MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);

            $scope.$emit('MsNewNote:close');
        }

        /**
         * Save Note
         */
        function save()
        {
            if ( isNotValid() )
            {
                return;
            }
            NotesService.updateNote(MsNoteForm.note);
            $mdDialog.hide();
        }

        /**
         * Delete Note Image
         */
        function deleteImage()
        {
            MsNoteForm.note.image = '';
        }

        /**
         * Toggle Archive State
         */
        function toggleArchive()
        {
            if ( MsNoteForm.type === 'new' )
            {
                MsNoteForm.note.archive = true;
                submit();
            }
            else if ( MsNoteForm.type === 'edit' )
            {
                MsNoteForm.note.archive = !MsNoteForm.note.archive;
                save();
            }
        }

        /**
         * One of the image, title, description, checklist inputs are should be exist.
         * @returns {boolean}
         */
        function isNotValid()
        {
            return MsNoteForm.note.image === '' && MsNoteForm.note.title === '' && MsNoteForm.note.description === '' && MsNoteForm.note.checklist.length === 0;
        }

        /**
         * Delete Note
         * @param ev
         */
        function deleteNote(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the note?')
                .htmlContent('the note will be deleted permanently.')
                .ariaLabel('delete note')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                NotesService.deleteNote(MsNoteForm.note);
            });
        }

        /**
         * Add Checklist Item
         */
        function addChecklistItem()
        {
            if ( MsNoteForm.newCheckListItem === '' )
            {
                return;
            }

            MsNoteForm.note.checklist.push({
                checked: false,
                text   : MsNoteForm.newCheckListItem
            });

            MsNoteForm.newCheckListItem = '';

            focusChecklistInput();
        }

        /**
         * Checklist form toggle
         */
        function checklistFormToggle()
        {
            $scope.$evalAsync(function ()
            {
                MsNoteForm.checkListForm = !MsNoteForm.checkListForm;

                $timeout(function ()
                {
                    focusChecklistInput();
                });
            });
        }

        /**
         * Delete check item
         * @param item
         */
        function deleteCheckItem(item)
        {
            MsNoteForm.note.checklist.splice(MsNoteForm.note.checklist.indexOf(item), 1);
            focusChecklistInput();
        }

        /**
         * Focus checklist input
         */
        function focusChecklistInput()
        {
            angular.element('#new-checklist-item-input').focus();
        }

        /**
         * Upload
         */
        function upload()
        {
            // Set headers
            MsNoteForm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            MsNoteForm.ngFlow.flow.upload();
        }

        /**
         * Image Success
         * @param file
         * @param message
         */
        function imageSuccess(file, message)
        {
            var fileReader = new FileReader();

            fileReader.readAsDataURL(file.file);

            fileReader.onload = function (event)
            {
                file.url = event.target.result;

                $scope.$evalAsync(function ()
                {
                    MsNoteForm.note.image = file.url;
                });
            };

            file.type = 'image';
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

    }

    /** @ngInject */
    function msNoteFormDirective()
    {
        return {
            restrict    : 'EA',
            controller  : 'msNoteFormController',
            controllerAs: 'MsNoteForm',
            scope       : {
                noteType: '=',
                noteId  : '='
            },
            templateUrl : 'app/main/apps/e-commerce/directives/ms-note-form/ms-note-form.html',
            link        : function (scope, element, attributes, MsNoteForm)
            {
                // Type
                MsNoteForm.type = scope.noteType;

                // Note id
                if ( angular.isDefined(scope.noteId) )
                {
                    MsNoteForm.noteId = scope.noteId;
                }

                MsNoteForm.init();

            }
        };
    }
})();

(function () {
  "use strict";

  var KEY_CARD_HOUR_OPTIONS = [];
  var KEY_CARD_MINUTE_OPTIONS = [];
  var hour;
  var minute;

  function formatKeyCardTimePart(value) {
    return value < 10 ? "0" + value : String(value);
  }

  for (hour = 0; hour <= 23; hour++) {
    KEY_CARD_HOUR_OPTIONS.push(formatKeyCardTimePart(hour));
  }
  for (minute = 0; minute <= 59; minute++) {
    KEY_CARD_MINUTE_OPTIONS.push(formatKeyCardTimePart(minute));
  }

  angular
    .module("app.e-commerce")
    .controller("KeyCardDialogController", KeyCardDialogController);

  KeyCardDialogController.$inject = [
    "$mdDialog",
    "$document",
    "$scope",
    "eCommerceService",
    "toastMessage",
    "roomLockEncoderService",
    "$rootScope",
    "localData",
    "pageFor",
  ];

  function KeyCardDialogController(
    $mdDialog,
    $document,
    $scope,
    eCommerceService,
    toastMessage,
    roomLockEncoderService,
    $rootScope,
    localData,
    pageFor
  ) {
    var vm = this;

    vm.order = localData || {};
    vm.keyCard = {};
    vm.keyCardIssueLoading = false;
    vm.keyCardVerifyLoading = false;
    vm.keyCardRevokeLoading = false;
    vm.keyCardOverrideOldCard = false;
    vm.keyCardHourOptions = KEY_CARD_HOUR_OPTIONS;
    vm.keyCardMinuteOptions = KEY_CARD_MINUTE_OPTIONS;

    vm.keyCardIssue = keyCardIssue;
    vm.keyCardOpenVerify = keyCardOpenVerify;
    vm.keyCardVerifyAgain = keyCardVerifyAgain;
    vm.keyCardRevoke = keyCardRevoke;
    vm.closeKeyCardDialog = closeKeyCardDialog;
    vm.closeKeyCardVerifyDialog = closeKeyCardVerifyDialog;
    vm.keyCardCheckinModified = keyCardCheckinModified;
    vm.keyCardDatesChanged = updateKeyCardNights;
    vm.keyCardEncoderSystemChanged = keyCardEncoderSystemChanged;
    vm.keyCardOverrideOldCardChanged = keyCardOverrideOldCardChanged;
    vm.hasKeyCardContent = hasKeyCardContent;
    vm.keyCardBtnClass = keyCardBtnClass;

    initKeyCardEncoderSystem();
    initKeyCardDates();

    function keyCardIssue() {
      var keyCardResult = buildKeyCardIssuePayload();
      if (!keyCardResult.success) {
        toastMessage.showSimpleToast(
          keyCardResult.message,
          "error-toast",
          true
        );
        return;
      }

      vm.keyCardIssueLoading = true;
      eCommerceService
        .issueKeyCard(keyCardResult.data)
        .then(function (response) {
          if (response && response.card_details) {
            setKeyCardFromResponse(response);
          }

          if (response && response.success) {
            toastMessage.showSimpleToast(
              getResponseMessage(response, "Key generated successfully."),
              "success-toast",
              true
            );
          } else {
            toastMessage.showSimpleToast(
              getResponseMessage(response, "Failed to issue card."),
              "error-toast",
              true
            );
          }
        })
        .finally(function () {
          vm.keyCardIssueLoading = false;
        });
    }

    function parseKeyCardTimeParts(timeValue) {
      if (timeValue === undefined || timeValue === null || timeValue === "") {
        return { hour: "00", minute: "00" };
      }
      if (timeValue === "00.00") {
        return { hour: "00", minute: "00" };
      }
      var timeStr = String(timeValue).trim();
      var hmMatch = timeStr.match(/^(\d{1,2})[:.](\d{2})/);
      if (hmMatch) {
        var hour = parseInt(hmMatch[1], 10);
        var minute = parseInt(hmMatch[2], 10);
        return {
          hour: formatKeyCardTimePart(hour),
          minute: formatKeyCardTimePart(minute),
        };
      }
      return { hour: "00", minute: "00" };
    }

    function combineKeyCardDateTime(dateValue, hourValue, minuteValue) {
      if (!dateValue) {
        return null;
      }
      var datePart = moment(dateValue);
      if (!datePart.isValid()) {
        return null;
      }
      if (
        hourValue === undefined ||
        hourValue === null ||
        hourValue === "" ||
        minuteValue === undefined ||
        minuteValue === null ||
        minuteValue === ""
      ) {
        return null;
      }
      return datePart
        .clone()
        .hour(parseInt(hourValue, 10))
        .minute(parseInt(minuteValue, 10))
        .second(0)
        .millisecond(0);
    }

    function formatKeyCardDateTimeForApi(dateValue, hourValue, minuteValue) {
      var combined = combineKeyCardDateTime(dateValue, hourValue, minuteValue);
      if (!combined || !combined.isValid()) {
        return "";
      }
      return combined.format("YYYYMMDD") + combined.format("HHmm");
    }

    function initKeyCardEncoderSystem() {
      vm.keyCardEncoderSystemOptions = $rootScope.getEncoderSystemOptions();
      var roomLockEncoderSettings = roomLockEncoderService.getRoomLockEncoder();
      var storedLabel = roomLockEncoderSettings.machine;
      var matchedOption = vm.keyCardEncoderSystemOptions.find(function (
        option
      ) {
        return option.label === storedLabel;
      });
      vm.keyCardEncoderSystem =
        (matchedOption && matchedOption.value) ||
        (vm.keyCardEncoderSystemOptions[0] &&
          vm.keyCardEncoderSystemOptions[0].value) ||
        "system_1";
      vm.keyCardOverrideOldCard = roomLockEncoderSettings.override_old;
    }

    function keyCardEncoderSystemChanged() {
      var selectedOption = vm.keyCardEncoderSystemOptions.find(function (
        option
      ) {
        return option.value === vm.keyCardEncoderSystem;
      });
      if (selectedOption) {
        roomLockEncoderService.setRoomLockEncoderMachine(selectedOption.label);
      }
    }

    function keyCardOverrideOldCardChanged() {
      roomLockEncoderService.setRoomLockEncoderOverrideOld(
        vm.keyCardOverrideOldCard
      );
    }

    function buildKeyCardVerifyRevokePayload() {
      return {
        system: vm.keyCardEncoderSystem || "system_1",
        page_for: pageFor,
      };
    }

    function parseKeyCardStayDate(dateValue) {
      if (!dateValue) {
        return null;
      }
      var parsed = moment(
        dateValue,
        ["MM/DD/YYYY", "MM/DD/YY", "MM/DD", "YYYY-MM-DD", moment.ISO_8601],
        true
      );
      if (!parsed.isValid()) {
        parsed = moment(dateValue);
      }
      return parsed.isValid() ? new Date(parsed.format()) : null;
    }

    function isDayReservationOrder(orderData) {
      var type = String(
        (orderData && orderData.type_of_reservation) || ""
      ).toLowerCase();
      return type === "day_reservation";
    }

    function resolveHourTimeParts(hourValue, fallbackHHmm) {
      if (
        hourValue !== undefined &&
        hourValue !== null &&
        hourValue !== "" &&
        !isNaN(parseInt(hourValue, 10)) &&
        parseInt(hourValue, 10) >= 0
      ) {
        return {
          hour: formatKeyCardTimePart(parseInt(hourValue, 10)),
          minute: "00",
        };
      }
      return parseKeyCardTimeParts(fallbackHHmm);
    }

    function initKeyCardDates() {
      var orderData = vm.order || {};
      var isDayRoom = isDayReservationOrder(orderData);
      var dayRoomTimes =
        typeof $rootScope.getDayRoomKeyCardTimes === "function"
          ? $rootScope.getDayRoomKeyCardTimes()
          : { checkin: "11:00", checkout: "17:00" };
      var checkinTime;
      var checkoutTime;

      if (isDayRoom) {
        // Day Room / Daily Rentals: use hotel config (122 => 11:00–17:00)
        // Prefer reservation arrival/departure hour when already set.
        checkinTime = resolveHourTimeParts(
          orderData.arrival_time,
          dayRoomTimes.checkin
        );
        checkoutTime = resolveHourTimeParts(
          orderData.departure_time,
          dayRoomTimes.checkout
        );
      } else {
        checkinTime = parseKeyCardTimeParts($rootScope.getGuestCheckinFrom());
        checkoutTime = parseKeyCardTimeParts($rootScope.getGuestCheckoutTo());
      }

      vm.keyCardCheckin =
        parseKeyCardStayDate(orderData.room_stay_from) || new Date();
      vm.keyCardCheckout =
        parseKeyCardStayDate(orderData.room_stay_to) ||
        (isDayRoom
          ? new Date(vm.keyCardCheckin)
          : new Date(moment(vm.keyCardCheckin).add(1, "days")));
      vm.keyCardCheckinHour = checkinTime.hour;
      vm.keyCardCheckinMinute = checkinTime.minute;
      vm.keyCardCheckoutHour = checkoutTime.hour;
      vm.keyCardCheckoutMinute = checkoutTime.minute;
      // Day rooms are same-calendar-day; overnight requires next-day min checkout.
      vm.keyCardMinCheckout = isDayRoom
        ? new Date(moment(vm.keyCardCheckin).startOf("day"))
        : new Date(moment(vm.keyCardCheckin).add(1, "days"));
      updateKeyCardNights();
    }

    function keyCardCheckinModified() {
      var isDayRoom = isDayReservationOrder(vm.order);
      vm.keyCardMinCheckout = isDayRoom
        ? new Date(moment(vm.keyCardCheckin).startOf("day"))
        : new Date(moment(vm.keyCardCheckin).add(1, "days"));
      var endDate = moment(vm.keyCardCheckout);
      var startDate = moment(vm.keyCardCheckin);
      if (endDate.isBefore(startDate, "day")) {
        vm.keyCardCheckout = new Date(
          moment(startDate).add(isDayRoom ? 0 : 1, "days")
        );
      } else if (!isDayRoom && endDate.isSame(startDate, "day")) {
        vm.keyCardCheckout = new Date(moment(startDate).add(1, "days"));
      }
      updateKeyCardNights();
    }

    function updateKeyCardNights() {
      vm.keyCardNights = getKeyCardNights();
    }

    function getKeyCardNights() {
      if (!vm.keyCardCheckin || !vm.keyCardCheckout) {
        return null;
      }
      var checkinDay = moment(vm.keyCardCheckin).startOf("day");
      var checkoutDay = moment(vm.keyCardCheckout).startOf("day");
      if (!checkinDay.isValid() || !checkoutDay.isValid()) {
        return null;
      }
      var nights = checkoutDay.diff(checkinDay, "days");
      if (nights < 1) {
        var checkin = combineKeyCardDateTime(
          vm.keyCardCheckin,
          vm.keyCardCheckinHour,
          vm.keyCardCheckinMinute
        );
        var checkout = combineKeyCardDateTime(
          vm.keyCardCheckout,
          vm.keyCardCheckoutHour,
          vm.keyCardCheckoutMinute
        );
        if (!checkin || !checkout || checkout.valueOf() <= checkin.valueOf()) {
          return null;
        }
        nights = Math.ceil(checkout.diff(checkin, "days", true));
      }
      return nights < 1 ? null : nights;
    }

    function buildKeyCardIssuePayload() {
      if (!vm.order || !vm.order.confirmation_number) {
        return {
          success: false,
          message: "Missing confirmation number.",
        };
      }
      if (!vm.keyCardCheckin || !vm.keyCardCheckout) {
        return {
          success: false,
          message: "Please select check-in and check-out dates.",
        };
      }
      var checkin = combineKeyCardDateTime(
        vm.keyCardCheckin,
        vm.keyCardCheckinHour,
        vm.keyCardCheckinMinute
      );
      var checkout = combineKeyCardDateTime(
        vm.keyCardCheckout,
        vm.keyCardCheckoutHour,
        vm.keyCardCheckoutMinute
      );
      if (!checkin || !checkout) {
        return {
          success: false,
          message: "Please enter valid check-in and check-out times.",
        };
      }
      if (checkout.valueOf() <= checkin.valueOf()) {
        return {
          success: false,
          message:
            "Check-out date and time must be after check-in date and time.",
        };
      }
      var room_stay_from = formatKeyCardDateTimeForApi(
        vm.keyCardCheckin,
        vm.keyCardCheckinHour,
        vm.keyCardCheckinMinute
      );
      var room_stay_to = formatKeyCardDateTimeForApi(
        vm.keyCardCheckout,
        vm.keyCardCheckoutHour,
        vm.keyCardCheckoutMinute
      );
      if (!room_stay_from || !room_stay_to) {
        return {
          success: false,
          message: "Please enter valid check-in and check-out times.",
        };
      }
      return {
        success: true,
        data: {
          confirmation_number: vm.order.confirmation_number,
          override_old_card: !!vm.keyCardOverrideOldCard,
          room_stay_from: room_stay_from,
          room_stay_to: room_stay_to,
          system: vm.keyCardEncoderSystem || "system_1",
          page_for: pageFor,
          common_doors: getKeyCardCommonDoorIds()
        },
      };
    }

    function keyCardOpenVerify(ev) {
      vm.keyCardVerifyLoading = true;

      eCommerceService
        .verifyKeyCard(buildKeyCardVerifyRevokePayload())
        .then(function (response) {
          if (!isKeyCardVerifyDialogAllowed(response)) {
            toastMessage.showSimpleToast(
              getResponseMessage(
                response,
                "Failed to verify card. Place a card on the encoder and try again."
              ),
              "error-toast",
              true
            );
            return;
          }

          setKeyCardFromResponse(response);
          openKeyCardVerifyDialog(ev);
        })
        .finally(function () {
          vm.keyCardVerifyLoading = false;
        });
    }

    function getKeyCardEncoderStatusCode(response) {
      if (!response || !response.encoder_response) {
        return "";
      }
      return String(response.encoder_response).split("|")[0].trim();
    }

    function isKeyCardVerifyDialogAllowed(response) {
      return !!(
        response &&
        response.success === true &&
        getKeyCardEncoderStatusCode(response) === "000000"
      );
    }

    function keyCardVerifyAgain() {
      vm.keyCardVerifyLoading = true;
      eCommerceService
        .verifyKeyCard(buildKeyCardVerifyRevokePayload())
        .then(function (response) {
          if (response && response.card_details) {
            setKeyCardFromResponse(response);
          }

          if (response && response.success) {
            toastMessage.showSimpleToast(
              getResponseMessage(response, "Card verified successfully."),
              "success-toast",
              true
            );
          } else {
            toastMessage.showSimpleToast(
              getResponseMessage(response, "Failed to verify card."),
              "error-toast",
              true
            );
          }
        })
        .finally(function () {
          vm.keyCardVerifyLoading = false;
        });
    }

    function openKeyCardVerifyDialog(ev) {
      var dialogScope = $scope.$new();
      dialogScope.vm = vm;

      $mdDialog.show({
        templateUrl:
          "app/main/apps/e-commerce/dialogs/key-card/key-card-verify-dialog.html",
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        skipHide: true,
        multiple: true,
        scope: dialogScope,
      });
    }

    function keyCardRevoke(ev) {
      var confirm = $mdDialog
        .confirm()
        .title("Revoke Card")
        .htmlContent(
          '<div class="md-padding revoke-dialog-content">Are you sure you want to revoke this card?</div>'
        )
        .ariaLabel("Revoke card confirmation")
        .targetEvent(ev)
        .ok("Yes, Revoke")
        .cancel("Cancel")
        .multiple(true);

      $mdDialog.show(confirm).then(function () {
        vm.keyCardRevokeLoading = true;
        eCommerceService
          .revokeKeyCard(buildKeyCardVerifyRevokePayload())
          .then(function (response) {
            if (response && response.card_details) {
              setKeyCardFromResponse(response);
            }

            if (response && response.success) {
              toastMessage.showSimpleToast(
                getResponseMessage(response, "Card revoked successfully."),
                "success-toast",
                true
              );
            } else {
              toastMessage.showSimpleToast(
                getResponseMessage(response, "Failed to revoke card."),
                "error-toast",
                true
              );
            }
          })
          .finally(function () {
            vm.keyCardRevokeLoading = false;
          });
      });
    }

    function closeKeyCardVerifyDialog() {
      $mdDialog.hide();
    }

    function closeKeyCardDialog() {
      $mdDialog.cancel();
    }

    function setKeyCardFromResponse(response) {
      var source = (response && response.card_details) || {};
      vm.keyCard = {
        card_type: source.card_type || "",
        building: source.building || "",
        room: source.room || "",
        floor: source.floor || "",
        room_name: source.room_name || "",
        name: source.name || "",
        begin_date: convertTo12HourFormat(source.begin_date || ""),
        expired_date: convertTo12HourFormat(source.expired_date || ""),
        card_no: source.card_no || source.card_number || "",
        override_old_card: source.override_old_card || false,
        common_doors: source.common_doors || []
      };
    }

    function getResponseMessage(response, fallback) {
      return (response && (response.errorMsg || response.message)) || fallback;
    }

    function hasKeyCardContent() {
      var card = vm.keyCard || {};
      return !!(
        card.card_type ||
        card.building ||
        card.room ||
        card.floor ||
        card.room_name ||
        card.name ||
        card.begin_date ||
        card.expired_date ||
        card.card_no ||
        (card.common_doors && card.common_doors.length)
      );
    }

    function keyCardBtnClass(loading, baseClass) {
      return loading
        ? "md-raised md-accent submit-button grey-100-fg key-card-action-btn"
        : "md-raised " +
            baseClass +
            " submit-button white-fg key-card-action-btn";
    }

    function convertTo12HourFormat(dateStr) {
      if (!dateStr) return "";

      var parts = dateStr.split(" ");
      if (parts.length < 2) return dateStr;

      var datePart = parts[0];
      var timePart = parts[1];
      var timePieces = timePart.split(":");
      var hours = parseInt(timePieces[0], 10);
      var minutes = timePieces[1];
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      if (hours === 0) hours = 12;

      return datePart + " " + hours + ":" + minutes + " " + ampm;
    }

    function getKeyCardCommonDoorIds() {
      var option = vm.keyCardEncoderSystemOptions[0];
      return (option && option.common_doors) || [];
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .controller('msNewNoteController', msNewNoteController)
        .directive('msNewNoteButton', msNewNoteButtonDirective)
        .directive('msNewNote', msNewNoteDirective);

    /** @ngInject */
    function msNewNoteController($scope, $document)
    {
        var MsNewNote = this;

        //Data
        MsNewNote.formVisible = false;
        MsNewNote.form = {
            title      : '',
            description: ''
        };

        //Methods
        MsNewNote.open = open;
        MsNewNote.close = close;
        MsNewNote.element = [];

        //////

        /**
         * Close Trigger
         */
        $scope.$on('MsNewNote:close', function ()
        {
            close();
        });

        /**
         * Open new note form
         */
        function open()
        {
            MsNewNote.element.addClass('form-visible');
            MsNewNote.element.find('textarea').focus();
            $document.on('click', outSideClick);
        }

        /**
         * Close new note form
         */
        function close()
        {
            MsNewNote.element.removeClass('form-visible');
            $scope.$broadcast('MsNewNote:closed');

            $document.off('click', outSideClick);
        }

        /**
         * Click Outside Event Handler
         * @param event
         */
        function outSideClick(event)
        {
            var isChild = MsNewNote.element.has(event.target).length > 0;
            var isSelf = MsNewNote.element[0] === event.target;
            var isMenu = angular.element(event.target).closest('md-menu-content').length > 0;
            var isCalendar = angular.element(event.target).closest('md-calendar').length > 0 || angular.element(event.target).closest('.md-datepicker-calendar-pane').length > 0 || angular.element(event.target).hasClass('md-scroll-mask');

            var isInside = isChild || isSelf || isMenu || isCalendar;

            if ( !isInside )
            {
                close();
            }
        }
    }

    /** @ngInject */
    function msNewNoteDirective()
    {
        return {
            restrict    : 'E',
            controller  : 'msNewNoteController',
            controllerAs: 'MsNewNote',
            templateUrl : 'app/main/apps/e-commerce/directives/ms-new-note/ms-new-note.html',
            link        : function (scope, element, attributes, MsNewNote)
            {
                MsNewNote.element = element;
            }
        };
    }

    /** @ngInject */
    function msNewNoteButtonDirective()
    {
        return {
            restrict: 'EA',
            require : '^msNewNote',
            link    : function (scope, element, attributes, msNewNote)
            {
                element.on('click', function ()
                {
                    msNewNote.open();
                });
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular.module('app.dashboards.gantt-chart')
        .controller('addCommentRes', addCommentRes);

    /** @ngInject */
    function addCommentRes($mdDialog, $document, dialogData, $rootScope, toastMessage, $state, ganttChartService,$scope,parentScope)
    {
		var vm = this;
		// Data
		vm.data = dialogData.thisnewcreateData.model;
		vm.product_id = dialogData.thisnewcreateData.row.model.id;
		vm.note_type = "comment";
		vm.label = 'Comment';
		vm.isloading = false;
		if(dialogData.thisnewcreateData.model.room_confirmation_number && dialogData.thisnewcreateData.model.room_confirmation_number!='')
			vm.data.confirmation_number = dialogData.thisnewcreateData.model.room_confirmation_number;
		else
			vm.data.confirmation_number = dialogData.thisnewcreateData.model.confirmation_number;
		vm.comment = '';
		vm.savingcomment = '';
        //Methods
        vm.closeDialog = closeDialog;
        vm.savecommentofRes = savecommentofRes;
        vm.type_changed = type_changed;
       
       /**
	   * Close dialog
	   */
	   function closeDialog()
       {
           $mdDialog.hide();
       }
       
       function type_changed(){
			if(vm.note_type == 'comment')
				vm.label = 'Comment';
			else
				vm.label = 'Special Request';
	   }
       function savecommentofRes(){
		   vm.isloading = true;
		   vm.savingcomment = true;
			ganttChartService.savecommentofRes({confirmation_number:vm.data.confirmation_number,type_of_reservation:vm.data.type_of_reservation,comm_req_value:vm.comment,comm_req_type:vm.note_type,room_stay_from:vm.data.from,room_stay_to:vm.data.to,product_id:vm.product_id}).then(function(response){
				vm.isloading = false;
				vm.savingcomment = false;
				parentScope.comment_reload = false;
				if(response.success){
					parentScope.comment_reload = true;
					closeDialog();
				}else if(response.errorMsg){
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				}else{
					toastMessage.showSimpleToast('There was some error in saving comment.','error-toast');
				}
			});
	   }
    }

})();

(function ()
{
    'use strict';

    angular.module('app.dashboards.gantt-chart')
        .controller('optionCreatePlaceGantt', optionCreatePlaceGantt);

    /** @ngInject */
    function optionCreatePlaceGantt(
    	EnvironmentConfig,
    	$mdDialog,
    	$document,
    	dialogData,
    	$rootScope,
    	toastMessage,
    	$state,
    	ganttChartServiceNew,
    	parentScope,
    	mode_of_call,
    	$timeout,
    	$localStorage,
    	$sessionStorage,
    	eCommerceService,
    	commonService,
    	createResService,
    	$q)
    {
		var vm = this;
		// Data
		// console.log("I am here for data", dialogData);

		vm.myDate = new Date();
		vm.minDate = new Date(
			vm.myDate.getFullYear(),
			vm.myDate.getMonth(),
			vm.myDate.getDate()
		);
		vm.mode_of_call = mode_of_call;
		vm.data = {};
		vm.showSaveBtn = true;
		vm.showSearch = true;
		vm.selectedRoom = {};
		vm.policiesDetail = {};
		vm.baseUrl = EnvironmentConfig.api;
		vm.data.product_name = dialogData.thisroomname;
		vm.data.product_id = dialogData.thisnewcreateData.row.model.productId !== undefined ? dialogData.thisnewcreateData.row.model.productId : dialogData.thisnewcreateData.row.model.id;
		vm.room_type_description = '';
		vm.pageType = (dialogData.chartData && dialogData.chartData.pageType) ? dialogData.chartData.pageType : (dialogData.requestFrom || 'room');
		vm.readText = 'Show description';
		vm.promoRequestGoing = false;
		vm.holdPromoApplied = false;
		vm.holdPromoCode = '';
		vm.holdPromoDiscount = 0;
		vm.holdPromoPolicy = '';
		vm.holdPromoMessage = '';
		vm.holdPromoLocked = false;
		vm.holdDiscountApplied = false;
		vm.holdDiscountAmount = 0;
		vm.holdDiscountPercent = 0;
		vm.holdDiscountComment = '';
		vm.holdDiscountPolicy = '';
		vm.displayNightlyRate = '';
		vm.showHoldPromoRemoveConfirm = false;
		vm.holdNightlyRows = [];
		vm.showHoldDiscountPanel = false;
		vm.baseSearchSummary = {};
		vm.roomTypeId = '';
		vm.stayNights = 1;
		// console.log(vm.data.product_id,'vm.data.product_id');
		// console.log('dialogData', dialogData);
		// console.log(vm.data);
		vm.data.adult = 2;
		vm.data.child = 0;
		vm.adultRange = [1, 2];
		vm.childRange = [0, 1];
		vm.original_adult = 2;
		vm.original_child = 0;
		vm.data.room_stay_from = new Date(moment(dialogData.thisnewcreateData.model.from._d).format('MM/DD/YYYY'));
		vm.data.room_stay_to = new Date(moment(dialogData.thisnewcreateData.model.to._d).format('MM/DD/YYYY'));
		vm.original_room_stay_from = angular.copy(vm.data.room_stay_from);
		vm.original_room_stay_to = angular.copy(vm.data.room_stay_to);
		var initStayDiff = Math.round(Math.abs(moment(vm.data.room_stay_to).diff(moment(vm.data.room_stay_from), 'days')));
		if (initStayDiff > 0) { vm.stayNights = initStayDiff; }
		vm.minDateCheckout = new Date(moment(vm.data.room_stay_from, "DD-MM-YYYY").add(1, 'days'));
		parentScope.reloaddashboard = true;

		vm.currentHotelId = $localStorage['preHotelId'];
		vm.isDayReservationHotel = typeof $rootScope.isDailyRentalsAvailable === 'function'
			? $rootScope.isDailyRentalsAvailable()
			: false;
		vm.isSameDaySelection = moment(vm.data.room_stay_from).format('YYYY-MM-DD') === moment(vm.data.room_stay_to).format('YYYY-MM-DD');
		vm.isCreateMode = function() {
			return vm.data.type_of_reservation === 'create' || vm.data.type_of_reservation === 'create_day';
		};
		vm.isDayCreateMode = function() {
			return vm.data.type_of_reservation === 'create_day';
		};
		vm.showRateUI = function() {
			return vm.isCreateMode() || vm.data.type_of_reservation === 'hold';
		};
		vm.hasHoldRoomLoaded = function() {
			return !!(vm.policiesDetail && Object.keys(vm.policiesDetail).length);
		};
		vm.showHoldGuestStep = false;
		vm.showHoldAvailableRooms = false;
		vm.available_rooms = [];
		vm.subHotel = [];
		vm.subHotelcount = {};
		vm.selectedSubHotelId = 0;
		vm.holdAvailablePick = {};
		vm.showHoldPolicyRow = function(policykey) {
			if (vm.data.type_of_reservation !== 'hold' || !vm.showHoldGuestStep) {
				return true;
			}
			return String(policykey) === String(vm.selectedRoom[vm.data.product_id]);
		};
		vm.goToHoldGuestStep = function() {
			if(vm.data.type_of_reservation !== 'hold'){ return; }
			if (vm.showHoldAvailableRooms) {
				if (!applyHoldAvailableSelection()) {
					vm.showHoldAvailableRooms = false;
					vm.showHoldGuestStep = true;
					return;
				}
			}
			if(!vm.onlyAllowHoldBlock && !vm.selectedRoom[vm.data.product_id]){ return; }
			if (!vm.data.hold_duration || moment(vm.data.hold_duration).isBefore(moment(vm.minDate), 'day')) {
				vm.data.hold_duration = angular.copy(vm.minDate);
			}
			vm.showHoldDiscountPanel = (vm.mode_of_call == 'edit');
			vm.showHoldAvailableRooms = false;
			vm.showHoldGuestStep = true;
		};
		vm.backToHoldRooms = function() {
			vm.showHoldGuestStep = false;
			vm.showHoldDiscountPanel = false;
			if (vm.mode_of_call == 'edit' && vm.data.type_of_reservation === 'hold') {
				loadHoldAvailableRooms();
			}
		};
		vm.showHoldSubHotel = function(hotelId) {
			vm.selectedSubHotelId = hotelId;
		};
		vm.temp = {};
		vm.pickHoldAvailableRoom = function(room, policyKey) {
			if (!room || !policyKey) { return; }
			markHoldAvailablePick(room, policyKey);
		};
		vm.hasHoldAvailablePick = function() {
			return Object.keys(vm.holdAvailablePick || {}).length > 0;
		};
		function holdPolicyKeys(policies) {
			return policies ? Object.keys(policies) : [];
		}
		function matchHoldPolicyKey(policies, wanted) {
			var keys = holdPolicyKeys(policies);
			if (!keys.length) { return ''; }
			if (wanted == null || wanted === '') { return keys[0]; }
			for (var i = 0; i < keys.length; i++) {
				if (String(keys[i]) === String(wanted)) { return keys[i]; }
			}
			return keys[0];
		}
		function markHoldAvailablePick(room, policyKey) {
			if (!room || !policyKey) { return; }
			vm.temp = {};
			angular.forEach(vm.available_rooms || [], function(item) {
				vm.temp[item.product_id] = {};
				angular.forEach(item.policy_name || {}, function(name, pkey) {
					vm.temp[item.product_id][pkey] = false;
				});
			});
			if (!vm.temp[room.product_id]) {
				vm.temp[room.product_id] = {};
			}
			vm.temp[room.product_id][policyKey] = true;
			vm.holdAvailablePick = {};
			vm.holdAvailablePick[room.product_id] = policyKey;
			vm.holdAvailableRoomRef = room;
		}
		function currentHoldPolicyKey() {
			if (!vm.data || !vm.data.product_id) { return ''; }
			return vm.selectedRoom[vm.data.product_id] || vm.selectedRoom[String(vm.data.product_id)] || '';
		}
		function preselectCurrentHoldRoom() {
			var currentPid = String(vm.data.product_id || '');
			var currentPk = currentHoldPolicyKey();
			var matchedRoom = null;
			vm.holdAvailablePick = {};
			vm.temp = {};
			angular.forEach(vm.available_rooms || [], function(room) {
				vm.temp[room.product_id] = {};
				angular.forEach(room.policy_name || {}, function(name, pkey) {
					vm.temp[room.product_id][pkey] = false;
				});
				if (String(room.product_id) === currentPid) {
					matchedRoom = room;
				}
			});
			if (!matchedRoom && currentPid && vm.data.product_name) {
				var pk = currentPk || '2';
				var policy = (vm.policiesDetail && vm.policiesDetail[pk]) || {};
				var summary = (vm.searchSummary && vm.searchSummary[pk]) || {};
				matchedRoom = {
					product_id: vm.data.product_id,
					product_name: vm.data.product_name,
					image: vm.proImage,
					max_occupancy: vm.maxOccupancy,
					sub_hotel_id: vm.selectedSubHotelId,
					policy_name: {},
					nightlyRate: {},
					searchSummary: {},
					rateNameDesc: {}
				};
				matchedRoom.policy_name[pk] = policy.policy_name || 'Selected';
				matchedRoom.nightlyRate[pk] = policy.nightlyRate;
				matchedRoom.searchSummary[pk] = summary;
				matchedRoom.rateNameDesc[pk] = { ratePlanName: policy.ratePlanName || '' };
				vm.available_rooms = [matchedRoom].concat(vm.available_rooms || []);
				if (vm.subHotelcount && vm.selectedSubHotelId != null && vm.subHotelcount[vm.selectedSubHotelId] != null) {
					vm.subHotelcount[vm.selectedSubHotelId] = (parseInt(vm.subHotelcount[vm.selectedSubHotelId], 10) || 0) + 1;
				}
				vm.temp[matchedRoom.product_id] = {};
				vm.temp[matchedRoom.product_id][pk] = false;
			}
			if (!matchedRoom) { return; }
			if (matchedRoom.sub_hotel_id) {
				vm.selectedSubHotelId = matchedRoom.sub_hotel_id;
			}
			var pickKey = matchHoldPolicyKey(matchedRoom.policy_name, currentPk);
			if (!pickKey) { return; }
			markHoldAvailablePick(matchedRoom, pickKey);
		}

		function loadHoldAvailableRooms() {
			vm.showHoldAvailableRooms = true;
			vm.showHoldGuestStep = false;
			vm.showHoldDiscountPanel = false;
			vm.isloading = true;
			var data = {
				new_checkin: moment(vm.data.room_stay_from || vm.original_room_stay_from).format('YYYY-MM-DD'),
				new_checkout: moment(vm.data.room_stay_to || vm.original_room_stay_to).format('YYYY-MM-DD'),
				new_adult: vm.data.adult || 2,
				new_child: vm.data.child || 0,
				productIdsInCart: [],
				requestFor: vm.pageType || 'room',
				type: 'new',
				confirmation_number: vm.data.confirmation_number || ''
			};
			if ((vm.holdPromoCode || '').trim()) {
				data.promo = (vm.holdPromoCode || '').trim();
			}
			createResService.getAvailableRooms(data).then(function(response) {
				vm.isloading = false;
				if (response && response.success) {
					vm.available_rooms = response.available_rooms || [];
					vm.subHotel = response.subHotel || [];
					vm.subHotelcount = response.subHotelcount || {};
					vm.selectedSubHotelId = response.roomShow || (vm.subHotel[0] && vm.subHotel[0].hotel_id) || 0;
					preselectCurrentHoldRoom();
					$timeout(function() {
						preselectCurrentHoldRoom();
					});
				} else {
					toastMessage.showSimpleToast((response && response.errorMsg) || 'Unable to load available rooms.', 'error-toast', true);
					vm.showHoldAvailableRooms = false;
					vm.showHoldGuestStep = true;
				}
			}, function() {
				vm.isloading = false;
				vm.showHoldAvailableRooms = false;
				vm.showHoldGuestStep = true;
			});
		}

		function applyHoldAvailableSelection() {
			var pid = Object.keys(vm.holdAvailablePick || {})[0];
			if (!pid) { return false; }
			var policyKey = vm.holdAvailablePick[pid];
			var room = vm.holdAvailableRoomRef;
			if (!room || String(room.product_id) !== String(pid)) {
				angular.forEach(vm.available_rooms, function(r) {
					if (String(r.product_id) === String(pid)) { room = r; }
				});
			}
			if (!room) { return false; }
			vm.data.product_id = room.product_id;
			vm.data.product_name = room.product_name;
			vm.selectedRoom = {};
			vm.selectedRoom[room.product_id] = policyKey;
			vm.showHoldAvailableRooms = false;
			vm.holdPromoLocked = false;
			vm._holdEditDiscountRestore = null;
			vm.holdPromoApplied = false;
			vm.holdPromoCode = '';
			vm.holdPromoDiscount = 0;
			vm.holdPromoPerNightDiscount = 0;
			vm.holdPromoPolicy = '';
			vm.holdPromoMessage = '';
			getPolicies();
			return true;
		}

		vm.locationres = dialogData.locationres;
		if(vm.isSameDaySelection && !vm.isDayReservationHotel){
			closeDialog();
			toastMessage.showSimpleToast('Check-in and check-out date cannot be same.','error-toast');
			return;
		}
		vm.data.type_of_reservation = 'create';
		if(vm.isDayReservationHotel && (dialogData.preselectDayReservation || vm.isSameDaySelection)){
			vm.data.type_of_reservation = 'create_day';
			vm.minDateCheckout = new Date(moment(vm.data.room_stay_from));
		}
		if(vm.locationres=='block' || vm.locationres=='hold'){
			vm.data.type_of_reservation = 'create';
			vm.data.block_conf_no = dialogData.thisnewcreateData.model.confirmation_number;
			vm.data.hold_block_choice = vm.locationres;
		}
		vm.hold_duration_time = new Date(1970, 0, 1, 18, 0, 0);
		vm.myDate = new Date();
		vm.minDate = new Date(
			vm.myDate.getFullYear(),
			vm.myDate.getMonth(),
			vm.myDate.getDate()
		);
		var initialFromMoment = moment(vm.data.room_stay_from);
		if (initialFromMoment.isValid() && initialFromMoment.isBefore(moment(vm.minDate), 'day')) {
			vm.data.hold_duration = angular.copy(vm.minDate);
		} else {
			vm.data.hold_duration = new Date(initialFromMoment.format('YYYY-MM-DD'));
		}
        vm.holdDetailsReady = vm.mode_of_call != 'edit';
        if(vm.mode_of_call == 'edit') {
        	vm.data.type_of_reservation = 'hold';
		    vm.showHoldGuestStep = true;
		    var editModel = dialogData.thisnewcreateData.model || {};
		    if (editModel.confirmation_number) {
		    	vm.data.confirmation_number = editModel.confirmation_number;
		    }
		    vm.holdDetailsReady = false;
		    loadHoldEditDetails();
		}

		function loadHoldEditDetails() {
			var confirmation = vm.data.confirmation_number;
			var model = dialogData.thisnewcreateData.model || {};
			if (!confirmation) {
				applyHoldEditModel(model);
				vm.holdDetailsReady = true;
				return;
			}
			ganttChartServiceNew.getGanttTooltipData({
				confirmation_number: confirmation,
				include_hold_pricing: true
			}).then(function(response) {
				if (!vm.holdEdited && response && response.success && response.tooltip_data) {
					var tip = response.tooltip_data;
					if (tip.first_name) {
						model.first_name = tip.first_name;
					}
					if (tip.last_name) {
						model.last_name = tip.last_name;
					}
					model.holdEmail = tip.holdEmail || tip.customer_email || model.holdEmail || '';
					model.holdPhone = tip.holdPhone || tip.phone_number || model.holdPhone || '';
					model.customer_email = model.holdEmail;
					model.phone_number = model.holdPhone;
					if (tip.room_stay_comment !== undefined && tip.room_stay_comment !== null) {
						model.comments = tip.room_stay_comment;
					} else if (tip.comments !== undefined && tip.comments !== null) {
						model.comments = tip.comments;
					}
					if (tip.hold_duration) {
						model.bexpiry = tip.hold_duration;
					}
					if (tip.room_stay_guest_count) {
						model.room_stay_guest_count = tip.room_stay_guest_count;
						model.adult = tip.room_stay_guest_count;
					}
					if (tip.room_stay_child_count !== undefined && tip.room_stay_child_count !== null) {
						model.room_stay_child_count = tip.room_stay_child_count;
						model.child = tip.room_stay_child_count;
					}
					if (tip.hold_pricing) {
						model.hold_pricing = tip.hold_pricing;
					}
					if (tip.promotion_code) {
						model.hold_promo_code = tip.promotion_code;
					}
					if (tip.promo_discount) {
						model.hold_promo_discount = tip.promo_discount;
					}
					if (tip.manual_discount) {
						model.hold_manual_discount = tip.manual_discount;
					}
					if (tip.nightly_discount) {
						model.hold_nightly_discount = tip.nightly_discount;
					}
					if (tip.nightly_discount_comment) {
						model.hold_nightly_discount_comment = tip.nightly_discount_comment;
					}
					if (tip.discount_percent) {
						model.hold_discount_percent = tip.discount_percent;
					}
					if (tip.discount_comment) {
						model.hold_discount_comment = tip.discount_comment;
					}
					if (tip.discount_type) {
						model.hold_discount_type = tip.discount_type;
					}
					model.confirmation_number = confirmation;
				}
				applyHoldEditModel(model);
				vm.holdDetailsReady = true;
			}, function() {
				applyHoldEditModel(model);
				vm.holdDetailsReady = true;
			});
		}

		function applyHoldSavedPromo(code, discount, policyKey, nightlyRate) {
			var promoCode = (code || '').toString().trim();
			if (!promoCode) { return; }
			vm.holdPromoApplied = true;
			vm.holdPromoCode = promoCode.toUpperCase();
			vm.holdPromoDiscount = discount || 0;
			vm.holdPromoPolicy = policyKey || vm.selectedRoom[vm.data.product_id] || '';
			var promoNights = vm.stayNights || 1;
			var promoTotal = parseFloat(discount) || 0;
			var origNightly = parseFloat(nightlyRate) || 0;
			if (!origNightly && vm.policiesDetail && vm.holdPromoPolicy && vm.policiesDetail[vm.holdPromoPolicy]) {
				origNightly = parseFloat(vm.policiesDetail[vm.holdPromoPolicy].nightlyRate) || 0;
			}
			vm.holdPromoPerNightDiscount = promoNights > 0 ? (promoTotal / promoNights).toFixed(2) : promoTotal.toFixed(2);
			vm.displayNightlyRate = origNightly > 0 ? Math.max(0, origNightly - (promoTotal / promoNights)).toFixed(2) : '';
			vm.holdPromoMessage = vm.holdPromoCode;
		}
		function stashHoldEditDiscountRestore() {
			vm._holdEditDiscountRestore = null;
			if (!vm.holdDiscountApplied || vm.holdPromoApplied) { return; }
			if (vm.holdDiscountType === 'per_night' && vm.holdNightlyDiscounts && vm.holdNightlyDiscounts.length) {
				var nights = [];
				angular.forEach(vm.holdNightlyDiscounts, function(amt, i) {
					nights.push({
						amount: parseFloat(amt) || 0,
						percent: 0,
						comment: (vm.holdNightlyComments && vm.holdNightlyComments[i]) || ''
					});
				});
				vm._holdEditDiscountRestore = {
					mode: 'per_night',
					nights: nights,
					totalDiscount: parseFloat(vm.holdTotalDiscount || vm.holdDiscountAmount) || 0
				};
				return;
			}
			vm._holdEditDiscountRestore = {
				mode: 'uniform',
				amount: parseFloat(vm.holdPerNightDiscount) || 0,
				percent: parseFloat(vm.holdDiscountPercent) || 0,
				comment: vm.holdDiscountComment || ''
			};
		}
		function restoreHoldEditPromoDiscount() {
			if ((vm.holdPromoCode || '').trim()) {
				vm.holdPromoApplied = false;
				vm.applyQuotePromo('applied');
				vm._holdEditDiscountRestore = null;
				return;
			}
			if (vm._holdEditDiscountRestore) {
				vm.applyHoldDiscount(vm._holdEditDiscountRestore);
				vm._holdEditDiscountRestore = null;
			}
		}
		function applyHoldSavedDiscount(hp, editModel, policyKey) {
			hp = hp || {};
			editModel = editModel || {};
			var manual = hp.manual_discount || editModel.hold_manual_discount;
			if (!manual || !(parseFloat(manual) > 0)) { return; }
			vm.holdDiscountApplied = true;
			vm.holdDiscountAmount = parseFloat(manual).toFixed(2);
			vm.holdTotalDiscount = parseFloat(manual).toFixed(2);
			vm.holdDiscountPercent = parseFloat(hp.discount_percent || editModel.hold_discount_percent) || 0;
			vm.holdDiscountComment = hp.discount_comment || editModel.hold_discount_comment || '';
			vm.holdDiscountPolicy = policyKey || vm.selectedRoom[vm.data.product_id] || '';
			vm.holdDiscountType = hp.discount_type || editModel.hold_discount_type || 'uniform';
			var nightlyDisc = hp.nightly_discount || editModel.hold_nightly_discount;
			var nightlyComm = hp.nightly_discount_comment || editModel.hold_nightly_discount_comment || '';
			if (nightlyDisc) {
				vm.holdNightlyDiscounts = String(nightlyDisc).split(',');
				vm.holdNightlyComments = String(nightlyComm).split('|');
				vm.holdPerNightDiscount = vm.holdNightlyDiscounts[0] || (vm.stayNights > 0 ? (parseFloat(manual) / vm.stayNights).toFixed(2) : manual);
			} else {
				vm.holdPerNightDiscount = (vm.stayNights > 0 ? (parseFloat(manual) / vm.stayNights).toFixed(2) : manual);
			}
		}
		function applyHoldEditModel(editModel) {
			vm.applyingHoldEdit = true;
			editModel = editModel || {};
			var holdName = (editModel.holdcustomer || '').trim();
			var holdNameParts = holdName ? holdName.split(/\s+/) : [];
			if ((editModel.first_name || '').trim() || (editModel.last_name || '').trim()) {
				vm.data.first_name = (editModel.first_name || '').trim();
				vm.data.last_name = (editModel.last_name || '').trim();
			} else if (holdName) {
				vm.data.first_name = holdNameParts[0] || '';
				vm.data.last_name = holdNameParts.slice(1).join(' ') || '';
			}
			vm.data.customer_name = (vm.data.first_name + ' ' + vm.data.last_name).trim() || holdName;
			var email = editModel.holdEmail || editModel.customer_email || '';
			var phone = editModel.holdPhone || editModel.phone_number || '';
			if (email) {
				vm.data.customer_email = email;
			}
			if (phone) {
				vm.data.phone_number = phone;
			}
			var hadAdultChild = false;
			if (editModel.adult || editModel.room_stay_guest_count) {
				vm.data.adult = parseInt(editModel.adult || editModel.room_stay_guest_count);
				vm.data.room_stay_guest_count = vm.data.adult;
				hadAdultChild = true;
			}
			if (typeof editModel.child !== 'undefined' || typeof editModel.room_stay_child_count !== 'undefined') {
				var ch = typeof editModel.child !== 'undefined' ? editModel.child : editModel.room_stay_child_count;
				vm.data.child = parseInt(ch || 0);
				vm.data.room_stay_child_count = vm.data.child;
				hadAdultChild = true;
			}
			if (vm.maxOccupancy) {
				vm.adultRange = vm.getRangeArray(1, (vm.maxOccupancy - ((vm.data.child != undefined) ? vm.data.child : 0)));
				vm.childRange = vm.getRangeArray(0, (vm.maxOccupancy - ((vm.data.adult != undefined) ? vm.data.adult : 2)));
			}
			if (editModel.hold_pricing) {
				var hp = editModel.hold_pricing;
				var pk = hp.policy_key || '2';
				vm.selectedRoom[vm.data.product_id] = pk;
				var holdDates = [];
				var holdRates = [];
				var holdPlans = [];
				var nightly = parseFloat(hp.nightly_rate) || 0;
				var nightCount = vm.stayNights || 1;
				if (hp.dates) {
					holdDates = angular.isArray(hp.dates) ? hp.dates : String(hp.dates).split(',');
				}
				if (hp.rates) {
					holdRates = angular.isArray(hp.rates) ? hp.rates : String(hp.rates).split(',');
				}
				if ((!holdDates.length || !holdRates.length) && vm.data.room_stay_from) {
					var holdStart = moment(vm.data.room_stay_from);
					for (var ni = 0; ni < nightCount; ni++) {
						if (!holdDates[ni] && holdStart && holdStart.isValid()) {
							holdDates[ni] = holdStart.clone().add(ni, 'days').format('MM-DD-YYYY');
						}
						if (holdRates[ni] == null || holdRates[ni] === '') {
							holdRates[ni] = nightly;
						}
						holdPlans[ni] = hp.rate_plan_name || '';
					}
				}
				vm.policiesDetail = {};
				vm.policiesDetail[pk] = {
					policy_name: hp.policy_name,
					ratePlanName: hp.rate_plan_name,
					nightlyRate: hp.nightly_rate,
					highestAvgRate: hp.nightly_rate,
					dates: holdDates,
					rates: holdRates,
					rate_plan: holdPlans
				};
				vm.searchSummary = {};
				vm.searchSummary[pk] = {
					grandTotal: hp.grand_total,
					subTotal: hp.sub_total,
					extraPersonAmt: hp.extra_person_amt,
					resortFee: hp.resort_fee,
					taxes: hp.taxes,
					dates: holdDates,
					rates: holdRates
				};
				vm.baseSearchSummary = angular.copy(vm.searchSummary);
				if (parseFloat(hp.resort_fee) > 0) {
					vm.resortFeeApplicable = true;
				}
				if (parseFloat(hp.extra_person_amt) > 0) {
					vm.extraPersonApplicable = true;
				}
				if (hp.image) {
					vm.proImage = hp.image;
				}
				if (hp.max_occupancy) {
					vm.maxOccupancy = hp.max_occupancy;
					vm.adultRange = vm.getRangeArray(1, (vm.maxOccupancy - ((vm.data.child != undefined) ? vm.data.child : 0)));
					vm.childRange = vm.getRangeArray(0, (vm.maxOccupancy - ((vm.data.adult != undefined) ? vm.data.adult : 2)));
				}
				applyHoldSavedPromo(hp.promotion_code || editModel.hold_promo_code, hp.promo_discount || editModel.hold_promo_discount, pk, hp.nightly_rate);
				applyHoldSavedDiscount(hp, editModel, pk);
				vm.show_result = true;
				vm.show_form = true;
			} else {
				if (vm.data.product_id) {
					var fallbackPk = currentHoldPolicyKey() || '2';
					vm.selectedRoom[vm.data.product_id] = fallbackPk;
					if (!vm.policiesDetail[fallbackPk]) {
						vm.policiesDetail[fallbackPk] = {
							policy_name: '',
							ratePlanName: '',
							nightlyRate: ''
						};
					}
					vm.show_result = true;
					vm.show_form = true;
				}
				applyHoldSavedPromo(editModel.hold_promo_code, editModel.hold_promo_discount, vm.selectedRoom[vm.data.product_id], '');
				applyHoldSavedDiscount({}, editModel, vm.selectedRoom[vm.data.product_id]);
			}
			if (editModel.comments !== undefined && editModel.comments !== null) {
				vm.data.room_stay_comment = editModel.comments;
			}
			if (editModel.bexpiry) {
				var expiryMoment = moment(editModel.bexpiry);
				if (expiryMoment.isValid()) {
					vm.data.hold_duration = new Date(expiryMoment.format('YYYY-MM-DD'));
					// Time input compares against 1970-01-01. A full expiry date fails max and keeps Save disabled.
					vm.hold_duration_time = new Date(1970, 0, 1, expiryMoment.hours(), expiryMoment.minutes(), 0, 0);
				}
			}
			if (editModel.confirmation_number) {
				vm.data.confirmation_number = editModel.confirmation_number;
			}
			vm.searchTextFn = vm.data.first_name || '';
			vm.searchTextLn = vm.data.last_name || '';
			vm.searchTextEm = vm.data.customer_email || '';
			if (vm.data.room_stay_from && vm.data.room_stay_to) {
				var stayDiff = Math.round(Math.abs(moment(vm.data.room_stay_to).diff(moment(vm.data.room_stay_from), 'days')));
				if (stayDiff > 0) { vm.stayNights = stayDiff; }
			}
			if ((vm.holdDiscountApplied || vm.holdPromoApplied) && !vm.displayNightlyRate) {
				var discPk = vm.selectedRoom[vm.data.product_id];
				var discPol = (vm.policiesDetail && discPk && vm.policiesDetail[discPk]) || {};
				var origNight = parseFloat(discPol.nightlyRate) || 0;
				var discAmt = parseFloat(vm.holdTotalDiscount || vm.holdDiscountAmount || vm.holdPromoDiscount) || 0;
				var discNights = vm.stayNights || 1;
				if (origNight > 0 && discAmt > 0) {
					vm.displayNightlyRate = Math.max(0, origNight - (discAmt / discNights)).toFixed(2);
				}
			}
			vm.holdEditSnapshot = holdEditValueKey();
			buildHoldNightlyRows();
			vm.showHoldDiscountPanel = true;
			stashHoldEditDiscountRestore();
			getPolicies();
			var holdSnapshotAtLoad = vm.holdEditSnapshot;
			$timeout(function() {
				vm.applyingHoldEdit = false;
				if (vm.holdEditSnapshot === holdSnapshotAtLoad) {
					vm.holdEditSnapshot = holdEditValueKey();
				}
			}, 700);
		}

		function holdEditValueKey() {
			var guest = vm.data || {};
			var phone = (guest.phone_number || '').replace(/\D/g, '');
			var adult = (guest.adult !== undefined && guest.adult !== null) ? guest.adult : (guest.room_stay_guest_count || 2);
			var child = (guest.child !== undefined && guest.child !== null) ? guest.child : (guest.room_stay_child_count || 0);
			return [
				(guest.first_name || '').trim(),
				(guest.last_name || '').trim(),
				(guest.customer_email || '').trim(),
				phone,
				(guest.room_stay_comment || '').trim(),
				guest.hold_duration ? moment(guest.hold_duration).format('YYYY-MM-DD') : '',
				vm.hold_duration_time ? moment(vm.hold_duration_time).format('HH:mm') : '',
				vm.original_room_stay_from ? moment(vm.original_room_stay_from).format('YYYY-MM-DD') : '',
				vm.original_room_stay_to ? moment(vm.original_room_stay_to).format('YYYY-MM-DD') : '',
				String(vm.data.product_id || ''),
				adult,
				child,
				(vm.holdPromoCode || '').trim(),
				vm.holdPromoDiscount || 0,
				vm.holdDiscountAmount || 0,
				vm.holdDiscountPercent || 0,
				(vm.holdDiscountComment || '').trim()
			].join('|');
		}
		
		if (vm.mode_of_call != 'edit') {
			vm.selectedRoom[vm.data.product_id] = '';
		}
		vm.show_result = true;
		vm.show_form = true;
		//Methods
		vm.closeDialog = closeDialog;
		vm.checkinSlected = checkinSlected;
		vm.checkAvailability = checkAvailability;
		vm.getPolicies = getPolicies;
		vm.type_changed = type_changed;
		vm.saveTypeofRes = saveTypeofRes;
		vm.readDescription = readDescription;
		vm.isCommentEmpty = false;
		vm.holdPhoneInvalid = false;
		vm.holdCustomerNoCache = true;
		vm.selectedHoldCustomer = { first_name: null, last_name: null, customer_email: null };
		vm.searchTextFn = '';
		vm.searchTextLn = '';
		vm.searchTextEm = '';
		vm.holdCustomerSearching = false;
		var holdCustomerSelecting = false;
		vm.queryHoldCustomer = function(query, field) {
			if (!query || vm.applyingHoldEdit || holdCustomerSelecting) {
				vm.holdCustomerSearching = false;
				return [];
			}
			var deferred = $q.defer();
			vm.holdCustomerSearching = true;
			createResService.getCustomers({
				search: query,
				field: field,
				pageFrom: 'reservation',
				selectedHotel: $localStorage.hotels[$localStorage.selectedHotel].hotel_id
			}).then(function(response) {
				vm.holdCustomerSearching = false;
				deferred.resolve((response && response[0] && response[0].customerList) ? response[0].customerList : []);
			}, function() {
				vm.holdCustomerSearching = false;
				deferred.resolve([]);
			});
			return deferred.promise;
		};
		vm.onHoldCustomerSearchChange = function(field) {
			if (holdCustomerSelecting) { return; }
			if (field === 'first_name') { vm.data.first_name = vm.searchTextFn; }
			if (field === 'last_name') { vm.data.last_name = vm.searchTextLn; }
			if (field === 'customer_email') { vm.data.customer_email = vm.searchTextEm; }
			markHoldEdited();
		};
		vm.selectHoldCustomer = function(item) {
			if (!item) { return; }
			holdCustomerSelecting = true;
			vm.data.first_name = item.first_name || '';
			vm.data.last_name = item.last_name || '';
			vm.data.customer_email = item.customer_email || '';
			if (item.phone_number) {
				vm.data.phone_number = item.phone_number;
				$timeout(function() { updateHoldPhone(); }, 300);
			}
			vm.searchTextFn = vm.data.first_name;
			vm.searchTextLn = vm.data.last_name;
			vm.searchTextEm = vm.data.customer_email;
			vm.selectedHoldCustomer.first_name = item;
			vm.selectedHoldCustomer.last_name = item;
			vm.selectedHoldCustomer.customer_email = item;
			markHoldEdited();
			$timeout(function() { holdCustomerSelecting = false; }, 300);
		};
		vm.holdEdited = false;
		vm.holdEditReady = false;
		vm.updateHoldPhone = updateHoldPhone;
		vm.markHoldEdited = markHoldEdited;
		vm.isHoldEdit = isHoldEdit;
		vm.isHoldEditLoading = isHoldEditLoading;
		vm.holdEditSaveDisabled = holdEditSaveDisabled;
		vm.holdSending = false;
		vm.isHoldCreateDisabled = isHoldCreateDisabled;
		if (vm.mode_of_call == 'edit') {
			$timeout(function() {
				vm.holdEditReady = true;
			}, 1000);
		}

		function isHoldCreateDisabled() {
			if (vm.holdSending) return true;
			if (!vm.showSaveBtn) return true;
			if (vm.holdPhoneInvalid) return true;
			var guest = vm.data || {};
			if (!guest.first_name || !String(guest.first_name).trim()) return true;
			if (!guest.last_name || !String(guest.last_name).trim()) return true;
			if (!guest.customer_email || !String(guest.customer_email).trim()) return true;
			if (!guest.phone_number || !String(guest.phone_number).trim()) return true;
			if (!guest.hold_duration) return true;
			return false;
		}

		function isHoldEdit() {
			return vm.mode_of_call == 'edit' && vm.data.type_of_reservation == 'hold';
		}

		function isHoldEditLoading() {
			return isHoldEdit() && (!vm.holdDetailsReady || vm.isloading);
		}

		function markHoldEdited() {
			if (vm.applyingHoldEdit || !isHoldEdit() || !vm.holdEditReady) {
				return;
			}
			vm.holdEdited = true;
			vm.showSaveBtn = true;
		}

		function holdEditSaveDisabled() {
			if (!vm.showSaveBtn || !vm.holdEditSnapshot) {
				return true;
			}
			if (vm.holdEditSnapshot === holdEditValueKey()) {
				return true;
			}
			var guest = vm.data || {};
			var email = (guest.customer_email || '').trim();
			if (!(guest.first_name || '').trim() || !(guest.last_name || '').trim()) {
				return true;
			}
			if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
				return true;
			}
			if (!(guest.phone_number || '').trim() || vm.holdPhoneInvalid) {
				return true;
			}
			return false;
		}

		function updateHoldPhone() {
			markHoldEdited();
			var phoneInput = document.querySelector('.openPlaceGantt .hold-quote-phone, .hold-quote-phone');
			if (!phoneInput) {
				vm.holdPhoneInvalid = false;
				return;
			}
			var iti = angular.element(phoneInput).data('iti');
			var inputValue = (phoneInput.value || '').trim();
			if (!inputValue) {
				vm.holdPhoneInvalid = false;
				angular.element(phoneInput).removeClass('ng-invalid').addClass('ng-valid');
				return;
			}
			if (!iti) {
				vm.holdPhoneInvalid = false;
				return;
			}
			var isValid = !!iti.isValidNumberPrecise();
			vm.holdPhoneInvalid = !isValid;
			angular.element(phoneInput).toggleClass('ng-invalid', !isValid);
			angular.element(phoneInput).toggleClass('ng-valid', isValid);
		}

		if(vm.isSameDaySelection && !vm.isDayReservationHotel){
			vm.closeDialog();
			return;
		}
		function checkinSlected(){
			if(vm.isDayCreateMode()){
				// Day reservation: check-out always matches check-in (same calendar day)
				vm.minDateCheckout = new Date(moment(vm.original_room_stay_from));
				vm.original_room_stay_to = angular.copy(vm.original_room_stay_from);
				vm.data.room_stay_from = angular.copy(vm.original_room_stay_from);
				vm.data.room_stay_to = angular.copy(vm.original_room_stay_from);
				if(vm.isCreateMode() || vm.data.type_of_reservation === 'hold'){
					if (vm.showHoldAvailableRooms) {
						loadHoldAvailableRooms();
					} else {
						vm.getPolicies();
					}
				}
				return;
			}
			// Create reservation: both dates editable; keep check-out after check-in
			vm.minDateCheckout = new Date(moment(vm.original_room_stay_from).add(1, 'days'));
			var endDate = moment(vm.original_room_stay_to);
			var startDate = moment(vm.original_room_stay_from);
			if(endDate.isBefore(startDate) || endDate.isSame(startDate)){
				vm.original_room_stay_to = new Date(moment(vm.original_room_stay_from).add(1, 'days'));
			}
			vm.data.room_stay_from = angular.copy(vm.original_room_stay_from);
			vm.data.room_stay_to = angular.copy(vm.original_room_stay_to);
			if(vm.isCreateMode() || vm.data.type_of_reservation === 'hold'){
				if (vm.showHoldAvailableRooms) {
					loadHoldAvailableRooms();
				} else {
					vm.getPolicies();
				}
			}
			markHoldEdited();
		}
		vm.checkoutSelected = checkoutSelected;
		function checkoutSelected(){
			if(vm.isDayCreateMode()){
				vm.original_room_stay_to = angular.copy(vm.original_room_stay_from);
				vm.data.room_stay_to = angular.copy(vm.original_room_stay_from);
				return;
			}
			vm.data.room_stay_from = angular.copy(vm.original_room_stay_from);
			vm.data.room_stay_to = angular.copy(vm.original_room_stay_to);
			if(vm.isCreateMode() || vm.data.type_of_reservation === 'hold'){
				if (vm.showHoldAvailableRooms) {
					loadHoldAvailableRooms();
				} else {
					vm.getPolicies();
				}
			}
			markHoldEdited();
		}
		vm.manageAdultChild = manageAdultChild;
		function manageAdultChild(calledFrom){
			markHoldEdited();
			var sum = parseInt(vm.data.child || 0) + parseInt(vm.data.adult || 1);
			if (vm.maxOccupancy) {
				if(calledFrom == 'adult'){
					if(sum > vm.maxOccupancy){
						vm.data.child = Math.max(0, vm.maxOccupancy - parseInt(vm.data.adult));
					}
					vm.childRange = getRangeArray(0, Math.max(0, vm.maxOccupancy - parseInt(vm.data.adult)));
				} else {
					if(sum > vm.maxOccupancy){
						vm.data.adult = Math.max(1, vm.maxOccupancy - parseInt(vm.data.child));
					}
					vm.adultRange = getRangeArray(1, Math.max(1, vm.maxOccupancy - parseInt(vm.data.child)));
				}
			}
			$timeout(function() {
				vm.getPolicies();
			}, 250);
		}

		vm.getRangeArray = getRangeArray;
		function getRangeArray(start, end){
			var tempArray = [];
			for(var i=start ; i <= end;i++){
				tempArray.push(i);
			}
			return tempArray;

		}
		function autoSelectHoldPolicy() {
			if (!vm.data || !vm.data.product_id || !vm.policiesDetail) {
				return;
			}
			var productId = vm.data.product_id;
			var current = vm.selectedRoom[productId];
			if (current && vm.policiesDetail[current]) {
				return;
			}
			var keys = Object.keys(vm.policiesDetail);
			if (keys.length) {
				vm.selectedRoom[productId] = keys[0];
			}
		}
		function getPolicies(){
			vm.isloading = true;
			vm.showSearch = false;
			// Send calendar dates as Y-m-d strings. new Date('YYYY-MM-DD') is UTC midnight
			// and JSON serializes to ...T00:00:00.000Z, which shifts a day on EST servers.
			var conf_no = '';
			if(vm.locationres=='block' || vm.locationres=='hold')
				conf_no = vm.data.block_conf_no;
			else if(vm.mode_of_call == 'edit' && vm.data.confirmation_number)
				conf_no = vm.data.confirmation_number;
			var priceRequest = {
				'product_id':vm.data.product_id,
				'room_stay_from':moment(vm.data.room_stay_from).format('YYYY-MM-DD'),
				'room_stay_to':moment(vm.data.room_stay_to).format('YYYY-MM-DD'),
				'adult':vm.data.adult,
				'child':vm.data.child,
				'confirmation_number':conf_no,
				'called_from':'BACK_END',
				'requestFor':vm.pageType
			};
			if(vm.isDayCreateMode()){
				priceRequest.cart_type = 'day_reservation';
				priceRequest.type_of_reservation = 'day_reservation';
			}
			if(dialogData.ignoreEarlyLate){
				priceRequest.ignore_early_late = true;
			}
			ganttChartServiceNew.getProductPriceData(priceRequest).then(function(response){
				vm.isloading = false;
				if(response && response.success) {
					vm.showSearch = true;
					if(response.occupancy_error){
						if (!(vm.mode_of_call == 'edit' && vm.data.type_of_reservation === 'hold' && vm.hasHoldRoomLoaded())) {
							vm.show_result = false;
						}
						vm.occupancy_error = response.errorMsg;
						toastMessage.showSimpleToast(response.errorMsg, 'error-toast', true);
					} else if(response.availability_error){
						if (!(vm.mode_of_call == 'edit' && vm.data.type_of_reservation === 'hold' && vm.hasHoldRoomLoaded())) {
							vm.show_result = false;
						}
						vm.occupancy_error = response.errorMsg;
						toastMessage.showSimpleToast(response.errorMsg, 'error-toast', true);
					} else {
						//~ vm.original_room_stay_from = angular.copy(vm.data.room_stay_from);
						//~ vm.original_room_stay_to = angular.copy(vm.data.room_stay_to);
						//~ vm.original_adult = angular.copy(vm.data.adult);
						//~ vm.original_child = angular.copy(vm.data.child);
						vm.show_result = true;
						vm.proImage = response.data.image;
						vm.policiesDetail = (response.data.prices != undefined)?response.data.prices:{};
						vm.maxOccupancy = (response['data']['max_occupancy'] != undefined)?response['data']['max_occupancy']:2;
						vm.boat_length = (response['data']['boat_length'] != undefined)?response['data']['boat_length']:5;
						vm.boat_width = (response['data']['boat_width'] != undefined)?response['data']['boat_width'] : 10;
						vm.searchSummary = response.data.searchSummary !== undefined ? response.data.searchSummary : {};
						vm.rememberQuotePrices(response);
						vm.resortFeeApplicable = response.resortFeeApplicable !== undefined ? response.resortFeeApplicable : false;
			    		vm.extraPersonApplicable = response.extraPersonApplicable !== undefined ? response.extraPersonApplicable : false;
						vm.adultRange = [];
						vm.adultRange = vm.getRangeArray(1,(response['data']['max_occupancy'] - ((vm.data.child != undefined)?vm.data.child:0)));

						vm.childRange = [];
						vm.childRange = vm.getRangeArray(0,(response['data']['max_occupancy'] - ((vm.data.adult != undefined)?vm.data.adult:2)));

						vm.PolicyLength = Object.keys(vm.policiesDetail).length;
						vm.additionalAmt = (response.data.additional_guest_amounts != undefined)?response.data.additional_guest_amounts:0;
						autoSelectHoldPolicy();
						vm.room_type_description = (response.data.room_type_description != undefined) ?response.data.room_type_description : response.data.room_type_description;
						vm.onlyAllowHoldBlock = response.onlyAllowHoldBlock != undefined ? response.onlyAllowHoldBlock : false;
						vm.noRateAssociatedMsg = response.noRateAssociatedMsg != undefined ? response.noRateAssociatedMsg : '';
						vm.show_form = true;
						if(vm.data.type_of_reservation === 'hold' && vm.onlyAllowHoldBlock){
							vm.selectedRoom[vm.data.product_id] = '2';
						}
						buildHoldNightlyRows();
						if (vm.mode_of_call == 'edit' && vm.data.type_of_reservation === 'hold') {
							vm.showHoldDiscountPanel = true;
							restoreHoldEditPromoDiscount();
						} else if ((vm.holdPromoCode || '').trim() && !vm.holdPromoApplied) {
							vm.applyQuotePromo('applied');
						}
					}
				}else if(response && response.errorMsg!='undefined' && response.errorMsg!=''){
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					if (!(vm.mode_of_call == 'edit' && vm.data.type_of_reservation === 'hold' && vm.hasHoldRoomLoaded())) {
						vm.closeDialog();
					}
				}else{
					toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
					if (!(vm.mode_of_call == 'edit' && vm.data.type_of_reservation === 'hold' && vm.hasHoldRoomLoaded())) {
						vm.closeDialog();
					}
				}
			}, function(err){
				vm.isloading = false;
			});
		}
		if (vm.mode_of_call != 'edit') {
			if (vm.locationres == 'hold' && vm.data.block_conf_no) {
				loadHoldConvertGuestThenPolicies();
			} else {
				getPolicies();
			}
		}

		function loadHoldConvertGuestThenPolicies() {
			ganttChartServiceNew.getGanttTooltipData({
				confirmation_number: vm.data.block_conf_no,
				include_hold_pricing: true
			}).then(function(response) {
				if (response && response.success && response.tooltip_data) {
					var tip = response.tooltip_data;
					if (tip.room_stay_guest_count) {
						vm.data.adult = parseInt(tip.room_stay_guest_count, 10);
					}
					if (tip.room_stay_child_count !== undefined && tip.room_stay_child_count !== null) {
						vm.data.child = parseInt(tip.room_stay_child_count, 10) || 0;
					}
					vm.holdConvertGuest = {
						first_name: tip.first_name || '',
						last_name: tip.last_name || '',
						customer_email: tip.holdEmail || tip.customer_email || '',
						phone_number: tip.holdPhone || tip.phone_number || ''
					};
				}
				getPolicies();
			}, function() {
				getPolicies();
			});
		}
		function checkAvailability(){
			vm.isloading = true;
			ganttChartServiceNew.checkAvailabilityForDates({'product_id':vm.data.product_id,'room_stay_from':moment(vm.data.room_stay_from).format('YYYY-MM-DD'),'room_stay_to':moment(vm.data.room_stay_to).format('YYYY-MM-DD')}).then(function(response){
				vm.isloading = false;
				if(response.success){
					//~ vm.original_room_stay_from = angular.copy(vm.data.room_stay_from);
					//~ vm.original_room_stay_to = angular.copy(vm.data.room_stay_to);
					//~ vm.original_adult = angular.copy(vm.data.adult);
					//~ vm.original_child = angular.copy(vm.data.child);
					vm.show_form = true;
					console.log(response);
					vm.proImage = response.data.image;
					vm.policiesDetail = response.data.prices;
					vm.additionalAmt = response.data.additional_guest_amounts;
					vm.room_type_description = response.data.room_type_description;
					autoSelectHoldPolicy();
				}else if(response.errorMsg!='undefined' && response.errorMsg!=''){
					vm.show_form = false;
					vm.availability_error = response.errorMsg;
				}else{
					vm.show_form = false;
					toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
					vm.closeDialog();
				}
			});
		}

		function type_changed(){
			vm.isCommentEmpty = false;
			vm.data.room_stay_from = angular.copy(vm.original_room_stay_from);
			vm.data.room_stay_to = angular.copy(vm.original_room_stay_to);
			if(vm.isDayCreateMode()){
				// Same-day stay: clear overnight min-date so checkout (= checkin) is not marked invalid
				vm.minDateCheckout = null;
				vm.data.room_stay_to = angular.copy(vm.data.room_stay_from);
				vm.original_room_stay_to = angular.copy(vm.original_room_stay_from);
				$timeout(function() {
					vm.original_room_stay_to = angular.copy(vm.original_room_stay_from);
					vm.data.room_stay_to = angular.copy(vm.original_room_stay_from);
				});
			} else if(vm.data.type_of_reservation === 'create' && vm.isSameDaySelection){
				vm.data.room_stay_to = new Date(moment(vm.data.room_stay_from).add(1, 'days'));
				vm.original_room_stay_to = angular.copy(vm.data.room_stay_to);
				vm.minDateCheckout = new Date(moment(vm.data.room_stay_from).add(1, 'days'));
			} else {
				vm.minDateCheckout = new Date(moment(vm.data.room_stay_from).add(1, 'days'));
				var endDate = moment(vm.original_room_stay_to);
				var startDate = moment(vm.original_room_stay_from);
				if(endDate.isBefore(startDate) || endDate.isSame(startDate, 'day')){
					vm.original_room_stay_to = new Date(moment(vm.original_room_stay_from).add(1, 'days'));
					vm.data.room_stay_to = angular.copy(vm.original_room_stay_to);
				}
			}
			vm.showHoldGuestStep = false;
			vm.selectedRoom[vm.data.product_id] = '';
			if(vm.isCreateMode() || vm.data.type_of_reservation === 'hold'){
				vm.getPolicies();
			} else {
				vm.checkAvailability();
			}
		}
        
        /**
	    * Close dialog
	    */
	    function closeDialog() {
           $mdDialog.hide();
        }

        function prepareHoldCustomerData() {
        	var first = (vm.data.first_name || '').trim();
        	var last = (vm.data.last_name || '').trim();
        	vm.data.first_name = first;
        	vm.data.last_name = last;
        	vm.data.customer_name = (first + ' ' + last).trim();
        	updateHoldPhone();
        	var phoneInput = document.querySelector('.hold-quote-phone');
        	if (phoneInput) {
        		var iti = angular.element(phoneInput).data('iti');
        		var val = phoneInput.value.trim();
        		if (val && iti && iti.isValidNumberPrecise()) {
        			var dialCode = '+' + iti.getSelectedCountryData().dialCode;
        			var localNumber = val.indexOf(dialCode) === 0 ? val.substring(dialCode.length).trim() : val;
        			vm.data.phone_number = dialCode + ' ' + localNumber;
        		} else {
        			vm.data.phone_number = val;
        		}
        	}
        }

		vm.rememberQuotePrices = function(response) {
			var keepPromo = (vm.data.type_of_reservation === 'hold' && vm.holdPromoApplied) ? (vm.holdPromoCode || '').trim() : '';
			vm.baseSearchSummary = angular.copy(vm.searchSummary || {});
			vm.roomTypeId = (response && response.data && (response.data.room_type_id || response.data.type_id)) || '';
			vm.stayNights = (response && response.data && response.data.nights) || 1;
			vm.holdPromoApplied = false;
			vm.holdPromoCode = keepPromo;
			vm.holdPromoDiscount = 0;
			vm.holdPromoPerNightDiscount = 0;
			vm.holdPromoPolicy = '';
			vm.holdPromoMessage = '';
			vm.holdDiscountApplied = false;
			vm.holdDiscountAmount = 0;
			vm.holdDiscountPercent = 0;
			vm.holdDiscountComment = '';
			vm.holdDiscountPolicy = '';
			vm.displayNightlyRate = '';
			vm.holdNightlyDiscounts = [];
			vm.holdNightlyComments = [];
			vm.showHoldPromoRemoveConfirm = false;
			buildHoldNightlyRows();
		};
		function quotePromoRates(summary, policy) {
			var rates = (summary && summary.rates) || (policy && policy.rates) || [];
			if (!angular.isArray(rates)) {
				rates = Object.keys(rates).map(function(key) { return rates[key]; });
			}
			return rates;
		}
		function quoteRoomTax(amount, taxRates) {
			var tax = 0;
			angular.forEach(taxRates || [], function(item) {
				tax += (parseFloat(amount) * parseFloat(item.tax_value || 0)) / 100;
			});
			return tax;
		}
		vm.clearQuotePromo = function() {
			vm.searchSummary = angular.copy(vm.baseSearchSummary || vm.searchSummary);
			vm.holdPromoApplied = false;
			vm.holdPromoDiscount = 0;
			vm.holdPromoCode = '';
			vm.holdPromoPolicy = '';
			vm.holdPromoMessage = '';
			vm.displayNightlyRate = '';
			vm.showHoldPromoRemoveConfirm = false;
			markHoldEdited();
			buildHoldNightlyRows();
		};
		vm.applyQuotePromo = function(type) {
			if (vm.onlyAllowHoldBlock || vm.data.type_of_reservation !== 'hold') { return; }
			if (type !== 'remove' && vm.holdDiscountApplied) {
				toastMessage.showSimpleToast('Cannot apply promo code while manual discount is active. Remove discount first.', 'warning-toast', true);
				return;
			}
			var policyKey = vm.selectedRoom[vm.data.product_id];
			var policy = (vm.policiesDetail && vm.policiesDetail[policyKey]) || {};
			var summary = (vm.baseSearchSummary && vm.baseSearchSummary[policyKey]) || {};
			if (type !== 'remove' && !(vm.holdPromoCode || '').trim()) { return; }
			if (type !== 'remove' && !quotePromoRates(summary, policy).length) {
				toastMessage.showSimpleToast('Promo code could not be priced for this room. Search the room again and retry.', 'warning-toast', true);
				return;
			}
			var run = function() {
				if (type === 'remove') {
					vm.clearQuotePromo();
					return;
				}
				var subTotal = parseFloat(summary.subTotal) || 0;
				vm.promoRequestGoing = true;
				eCommerceService.validatePromoCode({
					promoCode: (vm.holdPromoCode || '').trim(),
					promo: 'applied',
					resvProcess: 'create',
					cartDetail: {
						from: moment(vm.data.room_stay_from).format('MM/DD/YYYY'),
						to: moment(vm.isDayCreateMode() ? vm.data.room_stay_from : vm.data.room_stay_to).format('MM/DD/YYYY'),
						cart_type: vm.isDayCreateMode() ? 'day_reservation' : 'room',
						product_id: vm.data.product_id,
						product_name: vm.data.product_name,
						room_type_id: vm.roomTypeId,
						prices: { rates: quotePromoRates(summary, policy) },
						taxes: summary.taxRates || [],
						original_deposit_amt: 0,
						nightlySum: subTotal,
						product_discount: 0,
						overalltotals: { deposit_amount: 0, subtotal: subTotal, tax: 0, grand_total: 0, remaining_amount: 0, product_discount: 0 }
					}
				}).then(function(response) {
					vm.promoRequestGoing = false;
					if (response && !response.status && (response.errorMsg || response.warningMsg)) {
						toastMessage.showSimpleToast(response.errorMsg || response.warningMsg, response.errorMsg ? 'error-toast' : 'warning-toast', true);
						return;
					}
					if (response && response.warningMsg) {
						toastMessage.showSimpleToast(response.warningMsg, 'warning-toast', true);
					}
					if (!(response && response.order && response.order.anyPromoApplied)) { return; }
					var order = response.order;
					var totalDiscount = parseFloat(order.promoCodeDiscount) || 0;
					var nights = parseFloat(vm.stayNights) || quotePromoRates(summary, policy).length || 1;
					var perNightPromoDiscount = totalDiscount / nights;
					var nightlyRate = parseFloat(policy.nightlyRate) || (subTotal / nights);
					var promoPercent = (nightlyRate > 0) ? ((perNightPromoDiscount / nightlyRate) * 100) : 0;
					promoPercent = commonService ? commonService.roundnum(promoPercent, 2) : parseFloat(promoPercent.toFixed(2));

					var oldRoomTax = quoteRoomTax(summary.subTotal, summary.taxRates);
					var newRoomTax = 0;
					angular.forEach(order.taxes || [], function(tax) { newRoomTax += parseFloat(tax.tax_amt) || 0; });
					var taxDelta = oldRoomTax - newRoomTax;
					vm.searchSummary = angular.copy(vm.baseSearchSummary);
					vm.searchSummary[policyKey].taxes = (parseFloat(summary.taxes || 0) - taxDelta).toFixed(2);
					vm.searchSummary[policyKey].grandTotal = (parseFloat(summary.grandTotal || 0) - totalDiscount - taxDelta).toFixed(2);
					vm.holdPromoDiscount = totalDiscount.toFixed(2);
					vm.holdPromoPerNightDiscount = perNightPromoDiscount.toFixed(2);
					vm.holdPromoPercent = promoPercent;
					vm.holdPromoCode = order.promoCodeName || vm.holdPromoCode;
					vm.holdPromoMessage = vm.holdPromoCode || '';
					vm.holdPromoPolicy = policyKey;
					vm.holdPromoApplied = true;
					vm.displayNightlyRate = (nightlyRate - perNightPromoDiscount).toFixed(2);
					markHoldEdited();
					buildHoldNightlyRows();
				}, function() {
					vm.promoRequestGoing = false;
					toastMessage.showSimpleToast('Unable to apply promo code.', 'error-toast', true);
				});
			};
			run();
		};

		vm.askRemoveHoldPromo = function($event) {
			if ($event) {
				$event.preventDefault();
				$event.stopPropagation();
			}
			$mdDialog.show({
				controller: 'confirmController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
				parent: angular.element(document.body),
				targetEvent: $event,
				clickOutsideToClose: true,
				skipHide: true,
				multiple: true,
				locals: {
					title: 'Promo Code',
					htmlContent: 'Are you sure you want to remove the promo code?',
					cancelBtn: 'No',
					OkBtn: 'Yes'
				}
			}).then(function(answer) {
				if (typeof answer != 'undefined' && answer == 'update') {
					vm.applyQuotePromo('remove');
				}
			}, function() {});
		};

		function holdToList(val) {
			if (val == null || val === '') { return []; }
			if (angular.isArray(val)) { return val; }
			if (typeof val === 'object') {
				return Object.keys(val).map(function(k) { return val[k]; });
			}
			return [val];
		}

		function holdPercentLabel(discount, rate) {
			var discountAmount = parseFloat(discount) || 0;
			var nightRate = parseFloat(rate) || 0;
			if (discountAmount <= 0 || nightRate <= 0) { return ''; }
			var percent = parseFloat(commonService ? commonService.roundnum((discountAmount / nightRate) * 100, 2) : ((discountAmount / nightRate) * 100).toFixed(2));
			return percent % 1 === 0 ? percent.toFixed(0) : percent.toFixed(2);
		}
		vm.holdPercentLabel = holdPercentLabel;

		function buildHoldNightlyRows() {
			vm.holdNightlyRows = [];
			if (!vm.data || vm.data.type_of_reservation !== 'hold' || vm.onlyAllowHoldBlock) { return; }
			var policyKey = (vm.selectedRoom && (vm.selectedRoom[vm.data.product_id] || vm.selectedRoom[String(vm.data.product_id)])) || '';
			if (!policyKey && vm.policiesDetail) {
				var pkeys = Object.keys(vm.policiesDetail);
				policyKey = pkeys.length ? pkeys[0] : '';
			}
			if (!policyKey) { return; }
			var policy = (vm.policiesDetail && vm.policiesDetail[policyKey]) || {};
			var summary = (vm.baseSearchSummary && vm.baseSearchSummary[policyKey]) || (vm.searchSummary && vm.searchSummary[policyKey]) || {};
			var dates = holdToList(policy.dates || summary.dates);
			var rates = holdToList(policy.rates || summary.rates);
			var plans = holdToList(policy.rate_plan);
			var defaultRate = parseFloat(policy.nightlyRate) || 0;
			var defaultPlan = policy.ratePlanName || '';
			var nights = dates.length || rates.length || parseFloat(vm.stayNights) || 0;
			if (nights < 1 && vm.data.room_stay_from && vm.data.room_stay_to) {
				nights = Math.max(1, Math.round(Math.abs(moment(vm.data.room_stay_to).diff(moment(vm.data.room_stay_from), 'days'))));
			}
			if (nights < 1) { nights = 1; }
			var start = moment(vm.data.room_stay_from || vm.original_room_stay_from);
			for (var i = 0; i < nights; i++) {
				var rate = (rates[i] != null && rates[i] !== '') ? parseFloat(rates[i]) : defaultRate;
				if (!rate && nights > 0 && summary.subTotal) {
					rate = parseFloat(summary.subTotal) / nights;
				}
				var dateVal = dates[i];
				if (!dateVal && start && start.isValid()) {
					dateVal = start.clone().add(i, 'days').format('MM-DD-YYYY');
				}
				var amt = 0;
				var comm = '';
				if (vm.holdPromoApplied) {
					amt = parseFloat(vm.holdPromoPerNightDiscount) || 0;
					comm = vm.holdPromoCode || '';
				} else if (vm.holdNightlyDiscounts && vm.holdNightlyDiscounts[i] != null) {
					amt = parseFloat(vm.holdNightlyDiscounts[i]) || 0;
					comm = (vm.holdNightlyComments && vm.holdNightlyComments[i]) || '';
				}
				vm.holdNightlyRows.push({
					nightNum: i + 1,
					date: dateVal || ('Night ' + (i + 1)),
					ratePlan: plans[i] || defaultPlan,
					rate: rate || 0,
					amount: amt,
					percent: (rate > 0 && amt > 0) ? (commonService ? commonService.roundnum((amt / rate) * 100, 2) : parseFloat(((amt / rate) * 100).toFixed(2))) : 0,
					percentLabel: holdPercentLabel(amt, rate),
					comment: comm
				});
			}
		}
		vm.buildHoldNightlyRows = buildHoldNightlyRows;
		vm.showHoldRatePlanCol = function() {
			if (!vm.holdNightlyRows || !vm.holdNightlyRows.length) { return false; }
			for (var i = 0; i < vm.holdNightlyRows.length; i++) {
				if (vm.holdNightlyRows[i] && vm.holdNightlyRows[i].ratePlan) { return true; }
			}
			return false;
		};

		vm.toggleHoldDiscountPanel = function($event) {
			if ($event) {
				$event.preventDefault();
				$event.stopPropagation();
			}
			if (vm.onlyAllowHoldBlock || vm.data.type_of_reservation !== 'hold') { return; }
			buildHoldNightlyRows();
			vm.showHoldDiscountPanel = !vm.showHoldDiscountPanel;
		};

		vm.openHoldNightDiscount = function(index, $event) {
			if ($event) {
				$event.preventDefault();
				$event.stopPropagation();
			}
			if (vm.onlyAllowHoldBlock || vm.data.type_of_reservation !== 'hold') { return; }
			if (vm.holdPromoApplied) { return; }
			var night = vm.holdNightlyRows[index] || {};
			var nightlyRate = parseFloat(night.rate) || 0;
			if (nightlyRate <= 0) {
				toastMessage.showSimpleToast('Room rate not available for discount calculation.', 'warning-toast', true);
				return;
			}
			var existingAmount = parseFloat(night.amount) || 0;
			$mdDialog.show({
				controller: 'discountCommentController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/create-res/dialogs/discount-comment/discount-comment.html',
				parent: angular.element(document.body),
				targetEvent: $event,
				clickOutsideToClose: true,
				skipHide: true,
				multiple: true,
				locals: {
					oldcomment: night.comment || '',
					oldAmount: existingAmount > 0 ? existingAmount : '',
					type: 'nightly_discount',
					price: nightlyRate
				}
			}).then(function(answer) {
				if (answer === undefined || answer === null) { return; }
				var amt = parseFloat(answer.amount) || 0;
				night.amount = amt;
				night.percent = parseFloat(answer.percent) || 0;
				night.percentLabel = holdPercentLabel(amt, night.rate);
				night.comment = (answer.comment || '').trim();
				var nights = vm.holdNightlyRows.map(function(n) {
					return {
						nightNum: n.nightNum,
						date: n.date,
						rate: n.rate,
						amount: parseFloat(n.amount) || 0,
						percent: parseFloat(n.percent) || 0,
						comment: n.comment || ''
					};
				});
				var total = 0;
				nights.forEach(function(n) { total += n.amount; });
				if (total > 0) {
					vm.applyHoldDiscount({
						mode: 'per_night',
						nights: nights,
						totalDiscount: total,
						amount: nights[0] ? nights[0].amount : 0,
						percent: nights[0] ? nights[0].percent : 0,
						comment: nights[0] ? nights[0].comment : ''
					});
					markHoldEdited();
				} else {
					vm.removeHoldDiscount();
				}
			}, function() {});
		};

		vm.applyHoldDiscount = function(answer, policyKey, summary) {
			policyKey = policyKey || vm.selectedRoom[vm.data.product_id];
			summary = summary || (vm.baseSearchSummary && vm.baseSearchSummary[policyKey]) || (vm.searchSummary && vm.searchSummary[policyKey]) || {};
			var policy = (vm.policiesDetail && vm.policiesDetail[policyKey]) || {};
			var subTotal = parseFloat(summary.subTotal) || 0;
			var nights = parseFloat(vm.stayNights) || 1;
			if (nights < 1 && vm.data.room_stay_from && vm.data.room_stay_to) {
				nights = Math.max(1, Math.round(Math.abs(moment(vm.data.room_stay_to).diff(moment(vm.data.room_stay_from), 'days'))));
			}
			var nightlyRate = parseFloat(policy.nightlyRate) || (nights > 0 ? (subTotal / nights) : subTotal);
			var totalDiscount = 0;
			var comment = '';
			var percent = 0;

			if (answer.mode === 'per_night') {
				vm.holdDiscountType = 'per_night';
				vm.holdNightlyDiscounts = [];
				vm.holdNightlyComments = [];
				var commentParts = [];
				(answer.nights || []).forEach(function(n, idx) {
					var a = parseFloat(n.amount) || 0;
					totalDiscount += a;
					vm.holdNightlyDiscounts.push(a.toFixed(2));
					vm.holdNightlyComments.push((n.comment || '').trim());
					if (a > 0) {
						commentParts.push('Night ' + (idx + 1) + ': -$' + a.toFixed(2) + (n.comment ? ' (' + n.comment + ')' : ''));
					}
				});
				if (totalDiscount > subTotal) { totalDiscount = subTotal; }
				comment = commentParts.join(' | ');
				percent = (subTotal > 0) ? (commonService ? commonService.roundnum((totalDiscount / subTotal) * 100, 2) : parseFloat(((totalDiscount / subTotal) * 100).toFixed(2))) : 0;
				vm.holdDiscountAmount = totalDiscount.toFixed(2);
				vm.holdPerNightDiscount = (nights > 0 ? (totalDiscount / nights) : totalDiscount).toFixed(2);
			} else {
				vm.holdDiscountType = 'uniform';
				var perNightDiscount = parseFloat(answer.amount) || 0;
				if (perNightDiscount > nightlyRate) {
					perNightDiscount = nightlyRate;
				}
				totalDiscount = perNightDiscount * nights;
				if (totalDiscount > subTotal) {
					totalDiscount = subTotal;
				}
				percent = parseFloat(answer.percent) || 0;
				if (!percent && nightlyRate > 0) {
					percent = commonService ? commonService.roundnum((perNightDiscount / nightlyRate) * 100, 2) : parseFloat(((perNightDiscount / nightlyRate) * 100).toFixed(2));
				}
				comment = (answer.comment || '').trim();
				vm.holdPerNightDiscount = perNightDiscount.toFixed(2);
				vm.holdDiscountAmount = totalDiscount.toFixed(2);
				vm.holdNightlyDiscounts = [];
				vm.holdNightlyComments = [];
				for (var j = 0; j < nights; j++) {
					vm.holdNightlyDiscounts.push(perNightDiscount.toFixed(2));
					vm.holdNightlyComments.push(comment);
				}
			}

			var oldRoomTax = quoteRoomTax(summary.subTotal, summary.taxRates);
			var newRoomSubtotal = Math.max(0, subTotal - totalDiscount);
			var newRoomTax = quoteRoomTax(newRoomSubtotal, summary.taxRates);
			var taxDelta = Math.max(0, oldRoomTax - newRoomTax);

			if (!vm.baseSearchSummary || !Object.keys(vm.baseSearchSummary).length) {
				vm.baseSearchSummary = angular.copy(vm.searchSummary);
			}
			vm.searchSummary = angular.copy(vm.baseSearchSummary);
			vm.searchSummary[policyKey].taxes = (parseFloat(summary.taxes || 0) - taxDelta).toFixed(2);
			vm.searchSummary[policyKey].grandTotal = (parseFloat(summary.grandTotal || 0) - totalDiscount - taxDelta).toFixed(2);

			vm.holdDiscountApplied = true;
			vm.holdTotalDiscount = totalDiscount.toFixed(2);
			vm.holdDiscountPercent = percent;
			vm.holdDiscountComment = comment;
			vm.holdDiscountPolicy = policyKey;
			vm.displayNightlyRate = Math.max(0, (nightlyRate - (totalDiscount / (nights || 1)))).toFixed(2);
			buildHoldNightlyRows();
		};

		vm.removeHoldDiscount = function() {
			if (vm.baseSearchSummary && Object.keys(vm.baseSearchSummary).length) {
				vm.searchSummary = angular.copy(vm.baseSearchSummary);
			}
			vm.holdDiscountApplied = false;
			vm.holdDiscountType = 'uniform';
			vm.holdDiscountAmount = 0;
			vm.holdPerNightDiscount = 0;
			vm.holdTotalDiscount = 0;
			vm.holdDiscountPercent = 0;
			vm.holdDiscountComment = '';
			vm.holdDiscountPolicy = '';
			vm.holdNightlyDiscounts = [];
			vm.holdNightlyComments = [];
			vm.displayNightlyRate = '';
			markHoldEdited();
			buildHoldNightlyRows();
		};

        function saveTypeofRes(){
			if (vm.holdSending) { return false; }
       		if((vm.data.room_stay_comment == undefined || vm.data.room_stay_comment == '') && !vm.isCreateMode()) {
       			vm.isCommentEmpty = true; return false;
       		} else {
       			vm.isCommentEmpty = false;
       		}
		    vm.data.requestType = vm.pageType;
		   
			if(vm.mode_of_call == 'edit' && vm.data.type_of_reservation == 'hold' ){
				prepareHoldCustomerData();
				if(!(vm.data.phone_number || '').trim()){
					toastMessage.showSimpleToast('Please enter phone number','error-toast', true);
					return false;
				}
				if(vm.holdPhoneInvalid){
					toastMessage.showSimpleToast('Please enter a valid phone number','error-toast', true);
					return false;
				}
				vm.data.room_stay_from = new Date(moment(vm.original_room_stay_from).format('YYYY-MM-DD'));
				vm.data.room_stay_to = new Date(moment(vm.original_room_stay_to).format('YYYY-MM-DD'));
				if(vm.hold_duration_time != '' && typeof  vm.data['hold_duration'] != 'undefined'){
					vm.data.hold_duration = moment(vm.data.hold_duration).format('MM/DD/YYYY') +" "+ moment(vm.hold_duration_time).format('LT');
				}else{
					vm.data.hold_duration = "";
				}
				if (typeof vm.data.adult !== 'undefined') {
					vm.data.room_stay_guest_count = parseInt(vm.data.adult);
				}
				if (typeof vm.data.child !== 'undefined') {
					vm.data.room_stay_child_count = parseInt(vm.data.child);
				}
				if (vm.holdPromoApplied) {
					vm.data.promotion_code = vm.holdPromoCode;
					vm.data.promo_discount = vm.holdPromoDiscount;
				} else {
					delete vm.data.promotion_code;
					delete vm.data.promo_discount;
				}
				if (vm.holdDiscountApplied) {
					vm.data.manual_discount = vm.holdDiscountAmount;
					vm.data.discount_percent = vm.holdDiscountPercent;
					vm.data.discount_comment = vm.holdDiscountComment;
					vm.data.discount_type = vm.holdDiscountType || 'uniform';
					if (vm.holdNightlyDiscounts && vm.holdNightlyDiscounts.length) {
						vm.data.nightly_discount = vm.holdNightlyDiscounts.join(',');
						vm.data.nightly_discount_comment = (vm.holdNightlyComments || []).join('|');
					}
				} else {
					delete vm.data.manual_discount;
					delete vm.data.discount_percent;
					delete vm.data.discount_comment;
					delete vm.data.discount_type;
					delete vm.data.nightly_discount;
					delete vm.data.nightly_discount_comment;
				}
				vm.showSaveBtn = false;
				vm.holdSending = true;
				ganttChartServiceNew.saveHoldBlockDates({data:vm.data}).then(function(response){
					if(response.success ){
						parentScope.success = true;
						closeDialog();
					}else{
						vm.holdSending = false;
						vm.showSaveBtn = true;
						toastMessage.showSimpleToast(response.errorMsg,'error-toast', true);
					}
				}, function() {
					vm.holdSending = false;
					vm.showSaveBtn = true;
				});
			}else{
				vm.data.room_stay_from = new Date(moment(vm.original_room_stay_from).format('YYYY-MM-DD'));
				vm.data.room_stay_to = new Date(moment(vm.original_room_stay_to).format ('YYYY-MM-DD'));
				if(vm.isCreateMode()) {
					parentScope.reloaddashboard = false;
					if (vm.data.hold_block_choice == 'hold' && vm.holdConvertGuest) {
						$sessionStorage['hold_convert_guest_' + $localStorage['preHotelId']] = vm.holdConvertGuest;
					}
					var createParams = {
						prod_id:JSON.stringify(vm.selectedRoom),
						from:vm.data.room_stay_from,
						to:vm.data.room_stay_to,
						adult:vm.data.adult,
						child:vm.data.child,
						from_page:'header',
						block_conf_no:vm.data.block_conf_no,
						hold_block_choice:vm.data.hold_block_choice,
						creationSource:'Tape Chart'
					};
					if(vm.isDayCreateMode()){
						createParams.cart_type = 'day_reservation';
						createParams.to = createParams.from;
					}
					if(dialogData.ignoreEarlyLate){
						createParams.ignore_early_late = true;
					}
					$state.go('app.create-res', createParams);
				} else {
					prepareHoldCustomerData();
					if(vm.data.type_of_reservation == 'hold' && !(vm.data.phone_number || '').trim()){
						toastMessage.showSimpleToast('Please enter phone number','error-toast', true);
						return false;
					}
					if(vm.data.type_of_reservation == 'hold' && vm.holdPhoneInvalid){
						toastMessage.showSimpleToast('Please enter a valid phone number','error-toast', true);
						return false;
					}
					if(vm.hold_duration_time != '' && typeof  vm.data['hold_duration'] != 'undefined'){
						vm.data.hold_duration = moment(vm.data.hold_duration).format('MM/DD/YYYY') +" "+ moment(vm.hold_duration_time).format('LT');
					}else{
						vm.data.hold_duration = "";
					}
					if (typeof vm.data.adult !== 'undefined') {
						vm.data.room_stay_guest_count = parseInt(vm.data.adult);
					}
					if (typeof vm.data.child !== 'undefined') {
						vm.data.room_stay_child_count = parseInt(vm.data.child);
					}
					if (vm.data.type_of_reservation == 'hold' && vm.holdPromoApplied) {
						vm.data.promotion_code = vm.holdPromoCode;
						vm.data.promo_discount = vm.holdPromoDiscount;
					} else {
						delete vm.data.promotion_code;
						delete vm.data.promo_discount;
					}
					if (vm.data.type_of_reservation == 'hold' && vm.holdDiscountApplied) {
						vm.data.manual_discount = vm.holdDiscountAmount;
						vm.data.discount_percent = vm.holdDiscountPercent;
						vm.data.discount_comment = vm.holdDiscountComment;
						vm.data.discount_type = vm.holdDiscountType || 'uniform';
						if (vm.holdNightlyDiscounts && vm.holdNightlyDiscounts.length) {
							vm.data.nightly_discount = vm.holdNightlyDiscounts.join(',');
							vm.data.nightly_discount_comment = (vm.holdNightlyComments || []).join('|');
						}
					} else {
						delete vm.data.manual_discount;
						delete vm.data.discount_percent;
						delete vm.data.discount_comment;
						delete vm.data.discount_type;
						delete vm.data.nightly_discount;
						delete vm.data.nightly_discount_comment;
					}
					vm.showSaveBtn = false;
					vm.holdSending = true;
					ganttChartServiceNew.saveHoldBlockDates({data:vm.data}).then(function(response){
						if(!response.success ){
							vm.holdSending = false;
							vm.showSaveBtn = true;
							toastMessage.showSimpleToast(response.errorMsg,'error-toast', true);
						} else {
							closeDialog();
						}
					}, function() {
						vm.holdSending = false;
						vm.showSaveBtn = true;
					});
				}
			}
	   }
	 function readDescription() {
       		/*var descId = "description_"+id;
       		var buttonId = "readmoreblock_"+id;
       		var displayText = document.getElementById(buttonId).innerHTML;
       		var display = document.getElementById(descId).style.display;
       		if(displayText == 'Show description'){
       			document.getElementById(buttonId).innerHTML = 'Hide description';
       			document.getElementById(descId).style.display = 'block';
       		}
       		else{
       			document.getElementById(buttonId).innerHTML  = 'Show description';
       			document.getElementById(descId).style.display = 'none';	
       		}*/
       		if (vm.readText == 'Show description') {
       			vm.readText = 'Hide description';
       		} else {
       			vm.readText = 'Show description';
       		}
       		vm.showDescription = !vm.showDescription;          
       }   


        //Code 	to conditionaly run click event
       	vm.runClickEvent = false;
       	if($( window ).width() <= 1020){
       		vm.runClickEvent = true;
       	};

       
       	vm.showBlock = [];
       	vm.showRateDesc = [];
	    vm.showOverlay = false;
	    // function to close all details popup
	    vm.closeAllDetails = function(){
			angular.forEach(vm.showBlock,function(pval,pkey){
				vm.showBlock[pkey] = false;
			});
	    }

	    // function to show hide detail popup
		vm.showDetailBlock = function(policyKey){
			angular.forEach(vm.showBlock,function(pval,pkey){
				if(pkey == policyKey){
					vm.showBlock[pkey] = !vm.showBlock[pkey];
				} else {
					vm.showBlock[pkey] = false;
				}
			});
		}
		
		vm.closeAllRateDetails = function(){
			angular.forEach(vm.showRateDesc,function(pval,pkey){
				vm.showRateDesc[pkey] = false;
			});
	    }

	    // function to show hide detail popup
		vm.showDetailRateBlock = function(policyKey){
			angular.forEach(vm.showRateDesc,function(pval,pkey){
				if(pkey == policyKey){
					vm.showRateDesc[pkey] = !vm.showRateDesc[pkey];
				} else {
					vm.showRateDesc[pkey] = false;
				}
			});
		}
    }

})();

(function ()
{
    'use strict';

    angular.module('app.dashboards.gantt-chart')
        .controller('addCommentRes', addCommentRes);

    /** @ngInject */
    function addCommentRes($mdDialog, $document, dialogData, $rootScope, toastMessage, $state, ganttChartService,$scope,parentScope)
    {
		var vm = this;
		// Data
		vm.data = dialogData.thisnewcreateData.model;
		console.log(dialogData);
		vm.product_id = dialogData.thisnewcreateData.row.model.id;
		vm.note_type = "comment";
		vm.label = 'Comment';

		vm.isloading = false;
		if(dialogData.thisnewcreateData.model.room_confirmation_number && dialogData.thisnewcreateData.model.room_confirmation_number!='')
			vm.data.confirmation_number = dialogData.thisnewcreateData.model.room_confirmation_number;
		else
			vm.data.confirmation_number = dialogData.thisnewcreateData.model.confirmation_number;
		vm.comment = vm.data.comments;
		vm.savingcomment = '';
        //Methods
        vm.closeDialog = closeDialog;
        vm.savecommentofRes = savecommentofRes;
        vm.type_changed = type_changed;
       
       /**
	   * Close dialog
	   */
	   function closeDialog()
       {
           $mdDialog.hide();
       }
       
       function type_changed(){
			if(vm.note_type == 'comment'){
				vm.label = 'Comment';
				vm.comment = vm.data.comments;
			}  else{
				vm.label = 'Special Request';
				vm.comment = vm.data.special_req;
			}
	   }
       function savecommentofRes(){
		   vm.isloading = true;
		   vm.savingcomment = true;
			ganttChartService.savecommentofRes({confirmation_number:vm.data.confirmation_number,type_of_reservation:vm.data.type_of_reservation,comm_req_value:vm.comment,comm_req_type:vm.note_type,room_stay_from:vm.data.from,room_stay_to:vm.data.to,product_id:vm.product_id}).then(function(response){
				vm.isloading = false;
				vm.savingcomment = false;
				parentScope.comment_reload = false;
				if(response.success){
					// parentScope.comment_reload = true;
					closeDialog();
				}else if(response.errorMsg){
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				}else{
					toastMessage.showSimpleToast('There was some error in saving comment.','error-toast');
				}
			});
	   }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboards',
            [
                'app.dashboards.gantt-chart',                
                'ngMaterial',
                'ngMaterialDateRangePicker',
                'app.dashboards.modified-gantt-chart'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider){

        $stateProvider.state('app.dashboard', {
            url    : '/dashboard',
            title  : 'Dashboard',
            views  : {
               'content@app': {
                   templateUrl: 'app/main/apps/dashboards/dashboard.html',
                   controller : 'DashboardController as vm'
               }
            },
            params:{
                fromState:'dashboard'
            },
            resolve: {
                dashboardDetails: function (dashboardGraphService){
                    return dashboardGraphService.dashboardDetails('room');
                }
            },
           permission: 'dashboard'
       }).state('app.dashboardRevenue', {
            url    : '/dashboard',
            title  : 'Revenue',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/dashboard.html',
                    controller : 'DashboardController as vm'
                }
            },
            params:{
               fromState:'revenue'
            },
            resolve: {
                dashboardDetails: function (dashboardGraphService){
                    return dashboardGraphService.dashboardDetails('room');
               }
           },
           permission: 'dashboard'
       }).state('app.graphDetail', {
            url: '/graphDetail/?:param',
            title  : 'Dashboard',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/detail/dashGraphDetail.html',
                    controller : 'DashGraphDetailController as vm'
                }
            },
            resolve: {
                dashboardDetails: function (dashboardGraphService, $stateParams){
                    var qstr = "";
                    if ($stateParams.param != undefined) {
                        qstr = "?"+$stateParams.param;
                    }
                    return dashboardGraphService.getGraphDetailListing(qstr);
                }
            },
            permission: 'dashboard'
        }).state('app.housekeeping-dashboard', {
            url     : '/housekeeping-dashboard',
            title   : 'Housekeeping Dashboard',
            views   : {
                'content@app' : {
                    templateUrl : 'app/main/apps/dashboards/housekeeping/housekeeping.html',
                    controller  : 'HousekeepingDashboardController as vm'
                }
            },
            resolve: {
                dashHousekeepingDetails: function (dashboardGraphService){
                    return dashboardGraphService.dashboardDetails('room');
                }
            },
            permission: 'dashboard'
        }).state('app.housekeeping-portlet', {
            url     : '/housekeeping-portlet/:param/:type/:date/:subhotel_id',
            title   : 'Housekeeping portlet',
            views   : {
                'content@app' : {
                    templateUrl : 'app/main/apps/dashboards/housekeeping-portlet/housekeeping-portlet.html',
                    controller  : 'HousekeepingPortletController as vm'
                }
            },
            resolve: {
                reservationDetails: function ($stateParams){
                        var data ={};
                    if ($stateParams.param != undefined && $stateParams.type != undefined && $stateParams.date != undefined &&$stateParams.subhotel_id !=undefined ) {
                        data.param = $stateParams.param;
                        data.type = $stateParams.type;
                        data.subhotel_id = $stateParams.subhotel_id;
                        data.date = $stateParams.date;
                    }
                    
                    return data;
                }
            },
            permission: 'dashboard'
        }).state('app.revenue', {
            url    : '/revenue-management/revenue',
            title  : 'Dashboard',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/dashboard.html',
                    controller : 'DashboardController as vm'
                }
            },
            resolve: {
                dashboardDetails: function (dashboardGraphService){
                    return dashboardGraphService.dashboardRevenueDetails('room','Revenue');
                }
            },
            permission: 'Revenue'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/dashboards');
    }

})();

(function ()
{
    'use strict';

    angular.module('app.dashboards')
        .controller('resSearchController', resSearchController);

    /** @ngInject */
    function resSearchController(
    	EnvironmentConfig,
    	$mdDialog,
    	$document,
    	dialogData,
    	$rootScope,
    	toastMessage,
    	$state,
    	ganttChartService,
    	parentScope,
    	mode_of_call,
    	$timeout,
    	$localStorage,
    	eCommerceService,
    	commonService,
    	createResService,
    	$q)
    {
		var vm = this;
		var dateConv = [];
		vm.mode_of_call = mode_of_call;
		vm.data = {};
		vm.data = dialogData;
		vm.showSaveBtn = true;
		vm.showSearch  = true;
		vm.selectedRoom = {};
		vm.policiesDetail = {};
		vm.searchSummary = {};
		vm.baseUrl = EnvironmentConfig.api;
		vm.room_type_description = '';
		vm.pageType = dialogData.pageType;
		vm.readText = 'Show description';
		vm.showDescription = false;
		vm.promoRequestGoing = false;
		vm.holdPromoApplied = false;
		vm.holdPromoCode = '';
		vm.holdPromoDiscount = 0;
		vm.holdPromoPolicy = '';
		vm.holdPromoMessage = '';
		vm.holdDiscountApplied = false;
		vm.holdDiscountAmount = 0;
		vm.holdDiscountPercent = 0;
		vm.holdDiscountComment = '';
		vm.holdDiscountPolicy = '';
		vm.displayNightlyRate = '';
		vm.showHoldPromoRemoveConfirm = false;
		vm.holdNightlyRows = [];
		vm.showHoldDiscountPanel = false;
		vm.baseSearchSummary = {};
		vm.roomTypeId = '';
		vm.stayNights = 1;
		vm.data.adult = 2;
		vm.data.child = 0;		
		vm.data.type_of_reservation = 'create';

		vm.currentHotelId = $localStorage['preHotelId'];
		vm.isDayReservationHotel = typeof $rootScope.isDailyRentalsAvailable === 'function'
			? $rootScope.isDailyRentalsAvailable()
			: false;
		vm.isCreateMode = function() {
			return vm.data.type_of_reservation === 'create' || vm.data.type_of_reservation === 'create_day';
		};
		vm.isDayCreateMode = function() {
			return vm.data.type_of_reservation === 'create_day';
		};
		vm.showRateUI = function() {
			return vm.isCreateMode() || vm.data.type_of_reservation === 'hold';
		};
		vm.hasHoldRoomLoaded = function() {
			return !!(vm.policiesDetail && Object.keys(vm.policiesDetail).length);
		};
		vm.showHoldGuestStep = false;
		vm.showHoldPolicyRow = function(policykey) {
			if (vm.data.type_of_reservation !== 'hold' || !vm.showHoldGuestStep) {
				return true;
			}
			return String(policykey) === String(vm.selectedRoom[vm.data.product_id]);
		};
		vm.holdPhoneInvalid = false;
		vm.holdCustomerNoCache = true;
		vm.selectedHoldCustomer = { first_name: null, last_name: null, customer_email: null };
		vm.searchTextFn = '';
		vm.searchTextLn = '';
		vm.searchTextEm = '';
		vm.holdCustomerSearching = false;
		var holdCustomerSelecting = false;
		vm.queryHoldCustomer = function(query, field) {
			if (!query) {
				vm.holdCustomerSearching = false;
				return [];
			}
			var deferred = $q.defer();
			vm.holdCustomerSearching = true;
			createResService.getCustomers({
				search: query,
				field: field,
				pageFrom: 'reservation',
				selectedHotel: $localStorage.hotels[$localStorage.selectedHotel].hotel_id
			}).then(function(response) {
				vm.holdCustomerSearching = false;
				deferred.resolve((response && response[0] && response[0].customerList) ? response[0].customerList : []);
			}, function() {
				vm.holdCustomerSearching = false;
				deferred.resolve([]);
			});
			return deferred.promise;
		};
		vm.onHoldCustomerSearchChange = function(field) {
			if (holdCustomerSelecting) { return; }
			if (field === 'first_name') { vm.data.first_name = vm.searchTextFn; }
			if (field === 'last_name') { vm.data.last_name = vm.searchTextLn; }
			if (field === 'customer_email') { vm.data.customer_email = vm.searchTextEm; }
		};
		vm.selectHoldCustomer = function(item) {
			if (!item) { return; }
			holdCustomerSelecting = true;
			vm.data.first_name = item.first_name || '';
			vm.data.last_name = item.last_name || '';
			vm.data.customer_email = item.customer_email || '';
			if (item.phone_number) {
				vm.data.phone_number = item.phone_number;
				$timeout(function() { vm.updateHoldPhone(); }, 300);
			}
			vm.searchTextFn = vm.data.first_name;
			vm.searchTextLn = vm.data.last_name;
			vm.searchTextEm = vm.data.customer_email;
			vm.selectedHoldCustomer.first_name = item;
			vm.selectedHoldCustomer.last_name = item;
			vm.selectedHoldCustomer.customer_email = item;
			$timeout(function() { holdCustomerSelecting = false; }, 300);
		};
		vm.updateHoldPhone = function() {
			var phoneInput = document.querySelector('.hold-quote-phone');
			if (!phoneInput) {
				vm.holdPhoneInvalid = false;
				return;
			}
			var iti = angular.element(phoneInput).data('iti');
			var inputValue = (phoneInput.value || '').trim();
			if (!inputValue) {
				vm.holdPhoneInvalid = false;
				angular.element(phoneInput).removeClass('ng-invalid').addClass('ng-valid');
				return;
			}
			if (!iti) {
				vm.holdPhoneInvalid = false;
				return;
			}
			var isValid = !!iti.isValidNumberPrecise();
			vm.holdPhoneInvalid = !isValid;
			angular.element(phoneInput).toggleClass('ng-invalid', !isValid);
			angular.element(phoneInput).toggleClass('ng-valid', isValid);
		};
		vm.goToHoldGuestStep = function() {
			if(vm.data.type_of_reservation !== 'hold'){ return; }
			if(!vm.onlyAllowHoldBlock && !vm.selectedRoom[vm.data.product_id]){ return; }
			if (!vm.data.hold_duration || moment(vm.data.hold_duration).isBefore(moment(vm.minDate), 'day')) {
				vm.data.hold_duration = angular.copy(vm.minDate);
			}
			vm.showHoldDiscountPanel = false;
			vm.showHoldGuestStep = true;
		};
		vm.backToHoldRooms = function() {
			vm.showHoldGuestStep = false;
			vm.showHoldDiscountPanel = false;
		};

		vm.holdSending = false;
		vm.isHoldCreateDisabled = function() {
			if (vm.holdSending) return true;
			if (!vm.showSaveBtn) return true;
			if (vm.holdPhoneInvalid) return true;
			var guest = vm.data || {};
			if (!guest.first_name || !String(guest.first_name).trim()) return true;
			if (!guest.last_name || !String(guest.last_name).trim()) return true;
			if (!guest.customer_email || !String(guest.customer_email).trim()) return true;
			if (!guest.phone_number || !String(guest.phone_number).trim()) return true;
			if (!guest.hold_duration) return true;
			return false;
		};
		
		addJustDates(dialogData.room_stay_from, dialogData.room_stay_to);		
		vm.original_room_stay_from = angular.copy(vm.data.room_stay_from);
		vm.original_room_stay_to = angular.copy(vm.data.room_stay_to);
		vm.hold_duration_time = new Date(1970, 0, 1, 18, 0, 0);
		var initialFromMoment = moment(vm.data.room_stay_from);
		if (initialFromMoment.isValid() && initialFromMoment.isBefore(moment(vm.minDate), 'day')) {
			vm.data.hold_duration = angular.copy(vm.minDate);
		} else {
			vm.data.hold_duration = new Date(initialFromMoment.format('YYYY-MM-DD'));
		}
		vm.isSameDaySelection = moment(vm.data.room_stay_from).format('YYYY-MM-DD') === moment(vm.data.room_stay_to).format('YYYY-MM-DD');
		if(vm.isDayReservationHotel && (dialogData.preselectDayReservation || vm.isSameDaySelection)){
			vm.data.type_of_reservation = 'create_day';
			vm.minDateCheckout = new Date(moment(vm.data.room_stay_from));
		}
		parentScope.reloaddashboard = true;
		vm.selectedRoom[vm.data.product_id] = '';
		vm.show_result = false;
		vm.occupancy_error = '';
		vm.show_form = true;
		vm.onlyAllowHoldBlock = false;
		vm.noRateAssociatedMsg = '';

		function addJustDates(stDate, enDate) {			
			dateConv = $rootScope.convertDateIntoArray(stDate);
			vm.data.room_stay_from = new Date(dateConv[0], dateConv[1], dateConv[2]);
			dateConv = $rootScope.convertDateIntoArray(enDate);
			vm.data.room_stay_to = new Date(dateConv[0], dateConv[1], dateConv[2]);
			
			vm.minDateCheckout = new Date(moment(vm.data.room_stay_from).add(1, 'days'));
		}
		/**
	    * Close dialog
	    */
	    vm.closeDialog = function() {
       	    $mdDialog.hide();
        };
		
		vm.isCommentEmpty = false;
		vm.manageAdultChild = function(calledFrom) {
			var sum = parseInt(vm.data.child) + parseInt(vm.data.adult);
			if(calledFrom == 'adult'){
				vm.childRange = getRangeArray(0, (vm.maxOccupancy - vm.data.adult));
				if(sum > vm.maxOccupancy){
					vm.data.child = 0;
				}
			} else {
				vm.adultRange = getRangeArray(1, (vm.maxOccupancy - vm.data.child));
				if(sum > (vm.maxOccupancy)){
					vm.data.adult = 1;
				}
			}
            
			$timeout(function() {
				vm.getPolicies();
        	},500);              
		};	
		

		if(vm.isSameDaySelection && !vm.isDayReservationHotel){
			vm.closeDialog();
			return;
		}

		vm.checkinSlected = function(type){
			if(vm.isDayCreateMode()){
				vm.minDateCheckout = new Date(moment(vm.data.room_stay_from));
				var endDate = moment(vm.data.room_stay_to);
				var startDate = moment(vm.data.room_stay_from);
				if(endDate.isBefore(startDate)){
					vm.data.room_stay_to = new Date(moment(vm.data.room_stay_from));
				}
				vm.checkAvailability();
				return;
			}
			vm.minDateCheckout = new Date(moment(vm.data.room_stay_from).add(1, 'days'));
			var endDate = moment(vm.data.room_stay_to);
			var startDate = moment(vm.data.room_stay_from);
			if(endDate.isBefore(startDate) || endDate.isSame(startDate)){
				vm.data.room_stay_to = new Date(moment(vm.data.room_stay_from).add(1, 'days'));
			}
			vm.checkAvailability();
		};
		

		vm.getRangeArray = getRangeArray;
		function getRangeArray(start, end){
			var tempArray = [];
			for(var i=start ; i <= end;i++){
				tempArray.push(i);
			}
			return tempArray;

		}

		vm.resortFeeApplicable = false;
		vm.getPolicies = function() {
			vm.isloading = true;
			vm.showSearch = false;
			addJustDates(vm.data.room_stay_from, vm.data.room_stay_to);
			if(vm.isDayCreateMode()){
				vm.minDateCheckout = new Date(moment(vm.data.room_stay_from));
			}
			var conf_no = '';
			var priceRequest = {
					'product_id': vm.data.product_id,
					'room_stay_from': moment(vm.data.room_stay_from).format('YYYY-MM-DD'),
					'room_stay_to': moment(vm.data.room_stay_to).format('YYYY-MM-DD'),
					'adult': vm.data.adult,
					'child': vm.data.child,
					'confirmation_number': '',
					'called_from': 'BACK_END',
					'requestFor': vm.pageType
				};
			if(vm.isDayCreateMode()){
				priceRequest.cart_type = 'day_reservation';
				priceRequest.type_of_reservation = 'day_reservation';
			}
			
			ganttChartService.getProductPriceData(priceRequest).then(function(response) {
					if(response.success){
						vm.isloading = false; 
						vm.showSearch = true;
						if(response.occupancy_error) {
							vm.show_result = false;
							vm.occupancy_error = response.errorMsg;
						} else if(response.availability_error){
							vm.show_result = false;
							vm.occupancy_error = response.errorMsg;
						} else {
							vm.show_result = true;
							vm.proImage = response.data.image;
							vm.policiesDetail = (response.data.prices !== undefined)?response.data.prices :{};
							vm.searchSummary = response.data.searchSummary !== undefined ? response.data.searchSummary : {};
							vm.rememberQuotePrices(response);
							vm.resortFeeApplicable = response.resortFeeApplicable !== undefined ? response.resortFeeApplicable : false;
			    			vm.extraPersonApplicable = response.extraPersonApplicable !== undefined ? response.extraPersonApplicable : false;
							vm.maxOccupancy = (response['data']['max_occupancy'] != undefined)?response['data']['max_occupancy']:2;
							vm.boat_length = (response['data']['boat_length'] != undefined)?response['data']['boat_length']:5;
							vm.boat_width = (response['data']['boat_width']  != undefined)?response['data']['boat_width'] : 10;
							vm.adultRange = [];
							vm.adultRange = vm.getRangeArray(1,(((response['data']['max_occupancy'] != undefined)?response['data']['max_occupancy']:2) - vm.data.child));
							vm.childRange = [];
							vm.childRange = vm.getRangeArray(0,(((response['data']['max_occupancy'] != undefined)?response['data']['max_occupancy']:2) - vm.data.adult));
							vm.PolicyLength = Object.keys(vm.policiesDetail).length;
							vm.additionalAmt = (response.data.additional_guest_amounts != undefined)? response.data.additional_guest_amounts :0;
							vm.onlyAllowHoldBlock = response.onlyAllowHoldBlock != undefined ? response.onlyAllowHoldBlock : false;
							angular.forEach(vm.policiesDetail,function(value, key){
								if(key && vm.selectedRoom[vm.data.product_id]==''){
									vm.selectedRoom[vm.data.product_id] = key;
								}
							});
							vm.noRateAssociatedMsg = response.noRateAssociatedMsg != undefined ? response.noRateAssociatedMsg : '';
							vm.room_type_description = (response.data.room_type_description != undefined)?response.data.room_type_description :'';
							vm.show_form = true;
							if(vm.data.type_of_reservation === 'hold' && vm.onlyAllowHoldBlock){
								vm.selectedRoom[vm.data.product_id] = '2';
							}
							buildHoldNightlyRows();
							if ((vm.holdPromoCode || '').trim() && !vm.holdPromoApplied) {
								vm.applyQuotePromo('applied');
							}
						}
					} else if(response.errorMsg != 'undefined' && response.errorMsg != '') {
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
						vm.closeDialog();
					} else {
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
						vm.closeDialog();
					}
			});
		}

		vm.getPolicies();

		vm.checkAvailability = function(){
			vm.isloading = true;
			var availRequest = {
				'product_id': vm.data.product_id,
				'room_stay_from': moment(vm.data.room_stay_from).format('YYYY-MM-DD'),
                'room_stay_to': moment(vm.data.room_stay_to).format("YYYY-MM-DD"),
			};
			if(vm.isDayCreateMode()){
				availRequest.type_of_reservation = 'day_reservation';
			}
			ganttChartService.checkAvailabilityForDates(availRequest).then(function(response){
				vm.isloading = false;
				if(response.success){
					vm.showSaveBtn = true;
					vm.occupancy_error = '';
					vm.getPolicies();
					vm.show_form = true;
				} else if (response.errorMsg != 'undefined' && response.errorMsg !='') {
					vm.showSaveBtn = false;
					vm.show_result = false;
					vm.occupancy_error = response.errorMsg;
				} else {
					vm.show_form = false;
					toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
					vm.closeDialog();
				}
			});
		};

		vm.type_changed = function(){
			vm.isCommentEmpty = false;
			vm.data.room_stay_from = angular.copy(vm.original_room_stay_from);
			vm.data.room_stay_to = angular.copy(vm.original_room_stay_to);
			vm.showHoldGuestStep = false;
			vm.selectedRoom[vm.data.product_id] = '';
			if(vm.isDayCreateMode()){
				vm.minDateCheckout = new Date(moment(vm.data.room_stay_from));
				vm.data.room_stay_to = angular.copy(vm.data.room_stay_from);
			} else if(vm.data.type_of_reservation === 'create' && vm.isSameDaySelection){
				vm.data.room_stay_to = new Date(moment(vm.data.room_stay_from).add(1, 'days'));
				vm.minDateCheckout = new Date(moment(vm.data.room_stay_from).add(1, 'days'));
			} else {
				vm.minDateCheckout = new Date(moment(vm.data.room_stay_from).add(1, 'days'));
			}
			if(vm.isCreateMode() || vm.data.type_of_reservation === 'hold'){
				vm.getPolicies();
			} else {
				vm.checkAvailability();
			}
		};       
       
		vm.rememberQuotePrices = function(response) {
			var keepPromo = (vm.data.type_of_reservation === 'hold' && vm.holdPromoApplied) ? (vm.holdPromoCode || '').trim() : '';
			vm.baseSearchSummary = angular.copy(vm.searchSummary || {});
			vm.roomTypeId = (response && response.data && (response.data.room_type_id || response.data.type_id)) || '';
			vm.stayNights = (response && response.data && response.data.nights) || 1;
			vm.holdPromoApplied = false;
			vm.holdPromoCode = keepPromo;
			vm.holdPromoDiscount = 0;
			vm.holdPromoPerNightDiscount = 0;
			vm.holdPromoPolicy = '';
			vm.holdPromoMessage = '';
			vm.holdDiscountApplied = false;
			vm.holdDiscountAmount = 0;
			vm.holdDiscountPercent = 0;
			vm.holdDiscountComment = '';
			vm.holdDiscountPolicy = '';
			vm.displayNightlyRate = '';
			vm.holdNightlyDiscounts = [];
			vm.holdNightlyComments = [];
			vm.showHoldPromoRemoveConfirm = false;
			buildHoldNightlyRows();
		};
		function quotePromoRates(summary, policy) {
			var rates = (summary && summary.rates) || (policy && policy.rates) || [];
			if (!angular.isArray(rates)) {
				rates = Object.keys(rates).map(function(key) { return rates[key]; });
			}
			return rates;
		}
		function quoteRoomTax(amount, taxRates) {
			var tax = 0;
			angular.forEach(taxRates || [], function(item) {
				tax += (parseFloat(amount) * parseFloat(item.tax_value || 0)) / 100;
			});
			return tax;
		}
		vm.clearQuotePromo = function() {
			vm.searchSummary = angular.copy(vm.baseSearchSummary || vm.searchSummary);
			vm.holdPromoApplied = false;
			vm.holdPromoDiscount = 0;
			vm.holdPromoPerNightDiscount = 0;
			vm.holdPromoPercent = 0;
			vm.holdPromoCode = '';
			vm.holdPromoPolicy = '';
			vm.holdPromoMessage = '';
			vm.displayNightlyRate = '';
			vm.showHoldPromoRemoveConfirm = false;
			buildHoldNightlyRows();
		};
		vm.applyQuotePromo = function(type) {
			if (vm.onlyAllowHoldBlock || vm.data.type_of_reservation !== 'hold') { return; }
			if (type !== 'remove' && vm.holdDiscountApplied) {
				toastMessage.showSimpleToast('Cannot apply promo code while manual discount is active. Remove discount first.', 'warning-toast', true);
				return;
			}
			var policyKey = vm.selectedRoom[vm.data.product_id];
			var policy = (vm.policiesDetail && vm.policiesDetail[policyKey]) || {};
			var summary = (vm.baseSearchSummary && vm.baseSearchSummary[policyKey]) || {};
			if (type !== 'remove' && !(vm.holdPromoCode || '').trim()) { return; }
			if (type !== 'remove' && !quotePromoRates(summary, policy).length) {
				toastMessage.showSimpleToast('Promo code could not be priced for this room. Search the room again and retry.', 'warning-toast', true);
				return;
			}
			var run = function() {
				if (type === 'remove') {
					vm.clearQuotePromo();
					return;
				}
				var subTotal = parseFloat(summary.subTotal) || 0;
				vm.promoRequestGoing = true;
				eCommerceService.validatePromoCode({
					promoCode: (vm.holdPromoCode || '').trim(),
					promo: 'applied',
					resvProcess: 'create',
					cartDetail: {
						from: moment(vm.data.room_stay_from).format('MM/DD/YYYY'),
						to: moment(vm.isDayCreateMode() ? vm.data.room_stay_from : vm.data.room_stay_to).format('MM/DD/YYYY'),
						cart_type: vm.isDayCreateMode() ? 'day_reservation' : 'room',
						product_id: vm.data.product_id,
						product_name: vm.data.product_name,
						room_type_id: vm.roomTypeId,
						prices: { rates: quotePromoRates(summary, policy) },
						taxes: summary.taxRates || [],
						original_deposit_amt: 0,
						nightlySum: subTotal,
						product_discount: 0,
						overalltotals: { deposit_amount: 0, subtotal: subTotal, tax: 0, grand_total: 0, remaining_amount: 0, product_discount: 0 }
					}
				}).then(function(response) {
					vm.promoRequestGoing = false;
					if (response && !response.status && (response.errorMsg || response.warningMsg)) {
						toastMessage.showSimpleToast(response.errorMsg || response.warningMsg, response.errorMsg ? 'error-toast' : 'warning-toast', true);
						return;
					}
					if (response && response.warningMsg) {
						toastMessage.showSimpleToast(response.warningMsg, 'warning-toast', true);
					}
					if (!(response && response.order && response.order.anyPromoApplied)) { return; }
					var order = response.order;
					var totalDiscount = parseFloat(order.promoCodeDiscount) || 0;
					var nights = parseFloat(vm.stayNights) || quotePromoRates(summary, policy).length || 1;
					var perNightPromoDiscount = totalDiscount / nights;
					var nightlyRate = parseFloat(policy.nightlyRate) || (subTotal / nights);
					var promoPercent = (nightlyRate > 0) ? ((perNightPromoDiscount / nightlyRate) * 100) : 0;
					promoPercent = commonService ? commonService.roundnum(promoPercent, 2) : parseFloat(promoPercent.toFixed(2));

					var oldRoomTax = quoteRoomTax(summary.subTotal, summary.taxRates);
					var newRoomTax = 0;
					angular.forEach(order.taxes || [], function(tax) { newRoomTax += parseFloat(tax.tax_amt) || 0; });
					var taxDelta = oldRoomTax - newRoomTax;
					vm.searchSummary = angular.copy(vm.baseSearchSummary);
					vm.searchSummary[policyKey].taxes = (parseFloat(summary.taxes || 0) - taxDelta).toFixed(2);
					vm.searchSummary[policyKey].grandTotal = (parseFloat(summary.grandTotal || 0) - totalDiscount - taxDelta).toFixed(2);
					vm.holdPromoDiscount = totalDiscount.toFixed(2);
					vm.holdPromoPerNightDiscount = perNightPromoDiscount.toFixed(2);
					vm.holdPromoPercent = promoPercent;
					vm.holdPromoCode = order.promoCodeName || vm.holdPromoCode;
					vm.holdPromoMessage = vm.holdPromoCode || '';
					vm.holdPromoPolicy = policyKey;
					vm.holdPromoApplied = true;
					vm.displayNightlyRate = (nightlyRate - perNightPromoDiscount).toFixed(2);
					buildHoldNightlyRows();
				}, function() {
					vm.promoRequestGoing = false;
					toastMessage.showSimpleToast('Unable to apply promo code.', 'error-toast', true);
				});
			};
			run();
		};

		vm.askRemoveHoldPromo = function($event) {
			if ($event) {
				$event.preventDefault();
				$event.stopPropagation();
			}
			$mdDialog.show({
				controller: 'confirmController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
				parent: angular.element(document.body),
				targetEvent: $event,
				clickOutsideToClose: true,
				skipHide: true,
				multiple: true,
				locals: {
					title: 'Promo Code',
					htmlContent: 'Are you sure you want to remove the promo code?',
					cancelBtn: 'No',
					OkBtn: 'Yes'
				}
			}).then(function(answer) {
				if (typeof answer != 'undefined' && answer == 'update') {
					vm.applyQuotePromo('remove');
				}
			}, function() {});
		};

		function holdToList(val) {
			if (val == null || val === '') { return []; }
			if (angular.isArray(val)) { return val; }
			if (typeof val === 'object') {
				return Object.keys(val).map(function(k) { return val[k]; });
			}
			return [val];
		}

		function holdPercentLabel(discount, rate) {
			var discountAmount = parseFloat(discount) || 0;
			var nightRate = parseFloat(rate) || 0;
			if (discountAmount <= 0 || nightRate <= 0) { return ''; }
			var percent = parseFloat(commonService ? commonService.roundnum((discountAmount / nightRate) * 100, 2) : ((discountAmount / nightRate) * 100).toFixed(2));
			return percent % 1 === 0 ? percent.toFixed(0) : percent.toFixed(2);
		}
		vm.holdPercentLabel = holdPercentLabel;

		function buildHoldNightlyRows() {
			vm.holdNightlyRows = [];
			if (!vm.data || vm.data.type_of_reservation !== 'hold' || vm.onlyAllowHoldBlock) { return; }
			var policyKey = vm.selectedRoom && vm.selectedRoom[vm.data.product_id];
			if (!policyKey) { return; }
			var policy = (vm.policiesDetail && vm.policiesDetail[policyKey]) || {};
			var summary = (vm.baseSearchSummary && vm.baseSearchSummary[policyKey]) || (vm.searchSummary && vm.searchSummary[policyKey]) || {};
			var dates = holdToList(policy.dates || summary.dates);
			var rates = holdToList(policy.rates || summary.rates);
			var plans = holdToList(policy.rate_plan);
			var defaultRate = parseFloat(policy.nightlyRate) || 0;
			var defaultPlan = policy.ratePlanName || policy.policy_name || '---';
			var nights = dates.length || rates.length || parseFloat(vm.stayNights) || 0;
			if (nights < 1 && vm.data.room_stay_from && vm.data.room_stay_to) {
				nights = Math.max(1, Math.round(Math.abs(moment(vm.data.room_stay_to).diff(moment(vm.data.room_stay_from), 'days'))));
			}
			if (nights < 1) { nights = 1; }
			var start = moment(vm.data.room_stay_from || vm.original_room_stay_from);
			for (var i = 0; i < nights; i++) {
				var rate = (rates[i] != null && rates[i] !== '') ? parseFloat(rates[i]) : defaultRate;
				if (!rate && nights > 0 && summary.subTotal) {
					rate = parseFloat(summary.subTotal) / nights;
				}
				var dateVal = dates[i];
				if (!dateVal && start && start.isValid()) {
					dateVal = start.clone().add(i, 'days').format('MM-DD-YYYY');
				}
				var amt = 0;
				var comm = '';
				if (vm.holdPromoApplied) {
					amt = parseFloat(vm.holdPromoPerNightDiscount) || 0;
					comm = vm.holdPromoCode || '';
				} else if (vm.holdNightlyDiscounts && vm.holdNightlyDiscounts[i] != null) {
					amt = parseFloat(vm.holdNightlyDiscounts[i]) || 0;
					comm = (vm.holdNightlyComments && vm.holdNightlyComments[i]) || '';
				}
				vm.holdNightlyRows.push({
					nightNum: i + 1,
					date: dateVal || ('Night ' + (i + 1)),
					ratePlan: plans[i] || defaultPlan,
					rate: rate || 0,
					amount: amt,
					percent: (rate > 0 && amt > 0) ? (commonService ? commonService.roundnum((amt / rate) * 100, 2) : parseFloat(((amt / rate) * 100).toFixed(2))) : 0,
					percentLabel: holdPercentLabel(amt, rate),
					comment: comm
				});
			}
		}
		vm.buildHoldNightlyRows = buildHoldNightlyRows;
		vm.showHoldRatePlanCol = function() {
			if (!vm.holdNightlyRows || !vm.holdNightlyRows.length) { return false; }
			for (var i = 0; i < vm.holdNightlyRows.length; i++) {
				if (vm.holdNightlyRows[i] && vm.holdNightlyRows[i].ratePlan) { return true; }
			}
			return false;
		};

		vm.toggleHoldDiscountPanel = function($event) {
			if ($event) {
				$event.preventDefault();
				$event.stopPropagation();
			}
			if (vm.onlyAllowHoldBlock || vm.data.type_of_reservation !== 'hold') { return; }
			buildHoldNightlyRows();
			vm.showHoldDiscountPanel = !vm.showHoldDiscountPanel;
		};

		vm.openHoldNightDiscount = function(index, $event) {
			if ($event) {
				$event.preventDefault();
				$event.stopPropagation();
			}
			if (vm.onlyAllowHoldBlock || vm.data.type_of_reservation !== 'hold') { return; }
			if (vm.holdPromoApplied) { return; }
			var night = vm.holdNightlyRows[index] || {};
			var nightlyRate = parseFloat(night.rate) || 0;
			if (nightlyRate <= 0) {
				toastMessage.showSimpleToast('Room rate not available for discount calculation.', 'warning-toast', true);
				return;
			}
			var existingAmount = parseFloat(night.amount) || 0;
			$mdDialog.show({
				controller: 'discountCommentController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/create-res/dialogs/discount-comment/discount-comment.html',
				parent: angular.element(document.body),
				targetEvent: $event,
				clickOutsideToClose: true,
				skipHide: true,
				multiple: true,
				locals: {
					oldcomment: night.comment || '',
					oldAmount: existingAmount > 0 ? existingAmount : '',
					type: 'nightly_discount',
					price: nightlyRate
				}
			}).then(function(answer) {
				if (answer === undefined || answer === null) { return; }
				var amt = parseFloat(answer.amount) || 0;
				night.amount = amt;
				night.percent = parseFloat(answer.percent) || 0;
				night.percentLabel = holdPercentLabel(amt, night.rate);
				night.comment = (answer.comment || '').trim();
				var nights = vm.holdNightlyRows.map(function(n) {
					return {
						nightNum: n.nightNum,
						date: n.date,
						rate: n.rate,
						amount: parseFloat(n.amount) || 0,
						percent: parseFloat(n.percent) || 0,
						comment: n.comment || ''
					};
				});
				var total = 0;
				nights.forEach(function(n) { total += n.amount; });
				if (total > 0) {
					vm.applyHoldDiscount({
						mode: 'per_night',
						nights: nights,
						totalDiscount: total,
						amount: nights[0] ? nights[0].amount : 0,
						percent: nights[0] ? nights[0].percent : 0,
						comment: nights[0] ? nights[0].comment : ''
					});
				} else {
					vm.removeHoldDiscount();
				}
			}, function() {});
		};

		vm.applyHoldDiscount = function(answer, policyKey, summary) {
			policyKey = policyKey || vm.selectedRoom[vm.data.product_id];
			summary = summary || (vm.baseSearchSummary && vm.baseSearchSummary[policyKey]) || (vm.searchSummary && vm.searchSummary[policyKey]) || {};
			var policy = (vm.policiesDetail && vm.policiesDetail[policyKey]) || {};
			var subTotal = parseFloat(summary.subTotal) || 0;
			var nights = parseFloat(vm.stayNights) || 1;
			if (nights < 1 && vm.data.room_stay_from && vm.data.room_stay_to) {
				nights = Math.max(1, Math.round(Math.abs(moment(vm.data.room_stay_to).diff(moment(vm.data.room_stay_from), 'days'))));
			}
			var nightlyRate = parseFloat(policy.nightlyRate) || (nights > 0 ? (subTotal / nights) : subTotal);
			var totalDiscount = 0;
			var comment = '';
			var percent = 0;

			if (answer.mode === 'per_night') {
				vm.holdDiscountType = 'per_night';
				vm.holdNightlyDiscounts = [];
				vm.holdNightlyComments = [];
				var commentParts = [];
				(answer.nights || []).forEach(function(n, idx) {
					var a = parseFloat(n.amount) || 0;
					totalDiscount += a;
					vm.holdNightlyDiscounts.push(a.toFixed(2));
					vm.holdNightlyComments.push((n.comment || '').trim());
					if (a > 0) {
						commentParts.push('Night ' + (idx + 1) + ': -$' + a.toFixed(2) + (n.comment ? ' (' + n.comment + ')' : ''));
					}
				});
				if (totalDiscount > subTotal) { totalDiscount = subTotal; }
				comment = commentParts.join(' | ');
				percent = (subTotal > 0) ? (commonService ? commonService.roundnum((totalDiscount / subTotal) * 100, 2) : parseFloat(((totalDiscount / subTotal) * 100).toFixed(2))) : 0;
				vm.holdDiscountAmount = totalDiscount.toFixed(2);
				vm.holdPerNightDiscount = (nights > 0 ? (totalDiscount / nights) : totalDiscount).toFixed(2);
			} else {
				vm.holdDiscountType = 'uniform';
				var perNightDiscount = parseFloat(answer.amount) || 0;
				if (perNightDiscount > nightlyRate) {
					perNightDiscount = nightlyRate;
				}
				totalDiscount = perNightDiscount * nights;
				if (totalDiscount > subTotal) {
					totalDiscount = subTotal;
				}
				percent = parseFloat(answer.percent) || 0;
				if (!percent && nightlyRate > 0) {
					percent = commonService ? commonService.roundnum((perNightDiscount / nightlyRate) * 100, 2) : parseFloat(((perNightDiscount / nightlyRate) * 100).toFixed(2));
				}
				comment = (answer.comment || '').trim();
				vm.holdPerNightDiscount = perNightDiscount.toFixed(2);
				vm.holdDiscountAmount = totalDiscount.toFixed(2);
				vm.holdNightlyDiscounts = [];
				vm.holdNightlyComments = [];
				for (var j = 0; j < nights; j++) {
					vm.holdNightlyDiscounts.push(perNightDiscount.toFixed(2));
					vm.holdNightlyComments.push(comment);
				}
			}

			var oldRoomTax = quoteRoomTax(summary.subTotal, summary.taxRates);
			var newRoomSubtotal = Math.max(0, subTotal - totalDiscount);
			var newRoomTax = quoteRoomTax(newRoomSubtotal, summary.taxRates);
			var taxDelta = Math.max(0, oldRoomTax - newRoomTax);

			if (!vm.baseSearchSummary || !Object.keys(vm.baseSearchSummary).length) {
				vm.baseSearchSummary = angular.copy(vm.searchSummary);
			}
			vm.searchSummary = angular.copy(vm.baseSearchSummary);
			vm.searchSummary[policyKey].taxes = (parseFloat(summary.taxes || 0) - taxDelta).toFixed(2);
			vm.searchSummary[policyKey].grandTotal = (parseFloat(summary.grandTotal || 0) - totalDiscount - taxDelta).toFixed(2);

			vm.holdDiscountApplied = true;
			vm.holdTotalDiscount = totalDiscount.toFixed(2);
			vm.holdDiscountPercent = percent;
			vm.holdDiscountComment = comment;
			vm.holdDiscountPolicy = policyKey;
			vm.displayNightlyRate = Math.max(0, (nightlyRate - (totalDiscount / (nights || 1)))).toFixed(2);
			buildHoldNightlyRows();
		};

		vm.removeHoldDiscount = function() {
			if (vm.baseSearchSummary && Object.keys(vm.baseSearchSummary).length) {
				vm.searchSummary = angular.copy(vm.baseSearchSummary);
			}
			vm.holdDiscountApplied = false;
			vm.holdDiscountType = 'uniform';
			vm.holdDiscountAmount = 0;
			vm.holdPerNightDiscount = 0;
			vm.holdTotalDiscount = 0;
			vm.holdDiscountPercent = 0;
			vm.holdDiscountComment = '';
			vm.holdDiscountPolicy = '';
			vm.holdNightlyDiscounts = [];
			vm.holdNightlyComments = [];
			vm.displayNightlyRate = '';
			buildHoldNightlyRows();
		};

        vm.saveTypeofRes = function() {
			if (vm.holdSending) { return false; }
       		if((vm.data.room_stay_comment == undefined || vm.data.room_stay_comment == '') && !vm.isCreateMode()) {
       			vm.isCommentEmpty = true;
       			return false;
       		} else {
       			vm.isCommentEmpty = false;
       		}
		   	vm.data.requestType = vm.pageType;
		   	
			if(vm.isCreateMode()) {
				parentScope.reloaddashboard = false;
				var createParams = {
					prod_id:JSON.stringify(vm.selectedRoom),
					from: moment(vm.data.room_stay_from).format('YYYY-MM-DD'),
					to:moment(vm.data.room_stay_to).format('YYYY-MM-DD'),
					adult:vm.data.adult,
					child:vm.data.child,
					from_page:'header',
					block_conf_no:vm.data.block_conf_no,
					hold_block_choice:vm.data.hold_block_choice,
					creationSource:''
				};
				if(vm.isDayCreateMode()){
					createParams.cart_type = 'day_reservation';
					createParams.to = createParams.from;
				}
				$state.go('app.create-res', createParams);
			} else {
				var holdFirst = (vm.data.first_name || '').trim();
				var holdLast = (vm.data.last_name || '').trim();
				vm.data.first_name = holdFirst;
				vm.data.last_name = holdLast;
				vm.data.customer_name = (holdFirst + ' ' + holdLast).trim();
				vm.updateHoldPhone();
				if (vm.data.type_of_reservation == 'hold' && vm.holdPhoneInvalid) {
					toastMessage.showSimpleToast('Please enter a valid phone number','error-toast', true);
					return false;
				}
				var holdPhoneInput = document.querySelector('.hold-quote-phone');
				if (holdPhoneInput) {
					var holdIti = angular.element(holdPhoneInput).data('iti');
					var holdPhoneVal = holdPhoneInput.value.trim();
					if (holdPhoneVal && holdIti && holdIti.isValidNumberPrecise()) {
						var holdDialCode = '+' + holdIti.getSelectedCountryData().dialCode;
						var holdLocal = holdPhoneVal.indexOf(holdDialCode) === 0 ? holdPhoneVal.substring(holdDialCode.length).trim() : holdPhoneVal;
						vm.data.phone_number = holdDialCode + ' ' + holdLocal;
					} else {
						vm.data.phone_number = holdPhoneVal;
					}
				}
				if(vm.hold_duration_time != '' && typeof  vm.data['hold_duration'] != 'undefined'){
					vm.data.hold_duration = moment(vm.data.hold_duration).format('MM/DD/YYYY') +" "+ moment(vm.hold_duration_time).format('LT');
				} else{
					vm.data.hold_duration = "";
				}
				vm.data.room_stay_from = moment(vm.data.room_stay_from).format('YYYY-MM-DD');
				vm.data.room_stay_to = moment(vm.data.room_stay_to).format('YYYY-MM-DD');
				if (typeof vm.data.adult !== 'undefined') {
					vm.data.room_stay_guest_count = parseInt(vm.data.adult);
				}
				if (typeof vm.data.child !== 'undefined') {
					vm.data.room_stay_child_count = parseInt(vm.data.child);
				}
				delete vm.data.requestFor;
				delete vm.data.pageType;
				delete vm.data.called_from;
				if (vm.data.type_of_reservation == 'hold' && vm.holdPromoApplied) {
					vm.data.promotion_code = vm.holdPromoCode;
					vm.data.promo_discount = vm.holdPromoDiscount;
				} else {
					delete vm.data.promotion_code;
					delete vm.data.promo_discount;
				}
				if (vm.data.type_of_reservation == 'hold' && vm.holdDiscountApplied) {
					vm.data.manual_discount = vm.holdDiscountAmount;
					vm.data.discount_percent = vm.holdDiscountPercent;
					vm.data.discount_comment = vm.holdDiscountComment;
					vm.data.discount_type = vm.holdDiscountType || 'uniform';
					if (vm.holdNightlyDiscounts && vm.holdNightlyDiscounts.length) {
						vm.data.nightly_discount = vm.holdNightlyDiscounts.join(',');
						vm.data.nightly_discount_comment = (vm.holdNightlyComments || []).join('|');
					}
				} else {
					delete vm.data.manual_discount;
					delete vm.data.discount_percent;
					delete vm.data.discount_comment;
					delete vm.data.discount_type;
					delete vm.data.nightly_discount;
					delete vm.data.nightly_discount_comment;
				}
				vm.showSaveBtn = false;
				vm.holdSending = true;
				ganttChartService.saveHoldBlockDates({data:vm.data}).then(function(response){
					if(!response.success ){
						vm.holdSending = false;
						vm.showSaveBtn = true;
						toastMessage.showSimpleToast(response.errorMsg,'error-toast', true);
					} else {
						vm.closeDialog();
					}
				}, function() {
					vm.holdSending = false;
					vm.showSaveBtn = true;
				});
			}		
	    };

	 	vm.readDescription = function(id) {
	 		vm.readText = (vm.readText === 'Show description') ? 'Hide description' : 'Show description';
	 		vm.showDescription = !vm.showDescription;
       	};

       	//Code 	to conditionaly run click event
       	vm.runClickEvent = false;
       	if($( window ).width() <= 1020){
       		vm.runClickEvent = true;
       	};

       	vm.showBlock = [];
       	vm.showRateDesc = [];
	    vm.showOverlay = false;
	    // function to close all details popup
	    vm.closeAllDetails = function(){
			angular.forEach(vm.showBlock,function(pval,pkey){
				vm.showBlock[pkey] = false;
			});
	    }

	    // function to show hide detail popup
		vm.showDetailBlock = function(policyKey){
			angular.forEach(vm.showBlock,function(pval,pkey){
				if(pkey == policyKey){
					vm.showBlock[pkey] = !vm.showBlock[pkey];
				} else {
					vm.showBlock[pkey] = false;
				}
			});
		}

		vm.closeAllRateDetails = function(){
			console.log('sdfsdf');
			angular.forEach(vm.showRateDesc,function(pval,pkey){
				vm.showRateDesc[pkey] = false;
			});
	    }

	    // function to show hide detail popup
		vm.showDetailRateBlock = function(policyKey){
			angular.forEach(vm.showRateDesc,function(pval,pkey){
				if(pkey == policyKey){
					vm.showRateDesc[pkey] = !vm.showRateDesc[pkey];
				} else {
					vm.showRateDesc[pkey] = false;
				}
			});
		}
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.create-res',
            [
                // 3rd Party Dependencies
                'ngStorage',
                'credit-cards',
                'ngMessages'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider){

         $stateProvider.state('app.create-res', {
            url    : '/create-res',
            title  : 'Create Reservation',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/create-res/create-res.html',
                    controller : 'CreateReservationController as vm'
                }
            },
            params:      {prod_id:'',from:'',to:'',adult:2,child:0,from_page:'',itinerary_number:'',addToItinery:false, tabIndex: 0,block_conf_no: '',hold_block_choice: '', negotiatedCustId:0, newPosAdded : false, creationSource:'', cart_type:'', ignore_early_late: false},
            permission: 'reservations',
            resolve: {
                roomData: function ($localStorage,createResService,$stateParams,$state){
					if($stateParams.from_page == 'header'){
                        if(typeof $stateParams.prod_id != 'object')
						    $stateParams.prod_id = JSON.parse($stateParams.prod_id);
                        else
                            $stateParams.prod_id = $stateParams.prod_id;
					}
                    
                    var negotiatedCustId = 0;
                    if ($stateParams.negotiatedCustId != undefined) {
                        negotiatedCustId = $stateParams.negotiatedCustId;
                    }

					var cartRequest = {
                        prod_id: $stateParams.prod_id,
                        from: $stateParams.from,
                        to: $stateParams.to,
                        adult: $stateParams.adult,
                        child: $stateParams.child,
                        itinerary_number: $stateParams.itinerary_number,
                        addToItinery: $stateParams.addToItinery,
                        negotiatedCustId: negotiatedCustId
                    };
					if ($stateParams.cart_type) {
						cartRequest.cart_type = $stateParams.cart_type;
					}
					if ($stateParams.ignore_early_late) {
						cartRequest.ignore_early_late = true;
					}
					return createResService.getcartData(cartRequest);
				}
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/create-res');
    }

})();

(function () {
	'use strict';

	angular
		.module('app.create-res')
		.controller('posOptionsOverlayController', posOptionsOverlayController);

	/** @ngInject */
	function posOptionsOverlayController(
		$mdDialog,
		$scope,
		$document,
		$filter,
		$timeout,
		$localStorage,
		$sessionStorage,
		EnvironmentConfig,
		commonService,
		checkoutService,
		createResService,
		eCommerceService,
		toastMessage,
		roomIndex,
		addRoomInItin,
		itinerary_number,
		summaryCartdetails,
		taxNamedValues,
		cust_info
	) {
		var vm = this;
		var staticRestValue = 'restaurant';
		var hotelId = $localStorage.preHotelId || $localStorage['preHotelId'];
		var cartStorageKey = 'cartDetails_' + hotelId;

		function getRoomIdx() {
			var idx = parseInt(roomIndex, 10);
			return isNaN(idx) ? 0 : idx;
		}
		var EXTRA_ATTR_INSURANCE = 'insurance';
		var PRESERVED_EXTRA_ATTRS = { resort_fee: 1, extra_person: 1, surcharge: 1 };
		var DEFAULT_INSURANCE_NAME = 'Worry-Free Travel Protection';
		var INSURANCE_CANCEL_POLICY_DAYS = 7;

		var STEP_CONFIG = {
			1: { footerKey: 'pos', goTo: function () { goBackToPos(); } },
			2: { footerKey: 'insurance', goTo: function () { continueToInsurance(); } }
		};

		function idEquals(a, b) {
			return String(a) === String(b);
		}

		vm.summary = {
			cartdetails: summaryCartdetails,
			taxNamedValues: taxNamedValues || {},
			cust_info: cust_info || {}
		};
		$scope.overlaySummaryTotals = {
			grand_total: 0,
			deposit_amount: 0,
			remaining_amount: 0
		};
		vm.overlaySummaryTotals = $scope.overlaySummaryTotals;
		vm.roomTitle = summaryCartdetails.product_name || 'Room';
		vm.autoFillOff = true;
		vm.isloading = false;
		vm.applying = false;
		vm.baseUrl = EnvironmentConfig.api;
		vm.search = '';
		vm.curPage = 1;
		vm.totalPages = 1;
		vm.dataPerPage = 21;
		vm.skeletonProductSlots = new Array(vm.dataPerPage);
		vm.skeletonReviewSlots = new Array(5);
		vm.allPosProducts = [];
		vm.cartItem = [];
		vm.cartItemIds = [];
		vm.multipleNightPolicies = [];
		vm.insuranceTaxLines = [];
		vm.insuranceGrandTotal = 0;
		vm.insuranceSubtotal = 0;
		vm.insuranceOptIn = false;
		vm.insuranceChoice = null;
		vm.insuranceProductId = null;
		vm.insuranceProductData = null;
		vm.hasInsuranceProduct = false;
		vm.insuranceLoading = true;
		vm.flashProductId = null;
		vm.step = 'pos';
		vm.footerStep = 'pos';
		vm.addRoomInItin = addRoomInItin;
		vm.insuranceFeaturePoints = [
			'Cancel for any reason, anytime',
			'Full refund before check-in',
			'No questions asked',
			'Protection applies to your full reservation value'
		];

		vm.resDetails = {
			checkin: summaryCartdetails.from,
			checkout: summaryCartdetails.to,
			product_id: summaryCartdetails.product_id,
			product_name: summaryCartdetails.product_name,
			policy_id: summaryCartdetails.selelected_policy_id,
			cartIndex: getRoomIdx(),
			addServiceForRoom: true,
			taxValue: summaryCartdetails.customerTaxExempt,
			pageFrom: 'reservation',
			itinerary_number: itinerary_number || '',
			typeofService: 'retail'
		};

		loadCartItemsForRoom();

		if (summaryCartdetails.room_deposit_type_indicator === 'multiple-night') {
			eCommerceService.getmultipleNightPolicy($sessionStorage[cartStorageKey]).then(function (response) {
				vm.multipleNightPolicies = response;
				updateReservationSummary();
			});
		}

		updateReservationSummary();

		angular.extend(vm, {
			cancel: cancel,
			continueToInsurance: continueToInsurance,
			goBackToPos: goBackToPos,
			applyPos: applyPos,
			getPrimaryFooterLabel: getPrimaryFooterLabel,
			isPrimaryFooterDisabled: isPrimaryFooterDisabled,
			handlePrimaryFooterClick: handlePrimaryFooterClick,
			getToolbarTitle: getToolbarTitle,
			getInsuranceDisplayName: getInsuranceDisplayName,
			showInsurance7DayCancelPolicy: showInsurance7DayCancelPolicy,
			isStepperStepActive: isStepperStepActive,
			isStepperStepComplete: isStepperStepComplete,
			isStepperStepClickable: isStepperStepClickable,
			onStepperStepClick: onStepperStepClick,
			getStepperLabel: getStepperLabel,
			addToCart: addToCart,
			onProductCardClick: onProductCardClick,
			filterProducts: filterProducts,
			switchPage: switchPage,
			removeCartItem: removeCartItem,
			incrementCartItem: incrementCartItem,
			decrementCartItem: decrementCartItem,
			canAdjustCartQuantity: canAdjustCartQuantity,
			emptyCart: emptyCart,
			getProductImageUrl: getProductImageUrl,
			isSelectablePosLine: isSelectablePosLine,
			getSearchText: getSearchText,
			clearSearch: clearSearch,
			isInCart: isInCart,
			isPosQuantityLocked: isPosQuantityLocked,
			isQuantityLockedMaxed: isQuantityLockedMaxed,
			getCartQty: getCartQty,
			getSelectedPosSubtotal: getSelectedPosSubtotal,
			hasVisibleCartItems: hasVisibleCartItems,
			getReviewCartCount: getReviewCartCount,
			isInsuranceLine: isInsuranceLine,
			onInsuranceOptInChange: onInsuranceOptInChange,
			onInsuranceChoiceChange: onInsuranceChoiceChange,
			setInsuranceChoice: setInsuranceChoice
		});

		$scope.addTimeBoundProduct = function (product, quantity, from, to, index, status) {
			addProductToCart(product, quantity, from, to, index, status);
		};

		loadPosProducts();
		loadInsuranceProduct();

		$timeout(function () {
			vm.autoFillOff = false;
		}, 500);

		function parseProductExtraSettings(product) {
			if (!product || product.extra_settings == null || product.extra_settings === '') {
				return {};
			}
			if (angular.isObject(product.extra_settings)) {
				return product.extra_settings;
			}
			try {
				return JSON.parse(product.extra_settings) || {};
			} catch (e) {
				return {};
			}
		}

		function isPosQuantityLocked(productOrLine) {
			var settings = parseProductExtraSettings(productOrLine);
			return settings.is_quantity_locked === true ||
				settings.is_quantity_locked === 'true' ||
				settings.is_quantity_locked === 1 ||
				settings.is_quantity_locked === '1';
		}

		function prepareCheckoutProduct(product) {
			var item = angular.copy(product);
			item.product_price = parseFloat(item.product_price) || 0;
			item.total = parseFloat(item.total) || item.product_price;
			item.tax_value = parseFloat(item.tax_value) || 0;
			item.taxes = item.taxes || [];
			item.dynamic_attributes = item.dynamic_attributes || [];
			item.restaurant_attribute = item.restaurant_attribute || '0';
			item.extra_settings = parseProductExtraSettings(item);
			return item;
		}

		function loadPosProducts() {
			vm.isloading = true;
			createResService.getPosAvailableOnFe({}).then(function (response) {
				if (response && response.status === 'success' && angular.isArray(response.products)) {
					vm.allPosProducts = response.products.map(prepareCheckoutProduct);
				} else {
					vm.allPosProducts = [];
					if (response && response.errorMsg) {
						toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
					}
				}
				vm.curPage = 1;
				applyProductFilters();
				vm.isloading = false;
			}, function () {
				vm.allPosProducts = [];
				applyProductFilters();
				vm.isloading = false;
				toastMessage.showSimpleToast('Unable to load POS products.', 'error-toast');
			});
		}

		function applyProductFilters() {
			var search = getSearchText().toLowerCase();
			var filtered = (vm.allPosProducts || []).filter(function (product) {
				if (!search) {
					return true;
				}
				return (product.product_name && product.product_name.toLowerCase().indexOf(search) !== -1) ||
					(product.fe_display_product_name && product.fe_display_product_name.toLowerCase().indexOf(search) !== -1);
			});

			vm.totalProduct = filtered.length;
			vm.totalPages = Math.max(1, Math.ceil(vm.totalProduct / vm.dataPerPage));
			if (vm.curPage > vm.totalPages) {
				vm.curPage = vm.totalPages;
			}
			var offset = (vm.curPage - 1) * vm.dataPerPage;
			vm.categoryRelatedProducts = filtered.slice(offset, offset + vm.dataPerPage);
		}

		function clearSearch() {
			vm.search = '';
			vm.curPage = 1;
			applyProductFilters();
		}

		function isSeparateCartLine(item) {
			return item.product_is_timebound == 1 ||
				(item.ingredients && item.ingredients.length) ||
				(typeof item.restaurant_attribute !== 'undefined' && item.restaurant_attribute == 1);
		}

		function getCartLineCount(item) {
			if (isSeparateCartLine(item)) {
				return 1;
			}
			return parseInt(item.quantity, 10) || 1;
		}

		function isInCart(productId) {
			return getCartQty(productId) > 0;
		}

		function isQuantityLockedMaxed(product) {
			return isPosQuantityLocked(product) && isInCart(product.product_id);
		}

		function getCartQty(productId) {
			var total = 0;
			(vm.cartItem || []).forEach(function (item) {
				if (idEquals(item.product_id, productId)) {
					total += getCartLineCount(item);
				}
			});
			return total;
		}

		function hasVisibleCartItems() {
			return getReviewCartCount() > 0;
		}

		function isInsuranceLine(item) {
			if (!item) {
				return false;
			}
			if (item.extra_attribute === EXTRA_ATTR_INSURANCE) {
				return true;
			}
			return !!(vm.insuranceProductId && idEquals(item.product_id, vm.insuranceProductId));
		}

		function isPreservedPosLine(item) {
			return !!(item && PRESERVED_EXTRA_ATTRS[item.extra_attribute]);
		}

		function isSelectablePosLine(item) {
			return !!(item && !isPreservedPosLine(item) && !isInsuranceLine(item));
		}

		function partitionCartItems() {
			var preserved = [];
			var selectable = [];
			(vm.cartItem || []).forEach(function (item) {
				if (!item) {
					return;
				}
				if (isPreservedPosLine(item)) {
					preserved.push(item);
				} else if (!isInsuranceLine(item)) {
					selectable.push(item);
				}
			});
			return { preserved: preserved, selectable: selectable };
		}

		function getPosItemsForSession() {
			return partitionCartItems().selectable;
		}

		/** All non-insurance POS lines (includes resort fee, extra person, surcharge). */
		function getPosItemsForInsuranceBase() {
			return (vm.cartItem || []).filter(function (item) {
				return item && !isInsuranceLine(item);
			});
		}

		function buildPosListForSession() {
			var parts = partitionCartItems();
			return parts.preserved.concat(parts.selectable);
		}

		function getReviewCartCount() {
			var count = 0;
			(vm.cartItem || []).forEach(function (item) {
				if (isSelectablePosLine(item)) {
					count++;
				}
			});
			return count;
		}

		function getSelectedPosSubtotal() {
			var sum = 0;
			(vm.cartItem || []).forEach(function (item) {
				if (!isSelectablePosLine(item)) {
					return;
				}
				var price = safeNumber(item.particularCustomPrice || item.customPrice);
				var qty = parseInt(item.quantity, 10) || 1;
				sum += price * qty;
			});
			return commonService.roundnum(sum, 2);
		}

		function flashAddedProduct(productId) {
			vm.flashProductId = productId;
			$timeout(function () {
				vm.flashProductId = null;
			}, 350);
		}

		function getProductImageUrl(product) {
			if (product.image) {
				return product.image;
			}
			if (product.media) {
				return vm.baseUrl + 'assets/uploads/activities/thumbnail/' + product.media;
			}
			return vm.baseUrl + 'assets/uploads/product/room-service.svg';
		}

		function getSearchText() {
			return (vm.search || '').replace(/^\s+|\s+$/g, '');
		}

		function cancel() {
			$mdDialog.cancel();
		}

		function getToolbarTitle() {
			return vm.footerStep === 'insurance' ? 'Add Insurance' : 'Choose Add-Ons';
		}

		function isStepperStepActive(stepNum) {
			var cfg = STEP_CONFIG[stepNum];
			return !!(cfg && vm.footerStep === cfg.footerKey);
		}

		function isStepperStepComplete(stepNum) {
			return stepNum === 1 && vm.footerStep === 'insurance';
		}

		function isStepperStepClickable(stepNum) {
			var cfg = STEP_CONFIG[stepNum];
			if (!cfg || !vm.hasInsuranceProduct || vm.applying || vm.insuranceLoading) {
				return false;
			}
			return vm.footerStep !== cfg.footerKey;
		}

		function onStepperStepClick(stepNum) {
			if (!isStepperStepClickable(stepNum)) {
				return;
			}
			STEP_CONFIG[stepNum].goTo();
		}

		function getStepperLabel(stepNum) {
			if (stepNum !== 1) {
				return 'Add insurance';
			}
			if (vm.footerStep !== 'insurance') {
				return 'Choose add-ons';
			}
			var count = getReviewCartCount();
			if (count <= 0) {
				return 'Add-ons reviewed';
			}
			return count + ' add-on' + (count === 1 ? '' : 's') + ' selected';
		}

		function getInsuranceDisplayName() {
			return (vm.insuranceProductData && vm.insuranceProductData.product_name) || DEFAULT_INSURANCE_NAME;
		}

		function getDaysUntilCheckin() {
			var checkin = vm.summary.cartdetails && vm.summary.cartdetails.from;

			if (!checkin) {
				return null;
			}

			return moment(checkin).startOf('day').diff(moment().startOf('day'), 'days');
		}

		function showInsurance7DayCancelPolicy() {
			var daysUntilCheckin = getDaysUntilCheckin();

			return daysUntilCheckin === null || daysUntilCheckin > INSURANCE_CANCEL_POLICY_DAYS;
		}

		function getRoomCart() {
			var carts = $sessionStorage[cartStorageKey];
			var idx = getRoomIdx();
			if (!carts || carts === '' || !carts[idx]) {
				return null;
			}
			return carts[idx];
		}

		function loadCartItemsForRoom() {
			vm.cartItem = [];
			vm.cartItemIds = [];
			var roomCart = angular.copy(summaryCartdetails);
			if (!roomCart) {
				return;
			}
			if (roomCart.pos && roomCart.pos.length) {
				vm.cartItem = angular.copy(roomCart.pos);
				vm.cartItemIds = vm.cartItem.map(function (item) {
					return item.product_id;
				});
				syncCartLineTotals();
			}
		}

		function prepareCartForTotals(cart) {
			cart.pageFrom = cart.pageFrom || 'reservation';
			if (cart.addReservation === undefined) {
				cart.addReservation = true;
			}
			return cart;
		}

		function normalizePosDates(posItem) {
			if (posItem.product_is_timebound == 1) {
				posItem.nightlySum = commonService.roundnum(
					parseFloat(posItem.particularCustomPrice) * posItem.quantity, 2
				);
				posItem.quantity = 1;
			}
			if (posItem.dynamic_attributes && posItem.dynamic_attributes.length) {
				posItem.dynamic_attributes.forEach(function (attr) {
					if (attr.type === 'date' && attr.value) {
						attr.value = moment(attr.value).format('YYYY-MM-DD');
					}
				});
			}
		}

		function normalizePosList(cart) {
			if (!cart.pos) {
				cart.pos = [];
				return cart;
			}
			cart.pos.forEach(function (element, index) {
				normalizePosDates(element);
				cart.pos[index] = commonService.calculatePOSTotals(index, false, cart, '');
			});
			return cart;
		}

		function recalculateCart(cart) {
			return commonService.calculateTotals(
				prepareCartForTotals(cart),
				vm.addRoomInItin,
				vm.multipleNightPolicies
			);
		}

		function mutateRoomCartStorage(updater) {
			var cartStorage = $sessionStorage[cartStorageKey];
			var idx = getRoomIdx();
			if (!cartStorage || cartStorage === '' || typeof cartStorage[idx] === 'undefined') {
				return false;
			}
			updater(cartStorage[idx], cartStorage);
			cartStorage[idx] = recalculateCart(isolateRoomSnapshot(cartStorage[idx]));
			$sessionStorage[cartStorageKey] = cartStorage;
			return true;
		}

		function isolateRoomSnapshot(room) {
			if (!room) {
				return room;
			}
			var isolated = angular.copy(room);
			isolated.pos = angular.isArray(room.pos) && room.pos.length ? angular.copy(room.pos) : [];
			return isolated;
		}

		function persistPosToSession() {
			mutateRoomCartStorage(function (roomCart) {
				roomCart.pos = angular.copy(buildPosListForSession());
				normalizePosList(roomCart);
				roomCart.pos = angular.copy(roomCart.pos);
			});
		}

		function safeNumber(val) {
			var n = parseFloat(val);
			return isNaN(n) ? 0 : n;
		}

		function roundMoney(val) {
			return safeNumber(commonService.roundnum(safeNumber(val), 2));
		}

		function loadInsuranceProduct() {
			vm.insuranceLoading = true;
			createResService.getInsuranceProduct(hotelId).then(function (response) {
				if (response && response.status === 'success' &&
					response.data && response.data.length > 0) {
					vm.insuranceProductData = response.data[0];
					vm.insuranceProductId = vm.insuranceProductData.product_id;
					vm.hasInsuranceProduct = true;
					initInsuranceOptIn();
				} else {
					vm.hasInsuranceProduct = false;
				}
				stripInsuranceFromCartItems();
				syncCartLineTotals();
				refreshInsurancePrice();
				vm.insuranceLoading = false;
			}, function () {
				vm.hasInsuranceProduct = false;
				stripInsuranceFromCartItems();
				syncCartLineTotals();
				vm.insuranceLoading = false;
			});
		}

		function stripInsuranceFromCartItems() {
			vm.cartItem = (vm.cartItem || []).filter(function (item) {
				return item && !isInsuranceLine(item);
			});
			vm.cartItemIds = vm.cartItem.map(function (item) {
				return item.product_id;
			});
		}

		function calculateInsurancePrice() {
			if (!vm.insuranceProductData) {
				return 0;
			}
			var roomCart = getRoomCart();
			if (!roomCart) {
				return 0;
			}
			var settings = vm.insuranceProductData.extra_settings || {};
			var pct = safeNumber(vm.insuranceProductData.product_price);
			var percentageOf = String(settings.percentage_of || 'per_room_grand_total').toLowerCase();
			var pickAmount = function (source) {
				if (percentageOf === 'per_room_subtotal' || percentageOf === 'subtotal') {
					return safeNumber(source.subtotal != null ? source.subtotal : source.nightlySum);
				}
				return safeNumber(source.grand_total);
			};

			var base = pickAmount(roomCart);
			getPosItemsForInsuranceBase().forEach(function (posItem) {
				base += pickAmount(posItem);
			});
			return roundMoney((base * pct) / 100);
		}

		function buildInsuranceTaxes(subtotalPrice) {
			var taxes = [];
			var totalTaxAmount = 0;
			var subtotal = safeNumber(subtotalPrice);

			if (vm.insuranceProductData &&
				vm.insuranceProductData.taxes &&
				vm.insuranceProductData.taxes.length) {
				angular.forEach(vm.insuranceProductData.taxes, function (taxObj) {
					var taxPercent = parseFloat(taxObj.tax_value || 0);
					var taxAmount = roundMoney((subtotal * taxPercent) / 100);
					totalTaxAmount += taxAmount;
					taxes.push({
						tax_id: taxObj.tax_id,
						tax_name: taxObj.tax_name,
						tax_value: taxPercent,
						tax: taxAmount,
						tax_amt: taxAmount,
						orig_tax_value: taxAmount
					});
				});
			}

			return {
				taxes: taxes,
				totalTaxAmount: roundMoney(totalTaxAmount)
			};
		}

		function persistInsuranceSubtotal(subtotal, grandTotal) {
			var cart = $sessionStorage[cartStorageKey];
			var idx = getRoomIdx();
			if (cart && cart[idx] !== undefined) {
				cart[idx].insuranceSubtotal = roundMoney(subtotal);
				cart[idx].insuranceGrandTotal = roundMoney(grandTotal);
			}
		}

		function removeInsuranceFromPos(posList) {
			if (!posList || !posList.length) {
				return;
			}
			for (var i = posList.length - 1; i >= 0; i--) {
				if (isInsuranceLine(posList[i])) {
					posList.splice(i, 1);
				}
			}
		}

		function refreshInsurancePrice() {
			var subtotal = roundMoney(calculateInsurancePrice());
			vm.insuranceSubtotal = subtotal;
			var taxResult = buildInsuranceTaxes(subtotal);
			vm.insuranceTaxLines = taxResult.taxes;
			vm.insuranceGrandTotal = (vm.insuranceOptIn && subtotal > 0) ?
				roundMoney(subtotal + taxResult.totalTaxAmount) : 0;
		}

		function onInsuranceOptInChange() {
			refreshInsurancePrice();
			updateReservationSummary();
		}

		function onInsuranceChoiceChange() {
			vm.insuranceOptIn = vm.insuranceChoice === 'yes';
			onInsuranceOptInChange();
		}

		function setInsuranceChoice(choice) {
			vm.insuranceChoice = choice;
			onInsuranceChoiceChange();
		}

		function buildInsurancePosLine(subtotal) {
			subtotal = roundMoney(subtotal);
			var taxResult = buildInsuranceTaxes(subtotal);
			var grandTotal = roundMoney(subtotal + taxResult.totalTaxAmount);
			var roomCart = getRoomCart();
			var fromDate = moment(roomCart.from).format('MM/DD/YYYY');
			var toDate = moment(roomCart.to).format('MM/DD/YYYY');

			return {
				product_id: vm.insuranceProductId,
				product_name: vm.insuranceProductData.product_name,
				product_type: 'pos',
				product_is_timebound: 0,
				quantity: 1,
				product_price: subtotal,
				customPrice: subtotal,
				particularCustomPrice: subtotal,
				product_discount: 0,
				nightlySum: subtotal,
				subtotal: subtotal,
				grand_total: grandTotal,
				tax: taxResult.totalTaxAmount,
				tax_amt: taxResult.totalTaxAmount,
				tax_value: taxResult.totalTaxAmount,
				orig_tax_value: taxResult.totalTaxAmount,
				tax_name: (vm.insuranceProductData.tax_name || ''),
				remaining_amount: grandTotal,
				extra_attribute: 'insurance',
				from: fromDate,
				to: toDate,
				room_stay_from: fromDate,
				room_stay_to: toDate,
				prices: { rates: [subtotal], nightlydiscount: [0], nightlydiscountcomment: [''], dates: {} },
				taxes: taxResult.taxes,
				pos_deposit_type_indicator: 'zero',
				pos_deposit_amount: 0
			};
		}

		function applyInsuranceToSessionCart() {
			mutateRoomCartStorage(function (roomCart) {
				if (!roomCart.pos) {
					roomCart.pos = [];
				}
				removeInsuranceFromPos(roomCart.pos);

				if (vm.insuranceOptIn && vm.insuranceProductId) {
					refreshInsurancePrice();
					roomCart.pos.push(buildInsurancePosLine(vm.insuranceSubtotal));
					persistInsuranceSubtotal(vm.insuranceSubtotal, vm.insuranceGrandTotal);
				} else {
					persistInsuranceSubtotal(0, 0);
				}

				roomCart.isInsuranceSelected = vm.insuranceOptIn === true;
			});
		}

		function getPrimaryFooterLabel() {
			if (vm.applying) {
				return 'Adding…';
			}
			if (vm.footerStep === 'pos' && vm.hasInsuranceProduct) {
				return 'Continue';
			}
			return 'Finish';
		}

		function isPrimaryFooterDisabled() {
			if (vm.applying || vm.insuranceLoading) {
				return true;
			}
			if (vm.footerStep === 'insurance' && vm.hasInsuranceProduct && !vm.insuranceChoice) {
				return true;
			}
			return false;
		}

		function handlePrimaryFooterClick() {
			if (vm.footerStep === 'pos' && vm.hasInsuranceProduct) {
				continueToInsurance();
				return;
			}
			applyPos();
		}

		function continueToInsurance() {
			if (vm.insuranceLoading || !vm.hasInsuranceProduct) {
				applyPos();
				return;
			}
			vm.footerStep = 'insurance';
			$timeout(function () {
				vm.step = 'insurance';
				persistPosToSession();
				refreshInsurancePrice();
				updateReservationSummary();
			}, 0);
		}

		function goBackToPos() {
			vm.footerStep = 'pos';
			$timeout(function () {
				vm.step = 'pos';
				updateReservationSummary();
			}, 0);
		}

		function applyPos() {
			vm.applying = true;
			persistPosToSession();
			if (vm.hasInsuranceProduct) {
				applyInsuranceToSessionCart();
			} else {
				mutateRoomCartStorage(function (roomCart) {
					removeInsuranceFromPos(roomCart.pos);
					roomCart.isInsuranceSelected = false;
				});
			}
			vm.applying = false;
			$mdDialog.hide({
				cartIndex: getRoomIdx(),
				posAdded: true,
				insuranceOptIn: vm.hasInsuranceProduct ? vm.insuranceOptIn : false,
				insuranceSubtotal: vm.insuranceSubtotal
			});
		}

		function filterProducts() {
			vm.curPage = 1;
			applyProductFilters();
		}

		function switchPage(status) {
			if (status === 'back') {
				vm.curPage = parseInt(vm.curPage, 10) - 1;
			} else if (status === 'forward') {
				vm.curPage = parseInt(vm.curPage, 10) + 1;
			}
			applyProductFilters();
		}

		function showPosOverlayToast(content) {
			$mdToast.show(
				$mdToast.simple()
					.textContent(content)
					.position('top right')
					.hideDelay(3500)
			);
		}

		function onProductCardClick($event, product) {
			if ($event) {
				$event.stopPropagation();
				$event.preventDefault();
			}
			if (isQuantityLockedMaxed(product)) {
				showPosOverlayToast(
					'Only one of "' + (product.fe_display_product_name || product.product_name) + '" can be added.'
				);
				return;
			}
			addToCart(product);
		}

		function addToCart(product, updateIndexValue) {
			if (isQuantityLockedMaxed(product)) {
				showPosOverlayToast(
					'Only one of "' + (product.fe_display_product_name || product.product_name) + '" can be added.'
				);
				return;
			}
			if (product.product_is_timebound == 1 || (product.dynamic_attribute == 1 && product.dynamic_attributes.length > 0)) {
				getDaterange(product, updateIndexValue);
			} else if (product.product_pos_type === staticRestValue || (product.restaurant_attribute !== undefined && product.restaurant_attribute === '1')) {
				fetchRestaurantIngrediants(product, updateIndexValue);
			} else {
				addProductToCart(product, 1, '', '', '', '');
			}
		}

		function fetchRestaurantIngrediants(product, updateIndexValue) {
			checkoutService.getRestaurantIngrediants(product.product_id).then(function (res) {
				if ((res.ingredients !== undefined && res.ingredients.length) ||
					(res.restaurant_attributes !== undefined && Object.keys(res.restaurant_attributes).length)) {
					product.restaurant_attributes = res.restaurant_attributes;
					product.ingredients = res.ingredients;
					getDaterange(product, updateIndexValue);
				} else {
					addProductToCart(product, 1, '', '', '', '');
				}
			});
		}

		function getDaterange(product, updateIndexValue) {
			var temp_product = angular.copy(product);
			$mdDialog.show({
				controller: 'customSale',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/checkout/dialog/posProduct.html',
				parent: angular.element($document.find('md-dialog.pos-options-overlay-dialog')),
				scope: $scope.$new(),
				clickOutsideToClose: true,
				multiple: true,
				locals: {
					tax: [],
					product: temp_product,
					pageDetails: vm.resDetails,
					taxValue: vm.resDetails.taxValue,
					updateIndexValue: updateIndexValue
				}
			});
		}

		function findIncrementableCartIndex(productId) {
			for (var i = 0; i < vm.cartItem.length; i++) {
				var line = vm.cartItem[i];
				if (idEquals(line.product_id, productId) && !isSeparateCartLine(line)) {
					return i;
				}
			}
			return -1;
		}

		function shouldAddNewCartLine(product, itemIndex, status) {
			if (status === 'update') {
				return false;
			}
			if (itemIndex === -1) {
				return true;
			}
			if (safeNumber(product.product_price) !== safeNumber(vm.cartItem[itemIndex].product_price)) {
				return true;
			}
			return isSeparateCartLine(product);
		}

		function applyTimeboundPricing(cartPro, from, to) {
			cartPro.from = moment(from).format('YYYY-MM-DD');
			cartPro.to = moment(to).format('YYYY-MM-DD');
			cartPro.prices = angular.copy(getDates(from, to, cartPro.particularCustomPrice));
			cartPro.prices.nightlydiscount = [];
			cartPro.prices.nightlydiscountcomment = [];
			var perNightPrice = cartPro.customPrice;
			cartPro.prices.rates.forEach(function (_rate, rIndex) {
				cartPro.prices.nightlydiscountcomment.push('');
				cartPro.prices.nightlydiscount.push($filter('number')(0, 2));
				if (rIndex !== 0) {
					cartPro.customPrice += perNightPrice;
					cartPro.particularCustomPrice += perNightPrice;
				}
			});
		}

		function createNewCartLine(product, quantity, from, to) {
			var cartPro = angular.copy(product);
			var price = safeNumber(cartPro.product_price);
			var total = safeNumber(cartPro.total);

			cartPro.customPrice = price;
			cartPro.particularCustomPrice = price;
			cartPro.addOnPrice = 0;
			cartPro.customDiscount = 0;
			cartPro.customDiscountPercentage = 0;
			cartPro.quantity = isPosQuantityLocked(product) ? 1 :
				(typeof product.quantity !== 'undefined' ? product.quantity : quantity);
			cartPro.total = total;
			cartPro.tax = 0;
			cartPro.product_discount = 0;
			cartPro.product_discount_comment = '';
			cartPro.discountPer = 0;
			cartPro.discountAmt = 0;
			cartPro.pos_deposit_type_indicator = 'zero';
			cartPro.pos_deposit_amount = 0;
			cartPro.remaining_amount = total;
			cartPro.grand_total = total;
			cartPro.additional_guest_amounts = 0;
			cartPro.original_deposit_amt = 0;
			cartPro.nightlySum = commonService.roundnum(price, 2);

			if (product.product_is_timebound == 1) {
				applyTimeboundPricing(cartPro, from, to);
			}

			delete cartPro.$$hashKey;
			return cartPro;
		}

		function bumpExistingCartLine(itemIndex, product, quantity, from, to) {
			if (isPosQuantityLocked(product)) {
				return;
			}
			var line = vm.cartItem[itemIndex];
			if (product.product_is_timebound == 1) {
				line.customPrice = line.product_price;
				line.particularCustomPrice = line.product_price;
				line.quantity = quantity;
				line.from = moment(from).format('YYYY-MM-DD');
				line.to = moment(to).format('YYYY-MM-DD');
				line.prices = angular.copy(getDates(from, to, line.particularCustomPrice));
			} else {
				line.quantity = (parseInt(line.quantity, 10) || 0) + 1;
			}
			moveLineToFront(itemIndex);
		}

		function moveLineToFront(itemIndex) {
			var line = angular.copy(vm.cartItem[itemIndex]);
			vm.cartItem.splice(itemIndex, 1);
			vm.cartItemIds.splice(itemIndex, 1);
			vm.cartItem.unshift(line);
			vm.cartItemIds.unshift(line.product_id);
		}

		function addProductToCart(product, quantity, from, to, index, status) {
			if (isPosQuantityLocked(product) && status !== 'update') {
				var lockedIndex = findIncrementableCartIndex(product.product_id);
				if (lockedIndex !== -1) {
					return;
				}
				quantity = 1;
			}

			var itemIndex = (index !== '' && index !== undefined && index !== null) ?
				index : findIncrementableCartIndex(product.product_id);

			if (shouldAddNewCartLine(product, itemIndex, status)) {
				vm.cartItem.unshift(createNewCartLine(product, quantity, from, to));
				vm.cartItemIds.unshift(product.product_id);
			} else {
				bumpExistingCartLine(itemIndex, product, quantity, from, to);
			}

			syncCartLineTotals();
			flashAddedProduct(product.product_id);
		}

		function getDates(startDate, stopDate, price) {
			var dateArray = [];
			var currentDate = moment(startDate);
			var endDate = moment(stopDate);
			var priceArray = [];
			while (currentDate < endDate) {
				dateArray.push(moment(currentDate).format('DD/MM/YYYY'));
				currentDate = moment(currentDate).add(1, 'days');
				priceArray.push(commonService.roundnum(price, 2));
			}
			return { dates: dateArray, rates: priceArray };
		}

		function syncCartLineTotals() {
			var userTaxExempt = !!vm.resDetails.taxValue;

			vm.cartItem.forEach(function (element) {
				var customPrice = safeNumber(element.customPrice);
				var customDiscount = safeNumber(element.customDiscount);
				var qty = parseInt(element.quantity, 10) || 1;
				var taxableAmount = customPrice - customDiscount;
				var totalTax = 0;

				if (element.taxes && element.taxes.length > 0) {
					angular.forEach(element.taxes, function (tax) {
						if (typeof tax.tax_id === 'undefined') {
							return;
						}
						var amount = userTaxExempt ? 0 : safeNumber(
							commonService.roundnum((tax.tax_value * taxableAmount) / 100, 2)
						);
						tax.tax_amount = amount;
						tax.tax_amt = amount;
						tax.tax = amount;
						totalTax += amount;
					});
				}

				var remaining = commonService.roundnum((taxableAmount + totalTax) * qty, 2);
				element.tax = commonService.roundnum(totalTax * qty, 2);
				element.product_discount = commonService.roundnum(customDiscount * qty, 2);
				element.pos_deposit_type_indicator = 'zero';
				element.pos_deposit_amount = 0;
				element.remaining_amount = remaining;
				element.grand_total = remaining;
				element.nightlySum = commonService.roundnum(safeNumber(element.particularCustomPrice || element.customPrice), 2);
			});

			if (vm.step === 'insurance' && vm.hasInsuranceProduct) {
				refreshInsurancePrice();
			}
			updateReservationSummary();
		}

		function parseMoney(value) {
			if (value === undefined || value === null || value === '') {
				return NaN;
			}
			if (typeof value === 'number') {
				return value;
			}
			return parseFloat(String(value).replace(/,/g, ''));
		}

		function setOverlaySummaryTotals(totals) {
			$scope.overlaySummaryTotals = {
				grand_total: totals.grand_total,
				deposit_amount: totals.deposit_amount,
				remaining_amount: totals.remaining_amount
			};
			vm.overlaySummaryTotals = $scope.overlaySummaryTotals;
		}

		function resolveDisplayGrandTotal(cartdetails) {
			var totals = cartdetails.overalltotals || {};
			var grand = parseMoney(totals.grand_total);

			if (isNaN(grand) || grand <= 0) {
				grand = parseMoney(cartdetails.total_amount);
			}
			if (isNaN(grand) || grand <= 0) {
				var sub = parseMoney(totals.subtotal) || 0;
				var disc = parseMoney(totals.product_discount) || 0;
				var tax = parseMoney(totals.tax) || 0;
				var surcharge = parseMoney(totals.surcharge) || 0;
				grand = sub - disc + tax + surcharge;
			}
			if (isNaN(grand) || grand <= 0) {
				var roomGrand = parseMoney(cartdetails.grand_total) || 0;
				var posGrand = 0;
				(cartdetails.pos || []).forEach(function (posItem) {
					if (posItem && posItem.grand_total !== undefined && posItem.grand_total !== '') {
						posGrand += parseMoney(posItem.grand_total) || 0;
					}
				});
				grand = roomGrand + posGrand;
			}

			return isNaN(grand) ? 0 : grand;
		}

		function resolveDisplayDueAmount(cartdetails, grand, deposit) {
			var totals = cartdetails.overalltotals || {};
			var due = parseMoney(totals.remaining_amount);

			if (!isNaN(due) && due > 0) {
				return due;
			}

			if (cartdetails.room_deposit_type_indicator) {
				return grand - deposit;
			}
			if (cartdetails.hasOwnProperty('paid_amount')) {
				var paid = parseMoney(cartdetails.paid_amount);
				return grand - (isNaN(paid) ? 0 : paid);
			}

			return isNaN(due) ? grand : due;
		}

		function applySummaryTotals(cartdetails) {
			if (!cartdetails || !cartdetails.overalltotals) {
				setOverlaySummaryTotals({
					grand_total: 0,
					deposit_amount: 0,
					remaining_amount: 0
				});
				return;
			}

			var totals = cartdetails.overalltotals;
			var grand = resolveDisplayGrandTotal(cartdetails);
			var deposit = parseMoney(totals.deposit_amount);

			if (isNaN(deposit)) {
				deposit = 0;
			}

			var due = resolveDisplayDueAmount(cartdetails, grand, deposit);
			if (due < 0) {
				due = 0;
			}

			totals.grand_total = parseFloat(commonService.roundnum(grand, 2));
			totals.remaining_amount = parseFloat(commonService.roundnum(due, 2));
			totals.deposit_amount = parseFloat(commonService.roundnum(deposit, 2));

			setOverlaySummaryTotals({
				grand_total: totals.grand_total,
				deposit_amount: totals.deposit_amount,
				remaining_amount: totals.remaining_amount
			});
		}

		function findInsurancePosIndex(posList) {
			if (!posList || !posList.length) {
				return -1;
			}
			for (var i = 0; i < posList.length; i++) {
				if (isInsuranceLine(posList[i])) {
					return i;
				}
			}
			return -1;
		}

		function initInsuranceOptIn() {
			var roomCart = getRoomCart();
			if (roomCart && roomCart.isInsuranceSelected === true) {
				vm.insuranceOptIn = true;
				vm.insuranceChoice = 'yes';
				return;
			}
			vm.insuranceOptIn = false;
			vm.insuranceChoice = null;
		}

		function finalizeInsuranceOnPreviewCart(cart) {
			var insIdx = findInsurancePosIndex(cart.pos);
			if (insIdx === -1) {
				return cart;
			}
			var insPos = cart.pos[insIdx];
			var insTax = safeNumber(insPos.tax_value);
			if (!insTax && insPos.taxes && insPos.taxes.length) {
				insPos.taxes.forEach(function (tax) {
					insTax += safeNumber(tax.tax_amt || tax.tax);
				});
			}
			insPos.grand_total = parseFloat(commonService.roundnum(safeNumber(insPos.subtotal || insPos.nightlySum) + insTax, 2));
			insPos.tax = insPos.tax_amt = insTax;
			insPos.pos_deposit_amount = 0;
			return recalculateCart(cart);
		}

		function buildPreviewCartForSummary() {
			var idx = getRoomIdx();
			var storageCart = $sessionStorage[cartStorageKey];
			var previewCart = angular.copy(summaryCartdetails);
			if (storageCart && storageCart !== '' && storageCart[idx]) {
				var sessionRoom = angular.copy(storageCart[idx]);
				previewCart.product_id = sessionRoom.product_id;
				previewCart.product_name = sessionRoom.product_name;
				previewCart.product_room_number = sessionRoom.product_room_number;
				previewCart.from = sessionRoom.from;
				previewCart.to = sessionRoom.to;
				previewCart.selelected_policy_id = sessionRoom.selelected_policy_id;
				previewCart.customerTaxExempt = sessionRoom.customerTaxExempt;
				previewCart.travellerTaxExempt = sessionRoom.travellerTaxExempt;
				previewCart.room_deposit_type_indicator = sessionRoom.room_deposit_type_indicator;
				previewCart.taxes = angular.copy(sessionRoom.taxes);
				previewCart.prices = angular.copy(sessionRoom.prices);
				previewCart.overalltotals = angular.copy(sessionRoom.overalltotals);
				previewCart.promoCodeDiscount = sessionRoom.promoCodeDiscount;
				previewCart.promoCodeName = sessionRoom.promoCodeName;
				previewCart.resortFeeApplied = sessionRoom.resortFeeApplied;
				previewCart.resortFeePos = sessionRoom.resortFeePos;
				previewCart.extraPersonProduct = sessionRoom.extraPersonProduct;
			}
			previewCart.pos = angular.copy(buildPosListForSession()) || [];
			normalizePosList(prepareCartForTotals(previewCart));
			if (vm.step === 'insurance' && vm.hasInsuranceProduct) {
				refreshInsurancePrice();
				if (vm.insuranceOptIn) {
					previewCart.pos.push(buildInsurancePosLine(vm.insuranceSubtotal));
				}
			}
			return previewCart;
		}

		function updateReservationSummary() {
			var previewCart = buildPreviewCartForSummary();
			if (!previewCart) {
				return;
			}
			var calculated = recalculateCart(previewCart);
			if (vm.step === 'insurance' && vm.insuranceOptIn && vm.hasInsuranceProduct) {
				calculated = finalizeInsuranceOnPreviewCart(calculated);
			}
			vm.summary.cartdetails = calculated;
			applySummaryTotals(calculated);
		}

		function canAdjustCartQuantity(item) {
			return !!(item && item.product_is_timebound == 0 && !isPosQuantityLocked(item));
		}

		function incrementCartItem(index) {
			var item = vm.cartItem[index];
			if (!item || !canAdjustCartQuantity(item)) {
				return;
			}
			item.quantity = (parseInt(item.quantity, 10) || 1) + 1;
			syncCartLineTotals();
		}

		function decrementCartItem(index) {
			var item = vm.cartItem[index];
			if (!item) {
				return;
			}
			if (canAdjustCartQuantity(item)) {
				var qty = parseInt(item.quantity, 10) || 1;
				if (qty <= 1) {
					removeCartItem(index);
				} else {
					item.quantity = qty - 1;
					syncCartLineTotals();
				}
				return;
			}
			removeCartItem(index);
		}

		function removeCartItem(index) {
			vm.cartItemIds.splice(index, 1);
			vm.cartItem.splice(index, 1);
			syncCartLineTotals();
		}

		function emptyCart() {
			var kept = [];
			var keptIds = [];
			(vm.cartItem || []).forEach(function (item) {
				if (isPreservedPosLine(item)) {
					kept.push(item);
					keptIds.push(item.product_id);
				}
			});
			vm.cartItem = kept;
			vm.cartItemIds = keptIds;
			syncCartLineTotals();
		}
	}
})();

(function ()
{
    'use strict';

    angular.module('app.create-res')
        .controller('discountCommentController', discountCommentController);

    /** @ngInject */
    function discountCommentController(
    	EnvironmentConfig, 
    	$mdDialog, 
    	oldcomment,
    	oldAmount,
    	price,
    	type,
    	commonService)
    {
		var vm = this;
		if(type != undefined) {}
		vm.type = (type != undefined) ? type : '';
	    vm.showCommentError = false;
		vm.syncing = false;
		
		// Data
		vm.data = {};
		if( (oldcomment!='' && typeof oldcomment!='undefined') || ( typeof oldAmount!='undefined' && oldAmount!='' && oldAmount > 0) ){
			vm.data.comment = oldcomment;
			vm.data.amount = oldAmount;
			vm.title = 'Edit Discount';
		}else{
			vm.title = 'Apply Discount';
		}

		if (vm.type === 'nightly_discount' && price && parseFloat(price) > 0 && vm.data.amount) {
			vm.data.percent = commonService.roundnum((parseFloat(vm.data.amount) / parseFloat(price)) * 100, 2);
		}

		function hasDiscount() {
			return parseFloat(vm.data.amount) > 0 || parseFloat(vm.data.percent) > 0;
		}

		// Step 2 (select nights) - only when the caller passes nights via bindToController
		vm.step = 1;
		vm.applyToOtherNights = false;
		vm.applyMode = 'all';
		vm.selectedNights = {};
		var lastEdited = 'amount';
		var nightsInitialized = false;
		var enabledNights = angular.isArray(vm.nights) ? vm.nights.filter(function (night) {
			return !night.disabled;
		}) : [];
		vm.multiNight = vm.type === 'nightly_discount' && enabledNights.length > 1 && parseFloat(price) > 0;
		vm.enabledNightsCount = enabledNights.length;

		// Long stays use the caller's week/month groups, with the same night limits as the order page
		var nightTotal = angular.isArray(vm.nights) ? vm.nights.length : 0;
		vm.groupType = '';
		if (vm.multiNight && vm.nightGroups) {
			vm.groupType = nightTotal > 31 ? 'month' : (nightTotal >= 7 ? 'week' : '');
		}
		vm.openGroups = {};
		vm.nightsByIndex = {};
		if (nightTotal > 0) {
			vm.nights.forEach(function (night) {
				vm.nightsByIndex[night.index] = night;
			});
		}

		//Methods
		vm.closeDialog = closeDialog;
		vm.hideDialog = hideDialog;
		vm.onAmountChange = onAmountChange;
		vm.onPercentChange = onPercentChange;
		vm.checkReason = checkReason;
		vm.backToDiscount = backToDiscount;
		vm.toggleNight = toggleNight;
		vm.toggleAllNights = toggleAllNights;
		vm.allNightsSelected = allNightsSelected;
		vm.selectedCount = selectedCount;
		vm.changedCount = changedCount;
		vm.toggleGroup = toggleGroup;
		vm.getGroupSelectedCount = getGroupSelectedCount;
		vm.isGroupSelected = isGroupSelected;
		vm.isGroupPartlySelected = isGroupPartlySelected;
		vm.groupHasNights = groupHasNights;
		vm.toggleGroupNights = toggleGroupNights;
		vm.onGroupKeypress = onGroupKeypress;
		vm.getTableNights = getTableNights;
		vm.getShownDiscount = getShownDiscount;
		vm.isNightDiscountChanging = isNightDiscountChanging;
		vm.getNightsSummary = getNightsSummary;
		vm.applyToNights = applyToNights;
		vm.isContinueDisabled = isContinueDisabled;
		vm.getContinueLabel = getContinueLabel;

       /**
	   * Close dialog
	   */
	    function hideDialog(){
  	    	if((vm.data.comment == '' || !vm.data.comment) && hasDiscount()) {
  	    		vm.showCommentError = true;
  	    	} else if (isApplyingToAllNights()) {
  	    		saveNights(getAllChangedNights());
  	    	} else if (vm.multiNight && vm.applyToOtherNights) {
  	    		showNights();
  	    	} else {
              	$mdDialog.hide(vm.data);
  	    	}
      }

      /*
      **  Slide to the night selection step
      */
      function showNights() {
      	if (!nightsInitialized) {
      		vm.selectedNights[vm.currentNightIndex] = true;
      		nightsInitialized = true;
      		openCurrentNightGroup();
      	}
      	vm.step = 2;
      }

      function groupHasCurrentNight(items) {
      	return Object.prototype.hasOwnProperty.call(items, vm.currentNightIndex);
      }

      // Start with the clicked night visible
      function openCurrentNightGroup() {
      	if (vm.groupType === 'week') {
      		Object.keys(vm.nightGroups).forEach(function (weekName) {
      			if (groupHasCurrentNight(vm.nightGroups[weekName])) {
      				vm.openGroups[weekName] = true;
      			}
      		});
      	} else if (vm.groupType === 'month') {
      		Object.keys(vm.nightGroups).forEach(function (monthName) {
      			Object.keys(vm.nightGroups[monthName]).forEach(function (weekName) {
      				if (groupHasCurrentNight(vm.nightGroups[monthName][weekName])) {
      					vm.openGroups[monthName] = true;
      					vm.openGroups[weekName + monthName] = true;
      				}
      			});
      		});
      	}
      }

      function toggleGroup(key) {
      	vm.openGroups[key] = !vm.openGroups[key];
      }

      // Selectable nights of a week ({ nightIndex: date }) or a month ({ weekName: week })
      function getGroupNights(group) {
      	return Object.keys(group).reduce(function (nights, key) {
      		if (angular.isObject(group[key])) {
      			return nights.concat(getGroupNights(group[key]));
      		}
      		var night = vm.nightsByIndex[key];
      		return night && !night.disabled ? nights.concat(night) : nights;
      	}, []);
      }

      function getGroupSelectedCount(group) {
      	return getGroupNights(group).filter(function (night) {
      		return vm.selectedNights[night.index];
      	}).length;
      }

      function groupHasNights(group) {
      	return getGroupNights(group).length > 0;
      }

      function isGroupSelected(group) {
      	return groupHasNights(group) && getGroupSelectedCount(group) === getGroupNights(group).length;
      }

      function isGroupPartlySelected(group) {
      	return getGroupSelectedCount(group) > 0 && !isGroupSelected(group);
      }

      // The checkbox sits inside the header, so the click must not expand or collapse the group
      function toggleGroupNights(event, group) {
      	event.stopPropagation();
      	var selectAll = !isGroupSelected(group);
      	getGroupNights(group).forEach(function (night) {
      		vm.selectedNights[night.index] = selectAll;
      	});
      }

      // md-checkbox does not run ng-click for the keyboard
      function onGroupKeypress(event, group) {
      	var keyCode = event.which || event.keyCode;
      	if (keyCode === 32 || keyCode === 13) {
      		toggleGroupNights(event, group);
      	}
      }

      function backToDiscount() {
      	vm.step = 1;
      }

      /*
      **  Percent of the clicked night's rate, unrounded when the amount was typed
      */
      function getExactPercent() {
      	var nightRate = parseFloat(price);
      	if (lastEdited === 'percent') {
      		return parseFloat(vm.data.percent) || 0;
      	}
      	return ((parseFloat(vm.data.amount) || 0) / nightRate) * 100;
      }

      function toggleNight(night) {
      	if (night.disabled) {
      		return;
      	}
      	vm.selectedNights[night.index] = !vm.selectedNights[night.index];
      }

      function allNightsSelected() {
      	return enabledNights.every(function (night) {
      		return vm.selectedNights[night.index];
      	});
      }

      function selectedCount() {
      	return enabledNights.filter(function (night) {
      		return vm.selectedNights[night.index];
      	}).length;
      }

      function nightAmountChanged(night) {
      	return getNightAmount(night) !== parseFloat(commonService.roundnum(night.currentDiscount, 2));
      }

      function nightReasonChanged(night) {
      	return (vm.data.comment || '') !== (night.currentComment || '');
      }

      function nightHasChange(night) {
      	return nightAmountChanged(night) || nightReasonChanged(night);
      }

      // Selected nights the save would actually change
      function getChangedNights() {
      	return enabledNights.filter(function (night) {
      		return vm.selectedNights[night.index] && nightHasChange(night);
      	});
      }

      function changedCount() {
      	return getChangedNights().length;
      }

      function isApplyingToAllNights() {
      	return vm.multiNight && vm.applyToOtherNights && vm.applyMode === 'all';
      }

      // Every night the discount could actually change
      function getAllChangedNights() {
      	return enabledNights.filter(nightHasChange);
      }

      // The radio group is on the form too, so form.$dirty alone would count switching the option as an edit
      function isDiscountEdited(form) {
      	return ['amount', 'percent', 'comment'].some(function (field) {
      		return form[field] && form[field].$dirty;
      	});
      }

      function isContinueDisabled(form) {
      	if (form.$invalid) {
      		return true;
      	}
      	// With either option there is nothing to do if no night would change
      	if (vm.multiNight && vm.applyToOtherNights) {
      		return getAllChangedNights().length === 0;
      	}
      	return !isDiscountEdited(form);
      }

      // "All nights" saves straight away, so the button says what it will do
      function getContinueLabel() {
      	if (!isApplyingToAllNights()) {
      		return 'Continue';
      	}
      	var count = getAllChangedNights().length;
      	return 'Apply to ' + count + (count === 1 ? ' night' : ' nights');
      }

      // Nights of a week ({ nightIndex: date }) in date order
      function getTableNights(items) {
      	return Object.keys(items).map(function (index) {
      		return vm.nightsByIndex[index];
      	}).filter(Boolean);
      }

      function isNightPreviewed(night) {
      	return vm.selectedNights[night.index] && !night.disabled;
      }

      // Selected nights preview what the save would write, the rest show what they have now
      function getShownDiscount(night) {
      	return isNightPreviewed(night) ? getNightAmount(night) : night.currentDiscount;
      }

      function isNightDiscountChanging(night) {
      	return isNightPreviewed(night) && nightAmountChanged(night);
      }

      // Nights at different rates get different amounts for the same percent, so show the range
      function getNightsSummary() {
      	var percent = parseFloat(commonService.roundnum(getExactPercent(), 2));
      	if (!percent) {
      		return 'Removing the discount from selected nights';
      	}
      	var amounts = enabledNights.filter(function (night) {
      		return vm.selectedNights[night.index];
      	}).map(function (night) {
      		return getNightAmount(night);
      	});
      	var summary = 'Applying ' + percent + '%';
      	if (amounts.length > 0) {
      		var lowest = Math.min.apply(null, amounts);
      		var highest = Math.max.apply(null, amounts);
      		summary += ' ($' + lowest.toFixed(2) + (highest > lowest ? ' - $' + highest.toFixed(2) : '') + ')';
      	}
      	return summary + ' on selected nights';
      }

      function toggleAllNights() {
      	var selectAll = !allNightsSelected();
      	enabledNights.forEach(function (night) {
      		vm.selectedNights[night.index] = selectAll;
      	});
      }

      /*
      **  Same percent on every night; the clicked night keeps the exact amount entered
      */
      function getNightAmount(night) {
      	var amount = night.index === vm.currentNightIndex
      		? parseFloat(vm.data.amount) || 0
      		: (night.rate * getExactPercent()) / 100;
      	if (amount > night.rate) {
      		amount = night.rate;
      	}
      	return parseFloat(commonService.roundnum(amount, 2));
      }

      function applyToNights() {
      	saveNights(getChangedNights());
      }

      function saveNights(changedNights) {
      	var nights = changedNights.map(function (night) {
      		return { index: night.index, amount: getNightAmount(night) };
      	});
      	if (nights.length === 0) {
      		return;
      	}
      	$mdDialog.hide(angular.extend({}, vm.data, { nights: nights }));
      }

	    function closeDialog() {
          $mdDialog.hide();
      }

     	/*
     	**  Check reason validation
     	*/
      function checkReason() {
        	if (vm.data.comment != '' && vm.data.comment) {
        		  vm.showCommentError = false;
          	}
      }

      function onAmountChange() {
      	if (vm.syncing || !price || parseFloat(price) <= 0) {
      		return;
      	}
      	vm.syncing = true;
      	lastEdited = 'amount';
      	var amount = parseFloat(vm.data.amount) || 0;
      	var nightRate = parseFloat(price);
      	if (amount > nightRate) {
      		amount = nightRate;
      	}
      	vm.data.amount = commonService.roundnum(amount, 2);
      	vm.data.percent = commonService.roundnum((amount / nightRate) * 100, 2);
      	vm.syncing = false;
      }

      function onPercentChange() {
      	if (vm.syncing || !price || parseFloat(price) <= 0) {
      		return;
      	}
      	vm.syncing = true;
      	lastEdited = 'percent';
      	var percent = parseFloat(vm.data.percent) || 0;
      	var nightRate = parseFloat(price);
      	if (percent > 100) {
      		percent = 100;
      	}
      	vm.data.percent = commonService.roundnum(percent, 2);
      	vm.data.amount = commonService.roundnum((nightRate * percent) / 100, 2);
      	vm.syncing = false;
      }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.create-res')
        .controller('consolidateController', consolidateController);

    /** @ngInject */
    function consolidateController(
    	EnvironmentConfig,
    	$mdDialog,
    	$translate,
    	$rootScope,
    	type,
    	consolidateDisabled
    ) {
		var vm = this;
		vm.title = "Consolidate Actions";
		vm.consolidateDisabled = consolidateDisabled;
		vm.type = type;
		if(vm.type === 'boat') {
			vm.addNewType = "ADD_BOAT_TYPE";
		} else if(vm.type === 'residence') {
			vm.addNewType = "ADD_ROOM_TYPE";
		} else {
			vm.addNewType = "ADD_ROOM_TYPE";
		}
		vm.closeDialog = closeDialog;
		vm.clickButtonType = function(type) {
			$rootScope.$broadcast('consolidateType',{type:type});
		}

		function closeDialog()
		{
			$mdDialog.hide();
		}
    }

})();

	(function ()
	{
		'use strict';

		angular.module('app.create-res')
			.controller('showServicesController', showServicesController);

		/** @ngInject */
		function showServicesController($mdDialog, createResService, toastMessage, $translate, $rootScope, services, $scope, checkin, checkout, numberOfRooms, cartIndex,$sessionStorage, EnvironmentConfig)
		{
			var vm = this;
			// Data
			vm.data = {};
			vm.myDate = new Date();
			vm.minDate = new Date(
				vm.myDate.getFullYear(),
				vm.myDate.getMonth(),
				vm.myDate.getDate()
			);

		vm.new_checkin = new Date(moment(checkin).format());
        vm.new_checkout = new Date(moment(checkout).format());
        vm.baseUrl = EnvironmentConfig.api;

		var storageData = angular.copy($sessionStorage['cartDetails_' + $localStorage['preHotelId']]);
		vm.cartdetails = storageData;
		
		//Methods
		vm.closeDialog = closeDialog;
		vm.getDateRange = getDateRange;
		vm.convert = convert;
		vm.updateSelectedDate = updateSelectedDate;
		vm.addService = addService;
		vm.services = services;
		vm.selected = [];
		vm.selectedServicesDetails = [];
		vm.getSelectedPosId = [];
		// vm.totalPrice = parseFloat($sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['overalltotals']['grandtotal']);
		// vm.deposit_amount = parseFloat($sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['overalltotals']['deposit_amount']);
		// vm.tax = parseFloat($sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['overalltotals']['tax']);
		var preSelected = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['pos'];
		if(preSelected){
		preSelected.forEach(function(element) {
			// vm.selected.push(element.product_id);
			// vm.selectedServicesDetails.push(element); 
			vm.getSelectedPosId.push(element.product_id);
			
		}, this);
		}
		 
		
		vm.available_rooms = {};
		vm.show_rooms = false;
		vm.new_adult = 2;
		vm.new_child = 0;
		vm.enableAdd = false;
		$scope.toggle = function (item, details) {
			var idx = vm.selected.indexOf(item);
			if (idx > -1) {
			vm.selected.splice(idx, 1);
			vm.selectedServicesDetails.splice(idx, 1);
			// vm.totalPrice = parseFloat(vm.totalPrice) - parseFloat(details.product_price);
			// vm.deposit_amount =  parseFloat(vm.deposit_amount) - parseFloat(details.deposit_ammount);
			// vm.tax =  parseFloat(vm.tax) - parseFloat(details.tax);
			}
			else {
			// vm.totalPrice = parseFloat(vm.totalPrice) + parseFloat(details.product_price);
			// vm.deposit_amount = parseFloat(vm.deposit_amount) + parseFloat(details.deposit_ammount);
			// vm.tax =  parseFloat(vm.tax) + parseFloat(details.tax);
			
			vm.selected.push(item);
			if(details.product_is_timebound == 1){
				details['from'] = vm.new_checkin;
				details['to'] = vm.new_checkout;
				var dates = getDateRange(convert(vm.new_checkin), convert(vm.new_checkout));
				var dateRange = [];
				var prices = [];				
				dates.forEach(function(element, index){
					dateRange.push(element);
					prices.push(details.product_price);
				});
				// details['prices'].dateRange = dateRange;
				details['prices'] = {'dates':dateRange, 'rates':prices};
				details['deposit_ammount'] = details.deposit_ammount* dateRange.length;
				details['nightlySum'] = details.product_price * dateRange.length;
				details['grandTotal'] = (dateRange.length * details['product_price']);
				details['tax'] = (details['grandTotal'] * details['tax_value'])/100;
				details['grandTotal'] =parseFloat(details['grandTotal']) +parseFloat(details['tax']);
			} else {
				details['nightlySum'] = details.product_price;
			}
				
			
			vm.selectedServicesDetails.push(details); 
		}
		};

		$scope.exists = function (item) {
			return vm.selected.indexOf(item) > -1;
		};
		 function convert(str) {
              var date = new Date(str),
                  mnth = ("0" + (date.getMonth()+1)).slice(-2),
                  day  = ("0" + date.getDate()).slice(-2);
              return [ date.getFullYear(), mnth, day ].join("-");
          }
		function updateSelectedDate(index){
			var idx = vm.selected.indexOf(index);
			vm.selectedServicesDetails[idx]['from'] = vm.new_checkin[index];
			vm.selectedServicesDetails[idx]['to'] = vm.new_checkout[index];

			var dates = getDateRange(convert(vm.new_checkin[index]), convert(vm.new_checkout[index]));
				var dateRange = [];				
				dates.forEach(function(element){
					dateRange.push(element);
				});
			vm.selectedServicesDetails[idx]['grandTotal'] = dateRange.length * vm.selectedServicesDetails[idx]['product_price'];
			vm.selectedServicesDetails[idx]['tax'] = (vm.selectedServicesDetails[idx]['tax_value'] * vm.selectedServicesDetails[idx]['grandTotal'])/100;
			vm.selectedServicesDetails[idx]['grandTotal'] = parseFloat(vm.selectedServicesDetails[idx]['grandTotal'])+  parseFloat(vm.selectedServicesDetails[idx]['tax']);
						
				
			vm.selectedServicesDetails[idx]['dateRange'] = dateRange;	
			vm.new_date = vm.new_checkin[index];
			// vm.new_date = moment(vm.new_checkin[index]).add(1, 'days');


			// vm.myDate = new Date();
			// // alert(vm.new_checkout[index]);
			 vm.minDate = new Date(
	            this.new_date.getFullYear(),
	            this.new_date.getMonth(),
	            this.new_date.getDate()+1
          );
		}

		function getDateRange(startDate, endDate) {
        var dateStart = moment(startDate);
		var dateEnd = moment(endDate);
		var timeValues = [];

		while (dateEnd > dateStart) {
		timeValues.push(dateStart.format('MM/DD/YYYY'));
		dateStart.add(1,'day');
		}

        return timeValues;
    };



		function addService(){
			if(!$sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['pos'] || $sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['pos'].length == 0){
				$sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['pos'] = [];
			}
			var allposIndex = [];
			vm.selectedServicesDetails.forEach(function(element, index){

				var idx = vm.getSelectedPosId.indexOf(element.product_id);
				var grandTotal =$sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['overalltotals']['grandtotal'];
				var depositAmount = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['overalltotals']['deposit_amount'];
				var grandTax = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['overalltotals']['tax'] ;
				var posIndex=-1;




				if(idx == -1){
					$sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['pos'].push(element);
					posIndex = parseInt($sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['pos'].length)-1;
				} else {
					if(element.product_is_timebound == 1 ){
						$sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['pos'].push(element);
						posIndex = parseInt($sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['pos'].length)-1;

					}else {
						var price = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['pos'][idx]['product_price'];
						var quantity = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['pos'][idx]['quantity'] = parseFloat($sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['pos'][idx]['quantity']) + 1;

						$sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['pos'][idx]['tax'] = (parseFloat(price) * quantity *$sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['pos'][idx]['tax_value'])/100;
						$sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['pos'][idx]['deposit_ammount'] = element.deposit_ammount * quantity;
						$sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['pos'][idx]['grandTotal'] = parseFloat(price*quantity) + parseFloat($sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['pos'][idx]['tax']);
					posIndex = idx;
					}
				}
				allposIndex.push(posIndex);
				if($sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex].cust_info!=undefined && $sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex].cust_info.tax_exempt_indicator==1){
					$sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex]['pos'][posIndex]['tax_value'] = '0.00';
				}
			});
			$rootScope.$broadcast('closingAddServices',{allposIndex: allposIndex,roomIndex: cartIndex});
			$mdDialog.hide();
		}
		
		
		
		/**
		 * Close dialog
		 */
		function closeDialog()
		{
			$mdDialog.hide();
		}
		}

	})();

(function ()
{
    'use strict';

    angular.module('app.create-res')
        .controller('showRoomsController', showRoomsController);

    /** @ngInject */
    function showRoomsController(
    	EnvironmentConfig,
    	$mdDialog,
    	createResService,
    	toastMessage,
    	$translate,
    	checkin,
    	checkout,
    	adult,
    	child,
    	type,
    	productIdsInCart,
    	itin_no,
    	$rootScope,
    	$state,
    	ganttChartService,
    	eCommerceService,
    	pageFrom,
    	changeCartItemData,
    	additionalParams,
    	$sessionStorage,
    	$timeout,
		$localStorage,
		$q)
    {
		var vm = this;
		var requestFor = 'reservation';
        var product_id_occ = '';
		vm.pageFrom = pageFrom;
		vm.requestType = false;
		/*********** Check Permission for boat **********/
		var permissionArray = $rootScope.userPermissions.split(",");
		if(permissionArray.indexOf('boats') != -1) {
			vm.boatPermission = true;
		} else {
			vm.boatPermission = false;
		}
		if(vm.pageFrom == 'boat' && vm.boatPermission){
			vm.requestType = true;
			requestFor = 'boat';
		}
		vm.villaRooms = '';

		/************************************************/
		vm.negotiatedCustId = additionalParams != undefined && additionalParams.negotiatedCust != undefined ? additionalParams.negotiatedCust : 0;
		vm.selectedRatePlanId = additionalParams != undefined && additionalParams.ratePlanId != undefined ? additionalParams.ratePlanId : 0;
		vm.promoCodeInfo = additionalParams != undefined && additionalParams.promoCodeInfo != undefined ? additionalParams.promoCodeInfo : '';
		if(typeof additionalParams != 'undefined' && additionalParams && additionalParams.hasOwnProperty('reservation_type') && additionalParams['reservation_type'] == 'boat'){
			requestFor = 'boat';
			vm.requestType = true;
		}
		// Data
		vm.data = {};
		vm.myDate = new Date();
		vm.minDate = new Date(
			vm.myDate.getFullYear(),
			vm.myDate.getMonth(),
			vm.myDate.getDate()
		);
		vm.selectedRoom={};
		vm.selectedRoom1={};
		vm.selectedRoomName={};
		vm.show_search = true;
		vm.enable_search = true;
		vm.show_save = false;
		vm.pageHeader = requestFor == 'reservation'?'Add Room(s)':'Add Slip(s)';
		if(typeof pageFrom != 'undefined' && pageFrom == 'toolBar'){
			vm.pageHeader = requestFor == 'reservation'?'Add Reservation(s)':'Add Boat (s)';
		}
		//Methods
		vm.closeDialog = closeDialog;
		vm.autoFillOff = true;
		vm.getAvailableRooms = getAvailableRooms;
		vm.addNewRoomstoCart = addNewRoomstoCart;
		vm.checkinSlected = checkinSlected;
		vm.selectingroom = selectingroom;
		vm.selectingpolicy = selectingpolicy;
		vm.baseUrl = EnvironmentConfig.api;
		vm.type = type;
		
		vm.changeCartItemData = changeCartItemData;
		vm.readDescription = readDescription;
		vm.readText = 'Show description';
		vm.description = false;
		if(vm.type == 'changeCartItem'){
			vm.show_search = false;
			vm.show_save = true;
			vm.pageHeader = "Edit Date(s)"
		}
		vm.currentHotelId = $localStorage['preHotelId'];
		vm.isDayReservationHotel = typeof $rootScope.isDailyRentalsAvailable === 'function'
			? $rootScope.isDailyRentalsAvailable()
			: false;
		vm.isCreateMode = function() {
			return vm.data.type_of_reservation === 'reservation' || vm.data.type_of_reservation === 'create_day';
		};
		vm.isDayCreateMode = function() {
			return vm.data.type_of_reservation === 'create_day';
		};
 		vm.isDayReservationContext = function() {
			var fromParams = additionalParams && additionalParams.reservation_type === 'day_reservation';
			return vm.pageFrom === 'day_reservation' || fromParams || vm.isDayCreateMode();
		};
		
		/* Quote Dates: same room+price UI as create; guest form after Next */
		vm.showRateUI = function() {
			return vm.isCreateMode() || vm.data.type_of_reservation === 'hold';
		};
		vm.hasHoldRoomSelected = function() {
			return vm.data.type_of_reservation === 'hold' && Object.keys(vm.selectedRoom1 || {}).length > 0;
		};
		vm.showHoldGuestStep = false;
		vm.holdSending = false;
		vm.promoRequestGoing = false;
		vm.holdPromoCode = '';
		vm.holdPromoApplied = false;
		vm.holdPromoApplyIntent = false;
		vm.goToHoldGuestStep = function() {
			if(!vm.hasHoldRoomSelected()){ return; }
			if (vm.closeAllDetails) { vm.closeAllDetails(); }
			if (vm.closeAllRateDetails) { vm.closeAllRateDetails(); }
			vm.holdSelectedRooms = vm.buildHoldSelectedRooms();
			if (!vm.holdSelectedRooms.length) { return; }
			angular.forEach(vm.holdSelectedRooms, function(sroom) {
				sroom.showHoldDiscountPanel = false;
			});
			vm.showHoldGuestStep = true;
		};
		vm.backToHoldRooms = function() {
			vm.showHoldGuestStep = false;
		};
		function holdPromoRates(summary) {
			var rates = summary && summary.rates ? summary.rates : [];
			if (!angular.isArray(rates)) {
				rates = Object.keys(rates).map(function(key) { return rates[key]; });
			}
			return rates;
		}
		function holdRoomTax(amount, taxRates) {
			var tax = 0;
			angular.forEach(taxRates || [], function(item) {
				tax += (parseFloat(amount) * parseFloat(item.tax_value || 0)) / 100;
			});
			return tax;
		}
		vm.applyTopHoldPromo = function(type) {
			if (type === 'remove') {
				vm.holdPromoApplied = false;
				vm.holdPromoCode = '';
				vm.holdPromoApplyIntent = false;
				if (vm.show_rooms) {
					getAvailableRooms(true);
				}
				return;
			}
			var code = (vm.holdPromoCode || '').trim();
			if (!code || vm.promoRequestGoing) { return; }
			vm.promoRequestGoing = true;
			eCommerceService.validatePromoCode({
				promoCode: code,
				promo: 'applied',
				resvProcess: 'validate'
			}).then(function(response) {
				vm.promoRequestGoing = false;
				if (response && response.status) {
					vm.holdPromoApplied = true;
					vm.holdPromoApplyIntent = true;
					if (response.order && response.order.promoCodeName) {
						vm.holdPromoCode = response.order.promoCodeName;
					}
					if (vm.show_rooms) {
						getAvailableRooms(true);
					}
				} else {
					vm.holdPromoApplied = false;
					vm.holdPromoApplyIntent = false;
					toastMessage.showSimpleToast((response && (response.errorMsg || response.warningMsg)) || 'Promotion code is not valid.', 'error-toast', true);
				}
			}, function() {
				vm.promoRequestGoing = false;
				vm.holdPromoApplied = false;
				vm.holdPromoApplyIntent = false;
				toastMessage.showSimpleToast('Unable to apply promo code.', 'error-toast', true);
			});
		};
		vm.askRemoveHoldPromo = function($event) {
			if ($event) {
				$event.preventDefault();
				$event.stopPropagation();
			}
			$mdDialog.show({
				controller: 'confirmController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
				parent: angular.element(document.body),
				targetEvent: $event,
				clickOutsideToClose: true,
				skipHide: true,
				multiple: true,
				locals: {
					title: 'Promo Code',
					htmlContent: 'Are you sure you want to remove the promo code?',
					cancelBtn: 'No',
					OkBtn: 'Yes'
				}
			}).then(function(answer) {
				if (typeof answer != 'undefined' && answer == 'update') {
					vm.applyTopHoldPromo('remove');
				}
			}, function() {});
		};
		vm.buildHoldSelectedRooms = function() {
			var list = [];
			angular.forEach(vm.available_rooms, function(room, roomkey) {
				var policyKey = vm.selectedRoom1[room.product_id];
				if(!policyKey){ return; }
				var summary = (room.searchSummary && room.searchSummary[policyKey]) ? angular.copy(room.searchSummary[policyKey]) : {};
				var base = (room.baseSearchSummary && room.baseSearchSummary[policyKey]) ? angular.copy(room.baseSearchSummary[policyKey]) : angular.copy(summary);
				var rateDesc = (room.rateNameDesc && room.rateNameDesc[policyKey]) ? room.rateNameDesc[policyKey] : {};
				var nightly = (room.nightlyRate && room.nightlyRate[policyKey]) ? room.nightlyRate[policyKey] : '';
				var highest = (room.highestAvgRate && room.highestAvgRate[policyKey]) ? room.highestAvgRate[policyKey] : '';
				var promoApplied = !!room.anyPromoApplied;
				list.push({
					roomkey: roomkey,
					product_id: room.product_id,
					type_id: room.type_id || room.room_type_id || '',
					product_name: room.product_name || vm.selectedRoomName[room.product_id],
					image: room.image,
					policy_key: policyKey,
					policy_name: (room.policy_name && room.policy_name[policyKey]) ? room.policy_name[policyKey] : '',
					ratePlanName: rateDesc.ratePlanName || '',
					ratePlanDesc: rateDesc.ratePlanDesc || '',
					max_occupancy: room.max_occupancy,
					boat_length: room.boat_length,
					boat_width: room.boat_width,
					nights: room.nights || 1,
					nightlyRate: nightly,
					displayNightlyRate: (promoApplied && room.displayNightlyRate && room.displayNightlyRate[policyKey]) ? room.displayNightlyRate[policyKey] : nightly,
					highestAvgRate: highest,
					searchSummary: summary,
					baseSummary: base,
					taxRates: base.taxRates || summary.taxRates || [],
					promoCodeName: promoApplied ? (vm.holdPromoCode || '') : '',
					anyPromoApplied: promoApplied,
					promoCodeDiscount: (promoApplied && room.promoDiscount && room.promoDiscount[policyKey]) ? room.promoDiscount[policyKey] : 0,
					onlyAllowHoldBlock: !!room.onlyAllowHoldBlock,
					onlyAllowHoldBlockTxt: room.onlyAllowHoldBlockTxt || '',
					room_type_description: room.room_type_description || ''
				});
			});
			return list;
		};
		function holdPercentLabel(discountAmount, nightRate) {
			discountAmount = parseFloat(discountAmount) || 0;
			nightRate = parseFloat(nightRate) || 0;
			if (discountAmount <= 0 || nightRate <= 0) { return ''; }
			var percent = parseFloat(((discountAmount / nightRate) * 100).toFixed(2));
			return percent % 1 === 0 ? percent.toFixed(0) : percent.toFixed(2);
		}
		vm.holdPercentLabel = holdPercentLabel;
		function buildHoldRoomNightlyRows(sroom) {
			sroom.holdNightlyRows = [];
			if (!sroom || sroom.onlyAllowHoldBlock) { return; }
			var summary = sroom.baseSummary || sroom.searchSummary || {};
			var rates = holdPromoRates(summary);
			var nights = parseFloat(sroom.nights) || rates.length || 1;
			if (nights < 1) { nights = 1; }
			var start = moment(vm.new_checkin);
			var defaultRate = parseFloat(sroom.nightlyRate) || 0;
			var promoPerNight = sroom.anyPromoApplied ? ((parseFloat(sroom.promoCodeDiscount) || 0) / nights) : 0;
			for (var i = 0; i < nights; i++) {
				var rate = (rates[i] != null && rates[i] !== '') ? parseFloat(rates[i]) : defaultRate;
				if (!rate && nights > 0 && summary.subTotal) {
					rate = parseFloat(summary.subTotal) / nights;
				}
				var dateVal = (start && start.isValid()) ? start.clone().add(i, 'days').format('MM-DD-YYYY') : ('Night ' + (i + 1));
				var amt = 0;
				var comm = '';
				if (sroom.anyPromoApplied) {
					amt = promoPerNight;
					comm = sroom.promoCodeName || vm.holdPromoCode || '';
				} else if (sroom.holdNightlyDiscounts && sroom.holdNightlyDiscounts[i] != null) {
					amt = parseFloat(sroom.holdNightlyDiscounts[i]) || 0;
					comm = (sroom.holdNightlyComments && sroom.holdNightlyComments[i]) || '';
				}
				sroom.holdNightlyRows.push({
					nightNum: i + 1,
					date: dateVal,
					ratePlan: sroom.ratePlanName || '',
					rate: rate || 0,
					amount: amt,
					percent: (rate > 0 && amt > 0) ? parseFloat(((amt / rate) * 100).toFixed(2)) : 0,
					percentLabel: holdPercentLabel(amt, rate),
					comment: comm
				});
			}
		}
		vm.toggleHoldRoomDiscount = function(sroom, $event) {
			if ($event) {
				$event.preventDefault();
				$event.stopPropagation();
			}
			if (!sroom || sroom.onlyAllowHoldBlock) { return; }
			buildHoldRoomNightlyRows(sroom);
			sroom.showHoldDiscountPanel = !sroom.showHoldDiscountPanel;
		};
		vm.openHoldRoomNightDiscount = function(sroom, index, $event) {
			if ($event) {
				$event.preventDefault();
				$event.stopPropagation();
			}
			if (!sroom || sroom.onlyAllowHoldBlock) { return; }
			if (sroom.anyPromoApplied) { return; }
			var night = (sroom.holdNightlyRows && sroom.holdNightlyRows[index]) || {};
			var nightlyRate = parseFloat(night.rate) || 0;
			if (nightlyRate <= 0) {
				toastMessage.showSimpleToast('Room rate not available for discount calculation.', 'warning-toast', true);
				return;
			}
			var existingAmount = parseFloat(night.amount) || 0;
			$mdDialog.show({
				controller: 'discountCommentController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/create-res/dialogs/discount-comment/discount-comment.html',
				parent: angular.element(document.body),
				targetEvent: $event,
				clickOutsideToClose: true,
				skipHide: true,
				multiple: true,
				locals: {
					oldcomment: night.comment || '',
					oldAmount: existingAmount > 0 ? existingAmount : '',
					type: 'nightly_discount',
					price: nightlyRate
				}
			}).then(function(answer) {
				if (answer === undefined || answer === null) { return; }
				var amt = parseFloat(answer.amount) || 0;
				night.amount = amt;
				night.percent = parseFloat(answer.percent) || 0;
				night.percentLabel = holdPercentLabel(amt, night.rate);
				night.comment = (answer.comment || '').trim();
				var nights = (sroom.holdNightlyRows || []).map(function(n) {
					return {
						nightNum: n.nightNum,
						date: n.date,
						rate: n.rate,
						amount: parseFloat(n.amount) || 0,
						percent: parseFloat(n.percent) || 0,
						comment: n.comment || ''
					};
				});
				var total = 0;
				nights.forEach(function(n) { total += n.amount; });
				if (total > 0) {
					applyHoldRoomDiscount(sroom, nights, total);
				} else {
					removeHoldRoomDiscount(sroom);
				}
			}, function() {});
		};
		function applyHoldRoomDiscount(sroom, nights, totalDiscount) {
			var base = sroom.baseSummary || sroom.searchSummary || {};
			var subTotal = parseFloat(base.subTotal) || 0;
			var nightCount = parseFloat(sroom.nights) || nights.length || 1;
			if (totalDiscount > subTotal) { totalDiscount = subTotal; }
			sroom.holdDiscountType = 'per_night';
			sroom.holdNightlyDiscounts = [];
			sroom.holdNightlyComments = [];
			var commentParts = [];
			angular.forEach(nights, function(n, idx) {
				var a = parseFloat(n.amount) || 0;
				sroom.holdNightlyDiscounts.push(a.toFixed(2));
				sroom.holdNightlyComments.push((n.comment || '').trim());
				if (a > 0) {
					commentParts.push('Night ' + (idx + 1) + ': -$' + a.toFixed(2) + (n.comment ? ' (' + n.comment + ')' : ''));
				}
			});
			var oldRoomTax = holdRoomTax(subTotal, sroom.taxRates || base.taxRates);
			var newRoomTax = holdRoomTax(Math.max(0, subTotal - totalDiscount), sroom.taxRates || base.taxRates);
			var taxDelta = Math.max(0, oldRoomTax - newRoomTax);
			sroom.searchSummary = angular.copy(base);
			sroom.searchSummary.taxes = (parseFloat(base.taxes || 0) - taxDelta).toFixed(2);
			sroom.searchSummary.grandTotal = (parseFloat(base.grandTotal || 0) - totalDiscount - taxDelta).toFixed(2);
			sroom.holdDiscountApplied = true;
			sroom.holdDiscountAmount = totalDiscount.toFixed(2);
			sroom.holdDiscountPercent = (subTotal > 0) ? parseFloat(((totalDiscount / subTotal) * 100).toFixed(2)) : 0;
			sroom.holdDiscountComment = commentParts.join(' | ');
			sroom.displayNightlyRate = Math.max(0, (parseFloat(sroom.nightlyRate) || 0) - (totalDiscount / nightCount)).toFixed(2);
			buildHoldRoomNightlyRows(sroom);
		}
		function removeHoldRoomDiscount(sroom) {
			sroom.searchSummary = angular.copy(sroom.baseSummary || sroom.searchSummary);
			sroom.holdDiscountApplied = false;
			sroom.holdDiscountAmount = 0;
			sroom.holdDiscountPercent = 0;
			sroom.holdDiscountComment = '';
			sroom.holdNightlyDiscounts = [];
			sroom.holdNightlyComments = [];
			sroom.displayNightlyRate = sroom.nightlyRate;
			buildHoldRoomNightlyRows(sroom);
		}
		vm.data.type_of_reservation = 'reservation';
		if(vm.isDayReservationContext()){
			vm.data.type_of_reservation = 'create_day';
		}
		vm.data.hold_duration_time = new Date(1970, 0, 1, 18, 0, 0);
		vm.available_rooms = {};
		vm.subHotel = {};
		vm.subHotelcount = {};
		vm.show_rooms = false;
		vm.holdSelectedRooms = [];
		vm.showHoldSelectedBlock = {};
		if(checkin !== "")
			vm.new_checkin = new Date(moment(checkin).format());
		else
			vm.new_checkin = new Date();
		if(checkout !== "")
			vm.new_checkout = new Date(moment(checkout).format());
		else
			vm.new_checkout = new Date(moment().add(2, 'days'));
		vm.data.hold_duration = new Date(moment(vm.new_checkin).format('YYYY-MM-DD'));

		vm.original_room_stay_from = angular.copy(vm.new_checkin);
		vm.original_room_stay_to = angular.copy(vm.new_checkout);
		if(vm.isDayReservationContext()){
			vm.minDateCheckout = new Date(moment(vm.new_checkin));
			vm.new_checkout = angular.copy(vm.new_checkin);
			vm.original_room_stay_to = angular.copy(vm.new_checkout);
		} else {
			vm.minDateCheckout = new Date(moment(vm.new_checkin, "DD-MM-YYYY").add(1, 'days'));
		}
		vm.itin_no = itin_no;

		vm.new_adult = adult;
		vm.new_child = child;
		// vm.new_adult = 2;
		// vm.new_child = 0;
		vm.original_adult = adult;
		vm.original_child = child;
		vm.blockedReservation = {};
		vm.blockedOthers = {};
		vm.isCommentEmpty = false;
		vm.holdPhoneInvalid = false;
		vm.holdCustomerNoCache = true;
		vm.selectedHoldCustomer = { first_name: null, last_name: null, customer_email: null };
		vm.searchTextFn = '';
		vm.searchTextLn = '';
		vm.searchTextEm = '';
		vm.holdCustomerSearching = false;
		var holdCustomerSelecting = false;
		vm.queryHoldCustomer = function(query, field) {
			if (!query) {
				vm.holdCustomerSearching = false;
				return [];
			}
			var deferred = $q.defer();
			vm.holdCustomerSearching = true;
			createResService.getCustomers({
				search: query,
				field: field,
				pageFrom: 'reservation',
				selectedHotel: $localStorage.hotels[$localStorage.selectedHotel].hotel_id
			}).then(function(response) {
				vm.holdCustomerSearching = false;
				deferred.resolve((response && response[0] && response[0].customerList) ? response[0].customerList : []);
			}, function() {
				vm.holdCustomerSearching = false;
				deferred.resolve([]);
			});
			return deferred.promise;
		};
		vm.onHoldCustomerSearchChange = function(field) {
			if (holdCustomerSelecting) { return; }
			if (field === 'first_name') { vm.data.first_name = vm.searchTextFn; }
			if (field === 'last_name') { vm.data.last_name = vm.searchTextLn; }
			if (field === 'customer_email') { vm.data.customer_email = vm.searchTextEm; }
		};
		vm.selectHoldCustomer = function(item) {
			if (!item) { return; }
			holdCustomerSelecting = true;
			vm.data.first_name = item.first_name || '';
			vm.data.last_name = item.last_name || '';
			vm.data.customer_email = item.customer_email || '';
			if (item.phone_number) {
				vm.data.phone_number = item.phone_number;
				$timeout(function() { vm.updateHoldPhone(); }, 300);
			}
			vm.searchTextFn = vm.data.first_name;
			vm.searchTextLn = vm.data.last_name;
			vm.searchTextEm = vm.data.customer_email;
			vm.selectedHoldCustomer.first_name = item;
			vm.selectedHoldCustomer.last_name = item;
			vm.selectedHoldCustomer.customer_email = item;
			$timeout(function() { holdCustomerSelecting = false; }, 300);
		};
		vm.updateHoldPhone = function() {
			var phoneInput = document.querySelector('.hold-quote-phone');
			if (!phoneInput) {
				vm.holdPhoneInvalid = false;
				return;
			}
			var iti = angular.element(phoneInput).data('iti');
			var inputValue = (phoneInput.value || '').trim();
			if (!inputValue) {
				vm.holdPhoneInvalid = false;
				angular.element(phoneInput).removeClass('ng-invalid').addClass('ng-valid');
				return;
			}
			if (!iti) {
				vm.holdPhoneInvalid = false;
				return;
			}
			var isValid = !!iti.isValidNumberPrecise();
			vm.holdPhoneInvalid = !isValid;
			angular.element(phoneInput).toggleClass('ng-invalid', !isValid);
			angular.element(phoneInput).toggleClass('ng-valid', isValid);
		};

		vm.selectedProduct = [];
		vm.showWarning = [];
		vm.enableAdd = false;


		/* functions for top tabs slider */
		function getRangeArray(start, end){
			var tempArray = [];
			for(var i=start ; i <= end;i++){
				tempArray.push(i);
			}
			return tempArray;
		}
		if(vm.changeCartItemData != undefined){
			product_id_occ = vm.changeCartItemData.product_id;
		}

		if(requestFor == 'reservation'){
			var occData = {
				checkin:checkin,
				checkout:checkout,
				product_id_occ:product_id_occ
			}
			createResService.getMaxMinOccupancy(occData).then(function(response) {
				vm.max_occupancy = response.occ_data.max_occ;
				var sum = parseInt(vm.new_child) + parseInt(vm.new_adult);
				vm.adultRange = getRangeArray(1, (parseInt(vm.max_occupancy - vm.new_child)));

				vm.childRange = getRangeArray(0, (parseInt(vm.max_occupancy - vm.new_adult)));
			});
		}

		vm.manageAdultChild = manageAdultChild;
		function manageAdultChild(calledFrom){
			$timeout(function() {
				var sum = parseInt(vm.new_child) + parseInt(vm.new_adult);
				if(calledFrom == 'adult'){
					vm.childRange = getRangeArray(0, (vm.max_occupancy - vm.new_adult));
					if(sum > vm.max_occupancy){
						vm.new_child = 0;
					}
				} else {
					vm.adultRange = getRangeArray(1, (vm.max_occupancy - vm.new_child));
					if(sum > (vm.max_occupancy)){
						vm.new_adult = 1;
					}
				}

			},1000);
		}

		function checkifButton(){
			vm.enableAdd = false;
			angular.forEach(vm.selectedRoom,function(value, key){
				if(value == true){
					vm.enableAdd = true;
				}
			});
		}
		vm.roomObjectValidation = true;
       	
       	vm.hideWarning = function(productId) {
       		if (vm.showWarning.indexOf(productId) >= 0) {
       			vm.showWarning.splice(vm.showWarning.indexOf(productId), 1);
       		}
       	};

       	function selectingroom(status,product_name,idx , policyKey){
	       	var tempIndex = vm.selectedProduct.indexOf(status);
	       	if (tempIndex <= -1) {
	       		vm.selectedProduct.push(status);
	       		tempIndex = vm.showWarning.indexOf(status);
		       	if (tempIndex <= -1) {
		       		vm.showWarning.push(status);
		       	}	
	       	} else {
	       		vm.selectedProduct.splice(tempIndex, 1);
	       		if (vm.showWarning.indexOf(status) >= 0) {
	       			vm.showWarning.splice(vm.showWarning.indexOf(status), 1);
	       		}
	       	}

	       	if(vm.isCreateMode() || (vm.data.type_of_reservation === 'hold' && typeof policyKey !== 'undefined')){
	       		var CountRoomPolicy = 0;
	       	 	angular.forEach(vm.temp[status], function(element, index){
		       	 	if(policyKey != index ){
		       	 		vm.temp[status][index] = false;
		       	 	}
	       	 	});
		       	if(typeof vm.selectedRoom1[status] != 'undefined' && !vm.temp[status][policyKey]){
		       	 	delete vm.selectedRoom1[status];
		       	 	delete vm.selectedRoomName[status];
		       	} else {
			       	vm.selectedRoom1[status] = policyKey;
			       	vm.selectedRoomName[status] = product_name;
		       	}
	        	if(Object.keys(vm.selectedRoom1).length > 0){
	        		vm.roomObjectValidation = false;
	        		vm.enableAdd = true;
		   		} else {
		   		 	vm.roomObjectValidation = true;
		   		 	vm.enableAdd = false;
		   		 	vm.showHoldGuestStep = false;
		   		}
		   		var productBlocked = [];
				angular.forEach(vm.available_rooms,function(roomvalue,roomkey){
					if(vm.temp.hasOwnProperty(roomvalue.product_id)){
						if(vm.temp[roomvalue.product_id][policyKey]){
							if(vm.available_rooms[idx].products_to_be_blocked != undefined && vm.available_rooms[idx].products_to_be_blocked != ''){
					       		var products_to_be_blocked = vm.available_rooms[roomkey].products_to_be_blocked.split(',');
					       		angular.forEach(products_to_be_blocked,function(value, key){
								   vm.blockedReservation[value] = true;
								   productBlocked.push(value);
							   });
					       	}
						} else {
							if(vm.available_rooms[idx].products_to_be_blocked != undefined && vm.available_rooms[idx].products_to_be_blocked != ''){
					       		var products_to_be_blocked = vm.available_rooms[idx].products_to_be_blocked.split(',');
					       		angular.forEach(products_to_be_blocked,function(value, key){
					       			if(productBlocked.indexOf(value) == -1){
					       				vm.blockedReservation[value] = false;
					       			}
							   });
					       	}
						}
					}
				});
	       	} else {
	       		checkifButton();

			   	if(!vm.selectedRoom[status]){
				   	delete vm.selectedRoom1[status];
				   	delete vm.selectedRoomName[status];
				   	if(Object.keys(vm.selectedRoom1).length === 0){
				   		vm.showHoldGuestStep = false;
				   	}
			   	}else if(!vm.selectedRoom1.hasOwnProperty(status) || !vm.selectedRoom1[status]){


				   	var count = 0;
				   	if (vm.available_rooms[idx].onlyAllowHoldBlock) {
				   		vm.selectedRoom1[status] = '2';
				   	} else {
					   	angular.forEach(vm.available_rooms[idx].policy_name,function(value, key){
						   	if(count == 0){
							  	vm.selectedRoom1[status] = key;
						   	}
						   	count++;
					   	});
				   	}
				   	vm.selectedRoomName[status] = product_name;
			   	}else{
			   			vm.selectedRoomName[status] = product_name;
			   	}
			   	var productBlocked = [];
		       	angular.forEach(vm.available_rooms,function(roomvalue,roomkey){
		       		if(vm.selectedRoom.hasOwnProperty(roomvalue.product_id)){
		       			if(vm.selectedRoom[roomvalue.product_id]){
		       				if(vm.available_rooms[idx].products_to_be_blocked != undefined && vm.available_rooms[idx].products_to_be_blocked != ''){
					       		var products_to_be_blocked = vm.available_rooms[idx].products_to_be_blocked.split(',');
					       		angular.forEach(products_to_be_blocked,function(value, key){
								   vm.blockedOthers[value] = true;
								   productBlocked.push(value);
							   });
					       	}
		       			} else {
		       				if(vm.available_rooms[idx].products_to_be_blocked != undefined && vm.available_rooms[idx].products_to_be_blocked != ''){
					       		var products_to_be_blocked = vm.available_rooms[idx].products_to_be_blocked.split(',');
					       		angular.forEach(products_to_be_blocked,function(value, key){
					       			if(productBlocked.indexOf(value) == -1){
					       				vm.blockedOthers[value] = false;
					       			}
							   });
					       	}
		       			}
		       		}
		       	});
	       	}
       	}

	    function selectingpolicy(roomId){
		   if(!vm.selectedRoom.hasOwnProperty(roomId) || !vm.selectedRoom[roomId]){
			   vm.selectedRoom[roomId] = true;
		   }
		   checkifButton();
	    }


		function syncSelectedRoomsAfterPromo(applyPromo) {
			var roomsById = {};
			angular.forEach(vm.available_rooms, function(room) {
				roomsById[room.product_id] = room;
			});
			angular.forEach(vm.holdSelectedRooms || [], function(sroom) {
				var room = roomsById[sroom.product_id];
				var policyKey = sroom.policy_key;
				var listingPromo = !!(room && room.anyPromoApplied);
				if (applyPromo) {
					if (!listingPromo) { return; }
					if (room.searchSummary && room.searchSummary[policyKey]) {
						sroom.searchSummary = angular.copy(room.searchSummary[policyKey]);
					}
					sroom.anyPromoApplied = true;
					sroom.promoCodeName = vm.holdPromoCode || '';
					sroom.promoCodeDiscount = (room.promoDiscount && room.promoDiscount[policyKey]) ? room.promoDiscount[policyKey] : 0;
					sroom.displayNightlyRate = (room.displayNightlyRate && room.displayNightlyRate[policyKey]) ? room.displayNightlyRate[policyKey] : sroom.nightlyRate;
				} else {
					if (!sroom.anyPromoApplied) { return; }
					if (room && room.searchSummary && room.searchSummary[policyKey]) {
						sroom.searchSummary = angular.copy(room.searchSummary[policyKey]);
						sroom.baseSummary = angular.copy(sroom.searchSummary);
						if (room.nightlyRate && room.nightlyRate[policyKey]) {
							sroom.nightlyRate = room.nightlyRate[policyKey];
						}
					}
					sroom.anyPromoApplied = false;
					sroom.promoCodeDiscount = 0;
					sroom.promoCodeName = '';
					sroom.displayNightlyRate = sroom.nightlyRate;
				}
				if (sroom.showHoldDiscountPanel) {
					buildHoldRoomNightlyRows(sroom);
				}
			});
		}
		function getAvailableRooms(keepHoldState){
			//Current page
			if (!keepHoldState) {
				vm.selectedRoom1= {};
				vm.selectedRoomName = {};
				vm.temp = {};
				vm.enableAdd = false;
				vm.roomObjectValidation = true;
				vm.showHoldGuestStep = false;
				vm.holdSelectedRooms = [];
			}
			var requestType = vm.requestType == true ? 'boat' : 'room';
			vm.requestForType = requestType;
			var checkinDay = moment(vm.new_checkin).format('YYYY-MM-DD');
			var checkoutDay = moment(vm.new_checkout).format('YYYY-MM-DD');
			var data = {
				new_checkin: checkinDay,
				new_checkout: checkoutDay,
				new_adult:vm.new_adult,
				new_child:vm.new_child,
				productIdsInCart:productIdsInCart,
				requestFor:requestType,
				type : vm.type
			};
			// Day Add Room: always send day flags + same calendar day (avoid overnight rates / Date TZ drift)
			if(vm.isDayReservationContext()){
				data.cart_type = 'day_reservation';
				data.type_of_reservation = 'day_reservation';
				data.new_checkout = checkinDay;
			}
			if(requestType == 'boat') {
				data.new_length = vm.boat_length;
				data.new_beam = vm.boat_beam;
			}
			if (vm.data.type_of_reservation === 'hold' && (vm.holdPromoCode || '').trim()) {
				data.promo = (vm.holdPromoCode || '').trim();
			}
			if(vm.new_checkin !== '' && vm.new_checkout !== ''){
				vm.enable_search = false;
			    createResService.getAvailableRooms(data).then(function(response) {
					vm.promoRequestGoing = false;
			    	if (response.success) {
			    		vm.resortFeeApplicable = response.resortFeeApplicable !== undefined ? response.resortFeeApplicable : false;
			    		vm.extraPersonApplicable = response.extraPersonApplicable !== undefined ? response.extraPersonApplicable : false;
						vm.show_rooms = true;
						vm.enable_search = true;
						vm.original_room_stay_from = angular.copy(vm.new_checkin);
						vm.original_room_stay_to = angular.copy(vm.new_checkout);
						vm.original_adult = angular.copy(vm.new_adult);
						vm.original_child = angular.copy(vm.new_child);
						vm.available_rooms = response.available_rooms;
						if (keepHoldState) {
							syncSelectedRoomsAfterPromo(!!data.promo);
						}
						if (data.promo) {
							if (response.promoError) {
								vm.holdPromoApplied = false;
								toastMessage.showSimpleToast(response.promoError, 'error-toast', true);
							} else if (response.promoApplied) {
								vm.holdPromoApplied = true;
							} else {
								vm.holdPromoApplied = false;
								toastMessage.showSimpleToast('This promo code is not applicable on any available room.', 'warning-toast', true);
							}
						}
						vm.holdPromoApplyIntent = false;
						vm.villaRooms = response.villaRooms;
                        vm.subHotel = response.subHotel != undefined ? response.subHotel : [];
						vm.subHotelcount = response.subHotelcount != undefined ?  response.subHotelcount : [];
						vm.selectedSubHotelId =  response.roomShow;
						
					} else if(response.errorMsg!='undefined') {
						vm.show_rooms = false;
						vm.enable_search = true;
						vm.holdPromoApplyIntent = false;
						toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
					} else {
						vm.show_rooms = false;
						vm.enable_search = true;
						vm.holdPromoApplyIntent = false;
						toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'), 'error-toast');
					}
				}, function() {
					vm.promoRequestGoing = false;
					vm.enable_search = true;
					vm.holdPromoApplyIntent = false;
				});
		   } else {
				vm.holdPromoApplyIntent = false;
				vm.promoRequestGoing = false;
		   }
		}

		function checkinSlected(){
			if(vm.isDayCreateMode()){
				// Day reservation: check-out always matches check-in (same calendar day)
				vm.minDateCheckout = new Date(moment(vm.new_checkin));
				vm.new_checkout = angular.copy(vm.new_checkin);
				return;
			}
			vm.minDateCheckout = new Date(moment(vm.new_checkin, "DD-MM-YYYY").add(1, 'days'));
			var endDate = moment(vm.new_checkout);
			var startDate = moment(vm.new_checkin);
			if(endDate.isBefore(startDate) || endDate.isSame(startDate)){
				vm.new_checkout = new Date(moment(startDate, "DD-MM-YYYY").add(2, 'days'));
			}
		}


		function addNewRoomstoCart() {
			if (vm.holdSending) { return false; }
			if((vm.data.room_stay_comment == undefined || vm.data.room_stay_comment == '') && !vm.isCreateMode()) {
       			vm.isCommentEmpty = true; return false;
       		} else {
       			vm.isCommentEmpty = false;
       		}
			
			if(vm.selectedRoom != 'undefined' && vm.new_checkin !== '' && vm.new_checkout !== ''){
				if(vm.type == 'changeCartItem'){
					vm.new_checkin = moment(vm.new_checkin).format('YYYY-MM-DD');
					vm.new_checkout = moment(vm.new_checkout).format ('YYYY-MM-DD');
				} else {
					vm.new_checkin = moment(vm.original_room_stay_from).format('YYYY-MM-DD');
					vm.new_checkout = moment(vm.original_room_stay_to).format ('YYYY-MM-DD');
					vm.new_adult = angular.copy(vm.original_adult);
					vm.new_child = angular.copy(vm.original_child);
				}
				
				if(type == 'new'){
					if(vm.isCreateMode()){
						var createParams = {
							prod_id:JSON.stringify(vm.selectedRoom1),
							from:moment(vm.new_checkin).format('MM/DD/YYYY'),
							to:moment(vm.new_checkout).format('MM/DD/YYYY'),
							adult:vm.new_adult,
							child:vm.new_child,
							from_page:'header',
							creationSource:'Quick Access'
						};
						if(vm.isDayReservationContext()){
							createParams.cart_type = 'day_reservation';
							createParams.to = createParams.from;
						}
						$state.go('app.create-res', createParams);
					} else {
						var holdFirst = (vm.data.first_name || '').trim();
						var holdLast = (vm.data.last_name || '').trim();
						vm.data.first_name = holdFirst;
						vm.data.last_name = holdLast;
						vm.data.customer_name = (holdFirst + ' ' + holdLast).trim();
						vm.updateHoldPhone();
						if (vm.holdPhoneInvalid) {
							toastMessage.showSimpleToast('Please enter a valid phone number','error-toast');
							return false;
						}
						var holdPhoneInput = document.querySelector('.hold-quote-phone');
						if (holdPhoneInput) {
							var holdIti = angular.element(holdPhoneInput).data('iti');
							var holdPhoneVal = holdPhoneInput.value.trim();
							if (holdPhoneVal && holdIti && holdIti.isValidNumberPrecise()) {
								var holdDialCode = '+' + holdIti.getSelectedCountryData().dialCode;
								var holdLocal = holdPhoneVal.indexOf(holdDialCode) === 0 ? holdPhoneVal.substring(holdDialCode.length).trim() : holdPhoneVal;
								vm.data.phone_number = holdDialCode + ' ' + holdLocal;
							} else {
								vm.data.phone_number = holdPhoneVal;
							}
						}
						if(vm.data.hasOwnProperty('hold_duration_time') && vm.data.hold_duration_time != '' && typeof vm.data.hold_duration != 'undefined'){
							vm.data.hold_duration = moment(vm.data.hold_duration).format('MM/DD/YYYY') +" "+ moment(vm.data.hold_duration_time).format('LT');
							delete vm.data.hold_duration_time;
						}
						if(typeof vm.data.hold_duration == 'undefined'){
								vm.data.hold_duration = '';

						}
						vm.enableAdd = false;
						vm.holdSending = true;
						var roomDiscounts = {};
						angular.forEach(vm.holdSelectedRooms, function(room) {
							if (!room.product_id) { return; }
							var entry = {};
							if (room.anyPromoApplied) {
								entry.promotion_code = room.promoCodeName;
								entry.promo_discount = room.promoCodeDiscount;
							}
							if (room.holdDiscountApplied) {
								entry.manual_discount = room.holdDiscountAmount;
								entry.discount_percent = room.holdDiscountPercent;
								entry.discount_comment = room.holdDiscountComment;
								entry.discount_type = room.holdDiscountType || 'per_night';
								if (room.holdNightlyDiscounts && room.holdNightlyDiscounts.length) {
									entry.nightly_discount = room.holdNightlyDiscounts.join(',');
									entry.nightly_discount_comment = (room.holdNightlyComments || []).join('|');
								}
							}
							if (Object.keys(entry).length) {
								roomDiscounts[room.product_id] = entry;
							}
						});
						if (Object.keys(roomDiscounts).length) {
							vm.data.room_discounts = roomDiscounts;
						} else {
							delete vm.data.room_discounts;
						}
						delete vm.data.promotion_code;
						delete vm.data.promo_discount;
						delete vm.data.manual_discount;
						delete vm.data.discount_percent;
						delete vm.data.discount_comment;
						delete vm.data.discount_type;
						delete vm.data.nightly_discount;
						delete vm.data.nightly_discount_comment;
						if (typeof vm.new_adult !== 'undefined') {
							vm.data.room_stay_guest_count = parseInt(vm.new_adult);
							vm.data.adult = parseInt(vm.new_adult);
						}
						if (typeof vm.new_child !== 'undefined') {
							vm.data.room_stay_child_count = parseInt(vm.new_child);
							vm.data.child = parseInt(vm.new_child);
						}
						ganttChartService.saveHoldBlockDates({data:vm.data,adult:vm.new_adult,child:vm.new_child,created_from:'common',prod_id:JSON.stringify(vm.selectedRoom1),prod_name:JSON.stringify(vm.selectedRoomName),room_stay_from:moment(vm.new_checkin).format('MM/DD/YYYY'),room_stay_to:moment(vm.new_checkout).format('MM/DD/YYYY')}).then(function(response){
							if(response.success ){
								closeDialog();
								if($state.current.name == 'app.newGanttChart')
									$state.go($state.current, {}, {reload: true});
								else
									$state.go('app.newGanttChart');
							}else{
								vm.holdSending = false;
								vm.enableAdd = true;
								toastMessage.showSimpleToast(response.errorMsg,'error-toast');
							}
						}, function() {
							vm.holdSending = false;
							vm.enableAdd = true;
						});
					}
				}else if(type == 'currentorder'){
					var currentOrderParams = {
						prod_id:JSON.stringify(vm.selectedRoom1),
						from:moment(vm.new_checkin).format('MM/DD/YYYY'),
						to:moment(vm.new_checkout).format('MM/DD/YYYY'),
						adult:vm.new_adult,
						child:vm.new_child,
						itinerary_number:vm.itin_no,
						from_page:'header',
						'addToItinery' : true,
						negotiatedCustId: vm.negotiatedCustId,
						creationSource:'Quick Access'
					};
					if(vm.isDayReservationContext()){
						currentOrderParams.cart_type = 'day_reservation';
						currentOrderParams.to = currentOrderParams.from;
					}
					$state.go('app.create-res', currentOrderParams);
				}else if(type == 'changeCartItem'){
					if (vm.show_save) {					
						vm.selectedRoom1 = {};
						vm.selectedRoom1[vm.changeCartItemData.product_id] = vm.changeCartItemData.policy_id;

						var changeCartRequest = {
								prod_id:vm.selectedRoom1,
								from:moment(vm.new_checkin).format('YYYY-MM-DD'),
								to:moment(vm.new_checkout).format('YYYY-MM-DD'),
								adult:vm.new_adult,
								child:vm.new_child,
								itinerary_number:vm.itin_no,
								checkAvailability:true,
								block_conf_no:vm.changeCartItemData.block_conf_no,
								negotiatedCustId: vm.negotiatedCustId,
								selectedRatePlanId: vm.selectedRatePlanId,
								promoCodeInfo: vm.promoCodeInfo
							};
						if(vm.isDayReservationContext()){
							changeCartRequest.cart_type = 'day_reservation';
							changeCartRequest.type_of_reservation = 'day_reservation';
							changeCartRequest.to = changeCartRequest.from;
						}
						createResService.getcartData(changeCartRequest).then(function(response) {
							// return;
							if(response.availablity_error && parseInt(Object.keys(response.available_rooms).length) != 0){
								vm.show_rooms = true;
								vm.available_rooms = response.available_rooms;
								vm.show_save = false;
								vm.selectedRoom1 = {};
							} else if(response.availablity_error && parseInt(Object.keys(response.available_rooms).length) == 0){
								vm.available_rooms = response.available_rooms;
								vm.selectedRoom1 = {};
							} else {
								if(response.success){
									vm.closeDialog();
									$rootScope.$broadcast('update_cart_data',{data:response,changeIndex:vm.changeCartItemData.index});
								}else{
									toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'), 'error-toast');
								}
							}
						});
					} else {
						var changeCartSelectRequest = {
							prod_id:vm.selectedRoom1,
							from:moment(vm.new_checkin).format('YYYY-MM-DD'),
							to:moment(vm.new_checkout).format('YYYY-MM-DD'),
							adult:vm.new_adult,
							child:vm.new_child,
							negotiatedCustId: vm.negotiatedCustId
						};
						if(vm.isDayReservationContext()){
							changeCartSelectRequest.cart_type = 'day_reservation';
							changeCartSelectRequest.type_of_reservation = 'day_reservation';
							changeCartSelectRequest.to = changeCartSelectRequest.from;
						}
						createResService.getcartData(changeCartSelectRequest).then(function(response) {
							if (response.success) {
								vm.closeDialog();
								$rootScope.$broadcast('update_cart_data',{data:response,changeIndex:vm.changeCartItemData.index});
							} else {
								toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'), 'error-toast');
							}
						});
					}
				}else{
					var addCartRequest = {
						prod_id:vm.selectedRoom1,
						from:moment(vm.new_checkin).format('YYYY-MM-DD'),
						to:moment(vm.new_checkout).format('YYYY-MM-DD'),
						adult:vm.new_adult,
						child:vm.new_child,
						negotiatedCustId: vm.negotiatedCustId
					};
					if(vm.isDayReservationContext()){
						addCartRequest.cart_type = 'day_reservation';
						addCartRequest.type_of_reservation = 'day_reservation';
						addCartRequest.to = addCartRequest.from;
					}
					createResService.getcartData(addCartRequest).then(function(response) {
						if(response.success){

							vm.closeDialog();
							$rootScope.$broadcast('update_cart_data',{data:response});
						}else{
							toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'), 'error-toast');
						}
					});
				}
			}
		}

       /**
	   * Close dialog
	   */
	   function closeDialog()
       {
           $mdDialog.hide();
       }
       vm.readHoldDescription = function(id) {
       		var desc = document.getElementById('hold_description_' + id);
       		var button = document.getElementById('hold_readmoreblock_' + id);
       		if (!desc || !button) { return; }
       		if (button.innerHTML.indexOf('Show description') !== -1) {
       			button.innerHTML = 'Hide description';
       			desc.style.display = 'block';
       		} else {
       			button.innerHTML = 'Show description';
       			desc.style.display = 'none';
       		}
       };
       function readDescription(id)
       {
       		var descId = "description_"+id;
       		var buttonId = "readmoreblock_"+id;
       		var displayText = document.getElementById(buttonId).innerHTML;
       		var display = document.getElementById(descId).style.display;
       		if(displayText == 'Show description'){
       			document.getElementById(buttonId).innerHTML = 'Hide description';
       			document.getElementById(descId).style.display = 'block';
       		}
       		else{
       			document.getElementById(buttonId).innerHTML  = 'Show description';
       			document.getElementById(descId).style.display = 'none';	
       		}
          
       }

	   /*****************************************/
	   /***** Reset available rooms *************/
	   /*****************************************/
	   vm.changeType = function() {
		   vm.available_rooms = [];
		   vm.boat_length = '';
	   }
	   
	   	vm.getClass = function(room_number){
	   		var cssClass = '';
	   		if (vm.showRateUI())
		   		cssClass = 'createResCase';
		   	else 
		   		cssClass = 'hold_block_rooms';

	   		if (vm.villaRooms.indexOf(room_number) != -1) {
	   			cssClass = cssClass +' blockedRoom';
	   		}

		   	return cssClass;
	   	}

	    vm.type_changed = function(){
			vm.isCommentEmpty = false;
			vm.available_rooms = {};
			vm.show_rooms = false;
			vm.selectedRoom1 = {};
			vm.selectedRoom = {};
			vm.temp = {};
			vm.enableAdd = false;
			vm.roomObjectValidation = true;
			vm.showHoldGuestStep = false;
			vm.holdSelectedRooms = [];
			if(vm.isDayCreateMode()){
				// Same-day stay: clear overnight min-date so checkout (= checkin) is not marked invalid
				vm.minDateCheckout = null;
				vm.new_checkout = angular.copy(vm.new_checkin);
				vm.requestType = false;
				$timeout(function() {
					vm.new_checkout = angular.copy(vm.new_checkin);
				});
			} else if(vm.data.type_of_reservation === 'reservation'){
				vm.minDateCheckout = new Date(moment(vm.new_checkin).add(1, 'days'));
				var endDate = moment(vm.new_checkout);
				var startDate = moment(vm.new_checkin);
				if(endDate.isBefore(startDate) || endDate.isSame(startDate)){
					vm.new_checkout = new Date(moment(startDate).add(1, 'days'));
				}
			}
	    }

	    setTimeout(function() {
		   vm.autoFillOff = false;
		}, 1500); 

		 //Code 	to conditionaly run click event
       	vm.runClickEvent = false;
       	if($( window ).width() <= 1020){
       		vm.runClickEvent = true;
       	};


	    vm.showBlock = [];
	    vm.showRateDesc = [];
	    vm.showOverlay = false;
	    // function to close all details popup
	    vm.closeAllDetails = function(){
	    	angular.forEach(vm.showBlock,function(rval,rkey){
				angular.forEach(rval,function(pval,pkey){
					vm.showBlock[rkey][pkey] = false;
					vm.showOverlay = false;
				});
			});
	    }

	    // function to show hide detail popup
		vm.showDetailBlock = function(roomkey,policyKey){
			angular.forEach(vm.showBlock,function(rval,rkey){
				angular.forEach(rval,function(pval,pkey){
					if(rkey == roomkey && pkey == policyKey){
						vm.showBlock[rkey][pkey] = !vm.showBlock[rkey][pkey];
						if(vm.showBlock[rkey][pkey]){
							vm.showOverlay = true;
						} else {
							vm.showOverlay = false;
						}
					} else {
						vm.showBlock[rkey][pkey] = false;
					}
				});
			});
		}

		vm.showDetailRateBlock = function(roomkey,policyKey){
			angular.forEach(vm.showRateDesc,function(rval,rkey){
				angular.forEach(rval,function(pval,pkey){
					if(rkey == roomkey && pkey == policyKey){
						vm.showRateDesc[rkey][pkey] = !vm.showRateDesc[rkey][pkey];
						if(vm.showRateDesc[rkey][pkey]){
							vm.showOverlay = true;
						} else {
							vm.showOverlay = false;
						}
					} else {
						vm.showRateDesc[rkey][pkey] = false;
					}
				});
			});
		}

		// function to close all details popup
	    vm.closeAllRateDetails = function(){
	    	angular.forEach(vm.showRateDesc,function(rval,rkey){
				angular.forEach(rval,function(pval,pkey){
					vm.showRateDesc[rkey][pkey] = false;
				});
			});
	    }

		/**
		* Comment: Change value of selected sub hotel Id
		*/
		vm.showtabs = function(hotelId) {
        	vm.selectedSubHotelId = hotelId;
        };
    }

})();

(function() {
    'use strict';

    angular.module('app.create-res')
        .controller('addController', addController);

    /** @ngInject */
    function addController(
        $mdDialog,
        $state,
        customerIndex,
        createResService,
        $localStorage,
        toastMessage,
        $rootScope,
        typeOfCust,
        $timeout,
        Country,
        userService,
        $q,
        $scope,
        allTabs,
        commonCustomer,
        allTraveller,
        addRoomInItin,
        eCommerceService,
        $sessionStorage,
        pageType,
        $anchorScroll
    ) {
        var vm = this;

        vm.cartIndex = customerIndex;
        vm.allTabs = angular.copy(allTabs);
        vm.travellerDetails = [];
        vm.selectedStateTraveller = [];
        vm.selectedCountryTraveller = [];
        vm.travellerDetails[0] = true;
        vm.data = {};
        vm.closeDialog = closeDialog;
        vm.contact = {};
        vm.pop_header = 'Add Customer';
        vm.contact.is_active = 1;
        vm.addRoomInItin = addRoomInItin;
        vm.duplicateEmail = false;
        vm.contact.tax_exempt_indicator = false;
        vm.contact.send_email_indicator = true;
        vm.checkDuplicateEmail = checkDuplicateEmail;
        vm.addNewCustomer = addNewCustomer;
        vm.hotel_id = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
        vm.countries = vm.states = [];
        vm.querySearch = querySearch;
        vm.selectedSearch = [];
        vm.buttonType = 'Add';
        vm.pageType = pageType;
        vm.phoneValidity = {};

        function getFullPhone(fieldName, isTraveller) {
            var selector = isTraveller
                ? '.intel-number-input-traveller[name="' + fieldName + '"]'
                : '.intel-number-input:not(.intel-number-input-traveller)[name="' + fieldName + '"]';
        
            var el = document.querySelector(selector);
            if (!el) {
                return '';
            }
            var iti = angular.element(el).data('iti');
            var val = el.value.trim();
        
            if (!val) {
                return '';
            }
            if (!iti) {
                return val;
            }
            var countryData = iti.getSelectedCountryData();
            var dialCode = '+' + countryData.dialCode;
            var localNumber = val;
            if (localNumber.indexOf(dialCode) === 0) {
                localNumber = localNumber.substring(dialCode.length);
            }
            localNumber = localNumber.trim();
            return dialCode + ' ' + localNumber;
        }

        function setPhoneInputFields(contactData, isTraveller) {
            if (!contactData || !contactData.phone_number) return;
            var selector = isTraveller
                ? '.intel-number-input-traveller[name="phone_number"]'
                : '.intel-number-input:not(.intel-number-input-traveller)[name="phone_number"]';
            var input = document.querySelector(selector);
            if (!input) return;
            var iti = angular.element(input).data('iti');
            if (!iti) return;
            iti.setNumber(contactData.phone_number);
            contactData.phone_number = input.value.trim();
        }

        var pendingCustomer = null;
        var pendingTraveller = null;
        var phoneFieldsInitialized = false;

        function initPhoneFieldsOnce() {
            if (phoneFieldsInitialized) return;
            phoneFieldsInitialized = true;
            setPhoneInputFields(vm.contact, false);
            if (vm.contactTraveller && vm.contactTraveller.length) {
                angular.forEach(vm.contactTraveller, function (traveller) {
                    setPhoneInputFields(traveller, true);
                });
            }
        }

        vm.isRequestTrue = true;
        vm.hidePassword = false;

        vm.autoFillOff = true;

        vm.searchTxtCountryTraveller = [];
        vm.searchTxtStateTraveller = [];
        var actualCustomer = [];

        if (commonCustomer) {
            vm.contact = angular.copy(commonCustomer);
            actualCustomer = angular.copy(vm.contact);

            vm.searchTextFn = vm.contact['first_name'];
            vm.searchTextLn = vm.contact['last_name'];
            vm.searchTextEm = vm.contact['customer_email'];

            vm.searchTxtState = vm.contact['state'];
            if (!vm.contact['state']) {
                vm.contact['state'] = '';
            }
            if (vm.contact['state'] && vm.contact['state'].length > 0) {
                vm.selectedState = {
                    value: vm.contact['state'].toLowerCase(),
                    display: vm.contact['state']
                };
                vm.searchTxtState = vm.selectedState['display'];

            }
            if (vm.contact['country'] && vm.contact['country'].length > 0) {
                vm.selectedCountry = {
                    value: vm.contact['country'].toLowerCase(),
                    display: vm.contact['country']
                };
                vm.searchTxtCountry = vm.selectedCountry['display'];

            }
        } else {
            vm.selectedCountry = {
                value: "united states",
                display: "United States"
            };
        }
        var tempTravellers = [];
        var customerEmail = vm.contact['customer_email'];

        vm.searchTextTravTravellerFn = [];
        vm.searchTextTravellerLn = [];
        vm.searchTextTravellerEm = [];

        var element = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][customerIndex];
        if (element) {
            if (typeof vm.searchTextTravTravellerFn[0] == 'undefined') {
                vm.searchTextTravTravellerFn[0] = [];
                vm.searchTextTravellerLn[0] = [];
                vm.searchTextTravellerEm[0] = [];
            }
            if (typeof element['cust_info'] != 'undefined') {
                if (element['cust_info']['customer_email'] != customerEmail) {
                    tempTravellers.push(element['cust_info']);
                    vm.travellerDetails[0] = false;

                    vm.searchTextTravTravellerFn[0] = element['cust_info']['first_name'];
                    vm.searchTextTravellerLn[0] = element['cust_info']['last_name'];
                    vm.searchTextTravellerEm[0] = element['cust_info']['customer_email'];

                    // vm.selectedCountryTraveller[0] = {value: element['cust_info']['country'].toLowerCase(), display: element['cust_info']['country']};
                    // vm.searchTxtCountryTraveller[0] = element['cust_info']['country'];
                    // vm.searchTxtStateTraveller[0] = element['cust_info']['state'];
                    if (element['cust_info']['country'].length > 0) {
                        vm.selectedCountryTraveller[0] = {
                            value: element['cust_info']['country'].toLowerCase(),
                            display: element['cust_info']['country']
                        };
                        vm.searchTxtCountryTraveller[0] = vm.selectedCountryTraveller['display'];
                    } else {
                        vm.searchTxtCountryTraveller[0] = '';
                    }
                    if (element['cust_info']['state'].length > 0) {
                        vm.searchTxtStateTraveller[0] = element['cust_info']['state'];
                    } else {
                        vm.searchTxtStateTraveller[0] = '';
                    }
                } else {
                    tempTravellers.push(vm.contact);
                    vm.travellerDetails[0] = true;
                    vm.searchTextTravTravellerFn[0] = vm.contact['first_name'];
                    vm.searchTextTravellerLn[0] = vm.contact['last_name'];
                    vm.searchTextTravellerEm[0] = vm.contact['customer_email'];

                    //    vm.selectedCountryTraveller[0] = {value: vm.contact['country'].toLowerCase(), display: vm.contact['country']};
                    //    vm.searchTxtCountryTraveller[0] = vm.contact['country'];
                    //    vm.searchTxtStateTraveller[0] = vm.contact['state'];

                    if (vm.contact['country'].length > 0) {
                        vm.selectedCountryTraveller[0] = {
                            value: vm.contact['country'].toLowerCase(),
                            display: vm.contact['country']
                        };
                        vm.searchTxtCountryTraveller[0] = vm.selectedCountryTraveller['display'];
                    } else {
                        vm.searchTxtCountryTraveller[0] = '';
                    }
                    if (vm.contact['state'].length > 0) {
                        vm.searchTxtStateTraveller[0] = vm.contact['state'];
                    } else {
                        vm.searchTxtStateTraveller[0] = '';

                    }

                }
            } else {
                vm.travellerDetails[0] = true;
                tempTravellers.push(vm.contact);
                vm.searchTextTravTravellerFn[0] = vm.contact['first_name'];
                vm.searchTextTravellerLn[0] = vm.contact['last_name'];
                vm.searchTextTravellerEm[0] = vm.contact['customer_email'];
                if (vm.contact['country'] && vm.contact['country'].length > 0) {
                    vm.selectedCountryTraveller[0] = {
                        value: vm.contact['country'].toLowerCase(),
                        display: vm.contact['country']
                    };
                    vm.searchTxtCountryTraveller[0] = vm.selectedCountryTraveller['display'];
                } else {
                    vm.searchTxtCountryTraveller[0] = '';
                }
                if (vm.contact['country'] && vm.contact['state'].length > 0) {
                    vm.searchTxtStateTraveller[0] = vm.contact['state'];
                } else {
                    vm.searchTxtStateTraveller[0] = '';

                }
            }

        }

        if (tempTravellers) {
            vm.contactTraveller = angular.copy(tempTravellers);
        }

        function querySearch(query, myField) {
            if (vm.isRequestTrue) {
                var deferred = $q.defer();
                createResService.getCustomers({
                        search: query,
                        field: myField,
                        pageFrom: 'reservation'
                    })
                    .then(function(response) {
                        deferred.resolve(response[0].customerList);
                    });
                return deferred.promise;
            } else {
                return [];
                vm.hidePassword = true;
            }
        }

        vm.updateTravellerArray = updateTravellerArray;

        function updateTravellerArray(index) {
            if (!vm.travellerDetails[index]) {
                vm.contactTraveller.splice(index, 1);
            }
        }
        vm.deletePreviousData = deletePreviousData;
        var newIndex = '';
        function deletePreviousData(index) {
            initAutocompleteAddressTraveller();
            initAutocompleteZipTraveller();
            newIndex = index;
            if (vm.travellerDetails[index]) {
                vm.contactTraveller[index] = vm.contact;
                vm.searchTextTravellerEm[index] = vm.contact['customer_email'];
            } else {
                vm.contactTraveller[index] = [];
                vm.searchTextTravTravellerFn[index] = '';
                vm.searchTextTravellerLn[index] = '';
                vm.searchTextTravellerEm[index] = '';
                vm.searchTxtCountryTraveller[index] = '';
                vm.searchTxtStateTraveller[index] = '';
                vm.selectedSearchTraveller = [];
            }

        }
        vm.selectCustomer = selectCustomer;
        vm.queryProgress = false;

        vm.hasDnrTag = function (customer) {
            if (!customer || !angular.isArray(customer.customer_tag)) {
                return false;
            }
            return customer.customer_tag.some(function (tag) {
                return (tag || '').toLowerCase().trim() === 'dnr';
            });
        };


        function selectCustomer() {
            if (vm.hasDnrTag(vm.contact)) {
                var contactName = getContactName(vm.contact);

                return showDnrConfirmation(
                    'DNR Customer',
                    'The customer <b>' + (contactName || 'Unknown') +
                    '</b> has been marked as <b>DNR (Do Not Rent)</b>.<br/><br/>' +
                    'Are you sure you want to continue creating this reservation?',
                    proceedAfterContactDnrCheck
                );
            }

            proceedAfterContactDnrCheck();
        }

        function getContactName(contact) {
            return (
                (contact.first_name || vm.searchTextFn || '') + ' ' +
                (contact.last_name || vm.searchTextLn || '')
            ).trim();
        }

        function getDnrTravellers() {
            var dnrTravellers = [];

            if (!vm.contactTraveller || !vm.contactTraveller.length) {
                return dnrTravellers;
            }

            angular.forEach(vm.contactTraveller, function (traveller, index) {
                // Skip traveller if they are already the selected contact/customer
                if (vm.travellerDetails[index] || !vm.hasDnrTag(traveller)) {
                    return;
                }

                var name = (
                    (traveller.first_name || '') + ' ' +
                    (traveller.last_name || '')
                ).trim();

                dnrTravellers.push(name || 'Traveller ' + (index + 1));
            });

            return dnrTravellers;
        }

        function proceedAfterContactDnrCheck() {
            var dnrTravellers = getDnrTravellers();

            if (!dnrTravellers.length) {
                return proceedAfterDnrCheck();
            }

            var namesList = dnrTravellers.map(function (name) {
                return '<b>' + name + '</b>';
            }).join(', ');

            var travellerText = dnrTravellers.length === 1
                ? 'The traveller '
                : 'The travellers ';

            var verb = dnrTravellers.length === 1 ? ' has' : ' have';

            var html = travellerText +
                namesList +
                verb +
                ' been marked as <b>DNR (Do Not Rent)</b>.<br/><br/>' +
                'Are you sure you want to continue creating this reservation?';

            showDnrConfirmation(
                'DNR Traveller',
                html,
                proceedAfterDnrCheck
            );
        }

        function showDnrConfirmation(title, html, onContinue) {
            $mdDialog.show({
                controller: 'confirmController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                multiple: true,
                locals: {
                    title: title,
                    htmlContent: html,
                    cancelBtn: 'Cancel',
                    OkBtn: 'Continue'
                }
            }).then(function (answer) {
                if (answer === 'update') {
                    onContinue();
                } else {
                    $state.go('app.e-commerce.orders');
                }
            }, function () {
                $state.go('app.e-commerce.orders');
            });
        }

        function proceedAfterDnrCheck() {
            /* Check if user tax exempt status has been updated and has existing reservation */
            if (
                typeof actualCustomer['tax_exempt_indicator'] != 'undefined' &&
                actualCustomer['tax_exempt_indicator'] != vm.contact['tax_exempt_indicator']
            ) {
                vm.updateTaxExemptStatus();
            } else {
                vm.processRequestFurther();
            }
        }
        vm.updateTaxExemptStatus = function(){
            var data = {
                'customer_id' : vm.contact['customer_id']
            };
            /*eCommerceService.getUserResevations(data).then(function(response){
                if(response.success){
                    var event = '';
                    var allLinks = '';
                    response['reservationDetails'].forEach(function(element, index){
                        allLinks += "<b class='onlycursorPointer' ng-click='vm.goToReservaion("+element.reservation_id+", "+element.confirmation_number+")' > -- "+element.itinerary_number+".</b></br>";

                    });
                    var html = "Updating user's tax exempt status will update tax from user's ongoing and future reservations as well.</br></br>";
                     html = html + allLinks;
                    $mdDialog.show({
                          controller: 'confirmController',
                          controllerAs: 'vm',
                          templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                          parent: angular.element(document.body),
                          targetEvent: event,
                          clickOutsideToClose:true ,
                          onRemoving: function(answer) {
                                vm.contact['tax_exempt_indicator'] =  vm.contact['tax_exempt_indicator']  ? false : true;
                          },
                          locals: {
                                title: 'Customer has existing reservations.',
                                htmlContent:html,
                                cancelBtn:'Cancel',
                                OkBtn:'Proceed'
                            }
                        })
                        .then(function(answer) {
                           if(typeof answer != 'undefined' && answer == 'update'){
                            vm.contact['tax_exempt_indicator'] =  vm.contact['tax_exempt_indicator']  ? false : true;
                            vm.processRequestFurther();
                           }
                        }, function(){
                    });
                }else{
                    vm.processRequestFurther();
                }
            });*/
            vm.processRequestFurther();
        };

        vm.processRequestFurther = function(){
            vm.queryProgress = true;
            vm.QueryType = 'update';
            var key = 0;
            pendingCustomer = null;
            pendingTraveller = null;
            vm.contact['hotel_id'] = vm.hotel_id;
            vm.contact['first_name'] = vm.searchTextFn;
            vm.contact['last_name'] = vm.searchTextLn;
            vm.contact['customer_email'] = vm.searchTextEm;
            vm.contact['country'] = vm.searchTxtCountry;
            vm.contact['state'] = vm.searchTxtState;
            vm.contact['tax_exempt_id'] = vm.contact.tax_exempt_id;
            vm.contact['is_account_virtual'] = 1;

            var customerPayload = angular.copy(vm.contact);
            customerPayload.phone_number = getFullPhone('phone_number', false) || customerPayload.phone_number;

            var responsCust = false;
            var responsTrav = false;
            createResService.checkCustomerDuplicateEmail(vm.searchTextEm, vm.hotel_id).then(function(response) {
                if(!response.success && typeof vm.customer_id == 'undefined'){
                    addNewCustomer(key, 'customer');
                    responsCust = true;
                    vm.QueryType = 'add';
                    customerTravellerResponse(responsTrav, responsCust, key);
                }else{
                    if (!customerPayload.customer_id && response.customer_id) {
                        customerPayload.customer_id = response.customer_id;
                        vm.contact.customer_id = response.customer_id;
                    }
                    responsCust = true;

                    createResService.updateCustomer(customerPayload).then(function(response) {
                       createResService.getCustomers({
                        customer_id: customerPayload['customer_id'],
                        selectedHotel:  customerPayload['hotel_id']
                        })
                        .then(function(response) {
                                vm.contact = response[0].customerList[0];
                                customerTravellerResponse(responsTrav, responsCust, key);
                        });

                    });
                }
            });
            var key = 0;
            if (vm.travellerDetails[0]) {
                responsTrav = true;
                customerTravellerResponse(responsTrav, responsCust, key);
            } else {
                var travellerPayload = angular.copy(vm.contactTraveller[key]);
                travellerPayload['is_account_virtual'] = 1;
                travellerPayload['hotel_id'] = vm.hotel_id;
                travellerPayload['first_name'] = vm.searchTextTravTravellerFn[key];
                travellerPayload['last_name'] = vm.searchTextTravellerLn[key];
                travellerPayload['customer_email'] = vm.searchTextTravellerEm[key];
                travellerPayload['country'] = vm.searchTxtCountryTraveller[key];
                travellerPayload['state'] = vm.searchTxtStateTraveller[key];
                travellerPayload['tax_exempt_indicator'] = vm.contactTraveller[key].tax_exempt_indicator;
                travellerPayload['tax_exempt_id'] = vm.contactTraveller[key].tax_exempt_id;
                if (vm.searchTxtCountryTraveller[key].length != 0)
                    travellerPayload['state'] = vm.searchTxtStateTraveller[key];
                if (vm.searchTxtStateTraveller[key].length != 0)
                    travellerPayload['country'] = vm.searchTxtCountryTraveller[key];
                travellerPayload['phone_number'] = getFullPhone('phone_number', true) || travellerPayload.phone_number;

                createResService.checkCustomerDuplicateEmail(travellerPayload['customer_email'], vm.hotel_id).then(function(response) {

                    responsTrav = true;
                    if (!travellerPayload.customer_id && response.customer_id) {
                        travellerPayload.customer_id = response.customer_id;
                        vm.contactTraveller[key].customer_id = response.customer_id;
                    }

                    if (response.success) {
                        createResService.updateCustomer(travellerPayload).then(function(response) {
                             createResService.getCustomers({
                                customer_id: travellerPayload['customer_id'],
                                selectedHotel:  travellerPayload['hotel_id']
                            })
                            .then(function(response) {
                                if (response[0] && response[0].customerList && response[0].customerList[0]) {
                                    pendingTraveller = response[0].customerList[0];
                                }
                                customerTravellerResponse(responsTrav, responsCust, key);
                            });
                        });
                    } else {
                        addNewCustomer(key, 'traveller');
                        vm.QueryType = 'add';
                        customerTravellerResponse(responsTrav, responsCust, key);
                    }

                });
            }
        }

        vm.customerTravellerResponse = customerTravellerResponse;
        function customerTravellerResponse(responsTrav, responsCust, key) {
            if (responsTrav && responsCust) {
                var customer = pendingCustomer || angular.copy(vm.contact);
                var traveller = pendingTraveller || angular.copy(vm.contactTraveller[key]);
                if (!pendingCustomer) {
                    customer.phone_number = getFullPhone('phone_number', false) || customer.phone_number;
                }
                if (!pendingTraveller) {
                    traveller.phone_number = getFullPhone('phone_number', true) || traveller.phone_number;
                }
                if (vm.travellerDetails[0] || customer['customer_email'] == traveller['customer_email']) {
                    traveller = customer;
                }
                if(typeof customer['customer_id'] == 'undefined' || typeof traveller['customer_id'] == 'undefined') {
                    $timeout(function() {
                        customerTravellerResponse(responsTrav, responsCust, key);
                    }, 500);
                } else {
                    vm.queryProgress = false;
                    $rootScope.$broadcast('update_reservation_contact',{customer: customer, traveller: traveller, cartIndex: vm.cartIndex});
                    $mdDialog.hide({
                        selectUserConfirmed: true,
                        cartIndex: vm.cartIndex
                    });
                }
            }

        }


        vm.updateForm = updateForm;

        function updateForm(item, field) {
            if (typeof item != 'undefined' && vm.isRequestTrue) {
                vm.isRequestTrue = false;
                if (item) {
                    vm.hidePassword = true;
                    vm.buttonType = 'AutoSelect';
                    vm.selectedItem = item;
                } else {
                    vm.hidePassword = false;
                    vm.buttonType = 'Add';
                }
                if (field == 'cust.first_name') {
                    vm.selectedSearch.last_name = item.last_name;
                    vm.selectedSearch.customer_email = item.customer_email;
                    vm.selectedSearch.phone_number = item.phone_number;
                }
                if (field == 'cust.last_name') {
                    vm.selectedSearch.first_name = item.first_name;
                    vm.selectedSearch.customer_email = item.customer_email;
                    vm.selectedSearch.phone_number = item.phone_number;
                }
                if (field == 'cust.customer_email') {
                    vm.selectedSearch.first_name = item.first_name;
                    vm.selectedSearch.last_name = item.last_name;
                    vm.selectedSearch.phone_number = item.phone_number;
                }

                $timeout(function() {
                    vm.isRequestTrue = true;
                    if (item.state.length > 0) {
                        vm.selectedState = {
                            value: item['state'].toLowerCase(),
                            display: item['state']
                        };
                        vm.searchTxtState = vm.selectedState['display'];
                    } else {
                        vm.selectedState = '';
                    }

                }, 1000);
                vm.contact = item;
                $timeout(function () {
                    setPhoneInputFields(vm.contact, false);
                }, 300);

                if (item['country'].length > 0) {
                    vm.selectedCountry = {
                        value: item['country'].toLowerCase(),
                        display: item['country']
                    };
                    vm.searchTxtCountry = vm.selectedCountry['display'];
                } else {
                    vm.selectedCountry = '';
                }

                if (!item.tax_exempt_indicator) {
                    vm.contact['tax_exempt_indicator'] = false;
                } else {
                    vm.contact['tax_exempt_indicator'] = item.tax_exempt_indicator == 1 ? true : false;
                }
                if (!item.send_email_indicator) {
                    vm.contact['send_email_indicator'] = true;
                } else {
                    vm.contact['send_email_indicator'] = item.send_email_indicator == 1 ? true : false;
                }

                if (item.negotiated_rate_customer != undefined && item.negotiated_rate_customer > 0) {
                    vm.travellerDetails[0] = false;
                    $timeout(function() {
                        $anchorScroll('moveToTravellerDiv');
                    }, 200);
                }
                actualCustomer = angular.copy(vm.contact);
            }
        }

        vm.validateUser = validateUser;

        function validateUser(index) {
            var status = false;
            var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if (!filter.test(vm.searchTextEm)) {
                status = true;
            }
            if (vm.phoneValidity['customer_phone_number'] === false) {
              status = true;
            }

            if (!vm.travellerDetails[index]) {
                if (!filter.test(vm.searchTextTravellerEm[index])) {
                    status = true;
                }
                if (vm.phoneValidity['traveller_phone_number'] === false) {
                  status = true;
                }
            }
            return status;

        }

        vm.updateTravellerForm = updateTravellerForm;

        function updateTravellerForm(item, field, travellerIndex) {
            if (typeof item != 'undefined' && vm.isRequestTrue) {
                vm.isRequestTrue = false;
                vm.contactTraveller[travellerIndex] = angular.copy(item);
                $timeout(function () {
                    setPhoneInputFields(vm.contactTraveller[travellerIndex], true);
                }, 300);

                if (item) {
                    vm.hidePassword = true;
                    vm.buttonType = 'AutoSelect';
                    vm.selectedItem = item;
                } else {
                    vm.hidePassword = false;
                    vm.buttonType = 'Add';
                }
                if (field == 'cust.first_name') {
                    vm.selectedSearchTraveller[travellerIndex].last_name = item.last_name;
                    vm.selectedSearchTraveller[travellerIndex].customer_email = item.customer_email;
                    vm.selectedSearchTraveller[travellerIndex].phone_number = item.phone_number;
                }
                if (field == 'cust.last_name') {
                    vm.selectedSearchTraveller[travellerIndex].first_name = item.first_name;
                    vm.selectedSearchTraveller[travellerIndex].customer_email = item.customer_email;
                    vm.selectedSearchTraveller[travellerIndex].phone_number = item.phone_number;
                }
                if (field == 'cust.customer_email') {
                    vm.selectedSearchTraveller[travellerIndex].first_name = item.first_name;
                    vm.selectedSearchTraveller[travellerIndex].last_name = item.last_name;
                    vm.selectedSearchTraveller[travellerIndex].phone_number = item.phone_number;
                }
                $timeout(function() {
                    vm.isRequestTrue = true;

                }, 2000);

                vm.selectedCountryTraveller[0] = {
                    value: item['country'].toLowerCase(),
                    display: item['country']
                };
                vm.searchTxtCountryTraveller[0] = item['country'];
                vm.searchTxtStateTraveller[0] = item['state'];

                if (!vm.contactTraveller) {
                    vm.contactTraveller = [];
                }
                vm.contactTraveller[travellerIndex] = angular.copy(item);

                if (!item.tax_exempt_indicator) {
                    vm.contactTraveller[travellerIndex]['tax_exempt_indicator'] = false;
                } else {
                    vm.contactTraveller[travellerIndex]['tax_exempt_indicator'] = item.tax_exempt_indicator == 1 ? true : false;
                }
                if (!item.send_email_indicator) {
                    vm.contactTraveller[travellerIndex]['send_email_indicator'] = true;
                } else {
                    vm.contactTraveller[travellerIndex]['send_email_indicator'] = item.send_email_indicator == 1 ? true : false;
                }
                //vm.travellerDetails[travellerIndex] = true;
            }
        }



        vm.countryList = [];
        vm.stateList = [];
        Country.forEach(function(element) {
            vm.countryList.push(element.name);
        });

        selectedItemChange();
        vm.selectedItemChangeState = selectedItemChangeState;

        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        function checkDuplicateEmail(email, type) {
            if (type == 'customer') {
                vm.CustomerEmail
            }
            vm.CustomerEmail = false
            createResService.checkCustomerDuplicateEmail(email, vm.hotel_id).then(function(response) {
                if (response.success) {
                    vm.CustomerEmail = true;
                }
            });
        }

        function addNewCustomer(key, type) {
            var addData = {};
            var country = '';
            var state = '';
            if (type == 'customer') {
                if (typeof vm.searchTxtCountry != undefined && vm.searchTxtCountry != '')
                    country = vm.searchTxtCountry;

                if (typeof vm.searchTxtState != undefined && vm.searchTxtState != '')
                    state = vm.searchTxtState;


                addData = {
                    'first_name': vm.searchTextFn,
                    'last_name': vm.searchTextLn,
                    'phone_number': getFullPhone('phone_number', false) || vm.contact.phone_number,
                    'customer_email': vm.searchTextEm,
                    'address': vm.contact.address,
                    'city': vm.contact.city,
                    'state': state,
                    'hotel_id': vm.hotel_id,
                    'is_active': 1,
                    'zip_code': vm.contact.zip_code,
                    'country': country,
                    'tax_exempt_indicator': angular.copy(vm.contact.tax_exempt_indicator ? 1 : 0),
                    'tax_exempt_id': vm.contact.tax_exempt_id,
                    'send_email_indicator': angular.copy(vm.contact.send_email_indicator ? 1 : 0)
                }

            } else {
                if (typeof vm.searchTxtStateTraveller[key] != undefined && vm.searchTxtStateTraveller[key] != '')
                    state = vm.searchTxtStateTraveller[key];

                if (typeof vm.searchTxtCountryTraveller[key] != undefined && vm.searchTxtCountryTraveller[key] != '')
                    country = vm.searchTxtCountryTraveller[key];

                addData = {
                    'first_name': vm.searchTextTravTravellerFn[key],
                    'last_name': vm.searchTextTravellerLn[key],
                    'phone_number': getFullPhone('phone_number', true) || vm.contactTraveller[key].phone_number,
                    'customer_email': vm.searchTextTravellerEm[key],
                    'address': vm.contactTraveller[key].address,
                    'city': vm.contactTraveller[key].city,
                    'state': state,
                    'hotel_id': vm.hotel_id,
                    'is_active': 1,
                    'zip_code': vm.contactTraveller[key].zip_code,
                    'country': country,
                    'tax_exempt_indicator': vm.contactTraveller[key].tax_exempt_indicator ? 1 : 0,
                    'tax_exempt_id': vm.contactTraveller[key].tax_exempt_id,
                    'send_email_indicator': vm.contactTraveller[key].send_email_indicator ? 1 : 0
                }
            }
            createResService.addCustomer(addData).then(function(response) {
                if (response.success) {
                    if (response.errorMsg) {
                        toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                    }
                    createResService.getCustomers({
                            customer_id: response.id,
                            selectedHotel: vm.hotel_id
                        })
                        .then(function(response) {
                            if (response[0] && response[0].customerList && response[0].customerList[0]) {
                                if (type == 'customer') {
                                    pendingCustomer = response[0].customerList[0];
                                    vm.contact.customer_id = pendingCustomer.customer_id;
                                } else {
                                    pendingTraveller = response[0].customerList[0];
                                    vm.contactTraveller[key].customer_id = pendingTraveller.customer_id;
                                }
                            }
                        });
                } else if (response.errorMsg) {
                } else {
                    toastMessage.showSimpleToast('There was some error in saving customer.', 'error-toast');
                }
            })
        }

        vm.getCountries = function() {
            vm.isloading = true;
            if (Object.keys(vm.countries).length <= 1) {
                return $timeout(function() {
                    createResService.getCountries().then(function(response) {
                        vm.countries = response;
                        vm.isloading = false;
                    });
                }, 1500);
            }
        }

        vm.getStates = function() {
            vm.isloading = true;
            return $timeout(function() {
                createResService.getStates(vm.contact.country).then(function(response) {
                    vm.states = response;
                    vm.isloading = false;
                });
            }, 1500);
        }
        /*Search For country start*/
        vm.simulateQuery = false;
        vm.isDisabled = false;

        // list of `state` value/display objects
        vm.myCountryArr = loadAll();

        vm.queryCountrySearch = queryCountrySearch;
        vm.newState = newState;

        function newState(state) {
            alert("Sorry! You'll need to create a Constitution for " + state + " first!");
        }

        function queryCountrySearch(query) {
            var results = query ? vm.myCountryArr.filter(createFilterForCountry(query)) : vm.myCountryArr,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function() {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }
        /**
         * Build `states` list of key/value pairs
         */
        function loadAll() {
            var allStates = vm.countryList;
            return allStates.map(function(state) {
                return {
                    value: state.toLowerCase(),
                    display: state
                };
            });
        }

        /**
         * Create filter function for a query string
         */
        function createFilterForCountry(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };
        }
        /*Search For country end*/
        //for traveller
        vm.selectedItemChangeStateTraveller = selectedItemChangeStateTraveller;

        function selectedItemChangeStateTraveller(query, index) {
            if (vm.searchTxtCountryTraveller[index]) {
                var deferred = $q.defer();
                createResService.getAllStates({
                        state: query,
                        country: vm.searchTxtCountryTraveller[index]
                    })
                    .then(function(response) {
                        deferred.resolve(response.states);
                    });
                return deferred.promise;

            } else {
                return [];
            }

        }
        vm.selectedItemChange = selectedItemChange;

        function selectedItemChange(item, searchTxt, index) {
            vm.stateList = [];
            vm.isStateDisabled = true;
            if (vm.selectedCountry) {
                vm.contact.country = vm.selectedCountry['display'];
                if (typeof vm.selectedCountry['display'] != undefined || vm.selectedCountry['display'] != '') {
                    vm.selectedState = '';
                    vm.isloading = true;
                    userService.getStates(vm.contact.country).then(function(response) {
                        response.forEach(function(element) {
                            vm.stateList.push(element.name);
                        });
                        vm.isloading = false;
                    });
                    return $timeout(function() {
                        var temp = [];
                        vm.myStateArr = loadAllState();
                        vm.isStateDisabled = false;
                    }, 1500);
                }

            }

        }

        /*state start*/
        vm.simulateQuery = false;
        vm.isDisabled = false;
        // list of `state` value/display objects
        vm.queryStateSearch = queryStateSearch;

        function queryStateSearch(query) {
            var results = query ? vm.myStateArr.filter(createFilterForState(query)) : vm.myStateArr,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function() {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }
        /**
         * Build `states` list of key/value pairs
         */
        function loadAllState() {
            return vm.stateList.map(function(state) {
                return {
                    value: state.toLowerCase(),
                    display: state
                };
            });
        }


        /**
         * Create filter function for a query string
         */
        function createFilterForState(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };
        }

        function selectedItemChangeState() {
            if (vm.selectedState != undefined && vm.selectedState != null && typeof vm.selectedState['display'] != 'undefined' && vm.selectedState['display'] != null) {
                vm.contact.state = vm.selectedState['display'];
            } else {
                vm.contact.state = vm.contact.state;

            }
        }



        /*****************************************/
        /***** Geolocation autocomplete form *****/
        /*****************************************/
        var fullAddress = '';
        var result = '';

        initAutocomplete();
        function initAutocomplete() {
            setTimeout(function(){
                var autocomplete = new google.maps.places.Autocomplete(
                    (document.getElementById('autocomplete')),
                    {types: ['geocode']}
                );
                autocomplete.addListener('place_changed', function() {
                    result = autocomplete.getPlace();
                    getGeoData(result, 0, 'address');
                });
            }, 50);
        }


        /*****************************************/
        /***** Geolocation autocomplete form *****/
        /*****************************************/
        initAutocompleteZip();
        function initAutocompleteZip() {
            setTimeout(function(){
                var autocompletezip = new google.maps.places.Autocomplete(
                    (document.getElementById('autocompletezip')),
                    {types: ['(regions)']}
                );
                autocompletezip.addListener('place_changed', function() {
                    result = autocompletezip.getPlace();
                    getGeoData(result, 0, 'zip');
                });
            }, 50);
        }

        function initAutocompleteAddressTraveller() {
            setTimeout(function(){
                var autoCompleteTravellerAddress = new google.maps.places.Autocomplete(
                    (document.getElementById('autoCompleteTravellerAddress')),
                    {types: ['geocode']}
                );
                autoCompleteTravellerAddress.addListener('place_changed', function() {
                    result = autoCompleteTravellerAddress.getPlace();
                    getGeoData(result, 1, 'address');
                });
            }, 50);
        }


        /*****************************************/
        /***** Geolocation autocomplete form *****/
        /*****************************************/
        function initAutocompleteZipTraveller() {
            setTimeout(function(){
                var autoCompleteTravellerZipcode = new google.maps.places.Autocomplete(
                    (document.getElementById('autoCompleteTravellerZipcode')),
                        {types: ['(regions)']}
                );
                autoCompleteTravellerZipcode.addListener('place_changed', function() {
                    result = autoCompleteTravellerZipcode.getPlace();
                    getGeoData(result, 1, 'zip');
                });
            }, 50);
        }


        var addressData = {};
        function getGeoData(result, value, origin) {
            var country = '';
            var state = '';
            var city = '';
            var postal_code = '';
            var street = '';
            var street_number = '';
            var sublocality = '';
            var sublocality2 = '';
            var neighborhood = '';
            if(result && result.address_components && result.address_components.length != 0) {
                for(var i = 0; i<result.address_components.length; i += 1) {
                    var addressObj = result.address_components[i];
                    for(var j = 0; j < addressObj.types.length; j += 1) {
                        switch(addressObj.types[j]){
                            case "country":                     country = addressObj.long_name;         break;  //Country
                            case "administrative_area_level_1" : state  = addressObj.long_name;         break;  //State
                            case "administrative_area_level_2" : country = addressObj.long_name;        break;  //County
                            case "locality" :                   city    = addressObj.long_name;         break;  //City
                            case "route":                       street = addressObj.long_name;          break;  //street
                            case "neighborhood":                neighborhood = addressObj.long_name;    break;  //street
                            case "sublocality_level_2":         sublocality2 = addressObj.long_name;    break;  //street
                            case "sublocality_level_1":         sublocality = addressObj.long_name;     break;  //street
                            case "sublocality":                 sublocality = addressObj.long_name;     break;  //street
                            case "street_number":               street_number =  addressObj.long_name;  break;  //street number
                            case "postal_code":                 postal_code = addressObj.long_name;     break;  //Postal Code
                        }
                    }
                }
                addressData.zip_code = postal_code;
                addressData.address  = street_number + " " + sublocality + " " + sublocality2 + " " + street;
                addressData.city     = city ;
                addressData.state    = state;
                addressData.country  = country;
            } else {
                street = result.name;
            }
            if(!postal_code) {
                var data = {
                    address: result.name
                };
                userService.getZipCode(data).then(function(res) {
                    addressData.country = res.country;
                    addressData.state = res.administrative_area_level_1;
                    addressData.city = res.locality;
                    street_number = res.street_number ? res.street_number : '';
                    street = res.route ? res.route : '';
                    addressData.address = street_number + ' ' + street;
                    addressData.zip_code = res.postal_code;
                });
            } else {
                addressData.zip_code = postal_code ? postal_code : '';
            }
            $timeout(function() {
                if(!value) {
                    vm.contact.country = addressData.country;
                    vm.contact.state = addressData.state;
                    vm.contact.city = addressData.city;
                    if(addressData.address) {
                        vm.contact.address = (vm.contact.address != '' && origin == 'zip') ? vm.contact.address : addressData.address.trim();
                    } else {
                        vm.contact.address = (vm.contact.address != '' && origin == 'zip') ? vm.contact.address : '';
                    }
                    vm.contact.zip_code = addressData.zip_code;
                    vm.selectedCountry = {
                        value:addressData.country,
                        display: addressData.country
                    };
                    vm.searchTxtCountry = addressData.country;
                    $timeout(function() {
                        angular.element('#autocompletezip').val(vm.contact.zip_code);
                        angular.element('#autocomplete').val(vm.contact.address);
                        vm.searchTxtState = addressData.state;
                    }, 300);
                } else {
                    vm.contactTraveller[newIndex].country = addressData.country;
                    vm.contactTraveller[newIndex].state = addressData.state;
                    vm.contactTraveller[newIndex].city = addressData.city;
                    // vm.contactTraveller[newIndex].address = addressData.address ? addressData.address.trim() : '';
                    if(addressData.address) {
                        vm.contactTraveller[newIndex].address = (vm.contactTraveller[newIndex].address != '' && origin == 'zip') ? vm.contactTraveller[newIndex].address : addressData.address.trim();
                    } else {
                        vm.contactTraveller[newIndex].address = (vm.contactTraveller[newIndex].address != '' && origin == 'zip') ? vm.contactTraveller[newIndex].address : '';
                    }
                    vm.contactTraveller[newIndex].zip_code = addressData.zip_code;
                    vm.selectedCountryTraveller[newIndex] = {
                        value:addressData.country,
                        display: addressData.country
                    };
                    vm.searchTxtCountryTraveller[newIndex] = addressData.country;
                    $timeout(function() {
                        angular.element('#autoCompleteTravellerZipcode').val(vm.contactTraveller[newIndex].zip_code);
                        angular.element('#autoCompleteTravellerAddress').val(vm.contactTraveller[newIndex].address);
                        vm.searchTxtStateTraveller[newIndex] = addressData.state;
                    }, 300);
                }
            }, 1000);
        }
        /*state End*/

        setTimeout(function() {
           vm.autoFillOff = false;
           $timeout(initPhoneFieldsOnce, 100);
        }, 1500);

      var customerInputs = document.querySelectorAll('.intel-number-input:not(.intel-number-input-traveller)');
      angular.forEach(customerInputs, function (inputElement) {
        inputElement.addEventListener('countrychange', function () {
          var fieldName = inputElement.getAttribute('name');
          $timeout(function () {
            vm.updatePhoneWithCountryCode(fieldName);
          }, 0);
        });
      });

      var travellerInputs = document.querySelectorAll('.intel-number-input-traveller');
      angular.forEach(travellerInputs, function (inputElement) {
        inputElement.addEventListener('countrychange', function () {
          var fieldName = inputElement.getAttribute('name');
          $timeout(function () {
            vm.updatePhoneWithCountryCode(fieldName, null, 0);
          }, 0);
        });
      });

      vm.updatePhoneWithCountryCode = function (fieldName, scopeObj, travellerIndex) {
        var selector = travellerIndex !== undefined
          ? '.intel-number-input-traveller[name="' + fieldName + '"]'
          : '.intel-number-input:not(.intel-number-input-traveller)[name="' + fieldName + '"]';

        var inputElement = document.querySelector(selector);
        if (!inputElement) return;

        var iti = angular.element(inputElement).data('iti');
        if (!iti) return;

        var inputValue = inputElement.value.trim();
        var isValid = !inputValue || iti.isValidNumberPrecise();

        angular.element(inputElement).toggleClass('ng-invalid', !isValid);

        var key = travellerIndex !== undefined ? 'traveller_' + fieldName : 'customer_' + fieldName;
        vm.phoneValidity[key] = isValid;

        if (!inputValue) {
          vm.phoneValidity[key] = true;
          return;
        }

        if (!isValid) return;

        var dialCode = '+' + iti.getSelectedCountryData().dialCode;
        var localNumber = inputValue.startsWith(dialCode)
          ? inputValue.slice(dialCode.length).trim()
          : inputValue;

        if (typeof travellerIndex !== 'undefined') {
          if (!vm.contactTraveller[travellerIndex]) {
            vm.contactTraveller[travellerIndex] = {};
          }
          vm.contactTraveller[travellerIndex][fieldName] = localNumber;
        } else {
          vm.contact[fieldName] = localNumber;
        }
      };
    }

})();

(function() {
    'use strict';

    angular.module('app.create-res')
        .controller('addBoat', addBoat)
        .directive('allowOnlyNumbers', function () {  
            return {  
                restrict: 'A',  
                link: function (scope, elm, attrs, ctrl) {  
                    elm.on('keydown', function (event) {  
                        if (event.which == 64 || event.which == 16) {  
                            // to allow numbers  
                            return false;  
                        } else if (event.which >= 48 && event.which <= 57) {  
                            // to allow numbers  
                            return true;  
                        } else if (event.which >= 96 && event.which <= 105) {  
                            // to allow numpad number  
                            return true;  
                        } else if ([8, 13, 27, 37, 38, 39, 40].indexOf(event.which) > -1) {  
                            // to allow backspace, enter, escape, arrows  
                            return true;  
                        } else {  
                            event.preventDefault();  
                            // to stop others  
                            return false;  
                        }  
                    });  
                }  
            }  
        });

    /** @ngInject */
    function addBoat(
        $mdDialog,
        customerIndex,
        createResService,
        $localStorage,
        toastMessage,
        $rootScope,
        typeOfCust,
        $timeout,
        userService,
        $q,
        $scope,
        commonBoat,
        $sessionStorage
    ) {
        var vm = this;
        vm.cartIndex = customerIndex;
        vm.boat = {};
        vm.closeDialog = closeDialog;
        // vm.addNewCustomer = addNewCustomer;
        vm.hotel_id = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;

        vm.isRequestTrue = true;
        vm.hidePassword = false;

        if (commonBoat) {
            vm.boat = commonBoat;   
        }

        var element = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][customerIndex];
        vm.boatType = [{'name' : 'Power Boat', 'value' : 'powerboat'},{'name' : 'Sailboat', 'value' : 'sailboat'}];
        
        vm.addBoatData = addBoatData;
        function addBoatData() {
            $scope.$parent.addBoatData(vm.boat,vm.cartIndex);
            $mdDialog.hide();
        }
        vm.autoFillOff = true;
        vm.customerTravellerResponse = customerTravellerResponse;
        function customerTravellerResponse(responsTrav, responsCust, key) {
            if (responsTrav && responsCust) {
              if (vm.contact['customer_email'] == vm.contactTraveller[key]['customer_email']) {
                    vm.contactTraveller[key] = vm.contact;
                }
                if(typeof vm.contact['customer_id'] == 'undefined' || typeof vm.contactTraveller[key]['customer_id'] == 'undefined') {
                    $timeout(function() {
						customerTravellerResponse(responsTrav, responsCust, key);
					}, 500);
                } else {
                    vm.queryProgress = false;
                    $scope.$parent.addCustomer(vm.contact, vm.contactTraveller[key], vm.cartIndex);
                    $mdDialog.hide();
                }
            }

        }


        vm.updateForm = updateForm;

        function updateForm(item, field) {

            if (typeof item != 'undefined' && vm.isRequestTrue) {
                vm.isRequestTrue = false;
                if (item) {
                    vm.hidePassword = true;
                    vm.buttonType = 'AutoSelect';
                    vm.selectedItem = item;
                } else {
                    vm.hidePassword = false;
                    vm.buttonType = 'Add';
                }
                if (field == 'cust.first_name') {
                    vm.selectedSearch.last_name = item.last_name;
                    vm.selectedSearch.customer_email = item.customer_email;
                    vm.selectedSearch.phone_number = item.phone_number;
                }
                if (field == 'cust.last_name') {
                    vm.selectedSearch.first_name = item.first_name;
                    vm.selectedSearch.email = item.email;
                    vm.selectedSearch.phone_number = item.phone_number;
                }
                if (field == 'cust.customer_email') {
                    vm.selectedSearch.first_name = item.first_name;
                    vm.selectedSearch.last_name = item.last_name;
                    vm.selectedSearch.phone_number = item.phone_number;
                }

                $timeout(function() {
                    vm.isRequestTrue = true;
                    if (item.state.length > 0) {
                        vm.selectedState = {
                            value: item['state'].toLowerCase(),
                            display: item['state']
                        };
                        vm.searchTxtState = vm.selectedState['display'];
                    } else {
                        vm.selectedState = '';
                    }

                }, 1000);
                vm.contact = item;

                if (!item.tax_exempt_indicator) {
                    vm.contact['tax_exempt_indicator'] = false;
                } else {
                    vm.contact['tax_exempt_indicator'] = item.tax_exempt_indicator == 1 ? true : false;
                }
                if (!item.send_email_indicator) {
                    vm.contact['send_email_indicator'] = true;
                } else {
                    vm.contact['send_email_indicator'] = item.send_email_indicator == 1 ? true : false;
                }
            }
        }

        // vm.validateUser = validateUser;

        // function validateUser(index) {
        //     var status = false;
        //     var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        //     if (!filter.test(vm.searchTextEm)) {
        //         status = true;
        //     }
        //     if (!vm.travellerDetails[index]) {
        //         if (!filter.test(vm.searchTextTravellerEm[index])) {
        //             status = true;
        //         }
        //     }
        //     return status;

        // }





        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        setTimeout(function() {
           vm.autoFillOff = false;
        }, 1500); 
    }

})();

(function ()
{
    'use strict';

    angular
    .module('app.contacts')
    .controller('ContactDialogController', ContactDialogController);

    /** @ngInject */
    function ContactDialogController($mdDialog, Contact, Contacts, User, msUtils, $mdDateLocale, userService, $window, toastMessage, $localStorage, $scope, organizationsservice, $rootScope){

        var vm = this;
		var organizationdata = {onlyOrganizations:true};
        vm.userPermissions = $rootScope.userPermissions;
        // Data
        vm.title = 'Edit Customer';
        vm.disableWeb = 'Edit';
        vm.disableEmail = 'Edit';
        vm.disSubmit = true;
        vm.status = [{'value':1, 'name':'Active'}, {'value':0, 'name':'Inactive'}]
        vm.gender = [{'value':1, 'name':'Male'}, {'value':0, 'name':'Female'}]
        vm.contact = angular.copy(Contact);
        vm.contacts = Contacts;
        vm.user = User;
        vm.newContact = false;
        vm.allFields = false;
        if ( !vm.contact ) {
            vm.contact = {

            };
            vm.title = 'New Customer';
            vm.disableWeb = 'Add';
            vm.disableEmail = 'Add';
            vm.newContact = true;

            // vm.contact.tags = [];
        } else {
            vm.contact.date_of_birth = new Date(Contact.date_of_birth);
            vm.contact.website_id=  { website_id: vm.contact.website_id };
            vm.contact.is_active=  { value: vm.contact.is_active };
            vm.contact.customer_gender=  { value: vm.contact.customer_gender };
        }
        // Methods
        vm.addNewContact = addNewContact;
        //vm.saveContact = saveContact;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.validateEmail = validateEmail;
       
        /**
        * Add new contact
        */
         function addNewContact(){
            if(vm.disSubmit){
                userService.addUser(vm.contact)
                .then(function(response){
                 if(response.status){
					 var msg = 'Customer has been added successfully';
					if(response.errorMsg){
						msg+=', but '+response.errorMsg;
					}
                    toastMessage.showSimpleToast(msg,'success-toast');
                    $scope.updateTable();
                    closeDialog();

                } else {
                   toastMessage.showSimpleToast(response.errorMsg,'error-toast');
               }
           });
            } else {
               vm.focusElement = "EmailFocus";
           }
       }

        /**
         * Save contact
         */
         /*function saveContact(){

            userService.updateCustomer(vm.contact, Contact.password)
            .then(function(response){
                if(!response.status){
					toastMessage.showSimpleToast('There was some error in saving customer.','error-toast');
				} else {
					closeDialog();
					$scope.updateTable();
					toastMessage.showSimpleToast('Customer has been updated successfully.','success-toast');
				}
			});
        }*/
        
        function validateEmail(){
            if(vm.contact.customer_email){
                userService.validateEmail(vm.contact.customer_email, vm.contact.website_id.website_id)
                .then(function(response){
                    if(response.status){
                         vm.emailError = 'This email id already registered';
                         vm.disSubmit = false;
                     } else {
                      vm.disSubmit = true;
                      vm.emailError = false;
                  }
              });
            }
        }


        /**
        * Delete Contact Confirm Dialog
        */
        function deleteContactConfirm(ev){

            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the contact?')
                .htmlContent('<b>' + vm.contact.name + ' ' + vm.contact.lastName + '</b>' + ' will be deleted.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

                $mdDialog.show(confirm).then(function (){
                    vm.contacts.splice(vm.contacts.indexOf(Contact), 1);
                });
        }

        /**
        * Close dialog
        */
        function closeDialog(){
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.checkout',
            [
                // 3rd Party Dependencies
                'xeditable',
                'credit-cards'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.checkout', {
            url    : '/retail',
            title  : 'Checkout',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/checkout/checkout.html',
                    controller : 'checkoutController as vm'
                }
            },
            params:{
                checkin: '',
                checkout: '',
                cartIndex:0,
                product_id:'',
                product_name:'',
                addServiceForRoom: false,
                showaddDialog: false,
                typeofService: 'retail'

            },
			 resolve  : {
				productData: function (checkoutService,$stateParams, $localStorage){
                    var happy_hours = false;
                    if(typeof $localStorage['retail' + $localStorage['preHotelId']] != 'undefined' && $localStorage['retail' + $localStorage['preHotelId']]){
                       happy_hours =  $localStorage['retail' + $localStorage['preHotelId']]?true:false;
                    }
					return checkoutService.getCheckoutCategory($stateParams.typeofService, happy_hours);
				}
			},
			permission: 'retail'
        }).state('app.bar', {
            url    : '/bar',
            title  : 'Bar Checkout',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/checkout/checkout.html',
                    controller : 'checkoutController as vm'
                }
            },
            params:{
                checkin: '',
                checkout: '',
                cartIndex:0,
                product_id:'',
                product_name:'',
                addServiceForRoom: false,
                showaddDialog: false,
                typeofService: 'bar',
                one_go_id:''

            },
			 resolve  : {
				productData: function (checkoutService,$stateParams, $localStorage){
                    var happy_hours = false;
                    var typeofService = $stateParams.typeofService;
                    var category = 0;
                    if(typeof $localStorage['bar' + $localStorage['preHotelId']] != 'undefined' && $localStorage['bar' + $localStorage['preHotelId']]){
                       happy_hours =  $localStorage['bar' + $localStorage['preHotelId']]?true:false;
                    }
                    if( typeof $localStorage["postype" + $localStorage['preHotelId']] != 'undefined' && $localStorage["postype" + $localStorage['preHotelId']] != '' ){
                       typeofService =  $localStorage["postype" + $localStorage['preHotelId']];
                    }
                    if( typeof $localStorage["category-" + typeofService + $localStorage['preHotelId']] != 'undefined' && typeof $localStorage["category-" + typeofService + $localStorage['preHotelId']].category != 'undefined' && $localStorage["category-" + typeofService + $localStorage['preHotelId']].category != '' ) {
                        category = $localStorage["category-" + typeofService + $localStorage['preHotelId']].category;
                    }
					return checkoutService.getCheckoutCategory(typeofService, happy_hours, category);
				}
			},
			permission: 'bar'
        }).state('app.resCheckout', {
            url    : '/add-service-in-create-order',
            title  : 'Reservation Checkout',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/checkout/checkout.html',
                    controller : 'checkoutController as vm'
                }
            },
            params:{
                checkin: '',
                checkout: '',
                cartIndex:0,
                product_id:'',
                product_name:'',
                product_room_number:'',
                addServiceForRoom: true,
                typeofService: 'retail',
                taxValue:false,
                pageFrom: '',
                itinerary_number:'',
                policy_id:'',
                confirmation_number:'',
                one_go_id:'',
                associatedWithCustTrav:0
            },
			resolve  : {
				productData: function (checkoutService,$stateParams){
					return checkoutService.getCheckoutCategory($stateParams.typeofService);
				}
			}
        }).state('app.pos-orders', {
            url    : '/pos-orders',
            title  : 'Orders',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/checkout/posorders/posorders.html',
                    controller : 'posOrdersController as vm'
                }
            },
            params   : {toast_message:false, typeofService: 'bar'},
            permission: 'bar_orders'
        }).state('app.pos-order', {
            url    : '/pos-order/:one_go_id',
            title  : 'Orders',  
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/checkout/posorders/order/posorder.html',
                    controller : 'posOrderController as vm'
                }
            },
            resolve  : {
                Order: function (checkoutService, $stateParams){
                    return checkoutService.getOrderInfo({'one_go_id':$stateParams.one_go_id});
                }
            },
            permission: 'bar_orders'
        }).state('app.pos-reports', {
			url    : '/reports',
            title  : 'Reports',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/checkout/reports/reports.html',
                    controller : 'posreportsController as vm'
                }
            },
            permission: 'bar_reports'
		}).state('app.tab-order', {
            url    : '/tab-order',
            title  : 'Tab Orders',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/checkout/tabOrder/tabOrder.html',
                    controller : 'tabOrderController as vm'
                }
            },
            params:{
                checkin: '',
                checkout: '',
                cartIndex:0,
                product_id:'',
                product_name:'',
                addServiceForRoom: false
            },
			 resolve  : {
				TabData: function (checkoutService){
					return checkoutService.getTabOrder();
				},
				tabOrderName:function(){
					return '';
				}

			},
			permission: 'tab_orders'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/checkout');

    }

})();

(function ()
{
	'use strict';

	angular
		.module('app.checkout')
		.controller('posOrderController', posOrderController);

	/** @ngInject */
	function posOrderController(
		Order,
		toastMessage,
		$mdSidenav,
		$state,
		eCommerceService,
		checkoutService,
		$scope,
		$window,
		$mdDialog,
		ganttChartService,
		$timeout,
		$document,
		commonService,
		EnvironmentConfig,
		$translate,
		createResService,
		$stateParams,
		$location,
		$sessionStorage,
		$anchorScroll,
		$rootScope,
		userService,
		$q,
		$filter,
		$http,
		commonDailog,
		$localStorage
	){

		/* Variables & initializations */		
		var vm = this;	
		vm.baseUrl = EnvironmentConfig.api;
		vm.stateStatus = false;
		vm.processRequest = false;
		vm.processRequest = true
		vm.pos_status = [];
		vm.dates_option = EnvironmentConfig.cc_dates_option;
		vm.yrs_option = commonService.calculateExpirationYears();
		vm.roomCount = 1;
		vm.ct = '';
		vm.trigDivStatus = true;
		vm.modify_request = false;
		vm.refundStart = false;
		vm.autoFillOff = true;

		vm.myDate = new Date();
		vm.minDate = new Date(
			vm.myDate.getFullYear(),
			vm.myDate.getMonth(),
			vm.myDate.getDate()
		);
		vm.endDateMin = new Date(
			vm.myDate.getFullYear(),
			vm.myDate.getMonth(),
			vm.myDate.getDate()
		);
		vm.dtOptionsForPayment = {
			autoWidth : false,
			responsive: true,
			paging: false,
			searching: false,
			order: [8, "asc"],
			oLanguage: {"sEmptyTable": "No installments paid yet."},
			columnDefs: [
				{
					// Target the Action column
					targets   : 7,
					filterable: false,
					responsivePriority: 1,
					sortable  : false
				},
				{
					// Target the paid date column
					 targets   	: 1,
					 type		: 'date',
					 render   	: function( data, type, row, meta){
						var ThisDate = moment(new Date(data)).format("MM-DD-YYYY hh:mm:ss A");
						return ThisDate;
					 }
				}
			]
		};
		vm.commentsSpecial = {};
		vm.masonryOptions = {
			columnCount     : 3,
			responsive      : {
				sm: 2,
				xs: 1
			}
		}
		vm.allRoomCancelled = false;
		var cancelledCount = 0;
		vm.selectedIndex = 0;
		vm.use_existingcard = '';
		vm.notCardType = '';
		vm.payingFromGC = {};
		vm.statusesPos = {};
		vm.innerSlectedIndex = 0;
		vm.customeropened = false;
		vm.traveleropened = false;
		vm.showDiscountEdit = false;
		vm.tempData      = {0:'data'};
		vm.comment = vm.request = '';
		vm.isloading = true;
		vm.changeStatusData = {};
		vm.print_data = false;
		vm.print_invoice_data = false;
		vm.print_show_div = false;
		vm.showModifyBtn = false;
		vm.paymentrequestGoing = false;
		vm.gcrequestGoing = false;
		vm.orderEmailUpdated = false;
		vm.reservationEmailUpdated = false;
		var simulateQuery = false;
		var countryList = [];
		var userPermissions = [];
		var originalOrderData = {};
		vm.parking_access = false;
		vm.print_registration = false;
		var left = 0;
		var width;
		var tabsCount;
		var visibleOnScreen;
		var maxLeftAssign;
		vm.modificationComment = '';
		vm.changedColumn = '';

		vm.currentUrl = $location.absUrl().split('?')[0];
		if (vm.currentUrl.includes('restaurant-order')) {
			vm.currentPageFor = 'restaurant';
		} else {
			vm.currentPageFor = 'bar';
		}
		/* Variables & initializations */
		
		/* Permissions Checks */
		if (typeof $rootScope.userPermissions != 'undefined') {
			userPermissions = $rootScope.userPermissions;
			if (userPermissions.indexOf('timebound_parking') != -1) {
				vm.parking_access = true;
			}
			if (userPermissions.indexOf('registration_card') != -1) {
				vm.print_registration = true;
			}
		}
		/* Permissions Checks */
		
		
		/* Initial Data for view page */
		if(Order.success && Order.response && Order.response.order_data){
			vm.one_go_id = $stateParams.one_go_id;
			vm.order = Order.response.order_data;
			vm.allowed_card_types = Order.response.allowed_card_types;
			if(vm.order.hasOwnProperty('pos') && parseInt(Object.keys(vm.order.pos).length) > 0){
				vm.statusesPos = {};
				angular.forEach(vm.order.pos, function (value, key)
				{
					vm.statusesPos[key] = {'Active':'Active','Canceled':'Cancel'};
					vm.statusesPos[key][value.room_stay_status] = value.room_stay_status;
				});
			}
			vm.all_payment_methods = Order.response.payment_methods;

			vm.payment_method = {};
			var count = 0;
			vm.fieldsIsReadOnly = false;
			vm.showPaymentsLoader = true;
			$timeout(function() {
				vm.isloading = false;
				fetchPaymentsInformation(vm.one_go_id);
				originalOrderData = angular.copy(vm.order);
			},2000);
		} else {
			if(Order.success)
				Order.errorMsg = "Order doesn't exist";
			else
				Order.errorMsg = "Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.";
			$state.go('app.pos-orders',{toast_message:Order.errorMsg});
		}
		/* Initial Data for view page */
		
		
		
		/* Methods */
		vm.editParkingDates = editParkingDates;
		vm.payInstallment = payInstallment;
		vm.updateReservationValues = updateReservationValues;
		vm.fetchPaymentsInformation = fetchPaymentsInformation;
		vm.back = back;
		vm.changeStatusForService = changeStatusForService;
		vm.refundInstallmentFinally = refundInstallmentFinally;
		vm.setShowModifyBtn = setShowModifyBtn;
		vm.completeModification = completeModification;
		vm.refundInstallment = refundInstallment;
		vm.creditCardChanged = creditCardChanged;
		vm.checkValidExpDate = checkValidExpDate;
		vm.changeActiveCard = changeActiveCard;
		vm.checkremainingAmount = checkremainingAmount;
		vm.emptythisPayment = emptythisPayment;
		vm.validateGCCode = validateGCCode;
		// vm.addroomincart = addroomincart;
		vm.calculatesubtotal = calculatesubtotal;
		vm.calculatesubtotalPos = calculatesubtotalPos;
		vm.startDateModified = startDateModified;
		vm.endDateModified = endDateModified;
		vm.closeDialog = closeDialog;
		vm.calculateDiscount = calculateDiscount;
		vm.getRangeArray = getRangeArray;
		vm.printOrderInvoice = printOrderInvoice;
		vm.sendEmailToCustomer = sendEmailToCustomer;
		vm.sendEmailInit = sendEmailInit;
		vm.addTipToThisOrder = addTipToThisOrder;
		vm.addBarToThisOrder = addBarToThisOrder;
		vm.opencommentboxNightPOS = opencommentboxNightPOS;
		vm.opencommentbox = opencommentbox;
		vm.startEditingOrderAmounts = startEditingOrderAmounts;
		vm.changePayAmount = changePayAmount;
		/* Methods */
		function printOrderInvoice(){
			checkoutService.printInvoice({
				webpos_one_go_order_number : vm.one_go_id,
				printpreview : false
			}).then(function(response){
				var myWindow = window.open('', "_blank", "scrollbars=yes, resizable=yes, width=500, height=700");
				myWindow.document.write(response['data']);
				$timeout(function() {
					myWindow.close();
				},400);
			});
		}
		function sendEmailToCustomer(email_id){
			if(email_id!=''){
				vm.isloading = true;
				checkoutService.sendMailToCust({webpos_one_go_order_number:vm.one_go_id,cust_email_id:email_id}).then(function(response) {
					vm.isloading = false;
					if(!response.success && response.errorMsg){
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					}else if(!response.success){
						toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'),'error-toast');
					}
				});
			}
		}
		function sendEmailInit(){
			$mdDialog.show({
				clickOutsideToClose	: true,
				parent             	: angular.element($document.body),
				scope				: $scope,
				preserveScope		: true,
				templateUrl        	: 'app/main/apps/checkout/dialog/sendEmailInput.html',
				controller			: sendEmailInputController
			});
			function sendEmailInputController($scope, $mdDialog) {
				$scope.email_id = '';
				$scope.closeDialog = function(){
					$mdDialog.hide();
				};
				$scope.sendEmailToCustomer = function(){
					if($scope.email_id != ''){
						vm.sendEmailToCustomer($scope.email_id);
						$mdDialog.hide();
					}
				};
			}
		}
		function getRangeArray(start, end){
			var tempArray = [];
			for(var i=start ; i <= end;i++){
				tempArray.push(i);
			}
			return tempArray;

		}
		function opencommentboxNightPOS(poskey,action,nightIndex){
			var event = '';
			var thisCart = angular.copy(vm.order.pos[poskey]);
			if(thisCart.prices.nightlydiscountcomment) var comment = thisCart.prices.nightlydiscountcomment[nightIndex];
			else var comment = '';
			$mdDialog.show({
				controller: 'discountCommentController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/create-res/dialogs/discount-comment/discount-comment.html',
				parent: angular.element(document.body),
				targetEvent: event,
				clickOutsideToClose:true,
				locals             : {
					oldcomment   : comment,
					oldAmount    : '',
					type         : '',
					price        : ''
				}
			})
			.then(function(answer) {
				if(!thisCart.prices.nightlydiscountcomment){
					thisCart.prices.nightlydiscountcomment = {};
				}
				thisCart.prices.nightlydiscountcomment[nightIndex] = answer.comment;
				vm.order.pos[poskey] = thisCart;
				var data = {confirmation_number:thisCart.confirmation_number,nightlydiscountcomment:thisCart.prices.nightlydiscountcomment,nontimebound:false};
				eCommerceService.saveDiscountComment(data).then(function(response){
					if(response.success || response.data){
						thisCart.prices.nightlydiscountcomment = response.data;
						vm.order.pos[poskey] = thisCart;
					}
				});
			}, function() {});
		}
		function opencommentbox(posIndex){
			vm.event = '';
			$mdDialog.show({
				controller: 'discountCommentController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/create-res/dialogs/discount-comment/discount-comment.html',
				parent: angular.element(document.body),
				targetEvent: event,
				clickOutsideToClose:true,
				locals             : {
					oldcomment   : vm.order.pos[posIndex].product_discount_comment,
					oldAmount    : '',
					type         : '',
					price        : ''
				}
			})
			.then(function(answer) {
				if (answer !== undefined) {
					vm.order.pos[posIndex].product_discount_comment = answer.comment;
					var data = {confirmation_number:vm.order.pos[posIndex].confirmation_number,nightlydiscountcomment:vm.order.pos[posIndex].product_discount_comment,nontimebound:true};
					eCommerceService.saveDiscountComment(data).then(function(response){
						if(response.success || response.data){
							// vm.order.pos[posIndex].prices.product_discount_comment = response.data;
							vm.order.pos[posIndex].product_discount_comment = response.data;
						}
					});
				}
			}, function() {});
		}
		function calculateDiscount(){
			if(vm.discount_type == 'percent'){
				if(parseFloat(vm.newDiscount) > 100) vm.newDiscount = 100;
				var discount_amount = (parseFloat(parseFloat(vm.order.nightlySum) + parseFloat(vm.order.additional_guest_amounts) ) * parseFloat(vm.newDiscount))/100;

				vm.order.discount_percentage = commonService.roundnum(vm.newDiscount,2);
				vm.order.discount_amount = commonService.roundnum(discount_amount,2);
				var POS =  vm.order.pos;
				if((typeof POS != 'undefined' || POS)){
					vm.order.pos.forEach(function(element, key){
						if(element.room_stay_status == 'Active' && parseFloat(element.nightlySum) > 0){
							var discount_amount = parseFloat(element.nightlySum * vm.newDiscount)/100;
							vm.order.pos[key].discountAmt = commonService.roundnum(discount_amount,2);
							vm.order.pos[key].discountPer = commonService.roundnum(vm.newDiscount,2);
							vm.calculatePOSTotals(key,'');
							vm.setShowModifyBtn('discountPerpos'+key,'discountPer',key);
						}
					});
				}
				vm.setShowModifyBtn('DiscountPercent','discount_percentage');
			} else {
				if(parseFloat(vm.newDiscount) > parseFloat(vm.order.overalltotals.subtotal)) vm.newDiscount = vm.order.overalltotals.subtotal;
				var discount_amount = vm.newDiscount;
				if(parseFloat(vm.order.nightlySum) > 0){
					if(parseFloat(discount_amount) <= parseFloat(vm.order.nightlySum)){
						vm.order.discount_amount = commonService.roundnum(discount_amount,2);
						discount_amount = 0;
					} else if(discount_amount > vm.order.nightlySum){
						vm.order.discount_amount = commonService.roundnum(parseFloat(parseFloat(vm.order.nightlySum) + parseFloat(vm.order.additional_guest_amounts)),2);
						discount_amount = parseFloat(parseFloat(discount_amount)-vm.order.discount_amount);
					}
					var newDiscPer = (parseFloat(vm.order.discount_amount)*100)/parseFloat(parseFloat(vm.order.nightlySum) + parseFloat(vm.order.additional_guest_amounts));

					newDiscPer = commonService.roundnum(newDiscPer,2);
					vm.order.discount_percentage = commonService.roundnum(newDiscPer,2);
				}
				var POS =  vm.order.pos;
				if(parseFloat(discount_amount) > 0 && (typeof POS != 'undefined' || POS)){
					vm.order.pos.forEach(function(element, key){
						if(element.room_stay_status == 'Active' && parseFloat(element.nightlySum) > 0 && parseFloat(discount_amount) > 0){
							var nightlySum = parseFloat(element.nightlySum);
							if(parseFloat(discount_amount) <= nightlySum){
								vm.order.pos[key].discountAmt = commonService.roundnum(discount_amount,2);
								discount_amount = 0;
							} else if(parseFloat(discount_amount) > nightlySum){
								vm.order.pos[key].discountAmt = commonService.roundnum(nightlySum,2);
								discount_amount = parseFloat(parseFloat(discount_amount)-nightlySum);
							}
							var newDiscPer = (parseFloat(vm.order.pos[key].discountAmt)*100)/parseFloat(nightlySum);

							newDiscPer = commonService.roundnum(newDiscPer,2);
							vm.order.pos[key].discountPer = commonService.roundnum(newDiscPer,2);
							vm.calculatePOSTotals(key,'');
							vm.setShowModifyBtn('discountAmtpos'+key,'discountAmt',key);
						} else if(element.room_stay_status == 'Active' && parseFloat(element.nightlySum) > 0){
							vm.order.pos[key].discountAmt = 0.00;
							vm.order.pos[key].discountPer = 0.00;
							vm.calculatePOSTotals(key,'');
							vm.setShowModifyBtn('discountAmtpos'+key,'discountAmt',key);
						}
					});
				}
				vm.setShowModifyBtn('DiscountAmount','discount_amount');
			}
			vm.order = commonService.calculateTotals(vm.order,false, []);
		}

		function closeDialog(){
			$mdDialog.hide();
		}

		function startDateModified(posIdx){
			var endDate = new Date(moment(vm.order.pos[posIdx].room_stay_from, "DD-MM-YYYY").add(2, 'days'));
			vm.endDateMin = new Date(moment(vm.order.pos[posIdx].room_stay_from, "DD-MM-YYYY").add(1, 'days'));
			vm.order.pos[posIdx].room_stay_to = endDate;
			datesChanged(posIdx);
		}

		function endDateModified(room_stay_to,posIdx,event){
			var endDate = new Date(moment(room_stay_to).format());
			var startDate = new Date(moment(vm.order.pos[posIdx].room_stay_from).format());
			endDate = moment(endDate);
			startDate = moment(startDate);
			if(endDate.isBefore(startDate)){
				toastMessage.showSimpleToast('Checkout date cannot be less than checkin date.','error-toast');
				vm.order.pos[posIdx].room_stay_to = originalOrderData.pos[posIdx].room_stay_to;
				event.preventDefault();
			}
		}

		function calculatesubtotal(ec,rate){
			return commonService.calculatesubtotal(ec,rate);
		}
		function calculatesubtotalPos(qty,rate){
			return commonService.calculatesubtotalPos(qty,rate);
		}
		function creditCardChanged(event,cardType,payment_method){
			var result = commonService.creditCardChanged(event,cardType,payment_method,vm.allowed_card_types);
			vm.notCardType = result.notCardType;
			if(!result.notCardType) vm.payment_method = result.payment_method;
		}
		function checkValidExpDate(){
			var obj = {'method':vm.payment_method['payment_method'],'cc_exp_year':vm.payment_method['cc_exp_year'],'cc_exp_date':vm.payment_method['cc_exp_month']};
			var result = commonService.checkValidExpDate(obj);
			vm.exp_date = result.exp_date;
			vm.exp_date_err = result.exp_date_err;
		}
		function back(){
			if (vm.currentPageFor === 'restaurant') {
				$state.go('app.restaurant-orders');
			} else  {
				$state.go('app.pos-orders');
			}
		}
		
		function startEditingOrderAmounts(fieldname, fieldTitle, posIdx, originalAmount, nightIdx) {
			if(fieldname == 'product_discount'){
				originalAmount = commonService.roundnum(parseFloat(originalAmount) / parseInt(vm.order.pos[posIdx].quantity),2);
			}
			var event = ''; 
			$mdDialog.show({
				controller: 'editposorder',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/checkout/dialog/onlyNumberDialog.html',
				parent: angular.element($document.find('#content-container')),
				targetEvent: event,
				scope: $scope.$new(),
				preserveScope: true,
				clickOutsideToClose: true,
				locals: {
					dailogInfo: {
						title: fieldTitle,
						poskey: posIdx,
						fieldname: fieldname,
						nightIdx: nightIdx,
						originalAmount: originalAmount
					},
					parentScope: vm
				}
			});
		}

		function changePayAmount() {
			var event = ''; 
			$mdDialog.show({
				controller: 'payorder',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/checkout/dialog/onlyNumberDialog.html',
				parent: angular.element($document.find('#content-container')),
				targetEvent: event,
				scope: $scope.$new(),
				preserveScope: true,
				clickOutsideToClose: true,
				locals: {
					dailogInfo: {
						title: 'Pay Amount',
						originalAmount: parseFloat(vm.installments['remaining'].origremainingamt)
					},
					parentScope: vm
				}
			});
		}

		function completeModification(confirmation_number){
			vm.isloading = false;
			if(vm.processRequest){


			angular.forEach($http.pendingRequests, function(request) {
				if (request.cancel && request.timeout) {
				   request.cancel.resolve();
				}
			 });
			vm.isloading = true;
			var requestData = angular.copy(vm.order);
			requestData['order_history_comment'] = "AMOUNTS_MODIFED_MANUALLY_FROM_PMS";
			var data = {'order_info':requestData,'id':vm.order.reservation_id,'modification_comment':vm.modificationComment,changed_column:vm.changedColumn,modiified_confirmation:confirmation_number,one_go_id:vm.one_go_id};
			vm.modify_request = true;
			checkoutService.modifyBarOrder(data).then(function(response){
				try{
					vm.modify_request = false;
					vm.isloading = false;
					vm.showModifyBtn = false;
					vm.showDiscountEdit = false;
					if(typeof response != 'undefined' && response != ''  && response.response.order_data){
						vm.order = response.response.order_data;
						originalOrderData = angular.copy(vm.order);
						vm.showModifyBtn = false;
						vm.showPaymentsLoader = true;
						if(vm.order.hasOwnProperty('pos') && parseInt(Object.keys(vm.order.pos).length) > 0){
							vm.statusesPos = {};
							angular.forEach(vm.order.pos, function (value, key)
							{
								vm.statusesPos[key] = {'Active':'Active','Canceled':'Cancel'};
								vm.statusesPos[key][value.room_stay_status] = value.room_stay_status;
							});
						}
						$timeout(function(){
							fetchPaymentsInformation(vm.one_go_id);
						},100);

					}else{
						vm.modify_request = false;
						vm.isloading = false;
						vm.showDiscountEdit = true;
						vm.order = angular.copy(originalOrderData);
					}
				}
				catch(err) {
					vm.modify_request = false;
					vm.isloading = false;
					vm.showDiscountEdit = true;
					vm.order = angular.copy(originalOrderData);
				}
			});
		} else {
			vm.isloading = false;
			vm.showModifyBtn = false;
			vm.showDiscountEdit = false;
			vm.isloading = false;
		}

		}
		/*Divide nightly Sum*/
		vm.sumNightsPOS = sumNightsPOS;
		vm.datesChanged = datesChanged;
		function sumNightsPOS(poskey,action){
			var thisCart = angular.copy(vm.order.pos[poskey]);
			var nightlyAll = thisCart.prices.rates;
			var nightlySum = 0;
			var discountAmt = thisCart.discountAmt;
			for(var i=0;i<nightlyAll.length;i++){
				nightlySum+= parseFloat(nightlyAll[i]);
				thisCart.prices.rates[i] = commonService.roundnum(nightlyAll[i],2);
			}
			thisCart.nightlySum = commonService.roundnum(nightlySum,2);
			vm.order.pos[poskey] = thisCart;
			vm.order.pos[poskey] = commonService.calculatePOSTotals(poskey,true,vm.order);
			if(action == 'call')
				calculateOrderTotals();
		}

		function datesChanged(posIdx){
			var thisCart = vm.order.pos[posIdx];
			var origCart = originalOrderData.pos[posIdx];
			var new_room_stay_to = moment(thisCart.room_stay_to);
			var new_room_stay_from = moment(thisCart.room_stay_from);
			var old_room_stay_to = moment(origCart.room_stay_to);
			var old_room_stay_from = moment(origCart.room_stay_from);
			var nightly = thisCart.prices.rates;
			var dates = [];
			var rates = [];
			if(new_room_stay_to != old_room_stay_to || new_room_stay_from != old_room_stay_from){
				var nights = new_room_stay_to.diff(new_room_stay_from, 'days');
				var last_rate = 0;
				for (var m = moment(new_room_stay_from),k=0; m.isBefore(new_room_stay_to); m.add('days', 1),k++) {
					if(m.format('MM-DD-YYYY') == new_room_stay_to.format('MM-DD-YYYY'))
						break;
					dates.push(m.format('MM-DD-YYYY'));
					if(nightly[k] !== undefined){
						rates.push(nightly[k]);
						last_rate = nightly[k];
					}else{
						rates.push(last_rate);
					}
				}
			}
			vm.order.pos[posIdx].prices.rates = rates;
			vm.order.pos[posIdx].prices.dates = dates;
			sumNightsPOS(posIdx,'call');
			calculatePOSTotals(posIdx,'call');
		}

		function setShowModifyBtn(changedColumn,columnName,posIdx){
			vm.changedColumn = columnName;
			if(columnName == 'nightlydiscount'){
				var ind = changedColumn.split('-');
				vm.modificationComment  = originalOrderData.pos[posIdx]['product_name']+' discount for night '+ind[1]+' changed  from '+originalOrderData.pos[posIdx]['prices']['nightlydiscount'][parseFloat(ind[1]) - parseFloat(1)]+' to '+ $filter('number')(vm.order.pos[posIdx]['prices']['nightlydiscount'][parseFloat(ind[1]) - parseFloat(1)],2);
			} else if(columnName == 'product_discount'){
				vm.modificationComment  = originalOrderData.pos[posIdx]['product_name']+' discount changed  from '+originalOrderData.pos[posIdx][columnName]+' to '+ $filter('number')(vm.order.pos[posIdx][columnName],2);
			} else if(columnName == 'subtotal'){
				vm.modificationComment  = originalOrderData.pos[posIdx]['product_name']+' price changed  from '+originalOrderData.pos[posIdx][columnName]+' to '+ $filter('number')(vm.order.pos[posIdx][columnName], 2);
			}else if(columnName == 'quantity'){
				vm.modificationComment  = originalOrderData.pos[posIdx]['product_name']+' quantity changed  from '+originalOrderData.pos[posIdx][columnName]+' to '+ vm.order.pos[posIdx][columnName];
			}else{
				var ind = changedColumn.split('-');
				vm.modificationComment  = originalOrderData.pos[posIdx]['product_name']+' price for night '+ind[1]+' changed  from '+originalOrderData.pos[posIdx]['prices']['rates'][parseFloat(ind[1]) - parseFloat(1)]+' to '+ vm.order.pos[posIdx]['prices']['rates'][parseFloat(ind[1]) - parseFloat(1)];
			}
			completeModification(vm.order.pos[posIdx].confirmation_number);
		}

		function changeStatusForService(ev,confirmation_number,oldStatus,newStatus,rmMvIdx,grand_total,room_confirmation_number){
			var event = '';
			if(newStatus=='Canceled'){
				var label = 'Cancel';
			} else {
				var label = 'Active';
			}
			$mdDialog.show({
				controller: 'confirmController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
				parent: angular.element(document.body),
				targetEvent: event,
				clickOutsideToClose:true ,
				locals: {
					title: label+' order',
					htmlContent:"Are you sure want to change status of #"+confirmation_number+" to "+newStatus+"?",
					cancelBtn:'No',
					OkBtn:'Yes'
				}
			}).then(function(answer) {
				if(typeof answer != 'undefined' && answer == 'update'){
					$mdDialog.hide();
					changeStatusForServiceFinally(oldStatus,newStatus,confirmation_number,grand_total,room_confirmation_number,rmMvIdx);
				} else if(typeof answer != 'undefined' && (answer == 'close' || answer == 'no')){
					vm.pos_status[rmMvIdx] = oldStatus;
					$mdDialog.hide();
				}
			}, function(dialogText) {
				vm.pos_status[rmMvIdx] = oldStatus;
				$mdDialog.hide();
			});
		}
		vm.processAutomaticRefund = function(data){
			if(vm.order.overalltotals.remaining_amount < 0){
				vm.isloading = true;
				var html = 'Do you want to initiate an automatic refund by the system.</br>';
	            // html = html + '<b>Or you want to refund manually.</b>';	              
	            $mdDialog.show({
	              controller: 'confirmController',
	              controllerAs: 'vm',
	              templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
	              parent: angular.element(document.body),
	              targetEvent: event,
	              clickOutsideToClose:true ,
	              locals: {
	                    title: 'Initiate Automatic Refund.',
	                    htmlContent:html,
	                    cancelBtn:'No',
	                    OkBtn:'Yes'
	                }                
	            })
	            .then(function(answer) {
	               if(typeof answer != 'undefined' && answer == 'update'){
	               	vm.showPaymentsLoader = true;
	                checkoutService.processAutomaticRefund(data).then(function(response){
	                	if(!response.success){
							vm.isloading = false;
							toastMessage.showSimpleToast(response.statusMsg,'error-toast');
	                	}else{
	                		vm.order = response.response.order_data;
							originalOrderData = angular.copy(vm.order);
	                		
	                		$timeout(function(){
								vm.isloading = false;
								fetchPaymentsInformation(vm.one_go_id);
							},100);
	                	}
	                });
	               }
	            }, function() {});				
			}
		}

		function changeStatusForServiceFinally(oldStatus,newStatus,confirmation_number,grand_total,room_confirmation_number,rmMvIdx){
			
			vm.isloading = true;
			checkoutService.changeStatus({'confirmation_number':confirmation_number,'room_stay_status':newStatus,'grand_total':grand_total,'room_confirmation_number':room_confirmation_number,one_go_id:vm.one_go_id}).then(function(response){
				if(response.success ){
					vm.order = response.response.order_data;
					originalOrderData = angular.copy(vm.order);
					
					vm.showPaymentsLoader = true;
					
					if(response.statusMsg != ''){
						toastMessage.showSimpleToast(response.statusMsg,'error-toast');
					}
					if(vm.order.hasOwnProperty('pos') && parseInt(Object.keys(vm.order.pos).length) > 0){
						vm.statusesPos = {};
						angular.forEach(vm.order.pos, function (value, key)
						{
							vm.statusesPos[key] = {'Active':'Active','Canceled':'Cancel'};
							vm.statusesPos[key][value.room_stay_status] = value.room_stay_status;
						});
					}
					$timeout(function(){
						vm.isloading = false;
						fetchPaymentsInformation(vm.one_go_id);
					},100);
					vm.processAutomaticRefund({'confirmation_number':confirmation_number,'room_stay_status':newStatus,'grand_total':grand_total,'room_confirmation_number':room_confirmation_number,one_go_id:vm.one_go_id});
				} else {
					vm.isloading = false;
					toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
					vm.pos_status[rmMvIdx] = oldStatus;
				}
			});
		}

		function refundInstallment(installment,type){
			$mdDialog.show({
				clickOutsideToClose	: false,
				parent             	: angular.element($document.body),
				scope				: $scope,
				preserveScope		: true,
				locals				: {
										localData :{
											installment_id:installment.installment_id,
											installment_amount:installment.installment_amount,
											refund_by_check:installment.refund_by_check,
											type:type,
											payment:installment.payment
										}
									},
				templateUrl        	: 'app/main/apps/e-commerce/views/orders/dialogs/payments/refund.html',
				controller			: RefundController
			});
			function RefundController($scope, $mdDialog, localData) {
				$scope.installment_id = localData.installment_id;
				$scope.refund_amount = localData.installment_amount;
				$scope.installment_amount = localData.installment_amount;
				$scope.refund_by_check = localData.refund_by_check;
				$scope.type = localData.type;
				$scope.check_number = '';
				$scope.payment = localData.payment;
				$scope.closeDialog = function(){
					$mdDialog.hide();
				};
				$scope.checkRefundAmount = function(){
					if(parseFloat($scope.refund_amount) > parseFloat($scope.installment_amount)){
						$scope.refund_amount = $scope.installment_amount;
					}
				};
			}
		}

		function refundInstallmentFinally(installment_id,amount,refund_using,check_number,send_email_indicator){
			vm.isloading = true;
			vm.refundStart = true;
			if(typeof send_email_indicator == 'undefined')
				send_email_indicator = 0;
			if(refund_using == 'original' || refund_using == 'check'){
				var data = {installment_id:installment_id,amount:amount,refund_using:refund_using,confirmation_number:vm.order.room_confirmation_number,roomTotal:vm.order.overalltotals.grand_total,paid_amount:vm.order.overalltotals.paid_amount,traveler_fname:vm.order.first_name,traveler_lname:vm.order.last_name,remaining_amount:vm.order.remaining_amount,reservation_id:vm.order.reservation_id,check_number:check_number,sendEmail:send_email_indicator,one_go_id:vm.one_go_id};
			} else {
				var data = {installment_id:installment_id,amount:amount,refund_using:refund_using,confirmation_number:vm.order.room_confirmation_number,roomTotal:vm.order.overalltotals.grand_total,paid_amount:vm.order.overalltotals.paid_amount,traveler_fname:vm.order.first_name,traveler_lname:vm.order.last_name,remaining_amount:vm.order.remaining_amount,customer_email:vm.order.customer_email,reservation_id:vm.order.reservation_id,sendEmail:send_email_indicator,one_go_id:vm.one_go_id};
			}
			
			console.log(data);
			checkoutService.customPosRefundInstallment(data).then(function(response){
				console.log(response);
				vm.isloading = false;
				vm.refundStart = false;
				$mdDialog.hide();
				if(response.success){
					vm.payingFromGC = {};
					vm.installments = [];
					vm.installments = response.data.installments;
					vm.allcardsInfo = response.data.allcardsInfo;
					vm.installment_amount = angular.copy(vm.installments['remaining'].origremainingamt);
					vm.order = response.reservation;
					originalOrderData = angular.copy(vm.order);
					if(vm.order.hasOwnProperty('pos') && parseInt(Object.keys(vm.order.pos).length) > 0){
						vm.statusesPos = {};
						angular.forEach(vm.order.pos, function (value, key)
						{
							vm.statusesPos[key] = {'Active':'Active','Canceled':'Cancel'};
							vm.statusesPos[key][value.room_stay_status] = value.room_stay_status;
						});
					}
					if(Object.keys(response.data.allcardsInfo).length > 0){
						var size = response.data.allcardsInfo.length;
						vm.payment_method = response.data.allcardsInfo[(parseInt(size)-1)];
						let savedYear = parseInt(vm.payment_method.cc_exp_year);
						let currentYear = new Date().getFullYear();
						if (savedYear && savedYear < currentYear && !vm.yrs_option.includes(savedYear)) {
							vm.yrs_option.unshift(savedYear);
						}
						if(response.data.allcardsInfo[(parseInt(size)-1)].cc_number!=''){
							vm.fieldsIsReadOnly = true;
						}
					} else {
						vm.payment_method.payment_method = response.data.selectedPaymentMethod;
						if(response.data.selectedPaymentMethod == ""){
							vm.payment_method.payment_method = "Cash";
						}
					}
					// Refund Reason Code Start 
					if(response.last_id != undefined && response.last_id != 0) {
						$mdDialog.show({
							clickOutsideToClose	: false,
							parent             	: angular.element($document.body),
							scope				: $scope,
							preserveScope		: true,
							locals				: {
													localData :{}
												},
							templateUrl        	: 'app/main/apps/e-commerce/views/orders/dialogs/payments/refundReason.html',
							controller			: AskReason
						});
						function AskReason($scope, $mdDialog, localData) {
							$scope.voidReason = '';
							$scope.closeDialog = function(){
								$mdDialog.hide();
							};
							$scope.submitReason = function(){
								console.log($scope.voidReason);
								if($scope.voidReason != '') {
									vm.saveRefundReason(response.last_id, $scope.voidReason);
								}
							};
						}        	
					}
					// Refund Reason Code End 
					if(response.hasOwnProperty('mail_error') && response.mail_error && response.errorMsg != '')
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				} else {
					if(response.errorMsg)
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					else
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
				}
			});
		}
		
		function fetchPaymentsInformation(one_go_id){
			angular.forEach($http.pendingRequests, function(request) {
				if (request.cancel && request.timeout) {
				   request.cancel.resolve();
				}
			 });
			if(!vm.order.hasOwnProperty('installments') && one_go_id != ''){
				var data  = {one_go_id:one_go_id,first_name:vm.order.first_name,last_name:vm.order.last_name,total_amount:vm.order.overalltotals.grand_total,remaining_amount:vm.order.overalltotals.remaining_amount};
				eCommerceService.fetchPaymentsInformation(data).then(function(response){
					if(!response.success){
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
					} else {
						if(response.allcardsInfo.length > 0 && response.allcardsInfo != '' ){
							vm.ct = response['allcardsInfo']['cc_type'];
						}
						vm.installments = [];
						vm.installments = response.installments;
						vm.allcardsInfo = response.allcardsInfo;
						vm.customer_profile = response.customer_profile;
						vm.fieldsIsReadOnly = false;
						if(Object.keys(response.allcardsInfo).length > 0){
							vm.payment_method = response.allcardsInfo[0];
							let savedYear = parseInt(vm.payment_method.cc_exp_year);
							let currentYear = new Date().getFullYear();
							if (savedYear && savedYear < currentYear && !vm.yrs_option.includes(savedYear)) {
								vm.yrs_option.unshift(savedYear);
							}
							if(response.allcardsInfo[0].cc_number!=''){
								vm.fieldsIsReadOnly = true;
								vm.use_existingcard = 0;
							}
						}
						vm.installment_amount=vm.installments['remaining'].balance;

						vm.payment_method.payment_method = response.selectedPaymentMethod;
						if(response.selectedPaymentMethod == ""){
							vm.payment_method.payment_method = "Cash";

						}
					}
					vm.showPaymentsLoader = false;
				});
			}
		}
		
		function editParkingDates(ev,checkin,checkout,adult,child,confirmation_number,product_id,product_name,policy_id){
			var localData = {
				checkin:checkin,
				checkout:checkout,
				adult:adult,
				child:child,
				confirmation_number:confirmation_number,
				product_id:product_id,
				product_name:product_name,
				reservation_id:vm.order.reservation_id,
				FromPage:'bar-view',
				one_go_id:vm.one_go_id,
				policy_id:policy_id};
			eCommerceService.editPDatesDialog(ev,localData);
		}

		function updateReservationValues(confirmation_number,column_name,value){
			if(value != ""){
				vm.isloading = true;
				var data = {reservation_id:vm.order.reservation_id,confirmation_number:confirmation_number,column_name:column_name,value:value};
				eCommerceService.updateReservationValues(data).then(function(response){
					vm.isloading = false;
					if(!response.success){
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
					}
				});
			}
		}

		function payInstallment(){
			vm.paymentrequestGoing = true;
			vm.changeStatusData = {confirmation_number:vm.order.room_confirmation_number,remaining_amount:vm.installment_amount,payment_method:vm.payment_method,traveler_fname:vm.order.first_name,traveler_lname:vm.order.last_name,customer_profile:vm.customer_profile,itinerary_number:vm.order.itinerary_number,payingFromGC:vm.payingFromGC,one_go_id:vm.one_go_id};
			checkoutService.payPosInstallments(vm.changeStatusData).then(function(response){
				vm.paymentrequestGoing = false;
				if(!response.success && response.errorMsg!='undefined'){
					toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
				}else if(!response.success){
					toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.', 'error-toast');
				}else if(response.success){
					vm.payingFromGC = {};
					vm.installments = response.data.installments;
					vm.allcardsInfo = response.data.allcardsInfo;
					vm.customer_profile = response.data.customer_profile;
					vm.order = response.reservation;
					originalOrderData = angular.copy(vm.order);
					if(vm.order.hasOwnProperty('pos') && parseInt(Object.keys(vm.order.pos).length) > 0){
						vm.statusesPos = {};
						angular.forEach(vm.order.pos, function (value, key)
						{
							vm.statusesPos[key] = {'Active':'Active','Canceled':'Cancel'};
							vm.statusesPos[key][value.room_stay_status] = value.room_stay_status;
						});
					}
					vm.installment_amount = angular.copy(vm.installments['remaining'].origremainingamt);
					if(Object.keys(response.data.allcardsInfo).length > 0){
						var size = response.data.allcardsInfo.length;
						vm.payment_method = response.data.allcardsInfo[(parseInt(size)-1)];
						let savedYear = parseInt(vm.payment_method.cc_exp_year);
						let currentYear = new Date().getFullYear();
						if (savedYear && savedYear < currentYear && !vm.yrs_option.includes(savedYear)) {
							vm.yrs_option.unshift(savedYear);
						}
						if(response.data.allcardsInfo[(parseInt(size)-1)].cc_number!=''){
							vm.fieldsIsReadOnly = true;
						}
					} else {
						vm.payment_method.payment_method = response.data.selectedPaymentMethod;
						if(response.data.selectedPaymentMethod == ""){
							vm.payment_method.payment_method = "Cash";
						}
					}
				}
			});
		}

		function changeActiveCard(orderIndex){
			var count = vm.use_existingcard;
			vm.payment_method = vm.allcardsInfo[count];
			vm.fieldsIsReadOnly = true;
		}

		function checkremainingAmount(){
			if(parseFloat(vm.installments['remaining'].origremainingamt)<parseFloat(vm.installment_amount)){
				vm.installment_amount = vm.installments['remaining'].origremainingamt;
				toastMessage.showSimpleToast($translate.instant('CREATE_RES.PAYNOW_ERROR'), 'error-toast');
			}else if(parseFloat(vm.payingFromGC.gcCardOrigPrice)>0){
				var adjustedGCPrice = commonService.calculateGCValue(vm.installment_amount,vm.payingFromGC.gcCardOrigPrice);
				vm.payingFromGC.price = adjustedGCPrice;
			}
		}

		function emptythisPayment(){
			var oldPaymentmethod = angular.copy(vm.payment_method.payment_method);
			vm.payment_method = {};
			vm.payment_method.payment_method = oldPaymentmethod;
			vm.fieldsIsReadOnly = false;
			vm.use_existingcard = '';
			vm.ct = '';
		}

		function validateGCCode(){
			 vm.gcrequestGoing = true;
			 createResService.validateGCC({GCC:vm.giftCardCode}).then(function(response){
				vm.gcrequestGoing = false;
				if(response.success && !response.data.length == 0){

					if(parseFloat(response.data[0]['gift_card_price']) == 0){
						vm.giftCardErrro = 'No amount left for this gift card.';
					}else{
						var adjustedGCPrice = commonService.calculateGCValue(vm.installment_amount,response.data[0]['gift_card_price']);
						vm.payingFromGC = {};
						vm.payingFromGC.price = adjustedGCPrice;
						vm.payingFromGC.gcCode = response.data[0]['gift_card_code'];
						vm.payingFromGC.gcCardOrigPrice = response.data[0]['gift_card_price'];
						vm.giftCardErrro = '';
						vm.giftCardCode = '';
						$location.hash('focus-cccode');
							$timeout(function() {
								$window.location.hash='';
							},2000);
					}


				}else if(!response.success && response.errorMsg!=''){
					vm.payingFromGC = {};
					vm.giftCardErrro = response.errorMsg;
				}else if(response.data.length == 0){
					vm.payingFromGC = {};
					vm.giftCardErrro = $translate.instant('CREATE_RES.INVALID_GC');
				}else{
					vm.payingFromGC = {};
					vm.giftCardErrro = $translate.instant('CREATE_RES.SERVER_ERROR');
				}
			});
		}
  //       function addroomincart(ev){
		// 	createResService.addRoom(
		// 						ev,
		// 						vm.order.room_stay_from,
		// 						vm.order.room_stay_to,
		// 						vm.order['room_stay_guest_count'],
		// 						vm.order['room_stay_child_count'],
		// 						'',
		// 						'currentorder',
		// 						vm.order.itinerary_number
		// 						);
		// }

		
		$scope.$on('update_order_data', function(event,data) {
			vm.order = data.order_info;
			originalOrderData = angular.copy(vm.order);
			if(vm.order.hasOwnProperty('pos') && parseInt(Object.keys(vm.order.pos).length) > 0){
				vm.statusesPos = {};
				angular.forEach(vm.order.pos, function (value, key)
				{
					vm.statusesPos[key] = {'Active':'Active','Canceled':'Cancel'};
					vm.statusesPos[key][value.room_stay_status] = value.room_stay_status;
				});
			}
			vm.showModifyBtn = false;
			vm.showPaymentsLoader = true;
			$timeout(function(){
				fetchPaymentsInformation(vm.one_go_id);
			},100);
		});

		/*Print Registration Card*/
		vm.printRegistrationCard = function(){
			vm.isloading = true;
			createResService.printRegistrationCard({confirmation_number :vm.order.confirmation_number}).then(function(response){
				vm.isloading = false;
				var myWindow=window.open('','','', '');
				myWindow.document.write(response['data']);
				myWindow.document.close();
				myWindow.focus();
				$timeout(function() {
					myWindow.print();
					myWindow.close();
				},500);
			});
		}
		/*Function to print the parking pass*/
		vm.printParkingPass = printParkingPass;
		function printParkingPass(posValue){
			vm.isloading = true;
			var data = {
				conf : posValue['confirmation_number'],
				from : posValue['room_stay_from'],
				to 	 : posValue['room_stay_to']
			}
			createResService.printParkingPass(data).then(function(response){
				vm.isloading = false;
				var myWindow=window.open('','','', '');
				myWindow.document.write(response['data']);
				myWindow.document.close();
				myWindow.focus();
				$timeout(function() {
					myWindow.print();
					myWindow.close();
				},500);
			});

		}
		function addTipToThisOrder(){
			var barItem = [];
			angular.forEach(vm.order.pos, function (value, key){
				var singleBarItem = {
						'use_count' : false,
						'additional_guest_amounts' : 0,
						'auto_added' : 0,
						'customDiscount' : value.product_discount,
						'customDiscountPercentage' : 0,
						'customPrice' : value.subtotal,
						'discountAmt' : value.product_discount,
						'discountPer' : 0,
						'grand_total' : value.grand_total,
						'media' : '',
						'nightlySum' : value.nightlySum,
						'orig_tax_value' : value.tax_amount,
						'original_deposit_amt' : value.product_discount,
						'particularCustomPrice' : value.subtotal,
						'pos_deposit_amount' : 0,
						'pos_deposit_type_indicator' : 0,
						'product_description' : 0,
						'product_discount' : value.product_discount,
						'product_discount_comment' : '',
						'product_id' : value.product_id,
						'product_is_timebound' : 0,
						'product_name' : value.product_name,
						'product_price' : value.subtotal,
						'product_type' : 'pos',
						'quantity' : value.quantity,
						'remaining_amount' : value.remaining_amount,
						'tax' : value.tax_amount,
						'tax_id' : value.tax_id,
						'tax_value' : value.tax_percentage,
						'total' : value.grand_total
						};
				barItem.push(singleBarItem);
			});

			var barUser = {
						'address' : vm.order.address,
						'city' : vm.order.city,
						'country' : vm.order.country,
						'customer_email' : vm.order.customer_email,
						'customer_id' : vm.order.customer_id,
						'first_name' : vm.order.first_name,
						'last_name' : vm.order.last_name,
						'phone_number' : vm.order.phone_number,
						'secondary_phone_number' : '',
						'state' : vm.order.state,
						'zip_code' : vm.order.zip_code
						};
			$sessionStorage['selectedUser_' + $localStorage['preHotelId']] = '';
			$sessionStorage.add_tip_to_order = true;
			$sessionStorage['unset_all_var_' + $localStorage['preHotelId']] = false;
			$sessionStorage.add_tip_to_grand_total = vm.order.overalltotals.grand_total;
			$sessionStorage.add_tip_to_itinerary = vm.order.itinerary_number; //
			$sessionStorage.add_tip_to_room_conf = vm.order.room_confirmation_number; //
			$sessionStorage['webpos_one_go_order_number_' + $localStorage['preHotelId']] = vm.one_go_id;
			$sessionStorage.add_tip_to_method = vm.order.method;
			$localStorage['barUser_'+$localStorage['preHotelId']] = barUser;

			if (vm.currentPageFor === 'restaurant') {
				$sessionStorage['restaurantItem_'+$localStorage['preHotelId']] = barItem;
				$state.go('app.restaurant',{'one_go_id':vm.one_go_id});
			} else {
				$localStorage['barItem_'+$localStorage['preHotelId']] = barItem;
				$state.go('app.bar',{'one_go_id':vm.one_go_id});
			}
		}
		function addBarToThisOrder(){
			$sessionStorage['editReservationOrder'] = angular.copy(vm.order);
			var params = {
				product_id:vm.order.reservation_id,
				product_name: vm.currentPageFor+' Order',
				addServiceForRoom: true,
				typeofService: vm.currentPageFor,
				pageFrom : vm.currentPageFor === 'restaurant' ? 'restaurant' : 'order',
				itinerary_number:vm.order.itinerary_number,
				confirmation_number:vm.order.room_confirmation_number,
				one_go_id:vm.one_go_id
				};
			$sessionStorage['pageDetails_' + $localStorage['preHotelId']] = params;

			if (vm.currentPageFor === 'restaurant') {
				$state.go('app.restaurantCheckout', params);
			} else {
				$state.go('app.resCheckout',params);
			}
		}
		
		/* Card Swiper code starts */
		function trimNumber(s) {
			while (s.substr(0, 1) == '0' && s.length > 1) {
				s = s.substr(1, 9999);
			}
			return s;
		}

		function parseSwiperData(value) {
			if (value.charAt(0) !== '%') {
				return -1;
			}
			var p = new SwipeParserObj(value);
			var result = new Array();
			if (p.hasTrack1) {
				if (p.surname != null)
					result[0] = p.surname + ' ' + p.firstname;
				else
					result[0] = p.account_name;
				result[1] = p.account;
				result[2] = p.exp_month;
				result[3] = p.exp_year;
			}
			return result;
		}
		window.parseSwiperData = parseSwiperData;

		var method = 'authorizenet';
		vm.swipeText = 'Click here to swipe';
		vm.keyupfunction = keyupfunction;
		vm.paymentMethodSelected = paymentMethodSelected;
		vm.ReadySwipe = ReadySwipe;
		vm.ResetSwipe = ResetSwipe;
		vm.swipeNow = swipeNow;

		function swipeNow() {
			if (angular.element('#authorizenet-swiper-data')) {
				angular.element('#authorizenet-swiper-data').val(' ');
				angular.element('#authorizenet-swiper-data').select();
			}
		}

		function ReadySwipe() {
			vm.swipeText = 'Ready to swipe';
		}

		function ResetSwipe() {
			vm.swipeText = 'Click here to swipe';
		}

		vm.customerPreviousName = '';

		function paymentMethodSelected() {
			if (vm.payment_method.payment_method == 'Credit Card') {
				$timeout(function() {
					angular.element('#authorizenet-swiper-status').trigger('click');
				}, 100);
			}
		}

		function keyupfunction(event) {
			if (event.keyCode == 13) { // was: event.keyCode == 13
				var ccinfo = parseSwiperData(vm.ccinfo_a);
				var errorFound = false;
				if (ccinfo === -1) {} else {
					if (ccinfo != null && ccinfo.length > 0) {

						vm.payment_method.cc_fname = '';
						vm.payment_method.cc_lname = '';
						vm.payment_method.cc_number = '';
						vm.payment_method.cc_number_mask = '';
						vm.payment_method.cc_type = '';
						vm.payment_method.cc_exp_month = '';
						vm.payment_method.cc_exp_year = '';
						
						var owner = ccinfo[0].trim().replace(/\s\s+/g, ' ');
                        var cc_owner = owner.split(" ");
						if (cc_owner.length > 1) {
							vm.payment_method.cc_fname = cc_owner[0];
							vm.payment_method.cc_lname = cc_owner[cc_owner.length -1];
						} else {
							vm.payment_method.cc_fname = cc_owner[0];
						}
						if (ccinfo[1] == null) {
							alert('Card number not detected!');
							errorFound = true;
						} else {
							vm.payment_method.cc_number = ccinfo[1];
							vm.payment_method.cc_number_mask = ccinfo[1].replace(/.*(\d{4})$/, "xxxxxxxxxxxx$1");
							var startdigit = parseInt(ccinfo[1].charAt(0));
							if (startdigit == 3)
								vm.payment_method.cc_type = 'American Express';
							if (startdigit == 4)
								vm.payment_method.cc_type = 'Visa';
							if (startdigit == 5)
								vm.payment_method.cc_type = 'MasterCard';
							if (startdigit == 6)
								vm.payment_method.cc_type = 'Discover';
							if (jQuery('select#' + method + '_cc_type').val() == "") {
								alert('Card type not detected!');
								errorFound = true;
							}
						}
						if (ccinfo[2] == null) {
							alert('Expiration month not detected!');
							errorFound = true;
						} else {
							vm.payment_method.cc_exp_month = trimNumber(ccinfo[2]);
						}
						if (ccinfo[3] == null) {
							alert('Expiration year not detected!');
							errorFound = true;
						} else {
							vm.payment_method.cc_exp_year = ccinfo[3];
							if (jQuery('#' + method + '_expiration_yr').val() == "") {
								alert("The card might be expired!");
								errorFound = true;
							}
						}
						$timeout(function() {
							angular.element('#authorizenet_cc_number_label').trigger('click');
						}, 0);
					} else {
						alert("Cannot read the data!");
						errorFound = true;
					}
					if (!errorFound) {
						//~ onBlurCheckForm();
					}
					vm.ccinfo_a = "";
					jQuery('#loading-mask').hide();
				}
			}
		}

		/*
        **  Save the refund reason after refund is completed
        */
        vm.saveRefundReason = function(installmentId, reason) {
        	vm.isloading = true;
        	if(installmentId != undefined && reason != undefined) {
        		var postData = {
        			installmentId : installmentId,
        			reason : reason
        		}
        		
        		eCommerceService.saveRefundReason(postData).then(function(response){
        			vm.isloading = false;
					$mdDialog.hide();
        			if(response.status != undefined && response.status == "success") {
        				Object.keys(vm.installments).forEach(function(key) { 
			    			if(key != 'remaining' && vm.installments[key].installment_id == installmentId){
			    				console.log(vm.installments[key]);
			    				vm.installments[key].reason = reason;
			    			}
			    		});
        			}
        		});

        	}
        }

		jQuery(document).on("click", '.payment-methods input[type=radio]', function() {
			swipeNow(jQuery('.payment-methods input[type=radio]:checked').val());
		});
		swipeNow(jQuery('input[name="payment[method]"]:checked').val());
		/* Card Swiper code ends */

		setTimeout(function() {
		   vm.autoFillOff = false;
		}, 1500); 
	}
})();

(function() {
    'use strict';

    angular
        .module('app.checkout')
        .controller('payorder', payorder);

    /** @ngInject */
    function payorder(
        $sessionStorage,
        $scope,
        $mdDialog,
        $filter,
        commonService,
        parentScope,
        dailogInfo
    ) {
        /*initialization*/
        var vm = this;
        vm.number = 0;
        vm.tempNumber = 0.00;
        vm.updated = false;
        vm.customTip = dailogInfo.originalAmount + '';
        vm.dialogTitle = dailogInfo.title;
        vm.popUpType = 'editposorder';

        vm.getNumber = getNumber;
        vm.UpdateInputBox = UpdateInputBox;
        vm.updateCustomPrice = updateCustomPrice;

        function UpdateInputBox(number){
            vm.updated = true;
            if(number == -1){
                vm.tempNumber = commonService.roundnum(vm.tempNumber,2);
                if(vm.tempNumber > 0){
                    vm.tempNumber = commonService.roundnum(vm.tempNumber*0.1,3);
                    vm.tempNumber = vm.tempNumber + "";
                    vm.tempNumber = vm.tempNumber.slice(0, -1);
                    vm.tempNumber = commonService.roundnum(parseFloat(vm.tempNumber),2);
                }else
                    vm.tempNumber = '0.00';
            } else if(vm.tempNumber > 0 && typeof number == 'string'){
                vm.tempNumber = commonService.roundnum(parseFloat(vm.tempNumber) * 100,2);
            } else if(typeof number == 'number' && ((number == 0 && vm.tempNumber > 0) || number > 0 )){
                number = parseFloat(number) * 0.01;
                vm.tempNumber = commonService.roundnum((parseFloat(vm.tempNumber) * 10) + parseFloat(number),2);
            } else if(vm.tempNumber == 0 && (number == 0 || number == '00')){
                vm.tempNumber = '0.00';
            }
            vm.customTip = (typeof vm.tempNumber == 'string') ? vm.tempNumber : parseFloat(vm.tempNumber);
        }
        function getNumber(num){
            if(num <= 9){
                vm.number = parseInt(num)+ parseInt(1);
                return vm.number;
            }
        }
        function updateCustomPrice(event) {
            if(!vm.updated)
                vm.tempNumber = dailogInfo.originalAmount;
            parentScope.installment_amount = parseFloat(vm.tempNumber);
            parentScope.checkremainingAmount();
            $mdDialog.cancel();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.checkout')
        .controller('editposorder', editposorder);

    /** @ngInject */
    function editposorder(
        $sessionStorage,
        $scope,
        $mdDialog,
        $filter,
        commonService,
        parentScope,
        dailogInfo
    ) {
        /*initialization*/
        var vm = this;
        vm.number = 0;
        vm.tempNumber = 0.00;
        vm.updated = false;
        vm.customTip = dailogInfo.originalAmount + '';
        if(dailogInfo.fieldname == 'nightlydiscount'){
            vm.dialogTitle = 'Discount';
        } else if(dailogInfo.fieldname == 'product_discount'){
            vm.dialogTitle = 'Discount (per qty)';
        } else if(dailogInfo.fieldname == 'prices'){
            vm.dialogTitle = 'Price';
        } else {
            vm.dialogTitle = dailogInfo.title;
        }
        vm.popUpType = 'editposorder';

        vm.getNumber = getNumber;
        vm.UpdateInputBox = UpdateInputBox;
        vm.updateCustomPrice = updateCustomPrice;

        function UpdateInputBox(number){
            vm.updated = true;
            if(dailogInfo.fieldname == 'quantity'){
                vm.tempNumber = parseInt(vm.tempNumber);
                if(number == -1){
                    if(vm.tempNumber > 0){
                        vm.tempNumber = vm.tempNumber + "";
                        vm.tempNumber = vm.tempNumber.slice(0, -1);
                        if(vm.tempNumber == '')
                            vm.tempNumber = '1';
                    }else
                        vm.tempNumber = '1';
                } else if(number >= 0 && vm.tempNumber > 0){
                    vm.tempNumber = vm.tempNumber + '';
                    vm.tempNumber = vm.tempNumber + number;
                } else if(vm.tempNumber == 0 && number != 0) {
                    vm.tempNumber = number + '';
                } else {
                    vm.tempNumber = '1';
                }
                if(parseInt(vm.tempNumber) > 1000) vm.tempNumber = '1000';
            } else {
                if(number == -1){
                    vm.tempNumber = commonService.roundnum(vm.tempNumber,2);
                    if(vm.tempNumber > 0){
                        vm.tempNumber = commonService.roundnum(vm.tempNumber*0.1,3);
                        vm.tempNumber = vm.tempNumber + "";
                        vm.tempNumber = vm.tempNumber.slice(0, -1);
                        vm.tempNumber = commonService.roundnum(parseFloat(vm.tempNumber),2);
                    }else
                        vm.tempNumber = '0.00';
                } else if(vm.tempNumber > 0 && typeof number == 'string'){
                    vm.tempNumber = commonService.roundnum(parseFloat(vm.tempNumber) * 100,2);
                } else if(typeof number == 'number' && ((number == 0 && vm.tempNumber > 0) || number > 0 )){
                    number = parseFloat(number) * 0.01;
                    vm.tempNumber = commonService.roundnum((parseFloat(vm.tempNumber) * 10) + parseFloat(number),2);
                } else if(vm.tempNumber == 0 && (number == 0 || number == '00')){
                    vm.tempNumber = '0.00';
                }
            }
            vm.customTip = (typeof vm.tempNumber == 'string') ? vm.tempNumber : parseFloat(vm.tempNumber);
        }
        function getNumber(num){
            if(num <= 9){
                vm.number = parseInt(num)+ parseInt(1);
                return vm.number;
            }
        }
        function updateCustomPrice(event) {
            var newIndex = 0; 
            if(dailogInfo.fieldname == 'nightlydiscount'){
                newIndex = parseInt(dailogInfo.nightIdx) + 1; 
                parentScope.order.pos[dailogInfo.poskey].prices.nightlydiscount[dailogInfo.nightIdx] = vm.tempNumber;
                parentScope.order.pos[dailogInfo.poskey].reservation_status_type = 'POS-night'+dailogInfo.nightIdx +'-' + 'nightlydiscount';
            } else if(dailogInfo.fieldname == 'prices'){
                newIndex = parseInt(dailogInfo.nightIdx) + 1; 
                parentScope.order.pos[dailogInfo.poskey].prices.rates[dailogInfo.nightIdx] = vm.tempNumber;
                parentScope.order.pos[dailogInfo.poskey].reservation_status_type = 'POS-night'+dailogInfo.nightIdx +'-' + 'prices';
            } else if(dailogInfo.fieldname == 'subtotal'){
                parentScope.order.pos[dailogInfo.poskey].nightlySum = vm.tempNumber;
                parentScope.order.pos[dailogInfo.poskey].reservation_status_type = 'POS-subtotal';
            } else if(dailogInfo.fieldname == 'product_discount'){
                parentScope.order.pos[dailogInfo.poskey].product_discount = vm.tempNumber;
                parentScope.order.pos[dailogInfo.poskey].reservation_status_type = 'POS-discount';
            } else {
                parentScope.order.pos[dailogInfo.poskey][dailogInfo.fieldname] = vm.tempNumber;
                parentScope.order.pos[dailogInfo.poskey].reservation_status_type = 'POS-quantity';
            }
            if(!vm.updated)
                vm.tempNumber = dailogInfo.originalAmount;
            parentScope.setShowModifyBtn(vm.dialogTitle,dailogInfo.fieldname,dailogInfo.poskey);
            $mdDialog.cancel();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.blank', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_blank', {
            url  : '/ui/page-layouts/blank',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/blank/blank.html',
                    controller : 'BlankController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.blank')
        .controller('BlankController', BlankController);

    /** @ngInject */
    function BlankController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.resetpassword', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages/auth/resetpassword', {
            url      : '/resetpassword/:hash',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages/auth/resetpassword': {
                    templateUrl: 'app/main/pages/auth/resetpassword/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'resetpassword',
            authenticate: false
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/resetpassword');

        // Navigation
        /*msNavigationServiceProvider.saveItem('pages.auth.reset-password', {
            title : 'Reset Password',
            state : 'app.pages_auth_reset-password',
            weight: 6
        });*/
         
    }

})();

(function ()
{
    'use strict';

    angular
    .module('app.pages.auth.resetpassword')
    .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController($state,$http,$window,loginService,$location,$stateParams) {

        var vm              = this;
        vm.loadingmessage   = '';
        vm.generateNewPass  = generateNewPass;
        vm.disableClose  = disableClose;
        vm.errorMessage     = 'Reset password link expired.';
		vm.password='';
        function disableClose(){
           vm.type='';
       }

        function generateNewPass(){
            
            vm.form.password=vm.password;
            vm.error    = false;
            vm.password = false; 
            if(vm.form.password === vm.form.passwordConfirm && $location.$$search.hash !=='undefined'){

                var data = {'pass':vm.form.password,'confpass':vm.form.passwordConfirm,'hash':$stateParams.hash};
                loginService.generateNewPass(data).then(function(dataResponse){

                    if(dataResponse.success === true){
                        $state.go('app.pages_auth_login', { type: 'success', 'message': 'New password has been generated successfully.'});
                    }else{
                     vm.type = 'failure';
                vm.errorMessage = 'Your authorization token does not match.';
                 }
             });
            }else if(vm.form.password !== vm.form.passwordConfirm){
                vm.type = 'failure';
                vm.errorMessage = 'Password and confirm password should be same.';
                vm.password = true; 
            }else{
                vm.error = true;
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_register', {
            url      : '/register',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register': {
                    templateUrl: 'app/main/pages/auth/register/register.html',
                    controller : 'RegisterController as vm'
                }
            },
            bodyClass: 'register',
            authenticate: false
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/register');

        // Navigation
        /*msNavigationServiceProvider.saveItem('pages.auth.register', {
            title : 'Register',
            state : 'app.pages_auth_register',
            weight: 3
        });*/
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register')
        .service('signupservice', signupservice);

    /** @ngInject */
    function signupservice($http,EnvironmentConfig)
    {
        var service = {
            createUser: createUser,
            checkifunique  : checkifunique,
            socialRegistration : socialRegistration
        };

        return service;

       function getDataComplete(response) {
			return response.data;
		}

		function getDataFailed(error) {
			return error.data;
		}
		function checkifunique(fieldParams){
			return $http({
				url:EnvironmentConfig.api+'users/skipAcl_checkifuserexists',
				method:'POST',
				data:fieldParams
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function createUser(loginParams){
			return $http({
				url:EnvironmentConfig.api+'users/create_user',
				method:'POST',
				data:loginParams
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function socialRegistration(socialData){
			
			return $http({
				url:EnvironmentConfig.api+'users/skipAcl_social_user',
				method:'POST',
				data:socialData
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
    }
})();
(function ()
{
	'use strict';
    angular
        .module('app.pages.auth.register')
        .controller('RegisterController', RegisterController)
        .directive('emailUnique', emailUnique)
        .directive('pwdAndCnfmSame', pwdAndCnfmSame)
        .directive('minPassword', minPassword)
        .directive('minPasswordEdit', minPasswordEdit)
        .directive('pwdAndCnfmSameEdit', pwdAndCnfmSameEdit)
        .directive('compareTo', compareTo);

	/** @ngInject */
	function RegisterController($state,signupservice,$rootScope,toastMessage)
	{
        // Data
        var vm = this;
        vm.signup=signup;
        vm.buttonActive = 2;
        vm.disableClose=disableClose;
        vm.socalLogins = socalLogins;
        vm.password='';
        vm.socialData='';
        // Methods
        function signup(){
        	vm.buttonActive=1;
        	vm.form.password=vm.password;
        	vm.form.location='createscreen';
        	signupservice.createUser(vm.form).then(function(response){
        		if(response.success===1){
        			$state.go('app.pages_auth_login', { type: 'success', 'message': 'Account created successfuly, please login using your credentials.'});
        		}else{
        			vm.buttonActive = 2;
        			vm.errorMessage=response.errorMsg;
        		}
        	});
        };
        function disableClose(){
        	vm.errorMessage='';
        }

        function socalLogins(type,regPage) {
	    	$rootScope.$on('event:social-sign-in-success', function(event, userDetails){

	 			vm.socialData = userDetails;
	 			signupservice.socialRegistration(vm.socialData).then(function(response){
    					if(response.success ==true){
							toastMessage.showSimpleToast('You are successfully registered. Please check your email','success-toast');
    					}else{
							toastMessage.showSimpleToast('Email address already already exists.','error-toast');
    					}
    				});
	 			});
 			}
    }

    function emailUnique(signupservice){
    	return {
    		require: 'ngModel',
    		link: function(scope, element, attr, mCtrl) {
    			function myValidation(value) {
					if(value!=''){
						var data={'value':value,'field':'email'};
						if(typeof scope.vm.adminuser!='undefined' && scope.vm.adminuser.user_id!=''){
							var data={'value':value,'field':'email','user_id':scope.vm.adminuser.user_id};
						}else{
							var data={'value':value,'field':'email'};
						}
						signupservice.checkifunique(data).then(function(response){
							if(response.error===1){
								mCtrl.$setValidity('email-unique', false);
							}else{
								mCtrl.$setValidity('email-unique', true);
							}
						});

					}else{
						mCtrl.$setValidity('email-unique', true);
					}
					return value;
    			}
    			mCtrl.$parsers.push(myValidation);
    		}
    	};
    }
    function pwdAndCnfmSame(){
        return {
            require: 'ngModel',
            link: function(scope, element, attr, mCtrl) {
                function myValidation(value) {
                    if(scope.vm.password!=''){
                        if(value!=scope.vm.password){
                            mCtrl.$setValidity('pwd-and-cnfm-same', false);
                        }else{
                            mCtrl.$setValidity('pwd-and-cnfm-same', true);
                        }
                    }
                    return value;
                }
                mCtrl.$parsers.push(myValidation);
            }
        };
    }
    function minPassword(){
		return {
			require: 'ngModel',
			link: function(scope, element, attr, mCtrl) {
			  function myValidation(value) {
                var text = value == null ? '' : String(value);
				if(text.length < 6){
					mCtrl.$setValidity('min-password', false);
				} else {
					mCtrl.$setValidity('min-password', true);
				}
				return value;
			  }
			  mCtrl.$parsers.push(myValidation);
			}
		  };
	}
    function pwdAndCnfmSameEdit(){
        return {
            require: 'ngModel',
            link: function(scope, element, attr, mCtrl) {
                function myValidation(value) {
                        if(value.length == 0 ){
                            mCtrl.$setValidity('pwd-and-cnfm-same-edit', true);
                        }else if(value !=scope.vm.password){
                            mCtrl.$setValidity('pwd-and-cnfm-same-edit', false);
                        } else {
                            mCtrl.$setValidity('pwd-and-cnfm-same-edit', true);
                        }
                    return value;
                }
                mCtrl.$parsers.push(myValidation);
            }
        };
    }

    function minPasswordEdit(){
        return {
            require: 'ngModel',
            link: function(scope, element, attr, mCtrl) {
              function myValidation(value) {
                 var text = value == null ? '' : String(value);
                 if(text.length == 0){
                        mCtrl.$setValidity('min-password-edit', true);
                } else if(text.length > 0 && text.length <6) {
                        mCtrl.$setValidity('min-password-edit', false);
                }  else{
                        mCtrl.$setValidity('min-password-edit', true);
                }
                return value;
              }
              mCtrl.$parsers.push(myValidation);
            }
          };
    }
    function compareTo() {
    return {
      require: "ngModel",
      scope: {
        otherModelValue: "=compareTo"
      },
      link: function(scope, element, attributes, mCtrl) {

        mCtrl.$validators.compareTo = function(modelValue) {
          var current = modelValue == null ? '' : modelValue;
          var other = scope.otherModelValue == null ? '' : scope.otherModelValue;
          return current == other;
        };
        scope.$watch("otherModelValue", function() {
          mCtrl.$validate();
        });
      }
    };
  };



})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider,msApiProvider, msNavigationServiceProvider){
        // State
        $stateProvider.state('app.pages_auth_login', {
            url      : '/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/main/pages/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login',
            authenticate: false,
            params:{
                type:'',
                message:''
            }
        }).state('app.pages_auth_forgot-login', {
            url      : '/login-via-secret-code',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-login': {
                    templateUrl: 'app/main/pages/auth/login/login-via-secret-code.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'forgot-password',
            authenticate: false
         });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login');
		
		// Api
        // msApiProvider.register('login', ['app/data/pages/auth/login/pages.json']);

        // Navigation
        /*msNavigationServiceProvider.saveItem('pages.auth', {
            title : 'Authentication',
            icon  : 'icon-lock',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('pages.auth.login', {
            title : 'Login',
            state : 'app.pages_auth_login',
            weight: 1
        });*/
    }

})();

(function (){
    'use strict';

    angular
    .module('app.pages.auth.login')
    .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($rootScope, $state, loginService, $localStorage, $stateParams, EnvironmentConfig,Idle, Keepalive) {
        // Data
        var vm = this;
        // Methods
        vm.checklogin   = checklogin;
        vm.disableClose = disableClose;
        vm.togglePasswordVisibility = togglePasswordVisibility;
        vm.showPassword = false;
        vm.buttonActive = 2;
        vm.type 			= $stateParams.type;
		vm.successMessage 	= $stateParams.message;
        vm.requestProgressing = false;

		/**
         * Go to orders page
        */

        function checklogin(){
            if(vm.form.email.length > 0 && vm.form.password.length > 0 ){
                var data = {'uname':vm.form.email,'pass':vm.form.password};
                vm.buttonActive = 1;

                loginService.getlogin(data).then(function(res){
                    vm.loadingmessage='';
                    $localStorage.firstTimeRedirectState = '';
                    if(res.status && res.permission !== ''){
                        $localStorage.authToken = res.authToken;
                        $localStorage.userId    = res.userDetail.id;
                        $localStorage.firstName = res.userDetail.fname;
                        $localStorage.lastName  = res.userDetail.lname;
                        $localStorage.userPermissions= btoa(res.userPermissions);
                        $rootScope.userPermissions = atob($localStorage.userPermissions);
                        $rootScope.currentState = res.permission;
                        $localStorage.firstTimeRedirectState = res.permission;
                        $localStorage.roleId    = res.userDetail.roleId;
                        $localStorage.roleWebsites    = res.roleWebsites;
                        $rootScope.hotels       = $localStorage.hotels      = res.hotels.hotelList;
                        $rootScope.selectedHotel = $localStorage.selectedHotel = res.hotels.selected;
                        $localStorage.hotelgeneralsetting = res.hotelgeneralsetting || {};
                        $rootScope.loadHotelInformation($localStorage.hotels[$localStorage.selectedHotel].hotel_id);
                        if(res.userDetail.profilePic == null ||  res.userDetail.profilePic.length == 0){
                           res.userDetail.profilePic = 'profile.jpg';
                        }

                        $localStorage.profilePic = EnvironmentConfig.api+'assets/uploads/profileimage/thumbnail/'+res.userDetail.profilePic;
                        $rootScope.$broadcast('app:loggedIn');
                        loginService.updateLastLogin();
                        if(typeof $localStorage.preUrlOrder != 'undefined' && $localStorage.preUrlOrder.length > 0 && $localStorage.preUrlOrder != 'app.pages_auth_login' && $localStorage.preUrlOrder != 'app.pages_auth_forgot-password' ){
                            var url = angular.copy($localStorage.preUrlOrder);
                            var data = angular.copy($localStorage.preUrlData);
                            $state.go(url, data);
                            $localStorage.preUrlOrder = '';
                            $localStorage.preUrlData = '';
    					} else {
    						Idle.watch();
                            if($rootScope.currentState == ''){
    						    $state.go('app.dashboards_project');
                            } else {
                                $state.go($rootScope.currentState);
                            }
    					}
                    } else {
                        vm.buttonActive = 2;
                        vm.type = 'error';
                        if (res.permission === '') {
                            vm.successMessage = 'No permission is asssigned to role. Please contact administrator';
                        } else {
                            vm.successMessage = res.msg;
                        }
                    }
                }).catch(function (e) {
                    vm.buttonActive = 2;
                    vm.type = 'error';
                    vm.successMessage = 'Looks like you\'re not connected to the internet.  Please check your connection.';
                });
            }
       }

       vm.loginViaSecretCode = loginViaSecretCode;
       vm.secretCode = '';

       function loginViaSecretCode(){
           var data = {'loginThroughSscretCode':true,'secretCode':vm.secretCode};
         loginService.getlogin(data).then(function(res){            
                    vm.loadingmessage='';
                    $localStorage.firstTimeRedirectState = '';
                    if(res.status && res.permission !== ''){
                        $localStorage.authToken = res.authToken;
                        $localStorage.userId    = res.userDetail.id;
                        $localStorage.firstName = res.userDetail.fname;
                        $localStorage.lastName  = res.userDetail.lname;
                        $localStorage.userPermissions= btoa(res.userPermissions);
                        $rootScope.userPermissions = atob($localStorage.userPermissions);
                        $rootScope.currentState = res.permission;
                        $localStorage.firstTimeRedirectState = res.permission;
                        $localStorage.roleId    = res.userDetail.roleId;
                        $localStorage.roleWebsites    = res.roleWebsites;
                        $rootScope.hotels       = $localStorage.hotels      = res.hotels.hotelList;
                        $rootScope.selectedHotel = $localStorage.selectedHotel = res.hotels.selected;
                        $localStorage.hotelgeneralsetting = res.hotelgeneralsetting || {};
                        $rootScope.loadHotelInformation($localStorage.hotels[$localStorage.selectedHotel].hotel_id);
                        if(res.userDetail.profilePic == null ||  res.userDetail.profilePic.length == 0){
                           res.userDetail.profilePic = 'profile.jpg';
                        }

                        $localStorage.profilePic = EnvironmentConfig.api+'assets/uploads/profileimage/thumbnail/'+res.userDetail.profilePic;
                        $rootScope.$broadcast('app:loggedIn');
                        loginService.updateLastLogin();
                        if(typeof $localStorage.preUrlOrder != 'undefined' && $localStorage.preUrlOrder.length > 0 && $localStorage.preUrlOrder != 'app.pages_auth_login' && $localStorage.preUrlOrder != 'app.pages_auth_forgot-password' ){
                            var url = angular.copy($localStorage.preUrlOrder);
                            var data = angular.copy($localStorage.preUrlData);
                            $state.go(url, data);
                            $localStorage.preUrlOrder = '';
                            $localStorage.preUrlData = '';
                        } else {
                            Idle.watch();
                            if($rootScope.currentState == ''){
                                $state.go('app.dashboards_project');
                            } else {
                                $state.go($rootScope.currentState);
                            }
                        }
                    } else {
                        vm.buttonActive = 2;
                        vm.type = 'error';
                        if (res.permission === '') {
                            vm.errorMessage = 'No permission is asssigned to role. Please contact administrator';
                        } else {
                            vm.errorMessage = res.msg;
                        }
                    }
                
         }).catch(function (e) {;
                vm.errorMessage = 'Looks like you\'re not connected to the internet.  Please check your connection.';
            });

       }

       function disableClose(){
           vm.type='';
           vm.errorMessage = '';

	   }

       function togglePasswordVisibility() {
           vm.showPassword = !vm.showPassword;
       }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/main/pages/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password',
            authenticate: false
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/forgot-password');

        // Navigation
       /* msNavigationServiceProvider.saveItem('pages.auth.forgot-password', {
            title : 'Forgot Password',
            state : 'app.pages_auth_forgot-password',
            weight: 5
        });*/
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController($state,$http,$window,loginService){

        var vm = this;

        vm.generateResetPassLink = generateResetPassLink;
        vm.disableClose = disableClose;
        vm.requestProgressing = false;

        function generateResetPassLink(){
            vm.requestProgressing = true;

            vm.data = {'email':vm.form.email};
            loginService.getpasswordLink(vm.data).then(function(response){
                if(response.success === true){
                   vm.success = true;
                   vm.errorMessage = '';
                //    vm.ResetLink = 'Reset password link has been generated and sent to your email address.' ;
                   $state.go('app.pages_auth_login', { type: 'success', 'message': 'Reset password link has been generated and sent to your email address.'});
                   vm.requestProgressing = false;
                }else{
				   vm.success = false;
				   vm.errorMessage = 'Invalid email address.';
                   vm.ResetLink = '';
                   vm.requestProgressing = false;
				}
            });
        };
        function disableClose(){
			vm.success = false;
			vm.errorMessage = '';
		};
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.settings.triggers')
        .factory('triggersService', triggersService);

    /** @ngInject */
    function triggersService($http, EnvironmentConfig)
    {
        var baseUrl = EnvironmentConfig.api + 'Message_Center/';

        var service = {
            getTriggers: getTriggers,
            getTrigger: getTrigger,
            saveTrigger: saveTrigger,
            toggleTriggerStatus: toggleTriggerStatus,
            deleteTrigger: deleteTrigger,
            getTriggerOptions: getTriggerOptions,
            getTemplatesGrouped: getTemplatesGrouped
        };

        return service;

        function requestComplete(response)
        {
            return response.data;
        }

        function requestFailed(error)
        {
            return (error && error.data) ? error.data : { success: false, message: 'Request failed.' };
        }

        function getTriggers(params)
        {
            return $http({
                url: baseUrl + 'getTriggers',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getTrigger(id)
        {
            return $http({
                url: baseUrl + 'getTrigger',
                method: 'GET',
                params: { id: id }
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function saveTrigger(data)
        {
            return $http({
                url: baseUrl + 'saveTrigger',
                method: 'POST',
                data: data
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function toggleTriggerStatus(id, isActive)
        {
            return $http({
                url: baseUrl + 'toggleTriggerStatus',
                method: 'POST',
                data: {
                    id: id,
                    is_active: isActive ? 1 : 0
                }
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function deleteTrigger(id)
        {
            return $http({
                url: baseUrl + 'deleteTrigger',
                method: 'POST',
                data: { id: id }
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getTriggerOptions()
        {
            return $http({
                url: baseUrl + 'getTriggerOptions',
                method: 'GET'
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getTemplatesGrouped(params)
        {
            return $http({
                url: baseUrl + 'getTemplatesGrouped',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.settings.triggers')
        .controller('MessageCenterTriggersController', MessageCenterTriggersController);

    /** @ngInject */
    function MessageCenterTriggersController($scope, $mdDialog, toastMessage, triggersService, $state)
    {
        var vm = this;

        vm.triggers = [];
        vm.options = {};
        vm.isLoading = false;
        vm.totalTriggers = 0;

        vm.openAddTrigger = openAddTrigger;
        vm.editTrigger = editTrigger;
        vm.deleteTrigger = deleteTrigger;
        vm.toggleTriggerStatus = toggleTriggerStatus;
        vm.editTriggerById = editTriggerById;
        vm.deleteTriggerById = deleteTriggerById;
        vm.toggleTriggerStatusById = toggleTriggerStatusById;
        vm.getTimingLabel = getTimingLabel;
        vm.getEventLabel = getEventLabel;
        vm.getChannelLabel = getChannelLabel;
        vm.formatOffset = formatOffset;
        vm.formatSchedule = formatSchedule;
        vm.getMessageLabel = getMessageLabel;
        vm.getRecipientSummary = getRecipientSummary;
        vm.isTriggerActive = isTriggerActive;

        $scope.paginatorCallback = paginatorCallback;
        $scope.getLoadResultsCallback = getLoadResultsCallback;
        
        $scope.isDeletedAllowed = true;
        vm.selectedTriggerIds = [];
        
        $scope.selectedRowCallback = function(rows) {
            vm.selectedTriggerIds = rows;
        };

        $scope.deleteSelectedItem = function(ev) {
            var html = "Are you sure, you want to delete the selected trigger(s)?</br>";
            html = html + "<b>" + vm.selectedTriggerIds.length + " trigger(s)</b> will be deleted.";
            
            $mdDialog.show({
                controller: 'confirmController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    title: vm.selectedTriggerIds.length > 1 ? "Delete Triggers" : "Delete Trigger",
                    htmlContent: html,
                    cancelBtn: "Cancel",
                    OkBtn: "Ok"
                }
            }).then(function (answer) {
                if (typeof answer != 'undefined' && answer == 'update') {
                    // Loop delete
                    var promises = vm.selectedTriggerIds.map(function(id) {
                        return triggersService.deleteTrigger(id);
                    });
                    
                    var $q = angular.injector(['ng']).get('$q');
                    $q.all(promises).then(function() {
                        toastMessage.showSimpleToast('Triggers removed successfully.', 'success-toast');
                        vm.selectedTriggerIds = [];
                        if (loadPageCallbackWithDebounce) loadPageCallbackWithDebounce();
                    }).catch(function() {
                        toastMessage.showSimpleToast('Failed to delete some triggers.', 'error-toast');
                    });
                }
            }, angular.noop);
        };

        $scope.goToEditPage = function (value) {
            $state.go('app.settings_trigger', { id: value });
        };

        var loadPageCallbackWithDebounce;
        function getLoadResultsCallback(loadPageCallback) {
            loadPageCallbackWithDebounce = function () {
                if (loadPageCallback) loadPageCallback();
            };
        }

        var initialLoad = true;
        $scope.$watch('filterText', function () {
            if (initialLoad) {
                initialLoad = false;
                return;
            }
            if (loadPageCallbackWithDebounce) {
                loadPageCallbackWithDebounce();
            }
        });

        init();

        function init()
        {
            loadOptions();
        }

        function loadOptions()
        {
            triggersService.getTriggerOptions().then(function (res) {
                if (res && res.success && res.data) {
                    vm.options = res.data;
                }
            });
        }

        function paginatorCallback(page, pageSize, options)
        {
            return triggersService.getTriggers().then(function (res) {
                var allTriggers = (res && res.success) ? (res.data || []) : [];
                if ($scope.filterText) {
                    var txt = $scope.filterText.toLowerCase();
                    allTriggers = allTriggers.filter(function (t) {
                        return (t.name && t.name.toLowerCase().indexOf(txt) !== -1) ||
                               (t.custom_message && t.custom_message.toLowerCase().indexOf(txt) !== -1);
                    });
                }
                vm.triggers = allTriggers;
                vm.totalTriggers = allTriggers.length;

                var currentPage = page || 1;
                var limit = pageSize || 50;
                var start = (currentPage - 1) * limit;
                var pageTriggers = allTriggers.slice(start, start + limit);

                var rows = pageTriggers.map(function (t) {
                    return {
                        id: t.id,
                        name: t.name || ('Trigger #' + t.id),
                        custom_message: getMessageLabel(t),
                        timing: formatSchedule(t),
                        channel: t.channel_type || t.channel,
                        recipient_type: getRecipientSummary(t),
                        is_active: t.is_active ? 1 : 0,
                        editTriggerId: t.id,
                        _raw: t
                    };
                });

                return {
                    results: rows,
                    totalResultCount: allTriggers.length
                };
            }).catch(function () {
                vm.triggers = [];
                vm.totalTriggers = 0;
                return { results: [], totalResultCount: 0 };
            });
        }

        function findOptionLabel(optionsList, id)
        {
            if (!optionsList || !optionsList.length) return id || '—';
            var i;
            for (i = 0; i < optionsList.length; i++) {
                if (optionsList[i].id === id) {
                    return optionsList[i].label;
                }
            }
            return id || '—';
        }

        function getTimingLabel(id)
        {
            var list = (vm.options && vm.options.timing_relations) ? vm.options.timing_relations : [
                { id: 'at', label: 'At' },
                { id: 'before', label: 'Before' },
                { id: 'after', label: 'After' }
            ];
            return findOptionLabel(list, id);
        }

        function getEventLabel(id)
        {
            var list = (vm.options && vm.options.events) ? vm.options.events : [];
            return findOptionLabel(list, id);
        }

        function getChannelLabel(id)
        {
            var list = (vm.options && vm.options.channels) ? vm.options.channels : [];
            return findOptionLabel(list, id);
        }

        function getMessageLabel(trigger)
        {
            if (!trigger) return '—';
            if (trigger.template_id && trigger.template_name) {
                return trigger.template_name;
            }
            if (trigger.custom_message) {
                var preview = trigger.custom_message;
                if (preview.length > 40) {
                    preview = preview.substring(0, 40) + '...';
                }
                return preview;
            }
            if (trigger.messageId) {
                return trigger.messageId;
            }
            return 'Custom Message';
        }

        function formatSchedule(trigger)
        {
            if (!trigger) return '—';
            
            var eventLabel = getEventLabel(trigger.event_type || trigger.event);
            var cleanEventLabel = (eventLabel || '').replace(/event\s+/gi, '').toLowerCase();
            
            if (trigger.timing_type === 'fixed_time') {
                var offset = formatOffset(trigger);
                var rel = trigger.timing_relation || trigger.timing || 'at';
                var relLabel = getTimingLabel(rel);
                
                var timeStr = trigger.timing_fixed_time || '';
                var formattedTime = timeStr;
                if (timeStr) {
                    var parts = timeStr.split(':');
                    if (parts.length >= 2) {
                        var h = parseInt(parts[0], 10);
                        var ampm = h >= 12 ? 'pm' : 'am';
                        h = h % 12;
                        h = h ? h : 12;
                        formattedTime = h + ':' + parts[1] + ampm;
                    }
                }

                if (rel === 'at') {
                    return offset + ' at ' + formattedTime;
                }
                return offset + ' ' + (relLabel ? relLabel.toLowerCase() : '') + ' ' + cleanEventLabel + ' at ' + formattedTime;
            }

            var timingRel = trigger.timing_relation || trigger.timing || 'at';
            if (timingRel === 'at') {
                return 'At ' + cleanEventLabel;
            }
            var offset = formatOffset(trigger);
            var relLabel = getTimingLabel(timingRel);
            return offset + ' ' + (relLabel ? relLabel.toLowerCase() : '') + ' ' + cleanEventLabel;
        }

        function formatOffset(trigger)
        {
            if (!trigger) return '0 min';
            
            if (trigger.timing_type === 'fixed_time') {
                var days = parseInt(trigger.timing_offset_value, 10) || 0;
                var rel = trigger.timing_relation || trigger.timing || 'at';
                
                if (days === 0) {
                    return 'Same day';
                } else if (days === 1) {
                    return (rel === 'before' ? '1 day' : 'Next day');
                } else {
                    return days + ' days';
                }
            }

            var timing = trigger.timing_relation || trigger.timing || 'at';
            if (timing === 'at') {
                return 'At event time';
            }

            var offsetVal = (typeof trigger.timing_offset_value !== 'undefined') ? parseInt(trigger.timing_offset_value, 10) : (trigger.offsetValue ? parseInt(trigger.offsetValue, 10) : 0);
            var unit = trigger.timing_offset_unit || trigger.offsetUnit || 'minutes';
            var offsetMins = convertToMins(offsetVal, unit);

            if (offsetMins <= 0) {
                return '0 min';
            }

            if (offsetMins % 1440 === 0) {
                var d = offsetMins / 1440;
                return d + (d === 1 ? ' day' : ' days');
            }
            if (offsetMins % 60 === 0) {
                var h = offsetMins / 60;
                return h + (h === 1 ? ' hr' : ' hrs');
            }
            return offsetMins + ' min';
        }

        function findTriggerById(id)
        {
            if (!vm.triggers || !vm.triggers.length) return null;
            for (var i = 0; i < vm.triggers.length; i++) {
                if (vm.triggers[i].id == id) {
                    return vm.triggers[i];
                }
            }
            return null;
        }

        function editTriggerById(ev, id)
        {
            var trigger = findTriggerById(id);
            if (trigger) {
                editTrigger(ev, trigger);
            }
        }

        function deleteTriggerById(ev, id)
        {
            var trigger = findTriggerById(id);
            if (trigger) {
                deleteTrigger(ev, trigger);
            }
        }

        function toggleTriggerStatusById(id)
        {
            var trigger = findTriggerById(id);
            if (trigger) {
                toggleTriggerStatus(trigger);
            }
        }

        function convertToMins(val, unit)
        {
            var v = parseInt(val, 10) || 0;
            if (unit === 'days') return v * 1440;
            if (unit === 'hours') return v * 60;
            return v;
        }

        function getRecipientSummary(trigger)
        {
            if (!trigger) return 'Customer';
            if (trigger.recipient_type === 'customer') {
                return 'Customer';
            }
            if (trigger.recipient_meta) {
                var meta = trigger.recipient_meta;
                var parts = [];
                if (meta.to && meta.to.length) {
                    parts.push('To: ' + meta.to.join(', '));
                }
                if (meta.cc && meta.cc.length) {
                    parts.push('CC: ' + meta.cc.join(', '));
                }
                if (meta.phone_numbers && meta.phone_numbers.length) {
                    parts.push('SMS: ' + meta.phone_numbers.join(', '));
                }
                if (parts.length) {
                    return parts.join(' | ');
                }
            }
            return 'Specific User / Staff';
        }



        function openAddTrigger(ev)
        {
            $state.go('app.settings_trigger', { id: 'new' });
        }

        function editTrigger(ev, trigger)
        {
            if (ev) {
                ev.preventDefault();
                ev.stopPropagation();
            }
            $state.go('app.settings_trigger', { id: trigger.id });
        }

        function toggleTriggerStatus(trigger)
        {
            if (!trigger || !trigger.id) return;
            var targetStatus = trigger.is_active ? 0 : 1;
            triggersService.toggleTriggerStatus(trigger.id, targetStatus).then(function (res) {
                if (res && res.success) {
                    trigger.is_active = targetStatus;
                    toastMessage.showSimpleToast('Trigger status updated.', 'success-toast');
                    if (loadPageCallbackWithDebounce) loadPageCallbackWithDebounce();
                } else {
                    toastMessage.showSimpleToast((res && res.message) ? res.message : 'Failed to update status.', 'error-toast');
                }
            }).catch(function () {
            });
        }

        function deleteTrigger(ev, trigger)
        {
            if (ev) {
                ev.preventDefault();
                ev.stopPropagation();
            }

            $mdDialog.show({
                controller: 'MessageCenterTriggerDeleteDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/settings/triggers/dialogs/trigger-delete-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            }).then(function () {
                triggersService.deleteTrigger(trigger.id).then(function (res) {
                    if (res && res.success) {
                        toastMessage.showSimpleToast('Trigger removed successfully.', 'success-toast');
                        if (loadPageCallbackWithDebounce) loadPageCallbackWithDebounce();
                    } else {
                        toastMessage.showSimpleToast((res && res.message) ? res.message : 'Failed to delete trigger.', 'error-toast');
                    }
                });
            }, angular.noop);
        }

        function isTriggerActive(id)
        {
            var trigger = findTriggerById(id);
            return !!(trigger && trigger.is_active);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings.roomLockEncoder')
        .controller('RoomLockEncoderController', RoomLockEncoderController);

    /** @ngInject */
    function RoomLockEncoderController(
        $rootScope,
        $timeout,
        $localStorage,
        toastMessage,
        roomLockEncoderService,
        RoomLockEncoderSettings
    ) {
        var vm = this;

        vm.hotel_id = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
        vm.isloading = false;
        vm.enabled = false;
        vm.encoderUrls = [{ url: '', editing: false }];

        vm.commonDoors = [];
        vm.visibleDoors = [];
        vm.selectedDoorCount = 0;

        vm.openDbPicker = openDbPicker;
        vm.onDbFileSelected = onDbFileSelected;
        vm.toggleAllDoors = toggleAllDoors;
        vm.refreshDoors = refreshDoors;

        vm.addEncoderUrl = addEncoderUrl;
        vm.removeEncoderUrl = removeEncoderUrl;
        vm.startEditingEncoderUrl = startEditingEncoderUrl;
        vm.cancelEditingEncoderUrl = cancelEditingEncoderUrl;
        vm.isEncoderEditable = isEncoderEditable;
        vm.saveSettings = saveSettings;
        vm.showEncoderLabel = showEncoderLabel;
        vm.toggleEnabled = toggleEnabled;
        vm.onToggleKeypress = onToggleKeypress;

        $rootScope.getSubHotels($localStorage.hotels[$localStorage.selectedHotel].hotel_id, '');

        initSettings(RoomLockEncoderSettings);

        function initSettings(response) {
            if (!response) {
                return;
            }

            if (response.success === false) {
                if (response.errorMsg) {
                    toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                }
                return;
            }

            var settings = response.settings;
            if (!settings) {
                return;
            }
            vm.enabled = settings.room_lock_encoder_visible === true
                || settings.room_lock_encoder_visible === 1
                || settings.room_lock_encoder_visible === '1';
            vm.encoderUrls = parseEncoderUrlsFromSettings(settings);
            vm.commonDoors = normalizeDoors(settings.room_lock_common_doors);
            refreshDoors();
        }

        function parseEncoderUrlsFromSettings(settings) {
            if (!settings) {
                return [{ url: '', editing: false }];
            }

            if (settings.room_lock_encoder_urls && settings.room_lock_encoder_urls.length) {
                return normalizeEncoderUrls(settings.room_lock_encoder_urls);
            }

            var urls = [];
            var index = 1;
            var key = 'room_lock_encoder_url_' + index;

            while (settings[key]) {
                urls.push(settings[key]);
                index++;
                key = 'room_lock_encoder_url_' + index;
            }

            return normalizeEncoderUrls(urls);
        }

        function normalizeEncoderUrls(urls) {
            if (!urls || !urls.length) {
                return [{ url: '', editing: false }];
            }

            if (typeof urls === 'string') {
                try {
                    urls = JSON.parse(urls);
                } catch (e) {
                    urls = urls.split(',').map(function (url) {
                        return url.trim();
                    }).filter(Boolean);
                }
            }

            return urls.map(function (url) {
                if (typeof url === 'object' && url !== null) {
                    return { url: url.url || '', editing: false, isNew: false };
                }
                return { url: url || '', editing: false, isNew: false };
            });
        }

        function normalizeDoors(list) {
            return (Array.isArray(list) ? list : []).map(function (door) {
                var id = parseInt(door.id, 10);
                var mdbId = door.mdb_id != null && door.mdb_id !== ''
                    ? parseInt(door.mdb_id, 10)
                    : id;

                return {
                    id: id,
                    mdb_id: mdbId,
                    name: door.name,
                    is_enabled: door.is_enabled !== false,   // legacy rows (no flag) were selected doors
                    is_deleted: door.is_deleted === true
                };
            });
        }

        function refreshDoors() {
            vm.visibleDoors = vm.commonDoors.filter(function (door) { return door.is_deleted !== true; });
            vm.selectedDoorCount = vm.visibleDoors.filter(function (door) { return door.is_enabled; }).length;
        }

        function toggleAllDoors() {
            var select = vm.selectedDoorCount !== vm.visibleDoors.length;
            vm.visibleDoors.forEach(function (door) { door.is_enabled = select; });
            refreshDoors();
        }

        function showEncoderLabel() {
            return vm.encoderUrls.length > 1;
        }

        function toggleEnabled() {
            vm.enabled = !vm.enabled;
        }

        function onToggleKeypress(event) {
            if (event.keyCode === 13 || event.keyCode === 32) {
                event.preventDefault();
                toggleEnabled();
            }
        }

        function isEncoderEditable(encoder) {
            return encoder.isNew || encoder.editing;
        }

        function addEncoderUrl() {
            vm.encoderUrls.push({ url: '', editing: true, isNew: true });
            focusEncoderUrlInput(vm.encoderUrls.length - 1);
        }

        function startEditingEncoderUrl(index) {
            vm.encoderUrls.forEach(function (encoder, i) {
                if (encoder.isNew) {
                    encoder.editing = true;
                    return;
                }
                if (i === index) {
                    encoder.previousUrl = encoder.url;
                    encoder.editing = true;
                } else {
                    encoder.editing = false;
                }
            });
            focusEncoderUrlInput(index);
        }

        function cancelEditingEncoderUrl(index) {
            var encoder = vm.encoderUrls[index];
            if (!encoder || encoder.isNew) {
                return;
            }
            if (encoder.previousUrl !== undefined) {
                encoder.url = encoder.previousUrl;
            }
            encoder.editing = false;
            delete encoder.previousUrl;
        }

        function focusEncoderUrlInput(index) {
            $timeout(function () {
                var input = document.getElementById('encoderUrlInput' + index);
                if (!input) {
                    return;
                }
                input.focus();
                var length = input.value ? input.value.length : 0;
                if (typeof input.setSelectionRange === 'function') {
                    input.setSelectionRange(length, length);
                }
            });
        }

        function removeEncoderUrl(index) {
            if (vm.encoderUrls.length <= 1) {
                return;
            }
            vm.encoderUrls.splice(index, 1);
        }

        function openDbPicker() {
            var input = document.getElementById('commonDoorDbInput');
            if (input) {
                input.click();
            }
        }

        function resetDbInput() {
            var input = document.getElementById('commonDoorDbInput');
            if (input) {
                input.value = '';
            }
        }

        function onDbFileSelected(file) {
            if (!file) {
                return;
            }

            if (!/\.mdb$/i.test(file.name)) {
                toastMessage.showSimpleToast('Only .mdb file is allowed.', 'error-toast');
                resetDbInput();
                return;
            }

            vm.isloading = true;
            roomLockEncoderService.readCommonDoors(vm.hotel_id, file).then(function (response) {
                vm.isloading = false;
                resetDbInput();

                if (!response || !response.success) {
                    toastMessage.showSimpleToast(
                        (response && response.errorMsg) || 'Failed to read common doors from the file.',
                        'error-toast'
                    );
                    return;
                }

                if (!response.doors || !response.doors.length) {
                    toastMessage.showSimpleToast('No common doors found in the selected file.', 'error-toast');
                    return;
                }

                vm.commonDoors = normalizeDoors(response.doors);
                refreshDoors();
                syncCommonDoorsToHotelInformation(vm.commonDoors);
            });
        }

        function syncCommonDoorsToHotelInformation(doors) {
            if (!$rootScope.hotelInformation) {
                $rootScope.hotelInformation = {};
            }
            if (!$rootScope.hotelInformation.settings) {
                $rootScope.hotelInformation.settings = {};
            }
            if (!$rootScope.hotelInformation.settings.encoder_settings) {
                $rootScope.hotelInformation.settings.encoder_settings = {};
            }
            $rootScope.hotelInformation.settings.encoder_settings.room_lock_common_doors =
                angular.copy(doors);
        }

        function saveSettings() {
            var encoderUrls = vm.encoderUrls
                .map(function (encoder) {
                    return (encoder.url || '').trim();
                })
                .filter(function (url) {
                    return url.length > 0;
                });

            if (vm.enabled && encoderUrls.length === 0) {
                toastMessage.showSimpleToast('Please add at least one encoder URL.', 'error-toast');
                return;
            }

            var data = {
                hotel_id: vm.hotel_id,
                room_lock_encoder_visible: vm.enabled ? '1' : '0',
                room_lock_encoder_urls: encoderUrls,
                room_lock_common_doors: vm.commonDoors
            };

            vm.isloading = true;
            roomLockEncoderService.saveSettings(data).then(function (response) {
                vm.isloading = false;
                if (response && response.success) {
                    toastMessage.showSimpleToast(
                        response.message || 'Room lock encoder settings saved successfully.',
                        'success-toast'
                    );
                    if (response.settings) {
                        initSettings(response);
                    }
                    $rootScope.loadHotelInformation(vm.hotel_id);
                } else {
                    toastMessage.showSimpleToast(
                        (response && response.errorMsg) || 'Failed to save room lock encoder settings.',
                        'error-toast'
                    );
                }
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.settings.paymentmethod')
        .controller('paymentmethodController', paymentmethodController);

    /** @ngInject */
    function paymentmethodController(
    	$rootScope, 
    	$scope, 
    	$localStorage, 
    	toastMessage, 
    	PaymentMethods, 
    	paymentmethodsservice, 
    	PaymentMethodsSelected, 
    	CardTypes, 
    	AuthorizeSettings,
    	$timeout
    	){

        var vm = this;

    	$rootScope.getSubHotels($localStorage.selectedHotel, '');

        vm.isloading = false;
        vm.paymentMethods = PaymentMethods.payment_methods;
        vm.cardTypes = CardTypes.card_types;
        vm.isParent = false;
        vm.currentUpdatedData = []; 
        vm.autoFillOff = true;
        if(AuthorizeSettings.success){
			vm.authorizeSettings = AuthorizeSettings.authorize_settings;
    		vm.isParent = AuthorizeSettings.isParent;
    		vm.subHotels = AuthorizeSettings.subHotels;
    		vm.parentName = AuthorizeSettings.parent_name;
    	}
		else{
			vm.authorizeSettings = {};
			toastMessage.showSimpleToast(PaymentMethodsSelected.errorMsg,'error-toast');
		}

        vm.authSettingIds = [];
        vm.authorize = {};
        setValues(vm.authorizeSettings);

        vm.currentHotelId = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
        vm.parentHotelId = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
        vm.subHotelValues = [];

        if(PaymentMethodsSelected.success){
			if(PaymentMethodsSelected.selected_paymentmethods[vm.currentHotelId].length > 0 && PaymentMethodsSelected.selected_paymentmethods[vm.currentHotelId][0].hasOwnProperty('attribute_value')){
				vm.paymentMethodsSelected = PaymentMethodsSelected.selected_paymentmethods[vm.currentHotelId][0].attribute_value.split(',');
			}else{
				vm.paymentMethodsSelected = [];
			}
			if(PaymentMethodsSelected.selected_paymentmethods[vm.currentHotelId].length > 0){
				vm.settingId = PaymentMethodsSelected.selected_paymentmethods[vm.currentHotelId][0].setting_id;
			}else{
				vm.settingId = '';
			}
			vm.subHotelValues = PaymentMethodsSelected.subHotel;
		}else{
			vm.paymentMethodsSelected = [];
			toastMessage.showSimpleToast(PaymentMethodsSelected.errorMsg,'error-toast');
		}
		
        vm.paymentMethodClicked = paymentMethodClicked;
        vm.updateSetting = updateSetting;
        
        function setValues(tempData){
			angular.forEach(tempData, function(authorize_value, authorize_key) {
				if(authorize_key == 'authorize_cctypes'){
					vm.authorize[authorize_key] = authorize_value.attribute_value.split(',');
				}else{
					vm.authorize[authorize_key] = authorize_value.attribute_value;
				}
				vm.currentUpdatedData[vm.currentHotelId] = vm.authorize;
			});
		}
        
        function paymentMethodClicked(paymentMethod){
			vm.isloading = true;
			var idx = vm.paymentMethodsSelected.indexOf(paymentMethod);
			if( idx > -1 )
				vm.paymentMethodsSelected.splice(idx, 1);
			else
				vm.paymentMethodsSelected.push(paymentMethod);
			var data = {
							'hotel_id':vm.currentHotelId,
							'payment_methods':vm.paymentMethodsSelected,
							'setting_id':vm.settingId
						};
			paymentmethodsservice.setPaymentMethodsForHotel(data).then(function(response){
				vm.isloading = false;
				if(response.success){
					if(response.selected_paymentmethods > 1){
						vm.settingId = response.selected_paymentmethods;
					}
				}else{
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				}
			});
		}
		vm.requestGoingOn = false;
		vm.requestGoingOn1 = false;
		
		function updateSetting(code){
			if(vm.authorize.hasOwnProperty(code) && vm.authorize[code] != '' && !vm.requestGoingOn && !vm.requestGoingOn1){
				vm.isloading = true;
				if(vm.authSettingIds.hasOwnProperty(vm.currentHotelId) && vm.authSettingIds[vm.currentHotelId].hasOwnProperty(code) && vm.authSettingIds[vm.currentHotelId][code] > 0){
					var setting_id = vm.authSettingIds[vm.currentHotelId][code];
				}else{
					var setting_id = '';
				}
				var data = {
								'attribute_code':code,
								'attribute_value':vm.authorize[code],
								'hotel_id':vm.currentHotelId,
								'setting_type':'payment_methods',
								'setting_id':setting_id
							};
				paymentmethodsservice.saveAuthorizeSettings(data).then(function(response){
					vm.isloading = false;
					if(response.success){
						if(setting_id == ''){
							vm.authSettingIds[vm.currentHotelId] = [];
							vm.authSettingIds[vm.currentHotelId][code] = response.authorize_setting_id;
						}
					}else{
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					}
				});
			}
		}
		vm.changedValue = changedValue;
		
		vm.currentUpdatedData[vm.currentHotelId] = vm.authorize;

		function changedValue(){
			vm.requestGoingOn = true;
			vm.requestGoingOn1 = true;
			var previousHotelId = angular.copy(vm.currentHotelId);			
			vm.currentHotelId = vm.currentHotel;
			paymentmethodsservice.getPaymentMethodsSelected({hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id}).then(function(response){
				if(response['success']){
					vm.settingId = '';
					if(response.selected_paymentmethods[vm.currentHotelId].length > 0 && response.selected_paymentmethods[vm.currentHotelId][0].hasOwnProperty('attribute_value')){
						vm.paymentMethodsSelected = response.selected_paymentmethods[vm.currentHotelId][0].attribute_value.split(',');
						vm.settingId = response.selected_paymentmethods[vm.currentHotelId][0].setting_id;
					}else{
						vm.paymentMethodsSelected = [];
						vm.settingId = '';
					}
				}else{
					vm.paymentMethodsSelected = [];
						vm.settingId = '';						
				}
				$timeout(function() {
					vm.requestGoingOn = false;
				}, 2000);
			});

			paymentmethodsservice.getAuthorizeSettings({hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id}).then(function(response){
				if (response['success']) {
					vm.authorizeSettings = response.authorize_settings;
		    		vm.isParent = response.isParent;
		    		vm.subHotels = response.subHotels;
		    		vm.parentName = response.parent_name;

					if(vm.currentHotel == vm.parentHotelId){	
					 	setValues(vm.authorizeSettings);
					}else if(vm.subHotels[vm.currentHotel][0].length == 0){

						vm.authorize = [];
					}else{
						setValues(vm.subHotels[vm.currentHotel][0]);
					}
				} else {
					vm.authorize = [];
				}
				$timeout(function() {
					vm.requestGoingOn1 = false;
				}, 2000);
			});			
		}

		setTimeout(function() {
		   vm.autoFillOff = false;
		}, 1500); 
    }
})();

(function () {
    'use strict';

    angular
        .module('app.settings.messageCenter', [
            'app.guest-message-center'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.settings_message_center', {
            url: '/message-center-config',
            title: 'Message Center Config',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/settings/messageCenter/messageCenter.html',
                    controller: 'MessageCenterSettingsController as vm'
                }
            },
            permission: 'mc_settings'
        });

        $translatePartialLoaderProvider.addPart('app/main/apps/settings/messageCenter');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.settings.messageCenter')
        .controller('MessageCenterSettingsController', MessageCenterSettingsController);

    /** @ngInject */
    function MessageCenterSettingsController(
        $rootScope,
        messageCenterService,
        toastMessage
    )
    {
        var vm = this;

        vm.loading = false;
        vm.saving = false;
        vm.otaEnabled = false;
        vm.smsEnabled = false;
        vm.whatsappEnabled = false;
        vm.twilioConversationsServiceSid = '';
        vm.twilioPhoneNumber = '';
        vm.twilioWhatsappNumber = '';
        vm.overdueAlertEnabled = false;
        vm.unrepliedAlertEnabled = false;
        vm.overdueAlertSms = false;
        vm.overdueAlertEmail = false;
        vm.overdueAlertMins = 10;
        vm.overdueAlertEmailAddresses = [''];
        vm.overdueAlertPhones = [''];
        vm.afterHoursAutoReplyEnabled = false;
        vm.afterHoursStartHour = null;
        vm.afterHoursEndHour = null;
        vm.afterHoursMessage = '';
        vm.hourOptions = buildHourOptions();

        vm.loadSettings = loadSettings;
        vm.saveSettings = saveSettings;
        vm.addEmail = addEmail;
        vm.removeEmail = removeEmail;
        vm.addPhone = addPhone;
        vm.removePhone = removePhone;
        vm.canAddEmail = canAddEmail;
        vm.canAddPhone = canAddPhone;
        vm.isEmailDuplicate = isEmailDuplicate;
        vm.isPhoneDuplicate = isPhoneDuplicate;
        vm.afterHoursConfigIncomplete = afterHoursConfigIncomplete;
        vm.afterHoursHoursInvalid = afterHoursHoursInvalid;
        vm.browserNotificationsEnabled = false;
        // Last value successfully loaded/saved — used to detect off → on on Save.
        var savedBrowserNotificationsEnabled = false;

        loadSettings();

        function isEnabledFlag(value)
        {
            return value === true || value === 1 || value === '1';
        }

        function applySettings(settings)
        {
            settings = settings || {};

            vm.otaEnabled = isEnabledFlag(settings.ota_messaging_enabled);
            vm.smsEnabled = isEnabledFlag(settings.sms_messaging_enabled);
            vm.whatsappEnabled = isEnabledFlag(settings.whatsapp_messaging_enabled);
            vm.twilioConversationsServiceSid = settings.twilio_conversations_service_sid || '';
            vm.twilioPhoneNumber = settings.twilio_phone_number || '';
            vm.twilioWhatsappNumber = settings.twilio_whatsapp_number || '';
            
            vm.browserNotificationsEnabled = isEnabledFlag(settings.browser_notifications_enabled);
            savedBrowserNotificationsEnabled = vm.browserNotificationsEnabled;
            vm.overdueAlertEnabled = isEnabledFlag(settings.overdue_msg_alert_enabled);
            vm.unrepliedAlertEnabled = isEnabledFlag(settings.unreplied_msg_alert_enabled);
            vm.overdueAlertSms = isEnabledFlag(settings.overdue_msg_alert_sms);
            vm.overdueAlertEmail = isEnabledFlag(settings.overdue_msg_alert_email);
            vm.overdueAlertMins = settings.overdue_msg_alert_mins ? parseInt(settings.overdue_msg_alert_mins, 10) : 10;

            // Parse multiple emails — stored as JSON array or plain string
            vm.overdueAlertEmailAddresses = parseRecipients(settings.overdue_msg_alert_email_address);

            // Parse multiple phones — stored as JSON array or plain string
            vm.overdueAlertPhones = parseRecipients(settings.overdue_msg_alert_phone);

            vm.afterHoursAutoReplyEnabled = isEnabledFlag(settings.after_hours_auto_reply_enabled);
            vm.afterHoursStartHour = normalizeHour(settings.after_hours_auto_reply_start_hour);
            vm.afterHoursEndHour = normalizeHour(settings.after_hours_auto_reply_end_hour);
            vm.afterHoursMessage = settings.after_hours_auto_reply_message
                ? String(settings.after_hours_auto_reply_message)
                : '';
        }

        function buildHourOptions()
        {
            var options = [];
            for (var h = 0; h < 24; h++) {
                var suffix = h < 12 ? 'AM' : 'PM';
                var display = h % 12;
                if (display === 0) {
                    display = 12;
                }
                options.push({
                    value: h,
                    label: display + ':00 ' + suffix
                });
            }
            return options;
        }

        function normalizeHour(value)
        {
            if (value === null || value === undefined || value === '') {
                return null;
            }
            var hour = parseInt(value, 10);
            if (isNaN(hour) || hour < 0 || hour > 23) {
                return null;
            }
            return hour;
        }

        function isHourSelected(value)
        {
            return normalizeHour(value) !== null;
        }

        function afterHoursHoursInvalid()
        {
            if (!vm.afterHoursAutoReplyEnabled) {
                return false;
            }
            if (!isHourSelected(vm.afterHoursStartHour) || !isHourSelected(vm.afterHoursEndHour)) {
                return false;
            }
            return parseInt(vm.afterHoursStartHour, 10) === parseInt(vm.afterHoursEndHour, 10);
        }

        function afterHoursConfigIncomplete()
        {
            if (!vm.afterHoursAutoReplyEnabled) {
                return false;
            }
            if (!isHourSelected(vm.afterHoursStartHour) || !isHourSelected(vm.afterHoursEndHour)) {
                return true;
            }
            if (afterHoursHoursInvalid()) {
                return true;
            }
            return !(vm.afterHoursMessage || '').trim();
        }

        /**
         * Parse a recipients field which may be a JSON array string or a plain string.
         * Always returns an array with at least one element (empty string if nothing saved).
         */
        function parseRecipients(value) {
            if (!value || value === '') {
                return [''];
            }
            var trimmed = ('' + value).trim();
            if (trimmed.charAt(0) === '[') {
                try {
                    var parsed = JSON.parse(trimmed);
                    if (Array.isArray(parsed) && parsed.length > 0) {
                        return parsed;
                    }
                } catch (e) { /* fall through */ }
            }
            // Plain string (legacy single value)
            return [trimmed];
        }

        function getIntlNumber(inputName) {
            var inputElement = document.querySelector('input[name="' + inputName + '"]');
            if (inputElement) {
                var iti = angular.element(inputElement).data('iti');
                if (iti && iti.isValidNumberPrecise()) {
                    return iti.getNumber();
                }
            }
            return null;
        }

        /**
         * Validate a phone field by name. Accepts an optional array index
         * so multi-phone entries each get their own validity state.
         */
        vm.updatePhoneWithCountryCode = function (fieldName, arrayIndex) {
            var inputElement = document.querySelector('input[name="' + fieldName + '"]');
            if (!inputElement) {
                return;
            }

            var iti = angular.element(inputElement).data('iti');
            if (!iti) {
                return;
            }

            var inputValue = inputElement.value.trim();
            var isValid = !inputValue || iti.isValidNumber();

            angular.element(inputElement).toggleClass('ng-invalid', !isValid);
            angular.element(inputElement).toggleClass('has-error', !isValid);

            // Update the array entry with E.164 if valid
            if (inputValue && isValid && arrayIndex !== undefined) {
                vm.overdueAlertPhones[arrayIndex] = iti.getNumber();
            }

            // Set Angular form validity so the save button is disabled when invalid
            var scope = angular.element(inputElement).scope();
            if (scope && scope.messageCenterSettingsForm && scope.messageCenterSettingsForm[fieldName]) {
                scope.messageCenterSettingsForm[fieldName].$setValidity('invalidPhone', isValid);
            }
        };

        function loadSettings()
        {
            vm.loading = true;

            return messageCenterService.getSettings({}, { force: true }).then(function (response) {
                if (!response || response.success === false) {
                    toastMessage.showSimpleToast(
                        (response && (response.message || response.errorMsg)) || 'Unable to load settings.',
                        'error-toast'
                    );
                    return;
                }

                applySettings(response.settings);
            }).finally(function () {
                vm.loading = false;
            });
        }

        function saveSettings()
        {
            if (vm.saving || vm.loading) {
                return;
            }

            // Collect E.164 numbers for all phone fields before saving
            var resolvedPhones = vm.overdueAlertPhones.map(function (phone, idx) {
                var e164 = getIntlNumber('overdueAlertPhone_' + idx);
                return (e164 || phone || '').trim();
            }).filter(function (p) { return p !== ''; });
            if (resolvedPhones.length === 0) {
                resolvedPhones = [''];
            }

            var cleanEmails = vm.overdueAlertEmailAddresses
                .map(function (e) { return (e || '').trim(); })
                .filter(function (e) { return e !== ''; });
            if (cleanEmails.length === 0) {
                cleanEmails = [''];
            }

            if (afterHoursConfigIncomplete()) {
                toastMessage.showSimpleToast(
                    'Please complete after-hours start hour, end hour, and message before saving.',
                    'error-toast'
                );
                return;
            }

            var startHour = normalizeHour(vm.afterHoursStartHour);
            var endHour = normalizeHour(vm.afterHoursEndHour);
            var afterHoursMessage = (vm.afterHoursMessage || '').trim();

            var payload = {
                ota_messaging_enabled: vm.otaEnabled ? '1' : '0',
                sms_messaging_enabled: vm.smsEnabled ? '1' : '0',
                whatsapp_messaging_enabled: vm.whatsappEnabled ? '1' : '0',
                twilio_conversations_service_sid: vm.twilioConversationsServiceSid || '',
                twilio_phone_number: getIntlNumber('twilioPhoneNumber') || vm.twilioPhoneNumber || '',
                twilio_whatsapp_number: getIntlNumber('twilioWhatsappNumber') || vm.twilioWhatsappNumber || '',
                browser_notifications_enabled: vm.browserNotificationsEnabled ? '1' : '0',
                overdue_msg_alert_enabled: vm.overdueAlertEnabled ? '1' : '0',
                unreplied_msg_alert_enabled: vm.unrepliedAlertEnabled ? '1' : '0',
                overdue_msg_alert_sms: vm.overdueAlertSms ? '1' : '0',
                overdue_msg_alert_email: vm.overdueAlertEmail ? '1' : '0',
                overdue_msg_alert_mins: vm.overdueAlertMins || 10,
                overdue_msg_alert_email_address: JSON.stringify(cleanEmails),
                overdue_msg_alert_phone: JSON.stringify(resolvedPhones),
                after_hours_auto_reply_enabled: vm.afterHoursAutoReplyEnabled ? '1' : '0',
                after_hours_auto_reply_start_hour: startHour === null ? '' : String(startHour),
                after_hours_auto_reply_end_hour: endHour === null ? '' : String(endHour),
                after_hours_auto_reply_message: afterHoursMessage
            };

            vm.saving = true;

            return messageCenterService.updateSettings(payload).then(function (response) {
                var wasBrowserNotificationsEnabled;
                var nowBrowserNotificationsEnabled;

                if (!response || response.success === false) {
                    toastMessage.showSimpleToast(
                        (response && (response.message || response.errorMsg)) || 'Unable to save settings.',
                        'error-toast'
                    );
                    return;
                }

                wasBrowserNotificationsEnabled = savedBrowserNotificationsEnabled;
                nowBrowserNotificationsEnabled = !!vm.browserNotificationsEnabled;

                applySettings(response.settings || {});

                // Prefer the value just saved if the API omits the flag.
                if (!angular.isDefined((response.settings || {}).browser_notifications_enabled)) {
                    vm.browserNotificationsEnabled = nowBrowserNotificationsEnabled;
                    savedBrowserNotificationsEnabled = nowBrowserNotificationsEnabled;
                }

                $rootScope.$broadcast('messageCenter:settingsSaved', {
                    settings: response.settings || {},
                    previousBrowserNotificationsEnabled: wasBrowserNotificationsEnabled,
                    browserNotificationsEnabled: savedBrowserNotificationsEnabled
                });
                toastMessage.showSimpleToast('Message Center settings saved.', 'success-toast');
            }).finally(function () {
                vm.saving = false;
            });
        }

        // ─── Multi-recipient helpers ───────────────────────────────────────────

        /**
         * The last email in the list must be non-empty AND a valid email format
         * before the user can add another entry.
         * Also blocks if any existing entry is a duplicate.
         */
        function canAddEmail() {
            if (vm.loading || vm.saving) return false;
            var list = vm.overdueAlertEmailAddresses;
            if (!list || list.length === 0) return true;
            var last = (list[list.length - 1] || '').trim();
            // Last entry must be non-empty and pass a basic email format check
            if (!last || !isValidEmailFormat(last)) return false;
            // Block if any duplicate exists
            var seen = {};
            for (var i = 0; i < list.length; i++) {
                var v = (list[i] || '').trim().toLowerCase();
                if (v && seen[v]) return false;
                seen[v] = true;
            }
            return true;
        }

        /**
         * The last phone in the list must be non-empty AND validated by intl-tel-input
         * before the user can add another entry.
         * Also blocks if any existing entry is a duplicate.
         */
        function canAddPhone() {
            if (vm.loading || vm.saving) return false;
            var list = vm.overdueAlertPhones;
            if (!list || list.length === 0) return true;
            var lastIdx = list.length - 1;
            // Check intl-tel-input validity for the last field
            var lastE164 = getIntlNumber('overdueAlertPhone_' + lastIdx);
            var lastRaw  = (list[lastIdx] || '').trim();
            if (!lastRaw) return false;         // empty — must fill first
            if (!lastE164) return false;         // not a valid phone yet
            // Block if any duplicate exists (compare E.164 where available)
            var resolved = list.map(function (p, idx) {
                return getIntlNumber('overdueAlertPhone_' + idx) || (p || '').trim();
            });
            var seenP = {};
            for (var j = 0; j < resolved.length; j++) {
                var rv = resolved[j];
                if (rv && seenP[rv]) return false;
                if (rv) seenP[rv] = true;
            }
            return true;
        }

        /** True when the email at idx is a duplicate of any other entry. */
        function isEmailDuplicate(idx) {
            var list = vm.overdueAlertEmailAddresses;
            var val = (list[idx] || '').trim().toLowerCase();
            if (!val) return false;
            for (var i = 0; i < list.length; i++) {
                if (i !== idx && (list[i] || '').trim().toLowerCase() === val) {
                    return true;
                }
            }
            return false;
        }

        /** True when the phone at idx is a duplicate of any other entry. */
        function isPhoneDuplicate(idx) {
            var list = vm.overdueAlertPhones;
            var val = getIntlNumber('overdueAlertPhone_' + idx) || (list[idx] || '').trim();
            if (!val) return false;
            for (var i = 0; i < list.length; i++) {
                if (i === idx) continue;
                var other = getIntlNumber('overdueAlertPhone_' + i) || (list[i] || '').trim();
                if (other && other === val) return true;
            }
            return false;
        }

        /** Simple email format check (does not replace server-side validation). */
        function isValidEmailFormat(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        }

        function addEmail() {
            if (!canAddEmail()) return;
            vm.overdueAlertEmailAddresses.push('');
        }

        function removeEmail(idx) {
            if (vm.overdueAlertEmailAddresses.length > 1) {
                vm.overdueAlertEmailAddresses.splice(idx, 1);
            }
        }

        function addPhone() {
            if (!canAddPhone()) return;
            vm.overdueAlertPhones.push('');
        }

        function removePhone(idx) {
            if (vm.overdueAlertPhones.length > 1) {
                vm.overdueAlertPhones.splice(idx, 1);
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.settings.general')
        .controller('GeneralController', GeneralController);

    /** @ngInject */
    function GeneralController(
        EnvironmentConfig, 
        $rootScope, 
        $scope, 
        $mdSidenav, 
        Organizations, 
        Settings, 
        msUtils, 
        $document, 
        generalsservice, 
        $state, 
        $localStorage, 
        toastMessage, 
        $element, 
        $filter, 
        Templates, 
        $translate){
        var vm = this;
       
        vm.disableColorPicker = false;
        $scope.eventApi = {
            onChange:  function(api, color, $event) {
                vm.saveGeneral(color, 'hotelcolorcode');
            },
        };
        vm.isloading = false;
        vm.loggedinUserRole = $localStorage.roleId;
		vm.hotel_id = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
        vm.websites = Organizations.organizations;
        vm.previousPicture = '';
        vm.timeZone = "HST";
        vm.autoFillOff = true;
        $rootScope.getSubHotels($localStorage.hotels[$localStorage.selectedHotel].hotel_id, '');
        /**
         * Initialize settings
         */
        vm.parentSettings = angular.copy(Settings.settings[vm.hotel_id]);
        vm.showSettings = Settings.settings[vm.hotel_id];
        ensureGeneralSettingDefaults(vm.showSettings);
        syncHotelGeneralSettingToLocalStorage();
        vm.themeOptions = [
            {name: 'Fern Green', value: 'green', colorCode: '#5B6B51'},
            {name: 'Azure Blue', value: 'blue', colorCode: '#4891FF'},
            {name: 'Azure Green', value: 'azure', colorCode: '#007773'},
        ];
        if(vm.showSettings.hasOwnProperty('logo')){
			vm.previousPicture = EnvironmentConfig.api+'assets/uploads/hotels/logos/'+vm.showSettings.logo;
			vm.imageStatus = true;
		}
        if(vm.showSettings.hasOwnProperty('favicon')){
            vm.previousfavicon = EnvironmentConfig.api+'assets/uploads/hotels/favicons/'+vm.showSettings.favicon;
            vm.favStatus = true;
        } if(vm.showSettings.hasOwnProperty('hotelcolorcodeusedefault')){
			if(vm.showSettings.hotel_id != 1 && vm.showSettings.hotelcolorcodeusedefault)
			vm.disableColorPicker = true;
		}


         vm.options = {
            // id: 'srp_card_color',
            // name: 'srp_card_color',
            // inputClass: 'srp_card_color',
            restrictToFormat: true,
            format: 'hexString', 
            hue: true,
            saturation: true,
            lightness: true,
            disabled : vm.disableColorPicker
        };
		/**
         * Initialize settings
         */
        
        // Methods
        vm.saveGeneral                	= saveGeneral;
        vm.changedValue                 = changedValue;
        vm.saveCheck                 	= saveCheck;
        vm.upload                       = upload;
        vm.saveCheckAndEnableColorPicker= saveCheckAndEnableColorPicker;

	    /**
		 * Save general Settings
		 */
		function saveCheck(checkstatus){
            if(checkstatus){
                saveGeneral();
            }
        }
        function saveCheckAndEnableColorPicker(checkstatus){
			if(checkstatus){
                vm.options.disabled = true;
				saveGeneral();
			}
            else {
                vm.options.disabled = false;
            }
		}
		function saveGeneral(settingValue,type,location){
			if(settingValue !== null){
				if(type == 'image'){
					var data = new FormData();
					data.append('file',vm.file);
					data.append('location',location);
					data.append('hotel_id',vm.showSettings.hotel_id);
				} else {
					var data = vm.showSettings;
				}
				vm.showSettings.setting_type = 'general';
				vm.isloading = true;
				generalsservice.updateSettings(data).then(function(response){
					vm.isloading = false;
					if(response.hasOwnProperty('success') && response.success){
						Settings.settings = response.success;
						syncHotelGeneralSettingToLocalStorage();
						changedValue(vm.showSettings.hotel_id);
					}else if(response.error && response.errorMsg != ''){
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					}else{
						toastMessage.showSimpleToast('There is some error. Please check','error-toast');
					}
				});
			}
		}

		function upload(file,errFiles,location){
            if(file){
				vm.file = file;
				if(location == 'logo')
					vm.imageStatus= false;
				else
					vm.favStatus = false;
                saveGeneral(vm.showSettings.logo,'image',location);
            } else {
                if(errFiles.length > 0) {
                    angular.forEach(errFiles, function (value, index){                    
                        switch(value.$error) {
                            case 'pattern': vm.fileError = 'FILE_TYPE_NOT_SUPPORTED';
                                break;
                            case 'maxSize': vm.fileError = 'FILE_SIZE_EXCEEDS';
                                break;
                            case 'minWidth' : vm.fileError = 'MIN_SIZE_MESSAGE';
                                break;
                            case 'minHeight' : vm.fileError = 'MIN_SIZE_MESSAGE';
                                break;                                
                            default: vm.fileError = 'COMMON_IMAGE_MESSAGE';  
                        }
                        toastMessage.showSimpleToast($translate.instant('USERS.'+ vm.fileError),'error-toast');
                    });
                }
            }
        }
       
		/**
		 * Get settings on change Organization
		 */
		 
        function ensureGeneralSettingDefaults(settings) {
            if (!settings) {
                return;
            }
            if (typeof settings.showPosPopupOnReservation === 'undefined') {
                settings.showPosPopupOnReservation = '0';
            }
            if (typeof settings.isRoundUpEnable === 'undefined') {
                settings.isRoundUpEnable = '0';
            }
            if (typeof settings.enablePreCheckin === 'undefined') {
                settings.enablePreCheckin = '0';
            }
            if (typeof settings.enableBorrowedItems === 'undefined') {
                settings.enableBorrowedItems = '0';
            }
        }

        function syncHotelGeneralSettingToLocalStorage() {
            var activeHotelId = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
            if (String(vm.showSettings.hotel_id) !== String(activeHotelId)) {
                return;
            }
            $localStorage.hotelgeneralsetting = $localStorage.hotelgeneralsetting || {};
            angular.extend($localStorage.hotelgeneralsetting, angular.copy(vm.showSettings));
        }

        function changedValue(websiteId){
			vm.showSettings = Settings.settings[websiteId];
            ensureGeneralSettingDefaults(vm.showSettings);
			if(vm.showSettings.hasOwnProperty('logo')){
				vm.previousPicture = EnvironmentConfig.api+'assets/uploads/hotels/logos/'+vm.showSettings.logo;
				vm.imageStatus = true;
			}
			if(vm.showSettings.hasOwnProperty('favicon')){
				vm.previousfavicon = EnvironmentConfig.api+'assets/uploads/hotels/favicons/'+vm.showSettings.favicon;
				vm.favStatus = true;
			}
        }
		/**
		 * Get settings on change Organization
		 */

        setTimeout(function() {
           vm.autoFillOff = false;
        }, 1500); 
    }
})();


 angular.module('app.settings.general')
        .directive("timeZoneDirective", function() {
    return {
    	restrict: 'E',    	   
	   	scope: false,
       	template : "<select  ng-model='vm.showSettings.timezone' ng-change='vm.saveGeneral(vm.showSettings.timezone)' class='form-control'></select>"+
        "<script type='text/javascript'>$('select').timezones();</script>"
    };
});
(function () {
    'use strict';

    angular
        .module('app.settings.dailyRentals')
        .controller('DailyRentalsController', DailyRentalsController);

    /** @ngInject */
    function DailyRentalsController(
        $rootScope,
        $localStorage,
        toastMessage,
        dailyRentalsService,
        DailyRentalsSettings
    ) {
        var vm = this;

        vm.hotel_id = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
        vm.isloading = false;
        vm.enabled = false;
        vm.checkin = '11:00';
        vm.checkout = '17:00';
        // Check-in starts at 6 AM; check-out goes up to 6 PM (same window, AM/PM labels)
        vm.checkinOptions = buildTimeOptions(6, 18);
        vm.checkoutOptions = buildTimeOptions(6, 18);

        vm.saveSettings = saveSettings;
        vm.toggleEnabled = toggleEnabled;
        vm.onToggleKeypress = onToggleKeypress;

        $rootScope.getSubHotels($localStorage.hotels[$localStorage.selectedHotel].hotel_id, '');

        initSettings(DailyRentalsSettings);

        /**
         * Build HH:MM options from startHour..endHour (inclusive), 30-min steps.
         * Labels match arrival/departure style: "06:00 AM", "12:00 noon", "01:00 PM".
         */
        function buildTimeOptions(startHour, endHour) {
            var options = [];
            var hour;
            var minute;
            var value;
            for (hour = startHour; hour <= endHour; hour++) {
                for (minute = 0; minute < 60; minute += 30) {
                    if (hour === endHour && minute > 0) {
                        break;
                    }
                    value = pad2(hour) + ':' + pad2(minute);
                    options.push({
                        value: value,
                        label: formatAmPmLabel(hour, minute)
                    });
                }
            }
            return options;
        }

        function pad2(num) {
            return (num < 10 ? '0' : '') + num;
        }

        function formatAmPmLabel(hour, minute) {
            var minuteStr = pad2(minute);
            if (hour === 12 && minute === 0) {
                return '12:00 noon';
            }
            if (hour === 0) {
                return '12:' + minuteStr + ' AM';
            }
            if (hour < 12) {
                return pad2(hour) + ':' + minuteStr + ' AM';
            }
            if (hour === 12) {
                return '12:' + minuteStr + ' PM';
            }
            return pad2(hour - 12) + ':' + minuteStr + ' PM';
        }

        function normalizeStoredTime(value, fallback) {
            var time = (value || fallback || '').trim();
            if (!/^\d{1,2}:\d{2}$/.test(time)) {
                return fallback;
            }
            var parts = time.split(':');
            return pad2(parseInt(parts[0], 10)) + ':' + pad2(parseInt(parts[1], 10));
        }

        function ensureOptionInList(list, value) {
            var exists = list.some(function (option) {
                return option.value === value;
            });
            if (!exists && value) {
                var parts = value.split(':');
                list.unshift({
                    value: value,
                    label: formatAmPmLabel(parseInt(parts[0], 10), parseInt(parts[1], 10))
                });
            }
        }

        function initSettings(response) {
            if (!response) {
                return;
            }

            if (response.success === false) {
                if (response.errorMsg) {
                    toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                }
                return;
            }

            var settings = response.settings;
            if (!settings) {
                return;
            }

            vm.enabled = settings.daily_rentals_enabled === true
                || settings.daily_rentals_enabled === 1
                || settings.daily_rentals_enabled === '1';
            vm.checkin = normalizeStoredTime(settings.daily_rentals_checkin, '11:00');
            vm.checkout = normalizeStoredTime(settings.daily_rentals_checkout, '17:00');
            ensureOptionInList(vm.checkinOptions, vm.checkin);
            ensureOptionInList(vm.checkoutOptions, vm.checkout);
        }

        function toggleEnabled() {
            vm.enabled = !vm.enabled;
        }

        function onToggleKeypress(event) {
            if (event && (event.key === 'Enter' || event.key === ' ')) {
                event.preventDefault();
                toggleEnabled();
            }
        }

        function saveSettings() {
            if (vm.enabled && vm.checkin && vm.checkout && vm.checkin >= vm.checkout) {
                toastMessage.showSimpleToast('Check-out time must be after check-in time.', 'error-toast');
                return;
            }

            vm.isloading = true;
            dailyRentalsService.saveSettings({
                hotel_id: vm.hotel_id,
                daily_rentals_enabled: vm.enabled ? '1' : '0',
                daily_rentals_checkin: vm.checkin || '11:00',
                daily_rentals_checkout: vm.checkout || '17:00'
            }).then(function (response) {
                vm.isloading = false;
                if (!response || response.success === false) {
                    toastMessage.showSimpleToast(
                        (response && response.errorMsg) || 'Failed to save daily rentals settings.',
                        'error-toast'
                    );
                    return;
                }

                if (response.settings) {
                    initSettings(response);
                }

                if (typeof $rootScope.loadHotelInformation === 'function') {
                    $rootScope.loadHotelInformation(vm.hotel_id);
                }

                toastMessage.showSimpleToast('Daily rentals settings saved.', 'success-toast');
            }, function () {
                vm.isloading = false;
                toastMessage.showSimpleToast('Failed to save daily rentals settings.', 'error-toast');
            });
        }
    }
})();

'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../mls/mlsService
 * @description
 * # ../mls/mlsService
 * Service in the minervaApp.
 */
angular.module('app.restaurant')
  .service('restaurantSettingsService', function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
 	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}
 	
 	/**
 	* @param: object  data
 	* type: POST
 	* get restaurant fields list
 	*/
 	function getRestaurantSettings(data){
 		return $http({
			url: EnvironmentConfig.api+'Restaurantsettings/fetch_restaurant_settings',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* @param: object  data
	* type: POST
	* add or edit setting
	*/
	function addUpdateSetting(data) {
		return $http({
			url: EnvironmentConfig.api+'Restaurantsettings/add_edit_setting',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);	
	}

	/**
	* @param: integer  id
	* type: GET
	* get setting detail on edit
	*/
	function getSettingDetail(id) {
		return $http({
			url: EnvironmentConfig.api+'Restaurantsettings/get_setting_detail/'+id,
			method: 'GET',
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* @param: integer  id
	* type: GET
	* delete the setting 
	*/
	function deleteSetting(id) {
		return $http({
			url: EnvironmentConfig.api+'Restaurantsettings/delete_restaurant_setting/'+id,
			method: 'GET',
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
	/**
	* @param: object   data
	* type: POST
	* check settings name already exist
	*/
	function checkNameAlreadyExist(data) {
		return $http({
			url: EnvironmentConfig.api+'Restaurantsettings/check_name_already_exist',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* @param: integer  fieldId
	* type: GET
	* fetch sub items related with setting
	*/
	function getSubItemsDetail(fieldId) {
		return $http({
			url: EnvironmentConfig.api+'Restaurantsettings/get_setting_sub_items/'+fieldId,
			method: 'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* @param: object  data
	* used to add or update sub item
	*/
	function addUpdateSubItem(data) {
		return $http({
			url: EnvironmentConfig.api+'Restaurantsettings/add_update_subItem',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* @param: integer  subItemId
	* type: GET
	* delete the setting sub item
	*/
	function deleteSubItem(subItemId) {
		return $http({
			url: EnvironmentConfig.api+'Restaurantsettings/delete_setting_subItem/'+subItemId,
			method: 'GET',
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
	
 	return{
		getRestaurantSettings: getRestaurantSettings,
		addUpdateSetting: addUpdateSetting,
		getSettingDetail: getSettingDetail,
		deleteSetting: deleteSetting,
		checkNameAlreadyExist: checkNameAlreadyExist,
		getSubItemsDetail: getSubItemsDetail,
		addUpdateSubItem: addUpdateSubItem,
		deleteSubItem: deleteSubItem
	}
 });

(function() {
    'use strict';

    angular
        .module('app.restaurant')
        .controller('restaurantSettingsController', restaurantSettingsController);

    /** @ngInject */
    function restaurantSettingsController(
        restaurantData,
        restaurantSettingsService,
        $sessionStorage,
        $mdDialog,
        $scope,
        $state,
        toastMessage,
        $localStorage       
    ) {
        /*initialization*/
        var vm = this;
        vm.settingsList = restaurantData.settings;
        vm.settingsListCount = restaurantData.settingsCount; 
        vm.search = '';
        vm.curPage = 1;
        vm.limit = 10;
        vm.maxPage = (restaurantData.settingsCount > 0) ? parseInt(restaurantData.settingsCount / vm.limit) : 0;
        vm.activeIndex = -1;
        vm.subItems = {};
        vm.subItemsIncArray = [];
        vm.subItemsIncValue = 0;
        vm.showSubItemError = [];
        vm.showCostField = true;
        /**
        * Search the settings list
        */
        vm.autoFillOff = true;
        vm.searchFilterSettingsList = function() {
            vm.filters = {
                search: vm.search,
                offset: (vm.curPage - 1) * vm.limit,
                limit: vm.limit
            };
            restaurantSettingsService.getRestaurantSettings(vm.filters)
                .then(function(response){
                vm.activeIndex = -1;
                vm.isloading = false;
                vm.settingsList = response.settings;
                vm.settingsListCount = response.settingsCount;
                vm.maxPage = (response.settingsCount > 0) ? parseInt(response.settingsCount / vm.limit) : 0;
            });
        };

        /**
        * @param: integer  page
        * @param: string   type
        * change the limit options
        */
        vm.changePage = function(page, type) {
            var preCount = vm.curPage;
            if (type === 'pre'){
                vm.curPage = parseInt(vm.curPage) - 1;
            } else if (type === 'next'){
                vm.curPage = parseInt(vm.curPage) + 1;
            }
            
            if(vm.curPage > 0 && vm.curPage <= vm.maxPage){
                vm.searchFilterSettingsList();
            } else {
                vm.curPage = preCount;
            }
        };

        /**
        * @param: integer  id
        * open add or edit settings popup
        */
        vm.addEditDialog = function(id) {
            if (id > 0) {
                restaurantSettingsService.getSettingDetail(id)
                    .then(function(response){
                    opeDialogPopup(response.setting);
                });
            } else {
                opeDialogPopup({});
            } 
        };

        function opeDialogPopup(data) {
            $mdDialog.show({
                controller: 'RestaurantDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/restaurant/settings/dialog/addEdit.html',
                // parent: angular.element($document.find('#content-container')),
                // targetEvent: event,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                onRemoving: function() {                    
                    vm.isloading = true;
                    vm.searchFilterSettingsList();
                },
                locals: {
                    data: data,
                }
            });
        }

        /**
        * @param: integer  id
        * delete the setting
        */
        vm.deleteOrder = function(id) {
            var html = 'Are you sure, you want to delete the setting?</br>';
            html = html + 'Its sub items will also be deleted.'              
            $mdDialog.show({
                controller: 'confirmController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose:true ,
                locals: {
                    title: 'Delete Restaurant Setting',
                    htmlContent:html,
                    cancelBtn:'Cancel',
                    OkBtn:'Ok'
                }                
            }).then(function(answer) {
                if (answer !== undefined && answer === 'update') {
                    restaurantSettingsService.deleteSetting(id).then(function(){
                        vm.searchFilterSettingsList();
                    });
                }
            });
        };

        /**
        * @param: integer index
        * @param: integer fieldId
        * used to show sub items with parent item
        */
        vm.showSubItems = function(index, fieldId, hitRequest) {
            vm.isloading = true;
            vm.activeIndex = index;
            vm.showCostField = vm.settingsList[index].has_cost === '1' ? true : false;
            restaurantSettingsService.getSubItemsDetail(fieldId).then(function(response){
                vm.subItemsIncValue = (response.setting.length !== undefined) ? response.setting.length - 1 : 0;
                if (response.setting.length > 0){
                    vm.subItemsIncArray = [];
                    for (var i = 0; i < response.setting.length; i++) {
                        vm.subItemsIncArray.push(i);
                        vm.subItems['name_'+i] = response.setting[i].field_option_name;
                        // vm.subItems['cost_'+i] = parseFloat(response.setting[i].field_option_default_cost);
                        vm.subItems['cost_'+i] = '$'+parseFloat(response.setting[i].field_option_default_cost).toFixed(2);
                        vm.subItems['optionId_'+i] = response.setting[i].option_id;
                        vm.subItems['cook_pref_'+i] = response.setting[i].cooking_preference;
                        vm.showSubItemError['error_'+i] = false;
                    }
                } else {
                    vm.subItemsIncArray = [];
                    vm.subItemsIncArray.push(vm.subItemsIncValue);
                    vm.subItems['name_0'] = '';
                    vm.subItems['cost_0'] = 0;
                    vm.subItems['optionId_0'] = '';
                    vm.subItems['cook_pref_'+i] = 0;
                    vm.showSubItemError['error_0'] = false;
                }
                vm.isloading = false;                
            });
        };

        /**
        * push value in array to increase div
        */        
        vm.addSubItem = function() {
            vm.subItemsIncValue = parseInt(vm.subItemsIncValue + 1);
            vm.subItemsIncArray.push(vm.subItemsIncValue);
            var length = vm.subItemsIncArray.length > 0 ? vm.subItemsIncArray.length - 1 : 0;
            vm.subItems['name_'+length] = '';
            vm.subItems['cost_'+length] = 0;
            vm.subItems['optionId_'+length] = '';            
        };

        /**
        * delete the value from array
        */        
        vm.deleteSubItem = function(value) {
            var index = vm.subItemsIncArray.indexOf(value);
            if (vm.subItems['optionId_'+value] !== undefined && vm.subItems['optionId_'+value] !== '') {
                restaurantSettingsService.deleteSubItem(parseInt(vm.subItems['optionId_'+value])).then(function(){
                    vm.subItemsIncArray.splice(index, 1);
                });                
            } else {
                vm.subItemsIncArray.splice(index, 1);
            }
        };

        /**
        * @param: string  field_name
        * @param: integer index
        * add or update sub item of setting
        */
        vm.saveSubItemAdded = function(field_name, index) {
            if (vm.subItems['name_'+index] !== undefined && vm.subItems['name_'+index] !== '') {
                var tempData = {
                    field_option_name: vm.subItems['name_'+index],
                    field_option_default_cost: (vm.subItems['cost_'+index] !== undefined && vm.subItems['cost_'+index] !== null && vm.subItems['cost_'+index] !== 0) ? vm.subItems['cost_'+index].replace(/[^\d|\-+|\.+]/g, '') : 0,
                    cooking_preference: (vm.subItems['cook_pref_'+index] !== undefined) ? vm.subItems['cook_pref_'+index] : '',
                    option_id: vm.subItems['optionId_'+index],
                    field_id: vm.settingsList[vm.activeIndex].field_id
                };
                restaurantSettingsService.addUpdateSubItem(tempData).then(function(res) {
                    if (vm.subItems['cost_'+index] !== undefined && vm.subItems['cost_'+index] !== null && vm.subItems['cost_'+index] !== 0) {
                        vm.subItems['cost_'+index] = '$'+parseFloat(vm.subItems['cost_'+index].replace(/[^\d|\-+|\.+]/g, '')).toFixed(2);
                    } else {
                        vm.subItems['cost_'+index] = '$'+parseFloat(0).toFixed(2);
                    }

                    if (res.result !== undefined && res.result === 'nameExist') {
                        vm.showSubItemError['error_'+index] = true;
                    } else {
                        vm.showSubItemError['error_'+index] = false;
                        vm.subItems['optionId_'+index] = parseInt(res.result);
                    }
                });
            }
        };

        setTimeout(function() {
           vm.autoFillOff = false;
        }, 1500); 
    }
})();



(function() {
    'use strict';

    angular
        .module('app.restaurant')
        .controller('restaurantOrderController', restaurantOrderController);

    /** @ngInject */
    function restaurantOrderController(
        orderDetail,
        restaurantService,
        $sessionStorage,
        $mdDialog,
        $scope,
        $state,
        toastMessage,
        $localStorage       
    ) {
        /*initialization*/
        var vm = this;
        

        
    }
})();



(function() {
    'use strict';

    angular
        .module('app.restaurant')
        .controller('restaurantCookController', restaurantCookController);

    /** @ngInject */
    function restaurantCookController(
        cookData,
        restaurantSettingsService,
        restaurantService,
        $sessionStorage,
        $mdDialog,
        $scope,
        $state,
        toastMessage,
        $localStorage,
        $window     
    ) {
        /*initialization*/
        var vm = this;
        vm.loop = [];
        vm.columnCount = 4;
        console.log(cookData);

        vm.cookOrders = (cookData !== undefined && cookData.cookOrders !== undefined) ? cookData.cookOrders : [];


        vm.recountColumn = function() {
            vm.screenWidth = $(window).width();
            if(vm.screenWidth <= 4000 && vm.screenWidth >= 3000) {
                vm.columnCount = 7;
            } else if(vm.screenWidth >= 2300 && vm.screenWidth < 3000) {
                vm.columnCount = 6;
            } else if(vm.screenWidth >= 1800 && vm.screenWidth < 2300) {
                vm.columnCount = 5;
            } else if(vm.screenWidth >= 1366 && vm.screenWidth < 1800) {
                vm.columnCount = 4;
            } else if(vm.screenWidth >= 990 && vm.screenWidth < 1366) {
                vm.columnCount = 3;
            } else if(vm.screenWidth >= 640 && vm.screenWidth < 990) {
                vm.columnCount = 2;
            } else {
                vm.columnCount = 1;
            }

            vm.masonryOptions = {
                columnCount     : vm.columnCount,
                respectItemOrder: true
            }
        }
        
        vm.recountColumn();


        /*angular.element($window).bind('resize', function(){
            console.log("resizwe");
            vm.recountColumn();
        });*/

        /*
        ** Change oder status
        */
        vm.changeOrderStatus = function(value, index) {
            // console.log(value);
            // console.log(index);
            // console.log(vm.cookOrders[index]);
            var postData = {
                room_stay_id: vm.cookOrders[index].room_stay_id,
                restaurant_order_status: vm.cookOrders[index].restaurant_order_status
            }

            restaurantService.changeRestaurantOrderStatus(postData).then(function(response){
                console.log(response.data);
                if(response.data.status == "success") {
                    vm.cookOrders[index].restaurant_order_status = response.data.orderStatus;
                    if(response.data.orderStatus == "completed") {
                        setTimeout(function(){
                            console.log("delete order");
                            vm.cookOrders.splice(index, 1);
                        },60*1000);
                    }
                }
            });
        }
        
    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.reports',
            [
                // 3rd Party Dependencies
                'md.data.table'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider){
        // State
        $stateProvider
            .state('app.reports', {
                abstract: true
            })
            .state('app.reports.lodging_statistic', {
                url      : '/reports/lodging-statistic',
                title    : 'Lodging Statistic',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/lodging-statistic/lodging-statistic.html',
                        controller : 'LodgingStatisticController as vm'
                    }
                },
                permission: 'lodging_statistic',
                bodyClass: 'reports'
            }).state('app.reports.lodging_statistic_new', {
                url      : '/reports/lodging-statistic-new',
                title    : 'Lodging Statistic new',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/lodging-statistic/lodging-statistic-new.html',
                        controller : 'LodgingStatisticNewController as vm'
                    }
                },
                permission: 'lodging_statistic',
                bodyClass: 'reports'
            }).state('app.reports.detail', {
                url      : '/reports/detail/:param',
                title    : 'Lodging Statistic new',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/lodging-statistic/lodging-detail.html',
                        controller : 'LodgingDetailController as vm'
                    }
                },
                resolve  : {
                    detailData: function (lodgingStatistic, $stateParams){
                        var searchedParam = $stateParams.param;
                        searchedParam = searchedParam.split('&');
                        var hotels;
                        if (searchedParam[0] == 'lodgingStats') {
                            hotels = searchedParam[4] !== undefined ? searchedParam[4] : '';
                        } else if (searchedParam[0] == 'nightAudit') {
                            hotels = searchedParam[5] !== undefined ? searchedParam[5] : '';
                        } else if (searchedParam[0] == 'taxReport') {
                            hotels = searchedParam[6] !== undefined ? searchedParam[6] : '';
                        } else if (searchedParam[0] == 'revenueManagement') {
                            hotels = '';
                        } 

                        if (hotels != '') {
                            hotels = atob(hotels);
                            hotels = hotels.split("=");
                        } else {
                            hotels = [];
                        }

                        if (searchedParam[0] == 'lodgingStats') {
                            var data = {
                                date:searchedParam[2],
                                reportFor: searchedParam[3],
                                searchedArg: searchedParam[1],
                                selected_hotel: hotels
                            };
                            return lodgingStatistic.getLodgingStatsDetail(data);
                        } else if (searchedParam[0] == 'nightAudit') {
                            var data = {
                                start:searchedParam[2],
                                end:searchedParam[3],
                                reportFor: searchedParam[4],
                                searchedArg: searchedParam[1],
                                selected_hotel: hotels
                            };
                            return lodgingStatistic.getNightAuditDetail(data);
                        } else if (searchedParam[0] == 'taxReport') {
                            var data = {
                                start:searchedParam[2],
                                end:searchedParam[3],
                                reportFor: searchedParam[4],
                                searchedArg: searchedParam[1],
                                searchedId: atob(searchedParam[5]),
                                selected_hotel: hotels
                            };
                            return lodgingStatistic.getTaxReportDetail(data);
                        } else if (searchedParam[0] == 'revenueManagement') {
                            var data = {
                                reportFor: searchedParam[3],
                                searchedArg: searchedParam[1],
                                searchedId: searchedParam[2],
                                selected_hotel: hotels
                            };
                            var subHotelId = null;

                            if (searchedParam[2] == 'custom-range') {
                                var hasDateRange = searchedParam[4] && searchedParam[5] &&
                                    (String(searchedParam[4]).indexOf('-') !== -1 || String(searchedParam[4]).indexOf('/') !== -1);

                                if (hasDateRange) {
                                    data.startDate = searchedParam[4];
                                    data.endDate = searchedParam[5];
                                }
                            }

                            if (searchedParam[1] === 'channelBookings') {
                                if (searchedParam[6]) {
                                    data.channel = searchedParam[6].replace(/_/g, ' ').replace(/~/g, '.');
                                }
                                if (searchedParam[7] && !isNaN(parseInt(searchedParam[7], 10))) {
                                    subHotelId = parseInt(searchedParam[7], 10);
                                }
                            } else if (searchedParam[2] == 'custom-range') {
                                if (data.startDate && data.endDate && searchedParam[6] && !isNaN(parseInt(searchedParam[6], 10))) {
                                    subHotelId = parseInt(searchedParam[6], 10);
                                } else if (!data.startDate && searchedParam[4] && !isNaN(parseInt(searchedParam[4], 10))) {
                                    subHotelId = parseInt(searchedParam[4], 10);
                                }
                            } else if (searchedParam[4] && !isNaN(parseInt(searchedParam[4], 10))) {
                                subHotelId = parseInt(searchedParam[4], 10);
                            }

                            if (subHotelId) {
                                data.sub_hotel_id = subHotelId;
                                data.selected_hotel = [subHotelId];
                            }
                            
                            return lodgingStatistic.getRevenueManagementReport(data);
                        }
                    }
                },
                permission: 'lodging_statistic',
                bodyClass: 'reports'
            }).state('app.reports.departure_invoices', {
                url      : '/reports/departure-invoices',
                title    : 'Departure Invoices',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/departure-invoices/departure-invoices.html',
                        controller : 'DepartureInvoiceController as vm'
                    }
                },
                permission: 'departure_invoices',
                bodyClass: 'reports'
            }).state('app.reports.housekeeping', {
                url      : '/reports/housekeeping',
                title    : 'Housekeeping',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/housekeeping/housekeeping.html',
                        controller : 'housekeepingController as vm'
                    }
                },
                permission: 'housekeeping',
                bodyClass: 'housekeeping'
            }).state('app.reports.light-cleaning', {
                url      : '/reports/light-cleaning',
                title    : 'Light Cleaning',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/light-cleaning/light-cleaning.html',
                        controller : 'lightCleaningController as vm'
                    }
                },
                permission: 'light_cleaning',
                bodyClass: 'light-cleaning'
            }).state('app.reports.income-reports', {
                url      : '/reports/income-reports',
                title    : 'Income',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/income-report/income-report.html',
                        controller : 'incomeReportController as vm'
                    }
                },
                permission: 'income_reports',
                bodyClass: 'income_reports'
            }).state('app.reports.room-moves', {
                url      : '/reports/room-moves',
                title    : 'Room Moves',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/room-moves/room-moves.html',
                        controller : 'roomMoveController as vm'
                    }
                },
                permission: 'room_moves',
                bodyClass: 'housekeeping'
            }).state('app.reports.customer-advanced-deposit', {
                url      : '/reports/customer-advanced-deposit',
                title    : 'Advance Deposit',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/customer-advanced-deposit/customer-advanced-deposit.html',
                        controller : 'customerAdvancedDepositController as vm'
                    }
                },
                permission: 'customer_advanced_deposit',
                bodyClass: 'customerAdvancedDeposit'
            }).state('app.reports.payments-by-employee', {
                url      : '/reports/payments-by-employee',
                title    : 'Payments By Employee',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/payments-by-employee/payments-by-employee.html',
                        controller : 'paymentsByEmployeeController as vm'
                    }
                },
                permission: 'payments_by_employee',
                bodyClass: 'customerAdvancedDeposit'
            }).state('app.reports.gift-certificates', {
                url      : '/reports/gift-certificates',
                title    : 'Gift Certificates',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/gift-certificates/gift-certificates.html',
                        controller : 'giftCertificatesController as vm'
                    }
                },
                permission: 'gift_certificates',
                bodyClass: 'customerAdvancedDeposit'
            }).state('app.reports.payment-received', {
                url      : '/reports/payment-received',
                title    : 'Payment Received',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/payment-received/payment-received.html',
                        controller : 'paymentReceivedController as vm'
                    }
                },
                permission: 'payment_received',
                
                bodyClass: 'customerAdvancedDeposit'
            }).state('app.reports.retail-report', {
                url      : '/reports/pos-report',
                title    : 'POS Report',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/retail-report/retail-report.html',
                        controller : 'retailReportController as vm'
                    }
                },
                permission: 'retail_report',
                
                bodyClass: 'retailReport'
            }).state('app.reports.tax-report', {
                url      : '/reports/tax-report',
                title    : 'Tax Report',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/tax-report/tax-report.html',
                        controller : 'taxReportController as vm'
                    }
                },
                permission: 'tax_report',
                
                bodyClass: 'taxReport'
            }).state('app.reports.tax-report-new', {
                url      : '/reports/tax-report-new',
                title    : 'Tax Report',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/tax-report/tax-report-new.html',
                        controller : 'taxReportNewController as vm'
                    }
                },
                permission: 'tax_report',                
                bodyClass: 'taxReport'
            })
            .state('app.reports.night-audit', {
                url      : '/reports/night-audit',
                title    : 'Night Audit',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/night-audit/night-audit.html',
                        controller : 'nightAuditController as vm'
                    }
                },
                permission: 'night_audit_report',
                
                bodyClass: 'nightAuditReport'
            }).state('app.reports.night-audit-short', {
                url      : '/reports/night-audit-short',
                title    : 'Night Audit Short',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/night-audit-short/night-audit-short.html',
                        controller : 'nightAuditShortController as vm'
                    }
                },
                permission: 'night_audit_short_report',                
                bodyClass: 'nightAuditShortReport'
            }).state('app.reports.arrival-registration-card', {
                url      : '/reports/arrival-registration-card',
                title    : 'Arrival Regestration Card',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/arrival-registration-card/arrival-registration-card.html',
                        controller : 'arrivalRegistrationCardController as vm'
                    }
                },
                permission: 'arrival_registration_card',                
                bodyClass: 'arrivalRegistrationCard'
            }).state('app.reports.m3-report', {
                url      : '/reports/m3-report',
                title    : 'M3 Report',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/m3-report/m3report.html',
                        controller : 'mReportController as vm'
                    }
                },
                permission: 'm3_report',                
                bodyClass: 'nightAuditShortReport'
            }).state('app.reports.reservation-due-report', {
                url      : '/reports/reservation-due-report',
                title    : 'Reservation Due',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/reservation-due-report/reservation-due-report.html',
                        controller : 'reservationDueReport as vm'
                    }
                },
                permission: 'tax_report',                
                bodyClass: 'reservationDueReport'
            }).state('app.reports.zero-daily-rate', {
                url      : '/reports/zero-daily-rate',
                title    : 'Zero Daily Rate',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/zero-daily-rate/zero-daily-rate.html',
                        controller : 'zeroDailyRate as vm'
                    }
                },
                permission: 'tax_report',                
                bodyClass: 'zeroDailyRate'
            }).state('app.reports.night-audit-new', {
                url      : '/reports/night-audit-new',
                title    : 'Night Audit',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/night-audit-new/night-audit-new.html',
                        controller : 'nightAuditNewController as vm'
                    }
                },
                permission: 'night_audit_report',                
                bodyClass: 'nightAuditReport'
            }).state('app.reports.night-audit-latest', {
                url      : '/reports/night-audit-latest',
                title    : 'Night Audit',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/night-audit-latest/night-audit-latest.html',
                        controller : 'nightAuditLatestController as vm'
                    }
                },
                permission: 'night_audit_report',                
                bodyClass: 'nightAuditReport'
            }).state('app.reports.m3-report-new', {
                url      : '/reports/m3-report-new',
                title    : 'M3 Report New',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/m3-report-new/m3report-new.html',
                        controller : 'mReportNewController as vm'
                    }
                },
                permission: 'm3_report',                
                bodyClass: 'nightAuditShortReport'
            }).state('app.reports.sales_by_employee', {
                url      : '/reports/sales_by_employee',
                title    : 'Sales by Employee',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/salesbyemployee/salesbyemployee.html',
                        controller : 'salesByEmployeeController as vm'
                    }
                },
                permission: 'sales_by_employee',
                bodyClass: '',
                resolve: {
                    userPermission: function (reportService){
                        return reportService.getReportPermissions('salesbyemployee');
                    }
                }
            }).state('app.reports.reconciliation', {
                url      : '/reports/reconciliation',
                title    : 'Reconciliation Report',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/reconcillation/reconcillation.html',
                        controller : 'reconcillationController as vm'
                    }
                },
                permission: 'reconciliation',
                bodyClass: ''
            }).state('app.reports.custom_reports', {
                url      : '/reports/custom-reports',
                title    : 'Custom Reports',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/custom-reports/custom-reports.html',
                        controller : 'CustomReportsController as vm'
                    }
                },
                bodyClass: 'reports'
            }).state('app.reports.availability_report', {
                url      : '/reports/availability-report',
                title    : 'Availability Report',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/availability-report/availability-report.html',
                        controller : 'AvailabilityReportController as vm'
                    }
                },
                bodyClass: 'reports'
            }).state('app.reports.promo-reports', {
                url      : '/reports/promo',
                title    : 'Promo Reports',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/promo-reports/promo-reports.html',
                        controller : 'promoReports as vm'
                    }
                },
                permission: 'lodging_statistic',
                bodyClass: 'reports'
            }).state('app.reports.hold-report', {
                url      : '/reports/hold-report?start&end&status',
                title    : 'Courtesy Hold Report',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/reports/hold-report/hold-report.html',
                        controller : 'holdReports as vm'
                    }
                },
                permission: 'courtesy_hold_report',
                bodyClass: 'reports'
            });
            
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/reports');
    }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('zeroDailyRate', zeroDailyRate);

    /** @ngInject */
    function zeroDailyRate(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $filter,
       $mdDialog,
       $rootScope,
       $localStorage
    ){
        var vm = this; 
        vm.addTableClass = false;
        vm.removeClass = false;
        vm.prevScroll = 0;
        vm.initialOffset = 0;
        vm.tbodyHeight = 0;       

        // Change the selector if needed
        vm.tableStyle = {};
        vm.table;
        vm.bodyCells;
        vm.colWidth;

     

        vm.report = {};        

        vm.selectedColumns = 'itinerary_number,confirmation_number,room_stay_status,room_stay_from,room_stay_to,Customer,quantity,product_name,NoOfNights,hotel_title,source_of_creation,Employee,subtotal,product_discount,lodging tax percentage,lodging tax amount,resort fee percentage,resort fee amount,resort fee tax percentage,resort fee tax amount,sales tax percentage,sales tax amount,grand_total,total_paid_amount,total_remaining_amount,totalPaid,payment_method,paidToday';


        vm.not_required = 'product_id,product_is_timebound,sub_hotel_id,type_of_reservation,total,bar tax amount,bar tax percentage';
        vm.allIds = [];
        vm.selectedChannels = [];
        vm.selectedPaymentMethods = [];
        vm.selectedHotels = [];
        vm.csvHeader =  ['Itinerary' ,'Confirmation','Status','Checkin','Checkout','Customer','Quantity','Item','Number of Nights','Business Entity','Source','Employee  ','Sub Total ','Discount  ','Lodging Tax(%)','Lodging Tax($)','Resort Fee(%)','Resort Fee ($)  ','Resort Fee Tax(%)','Resort Fee Tax($)','Sales Tax  (%)','Sales Tax  ($)','Grand Total','Paid','Remaining','Reservation Total','Payment Method','Paid Within Report Range'];
        vm.pdfHeader = angular.copy(vm.csvHeader);
        vm.myDate = new Date();
        vm.allData = [];

        vm.channels = [];
        vm.startDate = null;
        vm.endDate =null;
        vm.checkInDate = null;
        vm.checkOutDate = null;
        vm.disableRefresh = true;
        vm.reportType = 'overAll';

        reportService.getAllChannels().then(function(response){
            if(response.success){
                vm.channels = response.result;
            }
        });

        /*Functions Dec*/
        vm.getIncomeReport = getIncomeReport;
        vm.getValues = getValues;
        vm.compareDate = compareDate;
        vm.calculateTotal = calculateTotal;

        vm.reinitialize = reinitialize;
        reinitialize();
        function reinitialize(){
        vm.quantity = 0;
        vm.NoOfNights = 0;
        vm.subtotal = 0;
        vm.product_discount = 0;
        vm.tax_amount = 0;
        vm.total = 0;
        vm.paymentsTodates = 0;
        vm.total_remaining_amount = 0;
        vm.grand_total = 0;
        vm.totalPaid = 0;
        vm.total_paid_amount = 0;
        vm.paidToday = 0;
        }
        vm.overAll = new Array();
        vm.pindex = '1111';
        vm.countLoopElement = 0;
        vm.countLoopElement2 = 0;
        vm.confirmation_numbers = [];
        vm.confirmation_numbers2 = [];

        // vm.goToState = goToState;
        // function goToState(itinerary_number, confirmation_number, test){
        //   $rootScope.goToState(itinerary_number, confirmation_number, test);
        //   // console.log(itinerary_number, confirmation_number);
        // }
        vm.showReportFor = false;
        vm.reportFor = 'all';
        if($localStorage['preHotelId'] !== undefined && $localStorage['preHotelId'] == 126){
          vm.reportFor = 'reservation';
          vm.showReportFor = true;
        }

        function calculateTotal(data, pindex){
          
          vm.countLoopElement = vm.countLoopElement + 1;

            if(vm.pindex != pindex){
                reinitialize();
                vm.pindex = pindex;
            }

            var income = angular.copy(data);
            if(vm.confirmation_numbers.indexOf(income.confirmation_number) == -1) {
            vm.tax_amount = parseFloat(vm.tax_amount) + parseFloat(income.tax_amount);
            vm.paymentsTodates = parseFloat(vm.paymentsTodates) + parseFloat(income.paymentsTodates);
            vm.NoOfNights = parseFloat(vm.NoOfNights) + parseFloat(income.NoOfNights);
            vm.subtotal = parseFloat(vm.subtotal) + parseFloat(income.subtotal);
            vm.product_discount = parseFloat(vm.product_discount) + parseFloat(income.product_discount);
            vm.grand_total = parseFloat(vm.grand_total) + parseFloat(income.grand_total);         
            vm.totalPaid = parseFloat(vm.totalPaid) + parseFloat(income.totalPaid);         
            

            vm.total_remaining_amount = parseFloat(vm.total_remaining_amount) + parseFloat(income.total_remaining_amount);

            vm.total_paid_amount = parseFloat(vm.total_paid_amount) + parseFloat(income.total_paid_amount);

            vm.quantity = parseFloat(vm.quantity) + parseFloat(income.quantity);
            }
            vm.paidToday = parseFloat(vm.paidToday) + parseFloat(income.paidToday);         
            // vm.total = parseFloat(vm.total) + parseFloat(income.total);

           vm.confirmation_numbers.push(income.confirmation_number);

            vm.overAll[pindex] = {};
            vm.overAll[pindex]['quantity'] = angular.copy(vm.quantity);
            vm.overAll[pindex]['NoOfNights'] = angular.copy(vm.NoOfNights);
            vm.overAll[pindex]['grand_total'] = angular.copy(vm.grand_total);
            vm.overAll[pindex]['subtotal'] = angular.copy(vm.subtotal);
            vm.overAll[pindex]['tax_amount'] = angular.copy(vm.tax);
            // vm.overAll[pindex]['total'] = angular.copy(vm.total);
            vm.overAll[pindex]['totalPaid'] = angular.copy(vm.totalPaid);
            vm.overAll[pindex]['paymentsTodates'] = angular.copy(vm.paymentsTodates);
            vm.overAll[pindex]['total_remaining_amount'] = angular.copy(vm.total_remaining_amount);
            vm.overAll[pindex]['total_paid_amount'] = angular.copy(vm.total_paid_amount);
            vm.overAll[pindex]['paidToday'] = angular.copy(vm.paidToday);

            if(vm.countLoopElement == vm.actualLength){              
              var totalPaid = 0;
              var paidToday = 0;
               for(var tempKey in vm.overAll){
                totalPaid = parseFloat(totalPaid) + parseFloat(vm.overAll[tempKey]['totalPaid']);
                paidToday = parseFloat(paidToday) + parseFloat(vm.overAll[tempKey]['paidToday']);
              }
              vm.overAllTotal = {
                                    'itinerary_number':'',
                                    'confirmation_number':'',
                                    'room_stay_status':'',
                                    'room_stay_from':'',
                                    'room_stay_to':'',
                                    'Customer':'',
                                    'quantity':'',
                                    'product_name':'',
                                    'NoOfNights':'',
                                    'hotel_title':'',
                                    'source_of_creation':'',
                                    'Employee':'',
                                    'subtotal':'',
                                    'product_discount':'',
                                    'lodging tax percentage':'',
                                    'lodging tax amount':'',
                                    'resort fee percentage':'',
                                    'resort fee amount':'',
                                    'resort fee tax percentage':'',
                                    'resort fee tax amount':'',
                                    'sales tax percentage':'',
                                    'sales tax amount':'',
                                    'grand_total':'',
                                    'total_paid_amount':'',
                                    'total_remaining_amount':'',
                                    'totalPaid':$filter('currency')(totalPaid,'$',2),
                                    'payment_method':'',
                                    'paidToday' : $filter('currency')(paidToday,'$',2)
              };
              if(vm.reportType=='detailed')
                vm.overAllTotal.installment_paid_date='';
              vm.allData.push(vm.overAllTotal);
            }
        }
        

        function compareDate(date1, date2,index){
            var startDate = moment(date1);
            var endDate = moment(date2);
            if(startDate > endDate || startDate < endDate){
                vm.currentDate = date2;
                return true;
            } else {
                return false;
            }

        }
        vm.noResultFound = false;

        function getValues(date){
            vm.currentDate  = angular.copy(date);
            return vm.currentDate;
        }
    // getIncomeReport();

    vm.showTable = false;

    vm.requestProcessing = false;
        function getIncomeReport(){          
          vm.countLoopElement = 0;

          vm.requestProcessing = true;
          vm.allData = [];
          vm.incomeData = [];
          var endDate = moment(vm.endDate).format('YYYY-MM-DD');
          var startDate = moment(vm.startDate).format('YYYY-MM-DD');
          var checkInDate = moment(vm.checkInDate).format('YYYY-MM-DD');
          var checkOutDate = moment(vm.checkOutDate).format('YYYY-MM-DD');
          vm.csvName =  'payment-due-reports'+vm.reportType+'.csv';
          vm.pdfName =  'payment-due-reports-'+vm.reportType+'.pdf';
          reinitialize();
          reportService.getZeroNightlyRatesReservations({
              startDate:new Date(startDate),
              endDate:new Date(endDate),
              checkInDate:new Date(checkInDate),
              checkOutDate:new Date(checkOutDate),
              selectedChannels:vm.selectedChannels,
              selectedPaymentMethods:vm.selectedPaymentMethods,
              reportType:vm.reportType,
              reportFor:vm.reportFor,
              mode:'listing',
              'selectedHotels':vm.selectedHotels,
          }).then(function(response){

            vm.reservationList = response.data;
            vm.showTable = response.showTable

            vm.requestProcessing = false;
            vm.noResultFound = true;
            vm.incomeData = response['incomeReport'];
            vm.noResultFound = false;    
            
           setTimeout(function(){
              vm.tbodyHeight = document.getElementById('tbodyHeight').clientHeight;
              vm.initialOffset = $('#table-container').offset().top;
                vm.table = $('#heightTable');
                vm.bodyCells = vm.table.find('tbody tr:first').children();
                vm.colWidth;
                console.log("-->",vm.table);
              // Adjust the width of thead cells when window resizes
              $(window).resize(function() {
                  // Get the tbody columns width array
                  vm.colWidth = vm.bodyCells.map(function() {
                      return $(this).width();
                  }).get();
                  
                  // Set the width of thead columns
                  vm.table.find('thead tr').children().each(function(i, v) {
                      $(v).width(vm.colWidth[i]);
                  });    
              }).resize(); // Trigger resize handler

              vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };

            },100);

            
          });
          vm.confirmation_numbers = [];
        }   


    vm.printRecords = printRecords;
    vm.requestProcessingEmail = false;
    function printRecords(){
      // vm.requestProcessingEmail = true;
          var checkInDate = moment(vm.checkInDate).format('YYYY-MM-DD');
          var checkOutDate = moment(vm.checkOutDate).format('YYYY-MM-DD');
      $mdDialog.show({
                    controller: 'getEmailAddress',
                    controllerAs: 'vm',
                  templateUrl: 'app/main/apps/reports/getEmailAddress.html',
                  parent: angular.element(document.body),
                  targetEvent: event,
                  clickOutsideToClose:true ,
                                  
                })
                .then(function(answer) {
                  vm.requestProcessingEmail = false;
                     var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                   if(typeof answer != 'undefined'){
                    vm.requestProcessingEmail = true;
                    var endDate = new Date(moment(vm.endDate).format('YYYY-MM-DD'));
                    var startDate = new Date(moment(vm.startDate).format('YYYY-MM-DD'));
                    vm.csvName =  'income-reports'+startDate+'-to-'+endDate+'.csv';
                      reinitialize();
                      reportService.getAllIncomeReports({
                          startDate:startDate,
                          endDate:endDate,
                          selectedChannels:vm.selectedChannels,
                          selectedPaymentMethods:vm.selectedPaymentMethods,
                          emailAddress:answer,
                          checkInDate:new Date(checkInDate),
                          checkOutDate:new Date(checkOutDate),
                          reportType:vm.reportType,
                          mode:'sendEmail',
                          'selectedHotels':vm.selectedHotels,
                          'runReportFor': 'dueReport'
                      }).then(function(response){
                        vm.requestProcessingEmail = false;
                        });
           
        }
               }, function() {
               vm.requestProcessingEmail = false;});

      
    
    }
      vm.ChangeEndDayIf = function(){
        vm.startDate = new Date(
                                     this.myDate.getFullYear(),
                                     this.myDate.getMonth(),
                                     this.myDate.getDate()
                                   );
        if(!vm.endDate){
          vm.endDate = vm.startDate;
        }

        if(!moment(vm.endDate).isAfter(vm.startDate)){
        vm.endDate = moment(vm.startDate).add(0, 'days').format('M/D/Y');
        }
      }
     vm.changeCheckDates = function(){
        if(vm.checkInDate != undefined && vm.checkInDate != undefined && moment(vm.checkInDate).isAfter(vm.checkOutDate)) {
          vm.checkOutDate = vm.checkInDate;
        }

        if(!vm.checkInDate || !vm.checkOutDate){
          vm.disableRefresh = true;
        }
        else{
          vm.disableRefresh = false;
        }
      } 
       vm.changePayDates = function(){
        if(!vm.endDate || !vm.startDate){
          vm.disableRefresh = true;
        }
        else{
          vm.disableRefresh = false;
        }
      }
      vm.changeReportType = function(){
        vm.incomeData = [];
      }


      
      vm.downloadFileCustom = function(reportType,type_of_file_download){
        if(vm.reportType=='detailed'){
        
          vm.selectedColumns =  'itinerary_number,confirmation_number,installment_paid_date,room_stay_status,room_stay_from,room_stay_to,Customer,quantity,product_name,NoOfNights,hotel_title,source_of_creation,Employee,subtotal,product_discount,lodging tax percentage,lodging tax amount,resort fee percentage,resort fee amount,resort fee tax percentage,resort fee tax amount,sales tax percentage,sales tax amount,grand_total,total_paid_amount,total_remaining_amount,totalPaid,payment_method,paidToday';
          vm.csvHeader =  ['Itinerary' ,'Confirmation','Date','Status','Checkin','Checkout','Customer','Quantity','Item','Number of Nights','Business Entity','Source','Employee  ','Sub Total ','Discount  ','Lodging Tax(%)','Lodging Tax($)','Resort Fee(%)','Resort Fee ($)  ','Resort Fee Tax(%)','Resort Fee Tax($)','Sales Tax  (%)','Sales Tax  ($)','Total','Paid','Remaining','Reservation Total','Payment Method','Paid Today'];
          vm.not_required = 'product_id,product_is_timebound,sub_hotel_id,type_of_reservation,total,bar tax amount,bar tax percentage';
          vm.pdfHeader = angular.copy(vm.csvHeader);
        } else {
          vm.csvHeader =  ['Itinerary' ,'Confirmation','Status','Checkin','Checkout','Customer','Quantity','Item','Number of Nights','Business Entity','Source','Employee  ','Sub Total ','Discount  ','Lodging Tax(%)','Lodging Tax($)','Resort Fee(%)','Resort Fee ($)  ','Resort Fee Tax(%)','Resort Fee Tax($)','Sales Tax  (%)','Sales Tax  ($)','Grand Total','Paid','Remaining','Reservation Total','Payment Method','Paid Within Report Range'];
          vm.pdfHeader = angular.copy(vm.csvHeader);
          //vm.not_required = 'product_is_timebound,sub_hotel_id,type_of_reservation';
          vm.not_required = 'product_id,product_is_timebound,sub_hotel_id,type_of_reservation,installment_paid_date,total,bar tax amount,bar tax percentage';
          vm.selectedColumns = 'itinerary_number,confirmation_number,room_stay_status,room_stay_from,room_stay_to,Customer,quantity,product_name,NoOfNights,hotel_title,source_of_creation,Employee,subtotal,product_discount,lodging tax percentage,lodging tax amount,resort fee percentage,resort fee amount,resort fee tax percentage,resort fee tax amount,sales tax percentage,sales tax amount,grand_total,total_paid_amount,total_remaining_amount,totalPaid,payment_method,paidToday';

        }
        if(type_of_file_download == 'pdf')
          $rootScope.downloadFile(vm.csvHeader, vm.allData, vm.pdfName,vm.selectedColumns,vm.not_required,'lodgingstats');
        else
          $rootScope.downloadFile(vm.pdfHeader, vm.allData, vm.csvName,vm.selectedColumns,vm.not_required);
      }
    }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('taxReportController', taxReportController);

    /** @ngInject */
    function taxReportController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $filter,
       $mdDialog,
       $rootScope,
       $localStorage
    ){
        var vm = this;
        vm.report = {};
        vm.retailType = 'all';
        vm.allIds = [];
        vm.selectedChannels = [];
        vm.staticHideVariable = false;
        vm.reportSelected = 'new';
        vm.hotelID = $localStorage['preHotelId'];
        if($localStorage['preHotelId'] == 119 || $localStorage['preHotelId'] == 122){
            vm.reportSelected = 'old';
            vm.staticHideVariable = true;
        }
        vm.reportType = [{'key' : 'new', 'name' : 'Tax Overview'}, {'key' : 'old', 'name' : 'Tax Detail'}];
        vm.csvHeader =  ['Itinerary',
                          'Confirmation',
                          'Status',
                          'Checkin',
                          'Checkout',
                          'Customer',
                          'Quantity',
                          'Item',
                          'Associated POS',
                          'Number of nights',
                          'Business entity',
                          'Source',
                          'Payment type',
                          'Sub total',
                          'discount',
                          'Lodging tax',
                          'Sales tax',
                          'Tax',
                          'Total',
                          'Payment to date',
                          'Due',
                          'Installments paid',
                          'Installments refunded'];
        vm.pdfHeader = angular.copy(vm.csvHeader);

        vm.myDate = new Date();
        vm.allData = [];
        vm.startDate = new Date(
            this.myDate.getFullYear(),
            this.myDate.getMonth(),
            this.myDate.getDate()
        );
        vm.endDate = new Date(
            this.myDate.getFullYear(),
            this.myDate.getMonth(),
            this.myDate.getDate()
        );
        vm.first = true;
        vm.selectedHotels = [];
        vm.noResultFound = true;
        vm.requestProcessing = false;        
        vm.overAll = new Array();
        vm.pindex = '1111';
        vm.countLoopElement = 0;
        vm.requestProcessingEmail = false;

        /*Functions Dec*/
        vm.getIncomeReport  = getIncomeReport;
        vm.downloadFile     = downloadFile;
        vm.compareDate      = compareDate;
        vm.calculateTotal   = calculateTotal;        
        vm.reinitialize     = reinitialize;
        vm.printRecords     = printRecords;
        vm.getPrintTaxReport= getPrintTaxReport;

        reinitialize();
        function reinitialize(){
            vm.quantity = 0;
            vm.nights = 0;
            vm.subtotal = 0;
            vm.lodging_tax = 0;
            vm.sale_tax = 0;
            vm.total_tax = 0;
            vm.total_amount = 0;
            vm.paid_amount = 0;
            vm.due_amount = 0;
            // vm.overAll[pindex] = {};
        }
        vm.insertedLastRow = false;

        vm.overAll = {};
        function calculateTotal(data, cindex, pindex){
            vm.countLoopElement = vm.countLoopElement + 1;
            if(vm.pindex != pindex){
                reinitialize(pindex);
                vm.pindex = pindex;
            }
            vm.quantity = parseFloat(data.quantity) + parseFloat(vm.quantity);
            vm.nights = parseFloat(data.nights) + parseFloat(vm.nights);
            vm.subtotal = parseFloat(data.sub_total) + parseFloat(vm.subtotal);
            vm.lodging_tax = parseFloat(data.lodgingTax) + parseFloat(vm.lodging_tax);
            vm.sale_tax = parseFloat(data.saleTax) + parseFloat(vm.sale_tax);
            vm.total_tax = parseFloat(data.totalTax) + parseFloat(vm.total_tax);
            vm.total_amount = parseFloat(data.total_amount) + parseFloat(vm.total_amount);
            vm.paid_amount = parseFloat(data.total_paid_amount) + parseFloat(vm.paid_amount);
            vm.due_amount = parseFloat(data.total_remaining_amount) + parseFloat(vm.due_amount);
            
            vm.overAll[pindex] = {};
            vm.overAll[pindex]['quantity'] =  angular.copy(parseFloat(vm.quantity));
            vm.overAll[pindex]['nights'] =  angular.copy(parseFloat(vm.nights));
            vm.overAll[pindex]['subtotal'] =  angular.copy(parseFloat(vm.subtotal));
            vm.overAll[pindex]['lodging_tax'] =  angular.copy(parseFloat(vm.lodging_tax));
            vm.overAll[pindex]['sale_tax'] =  angular.copy(parseFloat(vm.sale_tax));
            vm.overAll[pindex]['total_tax'] =  angular.copy(parseFloat(vm.total_tax));
            vm.overAll[pindex]['total_amount'] =  angular.copy(parseFloat(vm.total_amount));
            vm.overAll[pindex]['paid_amount'] =  angular.copy(parseFloat(vm.paid_amount));
            vm.overAll[pindex]['due_amount'] =  angular.copy(parseFloat(vm.due_amount));
            if (vm.countLoopElement === vm.allData.length) {
                vm.temp_quantity = 0;
                vm.temp_nights = 0;
                vm.temp_subtotal = 0;
                vm.temp_lodging_tax = 0;
                vm.temp_sale_tax = 0;
                vm.temp_total_tax = 0;
                vm.temp_total_amount = 0;
                vm.temp_paid_amount = 0;
                vm.temp_due_amount = 0;
                for (var tempKey in vm.overAll) {
                    vm.temp_quantity = parseFloat(vm.overAll[tempKey]['quantity']) + parseFloat(vm.temp_quantity);
                    vm.temp_nights = parseFloat(vm.overAll[tempKey]['nights']) + parseFloat(vm.temp_nights);
                    vm.temp_subtotal = parseFloat(vm.overAll[tempKey]['subtotal']) + parseFloat(vm.temp_subtotal);
                    vm.temp_lodging_tax = parseFloat(vm.overAll[tempKey]['lodging_tax']) + parseFloat(vm.temp_lodging_tax);
                    vm.temp_sale_tax = parseFloat(vm.overAll[tempKey]['sale_tax']) + parseFloat(vm.temp_sale_tax);
                    vm.temp_total_tax = parseFloat(vm.overAll[tempKey]['total_tax']) + parseFloat(vm.temp_total_tax);
                    vm.temp_total_amount = parseFloat(vm.overAll[tempKey]['total_amount']) + parseFloat(vm.temp_total_amount);
                    vm.temp_paid_amount = parseFloat(vm.overAll[tempKey]['paid_amount']) + parseFloat(vm.temp_paid_amount);
                    vm.temp_due_amount = parseFloat(vm.overAll[tempKey]['due_amount']) + parseFloat(vm.temp_due_amount);
                }
                var overAllTotal = [
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    vm.temp_quantity,
                    '',
                    '',
                    vm.temp_nights,
                    '',
                    '',
                    '',
                    $filter('currency')(vm.temp_subtotal, '$', 2),
                    '',
                    $filter('currency')(vm.temp_lodging_tax, '$', 2),
                    $filter('currency')(vm.temp_sale_tax, '$', 2),
                    $filter('currency')(vm.temp_total_tax, '$', 2),
                    $filter('currency')(vm.temp_total_amount, '$', 2),
                    $filter('currency')(vm.temp_paid_amount, '$', 2),
                    $filter('currency')(vm.temp_due_amount, '$', 2),
                    '',
                    ''
                ];
                if (!vm.insertedLastRow) {
                    vm.insertedLastRow = true;
                    vm.allData.push(overAllTotal);
                }
            }
        }


        function tempVariable() {
            vm.temp_quantity = 0;
            vm.temp_nights = 0;
            vm.temp_subtotal = 0;
            vm.temp_lodging_tax = 0;
            vm.temp_sale_tax = 0;
            vm.temp_total_tax = 0;
            vm.temp_total_amount = 0;
            vm.temp_paid_amount = 0;
            vm.temp_due_amount = 0;
            vm.overAll = {};
        }
        function compareDate(date1, date2,index){
            var startDate = moment(date1);
            var endDate = moment(date2);
            if (startDate > endDate || startDate < endDate) {
                vm.currentDate = date2;
                return true;
            } else {
                return false;
            }
        }
        
        function getIncomeReport(){
            vm.allData = [];
            vm.roomDetails = [];
            vm.noResultFound = true;
            vm.requestProcessing = true;
            vm.insertedLastRow = false;
            vm.countLoopElement = 0;
            reinitialize();
            tempVariable();
            var endDate = moment(vm.endDate).format('YYYY-MM-DD');
            var startDate = moment(vm.startDate).format('YYYY-MM-DD');
            // var endDate = startDate;
            vm.csvName =  'tax-reports'+startDate+'-to-'+endDate+'.csv';
            vm.pdfName =  'tax-reports'+startDate+'-to-'+endDate+'.pdf';
            var range = moment(vm.startDate).format('DD MMMM YYYY') +' - '+moment(vm.endDate).format('DD MMMM YYYY');
            if (moment(vm.startDate).format('DD MMMM YYYY') == moment(vm.endDate).format('DD MMMM YYYY')) {
                range = moment(vm.startDate).format('DD MMMM YYYY');
            }
            vm.month = range;
            vm.reportSelected = 'new';
            reportService.getAllTaxReports({
                startDate: new Date(startDate),
                endDate: new Date(endDate),
                selectedChannels: vm.selectedChannels,
                mode:'listing',
                selectedHotels: vm.selectedHotels,
                reportType: vm.reportSelected,
                requestFor: vm.reportFor
            }).then(function(response){
                vm.first = false;
                if (vm.reportSelected === 'new') {
                    vm.first = false;
                    vm.requestProcessing = false;
                    vm.noResultFound = response['noResultFound'];
                    vm.roomDetails = response['room_details'];
                    vm.paymentsDetails = response['paymentsDetails'];
                    vm.gcDetails = response['gcDetails'];
                    vm.overAllSale = response['overAllSale'];
                    vm.logo = EnvironmentConfig.api+'assets/uploads/hotels/logos/'+response['logo'];
                    vm.overAllTax = response['overAllTaxDetail'];
                    vm.overAllAmount = response['overAllAmountDetail'];
                    vm.staticsReport = response['staticsReport'];
                    vm.staticsReportDescription = response['staticsReportDescription'];
                    vm.advancedDeposit = response['advancedDeposit'];
                    vm.OverAllpercentage = response['OverAllpercentage'];
                    vm.cottagePresent = response['cottagePresent'];
                    vm.cottageData = response['cottageData'];

                    setTimeout(function(){
                        vm.tbodyHeight = document.getElementById('tbodyHeight').clientHeight;
                        vm.initialOffset = $('#table-container').offset().top;
                            vm.table = $('#heightTable');
                            vm.bodyCells = vm.table.find('tbody tr:first').children();
                            vm.colWidth;
                          // Adjust the width of thead cells when window resizes
                            $(window).resize(function() {
                              // Get the tbody columns width array
                                vm.colWidth = vm.bodyCells.map(function() {
                                  return $(this).width();
                            }).get();
                              
                              // Set the width of thead columns
                            vm.table.find('thead tr').children().each(function(i, v) {
                                $(v).width(vm.colWidth[i]);
                            });    
                        }).resize(); // Trigger resize handler

                        vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };

                    },1000);


                } else if (vm.reportSelected === 'old') {
                    tempVariable();
                    vm.requestProcessing = false;
                    vm.noResultFound     = false;
                    vm.taxReport         = response;
                    for (var i in vm.taxReport) {
                        vm.allData = vm.allData.concat(vm.taxReport[i]);
                    }


                    setTimeout(function(){
                        vm.initialOffset = $('#table-container').offset().top;
                        vm.tableOuter = $('#tableOuter');
                        vm.tableInner = $('#tableInner');
                        vm.bodyCells = vm.tableInner.find('tbody tr:first').children();
                        vm.colWidth;
                        // Adjust the width of thead cells when window resizes
                        $(window).resize(function() {
                            // Get the tbody columns width array
                            vm.colWidth = vm.bodyCells.map(function() {
                                return $(this).width();
                            }).get();
                            
                            // Set the width of thead columns
                            vm.tableOuter.find('thead tr').children().each(function(i, v) {
                                $(v).width(vm.colWidth[i]);
                            });    
                        }).resize(); // Trigger resize handler

                        vm.tableOuterStyle = { "max-height" : "calc(100vh - 200px)" };

                    },500);
                    
                    if (vm.allData.length == 0) {
                        vm.noResultFound = true;
                    }
                }
                

            });

        }

        function getPrintTaxReport(pdf){
            vm.requestProcessingPDF = true;
            reportService.getAllTaxReports({
                startDate: moment(vm.startDate).format('YYYY-MM-DD'),
                endDate: moment(vm.endDate).format('YYYY-MM-DD'),
                selectedChannels: vm.selectedChannels,
                selectedHotels: vm.selectedHotels,
                reportType: vm.reportSelected,
                requestFor: vm.reportFor,
                pdf: pdf
            }).then(function(response) {
                vm.requestProcessingPDF = false;
                if(response.status == 'success' && pdf=='pdf'){
                    var filepathToClean = response.data.filepath;
                    var data = {
                        filename:response.data.filename,
                        filepath:response.data.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        //return;
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
                            lodgingStatistic.cleanDisk(cleanData);
                        }, 2000);
                    });
                } 
            });
        }
        
        function printRecords(){
            $mdDialog.show({
                controller: 'getEmailAddress',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/reports/getEmailAddress.html',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose:true ,
            }).then(function(answer) {
               // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if(typeof answer != 'undefined'){
                    var endDate = new Date(moment(vm.startDate).format('YYYY-MM-DD'));
                    var startDate = new Date(moment(vm.startDate).format('YYYY-MM-DD'));
                    vm.csvName =  'tax-reports'+startDate+'-to-'+startDate+'.csv';
                    reportService.getAllTaxReports({
                        startDate: startDate,
                        endDate: startDate,
                        selectedChannels: vm.selectedChannels,
                        mode: 'sendEmail',
                        emailAddress: answer,
                        selectedHotels: vm.selectedHotels,
                        reportType: vm.reportSelected,
                        requestFor: vm.reportFor

                    }).then(function(response){
                        vm.requestProcessingEmail = false;
                    });
                }
            }, function() {});
        }

        /**
        *validate end date
        */
        vm.ChangeEndDayIf = function(){
            if(!moment(vm.endDate).isAfter(vm.startDate) || moment(vm.endDate).isSame(vm.startDate)){
                vm.endDate = moment(vm.startDate).add(0, 'days').format('MM/DD/YYYY');
            }
        }

        /**
        *Download the given file in csv/pdf
        */

        function downloadFile(id){
            vm.printRequest = true;
            vm.print = true;
            var innerContents = document.getElementById(id).innerHTML;
            var myWindow=window.open('','','', '');
            myWindow.document.write(innerContents);
            myWindow.print();
            myWindow.document.close();
            myWindow.focus();
            vm.printRequest = false;
            vm.print = false;
        }

        vm.reportTypeChange = function() {
            vm.noResultFound = true;
        }

        /**
        * download csv file
        */
        vm.downloadCsvFile = function(fileName) {
            var csvString = '';
            var dateValue = vm.month;
            var mainHeading = vm.reportFor == 'boat' ? 'Marina Details' : 'Room Details';

            csvString += ','+ mainHeading +',,' + "\n";
            var reportForName = vm.reportFor == 'boat' ? 'Marina Name' : 'Room Name';
            var reportTypeTitle = vm.reportFor == 'boat' ? 'Marina' : 'Rooms';
            csvString += reportForName+',Before Tax,Tax,After Tax' + "\n";
            var roomName, befTax, tax, aftTax;
            angular.forEach(vm.roomDetails, function(value, key) {
                // roomName = (value.name.indexOf(',') != -1) ? value.name.replace(/,/g,' ') : value.name;
                // if (value.name != 'Total') {
                //     befTax   = value.subTotal.indexOf(',') != -1 ? value.subTotal.replace(/,/g,'') : value.subTotal;
                // } else {
                //     befTax   = value.STT.indexOf(',') != -1 ? value.STT.replace(/,/g,'') : value.STT;
                // }

                // if (value.name != 'Total') {
                //     tax   = value.taxPaid.indexOf(',') != -1 ? value.taxPaid.replace(/,/g,'') : value.taxPaid;
                // } else {
                //     tax   = value.TPT.indexOf(',') != -1 ? value.TPT.replace(/,/g,'') : value.TPT;
                // }

                // if (value.name != 'Total') {
                //     aftTax   = value.grandTotal.indexOf(',') != -1 ? value.grandTotal.replace(/,/g,'') : value.grandTotal;
                // } else {
                //     aftTax   = value.GTT.indexOf(',') != -1 ? value.GTT.replace(/,/g,'') : value.GTT;
                // }

                // csvString += roomName + ',' + befTax + ',' + tax +',' +aftTax + "\n";
                csvString += value.name + ',' + value.subTotal + ',' + value.taxPaid +',' +value.grandTotal + "\n";
            });

            csvString = csvString + "\n";
            csvString = csvString + "\n";
            csvString += ','+reportTypeTitle+' Tax Report For '+dateValue+',,' + "\n";
            csvString += 'Type,Amount' + "\n";
            angular.forEach(vm.staticsReport, function(value, key) {
                csvString += key + ',' +value + "\n";
            });

            csvString = csvString + "\n";
            csvString = csvString + "\n";
            csvString += ','+reportTypeTitle+' Gift Certificates for '+dateValue+',,' + "\n";
            csvString += 'Type,Amount' + "\n";
            angular.forEach(vm.gcDetails, function(value, key) {
                csvString += key + ',' +value + "\n";
            });

            csvString = csvString + "\n";
            csvString = csvString + "\n";
            csvString += ','+reportTypeTitle+' Sales for '+dateValue+',,' + "\n";
            csvString += 'Type,Before Taxes,Taxes,Amount' + "\n";
            angular.forEach(vm.overAllSale, function(value, key) {
                csvString += value.type + ',' +value.subtotal + ',' +value.taxes + ',' +value.grand_total + "\n";
            });

            csvString = csvString + "\n";
            csvString = csvString + "\n";
            csvString += ','+reportTypeTitle+' Advance Deposit Liabilities for '+dateValue+',' + "\n";
            csvString += 'Type,Amount' + "\n";
            csvString += 'Advance Deposit Liabilities,' + vm.advancedDeposit + "\n";
            
            csvString = csvString + "\n";
            csvString = csvString + "\n";
            csvString += ','+reportTypeTitle+' Payments And Refunds for '+dateValue+',,' + "\n";
            csvString += 'Payment Method,Payment,Refunded,Total' + "\n";
            angular.forEach(vm.paymentsDetails, function(value, key) {
                if (key != 'Type') {
                    csvString += key + ',' +value.paid + ',' + value.refund + ',' + value.total + "\n";
                }
            });

            csvString = csvString + "\n";
            csvString = csvString + "\n";
            csvString += ','+reportTypeTitle+' Taxes for '+dateValue+',,' + "\n";
            csvString += 'Tax Name,Tax Percentage,Sale Amount,Tax Collected,Final Tax' + "\n";
            angular.forEach(vm.overAllAmount, function(value, key) {
                csvString += key + ',' + vm.OverAllpercentage[key] + ',' + vm.overAllAmount[key] + ',' + vm.overAllTax[key] + ',' + vm.overAllTax[key] + "\n";
            });
            
            var a = $('<a/>', {
                style:'display:none',
                href: "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvString),
                download:fileName
            }).appendTo('body')
            a[0].click()
            a.remove(); 
        };
    }    
})();
(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('taxReportNewController', taxReportNewController);

    /** @ngInject */
    function taxReportNewController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $filter,
       $mdDialog,
       $rootScope,
       $state,
       $window,
       $localStorage
    ){
        var vm = this;
        vm.report = {};
        vm.initialDate = new Date('2019', '00', '01');
        vm.showGeneratingFlag = false;

        vm.hotelID = $localStorage['preHotelId'];        
        vm.reportFor = 'hotel';
        vm.selectedPaymentMethods = [];
      
        vm.myDate = new Date();
        vm.startDate = new Date(this.myDate.getFullYear(), this.myDate.getMonth(), this.myDate.getDate());
        vm.endDate = new Date(this.myDate.getFullYear(), this.myDate.getMonth(), this.myDate.getDate());
        
        vm.selectedHotels = [];
        vm.noResultFound = true;
        vm.requestProcessing = false;   

        /*Functions Dec*/
        vm.getIncomeReport  = getIncomeReport;
        vm.downloadFile     = downloadFile;
        vm.getPrintTaxReport= getPrintTaxReport;        
        
        function getIncomeReport(){
            vm.noResultFound = true;
            vm.requestProcessing = true;
            vm.showGeneratingFlag = true;

            var endDate = moment(vm.endDate).format('YYYY-MM-DD');
            var startDate = moment(vm.startDate).format('YYYY-MM-DD');
           
            vm.csvName =  'tax-reports'+startDate+'-to-'+endDate+'.csv';
            vm.pdfName =  'tax-reports'+startDate+'-to-'+endDate+'.pdf';
            var range = moment(vm.startDate).format('DD MMMM YYYY') +' - '+moment(vm.endDate).format('DD MMMM YYYY');
            if (moment(vm.startDate).format('DD MMMM YYYY') == moment(vm.endDate).format('DD MMMM YYYY')) {
                range = moment(vm.startDate).format('DD MMMM YYYY');
            }
            vm.month = range;
            reportService.getFactsTaxReport({
                start: new Date(startDate),
                end: new Date(endDate),
                mode:'listing',
                selected_hotel: vm.selectedHotels,
                reportFor: vm.reportFor,
                selectedPaymentMethods:vm.selectedPaymentMethods,
            }).then(function(response){
                if (vm.reportFor == 'hotel') {
                    vm.reportTitle = 'Rooms';
                } else if (vm.reportFor == 'boat') {
                    vm.reportTitle = 'Marina';
                } else if (vm.reportFor == 'rent') {
                    vm.reportTitle = 'Rent';
                }

                vm.showGeneratingFlag = false;
                vm.requestProcessing = false;
                vm.noResultFound   = response['noResultFound'];
                vm.taxReportData   = response.data;
                vm.roomDetails     = response.data.resvDetail;

                vm.roomDetails.sort(function(a, b) {
                    if (a.product_name === 'Total') return 1;
                    if (b.product_name === 'Total') return -1;

                    var numA = parseInt(a.product_name.match(/\d+$/));
                    var numB = parseInt(b.product_name.match(/\d+$/));

                    return numA - numB;
                });

                vm.staticsReport   = response.data.statistics;
                vm.paymentsDetails = response.data.paymentDetails;
                vm.gcDetails       = response.data.giftCard;
                vm.overAllSale     = response.data.overAllSale;
                vm.logo            = EnvironmentConfig.api+'assets/uploads/hotels/logos/'+response.data.logo;
                vm.overAllTax      = response.data.taxes;
                vm.advancedDeposit = response.data.advDeposit;
                vm.taxAvailable    = Object.keys(vm.overAllTax).length > 0 ? true : false;
             
                setTimeout(function(){
                    vm.tbodyHeight = document.getElementById('tbodyHeight').clientHeight;
                    vm.initialOffset = $('#table-container').offset().top;
                        vm.table = $('#heightTable');
                        vm.bodyCells = vm.table.find('tbody tr:first').children();
                        vm.colWidth;
                        // Adjust the width of thead cells when window resizes
                        $(window).resize(function() {
                          // Get the tbody columns width array
                            vm.colWidth = vm.bodyCells.map(function() {
                              return $(this).width();
                            }).get();                          
                          // Set the width of thead columns
                        vm.table.find('thead tr').children().each(function(i, v) {
                            $(v).width(vm.colWidth[i]);
                        });    
                    }).resize(); // Trigger resize handler
                    vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };
                },1000);
            });
        }

        /**
        * make pdf file
        */
        function getPrintTaxReport(pdf){
            vm.requestProcessingPDF = true;
            reportService.getTaxReportPdf({
                startDate: moment(vm.startDate).format('YYYY-MM-DD'),
                endDate: moment(vm.endDate).format('YYYY-MM-DD'),
                selectedHotels: vm.selectedHotels,
                reportFor: vm.reportTitle,
                data: vm.taxReportData,
                selectedPaymentMethods:vm.selectedPaymentMethods,
            }).then(function(response) {
                vm.requestProcessingPDF = false;
                if (response.status == 'success') {
                    var filepathToClean = response.data.filepath;
                    var data = {
                        filename:response.data.filename,
                        filepath:response.data.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
                            lodgingStatistic.cleanDisk(cleanData);
                        }, 2000);
                    });
                } 
            });
        }
        
        /**
        *validate end date
        */
        vm.ChangeEndDayIf = function(){
            if(!moment(vm.endDate).isAfter(vm.startDate) || moment(vm.endDate).isSame(vm.startDate)){
                vm.endDate = moment(vm.startDate).add(0, 'days').format('MM/DD/YYYY');
            }
        }

        /**
        *Download the given file in csv/pdf
        */
        function downloadFile(id){
            vm.printRequest = true;
            vm.print = true;
            var innerContents = document.getElementById(id).innerHTML;
            var myWindow=window.open('','','', '');
            myWindow.document.write(innerContents);
            myWindow.print();
            myWindow.document.close();
            myWindow.focus();
            vm.printRequest = false;
            vm.print = false;
        }

        /**
        * download csv file
        */
        vm.downloadCsvFile = function(fileName) {
            var csvString = '';
            var dateValue = vm.month;

            csvString += ','+ vm.reportTitle+" Details" +',,' + "\n";
            csvString += vm.reportTitle+" Name"+',Before Tax,Tax,After Tax' + "\n";
            var roomName;
            angular.forEach(vm.roomDetails, function(value, key) {
                roomName = value.product_name.replace(/,/g," ");
                csvString += roomName + ',' + value.subTotal + ',' + value.tax +',' +value.grandTotal + "\n";
            });

            csvString = csvString + "\n";
            csvString += ','+vm.reportTitle+' Occupancy Report For '+dateValue+',,' + "\n";
            csvString += 'Type,Amount' + "\n";
            angular.forEach(vm.staticsReport, function(value, key) {
                csvString += value.type + ',' +value.value + "\n";
            });

            csvString = csvString + "\n";
            csvString += ', Gift Certificates for '+dateValue+',,' + "\n";
            csvString += 'Type,Amount' + "\n";
            angular.forEach(vm.gcDetails, function(value, key) {
                csvString += "Gift Certificate"+key + ',' +value + "\n";
            });

            csvString = csvString + "\n";
            csvString += ','+vm.reportTitle+' Sales for '+dateValue+',,' + "\n";
            csvString += 'Type,Before Taxes,Taxes,Amount' + "\n";
            angular.forEach(vm.overAllSale, function(value, key) {
                csvString += value.type + ',' +value.subTotal + ',' +value.tax + ',' +value.grandTotal + "\n";
            });

            csvString = csvString + "\n";
            csvString += ','+vm.reportTitle+' Advance Deposit Liabilities for '+dateValue+',' + "\n";
            csvString += 'Type,Amount' + "\n";
            csvString += 'Advance Deposit Liabilities,' + vm.advancedDeposit + "\n";
            
            csvString = csvString + "\n";
            csvString += ','+vm.reportTitle+' Payments And Refunds for '+dateValue+',,' + "\n";
            csvString += 'Payment Method,Payment,Refunded,Total' + "\n";
            angular.forEach(vm.paymentsDetails, function(value, key) {
                csvString += value.type + ',' +value.paid + ',' + value.refund + ',' + value.total + "\n";
            });

            csvString = csvString + "\n";
            csvString += ','+vm.reportTitle+' Taxes for '+dateValue+',,' + "\n";
            csvString += 'Tax Name,Tax Percentage,Sale Amount,Tax Collected,Final Tax' + "\n";
            angular.forEach(vm.overAllTax, function(value, key) {
                csvString += value.name + ',' + value.percentage + ',' + value.amount + ',' + value.taxAmount + ',' + value.taxAmount + "\n";
            });
            
            var a = $('<a/>', {
                style:'display:none',
                href: "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvString),
                download:fileName
            }).appendTo('body')
            a[0].click()
            a.remove(); 
        };

        /**
        * Comment: Go to detail page
        */
        vm.showTaxDetail = function(detail, index) {
            var showDetail = true;
            var searchedIndex;
            if (index == 'roomDetail') {
                showDetail = detail.subTotal != undefined && parseFloat(detail.subTotal) == 0 ? false : true;
                searchedIndex = detail.product_id;
            } else if (index == 'roomNights') {
                searchedIndex = detail;
                if (detail == 'occupancy_percentage' || detail == 'average_daily_rate') {
                    showDetail = false;
                } else if (detail == 'total_room_nights' || detail == 'room_night_out_of_service' || detail == 'total_room_available') {
                    var compDate = new Date("2020-02-01");
                    var fromDate = new Date(moment(vm.startDate).format('YYYY-MM-DD'));
                    if (fromDate < compDate) { // complete logs not avail before this date
                        showDetail = false;
                    }
                }
            } else if (index == 'overAllSale') {
                showDetail = detail.subTotal != undefined && parseFloat(detail.subTotal) == 0 ? false : true;
                searchedIndex = detail.type.replace(/ /g,"_");
            } else if (index == 'giftCard') {
                showDetail = vm.gcDetails[detail] != undefined && parseFloat(vm.gcDetails[detail]) == 0 ? false : true;
                searchedIndex = detail;
            } else if (index == 'payment') {
                searchedIndex = detail.type;
            } else if (index == 'advanceDeposit') {
                showDetail = vm.advancedDeposit != undefined && parseFloat(vm.advancedDeposit) == 0 ? false : true;
                searchedIndex = 'advanceDeposit';
            } else {
                searchedIndex = detail;
            }
            
            if (searchedIndex == undefined || searchedIndex == null) {
                return false;
            }
            var hotels = ''; 
            if (vm.selectedHotels.length) {
                for (var i = 0; i < vm.selectedHotels.length; i++) {
                    hotels += vm.selectedHotels[i];
                    if (i != vm.selectedHotels.length- 1) {
                        hotels += "=";
                    }
                }
            }
            if (hotels != '') {
                hotels = btoa(hotels);
            }

            if (showDetail) {
                vm.reportFor = vm.reportFor != undefined && vm.reportFor != '' ? vm.reportFor : 'hotel';
                var getData = 'taxReport&'+index+'&'+moment(vm.startDate).format('YYYY-MM-DD')+'&'+moment(vm.endDate).format('YYYY-MM-DD')+'&'+vm.reportFor;
                getData += "&"+btoa(searchedIndex);
                if (hotels != '') {
                    getData += "&"+hotels;
                }
                var url = $state.href("app.reports.detail",{param:getData});
                $window.open(url, '_blank');
            }
        };
    }    
})();
(function () {
	'use strict';

	angular
		.module('app.reports')
		.factory('promoCode', promoCode);

	/** @ngInject */
	function promoCode(msApi, $http, EnvironmentConfig) {
		function getDataFailed(error) {
			return error.data;
		}

		function getDataComplete(response) {
			return response.data;
		}

		function getAllPromoCodes(data) {
			return $http({
				url: EnvironmentConfig.api + 'Promotions/get_promotions',
				method: 'POST',
				data: data
			})
				.then(getDataComplete)
				.catch(getDataFailed);
		}

		function getPromoList(data) {
			return $http({
				url: EnvironmentConfig.api + 'Reports/getPromoCodeReportData',
				method: 'POST',
				data: data,
			})
				.then(getDataComplete)
				.catch(getDataFailed);
		}

		function downloadDataRequest(data) {
			return $http({
				url: EnvironmentConfig.api + 'Reports/download_data_request',
				method: 'POST',
				responseType: 'blob',
				data: data
			})
				.then(getDataComplete)
				.catch(getDataFailed);
		}
		function cleanDisk(data) {
			return $http({
				url: EnvironmentConfig.api + 'Reports/remove_file',
				method: 'POST',
				data: data
			})
				.then(getDataComplete)
				.catch(getDataFailed);
		}

		var service = {
			getAllPromoCodes: getAllPromoCodes,
			getPromoList: getPromoList,
			downloadDataRequest: downloadDataRequest,
			cleanDisk: cleanDisk,
		};
		return service;
	}

})();

(function ()
{
    'use strict';

    angular
    .module('app.reports')
    .factory('lodgingStatistic', lodgingStatistic);

    /** @ngInject */
    function lodgingStatistic(msApi, $http,EnvironmentConfig)
    {
        function getDataFailed(error) {
			return error.data;
		}

		function getDataComplete(response) {
			return response.data;
		}

		function getlodgingData(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/getlodgingData',
				method:'POST',
				data:data,
				headers: { 'Content-Type': undefined },
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function getCurrentDepartureReservations(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/DepartureReports',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		// function downloadGdprEmail(){
		// 	return $http({
		// 		url:EnvironmentConfig.api+'Reports/getlodgingData',
		// 		method:'POST',
		// 		data:data,
		// 		headers: { 'Content-Type': undefined },
		// 	})
		// 	.then(getDataComplete)
		// 	.catch(getDataFailed);
		// }
		function download_data_request(data) {
	 		return $http({
	 			url:EnvironmentConfig.api+'Reports/download_data_request',
	 			method:'POST',
	 			responseType: 'blob',
	 			data:data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}
	 	
	 	function cleanDisk(data) {
	 		return $http({
	 			url:EnvironmentConfig.api+'Reports/remove_file',
	 			method:'POST',
	 			data:data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}

	 	function getcustomreports(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/getHoldBlockHotelData',
				method:'POST',
				data:data,
				headers: { 'Content-Type': undefined },
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function getFactsLodgingData(data) {
			var url;
			if (data.factReport == 'old') {
				url = EnvironmentConfig.api+'Reports/getlodgingData';
			} else {
				url = EnvironmentConfig.api+'Factreports/getlodgingStatsReport';
			}
			return $http({
				url:url,
				method:'POST',
				data:data,
				headers: { 'Content-Type': undefined },
			})
			.then(getDataComplete)
			.catch(getDataFailed);

		}

		function getLodgingStatsDetail(data) {
			return $http({
				url:EnvironmentConfig.api+'Factreports/getLodgingStatsDetail',
				method:'POST',
				data:data,
				headers: { 'Content-Type': undefined },
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
	 	
	 	function getNightAuditDetail(data) {
	 		return $http({
				url:EnvironmentConfig.api+'Factreports/getNightAuditDetail',
				method:'POST',
				data:data,
				headers: { 'Content-Type': undefined },
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	 	}

	 	function getTaxReportDetail(data) {
	 		return $http({
				url:EnvironmentConfig.api+'Factreports/getTaxReportDetail',
				method:'POST',
				data:data,
				headers: { 'Content-Type': undefined },
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	 	}

		function getRevenueManagementReport(data) {
			return $http({
				url:EnvironmentConfig.api+'Factreports/getRevenueManagementReport',
				method: 'POST',
				data: data,
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

    var service = {
			getlodgingData: getlodgingData,
			getCurrentDepartureReservations: getCurrentDepartureReservations,
			download_data_request:download_data_request,
			cleanDisk:cleanDisk,
			getcustomreports:getcustomreports,
			getFactsLodgingData: getFactsLodgingData,
			getLodgingStatsDetail: getLodgingStatsDetail,
			getNightAuditDetail: getNightAuditDetail,
			getTaxReportDetail: getTaxReportDetail,
			getRevenueManagementReport: getRevenueManagementReport
		};
		return service;
}

})();

'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../mls/mlsService
 * @description
 * # ../mls/mlsService
 * Service in the minervaApp.
 */
angular.module('app.reports')
  .service('reportService', function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
 	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}
 	
 	function printSingleOrder(data){
		return $http({
			url:EnvironmentConfig.api+'Reports/printSingleOrder',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getCurrentDepartureReservations(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/DepartureReports',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}
	function getAllCurrentreservation(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/getAllCurrentReservations',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}
	function getAllRoomMoves(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/getAllRoomMove',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}
	function getCourtesyHoldReport(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/getCourtesyHoldReport',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}
	function getAllChannels(){
			return $http({
				url:EnvironmentConfig.api+'Reports/getAllChannels',
				method:'GET'
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}
	function getAllIncomeReports(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/getAllIncomeReports',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}
	function getCustomerAdvancedReports(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/getCustomerAdvancedReports',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}
	function getEmployeeReports(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/getEmployeeReports',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}
	function getGiftCards(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/getGiftCards',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}
	function getAllPaymentReceived(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/getAllPaymentReceived',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}
	function sendSubscribersReport(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/sendSubscribersReport',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}

	function getInvoiceData(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/getInvoiceData',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}

	function getAllRetailReports(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/getAllRetailReports',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}

	function getRoomPosProducts(){
			return $http({
				url:EnvironmentConfig.api+'Reports/getRoomPosProducts',
				method:'GET'
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}

	function getAllTaxReports(data){
		var url = EnvironmentConfig.api+'Reports/getAllTaxReports';
		if (data.reportType !== undefined && data.reportType === 'old') {
			url = EnvironmentConfig.api+'Reports/getPreviousTaxReport';
		}
		return $http({
			url: url,
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getAllNightAudit(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/getAllNightAudit',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}
	function getAllGiftCardRegistrationCard(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/getAllGiftCardRegistrationCard',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}
	function printAllRegistrationCard(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/printAllRegistrationCard',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}
	function getReservationId(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/getReservationId',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}
	function getSubHotels(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/getSubHotels',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}
	function lightCleaningReport(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/getLightCLeaningReservations',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}

	/**
	* @params: Object  data
	* Fetch m3 report for hotel
	*/

	function getM3AuditReport(data) {
		return $http({
			url: EnvironmentConfig.api+'Reports/getM3AuditReport',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getZeroNightlyRatesReservations(data) {
		return $http({
			url: EnvironmentConfig.api+'Reports/getZeroNightlyRatesReservations',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getNightAuditNew(data){
		return $http({
			url:EnvironmentConfig.api+'factreports/getNightAuditData',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getAllNightAuditFormatSkipjack(data){
			return $http({
				url:EnvironmentConfig.api+'Reports/getAllNightAuditFormatSkipjack',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
	}

	/**
	* @params: Object  data
	* Fetch m3 report for hotel
	*/

	function getM3AuditReportNew(data) {
		return $http({
			url: EnvironmentConfig.api+'Reports/getM3AuditReportNew',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* @params: Object  data
	* Fetch reservation of hotels by employees
	*/
	function getReservationSalesByEmployee(data) {
		return $http({
			url: EnvironmentConfig.api+'Reports/getReservationSalesByEmployee',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* @params: Object  data
	* Fetch ota reservations original data
	*/
	function getAllReconcillationOTA(data) {
		return $http({
			url: EnvironmentConfig.api+'Reports/getAllReconcillationOTA',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getNightAuditPdfCsv(data) {
		return $http({
			url:EnvironmentConfig.api+'factreports/getNightAuditPdfCsv',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
	function getFactsTaxReport(data){
		return $http({
			url: EnvironmentConfig.api+'factreports/getFactsTaxReport',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
	function getTaxReportPdf(data) {
		return $http({
			url: EnvironmentConfig.api+'factreports/getFactsTaxReportPdf',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getAvailabilityReport(data) {
		return $http({
			url: EnvironmentConfig.api+'factreports/getAvailabilityReport',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getAvailabilityReportPdfCsv(data) {
		return $http({
			url:EnvironmentConfig.api+'factreports/getAvailabilityReportPdfCsv',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getReportPermissions(type) {
		return $http({
			url:EnvironmentConfig.api+'reports/getReportPermissions/'+type,
			method:'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

 	return{
 		printSingleOrder: printSingleOrder,
 		getCurrentDepartureReservations: getCurrentDepartureReservations,
 		getAllCurrentreservation: getAllCurrentreservation,
 		getAllRoomMoves: getAllRoomMoves,
 		getCourtesyHoldReport: getCourtesyHoldReport,
 		getAllChannels: getAllChannels,
 		getAllIncomeReports: getAllIncomeReports,
 		getCustomerAdvancedReports: getCustomerAdvancedReports,
 		getEmployeeReports: getEmployeeReports,
 		getGiftCards: getGiftCards,
 		getAllPaymentReceived: getAllPaymentReceived,
		sendSubscribersReport: sendSubscribersReport,
 		getInvoiceData: getInvoiceData,
 		getAllRetailReports: getAllRetailReports,
		getRoomPosProducts: getRoomPosProducts,
 		getAllTaxReports: getAllTaxReports,
 		getAllNightAudit: getAllNightAudit,
 		getAllGiftCardRegistrationCard: getAllGiftCardRegistrationCard,
 		printAllRegistrationCard: printAllRegistrationCard,
 		getReservationId: getReservationId,
 		getSubHotels: getSubHotels,
 		lightCleaningReport: lightCleaningReport,
 		getM3AuditReport: getM3AuditReport,
 		getZeroNightlyRatesReservations: getZeroNightlyRatesReservations,
 		getNightAuditNew:getNightAuditNew,
 		getM3AuditReportNew : getM3AuditReportNew,
 		getAllNightAuditFormatSkipjack:getAllNightAuditFormatSkipjack,
 		getAllReconcillationOTA: getAllReconcillationOTA,
 		getReservationSalesByEmployee: getReservationSalesByEmployee,
 		getNightAuditPdfCsv: getNightAuditPdfCsv,
 		getFactsTaxReport: getFactsTaxReport,
 		getTaxReportPdf: getTaxReportPdf,
 		getAvailabilityReport: getAvailabilityReport,
 		getAvailabilityReportPdfCsv: getAvailabilityReportPdfCsv,
 		getReportPermissions: getReportPermissions
 	}
 });

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('salesByEmployeeController', salesByEmployeeController)
        .filter('split', function() {
              return function(input, splitChar, splitIndex) {
                  // do some bounds checking here to ensure it has that index
                  return input.split(splitChar)[splitIndex];
              }
          });

    /** @ngInject */
    function salesByEmployeeController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $localStorage,
       $filter,
       $rootScope,
       userPermission
    ){
        var vm = this;
        vm.selectedHotels = [];
        vm.from = new Date();
        vm.to = new Date();

        vm.previousDayPermission = userPermission.previousDayPermission != undefined ? userPermission.previousDayPermission : false;
        if (!vm.previousDayPermission) {
            vm.minDate = new Date();
        } else {
            vm.minDate = '';
        }
		    vm.showGeneratingFlag = false;
        vm.hotelID = $localStorage['preHotelId'];
        vm.reportFor = 'reservation';
        vm.initialOffset = 0;
        vm.tbodyHeight = 0;              

        // Change the selector if needed
        vm.tableStyle = {};
        vm.table;
        vm.bodyCells;
        vm.colWidth;


        vm.generateSales = generateSales;

        // Generate Sales by employees
        function generateSales() {
            vm.showGeneratingFlag = true;
            reportService.getReservationSalesByEmployee({
                from:moment(vm.from).format('YYYY-MM-DD'),
                to:moment(vm.to).format('YYYY-MM-DD'),
                'selectedHotels':vm.selectedHotels,
                reportFor: vm.reportFor
            }).then(function(response){
                vm.showGeneratingFlag = false;
                vm.agentKeys = Object.keys(response.salesByAgents);
                if(vm.agentKeys.length > 0) {
                    vm.salesByAgents = response.salesByAgents;
                } else {
                    vm.salesByAgents = [];
                }
                setTimeout(function(){              
                    angular.forEach(vm.salesByAgents, function(key,value){
                      var childKey = value.split(' ')[0];
                      vm.tbodyHeight = document.getElementsByClassName('tbodyHeight'+childKey).clientHeight;
                      vm.initialOffset = $('#table-container').offset().top;
                        vm.table = $('.heightTable'+childKey);
                        vm.bodyCells = vm.table.find('tbody tr:first').children();
                        vm.colWidth;
                      // Adjust the width of thead cells when window resizes
                      $(window).resize(function() {
                          // Get the tbody columns width array
                          vm.colWidth = vm.bodyCells.map(function() {
                              return $(this).width();
                          }).get();
                          
                          // Set the width of thead columns
                          vm.table.find('thead tr').children().each(function(i, v) {
                              $(v).width(vm.colWidth[i]);
                          });    
                      }).resize(); // Trigger resize handler

                      vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };
                    });
                },0);
            });
        }

        // Export as PDF
        vm.exportFile = exportFile;
        vm.exportLoader = false;
        vm.csvLoader = false;
        function exportFile(type) {
            var fromDate = moment(vm.from).format('YYYY-MM-DD');
            var toDate = moment(vm.to).format('YYYY-MM-DD');
            if(type == 'pdf') {
                vm.exportLoader = true;
            } else {
                vm.csvLoader = true;
            }
            reportService.getReservationSalesByEmployee({
                from:fromDate,
                to:toDate,
                'selectedHotels':vm.selectedHotels,
                reportFor: vm.reportFor,
                type: type
            }).then(function(response){
                if(type == 'pdf') {
                    vm.exportLoader = false;
                    var filepathToClean = response.data.filepath;
                    var data = {
                        filename:response.data.filename,
                        filepath:response.data.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
                            lodgingStatistic.cleanDisk(cleanData);
                        }, 2000);
                    });
                } else {
                    vm.csvLoader = false;
                    vm.csvHeader = ['Itinerary','Confirmation','Type', 'Product', 'From','To','Created','Status', 'Customer', 'Subtotal','Grand Total', 'Paid', 'Remaining'];
                    vm.csvData = response;
                    if(fromDate === toDate) {
                        vm.csvName = 'sales-by-employees-'+ moment(fromDate).format('MM-DD-YYYY') + '.csv';
                    } else {
                        vm.csvName = 'sales-by-employees-'+ moment(fromDate).format('MM-DD-YYYY') + '-' + moment(toDate).format('MM-DD-YYYY') +  '.csv';
                    }
                    $rootScope.downloadFile(vm.csvHeader, vm.csvData, vm.csvName);
                }
            });
        }

        vm.checkSchedule = function(type) {
            if(type == 'from') {
                vm.to = vm.from;
                var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds    
                vm.numberOfDays = Math.round(Math.abs((vm.from.getTime() - vm.to.getTime())/(oneDay)));
                if(vm.numberOfDays > 30) {
                    vm.numberOfDays = 30;
                }
                vm.startDate = new Date(vm.from);
                vm.newEndDate = vm.startDate;
                vm.newEndDate.setDate(this.newEndDate.getDate() + 30);
                vm.endDate = vm.startDate;
                vm.endDate.setDate(this.endDate.getDate() + vm.numberOfDays);
            }
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('roomMoveController', roomMoveController);

    /** @ngInject */
    function roomMoveController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $localStorage
    ){
        var vm = this;
		vm.report = {};
        vm.allIds = [];
        vm.all = [];
        vm.csvHeader = ['Itinerary',
                        'Old confirmation number',
                        'New confirmation number',
                        'Old room',
                        'New room',
                        'Business Entity',
                        'Date',
                        'Amount Moved',
                        'Guest',
                        'Number of guest'];


        vm.csvHeaderInterHotel = ['Itinerary',
                        'Old confirmation number',
                        'New confirmation number',
                        'Old room',
                        'New room',
                        'Date',
                        'Amount Moved'];

        vm.myDate = new Date();
        vm.startDate = new Date(
                                    this.myDate.getFullYear(),
                                    this.myDate.getMonth(),
                                    this.myDate.getDate()
                                  );
        vm.endDate = angular.copy(vm.startDate);
        vm.csvNameInterHotel = 'inter-hotel-room-move'+ vm.startDate + '.csv';

        /*Functions Dec*/
        vm.getReports = getReports;
        vm.getRoomMoves = getRoomMoves;
        vm.noDataFound = false;
        vm.selectedHotels = [];
        vm.isParent = false;
        vm.paidInDifferentRoom = [];



        vm.showReportFor = false;
        vm.reportFor = 'all';
        if($localStorage['preHotelId'] !== undefined && $localStorage['preHotelId'] == 126){
          vm.reportFor = 'reservation';
          vm.showReportFor = true;
        }

		// getRoomMoves();
        function getReports(){
            vm.all = [];
            reportService.getAllCurrentreservation({
                startDate:new Date(moment(vm.startDate).format('YYYY-MM-DD')),
                endDate:new Date(moment(vm.endDate).format('YYYY-MM-DD'))
            }).then(function(response){
                vm.arrivals = response['arrivals'];
                vm.departure = response['departure'];
                vm.stayovers = response['stayovers'];
                vm.all = vm.all.concat(vm.arrivals); 
                vm.all = vm.all.concat(vm.departure);
                vm.all = vm.all.concat(vm.stayovers); 
            });

        }
        function getRoomMoves(pdf, type){
            // console.log("asdasd");
            var startDate = moment(vm.startDate).format('YYYY-MM-DD');
            var endDate = moment(vm.endDate).format('YYYY-MM-DD');
            vm.csvName = 'room-move-'+ startDate + '.csv';
            vm.pdfName = 'room-move-'+ startDate + '.pdf';
            reportService.getAllRoomMoves({
                startDate:new Date(startDate),
                endDate:new Date(endDate),
                'selectedHotels':vm.selectedHotels,
                reportFor: vm.reportFor,
                pdf: pdf,
                type: type,
            }).then(function(response){
                if(response['status'] == 'success' && pdf=='pdf'){
                    console.log(response);
                    var filepathToClean = response.data.filepath;
                    var data = {
                        filename:response.data.filename,
                        filepath:response.data.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        //return;
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
                            lodgingStatistic.cleanDisk(cleanData);
                        }, 2000);
                    });
                } else if(response['roomMove'].length > 0){
                    vm.roomMove = response['roomMove'];
                    vm.noDataFound = false;
                    vm.isParent = response['is_parent'];
                    vm.roomMoveInterHotel = response['paid_in_diferrent_room'];
                    vm.paidInDifferentRoom = response['paid_in_diferrent_room'];
                } else {
                    vm.roomMove = [];
                    vm.noDataFound = true;
                    vm.isParent = false;
                    vm.paidInDifferentRoom = [];
                }
            });

        }    

    }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('retailReportController', retailReportController);

    /** @ngInject */
    function retailReportController(
        $scope,
        $http,
        EnvironmentConfig,
        toastMessage,
        lodgingStatistic,
        commonService,
        reportService,
        $timeout,
        $filter,
        $mdDialog,
        $localStorage
    ) {
        var vm = this;

        vm.addTableClass = false;
        vm.removeClass = false;
        vm.prevScroll = 0;
        vm.initialOffset = 0;
        vm.tbodyHeight = 0;       

        // Change the selector if needed
        vm.tableOuterStyle = {};
        vm.tableOuter;
        vm.bodyCells;
        vm.colWidth;
        vm.tableInner;

        vm.report = {};
        vm.retailType = 'all';
        vm.allIds = [];
        vm.selectedChannels = [];
        vm.roomPosOptions = [];
        vm.selectedRoomPos = [];
        vm.roomPosSearchText = '';
        vm.loadingRoomPosOptions = false;
        vm.roomPosOptionsLoaded = false;
        vm.csvHeader = ['Itinerary',
            'Confirmation',
            'Date',
            'Customer',
            'Quantity',
            'Item',
            'Employee',
            'Payment Type ',
            'Sub Total',
            'Discount',
            'Sales Tax',
            'Sales Tax %',
            'Tourist Development Tax',
            'Tourist Development Tax %',
            'CC Processing Fee',
            'CC Processing Fee %',
            'Bar Tax',
            'Bar Tax %',
            'Total Tax',
            'Total',
            'Paid',
            'Remaining'
        ];

        vm.pdfHeader = angular.copy(vm.csvHeader);

        vm.csvData = [];
        vm.showSkipjackRetailTypes = false;

        vm.myDate = new Date();
        vm.allData = [];
        vm.startDate = new Date(
            this.myDate.getFullYear(),
            this.myDate.getMonth(),
            this.myDate.getDate()
        );
        vm.endDate = new Date(
            this.myDate.getFullYear(),
            this.myDate.getMonth(),
            this.myDate.getDate()
        );

        /*Functions Dec*/
        vm.getIncomeReport = getIncomeReport;
        vm.getPrintRetail = getPrintRetail;
        vm.compareDate = compareDate;
        vm.calculateTotal = calculateTotal;
        vm.onRetailTypeChange = onRetailTypeChange;
        vm.filterRoomPosOptions = filterRoomPosOptions;
        vm.clearRoomPosSearch = clearRoomPosSearch;
        vm.hasPosOptionsFilter = hasPosOptionsFilter;
        vm.getPosOptionLabel = getPosOptionLabel;
        vm.removePosOption = removePosOption;
        vm.onPosOptionsSelectionChange = onPosOptionsSelectionChange;

        if($localStorage['preHotelId'] !== undefined && $localStorage['preHotelId'] == 126){
            vm.showSkipjackRetailTypes = true;
        }

        vm.overAll = new Array();
        vm.pindex = '1111';
        vm.countLoopElement = 0;
        vm.selectedHotels = [];

        fetchRoomPosOptions();

        function calculateTotal(data, pindex) {
            // for calculation
        }

        function compareDate(date1, date2, index) {
            var startDate = moment(date1);
            var endDate = moment(date2);
            if (startDate > endDate || startDate < endDate) {
                vm.currentDate = date2;
                return true;
            } else {
                return false;
            }

        }
        vm.noResultFound = false;

        vm.requestProcessing = false;

        function hasPosOptionsFilter() {
            return vm.retailType === 'all' || vm.retailType === 'reservation' || vm.retailType === 'service' || vm.retailType === 'bar';
        }

        function onRetailTypeChange() {
            vm.selectedRoomPos = [];
            vm.roomPosSearchText = '';
        }

        function clearRoomPosSearch() {
            vm.roomPosSearchText = '';
        }

        function onPosOptionsSelectionChange() {
            vm.roomPosSearchText = '';
        }

        function getPosOptionLabel(value) {
            var strValue = value !== undefined && value !== null ? String(value) : '';
            var options = vm.roomPosOptions || [];
            var i;
            var option;

            for (i = 0; i < options.length; i++) {
                option = options[i];
                if (String(option.value) === strValue) {
                    return option.product_name || option.label || strValue;
                }
            }

            return strValue;
        }

        function removePosOption(event, value) {
            if (event) {
                event.stopPropagation();
            }

            var strValue = String(value);
            vm.selectedRoomPos = (vm.selectedRoomPos || []).filter(function(selectedValue) {
                return String(selectedValue) !== strValue;
            });
            vm.roomPosSearchText = '';
        }

        function filterRoomPosOptions(option) {
            if (!option) {
                return false;
            }

            var term = (vm.roomPosSearchText || '').toLowerCase().trim();
            if (!term) {
                return true;
            }

            var productName = option.product_name ? String(option.product_name).toLowerCase() : '';
            var value = option.value ? String(option.value).toLowerCase() : '';
            var label = option.label ? String(option.label).toLowerCase() : '';

            return productName.indexOf(term) !== -1 || value.indexOf(term) !== -1 || label.indexOf(term) !== -1;
        }

        function fetchRoomPosOptions() {
            if (vm.roomPosOptionsLoaded || vm.loadingRoomPosOptions) {
                return;
            }

            vm.loadingRoomPosOptions = true;
            reportService.getRoomPosProducts().then(function(response) {
                vm.loadingRoomPosOptions = false;
                vm.roomPosOptionsLoaded = true;
                vm.roomPosOptions = buildRoomPosOptions(response && response.data ? response.data : response);
            }).catch(function() {
                vm.loadingRoomPosOptions = false;
                vm.roomPosOptions = [];
            });
        }

        function buildRoomPosOptions(reportData) {
            var options = [];
            var seenKeys = {};

            if (angular.isArray(reportData)) {
                angular.forEach(reportData, function(record) {
                    var value = record.value !== undefined ? String(record.value) : '';
                    var productName = record.product_name || '';

                    if (!value || seenKeys[value]) {
                        return;
                    }

                    seenKeys[value] = true;
                    options.push({
                        value: value,
                        confirmation: '',
                        itinerary: '',
                        product_name: productName,
                        customerName: productName,
                        label: productName || record.label || ((record.product_id ? String(record.product_id) : value) + (productName ? (' - ' + productName) : ''))
                    });
                });

                options.sort(function(a, b) {
                    return a.label.localeCompare(b.label);
                });

                return options;
            }

            angular.forEach(reportData, function(records) {
                angular.forEach(records, function(record) {
                    var confirmation = record.confirmation_number ? String(record.confirmation_number) : '';
                    var itinerary = record.itinerary_number ? String(record.itinerary_number) : '';
                    var optionKey = confirmation || itinerary;

                    if (!optionKey || seenKeys[optionKey]) {
                        return;
                    }

                    seenKeys[optionKey] = true;
                    options.push({
                        value: optionKey,
                        confirmation: confirmation,
                        itinerary: itinerary,
                        customerName: record.customerName || '',
                        label: (confirmation ? ('Conf: ' + confirmation) : ('Itin: ' + itinerary)) + (record.customerName ? (' - ' + record.customerName) : '')
                    });
                });
            });

            options.sort(function(a, b) {
                return a.label.localeCompare(b.label);
            });

            return options;
        }

        function applyRoomPosSelectionFilter(reportData, csvData) {
            if (!hasPosOptionsFilter() || !vm.selectedRoomPos || vm.selectedRoomPos.length === 0) {
                return {
                    report: reportData,
                    csv: csvData
                };
            }

            var selectedMap = {};
            var hasAnyMatch = false;
            angular.forEach(vm.selectedRoomPos, function(value) {
                selectedMap[String(value)] = true;
            });

            var filteredReport = {};
            angular.forEach(reportData, function(records, dateKey) {
                var validRows = [];
                angular.forEach(records, function(record) {
                    var confirmation = record.confirmation_number ? String(record.confirmation_number) : '';
                    var itinerary = record.itinerary_number ? String(record.itinerary_number) : '';
                    var productId = record.product_id !== undefined && record.product_id !== null ? String(record.product_id) : '';
                    var productValue = record.value !== undefined && record.value !== null ? String(record.value) : '';
                    if (selectedMap[confirmation] || selectedMap[itinerary] || selectedMap[productId] || selectedMap[productValue]) {
                        validRows.push(record);
                        hasAnyMatch = true;
                    }
                });

                if (validRows.length > 0) {
                    filteredReport[dateKey] = validRows;
                }
            });

            var filteredCsv = [];
            angular.forEach(csvData, function(row) {
                var confirmationCsv = '';
                var itineraryCsv = '';
                var productIdCsv = '';
                var productValueCsv = '';

                if (angular.isArray(row)) {
                    confirmationCsv = row.length > 1 && row[1] !== undefined ? String(row[1]) : '';
                    itineraryCsv = row.length > 0 && row[0] !== undefined ? String(row[0]) : '';
                } else {
                    confirmationCsv = row && row.confirmation_number ? String(row.confirmation_number) : '';
                    itineraryCsv = row && row.itinerary_number ? String(row.itinerary_number) : '';
                    productIdCsv = row && row.product_id !== undefined && row.product_id !== null ? String(row.product_id) : '';
                    productValueCsv = row && row.value !== undefined && row.value !== null ? String(row.value) : '';
                }

                if (selectedMap[confirmationCsv] || selectedMap[itineraryCsv] || selectedMap[productIdCsv] || selectedMap[productValueCsv]) {
                    filteredCsv.push(row);
                    hasAnyMatch = true;
                }
            });

            if (!hasAnyMatch) {
                return {
                    report: reportData,
                    csv: csvData
                };
            }

            return {
                report: filteredReport,
                csv: filteredCsv
            };
        }

        function getIncomeReport() {
            vm.previousKey = 0;
            vm.countAll = 0;
            initializeAll();
            vm.noResultFound = false;
            vm.requestProcessing = true;

            var endDate = moment(vm.endDate).format('YYYY-MM-DD');
            var startDate = moment(vm.startDate).format('YYYY-MM-DD');
            vm.csvName = 'retail-reports' + startDate + '-to-' + endDate + '.csv';
            vm.pdfName = 'retail-reports' + startDate + '-to-' + endDate + '.pdf';
            reportService.getAllRetailReports({
                startDate: new Date(startDate),
                endDate: new Date(endDate),
                retailType: vm.retailType,
                mode: 'listing',
                'selectedHotels':vm.selectedHotels,
                selectedRoomPos: vm.selectedRoomPos
            }).then(function(response) {
                vm.requestProcessing = false;
                vm.noResultFound = false;
                var reportData = response['data'] || {};
                var csvData = angular.copy(response['csvArray'] || []);

                var filteredOutput = applyRoomPosSelectionFilter(reportData, csvData);
                vm.retailReport = filteredOutput.report;
                vm.csvData = filteredOutput.csv;
                
                /*angular.forEach(vm.retailReport, function(value, key) {
                    console.log(value);
                });*/

                if (Object.keys(vm.retailReport).length == 0) {
                    vm.noResultFound = true;
                }
                setTimeout(function(){
                    vm.initialOffset = $('#table-container').offset().top;
                    vm.tableOuter = $('#tableOuter');
                    vm.tableInner = $('#tableInner');
                    vm.bodyCells = vm.tableInner.find('tbody tr:first').children();
                    vm.colWidth;
                    // Adjust the width of thead cells when window resizes
                    $(window).resize(function() {
                        // Get the tbody columns width array
                        vm.colWidth = vm.bodyCells.map(function() {
                            return $(this).width();
                        }).get();
                        
                        // Set the width of thead columns
                       /* vm.tableOuter.find('thead tr').children().each(function(i, v) {
                            $(v).width(vm.colWidth[i]);
                        });*/    
                    }).resize(); // Trigger resize handler

                    vm.tableOuterStyle = { "max-height" : "calc(100vh - 200px)" };

                },500);

            });
        }

        function getPrintRetail(pdf){
            vm.requestProcessingPDF = true;
            reportService.getAllRetailReports({
                startDate: moment(vm.startDate).format('YYYY-MM-DD'),
                endDate: moment(vm.endDate).format('YYYY-MM-DD'),
                retailType: vm.retailType,
                mode: 'listing',
                'selectedHotels':vm.selectedHotels,
                selectedRoomPos: vm.selectedRoomPos,
                pdf: pdf
            }).then(function(response) {
                vm.requestProcessingPDF = false;
                if(response.status == 'success' && pdf=='pdf'){
                    var filepathToClean = response.data.filepath;
                    var data = {
                        filename:response.data.filename,
                        filepath:response.data.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        //return;
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
                            lodgingStatistic.cleanDisk(cleanData);
                        }, 2000);
                    });
                } 
            });
        }


        vm.printRecords = printRecords;
        vm.requestProcessingEmail = false;

        function printRecords() {
            $mdDialog.show({
                    controller: 'getEmailAddress',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/reports/getEmailAddress.html',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: true,

                })
                .then(function(answer) {
                    // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (typeof answer != 'undefined') {
                        var endDate = new Date(moment(vm.endDate).format('YYYY-MM-DD'));
                        var startDate = new Date(moment(vm.startDate).format('YYYY-MM-DD'));
                        vm.requestProcessingEmail = true;
                        reportService.getAllRetailReports({
                            startDate: startDate,
                            endDate: endDate,
                            retailType: vm.retailType,
                            mode: 'sendEmail',
                            emailAddress: answer,
                            'selectedHotels':vm.selectedHotels,
                            selectedRoomPos: vm.selectedRoomPos
                        }).then(function(response) {
                            vm.requestProcessingEmail = false;
                        });

                    }
                }, function() {});

        }
        vm.ChangeEndDayIf = function() {
            /*if (!moment(vm.endDate).isAfter(vm.startDate)) {
                vm.endDate = moment(vm.startDate).add(0, 'days').format('M/D/Y');
            }*/
            if(vm.startDate != undefined && vm.endDate != undefined && moment(vm.startDate).isAfter(vm.endDate)) {
                vm.endDate = vm.startDate;
            }
        }
        vm.initializeAll = initializeAll;
        vm.formatReportDayKey = formatReportDayKey;

        function formatReportDayKey(dayKey) {
            if (!dayKey) {
                return '';
            }
            return moment(dayKey, 'YYYY-MM-DD', true).isValid()
                ? moment(dayKey, 'YYYY-MM-DD').format('MM/DD/YYYY')
                : dayKey;
        }

        function initializeAll() {
            vm.overAll = [];
            vm.retailReport = [];
            vm.csvData = [];
        }
        vm.previousKey = 0;
        vm.countAll = 0;

        vm.calculateTotal = function(element, key, pKey) {
            vm.countAll++;
            if (vm.previousKey != pKey) {
                vm.previousKey = pKey;
                vm.overAll[pKey] = [];
                vm.overAll[pKey]['quantity'] = 0;
                vm.overAll[pKey]['subtotal'] = 0;
                vm.overAll[pKey]['product_discount'] = 0;
                // vm.overAll[pKey]['tax_amount'] = 0;
                vm.overAll[pKey]['grand_total'] = 0;
                vm.overAll[pKey]['paid_amount'] = 0;
                vm.overAll[pKey]['remaining_amount'] = 0;
                vm.overAll[pKey]['tip_amount'] = 0;
                vm.overAll[pKey]['salesTaxAmt']     = 0;
                vm.overAll[pKey]['touristTaxAmt']   = 0;
                vm.overAll[pKey]['barTaxAmt']       = 0;
                vm.overAll[pKey]['ccProcessingFeeAmt'] = 0;
                vm.overAll[pKey]['totalTaxAmount']  = 0;
            }
            vm.overAll[pKey]['quantity'] = parseFloat(vm.overAll[pKey]['quantity']) + parseFloat(element['quantity']);
            vm.overAll[pKey]['subtotal'] = parseFloat(vm.overAll[pKey]['subtotal']) + parseFloat(element['subtotal']);
            vm.overAll[pKey]['product_discount'] = parseFloat(vm.overAll[pKey]['product_discount']) + parseFloat(element['product_discount']);
            // vm.overAll[pKey]['tax_amount'] = parseFloat(vm.overAll[pKey]['tax_amount']) + parseFloat(element['tax_amount']);
            vm.overAll[pKey]['grand_total'] = parseFloat(vm.overAll[pKey]['grand_total']) + parseFloat(element['grand_total']);
            vm.overAll[pKey]['paid_amount'] = parseFloat(vm.overAll[pKey]['paid_amount']) + parseFloat(element['paid_amount']);
            vm.overAll[pKey]['remaining_amount'] = parseFloat(vm.overAll[pKey]['remaining_amount']) + parseFloat(element['remaining_amount']);
            vm.overAll[pKey]['salesTaxAmt'] = parseFloat(vm.overAll[pKey]['salesTaxAmt']) + parseFloat(element['salesTaxAmt']);
            vm.overAll[pKey]['touristTaxAmt'] = parseFloat(vm.overAll[pKey]['touristTaxAmt']) + parseFloat(element['touristTaxAmt']);
            vm.overAll[pKey]['barTaxAmt'] = parseFloat(vm.overAll[pKey]['barTaxAmt']) + parseFloat(element['barTaxAmt']);
            vm.overAll[pKey]['ccProcessingFeeAmt'] = parseFloat(vm.overAll[pKey]['ccProcessingFeeAmt']) + parseFloat(element['ccProcessingFeeAmt']);
            vm.overAll[pKey]['totalTaxAmount'] = parseFloat(vm.overAll[pKey]['totalTaxAmount']) + parseFloat(element['totalTaxAmount']);

            // if (element['is_tip_product'] == 1)
            if (element['product_name'] != undefined && element['product_name'].toLowerCase().includes('customer tip')) {
                vm.overAll[pKey]['tip_amount'] = parseFloat(vm.overAll[pKey]['tip_amount']) + parseFloat(element['grand_total']);
            }

            if (vm.countAll == vm.csvData.length) {
                vm.grandTotal = [];
                vm.grandTotal['quantity'] = 0;
                vm.grandTotal['subtotal'] = 0;
                vm.grandTotal['product_discount'] = 0;
                // vm.grandTotal['tax_amount'] = 0;
                vm.grandTotal['grand_total'] = 0;
                vm.grandTotal['paid_amount'] = 0;
                vm.grandTotal['remaining_amount'] = 0;
                vm.grandTotal['tip_amount'] = 0;
                vm.grandTotal['salesTaxAmt']     = 0;
                vm.grandTotal['touristTaxAmt']   = 0;
                vm.grandTotal['barTaxAmt']       = 0;
                vm.grandTotal['ccProcessingFeeAmt'] = 0;
                vm.grandTotal['totalTaxAmount']  = 0;
                for (var subKey in vm.overAll) {
                    vm.grandTotal['quantity'] = parseFloat(vm.grandTotal['quantity']) + parseFloat(vm.overAll[subKey]['quantity']);
                    vm.grandTotal['subtotal'] = parseFloat(vm.grandTotal['subtotal']) + parseFloat(vm.overAll[subKey]['subtotal']);
                    vm.grandTotal['product_discount'] = parseFloat(vm.grandTotal['product_discount']) + parseFloat(vm.overAll[subKey]['product_discount']);
                    // vm.grandTotal['tax_amount'] = parseFloat(vm.grandTotal['tax_amount']) + parseFloat(vm.overAll[subKey]['tax_amount']);
                    vm.grandTotal['grand_total'] = parseFloat(vm.grandTotal['grand_total']) + parseFloat(vm.overAll[subKey]['grand_total']);
                    vm.grandTotal['paid_amount'] = parseFloat(vm.grandTotal['paid_amount']) + parseFloat(vm.overAll[subKey]['paid_amount']);
                    vm.grandTotal['remaining_amount'] = parseFloat(vm.grandTotal['remaining_amount']) + parseFloat(vm.overAll[subKey]['remaining_amount']);
                    vm.grandTotal['salesTaxAmt'] = parseFloat(vm.grandTotal['salesTaxAmt']) + parseFloat(vm.overAll[subKey]['salesTaxAmt']);
                    vm.grandTotal['touristTaxAmt'] = parseFloat(vm.grandTotal['touristTaxAmt']) + parseFloat(vm.overAll[subKey]['touristTaxAmt']);
                    vm.grandTotal['barTaxAmt'] = parseFloat(vm.grandTotal['barTaxAmt']) + parseFloat(vm.overAll[subKey]['barTaxAmt']);
                    vm.grandTotal['ccProcessingFeeAmt'] = parseFloat(vm.grandTotal['ccProcessingFeeAmt']) + parseFloat(vm.overAll[subKey]['ccProcessingFeeAmt']);
                    vm.grandTotal['totalTaxAmount'] = parseFloat(vm.grandTotal['totalTaxAmount']) + parseFloat(vm.overAll[subKey]['totalTaxAmount']);

                    vm.grandTotal['tip_amount'] = parseFloat(vm.grandTotal['tip_amount']) + parseFloat(vm.overAll[subKey]['tip_amount']);
                }
                var tempdata = ['',
                    '',
                    '',
                    '',
                    vm.grandTotal['quantity'],
                    '',
                    '',
                    '',
                    $filter('currency')(vm.grandTotal['subtotal'], '$', 2),
                    $filter('currency')(vm.grandTotal['product_discount'], '$', 2),
                    // $filter('currency')(vm.grandTotal['tax_amount'], '$', 2),
                    $filter('currency')(vm.grandTotal['salesTaxAmt'], '$', 2),
                    '',
                    $filter('currency')(vm.grandTotal['touristTaxAmt'], '$', 2),
                    '',
                    $filter('currency')(vm.grandTotal['ccProcessingFeeAmt'], '$', 2),
                    '',
                    $filter('currency')(vm.grandTotal['barTaxAmt'], '$', 2),
                    '',
                    $filter('currency')(vm.grandTotal['totalTaxAmount'], '$', 2),
                    $filter('currency')(vm.grandTotal['grand_total'], '$', 2),
                    $filter('currency')(vm.grandTotal['paid_amount'], '$', 2),
                    $filter('currency')(vm.grandTotal['remaining_amount'], '$', 2)
                ];
                vm.csvData.push(tempdata);
            }
            
        }

    }
})();
(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('reservationDueReport', reservationDueReport);

    /** @ngInject */
    function reservationDueReport(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $filter,
       $mdDialog,
       $rootScope,
       $localStorage
    ){
        var vm = this; 
        vm.addTableClass = false;
        vm.removeClass = false;
        vm.prevScroll = 0;
        vm.initialOffset = 0;
        vm.tbodyHeight = 0;       

        // Change the selector if needed
        vm.tableStyle = {};
        vm.table;
        vm.bodyCells;
        vm.colWidth;

     

        vm.report = {};        

        vm.selectedColumns = 'itinerary_number,confirmation_number,room_stay_status,room_stay_from,room_stay_to,Customer,quantity,product_name,NoOfNights,hotel_title,source_of_creation,Employee,subtotal,product_discount,lodging tax percentage,lodging tax amount,resort fee percentage,resort fee amount,resort fee tax percentage,resort fee tax amount,sales tax percentage,sales tax amount,grand_total,total_paid_amount,total_remaining_amount,totalPaid,payment_method,paidToday';


        vm.not_required = 'product_id,product_is_timebound,sub_hotel_id,type_of_reservation,total,bar tax amount,bar tax percentage';
        vm.allIds = [];
        vm.selectedChannels = [];
        vm.selectedPaymentMethods = [];
        vm.selectedHotels = [];
        vm.csvHeader =  ['Itinerary' ,'Confirmation','Status','Checkin','Checkout','Customer','Quantity','Item','Number of Nights','Business Entity','Source','Employee  ','Sub Total ','Discount  ','Lodging Tax(%)','Lodging Tax($)','Resort Fee(%)','Resort Fee ($)  ','Resort Fee Tax(%)','Resort Fee Tax($)','Sales Tax  (%)','Sales Tax  ($)','Grand Total','Paid','Remaining','Reservation Total','Payment Method','Paid Within Report Range'];
        vm.pdfHeader = angular.copy(vm.csvHeader);
        vm.myDate = new Date();
        vm.allData = [];

        vm.channels = [];
        vm.startDate = null;
        vm.endDate =null;
        vm.checkInDate = null;
        vm.checkOutDate = null;
        vm.disableRefresh = true;
        vm.reportType = 'overAll';

        reportService.getAllChannels().then(function(response){
            if(response.success){
                vm.channels = response.result;
            }
        });

        /*Functions Dec*/
        vm.getIncomeReport = getIncomeReport;
        vm.getValues = getValues;
        vm.compareDate = compareDate;
        vm.calculateTotal = calculateTotal;

        vm.reinitialize = reinitialize;
        reinitialize();
        function reinitialize(){
        vm.quantity = 0;
        vm.NoOfNights = 0;
        vm.subtotal = 0;
        vm.product_discount = 0;
        vm.tax_amount = 0;
        vm.total = 0;
        vm.paymentsTodates = 0;
        vm.total_remaining_amount = 0;
        vm.grand_total = 0;
        vm.totalPaid = 0;
        vm.total_paid_amount = 0;
        vm.paidToday = 0;
        }
        vm.overAll = new Array();
        vm.pindex = '1111';
        vm.countLoopElement = 0;
        vm.countLoopElement2 = 0;
        vm.confirmation_numbers = [];
        vm.confirmation_numbers2 = [];

        // vm.goToState = goToState;
        // function goToState(itinerary_number, confirmation_number, test){
        //   $rootScope.goToState(itinerary_number, confirmation_number, test);
        //   // console.log(itinerary_number, confirmation_number);
        // }
        vm.showReportFor = false;
        vm.reportFor = 'all';
        if($localStorage['preHotelId'] !== undefined && $localStorage['preHotelId'] == 126){
          vm.reportFor = 'reservation';
          vm.showReportFor = true;
        }

        function calculateTotal(data, pindex){
          
          vm.countLoopElement = vm.countLoopElement + 1;

            if(vm.pindex != pindex){
                reinitialize();
                vm.pindex = pindex;
            }

            var income = angular.copy(data);
            if(vm.confirmation_numbers.indexOf(income.confirmation_number) == -1) {
            vm.tax_amount = parseFloat(vm.tax_amount) + parseFloat(income.tax_amount);
            vm.paymentsTodates = parseFloat(vm.paymentsTodates) + parseFloat(income.paymentsTodates);
            vm.NoOfNights = parseFloat(vm.NoOfNights) + parseFloat(income.NoOfNights);
            vm.subtotal = parseFloat(vm.subtotal) + parseFloat(income.subtotal);
            vm.product_discount = parseFloat(vm.product_discount) + parseFloat(income.product_discount);
            vm.grand_total = parseFloat(vm.grand_total) + parseFloat(income.grand_total);         
            vm.totalPaid = parseFloat(vm.totalPaid) + parseFloat(income.totalPaid);         
            

            vm.total_remaining_amount = parseFloat(vm.total_remaining_amount) + parseFloat(income.total_remaining_amount);

            vm.total_paid_amount = parseFloat(vm.total_paid_amount) + parseFloat(income.total_paid_amount);

            vm.quantity = parseFloat(vm.quantity) + parseFloat(income.quantity);
            }
            vm.paidToday = parseFloat(vm.paidToday) + parseFloat(income.paidToday);         
            // vm.total = parseFloat(vm.total) + parseFloat(income.total);

           vm.confirmation_numbers.push(income.confirmation_number);

            vm.overAll[pindex] = {};
            vm.overAll[pindex]['quantity'] = angular.copy(vm.quantity);
            vm.overAll[pindex]['NoOfNights'] = angular.copy(vm.NoOfNights);
            vm.overAll[pindex]['grand_total'] = angular.copy(vm.grand_total);
            vm.overAll[pindex]['subtotal'] = angular.copy(vm.subtotal);
            vm.overAll[pindex]['tax_amount'] = angular.copy(vm.tax);
            // vm.overAll[pindex]['total'] = angular.copy(vm.total);
            vm.overAll[pindex]['totalPaid'] = angular.copy(vm.totalPaid);
            vm.overAll[pindex]['paymentsTodates'] = angular.copy(vm.paymentsTodates);
            vm.overAll[pindex]['total_remaining_amount'] = angular.copy(vm.total_remaining_amount);
            vm.overAll[pindex]['total_paid_amount'] = angular.copy(vm.total_paid_amount);
            vm.overAll[pindex]['paidToday'] = angular.copy(vm.paidToday);

            if(vm.countLoopElement == vm.actualLength){              
              var totalPaid = 0;
              var paidToday = 0;
               for(var tempKey in vm.overAll){
                totalPaid = parseFloat(totalPaid) + parseFloat(vm.overAll[tempKey]['totalPaid']);
                paidToday = parseFloat(paidToday) + parseFloat(vm.overAll[tempKey]['paidToday']);
              }
              vm.overAllTotal = {
                                    'itinerary_number':'',
                                    'confirmation_number':'',
                                    'room_stay_status':'',
                                    'room_stay_from':'',
                                    'room_stay_to':'',
                                    'Customer':'',
                                    'quantity':'',
                                    'product_name':'',
                                    'NoOfNights':'',
                                    'hotel_title':'',
                                    'source_of_creation':'',
                                    'Employee':'',
                                    'subtotal':'',
                                    'product_discount':'',
                                    'lodging tax percentage':'',
                                    'lodging tax amount':'',
                                    'resort fee percentage':'',
                                    'resort fee amount':'',
                                    'resort fee tax percentage':'',
                                    'resort fee tax amount':'',
                                    'sales tax percentage':'',
                                    'sales tax amount':'',
                                    'grand_total':'',
                                    'total_paid_amount':'',
                                    'total_remaining_amount':'',
                                    'totalPaid':$filter('currency')(totalPaid,'$',2),
                                    'payment_method':'',
                                    'paidToday' : $filter('currency')(paidToday,'$',2)
              };
              if(vm.reportType=='detailed')
                vm.overAllTotal.installment_paid_date='';
              vm.allData.push(vm.overAllTotal);
            }
        }
        

        function compareDate(date1, date2,index){
            var startDate = moment(date1);
            var endDate = moment(date2);
            if(startDate > endDate || startDate < endDate){
                vm.currentDate = date2;
                return true;
            } else {
                return false;
            }

        }
        vm.noResultFound = false;

        function getValues(date){
            vm.currentDate  = angular.copy(date);
            return vm.currentDate;
        }
    // getIncomeReport();
    vm.requestProcessing = false;
        function getIncomeReport(){          
          vm.countLoopElement = 0;

          vm.requestProcessing = true;
          vm.allData = [];
          vm.incomeData = [];
          var endDate = moment(vm.endDate).format('YYYY-MM-DD');
          var startDate = moment(vm.startDate).format('YYYY-MM-DD');
          var checkInDate = moment(vm.checkInDate).format('YYYY-MM-DD');
          var checkOutDate = moment(vm.checkOutDate).format('YYYY-MM-DD');
          vm.csvName =  'payment-due-reports'+vm.reportType+'.csv';
          vm.pdfName =  'payment-due-reports-'+vm.reportType+'.pdf';
          reinitialize();
          reportService.getAllIncomeReports({
              startDate:new Date(startDate),
              endDate:new Date(endDate),
              checkInDate:new Date(checkInDate),
              checkOutDate:new Date(checkOutDate),
              selectedChannels:vm.selectedChannels,
              selectedPaymentMethods:vm.selectedPaymentMethods,
              reportType:vm.reportType,
              reportFor:vm.reportFor,
              mode:'listing',
              'selectedHotels':vm.selectedHotels,
              'runReportFor': 'dueReport'
          }).then(function(response){

            vm.requestProcessing = false;
            vm.noResultFound = true;
            vm.incomeData = response['incomeReport'];
            vm.noResultFound = false;    
            // if(vm.incomeData.length<=0){
            // vm.noResultFound = true;    
            // }
            var allCount = 0;         
            for (var key in vm.incomeData) {
              for (var key1 in vm.incomeData[key]){
                  allCount ++;
                  var tempObj = angular.copy(vm.incomeData[key][key1]);
                  // console.log('Row Data', vm.incomeData[key][key1]);
                  tempObj['subtotal'] = $filter('currency')(tempObj['subtotal'], '$', 2);
                  tempObj['product_discount'] = $filter('currency')(tempObj['product_discount'], '$', 2);
                  tempObj['lodging tax percentage'] = $filter('currency')(tempObj['lodging tax percentage'], '', 2);
                  tempObj['lodging tax amount'] = $filter('currency')(tempObj['lodging tax amount'], '$', 2);
                  tempObj['resort fee percentage'] = $filter('currency')(tempObj['resort fee percentage'], '', 4);
                  tempObj['resort fee amount'] = $filter('currency')(tempObj['resort fee amount'], '$', 2);
                  tempObj['resort fee tax percentage'] = $filter('currency')(tempObj['resort fee tax percentage'], '', 2);
                  tempObj['resort fee tax amount'] = $filter('currency')(tempObj['resort fee tax amount'], '$', 2);
                  tempObj['sales tax percentage'] = $filter('currency')(tempObj['sales tax percentage'], '', 2);
                  tempObj['sales tax amount'] = $filter('currency')(tempObj['sales tax amount'], '$', 2);
                  tempObj['grand_total'] = $filter('currency')(tempObj['grand_total'], '$', 2);
                  tempObj['total_paid_amount'] = $filter('currency')(tempObj['total_paid_amount'], '$', 2);
                  tempObj['total_remaining_amount'] = $filter('currency')(tempObj['total_remaining_amount'], '$', 2);
                  tempObj['totalPaid'] = $filter('currency')(tempObj['totalPaid'], '$', 2);
                  tempObj['paidToday'] = $filter('currency')(tempObj['paidToday'], '$', 2);
                  vm.allData = vm.allData.concat(tempObj);
              }   
            }
            vm.actualLength = allCount;
            setTimeout(function(){
              vm.tbodyHeight = document.getElementById('tbodyHeight').clientHeight;
              vm.initialOffset = $('#table-container').offset().top;
                vm.table = $('#heightTable');
                vm.bodyCells = vm.table.find('tbody tr:first').children();
                vm.colWidth;
                console.log("-->",vm.table);
              // Adjust the width of thead cells when window resizes
              $(window).resize(function() {
                  // Get the tbody columns width array
                  vm.colWidth = vm.bodyCells.map(function() {
                      return $(this).width();
                  }).get();
                  
                  // Set the width of thead columns
                  vm.table.find('thead tr').children().each(function(i, v) {
                      $(v).width(vm.colWidth[i]);
                  });    
              }).resize(); // Trigger resize handler

              vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };

            },1000);
            
          });
          vm.confirmation_numbers = [];
        }   


    vm.printRecords = printRecords;
    vm.requestProcessingEmail = false;
    function printRecords(){
      // vm.requestProcessingEmail = true;
          var checkInDate = moment(vm.checkInDate).format('YYYY-MM-DD');
          var checkOutDate = moment(vm.checkOutDate).format('YYYY-MM-DD');
      $mdDialog.show({
                    controller: 'getEmailAddress',
                    controllerAs: 'vm',
                  templateUrl: 'app/main/apps/reports/getEmailAddress.html',
                  parent: angular.element(document.body),
                  targetEvent: event,
                  clickOutsideToClose:true ,
                                  
                })
                .then(function(answer) {
                  vm.requestProcessingEmail = false;
                     var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                   if(typeof answer != 'undefined'){
                    vm.requestProcessingEmail = true;
                    var endDate = new Date(moment(vm.endDate).format('YYYY-MM-DD'));
                    var startDate = new Date(moment(vm.startDate).format('YYYY-MM-DD'));
                    vm.csvName =  'income-reports'+startDate+'-to-'+endDate+'.csv';
                      reinitialize();
                      reportService.getAllIncomeReports({
                          startDate:startDate,
                          endDate:endDate,
                          selectedChannels:vm.selectedChannels,
                          selectedPaymentMethods:vm.selectedPaymentMethods,
                          emailAddress:answer,
                          checkInDate:new Date(checkInDate),
                          checkOutDate:new Date(checkOutDate),
                          reportType:vm.reportType,
                          mode:'sendEmail',
                          'selectedHotels':vm.selectedHotels,
                          'runReportFor': 'dueReport'
                      }).then(function(response){
                        vm.requestProcessingEmail = false;
                        });
           
        }
               }, function() {
               vm.requestProcessingEmail = false;});

      
    
    }
      vm.ChangeEndDayIf = function(){
        vm.startDate = new Date(
                                     this.myDate.getFullYear(),
                                     this.myDate.getMonth(),
                                     this.myDate.getDate()
                                   );
        if(!vm.endDate){
          vm.endDate = vm.startDate;
        }

        if(!moment(vm.endDate).isAfter(vm.startDate)){
        vm.endDate = moment(vm.startDate).add(0, 'days').format('M/D/Y');
        }
      }
     vm.changeCheckDates = function(){
        if(vm.checkInDate != undefined && vm.checkInDate != undefined && moment(vm.checkInDate).isAfter(vm.checkOutDate)) {
          vm.checkOutDate = vm.checkInDate;
        }

        if(!vm.checkInDate || !vm.checkOutDate){
          vm.disableRefresh = true;
        }
        else{
          vm.disableRefresh = false;
        }
      } 
       vm.changePayDates = function(){
        if(!vm.endDate || !vm.startDate){
          vm.disableRefresh = true;
        }
        else{
          vm.disableRefresh = false;
        }
      }
      vm.changeReportType = function(){
        vm.incomeData = [];
      }
      
      vm.downloadFileCustom = function(reportType,type_of_file_download){
        if(vm.reportType=='detailed'){
        
          vm.selectedColumns =  'itinerary_number,confirmation_number,installment_paid_date,room_stay_status,room_stay_from,room_stay_to,Customer,quantity,product_name,NoOfNights,hotel_title,source_of_creation,Employee,subtotal,product_discount,lodging tax percentage,lodging tax amount,resort fee percentage,resort fee amount,resort fee tax percentage,resort fee tax amount,sales tax percentage,sales tax amount,grand_total,total_paid_amount,total_remaining_amount,totalPaid,payment_method,paidToday';
          vm.csvHeader =  ['Itinerary' ,'Confirmation','Date','Status','Checkin','Checkout','Customer','Quantity','Item','Number of Nights','Business Entity','Source','Employee  ','Sub Total ','Discount  ','Lodging Tax(%)','Lodging Tax($)','Resort Fee(%)','Resort Fee ($)  ','Resort Fee Tax(%)','Resort Fee Tax($)','Sales Tax  (%)','Sales Tax  ($)','Total','Paid','Remaining','Reservation Total','Payment Method','Paid Today'];
          vm.not_required = 'product_id,product_is_timebound,sub_hotel_id,type_of_reservation,total,bar tax amount,bar tax percentage';
          vm.pdfHeader = angular.copy(vm.csvHeader);
        } else {
          vm.csvHeader =  ['Itinerary' ,'Confirmation','Status','Checkin','Checkout','Customer','Quantity','Item','Number of Nights','Business Entity','Source','Employee  ','Sub Total ','Discount  ','Lodging Tax(%)','Lodging Tax($)','Resort Fee(%)','Resort Fee ($)  ','Resort Fee Tax(%)','Resort Fee Tax($)','Sales Tax  (%)','Sales Tax  ($)','Grand Total','Paid','Remaining','Reservation Total','Payment Method','Paid Within Report Range'];
          vm.pdfHeader = angular.copy(vm.csvHeader);
          //vm.not_required = 'product_is_timebound,sub_hotel_id,type_of_reservation';
          vm.not_required = 'product_id,product_is_timebound,sub_hotel_id,type_of_reservation,installment_paid_date,total,bar tax amount,bar tax percentage';
          vm.selectedColumns = 'itinerary_number,confirmation_number,room_stay_status,room_stay_from,room_stay_to,Customer,quantity,product_name,NoOfNights,hotel_title,source_of_creation,Employee,subtotal,product_discount,lodging tax percentage,lodging tax amount,resort fee percentage,resort fee amount,resort fee tax percentage,resort fee tax amount,sales tax percentage,sales tax amount,grand_total,total_paid_amount,total_remaining_amount,totalPaid,payment_method,paidToday';

        }
        if(type_of_file_download == 'pdf')
          $rootScope.downloadFile(vm.csvHeader, vm.allData, vm.pdfName,vm.selectedColumns,vm.not_required,'lodgingstats');
        else
          $rootScope.downloadFile(vm.pdfHeader, vm.allData, vm.csvName,vm.selectedColumns,vm.not_required);
      }
    }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('reconcillationController', reconcillationController)
        .filter('split', function() {
              return function(input, splitChar, splitIndex) {
                  // do some bounds checking here to ensure it has that index
                  return input.split(splitChar)[splitIndex];
              }
          });

    /** @ngInject */
    function reconcillationController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $localStorage,
       $filter,
       $rootScope
    ){
        var vm = this;
        vm.hotelID = $localStorage.preHotelId;
        vm.selectedHotels = [];
		    vm.showGeneratingFlag = false;
        vm.csvFlag = false;
        vm.pdfFlag = false;
        var date = new Date();
        vm.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
        vm.toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        vm.refreshConcillation = refreshConcillation;
        vm.totalCommission = totalCommission;
        vm.channelWise = [];

        function refreshConcillation() {
          vm.showGeneratingFlag = true;
          reportService.getAllReconcillationOTA({
                from:moment(vm.fromDate).format('YYYY-MM-DD'),
                to:moment(vm.toDate).format('YYYY-MM-DD'),
                selectedHotels:vm.selectedHotels
            }).then(function(response){
                if(response.success) {
                  vm.reconcillationData = response.reconcillation;
                  vm.serviceFee = response.serviceFee;
                  vm.channelKeys = Object.keys(vm.reconcillationData);
                  if(vm.channelKeys.length == 0) {
                      vm.reconcillationData = [];
                  }
                  console.log(vm.channelKeys);
                  vm.showGeneratingFlag = false;
                  vm.otachargesPercentage = [];
                  vm.channelArray = Object.keys(response.otachargesPercentage);
                  angular.forEach(vm.channelArray, function(val, index) {
                    var channelVal = [];
                    channelVal.push(val.toLowerCase());
                    if(channelVal.indexOf('booking.com') !== -1) {
                      vm.otachargesPercentage['Booking.com'] = response.otachargesPercentage[val];
                    } else if(channelVal.indexOf('expedia') !== -1) {
                      vm.otachargesPercentage['Expedia'] = response.otachargesPercentage[val];
                    } else if(channelVal.indexOf('getaroom.com') !== -1) {
                      vm.otachargesPercentage['Getaroom.com'] = response.otachargesPercentage[val];
                    } else if(channelVal.indexOf('hoteltonight') !== -1) {
                      vm.otachargesPercentage['HotelTonight'] = response.otachargesPercentage[val];
                    } else if(channelVal.indexOf('travelzoo') !== -1) {
                      vm.otachargesPercentage['Travelzoo'] = response.otachargesPercentage[val];
                    } else if(channelVal.indexOf('airbnb') !== -1) {
                      vm.otachargesPercentage['Airbnb'] = response.otachargesPercentage[val];
                    } else if(channelVal.indexOf('agoda') !== -1) {
                      vm.otachargesPercentage['Agoda'] = response.otachargesPercentage[val];
                    } else if(channelVal.indexOf('priceline') !== -1) {
                      vm.otachargesPercentage['Priceline.com'] = response.otachargesPercentage[val];
                    } else if(channelVal.indexOf('guestcentric systems') !== -1) {
                      vm.otachargesPercentage['GuestCentric Systems'] = response.otachargesPercentage[val];
                    } else if(channelVal.indexOf('hotwire') !== -1) {
                      vm.otachargesPercentage['Hotwire'] = response.otachargesPercentage[val];
                    } else if(channelVal.indexOf('expedia_channel') !== -1) {
                      vm.otachargesPercentage['expedia_channel'] = response.otachargesPercentage[val];
                    } else if(channelVal.indexOf('expedia_hotel') !== -1) {
                      vm.otachargesPercentage['expedia_hotel'] = response.otachargesPercentage[val];
                    } else if(channelVal.indexOf('booking_channel') !== -1) {
                      vm.otachargesPercentage['booking_channel'] = response.otachargesPercentage[val];
                    } else if(channelVal.indexOf('booking_hotel') !== -1) {
                      vm.otachargesPercentage['booking_hotel'] = response.otachargesPercentage[val];
                    }
                  });
                }
                setTimeout(function(){              
                    angular.forEach(vm.salesByAgents, function(key,value){
                      var childKey = value.split(' ')[0];
                      vm.tbodyHeight = document.getElementsByClassName('tbodyHeight'+childKey).clientHeight;
                      vm.initialOffset = $('#table-container').offset().top;
                        vm.table = $('.heightTable'+childKey);
                        vm.bodyCells = vm.table.find('tbody tr:first').children();
                        vm.colWidth;
                      // Adjust the width of thead cells when window resizes
                      $(window).resize(function() {
                          // Get the tbody columns width array
                          vm.colWidth = vm.bodyCells.map(function() {
                              return $(this).width();
                          }).get();
                          
                          // Set the width of thead columns
                          vm.table.find('thead tr').children().each(function(i, v) {
                              $(v).width(vm.colWidth[i]);
                          });    
                      }).resize(); // Trigger resize handler

                      vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };
                    });
                },0);
            });
        }


        // Change from/to date
        vm.checkSchedule = function(type) {
          if(type == 'from') {
            vm.toDate = new Date(vm.fromDate.getFullYear(), vm.fromDate.getMonth() + 1, 0);
            vm.minDate = vm.fromDate;
            vm.maxDate = vm.toDate;
          }
        }

        // Export as PDF/ CSV
        vm.exportFile = exportFile;
        vm.exportLoader = false;
        vm.csvLoader = false;
        function exportFile(type) {
            var fromDate = moment(vm.fromDate).format('YYYY-MM-DD');
            var toDate = moment(vm.toDate).format('YYYY-MM-DD');
            if(type == 'pdf') {
                vm.exportLoader = true;
            } else {
                vm.csvLoader = true;
            }
            reportService.getAllReconcillationOTA({
                from:moment(vm.fromDate).format('YYYY-MM-DD'),
                to:moment(vm.toDate).format('YYYY-MM-DD'),
                selectedHotels:vm.selectedHotels,
                type: type
            }).then(function(response){
                if(type == 'pdf') {
                    vm.exportLoader = false;
                    var filepathToClean = response.data.filepath;
                    var data = {
                        filename:response.data.filename,
                        filepath:response.data.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
                            lodgingStatistic.cleanDisk(cleanData);
                        }, 2000);
                    });
                } else {
                    vm.csvLoader = false;
                    vm.csvHeader = ['Source','Itinerary','Confirmation','SiteminderID', 'Collect Which','From','To','Nights','Subtotal', 'Sales Tax', 'Tourist Development Tax', 'CC Processing Fee', 'Grand Total','Commission','Service Fee','Rate Plan','Created','Status','Customer','Email'];
                    vm.csvData = response;
                    if(fromDate === toDate) {
                        vm.csvName = 'ota_reconciliation-'+ moment(fromDate).format('MM-DD-YYYY') + '.csv';
                    } else {
                        vm.csvName = 'ota_reconciliation-'+ moment(fromDate).format('MM-DD-YYYY') + '-' + moment(toDate).format('MM-DD-YYYY') +  '.csv';
                    }
                    $rootScope.downloadFile(vm.csvHeader, vm.csvData, vm.csvName);
                }
            });
        }

        // Total Commission calculation
        function totalCommission(reservations,channel) {
          angular.forEach(reservations, function(value,index) {
            if(value.id === '') {
              vm.channelWise[channel] = value.commision_charges;
            }
          });
        }
    }
})();

(function () {
  "use strict";
  angular.module("app.reports").controller("promoReports", promoReports);

  /** @ngInject */
  function promoReports(
    $scope,
    $state,
    EnvironmentConfig,
    toastMessage,
    promoCode,
    commonUtils,
    $mdDialog,
    $localStorage,
    $timeout
  ) {
    var vm = this;
    var myDate = new Date();
    var hotelName = "";
    vm.promotions = [];
    vm.selectedPromotions = [];
    vm.init = false;
    vm.fromdate = new Date(myDate.getFullYear(), myDate.getMonth(), 1);
    vm.todate = new Date(
      myDate.getFullYear(),
      myDate.getMonth(),
      myDate.getDate()
    );
    vm.report = {};
    vm.initialOffset = 0;
    vm.tbodyHeight = 0;
    vm.tableStyle = {};
    vm.table;
    vm.bodyCells;
    vm.colWidth;

    vm.hotelID = $localStorage["preHotelId"];
    hotelName = commonUtils.getHotelName(vm.hotelID);
		console.log("test", hotelName)
    var reportName = "Promo Reports";

    $scope.selected = [];
    vm.selectedHotels = [];
    vm.getrecords = getrecords;
    vm.printRecords = printRecords;

    vm.reportType = "hotel";
    vm.requestProcessingEmail = false;
    vm.requestProcessingPDF = false;

    loadPromotions();
    function loadPromotions() {
      var payload = {
        hotel_id: $localStorage.hotels[$localStorage.selectedHotel].hotel_id,
        sort: {
          column: "created_date",
          order: "DESC",
        },
      };

      vm.requestGoing = true;
      promoCode
        .getAllPromoCodes(payload)
        .then(function (result) {
          vm.requestGoing = false;
          vm.promotions = result.promotions || [];
        })
        .catch(function (error) {
          vm.requestGoing = false;
          toastMessage.showSimpleToast(
            "Failed to load promotions",
            "error-toast"
          );
          console.error("Promotions API error:", error);
        });
    }

    function printRecords() {
      $mdDialog
        .show({
          controller: "getEmailAddress",
          controllerAs: "vm",
          templateUrl: "app/main/apps/reports/getEmailAddress.html",
          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: true,
        })
        .then(
          function (answer) {
            if (typeof answer != "undefined") {
              vm.requestProcessingEmail = true;
              var data = {
                start: new Date(moment(vm.fromdate).format("YYYY-MM-DD")),
                end: new Date(moment(vm.todate).format("YYYY-MM-DD")),
                mode: "sendMail",
                selected_hotel: vm.selectedHotels,
                emailAddress: answer,
                reportFor: vm.reportFor,
              };

              promoCode.getPromoList(data).then(function () {
                vm.requestProcessingEmail = false;
              });
            }
          },
          function () {}
        );
    }

    vm.requestProcessing = false;
    function getrecords(pdf) {
      if (pdf) vm.requestProcessingPDF = true;
      else vm.requestProcessing = true;
      var endDate = moment(vm.todate).format("YYYY-MM-DD");
      var startDate = moment(vm.fromdate).format("YYYY-MM-DD");
      var pdfendDate = moment(vm.todate).format("MM/DD/YY");
      var pdffromDate = moment(vm.fromdate).format("MM/DD/YY");
      vm.csvName = "promo-report-" + startDate + "-to-" + endDate + ".csv";
      vm.pdfName = "promo-report-" + startDate + "-to-" + endDate + ".pdf";
      vm.pageSet = "promoStats";
      var data = {
        start: startDate,
        end: endDate,
        promoIds:
          vm.selectedPromotions.length > 0 ? vm.selectedPromotions : undefined,
        mode: "listing",
        pdf: pdf,
      };

      promoCode.getPromoList(data).then(function (response) {
        var Reportsdata = response;
        if (pdf) vm.requestProcessingPDF = false;
        else vm.requestProcessing = false;

        if (Reportsdata.success) {
          vm.init = true;
          vm.report.heading = Reportsdata.headings;
          vm.report.data = Reportsdata.data;
          vm.totalRoomTypes = Reportsdata.count;
          vm.csvHeader = [];
          vm.pdfHeader = [];
          vm.csvData = [];

          vm.report.heading.forEach(function (element) {
            vm.csvHeader.push(element);
          });
          vm.pdfHeader = angular.copy(vm.csvHeader);
          var i = 0;
          for (var key in vm.report.data) {
            vm.csvData[i] = vm.report.data[key];
            i++;
          }
          setTimeout(function () {
            vm.tbodyHeight =
              document.getElementById("tbodyHeight").clientHeight;
            vm.initialOffset = $("#printSectionId").offset().top;
            vm.table = $("#heightTable");
            vm.bodyCells = vm.table.find("tbody tr").children();
            vm.colWidth;
            $(window)
              .resize(function () {
                vm.colWidth = vm.bodyCells
                  .map(function () {
                    return $(this).width();
                  })
                  .get();
                vm.table
                  .find("thead tr")
                  .children()
                  .each(function (i, v) {
                    $(v).width(vm.colWidth[i]);
                  });
              })
              .resize();

            vm.tableStyle = { "max-height": "calc(100vh - 200px)" };
          }, 1000);
          vm.logo =
            EnvironmentConfig.api +
            "assets/uploads/hotels/logos/" +
            response["logo"];
          vm.pdfHeaderData = {
            startpdf: pdffromDate,
            endpdf: pdfendDate,
            reportname: "Promo Report",
            hotelName: hotelName,
            logo: vm.logo,
          };
        } else if (
          !Reportsdata.success &&
          Reportsdata.errorMsg &&
          Reportsdata.errorMsg != ""
        ) {
          toastMessage.showSimpleToast(Reportsdata.errorMsg, "error-toast");
        } else if (pdf == "pdf" && Reportsdata.status == "success") {
          var filepathToClean = Reportsdata.data.filepath;
          var data = {
            filename: Reportsdata.data.filename,
            filepath: Reportsdata.data.filepath,
          };
          promoCode.downloadDataRequest(data).then(function (response) {
            var file = new Blob([response], {
              type: "application/pdf",
            });
            var fileURL = URL.createObjectURL(file);
            var a = document.createElement("a");
            a.href = fileURL;
            a.download = data.filename;
            document.body.appendChild(a);
            a.click();
            var cleanData = { filepath: filepathToClean };
            $timeout(function () {
              promoCode.cleanDisk(cleanData);
            }, 2000);
          });
        }
      });
    }

    vm.ChangeEndDayIf = function () {
      if (
        !moment(vm.todate).isAfter(vm.fromdate) ||
        moment(vm.todate).isSame(vm.fromdate)
      ) {
        vm.todate = moment(vm.fromdate).add(0, "days").format("MM/DD/YYYY");
      }
    };

    vm.goToPromotionDetails = function (promotionId) {
      if (!promotionId) return;
      var url = $state.href("app.promotion_edit", {
        edit_promotion_id: promotionId,
      });
      window.open(url, "_blank");
    };
  }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('paymentsByEmployeeController', paymentsByEmployeeController)
        .filter('split', function() {
              return function(input, splitChar, splitIndex) {
                  // do some bounds checking here to ensure it has that index
                  return input.split(splitChar)[splitIndex];
              }
          });
    /** @ngInject */
    function paymentsByEmployeeController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $mdDialog,
       $filter,
       $localStorage
    ){
        var vm = this;
		vm.report = {};
    vm.allIds = [];
    vm.selectedChannels = [];
    vm.csvHeader =  ['Date',
                    'Confirmation',
                    'Payment Type',
                    'Employee',
                    'Customer',
                    'Source',
                    'Amount'];
    vm.pdfHeader = angular.copy(vm.csvHeader);
    vm.myDate = new Date();
    vm.allData = [];
    vm.hotelID = $localStorage['preHotelId'];
    vm.channels = [];
    vm.noResultFound = false;

    vm.initialOffset = 0;
    vm.tbodyHeight = 0;              

    // Change the selector if needed
    vm.tableStyle = {};
    vm.table;
    vm.bodyCells;
    vm.colWidth;

    vm.startDate = new Date(
                                this.myDate.getFullYear(),
                                this.myDate.getMonth(),
                                this.myDate.getDate()
                              );
    vm.endDate = new Date(
                                this.myDate.getFullYear(),
                                this.myDate.getMonth(),
                                this.myDate.getDate()
                              );
    vm.selectedHotels = [];
    reportService.getAllChannels().then(function(response){
        if(response.success){
            vm.channels = response.result;
        }
    });

    /*Functions Dec*/
    vm.getEmployeeReports = getEmployeeReports;
    vm.getPrintEmployeeReport = getPrintEmployeeReport;
    vm.calculateTotal = calculateTotal;
    vm.reinitialize = reinitialize();
    vm.childInd = 1111;
    vm.parentIndex = 1111;
    vm.csvData = [];
    function reinitialize(){
      vm.quantity = 0;
    }
     vm.overAll = [];
     vm.dataLength = 0;


    function calculateTotal(data, parentIndex, childInd){
      vm.dataLength = parseInt(vm.dataLength) + parseInt(1);
      if(!vm.overAll[parentIndex]){
        vm.overAll[parentIndex] = {};
      }
      if(!vm.overAll[parentIndex]["overAll"]){
        vm.overAll[parentIndex]["overAll"] = 0;
      }
      if(!vm.overAll[parentIndex][childInd]){
        vm.overAll[parentIndex][childInd] = 0;
      }
        // if(data > 0){
      if(vm.childInd != childInd ||vm.parentIndex != parentIndex){
          reinitialize();
          vm.childInd = childInd;
          vm.parentIndex = parentIndex;
      }
      var income = angular.copy(data);
      vm.quantity = parseFloat(vm.quantity) + parseFloat(data);
      vm.overAll[parentIndex][childInd] = angular.copy(vm.quantity);
      vm.overAll[parentIndex]["overAll"] = parseFloat(data) + parseFloat(vm.overAll[parentIndex]["overAll"]);
        // }
      var tempVar = 0;
          // if(vm.dataLength == vm.csvData.length){
          //     for(var tempKey in vm.overAll){
          //          for(var tempKeySub in vm.overAll[tempKey]){
          //                 tempVar = parseFloat(tempVar) + parseFloat(vm.overAll[tempKey][tempKeySub]);
          //          }
          //     }
          //   var data = ['','','','','','',$filter('currency')(tempVar,'$',2)]
          //   vm.csvData.push(data);
          // }



    }
    vm.requestProcessingEmail = false;
    vm.emailRecords = emailRecords;
    function emailRecords(){
      $mdDialog.show({
              controller: 'getEmailAddress',
              controllerAs: 'vm',
            templateUrl: 'app/main/apps/reports/getEmailAddress.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose:true ,

          })
          .then(function(answer) {
               // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
             if(typeof answer != 'undefined'){
              vm.requestProcessingEmail = true;
              var params = {
                  startDate:new Date(moment(vm.startDate).format('YYYY-MM-DD')),
                  endDate:new Date(moment(vm.endDate).format('YYYY-MM-DD')),
                  selectedChannels:vm.selectedChannels,
                  mode:'sendEmail',
                  emailAddress:answer,
                  'selectedHotels':vm.selectedHotels,
                  'requestFor': vm.reportFor
              };
              reportService.getEmployeeReports(params).then(function(){
                vm.requestProcessingEmail = false;
              });
          }
         }, function() {});
    }

	//getEmployeeReports();
    vm.requestProcessing = false;
    function getEmployeeReports(){
      vm.overAll = [];
      vm.csvData = [];
      vm.amountCollected = [];
      vm.requestProcessing = true;
      vm.EmployeeData = [];
      var startDate = moment(vm.startDate).format('YYYY-MM-DD');
      var endDate = moment(vm.endDate).format('YYYY-MM-DD'); 
      vm.csvName = 'payments-by-employee-'+startDate+'-'+endDate+'.csv';
      vm.pdfName = 'payments-by-employee-'+startDate+'-'+endDate+'.pdf';
        reportService.getEmployeeReports({
            startDate         :   new Date(startDate),
            endDate           :   new Date(endDate),
            selectedChannels  :   vm.selectedChannels,
            mode              :   'listing',
            'selectedHotels'  :   vm.selectedHotels,
            'requestFor'      :   vm.reportFor
        }).then(function(response){
          vm.requestProcessing = false;
          reinitialize();
          vm.EmployeeData = response['result'];
          vm.amountCollected = response['amountCollected'];
          vm.employeeDatakeys =  Object.keys(vm.EmployeeData); 
          vm.noResultFound = true;
          var total = parseFloat(0);
          angular.forEach(vm.employeeDatakeys, function(value,key){
            total = parseFloat(0);
            angular.forEach(vm.EmployeeData[value], function(res,index){
              var data = {
                'Date': res.paidDate,
                'Confirmation': res.confirmation_number,
                'Payment Type':res.payment_type,
                'Employee':res.employee,
                'Customer': res.customer,
                'Source':res.source_of_creation,
                'Amount':res.original_paid_amount
              };
              vm.csvData.push(data);
              total += parseFloat(res.original_paid_amount);
            });
            angular.forEach(vm.amountCollected[value], function(amount, mode) {
              vm.csvData.push({
                'Date': mode,
                'Confirmation': '',
                'Payment Type':'',
                'Employee':'',
                'Customer': '',
                'Source':'',
                'Amount':amount
              });
            }); 
            vm.csvData.push({
              'Date': 'Total',
              'Confirmation': '',
              'Payment Type':'',
              'Employee':'',
              'Customer': '',
              'Source':'',
              'Amount':total
            });
            vm.csvData.push({
              'Date': '',
              'Confirmation': '',
              'Payment Type':'',
              'Employee':'',
              'Customer': '',
              'Source':'',
              'Amount': ''
            });
          });
          setTimeout(function(){              
            angular.forEach(vm.EmployeeData, function(key,value){
              var childKey = value.split(' ')[0];
              vm.tbodyHeight = document.getElementsByClassName('tbodyHeight'+childKey).clientHeight;
              vm.initialOffset = $('#table-container').offset().top;
                vm.table = $('.heightTable'+childKey);
                vm.bodyCells = vm.table.find('tbody tr:first').children();
                vm.colWidth;
              // Adjust the width of thead cells when window resizes
              $(window).resize(function() {
                  // Get the tbody columns width array
                  vm.colWidth = vm.bodyCells.map(function() {
                      return $(this).width();
                  }).get();
                  
                  // Set the width of thead columns
                  vm.table.find('thead tr').children().each(function(i, v) {
                      $(v).width(vm.colWidth[i]);
                  });    
              }).resize(); // Trigger resize handler

              vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };
            });
          },0);
          console.log("Overall total", vm.overAll);
        });
    }

    function getPrintEmployeeReport(pdf){
        vm.requestProcessingPDF = true;
        reportService.getEmployeeReports({
            startDate         :   moment(vm.startDate).format('YYYY-MM-DD'),
            endDate           :   moment(vm.endDate).format('YYYY-MM-DD'),
            selectedChannels  :   vm.selectedChannels,
            mode              :   'listing',
            'selectedHotels'  :   vm.selectedHotels,
            'requestFor'      :   vm.reportFor,
            pdf               :   pdf
        }).then(function(response){
            vm.requestProcessingPDF = false;
            if(response.data && pdf=='pdf'){
                var filepathToClean = response.data.filepath;
                var data = {
                    filename:response.data.filename,
                    filepath:response.data.filepath
                };
                lodgingStatistic.download_data_request(data).then(function(response){
                    //return;
                    var file = new Blob([ response ], {
                        type : 'application/pdf'
                    });
                    //trick to download store a file having its URL
                    var fileURL = URL.createObjectURL(file);
                    var a         = document.createElement('a');
                    a.href        = fileURL; 
                    //a.target      = '_blank';
                    a.download    = data.filename;
                    document.body.appendChild(a);
                    a.click();
                    var cleanData = {filepath:filepathToClean};
                    $timeout(function() {
                        lodgingStatistic.cleanDisk(cleanData);
                    }, 2000);
                });
            }

        });
    }

    vm.ChangeEndDayIf = function(){
      if(!moment(vm.endDate).isAfter(vm.startDate)){
        vm.endDate = moment(vm.startDate).add(0, 'days').format('M/D/Y');
      }
    }
  }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('paymentReceivedController', paymentReceivedController)
        .filter('split', function() {
              return function(input, splitChar, splitIndex) {
                  // do some bounds checking here to ensure it has that index
                  return input.split(splitChar)[splitIndex];
              }
          });

    /** @ngInject */
    function paymentReceivedController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $filter,
       $mdDialog,
       $localStorage
    ){
        var vm = this;
		    vm.report = {};
        vm.allIds = [];
        vm.selectedChannels = [];
        vm.csvHeader =  ['Date',
                          'Confirmation Number',
                          'Hotel',
                          'Employee',
                          'Customer',
                          'Source',
                          'Reservation Status',
                          'Transaction Id',
                          'Payment Details',
                          'Payment Status',
                          'Amount'];
        vm.pdfHeader = angular.copy(vm.csvHeader);
        vm.printInCsv = 'installment_paid_date,confirmation_number,hotel_title,Employee,Customer,source_of_creation,room_stay_status,txn_id,payment_details,installment_status,paidToday';              
        vm.doNotPrintInCsv = 'cc_number,cc_type,payment_method';                  

        vm.myDate = new Date();
        vm.allData = [];

        vm.initialOffset = 0;
        vm.tbodyHeight = 0;       
        // Change the selector if needed
        vm.tableStyle = {};
        vm.table;
        vm.bodyCells;
        vm.colWidth;

        vm.hotelID = $localStorage['preHotelId'];

        vm.channels = [];
        vm.startDate = new Date(
                                    this.myDate.getFullYear(),
                                    this.myDate.getMonth(),
                                    this.myDate.getDate()
                                  );
        vm.endDate = new Date(
                                    this.myDate.getFullYear(),
                                    this.myDate.getMonth(),
                                    this.myDate.getDate()
                                  );
        vm.selectedHotels = [];
        reportService.getAllChannels().then(function(response){
            if(response.success){
                vm.channels = response.result;
            }
        });

        /*Functions Dec*/
        vm.getIncomeReport = getIncomeReport;
        vm.getPrintPaymentReceived = getPrintPaymentReceived;
        vm.getValues = getValues;
        vm.compareDate = compareDate;
        vm.calculateTotal = calculateTotal;

        
        vm.reinitialize = reinitialize;
        reinitialize();
        function reinitialize(){
        vm.price = 0;       
        }
        vm.overAll = new Array();
        vm.pindex = '1111';
        vm.countLoopElement = 0;
        vm.curLen =  0;


        function calculateTotal(data, pindex, count,status){
          vm.countLoopElement = parseInt(vm.countLoopElement) + parseInt(1);
          if(vm.pindex != pindex){             
                reinitialize();
                vm.pindex = pindex;
            }

            var price = angular.copy(data);
            if(status == 'paid'){
            vm.price = parseFloat(vm.price) + parseFloat(data);
            vm.grandTotal = parseFloat(vm.grandTotal) + parseFloat(data); 
            }
            else{
            vm.price = parseFloat(vm.price) + parseFloat(data);
            vm.grandTotal = parseFloat(vm.grandTotal) + parseFloat(data);
            }

            vm.price = commonService.roundnum(parseFloat(vm.price),2); 
            vm.grandTotal = commonService.roundnum(parseFloat(vm.grandTotal),2);
            vm.overAll[pindex] = {};
            if(vm.countLoopElement == (Object.keys(vm.allData).length)){
              var total = {
                            installment_paid_date:'',
                            confirmation_number:'',
                            hotel_title:'',
                            Employee:'',
                            Customer:'',
                            source_of_creation:'',
                            room_stay_status:'',
                            txn_id:'',
                            payment_details:'',
                            installment_status:'Total',
                            paidToday:vm.grandTotal
                          };
              vm.allData.push(total);
              
            }
            vm.overAll[pindex]['subTotal'] = angular.copy(vm.price); 

        }

        function compareDate(date1, date2,index){
            var startDate = moment(date1);
            var endDate = moment(date2);
            if(startDate > endDate || startDate < endDate){
                vm.currentDate = date2;
                return true;
            } else {
                return false;
            }

        }
        vm.noResultFound = false;

        function getValues(date){
            vm.currentDate  = angular.copy(date);
            return vm.currentDate;
        }
	//	getIncomeReport();
    vm.requestProcessing = false;

        function getIncomeReport(){
          vm.allData = [];
          vm.countLoopElement = 0;
          vm.curLen =  0;
          vm.grandTotal = 0;
          vm.paymentReceived = {};

          vm.requestProcessing = true;

          var endDate = moment(vm.endDate).format('YYYY-MM-DD');
          var startDate = moment(vm.startDate).format('YYYY-MM-DD');
          vm.csvName =  'payment-received-'+startDate+'-to-'+endDate+'.csv';
          vm.pdfName =  'payment-received-'+startDate+'-to-'+endDate+'.pdf';
            reinitialize();
            reportService.getAllPaymentReceived({
                startDate         :   new Date(startDate),
                endDate           :   new Date(endDate),
                selectedChannels  :   vm.selectedChannels,
                mode              :   'listing',
                'selectedHotels'  :   vm.selectedHotels,
                'requestFor'      :   vm.reportFor
            }).then(function(response){
              vm.noResultFound = true; 

              vm.requestProcessing = false;
              reinitialize();
              vm.len = Object.keys(response['paymentReceived']).length - 1;
                vm.paymentReceived = response['paymentReceived'];
                  for (var key in vm.paymentReceived) {
                    vm.noResultFound = false;
                    vm.allData = vm.allData.concat(vm.paymentReceived[key]); 
                  }
                  
                  setTimeout(function(){
                    angular.forEach(vm.paymentReceived, function(key,value){
                      var value2 = value.split(' ')[0];
                      vm.tbodyHeight = document.getElementById('tbodyHeight'+value2).clientHeight;
                      vm.initialOffset = $('#printSectionId').offset().top;
                      vm.table = $('#heightTable'+value2);
                      vm.bodyCells = vm.table.find('tbody tr:first').children();
                      vm.colWidth;
                      // Adjust the width of thead cells when window resizes
                      $(window).resize(function() {
                          // Get the tbody columns width array
                          vm.colWidth = vm.bodyCells.map(function() {
                              return $(this).width();
                          }).get();
                    
                           // Set the width of thead columns
                          vm.table.find('thead tr').children().each(function(i, v) {
                              $(v).width(vm.colWidth[i]);
                           });    
                      }).resize(); // Trigger resize handler

                      vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };
                      //remove Housekeepingtable  simple (from table id)  ms-responsive-table
                  });
                },100);
            });
        } 

        function getPrintPaymentReceived(pdf){
            vm.requestPDF = true;
            reportService.getAllPaymentReceived({
                startDate         :   moment(vm.startDate).format('YYYY-MM-DD'),
                endDate           :   moment(vm.endDate).format('YYYY-MM-DD'),
                selectedChannels  :   vm.selectedChannels,
                'selectedHotels'  :   vm.selectedHotels,
                'requestFor'      :   vm.reportFor,
                pdf               :   pdf
            }).then(function(response){
                vm.requestPDF = false;
                if(response.status == 'success' && pdf=='pdf'){
                    var filepathToClean = response.data.filepath;
                    var data = {
                        filename:response.data.filename,
                        filepath:response.data.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        //return;
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
                            lodgingStatistic.cleanDisk(cleanData);
                        }, 2000);
                    });
                } 
            });
        } 




    vm.printRecords = printRecords;
    vm.requestProcessingEmail = false;
    function printRecords(){

      $mdDialog.show({
                    controller: 'getEmailAddress',
                    controllerAs: 'vm',
                  templateUrl: 'app/main/apps/reports/getEmailAddress.html',
                  parent: angular.element(document.body),
                  targetEvent: event,
                  clickOutsideToClose:true ,
                                  
                })
                .then(function(answer) {
                     // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                   if(typeof answer != 'undefined'){
                    vm.requestProcessingEmail = true;
                    var endDate = new Date(moment(vm.endDate).format('YYYY-MM-DD'));
                    var startDate = new Date(moment(vm.startDate).format('YYYY-MM-DD'));
                    vm.csvName =  'income-reports'+startDate+'-to-'+endDate+'.csv';
                      reinitialize();
                      reportService.getAllPaymentReceived({
                          startDate:startDate,
                          endDate:endDate,
                          selectedChannels:vm.selectedChannels,
                          emailAddress:answer,
                          mode:'sendEmail',
                          'selectedHotels':vm.selectedHotels
                      }).then(function(response){
                        vm.requestProcessingEmail = false;
                        });
           
        }
               }, function() {});

     }
     vm.printData = printData;

 function printData(){
            vm.printRequest = true;
             vm.print = true;
            var innerContents = document.getElementById('printSectionId').innerHTML;
             var myWindow=window.open('','','', '');
                myWindow.document.write(innerContents);
                myWindow.print();
                myWindow.document.close();
                myWindow.focus();
                vm.printRequest = false;
                vm.print = false;

        }
      vm.ChangeEndDayIf = function(){
          if(!moment(vm.endDate).isAfter(vm.startDate)){
          vm.endDate = moment(vm.startDate).add(0, 'days').format('M/D/Y');
          }
        } 



    }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('nightAuditShortController', nightAuditShortController);

    /** @ngInject */
    function nightAuditShortController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $filter,
       $localStorage
    ){
        var vm = this;
		vm.report = {};
        vm.allIds = [];
        vm.all = [];
        vm.logo = EnvironmentConfig.api;

        vm.myDate = new Date();
        vm.print = false;
        vm.total = 0;
        vm.paid = 0;
        vm.remaining = 0; 
        vm.departureDate = new Date(
                                    this.myDate.getFullYear(),
                                    this.myDate.getMonth(),
                                    this.myDate.getDate()
                                  );

        /*Calclate Total*/
        vm.CurCount = 0;
        vm.calculate = calculate;
        vm.selectedHotels = [];
        if($localStorage['preHotelId'] !== undefined && $localStorage['preHotelId'] == 126){
            vm.csvHeader = ['Room','Customer','Type of Reservation'];
        } else {
            vm.csvHeader = ['Room','Customer']
        }
        vm.showReportFor = false;
        vm.reportFor = 'all';
        if($localStorage['preHotelId'] !== undefined && $localStorage['preHotelId'] == 126){
            vm.reportFor = 'reservation';
            vm.showReportFor = true;
        }

        function calculate(data,key){
            vm.CurCount = parseInt(vm.CurCount) + parseInt(1);
            vm.total = parseFloat(vm.total) + parseFloat(data.total_amount);
            vm.paid = parseFloat(vm.paid) + parseFloat(data.total_paid_amount);
            vm.remaining = parseFloat(vm.remaining) + parseFloat(data.total_remaining_amount);

             if(vm.CurCount == vm.nightAudit.length){
                 var sumArray = [
                             '',
                             '',
                             '',
                             '',
                             '',
                             '',
                             '',
                             $filter('currency')(vm.total,'$',2),
                             $filter('currency')(vm.paid,'$',2),
                             $filter('currency')(vm.remaining,'$',2)
                             ];
                             vm.all.push(sumArray);
            }

        }

        /*Functions Dec*/
        vm.getReports = getReports;
        vm.getPrintNightShort = getPrintNightShort;
        vm.init = false;
		// getReports();

        function getReports(){
            vm.refreshRequest = true;
            vm.total = 0; vm.paid = 0; vm.remaining = 0; vm.CurCount = 0; vm.all = [];
            var departureDate = moment(vm.departureDate).format('YYYY-MM-DD');
            vm.csvName = 'nightaudit-'+departureDate+'.csv';
            reportService.getAllNightAudit({
                date:new Date(departureDate),
                'selectedHotels':vm.selectedHotels,
                type:'short',
                reportFor: vm.reportFor
            }).then(function(response){
                vm.refreshRequest = false;
                vm.logo = EnvironmentConfig.api+'assets/uploads/hotels/logos/'+response['logo'];
                
                vm.nightAudit = response['nightAudit'];
                for(var i in response['nightAudit']){
                    vm.all = vm.all.concat(response['nightAudit'][i]);
                    if(response['nightAudit'][i]['type_of_reservation']!== undefined){
                        vm.type_of_reservation = response['nightAudit'][0]['type_of_reservation'];
                    }
                
                }
                setTimeout(function(){
                    vm.tbodyHeight = document.getElementById('tbodyHeight').clientHeight;
                    vm.initialOffset = $('#printSectionId').offset().top;
                    vm.table = $('#heightTable');
                    vm.bodyCells = vm.table.find('tbody tr:first').children();
                    vm.colWidth;
                    // Adjust the width of thead cells when window resizes
                    $(window).resize(function() {
                        // Get the tbody columns width array
                        vm.colWidth = vm.bodyCells.map(function() {
                            // console.log($(this).width());
                            return $(this).width();
                        }).get();
                  
                         // Set the width of thead columns
                        vm.table.find('thead tr').children().each(function(i, v) {
                            // console.log(i,v);
                            // vm.colWidth[i]+=100;
                            $(v).width(vm.colWidth[i]);
                        });    
                    }).resize(); // Trigger resize handler
                    vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };
                },100);


            });

        }

        function getPrintNightShort(pdf){
            vm.refreshRequestPDF = true;
            reportService.getAllNightAudit({
                date:moment(vm.departureDate).format('YYYY-MM-DD'),
                'selectedHotels':vm.selectedHotels,
                type:'short',
                reportFor: vm.reportFor,
                pdf:pdf
            }).then(function(response){
                vm.refreshRequestPDF = false;
                if(response.status == 'success' && pdf=='pdf'){
                    var filepathToClean = response.data.filepath;
                    var data = {
                        filename:response.data.filename,
                        filepath:response.data.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        //return;
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
                            lodgingStatistic.cleanDisk(cleanData);
                        }, 2000);
                    });
                } 
            });
        }

        vm.printData = printData;
        function printData(){
             vm.print = true;
             vm.printRequest = true;
            // var w=window.open();
            var innerContents = document.getElementById('printSectionId').innerHTML;
            // w.document.write(innerContents);

            var myWindow=window.open('','','', '');
                myWindow.document.write(innerContents);
                myWindow.print();
                myWindow.document.close();
                myWindow.focus();
                vm.printRequest = false;
                vm.print = false;
            
        }   

    }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('nightAuditNewController', nightAuditNewController);

    /** @ngInject */
    function nightAuditNewController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $localStorage,
       $rootScope,
       $state,
       $window
    ){
        var vm = this;
		vm.report = {};
        vm.logo = EnvironmentConfig.api;
        vm.hotelID = $localStorage['preHotelId'];
        vm.initialDate = new Date('2019', '00', '01');
        
        if ($localStorage['preHotelId'] != 126){
            vm.reportFor = 'hotel';
        } else{
            vm.reportFor = 'all';
        }
        vm.initialOffset = 0;
        vm.tbodyHeight = 0;       
        // Change the selector if needed
        vm.tableStyle = {};
        vm.table;
        vm.bodyCells;
        vm.colWidth;

        vm.myDate = new Date();
        vm.print = false;
       
        vm.departureDate = new Date(this.myDate.getFullYear(), this.myDate.getMonth(), this.myDate.getDate());
        vm.departureDateTo = new Date(this.myDate.getFullYear(), this.myDate.getMonth(), this.myDate.getDate());

        vm.selectedHotels = [];
        /*Functions Dec*/
        vm.getReports = getReports;
        vm.init = false;
		
        function getReports(flag) {
            vm.showGeneratingFlag = true;
            vm.refreshRequest = true;
            var departureDate = moment(vm.departureDate).format('MM-DD-YYYY');
            var departureDateTo = moment(vm.departureDateTo).format('MM-DD-YYYY');
           
            reportService.getNightAuditNew({
                start:moment(departureDate).format('YYYY-MM-DD'),
                end:moment(departureDateTo).format('YYYY-MM-DD'),
                selected_hotel:vm.selectedHotels,
                reportFor: vm.reportFor,
                flag: flag
            }).then(function(response){
                vm.nightAudit = response.data;
                vm.objKeys = Object.keys(response.data);
                vm.defaultValue = "$" + commonService.roundnum(0,2);
                vm.hotelData = response.hotelData;

                vm.refreshRequest = false;
                vm.logo = EnvironmentConfig.api+'assets/uploads/hotels/logos/'+response['logo'];
                
                setTimeout(function(){
                    vm.initialOffset = $('#table-container').offset().top;
                    vm.tableOuter = $('#tableOuter');
                    vm.tableInner = $('#tableInner');
                    vm.subcategoryTable = $('#subcategory-table');
                    vm.bodyCells = vm.tableInner.find('tbody tr:nth-child(4)').children();
                    vm.colWidth;
                    // Adjust the width of thead cells when window resizes 
                    $(window).resize(function() {
                        // Get the tbody columns width array
                        vm.colWidth = vm.bodyCells.map(function() {
                            return $(this).width();
                        }).get();
                        
                        // Set the width of thead columns
                        vm.tableOuter.find('thead tr').children().each(function(i, v) {
                            $(v).width(vm.colWidth[i]);
                        });
                        vm.subcategoryTable.find('tbody tr').children().each(function(i, v) {
                            $(v).width(vm.colWidth[i]);
                        });    
                    }).resize(); // Trigger resize handler
                    vm.tableOuterStyle = { "max-height" : "calc(100vh - 200px)" };
                },500);
                vm.showGeneratingFlag = false;
            });
        }

        vm.exportFile = exportFile;
        vm.exportLoader = false;
        vm.csvLoader = false;
        
        function exportFile(type) {
            if(type == 'pdf') {
                vm.exportLoader = true;
            } else {
                vm.csvLoader = true;
            }

            var departureDate = moment(vm.departureDate).format('MM-DD-YYYY');
            var departureDateTo = moment(vm.departureDateTo).format('MM-DD-YYYY');
            if(departureDate === departureDateTo) {
                vm.csvName = 'nightaudit-'+departureDate+'.csv';
            } else {
                vm.csvName = 'nightaudit-'+departureDate + ' - '+ departureDateTo +'.csv';
            }

            reportService.getNightAuditPdfCsv({
                start:moment(vm.departureDate).format('YYYY-MM-DD'),
                end:moment(vm.departureDateTo).format('YYYY-MM-DD'),
                selected_hotel: vm.selectedHotels,
                reportFor: vm.reportFor,
                type: type,
                data: vm.nightAudit
             }).then(function(response){
                if(type == 'pdf') {
                    vm.exportLoader = false;
                    var filepathToClean = response.data.filepath;
                    var data = {
                        filename:response.data.filename,
                        filepath:response.data.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
                            lodgingStatistic.cleanDisk(cleanData);
                        }, 2000);
                    });
                } else {
                    vm.csvLoader = false;
                    vm.csvHeader = ['','Total Revenue','Total Tourist Development Tax Collected', 'Total Sales Tax Collected', 'CC Processing Fee', 'Grand Total'];
                    vm.csvData = response.data;
                    var date = moment(new Date(departureDate)).format('YYYY-MM-DD');
                    vm.csvName =  'night-audit-'+departureDate+'.csv';
                    $rootScope.downloadFile(vm.csvHeader, vm.csvData, vm.csvName);
                }
            });
        }

        vm.checkSchedule = function(type) {
            if(type == 'from') {
                vm.departureDateTo = vm.departureDate;
            } 
            var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds    
            vm.numberOfDays = Math.round(Math.abs((vm.departureDate.getTime() - vm.departureDateTo.getTime())/(oneDay)));
            if(vm.numberOfDays > 30) {
                vm.numberOfDays = 30;
            }
            vm.startDate = new Date(vm.departureDate);
            vm.newEndDate = vm.startDate;
            vm.newEndDate.setDate(this.newEndDate.getDate() + 30);
            vm.endDate = vm.startDate;
            vm.endDate.setDate(this.endDate.getDate() + vm.numberOfDays); 
        }

        /**
        * Show detail on click of row
        */
        vm.showNightAuditDetail = function(type, index) {
            var hotels = ''; 
            if (vm.selectedHotels.length) {
                for (var i = 0; i < vm.selectedHotels.length; i++) {
                    hotels += vm.selectedHotels[i];
                    if (i != vm.selectedHotels.length- 1) {
                        hotels += "=";
                    }
                }
            }
            if (hotels != '') {
                hotels = btoa(hotels);
            }
            var amt = vm.nightAudit[type][index].subTotal != undefined ? parseFloat(vm.nightAudit[type][index].subTotal) : 0;
            if (amt != 0) {
                vm.reportFor = vm.reportFor != undefined && vm.reportFor != '' ? vm.reportFor : 'hotel';
                var getData = 'nightAudit&'+index+'&'+moment(vm.departureDate).format('YYYY-MM-DD')+'&'+moment(vm.departureDateTo).format('YYYY-MM-DD')+'&'+vm.reportFor;
                if (hotels != '') {
                    getData += "&"+hotels;
                }
                var url = $state.href("app.reports.detail",{param:getData});
                $window.open(url, '_blank');
            }
        };
    }
})();
(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('nightAuditLatestController', nightAuditLatestController);

    /** @ngInject */
    function nightAuditLatestController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $localStorage,
       $filter,
       $rootScope
    ){
        var vm = this;
		vm.report = {};
        vm.allIds = [];
        vm.all = [];
        vm.logo = EnvironmentConfig.api;
        vm.hotelID = $localStorage['preHotelId'];
        
        vm.initialOffset = 0;
        vm.tbodyHeight = 0;       
        // Change the selector if needed
        vm.tableStyle = {};
        vm.table;
        vm.bodyCells;
        vm.colWidth;


        vm.myDate = new Date();
        vm.print = false;
        vm.total = 0;
        vm.paid = 0;
        vm.remaining = 0; 
        vm.departureDate = new Date(
                                    this.myDate.getFullYear(),
                                    this.myDate.getMonth(),
                                    this.myDate.getDate()
                                  );
        vm.departureDateTo = new Date(
                                    this.myDate.getFullYear(),
                                    this.myDate.getMonth(),
                                    this.myDate.getDate()
                                  );

        /*Calclate Total*/
        vm.CurCount = 0;
        vm.calculate = calculate;
        vm.selectedHotels = [];
        vm.showGeneratingFlag = false;
        function calculate(data,key){
            vm.CurCount = parseInt(vm.CurCount) + parseInt(1);
            vm.total = parseFloat(vm.total) + parseFloat(data.total_amount);
            vm.paid = parseFloat(vm.paid) + parseFloat(data.total_paid_amount);
            vm.remaining = parseFloat(vm.remaining) + parseFloat(data.total_remaining_amount);

             if(vm.CurCount == vm.nightAudit.length){
                 var sumArray = [
                             '',
                             '',
                             '',
                             '',
                             '',
                             '',
                             '',
                             $filter('currency')(vm.total,'$',2),
                             $filter('currency')(vm.paid,'$',2),
                             $filter('currency')(vm.remaining,'$',2)
                             ];
                             vm.all.push(sumArray);
             }


        }

        /*Functions Dec*/
        vm.getReports = getReports;
        vm.init = false;
		// getReports();

        function getReports(flag){
            vm.showGeneratingFlag = true;
            vm.refreshRequest = true;
            vm.total = 0; vm.paid = 0; vm.remaining = 0; vm.CurCount = 0; vm.all = [];
            var departureDate = moment(vm.departureDate).format('MM-DD-YYYY');
            var departureDateTo = moment(vm.departureDateTo).format('MM-DD-YYYY');
            if(departureDate === departureDateTo) {
                vm.csvName = 'nightaudit-'+departureDate+'.csv';
            } else {
                vm.csvName = 'nightaudit-'+departureDate + ' - '+ departureDateTo +'.csv';
            }
            reportService.getAllNightAuditFormatSkipjack({
                date:moment(departureDate).format('YYYY-MM-DD'),
                dateTo:moment(departureDateTo).format('YYYY-MM-DD'),
                'selectedHotels':vm.selectedHotels,
                reportFor: vm.reportFor,
                flag: flag
            }).then(function(response){
                vm.objKeys = Object.keys(response);
                vm.lodgingTax = 'Lodging Tax';
                vm.salesTax = 'Sales Tax';
                vm.hotelTitle = 'hotels';
                vm.marinaTitle = 'marina';
                vm.restaurantTitle = 'restaurant';
                vm.merchandiseTitle = 'merchandise';
                vm.advancedRentalTitle = 'advancedRental';
                vm.defaultValue = commonService.roundnum(0,2);
                vm.hotelData = response.hotelData;

                vm.refreshRequest = false;
                vm.logo = EnvironmentConfig.api+'assets/uploads/hotels/logos/'+response['logo'];
                
                // vm.nightAudit = response['nightAudit'];
                vm.nightAudit = response;

                for(var i in response['nightAudit']){
                    vm.all = vm.all.concat(response['nightAudit'][i]); 
                }
                setTimeout(function(){
                    vm.initialOffset = $('#table-container').offset().top;
                    vm.tableOuter = $('#tableOuter');
                    vm.tableInner = $('#tableInner');
                    vm.subcategoryTable = $('#subcategory-table');
                    vm.bodyCells = vm.tableInner.find('tbody tr:nth-child(4)').children(); 
                    vm.colWidth;
                    // Adjust the width of thead cells when window resizes 
                    $(window).resize(function() {
                        // Get the tbody columns width array
                        vm.colWidth = vm.bodyCells.map(function() {
                            return $(this).width();
                        }).get();
                        
                        // Set the width of thead columns
                        vm.tableOuter.find('thead tr').children().each(function(i, v) {
                            $(v).width(vm.colWidth[i]);
                        });
                        vm.subcategoryTable.find('tbody tr').children().each(function(i, v) {
                            $(v).width(vm.colWidth[i]);
                        });    
                    }).resize(); // Trigger resize handler
                    vm.tableOuterStyle = { "max-height" : "calc(100vh - 200px)" };
                },500);
                vm.showGeneratingFlag = false;
            });

        }



        vm.printData = printData;
        function printData(){
             vm.print = true;
             vm.printRequest = true;
            // var w=window.open();
            var innerContents = document.getElementById('printSectionId').innerHTML;
            // w.document.write(innerContents);

            var myWindow=window.open('','','', '');
                myWindow.document.write(innerContents);
                myWindow.print();
                myWindow.document.close();
                myWindow.focus();
                vm.printRequest = false;
                vm.print = false;


            // $timeout(function(){
            //    vm.print = false;
            // },550);
            // $timeout(function(){
            //         w.print();
            //         w.close();
            //          vm.print = false;
            // },500);
            
        }   

        vm.exportFile = exportFile;
        vm.exportLoader = false;
        vm.csvLoader = false;
        function exportFile(type) {
            if(type == 'pdf') {
                vm.exportLoader = true;
            } else {
                vm.csvLoader = true;
            }
            var departureDate = moment(vm.departureDate).format('YYYY-MM-DD');
            var departureDateTo = moment(vm.departureDateTo).format('YYYY-MM-DD');
            var departureDateFormat = moment(vm.departureDate).format('MM-DD-YYYY');
            var departureDateToFormat = moment(vm.departureDateTo).format('MM-DD-YYYY');
            reportService.getAllNightAuditFormatSkipjack({
                date:departureDate,
                dateTo:departureDateTo,
                'selectedHotels':vm.selectedHotels,
                reportFor: vm.reportFor,
                type: type
            }).then(function(response){
                if(type == 'pdf') {
                    vm.exportLoader = false;
                    var filepathToClean = response.data.filepath;
                    var data = {
                        filename:response.data.filename,
                        filepath:response.data.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
                            lodgingStatistic.cleanDisk(cleanData);
                        }, 2000);
                    });
                } else {
                    vm.csvLoader = false;
                    vm.csvHeader = ['','Total Revenue','Total Tourist Development Tax Collected', 'Total Sales Tax Collected', 'Grand Total'];
                    vm.csvData = response;
                    var date = moment(new Date(departureDate)).format('YYYY-MM-DD');
                    if(departureDate === departureDateTo) {
                        vm.csvName = 'nightaudit-'+departureDateFormat+'.csv';
                    } else {
                        vm.csvName = 'nightaudit-'+departureDateFormat + ' - '+ departureDateToFormat +'.csv';
                    }
                    $rootScope.downloadFile(vm.csvHeader, vm.csvData, vm.csvName);
                }
            });
        }

        vm.paymentTotalCalculate = function(paymentDetails) {
            var paymentmethods = [
                'MasterCard',
                'Visa',
                'Other',
                'Cash',
                'Discover',
                'Check',
                'Gift Card',
                'AmericanExpress'
            ];
            var totalpayment = 0.00;
            angular.forEach(paymentDetails, function(value, key) {
                // if(paymentmethods.indexOf(key) > -1) {
                    totalpayment = parseFloat(totalpayment) + parseFloat(value.paid);
                // }
            });
            return parseFloat(Math.round(totalpayment * 100) / 100).toFixed(2);
        }

        // Check date Schedule
        // vm.checkSchedule = function() {
        //     var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds    
        //     vm.numberOfDays = Math.round(Math.abs((vm.departureDate.getTime() - vm.departureDateTo.getTime())/(oneDay)));
        // }

        vm.checkSchedule = function(type) {
            if(type == 'from') {
                vm.departureDateTo = vm.departureDate;
            } 
            var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds    
            vm.numberOfDays = Math.round(Math.abs((vm.departureDate.getTime() - vm.departureDateTo.getTime())/(oneDay)));
            if(vm.numberOfDays > 30) {
                vm.numberOfDays = 30;
            }
            vm.startDate = new Date(vm.departureDate);
            vm.newEndDate = vm.startDate;
            vm.newEndDate.setDate(this.newEndDate.getDate() + 30);
            vm.endDate = vm.startDate;
            vm.endDate.setDate(this.endDate.getDate() + vm.numberOfDays); 
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('nightAuditController', nightAuditController);

    /** @ngInject */
    function nightAuditController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $localStorage,
       $filter
    ){
        var vm = this;
		vm.report = {};
        vm.allIds = [];
        vm.all = [];
        vm.logo = EnvironmentConfig.api;
        vm.hotelID = $localStorage['preHotelId'];
        
        vm.initialOffset = 0;
        vm.tbodyHeight = 0;       
        // Change the selector if needed
        vm.tableStyle = {};
        vm.table;
        vm.bodyCells;
        vm.colWidth;


        vm.myDate = new Date();
        vm.print = false;
        vm.total = 0;
        vm.paid = 0;
        vm.remaining = 0; 
        vm.departureDate = new Date(
                                    this.myDate.getFullYear(),
                                    this.myDate.getMonth(),
                                    this.myDate.getDate()
                                  );

        /*Calclate Total*/
        vm.CurCount = 0;
        vm.calculate = calculate;
        vm.selectedHotels = [];
        function calculate(data,key){
            vm.CurCount = parseInt(vm.CurCount) + parseInt(1);
            vm.total = parseFloat(vm.total) + parseFloat(data.total_amount);
            vm.paid = parseFloat(vm.paid) + parseFloat(data.total_paid_amount);
            vm.remaining = parseFloat(vm.remaining) + parseFloat(data.total_remaining_amount);

             if(vm.CurCount == vm.nightAudit.length){
                 var sumArray = [
                             '',
                             '',
                             '',
                             '',
                             '',
                             '',
                             '',
                             $filter('currency')(vm.total,'$',2),
                             $filter('currency')(vm.paid,'$',2),
                             $filter('currency')(vm.remaining,'$',2)
                             ];
                             vm.all.push(sumArray);
             }


        }

        /*Functions Dec*/
        vm.getReports = getReports;
        vm.printNight = printNight;
        vm.init = false;
		// getReports();

        function getReports(){
            vm.refreshRequest = true;
            vm.total = 0; vm.paid = 0; vm.remaining = 0; vm.CurCount = 0; vm.all = [];
            var departureDate = moment(vm.departureDate).format('YYYY-MM-DD');
            vm.csvName = 'nightaudit-'+departureDate+'.csv';
            reportService.getAllNightAudit({
                date:new Date(departureDate),
                'selectedHotels':vm.selectedHotels,
                reportFor: vm.reportFor
            }).then(function(response){
                vm.refreshRequest = false;
                vm.logo = EnvironmentConfig.api+'assets/uploads/hotels/logos/'+response['logo'];
                
                vm.nightAudit = response['nightAudit'];
                for(var i in response['nightAudit']){
                    vm.all = vm.all.concat(response['nightAudit'][i]); 
                }
                setTimeout(function(){
                    vm.tbodyHeight = document.getElementById('tbodyHeight').clientHeight;
                    vm.initialOffset = $('#printSectionId').offset().top;
                    vm.table = $('#heightTable');
                    vm.bodyCells = vm.table.find('tbody tr:first').children();
                    vm.colWidth;
                    // console.log("-->",vm.table);
                    // Adjust the width of thead cells when window resizes
                    $(window).resize(function() {
                        // Get the tbody columns width array
                        vm.colWidth = vm.bodyCells.map(function() {
                            // console.log($(this).width());
                            return $(this).width();
                        }).get();
                        // console.log(vm.colWidth,'colWidth');
                  
                         // Set the width of thead columns
                        vm.table.find('thead tr').children().each(function(i, v) {
                            // console.log(i,v);
                            // vm.colWidth[i]-=2;
                             $(v).width(vm.colWidth[i]);
                             // console.log($(v).width(vm.colWidth[i] ));
                         });    
                    }).resize(); // Trigger resize handler

                    vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };

                },100);

            });

        }

        function printNight(pdf){
            vm.refreshRequestPDF = true;
            reportService.getAllNightAudit({
                date:moment(vm.departureDate).format('YYYY-MM-DD'),
                'selectedHotels':vm.selectedHotels,
                pdf:pdf,
                reportFor: vm.reportFor
            }).then(function(response){
                vm.refreshRequestPDF = false;
                if(response.status == 'success' && pdf=='pdf'){
                    var filepathToClean = response.data.filepath;
                    var data = {
                        filename:response.data.filename,
                        filepath:response.data.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        //return;
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
                            lodgingStatistic.cleanDisk(cleanData);
                        }, 2000);
                    });
                }
            });
        }

        vm.printData = printData;
        function printData(){
             vm.print = true;
             vm.printRequest = true;
            // var w=window.open();
            var innerContents = document.getElementById('printSectionId').innerHTML;
            // w.document.write(innerContents);

            var myWindow=window.open('','','', '');
                myWindow.document.write(innerContents);
                myWindow.print();
                myWindow.document.close();
                myWindow.focus();
                vm.printRequest = false;
                vm.print = false;


            // $timeout(function(){
            //    vm.print = false;
            // },550);
            // $timeout(function(){
            //         w.print();
            //         w.close();
            //          vm.print = false;
            // },500);
            
        }   

    }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('mReportNewController', mReportController);

    /** @ngInject */
    function mReportController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $filter,
       $localStorage,
       $rootScope
    ){
        var vm       = this;
        vm.pageTitle = 'M3 Accounting New';
        vm.myDate    = new Date();
        vm.print     = false;
        vm.date      = new Date(this.myDate.getFullYear(), this.myDate.getMonth(), this.myDate.getDate());
        vm.xmlData   = '';
        vm.showTable = false;
        /**
        * Fetch report related data from db
        */
        vm.getReports = function(){
            vm.refreshRequest = true;
            reportService.getM3AuditReportNew({
                date: moment(vm.date).format('YYYY-MM-DD')
            }).then(function(response){
                vm.refreshRequest = false;
                vm.logo = EnvironmentConfig.api+'assets/uploads/hotels/logos/'+response.logo;                
                vm.reportData = response.resultData;
                vm.downloadFileName = response.fileName;
                vm.xmlData = response.xmlData;
                vm.showTable = (Object.keys(vm.reportData).length  > 0) ? true : false;
            });
        };

        /**
        * Print the data of table
        */
        vm.printData = function(){
            vm.print = true;
            vm.printRequest = true;
            var innerContents = document.getElementById('printSectionId').innerHTML;
            var myWindow=window.open('','','', '');
            myWindow.document.write(innerContents);
            myWindow.print();
            myWindow.document.close();
            myWindow.focus();
            vm.printRequest = false;
            vm.print = false;
        };  

        /**
        * download the xml file
        */
        vm.downloadXml = function() {
            vm.xmlDownloadRequest = true;
            reportService.getM3AuditReportNew({
                date: moment(vm.date).format('YYYY-MM-DD'),
                type: 'sendM3'
            }).then(function(response){
                vm.xmlDownloadRequest = false;               
                vm.downloadFileName = response.fileName;
            });

            if (vm.xmlData !== undefined && vm.xmlData !== '') {
                var downloadElement = angular.element("a.download");
                downloadElement.attr('href', 'data:application/xml;charset=utf-8,' + vm.xmlData);
                downloadElement.get(0).click();
                downloadElement.removeAttr('href');
                vm.xmlDownloadRequest = false;
            }
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('mReportController', mReportController);

    /** @ngInject */
    function mReportController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $filter,
       $localStorage
    ){
        var vm       = this;
        vm.pageTitle = 'M3 Accounting';
        vm.myDate    = new Date();
        vm.print     = false;
        vm.date      = new Date(this.myDate.getFullYear(), this.myDate.getMonth(), this.myDate.getDate());
        vm.xmlData   = '';
        /**
        * Fetch report related data from db
        */
        vm.getReports = function(){
            vm.refreshRequest = true;
            reportService.getM3AuditReport({
                date: moment(vm.date).format('YYYY-MM-DD')
            }).then(function(response){
                vm.refreshRequest = false;
                vm.logo = EnvironmentConfig.api+'assets/uploads/hotels/logos/'+response.logo;                
                vm.reportData = response.resultData;
                vm.downloadFileName = response.fileName;
                vm.xmlData = response.xmlData;
            });
        };

        /**
        * Print the data of table
        */
        vm.printData = function(){
            vm.print = true;
            vm.printRequest = true;
            var innerContents = document.getElementById('printSectionId').innerHTML;
            var myWindow=window.open('','','', '');
            myWindow.document.write(innerContents);
            myWindow.print();
            myWindow.document.close();
            myWindow.focus();
            vm.printRequest = false;
            vm.print = false;
        };  

        /**
        * download the xml file
        */
        vm.downloadXml = function() {
            vm.xmlDownloadRequest = true;       
            reportService.getM3AuditReport({
                date: moment(vm.date).format('YYYY-MM-DD'),
                type: 'sendM3'
            }).then(function(response){
                vm.xmlDownloadRequest = false;               
                vm.downloadFileName = response.fileName;
            });

            /*if (vm.xmlData !== undefined && vm.xmlData !== '') {
                var downloadElement = angular.element("a.download");
                downloadElement.attr('href', 'data:application/xml;charset=utf-8,' + vm.xmlData);
                downloadElement.get(0).click();
                downloadElement.removeAttr('href');
                vm.xmlDownloadRequest = false;
            }*/
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('LodgingStatisticController', LodgingStatisticController);

	/** @ngInject */
	function LodgingStatisticController(
	   $scope,
	   $state,
	   $stateParams,
	   $http,
	   EnvironmentConfig,
	   toastMessage,
	   lodgingStatistic,
	   $mdDialog,
	   $rootScope,
	   $localStorage,
	   $timeout
	){
		var vm = this;
		vm.loggedRole = $localStorage.roleId !== undefined ? $localStorage.roleId : 0;
		var myDate = new Date();
		var hotelName = '';

		vm.fromdate = new Date(
								myDate.getFullYear(),
								myDate.getMonth(),
								myDate.getDate()
							  );
		vm.todate = new Date(
							myDate.getFullYear(),
							myDate.getMonth(),
							myDate.getDate()
						  );
		vm.report = {};
		//for mddatatable
		$scope.query = {
			order: 'name',
			limit: 5,
			page: 1
		};

 		vm.initialOffset = 0;
        vm.tbodyHeight = 0;       
        // Change the selector if needed
        vm.tableStyle = {};
        vm.table;
        vm.bodyCells;
        vm.colWidth;

		vm.hotelID = $localStorage['preHotelId'];

		if(vm.hotelID == 126){
			hotelName = 'Skipjack';
		} else if(vm.hotelID == 122){
			hotelName = 'Plaza Beach Reports';
		} else if(vm.hotelID == 121){
			hotelName = 'Villa Venezia';
		} else if(vm.hotelID == 120){
			hotelName = 'Coral House';
		} else if(vm.hotelID == 119){
			hotelName = 'Southernmost House';
		} else if(vm.hotelID == 116){
			hotelName = 'Manhattan Tower Apartment';
		}
		var reportName = 'Lodging Statistics Report';

		$scope.selected = [];
		vm.selectedHotels = [];
		vm.getrecords = getrecords;
		vm.printRecords = printRecords;
		$rootScope.getSubHotels($localStorage['preHotelId']);

		vm.reportType = 'hotel';
		vm.requestProcessingEmail = false;
		vm.requestProcessingPDF =  false;

		function printRecords(){
			$mdDialog.show({
				controller: 'getEmailAddress',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/reports/getEmailAddress.html',
				parent: angular.element(document.body),
				targetEvent: event,
				clickOutsideToClose:true,
            })
			.then(function(answer) {
				 // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				 // if(typeof answer != 'undefined' && re.test(answer)){
				if(typeof answer != 'undefined'){
					vm.requestProcessingEmail = true;
					 var data = {
						start:new Date(moment(vm.fromdate).format('YYYY-MM-DD')),
						end:new Date(moment(vm.todate).format('YYYY-MM-DD')),
						mode:'sendMail',
						selected_hotel: vm.selectedHotels,
						emailAddress: answer,
						reportFor: vm.reportFor
					 };
					
					lodgingStatistic.getlodgingData(data).then(function(){
						vm.requestProcessingEmail = false;
					});
				}
            }, function() {});		
		}

		// getrecords();
		vm.requestProcessing = false;
		function getrecords(pdf){
			if(pdf)
				vm.requestProcessingPDF = true;
			else
				vm.requestProcessing = true;
			// var data = {
			// 	start:new Date(moment(vm.fromdate).format('YYYY-MM-DD')),
			// 	end:new Date(moment(vm.todate).format('YYYY-MM-DD')),
			// 	mode:'listing',
			// 	selected_hotel: vm.selectedHotels
			// };
			var endDate = moment(vm.todate).format('YYYY-MM-DD');
          	var startDate = moment(vm.fromdate).format('YYYY-MM-DD');
          	var pdfendDate = moment(vm.todate).format('MM/DD/YY');
			var pdffromDate = moment(vm.fromdate).format('MM/DD/YY');
			vm.csvName =  'lodging-statistic-'+startDate+'-to-'+endDate+'.csv';
			vm.pdfName =  'lodging-statistic-'+startDate+'-to-'+endDate+'.pdf';
			vm.pageSet = 'lodgingstats';
			var data = {
				start:startDate,
				end:endDate,
				mode:'listing',
				selected_hotel: vm.selectedHotels,
				reportFor: vm.reportFor,
				pdf:pdf,
				factReport: 'old'
			};
			
			lodgingStatistic.getFactsLodgingData(data).then(function(response){
				// console.log(response);
				var Reportsdata = response;
				if(pdf)
					vm.requestProcessingPDF = false;
				else
					vm.requestProcessing = false;
				
				if(Reportsdata.success){

					vm.report.heading = Reportsdata.headings;
					vm.report.data = Reportsdata.data;
					vm.totalRoomTypes = Reportsdata.count;
					vm.csvHeader = [];
					vm.pdfHeader = [];
					vm.csvData = [];

					vm.report.heading.forEach(function(element){
						vm.csvHeader.push(element);
					});
					vm.pdfHeader = angular.copy(vm.csvHeader);
					var i = 0;
					for(var key in vm.report.data){
						vm.csvData[i] = vm.report.data[key];
						i++;				
					}
					setTimeout(function(){
              			vm.tbodyHeight = document.getElementById('tbodyHeight').clientHeight;
              			vm.initialOffset = $('#printSectionId').offset().top;
		                vm.table = $('#heightTable');
		                vm.bodyCells = vm.table.find('tbody tr').children();
		                vm.colWidth;
		              	// Adjust the width of thead cells when window resizes
		              	$(window).resize(function() {
	                  		// Get the tbody columns width array
	                  		vm.colWidth = vm.bodyCells.map(function() {
	                      		return $(this).width();
	                  		}).get();
			                 vm.table.find('thead tr').children().each(function(i, v) {
			                     $(v).width(vm.colWidth[i]);
			                });    
			            }).resize(); // Trigger resize handler

              			vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };

            		},1000);
            		vm.logo = EnvironmentConfig.api+'assets/uploads/hotels/logos/'+response['logo'];
            		vm.pdfHeaderData = {
						startpdf:pdffromDate,
						endpdf:pdfendDate,
						reportname:'Lodging Statistics Report',
						hotelName:hotelName,
						logo:vm.logo
					};
				}else if(!Reportsdata.success && Reportsdata.errorMsg && Reportsdata.errorMsg!=''){
					toastMessage.showSimpleToast(Reportsdata.errorMsg, 'error-toast');
				} else if(pdf=='pdf' && Reportsdata.status == 'success'){
					// console.log(Reportsdata);
					var filepathToClean = Reportsdata.data.filepath;
                    var data = {
                        filename:Reportsdata.data.filename,
                        filepath:Reportsdata.data.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        //return;
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
	                        lodgingStatistic.cleanDisk(cleanData);
	                    }, 2000);
					});
				}
			});
		}
		vm.ChangeEndDayIf = function(){
			if(!moment(vm.todate).isAfter(vm.fromdate) || moment(vm.todate).isSame(vm.fromdate)){
				vm.todate = moment(vm.fromdate).add(0, 'days').format('MM/DD/YYYY');
			}
		}
    }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('LodgingStatisticNewController', LodgingStatisticNewController);

	/** @ngInject */
	function LodgingStatisticNewController(
	   $scope,
	   $state,
	   $stateParams,
	   $http,
	   EnvironmentConfig,
	   toastMessage,
	   lodgingStatistic,
	   $mdDialog,
	   $rootScope,
	   $localStorage,
	   $timeout,
	   $window
	){
		var vm = this;
		vm.loggedRole = $localStorage.roleId !== undefined ? $localStorage.roleId : 0;
		var myDate = new Date();
		var hotelName = '';

		vm.initialDate = new Date('2019', '00', '01');
		vm.fromdate = new Date(	myDate.getFullYear(), myDate.getMonth(),	myDate.getDate());
		vm.todate = new Date(myDate.getFullYear(), myDate.getMonth(), myDate.getDate());
		vm.report = {};
		//for mddatatable
		$scope.query = {
			order: 'name',
			limit: 5,
			page: 1
		};

 		vm.initialOffset = 0;
        vm.tbodyHeight = 0;       
        // Change the selector if needed
        vm.tableStyle = {};
        vm.table;
        vm.bodyCells;
        vm.colWidth;

		vm.hotelID = $localStorage['preHotelId'];

		if(vm.hotelID == 126){
			hotelName = 'Skipjack';
		} else if(vm.hotelID == 122){
			hotelName = 'Plaza Beach Reports';
		} else if(vm.hotelID == 121){
			hotelName = 'Villa Venezia';
		} else if(vm.hotelID == 120){
			hotelName = 'Coral House';
		} else if(vm.hotelID == 119){
			hotelName = 'Southernmost House';
		} else if(vm.hotelID == 116){
			hotelName = 'Manhattan Tower Apartment';
		}
		var reportName = 'Lodging Statistics Report';

		$scope.selected = [];
		vm.selectedHotels = [];
		vm.getrecords = getrecords;
		vm.printRecords = printRecords;
		$rootScope.getSubHotels($localStorage['preHotelId']);

		vm.reportType = 'hotel';
		vm.requestProcessingEmail = false;
		vm.requestProcessingPDF =  false;

		function printRecords(){
			$mdDialog.show({
				controller: 'getEmailAddress',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/reports/getEmailAddress.html',
				parent: angular.element(document.body),
				targetEvent: event,
				clickOutsideToClose:true,
            })
			.then(function(answer) {
				 // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				 // if(typeof answer != 'undefined' && re.test(answer)){
				if(typeof answer != 'undefined'){
					vm.requestProcessingEmail = true;
					 var data = {
						start:new Date(moment(vm.fromdate).format('YYYY-MM-DD')),
						end:new Date(moment(vm.todate).format('YYYY-MM-DD')),
						mode:'sendMail',
						selected_hotel: vm.selectedHotels,
						emailAddress: answer,
						reportFor: vm.reportFor,
						factReport: 'new'
					 };
					
					lodgingStatistic.getFactsLodgingData(data).then(function(response){
						vm.requestProcessingEmail = false;
					});
				}
            }, function() {});		
		}

		vm.columns = [];
		// getrecords();
		vm.requestProcessing = false;
		function getrecords(pdf){
			if(pdf)
				vm.requestProcessingPDF = true;
			else
				vm.requestProcessing = true;
			// var data = {
			// 	start:new Date(moment(vm.fromdate).format('YYYY-MM-DD')),
			// 	end:new Date(moment(vm.todate).format('YYYY-MM-DD')),
			// 	mode:'listing',
			// 	selected_hotel: vm.selectedHotels
			// };
			var endDate = moment(vm.todate).format('YYYY-MM-DD');
          	var startDate = moment(vm.fromdate).format('YYYY-MM-DD');
          	var pdfendDate = moment(vm.todate).format('MM/DD/YY');
			var pdffromDate = moment(vm.fromdate).format('MM/DD/YY');
			vm.csvName =  'lodging-statistic-new-'+startDate+'-to-'+endDate+'.csv';
			vm.pdfName =  'lodging-statistic-'+startDate+'-to-'+endDate+'.pdf';
			vm.pageSet = 'lodgingstats';
			var data = {
				start:startDate,
				end:endDate,
				mode:'listing',
				selected_hotel: vm.selectedHotels,
				reportFor: vm.reportFor,
				pdf:pdf,
				factReport: 'new'
			};
			
			lodgingStatistic.getFactsLodgingData(data).then(function(response){
				if(pdf)
					vm.requestProcessingPDF = false;
				else
					vm.requestProcessing = false;
				
				if (response.success){
					vm.columns = response.columns;
					vm.report.data = response.result;
					vm.totalRoomTypes = response.count;
					vm.clickedActions = response.clickedActions;
					vm.csvHeader = [];
					vm.pdfHeader = [];
					vm.csvData = [];

					vm.columns.forEach(function(element){
						vm.csvHeader.push(element);
					});
					vm.pdfHeader = angular.copy(vm.csvHeader);
					var i = 0;
					for(var key in vm.report.data){
						vm.csvData[i] = vm.report.data[key];
						i++;				
					}
					setTimeout(function(){
              			vm.tbodyHeight = document.getElementById('tbodyHeight').clientHeight;
              			vm.initialOffset = $('#printSectionId').offset().top;
		                vm.table = $('#heightTable');
		                vm.bodyCells = vm.table.find('tbody tr').children();
		                vm.colWidth;
		              	// Adjust the width of thead cells when window resizes
		              	$(window).resize(function() {
	                  		// Get the tbody columns width array
	                  		vm.colWidth = vm.bodyCells.map(function() {
	                      		return $(this).width();
	                  		}).get();
			                 vm.table.find('thead tr').children().each(function(i, v) {
			                     $(v).width(vm.colWidth[i]);
			                });    
			            }).resize(); // Trigger resize handler

              			vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };
            		},1000);
            		/*vm.logo = EnvironmentConfig.api+'assets/uploads/hotels/logos/'+response['logo'];
            		vm.pdfHeaderData = {
						startpdf:pdffromDate,
						endpdf:pdfendDate,
						reportname:'Lodging Statistics Report',
						hotelName:hotelName,
						logo:vm.logo
					};*/
				}else if(!response.success && response.errorMsg && response.errorMsg!=''){
					toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
				} else if(pdf == 'pdf' && response.status == 'success'){
					// console.log(Reportsdata);
					var filepathToClean = response.data.filepath;
                    var data = {
                        filename:response.data.filename,
                        filepath:response.data.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        //return;
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
	                        lodgingStatistic.cleanDisk(cleanData);
	                    }, 2000);
					});
				}
			});
		}

		vm.ChangeEndDayIf = function(){
			if(!moment(vm.todate).isAfter(vm.fromdate) || moment(vm.todate).isSame(vm.fromdate)){
				vm.todate = moment(vm.fromdate).add(0, 'days').format('MM/DD/YYYY');
			}
		}

		vm.clickedRow = function(index, data, value) {
			var columnClicked = vm.columns[index] != undefined ? vm.columns[index] : '';
			var dateColumn = data.date != undefined ? data.date : '';
			var hotels = ''; 
			if (vm.selectedHotels.length) {
				for (var i = 0; i < vm.selectedHotels.length; i++) {
					hotels += vm.selectedHotels[i];
					if (i != vm.selectedHotels.length- 1) {
						hotels += "=";
					}
				}
			}
			if (hotels != '') {
				hotels = btoa(hotels);
			}
			
			if (vm.clickedActions.indexOf(columnClicked) > -1 && value != '$0.00' && value != '$0' && value != '0.00' && value != '0' && dateColumn != 'Total') {
				if (columnClicked == 'Booking.com') {
					columnClicked = 'bdc Taxable';
				} else if (columnClicked == 'Booking.com Non Taxable') {
					columnClicked = 'bdc non Taxable';
				}
				columnClicked = columnClicked.replace(/ /g,"_");
				vm.reportFor = vm.reportFor != undefined && vm.reportFor != '' ? vm.reportFor : 'hotel';
				var getData = 'lodgingStats&'+columnClicked+'&'+data.date+'&'+vm.reportFor;
				if (hotels != '') {
					getData += "&"+hotels;
				}
				var url = $state.href("app.reports.detail",{param:getData});
				$window.open(url, '_blank');
			}
		}
    }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('LodgingDetailController', LodgingDetailController);

	/** @ngInject */
	function LodgingDetailController(
	   $scope,
	   $state,
	   $stateParams,
	   $http,
	   EnvironmentConfig,
	   toastMessage,
	   lodgingStatistic,
	   $mdDialog,
	   $rootScope,
	   $localStorage,
	   $timeout,
	   detailData,
	   $window
	){
		var vm = this;
		vm.loggedRole = $localStorage.roleId !== undefined ? $localStorage.roleId : 0;
		
		vm.columns = detailData.headers;
		vm.data = detailData.data;
		
		//for mddatatable
		$scope.query = {
			order: 'name',
			limit: 5,
			page: 1
		};
		
		var searchedParam = $stateParams.param;
		searchedParam = searchedParam.split('&');
		vm.reportType = searchedParam[0];
		vm.searchedArg = searchedParam[1];
		vm.clickForDetail = true;
		if (vm.reportType == 'lodgingStats') {
			vm.searchedDate = searchedParam[2];
			vm.reportFor = searchedParam[3];
		} else if (searchedParam[0] == 'nightAudit') {
			vm.startDate = searchedParam[2];
			vm.endDate = searchedParam[3];
			vm.reportFor = searchedParam[4];
		} else if (searchedParam[0] == 'taxReport') {
			vm.startDate = searchedParam[2];
			vm.endDate = searchedParam[3];
			vm.reportFor = searchedParam[4];
			vm.clickForDetail = detailData.clickable != undefined ? detailData.clickable : false;
		}

		if (vm.reportType === 'revenueManagement' && vm.searchedArg === 'occupancyPercentage') {
			vm.clickForDetail = false;
		}
		
		vm.heading = detailData.heading != undefined ? detailData.heading : '';
		vm.heading = vm.heading.replace(/_/g, ' ');		
		
		vm.subHeading = detailData.subHeading != undefined ? detailData.subHeading : '';
		vm.hasGrandAverageOccupancy = detailData.grandAverageOccupancy != undefined && detailData.grandAverageOccupancy !== null && detailData.grandAverageOccupancy !== '';
		vm.grandAverageOccupancy = vm.hasGrandAverageOccupancy ? detailData.grandAverageOccupancy : 0;
		vm.totalNights = detailData.totalNights != undefined ? detailData.totalNights : 0;

		vm.totalNightPrice = detailData.nightlyPrice != undefined ? detailData.nightlyPrice : 0;
		vm.appliedTaxes = detailData.taxesApplied ? detailData.taxesApplied : [];
 		vm.initialOffset = 0;
        vm.tbodyHeight = 0;       
        // Change the selector if needed
        vm.tableStyle = {};
        vm.table;
        vm.bodyCells;

		vm.totalRefundDeposit = 0;
		vm.totalNonRefundDeposit = 0;

		calculateTotals();

		function calculateTotals() {
			vm.totalRefundDeposit = 0;
			vm.totalNonRefundDeposit = 0;

			vm.data.forEach(function(row) {
				vm.totalRefundDeposit += parseFloat(row.refunded_deposit || 0);
				vm.totalNonRefundDeposit += parseFloat(row.non_refunded_deposit || 0);
			});
		}
		
		vm.getRefundMethodTooltip = function (value) {
			if (!value) return '';

			return value
				.replace(/\bCC\b/g, 'Credit Card')
				.replace(/\bGC\b/g, 'Gift Card');
		};
      	
      	vm.csvHeader = [];
		vm.csvData = [];

		if (detailData.csvName !== undefined) {
			vm.csvName = detailData.csvName;
		} else {
			vm.csvName = 'lodging-stats-detail-of-'+detailData.heading+'-for-'+vm.searchedDate+'.csv';
		}
		
		vm.columns.forEach(function(element){
			vm.csvHeader.push(element);
		});
		
		if (vm.data.length) {
			angular.forEach(vm.data, function(row) {
				var csvRow = angular.copy(row);
				// Hidden in the table for cancellations; including it shifts CSV columns.
				if (vm.searchedArg === 'roomCancel') {
					delete csvRow.reservation_id;
					csvRow.refunded_deposit = formatCsvCurrency(csvRow.refunded_deposit);
					csvRow.non_refunded_deposit = formatCsvCurrency(csvRow.non_refunded_deposit);
				}
				delete csvRow.$$hashKey;
				vm.csvData.push(csvRow);
			});

			if (vm.searchedArg === 'roomCancel') {
				var totalRow = {};
				var isFirstColumn = true;
				angular.forEach(vm.csvData[0], function(value, key) {
					if (key === 'refunded_deposit') {
						totalRow[key] = formatCsvCurrency(vm.totalRefundDeposit);
					} else if (key === 'non_refunded_deposit') {
						totalRow[key] = formatCsvCurrency(vm.totalNonRefundDeposit);
					} else if (isFirstColumn) {
						totalRow[key] = 'Total';
						isFirstColumn = false;
					} else {
						totalRow[key] = '';
					}
				});
				vm.csvData.push(totalRow);
			}
		}

		function formatCsvCurrency(amount) {
			var value = parseFloat(amount || 0);
			if (isNaN(value)) {
				value = 0;
			}
			return '$' + value.toFixed(2);
		}

		$scope.selected = [];
		vm.selectedHotels = [];
		vm.getrecords = getrecords;
		vm.makeTableFormat = makeTableFormat;
	
		vm.requestProcessing = false;

		function makeTableFormat(){
			setTimeout(function(){
      			vm.tbodyHeight = document.getElementById('tbodyHeight').clientHeight;
      			vm.initialOffset = $('#printSectionId').offset().top;
                vm.table = $('#heightTable');
                vm.bodyCells = vm.table.find('tbody tr').children();
                vm.colWidth;
              	// Adjust the width of thead cells when window resizes
              	$(window).resize(function() {
              		// Get the tbody columns width array
              		vm.colWidth = vm.bodyCells.map(function() {
                  		return $(this).width();
              		}).get();
	                 vm.table.find('thead tr').children().each(function(i, v) {
	                     $(v).width(vm.colWidth[i]);
	                });    
	            }).resize(); // Trigger resize handler

      			vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };

    		},1000);
		}

		vm.makeTableFormat();
		
		function getrecords(){
			var data = {
				date:vm.searchedDate,
				reportFor: vm.reportFor,
				searchedArg: vm.searchedArg
			};
			
			lodgingStatistic.getLodgingStatsDetail(data).then(function(response){
				vm.columns	 = response.headers;
				vm.data = response.data;

				calculateTotals();
			});
		}

		vm.goToDetail = function(index, value, data){
			var columnClicked = vm.columns[index] != undefined ? vm.columns[index] : '';
			var url;
			if (columnClicked != '' && (columnClicked.toLowerCase() == 'reservation id' || columnClicked.toLowerCase() == 'confirmation number')) {
				if (data.reservation_id != undefined && data.reservation_id != '') {
					if(vm.reportFor == 'marina'){
						url = $state.href("app.e-commerce.boatOrders.detail",{id:data.reservation_id, confirmation_number:data.confirmation_number});
					} else if(vm.pageType == 'rent'){
						url = $state.href("app.e-commerce.rentOrders.detail",{id:data.reservation_id, confirmation_number:data.confirmation_number});
					} else {
						url = $state.href("app.e-commerce.orders.detail",{id:data.reservation_id, confirmation_number:data.confirmation_number});
					}
					$window.open(url, '_blank');
				}
			} else if (columnClicked != '' && (columnClicked.toLowerCase() == 'gift card id' || columnClicked.toLowerCase() == 'gift card code')) {
				if (data.gift_card_id != undefined && data.gift_card_id != '') {
					url = $state.href("app.e-commerce.gcadmins.update",{giftCardID : data.gift_card_id});
					$window.open(url, '_blank');
				}				
			}
		}
    }
})();


(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('lightCleaningController', lightCleaningController);

    /** @ngInject */
    function lightCleaningController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $localStorage,
       $timeout
    ){
        var vm = this;
		vm.report = {};
        vm.allIds = [];
        vm.all = [];
        vm.logo = EnvironmentConfig.api;
        vm.logo = vm.logo+'assets/uploads/hotels/logos/'

        vm.myDate = new Date();
        vm.print = false;
        vm.hotelID = $localStorage['preHotelId'];
        vm.departureDate = new Date(
                                    this.myDate.getFullYear(),
                                    this.myDate.getMonth(),
                                    this.myDate.getDate()
                                  );

        /*Functions Dec*/
        vm.getReports = getReports;
        vm.getPrintReports = getPrintReports;
        vm.getRoomMoves = getRoomMoves;
        vm.init = false;
        vm.selectedHotels = [];
		//getReports();

        function getReports(){
            vm.all = [];
            var departureDate = moment(vm.departureDate).format('YYYY-MM-DD');
            vm.csvName = 'LightCleaning-'+departureDate+'.csv';
            vm.pdfName = 'LightCleaning-'+departureDate+'.pdf';
            vm.refreshRequest = true;
            reportService.lightCleaningReport({
                //date:new Date(moment(vm.departureDate).format('YYYY-MM-DD'))
                date:new Date(departureDate),
                selectedHotels:vm.selectedHotels
                // reportFor: vm.reportFor
            }).then(function(response){
                vm.refreshRequest = false;
                vm.init = true;
                vm.lightCleaningData = response['data'];
                 vm.all = vm.lightCleaningData;
                 vm.logo+=response.logo;
            });

        }

        function getPrintReports(pdf){
            vm.refreshRequestPDF = true;
            reportService.lightCleaningReport({
                date:moment(vm.departureDate).format('YYYY-MM-DD'),
                pdf:pdf
                // reportFor: vm.reportFor
            }).then(function(response){
                vm.refreshRequestPDF = false;
                if(response.data && pdf=='pdf'){
                    var filepathToClean = response.data.filepath;
                    var data = {
                        filename:response.data.filename,
                        filepath:response.data.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        //return;
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
                            lodgingStatistic.cleanDisk(cleanData);
                        }, 2000);
                    });
                }
            });
        }

        vm.printData = printData;
        function printData(){
            vm.printRequest = true;
             vm.print = true;
            var innerContents = document.getElementById('printSectionId').innerHTML;
             var myWindow=window.open('','','', '');
                myWindow.document.write(innerContents);
                myWindow.print();
                myWindow.document.close();
                myWindow.focus();
                vm.printRequest = false;
                vm.print = false;

        }
        function getRoomMoves(){
            vm.all = [];
            reportService.getAllRoomMoves({
                date:new Date(moment(vm.departureDate).format('YYYY-MM-DD'))
            }).then(function(response){
            });

        }

    }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('incomeReportController', incomeReportController)
        .filter('titleCase', function() {
          return function(input) {
            input = input || '';
            return input.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
          };
        });

    /** @ngInject */
    function incomeReportController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $filter,
       $mdDialog,
       $rootScope,
       $localStorage
    ){
        var vm = this; 
        vm.addTableClass = false;
        vm.removeClass = false;
        vm.prevScroll = 0;
        vm.initialOffset = 0;
        vm.tbodyHeight = 0;       

        // Change the selector if needed
        vm.tableStyle = {};
        vm.table;
        vm.bodyCells;
        vm.colWidth;

        /*window.addEventListener('scroll', function(event) {
          var elementOffset = $('#table-container').offset().top;
          var toolbarHeight = document.getElementById('toolbar').clientHeight;
          var offsetDiff = vm.initialOffset - elementOffset;
          var screenSize = $(window).height();
          var tbodyScrollTop;
          if(document.getElementById('tbodyHeight')) {
            var tbodyScrollTop = document.getElementById('tbodyHeight').scrollTop;
          }
          
          if(elementOffset <= toolbarHeight) {
            document.getElementById("tbodyHeight").style.height = 200;            
            console.log(document.getElementById('tbodyHeight').clientHeight);
          }

          if(vm.bodyCells) {
              vm.colWidth = vm.bodyCells.map(function() {
                  return $(this).width();
              }).get();
              
              // Set the width of thead columns
              vm.table.find('thead tr').children().each(function(i, v) {
                  $(v).width(vm.colWidth[i]);
              });
          }       

        }, true);*/

        vm.report = {};        

        vm.selectedColumns = 'itinerary_number,confirmation_number,room_stay_status,room_stay_from,room_stay_to,Customer,quantity,product_name,NoOfNights,hotel_title,source_of_creation,Employee,subtotal,product_discount,lodging tax percentage,lodging tax amount,tourist development tax percentage,tourist development tax amount,resort fee percentage,resort fee amount,resort fee tax percentage,resort fee tax amount,sales tax percentage,sales tax amount,grand_total,total_paid_amount,total_remaining_amount,totalPaid,payment_method,paidToday';


        vm.not_required = 'product_id,product_is_timebound,sub_hotel_id,type_of_reservation,total,bar tax amount,bar tax percentage';
        vm.allIds = [];
        vm.selectedChannels = [];
        vm.selectedPaymentMethods = [];
        vm.selectedHotels = [];
        vm.csvHeader =  ['Itinerary' ,'Confirmation','Status','Checkin','Checkout','Customer','Quantity','Item','Number of Nights','Business Entity','Source','Employee  ','Sub Total ','Discount  ','Lodging Tax(%)','Lodging Tax($)','Tourist Development Tax(%)','Tourist Development Tax($)','Resort Fee(%)','Resort Fee ($)  ','Resort Fee Tax(%)','Resort Fee Tax($)','Sales Tax  (%)','Sales Tax  ($)','Grand Total','Paid','Remaining','Reservation Total','Payment Method','Paid Within Report Range'];
        vm.pdfHeader = angular.copy(vm.csvHeader);
        vm.myDate = new Date();
        vm.allData = [];

        vm.channels = [];
        vm.startDate = null;
        // new Date(
        //                             this.myDate.getFullYear(),
        //                             this.myDate.getMonth(),
        //                             this.myDate.getDate()
        //                           );
        vm.endDate =null;
        // new Date(
        //                             this.myDate.getFullYear(),
        //                             this.myDate.getMonth(),
        //                             this.myDate.getDate()
        //                           ); 
        vm.checkInDate = null;
        vm.checkOutDate = null;
        vm.disableRefresh = true;
        vm.reportType = 'overAll';

        reportService.getAllChannels().then(function(response){
            if(response.success){
                vm.channels = response.result;
            }
        });

        /*Functions Dec*/
        vm.getIncomeReport = getIncomeReport;
        vm.getIncomePrintReport = getIncomePrintReport;
        vm.getValues = getValues;
        vm.compareDate = compareDate;
        vm.calculateTotal = calculateTotal;

        vm.reinitialize = reinitialize;
        reinitialize();
        function reinitialize(){
        vm.quantity = 0;
        vm.NoOfNights = 0;
        vm.subtotal = 0;
        vm.product_discount = 0;
        vm.tax_amount = 0;
        vm.total = 0;
        vm.paymentsTodates = 0;
        vm.total_remaining_amount = 0;
        vm.grand_total = 0;
        vm.totalPaid = 0;
        vm.total_paid_amount = 0;
        vm.paidToday = 0;
        }
        vm.overAll = new Array();
        vm.pindex = '1111';
        vm.countLoopElement = 0;
        vm.countLoopElement2 = 0;
        vm.confirmation_numbers = [];
        vm.confirmation_numbers2 = [];

        // vm.goToState = goToState;
        // function goToState(itinerary_number, confirmation_number, test){
        //   $rootScope.goToState(itinerary_number, confirmation_number, test);
        //   // console.log(itinerary_number, confirmation_number);
        // }
        vm.showReportFor = false;
        vm.reportFor = 'all';
        if($localStorage['preHotelId'] !== undefined && $localStorage['preHotelId'] == 126){
          vm.reportFor = 'reservation';
          vm.showReportFor = true;
        }

        function calculateTotal(data, pindex){
          
          vm.countLoopElement = vm.countLoopElement + 1;

            if(vm.pindex != pindex){
                reinitialize();
                vm.pindex = pindex;
            }

            var income = angular.copy(data);
            if(income !== null && income !== 'null' && income !== undefined && income !== 'undefined' && typeof income == 'object') {
              if (vm.confirmation_numbers.indexOf(income.confirmation_number) == -1) {
                vm.tax_amount = parseFloat(vm.tax_amount) + parseFloat(income.tax_amount?income.tax_amount:0 );
                vm.paymentsTodates = parseFloat(vm.paymentsTodates) + parseFloat(income.paymentsTodates);
                vm.NoOfNights = parseFloat(vm.NoOfNights) + parseFloat(income.NoOfNights?income.NoOfNights:0);
                vm.subtotal = parseFloat(vm.subtotal) + parseFloat(income.subtotal?income.subtotal:0);
                vm.product_discount = parseFloat(vm.product_discount) + parseFloat(income.product_discount?income.product_discount:0);
                vm.grand_total = parseFloat(vm.grand_total) + parseFloat(income.grand_total?income.grand_total:0);         
                vm.totalPaid = parseFloat(vm.totalPaid) + parseFloat(income.totalPaid?income.totalPaid:0);         
                

                vm.total_remaining_amount = parseFloat(vm.total_remaining_amount) + parseFloat(income.total_remaining_amount?income.total_remaining_amount:0);

                vm.total_paid_amount = parseFloat(vm.total_paid_amount) + parseFloat(income.total_paid_amount?income.total_paid_amount:0);

                vm.quantity = parseFloat(vm.quantity) + parseFloat(income.quantity?income.quantity:0);                
              }
              vm.paidToday = parseFloat(vm.paidToday) + parseFloat(income.paidToday?income.paidToday:0);         
              vm.confirmation_numbers.push(income.confirmation_number);
            }
            // vm.total = parseFloat(vm.total) + parseFloat(income.total);

            vm.overAll[pindex] = {};
            vm.overAll[pindex]['quantity'] = angular.copy(vm.quantity);
            vm.overAll[pindex]['NoOfNights'] = angular.copy(vm.NoOfNights);
            vm.overAll[pindex]['grand_total'] = angular.copy(vm.grand_total);
            vm.overAll[pindex]['subtotal'] = angular.copy(vm.subtotal);
            vm.overAll[pindex]['tax_amount'] = angular.copy(vm.tax);
            // vm.overAll[pindex]['total'] = angular.copy(vm.total);
            vm.overAll[pindex]['totalPaid'] = angular.copy(vm.totalPaid);
            vm.overAll[pindex]['paymentsTodates'] = angular.copy(vm.paymentsTodates);
            vm.overAll[pindex]['total_remaining_amount'] = angular.copy(vm.total_remaining_amount);
            vm.overAll[pindex]['total_paid_amount'] = angular.copy(vm.total_paid_amount);
            vm.overAll[pindex]['paidToday'] = angular.copy(vm.paidToday);

            if(vm.countLoopElement == vm.actualLength){              
              var totalPaid = 0;
              var paidToday = 0;
               for(var tempKey in vm.overAll){
                totalPaid = parseFloat(totalPaid) + parseFloat(vm.overAll[tempKey]['totalPaid']);
                paidToday = parseFloat(paidToday) + parseFloat(vm.overAll[tempKey]['paidToday']);
              }
              vm.overAllTotal = {
                'itinerary_number' : '',
                'confirmation_number' : '',
                'room_stay_status' : '',
                'room_stay_from' : '',
                'room_stay_to' : '',
                'Customer' : '',
                'quantity' : '',
                'product_name' : '',
                'NoOfNights' : '',
                'hotel_title' : '',
                'source_of_creation' : '',
                'Employee' : '',
                'subtotal' : '',
                'product_discount' : ''
              };
              
              angular.forEach(vm.taxesArray, function(value, index) {
                vm.overAllTotal[value] = '';
              });
              var restNew = [
                'grand_total',
                'total_paid_amount',
                'total_remaining_amount',
                'totalPaid',
                'payment_method',
                'paidToday'
              ];

              angular.forEach(restNew, function(value, index) {
                vm.overAllTotal[value] = '';
                if(value == 'totalPaid') {
                  vm.overAllTotal[value] = $filter('currency')(totalPaid,'$',2);
                }
                if(value == 'paidToday') {
                  vm.overAllTotal[value] = $filter('currency')(paidToday,'$',2);
                }
              });
              
              if(vm.reportType=='detailed')
                vm.overAllTotal.installment_paid_date='';
              vm.allData.push(vm.overAllTotal);
            }
        }
        

        function compareDate(date1, date2,index){
            var startDate = moment(date1);
            var endDate = moment(date2);
            if(startDate > endDate || startDate < endDate){
                vm.currentDate = date2;
                return true;
            } else {
                return false;
            }

        }
        vm.noResultFound = false;

        function getValues(date){
            vm.currentDate  = angular.copy(date);
            return vm.currentDate;
        }
    // getIncomeReport();
    vm.requestProcessing = false;
        function getIncomeReport(){ 
          // console.log(vm.startDate);         
          vm.countLoopElement = 0;

          vm.requestProcessing = true;
          vm.allData = [];
          vm.incomeData = [];
          var endDate = moment(vm.endDate).format('YYYY-MM-DD');
          var startDate = moment(vm.startDate).format('YYYY-MM-DD');
          
          var checkInDate = moment(vm.checkInDate).format('YYYY-MM-DD');
          var checkOutDate = moment(vm.checkOutDate).format('YYYY-MM-DD');
          vm.csvName =  'income-reports-'+vm.reportType+'.csv';
          vm.pdfName =  'income-reports-'+vm.reportType+'.pdf';
          reinitialize();
          reportService.getAllIncomeReports({
              startDate:new Date(startDate),
              endDate:new Date(endDate),
              checkInDate:new Date(checkInDate),
              checkOutDate:new Date(checkOutDate),
              selectedChannels:vm.selectedChannels,
              selectedPaymentMethods:vm.selectedPaymentMethods,
              reportType:vm.reportType,
              reportFor:vm.reportFor,
              mode:'listing',
              'selectedHotels':vm.selectedHotels
          }).then(function(response){
            vm.requestProcessing = false;
            vm.noResultFound = true;
            vm.incomeData = response.incomeDetails.incomeReport;
            vm.distinctHotelTaxes = response.distinctTaxes;
            vm.taxesArray = [];
            vm.taxesNamesArray = [];
            angular.forEach(vm.distinctHotelTaxes, function(val, index) {
              var percent = val + ' percentage';
              percent = percent.toString();

              var dollar = val + ' amount';
              dollar = dollar.toString();

              vm.taxesArray.push(percent);
              vm.taxesArray.push(dollar);

              vm.taxesNamesArray.push(val);
              vm.taxesNamesArray.push(val);


            });
            vm.noResultFound = false;    
            // if(vm.incomeData.length<=0){
            // vm.noResultFound = true;    
            // }
            var data = {
              'quantity'   : 0,
              'noOfNights' : 0,
              'subtotal'   : 0,
              'total'      : 0,
              'paid'       : 0,
              'remaining'  : 0,
              'totalPaid'  : 0,
              'paidToday'  : 0,
            }
            var allCount = 0;         
            for (var key in vm.incomeData) {
              for (var key1 in vm.incomeData[key]){
                  allCount ++;
                  var tempObj = angular.copy(vm.incomeData[key][key1]);
                  if (tempObj !== undefined && tempObj !== 'undefined' && tempObj !== null && tempObj !== 'null' &&  typeof tempObj == 'object' && Object.keys(tempObj).length > 0) {
                    data.quantity   += tempObj['quantity'];
                    data.noOfNights += tempObj['NoOfNights'];
                    data.subtotal   += tempObj['subtotal'];
                    data.total      += tempObj['grand_total'];
                    data.paid       += tempObj['total_paid_amount'];
                    data.remaining  += tempObj['total_remaining_amount'];
                    data.totalPaid  += tempObj['totalPaid'];
                    data.paidToday  += tempObj['paidToday'];

                    tempObj['subtotal'] = $filter('currency')(tempObj['subtotal'], '$', 2);
                    tempObj['product_discount'] = $filter('currency')(tempObj['product_discount'], '$', 2);
                    angular.forEach(vm.taxesArray, function(val, index) {
                      if(val.indexOf('percentage') > -1) {
                        tempObj[val] = tempObj[val] ? tempObj[val] : "0.00";
                        tempObj[val] = tempObj[val].toString();
                      }
                    });
                    angular.forEach(vm.taxesArray, function(val, index) {
                      if(val.indexOf('amount') > -1) {
                        if(tempObj[val]) {
                          tempObj[val] = $filter('currency')(tempObj[val], '$', 2);
                        } else {
                          tempObj[val] = "0.00";
                        }
                        tempObj[val] = tempObj[val].toString();
                      }
                    });
                    tempObj['grand_total'] = $filter('currency')(tempObj['grand_total'], '$', 2);
                    tempObj['total_paid_amount'] = $filter('currency')(tempObj['total_paid_amount'], '$', 2);
                    tempObj['total_remaining_amount'] = $filter('currency')(tempObj['total_remaining_amount'], '$', 2);
                    tempObj['totalPaid'] = $filter('currency')(tempObj['totalPaid'], '$', 2);
                    tempObj['paidToday'] = $filter('currency')(tempObj['paidToday'], '$', 2);
                    vm.allData = vm.allData.concat(tempObj);
                  }
              }
              
              // var newObj = {
              //   'Itinerary' : 'Total',
              //   'confirmation': data.total
              // };
              // vm.allData = vm.allData.concat(newObj);
            }
            vm.actualLength = allCount;
            setTimeout(function(){
              vm.tbodyHeight = document.getElementById('tbodyHeight').clientHeight;
              vm.initialOffset = $('#table-container').offset().top;
                vm.table = $('.customTable');
                vm.bodyCells = vm.table.find('tbody tr:first').children();
                vm.colWidth;
              // Adjust the width of thead cells when window resizes
              $(window).resize(function() {
                  // Get the tbody columns width array
                  vm.colWidth = vm.bodyCells.map(function() {
                      return $(this).width();
                  }).get();
                  
                  // Set the width of thead columns
                  vm.table.find('thead tr').children().each(function(i, v) {
                      $(v).width(vm.colWidth[i]);
                  });    
              }).resize(); // Trigger resize handler

              vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };

            },1000);
            
          });
          vm.confirmation_numbers = [];
        }   

        function getIncomePrintReport(pdf){
            vm.requestPDF = true;
            var data = {
                startDate:moment(vm.startDate).format('YYYY-MM-DD'),
                endDate:moment(vm.endDate).format('YYYY-MM-DD'),
                checkInDate:moment(vm.checkInDate).format('YYYY-MM-DD'),
                checkOutDate:moment(vm.checkOutDate).format('YYYY-MM-DD'),
                selectedChannels:vm.selectedChannels,
                selectedPaymentMethods:vm.selectedPaymentMethods,
                reportType:vm.reportType,
                reportFor:vm.reportFor,
                'selectedHotels':vm.selectedHotels,
                pdf:pdf
            };
            reportService.getAllIncomeReports(data).then(function(response){
                vm.requestPDF = false;
                if(response.status == 'success' && pdf=='pdf'){
                    var filepathToClean = response.data.filepath;
                    var data = {
                        filename:response.data.filename,
                        filepath:response.data.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        //return;
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
                            lodgingStatistic.cleanDisk(cleanData);
                        }, 2000);
                    });
                } 
            });
        }


    vm.printRecords = printRecords;
    vm.requestProcessingEmail = false;
    function printRecords(){
      // vm.requestProcessingEmail = true;
          var checkInDate = moment(vm.checkInDate).format('YYYY-MM-DD');
          var checkOutDate = moment(vm.checkOutDate).format('YYYY-MM-DD');
      $mdDialog.show({
                    controller: 'getEmailAddress',
                    controllerAs: 'vm',
                  templateUrl: 'app/main/apps/reports/getEmailAddress.html',
                  parent: angular.element(document.body),
                  targetEvent: event,
                  clickOutsideToClose:true ,
                                  
                })
                .then(function(answer) {
                  vm.requestProcessingEmail = false;
                     var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                   if(typeof answer != 'undefined'){
                    vm.requestProcessingEmail = true;
                    var endDate = new Date(moment(vm.endDate).format('YYYY-MM-DD'));
                    var startDate = new Date(moment(vm.startDate).format('YYYY-MM-DD'));
                    vm.csvName =  'income-reports'+startDate+'-to-'+endDate+'.csv';
                      reinitialize();
                      reportService.getAllIncomeReports({
                          startDate:startDate,
                          endDate:endDate,
                          selectedChannels:vm.selectedChannels,
                          selectedPaymentMethods:vm.selectedPaymentMethods,
                          emailAddress:answer,
                          checkInDate:new Date(checkInDate),
                          checkOutDate:new Date(checkOutDate),
                          reportType:vm.reportType,
                          mode:'sendEmail',
                          'selectedHotels':vm.selectedHotels
                      }).then(function(response){
                        vm.requestProcessingEmail = false;
                        });
           
        }
               }, function() {
               vm.requestProcessingEmail = false;});

      
    
    }
      vm.ChangeEndDayIf = function(){
        vm.startDate = new Date(
                                     this.myDate.getFullYear(),
                                     this.myDate.getMonth(),
                                     this.myDate.getDate()
                                   );
        if(!vm.endDate){
          vm.endDate = vm.startDate;
        }

        if(!moment(vm.endDate).isAfter(vm.startDate)){
        vm.endDate = moment(vm.startDate).add(0, 'days').format('M/D/Y');
        }
      }
     vm.changeCheckDates = function(){
        if(vm.checkInDate != undefined && vm.checkInDate != undefined && moment(vm.checkInDate).isAfter(vm.checkOutDate)) {
          vm.checkOutDate = vm.checkInDate;
        }

        if(!vm.checkInDate || !vm.checkOutDate){
          vm.disableRefresh = true;
        }
        else{
          vm.disableRefresh = false;
        }
      } 
       vm.changePayDates = function(){
        if(!vm.endDate || !vm.startDate){
          vm.disableRefresh = true;
        }
        else{
          vm.disableRefresh = false;
        }
      }
      vm.changeReportType = function(){
        vm.incomeData = [];
      }
      
      vm.downloadFileCustom = function(reportType,type_of_file_download){
        if(vm.reportType=='detailed'){
          vm.selectedColumns =  'itinerary_number,confirmation_number,installment_paid_date,room_stay_status,room_stay_from,room_stay_to,Customer,quantity,product_name,NoOfNights,hotel_title,source_of_creation,Employee,subtotal,product_discount';
          angular.forEach(vm.taxesArray, function(value, index) {
            vm.selectedColumns  = vm.selectedColumns + ',' + value;
          });
          var restAttr = 'grand_total,total_paid_amount,total_remaining_amount,totalPaid,payment_method,paidToday';
          vm.selectedColumns  = vm.selectedColumns + ',' + restAttr;


          vm.csvHeader =  ['Itinerary' ,'Confirmation','Date','Status','Checkin','Checkout','Customer','Quantity','Item','Number of Nights','Business Entity','Source','Employee  ','Sub Total ','Discount  '];
          var label = '';
          angular.forEach(vm.taxesArray, function(value, index) {
            vm.csvHeader.push(value);
          });
          var restAtt = ['Total','Paid','Remaining','Reservation Total','Payment Method','Paid Today'];
          angular.forEach(restAtt, function(value, index) {
            vm.csvHeader.push(value);
          });

          vm.not_required = 'product_id,product_is_timebound,sub_hotel_id,type_of_reservation,total';
          vm.pdfHeader = angular.copy(vm.csvHeader);
        } else {
          vm.csvHeader =  ['Itinerary' ,'Confirmation','Status','Checkin','Checkout','Customer','Quantity','Item','Number of Nights','Business Entity','Source','Employee  ','Sub Total ','Discount'];
          var label = '';
          angular.forEach(vm.taxesArray, function(value, index) {
            vm.csvHeader.push(value);
          });
          var restAtt = ['Grand Total','Paid','Remaining','Reservation Total','Payment Method','Paid Within Report Range'];
          angular.forEach(restAtt, function(value, index) {
            vm.csvHeader.push(value);
          });

          vm.pdfHeader = angular.copy(vm.csvHeader);
          //vm.not_required = 'product_is_timebound,sub_hotel_id,type_of_reservation';
          vm.not_required = 'product_id,product_is_timebound,sub_hotel_id,type_of_reservation,installment_paid_date,total,long term rental amount,long term rental percentage';
          vm.selectedColumns = 'itinerary_number,confirmation_number,room_stay_status,room_stay_from,room_stay_to,Customer,quantity,product_name,NoOfNights,hotel_title,source_of_creation,Employee,subtotal,product_discount';
          angular.forEach(vm.taxesArray, function(value, index) {
            vm.selectedColumns  = vm.selectedColumns + ',' + value;
          });
          var restAttr = 'grand_total,total_paid_amount,total_remaining_amount,totalPaid,payment_method,paidToday';
          vm.selectedColumns  = vm.selectedColumns + ',' + restAttr;
        }
        console.log("Vm All Data",vm.allData);
        if(type_of_file_download == 'pdf')
          $rootScope.downloadFile(vm.csvHeader, vm.allData, vm.pdfName,vm.selectedColumns,vm.not_required,'lodgingstats');
        else
          $rootScope.downloadFile(vm.pdfHeader, vm.allData, vm.csvName,vm.selectedColumns,vm.not_required);
      }
    }
})();


(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('housekeepingController', housekeepingController);

    /** @ngInject */
    function housekeepingController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $rootScope,
       $localStorage
    ){
        var vm = this;
		    vm.report = {};
        vm.allIds = [];
        vm.all = [];

        vm.initialOffset = 0;
        vm.tbodyHeight = 0;
        vm.tbodyHeight2 = 0;
        vm.tbodyHeight3 = 0;

        // Change the selector if needed
        vm.tableStyle = {};
        vm.table;
        vm.bodyCells;
        vm.colWidth;

        vm.myDate = new Date();
        vm.print = false;
        vm.departureDate = new Date(
                                    this.myDate.getFullYear(),
                                    this.myDate.getMonth(),
                                    this.myDate.getDate()
                                  );

        vm.hotelID = $localStorage['preHotelId'];
        $rootScope.getSubHotels($localStorage['preHotelId']);
        vm.selectedHotels = [];

        /*Functions Dec*/
        vm.getReports = getReports;
        vm.getPrintReports = getPrintReports;
        vm.getRoomMoves = getRoomMoves;
        vm.init = false;
		//getReports();

        function getReports(){
            vm.reportFor = 'reservation';
            vm.all = [];
            vm.refreshRequest = true;
            var date = moment(vm.departureDate).format('YYYY-MM-DD');
            vm.csvName = 'housekeeping-'+date+'.csv';
            reportService.getAllCurrentreservation({
                date:new Date(date),
                selectedHotels:vm.selectedHotels,
                reportFor: vm.reportFor

            }).then(function(response){
                vm.refreshRequest = false;
                vm.init = true;
                vm.roomMove = response['roomMove'];
                vm.arrivals = response['arrivals'];
                vm.departure = response['departure'];
                vm.stayovers = response['stayovers'];

                angular.forEach(vm.arrivals,function(obj){
                    if(obj.product_is_clean == 0){
                      obj.status = 'Full Cleaning';
                    } else if(obj.product_is_clean == 1){
                      obj.status = 'Clean';
                    } else {
                      obj.status = 'Light Cleaning';
                    }
                    if(vm.hotelID == "122"){
                        vm.all.push({'type':obj.type,'days':obj.days,'hotel_title':obj.hotel_title,'product_name':obj.product_name,'party':obj.party,'name':obj.name,'special_request':obj.special_request,'pos_comment':obj.pos_comment,'product_is_clean':obj.status});
                    } else if(vm.hotelID == 126){
                         vm.all.push({'type':obj.type,'days':obj.days,'product_name':obj.product_name,'name':obj.name,'special_request':obj.special_request,'pos_comment':obj.pos_comment,'product_is_clean':obj.status});
                    } else {
                        vm.all.push({'type':obj.type,'days':obj.days,'product_name':obj.product_name,'party':obj.party,'name':obj.name,'special_request':obj.special_request,'pos_comment':obj.pos_comment,'product_is_clean':obj.status});
                    }
                });

                angular.forEach(vm.departure,function(obj){
                    if(obj.product_is_clean == 0){
                      obj.status = 'Full Clean';
                    } else if(obj.product_is_clean == 1){
                      obj.status = 'Clean';
                    } else {
                      obj.status = 'Light Clean';
                    }
                    if(vm.hotelID == "122"){
                        vm.all.push({'type':obj.type,'days':obj.days,'hotel_title':obj.hotel_title,'product_name':obj.product_name,'party':obj.party,'name':obj.name,'special_request':obj.special_request,'pos_comment':obj.pos_comment,'product_is_clean':obj.status});
                    } else if(vm.hotelID == 126){
                      vm.all.push({'type':obj.type,'days':obj.days,'product_name':obj.product_name,'name':obj.name,'special_request':obj.special_request,'pos_comment':obj.pos_comment,'product_is_clean':obj.status});
                    } else {
                        vm.all.push({'type':obj.type,'days':obj.days,'product_name':obj.product_name,'party':obj.party,'name':obj.name,'special_request':obj.special_request,'pos_comment':obj.pos_comment,'product_is_clean':obj.status});

                    }
                });

                angular.forEach(vm.stayovers,function(obj){
                  if(obj.product_is_clean == 0)
                    obj.status = 'Full Clean';
                  else if(obj.product_is_clean == 1)
                    obj.status = 'Clean';
                  else
                    obj.status = 'Light Clean';
                  if(vm.hotelID == "122"){
                      vm.all.push({'type':obj.type,'days':obj.days,'hotel_title':obj.hotel_title,'product_name':obj.product_name,'party':obj.party,'name':obj.name,'special_request':obj.special_request,'pos_comment':obj.pos_comment,'product_is_clean':obj.status});
                  } else if(vm.hotelID == 126){
                      vm.all.push({'type':obj.type,'days':obj.days,'product_name':obj.product_name,'name':obj.name,'special_request':obj.special_request,'pos_comment':obj.pos_comment,'product_is_clean':obj.status});
                  } else {
                      vm.all.push({'type':obj.type,'days':obj.days,'product_name':obj.product_name,'party':obj.party,'name':obj.name,'special_request':obj.special_request,'pos_comment':obj.pos_comment,'product_is_clean':obj.status});
                  }
                });
                // vm.all = vm.all.concat(vm.arrivals);
                // vm.all = vm.all.concat(vm.departure);
                // vm.all = vm.all.concat(vm.stayovers);
                vm.logo = EnvironmentConfig.api+'assets/uploads/hotels/logos/'+response['logo'];
                // console.log(document.getElementById('tbodyHeight2'));
                setTimeout(function(){
                      if(vm.arrivals.length>0)
                        vm.tbodyHeight = document.getElementById('tbodyHeight').clientHeight;
                      // console.log(document.getElementById('tbodyHeight2'));
                      if(vm.departure.length>0)
                        vm.tbodyHeight2 = document.getElementById('tbodyHeight2').clientHeight;
                      if(vm.stayovers.length>0)
                        vm.tbodyHeight3 = document.getElementById('tbodyHeight3').clientHeight;
                      if(vm.roomMove.length>0)
                        vm.tbodyHeight4 = document.getElementById('tbodyHeight4').clientHeight;
                      vm.initialOffset1 = $('#printSectionId').offset().top;
                      // vm.initialOffset2 = $('#printSectionId1').offset().top;
                      // vm.initialOffset3 = $('#printSectionId2').offset().top;
                      vm.table = $('#heightTable');
                      vm.table2 = $('#heightTable2');
                      vm.table3 = $('#heightTable3');
                      vm.table4 = $('#heightTable4');
                      // console.log(vm.table);
                      vm.bodyCells = vm.table.find('tbody tr:first').children();
                      vm.bodyCells2 = vm.table2.find('tbody tr:first').children();
                      vm.bodyCells3 = vm.table3.find('tbody tr:first').children();
                      vm.bodyCells4 = vm.table4.find('tbody tr:first').children();
                      vm.colWidth;
                      vm.colWidth2;
                      vm.colWidth3;
                      vm.colWidth4;
                      // Adjust the width of thead cells when window resizes
                      $(window).resize(function() {
                          // Get the tbody columns width array
                          vm.colWidth = vm.bodyCells.map(function() {
                              return $(this).width();
                          }).get();
                          vm.colWidth2 = vm.bodyCells2.map(function() {
                              return $(this).width();
                          }).get();
                          vm.colWidth3 = vm.bodyCells3.map(function() {
                              return $(this).width();
                          }).get();
                          vm.colWidth4 = vm.bodyCells4.map(function() {
                              return $(this).width();
                          }).get();

                           // Set the width of thead columns
                          vm.table.find('thead tr').children().each(function(i, v) {
                               $(v).width(vm.colWidth[i]);
                           });
                           vm.table2.find('thead tr').children().each(function(i, v) {
                               $(v).width(vm.colWidth2[i]);
                           });
                           vm.table3.find('thead tr').children().each(function(i, v) {
                               $(v).width(vm.colWidth3[i]);
                           });
                           vm.table4.find('thead tr').children().each(function(i, v) {
                               $(v).width(vm.colWidth4[i]);
                           });
                      }).resize(); // Trigger resize handler

                      vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };
                      vm.tableStyle2 = { "max-height" : "calc(100vh - 100px)" };
                      vm.tableStyle3 = { "max-height" : "calc(100vh - 200px)" };
                      vm.tableStyle4 = { "max-height" : "calc(100vh - 200px)" };
                      //remove Housekeepingtable  simple (from table id)  ms-responsive-table
                  },100);
                // console.log(document.getElementById('tbodyHeight2'));

            });

        }
        function getPrintReports(pdf){
            vm.refreshRequestPDF = true;
            var date = moment(vm.departureDate).format('YYYY-MM-DD');

            reportService.getAllCurrentreservation({
                date:new Date(date),
                selectedHotels:vm.selectedHotels,
                reportFor: vm.reportFor,
                pdf:pdf

            }).then(function(response){
                vm.refreshRequestPDF = false;
                vm.init = true;
                if(response.filepath && pdf=='pdf'){
                    var filepathToClean = response.filepath.filepath;
                    var data = {
                        filename:response.filepath.filename,
                        filepath:response.filepath.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        //return;
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL;
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
                            lodgingStatistic.cleanDisk(cleanData);
                        }, 2000);
                    });
                }
              });
            }

        vm.printData = printData;
        function printData(){
            vm.printRequest = true;
             vm.print = true;
            var innerContents = document.getElementById('printSectionId').innerHTML;
             var myWindow=window.open('','','', '');
                myWindow.document.write(innerContents);
                myWindow.print();
                myWindow.document.close();
                myWindow.focus();
                vm.printRequest = false;
                vm.print = false;

        }
        function getRoomMoves(){
            vm.all = [];
            reportService.getAllRoomMoves({
                date:new Date(moment(vm.departureDate).format('YYYY-MM-DD'))
            }).then(function(response){
            });

        }

    }
})();

(function () {
  "use strict";
  angular.module("app.reports").controller("holdReports", holdReports);

  /** @ngInject */
  function holdReports($scope, $rootScope, $stateParams, toastMessage, reportService) {
    var vm = this;
    var myDate = new Date();

    vm.init = false;
    vm.requestProcessing = false;
    vm.allRows = [];
    vm.rows = [];
    vm.headings = [];
    vm.statusOptions = [
      { value: "email_sent", label: "Email Sent" },
      { value: "clicked", label: "Clicked" },
      { value: "converted", label: "Converted" }
    ];
    vm.viaOptions = [
      { value: "fe", label: "FE" },
      { value: "pms", label: "PMS" }
    ];
    vm.selectedStatuses = [];
    vm.selectedVias = [];
    vm.csvHeader = [];
    vm.csvData = [];
    vm.csvName = "courtesy-hold-report.csv";
    vm.startDate = new Date(myDate.getFullYear(), myDate.getMonth(), 1);
    vm.endDate = new Date(
      myDate.getFullYear(),
      myDate.getMonth(),
      myDate.getDate()
    );

    if ($stateParams.start) {
      vm.startDate = new Date(moment($stateParams.start).format("YYYY-MM-DD"));
    }
    if ($stateParams.end) {
      vm.endDate = new Date(moment($stateParams.end).format("YYYY-MM-DD"));
    }
    if ($stateParams.status) {
      vm.selectedStatuses = [String($stateParams.status)];
    }

    vm.getReport = getReport;
    vm.changeEndDayIf = changeEndDayIf;
    vm.applyStatusFilter = applyStatusFilter;
    vm.hasBookingConfirmation = hasBookingConfirmation;
    vm.openBookingDetail = openBookingDetail;

    function changeEndDayIf() {
      if (vm.endDate && vm.startDate && vm.endDate < vm.startDate) {
        vm.endDate = angular.copy(vm.startDate);
      }
    }

    function hasBookingConfirmation(row) {
      return !!(
        row &&
        row.converted_confirmation_number &&
        String(row.converted_confirmation_number).trim() !== "" &&
        String(row.converted_confirmation_number).trim() !== "--"
      );
    }

    function openBookingDetail(row) {
      if (!hasBookingConfirmation(row)) {
        return;
      }
      $rootScope.goToState("", row.converted_confirmation_number, "");
    }

    function isYes(value) {
      return value === "Yes" || value === 1 || value === "1" || value === true;
    }

    function rowMatchesStatus(row, status) {
      var sent = isYes(row.is_email_sent);
      var clicked = isYes(row.is_link_clicked);
      var converted = isYes(row.is_hold_converted);

      if (status === "email_sent") {
        return sent;
      }
      if (status === "clicked") {
        return clicked;
      }
      if (status === "converted") {
        return converted;
      }
      return false;
    }

    function buildCsv(rows) {
      return (rows || []).map(function (row) {
        return {
          Confirmation: row.confirmation_number || "",
          Date: row.hold_created_at || "",
          Customer: row.customer_name || "",
          "Check In": row.room_stay_from || "",
          "Check Out": row.room_stay_to || "",
          Product: row.product_name || "",
          "Email Sent": row.is_email_sent || "",
          "Link Clicked": row.is_link_clicked || "",
          Converted: row.is_hold_converted || "",
          "Converted Via": row.converted_via || "",
          "Booking Confirmation": row.converted_confirmation_number || "",
          Amount: row.converted_amount || ""
        };
      });
    }

    function applyStatusFilter() {
      var hasStatus = vm.selectedStatuses && vm.selectedStatuses.length > 0;
      var hasVia = vm.selectedVias && vm.selectedVias.length > 0;

      vm.rows = (vm.allRows || []).filter(function (row) {
        // Multiple statuses = AND (e.g. Email Sent + Clicked => both Yes)
        if (hasStatus) {
          for (var i = 0; i < vm.selectedStatuses.length; i++) {
            if (!rowMatchesStatus(row, vm.selectedStatuses[i])) {
              return false;
            }
          }
        }

        if (hasVia) {
          var via = String(row.converted_via || "")
            .toLowerCase()
            .trim();
          if (vm.selectedVias.indexOf(via) === -1) {
            return false;
          }
        }

        return true;
      });
      vm.csvData = buildCsv(vm.rows);
    }

    function getReport() {
      vm.requestProcessing = true;
      var startDate = moment(vm.startDate).format("YYYY-MM-DD");
      var endDate = moment(vm.endDate).format("YYYY-MM-DD");
      vm.csvName =
        "courtesy-hold-report-" + startDate + "-to-" + endDate + ".csv";

      reportService
        .getCourtesyHoldReport({
          startDate: startDate,
          endDate: endDate
        })
        .then(function (response) {
          vm.requestProcessing = false;
          vm.init = true;
          if (!response || response.success === false) {
            vm.allRows = [];
            vm.rows = [];
            vm.csvData = [];
            vm.headings = [];
            vm.statusOptions = [];
            vm.csvHeader = [];
            toastMessage.showSimpleToast(
              (response && response.errorMsg) || "Failed to load report",
              "error-toast"
            );
            return;
          }

          vm.headings = response.headings || [];
          vm.csvHeader = angular.copy(vm.headings);
          vm.statusOptions = response.status_options || [];
          vm.allRows = response.rows || [];

          if (vm.selectedStatuses && vm.selectedStatuses.length) {
            var validMap = {};
            angular.forEach(vm.statusOptions, function (opt) {
              validMap[opt.value] = true;
            });
            vm.selectedStatuses = vm.selectedStatuses.filter(function (value) {
              return !!validMap[value];
            });
          }

          applyStatusFilter();
        })
        .catch(function () {
          vm.requestProcessing = false;
          vm.init = true;
          vm.allRows = [];
          vm.rows = [];
          vm.csvData = [];
          vm.headings = [];
          vm.statusOptions = [];
          vm.csvHeader = [];
          toastMessage.showSimpleToast("Failed to load report", "error-toast");
        });
    }
  }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('giftCertificatesController', giftCertificatesController);

    /** @ngInject */
    function giftCertificatesController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $mdDialog,
       $state
    ){
        var vm = this;
		vm.report = {};
        vm.allIds = [];
        vm.all = [];
        vm.csvHeader = ['Issue Date',
                        'Number',
                        'Purchaser',
                        'Expiration date',
                        'Face value',
                        'Redeemed',
                        'Remaining'];
        vm.pdfHeader = angular.copy(vm.csvHeader);

        vm.initialOffset = 0;
        vm.tbodyHeight = 0;       
        // Change the selector if needed
        vm.tableStyle = {};
        vm.table;
        vm.bodyCells;
        vm.colWidth;


        vm.myDate = new Date();
        vm.startDate = new Date(
                                    this.myDate.getFullYear(),
                                    this.myDate.getMonth(),
                                    this.myDate.getDate()
                                  );
        vm.endDate = new Date(
                                    this.myDate.getFullYear(),
                                    this.myDate.getMonth(),
                                    this.myDate.getDate()
                                  );

        vm.noResultFound = false;
        vm.gcLedgerBalance = false;
        /*Functions Dec*/
        vm.getGiftCards = getGiftCards;
        vm.getPrintGiftCards = getPrintGiftCards;
        vm.emailRecords = emailRecords;
        vm.openGiftCard = openGiftCard;

        vm.requestProcessingEmail = false;
        vm.selectedHotels = [];

        function openGiftCard(gc) {

            if (!gc || !gc.gift_card_id) {
                console.error('Gift Card ID not found:', gc);
                return;
            }

            $state.go('app.e-commerce.gcadmins.update', {
                giftCardID: gc.gift_card_id
            });
        }

        function emailRecords(){

            

            $mdDialog.show({
                    controller: 'getEmailAddress',
                    controllerAs: 'vm',
                  templateUrl: 'app/main/apps/reports/getEmailAddress.html',
                  parent: angular.element(document.body),
                  targetEvent: event,
                  clickOutsideToClose:true ,
                                  
                })
                .then(function(answer) {
                  // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                   if(typeof answer != 'undefined'){
                    vm.requestProcessingEmail = true;
                    reportService.getGiftCards({
                        startDate:new Date(moment(vm.startDate).format('YYYY-MM-DD')),
                        endDate:new Date(moment(vm.endDate).format('YYYY-MM-DD')),
                        mode:'sendEmail',
                        emailAddress:answer,
                        'selectedHotels':vm.selectedHotels
                    }).then(function(response){
                        vm.requestProcessingEmail = false;
                    });
                }
               }, function() {});
        }

	
        vm.requestProcessing = false;
        vm.gcLedger = {};
        function getGiftCards(){
           vm.noResultFound = true;
            vm.requestProcessing = true;
            var startDate = moment(vm.startDate).format('YYYY-MM-DD');
            var endDate = moment(vm.endDate).format('YYYY-MM-DD');
            vm.csvName = 'gift-certificates-credits-'+startDate+'-'+endDate+'.csv';
            vm.pdfName = 'gift-certificates-credits-'+startDate+'-'+endDate+'.pdf';
            reportService.getGiftCards({
                startDate:new Date(startDate),
                endDate:new Date(endDate),
                mode:'listing',
                'selectedHotels':vm.selectedHotels
            }).then(function(response){
                vm.requestProcessing = false;
                if(response['data']){
                    vm.giftCards = response['data']; 
                    vm.gcLedgerBalance = (response.giftCardBal !== undefined && response.giftCardBal.show !== undefined) ? response.giftCardBal.show : false;
                    vm.gcLedger = (response.giftCardBal !== undefined && response.giftCardBal !== null) ? response.giftCardBal : {};
                    if (response['data'].length) {
                        setTimeout(function(){
                            vm.tbodyHeight = document.getElementById('tbodyHeight').clientHeight;
                            vm.initialOffset = $('#printSectionId').offset().top;
                            vm.table = $('#heightTable');
                            vm.bodyCells = vm.table.find('tbody tr').children();
                            vm.colWidth;
                            // Adjust the width of thead cells when window resizes
                            $(window).resize(function() {
                                // Get the tbody columns width array
                                vm.colWidth = vm.bodyCells.map(function() {
                                    return $(this).width();
                                }).get();
                            
                               // Set the width of thead columns
                                vm.table.find('thead tr').children().each(function(i, v) {
                                // vm.colWidth[i]-=2;
                                   $(v).width(vm.colWidth[i]);
                                   // console.log($(v).width(vm.colWidth[i] ));
                                });    
                          }).resize(); // Trigger resize handler
                            vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };
                        }, 1000);
                    }
                } else {
                    vm.giftCards = [];
                }
            });
        } 

        function getPrintGiftCards(pdf){
            reportService.getGiftCards({
                startDate :moment(vm.startDate).format('YYYY-MM-DD'),
                endDate   :moment(vm.endDate).format('YYYY-MM-DD'),
                mode:'listing',
                'selectedHotels':vm.selectedHotels,
                pdf:pdf   
            }).then(function(response){
                if(response.data && pdf=='pdf'){
                    var filepathToClean = response.data.filepath;
                    var data = {
                        filename:response.data.filename,
                        filepath:response.data.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        //return;
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
                            lodgingStatistic.cleanDisk(cleanData);
                        }, 2000);
                    });
                }
            });
        }

        vm.ChangeEndDayIf = function(){
            if(!moment(vm.endDate).isAfter(vm.startDate)  || moment(vm.endDate).isSame(vm.startDate)) {
               vm.endDate = moment(vm.startDate).add(0, 'days').format('MM/DD/YYYY');
            }
        }

        vm.downloadFile = function(headers, data, fileName){
            var csvString = '';
            if(!headers || !data || !fileName){
                console.log('some parameter are missing or not valid');
                return ;
            }

            var fileFormat = fileName.split('.');      
            if (data != undefined && data.length) {
                for(var hKey in headers){
                    csvString = csvString + headers[hKey] + ",";
                }
                
                csvString = csvString + "\n";
            }            
            
            for (var pKey in data) {
                var count=0;
                for (var cKey in data[pKey]) {
                   var column = '';
                    if (cKey  != '$$hashKey') {
                        column = (data[pKey][cKey]) ? data[pKey][cKey] : '';
                        column = column + ' ';
                        if (column && column !=  '') {
                            column = (column.indexOf(',') != -1) ? column.replace(/,/g,' ') : column;
                        }
                        csvString = csvString + column + ",";
                    }
                }
                csvString = csvString + "\n";
            }

            if (vm.gcLedgerBalance) {
                if (data != undefined && data.length) {
                    csvString = csvString + "\n";   
                    csvString = csvString + "\n";
                }  
                csvString += "Gift Certificate Ledger Balance,Amount" + "\n";
                csvString += "Gift Certificates Used," + vm.gcLedger.used + "\n";
                csvString += "Gift Certificates Outstanding," + vm.gcLedger.outStanding + "\n";
            }
            
            var a = $('<a/>', {
                style:'display:none',
                href: "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvString),
                download:fileName
            }).appendTo('body')
            a[0].click()
            a.remove(); 
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('DepartureInvoiceController', DepartureInvoiceController);

    /** @ngInject */
    function DepartureInvoiceController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $localStorage,
       $rootScope
    ){
        var vm = this;
		    vm.report = {};
        vm.allIds = [];
        /*Functions Dec*/
        vm.getDepartureReports =getDepartureReports;
        vm.addNumbers = addNumbers;
        vm.printSingleOrder = printSingleOrder;
        vm.PrintAll = PrintAll;
        vm.init = false;
        
        vm.hotelID = $localStorage['preHotelId'];
        vm.selectedHotels = [];
		    vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };

        function PrintAll(){
            vm.requestProcessing1 = true;
            reportService.printSingleOrder({
                data:vm.allIds
            }).then(function(response){
                vm.requestProcessing1 = false;
                vm.print_invoice_data = '';					
    			var myWindow=window.open('','','', '');
    		    myWindow.document.write(response.data);
    			myWindow.document.close();
    			myWindow.focus();  

            });

        }

        vm.myDate = new Date();
        vm.departureDate = new Date(
                                    this.myDate.getFullYear(),
                                    this.myDate.getMonth(),
                                    this.myDate.getDate()
                                  );
		//getDepartureReports();
        function printSingleOrder(confirmation_number){
          vm.requestProcessing2 = true;
           reportService.printSingleOrder({
            data:confirmation_number
           }).then(function(response){
            vm.requestProcessing2 = false;
            vm.print_invoice_data = '';
                    vm.print_invoice_data = response.data;
                    var myWindow=window.open('','','', '');
                     myWindow.document.write(response.data);
                     myWindow.document.close();
                     myWindow.focus();
                       
           });

        }

        function addNumbers(tax, price, priceLength){
            // tax = commonService.roundnum(parseFloat(tax /priceLength),2);
            // price = parseFloat(price);
            // var sum = parseFloat(tax) + parseFloat(price);
            // return commonService.roundnum(sum,2);
            price = parseFloat(price);
            var sum = parseFloat(tax) + parseFloat(price);
            return commonService.roundnum(sum,2);
        }


        function getDepartureReports(){
          vm.data = {};
          vm.allIds = [];
          vm.requestProcessing = true;
            if(vm.departureDate){
                reportService.getCurrentDepartureReservations({
                    departureDate : new Date(moment(vm.departureDate).format('YYYY-MM-DD')),
                    'selectedHotels':vm.selectedHotels,
                    reportFor: vm.reportFor
                }).then(function(response){
                  vm.requestProcessing = false;
                    vm.init = true;
                    if(response.success){
                        vm.data = response['data'];
                        console.log("vm.data ===> ", vm.data);
                        setTimeout(function(){
                          vm.tbodyHeight = document.getElementById('tbodyHeight').clientHeight;
                          vm.initialOffset = $('#table-container').offset().top;
                            vm.table = $('#heightTable');
                            vm.bodyCells = vm.table.find('tbody tr:first').children();
                            vm.colWidth;
                            
                          // Adjust the width of thead cells when window resizes
                            $(window).resize(function() {
                                // Get the tbody columns width array
                                vm.colWidth = vm.bodyCells.map(function() {
                                    return $(this).width();
                                }).get();
                                
                                // Set the width of thead columns
                                vm.table.find('thead tr').children().each(function(i, v) {
                                    $(v).width(vm.colWidth[i]);
                                });    
                            }).resize(); // Trigger resize handler

                          vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };

                        },100);
                    } else {
                        vm.data = {};
                    }
                });
            }            
        }      
    }
})();


(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('customerAdvancedDepositController', customerAdvancedDepositController);

    /** @ngInject */
    function customerAdvancedDepositController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,$mdDialog,$localStorage
    ){
        var vm = this;
		vm.report = {};
        vm.allIds = [];
        vm.all = vm.csvArray = [];
        // vm.csvHeader = ['Itinerary','Confirmation','Checkin','Checkout','Product','Customer name','Traveller name','Lodging tax','Tourist Development tax','Sales tax','Total Tax','Subtotal','Grand total','Paid amount','Remaining amount'];

        vm.csvHeader = [
        'Itinerary',
        'Confirmation',
        'Created on',
        'Checkin',
        'Checkout',
        'Product',
        'Customer name',
        'Grand total',
        'Paid amount',
        'Remaining amount',
        'Advanced Deposit Collected',
        'Advanced Deposit Used'];
        vm.pdfHeader = angular.copy(vm.csvHeader);
        vm.myDate = new Date();
        vm.startDate = new Date(
                                    this.myDate.getFullYear(),
                                    this.myDate.getMonth(),
                                    this.myDate.getDate()
                                  );
        vm.endDate = new Date(
                                    this.myDate.getFullYear(),
                                    this.myDate.getMonth(),
                                    this.myDate.getDate()
                                  );

        vm.noResultFound = false;

        vm.hotelID = $localStorage['preHotelId'];
        /*Functions Dec*/
        vm.getCustomerAdvancedReports = getCustomerAdvancedReports;
        vm.getPrintCustomerAdvancedReports = getPrintCustomerAdvancedReports;
        vm.emailRecords = emailRecords;
        vm.requestProcessingEmail = vm.showSummaryTable = false;
        vm.selectedHotels = [];
        vm.advance_used = vm.advance_outstanding = 0;

        function emailRecords(){
            $mdDialog.show({
                    controller: 'getEmailAddress',
                    controllerAs: 'vm',
                  templateUrl: 'app/main/apps/reports/getEmailAddress.html',
                  parent: angular.element(document.body),
                  targetEvent: event,
                  clickOutsideToClose:true ,

                })
                .then(function(answer) {
                    vm.requestProcessingEmail = false;
                     // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                   if(typeof answer != 'undefined'){
                     vm.requestProcessingEmail = true;
                    reportService.getCustomerAdvancedReports({
                        startDate:new Date(moment(vm.startDate).format('YYYY-MM-DD')),
                        endDate:new Date(moment(vm.endDate).format('YYYY-MM-DD')),
                        mode:'sendEmail',
                        emailAddress:answer,
                        'selectedHotels':vm.selectedHotels,
                        'requestFor'        :  vm.reportFor
                    }).then(function(){
                        vm.requestProcessingEmail = false;

                    });
                }
               }, function() {});
        }

		 vm.requestProcessing = false;
        function getCustomerAdvancedReports(){
            vm.requestProcessing = true;
            vm.showSummaryTable = false;
            var startDate = moment(vm.startDate).format('YYYY-MM-DD');
            var endDate = moment(vm.endDate).format('YYYY-MM-DD');
            vm.csvName = 'customer-advanced-deposit-'+startDate+'-'+endDate+'.csv';
            vm.pdfName = 'customer-advanced-deposit-'+startDate+'-'+endDate+'.pdf';
            vm.not_required = 'tax_amount,tax_id,total_amount';
            reportService.getCustomerAdvancedReports({
                startDate:new Date(startDate),
                endDate:new Date(endDate),
                mode                : 'listing',
                'selectedHotels'    :  vm.selectedHotels,
                'requestFor'        :  vm.reportFor
            }).then(function(response){
                vm.showSummaryTable    = true;
                vm.requestProcessing   = false;
                vm.advance_used        = (response.data.advance_used != undefined) ? response.data.advance_used : 0;
                vm.advance_outstanding = (response.data.advance_outstanding != undefined) ? response.data.advance_outstanding : 0;
                vm.date_vise_total_collected = (response.data.date_vise_total_collected != undefined) ? response.data.date_vise_total_collected : 0;
                vm.date_vise_total_used = (response.data.date_vise_total_used != undefined) ? response.data.date_vise_total_used : 0;
                if(response.data.records != undefined && response.data.records.length > 0){
                    vm.advanced_Customer = response.data.records;
                    vm.csvArray          = response.data.csvArray;
                    vm.noResultFound     = false;
                    setTimeout(function(){
                        vm.tbodyHeight = document.getElementById('tbodyHeight').clientHeight;
                        vm.summaryTbHeight = document.getElementById('summary-table').clientHeight;
                        vm.initialOffset = $('#printSectionId').offset().top;
                        vm.table = $('#heightTable');
                        vm.bodyCells = vm.table.find('tbody tr:first').children();
                        vm.colWidth;
                        // Adjust the width of thead cells when window resizes
                        $(window).resize(function() {
                            vm.colWidth = vm.bodyCells.map(function() { // Get the tbody columns width array
                                return $(this).width();
                            }).get();
                            
                            vm.table.find('thead tr').children().each(function(i, v) { // Set the width of thead columns
                                $(v).width(vm.colWidth[i]);
                            });    
                        }).resize(); // Trigger resize handler
                        vm.tableStyle = { "max-height" : "calc(100vh - 170px - "+ vm.summaryTbHeight +"px)" };
                    },100);

                } else {
                    vm.advanced_Customer = [];
                    vm.noResultFound     = true;
                }
            });

        }

        function getPrintCustomerAdvancedReports(pdf){
            vm.requestPDF = true;
            var date = moment(vm.departureDate).format('YYYY-MM-DD');

            reportService.getCustomerAdvancedReports({
                startDate:moment(vm.startDate).format('YYYY-MM-DD'),
                endDate:moment(vm.endDate).format('YYYY-MM-DD'),
                'selectedHotels'    :  vm.selectedHotels,
                'requestFor'        :  vm.reportFor,
                mode                : 'listing',
                pdf                 :  pdf
            }).then(function(response){
                vm.requestPDF = false;
                vm.init = true;
                if(response.data && pdf=='pdf'){
                    var filepathToClean = response.data.filepath;
                    var data = {
                        filename:response.data.filename,
                        filepath:response.data.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        //return;
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
                            lodgingStatistic.cleanDisk(cleanData);
                        }, 2000);
                    });
                } 
            });
        }

        vm.ChangeEndDayIf = function(){
            if(!moment(vm.endDate).isAfter(vm.startDate) || moment(vm.endDate).isSame(vm.startDate)){
                vm.endDate = moment(vm.startDate).add(0, 'days').format('MM/DD/YYYY');
            }
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('CustomReportsController', CustomReportsController)
        .filter('split', function() {
            return function(input, splitChar, splitIndex) {
                // do some bounds checking here to ensure it has that index
                return input.split(splitChar)[splitIndex];
            }
        });

	/** @ngInject */
	function CustomReportsController(
	   $scope,
	   $state,
	   $stateParams,
	   $http,
	   EnvironmentConfig,
	   toastMessage,
	   lodgingStatistic,
	   $mdDialog,
	   $rootScope,
	   $localStorage,
	   $timeout
	){
			var vm = this;
			var myDate = new Date();
			var hotelName = '';
			var date = new Date();
			vm.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
      vm.toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
			
			vm.hotelID = $localStorage['preHotelId'];
			vm.getrecords = getrecords;
			vm.exportFile = exportFile;
			vm.reservationData = [];
			vm.grandData = [];
			vm.status = false;
			vm.showExport = false;
			vm.selectedHotels = [];
			vm.reportFor = 'room';

			function getrecords(){
				vm.requestProcessing = true;
	    	var startDate = moment(vm.fromDate).format('YYYY-MM-DD');
				var endDate = moment(vm.toDate).format('YYYY-MM-DD');
				var data = {
					startDate:startDate,
					endDate:endDate,
					hotelID: vm.hotelID,
					reportFor: vm.reportFor,
					type: '',
					selectedHotels: vm.selectedHotels
				};
				lodgingStatistic.getcustomreports(data).then(function(response){
					vm.status = response.success;
					vm.reservationData = response.data.reservations;
					vm.reservationObjKey = Object.keys(vm.reservationData);
					vm.grandData       = response.data.grandData;
					vm.requestProcessing = false;
					if(vm.grandData.block.nights == 0 && vm.grandData.hold.nights == 0) {
						vm.showExport = false;
					} else {
						vm.showExport = true;
					}
					setTimeout(function(){
        		vm.initialOffset = $('#printSectionId').offset().top;
						angular.forEach(vm.reservationObjKey, function(action, index) {
							vm.tbodyHeight = document.getElementById('tbodyHeight' + action).clientHeight;
              vm.table = $('#heightTable' + action);
              vm.bodyCells = vm.table.find('tbody tr').children();
              vm.colWidth;
            	// Adjust the width of thead cells when window resizes
              $(window).resize(function() {
                  // Get the tbody columns width array
                  vm.colWidth = vm.bodyCells.map(function() {
                      return $(this).width();
                  }).get();
                  
                  // Set the width of thead columns
                  vm.table.find('thead tr').children().each(function(i, v) {
                      $(v).width(vm.colWidth[i]);
                  });    
              }).resize(); // Trigger resize handler

        			vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };
						});
      		},1000);
				});
			}

			vm.checkSchedule = function(type) {
        if(type == 'from') {
          vm.toDate = new Date(vm.fromDate.getFullYear(), vm.fromDate.getMonth() + 1, 0);
          vm.minDate = vm.fromDate;
          vm.maxDate = vm.toDate;
        }
      }

			function exportFile(type) {
				vm.csvLoader = true;
				var startDate = moment(vm.fromDate).format('YYYY-MM-DD');
				var endDate = moment(vm.toDate).format('YYYY-MM-DD');
				var data = {
					startDate:startDate,
					endDate:endDate,
					hotelID: vm.hotelID,
					reportFor: vm.reportFor,
					type: 'csv',
					selectedHotels: vm.selectedHotels
				};
				lodgingStatistic.getcustomreports(data).then(function(response){
					vm.csvLoader = false;
          vm.csvHeader = ['Block Id','Room','From','To', 'Nights','Revenue','Reason', 'Created By'];
          vm.csvData = response;
          if(startDate === endDate) {
              vm.csvName = 'out_of_order_report_'+ moment(startDate).format('MM-DD-YYYY') + '.csv';
          } else {
              vm.csvName = 'out_of_order_report_'+ moment(startDate).format('MM-DD-YYYY') + '_' + moment(endDate).format('MM-DD-YYYY') +  '.csv';
          }
          $rootScope.downloadFile(vm.csvHeader, vm.csvData, vm.csvName);
				});
			}
		
    }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('AvailabilityReportController', AvailabilityReportController);

	/** @ngInject */
	function AvailabilityReportController(
	   $scope,
	   $state,
	   $stateParams,
	   $http,
	   EnvironmentConfig,
	   toastMessage,
	   reportService,
	   $mdDialog,
	   $rootScope,
	   $localStorage,
	   $timeout,
	   lodgingStatistic,
	   $window
	){
		var vm = this;
		vm.loggedRole = $localStorage.roleId !== undefined ? $localStorage.roleId : 0;
		var myDate = new Date();
		
		vm.initialDate = new Date('2019', '00', '01');
		vm.fromdate = new Date(	myDate.getFullYear(), myDate.getMonth(),	myDate.getDate());
		vm.todate = new Date(myDate.getFullYear(), myDate.getMonth(), myDate.getDate());
		vm.report = {};
		vm.roomList = [];
		vm.dates = {};
		vm.roomCount = [];
		vm.searchedType = 'Room';

       	vm.hotelID = $localStorage['preHotelId'];	

		var reportName = 'Availability Report';

		$scope.selected = [];
		vm.selectedHotels = [];
		vm.getrecords = getrecords;
		vm.exportFile = exportFile;
		$rootScope.getSubHotels($localStorage['preHotelId']);
		vm.requestProcessing = false;

		/**
		* @param: String type
		* Comment: Make csv or pdf data
		*/
		function exportFile(type) {
            if(type == 'pdf') {
                vm.exportLoader = true;
            } else {
                vm.csvLoader = true;
            }

            var departureDate = moment(vm.departureDate).format('MM-DD-YYYY');
            var departureDateTo = moment(vm.departureDateTo).format('MM-DD-YYYY');
            if(departureDate === departureDateTo) {
                vm.csvName = reportName+'-'+departureDate+'.csv';
            } else {
                vm.csvName = reportName+'-'+departureDate + ' - '+ departureDateTo +'.csv';
            }

            reportService.getAvailabilityReportPdfCsv({
                start:moment(vm.departureDate).format('YYYY-MM-DD'),
                end:moment(vm.departureDateTo).format('YYYY-MM-DD'),
                selected_hotel: vm.selectedHotels,
                reportFor: vm.reportFor,
                type: type,
                typeName: vm.searchedType,
                roomList: vm.roomList,
				dates: vm.dates,
				roomCount: vm.roomCount
             }).then(function(response){
                if(type == 'pdf') {
                    vm.exportLoader = false;
                    console.log(response);
                    var filepathToClean = response.data.filepath;
                    var data = {
                        filename:response.data.filename,
                        filepath:response.data.filepath
                    };
                    lodgingStatistic.download_data_request(data).then(function(response){
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
                            lodgingStatistic.cleanDisk(cleanData);
                        }, 2000);
                    });
                } else {
                    vm.csvLoader = false;
                    vm.csvHeader = response.data.headers;
                    vm.csvData = response.data.records;
                    $rootScope.downloadFile(vm.csvHeader, vm.csvData, vm.csvName);
                }
            });
        }

		/**
		* @param: null
		* Comment: Get the records for the availbility
		*/
		function getrecords() {
			vm.requestProcessing = true;
			
			var endDate = moment(vm.todate).format('YYYY-MM-DD');
          	var startDate = moment(vm.fromdate).format('YYYY-MM-DD');
          	var data = {
				start: startDate,
				end: endDate,
				mode:'listing',
				selected_hotel: vm.selectedHotels,
				reportFor: vm.reportFor
			};
			
			if (vm.reportFor == 'boat') {
				vm.searchedType = 'Slips';
			} else if (vm.reportFor == 'rent') {
				vm.searchedType = 'Rent';
			} else {
				vm.searchedType = 'Rooms';
			}

			reportService.getAvailabilityReport(data).then(function(response){
				vm.requestProcessing = false;				
				vm.roomList = response.products;
				vm.dates = response.dates;
				vm.roomCount = response.result;
			});
		}

		vm.ChangeEndDayIf = function(){
			if(!moment(vm.todate).isAfter(vm.fromdate) || moment(vm.todate).isSame(vm.fromdate)){
				vm.todate = moment(vm.fromdate).add(0, 'days').format('MM/DD/YYYY');
			}
		}	
    }
})();

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('arrivalRegistrationCardController', arrivalRegistrationCardController)
        .filter('split', function() {
              return function(input, splitChar, splitIndex) {
                  // do some bounds checking here to ensure it has that index
                  return input.split(splitChar)[splitIndex];
              }
          });

    /** @ngInject */
    function arrivalRegistrationCardController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $localStorage,
       $state
    ){
        var vm = this;
        vm.logo = EnvironmentConfig.api;
        vm.myDate = new Date();
        vm.print = false;
        vm.departureDate = new Date(
                                    this.myDate.getFullYear(),
                                    this.myDate.getMonth(),
                                    this.myDate.getDate()
                                  );
        /*Functions Dec*/
        vm.hotelID = $localStorage['preHotelId'];

        vm.initialOffset = 0;
        vm.tbodyHeight = 0;       
        // Change the selector if needed
        vm.tableStyle = {};
        vm.table;
        vm.bodyCells;
        vm.colWidth;
        vm.channel = 'arrival';
        vm.getReports = getReports;
        vm.printData = printData;
        vm.init = false;
        vm.reservationData = [];
        vm.confirmation_numbers = [];
        vm.resultFound = false;
        vm.selectedHotels = [];


        function getReports(){
            vm.confirmation_numbers = [];
            vm.requestProcessing = true;
            reportService.getAllGiftCardRegistrationCard({
                date:new Date(moment(vm.departureDate).format('YYYY-MM-DD')),
                'selectedHotels':vm.selectedHotels,
                reportFor:vm.reportFor
            }).then(function(response){
                if(response['success'] && response['result'].length > 0 ){
                    vm.reservationData = response['result'];
                    angular.forEach(vm.reservationData, function(value, key) {
                        this.push(value.confirmation_number);
                    }, vm.confirmation_numbers);
                    vm.requestProcessing = false;
                    vm.resultFound = false;
                    setTimeout(function(){
                        vm.tbodyHeight = document.getElementById('tbodyHeight').clientHeight;
                        vm.initialOffset = $('#printSectionId').offset().top;
                        vm.table = $('#heightTable');
                        vm.bodyCells = vm.table.find('tbody tr:first').children();
                        vm.colWidth;
                        // console.log("-->",vm.table);
                        // Adjust the width of thead cells when window resizes
                        $(window).resize(function() {
                            // Get the tbody columns width array
                            vm.colWidth = vm.bodyCells.map(function() {
                                // console.log($(this).width());
                                return $(this).width();
                            }).get();
                      
                             // Set the width of thead columns
                            vm.table.find('thead tr').children().each(function(i, v) {
                                // console.log(i,v);
                                // vm.colWidth[i]+=10;
                                 $(v).width(vm.colWidth[i]);
                             });    
                        }).resize(); // Trigger resize handler

                        vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };
                        //remove Housekeepingtable  simple (from table id)  ms-responsive-table
                    },100);
                }else{
                    vm.reservationData = [];
                    vm.requestProcessing = false;
                    vm.resultFound = true;
                }
            });
        }

        function printData(){ 
            vm.printProcessing = true;           
            reportService.printAllRegistrationCard({
                confirmation_numbers:vm.confirmation_numbers
            }).then(function(response){
                vm.printProcessing = false;
                if(response.data != ''){
                    var myWindow=window.open('', "_blank", "scrollbars=yes, resizable=yes, width=900, height=800");
                        myWindow.document.write(response.data);
                        myWindow.document.close();
                        myWindow.focus();
                        $timeout(function() {
                            myWindow.print();
                        },1000);
                }           
            });
        }
        vm.goToLink = goToLink;

        function goToLink(id,itinary,confirmation){
             $state.go('app.e-commerce.orders.detail', {
                    confirmation_number: confirmation,
                    changeStatusData: ''
                });
        }
    }
})();

(function ()
{
  'use strict';

  angular
	.module('app.rateRule')
	.controller('negotiatedRateRuleController', negotiatedRateRuleController);

  /** @ngInject */
  function negotiatedRateRuleController($stateParams, $state, $scope, $http, EnvironmentConfig, toastMessage, $localStorage,RateRule,$timeout,negotiatedRateService,$mdDialog,$document, $animate, $compile, ganttUtils, GanttObjectModel, ganttDebounce, moment, $window, $mdSidenav, msApi, $translate, $rootScope){
	 
		var vm = this;
		if(!RateRule.success && RateRule.errorMsg){
			vm.mainErrorMsg = RateRule.errorMsg;
		}else{
			vm.mainErrorMsg = false;
		}

        vm.onlyRooms = RateRule.onlyrooms;
		vm.roomtype_subHotelIds = RateRule.roomtype_subHotelIds;
        vm.isParent =  RateRule.isParent;
        vm.boatExists =  RateRule.boatExists;
		vm.ratePlansData = RateRule.ratePlansData;
        vm.channelsData = RateRule.channelsData;
        vm.daysratecalender = RateRule.daysratecalender;
		// vm.roomTypeSel = RateRule.selectedRoom;
        vm.customers = RateRule.customers;
        var objectModel;
		vm.isloading = false;
        // Data
        vm.live = {};
        vm.raterule = {};
       
        vm.ratePlanSel = 0;
        vm.eachrateError = false;
        // vm.optionsAvail = {1:$translate.instant('RATERULE.RATES'), 2:$translate.instant('RATERULE.STOP_SELL'), 3:$translate.instant('RATERULE.CTA'), 4:$translate.instant('RATERULE.CTD'), 5:$translate.instant('RATERULE.MIN_STAY'), 6:$translate.instant('RATERULE.MAX_STAY')};
        vm.optionsAvail = {1:$translate.instant('RATERULE.RATES'), 2:$translate.instant('RATERULE.STOP_SELL'), 5:$translate.instant('RATERULE.MIN_STAY')};
        vm.optionsSel = 1;
        vm.roomTypeSel = vm.customers[0]['id'];
        var date = new Date(), y = date.getFullYear(), m = date.getMonth(), d = date.getDay();
		var unixdateEnd=(moment(date).add(vm.daysratecalender, 'days').unix())*1000;
		var dateTime=new Date(unixdateEnd);
		var date_EE=dateTime.toISOString();
		var firstDay=new Date();
		var lastDay=new Date(date_EE);
		vm.currenttask=[];
		vm.userPermissions = $rootScope.userPermissions;
		if(screen.width >= 3800){
			var zoomval=3;
		}else if(screen.width >= 2500 && screen.width < 3800){
			var zoomval=2;
		}else{
			var zoomval=1;
		}
		vm.maxheight=jQuery(window).height()-220;
        vm.options = {
			headersFormats: {
			  'year': 'YYYY', 
			  'quarter': '[Q]Q YYYY', 
			  month: 'MMMM YYYY', 
			  week: function(column) {
				return column.date.format('MMM D [-]') + column.endDate.format('[ ]MMM D');
			  },
			  day: 'D:dd:M-D-YYYY', 
			  hour: 'H', 
			  minute:'HH:mm'
			},
            mode                    : 'custom',
            scale                   : 'day',
            sortMode                : undefined,
            sideMode                : 'Tree',
            daily                   : true,
            maxHeight               : true,
            width                   : false,
            zoom                    : zoomval,
            rowSortable             : true,
            jsPlumbDefaults             : false,
            columns                 : ['model.name', 'from', 'to'],
            treeTableColumns        : ['from', 'to'],
            columnsHeaders          : {
                'model.name' : 'Rooms', 'from': 'From', 'to': 'To'
            },
            columnsClasses          : {
                'model.name': 'gantt-column-name',
                'from'      : 'gantt-column-from',
                'to'        : 'gantt-column-to'
            },
            columnsFormatters       : {
                'from': function (from)
                {
                    return angular.isDefined(from) ? from.format('lll') : undefined;
                },
                'to'  : function (to)
                {
                    return angular.isDefined(to) ? to.format('lll') : undefined;
                }
            },
            treeHeaderContent       : '{{getHeader()}}',
            columnsHeaderContents   : {
                'model.name': '{{getHeader()}}',
                'from'      : '{{getHeader()}}',
                'to'        : '{{getHeader()}}'
            },
            autoExpand              : 'both',
            taskOutOfRange          : 'expand',
            fromDate                : firstDay,
            toDate                  : lastDay,
            rowContentEnabled       : true,
            rowContent              : '<span>{{row.model.name}}</span>',
            taskContentEnabled      : true,
            taskContent             : '<span class="gantt-task-name">\n    {{task.model.name}}\n    <md-tooltip md-direction="top" class="gantt-chart-task-tooltip">\n        <div layout="column" layout-align="center center">\n            <div class="tooltip-name">\n                {{task.model.tootltiptext}}\n            </div>\n            <div class="tooltip-date">\n                <span>\n                    {{task.model.from.format(\'MMM DD, HH:mm\')}}\n                </span>\n                <span>-</span>\n                <span>\n                    {{task.model.to.format(\'MMM DD, HH:mm\')}}\n                </span>\n            </div>\n        </div>\n    </md-tooltip>\n</span>',
            allowSideResizing       : false,
            labelsEnabled           : true,
            currentDate             : 'none',
            currentDateValue        : new Date(),
            draw                    : false,
            readOnly                : true,
            groupDisplayMode        : 'diabled',
            filterTask              : '',
            filterRow               : '',
           
            timeFrames              : {
                'day'    : {
                    start  : moment('8:00', 'HH:mm'),
                    end    : moment('20:00', 'HH:mm'),
                    working: false,
                    default: false
                },
                'noon'   : {
                    start  : moment('12:00', 'HH:mm'),
                    end    : moment('13:30', 'HH:mm'),
                    working: false,
                    default: false
                },
                'weekend': {
                    color:'#da7b3b'
                },
                'holiday': {
                    working: false,
                    color  : 'red',
                    classes: ['gantt-timeframe-holiday']
                }
            },
            dateFrames              : {
                'weekend'    : {
                    evaluator: function (date)
                    {
                        return date.isoWeekday() === 5 || date.isoWeekday() === 6;
                    },
                    targets  : ['weekend']
                },
                '11-november': {
                    evaluator: function (date)
                    {
                        return date.month() === 10 && date.date() === 11;
                    },
                    targets  : ['holiday']
                }
            },
            timeFramesWorkingMode   : 'hidden',
            timeFramesNonWorkingMode: 'visible',
            columnMagnet            : '15 minutes',
            timeFramesMagnet        : false,
            canDraw                 : function (event)
            {
                var isLeftMouseButton = event.button === 0 || event.button === 1;
                return vm.options.draw && !vm.options.readOnly && isLeftMouseButton;
            },
            drawTaskFactory         : function ()
            {
                return {
                    id   : ganttUtils.randomUuid(),  // Unique id of the task.
                    name : '', // Name shown on top of each task.
                    color: '#AA8833', // Color of the task in HEX format (Optional).
                    darkcolor: '#BCAAA4' // Color of the task in HEX format (Optional).
                };
            },
            api                     : function (ganttApi)
            {
                // API Object is used to control methods and events from angular-gantt.
                vm.api = ganttApi;

                vm.api.core.on.ready($scope, function ()
                {
					
					
                    // When gantt is ready, load data.
                    // `data` attribute could have been used too.
                    vm.isloading = true;
                    $timeout(function ()
					{
						vm.load('graph');
					});
                    

                    // DOM events
                    vm.api.directives.on.new($scope, function (directiveName, directiveScope, element)
                    {
                        /**
                         * Gantt Task
                         */
                        if ( directiveName === 'ganttTask' )
                        {
                            element.on('mousedown touchstart', function (event)
                            {
                                event.preventDefault();
                                event.stopPropagation();
                                vm.live.row = directiveScope.task.row.model;
                                if ( angular.isDefined(directiveScope.task.originalModel) )
                                {
                                    vm.live.task = directiveScope.task.originalModel;
                                }
                                else
                                {
                                    vm.live.task = directiveScope.task.model;
                                }
                                jQuery('.rate-rule-input').html('');
                                vm.raterule = {};
								vm.raterule.channel_id = vm.live.task.channel_id;
								vm.raterule.date = vm.live.task.date;
								vm.raterule.rate_plan_id = vm.live.task.rate_plan_id;
								vm.raterule.room_type_id = vm.live.task.room_type_id;
                                vm.raterule.negotiated_rate_type_id = vm.live.task.negotiated_rate_type_id;
								vm.raterule.pageView = vm.optionsSel;
                                vm.raterule.hotel_id = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
								vm.raterule.sub_hotel_id = vm.roomtype_subHotelIds[vm.live.task.room_type_id];
                                
                                if(vm.optionsSel == 1 && typeof vm.live.task.derived_name!='undefined'){
									toastMessage.showSimpleToast('You cannot edit rates of this rate plan as this is derived from "'+vm.live.task.derived_name+'".','error-toast');
								}else{
									var html='<div class="custom-menu-rate"><form class="eachRateFormCls" name="eachRateForm">';
									if (vm.optionsSel == 1) {
										vm.raterule.room_type_price = vm.live.task.current_val;
										html+='<input type="text" ng-model="vm.raterule.room_type_price" ng-change="vm.editPrice(vm.live.task.index)" ng-model-options="{debounce: 1000}" ng-class="vm.eachrateError?\'errorField rateRuleCustomText\':\'rateRuleCustomText\'" required/>'; 
									}
									html+='<i ng-click="vm.showQuickUpdate(vm.live.task)" class="attachIcon"><md-icon md-font-icon="icon-content-copy" class="icon size15"></md-icon></i>';
									
									html+='</form></div>';
									jQuery('.rate-rule-input').html('');
									angular.element(jQuery('.rate-rule-input')).append($compile(html)($scope));
									//jQuery('.custom-menu').css('top',((vm.live.row.index * 48) + 96)+"px");  
									jQuery('.custom-menu-rate').css('top',((jQuery(element).offset().top) - 205)+"px");  
									jQuery('.custom-menu-rate').css('left',(element.position().left + angular.element('#gantt-side-content').width())+"px");  
									jQuery('.custom-menu-rate').css('max-width',(jQuery(element).css('width')));  
								}
								
                                $scope.$digest();
                            });
                        }

                        /**
                         * Gantt Row
                         */
                        else if ( directiveName === 'ganttRow' )
                        {
                            element.on('click', function (event)
                            {                             
                                event.stopPropagation();
                            });
                            element.on('mousedown touchstart', function (event)
                            {
                                event.stopPropagation();
                                vm.live.row = directiveScope.row.model;
                                $scope.$digest();
                            });
                        }

                        /**
                         * Gantt Row Label
                         */
                        else if ( directiveName === 'ganttRowLabel' )
                        {
                            // Fix for double trigger due to gantt-sortable plugin
                            element.off('click');

                            element.on('click', function (event)
                            {
                                event.preventDefault();
                                editDialog(event, 'row', directiveScope.row);
                            });

                            element.on('mousedown touchstart', function ()
                            {
                                vm.live.row = directiveScope.row.model;
                                $scope.$digest();
                            });

                        }
                    });
					vm.api.tasks.on.resizeEnd($scope,function (task){
						
					});
                    vm.api.tasks.on.rowChange($scope, function (task)
                    {
                        vm.live.row = task.row.model;
                    });

                    objectModel = new GanttObjectModel(vm.api);
                });

                vm.api.rows.on.move($scope, function(row, oldIndex, newIndex){
                    var newsortOrder = [];
                    angular.forEach(vm.data, function (value, key)
                    {
                        newsortOrder.push(value.id);
                    });
                    console.log('newsortOrder',newsortOrder);
                    
                    rateRuleService.setSortOrder({'newsortOrder':newsortOrder}).then(function(response){
                        console.log('response', response);
                        // if(!response.success){
                        //     toastMessage.showSimpleToast('There was some error in saving sort order of rooms. Please try again later.','error-toast');
                        // }
                    });
                    
                });


            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.search = search;
        vm.setSortMode = setSortMode;
        vm.canAutoWidth = canAutoWidth;
        vm.getColumnWidth = getColumnWidth;
        vm.load = load;
        vm.reload = reload;
        vm.copyrates = copyrates;
        vm.bulkUpdate = bulkUpdate;
        vm.showQuickUpdate = showQuickUpdate;
        vm.editPrice = editPrice;
        vm.changeView = changeView;
        vm.changeFilters = changeFilters;

        //////////
		
		init();
        /**
         * Initialize
         */
        function init()
        {
            // Set Gantt Chart height at the init
            calculateHeight();

            angular.element($window).on('resize', function ()
            {
                $scope.$apply(function ()
                {
                    calculateHeight();
                });
            });
        }
        function changeView(){
			jQuery('.rate-rule-input').html('');
			load('sameDate');
		}
		function changeFilters(){
			jQuery('.rate-rule-input').html('');
			load('sameDateAndFilter');
		}
        function showQuickUpdate(taskData){
            taskData.sub_hotel_id = vm.roomtype_subHotelIds[taskData.room_type_id];
			jQuery('.rate-rule-input').html('');
			$mdDialog.show({
				controller         : 'NegoRateDialogController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/apps/rateRule/negotiatedRateRule/dialogs/rate-dialog.html',
				parent             : angular.element($document.find('#product-container')),
				targetEvent        : event,
				scope:$scope.$new(),
				clickOutsideToClose: true,
				locals             : {
					Ratedata	: taskData,
					optionsSel	: vm.optionsSel
				}
			});
		}
		function editPrice(indexTask){
			vm.isloading = true;
			vm.eachrateError = false;
            negotiatedRateService.setNegoRateRuleData(vm.raterule).then(function(response){
				vm.isloading = false;
				if(response.success){
					jQuery('.rate-rule-input').html('');
					vm.data[vm.live.row.index].tasks[indexTask].name = response.newVal;
					load('changeDate');
				}else if(response.errorMsg){
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				} else{
					toastMessage.showSimpleToast('There was some error in updating '+(vm.optionsAvail[vm.optionsSel]).toLowerCase()+'.','error-toast');
				}
			});
		}

        /**
         * Max Height Fix
         */
        function calculateHeight()
        {
            vm.options.maxHeight = $document.find('#chart-container').offsetHeight;
        }

        
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };
		function isScrolledIntoView(elem)
		{
			var docViewTop = $(window).scrollTop();
			var docViewBottom = docViewTop + $(window).height();

			var elemTop = $(elem).offset().top;
			var elemBottom = elemTop + $(elem).height();

			return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
		}
        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Search
         * @param sidenavId
         */
        function search(option, keyword)
        {
            if ( option === 'rows' )
            {
                vm.options.filterRow = keyword;
            }
            else if ( option === 'tasks' )
            {
                vm.options.filterTask = keyword;
            }
        }

        /**
         * Sort Mode
         * @param mode
         */
        function setSortMode(mode)
        {
            vm.options.sortMode = mode;

            if ( angular.isUndefined(mode) )
            {
                vm.options.rowSortable = true;
            }
            else
            {
                vm.options.rowSortable = false;
            }
        }

        /**
         * Side Mode
         */
        $scope.$watch('vm.options.sideMode', function (newValue, oldValue)
        {
            if ( newValue !== oldValue )
            {
                vm.api.side.setWidth(undefined);

                $timeout(function ()
                {
                    vm.api.columns.refresh();
                });
            }
        });

        function canAutoWidth(scale)
        {
            if ( scale.match(/.*?hour.*?/) || scale.match(/.*?minute.*?/) )
            {
                return false;
            }

            return true;
        }

        function getColumnWidth(widthEnabled, scale, zoom)
        {
            if ( !widthEnabled && vm.canAutoWidth(scale) )
            {
                return undefined;
            }

            if ( scale.match(/.*?week.*?/) )
            {
                return 150 * zoom;
            }

            if ( scale.match(/.*?month.*?/) )
            {
                return 300 * zoom;
            }

            if ( scale.match(/.*?quarter.*?/) )
            {
                return 500 * zoom;
            }

            if ( scale.match(/.*?year.*?/) )
            {
                return 800 * zoom;
            }

            return 40 * zoom;
        }

        // Reload data action
        function load(location)
        {
			jQuery('.rate-rule-input').html('');
			vm.isloading = true;
            if(location=='changeDate'){
				var from = vm.options.fromDate;
				var to = moment(moment(moment(from).format('YYYY/MM/DD')).add(vm.daysratecalender, 'days')).format('YYYY/MM/DD');
				from = moment(from).format('YYYY/MM/DD');
				vm.options.toDate = to;
				var datas = {start:from,end:to, hotel_id:$localStorage.hotels[$localStorage.selectedHotel]['hotel_id'],pageView:vm.optionsSel};
				if(vm.roomTypeSel!=0){
					datas.roomFilter = vm.roomTypeSel;
				}if(vm.ratePlanSel!=0){
					datas.ratePlanFilter = vm.ratePlanSel;
				}
				negotiatedRateService.getNegotiatedRateRuleData(datas).then(function(response){
					vm.isloading = false;
                     // vm.roomTypeSel = response.selectedRoom;
					if(response.success){

						var data = [];
						for(var i=0;i<(response.roomsDetail).length;i++){
							data.push(JSON.parse((response.roomsDetail)[i]));
						}
						vm.data = data;
						vm.onlyRooms = response.onlyrooms;
                        vm.roomtype_subHotelIds = response.roomtype_subHotelIds;
					}else if(response.errorMsg){
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					} else{
						toastMessage.showSimpleToast('There was some error in fetching prices for selected range.','error-toast');
					}
				});
			}else if(location=='sameDate' || location=='sameDateAndFilter'){
				var from = vm.options.fromDate;
				var to = vm.options.toDate;
				var datas = {start:from,end:to, hotel_id:$localStorage.hotels[$localStorage.selectedHotel]['hotel_id'],pageView:vm.optionsSel};
				if(vm.roomTypeSel!=0){
					datas.roomFilter = vm.roomTypeSel;
				}if(vm.ratePlanSel!=0){
					datas.ratePlanFilter = vm.ratePlanSel;
				}
				negotiatedRateService.getNegotiatedRateRuleData(datas).then(function(response){
					vm.isloading = false;
					if(response.success){
						var data = [];
						for(var i=0;i<(response.roomsDetail).length;i++){
							data.push(JSON.parse((response.roomsDetail)[i]));
						}
						vm.data = data;
						vm.onlyRooms = response.onlyrooms;
                        vm.roomtype_subHotelIds = response.roomtype_subHotelIds;
					}else if(response.errorMsg){
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					} else{
						toastMessage.showSimpleToast('There was some error in fetching prices for selected range.','error-toast');
					}
				});
			}else{
				var data = [];
				for(var i=0;i<(RateRule.roomsDetail).length;i++){
                	data.push(JSON.parse((RateRule.roomsDetail[i])));
				}
                vm.data = data;
				vm.onlyRooms = RateRule.onlyrooms;
                vm.roomtype_subHotelIds = RateRule.roomtype_subHotelIds;
				vm.isloading = false;
			}
            // Fix for Angular-gantt-chart issue
            $animate.enabled(true);
            $animate.enabled($document.find('#gantt'), false);

        }

        /**
         * Reload Data
         */
         vm.reset = reset;

         function reset(){
            vm.ratePlanSel = 0
            vm.options.fromDate = new Date();
            vm.searchRowKeyword = '';
            vm.options.filterRow = '';
            vm.optionsSel = 1;
         }
        function reload()
        {
            reset();
			jQuery('.rate-rule-input').html('');
			vm.isloading = true;
			negotiatedRateService.getNegotiatedRateRuleData({hotel_id:$localStorage.hotels[$localStorage.selectedHotel]['hotel_id']}).then(function(response){
				vm.isloading = false;
				if(response.success){
					// if(vm.onlyRooms[0]) vm.roomTypeSel = vm.onlyRooms[0].id;
					// else vm.roomTypeSel = 0;
                    vm.roomTypeSel = response.selectedRoom;
					vm.ratePlanFilter = 0;
					var from = new Date();
					var to = moment(moment(moment(from).format('YYYY/MM/DD')).add(vm.daysratecalender, 'days')).format('YYYY/MM/DD');
					vm.options.toDate = to;
					vm.options.fromDate = from;
					var data = [];
					for(var i=0;i<(response.roomsDetail).length;i++){
						data.push(JSON.parse((response.roomsDetail)[i]));
					}
					vm.data = data;
					vm.onlyRooms = response.onlyrooms;
                    vm.roomtype_subHotelIds = response.roomtype_subHotelIds;
				}else if(response.errorMsg){
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				} else{
					toastMessage.showSimpleToast('There was some error in fetching prices for selected range.','error-toast');
				}
			});
        }

        // Visual two way binding.
        var ganttDebounceValue = 1000;

        var listenTaskJson = ganttDebounce(function (taskJson)
        {
            if ( angular.isDefined(taskJson) )
            {
                var task = angular.fromJson(taskJson);
                objectModel.cleanTask(task);
                var model = vm.live.task;
                angular.extend(model, task);
            }
        }, ganttDebounceValue);

        $scope.$watch('vm.live.taskJson', listenTaskJson);

        var listenRowJson = ganttDebounce(function (rowJson)
        {
            if ( angular.isDefined(rowJson) )
            {
                var row = angular.fromJson(rowJson);
                objectModel.cleanRow(row);
                var tasks = row.tasks;

                delete row.tasks;
                var rowModel = vm.live.row;

                angular.extend(rowModel, row);

                var newTasks = {};
                var i, l;

                if ( angular.isDefined(tasks) )
                {
                    for ( i = 0, l = tasks.length; i < l; i++ )
                    {
                        objectModel.cleanTask(tasks[i]);
                    }

                    for ( i = 0, l = tasks.length; i < l; i++ )
                    {
                        newTasks[tasks[i].id] = tasks[i];
                    }

                    if ( angular.isUndefined(rowModel.tasks) )
                    {
                        rowModel.tasks = [];
                    }

                    for ( i = rowModel.tasks.length - 1; i >= 0; i-- )
                    {
                        var existingTask = rowModel.tasks[i];
                        var newTask = newTasks[existingTask.id];

                        if ( angular.isUndefined(newTask) )
                        {
                            rowModel.tasks.splice(i, 1);
                        }
                        else
                        {
                            objectModel.cleanTask(newTask);
                            angular.extend(existingTask, newTask);

                            delete newTasks[existingTask.id];
                        }
                    }
                }
                else
                {
                    delete rowModel.tasks;
                }

                angular.forEach(newTasks, function (newTask)
                {
                    rowModel.tasks.push(newTask);
                });
            }
        }, ganttDebounceValue);

        $scope.$watch('vm.live.rowJson', listenRowJson);

        $scope.$watchCollection('vm.live.task', function (task)
        {
            vm.live.taskJson = angular.toJson(task, true);
            vm.live.rowJson = angular.toJson(vm.live.row, true);
        });
        
		
        $scope.$watchCollection('vm.live.row', function (row)
        {
            vm.live.rowJson = angular.toJson(row, true);
            if ( angular.isDefined(row) && angular.isDefined(row.tasks) && row.tasks.indexOf(vm.live.task) < 0 )
            {
                vm.live.task = row.tasks[0];
            }
        });

        $scope.$watchCollection('vm.live.row.tasks', function ()
        {
            vm.live.rowJson = angular.toJson(vm.live.row, true);
        });
        
        // Event handler
        var logTaskEvent = function(eventName, task) {
            
        };
        
        // Event utility function
        var addEventName = function(eventName, func) {
            return function(data) {
                return func(eventName, data);
            };
        };
	
	$scope.$on('update_full_ganttchart', function(event) { 
		load('changeDate');
	});

	function bulkUpdate(ev){
		$mdDialog.show({
			controller         : 'NegoBulkUpdateDialogCont',
			controllerAs       : 'vm',
			templateUrl        : 'app/main/apps/rateRule/negotiatedRateRule/dialogs/nego-bulk-update-dialog.html',
			parent             : angular.element($document.find('#product-container')),
			targetEvent        : ev,
			scope:$scope.$new(),
			clickOutsideToClose: true,
			locals             : {
				RoomsRateChannel	: vm.onlyRooms,
				RateData			: vm.ratePlansData,
                channelsData        : vm.channelsData,
				Rooms_sub_hotel_ids	: vm.roomtype_subHotelIds,
                pageFrom            : 'rateCalander',
                extraParams         : [],
                casitas_data        : [],
                negotiatedRates: vm.customers
			}
		});
	}
	function showNavigator(){
		vm.showCal = true;
	}
	function hideNavigator(){
		vm.showCal = false;
	}
	function copyrates(ev){
        $mdDialog.show({
			controller         : 'copyRatesDialogCont',
			controllerAs       : 'vm',
			templateUrl        : 'app/main/apps/rateRule/dialogs/copy-rates-dialog.html',
			parent             : angular.element($document.find('#product-container')),
			targetEvent        : ev,
			scope:$scope.$new(),
			clickOutsideToClose: true,
			locals             : {
				RoomsRateChannel	: vm.onlyRooms,
				RateData			: vm.ratePlansData,
				channelsData			: vm.channelsData
			}
		});	
	}
	

  }
})();

'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../category/categoryService
 * @description
 * # ../category/categoryService
 * Service in the minervaApp.
 */
angular.module('app.rateRule')
  .service('negotiatedRateService', function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
 	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}
 	
 	function getNegotiatedRateRuleData(data){
		return $http({
			url:EnvironmentConfig.api+'Raterule/getNegotiatedRateRuleData',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	function setNegoRateRuleData(data){
		return $http({
			url:EnvironmentConfig.api+'Raterule/skipAcl_setNegoRateRuleData',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	function setRateRuleBatch(data){
		return $http({
			url:EnvironmentConfig.api+'Raterule/skipAcl_setNegoRateRuleBatch',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	function setBulkRateRule(data){
		return $http({
			url:EnvironmentConfig.api+'Raterule/setNegotiatedRateRuleBulk',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function setCopyPrice(data){
		return $http({
			url:EnvironmentConfig.api+'Raterule/setCopyPriceBulk',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function setSortOrder(data){
		return $http({
			url:EnvironmentConfig.api+'Raterule/updateSortOrder',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getRateRulesData(hotelID){
		return $http({
			url:EnvironmentConfig.api + 'Raterule/getRateRulesData',
			method:'POST',
			data:{hotelID: hotelID}
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	return{
 		 getNegotiatedRateRuleData: getNegotiatedRateRuleData,
 		 setCopyPrice: setCopyPrice,
 		 setNegoRateRuleData: setNegoRateRuleData,
 		 setRateRuleBatch: setRateRuleBatch,
 		 setBulkRateRule: setBulkRateRule,
 		 setSortOrder: setSortOrder,
 		 getRateRulesData: getRateRulesData
 	}
 });

(function () {
  "use strict";

  angular
    .module("app.rateRule")
    .controller("RateDialogController", RateDialogController);

  /** @ngInject */
  function RateDialogController(
    $mdDialog,
    Ratedata,
    toastMessage,
    $localStorage,
    $scope,
    rateRuleService,
    $rootScope,
    $translate,
    optionsSel
  ) {
    var vm = this;
    // Data
    vm.title = $translate.instant("RATERULE.QUICK_ROW_UPDATE");
    vm.rateMaxError = false;
    vm.showLoader = false;
    vm.currentDateValue = new Date();
    vm.selectedDays = ["1", "2", "3", "4", "5", "6", "0"];
    vm.daysWeek = {
      1: $translate.instant("RATERULE.MONDAY"),
      2: $translate.instant("RATERULE.TUESDAY"),
      3: $translate.instant("RATERULE.WEDNESDAY"),
      4: $translate.instant("RATERULE.THURSDAY"),
      5: $translate.instant("RATERULE.FRIDAY"),
      6: $translate.instant("RATERULE.SATURDAY"),
      0: $translate.instant("RATERULE.SUNDAY"),
    };
    var dataRate = Ratedata;
    vm.autoFillOff = true;
    if (
      !dataRate.room_type_id ||
      !dataRate.rate_plan_id ||
      !dataRate.channel_id ||
      !dataRate.date ||
      !dataRate.current_val
    ) {
      toastMessage.showSimpleToast(
        "There was some error in fetching prices for selected range.",
        "error-toast"
      );
      $mdDialog.hide();
    } else {
      vm.indexTask = dataRate.index;
      vm.raterule = {};
      vm.raterule.room_type_id = dataRate.room_type_id;
      vm.raterule.sub_hotel_id = dataRate.sub_hotel_id;
      vm.raterule.rate_plan_id = dataRate.rate_plan_id;
      vm.raterule.channel_id = dataRate.channel_id;
      vm.raterule.date = dataRate.date;
      vm.optionsSel = optionsSel;
      if (optionsSel == 1) vm.raterule.room_type_price = dataRate.current_val;
      else if (optionsSel == 2) vm.raterule.is_stop_sell = dataRate.current_val;
      else if (optionsSel == 3) vm.raterule.is_cta = dataRate.current_val;
      else if (optionsSel == 4) vm.raterule.is_ctd = dataRate.current_val;
      else if (optionsSel == 5) vm.raterule.min_stay = dataRate.current_val;
      else if (optionsSel == 6) vm.raterule.max_stay = dataRate.current_val;
      vm.raterule.hotel_id =
        $localStorage.hotels[$localStorage.selectedHotel]["hotel_id"];
    }

    //Methods
    vm.closeDialog = closeDialog;
    vm.saveRowPrice = saveRowPrice;
    vm.addSelectedDays = addSelectedDays;
    $scope.checkList = function () {
      $scope.user.roles.splice(0, $scope.user.roles.length);
      $scope.user.roles.push("guest");
    };
    function addSelectedDays(dayWeek) {
      if (vm.selectedDays.indexOf(dayWeek) === -1) {
        //adding a day
        vm.selectedDays.push(dayWeek);
      } else {
        //removing a day
        vm.selectedDays.splice(vm.selectedDays.indexOf(dayWeek), 1);
      }
    }
    vm.requestProgressing = false;
    function saveRowPrice() {
      var data = {
        data: vm.raterule,
        from_range: moment(vm.from_range).format("YYYY-MM-DD"),
        to_range: moment(vm.to_range).format("YYYY-MM-DD"),
        selectedDays: vm.selectedDays,
        pageView: optionsSel,
      };
      vm.showLoader = true;
      vm.requestProgressing = true;
      rateRuleService.setRateRuleBatch(data).then(function (response) {
        vm.showLoader = false;
        if (response.success) {
          vm.closeDialog();
          $rootScope.$broadcast("update_full_ganttchart");
          $rootScope.$broadcast("update_custom_row_ratecalendar");
        } else if (response.errorMsg) {
          toastMessage.showSimpleToast(response.errorMsg, "error-toast");
        } else {
          toastMessage.showSimpleToast(
            "There was some error in updating prices.",
            "error-toast"
          );
        }
        vm.requestProgressing = false;
      });
    }
    function closeDialog() {
      $mdDialog.hide();
    }
    setTimeout(function () {
      vm.autoFillOff = false;
    }, 1500);
  }
})();

(function ()
{
	'use strict';

	angular
	.module('app.rateRule')
	.controller('copyRatesDialogCont', copyRatesDialogCont);

	/** @ngInject */
	function copyRatesDialogCont($mdDialog, $translate, RoomsRateChannel, RateData, channelsData, rateRuleService, $rootScope, toastMessage){
		var vm = this;

		// Data
		vm.title = $translate.instant('RATERULE.COPY_RATES');
		vm.optionsAvail = {1:$translate.instant('RATERULE.RATE'), 2:$translate.instant('RATERULE.CHANNEL'), 3:$translate.instant('RATERULE.ROOM'), 4:$translate.instant('RATERULE.DATE_RANGE')};
		vm.roomsRates = RoomsRateChannel;
		vm.ratesData = RateData;
		vm.channelsData = channelsData;
		vm.optionsSel = 2;
		vm.copyingOptions = angular.copy(channelsData);
		vm.copyprice = [];
		vm.copyprice.seleRates = [];
		vm.copyprice.seleRates.rate = [];
		vm.copyprice.seleRates.channels = [];
		vm.copyprice.seleRates.rooms = [];
		vm.selectAll = [];
		vm.selectAll['rate'] = false;
		vm.selectAll['channels'] = false;
		vm.selectAll['rooms'] = false;
		vm.advancedSettings = false;
		vm.to_range = '';
		vm.from_range = '';
		vm.currentDateValue = new Date();
		//Methods
		vm.closeDialog = closeDialog;
		vm.changeView = changeView;
		vm.selectall= selectall;
		vm.addSelectedData= addSelectedData;
		vm.triggerAdvancedSett= triggerAdvancedSett;
		vm.saveCopyPrice= saveCopyPrice;
		
		function closeDialog()
		{
			$mdDialog.hide();
		}
		function changeView(){
			if(vm.optionsSel==1)
				vm.copyingOptions = angular.copy(vm.ratesData);
			else if(vm.optionsSel==2)
				vm.copyingOptions = angular.copy(vm.channelsData);
			else if(vm.optionsSel==3)
				vm.copyingOptions = angular.copy(vm.roomsRates);
			else if(vm.optionsSel==4){

			}
			vm.fromCopying = '';
			vm.toCopying = '';
		}
		function selectall(type, array, idname, action){
			if(vm.copyprice.seleRates[type].length==array.length && action!='allselected'){
				vm.copyprice.seleRates[type] = [];
				vm.selectAll[type] = true;
			}else{
				vm.copyprice.seleRates[type] = [];	
				for(var i=0; i<=array.length-1; i++){
					vm.copyprice.seleRates[type].push(array[i][idname]);
					vm.selectAll[type] = false;
				}
			}
		}
		function addSelectedData(type,id,array){
			if(!vm.copyprice.seleRates[type]) vm.copyprice.seleRates[type] = [];
			if(vm.copyprice.seleRates[type].indexOf(id)===-1){
				vm.copyprice.seleRates[type].push(id);
			}
			else {
				vm.copyprice.seleRates[type].splice(vm.copyprice.seleRates[type].indexOf(id), 1);
			}
			if(vm.copyprice.seleRates[type].length==array.length) vm.selectAll[type] = true;
			else vm.selectAll[type] = false;
		}
		function triggerAdvancedSett(){
			if(vm.advancedSettings){
				vm.advancedSettings = false;
			}else{
				vm.advancedSettings = true;
			}
		}
		function saveCopyPrice(){
			var tempSelectedIds = [];
			if(vm.optionsSel==1){
				vm.fromCopying = angular.copy(vm.ratesData[vm.fromCopying].rate_plan_id);
				// vm.toCopying = angular.copy(vm.ratesData[vm.toCopying].rate_plan_id);
				vm.toCopying.forEach(function(element, index){
					tempSelectedIds[index] = vm.ratesData[element].rate_plan_id;
				});
				vm.toCopying = angular.copy(tempSelectedIds);
				/**/
				if(!vm.advancedSettings){
					vm.selectall('channels',vm.channelsData,'channel_id','allselected');
					vm.selectall('rooms',vm.roomsRates,'id','allselected');
				}
			}else if(vm.optionsSel==2){
				vm.fromCopying = angular.copy(vm.channelsData[vm.fromCopying].channel_id);
				// vm.toCopying = angular.copy(vm.channelsData[vm.toCopying].channel_id);
				vm.toCopying.forEach(function(element, index){
					tempSelectedIds[index] = vm.channelsData[element].channel_id;
				});
				vm.toCopying = angular.copy(tempSelectedIds);

				if(!vm.advancedSettings){
					vm.selectall('rate',vm.ratesData,'rate_plan_id','allselected');
					vm.selectall('rooms',vm.roomsRates,'id','allselected');
				}
			}else if(vm.optionsSel==3){
				vm.fromCopying = angular.copy(vm.roomsRates[vm.fromCopying].id);
				// vm.toCopying = angular.copy(vm.roomsRates[vm.toCopying].id);

				vm.toCopying.forEach(function(element, index){
					tempSelectedIds[index] = vm.roomsRates[element].id;
				});
				vm.toCopying = angular.copy(tempSelectedIds);

				if(!vm.advancedSettings){
					vm.selectall('rate',vm.ratesData,'rate_plan_id');
					vm.selectall('channels',vm.channelsData,'channel_id');
				}
			}else if(vm.optionsSel == 4){

				vm.fromCopying = {'start':new Date(moment(vm.dateRangeFromStart).format('YYYY-MM-DD')), 'end':new Date(moment(vm.dateRangeFromEnd).format('YYYY-MM-DD'))};
				vm.toCopying = {'start':new Date(moment(vm.dateRangeToStart).format('YYYY-MM-DD')), 'end':new Date(moment(vm.dateRangeToEnd).format('YYYY-MM-DD'))};

				if(!vm.advancedSettings){
					vm.selectall('rate',vm.ratesData,'rate_plan_id');
					vm.selectall('channels',vm.channelsData,'channel_id');
					vm.selectall('rooms',vm.roomsRates,'id','allselected');
				}
			}
			
			vm.queryRunning = true;
			var converted = Object.assign({}, vm.copyprice.seleRates);
			var data = {seleRates:converted,from_range:new Date(moment(vm.from_range).format('YYYY-MM-DD')),to_range:new Date(moment(vm.to_range).format('YYYY-MM-DD')),copying:vm.optionsSel,advancedSettings:vm.advancedSettings,fromCopying:vm.fromCopying,toCopying:vm.toCopying};
			
			rateRuleService.setCopyPrice(data).then(function(response){
				if(response.success){
					vm.closeDialog();
					$rootScope.$broadcast('update_full_ganttchart');
				}else if(response.errorMsg){
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				} else{
					toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
				}
				vm.queryRunning = false;
			});
		}

		vm.getDateValidation = getDateValidation;
		function getDateValidation(){

			if(typeof vm.dateRangeFromStart == 'undefined' || typeof vm.dateRangeFromEnd  == 'undefined' || typeof vm.dateRangeToStart  == 'undefined' || typeof vm.dateRangeToEnd  == 'undefined'){
				return true;		
			}else {
				return false;
			}
		}
	}
})();

(function ()
{
	'use strict';

	angular
	.module('app.rateRule')
	.controller('BulkUpdateDialogCont', BulkUpdateDialogCont);

	/** @ngInject */
	function BulkUpdateDialogCont(
		$mdDialog, 
		RoomsRateChannel, 
		RateData, 
		channelsData, 
		Rooms_sub_hotel_ids,
		pageFrom, 
		toastMessage, 
		$localStorage, 
		$scope, 
		rateRuleService, 
		$rootScope,
		extraParams,
		$translate,
		$timeout,
		$httpParamSerializer,
		dashboardGraphService,
		casitas_data
		){
		var vm = this;
		// Data
		if(pageFrom == "dashboard"){
			if(extraParams.min_stay) {
				vm.title = $translate.instant('RATERULE.EDIT_MLS_SMALL');
			} else if(extraParams.max_stay) {
				vm.title = $translate.instant('RATERULE.EDIT_MAS_SMALL');
			} else if(extraParams.is_stop_sell) {
				vm.title = $translate.instant('RATERULE.EDIT_ST_SMALL');
			} else if(extraParams.is_cta) {
				vm.title = $translate.instant('RATERULE.EDIT_CTA_SMALL');
			} else if(extraParams.is_ctd) {
				vm.title = $translate.instant('RATERULE.EDIT_CTD_SMALL');
			}
		} else {
			vm.title = $translate.instant('RATERULE.BULK_UPDATE_SMALL');
		}
		vm.rateMaxError = false;
		vm.ratebulk = [];
		vm.currentTab = 'room';
		if(extraParams.type !== undefined) {
			vm.currentTab = extraParams.type;
		}
		vm.previousRecords = {};
		vm.fixedRate = [];
		vm.derivedRates = [];

		vm.autoFillOff = true;
		if (extraParams !== undefined && extraParams != null) {
			vm.previousRecords = angular.copy(extraParams); 
		}

		vm.ratebulk.selectedDays = ['1', '2', '3', '4', '5', '6', '0'];
		vm.daysWeek = {1:$translate.instant('RATERULE.MONDAY'), 2:$translate.instant('RATERULE.TUESDAY'), 3:$translate.instant('RATERULE.WEDNESDAY'), 4:$translate.instant('RATERULE.THURSDAY'), 5:$translate.instant('RATERULE.FRIDAY'), 6:$translate.instant('RATERULE.SATURDAY'), 0:$translate.instant('RATERULE.SUNDAY')};
		if(pageFrom == "dashboard"){
			if(extraParams.min_stay) {
				vm.optionsAvail = {5:$translate.instant('RATERULE.MIN_STAY')};
			} else if(extraParams.max_stay) {
				vm.optionsAvail = {6:$translate.instant('RATERULE.MAX_STAY')};
			} else if(extraParams.is_stop_sell) {
				vm.optionsAvail = {2:$translate.instant('RATERULE.STOP_SELL')};
			} else if(extraParams.is_cta) {
				vm.optionsAvail = {3:$translate.instant('RATERULE.CTA')};
			} else if(extraParams.is_ctd) {
				vm.optionsAvail = {4:$translate.instant('RATERULE.CTD')};
			}
		} else {
			// vm.optionsAvail = {1:$translate.instant('RATERULE.RATES'), 2:$translate.instant('RATERULE.STOP_SELL'), 3:$translate.instant('RATERULE.CTA'), 4:$translate.instant('RATERULE.CTD'), 5:$translate.instant('RATERULE.MIN_STAY'), 6:$translate.instant('RATERULE.MAX_STAY')};
			vm.optionsAvail = {1:$translate.instant('RATERULE.RATES'), 2:$translate.instant('RATERULE.STOP_SELL'), 3:$translate.instant('RATERULE.CTA'), 4:$translate.instant('RATERULE.CTD'), 5:$translate.instant('RATERULE.MIN_STAY')};
		}

		vm.optionsSel = 1;
        vm.selectRate = 'new';
        vm.rate_plan_adjust_indicator = '1';
        vm.rate_plan_percentage = '0';
		vm.ratebulk.seleRates = [];
		vm.roomsRates = [];
		vm.showRoomBoatsBulk = false;
		vm.type = 'rooms';
		vm.hotelID = $localStorage.preHotelId;
		var roomIDs;
		vm.roomcasitas = [];
		vm.parentRoom = [];
		
		$timeout(function() {
			var bulkType = 5;
			if(extraParams.max_stay) {
				bulkType = 6
			} else if(extraParams.min_stay) {
				bulkType = 5;
			} else if(extraParams.is_stop_sell) {
				bulkType = 2;
			} else if(extraParams.is_cta) {
				bulkType = 3;
			} else if(extraParams.is_ctd) {
				bulkType = 4;
			}
            if(typeof extraParams.update != 'undefined' && extraParams.update == 'rate'){
            	angular.element('#channelSelector').triggerHandler('click');
				angular.element('#channelSelector').triggerHandler('click');
				vm.optionsSel = bulkType;
				if(bulkType == 5) {
					vm.ratebulk.min_stay = extraParams.min_stay;
				} else if(bulkType == 6) {
					vm.ratebulk.max_stay = extraParams.max_stay;
				} else if(bulkType == 2) {
					vm.ratebulk.is_stop_sell = extraParams.is_stop_sell;
				} else if(bulkType == 3) {
					vm.ratebulk.is_cta = extraParams.is_cta;
				} else if(bulkType == 4) {
					vm.ratebulk.is_ctd = extraParams.is_ctd;
				}

				var newFromDate = extraParams.startDate.split('-');
				var newEndDate = extraParams.endDate.split('-');
				vm.from_range =new Date(moment(newFromDate[2]+'-'+newFromDate[0]+'-'+newFromDate[1]).format('YYYY-MM-DD'));
				vm.from_range.setMinutes( vm.from_range.getMinutes() + vm.from_range.getTimezoneOffset() );
				vm.to_range = new Date(moment(newEndDate[2]+'-'+newEndDate[0]+'-'+newEndDate[1]).format('YYYY-MM-DD'));
				vm.to_range.setMinutes( vm.to_range.getMinutes() + vm.to_range.getTimezoneOffset() );


				if(Object.keys(extraParams.channel_ids).length == vm.channelsData.length){
					angular.element('#channelSelector').triggerHandler('click');
				}else{
					vm.ratebulk.seleRates.channels = extraParams.channel_ids;
				}
				if(extraParams.rooms_ids.length == vm.roomsRates.length){
					vm.selectall('rooms',vm.roomsRates,'id', vm.roomsRates)
					vm.selectAll['rooms'] = true;
				}else{
					vm.ratebulk.seleRates.rooms = extraParams.rooms_ids;
				}

				if(vm.hotelID == 128){
					angular.forEach(vm.roomsRates, function(val, key) {
						var keyArray = val.room_type_refs_id.split(',');	
						var counter = 0;
						angular.forEach(vm.ratebulk.seleRates.rooms, function(value, index) {
							if(keyArray.indexOf(value) !== -1) {
								counter++;
							}
						});
						if(parseInt(counter) == parseInt(keyArray.length)) {
							vm.casitasRooms.push(val.room_type_id);
						}
					});
					// casitas is having 4 parent rooms.
					if(vm.casitasRooms.length == 4){
						vm.selectAll['rooms'] = true; 
					}
				}
			}
        }, 1000);



		if(pageFrom == "dashboard" && $localStorage.preHotelId == 128) {
			vm.roomsRates = casitas_data.roomsData;
			vm.ratesData = casitas_data.ratePlansData;
			vm.channelsData = casitas_data.channel;
			vm.casitasRooms = [];
			vm.casitasRoomsIDs = [];
		}

		if($localStorage.preHotelId == 128) {
	       	rateRuleService.getRateRulesData($localStorage.preHotelId).then(function(response){
				if(response.success) {
					vm.roomsRates = response.data.roomsData;
					vm.ratesData = response.data.ratePlansData;
					vm.channelsData = response.data.channel;
					vm.casitasRooms = [];
					// angular.forEach(vm.roomsRates, function(value, key){
					 //      vm.casitasRooms.push(value.room_type_id);
					 //   	});
					 //   	console.log(vm.casitasRooms);
				 	vm.casitasRooms = [];
				   	vm.casitasRoomsIDs = [];
					// angular.forEach(vm.roomRates, function(val,index) {
					// 	console.log("val ===> ", val);
					// 	vm.casitasRooms.push(val.room_type_id);
					// 	console.log(vm.casitasRooms);
					// });
					// vm.casitasRoomsIDs = [];
				}
	        });
		} else if(typeof extraParams.update != 'undefined' && extraParams.update == 'rate'){
			if (RoomsRateChannel != undefined && RoomsRateChannel.parent != undefined) {
				vm.roomsRates = RoomsRateChannel != undefined && RoomsRateChannel.parent != undefined ? RoomsRateChannel['parent'] : [];
			} else if (RoomsRateChannel  != undefined) {
				for(var key in RoomsRateChannel){
				    if(key !== 'Boat'){
				        vm.roomsRates = vm.roomsRates.concat(RoomsRateChannel[key]);
				    }
				}
			}
			vm.ratesData = RateData.room;
			vm.channelsData = channelsData;
		} else {
			for(var key in RoomsRateChannel){
			    if(key !== 'Boat'){
			        vm.roomsRates = vm.roomsRates.concat(RoomsRateChannel[key]);
			    }
			}
			vm.roomsRates = RoomsRateChannel['Room'];
			vm.ratesData = RateData['Room'];
			vm.channelsData = channelsData['Room'];
		}

		// Code For Boat
		vm.userPermissions = $rootScope.userPermissions;
		if (vm.userPermissions.indexOf('boats') != -1) {
			vm.showRoomBoatsBulk = true;
			if(pageFrom == "dashboard"){
				vm.showRoomBoatsBulk = false;
			}
		}  
		// Code For Boat
		vm.currentDateValue = new Date();
		vm.ratebulk.seleRates.rate = [];
		vm.ratebulk.seleRates.channels = [];
		vm.ratebulk.seleRates.rooms = [];
		//Methods
		vm.closeDialog = closeDialog;
		vm.addSelectedDays= addSelectedDays;
		vm.checkRange= checkRange;
		vm.saveBulkPrice= saveBulkPrice;
		vm.addSelectedData= addSelectedData;
		vm.addSelectedDataRoom= addSelectedDataRoom;
		vm.showRooms = showRooms;
		vm.toggle = toggle;
		vm.selectall= selectall;
		vm.selectAll = [];
		vm.selectAll['rate'] = false;
		vm.selectAll['channels'] = false;
		vm.selectAll['rooms'] = false;
		vm.showLoader = false;
		function selectall(type, array, idname, roomData){
			if (vm.hotelID != 128 || type != 'rooms') {
				if(vm.ratebulk.seleRates[type].length==array.length){
					vm.ratebulk.seleRates[type] = [];
					vm.selectAll[type] = true;
				}else{
					vm.ratebulk.seleRates[type] = [];	
					for(var i=0; i<=array.length-1; i++){
						vm.ratebulk.seleRates[type].push(array[i][idname]);
						vm.selectAll[type] = false;
					}
				}
			} else {
				angular.forEach(roomData, function(val, key) {
					if(!vm.selectAll['rooms']) {
						if(vm.casitasRooms.indexOf(val) === -1) {
							vm.casitasRooms.push(val.room_type_id);
						}
						var roomIDs = val.room_type_refs_id.split(',');
						angular.forEach(roomIDs, function(value, key) {
							if(vm.ratebulk.seleRates.rooms.indexOf(value) === -1) {
								vm.ratebulk.seleRates.rooms.push(value);
							}
						});						
					} else {
						vm.casitasRooms.filter(function(value, index){ return vm.casitasRooms.indexOf(value) == index });
						var index = vm.casitasRooms.indexOf(val.room_type_id);
						vm.casitasRooms.splice(index,1);
						var roomIDs = val.room_type_refs_id.split(',');
						angular.forEach(roomIDs, function(value, key) {
							var roomInd = vm.ratebulk.seleRates.rooms.indexOf(value);
							vm.ratebulk.seleRates.rooms.splice(roomInd, 1);
						});
					}
					vm.ratebulk.seleRates.rooms = removeDuplicates(vm.ratebulk.seleRates.rooms);
					vm.casitasRooms = removeDuplicates(vm.casitasRooms);
				});
			}

			if (type == 'rate') {
				vm.checkIfDerivedRateSelected();
			}
		}
		// Select all rooms of same type
		function addSelectedDataRoom(type, room_ref_ids, outerRoomID, event){
			if(vm.casitasRooms.indexOf(outerRoomID) === -1) {
				if(vm.casitasRooms.indexOf(outerRoomID) === -1) {
					vm.casitasRooms.push(outerRoomID);
				}
				var roomIDs = room_ref_ids.split(',');
				angular.forEach(roomIDs, function(val, key) {
					if(vm.ratebulk.seleRates.rooms.indexOf(val) === -1) {
						vm.ratebulk.seleRates.rooms.push(val);
					}
				});
				if(vm.casitasRooms.length == 4){
					vm.selectAll['rooms'] = true;
				}
			} else {
				var ind = vm.casitasRooms.indexOf(outerRoomID);
				vm.casitasRooms.splice(ind,1);
				var roomIDs = room_ref_ids.split(',');
				angular.forEach(roomIDs, function(val, key) {
					var roomInd = vm.ratebulk.seleRates.rooms.indexOf(val);
					vm.ratebulk.seleRates.rooms.splice(roomInd, 1);
				});
				vm.selectAll['rooms'] = false;

			}
			vm.ratebulk.seleRates.rooms = removeDuplicates(vm.ratebulk.seleRates.rooms);
			vm.casitasRooms = removeDuplicates(vm.casitasRooms);
			event.stopPropagation();
		}

		vm.showDerivedRateSelMsg = '';
		function addSelectedData(type, id, array, roomRateID, event){
			if(!vm.ratebulk.seleRates[type]) vm.ratebulk.seleRates[type] = [];
			if(vm.ratebulk.seleRates[type].indexOf(id)===-1){
				vm.ratebulk.seleRates[type].push(id);
			} else {
				vm.ratebulk.seleRates[type].splice(vm.ratebulk.seleRates[type].indexOf(id), 1);
				if(vm.hotelID == 128) {
					if(vm.casitasRooms.indexOf(roomRateID) > -1) {
						var ind = vm.casitasRooms.indexOf(roomRateID);
						vm.casitasRooms.splice(ind,1);
						vm.selectAll['rooms'] = false;
					}
				}
			}
			if(vm.hotelID == 128 && type == 'rooms') {
				angular.forEach(array, function(val, index) {
					var arr = val.room_type_refs_id.split(",");
					var counter = 0;
					angular.forEach(vm.ratebulk.seleRates.rooms, function(value, index) {
						if(arr.indexOf(value) !== -1) {
							counter++;
						}
					});
					if(parseInt(counter) == parseInt(arr.length)) {
						vm.casitasRooms.push(val.room_type_id);
					}
				});				
			} else {
				if(vm.ratebulk.seleRates[type].length==array.length) {
					vm.selectAll[type] = true;
				} else {
					vm.selectAll[type] = false;
				}
			}

			if (type == 'rate' && vm.fixedRate.length > 0 && vm.derivedRates.length > 0) {
				vm.checkIfDerivedRateSelected();
			}
			event.stopPropagation();
		}

		/**
		* Comment: Check if derived and fixed rate both are selected
		*/
		vm.checkIfDerivedRateSelected =  function() {
			if (vm.fixedRate.length > 0 && vm.derivedRates.length > 0) {
				var ratesArray = vm.ratebulk.seleRates['rate'];
				var fixedRateId = vm.fixedRate[0].rate_plan_id;

				var fixedRateSelected = ratesArray.indexOf(fixedRateId) > -1 ? true : false;
				var otherRates = '';
				if (fixedRateSelected) {
					angular.forEach(vm.derivedRates, function(value, key) {
						if (ratesArray.indexOf(value.rate_plan_id) > -1) {
							otherRates += value.rate_plan_name+', ';
						}
					});

					if (otherRates != '') {
						var lastChar = otherRates.slice(-2);
						if (lastChar == ', ') {
						    otherRates = otherRates.slice(0, -2);
						}
					}
				}

				if (otherRates != '') {
					vm.showDerivedRateSelMsg = 'You are updating the fixed rate ('+vm.fixedRate[0].rate_plan_name+') as well as the rates which are derived from it ('+ otherRates +')';
				} else {
					vm.showDerivedRateSelMsg = '';
				}
			}
		}

		function addSelectedDays(dayWeek){
			if(vm.ratebulk.selectedDays.indexOf(dayWeek) === -1){//adding a day
				vm.ratebulk.selectedDays.push(dayWeek);
			}else{//removing a day
				vm.ratebulk.selectedDays.splice(vm.ratebulk.selectedDays.indexOf(dayWeek), 1);
			}
		}
		vm.queryRunning = false;
		function saveBulkPrice(){
			vm.queryRunning = true;
			vm.showLoader = true;
			
			if (vm.optionsSel > 1 && typeof extraParams.update == 'undefined') {
				vm.selectAll['rate'] = false;
				vm.selectall('rate',vm.ratesData,'rate_plan_id');
			}
			vm.ratebulk.seleRates['room_sub_hotel_id'] = Rooms_sub_hotel_ids;
			var converted = Object.assign({}, vm.ratebulk.seleRates);
			var data = {
				seleRates 	 	: 	converted,
				selectedDays 	: 	vm.ratebulk.selectedDays,
				hotel_id 	 	: 	$localStorage.hotels[$localStorage.selectedHotel]['hotel_id'],
				from_range 	 	: 	new Date(moment(vm.from_range).format('YYYY-MM-DD')),
				to_range	 	: 	new Date(moment(vm.to_range).format('YYYY-MM-DD')),
				pageView	 	: 	vm.optionsSel,
				selectRate   	: 	vm.selectRate,
				rate_plan_adjust_indicator : vm.rate_plan_adjust_indicator,
				rate_plan_percentage       : vm.rate_plan_percentage
			};
			if(vm.optionsSel==1)
				data.room_type_price = vm.ratebulk.room_type_price;
			else if(vm.optionsSel==2)
				data.is_stop_sell = vm.ratebulk.is_stop_sell;
			else if(vm.optionsSel==3)
				data.is_cta = vm.ratebulk.is_cta;
			else if(vm.optionsSel==4)
				data.is_ctd = vm.ratebulk.is_ctd;
			else if(vm.optionsSel==5)
				data.min_stay = vm.ratebulk.min_stay;
			else if(vm.optionsSel==6)
				data.max_stay = vm.ratebulk.max_stay;
			
			data.type = vm.type;
			if (pageFrom == 'dashboard') {
				data.seleRates.rate = vm.ratesData != undefined ? vm.ratesData : [];
				data.page = pageFrom != undefined ? pageFrom : '';
				dashboardGraphService.modifyBulkRateRule(vm.previousRecords).then(function(response){
					if (response.status) {
						data.oldValues = response.oldValues;
						vm.updateBulkChanges(data);
					} else {
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
						vm.queryRunning = false;
					}
				});
			} else {
				vm.updateBulkChanges(data);
			}
		}


		vm.updateBulkChanges = function(data) {
			data.selected_sub_hotel_id = extraParams.selected_sub_hotel;

			rateRuleService.setBulkRateRule(data).then(function(response){
				vm.showLoader = false;
				if(response.success){
					if(response.message){
						toastMessage.showSimpleToast(response.message,'success-toast');
					} else {
						vm.closeDialog();
					}
					if (pageFrom == 'dashboard') {
						$rootScope.$broadcast('updateMLS');
					} else {
						// $rootScope.$broadcast('update_full_ganttchart');
						$rootScope.$broadcast('update_custome_ratecalendar');
					}
				} else if (response.errorMsg){
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				} else{
					toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
				}
				vm.queryRunning = false;
			});
		};

		function checkRange(){
			vm.rateMaxError = false;
			if(vm.ratebulk.room_type_price>1000){
				vm.rateMaxError = true;
			}
		}
		function closeDialog()
		{
			$mdDialog.hide();
		}
		
		function showRooms(){
			if(vm.type == 'rooms'){
				vm.currentTab = 'room';
				vm.roomsRates = RoomsRateChannel['Room'];
				vm.ratesData = RateData['Room'];
				vm.channelsData = channelsData['Room'];
			} else {
				vm.type = 'boats';
				vm.currentTab = 'boat';
				vm.roomsRates = RoomsRateChannel['Boat'];
				vm.ratesData = RateData['Boat'];
				vm.channelsData = channelsData['Boat'];
			}
			vm.getDerivedFixedRates();
			vm.showDerivedRateSelMsg = '';
			vm.ratebulk.seleRates['rate'] = [];
			vm.selectAll['rate'] = [];
		}

		function removeDuplicates(arr){
		    var unique_array = []
		    for(var i = 0;i < arr.length; i++){
		        if(unique_array.indexOf(arr[i]) == -1){
		            unique_array.push(arr[i])
		        }
		    }
		    return unique_array
		}

		function toggle(id) {
			var innerID = 'innerroom'+id;
			var ele = angular.element(document.getElementById(innerID));
			ele.slideToggle();
			var outerID = 'outerroom'+id;
			var outerEle = angular.element(document.getElementById(outerID));
			outerEle.toggleClass('show-md-icon');
		}

		setTimeout(function() {
           vm.autoFillOff = false;
       	}, 1500); 

       	vm.getDerivedFixedRates = function() {
       		rateRuleService.getDerivedFixedRates(vm.currentTab).then(function(response){
       			vm.fixedRate = response.fixedRate != undefined ? response.fixedRate : [];
				vm.derivedRates = response.derivedRates != undefined ? response.derivedRates : [];
			});
       	};
       	vm.getDerivedFixedRates();
       	if (extraParams.type !== undefined) {
	       	vm.type = (extraParams.type == 'boat')?'boats':'rooms';
	       	vm.showRooms();
       	}
	}
})();

(function () {
  "use strict";

  angular
    .module("app.rateCalendarLogs", [
      // 3rd Party Dependencies
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state("app.rateCalendarLogs", {
      url: "/rate-calendar-logs",
      title: "Rate Calendar Logs",
      views: {
        "content@app": {
          templateUrl: "app/main/apps/rateCalendarLogs/rateCalendarLogs.html",
          controller: "rateCalendarLogsController as vm",
        },
      },
      resolve: {
        rateRoomChannelData: function (rateCalendarLogsService) {
          return rateCalendarLogsService.getRateRoomChannelDetails();
        },
      },
      permission: "rate_calendar_logs",
    });

    // Translation
    $translatePartialLoaderProvider.addPart("app/main/apps/rateCalendarLogs");
  }
})();

(function () {
  "use strict";

  angular
    .module("app.rateCalendarLogs")
    .controller(
      "RateCalendarLogsDialogController",
      RateCalendarLogsDialogController
    );

  /** @ngInject */
  function RateCalendarLogsDialogController($mdDialog, logDetail) {
    var vm = this;

    vm.logDetails = logDetail;
    vm.closeDialog = function () {
      $mdDialog.hide();
    };
    vm.hasScroll = function() {
      var tbody = document.querySelector('.simple-log tbody');
      return tbody && tbody.scrollHeight > tbody.clientHeight;
    };
  }
})();

(function (){
	'use strict';
	
	angular.module('app.promotions',
				[]
	).config(config);
	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider){
		$stateProvider.state('app.promotions', {
            url    : '/promotions',
            title : 'Promotions',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/promotions/promotions.html',
                    controller : 'PromotionsController as vm'
                }
            },
            resolve  : {
				Types: function (promotionsService){
					return promotionsService.getPromotionTypes();
				}
			},
			permission: 'promotions'
        }),
		$stateProvider.state('app.promotion_add', {
            url    : '/promotions/add',
            title : 'Promotions',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/promotions/promotion/promotion.html',
                    controller : 'PromotionController as vm'
                }
            },
            resolve  : {
				Types: function (promotionsService){
					return promotionsService.getPromotionTypes();
				},
				RatePlans: function (promotionsService,$localStorage){
					return [];
				},
				/*RatePlans: function (promotionsService,$localStorage){
					return promotionsService.getRatePlans({hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id});
				},*/
				Promotions: function (promotionsService,$localStorage){
					return promotionsService.getPromotion({promoId: 0});
				},
			},
			permission: 'add_promotion'
        }).state('app.promotion_edit', {
            url    : '/promotions/:edit_promotion_id',
            title : 'Promotions',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/promotions/promotion/promotion.html',
                    controller : 'PromotionController as vm'
                }
            },
            resolve  : {
				Types: function (promotionsService){
					return promotionsService.getPromotionTypes();
				},
				RatePlans: function (promotionsService,$localStorage){
					return [];
				},
				Promotions: function (promotionsService, $stateParams) {
					return promotionsService.getPromotion({promoId: $stateParams.edit_promotion_id});
				},
			},
			permission: 'update_promotion'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/promotions');
	}
})();

(function ()
    {
		'use strict';

		angular
			.module('app.promotions')
			.controller('PromotionController', PromotionController)
			.filter('toDate',function() {
				return function(input,fromDate) {
					if( typeof input != 'undefined' && moment(input).isValid()) {
						return moment(input).format('MM/DD/YYYY');
					} 
					return moment(fromDate).format('MM/DD/YYYY');
					//return '';
				}
			});

		/** @ngInject */
		function PromotionController($state, $scope, $http, $localStorage, EnvironmentConfig, Types, RatePlans, promotionsService, toastMessage, Promotions, $location, $timeout, $window)
		{
			var vm = this;
			vm.types = Types.types;
			vm.ratePlans = RatePlans.rate_plans;
			
			vm.promotions = Promotions.promotions;
			vm.isOldPromo = Promotions.oldPromo;
			vm.canUpdate = false;
			vm.isAdd = false;
			
			vm.weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
			vm.days = {};
			for (var i=1; i<= 20; i++) {
				vm.days[i] = i;
			}
			vm.selectedRatePlans = [];
			vm.selectedRoomTypes = [];
			//~ vm.selectedChannels = {};
			vm.selectedRoomRates = {};
			vm.ratePlans = RatePlans.rate_plans;
			vm.roomTypes = [];
			//~ vm.channels = [];
			vm.actionType = 'edit';
			vm.uniqueError = false;
			vm.autoFillOff = true;
			vm.promotionType = promotionType;		  
			vm.customerType = customerType;		  
			vm.singleUse = singleUse;		  
			vm.rateplanChanged = rateplanChanged;		  
			vm.roomtypeChanged = roomtypeChanged;		  
			vm.gotoPromotions = gotoPromotions;		  
			vm.savePromotion = savePromotion;
			vm.saveProductFormat = saveProductFormat;
			vm.hasInvalidProductDiscounts = function(){
				if(!vm.productsList || vm.productsList.length === 0) return false;
				for(var i=0;i<vm.productsList.length;i++){
					var group = vm.productsList[i];
					if(!group.list) continue;
					for(var j=0;j<group.list.length;j++){
						var item = group.list[j];
						if(item && item.discount){
							if(item.discount._percentInvalid || item.discount._amountInvalid) return true;
						}
					}
				}
				return false;
			};
			vm.toggle = toggle;		  
			vm.toggleDays = toggleDays;		  
			vm.toggleChannels = toggleChannels;	
			vm.checkLastMin = checkLastMin;	
			vm.checkHours = checkHours;	
			vm.checkdiscount = checkdiscount;
			vm.checkUniquePromoCode = checkUniquePromoCode;
			vm.min_stay_changed = min_stay_changed;
			vm.toggleCustomMode = toggleCustomMode;
			vm.saveCustomDayValues = saveCustomDayValues;
			
			vm.productsList = Promotions != undefined && Promotions.productsList != undefined ? Promotions.productsList : [];
			vm.weekList = [
        { key: "Mon", label: "Monday" },
        { key: "Tue", label: "Tuesday" },
        { key: "Wed", label: "Wednesday" },
        { key: "Thu", label: "Thursday" },
        { key: "Fri", label: "Friday" },
        { key: "Sat", label: "Saturday" },
        { key: "Sun", label: "Sunday" },
      ];
			angular.forEach(vm.productsList, function(group) {
				if (!group.list) return;

				angular.forEach(group.list, function(item) {

					if (!item.discount) item.discount = {};

					if (!item.discount.value || typeof item.discount.value !== 'object') {
						item.discount.value = { 
							Mon: null, Tue: null, Wed: null, Thu: null, Fri: null, Sat: null, Sun: null 
						};
					}

					if (typeof item.discount.customMode === 'undefined') {
						item.discount.customMode = false;
					}

					if (typeof item.discount.singleValue === 'undefined') {
						item.discount.singleValue = item.discount.value.Mon || null;
					}
				});
			});
			vm.showErrorBorder = false;

			function parseLocalDate(dateValue) {
				if (!dateValue || dateValue === 'undefined') {
					return dateValue;
				}
				if (dateValue instanceof Date && !isNaN(dateValue.getTime())) {
					return new Date(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate());
				}
				var localDate = moment(dateValue, 'YYYY-MM-DD', true);
				if (!localDate.isValid()) {
					return dateValue;
				}
				return new Date(localDate.year(), localDate.month(), localDate.date());
			}

			function formatLocalDate(dateValue) {
				if (!dateValue || dateValue === 'undefined') {
					return dateValue;
				}
				return moment(dateValue).format('YYYY-MM-DD');
			}

			var edit_promotion_id = $state.params.edit_promotion_id;
			if(edit_promotion_id != "undefined" && edit_promotion_id > 0){
				init();

				/**
				 * Initialize
				 */
				function init()
				{
					
					var found = false;

					for ( var i = 0; i < vm.promotions.length; i++ )
					{
						if ( vm.promotions[i].promotion_id == parseInt(edit_promotion_id) )
						{
							vm.promotions[i].promotion_discount = parseFloat(vm.promotions[i].promotion_discount);
							vm.promotion = vm.promotions[i];
							if(parseInt(vm.promotion.promotion_last_min_hours) > 0){
								vm.promotion.promotion_last_min_hours = parseInt(vm.promotion.promotion_last_min_hours);
								vm.lastmindeal = 2;
							}
							if(parseInt(vm.promotion.promotion_last_min_days) > 0){
								vm.promotion.promotion_last_min_days = parseInt(vm.promotion.promotion_last_min_days);
								vm.lastmindeal = 1;
							}
							if(parseFloat(vm.promotion.promotion_discount) > 0){
								vm.promotion.promotion_discount = parseFloat(vm.promotion.promotion_discount);
							}
							
							vm.promotion.promotion_days_discount = vm.promotion.promotion_days_discount.split(',');
							vm.title = vm.promotion.promotion_name;
							vm.promotion.promotion_checkin_date = parseLocalDate(vm.promotion.promotion_checkin_date);
							vm.promotion.promotion_checkout_date = parseLocalDate(vm.promotion.promotion_checkout_date);
							vm.promotion.booking_created_from = parseLocalDate(vm.promotion.booking_created_from);
							vm.promotion.booking_created_to = parseLocalDate(vm.promotion.booking_created_to);
							
							/*promotionsService.getPromotionAssociatedRates({promotion_id:edit_promotion_id}).then(function(response){
								vm.rates = response.rates;
								vm.selectedRatePlans = response.selectedRatePlans;
								vm.selectedRoomTypes = response.selectedRoomTypes;
								//~ vm.selectedChannels = response.selectedChannels;
								roomtypeChanged();
								rateplanChanged();
							});*/
							found = true;
							setTimeout(function(){
								vm.canUpdate = true;
							},1500);
							break;
						}
					}
					if(!found){
						toastMessage.showSimpleToast('Promotion not found or has been deleted.','error-toast');
						$state.go('app.promotions');
					}
				}
			}else if(typeof edit_promotion_id == "undefined"){
				vm.isAdd = true;
				vm.template = {};
				vm.actionType = 'add';
				vm.title = 'New Promotion';
				vm.promotion = {};
				vm.lastmindeal = 1;
				vm.promotion['promotion_discount_type'] = 'percent';
				vm.promotion['promotion_discount'] = 0;
				vm.promotion['promotion_min_stay'] = 0;
				vm.promotion['promotion_status'] = 1;
				vm.promotion['promotion_type_id'] = 1;
				vm.promotion['promotion_single_use'] = 0;
				vm.promotion['promotion_code_required'] = 1;
				vm.promotion['promotion_discount_type'] = 'percent';
				vm.promotion['promotion_customer_type'] = 'all';
				vm.promotion['promotion_days_discount'] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
			}else{
				$state.go('app.promotions');
			}
		  	
			function gotoPromotions(){
				$state.go('app.promotions');
			}
			function checkLastMin(value){
				if(value == 1)
					vm.promotion.promotion_last_min_hours = null;
				else
					vm.promotion.promotion_last_min_days = null;
			}
			function checkHours(value){
				if(value > 24)
					vm.promotion.promotion_last_min_hours = 24;
			}
			function checkdiscount(){
				if(vm.promotion.promotion_discount_type == 'percent' && parseFloat(vm.promotion.promotion_discount) > 100){
					vm.promotion.promotion_discount = 100;
				}else if(vm.promotion.promotion_discount_type == 'percent' && parseFloat(vm.promotion.promotion_discount) < 0){
					vm.promotion.promotion_discount = 0;
				}
			}
			function checkUniquePromoCode(){
				if(vm.promotion.promotion_code != "" && vm.promotion.promotion_code != null){
					if(vm.promotion.hasOwnProperty('promotion_id') && vm.promotion.promotion_id > 0){
						var promotion_id = vm.promotion.promotion_id;
					}else{
						var promotion_id = "";
					}
					promotionsService.checkUniquePromoCode({'promotion_code':vm.promotion.promotion_code,'hotel_id':$localStorage.hotels[$localStorage.selectedHotel].hotel_id,'promotion_id':promotion_id}).then(function(response){
						if(response.exists)
							vm.uniqueError = true;
						else
							vm.uniqueError = false;
					});	
				}
			}
			function toggle(item, list, store){
				if(store == 'index')
					var idx = list.indexOf(item);
				else
					var idx = list.indexOf(item[store]);
				if (idx > -1) {
				  list.splice(idx, 1);
				}
				else {
					if(store == 'index')
						list.push(idx);
					else{
						list.push(item[store]);
						//~ if(store == 'room_type_id'){
							//~ var channelIndex = item[store];
							//~ vm.selectedChannels[channelIndex] = [];
						//~ }
					}
				}
			}
			function toggleDays(item, list){
				var idx = list.indexOf(item);
				if (idx > -1) {
				  list.splice(idx, 1);
				}
				else {
					list.push(item);
				}
			}
			function toggleChannels(item, list, roomTypeId){
				var idx = list[roomTypeId].indexOf(item.channel_id);
				if (idx > -1) {
				  list[roomTypeId].splice(idx, 1);
				}
				else {
					list[roomTypeId].push(item.channel_id);
				}
			}
			function rateplanChanged(){
				if(vm.selectedRatePlans.length > 0){
					promotionsService.getRoomTypes({'rate_plan_id':vm.selectedRatePlans,'hotel_id':$localStorage.hotels[$localStorage.selectedHotel].hotel_id }).then(function(response){
						vm.roomTypes = response.rooms;
						for (var i=0; i< vm.selectedRoomTypes.length; i++){
							var exist = false;
							var room_delete_index = vm.selectedRoomTypes[i];
							Object.keys(vm.roomTypes).forEach(function(key) {
							  if (vm.roomTypes[key].room_type_id == vm.selectedRoomTypes[i]) {
								exist = true;
							  }
							});
							if(!exist){
								vm.selectedRoomTypes.splice(i,1);
								//~ vm.selectedChannels[room_delete_index] = [];
							}
						}
						vm.selectedRoomRates = response.rooms;
					});
				}else{
					vm.roomTypes = [];
					//~ vm.channels = [];
					vm.selectedRoomRates = {};
					vm.selectedRoomTypes = [];
					//~ vm.selectedChannels = {};
				}
			}
			
			function min_stay_changed(){
				vm.roomTypes = [];
				vm.selectedRatePlans = [];
				vm.selectedRoomRates = {};
				vm.selectedRoomTypes = [];
			}
			
			function roomtypeChanged(){
				//~ if(vm.selectedRoomTypes.length > 0){
					//~ promotionsService.getChannels({'rate_plan_id':vm.selectedRatePlans,'room_type_id':vm.selectedRoomTypes,'hotel_id':$localStorage.hotels[$localStorage.selectedHotel].hotel_id }).then(function(response){
						//~ vm.channels = response.channels;
					//~ });
				//~ }else{
					//~ vm.channels = [];
				//~ }
			}

			/**
			 * Validate and normalize product discount values.
			 * - If type is 'percent', clamp value to [0,100].
			 * - Parse numeric input and normalize to at most two decimals.
			 */
			function saveProductFormat(list, parent){
				// if (list.discount.customMode) {
				// 	return;
				// }
				initDiscountObject(list);

				let raw = list.discount.singleValue;

				if (raw === '' || raw === null || raw === undefined) {
					// Clear all days
					['Mon','Tue','Wed','Thu','Fri','Sat','Sun'].forEach(d => {
						list.discount.value[d] = null;
					});
					return;
				}

				let num = parseFloat(raw);

				if (isNaN(num)) {
					['Mon','Tue','Wed','Thu','Fri','Sat','Sun'].forEach(d => {
						list.discount.value[d] = null;
					});
					list.discount.singleValue = '';
					return;
				}

				if (list.discount.type === 'percent') {
					if (num < 0) num = 0;
					if (num > 100) {
						num = 100;
						list.discount.singleValue = 100;
					}
				}

				num = Math.round(num * 100) / 100;

				['Mon','Tue','Wed','Thu','Fri','Sat','Sun'].forEach(d => {
					list.discount.value[d] = num;
				});

				list.discount._percentInvalid = false;
				list.discount._amountInvalid = false;
			}
			vm.myDate = new Date();

			vm.minDate = new Date(
				vm.myDate.getFullYear(),
				vm.myDate.getMonth(),
				vm.myDate.getDate()
			);

			vm.minBookingDate = new Date(
				vm.myDate.getFullYear(),
				vm.myDate.getMonth(),
				vm.myDate.getDate()
			);
			vm.changeMinDate = function() {
				if (vm.promotion.promotion_checkin_date != undefined) {
					vm.myDate1 = new Date(vm.promotion.promotion_checkin_date);
					vm.minDate1 = new Date(
						vm.myDate1.getFullYear(),
						vm.myDate1.getMonth(),
						vm.myDate1.getDate()
					);
					if(moment(vm.promotion.promotion_checkout_date).isValid() && moment(vm.promotion.promotion_checkout_date).isBefore(vm.promotion.promotion_checkin_date)) {
						vm.promotion.promotion_checkout_date = vm.minDate1;
					}
				}
			};
			vm.changeMinDate();

			vm.changeBookingCreatedMinDate = function() {
				if (vm.promotion.booking_created_from != undefined) {
					vm.bookingDate1 = new Date(vm.promotion.booking_created_from);
					vm.minBookingDate = new Date(
						vm.bookingDate1.getFullYear(),
						vm.bookingDate1.getMonth(),
						vm.bookingDate1.getDate()
					);
					if(moment(vm.promotion.booking_created_to).isValid() && moment(vm.promotion.booking_created_to).isBefore(vm.promotion.booking_created_from)) {
						vm.promotion.booking_created_to = vm.minBookingDate;
					}
				}
			};
			vm.changeBookingCreatedMinDate();
			
			function promotionType(promotion_type_id){
				vm.promotion.promotion_type_id = promotion_type_id;
			}
			function customerType(customer_type){
				vm.promotion.promotion_customer_type = customer_type;
			}
			function singleUse(promotion_single_use){
				vm.promotion.promotion_single_use = promotion_single_use;
			}
			function savePromotion(){
				if(vm.hasInvalidProductDiscounts()){
					$location.hash('appliedProducts');
					vm.showErrorBorder = true;
					$timeout(function(){ $window.location.hash=''; }, 1000);
					toastMessage.showSimpleToast('Please fix invalid product discounts before saving.','error-toast');
					return false;
				}
				if(vm.promotion.hasOwnProperty('promotion_code_required') && vm.promotion.promotion_code_required == 0){
					delete vm.promotion.promotion_code;
					vm.uniqueError = false;
				}
				if(vm.uniqueError){
					toastMessage.showSimpleToast('Promotion Code already exists.','error-toast');
					return false;
				}
				if(vm.promotion.hasOwnProperty('promotion_checkin_date') && vm.promotion.promotion_checkin_date != 'undefined'){
					vm.promotion.promotion_checkin_date = formatLocalDate(vm.promotion.promotion_checkin_date);
				}
				if(vm.promotion.hasOwnProperty('promotion_checkout_date') && vm.promotion.promotion_checkout_date != 'undefined'){
					vm.promotion.promotion_checkout_date = formatLocalDate(vm.promotion.promotion_checkout_date);
				}
				if(vm.promotion.hasOwnProperty('booking_created_from') && vm.promotion.booking_created_from != 'undefined'){
					vm.promotion.booking_created_from = formatLocalDate(vm.promotion.booking_created_from);
				}
				if(vm.promotion.hasOwnProperty('booking_created_to') && vm.promotion.booking_created_to != 'undefined'){
					vm.promotion.booking_created_to = formatLocalDate(vm.promotion.booking_created_to);
				}
				vm.promotion['hotel_id'] = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
				var selected_room = {};
				/*angular.forEach(vm.selectedRoomTypes, function(room_value, room_key) {
					angular.forEach(vm.selectedRoomRates, function(value, key) {
						if(room_value == value.room_type_id){
							var res = value.rate_plan_id.split(",");
							selected_room[room_value] = {};
							for (var i = 0; i < res.length ; i++){
								selected_room[room_value][i] = res[i];
							}
						}
					});
				});*/
				/*if (vm.productsList.length > 0) {
					var showErrorMsg = true;
					angular.forEach(vm.productsList, function(value, key) {
						if (value.checked) {
							showErrorMsg = false;
						}
					});
					
					if (showErrorMsg) {
						$location.hash('appliedProducts');
						vm.showErrorBorder = true;
						$timeout(function(){
							$window.location.hash='';
						},1000);
						toastMessage.showSimpleToast('Please select at least one product on which you want to apply the promotion.','error-toast');
						return false;
					}
				}*/
				vm.promotion.productsList = vm.productsList;
				vm.isloading = true;
				//~ promotionsService.savePromotion({'promotion':vm.promotion,'selectedChannels':vm.selectedChannels,'selectedRoomTypes':selected_room}).then(function(response){
				promotionsService.savePromotion({'promotion':vm.promotion,'selectedRoomTypes':selected_room}).then(function(response){
					if(response.success ){
						gotoPromotions();
					}else{
						toastMessage.showSimpleToast('There is some error. Please check','error-toast');
					}
				});
				return;
			}

			setTimeout(function() {
	           vm.autoFillOff = false;
	       	}, 1500); 

			/**
			* @param: Object value
			* @param: Integer key
			* Comment: Expand collapse the class
			*/
	       	vm.openProductsList = function(value, key) {
	       		if (value.list != undefined && value.list.length > 0) {
	       			vm.productsList[key].openClass = !value.openClass;
	       		}
	       	};

	       	/**
			* @param: Object value
			* @param: Integer key
			* @param: Event event
			* Comment: check or uncheck the variables
			*/
	       	vm.listClicked = function(value, key, event) {
	       		event.stopPropagation();
	       		vm.productsList[key].checked = !value.checked;
	       		vm.showErrorBorder = false;
	       	};

	       	/**
			* @param: Integer parentIndex
			* @param: Integer key
			* @param: Object value
			* @param: Event event
			* Comment: check or uncheck the value of parent index when child index is changed
			*/
	       	vm.changeSingleProduct = function(parentIndex, childIndex, value, event) {
	       		event.stopPropagation();
	       		vm.productsList[parentIndex].list[childIndex].checked = !value.checked;
	       		var parentLength = vm.productsList[parentIndex].list.length;
	       		var checkParentChecked = false;
	       		angular.forEach(vm.productsList[parentIndex].list, function(val, listKey) {
       				if (val.checked) {
       					checkParentChecked = true;
       				}
       			});
       			vm.productsList[parentIndex].checked = checkParentChecked;

       			if (vm.productsList[parentIndex].value != undefined && (vm.productsList[parentIndex].value == 'rooms' || vm.productsList[parentIndex].value == 'reservation')) {
	       			angular.forEach(vm.productsList, function(val, key) {
	       				if (val.value == 'room_related_products') {
	       					vm.productsList[key].checked = checkParentChecked;
	       				}
	       			});
	       		}
	       		vm.showErrorBorder = false;
	       	};
      }

	function initDiscountObject(item) {
		if (!item.discount) item.discount = {};
		if (!item.discount.value || typeof item.discount.value !== 'object') {
			item.discount.value = { Mon: null, Tue: null, Wed: null, Thu: null, Fri: null, Sat: null, Sun: null };
		}
		if (item.discount.customMode === undefined) {
			item.discount.customMode = false;
		}
	}

	function toggleCustomMode(list) {
		if (!list.discount) list.discount = {};
		list.discount.customMode = !list.discount.customMode;

		// going to custom mode — fill table with existing single value
		if (list.discount.customMode) {
			let seed = parseFloat(list.discount.singleValue);
			if (!isNaN(seed)) {
				seed = Math.round(seed * 100) / 100;
				['Mon','Tue','Wed','Thu','Fri','Sat','Sun'].forEach(d => {
					list.discount.value[d] = seed;
				});
			}
		} 
		else {
			// going back to single mode
			list.discount.singleValue = list.discount.value.Mon || null;
		}
	};

	function saveCustomDayValues(list, key){
		initDiscountObject(list);

		list.discount._customInvalid = false;

		let v = list.discount.value[key];

		if (v === '' || v === null || v === undefined) v = null;

		let num = parseFloat(v);

		if (isNaN(num)) {
			list.discount.value[key] = '';
			return;
		}

		if (list.discount.type === 'percent') {
			if (num < 0) num = 0;
			if (num > 100) num = 100;
		}

		list.discount.value[key] = Math.round(num * 100) / 100;
	}
})();

    (function() {
        'use strict';

        angular
            .module('app.contacts')
            .controller('rolesEditPermissionController', rolesEditPermissionController);

        /** @ngInject */
        function rolesEditPermissionController($scope, $mdSidenav, rolePermissionModule, $localStorage, $stateParams, $filter, roleService, toastMessage, $state, $timeout) {
            

            var vm = this;
            vm.roleId = $stateParams.id;
            vm.hotel_id = $stateParams.hotel_id;
            $timeout(function() {
                vm.pageLoaded = true;
            }, 2000);
            vm.itemDisplayed = rolePermissionModule.listData;
            vm.hotels = rolePermissionModule.hotels;
            vm.Allhotels = rolePermissionModule.organizations;
            vm.actionStatus = "edit";
            vm.roleName = rolePermissionModule.role_name;
            vm.toggleSelectParentModule = toggleSelectParentModule;
            vm.toggleSelectModule = toggleSelectModule;
            vm.selectAllModules = selectAllModules;
            vm.selectModules = selectModules;
            vm.checkUnique = checkUnique;
            vm.getModule = getModule;
            vm.goToRoles = goToRoles;
            vm.saveHotel = saveHotel;
            vm.AddForm = false;
            vm.showAdd = true;
            vm.autoFillOff = true;
            vm.isloading = false;


            /*
            if role does not exist
            */
            if (rolePermissionModule.role_name == undefined) {
                $state.go('app.roles')
            }

            function checkUnique() {

                if (vm.roleName.length > 1) {
                    vm.uniqueName = false;
                    var data = {
                        'name': vm.roleName,
                        'role_id': $stateParams.id
                    };
                    roleService.checkUniqueRoleName(data).then(function(response) {
                        if (response.success == true) {
                            vm.showAdd = true;
                            vm.uniqueName = true;
                        } else {
                            vm.showAdd = false;
                            vm.uniqueName = false;
                        }
                    });
                } else {
                    vm.showAdd = true;
                }
            }

            /**
             * Save selected modules
             */

            function toggleSelectParentModule(event, parentIndex, subParentIndex, index, location) {
                if (location == 'file') {
                    var status = (vm.itemDisplayed[parentIndex].subs[subParentIndex].subs[index].selected == true) ? false : true;
                    vm.itemDisplayed[parentIndex].subs[subParentIndex].subs[index].selected = status;
                } else {
                    var status = vm.itemDisplayed[parentIndex].subs[subParentIndex].subs[index].selected;
                }
                
                var selectedSubs = 0;
                for (var i = 0; i < vm.itemDisplayed[parentIndex].subs[subParentIndex].subs.length; i++) {
                    if (vm.itemDisplayed[parentIndex].subs[subParentIndex].subs[i].selected == true) {
                        selectedSubs++;
                    }
                }
                /****** to make node selected if any of its child is selected start ****/
                
                if(selectedSubs > 0) {
                    vm.itemDisplayed[parentIndex].subs[subParentIndex].selected = true;
                } else {
                    vm.itemDisplayed[parentIndex].subs[subParentIndex].selected = false;
                }
                /****** to make node selected if any of its child is selected end ****/

                /*if (vm.itemDisplayed[parentIndex].subs[subParentIndex].subs.length == selectedSubs) {
                    vm.itemDisplayed[parentIndex].subs[subParentIndex].selected = true;
                } else {
                    vm.itemDisplayed[parentIndex].subs[subParentIndex].selected = false;
                }*/

                selectModules(parentIndex, index, event, 'controller');
                if (location != 'lastcontroller') {
                    var child_length = vm.itemDisplayed[parentIndex].subs[subParentIndex].subs[index].subs.length;
                    if (child_length > 0) {
                        for (var i = 0; i < child_length; i++) {
                            vm.itemDisplayed[parentIndex].subs[subParentIndex].subs[index].subs[i].selected = status;
                        }
                    }
                }
                if (event) {
                    event.stopPropagation();
                }
                vm.showAdd = false;
            }

            function toggleSelectModule(event, lastindex, secLastIndex, thirlastIndex, topLevelIndex) {
                var status = (vm.itemDisplayed[topLevelIndex].subs[thirlastIndex].subs[secLastIndex].subs[lastindex].selected == true) ? false : true;
                vm.itemDisplayed[topLevelIndex].subs[thirlastIndex].subs[secLastIndex].subs[lastindex].selected = status;
                var selectedSubs = 0;
                for (var i = 0; i < vm.itemDisplayed[topLevelIndex].subs[thirlastIndex].subs[secLastIndex].subs.length; i++) {
                    if (vm.itemDisplayed[topLevelIndex].subs[thirlastIndex].subs[secLastIndex].subs[i].selected == true) {
                        selectedSubs++;
                    }
                }
                if(selectedSubs > 0) {
                    vm.itemDisplayed[topLevelIndex].subs[thirlastIndex].subs[secLastIndex].selected = true;
                } else {
                    vm.itemDisplayed[topLevelIndex].subs[thirlastIndex].subs[secLastIndex].selected = false;
                }
                /*if (vm.itemDisplayed[topLevelIndex].subs[thirlastIndex].subs[secLastIndex].subs.length == selectedSubs) {
                    vm.itemDisplayed[topLevelIndex].subs[thirlastIndex].subs[secLastIndex].selected = true;
                } else {
                    vm.itemDisplayed[topLevelIndex].subs[thirlastIndex].subs[secLastIndex].selected = false;
                }*/
                toggleSelectParentModule(event, topLevelIndex, thirlastIndex, secLastIndex, 'lastcontroller')
                if (event) {
                    event.stopPropagation();
                }
                vm.showAdd = false;
            }
            /**
             * Sselect modules
             */
            function selectModules(parentIndex, index, event, location) {
                if (location == 'file') {
                    var status = (vm.itemDisplayed[parentIndex].subs[index].selected == true) ? false : true;
                    vm.itemDisplayed[parentIndex].subs[index].selected = status;
                }
                /***if parent have only one child and that child doesn't have any child***/
                var selectedSubs = 0;
                for (var i = 0; i < vm.itemDisplayed[parentIndex].subs.length; i++) {
                    if (vm.itemDisplayed[parentIndex].subs[i].selected == true) {
                        selectedSubs++;
                    }
                }
                if(selectedSubs > 0) {
                    vm.itemDisplayed[parentIndex].selected = true;
                } else {
                    vm.itemDisplayed[parentIndex].selected = false;
                }

                /*if (vm.itemDisplayed[parentIndex].subs.length == selectedSubs) {
                    vm.itemDisplayed[parentIndex].selected = true;
                } else {
                    vm.itemDisplayed[parentIndex].selected = false;
                }*/
                if (location == 'file') {
                    var child_length = vm.itemDisplayed[parentIndex].subs[index].subs.length;
                    if (child_length > 0) {
                        for (var i = 0; i < child_length; i++) {
                            vm.itemDisplayed[parentIndex].subs[index].subs[i].selected = status;
                            toggleSelectParentModule(event, parentIndex, index, i, 'controller');
                        }
                    }
                }
                vm.showAdd = false;
            }

            /**
             * Sselect all contacts
             */
            function selectAllModules(item, index) {
                var status = (vm.itemDisplayed[index].selected == true) ? false : true;
                vm.itemDisplayed[index].selected = status;
                for (var i = 0; i < vm.itemDisplayed[index].subs.length; i++) {
                    vm.itemDisplayed[index].subs[i].selected = status;
                    for (var j = 0; j < vm.itemDisplayed[index].subs[i].subs.length; j++) {
                        vm.itemDisplayed[index].subs[i].subs[j].selected = status;
                        for (var k = 0; k < vm.itemDisplayed[index].subs[i].subs[j].subs.length; k++) {
                            vm.itemDisplayed[index].subs[i].subs[j].subs[k].selected = status;
                        }
                    }
                }
                vm.showAdd = false;
            }

            function saveHotel() {
                var data = {
                    data: vm.itemDisplayed,
                    'role_id': $stateParams.id,
                    'role_name': vm.roleName
                };
                vm.isloading = false;
                roleService.UpdateSelectedModule(data).then(function(response) {
                    if (response.errorMsg) {
                        vm.isloading = false;
                        toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                    } else if (response.success) {
                        vm.isloading = false;
                        vm.goToRoles();
                    } else {
                        vm.isloading = false;
                        toastMessage.showSimpleToast('There was some error in saving permissions of role.', 'error-toast');
                    }
                });
            }

            function getModule() {
                if (vm.pageLoaded) {
                    vm.isloading = true;
                    var data = {
                        'hotels': vm.template.hotel_id,
                        'role_id': $stateParams.id
                    };
                    roleService.permissionBySelectedHotel(data).then(function(response) {
                        vm.itemDisplayed = response.listData;
                        vm.isloading = false;
                    });
                }
            }

            function goToRoles() {
                if (vm.hotel_id) {
                    $state.go('app.roles_hotelwise', {
                        hotel_id: vm.hotel_id
                    });
                } else {
                    $state.go('app.roles');
                }
            }

            setTimeout(function() {
               vm.autoFillOff = false;
            }, 1500); 
        }
    })();
(function ()
{
	'use strict';

	angular
	.module('app.contacts')
	.controller('rolesAddPermissionController', rolesAddPermissionController);

	/** @ngInject */
	function rolesAddPermissionController($scope, $mdSidenav, rolePermissionModule, $localStorage, $stateParams, $filter, roleService,toastMessage, $state)
	{

		var vm = this;
		vm.roleId 			= $stateParams.id;
		vm.hotel_id 		= $stateParams.hotel_id;
		vm.selectedhotel	= $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
		if(rolePermissionModule.success === false)
			$state.go('app.roles');
		vm.itemDisplayed 	= rolePermissionModule.listData;
		vm.hotels 		 	= [];
		vm.roleName 		= rolePermissionModule.role_name; 
		vm.Allhotels 		= rolePermissionModule.organizations;
		vm.actionStatus = 'add';
		//Methods
		vm.toggleSelectParentModule = toggleSelectParentModule;
		vm.toggleSelectModule = toggleSelectModule;
		vm.selectAllModules = selectAllModules;
		vm.selectModules = selectModules;
		vm.checkUnique 		= checkUnique;
		vm.goToRoles 		= goToRoles;
		vm.saveHotel 		= saveHotel;
		vm.getModule 		= getModule;
		//Conditional variables
		vm.showAction		= true;
		vm.showAdd			= true;
		vm.AddForm			= true;
		vm.uniqueName 		= false;
		vm.selectit = true;
		vm.autoFillOff = true;

		vm.isloading = false;
		vm.getModule();
		

   	/**
	* Save selected modules
   	*/
	
	function checkUnique(){
		 vm.isloading = true;
		if(vm.roleName.length >1){
			var data 	= {'name':vm.roleName,'role_id':'',selectedhotel:vm.selectedhotel};
				roleService.checkUniqueRoleName(data).then(function(response){
					if(response.success == true){
						vm.showAdd	= true;
						vm.uniqueName = true;
					}else{
						vm.uniqueName = false;
						vm.showAdd	= false;
					}
					 vm.isloading = false;
				});
		}else{
			vm.showAdd	= true;
		}
	}

	
	function toggleSelectParentModule(event, parentIndex, subParentIndex, index,location){
		if(location=='file'){
			var status = (vm.itemDisplayed[parentIndex].subs[subParentIndex].subs[index].selected == true)?false:true;
			vm.itemDisplayed[parentIndex].subs[subParentIndex].subs[index].selected = status;
		}else{
			var status = vm.itemDisplayed[parentIndex].subs[subParentIndex].subs[index].selected;
		}
		
		var selectedSubs = 0;
		for(var i=0;i<vm.itemDisplayed[parentIndex].subs[subParentIndex].subs.length;i++){
			if(vm.itemDisplayed[parentIndex].subs[subParentIndex].subs[i].selected==true){
				selectedSubs++;
			}
		}
		/****** to make node selected if any of its child is selected start ****/
                
        if(selectedSubs > 0) {
            vm.itemDisplayed[parentIndex].subs[subParentIndex].selected = true;
        } else {
            vm.itemDisplayed[parentIndex].subs[subParentIndex].selected = false;
        }
        /****** to make node selected if any of its child is selected end ****/
		/*if(vm.itemDisplayed[parentIndex].subs[subParentIndex].subs.length == selectedSubs) {
			vm.itemDisplayed[parentIndex].subs[subParentIndex].selected = true;
		}else{
			vm.itemDisplayed[parentIndex].subs[subParentIndex].selected = false;
		}*/
		
		selectModules(parentIndex, index, event,'controller');
		if(location!='lastcontroller'){
			var child_length = vm.itemDisplayed[parentIndex].subs[subParentIndex].subs[index].subs.length;
			if(child_length > 0) {
				for( var i = 0 ; i < child_length; i++){
					vm.itemDisplayed[parentIndex].subs[subParentIndex].subs[index].subs[i].selected = status;
				}
			}
		}
		if ( event ){
			event.stopPropagation();
		}
	}

	function toggleSelectModule(event,lastindex,secLastIndex,thirlastIndex,topLevelIndex){
		var status = (vm.itemDisplayed[topLevelIndex].subs[thirlastIndex].subs[secLastIndex].subs[lastindex].selected == true)?false:true;
		vm.itemDisplayed[topLevelIndex].subs[thirlastIndex].subs[secLastIndex].subs[lastindex].selected = status;
		var selectedSubs = 0;
		for(var i=0;i<vm.itemDisplayed[topLevelIndex].subs[thirlastIndex].subs[secLastIndex].subs.length;i++){
			if(vm.itemDisplayed[topLevelIndex].subs[thirlastIndex].subs[secLastIndex].subs[i].selected==true){
				selectedSubs++;
			}
		}
		if(selectedSubs > 0) {
            vm.itemDisplayed[topLevelIndex].subs[thirlastIndex].subs[secLastIndex].selected = true;
        } else {
            vm.itemDisplayed[topLevelIndex].subs[thirlastIndex].subs[secLastIndex].selected = false;
        }
		/*if(vm.itemDisplayed[topLevelIndex].subs[thirlastIndex].subs[secLastIndex].subs.length == selectedSubs) {
			vm.itemDisplayed[topLevelIndex].subs[thirlastIndex].subs[secLastIndex].selected = true;
		}else{
			vm.itemDisplayed[topLevelIndex].subs[thirlastIndex].subs[secLastIndex].selected = false;
		}*/
		toggleSelectParentModule(event,topLevelIndex,thirlastIndex,secLastIndex,'lastcontroller')
		if ( event ){
			event.stopPropagation();
		}
	}
	/**
	 * Sselect modules
	 */
	function selectModules(parentIndex, index, event,location){
		if(location=='file'){
			var status = (vm.itemDisplayed[parentIndex].subs[index].selected == true)?false:true;
			vm.itemDisplayed[parentIndex].subs[index].selected = status;
		}
		/***if parent have only one child and that child doesn't have any child***/
		var selectedSubs = 0;
		for(var i=0;i<vm.itemDisplayed[parentIndex].subs.length;i++){
			if(vm.itemDisplayed[parentIndex].subs[i].selected==true){
				selectedSubs++;
			}
		}
		if(selectedSubs > 0) {
            vm.itemDisplayed[parentIndex].selected = true;
        } else {
            vm.itemDisplayed[parentIndex].selected = false;
        }
		/*if(vm.itemDisplayed[parentIndex].subs.length == selectedSubs) {
			vm.itemDisplayed[parentIndex].selected = true;
		}else{
			vm.itemDisplayed[parentIndex].selected = false;
		}*/
		if(location=='file'){
			var child_length = vm.itemDisplayed[parentIndex].subs[index].subs.length;
			if(child_length > 0) {
				for( var i = 0 ; i < child_length; i++){
					vm.itemDisplayed[parentIndex].subs[index].subs[i].selected = status;
					toggleSelectParentModule(event, parentIndex, index, i,'controller');
				}
			}
		}
	}

	/**
	 * Sselect all contacts
	 */
	function selectAllModules(item, index){
		var status = (vm.itemDisplayed[index].selected == true)?false:true;
		vm.itemDisplayed[index].selected 	= status;
		for( var i=0 ; i< vm.itemDisplayed[index].subs.length; i++){
			vm.itemDisplayed[index].subs[i].selected = status;
			for( var j=0 ; j< vm.itemDisplayed[index].subs[i].subs.length; j++){
				vm.itemDisplayed[index].subs[i].subs[j].selected = status;
				for( var k=0 ; k< vm.itemDisplayed[index].subs[i].subs[j].subs.length; k++){
					vm.itemDisplayed[index].subs[i].subs[j].subs[k].selected = status;
				}
			}
		}
	}

	function saveHotel(){
		vm.isloading = true;
		var data = {'roles':vm.itemDisplayed,'role_name':vm.roleName,'hotel_id':vm.selectedhotel};
		roleService.addRole(data).then(function(response){
			if(response.status == true){
				$state.go('app.roles');
			}
			 vm.isloading = false;
		});
	}

	function getModule(){
		var data = {'hotel_id':vm.selectedhotel};
		vm.isloading = true;
		roleService.permissionBySelectedHotel(data).then(function(response){
			vm.isloading = false;
			vm.itemDisplayed = response.listData;
			vm.hotels 		 = response.hotels;
		});
	}

	function goToRoles(){
			if(vm.hotel_id){
			$state.go('app.roles_hotelwise',{hotel_id:vm.hotel_id});
		}else{
			$state.go('app.roles');
		}
	}
	function saveInstantModules(){
		vm.isloading = true;
        roleService.UpdateSelectedModule(data).then(function(response){
          if(response.errorMsg){
             vm.isloading = false;
            toastMessage.showSimpleToast(response.errorMsg,'error-toast');
          }else if(response.success){
             vm.isloading = false;
              vm.updatedPermission = roleService.getRolePermissions($stateParams.id,$localStorage.hotels[$localStorage.selectedHotel].hotel_id).then(function(response){
                vm.itemDisplayed 	= response.listData;						
              });
            }else{
               vm.isloading = false;
              toastMessage.showSimpleToast('There was some error in saving permissions of role.','error-toast');
            }
          });
	}

	setTimeout(function() {
       vm.autoFillOff = false;
   	}, 1500); 
 }
})();

(function ()
{
    'use strict';

    angular
        .module('app.permissions.roles')
        .service('roleService', roleService);

    /** @ngInject */
    function roleService($http,EnvironmentConfig)
    {
        var service = {
            getAllRoles: getAllRoles,
            fetchWebsite: fetchWebsite,
            addRole:addRole,
            UpdateRoles:UpdateRoles,
            deleteSelectedRole:deleteSelectedRole,
            checkUniqueRoleName:checkUniqueRoleName,
            getRolePermissions:getRolePermissions,
            saveRolePermissions:saveRolePermissions,
            UpdateRolePermission:UpdateRolePermission,
            getSingleEdit:getSingleEdit,
            UpdateSelectedModule:UpdateSelectedModule,
            UpdateSingleModule:UpdateSingleModule,
            currentUserPermission:currentUserPermission,
            permissionBySelectedHotel:permissionBySelectedHotel
        };

        return service;

       function getDataComplete(response) {
			return response.data;
		}

		function getDataFailed(error) {
			return error.data;
		}
		function getAllRoles(){
            return $http({
                url:EnvironmentConfig.api+'roles/roles',
                method:'GET'
            })
            .then(getDataComplete)
            .catch(getDataFailed);
        }
        function getSingleEdit(id){
            return $http({
                url:EnvironmentConfig.api+'roles/skipAcl_getSingleData',
                method:'POST',
                data:id

            })
            .then(getDataComplete)
            .catch(getDataFailed);
        }

        function fetchWebsite(){
            return $http({
                url:EnvironmentConfig.api+'roles/skipAcl_fetchWebsite',
                method:'GET'
            })
            .then(getDataComplete)
            .catch(getDataFailed);
        }


        function addRole(roleData){
			return $http({
				url:EnvironmentConfig.api+'roles/add_role',
				method:'POST',
                data:roleData
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

        function UpdateRoles(roleUpdateData){
            return $http({
                url: EnvironmentConfig.api + 'roles/update_roles',
                method:'POST',
                data:roleUpdateData
            })
            .then(getDataComplete)
            .catch(getDataFailed);
        }
        
        function deleteSelectedRole(selectedId){
            return $http({
                url:EnvironmentConfig.api + 'roles/delete_role',
                method:'POST',
                data: selectedId
            })
            .then(getDataComplete)
            .catch(getDataFailed);
        }
        function checkUniqueRoleName(roleName){
            return $http({
                url: EnvironmentConfig.api + "roles/skipAcl_check_unique_role_name",
                method:'POST',
                data:{"roleName":roleName}
            })
            .then(getDataComplete)
            .catch(getDataFailed);
        }
        function getRolePermissions(roleId,hotel_id){
			var data = {roleId:roleId,hotel_id:hotel_id};
            return $http({
                url:EnvironmentConfig.api + 'roles/skipAcl_role_permission_listing',
                method:'POST',
                data:data
            })
            .then(getDataComplete)
            .catch(getDataFailed);

        }
        function saveRolePermissions(){
            return({
                url:EnvironmentConfig.api + 'roles/'
            })
            .then(getDataComplete)
            .catch(getDataFailed);
        }
        function UpdateRolePermission(data){
            return $http({
                url: EnvironmentConfig.api + 'roles/skipAcl_role_permission_update',
                method: 'POST',
                data: data
            })
            .then(getDataComplete)
            .catch(getDataFailed);
        }

        function UpdateSelectedModule(data){
            return $http({
                url: EnvironmentConfig.api + 'roles/skipAcl_role_perm_update',
                method: 'POST',
                data: data
            })
            .then(getDataComplete)
            .catch(getDataFailed);
        }

        function UpdateSingleModule(data){
            return $http({
                url: EnvironmentConfig.api + 'roles/skipAcl_role_update',
                method: 'POST',
                data: data
            })
            .then(getDataComplete)
            .catch(getDataFailed);
        }

        function currentUserPermission(){

            return $http({
                url: EnvironmentConfig.api + 'roles/skipAcl_role_by_logged_user',
                method: 'post'
            })
            .then(getDataComplete)
            .catch(getDataFailed);
        }

        function permissionBySelectedHotel(data){

            return $http({
                url: EnvironmentConfig.api + 'roles/skipAcl_role_by_logged_user',
                method: 'post',
                data:data
            })
            .then(getDataComplete)
            .catch(getDataFailed);
        }
    }
})();


(function() {
    'use strict';

    angular
        .module('app.contacts')
        .controller('rolesController', rolesController);

    /** @ngInject */
    function rolesController(
        $mdToast,
        $scope,
        $mdSidenav,
        msUtils,
        $mdDialog,
        $document,
        roleService,
        $localStorage,
        $state,
        toastMessage,
        $http,
        EnvironmentConfig,
        $stateParams,
        $sessionStorage,
        $rootScope
    ) {

        var vm = this;

        if(!$rootScope.backButtonPressed){
          $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = {};
          $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] = 1;
          $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'] = 50;
        }

        vm.tempContact = [];
        vm.selectedRoleId = [];
        vm.checkDelete = false;
        vm.page = 1;
        vm.pageSize = 1;
        vm.hotel_id = $stateParams.hotel_id;
        vm.requestgoing = false;
        /*Start*/
        $scope.paginatorCallback = paginatorCallback;
        $scope.LoadAllData = LoadAllData;
        $scope.getLoadResultsCallback = getLoadResultsCallback;
        $scope.selectedRowCallback = function(rows) {
            vm.selectedRoleId = rows;
        };

        $scope.deleteSelectedItem = function(ev) {
            // new
            var html = 'Are you sure, you want to delete the selected role(s)?</br>';
            html = html + '<b>' + vm.selectedRoleId.length + ' role(s)</b>' + ' will be deleted.</br><b><h3>Users related to this role will also be deleted.</h3></b>';

            $mdDialog.show({
                    controller: 'confirmController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: true,
                    locals: {
                        title: 'Delete Role',
                        htmlContent: html,
                        cancelBtn: 'Cancel',
                        OkBtn: 'Ok'
                    }
                })
                .then(function(answer) {
                    if (typeof answer != 'undefined' && answer == 'update') {
                        roleService.deleteSelectedRole(vm.selectedRoleId)
                            .then(function(response) {
                                if (response.success) {
                                    vm.checkDelete = false;
                                    vm.selectedRoleId = [];
                                    loadPageCallbackWithDebounce();
                                } else {
                                    toastMessage.showSimpleToast('There was some error in deleting roles.', 'error-toast');
                                }
                            });
                    }
                }, function() {});
            //Old
        }
        var loadPageCallbackWithDebounce;
        $scope.$watch('filterText', function() {
            if (loadPageCallbackWithDebounce) {
                loadPageCallbackWithDebounce();
            }
        });

        $scope.showTabDialog = function(ev, module_id, id) {
            if (vm.userPermissions.indexOf('update_role') != -1) {
                if (module_id) {
                    roleService.getRolePermissions(id).then(function(response) {
                        // $state.go('app.rolesPermission',{id:id,hotel_id:vm.hotel_id});
                        $state.go('app.roles_detail', {
                            id: id
                        });
                    });
                } else {
                    toastMessage.showSimpleToast('There are no modules assigned for this hotel.', 'error-toast');
                }
            }
        };

        $scope.updateTable = function() {
            loadPageCallbackWithDebounce();
        };

        $scope.checkBox = function(value) {
            if (vm.selectedRoleId.indexOf(value) > -1) {
                vm.selectedRoleId.splice(vm.selectedRoleId.indexOf(value), 1);
            } else {
                vm.selectedRoleId.push(value);
            }
            if (vm.selectedRoleId.length > 0) {
                vm.getNumberOfSelectedRows = vm.selectedRoleId.length;
                vm.checkDelete = true;
            } else {
                vm.checkDelete = false;
            }
        };

        $scope.addmodel = function(ev, contact) {
            if (vm.userPermissions.indexOf('update_role') != -1) {
                roleService.getSingleEdit(contact).then(function(response) {
                    $mdDialog.show({
                        controller: 'roleControllers',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/apps/permissions/roles/dialogs/contact/role-dialog.html',
                        parent: angular.element($document.find('#content-container')),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        scope: $scope.$new(),
                        locals: {
                            Contact: response[0],
                            User: vm.user,
                            Contacts: vm.contacts,
                            HotelId: vm.hotel_id
                        }
                    });
                    jQuery('.sec-contact-tab').css('display', 'none');
                    jQuery('.third-contact-tab').css('display', 'none');
                });
            }
        }


        function getLoadResultsCallback(loadPageCallback) {
            loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
        }
        vm.UserColumns = ['role_name', 'hotel_role_id'];

         vm.onLoad = true;
        function paginatorCallback(page, pageSize, option) {
          if(vm.requestGoing) return;
          if(vm.onLoad == true){
            if(typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] != 'undefined'){

              var page1 =  $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
              var pageSize1 = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'];
            vm.onLoad = false;
              return LoadAllData(page1, pageSize1,option);
            }else{
              vm.onLoad = false;
              return LoadAllData(page, pageSize,option);    
            }
          }else{
            if(typeof page == 'undefined'){
              page = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
            }
            return LoadAllData(page, pageSize,option);
          } 
        vm.onLoad = false;         
        }
        /*End*/

        function LoadAllData(page, pageSize,option){

          vm.requestGoing = true;
          var pageDetail = {'currentPage':page,'pageSize':pageSize};
          $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = pageDetail;          
          if (!page) {
              page = vm.page;
          } else {
              vm.page = page;
          }
          vm.checkDelete = false;
          vm.selectedRoleId = [];
          var sort = {};
          for (var i = 0; i < option.columnSort.length; i++) {
              if (option.columnSort[i]['sort']) {
                  sort['column'] = vm.UserColumns[i];
                  sort['order'] = option.columnSort[i]['sort'];
              }
          }

          var offset = (page - 1) * pageSize;
          var query = $scope.filterText ? $scope.filterText : '';
          var filterData = {
              'offset': offset,
              'pageSize': pageSize,
              'search': $scope.filterText,
              'sort': sort,
              'selectedHotel': $localStorage.hotels[$localStorage.selectedHotel].hotel_id
          };
          if (vm.hotel_id) {
              filterData.hotel_id = vm.hotel_id;
          }
          return $http({
              url: EnvironmentConfig.api + 'roles/roles',
              method: 'POST',
              data: filterData
          }).then(function(result) {
              vm.requestGoing = false;
              vm.tempContact = result.data[0]['rolesList'];
              vm.contacts = result.data[0]['rolesList'];
              vm.totalRoles = result.data[0]['Count'];
              return {
                  results: result.data[0]['rolesList'],
                  totalResultCount: result.data[0]['Count']
              }
          });
        }

        // Data

        vm.user = [];
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'name';
        vm.listOrderAsc = false;
        vm.newGroupName = '';
        vm.myRoleId = $localStorage.roleId;
        // Methods
        vm.filterChange = filterChange;
        vm.manageRolePermission = manageRolePermission;
        vm.userPermissions = $rootScope.userPermissions;
        vm.openContactDialog = openContactDialog;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.deleteSelectedContacts = deleteSelectedContacts;
        vm.toggleSelectContact = toggleSelectContact;
        vm.deselectContacts = deselectContacts;
        vm.selectAllContacts = selectAllContacts;
        vm.deleteContact = deleteContact;
        vm.addNewGroup = addNewGroup;
        vm.deleteGroup = deleteGroup;
        vm.gotorolesusers = gotorolesusers;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.dtOptions = {
            dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth: false,
            responsive: true
        };
        if (vm.userPermissions.indexOf('delete_role') != -1) {
            $scope.isDeletedAllowed = true;
        } else {
            $scope.isDeletedAllowed = false;
        }

        //////////
        /*Manage Role Permission*/

        function manageRolePermission(id) {
            roleService.getRolePermissions(id).then(function(response) {
                if (response.listData.length == 0) {
                    toastMessage.showSimpleToast('This role has no module assigned.', 'error-toast');
                } else {
                    $state.go('app.rolesPermission', {
                        id: id
                    });

                }
            });
        }

        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type) {
            vm.listType = type;

            if (type === 'all') {
                vm.filterIds = null;
            } else if (type === 'frequent') {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred') {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type)) {
                vm.filterIds = type.contactIds;
            }
            vm.selectedContacts = [];
        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, contact) {

            $state.go('app.roles_add');
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteContactConfirm(contact, ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the Role?')
                .htmlContent('<b>' + contact.role_name + '</b>' + ' will be deleted.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');
            $mdDialog.show(confirm).then(function() {
                roleService.deleteRole(contact.role_id).then(function(response) {
                    if (!response.error) {
                        deleteContact(contact);
                        vm.selectedContacts = [];
                    } else {
                        alert('error');
                    }
                });
            }, function() {});
        }

        /**
         * Delete Contact
         */
        function deleteContact(contact) {
            vm.contacts.splice(vm.contacts.indexOf(contact), 1);
        }
        /**
         * Delete Selected Contacts
         */
        function deleteSelectedContacts(ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the selected contacts?')
                .htmlContent('<b>' + vm.selectedRoleId.length + ' roles</b>' + ' will be deleted.')
                .ariaLabel('delete contacts')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');
            $mdDialog.show(confirm).then(function() {
                roleService.deleteSelectedRole(vm.selectedRoleId)
                    .then(function(response) {
                        if (response.success) {
                            vm.checkDelete = false;
                            vm.selectedRoleId = [];
                            loadPageCallbackWithDebounce();
                        } else {
                            toastMessage.showSimpleToast('There was some error in deleting roles.', 'error-toast');
                        }
                    });
            });
        }

        /**
         * Toggle selected status of the contact
         *
         * @param contact
         * @param event
         */
        function toggleSelectContact(contact, event) {

            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedContacts.indexOf(contact) > -1) {
                vm.selectedContacts.splice(vm.selectedContacts.indexOf(contact), 1);
                vm.selectedRoleId.splice(vm.selectedRoleId.indexOf(contact.role_id), 1);
            } else {
                vm.selectedRoleId.push(contact.role_id);
                vm.selectedContacts.push(contact);
            }
        }

        /**
         * Deselect contacts
         */
        function deselectContacts() {
            vm.selectedContacts = [];
            vm.selectedRoleId = [];
        }

        /**
         * Sselect all contacts
         */
        function selectAllContacts() {
            vm.selectedRoleId = [];
            vm.selectedContacts = $scope.filteredContacts;
            for (var i = 0; i < $scope.filteredContacts.length; i++) {
                vm.selectedRoleId.push($scope.filteredContacts[i].role_id);
            }
        }

        /**
         *
         */
        function addNewGroup() {
            if (vm.newGroupName === '') {
                return;
            }
            var newGroup = {
                'id': msUtils.guidGenerator(),
                'name': vm.newGroupName,
                'contactIds': []
            };

            vm.user.groups.push(newGroup);
            vm.newGroupName = '';
        }

        /**
         * Delete Group
         */
        function deleteGroup(ev) {

            var group = vm.listType;

            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the group?')
                .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
                .ariaLabel('delete group')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');
            $mdDialog.show(confirm).then(function() {
                vm.user.groups.splice(vm.user.groups.indexOf(group), 1);
                filterChange('all');
            });
        }

        /**
         * Toggle sidenav
         * @param sidenavId
         */
        function gotorolesusers() {
            $state.go('app.permissions_rolespermissions');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.permissions.adminusers',
            [
                // 3rd Party Dependencies
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider){

        $stateProvider.state('app.permissions_adminusers', {
            url    : '/adminusers',
            title  : 'Users',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/permissions/adminusers/adminusers.html',
                    controller : 'AdminusersController as vm'
                }
            },
            permission: 'users',
            bodyClass: 'adminusers'

        }).state('app.user_detail_add', {
            url    : '/user/add',
            title  : 'Users',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/permissions/adminusers/adminuser.html',
                    controller : 'AdminuserController as vm'
                }
            },
            resolve: {
                Adminuser: function (adminusersservice,$stateParams,$localStorage){
                    return adminusersservice.getuserData('add',$localStorage.hotels[$localStorage.selectedHotel].hotel_id);
                }
            },
            permission: 'add_user',
            bodyClass: 'adminusers'
        }).state('app.user_detail_edit', {
            url    : '/user/:user_id',
            title  : 'Users',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/permissions/adminusers/adminuser.html',
                    controller : 'AdminuserController as vm'
                }
            },
            resolve: {
                Adminuser: function (adminusersservice,$stateParams,$localStorage){
                    return adminusersservice.getuserData($stateParams.user_id,$localStorage.hotels[$localStorage.selectedHotel].hotel_id);
                }
            },
            permission: 'update_user',
            bodyClass: 'adminusers'
        });
        
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/permissions');
    }
})();

(function ()
{
	'use strict';

	angular
	.module('app.permissions.adminusers')
	.service('profileservice', profileservice);

	/** @ngInject */
	function profileservice($http,EnvironmentConfig)
	{
		var service = {
			updateProfile: updateProfile,
			updateUser: updateUser
		};
		return service;

		function getDataComplete(response) {
			return response.data;
		}

		function getDataFailed(error) {
			return error.data;
		}

		function updateProfile(){
			return $http({
				url:EnvironmentConfig.api+'users/skipAcl_updateProfile',
				method:'GET'
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		
		function updateUser(formData){
			return $http({
				url: EnvironmentConfig.api+'/users/skipAcl_updateProfile',
				data: formData,
				headers: { 'Content-Type': undefined },
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

	}
})();


(function ()
{
    'use strict';

    angular
        .module('app.permissions.profile',
            [
                'xeditable',
                'ngMaterial',
                'ngFileUpload'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider){

        $stateProvider.state('app.permissions_profile', {
            url    : '/profile',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/permissions/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            },
            resolve: {
                profileData: function (profileservice){
                    return profileservice.updateProfile();
                }
            },
            bodyClass: 'profile'
        });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/permissions');
    }
})();

(function ()
{
  'use strict';

  angular
  .module('app.permissions.profile')
  .controller('ProfileController', ProfileController);


  /** @ngInject */
  function ProfileController($rootScope, $scope, $mdSidenav, profileservice,profileData, toastMessage,$localStorage, $http, EnvironmentConfig, $translate){

    var vm = this;
    vm.profile = profileData.userData;
    vm.filterIds = null;
    vm.selectFile = false;
    vm.imageStatus = true;
    vm.file = '';
    vm.previousPicture = $localStorage.profilePic.split('/thumbnail');
    vm.previousPicture = vm.previousPicture[0]+vm.previousPicture[1];
    vm.isloading = false;
    vm.profilePicStatus = false;
    vm.baseUrl = EnvironmentConfig.api;
    vm.autoFillOff = true;
    vm.updateProfile = function(field_name){
    	vm.isloading = true;
		var fd = new FormData();
		var fields = true;
		/*if(is_required == 'required' && vm.profile[field_name] == undefined) {
			fields = false;
		}*/
		if(field_name == 'profile_pic') {
			if(!vm.profilePicStatus) {
				fields = false;
				return false;
			}
			fd.append('file',vm.file);
			fd.append(field_name,vm.profile[field_name]);
		} else if((field_name == 'passwordConfirm' || field_name == 'password') && ((vm.profile.passwordConfirm != undefined) && ((vm.password) != undefined)) && (vm.password == vm.profile.passwordConfirm)) {
			fd.append('cnfpassword',vm.profile.passwordConfirm);
		} else if(field_name != 'passwordConfirm' && field_name != 'password') {
			fd.append(field_name,vm.profile[field_name]);
		}
		if((field_name == 'passwordConfirm' || field_name == 'password') && ((vm.profile.passwordConfirm == undefined) || (vm.password == undefined) || (vm.password != vm.profile.passwordConfirm))) {
			fields = false;
		}
		fd.append('user_id',vm.profile['user_id']);
		if(fields) {

			$http({
		        method: 'POST',
		        url: EnvironmentConfig.api+'/users/skipAcl_updateProfile',
		        data: fd,
		        headers: { 'Content-Type': undefined },
		    }).then(function(response) {
				vm.isloading = false;
				if(!response.data['error']){
					if(vm.profile['first_name'] != undefined)
						$localStorage.firstName = vm.profile['first_name'];
					if(vm.profile['last_name'] != undefined)
						$localStorage.lastName= vm.profile['last_name'];
					$rootScope.username = $localStorage.firstName+' '+$localStorage.lastName;
					if(response.data['image'] != '') {
						$localStorage.profilePic =  EnvironmentConfig.api+'assets/uploads/profileimage/thumbnail/'+response.data['image'];
						$rootScope.profilePic =  $localStorage.profilePic;
						vm.previousPicture = EnvironmentConfig.api+'assets/uploads/profileimage/'+response.data['image'];
					}
					//toastMessage.showSimpleToast('Profile updated successfully','success-toast');
				}
				else {
					if(response.data['errorType'] == 'image'){
						toastMessage.showSimpleToast(response.data['msg'],'error-toast');
                        vm.pictures = null;
                        vm.imageStatus = true;
                        vm.file =null;
                        vm.selectFile =false;
                    }
                    if(response.data['errorType'] === 'data') {
						toastMessage.showSimpleToast(response.data['msg'],'error-toast');
					}
				}
			}, function(err){
				vm.isloading = false;
			});
		} else {
			vm.isloading = false;
		}

	}
    $scope.upload = function(file,errFiles) {
    	if(file){
    		vm.profilePicStatus = true;
	        vm.imageStatus= false;
	        vm.file = file;
	        vm.selectFile = true;

	    } else {
	    	vm.isloading = false;
	    	vm.profilePicStatus = false;
	    	if(errFiles.length > 0) {
                angular.forEach(errFiles, function (value, index){
                    switch(value.$error) {
                        case 'pattern': vm.fileError = 'FILE_TYPE_NOT_SUPPORTED';
                            break;
                        case 'maxSize': vm.fileError = 'FILE_SIZE_EXCEEDS';
                            break;
                        case 'minWidth' : vm.fileError = 'MIN_SIZE_MESSAGE';
                            break;
                        case 'minHeight' : vm.fileError = 'MIN_SIZE_MESSAGE';
                            break;
                        default: vm.fileError = 'COMMON_IMAGE_MESSAGE';
                    }
                    toastMessage.showSimpleToast($translate.instant('PROFILE.'+ vm.fileError),'error-toast');
                });
            }
	    }
    }

 	setTimeout(function() {
       vm.autoFillOff = false;
   	}, 1500); 
  }
})();

(function() {
		'use strict';

		angular
				.module('app.permissions.organizations')
				.controller('OrganizationsController', OrganizationsController);

		/** @ngInject */
		function OrganizationsController(
				$scope,
				$mdSidenav,
				msUtils,
				$mdDialog,
				$document,
				organizationsservice,
				$state,
				$localStorage,
				toastMessage,
				$http,
				EnvironmentConfig,
				$sessionStorage,
				$rootScope
		) {

				var vm = this;

				if (!$rootScope.backButtonPressed) {
						$sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']] = {};
						$sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']]['currentPage'] = 1;
						$sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']]['pageSize'] = 50;
				}

				vm.tempOrganisation = [];
				vm.selectedOrganisationId = [];
				vm.checkDelete = false;
				vm.tempOrgParent = 0;
				$scope.userPermissions = $rootScope.userPermissions;
				// Data
				vm.loggedinUserRole = $localStorage.roleId;
				vm.userPermissions = $rootScope.userPermissions;
				vm.isDeleteAllowed = false;
				if (vm.userPermissions.indexOf('delete_hotel') != -1) vm.isDeleteAllowed = true;
				/*Changes For DataTable Start*/
				$scope.paginatorCallback = paginatorCallback;
				$scope.LoadAllData = LoadAllData;
				$scope.getLoadResultsCallback = getLoadResultsCallback;

				$scope.selectedRowCallback = function(rows) {
						vm.selectedOrganisationId = rows;
				};
				$scope.deleteSelectedItem = function(ev) {
						// new
						var html = 'Are you sure, you want to delete the selected hotel(s) ?</br>';
						html = html + '<b>' + vm.selectedOrganisationId.length + ' hotel(s)</b>' + ' will be deleted.';

						$mdDialog.show({
										controller: 'confirmController',
										controllerAs: 'vm',
										templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
										parent: angular.element(document.body),
										targetEvent: event,
										clickOutsideToClose: true,
										locals: {
												title: 'Delete Hotel',
												htmlContent: html,
												cancelBtn: 'Cancel',
												OkBtn: 'Ok'
										}
								})
								.then(function(answer) {
										if (typeof answer != 'undefined' && answer == 'update') {
												organizationsservice.deleteOrganization(vm.selectedOrganisationId)
														.then(function(response) {
																if (response.errorMsg) {
																		toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
																} else if (response.success) {
																		vm.selectedOrganizations.forEach(function(organization) {
																				deleteOrganization(organization);
																		});
																		if (response.hotelList) {
																				if ($localStorage.hotels[$localStorage.selectedHotel].hotel_id == vm.selectedOrganisationId[0] || response['selfDelete']) {
																						$rootScope.selectedHotel = $localStorage.selectedHotel = 0;
																						console.log('in ');
																				}
																				$rootScope.hotels = $localStorage.hotels = response.hotelList;
																		}
																		console.log('success');
																		vm.selectedOrganizations = [];
																		vm.selectedorgsOnlyId = [];
																		vm.selectedOrganisationId = [];
																		loadPageCallbackWithDebounce();
																} else {
																		toastMessage.showSimpleToast('There was some error in deleting hotels.', 'error-toast');
																}
														});
										}
								}, function() {});
						//Old
				}


				var loadPageCallbackWithDebounce;

				$scope.$watch('filterText', function() {
						if (loadPageCallbackWithDebounce) {
								loadPageCallbackWithDebounce();
						}
				});
				$scope.showTabDialog = function(ev, id) {
						if (vm.userPermissions.indexOf('update_hotel') != -1) {
								$state.go('app.permissions_organization_edit', {
										id: id
								});
						}

				};
				$scope.goToRoles = function(ev, id) {
						$state.go('app.roles_hotelwise', {
								hotel_id: id
						});
				};
				$scope.updateTable = function() {
						loadPageCallbackWithDebounce();
				};

				$scope.checkBox = function(value) {
						if (vm.selectedOrganisationId.indexOf(value) > -1) {
								vm.selectedOrganisationId.splice(vm.selectedOrganisationId.indexOf(value), 1);
						} else {
								vm.selectedOrganisationId.push(value);
						}

						if (vm.selectedOrganisationId.length > 0) {
								vm.getNumberOfSelectedRows = vm.selectedOrganisationId.length;
								vm.checkDelete = true;
						} else {
								vm.checkDelete = false;
						}
				};

				$scope.addsuborg = function(ev, organization) {
						vm.tempOrgParent = organization;
						vm.openOrganizationDialog(ev);
				}
				$scope.addmodel = function(ev, contact) {

						var organization = [];

						for (var i = 0; i < vm.tempOrganisation.length; i++) {
								if (vm.tempOrganisation[i]['hotel_id'] == contact) {
										organization = vm.tempOrganisation[i];

								}
						}
						delete organization.DeleteId;
						delete organization.EditId;
						if (typeof organization == 'undefined' || vm.userPermissions.indexOf('update_hotel') != -1 || vm.userPermissions == 'All') {
								$mdDialog.show({
										controller: 'OrganizationDialogController',
										controllerAs: 'vm',
										templateUrl: 'app/main/apps/permissions/organizations/dialogs/organization/organization-dialog.html',
										parent: angular.element($document.find('#content-container')),
										targetEvent: ev,
										scope: $scope.$new(),
										clickOutsideToClose: true,
										locals: {
												Organization: organization,
												Categories: vm.categories,
												Organizations: vm.websites,
												ParentOrg: vm.tempOrgParent
										}
								});
								jQuery('.sec-organization-tab').css('display', 'none');
								jQuery('.third-organization-tab').css('display', 'none');
						}


				}



				function getLoadResultsCallback(loadPageCallback) {
						loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
				}
				vm.UserColumns = ['hotel_title', 'parent_id'];

				vm.onLoad = true;
				vm.requestGoing = false;

				function paginatorCallback(page, pageSize, option) {
						if (vm.requestGoing) return;
						if (vm.onLoad == true) {
								if (typeof $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']]['currentPage'] != 'undefined') {

										var page1 = $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']]['currentPage'];
										var pageSize1 = $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']]['pageSize'];
										vm.onLoad = false;
										return LoadAllData(page1, pageSize1, option);
								} else {
										vm.onLoad = false;
										return LoadAllData(page, pageSize, option);
								}
						} else {
								if (typeof page == 'undefined') {
										page = $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']]['currentPage'];
								}
								return LoadAllData(page, pageSize, option);
						}

				}

				function LoadAllData(page, pageSize, option) {
						vm.requestGoing = true;
						var pageDetail = {
								'currentPage': page,
								'pageSize': pageSize
						};
						$sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']] = pageDetail;


						if (!page) {
								page = vm.page;
						} else {
								vm.page = page;
						}
						vm.selectedOrganisationId = [];
						vm.checkDelete = false;
						var sort = {};
						for (var i = 0; i < option.columnSort.length; i++) {
								if (option.columnSort[i]['sort']) {
										sort['column'] = vm.UserColumns[i];
										sort['order'] = option.columnSort[i]['sort'];
								}
						}
						// ev.preventPropagation();
						var offset = (page - 1) * pageSize;
						var query = $scope.filterText ? $scope.filterText : '';

						var filterData = {
								'offset': offset,
								'pageSize': pageSize,
								'search': $scope.filterText,
								'id': null,
								'sort': sort,
								'getsubHotels': true
						};


						return $http({
								url: EnvironmentConfig.api + 'organizations/organizations',
								method: 'POST',
								data: filterData
						}).then(function(result) {
								vm.requestGoing = false;
								vm.organizations = vm.websites = vm.tempOrganisation = result.data['organizations'];
								vm.totalOrg = result.data['totalOrg'];
								return {
										results: result.data['organizations'],
										totalResultCount: result.data['totalOrg']
								}
						});
				}
				/*End*/
				/*Changes For DataTable End*/

				vm.filterIds = null;
				vm.listType = 'all';
				vm.listOrder = 'hotel_title';
				vm.listOrderAsc = false;
				vm.selectedOrganizations = [];
				vm.selectedorgsOnlyId = [];
				vm.newGroupName = '';
				vm.dtOptions = {
						dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
						pagingType: 'simple',
						autoWidth: false,
						responsive: true
				};

				// Methods
				vm.filterChange = filterChange;
				vm.goToOrgDetail = goToOrgDetail;
				vm.openOrganizationDialog = openOrganizationDialog;
				vm.deleteOrganizationConfirm = deleteOrganizationConfirm;
				vm.deleteOrganization = deleteOrganization;
				vm.toggleSelectOrganization = toggleSelectOrganization;
				vm.deselectOrganizations = deselectOrganizations;
				vm.selectAllOrganizations = selectAllOrganizations;
				vm.deleteOrganization = deleteOrganization;
				vm.addNewGroup = addNewGroup;
				vm.deleteGroup = deleteGroup;
				vm.toggleSidenav = toggleSidenav;
				vm.toggleInArray = msUtils.toggleInArray;
				vm.exists = msUtils.exists;
				vm.goToaddHotel = goToaddHotel;

				/**
				 * Change Organizations List Filter
				 * @param type
				 */
				function filterChange(type) {

						vm.listType = type;

						if (type === 'all') {
								vm.filterIds = null;
						} else if (type === 'frequent') {
								vm.filterIds = vm.user.frequentOrganizations;
						} else if (type === 'starred') {
								vm.filterIds = vm.user.starred;
						} else if (angular.isObject(type)) {
								vm.filterIds = type.organizationIds;
						}

						vm.selectedOrganizations = [];
				}

				/**
				 * Open new organization dialog
				 *
				 * @param ev
				 * @param organization
				 */
				function openOrganizationDialog(ev, organization) {

						if (typeof organization == 'undefined' || vm.userPermissions.indexOf('update_organization') != -1 || $localStorage.roleId == 4) {
								$mdDialog.show({
										controller: 'OrganizationDialogController',
										controllerAs: 'vm',
										templateUrl: 'app/main/apps/permissions/organizations/dialogs/organization/organization-dialog.html',
										parent: angular.element($document.find('#content-container')),
										targetEvent: ev,
										scope: $scope.$new(),

										clickOutsideToClose: true,
										locals: {
												Organization: organization,
												Categories: vm.categories,
												Organizations: vm.websites,
												ParentOrg: vm.tempOrgParent
										}
								});
								jQuery('.sec-organization-tab').css('display', 'none');
								jQuery('.third-organization-tab').css('display', 'none');
						}
				}

				/**
				 * Delete Organization Confirm Dialog
				 */
				function deleteOrganizationConfirm(organization, ev) {

						var confirm = $mdDialog.confirm()
								.title('Are you sure want to delete the hotel?')
								.htmlContent('<b>' + organization.hotel_title + '</b>' + ' will be deleted.')
								.ariaLabel('delete Organization')
								.targetEvent(ev)
								.ok('OK')
								.cancel('CANCEL');

						$mdDialog.show(confirm).then(function() {

								deleteOrganization(organization);
								vm.selectedOrganizations = [];

						}, function() {

						});
						ev.stopPropagation();
				}

				/**
				 * Delete Organization
				 */
				function deleteOrganization(organization) {
						vm.organizations.splice(vm.organizations.indexOf(organization), 1);
				}


				/**
				 * Toggle selected status of the organization
				 *
				 * @param organization
				 * @param event
				 */
				function toggleSelectOrganization(organization, event) {
						if (event) {
								event.stopPropagation();
						}

						if (vm.selectedOrganizations.indexOf(organization) > -1) {
								vm.selectedOrganizations.splice(vm.selectedOrganizations.indexOf(organization), 1);
								vm.selectedorgsOnlyId.splice(vm.selectedorgsOnlyId.indexOf(organization.hotel_id), 1);
						} else {
								vm.selectedOrganizations.push(organization);
								vm.selectedorgsOnlyId.push(organization.hotel_id);
						}
				}

				/**
				 * Deselect organizations
				 */
				function deselectOrganizations() {
						vm.selectedOrganizations = [];
						vm.selectedorgsOnlyId = [];
				}

				/**
				 * Sselect all organizations
				 */
				function selectAllOrganizations() {
						vm.selectedOrganizations = $scope.filteredOrganizations;
						vm.selectedorgsOnlyId = [];
						for (var i = 0; i < $scope.filteredOrganizations.length; i++) {
								vm.selectedorgsOnlyId.push($scope.filteredOrganizations[i].user_id);
						}
				}

				/**
				 *
				 */
				function addNewGroup() {
						if (vm.newGroupName === '') {
								return;
						}

						var newGroup = {
								'id': msUtils.guidGenerator(),
								'name': vm.newGroupName,
								'organizationIds': []
						};

						vm.user.groups.push(newGroup);
						vm.newGroupName = '';
				}

				/**
				 * Delete Group
				 */
				function deleteGroup(ev) {

						var group = vm.listType;

						var confirm = $mdDialog.confirm()
								.title('Are you sure want to delete the group?')
								.htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
								.ariaLabel('delete group')
								.targetEvent(ev)
								.ok('OK')
								.cancel('CANCEL');

						$mdDialog.show(confirm).then(function() {

								vm.user.groups.splice(vm.user.groups.indexOf(group), 1);

								filterChange('all');
						});
				}

				/**
				 * Toggle sidenav
				 *
				 * @param sidenavId
				 */
				function toggleSidenav(sidenavId) {
						$mdSidenav(sidenavId).toggle();
				}

				function goToOrgDetail(id) {
						$state.go('app.permissions_organization_edit', {
								id: id
						});
				}

				function goToaddHotel(id) {
						$state.go('app.permissions_organization_add', {
								id: 'add'
						});
				}
		}
})();
(function ()
{
	'use strict';

	angular
	.module('app.permissions.organization')
	.controller('OrganizationController', OrganizationController);

	/** @ngInject */
	function OrganizationController(
		$scope, 
		$mdSidenav, 
		msUtils, 
		$mdDialog, 
		$document, 
		$state, 
		Organization, 
		Organizations, 
		organizationservice, 
		toastMessage, 
		$interval, 
		$stateParams, 
		$rootScope, 
		$localStorage, 
		$translate,
		loginService){
		var vm = this;
		vm.isloading = false;
		vm.modules = Organization['main_modules'];
		vm.modulesLength = Organization['modules_length'];
		vm.exists = msUtils.exists;
		vm.selectedModules = [];
		vm.uniqueRoomNameError = {};
		vm.uniqueBoatNameError = {};
		vm.parent = false;
		$rootScope.isSelectedParent = 0;
		vm.childHotels = Organization['child_hotels'];
		vm.showBoats = false;
		vm.autoFillOff = true;
        if(parseInt($stateParams.id) >0){//Editing hotel
			vm.organization = Organization['organizations'][0];
			vm.totalRooms = Organization['hotel_rooms'];
			vm.totalBoats = Organization['hotel_boats'];
			if(vm.organization.parent_id > 0){
				vm.parent = true;
				vm.permHotelId = vm.organization.parent_id;
			} else {
				vm.permHotelId = vm.organization.hotel_id;
			}

			loginService.updateselected(vm.permHotelId).then(function(response){
                if(response['success']){
                    if(response['success']) {
			            vm.showBoats = (response.permissionList.indexOf('boats') != -1) ? true : false;
                    } else {
                    	vm.showBoats = validatePermission('boats');
                    }
                }
            });
			if(!vm.organization || !vm.organization.hotel_id){
				$state.go('app.permissions_organizations');
			}
			vm.addOrg = false;
			for(var i=0 ; i<Organization['selected_modules'].length; i++){
				vm.selectedModules.push(Organization['selected_modules'][i].id);
			}
		}else{//Adding new hotel
			vm.organization = {};
			vm.organization.parent_id = 0;
        	vm.addOrg = true;
        	for(var i=0 ; i<vm.modules.length; i++){
				var module_length = vm.modules[i].length;
				for(var j=0 ; j<module_length; j++){
					vm.selectedModules.push(vm.modules[i][j].id);
				}
			}
			vm.totalRooms = [];
			vm.totalBoats = [];
		}
		vm.organizations = Organizations.organizations;
        // Methods
        vm.gotoOrgs = gotoOrgs;
        vm.toggleSelectModule = toggleSelectModule;
        vm.selectAllModules = selectAllModules;
        vm.saveOrganization     = saveOrganization;
        vm.uniqueOrgName   		= uniqueOrgName;
        vm.checkedParent   		= checkedParent;
        vm.addProduct   		= addProduct;
        vm.deleteProduct   		= deleteProduct;
        vm.deleteBoat   		= deleteBoat;
        vm.editRoomNames   		= editRoomNames;
        vm.checkifRoomUnique   	= checkifRoomUnique;
        vm.changeStatus   		= changeStatus;
        vm.checkSubHotel		= false;
        vm.organization.default_sub_hotel = Organization.default_sub_hotel; 
        function checkedParent(){
        	if(vm.organization.parent_id == 0){
				vm.parent = false;
				vm.checkSubHotel = false;
			}else{
				vm.parent = true;
				vm.checkSubHotel = true;
			}
        }
        function addProduct(){
			vm.totalRooms.unshift({room_no:'',adding_new:true});
		}

		vm.addBoats = addBoats;
		function addBoats(){
			console.log(vm.totalBoats);
			vm.totalBoats.unshift({boat_no:'',adding_new:true});
		}

        function deleteProduct(key){
			vm.totalRooms.splice(key, 1);
		}
		function deleteBoat(key){
			vm.totalBoats.splice(key, 1);
		}
		function changeStatus(id,key,status){
			if(status==true || status==1){
				status = 0
			}else{
				status = 1;
			}
			vm.isloading = true;
			organizationservice.changeStatusRooms({id:id,room_status:status,room_no:vm.totalRooms[key].room_no}).then(function(resposen){
				vm.isloading = false;
				if(resposen.errorMsg){
					toastMessage.showSimpleToast(resposen.errorMsg,'error-toast');
				}else if(!resposen.success){
					toastMessage.showSimpleToast('There was some error in updating hotel rooms.','error-toast');
				}else if(resposen.success){
					vm.totalRooms[key].room_status = resposen.newstatus;
				}
			});
		}
        function gotoOrgs(){
        	$state.go('app.permissions_organizations');
        }
        /**
         * Save selected modules
         */
         function toggleSelectModule(module, event){
         	if ( event )
         	{
         		event.stopPropagation();
         	}
         	if ( vm.selectedModules.indexOf(module.id) > -1 )
            { // deleting module
            	if(!vm.addOrg){
					vm.isloading = true;
            		organizationservice.deleteSelectedModule(vm.organization.hotel_id,module.id)
            		.then(function(response){
						vm.isloading = false;
            			if(response.errorMsg){
            				toastMessage.showSimpleToast(response.errorMsg,'error-toast');
            			}else if(response.success){
							vm.selectedModules.splice(vm.selectedModules.indexOf(module.id), 1);
						}else{
            				toastMessage.showSimpleToast('There was some error in updating permissions.','error-toast');
            			}
            		});
            	}else{
            		vm.selectedModules.splice(vm.selectedModules.indexOf(module.id), 1);
            	}

            }
            else
            { //adding module
            	if(!vm.addOrg){
					vm.isloading = true;
            		organizationservice.addSelectedModule(vm.organization.hotel_id,module.id)
            		.then(function(response){
						vm.isloading = false;
            			if(response.errorMsg){
            				toastMessage.showSimpleToast(response.errorMsg,'error-toast');
            			}else if(response.success){
							vm.selectedModules.push(module.id);
						}else{
            				toastMessage.showSimpleToast('There was some error in updating permissions.','error-toast');
            			}
            		});
            	}else{
            		vm.selectedModules.push(module.id);
            	}
            }
        }
        /**
         * Sselect all contacts
         */
        function selectAllModules()
        {
            if(vm.selectedModules.length!=vm.modulesLength){//SelectAllOption
                vm.allModules=[];
                var webid=vm.organization.hotel_id;
                var k = 0;
                for(var i=0 ; i<vm.modules.length; i++){
                    var module_length = vm.modules[i].length;
                    for(var j=0 ; j<module_length; j++){
                        vm.allModules[k]={hotel_id:webid,action_id:vm.modules[i][j].id};
                        k++;
                    }
                }
                if(!vm.addOrg){
					vm.isloading = true;
                    organizationservice.addAllModule(vm.organization.hotel_id,vm.allModules)
                    .then(function(response){
						vm.isloading = false;
                        if(response.errorMsg){
                            toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                        }else if(response.success){
                            vm.selectedModules=[];
                            for(var i=0 ; i<vm.modules.length; i++){
                                var module_length = vm.modules[i].length;
                                for(var j=0 ; j<module_length; j++){
                                    vm.selectedModules.push(vm.modules[i][j].id);
                                }
                            }
                        }else{
							toastMessage.showSimpleToast('There was some error in updating permissions.','error-toast');
						}
                    });
                }else{
                    vm.selectedModules=[];
					for(var i=0 ; i<vm.modules.length; i++){
						var module_length = vm.modules[i].length;
						for(var j=0 ; j<module_length; j++){
							vm.selectedModules.push(vm.modules[i][j].id);
						}
					}
                }

            }else{//DeSelectAllOption
                vm.allModules=[];
                for(var i=0 ; i<vm.modules.length; i++){
                    var module_length = vm.modules[i].length;
                    for(var j=0 ; j<module_length; j++){
                        vm.allModules.push(vm.modules[i][j].id);
                    }
                }
                if(!vm.addOrg){
					vm.isloading = true;
                    organizationservice.deleteAllModule(vm.organization.hotel_id,vm.allModules)
                    .then(function(response){
						vm.isloading = false;
                        if(response.errorMsg){
                            toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                        }else if(response.success){
                            vm.selectedModules=[];
                        }else{
							toastMessage.showSimpleToast('There was some error in updating permissions.','error-toast');
						}
                    });
                } else {
                    vm.selectedModules=[];
                }
            }

        }
		/**
		 * check if unique name
		 */
		function uniqueOrgName(value,column){
			if(!vm.addOrg){
				saveOrganization();
			}else{
				if(value){
					vm.orgInfo = {'value':value,'column':column,'hotel_id':vm.organization.hotel_id};
					organizationservice.checkUnique(vm.orgInfo).then(function(response){
						if(response.success === true){//error is there
							vm.uniqueError = true;
							vm.uniqueName = true;
						}else{
							vm.uniqueError 	= false;
							vm.uniqueName = false;

						}
					});
				}
			}
		}

		/**
		 * check if unique code
		 */
		vm.uniqueOrgCOde = uniqueOrgCOde;

		function uniqueOrgCOde(value,column){
			if(!vm.addOrg){
				saveOrganization();
			}else{
				if(value){
					vm.orgInfo = {'value':value,'column':column,'hotel_id':vm.organization.hotel_id};
					organizationservice.checkUnique(vm.orgInfo).then(function(response){
						if(response.success === true){//error is there
							vm.uniqueCode = true;
							vm.uniqueCode = true;
						}else{
							vm.uniqueCode 	= false;
							vm.uniqueCode = false;

						}
					});
				}
			}
		}
		function checkifRoomUnique(){
			var allrooms = [];
			for(var i=0;i<vm.totalRooms.length;i++){
				if(allrooms.indexOf(vm.totalRooms[i].room_no)==-1){
					allrooms.push(vm.totalRooms[i].room_no);
				}else{
					toastMessage.showSimpleToast($translate.instant('CREATE_RES.DUPLICATE_ROOM_NO'), 'error-toast');
					return false;
				}

			}
			return true;
		}
		function editRoomNames(key){
			if(vm.totalRooms[key].room_no!='' && vm.totalRooms[key].room_no!=undefined){
				vm.isloading = true;
				organizationservice.addSingleRoom({id:vm.totalRooms[key].id,room_no:vm.totalRooms[key].room_no,hotel_id:vm.organization.hotel_id}).then(function(resposen){
					vm.isloading = false;
					if(resposen.uniqueError){
						vm.uniqueRoomNameError[key] = true;
					}else if(!resposen.success){
						vm.uniqueRoomNameError[key] = false;
						toastMessage.showSimpleToast('There was some error in updating hotel rooms.','error-toast');
					}else if(resposen.success){
						vm.uniqueRoomNameError[key] = false;
						vm.totalRooms[key].adding_new = false;
						if(vm.totalRooms[key].id=='' || !vm.totalRooms[key].id){
							vm.totalRooms[key].room_status = 1;
						}
						vm.totalRooms[key].id = resposen.id;
					}
				});
			}
		}

		/**
		*Check Duplicate Boat Numbers Start
		*/

		vm.editBoatNames = editBoatNames;
		function editBoatNames(key){
			if(vm.totalBoats[key].boat_no!='' && vm.totalBoats[key].boat_no!=undefined){
				console.log(vm.totalBoats[key]);
				vm.isloading = true;
				organizationservice.addUpdateSingleBoat({id:vm.totalBoats[key].id,boat_no:vm.totalBoats[key].boat_no,hotel_id:vm.organization.hotel_id}).then(function(resposen){
					vm.isloading = false;
					if(resposen.uniqueError){
						vm.uniqueBoatNameError[key] = true;
					}else if(!resposen.success){
						vm.uniqueBoatNameError[key] = false;
						toastMessage.showSimpleToast('There was some error in updating hotel rooms.','error-toast');
					}else if(resposen.success){
						vm.uniqueBoatNameError[key] = false;
						vm.totalBoats[key].adding_new = false;
						if(vm.totalBoats[key].id=='' || !vm.totalBoats[key].id){
							vm.totalBoats[key].boat_status = 1;
						}
						vm.totalBoats[key].id = resposen.id;
					}
				});
			}
		}

		/**
		*Check Duplicate Boat Numbers End
		*/

		/**
		*change boat status
		*/
		vm.changeBoatStatus = changeBoatStatus;
		function changeBoatStatus(id,key,status){
			if(status==true || status==1){
				status = 0
			}else{
				status = 1;
			}
			vm.isloading = true;

			console.log("key = ", key);
			console.log("total = ", vm.totalBoats);
			organizationservice.changeStatusBoat({id:id,boat_status:status,boat_no:vm.totalBoats[key].boat_no}).then(function(resposen){
				vm.isloading = false;
				if(resposen.errorMsg){
					toastMessage.showSimpleToast(resposen.errorMsg,'error-toast');
				}else if(!resposen.success){
					toastMessage.showSimpleToast('There was some error in updating hotel rooms.','error-toast');
				}else if(resposen.success){
					vm.totalBoats[key].boat_status = status;
				}
			});
		}


		/**
		 * Save organization
		 */
		function saveOrganization(){

			// console.log('Boat Number',vm.totalBoats);
			// console.log('Page Status',vm.addOrg);
			// return;
			vm.isloading = true;
			if(!vm.addOrg){
				organizationservice.updateOrganization(vm.organization).then(function(resposen){
					vm.isloading = false;
					if(resposen.errorMsg){
						toastMessage.showSimpleToast(resposen.errorMsg,'error-toast');
					}else if(!resposen.success){
						toastMessage.showSimpleToast('There was some error in updating hotels.','error-toast');
					}else if(resposen.hotelList){
					  $rootScope.hotels = $localStorage.hotels = resposen.hotelList;
				    }
				});
			}else{
				if(vm.parent){
					vm.selectedModules = [];
				}
				organizationservice.updateOrganization(vm.organization,vm.selectedModules,vm.totalRooms, vm.totalBoats).then(function(resposen){
					if(resposen.errorMsg){
						toastMessage.showSimpleToast(resposen.errorMsg,'error-toast');
					}else if(!resposen.success){
						toastMessage.showSimpleToast('There was some error in creating hotel.','error-toast');
					}else if(resposen.success){
						$state.go('app.permissions_organizations');
						if(resposen.hotelList){
							$rootScope.hotels  = $localStorage.hotels     =  resposen.hotelList;
						}
					}
				});
			}

		}

		setTimeout(function() {
           vm.autoFillOff = false;
       	}, 1500); 
	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.permissions.adminusers')
        .service('adminusersservice', adminusersservice);

    /** @ngInject */
    function adminusersservice($http,EnvironmentConfig)
    {
        var service = {
            getallroles: getallroles,
            addUser: addUser,
            updateuser: updateuser,
            deleteuser: deleteuser,
            getuserData: getuserData,
            deleteSelUser: deleteSelUser,
            validateUserEmail: validateUserEmail
        };
        return service;

       	function getDataComplete(response) {
			return response.data;
		}

		function getDataFailed(error) {
			return error.data;
		}
		
		function getallroles(){
			return $http({
				url:EnvironmentConfig.api+'users/list_roles',
				method:'POST',
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function addUser(userParams){
			return $http({
				url:EnvironmentConfig.api+'users/add_user',
				method:'POST',
				data:userParams,
				headers: { 'Content-Type': undefined },
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function updateuser(userParams){
			return $http({
				url:EnvironmentConfig.api+'users/update_user',
				method:'POST',
				data:userParams,
				headers: { 'Content-Type': undefined },
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function deleteuser(userParams){
			return $http({
				url:EnvironmentConfig.api+'users/delete_user',
				method:'POST',
				data:userParams
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function deleteSelUser(deluserParams){
			return $http({
				url:EnvironmentConfig.api+'users/delete_user',
				method:'POST',
				data:deluserParams
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function getuserData(user_id,selected_hotel_id){
			return $http({
				url:EnvironmentConfig.api+'users/skipAcl_getuserData',
				method:'POST',
				data:{user_id:user_id,hotel_id:selected_hotel_id}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function validateUserEmail(email,user_id){
	 		return $http({
	 			url:EnvironmentConfig.api+'users/skipAcl_checkifuserexists',
	 			method:'POST',
	 			data: {'value':email, 'user_id':user_id}
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}
    }
})();


(function() {
    'use strict';

    angular
        .module('app.permissions.adminusers')
        .controller('AdminusersController', AdminusersController);

    /** @ngInject */
    function AdminusersController(
        $scope, 
        $mdSidenav, 
        msUtils, 
        $mdDialog, 
        $document, 
        adminusersservice, 
        toastMessage, 
        $localStorage, 
        $http, 
        EnvironmentConfig, 
        $stateParams, 
        $state, 
        commonService, 
        $sessionStorage,
        $rootScope,
        $q
        ){
        var vm = this;
        //vm.roles=Roles.allRoles;

        if(!$rootScope.backButtonPressed){
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = {};
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] = 1;
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'] = 50;
        }
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'name';
        vm.listOrderAsc = false;
        vm.selectedAdminusers = [];
        vm.selectedusersOnlyId = [];
        vm.tempUsers = [];
        vm.hotel_id = $stateParams.hotel_id;
        vm.selectedUserId = [];
        vm.selectedUserId = [];
        vm.checkDelete = false;
        vm.requestGoing = false;
        vm.page = 1;
        vm.pageSize = 1;
        vm.gotorolesusers = gotorolesusers;
        vm.gotoadduser = commonService.gotoadduser;

        /*Start*/
        $scope.paginatorCallback = paginatorCallback;
        $scope.LoadAllData = LoadAllData;
        $scope.getLoadResultsCallback = getLoadResultsCallback;
        $scope.statusValuesCallback = statusValuesCallback;
        $scope.statusValuesTransformer = statusValuesTransformer;
        $scope.defaultStatusFilter = {name: 'Active', fieldValue: 'status'};

        function statusValuesCallback(){
            return $q.resolve([
                {name: 'All', fieldValue: 'status'},
                $scope.defaultStatusFilter,
                {name: 'Inactive', fieldValue: 'status'}
            ]);
        }
        function statusValuesTransformer(statusObject){
            return statusObject.name;
        }

        $scope.selectedRowCallback = function(rows) {
            vm.selectedUserId = rows;
        };

        $scope.deleteSelectedItem = function(ev) {            

             // new
              var html ='Are you sure, you want to delete the selected user(s)?</br>';
              html = html +'<b>' + vm.selectedUserId.length + ' user(s)</b>' + ' will be deleted.';
                
                  $mdDialog.show({
                                controller: 'confirmController',
                                controllerAs: 'vm',
                                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                                parent: angular.element(document.body),
                                targetEvent: event,
                                clickOutsideToClose:true ,
                                locals: {
                                      title: 'Delete User',
                                      htmlContent:html,
                                      cancelBtn:'Cancel',
                                      OkBtn:'Ok'
                                  }                
                              })
                              .then(function(answer) {
                                 if(typeof answer != 'undefined' && answer == 'update'){
                               adminusersservice.deleteSelUser(vm.selectedUserId)
                                    .then(function(response) {
                                        if (response.errorMsg) {
                                            toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                                        } else {
                                            vm.selectedAdminusers.forEach(function(adminuser) {
                                                deleteAdminuser(adminuser);
                                            });
                                            loadPageCallbackWithDebounce();
                                            vm.selectedUserId = [];

                                        }
                                    });
                               }
                              }, function() {}); 
            //Old

        }


        var loadPageCallbackWithDebounce;

        $scope.$watch('filterText', function() {

            if (loadPageCallbackWithDebounce) {
                loadPageCallbackWithDebounce();
            }
        });
        $scope.showTabDialog = function(ev, id) {
            roleService.getRolePermissions(id).then(function(response) {
                if (response.listData.length == 0) {
                    toastMessage.showSimpleToast('This role has no module assigned.', 'error-toast');
                } else {
                    $state.go('app.rolesPermission', {
                        id: id
                    });

                }
            });
        };
        $scope.updateTable = function() {
            loadPageCallbackWithDebounce();

        };
        $scope.goToEditPage = function(value) {
            if ($scope.userPermissions.indexOf('update_user') != -1) {
                $state.go("app.user_detail_edit", {
                    user_id: value
                });
            }
        };

        $scope.toggleAll = function() {
            var toggleStatus = !$scope.isAllSelected;
            $scope.ChangeAll = toggleStatus;

        }


        $scope.checkBox = function(value) {
            if (vm.selectedUserId.indexOf(value) > -1) {
                vm.selectedUserId.splice(vm.selectedUserId.indexOf(value), 1);
            } else {
                vm.selectedUserId.push(value);
            }
            if (vm.selectedUserId.length > 0) {
                vm.getNumberOfSelectedRows = vm.selectedUserId.length;
                vm.checkDelete = true;
            } else {
                vm.checkDelete = false;
            }
        };

        /**
         * Save user
         */
        function upload(file) {
            if (file) {
                vm.imageStatus = false;
            }
        }

        function saveUser() {
            var fd = new FormData();
            var tempObj = JSON.stringify(vm.adminuser);
            fd.append('file', vm.pictures);
            fd.append('data', tempObj);

            vm.adminuser.password = vm.password;
            adminusersservice.updateuser(fd)
                .then(function(response) {
                    if (response.error) {
                        if (response.errorType == 'image') {
                            vm.pictures = null;
                            vm.imageStatus = true;
                            vm.file = null;
                        }
                        toastMessage.showSimpleToast(response.msg, 'error-toast');
                    } else if (response.success) {
                        toastMessage.showSimpleToast('User has been updated successfully', 'success-toast');
                        $scope.updateTable();
                        closeDialog();
                    } else {
                        toastMessage.showSimpleToast('There was some error in updating user.', 'error-toast');
                    }
                });
        }

        function getLoadResultsCallback(loadPageCallback) {
            loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
        }
        vm.UserColumns = ['common_name', 'email', 'role_name', 'last_login_at', 'status', 'EditId'];

        vm.onLoad = true;
        function paginatorCallback(page, pageSize, option) {
			if(vm.requestGoing) return;
            if(vm.onLoad == true){
                if(typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] != 'undefined'){

                    var page1 =  $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
                    var pageSize1 = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'];
                    vm.onLoad = false;
                    return LoadAllData(page1, pageSize1,option);
                }else{
                    vm.onLoad = false;
                    return LoadAllData(page, pageSize,option);      
                }
            }else{
                if(typeof page == 'undefined'){
                    page = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
                }
                return LoadAllData(page, pageSize,option);
            }
        }
        /*End*/

        function LoadAllData(page, pageSize,option){
            
            vm.requestGoing = true;
            var pageDetail = {'currentPage':page,'pageSize':pageSize};
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = pageDetail; 


            if (!page) {
                page = vm.page;
            } else {
                vm.page = page;
            }

            vm.checkDelete = false;
            vm.selectedUserId = [];
            var sort = {};
            for (var i = 0; i < option.columnSort.length; i++) {
                if (option.columnSort[i]['sort']) {
                    sort['column'] = vm.UserColumns[i];
                    sort['order'] = option.columnSort[i]['sort'];
                }
            }
            var offset = (page - 1) * pageSize;
            var query = $scope.filterText ? $scope.filterText : '';
            // status column filter: Active is pre-applied on load, nothing applied (after Clear) means all
            var statusFilter = option.columnFilter && option.columnFilter[4] && option.columnFilter[4].length ? option.columnFilter[4][0].name : 'All';
            var filterData = {
                'offset': offset,
                'pageSize': pageSize,
                'search': $scope.filterText,
                'sort': sort,
                'status': statusFilter == 'Active' ? 1 : (statusFilter == 'Inactive' ? 0 : ''),
                'selectedHotel': $localStorage.hotels[$localStorage.selectedHotel].hotel_id
            };
            if (vm.hotel_id) {
                filterData.hotel_id = vm.hotel_id;
            }
            return $http({
                url: EnvironmentConfig.api + 'users/users',
                method: 'POST',
                data: filterData
            }).then(function(result) {
                vm.requestGoing = false;
                vm.tempUsers = result.data['allUsers'];
                vm.Adminusers = result.data['allUsers'];
                vm.totalUsers = result.data['totalUser'];
                return {
                    results: result.data['allUsers'],
                    totalResultCount: result.data['totalUser']
                }
            });
        }

        $scope.userPermissions = $rootScope.userPermissions;
        if ($scope.userPermissions.indexOf('delete_user') != -1) {
            $scope.isDeletedAllowed = true;
        } else {
            $scope.isDeletedAllowed = false;
        }
        // Methods
        vm.getStatusClass = getStatusClass;
        vm.filterChange = filterChange;
        vm.toggleSelectUser = toggleSelectUser;
        vm.deselectUsers = deselectUsers;
        vm.selectAllUsers = selectAllUsers;
        vm.deleteAdminuser = deleteAdminuser;
        vm.addNewGroup = addNewGroup;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        function getStatusClass(statusid) {
            if (statusid == 1) {
                return 'status md-green-500-bg white-fg';
            } else {
                return 'status md-red-500-bg white-fg';
            }
        }

        function getStatusName(statusid) {
            if (statusid == 1) {
                return 'Active';
            } else {
                return 'Inactive';
            }
        }
        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type) {

            vm.listType = type;

            if (type === 'all') {
                vm.filterIds = null;
            } else if (type === 'frequent') {
                vm.filterIds = vm.user.frequentContacts;
            } else if (type === 'starred') {
                vm.filterIds = vm.user.starred;
            } else if (angular.isObject(type)) {
                vm.filterIds = type.contactIds;
            }

            vm.selectedAdminusers = [];
            vm.selectedusersOnlyId = [];

        }




        /**
         * Delete User
         */
        function deleteAdminuser(adminuser) {
            vm.adminusers.splice(vm.adminusers.indexOf(adminuser), 1);
        }



        /**
         * Toggle selected status of the contact
         *
         * @param user
         * @param event
         */

        function toggleSelectUser(adminuser, event) {

            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedAdminusers.indexOf(adminuser) > -1) {
                vm.selectedAdminusers.splice(vm.selectedAdminusers.indexOf(adminuser), 1);
                vm.selectedusersOnlyId.splice(vm.selectedusersOnlyId.indexOf(adminuser.user_id), 1);
            } else {
                vm.selectedAdminusers.push(adminuser);
                vm.selectedusersOnlyId.push(adminuser.user_id);
            }
        }

        /**
         * Deselect users
         */
        function deselectUsers() {
            vm.selectedAdminusers = [];
            vm.selectedusersOnlyId = [];
        }

        /**
         * Sselect all users
         */
        function selectAllUsers() {

            vm.selectedAdminusers = $scope.filteredContacts;
            vm.selectedusersOnlyId = [];
            for (var i = 0; i < $scope.filteredContacts.length; i++) {
                vm.selectedusersOnlyId.push($scope.filteredContacts[i].user_id);
            }
        }

        /**
         *
         */
        function addNewGroup() {
            if (vm.newGroupName === '') {
                return;
            }

            var newGroup = {
                'id': msUtils.guidGenerator(),
                'name': vm.newGroupName,
                'contactIds': []
            };

            vm.user.groups.push(newGroup);
            vm.newGroupName = '';
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function gotorolesusers() {
            $state.go('app.permissions_rolespermissions');
        }
    }
})();

(function ()
{
    'use strict';

    angular
    .module('app.permissions.adminusers')
    .controller('AdminuserController', AdminuserController)
    .directive('pwCheck', [function () {
		return {
			require: 'ngModel',
			link: function (scope, elem, attrs, ctrl) {
				var firstPassword = '#' + attrs.pwCheck;
				elem.add(firstPassword).on('keyup', function () {
					scope.$apply(function () {
						ctrl.$setValidity('pwmatch', elem.val() === $(firstPassword).val());
					});
				});
			}
		}
	}]);

    /** @ngInject */
    function AdminuserController(EnvironmentConfig, Adminuser, msUtils, adminusersservice, toastMessage, $localStorage, $scope, $stateParams, $state, $timeout, $element, $translate, $rootScope, messageCenterService, $mdDialog, $q)
    {
        var vm = this;
        var messageCenterPhoneSyncPromptOpen = false;
        // Data
        vm.autoFillOff = true;
        vm.isloading = false;
        if(parseInt($stateParams.user_id)>0){
			vm.adminuser = angular.copy(Adminuser.userData[0]);
			vm.newUser = false;
			if(!Adminuser.userData[0] || !Adminuser.userData[0].user_id){
				$state.go('app.permissions_adminusers');
			}
		}else{
			vm.adminuser = {};
			vm.newUser = true;
		}
        vm.roles = Adminuser.allRoles;
        vm.userPermissions = $rootScope.userPermissions;
        if(vm.userPermissions.indexOf('bar') != -1){
            vm.showBarUser = true;
        }else{
            vm.showBarUser = false;
        }
        vm.imageStatus = true;
        vm.previousPicture = '';
        vm.adminuser.bar_user = vm.adminuser.bar_user == 1? true:false;
        if(vm.adminuser && vm.adminuser.profile_pic != null && vm.adminuser.profile_pic.length > 0){
            vm.previousPicture = EnvironmentConfig.api+'assets/uploads/profileimage/'+vm.adminuser.profile_pic;
        } else {
            vm.previousPicture = EnvironmentConfig.api+'assets/uploads/defaultimage/profile.jpg';
        }

        
        // Methods
        vm.addNewUser = addNewUser;
        vm.saveExistingUser = saveExistingUser;
        vm.gotoUsers  = gotoUsers;
        vm.upload = upload;
        vm.updatePhoneWithCountryCode = updatePhoneWithCountryCode;
        vm.canSave = canSave;
        vm.hasUnsavedChanges = hasUnsavedChanges;
        vm.password='';
        vm.file = '';
        vm.searchRole = '';
        vm.clearSearchRole = clearSearchRole;
        vm.profilePicStatus = false;
        vm.validateUserEmail = validateUserEmail;
        vm.disSubmit = true;
        vm.originalPhoneNumber = vm.adminuser.phone_number || '';
        vm.adminuser.passwordConfirm = vm.adminuser.passwordConfirm || '';
        var originalUserState = null;
        captureOriginalUserState();
        //////////
        function normalizeComparableValue(value)
        {
            if (value === true || value === 1 || value === '1') {
                return '1';
            }

            if (value === false || value === 0 || value === '0') {
                return '0';
            }

            if (value === null || value === undefined) {
                return '';
            }

            return String(value).trim();
        }

        function getCurrentPhoneForCompare()
        {
            var inputElement = document.getElementById('adminPhoneNumber');
            if (inputElement) {
                var iti = angular.element(inputElement).data('iti');
                if (iti && iti.isValidNumberPrecise()) {
                    return iti.getNumber() || '';
                }
            }

            return vm.adminuser.phone_number || '';
        }

        function captureOriginalUserState()
        {
            originalUserState = {
                first_name: normalizeComparableValue(vm.adminuser.first_name),
                last_name: normalizeComparableValue(vm.adminuser.last_name),
                email: normalizeComparableValue(vm.adminuser.email),
                role_id: normalizeComparableValue(vm.adminuser.role_id),
                five_digit_code: normalizeComparableValue(vm.adminuser.five_digit_code),
                phone_number: normalizePhoneDigits(vm.adminuser.phone_number || ''),
                bar_user: normalizeComparableValue(vm.adminuser.bar_user),
                status: normalizeComparableValue(vm.adminuser.status)
            };
            vm.originalPhoneNumber = vm.adminuser.phone_number || '';
        }

        function hasUnsavedChanges()
        {
            if (vm.newUser) {
                return true;
            }

            if (!originalUserState) {
                return false;
            }

            if (vm.password || vm.adminuser.passwordConfirm || vm.profilePicStatus) {
                return true;
            }

            var current = {
                first_name: normalizeComparableValue(vm.adminuser.first_name),
                last_name: normalizeComparableValue(vm.adminuser.last_name),
                email: normalizeComparableValue(vm.adminuser.email),
                role_id: normalizeComparableValue(vm.adminuser.role_id),
                five_digit_code: normalizeComparableValue(vm.adminuser.five_digit_code),
                phone_number: normalizePhoneDigits(getCurrentPhoneForCompare()),
                bar_user: normalizeComparableValue(vm.adminuser.bar_user),
                status: normalizeComparableValue(vm.adminuser.status)
            };
            var key;

            for (key in originalUserState) {
                if (Object.prototype.hasOwnProperty.call(originalUserState, key) &&
                    originalUserState[key] !== current[key]) {
                    return true;
                }
            }

            return false;
        }

        function canSave(userForm)
        {
            if (vm.isloading || vm.emailError || !vm.disSubmit) {
                return false;
            }

            if (userForm && userForm.$invalid) {
                return false;
            }

            if (vm.newUser) {
                return !!(userForm && userForm.$dirty);
            }

            return hasUnsavedChanges();
        }
        function validateUserEmail(){
            $timeout(function() {
                if(vm.adminuser.email){
                    adminusersservice.validateUserEmail(vm.adminuser.email, vm.adminuser.user_id)
                    .then(function(response){
                        if(response.error){
                            vm.emailError = 'This email id already registered';
                            vm.disSubmit = false;
                        } else {
                            vm.disSubmit = true;
                            vm.emailError = false;
                        }
                  });
                } else {
                    vm.disSubmit = true;
                    vm.emailError = false;
                }
            },100);
        }

        function applyPhoneNumberFromInput()
        {
            var inputElement = document.getElementById('adminPhoneNumber');
            if (!inputElement) {
                return true;
            }

            var iti = angular.element(inputElement).data('iti');
            if (!iti) {
                return true;
            }

            if (iti.isValidNumberPrecise()) {
                vm.adminuser.phone_number = iti.getNumber();
                return true;
            }

            if (vm.adminuser.phone_number) {
                return false;
            }

            vm.adminuser.phone_number = '';
            return true;
        }
        /**
         * Add new contact
         */
         function addNewUser()
         {
            vm.adminuser.password = vm.password;

            if (!applyPhoneNumberFromInput()) {
                return false;
            }

            var fd = new FormData();
            var tempObj = JSON.stringify(vm.adminuser);

            fd.append('file',vm.file);
            fd.append('data',tempObj);
            vm.isloading = true;
            adminusersservice.addUser(fd)
            .then(function(response){
				vm.isloading = false;

                if(response.duplicateEmail){
                    vm.emailError = true;
                } else if(response.error){
                   toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                   if(response.errorType == 'image'){
                        vm.imageStatus = true;
                        vm.pictures = EnvironmentConfig.api+'assets/uploads/profileimage/profile.jpg';
                        vm.file =null;
                    }
                } else if(response.success){
                    vm.gotoUsers();
                } else{
                    toastMessage.showSimpleToast('There was some error in creating user.','error-toast');
                }
            });
        }

        function saveExistingUser()
        {
            if (vm.newUser || !vm.adminuser.user_id || vm.isloading) {
                return;
            }

            if (!applyPhoneNumberFromInput()) {
                toastMessage.showSimpleToast('Please enter a valid phone number.', 'error-toast');
                return;
            }

            var payload = {
                user_id: vm.adminuser.user_id,
                first_name: vm.adminuser.first_name,
                last_name: vm.adminuser.last_name,
                email: vm.adminuser.email,
                role_id: vm.adminuser.role_id,
                five_digit_code: vm.adminuser.five_digit_code,
                phone_number: vm.adminuser.phone_number || '',
                bar_user: vm.adminuser.bar_user ? 1 : 0,
                status: vm.adminuser.status
            };
            var savedPhone = payload.phone_number;
            var originalPhone = String(vm.originalPhoneNumber || '').trim();
            var phoneChanged = normalizePhoneDigits(savedPhone) !== normalizePhoneDigits(originalPhone) &&
                !!(normalizePhoneDigits(savedPhone) || normalizePhoneDigits(originalPhone));
            var fd = new FormData();

            if (vm.password) {
                payload.password = vm.password;
                payload.passwordConfirm = vm.adminuser.passwordConfirm;
            }

            fd.append('data', JSON.stringify(payload));
            if (vm.profilePicStatus && vm.file) {
                fd.append('file', vm.file);
            }

            vm.isloading = true;
            adminusersservice.updateuser(fd)
            .then(function(response){
                vm.isloading = false;
                vm.emailError = false;

                if(response.duplicateEmail){
                    vm.emailError = true;
                    vm.disSubmit = false;
                    toastMessage.showSimpleToast('This email id already registered', 'error-toast');
                } else if(response.error ){
                    if(response.errorType == 'image'){
                        vm.pictures = null;
                        vm.imageStatus = true;
                        vm.file = null;
                        vm.profilePicStatus = false;
                    }
                    toastMessage.showSimpleToast(response.msg,'error-toast');
                } else if(response.success){
                    if(response.image) {
                        vm.previousPicture = EnvironmentConfig.api+'assets/uploads/profileimage/'+response.image;
                        vm.imageStatus = true;
                        vm.pictures = null;
                        vm.file = null;
                        vm.profilePicStatus = false;
                    }
                    vm.originalPhoneNumber = savedPhone || '';
                    vm.password = '';
                    vm.adminuser.passwordConfirm = '';
                    captureOriginalUserState();
                    toastMessage.showSimpleToast('User updated successfully.', 'success-toast');
                    if (phoneChanged && savedPhone) {
                        maybePromptUpdateMessageCenterStaffPhone(vm.adminuser.user_id, savedPhone);
                    }
                } else{
                    toastMessage.showSimpleToast('There was some error in updating user.','error-toast');
                }
            }, function () {
                vm.isloading = false;
                toastMessage.showSimpleToast('There was some error in updating user.','error-toast');
            });
        }

        function upload(file,errFiles){
            if(file){
                vm.profilePicStatus = true;
				vm.file = file;
                vm.imageStatus= false;
            } else {
                vm.profilePicStatus = false;
                if(errFiles.length > 0) {
                    angular.forEach(errFiles, function (value, index){
                        switch(value.$error) {
                            case 'pattern': vm.fileError = 'FILE_TYPE_NOT_SUPPORTED';
                                break;
                            case 'maxSize': vm.fileError = 'FILE_SIZE_EXCEEDS';
                                break;
                            case 'minWidth' : vm.fileError = 'MIN_SIZE_MESSAGE';
                                break;
                            case 'minHeight' : vm.fileError = 'MIN_SIZE_MESSAGE';
                                break;
                            default: vm.fileError = 'COMMON_IMAGE_MESSAGE';
                        }
                        toastMessage.showSimpleToast($translate.instant('USERS.'+ vm.fileError),'error-toast');
                    });
                }
            }
        }
        function canSyncMessageCenterPhone() {
            var perms = $rootScope.userPermissions || '';

            if (!perms) {
                return false;
            }

            return (
                perms.indexOf('All') !== -1 ||
                perms.indexOf('message_center') !== -1 ||
                perms.indexOf('direct') !== -1
            );
        }

        function normalizePhoneDigits(phone) {
            return String(phone || '').replace(/\D+/g, '');
        }

        function phonesAreSame(phoneA, phoneB) {
            var a = normalizePhoneDigits(phoneA);
            var b = normalizePhoneDigits(phoneB);

            if (!a || !b) {
                return false;
            }

            if (a === b) {
                return true;
            }

            if (a.length >= 10 && b.length >= 10) {
                return a.slice(-10) === b.slice(-10);
            }

            return false;
        }

        function getOpenDirectChatPhones(context) {
            var channels = (context && context.channels) || {};
            var phones = [];
            var keys = ['sms', 'whatsapp'];
            var i;
            var channel;
            var phone;

            for (i = 0; i < keys.length; i++) {
                channel = channels[keys[i]];
                if (!channel || channel.is_closed) {
                    continue;
                }

                phone = String(channel.guest_phone_e164 || '').trim();
                if (phone) {
                    phones.push(phone);
                }
            }

            return phones;
        }

        function updateMessageCenterStaffPhone(staffUserId, staffPhone) {
            return messageCenterService
                .getStaffMessagingContext({
                    staff_user_id: staffUserId
                })
                .then(function (contextResponse) {
                    var confirmationNumber =
                        contextResponse &&
                        contextResponse.success !== false &&
                        contextResponse.data &&
                        contextResponse.data.confirmation_number
                            ? contextResponse.data.confirmation_number
                            : '';

                    if (!confirmationNumber) {
                        return $q.reject();
                    }

                    return messageCenterService.updateGuestPhone({
                        confirmation_number: confirmationNumber,
                        guest_phone: staffPhone
                    });
                })
                .then(function (response) {
                    if (!response || response.success === false) {
                        toastMessage.showSimpleToast(
                            (response && response.message) ||
                                'Unable to update phone in Message Center.',
                            'error-toast'
                        );
                        return $q.reject(response);
                    }

                    toastMessage.showSimpleToast(
                        'Message Center chat phone updated.',
                        'success-toast'
                    );
                    return response;
                });
        }

        function confirmUpdateMessageCenterStaffPhone(chatPhone, newPhone) {
            var html =
                'This staff member has an active Message Center chat on <b>' +
                (chatPhone || '') +
                '</b>.<br/><br/>' +
                'Do you want to update the Message Center chat phone to <b>' +
                (newPhone || '') +
                '</b>?';

            return $mdDialog.show({
                controller: 'confirmController',
                controllerAs: 'vm',
                templateUrl:
                    'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    title: 'Update Message Center phone?',
                    htmlContent: html,
                    cancelBtn: 'No',
                    OkBtn: 'Yes, update'
                }
            });
        }

        function maybePromptUpdateMessageCenterStaffPhone(staffUserId, newPhone) {
            var userId = parseInt(staffUserId, 10);
            var phone = String(newPhone || '').trim();

            if (
                !userId ||
                !phone ||
                !canSyncMessageCenterPhone() ||
                messageCenterPhoneSyncPromptOpen
            ) {
                return;
            }

            messageCenterPhoneSyncPromptOpen = true;

            messageCenterService
                .getStaffMessagingContext({
                    staff_user_id: userId
                })
                .then(function (response) {
                    var context =
                        response && response.success !== false && response.data
                            ? response.data
                            : null;
                    var openPhones = getOpenDirectChatPhones(context);
                    var mismatchedPhone = '';
                    var i;

                    if (!openPhones.length) {
                        return;
                    }

                    for (i = 0; i < openPhones.length; i++) {
                        if (!phonesAreSame(openPhones[i], phone)) {
                            mismatchedPhone = openPhones[i];
                            break;
                        }
                    }

                    if (!mismatchedPhone) {
                        return;
                    }

                    return confirmUpdateMessageCenterStaffPhone(
                        mismatchedPhone,
                        phone
                    ).then(function (answer) {
                        if (answer === 'update') {
                            return updateMessageCenterStaffPhone(userId, phone);
                        }
                    });
                })
                .catch(function () {
                    // Ignore cancel / context failures — user phone already saved.
                })
                .finally(function () {
                    messageCenterPhoneSyncPromptOpen = false;
                });
        }

        /**
        for searching role in dropdown in edit role when roles are greater then 10
        */
        function clearSearchRole() {
            vm.searchRole = '';
        };
        $element.find('.role-srch').on('keydown', function(ev) {
            ev.stopPropagation();
        });
        function gotoUsers(){
			$state.go('app.permissions_adminusers');
		}

        function updatePhoneWithCountryCode(fieldName, $event) {
            var inputName = fieldName;
            var inputElement = document.querySelector('input[name="' + inputName + '"]');
            if (!inputElement) {
                return;
            }
            var iti = angular.element(inputElement).data('iti');
            if (!iti) {
                return;
            }
            var inputValue = inputElement.value.trim();
            var isValid = !inputValue || iti.isValidNumberPrecise();
            
            angular.element(inputElement).toggleClass('ng-invalid', !isValid);
        }
        setTimeout(function() {
           vm.autoFillOff = false;
        }, 1500); 
    }
})();

(function (){
    'use strict';

    angular.module('app.customer-calendar-search',
        []
    ).config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider){
        $stateProvider.state('app.customerCalendarSearch', {
            url    : '/marketing/customer-search',
            title  : 'Customer Search',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/marketing/customer-calendar-search/customer-calendar-search.html',
                    controller : 'CustomerCalendarSearchController as vm'
                }
            },
            permission: 'marketing'
        });

        // Translation part (if translations are used)
        $translatePartialLoaderProvider.addPart('app/main/apps/marketing/customer-calendar-search');
    }

})();

(function () {
  "use strict";

  angular
    .module("app.customer-calendar-search")
    .controller(
      "CustomerCalendarSearchController",
      CustomerCalendarSearchController
    );

  /** @ngInject */
  function CustomerCalendarSearchController(
    $rootScope,
    $window,
    $scope,
    $mdSidenav,
    msUtils,
    $mdDialog,
    $document,
    userService,
    toastMessage,
    $localStorage,
    $http,
    EnvironmentConfig,
    $state,
    $sessionStorage,
    $stateParams,
    $q
  ) {
    var vm = this;
    $scope.stateFilter = { condition: "contains", terms: [] };
    $scope.zipFilter = { condition: "contains", terms: [] };
    $scope.dateRanges = [{ model: { startDate: null, endDate: null } }];
    $scope.loginFilter = "all";
    $scope.tagFilter = [];
    $scope.availableTags = [];

    if (!$rootScope.backButtonPressed) {
      $sessionStorage[
        $state["current"]["name"] + "_" + $localStorage["preHotelId"]
      ] = {};
      $sessionStorage[
        $state["current"]["name"] + "_" + $localStorage["preHotelId"]
      ]["currentPage"] = 1;
      $sessionStorage[
        $state["current"]["name"] + "_" + $localStorage["preHotelId"]
      ]["pageSize"] = 50;
    }
    vm.customerType =
      $stateParams.type != undefined ? $stateParams.type : "normal";
    vm.customerId = [];
    vm.requestGoing = false;
    vm.selectedCustomerId = [];
    vm.checkDelete = false;
    vm.tempselect = true;
    vm.appliedFilters = {
      state: angular.copy($scope.stateFilter),
      zipcode: angular.copy($scope.zipFilter),
      dateRanges: angular.copy($scope.dateRanges),
      loginFilter: angular.copy($scope.loginFilter),
      tags: angular.copy($scope.tagFilter),
    };
    $scope.checkoutValuesCallback = function () {
      return $q.resolve([]);
    };

    /*Start*/
    $scope.paginatorCallback = paginatorCallback;
    $scope.LoadAllData = LoadAllData;
    $scope.getLoadResultsCallback = getLoadResultsCallback;
    vm.applyFilter = applyFilter;
    vm.clearFilter = clearFilter;
    $scope.clearStateFilter = function () {
      clearChipInput("state");
      $scope.stateFilter = { condition: "contains", terms: [] };
    };

    $scope.clearZipFilter = function () {
      clearChipInput("zip");
      $scope.zipFilter = { condition: "contains", terms: [] };
    };
    $scope.addDateRange = function () {
      $scope.dateRanges.push({ model: { startDate: null, endDate: null } });
    };

    $scope.removeDateRange = function (index) {
      $scope.dateRanges.splice(index, 1);
    };

    $scope.clearDateRanges = function () {
      const allEmpty = $scope.dateRanges.every(
        (r) => !r.model.dateStart && !r.model.dateEnd
      );

      if (allEmpty) return;

      $scope.dateRanges = [{ model: { startDate: null, endDate: null } }];
    };

    $scope.hasDateRangeValues = function () {
      return $scope.dateRanges.some(
        (r) => r.model.dateStart || r.model.dateEnd
      );
    };

    $scope.selectedRowCallback = function (rows, id) {
      vm.selectedCustomerId = rows;
    };
    $scope.myRowClickCallback = function (event) {};
    $scope.goToEditPage = function (value) {
      if (vm.userPermissions.indexOf("update_customer") != -1) {
        var stateName =
          vm.customerType == "negotiated"
            ? "app.nego_customer_update"
            : "app.customer_update";
        try {
          var url = $state.href(
            stateName,
            {
              customer_id: value,
              from: "customer-search",
            },
            { absolute: true }
          );
          console.log(url);
          $window.open(url, "_blank");
        } catch (e) {
          $state.go(stateName, { customer_id: value });
        }
      }
    };

    $scope.deleteSelectedItem = function (ev) {
      var html =
        "Are you sure, you want to delete the selected customer(s)?</br>";
      html =
        html +
        "<b>" +
        vm.selectedCustomerId.length +
        " customer(s)</b>" +
        " will be deleted.";

      $mdDialog
        .show({
          controller: "confirmController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/contacts/confirmationPopUp/confirmation.html",
          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: true,
          locals: {
            title:
              vm.selectedCustomerId.length > 1
                ? "Delete Customers"
                : "Delete Customer",
            htmlContent: html,
            cancelBtn: "Cancel",
            OkBtn: "Ok",
          },
        })
        .then(
          function (answer) {
            if (typeof answer != "undefined" && answer == "update") {
              userService
                .deleteSelectedContacts(vm.selectedCustomerId)
                .then(function (response) {
                  if (!response.error) {
                    vm.selectedCustomerId = [];
                    vm.checkDelete = false;
                    loadPageCallbackWithDebounce();
                  } else {
                    toastMessage.showSimpleToast(
                      "Some error occured.Please try again.",
                      "error-toast"
                    );
                  }
                });
            }
          },
          function () {}
        );
    };

    var loadPageCallbackWithDebounce;
    var loadOptionsDebounced = _.debounce(function (text, type, defer) {
      userService.getOptions(text, type).then(function (data) {
        defer.resolve(data);
      }, function () {
        defer.resolve([]);
      });
    }, 300);

    $scope.$watch("filterText", function () {
      if (loadPageCallbackWithDebounce) {
        loadPageCallbackWithDebounce();
      }
    });

    $scope.updateTable = function () {
      loadPageCallbackWithDebounce();
    };

    function getLoadResultsCallback(loadPageCallback) {
      loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
    }
    vm.UserColumns = [
      "first_name",
      "customer_email",
      "phone_number",
      "no_of_stays",
      "address",
      "city",
      "state",
      "country",
      "zip_code",
      "is_active",
      "editCustomerId",
    ];

    vm.onLoad = true;
    function paginatorCallback(page, pageSize, option) {
      if (vm.requestGoing) return;
      if (vm.onLoad == true) {
        if (
          typeof $sessionStorage[
            $state["current"]["name"] + "_" + $localStorage["preHotelId"]
          ] != "undefined" &&
          typeof $sessionStorage[
            $state["current"]["name"] + "_" + $localStorage["preHotelId"]
          ]["currentPage"] != "undefined"
        ) {
          var page1 =
            $sessionStorage[
              $state["current"]["name"] + "_" + $localStorage["preHotelId"]
            ]["currentPage"];
          var pageSize1 =
            $sessionStorage[
              $state["current"]["name"] + "_" + $localStorage["preHotelId"]
            ]["pageSize"];
          vm.onLoad = false;
          return LoadAllData(page1, pageSize1, option);
        } else {
          vm.onLoad = false;
          return LoadAllData(page, pageSize, option);
        }
      } else {
        if (typeof page == "undefined") {
          page =
            $sessionStorage[
              $state["current"]["name"] + "_" + $localStorage["preHotelId"]
            ]["currentPage"];
        }
        return LoadAllData(page, pageSize, option);
      }
    }

    function LoadAllData(page, pageSize, option) {
      vm.requestGoing = true;

      var pageDetail = { currentPage: page, pageSize: pageSize };
      $sessionStorage[
        $state["current"]["name"] + "_" + $localStorage["preHotelId"]
      ] = pageDetail;

      vm.checkDelete = false;
      vm.selectedCustomerId = [];
      if (!page) {
        page = vm.page;
      } else {
        vm.page = page;
      }
      var sort = {};
      for (var i = 0; i < option.columnSort.length; i++) {
        if (option.columnSort[i]["sort"]) {
          sort["column"] = vm.UserColumns[i];
          sort["order"] = option.columnSort[i]["sort"];
        }
      }
      var columnSearch = [];
      if (option && option.columnFilter && option.columnFilter.length) {
        angular.forEach(option.columnFilter, function (filter, key) {
          if (filter && filter.length) {
            var value = filter[0];
            if (value !== "") {
              var fieldName = vm.UserColumns[key];
              if (fieldName && fieldName !== "editCustomerId") {
                columnSearch.push(fieldName + ":" + value);
              }
            }
          }
        });
      }
      var offset = (page - 1) * pageSize;
      var filterData = {
        offset: offset,
        pageSize: pageSize,
        search: $scope.filterText,
        sort: sort,
        selectedHotel:
          $localStorage.hotels[$localStorage.selectedHotel].hotel_id,
        customerType: vm.customerType,
        columnSearch: columnSearch,
        customFilters: {
          state: {
            operator: $scope.stateFilter.condition,
            values: $scope.stateFilter.terms,
          },
          zipcode: {
            operator: $scope.zipFilter.condition,
            values: $scope.zipFilter.terms,
          },
          dateRanges: $scope.dateRanges.map((r) => ({
            from: r.model.dateStart
              ? moment(r.model.dateStart).format("YYYY-MM-DD")
              : null,
            to: r.model.dateEnd
              ? moment(r.model.dateEnd).format("YYYY-MM-DD")
              : null,
          })),
          loginFilter: $scope.loginFilter,
          tags: $scope.tagFilter,
        },
      };

      vm.filterData = angular.copy(filterData);

      return userService
        .fetchAllCustomerList(filterData)
        .then(function (result) {
          vm.contacts = result["customerList"];
          vm.totalCustomers = parseInt(result["totalCustomer"]);
          vm.requestGoing = false;
          return {
            results: vm.contacts,
            totalResultCount: vm.totalCustomers,
          };
        });
    }

    /*End*/
    vm.user = [];
    vm.filterIds = null;
    vm.listType = "all";
    vm.listOrder = "name";
    vm.listOrderAsc = false;
    vm.selectedContacts = [];
    vm.newGroupName = "";
    vm.userPermissions = $rootScope.userPermissions;
    if (vm.userPermissions.indexOf("delete_customer") != -1) {
      $scope.isDeletedAllowed = true;
    } else {
      $scope.isDeletedAllowed = false;
    }
    // Methods
    vm.filterChange = filterChange;
    vm.openContactDialog = openContactDialog;
    vm.deleteContact = deleteContact;
    vm.deleteSelectedContacts = deleteSelectedContacts;
    vm.toggleSelectContact = toggleSelectContact;
    vm.deselectContacts = deselectContacts;
    vm.selectAllContacts = selectAllContacts;
    vm.deleteContact = deleteContact;
    vm.addNewGroup = addNewGroup;
    vm.deleteGroup = deleteGroup;
    vm.toggleSidenav = toggleSidenav;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.exists = msUtils.exists;
    vm.convertdatestring = convertdatestring;
    vm.status = [
      { value: 1, name: "Active" },
      { value: 0, name: "Inactive" },
    ];
    vm.gender = [
      { value: 1, name: "Male" },
      { value: 0, name: "Female" },
    ];

    function convertdatestring(dateString) {
      return new Date(dateString);
    }

    //////////

    function filterChange(type) {
      vm.listType = type;

      if (type === "all") {
        vm.filterIds = null;
      } else if (type === "frequent") {
        vm.filterIds = vm.user.frequentContacts;
      } else if (type === "starred") {
        vm.filterIds = vm.user.starred;
      } else if (angular.isObject(type)) {
        vm.filterIds = type.contactIds;
      }

      vm.selectedContacts = [];
    }

    function openContactDialog(ev, contact) {
      if (
        typeof contact == "undefined" ||
        vm.userPermissions.indexOf("delete_customer") != -1
      ) {
        $mdDialog.show({
          controller: "ContactDialogController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/contacts/dialogs/contact/contact-dialog.html",
          parent: angular.element($document.find("#content-container")),
          targetEvent: ev,
          scope: $scope.$new(),
          clickOutsideToClose: true,
          locals: {
            Contact: contact,
            User: vm.user,
            Contacts: vm.contacts,
          },
        });
        jQuery(".sec-contact-tab").css("display", "none");
        jQuery(".third-contact-tab").css("display", "none");
      }
    }

    function deleteContact(contact) {
      vm.contacts.splice(vm.contacts.indexOf(contact), 1);
    }

    function deleteSelectedContacts(ev) {
      var confirm = $mdDialog
        .confirm()
        .title("Are you sure, you want to delete the selected customer(s)?")
        .htmlContent(
          "<b>" +
            vm.selectedCustomerId.length +
            " customer(s)</b>" +
            " will be deleted."
        )
        .ariaLabel("delete contacts")
        .targetEvent(ev)
        .ok("OK")
        .cancel("CANCEL");

      $mdDialog.show(confirm).then(function () {
        userService
          .deleteSelectedContacts(vm.selectedCustomerId)
          .then(function (response) {
            if (!response.error) {
              vm.selectedCustomerId = [];
              vm.checkDelete = false;
              loadPageCallbackWithDebounce();
            } else {
              toastMessage.showSimpleToast(
                "There was some error in deleting customers.",
                "error-toast"
              );
            }
          });
      });
    }

    function toggleSelectContact(contact, event) {
      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedContacts.indexOf(contact) > -1) {
        vm.selectedContacts.splice(vm.selectedContacts.indexOf(contact), 1);
        vm.customerId.splice(vm.customerId.indexOf(contact.customer_id), 1);
      } else {
        vm.customerId.push(contact.customer_id);
        vm.selectedContacts.push(contact);
      }
    }

    function deselectContacts() {
      vm.selectedContacts = [];
      vm.customerId = [];
    }

    function selectAllContacts() {
      if (vm.checkAll) {
        vm.selectedCustomerId = [];
        vm.customerId = [];
        for (var i = 0; i < vm.contacts.length; i++) {
          vm.selectedCustomerId.push(vm.contacts[i].customer_id);
        }
        vm.deleteCheckbox = true;
      } else {
        vm.deleteCheckbox = false;
        vm.selectedCustomerId = [];
      }
    }

    function addNewGroup() {
      if (vm.newGroupName === "") {
        return;
      }

      var newGroup = {
        id: msUtils.guidGenerator(),
        name: vm.newGroupName,
        contactIds: [],
      };

      vm.user.groups.push(newGroup);
      vm.newGroupName = "";
    }

    function deleteGroup(ev) {
      var group = vm.listType;

      var confirm = $mdDialog
        .confirm()
        .title("Are you sure want to delete the group?")
        .htmlContent("<b>" + group.name + "</b>" + " will be deleted.")
        .ariaLabel("delete group")
        .targetEvent(ev)
        .ok("OK")
        .cancel("CANCEL");

      $mdDialog.show(confirm).then(function () {
        vm.user.groups.splice(vm.user.groups.indexOf(group), 1);
        filterChange("all");
      });
    }

    $scope.clearLoginFilter = function () {
      $scope.loginFilter = "all";
    };

    $scope.clearTagFilter = function () {
      $scope.tagFilter = [];
    };

    $scope.isTagSelected = function (tagId) {
      return $scope.tagFilter.indexOf(tagId) !== -1;
    };

    $scope.toggleTag = function (tagId) {
      var index = $scope.tagFilter.indexOf(tagId);
      if (index === -1) {
        $scope.tagFilter.push(tagId);
      } else {
        $scope.tagFilter.splice(index, 1);
      }
    };

    function loadCustomerTags() {
      userService.getCustomerTagsSearch().then(function (response) {
        if (response && response.success) {
          $scope.availableTags = (response.data || []).map(function (tag) {
            tag.id = parseInt(tag.id, 10);
            return tag;
          });
        } else {
          $scope.availableTags = [];
        }
      }).catch(function () {
        $scope.availableTags = [];
      });
    }

    loadCustomerTags();

    function toggleSidenav(sidenavId) {
      if (!$mdSidenav(sidenavId).isOpen()) {
        setCurrentFilters();
      }
      $mdSidenav(sidenavId).toggle();
    }
    vm.exportData = exportData;
    vm.processingRequest = false;

    function exportData() {
      var customerCount = vm.totalCustomers;
      vm.processingRequest = true;
      vm.csvName = "customers.csv";
      vm.csvHeader = [
        "Name",
        "Email",
        "Phone Number",
        "Address",
        "City",
        "Zip Code",
        "State",
        "Country",
        "No. of Stays",
        "Status",
      ];

      if (vm.selectedCustomerId.length > 0) {
        vm.filterData["customer_id"] = vm.selectedCustomerId;
        vm.filterData["getAllData"] = false;
        customerCount = 50;
      } else {
        delete vm.filterData["customer_id"];
        vm.filterData["getAllData"] = true;
      }

      vm.filterData.customerType = vm.customerType;
      vm.filterData.csv = true;
      var maxRecord = 5000;
      var offset = 0;

      var ilength = customerCount / maxRecord;
      var j = 0;
      for (i = 0; i <= ilength; i++) {
        (function (i) {
          setTimeout(function () {
            vm.filterData.offset = offset;
            vm.filterData.pageSize = maxRecord;
            userService
              .fetchAllCustomerList(vm.filterData)
              .then(function (response) {
                vm.allData =
                  response["customerList"] != undefined
                    ? response["customerList"]
                    : [];
                if (vm.allData.length) {
                  $rootScope.downloadFile(
                    vm.csvHeader,
                    vm.allData,
                    "customers-" + j + ".csv"
                  );
                }
              });
            offset += maxRecord;
            j = j + 1;
          }, 2000 * i);
        })(i);
      }
      if (i >= ilength) {
        vm.processingRequest = false;
      }
    }
    function applyFilter() {
      $mdSidenav("customerCalendarFilter").close();
      forceChipApply($scope.stateFilter.terms, "stateInputBox");
      forceChipApply($scope.zipFilter.terms, "zipInputBox");
      vm.appliedFilters.state = angular.copy($scope.stateFilter);
      vm.appliedFilters.zipcode = angular.copy($scope.zipFilter);
      vm.appliedFilters.dateRanges = angular.copy($scope.dateRanges);
      vm.appliedFilters.loginFilter = angular.copy($scope.loginFilter);
      vm.appliedFilters.tags = angular.copy($scope.tagFilter);
      if (loadPageCallbackWithDebounce) {
        loadPageCallbackWithDebounce();
      }
    }

    function forceChipApply(chipModel, chipInputId) {
      var inputEl = document.querySelector("#" + chipInputId + " input");

      if (!inputEl) return;

      var value = inputEl.value.trim();

      if (value.length > 0) {
        if (chipModel.indexOf(value) === -1) {
          chipModel.push(value);
        }
        inputEl.value = "";
        inputEl.dispatchEvent(new Event("input"));
      }
    }

    function setCurrentFilters() {
      $scope.stateFilter = angular.copy(vm.appliedFilters.state);
      $scope.zipFilter = angular.copy(vm.appliedFilters.zipcode);
      $scope.dateRanges = angular.copy(vm.appliedFilters.dateRanges);
      $scope.loginFilter = angular.copy(vm.appliedFilters.loginFilter);
      $scope.tagFilter = angular.copy(vm.appliedFilters.tags || []);
      clearChipInput("state");
      clearChipInput("zip");
    }

    function clearChipInput(type) {

      if (type === "state") {
        var el = document.querySelector("#stateInputBox input");
        if (el) {
          el.value = '';
          el.dispatchEvent(new Event('input'));
        }
      }

      if (type === "zip") {
        var el = document.querySelector("#zipInputBox input");
        if (el) {
          el.value = '';
          el.dispatchEvent(new Event('input'));
        }
      }
    }

    // Clear all filters
    function clearFilter() {
      $scope.stateFilter = { condition: "contains", terms: [] };
      $scope.zipFilter = { condition: "contains", terms: [] };
      $scope.filterText = "";
      $scope.dateRanges = [{ model: { startDate: null, endDate: null } }];
      $scope.loginFilter = "all";
      $scope.tagFilter = [];

      // Reset applied filters
      vm.appliedFilters = {
        state: angular.copy($scope.stateFilter),
        zipcode: angular.copy($scope.zipFilter),
        dateRanges: angular.copy($scope.dateRanges),
        loginFilter: angular.copy($scope.loginFilter),
        tags: angular.copy($scope.tagFilter),
      };

      $mdSidenav("customerCalendarFilter").close();

      if (loadPageCallbackWithDebounce) {
        loadPageCallbackWithDebounce();
      }
    }
    $scope.getDateRangeCount = function () {
      return $scope.dateRanges.filter(
        (r) =>
          r.model.startDate ||
          r.model.endDate ||
          r.model.dateStart ||
          r.model.dateEnd
      ).length;
    };
    $scope.getTotalFilters = function () {
      let count = 0;
      count += vm.appliedFilters.state.terms.length ? 1 : 0;
      count += vm.appliedFilters.zipcode.terms.length ? 1 : 0;
      count += vm.appliedFilters.dateRanges.filter(
        (r) =>
          r.model.startDate ||
          r.model.endDate ||
          r.model.dateStart ||
          r.model.dateEnd
      ).length
        ? 1
        : 0;
      count +=
        vm.appliedFilters.loginFilter && vm.appliedFilters.loginFilter !== "all"
          ? 1
          : 0;
      count += $scope.filterText && $scope.filterText.trim() !== "" ? 1 : 0;
      count += vm.appliedFilters.tags && vm.appliedFilters.tags.length ? 1 : 0;

      return count;
    };

    $scope.canClearAll = function () {
      const hasState =
        $scope.stateFilter &&
        $scope.stateFilter.terms &&
        $scope.stateFilter.terms.length > 0;
      const hasZip =
        $scope.zipFilter &&
        $scope.zipFilter.terms &&
        $scope.zipFilter.terms.length > 0;
      const hasDate = $scope.hasDateRangeValues();
      const hasLogin = $scope.loginFilter && $scope.loginFilter !== "all";
      const hasText = $scope.filterText && $scope.filterText.trim() !== "";
      const appliedHas = $scope.getTotalFilters() > 0;
      const hasTags = $scope.tagFilter && $scope.tagFilter.length > 0;

      return hasState || hasZip || hasDate || hasLogin || hasText || appliedHas || hasTags;
    };

    $scope.options = function (searchText, type) {
      if (!searchText || !searchText.trim()) {
        return [];
      }

      var lowercase = searchText.toLowerCase();

      var defer = $q.defer();

      loadOptionsDebounced(lowercase, type, defer);

      return defer.promise;
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .controller('StaffMessageCenterController', StaffMessageCenterController);

    /**
     * Unified Message Center controller.
     *
     * OTA (Channex) and Direct (Twilio SMS/WhatsApp) conversations for the SAME
     * reservation (matched by confirmation_number) are merged into ONE thread
     * "group". Each group holds an optional `_ota` sub-thread and an optional
     * `_direct` sub-thread. Messages from both providers are interleaved by
     * timestamp in a single chat panel, and replies are routed to whichever
     * channel of the latest message (guest or hotel).
     *
     * Threads without a confirmation_number (OTA inquiries, unmapped SMS) stay
     * standalone single-provider groups.
     *
     * @ngInject
     */
    function StaffMessageCenterController(
        $rootScope,
        $scope,
        $state,
        $stateParams,
        $q,
        $timeout,
        $interval,
        $document,
        $localStorage,
        $mdDialog,
        toastMessage,
        messageCenterService,
        messageCenterComposerSignature,
        eCommerceService,
        otaMessageCenterPubNubService,
        smsMessageCenterPubNubService,
        messageCenterNavBadgeService,
        phoneFormatService
    )
    {
        var vm = this;
        var FALLBACK_POLL_INTERVAL_MS = 60000;
        var fallbackPollTimer = null;
        var pollThreadsInFlight = false;
        var pollMessagesInFlight = false;
        var pendingMessagesRefresh = false;
        var visibilityChangeHandler = null;
        var pubNubConnected = true;
        var removePubNubListener = null;
        var removeSmsPubNubListener = null;
        var pendingConversationSid = '';
        var pendingConfirmation = $stateParams.confirmation_number || '';
        var pendingDeepLinkFetch = '';
        var useUnifiedApi = true;
        var searchDebounce = null;
        // In-memory only: per-thread composer drafts (text + image). Cleared on refresh.
        var composerDrafts = {};
        var threadListRequestId = 0;

        vm.activeTab = resolveInitialTab();
        vm.threads = [];
        vm._allUnifiedThreads = [];
        vm.otaThreads = [];
        vm.smsThreads = [];
        vm.messages = [];
        vm.selectedThread = null;
        vm.selectedKey = '';
        vm.subHotelId = '';
        vm.subHotels = $rootScope.subHotels || [];
        vm.isParent = false;
        vm.loadingThreads = false;
        vm.loadingMessages = false;
        vm.sendingMessage = false;
        vm.replyText = '';
        vm.pendingMedia = null;
        vm.uploadingMedia = false;
        vm.composerDragOver = false;
        vm.composerChannel = 'sms';
        vm.channelOptions = [];
        vm.threadLimit = 20;
        vm.threadPage = 1;
        vm.threadTotal = 0;
        vm.otaPage = 1;
        vm.otaTotal = 0;
        vm.smsPage = 1;
        vm.smsHasMore = false;
        vm.otaEnabled = false;
        vm.smsEnabled = false;
        vm.whatsappEnabled = false;
        vm.channelFlagsReady = false;
        vm.messageLimit = 50;
        vm.msgPage = 1;
        vm.msgTotal = 0;
        // Per-provider message pagination for the open group (legacy fallback).
        vm.msgOta = { page: 1, total: 0 };
        vm.msgDirect = { page: 1, hasMore: false };
        vm.threadErrors = [];
        vm.messageStayDates = null;
        vm.reservationStayDates = null;
        vm.showLoadEarlier = false;
        vm.searchQuery = '';
        vm.editingPhone = false;
        vm.phoneEditValue = '';
        vm.savingPhone = false;
        vm.updatingOptOut = false;
        vm.updatingAiMode = false;
        vm.highlightAiToggle = false;
        vm.localStorageUnavailable = false;
        vm.chatTimezone = '';
        vm.phoneOptions = { customer: '', traveler: '' };
        vm.sendToSource = '';
        vm.sendToCustomPhone = '';
        vm.phoneConflictMessage = '';

        vm.translateLanguages = [];
        vm.translateLanguagesLoaded = false;
        vm.translateLanguagesLoading = false;
        vm.translateLangSearchText = '';
        vm.composerTranslateOpen = false;
        vm.composerTranslateLang = 'en';
        vm.composerTranslating = false;
        vm.replyTranslation = null;

        var messagesScrollHandler = null;
        var threadsScrollHandler = null;
        var translateDocClickHandler = null;
        var translatePopupMessage = null;
        var channelFlagsFromSettings = false;
        var REPLY_TEXTAREA_ID = 'gmc-reply-textarea';
        var REPLY_MAX_LINES = 5;
        var THREAD_SCROLL_LOAD_PX = 120;

        vm.canViewOta = hasOtaPermission('getMessageThreads');
        vm.canViewDirect = hasDirectPermission();
        vm.canGetThreads = vm.canViewOta || vm.canViewDirect;
        vm.canGetMessages = hasOtaPermission('getThreadMessages') || vm.canViewDirect;
        vm.canSendOta = hasOtaPermission('sendThreadMessage');
        vm.canSendDirect = hasDirectPermission();
        vm.canSendMessage = vm.canSendOta || vm.canSendDirect;
        vm.channelFlagsReady = false;

        vm.setTab = setTab;
        vm.showTabs = showTabs;
        vm.showDirectFeatures = showDirectFeatures;
        vm.showOtaFeatures = showOtaFeatures;
        vm.hasAnyChannelEnabled = hasAnyChannelEnabled;
        vm.showGroupMessageTab = showGroupMessageTab;
        vm.loadThreads = loadThreads;
        vm.selectThread = selectThread;
        vm.sendReply = sendReply;
        vm.toggleComposerTranslate = toggleComposerTranslate;
        vm.translateComposerDraft = translateComposerDraft;
        vm.clearReplyTranslation = clearReplyTranslation;
        vm.getLanguageName = getLanguageName;
        vm.filterTranslateLanguages = filterTranslateLanguages;
        vm.clearTranslateLangSearch = clearTranslateLangSearch;
        vm.canTranslateMessage = canTranslateMessage;
        vm.toggleMessageTranslatePanel = toggleMessageTranslatePanel;
        vm.translateMessageBubble = translateMessageBubble;
        vm.toggleMessageOriginal = toggleMessageOriginal;
        vm.getDetectedLanguageLabel = getDetectedLanguageLabel;
        vm.getTranslationBadgeLabel = getTranslationBadgeLabel;
        vm.getMessageLanguageTag = getMessageLanguageTag;
        vm.getSentTranslationLanguageLabel = getSentTranslationLanguageLabel;
        vm.canSendToSelected = canSendToSelected;
        vm.hasSendableContent = hasSendableContent;
        vm.canAttachImage = canAttachImage;
        vm.openImagePicker = openImagePicker;
        vm.clearPendingMedia = clearPendingMedia;
        vm.onComposerDrop = onComposerDrop;
        vm.onImageSelected = onImageSelected;
        vm.getComposerBlockedMessage = getComposerBlockedMessage;
        vm.getActiveSendChannelLabel = getActiveSendChannelLabel;
        vm.onReplyKeydown = onReplyKeydown;
        vm.onReplyFocus = onReplyFocus;
        vm.onReplyTextChange = onReplyTextChange;
        vm.hasComposerBodyForTranslate = hasComposerBodyForTranslate;
        vm.resizeReplyTextarea = resizeReplyTextarea;
        vm.onSubHotelChange = onSubHotelChange;
        vm.loadMoreThreads = loadMoreThreads;
        vm.hasMoreThreads = hasMoreThreads;
        vm.loadMoreMessages = loadMoreMessages;
        vm.getProviderLabel = getProviderLabel;
        vm.getThreadChips = getThreadChips;
        vm.getThreadSourceChip = getThreadSourceChip;
        vm.getThreadTitle = getThreadTitle;
        vm.getThreadSubtitle = getThreadSubtitle;
        vm.getThreadPhone = getThreadPhone;
        vm.formatPhoneNumber = formatPhoneNumber;
        vm.getThreadActivity = getThreadActivity;
        vm.isMergedThread = isMergedThread;
        vm.showMessageChannel = showMessageChannel;
        vm.getMessageChannelLabel = getMessageChannelLabel;
        vm.getMessageChannelClass = getMessageChannelClass;
        vm.formatDate = formatDate;
        vm.formatShortDate = formatShortDate;
        vm.getInquiryDetails = getInquiryDetails;
        vm.getThreadCheckIn = getThreadCheckIn;
        vm.getThreadCheckOut = getThreadCheckOut;
        vm.getDisplayCheckIn = getDisplayCheckIn;
        vm.getDisplayCheckOut = getDisplayCheckOut;
        vm.hasStayDates = hasStayDates;
        vm.formatStayDate = formatStayDate;
        vm.formatStayDateRange = formatStayDateRange;
        vm.hasFormattedStayDate = hasFormattedStayDate;
        vm.hasHeaderStayInfo = hasHeaderStayInfo;
        vm.getStayStatus = getStayStatus;
        vm.getStayStatusLabel = getStayStatusLabel;
        vm.getStayStatusClass = getStayStatusClass;
        vm.openReservation = openReservation;
        vm.openUserDetail = openUserDetail;
        vm.hasUnread = hasUnread;
        vm.getUnreadLabel = getUnreadLabel;
        vm.getGuestUnreadTotal = messageCenterNavBadgeService.getGuestUnreadTotal;
        vm.getStaffUnreadTotal = messageCenterNavBadgeService.getStaffUnreadTotal;
        vm.getMessageText = getMessageText;
        vm.hasMessageMedia = hasMessageMedia;
        vm.getMessageMediaItems = getMessageMediaItems;
        vm.expandMessageMedia = expandMessageMedia;
        vm.retryMessageMedia = expandMessageMedia;
        vm.openMessageMedia = openMessageMedia;
        vm.openPendingMedia = openPendingMedia;
        vm.isPhoneChangeNotice = isPhoneChangeNotice;
        vm.getPhoneChangeNoticeText = getPhoneChangeNoticeText;
        vm.getLastMessageDirectionIcon = getLastMessageDirectionIcon;
        vm.isLastMessageMedia = isLastMessageMedia;
        vm.getThreadPreviewText = getThreadPreviewText;
        vm.getThreadKey = getThreadKey;
        vm.isThreadSelected = isThreadSelected;
        vm.getGuestInitial = getGuestInitial;
        vm.getAvatarStyle = getAvatarStyle;
        vm.getThreadHotelTitle = getThreadHotelTitle;
        vm.getProviderClass = getProviderClass;
        vm.hasMoreMessages = hasMoreMessages;
        vm.goBackToThreads = goBackToThreads;
        vm.openNewStaffConversationDialog = openNewStaffConversationDialog;
        vm.openGroupMessageLogs = openGroupMessageLogs;
        vm.goToInboxTab = goToInboxTab;
        vm.goToGuestGroupMessageTab = goToGuestGroupMessageTab;
        vm.setComposerChannel = setComposerChannel;
        vm.isChannelEnabled = isChannelEnabled;
        vm.getChannelOptions = getChannelOptions;
        vm.startChannelConversation = startChannelConversation;
        vm.beginPhoneEdit = beginPhoneEdit;
        vm.cancelPhoneEdit = cancelPhoneEdit;
        vm.saveGuestPhone = saveGuestPhone;
        vm.updatePhoneWithCountryCode = updatePhoneWithCountryCode;
        vm.isPhoneEditValid = isPhoneEditValid;
        vm.isCustomSendToPhoneValid = isCustomSendToPhoneValid;
        vm.toggleMessagingOptOut = toggleMessagingOptOut;
        vm.isOptedOut = isOptedOut;
        vm.getOptOutBannerText = getOptOutBannerText;
        vm.isStaffInactive = isStaffInactive;
        vm.getInactiveStaffBannerText = getInactiveStaffBannerText;
        vm.isAiModeOn = isAiModeOn;
        vm.toggleAiMode = toggleAiMode;
        vm.isSupportEscalation = isSupportEscalation;
        vm.getRoomLabel = getRoomLabel;
        vm.onSearchChange = onSearchChange;
        vm.clearSearch = clearSearch;
        vm.needsDirectChannelStart = needsDirectChannelStart;
        vm.needsPhonePicker = needsPhonePicker;
        vm.setSendToSource = setSendToSource;
        vm.getSelectedStartPhone = getSelectedStartPhone;

        init();
        startRealtime();

        $scope.$on('messageCenter:openConversation', function (event, params) {
            openConversationFromNav(params || {});
        });

        $scope.$on('$destroy', onDestroy);

        function goToInboxTab()
        {
            $state.go('app.guest-message-center.messages', {
                confirmation_number: null
            });
        }

        function goToGuestGroupMessageTab()
        {
            $state.go('app.guest-message-center.group-messages', {
                confirmation_number: null
            });
        }

        function resolveInitialTab()
        {
            // Staff Broadcast is temporarily disabled — always open staff inbox.
            return 'all';
        }

        function init()
        {
            phoneFormatService.ensureUtilsLoaded();

            if ($state.current && $state.current.name === 'app.guest-message-center.staff-group-messages') {
                $state.go('app.guest-message-center.staff-messages');
                return;
            }

            if ($rootScope.isParent && $rootScope.subHotels && $rootScope.subHotels.length) {
                vm.subHotels = $rootScope.subHotels;
            } else if ($localStorage.hotels && $localStorage.selectedHotel !== undefined) {
                var hotelId = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
                $rootScope.getSubHotels(hotelId, true);
                $scope.$watch(function () {
                    return $rootScope.subHotelsOfSelected;
                }, function (subHotels) {
                    if (subHotels && subHotels.length) {
                        vm.subHotels = subHotels;
                    }
                });
            }

            normalizeActiveTab();
            loadChannelEnabledFlags();
            loadTranslateLanguages();
            bindThreadsScroll();
        }

        function isEnabledFlag(value)
        {
            return value === true || value === 1 || value === '1';
        }

        function applyChannelEnabledFlags(source)
        {
            var settings;
            var changed = false;
            var fromSettings = false;

            if (!source) {
                return false;
            }

            // Prefer settings payload keys, then flat API flags.
            settings = source.settings || source;
            fromSettings = settings.ota_messaging_enabled !== undefined ||
                settings.sms_messaging_enabled !== undefined ||
                settings.whatsapp_messaging_enabled !== undefined;

            if (fromSettings) {
                if (settings.ota_messaging_enabled !== undefined) {
                    vm.otaEnabled = isEnabledFlag(settings.ota_messaging_enabled);
                    changed = true;
                }

                if (settings.sms_messaging_enabled !== undefined) {
                    vm.smsEnabled = isEnabledFlag(settings.sms_messaging_enabled);
                    changed = true;
                }

                if (settings.whatsapp_messaging_enabled !== undefined) {
                    vm.whatsappEnabled = isEnabledFlag(settings.whatsapp_messaging_enabled);
                    changed = true;
                }

                channelFlagsFromSettings = true;
                return changed;
            }

            // Legacy thread/unread payloads only until settings are loaded.
            if (channelFlagsFromSettings) {
                return false;
            }

            if (source.ota_enabled !== undefined) {
                vm.otaEnabled = !!source.ota_enabled;
                changed = true;
            } else if (source.data && source.data.ota_enabled !== undefined) {
                vm.otaEnabled = !!source.data.ota_enabled;
                changed = true;
            }

            if (source.sms_enabled !== undefined) {
                vm.smsEnabled = !!source.sms_enabled;
                changed = true;
            } else if (source.data && source.data.sms_enabled !== undefined) {
                vm.smsEnabled = !!source.data.sms_enabled;
                changed = true;
            }

            if (source.whatsapp_enabled !== undefined) {
                vm.whatsappEnabled = !!source.whatsapp_enabled;
                changed = true;
            } else if (source.data && source.data.whatsapp_enabled !== undefined) {
                vm.whatsappEnabled = !!source.data.whatsapp_enabled;
                changed = true;
            }

            return changed;
        }

        function afterChannelFlagsChanged()
        {
            normalizeActiveTab();

            if (!hasAnyChannelEnabled()) {
                vm.threads = [];
                vm._allUnifiedThreads = [];
                clearChat();
                return;
            }

            if (useUnifiedApi) {
                applyUnifiedTabFilter();
                refreshChannelOptions();
                if (vm.selectedThread) {
                    setDefaultComposerChannel(vm.selectedThread);
                }
            } else {
                rebuildThreadList();
            }
        }

        function loadChannelEnabledFlags()
        {
            if (!vm.canGetThreads) {
                vm.channelFlagsReady = true;
                return;
            }

            messageCenterService.getSettings({}).then(function (response) {
                applyChannelEnabledFlags(response);
            }).finally(function () {
                vm.channelFlagsReady = true;
                afterChannelFlagsChanged();
                loadThreads();
            });
        }

        function permsContains(key)
        {
            var perms = $rootScope.userPermissions || '';
            return !!perms && perms.indexOf(key) !== -1;
        }

        function hasOtaPermission(key)
        {
            return permsContains('All') ||
                permsContains('message_center') ||
                permsContains('ota') ||
                permsContains(key);
        }

        function hasDirectPermission()
        {
            return permsContains('All') ||
                permsContains('message_center') ||
                permsContains('direct');
        }

        function showDirectFeatures()
        {
            return vm.canViewDirect && (vm.smsEnabled || vm.whatsappEnabled);
        }

        function showOtaFeatures()
        {
            return vm.canViewOta && !!vm.otaEnabled;
        }

        function hasAnyChannelEnabled()
        {
            return showOtaFeatures() || showDirectFeatures();
        }

        function showGroupMessageTab()
        {
            // Wait for settings so Group message doesn't flash then disappear.
            return !!vm.channelFlagsReady && showDirectFeatures();
        }

        function isDirectChannelConfigured(channel)
        {
            if (channel === 'sms') {
                return !!vm.smsEnabled;
            }

            if (channel === 'whatsapp') {
                return !!vm.whatsappEnabled;
            }

            return false;
        }

        function canFetchOta()
        {
            return showOtaFeatures();
        }

        function canFetchSms()
        {
            return showDirectFeatures();
        }

        function showTabs()
        {
            return !!vm.canGetThreads && hasAnyChannelEnabled();
        }

        function normalizeActiveTab()
        {
            // Staff Broadcast is temporarily disabled.
            if (vm.activeTab !== 'all') {
                vm.activeTab = 'all';
            }

            if ($state.current && $state.current.name === 'app.guest-message-center.staff-group-messages') {
                $state.go('app.guest-message-center.staff-messages');
            }
        }

        function setTab(tab)
        {
            // Staff Broadcast is temporarily disabled — keep staff inbox only.
            tab = 'all';

            if (vm.activeTab === tab) {
                if ($state.current.name !== 'app.guest-message-center.staff-messages') {
                    $state.go('app.guest-message-center.staff-messages');
                }
                return;
            }

            vm.activeTab = tab;
            clearChat();

            if ($state.current.name !== 'app.guest-message-center.staff-messages') {
                $state.go('app.guest-message-center.staff-messages');
                return;
            }

            vm.threadPage = 1;
            vm.otaPage = 1;
            vm.smsPage = 1;
            vm.threadTotal = 0;
            vm.otaTotal = 0;
            vm.smsHasMore = false;
            vm.threads = [];
            vm._allUnifiedThreads = [];
            vm.otaThreads = [];
            vm.smsThreads = [];
            loadThreads();
            bindThreadsScroll();
        }

		/**
         * @param {Object} [options]
         * @param {boolean} [options.preserveOrder] Keep current relative order from
         *   _allUnifiedThreads instead of re-sorting by activity (avoids list jump
         *   when merely opening a chat refreshes context).
         */
		function applyUnifiedTabFilter(options)
        {
            var source = vm._allUnifiedThreads || [];
            var list = source.filter(threadMatchesTab);

            if (!(options && options.preserveOrder)) {
                list.sort(function (a, b) {
                    return (b._activityTs || 0) - (a._activityTs || 0);
                });
            }

            vm.threads = list;
        }

        /**
         * Move a reservation to the top of the inbox after start / send.
         */
        function promoteThreadToTop(thread)
        {
            if (!thread) {
                return;
            }

            var when = nowUtc();

            thread.last_message_at = when;
            thread._activityRaw = when;
            thread._activityTs = parseTs(when) || Date.now();

            if (useUnifiedApi) {
                upsertUnifiedThread(thread);
            } else {
                rebuildThreadList();
            }
        }

        function onSearchChange()
        {
            if (searchDebounce) {
                $timeout.cancel(searchDebounce);
            }

            searchDebounce = $timeout(function () {
                vm.threadPage = 1;
                loadThreads();
            }, 400);
        }

        function clearSearch()
        {
            if (searchDebounce) {
                $timeout.cancel(searchDebounce);
                searchDebounce = null;
            }

            if (!vm.searchQuery) {
                return;
            }

            vm.searchQuery = '';
            vm.threadPage = 1;
            loadThreads();
        }

        // ---------------------------------------------------------------------
        // Timestamp + message channel helpers
        // API contract: inserted_at / last_message_at are UTC.
        // FE converts UTC → current PC/browser timezone for display.
        // ---------------------------------------------------------------------

        function parseUtcMoment(value)
        {
            if (!value) {
                return null;
            }

            var parsed = moment.utc(value, [moment.ISO_8601, 'YYYY-MM-DD HH:mm:ss'], true);

            if (!parsed.isValid()) {
                parsed = moment.utc(value);
            }

            return parsed.isValid() ? parsed : null;
        }

        function parseTs(value)
        {
            var parsed = parseUtcMoment(value);
            return parsed ? parsed.valueOf() : 0;
        }

        /** Convert API UTC timestamp to the staff PC/browser local timezone. */
        function toLocalMoment(value)
        {
            var parsed = parseUtcMoment(value);
            return parsed ? parsed.clone().local() : null;
        }

        function nowUtc()
        {
            return moment.utc().format('YYYY-MM-DD HH:mm:ss');
        }

        /**
         * Tag messages with their channel, normalize SMS sender ('hotel' -> 'property'
         * so bubble alignment matches OTA), and add sort/dedupe helpers.
         * AI replies keep sender 'ai' for a distinct bubble.
         */
        function normalizeChannelMessages(list, channel)
        {
            list = list || [];

            for (var i = 0; i < list.length; i++) {
                var message = list[i];

                if (message.sender === 'hotel') {
                    message.sender = 'property';
                }

                message.channel = message.channel || channel;
                message._channel = message.channel || channel;
                message._sortTs = parseTs(message.inserted_at);
                message._uid = channel + ':' + (message.id || message.local_id || (message._sortTs + ':' + i));
            }

            return list;
        }

        function getUidMap(messages)
        {
            var map = {};
            var i;

            for (i = 0; i < (messages || []).length; i++) {
                if (messages[i]._uid) {
                    map[messages[i]._uid] = true;
                }
            }

            return map;
        }

        function findExistingMessageIndex(message)
        {
            if (!message) {
                return -1;
            }

            var id = message.id || message.local_id;
            var sid = message.message_sid || '';
            var i;

            if (id) {
                for (i = 0; i < vm.messages.length; i++) {
                    if (String(vm.messages[i].id || vm.messages[i].local_id || '') === String(id)) {
                        return i;
                    }
                    // Sent response may use Channex UUID as id before local id is known.
                    if (sid === '' && String(vm.messages[i].message_sid || '') === String(id)) {
                        return i;
                    }
                }
            }

            if (sid) {
                for (i = 0; i < vm.messages.length; i++) {
                    if (String(vm.messages[i].message_sid || '') === String(sid)) {
                        return i;
                    }
                    if (String(vm.messages[i].id || '') === String(sid)) {
                        return i;
                    }
                }
            }

            if (message._uid) {
                for (i = 0; i < vm.messages.length; i++) {
                    if (vm.messages[i]._uid === message._uid) {
                        return i;
                    }
                }
            }

            return -1;
        }

        function sortMessagesInPlace()
        {
            vm.messages.sort(function (a, b) {
                return (a._sortTs || 0) - (b._sortTs || 0);
            });
        }

        function addMessages(newMessages)
        {
            var existing = getUidMap(vm.messages);
            var added = [];
            var i;

            for (i = 0; i < (newMessages || []).length; i++) {
                var message = newMessages[i];

                if (!message || !message._uid) {
                    continue;
                }

                if (findExistingMessageIndex(message) !== -1 || existing[message._uid]) {
                    continue;
                }

                vm.messages.push(message);
                existing[message._uid] = true;
                added.push(message);
            }

            if (added.length) {
                sortMessagesInPlace();
                preloadVisibleMessageMedia(added);
            }

            return added;
        }

        /**
         * Always place a just-sent staff message at the end of the open chat.
         * Keep API inserted_at (UTC) for the label; only pin _sortTs for order.
         */
        function appendSentMessage(sent)
        {
            if (!sent) {
                return null;
            }

            if (findExistingMessageIndex(sent) !== -1) {
                return null;
            }

            var maxTs = 0;
            var i;

            for (i = 0; i < vm.messages.length; i++) {
                if ((vm.messages[i]._sortTs || 0) > maxTs) {
                    maxTs = vm.messages[i]._sortTs;
                }
            }

            var tz = sent.timezone || getChatTimezone();
            if (tz) {
                sent.timezone = tz;
                vm.chatTimezone = tz;
            }

            // API inserted_at is UTC — never overwrite; fill with UTC now if missing.
            if (!sent.inserted_at) {
                sent.inserted_at = nowUtc();
            }

            sent._sortTs = Math.max(maxTs + 1, Date.now());
            sent._pinnedToEnd = true;

            if (!sent._uid || String(sent._uid).indexOf(':undefined') !== -1 || /:$/.test(String(sent._uid))) {
                sent._uid = (sent._channel || sent.channel || 'x') + ':sent:' + sent._sortTs + ':' + Math.random().toString(36).slice(2, 8);
            }

            vm.messages.push(sent);
            preloadVisibleMessageMedia([sent]);
            return sent;
        }

        function getChatTimezone()
        {
            return (vm.selectedThread && vm.selectedThread.timezone) ||
                vm.chatTimezone ||
                'UTC';
        }

        function countMessagesByChannel(channel)
        {
            var count = 0;
            var i;

            for (i = 0; i < vm.messages.length; i++) {
                if (vm.messages[i]._channel === channel) {
                    count++;
                }
            }

            return count;
        }

        // ---------------------------------------------------------------------
        // Thread grouping (merge by confirmation_number)
        // ---------------------------------------------------------------------

        function buildGroupKey(confirmationNumber, provider, sub)
        {
            if (confirmationNumber) {
                return 'grp-' + confirmationNumber;
            }

            if (provider === 'ota') {
                return 'ota-' + sub;
            }

            return 'direct-' + sub;
        }

        function getThreadKey(thread)
        {
            if (!thread) {
                return '';
            }

            if (thread._key) {
                return thread._key;
            }

            if (thread.confirmation_number) {
                return 'grp-' + thread.confirmation_number;
            }

            if (thread.channels) {
                if (thread.channels.ota && thread.channels.ota.message_thread_id) {
                    return 'ota-' + thread.channels.ota.message_thread_id;
                }

                if (thread.channels.sms && thread.channels.sms.conversation_sid) {
                    return 'direct-' + thread.channels.sms.conversation_sid;
                }

                if (thread.channels.whatsapp && thread.channels.whatsapp.conversation_sid) {
                    return 'direct-' + thread.channels.whatsapp.conversation_sid;
                }
            }

            if (thread._ota) {
                return 'ota-' + thread._ota.thread_id + '-' + (thread._ota.hotel_id || '');
            }

            if (thread._direct) {
                return 'direct-' + (thread._direct.conversation_sid || '');
            }

            return '';
        }

        function isMergedThread(group)
        {
            if (!group) {
                return false;
            }

            if (group.channels) {
                var count = 0;
                if (group.channels.ota) { count++; }
                if (group.channels.sms) { count++; }
                if (group.channels.whatsapp) { count++; }
                return count > 1;
            }

            return !!(group._ota && group._direct);
        }

        function groupHasOta(group)
        {
            return !!(group && ((group.channels && group.channels.ota) || group._ota));
        }

        function groupHasDirect(group)
        {
            return !!(group && (
                (group.channels && (group.channels.sms || group.channels.whatsapp)) ||
                group._direct
            ));
        }

        function threadMatchesTab(group)
        {
            if (!group) {
                return false;
            }

            if (!hasAnyChannelEnabled()) {
                return false;
            }

            var hasOta = groupHasOta(group);
            var hasDirect = groupHasDirect(group);

            // Unmarked rows: only keep when at least one channel is enabled.
            if (!hasOta && !hasDirect) {
                return true;
            }

            return (canFetchOta() && hasOta) || (canFetchSms() && hasDirect);
        }

        function isInHouseThread(group)
        {
            if (!group) {
                return false;
            }

            // In-house = currently checked in only (not Active / upcoming / checked-out).
            return getStayStatus(group) === 'checked-in';
        }

        function finalizeGroup(group)
        {
            var ota = group._ota;
            var dir = group._direct;

            group.confirmation_number = (ota && ota.confirmation_number) ||
                (dir && dir.confirmation_number) ||
                group.confirmation_number || '';

            group.title = (dir && dir.guest_name) ||
                (ota && ota.title) ||
                (dir && (dir.title || dir.guest_phone)) ||
                group.confirmation_number || '';

            group.guest_name = (dir && dir.guest_name) || (ota && ota.title) || '';
            group.guest_phone = (dir && dir.guest_phone) || '';
            group.hotel_id = (ota && ota.hotel_id) || (dir && dir.hotel_id) || null;
            group.hotel_title = (ota && ota.hotel_title) || (dir && dir.hotel_title) || '';
            group.provider = ota ? ota.provider : null;
            group.channel = dir ? dir.channel : null;
            group.ota_id = ota ? ota.ota_id : '';
            group.is_closed = ota ? !!ota.is_closed : false;
            group.thread_id = ota ? ota.thread_id : '';
            group.booking_id = ota ? ota.booking_id : '';

            group.room_stay_from = (ota && ota.room_stay_from) ||
                (dir && dir.checkin_date) ||
                (ota && ota.checkin_date) || '';
            group.room_stay_to = (ota && ota.room_stay_to) ||
                (dir && dir.checkout_date) ||
                (ota && ota.checkout_date) || '';
            group.checkin_date = group.room_stay_from;
            group.checkout_date = group.room_stay_to;
            group.room_stay_status = (ota && ota.room_stay_status) ||
                (dir && dir.room_stay_status) || '';

            group.source_of_creation = extractSourceOfCreation({
                source_of_creation: group.source_of_creation ||
                    (ota && ota.source_of_creation) ||
                    (dir && dir.source_of_creation) ||
                    '',
                room_stays: group.room_stays ||
                    (ota && ota.room_stays) ||
                    (dir && dir.room_stays) ||
                    null,
                room_stay: group.room_stay ||
                    (ota && ota.room_stay) ||
                    (dir && dir.room_stay) ||
                    null,
                _ota: ota,
                _direct: dir
            });

            if (ota && ota.meta) {
                group.meta = ota.meta;
            }

            group.channels = {
                ota: ota ? {
                    channel: 'ota',
                    message_thread_id: ota.thread_id,
                    booking_id: ota.booking_id,
                    is_closed: !!ota.is_closed,
                    unread_count: parseInt(ota.ota_msg_unread_count, 10) || 0
                } : null,
                sms: (dir && dir.channel !== 'whatsapp') ? {
                    channel: 'sms',
                    conversation_sid: dir.conversation_sid,
                    unread_count: parseInt(dir.direct_msg_unread_counter, 10) || 0,
                    guest_phone_e164: dir.guest_phone
                } : null,
                whatsapp: (dir && dir.channel === 'whatsapp') ? {
                    channel: 'whatsapp',
                    conversation_sid: dir.conversation_sid,
                    unread_count: parseInt(dir.direct_msg_unread_counter, 10) || 0,
                    guest_phone_e164: dir.guest_phone
                } : null
            };

            group.messaging_opt_out = !!(dir && dir.messaging_opt_out);
            group.ai_mode = coerceAiMode(
                group.ai_mode != null ? group.ai_mode :
                (dir && dir.ai_mode != null ? dir.ai_mode :
                (ota && ota.ai_mode))
            );
            group.total_unread_count = (parseInt(ota && ota.ota_msg_unread_count, 10) || 0) +
                (parseInt(dir && dir.direct_msg_unread_counter, 10) || 0);
            group.room_number = group.room_number || (dir && dir.room_number) || (ota && ota.room_number) || '';

            // Precompute provider chips so ng-repeat gets a stable array reference
            // (returning a fresh array from a template function triggers infdig).
            group._chips = computeChips(group);

            var otaTs = ota ? parseTs(ota.last_message_received_at || ota.updated_at) : 0;
            var dirTs = dir ? parseTs(dir.date_updated || dir.date_created) : 0;

            if (otaTs >= dirTs) {
                group._activityTs = otaTs;
                group._activityRaw = ota ? (ota.last_message_received_at || ota.updated_at) : '';
                group.last_message = (ota && ota.last_message) || (dir && dir.last_message) || null;
                group._lastChannel = ota ? 'ota' : 'direct';
            } else {
                group._activityTs = dirTs;
                group._activityRaw = dir ? (dir.date_updated || dir.date_created) : '';
                group.last_message = (dir && dir.last_message) || (ota && ota.last_message) || null;
                group._lastChannel = 'direct';
            }

            return group;
        }

        function rebuildThreadList()
        {
            var groups = {};
            var list = [];

            function ensure(key)
            {
                if (!groups[key]) {
                    groups[key] = {
                        _provider: 'group',
                        _key: key,
                        _ota: null,
                        _direct: null,
                        confirmation_number: ''
                    };
                    list.push(groups[key]);
                }

                return groups[key];
            }

            var i;
            var thread;
            var key;

            if (canFetchOta()) {
                for (i = 0; i < vm.otaThreads.length; i++) {
                    thread = vm.otaThreads[i];
                    key = buildGroupKey(thread.confirmation_number, 'ota', thread.thread_id + '-' + (thread.hotel_id || ''));
                    ensure(key)._ota = thread;
                }
            }

            if (canFetchSms()) {
                for (i = 0; i < vm.smsThreads.length; i++) {
                    thread = vm.smsThreads[i];
                    key = buildGroupKey(thread.confirmation_number, 'direct', thread.conversation_sid || '');
                    ensure(key)._direct = thread;
                }
            }

            for (i = 0; i < list.length; i++) {
                finalizeGroup(list[i]);
            }

            list = list.filter(threadMatchesTab);

            list.sort(function (a, b) {
                return b._activityTs - a._activityTs;
            });

            vm.threads = list;

            if (vm.selectedKey) {
                for (i = 0; i < list.length; i++) {
                    if (list[i]._key === vm.selectedKey) {
                        vm.selectedThread = list[i];
                        break;
                    }
                }
            }
        }

        // ---------------------------------------------------------------------
        // Thread fetching
        // ---------------------------------------------------------------------

        function fetchOtaThreads(page, append)
        {
            var params = {
                page: page,
                limit: vm.threadLimit
            };

            if (vm.subHotelId) {
                params.sub_hotel_id = vm.subHotelId;
            }

            return messageCenterService.getMessageThreads(params).then(function (response) {
                if (!response || response.success === false) {
                    vm.threadErrors.push({
                        message: (response && response.message) || 'Unable to load OTA conversations.'
                    });
                    return false;
                }

                var data = response.data || [];

                if (append) {
                    vm.otaThreads = vm.otaThreads.concat(data);
                } else {
                    vm.otaThreads = data;
                }

                vm.otaPage = page;
                vm.otaTotal = (response.meta && response.meta.total) ? response.meta.total : vm.otaThreads.length;
                vm.isParent = vm.isParent || !!(response.meta && response.meta.is_parent);

                if (response.errors && response.errors.length) {
                    vm.threadErrors = vm.threadErrors.concat(response.errors);
                }

                messageCenterNavBadgeService.syncThreadUnreadMap(data);
                return true;
            }, function () {
                vm.threadErrors.push({ message: 'Unable to load OTA conversations.' });
                return false;
            });
        }

        function fetchSmsThreads(page, append)
        {
            var params = {
                page: page,
                limit: vm.threadLimit
            };

            if (vm.subHotelId) {
                params.sub_hotel_id = vm.subHotelId;
            }

            return messageCenterService.getSmsThreads(params).then(function (response) {
                if (!response || response.success === false) {
                    var message = (response && response.message) || 'Unable to load SMS conversations.';

                    if (/not enabled/i.test(message)) {
                        vm.smsEnabled = false;
                        normalizeActiveTab();
                        return false;
                    }

                    vm.threadErrors.push({ message: message });
                    return false;
                }

                var data = response.data || [];

                if (append) {
                    vm.smsThreads = vm.smsThreads.concat(data);
                } else {
                    vm.smsThreads = data;
                }

                vm.smsPage = page;
                vm.smsHasMore = data.length >= vm.threadLimit;
                vm.isParent = vm.isParent || !!(response.meta && response.meta.is_parent);

                messageCenterNavBadgeService.syncDirectThreadUnreadMap(data);
                return true;
            }, function () {
                vm.threadErrors.push({ message: 'Unable to load SMS conversations.' });
                return false;
            });
        }

        function isLocalStorageUnavailable(response)
        {
            var message = (response && response.message) || '';
            return /local message storage is not available/i.test(message);
        }

        function finalizeUnifiedThread(thread)
        {
            thread = thread || {};
            thread.channels = thread.channels || { ota: null, sms: null, whatsapp: null };

            if (thread.channels.ota) {
                thread.channels.ota.message_thread_id = thread.channels.ota.message_thread_id ||
                    thread.channels.ota.thread_external_id;
                thread.thread_id = thread.channels.ota.message_thread_id;
                thread.booking_id = thread.channels.ota.booking_id || thread.booking_id;
                thread.is_closed = !!thread.channels.ota.is_closed;
            }

            // Prefer SMS/WhatsApp thread phone over reservation guest phone for UI.
            thread.reservation_guest_phone = thread.guest_phone || '';
            thread.guest_phone =
                (thread.channels.sms && thread.channels.sms.guest_phone_e164) ||
                (thread.channels.whatsapp && thread.channels.whatsapp.guest_phone_e164) ||
                '';

            thread.room_stay_from = thread.room_stay_from || thread.checkin_date || '';
            thread.room_stay_to = thread.room_stay_to || thread.checkout_date || '';
            thread.checkin_date = thread.checkin_date || thread.room_stay_from;
            thread.checkout_date = thread.checkout_date || thread.room_stay_to;
            thread.source_of_creation = extractSourceOfCreation(thread);
            thread.total_unread_count = parseInt(thread.total_unread_count, 10) || 0;
            thread.ai_mode = coerceAiMode(thread.ai_mode);
            thread.messaging_opt_out = !!thread.messaging_opt_out;
            if (thread.staff_is_active === undefined || thread.staff_is_active === null) {
                thread.staff_is_active = true;
            } else {
                thread.staff_is_active = !(
                    thread.staff_is_active === false ||
                    thread.staff_is_active === 0 ||
                    thread.staff_is_active === '0'
                );
            }

            if (thread.confirmation_number) {
                messageCenterNavBadgeService.setReservationAiModeKnown(
                    thread.confirmation_number,
                    thread.ai_mode
                );
            }

            thread._key = getThreadKey(thread);
            thread._activityTs = parseTs(thread.last_message_at);
            thread._activityRaw = thread.last_message_at || '';
            thread._chips = computeChips(thread);

            // Prefer an API-provided last_message (staff). Guest unified
            // rows usually only have preview fields.
            if (thread.last_message) {
                if (thread.last_is_media_attached || thread.last_message.is_media_attached) {
                    thread.last_is_media_attached = 1;
                    thread.last_message.is_media_attached = 1;
                    thread.last_message.message = normalizeThreadPreviewText(
                        thread.last_message.message,
                        true
                    );
                } else {
                    thread.last_is_media_attached = 0;
                    thread.last_message.is_media_attached = 0;
                }
            } else if (thread.last_message_preview || thread.last_is_media_attached) {
                thread.last_message = {
                    message: normalizeThreadPreviewText(
                        thread.last_message_preview,
                        thread.last_is_media_attached
                    ),
                    sender: normalizeLastSender(thread.last_sender),
                    inserted_at: thread.last_message_at,
                    is_media_attached: thread.last_is_media_attached ? 1 : 0
                };
            }

            return thread;
        }

        function syncUnifiedUnreadMaps(threads)
        {
            var otaSync = [];
            var directSync = [];
            var i;
            var thread;
            var ch;

            for (i = 0; i < (threads || []).length; i++) {
                thread = threads[i];
                ch = thread.channels || {};

                if (ch.ota && ch.ota.message_thread_id) {
                    otaSync.push({
                        thread_id: ch.ota.message_thread_id,
                        ota_msg_unread_count: ch.ota.unread_count || 0
                    });
                }

                if (ch.sms && ch.sms.conversation_sid) {
                    directSync.push({
                        conversation_sid: ch.sms.conversation_sid,
                        direct_msg_unread_counter: ch.sms.unread_count || 0
                    });
                }

                if (ch.whatsapp && ch.whatsapp.conversation_sid) {
                    directSync.push({
                        conversation_sid: ch.whatsapp.conversation_sid,
                        direct_msg_unread_counter: ch.whatsapp.unread_count || 0
                    });
                }
            }

            if (otaSync.length) {
                messageCenterNavBadgeService.syncThreadUnreadMap(otaSync);
            }

            if (directSync.length) {
                messageCenterNavBadgeService.syncDirectThreadUnreadMap(directSync);
            }
        }

        function fetchUnifiedThreads(page, append)
        {
            var params = {
                page: page,
                limit: vm.threadLimit
            };
            var requestId;

            if (vm.subHotelId) {
                params.sub_hotel_id = vm.subHotelId;
            }

            if (vm.searchQuery) {
                params.q = vm.searchQuery;
            }

            // Ignore stale responses when the user types another search quickly.
            if (!append) {
                threadListRequestId += 1;
            }
            requestId = threadListRequestId;

            return messageCenterService.getStaffThreads(params).then(function (response) {
                if (requestId !== threadListRequestId) {
                    return true;
                }

                if (!response || response.success === false) {
                    if (isLocalStorageUnavailable(response)) {
                        useUnifiedApi = false;
                        vm.localStorageUnavailable = true;
                        return false;
                    }

                    // Endpoint missing / unexpected — fall back to legacy.
                    useUnifiedApi = false;
                    return false;
                }

                useUnifiedApi = true;
                vm.localStorageUnavailable = false;

                if (applyChannelEnabledFlags(response)) {
                    normalizeActiveTab();
                }

                if (response.timezone) {
                    vm.chatTimezone = response.timezone;
                }

                var data = (response.data || []).map(finalizeUnifiedThread);
                var selectedConfirmation = vm.selectedThread && vm.selectedThread.confirmation_number;
                var i;

                // Keep the open chat unread-cleared even if the list API is still stale.
                if (selectedConfirmation) {
                    for (i = 0; i < data.length; i++) {
                        if (data[i].confirmation_number === selectedConfirmation) {
                            zeroUnreadPayload(data[i]);
                        }
                    }
                }

                if (append) {
                    var existing = {};
                    var merged = [];
                    var item;
                    var key;
                    var prev = vm._allUnifiedThreads || [];

                    for (i = 0; i < prev.length; i++) {
                        item = prev[i];
                        key = item && item.confirmation_number ? String(item.confirmation_number) : getThreadKey(item);
                        if (!key || existing[key]) {
                            continue;
                        }
                        existing[key] = true;
                        merged.push(item);
                    }

                    for (i = 0; i < data.length; i++) {
                        item = data[i];
                        key = item && item.confirmation_number ? String(item.confirmation_number) : getThreadKey(item);
                        if (!key || existing[key]) {
                            continue;
                        }
                        existing[key] = true;
                        merged.push(item);
                    }

                    vm._allUnifiedThreads = merged;
                } else {
                    vm._allUnifiedThreads = data;
                }

                applyUnifiedTabFilter();
                vm.threadPage = page;
                vm.threadTotal = (response.meta && response.meta.total) ? response.meta.total : vm._allUnifiedThreads.length;
                vm.isParent = vm.isParent || !!(response.meta && response.meta.is_parent);
                syncUnifiedUnreadMaps(data);

                // Reattach selection to the list row so badge state stays in sync.
                if (vm.selectedKey) {
                    for (i = 0; i < (vm.threads || []).length; i++) {
                        if (getThreadKey(vm.threads[i]) === vm.selectedKey) {
                            vm.selectedThread = vm.threads[i];
                            clearLocalUnread(vm.selectedThread);
                            break;
                        }
                    }
                }

                return true;
            }, function () {
                if (requestId !== threadListRequestId) {
                    return true;
                }
                useUnifiedApi = false;
                return false;
            });
        }

        function loadLegacyThreads()
        {
            var promises = [];

            if (canFetchOta()) {
                promises.push(fetchOtaThreads(1, false));
            }

            if (canFetchSms()) {
                promises.push(fetchSmsThreads(1, false));
            }

            if (!promises.length) {
                vm.loadingThreads = false;
                rebuildThreadList();
                return $q.when();
            }

            return $q.all(promises).then(function () {
                vm.loadingThreads = false;
                rebuildThreadList();

                if (!vm.threads.length && !vm.selectedThread) {
                    clearChat();
                }

                autoSelectPendingConversation();
            });
        }

        function loadThreads(options)
        {
            options = options || {};
            vm.loadingThreads = true;
            vm.threadErrors = [];

            if (!vm.canGetThreads || !vm.channelFlagsReady || !hasAnyChannelEnabled()) {
                vm.loadingThreads = false;
                vm.threads = [];
                vm._allUnifiedThreads = [];
                return;
            }

            if (useUnifiedApi) {
                fetchUnifiedThreads(1, false).then(function (ok) {
                    if (ok) {
                        vm.loadingThreads = false;

                        if (!vm.threads.length && !vm.selectedThread) {
                            clearChat();
                        }

                        autoSelectPendingConversation();
                        return;
                    }

                    loadLegacyThreads();
                });
                return;
            }

            loadLegacyThreads();
        }

        /**
         * Find a unified group by confirmation in the loaded list / cache.
         */
        function findGroupByConfirmation(confirmation)
        {
            var i;

            if (!confirmation) {
                return null;
            }

            for (i = 0; i < (vm.threads || []).length; i++) {
                if (vm.threads[i].confirmation_number === confirmation) {
                    return vm.threads[i];
                }
            }

            for (i = 0; i < (vm._allUnifiedThreads || []).length; i++) {
                if (vm._allUnifiedThreads[i].confirmation_number === confirmation) {
                    return vm._allUnifiedThreads[i];
                }
            }

            return null;
        }

        /**
         * Open chat on the right for a confirmation that is not on the current
         * left-panel page. Leaves the thread list / search filter unchanged.
         */
        function openConfirmationOnRightOnly(confirmation)
        {
            var params;

            if (!confirmation || pendingDeepLinkFetch === confirmation) {
                return;
            }

            pendingDeepLinkFetch = confirmation;
            params = { confirmation_number: confirmation };

            if (vm.subHotelId) {
                params.sub_hotel_id = vm.subHotelId;
            }

            messageCenterService.getStaffMessagingContext(params).then(function (response) {
                if (pendingDeepLinkFetch !== confirmation) {
                    return;
                }

                pendingDeepLinkFetch = '';
                pendingConfirmation = '';
                pendingConversationSid = '';

                if (response && response.success !== false && response.data) {
                    selectThread(finalizeUnifiedThread(angular.copy(response.data)));
                }
            }, function () {
                if (pendingDeepLinkFetch === confirmation) {
                    pendingDeepLinkFetch = '';
                }

                pendingConfirmation = '';
            });
        }

        /**
         * After threads load, open deep-linked / toast-target conversation.
         * List stays as-is; missing threads are loaded into the right panel only.
         */
        function autoSelectPendingConversation()
        {
            var group;

            if (!pendingConfirmation && !pendingConversationSid) {
                return;
            }

            if (pendingConfirmation) {
                group = findGroupByConfirmation(pendingConfirmation);

                if (group) {
                    pendingConfirmation = '';
                    pendingConversationSid = '';
                    selectThread(group);
                    return;
                }

                if (useUnifiedApi) {
                    openConfirmationOnRightOnly(pendingConfirmation);
                    return;
                }

                pendingConfirmation = '';
            }

            if (pendingConversationSid) {
                group = findGroupByConversationSid(pendingConversationSid);

                if (group) {
                    pendingConversationSid = '';
                    selectThread(group);
                    return;
                }

                pendingConversationSid = '';
            }
        }

        /**
         * Open a reservation/thread from toast click or deep-link.
         * Prefer list row when present; otherwise load right panel only (no left filter).
         * params: confirmation_number?, conversation_sid?, message_thread_id?
         */
        function openConversationFromNav(params)
        {
            var confirmation = (params && params.confirmation_number) || '';
            var conversationSid = (params && params.conversation_sid) || '';
            var messageThreadId = (params && params.message_thread_id) || '';
            var group = null;
            var i;
            var ch;

            if (!confirmation && !conversationSid && !messageThreadId) {
                return;
            }

            // Leave group-message tab so the conversation panel is visible.
            if (vm.activeTab === 'group_msg') {
                vm.activeTab = 'all';
            }

            if (confirmation) {
                if (isSelectedConfirmation(confirmation)) {
                    scrollMessagesToBottom();
                    return;
                }

                group = findGroupByConfirmation(confirmation);
            }

            if (!group && conversationSid) {
                group = findGroupByConversationSid(conversationSid);
            }

            if (!group && messageThreadId) {
                for (i = 0; i < (vm.threads || []).length; i++) {
                    ch = vm.threads[i].channels || {};
                    if ((ch.ota && ch.ota.message_thread_id === messageThreadId) ||
                        (vm.threads[i]._ota && vm.threads[i]._ota.thread_id === messageThreadId) ||
                        vm.threads[i].thread_id === messageThreadId) {
                        group = vm.threads[i];
                        break;
                    }
                }
            }

            if (group) {
                pendingConfirmation = '';
                pendingConversationSid = '';
                selectThread(group);
                return;
            }

            pendingConfirmation = confirmation || '';
            pendingConversationSid = conversationSid || '';

            // Not in the left list — open on the right without changing the list/search.
            if (confirmation && useUnifiedApi) {
                openConfirmationOnRightOnly(confirmation);
            }
        }

        function hasMoreThreads()
        {
            if (useUnifiedApi) {
                return (vm._allUnifiedThreads || []).length < vm.threadTotal;
            }

            var more = false;

            if (canFetchOta()) {
                more = more || vm.otaThreads.length < vm.otaTotal;
            }

            if (canFetchSms()) {
                more = more || vm.smsHasMore;
            }

            return more;
        }

        function loadMoreThreads()
        {
            if (vm.loadingThreads || !hasMoreThreads()) {
                return;
            }

            vm.loadingThreads = true;

            if (useUnifiedApi) {
                fetchUnifiedThreads(vm.threadPage + 1, true).then(function () {
                    vm.loadingThreads = false;
                });
                return;
            }

            var promises = [];

            if (canFetchOta() && vm.otaThreads.length < vm.otaTotal) {
                promises.push(fetchOtaThreads(vm.otaPage + 1, true));
            }

            if (canFetchSms() && vm.smsHasMore) {
                promises.push(fetchSmsThreads(vm.smsPage + 1, true));
            }

            if (!promises.length) {
                vm.loadingThreads = false;
                return;
            }

            $q.all(promises).then(function () {
                vm.loadingThreads = false;
                rebuildThreadList();
            });
        }

        function isThreadSelected(group)
        {
            return vm.selectedKey && getThreadKey(group) === vm.selectedKey;
        }

        function clearChat()
        {
            if (vm.selectedKey) {
                saveComposerDraft(vm.selectedKey);
            }

            unbindMessagesScroll();
            vm.selectedThread = null;
            vm.selectedKey = '';
            vm.messages = [];
            vm.messageStayDates = null;
            vm.reservationStayDates = null;
            vm.showLoadEarlier = false;
            detachComposerState();
            vm.composerDragOver = false;
            vm.editingPhone = false;
            vm.phoneEditValue = '';
            resetReplyTextareaHeight();
            broadcastActiveConversation(null);
        }

        function saveComposerDraft(key)
        {
            if (!key) {
                return;
            }

            var text = String(vm.replyText || '');
            var hasBody = messageCenterComposerSignature.hasBodyBeyondSignature(text);
            var hasMedia = !!vm.pendingMedia;
            var hasTranslation = !!(vm.replyTranslation && vm.replyTranslation.text);

            if (!hasBody && !hasMedia && !hasTranslation) {
                delete composerDrafts[key];
                return;
            }

            composerDrafts[key] = {
                replyText: text,
                pendingMedia: vm.pendingMedia || null,
                replyTranslation: vm.replyTranslation || null,
                lastComposerBodyForTranslation: vm._lastComposerBodyForTranslation
            };
        }

        function restoreComposerDraft(key)
        {
            var draft = key ? composerDrafts[key] : null;

            if (!draft) {
                detachComposerState();
                return;
            }

            vm.replyText = draft.replyText || '';
            vm.pendingMedia = draft.pendingMedia || null;
            vm.uploadingMedia = !!(vm.pendingMedia && vm.pendingMedia.uploading);
            vm.replyTranslation = draft.replyTranslation || null;
            vm._lastComposerBodyForTranslation = draft.lastComposerBodyForTranslation;
            resetComposerFileInput();
        }

        function clearComposerDraft(key)
        {
            if (!key || !composerDrafts[key]) {
                return;
            }

            var draft = composerDrafts[key];
            var draftMedia = draft && draft.pendingMedia;

            if (draftMedia &&
                draftMedia.previewUrl &&
                draftMedia !== vm.pendingMedia) {
                try {
                    URL.revokeObjectURL(draftMedia.previewUrl);
                } catch (e) {
                    // ignore
                }
            }

            delete composerDrafts[key];
        }

        function detachComposerState()
        {
            vm.replyText = '';
            vm.pendingMedia = null;
            vm.uploadingMedia = false;
            clearReplyTranslation();
            vm._lastComposerBodyForTranslation = undefined;
            resetComposerFileInput();
        }

        function resetComposerFileInput()
        {
            var input = document.getElementById('gmc-staff-attach-image-input');
            if (input) {
                input.value = '';
            }
        }

        function clearComposerAfterSend()
        {
            clearComposerDraft(vm.selectedKey);
            vm.replyText = '';
            clearReplyTranslation();
            clearPendingMedia();
            resetReplyTextareaHeight();
        }

        function findPendingMediaByFile(file)
        {
            if (vm.pendingMedia && vm.pendingMedia.file === file) {
                return vm.pendingMedia;
            }

            var keys = Object.keys(composerDrafts);
            var i;
            var draft;

            for (i = 0; i < keys.length; i++) {
                draft = composerDrafts[keys[i]];
                if (draft && draft.pendingMedia && draft.pendingMedia.file === file) {
                    return draft.pendingMedia;
                }
            }

            return null;
        }

        function goBackToThreads()
        {
            clearChat();
            syncThreadUrlParam(null);
            loadThreads();
        }

        function onSubHotelChange()
        {
            vm.threadPage = 1;
            vm.otaPage = 1;
            vm.smsPage = 1;
            vm.threadTotal = 0;
            vm.otaTotal = 0;
            vm.smsHasMore = false;
            vm.threads = [];
            vm._allUnifiedThreads = [];
            vm.otaThreads = [];
            vm.smsThreads = [];
            clearChat();
            loadThreads();
        }

        // ---------------------------------------------------------------------
        // Unread accounting
        // ---------------------------------------------------------------------

        function getThreadUnreadCount(group)
        {
            if (!group) {
                return 0;
            }

            if (group.total_unread_count !== undefined && group.total_unread_count !== null) {
                var total = parseInt(group.total_unread_count, 10) || 0;

                if (total || !(group._ota || group._direct)) {
                    return total;
                }
            }

            var channels = group.channels || {};
            var fromChannels = 0;

            if (channels.ota) {
                fromChannels += parseInt(channels.ota.unread_count, 10) || 0;
            }

            if (channels.sms) {
                fromChannels += parseInt(channels.sms.unread_count, 10) || 0;
            }

            if (channels.whatsapp) {
                fromChannels += parseInt(channels.whatsapp.unread_count, 10) || 0;
            }

            if (fromChannels) {
                return fromChannels;
            }

            var otaUnread = group._ota ? (parseInt(group._ota.ota_msg_unread_count, 10) || 0) : 0;
            var dirUnread = group._direct ? (parseInt(group._direct.direct_msg_unread_counter, 10) || 0) : 0;

            return otaUnread + dirUnread;
        }

        function clearLocalUnread(group)
        {
            if (!group) {
                return;
            }

            group.total_unread_count = 0;

            if (group.channels) {
                ['ota', 'sms', 'whatsapp'].forEach(function (key) {
                    if (!group.channels[key]) {
                        return;
                    }

                    var prev = parseInt(group.channels[key].unread_count, 10) || 0;

                    if (key === 'ota' && group.channels[key].message_thread_id) {
                        messageCenterNavBadgeService.setThreadUnread(group.channels[key].message_thread_id, 0, prev);
                    } else if (group.channels[key].conversation_sid) {
                        messageCenterNavBadgeService.setDirectThreadUnread(group.channels[key].conversation_sid, 0, prev);
                    }

                    group.channels[key].unread_count = 0;
                });
            }

            if (group._ota) {
                var otaUnread = parseInt(group._ota.ota_msg_unread_count, 10) || 0;

                if (otaUnread > 0) {
                    messageCenterNavBadgeService.setThreadUnread(group._ota.thread_id, 0, otaUnread);
                    group._ota.ota_msg_unread_count = 0;
                }
            }

            if (group._direct) {
                var dirUnread = parseInt(group._direct.direct_msg_unread_counter, 10) || 0;

                if (dirUnread > 0) {
                    messageCenterNavBadgeService.setDirectThreadUnread(group._direct.conversation_sid, 0, dirUnread);
                    group._direct.direct_msg_unread_counter = 0;
                }
            }
        }

        /** Zero unread fields on a thread payload without touching nav badges. */
        function zeroUnreadPayload(thread)
        {
            if (!thread) {
                return thread;
            }

            thread.total_unread_count = 0;

            if (thread.channels) {
                ['ota', 'sms', 'whatsapp'].forEach(function (key) {
                    if (thread.channels[key]) {
                        thread.channels[key].unread_count = 0;
                    }
                });
            }

            if (thread._ota) {
                thread._ota.ota_msg_unread_count = 0;
            }

            if (thread._direct) {
                thread._direct.direct_msg_unread_counter = 0;
            }

            return thread;
        }

        /**
         * Match open/list rows for a PubNub event and patch unread + last preview.
         * Nav totals are owned by messageCenterNavBadgeService.
         */
        function applyPubNubToLocalRows(data, message, defaultSender)
        {
            var conf;
            var sid;
            var otaId;
            var seen = {};
            var groups = [];
            var text = '';
            var when;
            var sender;
            var isMedia = false;
            var i;
            var g;
            var ch;
            var total;
            var n;

            if (!data) {
                return;
            }

            conf = data.confirmation_number || '';
            sid = data.conversation_sid || '';
            otaId = data.message_thread_id || '';

            function push(group)
            {
                var key;

                if (!group) {
                    return;
                }

                key = group.confirmation_number || getThreadKey(group) || '';

                if (!key || seen[key]) {
                    return;
                }

                seen[key] = true;
                groups.push(group);
            }

            if (conf && vm.selectedThread &&
                vm.selectedThread.confirmation_number === conf) {
                push(vm.selectedThread);
            }

            if (conf) {
                push(findGroupByConfirmation(conf));
            }

            if (sid) {
                push(findGroupByConversationSid(sid));
            }

            if (otaId) {
                push(findOtaThread(otaId));
                angular.forEach(vm.threads || [], function (row) {
                    ch = (row && row.channels) || {};

                    if ((ch.ota && ch.ota.message_thread_id === otaId) ||
                        (row._ota && row._ota.thread_id === otaId) ||
                        row.thread_id === otaId) {
                        push(row);
                    }
                });
            }

            if (message && typeof message === 'object') {
                text = message.message || '';
                when = message.inserted_at || nowUtc();
                sender = normalizeLastSender(message.sender || defaultSender || 'property');
                isMedia = !!(message.is_media_attached ||
                    (angular.isArray(message.media) && message.media.length));
            } else if (typeof data.message === 'string') {
                text = data.message;
                when = data.inserted_at || nowUtc();
                sender = normalizeLastSender(defaultSender || data.sender || 'guest');
                isMedia = !!(data.is_media_attached ||
                    (angular.isArray(data.media) && data.media.length));
            }

            if (isMedia) {
                text = normalizeThreadPreviewText(text, true);
            }

            for (i = 0; i < groups.length; i++) {
                g = groups[i];
                ch = g.channels || {};

                if (data.ota_msg_unread_count != null) {
                    n = parseInt(data.ota_msg_unread_count, 10) || 0;

                    if (ch.ota) {
                        ch.ota.unread_count = n;
                    }

                    if (g._ota) {
                        g._ota.ota_msg_unread_count = n;
                    }
                }

                if (data.direct_msg_unread_counter != null) {
                    n = parseInt(data.direct_msg_unread_counter, 10) || 0;
                    angular.forEach(['sms', 'whatsapp'], function (key) {
                        if (ch[key]) {
                            ch[key].unread_count = n;
                        }
                    });

                    if (g._direct) {
                        g._direct.direct_msg_unread_counter = n;
                    }
                }

                total = (ch.ota ? (parseInt(ch.ota.unread_count, 10) || 0) : 0) +
                    (ch.sms ? (parseInt(ch.sms.unread_count, 10) || 0) : 0) +
                    (ch.whatsapp ? (parseInt(ch.whatsapp.unread_count, 10) || 0) : 0);

                if (!total && (g._ota || g._direct)) {
                    total = (g._ota ? (parseInt(g._ota.ota_msg_unread_count, 10) || 0) : 0) +
                        (g._direct ? (parseInt(g._direct.direct_msg_unread_counter, 10) || 0) : 0);
                }

                g.total_unread_count = total;

                if (text || isMedia) {
                    g.last_message = {
                        message: text,
                        sender: sender,
                        inserted_at: when,
                        is_media_attached: isMedia ? 1 : 0
                    };
                    g.last_message_preview = text;
                    g.last_sender = sender;
                    g.last_message_at = when;
                    g.last_is_media_attached = isMedia ? 1 : 0;
                    g._activityRaw = when;
                    g._activityTs = parseTs(when) || Date.now();
                }
            }
        }

        function isAiPubNubSender(data)
        {
            return !!(data && (data.sender === 'ai' ||
                (data.message && data.message.sender === 'ai')));
        }

        function normalizeEventMessage(data, channel)
        {
            if (data && data.message && typeof data.message === 'object') {
                return normalizeChannelMessages([angular.copy(data.message)], channel || 'sms')[0];
            }

            return null;
        }

        function eventTargetsSelected(data)
        {
            if (!data) {
                return false;
            }

            return (data.confirmation_number && isSelectedConfirmation(data.confirmation_number)) ||
                isSelectedSmsThread(data.conversation_sid) ||
                isSelectedOtaThread(data.message_thread_id);
        }

        function withOutboundUnread(data, channel)
        {
            var hasCounter = (channel === 'ota' && data.ota_msg_unread_count != null) ||
                (channel !== 'ota' && data.direct_msg_unread_counter != null);
            var copy;

            if (hasCounter) {
                return data;
            }

            copy = angular.copy(data) || {};

            if (channel === 'ota') {
                copy.ota_msg_unread_count = 0;
            } else {
                copy.direct_msg_unread_counter = 0;
            }

            return copy;
        }

        /** Shared path for staff/AI *_message_sent events. */
        function onOutboundMessageEvent(data, channel)
        {
            var message = normalizeEventMessage(data, channel);
            var isAi = isAiPubNubSender(data) || (message && message.sender === 'ai');
            var isSelected = eventTargetsSelected(data);
            var rowData = withOutboundUnread(data, channel);
            var sender = isAi ? 'ai' : ((message && message.sender) || 'property');

            applyPubNubToLocalRows(rowData, message, sender);

            if (isSelected) {
                if (message) {
                    if (appendSentMessage(message)) {
                        scrollMessagesToBottom();
                    }
                } else {
                    refreshActiveThreadMessages();
                }

                if (useUnifiedApi && data.confirmation_number) {
                    refreshMessagingContext(data.confirmation_number);
                }

                if (vm.selectedThread) {
                    zeroUnreadPayload(vm.selectedThread);
                }

                return;
            }

            if (data.confirmation_number && vm.threadPage === 1 && useUnifiedApi) {
                refreshInboxSilently();
            }
        }

        function markGroupRead(group, force)
        {
            if (!group) {
                return $q.when();
            }

            if (!force && getThreadUnreadCount(group) <= 0) {
                return $q.when();
            }

            clearLocalUnread(group);

            if (useUnifiedApi && group.confirmation_number) {
                var payload = {
                    confirmation_number: group.confirmation_number
                };

                if (vm.subHotelId) {
                    payload.sub_hotel_id = vm.subHotelId;
                }

                return messageCenterService.markUnifiedThreadAsRead(payload).then(function (response) {
                    if (response && response.success === false) {
                        // Soft API failure (e.g. scope check) — fall back so staff unread persists as read.
                        return markStaffChannelsRead(group);
                    }

                    messageCenterNavBadgeService.refresh();
                }, function () {
                    return markStaffChannelsRead(group);
                });
            }

            return markStaffChannelsRead(group);
        }

        /**
         * Mark each SMS/WhatsApp channel read for a staff thread (no OTA on staff inbox).
         */
        function markStaffChannelsRead(group)
        {
            var channels = (group && group.channels) || {};
            var promises = [];
            var key;
            var channel;

            for (key in channels) {
                if (!Object.prototype.hasOwnProperty.call(channels, key)) {
                    continue;
                }

                if (key !== 'sms' && key !== 'whatsapp') {
                    continue;
                }

                channel = channels[key];
                if (!channel || (!channel.conversation_sid && !group.confirmation_number)) {
                    continue;
                }

                promises.push(markDirectThreadRead({
                    conversation_sid: channel.conversation_sid || '',
                    confirmation_number: group.confirmation_number || '',
                    guest_phone: channel.guest_phone_e164 || group.guest_phone || ''
                }));
            }

            if (group && group._direct) {
                promises.push(markDirectThreadRead(group._direct));
            }

            if (!promises.length) {
                return $q.when();
            }

            return $q.all(promises).then(function () {
                messageCenterNavBadgeService.refresh();
            }, function () {
                // Keep local clear even if API fails; next open can retry.
            });
        }

        /**
         * While a chat is open, inbound guest messages still increment server unread.
         * Force mark-as-read even when the local badge was already zeroed.
         *
         * @param {Object} match confirmation_number / conversation_sid / message_thread_id
         * @param {Object} [eventData] optional PubNub payload for nav badge knownPrevious
         */
        function markSelectedThreadRead(match, eventData)
        {
            match = match || {};
            eventData = eventData || {};

            var group = vm.selectedThread;
            var matches = false;
            var channels;
            var knownDirect;
            var knownOta;

            if (!group) {
                return $q.when();
            }

            if (match.confirmation_number && isSelectedConfirmation(match.confirmation_number)) {
                matches = true;
            }

            if (match.conversation_sid && isSelectedSmsThread(match.conversation_sid)) {
                matches = true;
            }

            if (match.message_thread_id && isSelectedOtaThread(match.message_thread_id)) {
                matches = true;
            }

            if (!matches) {
                return $q.when();
            }

            knownDirect = eventData.direct_msg_unread_counter;
            knownOta = eventData.ota_msg_unread_count;
            channels = group.channels || {};

            // Nav badge map may be keyed by conversation_sid OR confirmation_number.
            if (match.conversation_sid) {
                messageCenterNavBadgeService.setDirectThreadUnread(
                    match.conversation_sid, 0, knownDirect
                );
            }

            if (match.confirmation_number || group.confirmation_number) {
                messageCenterNavBadgeService.setDirectThreadUnread(
                    match.confirmation_number || group.confirmation_number, 0, knownDirect
                );
            }

            if (channels.sms && channels.sms.conversation_sid) {
                messageCenterNavBadgeService.setDirectThreadUnread(
                    channels.sms.conversation_sid, 0, knownDirect
                );
            }

            if (channels.whatsapp && channels.whatsapp.conversation_sid) {
                messageCenterNavBadgeService.setDirectThreadUnread(
                    channels.whatsapp.conversation_sid, 0, knownDirect
                );
            }

            if (group._direct && group._direct.conversation_sid) {
                messageCenterNavBadgeService.setDirectThreadUnread(
                    group._direct.conversation_sid, 0, knownDirect
                );
            }

            if (match.message_thread_id) {
                messageCenterNavBadgeService.setThreadUnread(
                    match.message_thread_id, 0, knownOta
                );
            }

            if (channels.ota && channels.ota.message_thread_id) {
                messageCenterNavBadgeService.setThreadUnread(
                    channels.ota.message_thread_id, 0, knownOta
                );
            }

            if (group._ota && group._ota.thread_id) {
                messageCenterNavBadgeService.setThreadUnread(
                    group._ota.thread_id, 0, knownOta
                );
            }

            return markGroupRead(group, true);
        }

        function markOtaThreadRead(otaThread)
        {
            var payloads = [];

            if (otaThread.thread_id) {
                payloads.push({ message_thread_id: otaThread.thread_id });
            }

            if (otaThread.booking_id) {
                payloads.push({ booking_id: otaThread.booking_id });
            }

            if (otaThread.confirmation_number) {
                payloads.push({ confirmation_number: otaThread.confirmation_number });
            }

            if (!payloads.length) {
                return $q.when({ success: false });
            }

            function tryMark(index)
            {
                if (index >= payloads.length) {
                    return $q.when({ success: false });
                }

                return messageCenterService.markThreadAsRead(payloads[index]).then(function (response) {
                    if (response && response.success !== false) {
                        return response;
                    }

                    return tryMark(index + 1);
                });
            }

            return tryMark(0);
        }

        function markDirectThreadRead(directThread)
        {
            var payload = {
                conversation_sid: directThread.conversation_sid || ''
            };

            if (directThread.confirmation_number) {
                payload.confirmation_number = directThread.confirmation_number;
            }

            if (directThread.guest_phone) {
                payload.guest_phone = directThread.guest_phone;
            }

            if (vm.subHotelId) {
                payload.sub_hotel_id = vm.subHotelId;
            }

            return messageCenterService.markSmsThreadAsRead(payload);
        }

        // ---------------------------------------------------------------------
        // Selection + message loading
        // ---------------------------------------------------------------------

        function broadcastActiveConversation(group)
        {
            var ch = (group && group.channels) || {};
            var ota = ch.ota || (group && group._ota) || null;
            var sms = ch.sms || (group && group._sms) || null;

            $rootScope.$broadcast('messageCenter:activeConversation', {
                confirmation_number: (group && group.confirmation_number) || '',
                conversation_sid: (sms && (sms.conversation_sid || sms.sid)) ||
                    (group && group.conversation_sid) || '',
                message_thread_id: (ota && (ota.message_thread_id || ota.thread_id)) ||
                    (group && (group.message_thread_id || group.thread_id)) || ''
            });
        }

        function selectThread(group)
        {
            if (!group) {
                return;
            }

            var nextKey = getThreadKey(group);
            var prevKey = vm.selectedKey;
            var switchingThread = !!(prevKey && nextKey && prevKey !== nextKey);
            var openingThread = !prevKey;

            if (switchingThread) {
                saveComposerDraft(prevKey);
            }

            vm.selectedKey = nextKey;
            vm.selectedThread = group;
            vm.messages = [];
            vm.msgPage = 1;
            vm.msgTotal = 0;
            vm.msgOta = { page: 1, total: 0 };
            vm.msgDirect = { page: 1, hasMore: false };
            vm.messageStayDates = null;
            vm.reservationStayDates = null;
            vm.showLoadEarlier = false;
            vm.editingPhone = false;
            vm.phoneEditValue = '';
            closeComposerTranslate();
            closeMessageTranslatePopup();
            resetPhonePicker();
            unbindMessagesScroll();
            applyThreadStayData(group);
            setDefaultComposerChannel(group);
            syncThreadUrlParam(group);
            broadcastActiveConversation(group);

            if (switchingThread || openingThread) {
                restoreComposerDraft(nextKey);
            }

            var markPromise = getThreadUnreadCount(group) > 0 ? markGroupRead(group) : $q.when();

            loadMessages();

            if (group.confirmation_number) {
                // Wait for mark-as-read so messaging context does not revive the badge.
                markPromise.finally(function () {
                    if (!vm.selectedThread ||
                        vm.selectedThread.confirmation_number !== group.confirmation_number) {
                        return;
                    }

                    refreshMessagingContext(group.confirmation_number);
                });
            }

            if (group.confirmation_number || group.thread_id || group.booking_id) {
                loadReservationStayDates();
            }

            $timeout(function () {
                resizeReplyTextarea();
            });
        }

        function syncThreadUrlParam(group)
        {
            var stateName = ($state.current && $state.current.name) || '';
            var targetConfirmation = group && group.confirmation_number ? group.confirmation_number : null;

            if (stateName !== 'app.guest-message-center.messages' &&
                stateName !== 'app.guest-message-center.staff-messages') {
                return;
            }

            if (($stateParams.confirmation_number || null) === targetConfirmation) {
                return;
            }

            $state.go(stateName, {
                confirmation_number: targetConfirmation
            }, {
                notify: false,
                location: 'replace',
                inherit: true
            });

            $stateParams.confirmation_number = targetConfirmation || '';
        }

        function refreshMessagingContext(confirmationNumber)
        {
            if (!confirmationNumber || !useUnifiedApi) {
                return;
            }

            var params = { confirmation_number: confirmationNumber };

            if (vm.subHotelId) {
                params.sub_hotel_id = vm.subHotelId;
            }

            messageCenterService.getStaffMessagingContext(params).then(function (response) {
                if (!response || response.success === false || !response.data) {
                    return;
                }

                if (!vm.selectedThread || vm.selectedThread.confirmation_number !== confirmationNumber) {
                    return;
                }

                var updated = finalizeUnifiedThread(response.data);
                // Opening a chat must not reshuffle the left list. Keep the inbox
                // activity timestamp from the list row when context omits/blank it.
                var keepActivityAt = vm.selectedThread.last_message_at || vm.selectedThread._activityRaw || '';
                var keepActivityTs = vm.selectedThread._activityTs || 0;
                var keepLastMessage = vm.selectedThread.last_message || null;
                var keepPreview = vm.selectedThread.last_message_preview || '';
                var keepSender = vm.selectedThread.last_sender || '';
                var keepIsMedia = vm.selectedThread.last_is_media_attached ? 1 : 0;

                zeroUnreadPayload(updated);

                if (applyChannelEnabledFlags(response)) {
                    refreshChannelOptions();
                }

                applyPhoneOptions(
                    (response.data && response.data.phone_options) ||
                    response.phone_options ||
                    updated.phone_options
                );

                // Merge channels key-by-key instead of overwriting wholesale — the API
                // response may legitimately omit a channel it doesn't know about right
                // now, and that must not erase a channel we already have locally.
                var mergedChannels = angular.extend({}, vm.selectedThread.channels || {});
                angular.forEach(updated.channels || {}, function (value, key) {
                    if (value) {
                        mergedChannels[key] = value;
                    }
                });

                angular.extend(vm.selectedThread, updated);
                vm.selectedThread.channels = mergedChannels;

                if (!vm.selectedThread.last_message_at && keepActivityAt) {
                    vm.selectedThread.last_message_at = keepActivityAt;
                    vm.selectedThread._activityRaw = keepActivityAt;
                    vm.selectedThread._activityTs = keepActivityTs || parseTs(keepActivityAt);
                    vm.selectedThread.last_message = keepLastMessage || vm.selectedThread.last_message;
                    vm.selectedThread.last_message_preview = keepPreview || vm.selectedThread.last_message_preview;
                    vm.selectedThread.last_sender = keepSender || vm.selectedThread.last_sender;
                    if (keepIsMedia && !vm.selectedThread.last_is_media_attached) {
                        vm.selectedThread.last_is_media_attached = 1;
                    }
                } else {
                    vm.selectedThread._activityTs = parseTs(vm.selectedThread.last_message_at) || keepActivityTs;
                    vm.selectedThread._activityRaw = vm.selectedThread.last_message_at || keepActivityAt;
                }

                vm.selectedThread._chips = computeChips(vm.selectedThread);
                clearLocalUnread(vm.selectedThread);
                // selectedThread is already the same object in _allUnifiedThreads —
                // do not upsert/unshift or the list order jumps on every open.
                setDefaultComposerChannel(vm.selectedThread);
            });
        }

        function applyPhoneOptions(options)
        {
            options = options || {};
            vm.phoneOptions = {
                customer: String(options.customer || '').replace(/^\s+|\s+$/g, ''),
                traveler: String(options.traveler || '').replace(/^\s+|\s+$/g, '')
            };
            resetSendToSelection();
        }

        function resetPhonePicker()
        {
            vm.phoneOptions = { customer: '', traveler: '' };
            vm.sendToSource = '';
            vm.sendToCustomPhone = '';
            vm.phoneConflictMessage = '';
        }

        function resetSendToSelection()
        {
            vm.sendToSource = '';
            vm.sendToCustomPhone = '';
            vm.phoneConflictMessage = '';

            if (vm.phoneOptions.customer && !vm.phoneOptions.traveler) {
                vm.sendToSource = 'customer';
            } else if (vm.phoneOptions.traveler && !vm.phoneOptions.customer) {
                vm.sendToSource = 'traveler';
            }
        }

        function setSendToSource(source)
        {
            vm.sendToSource = source;
            vm.phoneConflictMessage = '';
        }

        function getSelectedStartPhone()
        {
            var existingDirectPhone = getExistingDirectPhone(
                vm.selectedThread,
                vm.composerChannel
            );

            // Keep SMS and WhatsApp on the same number once either channel exists.
            if (existingDirectPhone) {
                return existingDirectPhone;
            }

            if (vm.sendToSource === 'customer') {
                return vm.phoneOptions.customer || '';
            }

            if (vm.sendToSource === 'traveler') {
                return vm.phoneOptions.traveler || '';
            }

            if (vm.sendToSource === 'custom') {
                return phoneFormatService.getValidE164(
                    getCustomSendToInputName(),
                    vm.sendToCustomPhone
                );
            }

            return '';
        }

        /**
         * Phone already linked to an SMS/WhatsApp conversation for this reservation.
         * Prefer the target channel, then the other direct channel, then guest_phone.
         */
        function getExistingDirectPhone(group, preferredChannel)
        {
            group = group || vm.selectedThread;

            if (!group) {
                return '';
            }

            var channels = group.channels || {};
            var preferred = preferredChannel === 'whatsapp' ? 'whatsapp' : (preferredChannel === 'sms' ? 'sms' : '');
            var other = preferred === 'whatsapp' ? 'sms' : (preferred === 'sms' ? 'whatsapp' : '');
            var phone = '';

            if (preferred && channels[preferred] && channels[preferred].guest_phone_e164) {
                phone = channels[preferred].guest_phone_e164;
            } else if (other && channels[other] && channels[other].guest_phone_e164) {
                phone = channels[other].guest_phone_e164;
            } else if (group._direct && group._direct.guest_phone) {
                phone = group._direct.guest_phone;
            } else if (group.guest_phone) {
                // Only reuse top-level guest_phone when a direct channel already exists.
                if ((channels.sms && channels.sms.conversation_sid) ||
                    (channels.whatsapp && channels.whatsapp.conversation_sid) ||
                    (group._direct && group._direct.conversation_sid)) {
                    phone = group.guest_phone;
                }
            }

            return String(phone || '').replace(/^\s+|\s+$/g, '');
        }

        function needsPhonePicker()
        {
            var channel = vm.composerChannel;

            if (!channel || !needsDirectChannelStart(channel)) {
                return false;
            }

            // Don't ask again if SMS/WhatsApp already has a number on this stay.
            return !getExistingDirectPhone(vm.selectedThread, channel);
        }

        function isPhoneLinkedError(response)
        {
            if (!response) {
                return false;
            }

            return response.code === 'phone_linked_to_other_reservation' ||
                response.code === 'phone_linked_to_staff_contact' ||
                (response.data && (
                    response.data.code === 'phone_linked_to_other_reservation' ||
                    response.data.code === 'phone_linked_to_staff_contact'
                ));
        }

        function handlePhoneLinkedError(response)
        {
            var message = (response && response.message) ||
                (response && response.data && response.data.message) ||
                'This phone number is already linked to another conversation. Use another number.';

            vm.phoneConflictMessage = message;
            toastMessage.showSimpleToast(message, 'error-toast');
            return message;
        }

        /**
         * @param {Object} thread
         * @param {Object} [options]
         * @param {boolean} [options.promote=true] When false, update in place without
         *   moving the row (used for context refresh / unread clear on open).
         */
        function upsertUnifiedThread(thread, options)
        {
            if (!thread) {
                return;
            }

            options = options || {};
            var promote = options.promote !== false;
            var list = vm._allUnifiedThreads || [];
            var key = getThreadKey(thread);
            var i;
            var existing = null;
            var existingIndex = -1;

            for (i = 0; i < list.length; i++) {
                if (getThreadKey(list[i]) === key) {
                    existing = list[i];
                    existingIndex = i;
                    break;
                }
            }

            if (existing) {
                angular.extend(existing, thread);
                thread = existing;

                if (!promote) {
                    // Keep list position stable (e.g. opening a chat).
                    vm._allUnifiedThreads = list;
                    applyUnifiedTabFilter({ preserveOrder: true });
                    return;
                }

                list.splice(existingIndex, 1);
            }

            // Pin newly active threads (send / start) at the front before sort.
            list.unshift(thread);
            vm._allUnifiedThreads = list;
            applyUnifiedTabFilter();
        }

        function buildSmsMessageParams(directThread, page)
        {
            var params = {
                conversation_sid: directThread.conversation_sid,
                page: page,
                limit: vm.messageLimit
            };

            var confirmationNumber = directThread.confirmation_number ||
                (vm.selectedThread && vm.selectedThread.confirmation_number) ||
                '';

            if (confirmationNumber) {
                params.confirmation_number = confirmationNumber;
            }

            if (vm.subHotelId) {
                params.sub_hotel_id = vm.subHotelId;
            }

            return params;
        }

        function normalizeUnifiedMessages(list)
        {
            var out = [];
            var i;

            for (i = 0; i < (list || []).length; i++) {
                var message = angular.copy(list[i]);
                var channel = message.channel || 'ota';

                if (message.sender === 'hotel') {
                    message.sender = 'property';
                }

                message.channel = channel;
                message._channel = channel;
                message._sortTs = parseTs(message.inserted_at);
                message._uid = channel + ':' + (message.id || message.local_id || (message._sortTs + ':' + i));
                out.push(message);
            }

            return out;
        }

        function loadUnifiedMessages(page, append)
        {
            var group = vm.selectedThread;
            var params = {
                confirmation_number: group.confirmation_number,
                page: page || 1,
                limit: vm.messageLimit,
                order: 'desc'
            };

            if (vm.subHotelId) {
                params.sub_hotel_id = vm.subHotelId;
            }

            return messageCenterService.getUnifiedMessages(params).then(function (response) {
                if (!response || response.success === false) {
                    if (isLocalStorageUnavailable(response)) {
                        useUnifiedApi = false;
                        vm.localStorageUnavailable = true;
                    }

                    return { ok: false, response: response };
                }

                var data = normalizeUnifiedMessages(response.data || []);
                var added = [];
                vm.msgPage = page || 1;
                vm.msgTotal = (response.meta && response.meta.total) ? response.meta.total : data.length;

                if (response.timezone) {
                    vm.chatTimezone = response.timezone;
                    if (vm.selectedThread) {
                        vm.selectedThread.timezone = response.timezone;
                    }
                }

                if (append) {
                    added = addMessages(data);
                } else {
                    vm.messages = [];
                    added = addMessages(data);
                }

                return { ok: true, data: data, added: added };
            }, function () {
                useUnifiedApi = false;
                return { ok: false };
            });
        }

        function loadLegacyMessages()
        {
            var group = vm.selectedThread;
            var promises = [];

            if (group._ota || (group.channels && group.channels.ota)) {
                var otaId = (group._ota && group._ota.thread_id) ||
                    (group.channels.ota && group.channels.ota.message_thread_id);
                if (otaId) {
                    promises.push(
                        messageCenterService.getThreadMessages(otaId, 1, vm.messageLimit)
                            .then(function (response) {
                                return { channel: 'ota', response: response };
                            })
                    );
                }
            }

            var smsSid = (group._direct && group._direct.channel !== 'whatsapp' && group._direct.conversation_sid) ||
                (group.channels && group.channels.sms && group.channels.sms.conversation_sid);
            var waSid = (group._direct && group._direct.channel === 'whatsapp' && group._direct.conversation_sid) ||
                (group.channels && group.channels.whatsapp && group.channels.whatsapp.conversation_sid);

            if (smsSid) {
                promises.push(
                    messageCenterService.getSmsThreadMessages({
                        conversation_sid: smsSid,
                        page: 1,
                        limit: vm.messageLimit,
                        confirmation_number: group.confirmation_number || '',
                        sub_hotel_id: vm.subHotelId || undefined
                    }).then(function (response) {
                        return { channel: 'sms', response: response };
                    })
                );
            }

            if (waSid) {
                promises.push(
                    messageCenterService.getSmsThreadMessages({
                        conversation_sid: waSid,
                        page: 1,
                        limit: vm.messageLimit,
                        confirmation_number: group.confirmation_number || '',
                        sub_hotel_id: vm.subHotelId || undefined
                    }).then(function (response) {
                        return { channel: 'whatsapp', response: response };
                    })
                );
            }

            if (!promises.length) {
                vm.loadingMessages = false;
                schedulePendingMessagesRefresh();
                return;
            }

            $q.all(promises).then(function (results) {
                vm.loadingMessages = false;

                if (getThreadKey(vm.selectedThread) !== vm.selectedKey) {
                    schedulePendingMessagesRefresh();
                    return;
                }

                var collected = [];
                var hadError = false;

                results.forEach(function (result) {
                    var response = result.response;

                    if (!response || response.success === false) {
                        hadError = true;
                        return;
                    }

                    collected = collected.concat(normalizeChannelMessages(response.data || [], result.channel));

                    if (result.channel === 'ota') {
                        vm.msgOta.total = (response.meta && response.meta.total) ? response.meta.total : collected.length;
                    } else {
                        vm.msgDirect.hasMore = (response.data || []).length >= vm.messageLimit;
                    }
                });

                if (hadError && !collected.length) {
                    toastMessage.showSimpleToast('Unable to load messages.', 'error-toast');
                    schedulePendingMessagesRefresh();
                    return;
                }

                vm.messages = [];
                addMessages(collected);
                setDefaultComposerChannel(vm.selectedThread);
                bindMessagesScroll();
                scrollMessagesToBottom();
                updateMessageStayDates(vm.messages);
                updateLoadEarlierVisibility();
                schedulePendingMessagesRefresh();
            });
        }

        function loadMessages()
        {
            var group = vm.selectedThread;

            if (!group) {
                return;
            }

            vm.loadingMessages = true;

            if (useUnifiedApi && group.confirmation_number) {
                loadUnifiedMessages(1, false).then(function (result) {
                    if (result && result.ok) {
                        vm.loadingMessages = false;

                        if (getThreadKey(vm.selectedThread) !== vm.selectedKey) {
                            schedulePendingMessagesRefresh();
                            return;
                        }

                        setDefaultComposerChannel(vm.selectedThread);
                        bindMessagesScroll();
                        scrollMessagesToBottom();
                        updateMessageStayDates(vm.messages);
                        updateLoadEarlierVisibility();
                        schedulePendingMessagesRefresh();
                        return;
                    }

                    loadLegacyMessages();
                });
                return;
            }

            loadLegacyMessages();
        }

        function hasMoreMessages()
        {
            var group = vm.selectedThread;

            if (!group) {
                return false;
            }

            if (useUnifiedApi && group.confirmation_number) {
                return vm.messages.length < vm.msgTotal;
            }

            var otaMore = group._ota && countMessagesByChannel('ota') < vm.msgOta.total;
            var dirMore = group._direct && vm.msgDirect.hasMore;
            var smsMore = group.channels && group.channels.sms && vm.msgDirect.hasMore;

            return !!(otaMore || dirMore || smsMore);
        }

        function loadMoreMessages()
        {
            if (vm.loadingMessages || !hasMoreMessages()) {
                return;
            }

            var group = vm.selectedThread;
            var container = document.getElementById('gmc-messages-container');
            var previousScrollHeight = container ? container.scrollHeight : 0;

            if (useUnifiedApi && group.confirmation_number) {
                vm.loadingMessages = true;
                loadUnifiedMessages(vm.msgPage + 1, true).then(function (result) {
                    vm.loadingMessages = false;

                    if (!result || !result.ok) {
                        return;
                    }

                    if (getThreadKey(vm.selectedThread) !== vm.selectedKey) {
                        return;
                    }

                    preserveMessagesScroll(previousScrollHeight);
                    updateMessageStayDates(vm.messages);
                    updateLoadEarlierVisibility();
                });
                return;
            }

            var promises = [];

            if (group._ota && countMessagesByChannel('ota') < vm.msgOta.total) {
                vm.msgOta.page += 1;
                promises.push(
                    messageCenterService.getThreadMessages(group._ota.thread_id, vm.msgOta.page, vm.messageLimit)
                        .then(function (response) {
                            return { channel: 'ota', response: response };
                        })
                );
            }

            if (group._direct && vm.msgDirect.hasMore) {
                vm.msgDirect.page += 1;
                promises.push(
                    messageCenterService.getSmsThreadMessages(buildSmsMessageParams(group._direct, vm.msgDirect.page))
                        .then(function (response) {
                            return { channel: 'direct', response: response };
                        })
                );
            }

            if (!promises.length) {
                return;
            }

            vm.loadingMessages = true;

            $q.all(promises).then(function (results) {
                vm.loadingMessages = false;

                if (getThreadKey(vm.selectedThread) !== vm.selectedKey) {
                    return;
                }

                var collected = [];

                results.forEach(function (result) {
                    var response = result.response;

                    if (!response || response.success === false) {
                        if (result.channel === 'ota') {
                            vm.msgOta.page -= 1;
                        } else {
                            vm.msgDirect.page -= 1;
                        }
                        return;
                    }

                    var data = normalizeChannelMessages(response.data || [], result.channel);
                    collected = collected.concat(data);

                    if (result.channel === 'ota') {
                        vm.msgOta.total = (response.meta && response.meta.total) ? response.meta.total : vm.msgOta.total;
                    } else {
                        vm.msgDirect.hasMore = data.length >= vm.messageLimit;
                    }
                });

                addMessages(collected);
                preserveMessagesScroll(previousScrollHeight);
                updateMessageStayDates(vm.messages);
                updateLoadEarlierVisibility();
            });
        }

        // ---------------------------------------------------------------------
        // Stay-date resolution (unchanged behavior, reads from group fields)
        // ---------------------------------------------------------------------

        function applyThreadStayData(group)
        {
            if (!group) {
                return;
            }

            var checkIn = getThreadCheckIn(group);
            var checkOut = getThreadCheckOut(group);

            if (!checkIn && !checkOut && !group.room_stay_status) {
                return;
            }

            vm.reservationStayDates = {
                checkin_date: checkIn || null,
                checkout_date: checkOut || null,
                room_stay_status: group.room_stay_status || null
            };
        }

        function loadReservationStayDates()
        {
            if (!vm.selectedThread) {
                return;
            }

            if (vm.reservationStayDates && vm.reservationStayDates._loaded) {
                return;
            }

            if (getThreadCheckIn(vm.selectedThread) &&
                getThreadCheckOut(vm.selectedThread) &&
                vm.selectedThread.room_stay_status) {
                return;
            }

            var params = {
                confirmation_number: vm.selectedThread.confirmation_number || '',
                message_thread_id: vm.selectedThread.thread_id || '',
                booking_id: vm.selectedThread.booking_id || ''
            };

            if (!params.confirmation_number && !params.message_thread_id && !params.booking_id) {
                return;
            }

            var confirmationNumber = vm.selectedThread.confirmation_number;

            messageCenterService.getThreadStayInfo(params).then(function (response) {
                if (!vm.selectedThread) {
                    return;
                }

                if (response && response.success !== false && response.data) {
                    applyReservationStayData(response.data);
                    return;
                }

                if (!confirmationNumber) {
                    vm.reservationStayDates = { _loaded: true };
                    return;
                }

                loadReservationStayDatesFromOrder(confirmationNumber);
            }, function () {
                if (confirmationNumber) {
                    loadReservationStayDatesFromOrder(confirmationNumber);
                } else {
                    vm.reservationStayDates = { _loaded: true };
                }
            });
        }

        function loadReservationStayDatesFromOrder(confirmationNumber)
        {
            eCommerceService.fetchOrder({
                confirmation_number: confirmationNumber
            }).then(function (response) {
                if (!vm.selectedThread || vm.selectedThread.confirmation_number !== confirmationNumber) {
                    return;
                }

                if (!response || !response.success || !response.reservation) {
                    vm.reservationStayDates = { _loaded: true };
                    return;
                }

                var reservation = response.reservation;

                applyReservationStayData({
                    checkin_date: reservation.room_stay_from ||
                        reservation.arrival_time ||
                        reservation.arrival_date ||
                        null,
                    checkout_date: reservation.room_stay_to ||
                        reservation.departure_time ||
                        reservation.departure_date ||
                        null,
                    room_stay_status: reservation.room_stay_status ||
                        reservation.order_status ||
                        reservation.reservation_status_type ||
                        null,
                    source_of_creation: reservation.source_of_creation ||
                        reservation.booking_source ||
                        null
                });
            }, function () {
                if (vm.selectedThread && vm.selectedThread.confirmation_number === confirmationNumber) {
                    vm.reservationStayDates = { _loaded: true };
                }
            });
        }

        function applyReservationStayData(data)
        {
            if (!vm.selectedThread || !data) {
                return;
            }

            vm.reservationStayDates = {
                checkin_date: data.checkin_date || null,
                checkout_date: data.checkout_date || null,
                room_stay_status: data.room_stay_status || null,
                _loaded: true
            };

            if (data.checkin_date) {
                vm.selectedThread.room_stay_from = data.checkin_date;
                vm.selectedThread.checkin_date = data.checkin_date;
            }

            if (data.checkout_date) {
                vm.selectedThread.room_stay_to = data.checkout_date;
                vm.selectedThread.checkout_date = data.checkout_date;
            }

            if (data.room_stay_status) {
                vm.selectedThread.room_stay_status = data.room_stay_status;
            }

            if (data.source_of_creation || data.booking_source || data.provider) {
                vm.selectedThread.source_of_creation = data.source_of_creation ||
                    data.booking_source ||
                    data.provider ||
                    vm.selectedThread.source_of_creation;
                vm.selectedThread._chips = computeChips(vm.selectedThread);
                upsertUnifiedThread(vm.selectedThread);
            }
        }

        // ---------------------------------------------------------------------
        // Scroll handling
        // ---------------------------------------------------------------------

        function bindMessagesScroll()
        {
            $timeout(function () {
                var container = document.getElementById('gmc-messages-container');

                if (!container || container._gmcScrollBound) {
                    return;
                }

                container._gmcScrollBound = true;
                messagesScrollHandler = function () {
                    $scope.$applyAsync(function () {
                        updateLoadEarlierVisibility();
                    });
                };
                container.addEventListener('scroll', messagesScrollHandler);
            }, 0);
        }

        function unbindMessagesScroll()
        {
            var container = document.getElementById('gmc-messages-container');

            if (container && messagesScrollHandler) {
                container.removeEventListener('scroll', messagesScrollHandler);
                container._gmcScrollBound = false;
                messagesScrollHandler = null;
            }
        }

        function bindThreadsScroll()
        {
            $timeout(function () {
                var container = document.getElementById('gmc-thread-scroll');

                if (!container || container._gmcThreadsScrollBound) {
                    return;
                }

                container._gmcThreadsScrollBound = true;
                threadsScrollHandler = function () {
                    if (vm.loadingThreads || !hasMoreThreads()) {
                        return;
                    }

                    var remaining = container.scrollHeight - container.scrollTop - container.clientHeight;

                    if (remaining < THREAD_SCROLL_LOAD_PX) {
                        $scope.$applyAsync(function () {
                            loadMoreThreads();
                        });
                    }
                };
                container.addEventListener('scroll', threadsScrollHandler);
            }, 0);
        }

        function unbindThreadsScroll()
        {
            var container = document.getElementById('gmc-thread-scroll');

            if (container && threadsScrollHandler) {
                container.removeEventListener('scroll', threadsScrollHandler);
                container._gmcThreadsScrollBound = false;
                threadsScrollHandler = null;
            } else {
                threadsScrollHandler = null;
            }
        }

        function updateLoadEarlierVisibility()
        {
            var container = document.getElementById('gmc-messages-container');

            if (!container || !hasMoreMessages()) {
                vm.showLoadEarlier = false;
                return;
            }

            vm.showLoadEarlier = container.scrollTop <= 60;
        }

        function preserveMessagesScroll(previousScrollHeight)
        {
            $timeout(function () {
                var container = document.getElementById('gmc-messages-container');

                if (!container) {
                    return;
                }

                container.scrollTop = container.scrollHeight - previousScrollHeight;
                updateLoadEarlierVisibility();
            }, 0);
        }

        function updateMessageStayDates(messages)
        {
            vm.messageStayDates = null;

            if (!messages || !messages.length) {
                return;
            }

            for (var i = 0; i < messages.length; i++) {
                var details = getInquiryDetails(messages[i]);

                if (details && (details.checkin_date || details.checkout_date)) {
                    vm.messageStayDates = details;
                    return;
                }
            }
        }

        function scrollMessagesToBottom()
        {
            $timeout(function () {
                var container = document.getElementById('gmc-messages-container');
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }

                // Second pass after Angular paints the new bubble.
                $timeout(function () {
                    var el = document.getElementById('gmc-messages-container');
                    if (el) {
                        el.scrollTop = el.scrollHeight;
                    }
                }, 50);
            }, 0);
        }

        function isMessagesAtBottom()
        {
            var container = document.getElementById('gmc-messages-container');

            if (!container) {
                return true;
            }

            return (container.scrollHeight - container.scrollTop - container.clientHeight) < 80;
        }

        // ---------------------------------------------------------------------
        // Composer + send routing (explicit channel picker)
        // ---------------------------------------------------------------------

        function isOptedOut(group)
        {
            group = group || vm.selectedThread;
            return !!(group && group.messaging_opt_out);
        }

        function isStaffInactive(group)
        {
            group = group || vm.selectedThread;

            if (!group) {
                return false;
            }

            return group.staff_is_active === false ||
                group.staff_is_active === 0 ||
                group.staff_is_active === '0';
        }

        function getOptOutBannerText()
        {
            return 'Reservation opted out of direct messaging.';
        }

        function getInactiveStaffBannerText()
        {
            return 'This staff member is inactive. Messaging is disabled.';
        }

        function coerceAiMode(value)
        {
            return value === true || value === 1 || value === '1';
        }

        function normalizeLastSender(sender)
        {
            return sender === 'hotel' ? 'property' : (sender || 'guest');
        }

        function isAiModeOn(group)
        {
            group = group || vm.selectedThread;
            return !!(group && coerceAiMode(group.ai_mode));
        }

        function setAiModeLocal(confirmation, aiMode)
        {
            var mode = coerceAiMode(aiMode);

            if (!confirmation) {
                return;
            }

            angular.forEach([vm.selectedThread]
                .concat(vm.threads || [], vm._allUnifiedThreads || []), function (group) {
                if (!group || group.confirmation_number !== confirmation) {
                    return;
                }

                group.ai_mode = mode;

                if (group._direct) {
                    group._direct.ai_mode = mode;
                }

                if (group._ota) {
                    group._ota.ai_mode = mode;
                }
            });

            messageCenterNavBadgeService.setReservationAiModeKnown(confirmation, mode);
        }

        function handleAiModeSendBlocked(response)
        {
            var message = (response && response.message) ||
                'AI Mode is on for this reservation. Turn AI Mode off before sending a staff message.';

            if (vm.selectedThread) {
                vm.selectedThread.ai_mode = true;
            }

            toastMessage.showSimpleToast(message, 'error-toast');
            vm.highlightAiToggle = true;
            $timeout(function () {
                vm.highlightAiToggle = false;
            }, 2800);
        }

        function isAiModeActiveError(response)
        {
            return !!(response && response.code === 'ai_mode_active');
        }

        function appendAiModeNoticeIfOpen(confirmation, messageObj)
        {
            var notice;

            if (!confirmation || !messageObj || typeof messageObj !== 'object' ||
                !isSelectedConfirmation(confirmation)) {
                return;
            }

            notice = normalizeUnifiedMessages([angular.copy(messageObj)])[0];

            if (!notice) {
                return;
            }

            notice.sender = notice.sender || 'system';

            if (appendSentMessage(notice)) {
                scrollMessagesToBottom();
            }
        }

        function toggleAiMode()
        {
            var group = vm.selectedThread;
            var previous;
            var next;
            var payload;

            if (!group || !group.confirmation_number || vm.updatingAiMode) {
                return;
            }

            previous = isAiModeOn(group);
            next = !previous;
            payload = {
                confirmation_number: group.confirmation_number,
                ai_mode: next
            };

            if (vm.subHotelId) {
                payload.sub_hotel_id = vm.subHotelId;
            }

            setAiModeLocal(group.confirmation_number, next);
            vm.updatingAiMode = true;

            messageCenterService.setReservationAiMode(payload).then(function (response) {
                var data;
                var mode;
                var noticeText;

                vm.updatingAiMode = false;

                if (!response || response.success === false) {
                    setAiModeLocal(group.confirmation_number, previous);
                    toastMessage.showSimpleToast(
                        (response && response.message) || 'Unable to update AI Mode.',
                        'error-toast'
                    );
                    return;
                }

                data = response.data || {};
                mode = data.ai_mode != null ? data.ai_mode : next;
                setAiModeLocal(group.confirmation_number, mode);

                if (data.message && typeof data.message === 'object') {
                    appendAiModeNoticeIfOpen(group.confirmation_number, data.message);
                } else if (data.notice_text) {
                    noticeText = String(data.notice_text).trim();

                    if (noticeText) {
                        appendAiModeNoticeIfOpen(group.confirmation_number, {
                            sender: 'system',
                            message: noticeText,
                            event_type: coerceAiMode(mode) ? 'ai_mode_on' : 'ai_mode_off',
                            confirmation_number: group.confirmation_number,
                            channel: 'sms'
                        });
                    }
                }
            }, function (error) {
                var err = (error && error.data) ? error.data : null;

                vm.updatingAiMode = false;
                setAiModeLocal(group.confirmation_number, previous);
                toastMessage.showSimpleToast(
                    (err && err.message) || 'Unable to update AI Mode.',
                    'error-toast'
                );
            });
        }

        function getOtaChannel(group)
        {
            group = group || vm.selectedThread;
            if (!group) {
                return null;
            }
            return (group.channels && group.channels.ota) || null;
        }

        function getDirectChannel(group, channel)
        {
            group = group || vm.selectedThread;
            if (!group || !group.channels) {
                return null;
            }
            return group.channels[channel] || null;
        }

        function getOtaThreadId(group)
        {
            var ch = getOtaChannel(group);
            if (ch && ch.message_thread_id) {
                return ch.message_thread_id;
            }
            if (group && group._ota && group._ota.thread_id) {
                return group._ota.thread_id;
            }
            return group && group.thread_id ? group.thread_id : '';
        }

        function getConversationSid(group, channel)
        {
            var ch = getDirectChannel(group, channel);
            if (ch && ch.conversation_sid) {
                return ch.conversation_sid;
            }
            if (group && group._direct && (!channel || group._direct.channel === channel ||
                (!group._direct.channel && channel === 'sms'))) {
                return group._direct.conversation_sid;
            }
            return '';
        }

        function hasGuestPhone(group)
        {
            return !!getThreadPhone(group || vm.selectedThread);
        }

        function isChannelEnabled(channel)
        {
            var group = vm.selectedThread;

            if (!group || !channel) {
                return false;
            }

            if (isStaffInactive(group) && channel !== 'ota') {
                return false;
            }

            if (channel === 'ota') {
                return !!(vm.otaEnabled && vm.canSendOta && getOtaThreadId(group) && !(getOtaChannel(group) && getOtaChannel(group).is_closed) && !(group._ota && group._ota.is_closed));
            }

            if (channel === 'sms' || channel === 'whatsapp') {
                if (!vm.canSendDirect || !showDirectFeatures() || !isDirectChannelConfigured(channel)) {
                    return false;
                }

                // Existing thread, or can start once staff picks a phone.
                return !!getConversationSid(group, channel) || !isStaffInactive(group);
            }

            return false;
        }

        function needsDirectChannelStart(channel)
        {
            var group = vm.selectedThread;
            return !!(group && group.confirmation_number &&
                (channel === 'sms' || channel === 'whatsapp') &&
                !getConversationSid(group, channel) && !isStaffInactive(group));
        }

        function refreshChannelOptions()
        {
            var options = [];
            var group = vm.selectedThread;

            if (!group) {
                vm.channelOptions = options;
                return options;
            }

            if (showOtaFeatures() && (getOtaThreadId(group) || (group.channels && group.channels.ota))) {
                options.push({
                    id: 'ota',
                    label: getProviderLabel(extractSourceOfCreation(group) || group.provider) || 'OTA',
                    enabled: isChannelEnabled('ota')
                });
            }

            if (showDirectFeatures() && vm.canSendDirect) {
                if (vm.smsEnabled) {
                    options.push({
                        id: 'sms',
                        label: 'SMS',
                        enabled: isChannelEnabled('sms')
                    });
                }

                if (vm.whatsappEnabled) {
                    options.push({
                        id: 'whatsapp',
                        label: 'WhatsApp',
                        enabled: isChannelEnabled('whatsapp')
                    });
                }
            }

            vm.channelOptions = options;
            return options;
        }

        function getChannelOptions()
        {
            return vm.channelOptions || [];
        }

        function getPreferredDirectChannel()
        {
            if (vm.smsEnabled) {
                return 'sms';
            }

            if (vm.whatsappEnabled) {
                return 'whatsapp';
            }

            return showOtaFeatures() ? 'ota' : 'sms';
        }

        function setDefaultComposerChannel(group)
        {
            if (!group) {
                if (showDirectFeatures()) {
                    vm.composerChannel = getPreferredDirectChannel();
                } else if (showOtaFeatures()) {
                    vm.composerChannel = 'ota';
                } else {
                    vm.composerChannel = '';
                }
                refreshChannelOptions();
                return;
            }

            // Always reply on the channel of the latest message (guest or hotel).
            var preferred = resolveLastMessageChannel(group);

            if (preferred && isChannelEnabled(preferred)) {
                vm.composerChannel = preferred;
                refreshChannelOptions();
                return;
            }

            if (isChannelEnabled('sms')) {
                vm.composerChannel = 'sms';
            } else if (isChannelEnabled('whatsapp')) {
                vm.composerChannel = 'whatsapp';
            } else if (isChannelEnabled('ota')) {
                vm.composerChannel = 'ota';
            } else if (showDirectFeatures()) {
                vm.composerChannel = getPreferredDirectChannel();
            } else if (showOtaFeatures()) {
                vm.composerChannel = 'ota';
            } else {
                vm.composerChannel = '';
            }

            refreshChannelOptions();
        }

        /**
         * Prefer the newest message channel in the open chat (any sender),
         * then fall back to channel thread rows by last_message_at.
         */
        function resolveLastMessageChannel(group)
        {
            var i;
            var message;
            var channel;
            var channels;
            var names;
            var bestChannel = '';
            var bestTs = 0;
            var ts;

            for (i = (vm.messages || []).length - 1; i >= 0; i--) {
                message = vm.messages[i];

                if (!message || message.sender === 'system') {
                    continue;
                }

                channel = normalizeComposerChannel(message._channel || message.channel, group);

                if (channel) {
                    return channel;
                }
            }

            channels = (group && group.channels) || {};
            names = ['sms', 'whatsapp', 'ota'];

            for (i = 0; i < names.length; i++) {
                channel = names[i];

                if (!channels[channel] || !channels[channel].last_message_at) {
                    continue;
                }

                ts = parseTs(channels[channel].last_message_at) || 0;

                if (ts >= bestTs) {
                    bestTs = ts;
                    bestChannel = channel;
                }
            }

            if (bestChannel) {
                return bestChannel;
            }

            return normalizeComposerChannel(group && (group._lastChannel || group.channel), group);
        }

        function normalizeComposerChannel(channel, group)
        {
            if (!channel) {
                return '';
            }

            if (channel === 'direct') {
                return (group && group.channel === 'whatsapp') ? 'whatsapp' : 'sms';
            }

            if (channel === 'sms' || channel === 'whatsapp' || channel === 'ota') {
                return channel;
            }

            return '';
        }

        function setComposerChannel(channel)
        {
            if (!channel) {
                return;
            }

            vm.composerChannel = channel;
            vm.phoneConflictMessage = '';
            if (channel === 'ota') {
                clearPendingMedia();
            }
            refreshChannelOptions();
        }

        function canAttachImage()
        {
            var channel = getActiveSendChannel();
            return channel === 'sms' || channel === 'whatsapp';
        }

        function hasSendableContent()
        {
            if (hasComposerBodyForTranslate()) {
                return true;
            }

            return !!(vm.pendingMedia &&
                vm.pendingMedia.sid &&
                !vm.pendingMedia.uploading &&
                !vm.pendingMedia.error);
        }

        function hasComposerBodyForTranslate()
        {
            return messageCenterComposerSignature.hasBodyBeyondSignature(vm.replyText);
        }

        function getComposerStaffName()
        {
            return messageCenterComposerSignature.getStaffDisplayName();
        }

        function syncComposerSignature(options)
        {
            var name = getComposerStaffName();
            var opts = options || {};

            if (!name) {
                return;
            }

            var next = messageCenterComposerSignature.ensureInComposer(vm.replyText, name);

            if (next !== String(vm.replyText || '')) {
                vm._composerSignatureSync = true;
                vm.replyText = next;
            }

            $timeout(function () {
                var textarea = getReplyTextarea();

                if (opts.placeCaret !== false) {
                    messageCenterComposerSignature.placeCaretBeforeSignature(textarea, name);
                } else if (textarea && opts.focus) {
                    textarea.focus();
                }

                resizeReplyTextarea();
                vm._composerSignatureSync = false;
            }, 0);
        }

        function onReplyFocus()
        {
            if (!canSendToSelected() || isStaffInactive() || isAiModeOn()) {
                return;
            }

            var name = getComposerStaffName();
            var text = String(vm.replyText || '');

            // Seed signature only on an empty composer. If the user cleared it, leave it off.
            if (!text.replace(/^\s+|\s+$/g, '')) {
                syncComposerSignature({ placeCaret: true });
                return;
            }

            if (!name) {
                return;
            }

            var parts = messageCenterComposerSignature.split(text, name);

            if (!parts.hasSignature) {
                return;
            }

            $timeout(function () {
                messageCenterComposerSignature.placeCaretBeforeSignature(getReplyTextarea(), name);
            }, 0);
        }

        function onReplyTextChange()
        {
            resizeReplyTextarea();

            if (vm._composerSignatureSync) {
                return;
            }

            var name = getComposerStaffName();
            var body = messageCenterComposerSignature.split(vm.replyText, name).body;

            if (body !== vm._lastComposerBodyForTranslation) {
                vm._lastComposerBodyForTranslation = body;
                clearReplyTranslation();
            }
        }

        function getPendingMediaSid()
        {
            if (!vm.pendingMedia || vm.pendingMedia.uploading || vm.pendingMedia.error) {
                return '';
            }

            return vm.pendingMedia.sid || '';
        }

        function clearPendingMedia()
        {
            if (vm.pendingMedia && vm.pendingMedia.previewUrl) {
                try {
                    URL.revokeObjectURL(vm.pendingMedia.previewUrl);
                } catch (e) {
                    // ignore
                }
            }

            vm.pendingMedia = null;
            vm.uploadingMedia = false;

            var input = document.getElementById('gmc-staff-attach-image-input');
            if (input) {
                input.value = '';
            }
        }

        function canAcceptImageDrop()
        {
            return canAttachImage() && canSendToSelected() && !vm.sendingMessage && !vm.uploadingMedia;
        }

        function onComposerDrop(event)
        {
            var files;
            var file;
            var i;

            vm.composerDragOver = false;

            if (!canAcceptImageDrop()) {
                if (!canAttachImage()) {
                    toastMessage.showSimpleToast('Images can only be sent via SMS or WhatsApp.', 'error-toast');
                } else if (!canSendToSelected()) {
                    toastMessage.showSimpleToast(getComposerBlockedMessage() || 'Unable to attach image right now.', 'error-toast');
                }
                return;
            }

            files = event && event.dataTransfer && event.dataTransfer.files;
            if (!files || !files.length) {
                return;
            }

            file = null;
            for (i = 0; i < files.length; i++) {
                if (files[i] && String(files[i].type || '').indexOf('image/') === 0) {
                    file = files[i];
                    break;
                }
            }

            if (!file) {
                toastMessage.showSimpleToast('Only JPEG, PNG, GIF, or WebP images are supported.', 'error-toast');
                return;
            }

            attachImageFile(file);
        }

        function bindAttachInput(input)
        {
            if (!input || input._gmcChangeBound) {
                return;
            }

            input.addEventListener('change', function (event)
            {
                var files = event && event.target && event.target.files;
                var file = files && files.length ? files[0] : null;

                if ($scope.$root && $scope.$root.$$phase) {
                    attachImageFile(file);
                } else {
                    $scope.$apply(function ()
                    {
                        attachImageFile(file);
                    });
                }

                try {
                    input.value = '';
                } catch (e) {
                    // ignore
                }
            });
            input._gmcChangeBound = true;
        }

        function openImagePicker()
        {
            var input;

            if (!canAcceptImageDrop()) {
                return;
            }

            input = document.getElementById('gmc-staff-attach-image-input');
            if (!input) {
                return;
            }

            bindAttachInput(input);

            try {
                input.value = '';
            } catch (e) {
                // ignore
            }

            $timeout(function ()
            {
                input.click();
            }, 0);
        }

        function onImageSelected(event)
        {
            var files = event && event.target && event.target.files;
            attachImageFile(files && files.length ? files[0] : null);
        }

        function attachImageFile(file)
        {
            var maxBytes = 5 * 1024 * 1024;
            var allowed = {
                'image/jpeg': true,
                'image/jpg': true,
                'image/png': true,
                'image/gif': true,
                'image/webp': true
            };
            var previewUrl;

            if (!file) {
                return;
            }

            if (!canAcceptImageDrop()) {
                return;
            }

            if (!allowed[String(file.type || '').toLowerCase()]) {
                toastMessage.showSimpleToast('Only JPEG, PNG, GIF, or WebP images are supported.', 'error-toast');
                return;
            }

            if (!file.size || file.size > maxBytes) {
                toastMessage.showSimpleToast('Image must be 5 MB or smaller.', 'error-toast');
                return;
            }

            clearPendingMedia();
            previewUrl = URL.createObjectURL(file);
            vm.pendingMedia = {
                file: file,
                name: file.name || 'image',
                previewUrl: previewUrl,
                uploading: true,
                sid: '',
                error: ''
            };
            vm.uploadingMedia = true;

            messageCenterService.uploadSmsMedia(file, vm.subHotelId).then(function (response) {
                var media = findPendingMediaByFile(file);

                if (!media) {
                    return;
                }

                if (vm.pendingMedia && vm.pendingMedia.file === file) {
                    vm.uploadingMedia = false;
                }

                if (!response || response.success === false || !response.data || !response.data.sid) {
                    media.uploading = false;
                    media.error = (response && response.message) || 'Unable to upload image.';
                    toastMessage.showSimpleToast(media.error, 'error-toast');
                    return;
                }

                media.uploading = false;
                media.sid = response.data.sid;
                media.contentType = response.data.content_type || file.type;
            }, function (error) {
                var response = (error && error.data) ? error.data : null;
                var media = findPendingMediaByFile(file);

                if (!media) {
                    return;
                }

                if (vm.pendingMedia && vm.pendingMedia.file === file) {
                    vm.uploadingMedia = false;
                }

                media.uploading = false;
                media.error = (response && response.message) || 'Unable to upload image.';
                toastMessage.showSimpleToast(media.error, 'error-toast');
            });
        }

        function getActiveSendChannel()
        {
            if (!vm.selectedThread) {
                return null;
            }

            if (isChannelEnabled(vm.composerChannel)) {
                return vm.composerChannel;
            }

            return null;
        }

        function canSendToSelected()
        {
            var channel = getActiveSendChannel();

            if (!channel) {
                return false;
            }

            if (isStaffInactive()) {
                return false;
            }

            if (isAiModeOn()) {
                return false;
            }

            if (channel === 'ota') {
                return !!getOtaThreadId(vm.selectedThread);
            }

            if (needsDirectChannelStart(channel)) {
                if (vm.sendToSource === 'custom' && !isCustomSendToPhoneValid()) {
                    return false;
                }

                return !!getSelectedStartPhone();
            }

            return !!getConversationSid(vm.selectedThread, channel);
        }

        function getActiveSendChannelLabel()
        {
            var channel = vm.composerChannel || getActiveSendChannel();

            if (channel === 'ota') {
                return getProviderLabel(
                    extractSourceOfCreation(vm.selectedThread) ||
                    (vm.selectedThread && vm.selectedThread.provider)
                ) || 'OTA';
            }

            if (channel === 'whatsapp') {
                return 'WhatsApp';
            }

            if (channel === 'sms') {
                return 'SMS';
            }

            return '';
        }

        function getComposerBlockedMessage()
        {
            var group = vm.selectedThread;

            if (!group) {
                return '';
            }

            if (isStaffInactive(group)) {
                return getInactiveStaffBannerText();
            }

            if (isAiModeOn(group)) {
                return 'AI Mode is on. Turn it off to send a staff message.';
            }

            if (vm.composerChannel === 'ota') {
                if (!getOtaThreadId(group)) {
                    return 'No OTA conversation is linked to this reservation.';
                }
                if ((getOtaChannel(group) && getOtaChannel(group).is_closed) || (group._ota && group._ota.is_closed)) {
                    return 'The OTA conversation is closed.';
                }
            }

            if ((vm.composerChannel === 'sms' || vm.composerChannel === 'whatsapp') &&
                !needsDirectChannelStart(vm.composerChannel) &&
                !getConversationSid(group, vm.composerChannel) &&
                !hasGuestPhone(group)) {
                return 'Add a guest phone number to send via SMS or WhatsApp.';
            }

            if (group._direct && group._direct._smsBlocked) {
                return group._direct._smsBlocked;
            }

            return '';
        }

        function isBlockingSmsError(message)
        {
            if (!message) {
                return false;
            }

            return /past reservation|opted out|not enabled/i.test(message);
        }

        function sendReply()
        {
            if (!vm.selectedThread || vm.sendingMessage || isStaffInactive() || isAiModeOn()) {
                return;
            }

            var channel = getActiveSendChannel();

            if ((!channel || !canSendToSelected()) && !(channel && needsDirectChannelStart(channel))) {
                return;
            }

            var draftText = messageCenterComposerSignature.toOutboundMessage(vm.replyText);
            var message = resolveOutboundMessageBody(draftText);
            var translationMeta = buildOutboundTranslationMeta(draftText);
            var mediaSid = getPendingMediaSid();

            if (!message && !mediaSid) {
                return;
            }

            if (channel === 'ota' && mediaSid) {
                toastMessage.showSimpleToast('Images can only be sent via SMS or WhatsApp.', 'error-toast');
                return;
            }

            if (channel === 'ota' && isReservationCheckedIn(vm.selectedThread)) {
                confirmCheckedInOtaSend().then(function (answer) {
                    if (answer !== 'update') {
                        return;
                    }

                    if (!vm.selectedThread || vm.sendingMessage || isStaffInactive() || isAiModeOn()) {
                        return;
                    }

                    vm.sendingMessage = true;
                    sendOtaReply(message, translationMeta);
                }, function () {
                    // cancelled
                });
                return;
            }

            vm.sendingMessage = true;

            if (channel === 'ota') {
                sendOtaReply(message, translationMeta);
                return;
            }

            if (needsDirectChannelStart(channel)) {
                if (!getSelectedStartPhone()) {
                    vm.sendingMessage = false;
                    toastMessage.showSimpleToast('Pick a phone number to start the conversation.', 'error-toast');
                    return;
                }

                startChannelConversation(channel, message, mediaSid, translationMeta);
                return;
            }

            sendDirectReply(message, channel, mediaSid, translationMeta);
        }

        function isReservationCheckedIn(group)
        {
            return getStayStatus(group) === 'checked-in';
        }

        function confirmCheckedInOtaSend()
        {
            return $mdDialog.show({
                controller: 'confirmController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    title: 'Checked-in reservation',
                    htmlContent: 'This reservation is checked in. Do you still want to send the message through OTA? You can send the message through SMS or WhatsApp instead.',
                    cancelBtn: 'Cancel',
                    OkBtn: 'Send'
                }
            });
        }

        function sendOtaReply(message, translationMeta)
        {
            var group = vm.selectedThread;
            var threadId = getOtaThreadId(group);
            var payload = {
                message_thread_id: threadId,
                message: message,
                signature_applied: true
            };

            if (translationMeta) {
                payload.translation = translationMeta;
            }

            messageCenterService.sendThreadMessage(payload).then(function (response) {
                vm.sendingMessage = false;
                schedulePendingMessagesRefresh();

                if (!response || response.success === false) {
                    if (isAiModeActiveError(response)) {
                        handleAiModeSendBlocked(response);
                        return;
                    }

                    toastMessage.showSimpleToast((response && response.message) || 'Unable to send message.', 'error-toast');
                    return;
                }

                clearComposerAfterSend();

                var sent = normalizeChannelMessages([response.data], 'ota')[0];
                appendSentMessage(sent);
                scrollMessagesToBottom();
                bumpThreadPreview(group, sent, 'ota');
            });
        }

        function sendDirectReply(message, channel, mediaSid, translationMeta)
        {
            var group = vm.selectedThread;
            channel = channel || vm.composerChannel || 'sms';
            var conversationSid = getConversationSid(group, channel);

            if (!conversationSid) {
                vm.sendingMessage = false;
                toastMessage.showSimpleToast('No conversation found for this channel.', 'error-toast');
                return;
            }

            var payload = {
                conversation_sid: conversationSid,
                message: message || '',
                channel: channel,
                signature_applied: true
            };

            if (mediaSid) {
                payload.media_sid = mediaSid;
            }

            if (group.confirmation_number) {
                payload.confirmation_number = group.confirmation_number;
            }

            if (vm.subHotelId) {
                payload.sub_hotel_id = vm.subHotelId;
            }

            if (translationMeta) {
                payload.translation = translationMeta;
            }

            messageCenterService.sendStaffThreadMessage(payload).then(function (response) {
                vm.sendingMessage = false;
                schedulePendingMessagesRefresh();

                if (!response || response.success === false) {
                    if (isAiModeActiveError(response)) {
                        handleAiModeSendBlocked(response);
                        return;
                    }

                    if (isPhoneLinkedError(response)) {
                        handlePhoneLinkedError(response);
                        return;
                    }

                    var errorMessage = (response && response.message) || 'Unable to send message.';

                    if (isBlockingSmsError(errorMessage) && group._direct) {
                        group._direct._smsBlocked = errorMessage;
                    }

                    toastMessage.showSimpleToast(errorMessage, 'error-toast');
                    return;
                }

                clearComposerAfterSend();

                appendOutboundSendResponse(response, channel, group);
            }, function (error) {
                vm.sendingMessage = false;
                schedulePendingMessagesRefresh();
                var response = (error && error.data) ? error.data : null;

                if (isPhoneLinkedError(response)) {
                    handlePhoneLinkedError(response);
                    return;
                }

                toastMessage.showSimpleToast((response && response.message) || 'Unable to send message.', 'error-toast');
            });
        }

        function appendOutboundSendResponse(response, channel, group)
        {
            var mediaRaw = response && response.media_message;
            var textRaw = response && response.data;
            var last = null;

            // start* endpoints nest the sent payload under data.message
            if (textRaw && textRaw.message && typeof textRaw.message === 'object' && !angular.isArray(textRaw)) {
                mediaRaw = textRaw.media_message || mediaRaw;
                textRaw = textRaw.message || textRaw.sent_message || null;
            }

            if (mediaRaw) {
                last = appendSentMessage(normalizeChannelMessages([mediaRaw], channel)[0]) || last;
            }

            if (textRaw) {
                last = appendSentMessage(normalizeChannelMessages([textRaw], channel)[0]) || last;
            }

            if (last) {
                scrollMessagesToBottom();
                if (group) {
                    bumpThreadPreview(group, last, channel);
                }
            }

            return last;
        }

        function startChannelConversation(channel, firstMessage, mediaSid, translationMeta)
        {
            var group = vm.selectedThread;
            var guestPhone = getSelectedStartPhone();

            if (!group || !group.confirmation_number) {
                vm.sendingMessage = false;
                return;
            }

            channel = channel || vm.composerChannel || 'sms';

            if (!guestPhone) {
                vm.sendingMessage = false;
                toastMessage.showSimpleToast('Pick a phone number to start the conversation.', 'error-toast');
                return;
            }

            vm.sendingMessage = true;
            vm.phoneConflictMessage = '';

            // Staff threads use synthetic confirmation numbers (orgprefix + user id) —
            // always use the staff-specific start endpoint.
            var payload = {
                staff_user_id: group.staff_user_id,
                guest_phone: guestPhone,
                channel: channel === 'whatsapp' ? 'whatsapp' : 'sms',
                confirmation_number: group.confirmation_number,
                signature_applied: true
            };

            if (firstMessage) {
                payload.message = firstMessage;
            }

            if (mediaSid) {
                payload.media_sid = mediaSid;
            }

            if (vm.subHotelId) {
                payload.sub_hotel_id = vm.subHotelId;
            }

            if (translationMeta) {
                payload.translation = translationMeta;
            }

            messageCenterService.startStaffConversation(payload).then(function (response) {
                vm.sendingMessage = false;
                schedulePendingMessagesRefresh();

                if (!response || response.success === false) {
                    if (isPhoneLinkedError(response)) {
                        handlePhoneLinkedError(response);
                        return;
                    }
                    toastMessage.showSimpleToast((response && response.message) || 'Unable to start conversation.', 'error-toast');
                    return;
                }

                if (firstMessage || mediaSid) {
                    clearComposerAfterSend();
                }

                group.guest_phone = guestPhone;

                var thread = response.data && response.data.thread;
                if (thread) {
                    var mergedChannels = angular.extend({}, group.channels || {});
                    angular.forEach(thread.channels || {}, function (value, key) {
                        if (value) {
                            mergedChannels[key] = value;
                        }
                    });

                    angular.extend(group, thread);
                    group.channels = mergedChannels;
                    group._chips = computeChips(group);
                    upsertUnifiedThread(group);
                }

                vm.composerChannel = channel;
                refreshMessagingContext(group.confirmation_number);

                // Prefer the same key guest inbox uses (`message`), with staff alias fallback.
                var sentMessage = (response.data && (response.data.message || response.data.sent_message)) || null;
                var mediaMessage = response.data && response.data.media_message;
                if ((sentMessage && typeof sentMessage === 'object') || mediaMessage) {
                    appendOutboundSendResponse(response, channel, group);
                } else if (firstMessage || mediaSid) {
                    // Conversation resumed/created without an embedded send — finish via reply API.
                    vm.sendingMessage = true;
                    sendDirectReply(firstMessage, channel, mediaSid, translationMeta);
                } else {
                    loadMessages();
                }
            }, function (error) {
                vm.sendingMessage = false;
                schedulePendingMessagesRefresh();
                var response = (error && error.data) ? error.data : null;

                if (isPhoneLinkedError(response)) {
                    handlePhoneLinkedError(response);
                    return;
                }

                toastMessage.showSimpleToast((response && response.message) || 'Unable to start conversation.', 'error-toast');
            });
        }

        function bumpThreadPreview(group, sent, channel)
        {
            if (!group) {
                return;
            }

            var when = (sent && sent.inserted_at) || nowUtc();
            var isMedia = !!(sent && (sent.is_media_attached ||
                (angular.isArray(sent.media) && sent.media.length)));
            var previewText = normalizeThreadPreviewText(sent ? sent.message : '', isMedia);

            group.last_message = {
                message: previewText,
                sender: 'property',
                inserted_at: when,
                is_media_attached: isMedia ? 1 : 0
            };
            group.last_message_at = when;
            group.last_message_preview = previewText;
            group.last_is_media_attached = isMedia ? 1 : 0;
            group._activityRaw = when;
            group._activityTs = parseTs(when);
            group._lastChannel = channel;

            if (group._ota && channel === 'ota') {
                bumpOtaThreadPreview(group._ota, sent);
            }

            if (group._direct && channel !== 'ota') {
                bumpDirectThreadPreview(group._direct, sent);
            }

            if (useUnifiedApi) {
                upsertUnifiedThread(group);
            } else {
                rebuildThreadList();
            }
        }

        function bumpOtaThreadPreview(otaThread, sent)
        {
            var when = (sent && sent.inserted_at) || nowUtc();
            var isMedia = !!(sent && (sent.is_media_attached ||
                (angular.isArray(sent.media) && sent.media.length)));
            var previewText = normalizeThreadPreviewText(sent ? sent.message : '', isMedia);

            otaThread.last_message = {
                message: previewText,
                sender: 'property',
                inserted_at: when,
                is_media_attached: isMedia ? 1 : 0
            };
            otaThread.last_message_received_at = when;
            otaThread.updated_at = when;
        }

        function bumpDirectThreadPreview(directThread, sent)
        {
            var when = (sent && sent.inserted_at) || nowUtc();
            var isMedia = !!(sent && (sent.is_media_attached ||
                (angular.isArray(sent.media) && sent.media.length)));
            var previewText = normalizeThreadPreviewText(sent ? sent.message : '', isMedia);

            directThread.last_message = {
                message: previewText,
                sender: 'property',
                inserted_at: when,
                is_media_attached: isMedia ? 1 : 0
            };
            directThread.date_updated = when;
        }

        function getPhoneEditInputName()
        {
            return 'gmc_staff_phone_edit';
        }

        function getCustomSendToInputName()
        {
            return 'gmc_staff_send_to_custom';
        }

        function updatePhoneWithCountryCode(fieldName)
        {
            phoneFormatService.updateValidity(fieldName);
        }

        function isPhoneEditValid()
        {
            if (!vm.editingPhone) {
                return false;
            }

            return phoneFormatService.isValidInput(
                getPhoneEditInputName(),
                vm.phoneEditValue
            );
        }

        function isCustomSendToPhoneValid()
        {
            if (vm.sendToSource !== 'custom') {
                return true;
            }

            return phoneFormatService.isValidInput(
                getCustomSendToInputName(),
                vm.sendToCustomPhone
            );
        }

        function beginPhoneEdit()
        {
            var group = vm.selectedThread;

            if (!group) {
                return;
            }

            vm.editingPhone = true;
            vm.phoneEditValue = getThreadPhone(group) || '';
        }

        function cancelPhoneEdit()
        {
            vm.editingPhone = false;
            vm.phoneEditValue = '';
        }

        function saveGuestPhone()
        {
            var group = vm.selectedThread;
            var phone = phoneFormatService.getValidE164(
                getPhoneEditInputName(),
                vm.phoneEditValue
            );

            if (!group || !group.confirmation_number || vm.savingPhone) {
                return;
            }

            if (!phone) {
                phoneFormatService.updateValidity(getPhoneEditInputName());
                toastMessage.showSimpleToast('Enter a valid phone number with country code.', 'error-toast');
                return;
            }

            vm.phoneEditValue = phone;
            vm.savingPhone = true;

            messageCenterService.updateGuestPhone({
                confirmation_number: group.confirmation_number,
                guest_phone: phone
            }).then(function (response) {
                vm.savingPhone = false;

                if (!response || response.success === false) {
                    if (isPhoneLinkedError(response)) {
                        handlePhoneLinkedError(response);
                        return;
                    }

                    toastMessage.showSimpleToast((response && response.message) || 'Unable to update phone.', 'error-toast');
                    return;
                }

                var updatedPhone = (response.data && response.data.guest_phone) ? response.data.guest_phone : phone;
                group.guest_phone = updatedPhone;
                if (!group.channels) {
                    group.channels = {};
                }
                if (group.channels.sms) {
                    group.channels.sms.guest_phone_e164 = updatedPhone;
                }
                if (group.channels.whatsapp) {
                    group.channels.whatsapp.guest_phone_e164 = updatedPhone;
                }
                if (group._direct) {
                    group._direct.guest_phone = updatedPhone;
                }
                vm.editingPhone = false;
                vm.phoneEditValue = '';
                toastMessage.showSimpleToast('Staff phone updated.', 'success-toast');

                if (response.data && response.data.phone_change_notices && response.data.phone_change_notices.length) {
                    var notices = normalizeUnifiedMessages(response.data.phone_change_notices);
                    var addedNotices = addMessages(notices);

                    if (addedNotices.length && isMessagesAtBottom()) {
                        scrollMessagesToBottom();
                    }
                }

                refreshMessagingContext(group.confirmation_number);
            }, function (error) {
                vm.savingPhone = false;
                var response = (error && error.data) ? error.data : null;

                if (isPhoneLinkedError(response)) {
                    handlePhoneLinkedError(response);
                    return;
                }

                toastMessage.showSimpleToast((response && response.message) || 'Unable to update phone.', 'error-toast');
            });
        }

        function toggleMessagingOptOut()
        {
            var group = vm.selectedThread;

            if (!group || !group.confirmation_number || vm.updatingOptOut) {
                return;
            }

            var next = !isOptedOut(group);
            vm.updatingOptOut = true;

            messageCenterService.setMessagingOptOut({
                confirmation_number: group.confirmation_number,
                opted_out: next
            }).then(function (response) {
                vm.updatingOptOut = false;

                if (!response || response.success === false) {
                    toastMessage.showSimpleToast((response && response.message) || 'Unable to update opt-out.', 'error-toast');
                    return;
                }

                group.messaging_opt_out = next;

                var noticeText = '';
                if (response.data && response.data.notice_text) {
                    noticeText = String(response.data.notice_text).trim();
                }

                var noticePayload = response.data && (response.data.message || response.data.system_message);

                if (noticePayload && typeof noticePayload === 'object') {
                    if (!noticeText) {
                        noticeText = String(noticePayload.message || noticePayload.body || '').trim();
                    }
                    var notices = normalizeUnifiedMessages([angular.copy(noticePayload)]);
                    var added = addMessages(notices);

                    if (added.length) {
                        scrollMessagesToBottom();
                    }
                } else if (!noticeText && typeof noticePayload === 'string') {
                    noticeText = noticePayload.trim();
                }

                if (!noticeText && response.data && response.data.staff_user_name) {
                    var staffName = String(response.data.staff_user_name).trim();
                    noticeText = next
                        ? (staffName + ' opted out of direct messaging.')
                        : (staffName + ' opted back into direct messaging.');
                }

                if (!noticeText) {
                    noticeText = next
                        ? 'Opted out of direct messaging.'
                        : 'Opted back into direct messaging.';
                }

                toastMessage.showSimpleToast(noticeText, 'success-toast');
            }, function () {
                vm.updatingOptOut = false;
                toastMessage.showSimpleToast('Unable to update opt-out.', 'error-toast');
            });
        }

        function onReplyKeydown(event)
        {
            if (!event || (event.keyCode !== 13 && event.which !== 13)) {
                return;
            }

            // Enter inserts a new line; send only via the Send button.
            $timeout(resizeReplyTextarea);
        }

        function getReplyTextarea()
        {
            return document.getElementById(REPLY_TEXTAREA_ID);
        }

        function getReplyTextareaMaxHeight(textarea)
        {
            var styles = window.getComputedStyle(textarea);
            var lineHeight = parseFloat(styles.lineHeight);

            if (isNaN(lineHeight)) {
                lineHeight = parseFloat(styles.fontSize) * 1.45;
            }

            var paddingTop = parseFloat(styles.paddingTop) || 0;
            var paddingBottom = parseFloat(styles.paddingBottom) || 0;

            return Math.ceil((lineHeight * REPLY_MAX_LINES) + paddingTop + paddingBottom);
        }

        function resizeReplyTextarea()
        {
            $timeout(function () {
                var textarea = getReplyTextarea();

                if (!textarea) {
                    return;
                }

                var maxHeight = getReplyTextareaMaxHeight(textarea);

                textarea.style.height = 'auto';
                textarea.style.overflowY = 'hidden';

                if (textarea.scrollHeight > maxHeight) {
                    textarea.style.height = maxHeight + 'px';
                    textarea.style.overflowY = 'auto';
                    return;
                }

                textarea.style.height = textarea.scrollHeight + 'px';
            }, 0);
        }

        function resetReplyTextareaHeight()
        {
            $timeout(function () {
                var textarea = getReplyTextarea();

                if (!textarea) {
                    return;
                }

                textarea.style.height = '';
                textarea.style.overflowY = 'hidden';
                resizeReplyTextarea();
            }, 0);
        }

        // ---------------------------------------------------------------------
        // Display helpers
        // ---------------------------------------------------------------------

        function normalizeProviderKey(provider)
        {
            return String(provider || '')
                .toLowerCase()
                .replace(/[^a-z0-9]/g, '');
        }

        function isChannelManagerProvider(provider)
        {
            var key = normalizeProviderKey(provider);

            return key === 'channex' ||
                key === 'siteminder' ||
                key === 'staah' ||
                key === 'channelmanager' ||
                key === 'ota';
        }

        function extractSourceOfCreation(group)
        {
            if (!group) {
                return '';
            }

            var stays = group.room_stays || group.room_stay || null;
            var stay = null;
            var value = '';

            if (angular.isArray(stays) && stays.length) {
                stay = stays[0];
            } else if (stays && typeof stays === 'object') {
                stay = stays;
            }

            // Prefer room_stays.source_of_creation (reservation booking source).
            value = (stay && stay.source_of_creation) ||
                group.source_of_creation ||
                (group._ota && (
                    (group._ota.room_stays && group._ota.room_stays[0] && group._ota.room_stays[0].source_of_creation) ||
                    (group._ota.room_stay && group._ota.room_stay.source_of_creation) ||
                    group._ota.source_of_creation
                )) ||
                (group._direct && (
                    (group._direct.room_stays && group._direct.room_stays[0] && group._direct.room_stays[0].source_of_creation) ||
                    (group._direct.room_stay && group._direct.room_stay.source_of_creation) ||
                    group._direct.source_of_creation
                )) ||
                (group.channels && group.channels.ota && group.channels.ota.source_of_creation) ||
                (group.channels && group.channels.sms && group.channels.sms.source_of_creation) ||
                (group.channels && group.channels.whatsapp && group.channels.whatsapp.source_of_creation) ||
                (group.meta && group.meta.source_of_creation) ||
                (group.meta && group.meta.booking_details && group.meta.booking_details.source_of_creation) ||
                '';

            return String(value || '').replace(/^\s+|\s+$/g, '');
        }

        function getProviderLabel(provider)
        {
            var key = normalizeProviderKey(provider);

            if (!key || isChannelManagerProvider(provider)) {
                return '';
            }

            // room_stays.source_of_creation values: Booking, Expedia, Airbnb, PMS, FE, ...
            if (key === 'booking' || key.indexOf('booking') !== -1 || key === 'bdc') {
                return 'Booking.com';
            }

            if (key === 'airbnb' || key.indexOf('airbnb') !== -1 || key.indexOf('airbn') !== -1 || key === 'abb') {
                return 'Airbnb';
            }

            if (key === 'expedia' || key.indexOf('expedia') !== -1 || key === 'exp') {
                return 'Expedia';
            }

            if (key === 'fe' || key === 'pms' || key === 'direct' || key === 'sms' || key === 'whatsapp') {
                return 'Direct';
            }

            if (key.indexOf('hoteltonight') !== -1) {
                return 'Hoteltonight';
            }

            if (key.indexOf('priceline') !== -1) {
                return 'Priceline';
            }

            if (key.indexOf('agoda') !== -1) {
                return 'Agoda';
            }

            return provider;
        }

        function getProviderClass(provider)
        {
            var label = getProviderLabel(provider);

            if (label === 'Booking.com') {
                return 'is-booking';
            }

            if (label === 'Airbnb') {
                return 'is-airbnb';
            }

            if (label === 'Expedia') {
                return 'is-expedia';
            }

            if (label === 'Direct') {
                return 'is-direct';
            }

            return 'is-default';
        }

        function computeChips(group)
        {
            var chips = [];
            var source = '';
            var label = '';
            var hasDirectChannel = false;

            if (!group) {
                return chips;
            }

            source = extractSourceOfCreation(group);
            label = getProviderLabel(source);
            hasDirectChannel = !!(group.channels && (group.channels.sms || group.channels.whatsapp)) ||
                !!group._direct;

            // Booking.com / Expedia / Airbnb from room_stays.source_of_creation
            if (label && label !== 'Direct') {
                chips.push({
                    label: label,
                    cls: getProviderClass(source)
                });
            }

            // Direct: SMS/WhatsApp, or PMS/FE source_of_creation
            if (hasDirectChannel || label === 'Direct') {
                chips.push({
                    label: 'Direct',
                    cls: 'is-direct'
                });
            }

            return chips;
        }

        function getThreadChips(group)
        {
            return (group && group._chips) ? group._chips : [];
        }

        function getThreadSourceChip(group)
        {
            var chips = getThreadChips(group);
            var i;

            for (i = 0; i < chips.length; i++) {
                if (chips[i] && chips[i].label && chips[i].label !== 'Direct') {
                    return chips[i];
                }
            }

            return chips.length ? chips[0] : null;
        }

        function showMessageChannel(message)
        {
            // Always show channel tags when more than one channel exists, or channel is explicit.
            if (!message || message.sender === 'system') {
                return false;
            }

            return isMergedThread(vm.selectedThread) || !!(message.channel || message._channel);
        }

        function getMessageChannelLabel(message)
        {
            if (!message) {
                return '';
            }

            var channel = message._channel || message.channel;

            if (channel === 'sms' || channel === 'direct') {
                if (channel === 'direct' && vm.selectedThread && vm.selectedThread.channel === 'whatsapp') {
                    return 'WhatsApp';
                }
                return channel === 'whatsapp' ? 'WhatsApp' : 'SMS';
            }

            if (channel === 'whatsapp') {
                return 'WhatsApp';
            }

            return getProviderLabel(
                extractSourceOfCreation(vm.selectedThread) ||
                (vm.selectedThread && vm.selectedThread.provider)
            ) || '';
        }

		function getMessageChannelClass(message)
		{
			if (!message) {
				return 'is-default';
			}

			var channel = message._channel || message.channel;

			if (channel === 'whatsapp') {
				return 'is-whatsapp';
			}

			if (channel === 'sms' || channel === 'direct') {
				if (channel === 'direct' && vm.selectedThread && vm.selectedThread.channel === 'whatsapp') {
					return 'is-whatsapp';
				}
				return 'is-sms';
			}

			// Match sidebar/header chips: use booking source (Expedia/Booking/etc), not Channex provider.
			return getProviderClass(
				extractSourceOfCreation(vm.selectedThread) ||
				(vm.selectedThread && vm.selectedThread.provider)
			);
		}

        function getThreadTitle(group)
        {
            if (!group) {
                return '';
            }

            var name = group.guest_name || group.title || '';
            var room = getRoomLabel(group);

            if (name && room) {
                return name + ' · Room ' + room;
            }

            return name || group.guest_phone || group.confirmation_number || '';
        }

        function getRoomLabel(group)
        {
            if (!group) {
                return '';
            }

            return group.room_number || group.product_room_number || '';
        }

        /** Phone linked to SMS/WhatsApp thread — not reservation guest phone. */
        function getThreadPhone(group)
        {
            group = group || vm.selectedThread;

            if (!group) {
                return '';
            }

            var channels = group.channels || {};
            var phone =
                (channels.sms && channels.sms.guest_phone_e164) ||
                (channels.whatsapp && channels.whatsapp.guest_phone_e164) ||
                (group._direct && group._direct.guest_phone) ||
                '';

            // After start/edit, guest_phone may already be the thread number.
            if (!phone && group.guest_phone &&
                ((channels.sms && channels.sms.conversation_sid) ||
                    (channels.whatsapp && channels.whatsapp.conversation_sid) ||
                    (group._direct && group._direct.conversation_sid))) {
                phone = group.guest_phone;
            }

            return String(phone || '').replace(/^\s+|\s+$/g, '');
        }

        function getThreadSubtitle(group)
        {
            return formatPhoneNumber(getThreadPhone(group));
        }

        function getThreadActivity(group)
        {
            return group ? (group._activityRaw || group.last_message_at || '') : '';
        }

        function getGuestInitial(group)
        {
            if (!group) {
                return '?';
            }

            var first = String(group.first_name || '').trim().charAt(0);
            var last = String(group.last_name || '').trim().charAt(0);
            var initials = (first + last).toUpperCase();

            if (initials.length === 2) {
                return initials;
            }

            var name = String(group.guest_name || group.title || '').trim();

            // Strip "· Room NNN" / "- Room NNN" suffixes from display titles.
            name = name.replace(/\s*[·\-–]\s*Room\s+.*/i, '').trim();

            if (!name) {
                name = String(group.confirmation_number || group.guest_phone || '').trim();
            }

            if (!name) {
                return '?';
            }

            if (/^\+?\d/.test(name)) {
                return '#';
            }

            var parts = name.split(/\s+/).filter(Boolean);

            if (parts.length >= 2) {
                return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
            }

            return (parts[0].charAt(0) + (parts[0].charAt(1) || '')).toUpperCase() || '?';
        }

        var AVATAR_COLORS = [
            '#00bcd4',
            '#00acc1',
            '#00838f',
            '#039be5',
            '#0277bd',
            '#1565c0',
            '#3470ca',
            '#2d323e',
            '#3c4252',
            '#43a047',
            '#c62828',
            '#e65100'
        ];

        function getAvatarStyle(group)
        {
            var seed = '';

            if (group) {
                seed = String(
                    group.confirmation_number ||
                    group.guest_name ||
                    group.title ||
                    group.guest_phone ||
                    getGuestInitial(group) ||
                    ''
                );
            }

            var hash = 0;
            var i;

            for (i = 0; i < seed.length; i++) {
                hash = ((hash << 5) - hash) + seed.charCodeAt(i);
                hash |= 0;
            }

            var color = AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];

            return {
                background: color
            };
        }

        function getThreadHotelTitle(group)
        {
            var hotelTitle;
            var i;

            if (!group) {
                return '';
            }

            if (group.hotel_title) {
                return group.hotel_title;
            }

            if (group.hotel_id && vm.subHotels && vm.subHotels.length) {
                for (i = 0; i < vm.subHotels.length; i++) {
                    if (parseInt(vm.subHotels[i].hotel_id, 10) === parseInt(group.hotel_id, 10)) {
                        return vm.subHotels[i].hotel_title || '';
                    }
                }
            }

            if ($localStorage.hotels && $localStorage.hotels[$localStorage.selectedHotel]) {
                hotelTitle = $localStorage.hotels[$localStorage.selectedHotel].hotel_title;
                if (hotelTitle) {
                    return hotelTitle;
                }
            }

            return '';
        }

        /**
         * Display UTC inserted_at converted to the current PC/browser timezone.
         */
        function formatDate(value)
        {
            var local = toLocalMoment(value);
            return local ? local.format('MMM D, YYYY h:mm A') : '';
        }

        function formatShortDate(value)
        {
            var local = toLocalMoment(value);
            return local ? local.format('MMM D') : '';
        }

        function getInquiryDetails(message)
        {
            if (!message || !message.meta || !message.meta.booking_details) {
                return null;
            }

            return message.meta.booking_details;
        }

        function getStayField(source, type)
        {
            if (!source) {
                return null;
            }

            var checkInKeys = ['checkin_date', 'check_in_date', 'check_in', 'room_stay_from', 'arrival_date', 'arrival_time'];
            var checkOutKeys = ['checkout_date', 'check_out_date', 'check_out', 'room_stay_to', 'departure_date', 'departure_time'];
            var keys = type === 'in' ? checkInKeys : checkOutKeys;
            var i;

            for (i = 0; i < keys.length; i++) {
                if (source[keys[i]]) {
                    return source[keys[i]];
                }
            }

            if (source.meta && source.meta.booking_details) {
                return type === 'in'
                    ? source.meta.booking_details.checkin_date
                    : source.meta.booking_details.checkout_date;
            }

            if (source.booking_details) {
                return type === 'in'
                    ? source.booking_details.checkin_date
                    : source.booking_details.checkout_date;
            }

            return null;
        }

        function getThreadCheckIn(group)
        {
            return getStayField(group, 'in');
        }

        function getThreadCheckOut(group)
        {
            return getStayField(group, 'out');
        }

        function getDisplayCheckIn()
        {
            return getThreadCheckIn(vm.selectedThread) ||
                (vm.messageStayDates && vm.messageStayDates.checkin_date) ||
                (vm.reservationStayDates && vm.reservationStayDates.checkin_date);
        }

        function getDisplayCheckOut()
        {
            return getThreadCheckOut(vm.selectedThread) ||
                (vm.messageStayDates && vm.messageStayDates.checkout_date) ||
                (vm.reservationStayDates && vm.reservationStayDates.checkout_date);
        }

        function hasStayDates(group)
        {
            if (group) {
                return !!(getThreadCheckIn(group) || getThreadCheckOut(group));
            }

            return !!(getDisplayCheckIn() || getDisplayCheckOut());
        }

        function parseStayDate(value)
        {
            if (!value) {
                return null;
            }

            if (moment.isMoment(value)) {
                return value.isValid() ? value : null;
            }

            if (value instanceof Date) {
                return isNaN(value.getTime()) ? null : moment(value);
            }

            if (typeof value !== 'string') {
                return null;
            }

            var trimmed = value.trim();

            if (!trimmed || trimmed.indexOf('0000-00-00') === 0) {
                return null;
            }

            var parsed = moment(trimmed, [
                'MM/DD/YYYY',
                'M/D/YYYY',
                'MM/DD/YYYY HH:mm:ss',
                'M/D/YYYY HH:mm:ss',
                'YYYY-MM-DD',
                'YYYY-MM-DD HH:mm:ss',
                'YYYY/MM/DD',
                'DD-MM-YYYY',
                'DD/MM/YYYY',
                moment.ISO_8601
            ], true);

            if (parsed.isValid()) {
                return parsed;
            }

            parsed = moment(trimmed);

            return parsed.isValid() ? parsed : null;
        }

        function formatStayDate(value)
        {
            var parsed = parseStayDate(value);

            if (!parsed) {
                return '';
            }

            return parsed.format('MMM D, YYYY');
        }

        function formatStayDateRange(checkIn, checkOut)
        {
            var inParsed = parseStayDate(checkIn);
            var outParsed = parseStayDate(checkOut);

            if (inParsed && outParsed) {
                if (inParsed.year() === outParsed.year()) {
                    return inParsed.format('MMM D') + ' \u2013 ' + outParsed.format('MMM D, YYYY');
                }

                return inParsed.format('MMM D, YYYY') + ' \u2013 ' + outParsed.format('MMM D, YYYY');
            }

            if (inParsed) {
                return inParsed.format('MMM D, YYYY');
            }

            if (outParsed) {
                return outParsed.format('MMM D, YYYY');
            }

            return '';
        }

        function hasFormattedStayDate(value)
        {
            return !!formatStayDate(value);
        }

        function hasHeaderStayInfo()
        {
            return hasFormattedStayDate(getDisplayCheckIn()) ||
                hasFormattedStayDate(getDisplayCheckOut()) ||
                !!getReservationStatus() ||
                !!(vm.selectedThread && vm.selectedThread.confirmation_number);
        }

        function getReservationStatus(group)
        {
            if (group) {
                return group.room_stay_status || null;
            }

            if (vm.selectedThread && vm.selectedThread.room_stay_status) {
                return vm.selectedThread.room_stay_status;
            }

            return vm.reservationStayDates && vm.reservationStayDates.room_stay_status
                ? vm.reservationStayDates.room_stay_status
                : null;
        }

        function normalizeStayStatusKey(status)
        {
            if (!status) {
                return null;
            }

            var normalized = String(status).toLowerCase().replace(/[\s_]+/g, '-');

            if (normalized.indexOf('check') !== -1 && normalized.indexOf('out') !== -1) {
                return 'checked-out';
            }

            if (normalized.indexOf('check') !== -1 && normalized.indexOf('in') !== -1) {
                return 'checked-in';
            }

            if (normalized === 'canceled' || normalized === 'cancelled') {
                return 'canceled';
            }

            if (normalized === 'closed') {
                return 'checked-out';
            }

            if (normalized === 'active') {
                return 'active';
            }

            return 'active';
        }

        function getStayCheckInForStatus(group)
        {
            if (group) {
                return getThreadCheckIn(group);
            }

            return getDisplayCheckIn();
        }

        function getStayCheckOutForStatus(group)
        {
            if (group) {
                return getThreadCheckOut(group);
            }

            return getDisplayCheckOut();
        }

        function getStayStatus(group)
        {
            var apiStatus = getReservationStatus(group);

            if (apiStatus) {
                return normalizeStayStatusKey(apiStatus);
            }

            var checkIn = parseStayDate(getStayCheckInForStatus(group));
            var checkOut = parseStayDate(getStayCheckOutForStatus(group));
            var today = moment().startOf('day');

            if (!checkIn && !checkOut) {
                return null;
            }

            if (checkOut && today.isSameOrAfter(checkOut.clone().startOf('day'))) {
                return 'checked-out';
            }

            if (checkIn && today.isSameOrAfter(checkIn.clone().startOf('day'))) {
                if (!checkOut || today.isBefore(checkOut.clone().startOf('day'))) {
                    return 'checked-in';
                }
            }

            return 'active';
        }

        function getStayStatusLabel(group)
        {
            var apiStatus = getReservationStatus(group);

            if (apiStatus) {
                return apiStatus;
            }

            var status = getStayStatus(group);

            if (status === 'checked-in') {
                return 'Checked In';
            }

            if (status === 'checked-out') {
                return 'Checked Out';
            }

            if (status === 'canceled') {
                return 'Canceled';
            }

            if (status === 'active') {
                return 'Active';
            }

            return '';
        }

        function getStayStatusClass(group)
        {
            var status = getStayStatus(group);

            if (!status) {
                return 'is-default';
            }

            return 'is-' + status;
        }

        function openReservation()
        {
            if (!vm.selectedThread || !vm.selectedThread.confirmation_number) {
                return;
            }

            $rootScope.goToState('', vm.selectedThread.confirmation_number, '');
        }

        function openUserDetail()
        {
            var userId = vm.selectedThread && vm.selectedThread.staff_user_id;

            if (!userId) {
                return;
            }

            $state.go('app.user_detail_edit', {
                user_id: userId
            });
        }

        function hasUnread(group)
        {
            return getThreadUnreadCount(group) > 0;
        }

        function getUnreadLabel(group)
        {
            var count = getThreadUnreadCount(group);

            if (count <= 0) {
                return '';
            }

            return count > 99 ? '99+' : String(count);
        }

        function getMessageText(message)
        {
            if (!message) {
                return '';
            }

            if (message._showTranslation && message._translatedText) {
                return String(message._translatedText);
            }

            if (
                message._showOriginal &&
                message.translation &&
                message.translation.original_text
            ) {
                return String(message.translation.original_text);
            }

            if (message.message === null || message.message === undefined) {
                return '';
            }

            var text = String(message.message).replace(/^\s+|\s+$/g, '');

            if (isSupportEscalation(message) && text && text.indexOf('Escalation:') !== 0) {
                return 'Escalation: ' + text;
            }

            return text;
        }

        function getLanguageName(code)
        {
            code = String(code || '').trim();
            if (!code) {
                return '';
            }
            var i;
            for (i = 0; i < (vm.translateLanguages || []).length; i++) {
                if (String(vm.translateLanguages[i].code).toLowerCase() === code.toLowerCase()) {
                    return vm.translateLanguages[i].name;
                }
            }
            return code.toUpperCase();
        }

        function filterTranslateLanguages(lang)
        {
            if (!lang) {
                return false;
            }

            var term = (vm.translateLangSearchText || '').toLowerCase().trim();
            if (!term) {
                return true;
            }

            var name = lang.name ? String(lang.name).toLowerCase() : '';
            var code = lang.code ? String(lang.code).toLowerCase() : '';
            return name.indexOf(term) !== -1 || code.indexOf(term) !== -1;
        }

        function clearTranslateLangSearch()
        {
            vm.translateLangSearchText = '';
        }

        function getDetectedLanguageLabel(message)
        {
            if (!message || !message.detected_language) {
                return '';
            }
            return getLanguageName(message.detected_language);
        }

        function getTranslationBadgeLabel(message)
        {
            if (!message || !message.translation || !message.translation.target_language) {
                return '';
            }
            return getLanguageName(message.translation.target_language);
        }

        function formatLanguageDirection(fromCode, toCode)
        {
            var from = fromCode ? getLanguageName(fromCode) : '';
            var to = toCode ? getLanguageName(toCode) : '';
            if (from && to) {
                if (String(fromCode).toLowerCase() === String(toCode).toLowerCase()) {
                    return from;
                }
                return from + ' -> ' + to;
            }
            return to || from || '';
        }

        function getMessageLanguageTag(message)
        {
            if (!message) {
                return '';
            }

            // On-demand bubble translation currently shown: "Arabic -> English"
            if (message._showTranslation && message._translatedLang) {
                return formatLanguageDirection(
                    message._translatedSource || message.detected_language ||
                        (message.translation && message.translation.source_language) || '',
                    message._translatedLang
                );
            }

            return '';
        }

        function getSentTranslationLanguageLabel(message)
        {
            if (
                !message ||
                message._showTranslation ||
                message._showOriginal ||
                !message.translation ||
                !message.translation.target_language
            ) {
                return '';
            }
            return getLanguageName(message.translation.target_language);
        }

        function canTranslateMessage(message)
        {
            if (!message || message.sender === 'system') {
                return false;
            }
            // Guest + outbound (property/AI): translate for viewing when message has text
            var text = String(message.message || '').replace(/^\s+|\s+$/g, '');
            return !!text;
        }

        function toggleMessageTranslatePanel($event, message)
        {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            if (!message) {
                return;
            }

            if (message._translateOpen) {
                closeMessageTranslatePopup();
                return;
            }

            closeMessageTranslatePopup();
            closeComposerTranslate();

            var triggerEl = $event && $event.currentTarget
                ? $event.currentTarget
                : null;
            message._translatePlacement = resolveTranslatePopupPlacement(triggerEl);
            message._translateOpen = true;
            if (!message._translateTarget) {
                message._translateTarget = 'en';
            }
            translatePopupMessage = message;
            bindTranslateDocClick();
            loadTranslateLanguages();

            // Refine after render using the real popup size.
            $timeout(function () {
                if (!message._translateOpen || !triggerEl) {
                    return;
                }
                var refined = resolveTranslatePopupPlacement(triggerEl, true);
                if (refined && refined !== message._translatePlacement) {
                    message._translatePlacement = refined;
                }
            }, 0);
        }

        function resolveTranslatePopupPlacement(triggerEl, useRenderedSize)
        {
            var fallback = 'top';
            if (!triggerEl || !triggerEl.getBoundingClientRect) {
                return fallback;
            }

            var triggerRect = triggerEl.getBoundingClientRect();
            var container = triggerEl.closest
                ? triggerEl.closest('.gmc-messages')
                : null;
            if (!container) {
                var node = triggerEl.parentElement;
                while (node) {
                    if (node.classList && node.classList.contains('gmc-messages')) {
                        container = node;
                        break;
                    }
                    node = node.parentElement;
                }
            }
            if (!container) {
                return fallback;
            }

            var containerRect = container.getBoundingClientRect();
            var gap = 8;
            var popupWidth = 236;
            var popupHeight = 220;

            if (useRenderedSize) {
                var popupEl = triggerEl.parentElement
                    ? triggerEl.parentElement.querySelector('.gmc-msg-translate-popup')
                    : null;
                if (popupEl) {
                    var popupRect = popupEl.getBoundingClientRect();
                    if (popupRect.width > 0) {
                        popupWidth = popupRect.width;
                    }
                    if (popupRect.height > 0) {
                        popupHeight = popupRect.height;
                    }
                }
            }

            var space = {
                top: triggerRect.top - containerRect.top - gap,
                bottom: containerRect.bottom - triggerRect.bottom - gap,
                left: triggerRect.left - containerRect.left - gap,
                right: containerRect.right - triggerRect.right - gap
            };

            // Guest bubbles open left-aligned; staff/right bubbles flip with CSS.
            var isRightAligned = !!(
                triggerEl.closest &&
                (triggerEl.closest('.align-right') || triggerEl.closest('.from-property'))
            );
            var horizontalRoom = isRightAligned
                ? (triggerRect.right - containerRect.left)
                : (containerRect.right - triggerRect.left);
            // Side popups grow downward from the trigger top.
            var verticalRoomForSide = containerRect.bottom - triggerRect.top - gap;

            // Prefer top, then right, then bottom, then left.
            var order = ['top', 'right', 'bottom', 'left'];
            var i;
            var side;
            for (i = 0; i < order.length; i++) {
                side = order[i];
                if (side === 'top' || side === 'bottom') {
                    if (space[side] >= popupHeight && horizontalRoom >= popupWidth) {
                        return side;
                    }
                } else if (space[side] >= popupWidth && verticalRoomForSide >= popupHeight) {
                    return side;
                }
            }

            // Nothing fits fully — pick the side with the most usable room.
            // Avoid left for left-aligned guest bubbles when right has any room.
            var best = fallback;
            var bestScore = -1;
            var score;
            for (i = 0; i < order.length; i++) {
                side = order[i];
                if (side === 'left' && !isRightAligned && space.right > space.left) {
                    continue;
                }
                if (side === 'right' && isRightAligned && space.left > space.right) {
                    continue;
                }
                score = space[side];
                if (score > bestScore) {
                    bestScore = score;
                    best = side;
                }
            }
            return best;
        }

        function closeMessageTranslatePopup()
        {
            clearTranslateLangSearch();
            if (translatePopupMessage) {
                translatePopupMessage._translateOpen = false;
                translatePopupMessage._translatePlacement = null;
                translatePopupMessage = null;
            }
            angular.forEach(vm.messages || [], function (msg) {
                if (msg) {
                    msg._translateOpen = false;
                    msg._translatePlacement = null;
                }
            });
            unbindTranslateDocClickIfIdle();
        }

        function translateMessageBubble(message)
        {
            if (!message || message._translating) {
                return;
            }

            var target = message._translateTarget || 'en';
            var text = String(message.message || '').replace(/^\s+|\s+$/g, '');
            if (!text) {
                return;
            }

            if (message._showTranslation && message._translatedLang === target) {
                message._showTranslation = false;
                return;
            }

            if (message._translationsCache && message._translationsCache[target]) {
                message._translatedText = message._translationsCache[target].text ||
                    message._translationsCache[target];
                message._translatedSource = message._translationsCache[target].source ||
                    message._translatedSource ||
                    message.detected_language ||
                    '';
                message._translatedLang = target;
                message._showTranslation = true;
                message._showOriginal = false;
                closeMessageTranslatePopup();
                return;
            }

            message._translating = true;
            messageCenterService.translateText({
                text: text,
                target_language: target,
                message_id: message.local_id || message.id || undefined
            }).then(function (response) {
                message._translating = false;
                if (!response || response.success === false) {
                    toastMessage.showSimpleToast(
                        (response && response.message) || 'Unable to translate message.',
                        'error-toast'
                    );
                    return;
                }
                var data = response.data || {};
                var translated = data.translated_text || '';
                var source = data.source_language || data.detected_language || '';
                if (!message._translationsCache) {
                    message._translationsCache = {};
                }
                message._translationsCache[target] = {
                    text: translated,
                    source: source
                };
                message._translatedText = translated;
                message._translatedLang = target;
                message._translatedSource = source;
                message._showTranslation = true;
                message._showOriginal = false;
                if (source) {
                    message.detected_language = message.detected_language || source;
                }
                closeMessageTranslatePopup();
            }, function () {
                message._translating = false;
                toastMessage.showSimpleToast('Unable to translate message.', 'error-toast');
            });
        }

        function toggleMessageOriginal(message)
        {
            if (!message) {
                return;
            }
            if (message.translation && message.translation.original_text) {
                message._showOriginal = !message._showOriginal;
                message._showTranslation = false;
                return;
            }
            if (message._showTranslation) {
                message._showTranslation = false;
            }
        }

        function toggleComposerTranslate($event)
        {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            if (vm.composerTranslateOpen) {
                closeComposerTranslate();
                return;
            }

            closeMessageTranslatePopup();
            vm.composerTranslateOpen = true;
            bindTranslateDocClick();
            loadTranslateLanguages();
        }

        function closeComposerTranslate()
        {
            vm.composerTranslateOpen = false;
            clearTranslateLangSearch();
            unbindTranslateDocClickIfIdle();
        }

        function bindTranslateDocClick()
        {
            unbindTranslateDocClick();
            translateDocClickHandler = function ()
            {
                $scope.$applyAsync(function () {
                    closeMessageTranslatePopup();
                    closeComposerTranslate();
                });
            };
            $timeout(function () {
                $document.on('click', translateDocClickHandler);
            }, 0);
        }

        function unbindTranslateDocClick()
        {
            if (translateDocClickHandler) {
                $document.off('click', translateDocClickHandler);
                translateDocClickHandler = null;
            }
        }

        function unbindTranslateDocClickIfIdle()
        {
            if (!vm.composerTranslateOpen && !translatePopupMessage) {
                unbindTranslateDocClick();
            }
        }

        function clearReplyTranslation()
        {
            vm.replyTranslation = null;
        }

        function translateComposerDraft()
        {
            var name = getComposerStaffName();
            var parts = messageCenterComposerSignature.split(vm.replyText, name);
            var text = String(parts.body || '').replace(/^\s+|\s+$/g, '');
            var target = vm.composerTranslateLang || 'en';

            if (!text || vm.composerTranslating) {
                return;
            }

            vm.composerTranslating = true;
            messageCenterService.translateText({
                text: text,
                target_language: target
            }).then(function (response) {
                vm.composerTranslating = false;
                if (!response || response.success === false) {
                    toastMessage.showSimpleToast(
                        (response && response.message) || 'Unable to translate draft.',
                        'error-toast'
                    );
                    return;
                }
                var data = response.data || {};
                var translatedBody = String(data.translated_text || '').replace(/^\s+|\s+$/g, '');
                var outboundOriginal = messageCenterComposerSignature.toOutboundMessage(vm.replyText, name);
                var keepSignature = !!(parts.hasSignature && name);
                var outboundTranslated = translatedBody
                    ? (keepSignature ? (translatedBody + ' - ' + name) : translatedBody)
                    : '';

                vm.replyTranslation = {
                    text: outboundTranslated,
                    target_language: data.target_language || target,
                    source_language: data.source_language || '',
                    original_text: outboundOriginal
                };
                closeComposerTranslate();
            }, function () {
                vm.composerTranslating = false;
                toastMessage.showSimpleToast('Unable to translate draft.', 'error-toast');
            });
        }

        function buildOutboundTranslationMeta(originalText)
        {
            if (!vm.replyTranslation || !vm.replyTranslation.text) {
                return null;
            }
            return {
                original_text: originalText || vm.replyTranslation.original_text || '',
                source_language: vm.replyTranslation.source_language || '',
                target_language: vm.replyTranslation.target_language || ''
            };
        }

        function resolveOutboundMessageBody(draftText)
        {
            if (vm.replyTranslation && vm.replyTranslation.text) {
                return String(vm.replyTranslation.text);
            }
            return draftText;
        }

        function normalizeTranslateLanguages(list)
        {
            var seen = {};
            var out = [];
            angular.forEach(list || [], function (lang) {
                if (!lang || !lang.code) {
                    return;
                }
                var code = String(lang.code);
                var key = code.toLowerCase();
                if (seen[key]) {
                    return;
                }
                seen[key] = true;
                out.push({
                    code: code,
                    name: lang.name || code.toUpperCase()
                });
            });
            return out;
        }

        function applyTranslateLanguages(response)
        {
            if (response && response.success !== false && angular.isArray(response.data) && response.data.length) {
                var normalized = normalizeTranslateLanguages(response.data);
                if (normalized.length) {
                    vm.translateLanguages = normalized;
                    vm.translateLanguagesLoaded = true;
                }
            }
            return vm.translateLanguages;
        }

        function loadTranslateLanguages()
        {
            if (vm.translateLanguagesLoaded && vm.translateLanguages.length) {
                return $q.resolve(vm.translateLanguages);
            }

            vm.translateLanguagesLoading = true;
            return messageCenterService.getTranslateLanguages().then(function (response) {
                vm.translateLanguagesLoading = false;
                return applyTranslateLanguages(response);
            }, function () {
                vm.translateLanguagesLoading = false;
                return vm.translateLanguages;
            });
        }

        function getMessageMediaItems(message)
        {
            if (!message || !angular.isArray(message.media)) {
                return [];
            }

            return message.media.filter(function (item) {
                return item && item.sid;
            });
        }

        function hasMessageMedia(message)
        {
            return getMessageMediaItems(message).length > 0;
        }

        var MEDIA_PRELOAD_CONCURRENCY = 3;
        var mediaPreloadActive = 0;
        var mediaPreloadQueue = [];

        function preloadVisibleMessageMedia(messages)
        {
            var list = messages || vm.messages || [];
            var i;

            for (i = 0; i < list.length; i++) {
                enqueueMessageMediaPreload(list[i]);
            }
        }

        function enqueueMessageMediaPreload(message)
        {
            if (!message || !hasMessageMedia(message)) {
                return;
            }

            if (message._mediaExpanded || message._mediaLoading || message._mediaQueued) {
                return;
            }

            message._mediaError = false;
            message._mediaQueued = true;
            mediaPreloadQueue.push(message);
            drainMessageMediaPreloadQueue();
        }

        function drainMessageMediaPreloadQueue()
        {
            var message;

            while (mediaPreloadActive < MEDIA_PRELOAD_CONCURRENCY && mediaPreloadQueue.length) {
                message = mediaPreloadQueue.shift();
                if (!message) {
                    continue;
                }

                message._mediaQueued = false;

                if (message._mediaExpanded || message._mediaLoading || !hasMessageMedia(message)) {
                    continue;
                }

                mediaPreloadActive += 1;
                fetchMessageMedia(message).then(function () {
                    mediaPreloadActive = Math.max(0, mediaPreloadActive - 1);
                    drainMessageMediaPreloadQueue();
                }, function () {
                    mediaPreloadActive = Math.max(0, mediaPreloadActive - 1);
                    drainMessageMediaPreloadQueue();
                });
            }
        }

        function fetchMessageMedia(message, item)
        {
            var items = getMessageMediaItems(message);
            var mediaItem = item || items[0];

            if (!message || !mediaItem || !mediaItem.sid) {
                return $q.resolve();
            }

            if (message._mediaExpanded && message._mediaPreviewUrl) {
                return $q.resolve();
            }

            message._mediaLoading = true;
            message._mediaError = false;

            return messageCenterService.getSmsMedia(mediaItem.sid, vm.subHotelId).then(function (response) {
                message._mediaLoading = false;

                if (!response || response.success === false || !response.data || !response.data.url) {
                    message._mediaError = true;
                    return;
                }

                message._mediaExpanded = true;
                message._mediaPreviewUrl = response.data.url;
                message._mediaPreviewItem = mediaItem;
            }, function () {
                message._mediaLoading = false;
                message._mediaError = true;
            });
        }

        function expandMessageMedia(message, item)
        {
            if (!message || !hasMessageMedia(message)) {
                return;
            }

            if (message._mediaExpanded && message._mediaPreviewUrl) {
                return;
            }

            if (message._mediaLoading) {
                return;
            }

            message._mediaQueued = false;
            message._mediaError = false;
            mediaPreloadQueue = mediaPreloadQueue.filter(function (queued) {
                return queued !== message;
            });
            enqueueMessageMediaPreload(message);
        }

        function openImagePreview(ev, imageUrl)
        {
            if (!imageUrl) {
                return;
            }

            if (ev && ev.stopPropagation) {
                ev.stopPropagation();
            }

            $mdDialog.show({
                controller: 'GmcMediaPreviewDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/guest-message-center/dialogs/media-preview/media-preview.dialog.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Image: imageUrl
                }
            });
        }

        function openMessageMedia(ev, message)
        {
            openImagePreview(ev, message && message._mediaPreviewUrl);
        }

        function openPendingMedia(ev)
        {
            openImagePreview(ev, vm.pendingMedia && vm.pendingMedia.previewUrl);
        }

        function isSupportEscalation(message)
        {
            return !!(message && message.sender === 'system' &&
                message.event_type === 'support_escalation');
        }

        function isPhoneChangeNotice(message)
        {
            if (!message || message.sender !== 'system') {
                return false;
            }

            return message.event_type === 'guest_phone_changed' || message.event_type === 'guest_phone_set';
        }

        function getPhoneChangeNoticeText(message)
        {
            if (!message) {
                return '';
            }

            var rawText = message.message || message.body;
            if (rawText) {
                var text = rawText;
                if (message.old_phone) {
                    text = text.replace(message.old_phone, formatPhoneNumber(message.old_phone));
                }
                if (message.new_phone) {
                    text = text.replace(message.new_phone, formatPhoneNumber(message.new_phone));
                }
                return text;
            }

            if (message.event_type === 'guest_phone_set' && message.new_phone) {
                return 'Phone number set to ' + formatPhoneNumber(message.new_phone);
            }

            if (message.old_phone && message.new_phone) {
                return 'Phone number changed from ' + formatPhoneNumber(message.old_phone) +
                    ' to ' + formatPhoneNumber(message.new_phone);
            }

            return getMessageText(message);
        }

        function formatPhoneNumber(phoneNumber)
        {
            return phoneFormatService.format(phoneNumber);
        }

        function getLastMessageDirectionIcon(group)
        {
            if (!group || !group.last_message) {
                return '';
            }

            var sender = group.last_message.sender;

            if (sender !== 'property' && sender !== 'hotel' && sender !== 'ai') {
                return '';
            }

            return 'icon-reply';
        }

        function normalizeThreadPreviewText(text, isMedia)
        {
            var preview = text == null ? '' : String(text).trim();

            if (isMedia && (
                !preview ||
                preview === '[Image]' ||
                preview === 'Photo' ||
                preview === '—' ||
                preview === '-' ||
                preview.toUpperCase() === 'IMAGE'
            )) {
                return 'IMAGE';
            }

            return preview;
        }

        function isLastMessageMedia(group)
        {
            if (!group) {
                return false;
            }

            if (group.last_is_media_attached) {
                return true;
            }

            if (group.last_message) {
                if (group.last_message.is_media_attached || hasMessageMedia(group.last_message)) {
                    return true;
                }

                var msg = group.last_message.message;
                if (msg === 'Photo' || msg === '[Image]' || msg === 'IMAGE') {
                    return true;
                }
            }

            return false;
        }

        function getThreadPreviewText(group)
        {
            if (!group) {
                return '';
            }

            var text = '';

            if (group.last_message && group.last_message.message != null) {
                text = String(group.last_message.message).trim();
            } else if (group.last_message_preview) {
                text = String(group.last_message_preview).trim();
            }

            return normalizeThreadPreviewText(text, isLastMessageMedia(group));
        }

        // ---------------------------------------------------------------------
        // New conversation dialog
        // ---------------------------------------------------------------------

        function openNewStaffConversationDialog(ev)
        {
            if (!showDirectFeatures() || !vm.canSendDirect) {
                return;
            }

            $mdDialog.show({
                controller: 'NewStaffConversationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/guest-message-center/staff-messages/dialogs/new-staff-conversation/new-staff-conversation.dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    subHotelId: vm.subHotelId || null,
                    smsEnabled: !!vm.smsEnabled,
                    whatsappEnabled: !!vm.whatsappEnabled
                }
            }).then(function (result) {
                if (result) {
                    onConversationStarted(result);
                }
            }, function () {
                // dialog dismissed
            });
        }

        function openGroupMessageLogs()
        {
            $state.go('app.guest-message-center.group-message-logs');
        }

        /**
         * Map startSmsConversation legacy thread payload into a unified inbox row.
         * Reused Twilio SIDs can still belong to another reservation in the inbox,
         * so we never key/select only by conversation_sid when confirmation is known.
         */
        function buildUnifiedThreadFromStartResult(result)
        {
            var raw = (result && result.thread) || {};
            var confirmation = raw.confirmation_number || (result && result.confirmation_number) || '';
            var channel = raw.channel === 'whatsapp' ? 'whatsapp' : 'sms';
            var sid = raw.conversation_sid || '';
            var phone = raw.guest_phone || '';
            var room = raw.room_number || raw.product_room_number || raw.title || '';
            var when = raw.date_updated || raw.date_created || nowUtc();
            var existing = null;
            var i;
            var channelPayload = {
                conversation_sid: sid,
                guest_phone_e164: phone,
                unread_count: parseInt(raw.direct_msg_unread_counter, 10) || 0,
                is_closed: 0,
                provider: 'twilio'
            };
            var thread;

            if (confirmation) {
                for (i = 0; i < (vm.threads || []).length; i++) {
                    if (vm.threads[i].confirmation_number === confirmation) {
                        existing = vm.threads[i];
                        break;
                    }
                }

                if (!existing) {
                    for (i = 0; i < (vm._allUnifiedThreads || []).length; i++) {
                        if (vm._allUnifiedThreads[i].confirmation_number === confirmation) {
                            existing = vm._allUnifiedThreads[i];
                            break;
                        }
                    }
                }
            }

            thread = existing ? angular.extend({}, existing) : {};
            thread.confirmation_number = confirmation || thread.confirmation_number || '';
            thread.staff_user_id = (raw.staff_user_id !== undefined && raw.staff_user_id !== null) ? raw.staff_user_id : (thread.staff_user_id || null);
            thread.guest_name = raw.guest_name || thread.guest_name || '';
            thread.title = raw.guest_name || thread.title || room || confirmation;
            thread.guest_phone = phone || thread.guest_phone || '';
            thread.hotel_id = raw.hotel_id || thread.hotel_id || null;
            thread.hotel_title = raw.hotel_title || thread.hotel_title || '';
            thread.timezone = raw.timezone || thread.timezone || '';
            thread.checkin_date = raw.checkin_date || thread.checkin_date || '';
            thread.checkout_date = raw.checkout_date || thread.checkout_date || '';
            thread.room_stay_from = thread.checkin_date;
            thread.room_stay_to = thread.checkout_date;
            thread.room_stay_status = raw.room_stay_status || thread.room_stay_status || '';
            thread.room_number = room || thread.room_number || '';
            thread.product_room_number = room || thread.product_room_number || '';
            thread.provider = thread.provider || 'direct';
            thread.channel = channel;
            thread.channels = thread.channels || { ota: null, sms: null, whatsapp: null };
            thread.channels[channel] = angular.extend({}, thread.channels[channel] || {}, channelPayload);
            thread.last_message_at = when;
            thread._activityTs = parseTs(when) || Date.now();
            thread._activityRaw = when;

            return finalizeUnifiedThread(thread);
        }

        function onConversationStarted(result)
        {
            var rawThread = result && result.thread ? result.thread : null;
            var conversationSid = (rawThread && rawThread.conversation_sid) || (result && result.conversation_sid) || '';
            var confirmation = (rawThread && rawThread.confirmation_number) ||
                (result && result.confirmation_number) || '';
            var group;

            if (vm.activeTab === 'group_msg') {
                vm.activeTab = 'all';
            }

            pendingConfirmation = confirmation || '';
            pendingConversationSid = conversationSid || '';

            if (rawThread && !useUnifiedApi) {
                upsertSmsThread(rawThread);
                rebuildThreadList();
            }

            if (useUnifiedApi && (confirmation || conversationSid)) {
                group = buildUnifiedThreadFromStartResult(result);
                promoteThreadToTop(group);
                pendingConfirmation = '';
                pendingConversationSid = '';
                selectThread(group);
                return;
            }

            if (confirmation) {
                var i;
                for (i = 0; i < vm.threads.length; i++) {
                    if (vm.threads[i].confirmation_number === confirmation) {
                        pendingConfirmation = '';
                        pendingConversationSid = '';
                        promoteThreadToTop(vm.threads[i]);
                        selectThread(vm.threads[i]);
                        return;
                    }
                }
            }

            // Only fall back to SID when confirmation is unknown — a reused SID
            // may still be attached to a different reservation in the inbox.
            if (!confirmation && conversationSid) {
                group = findGroupByConversationSid(conversationSid);

                if (group) {
                    pendingConversationSid = '';
                    promoteThreadToTop(group);
                    selectThread(group);
                    return;
                }
            }

            loadThreads();
        }

        function findGroupByConversationSid(conversationSid)
        {
            var lists;
            var l;
            var i;
            var group;
            var channels;

            if (!conversationSid) {
                return null;
            }

            lists = [vm.threads, vm._allUnifiedThreads];

            for (l = 0; l < lists.length; l++) {
                for (i = 0; i < (lists[l] || []).length; i++) {
                    group = lists[l][i];
                    channels = (group && group.channels) || {};

                    if ((channels.sms && channels.sms.conversation_sid === conversationSid) ||
                        (channels.whatsapp && channels.whatsapp.conversation_sid === conversationSid) ||
                        (group._direct && group._direct.conversation_sid === conversationSid) ||
                        (group.conversation_sid === conversationSid)) {
                        return group;
                    }
                }
            }

            return null;
        }

        function findSmsThread(conversationSid)
        {
            var i;

            for (i = 0; i < vm.smsThreads.length; i++) {
                if (vm.smsThreads[i].conversation_sid === conversationSid) {
                    return vm.smsThreads[i];
                }
            }

            return null;
        }

        function findOtaThread(threadId)
        {
            var i;

            for (i = 0; i < vm.otaThreads.length; i++) {
                if (vm.otaThreads[i].thread_id === threadId) {
                    return vm.otaThreads[i];
                }
            }

            return null;
        }

        function upsertSmsThread(thread)
        {
            var existing = findSmsThread(thread.conversation_sid);

            if (existing) {
                angular.forEach(thread, function (value, key) {
                    if (value !== null && value !== undefined && value !== '') {
                        existing[key] = value;
                    }
                });
                return existing;
            }

            vm.smsThreads.unshift(thread);
            return thread;
        }

        // ---------------------------------------------------------------------
        // PubNub realtime + fallback polling
        // ---------------------------------------------------------------------

        function onDestroy()
        {
            stopFallbackPolling();
            broadcastActiveConversation(null);

            if (removePubNubListener) {
                removePubNubListener();
                removePubNubListener = null;
            }

            if (removeSmsPubNubListener) {
                removeSmsPubNubListener();
                removeSmsPubNubListener = null;
            }

            if (visibilityChangeHandler) {
                document.removeEventListener('visibilitychange', visibilityChangeHandler);
                visibilityChangeHandler = null;
            }

            unbindMessagesScroll();
            unbindThreadsScroll();
            closeComposerTranslate();
            closeMessageTranslatePopup();
            unbindTranslateDocClick();
        }

        function startRealtime()
        {
            stopFallbackPolling();

            if (vm.canViewOta) {
                removePubNubListener = otaMessageCenterPubNubService.addListener(
                    handlePubNubMessage,
                    handlePubNubStatus
                );
            }

            if (vm.canViewDirect) {
                removeSmsPubNubListener = smsMessageCenterPubNubService.addListener(
                    handleSmsPubNubMessage,
                    handlePubNubStatus
                );
            }

            if (!removePubNubListener && !removeSmsPubNubListener) {
                startFallbackPolling();
            }

            visibilityChangeHandler = function () {
                if (document.hidden) {
                    return;
                }

                messageCenterNavBadgeService.refresh();
                refreshInboxSilently();
                refreshActiveThreadMessages();
            };

            document.addEventListener('visibilitychange', visibilityChangeHandler);
        }

        function handlePubNubStatus(statusEvent)
        {
            if (!statusEvent || !statusEvent.category) {
                return;
            }

            if (statusEvent.category === 'PNNetworkDownCategory') {
                pubNubConnected = false;
                startFallbackPolling();
                return;
            }

            if (statusEvent.category === 'PNNetworkUpCategory') {
                pubNubConnected = true;
                stopFallbackPolling();
                refreshInboxSilently();
            }
        }

        function handlePubNubMessage(data)
        {
            if (!data || !data.event || !belongsToCurrentHotel(data.hotel_id)) {
                return;
            }

            $scope.$applyAsync(function () {
                switch (data.event) {
                    case 'ota_new_message':
                        onNewGuestMessage(data);
                        break;
                    case 'ota_message_received':
                        onMessageReceived(data);
                        break;
                    case 'ota_message_sent':
                        onMessageSent(data);
                        break;
                    case 'ota_thread_read':
                        onThreadRead(data);
                        break;
                    case 'ota_support_escalation':
                        onSupportEscalation(data, 'ota');
                        break;
                    case 'ai_mode_changed':
                        onAiModeChanged(data);
                        break;
                }
            });
        }

        function handleSmsPubNubMessage(data)
        {
            if (!data || !data.event || !belongsToCurrentHotel(data.hotel_id)) {
                return;
            }

            $scope.$applyAsync(function () {
                switch (data.event) {
                    case 'sms_new_message':
                        onNewSmsGuestMessage(data);
                        break;
                    case 'sms_message_sent':
                        onSmsMessageSent(data);
                        break;
                    case 'sms_thread_read':
                        onSmsThreadRead(data);
                        break;
                    case 'guest_phone_changed':
                        onGuestPhoneChanged(data);
                        break;
                    case 'messaging_opt_out_changed':
                        onMessagingOptOutChanged(data);
                        break;
                    case 'ai_mode_changed':
                        onAiModeChanged(data);
                        break;
                    case 'sms_support_escalation':
                        onSupportEscalation(data, 'sms');
                        break;
                }
            });
        }

        function getSelectedHotelId()
        {
            if (!$localStorage.hotels || $localStorage.selectedHotel === undefined) {
                return null;
            }

            return $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
        }

        function getSubHotelIds()
        {
            var ids = [];
            var i;

            if (!vm.subHotels || !vm.subHotels.length) {
                return ids;
            }

            for (i = 0; i < vm.subHotels.length; i++) {
                if (vm.subHotels[i].hotel_id) {
                    ids.push(parseInt(vm.subHotels[i].hotel_id, 10));
                }
            }

            return ids;
        }

        function belongsToCurrentHotel(hotelId)
        {
            if (!hotelId) {
                return true;
            }

            var selectedHotelId = getSelectedHotelId();
            var normalizedHotelId = parseInt(hotelId, 10);

            if (selectedHotelId && normalizedHotelId === parseInt(selectedHotelId, 10)) {
                return true;
            }

            return getSubHotelIds().indexOf(normalizedHotelId) !== -1;
        }

        function isSelectedOtaThread(threadId)
        {
            if (!vm.selectedThread || !threadId) {
                return false;
            }

            if (vm.selectedThread._ota && vm.selectedThread._ota.thread_id === threadId) {
                return true;
            }

            return !!(vm.selectedThread.channels && vm.selectedThread.channels.ota &&
                vm.selectedThread.channels.ota.message_thread_id === threadId);
        }

        function isSelectedSmsThread(conversationSid)
        {
            if (!vm.selectedThread || !conversationSid) {
                return false;
            }

            if (vm.selectedThread._direct &&
                vm.selectedThread._direct.conversation_sid === conversationSid) {
                return true;
            }

            var channels = vm.selectedThread.channels || {};

            return (channels.sms && channels.sms.conversation_sid === conversationSid) ||
                (channels.whatsapp && channels.whatsapp.conversation_sid === conversationSid);
        }

        function isSelectedConfirmation(confirmationNumber)
        {
            return !!(vm.selectedThread && confirmationNumber &&
                vm.selectedThread.confirmation_number === confirmationNumber);
        }

        function onNewGuestMessage(data)
        {
            var selected = (data.confirmation_number && isSelectedConfirmation(data.confirmation_number)) ||
                isSelectedOtaThread(data.message_thread_id);

            applyPubNubToLocalRows(data, null, data.sender || 'guest');

            if (selected) {
                markSelectedThreadRead({
                    confirmation_number: data.confirmation_number,
                    message_thread_id: data.message_thread_id
                }, data);
                refreshActiveThreadMessages();
                return;
            }

            if (useUnifiedApi) {
                if (data.ota_msg_unread_count == null && vm.threadPage === 1) {
                    refreshInboxSilently();
                }

                return;
            }

            if (findOtaThread(data.message_thread_id)) {
                rebuildThreadList();
            } else if (vm.otaPage === 1 && canFetchOta()) {
                refreshInboxSilently();
            }
        }

        function onMessageReceived(data)
        {
            var isSelected = eventTargetsSelected(data);

            applyPubNubToLocalRows(data, null, data.sender || 'property');

            if (isSelected) {
                refreshActiveThreadMessages();
            } else if (data.confirmation_number && vm.threadPage === 1 && useUnifiedApi) {
                refreshInboxSilently();
            }
        }

        function onMessageSent(data)
        {
            onOutboundMessageEvent(data, data.channel || 'ota');
        }

        function onThreadRead(data)
        {
            applyPubNubToLocalRows({
                message_thread_id: data.message_thread_id,
                confirmation_number: data.confirmation_number,
                ota_msg_unread_count: 0
            }, null);

            if (useUnifiedApi) {
                applyUnifiedTabFilter();
                return;
            }

            if (findOtaThread(data.message_thread_id) ||
                (data.confirmation_number && findGroupByConfirmation(data.confirmation_number))) {
                rebuildThreadList();
            }
        }

        function onNewSmsGuestMessage(data)
        {
            var conversationSid = data.conversation_sid || '';
            var confirmation = data.confirmation_number || '';
            var channel = data.channel || 'sms';
            var isSelected = isSelectedSmsThread(conversationSid) ||
                (confirmation && isSelectedConfirmation(confirmation));

            if ((data.opt_out === 'stop' || data.opt_out === 'start') && isSelected && vm.selectedThread) {
                vm.selectedThread.messaging_opt_out = data.opt_out === 'stop';
                refreshMessagingContext(vm.selectedThread.confirmation_number);
            }

            applyPubNubToLocalRows(data, null, data.sender || 'guest');

            if (isSelected) {
                if (channel === 'sms' || channel === 'whatsapp' || channel === 'ota') {
                    setComposerChannel(channel);
                }

                markSelectedThreadRead({
                    confirmation_number: confirmation ||
                        (vm.selectedThread && vm.selectedThread.confirmation_number) || '',
                    conversation_sid: conversationSid
                }, data);
                refreshActiveThreadMessages();

                if (confirmation || (vm.selectedThread && vm.selectedThread.confirmation_number)) {
                    refreshMessagingContext(confirmation || vm.selectedThread.confirmation_number);
                }

                return;
            }

            if (useUnifiedApi) {
                if (data.direct_msg_unread_counter == null && vm.threadPage === 1) {
                    refreshInboxSilently();
                }

                return;
            }

            if (!conversationSid) {
                return;
            }

            if (findSmsThread(conversationSid)) {
                rebuildThreadList();
            } else if (vm.smsPage === 1 && canFetchSms()) {
                refreshInboxSilently();
            }
        }

        function onSmsMessageSent(data)
        {
            onOutboundMessageEvent(data, data.channel || 'sms');
        }

        function onAiModeChanged(data)
        {
            if (!data || !data.confirmation_number) {
                return;
            }

            setAiModeLocal(data.confirmation_number, data.ai_mode);
            appendAiModeNoticeIfOpen(data.confirmation_number, data.message);
        }

        function onSupportEscalation(data, source)
        {
            var confirmation = data.confirmation_number || '';
            var channel = data.channel || (source === 'ota' ? 'ota' : 'sms');
            var isSelected = eventTargetsSelected(data);
            var notice;

            setAiModeLocal(
                confirmation || (isSelected && vm.selectedThread && vm.selectedThread.confirmation_number) || '',
                data.ai_mode != null ? data.ai_mode : false
            );

            if (!confirmation && isSelected && vm.selectedThread) {
                vm.selectedThread.ai_mode = false;
            }

            applyPubNubToLocalRows(data, null, 'system');

            if (data.message && typeof data.message === 'object') {
                notice = normalizeChannelMessages(
                    [angular.copy(data.message)],
                    data.message.channel || channel
                )[0];

                if (notice) {
                    notice.sender = notice.sender || 'system';
                    notice.event_type = notice.event_type || 'support_escalation';
                }

                if (notice && isSelected && appendSentMessage(notice) && isMessagesAtBottom()) {
                    scrollMessagesToBottom();
                } else if (notice) {
                    applyPubNubToLocalRows(data, notice, 'system');
                }
            } else if (isSelected) {
                refreshActiveThreadMessages();
            }

            if (isSelected && vm.selectedThread) {
                markSelectedThreadRead({
                    confirmation_number: confirmation || vm.selectedThread.confirmation_number || '',
                    conversation_sid: data.conversation_sid || '',
                    message_thread_id: data.message_thread_id || ''
                }, data);
            } else if (confirmation && useUnifiedApi && vm.threadPage === 1 &&
                !findGroupByConfirmation(confirmation)) {
                refreshInboxSilently();
            }
        }

        function onSmsThreadRead(data)
        {
            var conversationSid = data.conversation_sid || '';
            var confirmation = data.confirmation_number || '';
            var directThread;
            var i;

            applyPubNubToLocalRows({
                conversation_sid: conversationSid,
                confirmation_number: confirmation,
                direct_msg_unread_counter: 0
            }, null);

            if (useUnifiedApi) {
                applyUnifiedTabFilter();
                return;
            }

            if (!conversationSid && confirmation) {
                for (i = 0; i < vm.smsThreads.length; i++) {
                    if (vm.smsThreads[i].confirmation_number === confirmation) {
                        conversationSid = vm.smsThreads[i].conversation_sid;
                        break;
                    }
                }
            }

            if (!conversationSid) {
                return;
            }

            directThread = findSmsThread(conversationSid);

            if (directThread) {
                directThread.direct_msg_unread_counter = 0;
                rebuildThreadList();
            }
        }

        function onGuestPhoneChanged(data)
        {
            var confirmation = data.confirmation_number || '';

            if (!confirmation || !vm.selectedThread || vm.selectedThread.confirmation_number !== confirmation) {
                return;
            }

            if (data.message && typeof data.message === 'object') {
                var notices = normalizeUnifiedMessages([angular.copy(data.message)]);
                var added = addMessages(notices);

                if (added.length && isMessagesAtBottom()) {
                    scrollMessagesToBottom();
                }
            }

            refreshMessagingContext(confirmation);
        }

        function onMessagingOptOutChanged(data)
        {
            var confirmation = data.confirmation_number || '';
            var conversationSid = data.conversation_sid || '';
            var optedOut = !!data.messaging_opt_out;
            var group = null;
            var i;

            if (confirmation && vm.selectedThread &&
                vm.selectedThread.confirmation_number === confirmation) {
                group = vm.selectedThread;
            } else if (conversationSid) {
                group = findGroupByConversationSid(conversationSid);
            }

            if (!group && confirmation) {
                for (i = 0; i < (vm.threads || []).length; i++) {
                    if (vm.threads[i].confirmation_number === confirmation) {
                        group = vm.threads[i];
                        break;
                    }
                }
            }

            if (group) {
                group.messaging_opt_out = optedOut;

                if (group._direct) {
                    group._direct.messaging_opt_out = optedOut;
                }
            }

            if ((isSelectedConfirmation(confirmation) || isSelectedSmsThread(conversationSid)) &&
                data.message && typeof data.message === 'object') {
                var notices = normalizeUnifiedMessages([angular.copy(data.message)]);
                var added = addMessages(notices);

                if (added.length && isMessagesAtBottom()) {
                    scrollMessagesToBottom();
                }
            }

            if (confirmation) {
                refreshMessagingContext(confirmation);
            }
        }

        function startFallbackPolling()
        {
            if (fallbackPollTimer) {
                return;
            }

            fallbackPollTimer = $interval(function () {
                if (document.hidden || pubNubConnected) {
                    return;
                }

                refreshInboxSilently();
                refreshActiveThreadMessages();
            }, FALLBACK_POLL_INTERVAL_MS);
        }

        function stopFallbackPolling()
        {
            if (fallbackPollTimer) {
                $interval.cancel(fallbackPollTimer);
                fallbackPollTimer = null;
            }
        }

        function refreshInboxSilently()
        {
            pollThreadsSilently();
        }

        function refreshActiveThreadMessages()
        {
            if (!vm.selectedThread) {
                return;
            }

            pollMessagesSilently();
        }

        function schedulePendingMessagesRefresh()
        {
            if (!pendingMessagesRefresh) {
                return;
            }

            pendingMessagesRefresh = false;
            $timeout(function () {
                refreshActiveThreadMessages();
            }, 0);
        }

        function pollThreadsSilently()
        {
            if (!vm.canGetThreads || vm.loadingThreads || pollThreadsInFlight || document.hidden) {
                return;
            }

            pollThreadsInFlight = true;

            if (useUnifiedApi) {
                fetchUnifiedThreads(1, false).then(function (ok) {
                    pollThreadsInFlight = false;

                    if (!ok) {
                        // fall through next tick via legacy if needed
                    }
                }, function () {
                    pollThreadsInFlight = false;
                });
                return;
            }

            var promises = [];

            if (canFetchOta()) {
                promises.push(pollOtaThreads());
            }

            if (canFetchSms()) {
                promises.push(pollSmsThreads());
            }

            if (!promises.length) {
                pollThreadsInFlight = false;
                return;
            }

            $q.all(promises).then(function () {
                pollThreadsInFlight = false;
                rebuildThreadList();
            }, function () {
                pollThreadsInFlight = false;
            });
        }

        function pollOtaThreads()
        {
            var params = {
                page: 1,
                limit: vm.threadLimit
            };

            if (vm.subHotelId) {
                params.sub_hotel_id = vm.subHotelId;
            }

            return messageCenterService.getMessageThreads(params).then(function (response) {
                if (!response || response.success === false) {
                    return;
                }

                var fresh = response.data || [];

                if (vm.otaPage === 1) {
                    vm.otaThreads = fresh;
                } else {
                    mergeFreshThreads(vm.otaThreads, fresh, 'thread_id');
                }

                vm.otaTotal = (response.meta && response.meta.total) ? response.meta.total : vm.otaTotal;
            }, function () {});
        }

        function pollSmsThreads()
        {
            var params = {
                page: 1,
                limit: vm.threadLimit
            };

            if (vm.subHotelId) {
                params.sub_hotel_id = vm.subHotelId;
            }

            return messageCenterService.getSmsThreads(params).then(function (response) {
                if (!response || response.success === false) {
                    return;
                }

                var fresh = response.data || [];

                if (vm.smsPage === 1) {
                    vm.smsThreads = fresh;
                } else {
                    mergeFreshThreads(vm.smsThreads, fresh, 'conversation_sid');
                }
            }, function () {});
        }

        function mergeFreshThreads(current, fresh, idKey)
        {
            var freshById = {};
            var i;

            for (i = 0; i < fresh.length; i++) {
                freshById[fresh[i][idKey]] = fresh[i];
            }

            for (i = 0; i < current.length; i++) {
                var match = freshById[current[i][idKey]];

                if (match) {
                    angular.forEach(match, function (value, key) {
                        if (value !== null && value !== undefined && value !== '') {
                            current[i][key] = value;
                        }
                    });
                }
            }
        }

        function pollMessagesSilently()
        {
            var group = vm.selectedThread;

            if (!group || !vm.canGetMessages || document.hidden) {
                return;
            }

            // PubNub can fire while a load/send is in flight — retry after it finishes.
            if (vm.loadingMessages || vm.sendingMessage || pollMessagesInFlight) {
                pendingMessagesRefresh = true;
                return;
            }

            pollMessagesInFlight = true;

            var selectedKey = vm.selectedKey;
            var shouldScroll = isMessagesAtBottom();

            if (useUnifiedApi && group.confirmation_number) {
                loadUnifiedMessages(1, true).then(function (result) {
                    pollMessagesInFlight = false;

                    if (!result || !result.ok || !vm.selectedThread || vm.selectedKey !== selectedKey) {
                        schedulePendingMessagesRefresh();
                        return;
                    }

                    var added = result.added || [];

                    if (hasGuestMessages(added)) {
                        markSelectedThreadRead({
                            confirmation_number: vm.selectedThread.confirmation_number
                        });
                    }

                    if (added && added.length) {
                        setDefaultComposerChannel(vm.selectedThread);
                    }

                    if (shouldScroll && added && added.length) {
                        scrollMessagesToBottom();
                    }

                    schedulePendingMessagesRefresh();
                }, function () {
                    pollMessagesInFlight = false;
                    schedulePendingMessagesRefresh();
                });
                return;
            }

            var promises = [];

            if (group._ota) {
                promises.push(
                    messageCenterService.getThreadMessages(group._ota.thread_id, 1, vm.messageLimit)
                        .then(function (response) {
                            return { channel: 'ota', response: response };
                        })
                );
            }

            if (group._direct) {
                promises.push(
                    messageCenterService.getSmsThreadMessages(buildSmsMessageParams(group._direct, 1))
                        .then(function (response) {
                            return { channel: 'direct', response: response };
                        })
                );
            }

            if (!promises.length) {
                pollMessagesInFlight = false;
                schedulePendingMessagesRefresh();
                return;
            }

            $q.all(promises).then(function (results) {
                pollMessagesInFlight = false;

                if (!vm.selectedThread || vm.selectedKey !== selectedKey) {
                    schedulePendingMessagesRefresh();
                    return;
                }

                var collected = [];

                results.forEach(function (result) {
                    var response = result.response;

                    if (!response || response.success === false) {
                        return;
                    }

                    collected = collected.concat(normalizeChannelMessages(response.data || [], result.channel));

                    if (result.channel === 'ota') {
                        vm.msgOta.total = (response.meta && response.meta.total) ? response.meta.total : vm.msgOta.total;
                    }
                });

                var added = addMessages(collected);

                if (!added.length) {
                    schedulePendingMessagesRefresh();
                    return;
                }

                updateMessageStayDates(vm.messages);
                updateLoadEarlierVisibility();

                if (hasGuestMessages(added)) {
                    markSelectedThreadRead({
                        confirmation_number: vm.selectedThread.confirmation_number,
                        conversation_sid: vm.selectedThread._direct &&
                            vm.selectedThread._direct.conversation_sid,
                        message_thread_id: vm.selectedThread._ota &&
                            vm.selectedThread._ota.thread_id
                    });
                    rebuildThreadList();
                }

                if (shouldScroll) {
                    scrollMessagesToBottom();
                }

                schedulePendingMessagesRefresh();
            }, function () {
                pollMessagesInFlight = false;
                schedulePendingMessagesRefresh();
            });
        }

        function hasGuestMessages(messages)
        {
            var i;

            for (i = 0; i < (messages || []).length; i++) {
                if (messages[i].sender === 'guest') {
                    return true;
                }
            }

            return false;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .controller('StaffGroupMessagesController', StaffGroupMessagesController);

    /** @ngInject */
    function StaffGroupMessagesController(
        $scope,
        $rootScope,
        $localStorage,
        $q,
        $mdDialog,
        toastMessage,
        messageCenterService
    )
    {
        var vm = this;
        var staffRequestId = 0;
        var allStaffs = [];
        var staffsLoaded = false;
        var channelFlagsFromSettings = false;

        vm.subHotels = $rootScope.subHotels || [];
        vm.selectedSubHotelIds = {};
        vm.selectedIds = {};
        vm.channel = 'default';
        vm.message = '';
        vm.smsEnabled = true;
        vm.whatsappEnabled = true;
        vm.canSendDirect = hasDirectPermission();
        vm.sending = false;
        vm.loadingStaffs = false;
        vm.staffs = [];
        vm.eligibleStaffs = [];
        vm.ineligibleStaffs = [];
        vm.lastResult = null;
        vm.skipSendConfirm = false;
        vm.searchText = '';

        vm.getGuestUnreadTotal = messageCenterNavBadgeService.getGuestUnreadTotal;
        vm.getStaffUnreadTotal = messageCenterNavBadgeService.getStaffUnreadTotal;

        vm.setChannel = setChannel;
        vm.getChannelLabel = getChannelLabel;
        vm.toggleProperty = toggleProperty;
        vm.selectAllProperties = selectAllProperties;
        vm.isPropertySelected = isPropertySelected;
        vm.isPropertyTagActive = isPropertyTagActive;
        vm.isAllPropertiesSelected = isAllPropertiesSelected;
        vm.getPropertyShortName = getPropertyShortName;
        vm.getRecipientLabel = getRecipientLabel;
        vm.getStaffInitial = getStaffInitial;
        vm.isStaffSelected = isStaffSelected;
        vm.toggleStaff = toggleStaff;
        vm.selectAllEligible = selectAllEligible;
        vm.clearStaffSelection = clearStaffSelection;
        vm.areAllEligibleSelected = areAllEligibleSelected;
        vm.getSelectedCount = getSelectedCount;
        vm.canSubmit = canSubmit;
        vm.sendBroadcast = sendBroadcast;
        vm.getReasonLabel = getReasonLabel;
        vm.getResultStaffLabel = getResultStaffLabel;
        vm.searchStaff = searchStaff;

        init();

        function init()
        {
            loadChannelEnabledFlags();

            if ($rootScope.isParent && $rootScope.subHotels && $rootScope.subHotels.length) {
                vm.subHotels = $rootScope.subHotels;
                loadStaffs(true);
                return;
            }

            if ($localStorage.hotels && $localStorage.selectedHotel !== undefined) {
                $rootScope.getSubHotels($localStorage.hotels[$localStorage.selectedHotel].hotel_id, true);
                $scope.$watch(function () {
                    return $rootScope.subHotelsOfSelected;
                }, function (subHotels) {
                    if (subHotels && subHotels.length) {
                        vm.subHotels = subHotels;
                        if (!staffsLoaded) {
                            loadStaffs(true);
                        }
                    }
                });
            }

            loadStaffs(true);
        }

        function isEnabledFlag(value)
        {
            return value === true || value === 1 || value === '1';
        }

        function applyChannelEnabledFlags(source)
        {
            var settings;
            var fromSettings = false;

            if (!source) {
                return false;
            }

            settings = source.settings || source;
            fromSettings = settings.sms_messaging_enabled !== undefined ||
                settings.whatsapp_messaging_enabled !== undefined;

            if (fromSettings) {
                if (settings.sms_messaging_enabled !== undefined) {
                    vm.smsEnabled = isEnabledFlag(settings.sms_messaging_enabled);
                }

                if (settings.whatsapp_messaging_enabled !== undefined) {
                    vm.whatsappEnabled = isEnabledFlag(settings.whatsapp_messaging_enabled);
                }

                channelFlagsFromSettings = true;
                return true;
            }

            if (channelFlagsFromSettings) {
                return false;
            }

            if (source.sms_enabled !== undefined) {
                vm.smsEnabled = !!source.sms_enabled;
            }

            if (source.whatsapp_enabled !== undefined) {
                vm.whatsappEnabled = !!source.whatsapp_enabled;
            }

            return source.sms_enabled !== undefined || source.whatsapp_enabled !== undefined;
        }

        function hasAnyDirectChannelEnabled()
        {
            return !!(vm.smsEnabled || vm.whatsappEnabled);
        }

        function isChannelAvailable(channel)
        {
            if (channel === 'default') {
                return !!(vm.smsEnabled && vm.whatsappEnabled);
            }

            if (channel === 'sms') {
                return !!vm.smsEnabled;
            }

            if (channel === 'whatsapp') {
                return !!vm.whatsappEnabled;
            }

            return false;
        }

        function normalizeSelectedChannel()
        {
            if (isChannelAvailable(vm.channel)) {
                return;
            }

            if (vm.smsEnabled && vm.whatsappEnabled) {
                vm.channel = 'default';
            } else if (vm.smsEnabled) {
                vm.channel = 'sms';
            } else if (vm.whatsappEnabled) {
                vm.channel = 'whatsapp';
            } else {
                vm.channel = 'default';
            }
        }

        function loadChannelEnabledFlags()
        {
            if (!vm.canSendDirect) {
                return;
            }

            messageCenterService.getSettings({}).then(function (response) {
                if (!response || response.success === false) {
                    return;
                }

                applyChannelEnabledFlags(response);
                normalizeSelectedChannel();
            });
        }

        function permsContains(key)
        {
            var perms = $rootScope.userPermissions || '';
            return !!perms && perms.indexOf(key) !== -1;
        }

        function hasDirectPermission()
        {
            return permsContains('All') ||
                permsContains('message_center') ||
                permsContains('direct');
        }

        function setChannel(channel)
        {
            if (!isChannelAvailable(channel)) {
                return;
            }

            if (channel === 'sms' || channel === 'whatsapp' || channel === 'default') {
                vm.channel = channel;
            }
        }

        function getChannelLabel()
        {
            if (vm.channel === 'whatsapp') {
                return 'WhatsApp';
            }

            if (vm.channel === 'default') {
                return 'Default';
            }

            return 'SMS';
        }

        function normalizeHotelId(hotelId)
        {
            var id = parseInt(hotelId, 10);

            return isNaN(id) ? null : id;
        }

        function getSelectedSubHotelIds()
        {
            return Object.keys(vm.selectedSubHotelIds || {}).filter(function (key) {
                return !!vm.selectedSubHotelIds[key];
            }).map(normalizeHotelId).filter(function (id) {
                return id !== null;
            });
        }

        function isAllPropertiesSelected()
        {
            return !getSelectedSubHotelIds().length;
        }

        function getPropertyShortName(hotel)
        {
            var title = ((hotel && hotel.hotel_title) || '').toLowerCase();

            if (title.indexOf('bayview') !== -1) {
                return 'BV';
            }

            if (title.indexOf('bay palms') !== -1) {
                return 'BP';
            }

            if (title.indexOf('plaza beach') !== -1) {
                return 'PB';
            }

            return (hotel && hotel.hotel_title) || '';
        }

        function isPropertySelected(hotelId)
        {
            var id = normalizeHotelId(hotelId);

            if (id === null) {
                return false;
            }

            if (isAllPropertiesSelected()) {
                return true;
            }

            return !!vm.selectedSubHotelIds[id] || !!vm.selectedSubHotelIds[String(id)];
        }

        // Highlight only explicitly selected tags (not when "All Hotels" is active).
        function isPropertyTagActive(hotelId)
        {
            var id = normalizeHotelId(hotelId);

            if (id === null || isAllPropertiesSelected()) {
                return false;
            }

            return !!vm.selectedSubHotelIds[id] || !!vm.selectedSubHotelIds[String(id)];
        }

        function selectAllProperties()
        {
            vm.selectedSubHotelIds = {};
            applyFilters();
        }

        function toggleProperty(hotelId)
        {
            var id = normalizeHotelId(hotelId);
            var selected;

            if (id === null) {
                return;
            }

            // From "All Hotels": first click selects only that property.
            if (!getSelectedSubHotelIds().length) {
                vm.selectedSubHotelIds = {};
                vm.selectedSubHotelIds[id] = true;
                applyFilters();
                return;
            }

            if (vm.selectedSubHotelIds[id] || vm.selectedSubHotelIds[String(id)]) {
                delete vm.selectedSubHotelIds[id];
                delete vm.selectedSubHotelIds[String(id)];
            } else {
                vm.selectedSubHotelIds[id] = true;
            }

            selected = getSelectedSubHotelIds();

            // Selecting every property is the same as All Hotels.
            if (vm.subHotels.length && selected.length === vm.subHotels.length) {
                vm.selectedSubHotelIds = {};
            }

            if (!getSelectedSubHotelIds().length) {
                vm.selectedSubHotelIds = {};
            }

            applyFilters();
        }

        function getStaffInitial(staff)
        {
            var name;

            if (!staff) {
                return '?';
            }

            name = (staff.staff_name || staff.confirmation_number || '').trim();

            return name ? name.charAt(0).toUpperCase() : '?';
        }

        function applyFilters()
        {
            vm.staffs = allStaffs.slice();
            splitStaffsByEligibility();
            syncStaffSelection({ resetSelection: true });
        }

        function normalizeStaffRow(item)
        {
            var firstName = item.first_name || '';
            var lastName = item.last_name || '';
            var staffName = (firstName + ' ' + lastName).replace(/^\s+|\s+$/g, '');

            var staff = {
                user_id: item.user_id || '',
                confirmation_number: item.confirmation_number || '',
                staff_name: staffName || item.phone || item.email || 'Staff',
                hotel_id: normalizeHotelId(item.hotel_id),
                hotel_title: item.hotel_title || '',
                email: item.email || '',
                phone: (item.phone || item.phone_number || '').trim(),
                can_deliver: false,
                statuses: []
            };

            staff.can_deliver = !!staff.phone;
            if (!staff.phone) {
                staff.statuses.push({ key: 'no_phone', label: 'No phone' });
            }

            return staff;
        }

        function searchStaff()
        {
            staffsLoaded = false;
            loadStaffs(true);
        }

        function loadStaffs(forceReload)
        {
            var requestId = ++staffRequestId;

            if (!forceReload && staffsLoaded) {
                applyFilters();
                return $q.resolve();
            }

            vm.loadingStaffs = true;

            var params = {
                q: vm.searchText || ''
            };

            return messageCenterService.searchStaffRecipients(params).then(function (response) {
                var raw;
                var rows = [];
                var i;
                var item;

                if (requestId !== staffRequestId) {
                    return;
                }

                raw = (response && response.data) || [];

                for (i = 0; i < raw.length; i++) {
                    item = raw[i] || {};
                    rows.push(normalizeStaffRow(item));
                }

                allStaffs = rows;
                staffsLoaded = true;
                applyFilters();
            }).catch(function () {
                if (requestId !== staffRequestId) {
                    return;
                }

                allStaffs = [];
                staffsLoaded = false;
                vm.staffs = [];
                vm.eligibleStaffs = [];
                vm.ineligibleStaffs = [];
                vm.selectedIds = {};
                toastMessage.showSimpleToast('Unable to load staff members.', 'error-toast');
            }).finally(function () {
                if (requestId !== staffRequestId) {
                    return;
                }

                vm.loadingStaffs = false;
            });
        }

        function splitStaffsByEligibility()
        {
            var i;
            var staff;
            var eligible = [];
            var ineligible = [];

            for (i = 0; i < vm.staffs.length; i++) {
                staff = vm.staffs[i];
                if (staff.can_deliver) {
                    eligible.push(staff);
                } else {
                    ineligible.push(staff);
                }
            }

            vm.eligibleStaffs = eligible;
            vm.ineligibleStaffs = ineligible;
        }

        function isStaffSelected(staff)
        {
            var id = (staff && staff.user_id) || (staff && staff.confirmation_number);
            return !!(id && vm.selectedIds[id]);
        }

        function toggleStaff(staff, $event)
        {
            var id;

            if ($event) {
                $event.stopPropagation();
            }

            if (!staff || !staff.can_deliver) {
                return;
            }

            id = staff.user_id || staff.confirmation_number;
            if (!id) {
                return;
            }

            if (vm.selectedIds[id]) {
                delete vm.selectedIds[id];
            } else {
                vm.selectedIds[id] = true;
            }
        }

        function selectAllEligible()
        {
            var i;
            var id;

            for (i = 0; i < vm.eligibleStaffs.length; i++) {
                id = vm.eligibleStaffs[i].user_id || vm.eligibleStaffs[i].confirmation_number;
                if (id) {
                    vm.selectedIds[id] = true;
                }
            }
        }

        function clearStaffSelection()
        {
            vm.selectedIds = {};
        }

        function areAllEligibleSelected()
        {
            var i;
            var id;

            if (!vm.eligibleStaffs.length) {
                return false;
            }

            for (i = 0; i < vm.eligibleStaffs.length; i++) {
                id = vm.eligibleStaffs[i].user_id || vm.eligibleStaffs[i].confirmation_number;
                if (!id || !vm.selectedIds[id]) {
                    return false;
                }
            }

            return true;
        }

        function getSelectedStaffRecipients()
        {
            var recipients = [];
            var i;
            var id;
            var staff;
            var phone;

            for (i = 0; i < vm.staffs.length; i++) {
                staff = vm.staffs[i];
                id = staff.user_id || staff.confirmation_number;

                if (!id || !vm.selectedIds[id] || !staff.can_deliver) {
                    continue;
                }

                phone = (staff.phone || '').trim();
                if (!staff.confirmation_number || !phone) {
                    continue;
                }

                recipients.push({
                    confirmation_number: staff.confirmation_number,
                    guest_phone: phone,
                    staff_user_id: staff.user_id || null
                });
            }

            return recipients;
        }

        function getSelectedCount()
        {
            return Object.keys(vm.selectedIds || {}).filter(function(key) {
                return !!vm.selectedIds[key];
            }).length;
        }

        // Keep selection in current property/channel scope; optionally reset to all eligible.
        function syncStaffSelection(options)
        {
            var next = {};
            var i;
            var staff;
            var id;

            if (options && options.resetSelection) {
                vm.selectedIds = {};
                selectAllEligible();
                return;
            }

            for (i = 0; i < vm.staffs.length; i++) {
                staff = vm.staffs[i];
                id = staff.user_id || staff.confirmation_number;
                if (!id || !staff.can_deliver) {
                    continue;
                }

                if (vm.selectedIds[id]) {
                    next[id] = true;
                }
            }

            vm.selectedIds = next;
        }

        function getRecipientLabel()
        {
            var total;
            var deliverable;
            var selected;

            if (vm.loadingStaffs) {
                return 'Loading staff...';
            }

            total = vm.staffs.length || 0;
            deliverable = vm.eligibleStaffs.length || 0;
            selected = getSelectedCount();

            return selected + ' selected · ' + deliverable + ' of ' + total + ' can receive';
        }

        function canSubmit()
        {
            if (!vm.canSendDirect || !hasAnyDirectChannelEnabled() || vm.sending) {
                return false;
            }

            if (!isChannelAvailable(vm.channel)) {
                return false;
            }

            return !!(vm.message || '').trim() && getSelectedCount() > 0;
        }

        function buildPayload()
        {
            return {
                message: (vm.message || '').trim(),
                channel: vm.channel,
                recipients: getSelectedStaffRecipients()
            };
        }

        function confirmSend()
        {
            var title = 'Send broadcast';
            var channelLabel = getChannelLabel();
            var selectedCount = getSelectedCount();
            var html = 'Send this ' + channelLabel + ' message to <b>' +
                selectedCount + ' selected</b> staff member' +
                ((selectedCount === 1) ? '' : 's') + '?';

            if (vm.channel === 'whatsapp') {
                html += '<br/><br/>Staff members outside the WhatsApp 24-hour window will be skipped.';
            } else if (vm.channel === 'default') {
                html += '<br/><br/>Each staff gets their last active channel. ' +
                    'If WhatsApp is outside the 24-hour window, SMS is used when available.';
            }

            return $mdDialog.show({
                controller: 'confirmController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    title: title,
                    htmlContent: html,
                    cancelBtn: 'Cancel',
                    OkBtn: 'Send'
                }
            });
        }

        function shouldConfirmBeforeSend()
        {
            return !vm.skipSendConfirm;
        }

        function executeSend()
        {
            var payload = buildPayload();

            vm.sending = true;
            vm.lastResult = null;

            return messageCenterService.broadcastStaffMessage(payload).then(function (response) {
                if (!response || response.success === false) {
                    toastMessage.showSimpleToast(
                        (response && response.message) || 'Unable to send broadcast.',
                        'error-toast'
                    );
                    return;
                }

                vm.lastResult = normalizeBroadcastResult(response.data);

                toastMessage.showSimpleToast(
                    'Broadcast sent: ' + (vm.lastResult.sent || 0) + ' delivered.',
                    'success-toast'
                );
            }).finally(function () {
                vm.sending = false;
            });
        }

        function sendBroadcast()
        {
            if (!canSubmit()) {
                return;
            }

            if (!shouldConfirmBeforeSend()) {
                executeSend();
                return;
            }

            confirmSend().then(function (answer) {
                if (answer !== 'update') {
                    return;
                }

                return executeSend();
            }, function () {
                // cancelled
            });
        }

        function findStaffByConfirmation(confirmationNumber)
        {
            var i;
            var key = (confirmationNumber || '').toString();

            if (!key) {
                return null;
            }

            for (i = 0; i < (vm.staffs || []).length; i++) {
                if ((vm.staffs[i].confirmation_number || '').toString() === key) {
                    return vm.staffs[i];
                }
            }

            for (i = 0; i < (allStaffs || []).length; i++) {
                if ((allStaffs[i].confirmation_number || '').toString() === key) {
                    return allStaffs[i];
                }
            }

            return null;
        }

        function normalizeBroadcastResult(data)
        {
            var source = data || {};
            var rows = source.results || [];
            var mapped = [];
            var i;
            var row;
            var recipient;
            var confirmation;
            var status;
            var reason;
            var staff;

            for (i = 0; i < rows.length; i++) {
                row = rows[i] || {};
                recipient = row.recipient || {};
                confirmation = row.confirmation_number || recipient.confirmation_number || '';
                status = (row.status || '').toString().toLowerCase();

                if (!status) {
                    status = row.success ? 'sent' : 'failed';
                }

                reason = row.reason || row.code || row.message || '';
                if (status === 'sent') {
                    reason = '';
                }

                staff = findStaffByConfirmation(confirmation);

                mapped.push({
                    confirmation_number: confirmation,
                    staff_name: (staff && staff.staff_name) || '',
                    guest_phone: row.guest_phone || recipient.guest_phone || (staff && staff.phone) || '',
                    channel: row.channel || source.channel || '',
                    status: status,
                    reason: reason
                });
            }

            return {
                channel: source.channel || '',
                requested: source.requested != null ? source.requested : (source.total != null ? source.total : mapped.length),
                sent: source.sent != null ? source.sent : (source.success || 0),
                skipped: source.skipped || 0,
                failed: source.failed || 0,
                results: mapped
            };
        }

        function getResultStaffLabel(row)
        {
            if (!row) {
                return '—';
            }

            if (row.staff_name && row.confirmation_number) {
                return row.staff_name + ' (' + row.confirmation_number + ')';
            }

            return row.staff_name || row.confirmation_number || row.guest_phone || '—';
        }

        function getReasonLabel(reason)
        {
            var map = {
                out_of_scope: 'Out of scope',
                opted_out: 'Opted out',
                no_open_thread: 'No open chat',
                no_phone: 'No phone number',
                whatsapp_window_closed: 'WhatsApp 24h window closed',
                phone_linked_to_other_reservation: 'Number already used by a guest reservation',
                phone_linked_to_staff_contact: 'Number already used as a staff contact'
            };

            return map[reason] || reason || '';
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .factory('smsMessageCenterPubNubService', smsMessageCenterPubNubService);

    /** @ngInject */
    function smsMessageCenterPubNubService(EnvironmentConfig, $localStorage)
    {
        var CHANNEL = 'smsMessageCenter';
        var pubnub = null;
        var listeners = [];
        var channelSubscribed = false;

        function getUserId()
        {
            if (!$localStorage.userId) {
                return null;
            }

            return 'ls-user-' + String($localStorage.userId);
        }

        function getClient()
        {
            var userId = getUserId();

            if (!userId || !EnvironmentConfig.pubnubSubscribeKey || typeof PubNub === 'undefined') {
                return null;
            }

            if (!pubnub) {
                pubnub = new PubNub({
                    subscribeKey: EnvironmentConfig.pubnubSubscribeKey,
                    userId: userId
                });
            }

            return pubnub;
        }

        function ensureChannelSubscribed(client)
        {
            if (!channelSubscribed) {
                client.subscribe({ channels: [CHANNEL] });
                channelSubscribed = true;
            }
        }

        function maybeUnsubscribeChannel(client)
        {
            if (listeners.length || !channelSubscribed) {
                return;
            }

            client.unsubscribe({ channels: [CHANNEL] });
            channelSubscribed = false;
        }

        function addListener(messageHandler, statusHandler)
        {
            var client = getClient();

            if (!client || !messageHandler) {
                return null;
            }

            var listener = {
                message: function (event) {
                    messageHandler(event.message);
                }
            };

            if (statusHandler) {
                listener.status = function (statusEvent) {
                    statusHandler(statusEvent);
                };
            }

            client.addListener(listener);
            listeners.push(listener);
            ensureChannelSubscribed(client);

            return function removeListener() {
                var index = listeners.indexOf(listener);

                if (index === -1) {
                    return;
                }

                client.removeListener(listener);
                listeners.splice(index, 1);
                maybeUnsubscribeChannel(client);
            };
        }

        function subscribe(messageHandler, statusHandler)
        {
            return addListener(messageHandler, statusHandler) !== null;
        }

        function reset()
        {
            var client = pubnub;
            var i;

            if (!client) {
                return;
            }

            for (i = listeners.length - 1; i >= 0; i--) {
                client.removeListener(listeners[i]);
            }

            listeners = [];

            if (channelSubscribed) {
                client.unsubscribe({ channels: [CHANNEL] });
                channelSubscribed = false;
            }

            if (client.destroy) {
                client.destroy();
            }

            pubnub = null;
        }

        function unsubscribe()
        {
            reset();
        }

        return {
            addListener: addListener,
            subscribe: subscribe,
            unsubscribe: unsubscribe,
            reset: reset
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .factory('phoneFormatService', phoneFormatService);

    /** @ngInject */
    function phoneFormatService($timeout)
    {
        var utilsLoadPromise = null;

        function ensureUtilsLoaded()
        {
            if (!window.intlTelInput) {
                return;
            }

            if (window.intlTelInput.utils) {
                return;
            }

            if (utilsLoadPromise) {
                return;
            }

            var loadUtils = window.loadIntlTelUtils || (
                window.intlTelInput.options && window.intlTelInput.options.loadUtils
            );

            if (typeof window.intlTelInput.attachUtils !== 'function' || typeof loadUtils !== 'function') {
                return;
            }

            utilsLoadPromise = window.intlTelInput.attachUtils(loadUtils).then(function () {
                $timeout(angular.noop);
            }).catch(angular.noop);
        }

        function toE164Candidate(phoneNumber)
        {
            var number = String(phoneNumber || '').trim();
            if (!number) {
                return '';
            }

            // E.164 with country code already present.
            // Numbers without a leading + are treated as US/Canada (+1).
            if (number.charAt(0) !== '+') {
                var digits = number.replace(/[^\d]/g, '');
                if (!digits) {
                    return '';
                }
                if (digits.charAt(0) === '1' && digits.length === 11) {
                    return '+' + digits;
                }
                return '+1' + digits;
            }

            return number;
        }

        function format(phoneNumber)
        {
            if (!phoneNumber) {
                return phoneNumber;
            }

            ensureUtilsLoaded();

            var number = toE164Candidate(phoneNumber);
            if (!number) {
                return phoneNumber;
            }

            if (window.intlTelInput && window.intlTelInput.utils &&
                typeof window.intlTelInput.utils.formatNumber === 'function') {
                try {
                    var formatted = window.intlTelInput.utils.formatNumber(
                        number,
                        undefined,
                        'INTERNATIONAL'
                    );
                    if (formatted) {
                        return formatted;
                    }
                } catch (e) {
                    // Fall through to raw number.
                }
            }

            return phoneNumber;
        }

        function getInputByName(inputName)
        {
            if (!inputName) {
                return null;
            }

            return document.querySelector('input[name="' + inputName + '"]');
        }

        function getItiInstance(inputName)
        {
            var inputElement = getInputByName(inputName);

            if (!inputElement) {
                return null;
            }

            return angular.element(inputElement).data('iti') || null;
        }

        /**
         * Toggle ng-invalid on the intl-tel-input field (same pattern as order.html).
         * Empty is treated as valid so the user can clear and cancel.
         */
        function updateValidity(inputName)
        {
            var inputElement = getInputByName(inputName);
            var iti = getItiInstance(inputName);

            if (!inputElement || !iti) {
                return true;
            }

            var inputValue = String(inputElement.value || '').trim();
            var isValid = !inputValue || !!iti.isValidNumberPrecise();

            angular.element(inputElement).toggleClass('ng-invalid', !isValid);
            angular.element(inputElement).toggleClass('ng-valid', isValid);

            var field = null;
            var node = inputElement;

            while (node && node !== document.body) {
                if (node.classList && node.classList.contains('gmc-phone-iti-field')) {
                    field = node;
                    break;
                }
                node = node.parentNode;
            }

            if (field) {
                angular.element(field).toggleClass('is-invalid', !isValid);
            }

            return isValid;
        }

        /**
         * Returns E.164 when the named input has a valid number, otherwise ''.
         * Falls back to the provided model value when the plugin is not ready.
         */
        function getValidE164(inputName, fallbackValue)
        {
            var iti = getItiInstance(inputName);
            var inputElement = getInputByName(inputName);

            if (iti && inputElement) {
                var inputValue = String(inputElement.value || '').trim();

                if (!inputValue) {
                    return '';
                }

                if (iti.isValidNumberPrecise()) {
                    return iti.getNumber() || '';
                }

                return '';
            }

            var fallback = String(fallbackValue || '').trim();
            if (!fallback) {
                return '';
            }

            // Without an iti instance, only accept something that already looks like E.164.
            if (fallback.charAt(0) === '+' && fallback.replace(/\D/g, '').length >= 8) {
                return fallback;
            }

            return '';
        }

        function isValidInput(inputName, fallbackValue)
        {
            var inputElement = getInputByName(inputName);
            var iti = getItiInstance(inputName);

            if (iti && inputElement) {
                var inputValue = String(inputElement.value || '').trim();
                return !!inputValue && !!iti.isValidNumberPrecise();
            }

            return !!getValidE164(inputName, fallbackValue);
        }

        return {
            ensureUtilsLoaded: ensureUtilsLoaded,
            format: format,
            updateValidity: updateValidity,
            getValidE164: getValidE164,
            isValidInput: isValidInput
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .factory('otaMessageCenterPubNubService', otaMessageCenterPubNubService);

    /** @ngInject */
    function otaMessageCenterPubNubService(EnvironmentConfig, $localStorage)
    {
        var CHANNEL = 'otaMessageCenter';
        var pubnub = null;
        var listeners = [];
        var channelSubscribed = false;

        function getUserId()
        {
            if (!$localStorage.userId) {
                return null;
            }

            return 'ls-user-' + String($localStorage.userId);
        }

        function getClient()
        {
            var userId = getUserId();

            if (!userId || !EnvironmentConfig.pubnubSubscribeKey || typeof PubNub === 'undefined') {
                return null;
            }

            if (!pubnub) {
                pubnub = new PubNub({
                    subscribeKey: EnvironmentConfig.pubnubSubscribeKey,
                    userId: userId
                });
            }

            return pubnub;
        }

        function ensureChannelSubscribed(client)
        {
            if (!channelSubscribed) {
                client.subscribe({ channels: [CHANNEL] });
                channelSubscribed = true;
            }
        }

        function maybeUnsubscribeChannel(client)
        {
            if (listeners.length || !channelSubscribed) {
                return;
            }

            client.unsubscribe({ channels: [CHANNEL] });
            channelSubscribed = false;
        }

        function addListener(messageHandler, statusHandler)
        {
            var client = getClient();

            if (!client || !messageHandler) {
                return null;
            }

            var listener = {
                message: function (event) {
                    messageHandler(event.message);
                }
            };

            if (statusHandler) {
                listener.status = function (statusEvent) {
                    statusHandler(statusEvent);
                };
            }

            client.addListener(listener);
            listeners.push(listener);
            ensureChannelSubscribed(client);

            return function removeListener() {
                var index = listeners.indexOf(listener);

                if (index === -1) {
                    return;
                }

                client.removeListener(listener);
                listeners.splice(index, 1);
                maybeUnsubscribeChannel(client);
            };
        }

        function subscribe(messageHandler, statusHandler)
        {
            return addListener(messageHandler, statusHandler) !== null;
        }

        function reset()
        {
            var client = pubnub;
            var i;

            if (!client) {
                return;
            }

            for (i = listeners.length - 1; i >= 0; i--) {
                client.removeListener(listeners[i]);
            }

            listeners = [];

            if (channelSubscribed) {
                client.unsubscribe({ channels: [CHANNEL] });
                channelSubscribed = false;
            }

            if (client.destroy) {
                client.destroy();
            }

            pubnub = null;
        }

        function unsubscribe()
        {
            reset();
        }

        return {
            addListener: addListener,
            subscribe: subscribe,
            unsubscribe: unsubscribe,
            reset: reset
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .factory('messageCenterService', messageCenterService);

    /** @ngInject */
    function messageCenterService($http, $q, EnvironmentConfig)
    {
        var baseUrl = EnvironmentConfig.api + 'Message_Center/';
        var settingsCache = null;
        var settingsPromise = null;
        var threadFilter = 'in_house';

        function getThreadFilter()
        {
            return threadFilter;
        }

        function setThreadFilter(filter)
        {
            threadFilter = filter;
        }

        function requestComplete(response)
        {
            return response.data;
        }

        function requestFailed(error)
        {
            return (error && error.data) ? error.data : { success: false, message: 'Request failed.' };
        }

        function clearSettingsCache()
        {
            settingsCache = null;
            settingsPromise = null;
        }

        function setSettingsCache(response)
        {
            if (response && response.success !== false) {
                settingsCache = response;
            }
        }

        function getMessageThreads(params)
        {
            return $http({
                url: baseUrl + 'getMessageThreads',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getMessageThread(messageThreadId)
        {
            return $http({
                url: baseUrl + 'getMessageThread',
                method: 'GET',
                params: {
                    message_thread_id: messageThreadId
                }
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getThreadMessages(messageThreadId, page, limit)
        {
            return $http({
                url: baseUrl + 'getThreadMessages',
                method: 'GET',
                params: {
                    message_thread_id: messageThreadId,
                    page: page || 1,
                    limit: limit || 50
                }
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getBookingMessages(bookingId, page, limit)
        {
            return $http({
                url: baseUrl + 'getBookingMessages',
                method: 'GET',
                params: {
                    booking_id: bookingId,
                    page: page || 1,
                    limit: limit || 50
                }
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function sendThreadMessage(data)
        {
            return $http({
                url: baseUrl + 'sendThreadMessage',
                method: 'POST',
                data: data
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function sendBookingMessage(data)
        {
            return $http({
                url: baseUrl + 'sendBookingMessage',
                method: 'POST',
                data: data
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function markThreadAsRead(data)
        {
            return $http({
                url: baseUrl + 'markThreadAsRead',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getThreadStayInfo(params)
        {
            return $http({
                url: baseUrl + 'getThreadStayInfo',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getUnreadCounts()
        {
            return $http({
                url: baseUrl + 'getUnreadCounts',
                method: 'GET'
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getSmsThreads(params)
        {
            return $http({
                url: baseUrl + 'getSmsThreads',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getSmsThreadMessages(params)
        {
            // params: conversation_sid (required), page, limit, confirmation_number, sub_hotel_id
            return $http({
                url: baseUrl + 'getSmsThreadMessages',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getSmsMedia(mediaSid, subHotelId)
        {
            return $http({
                url: baseUrl + 'getSmsMedia',
                method: 'GET',
                params: {
                    media_sid: mediaSid,
                    sub_hotel_id: subHotelId || undefined
                }
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function uploadSmsMedia(file, subHotelId)
        {
            var formData = new FormData();
            formData.append('file', file);
            if (subHotelId) {
                formData.append('sub_hotel_id', subHotelId);
            }

            return $http({
                url: baseUrl + 'uploadSmsMedia',
                method: 'POST',
                data: formData,
                headers: { 'Content-Type': undefined },
                transformRequest: angular.identity
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function sendSmsThreadMessage(data)
        {
            // data: conversation_sid, message, media_sid?, sub_hotel_id
            return $http({
                url: baseUrl + 'sendSmsThreadMessage',
                method: 'POST',
                data: data
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function sendStaffThreadMessage(data)
        {
            // data: conversation_sid, message, sub_hotel_id
            return $http({
                url: baseUrl + 'sendStaffThreadMessage',
                method: 'POST',
                data: data
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function startSmsConversation(data)
        {
            // data: confirmation_number, guest_phone, message, channel, sub_hotel_id
            return $http({
                url: baseUrl + 'startSmsConversation',
                method: 'POST',
                data: data
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function markSmsThreadAsRead(data)
        {
            // data: conversation_sid and/or confirmation_number / guest_phone
            return $http({
                url: baseUrl + 'markSmsThreadAsRead',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function searchSmsRecipients(params)
        {
            // params: q, sub_hotel_id, limit
            return $http({
                url: baseUrl + 'searchSmsRecipients',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getUnifiedThreads(params)
        {
            // params: page, limit, q, sub_hotel_id, stay_filter (all|in_house)
            return $http({
                url: baseUrl + 'getUnifiedThreads',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getUnifiedMessages(params)
        {
            // params: confirmation_number (required), channel?, page, limit, order, sub_hotel_id?
            return $http({
                url: baseUrl + 'getUnifiedMessages',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getReservationMessagingContext(params)
        {
            return $http({
                url: baseUrl + 'getReservationMessagingContext',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        // --- STAFF MESSAGING ---

        function searchStaffRecipients(params)
        {
            return $http({
                url: baseUrl + 'searchStaffRecipients',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getStaffThreads(params)
        {
            return $http({
                url: baseUrl + 'getStaffThreads',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function startStaffConversation(data)
        {
            return $http({
                url: baseUrl + 'startStaffConversation',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getStaffMessagingContext(params)
        {
            return $http({
                url: baseUrl + 'getStaffMessagingContext',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function broadcastStaffMessage(data)
        {
            return $http({
                url: baseUrl + 'broadcastStaffMessage',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        // --- END STAFF MESSAGING ---

        function markUnifiedThreadAsRead(data)
        {
            return $http({
                url: baseUrl + 'markUnifiedThreadAsRead',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function setMessagingOptOut(data)
        {
            return $http({
                url: baseUrl + 'setMessagingOptOut',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function setThreadArchived(data)
        {
            return $http({
                url: baseUrl + 'setThreadArchived',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function acknowledgeThread(data)
        {
            return $http({
                url: baseUrl + 'acknowledgeThread',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function setReservationAiMode(data)
        {
            return $http({
                url: baseUrl + 'setReservationAiMode',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function updateGuestPhone(data)
        {
            return $http({
                url: baseUrl + 'updateGuestPhone',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getGuestDirectChatStatus(data)
        {
            return $http({
                url: baseUrl + 'getGuestDirectChatStatus',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function broadcastDirectMessage(data)
        {
            return $http({
                url: baseUrl + 'broadcastDirectMessage',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getBroadcastLogs(params)
        {
            return $http({
                url: baseUrl + 'getBroadcastLogs',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getBroadcastLog(params)
        {
            return $http({
                url: baseUrl + 'getBroadcastLog',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getCustomerThreads(params)
        {
            return $http({
                url: baseUrl + 'getCustomerThreads',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getMessageTemplateTypes(params)
        {
            return $http({

                url: baseUrl + 'getMessageTemplateTypes',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getTemplatesGrouped(params)
        {
            return $http({
                url: baseUrl + 'getTemplatesGrouped',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getTemplateCategories(params)
        {
            return $http({
                url: baseUrl + 'getTemplateCategories',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getTemplates(params)
        {
            return $http({
                url: baseUrl + 'getTemplates',
                method: 'GET',
                params: params || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function createTemplateCategory(data)
        {
            return $http({
                url: baseUrl + 'createTemplateCategory',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function updateTemplateCategory(data)
        {
            return $http({
                url: baseUrl + 'updateTemplateCategory',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function deleteTemplateCategory(data)
        {
            return $http({
                url: baseUrl + 'deleteTemplateCategory',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function createTemplate(data)
        {
            return $http({
                url: baseUrl + 'createTemplate',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function updateTemplate(data)
        {
            return $http({
                url: baseUrl + 'updateTemplate',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function deleteTemplate(data)
        {
            return $http({
                url: baseUrl + 'deleteTemplate',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function getSettings(data, options)
        {
            options = options || {};

            if (!options.force && settingsCache) {
                return $q.when(angular.copy(settingsCache));
            }

            if (!options.force && settingsPromise) {
                return settingsPromise.then(function (payload) {
                    return angular.copy(payload);
                });
            }

            settingsPromise = $http({
                url: baseUrl + 'getSettings',
                method: 'POST',
                data: data || {}
            })
            .then(function (response) {
                var payload = requestComplete(response);
                setSettingsCache(payload);
                return payload;
            })
            .catch(function (error) {
                return requestFailed(error);
            })
            .finally(function () {
                settingsPromise = null;
            });

            return settingsPromise.then(function (payload) {
                return angular.copy(payload);
            });
        }

        function updateSettings(data)
        {
            return $http({
                url: baseUrl + 'updateSettings',
                method: 'POST',
                data: data || {}
            })
            .then(function (response) {
                var payload = requestComplete(response);
                setSettingsCache(payload);
                return payload;
            })
            .catch(requestFailed);
        }

        function getGroupMessageGuests(data)
        {
            return $http({
                url: baseUrl + "getGroupMessageGuests",
                method: "POST",
                data: data
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        function translateText(data)
        {
            // data: { text, target_language, source_language?, message_id? }
            return $http({
                url: baseUrl + 'translateText',
                method: 'POST',
                data: data || {}
            })
            .then(requestComplete)
            .catch(requestFailed);
        }

        // Session cache: one languages fetch until page refresh.
        var translateLanguagesCache = null;
        var translateLanguagesPromise = null;

        function dedupeTranslateLanguages(list)
        {
            var seen = {};
            var out = [];
            angular.forEach(list || [], function (lang) {
                if (!lang || lang.code === undefined || lang.code === null || lang.code === '') {
                    return;
                }
                var code = String(lang.code);
                var key = code.toLowerCase();
                if (seen[key]) {
                    return;
                }
                seen[key] = true;
                out.push({
                    code: code,
                    name: lang.name || code.toUpperCase()
                });
            });
            return out;
        }

        function getTranslateLanguages(forceRefresh)
        {
            if (!forceRefresh && translateLanguagesCache) {
                return $q.resolve({
                    success: true,
                    data: translateLanguagesCache
                });
            }
            if (!forceRefresh && translateLanguagesPromise) {
                return translateLanguagesPromise;
            }

            translateLanguagesPromise = $http({
                url: baseUrl + 'getTranslateLanguages',
                method: 'GET'
            })
            .then(function (response) {
                var result = requestComplete(response);
                if (result && result.success !== false && angular.isArray(result.data) && result.data.length) {
                    var deduped = dedupeTranslateLanguages(result.data);
                    if (deduped.length) {
                        translateLanguagesCache = deduped;
                        result.data = deduped;
                    } else {
                        translateLanguagesPromise = null;
                    }
                } else {
                    translateLanguagesPromise = null;
                }
                return result;
            }, function (error) {
                translateLanguagesPromise = null;
                return requestFailed(error);
            });

            return translateLanguagesPromise;
        }

        function clearTranslateLanguagesCache()
        {
            translateLanguagesCache = null;
            translateLanguagesPromise = null;
        }

        // Settings stay cached for the session; callers clear on logout.
        return {
            getMessageThreads: getMessageThreads,
            getMessageThread: getMessageThread,
            getThreadMessages: getThreadMessages,
            getBookingMessages: getBookingMessages,
            sendThreadMessage: sendThreadMessage,
            sendBookingMessage: sendBookingMessage,
            markThreadAsRead: markThreadAsRead,
            getThreadStayInfo: getThreadStayInfo,
            getUnreadCounts: getUnreadCounts,
            getSmsThreads: getSmsThreads,
            getSmsThreadMessages: getSmsThreadMessages,
            getSmsMedia: getSmsMedia,
            uploadSmsMedia: uploadSmsMedia,
            sendSmsThreadMessage: sendSmsThreadMessage,
            sendStaffThreadMessage: sendStaffThreadMessage,
            startSmsConversation: startSmsConversation,
            markSmsThreadAsRead: markSmsThreadAsRead,
            searchSmsRecipients: searchSmsRecipients,
            getUnifiedThreads: getUnifiedThreads,
            getUnifiedMessages: getUnifiedMessages,
            getReservationMessagingContext: getReservationMessagingContext,
            markUnifiedThreadAsRead: markUnifiedThreadAsRead,
            setMessagingOptOut: setMessagingOptOut,
            setThreadArchived: setThreadArchived,
            acknowledgeThread: acknowledgeThread,
            setReservationAiMode: setReservationAiMode,
            updateGuestPhone: updateGuestPhone,
            getGuestDirectChatStatus: getGuestDirectChatStatus,
            broadcastDirectMessage: broadcastDirectMessage,
            getBroadcastLogs: getBroadcastLogs,
            getBroadcastLog: getBroadcastLog,
            getCustomerThreads: getCustomerThreads,
            getMessageTemplateTypes: getMessageTemplateTypes,
            getTemplatesGrouped: getTemplatesGrouped,
            getTemplateCategories: getTemplateCategories,
            getTemplates: getTemplates,
            createTemplateCategory: createTemplateCategory,
            updateTemplateCategory: updateTemplateCategory,
            translateText: translateText,
            getTranslateLanguages: getTranslateLanguages,
            clearTranslateLanguagesCache: clearTranslateLanguagesCache,
            deleteTemplateCategory: deleteTemplateCategory,
            createTemplate: createTemplate,
            updateTemplate: updateTemplate,
            deleteTemplate: deleteTemplate,
            getSettings: getSettings,
            updateSettings: updateSettings,
            clearSettingsCache: clearSettingsCache,
            searchStaffRecipients: searchStaffRecipients,
            getStaffThreads: getStaffThreads,
            startStaffConversation: startStaffConversation,
            getStaffMessagingContext: getStaffMessagingContext,
            broadcastStaffMessage: broadcastStaffMessage,
            getGroupMessageGuests: getGroupMessageGuests,
            getThreadFilter: getThreadFilter,
            setThreadFilter: setThreadFilter
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .factory('messageCenterNotificationSoundService', messageCenterNotificationSoundService);

    /** @ngInject */
    function messageCenterNotificationSoundService()
    {
        var MESSAGE_SOUND_URL = 'assets/sounds/notify-08-doorbell.wav';
        var ESCALATION_SOUND_URL = 'assets/sounds/escalation-alert.mp3';
        var messageAudio = null;
        var escalationAudio = null;
        var unlocked = false;
        var unlockBound = false;

        function ensureAudio(kind)
        {
            if (kind === 'escalation') {
                if (!escalationAudio && typeof Audio !== 'undefined') {
                    escalationAudio = new Audio(ESCALATION_SOUND_URL);
                    escalationAudio.preload = 'auto';
                    escalationAudio.volume = 0.65;
                }

                return escalationAudio;
            }

            if (!messageAudio && typeof Audio !== 'undefined') {
                messageAudio = new Audio(MESSAGE_SOUND_URL);
                messageAudio.preload = 'auto';
                messageAudio.volume = 0.5;
            }

            return messageAudio;
        }

        function softUnlock(audio)
        {
            if (!audio) {
                return Promise.resolve();
            }

            audio.muted = true;

            return audio.play().then(function () {
                audio.pause();
                audio.currentTime = 0;
                audio.muted = false;
            }).catch(angular.noop);
        }

        /**
         * Browsers block autoplay until a user gesture. Soft-unlock after first
         * click/keydown so later PubNub toasts can play without a second gesture.
         */
        function unlock()
        {
            if (unlocked) {
                return;
            }

            var message = ensureAudio('message');
            var escalation = ensureAudio('escalation');

            Promise.all([
                softUnlock(message),
                softUnlock(escalation)
            ]).then(function () {
                unlocked = true;
            }).catch(angular.noop);
        }

        function bindUnlock()
        {
            if (unlockBound || typeof document === 'undefined') {
                return;
            }

            unlockBound = true;
            document.addEventListener('click', unlock, { once: true, capture: true });
            document.addEventListener('keydown', unlock, { once: true, capture: true });
            document.addEventListener('touchstart', unlock, { once: true, capture: true });
        }

        function playKind(kind)
        {
            var a = ensureAudio(kind);

            if (!a) {
                return;
            }

            try {
                a.pause();
                a.currentTime = 0;
                a.play().catch(angular.noop);
            } catch (e) {
                // Ignore autoplay / missing-file failures.
            }
        }

        function play(type)
        {
            if (type === 'escalation') {
                playKind('escalation');
                return;
            }

            playKind('message');
        }

        function playEscalation()
        {
            playKind('escalation');
        }

        bindUnlock();

        return {
            play: play,
            playEscalation: playEscalation,
            unlock: unlock
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .factory('messageCenterNavBadgeService', messageCenterNavBadgeService);

    /** @ngInject */
    function messageCenterNavBadgeService(
        $rootScope,
        $q,
        $interval,
        $localStorage,
        msNavigationService,
        messageCenterService,
        otaMessageCenterPubNubService,
        smsMessageCenterPubNubService
    )
    {
        var BADGE_COLOR = '#D32F2F';
        var otaCount = 0;
        var directCount = 0;
        var staffCount = 0;
        var threadUnreadMap = {};
        var directThreadUnreadMap = {};
        var started = false;
        var removePubNubListener = null;
        var removeSmsPubNubListener = null;
        var removeVisibilityListener = null;
        var refreshing = false;
        var pendingRefresh = false;
        var otaEnabled = false;
        var smsEnabled = false;
        var whatsappEnabled = false;
        var guestNameCache = {};
        // confirmation_number -> bool — staff vs guest thread for toast routing.
        var staffThreadCache = {};
        // confirmation_number -> bool — suppress guest “New message” toasts while AI is handling.
        var aiModeByConfirmation = {};
        var baseTitle = '';
        var titleTimer = null;
        var showNewTitle = true;

        function hasPermission()
        {
            var perms = $rootScope.userPermissions || '';

            return perms.indexOf('All') !== -1 ||
                perms.indexOf('message_center') !== -1 ||
                perms.indexOf('messages') !== -1 ||
                perms.indexOf('ota') !== -1 ||
                perms.indexOf('direct') !== -1 ||
                perms.indexOf('getMessageThreads') !== -1;
        }

        function getSelectedHotelId()
        {
            if (!$localStorage.hotels || $localStorage.selectedHotel === undefined) {
                return null;
            }

            return parseInt($localStorage.hotels[$localStorage.selectedHotel].hotel_id, 10);
        }

        function getSubHotelIds()
        {
            var ids = [];
            var subHotels = $rootScope.subHotelsOfSelected || $rootScope.subHotels || [];
            var i;

            for (i = 0; i < subHotels.length; i++) {
                if (subHotels[i].hotel_id) {
                    ids.push(parseInt(subHotels[i].hotel_id, 10));
                }
            }

            return ids;
        }

        function belongsToCurrentHotel(hotelId)
        {
            if (!hotelId) {
                return true;
            }

            var selectedHotelId = getSelectedHotelId();
            var normalizedHotelId = parseInt(hotelId, 10);

            if (selectedHotelId && normalizedHotelId === selectedHotelId) {
                return true;
            }

            return getSubHotelIds().indexOf(normalizedHotelId) !== -1;
        }

        function buildBadge(count)
        {
            count = parseInt(count, 10) || 0;

            if (!count) {
                return null;
            }

            return {
                content: count > 99 ? '99+' : String(count),
                color: BADGE_COLOR
            };
        }

        function updateNav()
        {
            if (!hasPermission()) {
                return;
            }

            var total = unreadTotal();
            var badge = buildBadge(total);

            msNavigationService.saveItem('message_center.messages', { badge: badge });
            msNavigationService.saveItem('message_center', { badge: badge });
            msNavigationService.sort();
            syncTitle();
        }

        function getGuestUnreadTotal()
        {
            var otaTotal = otaEnabled ? (parseInt(otaCount, 10) || 0) : 0;
            var directTotal = (smsEnabled || whatsappEnabled) ? (parseInt(directCount, 10) || 0) : 0;

            return otaTotal + directTotal;
        }

        function getStaffUnreadTotal()
        {
            // Staff messages are only via direct channels (Twilio)
            return (smsEnabled || whatsappEnabled) ? (parseInt(staffCount, 10) || 0) : 0;
        }

        function unreadTotal()
        {
            return getGuestUnreadTotal() + getStaffUnreadTotal();
        }

        function applyChannelSettings(source)
        {
            var settings;

            if (!source) {
                return;
            }

            settings = source.settings || source;

            if (settings.ota_messaging_enabled !== undefined) {
                otaEnabled = settings.ota_messaging_enabled === true ||
                    settings.ota_messaging_enabled === 1 ||
                    settings.ota_messaging_enabled === '1';
            }

            if (settings.sms_messaging_enabled !== undefined) {
                smsEnabled = settings.sms_messaging_enabled === true ||
                    settings.sms_messaging_enabled === 1 ||
                    settings.sms_messaging_enabled === '1';
            }

            if (settings.whatsapp_messaging_enabled !== undefined) {
                whatsappEnabled = settings.whatsapp_messaging_enabled === true ||
                    settings.whatsapp_messaging_enabled === 1 ||
                    settings.whatsapp_messaging_enabled === '1';
            }
        }

        function stopTitleBlink()
        {
            if (titleTimer) {
                $interval.cancel(titleTimer);
                titleTimer = null;
            }
            showNewTitle = true;
        }

        function syncTitle()
        {
            var total = unreadTotal();
            var current = String($rootScope.siteTitle || '');

            // Keep the real page title when router updates it (ignore blink text).
            if (current && current.indexOf(' new msg ') === -1) {
                baseTitle = current;
            }
            if (!baseTitle) {
                baseTitle = 'Lodging System M';
            }

            if (!hasPermission() || total <= 0) {
                stopTitleBlink();
                $rootScope.siteTitle = baseTitle;
                return;
            }

            $rootScope.siteTitle = showNewTitle
                ? ('** ' + (total > 99 ? '99+' : total) + ' new msg **')
                : baseTitle;

            if (!titleTimer) {
                titleTimer = $interval(function () {
                    showNewTitle = !showNewTitle;
                    syncTitle();
                }, 1600);
            }
        }

        // -----------------------------------------------------------------
        // Shared per-thread unread accounting for OTA and Direct providers.
        // -----------------------------------------------------------------

        function applyUnreadChange(provider, threadId, count, knownPreviousCount)
        {
            if (!threadId) {
                return;
            }

            var map = provider === 'direct' ? directThreadUnreadMap : threadUnreadMap;
            var normalizedCount = parseInt(count, 10) || 0;
            var hasMappedPrevious = Object.prototype.hasOwnProperty.call(map, threadId);
            var previousCount;
            var delta = 0;

            if (hasMappedPrevious) {
                previousCount = parseInt(map[threadId], 10) || 0;
            } else if (knownPreviousCount !== undefined && knownPreviousCount !== null) {
                previousCount = parseInt(knownPreviousCount, 10) || 0;
            } else {
                previousCount = null;
            }

            if (previousCount === null) {
                if (normalizedCount > 0) {
                    map[threadId] = normalizedCount;
                } else {
                    delete map[threadId];
                }

                refresh();
                return;
            }

            if (previousCount !== normalizedCount) {
                delta = normalizedCount - previousCount;
            }

            if (provider === 'direct') {
                directCount = Math.max(0, directCount + delta);
            } else {
                otaCount = Math.max(0, otaCount + delta);
            }

            if (normalizedCount > 0) {
                map[threadId] = normalizedCount;
            } else {
                delete map[threadId];
            }

            updateNav();
        }

        function setUnread(provider, threadId, count, knownPreviousCount)
        {
            if (!threadId) {
                return;
            }

            var map = provider === 'direct' ? directThreadUnreadMap : threadUnreadMap;
            var normalizedCount = parseInt(count, 10) || 0;

            if (normalizedCount === 0) {
                var previousUnread = 0;

                if (knownPreviousCount !== undefined && knownPreviousCount !== null) {
                    previousUnread = parseInt(knownPreviousCount, 10) || 0;
                } else if (Object.prototype.hasOwnProperty.call(map, threadId)) {
                    previousUnread = parseInt(map[threadId], 10) || 0;
                }

                if (previousUnread > 0) {
                    if (provider === 'direct') {
                        directCount = Math.max(0, directCount - previousUnread);
                    } else {
                        otaCount = Math.max(0, otaCount - previousUnread);
                    }
                }

                delete map[threadId];
                updateNav();
                return;
            }

            applyUnreadChange(provider, threadId, count, knownPreviousCount);
        }

        function setThreadUnread(threadId, count, knownPreviousCount)
        {
            setUnread('ota', threadId, count, knownPreviousCount);
        }

        function setDirectThreadUnread(conversationSid, count, knownPreviousCount)
        {
            setUnread('direct', conversationSid, count, knownPreviousCount);
        }

        function syncThreadUnreadMap(threads)
        {
            var i;
            var threadId;
            var count;

            if (!threads || !threads.length) {
                return;
            }

            for (i = 0; i < threads.length; i++) {
                threadId = threads[i].thread_id;
                count = parseInt(threads[i].ota_msg_unread_count, 10) || 0;

                if (threadId && count > 0) {
                    threadUnreadMap[threadId] = count;
                }
            }
        }

        function syncDirectThreadUnreadMap(threads)
        {
            var i;
            var conversationSid;
            var count;

            if (!threads || !threads.length) {
                return;
            }

            for (i = 0; i < threads.length; i++) {
                conversationSid = threads[i].conversation_sid;
                count = parseInt(threads[i].direct_msg_unread_counter, 10) || 0;

                if (conversationSid && count > 0) {
                    directThreadUnreadMap[conversationSid] = count;
                }
            }
        }

        function applyCountsFromApi(data)
        {
            if (!data) {
                return;
            }

            otaCount = parseInt(data.ota_unread_total, 10) || 0;
            directCount = parseInt(data.direct_unread_total, 10) || 0;
            staffCount = parseInt(data.staff_unread_total, 10) || 0;
            threadUnreadMap = {};
            directThreadUnreadMap = {};
            updateNav();
        }

        function refresh()
        {
            if (!hasPermission()) {
                return;
            }

            if (refreshing) {
                pendingRefresh = true;
                return;
            }

            refreshing = true;

            messageCenterService.getUnreadCounts().then(function (response) {
                refreshing = false;

                if (response && response.success !== false && response.data) {
                    applyChannelSettings(response);
                    applyCountsFromApi(response.data);
                }

                if (pendingRefresh) {
                    pendingRefresh = false;
                    refresh();
                }
            }, function () {
                refreshing = false;

                if (pendingRefresh) {
                    pendingRefresh = false;
                    refresh();
                }
            });
        }

        // AI mode toast suppression + PubNub unread (guest may briefly bump; AI sent is final)
        function coerceAi(v)
        {
            return v === true || v === 1 || v === '1';
        }

        function unreadVal(data, key, fallback)
        {
            return (data && data[key] != null) ? data[key] : fallback;
        }

        function setAiModeKnown(confirmation, on)
        {
            if (!confirmation) {
                return;
            }

            if (coerceAi(on)) {
                aiModeByConfirmation[confirmation] = true;
            } else {
                delete aiModeByConfirmation[confirmation];
            }
        }

        function noteAiMode(data)
        {
            if (data && data.confirmation_number && data.ai_mode != null) {
                setAiModeKnown(data.confirmation_number, data.ai_mode);
            }
        }

        function coerceStaffFlag(value)
        {
            return value === true || value === 1 || value === '1';
        }

        function noteStaffThread(data)
        {
            var confirmation;

            if (!data || data.is_staff == null) {
                return;
            }

            confirmation = data.confirmation_number || '';
            if (confirmation) {
                staffThreadCache[confirmation] = coerceStaffFlag(data.is_staff);
            }
        }

        function isStaffThread(data)
        {
            var confirmation;

            if (!data) {
                return false;
            }

            if (data.is_staff != null) {
                noteStaffThread(data);
                return coerceStaffFlag(data.is_staff);
            }

            confirmation = data.confirmation_number || '';
            if (confirmation && Object.prototype.hasOwnProperty.call(staffThreadCache, confirmation)) {
                return !!staffThreadCache[confirmation];
            }

            return false;
        }

        /** Suppress guest "New message" toast while reservation AI Mode is ON. */
        function suppressGuestToast(data)
        {
            noteAiMode(data);
            noteStaffThread(data);
            if (!data) {
                return false;
            }

            // Staff threads never run AI Mode — always show their toast.
            if (isStaffThread(data)) {
                return false;
            }

            return !!(data.confirmation_number && aiModeByConfirmation[data.confirmation_number]) ||
                coerceAi(data.ai_mode);
        }

        function directThreadId(data)
        {
            return (data && (data.conversation_sid || data.confirmation_number)) || '';
        }

        function directReadIds(data)
        {
            var ids = [];
            var id;

            if (!data) {
                return ids;
            }

            if (data.conversation_sid) {
                ids.push(data.conversation_sid);
            }

            if (data.confirmation_number && ids.indexOf(data.confirmation_number) === -1) {
                ids.push(data.confirmation_number);
            }

            if (!ids.length) {
                id = directThreadId(data);

                if (id) {
                    ids.push(id);
                }
            }

            return ids;
        }

        /**
         * Zero a direct thread on every session. If neither id is in the local
         * map, reload getUnreadCounts the same way an unknown OTA read does.
         */
        function applyDirectThreadRead(data)
        {
            var ids = directReadIds(data);
            var i;
            var mappedId = '';

            if (!ids.length) {
                refresh();
                return;
            }

            for (i = 0; i < ids.length; i++) {
                if (Object.prototype.hasOwnProperty.call(directThreadUnreadMap, ids[i])) {
                    mappedId = ids[i];
                    break;
                }
            }

            if (!mappedId) {
                applyUnreadChange('direct', ids[0], 0);
                return;
            }

            applyUnreadChange('direct', mappedId, 0);

            for (i = 0; i < ids.length; i++) {
                if (ids[i] !== mappedId) {
                    delete directThreadUnreadMap[ids[i]];
                }
            }
        }

        function handlePubNubMessage(data)
        {
            if (!data || !data.event || !belongsToCurrentHotel(data.hotel_id)) {
                return;
            }

            if (data.ota_unread_total != null) {
                otaCount = parseInt(data.ota_unread_total, 10) || 0;
                updateNav();
                return;
            }

            switch (data.event) {
                case 'ai_mode_changed':
                    noteAiMode(data);
                    break;

                case 'ota_new_message':
                    if (!data.message_thread_id) {
                        break;
                    }

                    applyUnreadChange(
                        'ota',
                        data.message_thread_id,
                        unreadVal(data, 'ota_msg_unread_count', 1)
                    );

                    if (!suppressGuestToast(data)) {
                        emitInboxToast(data, 'OTA');
                    }
                    break;

                case 'ota_message_sent':
                    if (data.message_thread_id && data.ota_msg_unread_count != null) {
                        applyUnreadChange('ota', data.message_thread_id, data.ota_msg_unread_count);
                    } else {
                        refresh();
                    }
                    break;

                case 'ota_support_escalation':
                    noteAiMode(data);

                    if (data.message_thread_id && data.ota_msg_unread_count != null) {
                        applyUnreadChange('ota', data.message_thread_id, data.ota_msg_unread_count);
                    }

                    emitEscalationToast(data, 'OTA');
                    break;

                case 'ota_thread_read':
                    if (data.message_thread_id) {
                        applyUnreadChange('ota', data.message_thread_id, 0);
                    } else {
                        // Unified mark-as-read publishes confirmation_number only.
                        refresh();
                    }
                    break;
            }
        }

        function handleSmsPubNubMessage(data)
        {
            var id;

            if (!data || !data.event || !belongsToCurrentHotel(data.hotel_id)) {
                return;
            }

            switch (data.event) {
                case 'ai_mode_changed':
                    noteAiMode(data);
                    break;

                case 'sms_support_escalation':
                    noteAiMode(data);
                    id = directThreadId(data);

                    if (id && data.direct_msg_unread_counter != null) {
                        applyUnreadChange('direct', id, data.direct_msg_unread_counter);
                    }

                    emitEscalationToast(data, data.channel === 'whatsapp' ? 'WhatsApp' : 'SMS');
                    break;

                case 'sms_message_sent':
                    id = directThreadId(data);

                    if (id && data.direct_msg_unread_counter != null) {
                        applyUnreadChange('direct', id, data.direct_msg_unread_counter);
                    } else {
                        refresh();
                    }
                    break;

                case 'sms_new_message':
                    id = directThreadId(data);

                    if (!id) {
                        break;
                    }

                    applyUnreadChange(
                        'direct',
                        id,
                        unreadVal(data, 'direct_msg_unread_counter', 1)
                    );

                    if (!suppressGuestToast(data)) {
                        emitInboxToast(data, data.channel === 'whatsapp' ? 'WhatsApp' : 'SMS');
                    }
                    break;

                case 'sms_thread_read':
                    applyDirectThreadRead(data);
                    break;
            }
        }

        function getMessagePreview(data)
        {
            if (!data) {
                return '';
            }

            if (typeof data.message === 'string') {
                return data.message;
            }

            if (data.message && typeof data.message.message === 'string') {
                return data.message.message;
            }

            return '';
        }

        function buildInboxToastPayload(data, channelLabel, guestName)
        {
            var preview = getMessagePreview(data);
            var name = (guestName || data.guest_name || '').trim();
            var staff = isStaffThread(data);

            return {
                type: 'message',
                heading: 'New message',
                channel: channelLabel || 'Message',
                guest_name: name,
                title: name || (staff ? 'Staff' : 'Guest'),
                preview: preview || 'New message received',
                confirmation_number: data.confirmation_number || '',
                conversation_sid: data.conversation_sid || '',
                message_thread_id: data.message_thread_id || '',
                is_staff: staff
            };
        }

        function resolveGuestName(data)
        {
            var confirmation = (data && data.confirmation_number) || '';
            var knownName = ((data && data.guest_name) || '').trim();
            // When PubNub omits is_staff, still resolve via stay info so toast click
            // routes to staff inbox instead of guest inbox.
            var needsStaffLookup = !!(confirmation && data && data.is_staff == null &&
                !Object.prototype.hasOwnProperty.call(staffThreadCache, confirmation));

            noteStaffThread(data);

            if (knownName && !needsStaffLookup) {
                if (confirmation) {
                    guestNameCache[confirmation] = knownName;
                }

                return $q.resolve(knownName);
            }

            if (confirmation && guestNameCache[confirmation] && !needsStaffLookup) {
                return $q.resolve(guestNameCache[confirmation]);
            }

            if (!confirmation && !(data && data.message_thread_id) && !(data && data.booking_id)) {
                return $q.resolve('');
            }

            return messageCenterService.getThreadStayInfo({
                confirmation_number: confirmation,
                message_thread_id: (data && data.message_thread_id) || '',
                booking_id: (data && data.booking_id) || ''
            }).then(function (response) {
                var name = '';

                if (response && response.success !== false && response.data) {
                    name = (response.data.guest_name || '').trim();
                    if (response.data.is_staff != null && confirmation) {
                        staffThreadCache[confirmation] = coerceStaffFlag(response.data.is_staff);
                        data.is_staff = staffThreadCache[confirmation];
                    }
                }

                if (!name && knownName) {
                    name = knownName;
                }

                if (name && name.toLowerCase() !== 'guest' && name.toLowerCase() !== 'staff') {
                    if (confirmation) {
                        guestNameCache[confirmation] = name;
                    }

                    return name;
                }

                if (name) {
                    if (confirmation) {
                        guestNameCache[confirmation] = name;
                    }

                    return name;
                }

                // Fallback: unified thread list often already has guest_name.
                if (!confirmation) {
                    return name;
                }

                // Staff threads are not in the guest unified list.
                if (isStaffThread(data)) {
                    return name;
                }

                return messageCenterService.getUnifiedThreads({
                    q: confirmation,
                    page: 1,
                    limit: 5
                }).then(function (threadResponse) {
                    var threads = (threadResponse && threadResponse.data) || [];
                    var i;
                    var threadName = '';

                    for (i = 0; i < threads.length; i++) {
                        if ((threads[i].confirmation_number || '') === confirmation) {
                            threadName = (threads[i].guest_name || threads[i].title || '').trim();
                            if (threadName) {
                                break;
                            }
                        }
                    }

                    if (!threadName && threads.length) {
                        threadName = (threads[0].guest_name || threads[0].title || '').trim();
                    }

                    if (threadName) {
                        guestNameCache[confirmation] = threadName;
                    }

                    return threadName || name;
                }).catch(function () {
                    return name;
                });
            }).catch(function () {
                return knownName || '';
            });
        }

        function emitInboxToast(data, channelLabel)
        {
            var preview = getMessagePreview(data);
            var knownName = ((data && data.guest_name) || '').trim();
            var confirmation = (data && data.confirmation_number) || '';

            noteStaffThread(data);

            if (!preview && (data.opt_out === 'stop' || data.opt_out === 'start')) {
                return;
            }

            if (!knownName && confirmation && guestNameCache[confirmation]) {
                knownName = guestNameCache[confirmation];
            }

            // Avoid flashing confirmation number as the title when we can resolve a name.
            // Also resolve when staff flag is unknown so toast click routes to the right inbox.
            if ((knownName || !confirmation) &&
                (data.is_staff != null || !confirmation ||
                    Object.prototype.hasOwnProperty.call(staffThreadCache, confirmation))) {
                $rootScope.$broadcast(
                    'messageCenter:inboxToast',
                    buildInboxToastPayload(data, channelLabel, knownName)
                );
                return;
            }

            resolveGuestName(data).then(function (guestName) {
                $rootScope.$applyAsync(function () {
                    $rootScope.$broadcast(
                        'messageCenter:inboxToast',
                        buildInboxToastPayload(data, channelLabel, guestName)
                    );
                });
            });
        }

        function getEscalationPreview(data)
        {
            var query = data && data.escalation_query
                ? String(data.escalation_query).replace(/^\s+|\s+$/g, '')
                : '';

            if (query) {
                return query;
            }

            query = getMessagePreview(data);
            if (query) {
                return query;
            }

            return 'Guest needs staff assistance';
        }

        function emitEscalationToast(data, channelLabel)
        {
            var preview = getEscalationPreview(data);
            var confirmation = (data && data.confirmation_number) || '';

            function broadcast(guestName)
            {
                var name = (guestName || '').trim();
                var staff = isStaffThread(data || {});

                $rootScope.$broadcast('messageCenter:inboxToast', {
                    type: 'escalation',
                    force: true,
                    heading: 'Escalation',
                    channel: channelLabel || 'Message',
                    guest_name: name || confirmation || (staff ? 'Staff' : 'Guest'),
                    title: name || confirmation || (staff ? 'Staff' : 'Guest'),
                    preview: preview,
                    confirmation_number: confirmation,
                    conversation_sid: (data && data.conversation_sid) || '',
                    message_thread_id: (data && data.message_thread_id) || '',
                    is_staff: staff
                });
            }

            resolveGuestName(data || {}).then(function (guestName) {
                $rootScope.$applyAsync(function () {
                    broadcast(guestName);
                });
            });
        }

        function onVisibilityChange()
        {
            if (document.hidden || !hasPermission()) {
                return;
            }

            refresh();
        }

        function startVisibilityRefresh()
        {
            if (removeVisibilityListener) {
                return;
            }

            document.addEventListener('visibilitychange', onVisibilityChange);
            removeVisibilityListener = function () {
                document.removeEventListener('visibilitychange', onVisibilityChange);
                removeVisibilityListener = null;
            };
        }

        function startGlobalPubNub()
        {
            if (!removePubNubListener) {
                removePubNubListener = otaMessageCenterPubNubService.addListener(function (data) {
                    $rootScope.$applyAsync(function () {
                        handlePubNubMessage(data);
                    });
                });
            }

            if (!removeSmsPubNubListener) {
                removeSmsPubNubListener = smsMessageCenterPubNubService.addListener(function (data) {
                    $rootScope.$applyAsync(function () {
                        handleSmsPubNubMessage(data);
                    });
                });
            }
        }

        function init()
        {
            if (started || !hasPermission()) {
                return;
            }

            started = true;
            baseTitle = $rootScope.siteTitle || baseTitle;
            startGlobalPubNub();
            startVisibilityRefresh();
            messageCenterService.getSettings({}).then(function (response) {
                if (!response || response.success === false) {
                    return;
                }

                applyChannelSettings(response);
                updateNav();
            });
            refresh();

            $rootScope.$on('$stateChangeSuccess', function () {
                $rootScope.$evalAsync(function () {
                    if (($rootScope.siteTitle || '').indexOf(' new msg ') === -1) {
                        baseTitle = $rootScope.siteTitle || baseTitle;
                    }
                    syncTitle();
                });
            });
        }

        $rootScope.$on('app:loggedIn', function () {
            init();
        });

        function destroy()
        {
            started = false;
            stopTitleBlink();

            if (removePubNubListener) {
                removePubNubListener();
                removePubNubListener = null;
            }

            if (removeSmsPubNubListener) {
                removeSmsPubNubListener();
                removeSmsPubNubListener = null;
            }

            if (removeVisibilityListener) {
                removeVisibilityListener();
            }

            otaCount = 0;
            directCount = 0;
            staffCount = 0;
            otaEnabled = false;
            smsEnabled = false;
            whatsappEnabled = false;
            threadUnreadMap = {};
            directThreadUnreadMap = {};
            guestNameCache = {};
            staffThreadCache = {};
            aiModeByConfirmation = {};
            updateNav();
        }

        return {
            init: init,
            destroy: destroy,
            refresh: refresh,
            refreshOtaUnreadCount: refresh,
            setThreadUnread: setThreadUnread,
            setDirectThreadUnread: setDirectThreadUnread,
            syncThreadUnreadMap: syncThreadUnreadMap,
            syncDirectThreadUnreadMap: syncDirectThreadUnreadMap,
            setReservationAiModeKnown: setAiModeKnown,
            getUnreadTotal: unreadTotal,
            getGuestUnreadTotal: getGuestUnreadTotal,
            getStaffUnreadTotal: getStaffUnreadTotal
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .factory('messageCenterComposerSignature', messageCenterComposerSignature);

    /**
     * Staff composer signature helpers for Message Center.
     *
     * Compose UI shows the signature on its own line ("- John") so the agent
     * types above it. Outbound payloads keep the existing guest-facing format
     * ("Hello - John"). AI / automated sends still use "- Lisa" on the backend.
     *
     * @ngInject
     */
    function messageCenterComposerSignature($localStorage)
    {
        return {
            getStaffDisplayName: getStaffDisplayName,
            getSignatureLine: getSignatureLine,
            split: split,
            ensureInComposer: ensureInComposer,
            toOutboundMessage: toOutboundMessage,
            hasBodyBeyondSignature: hasBodyBeyondSignature,
            placeCaretBeforeSignature: placeCaretBeforeSignature
        };

        function getStaffDisplayName()
        {
            var first = String($localStorage.firstName || '').trim();
            if (first) {
                return first;
            }

            return String($localStorage.lastName || '').trim();
        }

        function getSignatureLine(name)
        {
            name = String(name || '').trim();
            if (!name) {
                return '';
            }

            return '- ' + name;
        }

        function escapeRegExp(value)
        {
            return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        }

        /**
         * Split composer / outbound text into body + trailing signature.
         * Accepts both multiline compose form and same-line outbound form.
         */
        function split(text, name)
        {
            var raw = String(text == null ? '' : text);
            var signature = getSignatureLine(name);
            var empty = {
                body: raw.replace(/\s+$/, ''),
                signature: '',
                hasSignature: false,
                signatureIndex: -1
            };

            if (!signature) {
                return empty;
            }

            var exactRe = new RegExp('^\\s*' + escapeRegExp(signature) + '\\s*$');
            if (exactRe.test(raw)) {
                return {
                    body: '',
                    signature: signature,
                    hasSignature: true,
                    signatureIndex: raw.search(new RegExp(escapeRegExp(signature)))
                };
            }

            // Multiline compose: optional blank line before "- Name"
            var multiRe = new RegExp('(?:\\r?\\n)+\\s*' + escapeRegExp(signature) + '\\s*$');
            var multiMatch = multiRe.exec(raw);
            if (multiMatch) {
                return {
                    body: raw.slice(0, multiMatch.index).replace(/\s+$/, ''),
                    signature: signature,
                    hasSignature: true,
                    signatureIndex: multiMatch.index
                };
            }

            // Same-line outbound / legacy: "message - Name"
            var sameLineRe = new RegExp('(?:^|\\s)' + escapeRegExp(signature) + '\\s*$');
            var sameMatch = sameLineRe.exec(raw);
            if (sameMatch) {
                var idx = sameMatch.index;
                // If matched via leading whitespace, keep caret/index at the dash.
                if (raw.charAt(idx) !== '-') {
                    idx = raw.indexOf(signature, idx);
                }
                return {
                    body: raw.slice(0, sameMatch.index).replace(/\s+$/, ''),
                    signature: signature,
                    hasSignature: true,
                    signatureIndex: idx < 0 ? sameMatch.index : idx
                };
            }

            return empty;
        }

        /**
         * Ensure composer text ends with a newline + "- Name". Empty drafts become
         * "\n- Name" so the caret can sit before the signature.
         */
        function ensureInComposer(text, name)
        {
            name = String(name || getStaffDisplayName()).trim();
            if (!name) {
                return String(text == null ? '' : text);
            }

            var parts = split(text, name);
            if (!parts.body) {
                return '\n' + getSignatureLine(name);
            }

            return parts.body + '\n' + getSignatureLine(name);
        }

        /**
         * Wire format sent to guests / APIs: "body - Name" (same line).
         * Signature-only drafts return ''.
         * If the user removed the signature from the composer, body is sent as-is.
         */
        function toOutboundMessage(text, name)
        {
            name = String(name || getStaffDisplayName()).trim();
            var parts = split(text, name);
            var body = String(parts.body || '').replace(/^\s+|\s+$/g, '');

            if (!body) {
                return '';
            }

            if (!name || !parts.hasSignature) {
                return body;
            }

            return body + ' ' + getSignatureLine(name);
        }

        function hasBodyBeyondSignature(text, name)
        {
            name = String(name || getStaffDisplayName()).trim();
            var parts = split(text, name);
            return !!String(parts.body || '').replace(/^\s+|\s+$/g, '');
        }

        function placeCaretBeforeSignature(textarea, name)
        {
            if (!textarea) {
                return;
            }

            name = String(name || getStaffDisplayName()).trim();
            var parts = split(textarea.value, name);
            var index = 0;

            if (parts.hasSignature && parts.signatureIndex >= 0) {
                // Prefer the blank line before the signature when present.
                index = parts.signatureIndex;
                if (index > 0 && (textarea.value.charAt(index - 1) === '\n')) {
                    index = index - 1;
                }
            } else if (parts.body) {
                index = String(parts.body).length;
            }

            try {
                textarea.focus();
                textarea.setSelectionRange(index, index);
            } catch (e) {
                // ignore unsupported selection
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .factory('messageCenterBrowserNotificationService', messageCenterBrowserNotificationService);

    /** @ngInject */
    function messageCenterBrowserNotificationService(
        $rootScope,
        $window,
        $localStorage,
        $state,
        $q,
        $timeout,
        messageCenterService,
        storageService
    )
    {
        // Nested under $localStorage.lodgingsystem.browser_notifications.data
        // Only prefs are persisted; cross-tab locks use BroadcastChannel.
        var STORAGE_SECTION = 'browser_notifications';
        var DATA_KEY = 'data';
        // Survives refresh; cleared on logout so the prompt returns on next login.
        var SESSION_DISMISS_KEY = 'mcBrowserNotificationPromptDismissed';
        var BROADCAST_CHANNEL_NAME = 'mc-browser-notifications';
        var NOTIFICATION_CLAIM_MS = 4000;
        var PROMPT_CLAIM_MS = 8000;
        var SETTINGS_TTL_MS = 30000;
        var started = false;
        var prompting = false;
        var promptNode = null;
        var hotelEnabled = false;
        var hotelLoaded = false;
        var hotelLoadedAt = 0;
        var loadedHotelId = null;
        var settingsRequest = null;
        var removeToastListener = null;
        var removeVisibilityListener = null;
        var removeLoginListener = null;
        var removeStateListener = null;
        var removeSettingsListener = null;
        var broadcastChannel = null;
        var lastNotificationClaim = { sig: '', at: 0 };
        var lastPromptClaimAt = 0;

        function isSupported()
        {
            return typeof $window.Notification === 'function';
        }

        function permission()
        {
            if (!isSupported()) {
                return 'unsupported';
            }

            return $window.Notification.permission || 'default';
        }

        function isFlag(value)
        {
            return value === true || value === 1 || value === '1';
        }

        function userId()
        {
            return String($localStorage.userId || '0');
        }

        function currentHotelId()
        {
            if (!$localStorage.hotels || $localStorage.selectedHotel === undefined || $localStorage.selectedHotel === '') {
                return null;
            }

            var hotel = $localStorage.hotels[$localStorage.selectedHotel];

            return hotel && hotel.hotel_id ? String(hotel.hotel_id) : null;
        }

        function hasPermission()
        {
            var perms = $rootScope.userPermissions || '';

            return perms.indexOf('All') !== -1 ||
                perms.indexOf('message_center') !== -1 ||
                perms.indexOf('messages') !== -1 ||
                perms.indexOf('mc_settings') !== -1;
        }

        function isLoginScreen()
        {
            var name = ($state.current && $state.current.name) || '';

            return !name || name.indexOf('pages_auth') !== -1;
        }

        /**
         * Prompt is allowed on any authenticated app screen (not login/auth).
         * Treated as a main-app browser notification permission, not route-scoped.
         */
        function isAppPromptRoute()
        {
            return !isLoginScreen();
        }

        function hidePrompt()
        {
            if (!prompting && !promptNode) {
                return;
            }

            removePromptNode();
            prompting = false;
        }

        function emptyData()
        {
            return {
                prefs: {}
            };
        }

        function readData()
        {
            var stored = storageService.getStorage(STORAGE_SECTION, DATA_KEY);

            if (!stored || typeof stored !== 'object') {
                return emptyData();
            }

            return {
                prefs: stored.prefs && typeof stored.prefs === 'object' ? stored.prefs : {}
            };
        }

        function writeData(data)
        {
            storageService.updateStorage(STORAGE_SECTION, DATA_KEY, {
                prefs: (data && data.prefs) || {}
            });
        }

        function ensureBroadcast()
        {
            if (broadcastChannel || typeof $window.BroadcastChannel !== 'function') {
                return;
            }

            try {
                broadcastChannel = new $window.BroadcastChannel(BROADCAST_CHANNEL_NAME);
                broadcastChannel.onmessage = onBroadcastMessage;
            }
            catch (e) {
                broadcastChannel = null;
            }
        }

        function closeBroadcast()
        {
            if (!broadcastChannel) {
                return;
            }

            try {
                broadcastChannel.close();
            }
            catch (e) {
                // Ignore close failures.
            }

            broadcastChannel = null;
        }

        function postBroadcast(message)
        {
            ensureBroadcast();

            if (!broadcastChannel) {
                return;
            }

            try {
                broadcastChannel.postMessage(message);
            }
            catch (e) {
                // Ignore post failures.
            }
        }

        function onBroadcastMessage(event)
        {
            var message = event && event.data;

            if (!message || !message.type) {
                return;
            }

            if (message.type === 'notification-claim' && message.sig) {
                lastNotificationClaim = {
                    sig: String(message.sig),
                    at: parseInt(message.at, 10) || Date.now()
                };
                return;
            }

            if (message.type === 'prompt-claim') {
                lastPromptClaimAt = parseInt(message.at, 10) || Date.now();
                return;
            }

            if (message.type === 'prompt-clear') {
                lastPromptClaimAt = 0;
            }
        }

        function clearPromptClaim()
        {
            lastPromptClaimAt = 0;
            postBroadcast({ type: 'prompt-clear' });
        }

        function emptyPref()
        {
            return {
                enabled: '0',
                choice: ''
            };
        }

        function readUserPref()
        {
            var stored = readData().prefs[userId()];

            if (stored === '1') {
                return {
                    enabled: '1',
                    choice: 'enabled'
                };
            }

            if (stored === '0') {
                return emptyPref();
            }

            if (!stored || typeof stored !== 'object') {
                return emptyPref();
            }

            return {
                enabled: stored.enabled === '1' ? '1' : '0',
                choice: stored.choice || ''
            };
        }

        function writeUserPref(pref)
        {
            var data = readData();

            data.prefs[userId()] = {
                enabled: pref.enabled === '1' ? '1' : '0',
                choice: pref.choice || ''
            };
            writeData(data);
        }

        function userOptedIn()
        {
            return readUserPref().enabled === '1' && permission() === 'granted';
        }

        function sessionDismissKey()
        {
            return SESSION_DISMISS_KEY + ':' + userId();
        }

        function markSessionDismissed()
        {
            try {
                $window.sessionStorage.setItem(sessionDismissKey(), '1');
            }
            catch (e) {
                // Ignore sessionStorage failures (private mode, etc.).
            }
        }

        function clearSessionDismissed()
        {
            try {
                $window.sessionStorage.removeItem(sessionDismissKey());
            }
            catch (e) {
                // Ignore sessionStorage failures (private mode, etc.).
            }
        }

        function isSessionDismissed()
        {
            try {
                return $window.sessionStorage.getItem(sessionDismissKey()) === '1';
            }
            catch (e) {
                return false;
            }
        }

        /**
         * Hide the prompt for the rest of this login session ("Not now" / blocked).
         * Cleared on logout so the next login can prompt again.
         */
        function snooze(choice)
        {
            var pref = readUserPref();

            markSessionDismissed();
            writeUserPref({
                enabled: '0',
                choice: choice || pref.choice || 'dismissed'
            });
        }

        function clearSnooze()
        {
            clearSessionDismissed();
        }

        function markEnabled()
        {
            clearSessionDismissed();
            writeUserPref({
                enabled: '1',
                choice: 'enabled'
            });
        }

        function markBlocked()
        {
            markSessionDismissed();
            writeUserPref({
                enabled: '0',
                choice: 'blocked'
            });
        }

        function isSnoozed()
        {
            return isSessionDismissed();
        }

        function applyHotelSettings(settings)
        {
            if (!settings) {
                return hotelEnabled;
            }

            hotelEnabled = isFlag(settings.browser_notifications_enabled);
            hotelLoaded = true;
            hotelLoadedAt = Date.now();
            loadedHotelId = currentHotelId();

            return hotelEnabled;
        }

        /**
         * Hotel flag comes from Message Center settings. Notifications stay off
         * until that API says this hotel has browser notifications enabled.
         */
        function ensureHotelSetting(force)
        {
            var hotelId = currentHotelId();
            var fresh = hotelLoaded &&
                hotelId === loadedHotelId &&
                (Date.now() - hotelLoadedAt) < SETTINGS_TTL_MS;

            if (!force && fresh) {
                return $q.resolve(hotelEnabled);
            }

            if (settingsRequest) {
                return settingsRequest;
            }

            settingsRequest = messageCenterService.getSettings({}, { force: true }).then(function (response) {
                settingsRequest = null;

                if (!response || response.success === false || !response.settings) {
                    return hotelEnabled;
                }

                return applyHotelSettings(response.settings);
            }, function () {
                settingsRequest = null;
                return hotelEnabled;
            });

            return settingsRequest;
        }

        function requestPermission()
        {
            var deferred = $q.defer();
            var settled = false;
            var result;

            function finish(status)
            {
                if (settled) {
                    return;
                }

                settled = true;
                deferred.resolve(status || permission());
            }

            try {
                result = $window.Notification.requestPermission(finish);
            } catch (e) {
                finish('denied');
                return deferred.promise;
            }

            if (result && typeof result.then === 'function') {
                result.then(finish, function () {
                    finish(permission());
                });
            }

            return deferred.promise;
        }

        function iconUrl()
        {
            var href = String($window.location.href || '').split('#')[0].split('?')[0];
            var slash = href.lastIndexOf('/');

            if (slash === -1) {
                return 'assets/lslogos/ios-icon/48.png';
            }

            return href.substring(0, slash + 1) + 'assets/lslogos/ios-icon/48.png';
        }

        function createNotification(options, payload)
        {
            var notification;

            try {
                notification = new $window.Notification(options.title, {
                    body: options.body,
                    icon: iconUrl(),
                    tag: options.tag,
                    renotify: true
                });
            } catch (e) {
                return;
            }

            notification.onclick = function () {
                try {
                    $window.focus();
                } catch (focusError) {
                    // The browser may block focus until the user clicks the notification.
                }

                notification.close();

                if (!payload) {
                    return;
                }

                $rootScope.$applyAsync(function () {
                    openConversation(payload);
                });
            };
        }

        function showEnabledNotice()
        {
            createNotification({
                title: 'Browser notifications on',
                body: 'You will be notified when new messages receive.',
                tag: 'mc-browser-notifications-on'
            }, null);
        }

        function removePromptNode()
        {
            if (promptNode && promptNode.parentNode) {
                promptNode.parentNode.removeChild(promptNode);
            }

            promptNode = null;
        }

        function showPromptCard(options)
        {
            var root = $window.document.createElement('div');
            var icon = $window.document.createElement('div');
            var main = $window.document.createElement('div');
            var title = $window.document.createElement('div');
            var actions = $window.document.createElement('div');
            var close = $window.document.createElement('button');
            var toast = $window.document.querySelector('.gmc-inbox-toast');
            var list;
            var item;
            var later;
            var go;
            var i;

            removePromptNode();
            prompting = true;

            root.className = 'mc-bn-prompt';
            root.setAttribute('role', 'dialog');
            root.setAttribute('aria-label', options.title);

            icon.className = 'mc-bn-prompt-icon';
            icon.innerHTML = '<span class="icon-bell-ring"></span>';

            main.className = 'mc-bn-prompt-main';
            title.className = 'mc-bn-prompt-title';
            title.textContent = options.title;
            main.appendChild(title);

            if (options.body) {
                var body = $window.document.createElement('p');

                body.className = 'mc-bn-prompt-text';
                body.textContent = options.body;
                main.appendChild(body);
            }

            if (options.steps && options.steps.length) {
                list = $window.document.createElement('ol');
                list.className = 'mc-bn-prompt-steps';

                for (i = 0; i < options.steps.length; i++) {
                    item = $window.document.createElement('li');
                    item.textContent = options.steps[i];
                    list.appendChild(item);
                }

                main.appendChild(list);
            }

            actions.className = 'mc-bn-prompt-actions';

            if (options.secondaryLabel) {
                later = $window.document.createElement('button');
                later.type = 'button';
                later.className = 'mc-bn-prompt-later';
                later.textContent = options.secondaryLabel;
                later.addEventListener('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    options.onSecondary();
                });
                actions.appendChild(later);
            }

            if (options.primaryLabel) {
                go = $window.document.createElement('button');
                go.type = 'button';
                go.className = 'mc-bn-prompt-go';
                go.textContent = options.primaryLabel;
                go.addEventListener('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    options.onPrimary();
                });
                actions.appendChild(go);
            }

            main.appendChild(actions);

            close.type = 'button';
            close.className = 'mc-bn-prompt-close';
            close.setAttribute('aria-label', 'Dismiss');
            close.innerHTML = '<span class="icon-close"></span>';
            close.addEventListener('click', function (event) {
                event.preventDefault();
                event.stopPropagation();

                if (options.onSecondary) {
                    options.onSecondary();
                    return;
                }

                options.onPrimary();
            });

            root.appendChild(icon);
            root.appendChild(main);
            root.appendChild(close);

            if (toast) {
                root.style.top = (toast.getBoundingClientRect().bottom + 10) + 'px';
            }

            $window.document.body.appendChild(root);
            promptNode = root;
        }

        function dismissPrompt(choice)
        {
            removePromptNode();
            prompting = false;
            snooze(choice);
        }

        function claimPromptSlot()
        {
            var now = Date.now();

            if (lastPromptClaimAt && (now - lastPromptClaimAt) < PROMPT_CLAIM_MS) {
                return false;
            }

            lastPromptClaimAt = now;
            postBroadcast({ type: 'prompt-claim', at: now });
            return true;
        }

        function markPromptClaim()
        {
            var now = Date.now();

            lastPromptClaimAt = now;
            postBroadcast({ type: 'prompt-claim', at: now });
        }

        function showOptInPrompt(force)
        {
            if (prompting || (!force && !claimPromptSlot())) {
                return;
            }

            if (force) {
                markPromptClaim();
            }

            showPromptCard({
                title: 'Enable Notifications',
                body: 'Stay updated on new messages by enabling browser notifications.',
                primaryLabel: 'Turn on',
                secondaryLabel: 'Not now',
                onPrimary: function () {
                    removePromptNode();
                    prompting = false;
                    enableFromPrompt();
                },
                onSecondary: function () {
                    dismissPrompt('dismissed');
                }
            });
        }

        function showDisabledPrompt(force)
        {
            if (prompting || (!force && !claimPromptSlot())) {
                return;
            }

            if (force) {
                markPromptClaim();
            }

            showPromptCard({
                title: 'Notifications are off',
                body: 'This browser is blocking message alerts. Turn them back on so you do not miss a message.',
                primaryLabel: 'Turn on',
                secondaryLabel: 'Not now',
                onPrimary: function () {
                    removePromptNode();
                    prompting = false;

                    if (permission() === 'denied') {
                        showUnblockSteps();
                        return;
                    }

                    if (permission() === 'granted') {
                        markEnabled();
                        showEnabledNotice();
                        return;
                    }

                    enableFromPrompt();
                },
                onSecondary: function () {
                    dismissPrompt('blocked');
                }
            });
        }

        function showUnblockSteps()
        {
            showPromptCard({
                title: 'Allow notifications',
                body: 'Notifications are currently blocked. Follow these steps to allow notifications and receive new message alerts.',
                steps: [
                    'Click the site settings icon next to the address bar.',
                    'Find Notifications and change it to Allow.',
                    'If blocked, reset the site permissions and reload the page.',
                    'Return here and click Turn on.'
                ],
                primaryLabel: 'Got it',
                onPrimary: function () {
                    removePromptNode();
                    prompting = false;
                    snooze('blocked');
                }
            });
        }

        function enableFromPrompt()
        {
            if (!isSupported()) {
                return;
            }

            requestPermission().then(function (status) {
                if (status === 'granted') {
                    markEnabled();
                    showEnabledNotice();
                    return;
                }

                if (status === 'denied') {
                    markBlocked();
                }
            });
        }

        /**
         * If the user was marked blocked, but later unblocked (or granted)
         * permission in the browser, clear that so we can offer Turn on again
         * — or silently enable when already granted.
         */
        function recoverFromBrowserUnblock(pref, perm)
        {
            if (pref.choice !== 'blocked') {
                return false;
            }

            if (perm === 'granted') {
                markEnabled();
                return true;
            }

            if (perm === 'default') {
                clearSessionDismissed();
                writeUserPref({
                    enabled: '0',
                    choice: ''
                });
                return true;
            }

            return false;
        }

        /**
         * Show the opt-in / blocked prompt anywhere in the authenticated app
         * when the hotel has browser notifications enabled and the browser
         * has not granted permission yet.
         *
         * options.force — bypass this-login dismiss (used after hotel toggle
         * off → on is saved).
         */
        function maybePrompt(options)
        {
            var force = !!(options && options.force);
            var perm;
            var pref;

            if (!isAppPromptRoute()) {
                hidePrompt();
                return;
            }

            if (!started || prompting || !hotelEnabled || !hotelLoaded || !isSupported() || !hasPermission()) {
                return;
            }

            perm = permission();
            pref = readUserPref();

            if (perm === 'granted') {
                if (pref.enabled !== '1' || pref.choice === 'blocked') {
                    markEnabled();
                }
                return;
            }

            // Blocked earlier, then unblocked in browser settings → allow
            // the opt-in card again even if dismissed this login.
            if (recoverFromBrowserUnblock(pref, perm)) {
                pref = readUserPref();
            }

            if (force) {
                clearSnooze();
                clearPromptClaim();
            } else if (isSnoozed()) {
                return;
            }

            // Still denied: after dismiss (or hotel re-enable), guide unblock.
            if (perm === 'denied') {
                if (force) {
                    showDisabledPrompt(true);
                    return;
                }

                showUnblockSteps();
                return;
            }

            showOptInPrompt(force);
        }

        function considerPrompt(force)
        {
            ensureHotelSetting(false).then(function () {
                $timeout(function () {
                    maybePrompt(force ? { force: true } : undefined);
                }, force ? 400 : 600);
            });
        }

        function previewText(payload)
        {
            var text = (payload && payload.preview) || 'New message received';

            if (text.length > 180) {
                return text.substring(0, 177) + '...';
            }

            return text;
        }

        function signature(payload)
        {
            return [
                (payload && payload.type) || 'message',
                (payload && payload.confirmation_number) || '',
                (payload && payload.conversation_sid) || '',
                (payload && payload.message_thread_id) || '',
                (payload && payload.preview) || ''
            ].join('|');
        }

        function claim(sig)
        {
            var now = Date.now();

            if (lastNotificationClaim.sig === sig &&
                lastNotificationClaim.at &&
                (now - lastNotificationClaim.at) < NOTIFICATION_CLAIM_MS) {
                return false;
            }

            lastNotificationClaim = { sig: sig, at: now };
            postBroadcast({
                type: 'notification-claim',
                sig: sig,
                at: now
            });
            return true;
        }

        function openConversation(payload)
        {
            var params = {
                confirmation_number: payload.confirmation_number || '',
                conversation_sid: payload.conversation_sid || '',
                message_thread_id: payload.message_thread_id || ''
            };
            var targetState = payload.is_staff
                ? 'app.guest-message-center.staff-messages'
                : 'app.guest-message-center.messages';

            $state.go(targetState, {
                confirmation_number: params.confirmation_number || null
            }).then(function () {
                $rootScope.$broadcast('messageCenter:openConversation', params);
            }, function () {
                $rootScope.$broadcast('messageCenter:openConversation', params);
            });
        }

        function showIncoming(payload)
        {
            var title;
            var body;
            var who;
            var sig;

            sig = signature(payload);

            if (!claim(sig)) {
                return;
            }

            who = (payload.guest_name || payload.title || '').trim();
            title = payload.heading || 'New message';

            if (who) {
                title += ' · ' + who;
            }

            createNotification({
                title: title,
                body: previewText(payload),
                tag: 'mc-' + (payload.confirmation_number || payload.conversation_sid || payload.message_thread_id || 'msg')
            }, payload);
        }

        function onInboxToast(event, payload)
        {
            if (!payload || !$window.document.hidden || !isSupported() || !hasPermission()) {
                return;
            }

            ensureHotelSetting(false).then(function (allowed) {
                if (!allowed || !userOptedIn()) {
                    return;
                }

                showIncoming(payload);
            });
        }

        function onVisibilityChange()
        {
            if ($window.document.hidden) {
                return;
            }

            // Returning from browser settings after Allow / Reset permission.
            $rootScope.$applyAsync(function () {
                maybePrompt();
            });
        }

        function init()
        {
            if (started || !$localStorage.authToken) {
                return;
            }

            started = true;
            ensureBroadcast();
            removeToastListener = $rootScope.$on('messageCenter:inboxToast', onInboxToast);
            $window.document.addEventListener('visibilitychange', onVisibilityChange);
            removeVisibilityListener = function () {
                $window.document.removeEventListener('visibilitychange', onVisibilityChange);
            };

            ensureHotelSetting(true).then(function () {
                $timeout(maybePrompt, 800);
            });
        }

        function destroy()
        {
            started = false;
            prompting = false;
            hotelEnabled = false;
            hotelLoaded = false;
            hotelLoadedAt = 0;
            loadedHotelId = null;
            lastNotificationClaim = { sig: '', at: 0 };
            lastPromptClaimAt = 0;
            // Next login should show the permission prompt again.
            clearSessionDismissed();
            closeBroadcast();

            if (removeToastListener) {
                removeToastListener();
                removeToastListener = null;
            }

            if (removeVisibilityListener) {
                removeVisibilityListener();
                removeVisibilityListener = null;
            }

            removePromptNode();
        }

        removeLoginListener = $rootScope.$on('app:loggedIn', function () {
            init();
        });

        removeStateListener = $rootScope.$on('$stateChangeSuccess', function () {
            if (!started) {
                return;
            }

            if (!isAppPromptRoute()) {
                hidePrompt();
                return;
            }

            var hotelId = currentHotelId();

            if (hotelId && hotelId !== loadedHotelId) {
                ensureHotelSetting(true).then(function () {
                    $timeout(maybePrompt, 600);
                });
                return;
            }

            considerPrompt(false);
        });

        removeSettingsListener = $rootScope.$on('messageCenter:settingsSaved', function (event, payload) {
            var settings;
            var wasEnabled;
            var nowEnabled;

            // Support both the new payload shape and a bare settings object.
            if (payload && payload.settings) {
                settings = payload.settings;
                wasEnabled = !!payload.previousBrowserNotificationsEnabled;
                nowEnabled = typeof payload.browserNotificationsEnabled === 'boolean'
                    ? payload.browserNotificationsEnabled
                    : isFlag(settings.browser_notifications_enabled);
            } else {
                settings = payload || {};
                wasEnabled = hotelEnabled;
                nowEnabled = isFlag(settings.browser_notifications_enabled);
            }

            applyHotelSettings(angular.extend({}, settings, {
                browser_notifications_enabled: nowEnabled ? '1' : '0'
            }));

            if (!nowEnabled) {
                hidePrompt();
                return;
            }

            // Hotel toggle off → on (saved): clear this-login dismiss and show
            // again even if the user said "Not now" earlier.
            if (!wasEnabled && permission() !== 'granted') {
                considerPrompt(true);
                return;
            }

            considerPrompt(false);
        });

        return {
            init: init,
            destroy: destroy,
            isSupported: isSupported,
            permission: permission
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .controller('InboxMessageCenterController', InboxMessageCenterController);

    /**
     * Unified Message Center controller.
     *
     * OTA (Channex) and Direct (Twilio SMS/WhatsApp) conversations for the SAME
     * reservation (matched by confirmation_number) are merged into ONE thread
     * "group". Each group holds an optional `_ota` sub-thread and an optional
     * `_direct` sub-thread. Messages from both providers are interleaved by
     * timestamp in a single chat panel, and replies are routed to whichever
     * channel of the latest message (guest or hotel).
     *
     * Threads without a confirmation_number (OTA inquiries, unmapped SMS) stay
     * standalone single-provider groups.
     *
     * @ngInject
     */
    function InboxMessageCenterController(
        $rootScope,
        $scope,
        $state,
        $stateParams,
        $q,
        $timeout,
        $interval,
        $document,
        $localStorage,
        $mdDialog,
        toastMessage,
        messageCenterService,
        messageCenterComposerSignature,
        eCommerceService,
        otaMessageCenterPubNubService,
        smsMessageCenterPubNubService,
        messageCenterNavBadgeService,
        phoneFormatService
    )
    {
        var vm = this;
        var FALLBACK_POLL_INTERVAL_MS = 60000;
        var fallbackPollTimer = null;
        var pollThreadsInFlight = false;
        var pollMessagesInFlight = false;
        var pendingMessagesRefresh = false;
        var visibilityChangeHandler = null;
        var pubNubConnected = true;
        var removePubNubListener = null;
        var removeSmsPubNubListener = null;
        var pendingConversationSid = '';
        var pendingConfirmation = $stateParams.confirmation_number || '';
        var pendingDeepLinkFetch = '';
        var useUnifiedApi = true;
        var searchDebounce = null;
        // In-memory only: per-thread composer drafts (text + image). Cleared on refresh.
        var composerDrafts = {};

        vm._keptInUnreadKeys = {};

        vm.isArchiveView = !!(
            $state.current &&
            $state.current.data &&
            $state.current.data.isArchiveView
        );
        vm.activeTab = resolveInitialTab();
        vm.threads = [];
        vm._allUnifiedThreads = [];
        vm.otaThreads = [];
        vm.smsThreads = [];
        vm.messages = [];
        vm.selectedThread = null;
        vm.selectedKey = '';
        vm.subHotelId = '';
        vm.subHotels = $rootScope.subHotels || [];
        // Archive view always lists archived chats; inbox keeps the chip filter.
        vm.threadFilter = vm.isArchiveView ? 'archived' : messageCenterService.getThreadFilter();
        if (vm.threadFilter === 'archived' && !vm.isArchiveView) {
            vm.threadFilter = 'all';
            messageCenterService.setThreadFilter('all');
        }
        vm.isParent = false;
        vm.loadingThreads = false;
        vm.updatingArchive = false;
        vm.updatingAcknowledge = false;
        vm.loadingMessages = false;
        vm.sendingMessage = false;
        vm.replyText = '';
        vm.pendingMedia = null;
        vm.uploadingMedia = false;
        vm.composerDragOver = false;
        vm.composerChannel = 'sms';
        vm.channelOptions = [];
        vm.threadLimit = 20;
        vm.threadPage = 1;
        vm.threadTotal = 0;
        vm.otaPage = 1;
        vm.otaTotal = 0;
        vm.smsPage = 1;
        vm.smsHasMore = false;
        vm.otaEnabled = false;
        vm.smsEnabled = false;
        vm.whatsappEnabled = false;
        vm.unrepliedAlertEnabled = false;
        vm.channelFlagsReady = false;
        vm.messageLimit = 50;
        vm.msgPage = 1;
        vm.msgTotal = 0;
        // Per-provider message pagination for the open group (legacy fallback).
        vm.msgOta = { page: 1, total: 0 };
        vm.msgDirect = { page: 1, hasMore: false };
        vm.threadErrors = [];
        vm.messageStayDates = null;
        vm.reservationStayDates = null;
        vm.showLoadEarlier = false;
        vm.searchQuery = '';
        vm.editingPhone = false;
        vm.phoneEditValue = '';
        vm.savingPhone = false;
        vm.updatingOptOut = false;
        vm.updatingAiMode = false;
        vm.highlightAiToggle = false;
        vm.localStorageUnavailable = false;
        vm.chatTimezone = '';
        vm.phoneOptions = { customer: '', traveler: '' };
        vm.sendToSource = '';
        vm.sendToCustomPhone = '';
        vm.phoneConflictMessage = '';
        vm.quickReplyOpen = false;
        vm.quickReplyLoading = false;
        vm.quickReplySearch = '';
        vm.quickReplyCategories = [];
        vm.quickReplyFiltered = [];

        vm.promoteReplyOpen = false;
        vm.promoteReplyLoading = false;
        vm.promoteReplySearch = '';
        vm.promoteReplyCategories = [];
        vm.promoteReplyFiltered = [];

        vm.translateLanguages = [];
        vm.translateLanguagesLoaded = false;
        vm.translateLanguagesLoading = false;
        vm.translateLangSearchText = '';
        vm.composerTranslateOpen = false;
        vm.composerTranslateLang = 'en';
        vm.composerTranslating = false;
        vm.replyTranslation = null;

        var messagesScrollHandler = null;
        var threadsScrollHandler = null;
        var quickReplyDocClickHandler = null;
        var quickReplyCache = null;

        var promoteReplyDocClickHandler = null;
        var promoteReplyCache = null;
        var translateDocClickHandler = null;
        var translatePopupMessage = null;
        var channelFlagsFromSettings = false;
        var REPLY_TEXTAREA_ID = 'gmc-reply-textarea';
        var REPLY_MAX_LINES = 5;
        var THREAD_SCROLL_LOAD_PX = 120;

        vm.canViewOta = hasOtaPermission('getMessageThreads');
        vm.canViewDirect = hasDirectPermission();
        vm.canGetThreads = vm.canViewOta || vm.canViewDirect;
        vm.canGetMessages = hasOtaPermission('getThreadMessages') || vm.canViewDirect;
        vm.canSendOta = hasOtaPermission('sendThreadMessage');
        vm.canSendDirect = hasDirectPermission();
        vm.canSendMessage = vm.canSendOta || vm.canSendDirect;
        vm.channelFlagsReady = false;

        vm.setTab = setTab;
        vm.showTabs = showTabs;
        vm.showNewConversation = showNewConversation;
        vm.showDirectFeatures = showDirectFeatures;
        vm.showOtaFeatures = showOtaFeatures;
        vm.hasAnyChannelEnabled = hasAnyChannelEnabled;
        vm.showGroupMessageTab = showGroupMessageTab;
        vm.loadThreads = loadThreads;
        vm.selectThread = selectThread;
        vm.sendReply = sendReply;
        vm.toggleComposerTranslate = toggleComposerTranslate;
        vm.translateComposerDraft = translateComposerDraft;
        vm.clearReplyTranslation = clearReplyTranslation;
        vm.getLanguageName = getLanguageName;
        vm.filterTranslateLanguages = filterTranslateLanguages;
        vm.clearTranslateLangSearch = clearTranslateLangSearch;
        vm.canTranslateMessage = canTranslateMessage;
        vm.toggleMessageTranslatePanel = toggleMessageTranslatePanel;
        vm.translateMessageBubble = translateMessageBubble;
        vm.toggleMessageOriginal = toggleMessageOriginal;
        vm.getDetectedLanguageLabel = getDetectedLanguageLabel;
        vm.getTranslationBadgeLabel = getTranslationBadgeLabel;
        vm.getMessageLanguageTag = getMessageLanguageTag;
        vm.getSentTranslationLanguageLabel = getSentTranslationLanguageLabel;
        vm.canSendToSelected = canSendToSelected;
        vm.hasSendableContent = hasSendableContent;
        vm.canAttachImage = canAttachImage;
        vm.openImagePicker = openImagePicker;
        vm.clearPendingMedia = clearPendingMedia;
        vm.onComposerDrop = onComposerDrop;
        vm.onImageSelected = onImageSelected;
        vm.getComposerBlockedMessage = getComposerBlockedMessage;
        vm.getActiveSendChannelLabel = getActiveSendChannelLabel;
        vm.onReplyKeydown = onReplyKeydown;
        vm.onReplyFocus = onReplyFocus;
        vm.onReplyTextChange = onReplyTextChange;
        vm.hasComposerBodyForTranslate = hasComposerBodyForTranslate;
        vm.resizeReplyTextarea = resizeReplyTextarea;
        vm.onSubHotelChange = onSubHotelChange;
        vm.setThreadFilter = setThreadFilter;
        vm.getUnreadTotal = messageCenterNavBadgeService.getUnreadTotal;
        vm.getGuestUnreadTotal = messageCenterNavBadgeService.getGuestUnreadTotal;
        vm.getStaffUnreadTotal = messageCenterNavBadgeService.getStaffUnreadTotal;
        vm.loadMoreThreads = loadMoreThreads;
        vm.hasMoreThreads = hasMoreThreads;
        vm.loadMoreMessages = loadMoreMessages;
        vm.getProviderLabel = getProviderLabel;
        vm.getThreadChips = getThreadChips;
        vm.getThreadSourceChip = getThreadSourceChip;
        vm.getThreadTitle = getThreadTitle;
        vm.getThreadSubtitle = getThreadSubtitle;
        vm.getThreadPhone = getThreadPhone;
        vm.formatPhoneNumber = formatPhoneNumber;
        vm.getThreadActivity = getThreadActivity;
        vm.isMergedThread = isMergedThread;
        vm.showMessageChannel = showMessageChannel;
        vm.getMessageChannelLabel = getMessageChannelLabel;
        vm.getMessageChannelClass = getMessageChannelClass;
        vm.formatDate = formatDate;
        vm.formatShortDate = formatShortDate;
        vm.getInquiryDetails = getInquiryDetails;
        vm.getThreadCheckIn = getThreadCheckIn;
        vm.getThreadCheckOut = getThreadCheckOut;
        vm.getDisplayCheckIn = getDisplayCheckIn;
        vm.getDisplayCheckOut = getDisplayCheckOut;
        vm.hasStayDates = hasStayDates;
        vm.formatStayDate = formatStayDate;
        vm.formatStayDateRange = formatStayDateRange;
        vm.hasFormattedStayDate = hasFormattedStayDate;
        vm.hasHeaderStayInfo = hasHeaderStayInfo;
        vm.getStayStatus = getStayStatus;
        vm.getStayStatusLabel = getStayStatusLabel;
        vm.getStayStatusClass = getStayStatusClass;
        vm.openReservation = openReservation;
        vm.hasUnread = hasUnread;
        vm.getUnreadLabel = getUnreadLabel;
        vm.showThreadUnreadBadge = showThreadUnreadBadge;
        vm.getMessageText = getMessageText;
        vm.hasMessageMedia = hasMessageMedia;
        vm.getMessageMediaItems = getMessageMediaItems;
        vm.expandMessageMedia = expandMessageMedia;
        vm.retryMessageMedia = expandMessageMedia;
        vm.openMessageMedia = openMessageMedia;
        vm.openPendingMedia = openPendingMedia;
        vm.isPhoneChangeNotice = isPhoneChangeNotice;
        vm.getPhoneChangeNoticeText = getPhoneChangeNoticeText;
        vm.getLastMessageDirectionIcon = getLastMessageDirectionIcon;
        vm.isLastMessageMedia = isLastMessageMedia;
        vm.getThreadPreviewText = getThreadPreviewText;
        vm.getThreadKey = getThreadKey;
        vm.isThreadSelected = isThreadSelected;
        vm.getGuestInitial = getGuestInitial;
        vm.getAvatarStyle = getAvatarStyle;
        vm.getThreadHotelTitle = getThreadHotelTitle;
        vm.getProviderClass = getProviderClass;
        vm.hasMoreMessages = hasMoreMessages;
        vm.goBackToThreads = goBackToThreads;
        vm.openNewConversationDialog = openNewConversationDialog;
        vm.openGroupMessageLogs = openGroupMessageLogs;
        vm.goToStaffTab = goToStaffTab;
        vm.setComposerChannel = setComposerChannel;
        vm.isChannelEnabled = isChannelEnabled;
        vm.getChannelOptions = getChannelOptions;
        vm.startChannelConversation = startChannelConversation;
        vm.beginPhoneEdit = beginPhoneEdit;
        vm.cancelPhoneEdit = cancelPhoneEdit;
        vm.saveGuestPhone = saveGuestPhone;
        vm.updatePhoneWithCountryCode = updatePhoneWithCountryCode;
        vm.isPhoneEditValid = isPhoneEditValid;
        vm.isCustomSendToPhoneValid = isCustomSendToPhoneValid;
        vm.toggleMessagingOptOut = toggleMessagingOptOut;
        vm.toggleThreadArchived = toggleThreadArchived;
        vm.isThreadArchived = isThreadArchived;
        vm.acknowledgeThread = acknowledgeThread;
        vm.canAcknowledgeThread = canAcknowledgeThread;
        vm.isOptedOut = isOptedOut;
        vm.getOptOutBannerText = getOptOutBannerText;
        vm.isAiModeOn = isAiModeOn;
        vm.toggleAiMode = toggleAiMode;
        vm.isSupportEscalation = isSupportEscalation;
        vm.isEscalationUnread = isEscalationUnread;
        vm.getRoomLabel = getRoomLabel;
        vm.onSearchChange = onSearchChange;
        vm.clearSearch = clearSearch;
        vm.needsDirectChannelStart = needsDirectChannelStart;
        vm.needsPhonePicker = needsPhonePicker;
        vm.setSendToSource = setSendToSource;
        vm.getSelectedStartPhone = getSelectedStartPhone;
        vm.toggleQuickReplyPicker = toggleQuickReplyPicker;
        vm.filterQuickReplies = filterQuickReplies;
        vm.applyQuickReply = applyQuickReply;
        vm.closeQuickReplyPicker = closeQuickReplyPicker;

        vm.togglePromoteReplyPicker = togglePromoteReplyPicker;
        vm.filterPromoteReplies = filterPromoteReplies;
        vm.applyPromoteReply = applyPromoteReply;
        vm.closePromoteReplyPicker = closePromoteReplyPicker;

        init();
        startRealtime();

        $scope.$on('messageCenter:openConversation', function (event, params) {
            openConversationFromNav(params || {});
        });

        $scope.$on('$destroy', onDestroy);

        function goToStaffTab()
        {
            if (vm.isArchiveView) {
                return;
            }

            $state.go('app.guest-message-center.staff-messages', {
                confirmation_number: null
            });
        }

        function resolveInitialTab()
        {
            // Archive never opens Group message mode.
            if (vm.isArchiveView) {
                return 'all';
            }

            if ($state.current && $state.current.data && $state.current.data.initialTab) {
                var initial = $state.current.data.initialTab;

                if (initial === 'group_msg' || initial === 'in_house') {
                    return 'group_msg';
                }
            }

            return 'all';
        }

        function init()
        {
            phoneFormatService.ensureUtilsLoaded();

            if ($rootScope.isParent && $rootScope.subHotels && $rootScope.subHotels.length) {
                vm.subHotels = $rootScope.subHotels;
            } else if ($localStorage.hotels && $localStorage.selectedHotel !== undefined) {
                var hotelId = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
                $rootScope.getSubHotels(hotelId, true);
                $scope.$watch(function () {
                    return $rootScope.subHotelsOfSelected;
                }, function (subHotels) {
                    if (subHotels && subHotels.length) {
                        vm.subHotels = subHotels;
                    }
                });
            }

            normalizeActiveTab();
            loadChannelEnabledFlags();
            loadTranslateLanguages();
            bindThreadsScroll();
        }

        function isEnabledFlag(value)
        {
            return value === true || value === 1 || value === '1';
        }

        function applyChannelEnabledFlags(source)
        {
            var settings;
            var changed = false;
            var fromSettings = false;

            if (!source) {
                return false;
            }

            // Prefer settings payload keys, then flat API flags.
            settings = source.settings || source;
            fromSettings = settings.ota_messaging_enabled !== undefined ||
                settings.sms_messaging_enabled !== undefined ||
                settings.whatsapp_messaging_enabled !== undefined;

            if (fromSettings) {
                if (settings.ota_messaging_enabled !== undefined) {
                    vm.otaEnabled = isEnabledFlag(settings.ota_messaging_enabled);
                    changed = true;
                }

                if (settings.sms_messaging_enabled !== undefined) {
                    vm.smsEnabled = isEnabledFlag(settings.sms_messaging_enabled);
                    changed = true;
                }

                if (settings.whatsapp_messaging_enabled !== undefined) {
                    vm.whatsappEnabled = isEnabledFlag(settings.whatsapp_messaging_enabled);
                    changed = true;
                }

                channelFlagsFromSettings = true;
                return changed;
            }

            // Legacy thread/unread payloads only until settings are loaded.
            if (channelFlagsFromSettings) {
                return false;
            }

            if (source.ota_enabled !== undefined) {
                vm.otaEnabled = !!source.ota_enabled;
                changed = true;
            } else if (source.data && source.data.ota_enabled !== undefined) {
                vm.otaEnabled = !!source.data.ota_enabled;
                changed = true;
            }

            if (source.sms_enabled !== undefined) {
                vm.smsEnabled = !!source.sms_enabled;
                changed = true;
            } else if (source.data && source.data.sms_enabled !== undefined) {
                vm.smsEnabled = !!source.data.sms_enabled;
                changed = true;
            }

            if (source.whatsapp_enabled !== undefined) {
                vm.whatsappEnabled = !!source.whatsapp_enabled;
                changed = true;
            } else if (source.data && source.data.whatsapp_enabled !== undefined) {
                vm.whatsappEnabled = !!source.data.whatsapp_enabled;
                changed = true;
            }

            return changed;
        }

        function afterChannelFlagsChanged()
        {
            normalizeActiveTab();

            if (!hasAnyChannelEnabled()) {
                vm.threads = [];
                vm._allUnifiedThreads = [];
                clearChat();
                return;
            }

            if (useUnifiedApi) {
                applyUnifiedTabFilter();
                refreshChannelOptions();
                if (vm.selectedThread) {
                    setDefaultComposerChannel(vm.selectedThread);
                }
            } else {
                rebuildThreadList();
            }
        }

        function loadChannelEnabledFlags()
        {
            if (!vm.canGetThreads) {
                vm.channelFlagsReady = true;
                return;
            }

            messageCenterService.getSettings({}).then(function (response) {
                applyChannelEnabledFlags(response);
                applyUnrepliedAlertEnabled(response);
            }).finally(function () {
                vm.channelFlagsReady = true;
                afterChannelFlagsChanged();
                loadThreads();
            });
        }

        function applyUnrepliedAlertEnabled(source)
        {
            var settings = (source && source.settings) || source || {};
            vm.unrepliedAlertEnabled = isEnabledFlag(settings.unreplied_msg_alert_enabled);
        }

        function permsContains(key)
        {
            var perms = $rootScope.userPermissions || '';
            return !!perms && perms.indexOf(key) !== -1;
        }

        function hasOtaPermission(key)
        {
            return permsContains('All') ||
                permsContains('message_center') ||
                permsContains('ota') ||
                permsContains(key);
        }

        function hasDirectPermission()
        {
            return permsContains('All') ||
                permsContains('message_center') ||
                permsContains('direct');
        }

        function showDirectFeatures()
        {
            return vm.canViewDirect && (vm.smsEnabled || vm.whatsappEnabled);
        }

        function showOtaFeatures()
        {
            return vm.canViewOta && !!vm.otaEnabled;
        }

        function hasAnyChannelEnabled()
        {
            return showOtaFeatures() || showDirectFeatures();
        }

        function showGroupMessageTab()
        {
            if (vm.isArchiveView) {
                return false;
            }

            // Wait for settings so Group message doesn't flash then disappear.
            return !!vm.channelFlagsReady && showDirectFeatures();
        }

        function isDirectChannelConfigured(channel)
        {
            if (channel === 'sms') {
                return !!vm.smsEnabled;
            }

            if (channel === 'whatsapp') {
                return !!vm.whatsappEnabled;
            }

            return false;
        }

        function canFetchOta()
        {
            return showOtaFeatures();
        }

        function canFetchSms()
        {
            return showDirectFeatures();
        }

        function showTabs()
        {
            // Archive is a guest-only list: no Inbox / Group / Staff tabs.
            if (vm.isArchiveView) {
                return false;
            }

            return !!vm.canGetThreads && hasAnyChannelEnabled();
        }

        function showNewConversation()
        {
            return !vm.isArchiveView &&
                vm.activeTab !== 'group_msg' &&
                vm.channelFlagsReady &&
                vm.showDirectFeatures() &&
                vm.canSendDirect;
        }

        function normalizeActiveTab()
        {
            if (vm.activeTab === 'group_msg' && vm.channelFlagsReady && !showDirectFeatures()) {
                vm.activeTab = 'all';

                if ($state.current && $state.current.name === 'app.guest-message-center.group-messages') {
                    $state.go('app.guest-message-center.messages');
                }

                return;
            }

            if (vm.activeTab !== 'all' && vm.activeTab !== 'group_msg') {
                vm.activeTab = 'all';
            }
        }

        function setTab(tab)
        {
            if (vm.isArchiveView) {
                return;
            }

            if (tab === 'group_msg' && !showGroupMessageTab()) {
                tab = 'all';
            }

            if (tab !== 'all' && tab !== 'group_msg') {
                tab = 'all';
            }

            if (vm.activeTab === tab) {
                return;
            }

            vm.activeTab = tab;
            clearChat();

            if (tab === 'group_msg') {
                unbindThreadsScroll();
                if ($state.current.name !== 'app.guest-message-center.group-messages') {
                    $state.go('app.guest-message-center.group-messages');
                }
                return;
            }

            if ($state.current.name !== 'app.guest-message-center.messages') {
                $state.go('app.guest-message-center.messages');
                return;
            }

            vm.threadPage = 1;
            vm.otaPage = 1;
            vm.smsPage = 1;
            vm.threadTotal = 0;
            vm.otaTotal = 0;
            vm.smsHasMore = false;
            vm.threads = [];
            vm._allUnifiedThreads = [];
            vm.otaThreads = [];
            vm.smsThreads = [];
            loadThreads();
            bindThreadsScroll();
        }

		function applyUnifiedTabFilter()
        {
            var source = vm._allUnifiedThreads || [];
            var list = source.filter(threadMatchesTab);

            // Always re-apply in-house on the client: realtime upserts / promote-to-top
            // can insert non-checked-in threads after the server stay_filter response.
            // Escalated unread bypasses All / In House / Unread chips and stays pinned.
            if (vm.threadFilter === 'in_house') {
                list = list.filter(function(thread) {
                    return isEscalationUnread(thread) || isInHouseThread(thread);
                });
            } else if (vm.threadFilter === 'unread') {
                list = list.filter(function(thread) {
                    if (isEscalationUnread(thread)) {
                        return true;
                    }
                    var key = vm.getThreadKey(thread);
                    if (hasUnread(thread)) {
                        vm._keptInUnreadKeys[key] = true;
                    }
                    return vm._keptInUnreadKeys[key] || (vm.selectedThread && key === vm.getThreadKey(vm.selectedThread));
                });
            }

            list.sort(compareThreadsForInbox);

            vm.threads = list;
        }

        function compareThreadsForInbox(a, b)
        {
            var aEsc = isEscalationUnread(a) ? 1 : 0;
            var bEsc = isEscalationUnread(b) ? 1 : 0;
            if (aEsc !== bEsc) {
                return bEsc - aEsc;
            }
            return (b._activityTs || 0) - (a._activityTs || 0);
        }

        /**
         * Pending escalation until staff mark-as-read acknowledges it.
         * Guest messages after escalation do not clear this (server flag).
         */
        function isEscalationUnread(thread)
        {
            return !!(thread && thread.has_escalation_unread && hasUnread(thread));
        }

        /**
         * Alert-only while escalation is pending with no guest activity after it.
         * Badge + alert when guest also messaged after the pending escalation.
         * Badge-only for normal unread (no pending escalation).
         */
        function showThreadUnreadBadge(thread)
        {
            if (!hasUnread(thread)) {
                return false;
            }

            if (!isEscalationUnread(thread)) {
                return true;
            }

            return !!thread.has_guest_after_escalation;
        }

        /**
         * Move a reservation to the top of the inbox after start / send.
         */
        function promoteThreadToTop(thread)
        {
            if (!thread) {
                return;
            }

            var when = nowUtc();

            thread.last_message_at = when;
            thread._activityRaw = when;
            thread._activityTs = parseTs(when) || Date.now();

            if (useUnifiedApi) {
                upsertUnifiedThread(thread);
            } else {
                rebuildThreadList();
            }
        }

        function onSearchChange()
        {
            if (searchDebounce) {
                $timeout.cancel(searchDebounce);
            }

            searchDebounce = $timeout(function () {
                vm.threadPage = 1;
                loadThreads();
            }, 400);
        }

        function clearSearch()
        {
            if (searchDebounce) {
                $timeout.cancel(searchDebounce);
                searchDebounce = null;
            }

            if (!vm.searchQuery) {
                return;
            }

            vm.searchQuery = '';
            vm.threadPage = 1;
            loadThreads();
        }

        // ---------------------------------------------------------------------
        // Timestamp + message channel helpers
        // API contract: inserted_at / last_message_at are UTC.
        // FE converts UTC → current PC/browser timezone for display.
        // ---------------------------------------------------------------------

        function parseUtcMoment(value)
        {
            if (!value) {
                return null;
            }

            var parsed = moment.utc(value, [moment.ISO_8601, 'YYYY-MM-DD HH:mm:ss'], true);

            if (!parsed.isValid()) {
                parsed = moment.utc(value);
            }

            return parsed.isValid() ? parsed : null;
        }

        function parseTs(value)
        {
            var parsed = parseUtcMoment(value);
            return parsed ? parsed.valueOf() : 0;
        }

        /** Convert API UTC timestamp to the staff PC/browser local timezone. */
        function toLocalMoment(value)
        {
            var parsed = parseUtcMoment(value);
            return parsed ? parsed.clone().local() : null;
        }

        function nowUtc()
        {
            return moment.utc().format('YYYY-MM-DD HH:mm:ss');
        }

        /**
         * Tag messages with their channel, normalize SMS sender ('hotel' -> 'property'
         * so bubble alignment matches OTA), and add sort/dedupe helpers.
         * AI replies keep sender 'ai' for a distinct bubble.
         */
        function normalizeChannelMessages(list, channel)
        {
            list = list || [];

            for (var i = 0; i < list.length; i++) {
                var message = list[i];

                if (message.sender === 'hotel') {
                    message.sender = 'property';
                }

                message.channel = message.channel || channel;
                message._channel = message.channel || channel;
                message._sortTs = parseTs(message.inserted_at);
                message._uid = channel + ':' + (message.id || message.local_id || (message._sortTs + ':' + i));
            }

            return list;
        }

        function getUidMap(messages)
        {
            var map = {};
            var i;

            for (i = 0; i < (messages || []).length; i++) {
                if (messages[i]._uid) {
                    map[messages[i]._uid] = true;
                }
            }

            return map;
        }

        function findExistingMessageIndex(message)
        {
            if (!message) {
                return -1;
            }

            var id = message.id || message.local_id;
            var sid = message.message_sid || '';
            var i;

            if (id) {
                for (i = 0; i < vm.messages.length; i++) {
                    if (String(vm.messages[i].id || vm.messages[i].local_id || '') === String(id)) {
                        return i;
                    }
                    // Sent response may use Channex UUID as id before local id is known.
                    if (sid === '' && String(vm.messages[i].message_sid || '') === String(id)) {
                        return i;
                    }
                }
            }

            if (sid) {
                for (i = 0; i < vm.messages.length; i++) {
                    if (String(vm.messages[i].message_sid || '') === String(sid)) {
                        return i;
                    }
                    if (String(vm.messages[i].id || '') === String(sid)) {
                        return i;
                    }
                }
            }

            if (message._uid) {
                for (i = 0; i < vm.messages.length; i++) {
                    if (vm.messages[i]._uid === message._uid) {
                        return i;
                    }
                }
            }

            return -1;
        }

        function sortMessagesInPlace()
        {
            vm.messages.sort(function (a, b) {
                return (a._sortTs || 0) - (b._sortTs || 0);
            });
        }

        function addMessages(newMessages)
        {
            var existing = getUidMap(vm.messages);
            var added = [];
            var i;

            for (i = 0; i < (newMessages || []).length; i++) {
                var message = newMessages[i];

                if (!message || !message._uid) {
                    continue;
                }

                if (findExistingMessageIndex(message) !== -1 || existing[message._uid]) {
                    continue;
                }

                vm.messages.push(message);
                existing[message._uid] = true;
                added.push(message);
            }

            if (added.length) {
                sortMessagesInPlace();
                preloadVisibleMessageMedia(added);
            }

            return added;
        }

        /**
         * Always place a just-sent staff message at the end of the open chat.
         * Keep API inserted_at (UTC) for the label; only pin _sortTs for order.
         */
        function appendSentMessage(sent)
        {
            if (!sent) {
                return null;
            }

            if (findExistingMessageIndex(sent) !== -1) {
                return null;
            }

            var maxTs = 0;
            var i;

            for (i = 0; i < vm.messages.length; i++) {
                if ((vm.messages[i]._sortTs || 0) > maxTs) {
                    maxTs = vm.messages[i]._sortTs;
                }
            }

            var tz = sent.timezone || getChatTimezone();
            if (tz) {
                sent.timezone = tz;
                vm.chatTimezone = tz;
            }

            // API inserted_at is UTC — never overwrite; fill with UTC now if missing.
            if (!sent.inserted_at) {
                sent.inserted_at = nowUtc();
            }

            sent._sortTs = Math.max(maxTs + 1, Date.now());
            sent._pinnedToEnd = true;

            if (!sent._uid || String(sent._uid).indexOf(':undefined') !== -1 || /:$/.test(String(sent._uid))) {
                sent._uid = (sent._channel || sent.channel || 'x') + ':sent:' + sent._sortTs + ':' + Math.random().toString(36).slice(2, 8);
            }

            vm.messages.push(sent);
            preloadVisibleMessageMedia([sent]);
            return sent;
        }

        function getChatTimezone()
        {
            return (vm.selectedThread && vm.selectedThread.timezone) ||
                vm.chatTimezone ||
                'UTC';
        }

        function countMessagesByChannel(channel)
        {
            var count = 0;
            var i;

            for (i = 0; i < vm.messages.length; i++) {
                if (vm.messages[i]._channel === channel) {
                    count++;
                }
            }

            return count;
        }

        // ---------------------------------------------------------------------
        // Thread grouping (merge by confirmation_number)
        // ---------------------------------------------------------------------

        function buildGroupKey(confirmationNumber, provider, sub)
        {
            if (confirmationNumber) {
                return 'grp-' + confirmationNumber;
            }

            if (provider === 'ota') {
                return 'ota-' + sub;
            }

            return 'direct-' + sub;
        }

        function getThreadKey(thread)
        {
            if (!thread) {
                return '';
            }

            if (thread._key) {
                return thread._key;
            }

            if (thread.confirmation_number) {
                return 'grp-' + thread.confirmation_number;
            }

            if (thread.channels) {
                if (thread.channels.ota && thread.channels.ota.message_thread_id) {
                    return 'ota-' + thread.channels.ota.message_thread_id;
                }

                if (thread.channels.sms && thread.channels.sms.conversation_sid) {
                    return 'direct-' + thread.channels.sms.conversation_sid;
                }

                if (thread.channels.whatsapp && thread.channels.whatsapp.conversation_sid) {
                    return 'direct-' + thread.channels.whatsapp.conversation_sid;
                }
            }

            if (thread._ota) {
                return 'ota-' + thread._ota.thread_id + '-' + (thread._ota.hotel_id || '');
            }

            if (thread._direct) {
                return 'direct-' + (thread._direct.conversation_sid || '');
            }

            return '';
        }

        function isMergedThread(group)
        {
            if (!group) {
                return false;
            }

            if (group.channels) {
                var count = 0;
                if (group.channels.ota) { count++; }
                if (group.channels.sms) { count++; }
                if (group.channels.whatsapp) { count++; }
                return count > 1;
            }

            return !!(group._ota && group._direct);
        }

        function groupHasOta(group)
        {
            return !!(group && ((group.channels && group.channels.ota) || group._ota));
        }

        function groupHasDirect(group)
        {
            return !!(group && (
                (group.channels && (group.channels.sms || group.channels.whatsapp)) ||
                group._direct
            ));
        }

        function threadMatchesTab(group)
        {
            if (!group) {
                return false;
            }

            if (!hasAnyChannelEnabled()) {
                return false;
            }

            var hasOta = groupHasOta(group);
            var hasDirect = groupHasDirect(group);

            // Unmarked rows: only keep when at least one channel is enabled.
            if (!hasOta && !hasDirect) {
                return true;
            }

            return (canFetchOta() && hasOta) || (canFetchSms() && hasDirect);
        }

        function isInHouseThread(group)
        {
            if (!group) {
                return false;
            }

            // In-house = currently checked in only (not Active / upcoming / checked-out).
            return getStayStatus(group) === 'checked-in';
        }

        function finalizeGroup(group)
        {
            var ota = group._ota;
            var dir = group._direct;

            group.confirmation_number = (ota && ota.confirmation_number) ||
                (dir && dir.confirmation_number) ||
                group.confirmation_number || '';

            group.title = (dir && dir.guest_name) ||
                (ota && ota.title) ||
                (dir && (dir.title || dir.guest_phone)) ||
                group.confirmation_number || '';

            group.guest_name = (dir && dir.guest_name) || (ota && ota.title) || '';
            group.guest_phone = (dir && dir.guest_phone) || '';
            group.hotel_id = (ota && ota.hotel_id) || (dir && dir.hotel_id) || null;
            group.hotel_title = (ota && ota.hotel_title) || (dir && dir.hotel_title) || '';
            group.provider = ota ? ota.provider : null;
            group.channel = dir ? dir.channel : null;
            group.ota_id = ota ? ota.ota_id : '';
            group.is_closed = ota ? !!ota.is_closed : false;
            group.thread_id = ota ? ota.thread_id : '';
            group.booking_id = ota ? ota.booking_id : '';

            group.room_stay_from = (ota && ota.room_stay_from) ||
                (dir && dir.checkin_date) ||
                (ota && ota.checkin_date) || '';
            group.room_stay_to = (ota && ota.room_stay_to) ||
                (dir && dir.checkout_date) ||
                (ota && ota.checkout_date) || '';
            group.checkin_date = group.room_stay_from;
            group.checkout_date = group.room_stay_to;
            group.room_stay_status = (ota && ota.room_stay_status) ||
                (dir && dir.room_stay_status) || '';

            group.source_of_creation = extractSourceOfCreation({
                source_of_creation: group.source_of_creation ||
                    (ota && ota.source_of_creation) ||
                    (dir && dir.source_of_creation) ||
                    '',
                room_stays: group.room_stays ||
                    (ota && ota.room_stays) ||
                    (dir && dir.room_stays) ||
                    null,
                room_stay: group.room_stay ||
                    (ota && ota.room_stay) ||
                    (dir && dir.room_stay) ||
                    null,
                _ota: ota,
                _direct: dir
            });

            if (ota && ota.meta) {
                group.meta = ota.meta;
            }

            group.channels = {
                ota: ota ? {
                    channel: 'ota',
                    message_thread_id: ota.thread_id,
                    booking_id: ota.booking_id,
                    is_closed: !!ota.is_closed,
                    unread_count: parseInt(ota.ota_msg_unread_count, 10) || 0
                } : null,
                sms: (dir && dir.channel !== 'whatsapp') ? {
                    channel: 'sms',
                    conversation_sid: dir.conversation_sid,
                    unread_count: parseInt(dir.direct_msg_unread_counter, 10) || 0,
                    guest_phone_e164: dir.guest_phone
                } : null,
                whatsapp: (dir && dir.channel === 'whatsapp') ? {
                    channel: 'whatsapp',
                    conversation_sid: dir.conversation_sid,
                    unread_count: parseInt(dir.direct_msg_unread_counter, 10) || 0,
                    guest_phone_e164: dir.guest_phone
                } : null
            };

            group.messaging_opt_out = !!(dir && dir.messaging_opt_out);
            group.ai_mode = coerceAiMode(
                group.ai_mode != null ? group.ai_mode :
                (dir && dir.ai_mode != null ? dir.ai_mode :
                (ota && ota.ai_mode))
            );
            group.total_unread_count = (parseInt(ota && ota.ota_msg_unread_count, 10) || 0) +
                (parseInt(dir && dir.direct_msg_unread_counter, 10) || 0);
            group.room_number = group.room_number || (dir && dir.room_number) || (ota && ota.room_number) || '';

            // Precompute provider chips so ng-repeat gets a stable array reference
            // (returning a fresh array from a template function triggers infdig).
            group._chips = computeChips(group);

            var otaTs = ota ? parseTs(ota.last_message_received_at || ota.updated_at) : 0;
            var dirTs = dir ? parseTs(dir.date_updated || dir.date_created) : 0;

            if (otaTs >= dirTs) {
                group._activityTs = otaTs;
                group._activityRaw = ota ? (ota.last_message_received_at || ota.updated_at) : '';
                group.last_message = (ota && ota.last_message) || (dir && dir.last_message) || null;
                group._lastChannel = ota ? 'ota' : 'direct';
            } else {
                group._activityTs = dirTs;
                group._activityRaw = dir ? (dir.date_updated || dir.date_created) : '';
                group.last_message = (dir && dir.last_message) || (ota && ota.last_message) || null;
                group._lastChannel = 'direct';
            }

            return group;
        }

        function rebuildThreadList()
        {
            var groups = {};
            var list = [];

            function ensure(key)
            {
                if (!groups[key]) {
                    groups[key] = {
                        _provider: 'group',
                        _key: key,
                        _ota: null,
                        _direct: null,
                        confirmation_number: ''
                    };
                    list.push(groups[key]);
                }

                return groups[key];
            }

            var i;
            var thread;
            var key;

            if (canFetchOta()) {
                for (i = 0; i < vm.otaThreads.length; i++) {
                    thread = vm.otaThreads[i];
                    key = buildGroupKey(thread.confirmation_number, 'ota', thread.thread_id + '-' + (thread.hotel_id || ''));
                    ensure(key)._ota = thread;
                }
            }

            if (canFetchSms()) {
                for (i = 0; i < vm.smsThreads.length; i++) {
                    thread = vm.smsThreads[i];
                    key = buildGroupKey(thread.confirmation_number, 'direct', thread.conversation_sid || '');
                    ensure(key)._direct = thread;
                }
            }

            for (i = 0; i < list.length; i++) {
                finalizeGroup(list[i]);
            }

            list = list.filter(threadMatchesTab);

            if (vm.threadFilter === 'in_house') {
                list = list.filter(function(thread) {
                    return isEscalationUnread(thread) || isInHouseThread(thread);
                });
            } else if (vm.threadFilter === 'unread') {
                list = list.filter(function(thread) {
                    if (isEscalationUnread(thread)) {
                        return true;
                    }
                    var key = vm.getThreadKey(thread);
                    if (hasUnread(thread)) {
                        vm._keptInUnreadKeys[key] = true;
                    }
                    return vm._keptInUnreadKeys[key] || (vm.selectedThread && key === vm.getThreadKey(vm.selectedThread));
                });
            }

            list.sort(compareThreadsForInbox);

            vm.threads = list;

            if (vm.selectedKey) {
                for (i = 0; i < list.length; i++) {
                    if (list[i]._key === vm.selectedKey) {
                        vm.selectedThread = list[i];
                        break;
                    }
                }
            }
        }

        // ---------------------------------------------------------------------
        // Thread fetching
        // ---------------------------------------------------------------------

        function fetchOtaThreads(page, append)
        {
            var params = {
                page: page,
                limit: vm.threadLimit
            };

            if (vm.subHotelId) {
                params.sub_hotel_id = vm.subHotelId;
            }

            return messageCenterService.getMessageThreads(params).then(function (response) {
                if (!response || response.success === false) {
                    vm.threadErrors.push({
                        message: (response && response.message) || 'Unable to load OTA conversations.'
                    });
                    return false;
                }

                var data = response.data || [];

                if (append) {
                    vm.otaThreads = vm.otaThreads.concat(data);
                } else {
                    vm.otaThreads = data;
                }

                vm.otaPage = page;
                vm.otaTotal = (response.meta && response.meta.total) ? response.meta.total : vm.otaThreads.length;
                vm.isParent = vm.isParent || !!(response.meta && response.meta.is_parent);

                if (response.errors && response.errors.length) {
                    vm.threadErrors = vm.threadErrors.concat(response.errors);
                }

                messageCenterNavBadgeService.syncThreadUnreadMap(data);
                return true;
            }, function () {
                vm.threadErrors.push({ message: 'Unable to load OTA conversations.' });
                return false;
            });
        }

        function fetchSmsThreads(page, append)
        {
            var params = {
                page: page,
                limit: vm.threadLimit
            };

            if (vm.subHotelId) {
                params.sub_hotel_id = vm.subHotelId;
            }

            return messageCenterService.getSmsThreads(params).then(function (response) {
                if (!response || response.success === false) {
                    var message = (response && response.message) || 'Unable to load SMS conversations.';

                    if (/not enabled/i.test(message)) {
                        vm.smsEnabled = false;
                        normalizeActiveTab();
                        return false;
                    }

                    vm.threadErrors.push({ message: message });
                    return false;
                }

                var data = response.data || [];

                if (append) {
                    vm.smsThreads = vm.smsThreads.concat(data);
                } else {
                    vm.smsThreads = data;
                }

                vm.smsPage = page;
                vm.smsHasMore = data.length >= vm.threadLimit;
                vm.isParent = vm.isParent || !!(response.meta && response.meta.is_parent);

                messageCenterNavBadgeService.syncDirectThreadUnreadMap(data);
                return true;
            }, function () {
                vm.threadErrors.push({ message: 'Unable to load SMS conversations.' });
                return false;
            });
        }

        function isLocalStorageUnavailable(response)
        {
            var message = (response && response.message) || '';
            return /local message storage is not available/i.test(message);
        }

        function finalizeUnifiedThread(thread)
        {
            thread = thread || {};
            thread.channels = thread.channels || { ota: null, sms: null, whatsapp: null };

            if (thread.channels.ota) {
                thread.channels.ota.message_thread_id = thread.channels.ota.message_thread_id ||
                    thread.channels.ota.thread_external_id;
                thread.thread_id = thread.channels.ota.message_thread_id;
                thread.booking_id = thread.channels.ota.booking_id || thread.booking_id;
                thread.is_closed = !!thread.channels.ota.is_closed;
            }

            // Prefer SMS/WhatsApp thread phone over reservation guest phone for UI.
            thread.reservation_guest_phone = thread.guest_phone || '';
            thread.guest_phone =
                (thread.channels.sms && thread.channels.sms.guest_phone_e164) ||
                (thread.channels.whatsapp && thread.channels.whatsapp.guest_phone_e164) ||
                '';

            thread.room_stay_from = thread.room_stay_from || thread.checkin_date || '';
            thread.room_stay_to = thread.room_stay_to || thread.checkout_date || '';
            thread.checkin_date = thread.checkin_date || thread.room_stay_from;
            thread.checkout_date = thread.checkout_date || thread.room_stay_to;
            thread.source_of_creation = extractSourceOfCreation(thread);
            thread.total_unread_count = parseInt(thread.total_unread_count, 10) || 0;
            thread.has_escalation_unread = !!thread.has_escalation_unread && thread.total_unread_count > 0;
            thread.has_guest_after_escalation = !!thread.has_escalation_unread &&
                !!thread.has_guest_after_escalation;
            thread.ai_mode = coerceAiMode(thread.ai_mode);
            thread.messaging_opt_out = !!thread.messaging_opt_out;
            thread.is_archived = !!thread.is_archived;
            // Default true when API omits the flag (column not yet migrated).
            thread.is_acknowledged = thread.is_acknowledged == null ? true : !!thread.is_acknowledged;

            if (thread.confirmation_number) {
                messageCenterNavBadgeService.setReservationAiModeKnown(
                    thread.confirmation_number,
                    thread.ai_mode
                );
            }

            thread._key = getThreadKey(thread);
            thread._activityTs = parseTs(thread.last_message_at);
            thread._activityRaw = thread.last_message_at || '';
            thread._chips = computeChips(thread);

            // Prefer an API-provided last_message (staff). Guest unified
            // rows usually only have preview fields.
            if (thread.last_message) {
                if (thread.last_is_media_attached || thread.last_message.is_media_attached) {
                    thread.last_is_media_attached = 1;
                    thread.last_message.is_media_attached = 1;
                    thread.last_message.message = normalizeThreadPreviewText(
                        thread.last_message.message,
                        true
                    );
                } else {
                    thread.last_is_media_attached = 0;
                    thread.last_message.is_media_attached = 0;
                }
            } else if (thread.last_message_preview || thread.last_is_media_attached) {
                thread.last_message = {
                    message: normalizeThreadPreviewText(
                        thread.last_message_preview,
                        thread.last_is_media_attached
                    ),
                    sender: normalizeLastSender(thread.last_sender),
                    inserted_at: thread.last_message_at,
                    is_media_attached: thread.last_is_media_attached ? 1 : 0
                };
            }

            return thread;
        }

        function syncUnifiedUnreadMaps(threads)
        {
            var otaSync = [];
            var directSync = [];
            var i;
            var thread;
            var ch;

            for (i = 0; i < (threads || []).length; i++) {
                thread = threads[i];
                ch = thread.channels || {};

                if (ch.ota && ch.ota.message_thread_id) {
                    otaSync.push({
                        thread_id: ch.ota.message_thread_id,
                        ota_msg_unread_count: ch.ota.unread_count || 0
                    });
                }

                if (ch.sms && ch.sms.conversation_sid) {
                    directSync.push({
                        conversation_sid: ch.sms.conversation_sid,
                        direct_msg_unread_counter: ch.sms.unread_count || 0
                    });
                }

                if (ch.whatsapp && ch.whatsapp.conversation_sid) {
                    directSync.push({
                        conversation_sid: ch.whatsapp.conversation_sid,
                        direct_msg_unread_counter: ch.whatsapp.unread_count || 0
                    });
                }
            }

            if (otaSync.length) {
                messageCenterNavBadgeService.syncThreadUnreadMap(otaSync);
            }

            if (directSync.length) {
                messageCenterNavBadgeService.syncDirectThreadUnreadMap(directSync);
            }
        }

        function fetchUnifiedThreads(page, append)
        {
            var params = {
                page: page,
                limit: vm.threadLimit
            };

            if (vm.subHotelId) {
                params.sub_hotel_id = vm.subHotelId;
            }

            if (vm.searchQuery) {
                params.q = vm.searchQuery;
            }

            if (vm.isArchiveView) {
                params.stay_filter = 'archived';
            } else {
                params.stay_filter = vm.threadFilter === 'all' ? 'all' : vm.threadFilter;
                if (params.stay_filter === 'archived') {
                    params.stay_filter = 'all';
                }
            }

            return messageCenterService.getUnifiedThreads(params).then(function (response) {
                if (!response || response.success === false) {
                    if (isLocalStorageUnavailable(response)) {
                        useUnifiedApi = false;
                        vm.localStorageUnavailable = true;
                        return false;
                    }

                    // Endpoint missing / unexpected — fall back to legacy.
                    useUnifiedApi = false;
                    return false;
                }

                useUnifiedApi = true;
                vm.localStorageUnavailable = false;

                if (applyChannelEnabledFlags(response)) {
                    normalizeActiveTab();
                }

                if (response.timezone) {
                    vm.chatTimezone = response.timezone;
                }

                var data = (response.data || []).map(finalizeUnifiedThread);
                var selectedConfirmation = vm.selectedThread && vm.selectedThread.confirmation_number;
                var i;

                // Keep the open chat unread-cleared even if the list API is still stale.
                if (selectedConfirmation) {
                    for (i = 0; i < data.length; i++) {
                        if (data[i].confirmation_number === selectedConfirmation) {
                            zeroUnreadPayload(data[i]);
                        }
                    }
                }

                if (append) {
                    var existing = {};
                    var merged = [];
                    var item;
                    var key;
                    var prev = vm._allUnifiedThreads || [];

                    for (i = 0; i < prev.length; i++) {
                        item = prev[i];
                        key = item && item.confirmation_number ? String(item.confirmation_number) : getThreadKey(item);
                        if (!key || existing[key]) {
                            continue;
                        }
                        existing[key] = true;
                        merged.push(item);
                    }

                    for (i = 0; i < data.length; i++) {
                        item = data[i];
                        key = item && item.confirmation_number ? String(item.confirmation_number) : getThreadKey(item);
                        if (!key || existing[key]) {
                            continue;
                        }
                        existing[key] = true;
                        merged.push(item);
                    }

                    vm._allUnifiedThreads = merged;
                } else {
                    if (vm.threadFilter === 'unread') {
                        var existing = {};
                        var merged = [];
                        
                        for (i = 0; i < data.length; i++) {
                            item = data[i];
                            key = item && item.confirmation_number ? String(item.confirmation_number) : getThreadKey(item);
                            if (key) existing[key] = true;
                            merged.push(item);
                        }
                        
                        for (i = 0; i < (vm._allUnifiedThreads || []).length; i++) {
                            item = vm._allUnifiedThreads[i];
                            key = item && item.confirmation_number ? String(item.confirmation_number) : getThreadKey(item);
                            if (key && vm._keptInUnreadKeys[key] && !existing[key]) {
                                existing[key] = true;
                                merged.push(item);
                            }
                        }
                        
                        if (vm.selectedThread) {
                            var _selectedKey = vm.getThreadKey(vm.selectedThread);
                            if (_selectedKey && !existing[_selectedKey]) {
                                merged.push(vm.selectedThread);
                            }
                        }
                        
                        vm._allUnifiedThreads = merged;
                    } else {
                        vm._allUnifiedThreads = data;
                    }
                }

                applyUnifiedTabFilter();
                vm.threadPage = page;
                vm.threadTotal = (response.meta && response.meta.total) ? response.meta.total : vm._allUnifiedThreads.length;
                vm.isParent = vm.isParent || !!(response.meta && response.meta.is_parent);
                syncUnifiedUnreadMaps(data);

                // Reattach selection to the list row so badge state stays in sync.
                if (vm.selectedKey) {
                    for (i = 0; i < (vm.threads || []).length; i++) {
                        if (getThreadKey(vm.threads[i]) === vm.selectedKey) {
                            vm.selectedThread = vm.threads[i];
                            clearLocalUnread(vm.selectedThread);
                            break;
                        }
                    }
                }

                return true;
            }, function () {
                useUnifiedApi = false;
                return false;
            });
        }

        function loadLegacyThreads()
        {
            var promises = [];

            if (canFetchOta()) {
                promises.push(fetchOtaThreads(1, false));
            }

            if (canFetchSms()) {
                promises.push(fetchSmsThreads(1, false));
            }

            if (!promises.length) {
                vm.loadingThreads = false;
                rebuildThreadList();
                return $q.when();
            }

            return $q.all(promises).then(function () {
                vm.loadingThreads = false;
                rebuildThreadList();

                if (!vm.threads.length && !vm.selectedThread) {
                    clearChat();
                }

                autoSelectPendingConversation();
            });
        }

        function loadThreads(options)
        {
            options = options || {};
            vm.loadingThreads = true;
            vm.threadErrors = [];

            if (!vm.canGetThreads || !vm.channelFlagsReady || !hasAnyChannelEnabled()) {
                vm.loadingThreads = false;
                vm.threads = [];
                vm._allUnifiedThreads = [];
                return;
            }

            if (useUnifiedApi) {
                fetchUnifiedThreads(1, false).then(function (ok) {
                    if (ok) {
                        vm.loadingThreads = false;

                        if (!vm.threads.length && !vm.selectedThread) {
                            clearChat();
                        }

                        autoSelectPendingConversation();
                        return;
                    }

                    loadLegacyThreads();
                });
                return;
            }

            loadLegacyThreads();
        }

        /**
         * Find a unified group by confirmation in the loaded list / cache.
         */
        function findGroupByConfirmation(confirmation)
        {
            var i;

            if (!confirmation) {
                return null;
            }

            for (i = 0; i < (vm.threads || []).length; i++) {
                if (vm.threads[i].confirmation_number === confirmation) {
                    return vm.threads[i];
                }
            }

            for (i = 0; i < (vm._allUnifiedThreads || []).length; i++) {
                if (vm._allUnifiedThreads[i].confirmation_number === confirmation) {
                    return vm._allUnifiedThreads[i];
                }
            }

            return null;
        }

        /**
         * Open chat on the right for a confirmation that is not on the current
         * left-panel page. Leaves the thread list / search filter unchanged.
         */
        function openConfirmationOnRightOnly(confirmation)
        {
            var params;

            if (!confirmation || pendingDeepLinkFetch === confirmation) {
                return;
            }

            pendingDeepLinkFetch = confirmation;
            params = { confirmation_number: confirmation };

            if (vm.subHotelId) {
                params.sub_hotel_id = vm.subHotelId;
            }

            messageCenterService.getReservationMessagingContext(params).then(function (response) {
                if (pendingDeepLinkFetch !== confirmation) {
                    return;
                }

                pendingDeepLinkFetch = '';
                pendingConfirmation = '';
                pendingConversationSid = '';

                if (response && response.success !== false && response.data) {
                    selectThread(finalizeUnifiedThread(angular.copy(response.data)));
                }
            }, function () {
                if (pendingDeepLinkFetch === confirmation) {
                    pendingDeepLinkFetch = '';
                }

                pendingConfirmation = '';
            });
        }

        /**
         * After threads load, open deep-linked / toast-target conversation.
         * List stays as-is; missing threads are loaded into the right panel only.
         */
        function autoSelectPendingConversation()
        {
            var group;

            if (!pendingConfirmation && !pendingConversationSid) {
                return;
            }

            if (pendingConfirmation) {
                group = findGroupByConfirmation(pendingConfirmation);

                if (group) {
                    pendingConfirmation = '';
                    pendingConversationSid = '';
                    selectThread(group);
                    return;
                }

                if (useUnifiedApi) {
                    openConfirmationOnRightOnly(pendingConfirmation);
                    return;
                }

                pendingConfirmation = '';
            }

            if (pendingConversationSid) {
                group = findGroupByConversationSid(pendingConversationSid);

                if (group) {
                    pendingConversationSid = '';
                    selectThread(group);
                    return;
                }

                pendingConversationSid = '';
            }
        }

        /**
         * Open a reservation/thread from toast click or deep-link.
         * Prefer list row when present; otherwise load right panel only (no left filter).
         * params: confirmation_number?, conversation_sid?, message_thread_id?
         */
        function openConversationFromNav(params)
        {
            var confirmation = (params && params.confirmation_number) || '';
            var conversationSid = (params && params.conversation_sid) || '';
            var messageThreadId = (params && params.message_thread_id) || '';
            var group = null;
            var i;
            var ch;

            if (!confirmation && !conversationSid && !messageThreadId) {
                return;
            }

            // Leave group-message tab so the conversation panel is visible.
            if (vm.activeTab === 'group_msg') {
                vm.activeTab = 'all';
            }

            if (confirmation) {
                if (isSelectedConfirmation(confirmation)) {
                    scrollMessagesToBottom();
                    return;
                }

                group = findGroupByConfirmation(confirmation);
            }

            if (!group && conversationSid) {
                group = findGroupByConversationSid(conversationSid);
            }

            if (!group && messageThreadId) {
                for (i = 0; i < (vm.threads || []).length; i++) {
                    ch = vm.threads[i].channels || {};
                    if ((ch.ota && ch.ota.message_thread_id === messageThreadId) ||
                        (vm.threads[i]._ota && vm.threads[i]._ota.thread_id === messageThreadId) ||
                        vm.threads[i].thread_id === messageThreadId) {
                        group = vm.threads[i];
                        break;
                    }
                }
            }

            if (group) {
                pendingConfirmation = '';
                pendingConversationSid = '';
                selectThread(group);
                return;
            }

            pendingConfirmation = confirmation || '';
            pendingConversationSid = conversationSid || '';

            // Not in the left list — open on the right without changing the list/search.
            if (confirmation && useUnifiedApi) {
                openConfirmationOnRightOnly(confirmation);
            }
        }

        function hasMoreThreads()
        {
            if (useUnifiedApi) {
                return (vm._allUnifiedThreads || []).length < vm.threadTotal;
            }

            var more = false;

            if (canFetchOta()) {
                more = more || vm.otaThreads.length < vm.otaTotal;
            }

            if (canFetchSms()) {
                more = more || vm.smsHasMore;
            }

            return more;
        }

        function loadMoreThreads()
        {
            if (vm.loadingThreads || !hasMoreThreads()) {
                return;
            }

            vm.loadingThreads = true;

            if (useUnifiedApi) {
                fetchUnifiedThreads(vm.threadPage + 1, true).then(function () {
                    vm.loadingThreads = false;
                });
                return;
            }

            var promises = [];

            if (canFetchOta() && vm.otaThreads.length < vm.otaTotal) {
                promises.push(fetchOtaThreads(vm.otaPage + 1, true));
            }

            if (canFetchSms() && vm.smsHasMore) {
                promises.push(fetchSmsThreads(vm.smsPage + 1, true));
            }

            if (!promises.length) {
                vm.loadingThreads = false;
                return;
            }

            $q.all(promises).then(function () {
                vm.loadingThreads = false;
                rebuildThreadList();
            });
        }

        function isThreadSelected(group)
        {
            return vm.selectedKey && getThreadKey(group) === vm.selectedKey;
        }

        function clearChat()
        {
            if (vm.selectedKey) {
                saveComposerDraft(vm.selectedKey);
            }

            unbindMessagesScroll();
            vm.selectedThread = null;
            vm.selectedKey = '';
            vm.messages = [];
            vm.messageStayDates = null;
            vm.reservationStayDates = null;
            vm.showLoadEarlier = false;
            detachComposerState();
            vm.composerDragOver = false;
            vm.editingPhone = false;
            vm.phoneEditValue = '';
            resetReplyTextareaHeight();
            broadcastActiveConversation(null);
        }

        function saveComposerDraft(key)
        {
            if (!key) {
                return;
            }

            var text = String(vm.replyText || '');
            var hasBody = messageCenterComposerSignature.hasBodyBeyondSignature(text);
            var hasMedia = !!vm.pendingMedia;
            var hasTranslation = !!(vm.replyTranslation && vm.replyTranslation.text);

            if (!hasBody && !hasMedia && !hasTranslation) {
                delete composerDrafts[key];
                return;
            }

            composerDrafts[key] = {
                replyText: text,
                pendingMedia: vm.pendingMedia || null,
                replyTranslation: vm.replyTranslation || null,
                lastComposerBodyForTranslation: vm._lastComposerBodyForTranslation
            };
        }

        function restoreComposerDraft(key)
        {
            var draft = key ? composerDrafts[key] : null;

            if (!draft) {
                detachComposerState();
                return;
            }

            vm.replyText = draft.replyText || '';
            vm.pendingMedia = draft.pendingMedia || null;
            vm.uploadingMedia = !!(vm.pendingMedia && vm.pendingMedia.uploading);
            vm.replyTranslation = draft.replyTranslation || null;
            vm._lastComposerBodyForTranslation = draft.lastComposerBodyForTranslation;
            resetComposerFileInput();
        }

        function clearComposerDraft(key)
        {
            if (!key || !composerDrafts[key]) {
                return;
            }

            var draft = composerDrafts[key];
            var draftMedia = draft && draft.pendingMedia;

            // Revoke only when this media is not still attached to the live composer.
            if (draftMedia &&
                draftMedia.previewUrl &&
                draftMedia !== vm.pendingMedia) {
                try {
                    URL.revokeObjectURL(draftMedia.previewUrl);
                } catch (e) {
                    // ignore
                }
            }

            delete composerDrafts[key];
        }

        function detachComposerState()
        {
            // Drop live composer fields without revoking draft-owned preview URLs.
            vm.replyText = '';
            vm.pendingMedia = null;
            vm.uploadingMedia = false;
            clearReplyTranslation();
            vm._lastComposerBodyForTranslation = undefined;
            resetComposerFileInput();
        }

        function resetComposerFileInput()
        {
            var input = document.getElementById('gmc-attach-image-input');
            if (input) {
                input.value = '';
            }
        }

        function clearComposerAfterSend()
        {
            clearComposerDraft(vm.selectedKey);
            vm.replyText = '';
            clearReplyTranslation();
            clearPendingMedia();
            resetReplyTextareaHeight();
        }

        function findPendingMediaByFile(file)
        {
            if (vm.pendingMedia && vm.pendingMedia.file === file) {
                return vm.pendingMedia;
            }

            var keys = Object.keys(composerDrafts);
            var i;
            var draft;

            for (i = 0; i < keys.length; i++) {
                draft = composerDrafts[keys[i]];
                if (draft && draft.pendingMedia && draft.pendingMedia.file === file) {
                    return draft.pendingMedia;
                }
            }

            return null;
        }

        function goBackToThreads()
        {
            clearChat();
            syncThreadUrlParam(null);
            loadThreads();
        }

        function onSubHotelChange()
        {
            resetThreadListAndReload();
        }

        function setThreadFilter(filter)
        {
            if (vm.isArchiveView) {
                return;
            }

            if (vm.threadFilter === filter) {
                return;
            }

            // Keep escalated-unread pinned in the list while the new chip reloads
            // so they do not flash away / remount on every All / In House / Unread switch.
            var keptEscalated = collectEscalatedUnreadThreads();

            vm.threadFilter = filter;
            vm._keptInUnreadKeys = {};
            messageCenterService.setThreadFilter(filter);
            // Drop URL deep-link so the previous confirmation does not reopen
            // against the new All / In-house / Unread list.
            pendingConfirmation = '';
            pendingConversationSid = '';
            pendingDeepLinkFetch = '';
            syncThreadUrlParam(null);
            resetThreadListAndReload({ keepThreads: keptEscalated });
        }

        function collectEscalatedUnreadThreads()
        {
            var source = (vm._allUnifiedThreads && vm._allUnifiedThreads.length)
                ? vm._allUnifiedThreads
                : (vm.threads || []);
            var seen = {};
            var kept = [];
            var i;
            var thread;
            var key;

            for (i = 0; i < source.length; i++) {
                thread = source[i];
                if (!isEscalationUnread(thread)) {
                    continue;
                }
                key = thread.confirmation_number
                    ? String(thread.confirmation_number)
                    : getThreadKey(thread);
                if (!key || seen[key]) {
                    continue;
                }
                seen[key] = true;
                kept.push(thread);
            }

            kept.sort(compareThreadsForInbox);
            return kept;
        }

        function resetThreadListAndReload(options)
        {
            options = options || {};
            var keepThreads = Array.isArray(options.keepThreads) ? options.keepThreads : [];

            vm.threadPage = 1;
            vm.otaPage = 1;
            vm.smsPage = 1;
            vm.threadTotal = 0;
            vm.otaTotal = 0;
            vm.smsHasMore = false;
            vm.otaThreads = [];
            vm.smsThreads = [];
            clearChat();

            // Leave escalated rows mounted during reload; replace once the new filter returns.
            vm._allUnifiedThreads = keepThreads.slice();
            if (useUnifiedApi) {
                applyUnifiedTabFilter();
            } else {
                vm.threads = keepThreads.slice();
            }

            loadThreads();
        }

        // ---------------------------------------------------------------------
        // Unread accounting
        // ---------------------------------------------------------------------

        function getThreadUnreadCount(group)
        {
            if (!group) {
                return 0;
            }

            if (group.total_unread_count !== undefined && group.total_unread_count !== null) {
                var total = parseInt(group.total_unread_count, 10) || 0;

                if (total || !(group._ota || group._direct)) {
                    return total;
                }
            }

            var channels = group.channels || {};
            var fromChannels = 0;

            if (channels.ota) {
                fromChannels += parseInt(channels.ota.unread_count, 10) || 0;
            }

            if (channels.sms) {
                fromChannels += parseInt(channels.sms.unread_count, 10) || 0;
            }

            if (channels.whatsapp) {
                fromChannels += parseInt(channels.whatsapp.unread_count, 10) || 0;
            }

            if (fromChannels) {
                return fromChannels;
            }

            var otaUnread = group._ota ? (parseInt(group._ota.ota_msg_unread_count, 10) || 0) : 0;
            var dirUnread = group._direct ? (parseInt(group._direct.direct_msg_unread_counter, 10) || 0) : 0;

            return otaUnread + dirUnread;
        }

        function clearLocalUnread(group)
        {
            if (!group) {
                return;
            }

            group.total_unread_count = 0;
            group.has_escalation_unread = false;
            group.has_guest_after_escalation = false;

            if (group.channels) {
                ['ota', 'sms', 'whatsapp'].forEach(function (key) {
                    if (!group.channels[key]) {
                        return;
                    }

                    var prev = parseInt(group.channels[key].unread_count, 10) || 0;

                    if (key === 'ota' && group.channels[key].message_thread_id) {
                        messageCenterNavBadgeService.setThreadUnread(group.channels[key].message_thread_id, 0, prev);
                    } else if (group.channels[key].conversation_sid) {
                        messageCenterNavBadgeService.setDirectThreadUnread(group.channels[key].conversation_sid, 0, prev);
                    }

                    group.channels[key].unread_count = 0;
                });
            }

            if (group._ota) {
                var otaUnread = parseInt(group._ota.ota_msg_unread_count, 10) || 0;

                if (otaUnread > 0) {
                    messageCenterNavBadgeService.setThreadUnread(group._ota.thread_id, 0, otaUnread);
                    group._ota.ota_msg_unread_count = 0;
                }
            }

            if (group._direct) {
                var dirUnread = parseInt(group._direct.direct_msg_unread_counter, 10) || 0;

                if (dirUnread > 0) {
                    messageCenterNavBadgeService.setDirectThreadUnread(group._direct.conversation_sid, 0, dirUnread);
                    group._direct.direct_msg_unread_counter = 0;
                }
            }
        }

        /** Zero unread fields on a thread payload without touching nav badges. */
        function zeroUnreadPayload(thread)
        {
            if (!thread) {
                return thread;
            }

            thread.total_unread_count = 0;
            thread.has_escalation_unread = false;
            thread.has_guest_after_escalation = false;

            if (thread.channels) {
                ['ota', 'sms', 'whatsapp'].forEach(function (key) {
                    if (thread.channels[key]) {
                        thread.channels[key].unread_count = 0;
                    }
                });
            }

            if (thread._ota) {
                thread._ota.ota_msg_unread_count = 0;
            }

            if (thread._direct) {
                thread._direct.direct_msg_unread_counter = 0;
            }

            return thread;
        }

        /**
         * Match open/list rows for a PubNub event and patch unread + last preview.
         * Nav totals are owned by messageCenterNavBadgeService.
         */
        function applyPubNubToLocalRows(data, message, defaultSender)
        {
            var conf;
            var sid;
            var otaId;
            var seen = {};
            var groups = [];
            var text = '';
            var when;
            var sender;
            var isMedia = false;
            var i;
            var g;
            var ch;
            var total;
            var n;

            if (!data) {
                return;
            }

            conf = data.confirmation_number || '';
            sid = data.conversation_sid || '';
            otaId = data.message_thread_id || '';

            function push(group)
            {
                var key;

                if (!group) {
                    return;
                }

                key = group.confirmation_number || getThreadKey(group) || '';

                if (!key || seen[key]) {
                    return;
                }

                seen[key] = true;
                groups.push(group);
            }

            if (conf && vm.selectedThread &&
                vm.selectedThread.confirmation_number === conf) {
                push(vm.selectedThread);
            }

            if (conf) {
                push(findGroupByConfirmation(conf));
            }

            if (sid) {
                push(findGroupByConversationSid(sid));
            }

            if (otaId) {
                push(findOtaThread(otaId));
                angular.forEach(vm.threads || [], function (row) {
                    ch = (row && row.channels) || {};

                    if ((ch.ota && ch.ota.message_thread_id === otaId) ||
                        (row._ota && row._ota.thread_id === otaId) ||
                        row.thread_id === otaId) {
                        push(row);
                    }
                });
            }

            if (message && typeof message === 'object') {
                text = message.message || '';
                when = message.inserted_at || nowUtc();
                sender = normalizeLastSender(message.sender || defaultSender || 'property');
                isMedia = !!(message.is_media_attached ||
                    (angular.isArray(message.media) && message.media.length));
            } else if (typeof data.message === 'string') {
                text = data.message;
                when = data.inserted_at || nowUtc();
                sender = normalizeLastSender(defaultSender || data.sender || 'guest');
                isMedia = !!(data.is_media_attached ||
                    (angular.isArray(data.media) && data.media.length));
            }

            if (isMedia) {
                text = normalizeThreadPreviewText(text, true);
            }

            for (i = 0; i < groups.length; i++) {
                g = groups[i];
                ch = g.channels || {};

                if (data.ota_msg_unread_count != null) {
                    n = parseInt(data.ota_msg_unread_count, 10) || 0;

                    if (ch.ota) {
                        ch.ota.unread_count = n;
                    }

                    if (g._ota) {
                        g._ota.ota_msg_unread_count = n;
                    }
                }

                if (data.direct_msg_unread_counter != null) {
                    n = parseInt(data.direct_msg_unread_counter, 10) || 0;
                    angular.forEach(['sms', 'whatsapp'], function (key) {
                        if (ch[key]) {
                            ch[key].unread_count = n;
                        }
                    });

                    if (g._direct) {
                        g._direct.direct_msg_unread_counter = n;
                    }
                }

                total = (ch.ota ? (parseInt(ch.ota.unread_count, 10) || 0) : 0) +
                    (ch.sms ? (parseInt(ch.sms.unread_count, 10) || 0) : 0) +
                    (ch.whatsapp ? (parseInt(ch.whatsapp.unread_count, 10) || 0) : 0);

                if (!total && (g._ota || g._direct)) {
                    total = (g._ota ? (parseInt(g._ota.ota_msg_unread_count, 10) || 0) : 0) +
                        (g._direct ? (parseInt(g._direct.direct_msg_unread_counter, 10) || 0) : 0);
                }

                g.total_unread_count = total;
                if (total <= 0) {
                    g.has_escalation_unread = false;
                    g.has_guest_after_escalation = false;
                }

                if (text || isMedia) {
                    g.last_message = {
                        message: text,
                        sender: sender,
                        inserted_at: when,
                        is_media_attached: isMedia ? 1 : 0
                    };
                    g.last_message_preview = text;
                    g.last_sender = sender;
                    g.last_message_at = when;
                    g.last_is_media_attached = isMedia ? 1 : 0;
                    g._activityRaw = when;
                    g._activityTs = parseTs(when) || Date.now();

                    // Guest after a still-pending escalation: keep alert, also show badge.
                    if (sender === 'guest' && g.has_escalation_unread) {
                        g.has_guest_after_escalation = true;
                    }

                    // Unreplied alerts: guest opens a pending reply; real staff/AI clears it.
                    // Automated hotel outbound (after-hours, triggers) uses staff_user_id 0/null.
                    var ackStaffUserId = 0;
                    if (message && message.staff_user_id != null && message.staff_user_id !== '') {
                        ackStaffUserId = parseInt(message.staff_user_id, 10) || 0;
                    } else if (data.message && typeof data.message === 'object' &&
                        data.message.staff_user_id != null && data.message.staff_user_id !== '') {
                        ackStaffUserId = parseInt(data.message.staff_user_id, 10) || 0;
                    } else if (data.staff_user_id != null && data.staff_user_id !== '') {
                        ackStaffUserId = parseInt(data.staff_user_id, 10) || 0;
                    }

                    if (sender === 'guest') {
                        g.is_acknowledged = false;
                    } else if (sender === 'ai') {
                        g.is_acknowledged = true;
                    } else if ((sender === 'hotel' || sender === 'property') && ackStaffUserId > 0) {
                        g.is_acknowledged = true;
                    }
                }
            }
        }

        function isAiPubNubSender(data)
        {
            return !!(data && (data.sender === 'ai' ||
                (data.message && data.message.sender === 'ai')));
        }

        function normalizeEventMessage(data, channel)
        {
            if (data && data.message && typeof data.message === 'object') {
                return normalizeChannelMessages([angular.copy(data.message)], channel || 'sms')[0];
            }

            return null;
        }

        function eventTargetsSelected(data)
        {
            if (!data) {
                return false;
            }

            return (data.confirmation_number && isSelectedConfirmation(data.confirmation_number)) ||
                isSelectedSmsThread(data.conversation_sid) ||
                isSelectedOtaThread(data.message_thread_id);
        }

        function withOutboundUnread(data, channel)
        {
            var hasCounter = (channel === 'ota' && data.ota_msg_unread_count != null) ||
                (channel !== 'ota' && data.direct_msg_unread_counter != null);
            var copy;

            if (hasCounter) {
                return data;
            }

            copy = angular.copy(data) || {};

            if (channel === 'ota') {
                copy.ota_msg_unread_count = 0;
            } else {
                copy.direct_msg_unread_counter = 0;
            }

            return copy;
        }

        /** Shared path for staff/AI *_message_sent events. */
        function onOutboundMessageEvent(data, channel)
        {
            var message = normalizeEventMessage(data, channel);
            var isAi = isAiPubNubSender(data) || (message && message.sender === 'ai');
            var isSelected = eventTargetsSelected(data);
            var rowData = withOutboundUnread(data, channel);
            var sender = isAi ? 'ai' : ((message && message.sender) || 'property');

            applyPubNubToLocalRows(rowData, message, sender);

            if (isSelected) {
                if (message) {
                    if (appendSentMessage(message)) {
                        scrollMessagesToBottom();
                    }
                } else {
                    refreshActiveThreadMessages();
                }

                if (useUnifiedApi && data.confirmation_number) {
                    refreshMessagingContext(data.confirmation_number);
                }

                if (vm.selectedThread) {
                    zeroUnreadPayload(vm.selectedThread);
                }

                return;
            }

            if (data.confirmation_number && vm.threadPage === 1 && useUnifiedApi) {
                refreshInboxSilently();
            }
        }

        function markGroupRead(group, force)
        {
            if (!group) {
                return $q.when();
            }

            if (!force && getThreadUnreadCount(group) <= 0) {
                return $q.when();
            }

            clearLocalUnread(group);

            if (useUnifiedApi && group.confirmation_number) {
                var payload = {
                    confirmation_number: group.confirmation_number
                };

                if (vm.subHotelId) {
                    payload.sub_hotel_id = vm.subHotelId;
                }

                return messageCenterService.markUnifiedThreadAsRead(payload).then(function () {
                    messageCenterNavBadgeService.refresh();
                }, function () {
                    // Keep local clear even if API fails; next open can retry.
                });
            }

            if (group._ota) {
                markOtaThreadRead(group._ota);
            }

            if (group._direct) {
                markDirectThreadRead(group._direct);
            }

            return $q.when();
        }

        /**
         * While a chat is open, inbound guest messages still increment server unread.
         * Force mark-as-read even when the local badge was already zeroed.
         *
         * @param {Object} match confirmation_number / conversation_sid / message_thread_id
         * @param {Object} [eventData] optional PubNub payload for nav badge knownPrevious
         */
        function markSelectedThreadRead(match, eventData)
        {
            match = match || {};
            eventData = eventData || {};

            var group = vm.selectedThread;
            var matches = false;
            var channels;
            var knownDirect;
            var knownOta;

            if (!group) {
                return $q.when();
            }

            if (match.confirmation_number && isSelectedConfirmation(match.confirmation_number)) {
                matches = true;
            }

            if (match.conversation_sid && isSelectedSmsThread(match.conversation_sid)) {
                matches = true;
            }

            if (match.message_thread_id && isSelectedOtaThread(match.message_thread_id)) {
                matches = true;
            }

            if (!matches) {
                return $q.when();
            }

            knownDirect = eventData.direct_msg_unread_counter;
            knownOta = eventData.ota_msg_unread_count;
            channels = group.channels || {};

            // Nav badge map may be keyed by conversation_sid OR confirmation_number.
            if (match.conversation_sid) {
                messageCenterNavBadgeService.setDirectThreadUnread(
                    match.conversation_sid, 0, knownDirect
                );
            }

            if (match.confirmation_number || group.confirmation_number) {
                messageCenterNavBadgeService.setDirectThreadUnread(
                    match.confirmation_number || group.confirmation_number, 0, knownDirect
                );
            }

            if (channels.sms && channels.sms.conversation_sid) {
                messageCenterNavBadgeService.setDirectThreadUnread(
                    channels.sms.conversation_sid, 0, knownDirect
                );
            }

            if (channels.whatsapp && channels.whatsapp.conversation_sid) {
                messageCenterNavBadgeService.setDirectThreadUnread(
                    channels.whatsapp.conversation_sid, 0, knownDirect
                );
            }

            if (group._direct && group._direct.conversation_sid) {
                messageCenterNavBadgeService.setDirectThreadUnread(
                    group._direct.conversation_sid, 0, knownDirect
                );
            }

            if (match.message_thread_id) {
                messageCenterNavBadgeService.setThreadUnread(
                    match.message_thread_id, 0, knownOta
                );
            }

            if (channels.ota && channels.ota.message_thread_id) {
                messageCenterNavBadgeService.setThreadUnread(
                    channels.ota.message_thread_id, 0, knownOta
                );
            }

            if (group._ota && group._ota.thread_id) {
                messageCenterNavBadgeService.setThreadUnread(
                    group._ota.thread_id, 0, knownOta
                );
            }

            return markGroupRead(group, true);
        }

        function markOtaThreadRead(otaThread)
        {
            var payloads = [];

            if (otaThread.thread_id) {
                payloads.push({ message_thread_id: otaThread.thread_id });
            }

            if (otaThread.booking_id) {
                payloads.push({ booking_id: otaThread.booking_id });
            }

            if (otaThread.confirmation_number) {
                payloads.push({ confirmation_number: otaThread.confirmation_number });
            }

            if (!payloads.length) {
                return $q.when({ success: false });
            }

            function tryMark(index)
            {
                if (index >= payloads.length) {
                    return $q.when({ success: false });
                }

                return messageCenterService.markThreadAsRead(payloads[index]).then(function (response) {
                    if (response && response.success !== false) {
                        return response;
                    }

                    return tryMark(index + 1);
                });
            }

            return tryMark(0);
        }

        function markDirectThreadRead(directThread)
        {
            var payload = {
                conversation_sid: directThread.conversation_sid || ''
            };

            if (directThread.confirmation_number) {
                payload.confirmation_number = directThread.confirmation_number;
            }

            if (directThread.guest_phone) {
                payload.guest_phone = directThread.guest_phone;
            }

            if (vm.subHotelId) {
                payload.sub_hotel_id = vm.subHotelId;
            }

            return messageCenterService.markSmsThreadAsRead(payload);
        }

        // ---------------------------------------------------------------------
        // Selection + message loading
        // ---------------------------------------------------------------------

        function broadcastActiveConversation(group)
        {
            var ch = (group && group.channels) || {};
            var ota = ch.ota || (group && group._ota) || null;
            var sms = ch.sms || (group && group._sms) || null;

            $rootScope.$broadcast('messageCenter:activeConversation', {
                confirmation_number: (group && group.confirmation_number) || '',
                conversation_sid: (sms && (sms.conversation_sid || sms.sid)) ||
                    (group && group.conversation_sid) || '',
                message_thread_id: (ota && (ota.message_thread_id || ota.thread_id)) ||
                    (group && (group.message_thread_id || group.thread_id)) || ''
            });
        }

        function selectThread(group)
        {
            if (!group) {
                return;
            }

            var nextKey = getThreadKey(group);
            var prevKey = vm.selectedKey;
            var switchingThread = !!(prevKey && nextKey && prevKey !== nextKey);
            var openingThread = !prevKey;

            if (switchingThread) {
                saveComposerDraft(prevKey);
            }

            vm.selectedKey = nextKey;
            vm.selectedThread = group;

            // Keep the open chat visible in Unread after mark-as-read clears its counter.
            if (vm.threadFilter === 'unread' && vm.selectedKey) {
                vm._keptInUnreadKeys[vm.selectedKey] = true;
            }

            vm.messages = [];
            vm.msgPage = 1;
            vm.msgTotal = 0;
            vm.msgOta = { page: 1, total: 0 };
            vm.msgDirect = { page: 1, hasMore: false };
            vm.messageStayDates = null;
            vm.reservationStayDates = null;
            vm.showLoadEarlier = false;
            vm.editingPhone = false;
            vm.phoneEditValue = '';
            closeQuickReplyPicker();
            closeComposerTranslate();
            closeMessageTranslatePopup();
            resetPhonePicker();
            unbindMessagesScroll();
            applyThreadStayData(group);
            setDefaultComposerChannel(group);
            syncThreadUrlParam(group);
            broadcastActiveConversation(group);

            if (switchingThread || openingThread) {
                restoreComposerDraft(nextKey);
            }

            // Always mark-as-read on open so escalation_acknowledged is set even when
            // the local unread badge was already cleared (or a prior ack attempt failed).
            var markPromise = markGroupRead(group, true);

            loadMessages();

            if (group.confirmation_number) {
                // Wait for mark-as-read so messaging context does not revive the badge.
                markPromise.finally(function () {
                    if (!vm.selectedThread ||
                        vm.selectedThread.confirmation_number !== group.confirmation_number) {
                        return;
                    }

                    refreshMessagingContext(group.confirmation_number);
                });
            }

            if (group.confirmation_number || group.thread_id || group.booking_id) {
                loadReservationStayDates();
            }

            $timeout(function () {
                resizeReplyTextarea();
            });
        }

        function syncThreadUrlParam(group)
        {
            var stateName = ($state.current && $state.current.name) || '';
            var targetConfirmation = group && group.confirmation_number ? group.confirmation_number : null;

            if (
                stateName !== 'app.guest-message-center.messages' &&
                stateName !== 'app.guest-message-center.archive'
            ) {
                return;
            }

            if (($stateParams.confirmation_number || null) === targetConfirmation) {
                return;
            }

            $state.go(stateName, {
                confirmation_number: targetConfirmation
            }, {
                notify: false,
                location: 'replace',
                inherit: true
            });

            $stateParams.confirmation_number = targetConfirmation || '';
        }

        function refreshMessagingContext(confirmationNumber)
        {
            if (!confirmationNumber || !useUnifiedApi) {
                return;
            }

            var params = { confirmation_number: confirmationNumber };

            if (vm.subHotelId) {
                params.sub_hotel_id = vm.subHotelId;
            }

            messageCenterService.getReservationMessagingContext(params).then(function (response) {
                if (!response || response.success === false || !response.data) {
                    return;
                }

                if (!vm.selectedThread || vm.selectedThread.confirmation_number !== confirmationNumber) {
                    return;
                }

                var updated = finalizeUnifiedThread(response.data);

                // Open chat is considered read — never reintroduce unread from a stale response.
                zeroUnreadPayload(updated);

                if (applyChannelEnabledFlags(response)) {
                    refreshChannelOptions();
                }

                applyPhoneOptions(
                    (response.data && response.data.phone_options) ||
                    response.phone_options ||
                    updated.phone_options
                );

                angular.extend(vm.selectedThread, updated);
                vm.selectedThread._chips = computeChips(vm.selectedThread);
                clearLocalUnread(vm.selectedThread);
                upsertUnifiedThread(vm.selectedThread);
                setDefaultComposerChannel(vm.selectedThread);

                // Inbound guest traffic unarchives on the server — drop from Archive list.
                if (vm.isArchiveView && !updated.is_archived) {
                    removeConfirmationFromLists(confirmationNumber);
                }
            });
        }

        function applyPhoneOptions(options)
        {
            options = options || {};
            vm.phoneOptions = {
                customer: String(options.customer || '').replace(/^\s+|\s+$/g, ''),
                traveler: String(options.traveler || '').replace(/^\s+|\s+$/g, '')
            };
            resetSendToSelection();
        }

        function resetPhonePicker()
        {
            vm.phoneOptions = { customer: '', traveler: '' };
            vm.sendToSource = '';
            vm.sendToCustomPhone = '';
            vm.phoneConflictMessage = '';
        }

        function resetSendToSelection()
        {
            vm.sendToSource = '';
            vm.sendToCustomPhone = '';
            vm.phoneConflictMessage = '';

            if (vm.phoneOptions.customer && !vm.phoneOptions.traveler) {
                vm.sendToSource = 'customer';
            } else if (vm.phoneOptions.traveler && !vm.phoneOptions.customer) {
                vm.sendToSource = 'traveler';
            }
        }

        function setSendToSource(source)
        {
            vm.sendToSource = source;
            vm.phoneConflictMessage = '';
        }

        function getSelectedStartPhone()
        {
            var existingDirectPhone = getExistingDirectPhone(
                vm.selectedThread,
                vm.composerChannel
            );

            // Keep SMS and WhatsApp on the same number once either channel exists.
            if (existingDirectPhone) {
                return existingDirectPhone;
            }

            if (vm.sendToSource === 'customer') {
                return vm.phoneOptions.customer || '';
            }

            if (vm.sendToSource === 'traveler') {
                return vm.phoneOptions.traveler || '';
            }

            if (vm.sendToSource === 'custom') {
                return phoneFormatService.getValidE164(
                    getCustomSendToInputName(),
                    vm.sendToCustomPhone
                );
            }

            return '';
        }

        /**
         * Phone already linked to an SMS/WhatsApp conversation for this reservation.
         * Prefer the target channel, then the other direct channel, then guest_phone.
         */
        function getExistingDirectPhone(group, preferredChannel)
        {
            group = group || vm.selectedThread;

            if (!group) {
                return '';
            }

            var channels = group.channels || {};
            var preferred = preferredChannel === 'whatsapp' ? 'whatsapp' : (preferredChannel === 'sms' ? 'sms' : '');
            var other = preferred === 'whatsapp' ? 'sms' : (preferred === 'sms' ? 'whatsapp' : '');
            var phone = '';

            if (preferred && channels[preferred] && channels[preferred].guest_phone_e164) {
                phone = channels[preferred].guest_phone_e164;
            } else if (other && channels[other] && channels[other].guest_phone_e164) {
                phone = channels[other].guest_phone_e164;
            } else if (group._direct && group._direct.guest_phone) {
                phone = group._direct.guest_phone;
            } else if (group.guest_phone) {
                // Only reuse top-level guest_phone when a direct channel already exists.
                if ((channels.sms && channels.sms.conversation_sid) ||
                    (channels.whatsapp && channels.whatsapp.conversation_sid) ||
                    (group._direct && group._direct.conversation_sid)) {
                    phone = group.guest_phone;
                }
            }

            return String(phone || '').replace(/^\s+|\s+$/g, '');
        }

        function needsPhonePicker()
        {
            var channel = vm.composerChannel;

            if (!channel || !needsDirectChannelStart(channel)) {
                return false;
            }

            // Don't ask again if SMS/WhatsApp already has a number on this stay.
            return !getExistingDirectPhone(vm.selectedThread, channel);
        }

        function isPhoneLinkedError(response)
        {
            if (!response) {
                return false;
            }

            return response.code === 'phone_linked_to_other_reservation' ||
                response.code === 'phone_linked_to_staff_contact' ||
                (response.data && (
                    response.data.code === 'phone_linked_to_other_reservation' ||
                    response.data.code === 'phone_linked_to_staff_contact'
                ));
        }

        function handlePhoneLinkedError(response)
        {
            var message = (response && response.message) ||
                (response && response.data && response.data.message) ||
                'This phone number is already linked to another conversation. Use another number.';

            vm.phoneConflictMessage = message;
            toastMessage.showSimpleToast(message, 'error-toast');
            return message;
        }

        function upsertUnifiedThread(thread)
        {
            if (!thread) {
                return;
            }

            var list = vm._allUnifiedThreads || [];
            var key = getThreadKey(thread);
            var i;
            var existing = null;

            for (i = 0; i < list.length; i++) {
                if (getThreadKey(list[i]) === key) {
                    existing = list[i];
                    list.splice(i, 1);
                    break;
                }
            }

            if (existing) {
                angular.extend(existing, thread);
                thread = existing;
            }

            // Always pin most-recently updated threads at the front before sort.
            list.unshift(thread);
            vm._allUnifiedThreads = list;
            applyUnifiedTabFilter();
        }

        function buildSmsMessageParams(directThread, page)
        {
            var params = {
                conversation_sid: directThread.conversation_sid,
                page: page,
                limit: vm.messageLimit
            };

            var confirmationNumber = directThread.confirmation_number ||
                (vm.selectedThread && vm.selectedThread.confirmation_number) ||
                '';

            if (confirmationNumber) {
                params.confirmation_number = confirmationNumber;
            }

            if (vm.subHotelId) {
                params.sub_hotel_id = vm.subHotelId;
            }

            return params;
        }

        function normalizeUnifiedMessages(list)
        {
            var out = [];
            var i;

            for (i = 0; i < (list || []).length; i++) {
                var message = angular.copy(list[i]);
                var channel = message.channel || 'ota';

                if (message.sender === 'hotel') {
                    message.sender = 'property';
                }

                message.channel = channel;
                message._channel = channel;
                message._sortTs = parseTs(message.inserted_at);
                message._uid = channel + ':' + (message.id || message.local_id || (message._sortTs + ':' + i));
                out.push(message);
            }

            return out;
        }

        function loadUnifiedMessages(page, append)
        {
            var group = vm.selectedThread;
            var params = {
                confirmation_number: group.confirmation_number,
                page: page || 1,
                limit: vm.messageLimit,
                order: 'desc'
            };

            if (vm.subHotelId) {
                params.sub_hotel_id = vm.subHotelId;
            }

            return messageCenterService.getUnifiedMessages(params).then(function (response) {
                if (!response || response.success === false) {
                    if (isLocalStorageUnavailable(response)) {
                        useUnifiedApi = false;
                        vm.localStorageUnavailable = true;
                    }

                    return { ok: false, response: response };
                }

                var data = normalizeUnifiedMessages(response.data || []);
                var added = [];
                vm.msgPage = page || 1;
                vm.msgTotal = (response.meta && response.meta.total) ? response.meta.total : data.length;

                if (response.timezone) {
                    vm.chatTimezone = response.timezone;
                    if (vm.selectedThread) {
                        vm.selectedThread.timezone = response.timezone;
                    }
                }

                if (append) {
                    added = addMessages(data);
                } else {
                    vm.messages = [];
                    added = addMessages(data);
                }

                return { ok: true, data: data, added: added };
            }, function () {
                useUnifiedApi = false;
                return { ok: false };
            });
        }

        function loadLegacyMessages()
        {
            var group = vm.selectedThread;
            var promises = [];

            if (group._ota || (group.channels && group.channels.ota)) {
                var otaId = (group._ota && group._ota.thread_id) ||
                    (group.channels.ota && group.channels.ota.message_thread_id);
                if (otaId) {
                    promises.push(
                        messageCenterService.getThreadMessages(otaId, 1, vm.messageLimit)
                            .then(function (response) {
                                return { channel: 'ota', response: response };
                            })
                    );
                }
            }

            var smsSid = (group._direct && group._direct.channel !== 'whatsapp' && group._direct.conversation_sid) ||
                (group.channels && group.channels.sms && group.channels.sms.conversation_sid);
            var waSid = (group._direct && group._direct.channel === 'whatsapp' && group._direct.conversation_sid) ||
                (group.channels && group.channels.whatsapp && group.channels.whatsapp.conversation_sid);

            if (smsSid) {
                promises.push(
                    messageCenterService.getSmsThreadMessages({
                        conversation_sid: smsSid,
                        page: 1,
                        limit: vm.messageLimit,
                        confirmation_number: group.confirmation_number || '',
                        sub_hotel_id: vm.subHotelId || undefined
                    }).then(function (response) {
                        return { channel: 'sms', response: response };
                    })
                );
            }

            if (waSid) {
                promises.push(
                    messageCenterService.getSmsThreadMessages({
                        conversation_sid: waSid,
                        page: 1,
                        limit: vm.messageLimit,
                        confirmation_number: group.confirmation_number || '',
                        sub_hotel_id: vm.subHotelId || undefined
                    }).then(function (response) {
                        return { channel: 'whatsapp', response: response };
                    })
                );
            }

            if (!promises.length) {
                vm.loadingMessages = false;
                schedulePendingMessagesRefresh();
                return;
            }

            $q.all(promises).then(function (results) {
                vm.loadingMessages = false;

                if (getThreadKey(vm.selectedThread) !== vm.selectedKey) {
                    schedulePendingMessagesRefresh();
                    return;
                }

                var collected = [];
                var hadError = false;

                results.forEach(function (result) {
                    var response = result.response;

                    if (!response || response.success === false) {
                        hadError = true;
                        return;
                    }

                    collected = collected.concat(normalizeChannelMessages(response.data || [], result.channel));

                    if (result.channel === 'ota') {
                        vm.msgOta.total = (response.meta && response.meta.total) ? response.meta.total : collected.length;
                    } else {
                        vm.msgDirect.hasMore = (response.data || []).length >= vm.messageLimit;
                    }
                });

                if (hadError && !collected.length) {
                    toastMessage.showSimpleToast('Unable to load messages.', 'error-toast');
                    schedulePendingMessagesRefresh();
                    return;
                }

                vm.messages = [];
                addMessages(collected);
                setDefaultComposerChannel(vm.selectedThread);
                bindMessagesScroll();
                scrollMessagesToBottom();
                updateMessageStayDates(vm.messages);
                updateLoadEarlierVisibility();
                schedulePendingMessagesRefresh();
            });
        }

        function loadMessages()
        {
            var group = vm.selectedThread;

            if (!group) {
                return;
            }

            vm.loadingMessages = true;

            if (useUnifiedApi && group.confirmation_number) {
                loadUnifiedMessages(1, false).then(function (result) {
                    if (result && result.ok) {
                        vm.loadingMessages = false;

                        if (getThreadKey(vm.selectedThread) !== vm.selectedKey) {
                            schedulePendingMessagesRefresh();
                            return;
                        }

                        setDefaultComposerChannel(vm.selectedThread);
                        bindMessagesScroll();
                        scrollMessagesToBottom();
                        updateMessageStayDates(vm.messages);
                        updateLoadEarlierVisibility();
                        schedulePendingMessagesRefresh();
                        return;
                    }

                    loadLegacyMessages();
                });
                return;
            }

            loadLegacyMessages();
        }

        function hasMoreMessages()
        {
            var group = vm.selectedThread;

            if (!group) {
                return false;
            }

            if (useUnifiedApi && group.confirmation_number) {
                return vm.messages.length < vm.msgTotal;
            }

            var otaMore = group._ota && countMessagesByChannel('ota') < vm.msgOta.total;
            var dirMore = group._direct && vm.msgDirect.hasMore;
            var smsMore = group.channels && group.channels.sms && vm.msgDirect.hasMore;

            return !!(otaMore || dirMore || smsMore);
        }

        function loadMoreMessages()
        {
            if (vm.loadingMessages || !hasMoreMessages()) {
                return;
            }

            var group = vm.selectedThread;
            var container = document.getElementById('gmc-messages-container');
            var previousScrollHeight = container ? container.scrollHeight : 0;

            if (useUnifiedApi && group.confirmation_number) {
                vm.loadingMessages = true;
                loadUnifiedMessages(vm.msgPage + 1, true).then(function (result) {
                    vm.loadingMessages = false;

                    if (!result || !result.ok) {
                        return;
                    }

                    if (getThreadKey(vm.selectedThread) !== vm.selectedKey) {
                        return;
                    }

                    preserveMessagesScroll(previousScrollHeight);
                    updateMessageStayDates(vm.messages);
                    updateLoadEarlierVisibility();
                });
                return;
            }

            var promises = [];

            if (group._ota && countMessagesByChannel('ota') < vm.msgOta.total) {
                vm.msgOta.page += 1;
                promises.push(
                    messageCenterService.getThreadMessages(group._ota.thread_id, vm.msgOta.page, vm.messageLimit)
                        .then(function (response) {
                            return { channel: 'ota', response: response };
                        })
                );
            }

            if (group._direct && vm.msgDirect.hasMore) {
                vm.msgDirect.page += 1;
                promises.push(
                    messageCenterService.getSmsThreadMessages(buildSmsMessageParams(group._direct, vm.msgDirect.page))
                        .then(function (response) {
                            return { channel: 'direct', response: response };
                        })
                );
            }

            if (!promises.length) {
                return;
            }

            vm.loadingMessages = true;

            $q.all(promises).then(function (results) {
                vm.loadingMessages = false;

                if (getThreadKey(vm.selectedThread) !== vm.selectedKey) {
                    return;
                }

                var collected = [];

                results.forEach(function (result) {
                    var response = result.response;

                    if (!response || response.success === false) {
                        if (result.channel === 'ota') {
                            vm.msgOta.page -= 1;
                        } else {
                            vm.msgDirect.page -= 1;
                        }
                        return;
                    }

                    var data = normalizeChannelMessages(response.data || [], result.channel);
                    collected = collected.concat(data);

                    if (result.channel === 'ota') {
                        vm.msgOta.total = (response.meta && response.meta.total) ? response.meta.total : vm.msgOta.total;
                    } else {
                        vm.msgDirect.hasMore = data.length >= vm.messageLimit;
                    }
                });

                addMessages(collected);
                preserveMessagesScroll(previousScrollHeight);
                updateMessageStayDates(vm.messages);
                updateLoadEarlierVisibility();
            });
        }

        // ---------------------------------------------------------------------
        // Stay-date resolution (unchanged behavior, reads from group fields)
        // ---------------------------------------------------------------------

        function applyThreadStayData(group)
        {
            if (!group) {
                return;
            }

            var checkIn = getThreadCheckIn(group);
            var checkOut = getThreadCheckOut(group);

            if (!checkIn && !checkOut && !group.room_stay_status) {
                return;
            }

            vm.reservationStayDates = {
                checkin_date: checkIn || null,
                checkout_date: checkOut || null,
                room_stay_status: group.room_stay_status || null
            };
        }

        function loadReservationStayDates()
        {
            if (!vm.selectedThread) {
                return;
            }

            if (vm.reservationStayDates && vm.reservationStayDates._loaded) {
                return;
            }

            if (getThreadCheckIn(vm.selectedThread) &&
                getThreadCheckOut(vm.selectedThread) &&
                vm.selectedThread.room_stay_status) {
                return;
            }

            var params = {
                confirmation_number: vm.selectedThread.confirmation_number || '',
                message_thread_id: vm.selectedThread.thread_id || '',
                booking_id: vm.selectedThread.booking_id || ''
            };

            if (!params.confirmation_number && !params.message_thread_id && !params.booking_id) {
                return;
            }

            var confirmationNumber = vm.selectedThread.confirmation_number;

            messageCenterService.getThreadStayInfo(params).then(function (response) {
                if (!vm.selectedThread) {
                    return;
                }

                if (response && response.success !== false && response.data) {
                    applyReservationStayData(response.data);
                    return;
                }

                if (!confirmationNumber) {
                    vm.reservationStayDates = { _loaded: true };
                    return;
                }

                loadReservationStayDatesFromOrder(confirmationNumber);
            }, function () {
                if (confirmationNumber) {
                    loadReservationStayDatesFromOrder(confirmationNumber);
                } else {
                    vm.reservationStayDates = { _loaded: true };
                }
            });
        }

        function loadReservationStayDatesFromOrder(confirmationNumber)
        {
            eCommerceService.fetchOrder({
                confirmation_number: confirmationNumber
            }).then(function (response) {
                if (!vm.selectedThread || vm.selectedThread.confirmation_number !== confirmationNumber) {
                    return;
                }

                if (!response || !response.success || !response.reservation) {
                    vm.reservationStayDates = { _loaded: true };
                    return;
                }

                var reservation = response.reservation;

                applyReservationStayData({
                    checkin_date: reservation.room_stay_from ||
                        reservation.arrival_time ||
                        reservation.arrival_date ||
                        null,
                    checkout_date: reservation.room_stay_to ||
                        reservation.departure_time ||
                        reservation.departure_date ||
                        null,
                    room_stay_status: reservation.room_stay_status ||
                        reservation.order_status ||
                        reservation.reservation_status_type ||
                        null,
                    source_of_creation: reservation.source_of_creation ||
                        reservation.booking_source ||
                        null
                });
            }, function () {
                if (vm.selectedThread && vm.selectedThread.confirmation_number === confirmationNumber) {
                    vm.reservationStayDates = { _loaded: true };
                }
            });
        }

        function applyReservationStayData(data)
        {
            if (!vm.selectedThread || !data) {
                return;
            }

            vm.reservationStayDates = {
                checkin_date: data.checkin_date || null,
                checkout_date: data.checkout_date || null,
                room_stay_status: data.room_stay_status || null,
                _loaded: true
            };

            if (data.checkin_date) {
                vm.selectedThread.room_stay_from = data.checkin_date;
                vm.selectedThread.checkin_date = data.checkin_date;
            }

            if (data.checkout_date) {
                vm.selectedThread.room_stay_to = data.checkout_date;
                vm.selectedThread.checkout_date = data.checkout_date;
            }

            if (data.room_stay_status) {
                vm.selectedThread.room_stay_status = data.room_stay_status;
            }

            if (data.source_of_creation || data.booking_source || data.provider) {
                vm.selectedThread.source_of_creation = data.source_of_creation ||
                    data.booking_source ||
                    data.provider ||
                    vm.selectedThread.source_of_creation;
                vm.selectedThread._chips = computeChips(vm.selectedThread);
                upsertUnifiedThread(vm.selectedThread);
            }
        }

        // ---------------------------------------------------------------------
        // Scroll handling
        // ---------------------------------------------------------------------

        function bindMessagesScroll()
        {
            $timeout(function () {
                var container = document.getElementById('gmc-messages-container');

                if (!container || container._gmcScrollBound) {
                    return;
                }

                container._gmcScrollBound = true;
                messagesScrollHandler = function () {
                    $scope.$applyAsync(function () {
                        updateLoadEarlierVisibility();
                    });
                };
                container.addEventListener('scroll', messagesScrollHandler);
            }, 0);
        }

        function unbindMessagesScroll()
        {
            var container = document.getElementById('gmc-messages-container');

            if (container && messagesScrollHandler) {
                container.removeEventListener('scroll', messagesScrollHandler);
                container._gmcScrollBound = false;
                messagesScrollHandler = null;
            }
        }

        function bindThreadsScroll()
        {
            $timeout(function () {
                var container = document.getElementById('gmc-thread-scroll');

                if (!container || container._gmcThreadsScrollBound) {
                    return;
                }

                container._gmcThreadsScrollBound = true;
                threadsScrollHandler = function () {
                    if (vm.loadingThreads || !hasMoreThreads()) {
                        return;
                    }

                    var remaining = container.scrollHeight - container.scrollTop - container.clientHeight;

                    if (remaining < THREAD_SCROLL_LOAD_PX) {
                        $scope.$applyAsync(function () {
                            loadMoreThreads();
                        });
                    }
                };
                container.addEventListener('scroll', threadsScrollHandler);
            }, 0);
        }

        function unbindThreadsScroll()
        {
            var container = document.getElementById('gmc-thread-scroll');

            if (container && threadsScrollHandler) {
                container.removeEventListener('scroll', threadsScrollHandler);
                container._gmcThreadsScrollBound = false;
                threadsScrollHandler = null;
            } else {
                threadsScrollHandler = null;
            }
        }

        function updateLoadEarlierVisibility()
        {
            var container = document.getElementById('gmc-messages-container');

            if (!container || !hasMoreMessages()) {
                vm.showLoadEarlier = false;
                return;
            }

            vm.showLoadEarlier = container.scrollTop <= 60;
        }

        function preserveMessagesScroll(previousScrollHeight)
        {
            $timeout(function () {
                var container = document.getElementById('gmc-messages-container');

                if (!container) {
                    return;
                }

                container.scrollTop = container.scrollHeight - previousScrollHeight;
                updateLoadEarlierVisibility();
            }, 0);
        }

        function updateMessageStayDates(messages)
        {
            vm.messageStayDates = null;

            if (!messages || !messages.length) {
                return;
            }

            for (var i = 0; i < messages.length; i++) {
                var details = getInquiryDetails(messages[i]);

                if (details && (details.checkin_date || details.checkout_date)) {
                    vm.messageStayDates = details;
                    return;
                }
            }
        }

        function scrollMessagesToBottom()
        {
            $timeout(function () {
                var container = document.getElementById('gmc-messages-container');
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }

                // Second pass after Angular paints the new bubble.
                $timeout(function () {
                    var el = document.getElementById('gmc-messages-container');
                    if (el) {
                        el.scrollTop = el.scrollHeight;
                    }
                }, 50);
            }, 0);
        }

        function isMessagesAtBottom()
        {
            var container = document.getElementById('gmc-messages-container');

            if (!container) {
                return true;
            }

            return (container.scrollHeight - container.scrollTop - container.clientHeight) < 80;
        }

        // ---------------------------------------------------------------------
        // Composer + send routing (explicit channel picker)
        // ---------------------------------------------------------------------

        function isOptedOut(group)
        {
            group = group || vm.selectedThread;
            return !!(group && group.messaging_opt_out);
        }

        function getOptOutBannerText()
        {
            return 'Reservation opted out of direct messaging.';
        }

        function coerceAiMode(value)
        {
            return value === true || value === 1 || value === '1';
        }

        function normalizeLastSender(sender)
        {
            return sender === 'hotel' ? 'property' : (sender || 'guest');
        }

        function isAiModeOn(group)
        {
            group = group || vm.selectedThread;
            return !!(group && coerceAiMode(group.ai_mode));
        }

        function setAiModeLocal(confirmation, aiMode)
        {
            var mode = coerceAiMode(aiMode);

            if (!confirmation) {
                return;
            }

            angular.forEach([vm.selectedThread]
                .concat(vm.threads || [], vm._allUnifiedThreads || []), function (group) {
                if (!group || group.confirmation_number !== confirmation) {
                    return;
                }

                group.ai_mode = mode;

                if (group._direct) {
                    group._direct.ai_mode = mode;
                }

                if (group._ota) {
                    group._ota.ai_mode = mode;
                }
            });

            messageCenterNavBadgeService.setReservationAiModeKnown(confirmation, mode);
        }

        function handleAiModeSendBlocked(response)
        {
            var message = (response && response.message) ||
                'AI Mode is on for this reservation. Turn AI Mode off before sending a staff message.';

            if (vm.selectedThread) {
                vm.selectedThread.ai_mode = true;
            }

            toastMessage.showSimpleToast(message, 'error-toast');
            vm.highlightAiToggle = true;
            $timeout(function () {
                vm.highlightAiToggle = false;
            }, 2800);
        }

        function isAiModeActiveError(response)
        {
            return !!(response && response.code === 'ai_mode_active');
        }

        function appendAiModeNoticeIfOpen(confirmation, messageObj)
        {
            var notice;

            if (!confirmation || !messageObj || typeof messageObj !== 'object' ||
                !isSelectedConfirmation(confirmation)) {
                return;
            }

            notice = normalizeUnifiedMessages([angular.copy(messageObj)])[0];

            if (!notice) {
                return;
            }

            notice.sender = notice.sender || 'system';

            if (appendSentMessage(notice)) {
                scrollMessagesToBottom();
            }
        }

        function toggleAiMode()
        {
            var group = vm.selectedThread;
            var previous;
            var next;
            var payload;

            if (!group || !group.confirmation_number || vm.updatingAiMode) {
                return;
            }

            previous = isAiModeOn(group);
            next = !previous;
            payload = {
                confirmation_number: group.confirmation_number,
                ai_mode: next
            };

            if (vm.subHotelId) {
                payload.sub_hotel_id = vm.subHotelId;
            }

            setAiModeLocal(group.confirmation_number, next);
            vm.updatingAiMode = true;

            messageCenterService.setReservationAiMode(payload).then(function (response) {
                var data;
                var mode;
                var noticeText;

                vm.updatingAiMode = false;

                if (!response || response.success === false) {
                    setAiModeLocal(group.confirmation_number, previous);
                    toastMessage.showSimpleToast(
                        (response && response.message) || 'Unable to update AI Mode.',
                        'error-toast'
                    );
                    return;
                }

                data = response.data || {};
                mode = data.ai_mode != null ? data.ai_mode : next;
                setAiModeLocal(group.confirmation_number, mode);

                if (data.message && typeof data.message === 'object') {
                    appendAiModeNoticeIfOpen(group.confirmation_number, data.message);
                } else if (data.notice_text) {
                    noticeText = String(data.notice_text).trim();

                    if (noticeText) {
                        appendAiModeNoticeIfOpen(group.confirmation_number, {
                            sender: 'system',
                            message: noticeText,
                            event_type: coerceAiMode(mode) ? 'ai_mode_on' : 'ai_mode_off',
                            confirmation_number: group.confirmation_number,
                            channel: 'sms'
                        });
                    }
                }
            }, function (error) {
                var err = (error && error.data) ? error.data : null;

                vm.updatingAiMode = false;
                setAiModeLocal(group.confirmation_number, previous);
                toastMessage.showSimpleToast(
                    (err && err.message) || 'Unable to update AI Mode.',
                    'error-toast'
                );
            });
        }

        function getOtaChannel(group)
        {
            group = group || vm.selectedThread;
            if (!group) {
                return null;
            }
            return (group.channels && group.channels.ota) || null;
        }

        function getDirectChannel(group, channel)
        {
            group = group || vm.selectedThread;
            if (!group || !group.channels) {
                return null;
            }
            return group.channels[channel] || null;
        }

        function getOtaThreadId(group)
        {
            var ch = getOtaChannel(group);
            if (ch && ch.message_thread_id) {
                return ch.message_thread_id;
            }
            if (group && group._ota && group._ota.thread_id) {
                return group._ota.thread_id;
            }
            return group && group.thread_id ? group.thread_id : '';
        }

        function getConversationSid(group, channel)
        {
            var ch = getDirectChannel(group, channel);
            if (ch && ch.conversation_sid) {
                return ch.conversation_sid;
            }
            if (group && group._direct && (!channel || group._direct.channel === channel ||
                (!group._direct.channel && channel === 'sms'))) {
                return group._direct.conversation_sid;
            }
            return '';
        }

        function hasGuestPhone(group)
        {
            return !!getThreadPhone(group || vm.selectedThread);
        }

        function isChannelEnabled(channel)
        {
            var group = vm.selectedThread;

            if (!group || !channel) {
                return false;
            }

            if (isOptedOut(group) && channel !== 'ota') {
                return false;
            }

            if (channel === 'ota') {
                return !!(vm.otaEnabled && vm.canSendOta && getOtaThreadId(group) && !(getOtaChannel(group) && getOtaChannel(group).is_closed) && !(group._ota && group._ota.is_closed));
            }

            if (channel === 'sms' || channel === 'whatsapp') {
                if (!vm.canSendDirect || !showDirectFeatures() || !isDirectChannelConfigured(channel)) {
                    return false;
                }

                // Existing thread, or can start once staff picks a phone.
                return !!getConversationSid(group, channel) || !isOptedOut(group);
            }

            return false;
        }

        function needsDirectChannelStart(channel)
        {
            var group = vm.selectedThread;
            return !!(group && group.confirmation_number &&
                (channel === 'sms' || channel === 'whatsapp') &&
                !getConversationSid(group, channel) && !isOptedOut(group));
        }

        function refreshChannelOptions()
        {
            var options = [];
            var group = vm.selectedThread;

            if (!group) {
                vm.channelOptions = options;
                return options;
            }

            if (showOtaFeatures() && (getOtaThreadId(group) || (group.channels && group.channels.ota))) {
                options.push({
                    id: 'ota',
                    label: getProviderLabel(extractSourceOfCreation(group) || group.provider) || 'OTA',
                    enabled: isChannelEnabled('ota')
                });
            }

            if (showDirectFeatures() && vm.canSendDirect) {
                if (vm.smsEnabled) {
                    options.push({
                        id: 'sms',
                        label: 'SMS',
                        enabled: isChannelEnabled('sms')
                    });
                }

                if (vm.whatsappEnabled) {
                    options.push({
                        id: 'whatsapp',
                        label: 'WhatsApp',
                        enabled: isChannelEnabled('whatsapp')
                    });
                }
            }

            vm.channelOptions = options;
            return options;
        }

        function getChannelOptions()
        {
            return vm.channelOptions || [];
        }

        function getPreferredDirectChannel()
        {
            if (vm.smsEnabled) {
                return 'sms';
            }

            if (vm.whatsappEnabled) {
                return 'whatsapp';
            }

            return showOtaFeatures() ? 'ota' : 'sms';
        }

        function setDefaultComposerChannel(group)
        {
            if (!group) {
                if (showDirectFeatures()) {
                    vm.composerChannel = getPreferredDirectChannel();
                } else if (showOtaFeatures()) {
                    vm.composerChannel = 'ota';
                } else {
                    vm.composerChannel = '';
                }
                refreshChannelOptions();
                return;
            }

            // Always reply on the channel of the latest message (guest or hotel).
            var preferred = resolveLastMessageChannel(group);

            if (preferred && isChannelEnabled(preferred)) {
                vm.composerChannel = preferred;
                refreshChannelOptions();
                return;
            }

            if (isChannelEnabled('sms')) {
                vm.composerChannel = 'sms';
            } else if (isChannelEnabled('whatsapp')) {
                vm.composerChannel = 'whatsapp';
            } else if (isChannelEnabled('ota')) {
                vm.composerChannel = 'ota';
            } else if (showDirectFeatures()) {
                vm.composerChannel = getPreferredDirectChannel();
            } else if (showOtaFeatures()) {
                vm.composerChannel = 'ota';
            } else {
                vm.composerChannel = '';
            }

            refreshChannelOptions();
        }

        /**
         * Prefer the newest message channel in the open chat (any sender),
         * then fall back to channel thread rows by last_message_at.
         */
        function resolveLastMessageChannel(group)
        {
            var i;
            var message;
            var channel;
            var channels;
            var names;
            var bestChannel = '';
            var bestTs = 0;
            var ts;

            for (i = (vm.messages || []).length - 1; i >= 0; i--) {
                message = vm.messages[i];

                if (!message || message.sender === 'system') {
                    continue;
                }

                channel = normalizeComposerChannel(message._channel || message.channel, group);

                if (channel) {
                    return channel;
                }
            }

            channels = (group && group.channels) || {};
            names = ['sms', 'whatsapp', 'ota'];

            for (i = 0; i < names.length; i++) {
                channel = names[i];

                if (!channels[channel] || !channels[channel].last_message_at) {
                    continue;
                }

                ts = parseTs(channels[channel].last_message_at) || 0;

                if (ts >= bestTs) {
                    bestTs = ts;
                    bestChannel = channel;
                }
            }

            if (bestChannel) {
                return bestChannel;
            }

            return normalizeComposerChannel(group && (group._lastChannel || group.channel), group);
        }

        function normalizeComposerChannel(channel, group)
        {
            if (!channel) {
                return '';
            }

            if (channel === 'direct') {
                return (group && group.channel === 'whatsapp') ? 'whatsapp' : 'sms';
            }

            if (channel === 'sms' || channel === 'whatsapp' || channel === 'ota') {
                return channel;
            }

            return '';
        }

        function setComposerChannel(channel)
        {
            if (!channel) {
                return;
            }

            vm.composerChannel = channel;
            vm.phoneConflictMessage = '';
            if (channel === 'ota') {
                clearPendingMedia();
            }
            refreshChannelOptions();
        }

        function canAttachImage()
        {
            var channel = getActiveSendChannel();
            return channel === 'sms' || channel === 'whatsapp';
        }

        function hasSendableContent()
        {
            if (hasComposerBodyForTranslate()) {
                return true;
            }

            return !!(vm.pendingMedia &&
                vm.pendingMedia.sid &&
                !vm.pendingMedia.uploading &&
                !vm.pendingMedia.error);
        }

        function hasComposerBodyForTranslate()
        {
            return messageCenterComposerSignature.hasBodyBeyondSignature(vm.replyText);
        }

        function getComposerStaffName()
        {
            return messageCenterComposerSignature.getStaffDisplayName();
        }

        function syncComposerSignature(options)
        {
            var name = getComposerStaffName();
            var opts = options || {};

            if (!name) {
                return;
            }

            var next = messageCenterComposerSignature.ensureInComposer(vm.replyText, name);

            if (next !== String(vm.replyText || '')) {
                vm._composerSignatureSync = true;
                vm.replyText = next;
            }

            $timeout(function () {
                var textarea = getReplyTextarea();

                if (opts.placeCaret !== false) {
                    messageCenterComposerSignature.placeCaretBeforeSignature(textarea, name);
                } else if (textarea && opts.focus) {
                    textarea.focus();
                }

                resizeReplyTextarea();
                vm._composerSignatureSync = false;
            }, 0);
        }

        function onReplyFocus()
        {
            if (!canSendToSelected() || isOptedOut() || isAiModeOn()) {
                return;
            }

            var name = getComposerStaffName();
            var text = String(vm.replyText || '');

            // Seed signature only on an empty composer. If the user cleared it, leave it off.
            if (!text.replace(/^\s+|\s+$/g, '')) {
                syncComposerSignature({ placeCaret: true });
                return;
            }

            if (!name) {
                return;
            }

            var parts = messageCenterComposerSignature.split(text, name);

            if (!parts.hasSignature) {
                return;
            }

            $timeout(function () {
                messageCenterComposerSignature.placeCaretBeforeSignature(getReplyTextarea(), name);
            }, 0);
        }

        function onReplyTextChange()
        {
            resizeReplyTextarea();

            if (vm._composerSignatureSync) {
                return;
            }

            var name = getComposerStaffName();
            var body = messageCenterComposerSignature.split(vm.replyText, name).body;

            if (body !== vm._lastComposerBodyForTranslation) {
                vm._lastComposerBodyForTranslation = body;
                clearReplyTranslation();
            }
        }

        function getPendingMediaSid()
        {
            if (!vm.pendingMedia || vm.pendingMedia.uploading || vm.pendingMedia.error) {
                return '';
            }

            return vm.pendingMedia.sid || '';
        }

        function clearPendingMedia()
        {
            if (vm.pendingMedia && vm.pendingMedia.previewUrl) {
                try {
                    URL.revokeObjectURL(vm.pendingMedia.previewUrl);
                } catch (e) {
                    // ignore
                }
            }

            vm.pendingMedia = null;
            vm.uploadingMedia = false;

            var input = document.getElementById('gmc-attach-image-input');
            if (input) {
                input.value = '';
            }
        }

        function canAcceptImageDrop()
        {
            return canAttachImage() && canSendToSelected() && !vm.sendingMessage && !vm.uploadingMedia;
        }

        function onComposerDrop(event)
        {
            var files;
            var file;
            var i;

            vm.composerDragOver = false;

            if (!canAcceptImageDrop()) {
                if (!canAttachImage()) {
                    toastMessage.showSimpleToast('Images can only be sent via SMS or WhatsApp.', 'error-toast');
                } else if (!canSendToSelected()) {
                    toastMessage.showSimpleToast(getComposerBlockedMessage() || 'Unable to attach image right now.', 'error-toast');
                }
                return;
            }

            files = event && event.dataTransfer && event.dataTransfer.files;
            if (!files || !files.length) {
                return;
            }

            file = null;
            for (i = 0; i < files.length; i++) {
                if (files[i] && String(files[i].type || '').indexOf('image/') === 0) {
                    file = files[i];
                    break;
                }
            }

            if (!file) {
                toastMessage.showSimpleToast('Only JPEG, PNG, GIF, or WebP images are supported.', 'error-toast');
                return;
            }

            attachImageFile(file);
        }

        function bindAttachInput(input)
        {
            if (!input || input._gmcChangeBound) {
                return;
            }

            input.addEventListener('change', function (event)
            {
                var files = event && event.target && event.target.files;
                var file = files && files.length ? files[0] : null;

                if ($scope.$root && $scope.$root.$$phase) {
                    attachImageFile(file);
                } else {
                    $scope.$apply(function ()
                    {
                        attachImageFile(file);
                    });
                }

                // Allow selecting the same file again later.
                try {
                    input.value = '';
                } catch (e) {
                    // ignore
                }
            });
            input._gmcChangeBound = true;
        }

        function openImagePicker()
        {
            var input;

            if (!canAcceptImageDrop()) {
                return;
            }

            input = document.getElementById('gmc-attach-image-input');
            if (!input) {
                return;
            }

            bindAttachInput(input);

            try {
                input.value = '';
            } catch (e) {
                // ignore
            }

            // Defer click so the cleared value settles before the OS dialog opens.
            $timeout(function ()
            {
                input.click();
            }, 0);
        }

        function onImageSelected(event)
        {
            var files = event && event.target && event.target.files;
            attachImageFile(files && files.length ? files[0] : null);
        }

        function attachImageFile(file)
        {
            var maxBytes = 5 * 1024 * 1024;
            var allowed = {
                'image/jpeg': true,
                'image/jpg': true,
                'image/png': true,
                'image/gif': true,
                'image/webp': true
            };
            var previewUrl;

            if (!file) {
                return;
            }

            if (!canAcceptImageDrop()) {
                return;
            }

            if (!allowed[String(file.type || '').toLowerCase()]) {
                toastMessage.showSimpleToast('Only JPEG, PNG, GIF, or WebP images are supported.', 'error-toast');
                return;
            }

            if (!file.size || file.size > maxBytes) {
                toastMessage.showSimpleToast('Image must be 5 MB or smaller.', 'error-toast');
                return;
            }

            clearPendingMedia();
            previewUrl = URL.createObjectURL(file);
            vm.pendingMedia = {
                file: file,
                name: file.name || 'image',
                previewUrl: previewUrl,
                uploading: true,
                sid: '',
                error: ''
            };
            vm.uploadingMedia = true;

            messageCenterService.uploadSmsMedia(file, vm.subHotelId).then(function (response) {
                var media = findPendingMediaByFile(file);

                if (!media) {
                    return;
                }

                if (vm.pendingMedia && vm.pendingMedia.file === file) {
                    vm.uploadingMedia = false;
                }

                if (!response || response.success === false || !response.data || !response.data.sid) {
                    media.uploading = false;
                    media.error = (response && response.message) || 'Unable to upload image.';
                    toastMessage.showSimpleToast(media.error, 'error-toast');
                    return;
                }

                media.uploading = false;
                media.sid = response.data.sid;
                media.contentType = response.data.content_type || file.type;
            }, function (error) {
                var response = (error && error.data) ? error.data : null;
                var media = findPendingMediaByFile(file);

                if (!media) {
                    return;
                }

                if (vm.pendingMedia && vm.pendingMedia.file === file) {
                    vm.uploadingMedia = false;
                }

                media.uploading = false;
                media.error = (response && response.message) || 'Unable to upload image.';
                toastMessage.showSimpleToast(media.error, 'error-toast');
            });
        }

        function getActiveSendChannel()
        {
            if (!vm.selectedThread) {
                return null;
            }

            if (isChannelEnabled(vm.composerChannel)) {
                return vm.composerChannel;
            }

            return null;
        }

        function canSendToSelected()
        {
            var channel = getActiveSendChannel();

            if (!channel) {
                return false;
            }

            if (isOptedOut()) {
                return false;
            }

            if (isAiModeOn()) {
                return false;
            }

            if (channel === 'ota') {
                return !!getOtaThreadId(vm.selectedThread);
            }

            if (needsDirectChannelStart(channel)) {
                if (vm.sendToSource === 'custom' && !isCustomSendToPhoneValid()) {
                    return false;
                }

                return !!getSelectedStartPhone();
            }

            return !!getConversationSid(vm.selectedThread, channel);
        }

        function getActiveSendChannelLabel()
        {
            var channel = vm.composerChannel || getActiveSendChannel();

            if (channel === 'ota') {
                return getProviderLabel(
                    extractSourceOfCreation(vm.selectedThread) ||
                    (vm.selectedThread && vm.selectedThread.provider)
                ) || 'OTA';
            }

            if (channel === 'whatsapp') {
                return 'WhatsApp';
            }

            if (channel === 'sms') {
                return 'SMS';
            }

            return '';
        }

        function getComposerBlockedMessage()
        {
            var group = vm.selectedThread;

            if (!group) {
                return '';
            }

            if (isOptedOut(group)) {
                return 'Reservation opted out of direct messaging. Opt in to send messages.';
            }

            if (isAiModeOn(group)) {
                return 'AI Mode is on. Turn it off to send a staff message.';
            }

            if (vm.composerChannel === 'ota') {
                if (!getOtaThreadId(group)) {
                    return 'No OTA conversation is linked to this reservation.';
                }
                if ((getOtaChannel(group) && getOtaChannel(group).is_closed) || (group._ota && group._ota.is_closed)) {
                    return 'The OTA conversation is closed.';
                }
            }

            if ((vm.composerChannel === 'sms' || vm.composerChannel === 'whatsapp') &&
                !needsDirectChannelStart(vm.composerChannel) &&
                !getConversationSid(group, vm.composerChannel) &&
                !hasGuestPhone(group)) {
                return 'Add a guest phone number to send via SMS or WhatsApp.';
            }

            if (group._direct && group._direct._smsBlocked) {
                return group._direct._smsBlocked;
            }

            return '';
        }

        function isBlockingSmsError(message)
        {
            if (!message) {
                return false;
            }

            return /past reservation|opted out|not enabled/i.test(message);
        }

        function sendReply()
        {
            if (!vm.selectedThread || vm.sendingMessage || isOptedOut() || isAiModeOn()) {
                return;
            }

            var channel = getActiveSendChannel();

            if ((!channel || !canSendToSelected()) && !(channel && needsDirectChannelStart(channel))) {
                return;
            }

            var draftText = messageCenterComposerSignature.toOutboundMessage(vm.replyText);
            var message = resolveOutboundMessageBody(draftText);
            var translationMeta = buildOutboundTranslationMeta(draftText);
            var mediaSid = getPendingMediaSid();

            if (!message && !mediaSid) {
                return;
            }

            if (channel === 'ota' && mediaSid) {
                toastMessage.showSimpleToast('Images can only be sent via SMS or WhatsApp.', 'error-toast');
                return;
            }

            if (channel === 'ota' && isReservationCheckedIn(vm.selectedThread)) {
                confirmCheckedInOtaSend().then(function (answer) {
                    if (answer !== 'update') {
                        return;
                    }

                    if (!vm.selectedThread || vm.sendingMessage || isOptedOut() || isAiModeOn()) {
                        return;
                    }

                    vm.sendingMessage = true;
                    sendOtaReply(message, translationMeta);
                }, function () {
                    // cancelled
                });
                return;
            }

            vm.sendingMessage = true;

            if (channel === 'ota') {
                sendOtaReply(message, translationMeta);
                return;
            }

            if (needsDirectChannelStart(channel)) {
                if (!getSelectedStartPhone()) {
                    vm.sendingMessage = false;
                    toastMessage.showSimpleToast('Pick a phone number to start the conversation.', 'error-toast');
                    return;
                }

                startChannelConversation(channel, message, mediaSid, translationMeta);
                return;
            }

            sendDirectReply(message, channel, mediaSid, translationMeta);
        }

        function isReservationCheckedIn(group)
        {
            return getStayStatus(group) === 'checked-in';
        }

        function confirmCheckedInOtaSend()
        {
            return $mdDialog.show({
                controller: 'confirmController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    title: 'Checked-in reservation',
                    htmlContent: 'This reservation is checked in. Do you still want to send the message through OTA? You can send the message through SMS or WhatsApp instead.',
                    cancelBtn: 'Cancel',
                    OkBtn: 'Send'
                }
            });
        }

        function sendOtaReply(message, translationMeta)
        {
            var group = vm.selectedThread;
            var threadId = getOtaThreadId(group);
            var payload = {
                message_thread_id: threadId,
                message: message,
                signature_applied: true
            };

            if (translationMeta) {
                payload.translation = translationMeta;
            }

            messageCenterService.sendThreadMessage(payload).then(function (response) {
                vm.sendingMessage = false;
                schedulePendingMessagesRefresh();

                if (!response || response.success === false) {
                    if (isAiModeActiveError(response)) {
                        handleAiModeSendBlocked(response);
                        return;
                    }

                    toastMessage.showSimpleToast((response && response.message) || 'Unable to send message.', 'error-toast');
                    return;
                }

                clearComposerAfterSend();

                var sent = normalizeChannelMessages([response.data], 'ota')[0];
                appendSentMessage(sent);
                scrollMessagesToBottom();
                bumpThreadPreview(group, sent, 'ota');
            });
        }

        function sendDirectReply(message, channel, mediaSid, translationMeta)
        {
            var group = vm.selectedThread;
            channel = channel || vm.composerChannel || 'sms';
            var conversationSid = getConversationSid(group, channel);

            if (!conversationSid) {
                vm.sendingMessage = false;
                toastMessage.showSimpleToast('No conversation found for this channel.', 'error-toast');
                return;
            }

            var payload = {
                conversation_sid: conversationSid,
                message: message || '',
                channel: channel,
                signature_applied: true
            };

            if (mediaSid) {
                payload.media_sid = mediaSid;
            }

            if (group.confirmation_number) {
                payload.confirmation_number = group.confirmation_number;
            }

            if (vm.subHotelId) {
                payload.sub_hotel_id = vm.subHotelId;
            }

            if (translationMeta) {
                payload.translation = translationMeta;
            }

            messageCenterService.sendSmsThreadMessage(payload).then(function (response) {
                vm.sendingMessage = false;
                schedulePendingMessagesRefresh();

                if (!response || response.success === false) {
                    if (isAiModeActiveError(response)) {
                        handleAiModeSendBlocked(response);
                        return;
                    }

                    if (isPhoneLinkedError(response)) {
                        handlePhoneLinkedError(response);
                        return;
                    }

                    var errorMessage = (response && response.message) || 'Unable to send message.';

                    if (isBlockingSmsError(errorMessage) && group._direct) {
                        group._direct._smsBlocked = errorMessage;
                    }

                    toastMessage.showSimpleToast(errorMessage, 'error-toast');
                    return;
                }

                clearComposerAfterSend();

                appendOutboundSendResponse(response, channel, group);
            });
        }

        function appendOutboundSendResponse(response, channel, group)
        {
            var mediaRaw = response && response.media_message;
            var textRaw = response && response.data;
            var last = null;

            // start* endpoints nest the sent payload under data.message
            if (textRaw && textRaw.message && typeof textRaw.message === 'object' && !angular.isArray(textRaw)) {
                mediaRaw = textRaw.media_message || mediaRaw;
                textRaw = textRaw.message || textRaw.sent_message || null;
            }

            if (mediaRaw) {
                last = appendSentMessage(normalizeChannelMessages([mediaRaw], channel)[0]) || last;
            }

            if (textRaw) {
                last = appendSentMessage(normalizeChannelMessages([textRaw], channel)[0]) || last;
            }

            if (last) {
                scrollMessagesToBottom();
                if (group) {
                    bumpThreadPreview(group, last, channel);
                }
            }

            return last;
        }

        function startChannelConversation(channel, firstMessage, mediaSid, translationMeta)
        {
            var group = vm.selectedThread;
            var guestPhone = getSelectedStartPhone();

            if (!group || !group.confirmation_number) {
                vm.sendingMessage = false;
                return;
            }

            channel = channel || vm.composerChannel || 'sms';

            if (!guestPhone) {
                vm.sendingMessage = false;
                toastMessage.showSimpleToast('Pick a phone number to start the conversation.', 'error-toast');
                return;
            }

            var payload = {
                confirmation_number: group.confirmation_number,
                guest_phone: guestPhone,
                channel: channel === 'whatsapp' ? 'whatsapp' : 'sms',
                message: firstMessage || undefined,
                signature_applied: true
            };

            if (mediaSid) {
                payload.media_sid = mediaSid;
            }

            if (vm.subHotelId) {
                payload.sub_hotel_id = vm.subHotelId;
            }

            if (translationMeta) {
                payload.translation = translationMeta;
            }

            vm.sendingMessage = true;
            vm.phoneConflictMessage = '';

            messageCenterService.startSmsConversation(payload).then(function (response) {
                vm.sendingMessage = false;
                schedulePendingMessagesRefresh();

                if (!response || response.success === false) {
                    if (isPhoneLinkedError(response)) {
                        handlePhoneLinkedError(response);
                        return;
                    }

                    toastMessage.showSimpleToast((response && response.message) || 'Unable to start conversation.', 'error-toast');
                    return;
                }

                if (firstMessage || mediaSid) {
                    clearComposerAfterSend();
                }

                group.guest_phone = guestPhone;
                refreshMessagingContext(group.confirmation_number);

                if (response.data && (response.data.message || response.data.media_message)) {
                    appendOutboundSendResponse(response, channel, group);
                } else {
                    loadMessages();
                }
            }, function (error) {
                vm.sendingMessage = false;
                schedulePendingMessagesRefresh();
                var response = (error && error.data) ? error.data : null;

                if (isPhoneLinkedError(response)) {
                    handlePhoneLinkedError(response);
                    return;
                }

                toastMessage.showSimpleToast((response && response.message) || 'Unable to start conversation.', 'error-toast');
            });
        }

        function bumpThreadPreview(group, sent, channel)
        {
            if (!group) {
                return;
            }

            var when = (sent && sent.inserted_at) || nowUtc();
            var isMedia = !!(sent && (sent.is_media_attached ||
                (angular.isArray(sent.media) && sent.media.length)));
            var previewText = normalizeThreadPreviewText(sent ? sent.message : '', isMedia);

            group.last_message = {
                message: previewText,
                sender: 'property',
                inserted_at: when,
                is_media_attached: isMedia ? 1 : 0
            };
            group.last_message_at = when;
            group.last_message_preview = previewText;
            group.last_is_media_attached = isMedia ? 1 : 0;
            group._activityRaw = when;
            group._activityTs = parseTs(when);
            group._lastChannel = channel;

            if (group._ota && channel === 'ota') {
                bumpOtaThreadPreview(group._ota, sent);
            }

            if (group._direct && channel !== 'ota') {
                bumpDirectThreadPreview(group._direct, sent);
            }

            if (useUnifiedApi) {
                upsertUnifiedThread(group);
            } else {
                rebuildThreadList();
            }
        }

        function bumpOtaThreadPreview(otaThread, sent)
        {
            var when = (sent && sent.inserted_at) || nowUtc();
            var isMedia = !!(sent && (sent.is_media_attached ||
                (angular.isArray(sent.media) && sent.media.length)));
            var previewText = normalizeThreadPreviewText(sent ? sent.message : '', isMedia);

            otaThread.last_message = {
                message: previewText,
                sender: 'property',
                inserted_at: when,
                is_media_attached: isMedia ? 1 : 0
            };
            otaThread.last_message_received_at = when;
            otaThread.updated_at = when;
        }

        function bumpDirectThreadPreview(directThread, sent)
        {
            var when = (sent && sent.inserted_at) || nowUtc();
            var isMedia = !!(sent && (sent.is_media_attached ||
                (angular.isArray(sent.media) && sent.media.length)));
            var previewText = normalizeThreadPreviewText(sent ? sent.message : '', isMedia);

            directThread.last_message = {
                message: previewText,
                sender: 'property',
                inserted_at: when,
                is_media_attached: isMedia ? 1 : 0
            };
            directThread.date_updated = when;
        }

        function getPhoneEditInputName()
        {
            return 'gmc_phone_edit';
        }

        function getCustomSendToInputName()
        {
            return 'gmc_send_to_custom';
        }

        function updatePhoneWithCountryCode(fieldName)
        {
            phoneFormatService.updateValidity(fieldName);
        }

        function isPhoneEditValid()
        {
            if (!vm.editingPhone) {
                return false;
            }

            return phoneFormatService.isValidInput(
                getPhoneEditInputName(),
                vm.phoneEditValue
            );
        }

        function isCustomSendToPhoneValid()
        {
            if (vm.sendToSource !== 'custom') {
                return true;
            }

            return phoneFormatService.isValidInput(
                getCustomSendToInputName(),
                vm.sendToCustomPhone
            );
        }

        function beginPhoneEdit()
        {
            var group = vm.selectedThread;

            if (!group) {
                return;
            }

            vm.editingPhone = true;
            vm.phoneEditValue = getThreadPhone(group) || '';
        }

        function cancelPhoneEdit()
        {
            vm.editingPhone = false;
            vm.phoneEditValue = '';
        }

        function saveGuestPhone()
        {
            var group = vm.selectedThread;
            var phone = phoneFormatService.getValidE164(
                getPhoneEditInputName(),
                vm.phoneEditValue
            );

            if (!group || !group.confirmation_number || vm.savingPhone) {
                return;
            }

            if (!phone) {
                phoneFormatService.updateValidity(getPhoneEditInputName());
                toastMessage.showSimpleToast('Enter a valid phone number with country code.', 'error-toast');
                return;
            }

            vm.phoneEditValue = phone;
            vm.savingPhone = true;

            messageCenterService.updateGuestPhone({
                confirmation_number: group.confirmation_number,
                guest_phone: phone
            }).then(function (response) {
                vm.savingPhone = false;

                if (!response || response.success === false) {
                    if (isPhoneLinkedError(response)) {
                        handlePhoneLinkedError(response);
                        return;
                    }

                    toastMessage.showSimpleToast((response && response.message) || 'Unable to update phone.', 'error-toast');
                    return;
                }

                var updatedPhone = (response.data && response.data.guest_phone) ? response.data.guest_phone : phone;
                group.guest_phone = updatedPhone;
                if (!group.channels) {
                    group.channels = {};
                }
                if (group.channels.sms) {
                    group.channels.sms.guest_phone_e164 = updatedPhone;
                }
                if (group.channels.whatsapp) {
                    group.channels.whatsapp.guest_phone_e164 = updatedPhone;
                }
                if (group._direct) {
                    group._direct.guest_phone = updatedPhone;
                }
                vm.editingPhone = false;
                vm.phoneEditValue = '';
                toastMessage.showSimpleToast('Guest phone updated.', 'success-toast');

                if (response.data && response.data.phone_change_notices && response.data.phone_change_notices.length) {
                    var notices = normalizeUnifiedMessages(response.data.phone_change_notices);
                    var addedNotices = addMessages(notices);

                    if (addedNotices.length && isMessagesAtBottom()) {
                        scrollMessagesToBottom();
                    }
                }

                refreshMessagingContext(group.confirmation_number);
            }, function (error) {
                vm.savingPhone = false;
                var response = (error && error.data) ? error.data : null;

                if (isPhoneLinkedError(response)) {
                    handlePhoneLinkedError(response);
                    return;
                }

                toastMessage.showSimpleToast((response && response.message) || 'Unable to update phone.', 'error-toast');
            });
        }

        function isThreadArchived(thread)
        {
            thread = thread || vm.selectedThread;
            return !!(thread && thread.is_archived);
        }

        function removeConfirmationFromLists(confirmationNumber)
        {
            var cn = confirmationNumber ? String(confirmationNumber) : '';
            var filterFn;

            if (!cn) {
                return;
            }

            filterFn = function (thread) {
                return !(thread && String(thread.confirmation_number) === cn);
            };

            vm.threads = (vm.threads || []).filter(filterFn);
            vm._allUnifiedThreads = (vm._allUnifiedThreads || []).filter(filterFn);

            if (vm.selectedThread && String(vm.selectedThread.confirmation_number) === cn) {
                clearChat();
                syncThreadUrlParam(null);
            }
        }

        function setArchivedLocal(confirmationNumber, archived)
        {
            var cn = confirmationNumber ? String(confirmationNumber) : '';
            var lists = [vm.threads, vm._allUnifiedThreads];
            var i;
            var j;
            var list;
            var thread;

            if (!cn) {
                return;
            }

            for (i = 0; i < lists.length; i++) {
                list = lists[i] || [];
                for (j = 0; j < list.length; j++) {
                    thread = list[j];
                    if (thread && String(thread.confirmation_number) === cn) {
                        thread.is_archived = !!archived;
                    }
                }
            }

            if (vm.selectedThread && String(vm.selectedThread.confirmation_number) === cn) {
                vm.selectedThread.is_archived = !!archived;
            }
        }

        function confirmArchiveToggle(willArchive)
        {
            return $mdDialog.show({
                controller: 'confirmController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    title: willArchive ? 'Archive conversation' : 'Unarchive conversation',
                    htmlContent: willArchive
                        ? 'Are you sure you want to archive this conversation?'
                        : 'Are you sure you want to unarchive this conversation?',
                    cancelBtn: 'Cancel',
                    OkBtn: willArchive ? 'Archive' : 'Unarchive'
                }
            });
        }

        function canAcknowledgeThread(thread)
        {
            var group = thread || vm.selectedThread;
            // Acknowledge only matters when unreplied-message alerts are enabled.
            if (!vm.unrepliedAlertEnabled) {
                return false;
            }
            if (!group || !group.confirmation_number || vm.isArchiveView) {
                return false;
            }
            return group.is_acknowledged === false;
        }

        function setAcknowledgedLocal(confirmationNumber, acknowledged)
        {
            var value = !!acknowledged;

            angular.forEach([vm.threads, vm._allUnifiedThreads], function (list) {
                if (!list || !list.length) {
                    return;
                }
                angular.forEach(list, function (thread) {
                    if (thread && thread.confirmation_number === confirmationNumber) {
                        thread.is_acknowledged = value;
                    }
                });
            });

            if (vm.selectedThread && vm.selectedThread.confirmation_number === confirmationNumber) {
                vm.selectedThread.is_acknowledged = value;
            }
        }

        function acknowledgeThread()
        {
            var group = vm.selectedThread;
            var payload;

            if (!canAcknowledgeThread(group) || vm.updatingAcknowledge) {
                return;
            }

            payload = {
                confirmation_number: group.confirmation_number
            };
            if (vm.subHotelId) {
                payload.sub_hotel_id = vm.subHotelId;
            }

            setAcknowledgedLocal(group.confirmation_number, true);
            vm.updatingAcknowledge = true;

            messageCenterService.acknowledgeThread(payload).then(function (response) {
                var data;
                var noticeText = '';
                var noticePayload;

                vm.updatingAcknowledge = false;

                if (!response || response.success === false) {
                    setAcknowledgedLocal(group.confirmation_number, false);
                    toastMessage.showSimpleToast(
                        (response && response.message) || 'Unable to acknowledge conversation.',
                        'error-toast'
                    );
                    return;
                }

                data = response.data || {};
                setAcknowledgedLocal(group.confirmation_number, true);

                if (data.notice_text) {
                    noticeText = String(data.notice_text).trim();
                }

                noticePayload = data.message || data.system_message;
                if (noticePayload && typeof noticePayload === 'object') {
                    if (!noticeText) {
                        noticeText = String(noticePayload.message || noticePayload.body || '').trim();
                    }
                    var notices = normalizeUnifiedMessages([angular.copy(noticePayload)]);
                    var added = addMessages(notices);

                    if (added.length) {
                        scrollMessagesToBottom();
                    }
                } else if (!noticeText && typeof noticePayload === 'string') {
                    noticeText = noticePayload.trim();
                }

                if (!noticeText && data.staff_user_name) {
                    noticeText = String(data.staff_user_name).trim() + ' acknowledged this chat.';
                }

                toastMessage.showSimpleToast(
                    noticeText || 'Conversation acknowledged.',
                    'success-toast'
                );
            }, function (error) {
                var err = (error && error.data) ? error.data : null;

                vm.updatingAcknowledge = false;
                setAcknowledgedLocal(group.confirmation_number, false);
                toastMessage.showSimpleToast(
                    (err && err.message) || 'Unable to acknowledge conversation.',
                    'error-toast'
                );
            });
        }

        function onThreadAcknowledgedChanged(data)
        {
            var confirmation = data && data.confirmation_number ? String(data.confirmation_number) : '';
            if (!confirmation) {
                return;
            }

            setAcknowledgedLocal(confirmation, data.is_acknowledged == null ? true : !!data.is_acknowledged);

            if (isSelectedConfirmation(confirmation) && data.message) {
                var notices = normalizeUnifiedMessages([angular.copy(data.message)]);
                var added = addMessages(notices);
                if (added.length) {
                    scrollMessagesToBottom();
                }
            }
        }

        function toggleThreadArchived(thread)
        {
            var group = thread || vm.selectedThread;
            var previous;
            var next;

            if (!group || !group.confirmation_number || vm.updatingArchive) {
                return;
            }

            previous = isThreadArchived(group);
            next = !previous;

            confirmArchiveToggle(next).then(function (result) {
                // confirmController hides with 'update' on OK and 'no'/'close' on Cancel —
                // both resolve the promise, so only proceed on explicit confirm.
                if (result === 'update') {
                    applyThreadArchived(group, previous, next);
                }
            });
        }

        function applyThreadArchived(group, previous, next)
        {
            var payload = {
                confirmation_number: group.confirmation_number,
                archived: next
            };

            if (vm.subHotelId) {
                payload.sub_hotel_id = vm.subHotelId;
            }

            setArchivedLocal(group.confirmation_number, next);
            vm.updatingArchive = true;

            messageCenterService.setThreadArchived(payload).then(function (response) {
                var data;
                var archived;
                var noticeText = '';
                var noticePayload;

                vm.updatingArchive = false;

                if (!response || response.success === false) {
                    setArchivedLocal(group.confirmation_number, previous);
                    toastMessage.showSimpleToast(
                        (response && response.message) || 'Unable to update archive status.',
                        'error-toast'
                    );
                    return;
                }

                data = response.data || {};
                archived = data.is_archived != null ? !!data.is_archived : next;
                setArchivedLocal(group.confirmation_number, archived);

                if (data.notice_text) {
                    noticeText = String(data.notice_text).trim();
                }

                noticePayload = data.message || data.system_message;
                if (noticePayload && typeof noticePayload === 'object') {
                    if (!noticeText) {
                        noticeText = String(noticePayload.message || noticePayload.body || '').trim();
                    }
                    var notices = normalizeUnifiedMessages([angular.copy(noticePayload)]);
                    var added = addMessages(notices);

                    if (added.length) {
                        scrollMessagesToBottom();
                    }
                } else if (!noticeText && typeof noticePayload === 'string') {
                    noticeText = noticePayload.trim();
                }

                if (!noticeText && data.staff_user_name) {
                    var staffName = String(data.staff_user_name).trim();
                    noticeText = archived
                        ? (staffName + ' archived this chat.')
                        : (staffName + ' unarchived this chat.');
                }

                // Leaving the current list (inbox ↔ archive) after a successful toggle.
                if ((vm.isArchiveView && !archived) || (!vm.isArchiveView && archived)) {
                    removeConfirmationFromLists(group.confirmation_number);
                }

                toastMessage.showSimpleToast(
                    noticeText || (archived ? 'Conversation archived.' : 'Conversation moved back to Messages.'),
                    'success-toast'
                );
            }, function (error) {
                var err = (error && error.data) ? error.data : null;

                vm.updatingArchive = false;
                setArchivedLocal(group.confirmation_number, previous);
                toastMessage.showSimpleToast(
                    (err && err.message) || 'Unable to update archive status.',
                    'error-toast'
                );
            });
        }

        function toggleMessagingOptOut()
        {
            var group = vm.selectedThread;

            if (!group || !group.confirmation_number || vm.updatingOptOut) {
                return;
            }

            var next = !isOptedOut(group);
            vm.updatingOptOut = true;

            messageCenterService.setMessagingOptOut({
                confirmation_number: group.confirmation_number,
                opted_out: next
            }).then(function (response) {
                vm.updatingOptOut = false;

                if (!response || response.success === false) {
                    toastMessage.showSimpleToast((response && response.message) || 'Unable to update opt-out.', 'error-toast');
                    return;
                }

                group.messaging_opt_out = next;

                var noticeText = '';
                if (response.data && response.data.notice_text) {
                    noticeText = String(response.data.notice_text).trim();
                }

                var noticePayload = response.data && (response.data.message || response.data.system_message);

                if (noticePayload && typeof noticePayload === 'object') {
                    if (!noticeText) {
                        noticeText = String(noticePayload.message || noticePayload.body || '').trim();
                    }
                    var notices = normalizeUnifiedMessages([angular.copy(noticePayload)]);
                    var added = addMessages(notices);

                    if (added.length) {
                        scrollMessagesToBottom();
                    }
                } else if (!noticeText && typeof noticePayload === 'string') {
                    noticeText = noticePayload.trim();
                }

                if (!noticeText && response.data && response.data.staff_user_name) {
                    var staffName = String(response.data.staff_user_name).trim();
                    noticeText = next
                        ? (staffName + ' opted out of direct messaging.')
                        : (staffName + ' opted back into direct messaging.');
                }

                if (!noticeText) {
                    noticeText = next
                        ? 'Opted out of direct messaging.'
                        : 'Opted back into direct messaging.';
                }

                toastMessage.showSimpleToast(noticeText, 'success-toast');
            }, function () {
                vm.updatingOptOut = false;
                toastMessage.showSimpleToast('Unable to update opt-out.', 'error-toast');
            });
        }

        function onReplyKeydown(event)
        {
            if (!event || (event.keyCode !== 13 && event.which !== 13)) {
                return;
            }

            // Enter inserts a new line; send only via the Send button.
            $timeout(resizeReplyTextarea);
        }

        function getReplyTextarea()
        {
            return document.getElementById(REPLY_TEXTAREA_ID);
        }

        function getReplyTextareaMaxHeight(textarea)
        {
            var styles = window.getComputedStyle(textarea);
            var lineHeight = parseFloat(styles.lineHeight);

            if (isNaN(lineHeight)) {
                lineHeight = parseFloat(styles.fontSize) * 1.45;
            }

            var paddingTop = parseFloat(styles.paddingTop) || 0;
            var paddingBottom = parseFloat(styles.paddingBottom) || 0;

            return Math.ceil((lineHeight * REPLY_MAX_LINES) + paddingTop + paddingBottom);
        }

        function resizeReplyTextarea()
        {
            $timeout(function () {
                var textarea = getReplyTextarea();

                if (!textarea) {
                    return;
                }

                var maxHeight = getReplyTextareaMaxHeight(textarea);

                textarea.style.height = 'auto';
                textarea.style.overflowY = 'hidden';

                if (textarea.scrollHeight > maxHeight) {
                    textarea.style.height = maxHeight + 'px';
                    textarea.style.overflowY = 'auto';
                    return;
                }

                textarea.style.height = textarea.scrollHeight + 'px';
            }, 0);
        }

        function toggleQuickReplyPicker($event)
        {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            if (vm.quickReplyOpen) {
                closeQuickReplyPicker();
                return;
            }

            openQuickReplyPicker();
        }

        function openQuickReplyPicker()
        {
            if (vm.promoteReplyOpen) closePromoteReplyPicker();
            closeComposerTranslate();
            closeMessageTranslatePopup();
            vm.quickReplyOpen = true;
            vm.quickReplySearch = '';
            bindQuickReplyDocClick();
            loadQuickReplies();
        }

        function closeQuickReplyPicker()
        {
            vm.quickReplyOpen = false;
            vm.quickReplySearch = '';
            unbindQuickReplyDocClick();
        }

        function bindQuickReplyDocClick()
        {
            unbindQuickReplyDocClick();

            quickReplyDocClickHandler = function ()
            {
                $scope.$applyAsync(function () {
                    closeQuickReplyPicker();
                });
            };

            $timeout(function () {
                $document.on('click', quickReplyDocClickHandler);
            }, 0);
        }

        function unbindQuickReplyDocClick()
        {
            if (quickReplyDocClickHandler) {
                $document.off('click', quickReplyDocClickHandler);
                quickReplyDocClickHandler = null;
            }
        }

        function loadQuickReplies()
        {
            if (quickReplyCache) {
                vm.quickReplyCategories = quickReplyCache;
                filterQuickReplies();
                return;
            }

            vm.quickReplyLoading = true;
            vm.quickReplyFiltered = [];

            messageCenterService.getTemplatesGrouped({
                template_type: 'quick_reply'
            }).then(function (response) {
                vm.quickReplyLoading = false;

                if (!response || response.success === false) {
                    vm.quickReplyCategories = [];
                    vm.quickReplyFiltered = [];
                    toastMessage.showSimpleToast(
                        (response && response.message) || 'Unable to load quick replies.',
                        'error-toast'
                    );
                    return;
                }

                quickReplyCache = normalizeQuickReplyCategories(response.data || []);
                vm.quickReplyCategories = quickReplyCache;
                filterQuickReplies();
            }, function () {
                vm.quickReplyLoading = false;
                vm.quickReplyCategories = [];
                vm.quickReplyFiltered = [];
                toastMessage.showSimpleToast('Unable to load quick replies.', 'error-toast');
            });
        }

        function normalizeQuickReplyCategories(categories)
        {
            var result = [];
            var i;
            var j;

            for (i = 0; i < categories.length; i++) {
                var category = categories[i] || {};
                var templates = category.templates || [];
                var items = [];

                for (j = 0; j < templates.length; j++) {
                    var template = templates[j] || {};

                    if (String(template.is_active) === '0') {
                        continue;
                    }

                    items.push({
                        id: String(template.id),
                        name: template.name || '',
                        body: template.body || ''
                    });
                }

                if (!items.length) {
                    continue;
                }

                result.push({
                    id: String(category.id),
                    name: category.name || '',
                    templates: items
                });
            }

            return result;
        }

        function filterQuickReplies()
        {
            var query = String(vm.quickReplySearch || '').toLowerCase().trim();
            var categories = vm.quickReplyCategories || [];
            var filtered = [];
            var i;
            var j;

            if (!query) {
                vm.quickReplyFiltered = categories;
                return;
            }

            for (i = 0; i < categories.length; i++) {
                var category = categories[i];
                var matchedTemplates = [];

                if (String(category.name || '').toLowerCase().indexOf(query) !== -1) {
                    filtered.push(category);
                    continue;
                }

                for (j = 0; j < (category.templates || []).length; j++) {
                    var template = category.templates[j];
                    var name = String(template.name || '').toLowerCase();
                    var body = String(template.body || '').toLowerCase();

                    if (name.indexOf(query) !== -1 || body.indexOf(query) !== -1) {
                        matchedTemplates.push(template);
                    }
                }

                if (matchedTemplates.length) {
                    filtered.push({
                        id: category.id,
                        name: category.name,
                        templates: matchedTemplates
                    });
                }
            }

            vm.quickReplyFiltered = filtered;
        }

        function applyQuickReply(template)
        {
            if (!template) {
                return;
            }

            var body = renderQuickReplyBody(template.body || '');

            if (!body) {
                closeQuickReplyPicker();
                return;
            }

            vm.replyText = body;
            closeQuickReplyPicker();
            syncComposerSignature({ placeCaret: true, focus: true });
        }

        function renderQuickReplyBody(body)
        {
            var tokens = getQuickReplyTokens();
            var text = String(body || '');

            Object.keys(tokens).forEach(function (key) {
                var pattern = new RegExp('#\\{' + key + '\\}', 'g');
                text = text.replace(pattern, tokens[key]);
            });

            return text
                .replace(/[ \t]+\n/g, '\n')
                .replace(/\n[ \t]+/g, '\n')
                .replace(/ {2,}/g, ' ')
                .replace(/^\s+|\s+$/g, '');
        }

        function getQuickReplyTokens()
        {
            var group = vm.selectedThread || {};
            var firstName = String(group.first_name || '').trim();
            var lastName = String(group.last_name || '').trim();

            if (!firstName && !lastName) {
                var parts = String(group.guest_name || group.title || '')
                    .replace(/\s*[·\-–]\s*Room\s+.*/i, '')
                    .trim()
                    .split(/\s+/);

                if (parts.length && parts[0]) {
                    firstName = parts[0];
                    lastName = parts.slice(1).join(' ');
                }
            }

            return {
                greeting: 'Hello',
                honorific: 'Mr./Ms.',
                firstName: firstName,
                lastName: lastName,
                roomNumber: getRoomLabel(group) || '',
                confirmationNumber: String(group.confirmation_number || ''),
                hotelName: getThreadHotelTitle(group) || ''
            };
        }

        function togglePromoteReplyPicker($event)
        {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            if (vm.promoteReplyOpen) {
                closePromoteReplyPicker();
                return;
            }

            openPromoteReplyPicker();
        }

        function openPromoteReplyPicker()
        {
            if (vm.quickReplyOpen) closeQuickReplyPicker();
            closeComposerTranslate();
            closeMessageTranslatePopup();
            vm.promoteReplyOpen = true;
            vm.promoteReplySearch = '';
            bindPromoteReplyDocClick();
            loadPromoteReplies();
        }

        function closePromoteReplyPicker()
        {
            vm.promoteReplyOpen = false;
            vm.promoteReplySearch = '';
            unbindPromoteReplyDocClick();
        }

        function bindPromoteReplyDocClick()
        {
            unbindPromoteReplyDocClick();

            promoteReplyDocClickHandler = function ()
            {
                $scope.$applyAsync(function () {
                    closePromoteReplyPicker();
                });
            };

            $timeout(function () {
                $document.on('click', promoteReplyDocClickHandler);
            }, 0);
        }

        function unbindPromoteReplyDocClick()
        {
            if (promoteReplyDocClickHandler) {
                $document.off('click', promoteReplyDocClickHandler);
                promoteReplyDocClickHandler = null;
            }
        }

        function loadPromoteReplies()
        {
            if (promoteReplyCache) {
                vm.promoteReplyCategories = promoteReplyCache;
                filterPromoteReplies();
                return;
            }

            vm.promoteReplyLoading = true;
            vm.promoteReplyFiltered = [];

            messageCenterService.getTemplatesGrouped({
                template_type: 'promote_reply'
            }).then(function (response) {
                vm.promoteReplyLoading = false;

                if (!response || response.success === false) {
                    vm.promoteReplyCategories = [];
                    vm.promoteReplyFiltered = [];
                    toastMessage.showSimpleToast(
                        (response && response.message) || 'Unable to load quick replies.',
                        'error-toast'
                    );
                    return;
                }

                promoteReplyCache = normalizePromoteReplyCategories(response.data || []);
                vm.promoteReplyCategories = promoteReplyCache;
                filterPromoteReplies();
            }, function () {
                vm.promoteReplyLoading = false;
                vm.promoteReplyCategories = [];
                vm.promoteReplyFiltered = [];
                toastMessage.showSimpleToast('Unable to load quick replies.', 'error-toast');
            });
        }

        function normalizePromoteReplyCategories(categories)
        {
            var result = [];
            var i;
            var j;

            for (i = 0; i < categories.length; i++) {
                var category = categories[i] || {};
                var templates = category.templates || [];
                var items = [];

                for (j = 0; j < templates.length; j++) {
                    var template = templates[j] || {};

                    if (String(template.is_active) === '0') {
                        continue;
                    }

                    items.push({
                        id: String(template.id),
                        name: template.name || '',
                        body: template.body || ''
                    });
                }

                if (!items.length) {
                    continue;
                }

                result.push({
                    id: String(category.id),
                    name: category.name || '',
                    templates: items
                });
            }

            return result;
        }

        function filterPromoteReplies()
        {
            var query = String(vm.promoteReplySearch || '').toLowerCase().trim();
            var categories = vm.promoteReplyCategories || [];
            var filtered = [];
            var i;
            var j;

            if (!query) {
                vm.promoteReplyFiltered = categories;
                return;
            }

            for (i = 0; i < categories.length; i++) {
                var category = categories[i];
                var matchedTemplates = [];

                if (String(category.name || '').toLowerCase().indexOf(query) !== -1) {
                    filtered.push(category);
                    continue;
                }

                for (j = 0; j < (category.templates || []).length; j++) {
                    var template = category.templates[j];
                    var name = String(template.name || '').toLowerCase();
                    var body = String(template.body || '').toLowerCase();

                    if (name.indexOf(query) !== -1 || body.indexOf(query) !== -1) {
                        matchedTemplates.push(template);
                    }
                }

                if (matchedTemplates.length) {
                    filtered.push({
                        id: category.id,
                        name: category.name,
                        templates: matchedTemplates
                    });
                }
            }

            vm.promoteReplyFiltered = filtered;
        }

        function applyPromoteReply(template)
        {
            if (!template) {
                return;
            }

            var body = renderPromoteReplyBody(template.body || '');

            if (!body) {
                closePromoteReplyPicker();
                return;
            }

            vm.replyText = body;
            closePromoteReplyPicker();
            syncComposerSignature({ placeCaret: true, focus: true });
        }

        function renderPromoteReplyBody(body)
        {
            var tokens = getPromoteReplyTokens();
            var text = String(body || '');

            Object.keys(tokens).forEach(function (key) {
                var pattern = new RegExp('#\\{' + key + '\\}', 'g');
                text = text.replace(pattern, tokens[key]);
            });

            return text
                .replace(/[ \t]+\n/g, '\n')
                .replace(/\n[ \t]+/g, '\n')
                .replace(/ {2,}/g, ' ')
                .replace(/^\s+|\s+$/g, '');
        }

        function getPromoteReplyTokens()
        {
            var group = vm.selectedThread || {};
            var firstName = String(group.first_name || '').trim();
            var lastName = String(group.last_name || '').trim();

            if (!firstName && !lastName) {
                var parts = String(group.guest_name || group.title || '')
                    .replace(/\s*[·\-–]\s*Room\s+.*/i, '')
                    .trim()
                    .split(/\s+/);

                if (parts.length && parts[0]) {
                    firstName = parts[0];
                    lastName = parts.slice(1).join(' ');
                }
            }

            return {
                greeting: 'Hello',
                honorific: 'Mr./Ms.',
                firstName: firstName,
                lastName: lastName,
                roomNumber: getRoomLabel(group) || '',
                confirmationNumber: String(group.confirmation_number || ''),
                hotelName: getThreadHotelTitle(group) || ''
            };
        }


        function resetReplyTextareaHeight()
        {
            $timeout(function () {
                var textarea = getReplyTextarea();

                if (!textarea) {
                    return;
                }

                textarea.style.height = '';
                textarea.style.overflowY = 'hidden';
                resizeReplyTextarea();
            }, 0);
        }

        // ---------------------------------------------------------------------
        // Display helpers
        // ---------------------------------------------------------------------

        function normalizeProviderKey(provider)
        {
            return String(provider || '')
                .toLowerCase()
                .replace(/[^a-z0-9]/g, '');
        }

        function isChannelManagerProvider(provider)
        {
            var key = normalizeProviderKey(provider);

            return key === 'channex' ||
                key === 'siteminder' ||
                key === 'staah' ||
                key === 'channelmanager' ||
                key === 'ota';
        }

        function extractSourceOfCreation(group)
        {
            if (!group) {
                return '';
            }

            var stays = group.room_stays || group.room_stay || null;
            var stay = null;
            var value = '';

            if (angular.isArray(stays) && stays.length) {
                stay = stays[0];
            } else if (stays && typeof stays === 'object') {
                stay = stays;
            }

            // Prefer room_stays.source_of_creation (reservation booking source).
            value = (stay && stay.source_of_creation) ||
                group.source_of_creation ||
                (group._ota && (
                    (group._ota.room_stays && group._ota.room_stays[0] && group._ota.room_stays[0].source_of_creation) ||
                    (group._ota.room_stay && group._ota.room_stay.source_of_creation) ||
                    group._ota.source_of_creation
                )) ||
                (group._direct && (
                    (group._direct.room_stays && group._direct.room_stays[0] && group._direct.room_stays[0].source_of_creation) ||
                    (group._direct.room_stay && group._direct.room_stay.source_of_creation) ||
                    group._direct.source_of_creation
                )) ||
                (group.channels && group.channels.ota && group.channels.ota.source_of_creation) ||
                (group.channels && group.channels.sms && group.channels.sms.source_of_creation) ||
                (group.channels && group.channels.whatsapp && group.channels.whatsapp.source_of_creation) ||
                (group.meta && group.meta.source_of_creation) ||
                (group.meta && group.meta.booking_details && group.meta.booking_details.source_of_creation) ||
                '';

            return String(value || '').replace(/^\s+|\s+$/g, '');
        }

        function getProviderLabel(provider)
        {
            var key = normalizeProviderKey(provider);

            if (!key || isChannelManagerProvider(provider)) {
                return '';
            }

            // room_stays.source_of_creation values: Booking, Expedia, Airbnb, PMS, FE, ...
            if (key === 'booking' || key.indexOf('booking') !== -1 || key === 'bdc') {
                return 'Booking.com';
            }

            if (key === 'airbnb' || key.indexOf('airbnb') !== -1 || key.indexOf('airbn') !== -1 || key === 'abb') {
                return 'Airbnb';
            }

            if (key === 'expedia' || key.indexOf('expedia') !== -1 || key === 'exp') {
                return 'Expedia';
            }

            if (key === 'fe' || key === 'pms' || key === 'direct' || key === 'sms' || key === 'whatsapp') {
                return 'Direct';
            }

            if (key.indexOf('hoteltonight') !== -1) {
                return 'Hoteltonight';
            }

            if (key.indexOf('priceline') !== -1) {
                return 'Priceline';
            }

            if (key.indexOf('agoda') !== -1) {
                return 'Agoda';
            }

            return provider;
        }

        function getProviderClass(provider)
        {
            var label = getProviderLabel(provider);

            if (label === 'Booking.com') {
                return 'is-booking';
            }

            if (label === 'Airbnb') {
                return 'is-airbnb';
            }

            if (label === 'Expedia') {
                return 'is-expedia';
            }

            if (label === 'Direct') {
                return 'is-direct';
            }

            return 'is-default';
        }

        function computeChips(group)
        {
            var chips = [];
            var source = '';
            var label = '';
            var hasDirectChannel = false;

            if (!group) {
                return chips;
            }

            source = extractSourceOfCreation(group);
            label = getProviderLabel(source);
            hasDirectChannel = !!(group.channels && (group.channels.sms || group.channels.whatsapp)) ||
                !!group._direct;

            // Booking.com / Expedia / Airbnb from room_stays.source_of_creation
            if (label && label !== 'Direct') {
                chips.push({
                    label: label,
                    cls: getProviderClass(source)
                });
            }

            // Direct: SMS/WhatsApp, or PMS/FE source_of_creation
            if (hasDirectChannel || label === 'Direct') {
                chips.push({
                    label: 'Direct',
                    cls: 'is-direct'
                });
            }

            return chips;
        }

        function getThreadChips(group)
        {
            return (group && group._chips) ? group._chips : [];
        }

        function getThreadSourceChip(group)
        {
            var chips = getThreadChips(group);
            var i;

            for (i = 0; i < chips.length; i++) {
                if (chips[i] && chips[i].label && chips[i].label !== 'Direct') {
                    return chips[i];
                }
            }

            return chips.length ? chips[0] : null;
        }

        function showMessageChannel(message)
        {
            // Always show channel tags when more than one channel exists, or channel is explicit.
            if (!message || message.sender === 'system') {
                return false;
            }

            return isMergedThread(vm.selectedThread) || !!(message.channel || message._channel);
        }

        function getMessageChannelLabel(message)
        {
            if (!message) {
                return '';
            }

            var channel = message._channel || message.channel;

            if (channel === 'sms' || channel === 'direct') {
                if (channel === 'direct' && vm.selectedThread && vm.selectedThread.channel === 'whatsapp') {
                    return 'WhatsApp';
                }
                return channel === 'whatsapp' ? 'WhatsApp' : 'SMS';
            }

            if (channel === 'whatsapp') {
                return 'WhatsApp';
            }

            return getProviderLabel(
                extractSourceOfCreation(vm.selectedThread) ||
                (vm.selectedThread && vm.selectedThread.provider)
            ) || '';
        }

		function getMessageChannelClass(message)
		{
			if (!message) {
				return 'is-default';
			}

			var channel = message._channel || message.channel;

			if (channel === 'whatsapp') {
				return 'is-whatsapp';
			}

			if (channel === 'sms' || channel === 'direct') {
				if (channel === 'direct' && vm.selectedThread && vm.selectedThread.channel === 'whatsapp') {
					return 'is-whatsapp';
				}
				return 'is-sms';
			}

			// Match sidebar/header chips: use booking source (Expedia/Booking/etc), not Channex provider.
			return getProviderClass(
				extractSourceOfCreation(vm.selectedThread) ||
				(vm.selectedThread && vm.selectedThread.provider)
			);
		}

        function getThreadTitle(group)
        {
            if (!group) {
                return '';
            }

            var name = group.guest_name || group.title || '';
            var room = getRoomLabel(group);

            if (name && room) {
                return name + ' · Room ' + room;
            }

            return name || group.guest_phone || group.confirmation_number || '';
        }

        function getRoomLabel(group)
        {
            if (!group) {
                return '';
            }

            return group.room_number || group.product_room_number || '';
        }

        /** Phone linked to SMS/WhatsApp thread — not reservation guest phone. */
        function getThreadPhone(group)
        {
            group = group || vm.selectedThread;

            if (!group) {
                return '';
            }

            var channels = group.channels || {};
            var phone =
                (channels.sms && channels.sms.guest_phone_e164) ||
                (channels.whatsapp && channels.whatsapp.guest_phone_e164) ||
                (group._direct && group._direct.guest_phone) ||
                '';

            // After start/edit, guest_phone may already be the thread number.
            if (!phone && group.guest_phone &&
                ((channels.sms && channels.sms.conversation_sid) ||
                    (channels.whatsapp && channels.whatsapp.conversation_sid) ||
                    (group._direct && group._direct.conversation_sid))) {
                phone = group.guest_phone;
            }

            return String(phone || '').replace(/^\s+|\s+$/g, '');
        }

        function getThreadSubtitle(group)
        {
            return formatPhoneNumber(getThreadPhone(group));
        }

        function getThreadActivity(group)
        {
            return group ? (group._activityRaw || group.last_message_at || '') : '';
        }

        function getGuestInitial(group)
        {
            if (!group) {
                return '?';
            }

            var first = String(group.first_name || '').trim().charAt(0);
            var last = String(group.last_name || '').trim().charAt(0);
            var initials = (first + last).toUpperCase();

            if (initials.length === 2) {
                return initials;
            }

            var name = String(group.guest_name || group.title || '').trim();

            // Strip "· Room NNN" / "- Room NNN" suffixes from display titles.
            name = name.replace(/\s*[·\-–]\s*Room\s+.*/i, '').trim();

            if (!name) {
                name = String(group.confirmation_number || group.guest_phone || '').trim();
            }

            if (!name) {
                return '?';
            }

            if (/^\+?\d/.test(name)) {
                return '#';
            }

            var parts = name.split(/\s+/).filter(Boolean);

            if (parts.length >= 2) {
                return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
            }

            return (parts[0].charAt(0) + (parts[0].charAt(1) || '')).toUpperCase() || '?';
        }

        var AVATAR_COLORS = [
            '#00bcd4',
            '#00acc1',
            '#00838f',
            '#039be5',
            '#0277bd',
            '#1565c0',
            '#3470ca',
            '#2d323e',
            '#3c4252',
            '#43a047',
            '#c62828',
            '#e65100'
        ];

        function getAvatarStyle(group)
        {
            var seed = '';

            if (group) {
                seed = String(
                    group.confirmation_number ||
                    group.guest_name ||
                    group.title ||
                    group.guest_phone ||
                    getGuestInitial(group) ||
                    ''
                );
            }

            var hash = 0;
            var i;

            for (i = 0; i < seed.length; i++) {
                hash = ((hash << 5) - hash) + seed.charCodeAt(i);
                hash |= 0;
            }

            var color = AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];

            return {
                background: color
            };
        }

        function getThreadHotelTitle(group)
        {
            var hotelTitle;
            var i;

            if (!group) {
                return '';
            }

            if (group.hotel_title) {
                return group.hotel_title;
            }

            if (group.hotel_id && vm.subHotels && vm.subHotels.length) {
                for (i = 0; i < vm.subHotels.length; i++) {
                    if (parseInt(vm.subHotels[i].hotel_id, 10) === parseInt(group.hotel_id, 10)) {
                        return vm.subHotels[i].hotel_title || '';
                    }
                }
            }

            if ($localStorage.hotels && $localStorage.hotels[$localStorage.selectedHotel]) {
                hotelTitle = $localStorage.hotels[$localStorage.selectedHotel].hotel_title;
                if (hotelTitle) {
                    return hotelTitle;
                }
            }

            return '';
        }

        /**
         * Display UTC inserted_at converted to the current PC/browser timezone.
         */
        function formatDate(value)
        {
            var local = toLocalMoment(value);
            return local ? local.format('MMM D, YYYY h:mm A') : '';
        }

        function formatShortDate(value)
        {
            var local = toLocalMoment(value);
            return local ? local.format('MMM D') : '';
        }

        function getInquiryDetails(message)
        {
            if (!message || !message.meta || !message.meta.booking_details) {
                return null;
            }

            return message.meta.booking_details;
        }

        function getStayField(source, type)
        {
            if (!source) {
                return null;
            }

            var checkInKeys = ['checkin_date', 'check_in_date', 'check_in', 'room_stay_from', 'arrival_date', 'arrival_time'];
            var checkOutKeys = ['checkout_date', 'check_out_date', 'check_out', 'room_stay_to', 'departure_date', 'departure_time'];
            var keys = type === 'in' ? checkInKeys : checkOutKeys;
            var i;

            for (i = 0; i < keys.length; i++) {
                if (source[keys[i]]) {
                    return source[keys[i]];
                }
            }

            if (source.meta && source.meta.booking_details) {
                return type === 'in'
                    ? source.meta.booking_details.checkin_date
                    : source.meta.booking_details.checkout_date;
            }

            if (source.booking_details) {
                return type === 'in'
                    ? source.booking_details.checkin_date
                    : source.booking_details.checkout_date;
            }

            return null;
        }

        function getThreadCheckIn(group)
        {
            return getStayField(group, 'in');
        }

        function getThreadCheckOut(group)
        {
            return getStayField(group, 'out');
        }

        function getDisplayCheckIn()
        {
            return getThreadCheckIn(vm.selectedThread) ||
                (vm.messageStayDates && vm.messageStayDates.checkin_date) ||
                (vm.reservationStayDates && vm.reservationStayDates.checkin_date);
        }

        function getDisplayCheckOut()
        {
            return getThreadCheckOut(vm.selectedThread) ||
                (vm.messageStayDates && vm.messageStayDates.checkout_date) ||
                (vm.reservationStayDates && vm.reservationStayDates.checkout_date);
        }

        function hasStayDates(group)
        {
            if (group) {
                return !!(getThreadCheckIn(group) || getThreadCheckOut(group));
            }

            return !!(getDisplayCheckIn() || getDisplayCheckOut());
        }

        function parseStayDate(value)
        {
            if (!value) {
                return null;
            }

            if (moment.isMoment(value)) {
                return value.isValid() ? value : null;
            }

            if (value instanceof Date) {
                return isNaN(value.getTime()) ? null : moment(value);
            }

            if (typeof value !== 'string') {
                return null;
            }

            var trimmed = value.trim();

            if (!trimmed || trimmed.indexOf('0000-00-00') === 0) {
                return null;
            }

            var parsed = moment(trimmed, [
                'MM/DD/YYYY',
                'M/D/YYYY',
                'MM/DD/YYYY HH:mm:ss',
                'M/D/YYYY HH:mm:ss',
                'YYYY-MM-DD',
                'YYYY-MM-DD HH:mm:ss',
                'YYYY/MM/DD',
                'DD-MM-YYYY',
                'DD/MM/YYYY',
                moment.ISO_8601
            ], true);

            if (parsed.isValid()) {
                return parsed;
            }

            parsed = moment(trimmed);

            return parsed.isValid() ? parsed : null;
        }

        function formatStayDate(value)
        {
            var parsed = parseStayDate(value);

            if (!parsed) {
                return '';
            }

            return parsed.format('MMM D, YYYY');
        }

        function formatStayDateRange(checkIn, checkOut)
        {
            var inParsed = parseStayDate(checkIn);
            var outParsed = parseStayDate(checkOut);

            if (inParsed && outParsed) {
                if (inParsed.year() === outParsed.year()) {
                    return inParsed.format('MMM D') + ' \u2013 ' + outParsed.format('MMM D, YYYY');
                }

                return inParsed.format('MMM D, YYYY') + ' \u2013 ' + outParsed.format('MMM D, YYYY');
            }

            if (inParsed) {
                return inParsed.format('MMM D, YYYY');
            }

            if (outParsed) {
                return outParsed.format('MMM D, YYYY');
            }

            return '';
        }

        function hasFormattedStayDate(value)
        {
            return !!formatStayDate(value);
        }

        function hasHeaderStayInfo()
        {
            return hasFormattedStayDate(getDisplayCheckIn()) ||
                hasFormattedStayDate(getDisplayCheckOut()) ||
                !!getReservationStatus() ||
                !!(vm.selectedThread && vm.selectedThread.confirmation_number);
        }

        function getReservationStatus(group)
        {
            if (group) {
                return group.room_stay_status || null;
            }

            if (vm.selectedThread && vm.selectedThread.room_stay_status) {
                return vm.selectedThread.room_stay_status;
            }

            return vm.reservationStayDates && vm.reservationStayDates.room_stay_status
                ? vm.reservationStayDates.room_stay_status
                : null;
        }

        function normalizeStayStatusKey(status)
        {
            if (!status) {
                return null;
            }

            var normalized = String(status).toLowerCase().replace(/[\s_]+/g, '-');

            if (normalized.indexOf('check') !== -1 && normalized.indexOf('out') !== -1) {
                return 'checked-out';
            }

            if (normalized.indexOf('check') !== -1 && normalized.indexOf('in') !== -1) {
                return 'checked-in';
            }

            if (normalized === 'canceled' || normalized === 'cancelled') {
                return 'canceled';
            }

            if (normalized === 'closed') {
                return 'checked-out';
            }

            if (normalized === 'active') {
                return 'active';
            }

            return 'active';
        }

        function getStayCheckInForStatus(group)
        {
            if (group) {
                return getThreadCheckIn(group);
            }

            return getDisplayCheckIn();
        }

        function getStayCheckOutForStatus(group)
        {
            if (group) {
                return getThreadCheckOut(group);
            }

            return getDisplayCheckOut();
        }

        function getStayStatus(group)
        {
            var apiStatus = getReservationStatus(group);

            if (apiStatus) {
                return normalizeStayStatusKey(apiStatus);
            }

            var checkIn = parseStayDate(getStayCheckInForStatus(group));
            var checkOut = parseStayDate(getStayCheckOutForStatus(group));
            var today = moment().startOf('day');

            if (!checkIn && !checkOut) {
                return null;
            }

            if (checkOut && today.isSameOrAfter(checkOut.clone().startOf('day'))) {
                return 'checked-out';
            }

            if (checkIn && today.isSameOrAfter(checkIn.clone().startOf('day'))) {
                if (!checkOut || today.isBefore(checkOut.clone().startOf('day'))) {
                    return 'checked-in';
                }
            }

            return 'active';
        }

        function getStayStatusLabel(group)
        {
            var apiStatus = getReservationStatus(group);

            if (apiStatus) {
                return apiStatus;
            }

            var status = getStayStatus(group);

            if (status === 'checked-in') {
                return 'Checked In';
            }

            if (status === 'checked-out') {
                return 'Checked Out';
            }

            if (status === 'canceled') {
                return 'Canceled';
            }

            if (status === 'active') {
                return 'Active';
            }

            return '';
        }

        function getStayStatusClass(group)
        {
            var status = getStayStatus(group);

            if (!status) {
                return 'is-default';
            }

            return 'is-' + status;
        }

        function openReservation()
        {
            if (!vm.selectedThread || !vm.selectedThread.confirmation_number) {
                return;
            }

            $rootScope.goToState('', vm.selectedThread.confirmation_number, '');
        }

        function hasUnread(group)
        {
            return getThreadUnreadCount(group) > 0;
        }

        function getUnreadLabel(group)
        {
            var count = getThreadUnreadCount(group);

            if (count <= 0) {
                return '';
            }

            return count > 99 ? '99+' : String(count);
        }

        function getMessageText(message)
        {
            if (!message) {
                return '';
            }

            // Guest bubble showing on-demand translation
            if (message._showTranslation && message._translatedText) {
                return String(message._translatedText);
            }

            // Own outbound: toggle back to pre-send original
            if (
                message._showOriginal &&
                message.translation &&
                message.translation.original_text
            ) {
                return String(message.translation.original_text);
            }

            if (message.message === null || message.message === undefined) {
                return '';
            }

            var text = String(message.message).replace(/^\s+|\s+$/g, '');

            if (isSupportEscalation(message) && text && text.indexOf('Escalation:') !== 0) {
                return 'Escalation: ' + text;
            }

            return text;
        }

        function getLanguageName(code)
        {
            code = String(code || '').trim();
            if (!code) {
                return '';
            }
            var i;
            for (i = 0; i < (vm.translateLanguages || []).length; i++) {
                if (String(vm.translateLanguages[i].code).toLowerCase() === code.toLowerCase()) {
                    return vm.translateLanguages[i].name;
                }
            }
            return code.toUpperCase();
        }

        function filterTranslateLanguages(lang)
        {
            if (!lang) {
                return false;
            }

            var term = (vm.translateLangSearchText || '').toLowerCase().trim();
            if (!term) {
                return true;
            }

            var name = lang.name ? String(lang.name).toLowerCase() : '';
            var code = lang.code ? String(lang.code).toLowerCase() : '';
            return name.indexOf(term) !== -1 || code.indexOf(term) !== -1;
        }

        function clearTranslateLangSearch()
        {
            vm.translateLangSearchText = '';
        }

        function getDetectedLanguageLabel(message)
        {
            if (!message || !message.detected_language) {
                return '';
            }
            return getLanguageName(message.detected_language);
        }

        function getTranslationBadgeLabel(message)
        {
            if (!message || !message.translation || !message.translation.target_language) {
                return '';
            }
            return getLanguageName(message.translation.target_language);
        }

        function formatLanguageDirection(fromCode, toCode)
        {
            var from = fromCode ? getLanguageName(fromCode) : '';
            var to = toCode ? getLanguageName(toCode) : '';
            if (from && to) {
                if (String(fromCode).toLowerCase() === String(toCode).toLowerCase()) {
                    return from;
                }
                return from + ' -> ' + to;
            }
            return to || from || '';
        }

        function getMessageLanguageTag(message)
        {
            if (!message) {
                return '';
            }

            // On-demand bubble translation currently shown: "Arabic -> English"
            if (message._showTranslation && message._translatedLang) {
                return formatLanguageDirection(
                    message._translatedSource || message.detected_language ||
                        (message.translation && message.translation.source_language) || '',
                    message._translatedLang
                );
            }

            return '';
        }

        function getSentTranslationLanguageLabel(message)
        {
            if (
                !message ||
                message._showTranslation ||
                message._showOriginal ||
                !message.translation ||
                !message.translation.target_language
            ) {
                return '';
            }
            return getLanguageName(message.translation.target_language);
        }

        function canTranslateMessage(message)
        {
            if (!message || message.sender === 'system') {
                return false;
            }
            // Guest + outbound (property/AI): translate for viewing when message has text
            var text = String(message.message || '').replace(/^\s+|\s+$/g, '');
            return !!text;
        }

        function toggleMessageTranslatePanel($event, message)
        {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            if (!message) {
                return;
            }

            if (message._translateOpen) {
                closeMessageTranslatePopup();
                return;
            }

            closeMessageTranslatePopup();
            closeComposerTranslate();
            if (vm.quickReplyOpen) {
                closeQuickReplyPicker();
            }
            if (vm.promoteReplyOpen) {
                closePromoteReplyPicker();
            }

            var triggerEl = $event && $event.currentTarget
                ? $event.currentTarget
                : null;
            message._translatePlacement = resolveTranslatePopupPlacement(triggerEl);
            message._translateOpen = true;
            if (!message._translateTarget) {
                message._translateTarget = 'en';
            }
            translatePopupMessage = message;
            bindTranslateDocClick();
            loadTranslateLanguages();

            // Refine after render using the real popup size.
            $timeout(function () {
                if (!message._translateOpen || !triggerEl) {
                    return;
                }
                var refined = resolveTranslatePopupPlacement(triggerEl, true);
                if (refined && refined !== message._translatePlacement) {
                    message._translatePlacement = refined;
                }
            }, 0);
        }

        function resolveTranslatePopupPlacement(triggerEl, useRenderedSize)
        {
            var fallback = 'top';
            if (!triggerEl || !triggerEl.getBoundingClientRect) {
                return fallback;
            }

            var triggerRect = triggerEl.getBoundingClientRect();
            var container = triggerEl.closest
                ? triggerEl.closest('.gmc-messages')
                : null;
            if (!container) {
                var node = triggerEl.parentElement;
                while (node) {
                    if (node.classList && node.classList.contains('gmc-messages')) {
                        container = node;
                        break;
                    }
                    node = node.parentElement;
                }
            }
            if (!container) {
                return fallback;
            }

            var containerRect = container.getBoundingClientRect();
            var gap = 8;
            var popupWidth = 236;
            var popupHeight = 220;

            if (useRenderedSize) {
                var popupEl = triggerEl.parentElement
                    ? triggerEl.parentElement.querySelector('.gmc-msg-translate-popup')
                    : null;
                if (popupEl) {
                    var popupRect = popupEl.getBoundingClientRect();
                    if (popupRect.width > 0) {
                        popupWidth = popupRect.width;
                    }
                    if (popupRect.height > 0) {
                        popupHeight = popupRect.height;
                    }
                }
            }

            var space = {
                top: triggerRect.top - containerRect.top - gap,
                bottom: containerRect.bottom - triggerRect.bottom - gap,
                left: triggerRect.left - containerRect.left - gap,
                right: containerRect.right - triggerRect.right - gap
            };

            // Guest bubbles open left-aligned; staff/right bubbles flip with CSS.
            var isRightAligned = !!(
                triggerEl.closest &&
                (triggerEl.closest('.align-right') || triggerEl.closest('.from-property'))
            );
            var horizontalRoom = isRightAligned
                ? (triggerRect.right - containerRect.left)
                : (containerRect.right - triggerRect.left);
            // Side popups grow downward from the trigger top.
            var verticalRoomForSide = containerRect.bottom - triggerRect.top - gap;

            // Prefer top, then right, then bottom, then left.
            var order = ['top', 'right', 'bottom', 'left'];
            var i;
            var side;
            for (i = 0; i < order.length; i++) {
                side = order[i];
                if (side === 'top' || side === 'bottom') {
                    if (space[side] >= popupHeight && horizontalRoom >= popupWidth) {
                        return side;
                    }
                } else if (space[side] >= popupWidth && verticalRoomForSide >= popupHeight) {
                    return side;
                }
            }

            // Nothing fits fully — pick the side with the most usable room.
            // Avoid left for left-aligned guest bubbles when right has any room.
            var best = fallback;
            var bestScore = -1;
            var score;
            for (i = 0; i < order.length; i++) {
                side = order[i];
                if (side === 'left' && !isRightAligned && space.right > space.left) {
                    continue;
                }
                if (side === 'right' && isRightAligned && space.left > space.right) {
                    continue;
                }
                score = space[side];
                if (score > bestScore) {
                    bestScore = score;
                    best = side;
                }
            }
            return best;
        }

        function closeMessageTranslatePopup()
        {
            clearTranslateLangSearch();
            if (translatePopupMessage) {
                translatePopupMessage._translateOpen = false;
                translatePopupMessage._translatePlacement = null;
                translatePopupMessage = null;
            }
            angular.forEach(vm.messages || [], function (msg) {
                if (msg) {
                    msg._translateOpen = false;
                    msg._translatePlacement = null;
                }
            });
            unbindTranslateDocClickIfIdle();
        }

        function translateMessageBubble(message)
        {
            if (!message || message._translating) {
                return;
            }

            var target = message._translateTarget || 'en';
            var text = String(message.message || '').replace(/^\s+|\s+$/g, '');
            if (!text) {
                return;
            }

            // Toggle off if already showing this language
            if (message._showTranslation && message._translatedLang === target) {
                message._showTranslation = false;
                return;
            }

            if (message._translationsCache && message._translationsCache[target]) {
                message._translatedText = message._translationsCache[target].text ||
                    message._translationsCache[target];
                message._translatedSource = message._translationsCache[target].source ||
                    message._translatedSource ||
                    message.detected_language ||
                    '';
                message._translatedLang = target;
                message._showTranslation = true;
                message._showOriginal = false;
                closeMessageTranslatePopup();
                return;
            }

            message._translating = true;
            messageCenterService.translateText({
                text: text,
                target_language: target,
                message_id: message.local_id || message.id || undefined
            }).then(function (response) {
                message._translating = false;
                if (!response || response.success === false) {
                    toastMessage.showSimpleToast(
                        (response && response.message) || 'Unable to translate message.',
                        'error-toast'
                    );
                    return;
                }
                var data = response.data || {};
                var translated = data.translated_text || '';
                var source = data.source_language || data.detected_language || '';
                if (!message._translationsCache) {
                    message._translationsCache = {};
                }
                message._translationsCache[target] = {
                    text: translated,
                    source: source
                };
                message._translatedText = translated;
                message._translatedLang = target;
                message._translatedSource = source;
                message._showTranslation = true;
                message._showOriginal = false;
                if (source) {
                    message.detected_language = message.detected_language || source;
                }
                closeMessageTranslatePopup();
            }, function () {
                message._translating = false;
                toastMessage.showSimpleToast('Unable to translate message.', 'error-toast');
            });
        }

        function toggleMessageOriginal(message)
        {
            if (!message) {
                return;
            }
            if (message.translation && message.translation.original_text) {
                message._showOriginal = !message._showOriginal;
                message._showTranslation = false;
                return;
            }
            if (message._showTranslation) {
                message._showTranslation = false;
            }
        }

        function toggleComposerTranslate($event)
        {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            if (vm.composerTranslateOpen) {
                closeComposerTranslate();
                return;
            }

            closeMessageTranslatePopup();
            if (vm.quickReplyOpen) {
                closeQuickReplyPicker();
            }
            if (vm.promoteReplyOpen) {
                closePromoteReplyPicker();
            }

            vm.composerTranslateOpen = true;
            bindTranslateDocClick();
            loadTranslateLanguages();
        }

        function closeComposerTranslate()
        {
            vm.composerTranslateOpen = false;
            clearTranslateLangSearch();
            unbindTranslateDocClickIfIdle();
        }

        function bindTranslateDocClick()
        {
            unbindTranslateDocClick();
            translateDocClickHandler = function ()
            {
                $scope.$applyAsync(function () {
                    closeMessageTranslatePopup();
                    closeComposerTranslate();
                });
            };
            $timeout(function () {
                $document.on('click', translateDocClickHandler);
            }, 0);
        }

        function unbindTranslateDocClick()
        {
            if (translateDocClickHandler) {
                $document.off('click', translateDocClickHandler);
                translateDocClickHandler = null;
            }
        }

        function unbindTranslateDocClickIfIdle()
        {
            if (!vm.composerTranslateOpen && !translatePopupMessage) {
                unbindTranslateDocClick();
            }
        }

        function clearReplyTranslation()
        {
            vm.replyTranslation = null;
        }

        function translateComposerDraft()
        {
            var name = getComposerStaffName();
            var parts = messageCenterComposerSignature.split(vm.replyText, name);
            var text = String(parts.body || '').replace(/^\s+|\s+$/g, '');
            var target = vm.composerTranslateLang || 'en';

            if (!text || vm.composerTranslating) {
                return;
            }

            vm.composerTranslating = true;
            messageCenterService.translateText({
                text: text,
                target_language: target
            }).then(function (response) {
                vm.composerTranslating = false;
                if (!response || response.success === false) {
                    toastMessage.showSimpleToast(
                        (response && response.message) || 'Unable to translate draft.',
                        'error-toast'
                    );
                    return;
                }
                var data = response.data || {};
                var translatedBody = String(data.translated_text || '').replace(/^\s+|\s+$/g, '');
                var outboundOriginal = messageCenterComposerSignature.toOutboundMessage(vm.replyText, name);
                var keepSignature = !!(parts.hasSignature && name);
                var outboundTranslated = translatedBody
                    ? (keepSignature ? (translatedBody + ' - ' + name) : translatedBody)
                    : '';

                vm.replyTranslation = {
                    text: outboundTranslated,
                    target_language: data.target_language || target,
                    source_language: data.source_language || '',
                    original_text: outboundOriginal
                };
                closeComposerTranslate();
            }, function () {
                vm.composerTranslating = false;
                toastMessage.showSimpleToast('Unable to translate draft.', 'error-toast');
            });
        }

        function buildOutboundTranslationMeta(originalText)
        {
            if (!vm.replyTranslation || !vm.replyTranslation.text) {
                return null;
            }
            return {
                original_text: originalText || vm.replyTranslation.original_text || '',
                source_language: vm.replyTranslation.source_language || '',
                target_language: vm.replyTranslation.target_language || ''
            };
        }

        function resolveOutboundMessageBody(draftText)
        {
            if (vm.replyTranslation && vm.replyTranslation.text) {
                return String(vm.replyTranslation.text);
            }
            return draftText;
        }

        function normalizeTranslateLanguages(list)
        {
            var seen = {};
            var out = [];
            angular.forEach(list || [], function (lang) {
                if (!lang || !lang.code) {
                    return;
                }
                var code = String(lang.code);
                var key = code.toLowerCase();
                if (seen[key]) {
                    return;
                }
                seen[key] = true;
                out.push({
                    code: code,
                    name: lang.name || code.toUpperCase()
                });
            });
            return out;
        }

        function applyTranslateLanguages(response)
        {
            if (response && response.success !== false && angular.isArray(response.data) && response.data.length) {
                var normalized = normalizeTranslateLanguages(response.data);
                if (normalized.length) {
                    vm.translateLanguages = normalized;
                    vm.translateLanguagesLoaded = true;
                }
            }
            return vm.translateLanguages;
        }

        function loadTranslateLanguages()
        {
            if (vm.translateLanguagesLoaded && vm.translateLanguages.length) {
                return $q.resolve(vm.translateLanguages);
            }

            vm.translateLanguagesLoading = true;
            return messageCenterService.getTranslateLanguages().then(function (response) {
                vm.translateLanguagesLoading = false;
                return applyTranslateLanguages(response);
            }, function () {
                vm.translateLanguagesLoading = false;
                return vm.translateLanguages;
            });
        }

        function getMessageMediaItems(message)
        {
            if (!message || !angular.isArray(message.media)) {
                return [];
            }

            return message.media.filter(function (item) {
                return item && item.sid;
            });
        }

        function hasMessageMedia(message)
        {
            return getMessageMediaItems(message).length > 0;
        }

        var MEDIA_PRELOAD_CONCURRENCY = 3;
        var mediaPreloadActive = 0;
        var mediaPreloadQueue = [];

        function preloadVisibleMessageMedia(messages)
        {
            var list = messages || vm.messages || [];
            var i;

            for (i = 0; i < list.length; i++) {
                enqueueMessageMediaPreload(list[i]);
            }
        }

        function enqueueMessageMediaPreload(message)
        {
            if (!message || !hasMessageMedia(message)) {
                return;
            }

            if (message._mediaExpanded || message._mediaLoading || message._mediaQueued) {
                return;
            }

            message._mediaError = false;
            message._mediaQueued = true;
            mediaPreloadQueue.push(message);
            drainMessageMediaPreloadQueue();
        }

        function drainMessageMediaPreloadQueue()
        {
            var message;

            while (mediaPreloadActive < MEDIA_PRELOAD_CONCURRENCY && mediaPreloadQueue.length) {
                message = mediaPreloadQueue.shift();
                if (!message) {
                    continue;
                }

                message._mediaQueued = false;

                if (message._mediaExpanded || message._mediaLoading || !hasMessageMedia(message)) {
                    continue;
                }

                mediaPreloadActive += 1;
                fetchMessageMedia(message).then(function () {
                    mediaPreloadActive = Math.max(0, mediaPreloadActive - 1);
                    drainMessageMediaPreloadQueue();
                }, function () {
                    mediaPreloadActive = Math.max(0, mediaPreloadActive - 1);
                    drainMessageMediaPreloadQueue();
                });
            }
        }

        function fetchMessageMedia(message, item)
        {
            var items = getMessageMediaItems(message);
            var mediaItem = item || items[0];

            if (!message || !mediaItem || !mediaItem.sid) {
                return $q.resolve();
            }

            if (message._mediaExpanded && message._mediaPreviewUrl) {
                return $q.resolve();
            }

            message._mediaLoading = true;
            message._mediaError = false;

            return messageCenterService.getSmsMedia(mediaItem.sid, vm.subHotelId).then(function (response) {
                message._mediaLoading = false;

                if (!response || response.success === false || !response.data || !response.data.url) {
                    message._mediaError = true;
                    return;
                }

                message._mediaExpanded = true;
                message._mediaPreviewUrl = response.data.url;
                message._mediaPreviewItem = mediaItem;
            }, function () {
                message._mediaLoading = false;
                message._mediaError = true;
            });
        }

        function expandMessageMedia(message, item)
        {
            if (!message || !hasMessageMedia(message)) {
                return;
            }

            if (message._mediaExpanded && message._mediaPreviewUrl) {
                return;
            }

            if (message._mediaLoading) {
                return;
            }

            // Manual retry / force: drop queue flag and fetch now (or re-queue).
            message._mediaQueued = false;
            message._mediaError = false;
            mediaPreloadQueue = mediaPreloadQueue.filter(function (queued) {
                return queued !== message;
            });
            enqueueMessageMediaPreload(message);
        }

        function openImagePreview(ev, imageUrl)
        {
            if (!imageUrl) {
                return;
            }

            if (ev && ev.stopPropagation) {
                ev.stopPropagation();
            }

            $mdDialog.show({
                controller: 'GmcMediaPreviewDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/guest-message-center/dialogs/media-preview/media-preview.dialog.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Image: imageUrl
                }
            });
        }

        function openMessageMedia(ev, message)
        {
            openImagePreview(ev, message && message._mediaPreviewUrl);
        }

        function openPendingMedia(ev)
        {
            openImagePreview(ev, vm.pendingMedia && vm.pendingMedia.previewUrl);
        }

        function isSupportEscalation(message)
        {
            return !!(message && message.sender === 'system' &&
                message.event_type === 'support_escalation');
        }

        function isPhoneChangeNotice(message)
        {
            if (!message || message.sender !== 'system') {
                return false;
            }

            return message.event_type === 'guest_phone_changed' || message.event_type === 'guest_phone_set';
        }

        function getPhoneChangeNoticeText(message)
        {
            if (!message) {
                return '';
            }

            var rawText = message.message || message.body;
            if (rawText) {
                var text = rawText;
                if (message.old_phone) {
                    text = text.replace(message.old_phone, formatPhoneNumber(message.old_phone));
                }
                if (message.new_phone) {
                    text = text.replace(message.new_phone, formatPhoneNumber(message.new_phone));
                }
                return text;
            }

            if (message.event_type === 'guest_phone_set' && message.new_phone) {
                return 'Phone number set to ' + formatPhoneNumber(message.new_phone);
            }

            if (message.old_phone && message.new_phone) {
                return 'Phone number changed from ' + formatPhoneNumber(message.old_phone) +
                    ' to ' + formatPhoneNumber(message.new_phone);
            }

            return getMessageText(message);
        }

        function formatPhoneNumber(phoneNumber)
        {
            return phoneFormatService.format(phoneNumber);
        }

        function getLastMessageDirectionIcon(group)
        {
            if (!group || !group.last_message) {
                return '';
            }

            var sender = group.last_message.sender;

            if (sender !== 'property' && sender !== 'hotel' && sender !== 'ai') {
                return '';
            }

            return 'icon-reply';
        }

        function normalizeThreadPreviewText(text, isMedia)
        {
            var preview = text == null ? '' : String(text).trim();

            if (isMedia && (
                !preview ||
                preview === '[Image]' ||
                preview === 'Photo' ||
                preview === '—' ||
                preview === '-' ||
                preview.toUpperCase() === 'IMAGE'
            )) {
                return 'IMAGE';
            }

            return preview;
        }

        function isLastMessageMedia(group)
        {
            if (!group) {
                return false;
            }

            if (group.last_is_media_attached) {
                return true;
            }

            if (group.last_message) {
                if (group.last_message.is_media_attached || hasMessageMedia(group.last_message)) {
                    return true;
                }

                var msg = group.last_message.message;
                if (msg === 'Photo' || msg === '[Image]' || msg === 'IMAGE') {
                    return true;
                }
            }

            return false;
        }

        function getThreadPreviewText(group)
        {
            if (!group) {
                return '';
            }

            var text = '';

            if (group.last_message && group.last_message.message != null) {
                text = String(group.last_message.message).trim();
            } else if (group.last_message_preview) {
                text = String(group.last_message_preview).trim();
            }

            return normalizeThreadPreviewText(text, isLastMessageMedia(group));
        }

        // ---------------------------------------------------------------------
        // New conversation dialog
        // ---------------------------------------------------------------------

        function openNewConversationDialog(event)
        {
            if (!showDirectFeatures() || !vm.canSendDirect) {
                return;
            }

            $mdDialog.show({
                controller: 'NewSmsConversationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/guest-message-center/direct/dialogs/new-sms-conversation/new-sms-conversation.dialog.html',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                    subHotelId: vm.subHotelId || null,
                    smsEnabled: !!vm.smsEnabled,
                    whatsappEnabled: !!vm.whatsappEnabled
                }
            }).then(function (result) {
                if (result) {
                    onConversationStarted(result);
                }
            }, function () {
                // dialog dismissed
            });
        }

        function openGroupMessageLogs()
        {
            $state.go('app.guest-message-center.group-message-logs');
        }

        /**
         * Map startSmsConversation legacy thread payload into a unified inbox row.
         * Reused Twilio SIDs can still belong to another reservation in the inbox,
         * so we never key/select only by conversation_sid when confirmation is known.
         */
        function buildUnifiedThreadFromStartResult(result)
        {
            var raw = (result && result.thread) || {};
            var confirmation = raw.confirmation_number || (result && result.confirmation_number) || '';
            var channel = raw.channel === 'whatsapp' ? 'whatsapp' : 'sms';
            var sid = raw.conversation_sid || '';
            var phone = raw.guest_phone || '';
            var room = raw.room_number || raw.product_room_number || raw.title || '';
            var when = raw.date_updated || raw.date_created || nowUtc();
            var existing = null;
            var i;
            var channelPayload = {
                conversation_sid: sid,
                guest_phone_e164: phone,
                unread_count: parseInt(raw.direct_msg_unread_counter, 10) || 0,
                is_closed: 0,
                provider: 'twilio'
            };
            var thread;

            if (confirmation) {
                for (i = 0; i < (vm.threads || []).length; i++) {
                    if (vm.threads[i].confirmation_number === confirmation) {
                        existing = vm.threads[i];
                        break;
                    }
                }

                if (!existing) {
                    for (i = 0; i < (vm._allUnifiedThreads || []).length; i++) {
                        if (vm._allUnifiedThreads[i].confirmation_number === confirmation) {
                            existing = vm._allUnifiedThreads[i];
                            break;
                        }
                    }
                }
            }

            thread = existing ? angular.extend({}, existing) : {};
            thread.confirmation_number = confirmation || thread.confirmation_number || '';
            thread.guest_name = raw.guest_name || thread.guest_name || '';
            thread.title = raw.guest_name || thread.title || room || confirmation;
            thread.guest_phone = phone || thread.guest_phone || '';
            thread.hotel_id = raw.hotel_id || thread.hotel_id || null;
            thread.hotel_title = raw.hotel_title || thread.hotel_title || '';
            thread.timezone = raw.timezone || thread.timezone || '';
            thread.checkin_date = raw.checkin_date || thread.checkin_date || '';
            thread.checkout_date = raw.checkout_date || thread.checkout_date || '';
            thread.room_stay_from = thread.checkin_date;
            thread.room_stay_to = thread.checkout_date;
            thread.room_stay_status = raw.room_stay_status || thread.room_stay_status || '';
            thread.room_number = room || thread.room_number || '';
            thread.product_room_number = room || thread.product_room_number || '';
            thread.provider = thread.provider || 'direct';
            thread.channel = channel;
            thread.channels = thread.channels || { ota: null, sms: null, whatsapp: null };
            thread.channels[channel] = angular.extend({}, thread.channels[channel] || {}, channelPayload);
            thread.last_message_at = when;
            thread._activityTs = parseTs(when) || Date.now();
            thread._activityRaw = when;

            return finalizeUnifiedThread(thread);
        }

        function onConversationStarted(result)
        {
            var rawThread = result && result.thread ? result.thread : null;
            var conversationSid = (rawThread && rawThread.conversation_sid) || (result && result.conversation_sid) || '';
            var confirmation = (rawThread && rawThread.confirmation_number) ||
                (result && result.confirmation_number) || '';
            var group;

            if (vm.activeTab === 'group_msg') {
                vm.activeTab = 'all';
            }

            pendingConfirmation = confirmation || '';
            pendingConversationSid = conversationSid || '';

            if (rawThread && !useUnifiedApi) {
                upsertSmsThread(rawThread);
                rebuildThreadList();
            }

            if (useUnifiedApi && (confirmation || conversationSid)) {
                group = buildUnifiedThreadFromStartResult(result);
                promoteThreadToTop(group);
                pendingConfirmation = '';
                pendingConversationSid = '';
                selectThread(group);
                return;
            }

            if (confirmation) {
                var i;
                for (i = 0; i < vm.threads.length; i++) {
                    if (vm.threads[i].confirmation_number === confirmation) {
                        pendingConfirmation = '';
                        pendingConversationSid = '';
                        promoteThreadToTop(vm.threads[i]);
                        selectThread(vm.threads[i]);
                        return;
                    }
                }
            }

            // Only fall back to SID when confirmation is unknown — a reused SID
            // may still be attached to a different reservation in the inbox.
            if (!confirmation && conversationSid) {
                group = findGroupByConversationSid(conversationSid);

                if (group) {
                    pendingConversationSid = '';
                    promoteThreadToTop(group);
                    selectThread(group);
                    return;
                }
            }

            loadThreads();
        }

        function findGroupByConversationSid(conversationSid)
        {
            var lists;
            var l;
            var i;
            var group;
            var channels;

            if (!conversationSid) {
                return null;
            }

            lists = [vm.threads, vm._allUnifiedThreads];

            for (l = 0; l < lists.length; l++) {
                for (i = 0; i < (lists[l] || []).length; i++) {
                    group = lists[l][i];
                    channels = (group && group.channels) || {};

                    if ((channels.sms && channels.sms.conversation_sid === conversationSid) ||
                        (channels.whatsapp && channels.whatsapp.conversation_sid === conversationSid) ||
                        (group._direct && group._direct.conversation_sid === conversationSid) ||
                        (group.conversation_sid === conversationSid)) {
                        return group;
                    }
                }
            }

            return null;
        }

        function findSmsThread(conversationSid)
        {
            var i;

            for (i = 0; i < vm.smsThreads.length; i++) {
                if (vm.smsThreads[i].conversation_sid === conversationSid) {
                    return vm.smsThreads[i];
                }
            }

            return null;
        }

        function findOtaThread(threadId)
        {
            var i;

            for (i = 0; i < vm.otaThreads.length; i++) {
                if (vm.otaThreads[i].thread_id === threadId) {
                    return vm.otaThreads[i];
                }
            }

            return null;
        }

        function upsertSmsThread(thread)
        {
            var existing = findSmsThread(thread.conversation_sid);

            if (existing) {
                angular.forEach(thread, function (value, key) {
                    if (value !== null && value !== undefined && value !== '') {
                        existing[key] = value;
                    }
                });
                return existing;
            }

            vm.smsThreads.unshift(thread);
            return thread;
        }

        // ---------------------------------------------------------------------
        // PubNub realtime + fallback polling
        // ---------------------------------------------------------------------

        function onDestroy()
        {
            stopFallbackPolling();
            broadcastActiveConversation(null);

            if (removePubNubListener) {
                removePubNubListener();
                removePubNubListener = null;
            }

            if (removeSmsPubNubListener) {
                removeSmsPubNubListener();
                removeSmsPubNubListener = null;
            }

            if (visibilityChangeHandler) {
                document.removeEventListener('visibilitychange', visibilityChangeHandler);
                visibilityChangeHandler = null;
            }

            unbindMessagesScroll();
            unbindThreadsScroll();
            closeQuickReplyPicker();
            closeComposerTranslate();
            closeMessageTranslatePopup();
            unbindTranslateDocClick();
        }

        function startRealtime()
        {
            stopFallbackPolling();

            if (vm.canViewOta) {
                removePubNubListener = otaMessageCenterPubNubService.addListener(
                    handlePubNubMessage,
                    handlePubNubStatus
                );
            }

            if (vm.canViewDirect) {
                removeSmsPubNubListener = smsMessageCenterPubNubService.addListener(
                    handleSmsPubNubMessage,
                    handlePubNubStatus
                );
            }

            if (!removePubNubListener && !removeSmsPubNubListener) {
                startFallbackPolling();
            }

            visibilityChangeHandler = function () {
                if (document.hidden) {
                    return;
                }

                messageCenterNavBadgeService.refresh();
                refreshInboxSilently();
                refreshActiveThreadMessages();
            };

            document.addEventListener('visibilitychange', visibilityChangeHandler);
        }

        function handlePubNubStatus(statusEvent)
        {
            if (!statusEvent || !statusEvent.category) {
                return;
            }

            if (statusEvent.category === 'PNNetworkDownCategory') {
                pubNubConnected = false;
                startFallbackPolling();
                return;
            }

            if (statusEvent.category === 'PNNetworkUpCategory') {
                pubNubConnected = true;
                stopFallbackPolling();
                refreshInboxSilently();
            }
        }

        function handlePubNubMessage(data)
        {
            if (!data || !data.event || !belongsToCurrentHotel(data.hotel_id)) {
                return;
            }

            $scope.$applyAsync(function () {
                switch (data.event) {
                    case 'ota_new_message':
                        onNewGuestMessage(data);
                        break;
                    case 'ota_message_received':
                        onMessageReceived(data);
                        break;
                    case 'ota_message_sent':
                        onMessageSent(data);
                        break;
                    case 'ota_thread_read':
                        onThreadRead(data);
                        break;
                    case 'ota_support_escalation':
                        onSupportEscalation(data, 'ota');
                        break;
                    case 'ai_mode_changed':
                        onAiModeChanged(data);
                        break;
                }
            });
        }

        function handleSmsPubNubMessage(data)
        {
            if (!data || !data.event || !belongsToCurrentHotel(data.hotel_id)) {
                return;
            }

            $scope.$applyAsync(function () {
                switch (data.event) {
                    case 'sms_new_message':
                        onNewSmsGuestMessage(data);
                        break;
                    case 'sms_message_sent':
                        onSmsMessageSent(data);
                        break;
                    case 'sms_thread_read':
                        onSmsThreadRead(data);
                        break;
                    case 'guest_phone_changed':
                        onGuestPhoneChanged(data);
                        break;
                    case 'messaging_opt_out_changed':
                        onMessagingOptOutChanged(data);
                        break;
                    case 'thread_archived_changed':
                        onThreadArchivedChanged(data);
                        break;
                    case 'thread_acknowledged':
                        onThreadAcknowledgedChanged(data);
                        break;
                    case 'ai_mode_changed':
                        onAiModeChanged(data);
                        break;
                    case 'sms_support_escalation':
                        onSupportEscalation(data, 'sms');
                        break;
                }
            });
        }

        function getSelectedHotelId()
        {
            if (!$localStorage.hotels || $localStorage.selectedHotel === undefined) {
                return null;
            }

            return $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
        }

        function getSubHotelIds()
        {
            var ids = [];
            var i;

            if (!vm.subHotels || !vm.subHotels.length) {
                return ids;
            }

            for (i = 0; i < vm.subHotels.length; i++) {
                if (vm.subHotels[i].hotel_id) {
                    ids.push(parseInt(vm.subHotels[i].hotel_id, 10));
                }
            }

            return ids;
        }

        function belongsToCurrentHotel(hotelId)
        {
            if (!hotelId) {
                return true;
            }

            var selectedHotelId = getSelectedHotelId();
            var normalizedHotelId = parseInt(hotelId, 10);

            if (selectedHotelId && normalizedHotelId === parseInt(selectedHotelId, 10)) {
                return true;
            }

            return getSubHotelIds().indexOf(normalizedHotelId) !== -1;
        }

        function isSelectedOtaThread(threadId)
        {
            if (!vm.selectedThread || !threadId) {
                return false;
            }

            if (vm.selectedThread._ota && vm.selectedThread._ota.thread_id === threadId) {
                return true;
            }

            return !!(vm.selectedThread.channels && vm.selectedThread.channels.ota &&
                vm.selectedThread.channels.ota.message_thread_id === threadId);
        }

        function isSelectedSmsThread(conversationSid)
        {
            if (!vm.selectedThread || !conversationSid) {
                return false;
            }

            if (vm.selectedThread._direct &&
                vm.selectedThread._direct.conversation_sid === conversationSid) {
                return true;
            }

            var channels = vm.selectedThread.channels || {};

            return (channels.sms && channels.sms.conversation_sid === conversationSid) ||
                (channels.whatsapp && channels.whatsapp.conversation_sid === conversationSid);
        }

        function isSelectedConfirmation(confirmationNumber)
        {
            return !!(vm.selectedThread && confirmationNumber &&
                vm.selectedThread.confirmation_number === confirmationNumber);
        }

        function onNewGuestMessage(data)
        {
            var selected = (data.confirmation_number && isSelectedConfirmation(data.confirmation_number)) ||
                isSelectedOtaThread(data.message_thread_id);

            applyPubNubToLocalRows(data, null, data.sender || 'guest');

            if (selected) {
                markSelectedThreadRead({
                    confirmation_number: data.confirmation_number,
                    message_thread_id: data.message_thread_id
                }, data);
                refreshActiveThreadMessages();
                return;
            }

            if (useUnifiedApi) {
                if (data.ota_msg_unread_count == null && vm.threadPage === 1) {
                    refreshInboxSilently();
                }

                return;
            }

            if (findOtaThread(data.message_thread_id)) {
                rebuildThreadList();
            } else if (vm.otaPage === 1 && canFetchOta()) {
                refreshInboxSilently();
            }
        }

        function onMessageReceived(data)
        {
            var isSelected = eventTargetsSelected(data);

            applyPubNubToLocalRows(data, null, data.sender || 'property');

            if (isSelected) {
                refreshActiveThreadMessages();
            } else if (data.confirmation_number && vm.threadPage === 1 && useUnifiedApi) {
                refreshInboxSilently();
            }
        }

        function onMessageSent(data)
        {
            onOutboundMessageEvent(data, data.channel || 'ota');
        }

        function onThreadRead(data)
        {
            applyPubNubToLocalRows({
                message_thread_id: data.message_thread_id,
                confirmation_number: data.confirmation_number,
                ota_msg_unread_count: 0
            }, null);

            if (useUnifiedApi) {
                applyUnifiedTabFilter();
                return;
            }

            if (findOtaThread(data.message_thread_id) ||
                (data.confirmation_number && findGroupByConfirmation(data.confirmation_number))) {
                rebuildThreadList();
            }
        }

        function onNewSmsGuestMessage(data)
        {
            var conversationSid = data.conversation_sid || '';
            var confirmation = data.confirmation_number || '';
            var channel = data.channel || 'sms';
            var isSelected = isSelectedSmsThread(conversationSid) ||
                (confirmation && isSelectedConfirmation(confirmation));

            if ((data.opt_out === 'stop' || data.opt_out === 'start') && isSelected && vm.selectedThread) {
                vm.selectedThread.messaging_opt_out = data.opt_out === 'stop';
                refreshMessagingContext(vm.selectedThread.confirmation_number);
            }

            applyPubNubToLocalRows(data, null, data.sender || 'guest');

            if (isSelected) {
                if (channel === 'sms' || channel === 'whatsapp' || channel === 'ota') {
                    setComposerChannel(channel);
                }

                markSelectedThreadRead({
                    confirmation_number: confirmation ||
                        (vm.selectedThread && vm.selectedThread.confirmation_number) || '',
                    conversation_sid: conversationSid
                }, data);
                refreshActiveThreadMessages();

                if (confirmation || (vm.selectedThread && vm.selectedThread.confirmation_number)) {
                    refreshMessagingContext(confirmation || vm.selectedThread.confirmation_number);
                }

                return;
            }

            if (useUnifiedApi) {
                if (data.direct_msg_unread_counter == null && vm.threadPage === 1) {
                    refreshInboxSilently();
                }

                return;
            }

            if (!conversationSid) {
                return;
            }

            if (findSmsThread(conversationSid)) {
                rebuildThreadList();
            } else if (vm.smsPage === 1 && canFetchSms()) {
                refreshInboxSilently();
            }
        }

        function onSmsMessageSent(data)
        {
            onOutboundMessageEvent(data, data.channel || 'sms');
        }

        function onAiModeChanged(data)
        {
            if (!data || !data.confirmation_number) {
                return;
            }

            setAiModeLocal(data.confirmation_number, data.ai_mode);
            appendAiModeNoticeIfOpen(data.confirmation_number, data.message);
        }

        function onSupportEscalation(data, source)
        {
            var confirmation = data.confirmation_number || '';
            var channel = data.channel || (source === 'ota' ? 'ota' : 'sms');
            var isSelected = eventTargetsSelected(data);
            var notice;

            setAiModeLocal(
                confirmation || (isSelected && vm.selectedThread && vm.selectedThread.confirmation_number) || '',
                data.ai_mode != null ? data.ai_mode : false
            );

            if (!confirmation && isSelected && vm.selectedThread) {
                vm.selectedThread.ai_mode = false;
            }

            applyPubNubToLocalRows(data, null, 'system');

            if (data.message && typeof data.message === 'object') {
                notice = normalizeChannelMessages(
                    [angular.copy(data.message)],
                    data.message.channel || channel
                )[0];

                if (notice) {
                    notice.sender = notice.sender || 'system';
                    notice.event_type = notice.event_type || 'support_escalation';
                }

                if (notice && isSelected && appendSentMessage(notice) && isMessagesAtBottom()) {
                    scrollMessagesToBottom();
                } else if (notice) {
                    applyPubNubToLocalRows(data, notice, 'system');
                }
            } else if (isSelected) {
                refreshActiveThreadMessages();
            }

            if (isSelected && vm.selectedThread) {
                markSelectedThreadRead({
                    confirmation_number: confirmation || vm.selectedThread.confirmation_number || '',
                    conversation_sid: data.conversation_sid || '',
                    message_thread_id: data.message_thread_id || ''
                }, data);
            } else if (confirmation && useUnifiedApi && vm.threadPage === 1 &&
                !findGroupByConfirmation(confirmation)) {
                refreshInboxSilently();
            } else {
                markLocalEscalationUnread(confirmation);
            }
        }

        function markLocalEscalationUnread(confirmation)
        {
            if (!confirmation) {
                return;
            }

            var group = findGroupByConfirmation(confirmation);
            if (!group) {
                return;
            }

            group.has_escalation_unread = true;
            group.has_guest_after_escalation = false;
            if (useUnifiedApi) {
                upsertUnifiedThread(group);
            } else {
                rebuildThreadList();
            }
        }

        function onSmsThreadRead(data)
        {
            var conversationSid = data.conversation_sid || '';
            var confirmation = data.confirmation_number || '';
            var directThread;
            var i;

            applyPubNubToLocalRows({
                conversation_sid: conversationSid,
                confirmation_number: confirmation,
                direct_msg_unread_counter: 0
            }, null);

            if (useUnifiedApi) {
                applyUnifiedTabFilter();
                return;
            }

            if (!conversationSid && confirmation) {
                for (i = 0; i < vm.smsThreads.length; i++) {
                    if (vm.smsThreads[i].confirmation_number === confirmation) {
                        conversationSid = vm.smsThreads[i].conversation_sid;
                        break;
                    }
                }
            }

            if (!conversationSid) {
                return;
            }

            directThread = findSmsThread(conversationSid);

            if (directThread) {
                directThread.direct_msg_unread_counter = 0;
                rebuildThreadList();
            }
        }

        function onGuestPhoneChanged(data)
        {
            var confirmation = data.confirmation_number || '';

            if (!confirmation || !vm.selectedThread || vm.selectedThread.confirmation_number !== confirmation) {
                return;
            }

            if (data.message && typeof data.message === 'object') {
                var notices = normalizeUnifiedMessages([angular.copy(data.message)]);
                var added = addMessages(notices);

                if (added.length && isMessagesAtBottom()) {
                    scrollMessagesToBottom();
                }
            }

            refreshMessagingContext(confirmation);
        }

        function onMessagingOptOutChanged(data)
        {
            var confirmation = data.confirmation_number || '';
            var conversationSid = data.conversation_sid || '';
            var optedOut = !!data.messaging_opt_out;
            var group = null;
            var i;

            if (confirmation && vm.selectedThread &&
                vm.selectedThread.confirmation_number === confirmation) {
                group = vm.selectedThread;
            } else if (conversationSid) {
                group = findGroupByConversationSid(conversationSid);
            }

            if (!group && confirmation) {
                for (i = 0; i < (vm.threads || []).length; i++) {
                    if (vm.threads[i].confirmation_number === confirmation) {
                        group = vm.threads[i];
                        break;
                    }
                }
            }

            if (group) {
                group.messaging_opt_out = optedOut;

                if (group._direct) {
                    group._direct.messaging_opt_out = optedOut;
                }
            }

            if ((isSelectedConfirmation(confirmation) || isSelectedSmsThread(conversationSid)) &&
                data.message && typeof data.message === 'object') {
                var notices = normalizeUnifiedMessages([angular.copy(data.message)]);
                var added = addMessages(notices);

                if (added.length && isMessagesAtBottom()) {
                    scrollMessagesToBottom();
                }
            }

            if (confirmation) {
                refreshMessagingContext(confirmation);
            }
        }

        function onThreadArchivedChanged(data)
        {
            var confirmation = data.confirmation_number || '';
            var conversationSid = data.conversation_sid || '';
            var archived = !!data.is_archived;

            if (!confirmation) {
                return;
            }

            setArchivedLocal(confirmation, archived);

            if ((isSelectedConfirmation(confirmation) || isSelectedSmsThread(conversationSid)) &&
                data.message && typeof data.message === 'object') {
                var notices = normalizeUnifiedMessages([angular.copy(data.message)]);
                var added = addMessages(notices);

                if (added.length && isMessagesAtBottom()) {
                    scrollMessagesToBottom();
                }
            }

            // Keep list membership in sync for other open clients.
            if ((vm.isArchiveView && !archived) || (!vm.isArchiveView && archived)) {
                removeConfirmationFromLists(confirmation);
            }
        }

        function startFallbackPolling()
        {
            if (fallbackPollTimer) {
                return;
            }

            fallbackPollTimer = $interval(function () {
                if (document.hidden || pubNubConnected) {
                    return;
                }

                refreshInboxSilently();
                refreshActiveThreadMessages();
            }, FALLBACK_POLL_INTERVAL_MS);
        }

        function stopFallbackPolling()
        {
            if (fallbackPollTimer) {
                $interval.cancel(fallbackPollTimer);
                fallbackPollTimer = null;
            }
        }

        function refreshInboxSilently()
        {
            pollThreadsSilently();
        }

        function refreshActiveThreadMessages()
        {
            if (!vm.selectedThread) {
                return;
            }

            pollMessagesSilently();
        }

        function schedulePendingMessagesRefresh()
        {
            if (!pendingMessagesRefresh) {
                return;
            }

            pendingMessagesRefresh = false;
            $timeout(function () {
                refreshActiveThreadMessages();
            }, 0);
        }

        function pollThreadsSilently()
        {
            if (!vm.canGetThreads || vm.loadingThreads || pollThreadsInFlight || document.hidden) {
                return;
            }

            pollThreadsInFlight = true;

            if (useUnifiedApi) {
                fetchUnifiedThreads(1, false).then(function (ok) {
                    pollThreadsInFlight = false;

                    if (!ok) {
                        // fall through next tick via legacy if needed
                    }
                }, function () {
                    pollThreadsInFlight = false;
                });
                return;
            }

            var promises = [];

            if (canFetchOta()) {
                promises.push(pollOtaThreads());
            }

            if (canFetchSms()) {
                promises.push(pollSmsThreads());
            }

            if (!promises.length) {
                pollThreadsInFlight = false;
                return;
            }

            $q.all(promises).then(function () {
                pollThreadsInFlight = false;
                rebuildThreadList();
            }, function () {
                pollThreadsInFlight = false;
            });
        }

        function pollOtaThreads()
        {
            var params = {
                page: 1,
                limit: vm.threadLimit
            };

            if (vm.subHotelId) {
                params.sub_hotel_id = vm.subHotelId;
            }

            return messageCenterService.getMessageThreads(params).then(function (response) {
                if (!response || response.success === false) {
                    return;
                }

                var fresh = response.data || [];

                if (vm.otaPage === 1) {
                    vm.otaThreads = fresh;
                } else {
                    mergeFreshThreads(vm.otaThreads, fresh, 'thread_id');
                }

                vm.otaTotal = (response.meta && response.meta.total) ? response.meta.total : vm.otaTotal;
            }, function () {});
        }

        function pollSmsThreads()
        {
            var params = {
                page: 1,
                limit: vm.threadLimit
            };

            if (vm.subHotelId) {
                params.sub_hotel_id = vm.subHotelId;
            }

            return messageCenterService.getSmsThreads(params).then(function (response) {
                if (!response || response.success === false) {
                    return;
                }

                var fresh = response.data || [];

                if (vm.smsPage === 1) {
                    vm.smsThreads = fresh;
                } else {
                    mergeFreshThreads(vm.smsThreads, fresh, 'conversation_sid');
                }
            }, function () {});
        }

        function mergeFreshThreads(current, fresh, idKey)
        {
            var freshById = {};
            var i;

            for (i = 0; i < fresh.length; i++) {
                freshById[fresh[i][idKey]] = fresh[i];
            }

            for (i = 0; i < current.length; i++) {
                var match = freshById[current[i][idKey]];

                if (match) {
                    angular.forEach(match, function (value, key) {
                        if (value !== null && value !== undefined && value !== '') {
                            current[i][key] = value;
                        }
                    });
                }
            }
        }

        function pollMessagesSilently()
        {
            var group = vm.selectedThread;

            if (!group || !vm.canGetMessages || document.hidden) {
                return;
            }

            // PubNub can fire while a load/send is in flight — retry after it finishes.
            if (vm.loadingMessages || vm.sendingMessage || pollMessagesInFlight) {
                pendingMessagesRefresh = true;
                return;
            }

            pollMessagesInFlight = true;

            var selectedKey = vm.selectedKey;
            var shouldScroll = isMessagesAtBottom();

            if (useUnifiedApi && group.confirmation_number) {
                loadUnifiedMessages(1, true).then(function (result) {
                    pollMessagesInFlight = false;

                    if (!result || !result.ok || !vm.selectedThread || vm.selectedKey !== selectedKey) {
                        schedulePendingMessagesRefresh();
                        return;
                    }

                    var added = result.added || [];

                    if (hasGuestMessages(added)) {
                        markSelectedThreadRead({
                            confirmation_number: vm.selectedThread.confirmation_number
                        });
                    }

                    if (added && added.length) {
                        setDefaultComposerChannel(vm.selectedThread);
                    }

                    if (shouldScroll && added && added.length) {
                        scrollMessagesToBottom();
                    }

                    schedulePendingMessagesRefresh();
                }, function () {
                    pollMessagesInFlight = false;
                    schedulePendingMessagesRefresh();
                });
                return;
            }

            var promises = [];

            if (group._ota) {
                promises.push(
                    messageCenterService.getThreadMessages(group._ota.thread_id, 1, vm.messageLimit)
                        .then(function (response) {
                            return { channel: 'ota', response: response };
                        })
                );
            }

            if (group._direct) {
                promises.push(
                    messageCenterService.getSmsThreadMessages(buildSmsMessageParams(group._direct, 1))
                        .then(function (response) {
                            return { channel: 'direct', response: response };
                        })
                );
            }

            if (!promises.length) {
                pollMessagesInFlight = false;
                schedulePendingMessagesRefresh();
                return;
            }

            $q.all(promises).then(function (results) {
                pollMessagesInFlight = false;

                if (!vm.selectedThread || vm.selectedKey !== selectedKey) {
                    schedulePendingMessagesRefresh();
                    return;
                }

                var collected = [];

                results.forEach(function (result) {
                    var response = result.response;

                    if (!response || response.success === false) {
                        return;
                    }

                    collected = collected.concat(normalizeChannelMessages(response.data || [], result.channel));

                    if (result.channel === 'ota') {
                        vm.msgOta.total = (response.meta && response.meta.total) ? response.meta.total : vm.msgOta.total;
                    }
                });

                var added = addMessages(collected);

                if (!added.length) {
                    schedulePendingMessagesRefresh();
                    return;
                }

                updateMessageStayDates(vm.messages);
                updateLoadEarlierVisibility();

                if (hasGuestMessages(added)) {
                    markSelectedThreadRead({
                        confirmation_number: vm.selectedThread.confirmation_number,
                        conversation_sid: vm.selectedThread._direct &&
                            vm.selectedThread._direct.conversation_sid,
                        message_thread_id: vm.selectedThread._ota &&
                            vm.selectedThread._ota.thread_id
                    });
                    rebuildThreadList();
                }

                if (shouldScroll) {
                    scrollMessagesToBottom();
                }

                schedulePendingMessagesRefresh();
            }, function () {
                pollMessagesInFlight = false;
                schedulePendingMessagesRefresh();
            });
        }

        function hasGuestMessages(messages)
        {
            var i;

            for (i = 0; i < (messages || []).length; i++) {
                if (messages[i].sender === 'guest') {
                    return true;
                }
            }

            return false;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .controller('GroupMessagesController', GroupMessagesController);

    /** @ngInject */
    function GroupMessagesController(
        $scope,
        $rootScope,
        $localStorage,
        $q,
        $mdDialog,
        $document,
        $timeout,
        toastMessage,
        messageCenterService,
        dashboardGraphService,
        phoneFormatService,
        messageCenterNavBadgeService
    )
    {
        var vm = this;
        var guestsRequestId = 0;
        var threadStatusByConfirmation = {};
        var allInHouseGuests = [];
        var guestsLoaded = false;
        var channelFlagsFromSettings = false;
        var quickReplyDocClickHandler = null;
        var quickReplyCache = null;

        var promoteReplyDocClickHandler = null;
        var promoteReplyCache = null;

        vm.subHotels = $rootScope.subHotels || [];
        vm.selectedSubHotelIds = {};
        vm.selectedConfirmations = {};
        vm.channel = 'default';
        vm.message = '';
        vm.smsEnabled = true;
        vm.whatsappEnabled = true;
        vm.canSendDirect = hasDirectPermission();
        vm.sending = false;
        vm.loadingGuests = false;
        vm.loadingGuestCount = false;
        vm.inHouseGuestCount = 0;
        vm.deliverableGuestCount = 0;
        vm.inHouseGuests = [];
        vm.eligibleGuests = [];
        vm.ineligibleGuests = [];
        vm.guestHasMore = false;
        vm.eligibilityIncomplete = false;
        vm.lastResult = null;
        vm.skipSendConfirm = false;
        vm.inHouseEnabled = true;
        vm.stayFilterMode = 'in_house';

        vm.getGuestUnreadTotal = messageCenterNavBadgeService.getGuestUnreadTotal;
        vm.getStaffUnreadTotal = messageCenterNavBadgeService.getStaffUnreadTotal;

        vm.setChannel = setChannel;
        vm.getChannelLabel = getChannelLabel;
        vm.toggleProperty = toggleProperty;
        vm.selectAllProperties = selectAllProperties;
        vm.isPropertySelected = isPropertySelected;
        vm.isPropertyTagActive = isPropertyTagActive;
        vm.isAllPropertiesSelected = isAllPropertiesSelected;
        vm.getPropertyShortName = getPropertyShortName;
        vm.getInHouseTagLabel = getInHouseTagLabel;
        vm.getRecipientLabel = getRecipientLabel;
        vm.getGuestInitial = getGuestInitial;
        vm.isGuestSelected = isGuestSelected;
        vm.toggleGuest = toggleGuest;
        vm.selectAllEligible = selectAllEligible;
        vm.clearGuestSelection = clearGuestSelection;
        vm.areAllEligibleSelected = areAllEligibleSelected;
        vm.getSelectedCount = getSelectedCount;
        vm.canSubmit = canSubmit;
        vm.sendBroadcast = sendBroadcast;
        vm.getReasonLabel = getReasonLabel;
        
        vm.checkoutFilter = null;
        vm.setCheckoutFilter = setCheckoutFilter;
        vm.onCustomCheckoutDateChange = onCustomCheckoutDateChange;
        vm.customCheckoutDate = new Date();

        vm.checkinFilter = null;
        vm.setCheckinFilter = setCheckinFilter;
        vm.onCustomCheckinDateChange = onCustomCheckinDateChange;
        vm.customCheckinDate = new Date();
        vm.onStayFilterModeChange = onStayFilterModeChange;

        vm.quickReplyOpen = false;
        vm.quickReplyLoading = false;
        vm.quickReplySearch = '';
        vm.quickReplyCategories = [];
        vm.quickReplyFiltered = [];

        vm.promoteReplyOpen = false;
        vm.promoteReplyLoading = false;
        vm.promoteReplySearch = '';
        vm.promoteReplyCategories = [];
        vm.promoteReplyFiltered = [];
        
        vm.togglePromoteReplyPicker = togglePromoteReplyPicker;
        vm.filterPromoteReplies = filterPromoteReplies;
        vm.applyPromoteReply = applyPromoteReply;
        vm.closePromoteReplyPicker = closePromoteReplyPicker;
        vm.toggleQuickReplyPicker = toggleQuickReplyPicker;
        vm.filterQuickReplies = filterQuickReplies;
        vm.applyQuickReply = applyQuickReply;
        vm.formatPhoneNumber = formatPhoneNumber;

        init();
        $scope.$on('$destroy', onDestroy);

        function init()
        {
            phoneFormatService.ensureUtilsLoaded();
            loadChannelEnabledFlags();

            if ($rootScope.isParent && $rootScope.subHotels && $rootScope.subHotels.length) {
                vm.subHotels = $rootScope.subHotels;
                loadInHouseGuests(true);
                return;
            }

            if ($localStorage.hotels && $localStorage.selectedHotel !== undefined) {
                $rootScope.getSubHotels($localStorage.hotels[$localStorage.selectedHotel].hotel_id, true);
                $scope.$watch(function () {
                    return $rootScope.subHotelsOfSelected;
                }, function (subHotels) {
                    if (subHotels && subHotels.length) {
                        vm.subHotels = subHotels;
                        if (!guestsLoaded) {
                            loadInHouseGuests(true);
                        }
                    }
                });
            }

            loadInHouseGuests(true);
        }

        function isEnabledFlag(value)
        {
            return value === true || value === 1 || value === '1';
        }

        function applyChannelEnabledFlags(source)
        {
            var settings;
            var fromSettings = false;

            if (!source) {
                return false;
            }

            settings = source.settings || source;
            fromSettings = settings.sms_messaging_enabled !== undefined ||
                settings.whatsapp_messaging_enabled !== undefined;

            if (fromSettings) {
                if (settings.sms_messaging_enabled !== undefined) {
                    vm.smsEnabled = isEnabledFlag(settings.sms_messaging_enabled);
                }

                if (settings.whatsapp_messaging_enabled !== undefined) {
                    vm.whatsappEnabled = isEnabledFlag(settings.whatsapp_messaging_enabled);
                }

                channelFlagsFromSettings = true;
                return true;
            }

            if (channelFlagsFromSettings) {
                return false;
            }

            if (source.sms_enabled !== undefined) {
                vm.smsEnabled = !!source.sms_enabled;
            }

            if (source.whatsapp_enabled !== undefined) {
                vm.whatsappEnabled = !!source.whatsapp_enabled;
            }

            return source.sms_enabled !== undefined || source.whatsapp_enabled !== undefined;
        }

        function hasAnyDirectChannelEnabled()
        {
            return !!(vm.smsEnabled || vm.whatsappEnabled);
        }

        function isChannelAvailable(channel)
        {
            if (channel === 'default') {
                return !!(vm.smsEnabled && vm.whatsappEnabled);
            }

            if (channel === 'sms') {
                return !!vm.smsEnabled;
            }

            if (channel === 'whatsapp') {
                return !!vm.whatsappEnabled;
            }

            return false;
        }

        function normalizeSelectedChannel()
        {
            if (isChannelAvailable(vm.channel)) {
                return;
            }

            if (vm.smsEnabled && vm.whatsappEnabled) {
                vm.channel = 'default';
            } else if (vm.smsEnabled) {
                vm.channel = 'sms';
            } else if (vm.whatsappEnabled) {
                vm.channel = 'whatsapp';
            } else {
                vm.channel = 'default';
            }

            refreshGuestDeliveryFlags();
        }

        function loadChannelEnabledFlags()
        {
            if (!vm.canSendDirect) {
                return;
            }

            messageCenterService.getSettings({}).then(function (response) {
                if (!response || response.success === false) {
                    return;
                }

                applyChannelEnabledFlags(response);
                normalizeSelectedChannel();
            });
        }

        function permsContains(key)
        {
            var perms = $rootScope.userPermissions || '';
            return !!perms && perms.indexOf(key) !== -1;
        }

        function hasDirectPermission()
        {
            return permsContains('All') ||
                permsContains('message_center') ||
                permsContains('direct');
        }

        function setChannel(channel)
        {
            if (!isChannelAvailable(channel)) {
                return;
            }

            if (channel === 'sms' || channel === 'whatsapp' || channel === 'default') {
                vm.channel = channel;
                refreshGuestDeliveryFlags();
            }
        }

        function getChannelLabel()
        {
            if (vm.channel === 'whatsapp') {
                return 'WhatsApp';
            }

            if (vm.channel === 'default') {
                return 'Default';
            }

            return 'SMS';
        }

        function normalizeHotelId(hotelId)
        {
            var id = parseInt(hotelId, 10);

            return isNaN(id) ? null : id;
        }

        function getSelectedSubHotelIds()
        {
            return Object.keys(vm.selectedSubHotelIds || {}).filter(function (key) {
                return !!vm.selectedSubHotelIds[key];
            }).map(normalizeHotelId).filter(function (id) {
                return id !== null;
            });
        }

        function isAllPropertiesSelected()
        {
            return !getSelectedSubHotelIds().length;
        }

        function getPropertyShortName(hotel)
        {
            var title = ((hotel && hotel.hotel_title) || '').toLowerCase();

            if (title.indexOf('bayview') !== -1) {
                return 'Bayview';
            }

            if (title.indexOf('bay palms') !== -1) {
                return 'Baypalms';
            }

            if (title.indexOf('plaza beach') !== -1) {
                return 'Plazabeach';
            }

            return (hotel && hotel.hotel_title) || '';
        }

        function getInHouseTagLabel(hotel)
        {
            var shortName = getPropertyShortName(hotel);

            return shortName ? ('InHouse ' + shortName) : 'InHouse';
        }

        function isPropertySelected(hotelId)
        {
            var id = normalizeHotelId(hotelId);

            if (id === null) {
                return false;
            }

            if (isAllPropertiesSelected()) {
                return true;
            }

            return !!vm.selectedSubHotelIds[id] || !!vm.selectedSubHotelIds[String(id)];
        }

        // Highlight only explicitly selected tags (not when "All Hotels" is active).
        function isPropertyTagActive(hotelId)
        {
            var id = normalizeHotelId(hotelId);

            if (id === null || isAllPropertiesSelected()) {
                return false;
            }

            return !!vm.selectedSubHotelIds[id] || !!vm.selectedSubHotelIds[String(id)];
        }

        function applyStayFilterMode(mode, options)
        {
            var nextMode = mode || 'in_house';
            var reload = !(options && options.skipReload);

            vm.stayFilterMode = nextMode;

            if (nextMode === 'checkin') {
                vm.inHouseEnabled = false;
                vm.checkoutFilter = null;
                if (!vm.checkinFilter) {
                    vm.checkinFilter = 'today';
                    vm.customCheckinDate = new Date();
                }
            } else if (nextMode === 'checkout') {
                vm.inHouseEnabled = false;
                vm.checkinFilter = null;
                if (!vm.checkoutFilter) {
                    vm.checkoutFilter = 'today';
                    vm.customCheckoutDate = new Date();
                }
            } else if (nextMode === 'waiting_for_room') {
                vm.inHouseEnabled = false;
                vm.checkinFilter = null;
                vm.checkoutFilter = null;
            } else {
                vm.stayFilterMode = 'in_house';
                vm.inHouseEnabled = true;
                vm.checkinFilter = null;
                vm.checkoutFilter = null;
            }

            if (reload) {
                guestsLoaded = false;
                loadInHouseGuests(true);
            }
        }

        function onStayFilterModeChange()
        {
            applyStayFilterMode(vm.stayFilterMode);
        }

        function selectAllProperties()
        {
            // Empty selection means all hotels are included.
            if (isAllPropertiesSelected()) {
                return;
            }

            vm.selectedSubHotelIds = {};
            applyPropertyFilter();
        }

        function toggleProperty(hotelId)
        {
            var id = normalizeHotelId(hotelId);
            var selected;

            if (id === null) {
                return;
            }

            // From "All Hotels": first click selects only that property.
            if (!getSelectedSubHotelIds().length) {
                vm.selectedSubHotelIds = {};
                vm.selectedSubHotelIds[id] = true;
                applyPropertyFilter();
                return;
            }

            if (vm.selectedSubHotelIds[id] || vm.selectedSubHotelIds[String(id)]) {
                delete vm.selectedSubHotelIds[id];
                delete vm.selectedSubHotelIds[String(id)];
            } else {
                vm.selectedSubHotelIds[id] = true;
            }

            selected = getSelectedSubHotelIds();

            // Selecting every property individually is the same as "All Hotels".
            if (vm.subHotels.length && selected.length === vm.subHotels.length) {
                vm.selectedSubHotelIds = {};
            }

            // Unchecking the last hotel falls back to all hotels.
            applyPropertyFilter();
        }

        function findHotelIdByTitle(title)
        {
            var i;
            var hotelTitle = (title || '').trim().toLowerCase();

            if (!hotelTitle) {
                return null;
            }

            for (i = 0; i < vm.subHotels.length; i++) {
                if (((vm.subHotels[i].hotel_title || '').trim().toLowerCase()) === hotelTitle) {
                    return normalizeHotelId(vm.subHotels[i].hotel_id);
                }
            }

            return null;
        }

        function getGuestInitial(guest)
        {
            var name;

            if (!guest) {
                return '?';
            }

            name = (guest.guest_name || guest.confirmation_number || '').trim();

            return name ? name.charAt(0).toUpperCase() : '?';
        }

        function refreshGuestDeliveryFlags(options)
        {
            var i;
            var guest;
            var info;
            var hasChat;
            var statuses;

            for (i = 0; i < vm.inHouseGuests.length; i++) {
                guest = vm.inHouseGuests[i];
                info = threadStatusByConfirmation[guest.confirmation_number] || {};
                if (vm.channel === 'default') {
                    hasChat = !!((vm.smsEnabled && info.has_sms) || (vm.whatsappEnabled && info.has_whatsapp));
                } else {
                    hasChat = vm.channel === 'whatsapp' ? !!info.has_whatsapp : !!info.has_sms;
                }
                statuses = [];

                guest.messaging_opt_out = !!info.messaging_opt_out;
                guest.has_open_chat = hasChat;
                // Prefer active-chat phone; otherwise default to traveler/reservation phone.
                guest.phone = ((info.guest_phone || guest.reservation_phone || '') + '').trim();
                guest.has_phone = !!guest.phone;

                // WhatsApp cannot start a brand-new freeform chat from broadcast.
                // Default/SMS can open a new SMS thread using the traveler phone.
                if (vm.channel === 'whatsapp') {
                    guest.can_deliver = !guest.messaging_opt_out && hasChat;
                } else {
                    guest.can_deliver = !guest.messaging_opt_out && guest.has_phone;
                }

                if (guest.messaging_opt_out) {
                    statuses.push({ key: 'opted_out', label: 'Opt out' });
                }

                if (vm.channel === 'whatsapp' && guest.has_phone && !hasChat) {
                    statuses.push({ key: 'no_chat', label: 'No WhatsApp chat' });
                } else if (!guest.has_phone) {
                    statuses.push({ key: 'no_phone', label: 'No phone' });
                } else if (!guest.has_open_chat) {
                    statuses.push({ key: 'no_chat', label: 'New chat' });
                } else {
                    statuses.push({ key: 'chat_open', label: 'Chat open' });
                }

                guest.statuses = statuses;
            }

            splitGuestsByEligibility();
            vm.deliverableGuestCount = getDeliverableCount();
            syncGuestSelection(options);
        }

        function splitGuestsByEligibility()
        {
            var i;
            var guest;
            var eligible = [];
            var ineligible = [];

            for (i = 0; i < vm.inHouseGuests.length; i++) {
                guest = vm.inHouseGuests[i];
                if (guest.can_deliver) {
                    eligible.push(guest);
                } else {
                    ineligible.push(guest);
                }
            }

            vm.eligibleGuests = eligible;
            vm.ineligibleGuests = ineligible;
        }

        function isGuestSelected(guest)
        {
            var confirmation = guest && guest.confirmation_number;

            return !!(confirmation && vm.selectedConfirmations[confirmation]);
        }

        function toggleGuest(guest, $event)
        {
            var confirmation;

            if ($event) {
                $event.stopPropagation();
            }

            if (!guest || !guest.can_deliver) {
                return;
            }

            confirmation = guest.confirmation_number;
            if (!confirmation) {
                return;
            }

            if (vm.selectedConfirmations[confirmation]) {
                delete vm.selectedConfirmations[confirmation];
            } else {
                vm.selectedConfirmations[confirmation] = true;
            }
        }

        function selectAllEligible()
        {
            var i;
            var confirmation;

            for (i = 0; i < vm.eligibleGuests.length; i++) {
                confirmation = vm.eligibleGuests[i].confirmation_number;
                if (confirmation) {
                    vm.selectedConfirmations[confirmation] = true;
                }
            }
        }

        function clearGuestSelection()
        {
            var i;
            var confirmation;

            for (i = 0; i < vm.inHouseGuests.length; i++) {
                confirmation = vm.inHouseGuests[i].confirmation_number;
                if (confirmation) {
                    delete vm.selectedConfirmations[confirmation];
                }
            }
        }

        function areAllEligibleSelected()
        {
            var i;
            var confirmation;

            if (!vm.eligibleGuests.length) {
                return false;
            }

            for (i = 0; i < vm.eligibleGuests.length; i++) {
                confirmation = vm.eligibleGuests[i].confirmation_number;
                if (!confirmation || !vm.selectedConfirmations[confirmation]) {
                    return false;
                }
            }

            return true;
        }

        function getSelectedConfirmationNumbers()
        {
            var numbers = [];
            var i;
            var confirmation;
            var seen = {};

            for (i = 0; i < vm.inHouseGuests.length; i++) {
                confirmation = (vm.inHouseGuests[i].confirmation_number || '').trim();
                if (!confirmation || seen[confirmation] || !vm.selectedConfirmations[confirmation]) {
                    continue;
                }

                seen[confirmation] = true;
                numbers.push(confirmation);
            }

            return numbers;
        }

        function getSelectedCount()
        {
            return getSelectedConfirmationNumbers().length;
        }

        // Keep selection in current property/channel scope; optionally reset to all eligible.
        function syncGuestSelection(options)
        {
            var next = {};
            var i;
            var guest;
            var confirmation;

            if (options && options.resetSelection) {
                vm.selectedConfirmations = {};
                selectAllEligible();
                return;
            }

            for (i = 0; i < vm.inHouseGuests.length; i++) {
                guest = vm.inHouseGuests[i];
                confirmation = guest.confirmation_number;
                if (!confirmation || !guest.can_deliver) {
                    continue;
                }

                if (vm.selectedConfirmations[confirmation]) {
                    next[confirmation] = true;
                }
            }

            vm.selectedConfirmations = next;
        }

        function getDeliverableCount()
        {
            var count = 0;
            var i;

            for (i = 0; i < vm.inHouseGuests.length; i++) {
                if (vm.inHouseGuests[i].can_deliver) {
                    count++;
                }
            }

            return count;
        }

        function fetchThreadStatusForConfirmations(confirmationNumbers)
        {
            var numbers = [];
            var seen = {};
            var i;
            var cn;

            for (i = 0; i < (confirmationNumbers || []).length; i++) {
                cn = String(confirmationNumbers[i] || '').trim();
                if (!cn || seen[cn]) {
                    continue;
                }
                seen[cn] = true;
                numbers.push(cn);
            }

            if (!numbers.length) {
                vm.eligibilityIncomplete = false;
                return $q.resolve({});
            }

            return messageCenterService.getGuestDirectChatStatus({
                confirmation_numbers: numbers
            }).then(function (response) {
                if (applyChannelEnabledFlags(response)) {
                    normalizeSelectedChannel();
                }

                if (!response || response.success === false) {
                    vm.eligibilityIncomplete = false;
                    return {};
                }

                vm.eligibilityIncomplete = false;
                return response.data || {};
            }).catch(function () {
                vm.eligibilityIncomplete = false;
                return {};
            });
        }

        function mergeThreadStatusUpdates(updates)
        {
            var cn;

            if (!updates) {
                return;
            }

            for (cn in updates) {
                if (Object.prototype.hasOwnProperty.call(updates, cn)) {
                    threadStatusByConfirmation[cn] = updates[cn];
                }
            }
        }

        function getBroadcastStatusConfirmationNumbers(result, fallbackNumbers)
        {
            var numbers = [];
            var seen = {};
            var i;
            var row;
            var cn;

            for (i = 0; i < ((result && result.results) || []).length; i++) {
                row = result.results[i] || {};
                if (row.status !== 'sent') {
                    continue;
                }

                cn = String(row.confirmation_number || '').trim();
                if (!cn || seen[cn]) {
                    continue;
                }

                seen[cn] = true;
                numbers.push(cn);
            }

            if (numbers.length) {
                return numbers;
            }

            for (i = 0; i < (fallbackNumbers || []).length; i++) {
                cn = String(fallbackNumbers[i] || '').trim();
                if (!cn || seen[cn]) {
                    continue;
                }

                seen[cn] = true;
                numbers.push(cn);
            }

            return numbers;
        }

        function refreshChatStatusForGuests(confirmationNumbers)
        {
            return fetchThreadStatusForConfirmations(confirmationNumbers).then(function (statusMap) {
                mergeThreadStatusUpdates(statusMap);
                refreshGuestDeliveryFlags();
            });
        }

        function guestMatchesFilters(guest)
        {
            // Only require "currently checked-in" when the In House filter is on.
            if (vm.inHouseEnabled && !isCheckedInStatus(guest.room_stay_status)) {
                return false;
            }

            return guestMatchesPropertyScope(guest);
        }

        function applyPropertyFilter()
        {
            var rows = [];
            var i;

            for (i = 0; i < allInHouseGuests.length; i++) {
                if (guestMatchesFilters(allInHouseGuests[i])) {
                    rows.push(allInHouseGuests[i]);
                }
            }

            vm.inHouseGuests = rows;
            vm.inHouseGuestCount = rows.length;
            refreshGuestDeliveryFlags({ resetSelection: true });
        }

        function guestMatchesPropertyScope(guest)
        {
            var selected = getSelectedSubHotelIds();
            var guestHotelId;
            var i;
            var hotelId;

            if (!selected.length) {
                return true;
            }

            guestHotelId = normalizeHotelId(guest && guest.hotel_id);

            if (guestHotelId !== null) {
                return selected.indexOf(guestHotelId) !== -1;
            }

            for (i = 0; i < vm.subHotels.length; i++) {
                hotelId = normalizeHotelId(vm.subHotels[i].hotel_id);

                if (selected.indexOf(hotelId) === -1) {
                    continue;
                }

                if ((vm.subHotels[i].hotel_title || '') === (guest.hotel_title || '')) {
                    return true;
                }
            }

            return false;
        }

        function isCheckedInStatus(status)
        {
            if (!status) {
                return false;
            }

            var normalized = String(status).toLowerCase()
                .replace(/[_-]+/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();

            return normalized === 'checked in';
        }

        function extractTravelerPhone(item)
        {
            var phone = (
                (item && (item.traveller_phone_number || item.traveler_phone_number || item.phone_number)) ||
                (item && (item.traveller_secondary_phone_number || item.traveler_secondary_phone_number)) ||
                ''
            );

            return String(phone).trim();
        }

        function normalizeInHouseRow(item, currentHotelTitle, currentHotelId)
        {
            var firstName = item.first_name || '';
            var lastName = item.last_name || '';
            var guestName = (firstName + ' ' + lastName).replace(/^\s+|\s+$/g, '');
            var room = item.first_room || item.product_name || item.rm || item.product_room_number || '';
            var travelerPhone = extractTravelerPhone(item);

            if (item.second_room) {
                room = room ? (room + ' ' + item.second_room) : item.second_room;
            }

            return {
                confirmation_number: item.confirmation_number || '',
                guest_name: guestName || item.confirmation_number || 'Guest',
                room: room,
                hotel_id: normalizeHotelId(item.hotel_id) || currentHotelId,
                hotel_title: item.hotel_title || currentHotelTitle || '',
                room_stay_status: item.room_stay_status || '',
                messaging_opt_out: !!item.messaging_opt_out,
                // Default number when no open chat: traveler phone from reservation.
                reservation_phone: travelerPhone,
                phone: travelerPhone,
                has_open_chat: false,
                has_phone: !!travelerPhone,
                can_deliver: false,
                statuses: [{ key: 'no_chat', label: 'No chat open' }]
            };
        }

        function getDateFilterParam(filter, customDate)
        {
            var today = moment();

            if (!filter) {
                return null;
            }

            if (filter === 'today') {
                return today.format('YYYY-MM-DD');
            }

            if (filter === 'tomorrow') {
                return today.add(1, 'days').format('YYYY-MM-DD');
            }

            if (filter === 'custom' && customDate) {
                return moment(customDate).format('YYYY-MM-DD');
            }

            return today.format('YYYY-MM-DD');
        }

        function getCheckoutDateParam()
        {
            return getDateFilterParam(vm.checkoutFilter, vm.customCheckoutDate);
        }

        function getCheckinDateParam()
        {
            return getDateFilterParam(vm.checkinFilter, vm.customCheckinDate);
        }

        function loadInHouseGuests(forceReload)
        {
            var requestId = ++guestsRequestId;
            var today = moment().format('YYYY-MM-DD');
            var checkoutDate = getCheckoutDateParam();
            var checkinDate = getCheckinDateParam();

            if (!forceReload && guestsLoaded) {
                applyPropertyFilter();
                return $q.resolve();
            }

            vm.loadingGuests = true;
            vm.loadingGuestCount = true;
            vm.guestHasMore = false;
            vm.eligibilityIncomplete = false;

            return messageCenterService.getGroupMessageGuests({
                checkoutDate: checkoutDate,
                checkinDate: checkinDate,
                waitingForRoom: vm.stayFilterMode === 'waiting_for_room'
            }).then(function (response) {
                var raw;
                var rows = [];
                var confirmations = [];
                var currentHotelTitle = '';
                var currentHotelId = null;
                var i;
                var item;
                var guest;

                if (requestId !== guestsRequestId) {
                    return;
                }

                raw = (response && response.result) || [];

                // result can be a sparse object after PHP unset(); normalize to values.
                if (!angular.isArray(raw)) {
                    raw = Object.keys(raw).map(function (key) {
                        return raw[key];
                    });
                }

                for (i = 0; i < raw.length; i++) {
                    item = raw[i] || {};

                    if (item.hotel_name) {
                        currentHotelTitle = item.hotel_name;
                        currentHotelId = normalizeHotelId(item.hotel_id) || findHotelIdByTitle(item.hotel_name);
                        continue;
                    }

                    if (!item.confirmation_number && !item.first_name && !item.last_name) {
                        continue;
                    }

                    guest = normalizeInHouseRow(item, currentHotelTitle, currentHotelId);
                    rows.push(guest);
                    if (guest.confirmation_number) {
                        confirmations.push(guest.confirmation_number);
                    }
                }

                return fetchThreadStatusForConfirmations(confirmations).then(function (statusMap) {
                    if (requestId !== guestsRequestId) {
                        return;
                    }

                    threadStatusByConfirmation = statusMap || {};
                    allInHouseGuests = rows;
                    guestsLoaded = true;
                    applyPropertyFilter();
                });
            }).catch(function () {
                if (requestId !== guestsRequestId) {
                    return;
                }

                allInHouseGuests = [];
                guestsLoaded = false;
                vm.inHouseGuests = [];
                vm.eligibleGuests = [];
                vm.ineligibleGuests = [];
                vm.selectedConfirmations = {};
                vm.inHouseGuestCount = 0;
                vm.deliverableGuestCount = 0;
                toastMessage.showSimpleToast('Unable to load in-house reservations.', 'error-toast');
            }).finally(function () {
                if (requestId !== guestsRequestId) {
                    return;
                }

                vm.loadingGuests = false;
                vm.loadingGuestCount = false;
            });
        }

        function getRecipientLabel()
        {
            var total;
            var deliverable;
            var selected;

            if (vm.loadingGuestCount) {
                return 'Loading guests...';
            }

            total = vm.inHouseGuestCount || 0;
            deliverable = vm.deliverableGuestCount || 0;
            selected = getSelectedCount();

            return selected + ' selected · ' + deliverable + ' of ' + total + ' can receive';
        }

        function canSubmit()
        {
            if (!vm.canSendDirect || !hasAnyDirectChannelEnabled() || vm.sending) {
                return false;
            }

            if (!isChannelAvailable(vm.channel)) {
                return false;
            }

            return !!(vm.message || '').trim() && getSelectedCount() > 0;
        }

        function buildPayload()
        {
            var payload = {
                message: (vm.message || '').trim(),
                channel: vm.channel,
                confirmation_numbers: getSelectedConfirmationNumbers()
            };
            var selected = getSelectedSubHotelIds();

            if (selected.length && vm.subHotels.length > 1 && selected.length < vm.subHotels.length) {
                payload.sub_hotel_ids = selected;
            }

            return payload;
        }

        function confirmSend()
        {
            var title = 'Send broadcast';
            var channelLabel = getChannelLabel();
            var selectedCount = getSelectedCount();
            var html = 'Send this ' + channelLabel + ' message to <b>' +
                selectedCount + ' selected</b> reservation' +
                ((selectedCount === 1) ? '' : 's') + '?';

            if (vm.channel === 'whatsapp') {
                html += '<br/><br/>Guests outside the WhatsApp 24-hour window will be skipped.';
            } else if (vm.channel === 'default') {
                html += '<br/><br/>Each guest gets their last active channel. ' +
                    'If WhatsApp is outside the 24-hour window, SMS is used when available.';
            }

            return $mdDialog.show({
                controller: 'confirmController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    title: title,
                    htmlContent: html,
                    cancelBtn: 'Cancel',
                    OkBtn: 'Send'
                }
            });
        }

        function shouldConfirmBeforeSend()
        {
            return !vm.skipSendConfirm;
        }

        function executeSend()
        {
            var payload = buildPayload();

            vm.sending = true;
            vm.lastResult = null;

            return messageCenterService.broadcastDirectMessage(payload).then(function (response) {
                if (!response || response.success === false) {
                    toastMessage.showSimpleToast(
                        (response && response.message) || 'Unable to send broadcast.',
                        'error-toast'
                    );
                    return;
                }

                vm.lastResult = response.data || null;

                toastMessage.showSimpleToast(
                    'Broadcast sent: ' + (vm.lastResult.sent || 0) + ' delivered.',
                    'success-toast'
                );

                return refreshChatStatusForGuests(
                    getBroadcastStatusConfirmationNumbers(
                        vm.lastResult,
                        payload.confirmation_numbers
                    )
                );
            }).finally(function () {
                vm.sending = false;
            });
        }

        function sendBroadcast()
        {
            if (!canSubmit()) {
                return;
            }

            if (!shouldConfirmBeforeSend()) {
                executeSend();
                return;
            }

            confirmSend().then(function (answer) {
                if (answer !== 'update') {
                    return;
                }

                return executeSend();
            }, function () {
                // cancelled
            });
        }

        function getReasonLabel(reason)
        {
            var map = {
                out_of_scope: 'Out of scope',
                opted_out: 'Opted out',
                no_open_thread: 'No open chat',
                no_phone: 'No phone number',
                invalid_phone: 'Invalid phone number',
                whatsapp_window_closed: 'WhatsApp 24h window closed',
                whatsapp_messaging_disabled: 'WhatsApp messaging disabled',
                sms_messaging_disabled: 'SMS messaging disabled',
                phone_linked_to_other_reservation: 'Conversation already started with this number',
                phone_linked_to_staff_contact: 'Number already used as a staff contact',
                create_failed: 'Unable to start conversation',
                empty_message: 'Message empty after personalization'
            };

            return map[reason] || reason || '';
        }

        function setCheckoutFilter(filter)
        {
            if (vm.stayFilterMode !== 'checkout') {
                applyStayFilterMode('checkout', { skipReload: true });
            }

            if (vm.checkoutFilter === filter) {
                return;
            }

            vm.checkoutFilter = filter;
            guestsLoaded = false;
            loadInHouseGuests(true);
        }

        function onCustomCheckoutDateChange()
        {
            if (vm.customCheckoutDate) {
                guestsLoaded = false;
                loadInHouseGuests(true);
            }
        }

        function setCheckinFilter(filter)
        {
            if (vm.stayFilterMode !== 'checkin') {
                applyStayFilterMode('checkin', { skipReload: true });
            }

            if (vm.checkinFilter === filter) {
                return;
            }

            vm.checkinFilter = filter;
            guestsLoaded = false;
            loadInHouseGuests(true);
        }

        function onCustomCheckinDateChange()
        {
            if (vm.customCheckinDate) {
                guestsLoaded = false;
                loadInHouseGuests(true);
            }
        }

        function onDestroy()
        {
            unbindQuickReplyDocClick();
        }

        function toggleQuickReplyPicker($event)
        {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            if (vm.quickReplyOpen) {
                closeQuickReplyPicker();
                return;
            }

            openQuickReplyPicker();
        }

        function openQuickReplyPicker()
        {
            if (vm.promoteReplyOpen) closePromoteReplyPicker();
            vm.quickReplyOpen = true;
            vm.quickReplySearch = '';
            bindQuickReplyDocClick();
            loadQuickReplies();
        }

        function closeQuickReplyPicker()
        {
            vm.quickReplyOpen = false;
            vm.quickReplySearch = '';
            unbindQuickReplyDocClick();
        }

        function bindQuickReplyDocClick()
        {
            unbindQuickReplyDocClick();

            quickReplyDocClickHandler = function ()
            {
                $scope.$applyAsync(function () {
                    closeQuickReplyPicker();
                });
            };

            $timeout(function () {
                $document.on('click', quickReplyDocClickHandler);
            }, 0);
        }

        function unbindQuickReplyDocClick()
        {
            if (quickReplyDocClickHandler) {
                $document.off('click', quickReplyDocClickHandler);
                quickReplyDocClickHandler = null;
            }
        }

        function loadQuickReplies()
        {
            if (quickReplyCache) {
                vm.quickReplyCategories = quickReplyCache;
                filterQuickReplies();
                return;
            }

            vm.quickReplyLoading = true;
            vm.quickReplyFiltered = [];

            messageCenterService.getTemplatesGrouped({
                template_type: 'quick_reply'
            }).then(function (response) {
                vm.quickReplyLoading = false;

                if (!response || response.success === false) {
                    vm.quickReplyCategories = [];
                    vm.quickReplyFiltered = [];
                    toastMessage.showSimpleToast(
                        (response && response.message) || 'Unable to load quick replies.',
                        'error-toast'
                    );
                    return;
                }

                quickReplyCache = normalizeQuickReplyCategories(response.data || []);
                vm.quickReplyCategories = quickReplyCache;
                filterQuickReplies();
            }, function () {
                vm.quickReplyLoading = false;
                vm.quickReplyCategories = [];
                vm.quickReplyFiltered = [];
                toastMessage.showSimpleToast('Unable to load quick replies.', 'error-toast');
            });
        }

        function normalizeQuickReplyCategories(categories)
        {
            var result = [];
            var i;
            var j;

            for (i = 0; i < categories.length; i++) {
                var category = categories[i] || {};
                var templates = category.templates || [];
                var items = [];

                for (j = 0; j < templates.length; j++) {
                    var template = templates[j] || {};

                    if (String(template.is_active) === '0') {
                        continue;
                    }

                    items.push({
                        id: String(template.id),
                        name: template.name || '',
                        body: template.body || ''
                    });
                }

                if (!items.length) {
                    continue;
                }

                result.push({
                    id: String(category.id),
                    name: category.name || '',
                    templates: items
                });
            }

            return result;
        }

        function filterQuickReplies()
        {
            var query = String(vm.quickReplySearch || '').toLowerCase().trim();
            var categories = vm.quickReplyCategories || [];
            var filtered = [];
            var i;
            var j;

            if (!query) {
                vm.quickReplyFiltered = categories;
                return;
            }

            for (i = 0; i < categories.length; i++) {
                var category = categories[i];
                var matchedTemplates = [];

                if (String(category.name || '').toLowerCase().indexOf(query) !== -1) {
                    filtered.push(category);
                    continue;
                }

                for (j = 0; j < (category.templates || []).length; j++) {
                    var template = category.templates[j];
                    var name = String(template.name || '').toLowerCase();
                    var body = String(template.body || '').toLowerCase();

                    if (name.indexOf(query) !== -1 || body.indexOf(query) !== -1) {
                        matchedTemplates.push(template);
                    }
                }

                if (matchedTemplates.length) {
                    filtered.push({
                        id: category.id,
                        name: category.name,
                        templates: matchedTemplates
                    });
                }
            }

            vm.quickReplyFiltered = filtered;
        }

        function applyQuickReply(template)
        {
            if (!template) {
                return;
            }

            // Keep guest tokens (#{firstName}, etc.) in the compose body.
            // They are filled per reservation when the group message is sent.
            var body = renderQuickReplyBody(template.body || '');

            if (!body) {
                closeQuickReplyPicker();
                return;
            }

            vm.message = body;
            closeQuickReplyPicker();

            $timeout(function () {
                var textarea = document.querySelector(
                    '#message-center-broadcast .gmc-broadcast-textarea'
                );

                if (textarea) {
                    textarea.focus();
                }
            }, 0);
        }

        function renderQuickReplyBody(body)
        {
            // Only expand static tokens here. Guest-specific tokens stay as
            // #{firstName}, #{roomNumber}, etc. and are personalized per guest
            // on the server during broadcastDirectMessage (same as inbox values).
            var tokens = {
                greeting: 'Hello',
                honorific: 'Mr./Ms.'
            };
            var text = String(body || '');

            Object.keys(tokens).forEach(function (key) {
                var pattern = new RegExp('#\\{' + key + '\\}', 'g');
                text = text.replace(pattern, tokens[key]);
            });

            return text
                .replace(/[ \t]+\n/g, '\n')
                .replace(/\n[ \t]+/g, '\n')
                .replace(/ {2,}/g, ' ')
                .replace(/^\s+|\s+$/g, '');
        }

        function togglePromoteReplyPicker($event)
        {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            if (vm.promoteReplyOpen) {
                closePromoteReplyPicker();
                return;
            }

            openPromoteReplyPicker();
        }

        function openPromoteReplyPicker()
        {
            if (vm.quickReplyOpen) closeQuickReplyPicker();
            vm.promoteReplyOpen = true;
            vm.promoteReplySearch = '';
            bindPromoteReplyDocClick();
            loadPromoteReplies();
        }

        function closePromoteReplyPicker()
        {
            vm.promoteReplyOpen = false;
            vm.promoteReplySearch = '';
            unbindPromoteReplyDocClick();
        }

        function bindPromoteReplyDocClick()
        {
            unbindPromoteReplyDocClick();

            promoteReplyDocClickHandler = function ()
            {
                $scope.$applyAsync(function () {
                    closePromoteReplyPicker();
                });
            };

            $timeout(function () {
                $document.on('click', promoteReplyDocClickHandler);
            }, 0);
        }

        function unbindPromoteReplyDocClick()
        {
            if (promoteReplyDocClickHandler) {
                $document.off('click', promoteReplyDocClickHandler);
                promoteReplyDocClickHandler = null;
            }
        }

        function loadPromoteReplies()
        {
            if (promoteReplyCache) {
                vm.promoteReplyCategories = promoteReplyCache;
                filterPromoteReplies();
                return;
            }

            vm.promoteReplyLoading = true;
            vm.promoteReplyFiltered = [];

            messageCenterService.getTemplatesGrouped({
                template_type: 'promote_reply'
            }).then(function (response) {
                vm.promoteReplyLoading = false;

                if (!response || response.success === false) {
                    vm.promoteReplyCategories = [];
                    vm.promoteReplyFiltered = [];
                    toastMessage.showSimpleToast(
                        (response && response.message) || 'Unable to load quick replies.',
                        'error-toast'
                    );
                    return;
                }

                promoteReplyCache = normalizePromoteReplyCategories(response.data || []);
                vm.promoteReplyCategories = promoteReplyCache;
                filterPromoteReplies();
            }, function () {
                vm.promoteReplyLoading = false;
                vm.promoteReplyCategories = [];
                vm.promoteReplyFiltered = [];
                toastMessage.showSimpleToast('Unable to load quick replies.', 'error-toast');
            });
        }

        function normalizePromoteReplyCategories(categories)
        {
            var result = [];
            var i;
            var j;

            for (i = 0; i < categories.length; i++) {
                var category = categories[i] || {};
                var templates = category.templates || [];
                var items = [];

                for (j = 0; j < templates.length; j++) {
                    var template = templates[j] || {};

                    if (String(template.is_active) === '0') {
                        continue;
                    }

                    items.push({
                        id: String(template.id),
                        name: template.name || '',
                        body: template.body || ''
                    });
                }

                if (!items.length) {
                    continue;
                }

                result.push({
                    id: String(category.id),
                    name: category.name || '',
                    templates: items
                });
            }

            return result;
        }

        function filterPromoteReplies()
        {
            var query = String(vm.promoteReplySearch || '').toLowerCase().trim();
            var categories = vm.promoteReplyCategories || [];
            var filtered = [];
            var i;
            var j;

            if (!query) {
                vm.promoteReplyFiltered = categories;
                return;
            }

            for (i = 0; i < categories.length; i++) {
                var category = categories[i];
                var matchedTemplates = [];

                if (String(category.name || '').toLowerCase().indexOf(query) !== -1) {
                    filtered.push(category);
                    continue;
                }

                for (j = 0; j < (category.templates || []).length; j++) {
                    var template = category.templates[j];
                    var name = String(template.name || '').toLowerCase();
                    var body = String(template.body || '').toLowerCase();

                    if (name.indexOf(query) !== -1 || body.indexOf(query) !== -1) {
                        matchedTemplates.push(template);
                    }
                }

                if (matchedTemplates.length) {
                    filtered.push({
                        id: category.id,
                        name: category.name,
                        templates: matchedTemplates
                    });
                }
            }

            vm.promoteReplyFiltered = filtered;
        }

        function applyPromoteReply(template)
        {
            if (!template) {
                return;
            }

            // Keep guest tokens (#{firstName}, etc.) in the compose body.
            // They are filled per reservation when the group message is sent.
            var body = renderPromoteReplyBody(template.body || '');

            if (!body) {
                closePromoteReplyPicker();
                return;
            }

            vm.message = body;
            closePromoteReplyPicker();

            $timeout(function () {
                var textarea = document.querySelector(
                    '#message-center-broadcast .gmc-broadcast-textarea'
                );

                if (textarea) {
                    textarea.focus();
                }
            }, 0);
        }

        function renderPromoteReplyBody(body)
        {
            // Only expand static tokens here. Guest-specific tokens stay as
            // #{firstName}, #{roomNumber}, etc. and are personalized per guest
            // on the server during broadcastDirectMessage (same as inbox values).
            var tokens = {
                greeting: 'Hello',
                honorific: 'Mr./Ms.'
            };
            var text = String(body || '');

            Object.keys(tokens).forEach(function (key) {
                var pattern = new RegExp('#\\{' + key + '\\}', 'g');
                text = text.replace(pattern, tokens[key]);
            });

            return text
                .replace(/[ \t]+\n/g, '\n')
                .replace(/\n[ \t]+/g, '\n')
                .replace(/ {2,}/g, ' ')
                .replace(/^\s+|\s+$/g, '');
        }



        function formatPhoneNumber(phoneNumber)
        {
            return phoneFormatService.format(phoneNumber);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .controller('GroupMessageLogsController', GroupMessageLogsController);

    /** @ngInject */
    function GroupMessageLogsController(
        $scope,
        $rootScope,
        $mdDialog,
        $localStorage,
        messageCenterService
    )
    {
        var vm = this;
        var loadPageCallbackWithDebounce;
        var logsById = {};

        vm.subHotels = $rootScope.subHotels || [];
        vm.requestProcessing = false;
        vm.totalLogs = 0;
        vm.page = 1;

        vm.refreshTable = refreshTable;
        vm.openBroadcastLog = openBroadcastLog;
        vm.getPropertyLabels = getPropertyLabels;
        vm.formatBroadcastTime = formatBroadcastTime;
        vm.getReasonLabel = getReasonLabel;

        $scope.paginatorCallback = paginatorCallback;
        $scope.getLoadResultsCallback = getLoadResultsCallback;

        init();

        function init()
        {
            if ($rootScope.isParent && $rootScope.subHotels && $rootScope.subHotels.length) {
                vm.subHotels = $rootScope.subHotels;
                return;
            }

            if ($localStorage.hotels && $localStorage.selectedHotel !== undefined) {
                $rootScope.getSubHotels($localStorage.hotels[$localStorage.selectedHotel].hotel_id, true);
                $scope.$watch(function () {
                    return $rootScope.subHotelsOfSelected;
                }, function (subHotels) {
                    if (subHotels && subHotels.length) {
                        vm.subHotels = subHotels;
                    }
                });
            }
        }

        function getLoadResultsCallback(loadPageCallback)
        {
            loadPageCallbackWithDebounce = _.debounce(function (page)
            {
                loadPageCallback(page || 1);
            }, 100);
        }

        function refreshTable()
        {
            if (loadPageCallbackWithDebounce) {
                loadPageCallbackWithDebounce(vm.page || 1);
            }
        }

        function normalizeHotelId(hotelId)
        {
            var id = parseInt(hotelId, 10);

            return isNaN(id) ? null : id;
        }

        function getPropertyLabelList(subHotelIds)
        {
            var ids = subHotelIds || [];
            var labels = [];
            var i;
            var hotelId;
            var j;
            var title;

            if (!ids.length) {
                return ['All hotels'];
            }

            for (i = 0; i < ids.length; i++) {
                hotelId = normalizeHotelId(ids[i]);
                title = null;

                for (j = 0; j < vm.subHotels.length; j++) {
                    if (normalizeHotelId(vm.subHotels[j].hotel_id) === hotelId) {
                        title = vm.subHotels[j].hotel_title || String(hotelId);
                        break;
                    }
                }

                labels.push(title || String(ids[i]));
            }

            return labels;
        }

        function getPropertyLabels(subHotelIds)
        {
            return getPropertyLabelList(subHotelIds).join(', ');
        }

        function formatBroadcastTime(value)
        {
            if (!value) {
                return '—';
            }

            // API returns hotel-local created_at as YYYY-MM-DD HH:mm:ss.
            if (typeof moment === 'function') {
                var m = moment(value, ['YYYY-MM-DD HH:mm:ss', moment.ISO_8601], true);
                if (m.isValid()) {
                    return m.format('MM-DD-YYYY HH:mm:ss');
                }
            }

            return String(value).replace(/\//g, '-');
        }

        function getReasonLabel(reason)
        {
            var map = {
                out_of_scope: 'Out of scope',
                opted_out: 'Opted out',
                no_open_thread: 'No open chat',
                no_phone: 'No phone number',
                invalid_phone: 'Invalid phone number',
                whatsapp_window_closed: 'WhatsApp 24h window closed',
                whatsapp_messaging_disabled: 'WhatsApp messaging disabled',
                sms_messaging_disabled: 'SMS messaging disabled',
                phone_linked_to_other_reservation: 'Conversation already started with this number',
                phone_linked_to_staff_contact: 'Number already used as a staff contact',
                create_failed: 'Unable to start conversation'
            };

            return map[reason] || reason || '';
        }

        function truncateMessage(message)
        {
            var text = (message || '').replace(/\s+/g, ' ').trim();

            if (text.length <= 80) {
                return text || '—';
            }

            return text.substring(0, 77) + '...';
        }

        function mapLogRow(log)
        {
            return {
                id: log.id,
                message: truncateMessage(log.message),
                channel: log.channel || '—',
                properties: getPropertyLabels(log.sub_hotel_ids),
                requested: log.requested || 0,
                sent: log.sent || 0,
                skipped: log.skipped || 0,
                failed: log.failed || 0,
                created_at: formatBroadcastTime(log.created_at),
                action_id: log.id
            };
        }

        function paginatorCallback(page, pageSize)
        {
            page = parseInt(page, 10) || vm.page || 1;
            pageSize = parseInt(pageSize, 10) || 20;
            vm.page = page;
            vm.requestProcessing = true;

            return messageCenterService.getBroadcastLogs({
                page: page,
                limit: pageSize
            }).then(function (response) {
                var rows = [];
                var i;
                var mapped;

                logsById = {};

                if (!response || response.success === false) {
                    vm.totalLogs = 0;
                    return {
                        results: [],
                        totalResultCount: 0
                    };
                }

                rows = response.data || [];
                mapped = [];

                for (i = 0; i < rows.length; i++) {
                    logsById[String(rows[i].id)] = rows[i];
                    mapped.push(mapLogRow(rows[i]));
                }

                vm.totalLogs = (response.meta && response.meta.total) || mapped.length;

                return {
                    results: mapped,
                    totalResultCount: vm.totalLogs
                };
            }).catch(function () {
                vm.totalLogs = 0;
                return {
                    results: [],
                    totalResultCount: 0
                };
            }).finally(function () {
                vm.requestProcessing = false;
            });
        }

        function openBroadcastLog(logId)
        {
            var log = logsById[String(logId)];

            if (!logId) {
                return;
            }

            $mdDialog.show({
                controller: 'GroupMessageLogDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/guest-message-center/group-messages/dialogs/group-message-log-dialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    broadcastLogId: logId,
                    propertyLabel: log ? getPropertyLabels(log.sub_hotel_ids) : 'All hotels',
                    propertyLabels: log ? getPropertyLabelList(log.sub_hotel_ids) : ['All hotels'],
                    getReasonLabelFn: getReasonLabel
                }
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.guest-message-center')
        .directive('gmcDropzone', gmcDropzoneDirective);

    /**
     * Full-panel HTML5 file dropzone.
     * Toggles .is-drag-over synchronously on the element (no digest delay),
     * then calls gmc-dropzone-drop="vm.onComposerDrop($event)" on drop.
     * Also clears stuck overlay if the user cancels or drops outside the zone.
     */
    /** @ngInject */
    function gmcDropzoneDirective()
    {
        return {
            restrict: 'A',
            link: function (scope, element, attrs)
            {
                var el = element[0];
                var dragDepth = 0;
                var enabledAttr = attrs.gmcDropzoneEnabled;

                function isEnabled()
                {
                    if (!enabledAttr) {
                        return true;
                    }

                    try {
                        return !!scope.$eval(enabledAttr);
                    } catch (e) {
                        return true;
                    }
                }

                function nativeEvent(event)
                {
                    return (event && event.originalEvent) ? event.originalEvent : event;
                }

                function preventAndAllow(event)
                {
                    var native = nativeEvent(event);

                    if (event.preventDefault) {
                        event.preventDefault();
                    }
                    if (native && native.preventDefault) {
                        native.preventDefault();
                    }
                    if (event.stopPropagation) {
                        event.stopPropagation();
                    }
                    if (native && native.stopPropagation) {
                        native.stopPropagation();
                    }
                    if (native && native.dataTransfer) {
                        try {
                            native.dataTransfer.dropEffect = 'copy';
                        } catch (e) {
                            // ignore
                        }
                    }
                }

                function setDragOver(active)
                {
                    if (active) {
                        el.classList.add('is-drag-over');
                        if (!el.getAttribute('data-drop-hint')) {
                            el.setAttribute('data-drop-hint', 'Drop image to attach');
                        }
                    } else {
                        el.classList.remove('is-drag-over');
                    }
                }

                function clearDragState()
                {
                    dragDepth = 0;
                    setDragOver(false);
                }

                function onDragEnter(event)
                {
                    // On Linux/Chromium, dataTransfer.types is often empty while
                    // dragging from the file manager — still allow the drop.
                    if (!isEnabled()) {
                        return;
                    }

                    preventAndAllow(event);
                    dragDepth += 1;
                    setDragOver(true);
                }

                function onDragOver(event)
                {
                    if (!isEnabled()) {
                        return;
                    }

                    preventAndAllow(event);
                    setDragOver(true);
                }

                function onDragLeave(event)
                {
                    var native = nativeEvent(event);
                    var related = (native && native.relatedTarget) || (event && event.relatedTarget);

                    // Left the window / unknown target — always clear.
                    if (!related) {
                        clearDragState();
                        return;
                    }

                    // Child enter/leave: stay active while pointer remains inside panel.
                    if (el.contains(related)) {
                        return;
                    }

                    dragDepth = Math.max(0, dragDepth - 1);
                    if (dragDepth === 0) {
                        setDragOver(false);
                    }
                }

                function onDrop(event)
                {
                    var native = nativeEvent(event);
                    var expr = attrs.gmcDropzoneDrop;

                    preventAndAllow(event);
                    clearDragState();

                    if (!isEnabled() || !expr) {
                        return;
                    }

                    // Synchronous apply so attach runs immediately.
                    if (scope.$root && scope.$root.$$phase) {
                        scope.$eval(expr, { $event: native });
                    } else {
                        scope.$apply(function ()
                        {
                            scope.$eval(expr, { $event: native });
                        });
                    }
                }

                function isDragActive()
                {
                    return dragDepth > 0 || el.classList.contains('is-drag-over');
                }

                // If drag is cancelled, dropped outside, or browser opens the file
                // in a new tab, clear the stuck overlay.
                function onDocumentDragEnd()
                {
                    clearDragState();
                }

                function onDocumentDragOver(event)
                {
                    // While our overlay is active, block the browser default
                    // (open file in a new tab) for drops elsewhere in the page.
                    if (!isDragActive()) {
                        return;
                    }

                    if (event.preventDefault) {
                        event.preventDefault();
                    }
                }

                function onDocumentDrop(event)
                {
                    if (isDragActive() && event.preventDefault) {
                        event.preventDefault();
                    }
                    clearDragState();
                }

                function onWindowBlur()
                {
                    clearDragState();
                }

                function onWindowFocus()
                {
                    // Returning from a browser-opened image tab leaves overlay stuck
                    // if drop/blur never reached the page — clear on focus.
                    clearDragState();
                }

                function onVisibilityChange()
                {
                    clearDragState();
                }

                el.addEventListener('dragenter', onDragEnter, false);
                el.addEventListener('dragover', onDragOver, false);
                el.addEventListener('dragleave', onDragLeave, false);
                el.addEventListener('drop', onDrop, false);

                document.addEventListener('dragend', onDocumentDragEnd, true);
                document.addEventListener('dragover', onDocumentDragOver, true);
                document.addEventListener('drop', onDocumentDrop, true);
                window.addEventListener('blur', onWindowBlur, false);
                window.addEventListener('focus', onWindowFocus, false);
                document.addEventListener('visibilitychange', onVisibilityChange, false);

                scope.$on('$destroy', function ()
                {
                    clearDragState();
                    el.removeEventListener('dragenter', onDragEnter, false);
                    el.removeEventListener('dragover', onDragOver, false);
                    el.removeEventListener('dragleave', onDragLeave, false);
                    el.removeEventListener('drop', onDrop, false);
                    document.removeEventListener('dragend', onDocumentDragEnd, true);
                    document.removeEventListener('dragover', onDocumentDragOver, true);
                    document.removeEventListener('drop', onDocumentDrop, true);
                    window.removeEventListener('blur', onWindowBlur, false);
                    window.removeEventListener('focus', onWindowFocus, false);
                    document.removeEventListener('visibilitychange', onVisibilityChange, false);
                });
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
    .module('app.e-commerce')
    .factory('roomTypeService', roomTypeService);

    /** @ngInject */
    function roomTypeService(msApi, $http,EnvironmentConfig,$localStorage)
    {
        function getDataFailed(error) {
			return error.data;
		}

		function getDataComplete(response) {
			return response.data;
		}

		function getProgressPercentage(){
			return $http({
				url:EnvironmentConfig.api+'roomtypes/get_progress_percentage',
				method:'GET'
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function roomTypeComponentData(hotelID, roomTypeID,type){
			return $http({
				url:EnvironmentConfig.api+'roomtypes/allRoomTypeComponent',
				method:'POST',
				data: {'selectedHotel': hotelID, 'roomTypeID': roomTypeID, 'type': type}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function addRoomType(data,setIndex){
			return $http({
				url:EnvironmentConfig.api+'roomtypes/add_room_type',
				method:'POST',
				data:{'data':data,'setIndex':setIndex}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function editRoomName(data){
			return $http({
				url:EnvironmentConfig.api+'roomtypes/editRoomName',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function getAllRoomTypes(data){
			return $http({
				url:EnvironmentConfig.api+'roomtypes/room_types',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function roomTypeData(id) {
			return $http({
				url:EnvironmentConfig.api+'roomtypes/roomTypeData/' + id,
				method:'GET'
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function updateRoomType(data) {
			return $http({
				url:EnvironmentConfig.api+'roomtypes/update_room_type',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function updateBoatType(data) {
			return $http({
				url:EnvironmentConfig.api+'roomtypes/update_boat_type',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function deleteImage(data) {
			return $http({
				url:EnvironmentConfig.api+'roomtypes/deleteImage',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function checkRoomTypeName(data) {
			return $http({
				url:EnvironmentConfig.api+'roomtypes/RoomTypeUniqueName',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function sortRoomImages(data) {
			return $http({
				url:EnvironmentConfig.api+'roomtypes/sortRoomImages',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function deleteSelectedRoomTypes(roomTypeId,hotelID){
			return $http({
	 			url:EnvironmentConfig.api+'roomtypes/delete_room_type',
	 			method:'POST',
	 			data: {roomTypeId : roomTypeId, hotel_id : hotelID}
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}

		function deleteRoomProduct(data){
			return $http({
	 			url:EnvironmentConfig.api+'roomtypes/deleteRoomProduct',
	 			method:'POST',
	 			data: data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}

		function addRoomProduct(data){
			return $http({
	 			url:EnvironmentConfig.api+'roomtypes/addRoomProduct',
	 			method:'POST',
	 			data: data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}
	 	function editBundleRooms(data){
			return $http({
	 			url:EnvironmentConfig.api+'roomtypes/editBundleRooms',
	 			method:'POST',
	 			data: data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}

		function saveProductSortOrder(data){
			return $http({
	 			url:EnvironmentConfig.api+'roomtypes/saveProductSortOrder',
	 			method:'POST',
	 			data: data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}

		function getRoomProduct(data){
			return $http({
	 			url:EnvironmentConfig.api+'roomtypes/getRoomProduct',
	 			method:'POST',
	 			data: data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}
		
		function UniqueProductName(data){
			return $http({
	 			url:EnvironmentConfig.api+'roomtypes/UniqueProductName',
	 			method:'POST',
	 			data: data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}

	 	function SaveBoatProductName(data){
			return $http({
	 			url:EnvironmentConfig.api+'roomtypes/SaveBoatProductName',
	 			method:'POST',
	 			data: data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}
		
		function getSingleRoomList(data){
			return $http({
	 			url:EnvironmentConfig.api+'roomtypes/getSingleRoomList',
	 			method:'POST',
	 			data: data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}

	 	function checkRoomTypeCode(data){
			return $http({
	 			url:EnvironmentConfig.api+'roomtypes/skipAcl_roomTypeCodeExists',
	 			method:'POST',
	 			data: data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}

	 	function getRoomsOfSubHotel(data){
			return $http({
	 			url:EnvironmentConfig.api+'roomtypes/get_rooms_of_sub_hotel',
	 			method:'POST',
	 			data: data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}


        var service = {
			roomTypeComponentData: roomTypeComponentData,
			addRoomType: addRoomType,
			editBundleRooms: editBundleRooms,
			editRoomName: editRoomName,
			getAllRoomTypes: getAllRoomTypes,
			roomTypeData: roomTypeData,
			updateRoomType: updateRoomType,
			updateBoatType: updateBoatType,
			deleteImage: deleteImage,
			checkRoomTypeName: checkRoomTypeName,
			sortRoomImages: sortRoomImages,
			deleteSelectedRoomTypes: deleteSelectedRoomTypes,
			deleteRoomProduct: deleteRoomProduct,
			addRoomProduct: addRoomProduct,
			saveProductSortOrder: saveProductSortOrder,
			getRoomProduct: getRoomProduct,
			UniqueProductName: UniqueProductName,
			SaveBoatProductName: SaveBoatProductName,
			getSingleRoomList : getSingleRoomList,
			getProgressPercentage : getProgressPercentage,
			checkRoomTypeCode : checkRoomTypeCode,
			getRoomsOfSubHotel : getRoomsOfSubHotel
		};
		return service;
}

})();

(function ()
{
    'use strict';

    angular
    .module('app.e-commerce')
    .factory('activityService', activityService);

    /** @ngInject */
    function activityService(msApi, $http,EnvironmentConfig,$localStorage)
    {
        function getDataFailed(error) {
			return error.data;
		}

		function getDataComplete(response) {
			return response.data;
		}

		function addPosType(data){
			return $http({
				url:EnvironmentConfig.api+'Activities/add_pos_type',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function addActivity(data){
			return $http({
				url:EnvironmentConfig.api+'Activities/add_activity',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function posTypeComponentData(hotelID,posTypeID) {
			return $http({
				url : EnvironmentConfig.api+'Activities/allPosTypeComponent',
				method : 'POST',
				data: {'selectedHotel': hotelID, 'posTypeID': posTypeID}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function roomTypeData(id) {
			return $http({
				url:EnvironmentConfig.api+'roomtypes/roomTypeData/' + id,
				method:'GET'
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function updateRoomType(data) {
			return $http({
				url:EnvironmentConfig.api+'roomtypes/updateRoomType',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function deleteImage(data) {
			return $http({
				url:EnvironmentConfig.api+'roomtypes/deleteImage',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function checkRoomTypeName(data) {
			return $http({
				url:EnvironmentConfig.api+'roomtypes/RoomTypeUniqueName',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function sortRoomImages(data) {
			return $http({
				url:EnvironmentConfig.api+'roomtypes/sortRoomImages',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function deleteSelectedRoomTypes(roomTypeId,hotelID){
			return $http({
	 			url:EnvironmentConfig.api+'roomtypes/deleteRoomTypes',
	 			method:'POST',
	 			data: {roomTypeId : roomTypeId, hotel_id : hotelID}
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}

        var service = {
			addPosType: addPosType,
			addActivity: addActivity,
			posTypeComponentData: posTypeComponentData,
			roomTypeData: roomTypeData,
			updateRoomType: updateRoomType,
			deleteImage: deleteImage,
			checkRoomTypeName: checkRoomTypeName,
			sortRoomImages: sortRoomImages,
			deleteSelectedRoomTypes: deleteSelectedRoomTypes
		};
		return service;
}

})();

(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .factory('NotesService', NotesService);

    /** @ngInject */
    function NotesService(msApi, $q)
    {
        var service = {
            data      : [],
            addNote   : addNote,
            updateNote: updateNote,
            deleteNote: deleteNote,
            getData   : getData
        };

        /**
         * Add Note
         * @param note
         */
        function addNote(note)
        {
            service.data.push(note);
        }

        /**
         * Update Note
         * @param note
         */
        function updateNote(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data[i] = note;
                }
            }
        }

        /**
         * Delete Note
         * @param note
         */
        function deleteNote(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data.splice(i, 1);
                }
            }
        }

        /**
         * Get service data
         * @returns {Array}
         */
        function getData()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('notes.notes@get', {},
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        return service;

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .factory('LabelsService', LabelsService);

    /** @ngInject */
    function LabelsService(msUtils, NotesService, msApi, $q)
    {
        var service = {
            data       : [],
            addLabel   : addLabel,
            updateLabel: updateLabel,
            deleteLabel: deleteLabel,
            getData    : getData
        };

        /**
         * Add label
         * @param newLabel
         */
        function addLabel(newLabel)
        {
            if ( newLabel.name === '' )
            {
                return;
            }

            service.data.push({
                id   : msUtils.guidGenerator(),
                name : newLabel.name,
                color: newLabel.color || ''
            });
        }

        /**
         * Update Label
         * @param note
         */
        function updateLabel(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data[i] = note;
                }
            }
        }

        /**
         * Delete Label
         * @param label
         */
        function deleteLabel(label)
        {
            var notes = NotesService.data;

            // Look for all notes if they have the labels
            for ( var j = 0; j < notes.length; j++ )
            {
                if ( notes[j].labels.indexOf(label.id) > -1 )
                {
                    notes[j].labels.splice(notes[j].labels.indexOf(label.id), 1);
                }
            }

            // Delete label from service data
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === label.id )
                {
                    service.data.splice(i, 1);
                }
            }

        }

        /**
         * Get service data
         * @returns {Array}
         */
        function getData()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('notes.labels@get', {},
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        return service;

    }
})();

(function ()
{
    'use strict';

    angular
    .module('app.e-commerce')
    .factory('giftCardService', giftCardService);

    /** @ngInject */
    function giftCardService(msApi, $http,EnvironmentConfig,$localStorage)
    {
        function getDataFailed(error) {
			return error.data;
		}

		function getDataComplete(response) {
			return response.data;
		}

		function addGiftCard(data){
			return $http({
				url:EnvironmentConfig.api+'giftcards/add_gift_card',
				method:'POST',
				data: data,
				headers: { 'Content-Type': undefined }
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function getGiftCard(hotelID){
			return $http({
				url:EnvironmentConfig.api+'giftcards/getGiftCard',
				method:'POST',
				data: {hotelID: hotelID}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function removePrice(data){
			return $http({
				url:EnvironmentConfig.api+'giftcards/removePrice',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function deleteImage(data) {
			return $http({
				url:EnvironmentConfig.api+'giftcards/deleteImage',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		function addGiftPrice(data) {
			return $http({
				url:EnvironmentConfig.api+'giftcards/addGiftPrice',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		

		function updateAllowAmount(data) {
			return $http({
				url:EnvironmentConfig.api+'giftcards/updateAllowAmount',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function updateProductDetail(data) {
			return $http({
				url:EnvironmentConfig.api+'giftcards/update_gift_card',
				method:'POST',
				data: data,
				headers: { 'Content-Type': undefined }
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		function taxData(hotelID) {
			return $http({
				url:EnvironmentConfig.api+'giftcards/taxData',
				method:'POST',
				data: {hotelID: hotelID}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

        var service = {
			addGiftCard : addGiftCard,
			getGiftCard : getGiftCard,
			removePrice : removePrice,
			deleteImage : deleteImage,
			addGiftPrice : addGiftPrice,
			updateAllowAmount: updateAllowAmount,
			updateProductDetail: updateProductDetail,
			taxData: taxData
		};
		return service;
}

})();

(function ()
{
    'use strict';

    angular
    .module('app.e-commerce')
    .factory('gcAdminService', gcAdminService);

    /** @ngInject */
    function gcAdminService(msApi, $http,EnvironmentConfig,$localStorage)
    {
        function getDataFailed(error) {
			return error.data;
		}

		function getDataComplete(response) {
			return response.data;
		}

		function gcadmins(data){
			return $http({
				url:EnvironmentConfig.api+'gcadmins/admin_gift_cards',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		function addGiftCard(data){
			return $http({
				url:EnvironmentConfig.api+'gcadmins/add_admin_gift_card',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function getGiftCard(data){
			return $http({
				url:EnvironmentConfig.api+'gcadmins/getGiftCard',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		function checkGiftCardCodeExist(data){
			return $http({
				url:EnvironmentConfig.api+'gcadmins/checkGiftCardCodeExist',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function updateGiftCard(data){
			return $http({
				url:EnvironmentConfig.api+'gcadmins/update_admin_gift_card',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function deleteSelectedGiftCards(giftCardID,hotelID){
			return $http({
	 			url:EnvironmentConfig.api+'gcadmins/delete_admin_gift_card',
	 			method:'POST',
	 			data: {giftCardID : giftCardID, hotelID : hotelID}
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}

        var service = {
			gcadmins: gcadmins,
			addGiftCard : addGiftCard,
			getGiftCard : getGiftCard,
			checkGiftCardCodeExist: checkGiftCardCodeExist,
			updateGiftCard : updateGiftCard,
			deleteSelectedGiftCards : deleteSelectedGiftCards
		};
		return service;
}

})();

(function ()
{
    'use strict';

    angular
    .module('app.e-commerce')
    .factory('eCommerceService', eCommerceService);

    /** @ngInject */
    function eCommerceService($q, $mdToast, msApi, $http,EnvironmentConfig, $localStorage, $mdDialog, $document, toastMessage, $rootScope)
    {
		var products = [],
		orders = [],
		orderStatuses = [];
		var _keyCardDialogOpen = false;

		var service = {
			/* Products */
			saveProduct    				: saveProduct,
			checkUnique  				: checkUnique,
			updateProduct  				: updateProduct,
			getProductTypes    			: getProductTypes,
			deleteSelProd  	 			: deleteSelProd,
			/* Products */
			
			/* Taxes */
			addTax          			: addTax,
			getSingleTax    			: getSingleTax,
			deleteSelTax    			: deleteSelTax,
			getTaxNames    				: getTaxNames,
			getDefaultTaxData   		: getDefaultTaxData,
			updateTax           		: updateTax,
			checkTaxExists	   			: checkTaxExists,
			updateTaxList      	 		: updateTaxList,
			/* Taxes */
			
			/* Reservations */
			getOrders       			: getOrders,
			saveEmailCustomer       	: saveEmailCustomer,
			getOrder        			: getOrder,
			deleteSelOrder 	 			: deleteSelOrder,
			sendInvoice        			: sendInvoice,
			sendOrderInvoice   	 		: sendOrderInvoice,
			issueKeyCard				: issueKeyCard,
			revokeKeyCard				: revokeKeyCard,
			verifyKeyCard				: verifyKeyCard,
			openKeyCardDialog			: openKeyCardDialog,
			normalizeKeyCardOrder		: normalizeKeyCardOrder,
			printInvoice   	        	: printInvoice,
			printOrderInvoice   		: printOrderInvoice,
			changeDatesForRes 			: changeDatesForRes,
			saveCommentReq 				: saveCommentReq,
			updateReservationValues 	: updateReservationValues,
			fetchOrder	 				: fetchOrder,
			fetchOrderHistory	 		: fetchOrderHistory,
			fetchPaymentsInformation	: fetchPaymentsInformation,
			fetchOrderCommentsRequests	: fetchOrderCommentsRequests,
			editDatesDialog	 			: editDatesDialog,
			editPDatesDialog	 		: editPDatesDialog,
			searchParking	 			: searchParking,
			addParking		 			: addParking,
			modifyOrderAmounts 			: modifyOrderAmounts,
			customRefundInstallment 	: customRefundInstallment,
			customRefundEmail 			: customRefundEmail,
			roomMove 					: roomMove,
			payInstallment	 			: payInstallment,
			changeCCProcessingFeeTax	: changeCCProcessingFeeTax,
			updateCustomer	 			: updateCustomer,
			getCustomerTags	 				: getCustomerTags,
			saveCustomerTags	 			: saveCustomerTags,
			saveDiscountComment			: saveDiscountComment,
			updateSendEmailIndicator	: updateSendEmailIndicator,
			getmultipleNightPolicy		: getmultipleNightPolicy,
			exportCsvData				: exportCsvData,
			updateReservationData       : updateReservationData,
			saveRefundReason 			: saveRefundReason,
			fetchAttachmentDocs 		: fetchAttachmentDocs,
			deleteDoc 					: deleteDoc,
			deleteAllDoc 				: deleteAllDoc,
			transferAmount 				: transferAmount,
			inititateFundTransfer		: inititateFundTransfer,
			moreTransactionExists		: moreTransactionExists,
			checkRoomAmounts			: checkRoomAmounts,
			downloadDocument 			: downloadDocument,
			getUserResevations 			: getUserResevations,
			updateTravellerAsCustomer   : updateTravellerAsCustomer,
			updateBillingOption 		: updateBillingOption,
			printInvoiceInfo			: printInvoiceInfo,
			checkCustomerTravellerInfo	: checkCustomerTravellerInfo,
			getNegotiatedRates			: getNegotiatedRates,
			checkCancelNightRefund      : checkCancelNightRefund,
			validatePromoCode			: validatePromoCode,
			updateCustomerReservation   : updateCustomerReservation,
			roundOffRemaining			: roundOffRemaining,
			getGeneralSettings          : getGeneralSettings,
			deletePosFromReservation	: deletePosFromReservation,
			sendConfirmationEmail        : sendConfirmationEmail,
			getCustomerFamilyMembers     : getCustomerFamilyMembers,
			addFamilyMember					: addFamilyMember,
			getRelationshipTypes				: getRelationshipTypes,
			updateFamilyMember				: updateFamilyMember,
			deleteFamilyMember				: deleteFamilyMember,
			getCustomerPets     				: getCustomerPets,
			getPetTypes							: getPetTypes,
			addCustomerPet						: addCustomerPet,
			updateCustomerPet					: updateCustomerPet,
			deleteCustomerPet					: deleteCustomerPet,
			saveReservationColor         : saveReservationColor,
			setWaitingStatus             : setWaitingStatus,
			isWaitingForRoom             : isWaitingForRoom,
			confirmAndSetWaitingForRoom  : confirmAndSetWaitingForRoom,
			sendPrecheckinLink		   	: sendPrecheckinLink,
			getPrecheckinStatus		   	: getPrecheckinStatus,
			/* Reservations */

		};

		return service;

		//////////
		function getDataComplete(response) {
			return response.data;
		}

		function getDataFailed(error) {
			return error.data;
		}
		/**
		* Get products
		*/
		function getProductTypes()
		{
			var data = {selectedHotel: $localStorage.hotels[$localStorage.selectedHotel].hotel_id};
			return $http({
				url:EnvironmentConfig.api+'product/skipAcl_getallproducttypes',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function saveEmailCustomer(data){
			/*var data = {
				selectedHotel: $localStorage.hotels[$localStorage.selectedHotel].hotel_id,
				customer_id:customer_id,
				email:email,
				confirmation_number:confirmation_number,
				reservation_id:reservation_id,
				order_confirmation_number: order_confirmation_number,
				customerTravelSame:travCust
			};*/
			return $http({
				url:EnvironmentConfig.api+'customer/savecustomerReservation',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function updateSendEmailIndicator(data){
			return $http({
				url:EnvironmentConfig.api+'customer/skipAcl_updateSendEmailIndicator',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function saveProduct(data)
		{
			return $http({
				url: EnvironmentConfig.api+'product/skipAcl_saveProduct',
				method: 'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function checkUnique(data)
		{
			return $http({
				url: EnvironmentConfig.api+'product/skipAcl_checkUnique',
				method: 'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function updateProduct(data)
		{
			return $http({
				url: EnvironmentConfig.api+'product/skipAcl_updateProduct',
				method: 'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		/**
		* send Invoice in Reservation section to send emails to the main customer for particular reservation
		*/
		function sendInvoice(reservation_id,itinerary_id,type_of_order,from_backend){
			return $http({
				url:EnvironmentConfig.api+'reservations/send_invoice',
				method:'POST',
				data:{reservation_id:reservation_id,itinerary_id:itinerary_id,type_of_order:type_of_order,from_backend:from_backend}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		/**
		* send Order Invoice in Reservation section to send emails to the single room stay customer for particular reservation confirmation_number
		*/
		function sendOrderInvoice(confirmation_number,reservation_id,type_of_order){
			return $http({
				url:EnvironmentConfig.api+'reservations/send_order_invoice',
				method:'POST',
				data:{confirmation_number:confirmation_number,reservation_id:reservation_id,type_of_order:type_of_order}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		/**
		* Sync room to Cloudflare (generate key) for a room confirmation number
		*/
		function issueKeyCard(payload){
			return $http({
				url:EnvironmentConfig.api+'reservations/issue_key_card',
				method:'POST',
				data: payload
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		/**
		* Revoke (erase) guest key card via hotel Cloudflare TCP tunnel
		*/
		function revokeKeyCard(payload){
			return $http({
				url:EnvironmentConfig.api+'reservations/revoke_key_card',
				method:'POST',
				data: payload
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		/**
		* Verify (read/query) guest key card via hotel Cloudflare TCP tunnel
		*/
		function verifyKeyCard(payload){
			return $http({
				url:EnvironmentConfig.api+'reservations/verify_key_card',
				method:'POST',
				data: payload
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		/**
		* print Order Invoice in Reservation section to print data for some confirmation_number
		*/
		function printOrderInvoice(confirmation_number){
			return $http({
				url:EnvironmentConfig.api+'reservations/get_order_invoice',
				method:'POST',
				data:{confirmation_number:confirmation_number}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		/**
		* print Invoice in Reservation section to print data for some reservation number
		*/
		function printInvoice(reservation_id){
			return $http({
				url:EnvironmentConfig.api+'reservations/get_invoice',
				method:'POST',
				data:{reservation_id:reservation_id}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		/**
		* Get orders
		*/
		function getOrders(){
			return $http({
				url:EnvironmentConfig.api+'reservations/get_orders_list',
				method:'POST'
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		/**
		* Get order by id
		*
		* @param id
		*/
		function getOrder(id,confirmation_number,changeStatusData){
			return $http({
				url:EnvironmentConfig.api+'reservations/get_order_info',
				method:'POST',
				data:{id:id,confirmation_number:confirmation_number,changeStatusData:changeStatusData}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		function fetchOrderHistory(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/fetch_order_history',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		function saveDiscountComment(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/save_discount_comment',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		function customRefundInstallment(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/custom_refund_installment',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function customRefundEmail(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/custom_refund_email',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		function fetchOrder(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/fetch_order',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		function fetchPaymentsInformation(data){
			
			
			return $http({
				url:EnvironmentConfig.api+'reservations/fetch_payments_information',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		function fetchOrderCommentsRequests(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/fetch_order_comments_requests',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		function saveCommentReq(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/save_comment_req',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		function updateReservationValues(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/update_reservation_values',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		function modifyOrderAmounts(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/modify_order_amounts',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		function editDatesDialog(ev,localData){
			$mdDialog.show({
				controller         	: 'editDatesController',
				controllerAs       	: 'vm',
				templateUrl        	: 'app/main/apps/e-commerce/views/orders/dialogs/edit-dates/edit-dates.html',
				parent             	: angular.element($document.body),
				targetEvent        	: ev,
				clickOutsideToClose	: true,
				locals             	: {
					localData		: localData
				}
			});
		}

		function normalizeKeyCardOrder(source) {
			if (!source) {
				return {};
			}
			return angular.extend({}, source, {
				confirmation_number: source.confirmation_number || source.room_confirmation_number,
				product_room_number: source.product_room_number || source.first_room,
				product_name: source.product_name || source.rm
			});
		}

		function openKeyCardDialog(ev, orderData, pageFor) {
			if (_keyCardDialogOpen) return;

			if ($rootScope.isRoomLockEncoderVisible && !$rootScope.isRoomLockEncoderVisible()) {
				return;
			}

			var order = normalizeKeyCardOrder(orderData);
			if (!order.confirmation_number) {
				toastMessage.showSimpleToast(
					'Missing confirmation number.',
					'error-toast'
				);
				return;
			}
			_keyCardDialogOpen = true;

			return $mdDialog.show({
				controller          : 'KeyCardDialogController',
				controllerAs        : 'vm',
				templateUrl         : 'app/main/apps/e-commerce/dialogs/key-card/key-card-dialog.html',
				parent              : angular.element($document.body),
				targetEvent         : ev,
				clickOutsideToClose : true,
				locals              : {
					localData: order,
					pageFor: pageFor
				}
			}).finally(function() {
				_keyCardDialogOpen = false;
			});
		}

		function editPDatesDialog(ev,localData){
			$mdDialog.show({
				controller         	: 'parkingController',
				controllerAs       	: 'vm',
				templateUrl        	: 'app/main/apps/e-commerce/views/orders/dialogs/parking/parking.html',
				parent             	: angular.element($document.body),
				targetEvent        	: ev,
				clickOutsideToClose	: true,
				locals             	: {
					localData	: localData
				}
			});
		}
		
		function changeDatesForRes(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/change_dates_for_res',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function searchParking(data){
			return $http({
				url:EnvironmentConfig.api+'parking/search_parking',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		function addParking(data){
			return $http({
				url:EnvironmentConfig.api+'parking/add_parking',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function deleteSelProd(delprodParams){
			return $http({
				url:EnvironmentConfig.api+'product/delete_product',
				method:'POST',
				data:delprodParams
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function deleteSelOrder(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/delete_reservations',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function addTax(data)
		{
			return $http({
				url:EnvironmentConfig.api+'tax/add_tax',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function getSingleTax(id)
		{
		return $http({
			url:EnvironmentConfig.api+'tax/skipAcl_getSingleProduct',
				method:'POST',
				data:id
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function deleteSelTax(ids)
		{
			return $http({
				url:EnvironmentConfig.api+'tax/delete_tax',
				method:'POST',
				data:ids
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function getTaxNames()
		{
			return $http({
				url:EnvironmentConfig.api+'tax/skipAcl_getTaxName',
				method:'GET'
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function getDefaultTaxData(){
			var data = {hotel_id:1};
			return $http({
				url:EnvironmentConfig.api+'tax/taxes',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function updateTax(data){
			return $http({
				url:EnvironmentConfig.api+'tax/manage_tax',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function updateTaxList(data){
			return $http({
				url:EnvironmentConfig.api+'tax/taxes',
				method:'POST',
				data:{'hotel_id' : data.hotel_id}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		function checkTaxExists(data){
			return $http({
				url:EnvironmentConfig.api+'tax/check_exists',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function payInstallment(data){
		
			var deferred = $q.defer();
			return $http({
				url:EnvironmentConfig.api+'reservations/pay_installments',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function changeCCProcessingFeeTax(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/change_cc_processing_fee_tax',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function roomMove(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/room_move',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

	 	function updateCustomer(data){
			return $http({
	 			url:EnvironmentConfig.api+'roomtypes/skipAcl_updateCustomers',
	 			method:'POST',
	 			data: data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}

		function getCustomerTags(customerId){
			return $http({
				url: EnvironmentConfig.api + 'customer/getAllCustomerTags',
				method: 'GET',
				params:{
						customer_id: customerId
				}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function saveCustomerTags(data) {
			return $http({
				url: EnvironmentConfig.api + 'customer/saveCustomerTags',
				method: 'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

	 	function updateCustomerReservation(data){
			return $http({
	 			url:EnvironmentConfig.api+'roomtypes/updateCustomerReservation',
	 			method:'POST',
	 			data: data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}


	 	function getmultipleNightPolicy(data){
			return $http({
	 			url:EnvironmentConfig.api+'reservations/skipAcl_getmultipleNightPolicy',
	 			method:'POST',
	 			data: data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}
	 	function exportCsvData(data){
			return $http({
	 			url:EnvironmentConfig.api+'reservations/exportCsvData',
	 			method:'POST',
	 			data: data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}
	 	function updateReservationData(data) {
	 		return $http({
	 			url:EnvironmentConfig.api+'reservations/skipAcl_updateCustomersAutofill',
	 			method:'POST',
	 			data: data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}

	 	function saveRefundReason(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/save_refund_reason',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function fetchAttachmentDocs(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/fetch_attachment_docs',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function deleteDoc(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/delete_document',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}		

		function deleteAllDoc(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/delete_all_documents',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function transferAmount(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/transferAmount',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function inititateFundTransfer(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/inititateFundTransfer',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function moreTransactionExists(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/moreTransactionExists',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function checkRoomAmounts(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/checkRoomAmounts',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		/*
		** To download attached documents
		*/
		function  downloadDocument(docName) {
			const url = EnvironmentConfig.api + "scripts/downloadDocument/" + docName;
        	window.location.href = url;
		}
		/*
		** To get User Reservations
		*/
		function  getUserResevations(data) {
			return $http({
				url:EnvironmentConfig.api+'reservations/getUserResevations',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		/*
		** To update traveller same as customer
		*/
		function  updateTravellerAsCustomer(data) {
			return $http({
				url:EnvironmentConfig.api+'customer/skipAcl_updateTravellerAsCustomer',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		/*
		** To update billing option from traveller to customer
		*/
		function updateBillingOption(data){
			return $http({
				url :EnvironmentConfig.api+'Reservations/skipAcl_updateBillingOption',
				method: 'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		/**
		* print Invoice in Reservation section to print data for some reservation number
		*/
		function printInvoiceInfo(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/generate_invoice',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		/**
		* Get customer and traveller info for reservation
		*/
		function checkCustomerTravellerInfo($resvId) {
			return $http({
				url:EnvironmentConfig.api+'reservations/checkResvCustTravellers/'+$resvId,
				method:'GET'
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		/**
		* Get negotiated rates for rate type
		*/
		function getNegotiatedRates(negotId, data) {
			return $http({
				url:EnvironmentConfig.api+'reservations/skipAcl_getNegotiatedRates',
				method:'POST',
				data: {negotiatedId : negotId, data: data}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		/**
		* Check whether cancel or no show should refund amount or not
		*/
		function checkCancelNightRefund(data) {
			return $http({
				url:EnvironmentConfig.api+'reservations/skipAcl_checkCancelNightRefund',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		/**
		* @param: Object data
		* @return: Json data
		*/
		function roundOffRemaining(data) {
			return $http({
				url:EnvironmentConfig.api+'reservations/round_off_remaining',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function validatePromoCode(data) {
			return $http({
				url:EnvironmentConfig.api+'reservations/skipAcl_checkValidPromoCode',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function getGeneralSettings(data) {
			return $http({
				url: EnvironmentConfig.api + 'general/general_settings',
				method: 'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function deletePosFromReservation(data){
			return $http({
				url:EnvironmentConfig.api+'reservations/delete_pos_from_reservation',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function sendConfirmationEmail(confirmation_number,reservation_id){
			return $http({
				url: EnvironmentConfig.api + 'reservations/sendConfirmationEmail',
				method: 'POST',
				data:{confirmation_number:confirmation_number,reservation_id:reservation_id}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function addFamilyMember(data){
			return $http({
				url: EnvironmentConfig.api + 'customer/addFamilyMember',
				method: 'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function getCustomerFamilyMembers(customer_id) {
			return $http({
				url: EnvironmentConfig.api + 'customer/getCustomerFamilyMembers',
				method: 'POST',
				data: { customer_id }
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function updateFamilyMember(data) {
			return $http({
				url: EnvironmentConfig.api + 'customer/updateFamilyMember',
				method: 'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function deleteFamilyMember(data) {
			return $http({
				method: 'POST',
				url: EnvironmentConfig.api + 'customer/deleteFamilyMember',
				data: data,
				headers: {
						'Content-Type': 'application/json'
				}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function getRelationshipTypes(data) {
			return $http({
				url: EnvironmentConfig.api + 'customer/getRelationshipTypes',
				method: 'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function getPetTypes() {
			return $http({
				url: EnvironmentConfig.api + 'customer/getPetTypes',
				method: 'GET'
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function addCustomerPet(data){
			return $http({
				url: EnvironmentConfig.api + 'customer/addCustomerPet',
				method: 'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function getCustomerPets(customer_id) {
			return $http({
				url: EnvironmentConfig.api + 'customer/getCustomerPets',
				method: 'POST',
				data: { customer_id }
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function updateCustomerPet(data) {
			return $http({
				url: EnvironmentConfig.api + 'customer/updateCustomerPet',
				method: 'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function deleteCustomerPet(data) {
			return $http({
				url: EnvironmentConfig.api + 'customer/deleteCustomerPet',
				method: 'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function saveReservationColor(data) {
			return $http({
				url: EnvironmentConfig.api + 'reservations/saveReservationColor',
				method: 'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function setWaitingStatus(data) {
			return $http({
				url: EnvironmentConfig.api + 'Reservations/set_waiting_status',
				method: 'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function sendPrecheckinLink(data) {
			return $http({
				url: EnvironmentConfig.api + 'customer/sendPrecheckinLink',
				method: 'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		/**
		 * Shared Waiting for Room check. Same behavior as existing call sites.
		 * options.checkColor / options.checkShowStatus default false for order/dashboard;
		 * gantt passes both true.
		 */
		function isWaitingForRoom(item, options) {
			if (!item) {
				return false;
			}
			options = options || {};
			if (
				item.is_waiting_for_room == 1 ||
				item.is_waiting_for_room === "1" ||
				item.is_waiting_for_room === true ||
				Number(item.is_waiting_for_room) === 1
			) {
				return true;
			}
			if (options.checkShowStatus && item.show_status === "Waiting for Room") {
				return true;
			}
			if (
				options.checkColor &&
				String(item.color || "").toUpperCase() === "#0288D1"
			) {
				return true;
			}
			return false;
		}

		function showAlreadyWaitingDialog(event, options) {
			options = options || {};
			if (options.useGanttDialog) {
				return $mdDialog.show({
					controller: "confirmPageController",
					controllerAs: "vm",
					templateUrl:
						"app/main/apps/dashboards/gantt-chart/confirmationPage.html",
					parent: angular.element(document.body),
					targetEvent: event,
					clickOutsideToClose: true,
					locals: {
						title: "Change Status",
						htmlContent:
							'This reservation is already in state "Waiting for Room".',
						btnTxt: "Continue",
						cancelTxt: "Cancel",
						localData: {},
					},
				});
			}

			return $mdDialog.show({
				controller: "confirmController",
				controllerAs: "vm",
				templateUrl:
					"app/main/apps/contacts/confirmationPopUp/confirmation.html",
				parent: angular.element(document.body),
				targetEvent: event,
				clickOutsideToClose: true,
				locals: {
					title: "Change Status",
					htmlContent:
						'This reservation is already in state "Waiting for Room".',
					cancelBtn: "Cancel",
					OkBtn: "Continue",
				},
			});
		}

		/**
		 * Confirm + set Waiting for Room. Mutates item on success (same as before).
		 * options: checkColor, checkShowStatus, useGanttDialog, applyGanttFields
		 */
		function confirmAndSetWaitingForRoom(item, event, options) {
			options = options || {};
			if (!item || !item.confirmation_number) {
				return $q.reject({ success: false });
			}

			if (
				isWaitingForRoom(item, {
					checkColor: !!options.checkColor,
					checkShowStatus: !!options.checkShowStatus,
				})
			) {
				return showAlreadyWaitingDialog(event, options).then(
					function () {
						return { success: true, already: true };
					},
					function () {
						return { success: true, already: true, cancelled: true };
					}
				);
			}

			return $mdDialog
				.show({
					controller: "confirmController",
					controllerAs: "vm",
					templateUrl:
						"app/main/apps/contacts/confirmationPopUp/confirmation.html",
					parent: angular.element(document.body),
					targetEvent: event,
					clickOutsideToClose: true,
					locals: {
						title: "Waiting for Room",
						htmlContent:
							"Are you sure you want to change status to Waiting for Room?",
						cancelBtn: "Cancel",
						OkBtn: "Ok",
					},
				})
				.then(function (answer) {
					if (typeof answer === "undefined" || answer !== "update") {
						return { success: false, cancelled: true };
					}

					if (typeof options.onRequestStart === "function") {
						options.onRequestStart();
					}

					return setWaitingStatus({
						confirmation_number: item.confirmation_number,
						waiting: 1,
					}).then(
						function (response) {
							if (typeof options.onRequestEnd === "function") {
								options.onRequestEnd();
							}
							if (response && response.success) {
								item.is_waiting_for_room = 1;
								item.room_stay_status = "Active";
								if (options.applyGanttFields) {
									item.color = "#0288D1";
									item.status = "Active";
								}
								return { success: true, response: response };
							}

							toastMessage.showSimpleToast(
								(response && response.errorMsg) ||
									"Unable to update Waiting for Room status.",
								"error-toast"
							);
							return { success: false, response: response };
						},
						function () {
							if (typeof options.onRequestEnd === "function") {
								options.onRequestEnd();
							}
							toastMessage.showSimpleToast(
								"Unable to update Waiting for Room status.",
								"error-toast"
							);
							return { success: false };
						}
					);
				}, function () {
					return { success: false, cancelled: true };
				});
		}

		function getPrecheckinStatus(data) {
			return $http({
				url: EnvironmentConfig.api + 'customer/getPrecheckinStatus',
				method: 'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
	}

})();

(function ()
{
    'use strict';

    angular
    .module('app.e-commerce')
    .factory('bundleRoomsService', bundleRoomsService);

    /** @ngInject */
    function bundleRoomsService(msApi, $http,EnvironmentConfig,$localStorage)
    {
        function getDataComplete(response) {
			return response.data;
		}

		function getDataFailed(error) {
			return error.data;
		}

		function getRoomsList(data){
			return $http({
				url:EnvironmentConfig.api+'bundleRooms/rooms_list',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function addBundleRoom(data){
			return $http({
				url:EnvironmentConfig.api+'bundleRooms/add_bundle_room',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function deleteSelectedBundles(data){
			return $http({
				url:EnvironmentConfig.api+'bundleRooms/delete_selected_bundles',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function getBundleInfo(data){
			return $http({
				url:EnvironmentConfig.api+'bundleRooms/get_bundle_info',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function updateBundleRoom(data){
			return $http({
				url:EnvironmentConfig.api+'bundleRooms/update_bundle_room',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function uniqueBundleRoom(data){
			return $http({
				url:EnvironmentConfig.api+'bundleRooms/unique_bundle_room',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

        var service = {
			deleteSelectedBundles: deleteSelectedBundles,
			getBundleInfo: getBundleInfo,
			updateBundleRoom: updateBundleRoom,
			getRoomsList: getRoomsList,
			uniqueBundleRoom: uniqueBundleRoom,
			addBundleRoom: addBundleRoom
		};
		return service;
}

})();

(function ()
{
    'use strict';

    angular
        .module('app.e-commerce')
        .factory('attributeService', attributeService);

    /** @ngInject */
    function attributeService($q, $mdToast, msApi, $http,EnvironmentConfig){

        var products    = [],
        orders      = [],
        orderStatuses = [];

        var attributeSservice = {
            fetchAttributeByID            : fetchAttributeByID,
            saveAttribute                 : saveAttribute,
            checkUniqueHeading            : checkUniqueHeading,
            deleteSelectedAttributes      : deleteSelectedAttributes
        };

        return attributeSservice;

        //////////
		function getDataComplete(response) {
			return response.data;
		}

		function getDataFailed(error) {
			return error.data;
		}
        
        function fetchAttributeByID(id){
            return $http({
                url : EnvironmentConfig.api+'attribute/get_attribute/'+id,
                method: 'GET'
            })
            .then(getDataComplete)
            .catch(getDataFailed);
        }
        function saveAttribute(data){
            return $http({
                url : EnvironmentConfig.api+'attribute/save_attribute',
                method: 'POST',
                data:data
            })
            .then(getDataComplete)
            .catch(getDataFailed);
        } 

        function checkUniqueHeading(data){
            return $http({
                url : EnvironmentConfig.api+'attribute/unique_check',
                method: 'POST',
                data:data
            })
            .then(getDataComplete)
            .catch(getDataFailed);
        }

        function deleteSelectedAttributes(deleteIds){
            return $http({
                url : EnvironmentConfig.api+'attribute/delete_attribute',
                method: 'POST',
                data:deleteIds
            })
            .then(getDataComplete)
            .catch(getDataFailed);
        }

    }

})();

(function ()
{
    'use strict';

    angular
    .module('app.e-commerce')
    .factory('amenitiesService', amenitiesService);

    /** @ngInject */
    function amenitiesService(msApi, $http,EnvironmentConfig,$localStorage)
    {
        function getDataFailed(error) {
			return error.data;
		}

		function getDataComplete(response) {
			return response.data;
		}
		function deleteAmenity(data){
			return $http({
				url:EnvironmentConfig.api+'amenities/skipAcl_deleteAmenity',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function getCommonAmenitiesForOrganization(data){
			var data = {selectedHotel: $localStorage.hotels[$localStorage.selectedHotel].hotel_id};
			return $http({
				url:EnvironmentConfig.api+'amenities/skipAcl_commonAmenitiesForOrg',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function getRoomsAmenitiesForOrganization(data){
			return $http({
				url:EnvironmentConfig.api+'amenities/skipAcl_roomsAmenitiesForOrg',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function saveAssignedAmenity(data){
			return $http({
				url:EnvironmentConfig.api+'amenities/skipAcl_saveAssignedAmenity',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function getAllPropertyAmenities(data){
			return $http({
				url:EnvironmentConfig.api+'amenities/property_amenities',
				method:'POST'
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function getAllHotelAmenities(data){
			return $http({
				url:EnvironmentConfig.api+'amenities/all_room_amenities',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function savePropertyAmenity(data){
			return $http({
				url:EnvironmentConfig.api+'amenities/update_property_amenity',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function saveAllRoomAmenity(data){
			return $http({
				url:EnvironmentConfig.api+'amenities/update_all_room_amenity',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		function saveSelectedRoomAmenity(data){
			return $http({
				url:EnvironmentConfig.api+'amenities/update_selected_room_amenity',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

        var service = {
			savePropertyAmenity: savePropertyAmenity,
			saveAllRoomAmenity: saveAllRoomAmenity,
			saveSelectedRoomAmenity: saveSelectedRoomAmenity,
			getAllHotelAmenities: getAllHotelAmenities,
			getAllPropertyAmenities: getAllPropertyAmenities,
			getCommonAmenitiesForOrganization: getCommonAmenitiesForOrganization,
			getRoomsAmenitiesForOrganization: getRoomsAmenitiesForOrganization,
			saveAssignedAmenity: saveAssignedAmenity,
			deleteAmenity: deleteAmenity
		};
		return service;
}

})();

(function ()
{
    'use strict';

    angular
    .module('app.e-commerce')
    .factory('activityService', activityService);

    /** @ngInject */
    function activityService(msApi, $http,EnvironmentConfig,$localStorage)
    {
        function getDataFailed(error) {
			return error.data;
		}

		function getDataComplete(response) {
			return response.data;
		}

		function addPosType(data){
			return $http({
				url:EnvironmentConfig.api+'Postypes/add_pos_type',
				method:'POST',
				data:data,
				headers: { 'Content-Type': undefined },
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function PosTypes(pos_type,hotel_id){
			return $http({
				url:EnvironmentConfig.api+'Postypes/get_pos_types_only',
				method:'POST',
				data:{posType : pos_type, hotel_id : hotel_id}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}
		
		function getPosTypesOnly(data){
			return $http({
				url:EnvironmentConfig.api+'Postypes/get_pos_types_only',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function getPosType(pos_type_id){
			return $http({
				url:EnvironmentConfig.api+'Postypes/get_pos_type_by_id',
				method:'POST',
				data:{pos_type_id : pos_type_id}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function deletePosType(pos_type_id,pos_type,hotel_id){
			return $http({
				url:EnvironmentConfig.api+'Postypes/delete_pos_type',
				method:'POST',
				data:{pos_type_id : pos_type_id,pos_type:pos_type, hotel_id : hotel_id}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function checkPosTypeName(data) {
			return $http({
				url:EnvironmentConfig.api+'Postypes/PosTypeUniqueName',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function addActivity(data){
			return $http({
				url:EnvironmentConfig.api+'Activities/add_activity',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function activityComponentData(hotelID,posTypeID,prod_id) {
			return $http({
				url : EnvironmentConfig.api+'Activities/allPosTypeComponent',
				method : 'POST',
				data: {'selectedHotel': hotelID, 'posTypeID': posTypeID, 'prod_id': prod_id}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function activityData(id) {
			return $http({
				url:EnvironmentConfig.api+'Activities/activity_data/' + id,
				method:'GET'
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function updateActivity(data) {
			return $http({
				url:EnvironmentConfig.api+'Activities/update_activity',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function deleteImage(data) {
			return $http({
				url:EnvironmentConfig.api+'Activities/deleteImage',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function unlinkImage(img) {
			return $http({
				url:EnvironmentConfig.api+'Activities/unlinkImage',
				method:'POST',
				data: {'image' : img}
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function checkActivityName(data) {
			return $http({
				url:EnvironmentConfig.api+'Activities/ActivityUniqueName',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function sortActivityImages(data) {
			return $http({
				url:EnvironmentConfig.api+'Activities/sortActivityImages',
				method:'POST',
				data: data
			})
			.then(getDataComplete)
			.catch(getDataFailed);
		}

		function deleteSelectedActivities(productId,hotelID){
			return $http({
	 			url:EnvironmentConfig.api+'Activities/delete_activity',
	 			method:'POST',
	 			data: {productId : productId, hotel_id : hotelID}
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}

	 	function getRoomTypeData(data){
			return $http({
	 			url:EnvironmentConfig.api+'Activities/get_rooms_type',
	 			method:'POST',
	 			data: data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}

	 	function getPosTypeData(data){
			return $http({
	 			url:EnvironmentConfig.api+'Activities/get_pos_type',
	 			method:'POST',
	 			data: data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}

	 	function checkActivityType(data) {
	 		return $http({
	 			url 	: EnvironmentConfig.api + 'Activities/checkUniqueProductType',
	 			method 	: 'POST',
	 			data 	: data
	 		})
	 		.then(getDataComplete)
	 		.catch(getDataFailed);
	 	}

        var service = {
			addPosType: addPosType,
			getPosTypesOnly: getPosTypesOnly,
			PosTypes: PosTypes,
			getPosType: getPosType,
			addActivity: addActivity,
			deletePosType: deletePosType,
			activityComponentData: activityComponentData,
			activityData: activityData,
			updateActivity: updateActivity,
			deleteSelectedActivities: deleteSelectedActivities,
			deleteImage: deleteImage,
			unlinkImage: unlinkImage,
			checkActivityName: checkActivityName,
			checkPosTypeName: checkPosTypeName,
			sortActivityImages: sortActivityImages,
			getRoomTypeData: getRoomTypeData,
			getPosTypeData: getPosTypeData,
			checkActivityType : checkActivityType
		};
		return service;
}

})();

(function ()
{
    'use strict';

    angular.module('app.dashboards.gantt-chart')
        .controller('NewGanttChartController', NewGanttChartController);

    /** @ngInject */
    function NewGanttChartController(
        EnvironmentConfig,
        $mdDialog, 
        $document, 
        $animate, 
        toastMessage, 
        $scope, 
        $rootScope, 
        $timeout, 
        $compile, 
        ganttUtils, 
        GanttObjectModel, 
        ganttDebounce, 
        moment, 
        $window, 
        $mdSidenav, 
        msApi, 
        $localStorage, 
        ganttData,
        requestFor,
        ganttChartServiceNew, 
        $sessionStorage,
        todoService,
        $state,
        eCommerceService)
    {
        var vm = this;
        var objectModel;
        vm.currentHotelId = $localStorage['preHotelId'];
        vm.allRoomHotels = ['116', '120', '121', '128', '117', '136'];
        vm.subRoomHotels = ['126', '122', '129'];
        vm.roomTypes = ganttData.roomTypes;

        vm.currentClickedIndex = vm.previousClickedIndex = vm.clickedParentIndex = 0;
        vm.boatFilterType = [{key: 'month', value: 'Month'}, {key: 'quarter', value: 'Quarter'}];
        vm.rentFilterType = [{key: 'month', value: 'Month'}, {key: 'quarter', value: 'Quarter'}, {key: 'year', value: 'Year'}];
        vm.stateChanged = true;

        if (typeof $localStorage['boatFilterType'] == 'undefined' || $localStorage['boatFilterType'] == null) {
            $localStorage['boatFilterType'] = 'month';
        }
        
        // Residence default filter
        if (typeof $localStorage['rentFilterType'] == 'undefined' || $localStorage['rentFilterType'] == null) {
            $localStorage['rentFilterType'] = 'month';
        }
        vm.rentDispType = $localStorage['rentFilterType'];
        
        vm.boatDispType = $localStorage['boatFilterType'];

        vm.ganttChartHeader = ['month', 'day'];
        vm.ganttScale = 'day';
        
        vm.room_type_count = [];
        if(typeof ganttData.room_counts != 'undefined'){
            vm.room_type_count = ganttData.room_counts;
        }

        vm.product_type_list = [];
        if(typeof ganttData.product_type_list != 'undefined'){
            vm.product_type_list = ganttData.product_type_list;
        }
        
        if (vm.roomTypes == 'condos') {
            vm.mdSelectedIndex = 0;
        } else if (vm.roomTypes == 'villas') {
            vm.mdSelectedIndex = 1;
        } else {
            vm.mdSelectedIndex = 2;
        }
       
        vm.pageType = 'room';
        if(typeof requestFor != 'undefined' && requestFor == 'boat'){
            vm.pageType = 'boat';
            if (vm.boatDispType == 'quarter' || vm.boatDispType  == 'year') {
                vm.ganttChartHeader = ['year','month'];
                vm.ganttScale = vm.boatDispType;
            } else {
                vm.ganttChartHeader = ['month', 'day'];
                vm.ganttScale = 'day';
            }
        }else if(typeof requestFor != 'undefined' && requestFor == 'rent'){
            vm.pageType = 'rent';
            // vm.ganttChartHeader = ['year','month'];
            // vm.ganttScale = 'year';
            if (vm.rentDispType == 'quarter' || vm.rentDispType  == 'year') {
                vm.ganttChartHeader = ['year','month'];
                vm.ganttScale = vm.rentDispType;
            } else {
                vm.ganttChartHeader = ['month', 'day'];
                vm.ganttScale = 'day';
            }
        }

        if (vm.currentHotelId == '122' || vm.currentHotelId == '129' ||  vm.currentHotelId == '135' ||  (vm.currentHotelId == '126' && vm.pageType != 'rent')) {
            vm.modifiedTapeChart = true;
        } else {
            vm.modifiedTapeChart = false;
        }
        
        vm.condoLabel = 'Condos';
        if (vm.currentHotelId == 122) {
            vm.condoLabel = 'Rooms';
        }
		if (!ganttData.success && ganttData.errorMsg){
			vm.mainErrorMsg = ganttData.errorMsg;
		} else {
			vm.mainErrorMsg = false;
            vm.number_of_days = parseInt(ganttData.number_of_days) + parseInt(2) ;
            $rootScope.number_of_days = parseInt(ganttData.number_of_days) + parseInt(2);
		}

        vm.changeTab = function(type) {
            vm.isloading = true;
            vm.scopeDataValue = $scope.data = [];
            if (type == 'villas') {
                // vm.pageType = 'room';
                // vm.roomTypes = 'villas';                
                $state.go("app.villasGanttChart");
            } else if (type == 'condos') {
                // vm.pageType = 'room';
                // vm.roomTypes = 'condos';
                $state.go("app.newGanttChart");
            } else if (type == 'boat') {
                // vm.pageType = 'boat';
                // vm.roomTypes = 'boat';
                $state.go("app.boat_gannChartNew");
            }
            // vm.getDataOnStateChange();
        };

        vm.changeBoatDisplayType = function() {
            $localStorage['boatFilterType'] = vm.boatDispType;
            $state.reload();
        };

        // Residence range change
        vm.changeRentDisplayType = function() {
            $localStorage['rentFilterType'] = vm.rentDispType;
            $state.reload();
        }
        // vm.boatTypes = [{key: 'finger_pier', value: 'Finger Pier'}, {key: 'dingy_dock+sea_wall', value: 'Sea Wall Plus Dingy Dock'}];
        // Data
        vm.live = {};
        vm.enableReload = true;
        vm.isCurrentDateVisible = true;
        vm.myStyle = "";
        vm.scrollFrom = vm.scrollto = '';
        var date = new Date(), y = date.getFullYear(), m = date.getMonth(), d = date.getDay();
        var unixdateEnd=(moment(date).add(parseInt(vm.number_of_days), 'days').unix())*1000;
        var unixdatestart=(moment(date).subtract(2, 'days').unix())*1000;
		var dateTime=new Date(unixdatestart);
		var date_SS=dateTime.toISOString();
		var dateTime=new Date(unixdateEnd);
		var date_EE=dateTime.toISOString();
		var firstDay=new Date(date_SS);
		var lastDay=new Date(date_EE);
		vm.commit = false;
		vm.currenttask=[];
		vm.orderModifying = {};
		vm.userPermissions = $rootScope.userPermissions;
		vm.occupancyData = {};
		vm.requestgoing = false;
		vm.roomMovedOrderData = {};
		vm.policyData='';
        vm.lastTaskEvent = '';
        vm.roomInformation = '';
        vm.roomInformationHtml = '';
		var srceenwidth = $window.innerWidth;
        var zoomval;
		if(srceenwidth >= 3800){
			 if($rootScope.number_of_days >= 30){
                 zoomval=3.5;
            }else{
                 zoomval=4.5;
            }
		}else if(srceenwidth >= 3200 && srceenwidth < 3800){
            if($rootScope.number_of_days >= 30){
                 zoomval=3;
            }else{
                 zoomval=4;
            }			
		}else if(srceenwidth >= 3000 && srceenwidth < 3200){
			if($rootScope.number_of_days >= 30){
                 zoomval=2.5;
            }else{
                 zoomval=4.0;
            }
		}else if(srceenwidth > 2000 && srceenwidth < 3000){
            if($rootScope.number_of_days >= 30){
                 zoomval=2.0;
            }else{
                 zoomval=3.0;
            }
		}else if(srceenwidth > 1600 && srceenwidth <= 2000){
            if($rootScope.number_of_days >= 30){
                 zoomval=1.5;
            }else{
                 zoomval=2.0;
            }
		}else{
            if($rootScope.number_of_days >= 30){
                 zoomval=1;
            }else{
                 zoomval=1.5;
            }
		}

        if (typeof requestFor != 'undefined' && requestFor == 'boat') {
            if (vm.boatDispType == 'year') {
                zoomval=2.5;
            } else if (vm.boatDispType == 'month')  {
                if(srceenwidth >= 3800){
                    zoomval=4.5;
                } else if(srceenwidth >= 3200 && srceenwidth < 3800) {
                    zoomval=4;
                } else if(srceenwidth >= 3000 && srceenwidth < 3200) {
                    zoomval=4.0;
                } else if(srceenwidth > 2000 && srceenwidth < 3000) {
                    zoomval=3.0;
                } else if(srceenwidth > 1600 && srceenwidth <= 2000) {
                    zoomval=2.0;
                } else {
                    zoomval=1.5;
                }
            } else if (vm.boatDispType == 'quarter') {
                if(srceenwidth > 4000){
                    zoomval=8;
                } else if (srceenwidth > 3600 && srceenwidth <= 4000) {
                    zoomval=6;
                } else if (srceenwidth > 3100 && srceenwidth <= 3600) {
                    zoomval=5;
                } else if (srceenwidth > 2700 && srceenwidth <= 3100) {
                    zoomval=4;
                } else if (srceenwidth > 2300 && srceenwidth <= 2700) {
                    zoomval=4.0;
                } else if (srceenwidth > 1900 && srceenwidth <= 2300) {
                    zoomval=3.0;
                } else if (srceenwidth > 1600 && srceenwidth <= 1900) {
                    zoomval=2.4;
                } else {
                    zoomval=2;
                }
            }
        } else if (typeof requestFor != 'undefined' && requestFor == 'rent') {
            if (vm.rentDispType == 'year') {
                zoomval=2.5;
            } else if (vm.rentDispType == 'month')  {
                if(srceenwidth >= 3800){
                    zoomval=4.5;
                } else if(srceenwidth >= 3200 && srceenwidth < 3800) {
                    zoomval=4;
                } else if(srceenwidth >= 3000 && srceenwidth < 3200) {
                    zoomval=4.0;
                } else if(srceenwidth > 2000 && srceenwidth < 3000) {
                    zoomval=3.0;
                } else if(srceenwidth > 1600 && srceenwidth <= 2000) {
                    zoomval=2.0;
                } else {
                    zoomval=1.5;
                }
            } else if (vm.rentDispType == 'quarter') {
                if(srceenwidth > 4000){
                    zoomval=8;
                } else if (srceenwidth > 3600 && srceenwidth <= 4000) {
                    zoomval=6;
                } else if (srceenwidth > 3100 && srceenwidth <= 3600) {
                    zoomval=5;
                } else if (srceenwidth > 2700 && srceenwidth <= 3100) {
                    zoomval=4;
                } else if (srceenwidth > 2300 && srceenwidth <= 2700) {
                    zoomval=4.0;
                } else if (srceenwidth > 1900 && srceenwidth <= 2300) {
                    zoomval=3.0;
                } else if (srceenwidth > 1600 && srceenwidth <= 1900) {
                    zoomval=2.4;
                } else {
                    zoomval=2;
                }
            }
        }
       
        // if(typeof requestFor != 'undefined' && requestFor == 'rent'){
        //     zoomval=2.5;
        // }
        
		$rootScope.customoption = 'yes';
        if ((vm.currentHotelId == 126 || vm.currentHotelId == 122)&& vm.pageType == 'room') {
		    vm.maxheight=jQuery(window).height()-205;
        } else if (vm.pageType == 'boat') {
            vm.maxheight=jQuery(window).height()-205;
        } else {
            vm.maxheight=jQuery(window).height()-155;
        }
		vm.isloading = false;

        vm.options = {
			headersFormats: {
			  'year': 'YYYY', 
			  'quarter': '[Q]Q YYYY', 
			  month: 'MMMM YYYY', 
			  week: function(column) {
				return column.date.format('MMM D [-]') + column.endDate.format('[ ]MMM D');
			  },
			  day: 'D:dd:M-D-YYYY', 
			  hour: 'H', 
			  minute:'HH:mm'
			},
            mode                    : 'custom',
            scale                   : vm.ganttScale,
            sortMode                : undefined,
            sideMode                : 'Tree',
            daily                   : false,
            maxHeight               : true,
            width                   : true,
            zoom                    : zoomval,
            rowSortable             : true,
            jsPlumbDefaults             : false,
            columns                 : ['model.name', 'from', 'to'],
            treeTableColumns        : ['from', 'to'],
            columnsHeaders          : {
                'model.name' : 'Rooms', 'from': 'From', 'to': 'To'
            },
            columnsClasses          : {
                'model.name': 'gantt-column-name',
                'from'      : 'gantt-column-from',
                'to'        : 'gantt-column-to'
            },
            columnsFormatters       : {
                'from': function (from)
                {
                    return angular.isDefined(from) ? from.format('lll') : undefined;
                },
                'to'  : function (to)
                {
                    return angular.isDefined(to) ? to.format('lll') : undefined;
                }
            },
            treeHeaderContent       : '',
            columnsHeaderContents   : {
                'model.name': '{{getHeader()}}',
                'from'      : '{{getHeader()}}',
                'to'        : '{{getHeader()}}'
            },
            autoExpand              : 'both',
            taskOutOfRange          : 'truncate',
            fromDate                : firstDay,
            toDate                  : lastDay,
            rowContentEnabled       : true,
            // rowContent              : '<div ng-if="row.model.is_sub_hotel == 1" class="icon-hotel right-hotel_gant"  title="hotel"/><div ng-if="row.model.product_is_clean==2 && row.model.is_walk != 1" class="icon-light-cleaning right-hotel_gant green-500-fg" ng-click="scope.popupRoomClean(2,$event,row.model.id,row)" title="Light Clean"/><div ng-if="row.model.product_is_clean==1 && row.model.is_walk != 1" class="icon-check-circle right-hotel_gant green-500-fg" ng-click="scope.popupRoomClean(1,$event,row.model.id,row)" title="clean"/><div ng-if="row.model.product_is_clean==0  && row.model.is_walk != 1" class="icon-broom right-hotel_gant red-A800-fg" ng-click="scope.popupRoomClean(0,$event,row.model.id,row)" title="dirty"/><span>{{row.model.name}} <b style="font-weight:normal;font-size:14px;display:inline-block;" ng-if="row.model.boat_dimension">({{row.model.boat_dimension}})</b><b ng-if="row.model.is_walk != 1"></b></span><span class="icon-information info-icon" ng-if="row.model.is_sub_hotel != 1 && row.model.is_walk !=  1"ng-click="scope.get_room_description($event,row.model.id,row)"></span> ',
            rowContent              : '<span ng-if="row.model.is_sub_hotel == 1" class="right-hotel_gant sub-hotel-expand-icon" ng-class="row.model.allExpanded ? \'icon-chevron-down\' : \'icon-chevron-right\'" title="{{row.model.allExpanded ? \'Collapse all\' : \'Expand all\'}}"></span><div ng-if="row.model.product_is_clean==2 && row.model.is_walk != 1" class="icon-light-cleaning right-hotel_gant green-500-fg" ng-click="scope.popupRoomClean(2,$event,row.model.productId,row)" title="Light Clean"/><div ng-if="row.model.product_is_clean==1 && row.model.is_walk != 1" class="icon-check-circle right-hotel_gant green-500-fg" ng-click="scope.popupRoomClean(1,$event,row.model.productId,row)" title="clean"/><div ng-if="row.model.product_is_clean==0  && row.model.is_walk != 1" class="icon-broom right-hotel_gant red-A800-fg" ng-click="scope.popupRoomClean(0,$event,row.model.productId,row)" title="dirty"/><span class="room-name-class">{{row.model.name}} <b style="font-weight:normal;font-size:14px;display:inline-block;" ng-if="row.model.boat_dimension">({{row.model.boat_dimension}})</b><md-progress-circular md-mode="indeterminate" class="loader-pdfmain md-accent gantt-chart-loader" md-diameter="30px" ng-if="row.model.is_sub_hotel != 1 && row.model.isParent && row.model.showRoomLoader && row.model.is_walk != 1"></md-progress-circular><b ng-if="row.model.is_walk != 1"></b></span><span class="icon-information info-icon" ng-if="row.model.is_sub_hotel != 1 && row.model.is_walk != 1 && row.model.showDescription" ng-click="scope.get_room_description($event,row)"></span>',
            taskContentEnabled      : true,
            taskContent             : '<i ng-if="task.model.name == \'New Reservation\'" class="gantt-task-edit-button icon-pencil s12 icon hiddendata"   aria-label="edit task"></i><span bind-html-compile="task.model.name"></span>',
            allowSideResizing       : false,
            labelsEnabled           : true,
            currentDate             : 'line',
            currentDateValue        : new Date(),
            draw                    : true,
            readOnly                : false,
            groupDisplayMode        : 'group',
            filterTask              : '',
            filterRow               : '',
           
            timeFrames              : {
                'day'    : {
                    start  : moment('8:00', 'HH:mm'),
                    end    : moment('20:00', 'HH:mm'),
                    working: false,
                    default: false
                },
                'noon'   : {
                    start  : moment('12:00', 'HH:mm'),
                    end    : moment('13:30', 'HH:mm'),
                    working: false,
                    default: false
                },
                'weekend': {
                    color:'#da7b3b'
                },
                'holiday': {
                    working: false,
                    color  : 'red',
                    classes: ['gantt-timeframe-holiday']
                }
            },
            dateFrames              : {
                'weekend'    : {
                    evaluator: function (date)
                    {
                        return date.isoWeekday() === 5 || date.isoWeekday() === 6;
                    },
                    targets  : ['weekend']
                },
                '11-november': {
                    evaluator: function (date)
                    {
                        return date.month() === 10 && date.date() === 11;
                    },
                    targets  : ['holiday']
                }
            },
            timeFramesWorkingMode   : 'hidden',
            timeFramesNonWorkingMode: 'visible',
            columnMagnet            : '15 minutes',
            timeFramesMagnet        : true,
            canDraw                 : function (event)
            {
                var isLeftMouseButton = event.button === 0 || event.button === 1;
                return vm.options.draw && !vm.options.readOnly && isLeftMouseButton;
            },
            drawTaskFactory         : function ()
            {
                return {
                    id   : ganttUtils.randomUuid(),  // Unique id of the task.
                    name : 'New Reservation', // Name shown on top of each task.
                    color: '#AA8833', // Color of the task in HEX format (Optional).
                    darkcolor: '#BCAAA4' // Color of the task in HEX format (Optional).
                };
            },
            api                     : function (ganttApi)
            {
                // API Object is used to control methods and events from angular-gantt.
                vm.api = ganttApi;
                vm.api.core.on.ready($scope, function () {
                    vm.api.tasks.on.add($scope, addEventName('tasks.on.add', logTaskEvent));
                    vm.api.tasks.on.change($scope, addEventName('tasks.on.change', logTaskEvent));
                    vm.api.tasks.on.rowChange($scope, addEventName('tasks.on.rowChange', logTaskEvent));
                    vm.api.tasks.on.remove($scope, addEventName('tasks.on.remove', logTaskEvent));

                    if (vm.api.tasks.on.moveBegin) {

                        vm.api.tasks.on.moveBegin($scope, function(task){
                            vm.currentMovingTask = task;
                            vm.highlightFrom = moment(task.model.from);
                            vm.highlightTo   = moment(task.model.to);
                            addEventName('tasks.on.moveBegin', logTaskEvent)(task);
                            highlightCheckInOut(task, true);
                        });

                        vm.api.tasks.on.moveEnd($scope, function(task){
                            vm.currentMovingTask = null;
                            vm.highlightFrom = null;
                            vm.highlightTo   = null;
                            addEventName('tasks.on.moveEnd', logTaskEvent)(task);
                            highlightCheckInOut(task, false);
                        });

                        vm.api.tasks.on.resizeBegin($scope, function(task){
                            vm.currentMovingTask = task;
                            vm.highlightFrom = moment(task.model.from);
                            vm.highlightTo   = moment(task.model.to);
                            addEventName('tasks.on.resizeBegin', logTaskEvent)(task);
                            highlightCheckInOut(task, true);
                        });

                        vm.api.tasks.on.resizeEnd($scope, function(task){
                            vm.currentMovingTask = null;
                            vm.highlightFrom = null;
                            vm.highlightTo   = null;
                            addEventName('tasks.on.resizeEnd', logTaskEvent)(task);
                            highlightCheckInOut(task, false);
                        });

                    }
                    // When gantt is ready, load data.
                    // `data` attribute could have been used too.
                    vm.load('graph');
                    if (vm.stateChanged) {
                        $timeout(function() {
                            vm.api.tree.collapseAll();
                            vm.expandRooms();
                        }, 0);
                        vm.stateChanged = false;
                    }
                    // DOM events
                    jQuery("div.custom-menu").hide();
                    vm.api.directives.on.new($scope, function (directiveName, directiveScope, element)
                    {
                        /**
                         * Gantt Task
                         */
                        if ( directiveName === 'ganttTask' )
                        {
                            var taskModel = directiveScope.task.model;
                            if (taskModel.color_code && taskModel.type_of_reservation === 'reservation') {
                                element.css({
                                    'border-bottom': '2px solid ' + taskModel.color_code,
                                    'border-radius': '4px',
                                });
                            }

                            element.on('mousedown touchstart', function (event)
                            {
                                event.preventDefault();
                                event.stopPropagation();
                                vm.live.row = directiveScope.task.row.model;
                                if ( angular.isDefined(directiveScope.task.originalModel) )
                                {
                                    vm.live.task = directiveScope.task.originalModel;
                                }
                                else
                                {
                                    vm.live.task = directiveScope.task.model;
                                }
                                $scope.$digest();
                            });
                            element.on('contextmenu', function (event)
                            {
                                event.preventDefault();
                                vm.currenttask=directiveScope.task;
                                if(vm.currenttask.model.type_of_reservation == 'hold'){
                                    var html='<div class="custom-menu"><md-menu-content width="2" class="pv-0"> ';
                                      html+='     <md-menu-item>';
                                      html+='              <md-button aria-label="View" ng-click="vm.editHoldDates(event)"  class="no-margin ph-16">';
                                      html+='                  Edit';
                                      html+='              </md-button>';
                                      html+='          </md-menu-item>';
                                      html+='          <md-menu-item>';
                                      html+='              <md-button ng-click="vm.removeHoldBlockDates(\'hold\',event)" aria-label="Cancel">';
                                      html+='                  Release';
                                      html+='              </md-button>';
                                      html+='          </md-menu-item>';
                                      html+='     <md-menu-item>';
                                      html+='              <md-button aria-label="Unblock" ng-click="vm.convertToRes(\'hold\',event)"  class="no-margin ph-16">';
                                      html+='                  Create reservation';
                                      html+='              </md-button>';
                                      html+='          </md-menu-item>';
                                      html+='          <md-menu-item>';
                                      html+='              <md-button ng-click="vm.addcommentinorder(event)" aria-label="Add comment">';
                                      html+='                  Note';
                                      html+='              </md-button>';
                                      html+='          </md-menu-item>';
                                      html+='      </md-menu-content></div>';
                                } else if(vm.currenttask.model.type_of_reservation == 'block'){
                                    var html='<div class="custom-menu"><md-menu-content width="2" class="pv-0"> ';
                                      html+='     <md-menu-item>';
                                      html+='              <md-button aria-label="Unblock" ng-click="vm.removeHoldBlockDates(\'block\',event)"  class="no-margin ph-16">';
                                      html+='                  Unblock';
                                      html+='              </md-button>';
                                      html+='          </md-menu-item>';
                                      html+='     <md-menu-item>';
                                      html+='              <md-button aria-label="Unblock" ng-click="vm.convertToRes(\'block\',event)"  class="no-margin ph-16">';
                                      html+='                  Create reservation';
                                      html+='              </md-button>';
                                      html+='          </md-menu-item>';
                                      html+='          <md-menu-item>';
                                      html+='              <md-button ng-click="vm.addcommentinorder(event)" aria-label="Add comment">';
                                      html+='                  Note';
                                      html+='              </md-button>';
                                      html+='          </md-menu-item>';
                                      html+='      </md-menu-content></div>';
                                } else if(vm.currenttask.model.type_of_reservation == 'reservation' || vm.currenttask.model.type_of_reservation == 'boat' || vm.currenttask.model.type_of_reservation == 'rent' || vm.currenttask.model.type_of_reservation == 'day_reservation' ){
                                    var html='<div class="custom-menu"><md-menu-content width="2" class="pv-0"> ';
                                      html+='          <md-menu-item>';
                                      if(vm.currenttask.model.hasOwnProperty('room_confirmation_number') && vm.currenttask.model.room_confirmation_number != null )
                                        html+='              <md-button ng-click="vm.viewOrder('+vm.currenttask.model.reservation_id+',\''+vm.currenttask.model.room_confirmation_number+'\')" aria-label="Cancel">';
                                      else
                                        html+='              <md-button ng-click="vm.viewOrder('+vm.currenttask.model.reservation_id+',\''+vm.currenttask.model.confirmation_number+'\')" aria-label="Cancel">';
                                      html+='                  View';
                                      html+='              </md-button>';
                                      html+='          </md-menu-item>';
                                      html+='          <md-menu-item>';
                                      html+='              <md-button ng-click="vm.setWaitingForRoomFromGantt(event)" aria-label="Waiting for Room">';
                                      html+='                  Waiting for Room';
                                      html+='              </md-button>';
                                      html+='          </md-menu-item>';
                                      html+='          <md-menu-item>';
                                      html+='              <md-button ng-click="statusDialog(event,\'Checked-In\','+vm.currenttask.model.RemainAmount+')" aria-label="Check In">';
                                      html+='                  Check In';
                                      html+='              </md-button>';
                                      html+='          </md-menu-item>';
                                      html+='          <md-menu-item>';
                                      html+='              <md-button ng-click="statusDialog(event,\'Checked-Out\','+vm.currenttask.model.RemainAmount+')" aria-label="Check Out">';
                                      html+='                  Check Out';
                                      html+='              </md-button>';
                                      html+='          </md-menu-item>';
                                      html+='          <md-menu-item>';
                                      html+='              <md-button ng-click="statusDialog(event,\'Canceled\',\'\')" aria-label="Cancel">';
                                      html+='                  Cancel';
                                      html+='              </md-button>';
                                      html+='          </md-menu-item>';
                                      html+='          <md-menu-item>';
                                      html+='              <md-button ng-click="statusDialog(event,\'Closed\','+vm.currenttask.model.RemainAmount+')" aria-label="Close">';
                                      html+='                  Close';
                                      html+='              </md-button>';
                                      html+='          </md-menu-item>';
                                      html+='          <md-menu-item>';
                                      html+='              <md-button ng-click="vm.addcommentinorder(event)" aria-label="Add comment">';
                                      html+='                  Note';
                                      html+='              </md-button>';
                                      html+='          </md-menu-item>';
                                      html+='      </md-menu-content></div>';
                                  }
                                  jQuery('.custom-mnu-container').html('');
                                angular.element(jQuery('.custom-mnu-container')).append($compile(html)($scope));
                                jQuery('.custom-menu').css('top',event.pageY+"px");
                                jQuery('.custom-menu').css('left',event.pageX+"px");
                                if(!isScrolledIntoView(jQuery('.custom-menu'))){
                                    jQuery('.custom-menu').css('bottom',"14px");
                                    jQuery('.custom-menu').css('top',"auto");
                                    jQuery('.custom-menu').css('left',event.pageX+"px");
                                }
                            });

                        }

                        /**
                         * Gantt Row
                         */
                        else if ( directiveName === 'ganttRow' )
                        {

                            element.on('click', function (event)
                            {
                                event.stopPropagation();
                            });

                            element.on('mousedown touchstart', function (event)
                            {
                                event.stopPropagation();
                                vm.live.row = directiveScope.row.model;
                                $scope.$digest();
                            });

                        }

                        /**
                         * Gantt Row Label
                         */
                        else if ( directiveName === 'ganttRowLabel' )
                        {
                            
                            // Sub-hotel: whole label click = expand/collapse all (like room-type row click)
                            if (directiveScope.row.model.is_sub_hotel == 1) {
                                element.css({'pointer-events': 'all', 'cursor': 'pointer'});
                                element.off('click.subHotelExpand').on('click.subHotelExpand', function (event)
                                {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    $scope.expandAllForSubHotel(event, directiveScope.row);
                                    if (!$scope.$$phase) {
                                        $scope.$apply();
                                    }
                                });
                            } else {
                                // Fix for double trigger due to gantt-sortable plugin
                                element.off('click');
                                element.on('click', function (event)
                                {
                                    event.preventDefault();
                                    //~ editDialog(event, 'row', directiveScope.row);
                                    if($(this).prev('a.gantt-tree-handle-button')) {
                                       $(this).prev('a.gantt-tree-handle-button').click();
                                    }
                                });
                            }

                            element.on('mousedown touchstart', function ()
                            {
                                vm.live.row = directiveScope.row.model;
                                $scope.$digest();
                            });

                        }
                    });
					vm.api.tasks.on.resizeEnd($scope,function (task){
                        if (task.model.name == 'New Reservation') {
							vm.eventType='new';
							vm.roomName=task.row.model.prodName != undefined ? task.row.model.prodName : task.row.model.name;
							$timeout(function() {
								vm.isloading = true;
								vm.addReservation(task,vm.roomName,'create');
							},500);
						} else {
                            vm.eventType='resize';
							vm.lastTaskEvent = 'resizeEnd';
                            vm.getOrderInfo(task,false);
						}
					});
                    vm.api.tasks.on.rowChange($scope, function (task)
                    {
                        vm.live.row = task.row.model;
                        if(task.model.name!='New Reservation'){
							vm.lastTaskEvent = 'rowChange';
							vm.getOrderInfo(task,true);
						}
                    });
                    vm.api.tasks.on.moveEnd($scope, function (task)
                    {
                        if(task.model.name!='New Reservation' && vm.lastTaskEvent!='rowChange'){
							vm.lastTaskEvent = 'moveEnd';
							vm.getOrderInfo(task,false);
						}
                    });
                    vm.api.scroll.on.scroll($scope, function (left, date, direction){
                         if(vm.currentMovingTask){
                            highlightCheckInOut({
                                model:{
                                    from: vm.highlightFrom,
                                    to: vm.highlightTo
                                }
                            }, true);
                        }
                        if(direction!='undefined' && left > 0 && vm.currentHotelId != '122') {
							get_room_percent_this(vm.occupancyData);
                        }
                        updateCurrentDateLine();
					});
 
                    objectModel = new GanttObjectModel(vm.api);
 
                    if (vm.api.columns && vm.api.columns.on && vm.api.columns.on.refresh) {
                        vm.api.columns.on.refresh($scope, function () {
                            updateCurrentDateLine();
                        });
                    }
                });
 
                vm.api.core.on.rendered($scope, function (){
                    updateCurrentDateLine();
                });
               
                vm.api.rows.on.move($scope, function(row, oldIndex, newIndex){
                    var error = false;
                    // var isSJ = (typeof vm.currentHotelId != 'undefined' && (vm.currentHotelId == 126))? true : false;
                    // var isPBR = (typeof vm.currentHotelId != 'undefined' && (vm.currentHotelId == 122))? true : false;
                    var isMT = (typeof vm.currentHotelId != 'undefined' && (vm.currentHotelId == 116))? true : false;
                    var roomName = row.model.name != undefined ? row.model.name : '';
                    var isWalk = row.model.is_walk !== undefined && row.model.is_walk == '1' ? true : false;
                    var parentMoved = row.model.isParent != undefined ? row.model.isParent.toString() : 'false';
                    var parentId = row.model.parent != undefined ? row.model.parent : 0;
                    var mainId = row.model.id;
                    var parentWrongIndex = false;
                    vm.childIndex = '';

                    if (isMT) {
                        if(vm.pageType == 'room' && roomName.toLowerCase() != 'walk') {
                            if(vm.product_type_list.length > 0 || Object.keys(vm.product_type_list).length > 0) {
                                var pro_id = row.model.id;
                                var pro_type = vm.product_type_list[pro_id];
                               
                                if (pro_type == 116 && (newIndex < vm.room_type_count['116']['start'] || newIndex > vm.room_type_count['116']['end'])) {
                                    error = true;
                                } else if (pro_type == 'garden villa' && (newIndex < vm.room_type_count['garden villa']['start'] || newIndex > vm.room_type_count['garden villa']['end'])) {
                                    error = true;
                                }
                            }
                        }
                    } else if (vm.currentHotelId == 122 && vm.pageType == 'boat') {

                    } else if(vm.subRoomHotels.includes(vm.currentHotelId) && !isWalk && vm.pageType != 'rent') {
                        if (parentMoved === 'true' && vm.parentRoomIndexes.includes(newIndex)) {
                            var tempData = angular.copy(vm.scopeDataValue);
                            var storeTempRoom = [];
                            var roomSubProd = [];
                            var actualProd = [];
                            /*if (oldIndex < newIndex) {
                                actualProd = tempData[newIndex];
                                tempData.splice(newIndex, 1);
                                angular.forEach(vm.scopeDataValue, function(value, key) {
                                    if (key >= oldIndex && mainId == value.parent) {
                                        roomSubProd.push(value);
                                        tempData.splice(key, 1);
                                    }
                                });
                                
                                tempData.splice(newIndex, 0 , actualProd);
                                var incNewIndex = newIndex;
                                if (roomSubProd.length > 0) {
                                    angular.forEach(roomSubProd, function(value, key) {
                                        incNewIndex = parseInt(incNewIndex + key + 1);
                                        tempData.splice(incNewIndex, 0, value);
                                    });                                    
                                }

                                $timeout(function() {
                                    $scope.data = [];
                                    $scope.data = tempData;
                                }, 0);
                            } else {
                                angular.forEach(vm.scopeDataValue, function(value, key) {
                                    if (key > newIndex) {
                                        if (value.parent != undefined && value.parent == mainId) {
                                            roomSubProd.push(value);
                                        } else {
                                            storeTempRoom.push(value);
                                        }
                                        tempData.splice(key);
                                    } else if (key == newIndex) {
                                        actualProd = value;
                                        tempData.splice(key);
                                    }
                                });
                                $timeout(function() {
                                    tempData.push(actualProd);
                                    
                                    if (roomSubProd.length > 0) {
                                        angular.forEach(roomSubProd, function(value, key) {
                                            tempData.push(value);
                                        });
                                    }

                                    if (storeTempRoom.length > 0) {
                                        angular.forEach(storeTempRoom, function(value, key) {
                                            tempData.push(value);
                                        });
                                    }

                                    $scope.data = [];
                                    $scope.data = tempData;
                                }, 0);
                            }*/                                   
                        } else if (parentMoved === 'true' && !vm.parentRoomIndexes.includes(newIndex)) {
                            parentWrongIndex = true;
                        } else {
                            vm.parentIdIndex;
                            vm.walkIndexes = [];
                            angular.forEach($scope.data, function(value, key){
                                if (value.isParent != undefined && value.id == parentId) {
                                    vm.parentIdIndex = key;
                                    // return;
                                }

                                if (value.parent != undefined && value.is_walk != undefined && value.is_walk == 1) {
                                    if (vm.walkIndexes.length == 0) {
                                        vm.walkIndexes.push(key+1);
                                    } else {
                                        vm.walkIndexes.push(key);
                                    }
                                }
                            });

                            var index = vm.parentRoomIndexes.indexOf(vm.parentIdIndex);
                            vm.startIndex = vm.parentIdIndex;
                            vm.endIndex;
                            if (index >= 0 && index < vm.parentRoomIndexes.length - 1) {
                                vm.endIndex = vm.parentRoomIndexes[index + 1];
                            } else if (index == vm.parentRoomIndexes.length - 1) {
                                vm.endIndex = newIndex + 1;  // last array check
                            }
                            
                            if (vm.walkIndexes.indexOf(newIndex) > -1) {
                                vm.childIndex = 'walk';
                            } else {
                                if (vm.startIndex < newIndex && vm.endIndex > newIndex) {
                                    vm.childIndex = 'correct';
                                } else {
                                   vm.childIndex = 'wrong';
                                }
                            }
                        }                           
                    }

                    if (error || parentWrongIndex || vm.childIndex == 'wrong' || vm.childIndex == 'walk' || (isWalk && vm.subRoomHotels.includes(vm.currentHotelId))) {
                        var msg;

                        vm.roomSlip = vm.pageType == 'boat' ? 'slip' : 'room';
                        if (isWalk) {
                            msg = 'Walk room cannot be moved.'; 
                        } else if (parentWrongIndex) {
                            msg = 'You cannot move parent of one '+vm.roomSlip+' type into another.';
                        } else if (vm.childIndex == 'wrong') {
                            msg = 'You cannot move one '+vm.roomSlip+' type into another '+vm.roomSlip+' type.';
                        } else if (vm.childIndex == 'walk') {
                            msg = 'You cannot move room to walk position.';
                        } else {
                           msg = 'You cannot move one room type to another.'; 
                        }
                        toastMessage.showSimpleToast(msg,'warning-toast');
                        if (vm.allRoomHotels.includes(vm.currentHotelId) || vm.pageType == 'rent') {
                            load('changeDate');
                        } else {
                            $timeout(function() {
                                $state.reload();
                            }, 10);
                            /*var tempStoreJsonData = JSON.parse(vm.storeJsonData);
                            $timeout(function() {
                                vm.scopeDataValue = $scope.data = [];
                                vm.scopeDataValue = $scope.data = tempStoreJsonData;                                
                            }, 0);

                            $timeout(function() {
                                vm.updateFullGanttData();
                            }, 100);*/
                        }
                    } else if(!error) {
                        var newSortOrder = [];
                        var childMoved = false;

                        if (parentMoved === 'true') {
                            angular.forEach($scope.data, function (value, key) {
                                if (value.isParent != undefined || (value.is_walk != undefined && value.is_walk == 1 && value.parent != undefined)) {
                                    if (value.is_walk != undefined && value.is_walk == 1) {
                                        newSortOrder.push(value.parent);
                                    } else {
                                        newSortOrder.push(value.id);
                                    }
                                }
                            });
                        } else if (vm.childIndex == 'correct') {
                            childMoved = true;
                            angular.forEach($scope.data, function(value, key){
                                if (value.parent != undefined && value.parent == parentId) {
                                    newSortOrder.push(value.productId);
                                }
                            });
                            vm.calculateSelectedIndex(parentId, 'parent');
                        } else {
                           angular.forEach($scope.data, function (value, key) {
                                if (value.productId != undefined) {
                                    newSortOrder.push(value.productId);
                                }
                            });
                        }
                        
                        ganttChartServiceNew.setSortOrder({newSortOrder: newSortOrder, parentMoved : parentMoved, childMoved: childMoved, parentId: parentId}).then(function(response){
                            if (vm.currentHotelId == 122 && vm.pageType == 'boat') {

                            } else if (vm.subRoomHotels.includes(vm.currentHotelId) && vm.pageType != 'rent') {
                                // vm.updateFullGanttData();
                                if (parentMoved) {
                                    $state.reload();
                                } else if (vm.childIndex == 'correct') {
                                    if (response.productIds != undefined && response.productIds.length && vm.pageType != 'boat') {
                                        $scope.data[vm.clickedParentIndex].productIds = response.productIds;
                                    }
                                }
                            }
    						if(!response.success){
    							toastMessage.showSimpleToast('There was some error in saving sort order of rooms. Please try again later.','error-toast');
    						}
    					});
                    }
				});
            }
        };

        function highlightCheckInOut(task, highlight) {

            // remove previous highlights
            jQuery('.gantt-column-highlight')
                .removeClass('gantt-column-highlight');

            jQuery('.gantt-col-highlight')
                .removeClass('gantt-col-highlight');
            
            // restore weekend background
            jQuery('.gantt-timeframe-non-working')
                .css('background-color', 'rgb(218, 123, 59)');


            if (!highlight) return;

            const fromDate = moment(task.model.from);
            const toDate   = moment(task.model.to);

            const headers = jQuery('.gantt-column-header[data-room]');
            const columns = jQuery('.gantt-column.gantt-foreground-col');

            //Build a map: leftPx → column element
            const leftToColumn = {};
            columns.each(function() {
                const leftPx = parseInt(jQuery(this).css('left'), 10);
                leftToColumn[leftPx] = this;
            });

            headers.each(function() {
                const dataRoom = jQuery(this).attr('data-room');
                const columnDate = moment(dataRoom, 'M-D-YYYY');

                if (columnDate.isSameOrAfter(fromDate, 'day') && columnDate.isSameOrBefore(toDate, 'day')) {

                    jQuery(this).addClass('gantt-column-highlight');

                    // Match body column by identical left px
                    const headerLeft = parseInt(jQuery(this).css('left'), 10);
                    const matchedCol = jQuery(leftToColumn[headerLeft]);

                    matchedCol.addClass('gantt-col-highlight');
                    matchedCol
                        .find('.gantt-timeframe-non-working')
                        .css('background', 'transparent');
                }
            });
        }

        vm.isOpen = false;
		$scope.$watch('vm.isOpen', function(newValue, oldValue) {
			if (!newValue && oldValue) {
				document.querySelector('.md-datepicker-input').blur();
			}  
		});

        // jQuery(document).unbind().on("click",".gantt-tree-handle-button.gantt-tree-expanded",function() {
        jQuery(document).unbind().on("click",".gantt-tree-handle-button",function() {
            var $btn = $(this);
            var $nameEl = $btn.next().find('.room-name-class').first();
            var clickedKey = $nameEl.length
                ? $nameEl.clone().children().remove().end().text().replace(/^\s+|\s+$/gm, '')
                : ($btn.next().children().text() || '').trim();

            if (clickedKey === '') {
                return;
            }

            vm.isloading = true;
            $timeout(function() {
                if ($btn.hasClass('gantt-tree-expanded')) {
                    vm.getTasksForGroupRooms(clickedKey, 'rooms');
                    if (vm.storeRoomsRecord[clickedKey] != undefined) {
                        vm.storeRoomsRecord[clickedKey].expanded = true;
                    }
                } else if ($btn.hasClass('gantt-tree-collapsed')) {
                    if (vm.storeRoomsRecord[clickedKey] != undefined) {
                        vm.storeRoomsRecord[clickedKey].expanded = false;
                    }
                    angular.forEach($scope.data, function(value, key) {
                        if (value.name != undefined && value.name == clickedKey) {
                            $scope.data[key].showRoomLoader = false;
                            $scope.data[key].expanded = false;
                            $scope.data[key].classes = "parentClass pointer_events_disabled";
                            
                            angular.forEach($scope.data, function(roomValue, roomKey) {
                                if (roomValue.parent != undefined && value.id == roomValue.parent) {
                                    $scope.data[roomKey].tasks = [];
                                }
                            });
                            return;
                        }
                    });

                    angular.forEach(vm.parentRoomTypes, function(value, key) {
                        if (value.roomName == clickedKey) {
                            vm.parentRoomTypes[key].expanded = false;
                            return;
                        }
                    });
                }
                vm.updateParentRoomIndexes();
                vm.isloading = false;
            }, 0);
        });

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.search = search;
        vm.setSortMode = setSortMode;
        vm.addDialog = addDialog;
        vm.addReservation = addReservation;
        vm.convertToRes = convertToRes;
        vm.changeStatusAfterPayment = changeStatusAfterPayment;
        //~ vm.editDialog = editDialog;
        vm.addcommentinorder = addcommentinorder;
        vm.viewOrder = viewOrder;
        vm.canAutoWidth = canAutoWidth;
        vm.getColumnWidth = getColumnWidth;
        vm.load = load;
        vm.reload = reload;
        vm.removeHoldBlockDates = removeHoldBlockDates;
        vm.editHoldDates = editHoldDates;
        vm.getOrderInfo  = getOrderInfo;
        vm.saveReservation = saveReservation;
        vm.confirmEdit = confirmEdit;
        //////////

        init();
        
        $scope.$on('cancel_modification', function(event, data) {
            vm.reloadDataConditionally(data.productId);
            if (vm.storeLastEvent == 'rowChange') {
                $timeout(function(){
                    vm.reloadDataConditionally(vm.originalProductId, 'previous');
                }, 500);
            }
		});
        vm.task = {};
        vm.roomcleanstatus = '';

        /**
         * Room-type parents belonging to this sub-hotel only (until next is_sub_hotel).
         */
        function getRoomTypesForSubHotel(subHotelModel) {
            var groups = [];
            var startIndex = -1;
            var i;
            for (i = 0; i < $scope.data.length; i++) {
                if ($scope.data[i].id == subHotelModel.id && $scope.data[i].is_sub_hotel == 1) {
                    startIndex = i;
                    break;
                }
            }
            if (startIndex < 0) {
                return groups;
            }
            for (i = startIndex + 1; i < $scope.data.length; i++) {
                if ($scope.data[i].is_sub_hotel == 1) {
                    break;
                }
                if ($scope.data[i].isParent && $scope.data[i].productIds) {
                    groups.push($scope.data[i]);
                }
            }
            return groups;
        }

        /**
         * True if this room-type group is currently open.
         */
        function isRoomTypeOpen(group) {
            if (group.expanded) {
                return true;
            }
            if (vm.parentRoomTypes) {
                for (var i = 0; i < vm.parentRoomTypes.length; i++) {
                    if (vm.parentRoomTypes[i].roomName == group.name && vm.parentRoomTypes[i].expanded) {
                        return true;
                    }
                }
            }
            if (vm.storeRoomsRecord && vm.storeRoomsRecord[group.name] && vm.storeRoomsRecord[group.name].expanded) {
                return true;
            }
            return false;
        }

        /**
         * Sub-hotel chevron: down if any room type is open (next click closes all).
         */
        function syncSubHotelExpandIcons() {
            if (!$scope.data || !$scope.data.length) {
                return;
            }
            angular.forEach($scope.data, function(row) {
                if (row.is_sub_hotel != 1) {
                    return;
                }
                var groups = getRoomTypesForSubHotel(row);
                var anyOpen = false;
                angular.forEach(groups, function(group) {
                    if (isRoomTypeOpen(group)) {
                        anyOpen = true;
                    }
                });
                row.allExpanded = anyOpen;
            });
        }

        $scope.expandAllForSubHotel = function(event, row) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
                var nativeEvent = event.originalEvent || event;
                if (nativeEvent.subHotelExpandHandled) {
                    return;
                }
                nativeEvent.subHotelExpandHandled = true;
            }
            if (!row || !row.model || row.model.is_sub_hotel != 1 || !$scope.data) {
                return;
            }
            if (row.model._expandAllRunning) {
                return;
            }
            row.model._expandAllRunning = true;

            var groups = getRoomTypesForSubHotel(row.model);
            if (!groups.length) {
                row.model._expandAllRunning = false;
                return;
            }

            var anyOpen = false;
            angular.forEach(groups, function(group) {
                if (isRoomTypeOpen(group)) {
                    anyOpen = true;
                }
            });
            var collapsing = anyOpen;
            row.model.allExpanded = !collapsing;

            angular.forEach(groups, function(group) {
                if (collapsing) {
                    try {
                        if (vm.api && vm.api.tree && vm.api.tree.collapse) {
                            vm.api.tree.collapse(String(group.id));
                        }
                    } catch (e) {}
                    if (vm.storeRoomsRecord && vm.storeRoomsRecord[group.name] != undefined) {
                        vm.storeRoomsRecord[group.name].expanded = false;
                    }
                    angular.forEach($scope.data, function(value, key) {
                        if (value.name != undefined && value.name == group.name) {
                            $scope.data[key].showRoomLoader = false;
                            $scope.data[key].expanded = false;
                            $scope.data[key].classes = "parentClass pointer_events_disabled";
                            angular.forEach($scope.data, function(roomValue, roomKey) {
                                if (roomValue.parent != undefined && value.id == roomValue.parent) {
                                    $scope.data[roomKey].tasks = [];
                                }
                            });
                        }
                    });
                    angular.forEach(vm.parentRoomTypes, function(value, key) {
                        if (value.roomName == group.name) {
                            vm.parentRoomTypes[key].expanded = false;
                        }
                    });
                } else {
                    try {
                        if (vm.api && vm.api.tree && vm.api.tree.expand) {
                            vm.api.tree.expand(String(group.id));
                        }
                    } catch (e) {}
                    if (vm.storeRoomsRecord && vm.storeRoomsRecord[group.name] != undefined) {
                        vm.storeRoomsRecord[group.name].expanded = true;
                    }
                    vm.getTasksForGroupRooms(group.name, 'rooms');
                }
            });

            row.model._expandAllRunning = false;
            $timeout(function() {
                vm.updateParentRoomIndexes();
            }, 1);
        };

        $scope.popupRoomClean = function(isclean,ev,product_id,row){
            vm.roomcleanstatus = 1;
            vm.cleantype = isclean;
            vm.product_id = product_id;
            vm.row = row;
            var tooltipTop, tooltipBottom;
            var elementRect = row.$element[0].getBoundingClientRect();
            var tooltipArrowFromTop = true;
            var tooltipHeight;
            if(getViewPortWidth() >= 1800){
                tooltipHeight = 450;
            } else {
                tooltipHeight = 300;
            }
            if(parseInt(elementRect.top) + parseInt(tooltipHeight) > getViewPortHeight()){
                tooltipTop = "auto";
                tooltipBottom = (parseInt(getViewPortHeight()) - parseInt(elementRect.bottom) ) + "px";
                tooltipArrowFromTop = false;
            } else {
                tooltipTop = (parseInt(elementRect.top) - 64) + "px";
                tooltipBottom = "auto";
            }
            // tooltipTop = (parseInt(elementRect.top) - 204) + "px";
            // tooltipBottom = "auto";
            var divWidth = $(".gantt-row-label").width();
            var newDivWidth = parseInt(divWidth)-150;
            newDivWidth = newDivWidth+"px";
            if(!tooltipArrowFromTop){
                $('head').append('<style>.popup_room_class{top:'+tooltipTop+';bottom:'+tooltipBottom+'}.popup_room_class{left:'+newDivWidth+'}.popup_room_class:before{top:auto !important;bottom:11px !important;}.popup_room_class:after{top:auto !important;bottom:10px;}</style>');
            } else {
                $('head').append('<style>.popup_room_class{top:'+tooltipTop+';bottom:'+tooltipBottom+'}.popup_room_class{left:'+newDivWidth+'}.popup_room_class:before{top:11px !important;bottom:auto !important;}.popup_room_class:after{top:10px !important;bottom:auto;}</style>');
            }
        }

        /**
        * @param: Integer isClean
        * @param: Event ev
        * Comment: Mark room as dirty, clean or light clean
        */
        $scope.triggerRoomClean = function(isclean,ev){
            var product_id = vm.product_id;
            var row = vm.row;         
            
			ganttChartServiceNew.setRoomCleanStatus({'isclean':isclean,'product_id':product_id}).then(function(response){
				if(response.success){
					row.model.product_is_clean = response.newstatus;
				}else if(response.errorMsg){
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				}else{
					toastMessage.showSimpleToast('There was some error in saving clean status of this room.','error-toast');
				}
			});

            // create task for room clean/dirty
            vm.task['task_title'] = row.model.name+' needs to be cleaned';
            vm.task['task_product_id'] = product_id;
            vm.task['source'] = 'gantt-chart';
            vm.task['product_is_clean'] = isclean;
            vm.task['customMessage'] = true;
            todoService.addTaskGanttChart(vm.task).then(function(response){
                vm.roomcleanstatus = '';
            });
		}
        
		jQuery(document).bind("click",function(event){jQuery("div.custom-menu").hide()});
        /**
         * Initialize
         */
        function init()
        {
            // Set Gantt Chart height at the init
            calculateHeight();
            if((vm.currentHotelId == 126 || vm.currentHotelId == 122) && vm.pageType != 'rent') {
               $('head').append('<style>md-tab-content{display:unset;}</style>');
            }

            angular.element($window).on('resize', function ()
            {
                $scope.$apply(function ()
                {
					var srceenwidth = $window.innerWidth;
					if(srceenwidth >= 3800){
						var zoomval=3.5;
					}else if(srceenwidth >= 3200 && srceenwidth < 3800){
						var zoomval=3;
					}else if(srceenwidth >= 3000 && srceenwidth < 3200){
						var zoomval=2.5;
					}else if(srceenwidth > 2000 && srceenwidth < 3000){
						var zoomval=2;
					}else if(srceenwidth > 1600 && srceenwidth <= 2000){
						var zoomval=1.5;
					}else{
						var zoomval=1;
					}
					vm.options.zoom = zoomval;
                    calculateHeight();
                });
            });
        }

        /**
         * Max Height Fix
         */
        function calculateHeight()
        {
            vm.options.maxHeight = $document.find('#chart-container').offsetHeight;
        }

        /**
         * Add New Row
         */
        function addDialog(ev)
        {
            $mdDialog.show({
                controller         : 'GanttChartAddEditDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/dashboards/gantt-chart/dialogs/add-edit/add-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: {
                        chartData : vm.data,
                        dialogType: 'add'
                    }
                }
            });
        }
        /**
         * Add New Reservation
         */
        function addReservation(ev,roomname,location)
        {

            // alert('Open pop');
            /*Make changes for boat and room */
			/*
			 * Check avaialable dates
			*/
            if (ev.row.model.productId == undefined || ev.row.model.productId == null) {
                var roomBoat = vm.roomTypes == 'boat' ? 'slip' : 'room';                
                toastMessage.showSimpleToast("Please create reservation in any specific "+roomBoat+".",'error-toast');
                vm.isloading = false;
                /*vm.calculateSelectedIndex(ev.row.model.id, 'parent');
                $timeout(function() {
                    vm.reloadParentData(ev.row.model.id);
                }, 100);*/
                return false;
            }
            var product_id = ev.row.model.productId;           

            var room_stay_from = moment(ev.model.from._d).format('YYYY-MM-DD');
			var room_stay_to = moment(ev.model.to._d).format('YYYY-MM-DD');
			var isSameDayDrag = (room_stay_from == room_stay_to);
			var isDayReservationHotel = typeof $rootScope.isDailyRentalsAvailable === 'function'
				? $rootScope.isDailyRentalsAvailable()
				: false;
			if(isSameDayDrag && !isDayReservationHotel && ev.model.type_of_reservation !== 'day_reservation'){
				var targetRow = ev.row;
				targetRow.removeTask(ev.model.productId, false, true);
				toastMessage.showSimpleToast('Check-in and check-out date cannot be same.','error-toast');
				vm.isloading = false;
                vm.reloadDataConditionally(product_id);
				return false;
			}
			if(ev.model.confirmation_number){
				var confirmation_number = ev.model.confirmation_number;
			}else{
				var confirmation_number = '';
			}
			/* get policy wise rates*/
			var availType = ev.model.type_of_reservation || '';
			if(isSameDayDrag && isDayReservationHotel && !availType){
				availType = 'day_reservation';
			}
			
			ganttChartServiceNew.checkAvailabilityForDates(
                {
                    'product_id'           :product_id,
                    'room_stay_from'        :room_stay_from,
                    'room_stay_to'          :room_stay_to,
                    'confirmation_number'   :confirmation_number,
                    'type_of_reservation'   : availType,
                    'called_from'           :'BACK_END',
                    'requestFor'            : vm.pageType

                }).then(function(response){
				vm.isloading = false;
                var print = '';
                var dialogTitle = '';
				if (response.success) {
                    if((response.mls_days && response.mls_days > 0) || (response.stop_sell && response.stop_sell=='yes')){
                        if(response.mls_days){
                            print =  ' MLS for '+response.mls_days+' nights';
                            dialogTitle =  'Minimum length of stay';
                        }
                        else{
                             print = ' Stop Sell';
                             dialogTitle = 'Stop Sell';
                         }
                        $mdDialog.show({
                            controller: 'confirmPageController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
                            parent: angular.element(document.body),
                            targetEvent: event,
                            clickOutsideToClose:true ,
                            locals: {
                                title: dialogTitle,
                                htmlContent:'Selected dates have'+print+'. Do you want to continue?',
                                btnTxt: 'Continue',
                                cancelTxt: 'Cancel',
                                localData: { invertButtonColors: true }
                            }                
                        }).then(function(response) {                           
                            if(typeof response.answer != 'undefined' && response.answer == 'update'){
                                vm.addResvPopup(vm.data, ev, roomname, location, product_id);
                            }
                        }, function() {
                            vm.reloadDataConditionally(product_id);
                        });
                        // End for New Pop Up
					} else {
                        vm.data.pageType = vm.pageType;
                        vm.addResvPopup(vm.data, ev, roomname, location, product_id);
					}					
				} else if (response.canOverride && (response.errorTitle === 'Late checkout' || response.errorTitle === 'Early check-in')) {
					// Soft conflict: allow staff to create day reservation after confirm (like Do not move)
					$mdDialog.show({
						controller: 'confirmPageController',
						controllerAs: 'vm',
						templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
						parent: angular.element(document.body),
						targetEvent: event,
						clickOutsideToClose: true,
						locals: {
							title: response.errorTitle || 'Confirm Create',
							htmlContent: response.errorMsg || 'Are you sure you want to create a day reservation on this room?',
							btnTxt: 'Yes, Create',
							cancelTxt: 'Cancel',
							localData: { invertButtonColors: true }
						}
					}).then(function(confirmResponse) {
						if (typeof confirmResponse.answer != 'undefined' && confirmResponse.answer == 'update') {
							vm.addResvPopup(vm.data, ev, roomname, location, product_id, true);
						} else {
							vm.reloadDataConditionally(product_id);
						}
					}, function() {
						vm.reloadDataConditionally(product_id);
					});
				} else {
                    vm.reloadDataConditionally(product_id);                 
					toastMessage.showSimpleToast(response.errorMsg, 'error-toast', false, response.errorTitle || null);
				}
			});
        }

        vm.addResvPopup = function(data, ev, roomname, location, productId, ignoreEarlyLate) {
			var room_stay_from = moment(ev.model.from._d).format('YYYY-MM-DD');
			var room_stay_to = moment(ev.model.to._d).format('YYYY-MM-DD');
			var preselectDayReservation = (typeof $rootScope.isDailyRentalsAvailable === 'function'
				? $rootScope.isDailyRentalsAvailable()
				: false) && (room_stay_from === room_stay_to);
            $mdDialog.show({
                controller         : 'optionCreatePlaceGantt',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/dashboards/gantt-chart/dialogs/option-place-on-gantt.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                preserveScope       : true,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: {
                        chartData : data,
                        thisnewcreateData : ev,
                        thisroomname : roomname,
                        policydetails : vm.policyData,
                        locationres: location,
                        requestFrom:vm.pageType,
                        preselectDayReservation: preselectDayReservation,
                        ignoreEarlyLate: !!ignoreEarlyLate
                    },
                    parentScope: $scope,
                    mode_of_call: 'add'
                },
                onRemoving: function (event) {
                    if ($scope.reloaddashboard){
                        vm.reloadDataConditionally(productId);                          
                    }
                }
            });
        };
        /**
         * Edit Dialog
         */
		function getOrderInfo(formData,rowChange)
        {
            if(vm.requestgoing) return;
            vm.storeLastEvent = vm.lastTaskEvent;
            var product_id = formData.row.model.productId;
            
            vm.originalProductId;
            if (vm.lastTaskEvent == 'rowChange') {
                vm.originalProductId = formData.model.productId
            }

			if(rowChange && formData.model.classes.indexOf('do-not-move-mark') !== -1){
                var html='This reservation is tagged as <b>"Do not move"</b>. Are you sure you want to move it?';
                $mdDialog.show({
                    controller: 'confirmPageController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose:true ,
                    locals: {
                        title: 'Confirm Move',
                        htmlContent:html,
                        btnTxt: 'Yes, Move',
                        cancelTxt: 'Cancel',
                        localData: { invertButtonColors: true }
                    }                
                }).then(function(response) {
                    if(typeof response.answer != 'undefined' && response.answer == 'update'){
                        vm.getOrderInfo(formData, false);
                   }
                }, function() {
                    vm.lastTaskEvent = null;
                    if (typeof product_id != 'undefined' && product_id != 0) {
                        vm.reloadDataConditionally(product_id);
                    }
                    vm.reloadDataConditionally(vm.originalProductId, 'previous');
                });
                return;
			} else if(formData.model.type_of_reservation == 'bundleblock') {
                var html='Automatic blocked ranges cannot be modified.';
                $mdDialog.show({
                    controller: 'confirmPageController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose:true ,
                    locals: {
                        title: 'Automatic blocked range',
                        htmlContent:html,
                        btnTxt: 'OK',
                        cancelTxt: 'Cancel',
                        localData: {}
                    }                
                }).then(function(response) {
                    if(typeof response.answer != 'undefined' && response.answer == 'update'){
                        $mdDialog.hide();
                    }
                }, function() {});
                if (typeof product_id != 'undefined' && product_id != 0) {
                   vm.reloadDataConditionally(product_id);
                } 
                /*else {
                    vm.calculateSelectedIndex(formData.row.model.id, 'parent');
                    $timeout(function() {
                        vm.reloadParentData(formData.row.model.id);
                    }, 100)
                }*/
                
                if (vm.storeLastEvent == 'rowChange') {
                    $timeout(function(){
                        vm.reloadDataConditionally(vm.originalProductId, 'previous');
                    }, 500);
                }
                return;
            }
			var product_name = formData.row.model.prodName != undefined ? formData.row.model.prodName : formData.row.model.name;
			var room_stay_from = moment(formData.model.from._d).format('MM/DD/YYYY');
			var room_stay_to = moment(formData.model.to._d).format('MM/DD/YYYY');
			var confirmation_number = formData.model.confirmation_number;
			// Overnight stays cannot be 0 nights; same-day is only valid for day_reservation.
			if (room_stay_from == room_stay_to && formData.model.type_of_reservation !== 'day_reservation') {
				vm.requestgoing = true;
				toastMessage.showSimpleToast('Check-in and check-out date cannot be same.','error-toast');
				vm.lastTaskEvent = '';
				vm.isloading = false;
				if (typeof product_id != 'undefined' && product_id != 0) {
					vm.reloadDataConditionally(product_id);
				}
				if (vm.storeLastEvent == 'rowChange') {
					$timeout(function() {
						vm.reloadDataConditionally(vm.originalProductId, 'previous');
					}, 500);
				}
				$timeout(function() {
					vm.requestgoing = false;
				});
				return;
			}
			vm.currenttask = formData;               
			var rowId = vm.currenttask.row.$scope.$index;
			var taskId = vm.currenttask.$scope.$index;
			vm.isloading = true;
			vm.requestgoing = true;
			ganttChartServiceNew.getModifiedOrder({'product_id':product_id,'room_stay_from':room_stay_from,'room_stay_to':room_stay_to,'confirmation_number':confirmation_number,'type_of_reservation':formData.model.type_of_reservation || ''}).then(function(response){
                vm.lastTaskEvent = '';
				vm.isloading = false;
				vm.requestgoing = false;
				if(response.success ){
					vm.orderModifying = {
						'new_product_id':product_id,
                        'old_product_id':response.order_info[0].product_id,
						'new_product_name':product_name,
						'new_room_stay_from':room_stay_from,
						'new_room_stay_to':room_stay_to,
						'old_product_name':response.order_info[0].product_name,
						'old_room_stay_from':moment(response.order_info[0].room_stay_from).format('MM/DD/YYYY'),
						'old_room_stay_to':moment(response.order_info[0].room_stay_to).format('MM/DD/YYYY'),
						'type_of_reservation':formData.model.type_of_reservation,
						'confirmation_number':confirmation_number
					}
					confirmEdit(null);
				} else if (response.canOverride && (response.errorTitle === 'Late checkout' || response.errorTitle === 'Early check-in')) {
					var moveConflictHtml = (response.errorMsg || '')
						.replace('create a day reservation on this room?', 'move this day reservation here?')
						|| 'Are you sure you want to move this day reservation?';
					$mdDialog.show({
						controller: 'confirmPageController',
						controllerAs: 'vm',
						templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
						parent: angular.element(document.body),
						targetEvent: event,
						clickOutsideToClose: true,
						locals: {
							title: response.errorTitle || 'Confirm Move',
							htmlContent: moveConflictHtml,
							btnTxt: 'Yes, Move',
							cancelTxt: 'Cancel',
							localData: { invertButtonColors: true }
						}
					}).then(function(confirmResponse) {
						if (typeof confirmResponse.answer != 'undefined' && confirmResponse.answer == 'update') {
							ganttChartServiceNew.getModifiedOrder({
								'product_id': product_id,
								'room_stay_from': room_stay_from,
								'room_stay_to': room_stay_to,
								'confirmation_number': confirmation_number,
								'type_of_reservation': formData.model.type_of_reservation || '',
								'ignore_early_late': true
							}).then(function(retryResponse) {
								if (retryResponse.success) {
									vm.orderModifying = {
										'new_product_id': product_id,
										'old_product_id': retryResponse.order_info[0].product_id,
										'new_product_name': product_name,
										'new_room_stay_from': room_stay_from,
										'new_room_stay_to': room_stay_to,
										'old_product_name': retryResponse.order_info[0].product_name,
										'old_room_stay_from': moment(retryResponse.order_info[0].room_stay_from).format('MM/DD/YYYY'),
										'old_room_stay_to': moment(retryResponse.order_info[0].room_stay_to).format('MM/DD/YYYY'),
										'type_of_reservation': formData.model.type_of_reservation,
										'confirmation_number': confirmation_number
									};
									confirmEdit(null);
								} else {
									vm.orderModifying = {};
									vm.commit = false;
									toastMessage.showSimpleToast(retryResponse.errorMsg, 'error-toast', false, retryResponse.errorTitle || null);
									if (typeof product_id != 'undefined' && product_id != 0) {
										vm.reloadDataConditionally(product_id);
									}
									if (vm.storeLastEvent == 'rowChange') {
										$timeout(function() {
											vm.reloadDataConditionally(vm.originalProductId, 'previous');
										}, 500);
									}
								}
							});
						} else {
							vm.orderModifying = {};
							vm.commit = false;
							if (typeof product_id != 'undefined' && product_id != 0) {
								vm.reloadDataConditionally(product_id);
							}
							if (vm.storeLastEvent == 'rowChange') {
								$timeout(function() {
									vm.reloadDataConditionally(vm.originalProductId, 'previous');
								}, 500);
							}
						}
					}, function() {
						vm.orderModifying = {};
						vm.commit = false;
						if (typeof product_id != 'undefined' && product_id != 0) {
							vm.reloadDataConditionally(product_id);
						}
						if (vm.storeLastEvent == 'rowChange') {
							$timeout(function() {
								vm.reloadDataConditionally(vm.originalProductId, 'previous');
							}, 500);
						}
					});
				} else {
                    vm.orderModifying = {};
					vm.commit = false;
					toastMessage.showSimpleToast(response.errorMsg, 'error-toast', false, response.errorTitle || null);
                    if (typeof product_id != 'undefined' && product_id != 0) {
					   vm.reloadDataConditionally(product_id);
                    } 
                    /*else {
                        vm.calculateSelectedIndex(formData.row.model.id, 'parent');
                        $timeout(function() {
                            vm.reloadParentData(formData.row.model.id);
                        }, 100)
                    }*/

                    if (vm.storeLastEvent == 'rowChange') {
                        $timeout(function(){
                            vm.reloadDataConditionally(vm.originalProductId, 'previous');
                        }, 500);
                    }
                    return;
				}
			});
        }
        function confirmEdit(ev){
			vm.commit = false;
            if(vm.orderModifying.type_of_reservation == 'reservation' || vm.orderModifying.type_of_reservation == 'boat'|| vm.orderModifying.type_of_reservation == 'rent' || vm.orderModifying.type_of_reservation == 'day_reservation'){
				$mdDialog.show({
					controller         : 'GanttChartEditDialogController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/apps/dashboards/modified-gantt-chart/dialogs/edit/edit-dialog.html',
					parent             : angular.element($document.body),
					targetEvent        : ev,
					clickOutsideToClose: false,
					locals             : {
						dialogData: {
							formData  	: vm.orderModifying,
							currentTask : vm.currenttask
						}
					}
				});
			}else{
				var html = "";
				if(vm.orderModifying.type_of_reservation == 'hold'){
					html += "<h2 class='title mt-0'>You are about to change hold dates</h2>";
				} else if(vm.orderModifying.type_of_reservation == 'block') {
					html += "<h2 class='title mt-0'>You are about to change blocked dates</h2>";
				}
				
				html += "<div class='editHoldBlock'>\
							<div class='editHoldBlockFrom editholdComn'><span class='fromTitleHB'>From:</span><span class='fromContent'><b class='HBProdName'>"+vm.orderModifying.old_product_name+":</b><p>\
							"+vm.orderModifying.old_room_stay_from+" <b><em>to</em></b> "+vm.orderModifying.old_room_stay_to + "</p></span></div>\
							<div class='editHoldBlockTo editholdComn'><span class='fromTitleHB'>To:</span>\
							<span class='fromContent'><b class='HBProdName'>"+vm.orderModifying.new_product_name+":</b><p>\
							"+vm.orderModifying.new_room_stay_from+" <b><em>to</em></b> "+vm.orderModifying.new_room_stay_to+"</p></span></div></div>";
					
                $mdDialog.show({
                    controller: 'confirmPageController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose:true ,
                    locals: {
                        title: 'Modify dates',
                        htmlContent:html,
                        btnTxt: 'Continue',
                        cancelTxt: 'Cancel',
                        localData: {}
                    }                
                }).then(function(response) {
                    if(typeof response.answer != 'undefined' && response.answer == 'update'){
                        saveReservation();
                    }
                }, function() {
                    vm.reloadDataConditionally(vm.orderModifying.new_product_id);
                    if (vm.storeLastEvent == 'rowChange') {
                        $timeout(function(){
                            vm.reloadDataConditionally(vm.originalProductId, 'previous');
                        }, 500);
                    }
                    vm.currenttask = {};
                });
			}
		}
		
        function saveReservation() {
            vm.isloading = true;
			var data = {'product_id':vm.orderModifying.new_product_id,'product_name':vm.orderModifying.new_product_name,'room_stay_from':vm.orderModifying.new_room_stay_from,'room_stay_to':vm.orderModifying.new_room_stay_to,'confirmation_number':vm.orderModifying.confirmation_number,'type_of_reservation':vm.orderModifying.type_of_reservation};
			ganttChartServiceNew.saveModifiedOrder(data).then(function(response){
				vm.isloading = false;
				if(response.success){
					vm.reloadDataConditionally(vm.orderModifying.new_product_id);
                    if (vm.storeLastEvent == 'rowChange') {
                        $timeout(function(){
                            vm.reloadDataConditionally(vm.originalProductId, 'previous');
                        }, 500);
                    }
				}else{
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				}
				vm.currenttask = {};
			});
		}
		
		$scope.$on('done_modification', function(event, data) {
			vm.reloadDataConditionally(data.productId);
            if (vm.storeLastEvent == 'rowChange') {
                $timeout(function(){
                    vm.reloadDataConditionally(vm.originalProductId, 'previous');
                }, 500);
            }
			vm.currenttask = {};
		});
        
        function changeStatusAfterPayment(idx,confirmation_number,oldStatus,newStatus,sendEmail){
			vm.changingStatus = true;
			vm.changeStatusData = {newStatus:newStatus,oldStatus:oldStatus,sendEmail:sendEmail};
			vm.room_stay_status = oldStatus;
			$mdDialog.hide();
			$state.go("app.e-commerce.orders.detail",{id:vm.currenttask.model.reservation_id,confirmation_number:vm.currenttask.model.confirmation_number,changeStatusData:vm.changeStatusData});
			
		}

        function viewOrder(reservation_id,confirmation_number){
            var url;
            if(vm.pageType == 'room'){
                url = $state.href("app.e-commerce.orders.detail",{id:reservation_id,confirmation_number:confirmation_number});
            } else if (vm.pageType == 'rent'){
                url = $state.href("app.e-commerce.rentOrders.detail",{id:reservation_id,confirmation_number:confirmation_number});
            } else {
    			url = $state.href("app.e-commerce.boatOrders.detail",{id:reservation_id,confirmation_number:confirmation_number});
            }
            $window.open(url, '_blank');
		}

		function addcommentinorder(event){
            $mdDialog.show({
				controller         : 'addCommentRes',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/apps/dashboards/gantt-chart/dialogs/add-comment.html',
				parent             : angular.element($document.body),
				targetEvent        : event,
				clickOutsideToClose: true,
				locals             : {
					dialogData: {
						chartData : vm.data,
						thisnewcreateData : vm.currenttask
					},
					parentScope: $scope
				},
				onRemoving: function (event) {
					if($scope.comment_reload && vm.currenttask.model.type_of_reservation != 'reservation' && vm.currenttask.model.type_of_reservation != 'boat' && vm.currenttask.model.type_of_reservation != 'rent'){
						vm.reloadDataConditionally(vm.currenttask.model.productId);
					}
				}
			});
		}

        /**
         * Mark Active reservation as Waiting for Room from gantt context menu.
         */
        vm.setWaitingForRoomFromGantt = function (event) {
            if (!vm.currenttask || !vm.currenttask.model) {
                return;
            }

            var taskModel = vm.currenttask.model;
            jQuery('.custom-mnu-container').html('');

            eCommerceService.confirmAndSetWaitingForRoom(taskModel, event, {
                checkColor: true,
                useGanttDialog: true,
                applyGanttFields: true,
                onRequestStart: function () {
                    vm.isloading = true;
                },
                onRequestEnd: function () {
                    vm.isloading = false;
                }
            });
        };

        /**
        * @param: Event ev
        * @param: String newstatus
        * @param: Float RemainAmount
        * Comment: change reservation status for resv
        */
		$scope.statusDialog = function(ev, newstatus, RemainAmount) {
			var confirmation_number = vm.currenttask.model.confirmation_number;
            var resvDetail = vm.currenttask.model;
            vm.isloading = true;
            if (typeof RemainAmount == 'undefined') {
                ganttChartServiceNew.fetchRemainingAmount(confirmation_number)
                    .then(function(res) {
                        if (res.result !== undefined && Object.keys(res.result).length > 0) {
                            RemainAmount = parseFloat(res.result.total_remaining_amount);
                            vm.changeResvStatus(resvDetail, newstatus, RemainAmount);
                        } else {
                            vm.isloading = false;
                        }
                });
            } else {
               vm.changeResvStatus(resvDetail, newstatus, RemainAmount);
            }                       
        }

        function getAllowCheckoutWithPendingDuesSetting() {
            var data = {
                hotel_id: vm.currentHotelId,
                attribute_code: 'allowCheckoutWithPendingDues',
                setting_type: 'general'
            };

            return eCommerceService.getGeneralSettings(data).then(function(payload) {
                var settings = payload && payload.settings ? payload.settings : payload || {};
                var hotelSettings = settings[vm.currentHotelId] || settings[String(vm.currentHotelId)];
                var parentSettings = settings[1] || settings['1'];
                var settingValue = readSettingValue(hotelSettings);

                if (isEmptyValue(settingValue)) {
                    settingValue = readSettingValue(parentSettings);
                }

                return toBooleanOrDefault(settingValue, true);
            }, function() {
                return true;
            });

            function readSettingValue(settingsObj) {
                if (!settingsObj || typeof settingsObj !== 'object') {
                    return undefined;
                }
                return settingsObj.allowCheckoutWithPendingDues;
            }

            function isEmptyValue(value) {
                return typeof value === 'undefined' || value === null || value === '';
            }

            function toBooleanOrDefault(value, defaultValue) {
                if (value === true || value === 1 || value === '1') {
                    return true;
                }
                if (value === false || value === 0 || value === '0') {
                    return false;
                }
                return defaultValue;
            }
        }

        function showPendingCheckoutBlockedPopup() {
            $mdDialog.show({
                controller: 'confirmController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    title: 'Outstanding balance',
                    htmlContent: 'This reservation still has an unpaid balance. Collect or adjust the remaining amount before you can check out.',
                    cancelBtn: 'none',
                    OkBtn: 'OK'
                }
            });
        }

        /**
        * param: Object resvDetail
        * param: String newstatus
        * param: Float RemainAmount
        * return: Boolean
        * Comment: process final step of status change of reservation
        */
        vm.changeResvStatus = function(resvDetail, newstatus, RemainAmount) {
            var isCheckoutStatus = String(newstatus || '').toLowerCase() === 'checked-out';
            var pendingAmount = parseFloat(RemainAmount);

            if (isCheckoutStatus) {
                ganttChartServiceNew.blockCheckoutIfBorrowedItems(resvDetail).then(function(result) {
                    if (result && result.blocked) {
                        vm.isloading = false;
                        return;
                    }
                    continueAfterBorrowedItemsCheck();
                });
                return;
            }

            continueAfterBorrowedItemsCheck();

            function continueAfterBorrowedItemsCheck() {
            if (isCheckoutStatus && !isNaN(pendingAmount) && pendingAmount > 0) {
                getAllowCheckoutWithPendingDuesSetting().then(function(allowCheckout) {
                    if (!allowCheckout) {
                        vm.isloading = false;
                        showPendingCheckoutBlockedPopup();
                        return;
                    }

                    processStatusChange();
                });
                return;
            }

            processStatusChange();
            }

            function processStatusChange() {
            ganttChartServiceNew.processStatusRequest(resvDetail, newstatus, RemainAmount, 'ganttChart').then(function(result) {
                vm.isloading = false;
                if (result.hitRequest) {
                    vm.reloadDataConditionally(resvDetail.productId);
                }
            });
            }
        };

		function isScrolledIntoView(elem)
		{
            var docViewTop = $(window).scrollTop();
			var docViewBottom = docViewTop + $(window).height();
			var elemTop = $(elem).offset().top;
			var elemBottom = elemTop + $(elem).height();
			return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
		}
        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Search
         * @param sidenavId
         */
        function search(option, keyword)
        {
            if ( option === 'rows' )
            {
                vm.options.filterRow = keyword;
            }
            else if ( option === 'tasks' )
            {
                vm.options.filterTask = keyword;
            }
        }

        /**
         * Sort Mode
         * @param mode
         */
        function setSortMode(mode)
        {
            vm.options.sortMode = mode;

            if ( angular.isUndefined(mode) )
            {
                vm.options.rowSortable = true;
            }
            else
            {
                vm.options.rowSortable = false;
            }
        }

        /**
         * Side Mode
         */
        $scope.$watch('vm.options.sideMode', function (newValue, oldValue)
        {
            if ( newValue !== oldValue )
            {
                vm.api.side.setWidth(undefined);

                $timeout(function ()
                {
                    vm.api.columns.refresh();
                });
            }
        });

        function canAutoWidth(scale)
        {
            if ( scale.match(/.*?hour.*?/) || scale.match(/.*?minute.*?/) )
            {
                return false;
            }

            return true;
        }

        function getColumnWidth(widthEnabled, scale, zoom)
        {
            if ( !widthEnabled && vm.canAutoWidth(scale) )
            {
                return undefined;
            }

            if ( scale.match(/.*?week.*?/) )
            {
                return 150 * zoom;
            }

            if ( scale.match(/.*?month.*?/) )
            {
                return 300 * zoom;
            }

            if ( scale.match(/.*?quarter.*?/) )
            {
                return 500 * zoom;
            }

            if ( scale.match(/.*?year.*?/) )
            {
                return 800 * zoom;
            }

            return 40 * zoom;
        }
        $rootScope.loadFromScroll = function(from, to){
			vm.scrollFrom = from;
			vm.scrollTo = to;
            load('scroll');
		}

        vm.navigateDates = function(direction) {
            if (vm.isDataLoading) return;   
            var currentDate = moment(vm.options.fromDate);
            var daysToAdd = 7; // or however many days you want to navigate
            
            if (direction === 'prev') {
                vm.options.fromDate = currentDate.subtract(daysToAdd, 'days').toDate();
            } else {
                vm.options.fromDate = currentDate.add(daysToAdd, 'days').toDate();
            }
            
            // Trigger the data load with the new date
            vm.load('changeDate');
            vm.scrollToStart();
        };
        vm.scrollToStart = function() {
                if (vm.api && vm.api.scroll) {
                $timeout(function() {
                    vm.api.scroll.to(0, 0); // x, y coordinates
                }, 100);
            }
        };

        jQuery(document).on("click",".gantt-column-header",function(){
            var clicked_date=jQuery(this).data('room')
            if (vm.allRoomHotels.includes(vm.currentHotelId)) {
                load('changeDate',clicked_date);
            }
        });
        vm.updateAdjustedFromDate = function() {
            if (!vm.options.fromDate) {
                vm.adjustedFromDate = new Date();
            } else {
                vm.adjustedFromDate = moment(vm.options.fromDate).subtract(2, 'days').toDate();
            }
        };

        vm.updateAdjustedFromDate();

        $scope.$watch('vm.options.fromDate', function(newVal) {
            if (newVal) {
                vm.updateAdjustedFromDate();
            }
            updateCurrentDateLine();
        });
 
        $scope.$watch('vm.options.toDate', function() {
            updateCurrentDateLine();
        });
 
        function updateCurrentDateLine() {
            var today = moment(vm.options.currentDateValue || new Date());
            var inRange;
 
            if (vm.api && vm.api.columns && angular.isFunction(vm.api.columns.getDateRange)) {
                var range = vm.api.columns.getDateRange(true) || vm.api.columns.getDateRange(false);
                if (range && range[0] && range[1]) {
                    inRange = !today.isBefore(range[0]) && !today.isAfter(range[1]);
                }
            }
 
            if (inRange === undefined && vm.options.fromDate && vm.options.toDate) {
                inRange = today.isSameOrAfter(moment(vm.options.fromDate).startOf('day')) &&
                    today.isSameOrBefore(moment(vm.options.toDate).endOf('day'));
            }
 
            if (inRange === undefined || vm.isCurrentDateVisible === inRange) {
                return;
            }
 
            var applyVisibility = function () {
                vm.isCurrentDateVisible = inRange;
            };
 
            if ($scope.$root.$$phase) {
                applyVisibility();
            } else {
                $scope.$apply(applyVisibility);
            }
        }
 
        // Reload data action
        function load(location,clicked_date)
        {
            var reqObject = {};
            vm.isloading = true;
            if (location == 'changeDate') {
                $rootScope.customoption = 'no';
                var from = moment(vm.options.fromDate).subtract(2, 'days');
                var to = moment(from)
                    .add(parseInt(vm.number_of_days), 'days');

                vm.options.fromDate = from.toDate();
                vm.options.toDate = to.toDate();

                reqObject = {
                    start:from.format('YYYY/MM/DD'),
                    end:to.format('YYYY/MM/DD'),
                    clicked_date: clicked_date, 
                    position: 'changeDate'            
                };
                vm.getGanttReservations(reqObject, '');
            }
        else if (location=='scroll'){
                var from = moment(vm.scrollFrom).format('YYYY/MM/DD');
                var to = moment(vm.scrollTo).format('YYYY/MM/DD');
                
                vm.options.toDate = to;
                vm.options.fromDate = from;
                reqObject = {
                    start: from,
                    end: to,
                    position: 'scroll'                  
                };
                vm.getGanttReservations(reqObject, '');
            } else {
                var hotel_id = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
                if (vm.pageType !== undefined && vm.pageType == 'boat') {
                    if(typeof $sessionStorage['boat'] != 'undefined' && $sessionStorage['boat'].hasOwnProperty('gantt_chart_from') && $sessionStorage['boat']['gantt_chart_from'] != '' && $sessionStorage['boat'].hasOwnProperty('gantt_chart_to') && $sessionStorage['boat']['gantt_chart_to'] != '' ){
                        vm.options.toDate = angular.copy($sessionStorage['boat']['gantt_chart_to']);
                        vm.options.fromDate = angular.copy($sessionStorage['boat']['gantt_chart_from']);
                    }
                } else {
                    if(typeof $sessionStorage[hotel_id] != 'undefined' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_from') && $sessionStorage[hotel_id]['gantt_chart_from'] != '' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_to') && $sessionStorage[hotel_id]['gantt_chart_to'] != '' ){
                        vm.options.toDate = angular.copy($sessionStorage[hotel_id]['gantt_chart_to']);
                        vm.options.fromDate = angular.copy($sessionStorage[hotel_id]['gantt_chart_from']);
                    }
                }

                var data = [];
                for(var i=0;i<(ganttData.roomsDetail).length;i++){
                    data.push(JSON.parse((ganttData.roomsDetail[i])));
                }
                vm.storeRoomsRecord = ganttData.storeRooms !== undefined ? ganttData.storeRooms : {};
                vm.scopeDataValue = $scope.data = data; 
                vm.storeJsonData = JSON.stringify(vm.scopeDataValue);
                vm.parentRoomTypes = ganttData.parentRoomTypes != undefined ? ganttData.parentRoomTypes : [];
                vm.parentRoomIndexes = ganttData.parentRoomIndexes != undefined ? ganttData.parentRoomIndexes : [];
                vm.roomsData = ganttData.newHtml;
                vm.walkArray = ganttData.walkArray != undefined ? ganttData.walkArray : [];
                vm.occupancyArray = ganttData.occupancyArray != undefined ? ganttData.occupancyArray : [];
                setTimeout(function() {
                    vm.data = data;
                    vm.occupancyData = ganttData.occupancyData;
                    if (vm.checkGroupOrSingleRooms() == 'single') {
                        $timeout(function() {
                            vm.loadRemainingInfo();
                        }, 50);
                    }

                    if (vm.allRoomHotels.includes(vm.currentHotelId) || (vm.currentHotelId == '126' && (vm.pageType == 'rent' || vm.pageType == 'boat')) || vm.currentHotelId == '129') {
                        get_room_percent_this(vm.occupancyData);
                    }
                }, 50);
                vm.isloading = false;
            }
            // Fix for Angular-gantt-chart issue
            $animate.enabled(true);
            $animate.enabled($document.find('#gantt'), false);
        }

        /**
        * Comment: Load task or reservation in room after some time delay
        */
        vm.loadRemainingInfo = function() {
            var count = 0;
            if (vm.roomsData !== undefined && Object.keys(vm.roomsData).length > 0) {
                var tempkey;
                for (var i = 0; i < vm.data.length; i++) {
                    angular.forEach(vm.roomsData, function(value, key) {
                        if (parseInt(key) === parseInt(vm.data[i].productId)) {
                           vm.data[i].tasks = value;
                            return;
                        }
                    });
                }
                $scope.$apply(function() {
                    $scope.data = vm.data;
                });
            }
        }

        /**
        * @param: Object data
        * @param: String parm
        * Comment: Get the reservations for tape chart
        */
        vm.getGanttReservations = function(data, parm) {
            if (vm.checkGroupOrSingleRooms() == 'group') {
                vm.removeAllTasks();
            }
            var hotel_id = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
            if (parm != 'tabChange') {
                if (vm.pageType !== undefined && vm.pageType == 'boat') {
                    $sessionStorage['boat']= {};
                    $sessionStorage['boat']['gantt_chart_from'] = data.start;
                    $sessionStorage['boat']['gantt_chart_to'] = data.end;
                } else {
                    $sessionStorage[hotel_id] = {};
                    $sessionStorage[hotel_id]['gantt_chart_from'] = data.start;
                    $sessionStorage[hotel_id]['gantt_chart_to'] = data.end;
                }
            }

            data.roomTypes = vm.roomTypes;
            data.requestFor = vm.pageType;
            data.newChart = true;
            data.boatDispType = vm.boatDispType;
            data.rentDispType = vm.rentDispType;
            data.hotelId = vm.currentHotelId;
            var roomsExpanded = [];
            if (typeof $localStorage[vm.currentHotelId+'_'+vm.roomTypes+'_expanded'] != 'undefined') {
                angular.forEach($localStorage[vm.currentHotelId+'_'+vm.roomTypes+'_expanded'], function(value, key) {
                    roomsExpanded.push(value);
                });
            } 
            data.roomsExpanded = roomsExpanded;

            vm.position = data.position;
            
            if (vm.checkGroupOrSingleRooms() == 'single') {
                ganttChartServiceNew.getGanttData(data).then(function(response) {
                    
                    vm.isloading = false;
                    vm.enableReload = true;
                    
                    if(response.success){
                        vm.parentRoomTypes = response.parentRoomTypes != undefined ? response.parentRoomTypes : [];

                        var data = [];
                        for(var i=0;i<(response.roomsDetail).length;i++){
                            data.push(JSON.parse((response.roomsDetail)[i]));
                        }
                        vm.storeRoomsRecord = response.storeRooms !== undefined ? response.storeRooms : {};
                        vm.data = data;                  
                        vm.roomsData = response.newHtml;
                        vm.occupancyData = response.occupancyData;
                        vm.parentRoomIndexes = ganttData.parentRoomIndexes != undefined ? ganttData.parentRoomIndexes : [];
                        if (vm.checkGroupOrSingleRooms() == 'single') {
                            $timeout(function() {
                                vm.loadRemainingInfo();
                            }, 50);                        
                        }

                        if (vm.allRoomHotels.includes(vm.currentHotelId) || (vm.currentHotelId == '126' && (vm.pageType == 'rent' || vm.pageType == 'boat')) || vm.currentHotelId == '129') {
                            get_room_percent_this(vm.occupancyData);
                        }
                    } else if (response.errorMsg) {
                        toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                    } else {
                        toastMessage.showSimpleToast('There was some error in fetching prices for selected range.','error-toast');
                    }

                    $timeout(function () {
                        $rootScope.customoption = 'yes';
                    },500);
                });
            } else {
                $timeout(function() {
                    vm.getTaskOnChange();
                    vm.getWalkRoomsData();
                    vm.getOccupancyData();
                    $rootScope.customoption = 'yes';
                    vm.isloading = false;
                    vm.enableReload = true;                     
                }, 500);
            }
        };

        /**
         * Reload Data
         */
        function reload()
        {
            vm.commit = false;
            vm.enableReload = false;
            vm.isloading = true;
            $rootScope.customoption = 'no';

            var from = new Date();
            var to = moment(moment(moment(from).format('YYYY/MM/DD')).add(parseInt(vm.number_of_days), 'days')).format('YYYY/MM/DD');
            from = moment(moment(from).subtract(2, 'days')).format('YYYY/MM/DD');
            vm.options.toDate = to;
            vm.options.fromDate = from;
            
            var reqObject = {
                start: from,
                end: to,
                position: 'reload',                  
            };
            vm.getGanttReservations(reqObject, '');
        }
        
        function convertToRes(type,event) {
			if (type == 'hold') {
				goDirectCreateResFromHold();
				return;
			}
			vm.isloading = true;
            var prodName = vm.currenttask.row.model.prodName != undefined ? vm.currenttask.row.model.prodName : vm.currenttask.row.model.name;
			addReservation(vm.currenttask, prodName, type);
		}

		function goDirectCreateResFromHold() {
			var task = vm.currenttask;
			if (!task || !task.model || !task.row) {
				return;
			}
			var productId = task.row.model.productId !== undefined ? task.row.model.productId : task.row.model.id;
			var fromDate = task.model.from && task.model.from._d ? task.model.from._d : task.model.from;
			var toDate = task.model.to && task.model.to._d ? task.model.to._d : task.model.to;
			var confirmation = task.model.confirmation_number;
			if (!confirmation || !productId) {
				toastMessage.showSimpleToast('Unable to load hold details.','error-toast');
				return;
			}
			vm.isloading = true;
			ganttChartServiceNew.getGanttTooltipData({
				confirmation_number: confirmation,
				include_hold_pricing: true
			}).then(function(response) {
				var tip = (response && response.success && response.tooltip_data) ? response.tooltip_data : {};
				var policyId = (tip.hold_pricing && tip.hold_pricing.policy_key) ? tip.hold_pricing.policy_key : '2';
				var selectedRoom = {};
				selectedRoom[productId] = policyId;
				var guest = {
					first_name: tip.first_name || '',
					last_name: tip.last_name || '',
					customer_email: tip.holdEmail || tip.customer_email || '',
					phone_number: tip.holdPhone || tip.phone_number || ''
				};
				if (guest.first_name || guest.last_name || guest.customer_email) {
					$sessionStorage['hold_convert_guest_' + $localStorage['preHotelId']] = guest;
				}
				vm.isloading = false;
				$state.go('app.create-res', {
					prod_id: JSON.stringify(selectedRoom),
					from: new Date(moment(fromDate).format('YYYY-MM-DD')),
					to: new Date(moment(toDate).format('YYYY-MM-DD')),
					adult: parseInt(tip.room_stay_guest_count, 10) || 2,
					child: parseInt(tip.room_stay_child_count, 10) || 0,
					from_page: 'header',
					block_conf_no: confirmation,
					hold_block_choice: 'hold',
					creationSource: 'Tape Chart'
				});
			}, function() {
				vm.isloading = false;
				toastMessage.showSimpleToast('Unable to load hold details.','error-toast');
			});
		}

		function removeHoldBlockDates(type,event) {
            if(type == 'hold'){
				var html='Are you sure you want to release dates from "'+moment(vm.currenttask.model.from).format('MM/DD/YYYY')+' to '+moment(vm.currenttask.model.to).format('MM/DD/YYYY')+'"?';
				var title = "Release Dates";
			} else {
				var html='Are you sure you want to unblock dates from "'+moment(vm.currenttask.model.from).format('MM/DD/YYYY')+' to '+moment(vm.currenttask.model.to).format('MM/DD/YYYY')+'"?';
				var title = "Unblock Dates";
			}
            $mdDialog.show({
                controller: 'confirmPageController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose:true ,
                locals: {
                    title: title,
                    htmlContent:html,
                    btnTxt: 'Continue',
                    cancelTxt: 'Cancel',
                    localData: {}
                }              
            }).then(function(response) {
                if(typeof response.answer != 'undefined' && response.answer == 'update') {
                    vm.isloading = true;
                    var roomName=vm.currenttask.row.model.name;
                    var data = {confirmation_number:vm.currenttask.model.confirmation_number,
                        type_of_reservation:vm.currenttask.model.type_of_reservation,
                        room_name:roomName,
                        from:vm.currenttask.model.from,
                        to:vm.currenttask.model.to
                    };
                    ganttChartServiceNew.removeHoldBlockDates(data).then(function(response) {
                        vm.isloading = false;
                        if (response.success) {
                            vm.reloadDataConditionally(vm.currenttask.model.productId);
                        } else if (response.errorMsg) {
                            toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                        } else {
                            toastMessage.showSimpleToast('There was some error in fetching prices for selected range.','error-toast');
                        }
                    });
                }
            }, function() {});			 
		}
		
		function editHoldDates(event){
			var roomName = vm.currenttask.row.model.prodName != undefined ? vm.currenttask.row.model.prodName : vm.currenttask.row.model.name;
			var openEditDialog = function() {
				$mdDialog.show({
					controller         : 'optionCreatePlaceGantt',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/apps/dashboards/gantt-chart/dialogs/option-place-on-gantt.html',
					parent             : angular.element($document.body),
					targetEvent        : event,
					clickOutsideToClose: true,
					locals             : {
						dialogData: {
							chartData : vm.data,
							thisnewcreateData : vm.currenttask,
							thisroomname : roomName,
							requestFrom : vm.pageType || 'room'
						},
						parentScope: $scope,
						mode_of_call: 'edit'
					},
					onRemoving: function (event) {
						if($scope.success == undefined || !$scope.success){
						}else{
							vm.reloadDataConditionally(vm.currenttask.model.productId);
						}
					}
				});
			};
			openEditDialog();
		}	

        // Visual two way binding.
        var ganttDebounceValue = 100;

        var listenTaskJson = ganttDebounce(function (taskJson)
        {
            if ( angular.isDefined(taskJson) )
            {
                var task = angular.fromJson(taskJson);
                objectModel.cleanTask(task);
                var model = vm.live.task;
                angular.extend(model, task);
            }
        }, ganttDebounceValue);

        $scope.$watch('vm.live.taskJson', listenTaskJson);

        var listenRowJson = ganttDebounce(function (rowJson)
        {
            if ( angular.isDefined(rowJson) )
            {
                var row = angular.fromJson(rowJson);
                objectModel.cleanRow(row);
                var tasks = row.tasks;

                delete row.tasks;
                var rowModel = vm.live.row;

                angular.extend(rowModel, row);

                var newTasks = {};
                var i, l;

                if ( angular.isDefined(tasks) )
                {
                    for ( i = 0, l = tasks.length; i < l; i++ )
                    {
                        objectModel.cleanTask(tasks[i]);
                    }

                    for ( i = 0, l = tasks.length; i < l; i++ )
                    {
                        newTasks[tasks[i].id] = tasks[i];
                    }

                    if ( angular.isUndefined(rowModel.tasks) )
                    {
                        rowModel.tasks = [];
                    }

                    for ( i = rowModel.tasks.length - 1; i >= 0; i-- )
                    {
                        var existingTask = rowModel.tasks[i];
                        var newTask = newTasks[existingTask.id];

                        if ( angular.isUndefined(newTask) )
                        {
                            rowModel.tasks.splice(i, 1);
                        }
                        else
                        {
                            objectModel.cleanTask(newTask);
                            angular.extend(existingTask, newTask);

                            delete newTasks[existingTask.id];
                        }
                    }
                }
                else
                {
                    delete rowModel.tasks;
                }

                angular.forEach(newTasks, function (newTask)
                {
                    rowModel.tasks.push(newTask);
                });
            }
        }, ganttDebounceValue);

        $scope.$watch('vm.live.rowJson', listenRowJson);

        $scope.$watchCollection('vm.live.task', function (task)
        {
            vm.live.taskJson = angular.toJson(task, true);
            vm.live.rowJson = angular.toJson(vm.live.row, true);
        });
        
		
        $scope.$watchCollection('vm.live.row', function (row)
        {
            vm.live.rowJson = angular.toJson(row, true);
            if ( angular.isDefined(row) && angular.isDefined(row.tasks) && row.tasks.indexOf(vm.live.task) < 0 )
            {
                vm.live.task = row.tasks[0];
            }
        });

        $scope.$watchCollection('vm.live.row.tasks', function ()
        {
            vm.live.rowJson = angular.toJson(vm.live.row, true);
        });
        
        // Event handler
        var logTaskEvent = function(eventName, task) {
        };
        
        // Event utility function
        var addEventName = function(eventName, func) {
            return function(data) {
                return func(eventName, data);
            };
        };
        function get_room_percent_this(jsondata){
			jQuery('.occupancy_percent').remove();
            if (jsondata != undefined && jsondata.length) {
    			jQuery.each(jQuery.parseJSON(jsondata), function(idxclass, objclass) {							
    				setTimeout(function() {  
                        var test = jQuery("."+idxclass).html();
    					if(test == 'undefined'){
    						jQuery("."+idxclass).append('<span class="occupancy_percent">0%</span>');
    					}else{
    						objclass=objclass.toFixed(2);
    						jQuery("."+idxclass).append('<span class="occupancy_percent">'+parseFloat(objclass)+'%</span>');		
    					}
    				},100);
    						
    			});
            }
		}
        
        var getViewPortWidth = function() {
            var d = $document[0];
            return d.documentElement.clientWidth || d.documentElement.getElementById('body')[0].clientWidth;
        };

        var getViewPortHeight = function() {
            var d = $document[0];
            return d.documentElement.clientHeight || d.documentElement.getElementById('body')[0].clientHeight;
        };

        /**
        * @param: Event event
        * @param: Object row
        * Comment: Get the description for particular row
        */
        $scope.get_room_description = function(event, row) {
            event.preventDefault();
            event.stopPropagation();
            var elementRect = row.$element[0].getBoundingClientRect();
            var tooltipTop, tooltipBottom;
            var tooltipArrowFromTop = true;
            var tooltipHeight;
            if(getViewPortWidth() >= 1800){
                tooltipHeight = 450;
            } else {
                tooltipHeight = 300;
            }
            if(parseInt(elementRect.top) + parseInt(tooltipHeight) > getViewPortHeight()){
                tooltipTop = "auto";
                tooltipBottom = (parseInt(getViewPortHeight()) - parseInt(elementRect.bottom) ) + "px";
                tooltipArrowFromTop = false;
            } else {
                tooltipTop = (parseInt(elementRect.top) - 64) + "px";
                tooltipBottom = "auto";
            }
            vm.description = {};
            vm.description.loader = EnvironmentConfig.feBase_url+'/images/loader.gif';
            vm.roomInformation = '';
            vm.isloading = true;


            var postData = {
                'product_id': row.model.productId != undefined ? row.model.productId : row.model.id,
                'table': row.model.productId != undefined ? 'products' : 'room_type',
            }
            ganttChartServiceNew.getRoomDescription(postData).then(function(response){
                if(response.success){
                    vm.isloading = false;

                    vm.roomInformation = response.data;
                    vm.showAmenity = response.data.amenitiesdata.hasOwnProperty('Room features') > 0? true:false;

                    if(typeof vm.roomInformation.image == 'undefined')
                    vm.roomInformation.imagePath = EnvironmentConfig.api+'assets/uploads/product/room-service.svg';
                    else
                    vm.roomInformation.imagePath = EnvironmentConfig.api+'assets/uploads/hotels/org/'+vm.roomInformation.image;
                }else if(response.errorMsg){
                    toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                }else{
                    toastMessage.showSimpleToast('There was some error in getting description of this room.','error-toast');
                }
                var divWidth = $(".gantt-row-label").width();
                var newDivWidth = parseInt(divWidth)+35;
                newDivWidth = newDivWidth+"px";
                if(!tooltipArrowFromTop){
                    $('head').append('<style>.popup_roomdes{top:'+tooltipTop+';bottom:'+tooltipBottom+'}.popup_roomdes{left:'+newDivWidth+'}.popup_roomdes:before{top:auto !important;bottom:11px !important;}.popup_roomdes:after{top:auto !important;bottom:10px;}</style>');
                } else {
                    $('head').append('<style>.popup_roomdes{top:'+tooltipTop+';bottom:'+tooltipBottom+'}.popup_roomdes{left:'+newDivWidth+'}.popup_roomdes:before{top:11px !important;bottom:auto !important;}.popup_roomdes:after{top:10px !important;bottom:auto;}</style>');
                }
            });
        }   

        $scope.hide_description = function(){
            vm.roomInformation = '';
        }

        /**
        * @param: null
        * Comment: Update the parent room indexes
        */
        vm.updateParentRoomIndexes = function() {
            vm.parentRoomIndexes = [];
            if(typeof $localStorage[vm.currentHotelId+'_'+vm.roomTypes+'_expanded'] != 'undefined'){
                $localStorage[vm.currentHotelId+'_'+vm.roomTypes+'_expanded'] = [];
            } else {
                $localStorage[vm.currentHotelId+'_'+vm.roomTypes+'_expanded'] = [];
            }
            
            angular.forEach($scope.data, function(value, key) {
                if (value.isParent != undefined && value.isParent) {
                    vm.parentRoomIndexes.push(key);
                }
            });

            if (vm.storeRoomsRecord != undefined && Object.keys(vm.storeRoomsRecord).length > 0) {
                angular.forEach(vm.storeRoomsRecord, function(value, key) {
                    $localStorage[vm.currentHotelId+'_'+vm.roomTypes+'_expanded'].push({roomTypeId: value.roomTypeId, expanded: value.expanded});
                });
            }
            syncSubHotelExpandIcons();
        };

        /**
        * @param: null
        * Comment: Update the gantt chart data according to the room and its childs
        */
        /*vm.updateFullGanttData = function() {
            $timeout(function() {
                var tempData = JSON.stringify(vm.scopeDataValue);
                tempData = JSON.parse(tempData);
                var finalData = [];
                angular.forEach(tempData, function(value, key){
                    if (parseInt(value.id) > 4 && ((value.is_walk != undefined && value.is_walk != 1) || value.is_walk == undefined)) { // leave occupancy arrays
                        if (value.isParent) {
                            finalData.push(value);
                            for (var i = 0; i < tempData.length; i++) {
                                if (tempData[i].parent != undefined && tempData[i].parent == value.id) {
                                    finalData.push(tempData[i]);
                                }
                            }
                        }
                    } else {
                        finalData.push(value);
                    }
                });

                vm.scopeDataValue = $scope.data = [];
                vm.scopeDataValue = $scope.data = finalData;
                vm.storeJsonData = JSON.stringify(vm.scopeDataValue);
                vm.updateParentRoomIndexes();
            }, 10);
        };*/

        /**
        * @param: String productId
        * @param: String type
        * @return: Null
        * Comment: Get the index which is clicked to create or move hold, block or reservation
        */
        vm.calculateSelectedIndex = function(productId, type) {
            if ($scope.data != undefined && $scope.data.length > 0) {
                angular.forEach($scope.data, function(value, key) {
                    if (type == 'parent') {
                        if (value.id == productId) {
                            vm.clickedParentIndex = key;
                            return;
                        }
                    } else if (type == 'current' || type == 'previous' || type == 'returnkey') {
                        if (value.productId != undefined && value.productId == productId) {
                            if (type == 'current') {
                                vm.currentClickedIndex = key;
                            } else if (type == 'previous') {
                                vm.previousClickedIndex = key;
                            } else if (type == 'returnkey') {
                                vm.returnKey[productId] = key;
                            }
                            return;
                        }
                    }
                });
            }                       
        };

        /**
        * @param: String productId
        * @param: String type
        * @return: Null
        * Comment: Get the reservations for a particular room
        */
        vm.getRoomReservations = function(productId, type) {
            var hotel_id = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
            var data = {
                roomTypes: vm.roomTypes,
                requestFor: vm.pageType,
                newChart: true,
                boatDispType: vm.boatDispType,
                rentDispType: vm.rentDispType,
                hotelId: vm.currentHotelId,
                start: vm.options.fromDate,
                end: vm.options.toDate,
                productId: productId
            };

            vm.isloading = true;
            ganttChartServiceNew.getGanttSingleRoomData(data).then(function(response) {
                vm.isloading = false;
                var tempRoomData = [];
                var activeIndex = type == 'current' ? vm.currentClickedIndex : vm.previousClickedIndex;
                if (response.roomDetail != undefined && response.roomDetail) {
                    $scope.data[activeIndex].tasks = response.roomDetail;
                    if (response.otherRoomUpdate != undefined && response.otherRoomUpdate.length > 0) {
                        angular.forEach(response.otherRoomUpdate, function(value, key) {
                            vm.returnKey = {};
                            vm.returnKey[value.productId] = -1;
                            vm.calculateSelectedIndex(value.productId, 'returnkey');
                            if (vm.returnKey[value.productId] == -1) {
                                                               
                            } else {
                                $scope.data[vm.returnKey[value.productId]].tasks = value.data;
                            }
                        });
                    }
                }
            });
        }

        /**
        * @param: Integer productId
        * @param: String parm
        * Comment: Check whether we need to fetch complete data of single room data
        */
        vm.reloadDataConditionally = function(productId, parm) {
            parm = parm != undefined && parm != '' ? parm : 'current';
            vm.calculateSelectedIndex(productId, parm);
            if (vm.allRoomHotels.includes(vm.currentHotelId) || productId == undefined || vm.pageType == 'rent' || (vm.currentHotelId == 122 && vm.pageType == 'boat')) {
               load('changeDate');
            } else {
                vm.getRoomReservations(productId, parm);
            }
        }

        /**
        * @param: Integer id
        * Comment: Update the data when parent view is reloaded
        */
        /*vm.reloadParentData = function(id) {
            var tempData = JSON.stringify($scope.data);
            tempData = JSON.parse(tempData);
            tempData[vm.clickedParentIndex].tasks = [];
            vm.updateData(tempData);
        };*/



        /**
        * @param: Null
        * Comment: Update the main object with the changed records
        */
        /*vm.updateData = function(tempData) {
            $timeout(function() {
                vm.scopeDataValue = $scope.data = [];
                vm.scopeDataValue = $scope.data = tempData;
                vm.storeJsonData = JSON.stringify(vm.scopeDataValue);
                vm.updateParentRoomIndexes();
            }, 0);
        };*/

        vm.getDataOnStateChange = function() {
            var data = {};
            var hotel_id = vm.currentHotelId;
            if (vm.pageType != 'boat' && typeof $sessionStorage[hotel_id] != 'undefined' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_from') && $sessionStorage[hotel_id]['gantt_chart_from'] != '' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_to') && $sessionStorage[hotel_id]['gantt_chart_to'] != '') {
                data = {
                    start:$sessionStorage[hotel_id]['gantt_chart_from'],
                    end:$sessionStorage[hotel_id]['gantt_chart_to'],
                };
            } else if (vm.pageType == 'boat' && typeof $sessionStorage['boat'] != 'undefined' && $sessionStorage['boat'].hasOwnProperty('gantt_chart_from') && $sessionStorage['boat']['gantt_chart_from'] != '' && $sessionStorage['boat'].hasOwnProperty('gantt_chart_to') && $sessionStorage['boat']['gantt_chart_to'] != '') {
                data = {
                    start:$sessionStorage['boat']['gantt_chart_from'],
                    end:$sessionStorage['boat']['gantt_chart_to']
                };
            }
            
            // vm.getGanttReservations(data, 'tabChange');
        }

        /**
        * @param: null
        * Comment: Expand the rooms which should be expanded when user navigates from another page
        */
        vm.expandRooms = function() {
            var roomName, roomElement = '';
            if (vm.parentRoomTypes != undefined && vm.parentRoomTypes.length) {
                angular.forEach($('.gantt-tree-root li.angular-ui-tree-node'), function(element, key){
                    roomElement = '';
                    if ($(element).children('.gantt-row-label').children('.gantt-valign-container').children('.gantt-valign-content')) {
                        roomElement = ($(element).children('.gantt-row-label').children('.gantt-valign-container').children('.gantt-valign-content').children('span'));
                        roomName = ($(roomElement).children('span:first-child').text());
                        roomName = roomName.replace(/^\s+|\s+$/gm,'');
                        if (roomName != '') {
                            angular.forEach(vm.parentRoomTypes, function(roomVal, roomKey) {
                                if (roomName == roomVal.roomName && roomVal.expanded) {
                                    if($(roomElement).prev('a.gantt-tree-handle-button')) {
                                       $(roomElement).prev('a.gantt-tree-handle-button').click();
                                    }
                                }
                            });                            
                        }
                    }
                });
            }

            vm.getWalkRoomsData();
            syncSubHotelExpandIcons();
        }

        /**
        * @param: String clickedKey
        * @param: String roomType
        * @param: Integer parentIndex
        * Comment: Get tasks for single gantt row
        */
        vm.getTasksForGroupRooms = function(clickedKey, roomType) {
            var productIds = [];
            var parentIndex = '';
            if (roomType !== 'walk') {
                angular.forEach($scope.data, function(value, key) {
                    if (value.name != undefined && value.name == clickedKey) {
                        $scope.data[key].showRoomLoader = true;
                        $scope.data[key].expanded = true;
                        $scope.data[key].classes = "pointer_events_disabled";
                        parentIndex = key;
                        productIds = value.productIds;
                        return;
                    }
                });

                angular.forEach(vm.parentRoomTypes, function(value, key) {
                    if (value.roomName == clickedKey) {
                        vm.parentRoomTypes[key].expanded = true;
                        return;
                    }
                });
            } else if (roomType === 'walk') {
                parentIndex = clickedKey.index;
                productIds.push(clickedKey.roomId);
            }
            
            if (productIds.length > 0) {
                var data = {
                    roomTypes: vm.roomTypes,
                    requestFor: vm.pageType,
                    newChart: true,
                    boatDispType: vm.boatDispType,
                    rentDispType: vm.rentDispType,
                    hotelId: vm.currentHotelId,
                    start: vm.options.fromDate,
                    end: vm.options.toDate,
                    productIds: productIds,
                    expandedRooms: true,
                    parentIndex: parentIndex
                };
                ganttChartServiceNew.getGanttSingleRoomData(data).then(function(response) {
                    var tempParentIndex = response.parentIndex != undefined && response.parentIndex > 0 ? response.parentIndex : parentIndex; // get parent index from php so that request should not change indexs
                    $scope.data[tempParentIndex].showRoomLoader = false;
                    if (roomType !== 'walk') {
                        $scope.data[tempParentIndex].classes = "parentClass pointer_events_disabled";
                    }

                    var loopKey;
                    if (response.tasksList != undefined && Object.keys(response.tasksList).length > 0) {
                        angular.forEach(response.tasksList, function(value, key) {
                            if (roomType === 'walk') {
                                loopKey = parseInt(tempParentIndex);
                            } else {
                                loopKey = parseInt(tempParentIndex + key + 1);
                            }
                            $scope.data[loopKey].tasks = value;
                        });
                    }
                });
            }
        };

        /**
        * @param: null
        * Comment: Remove all the tasks on change of scroll, date or reload 
        */
        vm.removeAllTasks = function() {
            if ($scope.data.length > 0) {
                angular.forEach($scope.data, function(value, key) {
                    if (value.isParent != undefined) {

                    } else {
                        $scope.data[key].tasks = [];
                    }
                });
            }
        }

        /**
        * @param: null
        * Comment: Get the tasks on change of date, scroll or reload from icon
        */
        vm.getTaskOnChange = function() {
            if (vm.parentRoomTypes.length) {
                angular.forEach(vm.parentRoomTypes, function(value, key) {
                    if (value.expanded != undefined && value.expanded) {
                        vm.getTasksForGroupRooms(value.roomName, 'rooms');
                    }
                });
            }           
        }

        /**
        * @param: null
        * @return: String
        * Comment: Check if selected hotel contains single room or group rooms
        */
        vm.checkGroupOrSingleRooms = function() {
            var status;
            if (vm.allRoomHotels.includes(vm.currentHotelId) || vm.pageType == 'rent' || (vm.currentHotelId == 122 && vm.pageType == 'boat')) {
                status = 'single';
            } else {
                status = 'group';
            }
            return status;
        }

        /**
        * @param: Null
        * Comment: Fetch data for walk rooms as they have single entry only not parent rooms
        */
        vm.getWalkRoomsData = function() {
            if (vm.walkArray != undefined && vm.walkArray.length > 0) {
                angular.forEach(vm.walkArray, function(value, key) {
                   vm.getTasksForGroupRooms(value, 'walk'); 
                });
            }
        }

        /**
        * @param: Null
        * Comment: Fetch data for occupancy for each hotel
        */
        vm.getOccupancyData = function() {
            if ((vm.occupancyArray != undefined && vm.occupancyArray.length > 0) || (vm.currentHotelId == 126 && vm.pageType == 'boat') || vm.currentHotelId == 129) {                                  
                var data = {
                    start: vm.options.fromDate,
                    end: vm.options.toDate,
                    requestFor: vm.pageType,
                    newChart: true,
                    hotelId: vm.currentHotelId,
                    roomTypes: vm.roomTypes,
                    boatDispType: vm.boatDispType,
                    rentDispType: vm.rentDispType,
                    occupancyDataOnly: true,
                    parentIndexes: vm.occupancyArray
                };
                ganttChartServiceNew.getGanttData(data).then(function(response) {
                    if (response.occupancyData != undefined) {
                        if ((vm.currentHotelId == 126 && vm.pageType == 'boat')) {
                            vm.occupancyData = response.occupancyData;
                            get_room_percent_this(vm.occupancyData);
                        } else {
                            angular.forEach(response.occupancyData, function(value, key) {
                                $scope.data[value.index].tasks = value.tasks;
                            });
                        }
                    }
                });
            }
        } 
    }

})();

"use strict";

/**
 * @ngdoc service
 * @name minervaApp.../category/categoryService
 * @description
 * # ../category/categoryService
 * Service in the minervaApp.
 */
angular
  .module("app.dashboards.gantt-chart")
  .service(
    "ganttChartServiceNew",
    function (
      $http,
      EnvironmentConfig,
      $mdDialog,
      $document,
      toastMessage,
      $q,
      $state,
      $timeout,
      $window,
      dashboardGraphService,
      $sessionStorage,
      $localStorage,
      $rootScope,
      $stateParams,
      eCommerceService
    ) {
      // AngularJS will instantiate a singleton by calling "new" on this function
      function getDataComplete(response) {
        return response.data;
      }

      function getDataFailed(error) {
        return error.data;
      }

      function getGanttData(data) {
        var url;
        if (
          data.hotelId !== undefined &&
          ((data.hotelId == "122" && data.requestFor == "room") ||
            (data.hotelId == "126" && data.requestFor != "rent") ||
            (data.hotelId == "135" && data.requestFor == "room"))
        ) {
          url = EnvironmentConfig.api + "Dashboard/viewModifiedDashboard";
        } else {
          url = EnvironmentConfig.api + "Dashboard/view_dashboard";
        }

        return $http({
          url: url,
          method: "POST",
          data: data,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }

      function getGanttTooltipData(data) {
        return $http({
          url: EnvironmentConfig.api + "Dashboard/get_tooltip_data",
          method: "POST",
          data: data,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }

      function checkAvailabilityForDates(data) {
        var payload = angular.copy(data) || {};
        if (payload.room_stay_from) {
          payload.room_stay_from = moment(payload.room_stay_from).format("YYYY-MM-DD");
        }
        if (payload.room_stay_to) {
          payload.room_stay_to = moment(payload.room_stay_to).format("YYYY-MM-DD");
        }
        return $http({
          url: EnvironmentConfig.api + "Dashboard/check_availabilty_for_dates",
          method: "POST",
          data: payload,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }

      function getModifiedOrder(data) {
        return $http({
          url: EnvironmentConfig.api + "Dashboard/get_modified_order",
          method: "POST",
          data: data,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }

      function saveHoldBlockDates(data) {
        return $http({
          url: EnvironmentConfig.api + "Dashboard/save_hold_block_dates",
          method: "POST",
          data: data,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }

      function saveModifiedOrder(data) {
        return $http({
          url: EnvironmentConfig.api + "Dashboard/save_modified_order",
          method: "POST",
          data: data,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }

      function saveModifiedReservation(data) {
        return $http({
          url: EnvironmentConfig.api + "Dashboard/save_modified_reservation",
          method: "POST",
          data: data,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }

      /**
       * @param: Object data
       * @return: Boolean
       * Comment: Change the order for rooms
       */
      function setSortOrder(data) {
        return $http({
          url: EnvironmentConfig.api + "Dashboard/updateProductsSortOrder",
          method: "POST",
          data: data,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }

      function removeHoldBlockDates(data) {
        return $http({
          url: EnvironmentConfig.api + "Dashboard/remove_hold_block_dates",
          method: "POST",
          data: data,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }

      function changeReservationStatus(data) {
        return $http({
          url: EnvironmentConfig.api + "Reservations/change_reservation_status",
          method: "POST",
          data: data,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }

      function getCancelOrderData(data) {
        return $http({
          url: EnvironmentConfig.api + "Reservations/cancel_order_data",
          method: "POST",
          data: data,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }

      function cancelOrder(data) {
        return $http({
          url: EnvironmentConfig.api + "Reservations/cancel_order",
          method: "POST",
          data: data,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }

      function changeStatusForService(data) {
        return $http({
          url: EnvironmentConfig.api + "Reservations/change_services_status",
          method: "POST",
          data: data,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }

      function getProductPriceData(data) {
        var payload = angular.copy(data) || {};
        // Stay dates must be calendar Y-m-d; Date/ISO Z shifts a day across timezones
        if (payload.room_stay_from) {
          payload.room_stay_from = moment(payload.room_stay_from).format("YYYY-MM-DD");
        }
        if (payload.room_stay_to) {
          payload.room_stay_to = moment(payload.room_stay_to).format("YYYY-MM-DD");
        }
        return $http({
          url: EnvironmentConfig.api + "Reservations/get_price_all_policies",
          method: "POST",
          data: payload,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }

      function loadRoomMovedOrderInfoForCancel(data) {
        return $http({
          url: EnvironmentConfig.api + "Dashboard/load_rm_order_info_cancel",
          method: "POST",
          data: data,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }
      function setRoomCleanStatus(data) {
        return $http({
          url: EnvironmentConfig.api + "Product/setProductCleanStatus",
          method: "POST",
          data: data,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }
      function savecommentofRes(data) {
        return $http({
          url: EnvironmentConfig.api + "Dashboard/savecommentofRes",
          method: "POST",
          data: data,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }
      function getRoomDescription(data) {
        return $http({
          url: EnvironmentConfig.api + "Dashboard/get_room_description",
          method: "POST",
          data: data,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }

      function fetchRemainingAmount(confNo) {
        return $http({
          url: EnvironmentConfig.api + "Dashboard/getRemainingAmount/" + confNo,
          method: "GET",
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }

      function getBorrowedCount(confirmationNumber) {
        return dashboardGraphService
          .getBorrowedItems({
            confirmation_number: confirmationNumber,
          })
          .then(function (res) {
            return parseInt(res && res.borrowed_count, 10) || 0;
          })
          .catch(function () {
            return 0;
          });
      }

      function blockCheckoutIfBorrowedItems(resvDetail) {
        if ($localStorage && $localStorage.hotelgeneralsetting && $localStorage.hotelgeneralsetting.enableBorrowedItems !== '1') {
          return $q.when({ blocked: false, borrowed_count: 0 });
        }
        var confirmationNumber =
          resvDetail && resvDetail.confirmation_number
            ? resvDetail.confirmation_number
            : "";

        if (!confirmationNumber) {
          return $q.when({ blocked: false, borrowed_count: 0 });
        }

        return getBorrowedCount(confirmationNumber).then(function (borrowedCount) {
          resvDetail.borrowed_count = borrowedCount;

          if (borrowedCount <= 0) {
            return { blocked: false, borrowed_count: 0 };
          }

          var itemLabel = borrowedCount === 1 ? "item" : "items";
          var html =
            "This guest still has <strong>" +
            borrowedCount +
            "</strong> borrowed " +
            itemLabel +
            ". Collect those before checkout, or add them to the reservation.";

          return $mdDialog
            .show({
              controller: "confirmController",
              controllerAs: "vm",
              templateUrl:
                "app/main/apps/contacts/confirmationPopUp/confirmation.html",
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              locals: {
                title: "Borrowed items",
                htmlContent: html,
                cancelBtn: "Cancel",
                OkBtn: "Continue",
              },
            })
            .then(
              function (answer) {
                if (answer === "update") {
                  var reservationId =
                    resvDetail.reservation_id ||
                    resvDetail.reserv_id ||
                    resvDetail.id ||
                    "";
                  var resvType =
                    resvDetail.resvType ||
                    resvDetail.type_of_reservation ||
                    resvDetail.type ||
                    "room";

                  if (resvType === "reservation") {
                    resvType = "room";
                  }

                  var alreadyOnDetail =
                    ($stateParams &&
                      $stateParams.confirmation_number &&
                      String($stateParams.confirmation_number) ===
                        String(confirmationNumber)) ||
                    ($stateParams &&
                      reservationId &&
                      String($stateParams.id) === String(reservationId));

                  // Already on reservation detail: let the caller open the dialog
                  // after this confirm dialog has fully closed.
                  if (alreadyOnDetail) {
                    return {
                      blocked: true,
                      borrowed_count: borrowedCount,
                      openBorrowedItems: true,
                    };
                  }

                  if (reservationId && confirmationNumber) {
                    $sessionStorage["open_borrowed_items_for"] = String(
                      confirmationNumber
                    );
                    goToResvDetailPage(
                      resvType,
                      confirmationNumber,
                      reservationId
                    );
                    return {
                      blocked: true,
                      borrowed_count: borrowedCount,
                    };
                  }

                  // Fallback when we cannot navigate — open on current page.
                  return {
                    blocked: true,
                    borrowed_count: borrowedCount,
                    openBorrowedItems: true,
                  };
                }
                return {
                  blocked: true,
                  borrowed_count: borrowedCount,
                };
              },
              function () {
                return {
                  blocked: true,
                  borrowed_count: borrowedCount,
                };
              }
            );
        });
      }

      /**
       * param: Object resvDetail
       * param: String newstatus
       * param: Float RemainAmount
       * param: String fromPage
       * return: Object
       * Comment: cancel, checkin or checkout resv status depending upon amount left
       */
      function processStatusRequest(
        resvDetail,
        newstatus,
        remainAmount,
        fromPage
      ) {
        var notHitRequest = { success: true, hitRequest: false };
        var hitRequest = { success: true, hitRequest: true };
        if (fromPage === "ganttChart" && remainAmount == undefined) {
          remainAmount = resvDetail.RemainAmount;
        }

        if (fromPage !== "ganttChart") {
          resvDetail.status = resvDetail.room_stay_status;
          resvDetail.check_send_email = resvDetail.send_email_indicator;
        }

        // Waiting for Room is display-only; functional status stays room_stay_status (usually Active).
        // Display priority: Waiting for Room > Active / room_stay_status.
        var isWaiting = eCommerceService.isWaitingForRoom(resvDetail, {
          checkColor: true,
          checkShowStatus: true,
        });
        var functionalOldStatus =
          resvDetail.status ||
          resvDetail.room_stay_status ||
          "Active";
        if (functionalOldStatus === "undefined" || functionalOldStatus === "Waiting for Room") {
          functionalOldStatus = "Active";
        }
        var displayOldStatus = isWaiting
          ? "Waiting for Room"
          : functionalOldStatus;

        var defer = $q.defer();
        var globalItems = {
          reservation_id:
            resvDetail.reservation_id !== undefined
              ? resvDetail.reservation_id
              : resvDetail.reserv_id,
          confirmation_number: resvDetail.confirmation_number,
          checkSendEmail: resvDetail.check_send_email == 1 ? true : false,
          oldStatus: functionalOldStatus,
          displayOldStatus: displayOldStatus,
          isWaiting: !!isWaiting,
          newStatus: newstatus,
          fromPage: fromPage,
          name:
            resvDetail.name !== undefined
              ? resvDetail.name
              : resvDetail.first_name !== undefined
              ? resvDetail.first_name + " " + resvDetail.last_name
              : "",
          paidAmount:
            resvDetail.overalltotals !== undefined &&
            resvDetail.overalltotals.paid_amount !== undefined
              ? resvDetail.overalltotals.paid_amount
              : resvDetail.paidAmount !== undefined
              ? resvDetail.paidAmount
              : 0,
          resvType:
            resvDetail.resvType !== undefined ? resvDetail.resvType : "room",
          room_stay_id:
            resvDetail.room_stay_id != undefined ? resvDetail.room_stay_id : "",
          product_id:
            resvDetail.product_id != undefined ? resvDetail.product_id : "",
        };

        if (String(newstatus || "").toLowerCase() === "checked-out") {
          blockCheckoutIfBorrowedItems(resvDetail).then(function (result) {
            if (result.blocked) {
              defer.resolve({
                success: true,
                hitRequest: false,
                openBorrowedItems: !!result.openBorrowedItems,
              });
              return;
            }
            runExistingStatusFlow();
          });
        } else {
          runExistingStatusFlow();
        }

        function runExistingStatusFlow() {
        if (newstatus == "Canceled" || newstatus == "No Show") {
          getCancelOrderData({
            confirmation_number: globalItems.confirmation_number,
            status: globalItems.newStatus,
          }).then(function (response) {
            if (response.success && response.statusMsg == "") {
              var days_free_cancellation = response.days_free_cancellation;
              var payments = response.payments;
              var refund_type = response.refund_type;
              var policy_name = response.policy_name;
              var room_stay_from = response.room_stay_from;
              var payment_exists = response.payment_exists;
              var total_amount = response.total_amount;
              var total_paid_amount = response.total_paid_amount;
              var customer_email = response.customer_email;
              var cancellation_charges = response.cancellation_charges;
              var if_cancelled_period = response.if_cancelled_period;
              var insurance_amount = response.insurance_amount || 0;
              $mdDialog.show({
                clickOutsideToClose: false,
                parent: angular.element($document.body),
                // scope				: $scope,
                preserveScope: true,
                locals: {
                  localData: {
                    oldStatus: globalItems.displayOldStatus || globalItems.oldStatus,
                    newStatus: globalItems.newStatus,
                    confirmation_number: globalItems.confirmation_number,
                    days_free_cancellation: days_free_cancellation,
                    payments: payments,
                    room_stay_from: room_stay_from,
                    refund_type: refund_type,
                    customer_name: globalItems.name,
                    customer_email: customer_email,
                    paidAmount: globalItems.paidAmount,
                    total_amount: total_amount,
                    total_paid_amount: total_paid_amount,
                    payment_exists: payment_exists,
                    cancellation_charges: cancellation_charges,
                    if_cancelled_period: if_cancelled_period,
                    policy_name: policy_name,
                    send_email_indicator: globalItems.checkSendEmail,
                    ibServicePosProductsPaid: response.ibServicePosProductsPaid,
                    insurance_amount: insurance_amount,
                  },
                },
                templateUrl:
                  "app/main/apps/e-commerce/views/orders/dialogs/status/cancel.html",
                controller: CancelController,
                controllerAs: "vm",
              });
              function CancelController($scope, $mdDialog, localData) {
                var vm = this;
                $scope.oldStatus = localData.oldStatus;
                $scope.confirmation_number = localData.confirmation_number;
                $scope.newStatus = localData.newStatus;
                $scope.send_email_indicator = localData.send_email_indicator;
                $scope.refund_type = localData.refund_type;
                $scope.policy_name = localData.policy_name;
                $scope.days_free_cancellation =
                  localData.days_free_cancellation;
                $scope.payments = localData.payments;
                $scope.customer_name = localData.customer_name;
                $scope.customer_email = localData.customer_email;
                $scope.paidAmount = localData.total_paid_amount;
                $scope.total_amount = localData.total_amount;
                $scope.total_paid_amount = localData.total_paid_amount;
                $scope.payment_exists = localData.payment_exists;
                $scope.cancellation_charges = localData.cancellation_charges;
                $scope.if_cancelled_period = localData.if_cancelled_period;
                $scope.insurance_amount = insurance_amount;
                if (
                  $scope.if_cancelled_period == "0" &&
                  $scope.cancellation_charges > 0
                )
                  vm.keepCancelCharges = true;
                else vm.keepCancelCharges = false;

                $scope.takeChargesInstallment = {};
                $scope.cancel_order_comment = "";
                $scope.showSubmit = true;
                $scope.titleContent =
                  globalItems.newStatus == "Canceled" ? "Cancel" : "No Show";

                $scope.closeDialog = function () {
                  $mdDialog.hide();
                  defer.resolve(notHitRequest);
                };
                vm.keep_chargess = false;
                $scope.changeKeepCharges = function (idx, old_value) {
                  if (old_value == 1) $scope.payments[idx].keep_charges = false;
                  else $scope.payments[idx].keep_charges = true;
                  if (vm.keepCancelCharges) {
                    var keep_amount = 0;
                    $timeout(function () {
                      angular.forEach($scope.payments, function (value, key) {
                        var intallmentId = value.installment_id;
                        if (
                          $scope.takeChargesInstallment[intallmentId] !=
                            "undefined" &&
                          $scope.takeChargesInstallment[intallmentId]
                        ) {
                          keep_amount =
                            parseFloat(keep_amount) +
                            parseFloat(value.installment_amount);
                        }
                        if (
                          parseFloat(keep_amount) >=
                          parseFloat($scope.cancellation_charges)
                        ) {
                          $scope.showSubmit = true;
                        } else {
                          $scope.showSubmit = false;
                        }
                      });
                    });
                  } else {
                    $scope.showSubmit = true;
                  }
                };

                $scope.cancelFinally = function (sendEmail) {
                  $scope.showSubmit = false;
                  vm.locationTitle = "";
                  vm.cancellationSource = "";
                  if (globalItems.fromPage === "ganttChart") {
                    vm.locationTitle = "PMS (Graph)";
                    vm.cancellationSource = "Tape Chart";
                  } else if (globalItems.fromPage == "reservationDetail") {
                    vm.locationTitle = "Reservation detail";
                    vm.cancellationSource = "Reservation Detail";
                  }
                  const cancellationSource = vm.cancellationSource.trim();

                  var data = {
                    refund_type: $scope.refund_type,
                    confirmation_number: $scope.confirmation_number,
                    reservation_id: globalItems.reservation_id,
                    cancel_order_comment: $scope.cancel_order_comment,
                    total_amount: $scope.total_amount,
                    keepCancelCharges: vm.keepCancelCharges,
                    takeChargesInstallment: $scope.takeChargesInstallment,
                    cancellation_charges: $scope.cancellation_charges,
                    location: vm.locationTitle,
                    sendEmail: sendEmail,
                    status: globalItems.newStatus,
                    ibServicePosProductsPaid:
                    localData.ibServicePosProductsPaid,
                    paidAmount: $scope.paidAmount,
                    insurance_amount: $scope.insurance_amount,
                    source: EnvironmentConfig.source + (cancellationSource ? ' - ' + cancellationSource : '')  };

                  if (globalItems.room_stay_id != "") {
                    data.room_stay_id = globalItems.room_stay_id;
                  }

                  if ($scope.refund_type == 0 || $scope.refund_type == 1) {
                  } else {
                    data.customer_name = $scope.customer_name;
                    data.customer_email = $scope.customer_email;
                  }

                  cancelOrder(data).then(function (response) {
                    if (response.success) {
                      if (response.refund_error)
                        toastMessage.showSimpleToast(
                          response.errorMsg,
                          "error-toast"
                        );

                      if (response.mail_error)
                        toastMessage.showSimpleToast(
                          "Reservation canceled successfully but there was some error in sending email to the customer.",
                          "error-toast"
                        );

                      $mdDialog.hide();
                      hitRequest.reservationCanceled = true;
                      defer.resolve(hitRequest);
                    } else {
                      toastMessage.showSimpleToast(
                        response.showErrorMsg && response.errorMsg
                          ? response.errorMsg
                          : "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.",
                        "error-toast"
                      );
                      defer.resolve(notHitRequest);
                    }
                  });
                };
              }
            } else if (response.statusMsg != "") {
              toastMessage.showSimpleToast(response.statusMsg, "error-toast");
              notHitRequest.alreadyCanceled = true;
              defer.resolve(notHitRequest);
            } else {
              toastMessage.showSimpleToast(
                "Oops! -  We've encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.",
                "error-toast"
              );
              defer.resolve(notHitRequest);
            }
          });
        } else {
          if (
            globalItems.oldStatus &&
            globalItems.oldStatus.toLowerCase() === newstatus.toLowerCase() &&
            !globalItems.isWaiting
          ) {
            var html =
              'This reservation is already in state "' + newstatus + '".';
            $mdDialog
              .show({
                controller: "confirmPageController",
                controllerAs: "vm",
                templateUrl:
                  "app/main/apps/dashboards/gantt-chart/confirmationPage.html",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                  title: "Change Status",
                  htmlContent: html,
                  btnTxt: "Continue",
                  cancelTxt: "Cancel",
                  localData: {},
                },
              })
              .then(
                function (response) {
                  if (
                    typeof response.answer != "undefined" &&
                    response.answer == "update"
                  ) {
                    $mdDialog.hide();
                    defer.resolve(notHitRequest);
                  }
                },
                function () {
                  defer.resolve(notHitRequest);
                }
              );
          } else {
            if (globalItems.newStatus != "Active" && remainAmount > 0) {
              $mdDialog.show({
                clickOutsideToClose: false,
                parent: angular.element($document.body),
                // scope				: $new(),
                preserveScope: true,
                locals: {
                  oldStatus:
                    globalItems.displayOldStatus ||
                    (globalItems.isWaiting
                      ? "Waiting for Room"
                      : globalItems.oldStatus) ||
                    "Active",
                  newStatus: newstatus,
                  RemainAmount: remainAmount,
                  confirmation_number: globalItems.confirmation_number,
                  // orig_confirmation_number: orig_confirmation_number,
                  // send_email_indicator: globalItems.checkSendEmail,
                  globalValues: globalItems,
                },
                templateUrl:
                  "app/main/apps/e-commerce/views/orders/dialogs/status/checkin-out.html",
                controller: StatusController,
                controllerAs: "vm",
              });
              function StatusController(
                $scope,
                $mdDialog,
                oldStatus,
                RemainAmount,
                newStatus,
                confirmation_number,
                globalValues
              ) {
                var vm = this;
                $scope.oldStatus = oldStatus;
                $scope.idx = 0;
                $scope.confirmation_number = confirmation_number;
                // $scope.orig_confirmation_number = orig_confirmation_number;
                $scope.newStatus = newStatus;
                $scope.send_email_indicator = globalItems.checkSendEmail;
                $scope.remainingBalance = RemainAmount;
                vm.globalValues = globalValues;
                if (newStatus == "Checked-In") $scope.showStatus = "Check-in";
                else if (newStatus == "Checked-Out")
                  $scope.showStatus = "Check-out";
                else if (newStatus == "Closed") $scope.showStatus = "Close";
                else $scope.showStatus = newStatus;

                vm.changeStatusWithoutPayment = function () {
                  clearWaitingIfNeeded(vm.globalValues).then(function () {
                    finalstatuschange(vm.globalValues).then(function (res) {
                      hitRequest.response = res;
                      defer.resolve(hitRequest);
                    });
                  }, function () {
                    defer.resolve(notHitRequest);
                  });
                };

                vm.changeStatusAfterPayment = function () {
                  var changeStatusData = {
                    newStatus: vm.globalValues.newStatus,
                    oldStatus: vm.globalValues.oldStatus,
                    sendEmail: vm.globalValues.checkSendEmail,
                  };

                  $mdDialog.hide();
                  // Do not clear Waiting yet — status is still Active until
                  // payment + Check-In complete on the reservation detail page.
                  if (vm.globalValues.fromPage === "ganttChart") {
                    $state.go("app.e-commerce.orders.detail", {
                      id: vm.globalValues.reservation_id,
                      confirmation_number: vm.globalValues.confirmation_number,
                      changeStatusData: changeStatusData,
                    });
                  } else if (
                    vm.globalValues.fromPage === "checkInListing" ||
                    vm.globalValues.fromPage === "dashboardPortlet"
                  ) {
                    redirectToResvPage(
                      vm.globalValues.resvType,
                      vm.globalValues.confirmation_number,
                      vm.globalValues.reservation_id
                    );
                  }
                  notHitRequest.processPayment = true;
                  notHitRequest.send_email_indicator =
                    $scope.send_email_indicator;
                  defer.resolve(notHitRequest);
                };

                $scope.closeDialog = function () {
                  $mdDialog.hide();
                  defer.resolve(notHitRequest);
                };
              }
            } else {
              var shownOldStatus =
                globalItems.displayOldStatus ||
                (globalItems.isWaiting
                  ? "Waiting for Room"
                  : globalItems.oldStatus) ||
                "Active";
              var html =
                'Are you sure you want to change status of reservation "' +
                globalItems.confirmation_number +
                " (" +
                globalItems.name +
                ')" from ' +
                shownOldStatus +
                " to " +
                globalItems.newStatus +
                ".";
              $mdDialog
                .show({
                  controller: "confirmPageController",
                  controllerAs: "vm",
                  templateUrl:
                    "app/main/apps/dashboards/gantt-chart/confirmationPage.html",
                  parent: angular.element(document.body),
                  targetEvent: event,
                  clickOutsideToClose: true,
                  locals: {
                    title: "Change Status",
                    htmlContent: html,
                    btnTxt: "Continue",
                    cancelTxt: "Cancel",
                    localData: {
                      newStatus: globalItems.newstatus,
                      send_email_indicator: globalItems.checkSendEmail,
                    },
                  },
                })
                .then(
                  function (response) {
                    if (
                      typeof response.answer != "undefined" &&
                      response.answer == "update"
                    ) {
                      clearWaitingIfNeeded(globalItems).then(function () {
                        finalstatuschange(globalItems).then(function (res) {
                          hitRequest.response = res;
                          defer.resolve(hitRequest);
                        });
                      }, function () {
                        defer.resolve(notHitRequest);
                      });
                    }
                  },
                  function () {
                    defer.resolve(notHitRequest);
                  }
                );
            }
          }
        }
        }

        return defer.promise;
      }

      /**
       * Clear Waiting for Room flag before a real status change.
       * Functionally Waiting maps to Active; display only shows Waiting for Room.
       */
      function clearWaitingIfNeeded(globalValues) {
        if (!globalValues || !globalValues.isWaiting) {
          return $q.resolve(true);
        }

        return eCommerceService
          .setWaitingStatus({
            confirmation_number: globalValues.confirmation_number,
            waiting: 0,
          })
          .then(function (response) {
            if (response && response.success) {
              globalValues.isWaiting = false;
              globalValues.displayOldStatus = globalValues.oldStatus;
              return true;
            }

            toastMessage.showSimpleToast(
              (response && response.errorMsg) ||
                "Unable to update Waiting for Room status.",
              "error-toast"
            );
            return $q.reject(response);
          }, function () {
            toastMessage.showSimpleToast(
              "Unable to update Waiting for Room status.",
              "error-toast"
            );
            return $q.reject();
          });
      }

      /**
       * @param: Object globalValues
       * @return: Boolean
       * Comment: Change the status of reservation to checkin, checkout or closed
       */
      function finalstatuschange(globalValues) {
        var defered = $q.defer();
        $mdDialog.hide();
        changeReservationStatus({
          reservation_id: globalValues.reservation_id,
          room_stay_status: globalValues.newStatus,
          oldStatus: globalValues.oldStatus,
          confirmation_number: globalValues.confirmation_number,
          sendEmail: globalValues.checkSendEmail,
          location: globalValues.fromPage,
          product_id:
            globalValues.product_id != undefined ? globalValues.product_id : 0,
        }).then(function (response) {
          if (response.success) {
            if (
              response.hasOwnProperty("mail_error") &&
              response.mail_error &&
              response.errorMsg != ""
            ) {
              toastMessage.showSimpleToast(response.errorMsg, "error-toast");
            }
          } else {
            toastMessage.showSimpleToast(response.errorMsg, "error-toast");
          }
          defered.resolve(response);
        });
        return defered.promise;
      }

      /**
       * @param: String type (boat, rent or room)
       * @param: String confirmationNumber
       * @param: Integer reservationId
       * @return: Boolean
       * Comment: Redirect the user to the reservation detail page for rent, boat or room
       */
      function redirectToResvPage(type, confirmationNumber, reservationId) {
        var url;
        var params = {
          id: reservationId,
          confirmation_number: confirmationNumber,
        };

        if (type === "boat") {
          url = $state.href("app.e-commerce.boatOrders.detail", params);
        } else if (type === "rent") {
          url = $state.href("app.e-commerce.rentOrders.detail", params);
        } else {
          url = $state.href("app.e-commerce.orders.detail", params);
        }

        $window.open(url, "_blank");
      }

      function goToResvDetailPage(type, confirmationNumber, reservationId) {
        var stateName = "app.e-commerce.orders.detail";
        var params = {
          id: reservationId,
          confirmation_number: confirmationNumber,
        };

        if (type === "boat") {
          stateName = "app.e-commerce.boatOrders.detail";
        } else if (type === "rent") {
          stateName = "app.e-commerce.rentOrders.detail";
        }

        $state.go(stateName, params);
      }

      function openBorrowedItemsDialog(value, $event) {
        if ($localStorage && $localStorage.hotelgeneralsetting && $localStorage.hotelgeneralsetting.enableBorrowedItems !== '1') {
          return $q.when();
        }
        if (!value || !value.confirmation_number) {
          return $q.when();
        }

        if ($event) {
          $event.stopPropagation();
          $event.preventDefault();
        }

        return $mdDialog.show({
          controller: "BorrowedItemsController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/dashboards/modified-gantt-chart/dialogs/borrowed-items/borrowed-items.html",
          parent: angular.element(document.body),
          targetEvent: $event,
          clickOutsideToClose: true,
          locals: {
            value: value,
            dashboardGraphService: dashboardGraphService,
            toastMessage: toastMessage,
          },
        });
      }

      /**
       * @param: Object data
       * @return: Json Object
       * Comment: Get reservations, hold and block for single room
       */
      function getGanttSingleRoomData(data) {
        return $http({
          url: EnvironmentConfig.api + "Dashboard/getGanttSingleRoomData",
          method: "POST",
          data: data,
        })
          .then(getDataComplete)
          .catch(getDataFailed);
      }

      return {
        getGanttData: getGanttData,
        getGanttTooltipData: getGanttTooltipData,
        setRoomCleanStatus: setRoomCleanStatus,
        savecommentofRes: savecommentofRes,
        getProductPriceData: getProductPriceData,
        checkAvailabilityForDates: checkAvailabilityForDates,
        removeHoldBlockDates: removeHoldBlockDates,
        getModifiedOrder: getModifiedOrder,
        saveModifiedOrder: saveModifiedOrder,
        saveModifiedReservation: saveModifiedReservation,
        setSortOrder: setSortOrder,
        saveHoldBlockDates: saveHoldBlockDates,
        getCancelOrderData: getCancelOrderData,
        cancelOrder: cancelOrder,
        changeStatusForService: changeStatusForService,
        loadRoomMovedOrderInfoForCancel: loadRoomMovedOrderInfoForCancel,
        changeReservationStatus: changeReservationStatus,
        getRoomDescription: getRoomDescription,
        fetchRemainingAmount: fetchRemainingAmount,
        processStatusRequest: processStatusRequest,
        blockCheckoutIfBorrowedItems: blockCheckoutIfBorrowedItems,
        openBorrowedItemsDialog: openBorrowedItemsDialog,
        finalstatuschange: finalstatuschange,
        redirectToResvPage: redirectToResvPage,
        getGanttSingleRoomData: getGanttSingleRoomData,
      };
    }
  );

(function ()
{
    'use strict';
    angular.module('app.dashboards.gantt-chart')
        .controller('confirmPageController', confirmPageController);
    /** @ngInject */
    function confirmPageController($mdDialog, title, htmlContent, btnTxt, cancelTxt, localData)
    {
        var vm = this;
        var buttonBaseClass = 'md-raised md-accent submit-button grey-100-fg ';
        var invertButtonColors;

        localData = localData || {};
        invertButtonColors = !!localData.invertButtonColors;

        vm.title = title;
        vm.btnTxt = btnTxt;
        vm.cancelTxt = cancelTxt || 'Cancel';
        vm.cancelBtnClass = buttonBaseClass + (invertButtonColors ? 'md-green-500-bg' : 'md-red-500-bg');
        vm.confirmBtnClass = buttonBaseClass + (invertButtonColors ? 'md-red-500-bg' : 'md-green-500-bg');

        if(localData.newStatus){
			vm.newStatus = localData.newStatus;
			vm.send_email_indicator = localData.send_email_indicator;
		}else{
			vm.newStatus = '';
			vm.send_email_indicator = 0;
		}
        if(vm.title == 'DoNotMove Reservation'){
            vm.btnTxt = 'Ok';
        }
        vm.htmlContent = htmlContent;
        vm.closeDialog = closeDialog;
        function closeDialog(){
             $mdDialog.cancel();
        }
        vm.hideDialog = hideDialog;
        function hideDialog(){
            $mdDialog.hide({'answer' : 'update','email_indicator' : vm.send_email_indicator});
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app.dashboards')
        .controller('HousekeepingPortletController', HousekeepingPortletController);

    /** @ngInject */
    function HousekeepingPortletController($window,$scope,$sessionStorage,$state,$mdDialog,reservationDetails, $localStorage, $rootScope, EnvironmentConfig,$http,$q) {
        var vm = this;
        vm.title = 'Reservations';
        $scope.paginatorCallback = paginatorCallback;
        $scope.LoadAllData = LoadAllData;
        $scope.getLoadResultsCallback = getLoadResultsCallback;

        /*********************************/
        /**** Paginate Room type data ****/
        /*********************************/
        $scope.selectedRowCallback = function(rows, id) {
            vm.selectedProdIds = rows;
        };

        function getLoadResultsCallback(loadPageCallback) {
            loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
        }
        vm.UserColumns = ['itinerary_number','confirmation_number','product_name','product_room_number','reservation_created_date','customer_name','room_stay_status','room_stay_from','room_stay_to','source_of_creation','created_by_user'];

        vm.onLoad = true;
        vm.requestGoing = false;
        function paginatorCallback(page, pageSize, option) {
            if(vm.requestGoing) return;
            if(vm.onLoad == true){
                if(typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] != 'undefined'){

                    var page1 =  $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
                    var pageSize1 = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'];
                    vm.onLoad = false;
                    return LoadAllData(page1, pageSize1,option);
                }else{
                    vm.onLoad = false;
                    return LoadAllData(page, pageSize,option);      
                }
            }else{
                if(typeof page == 'undefined'){
                    page = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
                }
                return LoadAllData(page, pageSize,option);
            }
        }
        function LoadAllData(page, pageSize,option){
            vm.requestGoing = true;
            var pageDetail = {'currentPage':page,'pageSize':pageSize};
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = pageDetail;
            vm.page = page;
            vm.pageSize = pageSize;
            vm.checkDelete = false;
            vm.selectedProdIds = [];
            vm.search = [];
            var filtersApplied = option.columnFilter;
            console.log(filtersApplied);
            angular.forEach(filtersApplied, function(filter,key) {
              if(key == 4 && filter.length > 0){
                filter = moment(filter[0]).format('YYYY-MM-DD');
                this.push('created_date:'+filter);
              }else if(key == 6 && filter.length > 0){
                this.push('room_stay_status:'+filter[0].name);
              }else if(key == 7 && filter.length > 0){
                filter = moment(filter[0]).format('YYYY-MM-DD');
                this.push('room_stay_from:'+filter);
              }else if(key == 8 && filter.length > 0){
                filter = moment(filter[0]).format('YYYY-MM-DD');
                this.push('room_stay_to:'+filter);
              }else{
                if(filter.length > 0 && filter[0].name != 'All'){
                  this.push(filter[0].fieldValue + ':' + filter[0].name);
                }
              }
            }, vm.search);
            var sort = {};
            for(var i=0; i<option.columnSort.length; i++){
                if(option.columnSort[i]['sort']){
                    sort['column']= vm.UserColumns[i];
                    sort['order']= option.columnSort[i]['sort'];
                }
            }

            var offset = (page-1) * pageSize;
            var filterData = {'offset':offset , 'pageSize': pageSize, 'search':$scope.filterText , 'sort':sort, 'customSearch':vm.search};
            vm.filterData = filterData;
            return $http({
                url: EnvironmentConfig.api + 'DashboardGraph/getHousekeepingReservations/',
                method: 'POST',
                data:{'filterData':filterData,'data':reservationDetails}
            }).then(function(result) {
                vm.requestGoing = false;
                vm.totalReservations = result.data.length;
                return {results : result.data,
                        totalResultCount: result.data.length};
                // if (result.data.status === 'success') {
                //     vm.activities = result.data.data.activities;
                //     vm.totalActivities = result.data.data.totalActivities;
                //     return {
                //         results: result.data.data.activities,
                //         totalResultCount: result.data.data.totalActivities
                //     }
                // } else {
                //     toastMessage.showSimpleToast(result.data.errorMsg, 'error-toast');
                // }
            });
        }

        var loadPageCallbackWithDebounce;
        $scope.$watch('filterText', function() {
            if (loadPageCallbackWithDebounce) {
                loadPageCallbackWithDebounce();
            }
        });

        /*********************************/
        /******* Edit Activity **********/
        /*********************************/
        $scope.goToEditPage = function(value) {
          value = value.split("-");
          var url = $state.href("app.e-commerce.orders.detail",{id:value[0],confirmation_number:value[1]});
          $window.open(url, '_blank');
      
        };
        var loadPageCallbackWithDebounce;
        $scope.statusValuesCallback = statusValuesCallback;
        $scope.statusValuesTransformer = statusValuesTransformer;
        function statusValuesCallback(){
          return $q.resolve([
          {
            name: 'All',fieldValue: 'room_stay_status'
          }, {
            name: 'Checked-In',fieldValue: 'room_stay_status'
          }, {
            name: 'Checked-Out',fieldValue: 'room_stay_status'
          }, {
            name: 'Closed',fieldValue: 'room_stay_status'
          }, {
            name: 'Active',fieldValue: 'room_stay_status'
          }, {
            name: 'Canceled',fieldValue: 'room_stay_status'
          }]);
        }
        $scope.createdValuesCallback = createdValuesCallback;
        $scope.checkinValuesCallback = checkinValuesCallback;
        $scope.checkoutValuesCallback = checkoutValuesCallback;
        function createdValuesCallback(){
          return $q.resolve('created_date');
        }
        function checkinValuesCallback(){
          return $q.resolve('room_stay_from');
        }
        function checkoutValuesCallback(){
          return $q.resolve('room_stay_to');
        }
        function statusValuesTransformer(statusObject){
          return statusObject.name;
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.dashboards')
        .controller('HousekeepingDashboardController', HousekeepingDashboardController);

    /** @ngInject */
    function HousekeepingDashboardController(
        $scope,
        $timeout,
        dashboardGraphService,
        dashHousekeepingDetails,
        $mdDateRangePicker,
        $rootScope,
        $localStorage,
        $sessionStorage,
        $state,
        $window,
        $mdDialog,
        toastMessage,
        todoService,
        $document,
        ganttChartService
    )
    {
        var vm = this;
        vm.routePermissions = $rootScope.userPermissions.split(',');
        vm.checkInCheckout = ['Check In', 'Check Out'];
        vm.dashboardData = (dashHousekeepingDetails != undefined) ? dashHousekeepingDetails : {};
        vm.tabsHeading = 'Dashboard';
        var args = '';
        vm.showPortlets = false;
        vm.floorOnePlan = {
            'room_1'  : {'room_num' : '116', 'room_status' : 'clean' },
            'room_2'  : {'room_num' : '123', 'room_status' : 'light-clean' },
            'room_3'  : {'room_num' : '124', 'room_status' : 'dirty' },
            'room_4'  : {'room_num' : '133', 'room_status' : 'clean' },
            'room_5'  : {'room_num' : '134', 'room_status' : 'clean' },
            'room_6'  : {'room_num' : '135', 'room_status' : 'clean' },
            'room_7'  : {'room_num' : '136', 'room_status' : 'clean' },
            'room_8'  : {'room_num' : '137', 'room_status' : 'clean' },
            'room_9'  : {'room_num' : '129', 'room_status' : 'dirty' },
            'room_10' : {'room_num' : '138', 'room_status' : 'clean' },
            'room_11' : {'room_num' : '127', 'room_status' : 'clean' },
            'room_12' : {'room_num' : '128', 'room_status' : 'clean' },
            'room_13' : {'room_num' : '141', 'room_status' : 'clean' },
            'room_14' : {'room_num' : '142', 'room_status' : 'clean' },
            'room_15' : {'room_num' : '143', 'room_status' : 'light-clean' },
            'room_16' : {'room_num' : '144', 'room_status' : 'clean' },
        };
        vm.floorTwoPlan = {
            'room_1'  : {'room_num' : '201', 'room_status' : 'clean' },
            'room_2'  : {'room_num' : '202', 'room_status' : 'light-clean' },
            'room_3'  : {'room_num' : '203', 'room_status' : 'light-clean' },
            'room_4'  : {'room_num' : '204', 'room_status' : 'clean' },
            'room_5'  : {'room_num' : '205', 'room_status' : 'clean' },
            'room_6'  : {'room_num' : '206', 'room_status' : 'dirty' },
            'room_7'  : {'room_num' : '207', 'room_status' : 'clean' },
            'room_8'  : {'room_num' : '208', 'room_status' : 'clean' },
            'room_9'  : {'room_num' : '209', 'room_status' : 'dirty' },
            'room_10' : {'room_num' : '210', 'room_status' : 'clean' },
            'room_11' : {'room_num' : '211', 'room_status' : 'clean' },
            'room_12' : {'room_num' : '212', 'room_status' : 'clean' },
            'room_13' : {'room_num' : '213', 'room_status' : 'clean' },
            'room_14' : {'room_num' : '214', 'room_status' : 'clean' },
            'room_15' : {'room_num' : '215', 'room_status' : 'clean' },
            'room_16' : {'room_num' : '216', 'room_status' : 'clean' },
        };
        vm.floorThreePlan = {
            'room_1'  : {'room_num' : '301', 'room_status' : 'dirty' },
            'room_2'  : {'room_num' : '302', 'room_status' : 'clean' },
            'room_3'  : {'room_num' : '303', 'room_status' : 'clean' },
            'room_4'  : {'room_num' : '304', 'room_status' : 'clean' },
            'room_5'  : {'room_num' : '305', 'room_status' : 'clean' },
            'room_6'  : {'room_num' : '306', 'room_status' : 'clean' },
            'room_7'  : {'room_num' : '307', 'room_status' : 'clean' },
            'room_8'  : {'room_num' : '308', 'room_status' : 'clean' },
            'room_9'  : {'room_num' : '309', 'room_status' : 'light-clean' },
            'room_10' : {'room_num' : '310', 'room_status' : 'clean' },
            'room_11' : {'room_num' : '311', 'room_status' : 'clean' },
            'room_12' : {'room_num' : '312', 'room_status' : 'clean' },
            'room_13' : {'room_num' : '313', 'room_status' : 'clean' },
            'room_14' : {'room_num' : '314', 'room_status' : 'clean' },
            'room_15' : {'room_num' : '315', 'room_status' : 'clean' },
            'room_16' : {'room_num' : '316', 'room_status' : 'clean' },
        };
        vm.floorFourPlan = {
            'room_1'  : {'room_num' : '401', 'room_status' : 'light-clean' },
            'room_2'  : {'room_num' : '402', 'room_status' : 'dirty' },
            'room_3'  : {'room_num' : '403', 'room_status' : 'dirty' },
            'room_4'  : {'room_num' : '404', 'room_status' : 'clean' },
            'room_5'  : {'room_num' : '405', 'room_status' : 'clean' },
            'room_6'  : {'room_num' : '406', 'room_status' : 'clean' },
            'room_7'  : {'room_num' : '407', 'room_status' : 'clean' },
            'room_8'  : {'room_num' : '408', 'room_status' : 'clean' },
            'room_9'  : {'room_num' : '409', 'room_status' : 'dirty' },
            'room_10' : {'room_num' : '410', 'room_status' : 'clean' },
            'room_11' : {'room_num' : '411', 'room_status' : 'clean' },
            'room_12' : {'room_num' : '412', 'room_status' : 'clean' },
            'room_13' : {'room_num' : '413', 'room_status' : 'clean' },
            'room_14' : {'room_num' : '414', 'room_status' : 'clean' },
            'room_15' : {'room_num' : '415', 'room_status' : 'dirty' },
            'room_16' : {'room_num' : '416', 'room_status' : 'dirty' },
        };
        vm.floorPlan = vm.floorOnePlan;
        vm.selectedFloor = 1;
        vm.loadRemHtml = vm.taskStatusLoader = vm.resDetailsLoader = vm.taskStatusExist = vm.inHouseCustomerLoader = vm.roomStatusLoader = false;
        vm.currentTabValue = 'check_in';
        vm.portletTabs = [
            {'tabName': 'Check In', 'value': 'check_in'},
            {'tabName': 'Check Out', 'value': 'check_out'},
            {'tabName': 'Stay Over', 'value': 'stayovers'}
        ];
        vm.taskStatusPieChart = vm.currentReservations = vm.detailedRes = vm.dateRange = vm.dateArray = {};
        vm.activeRes = [];
        vm.activeIndex = 0;

        if(vm.routePermissions.indexOf('housekeeping-dashboard') != -1) {
            vm.selectedTab = 'dashboard';
        } else if (vm.routePermissions.indexOf('tasks') != -1) {
            vm.selectedTab = 'todo';
        }
        vm.portletloader = true;
        vm.outlookDatePickerOpen = false;
        vm.minDate = moment().startOf('day').toDate();
        if ($sessionStorage['housekeeping_outlook_start_date']) {
            var savedOutlook = $rootScope.convertDateIntoArray($sessionStorage['housekeeping_outlook_start_date']);
            vm.outlookStartDate = new Date(savedOutlook[0], savedOutlook[1], savedOutlook[2]);
        } else {
            vm.outlookStartDate = moment().startOf('day').toDate();
        }
        if (vm.outlookStartDate < vm.minDate) {
            vm.outlookStartDate = vm.minDate;
        }
        vm.selectTab = function(tab) {
            vm.selectedTab = tab;
        };

        angular.element(function () {
            $timeout(function() {
                vm.loadRemHtml = true;
                vm.fetchLatestData();
            }, 400);
        });

        var dateConv = [];
        if($localStorage['housekeeping_dashboard_dates'] != undefined && $localStorage['housekeeping_dashboard_dates'].dateStart != undefined && $localStorage['housekeeping_dashboard_dates'].dateStart != '') {
            dateConv = $rootScope.convertDateIntoArray($localStorage.housekeeping_dashboard_dates.dateStart);
            vm.dateRange.dateStart = new Date(dateConv[0], dateConv[1], dateConv[2]);
            dateConv = $rootScope.convertDateIntoArray($localStorage.housekeeping_dashboard_dates.dateEnd);
            vm.dateRange.dateEnd = new Date(dateConv[0], dateConv[1], dateConv[2]);            
        } else {
            var currentDate = new Date();
            var yesterday = new Date(currentDate);
            yesterday.setDate(currentDate.getDate() - 1);
            vm.dateRange = {
                dateStart : currentDate,
                dateEnd   : yesterday
            }
        }

        /*
        ** Redirrect to reservations listing page on click of checkin/checkout portlet
        */
        vm.checkInCheckoutClicket = function(reqtype, reservationType) {
            args = '';
            reqtype = (reqtype == 'Check In') ? 'check_in' : 'check_out';
            if(reservationType === 'boat') {
                args = "marina="+reqtype;
            } else {
                args = "reservation="+reqtype;
            }

            var url = $state.href("app.graphDetail",{ param:args, type:true }, { reload: true });
            $window.open(url, '_blank');
        };

        /*
        ** Handler on select of date range picker
        */
        vm.mdDateRangeHandler = function(dates) {
            var selectedDates = {};
            selectedDates = {
                dateStart : moment(vm.dateRange.dateStart).format('YYYY-MM-DD'),
                dateEnd : moment(vm.dateRange.dateEnd).format('YYYY-MM-DD')
            }
            $localStorage['housekeeping_dashboard_dates'] = selectedDates;
            // vm.updateTempData();
            vm.fetchLatestData();
        }

        /**
        * Reload all section to fetch fresh data
        */
        vm.fetchLatestData = function() {
            vm.dateArray = {
                startDate: moment(vm.dateRange.dateStart).format('YYYY-MM-DD'),
                endDate: moment(vm.dateRange.dateEnd).format('YYYY-MM-DD'),
            };
            vm.showLoaders();
            // vm.fetchTaskStatus();
            vm.getReservationDetails('check_in');
            vm.inHouseCustomers();
            vm.roomStatus();
        }

        /*
        ** Set all loader status to true
        */
        vm.showLoaders = function() {
            vm.taskStatusLoader = true;
            vm.resDetailsLoader = true;
            vm.inHouseCustomerLoader = true;
            vm.roomStatusLoader = true;
            vm.roomStatusExist = true;
        };

        /*
        ** Fetch data for task
        */
        vm.fetchTaskStatus = function() {
            dashboardGraphService.taskStatusPieChart(vm.dateArray)
                .then(function(response) {
                if(response.tasksCount !== undefined && response.tasksCount.total != undefined && parseInt(response.tasksCount.total) > 0) {
                    vm.taskStatusData = response.tasksCount;
                    vm.taskStatusChart = [
                        ['Assigned', parseInt(response.tasksCount.assigned)],
                        ['Unassigned', parseInt(response.tasksCount.unassigned)],
                        ['Inprogress', parseInt(response.tasksCount.inprogress)],
                        ['Completed', parseInt(response.tasksCount.completed)]
                    ];

                    $scope.taskStatusConfig = {                       
                        colors: ['#24BCD1', '#FF5861', '#607D8B', '#4CB050'],
                        chart: {
                            plotBackgroundColor: null,
                            plotBorderWidth: 0,
                            plotShadow: false,
                            height: "190px",
                            redraw: true
                        },
                         credits: {
                            enabled: false
                        },
                        title: {
                            text: '',
                            align: 'left',
                            verticalAlign: 'left',
                            y: 5
                        },
                        plotOptions: {
                            pie: {
                                allowPointSelect: true,
                                slicedOffset: 0,
                                cursor: 'pointer',
                                dataLabels: {
                                    enabled: false,
                                    distance: -50,
                                    style: {
                                        color: 'black'
                                    }
                                },                                
                                center: ['50%', '50%'],
                                events: {
                                    click: function (event) {
                                        vm.showFilteredTasks(event.point.name);
                                    }
                                }
                            }
                        },
                        tooltip: {
                            formatter: function () {
                                return '<span><b>' + this.point.name + '</b></span>: ' + this.point.y;
                            }
                        },
                        series: [{
                            type: 'pie',
                            name: '',
                            innerSize: '50%',
                            data: vm.taskStatusChart
                        }]
                    };
                    vm.taskStatusExist = true;                    
                } else {
                    vm.taskStatusExist = false;
                }
                vm.taskStatusLoader = false;
            });
        }

        /**
        ** Move to task page on click
        */
        vm.showFilteredTasks = function(event, count) {
            console.log("event : ",event);
            console.log("count : ",count);
            var taskStatus = event.replace(/ /g,"_");
            args = "taskStatus="+taskStatus;
            console.log(args);
            if(count == undefined || (count != undefined && count > 0)) {
                var url = $state.href('app.to-do',{ param:args, type:true }, { reload: true });
                $window.open(url, '_blank');
            }
        };

        /*
        ** Fetch reservation details with thier cleanliness status as well task details
        */
        vm.getReservationDetails = function(type) {
            vm.currentTabValue = type;
            vm.resDetailsLoader = true;
            vm.currentReservations = {};
            dashboardGraphService.getReservations({'dateArray' : vm.dateArray, 'type' : type}).then(function(response) {
                if(response.reservations != undefined) {
                    vm.currentReservations = response.reservations;
                    // console.log(vm.currentReservations);
                    vm.resDetailsLoader = false;
                    if(response.reservations.length > 0 && response.reservations[0] != undefined) {
                        vm.showReservationDetails(response.reservations[0], 0);
                    } else {
                        vm.detailedRes = [];
                    }
                }
            });
        }

        vm.showInhouseCustomers= function(type,date,subhotel_id){
            var param ='reservations';
            var url = $state.href("app.housekeeping-portlet",{param:param, type: type,date:date,subhotel_id:subhotel_id},{reload:true});
            $window.open(url, '_blank'); 
        }
        vm.getArrivalDepartureData=function(){
            if (vm.outlookStartDate < vm.minDate) {
                vm.outlookStartDate = vm.minDate;
            }
            vm.portletloader = true;

            var startDate = moment(vm.outlookStartDate || new Date()).format('YYYY-MM-DD');
            $sessionStorage['housekeeping_outlook_start_date'] = startDate;
            dashboardGraphService.getArrivalDepartureData({startDate: startDate}).then(function(response) {
                if(response != undefined && response.data) {
                    vm.DatesData = response.data.dates || {};
                    vm.productData = response.data.housekeeperData || {};
                }
            }).finally(function() {
                vm.portletloader = false;
            });
        }

        vm.navigateOutlookDates = function(direction) {
            if (vm.portletloader) {
                return;
            }
            var currentDate = moment(vm.outlookStartDate || new Date());
            if (direction === 'prev') {
                if (vm.outlookStartDate <= vm.minDate) {
                    return;
                }
                var previousDate = currentDate.subtract(7, 'days').toDate();
                vm.outlookStartDate = previousDate < vm.minDate ? vm.minDate : previousDate;
            } else {
                vm.outlookStartDate = currentDate.add(7, 'days').toDate();
            }
            vm.getArrivalDepartureData();
        };

        vm.onOutlookDateChange = function() {
            if (!vm.outlookStartDate) {
                return;
            }
            vm.getArrivalDepartureData();
        };

        vm.getArrivalDepartureData();
        /*
        ** To show the details of selected reservation
        */
        vm.showReservationDetails = function(reservation, index) {
            vm.detailedRes = reservation;
            vm.activeRes = [];
            vm.activeRes[index] = true;
            vm.activeIndex = index;
        }

        /*
        ** To assign the task to the user
        */
        vm.assignTask = function(taskId) {
            todoService.getTaskDetail(taskId).then(function(response) {
                $mdDialog.show({
                    controller: 'HousekeepTaskDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/todo/dialogs/task/housekeep-dialog.html',
                    parent: angular.element($document.body),
                    // targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        data: response,
                        task_category: response.taskCategory,
                        type: (taskId === 0 || taskId === '') ? 'add' : 'edit',
                        selectedCategory: response.taskCategory
                    },
                    onRemoving:function(response){
                        // console.log("----- onRemoving ---- : ",response);
                    }
                }).then(function(response) {
                    if(response != undefined && response.from != 'close' && response.task != undefined) {
                        vm.getReservationDetails(vm.currentTabValue);
                        /*if(response.task.task_to_user != undefined && response.task.task_to_user.length > 0) {
                            vm.currentReservations[vm.activeIndex].task_to_user = vm.currentReservations[vm.activeIndex].assigned_to = '';
                            angular.forEach(response.task.task_to_user, function(taskUser , userKey){
                                vm.currentReservations[vm.activeIndex].task_to_user += taskUser.value + ',';
                                vm.currentReservations[vm.activeIndex].assigned_to  += taskUser.display + ',';
                            });
                            vm.currentReservations[vm.activeIndex].task_to_user = vm.currentReservations[vm.activeIndex].task_to_user.replace(/,\s*$/, "");
                            vm.currentReservations[vm.activeIndex].assigned_to  = vm.currentReservations[vm.activeIndex].assigned_to.replace(/,\s*$/, "");
                        }

                        if(response.task.inspection != undefined && response.task.inspection == "accepted") {
                            vm.currentReservations[vm.activeIndex].task_status = "--";
                            vm.currentReservations[vm.activeIndex].clean_status = "Clean";
                            vm.currentReservations[vm.activeIndex].product_is_clean = '1';
                            vm.currentReservations[vm.activeIndex].assigned_to = '';
                        } else if (response.task.inspection != undefined && response.task.inspection == "rejected") {
                            vm.currentReservations[vm.activeIndex].task_status = "undone";
                        }
                        console.log(vm.currentReservations[vm.activeIndex]);
                        vm.detailedRes = vm.currentReservations[vm.activeIndex];*/
                    }
                }).catch(function(error) {
                    // console.log('catch : ',error);
                });
            });
        }

        /*
        ** Listen to the emit when task is deleted from housekeep-dialog.controller.js
        */
        $rootScope.$on("updateTaskList", function(event, data){
            console.log("got here : ",data);
            console.log("vm.activeIndex  : ",vm.activeIndex);
            if(data.type != undefined && data.type == 'deleted' && data.task_id != undefined) {
                vm.currentReservations[vm.activeIndex].task_status  = "--";
                vm.currentReservations[vm.activeIndex].assigned_to  = '';
                vm.currentReservations[vm.activeIndex].task_to_user = '';
                vm.currentReservations[vm.activeIndex].task_id      = '';
            }
        });

        /*
        ** On select of floor
        */
        vm.selectFloor = function(floorNumber) {
            vm.selectedFloor = floorNumber;
            switch(parseInt(vm.selectedFloor)) {
                case 1 :   vm.floorPlan = vm.floorOnePlan;      break;
                case 2 :   vm.floorPlan = vm.floorTwoPlan;      break;
                case 3 :   vm.floorPlan = vm.floorThreePlan;    break;
                case 4 :   vm.floorPlan = vm.floorFourPlan;     break;
                default :  vm.floorPlan = vm.floorOnePlan;      break;
            }
        }

        /**
        * Get data for inhouse customers
        */
        vm.inHouseCustomers = function(sortColumn, sortType) {
            // console.log(vm.dateArray);
            var postData = vm.dateArray;
            postData.sortColumn  = (sortColumn != undefined && sortColumn != '') ? sortColumn : 'res.room_stay_from';
            postData.sortType    = (sortType != undefined && sortType != '') ? sortType : 'ASC';
            postData.typeFor     = 'room';

            dashboardGraphService.getInHouseCustomers(postData)
                .then(function(response) {
                    vm.inHouseCustomerLoader = false;
                    vm.todayInHouseCustomers = response.result;
            });
        };

        /*
        ** Sort columns in in-house portlet
        */
        vm.sortCustom = function(columnName, sortType){
            vm.inHouseCustomerLoader = true;
            var type = (sortType == "ASC" || sortType == "") ? "DESC" : "ASC";
            var sortColumn = '';
            vm.nameSortType = vm.badgeSortType = vm.roomSortType = vm.checkInSortType = vm.checkOutSortType = vm.guestSortType = vm.cleanSortType = '';
            vm.selectedColumn = columnName;
            switch(columnName){
                case 'name'                 : sortColumn = 'traveller.first_name';  vm.nameSortType         = type;     break;
                case 'cc_is_incidental'     : sortColumn = 'cc_is_incidental';      vm.badgeSortType        = type;     break;
                case 'product_name'         : sortColumn = 'product_name';          vm.roomSortType         = type;     break;
                case 'room_stay_from'       : sortColumn = 'res.room_stay_from';    vm.checkInSortType      = type;     break;
                case 'room_stay_to'         : sortColumn = 'res.room_stay_to';      vm.checkOutSortType     = type;     break;
                case 'guests'               : sortColumn = 'guests';                vm.guestSortType        = type;     break;
                case 'cleaning_status'      : sortColumn = 'product_is_clean';      vm.cleanSortType        = type;     break;
            }
            vm.inHouseCustomers(sortColumn, sortType);
        };

        /**
        * Open reservations page in new tab
        */
        vm.openReservationPage = function(resId) {
            var url = $state.href("app.e-commerce.orders.detail",{id:resId});
            $window.open(url, '_blank');
        };


        /*****************************************/
        /********* Room status graph chart********/
        /*****************************************/
        vm.pageFor = 'room';
        vm.roomStatus = function() {
            dashboardGraphService.roomStatusGraphChart({type: vm.pageFor})
                .then(function(response) {
                if(response.result !== undefined) {
                    vm.roomStatusPieChart = response.result;
                    vm.roomStatusChart = [
                        ['In Cleaning', parseInt(response.result.inCleaning)],
                        ['Available', parseInt(response.result.available)],
                        ['Out of Service', parseInt(response.result.outOfService)]
                    ];

                    $scope.roomStatusConfig = {                       
                        colors: ['#24BCD1', '#303540', '#FF5861'],
                        chart: {
                            plotBackgroundColor: null,
                            plotBorderWidth: 0,
                            plotShadow: false,
                            height: "300px",
                            redraw: true
                        },
                         credits: {
                            enabled: false
                        },
                        title: {
                            text: '',
                            align: 'left',
                            verticalAlign: 'left',
                            y: 5
                        },
                        plotOptions: {
                            pie: {
                                allowPointSelect: true,
                                slicedOffset: 0,
                                cursor: 'pointer',
                                dataLabels: {
                                    enabled: false,
                                    distance: -50,
                                    style: {
                                        color: 'black'
                                    }
                                },                                
                                center: ['50%', '50%'],
                                events: {
                                    click: function (event) {                                       
                                        vm.showRecordsWithFilter('room_status', event.point);
                                    }
                                }
                            }
                        },
                        tooltip: {
                            formatter: function () {
                                return '<span><b>' + this.point.name + '</b></span>: ' + this.point.y;
                            }
                        },
                        series: [{
                            type: 'pie',
                            name: '',
                            innerSize: '50%',
                            data: vm.roomStatusChart
                        }]
                    };                    
                } else {
                    vm.roomStatusExist = false;
                }
                vm.roomStatusLoader = false;
            });
        };

        /*
        ** OPen listing page in new tab for room status
        */
        vm.showRoomStatus = function(type, number) {
            var tempEvent = {
                name: type
            };

            if (number > 0) {
                vm.showRecordsWithFilter('room_status', tempEvent);
            }
        };

        /**
        * Move to listing page on click
        */
        vm.showRecordsWithFilter = function(type, event) {            
            switch(type) {
                case 'room_status':
                        var roomStatus = event.name.replace(/ /g,"_");
                        args = "roomStatus="+roomStatus;
                    break;

                default:
                    break;
            }

            // $state.go('app.graphDetail', { param:args, type:true }, { reload: true } );
            var url = $state.href('app.graphDetail',{ param:args, type:true }, { reload: true });
            $window.open(url, '_blank');
        };

        /*
        ** Toogle room cleaning status
        */
        vm.toggleCleaningStatus = function(event, index) {
            event.stopPropagation()
            var cleaningStatus = '1';
            var cleaningValue = '';
            switch(parseInt(vm.todayInHouseCustomers[index]['product_is_clean'])) {
                case 1 : cleaningStatus = '2' ; cleaningValue = 'Light Clean'; break;
                case 2 : cleaningStatus = '0' ; cleaningValue = 'Dirty'; break;
                case 0 : cleaningStatus = '1' ; cleaningValue = 'Clean'; break;
            }

            var html='Are you sure you want to mark the room as '+cleaningValue+'?';
            var title = "Change Cleaning Status";
            var event = '';
            $mdDialog.show({
                controller: 'confirmController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose:true ,
                locals: {
                    title: title,
                    htmlContent:html,
                    cancelBtn:'Cancel',
                    OkBtn:'Ok'
                }                
            }).then(function(answer) {
                if (typeof answer != 'undefined' && answer == 'update') {
                    var product_id = vm.todayInHouseCustomers[index]['product_id'];      
            
                    ganttChartService.setRoomCleanStatus({'isclean' : cleaningStatus,'product_id' : product_id}).then(function(response){
                        if(response.success){
                            vm.todayInHouseCustomers[index]['product_is_clean']  = cleaningStatus;
                            var task = {};
                            task.task_title       = vm.todayInHouseCustomers[index].rm+' needs to be cleaned';
                            task.task_product_id  = product_id;
                            task.source           = 'housekeeping-dashboard/change room status';
                            task.product_is_clean = cleaningStatus;
                            todoService.addTaskGanttChart(task).then(function(response){
                                vm.roomcleanstatus = '';
                            });  

                        } else if(response.errorMsg){
                            toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                        } else{
                            toastMessage.showSimpleToast('There was some error in saving clean status of this room.','error-toast');
                        }
                    });
                }
            }, function() {
                
            });          
        }
    }

})();
'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../category/categoryService
 * @description
 * # ../category/categoryService
 * Service in the minervaApp.
 */
angular.module('app.dashboards.gantt-chart')
  .service('ganttChartService', function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
 	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}
 	
 	function getGanttData(data){
 		// console.log(data);
		return $http({
			url:EnvironmentConfig.api+'Dashboard/view_dashboard',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
 	function getGanttTooltipData(data){
		return $http({
			url:EnvironmentConfig.api+'Dashboard/get_tooltip_data',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
 	function checkAvailabilityForDates(data){
		var payload = angular.copy(data) || {};
		if (payload.room_stay_from) {
			payload.room_stay_from = moment(payload.room_stay_from).format('YYYY-MM-DD');
		}
		if (payload.room_stay_to) {
			payload.room_stay_to = moment(payload.room_stay_to).format('YYYY-MM-DD');
		}
		return $http({
			url:EnvironmentConfig.api+'Dashboard/check_availabilty_for_dates',
			method:'POST',
			data:payload
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
 	function getModifiedOrder(data){
		return $http({
			url:EnvironmentConfig.api+'Dashboard/get_modified_order',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
 	function saveHoldBlockDates(data){
		return $http({
			url:EnvironmentConfig.api+'Dashboard/save_hold_block_dates',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
 	function saveModifiedOrder(data){
		return $http({
			url:EnvironmentConfig.api+'Dashboard/save_modified_order',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
 	function saveModifiedReservation(data){
		return $http({
			url:EnvironmentConfig.api+'Dashboard/save_modified_reservation',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
 	function setSortOrder(data){
		return $http({
			url:EnvironmentConfig.api+'Dashboard/set_sort_order',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
 	function removeHoldBlockDates(data){
		return $http({
			url:EnvironmentConfig.api+'Dashboard/remove_hold_block_dates',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
	
 	function changeReservationStatus(data){
		return $http({
			url:EnvironmentConfig.api+'Reservations/change_reservation_status',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
 	function getCancelOrderData(data){
		return $http({
			url:EnvironmentConfig.api+'Reservations/cancel_order_data',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
 	function cancelOrder(data){
		return $http({
			url:EnvironmentConfig.api+'Reservations/cancel_order',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
 	function changeStatusForService(data){
		return $http({
			url:EnvironmentConfig.api+'Reservations/change_services_status',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
 	function getProductPriceData(data){
		var payload = angular.copy(data) || {};
		// Stay dates must be calendar Y-m-d; Date/ISO Z shifts a day across timezones
		if (payload.room_stay_from) {
			payload.room_stay_from = moment(payload.room_stay_from).format('YYYY-MM-DD');
		}
		if (payload.room_stay_to) {
			payload.room_stay_to = moment(payload.room_stay_to).format('YYYY-MM-DD');
		}
		return $http({
			url:EnvironmentConfig.api+'Reservations/get_price_all_policies',
			method:'POST',
			data:payload
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
 	function loadRoomMovedOrderInfoForCancel(data){
		return $http({
			url:EnvironmentConfig.api+'Dashboard/load_rm_order_info_cancel',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function setRoomCleanStatus(data){
		return $http({
			url:EnvironmentConfig.api+'Product/setProductCleanStatus',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function savecommentofRes(data){
		return $http({
			url:EnvironmentConfig.api+'Dashboard/savecommentofRes',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getRoomDescription(data){
		return $http({
			url:EnvironmentConfig.api+'Dashboard/get_room_description',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function fetchRemainingAmount(confNo){
		return $http({
			url:EnvironmentConfig.api+'Dashboard/getRemainingAmount/'+confNo,
			method:'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
	
 	return{
 		getGanttData: getGanttData,
 		getGanttTooltipData: getGanttTooltipData,
 		setRoomCleanStatus: setRoomCleanStatus,
 		savecommentofRes: savecommentofRes,
 		getProductPriceData: getProductPriceData,
 		checkAvailabilityForDates: checkAvailabilityForDates,
 		removeHoldBlockDates: removeHoldBlockDates,
 		getModifiedOrder: getModifiedOrder,
 		saveModifiedOrder: saveModifiedOrder,
 		saveModifiedReservation: saveModifiedReservation,
 		setSortOrder: setSortOrder,
 		saveHoldBlockDates: saveHoldBlockDates,
 		getCancelOrderData: getCancelOrderData,
 		cancelOrder: cancelOrder,
 		changeStatusForService: changeStatusForService,
 		loadRoomMovedOrderInfoForCancel: loadRoomMovedOrderInfoForCancel,
 		changeReservationStatus: changeReservationStatus,
 		getRoomDescription:getRoomDescription,
 		fetchRemainingAmount: fetchRemainingAmount
 	}
 });

(function ()
{
    'use strict';

    angular.module('app.dashboards.gantt-chart')
        .controller('GanttChartController', GanttChartController);

    /** @ngInject */
    function GanttChartController(
        EnvironmentConfig,
        $mdDialog, 
        $document, 
        $animate, 
        toastMessage, 
        $scope, 
        $rootScope, 
        $timeout, 
        $compile, 
        ganttUtils, 
        GanttObjectModel, 
        ganttDebounce, 
        moment, 
        $window, 
        $mdSidenav, 
        msApi, 
        $localStorage, 
        ganttData,
        requestFor,
        ganttChartService, 
        $sessionStorage,
        todoService,
        $state,
        eCommerceService)
    {
        var vm = this;
        var objectModel;

        vm.ganttChartHeader = ['month', 'day'];
        vm.ganttScale = 'day';

        vm.room_type_count = [];
        if(typeof ganttData.room_counts != 'undefined'){
            vm.room_type_count = ganttData.room_counts;
        }

        vm.product_type_list = [];
        if(typeof ganttData.product_type_list != 'undefined'){
            vm.product_type_list = ganttData.product_type_list;
        }

        vm.pageType = 'room';
        if(typeof requestFor != 'undefined' && requestFor == 'boat'){
            vm.pageType = 'boat';
        }else if(typeof requestFor != 'undefined' && requestFor == 'rent'){
            vm.pageType = 'rent';
            vm.ganttChartHeader = ['year','month'];
            vm.ganttScale = 'year';
        }

		if (!ganttData.success && ganttData.errorMsg){
			vm.mainErrorMsg = ganttData.errorMsg;
		} else {
			vm.mainErrorMsg = false;
            vm.number_of_days = parseInt(ganttData.number_of_days) + parseInt(2) ;
            $rootScope.number_of_days = parseInt(ganttData.number_of_days) + parseInt(2);
		}

        vm.currentHotelId = $localStorage['preHotelId'];

        // vm.boatTypes = [{key: 'finger_pier', value: 'Finger Pier'}, {key: 'dingy_dock+sea_wall', value: 'Sea Wall Plus Dingy Dock'}];
        // Data
        vm.live = {};
        vm.enableReload = true;
        vm.myStyle = "";
        vm.scrollFrom = vm.scrollto = '';
        var date = new Date(), y = date.getFullYear(), m = date.getMonth(), d = date.getDay();
        var unixdateEnd=(moment(date).add(parseInt(vm.number_of_days), 'days').unix())*1000;
        var unixdatestart=(moment(date).subtract(2, 'days').unix())*1000;
		var dateTime=new Date(unixdatestart);
		var date_SS=dateTime.toISOString();
		var dateTime=new Date(unixdateEnd);
		var date_EE=dateTime.toISOString();
		var firstDay=new Date(date_SS);
		var lastDay=new Date(date_EE);
		vm.commit = false;
		vm.currenttask=[];
		vm.orderModifying = {};
		vm.userPermissions = $rootScope.userPermissions;
		vm.occupancyData = {};
		vm.requestgoing = false;
		vm.roomMovedOrderData = {};
		vm.policyData='';
        vm.lastTaskEvent = '';
        vm.roomInformation = '';
        vm.roomInformationHtml = '';
		var srceenwidth = $window.innerWidth;
		if(srceenwidth >= 3800){
			 if($rootScope.number_of_days >= 30){
                var zoomval=3.5;
            }else{
                var zoomval=4.5;
            }
		}else if(srceenwidth >= 3200 && srceenwidth < 3800){
            if($rootScope.number_of_days >= 30){
                var zoomval=3;
            }else{
                var zoomval=4;
            }			
		}else if(srceenwidth >= 3000 && srceenwidth < 3200){
			if($rootScope.number_of_days >= 30){
                var zoomval=2.5;
            }else{
                var zoomval=4.0;
            }
		}else if(srceenwidth > 2000 && srceenwidth < 3000){
            if($rootScope.number_of_days >= 30){
                var zoomval=2.0;
            }else{
                var zoomval=3.0;
            }
		}else if(srceenwidth > 1600 && srceenwidth <= 2000){
            if($rootScope.number_of_days >= 30){
                var zoomval=1.5;
            }else{
                var zoomval=2.0;
            }
		}else{
            if($rootScope.number_of_days >= 30){
                var zoomval=1;
            }else{
                var zoomval=1.5;
            }
		}

        if(typeof requestFor != 'undefined' && requestFor == 'rent'){
            zoomval=2.5;
        }
		$rootScope.customoption = 'yes';
		vm.maxheight=jQuery(window).height()-155;
		vm.isloading = false;
        vm.options = {
			headersFormats: {
			  'year': 'YYYY', 
			  'quarter': '[Q]Q YYYY', 
			  month: 'MMMM YYYY', 
			  week: function(column) {
				return column.date.format('MMM D [-]') + column.endDate.format('[ ]MMM D');
			  },
			  day: 'D:dd:M-D-YYYY', 
			  hour: 'H', 
			  minute:'HH:mm'
			},
            mode                    : 'custom',
            scale                   : vm.ganttScale,
            sortMode                : undefined,
            sideMode                : 'Tree',
            daily                   : false,
            maxHeight               : true,
            width                   : true,
            zoom                    : zoomval,
            rowSortable             : true,
            jsPlumbDefaults             : false,
            columns                 : ['model.name', 'from', 'to'],
            treeTableColumns        : ['from', 'to'],
            columnsHeaders          : {
                'model.name' : 'Rooms', 'from': 'From', 'to': 'To'
            },
            columnsClasses          : {
                'model.name': 'gantt-column-name',
                'from'      : 'gantt-column-from',
                'to'        : 'gantt-column-to'
            },
            columnsFormatters       : {
                'from': function (from)
                {
                    return angular.isDefined(from) ? from.format('lll') : undefined;
                },
                'to'  : function (to)
                {
                    return angular.isDefined(to) ? to.format('lll') : undefined;
                }
            },
            treeHeaderContent       : '',
            columnsHeaderContents   : {
                'model.name': '{{getHeader()}}',
                'from'      : '{{getHeader()}}',
                'to'        : '{{getHeader()}}'
            },
            autoExpand              : 'both',
            taskOutOfRange          : 'truncate',
            fromDate                : firstDay,
            toDate                  : lastDay,
            rowContentEnabled       : true,
            // rowContent              : '<div ng-if="row.model.is_sub_hotel == 1" class="icon-hotel right-hotel_gant"  title="hotel"/><div ng-if="row.model.product_is_clean==2 && row.model.is_walk != 1" class="icon-light-cleaning right-hotel_gant green-500-fg" ng-click="scope.triggerRoomClean(1,$event,row.model.id,row)" title="Light Clean"/><div ng-if="row.model.product_is_clean==1 && row.model.is_walk != 1" class="icon-check-circle right-hotel_gant green-500-fg" ng-click="scope.triggerRoomClean(0,$event,row.model.id,row)" title="clean"/><div ng-if="row.model.product_is_clean==0  && row.model.is_walk != 1" class="icon-broom right-hotel_gant red-A800-fg" ng-click="scope.triggerRoomClean(2,$event,row.model.id,row)" title="dirty"/><span>{{row.model.name}}<b ng-if="row.model.is_walk != 1"></b></span><span class="icon-information info-icon" ng-if="row.model.is_sub_hotel != 1 && row.model.is_walk !=  1"ng-click="scope.get_room_description($event,row.model.id,row)"></span> ',
            rowContent              : '<div ng-if="row.model.is_sub_hotel == 1" class="icon-hotel right-hotel_gant"  title="hotel"/><div ng-if="row.model.product_is_clean==2 && row.model.is_walk != 1" class="icon-light-cleaning right-hotel_gant green-500-fg" ng-click="scope.popupRoomClean(2,$event,row.model.id,row)" title="Light Clean"/><div ng-if="row.model.product_is_clean==1 && row.model.is_walk != 1" class="icon-check-circle right-hotel_gant green-500-fg" ng-click="scope.popupRoomClean(1,$event,row.model.id,row)" title="clean"/><div ng-if="row.model.product_is_clean==0  && row.model.is_walk != 1" class="icon-broom right-hotel_gant red-A800-fg" ng-click="scope.popupRoomClean(0,$event,row.model.id,row)" title="dirty"/><span>{{row.model.name}} <b style="font-weight:normal;font-size:14px;display:inline-block;" ng-if="row.model.boat_dimension">({{row.model.boat_dimension}})</b><b ng-if="row.model.is_walk != 1"></b></span><span class="icon-information info-icon" ng-if="row.model.is_sub_hotel != 1 && row.model.is_walk !=  1"ng-click="scope.get_room_description($event,row.model.id,row)"></span> ',
            taskContentEnabled      : true,
            taskContent             : '<i ng-if="task.model.name == \'New Reservation\'" class="gantt-task-edit-button icon-pencil s12 icon hiddendata"   aria-label="edit task"></i><span bind-html-compile="task.model.name"></span>',
            allowSideResizing       : false,
            labelsEnabled           : true,
            currentDate             : 'line',
            currentDateValue        : new Date(),
            draw                    : true,
            readOnly                : false,
            groupDisplayMode        : 'group',
            filterTask              : '',
            filterRow               : '',
           
            timeFrames              : {
                'day'    : {
                    start  : moment('8:00', 'HH:mm'),
                    end    : moment('20:00', 'HH:mm'),
                    working: false,
                    default: false
                },
                'noon'   : {
                    start  : moment('12:00', 'HH:mm'),
                    end    : moment('13:30', 'HH:mm'),
                    working: false,
                    default: false
                },
                'weekend': {
                    color:'#da7b3b'
                },
                'holiday': {
                    working: false,
                    color  : 'red',
                    classes: ['gantt-timeframe-holiday']
                }
            },
            dateFrames              : {
                'weekend'    : {
                    evaluator: function (date)
                    {
                        return date.isoWeekday() === 5 || date.isoWeekday() === 6;
                    },
                    targets  : ['weekend']
                },
                '11-november': {
                    evaluator: function (date)
                    {
                        return date.month() === 10 && date.date() === 11;
                    },
                    targets  : ['holiday']
                }
            },
            timeFramesWorkingMode   : 'hidden',
            timeFramesNonWorkingMode: 'visible',
            columnMagnet            : '15 minutes',
            timeFramesMagnet        : true,
            canDraw                 : function (event)
            {
                var isLeftMouseButton = event.button === 0 || event.button === 1;
                return vm.options.draw && !vm.options.readOnly && isLeftMouseButton;
            },
            drawTaskFactory         : function ()
            {
                return {
                    id   : ganttUtils.randomUuid(),  // Unique id of the task.
                    name : 'New Reservation', // Name shown on top of each task.
                    color: '#AA8833', // Color of the task in HEX format (Optional).
                    darkcolor: '#BCAAA4' // Color of the task in HEX format (Optional).
                };
            },
            api                     : function (ganttApi)
            {
                // API Object is used to control methods and events from angular-gantt.
                vm.api = ganttApi;
                vm.api.core.on.ready($scope, function ()
                {
					vm.api.tasks.on.add($scope, addEventName('tasks.on.add', logTaskEvent));
                    vm.api.tasks.on.change($scope, addEventName('tasks.on.change', logTaskEvent));
                    vm.api.tasks.on.rowChange($scope, addEventName('tasks.on.rowChange', logTaskEvent));
                    vm.api.tasks.on.remove($scope, addEventName('tasks.on.remove', logTaskEvent));

                    if (vm.api.tasks.on.moveBegin) {
                        vm.api.tasks.on.moveBegin($scope, addEventName('tasks.on.moveBegin', logTaskEvent));
                        //vm.api.tasks.on.move($scope, addEventName('tasks.on.move', logTaskEvent));
                        vm.api.tasks.on.moveEnd($scope, addEventName('tasks.on.moveEnd', logTaskEvent));

                        vm.api.tasks.on.resizeBegin($scope, addEventName('tasks.on.resizeBegin', logTaskEvent));
                        //vm.api.tasks.on.resize($scope, addEventName('tasks.on.resize', logTaskEvent));
                        vm.api.tasks.on.resizeEnd($scope, addEventName('tasks.on.resizeEnd', logTaskEvent));
                    }
                    // When gantt is ready, load data.
                    // `data` attribute could have been used too.
                    vm.load('graph');

                    // DOM events
                    jQuery("div.custom-menu").hide();
                    vm.api.directives.on.new($scope, function (directiveName, directiveScope, element)
                    {
                        /**
                         * Gantt Task
                         */
                        if ( directiveName === 'ganttTask' )
                        {
                            element.on('mousedown touchstart', function (event)
                            {
                                event.preventDefault();
                                event.stopPropagation();
                                vm.live.row = directiveScope.task.row.model;
                                if ( angular.isDefined(directiveScope.task.originalModel) )
                                {
                                    vm.live.task = directiveScope.task.originalModel;
                                }
                                else
                                {
                                    vm.live.task = directiveScope.task.model;
                                }
                                $scope.$digest();
                            });
                            element.on('contextmenu', function (event)
                            {
								event.preventDefault();
								vm.currenttask=directiveScope.task;
								if(vm.currenttask.model.type_of_reservation == 'hold'){
									var html='<div class="custom-menu"><md-menu-content width="2" class="pv-0"> ';
									  html+='     <md-menu-item>';
									  html+='              <md-button aria-label="View" ng-click="vm.editHoldDates(event)"  class="no-margin ph-16">';
									  html+='                  Edit';
									  html+='              </md-button>';
									  html+='          </md-menu-item>';
									  html+='          <md-menu-item>';
									  html+='              <md-button ng-click="vm.removeHoldBlockDates(\'hold\',event)" aria-label="Cancel">';
									  html+='                  Release';
									  html+='              </md-button>';
									  html+='          </md-menu-item>';
									  html+='     <md-menu-item>';
									  html+='              <md-button aria-label="Unblock" ng-click="vm.convertToRes(\'hold\',event)"  class="no-margin ph-16">';
									  html+='                  Create reservation';
									  html+='              </md-button>';
									  html+='          </md-menu-item>';
									  html+='          <md-menu-item>';
									  html+='              <md-button ng-click="vm.addcommentinorder(event)" aria-label="Add comment">';
									  html+='                  Note';
									  html+='              </md-button>';
									  html+='          </md-menu-item>';
									  html+='      </md-menu-content></div>';
								} else if(vm.currenttask.model.type_of_reservation == 'block'){
									var html='<div class="custom-menu"><md-menu-content width="2" class="pv-0"> ';
									  html+='     <md-menu-item>';
									  html+='              <md-button aria-label="Unblock" ng-click="vm.removeHoldBlockDates(\'block\',event)"  class="no-margin ph-16">';
									  html+='                  Unblock';
									  html+='              </md-button>';
									  html+='          </md-menu-item>';
									  html+='     <md-menu-item>';
									  html+='              <md-button aria-label="Unblock" ng-click="vm.convertToRes(\'block\',event)"  class="no-margin ph-16">';
									  html+='                  Create reservation';
									  html+='              </md-button>';
									  html+='          </md-menu-item>';
									  html+='          <md-menu-item>';
									  html+='              <md-button ng-click="vm.addcommentinorder(event)" aria-label="Add comment">';
									  html+='                  Note';
									  html+='              </md-button>';
									  html+='          </md-menu-item>';
									  html+='      </md-menu-content></div>';
								} else if(vm.currenttask.model.type_of_reservation == 'reservation' || vm.currenttask.model.type_of_reservation == 'boat' || vm.currenttask.model.type_of_reservation == 'rent' || vm.currenttask.model.type_of_reservation == 'day_reservation' ){
                                	var html='<div class="custom-menu"><md-menu-content width="2" class="pv-0"> ';
									  html+='          <md-menu-item>';
									  if(vm.currenttask.model.hasOwnProperty('room_confirmation_number') && vm.currenttask.model.room_confirmation_number != null )
										html+='              <md-button ng-click="vm.viewOrder('+vm.currenttask.model.reservation_id+',\''+vm.currenttask.model.room_confirmation_number+'\')" aria-label="Cancel">';
									  else
										html+='              <md-button ng-click="vm.viewOrder('+vm.currenttask.model.reservation_id+',\''+vm.currenttask.model.confirmation_number+'\')" aria-label="Cancel">';
									  html+='                  View';
									  html+='              </md-button>';
									  html+='          </md-menu-item>';
									  html+='          <md-menu-item>';
									  html+='              <md-button ng-click="vm.setWaitingForRoomFromGantt(event)" aria-label="Waiting for Room">';
									  html+='                  Waiting for Room';
									  html+='              </md-button>';
									  html+='          </md-menu-item>';
									  html+='          <md-menu-item>';
									  html+='              <md-button ng-click="statusDialog(event,\'Checked-In\','+vm.currenttask.model.RemainAmount+')" aria-label="Check In">';
									  html+='                  Check In';
									  html+='              </md-button>';
									  html+='          </md-menu-item>';
									  html+='          <md-menu-item>';
									  html+='              <md-button ng-click="statusDialog(event,\'Checked-Out\','+vm.currenttask.model.RemainAmount+')" aria-label="Check Out">';
									  html+='                  Check Out';
									  html+='              </md-button>';
									  html+='          </md-menu-item>';
									  html+='          <md-menu-item>';
									  html+='              <md-button ng-click="statusDialog(event,\'Canceled\',\'\')" aria-label="Cancel">';
									  html+='                  Cancel';
									  html+='              </md-button>';
									  html+='          </md-menu-item>';
									  html+='          <md-menu-item>';
									  html+='              <md-button ng-click="statusDialog(event,\'Closed\','+vm.currenttask.model.RemainAmount+')" aria-label="Close">';
									  html+='                  Close';
									  html+='              </md-button>';
									  html+='          </md-menu-item>';
									  html+='          <md-menu-item>';
									  html+='              <md-button ng-click="vm.addcommentinorder(event)" aria-label="Add comment">';
									  html+='                  Note';
									  html+='              </md-button>';
									  html+='          </md-menu-item>';
									  html+='      </md-menu-content></div>';
								  }
                                  jQuery('.custom-mnu-container').html('');
								angular.element(jQuery('.custom-mnu-container')).append($compile(html)($scope));
								jQuery('.custom-menu').css('top',event.pageY+"px");
								jQuery('.custom-menu').css('left',event.pageX+"px");
								if(!isScrolledIntoView(jQuery('.custom-menu'))){
									jQuery('.custom-menu').css('bottom',"14px");
									jQuery('.custom-menu').css('top',"auto");
									jQuery('.custom-menu').css('left',event.pageX+"px");
								}
							});

                        }

                        /**
                         * Gantt Row
                         */
                        else if ( directiveName === 'ganttRow' )
                        {

                            element.on('click', function (event)
                            {
                                event.stopPropagation();
                            });

                            element.on('mousedown touchstart', function (event)
                            {
                                event.stopPropagation();
                                vm.live.row = directiveScope.row.model;
                                $scope.$digest();
                            });

                        }

                        /**
                         * Gantt Row Label
                         */
                        else if ( directiveName === 'ganttRowLabel' )
                        {
                            // Fix for double trigger due to gantt-sortable plugin
                            element.off('click');

                            element.on('click', function (event)
                            {
                                event.preventDefault();
                                //~ editDialog(event, 'row', directiveScope.row);
                            });

                            element.on('mousedown touchstart', function ()
                            {
                                vm.live.row = directiveScope.row.model;
                                $scope.$digest();
                            });

                        }
                    });
					vm.api.tasks.on.resizeEnd($scope,function (task){
						if(task.model.name=='New Reservation'){
							vm.eventType='new';
							vm.roomName=task.row.model.name;
							$timeout(function ()
							{
								vm.isloading = true;
								vm.addReservation(task,vm.roomName,'create');
							},700);
						}else{
							vm.eventType='resize';
							vm.roomName=task.row.model
						}
					});
                    vm.api.tasks.on.rowChange($scope, function (task)
                    {
						vm.live.row = task.row.model;
						if(task.model.name!='New Reservation'){
							vm.lastTaskEvent = 'rowChange';
							vm.getOrderInfo(task,true);
						}
                    });
                    vm.api.tasks.on.resizeEnd($scope, function (task)
                    {
                        if(task.model.name!='New Reservation'){
							vm.lastTaskEvent = 'resizeEnd';
							vm.getOrderInfo(task,false);
						}
                    });
                    vm.api.tasks.on.moveEnd($scope, function (task)
                    {
                        if(task.model.name!='New Reservation' && vm.lastTaskEvent!='rowChange'){
							vm.lastTaskEvent = 'moveEnd';
							vm.getOrderInfo(task,false);
						}
                    });
                    vm.api.scroll.on.scroll($scope, function (left, date, direction){
						if(direction!='undefined')
							get_room_percent_this(vm.occupancyData);
					});

                    objectModel = new GanttObjectModel(vm.api);
                });

                vm.api.core.on.rendered($scope, function (){
                    console.log('rendered at', moment().format('YYYY-MM-DD HH:mm:ss'));
                });


               
                vm.api.rows.on.move($scope, function(row, oldIndex, newIndex){

                    // var tempNew = angular.copy(vm.data[newIndex]);
                    // vm.data.splice( newIndex, 1);
                    // vm.data.splice(oldIndex, 0, tempNew);

                    var error = false;
                    var isSJ = (typeof vm.currentHotelId != 'undefined' && (vm.currentHotelId == 126))? true : false;
                    var isPBR = (typeof vm.currentHotelId != 'undefined' && (vm.currentHotelId == 122))? true : false;
                    var isMT = (typeof vm.currentHotelId != 'undefined' && (vm.currentHotelId == 116))? true : false;
                    var error_msg = '';
                    
                    if(isSJ || isPBR || isMT){
                        if(isSJ){
                            if(vm.pageType == 'room'){
                                if(vm.product_type_list.length > 0 || Object.keys(vm.product_type_list).length > 0) {
                                    var pro_id = row.model.id;
                                    var pro_type = vm.product_type_list[pro_id];
                                    if(pro_type == 126 && (newIndex < vm.room_type_count['126']['start'] || newIndex > vm.room_type_count['126']['end']) ){
                                        error = true;
                                        error_msg = '126';
                                    }else if(pro_type == 'canal' && (newIndex < vm.room_type_count['canal']['start'] || newIndex > vm.room_type_count['canal']['end'])){
                                        error = true;
                                        error_msg = 'canal';
                                    }else if(pro_type == 'king' && (newIndex < vm.room_type_count['king']['start'] || newIndex > vm.room_type_count['king']['end'])){
                                        error = true;
                                        error_msg = 'king';
                                    }
                                }
                            }
                        }else if(isPBR){
                            if(vm.pageType == 'room'){
                                if(vm.product_type_list.length > 0 || Object.keys(vm.product_type_list).length > 0) {
                                    var pro_id = row.model.id;
                                    var pro_type = vm.product_type_list[pro_id];
                                    if(pro_type == 123 && (newIndex < vm.room_type_count['123']['start'] || newIndex > vm.room_type_count['123']['end']) ){
                                        error = true;
                                        error_msg = '126';
                                    }else if(pro_type == '124' && (newIndex < vm.room_type_count['124']['start'] || newIndex > vm.room_type_count['124']['end'])){
                                        error = true;
                                        error_msg = 'canal';
                                    }else if(pro_type == '125' && (newIndex < vm.room_type_count['125']['start'] || newIndex > vm.room_type_count['125']['end'])){
                                        error = true;
                                        error_msg = 'king';
                                    }
                                }
                            }
                        } else if(isMT){
                            if(vm.pageType == 'room'){
                                if(vm.product_type_list.length > 0 || Object.keys(vm.product_type_list).length > 0) {
                                    var pro_id = row.model.id;
                                    var pro_type = vm.product_type_list[pro_id];
                                    if(pro_type == 116 && (newIndex < vm.room_type_count['116']['start'] || newIndex > vm.room_type_count['116']['end']) ){
                                        error = true;
                                        error_msg = '116';
                                    }else if(pro_type == 'garden villa' && (newIndex < vm.room_type_count['garden villa']['start'] || newIndex > vm.room_type_count['garden villa']['end'])){
                                        error = true;
                                        error_msg = 'garden villa';
                                    }
                                }
                            }
                        }
                    }

                    if(error){
                        toastMessage.showSimpleToast('You cannot move one room type to another','warning-toast');
                        load('changeDate');
                    }else if(!error || (!isSJ && !isPBR && !isMT)){
                        var newsortOrder = [];     
                        angular.forEach(vm.data, function (value, key)
                        {
                            newsortOrder.push(value.id);
                        });					
    					ganttChartService.setSortOrder({'newsortOrder':newsortOrder}).then(function(response){
    						if(!response.success){
    							toastMessage.showSimpleToast('There was some error in saving sort order of rooms. Please try again later.','error-toast');
    						}
    					});
                    }
				});
            }
        };
        vm.isOpen = false;
		$scope.$watch('vm.isOpen', function(newValue, oldValue) {
			if (!newValue && oldValue) {
				document.querySelector('.md-datepicker-input').blur();
			}  
		});
        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.search = search;
        vm.setSortMode = setSortMode;
        vm.addDialog = addDialog;
        vm.addReservation = addReservation;
        vm.convertToRes = convertToRes;
        vm.changeStatusAfterPayment = changeStatusAfterPayment;
        //~ vm.editDialog = editDialog;
        vm.addcommentinorder = addcommentinorder;
        vm.viewOrder = viewOrder;
        vm.changeStatusWithoutPayment = changeStatusWithoutPayment;
        vm.canAutoWidth = canAutoWidth;
        vm.getColumnWidth = getColumnWidth;
        vm.load = load;
        vm.reload = reload;
        vm.removeHoldBlockDates = removeHoldBlockDates;
        vm.editHoldDates = editHoldDates;
        vm.getOrderInfo  = getOrderInfo;
        vm.saveReservation = saveReservation;
        vm.confirmEdit = confirmEdit;
		vm.sortByOccupancy = sortByOccupancy;
        //////////

        init();
        
        $scope.$on('cancel_modification', function(event) { 
			load('changeDate');
		});
        vm.task = {};
        vm.roomcleanstatus = '';
        $scope.popupRoomClean = function(isclean,ev,product_id,row){
            vm.roomcleanstatus = 1;
            vm.cleantype = isclean;
            vm.product_id = product_id;
            vm.row = row;
            var tooltipTop, tooltipBottom;
            var elementRect = row.$element[0].getBoundingClientRect();
            var tooltipArrowFromTop = true;
            var tooltipHeight;
            if(getViewPortWidth() >= 1800){
                tooltipHeight = 450;
            } else {
                tooltipHeight = 300;
            }
            if(parseInt(elementRect.top) + parseInt(tooltipHeight) > getViewPortHeight()){
                tooltipTop = "auto";
                tooltipBottom = (parseInt(getViewPortHeight()) - parseInt(elementRect.bottom) ) + "px";
                tooltipArrowFromTop = false;
            } else {
                tooltipTop = (parseInt(elementRect.top) - 64) + "px";
                tooltipBottom = "auto";
            }
            var divWidth = $(".gantt-row-label").width();
                var newDivWidth = parseInt(divWidth)-150;
                newDivWidth = newDivWidth+"px";
                if(!tooltipArrowFromTop){
                    $('head').append('<style>.popup_room_class{top:'+tooltipTop+';bottom:'+tooltipBottom+'}.popup_room_class{left:'+newDivWidth+'}.popup_room_class:before{top:auto !important;bottom:11px !important;}.popup_room_class:after{top:auto !important;bottom:10px;}</style>');
                } else {
                    $('head').append('<style>.popup_room_class{top:'+tooltipTop+';bottom:'+tooltipBottom+'}.popup_room_class{left:'+newDivWidth+'}.popup_room_class:before{top:11px !important;bottom:auto !important;}.popup_room_class:after{top:10px !important;bottom:auto;}</style>');
                }
        }

        $scope.triggerRoomClean = function(isclean,ev){
            var product_id = vm.product_id;
            var row = vm.row;         
            
			ganttChartService.setRoomCleanStatus({'isclean':isclean,'product_id':product_id}).then(function(response){
				if(response.success){
					row.model.product_is_clean = response.newstatus;
				}else if(response.errorMsg){
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				}else{
					toastMessage.showSimpleToast('There was some error in saving clean status of this room.','error-toast');
				}
			});

            // create task for room clean/dirty

            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth()+1; //January is 0!
            var yyyy = today.getFullYear();
            vm.Today = yyyy+'-'+mm+'-'+dd;
            vm.task['task_title'] = row.model.name+' needs to be cleaned';
            vm.task['task_product_id'] = product_id;
            vm.task['task_priority'] = 'higher';
            vm.task['task_start'] = vm.Today;
            vm.task['task_due_date'] = vm.Today;
            vm.task['source'] = 'gantt-chart';
            //21 vm.task['task_note'] = '<p></p>';
            vm.task['selectedTags'] = [];
            vm.task['task_to_user'] = 0;
            vm.task['task_category'] = 'housekeeping';
            vm.task['product_is_clean'] = isclean;
            vm.task['customMessage'] = true;             

            todoService.addTaskGanttChart(vm.task).then(function(response){
                vm.roomcleanstatus = '';
            }); 

            /*if(!isclean){
                todoService.addTask(vm.task).then(function(response){}); 
            } else {
                var data = {'source':'gantt-chart','task_product_id':product_id,'task_category':'maintainance'};
                todoService.updateTaskStatus(data).then(function(response){});
            }*/
           
             
		}
        
		jQuery(document).bind("click",function(event){jQuery("div.custom-menu").hide()});
        /**
         * Initialize
         */
        function init()
        {
            // Set Gantt Chart height at the init
            calculateHeight();

            angular.element($window).on('resize', function ()
            {
                $scope.$apply(function ()
                {
					var srceenwidth = $window.innerWidth;
					if(srceenwidth >= 3800){
						var zoomval=3.5;
					}else if(srceenwidth >= 3200 && srceenwidth < 3800){
						var zoomval=3;
					}else if(srceenwidth >= 3000 && srceenwidth < 3200){
						var zoomval=2.5;
					}else if(srceenwidth > 2000 && srceenwidth < 3000){
						var zoomval=2;
					}else if(srceenwidth > 1600 && srceenwidth <= 2000){
						var zoomval=1.5;
					}else{
						var zoomval=1;
					}
					vm.options.zoom = zoomval;
                    calculateHeight();
                });
            });
        }

        /**
         * Max Height Fix
         */
        function calculateHeight()
        {
            vm.options.maxHeight = $document.find('#chart-container').offsetHeight;
        }

        /**
         * Add New Row
         */
        function addDialog(ev)
        {
            $mdDialog.show({
                controller         : 'GanttChartAddEditDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/dashboards/gantt-chart/dialogs/add-edit/add-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: {
                        chartData : vm.data,
                        dialogType: 'add'
                    }
                }
            });
        }
        /**
         * Add New Reservation
         */
        function addReservation(ev,roomname,location)
        {

            // alert('Open pop');
            /*Make changes for boat and room */
			/*
			 * Check avaialable dates
			*/	
			var product_id = ev.row.model.id;
			var room_stay_from = moment(ev.model.from._d).format('YYYY-MM-DD');
			var room_stay_to = moment(ev.model.to._d).format('YYYY-MM-DD');
			if(room_stay_from == room_stay_to && ev.model.type_of_reservation !== 'day_reservation'){
				var targetRow = ev.row;
				targetRow.removeTask(ev.model.id, false, true);
				toastMessage.showSimpleToast('Check-in and check-out date cannot be same.','error-toast');
				vm.isloading = false;
				return false;
			}
			if(ev.model.confirmation_number){
				var confirmation_number = ev.model.confirmation_number;
			}else{
				var confirmation_number = '';
			}
			/* get policy wise rates*/
			
			ganttChartService.checkAvailabilityForDates(
                {
                    'product_id'           :product_id,
                    'room_stay_from'        :room_stay_from,
                    'room_stay_to'          :room_stay_to,
                    'confirmation_number'   :confirmation_number,
                    'type_of_reservation'   : ev.model.type_of_reservation || '',
                    'called_from'           :'BACK_END',
                    'requestFor'            : vm.pageType

                }).then(function(response){
				vm.isloading = false;
                var print = '';
                var dialogTitle = '';
				if(response.success ){
					if((response.mls_days && response.mls_days > 0) || (response.stop_sell && response.stop_sell=='yes')){
                        if(response.mls_days){
                            print =  ' MLS for '+response.mls_days+' nights';
                            dialogTitle =  'Minimum length of stay';
                        }
                        else{
                             print = ' Stop Sell';
                             dialogTitle = 'Stop Sell';
                         }
                        $mdDialog.show({
                            controller: 'confirmPageController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
                            parent: angular.element(document.body),
                            targetEvent: event,
                            clickOutsideToClose:true ,
                            locals: {
                                title: dialogTitle,
                                htmlContent:'Selected dates have'+print+'. Do you want to continue?',
                                btnTxt: 'Continue',
                                cancelTxt: 'Cancel',
                                localData: { invertButtonColors: true }
                            }                
                        }).then(function(response) {
                           
                            if(typeof response.answer != 'undefined' && response.answer == 'update'){
                                $mdDialog.show({
                                    controller         : 'optionCreatePlaceGantt',
                                    controllerAs       : 'vm',
                                    templateUrl        : 'app/main/apps/dashboards/gantt-chart/dialogs/option-place-on-gantt.html',
                                    parent             : angular.element($document.body),
                                    targetEvent        : ev,
									preserveScope		: true,
                                    clickOutsideToClose: true,
                                    locals             : {
                                        dialogData: {
                                            chartData : vm.data,
                                            thisnewcreateData : ev,
                                            thisroomname : roomname,
                                            policydetails : vm.policyData,
                                            locationres: location,
                                            requestFrom:vm.pageType
                                        },
                                        parentScope: $scope,
                                        mode_of_call: 'add'
                                    },
                                    onRemoving: function (event) {
										if($scope.reloaddashboard){
											load('changeDate');                         
										}
                                    }
                                });
                            }
                        }, function() {
                            load('changeDate');
                        });
                        // End for New Pop Up
					} else {

                        vm.data.pageType = vm.pageType;
						$mdDialog.show({
							controller         : 'optionCreatePlaceGantt',
							controllerAs       : 'vm',
							templateUrl        : 'app/main/apps/dashboards/gantt-chart/dialogs/option-place-on-gantt.html',
							parent             : angular.element($document.body),
							targetEvent        : ev,
							clickOutsideToClose: true,
							locals             : {
								dialogData: {
									chartData : vm.data,
									thisnewcreateData : ev,
									thisroomname : roomname,
									policydetails : vm.policyData,
									locationres: location,
                                    requestFrom:vm.pageType
								},
								parentScope: $scope,
								mode_of_call: 'add'
							},
							onRemoving: function (event) {
								if($scope.reloaddashboard){
									load('changeDate');                         
								}
							}
						});
					}
					
				} else if (response.canOverride && (response.errorTitle === 'Late checkout' || response.errorTitle === 'Early check-in')) {
					$mdDialog.show({
						controller: 'confirmPageController',
						controllerAs: 'vm',
						templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
						parent: angular.element(document.body),
						targetEvent: event,
						clickOutsideToClose: true,
						locals: {
							title: response.errorTitle || 'Confirm Create',
							htmlContent: response.errorMsg || 'Are you sure you want to create a day reservation on this room?',
							btnTxt: 'Yes, Create',
							cancelTxt: 'Cancel',
							localData: { invertButtonColors: true }
						}
					}).then(function(confirmResponse) {
						if (typeof confirmResponse.answer != 'undefined' && confirmResponse.answer == 'update') {
							vm.data.pageType = vm.pageType;
							$mdDialog.show({
								controller         : 'optionCreatePlaceGantt',
								controllerAs       : 'vm',
								templateUrl        : 'app/main/apps/dashboards/gantt-chart/dialogs/option-place-on-gantt.html',
								parent             : angular.element($document.body),
								targetEvent        : ev,
								clickOutsideToClose: true,
								locals             : {
									dialogData: {
										chartData : vm.data,
										thisnewcreateData : ev,
										thisroomname : roomname,
										policydetails : vm.policyData,
										locationres: location,
										requestFrom:vm.pageType,
										ignoreEarlyLate: true
									},
									parentScope: $scope,
									mode_of_call: 'add'
								},
								onRemoving: function (event) {
									if($scope.reloaddashboard){
										load('changeDate');
									}
								}
							});
						} else {
							load('changeDate');
						}
					}, function() {
						load('changeDate');
					});
				}else{
					load('changeDate');
					toastMessage.showSimpleToast(response.errorMsg, 'error-toast', false, response.errorTitle || null);
				}
			});
			
            
        }
        /**
         * Edit Dialog
         */
		function getOrderInfo(formData,rowChange)
        {
			if(vm.requestgoing) return;
			if(rowChange && formData.model.classes == 'do-not-move-mark'){
                var html='This reservation has requested "Do not move".';
                $mdDialog.show({
                              controller: 'confirmPageController',
                              controllerAs: 'vm',
                              templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
                              parent: angular.element(document.body),
                              targetEvent: event,
                              clickOutsideToClose:true ,
                              locals: {
                                    title: 'Do not move reservation',
                                    htmlContent:html,
                                    btnTxt: 'OK',
                                    cancelTxt: 'Cancel',
                                    localData: { invertButtonColors: true }
                                }                
                            }).then(function(response) {
                            if(typeof response.answer != 'undefined' && response.answer == 'update'){
                                $mdDialog.hide();
                               }
                            }, function() {}); 
				load('changeDate');return;
			} else if(formData.model.type_of_reservation == 'bundleblock'){
                var html='Automatic blocked ranges cannot be modified.';
                $mdDialog.show({
                              controller: 'confirmPageController',
                              controllerAs: 'vm',
                              templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
                              parent: angular.element(document.body),
                              targetEvent: event,
                              clickOutsideToClose:true ,
                              locals: {
                                    title: 'Automatic blocked range',
                                    htmlContent:html,
                                    btnTxt: 'OK',
                                    localData: {}
                                }                
                            }).then(function(response) {
                            if(typeof response.answer != 'undefined' && response.answer == 'update'){
                                $mdDialog.hide();
                               }
                            }, function() {});
                load('changeDate');return;
            }
			var product_id = formData.row.model.id;
			var product_name = formData.row.model.name;
			var room_stay_from = moment(formData.model.from._d).format('MM/DD/YYYY');
			var room_stay_to = moment(formData.model.to._d).format('MM/DD/YYYY');
			var confirmation_number = formData.model.confirmation_number;
			// Overnight stays cannot be 0 nights; same-day is only valid for day_reservation.
			if (room_stay_from == room_stay_to && formData.model.type_of_reservation !== 'day_reservation') {
				vm.requestgoing = true;
				toastMessage.showSimpleToast('Check-in and check-out date cannot be same.','error-toast');
				vm.lastTaskEvent = '';
				vm.isloading = false;
				load('changeDate');
				$timeout(function() {
					vm.requestgoing = false;
				});
				return;
			}
			vm.currenttask = formData;               
			var rowId = vm.currenttask.row.$scope.$index;
			var taskId = vm.currenttask.$scope.$index;
			vm.isloading = true;
			vm.requestgoing = true;
			ganttChartService.getModifiedOrder({'product_id':product_id,'room_stay_from':room_stay_from,'room_stay_to':room_stay_to,'confirmation_number':confirmation_number,'type_of_reservation':formData.model.type_of_reservation || ''}).then(function(response){
                vm.lastTaskEvent = '';
				vm.isloading = false;
				vm.requestgoing = false;
				if(response.success ){
					vm.orderModifying = {
						'new_product_id':product_id,
                        'old_product_id':response.order_info[0].product_id,
						'new_product_name':product_name,
						'new_room_stay_from':room_stay_from,
						'new_room_stay_to':room_stay_to,
						'old_product_name':response.order_info[0].product_name,
						'old_room_stay_from':moment(response.order_info[0].room_stay_from).format('MM/DD/YYYY'),
						'old_room_stay_to':moment(response.order_info[0].room_stay_to).format('MM/DD/YYYY'),
						'type_of_reservation':formData.model.type_of_reservation,
						'confirmation_number':confirmation_number
					}
					confirmEdit(null);
				} else if (response.canOverride && (response.errorTitle === 'Late checkout' || response.errorTitle === 'Early check-in')) {
					var moveConflictHtml = (response.errorMsg || '')
						.replace('create a day reservation on this room?', 'move this day reservation here?')
						|| 'Are you sure you want to move this day reservation?';
					$mdDialog.show({
						controller: 'confirmPageController',
						controllerAs: 'vm',
						templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
						parent: angular.element(document.body),
						targetEvent: event,
						clickOutsideToClose: true,
						locals: {
							title: response.errorTitle || 'Confirm Move',
							htmlContent: moveConflictHtml,
							btnTxt: 'Yes, Move',
							cancelTxt: 'Cancel',
							localData: { invertButtonColors: true }
						}
					}).then(function(confirmResponse) {
						if (typeof confirmResponse.answer != 'undefined' && confirmResponse.answer == 'update') {
							ganttChartService.getModifiedOrder({
								'product_id': product_id,
								'room_stay_from': room_stay_from,
								'room_stay_to': room_stay_to,
								'confirmation_number': confirmation_number,
								'type_of_reservation': formData.model.type_of_reservation || '',
								'ignore_early_late': true
							}).then(function(retryResponse) {
								if (retryResponse.success) {
									vm.orderModifying = {
										'new_product_id': product_id,
										'old_product_id': retryResponse.order_info[0].product_id,
										'new_product_name': product_name,
										'new_room_stay_from': room_stay_from,
										'new_room_stay_to': room_stay_to,
										'old_product_name': retryResponse.order_info[0].product_name,
										'old_room_stay_from': moment(retryResponse.order_info[0].room_stay_from).format('MM/DD/YYYY'),
										'old_room_stay_to': moment(retryResponse.order_info[0].room_stay_to).format('MM/DD/YYYY'),
										'type_of_reservation': formData.model.type_of_reservation,
										'confirmation_number': confirmation_number
									};
									confirmEdit(null);
								} else {
									vm.orderModifying = {};
									vm.commit = false;
									toastMessage.showSimpleToast(retryResponse.errorMsg, 'error-toast', false, retryResponse.errorTitle || null);
									load('changeDate');
								}
							});
						} else {
							load('changeDate');
						}
					}, function() {
						load('changeDate');
					});
				}else{
					vm.orderModifying = {};
					vm.commit = false;
					toastMessage.showSimpleToast(response.errorMsg, 'error-toast', false, response.errorTitle || null);
					load('changeDate');return;
				}
			});
        }
        function confirmEdit(ev){
			vm.commit = false;
			if(vm.orderModifying.type_of_reservation == 'reservation' || vm.orderModifying.type_of_reservation == 'boat'|| vm.orderModifying.type_of_reservation == 'rent' || vm.orderModifying.type_of_reservation == 'day_reservation'){
				$mdDialog.show({
					controller         : 'GanttChartEditDialogController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/apps/dashboards/gantt-chart/dialogs/edit/edit-dialog.html',
					parent             : angular.element($document.body),
					targetEvent        : ev,
					clickOutsideToClose: false,
					locals             : {
						dialogData: {
							formData  	: vm.orderModifying,
							currentTask : vm.currenttask
						}
					}
				});
			}else{
				var html = "";
				if(vm.orderModifying.type_of_reservation == 'hold'){
					html += "<h2 class='title mt-0'>You are about to change hold dates</h2>";
				} else if(vm.orderModifying.type_of_reservation == 'block') {
					html += "<h2 class='title mt-0'>You are about to change blocked dates</h2>";
				}
				
				html += "<div class='editHoldBlock'>\
							<div class='editHoldBlockFrom editholdComn'><span class='fromTitleHB'>From:</span><span class='fromContent'><b class='HBProdName'>"+vm.orderModifying.old_product_name+":</b><p>\
							"+vm.orderModifying.old_room_stay_from+" <b><em>to</em></b> "+vm.orderModifying.old_room_stay_to + "</p></span></div>\
							<div class='editHoldBlockTo editholdComn'><span class='fromTitleHB'>To:</span>\
							<span class='fromContent'><b class='HBProdName'>"+vm.orderModifying.new_product_name+":</b><p>\
							"+vm.orderModifying.new_room_stay_from+" <b><em>to</em></b> "+vm.orderModifying.new_room_stay_to+"</p></span></div></div>";
							
					
                 $mdDialog.show({
                  controller: 'confirmPageController',
                  controllerAs: 'vm',
                  templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
                  parent: angular.element(document.body),
                  targetEvent: event,
                  clickOutsideToClose:true ,
                  locals: {
                        title: 'Modify dates',
                        htmlContent:html,
                        btnTxt: 'Continue',
                        localData: {}
                         }                
                        }).then(function(response) {
                        if(typeof response.answer != 'undefined' && response.answer == 'update'){
                           saveReservation();
                           }
                        }, function() {
                            load('changeDate');vm.currenttask = {};
                    });

			}
		}
		
        function saveReservation()
		{
			vm.isloading = true;
			var data = {'product_id':vm.orderModifying.new_product_id,'product_name':vm.orderModifying.new_product_name,'room_stay_from':vm.orderModifying.new_room_stay_from,'room_stay_to':vm.orderModifying.new_room_stay_to,'confirmation_number':vm.orderModifying.confirmation_number,'type_of_reservation':vm.orderModifying.type_of_reservation};
			ganttChartService.saveModifiedOrder(data).then(function(response){
				vm.isloading = false;
				if(response.success){
					load('changeDate');
				}else{
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				}
				vm.currenttask = {};
			});
		}
		
		$scope.$on('done_modification', function(event) {
			load('changeDate');
			vm.currenttask = {};
		});
        
        function changeStatusAfterPayment(idx,confirmation_number,oldStatus,newStatus,sendEmail){
			vm.changingStatus = true;
			vm.changeStatusData = {newStatus:newStatus,oldStatus:oldStatus,sendEmail:sendEmail};
			vm.room_stay_status = oldStatus;
			$mdDialog.hide();
			$state.go("app.e-commerce.orders.detail",{id:vm.currenttask.model.reservation_id,confirmation_number:vm.currenttask.model.confirmation_number,changeStatusData:vm.changeStatusData});
			
		}

        function viewOrder(reservation_id,confirmation_number){
            if(vm.pageType == 'room'){
                var url = $state.href("app.e-commerce.orders.detail",{id:reservation_id,confirmation_number:confirmation_number});
                $window.open(url, '_blank');
            }else if(vm.pageType == 'rent'){
                var url = $state.href("app.e-commerce.rentOrders.detail",{id:reservation_id,confirmation_number:confirmation_number});
                $window.open(url, '_blank');
            } else {
    			var url = $state.href("app.e-commerce.boatOrders.detail",{id:reservation_id,confirmation_number:confirmation_number});
                $window.open(url, '_blank');
            }
		}

		function addcommentinorder(event){
			$mdDialog.show({
				controller         : 'addCommentRes',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/apps/dashboards/gantt-chart/dialogs/add-comment.html',
				parent             : angular.element($document.body),
				targetEvent        : event,
				clickOutsideToClose: true,
				locals             : {
					dialogData: {
						chartData : vm.data,
						thisnewcreateData : vm.currenttask
					},
					parentScope: $scope
				}
    //             ,
				// onRemoving: function (event) {
				// 	if($scope.comment_reload && vm.currenttask.model.type_of_reservation != 'reservation' && vm.currenttask.model.type_of_reservation != 'boat' && vm.currenttask.model.type_of_reservation != 'rent'){
				// 		// load('changeDate');
				// 	}
				// }
			});
		}

		/**
		 * Mark Active reservation as Waiting for Room from gantt context menu.
		 */
		vm.setWaitingForRoomFromGantt = function (event) {
			if (!vm.currenttask || !vm.currenttask.model) {
				return;
			}

			var taskModel = vm.currenttask.model;
			jQuery('.custom-mnu-container').html('');

			eCommerceService.confirmAndSetWaitingForRoom(taskModel, event, {
				checkColor: true,
				useGanttDialog: true,
				applyGanttFields: true,
				onRequestStart: function () {
					vm.isloading = true;
				},
				onRequestEnd: function () {
					vm.isloading = false;
				}
			});
		};

		$scope.statusDialog = function(ev, newstatus, RemainAmount)
		{
			var confirmation_number = vm.currenttask.model.confirmation_number;
            if(typeof RemainAmount == 'undefined'){
                // vm.currenttask.statusDialog = true;
                // vm.currenttask.statusEvent = ev;
                // vm.currenttask.newStatus = newstatus;
                ganttChartService.fetchRemainingAmount(confirmation_number)
                    .then(function(res) {
                        if (res.result !== undefined && Object.keys(res.result).length > 0) {
                            RemainAmount = parseFloat(res.result.total_remaining_amount);
                            vm.tempOldStatus = res.result.room_stay_status;
                            vm.processStatusRequest(ev, newstatus, RemainAmount);
                        }
                });
                // return;
            } else {
                vm.processStatusRequest(ev, newstatus, RemainAmount);
            }
        }

        vm.processStatusRequest = function(ev, newstatus, RemainAmount) {
            var confirmation_number = vm.currenttask.model.confirmation_number;
            vm.currenttask.model.check_send_email = vm.currenttask.model.check_send_email == 1 ?true:false;
            var isWaiting = eCommerceService.isWaitingForRoom(vm.currenttask.model, {
                checkColor: true
            });
            var oldStatus = vm.currenttask.model.status || vm.currenttask.model.room_stay_status || vm.tempOldStatus || 'Active';
            if (oldStatus === undefined || oldStatus === '' || oldStatus === 'undefined') {
                oldStatus = vm.tempOldStatus || 'Active';
            }
            var displayOldStatus = isWaiting ? 'Waiting for Room' : oldStatus;
            var orig_confirmation_number = '';
			if(newstatus=='Canceled'){
				vm.isloading = true;
				ganttChartService.getCancelOrderData({'confirmation_number':confirmation_number}).then(function(response){
					vm.isloading = false;
					if(response.success ){
						var days_free_cancellation = response.days_free_cancellation;
						var payments = response.payments;
						var refund_type = response.refund_type;
						var policy_name = response.policy_name;
						var room_stay_from = response.room_stay_from;
						var payment_exists = response.payment_exists;
						var total_amount = response.total_amount;
						var customer_email = response.customer_email;
						var Reservation_id = vm.currenttask.model.reservation_id;
						var cancellation_charges = response.cancellation_charges;
						var if_cancelled_period = response.if_cancelled_period;
						$mdDialog.show({
							clickOutsideToClose	: false,
							parent             	: angular.element($document.body),
							scope				: $scope,
							preserveScope		: true,
							locals				: { 
													localData :{
														oldStatus: oldStatus,
														newStatus: newstatus,
														confirmation_number: confirmation_number,
														days_free_cancellation:days_free_cancellation,
														payments:payments,
														room_stay_from:room_stay_from,
														refund_type:refund_type,
														customer_name:(vm.currenttask.model.type_of_reservation === 'day_reservation' && vm.currenttask.model.holdcustomer) ? vm.currenttask.model.holdcustomer : vm.currenttask.model.name,
														customer_email:customer_email,
														paidAmount:vm.currenttask.model.paidAmount,
														total_amount:total_amount,
														payment_exists:payment_exists,
														cancellation_charges:cancellation_charges,
														if_cancelled_period:if_cancelled_period,
														policy_name:policy_name,
                                                        send_email_indicator:  vm.currenttask.model.check_send_email
													}
												},
							templateUrl        	: 'app/main/apps/e-commerce/views/orders/dialogs/status/cancel.html',
							controller			: CancelController
						});
						function CancelController($scope, $mdDialog, localData) {
                            $scope.oldStatus = localData.oldStatus;
							$scope.confirmation_number = localData.confirmation_number;
							$scope.newStatus = localData.newStatus;
                            $scope.send_email_indicator = localData.send_email_indicator;
							$scope.refund_type = localData.refund_type;
							$scope.policy_name = localData.policy_name;
							$scope.days_free_cancellation = localData.days_free_cancellation;
							$scope.payments = localData.payments;
							$scope.customer_name = localData.customer_name;
							$scope.customer_email = localData.customer_email;
							$scope.paidAmount = localData.paidAmount;
							$scope.total_amount = localData.total_amount;
							$scope.payment_exists = localData.payment_exists;
							$scope.cancellation_charges = localData.cancellation_charges;
							$scope.if_cancelled_period = localData.if_cancelled_period;
							if($scope.if_cancelled_period == "0" && $scope.cancellation_charges > 0)
								vm.keepCancelCharges = true;
							else
								vm.keepCancelCharges = false;
							$scope.takeChargesInstallment = {};
							$scope.cancel_order_comment = "";
							$scope.showSubmit = true;
							$scope.closeDialog = function(){
								vm.room_stay_status = $scope.oldStatus;
								$mdDialog.hide();
							};
							$scope.changeKeepCharges = function(idx,old_value){
								if(old_value == 1)
									$scope.payments[idx].keep_charges = false;
								else
									$scope.payments[idx].keep_charges = true;
								if(vm.keepCancelCharges){
									var keep_amount = 0;
									$timeout(function ()
									{
										angular.forEach($scope.payments, function(value,key) {
											var intallmentId = value.installment_id;
											if($scope.takeChargesInstallment[intallmentId] != 'undefined' && $scope.takeChargesInstallment[intallmentId]){
												keep_amount = parseFloat(keep_amount) + parseFloat(value.installment_amount);
											}
											if( parseFloat(keep_amount) >= parseFloat($scope.cancellation_charges) ){
												$scope.showSubmit = true;
											} else {
												$scope.showSubmit = false;
											}
										});
									});
								} else {
									$scope.showSubmit = true;
								}
							};
							$scope.cancelFinally = function(sendEmail){
								vm.isloading = true;
								$scope.showSubmit = false;
								if($scope.refund_type == 0 || $scope.refund_type == 1){
									var data = {refund_type:$scope.refund_type,confirmation_number:$scope.confirmation_number,reservation_id:Reservation_id,cancel_order_comment:$scope.cancel_order_comment,total_amount:$scope.total_amount,keepCancelCharges:vm.keepCancelCharges,takeChargesInstallment:$scope.takeChargesInstallment,cancellation_charges:$scope.cancellation_charges,location:'PMS (Graph)',sendEmail:sendEmail,source:EnvironmentConfig.source + ' - Tape Chart'};
								} else {
									var data = {refund_type:$scope.refund_type,paidAmount:$scope.paidAmount,customer_name:$scope.customer_name,customer_email:$scope.customer_email,confirmation_number:$scope.confirmation_number,reservation_id:Reservation_id,cancel_order_comment:$scope.cancel_order_comment,total_amount:$scope.total_amount,keepCancelCharges:vm.keepCancelCharges,takeChargesInstallment:$scope.takeChargesInstallment,cancellation_charges:$scope.cancellation_charges,location:'PMS (Graph)',sendEmail:sendEmail,source:EnvironmentConfig.source + ' - Tape Chart'};
								}
								
								ganttChartService.cancelOrder(data).then(function(response){
									vm.isloading = false;
									if(response.success){
										if(response.refund_error)
											toastMessage.showSimpleToast(response.errorMsg,'error-toast');
										var targetRow = vm.currenttask.row;
										
										if(response.refund_error)
											toastMessage.showSimpleToast(response.errorMsg,'error-toast');
											
										if(response.mail_error)
											toastMessage.showSimpleToast('Reservation canceled successfully but there was some error in sending email to the customer.','error-toast');
											
										//~ targetRow.removeTask(vm.currenttask.model.id, false, true);
										load('changeDate');
										$mdDialog.hide();
									} else {
										vm.room_stay_status = $scope.oldStatus;
										toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
									}
								});
							};
						}
					}else{
						toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.','error-toast');
						vm.room_stay_status = oldStatus;
						$mdDialog.hide();
					}
				});
			}else{
				if(oldStatus && oldStatus.toLowerCase()==newstatus.toLowerCase() && !isWaiting){
					var html='This reservation is already in state "'+newstatus+'".';
                      $mdDialog.show({
                                      controller: 'confirmPageController',
                                      controllerAs: 'vm',
                                      templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
                                      parent: angular.element(document.body),
                                      targetEvent: event,
                                      clickOutsideToClose:true ,
                                      locals: {
                                            title: 'Change Status',
                                            htmlContent:html,
                                            btnTxt: 'Continue',
                                            localData: {}
                                        }                
                                    }).then(function(response) {
                                    if(typeof response.answer != 'undefined' && response.answer == 'update'){
                                        $mdDialog.hide();
                                       }
                                    }, function() {});
				}else{
					if(RemainAmount > 0){
                        vm.currenttask.model.check_send_email = vm.currenttask.model.check_send_email == 1 ?true:false;
						$mdDialog.show({
							clickOutsideToClose	: false,
							parent             	: angular.element($document.body),
							scope				: $scope,
							preserveScope		: true,
							locals				: { oldStatus: displayOldStatus, newStatus: newstatus, RemainAmount: RemainAmount, confirmation_number: vm.currenttask.model.confirmation_number, orig_confirmation_number: orig_confirmation_number,send_email_indicator:vm.currenttask.model.check_send_email },
							templateUrl        	: 'app/main/apps/e-commerce/views/orders/dialogs/status/checkin-out.html',
							controller			: StatusController
						});
						function StatusController($scope, $mdDialog, oldStatus, RemainAmount, newStatus, confirmation_number, orig_confirmation_number,send_email_indicator) {
							$scope.oldStatus = oldStatus;
							$scope.idx = 0;
							$scope.confirmation_number = confirmation_number;
							$scope.orig_confirmation_number = orig_confirmation_number;
                            $scope.newStatus = newStatus;
							$scope.send_email_indicator = send_email_indicator;
							$scope.remainingBalance = RemainAmount;
							if(newStatus == 'Checked-In')
								$scope.showStatus = 'Check-in';
							else if(newStatus == 'Checked-Out')
								$scope.showStatus = 'Check-out';
							else if(newStatus == 'Closed')
								$scope.showStatus = 'Close';
							else
								$scope.showStatus = newStatus;
							$scope.closeDialog = function(){
								vm.room_stay_status = $scope.oldStatus;
								$mdDialog.hide();
							};
						}
					} else {
						var displayCustomerName = (vm.currenttask.model.type_of_reservation === 'day_reservation' && vm.currenttask.model.holdcustomer) ? vm.currenttask.model.holdcustomer : vm.currenttask.model.name;
						var html='Are you sure you want to change status of reservation "'+confirmation_number+' ('+displayCustomerName+')" from '+displayOldStatus+' to '+newstatus+'.';
                        $mdDialog.show({
                                    controller: 'confirmPageController',
                                    controllerAs: 'vm',
                                  templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
                                  parent: angular.element(document.body),
                                  targetEvent: event,
                                  clickOutsideToClose:true ,
                                  locals: {
                                        title: 'Change Status',
                                        htmlContent:html,
                                        btnTxt: 'Continue',
                                        localData: {
											newStatus: newstatus,
											send_email_indicator:vm.currenttask.model.check_send_email
										}
                                    }                
                                }).then(function(response) {
                                if(typeof response.answer != 'undefined' && response.answer == 'update'){
                                     clearWaitingThenChangeStatus(newstatus, oldStatus, response.email_indicator);

                                   }
                                }, function() {});
					}
				}				
			}
        }
        function changeStatusWithoutPayment(idx, confirmation_number, oldStatus, newStatus, sendEmail){
			clearWaitingThenChangeStatus(newStatus, oldStatus, sendEmail);
		}
		/**
         * Clear Waiting for Room flag (display-only) before real status change.
         */
		function clearWaitingThenChangeStatus(newstatus, oldstatus, sendEmail) {
			var taskModel = vm.currenttask && vm.currenttask.model;
			var isWaiting = eCommerceService.isWaitingForRoom(taskModel);
			if (!isWaiting) {
				finalstatuschange(newstatus, oldstatus, sendEmail);
				return;
			}
			vm.isloading = true;
			eCommerceService.setWaitingStatus({
				confirmation_number: taskModel.confirmation_number,
				waiting: 0
			}).then(function(response) {
				if (response && response.success) {
					taskModel.is_waiting_for_room = 0;
					finalstatuschange(newstatus, oldstatus || 'Active', sendEmail);
				} else {
					vm.isloading = false;
					toastMessage.showSimpleToast((response && response.errorMsg) || 'Unable to update Waiting for Room status.', 'error-toast');
				}
			}, function() {
				vm.isloading = false;
				toastMessage.showSimpleToast('Unable to update Waiting for Room status.', 'error-toast');
			});
		}
		/**
         * Remove Task
         */
        function finalstatuschange(newstatus,oldstatus,sendEmail)
        {
			var reservation_id = vm.currenttask.model.reservation_id;
			vm.isloading = true;
			$mdDialog.hide();
			ganttChartService.changeReservationStatus({'reservation_id':reservation_id,'room_stay_status':newstatus,'oldStatus':oldstatus,'confirmation_number':vm.currenttask.model.confirmation_number,'sendEmail':sendEmail,'location':'graph'}).then(function(response){
				vm.isloading = false;
				if(response.success ){
					load('changeDate');
					if(response.hasOwnProperty('mail_error') && response.mail_error && response.errorMsg != '')
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				}else{
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				}
			});
        }

		function isScrolledIntoView(elem)
		{
            var docViewTop = $(window).scrollTop();
			var docViewBottom = docViewTop + $(window).height();
			var elemTop = $(elem).offset().top;
			var elemBottom = elemTop + $(elem).height();
			return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
		}
        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Search
         * @param sidenavId
         */
        function search(option, keyword)
        {
            if ( option === 'rows' )
            {
                vm.options.filterRow = keyword;
            }
            else if ( option === 'tasks' )
            {
                vm.options.filterTask = keyword;
            }
        }

        /**
         * Sort Mode
         * @param mode
         */
        function setSortMode(mode)
        {
            vm.options.sortMode = mode;

            if ( angular.isUndefined(mode) )
            {
                vm.options.rowSortable = true;
            }
            else
            {
                vm.options.rowSortable = false;
            }
        }

        /**
         * Side Mode
         */
        $scope.$watch('vm.options.sideMode', function (newValue, oldValue)
        {
            if ( newValue !== oldValue )
            {
                vm.api.side.setWidth(undefined);

                $timeout(function ()
                {
                    vm.api.columns.refresh();
                });
            }
        });

        function canAutoWidth(scale)
        {
            if ( scale.match(/.*?hour.*?/) || scale.match(/.*?minute.*?/) )
            {
                return false;
            }

            return true;
        }

        function getColumnWidth(widthEnabled, scale, zoom)
        {
            if ( !widthEnabled && vm.canAutoWidth(scale) )
            {
                return undefined;
            }

            if ( scale.match(/.*?week.*?/) )
            {
                return 150 * zoom;
            }

            if ( scale.match(/.*?month.*?/) )
            {
                return 300 * zoom;
            }

            if ( scale.match(/.*?quarter.*?/) )
            {
                return 500 * zoom;
            }

            if ( scale.match(/.*?year.*?/) )
            {
                return 800 * zoom;
            }

            return 40 * zoom;
        }
        $rootScope.loadFromScroll = function(from, to){
			vm.scrollFrom = from;
			vm.scrollTo = to;
			load('scroll');
		}
//sortByOccupancy
        function sortByOccupancy(){

        }
        jQuery(document).on("click",".gantt-column-header",function(){
            var clicked_date=jQuery(this).data('room')
            load('changeDate',clicked_date);
        });

        // Reload data action
        function load(location,clicked_date)
        {
			vm.isloading = true;
			if(location=='changeDate'){
				$rootScope.customoption = 'no';
				var from = vm.options.fromDate;
                var to = moment(moment(moment(from).format('YYYY/MM/DD')).add(parseInt(vm.number_of_days), 'days')).format('YYYY/MM/DD');
                from = moment(moment(moment(from).format('YYYY/MM/DD')).subtract(2, 'days')).format('YYYY/MM/DD');
                // from = moment(from).format('YYYY/MM/DD');
                // moment(moment(moment(from).format('YYYY/MM/DD')).subtract(2, 'days')).format('YYYY/MM/DD');

				vm.options.toDate = to;
                var hotel_id = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
                $sessionStorage[hotel_id] = {};
                $sessionStorage[hotel_id]['gantt_chart_from'] = from;
                $sessionStorage[hotel_id]['gantt_chart_to'] = to;
				ganttChartService.getGanttData({
                    start:from,
                    end:to,
                    clicked_date:clicked_date,
                    requestFor:vm.pageType,
                }).then(function(response){
					vm.isloading = false;
					if(response.success){
						var data = [];
						for(var i=0;i<(response.roomsDetail).length;i++){
							data.push(JSON.parse((response.roomsDetail)[i]));
						}
                        vm.data = data;
						vm.occupancyData = response.occupancyData;
						get_room_percent_this(vm.occupancyData);
						$timeout(function ()
						{
							$rootScope.customoption = 'yes';
						},500);
					}else if(response.errorMsg){
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					} else{
						toastMessage.showSimpleToast('There was some error in fetching prices for selected range.','error-toast');
					}
				});
			}else if(location=='scroll'){
				var from = moment(vm.scrollFrom).format('YYYY/MM/DD');
				var to = moment(vm.scrollTo).format('YYYY/MM/DD');
                var hotel_id = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
                $sessionStorage[hotel_id] = {};
                $sessionStorage[hotel_id]['gantt_chart_from'] = angular.copy(from);
                $sessionStorage[hotel_id]['gantt_chart_to'] = angular.copy(to);
				vm.options.toDate = to;
				vm.options.fromDate = from;
				ganttChartService.getGanttData({
                    start:from,
                    end:to,
                    requestFor:vm.pageType,
                 }).then(function(response){
					vm.isloading = false;
					if(response.success){
						var data = [];
						for(var i=0;i<(response.roomsDetail).length;i++){
							data.push(JSON.parse((response.roomsDetail)[i]));
						}
						vm.data = data;

						vm.occupancyData = response.occupancyData;
						get_room_percent_this(vm.occupancyData);
					}else if(response.errorMsg){
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					} else{
						toastMessage.showSimpleToast('There was some error in fetching prices for selected range.','error-toast');
					}
					$timeout(function ()
					{
						$rootScope.customoption = 'yes';
					},500);
				});
			}else{
                var hotel_id = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
                if(typeof $sessionStorage[hotel_id] != 'undefined' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_from') && $sessionStorage[hotel_id]['gantt_chart_from'] != '' && $sessionStorage[hotel_id].hasOwnProperty('gantt_chart_to') && $sessionStorage[hotel_id]['gantt_chart_to'] != '' ){
                    vm.options.toDate = angular.copy($sessionStorage[hotel_id]['gantt_chart_to']);
                    vm.options.fromDate = angular.copy($sessionStorage[hotel_id]['gantt_chart_from']);
                }
				var data = [];
				for(var i=0;i<(ganttData.roomsDetail).length;i++){
					data.push(JSON.parse((ganttData.roomsDetail[i])));
				}
				vm.data = data;

				vm.occupancyData = ganttData.occupancyData;
				get_room_percent_this(vm.occupancyData);
				vm.isloading = false;
			}
            // Fix for Angular-gantt-chart issue
            $animate.enabled(true);
            $animate.enabled($document.find('#gantt'), false);

        }

        /**
        * change boat types from dropdown
        *
        vm.filterBoatTypes = function() {
            var clicked_date=jQuery(this).data('room')
            load('changeDate',clicked_date);
        };*/

        /**
         * Reload Data
         */
        function reload()
        {
			vm.commit = false;
			vm.enableReload = false;
			vm.isloading = true;
			$rootScope.customoption = 'no';
            ganttChartService.getGanttData({requestFor:vm.pageType}).then(function(response){
				vm.isloading = false;
				vm.enableReload = true;
				if(response.success){
					var from = new Date();
                    var to = moment(moment(moment(from).format('YYYY/MM/DD')).add(parseInt(vm.number_of_days), 'days')).format('YYYY/MM/DD');
					from = moment(moment(from).subtract(2, 'days')).format('YYYY/MM/DD');
					vm.options.toDate = to;
					vm.options.fromDate = from;
                    var hotel_id = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
                    $sessionStorage[hotel_id] = {};
                    $sessionStorage[hotel_id]['gantt_chart_from'] = angular.copy(from);
                    $sessionStorage[hotel_id]['gantt_chart_to'] = angular.copy(to);
					var data = [];
					for(var i=0;i<(response.roomsDetail).length;i++){
						data.push(JSON.parse(response.roomsDetail[i]));
					}
					vm.data = data;

					vm.occupancyData = response.occupancyData;
					get_room_percent_this(vm.occupancyData);
					$timeout(function ()
					{
						$rootScope.customoption = 'yes';
					},500);
				}else if(response.errorMsg){
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				} else{
					toastMessage.showSimpleToast('There was some error in fetching data for selected range.','error-toast');
				}
			});
        }
        
        function convertToRes(type,event){
			if (type == 'hold') {
				goDirectCreateResFromHold();
				return;
			}
			vm.isloading = true;
			addReservation(vm.currenttask,vm.currenttask.row.model.name,type);
		}

		function goDirectCreateResFromHold() {
			var task = vm.currenttask;
			if (!task || !task.model || !task.row) {
				return;
			}
			var productId = task.row.model.productId !== undefined ? task.row.model.productId : task.row.model.id;
			var fromDate = task.model.from && task.model.from._d ? task.model.from._d : task.model.from;
			var toDate = task.model.to && task.model.to._d ? task.model.to._d : task.model.to;
			var confirmation = task.model.confirmation_number;
			if (!confirmation || !productId) {
				toastMessage.showSimpleToast('Unable to load hold details.','error-toast');
				return;
			}
			vm.isloading = true;
			ganttChartService.getGanttTooltipData({
				confirmation_number: confirmation,
				include_hold_pricing: true
			}).then(function(response) {
				var tip = (response && response.success && response.tooltip_data) ? response.tooltip_data : {};
				var policyId = (tip.hold_pricing && tip.hold_pricing.policy_key) ? tip.hold_pricing.policy_key : '2';
				var selectedRoom = {};
				selectedRoom[productId] = policyId;
				var guest = {
					first_name: tip.first_name || '',
					last_name: tip.last_name || '',
					customer_email: tip.holdEmail || tip.customer_email || '',
					phone_number: tip.holdPhone || tip.phone_number || ''
				};
				if (guest.first_name || guest.last_name || guest.customer_email) {
					$sessionStorage['hold_convert_guest_' + $localStorage['preHotelId']] = guest;
				}
				vm.isloading = false;
				$state.go('app.create-res', {
					prod_id: JSON.stringify(selectedRoom),
					from: new Date(moment(fromDate).format('YYYY-MM-DD')),
					to: new Date(moment(toDate).format('YYYY-MM-DD')),
					adult: parseInt(tip.room_stay_guest_count, 10) || 2,
					child: parseInt(tip.room_stay_child_count, 10) || 0,
					from_page: 'header',
					block_conf_no: confirmation,
					hold_block_choice: 'hold',
					creationSource: 'Tape Chart'
				});
			}, function() {
				vm.isloading = false;
				toastMessage.showSimpleToast('Unable to load hold details.','error-toast');
			});
		}

		function removeHoldBlockDates(type,event){
			if(type == 'hold'){
				var html='Are you sure you want to release dates from "'+moment(vm.currenttask.model.from).format('MM/DD/YYYY')+' to '+moment(vm.currenttask.model.to).format('MM/DD/YYYY')+'"?';
				var title = "Release Dates";
			} else {
				var html='Are you sure you want to unblock dates from "'+moment(vm.currenttask.model.from).format('MM/DD/YYYY')+' to '+moment(vm.currenttask.model.to).format('MM/DD/YYYY')+'"?';
				var title = "Unblock Dates";
			}
            $mdDialog.show({
                    controller: 'confirmPageController',
                    controllerAs: 'vm',
                  templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
                  parent: angular.element(document.body),
                  targetEvent: event,
                  clickOutsideToClose:true ,
                  locals: {
                        title: title,
                        htmlContent:html,
                        btnTxt: 'Continue',
                        localData: {}
                    }                
                }).then(function(response) {
                       if(typeof response.answer != 'undefined' && response.answer == 'update'){
                     vm.isloading = true;
                        var roomName=vm.currenttask.row.model.name;
                        var data = {confirmation_number:vm.currenttask.model.confirmation_number,
                                    type_of_reservation:vm.currenttask.model.type_of_reservation,
                                    room_name:roomName,
                                    from:vm.currenttask.model.from,
                                    to:vm.currenttask.model.to
                                };
                        ganttChartService.removeHoldBlockDates(data).then(function(response){
                            vm.isloading = false;
                            if(response.success){
                                //~ var targetRow = vm.currenttask.row;
                                //~ targetRow.removeTask(vm.currenttask.model.id, false, true);
                                load('changeDate');
                            }else if(response.errorMsg){
                                toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                            } else{
                                toastMessage.showSimpleToast('There was some error in fetching prices for selected range.','error-toast');
                            }
                });

                   }
                }, function() {});

			 
		}
		
		function editHoldDates(event){
			var roomName=vm.currenttask.row.model.name;
			var openEditDialog = function() {
				$mdDialog.show({
					controller         : 'optionCreatePlaceGantt',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/apps/dashboards/gantt-chart/dialogs/option-place-on-gantt.html',
					parent             : angular.element($document.body),
					targetEvent        : event,
					clickOutsideToClose: true,
					locals             : {
						dialogData: {
							chartData : vm.data,
							thisnewcreateData : vm.currenttask,
							thisroomname : roomName,
							requestFrom : vm.pageType || 'room'
						},
						parentScope: $scope,
						mode_of_call: 'edit'
					},
					onRemoving: function (event) {
						if($scope.success == undefined || !$scope.success){
						}else{
							load('changeDate');
						}
					}
				});
			};
			openEditDialog();
		}
	

        // Visual two way binding.
        var ganttDebounceValue = 1000;

        var listenTaskJson = ganttDebounce(function (taskJson)
        {
            if ( angular.isDefined(taskJson) )
            {
                var task = angular.fromJson(taskJson);
                objectModel.cleanTask(task);
                var model = vm.live.task;
                angular.extend(model, task);
            }
        }, ganttDebounceValue);

        $scope.$watch('vm.live.taskJson', listenTaskJson);

        var listenRowJson = ganttDebounce(function (rowJson)
        {
            if ( angular.isDefined(rowJson) )
            {
                var row = angular.fromJson(rowJson);
                objectModel.cleanRow(row);
                var tasks = row.tasks;

                delete row.tasks;
                var rowModel = vm.live.row;

                angular.extend(rowModel, row);

                var newTasks = {};
                var i, l;

                if ( angular.isDefined(tasks) )
                {
                    for ( i = 0, l = tasks.length; i < l; i++ )
                    {
                        objectModel.cleanTask(tasks[i]);
                    }

                    for ( i = 0, l = tasks.length; i < l; i++ )
                    {
                        newTasks[tasks[i].id] = tasks[i];
                    }

                    if ( angular.isUndefined(rowModel.tasks) )
                    {
                        rowModel.tasks = [];
                    }

                    for ( i = rowModel.tasks.length - 1; i >= 0; i-- )
                    {
                        var existingTask = rowModel.tasks[i];
                        var newTask = newTasks[existingTask.id];

                        if ( angular.isUndefined(newTask) )
                        {
                            rowModel.tasks.splice(i, 1);
                        }
                        else
                        {
                            objectModel.cleanTask(newTask);
                            angular.extend(existingTask, newTask);

                            delete newTasks[existingTask.id];
                        }
                    }
                }
                else
                {
                    delete rowModel.tasks;
                }

                angular.forEach(newTasks, function (newTask)
                {
                    rowModel.tasks.push(newTask);
                });
            }
        }, ganttDebounceValue);

        $scope.$watch('vm.live.rowJson', listenRowJson);

        $scope.$watchCollection('vm.live.task', function (task)
        {
            vm.live.taskJson = angular.toJson(task, true);
            vm.live.rowJson = angular.toJson(vm.live.row, true);
        });
        
		
        $scope.$watchCollection('vm.live.row', function (row)
        {
            vm.live.rowJson = angular.toJson(row, true);
            if ( angular.isDefined(row) && angular.isDefined(row.tasks) && row.tasks.indexOf(vm.live.task) < 0 )
            {
                vm.live.task = row.tasks[0];
            }
        });

        $scope.$watchCollection('vm.live.row.tasks', function ()
        {
            vm.live.rowJson = angular.toJson(vm.live.row, true);
        });
        
        // Event handler
        var logTaskEvent = function(eventName, task) {
        };
        
        // Event utility function
        var addEventName = function(eventName, func) {
            return function(data) {
                return func(eventName, data);
            };
        };
        function get_room_percent_this(jsondata){
			jQuery('.occupancy_percent').remove();
			jQuery.each(jQuery.parseJSON(jsondata), function(idxclass, objclass) {							
				setTimeout(function() {  
					var test = jQuery("."+idxclass).html();
					if(test == 'undefined'){
						jQuery("."+idxclass).append('<span class="occupancy_percent">0%</span>');
					}else{
						objclass=objclass.toFixed(2);
						jQuery("."+idxclass).append('<span class="occupancy_percent">'+parseFloat(objclass)+'%</span>');		
					}
				},2000);
						
			});
		}
        
        var getViewPortWidth = function() {
            var d = $document[0];
            return d.documentElement.clientWidth || d.documentElement.getElementById('body')[0].clientWidth;
        };

        var getViewPortHeight = function() {
            var d = $document[0];
            return d.documentElement.clientHeight || d.documentElement.getElementById('body')[0].clientHeight;
        };
        $scope.get_room_description = function(e,id,row){
            var elementRect = row.$element[0].getBoundingClientRect();
            var tooltipTop, tooltipBottom;
            var tooltipArrowFromTop = true;
            var tooltipHeight;
            if(getViewPortWidth() >= 1800){
                tooltipHeight = 450;
            } else {
                tooltipHeight = 300;
            }
            if(parseInt(elementRect.top) + parseInt(tooltipHeight) > getViewPortHeight()){
                tooltipTop = "auto";
                tooltipBottom = (parseInt(getViewPortHeight()) - parseInt(elementRect.bottom) ) + "px";
                tooltipArrowFromTop = false;
            } else {
                tooltipTop = (parseInt(elementRect.top) - 64) + "px";
                tooltipBottom = "auto";
            }
            vm.description = {};
            vm.description.loader = EnvironmentConfig.feBase_url+'/images/loader.gif';
            vm.roomInformation = '';
            vm.isloading = true;
            ganttChartService.getRoomDescription({'product_id':id}).then(function(response){
                if(response.success){
                    vm.isloading = false;

                    vm.roomInformation = response.data;
                    vm.showAmenity = response.data.amenitiesdata.hasOwnProperty('Room features') > 0? true:false;

                    if(typeof vm.roomInformation.image == 'undefined')
                    vm.roomInformation.imagePath = EnvironmentConfig.api+'assets/uploads/product/room-service.svg';
                    else
                    vm.roomInformation.imagePath = EnvironmentConfig.api+'assets/uploads/hotels/org/'+vm.roomInformation.image;
                }else if(response.errorMsg){
                    toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                }else{
                    toastMessage.showSimpleToast('There was some error in getting description of this room.','error-toast');
                }
                var divWidth = $(".gantt-row-label").width();
                var newDivWidth = parseInt(divWidth)+35;
                newDivWidth = newDivWidth+"px";
                if(!tooltipArrowFromTop){
                    $('head').append('<style>.popup_roomdes{top:'+tooltipTop+';bottom:'+tooltipBottom+'}.popup_roomdes{left:'+newDivWidth+'}.popup_roomdes:before{top:auto !important;bottom:11px !important;}.popup_roomdes:after{top:auto !important;bottom:10px;}</style>');
                } else {
                    $('head').append('<style>.popup_roomdes{top:'+tooltipTop+';bottom:'+tooltipBottom+'}.popup_roomdes{left:'+newDivWidth+'}.popup_roomdes:before{top:11px !important;bottom:auto !important;}.popup_roomdes:after{top:10px !important;bottom:auto;}</style>');
                }
            });
        }   

         $scope.hide_description = function(){
            vm.roomInformation = '';
        }  

    }

})();

(function ()
{
    'use strict';
    angular.module('app.dashboards.gantt-chart')
        .controller('confirmPageController', confirmPageController);
    /** @ngInject */
    function confirmPageController($mdDialog, title, htmlContent, btnTxt, cancelTxt, localData)
    {
        var vm = this;
        var buttonBaseClass = 'md-raised md-accent submit-button grey-100-fg ';
        var invertButtonColors;

        localData = localData || {};
        invertButtonColors = !!localData.invertButtonColors;

        vm.title = title;
        vm.btnTxt = btnTxt;
        vm.cancelTxt = cancelTxt || 'Cancel';
        vm.cancelBtnClass = buttonBaseClass + (invertButtonColors ? 'md-green-500-bg' : 'md-red-500-bg');
        vm.confirmBtnClass = buttonBaseClass + (invertButtonColors ? 'md-red-500-bg' : 'md-green-500-bg');

        if(localData.newStatus){
			vm.newStatus = localData.newStatus;
			vm.send_email_indicator = localData.send_email_indicator;
		}else{
			vm.newStatus = '';
			vm.send_email_indicator = 0;
		}
        if(vm.title == 'DoNotMove Reservation'){
            vm.btnTxt = 'Ok';
        }
        vm.htmlContent = htmlContent;
        vm.closeDialog = closeDialog;
        function closeDialog(){
             $mdDialog.cancel();
        }
        vm.hideDialog = hideDialog;
        function hideDialog(){
            $mdDialog.hide({'answer' : 'update','email_indicator' : vm.send_email_indicator});
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboards')
        .controller('DashGraphDetailController', DashGraphDetailController);

    /** @ngInject */
    function DashGraphDetailController( 
    	$state, 
    	toastMessage, 
    	$scope, 
    	$http, 
    	EnvironmentConfig, 
    	$q, 
    	moment, 
    	$mdDialog, 
    	eCommerceService, 
    	$stateParams,
    	$rootScope,
    	$sessionStorage,
    	$timeout,
    	$window,
    	$localStorage,
    	dashboardDetails,
    	ganttChartServiceNew)
    {
		var vm = this;
		vm.listingType = (dashboardDetails.result !== undefined && dashboardDetails.result.listingtype !== undefined) ? dashboardDetails.result.listingtype : '';
		vm.paramsValue = $stateParams.param;
		vm.roomStatus = vm.paramsValue.split('=')[1];
		// vm.roomStatus = extraParam.roomStatus;
		if(!$rootScope.backButtonPressed){
			$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = {};
			$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] = 1;
        	$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'] = 20;
		}
		vm.requestGoing = false;
		vm.canDelete = false;
		var url = '';
		var extraParam = {};
		
		switch(vm.listingType) {
			case 'roomsListing' :
        		vm.UserColumns = ['s_no', 'product_name', 'product_room_number', 'product_is_clean'];
        		url = EnvironmentConfig.api+'DashboardGraph/getRoomsListingAccStatus';
        		extraParam = {
        			'listingFor': (dashboardDetails.result !== undefined && dashboardDetails.result.listingFor !== undefined) ? dashboardDetails.result.listingFor : '',
					'roomStatus': (dashboardDetails.result !== undefined && dashboardDetails.result.listingStatus !== undefined) ? dashboardDetails.result.listingStatus : ''
        		};
        		vm.title = 'Rooms';
        		break;

        	case 'reservationListing':
        		vm.UserColumns = ['itinerary_number', 'confirmation_number', 'product_name', 'created_date', 'customer_name', 'traveler', 'grand_total', 'paid_amount', 'remaining_amount', 'room_stay_status', 'room_stay_from', 'room_stay_to', 'source_of_creation', 'created_by_user' ];
        		url = EnvironmentConfig.api+'DashboardGraph/getResByFilter';
        		extraParam = {
        			'listingFor': (dashboardDetails.result !== undefined && dashboardDetails.result.listingFor !== undefined) ? dashboardDetails.result.listingFor : '',
					'roomStatus': (dashboardDetails.result !== undefined && dashboardDetails.result.listingStatus !== undefined) ? dashboardDetails.result.listingStatus : ''
        		};
        		vm.title = 'Reservations';
        		break;

        	default:
        		break;
        }
        vm.pageType = (dashboardDetails.result !== undefined && dashboardDetails.result.listingFor !== undefined) ? dashboardDetails.result.listingFor : '';
        
        /*Start*/
		$scope.paginatorCallback = paginatorCallback;
		$scope.LoadAllData = LoadAllData;
		$scope.getLoadResultsCallback = getLoadResultsCallback;

		$scope.selectedRowCallback = function(rows){
			vm.selectedUserId = rows;
		};
		var loadPageCallbackWithDebounce;
		$scope.statusValuesCallback = statusValuesCallback;
		$scope.createdValuesCallback = createdValuesCallback;
		$scope.checkinValuesCallback = checkinValuesCallback;
		$scope.checkoutValuesCallback = checkoutValuesCallback;
		$scope.statusValuesTransformer = statusValuesTransformer;
		$scope.cleanStatusValuesCallback = cleanStatusValuesCallback;


		$scope.$watch('filterText', function(){
			if(loadPageCallbackWithDebounce){
				loadPageCallbackWithDebounce();
			}
		});

        function getLoadResultsCallback(loadPageCallback){
			loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
        }

        vm.onLoad = true;
        function paginatorCallback(page, pageSize,option){
        	if(vm.requestGoing) return;
        	if(vm.onLoad == true){
        		if(typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] != 'undefined'){
        			var page1 =  $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
        			var pageSize1 = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'];
  					vm.onLoad = false;
        			return LoadAllData(page1, pageSize1,option);
        		}else{
	        		vm.onLoad = false;
	        		return LoadAllData(page, pageSize,option);		
        		}
        	}else{
        		if(typeof page == 'undefined'){
        			page = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
        		}
        		return LoadAllData(page, pageSize,option);
        	}
		}

		function LoadAllData(page, pageSize,option){
			vm.requestGoing = true;
			var pageDetail = {'currentPage':page,'pageSize':pageSize};
        	$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = pageDetail;
            vm.page = page;
            vm.pageSize = pageSize;
            vm.checkDelete = false;
            vm.selectedUserId = [];
            vm.search = [];

            var filtersApplied = option.columnFilter;            
            var sort = {};
            for(var i=0; i<option.columnSort.length; i++){
                if(option.columnSort[i]['sort']){
                    sort['column']= vm.UserColumns[i];
                    sort['order']= option.columnSort[i]['sort'];
                }
            }
            
            angular.forEach(filtersApplied, function(filter,key) {
				if(key == 3 && filter.length > 0 && vm.listingType == 'reservationListing'){
					filter = moment(filter[0]).format('YYYY-MM-DD');
					this.push('created_date:'+filter);
				} else if(key == 9 && filter.length > 0){
					this.push('room_stay_status:'+filter[0].name);
				} else if(key == 10 && filter.length > 0){
					filter = moment(filter[0]).format('YYYY-MM-DD');
					this.push('room_stay_from:'+filter);
				} else if(key == 11 && filter.length > 0){
					filter = moment(filter[0]).format('YYYY-MM-DD');
					this.push('room_stay_to:'+filter);
				} else{
					if(filter.length > 0 && filter[0].name != 'All'){
						this.push(filter[0].fieldValue + ':' + filter[0].name);
					}
				}
			}, vm.search);

            var offset = (page-1) * pageSize;
            var query = $scope.filterText ? $scope.filterText : '';
            var filterData = {
            	'offset': offset,
            	'pageSize': pageSize,
            	'search': $scope.filterText,
            	'sort': sort,
            	'customSearch': vm.search,
            	'pageType': vm.pageType,
            	'extraParam': extraParam
            };            
            return $http({
                url: url,
                method:'POST',
                data:filterData
            }).then(function(result){
				vm.templates = result.data.result;
				vm.totalReservations = result.data.total;
				vm.requestGoing = false;
				if($stateParams.toast_message){
					toastMessage.showSimpleToast($stateParams.toast_message,'error-toast');
					$stateParams.toast_message = false;
				}
				return {
					results: result.data.result,
					totalResultCount: result.data.total
				}
            });

		}

		function statusValuesCallback(){
			return $q.resolve([
			{
				name: 'All',fieldValue: 'room_stay_status'
			}, {
				name: 'Checked-In',fieldValue: 'room_stay_status'
			}, {
				name: 'Checked-Out',fieldValue: 'room_stay_status'
			}, {
				name: 'Closed',fieldValue: 'room_stay_status'
			}, {
				name: 'Active',fieldValue: 'room_stay_status'
			}, {
				name: 'Canceled',fieldValue: 'room_stay_status'
			}]);
		}
		function createdValuesCallback(){
			return $q.resolve('created_date');
		}
		function checkinValuesCallback(){
			return $q.resolve('room_stay_from');
		}
		function checkoutValuesCallback(){
			return $q.resolve('room_stay_to');
		}
		function statusValuesTransformer(statusObject){
			return statusObject.name;
		}

		function cleanStatusValuesCallback(){
			return $q.resolve([
				{ name: 'Clean', fieldValue: 'product_is_clean' },
				{ name: 'Light Clean', fieldValue: 'product_is_clean' },
				{ name: 'Dirty', fieldValue: 'product_is_clean' }
			]);
		}
		/*End*/



		 /**
         * Delete Selected Users
         */
         $scope.deleteSelectedItem = function(ev){
			var confirm = $mdDialog.confirm()
			.title('Are you sure, you want to delete the selected reservations(s)?')
			.htmlContent('<b>' + vm.selectedUserId.length + ' reservation(s)</b>' + ' will be deleted.')
			.ariaLabel('delete users')
			.targetEvent(ev)
			.ok('OK')
			.cancel('CANCEL');

			$mdDialog.show(confirm).then(function ()
			{
				eCommerceService.deleteSelOrder(vm.selectedUserId).then(function(response){
					if(response.success){
						vm.selectedUserId = [];
						loadPageCallbackWithDebounce();
					}else{
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					}
				});
			});
        }
        /**
         * Go to product detail
         *
         * @param id
         */
		$scope.goToEditPage= function(value) {
			value = value.split("-");
			if(vm.pageType == 'boat'){
				var url = $state.href("app.e-commerce.boatOrders.detail",{id:value[0],confirmation_number:value[1]});
			}else if(vm.pageType == 'rent'){
				var url = $state.href("app.e-commerce.rentOrders.detail",{id:value[0],confirmation_number:value[1]});
			} else {
				var url = $state.href("app.e-commerce.orders.detail",{id:value[0],confirmation_number:value[1]});				
			}
			$window.open(url, '_blank');
		};

		/**
		* @param: String confirmation_number
		* @param: String newStatus
		* @return: Boolean
		* Comment: Change the status of reservation to checkin or checkout
		*/
		$scope.changeStatus = function(confirmation_number, newStatus){
			var selectedrow = '';
			var flag = true;
			angular.forEach(vm.templates,function(val,key){
				if(flag){
					if(val.confirmation_number == confirmation_number){
						selectedrow = val;
						flag = false;
					}					
				}
			});
			selectedrow.name = selectedrow.customer_name !== undefined ? selectedrow.customer_name : '';
			selectedrow.resvType = vm.pageType;
			var remainingBalance = parseFloat(selectedrow.total_remaining_amount);
			vm.isloading = true;

			ganttChartServiceNew.processStatusRequest(selectedrow, newStatus, remainingBalance, 'checkInListing').then(function(result) {
				vm.isloading = false;
                if (result.hitRequest) {
                	loadPageCallbackWithDebounce();
                }
            });
		}
    }
})();

(function() {
    'use strict';

    angular
        .module('app.contacts')
        .controller('ContactController', ContactController);

    /** @ngInject */
    function ContactController(
        $document,
        $mdDialog,
        Contact,
        msUtils,
        $mdDateLocale,
        userService,
        $window,
        Country,
        toastMessage,
        $localStorage,
        $scope,
        $state,
        $timeout,
        $stateParams,
        $rootScope,
        $q,
        $log,
        $sessionStorage,
        createResService,
        eCommerceService
    ) {
        var pageLoaded = false;
        var newState = '';
        $scope.$watch('$viewContentLoaded',
            function() {
                $timeout(function() {
                    pageLoaded = true;
                }, 1000);
            });
        var vm = this;
        vm.isloading = false;

        // Customer Tags
        vm.systemTags = [];
        vm.hotelTags = [];
        vm.assignedTags = [];
        vm.tempAssignedTags = [];
        vm.systemTagSearch = '';
        vm.hotelTagSearch = '';
        vm.isCustomerTagsLoading = false;

        // Customer Family Members
        vm.maxDateOfBirth = new Date();
        vm.customerFamilyMembers = {
            isloading: false,
            data: []
        };
        vm.familyMemberForm = {
            first_name: '',
            last_name: '',
            customer_email: '',
            phone_number: '',
            date_of_birth: null,
            relationship_status: '',
            other_relationship: ''
        };
        vm.isSavingFamilyMember = false;
        vm.editingFamilyMember = null;
        vm.isUpdatingFamilyMember = false;
        vm.isFamilyMemberPhoneValid = true;
        vm.relationshipTypes = [];
        vm.familyMemberSearch = {
            first_name: '',
            last_name: '',
            customer_email: ''
        };
        vm.selectedFamilyMemberSearch = {
            first_name: null,
            last_name: null,
            customer_email: null
        };

        // Customer Pets
        vm.customerPets = {
            isloading: false,
            data: []
        };
        vm.customerPetForm = {
            name: '',
            date_of_birth: null,
            pet_type_id: null,
            other_pet_type: ''
        };
        vm.petTypes = {
            isloading: false,
            data: []
        };
        vm.otherPetTypeId = null;
        vm.editingCustomerPet = null;
        vm.isSavingCustomerPet = false;
        vm.isUpdatingCustomerPet = false;

        var organizationdata = {
            onlyOrganizations: true
        };
        vm.customerType = $stateParams.type != undefined ? $stateParams.type : 'normal';
        vm.autoFillOff = true;
        vm.userPermissions = $rootScope.userPermissions;
        vm.loggedInUserRole = angular.copy(parseInt($localStorage.roleId));
        vm.countryList = [];
        vm.stateList = [];
        Country.forEach(function(element) {
            vm.countryList.push(element.name);
        });

        vm.reservations = {
            heading: ['Product', 'Checkin', 'Checkout', 'Total', 'ADR', 'Created Date', 'Source'],
            data: [],
            totalResv: null,
            isloading: true
        };


        vm.goToState = function(a, confirmation_number, c) {
            if (!confirmation_number) {
                return;
            }
            var found = vm.reservations.data && vm.reservations.data.length ? vm.reservations.data.find(function(r) { return r.confirmation_number === confirmation_number; }) : null;
            var id = found ? found.reservation_id : null;
            if (id) {
                var url = $state.href('app.e-commerce.orders.detail', { id: id, confirmation_number: confirmation_number });
                $window.open(url, '_blank');
            }
        };

        vm.negotiatedCustomerType = Contact.negoCustomerTypes != undefined ? Contact.negoCustomerTypes : [];
        // Data
        vm.noCache = true;
        vm.gotocustomers = gotocustomers;
        if(typeof Contact['customerDetail'] != 'undefined'){
            vm.contact = Contact['customerDetail'];
        } else {
            vm.contact = [];
        }
        if(typeof Contact['customerShownData'] != 'undefined'){
            vm.shownContact = Contact['customerShownData'];
        } else {
            vm.shownContact = [];
        }
        vm.title = 'Edit Customer';
        vm.disableWeb = 'Edit';
        vm.disableEmail = 'Edit';
        vm.disSubmit = true;
        vm.status = [{
            'value': 1,
            'name': 'Active'
        }, {
            'value': 0,
            'name': 'Inactive'
        }]
        vm.gender = [{
            'value': 1,
            'name': 'Male'
        }, {
            'value': 0,
            'name': 'Female'
        }]
        vm.balance = 0.0;

        vm.newContact = false;
        vm.allFields = false;
        vm.amountError = false;

        vm.hotelId = $localStorage.hotels[$localStorage.selectedHotel].hotel_id != undefined ? $localStorage.hotels[$localStorage.selectedHotel].hotel_id : 0;

        if ($stateParams.customer_id && !vm.contact.length) {
            if (vm.customerType == 'negotiated') {
                $state.go('app.negotiatedCustomers');
            } else {
                $state.go('app.contacts');
            }
        }


        vm.emailCount = [];
        vm.emailIndex = 0;
        vm.userEmail = [];
        vm.otherEmailError = [];
        vm.otherValidEamil = [];
        var flag = 'add';
        if (!vm.contact.length) { //add
            vm.contact = {
            };
            vm.title = 'New Customer';
            vm.disableWeb = 'Add';
            vm.disableEmail = 'Add';
            vm.newContact = true;
            vm.contact.phone_number = '';
            vm.amountExceeds = '';
            vm.contact.tax_exempt_indicator = false;
            vm.countries = vm.states = [];
            vm.contact.send_email_indicator = true;
            // vm.amountExceeds = 'PLease enter the amount less than balance remaining.';
             vm.selectedCountry = {value: "united states", display: "United States"};
        } else {
            flag = 'edit';
            //edit
            vm.contact = vm.contact[0];
            vm.userEmail =  Contact['allEmails'];
            if(Contact['emailWithId']){
                Contact['emailWithId'].forEach(function(element){
                    vm.emailIndex = parseInt(vm.emailIndex) + 1;
                    vm.emailCount.push({'count':vm.emailIndex, 'id':element['id'], 'email':element['customer_email']});
                });
            }

            vm.contact.date_of_birth = vm.contact.date_of_birth == '' ? null : new Date(vm.contact.date_of_birth);
            vm.contact.phone_number = vm.contact.phone_number == 0 ? '' : vm.contact.phone_number;
            vm.contact.tax_exempt_indicator = vm.contact.tax_exempt_indicator == 1? true:false;
            vm.contact.send_email_indicator = vm.contact.send_email_indicator == 1? true:false;
            vm.updateHotelCredit = updateHotelCredit;

            function updateHotelCredit() {
                userService.getHotelCreditHistory(vm.contact.customer_id).then(function(response) {
                    vm.customerAllCredits = response[0].credits;
                    vm.balance = response[0].total;
                    if (response[0].total == null || response[0].total == '') {
                        vm.balance = 0;
                    }
                });
            }
            updateHotelCredit();
            $scope.updateHotelCredit_update = function() {
                updateHotelCredit();
            }

            vm.countries = [{
                name: vm.contact.country,
                display:vm.contact.country
            }];
            vm.selectedCountry = [];

             vm.searchTxtState = vm.contact.state;



            if(vm.contact.country){
                vm.selectedCountry['display'] = vm.contact.country;
                vm.selectedCountry['value'] = vm.contact.country.toLowerCase();
                vm.selectedCountry = vm.selectedCountry;
                selectedItemChange();
            }


        }
        // Methods
        vm.addNewContact = addNewContact;
        vm.saveContact = saveContact;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.validateEmail = validateEmail;
        vm.showPrerenderedDialog = showPrerenderedDialog;

        // Tags Methods
        vm.manageTags = manageTags;
        vm.getCustomerInitials = getCustomerInitials;
        vm.saveCustomerTags = saveCustomerTags;
        vm.assignTag = assignTag;
        vm.clearAllTags = clearAllTags;
        vm.removeAssignedTag = removeAssignedTag;
        vm.unassignedTagsFilter = unassignedTagsFilter;
        vm.closeTagsDialog = closeTagsDialog;

        // Family Members Methods
        vm.loadCustomerFamilyMembers = loadCustomerFamilyMembers;
        vm.saveFamilyMember = saveFamilyMember;
        vm.editFamilyMember = editFamilyMember;
        vm.cancelEditFamilyMember = cancelEditFamilyMember;
        vm.updateFamilyMember = updateFamilyMember;
        vm.deleteFamilyMember = deleteFamilyMember;
        vm.getRelationshipTypes = getRelationshipTypes;
        vm.queryFamilyMemberSearch = queryFamilyMemberSearch;
        vm.selectFamilyMemberCustomer = selectFamilyMemberCustomer;
        vm.updatePhoneWithCountryCode = updatePhoneWithCountryCode;
        vm.openAddFamilyMemberDialog = openAddFamilyMemberDialog;
        vm.openEditFamilyMemberDialog = openEditFamilyMemberDialog;
        vm.closeFamilyMemberDialog = closeFamilyMemberDialog;

        // Pets Methods
        vm.loadCustomerPets = loadCustomerPets;
        vm.saveCustomerPet = saveCustomerPet;
        vm.editCustomerPet = editCustomerPet;
        vm.cancelEditCustomerPet = cancelEditCustomerPet;
        vm.updateCustomerPet = updateCustomerPet;
        vm.deleteCustomerPet = deleteCustomerPet;
        vm.openAddPetDialog = openAddPetDialog;
        vm.openEditPetDialog = openEditPetDialog;
        vm.closePetDialog = closePetDialog;

        // Load tags if editing an existing customer
        if (flag === 'edit' && vm.contact.customer_id) {
            loadCustomerTags();
            loadCustomerFamilyMembers();
            loadCustomerPets();
            loadPetTypes();
            getRelationshipTypes();
        }        
        /*vm.countries = [{name:'sad',id:10},{name:'ssad',id:120}];*/

        vm.addMultipleEmail = addMultipleEmail;


        function addMultipleEmail(){
            vm.emailIndex = parseInt(vm.emailIndex) + 1;
            vm.emailCount.push({'count':vm.emailIndex, 'id':'', 'email':''});
        }
        vm.deleteThisEmail = deleteThisEmail;
        function deleteThisEmail(index){
            vm.emailCount.splice(index, 1);
            vm.userEmail.splice(index, 1);
        }
        vm.validateOtherEmail = validateOtherEmail;
        function validateOtherEmail(index){
            var emailExists = false;

            for(var arrayKey in vm.emailCount){
                if(vm.emailCount[arrayKey]['email'] == vm.userEmail[index] || vm.userEmail[index] == vm.contact.customer_email ){
                    emailExists = true;
                }
            }
            if(!emailExists){
                vm.emailCount[arrayKey]['email'] = vm.userEmail[index];
                var re = /^.+@.+\..+$/;
                var validEmail = re.test(vm.userEmail[index]);
                vm.otherValidEamil[index] = false;
                if(typeof vm.userEmail[index] != 'undefined' && validEmail){
                    userService.validateEmail(vm.userEmail[index],  vm.contact.customer_id, vm.emailCount[index]['id']).then(function(response){
                        vm.emailCount[index]['id'] = response.emailId;
                        if(response.success){
                            vm.otherEmailError[index] = true;
                            vm.emailCount[index]['id'] = response.emailId;
                        } else {
                            if(response['sameEmailExists']){
                                vm.otherEmailError[index] = true;
                            } else {
                                vm.otherEmailError[index] = false;
                            }

                         }
                    });
                } else {
                    vm.otherEmailError[index] = false;
                    vm.otherValidEamil[index] = true;
                }
            } else {
                 vm.otherEmailError[index] = true;
            }

        }

        vm.deleteThisEmail = deleteThisEmail;
        function deleteThisEmail(index){
            userService.deleteOtherEmail({id:vm.emailCount[index]['id']}).then(function(response){
                if(response.success){
                    vm.emailCount.splice(index, 1);
                    vm.userEmail.splice(index,1);
                }
            });
        }


        vm.selectedItemChangeStateTraveller = selectedItemChangeStateTraveller;
        function selectedItemChangeStateTraveller(query){
            if(vm.searchTxtCountry){
                var deferred = $q.defer();
                      createResService.getAllStates({state:query,country:vm.searchTxtCountry})
                      .then(function(response) {
                        deferred.resolve(response.states);
                      });
                      return deferred.promise;

            } else {
                return [];
            }

        }

        vm.selectedItemChangeState = selectedItemChangeState;
        function selectedItemChangeState(){
            saveContact('state');
        }
        /*function to */
        function showPrerenderedDialog(ev) {
            var MlsData = {
                id: vm.contact.customer_id,
                balance: vm.balance
            };

            $mdDialog.show({
                controller: 'hotelCreditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/contacts/hotelCredit.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                locals: {
                    mlsData: MlsData
                }
            });
        }
        vm.updatePhoneWithCountryCode = function(fieldName, $event) {
            var inputElement = $event ? ($event.target || $event.srcElement) : null;
            if (!inputElement) {
                inputElement = document.querySelector('input[name="' + fieldName + '"]');
            }
            if (!inputElement) return;

            var iti = angular.element(inputElement).data('iti');
            if (!iti && window.intlTelInputGlobals && window.intlTelInputGlobals.getInstance) {
                iti = window.intlTelInputGlobals.getInstance(inputElement);
            }
            if (!iti) return;

            var inputValue = (inputElement.value || '').trim();
            var fullNumber = iti.getNumber();
            var isValid = !inputValue || iti.isValidNumberPrecise();

            // Match order page: toggle invalid class for intl-tel-input styling
            angular.element(inputElement).toggleClass('ng-invalid', !isValid);
            angular.element(inputElement).toggleClass('ng-valid', isValid);
            if (inputValue) {
                angular.element(inputElement).addClass('ng-dirty');
            }

            var ngModelCtrl = $scope.contactForm && $scope.contactForm[fieldName];
            if (ngModelCtrl) {
                ngModelCtrl.$setValidity('phoneInvalid', isValid);
            }

            var familyFormCtrl = $scope.familyMemberDialogForm && $scope.familyMemberDialogForm[fieldName];
            if (familyFormCtrl) {
                familyFormCtrl.$setValidity('phoneInvalid', isValid);
                if (inputValue) {
                    familyFormCtrl.$setDirty();
                }
            }

            if (fieldName === 'family_member_phone') {
                vm.isFamilyMemberPhoneValid = isValid;
                if (fullNumber) {
                    vm.familyMemberForm.phone_number = fullNumber;
                }
            }
        };

        function getPhoneWithCountryCode(fieldName) {
            var inputElement = document.querySelector('input[name="' + fieldName + '"]');
            if (!inputElement) return '';

            var iti = angular.element(inputElement).data('iti');
            if (!iti) return '';

            var dialCode = '+' + iti.getSelectedCountryData().dialCode;
            var inputValue = inputElement.value.trim();

            if (!inputValue) return '';
            if (inputValue.startsWith(dialCode)) {
                return inputValue;
            }
            return dialCode + ' ' + inputValue;
        }

        /**
         * Add new contact
         */
        /*
         * Format DOB for API/DB as MM-DD-YYYY (e.g. 09-10-2002).
         * Keeps md-datepicker Date object in the UI model.
         */
        function formatDateOfBirthForApi(value) {
            if (!value) {
                return '';
            }

            var dobMoment = moment(value);

            if (!dobMoment.isValid()) {
                return '';
            }

            return dobMoment.format('MM-DD-YYYY');
        }

        function addNewContact() {
            vm.isloading = true;
            var contactToSend = angular.copy(vm.contact);
            var phoneFields = ['phone_number', 'secondary_phone_number'];
            phoneFields.forEach(function(fieldName) {
              var inputElement = document.querySelector('input[name="' + fieldName + '"]');
              if (inputElement) {
                var iti = angular.element(inputElement).data('iti');
                if (iti) {
                  var dialCode = '+' + iti.getSelectedCountryData().dialCode;
                  var inputValue = inputElement.value.trim();
                  if (inputValue) {
                    if (inputValue.startsWith(dialCode)) {
                      contactToSend[fieldName] = inputValue; // already has dial code
                    } else {
                      contactToSend[fieldName] = dialCode + ' ' + inputValue; // space ke saath ✓
                    }
                  }
                }
              }
            });
            contactToSend.tax_exempt_indicator = contactToSend.tax_exempt_indicator ? 1 : 0;
            contactToSend.send_email_indicator = contactToSend.send_email_indicator ? 1 : 0;
            contactToSend.hotel_id = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
            contactToSend.customer_source = 'PMS';
            contactToSend.date_of_birth = formatDateOfBirthForApi(
                contactToSend.date_of_birth
            );
            if (vm.searchTxtCountry) {
                contactToSend.country = vm.searchTxtCountry;
            }
            if(vm.searchTxtState){
                contactToSend.state = vm.searchTxtState;
            }
            if(vm.userEmail){
                contactToSend.userEmail =  vm.userEmail;
            }
            var tempObj = JSON.stringify(contactToSend);
            userService.addUser(tempObj)
                .then(function(response) {
                    if (response.success) {
                        if (response.errorMsg) {
                            toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                        }
                        if (vm.customerType == 'negotiated') {
                            $state.go('app.negotiatedCustomers');
                        } else {
                            $state.go('app.contacts');
                        }
                    } else if (response.errorMsg) {
                        toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                    } else {
                        toastMessage.showSimpleToast('There was some error in saving customer.', 'error-toast');
                    }
                    vm.isloading = false;
                });
        }

        /**
         * Save contact
         */
        function saveContact(field_name, val) {
            vm.isloading = true;

            if (vm.newContact === false && pageLoaded == true) {
                var fields = true;
                if ((field_name == 'passwordConfirm' || field_name == 'password') && ((vm.contact.passwordConfirm == undefined) || ((vm.password) == undefined) || (vm.password != vm.contact.passwordConfirm))) {
                    fields = false;
                } else if (field_name == 'customer_email' && vm.contact[field_name] == undefined) {
                    fields = false;
                }
                if (field_name == 'country'){
                    vm.getStates();
                    vm.contact.state = '';
                    vm.searchTxtState = val;
                    vm.contact['country'] = vm.searchTxtCountry;

                }
                if(field_name == 'state'){
                    vm.contact['state'] = vm.searchTxtState ? vm.searchTxtState : val;
                }

                if (fields) {
                    vm.contact.hotel_id = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;

                    var contactToSave = angular.copy(vm.contact);

                    if (field_name === 'phone_number' || field_name === 'secondary_phone_number') {
                      var formattedNumber = getPhoneWithCountryCode(field_name);
                      contactToSave[field_name] = formattedNumber;
                    }

                    /*
                     * Always send DOB as MM-DD-YYYY for DB storage.
                     */
                    contactToSave.date_of_birth = formatDateOfBirthForApi(
                        contactToSave.date_of_birth
                    );

                    userService.updateCustomer(contactToSave, field_name)
                        .then(function(response) {
                            if (response.duplicateEmail) {
                                vm.emailError = true;
                            } else if (!response.success) {
                                toastMessage.showSimpleToast('There was some error in saving customer.', 'error-toast');
                                vm.emailError = false;
                            } else {
                                vm.emailError = false;
                            }
                            vm.isloading = false;
                        });
                } else {
                    vm.isloading = false;
                }
            }
            else {
                validateEmail();
                vm.isloading = false;
            }

        }

        function validateEmail() {
            vm.isloading = true;
            $timeout(function() {
                if (vm.newContact === true) {
                    vm.emailError = false;
                    if (vm.contact.customer_email) {
                        userService.validateEmail(vm.contact.customer_email, vm.contact.customer_id)
                            .then(function(response) {
                                if (response.success) {
                                    vm.emailError = 'This email id already registered';
                                    vm.disSubmit = false;
                                } else {
                                    vm.disSubmit = true;
                                    vm.emailError = false;
                                }
                            });
                    }
                }
            }, 600);
            vm.isloading = false;
        }

        function gotocustomers() {
            if ($stateParams.from === "customer-search") {
              $state.go("app.customerCalendarSearch");
              return;
            }
            if (vm.customerType == 'negotiated') {
                $state.go('app.negotiatedCustomers');
            } else {
                $state.go('app.contacts');
            }
        }

        vm.getCountries = function() {

            vm.isloading = true;
            if (Object.keys(vm.countries).length <= 1) {
                return $timeout(function() {
                    userService.getCountries().then(function(response) {
                        vm.countries = response;
                        vm.isloading = false;
                    });
                }, 1500);
            }
        }

        vm.getStates = function() {
            vm.isloading = true;
            return $timeout(function() {
                userService.getStates(vm.contact.country).then(function(response) {
                    vm.states = response;
                    vm.isloading = false;
                });
            }, 1500);
        }
        /*Search For country start*/
        vm.simulateQuery = false;
        vm.isDisabled = false;

        // list of `state` value/display objects
        vm.myCountryArr = loadAll();

        vm.queryCountrySearch = queryCountrySearch;
        vm.selectedCountryChange = selectedCountryChange;
        vm.searchCountry = searchCountry;

        vm.newState = newState;

        function newState(state) {
            alert("Sorry! You'll need to create a Constitution for " + state + " first!");
        }

        function queryCountrySearch(query) {
            var results = query ? vm.myCountryArr.filter(createFilterForCountry(query)) : vm.myCountryArr,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function() {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }

        }

        function searchCountry(text) {
            $log.info('Text changed to ' + text);
        }

        function selectedCountryChange(item) {
            $log.info('Item changed to ' + JSON.stringify(item));
        }

        /**
         * Build `states` list of key/value pairs
         */


        function loadAll() {
            var allStates = vm.countryList;
            return allStates.map(function(state) {
                return {
                    value: state.toLowerCase(),
                    display: state
                };
            });
        }


        /**
         * Create filter function for a query string
         */
        function createFilterForCountry(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };

        }
        /*Search For country end*/
        vm.selectedItemChange = selectedItemChange;
        function selectedItemChange() {
            vm.contact.country = vm.selectedCountry['display'];
            if (typeof vm.selectedCountry['display'] != undefined || vm.selectedCountry['display'] != '') {
                //vm.selectedState = '';
                vm.isloading = true;
                userService.getStates(vm.contact.country).then(function(response) {
                    response.forEach(function(element) {
                        vm.stateList.push(element.name);
                    });
                    vm.isloading = false;
                });
                saveContact('country', newState);
            }
        }

        /*state start*/
        vm.simulateQuery = false;
        vm.isDisabled = false;
        // list of `state` value/display objects
        vm.queryStateSearch = queryStateSearch;

        function queryStateSearch(query) {
            var results = query ? vm.myStateArr.filter(createFilterForState(query)) : vm.myStateArr,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function() {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }

        /**
         * Build `states` list of key/value pairs
         */
        function loadAllState() {
            return vm.stateList.map(function(state) {
                return {
                    value: state.toLowerCase(),
                    display: state
                };
            });
        }

        /**
         * Create filter function for a query string
         */
        function createFilterForState(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };
        }

        /*****************************************/
        /***** Geolocation autocomplete form *****/
        /*****************************************/
        var fullAddress = '';
        var result = '';

        initAutocomplete();
        function initAutocomplete() {
            setTimeout(function(){
                var autocomplete = new google.maps.places.Autocomplete(
                    (document.getElementById('autocomplete')),
                    {types: ['geocode']}
                );
                autocomplete.addListener('place_changed', function() {
                    result = autocomplete.getPlace();
                    getGeoData(result);
                });
            }, 50);
        }


        /*****************************************/
        /***** Geolocation autocomplete form *****/
        /*****************************************/
        initAutocompleteZip();
        function initAutocompleteZip() {
            setTimeout(function(){
                var autocompletezip = new google.maps.places.Autocomplete(
                    (document.getElementById('autocompletezip')),
                    {types: ['geocode']}
                );
                autocompletezip.addListener('place_changed', function() {
                    result = autocompletezip.getPlace();
                    getGeoData(result);
                });
            }, 50);
        }

        var addressData = {};
        function getGeoData(result) {
            addressData = {};
            var country = '';
            var state = '';
            var city = '';
            var postal_code = '';
            var street = '';
            var street_number = '';
            var sublocality = '';
            var sublocality2 = '';
            var neighborhood = '';
            if(result && result.address_components && result.address_components.length != 0) {
                for(var i = 0; i<result.address_components.length; i += 1) {
                    var addressObj = result.address_components[i];
                    for(var j = 0; j < addressObj.types.length; j += 1) {
                        switch(addressObj.types[j]){
                            case "country":                      country = addressObj.long_name;         break;  //Country
                            case "administrative_area_level_1" : state  = addressObj.long_name;         break;  //State
                            case "administrative_area_level_2" : country = addressObj.long_name;        break;  //County
                            case "locality" :                    city    = addressObj.long_name;         break;  //City
                            case "route":                        street = addressObj.long_name;          break;  //street
                            case "neighborhood":                 neighborhood = addressObj.long_name;    break;  //street
                            case "sublocality_level_2":          sublocality2 = addressObj.long_name;    break;  //street
                            case "sublocality_level_1":          sublocality = addressObj.long_name;     break;  //street
                            case "sublocality":                  sublocality = addressObj.long_name;     break;  //street
                            case "street_number":                street_number =  addressObj.long_name;  break;  //street number
                            case "postal_code":                  postal_code = addressObj.long_name;     break;  //Postal Code
                        }
                    }
                }
                addressData.zip_code = postal_code;
                addressData.address  = street_number + " " + sublocality + " " + sublocality2 + " " + street;
                addressData.city     = city;
                addressData.state    = state;
                addressData.country  = country;
            }
            if(!postal_code) {
                var data = {
                    address: result.name
                };
                userService.getZipCode(data).then(function(res) {
                    addressData.country = res.country;
                    addressData.state = res.administrative_area_level_1;
                    addressData.city = res.locality;
                    street_number = res.street_number ? res.street_number : '';
                    street = res.route ? res.route : '';
                    neighborhood = res.neighborhood ? res.neighborhood : '';
                    addressData.address = street_number + ' ' + street;
                    addressData.zip_code = res.postal_code;
                });
            } else {
                addressData.zip_code = postal_code ? postal_code : '';
            }
            $timeout(function() {
                vm.contact.country = addressData.country;
                vm.contact.state = addressData.state;
                vm.contact.city = addressData.city;
                vm.contact.address = addressData.address ? addressData.address.trim() : '';
                vm.contact.zip_code = addressData.zip_code;
                vm.selectedCountry = addressData.country;
                vm.searchTxtCountry = addressData.country;
                vm.searchTxtState = addressData.state;
                newState = vm.searchTxtState;
                if(flag === 'edit') {
                    vm.saveContact('country', newState);
                    vm.saveContact('city');
                    vm.saveContact('address');
                    vm.saveContact('zipcode');
                    $timeout(function() {
                        vm.saveContact('state', newState);
                    }, 500);
                } else {
                    if(addressData.state) {
                        vm.selectedState = {name: addressData.state};
                    }
                }
                $timeout(function() {
                    angular.element('#autocompletezip').val(vm.contact.zip_code);
                    angular.element('#autocomplete').val(vm.contact.address);
                }, 1000);
            }, 1000);
        }
        /*state End*/


        setTimeout(function() {
            vm.autoFillOff = false;
        }, 1500);

        vm.getReservations = function() {
            if (!vm.contact || !vm.contact.customer_id) return;
            vm.reservations.isloading = true;
            userService.getSingleCustomerReservations(vm.contact.customer_id).then(function(response) {
                vm.reservations.data = response.reservations;
                vm.reservations.totalResv = response.reservations ? response.reservations.length : null;
                vm.reservations.isloading = false;
            })
        };
        vm.getReservations();
        
        vm.getCustomerTagStyle = function(color) {
            if (!color) {
                color = '#00a3bd';
            }

            return {
                color: color,
                background: 'color-mix(in srgb, ' + color + ' 12%, transparent)',
                border: '1px solid color-mix(in srgb, ' + color + ' 35%, transparent)'
            };
        };

        // ========== Customer Tags Functions ==========

        function loadCustomerTags() {
            vm.isCustomerTagsLoading = true;
            userService.getCustomerTags(vm.contact.customer_id)
                .then(function (response) {
                    if (!response.success) {
                        vm.isCustomerTagsLoading = false;
                        return;
                    }

                    // System Tags
                    angular.forEach(response.data.systemTags, function (tag) {
                        tag.type = 'system';
                        if (!vm.systemTags.some(function (t) { return t.id === tag.id; })) {
                            vm.systemTags.push(tag);
                        }
                        if (tag.selected) {
                            if (!vm.assignedTags.some(function (t) { return t.id === tag.id; })) {
                                vm.assignedTags.push(tag);
                            }
                        }
                    });

                    // Hotel Tags
                    angular.forEach(response.data.hotelTags, function (tag) {
                        tag.type = 'hotel';
                        if (!vm.hotelTags.some(function (t) { return t.id === tag.id; })) {
                            vm.hotelTags.push(tag);
                        }
                        if (tag.selected) {
                            if (!vm.assignedTags.some(function (t) { return t.id === tag.id; })) {
                                vm.assignedTags.push(tag);
                            }
                        }
                    });

                    // Update the contact.customer_tag array for display
                    vm.contact.customer_tag = vm.assignedTags.map(function (t) { return {name: t.name, colour_code: t.colour_code}; });
                    vm.isCustomerTagsLoading = false;
                });
        }

        function manageTags($event) {
            vm.tempAssignedTags = angular.copy(vm.assignedTags);
            $mdDialog.show({
                contentElement: '#CustomerTags',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true
            });
        }

        function saveCustomerTags() {
            var payload = {
                customer_id: vm.contact.customer_id,
                tag_ids: vm.tempAssignedTags.map(function (tag) {
                    return parseInt(tag.id);
                })
            };
            userService.saveCustomerTags(payload)
                .then(function (response) {
                    if (response.success) {
                        vm.assignedTags = angular.copy(vm.tempAssignedTags);
                        vm.contact.customer_tag = vm.assignedTags.map(function (t) { return {name: t.name, colour_code: t.colour_code}; });
                        closeTagsDialog();
                    }
                });
        }

        function getCustomerInitials() {
            var first = (vm.contact.first_name || '');
            var last = (vm.contact.last_name || '');
            var initials = '';
            if (first.length) { initials += first.charAt(0); }
            if (last.length) { initials += last.charAt(0); }
            return initials.toUpperCase();
        }

        function assignTag(tag) {
            if (!vm.tempAssignedTags.some(function (t) { return t.id === tag.id; })) {
                vm.tempAssignedTags.push(tag);
            }
        }

        function removeAssignedTag(tag) {
            var index = vm.tempAssignedTags.findIndex(function (t) { return t.id === tag.id; });
            if (index > -1) {
                vm.tempAssignedTags.splice(index, 1);
            }
        }

        function clearAllTags() {
            vm.tempAssignedTags = [];
        }

        function unassignedTagsFilter(tag) {
            if (!vm.tempAssignedTags) return true;
            return !vm.tempAssignedTags.some(function (t) { return t.id === tag.id; });
        }

        function closeTagsDialog() {
            $mdDialog.hide();
        }

        // ========== Customer Family Members Functions ==========

        function loadCustomerFamilyMembers() {
            if (vm.customerFamilyMembers.isloading) {
                return;
            }

            var customerId = vm.contact && vm.contact.customer_id;
            if (!customerId) {
                return;
            }

            vm.customerFamilyMembers.isloading = true;

            eCommerceService.getCustomerFamilyMembers(customerId).then(function(response) {
                if (response.data && response.success) {
                    vm.customerFamilyMembers.data = response.data || [];
                } else {
                    vm.customerFamilyMembers.data = [];
                }
            }).catch(function(error) {
                toastMessage.showSimpleToast(
                    error.message || 'Unable to load family members.',
                    "error-toast"
                );
                vm.customerFamilyMembers.data = [];
            }).finally(function() {
                vm.customerFamilyMembers.isloading = false;
            });
        }

        function saveFamilyMember() {
            if (vm.isSavingFamilyMember) {
                return;
            }

            var form = vm.familyMemberForm;

            if (!form.first_name || !form.last_name || !form.relationship_id || !form.customer_email) {
                return;
            }

            if (vm.isFamilyMemberPhoneValid === false) {
                return;
            }

            vm.isSavingFamilyMember = true;

            var dobString = '';
            if (form.date_of_birth) {
                if (form.date_of_birth instanceof Date) {
                    dobString = moment(form.date_of_birth).format('MM-DD-YYYY');
                } else {
                    dobString = form.date_of_birth;
                }
            }
            var phoneNumber = form.phone_number || '';
            var phoneInput = document.getElementById(
                'familyMemberPhoneNumber'
            );
            if (phoneInput) {
                var iti = angular.element(phoneInput).data('iti');
                if (
                !iti &&
                window.intlTelInputGlobals &&
                window.intlTelInputGlobals.getInstance
                ) {
                iti =
                    window.intlTelInputGlobals.getInstance(
                    phoneInput
                    );
                }
                if (iti) {
                phoneNumber = iti.getNumber();
                /*
                * Keep Angular model synchronized as well.
                */
                vm.familyMemberForm.phone_number =
                    phoneNumber;
                }
            }
            var data = {
                customer_id: vm.contact.customer_id,
                first_name: form.first_name.trim(),
                last_name: form.last_name.trim(),
                customer_email: form.customer_email ? form.customer_email.trim() : '',
                phone_number: phoneNumber || '',
                relationship_id: form.relationship_id,
                date_of_birth: dobString
            };

            eCommerceService.addFamilyMember(data)
                .then(function(response) {
                    if (response && response.success) {
                        if (!vm.customerFamilyMembers.data) {
                            vm.customerFamilyMembers.data = [];
                        }

                        vm.customerFamilyMembers.data.unshift(response.data);

                        vm.familyMemberForm = {
                            first_name: '',
                            last_name: '',
                            customer_email: '',
                            phone_number: '',
                            relationship_id: null,
                            date_of_birth: null
                        };

                        vm.familyMemberSearch = {
                            first_name: '',
                            last_name: '',
                            customer_email: ''
                        };

                        vm.selectedFamilyMemberSearch = {
                            first_name: null,
                            last_name: null,
                            customer_email: null
                        };

                        resetFamilyMemberDialogFormState();
                        closeFamilyMemberDialog();
                    } else {
                        toastMessage.showSimpleToast(
                            (response && response.message) || 'Unable to add family member.',
                            "error-toast"
                        );
                    }
                })
                .catch(function(error) {
                    toastMessage.showSimpleToast(error.message || 'Unable to add family member.', 'error-toast');
                })
                .finally(function() {
                    vm.isSavingFamilyMember = false;
                });
        }

        function editFamilyMember(member) {
            if (!member) {
                return;
            }
            vm.editingFamilyMember = member;

            vm.familyMemberSearch = {
                first_name: member.first_name || '',
                last_name: member.last_name || '',
                customer_email: member.customer_email || ''
            };

            vm.selectedFamilyMemberSearch = {
                first_name: member,
                last_name: member,
                customer_email: member
            };

            var familyDob = null;
            if (member.date_of_birth) {
                if (member.date_of_birth instanceof Date) {
                    familyDob = member.date_of_birth;
                } else {
                    var dob = String(member.date_of_birth).trim();
                    if (/^\d{4}-\d{2}-\d{2}$/.test(dob)) {
                        var parts = dob.split('-');
                        familyDob = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10), 12, 0, 0);
                    } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(dob)) {
                        var usParts = dob.split('/');
                        familyDob = new Date(parseInt(usParts[2], 10), parseInt(usParts[0], 10) - 1, parseInt(usParts[1], 10), 12, 0, 0);
                    } else {
                        familyDob = new Date(dob);
                    }
                }
                if (familyDob instanceof Date && isNaN(familyDob.getTime())) {
                    familyDob = null;
                }
            }

            vm.familyMemberForm = {
                customer_id: member.customer_id,
                first_name: member.first_name || '',
                last_name: member.last_name || '',
                customer_email: member.customer_email || '',
                phone_number: '',
                date_of_birth: familyDob,
                relationship_id: member.relationship_id ? parseInt(member.relationship_id, 10) : null
            };

            $timeout(function() {
                var phoneInput = document.getElementById('familyMemberPhoneNumberContact');
                if (!phoneInput) return;

                var iti = angular.element(phoneInput).data('iti');
                if (!iti && window.intlTelInputGlobals && window.intlTelInputGlobals.getInstance) {
                    iti = window.intlTelInputGlobals.getInstance(phoneInput);
                }

                if (iti) {
                    phoneInput.value = '';
                    iti.setNumber(member.phone_number || '');
                    vm.familyMemberForm.phone_number = iti.getNumber();
                } else {
                    vm.familyMemberForm.phone_number = member.phone_number || '';
                    phoneInput.value = member.phone_number || '';
                }

                $timeout(function() {
                    if (iti) {
                        vm.familyMemberForm.phone_number = iti.getNumber();
                    }
                    $scope.$applyAsync();
                }, 0);
            }, 0);
        }

        function cancelEditFamilyMember() {
            vm.editingFamilyMember = null;
            resetFamilyMemberForm();
        }

        function resetFamilyMemberForm() {
            vm.isFamilyMemberPhoneValid = true;
            vm.familyMemberForm = {
                customer_id: null,
                first_name: '',
                last_name: '',
                customer_email: '',
                phone_number: '',
                date_of_birth: null,
                relationship_id: null
            };

            vm.familyMemberSearch = {
                first_name: '',
                last_name: '',
                customer_email: ''
            };

            vm.selectedFamilyMemberSearch = {
                first_name: null,
                last_name: null,
                customer_email: null
            };

            var phoneInput = document.getElementById('familyMemberPhoneNumberContact');
            if (phoneInput) {
                phoneInput.value = '';
                var iti = angular.element(phoneInput).data('iti');
                if (!iti && window.intlTelInputGlobals && window.intlTelInputGlobals.getInstance) {
                    iti = window.intlTelInputGlobals.getInstance(phoneInput);
                }
                if (iti) {
                    iti.setNumber('');
                }
            }
        }

        function updateFamilyMember() {
            if (vm.isUpdatingFamilyMember || !vm.editingFamilyMember) {
                return;
            }

            var form = vm.familyMemberForm;
            if (!form.first_name || !form.last_name || !form.relationship_id) {
                return;
            }

            if (vm.isFamilyMemberPhoneValid === false) {
                return;
            }

            var customerId = parseInt(vm.contact.customer_id, 10);
            var relatedCustomerId = parseInt(vm.editingFamilyMember.customer_id, 10);

            if (!customerId || !relatedCustomerId) {
                toastMessage.showSimpleToast('Invalid family relationship.', 'error-toast');
                return;
            }

            var dobString = '';
            if (form.date_of_birth) {
                var dobMoment = moment(form.date_of_birth);
                if (dobMoment.isValid()) {
                    dobString = dobMoment.format('MM-DD-YYYY');
                }
            }

            var relationshipId = parseInt(form.relationship_id, 10);
            if (!relationshipId) {
                toastMessage.showSimpleToast('Please select a relationship.', 'error-toast');
                return;
            }

            var data = {
                customer_id: customerId,
                related_customer_id: relatedCustomerId,
                first_name: String(form.first_name || '').trim(),
                last_name: String(form.last_name || '').trim(),
                customer_email: String(form.customer_email || '').trim(),
                phone_number: form.phone_number || '',
                date_of_birth: dobString,
                relationship_id: relationshipId
            };

            vm.isUpdatingFamilyMember = true;

            eCommerceService.updateFamilyMember(data)
                .then(function(response) {
                    if (response && response.success === true) {
                        if (response.data && vm.customerFamilyMembers.data) {
                            var index = vm.customerFamilyMembers.data.findIndex(function(member) {
                                return parseInt(member.customer_id, 10) === relatedCustomerId;
                            });
                            if (index !== -1) {
                                vm.customerFamilyMembers.data[index] = response.data;
                            }
                        }

                        closeFamilyMemberDialog();
                    } else {
                        toastMessage.showSimpleToast(
                            (response && response.message) || 'Unable to update family member.',
                            'error-toast'
                        );
                    }
                })
                .catch(function(error) {
                    toastMessage.showSimpleToast(
                        (error && error.message) || 'Unable to update family member.',
                        'error-toast'
                    );
                })
                .finally(function() {
                    vm.isUpdatingFamilyMember = false;
                });
        }

        function deleteFamilyMember(ev, member) {
            if (!member) {
                return;
            }

            var customerId = vm.contact.customer_id;
            if (!customerId) {
                toastMessage.showSimpleToast("Invalid customer.", "error-toast");
                return;
            }

            var confirm = $mdDialog.confirm()
                .title("Delete Family Member")
                .htmlContent('<div class="md-padding custom-common-dailog">Are you sure you want to delete this family member?</div>')
                .ariaLabel("Delete family member")
                .targetEvent(ev)
                .ok("DELETE")
                .cancel("CANCEL");

            $mdDialog.show(confirm).then(function() {
                if (vm.editingFamilyMember && vm.editingFamilyMember.customer_id === member.customer_id) {
                    vm.cancelEditFamilyMember();
                }

                member.isDeleting = true;

                var memberData = {
                    customer_id: customerId,
                    related_customer_id: member.customer_id
                };

                eCommerceService.deleteFamilyMember(memberData)
                    .then(function(response) {
                        if (response && response.success) {
                            vm.customerFamilyMembers.data = vm.customerFamilyMembers.data.filter(function(item) {
                                return item.customer_id !== member.customer_id;
                            });
                        } else {
                            toastMessage.showSimpleToast(
                                (response && response.message) || "Unable to delete family member.",
                                "error-toast"
                            );
                        }
                    })
                    .catch(function() {
                        toastMessage.showSimpleToast("Unable to delete family member.", "error-toast");
                    })
                    .finally(function() {
                        member.isDeleting = false;
                    });
            });
        }

        function getRelationshipTypes() {
            eCommerceService.getRelationshipTypes()
                .then(function(response) {
                    if (response && response.success) {

                        vm.relationshipTypes = (response.data || []).map(function(rel) {
                            rel.id = parseInt(rel.id, 10);
                            return rel;
                        });

                    } else {
                        toastMessage.showSimpleToast(
                            (response && response.message) || 'Unable to fetch relationship types.',
                            'error-toast'
                        );
                    }
                })
                .catch(function() {
                    toastMessage.showSimpleToast(
                        'Unable to fetch relationship types.',
                        'error-toast'
                    );
                });
        }

        function queryFamilyMemberSearch(query, field) {
            if (!query) {
                return $q.when([]);
            }

            return createResService.getCustomers({
                search: query,
                field: field,
                pageFrom: 'reservation'
            }).then(function (response) {
                if (
                    response &&
                    response[0] &&
                    response[0].customerList
                ) {
                    return response[0].customerList;
                }

                return [];
            });
        }

        function selectFamilyMemberCustomer(item) {
            if (!item) {
                return;
            }

            vm.familyMemberForm.customer_id = item.customer_id;

            vm.familyMemberForm.first_name = item.first_name || '';
            vm.familyMemberForm.last_name = item.last_name || '';
            vm.familyMemberForm.customer_email = item.customer_email || '';
            vm.familyMemberForm.date_of_birth = item.date_of_birth || null;

            vm.familyMemberSearch.first_name = item.first_name || '';
            vm.familyMemberSearch.last_name = item.last_name || '';
            vm.familyMemberSearch.customer_email = item.customer_email || '';

            vm.selectedFamilyMemberSearch.first_name = item;
            vm.selectedFamilyMemberSearch.last_name = item;
            vm.selectedFamilyMemberSearch.customer_email = item;

            $timeout(function() {
                var phoneInput = document.getElementById(
                    'familyMemberPhoneNumber'
                );

                if (!phoneInput || !item.phone_number) {
                    return;
                }

                // Get the intl-tel-input instance
                var iti = null;

                if (
                    window.intlTelInputGlobals &&
                    window.intlTelInputGlobals.getInstance
                ) {
                    iti = window.intlTelInputGlobals.getInstance(phoneInput);
                }

                if (iti) {
                    iti.setNumber(item.phone_number);
                    vm.familyMemberForm.phone_number = iti.getNumber();
                    vm.isFamilyMemberPhoneValid = !phoneInput.value.trim() || iti.isValidNumberPrecise();
                    angular.element(phoneInput).toggleClass('ng-invalid', !vm.isFamilyMemberPhoneValid);
                    angular.element(phoneInput).toggleClass('ng-valid', vm.isFamilyMemberPhoneValid);
                } else {
                    vm.familyMemberForm.phone_number = item.phone_number;
                    vm.isFamilyMemberPhoneValid = true;
                }
                $scope.$applyAsync();

            });
        }

        function updatePhoneWithCountryCode(fieldName, $event) {
            var inputElement = $event ? ($event.target || $event.srcElement) : null;
            if (!inputElement) {
                return;
            }

            var iti = angular.element(inputElement).data('iti');
            if (!iti && window.intlTelInputGlobals && window.intlTelInputGlobals.getInstance) {
                iti = window.intlTelInputGlobals.getInstance(inputElement);
            }

            if (iti) {
                var fullNumber = iti.getNumber();
                var fieldFormName = fieldName === 'family_member_phone_contact' ? 'familyForm' : 'contactForm';
                if (fieldName === 'family_member_phone_contact') {
                    vm.familyMemberForm.phone_number = fullNumber;
                }
            }
        }

        // Modal Dialog Functions for Family Members
        function resetFamilyMemberDialogFormState() {
            vm.isFamilyMemberPhoneValid = true;
            if ($scope.familyMemberDialogForm) {
                $scope.familyMemberDialogForm.$setPristine();
                $scope.familyMemberDialogForm.$setUntouched();
            }
            var dialog = document.getElementById('FamilyMemberDialog');
            if (dialog) {
                angular.element(dialog.querySelectorAll('md-input-container.md-input-invalid'))
                    .removeClass('md-input-invalid md-input-has-value');
                angular.element(dialog.querySelectorAll('.family-member-autocomplete'))
                    .removeClass('email-invalid');
                angular.element(dialog.querySelectorAll('.family-member-autocomplete input'))
                    .removeClass('ng-invalid ng-dirty ng-touched')
                    .addClass('ng-valid ng-pristine ng-untouched');
            }
            var phoneInput = document.getElementById('familyMemberPhoneNumber');
            if (phoneInput) {
                angular.element(phoneInput)
                    .removeClass('ng-invalid ng-dirty ng-touched')
                    .addClass('ng-valid ng-pristine ng-untouched');
                var iti = angular.element(phoneInput).data('iti');
                if (!iti && window.intlTelInputGlobals && window.intlTelInputGlobals.getInstance) {
                    iti = window.intlTelInputGlobals.getInstance(phoneInput);
                }
                if (iti) {
                    iti.setNumber('');
                } else {
                    phoneInput.value = '';
                }
            }
        }

        function openAddFamilyMemberDialog(ev) {
            vm.editingFamilyMember = null;
            vm.isFamilyMemberPhoneValid = true;
            vm.familyMemberForm = {
                first_name: '',
                last_name: '',
                customer_email: '',
                phone_number: '',
                relationship_status: '',
                date_of_birth: null
            };

            vm.familyMemberSearch = {
                first_name: '',
                last_name: '',
                customer_email: ''
            };

            vm.selectedFamilyMemberSearch = {
                first_name: null,
                last_name: null,
                customer_email: null
            };

            resetFamilyMemberDialogFormState();

            var config = {
                controller: function() {},
                templateUrl: null,
                contentElement: '#FamilyMemberDialog',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false
            };

            $mdDialog.show(config);
            $timeout(resetFamilyMemberDialogFormState, 0);
        }

        function openEditFamilyMemberDialog(ev, member) {
            if (!member) {
                return;
            }
            vm.editingFamilyMember = member;

            vm.familyMemberSearch = {
                first_name: member.first_name || '',
                last_name: member.last_name || '',
                customer_email: member.customer_email || ''
            };

            vm.selectedFamilyMemberSearch = {
                first_name: member,
                last_name: member,
                customer_email: member
            };

            var memberDob = null;
            if (member.date_of_birth) {
                if (member.date_of_birth instanceof Date) {
                    memberDob = member.date_of_birth;
                } else {
                    var dob = String(member.date_of_birth).trim();
                    if (/^\d{4}-\d{2}-\d{2}$/.test(dob)) {
                        var parts = dob.split('-');
                        memberDob = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10), 12, 0, 0);
                    } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(dob)) {
                        var usParts = dob.split('/');
                        memberDob = new Date(parseInt(usParts[2], 10), parseInt(usParts[0], 10) - 1, parseInt(usParts[1], 10), 12, 0, 0);
                    } else {
                        memberDob = new Date(dob);
                    }
                }
                if (memberDob instanceof Date && isNaN(memberDob.getTime())) {
                    memberDob = null;
                }
            }

            vm.familyMemberForm = {
                customer_id: member.customer_id,
                first_name: member.first_name || '',
                last_name: member.last_name || '',
                customer_email: member.customer_email || '',
                phone_number: member.phone_number || '',
                date_of_birth: memberDob,
                relationship_id: member.relationship_id ? parseInt(member.relationship_id, 10) : null
            };
            vm.isFamilyMemberPhoneValid = true;

            var config = {
                controller: function() {},
                templateUrl: null,
                contentElement: '#FamilyMemberDialog',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false
            };

            $mdDialog.show(config).then(angular.noop, angular.noop);
            $timeout(function() {
                var phoneInput = document.getElementById('familyMemberPhoneNumber');
                if (!phoneInput) {
                    return;
                }
                var iti = angular.element(phoneInput).data('iti');
                if (!iti && window.intlTelInputGlobals && window.intlTelInputGlobals.getInstance) {
                    iti = window.intlTelInputGlobals.getInstance(phoneInput);
                }
                if (iti && member.phone_number) {
                    iti.setNumber(member.phone_number);
                    vm.familyMemberForm.phone_number = iti.getNumber();
                    vm.isFamilyMemberPhoneValid = !phoneInput.value.trim() || iti.isValidNumberPrecise();
                    angular.element(phoneInput).toggleClass('ng-invalid', !vm.isFamilyMemberPhoneValid);
                    angular.element(phoneInput).toggleClass('ng-valid', vm.isFamilyMemberPhoneValid);
                }
            }, 100);
        }

        function closeFamilyMemberDialog() {
            $mdDialog.hide();
            vm.editingFamilyMember = null;
            resetFamilyMemberForm();
        }

        function resetFamilyMemberForm() {
            vm.isFamilyMemberPhoneValid = true;
            vm.familyMemberForm = {
                first_name: '',
                last_name: '',
                customer_email: '',
                phone_number: '',
                relationship_status: '',
                date_of_birth: null
            };
        }

        // ========== Customer Pets Functions ==========

        function loadPetTypes() {
            if (vm.petTypes.isloading) {
                return;
            }
            vm.petTypes.isloading = true;

            eCommerceService.getPetTypes()
                .then(function (response) {

                    if (response && response.success) {

                        vm.petTypes.data = response.data || [];

                        /*
                        * Find "Other" dynamically from the database.
                        */
                        var otherType = vm.petTypes.data.find(function (type) {
                            return type.name === 'Other';
                        });

                        vm.otherPetTypeId = otherType
                            ? parseInt(otherType.id, 10)
                            : null;
                        

                    } else {

                        vm.petTypes.data = [];
                        vm.otherPetTypeId = null;

                        toastMessage.showSimpleToast(
                            (response && response.message) ||
                            'Unable to load pet types.',
                            'error-toast'
                        );
                    }

                })
                .catch(function (error) {

                    vm.petTypes.data = [];
                    vm.otherPetTypeId = null;

                    toastMessage.showSimpleToast(
                        (error && error.message) ||
                        'Unable to load pet types.',
                        'error-toast'
                    );

                })
                .finally(function () {

                    vm.petTypes.isloading = false;

                });
        }

        function loadCustomerPets() {
            if (vm.customerPets.isloading) {
                return;
            }

            var customerId = vm.contact && vm.contact.customer_id;
            if (!customerId) {
                toastMessage.showSimpleToast('Invalid customer.', 'error-toast');
                return;
            }

            vm.customerPets.isloading = true;

            eCommerceService.getCustomerPets(customerId)
                .then(function(response) {
                    if (response && response.success) {
                        vm.customerPets.data = response.data || [];
                    } else {
                        vm.customerPets.data = [];
                        toastMessage.showSimpleToast(
                            (response && response.message) || 'Unable to load pets.',
                            'error-toast'
                        );
                    }
                })
                .catch(function(error) {
                    vm.customerPets.data = [];
                    toastMessage.showSimpleToast(
                        (error && error.message) || 'Unable to load pets.',
                        'error-toast'
                    );
                })
                .finally(function() {
                    vm.customerPets.isloading = false;
                });
        }

        function saveCustomerPet() {
            if (vm.isSavingCustomerPet) {
                return;
            }

            var form = vm.customerPetForm;

            if (!form.name || !form.pet_type_id) {
                return;
            }

            var petTypeId = parseInt(form.pet_type_id, 10);
            var otherPetTypeId = parseInt(vm.otherPetTypeId, 10);

            /*
            * If "Other" is selected, custom pet type is required.
            */
            if (
                petTypeId === otherPetTypeId &&
                !String(form.other_pet_type || '').trim()
            ) {
                return;
            }

            vm.isSavingCustomerPet = true;

            var dobString = '';

            if (form.date_of_birth) {
                if (form.date_of_birth instanceof Date) {
                    dobString = moment(
                        form.date_of_birth
                    ).format('MM-DD-YYYY');
                } else {
                    dobString = form.date_of_birth;
                }
            }

            var data = {
                customer_id: vm.contact.customer_id,

                name: String(
                    form.name || ''
                ).trim(),

                pet_type_id: petTypeId,

                other_pet_type:
                    petTypeId === otherPetTypeId
                        ? String(
                            form.other_pet_type || ''
                        ).trim()
                        : null,

                date_of_birth: dobString
            };

            eCommerceService
                .addCustomerPet(data)
                .then(function (response) {

                    if (response && response.success) {

                        if (!vm.customerPets.data) {
                            vm.customerPets.data = [];
                        }

                        vm.customerPets.data.unshift(
                            response.data
                        );

                        closePetDialog();

                    } else {

                        toastMessage.showSimpleToast(
                            (response && response.message) ||
                            'Unable to add pet.',
                            'error-toast'
                        );
                    }

                })
                .catch(function (error) {

                    toastMessage.showSimpleToast(
                        (error && error.message) ||
                        'Unable to add pet.',
                        'error-toast'
                    );

                })
                .finally(function () {
                    vm.isSavingCustomerPet = false;
                });
        }

        function editCustomerPet(pet) {
            if (!pet) {
                return;
            }
            vm.editingCustomerPet = pet;
            var petDob = null;
            if (pet.date_of_birth) {
                if (pet.date_of_birth instanceof Date) {
                    petDob = pet.date_of_birth;
                } else {
                    var dob = String(
                        pet.date_of_birth
                    ).trim();
                    if (/^\d{4}-\d{2}-\d{2}$/.test(dob)) {
                        var parts = dob.split('-');
                        petDob = new Date(
                            parseInt(parts[0], 10),
                            parseInt(parts[1], 10) - 1,
                            parseInt(parts[2], 10),
                            12,
                            0,
                            0
                        );

                    } else if (
                        /^\d{2}\/\d{2}\/\d{4}$/.test(dob)
                    ) {

                        var usParts = dob.split('/');

                        petDob = new Date(
                            parseInt(usParts[2], 10),
                            parseInt(usParts[0], 10) - 1,
                            parseInt(usParts[1], 10),
                            12,
                            0,
                            0
                        );

                    } else {

                        petDob = new Date(dob);
                    }
                }
            }

            vm.customerPetForm = {
                id: pet.id,
                name: pet.name || '',
                pet_type_id: pet.pet_type_id
                    ? parseInt(pet.pet_type_id, 10)
                    : null,
                other_pet_type: pet.other_pet_type || '',
                date_of_birth: petDob
            };
        }

        function cancelEditCustomerPet() {
            vm.editingCustomerPet = null;
            resetCustomerPetForm();
        }

        function resetCustomerPetForm() {
            vm.customerPetForm = {
                name: '',
                date_of_birth: null,
                pet_type_id: null,
                other_pet_type: ''
            };
        }

        function updateCustomerPet() {
            if (
                vm.isUpdatingCustomerPet ||
                !vm.editingCustomerPet
            ) {
                return;
            }
            var form = vm.customerPetForm;
            if (!form.name || !form.pet_type_id) {
                return;
            }
            /*
            * If "Other" is selected, custom pet type is required.
            */
            if (
                form.pet_type_id == vm.otherPetTypeId &&
                !form.other_pet_type
            ) {
                return;
            }
            var petId = parseInt(
                vm.editingCustomerPet.id,
                10
            );
            var customerId = parseInt(
                vm.contact.customer_id,
                10
            );
            if (!petId || !customerId) {
                toastMessage.showSimpleToast(
                    'Invalid pet.',
                    'error-toast'
                );
                return;
            }

            vm.isUpdatingCustomerPet = true;

            var dobString = '';

            if (form.date_of_birth) {

                var dobMoment = moment(
                    form.date_of_birth
                );

                if (dobMoment.isValid()) {

                    dobString = dobMoment.format(
                        'MM-DD-YYYY'
                    );
                }
            }

            var data = {

                pet_id: petId,

                customer_id: customerId,

                name: String(
                    form.name || ''
                ).trim(),

                pet_type_id: parseInt(
                    form.pet_type_id,
                    10
                ),

                other_pet_type:
                    form.pet_type_id == vm.otherPetTypeId
                        ? String(form.other_pet_type || '').trim()
                        : null,

                date_of_birth: dobString
            };

            eCommerceService
                .updateCustomerPet(data)

                .then(function(response) {

                    if (
                        response &&
                        response.success === true
                    ) {

                        if (
                            response.data &&
                            vm.customerPets.data
                        ) {

                            var index =
                                vm.customerPets.data.findIndex(
                                    function(pet) {

                                        return parseInt(
                                            pet.id,
                                            10
                                        ) === petId;

                                    }
                                );

                            if (index !== -1) {

                                vm.customerPets.data[index] =
                                    response.data;
                            }
                        }

                        closePetDialog();

                    } else {

                        toastMessage.showSimpleToast(
                            (response && response.message) ||
                            'Unable to update pet.',
                            'error-toast'
                        );
                    }

                })
                .catch(function(error) {

                    toastMessage.showSimpleToast(
                        (error && error.message) ||
                        'Unable to update pet.',
                        'error-toast'
                    );

                })
                .finally(function() {

                    vm.isUpdatingCustomerPet = false;

                });
        }

        function deleteCustomerPet(ev, pet) {
            if (!pet) {
                return;
            }

            var confirm = $mdDialog.confirm()
                .title("Delete Pet")
                .htmlContent('<div class="md-padding custom-common-dailog">Are you sure you want to delete this pet?</div>')
                .ariaLabel("Delete pet")
                .targetEvent(ev)
                .ok("DELETE")
                .cancel("CANCEL");

            $mdDialog.show(confirm).then(function() {
                if (vm.editingCustomerPet && vm.editingCustomerPet.id === pet.id) {
                    vm.cancelEditCustomerPet();
                }

                pet.isDeleting = true;

                var petData = {
                    pet_id: pet.id,
                    customer_id: vm.contact.customer_id
                };

                eCommerceService.deleteCustomerPet(petData)
                    .then(function(response) {
                        if (response && response.success) {
                            vm.customerPets.data = vm.customerPets.data.filter(function(item) {
                                return item.id !== pet.id;
                            });
                        } else {
                            toastMessage.showSimpleToast(
                                (response && response.message) || "Unable to delete pet.",
                                "error-toast"
                            );
                        }
                    })
                    .catch(function() {
                        toastMessage.showSimpleToast("Unable to delete pet.", "error-toast");
                    })
                    .finally(function() {
                        pet.isDeleting = false;
                    });
            });
        }

        // Modal Dialog Functions for Pets
        function openAddPetDialog(ev) {
            vm.editingCustomerPet = null;
            vm.customerPetForm = {
                name: '',
                pet_type_id: null,
                other_pet_type: '',
                date_of_birth: null
            };
            var config = {
                controller: function() {},
                templateUrl: null,
                contentElement: '#PetDialog',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false
            };
            $mdDialog.show(config);
        }

        function openEditPetDialog(ev, pet) {
            if (!pet) {
                return;
            }
            vm.editingCustomerPet = pet;
            var petDob = null;
            if (pet.date_of_birth) {
                if (pet.date_of_birth instanceof Date) {
                    petDob = pet.date_of_birth;
                } else {
                    var dob = String(pet.date_of_birth).trim();
                    if (/^\d{4}-\d{2}-\d{2}$/.test(dob)) {
                        var parts = dob.split('-');
                        petDob = new Date(
                            parseInt(parts[0], 10),
                            parseInt(parts[1], 10) - 1,
                            parseInt(parts[2], 10),
                            12,
                            0,
                            0
                        );
                    } else if (
                        /^\d{2}\/\d{2}\/\d{4}$/.test(dob)
                    ) {
                        var usParts = dob.split('/');
                        petDob = new Date(
                            parseInt(usParts[2], 10),
                            parseInt(usParts[0], 10) - 1,
                            parseInt(usParts[1], 10),
                            12,
                            0,
                            0
                        );
                    } else {
                        petDob = new Date(dob);
                    }
                }
            }
            vm.customerPetForm = {
                id: pet.id,
                name: pet.name || '',
                pet_type_id: pet.pet_type_id
                    ? parseInt(pet.pet_type_id, 10)
                    : null,
                other_pet_type:
                    pet.other_pet_type || '',
                date_of_birth: petDob
            };

            var config = {
                controller: function() {},
                templateUrl: null,
                contentElement: '#PetDialog',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false
            };

            $mdDialog.show(config);
        }

        function closePetDialog() {
            $mdDialog.hide();
            vm.editingCustomerPet = null;
            resetCustomerPetForm();
        }

        vm.goToFamilyMember = function(customerId) {
            if (!customerId) {
                return;
            }
            var url = $state.href('app.customer_update', {
                customer_id: customerId
            });
    
            $window.open(url, '_blank');
        };

        vm.isValidEmail = function(email) {
            if (!email) {
                return false;
            }

            var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

            return emailRegex.test(email);
        };

        vm.formatPhoneNumber = function(phoneNumber) {
            if (!phoneNumber) {
                return phoneNumber;
            }
            if (window.intlTelInput && window.intlTelInput.utils) {
                return window.intlTelInput.utils.formatNumber(
                    phoneNumber,
                    undefined,
                    'INTERNATIONAL'
                );
            }
            return phoneNumber;
        };

        vm.formatDateOfBirth = function (dob) {
            if (!dob) {
                return "";
            }

            var date = new Date(dob);

            if (isNaN(date.getTime())) {
                return "";
            }

            var month = String(date.getMonth() + 1).padStart(2, '0');
            var day = String(date.getDate()).padStart(2, '0');
            var year = date.getFullYear();

            return month + "-" + day + "-" + year;
            }
    }

})();

(function ()
{
    'use strict';

    angular.module('app.contacts')
        .controller('confirmController', confirmController);

    /** @ngInject */
    function confirmController(
        $mdDialog, 
        title, 
        htmlContent,
        cancelBtn,
        $state,
        $window,
        OkBtn)
    {
        var vm = this;
        vm.title = title;
        vm.CancelbtnTxt = 'Cancel';
        vm.OkbtnTxt = 'Ok';
        if(cancelBtn != ''){
            vm.CancelbtnTxt = cancelBtn;
        }
        if(OkBtn != ''){
            vm.OkbtnTxt = OkBtn;
        }
        vm.htmlContent = htmlContent;
        vm.closeDialog = closeDialog;
        function closeDialog(param){
           $mdDialog.hide(param);
        }
        vm.hideDialog = hideDialog;

        function hideDialog(){
           $mdDialog.hide('update');
        }
        vm.htmlInfo = 'If you want to remove a night with refund you should change dates instead.';

        vm.goToReservaion = function(reservation_id, confirmation_number){

           var url = $state.href("app.e-commerce.orders.detail",{id: reservation_id,
                confirmation_number: confirmation_number});
                $window.open(url, '_blank');
        }
    }

})();

'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../mls/mlsService
 * @description
 * # ../mls/mlsService
 * Service in the minervaApp.
 */
angular.module('app.checkout')
  .service('checkoutService', function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
 	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}
 	
 	function getCheckoutCategory(){
		return $http({
			url		:EnvironmentConfig.api+'Checkout/skipAcl_getAllCategory',
			method	:'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getRelatedProducts(data){
		return $http({
			url		:EnvironmentConfig.api+'Checkout/skipAcl_getAllRelatedProduct',
			method	:'POST',
			data 	:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getFilteredProducts(data){
		return $http({
			url		:EnvironmentConfig.api+'Checkout/skipAcl_getFilteredProducts',
			method	:'POST',
			data 	:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getTax(){
		return $http({
			url		:EnvironmentConfig.api+'Checkout/skipAcl_getTax',
			method	:'GET',
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getCurrentCustomers(){
		return $http({
			url		:EnvironmentConfig.api+'Checkout/skipAcl_getCurrentCustomers',
			method	:'GET',
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getCardDetails(data){
		return $http({
			url		:EnvironmentConfig.api+'Checkout/skipAcl_getCardDetails',
			method	:'POST',
			data  	:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getReservedUsers(data){
		return $http({
			url		:EnvironmentConfig.api+'Checkout/skipAcl_getReservedUsers',
			method	:'POST',
			data  	:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getGiftCards(){
		return $http({
			url		:EnvironmentConfig.api+'Checkout/skipAcl_getGiftCardItem',
			method	:'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	return{
	 		getCheckoutCategory: getCheckoutCategory,
	 		getRelatedProducts: getRelatedProducts,
	 		getFilteredProducts: getFilteredProducts,
	 		getTax: getTax,
	 		getCurrentCustomers: getCurrentCustomers,
	 		getCardDetails: getCardDetails,
			getReservedUsers: getReservedUsers,
			getGiftCards: getGiftCards,
 	}
 });

(function() {
    'use strict';

    angular
        .module('app.checkout')
        .controller('tabOrderController', tabOrderController);

    /** @ngInject */
    function tabOrderController(
        TabData,
        checkoutService,
        $filter,
        $sessionStorage,
        $mdDialog,
        $document,
        $scope,
        tabOrderName,
        $state,
        toastMessage,
        $localStorage,
        $timeout
       
    ) {
        /*initialization*/
        var vm = this;
        vm.tabOrder = [];
        vm.tabOrders = [];
        vm.single_tab_order = [];
        if (typeof TabData != 'undefined' && TabData['tabData'].length > 0){
            vm.tabOrder = TabData['tabData'];
            vm.single_tab_order = angular.copy(vm.tabOrder[0].cartData);
            vm.overallTotals = angular.copy(vm.tabOrder[0].overallTotals);
            vm.customer = angular.copy(vm.tabOrder[0].customer);
            vm.OrderTime = angular.copy(vm.tabOrder[0].OrderTime);
            vm.created_by_user = angular.copy(vm.tabOrder[0].created_by_user);
            vm.note = angular.copy(vm.tabOrder[0].name);
        }

        if (tabOrderName != '') {
            vm.tabName = tabOrderName;
        }

		vm.loadSingleTabOrder = loadSingleTabOrder;
        vm.activeClass = 0;

		function loadSingleTabOrder(index){
            vm.activeClass = index;
			vm.single_tab_order = angular.copy(vm.tabOrder[index].cartData);
            vm.overallTotals = angular.copy(vm.tabOrder[index].overallTotals);
            vm.customer = angular.copy(vm.tabOrder[index].customer);
            vm.OrderTime = angular.copy(vm.tabOrder[index].OrderTime);
            vm.created_by_user = angular.copy(vm.tabOrder[index].created_by_user);
            vm.note = angular.copy(vm.tabOrder[index].name);
		}

        /*used to rename the tabOrder name*/
        vm.renameTabOrderName = function(index) {
            var event = '';
            vm.tabOrderIndex = index;
            $mdDialog.show({
                controller: 'tabOrderController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/checkout/dialog/tabOrderName.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: event,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                onRemoving: function() { //

                },
                locals: {
                    TabData: TabData,
                    tabOrderName: vm.tabOrder[index]['name']
                }
            });
        }
        /*close dialog of rename*/
        vm.closeDialog = function() {
            $mdDialog.cancel();
        }

        /*update tab order name in the child Controller*/
        vm.getTabOrderName = function() {
            $scope.$parent.updateTabOrder(vm.tabName, TabData);
            $mdDialog.cancel();
        }

        /*Update Tab order names in parent controller*/
        $scope.updateTabOrder = function(name, TabData) {
            // vm.tabOrder[vm.tabOrderIndex]['name'] = name;
            var data = {tabId:TabData['tabData'][vm.tabOrderIndex]['tabId'], newName: name};
            checkoutService.renameTabOrderName(data).then(function(response){
              if(response['success']){
                vm.tabOrder[vm.tabOrderIndex]['name'] = name;
                vm.note = name;
              }else{
                 toastMessage.showSimpleToast('Some error occured.Please try again.','error-toast');
              }
            });
        }
        /*Delete tab order*/
        vm.disableCancel = [];
        vm.deleteOrder = function(index){
            vm.disableCancel[index] = true;
           checkoutService.deleteTabOrder({'tabId':vm.tabOrder[index]['tabId']}).then(function(response){
            vm.disableCancel[index] = false;
              if(response['cart_info']['success']){
                vm.tabOrder.splice(index,1);
                $localStorage['currentTabDetails'] = '';
                if(vm.tabOrder.length > 0)
                    loadSingleTabOrder(0);
              }
            });
        }
        
        /*set tab id and move to bar with tab order*/
        vm.processRequest = false;
        vm.moveToRetailWithOrder = function(index){
         	if($localStorage['barItem_'+$localStorage['preHotelId']] && $localStorage['barItem_'+$localStorage['preHotelId']]!='' && $localStorage['currentTabDetails']!=TabData['tabData'][index]['tabId']){
				 var title = 'Attention!';
				 var html = 'Your cart already contains some items in it. Please process it first to load tab in cart.';
				 $mdDialog.show({
				 	controller: 'confirmPageController',
				 	controllerAs: 'vm',
				 	templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
				 	parent: angular.element(document.body),
				 	targetEvent: event,
				 	clickOutsideToClose:true ,
				 	locals: {
				 		title: title,
				 		htmlContent:html,
				 		btnTxt:'Okay',
                        cancelTxt: 'Cancel',
				 		localData: {}
				 	}
				 });
			} else {
                if(vm.processRequest) return ;

                vm.processRequest = true;                
				    movetoretailFinally(index);
			}
        }
        vm.isloading = false;
        vm.requestProcessing = [];
        function movetoretailFinally(index){
			if($localStorage['currentTabDetails']==TabData['tabData'][index]['tabId']){
				$state.go('app.bar');
			} else {  
                vm.requestProcessing[index] = true;       
                vm.isloading = true;
    			checkoutService.setTabStatusToActive({'tabId':vm.tabOrder[index]['tabId'], status : 1}).then(function(response){
    			    if(response['status']){
    					vm.requestProcessing[index] = false;
                        vm.processRequest = false; 
    					vm.isloading = false;
    					$localStorage.barNote = '';
    					$localStorage.barDiscount = '';
    					$localStorage['barItem_'+$localStorage['preHotelId']]= TabData['tabData'][index]['cartData'];
    					$localStorage['barUser_'+$localStorage['preHotelId']] = TabData['tabData'][index]['customer'];
    					// $localStorage['currentTabDetails']['tabId'] = TabData['tabData'][index]['tabId'];
    					$localStorage['currentTabDetails'] = TabData['tabData'][index]['tabId'];
    					$state.go('app.bar');
    				} else {
    					vm.requestProcessing[index] = false;
    					vm.isloading = false;
                        vm.processRequest = false; 
    					toastMessage.showSimpleToast(response['errMsg'],'error-toast');
    				}
    			});            
			}
		}

        vm.printInvoice = printInvoice;
        function printInvoice(index){
            var requestData = {
                                    cartData:vm.tabOrder[index]['cartData'],
                                    paymentMethod:{},
                                    printpreview:true,
                                    spliting:false,
                                    user:vm.tabOrder[index]['customer']
                                };            
            checkoutService.printInvoice(requestData).then(function(response) {
                var myWindow = window.open('', "_blank", "scrollbars=yes, resizable=yes, width=500, height=700")
                myWindow.document.write(response['data']);
                $timeout(function() {
                    myWindow.close();
                },400);
                /*New*/
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.checkout')
        .controller('posreportsController', posreportsController);

    /** @ngInject */
    function posreportsController(
        $scope,
        checkoutService,
        $localStorage,
        $timeout
    ) {
        /*initialization*/
        var vm = this;
        vm.depositType = [];
        vm.reportDetail = [];
        vm.userInput = [];
        vm.dailyreports = [];
        vm.totalDiff = 0;
        vm.cashOut = 0;
        vm.cashEntry = false;
        vm.tipLength = 0;
        vm.empty = false;
        // vm.closingDate = '';
        vm.xzReport = [];
        vm.myDate = new Date();
        vm.startDate = new Date(
                            this.myDate.getFullYear(),
                            this.myDate.getMonth(),
                            this.myDate.getDate()
                          );
        vm.endDate = new Date(
                            this.myDate.getFullYear(),
                            this.myDate.getMonth(),
                            this.myDate.getDate()
                          );
        vm.today = new Date(
                            this.myDate.getFullYear(),
                            this.myDate.getMonth(),
                            this.myDate.getDate()
                          );

        vm.reportTypeArray = [{
                value: "n",
                name: 'Please select report type'
            },
            {
                value: "x",
                name: 'X-Report (mid-day report)'
            },
            {
                value: "z",
                name: 'Z-Report (end-of-day report)'
            },
            {
                value: "daily",
                name: 'Daily report on Bar Orders'
            },
            {
                value: "sales",
                name: 'Sales report'
            },
            {
                value: "tip",
                name: 'Tip report'
            }
        ];
        vm.autoFillOff = true;
        if($localStorage['preHotelId'] !== undefined && $localStorage['preHotelId'] == 126){
            for (var i=0; i<vm.reportTypeArray.length ; i++) {
                if(vm.reportTypeArray[i].value == "daily") {
                    vm.reportTypeArray[i].name = "Daily report on Food & Drink Orders";
                    break;
                }
            }
        }

        vm.reportType = 'n';

        vm.allUsers = [];
        vm.tipPaymentType = 'All';
        vm.hotelPaymentMethods = [];
        vm.userId = 0;

        checkoutService.getUsers().then(function(response) {
            if (response['success']) {
                vm.allUsers = response['cashier'];
                vm.hotelPaymentMethods = response['hotelPaymentMethods'];
            }
        });


        vm.requestSent = false;

        vm.getReport = function() {
            vm.refreshClicked = 1;
            vm.closeStoreStatus = true;
            vm.requestSent = true;

            vm.depositType = [];
            vm.reportDetail = [];
            vm.dailyreports = [];
            vm.xzReport = [];

            var condition = [];
            var responseData = {
                reportType: vm.reportType,
                condition: condition,
                selectedUser: vm.userId
            };

            if(vm.reportType == 'tip'){
                // if(vm.userId == 0)
                // vm.userId = $localStorage.userId;
                vm.isloading = true;
                var responseDataTip = {
                    startDate   : new Date(moment(vm.startDate).format('YYYY-MM-DD')),
                    endDate     : new Date(moment(vm.endDate).format('YYYY-MM-DD')),
                    selectedUser: vm.userId,
                    pageStatus  : 'view'
                    //~ tipPaymentType : vm.tipPaymentType
                };
                checkoutService.getTipReport(responseDataTip).then(function(response) {
                    vm.tipData = response['tipData'];
                    vm.tip_total = response['tip_total'];
                    vm.tip_total_count = response['tip_total_count'];
                    vm.tip_table = response['tiptable'];
                    vm.tipLength = Object.keys(vm.tipData).length;
                    vm.empty = (vm.tipLength == 0) ? true : false;
                    vm.isloading = false;
                    // setTimeout(function(){
                    //     vm.tbodyHeight = document.getElementById('tbodyHeight').clientHeight;
                    //     vm.initialOffset = $('#printSectionId').offset().top;
                    //     vm.table = $('#heightTable');
                    //     vm.bodyCells = vm.table.find('tbody tr').children();
                    //     vm.colWidth;
                    //     // Adjust the width of thead cells when window resizes
                    //     $(window).resize(function() {
                    //         // Get the tbody columns width array
                    //         vm.colWidth = vm.bodyCells.map(function() {
                    //             return $(this).width();
                    //         }).get();
                    //          vm.table.find('thead tr').children().each(function(i, v) {
                    //              $(v).width(vm.colWidth[i]);
                    //         });    
                    //     }).resize(); // Trigger resize handler

                    //     vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };

                    // },1000);
                });
                // return;
            } else if (vm.reportType != 'sales') {
                vm.isloading = true;
                if (vm.reportType == 'daily') {
                    responseData.startDate  = new Date(moment(vm.startDate).format('YYYY-MM-DD'));
                    responseData.endDate    = new Date(moment(vm.endDate).format('YYYY-MM-DD'));
                }

                if (vm.reportType == 'x' || vm.reportType == 'z') {
                    responseData.startDate  = new Date(moment(vm.startDate).format('YYYY-MM-DD'));
                }
                
                checkoutService.getPosReport(responseData).then(function(response) {
                    if (response['success']) {
                        if (vm.reportType == 'x' || vm.reportType == 'z') {
                            // console.log(response);
                            vm.xzReport = response['data'];
                            if(vm.xzReport.length > 0) {
                                vm.depositType = vm.xzReport[0]['depositType'];
                                vm.reportDetail = vm.xzReport[0]['reportDetail'];
                            }
                            vm.empty = (vm.xzReport.length == 0) ? true : false;
                        } else if (vm.reportType == 'daily') {
                            vm.dailyreports = response['result'];
                            vm.empty = (vm.dailyreports.length == 0) ? true : false;
                        }
                        vm.isloading = false;
                        setTimeout(function(){
                            vm.tbodyHeight = document.getElementById('tbodyHeight').clientHeight;
                            vm.initialOffset = $('#printSectionId').offset().top;
                            vm.table = $('#heightTable');
                            vm.bodyCells = vm.table.find('tbody tr').children();
                            vm.colWidth;
                            // Adjust the width of thead cells when window resizes
                            $(window).resize(function() {
                                // Get the tbody columns width array
                                vm.colWidth = vm.bodyCells.map(function() {
                                    return $(this).width();
                                }).get();
                                 vm.table.find('thead tr').children().each(function(i, v) {
                                     $(v).width(vm.colWidth[i]);
                                });    
                            }).resize(); // Trigger resize handler
                            vm.tableStyle = { "max-height" : "calc(100vh - 200px)" };
                        },1000);
                    } else {
                        vm.isloading = false;
                    }
                });
            } else {
               vm.getSalesReport();
            }
        }



        // vm.getPdf = function() {
        //     var data = [];
        //     data.push(['Order#', 'Cashier', 'Bill to Name','Product Name','Total','Purchased On'])
        //     angular.forEach(vm.dailyreports, function(value, key) {
        //         data.push([
        //             {
        //                 text: value.confirmation_number
        //             },
        //             {
        //                 text: value.cashier
        //             },
        //             {
        //                 text: value.customer
        //             },
        //             {
        //                 text: value.product_name
        //             },
        //             {
        //                 text: '$'+value.total_deposit_amount
        //             },
        //             {
        //                 text: value.created_date
        //             }
        //         ]);

        //     });

        //     var headerText = '';
        //     if($localStorage['preHotelId'] !== undefined && $localStorage['preHotelId'] == 126){
        //         headerText = 'Daily report on Food & Drink orders'
        //     } else {
        //         headerText = 'Daily report on Bar orders';
        //     }
        //     var docDefinition = {
        //         header: {
        //         text: headerText,
        //         fontSize: 16,
        //         alignment: 'center',
        //         margin: [72, 40],
        //         bold: true
        //      },
        //         content: [{
        //         table:  {
        //             headerRows: 1,
        //             body: data
        //              }
        //         }],
        //         styles: {
        //             header: {
        //             fontSize: 14,
        //             bold: true
        //             }
        //         },
        //          pageMargins: [72, 100, 72, 40]
        //         };

        //     pdfMake.createPdf(docDefinition).download("daily_bar_report.pdf");

        // }

        vm.getPdf = function(pdf){
            vm.requestProcessingPDF = true;
            var condition = [];
            var responseData = {
                reportType: vm.reportType,
                condition: condition,
                selectedUser: vm.userId,
                pdf: pdf
            };
            if (vm.reportType == 'daily' || vm.reportType == 'sales' || vm.reportType == 'tip') {
                responseData.startDate  = moment(vm.startDate).format('YYYY-MM-DD');
                responseData.endDate    = moment(vm.endDate).format('YYYY-MM-DD');
            }
            if (vm.reportType == 'x' || vm.reportType == 'z') {
                responseData.startDate  = moment(vm.startDate).format('YYYY-MM-DD');
            }
            if(vm.reportType == 'tip'){
                
                checkoutService.getTipReport(responseData).then(function(response) {
                    vm.requestProcessingPDF = false;
                    if(response.status == 'success' && pdf=='pdf'){
                        var filepathToClean = response.data.filepath;
                        var data = {
                            filename:response.data.filename,
                            filepath:response.data.filepath
                        };
                        checkoutService.download_data_request(data).then(function(response){
                            //return;
                            var file = new Blob([ response ], {
                                type : 'application/pdf'
                            });
                            //trick to download store a file having its URL
                            var fileURL = URL.createObjectURL(file);
                            var a         = document.createElement('a');
                            a.href        = fileURL; 
                            //a.target      = '_blank';
                            a.download    = data.filename;
                            document.body.appendChild(a);
                            a.click();
                            var cleanData = {filepath:filepathToClean};
                            $timeout(function() {
                                checkoutService.cleanDisk(cleanData);
                            }, 2000);
                        });
                    }
                });

            } else {
                checkoutService.getPosReport(responseData).then(function(response) {
                    vm.requestProcessingPDF = false;
                    if(response.status == 'success' && pdf=='pdf'){
                        var filepathToClean = response.data.filepath;
                        var data = {
                            filename:response.data.filename,
                            filepath:response.data.filepath
                        };
                        checkoutService.download_data_request(data).then(function(response){
                            //return;
                            var file = new Blob([ response ], {
                                type : 'application/pdf'
                            });
                            //trick to download store a file having its URL
                            var fileURL = URL.createObjectURL(file);
                            var a         = document.createElement('a');
                            a.href        = fileURL; 
                            //a.target      = '_blank';
                            a.download    = data.filename;
                            document.body.appendChild(a);
                            a.click();
                            var cleanData = {filepath:filepathToClean};
                            $timeout(function() {
                                checkoutService.cleanDisk(cleanData);
                            }, 2000);
                        });
                    }
                });
            }

        }

        vm.salesReport = [];

        /*get the sales report*/
        vm.getSalesReport = function() {
            vm.refreshClicked = true;
            vm.isloading = true;
            vm.requestSent = true;
            // vm.startDate = new Date(moment(vm.startDate).format('YYYY-MM-DD'));
            // vm.endDate = new Date(moment(vm.endDate).format('YYYY-MM-DD'));
            var condition = {
                from: new Date(moment(vm.startDate).format('YYYY-MM-DD')),
                to: new Date(moment(vm.endDate).format('YYYY-MM-DD'))
            };
            var responseData = {
                reportType: vm.reportType,
                condition: condition,
                selectedUser: vm.userId
            };

            checkoutService.getPosReport(responseData).then(function(response) {
                vm.salesReport = response['result'];
                vm.isloading = false;
                vm.empty = (vm.salesReport.length == 0) ? true : false;
            });
        }

        vm.updateDifference = function(key) {
            if (vm.userInput[key]) {
                vm.totalDiff = 0;
                vm.cashEntry = false;
                vm.depositType[key]['difference'] = vm.depositType[key]['Total'] - vm.userInput[key];
                for (var key in vm.depositType) {
                    vm.totalDiff = parseFloat(vm.totalDiff) + parseFloat(vm.depositType[key]['difference']);
                }
            } else {
                vm.cashEntry = true;
            }
        }
        vm.printData = '';

        /*
        ** To close store and save data
        */
        vm.closeStoreStatus = true;
        vm.closeStore = function() {
            vm.isloading = true;
            vm.cashEntry = false;
            if (vm.userInput['Cash']) {
                var data = {
                    depositType     : vm.depositType,
                    diff            : vm.totalDiff,
                    reportDetail    : vm.reportDetail,
                    cashOut         : vm.cashOut
                };
                vm.closeStoreStatus = false;
                
                checkoutService.saveCurrentReport(data).then(function(response) {
                    vm.cashOut = 0;
                    vm.isloading = false;
                    vm.userInput = [];
                    vm.totalDiff = 0;
                    angular.forEach(vm.depositType, function(value, key) {
                        if(vm.depositType[key] != undefined && vm.depositType[key].difference != undefined){
                            vm.depositType[key].difference = 0;
                        }
                    });
                    /*vm.startDate = new Date(
                            this.myDate.getFullYear(),
                            this.myDate.getMonth(),
                            this.myDate.getDate()
                          );            
                    vm.closingDate = new Date(moment(vm.startDate).format('YYYY-MM-DD'));*/            
                });
            } else {
                vm.cashEntry = true;
                vm.isloading = false;
            }
        }

        /*Print order*/

        vm.printIvoice = function(type,pdf) {
            var reportData;
            if(vm.reportType == 'z' && type != 'complete') {
                reportData = [];
                reportData[0] = {
                    'depositType' : vm.depositType,
                    'reportDetail' : vm.reportDetail
                }
            } else {
                reportData = vm.xzReport;
            }
            var data = {

                depositType  : vm.depositType,
                diff         : vm.totalDiff,
                reportDetail : vm.reportDetail,
                cashOut      : vm.cashOut,
                reportType   : vm.reportType,
                selectedUser : vm.userId,
                xzReport     : reportData,
                type         : type,
                pdf          : pdf
            };
            
            checkoutService.printOrder(data).then(function(response) {
                // console.log(response);
                 if(response['status'] == 'success' && pdf=='pdf'){
                    var filepathToClean = response.data.filepath;
                    var data = {
                        filename:response.data.filename,
                        filepath:response.data.filepath
                    };
                    checkoutService.download_data_request(data).then(function(response){
                        console.log("response : ",response);
                        //return;
                        var file = new Blob([ response ], {
                            type : 'application/pdf'
                        });
                        //trick to download store a file having its URL
                        var fileURL = URL.createObjectURL(file);
                        var a         = document.createElement('a');
                        a.href        = fileURL; 
                        //a.target      = '_blank';
                        a.download    = data.filename;
                        document.body.appendChild(a);
                        a.click();
                        var cleanData = {filepath:filepathToClean};
                        $timeout(function() {
                            checkoutService.cleanDisk(cleanData);
                        }, 2000);
                    });
                } else {
                    vm.printData = response['printData'];
                    var w = window.open('', "_blank", "scrollbars=yes, resizable=yes, width=500, height=700");
                    w.document.write(vm.printData);
                    $timeout(function() {
                        w.print();
                        w.close();
                    }, 1000);
                }
            });
        }

        vm.printTipDetail = printTipDetail;
        function printTipDetail(){
            var responseData = {
                    startDate: new Date(moment(vm.startDate).format('YYYY-MM-DD')),
                    endDate: new Date(moment(vm.endDate).format('YYYY-MM-DD')),
                    selectedUser:vm.userId,
                    pageStatus:'print',
                    tipPaymentType : vm.tipPaymentType
                }
                checkoutService.getTipReport(responseData).then(function(response) {
                    if(response['success']){

                        var myWindow = window.open('', "_blank", "scrollbars=yes, resizable=yes, width=500, height=700");
                        myWindow.document.write(response['printData']);
                        $timeout(function() {
                            myWindow.print();
                            myWindow.close();
                        },400);
                    }
                });
        }

        vm.waitForRefreshButton = waitForRefreshButton;
        vm.refreshClicked = 0;
        function waitForRefreshButton(){
            if(vm.reportType == 'daily') {
                vm.startDate = new Date(
                            this.myDate.getFullYear(),
                            this.myDate.getMonth(),
                            this.myDate.getDate()
                          );
                vm.endDate = new Date(
                            this.myDate.getFullYear(),
                            this.myDate.getMonth(),
                            this.myDate.getDate()
                          );
            }

            if(vm.reportType == 'x' || vm.reportType == 'z') {
                // vm.startDate = new Date(moment(vm.closingDate).format('YYYY-MM-DD'));
            }
            vm.refreshClicked = 0;
            vm.empty = false;
            vm.dailyreports = [];
            vm.salesReport = [];
        }

        /*
        ** Check if start date is after end date onchange of selected date
        */
        vm.onChangeDate = function() {
            if(vm.startDate != undefined && vm.endDate != undefined && moment(vm.startDate).isAfter(vm.endDate)) {
                vm.endDate = vm.startDate;
            }
        }

        /*
        ** Print sales and daily report
        */
        vm.printReport = function() {
            var condition = [];

            if(vm.reportType == 'sales') {
                condition = {
                    from: new Date(moment(vm.startDate).format('YYYY-MM-DD')),
                    to: new Date(moment(vm.endDate).format('YYYY-MM-DD'))
                };
            }

            var responseData = {
                reportType: vm.reportType,
                selectedUser: vm.userId,
                condition: condition,
                pageStatus:'print'
            };
           
            responseData.startDate  = new Date(moment(vm.startDate).format('YYYY-MM-DD'));
            responseData.endDate    = new Date(moment(vm.endDate).format('YYYY-MM-DD'));

            checkoutService.getPosReport(responseData).then(function(response) {
                if (response['success']) {
                    var myWindow = window.open('', "_blank", "scrollbars=yes, resizable=yes, width=500, height=700");
                    myWindow.document.write(response['printData']);
                    $timeout(function() {
                        myWindow.print();
                        myWindow.close();
                    },400);                    
                }
            });
        }

        
        setTimeout(function() {
           vm.autoFillOff = false;
        }, 1500); 
        
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.checkout')
        .controller('posOrdersController', posOrdersController);

    /** @ngInject */
    function posOrdersController(
    	$state, 
    	toastMessage, 
    	$scope, 
    	$http, 
    	EnvironmentConfig, 
    	$q, 
    	moment, 
    	$mdDialog, 
    	$stateParams,
    	$localStorage,
    	$sessionStorage,
    	$rootScope
    )
    {
    	var vm = this;
		if(!$rootScope.backButtonPressed){
			$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = {};
			$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] = 1;
        	$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'] = 50;
		}
		vm.requestGoing = false;
		vm.canDelete = false;
        // vm.UserColumns = ['itinerary_number', 'confirmation_number', 'product_name', 'created_date', 'customer_name', 'grand_total', 'paid_amount', 'remaining_amount', 'room_stay_status', 'room_stay_from', 'room_stay_to', 'source_of_creation', 'created_by_user' ];
        vm.UserColumns = ['itinerary_number', 'product_name', 'created_date', 'customer_name', 'grand_total', 'created_by_user' ];
		vm.resetPageOffset = false;
		vm.showTable = true;
        /*Start*/
		$scope.paginatorCallback = paginatorCallback;
		$scope.LoadAllData = LoadAllData;
		$scope.getLoadResultsCallback = getLoadResultsCallback;

		$scope.selectedRowCallback = function(rows){
			vm.selectedUserId = rows;
		};
		var loadPageCallbackWithDebounce;
		$scope.statusValuesCallback = statusValuesCallback;
		$scope.createdValuesCallback = createdValuesCallback;
		$scope.checkinValuesCallback = checkinValuesCallback;
		$scope.checkoutValuesCallback = checkoutValuesCallback;
		$scope.statusValuesTransformer = statusValuesTransformer;

		$scope.$watch('filterText', function(){
			if(loadPageCallbackWithDebounce){
				loadPageCallbackWithDebounce();
				if($scope.filterText != undefined && $scope.filterText != ''){
					vm.resetPageOffset = true;
				}
			}
		});

		$scope.toggleAll = function() {
			var toggleStatus = !$scope.isAllSelected;
			$scope.ChangeAll = toggleStatus;
		}
		$scope.checkBox = function(value) {
            if (vm.selectedUserId.indexOf(value) > -1 )
            {
				vm.selectedUserId.splice(vm.selectedUserId.indexOf(value), 1);
            }
            else
            {
				vm.selectedUserId.push(value);
            }
            if(vm.selectedUserId.length > 0){
				vm.getNumberOfSelectedRows = vm.selectedUserId.length;
				vm.checkDelete = true;
            } else {
				vm.checkDelete = false;
            }
		};

        function getLoadResultsCallback(loadPageCallback){
			loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
        }
        vm.onLoad = true;
        function paginatorCallback(page, pageSize,option){
        	if(vm.requestGoing) return;
        	if(vm.onLoad == true){
        		if(typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] != 'undefined'){

        			var page1 =  $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
        			var pageSize1 = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'];
  					vm.onLoad = false;
        			return LoadAllData(page1, pageSize1,option);
        		}else{
	        		vm.onLoad = false;
	        		return LoadAllData(page, pageSize,option);		
        		}
        	}else{
        		if(typeof page == 'undefined'){
        			page = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
        		}
        		
        		var currentOffset = (page-1) * pageSize;        		
        		if(vm.resetPageOffset || currentOffset > vm.totalReservations) {
	            	page = 1;	            	
	            }
	            if(vm.resetPageOffset) {
	            	vm.showTable = false;
	            	setTimeout(function() {
	            		vm.showTable = true;
	            	},10);
	            }
        		return LoadAllData(page, pageSize,option);
        	}
		}
		function LoadAllData(page, pageSize,option){        	
			vm.requestGoing = true;
			var pageDetail = {'currentPage':page,'pageSize':pageSize};
        	$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = pageDetail;

            vm.page = page;
            vm.pageSize = pageSize;
            vm.checkDelete = false;
            vm.selectedUserId = [];
            vm.search = [];
            var filtersApplied = option.columnFilter;            
            angular.forEach(filtersApplied, function(filter,key) {
				if(key == 2 && filter.length > 0){
					filter = moment(filter[0]).format('YYYY-MM-DD');
					this.push('created_date:'+filter);
				}else if(key == 9 && filter.length > 0){
					filter = moment(filter[0]).format('YYYY-MM-DD');
					this.push('room_stay_from:'+filter);
				}else if(key == 10 && filter.length > 0){
					filter = moment(filter[0]).format('YYYY-MM-DD');
					this.push('room_stay_to:'+filter);
				}else{
					if(filter.length > 0 && filter[0].name != 'All'){
						this.push(filter[0].fieldValue + ':' + filter[0].name);
					}
				}
			}, vm.search);
            var sort = {};
            for(var i=0; i<option.columnSort.length; i++){
                if(option.columnSort[i]['sort']){
                    sort['column']= vm.UserColumns[i];
                    sort['order']= option.columnSort[i]['sort'];
                }
            }

            var offset = (page-1) * pageSize;
            var query = $scope.filterText ? $scope.filterText : '';
           	
            var filterData = {'offset':offset , 'pageSize': pageSize, 'search':$scope.filterText , 'sort':sort, 'customSearch':vm.search, typeOfService: $stateParams.typeofService};
          	
          	return $http({
                url: EnvironmentConfig.api+'Checkout/getAllOrdersListing',
                method:'POST',
                data:filterData
            }).then(function(result){
				vm.resetPageOffset = false;
				vm.templates =result.data['reservations'];
				vm.totalReservations =result.data['totalReservations'];
				vm.requestGoing = false;
				if($stateParams.toast_message){
					toastMessage.showSimpleToast($stateParams.toast_message,'error-toast');
					$stateParams.toast_message = false;
				}
				return {
					results: result.data['reservations'],
					totalResultCount: result.data['totalReservations']
				}
            });

		}

		function statusValuesCallback(){
			return $q.resolve([
			{
				name: 'All',fieldValue: 'room_stay_status'
			}, {
				name: 'Checked-In',fieldValue: 'room_stay_status'
			}, {
				name: 'Checked-Out',fieldValue: 'room_stay_status'
			}, {
				name: 'Closed',fieldValue: 'room_stay_status'
			}, {
				name: 'Active',fieldValue: 'room_stay_status'
			}, {
				name: 'Canceled',fieldValue: 'room_stay_status'
			}]);
		}
		function createdValuesCallback(){
			return $q.resolve('created_date');
		}
		function checkinValuesCallback(){
			return $q.resolve('room_stay_from');
		}
		function checkoutValuesCallback(){
			return $q.resolve('room_stay_to');
		}
		function statusValuesTransformer(statusObject){
			return statusObject.name;
		}
		/*End*/

        /**
         * Go to product detail
         *
         * @param id
         */
		$scope.goToEditPage= function(value) {
			if ($stateParams.typeofService === 'restaurant') {
				$state.go("app.restaurant-order",{one_go_id:value});
			} else {
				$state.go("app.pos-order",{one_go_id:value});
			}
		};
    }
})();
(function ()
{
    'use strict';

    angular.module('app.create-res')
        .controller('addController1', addController1);

    /** @ngInject */
    function addController1(
        $mdDialog,
        customerIndex,
        createResService,
        $localStorage,
        toastMessage,
        $rootScope,
        typeOfCust, 
        $timeout,
        Country,
        userService
    ){
		var vm = this;
		// Data
		vm.data = {};
       //Methods
       vm.closeDialog = closeDialog;
       vm.contact = {};
       vm.pop_header = 'Add Customer';
       vm.contact.is_active = 1;
       
       vm.duplicateEmail = false;
       vm.contact.tax_exempt_indicator = 0;
       vm.contact.send_email_indicator = 1;
       vm.checkDuplicateEmail = checkDuplicateEmail;
       vm.addNewCustomer = addNewCustomer;
       vm.hotel_id = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
       vm.countries = vm.states = [];
       vm.autoFillOff = true;


       vm.countryList = [];
        vm.stateList = [];
        Country.forEach(function(element) {
            vm.countryList.push(element.name);
        });

        vm.selectedItemChangeState = selectedItemChangeState;
        

       /**
	   * Close dialog
	   */
	    function closeDialog()
        {
           $mdDialog.hide();
        }

        function checkDuplicateEmail() {
            vm.isloading = true;
            vm.duplicateEmail = false;
            createResService.checkCustomerDuplicateEmail(vm.contact.customer_email,vm.hotel_id).then(function(response) {
                if(response.success) {
                    vm.duplicateEmail = true;
                }
            });
            vm.isloading = false;
        }

        function addNewCustomer() {
            vm.isloading = true;
            if(!vm.duplicateEmail) {
                vm.contact.is_account_virtual = 1;
                vm.contact.hotel_id = vm.hotel_id;
                createResService.addCustomer(vm.contact).then(function(response) {
                    if(response.success){
                        if(response.errorMsg){
                            toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                        }
                        //customerIndex
                        createResService.getCustomers({customer_id:response.id,selectedHotel:vm.hotel_id})
                            .then(function(response) {
                                alert('Calling broad cast');
                                $rootScope.$broadcast('updateCustomer',{customerIndex: customerIndex,customerPopup: response[0].customerList,typeOfCust:typeOfCust});
                        });
                        vm.closeDialog();
                    } else if(response.errorMsg){
                        toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                    }else{
                        toastMessage.showSimpleToast('There was some error in saving customer.','error-toast');
                    }
                })
            }
            vm.isloading = false;
        }

        vm.getCountries = function() {
            vm.isloading = true;
            if(Object.keys(vm.countries).length <= 1) {
                return $timeout(function() {
                    createResService.getCountries().then(function(response) {
                        vm.countries = response;
                        vm.isloading = false;
                    });
                },1500);
            }
         }

         vm.getStates = function() {
            vm.isloading = true;
            return $timeout(function() {
                createResService.getStates(vm.contact.country).then(function(response) {
                    vm.states = response;
                    vm.isloading = false;
                });
            },1500);
         }
         /*Search For country start*/
        vm.simulateQuery = false;
        vm.isDisabled = false;

        // list of `state` value/display objects
        vm.myCountryArr = loadAll();

        vm.queryCountrySearch = queryCountrySearch;
        vm.newState = newState;

        function newState(state) {
            alert("Sorry! You'll need to create a Constitution for " + state + " first!");
        }

        function queryCountrySearch(query) {
            var results = query ? vm.myCountryArr.filter(createFilterForCountry(query)) : vm.myCountryArr,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function() {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }
        /**
         * Build `states` list of key/value pairs
         */
        function loadAll() {
            var allStates = vm.countryList;
            return allStates.map(function(state) {
                return {
                    value: state.toLowerCase(),
                    display: state
                };
            });
        }

        /**
         * Create filter function for a query string
         */
        function createFilterForCountry(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };
        }
        /*Search For country end*/
        vm.selectedItemChange = selectedItemChange;
        function selectedItemChange() {
             vm.stateList = [];
            vm.isStateDisabled = true;
            if(vm.selectedCountry){
                vm.contact.country = vm.selectedCountry['display'];
                if (typeof vm.selectedCountry['display'] != undefined || vm.selectedCountry['display'] != '') {
                    vm.selectedState = '';
                    vm.isloading = true;
                    userService.getStates(vm.contact.country).then(function(response) {
                        response.forEach(function(element) {
                            vm.stateList.push(element.name);
                        });
                        vm.isloading = false;
                    });
                    return $timeout(function() {
                        var temp = [];
                        vm.myStateArr = loadAllState();
                        vm.isStateDisabled = false;
                    }, 1500);
                }

            }
            
        }

        /*state start*/
        vm.simulateQuery = false;
        vm.isDisabled = false;
        // list of `state` value/display objects
        vm.queryStateSearch = queryStateSearch;

        function queryStateSearch(query) {
            var results = query ? vm.myStateArr.filter(createFilterForState(query)) : vm.myStateArr,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function() {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }
        /**
         * Build `states` list of key/value pairs
         */
        function loadAllState() {
            return vm.stateList.map(function(state) {
                return {
                    value: state.toLowerCase(),
                    display: state
                };
            });
        }

        /**
         * Create filter function for a query string
         */
        function createFilterForState(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };
        }

        function selectedItemChangeState() {
            if (vm.selectedState['display']) {
                vm.contact.state = vm.selectedState['display'];
            }
        }
        /*state End*/
        setTimeout(function() {
           vm.autoFillOff = false;
        }, 1500); 

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.components.tables.simple-table', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.components_tables_simple-table', {
            url  : '/components/table/simple-table',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/tables/simple-table/simple-table.html',
                    controller : 'SimpleTableController as vm'
                }
            },
            resolve: {
                Employees: function (msApi)
                {
                    return msApi.resolve('tables.employees@get');
                }
            }
        });

        // Api
        msApiProvider.register('tables.employees', ['app/data/tables/employees.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.simple-table')
        .controller('SimpleTableController', SimpleTableController);

    /** @ngInject */
    function SimpleTableController(Employees)
    {
        var vm = this;

        // Data
        vm.employees = Employees.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.datatable',
            [
                // 3rd Party Dependencies
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.components_tables_datatable', {
            url    : '/components/table/datatable',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/components/tables/datatable/datatable.html',
                    controller : 'DatatableController as vm'
                }
            },
            resolve: {
                Employees: function (msApi)
                {
                    return msApi.resolve('tables.employees100@get');
                }
            }
        });

        // Api
        msApiProvider.register('tables.employees100', ['app/data/tables/employees100.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.datatable')
        .controller('DatatableController', DatatableController);

    /** @ngInject */
    function DatatableController(Employees)
    {
        var vm = this;

        // Data
        vm.employees = Employees.data;

        vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.typography', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_typography', {
            url      : '/ui/typography',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/typography/typography.html',
                    controller : 'TypographyController as vm'
                }
            },
            bodyClass: 'typography'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.typography')
        .controller('TypographyController', TypographyController);

    /** @ngInject */
    function TypographyController()
    {
        // Data

        // Methods

        //////////
    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors')
        .controller('ThemeColorsController', ThemeColorsController);

    /** @ngInject */
    function ThemeColorsController(fuseTheming, $mdDialog, $document)
    {
        var vm = this;
        // Data
        vm.themes = fuseTheming.themes;

        // Methods
        vm.createTheme = createTheme;
        //////////

        function createTheme(ev)
        {
            $mdDialog.show({
                controller         : 'CustomThemeDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/ui/theme-colors/dialogs/custom-theme/custom-theme-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.material-colors', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_material-colors', {
            url  : '/ui/material-colors',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/material-colors/material-colors.html',
                    controller : 'MaterialColorsController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.material-colors')
        .controller('MaterialColorsController', MaterialColorsController);

    /** @ngInject */
    function MaterialColorsController($mdColorPalette)
    {
        var vm = this;

        // Data
        vm.palettes = $mdColorPalette;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.icons', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.ui_icons', {
            url      : '/ui/icons',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/icons/icons.html',
                    controller : 'IconsController as vm'
                }
            },
            resolve  : {
                Icons: function (msApi)
                {
                    return msApi.resolve('icons@get');
                }
            },
            bodyClass: 'icons'
        });

        // Api
        msApiProvider.register('icons', ['assets/icons/selection.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.icons')
        .controller('IconsController', IconsController);

    /** @ngInject */
    function IconsController(Icons)
    {
        var vm = this;

        // Data
        vm.icons = Icons.icons;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.helper-classes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_helper-classes', {
            url      : '/ui/helper-classes',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/helper-classes/helper-classes.html',
                    controller : 'HelperClassesController as vm'
                }
            },
            bodyClass: 'helper-classes'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.helper-classes')
        .controller('HelperClassesController', HelperClassesController);

    /** @ngInject */
    function HelperClassesController()
    {
        // Data

        // Methods

        //////////
    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.forms', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_forms', {
            url      : '/ui/forms',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/forms/forms.html',
                    controller : 'FormsController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.forms')
        .controller('FormsController', FormsController);

    /** @ngInject */
    function FormsController($mdDialog)
    {
        var vm = this;

        // Data
        vm.horizontalStepper = {
            step1: {},
            step2: {},
            step3: {},
            step4: {},
            step5: {}
        };

        vm.verticalStepper = {
            step1: {},
            step2: {},
            step3: {},
            step4: {},
            step5: {}
        };

        vm.basicForm = {};
        vm.formWizard = {};
        vm.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
        'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
        'WY').split(' ').map(function (state)
        {
            return {abbrev: state};
        });

        // Methods
        vm.sendForm = sendForm;
        vm.showDataDialog = showDataDialog;
        vm.submitHorizontalStepper = submitHorizontalStepper;
        vm.submitVerticalStepper = submitVerticalStepper;

        //////////

        /**
         * Submit horizontal stepper data
         * @param event
         */
        function submitHorizontalStepper(event)
        {
            // Show the model data in a dialog
            vm.showDataDialog(event, vm.horizontalStepper);

            // Reset the form model
            vm.horizontalStepper = {
                step1: {},
                step2: {},
                step3: {},
                step4: {},
                step5: {}
            };
        }

        /**
         * Submit vertical stepper data
         *
         * @param event
         */
        function submitVerticalStepper(event)
        {
            // Show the model data in a dialog
            vm.showDataDialog(event, vm.verticalStepper);

            // Reset the form model
            vm.verticalStepper = {
                step1: {},
                step2: {},
                step3: {},
                step4: {},
                step5: {}
            };
        }

        /**
         * Submit stepper form
         *
         * @param ev
         */
        function showDataDialog(ev, data)
        {
            // You can do an API call here to send the form to your server

            // Show the sent data.. you can delete this safely.
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    };
                },
                template           : '<md-dialog>' +
                '  <md-dialog-content><h1>You have sent the form with the following data</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Close' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: data
                },
                clickOutsideToClose: true
            });
        }

        /**
         * Send form
         */
        function sendForm(ev)
        {
            // You can do an API call here to send the form to your server

            // Show the sent data.. you can delete this safely.
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    };
                },
                template           : '<md-dialog>' +
                '  <md-dialog-content><h1>You have sent the form with the following data</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Close' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });

            // Clear the form data
            vm.formWizard = {};
        }
    }
})();
'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../category/categoryService
 * @description
 * # ../category/categoryService
 * Service in the minervaApp.
 */
angular.module('app.todo')
  .service('todoService', function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
 	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}
 	
 	
 	function getUsers(){
		return $http({
			url:EnvironmentConfig.api+'Todo/skipAcl_getAllUsers',
			method:'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getTags(){
		return $http({
			url:EnvironmentConfig.api+'Todo/skipAcl_getAllTags',
			method:'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function addTask(taskData){
		return $http({
			url:EnvironmentConfig.api+'Todo/add_task',
			method:'POST',
			data: taskData
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getAllTasks(data){
		var url = '';
		if(data != undefined) {
			url = EnvironmentConfig.api+'Todo/skipAcl_getAllTasks/'+data;
		} else {
			url = EnvironmentConfig.api+'Todo/skipAcl_getAllTasks';
		}
		return $http({
			url: url,
			method:'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function updateTaskStatus(data){
		return $http({
			url:EnvironmentConfig.api+'Todo/skipAcl_updateTaskStatus',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function filterTheData(data){
		return $http({
			url:EnvironmentConfig.api+'Todo/skipAcl_getFilterData',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function updateTask(data){
		return $http({
			url:EnvironmentConfig.api+'Todo/update_task',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function deleteTask(data){
		return $http({
			url:EnvironmentConfig.api+'Todo/delete_task',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* change task status to approved or rejected 
	*/

	function approveRejectTaskStatus(taskId, status, productId) {
		var data = {
			taskId: taskId,
			task_inspected: status,
			type: 'task_inspected',
			task_product_id: productId
		};
		return $http({
			url:EnvironmentConfig.api+'todo/approve_reject_tasks_status',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* Get detail of task
	*/

	function getTaskDetail(taskId) {
		return $http({
			url:EnvironmentConfig.api+'todo/get_task_detail/'+taskId,
			method:'GET',
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* Update the task
	*/

	function updateHouseKeepTask(data) {
		return $http({
			url:EnvironmentConfig.api+'Todo/update_housekeep_task',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);	        
	}

	function updatemultipletasks(task,Inspection) {
		return $http({
			url:EnvironmentConfig.api+'Todo/updatemultipletasks',
			method:'POST',
			data:{"task":task,'Inspection':Inspection}
		})
		.then(getDataComplete)
		.catch(getDataFailed);	        
	}

	/**
	* add comment 
	*/

	function addComment(data) {
		return $http({
			url:EnvironmentConfig.api+'Todo/add_task_comment',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* add task 
	*/
	
	function addHouseKeepTask(data) {
		return $http({
			url:EnvironmentConfig.api+'Todo/add_housekeep_task',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);	        
	}


	function addTaskGanttChart(data) {
		var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth()+1; //January is 0!
        var yyyy = today.getFullYear();
        var todayDate = yyyy+'-'+mm+'-'+dd;
        data.task_priority    = 'higher';
        data.task_start       = todayDate;
        data.task_due_date    = todayDate;
        data.selectedTags     = [];
        data.task_to_user     = 0;
        data.task_category    = 'housekeeping';
        data.customMessage    = true;
        return $http({
			url:EnvironmentConfig.api+'Todo/add_task_ganttChart',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/*
	** Check if task already exist for the selected room
	*/
	function checkIfTaskExistForRoom(data) {
		return $http({
			url:EnvironmentConfig.api+'Todo/checkIfTaskExistForRoom',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/*
	** Upload audio file
	*/
	function uploadAudio(data) {
		return $http({
			url: EnvironmentConfig.api+'Todo/upload_audio',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/*
	** Upload audio file
	*/
	function deleteAudio(data) {
		$http({
			url: EnvironmentConfig.api+'Todo/delete_audio',
			method: 'POST',
			data: data
		});
	}

	/**
	* Get default housekeeper
	*/
	function getDefaultHousekeeper(room) {
		return $http({
			url:EnvironmentConfig.api+'todo/getDefaultHousekeeper/'+taskId,
			method:'GET',
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* Get default housekeeper
	*/
	function getCategoryRooms(data) {
		return $http({
			url: EnvironmentConfig.api+'Todo/getCategoryRooms',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* Get activity logs for a task
	*/
	function getTaskLogs(taskId) {
		return $http({
			url: EnvironmentConfig.api + 'todo/get_task_logs/' + taskId,
			method: 'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}


 	return{
 		getUsers: getUsers,
 		getTags: getTags,
 		addTask: addTask,
 		getAllTasks: getAllTasks,
 		updateTaskStatus: updateTaskStatus,
 		filterTheData: filterTheData,
 		updateTask: updateTask,
 		deleteTask: deleteTask,
 		approveRejectTaskStatus: approveRejectTaskStatus,
 		updateHouseKeepTask: updateHouseKeepTask,
 		getTaskDetail: getTaskDetail,
 		addComment: addComment,
 		addHouseKeepTask: addHouseKeepTask,
 		addTaskGanttChart: addTaskGanttChart,
 		checkIfTaskExistForRoom : checkIfTaskExistForRoom,
 		uploadAudio : uploadAudio,
 		deleteAudio : deleteAudio,
 		getDefaultHousekeeper: getDefaultHousekeeper,
 		getCategoryRooms: getCategoryRooms,
 		updatemultipletasks:updatemultipletasks,
 		getTaskLogs: getTaskLogs
 	}
 });

(function() {
    'use strict';

    angular
        .module('app.todo')
        .controller('TodoController', TodoController)
        .filter('split', function() {
            return function(input, splitChar) {
                // do some bounds checking here to ensure it has that index
                var newChar=input.split(splitChar)
                if(newChar.length>1){
                    return +newChar[0]+"<hr class='newline'/>"+"\n"+newChar[1];
                } else{
                    newChar=input.split("+");
                    if(newChar.length>1){
                        return newChar[0]+"<hr class='newline'/>"+"\n"+newChar[1];
                    } else {
                        return input;
                    }
                }
            }
        });

    /** @ngInject */
    function TodoController($timeout, $document, $mdDialog, $mdSidenav, todoService, $rootScope, $localStorage, $scope, $stateParams, $state, EnvironmentConfig) {
        /* toDoTasks */
        var vm = this;
        // Data
        // vm.tasks = toDoTasks['toDoTasks'];
        // vm.pages = toDoTasks['pages'];
        // vm.totalCount = toDoTasks['count'];
        // vm.tags = toDoTasks['tags'];
        vm.tasks = vm.pages = vm.tags = [];
        vm.totalCount = 0;
        vm.taskPriority = 'none';
        vm.search = '';
        vm.completed = [];
        vm.curPage = 1;
        vm.limit = 20;
        vm.selectedFilterParams = [];
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth()+1; //January is 0!
        var yyyy = today.getFullYear();
        vm.Today = yyyy+'-'+mm+'-'+dd;
        vm.selectedFilterTags = vm.adminUsers = [];
        vm.colors = ['blue', 'blue-grey', 'orange', 'pink', 'purple'];
        vm.permissions = $rootScope.userPermissions;
        vm.hotelID = $localStorage.preHotelId;
        vm.subhotelID = 0;
        vm.PBColor = 'pbrcolor';
        vm.BVColor = 'bvcolor';
        vm.BPColor = 'bpcolor';
        vm.subHotels = [];

        todoService.getAllTasks().then(function(response){
            vm.tasks       = response['toDoTasks'];
            vm.pages       = response['pages'];
            vm.totalCount  = response['count'];
            vm.tags        = response['tags'];
            vm.adminUsers  = response['adminUsers'];
            vm.subHotels   = response.subHotel;

            if (response.subHotel.length > 0) {
                vm.subhotelID = response.mainHotel['hotel_id'];
            }
        });

        vm.emptyTasks = true;
        vm.selectedFilter = {
            filter: 'Start Date',
            dueDate: 'Next 3 days'
        };
        vm.selectedProject = 'housekeeping';
        $rootScope.filterParams = [];
        $rootScope.selectedFilterParams = [];
        vm.roomStatus = '';
        vm.roomFilterStatus = vm.roomCleaningStatus = '';
        vm.userView = 'housekeeper';
        vm.loggedRoleId = $localStorage.roleId;
        vm.selectedUser = 'all';
        // Tasks will be filtered against these models
        vm.taskFilters = {
            search: '',
            tags: [],
            completed: '',
            deleted: false,
            important: '',
            starred: '',
            startDate: '',
            dueDate: ''
        };
        vm.taskFiltersDefaults = angular.copy(vm.taskFilters);
        vm.showAllTasks = true;

        vm.taskOrder = '';
        vm.taskOrderDescending = false;

        vm.sortableOptions = {
            handle: '.handle',
            forceFallback: true,
            ghostClass: 'todo-item-placeholder',
            fallbackClass: 'todo-item-ghost',
            fallbackOnBody: true,
            sort: true
        };
        vm.msScrollOptions = {
            suppressScrollX: true
        };
		if($stateParams.showaddDialog==true){
		    $timeout(function ()
		    {
			   vm.openTaskDialog('')
		    });
	    }
        // Methods
        vm.preventDefault = preventDefault;
        vm.openTaskDialog = openTaskDialog;
        vm.toggleCompleted = toggleCompleted;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleFilter = toggleFilter;
        vm.toggleFilterWithEmpty = toggleFilterWithEmpty;
        vm.filterByStartDate = filterByStartDate;
        vm.filterByDueDate = filterByDueDate;
        vm.resetFilters = resetFilters;
        vm.toggleTagFilter = toggleTagFilter;
        vm.isTagFilterExists = isTagFilterExists;
        vm.upDateTaskStatus = upDateTaskStatus;
        vm.filterData = filterData;
        vm.filterTheList = filterTheList;
        vm.filterByDateRange = filterByDateRange;
        vm.getSearchFilters = getSearchFilters;
        vm.sortDataByField = sortDataByField;
        vm.updateValues = updateValues;
        vm.loadPage = loadPage;

        function loadPage(curPage, goTo){          
            var preCount = vm.curPage;
            if(goTo == 'pre'){
                vm.curPage = parseInt(vm.curPage) - 1;
            }else if(goTo == 'next'){
                vm.curPage = parseInt(vm.curPage) + 1;
            }

            if(vm.pages.indexOf(vm.curPage) == -1){
                vm.curPage = preCount;
            } else{
                filterTheList();
            }
        }


        init();

        //////////


        /**
         * Initialize the controller
         */
        function init() {
            angular.forEach(vm.tasks, function(task) {
                if (task.startDate) {
                    task.startDate = new Date(task.startDate);
                    task.startDateTimestamp = task.startDate.getTime();
                }

                if (task.dueDate) {
                    task.dueDate = new Date(task.dueDate);
                    task.dueDateTimestamp = task.dueDate.getTime();
                }
            });
        }
        vm.checkboxes=[];
        angular.forEach(vm.tasks,function(task,key){
            vm.checkboxes[key] = false;
        })

        vm.Tasksarray ={};
        vm.showCheckbox=false;
        vm.selectAllTasks=false;
        vm.SelectallLIstings = function(){
            if(vm.selectAllTasks ==false){
                angular.forEach(vm.tasks,function(task,key){
                    vm.checkboxes[key] = true;
                    vm.Tasksarray[key] = angular.copy(task);
                });
                vm.showCheckbox=true;
            } else {
                angular.forEach(vm.tasks,function(task,key){
                    vm.checkboxes[key] = false;
                });
                vm.Tasksarray= {};
                vm.showCheckbox=false;
            }             
        }

        vm.addTaskarray =function(Taskid,Index){
           if(vm.Tasksarray[Index] == '' || vm.Tasksarray[Index] == undefined){
                vm.Tasksarray[Index]= angular.copy(vm.tasks[Index]);
           } else {
                delete vm.Tasksarray[Index];
                vm.selectAllTasks = false;
           }
           if( Object.keys(vm.Tasksarray ).length >0 ){
                vm.showCheckbox=true;
           } else {
                vm.showCheckbox=false;          
           }
           if(Object.keys(vm.Tasksarray ).length == Object.keys(vm.tasks ).length){
            vm.selectAllTasks =true;
           }
        }

        vm.InspectionMethod='Inspection';
        vm.showloader = false;
        vm.disableButtons = false;
        vm.assignedUser ='';
        vm.changeMultiple= function(type){
            if(type== 'user' && vm.assignedUser.length >0){
                angular.forEach(vm.Tasksarray, function(val,key){
                    vm.Tasksarray[key].task_to_user = vm.assignedUser;
                });    
            }
            if(type == 'user' && vm.assignedUser.length == 0){
                return false;
            }
            vm.showloader = true;
            vm.disableButtons = true;
            todoService.updatemultipletasks(vm.Tasksarray,vm.InspectionMethod).then(function(response){  
                var user = '';
                var userTooltip = '';
                 if(type== 'user' && vm.assignedUser.length >0){
                    var matchedNames = [];
                    angular.forEach(vm.adminUsers,function(val,key){
                        angular.forEach(vm.assignedUser,function(uval,ukey){
                            if(val.value == uval){
                               matchedNames.push(val.display);
                               if(user == ''){
                                    user = val.display.split(' ')[0];
                                }
                            }
                        })
                    });
                    userTooltip = matchedNames.join(', ');
                    if(user != '' && vm.assignedUser.length > 1 ) {
                        user = user + ' (+'+(vm.assignedUser.length-1)+')';
                    }
                 };

                var responses = angular.isArray(response) ? response : [];
                angular.forEach(vm.tasks,function(task,key){
                   angular.forEach(responses,function(responseid,responsekey){
                        if(task.task_id == responseid.id && responseid.success !== false){
                            if (type === 'user') {
                                vm.tasks[key].task_to_user = vm.assignedUser.join ? vm.assignedUser.join(',') : vm.assignedUser;
                                vm.tasks[key].user_name = user;
                                vm.tasks[key].user_name_tooltip = userTooltip || user;
                            } else {
                                vm.tasks[key].inspection=vm.InspectionMethod;
                                if(vm.InspectionMethod =='notInspected'){
                                    vm.tasks[key].task_status = 'undone';
                                    vm.tasks[key].task_inspected = 'notInspected';
                                    vm.tasks[key].task_rejected = '0';
                                }else if (vm.InspectionMethod =='accepted'){
                                    vm.tasks[key].task_status = 'done';
                                    vm.tasks[key].task_inspected = 'accepted';
                                    vm.tasks[key].task_rejected = '0';
                                }else if (vm.InspectionMethod =='rejected'){
                                    vm.tasks[key].task_status = 'undone';
                                    vm.tasks[key].task_inspected = 'rejected';
                                    vm.tasks[key].task_rejected = '1';
                                }else {
                                    vm.tasks[key].task_status = 'undone';
                                }
                            }
                        }
                    }) 
                });
                vm.selectAllTasks=false;
                vm.showCheckbox =false;
                vm.assignedUser = '';
                vm.Tasksarray={};
                angular.forEach(vm.tasks,function(task,key){
                    vm.checkboxes[key] = false;
                });
                vm.showloader = false;
                vm.disableButtons = false;
                vm.InspectionMethod ='';
                // Reload list so closed/accepted tasks leave the open view and assignees refresh
                filterTheList();
            }, function() {
                vm.showloader = false;
                vm.disableButtons = false;
            });
        }
        /**
         * Prevent default
         *
         * @param e
         */
        function preventDefault(e) {
            e.preventDefault();
            e.stopPropagation();
        }

        vm.productId = '';
        vm.selectedIndex = '';
        vm.subType = '';
        /**
         * Open new task dialog
         *
         * @param ev
         * @param task
         */
        function openTaskDialog(ev, task, type) {
            var userPermissions = $rootScope.userPermissions;
            if(userPermissions.indexOf("add_task") == -1 && userPermissions.indexOf("update_task") == -1 ){
                toastMessage.showSimpleToast('Access denied.','error-toast');
            } else {                
                if( vm.selectedProject === 'housekeeping') {
                    vm.openHousekeepingEditPopup(0, 0);
                } else {
                    todoService.getUsers().then(function(response) {
                        $mdDialog.show({
                            controller: 'TaskDialogController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/apps/todo/dialogs/task/task-dialog.html',
                            parent: angular.element($document.body),
                            targetEvent: ev,
                            clickOutsideToClose: true,
                            // onRemoving: function() { alert("closing!") },
                            locals: {
                                Task: task,
                                Tasks: vm.tasks,
                                ModalData: response,
                                task_category: vm.selectedProject,
                                event: ev,
                            },
                            onRemoving:function(){
                                vm.emptyTasks = false;
                                updateValues();
                            }
                        });
                    });

                }
            }
        }
        function updateValues(){
            $timeout(function() { 
                filterTheList();
         }, 500);
            
        }



        /**
         * Toggle completed status of the task
         *
         * @param task
         * @param event
         */
        function toggleCompleted(task, event, key) {
            event.stopPropagation();
            vm.tasks[key]['task_status'] = vm.tasks[key]['task_status'] == 'done' ? 'undone' : 'done';
            todoService.updateTaskStatus({
                id: vm.tasks[key]['task_id'],
                status: vm.tasks[key]['task_status']
            }).then(function(response) {
            });

            // task.completed = !task.completed;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggles filter with true or false
         *
         * @param filter
         */
        function toggleFilter(filter) {
            vm.taskFilters[filter] = !vm.taskFilters[filter];

            checkFilters();
        }


        /**
         * Toggles filter with true or empty string
         * @param filter
         */
        function toggleFilterWithEmpty(filter) {
            if (vm.taskFilters[filter] === '') {
                vm.taskFilters[filter] = true;
            } else {
                vm.taskFilters[filter] = '';
            }

            checkFilters();
        }

        /**
         * Reset filters
         */
        function resetFilters() {
            $rootScope.filterParams = [];
            $rootScope.selectedFilterParams = [];
            vm.selectedFilterTags = [];
            vm.selectedFilterParams = [];
            vm.taskPriority = 'none';
            vm.dueDate = '';
            vm.roomStatus = '';
            vm.roomFilterStatus = '';
            vm.roomCleaningStatus = '';
            vm.taskOrder = '';
            vm.search = '';
            vm.selectedUser = 'all';
            filterTheList();
        }



        /**
         * Check filters and mark showAllTasks
         * as true if no filters selected
         */
        function checkFilters() {
            vm.showAllTasks = !!angular.equals(vm.taskFiltersDefaults, vm.taskFilters);
        }

        /**
         * Filter by startDate
         *
         * @param item
         * @returns {boolean}
         */
        function filterByStartDate(item) {
            if (vm.taskFilters.startDate === true) {
                return item.startDate === new Date();
            }

            return true;
        }

        /**
         * Filter Due Date
         *
         * @param item
         * @returns {boolean}
         */
        function filterByDueDate(item) {
            if (vm.taskFilters.dueDate === true) {
                return !(item.dueDate === null || item.dueDate.length === 0);
            }

            return true;
        }

        /**
         * Toggles tag filter
         *
         * @param tag
         */
        function toggleTagFilter(tag_id) {
            var i = vm.selectedFilterTags.indexOf(tag_id);

            if (i > -1) {
                vm.selectedFilterTags.splice(i,1);
            } else {
                vm.selectedFilterTags.push(tag_id);
            }
            filterTheList();
        }
         /**
        get data within date range*/
        function filterByDateRange(){
            filterTheList();
            
        }
        /**
        get data within date range*/
        function getSearchFilters(){
            filterTheList();
            
        }
        function sortDataByField(){
            filterTheList();
            
        }
        vm.sortData = sortData;
        function sortData(){
            vm.taskOrderDescending = !vm.taskOrderDescending 
            filterTheList();
            
        }


        var filterListDebounce = null;
        function filterTheList(){
            /*if(vm.subhotelID && vm.subhotelID == 122) {
                vm.subhotelID = '';
            }*/
            // Collapse rapid duplicate refresh triggers into a single API call
            if (filterListDebounce) {
                $timeout.cancel(filterListDebounce);
            }
            filterListDebounce = $timeout(function() {
                filterListDebounce = null;
                var searchFields = {
                    'tags':vm.selectedFilterTags,
                    'filter':$rootScope.filterParams,
                    'dateRange':vm.dueDate,
                    'search':vm.search,
                    'sort':vm.taskOrder,
                    'sortorder':vm.taskOrderDescending,
                    'category':vm.selectedProject, 
                    'offset': (vm.curPage - 1) * vm.limit,
                    'limit':vm.limit,
                    'roomStatus': vm.roomFilterStatus,
                    'roomCleaningStatus': vm.roomCleaningStatus,
                    'selectedUser': vm.selectedUser,
                    'subhotel': vm.subhotelID
                };
                /*if (vm.emptyTasks) {
                    vm.tasks = [];
                }*/
                todoService.filterTheData(searchFields).then(function(response){
                    vm.tasks = angular.copy(response['toDoTasks']);
                    vm.pages = response['pages'];
                    vm.tags = response['tags'];
                    vm.totalCount = response['count'];
                    vm.adminUsers = response['adminUsers'];
                });
            }, 100);
        }

        var offUpdateTaskList = $rootScope.$on("updateTaskList", function(){
           filterTheList();          
        });

        var taskListPubnub = null;
        var taskListListener = null;
        function applyLiveTaskStatus(msg) {
            if (!msg || !msg.taskId || !vm.tasks || !vm.tasks.length) {
                return;
            }
            angular.forEach(vm.tasks, function(task) {
                if (String(task.task_id) !== String(msg.taskId)) {
                    return;
                }
                if (msg.type === 'task_status' && msg.status) {
                    task.task_status = msg.status;
                } else if (msg.type === 'task_accept_reject' && msg.status) {
                    task.task_inspected = msg.status;
                    if (msg.status === 'rejected') {
                        task.task_rejected = '1';
                        task.task_status = 'undone';
                    } else if (msg.status === 'accepted') {
                        task.task_rejected = '0';
                        task.task_status = 'done';
                    } else {
                        task.task_rejected = '0';
                    }
                } else if (msg.status) {
                    task.task_status = msg.status;
                }
            });
        }
        function initTaskListRealtime() {
            if (typeof PubNub === 'undefined' || !EnvironmentConfig.pubnubSubscribeKey) {
                return;
            }
            taskListPubnub = new PubNub({
                subscribeKey: EnvironmentConfig.pubnubSubscribeKey,
                userId: 'ls-admin-tasks-' + String($localStorage.userId || 'guest')
            });
            taskListListener = {
                message: function(event) {
                    if (!event || !event.message) {
                        return;
                    }
                    var msg = event.message;
                    if (msg.hotelID && String(msg.hotelID) !== String(vm.hotelID)) {
                        return;
                    }
                    var isStatus = msg.type === 'task_status' || msg.type === 'task_accept_reject';
                    var isListRefresh = event.channel === 'tasksUpdateListing';
                    if (isStatus) {
                        $scope.$applyAsync(function() {
                            applyLiveTaskStatus(msg);
                        });
                        return;
                    }
                    if (!isListRefresh) {
                        return;
                    }
                    $scope.$applyAsync(function() {
                        filterTheList();
                    });
                }
            };
            taskListPubnub.addListener(taskListListener);
            taskListPubnub.subscribe({ channels: ['task-updates', 'tasksUpdateListing'] });
        }
        function destroyTaskListRealtime() {
            if (!taskListPubnub) {
                return;
            }
            if (taskListListener) {
                taskListPubnub.removeListener(taskListListener);
            }
            taskListPubnub.unsubscribe({ channels: ['task-updates', 'tasksUpdateListing'] });
            taskListPubnub = null;
            taskListListener = null;
        }
        initTaskListRealtime();

        $scope.$on('$destroy', function() {
            if (offUpdateTaskList) {
                offUpdateTaskList();
            }
            if (filterListDebounce) {
                $timeout.cancel(filterListDebounce);
            }
            destroyTaskListRealtime();
        });

        /**
         * Returns if tag exists in the tagsFilter
         *
         * @param tag
         * @returns {boolean}
         */
        function isTagFilterExists(tag) {
            return vm.taskFilters.tags.indexOf(tag) > -1;
        }
        /**
        function to update task Status*/
        function upDateTaskStatus(status, key) {
            vm.tasks[key]['task_status'] = status;
            todoService.updateTaskStatus({
                id: vm.tasks[key]['task_id'],
                status: vm.tasks[key]['task_status']
            }).then(function(response) {
            });
        }
    

        function filterData(field, value) {         

            var index = $rootScope.selectedFilterParams.indexOf(field);
            if (field == 'task_priority') {
                if (index != -1) {
                    if ($rootScope.filterParams[index]['task_priority'] == value) { 
                        vm.taskPriority = 'none';
                        $rootScope.selectedFilterParams.splice(index, 1);
                        $rootScope.filterParams.splice(index, 1);

                    } else {
                        vm.taskPriority = value;                        
                        $rootScope.filterParams[index]['task_priority'] = value;
                    }
                } else {
                     
                    var val = {};
                    val[field] = value;
                    $rootScope.filterParams.push(val);
                    $rootScope.selectedFilterParams.push(field);
                    vm.taskPriority = value;
                }
            } else {
                if (index == -1) {
                     var val = {};
                    val[field] = value;
                    $rootScope.selectedFilterParams.push(field);
                    $rootScope.filterParams.push(val);
                } else {
                    $rootScope.selectedFilterParams.splice(index, 1);
                    $rootScope.filterParams.splice(index, 1);
                }
            }
            vm.selectedFilterParams = $rootScope.selectedFilterParams;
            filterTheList();
        }

        /**
        * filter by clean, dirty status
        */

        vm.filterByRoomStatus = function(value) {
            vm.roomFilterStatus = value;
            filterTheList();
        };

        /**
        * change task category from dropdown
        */

        vm.changeTaskCategory = function() {
            $rootScope.filterParams = [];
            $rootScope.selectedFilterParams = [];
            vm.selectedFilterTags = [];
            vm.selectedFilterParams = [];
            vm.taskPriority = 'none';
            vm.dueDate = '';
            vm.roomStatus = '';
            vm.roomFilterStatus = '';
            vm.roomCleaningStatus = '';
            vm.taskOrder = '';
            vm.search = '';
            vm.curPage = 1;
            vm.selectedUser = 0;
            filterTheList();
        }

        /**
        * approve or reject the task
        */

        vm.approveRejectTask = function(taskId, status, index) {
            todoService.approveRejectTaskStatus(taskId, status, vm.tasks[index].task_product_id).then(function(res){
                if (res) {
                    vm.tasks[index].task_inspected = status;
                }
            });
        }

        /**
         * Open task activity / workflow logs dialog
         */
        vm.openTaskLogsDialog = function(task, ev) {
            if (ev) {
                ev.preventDefault();
                ev.stopPropagation();
            }
            if (!task || !task.task_id) {
                return;
            }
            $mdDialog.show({
                controller: 'TaskLogsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/todo/dialogs/task-logs/task-logs-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                locals: {
                    taskId: task.task_id,
                    taskMeta: {
                        task_title: task.task_title,
                        product_room_number: task.product_room_number
                    }
                }
            }).catch(angular.noop);
        };
        /**
        * open popup to select user or priority or status
        */

        vm.openHousekeepingEditPopup = function(taskId, index) {
            vm.selectedIndex = index;
            if (taskId === 0 && vm.permissions.indexOf("add_task") === -1) {
                toastMessage.showSimpleToast('Access denied.','error-toast');
            } else if (vm.permissions.indexOf("update_task") === -1 ) {
                toastMessage.showSimpleToast('Access denied.','error-toast');
            } else {
                todoService.getTaskDetail(taskId).then(function(response) {
                    $mdDialog.show({
                        controller: 'HousekeepTaskDialogController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/apps/todo/dialogs/task/housekeep-dialog.html',
                        parent: angular.element($document.body),
                        // targetEvent: ev,
                        clickOutsideToClose: true,
                        locals: {
                            data: response,
                            task_category: response.taskDetail.task_category !== undefined ? response.taskDetail.task_category : vm.selectedProject,
                            type: (taskId === 0) ? 'add' : 'edit',
                            selectedCategory: response.taskDetail.task_category !== undefined ? response.taskDetail.task_category : vm.selectedProject
                        },
                        onRemoving:function(res){
                            vm.emptyTasks = false;
                            // Do not call updateValues/filterTheList here — edit/add already
                            // refresh once via $rootScope updateTaskList emit.
                            vm.deleteAudioFiles();
                        }
                    }).then(function(response) {
                        // edit/add already refresh via $rootScope updateTaskList emit
                        if (response && (response.from === 'edit' || response.from === 'add' || response.from === 'acceptReject')) {
                            return;
                        }
                        filterTheList();
                    });
                });
            } 
        };

        /**
         * Open reservation order page for a check-in / check-out stay side.
         */
        vm.openStayReservation = function(stay, $event) {
            if ($event) {
                $event.stopPropagation();
                $event.preventDefault();
            }
            if (!stay || stay.type === 'empty' || !stay.confirmation_number) {
                return;
            }
            var params = {
                confirmation_number: stay.confirmation_number
            };
            if (stay.reservation_id) {
                params.id = stay.reservation_id;
            }
            var url = $state.href('app.e-commerce.orders.detail', params);
            if (url) {
                window.open(url, '_blank');
            }
        };

        /**
        * task approved or rejected from edit popup
        */
        $scope.$on('approveRejTask', function(event, data){
            vm.approveRejectTask(data.taskId, data.status, vm.selectedIndex);
        });

        /**
        * To filter tasks by selected housekeeper assigned to the task
        */
        vm.filterBySelectedUser = function(userId) {
            filterTheList();
        };

        /**
        * To filter tasks by cleaning status of room
        */
        vm.filterByCleaningStatus = function(cleaningStatus) {
            vm.roomCleaningStatus = cleaningStatus;
            filterTheList();
        };

        /*
        ** Delete uploaded audio files from server
        */
        vm.deleteAudioFiles = function() {
            if($rootScope.audioFilesAdded.length > 0) {
                todoService.deleteAudio({files : $rootScope.audioFilesAdded});
            }
        }      

        vm.selectSubHotel = function(subhotelID) {
            /*if(subhotelID && subhotelID == 122) {
                vm.subhotelID = '';
            }*/
            setTimeout(function() {
                filterTheList();
            },100);
        }  

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.policy',
            [
                // 3rd Party Dependencies
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.policy', {
            url    : '/policy',
            title : 'Policies',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/policy/policy.html',
                    controller : 'PolicyController as vm'
                }
            },
			 resolve  : {
				Policies: function (policyService,$localStorage){
					return policyService.getDefaultPloicy( {hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id});
				}
			},
			permission: 'rate_policies'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/policy');

    }

})();

'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../category/categoryService
 * @description
 * # ../category/categoryService
 * Service in the minervaApp.
 */
angular.module('app.policy')
  .service('teamService', function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
 	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}
 	
 	function getFormData(data){
		return $http({
			url:EnvironmentConfig.api+'Team/skipAcl_formData',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getSelectedGroupMemebers(data){
		return $http({
			url:EnvironmentConfig.api+'Team/skipAcl_getSelectedGroupMemebers',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function createTeam(data){
		return $http({
			url:EnvironmentConfig.api + 'Team/add_team',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function deleteSelectedTeam(Ids){
		return $http({
			url:EnvironmentConfig.api +'Team/delete_Team',
			method:'POST',
			data:Ids
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function UpdateTeam(formData){
	return $http({
		url:EnvironmentConfig.api + 'Team/update_team',
		method:'POST',
		data:formData
	})
	.then(getDataComplete)
	.catch(getDataFailed);

	}
 	return{
 		getFormData: getFormData,
		createTeam:createTeam,
		deleteSelectedTeam:deleteSelectedTeam,
		UpdateTeam:UpdateTeam,
		getSelectedGroupMemebers:getSelectedGroupMemebers
 	}
 });

(function ()
{
    'use strict';

    angular
        .module('app.team',
            [
                // 3rd Party Dependencies
                'xeditable',
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.team', {
            url    : '/team',
            title  : 'Teams',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/team/team.html',
                    controller : 'team as vm'
                }
            },
            resolve  : {
                Users: function (){
                    return [];
                }
            },
			permission: 'teams'
        })
        .state('app.teamAdd', {
            url    : '/teamAddEdit/add',
            title  : 'Teams',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/team/teamAddEdit.html',
                    controller : 'team as vm'
                }
            },
            resolve  : {
                Users: function (teamService,$localStorage,$stateParams){
                    return teamService.getFormData( {hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id, status:'add'});
                }
            },
            params:      {status:'add'},
			permission: 'add_team',
            bodyClass: 'team'
        }).state('app.teamEdit', {
            url    : '/teamAddEdit/:status',
            title  : 'Teams',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/team/teamAddEdit.html',
                    controller : 'team as vm'
                }
            },
            resolve  : {
                Users: function (teamService,$localStorage,$stateParams){
                    return teamService.getFormData( {hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id, status:$stateParams.status});
                }
            },
			permission: 'update_team',
            bodyClass: 'team'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/team');

    }

})();

  (function() {
      'use strict';

      angular
          .module('app.team')
          .controller('team', team);

      /** @ngInject */
      function team(
        $stateParams, 
        $state, 
        $scope, 
        $http, 
        EnvironmentConfig, 
        $mdDialog, 
        toastMessage, 
        $localStorage, 
        $document, 
        groupService, 
        teamService, 
        Users, 
        commonService, 
        $sessionStorage,
        $rootScope
        ) {
          var vm = this;

          if(!$rootScope.backButtonPressed){
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = {};
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] = 1;
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'] = 50;
          }

          vm.pageStatus = $stateParams.status;
          vm.gotoaddteam = commonService.gotoaddteam;
          vm.saveTeam = saveTeam;
          vm.gotoTeamListing = gotoTeamListing;
          vm.updateTeam = updateTeam;
          vm.updateUserList = updateUserList;
          vm.addTeam = addTeam;
          vm.users = [];
          vm.groupForm = {};
          vm.SelectedUsers = [];
          vm.tempCust = [];
          vm.autoFillOff = true;
          if ($stateParams.status !== 'add' && typeof $stateParams.status != 'undefined') {
              vm.groupForm.team_name = Users[0]['teamData']['team_name'];
              vm.groupForm.group_id = Users[0]['teamData']['group_id']
              Users[0]['selectedMembers'].forEach(function(element, index) {
                  vm.SelectedUsers.push(element.user_id);
              });
              vm.tempCust = Users[0]['groupMembers'];

          }
           if (typeof $stateParams.status != 'undefined') {
              vm.groupList = Users[0]['groupList'];
          }



          function gotoTeamListing() {
              $state.go("app.team", {
                  status: 'add'
              });
          }

          function addTeam() {
          }

          function saveTeam() {
              vm.groupForm['selectedContacts'] = vm.users;
              vm.groupForm['hotel_id'] = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
              teamService.createTeam(vm.groupForm)
                  .then(function(response) {
                      if (!response) {
                          toastMessage.showSimpleToast('Some error occured. Please try again.', 'error-toast');

                      } else {
                          $state.go("app.team");
                      }
                  });
          }

          function updateTeam() {
              vm.groupForm['team_id'] = $stateParams.status;
              vm.groupForm['selectedContacts'] = vm.users;
              vm.groupForm['hotel_id'] = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];

              teamService.UpdateTeam(vm.groupForm)
                  .then(function(response) {
                      if (!response) {
                          toastMessage.showSimpleToast('Some error occured. Please try again.', 'error-toast');

                      } else {
                          $state.go("app.team");
                      }
                  });

          }

          function updateUserList() {
              teamService.getSelectedGroupMemebers({
                      group_id: vm.groupForm.group_id
                  })
                  .then(function(response) {
                      vm.tempCust = response;
                      vm.users = [];
                      vm.allUsers = loadUsers();
                  });


          }


          // chip select start##############################
          vm.querySearch = querySearch;
          vm.allUsers = loadUsers();
          //For Selected Users
          vm.filterSelected = true;
          /**
           * Search for contacts.
           */
          function querySearch(query) {
              var results = query ?
                  vm.allUsers.filter(createFilterFor(query)) : [];
              return results;
          }
          /**
           * Create filter function for a query string
           */
          function createFilterFor(query) {
              var lowercaseQuery = angular.lowercase(query);
              return function filterFn(contact) {
                  return (contact._lowername.indexOf(lowercaseQuery) != -1);;
              };
          }

          function loadUsers() {
              var users = [];
              if (Users[0])
                  users = vm.tempCust;

              return users.map(function(c, index) {

                  var user = {
                      name: c.first_name + ' ' + c.last_name,
                      email: c.email,
                      id: c.user_id
                  };
                  user._lowername = user.name.toLowerCase();
                  if (vm.SelectedUsers.indexOf(c.user_id) != -1) {
                      vm.users.push(user);
                  }
                  return user;
              });
          }
          // chip select end

          /*Start*/
          $scope.paginatorCallback = paginatorCallback;
          $scope.LoadAllData = LoadAllData;

          $scope.getLoadResultsCallback = getLoadResultsCallback;
          $scope.selectedRowCallback = function(rows) {
              vm.selectedprodId = rows;
              vm.checkDelete = false;
          };
          vm.userPermissions = $rootScope.userPermissions;
          if (vm.userPermissions.indexOf('delete_team') != -1) {
              vm.delete_product = true;
          } else {
              vm.delete_product = false;
          }
          var loadPageCallbackWithDebounce;
          $scope.$watch('filterText', function() {
              if (loadPageCallbackWithDebounce) {
                  loadPageCallbackWithDebounce();
              }
          });
          $scope.showTabDialog = function(ev, id) {
              roleService.getRolePermissions(id).then(function(response) {
                  if (response.listData.length == 0) {
                      toastMessage.showSimpleToast('This role has no module assigned.', 'error-toast');
                  } else {
                      $state.go('app.rolesPermission', {
                          id: id
                      });

                  }
              });
          };
          $scope.userPermissions = vm.userPermissions;
          $scope.updateTable = function() {
              loadPageCallbackWithDebounce();
          };

          $scope.toggleAll = function() {
              var toggleStatus = !$scope.isAllSelected;
              $scope.ChangeAll = toggleStatus;
          }
          $scope.checkBox = function(value) {
              if (vm.selectedprodId.indexOf(value) > -1) {
                  vm.selectedprodId.splice(vm.selectedprodId.indexOf(value), 1);
              } else {
                  vm.selectedprodId.push(value);
              }
              if (vm.selectedprodId.length > 0) {
                  vm.getNumberOfSelectedRows = vm.selectedprodId.length;
                  vm.checkDelete = true;
              } else {
                  vm.checkDelete = false;
              }
          };
          $scope.deleteSelectedItem = function(ev, selectedprodId) {
              var del_title = vm.selectedprodId.length > 1 ? 'teams' : 'team';

              // new
              var html ='Are you sure, you want to delete the selected ' + del_title + '?</br>';
              html = html +'<b>' + vm.selectedprodId.length + ' ' + del_title + '</b>' + ' will be deleted.';
                
                  $mdDialog.show({
                                controller: 'confirmController',
                                controllerAs: 'vm',
                                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                                parent: angular.element(document.body),
                                targetEvent: event,
                                clickOutsideToClose:true ,
                                locals: {
                                      title: 'Delete Team',
                                      htmlContent:html,
                                      cancelBtn:'Cancel',
                                      OkBtn:'Ok'
                                  }                
                              })
                              .then(function(answer) {
                                 if(typeof answer != 'undefined' && answer == 'update'){
                              teamService.deleteSelectedTeam(vm.selectedprodId)
                                .then(function(response) {
                                    if (response.errorMsg) {
                                        toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                                    } else {
                                        loadPageCallbackWithDebounce();
                                        vm.selectedprodId = [];
                                    }
                                });
                               }
                              }, function() {}); 
            //Old
          };

          function getLoadResultsCallback(loadPageCallback) {
              loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
          }
          vm.UserColumns = [
              'adminT.team_name',
              'adminG.group_name',
              'total_members'
            ];


          vm.onLoad = true;
          vm.requestGoing = false;
          function paginatorCallback(page, pageSize, option) {
            if(vm.requestGoing) return;
            if(vm.onLoad == true){
              if(typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] != 'undefined'){

                var page1 =  $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
                var pageSize1 = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'];
              vm.onLoad = false;
                return LoadAllData(page1, pageSize1,option);
              }else{
                vm.onLoad = false;
                return LoadAllData(page, pageSize,option);    
              }
            }else{
              if(typeof page == 'undefined'){
                page = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
              }
              return LoadAllData(page, pageSize,option);
            }

              
          }
          /*End*/

          function LoadAllData(page, pageSize,option){
            vm.requestGoing = true;
            var pageDetail = {'currentPage':page,'pageSize':pageSize};
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = pageDetail;

            vm.page = page;
              vm.pageSize = pageSize;
              vm.selectedprodId = [];
              var sort = {};

              for (var i = 0; i < option.columnSort.length; i++) {

                  if (option.columnSort[i]['sort']) {
                      sort['column'] = vm.UserColumns[i];
                      sort['order'] = option.columnSort[i]['sort'];
                  }
              }
              var offset = (page - 1) * pageSize;
              var query = $scope.filterText ? $scope.filterText : '';


              var filterData = {
                  'offset': offset,
                  'pageSize': pageSize,
                  'search': $scope.filterText,
                  'sort': sort,
                  'get_organization': true,
                  'get_count': true,
                  'hotel_id': $localStorage.hotels[$localStorage.selectedHotel].hotel_id
              };


              return $http({
                  url: EnvironmentConfig.api + 'Team/teams',
                  method: 'POST',
                  data: filterData
              }).then(function(result) {
                vm.requestGoing = false;
                  vm.totalGroups = result.data[0]['totalCount'];
                  return {
                      results: result.data[0]['teams'],
                      totalResultCount: result.data[0]['totalCount']
                  }
              });
          }

          $scope.goToEditPage = function(id) {
              if (vm.userPermissions.indexOf('update_team') != -1) {
                  $state.go("app.teamEdit", {
                      status: id
                  });
              }
          }

          setTimeout(function() {
             vm.autoFillOff = false;
          }, 1500); 

      }
  })();

(function ()
{
    'use strict';

    angular
        .module('app.subscriber',
            [
                // 3rd Party Dependencies
                'xeditable',
                'ngMaterial'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.subscriber', {
            url    : '/subscriber/',
            title  : 'Subscribers',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/subscriber/subscriber.html',
                    controller : 'SubscriberController as vm'
                }
            },
            resolve: {
                customerList: function (){
                    return [];
                }
            },
            permissions :'subscriber',
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/subscriber');

    }

})();

(function ()
{
    'use strict';

    angular
    .module('app.subscriber')
    .controller('SubscriberController', SubscriberController);

    /** @ngInject */
    function SubscriberController(
        $rootScope,
        $window,
        $scope,
        $mdSidenav,
        msUtils,
        $mdDialog,
        $document,
        userService,
        toastMessage,
        $localStorage,
        $http,
        EnvironmentConfig,
        $state,
        $sessionStorage,
        reportService
    )

    {
        var vm = this;
        if(!$rootScope.backButtonPressed){
          $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = {};
          $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] = 1;
          $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'] = 50;
        }
        vm.customerId = [];

        //vm.contacts = customerList[0];
        vm.selectedCustomerId = [];
        vm.checkDelete = false;
        vm.tempselect = true;
        vm.gotoaddcustomer = gotoaddcustomer;


        /*Start*/
        $scope.paginatorCallback = paginatorCallback;
        $scope.getLoadResultsCallback = getLoadResultsCallback;
        $scope.selectedRowCallback = function(rows, id){
            vm.selectedCustomerId = rows;
        };
        $scope.myRowClickCallback = function(event){
        };
        $scope.goToEditPage = function(value){
			if(vm.userPermissions.indexOf('update_customer') != -1) {
				// $state.go("app.customer_update",{customer_id:value});
			}
        };
        // self.myRowClickCallback = function (rowId) {
        //               .....
        //             };
        $scope.deleteSelectedItem = function(ev){

            var html = 'Are you sure, you want to delete the selected subscriber(s)?</br>';
            html = html + '<b>' + vm.selectedCustomerId.length + ' subscriber(s)</b>' + ' will be deleted.'

                $mdDialog.show({
                              controller: 'confirmController',
                              controllerAs: 'vm',
                              templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                              parent: angular.element(document.body),
                              targetEvent: event,
                              clickOutsideToClose:true ,
                              locals: {
                                    title: vm.selectedCustomerId.length > 1?'Delete Subscribers':'Delete Subscriber',
                                    htmlContent:html,
                                    cancelBtn:'Cancel',
                                    OkBtn:'Ok'
                                }
                            })
                            .then(function(answer) {
                               if(typeof answer != 'undefined' && answer == 'update'){

                               userService.deleteSelectedSubscribe(vm.selectedCustomerId)
                                .then(function(response){
                                    if(!response.error){
                                        vm.selectedCustomerId = [];
                                        vm.checkDelete = false;
                                        loadPageCallbackWithDebounce();
                                    } else {
                                        if(response.message){
                                          toastMessage.showSimpleToast(response.message,'error-toast');
                                        } else {

                                          toastMessage.showSimpleToast('Some error occured.Please try again.','error-toast');
                                        }
                                    }
                                });
                               }
                            }, function() {});
            //Old
        };

        var loadPageCallbackWithDebounce;
        $scope.$watch('filterText', function(){
            if(loadPageCallbackWithDebounce){
              loadPageCallbackWithDebounce();
          }
      });

        $scope.updateTable= function() {
          loadPageCallbackWithDebounce();

      };


    $scope.addmodel = function (ev, contact){

        userService.getSingleEdit(contact).then(function(response){

            // if(typeof contact=='undefined' || vm.userPermissions.indexOf('delete_customer') != -1){
            // if(userPermissions!='All' && userPermissions.indexOf('List Customers') == -1){
                $mdDialog.show({
                    controller         : 'ContactDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/apps/contacts/dialogs/contact/contact-dialog.html',
                    parent             : angular.element($document.find('#content-container')),
                    targetEvent        : ev,
                    scope:$scope.$new(),
                    clickOutsideToClose: true,
                    locals             : {
                        Contact : response[0],
                        User    : vm.user,
                        Contacts: vm.contacts
                    }
                });
                jQuery('.sec-contact-tab').css('display','none');
                jQuery('.third-contact-tab').css('display','none');
            // }

        });

}



	function getLoadResultsCallback(loadPageCallback){
		loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
	}
	vm.UserColumns = [
                    'email',
                    'created_date',
                    'id'
    ];


	function paginatorCallback(page, pageSize, option){
    if(typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] != 'undefined'){
      var page =  $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
      var pageSize = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'];
    }

		vm.checkDelete = false;
		vm.selectedCustomerId = [];
		if(!page){
			page = vm.page;
        } else {
            vm.page = page;
        }
		var sort = {};
		for(var i=0; i<option.columnSort.length; i++){
			if(option.columnSort[i]['sort']){
				sort['column']= vm.UserColumns[i];
				sort['order']= option.columnSort[i]['sort'];
			}
		}
		var offset = (page-1) * pageSize;
		var query = $scope.filterText ? $scope.filterText : '';
		var filterData = {'offset':offset , 'pageSize': pageSize, 'search':$scope.filterText,'sort':sort, 'selectedHotel':$localStorage.hotels[$localStorage.selectedHotel].hotel_id };
		return $http({
			url: EnvironmentConfig.api+'customer/getSubscribers',
			method:'POST',
			data:filterData
		}).then(function(result){
			vm.contacts = result.data['subscribers'];
			vm.totalCustomers = parseInt(result.data['count']);
			return {
				results: vm.contacts,
				totalResultCount: vm.totalCustomers
			}
		});
	}

	/*End*/
	vm.user = [];
	vm.filterIds = null;
	vm.listType = 'all';
	vm.listOrder = 'name';
	vm.listOrderAsc = false;
	vm.selectedContacts = [];
	vm.newGroupName = '';
	vm.userPermissions = $rootScope.userPermissions;
	if(vm.userPermissions.indexOf('delete_customer') != -1){
		$scope.isDeletedAllowed = true;
	}else{
		$scope.isDeletedAllowed = false;
	}
	// Methods
	vm.filterChange = filterChange;
	vm.openContactDialog = openContactDialog;
	// vm.deleteContactConfirm = deleteContactConfirm;
	vm.deleteContact = deleteContact;
	vm.deleteSelectedContacts = deleteSelectedContacts;
	vm.toggleSelectContact = toggleSelectContact;
	vm.deselectContacts = deselectContacts;
	vm.selectAllContacts = selectAllContacts;
	vm.deleteContact = deleteContact;
	vm.addNewGroup = addNewGroup;
	vm.deleteGroup = deleteGroup;
	vm.toggleSidenav = toggleSidenav;
	vm.toggleInArray = msUtils.toggleInArray;
	vm.exists = msUtils.exists;
	vm.convertdatestring = convertdatestring;
	vm.status = [{'value':1, 'name':'Active'}, {'value':0, 'name':'Inactive'}]
	vm.gender = [{'value':1, 'name':'Male'}, {'value':0, 'name':'Female'}]

	function convertdatestring(dateString){
	   return new Date(dateString);
	}

        //////////

        /**
         * Change Contacts List Filter
         * @param type
         */
         function filterChange(type)
         {
            vm.listType = type;

            if ( type === 'all' )
            {
                vm.filterIds = null;
            }
            else if ( type === 'frequent' )
            {
                vm.filterIds = vm.user.frequentContacts;
            }
            else if ( type === 'starred' )
            {
                vm.filterIds = vm.user.starred;
            }
            else if ( angular.isObject(type) )
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
         function openContactDialog(ev, contact)
         {
            if(typeof contact=='undefined' || vm.userPermissions.indexOf('delete_customer') != -1){
                $mdDialog.show({
                    controller         : 'ContactDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/apps/contacts/dialogs/contact/contact-dialog.html',
                    parent             : angular.element($document.find('#content-container')),
                    targetEvent        : ev,
                    scope:$scope.$new(),
                    clickOutsideToClose: true,
                    locals             : {
                        Contact : contact,
                        User    : vm.user,
                        Contacts: vm.contacts
                    }
                });
                jQuery('.sec-contact-tab').css('display','none');
                jQuery('.third-contact-tab').css('display','none');
            }
        }

        /**
         * Delete Contact
         */
         function deleteContact(contact)
         {
            vm.contacts.splice(vm.contacts.indexOf(contact), 1);
        }

        /**
         * Delete Selected Contacts
         */
         function deleteSelectedContacts(ev)
         {
            var confirm = $mdDialog.confirm()
            .title('Are you sure, you want to delete the selected customer(s)?')
            .htmlContent('<b>' + vm.selectedCustomerId.length + ' customer(s)</b>' + ' will be deleted.')
            .ariaLabel('delete contacts')
            .targetEvent(ev)
            .ok('OK')
            .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                userService.deleteSelectedContacts(vm.selectedCustomerId)
                .then(function(response){
                    if(!response.error){
                        vm.selectedCustomerId = [];
                        vm.checkDelete = false;
                        loadPageCallbackWithDebounce();

                    } else {
                        toastMessage.showSimpleToast('There was some error in deleting customers.','error-toast');
                    }
                });
            });

        }

        /**
         * Toggle selected status of the contact
         *
         * @param contact
         * @param event
         */
         function toggleSelectContact(contact, event)
         {

            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedContacts.indexOf(contact) > -1 )
            {
                vm.selectedContacts.splice(vm.selectedContacts.indexOf(contact), 1);
                vm.customerId.splice(vm.customerId.indexOf(contact.customer_id), 1);
            }
            else
            {
                vm.customerId.push(contact.customer_id);
                vm.selectedContacts.push(contact);
            }
        }

        /**
         * Deselect contacts
         */
         function deselectContacts()
         {
            vm.selectedContacts = [];
            vm.customerId = [];
        }

        /**
         * Sselect all contacts
         */
         function selectAllContacts()
         {
            if(vm.checkAll){
                vm.selectedCustomerId = [];
                vm.customerId = [];
                for(var i=0 ; i< vm.contacts.length; i++){
                    vm.selectedCustomerId.push(vm.contacts[i].customer_id);
                }
                //  angular.forEach($scope.Items, function (item) {
                //     item.Selected = $scope.selectedAll;
                // });
                vm.deleteCheckbox = true;
            } else {
                vm.deleteCheckbox = false;
                vm.selectedCustomerId = [];
            }


        }

        /**
         *
         */
         function addNewGroup()
         {
            if ( vm.newGroupName === '' )
            {
                return;
            }

            var newGroup = {
                'id'        : msUtils.guidGenerator(),
                'name'      : vm.newGroupName,
                'contactIds': []
            };

            vm.user.groups.push(newGroup);
            vm.newGroupName = '';
        }

        /**
         * Delete Group
         */
         function deleteGroup(ev)
         {
            var group = vm.listType;

            var confirm = $mdDialog.confirm()
            .title('Are you sure want to delete the group?')
            .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
            .ariaLabel('delete group')
            .targetEvent(ev)
            .ok('OK')
            .cancel('CANCEL');

            $mdDialog.show(confirm).then(function (){
                vm.user.groups.splice(vm.user.groups.indexOf(group), 1);
                filterChange('all');
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId){
            $mdSidenav(sidenavId).toggle();
        }
        function gotoaddcustomer(){
			$state.go('app.customer_add');
		}
        vm.emailReport = emailReport;
        vm.requestProcessingEmail = false;
        function emailReport(){
            $mdDialog.show({
                controller: "getEmailAddress",
                controllerAs: "vm",
                templateUrl: "app/main/apps/reports/getEmailAddress.html",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true
            })
            .then(function(answer) {
                if(typeof answer != "undefined"){
                    vm.requestProcessingEmail = true;

                    reportService.sendSubscribersReport({
                        emailAddress: answer
                    }).then(function(response){
                        vm.requestProcessingEmail = false;
                        if(response.success){
                            toastMessage.showSimpleToast("Subscribers report sent successfully.", "success-toast");
                        } else {
                            toastMessage.showSimpleToast(response.errorMsg || "Error sending report.", "error-toast");
                        }
                    });
                }
            }, function() {});
        }

    }

})();

(function () {
  "use strict";

  angular.module("app.sheetPrice", []).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {

    $stateProvider.state("app.room-precedence-sheet-prices", {
      url: "/sheetPrice",
      title: "Sheet Price",
      views: {
        "content@app": {
          templateUrl: "app/main/apps/sheetPrice/sheetPrice.html",
          controller: "sheetPriceController as vm",
        },
      },
      permission: "room_precedence",
    });
    $translatePartialLoaderProvider.addPart("app/main/apps/sheetPrice");
  }
})();

"use strict";

angular
  .module("app.sheetPrice")
  .service("sheetPriceService", function ($http, EnvironmentConfig) {

    function getDataComplete(response) {
      return response.data;
    }

    function getDataFailed(error) {
      return error.data;
    }

    function getSheetPriceData(subHotelId) {
        var queryParams = [];
        if (subHotelId) {
            queryParams.push("sub_hotel_id=" + encodeURIComponent(subHotelId));
        }
        var url = EnvironmentConfig.api + "roomPrecedences/getRoomUpgradeMatrix";

      if (queryParams.length) {
        url += "?" + queryParams.join("&");
      }
      return $http({
        url: url,
        method: "GET"
      })
      .then(getDataComplete)
      .catch(getDataFailed);
    }

    function saveSheetPrice(payload, subHotelId) {
      var queryParams = [];
      if (subHotelId) {
          queryParams.push("sub_hotel_id=" + encodeURIComponent(subHotelId));
      }

      var url = EnvironmentConfig.api + "roomPrecedences/updateRoomUpgradePrices";

      if (queryParams.length) {
          url += "?" + queryParams.join("&");
      }
      return $http({
          url: url,
          method: "POST",
          data: payload
      })
      .then(getDataComplete)
      .catch(getDataFailed);
    }

    return {
      getSheetPriceData: getSheetPriceData,
      saveSheetPrice: saveSheetPrice
    };
  });

(function () {
    "use strict";

    angular
        .module("app.sheetPrice")
        .controller("sheetPriceController", sheetPriceController);

    /** @ngInject */
    function sheetPriceController(
        sheetPriceService,
        toastMessage,
        $q,
        $rootScope,
        $scope,
        $localStorage
    ) {

        var vm = this;
        vm.rooms = [];
        vm.rows = [];
        vm.placeholderColumns = 8;
        vm.gridTemplateColumns =
            '220px repeat(' + vm.placeholderColumns + ', minmax(120px,1fr))';
        vm.isCellChange = false;
        vm.saving = false;
        vm.loading = false;
        vm.subHotels = [];
        vm.showSubHotelDropdown = false;
        vm.selectedSubHotelId = null;

        function getCurrentHotelId() {
            if (
                $localStorage.hotels &&
                $localStorage.selectedHotel !== undefined &&
                $localStorage.selectedHotel !== ''
            ) {
                return $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
            }
            return $localStorage.preHotelId || null;
        }

        function normalizeSubHotels(list) {
            return (list || []).map(function (hotel) {
                return {
                    id: hotel.hotel_id || hotel.id,
                    name: hotel.hotel_title || hotel.hotel_name || hotel.name
                };
            }).filter(function (hotel) {
                return !!hotel.id;
            });
        }

        function syncSubHotels() {
            var list = normalizeSubHotels($rootScope.subHotels);
            if (!list.length && $rootScope.hotelInformation) {
                list = normalizeSubHotels($rootScope.hotelInformation.sub_hotels);
            }

            vm.subHotels = list;
            // Sub-hotels present → show dropdown; otherwise hide
            vm.showSubHotelDropdown = vm.subHotels.length > 0;

            if (vm.showSubHotelDropdown) {
                var stillValid = vm.subHotels.some(function (h) {
                    return h.id == vm.selectedSubHotelId;
                });
                if (!stillValid) {
                    vm.selectedSubHotelId = vm.subHotels[0].id;
                }
            } else {
                vm.selectedSubHotelId = null;
            }
        }

        vm.changeHotel = function () {
            vm.rooms = [];
            vm.rows = [];
            vm.placeholderColumns = 8;
            vm.gridTemplateColumns =
                '220px repeat(' + vm.placeholderColumns + ', minmax(120px,1fr))';
            vm.isCellChange = false;

            init(vm.selectedSubHotelId);
        };

        // Keep dropdown in sync when getSubHotels finishes (async)
        $scope.$watch(
            function () {
                return $rootScope.subHotels;
            },
            function () {
                var hadDropdown = vm.showSubHotelDropdown;
                var prevSelected = vm.selectedSubHotelId;
                syncSubHotels();

                // Sub-hotels just arrived → show dropdown and load that property's sheet
                if (
                    vm.showSubHotelDropdown &&
                    (!hadDropdown || prevSelected !== vm.selectedSubHotelId)
                ) {
                    init(vm.selectedSubHotelId);
                }
            },
            true
        );

        syncSubHotels();
        init(vm.selectedSubHotelId);

        // If sub-hotels not loaded yet, fetch them for current hotel
        if (!vm.subHotels.length) {
            var hotelId = getCurrentHotelId();
            if (hotelId && typeof $rootScope.getSubHotels === 'function') {
                $rootScope.getSubHotels(hotelId);
            }
        }

        function init(subHotelId) {
            vm.loading = true;
            sheetPriceService.getSheetPriceData(subHotelId)
                .then(function (res) {

                    if (!res.success) {
                        toastMessage.showSimpleToast(
                            res.message || "Failed to load sheet prices",
                            "error-toast"
                        );
                        return;
                    }

                    var data = res.data;
                    // Header Rooms
                    vm.rooms = data.rooms.map(function (room) {
                        return {
                            key: room.room_type_id,
                            shortName: room.room_type_name,
                            fullName: room.room_type_name,
                            room_type_id: room.room_type_id
                        };
                    });

                    // Matrix Rows
                    vm.rows = data.rooms.map(function (fromRoom) {

                        return {

                            key: fromRoom.room_type_id,
                            room_type_id: fromRoom.room_type_id,
                            name: fromRoom.room_type_name,

                            cells: data.rooms.map(function (toRoom) {

                                var isSameRoom = fromRoom.room_type_id === toRoom.room_type_id;

                                var value = isSameRoom ? "X" : data.prices[fromRoom.room_type_id][toRoom.room_type_id];

                                return {
                                    room_type_id: toRoom.room_type_id,
                                    value: value,
                                    originalValue: isSameRoom ? "X" : Number(value),
                                    editValue: isSameRoom ? "X" : Number(value),
                                    display: value,
                                    disabled: isSameRoom,
                                    state: isSameRoom ? "same" : Number(value) > 0 ? "increase" : Number(value) < 0  ? "decrease"  : ""
                                };

                            })

                        };

                    });
                    vm.placeholderColumns = vm.rooms.length;

                    vm.gridTemplateColumns =
                        "280px repeat(" + vm.rooms.length + ", minmax(120px,1fr))";

                })
                .catch(function () {
                    toastMessage.showSimpleToast(
                        "Failed to load room upgrade prices",
                        "error-toast"
                    );
                })
                .finally(function () {
                    vm.loading = false;
                }
            );
        }

        vm.onCellChange = function (cell) {

            if (cell.disabled) {
                return;
            }

            var value = String(cell.editValue || '');

            var validPattern = /^[+-]?(\d+(\.\d*)?|\.\d*)?$/;

            if (!validPattern.test(value)) {

                toastMessage.showSimpleToast(
                    "Only numeric values are allowed.",
                    "error-toast"
                );

                cell.editValue = cell.originalValue;
                return;
            }

            vm.isCellChange = true;
        };

        vm.reset = function () {

            angular.forEach(vm.rows, function (row) {
                angular.forEach(row.cells, function (cell) {
                    cell.editValue = cell.value === "X"
                        ? "X"
                        : Number(cell.value);
                });
            });

            vm.isCellChange = false;
        };

        vm.save = function () {

            if (!vm.isCellChange || vm.saving) {
                return $q.when();
            }

            vm.saving = true;

            var payload = [];

            angular.forEach(vm.rows, function (row) {

                angular.forEach(row.cells, function (cell) {

                    if (cell.value !== "X" && Number(cell.editValue) !== Number(cell.originalValue)) {

                        payload.push({
                            from_room_type_id: row.room_type_id,
                            to_room_type_id: cell.room_type_id,
                            upgrade_price: Number(cell.editValue)
                        });

                    }

                });

            });

            sheetPriceService.saveSheetPrice(payload, vm.selectedSubHotelId)
                .then(function (res) {

                    if (!res.success) {
                        toastMessage.showSimpleToast(
                            res.message || "Failed to save sheet prices",
                            "error-toast"
                        );
                        return;
                    }

                    angular.forEach(vm.rows, function (row) {
                        angular.forEach(row.cells, function (cell) {

                            cell.value = cell.editValue;

                            if (cell.value !== "X") {
                                cell.originalValue = Number(cell.editValue);

                                cell.display = cell.value > 0
                                    ? "+" + cell.value
                                    : "" + cell.value;
                            }

                        });
                    });

                    vm.isCellChange = false;
                })
                .catch(function (err) {
                    console.log(err);
                    toastMessage.showSimpleToast(
                        "Failed to save sheet prices",
                        "error-toast"
                    );
                })
                .finally(function () {
                    vm.saving = false;
                });
        };
    }
})();
(function () {
  "use strict";

  angular.module("app.roomPrecedence", []).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    $stateProvider.state("app.room-precedence", {
      url: "/roomPrecedence",
      title: "Room Precedence",
      views: {
        "content@app": {
          templateUrl: "app/main/apps/roomPrecedence/roomPrecedence.html",
          controller: "roomPrecedenceController as vm",
        },
      },
      resolve: {
        roomTypesData: function (roomPrecedenceService) {
          return roomPrecedenceService.getHotelRooms();
        },
      },
      permission: "room_precedence",
    });

    // Translation
    $translatePartialLoaderProvider.addPart("app/main/apps/roomPrecedence");
  }
})();

"use strict";

/**
 * @ngdoc service
 * @description
 * Service in the minervaApp.
 */
angular
  .module("app.roomPrecedence")
  .service("roomPrecedenceService", function ($http, EnvironmentConfig) {
    function getDataComplete(response) {
      return response.data;
    }

    function getDataFailed(error) {
      return error.data;
    }

    function getHotelRooms() {
      return $http({
        url:
          EnvironmentConfig.api + "roomPrecedences/getHotelRoomsByPrecedence",
        method: "GET",
      })
        .then(getDataComplete)
        .catch(getDataFailed);
    }

    function updateRoomPrecedenceById(payload) {
      return $http({
        url: EnvironmentConfig.api + "roomPrecedences/updateRoomPrecedenceById",
        method: "POST",
        data: payload,
      })
        .then(getDataComplete)
        .catch(getDataFailed);
    }

    function updateDaysBeforeCheckinForEmail(noOfDays) {
      return $http({
        url:
          EnvironmentConfig.api +
          "roomPrecedences/updateDaysBeforeCheckinForEmail/" +
          noOfDays,
        method: "GET",
      })
        .then(getDataComplete)
        .catch(getDataFailed);
    }

    return {
      getHotelRooms: getHotelRooms,
      updateRoomPrecedenceById: updateRoomPrecedenceById,
      updateDaysBeforeCheckinForEmail: updateDaysBeforeCheckinForEmail,
    };
  });
  

(function () {
  "use strict";

  angular
    .module("app.roomPrecedence")
    .controller("roomPrecedenceController", roomPrecedenceController);

  /** @ngInject */
  function roomPrecedenceController(
    roomTypesData,
    roomPrecedenceService,
    toastMessage
  ) {
    var vm = this;

    vm.numberOfDaysBeforeCheckin = 0;
    vm.roomTypes = {};

    if (roomTypesData) {
      if (Object.keys(roomTypesData.roomTypes).length) {
        vm.roomTypes = roomTypesData.roomTypes;

        angular.forEach(vm.roomTypes, function (hotel) {
          angular.forEach(hotel.rooms, function (room) {
            room._lastValidPrecedence = room.room_precedence;
          });
        });
      }

      if (roomTypesData.noOfDaysBeforeCheckin) {
        vm.numberOfDaysBeforeCheckin = roomTypesData.noOfDaysBeforeCheckin;
      }
    }

    vm.updateNumberOfDaysBeforeCheckinForEmail = function () {
      roomPrecedenceService.updateDaysBeforeCheckinForEmail(
        vm.numberOfDaysBeforeCheckin
      );
    };

    vm.updateRoomPrecedence = function (room, max) {
      var value = Number(room.room_precedence);

      if (!value || value < 1 || value > max) {
        toastMessage.showSimpleToast(
          "You cannot set value more than " + max,
          "error-toast"
        );

        room.room_precedence = room._lastValidPrecedence;
        return;
      }

      room._lastValidPrecedence = value;

      var payload = {
        room_type_id: room.room_type_id,
        room_precedence: value,
      };

      roomPrecedenceService.updateRoomPrecedenceById(payload);
    };
  }
})();

'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../mls/mlsService
 * @description
 * # ../mls/mlsService
 * Service in the minervaApp.
 */
angular.module('app.restaurant')
  .service('restaurantService', function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
 	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}

 	/*
 	param: posNo   <string>
 	Desc: used to fetch detail of restaurant order
 	*/

 	function getOrderInfo(posNo){
		return $http({
			url		:EnvironmentConfig.api+'Checkout/getOrderDetailInfo/'+posNo,
			method	:'GET',
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* Desc: used to fetch detail of cook order
	*/

	function fetchRestaurantCookOrders() {
		return $http({
			url: EnvironmentConfig.api+'Cooks/get_cook_orders',
			method: 'POST',
			data: [],
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/*
	** Cook changes status of restaurant order
	*/
	function changeRestaurantOrderStatus(data) {
		return $http({
			url: EnvironmentConfig.api+'Cooks/change_cook_order_status',
			method: "POST",
			data: data
		});
	}
	
 	return{
	 	getOrderInfo: getOrderInfo,
	 	fetchRestaurantCookOrders: fetchRestaurantCookOrders,
	 	changeRestaurantOrderStatus: changeRestaurantOrderStatus	
 	}
 });

(function ()
{
    'use strict';

    angular.module('app.reports')
        .controller('getEmailAddress', getEmailAddress)
        .directive('multipleEmails', multipleEmails);
    /** @ngInject */
    function getEmailAddress($mdDialog,$scope)
    {
        var vm = this;


        vm.title = 'Recipient Email Address';
        vm.htmlContent = 'Email Address';

        vm.closeDialog = closeDialog;

        /* for chip select start */

        vm.emailAddress = [];
        vm.readonly = false;

        vm.autoFillOff = true;
        vm.searchQuery = searchQuery;
        function searchQuery(val){
            var emailValue = angular.element(".getValue").val();
        };

        /*For chip select end*/

        function closeDialog(){
             $mdDialog.cancel();
        }
        vm.hideDialog = hideDialog;

        function hideDialog(){
              $mdDialog.hide(vm.ploicyForm.email);
        }
         setTimeout(function() {
           vm.autoFillOff = false;
       }, 1500); 
    }

    function multipleEmails(){
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ctrl) {
                ctrl.$parsers.unshift(function(viewValue) {
                    var emails = viewValue.split(',');
                    var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    var validityArr = emails.map(function(str){
                        return regex.test(str.trim());
                    });
                     
                    var atLeastOneInvalid = false;
                    angular.forEach(validityArr, function(value) {
                        if(value === false)
                        atLeastOneInvalid = true; 
                    }); 
                    if(!atLeastOneInvalid) { 
                        ctrl.$setValidity('multipleEmails', true);
                        return viewValue;
                    } else {
                        ctrl.$setValidity('multipleEmails', false);
                        return undefined;
                    }
                });
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.reset',[])
        .config(config);

    /** @ngInject */
   function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $rootScope)
    {

        $stateProvider.state('app.reset', {
            url    : '/resetpassword',
            title  : 'Reset Password',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/app.reset/resetPassword.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            resolve: {
                customerList: function ()
                {
                    // return userService.fetchCustomerList();
                    return [];
                }
            },onEnter: function($localStorage,toastMessage,$state){
                var userPermissions = $rootScope.userPermissions;
                if(userPermissions.indexOf('customers') == -1){
                    $state.go('app.dashboards_project');
                    toastMessage.showSimpleToast('Access denied.','error-toast');
                }
            },
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/contacts');
    }

})();

(function ()
{
    'use strict';

    angular
    .module('app.reset')
    .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController($scope, $document, userService, toastMessage, $localStorage, $http, EnvironmentConfig)
    {
        var vm = this;
        vm.customerId = [];
        vm.autoFillOff = true;
        setTimeout(function() {
            vm.autoFillOff = false;
        }, 1500); 
    }
})();

(function() {
    'use strict';

    angular
        .module('app.rentalListing',
            [
                // 3rd Party Dependencies
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config(
        $stateProvider,
        $translatePartialLoaderProvider,
        msApiProvider,
        msNavigationServiceProvider
    ) {

        $stateProvider.state('app.rentalListing', {
            url: '/rentalListing',
            title : 'Rental Applications',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/rentalListing/rentalListing.html',
                    controller: 'rentalListingController as vm'
                }
            },
            params: {
                pageType: 'listing'
            },
            resolve: {
                applicationData: function() {
                    return [];
                },
                roomData: function() {
                    return [];
                }
            },
            permission: 'boat'
        }).state('app.applicationDetail', {
            url: '/application-details/:application_id',
            title : 'Rental Application',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/rentalListing/applicationDetail.html',
                    controller: 'rentalListingController as vm'
                }
            },
            params: {
                pageType: 'edit'
            },
            resolve: {
                applicationData: function(rentalListingService,$stateParams) {
                    var data = {application_id:$stateParams.application_id};
                    return rentalListingService.getApplicationDetails(data);
                },
                roomData: function(createResService,$stateParams,$localStorage) {
                    return createResService.getcartData($localStorage['stateParams']);
                }
            },
            permission: 'boat'
        }).state('app.apply-for-rent', {
            url: '/apply-for-rent',
            title : 'Apply For Rent',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/rentalListing/applicationDetail.html',
                    controller: 'rentalListingController as vm'
                }
            },
            params: {
                pageType: 'add'
            },
            resolve: {
                applicationData: function() {
                    return [];
                },
                roomData: function() {
                    return [];
                }
            },
            permission: 'boat'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/mls');

    }

})();
'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../mls/mlsService
 * @description
 * # ../mls/mlsService
 * Service in the minervaApp.
 */
angular.module('app.rentalListing')
  .service('rentalListingService', function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
 	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}
 	
 	
	function deleteApplications(deleteIds){
		return $http({
			url:EnvironmentConfig.api+'RentalReservations/deleteApplications',
			method:'POST',
			data:deleteIds
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getApplicationDetails(application_id){
		return $http({
			url:EnvironmentConfig.api+'RentalReservations/getApplicationDetails',
			method:'POST',
			data:{rent_application_id: application_id}
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getPriceDetails(data){
		return $http({
			url:EnvironmentConfig.api+'RentalReservations/getPriceDetails',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function updateStatus(data){
		return $http({
			url:EnvironmentConfig.api+'RentalReservations/updateStatus',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
		
 	return{
		 deleteApplications:deleteApplications,
		 getApplicationDetails:getApplicationDetails,
		 getPriceDetails:getPriceDetails,
		 updateStatus:updateStatus,
 	}
 });

(function() {
    'use strict';

    angular
        .module('app.rentalListing')
        .controller('rentalListingController', rentalListingController);

    /** @ngInject */
    function rentalListingController(
        $state,
        $scope,
        $http,
        EnvironmentConfig,
        $mdDialog,
        toastMessage,
        $localStorage,
        applicationData,
        roomData,
        rentalListingService,
        $stateParams,
        $timeout,
        $sessionStorage,
        $rootScope,
        ganttChartService,
        $document,
        eCommerceService
    ) {
        var vm = this;
        if(!$rootScope.backButtonPressed){
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = {};
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] = 1;
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'] = 50;
        }
        vm.closeDialog = closeDialog;

        vm.mls_data = [];
        vm.userPermissions = $rootScope.userPermissions;

        if (vm.userPermissions.indexOf('delete_restriction') != -1) {
            vm.delete_product = true;
        } else {
            vm.delete_product = false;
        }

        vm.applicationData = [];
        vm.paymentDetails = [];

        vm.cartData = [];
        vm.autoFillOff = true;
        if(typeof roomData['cartData'] != 'undefined'){
            $localStorage['rentalCartDetails'] = roomData['cartData'];
            vm.cartData  = roomData['cartData'];
        }

        if(typeof $localStorage['rentalCartDetails'] != 'undefined' && $localStorage['rentalCartDetails'] != ''){
            vm.cartData  = $localStorage['rentalCartDetails'];
        }
        // console.log(vm.cartData, 'vm.cartData');

        vm.refundInstallment = refundInstallment;


        
        function refundInstallment(installment,type){
            installment = vm.transactionDetail;
            installment['payment'] = vm.transactionDetail['payment_method'];
            console.log(vm.transactionDetail, 'installMent');
            $mdDialog.show({
                clickOutsideToClose : false,
                parent              : angular.element($document.body),
                scope               : $scope,
                preserveScope       : true,
                locals              : {
                                        localData :{
                                            installment_id:installment.installment_id,
                                            installment_amount:installment.installment_amount,
                                            refund_by_check:false,
                                            type:type,
                                            payment:installment.payment
                                        }
                                    },
                templateUrl         : 'app/main/apps/e-commerce/views/orders/dialogs/payments/refund.html',
                controller          : RefundController
            });
            function RefundController($scope, $mdDialog, localData) {
                $scope.installment_id = localData.installment_id;
                $scope.refund_amount = localData.installment_amount;
                $scope.installment_amount = localData.installment_amount;
                $scope.refund_by_check = localData.refund_by_check;
                $scope.type = localData.type;
                $scope.check_number = '';
                $scope.payment = localData.payment;
                $scope.closeDialog = function(){
                    $mdDialog.hide();
                };
                $scope.checkRefundAmount = function(){
                    if(parseFloat($scope.refund_amount) < 0){
                        $scope.refund_amount = -($scope.refund_amount);
                    }
                    if(parseFloat($scope.refund_amount) > parseFloat($scope.installment_amount)){
                        $scope.refund_amount = $scope.installment_amount;
                    }
                };
            }
        }


        /*Refund Functionality*/
        vm.refundInstallmentFinally = refundInstallmentFinally;
        function refundInstallmentFinally(installment_id,amount,refund_using,check_number,send_email_indicator){
            vm.isloading = true;
            vm.refundStart  = true;
            if(refund_using == 'original' || refund_using == 'check'){
                var data = {
                            installment_id:installment_id,
                            amount:amount,
                            refund_using:refund_using,
                            confirmation_number:vm.transactionDetail.confirmation_number,
                            roomTotal:vm.transactionDetail.original_paid_amount,
                            paid_amount:vm.transactionDetail.original_paid_amount,
                            traveler_fname:vm.transactionDetail.cc_fname,
                            traveler_lname:vm.transactionDetail.cc_lname,
                            remaining_amount:22800,
                            check_number:check_number
                        };
            } else {
                var data = {
                    installment_id:installment_id,
                    amount:amount,
                    refund_using:refund_using,
                    confirmation_number:vm.transactionDetail.confirmation_number,
                    roomTotal:vm.transactionDetail.original_paid_amount,
                    paid_amount:vm.transactionDetail.original_paid_amount,
                    traveler_fname:vm.transactionDetail.cc_fname,
                    traveler_lname:vm.transactionDetail.cc_lname,
                    remaining_amount:22800,
                    customer_email:'',
                };
            }
            
            eCommerceService.customRefundInstallment(data).then(function(response){
                vm.isloading = false;
                vm.refundStart = false;
                $mdDialog.hide();
                console.log('response',response);
                
            });
        }


        if(applicationData.hasOwnProperty('rental_data')){
              vm.applicationData = applicationData['rental_data'];
              vm.applicationData['rental_from'] = applicationData['rental_from'];
              vm.applicationData['rental_to'] = applicationData['rental_to'];
              vm.applicationData['application_status'] = applicationData['application_status'];
              vm.applicationData['rental_id'] = applicationData['rental_id'];
               vm.rental_id = applicationData['rental_id'];
              vm.paymentDetails = applicationData['payment_details'];

              vm.transactionDetail = applicationData['transactionDetails'];
          }

        vm.applicationData['onlyUpdateStatus'] = false;

        if(!applicationData.hasOwnProperty('rental_data') && applicationData != ''){
            var statusId = applicationData.split('-');
            vm.application_status =  statusId[1];
            vm.rental_id = statusId[0];
            vm.applicationData['application_status'] = vm.application_status;
            vm.applicationData['rental_id'] = vm.rental_id;
            vm.applicationData['onlyUpdateStatus'] = true;

        }

        vm.formFields = {
            'PRIMARY APPLICANT': [{
                    label: 'First Name',
                    type: "text",
                    name: 'first_name',
                    id: 'first_name',
                    error_msg: "Please enter first name."
                },
                {
                    label: 'Last Name',
                    type: "text",
                    name: 'last_name',
                    id: 'last_name',
                    error_msg: "Please enter last name."
                },
                {
                    label: 'Middle Name',
                    type: "text",
                    name: 'middle_name',
                    id: 'middle_name',
                    error_msg: "Please enter middle name."
                },
                {
                    label: 'Social Security Number',
                    type: "number",
                    name: 'security_number',
                    id: 'security_number',
                    error_msg: "Please enter social security number."
                },
                {
                    label: 'Date Of Birth',
                    type: "date",
                    name: 'date_of_birth',
                    id: 'date_of_birth',
                    error_msg: "Please enter date of birth."
                },
                {
                    label: 'Driver License Number',
                    type: "number",
                    name: 'license_number',
                    id: 'license_number',
                    error_msg: "Please enter license number."
                },
                {
                    label: 'Driver License State',
                    type: "text",
                    name: 'license_state',
                    id: 'license_state',
                    error_msg: "Please enter license state."
                },
                {
                    label: 'Expiration Date',
                    type: "date",
                    name: 'exp_date',
                    id: 'exp_date',
                    error_msg: "Please enter expiration date."
                },
                {
                    label: 'Phone Number',
                    type: "text",
                    name: 'phone_number',
                    id: 'phone_number',
                    error_msg: "Please enter phone number."
                },
                {
                    label: 'Secondary Phone Number',
                    type: "text",
                    name: 'sec_phone_number',
                    id: 'sec_phone_number',
                    error_msg: "Please enter secondary phone number."
                },
                {
                    label: 'Email Address',
                    type: "email",
                    name: 'customer_email',
                    id: 'customer_email',
                    error_msg: "Please enter email."
                },
                {
                    label: 'Spouse First Name',
                    type: "text",
                    name: 'spouse_first_name',
                    id: 'spouse_first_name',
                    error_msg: "Please enter spouse first name."
                },
                {
                    label: 'Spouse Last Name',
                    type: "text",
                    name: 'spouse_last_name',
                    id: 'spouse_last_name',
                    error_msg: "Please enter spouse last name."
                },
                {
                    label: 'Spouse Middle Name',
                    type: "text",
                    name: 'spouse_middle_name',
                    id: 'spouse_middle_name',
                    error_msg: "Please enter spouse middle name."
                },
                {
                    label: 'Social Security Number',
                    type: "text",
                    name: 'spouse_security_number',
                    id: 'spouse_security_number',
                    error_msg: "Please enter social secuirity number."
                },
                {
                    label: 'Date Of Birth',
                    type: "date",
                    name: 'date_of_birth',
                    id: 'date_of_birth',
                    error_msg: "Please select date of birth."
                },
                {
                    label: 'Driver License Number',
                    type: "text",
                    name: 'spouse_license_number',
                    id: 'spouse_license_number',
                    error_msg: "Please enter spouse license number."
                },
                {
                    label: 'Driver License State',
                    type: "text",
                    name: 'spouse_license_state',
                    id: 'spouse_license_state',
                    error_msg: "Please select spouse license state."
                },
                {
                    label: 'Expiration Date',
                    type: "date",
                    name: 'spouse_exp_date',
                    id: 'spouse_exp_date',
                    error_msg: "Please select spouse license expiration date."
                },
                {
                    label: 'Phone Number',
                    type: "text",
                    name: 'spouse_phone_number',
                    id: 'spouse_phone_number',
                    error_msg: "Please enter phone number."
                },
                {
                    label: 'Secondary Phone Number',
                    type: "text",
                    name: 'spouse_sec_phone_number',
                    id: 'spouse_sec_phone_number',
                    error_msg: "Please enter secondary phone number."
                },
                {
                    label: 'Email Address',
                    type: "email",
                    name: 'spouse_customer_email',
                    id: 'spouse_customer_email',
                    error_msg: "Please enter email."
                }
            ],
            'PRIMARY APPLICANT RENTAL HISTORY INFORMATION': [

                {
                    label: 'Address',
                    type: "text",
                    name: 'address',
                    id: 'address',
                    error_msg: "Please enter address name."
                },
                {
                    label: 'City',
                    type: "text",
                    name: 'city',
                    id: 'city',
                    error_msg: "Please enter city."
                },
                {
                    label: 'State',
                    type: "text",
                    name: 'state',
                    id: 'state',
                    error_msg: "Please enter state."
                },
                {
                    label: 'Zip/Postal Code',
                    type: "text",
                    name: 'zip_code',
                    id: 'zip_code',
                    error_msg: "Please enter zip_code."
                },
                {
                    label: 'Since',
                    type: "date",
                    name: 'since',
                    id: 'since',
                    error_msg: "Please enter since."
                },
                {
                    label: 'Rent Amount',
                    type: "text",
                    name: 'rent_amount',
                    id: 'rent_amount',
                    error_msg: "Please enter rent amount."
                },
                {
                    label: 'Rent Payment Period',
                    type: "text",
                    name: 'rent_payment_period',
                    id: 'rent_payment_period',
                    error_msg: "Please enter rent payment period."
                },
                {
                    label: 'Was Your Rent Up to Date?',
                    type: "radio",
                    name: 'retn_uptodate',
                    id: 'retn_uptodate',
                    error_msg: "",
                    subLabel:['Yes', 'No'],
                    subValues:['yes', 'no']


                },
                {
                    label: 'Landlord Name',
                    type: "text",
                    name: 'landlord_name',
                    id: 'landlord_name',
                    error_msg: "Please enter landlord name."
                },
                {
                    label: 'Landlord Phone Number',
                    type: "text",
                    name: 'landlord_phone',
                    id: 'landlord_phone',
                    error_msg: "Please enter landlord phone number."
                },
                {
                    label: 'Landlord Email',
                    type: "email",
                    name: 'landlord_email',
                    id: 'landlord_email',
                    error_msg: "Please enter landlord email."
                },
                {
                    label: 'Previous Address',
                    type: "text",
                    name: 'previous_address',
                    id: 'previous_address',
                    error_msg: "Please enter previous address."
                },
                {
                    label: 'City',
                    type: "text",
                    name: 'previous_city',
                    id: 'previous_city',
                    error_msg: "Please enter previous city."
                },
                {
                    label: 'State',
                    type: "text",
                    name: 'previous_state',
                    id: 'previous_state',
                    error_msg: "Please enter previous state."
                },
                {
                    label: 'Zip/Postal Code',
                    type: "text",
                    name: 'previous_zip_code',
                    id: 'previous_zip_code',
                    error_msg: "Please enter previous zip code."
                },
                {
                    label: 'Move In Date',
                    type: "date",
                    name: 'move_in',
                    id: 'move_in',
                    error_msg: "Please enter move in date."
                },
                {
                    label: 'Move Out Date',
                    type: "date",
                    name: 'move_out',
                    id: 'move_out',
                    error_msg: "Please enter move out date."
                },
                {
                    label: 'Rent Amount',
                    type: "text",
                    name: 'pre_rent_amount',
                    id: 'pre_rent_amount',
                    error_msg: "Please enter rent amount."
                },
                {
                    label: 'Rent Payment Period',
                    type: "text",
                    name: 'pre_rent_payment_period',
                    id: 'pre_rent_payment_period',
                    error_msg: "Please enter rent payment period."
                },
                {
                    label: 'Was Your Rent Up to Date?',
                    type: "radio",
                    name: 'pre_retn_uptodate',
                    id: 'pre_retn_uptodate',
                    error_msg: "",
                    subLabel:['Yes', 'No'],
                    subValues:['yes', 'no']
                },
                {
                    label: 'Landlord Name',
                    type: "text",
                    name: 'pre_landlord_name',
                    id: 'pre_landlord_name',
                    error_msg: "Please enter landlord name."
                },
                {
                    label: 'Landlord Phone Number',
                    type: "text",
                    name: 'pre_landlord_phone',
                    id: 'pre_landlord_phone',
                    error_msg: "Please enter landlord phone number."
                },
                {
                    label: 'Landlord Email',
                    type: "email",
                    name: 'pre_landlord_email',
                    id: 'pre_landlord_email',
                    error_msg: "Please enter landlord email."
                }
            ],
            'OCCUPANTS THAT WILL LIVE IN THE PROPERTY': [{
                    label: 'Full Name',
                    type: "text",
                    name: 'full_name',
                    id: 'full_name',
                    error_msg: "Please enter full name."
                },
                {
                    label: 'Age',
                    type: "text",
                    name: 'age',
                    id: 'age',
                    error_msg: "Please enter age."
                },
                {
                    label: 'Relationship',
                    type: "text",
                    name: 'relationship',
                    id: 'relationship',
                    error_msg: "Please enter relationship."
                },
                {
                    label: 'Full Name',
                    type: "text",
                    name: 'full_name1',
                    id: 'full_name1',
                    error_msg: "Please enter full name."
                },
                {
                    label: 'Age',
                    type: "text",
                    name: 'age1',
                    id: 'age1',
                    error_msg: "Please enter age."
                },
                {
                    label: 'Relationship',
                    type: "text",
                    name: 'relationship1',
                    id: 'relationship1',
                    error_msg: "Please enter relationship."
                },
                {
                    label: 'Full Name',
                    type: "text",
                    name: 'full_name2',
                    id: 'full_name2',
                    error_msg: "Please enter full name."
                },
                {
                    label: 'Age',
                    type: "text",
                    name: 'age2',
                    id: 'age2',
                    error_msg: "Please enter age."
                },
                {
                    label: 'Relationship',
                    type: "text",
                    name: 'relationship2',
                    id: 'relationship2',
                    error_msg: "Please enter relationship."
                },
            ],
            'PETS THAT WILL LIVE IN THE PROPERTY': [{
                    label: 'Number of pets',
                    type: "number",
                    name: 'pets',
                    id: 'pets',
                    error_msg: "Please enter number of pets."
                },
                {
                    label: 'Type/Breed',
                    type: "text",
                    name: 'pet_type',
                    id: 'pet_type',
                    error_msg: "Please enter pet type/breed."
                },
                {
                    label: 'Indoor/Outdoor',
                    type: "text",
                    name: 'indoor_outdoor',
                    id: 'indoor_outdoor',
                    error_msg: "Please enter Indoor/Outdoor."
                },
                {
                    label: 'Name/Age',
                    type: "text",
                    name: 'pet_name',
                    id: 'pet_name',
                    error_msg: "Please enter pet name."
                },
                {
                    label: '',
                    type: "button",
                    name: 'pet_button',
                    id: 'pet_button',
                    class: 'petClass',
                    error_msg: ""
                },
            ],
            'APPLICANT EMPLOYMENT HISTORY': [{
                    label: 'Current Employer',
                    type: "text",
                    name: 'curr_employer',
                    id: 'curr_employer',
                    error_msg: "Please enter current employer."
                },
                {
                    label: 'Position',
                    type: "text",
                    name: 'position',
                    id: 'position',
                    error_msg: "Please enter position."
                },
                {
                    label: 'Supervisor Name',
                    type: "text",
                    name: 'supervisor_name',
                    id: 'supervisor_name',
                    error_msg: "Please enter supervisor name."
                },
                {
                    label: 'Supervisor Phone Number',
                    type: "text",
                    name: 'supervisor_phone',
                    id: 'supervisor_phone',
                    error_msg: "Please enter supervisor phone number."
                },
                {
                    label: 'Supervisor Email',
                    type: "text",
                    name: 'supervisor_email',
                    id: 'supervisor_email',
                    error_msg: "Please enter supervisor email."
                },
                {
                    label: 'Salary',
                    type: "number",
                    name: 'salary',
                    id: 'salary',
                    error_msg: "Please enter salary."
                },
                {
                    label: 'How Long Worked There',
                    type: "number",
                    name: 'work_time',
                    id: 'work_time',
                    error_msg: "Please enter worked time."
                },
                {
                    label: 'Previous Employer',
                    type: "text",
                    name: 'pre_employer',
                    id: 'pre_employer',
                    error_msg: "Please enter previous employer."
                },
                {
                    label: 'Position',
                    type: "text",
                    name: 'pre_position',
                    id: 'pre_position',
                    error_msg: "Please enter position."
                },
                {
                    label: 'Supervisor Name',
                    type: "text",
                    name: 'pre_supervisor_name',
                    id: 'pre_supervisor_name',
                    error_msg: "Please enter supervisor name."
                },
                {
                    label: 'Supervisor Phone Number',
                    type: "text",
                    name: 'pre_supervisor_phone',
                    id: 'pre_supervisor_phone',
                    error_msg: "Please enter supervisor phone number."
                },
                {
                    label: 'Supervisor Email',
                    type: "text",
                    name: 'pre_supervisor_email',
                    id: 'pre_supervisor_email',
                    error_msg: "Please enter supervisor email."
                },
                {
                    label: 'Salary',
                    type: "number",
                    name: 'pre_salary',
                    id: 'pre_salary',
                    error_msg: "Please enter salary."
                },
                {
                    label: 'How Long Worked There',
                    type: "number",
                    name: 'pre_work_time',
                    id: 'pre_work_time',
                    error_msg: "Please enter worked time."
                }
            ],
            'APPLICANT VEHICLE INFORMATION': [{
                    label: 'Make',
                    type: "text",
                    name: 'make',
                    id: 'make',
                    error_msg: "Please enter vehicle make."
                },
                {
                    label: 'Model',
                    type: "text",
                    name: 'model',
                    id: 'model',
                    error_msg: "Please enter vehicle model."
                },
                {
                    label: 'Year',
                    type: "date",
                    name: 'vehicle_year',
                    id: 'vehicle_year',
                    error_msg: "Please enter vehicle year."
                },
                {
                    label: 'License Plate',
                    type: "text",
                    name: 'license_plate',
                    id: 'license_plate',
                    error_msg: "Please enter vehicle license plate."
                },
                {
                    label: 'Make',
                    type: "text",
                    name: 'make1',
                    id: 'make1',
                    error_msg: "Please enter vehicle make."
                },
                {
                    label: 'Model',
                    type: "text",
                    name: 'model1',
                    id: 'model1',
                    error_msg: "Please enter vehicle model."
                },
                {
                    label: 'Year',
                    type: "date",
                    name: 'vehicle_year1',
                    id: 'vehicle_year1',
                    error_msg: "Please enter vehicle year."
                },
                {
                    label: 'License Plate',
                    type: "text",
                    name: 'license_plate1',
                    id: 'license_plate1',
                    error_msg: "Please enter vehicle license plate."
                }
            ],
            'APPLICANT REFERENCE': [{
                    label: 'Full Name',
                    type: "text",
                    name: 'ref_name',
                    id: 'ref_name',
                    error_msg: "Please enter full name."
                },
                {
                    label: 'Relationship',
                    type: "text",
                    name: 'ref_relationship',
                    id: 'ref_relationship',
                    error_msg: "Please enter relationship."
                },
                {
                    label: 'E-mail',
                    type: "email",
                    name: 'ref_email',
                    id: 'ref_email',
                    error_msg: "Please enter email."
                },
                {
                    label: 'Phone',
                    type: "text",
                    name: 'ref_phone',
                    id: 'ref_phone',
                    error_msg: "Please enter phone number."
                },
                {
                    label: 'Full Name',
                    type: "text",
                    name: 'ref_name1',
                    id: 'ref_name1',
                    error_msg: "Please enter full name."
                },
                {
                    label: 'Relationship',
                    type: "text",
                    name: 'ref_relationship1',
                    id: 'ref_relationship1',
                    error_msg: "Please enter relationship."
                },
                {
                    label: 'E-mail',
                    type: "email",
                    name: 'ref_email1',
                    id: 'ref_email1',
                    error_msg: "Please enter email."
                },
                {
                    label: 'Phone',
                    type: "text",
                    name: 'ref_phone1',
                    id: 'ref_phone1',
                    error_msg: "Please enter phone number."
                },
                {
                    label: 'Full Name',
                    type: "text",
                    name: 'ref_name2',
                    id: 'ref_name2',
                    error_msg: "Please enter full name."
                },
                {
                    label: 'Relationship',
                    type: "text",
                    name: 'ref_relationship2',
                    id: 'ref_relationship2',
                    error_msg: "Please enter relationship."
                },
                {
                    label: 'E-mail',
                    type: "email",
                    name: 'ref_email2',
                    id: 'ref_email2',
                    error_msg: "Please enter email."
                },
                {
                    label: 'Phone',
                    type: "text",
                    name: 'ref_phone2',
                    id: 'ref_phone2',
                    error_msg: "Please enter phone number."
                }
            ],
            'APPLICANT CREDIT HISTORY': [{
                    label: 'Bank Name',
                    type: "text",
                    name: 'bank_name',
                    id: 'bank_name',
                    error_msg: "Please enter bank name."
                },
                {
                    label: 'Saving Account #',
                    type: "number",
                    name: 'account_no',
                    id: 'account_no',
                    error_msg: "Please enter account number."
                },
                {
                    label: 'Balance',
                    type: "number",
                    name: 'balance',
                    id: 'balance',
                    error_msg: "Please enter balance."
                },
                {
                    label: 'Checking Account #',
                    type: "text",
                    name: 'check_acnt',
                    id: 'check_acnt',
                    error_msg: "Please enter checking account number."
                },
                {
                    label: 'Balance',
                    type: "number",
                    name: 'check_balance',
                    id: 'check_balance',
                    error_msg: "Please enter balance."
                },
                {
                    label: 'Bank Name',
                    type: "text",
                    name: 'bank_name1',
                    id: 'bank_name1',
                    error_msg: "Please enter bank name."
                },
                {
                    label: 'Saving Account #',
                    type: "number",
                    name: 'account_no1',
                    id: 'account_no1',
                    error_msg: "Please enter account number."
                },
                {
                    label: 'Balance',
                    type: "number",
                    name: 'balance1',
                    id: 'balance1',
                    error_msg: "Please enter balance."
                },
                {
                    label: 'Checking Account #',
                    type: "text",
                    name: 'check_acnt1',
                    id: 'check_acnt1',
                    error_msg: "Please enter checking account number."
                },
                {
                    label: 'Balance',
                    type: "number",
                    name: 'check_balance1',
                    id: 'check_balance1',
                    error_msg: "Please enter balance."
                },
                {
                    label: 'Bank Name',
                    type: "text",
                    name: 'bank_name2',
                    id: 'bank_name2',
                    error_msg: "Please enter bank name."
                },
                {
                    label: 'Saving Account #',
                    type: "number",
                    name: 'account_no2',
                    id: 'account_no2',
                    error_msg: "Please enter account number."
                },
                {
                    label: 'Balance',
                    type: "number",
                    name: 'balance2',
                    id: 'balance2',
                    error_msg: "Please enter balance."
                },
                {
                    label: 'Checking Account #',
                    type: "text",
                    name: 'check_acnt2',
                    id: 'check_acnt2',
                    error_msg: "Please enter checking account number."
                },
                {
                    label: 'Balance',
                    type: "number",
                    name: 'check_balance2',
                    id: 'check_balance2',
                    error_msg: "Please enter balance."
                },
                {
                    label: 'Has the Applicant or Occupants named in application ever filled by bankruptcy?',
                    type: "radio",
                    name: 'bankruptcy',
                    id: 'bankruptcy',
                    class: 'radioClass',
                    error_msg: "",
                    subLabel:['Yes', 'No'],
                    subValues:['yes', 'no']
                },
                {
                    label: 'Date Filled',
                    type: "date",
                    name: 'date_fill',
                    id: 'date_fill',
                    error_msg: "Please select filled date."
                },
                {
                    label: 'Date Granted',
                    type: "date",
                    name: 'date_grant',
                    id: 'date_grant',
                    error_msg: "Please select granted date."
                },
                {
                    label: 'Date Discharged',
                    type: "date",
                    name: 'date_discharge',
                    id: 'date_discharge',
                    error_msg: "Please select discharged date."
                },
                {
                    label: 'Has the Applicant or Occupants named in application ever been evicted or had judgement issued against him/her?',
                    type: "radio",
                    name: 'judgement',
                    id: 'judgement',
                    class: 'radioClass',
                    error_msg: "",
                    subLabel:['Yes', 'No'],
                    subValues:['yes', 'no']
                },
                {
                    label: 'Are there any outstanding judgements against Applicant or Occupants named in application?',
                    type: "radio",
                    name: 'outstanding',
                    id: 'outstanding',
                    class: 'radioClass',
                    error_msg: "",
                    subLabel:['Yes', 'No'],
                    subValues:['yes', 'no']
                },
                {
                    label: 'Has Applicant or Occupants named in application had property foreclosed upon or given title or deed in lieu there of in the past seven(7) years?',
                    type: "radio",
                    name: 'property',
                    id: 'property',
                    class: 'radioClass',
                    error_msg: "",
                    subLabel:['Yes', 'No'],
                    subValues:['yes', 'no']
                },
                {
                    label: 'Has Applicant or Occupants named in application have pending criminal charges or ever been convicted of, plead guilty, or no contest to, any criminal offense(s) other than traffic infractions that were disposed of other than by acquittal or a finding of not guilty?',
                    type: "radio",
                    name: 'criminal_charges',
                    id: 'criminal_charges',
                    class: 'radioClass',
                    error_msg: "",
                    subLabel:['Yes', 'No'],
                    subValues:['yes', 'no']
                },
                {
                    label: 'Has Applicant or Occupants named in application party to a lawsuite?',
                    type: "radio",
                    name: 'lawsuite',
                    id: 'lawsuite',
                    class: 'radioClass',
                    error_msg: ""
                },
                {
                    label: 'Has Applicant or Occupants named in application obligated to play alimony, child support, or separate maintenance?',
                    type: "radio",
                    name: 'obligated',
                    id: 'obligated',
                    class: 'radioClass',
                    error_msg: "",
                    subLabel:['Yes', 'No'],
                    subValues:['yes', 'no']
                },
                {
                    label: 'Agreement and Authorization',
                    type: "",
                    name: 'date_fill',
                    id: 'date_fill',
                    class: 'radioClass',
                    error_msg: "Please select filled date.",
                    title: "The statements above made are true or correct.Applicant authorizes to conduct a credit check and applicant knows that this is a rental application and not a lease agreement."
                },
                {
                    label: 'Date',
                    type: "date",
                    name: 'agreement_date',
                    id: 'agreement_date',
                    error_msg: "Please select agreement date."
                },
                {
                    label: 'Signature',
                    type: "text",
                    name: 'signature',
                    id: 'signature',
                    error_msg: "Please select discharged date."
                }
            ]
        };

        vm.gotoApplication = gotoApplication;

        vm.updateStatus = updateStatus;

        function updateStatus(){

            if(vm.applicationData['onlyUpdateStatus']){
                var responseData = {
                                        data:vm.applicationData,
                                        rental_id:vm.rental_id,
                                        status:vm.application_status,
                                        createReservation: false
                                    };
            }else{
                var responseData = {
                                        data:vm.applicationData,
                                        rental_id:vm.rental_id,
                                        status:vm.applicationData.application_status,
                                        cartData:vm.cartData,
                                        createReservation: true


                                    };
            }

            rentalListingService.updateStatus(responseData).then(function(response){
                if(vm.applicationData['onlyUpdateStatus']){
                    $rootScope.$broadcast('updateTable',{});
                    $mdDialog.hide();
                }else{
                    if(response['success']){
                        $state.go("app.e-commerce.rentOrders.detail",{id:response['data']['reservation_id'],confirmation_number:response['data']['confirmation_number']});
                    }else{
                         toastMessage.showSimpleToast(response['errorMsg'], 'error-toast');
                    }
                }
            });

        }

         $scope.$on('updateTable', function(event, data) {
            loadPageCallbackWithDebounce();
        });

        function gotoApplication(){
          $state.go("app.apply-for-rent");
        }

        vm.goBack = goBack;
        function goBack(){
          window.history.back();
        }

        vm.overAllTotal = [];
        vm.showOverAllTotal = false;

        vm.getProductDetails = getProductDetails;
        function getProductDetails(){

            vm.applicationData.rental_to = moment(vm.applicationData.rental_from).add('years', 1);
          var data = {
                        room_stay_from:vm.applicationData['rental_from'],
                        room_stay_to:vm.applicationData['rental_to'],
                        room_type_id: vm.applicationData['room_type_id']
                      };

          rentalListingService.getPriceDetails(data).then(function(response){
            console.log(response);
            if(response.success){
                vm.overAllTotal = response['data'];
                vm.showOverAllTotal = true; 

            }else{
                 vm.overAllTotal = response['data'];
                vm.showOverAllTotal = true; 
                
            }
          });

        }

        vm.updateApplicationStatus = updateApplicationStatus;
        function updateApplicationStatus(){

        }



        $scope.goToEditPage = function(id, ev) {           


            if (vm.userPermissions.indexOf('update_restriction') != -1) {
                var product_policy = {};
                product_policy[1719] = 2;

                var data = {
                                adult:2,
                                child:0,
                                from:"2018-09-24T00:00:00.000Z",
                                itinerary_number:"",
                                prod_id:product_policy,
                                to:"2019-09-27T00:00:00.000Z"
                            };
                $localStorage['stateParams'] = data;
                $state.go("app.applicationDetail", {
                    application_id: id
                });
            }
        }

        $scope.openCustomPage = function(id,  ev) {
            ev.stopPropagation();
            $mdDialog.show({
                controller: 'rentalListingController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/rentalListing/dialog/updateStatus.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                locals: {
                    applicationData: id,
                    roomData: [],
                }
            });
        }


        function closeDialog() {
            $mdDialog.hide();
        }

        /*Start*/
        $scope.paginatorCallback = paginatorCallback;
        $scope.LoadAllData = LoadAllData;
        $scope.getLoadResultsCallback = getLoadResultsCallback;
        $scope.selectedRowCallback = function(rows) {
            vm.selectedprodId = rows;
            vm.checkDelete = false;
        };
        var loadPageCallbackWithDebounce;
        $scope.$watch('filterText', function() {
            if (loadPageCallbackWithDebounce) {
                loadPageCallbackWithDebounce();
            }
        });
        $scope.showTabDialog = function(ev, id) {
            roleService.getRolePermissions(id).then(function(response) {
                if (response.listData.length == 0) {
                    toastMessage.showSimpleToast('This role has no module assigned.', 'error-toast');
                } else {
                    $state.go('app.rolesPermission', {
                        id: id
                    });
                }
            });
        };
        $scope.userPermissions = vm.userPermissions;
        $scope.updateTable = function() {
            loadPageCallbackWithDebounce();
        };

        $scope.toggleAll = function() {
            var toggleStatus = !$scope.isAllSelected;
            $scope.ChangeAll = toggleStatus;
        }
        $scope.checkBox = function(value) {
            if (vm.selectedprodId.indexOf(value) > -1) {
                vm.selectedprodId.splice(vm.selectedprodId.indexOf(value), 1);
            } else {
                vm.selectedprodId.push(value);
            }
            if (vm.selectedprodId.length > 0) {
                vm.getNumberOfSelectedRows = vm.selectedprodId.length;
                vm.checkDelete = true;
            } else {
                vm.checkDelete = false;
            }
        };
        $scope.deleteSelectedItem = function(ev, selectedprodId) {
            // new
            var html = 'Are you sure, you want to delete the selected Application? </br>';
            html = html + '<b>' + vm.selectedprodId.length + ' application</b>' + ' will be deleted.';

            $mdDialog.show({
                    controller: 'confirmController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: true,
                    locals: {
                        title: 'Delete Application',
                        htmlContent: html,
                        cancelBtn: 'Cancel',
                        OkBtn: 'Ok'
                    }
                })
                .then(function(answer) {
                    if (typeof answer != 'undefined' && answer == 'update') {
                        var myObj = {
                            deleteIds: vm.selectedprodId
                        };

                        console.log(myObj);
                        rentalListingService.deleteApplications(myObj).then(function(response) {
                            loadPageCallbackWithDebounce();
                            
                        });
                    }
                }, function() {});
            //Old
        };

        function getLoadResultsCallback(loadPageCallback) {
            loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
        }



        vm.UserColumns = [
            'first_name',
            'last_name',
            'customer_email',
            'phone_number',
            'rental_from',
            'rental_to',
            'editId',
            'application_status',
            'rental_id'
        ];

        vm.onLoad = true;
        vm.requestGoing = false;

        function paginatorCallback(page, pageSize, option) {

            if (vm.requestGoing) return;
            if (vm.onLoad == true) {
                if (typeof $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']]['currentPage'] != 'undefined') {

                    var page1 = $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']]['currentPage'];
                    var pageSize1 = $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']]['pageSize'];
                    vm.onLoad = false;
                    return LoadAllData(page1, pageSize1, option);
                } else {
                    vm.onLoad = false;
                    return LoadAllData(page, pageSize, option);
                }
            } else {
                if (typeof page == 'undefined') {
                    page = $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']]['currentPage'];
                }
                return LoadAllData(page, pageSize, option);
            }


        }
        vm.columnSort = [];

        function LoadAllData(page, pageSize, option) {
            vm.columnSort = option;
            vm.requestGoing = true;
            var pageDetail = {
                'currentPage': page,
                'pageSize': pageSize
            };

            $sessionStorage[$state['current']['name'] + '_' + $localStorage['preHotelId']] = pageDetail;
            vm.page = page;
            vm.pageSize = pageSize;
            vm.selectedprodId = [];
            var sort = {};

            for (var i = 0; i < option.columnSort.length; i++) {

                if (option.columnSort[i]['sort']) {
                    sort['column'] = vm.UserColumns[i];
                    sort['order'] = option.columnSort[i]['sort'];
                }
            }
            var offset = (page - 1) * pageSize;
            var query = $scope.filterText ? $scope.filterText : '';


            var filterData = {
                'offset': offset,
                'pageSize': pageSize,
                'search': $scope.filterText,
                'sort': sort,
                'get_organization': true,
                'get_count': true,
                'requestFor': vm.restriction,
                'selectedHotel': $localStorage.hotels[$localStorage.selectedHotel].hotel_id
            };


            return $http({
                url: EnvironmentConfig.api + 'RentalReservations/getAllRentalApplication',
                method: 'POST',
                data: filterData
            }).then(function(result) {

                vm.requestGoing = false;

                vm.totalUsers = result.data['rentApplicationsCount'];

                return {
                    results: result.data['rentApplications'],
                    totalResultCount: result.data['rentApplicationsCount']
                }
            });
        }


        vm.fetchRestrictionType = function() {
            loadPageCallbackWithDebounce();
        }

        /*End*/

        setTimeout(function() {
           vm.autoFillOff = false;
        }, 1500); 
    }
})();
'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../category/categoryService
 * @description
 * # ../category/categoryService
 * Service in the minervaApp.
 */
angular.module('app.rateRule')
  .service('rateRuleService', function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
 	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}
 	
 	function getRateRuleData(data){
		return $http({
			url:EnvironmentConfig.api+'Raterule/getRateRuleData',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	function setRateRuleData(data){
		return $http({
			url:EnvironmentConfig.api+'Raterule/setRateRuleData',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	function setRateRuleBatch(data){
		return $http({
			url:EnvironmentConfig.api+'Raterule/setRateRuleBatch',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	function setBulkRateRule(data){
		return $http({
			url:EnvironmentConfig.api+'Raterule/setRateRuleBulk',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function setCopyPrice(data){
		return $http({
			url:EnvironmentConfig.api+'Raterule/setCopyPriceBulk',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function setSortOrder(data){
		return $http({
			url:EnvironmentConfig.api+'Raterule/updateSortOrder',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getRateRulesData(hotelID){
		return $http({
			url:EnvironmentConfig.api + 'Raterule/getRateRulesData',
			method:'POST',
			data:{hotelID: hotelID}
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getCustomRateRuleData(data){
		return $http({
			url:EnvironmentConfig.api+'Raterule/getCustomRateRuleData',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getRatlePlanChannelPrices(data){
		return $http({
			url:EnvironmentConfig.api+'Raterule/getRatlePlanChannelPrices',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getDerivedFixedRates(type) {
		return $http({
			url:EnvironmentConfig.api+'Raterule/getDerivedFixedRates/'+type,
			method:'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

 	return {
 		getRateRuleData: getRateRuleData,
 		setCopyPrice: setCopyPrice,
 		setRateRuleData: setRateRuleData,
 		setRateRuleBatch: setRateRuleBatch,
 		setBulkRateRule: setBulkRateRule,
 		setSortOrder: setSortOrder,
 		getRateRulesData: getRateRulesData,
 		getCustomRateRuleData: getCustomRateRuleData, 	
 		getRatlePlanChannelPrices: getRatlePlanChannelPrices,
 		getDerivedFixedRates: getDerivedFixedRates
 	}
 });

(function ()
{
  'use strict';

  angular
	.module('app.rateRule')
	.controller('rateRuleController', rateRuleController);

  /** @ngInject */
  function rateRuleController($stateParams, $state, $scope, $http, EnvironmentConfig, toastMessage, $localStorage,RateRule,$timeout,rateRuleService,$mdDialog,$document, $animate, $compile, ganttUtils, GanttObjectModel, ganttDebounce, moment, $window, $mdSidenav, msApi, $translate, $rootScope){
	 
		var vm = this;
		if(!RateRule.success && RateRule.errorMsg){
			vm.mainErrorMsg = RateRule.errorMsg;
		}else{
			vm.mainErrorMsg = false;
		}
        vm.height = document.getElementById('rateRulePage').clientHeight;
        if(vm.height) {
            vm.height = vm.height-100;
        }
        console.log(vm.height)
        vm.onlyRooms = RateRule.onlyrooms;
		vm.roomtype_subHotelIds = RateRule.roomtype_subHotelIds;
        vm.isParent =  RateRule.isParent;
        vm.boatExists =  RateRule.boatExists;
		vm.ratePlansData = RateRule.ratePlansData;

		vm.channelsData = RateRule.channelsData;
        vm.daysratecalender = RateRule.daysratecalender;
		vm.roomTypeSel = RateRule.selectedRoom;
		var objectModel;
		vm.isloading = false;
        // Data
        vm.live = {};
        vm.raterule = {};
       
        vm.ratePlanSel = 0;
        vm.eachrateError = false;
        // vm.optionsAvail = {1:$translate.instant('RATERULE.RATES'), 2:$translate.instant('RATERULE.STOP_SELL'), 3:$translate.instant('RATERULE.CTA'), 4:$translate.instant('RATERULE.CTD'), 5:$translate.instant('RATERULE.MIN_STAY'), 6:$translate.instant('RATERULE.MAX_STAY')};
        vm.optionsAvail = {1:$translate.instant('RATERULE.RATES'), 2:$translate.instant('RATERULE.STOP_SELL'), 5:$translate.instant('RATERULE.MIN_STAY')};
        vm.optionsSel = 1;
        var date = new Date(), y = date.getFullYear(), m = date.getMonth(), d = date.getDay();
		var unixdateEnd=(moment(date).add(vm.daysratecalender, 'days').unix())*1000;
		var dateTime=new Date(unixdateEnd);
		var date_EE=dateTime.toISOString();
		var firstDay=new Date();
		var lastDay=new Date(date_EE);
		vm.currenttask=[];
		vm.userPermissions = $rootScope.userPermissions;
		if(screen.width >= 3800){
			var zoomval=3;
		}else if(screen.width >= 2500 && screen.width < 3800){
			var zoomval=2;
		}else{
			var zoomval=1;
		}
		vm.maxheight=jQuery(window).height()-220;
        vm.options = {
			headersFormats: {
			  'year': 'YYYY', 
			  'quarter': '[Q]Q YYYY', 
			  month: 'MMMM YYYY', 
			  week: function(column) {
				return column.date.format('MMM D [-]') + column.endDate.format('[ ]MMM D');
			  },
			  day: 'D:dd:M-D-YYYY', 
			  hour: 'H', 
			  minute:'HH:mm'
			},
            mode                    : 'custom',
            scale                   : 'day',
            sortMode                : undefined,
            sideMode                : 'Tree',
            daily                   : true,
            maxHeight               : true,
            width                   : false,
            zoom                    : zoomval,
            rowSortable             : true,
            jsPlumbDefaults             : false,
            columns                 : ['model.name', 'from', 'to'],
            treeTableColumns        : ['from', 'to'],
            columnsHeaders          : {
                'model.name' : 'Rooms', 'from': 'From', 'to': 'To'
            },
            columnsClasses          : {
                'model.name': 'gantt-column-name',
                'from'      : 'gantt-column-from',
                'to'        : 'gantt-column-to'
            },
            columnsFormatters       : {
                'from': function (from)
                {
                    return angular.isDefined(from) ? from.format('lll') : undefined;
                },
                'to'  : function (to)
                {
                    return angular.isDefined(to) ? to.format('lll') : undefined;
                }
            },
            treeHeaderContent       : '{{getHeader()}}',
            columnsHeaderContents   : {
                'model.name': '{{getHeader()}}',
                'from'      : '{{getHeader()}}',
                'to'        : '{{getHeader()}}'
            },
            autoExpand              : 'both',
            taskOutOfRange          : 'expand',
            fromDate                : firstDay,
            toDate                  : lastDay,
            rowContentEnabled       : true,
            rowContent              : '<span>{{row.model.name}}</span>',
            taskContentEnabled      : true,
            taskContent             : '<span class="gantt-task-name">\n    {{task.model.name}}\n    <md-tooltip md-direction="top" class="gantt-chart-task-tooltip">\n        <div layout="column" layout-align="center center">\n            <div class="tooltip-name">\n                {{task.model.tootltiptext}}\n            </div>\n            <div class="tooltip-date">\n                <span>\n                    {{task.model.from.format(\'MMM DD, HH:mm\')}}\n                </span>\n                <span>-</span>\n                <span>\n                    {{task.model.to.format(\'MMM DD, HH:mm\')}}\n                </span>\n            </div>\n        </div>\n    </md-tooltip>\n</span>',
            allowSideResizing       : false,
            labelsEnabled           : true,
            currentDate             : 'none',
            currentDateValue        : new Date(),
            draw                    : false,
            readOnly                : true,
            groupDisplayMode        : 'diabled',
            filterTask              : '',
            filterRow               : '',
           
            timeFrames              : {
                'day'    : {
                    start  : moment('8:00', 'HH:mm'),
                    end    : moment('20:00', 'HH:mm'),
                    working: false,
                    default: false
                },
                'noon'   : {
                    start  : moment('12:00', 'HH:mm'),
                    end    : moment('13:30', 'HH:mm'),
                    working: false,
                    default: false
                },
                'weekend': {
                    color:'#da7b3b'
                },
                'holiday': {
                    working: false,
                    color  : 'red',
                    classes: ['gantt-timeframe-holiday']
                }
            },
            dateFrames              : {
                'weekend'    : {
                    evaluator: function (date)
                    {
                        return date.isoWeekday() === 5 || date.isoWeekday() === 6;
                    },
                    targets  : ['weekend']
                },
                '11-november': {
                    evaluator: function (date)
                    {
                        return date.month() === 10 && date.date() === 11;
                    },
                    targets  : ['holiday']
                }
            },
            timeFramesWorkingMode   : 'hidden',
            timeFramesNonWorkingMode: 'visible',
            columnMagnet            : '15 minutes',
            timeFramesMagnet        : false,
            canDraw                 : function (event)
            {
                var isLeftMouseButton = event.button === 0 || event.button === 1;
                return vm.options.draw && !vm.options.readOnly && isLeftMouseButton;
            },
            drawTaskFactory         : function ()
            {
                return {
                    id   : ganttUtils.randomUuid(),  // Unique id of the task.
                    name : '', // Name shown on top of each task.
                    color: '#AA8833', // Color of the task in HEX format (Optional).
                    darkcolor: '#BCAAA4' // Color of the task in HEX format (Optional).
                };
            },
            api                     : function (ganttApi)
            {
                // API Object is used to control methods and events from angular-gantt.
                vm.api = ganttApi;

                vm.api.core.on.ready($scope, function ()
                {
					
					
                    // When gantt is ready, load data.
                    // `data` attribute could have been used too.
                    vm.isloading = true;
                    $timeout(function ()
					{
						vm.load('graph');
					});
                    

                    // DOM events
                    vm.api.directives.on.new($scope, function (directiveName, directiveScope, element)
                    {
                        /**
                         * Gantt Task
                         */
                        if ( directiveName === 'ganttTask' )
                        {
                            element.on('mousedown touchstart', function (event)
                            {
                                event.preventDefault();
                                event.stopPropagation();
                                vm.live.row = directiveScope.task.row.model;
                                if ( angular.isDefined(directiveScope.task.originalModel) )
                                {
                                    vm.live.task = directiveScope.task.originalModel;
                                }
                                else
                                {
                                    vm.live.task = directiveScope.task.model;
                                }
                                jQuery('.rate-rule-input').html('');
                                vm.raterule = {};
								vm.raterule.channel_id = vm.live.task.channel_id;
								vm.raterule.date = vm.live.task.date;
								vm.raterule.rate_plan_id = vm.live.task.rate_plan_id;
								vm.raterule.room_type_id = vm.live.task.room_type_id;
								vm.raterule.pageView = vm.optionsSel;
                                vm.raterule.hotel_id = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
								vm.raterule.sub_hotel_id = vm.roomtype_subHotelIds[vm.live.task.room_type_id];
                                if(vm.optionsSel == 1 || vm.optionsSel == 5 || vm.optionsSel == 6){//'RATES',Min Stay,Max Stay
									if(vm.optionsSel == 1 && typeof vm.live.task.derived_name!='undefined'){
										toastMessage.showSimpleToast('You cannot edit rates of this rate plan as this is derived from "'+vm.live.task.derived_name+'".','error-toast');
									}else{
										var html='<div class="custom-menu-rate"><form class="eachRateFormCls" name="eachRateForm">';
										if(vm.optionsSel == 1)
										{
											vm.raterule.room_type_price = vm.live.task.current_val;
											html+='<input type="text" ng-model="vm.raterule.room_type_price" ng-change="vm.editPrice(vm.live.task.index)" ng-model-options="{debounce: 1000}" ng-class="vm.eachrateError?\'errorField rateRuleCustomText\':\'rateRuleCustomText\'" required/>'; 
										}else if(vm.optionsSel == 5){
											vm.raterule.min_stay = vm.live.task.current_val;
											html+='<input type="text" ng-model="vm.raterule.min_stay" ng-change="vm.editPrice(vm.live.task.index)" ng-model-options="{debounce: 1000}" ng-class="vm.eachrateError?\'errorField rateRuleCustomText\':\'rateRuleCustomText\'" required allow-decimal-numbers/>'; 
										}else if(vm.optionsSel == 6){
											vm.raterule.max_stay = vm.live.task.current_val;
											html+='<input type="text" ng-model="vm.raterule.max_stay" ng-change="vm.editPrice(vm.live.task.index)" ng-model-options="{debounce: 1000}" ng-class="vm.eachrateError?\'errorField rateRuleCustomText\':\'rateRuleCustomText\'" required allow-decimal-numbers/>';
										}
										html+='<i ng-click="vm.showQuickUpdate(vm.live.task)" class="attachIcon"><md-icon md-font-icon="icon-content-copy" class="icon size15"></md-icon></i>';
										
										html+='</form></div>';
										jQuery('.rate-rule-input').html('');
										angular.element(jQuery('.rate-rule-input')).append($compile(html)($scope));
										//jQuery('.custom-menu').css('top',((vm.live.row.index * 48) + 96)+"px");  
										jQuery('.custom-menu-rate').css('top',((jQuery(element).offset().top) - 205)+"px");  
										jQuery('.custom-menu-rate').css('left',(element.position().left + angular.element('#gantt-side-content').width())+"px");  
										jQuery('.custom-menu-rate').css('max-width',(jQuery(element).css('width')));  
									}
								}else if(vm.optionsSel == 2 || vm.optionsSel == 3 || vm.optionsSel == 4){
									if(vm.live.task.current_val == 0)
										vm.live.task.current_val = 1;
									else
										vm.live.task.current_val = 0;
									if(vm.optionsSel == 2)
										vm.raterule.is_stop_sell = vm.live.task.current_val;
									else if(vm.optionsSel == 3)
										vm.raterule.is_cta = vm.live.task.current_val;
									else if(vm.optionsSel == 4)
										vm.raterule.is_ctd = vm.live.task.current_val;
									editPrice(vm.live.task.index);
								}
                                $scope.$digest();
                            });

                        }

                        /**
                         * Gantt Row
                         */
                        else if ( directiveName === 'ganttRow' )
                        {
                            element.on('click', function (event)
                            {                             
                                event.stopPropagation();
                            });
                            element.on('mousedown touchstart', function (event)
                            {
                                event.stopPropagation();
                                vm.live.row = directiveScope.row.model;
                                $scope.$digest();
                            });
                        }

                        /**
                         * Gantt Row Label
                         */
                        else if ( directiveName === 'ganttRowLabel' )
                        {
                            // Fix for double trigger due to gantt-sortable plugin
                            element.off('click');

                            element.on('click', function (event)
                            {
                                event.preventDefault();
                                editDialog(event, 'row', directiveScope.row);
                            });

                            element.on('mousedown touchstart', function ()
                            {
                                vm.live.row = directiveScope.row.model;
                                $scope.$digest();
                            });

                        }
                    });
					vm.api.tasks.on.resizeEnd($scope,function (task){
						
					});
                    vm.api.tasks.on.rowChange($scope, function (task)
                    {
                        vm.live.row = task.row.model;
                    });

                    objectModel = new GanttObjectModel(vm.api);
                });

                vm.api.rows.on.move($scope, function(row, oldIndex, newIndex){
                    var newsortOrder = [];
                    angular.forEach(vm.data, function (value, key)
                    {
                        newsortOrder.push(value.id);
                    });
                    console.log('newsortOrder',newsortOrder);
                    
                    rateRuleService.setSortOrder({'newsortOrder':newsortOrder}).then(function(response){
                        console.log('response', response);
                        // if(!response.success){
                        //     toastMessage.showSimpleToast('There was some error in saving sort order of rooms. Please try again later.','error-toast');
                        // }
                    });
                    
                });


            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.search = search;
        vm.setSortMode = setSortMode;
        vm.canAutoWidth = canAutoWidth;
        vm.getColumnWidth = getColumnWidth;
        vm.load = load;
        vm.reload = reload;
        vm.copyrates = copyrates;
        vm.bulkUpdate = bulkUpdate;
        vm.showQuickUpdate = showQuickUpdate;
        vm.editPrice = editPrice;
        vm.changeView = changeView;
        vm.changeFilters = changeFilters;

        //////////
		
		//~ jQuery(document).on('click', function(){
			//~ if(jQuery(this).attr('class') !== undefined)
				//~ jQuery('.rate-rule-input').html('');
		//~ }).not('.gantt-task').not('.gantt-task-name').not('.gantt-task-content').not('.rate-rule-span').not('.gantt-task-background').not('.rate-rule-input').not('.custom-menu-rate').not('.rateRuleCustomText').not('.eachRateFormCls');
		
        init();
        /**
         * Initialize
         */
        function init()
        {
            // Set Gantt Chart height at the init
            calculateHeight();

            angular.element($window).on('resize', function ()
            {
                $scope.$apply(function ()
                {
                    calculateHeight();
                });
            });
        }
        function changeView(){
			jQuery('.rate-rule-input').html('');
			load('sameDate');
		}
		function changeFilters(){
			jQuery('.rate-rule-input').html('');
			load('sameDateAndFilter');
		}
        function showQuickUpdate(taskData){
            taskData.sub_hotel_id = vm.roomtype_subHotelIds[taskData.room_type_id];
			jQuery('.rate-rule-input').html('');
			$mdDialog.show({
				controller         : 'RateDialogController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/apps/rateRule/dialogs/rate-dialog.html',
				parent             : angular.element($document.find('#product-container')),
				targetEvent        : event,
				scope:$scope.$new(),
				clickOutsideToClose: true,
				locals             : {
					Ratedata	: taskData,
					optionsSel	: vm.optionsSel
				}
			});
		}
		function editPrice(indexTask){
			vm.isloading = true;
			vm.eachrateError = false;
			rateRuleService.setRateRuleData(vm.raterule).then(function(response){
				vm.isloading = false;
				if(response.success){
					jQuery('.rate-rule-input').html('');
					vm.data[vm.live.row.index].tasks[indexTask].name = response.newVal;
					load('changeDate');
				}else if(response.errorMsg){
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				} else{
					toastMessage.showSimpleToast('There was some error in updating '+(vm.optionsAvail[vm.optionsSel]).toLowerCase()+'.','error-toast');
				}
			});
		}

        /**
         * Max Height Fix
         */
        function calculateHeight()
        {
            vm.options.maxHeight = $document.find('#chart-container').offsetHeight;
        }

        
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };
		function isScrolledIntoView(elem)
		{
			var docViewTop = $(window).scrollTop();
			var docViewBottom = docViewTop + $(window).height();

			var elemTop = $(elem).offset().top;
			var elemBottom = elemTop + $(elem).height();

			return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
		}
        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Search
         * @param sidenavId
         */
        function search(option, keyword)
        {
            if ( option === 'rows' )
            {
                vm.options.filterRow = keyword;
            }
            else if ( option === 'tasks' )
            {
                vm.options.filterTask = keyword;
            }
        }

        /**
         * Sort Mode
         * @param mode
         */
        function setSortMode(mode)
        {
            vm.options.sortMode = mode;

            if ( angular.isUndefined(mode) )
            {
                vm.options.rowSortable = true;
            }
            else
            {
                vm.options.rowSortable = false;
            }
        }

        /**
         * Side Mode
         */
        $scope.$watch('vm.options.sideMode', function (newValue, oldValue)
        {
            if ( newValue !== oldValue )
            {
                vm.api.side.setWidth(undefined);

                $timeout(function ()
                {
                    vm.api.columns.refresh();
                });
            }
        });

        function canAutoWidth(scale)
        {
            if ( scale.match(/.*?hour.*?/) || scale.match(/.*?minute.*?/) )
            {
                return false;
            }

            return true;
        }

        function getColumnWidth(widthEnabled, scale, zoom)
        {
            if ( !widthEnabled && vm.canAutoWidth(scale) )
            {
                return undefined;
            }

            if ( scale.match(/.*?week.*?/) )
            {
                return 150 * zoom;
            }

            if ( scale.match(/.*?month.*?/) )
            {
                return 300 * zoom;
            }

            if ( scale.match(/.*?quarter.*?/) )
            {
                return 500 * zoom;
            }

            if ( scale.match(/.*?year.*?/) )
            {
                return 800 * zoom;
            }

            return 40 * zoom;
        }

        // Reload data action
        function load(location)
        {
			jQuery('.rate-rule-input').html('');
			vm.isloading = true;
			if(location=='changeDate'){
				var from = vm.options.fromDate;
				var to = moment(moment(moment(from).format('YYYY/MM/DD')).add(vm.daysratecalender, 'days')).format('YYYY/MM/DD');
				from = moment(from).format('YYYY/MM/DD');
				vm.options.toDate = to;
				var datas = {start:from,end:to, hotel_id:$localStorage.hotels[$localStorage.selectedHotel]['hotel_id'],pageView:vm.optionsSel};
				if(vm.roomTypeSel!=0){
					datas.roomFilter = vm.roomTypeSel;
				}if(vm.ratePlanSel!=0){
					datas.ratePlanFilter = vm.ratePlanSel;
				}
				rateRuleService.getRateRuleData(datas).then(function(response){
					vm.isloading = false;
                     // vm.roomTypeSel = response.selectedRoom;
					if(response.success){

						var data = [];
						for(var i=0;i<(response.roomsDetail).length;i++){
							data.push(JSON.parse((response.roomsDetail)[i]));
						}
						vm.data = data;
						vm.onlyRooms = response.onlyrooms;
                        vm.roomtype_subHotelIds = response.roomtype_subHotelIds;
					}else if(response.errorMsg){
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					} else{
						toastMessage.showSimpleToast('There was some error in fetching prices for selected range.','error-toast');
					}
				});
			}else if(location=='sameDate' || location=='sameDateAndFilter'){
				var from = vm.options.fromDate;
				var to = vm.options.toDate;
				var datas = {start:from,end:to, hotel_id:$localStorage.hotels[$localStorage.selectedHotel]['hotel_id'],pageView:vm.optionsSel};
				if(vm.roomTypeSel!=0){
					datas.roomFilter = vm.roomTypeSel;
				}if(vm.ratePlanSel!=0){
					datas.ratePlanFilter = vm.ratePlanSel;
				}
				rateRuleService.getRateRuleData(datas).then(function(response){
					vm.isloading = false;
					if(response.success){
						var data = [];
						for(var i=0;i<(response.roomsDetail).length;i++){
							data.push(JSON.parse((response.roomsDetail)[i]));
						}
						vm.data = data;
						vm.onlyRooms = response.onlyrooms;
                        vm.roomtype_subHotelIds = response.roomtype_subHotelIds;
					}else if(response.errorMsg){
						toastMessage.showSimpleToast(response.errorMsg,'error-toast');
					} else{
						toastMessage.showSimpleToast('There was some error in fetching prices for selected range.','error-toast');
					}
				});
			}else{
				var data = [];
				for(var i=0;i<(RateRule.roomsDetail).length;i++){
					data.push(JSON.parse((RateRule.roomsDetail[i])));
				}
				vm.data = data;
				vm.onlyRooms = RateRule.onlyrooms;
                vm.roomtype_subHotelIds = RateRule.roomtype_subHotelIds;
				vm.isloading = false;
			}
            // Fix for Angular-gantt-chart issue
            $animate.enabled(true);
            $animate.enabled($document.find('#gantt'), false);

        }

        /**
         * Reload Data
         */
         vm.reset = reset;

         function reset(){
            vm.ratePlanSel = 0
            vm.options.fromDate = new Date();
            vm.searchRowKeyword = '';
            vm.options.filterRow = '';
            vm.optionsSel = 1;
         }
        function reload()
        {
            reset();
			jQuery('.rate-rule-input').html('');
			vm.isloading = true;
			rateRuleService.getRateRuleData({hotel_id:$localStorage.hotels[$localStorage.selectedHotel]['hotel_id']}).then(function(response){
				vm.isloading = false;
				if(response.success){
					// if(vm.onlyRooms[0]) vm.roomTypeSel = vm.onlyRooms[0].id;
					// else vm.roomTypeSel = 0;
                    vm.roomTypeSel = response.selectedRoom;
					vm.ratePlanFilter = 0;
					var from = new Date();
					var to = moment(moment(moment(from).format('YYYY/MM/DD')).add(vm.daysratecalender, 'days')).format('YYYY/MM/DD');
					vm.options.toDate = to;
					vm.options.fromDate = from;
					var data = [];
					for(var i=0;i<(response.roomsDetail).length;i++){
						data.push(JSON.parse((response.roomsDetail)[i]));
					}
					vm.data = data;
					vm.onlyRooms = response.onlyrooms;
                    vm.roomtype_subHotelIds = response.roomtype_subHotelIds;
				}else if(response.errorMsg){
					toastMessage.showSimpleToast(response.errorMsg,'error-toast');
				} else{
					toastMessage.showSimpleToast('There was some error in fetching prices for selected range.','error-toast');
				}
			});
        }

        // Visual two way binding.
        var ganttDebounceValue = 1000;

        var listenTaskJson = ganttDebounce(function (taskJson)
        {
            if ( angular.isDefined(taskJson) )
            {
                var task = angular.fromJson(taskJson);
                objectModel.cleanTask(task);
                var model = vm.live.task;
                angular.extend(model, task);
            }
        }, ganttDebounceValue);

        $scope.$watch('vm.live.taskJson', listenTaskJson);

        var listenRowJson = ganttDebounce(function (rowJson)
        {
            if ( angular.isDefined(rowJson) )
            {
                var row = angular.fromJson(rowJson);
                objectModel.cleanRow(row);
                var tasks = row.tasks;

                delete row.tasks;
                var rowModel = vm.live.row;

                angular.extend(rowModel, row);

                var newTasks = {};
                var i, l;

                if ( angular.isDefined(tasks) )
                {
                    for ( i = 0, l = tasks.length; i < l; i++ )
                    {
                        objectModel.cleanTask(tasks[i]);
                    }

                    for ( i = 0, l = tasks.length; i < l; i++ )
                    {
                        newTasks[tasks[i].id] = tasks[i];
                    }

                    if ( angular.isUndefined(rowModel.tasks) )
                    {
                        rowModel.tasks = [];
                    }

                    for ( i = rowModel.tasks.length - 1; i >= 0; i-- )
                    {
                        var existingTask = rowModel.tasks[i];
                        var newTask = newTasks[existingTask.id];

                        if ( angular.isUndefined(newTask) )
                        {
                            rowModel.tasks.splice(i, 1);
                        }
                        else
                        {
                            objectModel.cleanTask(newTask);
                            angular.extend(existingTask, newTask);

                            delete newTasks[existingTask.id];
                        }
                    }
                }
                else
                {
                    delete rowModel.tasks;
                }

                angular.forEach(newTasks, function (newTask)
                {
                    rowModel.tasks.push(newTask);
                });
            }
        }, ganttDebounceValue);

        $scope.$watch('vm.live.rowJson', listenRowJson);

        $scope.$watchCollection('vm.live.task', function (task)
        {
            vm.live.taskJson = angular.toJson(task, true);
            vm.live.rowJson = angular.toJson(vm.live.row, true);
        });
        
		
        $scope.$watchCollection('vm.live.row', function (row)
        {
            vm.live.rowJson = angular.toJson(row, true);
            if ( angular.isDefined(row) && angular.isDefined(row.tasks) && row.tasks.indexOf(vm.live.task) < 0 )
            {
                vm.live.task = row.tasks[0];
            }
        });

        $scope.$watchCollection('vm.live.row.tasks', function ()
        {
            vm.live.rowJson = angular.toJson(vm.live.row, true);
        });
        
        // Event handler
        var logTaskEvent = function(eventName, task) {
            
        };
        
        // Event utility function
        var addEventName = function(eventName, func) {
            return function(data) {
                return func(eventName, data);
            };
        };
	
	$scope.$on('update_full_ganttchart', function(event) { 
		load('changeDate');
	});

	function bulkUpdate(ev){

		$mdDialog.show({
			controller         : 'BulkUpdateDialogCont',
			controllerAs       : 'vm',
			templateUrl        : 'app/main/apps/rateRule/dialogs/bulk-update-dialog.html',
			parent             : angular.element($document.find('#product-container')),
			targetEvent        : ev,
			scope:$scope.$new(),
			clickOutsideToClose: true,
			locals             : {
				RoomsRateChannel	: vm.onlyRooms,
				RateData			: vm.ratePlansData,
                channelsData        : vm.channelsData,
				Rooms_sub_hotel_ids	: vm.roomtype_subHotelIds,
                pageFrom            : 'rateCalander',
                extraParams         : [],
                casitas_data        : []
			}
		});
	}
	function showNavigator(){
		vm.showCal = true;
	}
	function hideNavigator(){
		vm.showCal = false;
	}
	function copyrates(ev){
		$mdDialog.show({
			controller         : 'copyRatesDialogCont',
			controllerAs       : 'vm',
			templateUrl        : 'app/main/apps/rateRule/dialogs/copy-rates-dialog.html',
			parent             : angular.element($document.find('#product-container')),
			targetEvent        : ev,
			scope:$scope.$new(),
			clickOutsideToClose: true,
			locals             : {
				RoomsRateChannel	: vm.onlyRooms,
				RateData			: vm.ratePlansData,
				channelsData			: vm.channelsData
			}
		});	
	}
	

  }
})();

  (function () {
    "use strict";

    angular
      .module("app.rateRule")
      .controller("rateCustomCalendarController", rateCustomCalendarController);

    /** @ngInject */
    function rateCustomCalendarController(
      $stateParams,
      $state,
      $scope,
      $http,
      EnvironmentConfig,
      toastMessage,
      $localStorage,
      RateRule,
      $timeout,
      rateRuleService,
      $mdDialog,
      $document,
      $animate,
      $compile,
      ganttUtils,
      GanttObjectModel,
      ganttDebounce,
      moment,
      $window,
      $mdSidenav,
      msApi,
      $translate,
      $rootScope,
      ganttChartServiceNew,
      dashboardGraphService
    ) {      

      var vm = this;
      var data = {};
      
      $scope.$watch(
        function() {
          return {
            hotelId: $localStorage.hotels && $localStorage.selectedHotel !== undefined ? 
                     $localStorage.hotels[$localStorage.selectedHotel].hotel_id : null,
            startDate: vm.fromDate ? vm.fromDate.dateStart : null,
            endDate: vm.fromDate ? vm.fromDate.dateEnd : null
          };
        },
        function(newVal) {
          if (newVal.hotelId && newVal.startDate && newVal.endDate) {
            data = {
              hotelId: newVal.hotelId,
              requestFor: 'room',
              start: moment(newVal.startDate).format('YYYY-MM-DD'),
              end: moment(newVal.endDate).format('YYYY-MM-DD')
            };
            refreshGanttData();   
            vm.getAvailability();         
          }
        },
        true // Deep watch
      );
      function refreshGanttData() {
        if (data.hotelId && data.start && data.end) {
          ganttChartServiceNew.getGanttData(data).then(processGanttData);
        }
      }
  
      refreshGanttData();
      
      function processGanttData(response) {
        vm.ganttData = response;
        vm.hotelDatePercentages = {};
        
        vm.ganttData.roomsDetail.forEach(hotelData => {
            try {
                const hotel = typeof hotelData === 'string' ? JSON.parse(hotelData) : hotelData;
                if (hotel.is_sub_hotel && hotel.tasks && hotel.tasks.length > 0) {
                    const hotelName = hotel.name || 'default';
                    vm.hotelDatePercentages[hotelName] = {};
                    
                    hotel.tasks.forEach(task => {
                        if (task.from) {
                            const date = moment(task.from).format('YYYY-MM-DD');
                            vm.hotelDatePercentages[hotelName][date] = task.name;
                        }
                    });
                }
            } catch (e) {
                console.error('Error processing hotel data:', e);
            }
        });
        
        vm.getPercentageForDate = function(dateObj, hotelName) {
            if (!dateObj || !dateObj.date || !vm.hotelDatePercentages) return '';
            if (!hotelName) return ''; 
            
            const formattedDate = dateObj.date;
            const hotelData = vm.hotelDatePercentages[hotelName];
            
            if (!hotelData) {
                const matchingHotel = Object.keys(vm.hotelDatePercentages).find(hotel => 
                    hotelName.toLowerCase().includes(hotel.toLowerCase()) || 
                    hotel.toLowerCase().includes(hotelName.toLowerCase())
                );
                
                if (!matchingHotel) return ''; 
                hotelData = vm.hotelDatePercentages[matchingHotel];
            }
            
            if (hotelData.hasOwnProperty(formattedDate)) {
                return hotelData[formattedDate];
            }
            
            const altFormat = formattedDate.split('-').join('-');
            return hotelData[altFormat] || '';
        };
        
      }

      // Count total products for each room type
      vm.getProductCount = function(roomId) {
        if (!vm.ganttData || !vm.ganttData.roomsDetail) return 0;
        
        for (let i = 0; i < vm.ganttData.roomsDetail.length; i++) {
          const room = typeof vm.ganttData.roomsDetail[i] === 'string' ? 
                      JSON.parse(vm.ganttData.roomsDetail[i]) : vm.ganttData.roomsDetail[i];
          
          if (room.id && room.id.toString() === roomId.toString() && room.productIds) {
            return room.productIds.length;
          }
        }
        return 0;
      };

      vm.getAvailability = function() {
        vm.availabilityLoader = true;
        var minDays = 0;
        if (vm.fromDate && vm.fromDate.dateStart && vm.fromDate.dateEnd) {
          minDays = moment(vm.fromDate.dateEnd).diff(moment(vm.fromDate.dateStart), 'days') + 1;
        }
        
        var data = {
          startDate: moment(vm.fromDate.dateStart).format('YYYY-MM-DD'),
          endDate:moment(vm.fromDate.dateEnd).format('YYYY-MM-DD'),
          typeFor: 'room',
          sortType: 'ASC',
          minDays: minDays
      };
        dashboardGraphService.getAvailabilityStatus(data)
            .then(function(response) {
                if (response.data !== undefined) {
                    vm.topHeadDates = response.dates;
                    vm.collapsebleRoom = [];
                    if(response.roomTypeRates) {
                        vm.roomTypeRates = response.roomTypeRates;
                        vm.roomNumberResults = response.roomNumberResults;
                        vm.unAvailableDates = response.unAvailableDates;
                    } else {
                        vm.availableRooms = response.data;
                        vm.availableRoomsDates = response.result;    
                    }
                }
                vm.availabilityLoader = false;
        });
    };

    vm.generateDateRange = function() {
      var startDate = moment(vm.dateRange.startDate);
      var endDate = moment(vm.dateRange.endDate);
      
      vm.dateRange = [];
      while (startDate.isSameOrBefore(endDate)) {
          vm.dateRange.push({
              date: startDate.format('YYYY-MM-DD'),
              name: startDate.format('ddd')
          });
          startDate.add(1, 'day');
      }
  };
      vm.daysratecalender = RateRule.daysratecalender;
      vm.setIntialValues = function (rateRule) {
        vm.roomTypes = rateRule.roomTypes;
        vm.subHotels = rateRule.subhotels;
        
        vm.groupedRoomTypes = {};
        vm.roomTypes.forEach(function(roomType) {
          var hotelId = roomType.sub_hotel_id || 'other';
          if (!vm.groupedRoomTypes[hotelId]) {
            vm.groupedRoomTypes[hotelId] = [];
          }
          vm.groupedRoomTypes[hotelId].push(roomType);
        });
        
        if (vm.roomTypes && vm.subHotels) {
          var hotelMap = {};
          vm.subHotels.forEach(function(hotel) {
            hotelMap[hotel.hotel_id] = hotel.hotel_title;
          });
          
          vm.roomTypes.forEach(function(roomType) {
            if (roomType.sub_hotel_id && hotelMap[roomType.sub_hotel_id]) {
              roomType.hotel_title = hotelMap[roomType.sub_hotel_id];
            }
          });
          
          if (rateRule.onlyrooms) {
            rateRule.onlyrooms.forEach(function(room) {
              if (room.sub_hotel_id && hotelMap[room.sub_hotel_id]) {
                room.hotel_title = hotelMap[room.sub_hotel_id];
              }
            });
          }
        }
        
        vm.ratePlansData = rateRule.ratePlansData;
        vm.dateRange = rateRule.dateRange;
        vm.monthRange = rateRule.monthRange;
        vm.channelsData = rateRule.channelsData;
        vm.roomTypeSel = rateRule.selectedRoom;
        vm.onlyRooms = rateRule.onlyrooms;
        vm.roomRate = rateRule.roomRate;
        vm.selectSubHotel = rateRule.defaultSubHotelId;
      };

      // Range selector default dates
      vm.defaultDate = function () {
        vm.fromDate = {};
        vm.fromDate.dateStart = new Date();
        var date = new Date();
        var endDate = date.setDate(date.getDate() + vm.daysratecalender);
        vm.fromDate.dateEnd = new Date(endDate);
        vm.fromDate.selectedTemplateName =
          moment(vm.fromDate.dateStart).format("D MMM") +
          " - " +
          moment(vm.fromDate.dateEnd).format("D MMM YYYY");
      };

      vm.height = window.innerHeight;
      if (vm.height) {
        vm.height = vm.height - 210;
      }
      // Range selector default dates
      vm.defaultDate();

      vm.selectedType = "room";
      vm.roomTypeSelect = {
        room: $translate.instant("RATERULE.ROOM"),
        boat: $translate.instant("RATERULE.BOAT"),
      };

      // Set initial values from resolve
      vm.setIntialValues(RateRule);

      // Default values
      vm.ChannelRate = [];
      vm.showChannelRate = [];
      vm.channelRates = [];
      vm.optionsAvail = {
        1: $translate.instant("RATERULE.RATES"),
        2: $translate.instant("RATERULE.STOP_SELL"),
        3: $translate.instant("RATERULE.CTA"),
        4: $translate.instant("RATERULE.CTD"),
        5: $translate.instant("RATERULE.MIN_STAY"),
      };
      vm.optionsSel = 1;
      vm.ratePlanSel = 0;
      // vm.fromDate = new Date();
      vm.hotel_id = $localStorage.hotels[$localStorage.selectedHotel]["hotel_id"];
      vm.load = load;

      // Get rateplan channel prices
      vm.getchannelPrices = function (roomTypeId, ratePlanCode) {
        var from = moment(vm.fromDate.dateStart).format("YYYY-MM-DD");
        var to = moment(vm.fromDate.dateEnd).format("YYYY-MM-DD");
        var data = {
          roomTypeId: roomTypeId,
          ratePlanCode: ratePlanCode,
          start: from,
          end: to,
          hotel_id: $localStorage.hotels[$localStorage.selectedHotel]["hotel_id"],
          pageView: vm.optionsSel,
          subHotelId: vm.selectSubHotel,
        };
        vm.isloading = true;

        if (!vm.showChannelRate[roomTypeId]) vm.showChannelRate[roomTypeId] = [];

        if (!vm.channelRates[roomTypeId]) vm.channelRates[roomTypeId] = [];

        rateRuleService.getRatlePlanChannelPrices(data).then(function (response) {
          vm.isloading = false;
          if (response.success) {
            vm.channelRates[roomTypeId][ratePlanCode] = response.rates;
            vm.showChannelRate[roomTypeId][ratePlanCode] = true;
          } else if (response.errorMsg) {
            toastMessage.showSimpleToast(response.errorMsg, "error-toast");
          } else {
            toastMessage.showSimpleToast(
              "There was some error in updating " +
                vm.optionsAvail[vm.optionsSel].toLowerCase() +
                ".",
              "error-toast"
            );
          }
        });
      };

      // Hide channel rates
      vm.hideChannelRates = function (index, secondIndex) {
        if (vm.showChannelRate[index] && vm.showChannelRate[index][secondIndex])
          vm.showChannelRate[index][secondIndex] = false;
      };

      // Filter changes load data
      vm.changeFilters = function () {
        vm.showChannelRate = [];
        load("sameDateAndFilter");
      };

      // Reload data action
      function load(location) {
        //
        vm.isloading = true;
        // var from = vm.fromDate;
        // var to = moment(moment(moment(from).format('YYYY/MM/DD')).add(vm.daysratecalender, 'days')).format('YYYY/MM/DD');
        // from = moment(from).format('YYYY/MM/DD');
        var from = moment(vm.fromDate.dateStart).format("YYYY-MM-DD");
        var to = moment(vm.fromDate.dateEnd).format("YYYY-MM-DD");
        var datas = {
          start: from,
          end: to,
          hotel_id: $localStorage.hotels[$localStorage.selectedHotel]["hotel_id"],
          pageView: vm.optionsSel,
        };
        if (vm.roomTypeSel != 0) {
          datas.roomFilter = vm.roomTypeSel;
        }
        if (vm.ratePlanSel != 0) {
          datas.ratePlanFilter = vm.ratePlanSel;
        }
        if (vm.selectSubHotel) datas.subHotelId = vm.selectSubHotel;

        if (vm.selectedType) datas.type = vm.selectedType;

        if (location == "changeDate") {
          vm.showChannelRate = [];
          datas.filterChange = "changeDate";
        }

        vm.getCustomRates(datas, location);
        // Fix for Angular-gantt-chart issue
        $animate.enabled(true);
        $animate.enabled($document.find("#gantt"), false);
      }

      vm.getCustomRates = function (datas, location) {
        rateRuleService.getCustomRateRuleData(datas).then(function (response) {

          vm.isloading = false;
          if (response.success) {                          
            if (location == "sameDate" || location == "sameDateAndFilter") {
              // vm.roomTypes = response.roomTypes;
              vm.ratePlansData = response.ratePlansData;
              vm.dateRange = response.dateRange;
              vm.monthRange = vm.monthRange;
              vm.roomRate = response.roomRate;
            } else if (location == "changeDate") {
              vm.dateRange = response.dateRange;
              vm.monthRange = response.monthRange;
            } else if (location == "subHotels" || location == "changeType") {
              vm.setIntialValues(response);
            }
          } else if (response.errorMsg) {
            toastMessage.showSimpleToast(response.errorMsg, "error-toast");
          } else {
            toastMessage.showSimpleToast(
              "There was some error in fetching prices for selected range.",
              "error-toast"
            );
          }
        });
      };

      // Toggle between rates/stopshell/min stay
      vm.changeView = function () {
        //
        vm.showChannelRate = [];
        load("sameDate");
      };

      // Show Bulk update popup
      vm.bulkUpdate = function (ev) {
        var onlyRooms = angular.copy(vm.onlyRooms);
        onlyRooms.shift();
        var ratePlansData = {};
        var channelsData = {};
        var roomsData = {};
        var typeForSearch = "boat";
        var typeIndex = "Boat";
        if (vm.selectedType == "room") {
          roomsData["Room"] = onlyRooms;
          ratePlansData["Room"] = angular.copy(vm.ratePlansData["room"]);
          channelsData["Room"] = angular.copy(vm.channelsData);
          typeForSearch = "boat";
          typeIndex = "Boat";
        } else {
          roomsData["Boat"] = onlyRooms;
          ratePlansData["Boat"] = angular.copy(vm.ratePlansData["boat"]);
          channelsData["Boat"] = angular.copy(vm.channelsData);
          typeForSearch = "room";
          typeIndex = "Room";
        }
        if (vm.hotel_id == 126 || vm.hotel_id == 122) {
          var data = {
            start: moment(vm.fromDate.dateStart).format("YYYY-MM-DD"),
            end: moment(vm.fromDate.dateEnd).format("YYYY-MM-DD"),
            hotel_id: vm.hotel_id,
            pageView: 1,
            type: typeForSearch,
          };
          rateRuleService.getCustomRateRuleData(data).then(function (response) {

            vm.isloading = false;
            if (response.success) {
              if (
                response.ratePlansData[typeForSearch] !== undefined &&
                response.ratePlansData[typeForSearch] !== null &&
                response.ratePlansData[typeForSearch] !== ""
              ) {
                roomsData[typeIndex] = response.onlyrooms;
                roomsData[typeIndex].shift();
                channelsData[typeIndex] = response.channelsData;
                ratePlansData[typeIndex] = response.ratePlansData[typeForSearch];
              } else {
                roomsData[typeIndex] = [];
                channelsData[typeIndex] = [];
                ratePlansData[typeIndex] = [];
              }
            } else {
              roomsData[typeIndex] = [];
              channelsData[typeIndex] = [];
              ratePlansData[typeIndex] = [];
            }
          });
        }
        var extraParams = {
          type: vm.selectedType,
          selected_sub_hotel: vm.selectSubHotel
        };
        $mdDialog.show({
          controller: "BulkUpdateDialogCont",
          controllerAs: "vm",
          templateUrl: "app/main/apps/rateRule/dialogs/bulk-update-dialog.html",
          parent: angular.element($document.find("#product-container")),
          targetEvent: ev,
          scope: $scope.$new(),
          clickOutsideToClose: true,
          locals: {
            RoomsRateChannel: roomsData,
            RateData: ratePlansData,
            channelsData: channelsData,
            Rooms_sub_hotel_ids: vm.roomtype_subHotelIds,
            pageFrom: "rateCalander",
            extraParams: extraParams,
            casitas_data: [],
          },
        });
      };

      // Reset values
      vm.reset = function () {
        vm.ratePlanSel = 0;
        vm.fromDate = new Date();
        vm.searchRowKeyword = "";
        vm.optionsSel = 1;
        vm.showChannelRate = [];
        vm.channelRates = [];
        vm.selectedType = "room";
      };

      //Reload calendar
      vm.reload = function () {
        vm.reset();
        //
        vm.isloading = true;

        rateRuleService
          .getCustomRateRuleData({
            hotel_id:
              $localStorage.hotels[$localStorage.selectedHotel]["hotel_id"],
          })
          .then(function (response) {
            vm.isloading = false;
            if (response.success) {
              vm.setIntialValues(response);
              vm.daysratecalender = response.daysratecalender;
              vm.defaultDate();
              vm.getAvailability();
            } else if (response.errorMsg) {
              toastMessage.showSimpleToast(response.errorMsg, "error-toast");
            } else {
              toastMessage.showSimpleToast(
                "There was some error in fetching prices for selected range.",
                "error-toast"
              );
            }
          });
      };

      // Update records after bulk rates update
      $scope.$on("update_custome_ratecalendar", function (event) {
        vm.showChannelRate = [];
        vm.showInput = "";
        load("changeDate");
        vm.getAvailability();
      });

      vm.editPrice = function (roomTypeId, ratePlanCode, channel, index) {
        // Don't not submit
        var current_val;
        if (vm.optionsSel == 1 && vm.oldValue == vm.raterule.room_type_price) {
          vm.showInput = "";
          return false;
        } else if (vm.optionsSel == 5 && vm.oldValue == vm.raterule.min_stay) {
          vm.showInput = "";
          return false;
        }

        vm.raterule.requestFor = vm.selectedType;
        vm.isloading = true;
        rateRuleService.setRateRuleData(vm.raterule).then(function (response) {
          vm.isloading = false;

          if (response.success) {
            //
            vm.showInput = "";

            if (vm.optionsSel == 1) current_val = vm.raterule.room_type_price;
            if (vm.optionsSel == 5) current_val = vm.raterule.min_stay;
            if (vm.optionsSel == 2) current_val = vm.raterule.is_stop_sell;
            if (vm.optionsSel == 3) current_val = vm.raterule.is_cta;
            if (vm.optionsSel == 4) current_val = vm.raterule.is_ctd;
            // Update values in span
            if (
              vm.channelRates[roomTypeId] &&
              vm.channelRates[roomTypeId][ratePlanCode] &&
              vm.channelRates[roomTypeId][ratePlanCode][channel] &&
              vm.channelRates[roomTypeId][ratePlanCode][channel]["rates"][index]
            ) {
              vm.channelRates[roomTypeId][ratePlanCode][channel]["rates"][index][
                "current_val"
              ] = current_val;
            }
            // Referesh list
            vm.getchannelPrices(roomTypeId, ratePlanCode);
          } else if (response.errorMsg) {
            toastMessage.showSimpleToast(response.errorMsg, "error-toast");
          } else {
            toastMessage.showSimpleToast(
              "There was some error in updating " +
                vm.optionsAvail[vm.optionsSel].toLowerCase() +
                ".",
              "error-toast"
            );
          }
        });
      };

      // Show input box
      vm.showInputFn = function (rate, channel_id, rate_plan_code) {
        vm.raterule = {};
        vm.raterule.channel_id = channel_id;
        vm.raterule.date = rate.date;
        vm.raterule.rate_plan_id = rate.rate_plan_id;
        vm.raterule.room_type_id = rate.room_type_id;
        vm.raterule.pageView = vm.optionsSel;
        vm.raterule.hotel_id =
          $localStorage.hotels[$localStorage.selectedHotel]["hotel_id"];
        vm.raterule.sub_hotel_id = rate.sub_hotel_id;

        if (vm.optionsSel == 1) {
          vm.raterule.room_type_price = rate.current_val;
          vm.showInput =
            rate.room_type_id +
            "_" +
            rate.rate_plan_id +
            "_" +
            channel_id +
            "_" +
            rate.index +
            "_rate";
          $timeout(function () {
            document.getElementById(vm.showInput).focus();
          }, 200);
        } else if (vm.optionsSel == 5) {
          vm.raterule.min_stay = rate.current_val;
          vm.showInput =
            rate.room_type_id +
            "_" +
            rate.rate_plan_id +
            "_" +
            channel_id +
            "_" +
            rate.index +
            "_rate";
          $timeout(function () {
            document.getElementById(vm.showInput).focus();
          }, 200);
        } else if (vm.optionsSel == 2) {
          // Toggle stop sell status
          vm.raterule.is_stop_sell = rate.current_val == "0" ? 1 : 0;
          vm.editPrice(rate.room_type_id, rate_plan_code);
        } else if (vm.optionsSel == 3) {
          // Toggle cta status
          vm.raterule.is_cta = rate.current_val == "0" ? 1 : 0;
          vm.editPrice(rate.room_type_id, rate_plan_code);
        } else if (vm.optionsSel == 4) {
          // Toggle ctd status
          vm.raterule.is_ctd = rate.current_val == "0" ? 1 : 0;
          vm.editPrice(rate.room_type_id, rate_plan_code);
        }
        vm.oldValue = rate.current_val;
      };

      // Update records after row update
      $scope.$on("update_custom_row_ratecalendar", function (event) {
        vm.showInput = "";
        if (vm.updateChannelRates) {
          vm.getchannelPrices(
            vm.updateChannelRates.room_type_id,
            vm.updateChannelRates.rate_plan_code
          );
        }
      });

      // Show popup for row update
      vm.showQuickUpdate = function (rates, channel_id, rate_plan_code) {
        rates.channel_id = channel_id;
        //
        vm.updateChannelRates = {
          room_type_id: rates.room_type_id,
          rate_plan_code: rate_plan_code,
        };
        $mdDialog.show({
          controller: "RateDialogController",
          controllerAs: "vm",
          templateUrl: "app/main/apps/rateRule/dialogs/rate-dialog.html",
          parent: angular.element($document.find("#product-container")),
          targetEvent: event,
          scope: $scope.$new(),
          clickOutsideToClose: true,
          locals: {
            Ratedata: rates,
            optionsSel: vm.optionsSel,
          },
        });
      };

      // Change subhotels (PBR)
      vm.changeSubHotel = function () {
        vm.resetCollapsable();
        load("subHotels");
      };

      // Change type (Room/Boat)
      vm.changeType = function () {
        vm.resetCollapsable();
        load("changeType");
      };

      vm.resetCollapsable = function () {
        vm.showChannelRate = [];
        vm.ratePlanSel = 0;
        vm.roomTypeSel = 0;
      };

      // Changes in dates
      vm.changeDates = function () {
        var from = moment(vm.fromDate.dateStart);
        var to = moment(vm.fromDate.dateEnd);
        var diff = to.diff(from, "days");
        if (diff < 15) {
          var from = moment(vm.fromDate.dateStart).format("YYYY-MM-DD");
          var date = new Date(from);
          var endDate = date.setDate(date.getDate() + vm.daysratecalender);
          vm.fromDate.dateEnd = new Date(endDate);
          vm.fromDate.selectedTemplateName =
            moment(vm.fromDate.dateStart).format("D MMM") +
            " - " +
            moment(vm.fromDate.dateEnd).format("D MMM YYYY");
          console.log(vm.fromDate);
        }
        vm.showChannelRate = [];
        load("changeDate");
      };
    }
  })();

'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../category/categoryService
 * @description
 * # ../category/categoryService
 * Service in the minervaApp.
 */
angular.module('app.policy')
  .service('rateCategoryService', function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
 	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}
 	
 	function getFormData(data){
		return $http({
			url:EnvironmentConfig.api+'RateCategory/skipAcl_formData',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function upDateHotelPolicy(data){
		return $http({
			url:EnvironmentConfig.api+'Policy/Update_hotel_policy',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function addrateCategory(data){
		return $http({
			url:EnvironmentConfig.api+'RateCategory/add_ratecategory',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);

	}
	function updaterateCategory(data){
		return $http({
			url:EnvironmentConfig.api+'RateCategory/update_ratecategory',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);

	}
	function deleteRateCategory(data){
		return $http({
			url:EnvironmentConfig.api+'RateCategory/delete_ratecategory',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function validateRateCategoryName(data){
		return $http({
			url:EnvironmentConfig.api+'RateCategory/skipAcl_validate_rate_category_name',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function validateRateCategoryCode(data){
		return $http({
			url:EnvironmentConfig.api+'RateCategory/skipAcl_validate_rate_category_code',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getAssociatedRooms(data){
		return $http({
			url:EnvironmentConfig.api+'RateCategory/skipAcl_getAssociatedRooms',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	return{
 		getFormData 					: getFormData,
		 upDateHotelPolicy 				: upDateHotelPolicy,
		 addrateCategory 				: addrateCategory,
		 updaterateCategory 			: updaterateCategory,
		 deleteRateCategory 			: deleteRateCategory,
		 validateRateCategoryName 		: validateRateCategoryName,
		 getAssociatedRooms 			: getAssociatedRooms,
		 validateRateCategoryCode		: validateRateCategoryCode
	}
 });

(function() {
	'use strict';

	angular
	.module('app.policy')
	.controller('rateCategoryController', rateCategoryController);

	/** @ngInject */
	function rateCategoryController(
		$stateParams, 
		$state, 
		$scope, 
		$http, 
		EnvironmentConfig, 
		$mdDialog, 
		toastMessage, 
		$localStorage, 
		$document, 
		Policies,
		Pageheading,
		rateCategoryService, 
		$sessionStorage,
		$rootScope,
		$timeout
		) {
		var vm = this;
		if(!$rootScope.backButtonPressed){
			$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = {};
			$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] = 1;
			$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'] = 50;
		}
		vm.preHotelName = '';
		vm.hotelId = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
		vm.showMoreOption = false;
		vm.selectedRoom = [];
		vm.selectedMeal = [];
		vm.disRoom = false;
		vm.perOrDollar = 'percentage';
		vm.preselectedRateCtegory = 0;
		vm.amountgroup = 1;
		vm.pageStatus = 'add';
		vm.pageHeader = "New Rate Category";
		vm.rateCategoryNameExists = false;
		vm.nameError = false;
		vm.codeError = false;
		vm.loggedInUserRole = angular.copy(parseInt($localStorage.roleId));
		vm.dcValue = true;
		vm.showBoatPlan = false;
		vm.showSelectPlanType = false;
		vm.tempPlanType = vm.planType = 'room';
		vm.derivedRateData = [];

		vm.updateId = 0;
		vm.userPermissions = $rootScope.userPermissions;
		if (vm.userPermissions.indexOf('boats') != -1) {
			vm.showSelectPlanType = true;
		} 

		vm.selectedmealPlans = [];
		vm.selectedRooms = [];
		if (Pageheading!='list' && typeof $stateParams['rate_plan_id'] == 'undefined' && vm.userPermissions.indexOf('add_rate_rule') === -1) {
			$state.go('app.dashboards_project');
			toastMessage.showSimpleToast('Access denied.', 'error-toast');
		} else if (Pageheading!='list' && $stateParams['rate_plan_id'] != 'undefined' && $stateParams['rate_plan_id'] != '' && vm.userPermissions.indexOf('update_rate_rule') === -1) {
			$state.go('app.dashboards_project');
			toastMessage.showSimpleToast('Access denied.', 'error-toast');
		}

		vm.allRoomswithParentName = Policies[0]['parentRoom'];
		vm.allRooms = Policies[0]['rooms'];
		vm.policy = Policies[0]['policy'];
		vm.mealPlans = Policies[0]['meal_plans'];
		vm.rate_plans = Policies[0]['rate_plans'];
		vm.fixedRate = Policies[0]['fixedRate'] != undefined ? Policies[0]['fixedRate'] : [];
		vm.derivedRateData = Policies[0]['derivedRateData'] != undefined ? Policies[0]['derivedRateData'] : [];

		vm.rateCategoryBackup = {};
		vm.derivedRateChanged = false;

		vm.policy_length_error = false;
		if (vm.policy == '' || vm.policy.length == 0) {
			vm.policy_length_error = true;
		}

		vm.minDays = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28];
		if (Policies[0]['rate_plan_data'].length != 0) {
			vm.rateCategory = Policies[0]['rate_plan_data'][0];
			var dcId = Policies[0]['rate_plan_data'][0]['channel_id'];
			vm.dcValue = dcId == 1?true:false;
			if(vm.rateCategory.room_type.indexOf('room') != -1){
				vm.tempPlanType = vm.planType = 'room';
			} else if (vm.rateCategory.room_type.indexOf('rent') != -1 ) {
				vm.tempPlanType = vm.planType = 'rent';
			} else {
				vm.tempPlanType = vm.planType = 'boat';
				vm.showBoatPlan = true;
				vm.allRooms = Policies[0]['boats'];
				vm.allRoomswithParentName = Policies[0]['parentBoat'];
			}

			vm.rateCategory.rate_plan_default_price = parseInt(Policies[0]['rate_plan_data'][0]['rate_plan_default_price']);
			vm.updateId = vm.rateCategory['rate_plan_id'];
			if (Policies[0]['rate_plan_data'][0]['selectedRoom'] == null || Policies[0]['rate_plan_data'][0]['selectedRoom'] == '' || typeof Policies[0]['rate_plan_data'][0]['selectedRoom'] == 'udefined') {

				vm.selectedRoom = [];
				vm.disRoom = true;
			} else {
				vm.selectedRoom = Policies[0]['rate_plan_data'][0]['selectedRoom'].split(',');

			}
			if (Policies[0]['rate_plan_data'][0]['selectedMeal'] != null)
				vm.selectedMeal = Policies[0]['rate_plan_data'][0]['selectedMeal'].split(',');
				vm.selectedmealPlans = vm.selectedMeal;
				vm.selectedRooms = vm.selectedRoom;

				vm.amountgroup = vm.rateCategory.rate_plan_adjust_up_indicator;
				vm.preselectedRateCtegory = vm.rateCategory.rate_plan_derived_from;
				vm.pageStatus = 'edit';
				vm.pageHeader = vm.rateCategory.rate_plan_name;
				vm.rateCategory['derived_id'] = vm.rateCategory.rate_plan_derived_from;
				if (vm.rateCategory.rate_plan_derived_from != 0) {
					vm.autoMan = 1;
					vm.rateCategory.rate_plan_derived_from = 1;
					vm.checkSelect = vm.rateCategory.rate_plan_derived_from;
					vm.rateCategory.rate_plan_adjust_up_indicator = vm.rateCategory.rate_plan_adjust_up_indicator;

					if (vm.rateCategory.rate_plan_derived_percentage == 0) {
						vm.rateCategory.rate_plan_derived_amount = parseInt(vm.rateCategory.rate_plan_derived_amount);
						vm.perOrDollar = 'dollar';
					} else {
						vm.rateCategory.rate_plan_derived_amount = parseInt(vm.rateCategory.rate_plan_derived_percentage);
					}
				} else {
					vm.autoMan = 0;
					vm.rateCategory.rate_plan_derived_from = 0;
				}
				vm.currentRatePlanStatus = vm.rateCategory.rate_plan_status;
				vm.rateCategoryBackup = JSON.stringify(vm.rateCategory);
				vm.originalPerDollar = vm.perOrDollar;
		} else if (Pageheading == 'add') {
			vm.rateCategory = {};
			vm.currentRatePlanStatus = vm.rateCategory.rate_plan_status = 1;
		}
		if (typeof $stateParams['rate_plan_id'] != 'undefined' && $stateParams['rate_plan_id'] != 'add' && Policies[0]['rate_plan_data'].length == 0) {
			$state.go('app.rateCategory');

		}

		vm.toggleManageRate = toggleManageRate;
		vm.togglePlanType = togglePlanType;
		vm.saveRateCategory = saveRateCategory;
		vm.gotoaddRole = gotoaddRole;
		vm.UpdateRateCategory = UpdateRateCategory;
		vm.gotoRateCategory = gotoRateCategory;
		vm.checkRateCategoryName = checkRateCategoryName;
		vm.checkRateCategoryCode = checkRateCategoryCode;
		vm.updateRoomList = updateRoomList;


		function updateRoomList() {
			rateCategoryService.getAssociatedRooms({
				rate_plan_id: vm.rateCategory.standard_rate,
				hotel_id: $localStorage.hotels[$localStorage.selectedHotel]['hotel_id']
			}).then(function(response) {
				vm.allRooms = response;
			});

		}

		function checkRateCategoryName() {
			if (vm.rateCategory.rate_plan_name) {
				rateCategoryService.validateRateCategoryName({
					name: vm.rateCategory.rate_plan_name,
					hotel_id: $localStorage.hotels[$localStorage.selectedHotel]['hotel_id']
				}).then(function(response) {
					if (response.status) {
						if (vm.updateId != response.id) {
							vm.nameError = true;
							vm.rateCategoryNameExists = 'Rate category with the same name already exists.';
						} else {
							vm.nameError = false;
							vm.rateCategoryNameExists = false;

						}
					} else {
						vm.nameError = false;
						vm.rateCategoryNameExists = false;
					}
				});
			}
		}

		/*Check if code rate plan code exists*/

		function checkRateCategoryCode() {
			if (vm.rateCategory.rate_plan_code) {
				rateCategoryService.validateRateCategoryCode({
					code: vm.rateCategory.rate_plan_code,
				}).then(function(response) {
					if (response.status) {
						if (vm.updateId != response.id) {
							vm.codeError = true;
							vm.rateCategoryCodeExists = 'Rate category with the same name already exists.';
						} else {
							vm.codeError = false;
							vm.rateCategoryCodeExists = false;

						}
					} else {
						vm.codeError = false;
						vm.rateCategoryCodeExists = false;
					}
				});
			}
		}

		function gotoRateCategory() {
			$state.go('app.rateCategory');
		}

		function gotoaddRole() {
			$state.go('app.ratecategoryform');
		}
		$scope.goToEditPage = function(value) {
			if (vm.userPermissions.indexOf('update_rate_rule') != -1) {
				$state.go('app.ratecategoryform_edit', {
					rate_plan_id: value
				});
			}
		};
		
		function toggleManageRate() {
			if (vm.autoMan == 1) {
				vm.rateCategory.rate_plan_derived_from = 1;
				if (!vm.rateCategory.standard_rate) {
				} else {
					/*rateCategoryService.getAssociatedRooms({
						rate_plan_id: vm.rateCategory.standard_rate,
						hotel_id: $localStorage.hotels[$localStorage.selectedHotel]['hotel_id']
					}).then(function(response) {
						vm.allRooms = response;
					});*/
				}
			} else {
				vm.allRooms = Policies[0]['rooms'];
			}
		}

		function togglePlanType() {
			if (Pageheading == 'add' && vm.planType != vm.tempPlanType) {
				if (vm.planType == 'boat') {
					vm.rateCategory = {};
					vm.roomSelectAll = false;
					vm.selectedRooms = [];
					vm.autoMan = '';
	      			$scope.rateCategory.$setPristine();
					vm.showBoatPlan = true;
					vm.allRooms = Policies[0]['boats'];
					vm.allRoomswithParentName = Policies[0]['parentBoat'];
					if(vm.allRooms.length != 0 && vm.pageStatus == 'add'){
						// vm.allRooms.forEach(function(element,index){
						// 	vm.selectedRooms.push(element['room_type_id']);
						// });
						// vm.roomSelectAll = true;
					} else if(vm.allRooms.length != 0 && vm.pageStatus == 'edit'){
						if(vm.selectedRooms.length == vm.allRooms.length){
							vm.roomSelectAll = true;
						}else{
							vm.roomSelectAll = false;
						}
					}
				} else {
					vm.rateCategory = {};
					vm.roomSelectAll = false;
					vm.selectedRooms = [];
					vm.autoMan = '';
	      			$scope.rateCategory.$setPristine();
					vm.showBoatPlan = false;
					vm.allRooms = Policies[0]['rooms'];
					vm.allRoomswithParentName = Policies[0]['parentRoom'];
				}
				vm.tempPlanType = vm.planType;
				vm.rateCategory.rate_plan_status = 1;
				vm.currentRatePlanStatus = vm.rateCategory.rate_plan_status;
			}
		}


		$scope.exists = function(item, list) {
			return list.indexOf(item) > -1;
		};
		$scope.toggle = function(item, list, disableOption) {

			var idx = list.indexOf(item);
			if (idx > -1) {
				list.splice(idx, 1);
			} else {
				list.push(item);
			}
			if (disableOption) {
				if (list.length == 0) {
					vm.disRoom = true;
				} else {
					vm.disRoom = false;
				}
			}
			if(vm.selectedRooms.length == vm.allRooms.length){
				vm.roomSelectAll = true;
			}else{
				vm.roomSelectAll = false;
			}
		};

		if(vm.allRooms.length != 0 && vm.pageStatus == 'add'){
			// vm.allRooms.forEach(function(element,index){
			// 	vm.selectedRooms.push(element['room_type_id']);
			// });
			// vm.roomSelectAll = true;
		} else if(vm.allRooms.length != 0 && vm.pageStatus == 'edit'){
			if(vm.selectedRooms.length == vm.allRooms.length){
				vm.roomSelectAll = true;
			}else{
				vm.roomSelectAll = false;
			}
		}
		
		vm.toggleAll = function(){
			if(!vm.roomSelectAll){
				vm.selectedRooms = [];
				if(vm.showBoatPlan){
					vm.allRooms = Policies[0]['boats'];
					if(vm.allRooms.length != 0){
						vm.allRooms.forEach(function(element,index){
							vm.selectedRooms.push(element['room_type_id']);
						});
					}
				} else {
					vm.allRooms = Policies[0]['rooms'];
					if(vm.allRooms.length != 0){
						vm.allRooms.forEach(function(element,index){
							vm.selectedRooms.push(element['room_type_id']);
						});
					}
				}
			}else{
				vm.selectedRooms = [];
			}
		}

		function saveRateCategory() {
			vm.rateCategory['hotel_id'] = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
			vm.rateCategory['mealPlans'] = vm.selectedmealPlans;
			vm.rateCategory['product_ids'] = vm.selectedRooms;
			vm.rateCategory['defaultChannelValue'] = vm.dcValue;
			vm.rateCategory['rate_plan_derived_from'] = vm.autoMan;
			vm.rateCategory.planType = vm.planType;
			delete vm.rateCategory.temp;
			rateCategoryService.addrateCategory(vm.rateCategory).then(function(response) {
				if (response['status']) {
					$state.go('app.rateCategory');
				} else {
					toastMessage.showSimpleToast('Some error occured. Please try again.', 'error-toast');
				}

			});

		}

		function UpdateRateCategory() {
			
			vm.rateCategory['rate_plan_derived_from'] = vm.autoMan
			vm.rateCategory['hotel_id'] = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
			vm.rateCategory['rate_plan_id'] = vm.updateId;
			vm.rateCategory['mealPlans'] = vm.selectedmealPlans;
			vm.rateCategory['product_ids'] = vm.selectedRooms;
			vm.rateCategory['defaultChannelValue'] = vm.dcValue;
			vm.rateCategory.currentRatePlanStatus = vm.currentRatePlanStatus;
			// vm.rateCategory.derivedRateChanged = vm.derivedRateChanged;
			vm.rateCategory.derivedRateData = vm.derivedRateData;
			vm.rateCategory.planType = vm.planType;
			//delete vm.rateCategory.temp;
			rateCategoryService.updaterateCategory(vm.rateCategory).then(function(response) {
				if (response['status']) {
					if (response.warningMsg != undefined && response.warningMsg != '') {
						toastMessage.showSimpleToast(response.warningMsg, 'success-toast');
						$timeout(function() {
							$state.go('app.rateCategory');
						}, 2500);
					} else {
						$state.go('app.rateCategory');
					}
				} else {
					toastMessage.showSimpleToast('Some error occured. Please try again.', 'error-toast');
				}

			});

		}


		/*Start*/
		$scope.paginatorCallback = paginatorCallback;
		$scope.LoadAllData = LoadAllData;
		$scope.getLoadResultsCallback = getLoadResultsCallback;
		$scope.selectedRowCallback = function(rows) {
			vm.selectedprodId = rows;
			vm.checkDelete = false;

		};
		
		if (vm.userPermissions.indexOf('delete_rate_rule') != -1 && vm.loggedInUserRole == 1) {
			vm.delete_product = true;
		} else {
			vm.delete_product = false;
		}
		var loadPageCallbackWithDebounce;
		$scope.$watch('filterText', function() {
			if (loadPageCallbackWithDebounce) {
				loadPageCallbackWithDebounce();
			}
		});
		$scope.showTabDialog = function(ev, id) {
			roleService.getRolePermissions(id).then(function(response) {
				if (response.listData.length == 0) {
					toastMessage.showSimpleToast('This role has no module assigned.', 'error-toast');
				} else {
					$state.go('app.rolesPermission', {
						id: id
					});

				}
			});
		};
		$scope.userPermissions = vm.userPermissions;
		$scope.updateTable = function() {
			loadPageCallbackWithDebounce();
		};

		$scope.toggleAll = function() {
			var toggleStatus = !$scope.isAllSelected;
			$scope.ChangeAll = toggleStatus;
		}
		$scope.checkBox = function(value) {
			if (vm.selectedprodId.indexOf(value) > -1) {
				vm.selectedprodId.splice(vm.selectedprodId.indexOf(value), 1);
			} else {
				vm.selectedprodId.push(value);
			}
			if (vm.selectedprodId.length > 0) {
				vm.getNumberOfSelectedRows = vm.selectedprodId.length;
				vm.checkDelete = true;
			} else {
				vm.checkDelete = false;
			}
		};
		$scope.deleteSelectedItem = function(ev, selectedprodId) {
			if(vm.loggedInUserRole != 1) {
				return false;
			}
			var del_title = vm.selectedprodId.length > 1 ? 'categories' : 'category';
			
			 // new
			 var html = 'Are you sure, you want to delete the selected rate ' + del_title + '? </br>';
			 html = html + '<b>' + vm.selectedprodId.length + ' rate ' + del_title + '</b>' + ' will be deleted.';
			 
			 $mdDialog.show({
			 	controller: 'confirmController',
			 	controllerAs: 'vm',
			 	templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
			 	parent: angular.element(document.body),
			 	targetEvent: event,
			 	clickOutsideToClose:true ,
			 	locals: {
			 		title: 'Delete Rate Category',
			 		htmlContent:html,
			 		cancelBtn:'Cancel',
			 		OkBtn:'Ok'
			 	}                
			 })
			 .then(function(answer) {
			 	if(typeof answer != 'undefined' && answer == 'update'){
			 		var myObj = {
			 			deleteIds: vm.selectedprodId,
			 			hotel_id: $localStorage.hotels[$localStorage.selectedHotel].hotel_id
			 		};
			 		rateCategoryService.deleteRateCategory(myObj)
			 		.then(function(response) {
			 			if (response.errorMsg) {
			 				toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
			 			} else {
			 				loadPageCallbackWithDebounce();
			 				vm.selectedprodId = [];
			 			}
			 		});
			 	}
			 }, function() {}); 
            //Old
        };

        function getLoadResultsCallback(loadPageCallback) {
        	loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
        }
        vm.UserColumns = [
        'ratePlan.rate_plan_name',
        'pol.policy_name',
        'ratePlan.rate_plan_description',
        'roomtype.room_type_name',
        'rate_plan_id'            
        ];

        vm.onLoad = true;
        vm.requestGoing = false;
        function paginatorCallback(page, pageSize, option) {
        	if(vm.userPermissions.indexOf('update_rate_rule') === -1){
        		return LoadAllData(page, pageSize,option);
        	}
        	if(vm.requestGoing) return;
        	if(vm.onLoad == true){
        		if(typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] != 'undefined'){

        			var page1 =  $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
        			var pageSize1 = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'];
        			vm.onLoad = false;
        			return LoadAllData(page1, pageSize1,option);
        		}else{
        			vm.onLoad = false;
        			return LoadAllData(page, pageSize,option);		
        		}
        	}else{
        		if(typeof page == 'undefined' && typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] != 'undefined'){
        			page = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
        		}
        		return LoadAllData(page, pageSize,option);
        	}
        	
        }

        function LoadAllData(page, pageSize, option){
        	vm.requestGoing = true;
        	var pageDetail = {'currentPage':page,'pageSize':pageSize};
        	$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = pageDetail;

        	vm.page = page;
        	vm.pageSize = pageSize;
        	vm.selectedprodId = [];
        	var sort = {};
        	
        	for (var i = 0; i < option.columnSort.length; i++) {
        		if (option.columnSort[i]['sort']) {
        			sort['column'] = vm.UserColumns[i];
        			sort['order'] = option.columnSort[i]['sort'];
        		}
        	}
        	var offset = (page - 1) * pageSize;
        	var query = $scope.filterText ? $scope.filterText : '';
        	
        	var filterData = {
        		'offset': offset,
        		'pageSize': pageSize,
        		'search': $scope.filterText,
        		'sort': sort,
        		'get_organization': true,
        		'get_count': true,
        		'selectedHotel': $localStorage.hotels[$localStorage.selectedHotel].hotel_id
        	};

        	return $http({
        		url: EnvironmentConfig.api + 'RateCategory/rate_categories',
        		method: 'POST',
        		data: filterData
        	}).then(function(result) {
        		vm.requestGoing = false;
        		vm.categories = result.data['rateCategory'];
        		vm.totalCategories = result.data['totalCount'];
        		vm.totalUsers = result.data['totalCount'];
        		return {
        			results: result.data['rateCategory'],
        			totalResultCount: result.data['totalCount']
        		}
        	});
        }

        
        vm.showWarningToUser = function(type) {
        	if (type == 'edit' && vm.currentRatePlanStatus != vm.rateCategory.rate_plan_status && vm.currentRatePlanStatus == 1 && vm.planType == 'room') {
        		var statusName = vm.currentRatePlanStatus == 1 ? 'deactivated' : 'activated';
        		var html = "It may take up to 48 hours for the changes to propagate in all locations. <br/><br/>";
        		html += "<p style='font-size:13px;'>ALERT:- Rate plan will be "+statusName+" for all channels. Want to change it for particular channel go to <a target='_blank' href='channels'>Admin --> Rates -->Channels page. </a></p>";
        		$mdDialog.show({
				 	controller: 'confirmController',
				 	controllerAs: 'vm',
				 	templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
				 	parent: angular.element(document.body),
				 	targetEvent: event,
				 	clickOutsideToClose:true ,
				 	locals: {
				 		title: 'Rate plan mapping is being changed.',
				 		htmlContent:html,
				 		cancelBtn:'none',
				 		OkBtn:'Ok'
				 	}                
			 	}).then(function(answer) {
			 		if(typeof answer != 'undefined' && answer == 'update'){
			 			
			 		} else {
			 			vm.rateCategory.rate_plan_status = vm.currentRatePlanStatus;
			 		}
			 	}, function() {
			 		vm.rateCategory.rate_plan_status = vm.currentRatePlanStatus;
			 	}); 
        	}
        };

        /*vm.checkValueChanged = function() {
        	if (Pageheading == 'update') {
        		var tempData = JSON.parse(vm.rateCategoryBackup);
        		if (tempData.rate_plan_adjust_up_indicator != vm.rateCategory.rate_plan_adjust_up_indicator || tempData.rate_plan_derived_amount != vm.rateCategory.rate_plan_derived_amount || vm.originalPerDollar != vm.perOrDollar) {
        			vm.derivedRateChanged = true;
        		} else {
        			vm.derivedRateChanged = false;
        		}
        	}
        }

        vm.checkPercentValueChanged = function(value) {
        	vm.perOrDollar = value;
        	vm.checkValueChanged();
        }*/
        /*End*/
    }
})();


"use strict";

angular
  .module("app.rateCalendarLogs")
  .service("rateCalendarLogsService", function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
    function getDataComplete(response) {
      return response.data;
    }

    function getDataFailed(error) {
      return error.data;
    }

    function getRateCalendarLogs(params) {
      return $http({
        url: EnvironmentConfig.api + "RateCalenderLogs/getRateCalendarLogsByFilter",
        method: "POST",
        data: params,
      })
        .then(getDataComplete)
        .catch(getDataFailed);
    }

    function getRateCalendarLogById(logId, filters) {
      return $http({
        url: EnvironmentConfig.api + "RateCalenderLogs/getRateCalendarLogById/" + logId,
        method: "POST",
        data: filters
      })
        .then(getDataComplete)
        .catch(getDataFailed);
    }

    function getRateRoomChannelDetails() {
      return $http({
        url: EnvironmentConfig.api + "RateCalenderLogs/getRateRoomChannelDetails",
        method: "GET"
      })
        .then(getDataComplete)
        .catch(getDataFailed);
    }

    return {
      getRateCalendarLogs: getRateCalendarLogs,
      getRateCalendarLogById: getRateCalendarLogById,
      getRateRoomChannelDetails: getRateRoomChannelDetails
    };
  });

(function () {
  "use strict";

  angular
    .module("app.rateCalendarLogs")
    .controller("rateCalendarLogsController", rateCalendarLogsController);

  /** @ngInject */
  function rateCalendarLogsController(
    $mdDialog,
    $document,
    rateCalendarLogsService,
    rateRoomChannelData,
    $scope
  ) {
    var vm = this;

    vm.inventoryChangeFor = ["Rates", "Stop Sell", "CTA", "CTD", "Min Stay"];

    vm.rateCalendarLogsData = [];
    vm.ratePlans = [];
    vm.channels = [];
    vm.roomTypes = [];

    if (rateRoomChannelData && rateRoomChannelData.data) {
      vm.ratePlans = rateRoomChannelData.data.ratePlans;
      vm.channels = rateRoomChannelData.data.channels;
      vm.roomTypes = rateRoomChannelData.data.roomTypes;
    }

    var todayDate = new Date();

    vm.startDate = new Date(
      todayDate.getFullYear(),
      todayDate.getMonth(),
      todayDate.getDate() - 7
    );
    vm.endDate = new Date(
      todayDate.getFullYear(),
      todayDate.getMonth(),
      todayDate.getDate()
    );

    vm.requestProcessing = false;
    vm.requestInProgress = false;

    vm.ChangeEndDayIf = function () {
      if (!vm.startDate) return;

      if (
        !moment(vm.endDate).isAfter(vm.startDate) ||
        moment(vm.endDate).isSame(vm.startDate)
      ) {
        vm.endDate = moment(vm.startDate).add(0, "days").format("MM/DD/YYYY");
      }
    };

    vm.fetchLogDetailsById = function (logId) {
      if (vm.requestInProgress) return;

      vm.requestInProgress = true;
      rateCalendarLogsService
        .getRateCalendarLogById(logId, {
          roomTypes: vm.roomTypes,
          ratePlans: vm.ratePlans,
          channels: vm.channels,
          selected_rate_plans: vm.selectedRatePlans,
          selected_room_types: vm.selectedRoomTypes,
          selected_channels: vm.selectedChannels,
        })
        .then(function (response) {
          if (response.success) {
            vm.showLogsDetailPopup(response.data);
          }
          vm.requestInProgress = false;
        });
    };

    vm.showLogsDetailPopup = function (data) {
      $mdDialog.show({
        controller: "RateCalendarLogsDialogController",
        controllerAs: "vm",
        templateUrl:
          "app/main/apps/rateCalendarLogs/dialogs/rate-calender-logs-dialog.html",
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        locals: {
          logDetail: data,
        },
      });
    };

    vm.rateLogsColumns = [
      "change_for",
      "username",
      "start_date",
      "end_date",
      "updated_from",
      "created_date",
      "grand_total",
    ];

    var loadPageCallbackWithDebounce;
    function getRateLogsResultsCallback(loadPageCallback) {
      loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 100);
    }

    $scope.getRateLogsResultsCallback = getRateLogsResultsCallback;

    vm.refreshTable = function () {
      if (loadPageCallbackWithDebounce) {
        loadPageCallbackWithDebounce();
      }
    };

    vm.paginatorCallback = function (page, pageSize, options) {
      if (vm.requestProcessing) return;

      vm.requestProcessing = true;

      var sort = {};
      for (var i = 0; i < options.columnSort.length; i++) {
        if (options.columnSort[i]["sort"]) {
          sort["column"] = vm.rateLogsColumns[i];
          sort["order"] = options.columnSort[i]["sort"];
        }
      }

      var offset = (page - 1) * pageSize;
      var filterData = {
        offset: offset,
        pageSize: pageSize,
        sort: sort,
        start_date: vm.startDate
          ? moment(vm.startDate).format("YYYY-MM-DD")
          : "",
        end_date: vm.endDate ? moment(vm.endDate).format("YYYY-MM-DD") : "",
        rate_change_for: "rates",
        inventory_type: vm.inventoryChangesFor,
        selected_rate_plans: vm.selectedRatePlans,
        selected_room_types: vm.selectedRoomTypes,
        selected_channels: vm.selectedChannels,
      };

      return rateCalendarLogsService
        .getRateCalendarLogs(filterData)
        .then(function (response) {
          vm.requestProcessing = false;
          if (response.success) {
            return {
              results: response.data,
              totalResultCount: response.totalCount,
            };
          }
        });
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quickBook',
            [
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('external', {
            url    : 'https://sandbox.qbo.intuit.com',
            external:true,
   //          views  : {
   //              'content@app': {
   //                  templateUrl: 'app/main/apps/quickBook/quickBook.html',
   //                  controller : 'quickBookController as vm'
   //              }
   //          },
			//  resolve  : {
			// 	companyId: function (policyService){                    
			// 		return policyService.getMyCompanyId();				}
			// },
        });

    }

})();

(function() {
    'use strict';

    angular
        .module('app.quickBook')
        .controller('quickBookController', quickBookController);

    /** @ngInject */
    function quickBookController() {
        // window.location.href = "https://sandbox.qbo.intuit.com";
    }
})();

'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../category/categoryService
 * @description
 * # ../category/categoryService
 * Service in the minervaApp.
 */
angular.module('app.promotions')
  .service('promotionsService', function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
 	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}
 	
 	function getPromotionTypes(){
		return $http({
			url:EnvironmentConfig.api + 'Promotions/get_types',
			method:'POST'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	
 	function getRatePlans(data){
		return $http({
			url:EnvironmentConfig.api + 'Promotions/get_rate_plans',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	
 	function getRoomTypes(data){
		return $http({
			url:EnvironmentConfig.api + 'Promotions/get_room_types',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	
 	function getChannels(data){
		return $http({
			url:EnvironmentConfig.api + 'Promotions/get_associated_channels',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	
 	function getPromotion(data){
		return $http({
			url:EnvironmentConfig.api + 'Promotions/get_promotions_edit',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	
 	function getPromotionAssociatedRates(data){
		return $http({
			url:EnvironmentConfig.api + 'Promotions/get_promotions_rates',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	
 	function savePromotion(data){
		return $http({
			url:EnvironmentConfig.api + 'Promotions/save_promotion',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	
 	function deletePromotion(data){
		return $http({
			url:EnvironmentConfig.api + 'Promotions/delete_promotion',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	
 	function checkUniquePromoCode(data){
		return $http({
			url:EnvironmentConfig.api + 'Promotions/unique_promotion',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	
 	return{
		getPromotionTypes:getPromotionTypes,
		getRoomTypes :getRoomTypes,
		getChannels :getChannels,
		getRatePlans :getRatePlans,
		getPromotion :getPromotion,
		getPromotionAssociatedRates :getPromotionAssociatedRates,
		checkUniquePromoCode :checkUniquePromoCode,
		deletePromotion :deletePromotion,
		savePromotion :savePromotion
 	}
 });

(function ()
    {
      'use strict';

      angular
        .module('app.promotions')
        .controller('PromotionsController', PromotionsController);

      /** @ngInject */
      function PromotionsController(
      	$state, 
      	$scope, 
      	$mdDialog, 
      	$http, 
      	$localStorage, 
      	EnvironmentConfig, 
      	Types, 
      	promotionsService, 
      	commonService, 
    	$sessionStorage,
    	$rootScope,
    	$q)
      {
		  var vm = this;

			if(!$rootScope.backButtonPressed){
				$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = {};
				$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] = 1;
	        	$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'] = 50;
			}

		  vm.types = Types.types;
		  vm.isloading = false;
		  vm.addPoromotion=commonService.addPoromotion;
		  vm.userPermissions = $rootScope.userPermissions;
		  vm.isDeleteAllowed = false;
          if(vm.userPermissions.indexOf('delete_promotion')!=-1) vm.isDeleteAllowed = true;
		  /*Start*/
			$scope.paginatorCallback = paginatorCallback;
			$scope.LoadAllData = LoadAllData;
			$scope.getLoadResultsCallback = getLoadResultsCallback;
			$scope.statusValuesCallback = statusValuesCallback;
			$scope.statusValuesTransformer = statusValuesTransformer;
			$scope.defaultStatusFilter = {name: 'Active', fieldValue: 'promotion_status'};

			function statusValuesCallback(){
				return $q.resolve([
					{name: 'All', fieldValue: 'promotion_status'},
					$scope.defaultStatusFilter,
					{name: 'Inactive', fieldValue: 'promotion_status'}
				]);
			}
			function statusValuesTransformer(statusObject){
				return statusObject.name;
			}
			$scope.selectedRowCallback = function(rows){
			  vm.selectedPromotiomId = rows;
			};
			var loadPageCallbackWithDebounce;
			$scope.$watch('filterText', function(){
				if(loadPageCallbackWithDebounce){
					loadPageCallbackWithDebounce();  
				}
			});
			/**
			 * Delete Selected Users
			 */
			 $scope.deleteSelectedItem = function(ev){

				// new
              var html = 'Are you sure, you want to delete the selected promotion(s)? </br>';
              html = html + '<b>' + vm.selectedPromotiomId.length + ' promotion(s)</b>' + ' will be deleted.';
                
                  $mdDialog.show({
                                controller: 'confirmController',
                                controllerAs: 'vm',
                                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                                parent: angular.element(document.body),
                                targetEvent: event,
                                clickOutsideToClose:true ,
                                locals: {
                                      title: 'Delete Promotion',
                                      htmlContent:html,
                                      cancelBtn:'Cancel',
                                      OkBtn:'Ok'
                                  }                
                              })
                              .then(function(answer) {
                                 if(typeof answer != 'undefined' && answer == 'update'){
                                 vm.isloading = true;
									promotionsService.deletePromotion(vm.selectedPromotiomId).then(function(response){
										vm.isloading = false;
										if(response.errorMsg){
											toastMessage.showSimpleToast(response.errorMsg,'error-toast');
										}else{
											vm.selectedPromotiomId = [];
											//~ toastMessage.showSimpleToast('Templates(s) deleted successfully.','success-toast');
											loadPageCallbackWithDebounce();
										}
									});
				                       }
                              }, function() {}); 
            //Old
			}
			$scope.editmodel = function (ev, promotion_id)
			{
				if(vm.userPermissions.indexOf('update_promotion')!=-1){
					$state.go('app.promotion_edit',{"edit_promotion_id" : promotion_id});
				}
			}
			
			$scope.checkBox = function(value) {
				if (vm.selectedPromotiomId.indexOf(value) > -1 )
				{
				  vm.selectedPromotiomId.splice(vm.selectedPromotiomId.indexOf(value), 1);
			  }
			  else
			  {
				  vm.selectedPromotiomId.push(value);
			  }
			  if(vm.selectedPromotiomId.length > 0){
				  vm.getNumberOfSelectedRows = vm.selectedPromotiomId.length;
				  vm.checkDelete = true;
			  } else {
				  vm.checkDelete = false;
			  } 
			};
			function getLoadResultsCallback(loadPageCallback){
				loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
			}
			vm.UserColumns = ['promotion_name','promotion_code','promotion_discount','promotion_type','promotion_status','promotion_id'];


			vm.requestGoing = false;
			vm.onLoad = true;
			function paginatorCallback(page, pageSize,option){
				if(vm.requestGoing) return;
	        	if(vm.onLoad == true){
	        		if(typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] != 'undefined'){

	        			var page1 =  $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
	        			var pageSize1 = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'];
	  					vm.onLoad = false;
	        			return LoadAllData(page1, pageSize1,option);
	        		}else{
		        		vm.onLoad = false;
		        		return LoadAllData(page, pageSize,option);		
	        		}
	        	}else{
	        		if(typeof page == 'undefined'){
	        			page = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
	        		}
	        		return LoadAllData(page, pageSize,option);
	        	}
			}

			function LoadAllData(page, pageSize,option){

				vm.requestGoing = true;
				var pageDetail = {'currentPage':page,'pageSize':pageSize};
	        	$sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = pageDetail;
				if(!page){
					 page = vm.page;
				 } else {
					 vm.page = page;
				 }
				 vm.checkDelete = false;
				 vm.selectedPromotiomId = [];
				 var sort = {};
				 for(var i=0; i<option.columnSort.length; i++){
					if(option.columnSort[i]['sort']){
					  sort['column']= vm.UserColumns[i];
					  sort['order']= option.columnSort[i]['sort'];
				  }
				}
				var offset = (page-1) * pageSize;
				var query = $scope.filterText ? $scope.filterText : '';
				// status column filter: Active is pre-applied on load, nothing applied (after Clear) means all
				var statusFilter = option.columnFilter && option.columnFilter[3] && option.columnFilter[3].length ? option.columnFilter[3][0].name : 'All';
				var filterData = {'offset':offset , 'pageSize': pageSize, 'search':$scope.filterText, 'sort':sort, 'status': statusFilter == 'Active' ? 1 : (statusFilter == 'Inactive' ? 0 : ''), 'hotel_id':$localStorage.hotels[$localStorage.selectedHotel].hotel_id };
				return $http({
				  url: EnvironmentConfig.api+'Promotions/get_promotions',
				  method:'POST',
				  data:filterData
				}).then(function(result){
					vm.requestGoing = false;
				  vm.totalPromotions = result.data['totalPromotions'];
				  return {
					results: result.data['promotions'],
					totalResultCount: result.data['totalPromotions']
				}
				});
			}
			/*End*/
      }
})();

'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../category/categoryService
 * @description
 * # ../category/categoryService
 * Service in the minervaApp.
 */
 angular.module('app.policy')
 .service('policyService', function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
    function getDataComplete(response) {
    	return response.data;
    }

    function getDataFailed(error) {
    	return error.data;
    }

    function getDefaultPloicy(data){
    	return $http({
    		url:EnvironmentConfig.api+'Policy/policy',
    		method:'POST',
    		data:data
    	})
    	.then(getDataComplete)
    	.catch(getDataFailed);
    }
    function upDateHotelPolicy(data){
    	return $http({
    		url:EnvironmentConfig.api+'Policy/Update_hotel_policy',
    		method:'POST',
    		data:data
    	})
    	.then(getDataComplete)
    	.catch(getDataFailed);
    }
    function getFormData(data){
    	return $http({
    		url:EnvironmentConfig.api + 'Policy/skipAcl_getFormData',
    		method: 'POST',
    		data:data
    	})
    	.then(getDataComplete)
    	.catch(getDataFailed);
    }
    function updatePolicy(data){
    	return $http({
    		url:EnvironmentConfig.api + 'Policy/update_policy1',
    		method:'POST',
    		data:data
    	})
    	.then(getDataComplete)
    	.catch(getDataFailed);

    }
    function updatePropertyPolicy(data){
    	return $http({
    		url:EnvironmentConfig.api + 'Policy/skipAcl_updatePropertyPolicy',
    		method:'POST',
    		data:data
    	})
    	.then(getDataComplete)
    	.catch(getDataFailed);

    }
    function updateDepositPolicy(data){
    	return $http({
    		url:EnvironmentConfig.api + 'Policy/skipAcl_updateDepositPolicy',
    	method:'POST',
    	data:data
    })
 .then(getDataComplete)
 .catch(getDataFailed);

}
function deleteMultiplePolicy(data){
    return $http({
        url:EnvironmentConfig.api + 'Policy/skipAcl_deleteMultiplePolicy',
        method:'POST',
        data:data
    })
    .then(getDataComplete)
    .catch(getDataFailed);

}
function getMyCompanyId(){
	return $http({
		url:EnvironmentConfig.api + 'Policy/getMyCompanyId',
		method:'GET'
	})
	.then(getDataComplete)
	.catch(getDataFailed);

}
return{
	getDefaultPloicy: getDefaultPloicy,
	upDateHotelPolicy: upDateHotelPolicy,
	getFormData: getFormData,
	updatePolicy:updatePolicy,
	updatePropertyPolicy:updatePropertyPolicy,
	updateDepositPolicy:updateDepositPolicy,
    deleteMultiplePolicy:deleteMultiplePolicy,
	getMyCompanyId:getMyCompanyId
}
});

(function() {
    'use strict';

    angular
        .module('app.policy')
        .controller('PolicyController', PolicyController);

    /** @ngInject */
    function PolicyController($timeout, $state, $scope, $http, EnvironmentConfig, $mdDialog, toastMessage, $localStorage, $document, Policies, policyService) {
        var vm = this;
        vm.selectedTaxIds = {};

        vm.policies = Policies[0]['Policies'];
        vm.otherPolicies = Policies[0]['otherPolicies'];
        vm.depositPolicy = Policies[0]['depositPolicy'][0];
        vm.CancellationTime = Policies[0]['CancellationTime'];
        vm.cancellationCharge = Policies[0]['cancellationCharge'];
        vm.cancellationChargeifno = Policies[0]['cancellationCharge'];
        vm.taxes = Policies[0]['taxes'];
        vm.multipleNightPolicy = Policies[0]['multipleNightPolicy'];
        vm.multipleDeposit = Policies[0]['multipleNightPolicy'];
        vm.selectedDaysMultipleNights = [];
        vm.days = [];
        vm.months = [];
        vm.years = [];
        vm.autoFillOff =true ;
        vm.monthnames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        for(var i = 1;i<31;i++){
            vm.days.push(i);
        }
        for(var i = 1;i<12;i++){
            vm.months.push(i);
        }
        for(var i = 2018;i<2030;i++){
            vm.years.push(i);
        }
        Policies[0]['multipleNightPolicy'].forEach(function(element, index) {
            vm.selectedDaysMultipleNights.push(parseInt(element.for_upto_days));

        }, this);


        vm.numberName = {
            1:'first',
            2:'second',
            3:'third',
            4:'fourth',
            5:'fifth',
            6:'sixth',
            7:'seventh',
            8:'eight',
            9:'ninth',
            10:'tenth',
            11:'eleventh',
            12:'twelve-th',
            13:'thirteenth'
        };

        vm.taxNameValue = [];

        vm.taxes.forEach(function(element, index) {
            vm.taxNameValue[element.tax_id] = element;

        });
        vm.timeStatus = false;
        vm.guest_checkin_from = getTime(7, 20);
        vm.guest_checkin_to = getTime(12, 24);
        vm.guest_checkout_from = getTime(0, 14);
        vm.guest_checkout_to = getTime(7, 20);
        vm.convertFloat = convertFloat;
        vm.addMultipleExceptions = addMultipleExceptions;
        vm.deleteMultipleExceptions = deleteMultipleExceptions;

        function addMultipleExceptions(){
            vm.CustomPolicy.cancellation_charges_exceptions.push({});
        }
        function deleteMultipleExceptions(idx){
            vm.CustomPolicy.cancellation_charges_exceptions.splice(idx,1);
        }

        function convertFloat(inputVal) {
            if (inputVal == 'undefined' || inputVal == '' || inputVal == 0)
                inputVal = '';
            return parseFloat(inputVal);
        }

        var tempSelected = Policies[0]['selectdPolicies'];
        vm.selectedAllPolicies = Policies[0]['selectdPolicies'];
        vm.otherSelectdPolicies = Policies[0]['otherSelectdPolicies'];
        vm.childCategoryOptions = Policies[0]['childCategory'];


        Policies[0]['otherSelectdPolicies'].forEach(function(element, index) {
            if (element.policy_id == 7) {
                vm.DepositSelectdPolicies = element;
                vm.depositPol = element;
                vm.depositPol.pos_deposit_first_night = convertFloat(element['pos_deposit_first_night']);
                vm.depositPol.pos_deposit_amount = convertFloat(element['pos_deposit_amount']);
                vm.depositPol.pos_deposit_percentage = convertFloat(element['pos_deposit_percentage']);

                vm.depositPol.room_deposit_first_night = convertFloat(element['room_deposit_first_night']);
                vm.depositPol.room_deposit_amount = convertFloat(element['room_deposit_amount']);
                vm.depositPol.room_deposit_percentage = convertFloat(element['room_deposit_percentage']);
                vm.depositPol.room_deposit_tax_included_indicator = element['room_deposit_tax_included_indicator'] == 1 ?true:false;

            }

        }, this);
        vm.selecetdTax = '';


        policyService.getDefaultPloicy({
                            hotel_id: $localStorage.hotels[$localStorage.selectedHotel].hotel_id
                        })
                        .then(function(response) {
                            vm.selectedTaxIds = {};
                            vm.selectedTaxIds = response[0]['selectedTax'];
                            vm.depositPolicy = {};
                            vm.selecetdTax = '';
                            vm.depositPolicy = response[0]['depositPolicy'][0];
                            vm.taxes.forEach(function(element, index){
                                if(vm.selectedTaxIds.indexOf(element['tax_id']) != -1){
                                    vm.selecetdTax = vm.selecetdTax +','+element['tax_name'];
                                }
                            });
                            vm.selecetdTax = vm.selecetdTax.substr(1);
                        });

        var temp = vm.policies;
        vm.Selectedpolicies = [];
        vm.unSelectedpolicies = [];
        vm.cancellationMessage = "How much is the guest charged for cancellation?";
        vm.cancellationMessage1 = "";
        vm.cancellationMessages = {};
        var temp = vm.childCategoryOptions;
        vm.ageArray = [];
        temp.forEach(function(element, index) {
            vm.ageArray[element.age_qualifying_code] = element.age_qualifying_value;
        });

        // vm.cancellation_charges_exceptions_content = false; please confirm first

        if (Policies['pageStatus']) {
            if (Policies['pageStatus'] == 'add') {
                vm.pageStatus = Policies['pageStatus'];
            } else {
                policyService.getFormData({
                    policyType: 'cancellation',
                    policy_id: Policies['id'],
                    hotel_id: $localStorage.hotels[$localStorage.selectedHotel].hotel_id
                }).then(function(response) {
                    vm.CustomPolicy = response[0];
                    if(vm.CustomPolicy.cancellation_exception && Object.keys(vm.CustomPolicy.cancellation_charges_exceptions[0]).length > 0){
                        // vm.cancellation_charges_exceptions_content = true; please confirm first

                    }
                    changeMessage();
                })
            }
        }


        vm.allPoliciesId = [];
        vm.currentSelectedId = [];
        vm.selectedAllPolicies.forEach(function(element, index) {
            vm.currentSelectedId.push(element.policy_id);
        });



        vm.otherSelectdPolicies.forEach(function(element, index) {
            Policies[0]['otherPolicies'].forEach(function(otEle, otIndex) {
                if (element.policy_id == otEle.policy_id) {
                    if (element.policy_id == 5) {
                        vm.propertyData = element;
                        vm.propertyData.internet_price = parseFloat(element.internet_price);
                        vm.propertyData.parking_price = parseFloat(element.parking_price);
                        vm.propertyData.pet_price = parseFloat(element.pet_price);

                    }
                    if (element.policy_id == 4) {
                        vm.childData = {};
                        vm.tempExisting = 1;
                        if (Policies.policy_id == 4) {
                            vm.childData.Existing_bed = 1;
                            var intVal = parseInt(element.existing_extra_child_count_allowed);
                            if (intVal == 0) {
                                vm.tempExisting = 0;
                            }
                        }
                        vm.childData = element;
                        vm.childData.extra_bed_price_per_night_per_child = parseFloat(element.extra_bed_price_per_night_per_child);
                        vm.childData.extra_bed_price_per_night_per_adult = parseFloat(element.extra_bed_price_per_night_per_adult);
                        vm.childData.child_price_per_night = parseFloat(element.child_price_per_night);
                    }
                    if (element.policy_id == 6) {
                        vm.guestInfo = element;
                    }
                }
            });
            // }
        }, this);


        temp.forEach(function(element, index) {
            vm.allPoliciesId.push(element.policy_id);
            if (vm.currentSelectedId.indexOf(element.policy_id) != -1) {
                vm.Selectedpolicies.push(element);
            } else {
                vm.unSelectedpolicies.push(element);
            }

        }, this);


        vm.selectedHotelId = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
        vm.customadd = customadd;
        vm.normaladd = normaladd;
        vm.closeDialog = closeDialog;
        vm.saveCustomPolicy = saveCustomPolicy;
        vm.openPolicyPopup = openPolicyPopup;
        vm.changeMessage = changeMessage;
        vm.cancelPeriodStatus = cancelPeriodStatus;
        vm.updateCustomPolicy = updateCustomPolicy;
        vm.updateCustomPolicyData = updateCustomPolicyData;
        vm.updateOtherPolicy = updateOtherPolicy;
        vm.updatePropertyPolicy = updatePropertyPolicy;
        vm.updatePropertyPolicy2 = updatePropertyPolicy2;
        vm.updateChildPolicy = updateChildPolicy;
        vm.updateGuestInformationPolicy = updateGuestInformationPolicy;
        vm.getTime = getTime;
        vm.checkNumberValue = checkNumberValue;
        vm.numberErro = false;
        vm.updatePolicyList = updatePolicyList;

        vm.ErrorArray = [];

        function updatePolicyList() {
            policyService.getDefaultPloicy({
                hotel_id: $localStorage.hotels[$localStorage.selectedHotel].hotel_id
            }).then(function(response) {
                angular.extend(vm.otherPolicies, response[0]['otherPolicies']);
                angular.extend(vm.policies, response[0]['Policies']);
                angular.extend(vm.otherPolicies, response[0]['otherPolicies']);
                angular.extend(vm.depositPolicy, response[0]['depositPolicy'][0]);
                angular.extend(vm.multipleNightPolicy, response[0]['multipleNightPolicy']);

                angular.extend(vm.CancellationTime, response[0]['CancellationTime']);
                angular.extend(vm.cancellationCharge, response[0]['cancellationCharge']);
                angular.extend(vm.cancellationChargeifno, response[0]['cancellationCharge']);
                angular.extend(vm.taxes, response[0]['taxes']);
            });
        }

        function checkNumberValue(indexKey) {
            vm.numberErro = false;

            if (indexKey != 'room_deposit_first_night' && indexKey != 'pos_deposit_first_night' && typeof vm.depositPol[indexKey] != 'undefined') {
                if (isNaN(vm.depositPol[indexKey])) {
                    vm.numberErro = true;
                }
            }
        }

        function getTime(start, end) {
            var ab = [];
            for (var i = start; i <= end; i++) {
                ab.push(i + ":00");
                ab.push(i + ":30");
            }
            ab.pop();
            if (end == 24) {
                ab.pop();
                ab.push('00.00');
            }
            return ab;
        }


        function updateOtherPolicy(id, ev) {
            Policies['policy_id'] = id;
            var path = "app/main/apps/policy/propertyModal.html";
            if (id == 4) {
                path = "app/main/apps/policy/childModel.html";
            } else if (id == 6) {
                path = "app/main/apps/policy/guestInformation.html";
            } else if (id == 7) {
                path = "app/main/apps/policy/depositModal.html";
            }

            $mdDialog.show({
                controller: 'PolicyController',
                controllerAs: 'vm',
                templateUrl: path,
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                locals: {
                    Policies: Policies
                },
                onRemoving: function(event, removePromise) {
                    policyService.getDefaultPloicy({
                            hotel_id: $localStorage.hotels[$localStorage.selectedHotel].hotel_id
                        })
                        .then(function(response) {
                          

                            vm.otherPolicies = {};
                            vm.otherSelectdPolicies = {};
                            vm.DepositSelectdPolicies = {};
                            vm.selectedTaxIds = {};
                            angular.extend(vm.otherPolicies, response[0]['otherPolicies']);
                            angular.extend(vm.otherSelectdPolicies, response[0]['otherSelectdPolicies']);
                            angular.extend(vm.DepositSelectdPolicies, response[0]['otherSelectdPolicies'][3]);                            
                            angular.extend(vm.selectedTaxIds,  response[0]['selectedTax']);


                             vm.selectedTaxIds = {};
                             vm.selecetdTax = '';
                             vm.selectedTaxIds = response[0]['selectedTax'];
                             vm.taxes.forEach(function(element, index){
                                if(vm.selectedTaxIds.indexOf(element['tax_id']) != -1){
                                    vm.selecetdTax = vm.selecetdTax +','+element['tax_name'];
                                }
                             });
                             vm.selecetdTax = vm.selecetdTax.substr(1);

                             angular.extend(vm.selecetdTax,  vm.selecetdTax);
                        });
                        if(vm.deleteStatusOfMultipleNight){
                            vm.deleteDataOfMultipleNight.forEach(function(element, index){
                                var idPresent = false;
                                vm.multipleDeposit.forEach(function(multipleElement, multipleIndex){
                                    if(multipleElement['id'] == element['id']){
                                        idPresent = true;
                                    } else {
                                        idPresent = false;
                                    }
                                });
                                if(!idPresent){
                                    vm.multipleDeposit.push(vm.deleteDataOfMultipleNight[index]);
                                }
                            });
                            var tempVar = angular.copy(vm.multipleDeposit);
                            tempVar.forEach(function(element, index){
                               if(element['for_upto_days'] == '' || element['room_deposit_type_indicator'] == '' || typeof element['room_deposit_which_night'] == 'undefined'){
                                vm.multipleDeposit.splice(index, 1);
                               }
                            });
                        }
                }
            });
        }

        

        function updatePropertyPolicy2() {

            if (vm.depositPol.room_deposit_type_indicator == 'first-night') {
                vm.depositPol.room_deposit_first_night = 1;
            }
            if (vm.depositPol.pos_deposit_type_indicator == 'first-night') {
                vm.depositPol.pos_deposit_first_night = 1;
            }
           
            if(vm.depositPol.room_deposit_type_indicator == 'amt' || vm.depositPol.room_deposit_type_indicator == 'perc' ){
                vm.selectedTaxIds = [];
                vm.depositPol.room_deposit_tax_included_indicator = vm.depositPol.room_deposit_tax_included_indicator?1:0;
            }
             var data = {
                depositPolicy: vm.depositPol,
                multipleDepositPolicy:vm.multipleDeposit,
                taxData:vm.selectedTaxIds
            }

            vm.depositPol['policy_id'] = Policies['policy_id'];
            policyService.updateDepositPolicy(data)
                .then(function(response) {
                    if (response) {
                        policyService.getDefaultPloicy({
                                hotel_id: $localStorage.hotels[$localStorage.selectedHotel].hotel_id
                            })
                            .then(function(response) {
                                vm.otherPolicies = {};
                            vm.otherSelectdPolicies = {};
                            vm.DepositSelectdPolicies = {};
                                angular.extend(vm.otherPolicies, response[0]['otherPolicies']);
                                angular.extend(vm.otherSelectdPolicies, response[0]['otherSelectdPolicies']);
                                angular.extend(vm.DepositSelectdPolicies, response[0]['otherSelectdPolicies'][3]);
                            });

                        $mdDialog.hide();
                    } else {
                        toastMessage.showSimpleToast('Some error occured. Please try again.', 'error-toast');
                    }
                });

                if(vm.deleteStatusOfMultipleNight){
                     policyService.deleteMultiplePolicy(vm.deleteIdOfMultipleNight).then(function(response) {
                        $scope.$parent.updateVariable([],false);
                    });
                }
        }

        function updatePropertyPolicy() {
            vm.propertyData['hotel_id'] = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
            vm.propertyData['policy_id'] = Policies['policy_id'];
            if (vm.propertyData.pet_price_type == 'free') {
                vm.propertyData.pet_price = 0;
            }
            policyService.updatePropertyPolicy(vm.propertyData)
                .then(function(response) {
                    if (response) {

                        policyService.getDefaultPloicy({
                                hotel_id: $localStorage.hotels[$localStorage.selectedHotel].hotel_id
                            })
                            .then(function(response) {
                                // vm.policies = response[0]['Policies'];
                                angular.extend(vm.otherPolicies, response[0]['otherPolicies']);
                                angular.extend(vm.otherSelectdPolicies, response[0]['otherSelectdPolicies']);

                            });
                        $mdDialog.hide();
                    } else {
                        toastMessage.showSimpleToast('Some error occured. Please try again.', 'error-toast');
                    }
                });

        }

        function updateCustomPolicyData() {
            policyService.updatePolicy(vm.CustomPolicy)
                .then(function(response) {
                    if (response) {
                        $mdDialog.hide();
                    } else {
                        toastMessage.showSimpleToast('Some error occured. Please try again.', 'error-toast');
                    }
                })

        }

        function updateChildPolicy() {
            var temp = vm.childData.Existing_bed;
            if (!vm.extraAdult) {
                vm.childData.extra_bed_price_per_night_per_adult = 0
            }
            if (!vm.extraChild) {
                vm.childData.extra_bed_price_per_night_per_child = 0;
            }
            if (vm.childData.is_child_allowed == 0) {
                vm.childData.child_price_per_night = 0;
                vm.childData.existing_extra_child_count_allowed = 0;
                vm.childData.child_age = 0;
                vm.extra_bed_price_per_night_per_child = 0;

            }
            if (vm.childData.Existing_bed == 0) {
                vm.childData.existing_extra_child_count_allowed = 0;
                vm.childData.child_price_per_night = 0;
                delete vm.childData['Existing_bed'];
            } else {
                delete vm.childData['Existing_bed'];
            }
            vm.childData['hotel_id'] = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
            vm.childData['policy_id'] = Policies['policy_id'];

            policyService.updatePropertyPolicy(vm.childData)
                .then(function(response) {
                    vm.childData.Existing_bed = temp;
                    if (response) {
                        policyService.getDefaultPloicy({
                                hotel_id: $localStorage.hotels[$localStorage.selectedHotel].hotel_id
                            })
                            .then(function(response) {
                                angular.extend(vm.otherPolicies, response[0]['otherPolicies']);
                                angular.extend(vm.otherSelectdPolicies, response[0]['otherSelectdPolicies']);

                            });

                        $mdDialog.hide();
                    } else {
                        toastMessage.showSimpleToast('Some error occured. Please try again.', 'error-toast');
                    }
                });

        }

        function updateGuestInformationPolicy() {
            var msg = "";
            if (typeof vm.guestInfo.guest_checkin_from == 'undefined' && typeof vm.guestInfo.guest_checkin_to == 'undefined') {
                vm.timeStatus = true;
                msg = "Please select check in time";
            } else if (typeof vm.guestInfo.guest_checkout_from == 'undefined' && typeof vm.guestInfo.guest_checkout_to == 'undefined') {
                vm.timeStatus = true;
                msg = "Please select check out time";

            }
            if (!vm.timeStatus) {
                vm.guestInfo['hotel_id'] = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
                vm.guestInfo['policy_id'] = Policies['policy_id'];
                policyService.updatePropertyPolicy(vm.guestInfo)
                    .then(function(response) {
                        if (response) {
                            policyService.getDefaultPloicy({
                                    hotel_id: $localStorage.hotels[$localStorage.selectedHotel].hotel_id
                                })
                                .then(function(response) {
                                    angular.extend(vm.otherPolicies, response[0]['otherPolicies']);
                                    angular.extend(vm.otherSelectdPolicies, response[0]['otherSelectdPolicies']);

                                });

                            $mdDialog.hide();
                        } else {
                            toastMessage.showSimpleToast('Some error occured. Please try again.', 'error-toast');
                        }
                    });
            } else {
                toastMessage.showSimpleToast(msg, 'error-toast');
            }
        }


        function updateCustomPolicy(id, ev) {
            if (id) {
                Policies['id'] = id;
                Policies['pageStatus'] = 'update';
                $mdDialog.show({
                    controller: 'PolicyController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/policy/dialog/policyModel.html',
                    parent: angular.element($document.find('#content-container')),
                    targetEvent: ev,
                    scope: $scope.$new(),
                    clickOutsideToClose: true,
                    locals: {
                        Policies: Policies
                    }
                });
            }

        }


        function cancelPeriodStatus(value) {
            if (value == 0) {
                vm.cancellationMessage1 = vm.cancellationMessage;
                vm.cancellationMessage = "Please select..";
            } else if (value == 1) {
                vm.cancellationMessage = vm.cancellationMessage1;
            }
        }


        function changeMessage(idx) {
            var message = "How much is the guest charged for cancellation";
            if(typeof idx == 'undefined')
                var Part2 = vm.CancellationTime[vm.CustomPolicy.days_free_cancellation].replace("until", '');
            else
                var Part2 = vm.CancellationTime[vm.CustomPolicy.cancellation_charges_exceptions[idx].days_free_cancellation].replace("until", '');
            if (vm.CustomPolicy.days_free_cancellation > 2) {
                message = message + Part2 + '?';
            } else {
                if (vm.CustomPolicy.if_cancelled_period == 1) {
                    message = message + ' after ' + Part2 + '?';
                } else {
                    message = message + ' before ' + Part2 + '?';
                }
            }
            if (vm.CustomPolicy.if_cancelled_period == 1) {
                vm.cancellationMessage = message;
            } else if(typeof idx != 'undefined') {
                vm.cancellationMessages[idx] = message;
            } else {
                vm.cancellationMessage1 = message;
            }
        }

        $scope.checkfun = function(param) {
            vm.currentSelectedId.push(param[0]);
        }

        // function to add policy modal
        function openPolicyPopup(ev) {
            $mdDialog.show({
                contentElement: '#myDialog',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        }

        function normaladd(id, ev) {
            var status = 'add';
            var index = vm.currentSelectedId.indexOf(id);
            if (index == -1) {
                vm.currentSelectedId.push(id);
                var data = {
                    hotel_id: vm.selectedHotelId,
                    policy_id: id,
                    status: status
                };
                policyService.upDateHotelPolicy(data).then(function(response) {});
                if (vm.currentSelectedId.length == 3) {
                    $mdDialog.hide();
                }
            } else {
                 // new
            var html = 'Are you sure, you want to delete the selected policy?</br>';
            html = html + 'Please confirm to proceed.'

                $mdDialog.show({
                              controller: 'confirmController',
                              controllerAs: 'vm',
                              templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                              parent: angular.element(document.body),
                              targetEvent: event,
                              clickOutsideToClose:true ,
                              locals: {
                                    title: 'Delete Policy',
                                    htmlContent:html,
                                    cancelBtn:'Cancel',
                                    OkBtn:'Ok'
                                }
                            })
                            .then(function(answer) {
                               if(typeof answer != 'undefined' && answer == 'update'){
                              vm.currentSelectedId.splice(index, 1);
                                var status = 'delete';
                                var data = {
                                    hotel_id: vm.selectedHotelId,
                                    policy_id: id,
                                    status: status
                                };
                                policyService.upDateHotelPolicy(data).then(function(response) {
                                    // vm.currentSelectedId.splice(index, 1);
                                });
                                if (vm.currentSelectedId.length == 3) {
                                    $mdDialog.hide();
                                }
                               }
                            }, function() {});
            }
        }

        function closeDialog() {
            $mdDialog.hide();
            if(vm.deleteStatusOfMultipleNight){
                vm.deleteDataOfMultipleNight.forEach(function(element, index){
                    var idPresent = false;
                    vm.multipleDeposit.forEach(function(multipleElement, multipleIndex){
                        if(multipleElement['id'] == element['id']){
                            idPresent = true;
                        } else {
                            idPresent = false;
                        }
                    });
                    if(!idPresent){
                        vm.multipleDeposit.push(vm.deleteDataOfMultipleNight[index]);
                    }
                });
                var tempVar = angular.copy(vm.multipleDeposit);
                tempVar.forEach(function(element, index){
                   if(element['for_upto_days'] == '' || element['room_deposit_type_indicator'] == '' || typeof element['room_deposit_which_night'] == 'undefined'){
                    vm.multipleDeposit.splice(index, 1);
                   }
                });
            }
        }

        function customadd(id, ev) {

            var index = vm.currentSelectedId.indexOf(id);
            if (index == -1) {
                Policies['id'] = id;
                Policies['pageStatus'] = 'add';
                $mdDialog.show({
                    controller: 'PolicyController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/policy/dialog/policyModel.html',
                    parent: angular.element($document.find('#content-container')),
                    targetEvent: ev,
                    scope: $scope.$new(),
                    clickOutsideToClose: true,
                    locals: {
                        Policies: Policies
                    }
                });
            } else {
                var confirm = $mdDialog.confirm()
                    .title('Are you sure, you want to delete the selected policy?')
                    .htmlContent('Please confirm to proceed.')
                    .ariaLabel('delete contacts')
                    .targetEvent(ev)
                    .ok('OK')
                    .cancel('CANCEL');

                $mdDialog.show(confirm).then(function() {
                    var data = {
                        hotel_id: vm.selectedHotelId,
                        policy_id: id,
                        status: 'delete'
                    };
                    vm.currentSelectedId.splice(index, 1);
                    policyService.upDateHotelPolicy(data).then(function(response) {});
                });
            }


        }

        function saveCustomPolicy() {
            vm.currentSelectedId.push(Policies['id']);
            vm.CustomPolicy['hotel_id'] = vm.selectedHotelId;
            vm.CustomPolicy['policy_id'] = Policies['id'];
            vm.CustomPolicy['status'] = 'add';
            policyService.upDateHotelPolicy(vm.CustomPolicy).then(function(response) {
                $mdDialog.hide();
            });
            $scope.$parent.checkfun(Policies['id']);
        }
        if(vm.multipleDeposit.length == 0){
            vm.multipleDeposit.push({'id':'currentItem','for_upto_days':'', 'room_deposit_type_indicator':'', 'amount':'', 'room_deposit_amount':'','room_deposit_percentage':''});
            vm.multipleDeposit.push({'id':'currentItem','for_upto_days':'', 'room_deposit_type_indicator':'', 'amount':'', 'room_deposit_amount':'','room_deposit_percentage':''});
        }
        vm.addMultipleRoomDepositPolicy = addMultipleRoomDepositPolicy;
        function addMultipleRoomDepositPolicy(){
            if(vm.multipleDeposit.length > 0&& (vm.multipleDeposit[vm.multipleDeposit.length-1]['for_upto_days'] == '' || vm.multipleDeposit[vm.multipleDeposit.length-1]['room_deposit_type_indicator'] == '')){

            }else {
                vm.multipleDeposit.push({'id':'currentItem','for_upto_days':'', 'room_deposit_type_indicator':'', 'amount':'', 'room_deposit_amount':'','room_deposit_percentage':''});
            }
        }
        $scope.updateVariable = function(data, status) {
            vm.deleteDataOfMultipleNight = data;
            vm.deleteStatusOfMultipleNight = status;
        }
        vm.deleteThisNightPlan = deleteThisNightPlan;
        vm.deleteStatusOfMultipleNight = false;
        vm.deleteDataOfMultipleNight = [];
        vm.deleteIdOfMultipleNight = [];
        function deleteThisNightPlan(index, multiplePolicyId){
            var lIndex = vm.selectedDaysMultipleNights.indexOf(parseInt(vm.multipleDeposit[index]['for_upto_days']));

            vm.selectedDaysMultipleNights.splice(lIndex, 1);
            if(multiplePolicyId != 'currentItem'){
                vm.deleteDataOfMultipleNight.push(vm.multipleDeposit[index]);
                vm.deleteIdOfMultipleNight.push(vm.multipleDeposit[index]['id']);
                vm.multipleDeposit.splice(index, 1);
                vm.deleteStatusOfMultipleNight = true;
                $scope.$parent.updateVariable(vm.deleteDataOfMultipleNight,vm.deleteStatusOfMultipleNight);


                // policyService.deleteMultiplePolicy({id:multiplePolicyId}).then(function(response) {
                //     vm.multipleDeposit.splice(index, 1);
                // });

            } else{
                vm.multipleDeposit.splice(index, 1);
            }

        }

        vm.updateselectedDaysMultipleNights = updateselectedDaysMultipleNights;
        vm.preVal = 0;
        vm.preKey = -1;
        function updateselectedDaysMultipleNights(index){
            vm.selectedDaysMultipleNights = [];
            vm.multipleDeposit.forEach(function(element, index) {
                vm.selectedDaysMultipleNights.push(parseInt(element.for_upto_days));
            }, this);
        }
        vm.checkValidation = checkValidation;
        function checkValidation(){
            var status = false;
            vm.multipleDeposit.forEach(function(element, index) {
                if(vm.multipleDeposit[index]['for_upto_days'] == '' || vm.multipleDeposit[index]['room_deposit_type_indicator'] == '' ){
                    status = true;
                } else {
                    status =  false;
                }

                     if(vm.multipleDeposit[index]['room_deposit_type_indicator'] == 'night-rate'){
                        if(typeof vm.multipleDeposit[index]['room_deposit_which_night'] != 'undefined' && vm.multipleDeposit[index]['room_deposit_which_night'] > 0){
                             status = false;
                        }else{
                             status = true;
                        }                   
                    }else if(vm.multipleDeposit[index]['room_deposit_type_indicator'] == 'amt'){
                        if(typeof vm.multipleDeposit[index]['room_deposit_amount'] != 'undefined' && vm.multipleDeposit[index]['room_deposit_amount'] > 0){
                             status = false;
                        }else{
                             status = true;

                        }                   
                    }else if(vm.multipleDeposit[index]['room_deposit_type_indicator'] == 'amt-for-all-night'){
                        if(typeof vm.multipleDeposit[index]['room_deposit_amount'] != 'undefined' && vm.multipleDeposit[index]['room_deposit_amount'] > 0){
                             status = false;
                        }else{

                             status = true;
                        }                   
                    }else if(vm.multipleDeposit[index]['room_deposit_type_indicator'] == 'perc'){
                        if(typeof vm.multipleDeposit[index]['room_deposit_percentage'] != 'undefined' && vm.multipleDeposit[index]['room_deposit_percentage'] > 0){
                             status = false;
                        }else{
                             status = true;
                        }                   
                    }else if(vm.multipleDeposit[index]['room_deposit_type_indicator'] == 'perc-for-all-night'){
                        if(typeof vm.multipleDeposit[index]['room_deposit_percentage'] != 'undefined' && vm.multipleDeposit[index]['room_deposit_percentage'] > 0){
                             status = false;
                        }else{
                             status = true;
                        }                   
                    }
                    if(status){
                        return status;
                    }

            }, this);
            return status;
        }

        setTimeout(function() {
           vm.autoFillOff = false;
        }, 1500); 
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.mls',
            [
                // 3rd Party Dependencies
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.mls', {
            url    : '/mls',
            title : 'Minimun Length Stay',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/mls/mls.html',
                    controller : 'mlsController as vm'
                }
            },
            params:      {showaddDialog:''},
                 resolve  : {
                    mls: function (){
                        return [];
                    },
                    callingController : function (){
						return 'frommodule';
					},
                    mlsType:function (){
                        return 'room';
                    }
                },
                permission: 'restrictions'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/mls');

    }

})();

'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../mls/mlsService
 * @description
 * # ../mls/mlsService
 * Service in the minervaApp.
 */
angular.module('app.mls')
  .service('mlsService', function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
 	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}
 	
 	function saveMls(data){
		return $http({
			url:EnvironmentConfig.api+'Mls/add_mls',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function deleteMls(deleteIds){
		return $http({
			url:EnvironmentConfig.api+'Mls/delete_mls',
			method:'POST',
			data:deleteIds
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getsingleMlsData(id){
		return $http({
			url:EnvironmentConfig.api + 'Mls/skipAcl_getSingleMls',
			method:'POST',
			data: id

		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function UpdateMls(mlsData){
		return $http({
			url:EnvironmentConfig.api + 'Mls/update_mls',
			method:'POST',
			data: mlsData

		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getAllMls(request){
		return $http({
			url:EnvironmentConfig.api + 'Mls/minimum_length_stay',
			method:'POST',
			data: request

		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	
 	return{
 		saveMls: saveMls,
		 deleteMls:deleteMls,
		 getsingleMlsData:getsingleMlsData,
		 UpdateMls:UpdateMls,
		 getAllMls:getAllMls
 	}
 });

      (function ()
      {
        'use strict';

        angular
          .module('app.mls')
          .controller('mlsController', mlsController);

        /** @ngInject */
        function mlsController(
          $state, 
          $scope, 
          $http, 
          EnvironmentConfig, 
          $mdDialog, 
          toastMessage, 
          $localStorage, 
          $document,
          mls, 
          rateCategoryService, 
          mlsService,
          $stateParams,
          mlsType,
          $timeout,
          callingController, 
          $sessionStorage,
          $rootScope
          )
        {
          var vm = this;

          vm.showMultiplePropertes = false;

          if(!$rootScope.backButtonPressed){
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = {};
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] = 1;
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'] = 50;
          }

          vm.gotoAddMls = gotoAddMls;
          vm.closeDialog = closeDialog;
          vm.validateDayCount = validateDayCount;

          /*New Variable*/
          vm.restriction = mlsType;
          
          vm.saveMls = saveMls;
          vm.mls_data = [];
          vm.convert = convert;
          vm.updateMls = updateMls;
          vm.minDayCountStatus = false;
          vm.pageStatus = 'add';
          vm.userPermissions = $rootScope.userPermissions;
          if(vm.userPermissions.indexOf('delete_restriction') != -1){
            vm.delete_product=true;
          }else{
            vm.delete_product=false;
          }
          if(mls == ''){
          } else {
            
             mlsService.getsingleMlsData({id:mls}).then(function(response){
               vm.mls = response['mls'][0];
               vm.mls.mls_from = new Date(moment(vm.mls.mls_from).format('MM/DD/YYYY'));
			   vm.mls.mls_to = new Date(moment(vm.mls.mls_to).format('MM/DD/YYYY'));
               vm.mls['mls_days'] = parseInt(response['mls'][0]['mls_days']);
               vm.pageStatus = 'edit';
            });

          }
		  if($stateParams.showaddDialog==true && callingController!='dialog'){
			  $timeout(function ()
			  {
				 vm.gotoAddMls();
			  });
		  }
          $scope.goToEditPage = function(id,ev){
			  if(vm.userPermissions.indexOf('update_restriction') != -1){
				$mdDialog.show({
                    controller         : 'mlsController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/apps/mls/dialog/mlsModel.html',
                    parent             : angular.element($document.find('#content-container')),
                    targetEvent        : ev,                    
                    scope              : $scope.$new(),
                    clickOutsideToClose: true,
                    locals             : {
            						mls: id,
            						callingController: 'dialog',
                        mlsType: vm.restriction
                    }
                });
			 }
          }

          vm.myDate = new Date();

          vm.minDate = new Date(
            this.myDate.getFullYear(),
            this.myDate.getMonth(),
            this.myDate.getDate()
          );
          vm.minDateForEndDate = new Date(
            this.myDate.getFullYear(),
            this.myDate.getMonth(),
            this.myDate.getDate() + 1
          );
          function validateDayCount(){
           var date1 = new Date(convert(vm.mls.mls_from));
           var date2 = new Date(convert(vm.mls.mls_to));
           var diffDays = Math.floor(( Date.parse(date2) - Date.parse(date1) ) / 86400000); 
          //  if(diffDays <= 0){
          //    vm.dayCountErrorMsg = "Start date must be less than end date.";
          //     vm.minDayCountStatus = true;
          //  }
          //  else if(diffDays < vm.mls.mls_days){
          //    vm.minDayCountStatus = true;
          //    vm.dayCountErrorMsg = "Days Count must be less";
          //  } 
          //  else {
          //    vm.dayCountErrorMsg = "";
          //    vm.minDayCountStatus = false;
             
          //  }
           
          }
          vm.requestProgressing = false;
          function saveMls(){
            vm.requestProgressing = true;
            vm.mls.mls_from = moment(vm.mls.mls_from).format('MM/DD/YYYY');
            vm.mls.mls_to = moment(vm.mls.mls_to).format('MM/DD/YYYY');
            vm.mls.mls_for = vm.restriction;

             
            mlsService.saveMls(vm.mls).then(function(response){
              if(response.status){
               $scope.$parent.updateTable();
                    closeDialog();
                }else{
                  toastMessage.showSimpleToast(response.errMsg,'error-toast');
                }
                vm.requestProgressing = false;
            })

          }
          function updateMls(){
            vm.requestProgressing = true;
            vm.mls.mls_from = moment(vm.mls.mls_from).format('MM/DD/YYYY');
            vm.mls.mls_to = moment(vm.mls.mls_to).format('MM/DD/YYYY');
            mlsService.UpdateMls(vm.mls).then(function(response){
               if(response.status){
                $scope.$parent.updateTable();
                    closeDialog();
                }else{
                  toastMessage.showSimpleToast(response.errMsg,'error-toast');
                }
                vm.requestProgressing = false;
            })

          }

          function convert(str) {
              var date = new Date(str),
                  mnth = ("0" + (date.getMonth()+1)).slice(-2),
                  day  = ("0" + date.getDate()).slice(-2);
              return [ date.getFullYear(), mnth, day ].join("-");
          }

         
          
          
          function closeDialog()
            {
              $mdDialog.hide();
            }

          function gotoAddMls(ev){
              $mdDialog.show({
                    controller         : 'mlsController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/apps/mls/dialog/mlsModel.html',
                    parent             : angular.element($document.find('#content-container')),
                    targetEvent        : ev,                    
                    scope              : $scope.$new(),
                    clickOutsideToClose: true,
                    locals             : {
                        mls:[],
                        callingController: 'dialog',
                        mlsType: vm.restriction
                    }
                });
          }
              /*Start*/
            $scope.paginatorCallback = paginatorCallback;
            $scope.LoadAllData = LoadAllData;
            $scope.getLoadResultsCallback = getLoadResultsCallback;
            $scope.selectedRowCallback = function(rows){
              vm.selectedprodId = rows;
              vm.checkDelete = false;
            };
            var loadPageCallbackWithDebounce;
            $scope.$watch('filterText', function(){
            if(loadPageCallbackWithDebounce){
              loadPageCallbackWithDebounce();  
            }
            });
            $scope.showTabDialog = function(ev, id) {
            roleService.getRolePermissions(id).then(function(response){
            if(response.listData.length ==0){
              toastMessage.showSimpleToast('This role has no module assigned.','error-toast');
            } else {
              $state.go('app.rolesPermission',{id:id});
             

            }
            });
          };
          $scope.userPermissions = vm.userPermissions;
          $scope.updateTable= function() {
            loadPageCallbackWithDebounce();
          };

          $scope.toggleAll = function() {
            var toggleStatus = !$scope.isAllSelected;
            $scope.ChangeAll = toggleStatus;
          }
          $scope.checkBox = function(value) {
                  if (vm.selectedprodId.indexOf(value) > -1 )
                  {
                    vm.selectedprodId.splice(vm.selectedprodId.indexOf(value), 1);
                  }
                  else
                  {
                    vm.selectedprodId.push(value);
                  }
                  if(vm.selectedprodId.length > 0){
                    vm.getNumberOfSelectedRows = vm.selectedprodId.length;
                    vm.checkDelete = true;
                  } else {
                    vm.checkDelete = false;
                  } 
                };
          $scope.deleteSelectedItem = function(ev, selectedprodId){
            
                // new
              var html = 'Are you sure, you want to delete the selected minimum length stay? </br>';
              html = html + '<b>' + vm.selectedprodId.length + ' minimum length stay</b>' + ' will be deleted.';
                
                  $mdDialog.show({
                                controller: 'confirmController',
                                controllerAs: 'vm',
                                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                                parent: angular.element(document.body),
                                targetEvent: event,
                                clickOutsideToClose:true ,
                                locals: {
                                      title: 'Delete MLS',
                                      htmlContent:html,
                                      cancelBtn:'Cancel',
                                      OkBtn:'Ok'
                                  }                
                              })
                              .then(function(answer) {
                                 if(typeof answer != 'undefined' && answer == 'update'){
                               var myObj = {deleteIds:vm.selectedprodId};
                                mlsService.deleteMls(myObj).then(function(response){
                                    if(!response.status){
                                        toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                                    }else{
                                        loadPageCallbackWithDebounce();  
                                        vm.selectedprodId = [];
                                    }
                                });
                               }
                              }, function() {}); 
            //Old
            };
          function getLoadResultsCallback(loadPageCallback){
            loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
          }
          vm.UserColumns = [
                'mls_to',
                'mls_from',
                'mls_days',
                'mls_id'
              ];

              vm.onLoad = true;
              vm.requestGoing = false;

          function paginatorCallback(page, pageSize,option){

            if(vm.requestGoing) return;
            if(vm.onLoad == true){
              if(typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] != 'undefined'){

                var page1 =  $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
                var pageSize1 = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'];
              vm.onLoad = false;
                return LoadAllData(page1, pageSize1,option);
              }else{
                vm.onLoad = false;
                return LoadAllData(page, pageSize,option);    
              }
            }else{
              if(typeof page == 'undefined'){
                page = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
              }
              return LoadAllData(page, pageSize,option);
            }
            
            
            }
            vm.columnSort = [];

            function LoadAllData(page, pageSize,option){
              console.log('option',option);
              vm.columnSort = option;

              vm.requestGoing = true;
              var pageDetail = {'currentPage':page,'pageSize':pageSize};
             $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = pageDetail;


              vm.page     = page;
            vm.pageSize   = pageSize;
            vm.selectedprodId = [];
            var sort    = {};

            for(var i=0; i < option.columnSort.length; i++){

            if(option.columnSort[i]['sort']){
              sort['column']= vm.UserColumns[i];
              sort['order']= option.columnSort[i]['sort'];
            }
            }
            var offset = (page-1) * pageSize;
            var query = $scope.filterText ? $scope.filterText : '';


            var filterData = {
                                'offset':offset , 
                                'pageSize': pageSize, 
                                'search':$scope.filterText , 
                                'sort':sort, 
                                'get_organization': true, 
                                'get_count': true, 
                                'requestFor': vm.restriction, 
                                'selectedHotel':$localStorage.hotels[$localStorage.selectedHotel].hotel_id
                              };


            return $http({
              url: EnvironmentConfig.api+'Mls/minimum_length_stay',
              method:'POST',
              data:filterData
            }).then(function(result){  

              vm.requestGoing = false;

              vm.totalUsers = result.data['count'];
              vm.showMultiplePropertes = result.data['showMultiplePropertes'];
              return {
              results: result.data['mls'],
              totalResultCount:result.data['count']
              }
            });
            }


            vm.fetchRestrictionType = function(){
              loadPageCallbackWithDebounce();
            }

            /*End*/


          
        }
      })();

(function ()
{
    'use strict';

    angular
        .module('app.groups',
            [
                // 3rd Party Dependencies
                'xeditable',
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.groups', {
            url    : '/groups',
            title  : 'Groups',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/groups/groups.html',
                    controller : 'groups as vm'
                }
            },
             resolve  : {
                Users: function (){
                    return [];
                }
            },
            permission: 'groups',
        }).state('app.groupAdd', {
            url    : '/groupAddEdit/add',
            title  : 'Groups',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/groups/groupsAddEdit.html',
                    controller : 'groups as vm'
                }
            },
             resolve  : {
				Users: function (groupService,$localStorage,$stateParams){
					return groupService.getFormData( {hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id, status:'add'});
				}
           },
           permission: 'add_group',
           params:      {status:'add'},
           bodyClass: 'groups'
        })
        .state('app.groupEdit', {
            url    : '/groupAddEdit/:status',
            title  : 'Groups',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/groups/groupsAddEdit.html',
                    controller : 'groups as vm'
                }
            },
             resolve  : {
				Users: function (groupService,$localStorage,$stateParams){
					return groupService.getFormData( {hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id, status:$stateParams.status});
				}
             },
           permission: 'update_group',
           bodyClass: 'groups'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/groups');

    }

})();

  (function() {
      'use strict';

      angular
          .module('app.groups')
          .controller('groups', groups);

      /** @ngInject */
      function groups(
        $stateParams, 
        $state, 
        $scope, 
        $http, 
        EnvironmentConfig, 
        $mdDialog, 
        toastMessage, 
        $localStorage, 
        $document, 
        groupService, 
        Users,
        commonService, 
        $sessionStorage,
        $rootScope
        ) {

          var vm = this;
          if(!$rootScope.backButtonPressed){
                $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = {};
                $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] = 1;
                $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'] = 50;
          }

          vm.pageStatus = $stateParams.status;
          vm.gotoaddRole = commonService.gotoaddGroup;
          vm.saveGroup = saveGroup;
          vm.gotoGroupListing = gotoGroupListing;
          vm.updateGroup = updateGroup;
          vm.checkGroupName = checkGroupName;
          vm.users = [];
          vm.groupForm = {};
          vm.SelectedUsers = [];
          vm.rateGroupNameExists = '';
          vm.nameErrro = false;
          if (typeof $stateParams.status !== 'add' && typeof $stateParams.status != 'undefined') {
              vm.groupForm.group_name = Users[0]['group_name'].length > 0 ? Users[0]['group_name'] : '';
              Users[0]['groupMembers'].forEach(function(element, index) {
                  vm.SelectedUsers.push(element.user_id);
              });
          }


          /**
          *Function to check the group name
          */
          function checkGroupName(){
             groupService.checkGroupName({name:vm.groupForm.group_name})
                  .then(function(response) {
                    if(response.length > 0){
                     vm.rateGroupNameExists = 'Group already exists.';
                     vm.nameErrro = true;

                    } else {
                     vm.nameErrro = false;
                     vm.rateGroupNameExists = '';
                    }
                  });
          }

          function gotoGroupListing() {
              $state.go("app.groups", {
                  status: 'add'
              });
          }

          function saveGroup() {
              vm.groupForm['selectedContacts'] = vm.users;
              vm.groupForm['hotel_id'] = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
              groupService.createGroup(vm.groupForm)
                  .then(function(response) {
                      if (!response) {
                          toastMessage.showSimpleToast('Some error occured. Please try again.', 'error-toast');

                      } else {
                          $state.go("app.groups");
                      }
                  });
          }

          function updateGroup() {
              vm.groupForm['group_id'] = $stateParams.status;
              vm.groupForm['selectedContacts'] = vm.users;
              vm.groupForm['hotel_id'] = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
              groupService.UpdateGroup(vm.groupForm)
                  .then(function(response) {
                      if (!response) {
                          toastMessage.showSimpleToast('Some error occured. Please try again.', 'error-toast');

                      } else {
                          $state.go("app.groups");
                      }
                  });

          }


          // chip select start##############################
          vm.querySearch = querySearch;
          vm.allUsers = loadUsers();
          //For Selected Users
          vm.filterSelected = true;
          /**
           * Search for contacts.
           */
          function querySearch(query) {
              var results = query ?
                  vm.allUsers.filter(createFilterFor(query)) : [];
              return results;
          }
          /**
           * Create filter function for a query string
           */
          function createFilterFor(query) {
              var lowercaseQuery = angular.lowercase(query);
              return function filterFn(contact) {
                  return (contact._lowername.indexOf(lowercaseQuery) != -1);;
              };
          }

          function loadUsers() {
              var users = [];
              if (Users[0])
                  users = Users[0]['users'];

              return users.map(function(c, index) {

                  var user = {
                      name: c.first_name + ' ' + c.last_name,
                      email: c.email,
                      id: c.user_id
                  };
                  user._lowername = user.name.toLowerCase();
                  if (vm.SelectedUsers.indexOf(c.user_id) != -1) {
                      vm.users.push(user);
                  }
                  return user;
              });
          }
          // chip select end

          /*Start*/
          $scope.paginatorCallback = paginatorCallback;
          $scope.LoadAllData = LoadAllData;
          $scope.getLoadResultsCallback = getLoadResultsCallback;
          $scope.selectedRowCallback = function(rows) {
              vm.selectedprodId = rows;
              vm.checkDelete = false;
          };
          vm.userPermissions = $rootScope.userPermissions;
          if (vm.userPermissions.indexOf('delete_group') != -1) {
              vm.delete_product = true;
          } else {
              vm.delete_product = false;
          }
          var loadPageCallbackWithDebounce;
          $scope.$watch('filterText', function() {
              if (loadPageCallbackWithDebounce) {
                  loadPageCallbackWithDebounce();
              }
          });
          $scope.showTabDialog = function(ev, id) {
              roleService.getRolePermissions(id).then(function(response) {
                  if (response.listData.length == 0) {
                      toastMessage.showSimpleToast('This role has no module assigned.', 'error-toast');
                  } else {
                      $state.go('app.rolesPermission', {
                          id: id
                      });

                  }
              });
          };
          $scope.userPermissions = vm.userPermissions;
          $scope.updateTable = function() {
              loadPageCallbackWithDebounce();
          };

          $scope.toggleAll = function() {
              var toggleStatus = !$scope.isAllSelected;
              $scope.ChangeAll = toggleStatus;
          }
          $scope.checkBox = function(value) {
              if (vm.selectedprodId.indexOf(value) > -1) {
                  vm.selectedprodId.splice(vm.selectedprodId.indexOf(value), 1);
              } else {
                  vm.selectedprodId.push(value);
              }
              if (vm.selectedprodId.length > 0) {
                  vm.getNumberOfSelectedRows = vm.selectedprodId.length;
                  vm.checkDelete = true;
              } else {
                  vm.checkDelete = false;
              }
          };
          $scope.deleteSelectedItem = function(ev, selectedprodId) {

            // new
              var html ='Are you sure, you want to delete the selected group(s)?</br>';
              html = html +'<b>' + vm.selectedprodId.length + ' group(s)</b>' + ' will be deleted.';

                  $mdDialog.show({
                                controller: 'confirmController',
                                controllerAs: 'vm',
                                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                                parent: angular.element(document.body),
                                targetEvent: event,
                                clickOutsideToClose:true ,
                                locals: {
                                      title: 'Delete Group',
                                      htmlContent:html,
                                      cancelBtn:'Cancel',
                                      OkBtn:'Ok'
                                  }
                              })
                              .then(function(answer) {
                                 if(typeof answer != 'undefined' && answer == 'update'){
                               groupService.deleteSelectedGroup(vm.selectedprodId)
                                .then(function(response) {
                                    if (response.errorMsg) {
                                        toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                                    } else {
                                        loadPageCallbackWithDebounce();
                                        vm.selectedprodId = [];
                                    }
                                });
                               }
                              }, function() {});
            //Old
          };

          function getLoadResultsCallback(loadPageCallback) {
              loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
          }
          vm.UserColumns = [
              'adminG.group_name',
              'total_members'
            ];

          vm.onLoad = true;
          vm.requestGoing = false;
          function paginatorCallback(page, pageSize, option) {
            if(vm.requestGoing) return;
            if(vm.onLoad == true){
              if(typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] != 'undefined'){

                var page1 =  $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
                var pageSize1 = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'];
              vm.onLoad = false;
                return LoadAllData(page1, pageSize1,option);
              }else{
                vm.onLoad = false;
                return LoadAllData(page, pageSize,option);    
              }
            }else{
              if(typeof page == 'undefined'){
                page = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
              }
              return LoadAllData(page, pageSize,option);
            }              
          }
          /*End*/

          function LoadAllData(page, pageSize,option){

            vm.requestGoing = true;
            var pageDetail = {'currentPage':page,'pageSize':pageSize};
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = pageDetail;

              vm.page = page;
              vm.pageSize = pageSize;
              vm.selectedprodId = [];
              var sort = {};

              for (var i = 0; i < option.columnSort.length; i++) {

                  if (option.columnSort[i]['sort']) {
                      sort['column'] = vm.UserColumns[i];
                      sort['order'] = option.columnSort[i]['sort'];
                  }
              }
              var offset = (page - 1) * pageSize;
              var query = $scope.filterText ? $scope.filterText : '';


              var filterData = {
                  'offset': offset,
                  'pageSize': pageSize,
                  'search': $scope.filterText,
                  'sort': sort,
                  'get_organization': true,
                  'get_count': true,
                  'hotel_id': $localStorage.hotels[$localStorage.selectedHotel].hotel_id
              };


              return $http({
                  url: EnvironmentConfig.api + 'Group/groups',
                  method: 'POST',
                  data: filterData
              }).then(function(result) {
                  vm.requestGoing = false;
                  vm.totalGroups = result.data[0]['totalCount'];
                  return {
                      results: result.data[0]['groups'],
                      totalResultCount: result.data[0]['totalCount']
                  }
              });

          }

          $scope.goToEditPage = function(id) {
              if (vm.userPermissions.indexOf('update_group') != -1) {
                  $state.go("app.groupEdit", {
                      status: id
                  });
              }
          }

      }
  })();

'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../category/categoryService
 * @description
 * # ../category/categoryService
 * Service in the minervaApp.
 */
angular.module('app.policy')
  .service('groupService', function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
 	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}
 	
 	function getFormData(data){
		return $http({
			url:EnvironmentConfig.api+'Group/skipAcl_formData',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function createGroup(data){
		return $http({
			url:EnvironmentConfig.api + 'Group/add_group',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function deleteSelectedGroup(Ids){
		return $http({
			url:EnvironmentConfig.api +'Group/delete_group',
			method:'POST',
			data:Ids
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function UpdateGroup(formData){
	return $http({
		url:EnvironmentConfig.api + 'Group/update_group',
		method:'POST',
		data:formData
	})
	.then(getDataComplete)
	.catch(getDataFailed);
	}
	function checkGroupName(formData){
	return $http({
		url:EnvironmentConfig.api + 'Group/skipAcl_checkGroupName',
		method:'POST',
		data:formData
	})
	.then(getDataComplete)
	.catch(getDataFailed);
	}
 	return{
 		getFormData: getFormData,
		createGroup:createGroup,
		deleteSelectedGroup:deleteSelectedGroup,
		UpdateGroup:UpdateGroup,
		checkGroupName:checkGroupName
 	}
 });

(function() {
    'use strict';
    angular
        .module('app.reports')
        .controller('generateInvoiceController', generateInvoiceController);

    /** @ngInject */
    function generateInvoiceController(
       $scope,
       $http,
       EnvironmentConfig,
       toastMessage,
       lodgingStatistic,
       commonService,
       reportService,
       $timeout,
       $filter,
       $mdDialog
    ){
        var vm = this;
        vm.allMonth = [
           {name:'January',value:1},
           {name:'Feburary',value:2},
           {name:'March', value:3},
           {name:'April', value:4},
           {name:'May', value:5},
           {name:'June', value:6},
           {name:'July', value:7},
           {name:'August', value:8},
           {name:'September', value:9},
           {name:'October', value:10},
           {name:'November', value:11},
           {name:'December',value:12}
         ];
         vm.MonthName = ['January', 'Feburary', 'March','April','May','June','July','August','September','October','November','December'] ;

         vm.csvHeader = ['Confirmation Number',
                          'Status',
                          'Source',
                          'Product Name',
                          'Created Date',
                          'Arrival Date',
                          'Departure Date',
                          'Customer Name',
                          'Email',
                          'Number of nights/Quantity',
                          'Subtotal',
                          'Comission(2.5%)'];


        vm.selectedChannels = [];
        vm.allYear = [];
        vm.month = parseInt(moment().format('MM'));
        vm.monthNam = parseInt(moment().format('MMMM'));
        vm.year = parseInt(moment().format('YYYY'));
        var year = parseInt(moment().format('YYYY')) - 2;
        for(var i = 1; i <= 13 ; i++){
          vm.allYear.push(year);
          year = parseInt(year) + parseInt(1);
        }

        reportService.getAllChannels().then(function(response){
            if(response.success){
                vm.channels = response.result;
            }
        });



        vm.getInvoiceData = getInvoiceData;
        // getInvoiceData();
        vm.requestProcessing = false;
        function getInvoiceData(){
          vm.csvData = [];
          vm.total = 0;
          vm.comission = 0;
          vm.requestProcessing = true
          var data = {
            month:vm.month,
            year:vm.year,
            selectedChannels:vm.selectedChannels,
            mode:'listing'
          }
          reportService.getInvoiceData(data).then(function(response){
              vm.requestProcessing = false;
              vm.invoiceData = response;
              vm.csvData = angular.copy(vm.invoiceData);
          });
        }
        vm.total = 0;
        vm.calculate = calculate;
        vm.comission = 0;
        vm.rowCount = 0;
        function calculate(value){
          vm.rowCount = parseInt(vm.rowCount) + parseInt(1);
          vm.total = parseFloat(vm.total) + parseFloat(value);
          vm.comission = (vm.total * 2.5) / 100;

          if(vm.rowCount == vm.csvData.length){
             var lastRow = ['',
                          '',
                          '',
                          '',
                          '',
                          '',
                          '',
                          '',
                          'Total',
                          $filter('currency')( vm.total, '$' , 2),
                          $filter('currency')(vm.comission, '$', 2)];

             vm.csvData.push(lastRow);
          }
        }




        vm.printRecords = printRecords;
    vm.requestProcessingEmail = false;
    function printRecords(){

      $mdDialog.show({
                    controller: 'getEmailAddress',
                    controllerAs: 'vm',
                  templateUrl: 'app/main/apps/reports/getEmailAddress.html',
                  parent: angular.element(document.body),
                  targetEvent: event,
                  clickOutsideToClose:true ,

                })
                .then(function(answer) {
                  vm.requestProcessingEmail = true;
                     var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                   if(typeof answer != 'undefined' && re.test(answer)){

                    var data = {
                      month:vm.month,
                      year:vm.year,
                      selectedChannels:vm.selectedChannels,
                      emailAddress:answer,
                      mode:'sendEmail'
                    }
                    reportService.getInvoiceData(data).then(function(response){
                      vm.requestProcessingEmail = false;
                    });

        }
               }, function() {});

     }

    }
})();

'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../dashboards/dashboardGraphService
 * @description
 * # ../dashboards/dashboardGraphService
 * Service in the minervaApp.
 */
angular.module('app.dashboards')
  .service('dashboardGraphService', function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
 	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}
 	
 	/*****************************************/
    /******** dashboard detail request *******/
    /*****************************************/
 	function dashboardDetails(type){
		return $http({
			url:EnvironmentConfig.api+'DashboardGraph/getAllDashboardDetails/'+type,
			method:'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function dashboardRevenueDetails(type,tab){
		return $http({
			url:EnvironmentConfig.api+'DashboardGraph/getAllDashboardDetails/'+type+'/'+tab,
			method:'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/*****************************************/
    /******** Reservation by channels ********/
    /*****************************************/
	function getAllReservationByChannels(data){
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/getAllReservationByChannels',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getCourtesyHoldStatusPie(data){
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/getCourtesyHoldStatusPie',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/*****************************************/
    /******** Room status chart graph ********/
    /*****************************************/
	function getAllRoomStatusGraphChart(data){
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/getAllRoomStatusGraphChart',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/*****************************************/
    /******* Reservation distribution ********/
    /*****************************************/
	function getAllReservationDistribution(data){
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/getAllReservationDistribution',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/*****************************************/
    /********* Property performance **********/
    /*****************************************/
	function getAllPropertyPerformance(data){
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/getAllPropertyPerformance',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
	/*****************************************/
    /************* Quick Sales ***************/
    /*****************************************/
	function getQuickSales(type){
		return $http({
			url:EnvironmentConfig.api+'DashboardGraph/getQuickSales/' + type,
			method:'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/*****************************************/
    /*************** Sales POS ***************/
    /*****************************************/
	function getSalesPos(type, pageFor, startDate, endDate, subHotelId) {
		var queryParams = [];
		if (startDate) {
			queryParams.push('startDate=' + encodeURIComponent(startDate));
		}

		if (endDate) {
			queryParams.push('endDate=' + encodeURIComponent(endDate));
		}

		if (subHotelId) {
			queryParams.push('sub_hotel_id=' + encodeURIComponent(subHotelId));
		}
		
		var queryString = queryParams.length ? ('?' + queryParams.join('&')) : '';

		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/getSalesPos/' + type + '/'+ pageFor + queryString,
			method: 'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
	/*****************************************/
    /*************** Sales POS ***************/
    /*****************************************/
	function reservationSales(data){
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/getSalesData',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* @param: String type
	* @param: String statFor
	* @param: string startDate
	* @param: string endDate
	* Comment: Fetch rooms sold detail
	*/
	function quickStats(type, statFor, startDate, endDate, subHotelId) {
		var queryParams = [];
		if (startDate) {
			queryParams.push('startDate=' + encodeURIComponent(startDate));
		}

		if (endDate) {
			queryParams.push('endDate=' + encodeURIComponent(endDate));
		}

		if (subHotelId) {
			queryParams.push('sub_hotel_id=' + encodeURIComponent(subHotelId));
		}
		
		var queryString = queryParams.length ? ('?' + queryParams.join('&')) : '';
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/getQuickStatsData/'+type + '/' +statFor + queryString,
			method:'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* @param: Object data
	* Comment: Fetch rooms sold detail
	*/
	function getLatestTasks(data) {
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/getLatestTasks/',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* @param: Object data
	* Comment: Fetch rooms sold detail
	*/
	function getInHouseCustomers(data) {
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/getInHouseCustomers/',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* @param: queryString query
	* Comment: Get which type of listing is to be fetched
	*/
	function getGraphDetailListing(data) {
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/getGraphDetailListing/'+data,
			method: 'GET',
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* @param: Object data
	* Comment: Fetch available rooms for hotel
	*/
	function getAvailabilityStatus(data) {
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/getAvailabilityStatus',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getAllRoomMLS(data) {
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/getAllRoomMLS',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getChannelsMLS(data) {
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/getChannelsMls',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getAllMlsInListView(data) {
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/getAllMlsInListView',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
	/**
	* @param: Object data
	* Comment: Fetch pos products buy from frontend
	*/
	function getShoppersOnSite(data) {
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/getShoppersOnSite',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* @param: Object data
	* Comment: Fetch task for pie chart
	*/
	function taskStatusPieChart(data) {
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/getTaskStatusChartData',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}


	/**
	* @param: Object data
	* Comment: Fetch checkin, checkout and stayover reservation with thier task status
	*/
	function getReservations(data) {
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/getCurrentReservations',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}


	function getArrivalDepartureData(data) {
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/housekeepingPortlet',
			method:'POST',
			data: data || {}
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function deleteMlsforRoom(data) {
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/deleteMlsforRoom',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* @param: Object data
	* Comment: Update the mls for particular days, nights etc
	*/
	function modifyBulkRateRule(data) {
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/modifyBulkRateRule',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* @param: Object data
	* Comment: Get the reservations of checkin out portlets
	*/
	function getCheckInOutResvList(data) {
		return $http({
			url: EnvironmentConfig.api+'DashboardGraph/skipAcl_getCheckInOutResvs',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getBorrowedItems(data) {
		return $http({
			method: 'POST',
			url: EnvironmentConfig.api + 'DashboardGraph/getBorrowedItems',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function updateBorrowedItems(data) {
		return $http({
			method: 'POST',
			url: EnvironmentConfig.api + 'DashboardGraph/updateBorrowedItems',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function addBorrowedItemToReservation(data) {
		return $http({
			method: 'POST',
			url: EnvironmentConfig.api + 'DashboardGraph/addBorrowedItemToReservation',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	return	{
		dashboardDetails: dashboardDetails,
		dashboardRevenueDetails: dashboardRevenueDetails,
		reservationByChannels: getAllReservationByChannels,
		courtesyHoldStatusPie: getCourtesyHoldStatusPie,
		roomStatusGraphChart: getAllRoomStatusGraphChart,
		reservationDistribution: getAllReservationDistribution,
		propertyPerformance: getAllPropertyPerformance,
		getQuickSales: getQuickSales,
		getSalesPos: getSalesPos,
		reservationSales: reservationSales,
		quickStats: quickStats,
		getLatestTasks: getLatestTasks,
		getInHouseCustomers: getInHouseCustomers,
		getGraphDetailListing: getGraphDetailListing,
		getAvailabilityStatus: getAvailabilityStatus,
		getAllRoomMLS: getAllRoomMLS,
		getChannelsMLS: getChannelsMLS,
		getAllMlsInListView	: getAllMlsInListView,
		getShoppersOnSite: getShoppersOnSite,
		taskStatusPieChart : taskStatusPieChart,
		getReservations : getReservations,
		deleteMlsforRoom : deleteMlsforRoom,
		modifyBulkRateRule: modifyBulkRateRule,
		getArrivalDepartureData: getArrivalDepartureData,
		getCheckInOutResvList: getCheckInOutResvList,
		getBorrowedItems: getBorrowedItems,
		updateBorrowedItems: updateBorrowedItems,
		addBorrowedItemToReservation: addBorrowedItemToReservation
	}
});

(function () {
    'use strict';

    angular.module('app.dashboards')
        .controller('DashboardController', DashboardController)
        .filter('strReplace', function () {
            return function (input, from, to) {
                input = input || '';
                from = from || '';
                to = to || '';
                return input.replace(new RegExp(from, 'g'), to);
            };
        }).filter('strReplaceRoom', function () {
            return function (input) {
                input = input || '';
                var invalid = /[°"§%()\[\]{}=\\?´`'#<>|,;.:+_ ]+/g;
                return input.replace(invalid, "");
            };
        });

    /** @ngInject */
    function DashboardController(
        $scope,
        $timeout,
        $interval,
        dashboardDetails,
        dashboardGraphService,
        ganttChartService,
        $mdDateRangePicker,
        $rootScope,
        $localStorage,
        $state,
        $window,
        $mdDialog,
        toastMessage,
        $stateParams,
        rateRuleService,
        $document,
        todoService,
        createResService,
        eCommerceService,
        ganttChartServiceNew,
        $sessionStorage,
        userService,
        EnvironmentConfig
    ) {
        var vm = this;
        vm.canViewCourtesyHoldReport = function () {
            var perms = ($rootScope.userPermissions || '').toString();
            return perms.indexOf('courtesy_hold_report') !== -1 || perms.indexOf('system_reports') !== -1;
        };

        vm.isBorrowedItemsEnabled = function () {
            if ($localStorage && $localStorage.hotelgeneralsetting && typeof $localStorage.hotelgeneralsetting.enableBorrowedItems !== 'undefined') {
                return $localStorage.hotelgeneralsetting.enableBorrowedItems == '1';
            }
            return false;
        };

        var args = '';
        var progressInterval;
        vm.loadRemHtml = false;
        vm.pageFor = 'room';
        vm.quickStatsType = 'custom-range';
        vm.salesPosType = 'custom-range';
        vm.currentTab = dashboardDetails.tabs !== undefined ? dashboardDetails.tabs[0] : 'Front desk';
        vm.dashboardData = {};
        vm.salesRetail = {};
        vm.dateObj = {};
        vm.mlsDays = {};
        vm.availableMlsRooms = {};
        vm.mlsRoomDates = {};
        vm.tempData = {};
        vm.showAvailStatusPop = false;
        vm.availStatusPop = {};
        function rebuildCheckInCheckout() {
            vm.checkInCheckout = [
                { key: 'checkIn', val: 'Check In' },
                { key: 'checkOut', val: 'Check Out' }
            ];
            if (typeof $rootScope.isDailyRentalsAvailable === 'function' && $rootScope.isDailyRentalsAvailable()) {
                vm.checkInCheckout.push({ key: 'dailyRentals', val: 'Daily Rentals' });
            }
            if (vm.checkinOutSelected === 'dailyRentals'
                && !vm.checkInCheckout.some(function (item) { return item.key === 'dailyRentals'; })) {
                vm.checkinOutSelected = 'checkIn';
            }
        }
        rebuildCheckInCheckout();
        $scope.$watch(function () {
            var settings = $rootScope.hotelInformation
                && $rootScope.hotelInformation.settings
                && $rootScope.hotelInformation.settings.daily_rentals_settings;
            return (settings && settings.enabled) + '|' + ($rootScope.userPermissions || '');
        }, function () {
            rebuildCheckInCheckout();
        });
        vm.nameSortType = vm.badgeSortType = vm.roomSortType = vm.checkOutSortType = vm.guestSortType = '';
        vm.checkInNameSortType = {
            'checkIn': '',
            'checkOut': '',
            'dailyRentals': ''
        };
        vm.checkInPortSortType = {
            'checkIn': '',
            'checkOut': '',
            'dailyRentals': ''
        };
        vm.checkOutPortSortType = {
            'checkIn': '',
            'checkOut': '',
            'dailyRentals': ''
        };
        vm.checkRemSortType = {
            'checkIn': '',
            'checkOut': '',
            'dailyRentals': ''
        };

        vm.checkInSortType = 'ASC';
        vm.selectedColumn = 'room_stay_from';
        vm.selectedCheckInColumn = {
            'checkIn': 'room_stay_from',
            'checkOut': 'room_stay_from',
            'dailyRentals': 'room_stay_from'
        };

        vm.isDailyRentalsPortlet = function (key) {
            return key === 'dailyRentals';
        };

        vm.hasRoomAssigned = function (resv) {
            if (!resv) {
                return false;
            }
            if (resv.has_room == 1 || resv.has_room === '1' || resv.has_room === true) {
                return true;
            }
            return parseInt(resv.product_id, 10) > 0;
        };

        vm.showDailyRentalCheckIn = function (resv) {
            // Day Room only — Beach Pass / Day Pass (no room) hide check-in
            if (!resv || !vm.hasRoomAssigned(resv)) {
                return false;
            }
            if (resv.show_check_in == 1 || resv.show_check_in === '1') {
                return true;
            }
            return String(resv.room_stay_status || '').toLowerCase() === 'active';
        };

        vm.showDailyRentalCheckOut = function (resv) {
            // Day Room only — Beach Pass / Day Pass (no room) hide check-out
            if (!resv || !vm.hasRoomAssigned(resv)) {
                return false;
            }
            if (resv.show_check_out == 1 || resv.show_check_out === '1') {
                return true;
            }
            return String(resv.room_stay_status || '').toLowerCase() === 'checked-in';
        };

        // Print Invoice: always for Daily Rentals (Day Room, Beach Pass, Day Pass)
        vm.showDailyRentalPrintInvoice = function (resv) {
            return !!resv;
        };

        vm.currentHotelId = $localStorage.preHotelId;
        vm.selectedPropertyId = 'all';

        vm.normalizeSubHotels = function (subHotels) {
            return (subHotels || []).map(function (hotel) {
                return {
                    id: hotel.id || hotel.hotel_id,
                    name: hotel.name || hotel.hotel_title
                };
            }).filter(function (hotel) {
                return hotel.id;
            });
        };

        vm.syncSubHotels = function () {
            var fromHotelInfo = ($rootScope.hotelInformation && $rootScope.hotelInformation.sub_hotels) || [];
            var fromRootScope = $rootScope.subHotels || [];
            var normalized = vm.normalizeSubHotels(fromHotelInfo.length ? fromHotelInfo : fromRootScope);
            vm.subHotels = normalized;
            if (!vm.subHotels.length) {
                vm.selectedPropertyId = 'all';
            }
        };

        vm.syncSubHotels();
        vm.tabsHeading = [];
        if (dashboardDetails.tabs !== undefined && dashboardDetails.tabs.length) {
            dashboardDetails.tabs.forEach(function (value, key) {
                vm.tabsHeading.push(value);
            });
        } else {
            vm.tabsHeading = ['Front desk'];
        }

        $scope.$watch(function () {
            return [
                $rootScope.hotelInformation && $rootScope.hotelInformation.sub_hotels,
                $rootScope.subHotels,
                $rootScope.hotelInformation && $rootScope.hotelInformation.id
            ];
        }, function (watchValues, oldWatchValues) {
            var previousHotelId = oldWatchValues && oldWatchValues[2];
            var currentHotelId = watchValues && watchValues[2];

            if (previousHotelId && currentHotelId && previousHotelId !== currentHotelId) {
                vm.selectedPropertyId = 'all';
            }

            vm.syncSubHotels();
        }, true);

        vm.appendRevenueSubHotelParam = function (getData) {
            vm.updateTempData();
            if (vm.selectedPropertyId && vm.selectedPropertyId !== 'all') {
                getData += '&' + vm.selectedPropertyId;
            }
            return getData;
        };


        vm.srceenwidth = $window.innerWidth
        vm.checkinOutSelected = 'checkIn';
        /**
        * Change check in out listing view
        */
        vm.changeCheckInOutView = function (type) {
            if (type !== vm.checkinOutSelected) {
                vm.checkInOutLoader = {
                    'checkIn': false,
                    'checkOut': false,
                    'dailyRentals': false
                };
                vm.checkinOutSelected = type;
            }
        };

        vm.getPreCheckInCount = function (type) {
            if (!vm.dashboardData) {
                return 0;
            }
            if (type === 'started') {
                return Number(vm.dashboardData.precheckin_started_count) || 0;
            }
            return Number(vm.dashboardData.precheckin_completed_count) || 0;
        };

        vm.hasPreCheckInCounts = function () {
            return vm.getPreCheckInCount('started') > 0 || vm.getPreCheckInCount('completed') > 0;
        };

        vm.isPreCheckInFlagSet = function (resv, field) {
            return resv && (resv[field] == 1 || resv[field] == '1');
        };

        vm.getPreCheckInTooltipReservations = function (type) {
            var list = vm.checkInOutList && vm.checkInOutList.checkIn ? vm.checkInOutList.checkIn : [];

            return list.filter(function (resv) {
                if (!resv || (resv.hotel_name !== undefined && resv.hotel_name !== '')) {
                    return false;
                }
                if (type === 'started') {
                    return vm.isPreCheckInFlagSet(resv, 'is_precheckin_started');
                }
                if (type === 'completed') {
                    return vm.isPreCheckInFlagSet(resv, 'is_precheckin_completed');
                }
                return false;
            });
        };

        vm.getPreCheckInRoomNumber = function (resv) {
            if (!resv) {
                return '';
            }
            var room = resv.first_room || '';
            if (resv.second_room) {
                room += (room ? ', ' : '') + resv.second_room;
            }
            return room;
        };

        vm.getPreCheckInGuestName = function (resv) {
            if (!resv) {
                return '';
            }
            return ((resv.first_name || '') + ' ' + (resv.last_name || '')).trim();
        };

        vm.getGuestStaysCount = function (resv) {
            if (!resv) {
                return 0;
            }
            return Number(resv.no_of_stays) || 0;
        };

        vm.guestStaysTooltip = {
            open: false,
            customerId: null,
            reservationId: null,
            key: null,
            source: null,
            count: 0,
            loading: false,
            reservations: [],
            tags: []
        };
        vm.guestStaysSkeletonSlots = [1, 2, 3];
        vm.guestStaysTooltipTpl = 'app/main/apps/dashboards/dash-views/guest-stays-tooltip.html';
        vm.guestStaysTooltipHeadings = [
            { label: 'Product', icon: 'icon-briefcase-checked' },
            { label: 'Check In', icon: 'icon-calendar-blank' },
            { label: 'Check Out', icon: 'icon-calendar-blank' },
            { label: 'Total', icon: 'icon-currency-usd' },
            { label: 'ADR', icon: 'icon-currency-usd' },
            { label: 'Created', icon: 'icon-calendar-blank' },
            { label: 'Source', icon: 'icon-file-document' }
        ];

        vm.guestStaysTooltipStyle = {};
        vm.guestStaysArrowStyle = {};

        function guestStaysKey(resv) {
            if (!resv || !resv.reservation_id) {
                return null;
            }
            return resv.reservation_id + '::' + (resv.product_id || resv.first_room || '');
        }

        vm.isGuestStaysTooltipOpen = function (resv, source) {
            var key = guestStaysKey(resv);
            return !!(vm.guestStaysTooltip.open && key && source &&
                key === vm.guestStaysTooltip.key &&
                vm.guestStaysTooltip.source === source);
        };

        function positionGuestStaysTooltip(anchorEl) {
            if (!anchorEl || !anchorEl.getBoundingClientRect) {
                return;
            }

            var popup = angular.element($document[0].querySelector('.global-stays-tooltip-anchor'));
            if (popup.length && popup.parent()[0] !== $document[0].body) {
                angular.element($document[0].body).append(popup);
            }

            var rect = anchorEl.getBoundingClientRect();
            var viewportWidth = $window.innerWidth;
            var viewportHeight = $window.innerHeight;
            var width = Math.min(920, viewportWidth - 32);
            var left = Math.round(Math.min(Math.max(rect.left - 14, 16), viewportWidth - width - 16));
            var spaceBelow = viewportHeight - rect.bottom;
            var openAbove = spaceBelow < 380 && rect.top > spaceBelow;

            vm.guestStaysTooltip.openAbove = openAbove;
            vm.guestStaysTooltipStyle = {
                position: 'fixed',
                width: width + 'px',
                left: left + 'px',
                right: 'auto',
                top: openAbove ? 'auto' : Math.round(rect.bottom + 8) + 'px',
                bottom: openAbove ? Math.round(viewportHeight - rect.top + 8) + 'px' : 'auto'
            };
            vm.guestStaysArrowStyle = {
                left: Math.round(Math.min(Math.max(rect.left + (rect.width / 2) - left - 9, 12), width - 30)) + 'px',
                right: 'auto'
            };
        }

        vm.toggleGuestStaysTooltip = function ($event, resv, source) {
            if ($event) {
                $event.stopPropagation();
                $event.preventDefault();
            }
            if (!resv || !resv.customer_id || !resv.reservation_id) {
                return;
            }

            source = source || 'checkIn';
            var customerId = resv.customer_id;
            var reservationId = resv.reservation_id;
            var key = guestStaysKey(resv);

            if (vm.isGuestStaysTooltipOpen(resv, source)) {
                vm.guestStaysTooltip.open = false;
                return;
            }

            vm.guestStaysTooltip.open = true;
            vm.guestStaysTooltip.customerId = customerId;
            vm.guestStaysTooltip.reservationId = reservationId;
            vm.guestStaysTooltip.key = key;
            vm.guestStaysTooltip.source = source;
            vm.guestStaysTooltip.count = vm.getGuestStaysCount(resv);
            vm.guestStaysTooltip.tags = angular.copy(resv.customer_tags || []);
            positionGuestStaysTooltip($event && $event.currentTarget);

            vm.guestStaysTooltip.loading = true;
            vm.guestStaysTooltip.reservations = [];
            userService.getSingleCustomerReservations(customerId).then(function (response) {
                if (!response || !angular.isArray(response.reservations)) {
                    if (vm.guestStaysTooltip.key === key && vm.guestStaysTooltip.source === source) {
                        vm.guestStaysTooltip.reservations = [];
                        vm.guestStaysTooltip.loading = false;
                    }
                    return;
                }
                if (vm.guestStaysTooltip.key === key && vm.guestStaysTooltip.source === source) {
                    vm.guestStaysTooltip.reservations = response.reservations;
                    vm.guestStaysTooltip.loading = false;
                }
            });
        };

        vm.closeGuestStaysTooltip = function ($event) {
            if ($event) {
                $event.stopPropagation();
            }
            vm.guestStaysTooltip.open = false;
        };

        function closeGuestStaysTooltipOnOutsideClick(event) {
            if (!vm.guestStaysTooltip.open) {
                return;
            }
            var target = event && event.target;
            if (target && target.closest &&
                (target.closest('.global-stays-tooltip-anchor') || target.closest('.stays-count-icon'))) {
                return;
            }
            $scope.$applyAsync(function () {
                vm.guestStaysTooltip.open = false;
            });
        }
        function closeGuestStaysTooltipOnScroll(event) {
            if (!vm.guestStaysTooltip.open) {
                return;
            }
            var target = event && event.target;
            if (target && target.closest && target.closest('.stays-stat-tooltip')) {
                return;
            }
            $scope.$applyAsync(function () {
                vm.guestStaysTooltip.open = false;
            });
        }
        function closeGuestStaysTooltipOnPageShow(event) {
            if (event.persisted) {
                $scope.$applyAsync(function () {
                    vm.guestStaysTooltip.open = false;
                });
            }
        }
        $document[0].addEventListener('click', closeGuestStaysTooltipOnOutsideClick, true);
        $document[0].addEventListener('scroll', closeGuestStaysTooltipOnScroll, true);
        $window.addEventListener('resize', closeGuestStaysTooltipOnScroll);
        $window.addEventListener('pageshow', closeGuestStaysTooltipOnPageShow);
        $scope.$on('$stateChangeStart', function () {
            vm.guestStaysTooltip.open = false;
            var allPopups = $document[0].querySelectorAll('.global-stays-tooltip-anchor');
            for (var i = 0; i < allPopups.length; i++) {
                if (allPopups[i].parentNode) {
                    allPopups[i].parentNode.removeChild(allPopups[i]);
                }
            }
        });
        $scope.$on('$destroy', function () {
            $document[0].removeEventListener('click', closeGuestStaysTooltipOnOutsideClick, true);
            $document[0].removeEventListener('scroll', closeGuestStaysTooltipOnScroll, true);
            $window.removeEventListener('resize', closeGuestStaysTooltipOnScroll);
            $window.removeEventListener('pageshow', closeGuestStaysTooltipOnPageShow);

            var allPopups = $document[0].querySelectorAll('.global-stays-tooltip-anchor');
            for (var i = 0; i < allPopups.length; i++) {
                if (allPopups[i].parentNode) {
                    allPopups[i].parentNode.removeChild(allPopups[i]);
                }
            }
        });

        vm.addonIconBaseUrl = EnvironmentConfig.api + 'assets/img/addon-icons/';

        vm.getReservationAddons = function (resv, addonKey) {
            if (!resv || !resv.addons || Array.isArray(resv.addons) || typeof resv.addons !== 'object') {
                return [];
            }
            var list = resv.addons[addonKey];
            return Array.isArray(list) ? list : [];
        };

        vm.isValidAddonCategory = function (addonKey, addonList) {
            return !!addonKey
                && addonKey.indexOf('for_') === 0
                && Array.isArray(addonList)
                && addonList.length > 0;
        };

        vm.getCustomerTagNames = function(tags) {
            if (!tags || !tags.length) {
                return '';
            }

            return tags.map(function(tag) {
                return tag.name;
            }).join(', ');
        };

        vm.getCustomerTagStyle = function(color) {
            if (!color) {
                color = '#00a3bd';
            }

            return {
                color: color,
                background: 'color-mix(in srgb, ' + color + ' 12%, transparent)',
                border: '1px solid color-mix(in srgb, ' + color + ' 35%, transparent)'
            };
        };

        vm.hasReservationAddonIcons = function (resv) {
            if (!resv || (resv.hotel_name !== undefined && resv.hotel_name !== '')) {
                return false;
            }
            if (!resv.addons || Array.isArray(resv.addons) || typeof resv.addons !== 'object') {
                return false;
            }
            for (var key in resv.addons) {
                if (Object.prototype.hasOwnProperty.call(resv.addons, key)
                    && vm.isValidAddonCategory(key, resv.addons[key])) {
                    return true;
                }
            }
            return false;
        };

        vm.getAddonIconName = function (addonKey) {
            if (!addonKey) {
                return '';
            }
            return addonKey.indexOf('for_') === 0 ? addonKey.substring(4) : addonKey;
        };

        vm.isEarlyOrLateAddon = function (addonKey) {
            var name = vm.getAddonIconName(addonKey);
            return name === 'early_check-in' || name === 'late_check-out' || name === 'miscellaneous';
        };

        vm.getAddonIconUrl = function (addonKey) {
            var iconName = vm.getAddonIconName(addonKey);
            if (!iconName) {
                return '';
            }
            return vm.addonIconBaseUrl + iconName + '.png';
        };

        vm.getAddonTooltip = function (resv, addonKey) {
            var names = [];
            var seen = {};
            vm.getReservationAddons(resv, addonKey).forEach(function (addon) {
                var name = addon && addon.product_name ? String(addon.product_name).trim() : '';
                if (name && !seen[name]) {
                    seen[name] = true;
                    names.push(name);
                }
            });
            return names.join(', ');
        };

        vm.hasCheckInRowStatusIcons = function (resv, checkInType) {
            if (!resv || (resv.hotel_name !== undefined && resv.hotel_name !== '')) {
                return false;
            }
            if (vm.hasReservationAddonIcons(resv)) {
                return true;
            }
            if (checkInType === 'checkOut' || checkInType === 'dailyRentals') {
                return false;
            }
            return vm.isPreCheckInFlagSet(resv, 'is_precheckin_started')
                || vm.isPreCheckInFlagSet(resv, 'is_precheckin_completed')
                || vm.getGuestStaysCount(resv) > 0;
        };

        vm.checkInOutList = {
            'checkIn': dashboardDetails.checkInList !== undefined ? dashboardDetails.checkInList : [],
            'checkOut': dashboardDetails.checkOutList !== undefined ? dashboardDetails.checkOutList : [],
            'dailyRentals': dashboardDetails.dailyRentalsList !== undefined ? dashboardDetails.dailyRentalsList : []
        };

        vm.checkInOutLoader = {
            'checkIn': false,
            'checkOut': false,
            'dailyRentals': false
        };
        vm.stateFrom = '';
        vm.casitas_response = '';
        if (typeof $stateParams.fromState != 'undefined' && $stateParams.fromState == 'dashboard') {
            vm.stateFrom = 'Front desk';
        } else {
            vm.stateFrom = 'Revenue';
        }

        vm.onlyrooms = {};
        vm.RateData = {};
        vm.channelsData = {};
        vm.Rooms_sub_hotel_ids = {};

        // Restriction level
        vm.restrictionLevel = 'all';
        vm.title = 'Restrictions';
        vm.level = 'all';


        vm.showHotelLoaders = function () {
            vm.roomStatusLoader = true;
            vm.latestTasksLoader = true;
            vm.inHouseCustLoadear = true;
            vm.roomStatusExist = true;
            vm.availabilityLoader = true;
        };

        vm.showRevenueLoaders = function () {
            vm.revLoader = true;
            vm.otaSaleLoader = true;
            vm.resChannelsLoader = true;
            vm.resDistributionLoader = true;
            vm.resDistributionExist = true;
            vm.resPieChartExist = true;
            vm.courtesyHoldLoader = true;
            vm.courtesyHoldPieExist = true;
            vm.otaSalesExist = true;
            vm.showremoveMLSLoader = true;
            vm.quickStatsLoader = true;
            vm.salesPosLoader = true;
        };
        vm.showHotelLoaders();

        vm.dateObj.startDate = moment().format('YYYY-MM-DD');
        vm.dateObj.endDate = moment().add(7, 'day').format('YYYY-MM-DD');
        vm.dashboardData = dashboardDetails;

        var dateConv = [];
        vm.currentDate = new Date();
        vm.frontDeskPicker = {};
        if ($localStorage['dashboard_dates'] != undefined && $localStorage['dashboard_dates'].dateStart != undefined && $localStorage['dashboard_dates'].dateStart != '') {
            dateConv = $rootScope.convertDateIntoArray($localStorage.dashboard_dates.dateStart);
            vm.frontDeskPicker.dateStart = new Date(dateConv[0], dateConv[1], dateConv[2]);
            dateConv = $rootScope.convertDateIntoArray($localStorage.dashboard_dates.dateEnd);
            vm.frontDeskPicker.dateEnd = new Date(dateConv[0], dateConv[1], dateConv[2]);
        } else {
            vm.frontDeskPicker = {
                dateStart: new Date(vm.currentDate.getFullYear(), vm.currentDate.getMonth(), vm.currentDate.getDate()),
                dateEnd: new Date(vm.currentDate.getFullYear(), vm.currentDate.getMonth() + 1, 0)
            }
        }

        vm.revenuePicker = {};
        if ($localStorage['dashboard_revenue_dates'] != undefined && $localStorage['dashboard_revenue_dates'].dateStart != undefined && $localStorage['dashboard_revenue_dates'].dateStart != '') {
            dateConv = $rootScope.convertDateIntoArray($localStorage.dashboard_revenue_dates.dateStart);
            vm.revenuePicker.dateStart = new Date(dateConv[0], dateConv[1], dateConv[2]);
            dateConv = $rootScope.convertDateIntoArray($localStorage.dashboard_revenue_dates.dateEnd);
            vm.revenuePicker.dateEnd = new Date(dateConv[0], dateConv[1], dateConv[2]);
        } else {
            vm.revenuePicker = {
                dateStart: new Date(vm.currentDate.getFullYear(), vm.currentDate.getMonth(), 1),
                dateEnd: new Date(vm.currentDate.getFullYear(), vm.currentDate.getMonth() + 1, 0)
            }
        }

        angular.element(function () {
            $timeout(function () {
                vm.loadRemHtml = true;
                vm.fetchLatesData();
            }, 400);
        });


        /*
        ** Handler on select of date range picker
        */
        vm.mdDateRangeHandler = function (dates, tab) {
            var selectedDates = {};
            if (tab === 'frontdesk') {
                selectedDates = {
                    dateStart: moment(vm.frontDeskPicker.dateStart).format('YYYY-MM-DD'),
                    dateEnd: moment(vm.frontDeskPicker.dateEnd).format('YYYY-MM-DD')
                }
                $localStorage['dashboard_dates'] = selectedDates;
            } else if (tab === 'revenue') {
                selectedDates = {
                    dateStart: moment(vm.revenuePicker.dateStart).format('YYYY-MM-DD'),
                    dateEnd: moment(vm.revenuePicker.dateEnd).format('YYYY-MM-DD')
                }
                $localStorage['dashboard_revenue_dates'] = selectedDates;
            }
            vm.updateTempData();
            vm.fetchLatesData();
        }
        vm.isActive = [];

        vm.toggleChannelDiv = function (product_id) {
            var cssClass = 'toggleClass_' + product_id + 'subDiv';
            if (typeof vm.isActive[product_id] == 'undefined') {
                vm.isActive[product_id] = false;
            }

            vm.isActive[product_id] = !vm.isActive[product_id];

            /*if(vm.isActive[product_id])
                angular.element(document.getElementsByClassName('classToToggle')).removeClass("hideAllNames");
            else
                angular.element(document.getElementsByClassName('classToToggle')).addClass("hideAllNames");
*/
            angular.element(document.getElementsByClassName(cssClass)).toggleClass('hideAllNames');
            // angular.element(document.getElementsByClassName(cssClass)).slideToggle('hideAllNames');

            angular.element(document.getElementsByClassName(product_id + '_toggleRow')).toggleClass('hideAllNames');

        }

        vm.updateTempData = function () {
            if (vm.currentTab.toLowerCase() === 'front desk' || vm.currentTab.toLowerCase() === 'marina') {
                vm.tempData = {
                    startDate: (vm.frontDeskPicker.dateStart != undefined) ? moment(vm.frontDeskPicker.dateStart).format('YYYY-MM-DD') : vm.dateObj.startDate,
                    endDate: (vm.frontDeskPicker.dateEnd != undefined) ? moment(vm.frontDeskPicker.dateEnd).format('YYYY-MM-DD') : vm.dateObj.endDate,
                };
            } else if (vm.currentTab.toLowerCase() === 'revenue') {
                vm.tempData = {
                    startDate: (vm.revenuePicker.dateStart != undefined) ? moment(vm.revenuePicker.dateStart).format('YYYY-MM-DD') : vm.dateObj.startDate,
                    endDate: (vm.revenuePicker.dateEnd != undefined) ? moment(vm.revenuePicker.dateEnd).format('YYYY-MM-DD') : vm.dateObj.endDate,
                };
            }
            vm.tempData.typeFor = vm.pageFor;
            if (vm.selectedPropertyId && vm.selectedPropertyId !== 'all') {
                vm.tempData.sub_hotel_id = vm.selectedPropertyId;
            } else {
                delete vm.tempData.sub_hotel_id;
            }
        };

        vm.onPropertyFilterChange = function () {
            vm.updateTempData();
            if (vm.currentTab === 'Revenue') {
                vm.fetchLatesData();
            }
        };

        vm.updateTempData();
        /**
        * Reload all section to fetch fresh data
        */
        vm.fetchLatesData = function () {
            switch (vm.currentTab) {
                case 'Front desk':
                    vm.showHotelLoaders();
                    vm.roomStatus();
                    vm.latestTasksData();
                    vm.inHouseCustomers();
                    vm.getAvailability();
                    // vm.getShoppersOnSite();
                    break;

                case 'Marina':
                    vm.showHotelLoaders();
                    vm.roomStatus();
                    vm.latestTasksData();
                    vm.inHouseCustomers();
                    vm.getAvailability();
                    // vm.getShoppersOnSite();
                    break;

                case 'Revenue':
                    vm.showRevenueLoaders();
                    vm.otaCommissionSale();
                    vm.getSalesPos(vm.salesPosType || 'custom-range');
                    vm.channelReservations();
                    if (vm.canViewCourtesyHoldReport()) {
                        vm.courtesyHoldStatusPie();
                    } else {
                        vm.courtesyHoldLoader = false;
                        vm.courtesyHoldPieExist = false;
                    }
                    vm.propertyPerformance();
                    vm.quickStatsData(vm.quickStatsType || 'custom-range');
                    vm.resDistributionData();
                    vm.getRoomMLSData();
                    break;

                case 'Restrictions':
                    vm.getAllMlsInListView(vm.level);
                    break;

                default:
                    break;
            }
        };

        vm.changePageFor = function (type) {
            if (vm.currentTab !== type) {
                vm.currentTab = type;
                vm.pageFor = (type === 'Marina') ? 'boat' : 'room';
                vm.updateTempData();
                vm.fetchLatesData();
                if (type.toLowerCase() === 'front desk' || type.toLowerCase() === 'marina') {
                    vm.updateTopHeaders();
                }
            }
        }
        var updateDataOnly = false;
        vm.getRoomMLSData = function (type) {
            // console.log(vm.tempData);
            dashboardGraphService.getAllRoomMLS(vm.tempData)
                .then(function (response) {
                    if (!updateDataOnly) {
                        updateDataOnly = true;
                        vm.mlsDays = response['mlsData']['dates'];
                        vm.availableMlsRooms = response['mlsData']['rooms'];
                    }
                    vm.mlsRoomDates = response['mlsData']['result'];
                });

            rateRuleService.getRateRuleData({ hotel_id: $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'] }).then(function (response) {
                vm.onlyrooms = response.onlyrooms;
                vm.RateData = response.ratePlansData;
                vm.channelsData = response.channelsData;
                vm.Rooms_sub_hotel_ids = response.roomtype_subHotelIds;
            });
        }

        vm.MLSlistView = [];

        vm.getAllMlsInListView = function (level) {
            var data = {
                pageFor: '',
                level: level
            };
            dashboardGraphService.getAllMlsInListView(data)
                .then(function (response) {
                    vm.MLSlistView = response['data'];
                    vm.showremoveMLSLoader = false;
                });
        }

        vm.updateTopHeaders = function () {
            dashboardGraphService.dashboardDetails(vm.pageFor)
                .then(function (response) {
                    vm.dashboardData = response;
                    vm.checkinOutSelected = 'checkIn';
                    vm.checkInOutList = {
                        'checkIn': response.checkInList !== undefined ? response.checkInList : [],
                        'checkOut': response.checkOutList !== undefined ? response.checkOutList : [],
                        'dailyRentals': response.dailyRentalsList !== undefined ? response.dailyRentalsList : []
                    };

                    vm.checkInOutLoader = {
                        'checkIn': false,
                        'checkOut': false,
                        'dailyRentals': false
                    };
                });
        };

        $scope.$on('updateMLS', function (event) {
            vm.getAllMlsInListView(vm.level);
        });

        if ($localStorage.preHotelId == 128) {
            rateRuleService.getRateRulesData($localStorage.preHotelId).then(function (response) {
                if (response.success) {
                    vm.casitas_response = response.data;
                }
            });
        }

        vm.insertnew = function (ev) {
            var data = {
                hotel_id: $localStorage.preHotelId,
                start: moment().format('YYYY-MM-DD'),
                end: moment().add({ month: 1 }).format('YYYY-MM-DD'),
                pageView: 1,
                type: 'boat'
            };
            var ratePlansData = {};
            var channelsData = {};
            var roomsData = {};
            if (vm.onlyrooms['Room'] !== undefined) {
                roomsData['Room'] = angular.copy(vm.onlyrooms['Room']);
            } else if (vm.onlyrooms['parent'] != undefined) {
                roomsData['Room'] = angular.copy(vm.onlyrooms['parent']);
            }
            ratePlansData['Room'] = angular.copy(vm.RateData['room']);
            channelsData['Room'] = angular.copy(vm.channelsData);
            var typeForSearch = 'boat';
            var typeIndex = 'Boat';
            var showPopup = false;
            var newData = {};
            if (data.hotel_id == 122 || data.hotel_id == 126) {
                rateRuleService.getCustomRateRuleData(data).then(function (response) {
                    vm.isloading = false;
                    if (response.success) {
                        if (response.ratePlansData[typeForSearch] !== undefined && response.ratePlansData[typeForSearch] !== null && response.ratePlansData[typeForSearch] !== '') {
                            roomsData[typeIndex] = (response.onlyrooms);
                            roomsData[typeIndex].shift();
                            channelsData[typeIndex] = response.channelsData;
                            ratePlansData[typeIndex] = response.ratePlansData[typeForSearch];

                        } else {
                            roomsData[typeIndex] = [];
                            channelsData[typeIndex] = [];
                            ratePlansData[typeIndex] = [];
                        }
                    } else {
                        roomsData[typeIndex] = [];
                        channelsData[typeIndex] = [];
                        ratePlansData[typeIndex] = [];
                    }
                    newData = {
                        roomsData: roomsData,
                        ratePlansData: ratePlansData,
                        channelsData: channelsData
                    };
                    vm.showPopup(ev, newData, [], 'rateCalander', []);
                });
            } else {
                newData = {
                    roomsData: roomsData,
                    ratePlansData: ratePlansData,
                    channelsData: channelsData
                };
                vm.showPopup(ev, newData, [], 'rateCalander', []);
            }
        }


        vm.bulkUpdate = function (ev, value) {
            value['update'] = 'rate';
            var data = {
                hotel_id: $localStorage.preHotelId,
                start: moment().format('YYYY-MM-DD'),
                end: moment().add({ month: 1 }).format('YYYY-MM-DD'),
                pageView: 1,
                type: value.type
            };
            var ratePlansData = {};
            var channelsData = {};
            var roomsData = {};
            var newData = {};
            var typeForSearch = value.type;
            if (vm.onlyrooms['Room'] !== undefined) {
                roomsData['Room'] = angular.copy(vm.onlyrooms['Room']);
            } else if (vm.onlyrooms['parent'] != undefined) {
                roomsData['Room'] = angular.copy(vm.onlyrooms['parent']);
            }
            ratePlansData['Room'] = angular.copy(vm.RateData['room']);
            channelsData['Room'] = angular.copy(vm.channelsData);
            var typeIndex = (value.type == 'boat') ? 'Boat' : 'Room';
            var newData = {};
            newData = {
                roomsData: roomsData,
                ratePlansData: ratePlansData,
                channelsData: channelsData
            };
            if ((data.hotel_id == 122 || data.hotel_id == 126) && value.type == 'boat') {
                rateRuleService.getCustomRateRuleData(data).then(function (response) {
                    vm.isloading = false;
                    if (response.success) {
                        if (response.ratePlansData[typeForSearch] !== undefined && response.ratePlansData[typeForSearch] !== null && response.ratePlansData[typeForSearch] !== '') {
                            roomsData[typeIndex] = (response.onlyrooms);
                            roomsData[typeIndex].shift();
                            channelsData[typeIndex] = response.channelsData;
                            ratePlansData[typeIndex] = response.ratePlansData[typeForSearch];

                        } else {
                            roomsData[typeIndex] = [];
                            channelsData[typeIndex] = [];
                            ratePlansData[typeIndex] = [];
                        }
                    } else {
                        roomsData[typeIndex] = [];
                        channelsData[typeIndex] = [];
                        ratePlansData[typeIndex] = [];
                    }
                    newData = {
                        roomsData: roomsData,
                        ratePlansData: ratePlansData,
                        channelsData: channelsData
                    };
                    vm.showPopup(ev, newData, value, 'dashboard', vm.casitas_response);
                });
            } else {

                vm.showPopup(ev, newData, value, 'dashboard', vm.casitas_response);
            }



        };

        vm.showPopup = function (ev, data, extraParams, calledFor, casitasData) {
            $mdDialog.show({
                controller: 'BulkUpdateDialogCont',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/rateRule/dialogs/bulk-update-dialog.html',
                parent: angular.element($document.find('#product-container')),
                targetEvent: ev,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                locals: {
                    RoomsRateChannel: data.roomsData,
                    RateData: data.ratePlansData,
                    channelsData: data.channelsData,
                    Rooms_sub_hotel_ids: vm.Rooms_sub_hotel_ids,
                    pageFrom: calledFor,
                    // pageFrom            : 'rateCalander',
                    extraParams: extraParams,
                    casitas_data: casitasData
                }
            }).then(function () {
                vm.getAllMlsInListView(vm.level);
            });
        }



        /**
        * Get data for inhouse customers
        */
        vm.inHouseCustomers = function (sortColumn, sortType) {
            vm.tempData.sortColumn = (sortColumn != undefined && sortColumn != '') ? sortColumn : 'product_room_number';
            vm.tempData.sortType = (sortType != undefined && sortType != '') ? sortType : 'ASC';

            dashboardGraphService.getInHouseCustomers(vm.tempData)
                .then(function (response) {
                    vm.inHouseCustLoadear = false;
                    vm.todayInHouseCustomers = response !== undefined ? response.result : [];
                });
        };

        /**
        * Get availability for hotel
        */
        vm.getAvailability = function () {
            vm.availabilityLoader = true;
            var previousCollapseState = angular.copy(vm.collapsebleRoom);

            var data = angular.copy(vm.tempData);
            data.minDays = $(window).width() > 2500 ? 13 : ($(window).width() > 1900 ? 9 : 6);
            dashboardGraphService.getAvailabilityStatus(data)
                .then(function (response) {
                    if (response.data !== undefined) {
                        vm.topHeadDates = response.dates;
                        if (response.roomTypeRates) {
                            vm.roomTypeRates = response.roomTypeRates;
                            vm.roomNumberResults = response.roomNumberResults;
                            vm.unAvailableDates = response.unAvailableDates;
                            vm.collapsebleRoom = [];
                            angular.forEach(response.roomTypeRates, function (roomType) {
                                if (roomType.room_type_id && previousCollapseState[roomType.room_type_id]) {
                                    vm.collapsebleRoom[roomType.room_type_id] = true;
                                }
                            });
                        } else {
                            vm.collapsebleRoom = [];
                            vm.availableRooms = response.data;
                            vm.availableRoomsDates = response.result;
                        }
                    }
                    vm.availabilityLoader = false;
                });
        };


        vm.tempChanneldata = function () {
            // var requestParams = {
            //     'data' : vm.tempData,
            //     'room_type_id' : type_id
            // };
            dashboardGraphService.getAllRoomMLS(vm.tempData)
                .then(function (response) {
                    vm.mlsDays = response['mlsData']['dates'];
                    vm.availableMlsRooms = response['mlsData']['rooms'];
                    vm.mlsDays = response['mlsData']['dates'];
                    vm.mlsRoomDates = response['mlsData']['result'];
                });
        }

        /**
        * Show popup to book reservation
        */
        vm.showResvBookPopup = function (availStatus, date, productId, roomName) {
            if (availStatus !== '' && availStatus === 'available') {
                var temp = {
                    'product_id': productId,
                    'room_stay_from': moment(date).format('YYYY-MM-DD'),
                    'room_stay_to': moment(date).add(1, 'days').format("YYYY-MM-DD"),
                    'called_from': 'BACK_END',
                    'requestFor': vm.pageFor,
                    'product_name': roomName
                };
                vm.availabilityLoader = true;
                ganttChartService.checkAvailabilityForDates(temp)
                    .then(function (response) {
                        vm.availabilityLoader = false;
                        temp.pageType = vm.pageFor;
                        var print = '';
                        var dialogTitle = '';
                        if (response.success) {
                            if ((response.mls_days && response.mls_days > 0) || (response.stop_sell && response.stop_sell == 'yes')) {
                                if (response.mls_days) {
                                    print = ' MLS for ' + response.mls_days + ' nights';
                                    dialogTitle = 'Minimum length of stay';
                                } else {
                                    print = ' Stop Sell';
                                    dialogTitle = 'Stop Sell';
                                }
                                $mdDialog.show({
                                    controller: 'confirmPageController',
                                    controllerAs: 'vm',
                                    templateUrl: 'app/main/apps/dashboards/gantt-chart/confirmationPage.html',
                                    parent: angular.element(document.body),
                                    targetEvent: event,
                                    clickOutsideToClose: true,
                                    locals: {
                                        title: dialogTitle,
                                        htmlContent: 'Selected dates have' + print + '. Do you want to continue?',
                                        btnTxt: 'Continue',
                                        cancelTxt: 'Cancel',
                                        localData: { invertButtonColors: true }
                                    }
                                }).then(function (response) {
                                    if (typeof response.answer != 'undefined' && response.answer == 'update') {
                                        showAvailPopup(temp);
                                    }
                                });
                                // End for New Pop Up
                            } else {
                                showAvailPopup(temp);
                            }
                        } else {
                            vm.getAvailability();
                            toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                        }
                    });
            }
        };

        function showAvailPopup(temp) {
            $mdDialog.show({
                controller: 'resSearchController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/dashboards/dash-views/availability/res-search.html',
                targetEvent: {},
                clickOutsideToClose: true,
                locals: {
                    dialogData: temp,
                    parentScope: $scope,
                    mode_of_call: 'add'
                },
                onRemoving: function (event) {
                    vm.getAvailability();
                }
            });
        }
        /*****************************************/
        /******** Reservation Sales data *********/
        /*****************************************/
        vm.otaCommissionSale = function () {
            dashboardGraphService.reservationSales(vm.tempData)
                .then(function (response) {
                    if (response.result !== undefined && response.result.length) {
                        vm.sales = response.result;
                        $scope.otaSalesConfig = {
                            chart: {
                                type: 'column'
                            },
                            title: {
                                text: ''
                            },
                            credits: {
                                enabled: false
                            },
                            colors: response.colorCodes,
                            xAxis: {
                                categories: response.dates
                            },
                            yAxis: {
                                min: -50,
                                title: {
                                    text: ''
                                }
                            },
                            tooltip: {
                                formatter: function () {
                                    var numb = 0;
                                    var s = '<b>' + this.x + '</b>';
                                    $.each(this.points, function () {
                                        numb = this.y;
                                        numb = -numb > 0 ? -numb : numb;
                                        s += '<br/><span style="color:{series.color}"><b>' + this.series.name + '</b></span>: $' +
                                            numb.format(2, 3, ',', '.');
                                    });
                                    return s;
                                },
                                // pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>${point.y.format(2, 3, ',', '.')}</b><br/>',
                                shared: true
                            },
                            plotOptions: {
                                column: {
                                    stacking: 'normal'
                                }
                            },
                            series: vm.sales
                        };
                    } else {
                        vm.otaSalesExist = false;
                    }
                    vm.otaSaleLoader = false;
                });
        };

        /*****************************************/
        /********* Reservation channels **********/
        /*****************************************/

        vm.channelReservations = function () {
            var channelRequest = angular.copy(vm.tempData);
            channelRequest.resDist = true;
            dashboardGraphService.reservationByChannels(channelRequest)
                .then(function (response) {
                    if (response.result !== undefined && response.result.length > 0) {
                        vm.resPieChartExist = true;
                        vm.channelWiseData = response.result;
                        vm.channelTotal = response.total || {};

                        $scope.channelsConfig = {
                            chart: {
                                plotBackgroundColor: null,
                                plotBorderWidth: null,
                                plotShadow: false,
                                type: 'pie'
                            },
                            credits: {
                                enabled: false
                            },
                            colors: response.colorCodes,
                            title: {
                                text: ''
                            },
                            tooltip: {
                                pointFormat: '{series.name}: <b>${point.y:.2f}</b> <br> Bookings: <b>{point.count}</b>',
                                style: { fontSize: '15px' }
                            },
                            plotOptions: {
                                pie: {
                                    allowPointSelect: true,
                                    cursor: 'pointer',
                                    dataLabels: {
                                        enabled: false
                                    },
                                    showInLegend: true,
                                    point: {
                                        events: {
                                            click: function () {
                                                vm.openChannelBookingsDetail({
                                                    name: this.name,
                                                    count: this.count
                                                });
                                            }
                                        }
                                    }
                                }
                            },
                            series: [{
                                name: 'Sale',
                                colorByPoint: true,
                                data: vm.channelWiseData
                            }]
                        };
                    } else {
                        vm.resPieChartExist = false;
                        vm.channelWiseData = [];
                        vm.channelTotal = {};
                    }
                    vm.resChannelsLoader = false;
                });
        };

        /*****************************************/
        /********* Courtesy Hold status pie ******/
        /*****************************************/
        vm.courtesyHoldStatusPie = function () {
            var holdRequest = angular.copy(vm.tempData);
            dashboardGraphService.courtesyHoldStatusPie(holdRequest)
                .then(function (response) {
                    if (response && response.total && response.total.count > 0) {
                        vm.courtesyHoldPieExist = true;
                        vm.courtesyHoldData = response.result || [];
                        vm.courtesyHoldTotal = response.total || {};
                        var pieSeries = (response.pieData && response.pieData.length)
                            ? response.pieData
                            : vm.courtesyHoldData;

                        $scope.courtesyHoldConfig = {
                            chart: {
                                plotBackgroundColor: null,
                                plotBorderWidth: null,
                                plotShadow: false,
                                type: 'pie'
                            },
                            credits: {
                                enabled: false
                            },
                            colors: response.colorCodes,
                            title: {
                                text: ''
                            },
                            tooltip: {
                                pointFormat: 'Count: <b>{point.count}</b>',
                                style: { fontSize: '15px' }
                            },
                            plotOptions: {
                                pie: {
                                    allowPointSelect: true,
                                    cursor: 'pointer',
                                    dataLabels: {
                                        enabled: false
                                    },
                                    showInLegend: true,
                                    point: {
                                        events: {
                                            click: function () {
                                                vm.openCourtesyHoldReport(this.name);
                                            }
                                        }
                                    }
                                }
                            },
                            series: [{
                                name: 'Courtesy Holds',
                                colorByPoint: true,
                                data: pieSeries
                            }]
                        };
                    } else {
                        vm.courtesyHoldPieExist = false;
                        vm.courtesyHoldData = [];
                        vm.courtesyHoldTotal = {};
                    }
                    vm.courtesyHoldLoader = false;
                });
        };

        vm.openCourtesyHoldReport = function (statusName) {
            if (!vm.canViewCourtesyHoldReport()) {
                return;
            }
            var statusMap = {
                'Email Sent': 'email_sent',
                'Clicked': 'clicked',
                'Converted': 'converted'
            };
            var params = {
                start: moment(vm.tempData.startDate).format('YYYY-MM-DD'),
                end: moment(vm.tempData.endDate).format('YYYY-MM-DD')
            };
            if (statusName && statusMap[statusName]) {
                params.status = statusMap[statusName];
            }
            $state.go('app.reports.hold-report', params);
        };


        /*****************************************/
        /********* Room status graph chart********/
        /*****************************************/
        vm.roomStatus = function () {
            dashboardGraphService.roomStatusGraphChart({ type: vm.pageFor })
                .then(function (response) {
                    if (response.result !== undefined) {
                        vm.roomStatusPieChart = response.result;
                        vm.roomStatusChart = [
                            ['In Cleaning', parseInt(response.result.inCleaning)],
                            ['Available', parseInt(response.result.available)],
                            ['Out of Service', parseInt(response.result.outOfService)]
                        ];

                        $scope.roomStatusConfig = {
                            colors: ['#24BCD1', '#303540', '#FF5861'],
                            chart: {
                                plotBackgroundColor: null,
                                plotBorderWidth: 0,
                                plotShadow: false,
                                height: "300px",
                                redraw: true
                            },
                            credits: {
                                enabled: false
                            },
                            title: {
                                text: '',
                                align: 'left',
                                verticalAlign: 'left',
                                y: 5
                            },
                            plotOptions: {
                                pie: {
                                    allowPointSelect: true,
                                    slicedOffset: 0,
                                    cursor: 'pointer',
                                    dataLabels: {
                                        enabled: false,
                                        distance: -50,
                                        style: {
                                            color: 'black'
                                        }
                                    },
                                    center: ['50%', '50%'],
                                    events: {
                                        click: function (event) {
                                            vm.showRecordsWithFilter('room_status', event.point);
                                        }
                                    }
                                }
                            },
                            tooltip: {
                                formatter: function () {
                                    return '<span><b>' + this.point.name + '</b></span>: ' + this.point.y;
                                }
                            },
                            series: [{
                                type: 'pie',
                                name: '',
                                innerSize: '50%',
                                data: vm.roomStatusChart
                            }]
                        };
                    } else {
                        vm.roomStatusExist = false;
                    }
                    vm.roomStatusLoader = false;
                });
        };

        vm.quickStatsData = function (statFor) {
            vm.updateTempData();
            var startDate, endDate = '';

            if (vm.tempData.startDate && vm.tempData.endDate) {
                startDate = vm.tempData.startDate;
                endDate = vm.tempData.endDate;
            }

            var selectedRevDates = $localStorage['dashboard_revenue_dates'];

            if (selectedRevDates && selectedRevDates.dateStart && selectedRevDates.dateEnd) {
                startDate = selectedRevDates.dateStart;
                endDate = selectedRevDates.dateEnd;
            }
            vm.progressValue = 0;

            if (progressInterval) {
                $interval.cancel(progressInterval);
            }

            progressInterval = $interval(function () {
                if (vm.progressValue < 90) {
                    vm.progressValue += 1;
                } else if (vm.progressValue < 95) {
                    vm.progressValue += 0.2;
                }
            }, 80);

            vm.quickStatsLoader = true;
            vm.quickStatsType = statFor;
            vm.setQuickStatsSelectedTab(vm.quickStatsType);

            dashboardGraphService.quickStats(vm.pageFor, statFor, startDate, endDate, vm.tempData.sub_hotel_id)
                .then(function (response) {
                    var quickStatsResponse = (response && response.result) ? response.result : response;

                    if (quickStatsResponse && quickStatsResponse.roomsSold !== undefined) {
                        vm.quickStats = quickStatsResponse;
                        vm.quickStatsHoverInfo = quickStatsResponse.hoverInfo || response.hoverInfo || {};
                        vm.progressValue = 100;
                        $timeout(function () {
                            vm.quickStatsLoader = false;
                            if (progressInterval) {
                                $interval.cancel(progressInterval);
                            }
                        }, 300);
                    }
                });
        };

        vm.setQuickStatsSelectedTab = function (type) {
            switch (type) {
                case 'custom-range':
                    vm.selectedQuickStatsTab = 0;
                    break;
                case 'week':
                    vm.selectedQuickStatsTab = 1;
                    break;
                case 'month':
                    vm.selectedQuickStatsTab = 2;
                    break;
                case 'year':
                    vm.selectedQuickStatsTab = 3;
                    break;
            }
        };

        vm.redirectToResvDetail = function (type) {
            vm.updateTempData();
            let hotelBoatType = vm.pageFor == 'room' ? 'hotel' : 'boat';
            var getData = 'revenueManagement&' + type + '&' + vm.quickStatsType + '&' + hotelBoatType;
            var startDate = '';
            var endDate = '';

            if (vm.quickStatsType == 'custom-range') {
                var selectedRevDates = $localStorage['dashboard_revenue_dates'];

                if (selectedRevDates && selectedRevDates.dateStart && selectedRevDates.dateEnd) {
                    startDate = selectedRevDates.dateStart;
                    endDate = selectedRevDates.dateEnd;
                } else if (vm.tempData.startDate && vm.tempData.endDate) {
                    startDate = vm.tempData.startDate;
                    endDate = vm.tempData.endDate;
                } else if (vm.revenuePicker.dateStart && vm.revenuePicker.dateEnd) {
                    startDate = moment(vm.revenuePicker.dateStart).format('YYYY-MM-DD');
                    endDate = moment(vm.revenuePicker.dateEnd).format('YYYY-MM-DD');
                }

                if (startDate && endDate) {
                    getData += '&' + startDate + '&' + endDate;
                }
            }

            if (vm.selectedPropertyId && vm.selectedPropertyId !== 'all') {
                getData += '&' + vm.selectedPropertyId;
            }

            var url = $state.href("app.reports.detail", { param: getData });
            $window.open(url, '_blank');
        }

        vm.openChannelBookingsDetail = function (channel, startDateOverride, endDateOverride) {
            if (!channel || !channel.name) {
                return;
            }

            var hotelBoatType = vm.pageFor == 'room' ? 'hotel' : 'boat';
            var startDate = startDateOverride || (vm.tempData && vm.tempData.startDate ? vm.tempData.startDate : '');
            var endDate = endDateOverride || (vm.tempData && vm.tempData.endDate ? vm.tempData.endDate : '');
            var channelKey = String(channel.name).replace(/ /g, '_').replace(/\./g, '~');

            if (!startDate || !endDate) {
                return;
            }

            var getData = 'revenueManagement&channelBookings&custom-range&' + hotelBoatType + '&' + startDate + '&' + endDate + '&' + channelKey;
            getData = vm.appendRevenueSubHotelParam(getData);
            var url = $state.href("app.reports.detail", { param: getData });
            $window.open(url, '_blank');
        }

        /*****************************************/
        /******** Reservation Distribution *******/
        /*****************************************/
        vm.resDistributionData = function () {
            dashboardGraphService.reservationDistribution(vm.tempData)
                .then(function (response) {
                    if (response.result !== undefined && response.result.length) {
                        vm.reservation_distribution = response.result;
                        vm.datesFormat = response.datesFormat;
                        $scope.resDistributionConfig = {

                            title: {
                                text: ''
                            },
                            credits: {
                                enabled: false
                            },
                            subtitle: {
                                text: ''
                            },
                            xAxis: {
                                categories: vm.datesFormat
                            },
                            yAxis: {
                                title: {
                                    text: 'Number of Reservations'
                                }
                            },
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom'
                            },

                            plotOptions: {
                                series: {
                                    cursor: 'pointer',
                                    label: {
                                        connectorAllowed: false
                                    },
                                    point: {
                                        events: {
                                            click: function () {
                                                var pointDate = this.category || (vm.datesFormat && vm.datesFormat[this.x]);
                                                if (!pointDate || !this.series || !this.series.name) {
                                                    return;
                                                }
                                                vm.openChannelBookingsDetail({ name: this.series.name }, pointDate, pointDate);
                                            }
                                        }
                                    }
                                },
                                maxWidth: 200
                            },
                            series: vm.reservation_distribution,

                            responsive: {
                                rules: [{
                                    condition: {
                                        maxWidth: 500
                                    },
                                    chartOptions: {
                                        legend: {
                                            layout: 'horizontal',
                                            align: 'center',
                                            verticalAlign: 'bottom'
                                        }
                                    }
                                }]
                            }
                        };
                    } else {
                        vm.resDistributionExist = false;
                    }
                    vm.resDistributionLoader = false;
                });
        };
        /*****************************************/
        /********* Property Performance **********/
        /*****************************************/
        vm.propertyPerformance = function () {
            dashboardGraphService.propertyPerformance(vm.tempData)
                .then(function (response) {
                    if (response.result !== undefined && response.result.dates !== undefined && response.result.dates.length) {
                        vm.revLoader = false;
                        vm.propertyMonths = response.result.dates;
                        vm.propertyOccupancy = response.result.occupancyPerc;
                        vm.propertyAdr = response.result.adr;
                        vm.revPAR = response.result.revPar;

                        $scope.propPerfConfig = {
                            title: {
                                text: ''
                            },
                            credits: {
                                enabled: false
                            },
                            colors: ['#24BCD1', '#303540', '#FF5861'],
                            xAxis: {
                                categories: vm.propertyMonths
                            },
                            yAxis: {
                                text: ''
                            },
                            tooltip: {
                                formatter: function () {
                                    var s = '<b>' + this.x + '</b><br/>';
                                    if (this.series.name.toLowerCase() == 'occupancy') {
                                        s += '<br/><span><b>' + this.series.name + '</b></span>: ' + this.y.format(2, 3, ',', '.') + '%';
                                    } else {
                                        s += '<br/><span><b>' + this.series.name + '</b></span>: $' + this.y.format(2, 3, ',', '.');
                                    }
                                    return s;
                                }
                            },
                            series: [{
                                type: 'column',
                                name: 'Occupancy',
                                data: vm.propertyOccupancy
                            }, {
                                type: 'column',
                                name: 'ADR',
                                data: vm.propertyAdr
                            }, {
                                type: 'column',
                                name: 'RevPAR',
                                data: vm.revPAR
                            }]
                        };

                        $scope.revParConfig = {
                            chart: {
                                type: 'area'
                            },
                            title: {
                                text: ''
                            },
                            credits: {
                                enabled: false
                            },
                            subtitle: {
                                text: ''
                            },
                            colors: ['#FF5861'],
                            xAxis: {
                                categories: vm.propertyMonths
                            },
                            yAxis: {
                                title: {
                                    text: ''
                                },
                                labels: {
                                    formatter: function () {
                                        return this.value;
                                    }
                                }
                            },
                            tooltip: {
                                formatter: function () {
                                    var s = '<b>' + this.x + '</b><br/>';
                                    s += '<br/><span><b>' + this.series.name + '</b></span>: $' + this.y.format(2, 3, ',', '.');
                                    return s;
                                }
                            },
                            plotOptions: {
                                series: {
                                    fillColor: {
                                        linearGradient: [0, 0, 0, 300],
                                        stops: [
                                            [0, '#FF5861'],
                                            [1, 'rgba(255, 0, 0, 0.2)']
                                        ]
                                    }
                                },
                                area: {
                                    stacking: 'normal',
                                    lineColor: '#666666',
                                    lineWidth: 0,
                                    marker: {
                                        lineWidth: 0
                                    }
                                }
                            },

                            series: [{
                                name: 'RevPAR',
                                data: vm.revPAR
                            }]
                        };
                    }
                });
        }

        /*****************************************/
        /******* Get Expected Rooms Count ********/
        /*****************************************/
        vm.addExpected = function (value, empty) {
            return parseInt(value + empty);
        }

        /*****************************************/
        /******* Get Expected Rooms Sold *********/
        /*****************************************/
        vm.getTotalExpectedRooms = function (totalRooms, type) {
            var days = 7;
            switch (type) {
                case 'month':
                    days = 30;
                    break;
                case 'year':
                    days = 365;
                    break;
                default:
                    days = 7;
                    break;
            }
            return parseInt(totalRooms * days);
        }

        /*****************************************/
        /*** Get sales POS day/week/Month/Year ***/
        /*****************************************/
        vm.getSalesPos = function (type) {
            vm.updateTempData();
            vm.salesPosType = type;
            vm.setSalesPosSelectedTab(type);
            vm.salesPosLoader = true;

            var startDate = '';
            var endDate = '';

            if (vm.tempData.startDate && vm.tempData.endDate) {
                startDate = vm.tempData.startDate;
                endDate = vm.tempData.endDate;
            }

            var selectedRevDates = $localStorage['dashboard_revenue_dates'];

            if (selectedRevDates && selectedRevDates.dateStart && selectedRevDates.dateEnd) {
                startDate = selectedRevDates.dateStart;
                endDate = selectedRevDates.dateEnd;
            }

            dashboardGraphService.getSalesPos(type, vm.tempData.typeFor, startDate, endDate, vm.tempData.sub_hotel_id)
                .then(function (response) {
                    vm.salesPosLoader = false;

                    vm.salesRetail = {};
                    vm.salesRetail.type = type;
                    vm.salesRetail.dateValues = response.dateValues;
                    vm.salesRetail.saleHeading = response.salesHeading;
                    vm.salesRetail.retail = (response.retail !== undefined && response.retail.sales !== undefined) ? response.retail.sales : 0;
                    vm.salesRetail.barRes = (response.bar !== undefined && response.bar.sales !== undefined) ? response.bar.sales : 0;
                });
        }

        vm.setSalesPosSelectedTab = function (type) {
            switch (type) {
                case 'custom-range':
                    vm.selectedSalesPosTab = 0;
                    break;
                case 'day':
                    vm.selectedSalesPosTab = 1;
                    break;
                case 'week':
                    vm.selectedSalesPosTab = 2;
                    break;
                case 'month':
                    vm.selectedSalesPosTab = 3;
                    break;
                case 'year':
                    vm.selectedSalesPosTab = 4;
                    break;
            }
        };

        /**
        * Get latest tasks
        */
        vm.latestTasksData = function () {
            dashboardGraphService.getLatestTasks(vm.tempData)
                .then(function (response) {
                    vm.latestTasks = response.results;
                    vm.latestTasksLoader = false;
                });
        };

        Number.prototype.format = function (n, x, s, c) {
            var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
                num = this.toFixed(Math.max(0, ~~n));

            return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
        };

        vm.showRoomStatus = function (type, number) {
            var tempEvent = {
                name: type
            };

            if (number > 0) {
                vm.showRecordsWithFilter('room_status', tempEvent);
            }
        };

        /**
        * @param: Integer resId
        * @param: String confNo
        * Comment: Open reservations page in new tab
        */
        vm.openReservationPage = function (resId, confNo) {
            ganttChartServiceNew.redirectToResvPage(vm.pageFor, confNo, resId);
        };

        vm.isRoomLockEncoderVisible = function () {
            return $rootScope.isRoomLockEncoderVisible();
        };

        vm.openKeyCardDialog = function (ev, reservation) {
            if (ev && ev.stopPropagation) {
                ev.stopPropagation();
            }
            ev.preventDefault();
            eCommerceService.openKeyCardDialog(ev, reservation, 'dashboard');
        };

        /**
        * Move to listing page on click
        */
        vm.showRecordsWithFilter = function (type, event) {
            switch (type) {
                case 'room_status':
                    var roomStatus = event.name.replace(/ /g, "_");
                    args = "roomStatus=" + roomStatus;
                    break;

                default:
                    break;
            }

            // $state.go('app.graphDetail', { param:args, type:true }, { reload: true } );
            var url = $state.href('app.graphDetail', { param: args, type: true }, { reload: true });
            $window.open(url, '_blank');
        };

        vm.checkInCheckoutClicket = function (reqtype, reservationType) {
            args = '';
            reqtype = (reqtype == 'Check In') ? 'check_in' : 'check_out';
            if (reservationType === 'boat') {
                args = "marina=" + reqtype;
            } else {
                args = "reservation=" + reqtype;
            }
            // $state.go('app.graphDetail', { param:args, type:true }, { reload: true } );

            var url = $state.href("app.graphDetail", { param: args, type: true }, { reload: true });
            $window.open(url, '_blank');
        };

        /**
        * Get data for shoppers on site from Frontend
        */
        vm.getShoppersOnSite = function () {
            var data = {
                'startDate': vm.frontDeskPicker.dateStart,
                'endDate': vm.frontDeskPicker.dateEnd,
                'pageFor': vm.pageFor
            }
            dashboardGraphService.getShoppersOnSite(data)
                .then(function (response) {
                    vm.shoppersOnSite = response;
                });
        }

        /*
        ** Sort columns in in-house portlet
        */
        vm.sortCustom = function (columnName, sortType) {
            vm.inHouseCustLoadear = true;
            var type = (sortType == "ASC" || sortType == "") ? "DESC" : "ASC";
            var sortColumn = '';
            vm.nameSortType = vm.badgeSortType = vm.roomSortType = vm.checkInSortType = vm.checkOutSortType = vm.guestSortType = '';
            vm.selectedColumn = columnName;
            switch (columnName) {
                case 'name': sortColumn = 'traveller.first_name'; vm.nameSortType = type; break;
                case 'cc_is_incidental': sortColumn = 'cc_is_incidental'; vm.badgeSortType = type; break;
                case 'product_name': sortColumn = 'product_name'; vm.roomSortType = type; break;
                case 'room_stay_from': sortColumn = 'res.room_stay_from'; vm.checkInSortType = type; break;
                case 'room_stay_to': sortColumn = 'res.room_stay_to'; vm.checkOutSortType = type; break;
                case 'guests': sortColumn = 'guests'; vm.guestSortType = type; break;
            }
            vm.inHouseCustomers(sortColumn, sortType);
        }

        /**
        * @param: String columnName
        * @param: String sortType
        * @param: String checkInType
        * Comment: Sort columns in check in and out portlet list
        */
        vm.sortCheckInOut = function (columnName, sortType, checkInType) {
            var type = (sortType == "ASC" || sortType == "") ? "DESC" : "ASC";
            var sortColumn = '';
            vm.checkInNameSortType[checkInType] = vm.checkInPortSortType[checkInType] = vm.checkOutPortSortType[checkInType] = vm.checkRemSortType[checkInType] = '';
            vm.selectedCheckInColumn[checkInType] = columnName;
            switch (columnName) {
                case 'name': sortColumn = 'traveller.first_name'; vm.checkInNameSortType[checkInType] = type; break;
                case 'room_stay_from': sortColumn = 'res.room_stay_from'; vm.checkInPortSortType[checkInType] = type; break;
                case 'room_stay_to': sortColumn = 'res.room_stay_to'; vm.checkOutPortSortType[checkInType] = type; break;
                case 'total_remaining_amount': sortColumn = 'res.total_remaining_amount'; vm.checkRemSortType[checkInType] = type; break;
            }
            vm.checkInOutPortlets(sortColumn, sortType, checkInType);
        };

        /**
        * @param: String sortColumn
        * @param: String sortType
        * @param: String type
        * @return: Array of objects
        * Comment: fetch values for checkin and out portlets from database
        */
        vm.checkInOutPortlets = function (sortColumn, sortType, type) {
            vm.tempData.sortColumn = (sortColumn != undefined && sortColumn != '') ? sortColumn : 'product_room_number';
            vm.tempData.sortType = (sortType != undefined && sortType != '') ? sortType : 'ASC';
            vm.tempData.checkInType = (type != undefined && type != '') ? type : 'checkIn';
            vm.tempData.pageFor = vm.pageFor !== undefined && vm.pageFor !== '' ? vm.pageFor : 'room';

            vm.checkInOutLoader[type] = true;
            dashboardGraphService.getCheckInOutResvList(vm.tempData)
                .then(function (response) {
                    vm.checkInOutLoader[type] = false;
                    vm.checkInOutList[type] = response.data;
                    if (type == 'checkIn') {
                        vm.dashboardData.todayCheckIn = response.todayCheckIn;
                        vm.dashboardData.todayCheckInExpected = response.todayCheckInExpected;
                        vm.dashboardData.todayCheckInRemaining = response.todayCheckInRemaining;
                        vm.dashboardData.precheckin_started_count = response.precheckin_started_count;
                        vm.dashboardData.precheckin_completed_count = response.precheckin_completed_count;
                    } else if (type == 'dailyRentals') {
                        vm.dashboardData.todayDailyRentals = response.todayDailyRentals;
                        vm.dashboardData.todayDailyRentalsExpected = response.todayDailyRentalsExpected;
                        vm.dashboardData.todayDailyRentalsRemaining = response.todayDailyRentalsRemaining;
                    } else {
                        vm.dashboardData.todayCheckOut = response.todayCheckOut;
                        vm.dashboardData.todayCheckOutExpected = response.todayCheckOutExpected;
                        vm.dashboardData.todayCheckOutRemaining = response.todayCheckOutRemaining;
                    }
                });
        };

        function getAllowCheckoutWithPendingDuesSetting() {
            var data = {
                hotel_id: vm.currentHotelId,
                attribute_code: 'allowCheckoutWithPendingDues',
                setting_type: 'general'
            };

            return eCommerceService.getGeneralSettings(data).then(function (payload) {
                var settings = payload && payload.settings ? payload.settings : payload || {};
                var hotelSettings = settings[vm.currentHotelId] || settings[String(vm.currentHotelId)];
                var parentSettings = settings[1] || settings['1'];
                var settingValue = readSettingValue(hotelSettings);

                if (isEmptyValue(settingValue)) {
                    settingValue = readSettingValue(parentSettings);
                }

                return toBooleanOrDefault(settingValue, true);
            }, function () {
                return true;
            });

            function readSettingValue(settingsObj) {
                if (!settingsObj || typeof settingsObj !== 'object') {
                    return undefined;
                }
                return settingsObj.allowCheckoutWithPendingDues;
            }

            function isEmptyValue(value) {
                return typeof value === 'undefined' || value === null || value === '';
            }

            function toBooleanOrDefault(value, defaultValue) {
                if (value === true || value === 1 || value === '1') {
                    return true;
                }
                if (value === false || value === 0 || value === '0') {
                    return false;
                }
                return defaultValue;
            }
        }

        function showPendingCheckoutBlockedPopup() {
            var html = 'This reservation still has an unpaid balance. Collect or adjust the remaining amount before you can check out.';
            $mdDialog.show({
                controller: 'confirmController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    title: 'Outstanding balance',
                    htmlContent: html,
                    cancelBtn: 'none',
                    OkBtn: 'OK'
                }
            });
        }

        /**
        * @param: String newStatus
        * @param: Integer index
        * @param: String checkInOutType
        * @return: Boolean
        * Comment: Change the status of reservation to checkin / checkout
        */
        vm.changeCheckInOutStatus = function (newStatus, index, checkInOutType) {
            var selectedrow = vm.checkInOutList[checkInOutType][index];
            selectedrow.name = selectedrow.first_name + ' ' + selectedrow.last_name;
            selectedrow.resvType = vm.pageFor;
            var remainingBalance = parseFloat(selectedrow.total_remaining_amount);
            var isCheckoutStatus = String(newStatus || '').toLowerCase() === 'checked-out';

            if (isCheckoutStatus) {
                ganttChartServiceNew.blockCheckoutIfBorrowedItems(selectedrow).then(function (result) {
                    if (result && result.blocked) {
                        return;
                    }
                    continueAfterBorrowedItemsCheck();
                });
                return;
            }

            continueAfterBorrowedItemsCheck();

            function continueAfterBorrowedItemsCheck() {
            if (isCheckoutStatus && !isNaN(remainingBalance) && remainingBalance > 0) {
                vm.checkInOutLoader[checkInOutType] = true;
                getAllowCheckoutWithPendingDuesSetting().then(function (allowCheckout) {
                    if (!allowCheckout) {
                        vm.checkInOutLoader[checkInOutType] = false;
                        showPendingCheckoutBlockedPopup();
                        return;
                    }

                    proceedStatusChange();
                });
                return;
            }

            proceedStatusChange();
            }

            function proceedStatusChange() {
                vm.checkInOutLoader[checkInOutType] = true;
                ganttChartServiceNew.processStatusRequest(selectedrow, newStatus, remainingBalance, 'dashboardPortlet').then(function (result) {
                    vm.checkInOutLoader[checkInOutType] = false;
                    if (result.hitRequest) {
                        vm.checkInOutPortlets('product_room_number', 'ASC', checkInOutType);
                    }
                });
            }
        };

        /**
         * Mark Active reservation as Waiting for Room (early arrival / room not ready).
         */
        vm.isWaitingForRoom = function (resv) {
            return eCommerceService.isWaitingForRoom(resv);
        };

        vm.setWaitingForRoom = function (event, index, checkInOutType) {
            var selectedrow = vm.checkInOutList[checkInOutType][index];
            if (!selectedrow) {
                return;
            }

            eCommerceService.confirmAndSetWaitingForRoom(selectedrow, event, {
                onRequestStart: function () {
                    vm.checkInOutLoader[checkInOutType] = true;
                },
                onRequestEnd: function () {
                    vm.checkInOutLoader[checkInOutType] = false;
                }
            });
        };

        /**
        * @param: Object reservation
        * @param: Event event
        * Comment: Redirect to resv page and open split popup
        */
        vm.redirectToSplitReservation = function (reservation, event) {
            event.stopPropagation();
            // $localStorage[vm.currentHotelId+reservation.reservation_id+"splitPopUp"] = true;
            $localStorage[vm.currentHotelId + reservation.reservation_id + "consolidatePopup"] = true;
            ganttChartServiceNew.redirectToResvPage(reservation.type_of_reservation, reservation.confirmation_number, reservation.reservation_id);
        }

        /* to delete the mls start */
        vm.deleteMls = function (value, $event, ev) {
            var title = '';
            if (value.is_stop_sell !== undefined) {
                title = 'Stop Sell';
            } else if (value.is_cta !== undefined) {
                title = 'Close To Arrival';
            } else if (value.is_ctd !== undefined) {
                title = 'Close To Departure';
            } else if (value.min_stay !== undefined) {
                title = 'Minimum Length of Stay';
            }
            var html = 'Are you sure, you want to remove the restrictions for selected row?</br>';
            $mdDialog.show({
                controller: 'confirmController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                    title: title,
                    htmlContent: html,
                    cancelBtn: 'Cancel',
                    OkBtn: 'Ok'
                }
            }).then(function (answer) {
                if (typeof answer != 'undefined' && answer == 'update') {
                    var tempValue = JSON.stringify(value);
                    tempValue = JSON.parse(tempValue);

                    tempValue.startDate = vm.convertDateFormat(tempValue.startDate);
                    tempValue.endDate = vm.convertDateFormat(tempValue.endDate);

                    var delData = {
                        'channel_id': tempValue.channel_ids,
                        'room_type_id': tempValue.rooms_ids,
                        'startDate': moment(tempValue.startDate).format('YYYY-MM-DD'),
                        'endDate': moment(tempValue.endDate).format('YYYY-MM-DD'),
                        'hotel_id': $localStorage.preHotelId,
                        'called_from': vm.restrictionLevel
                    }
                    if (value.is_stop_sell !== undefined) {
                        delData.is_stop_sell = tempValue.is_stop_sell;
                    } else if (value.is_cta !== undefined) {
                        delData.is_cta = tempValue.is_cta;
                    } else if (value.is_ctd !== undefined) {
                        delData.is_ctd = tempValue.is_ctd;
                    } else if (value.min_stay !== undefined) {
                        delData.min_stay = tempValue.min_stay;
                    }
                    console.log(delData);
                    dashboardGraphService.deleteMlsforRoom(delData).then(function (response) {
                        vm.MLSlistView = response['data'];
                        vm.showremoveMLSLoader = false;
                    });
                }
            });
        }

        vm.convertDateFormat = function (date) {
            var splitDate = [];
            splitDate = date.split('-');
            var derivedDate = '';
            splitDate[0] = parseInt(splitDate[0]) < 10 ? '0' + parseInt(splitDate[0]) : splitDate[0];
            splitDate[1] = parseInt(splitDate[1]) < 10 ? '0' + parseInt(splitDate[1]) : splitDate[1];
            derivedDate = splitDate[2] + '-' + splitDate[0] + '-' + splitDate[1];
            return derivedDate;
        };
        /* to delete the mls end */

        var getViewPortWidth = function () {
            var d = $document[0];
            return d.documentElement.clientWidth || d.documentElement.getElementById('body')[0].clientWidth;
        };

        var getViewPortHeight = function () {
            var d = $document[0];
            return d.documentElement.clientHeight || d.documentElement.getElementById('body')[0].clientHeight;
        };

        vm.showMLSPopup = function (mls, room_name) {

            var invalid = /[°"§%()\[\]{}=\\?´`'#<>|,;.:+_ ]+/g;
            var room_name_nospace = room_name.replace(invalid, "");

            if ((mls.availability == 'available' || mls.available) && mls.mls != '' && mls.mls > 1) {

                var tooltipTop, tooltipBottom, tooltipLeft, tooltipWidth;
                var tooltipHeight;
                if (getViewPortWidth() >= 3500) {
                    tooltipHeight = 200;
                    tooltipWidth = 340;
                } else {
                    tooltipHeight = 160;
                    tooltipWidth = 365;
                }

                var div3 = angular.element(document.getElementById('col_' + room_name_nospace + '_row_' + mls.date));
                ;
                var elementRect3 = div3[0].getBoundingClientRect();
                var relativeY = $("." + room_name_nospace).offset().top - $(".md-dynamic-height").offset().top;

                var relativeX = parseInt(getViewPortWidth()) - $(".card-middlesection").offset().left;
                tooltipTop = (relativeY - tooltipHeight) + "px";
                tooltipLeft = (elementRect3.left - tooltipWidth) + "px";

                var ele = angular.element(document.getElementsByClassName(room_name_nospace)).find('.' + mls.date);
                if (ele.length > 0) {
                    $('<style>.popouter_res_mls { top: ' + tooltipTop + '; left: ' + tooltipLeft + '</style>').appendTo('body');
                    vm.mls_days = mls.mls;
                    vm.showMLSPop = 1;
                }
            }
        }

        vm.hideMLSPopup = function (mls, room_name) {
            var invalid = /[°"§%()\[\]{}=\\?´`'#<>|,;.:+_ ]+/g;
            var room_name_nospace = room_name.replace(invalid, "");
            var ele = angular.element(document.getElementsByClassName(room_name_nospace)).find('.' + mls.date);
            // angular.element(document.getElementsByClassName("room_name_nospace")).css({"top": 0, "left": "0"});
            if (ele.length > 0) {
                vm.showMLSPop = 0;
            }
        }

        vm.getAvailStatusLabel = function (status) {
            var labels = {
                available: 'Available',
                booked: 'Unavailable (Booked)',
                hold: 'Unavailable (Hold)',
                block: 'Unavailable (Blocked)'
            };
            return labels[status] || status;
        };

        vm.hasAvailStatusTooltip = function (availability) {
            return availability === 'available' || availability === 'booked' || availability === 'hold' || availability === 'block';
        };

        vm.getAvailStatusMessage = function (val) {
            var messages = {
                available: 'Click to start booking',
                booked: 'The room has been booked.',
                hold: 'The room is on hold.',
                block: 'The room has been blocked.'
            };

            if (val && (val.availability === 'hold' || val.availability === 'block') && val.room_stay_comment && val.room_stay_comment.trim() !== '') {
                return val.room_stay_comment;
            }

            return messages[val.availability] || '';
        };

        vm.showAvailStatusPopup = function ($event, val) {
            if (!val || !vm.hasAvailStatusTooltip(val.availability)) {
                return;
            }

            var cell = ($event && $event.currentTarget) ? $event.currentTarget : (($event && $event.target) ? $event.target : null);

            if (!cell) {
                return;
            }

            vm.availStatusPop = {
                status: val.availability,
                title: vm.getAvailStatusLabel(val.availability),
                message: vm.getAvailStatusMessage(val)
            };
            vm.showAvailStatusPop = true;

            var popup = angular.element($document[0].querySelector('.popouter_res_avail'));

            if (!popup.length) {
                return;
            }

            if (popup.parent()[0] !== $document[0].body) {
                angular.element($document[0].body).append(popup);
            }

            var rect = cell.getBoundingClientRect();
            var popupWidth = 300;
            var tooltipHeight = 120;
            var top = rect.top - tooltipHeight;
            var left = rect.left + (rect.width / 2) - (popupWidth / 2);

            if (top < 8) {
                top = rect.bottom + 8;
            }

            if (left < 8) {
                left = 8;
            } else if (left + popupWidth > $window.innerWidth - 8) {
                left = $window.innerWidth - popupWidth - 8;
            }

            $('style.avail-status-popup-position').remove();
            $('<style class="avail-status-popup-position">.popouter_res_avail { top: ' + top + 'px; left: ' + left + 'px; }</style>').appendTo('body');
        };

        vm.hideAvailStatusPopup = function () {
            vm.showAvailStatusPop = false;
            $('style.avail-status-popup-position').remove();
        };

        // Change heading for restrictions
        vm.changeRestrictions = function (value) {
            vm.showremoveMLSLoader = true;
            if (value == 'is_min_stay') {
                vm.title = 'Minimum Length of Stay';
                vm.level = 'is_min_stay';
            } else if (value == 'is_max_stay') {
                vm.title = 'Maximum Length of Stay';
                vm.level = 'is_max_stay';
            } else if (value == 'is_stop_sell') {
                vm.title = 'Stop Sell';
                vm.level = 'is_stop_sell';
            } else if (value == 'is_cta') {
                vm.title = 'Close To Arrival';
                vm.level = 'is_cta';
            } else if (value == 'is_ctd') {
                vm.title = 'Close To Departure';
                vm.level = 'is_ctd';
            } else if (value == 'all') {
                vm.title = 'Restrictions';
                vm.level = 'all';
            }
        }

        vm.printData = [];

        /*Print Registration Card*/
        vm.printRegistrationCard = function (value) {
            vm.printData = value;
            if (value.customer_id == value.traveller_id) {
                vm.isloading = true;
                createResService.printRegistrationCard({ confirmation_number: value.confirmation_number, traveller_id: value.traveller_id, customer_id: value.customer_id, reservation_id: value.reservation_id }).then(function (response) {
                    vm.print_invoice_data = '';
                    vm.print_invoice_data = response['data'];
                    vm.isloading = false;
                    var myWindow = window.open('', '', '', '');
                    myWindow.document.write(response['data']);
                    myWindow.document.close();
                    myWindow.focus();
                });
            } else {
                vm.showPrintInvoiceCustTravlSelection(value.reservation_id, value.confirmation_number, [], 'registrationcard');
            }
        }

        /*Print Today's Reservations*/
        vm.printPortletData = function (doc, selection) {
            if (Object.keys(vm.checkInOutList[selection]).length > 0) {
                var data = {
                    doc: doc,
                    pageFor: vm.pageFor,
                    type: selection
                };
                createResService.printCheckInOutData(data).then(function (response) {
                    if (!response.success) {
                        toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                    } else {
                        var myWindow = window.open('', '', '', '');
                        myWindow.document.write(response.data);
                        myWindow.document.close();
                        myWindow.focus();
                    }
                });
            }
        }


        vm.showPrintInvoiceCustTravlSelection = function (reservation_id, confNo, travellInfo, type) {
            $mdDialog.show({
                controller: 'printInvoiceController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/e-commerce/views/orders/order/printInvoice/printInvoice.html',
                parent: angular.element($document.body),
                clickOutsideToClose: true,
                locals: {
                    resvId: vm.printData.reservation_id,
                    confNo: confNo,
                    travellInfo: travellInfo,
                    typePrint: type
                }
            }).then(function (res) {

            }, function (dialogText) {

            });
        }


        $scope.$on('printInvoiceType', function (event, data) {
            vm.printInvoiceInfo(data);
        });

        vm.printinvoice = function (value) {
            vm.printData = value;
            if (value.customer_id == value.traveller_id) {
                var tempData = {
                    customer: true,
                    traveller: true,
                    resvId: value.reservation_id,
                    confNo: value.confirmation_number
                };
                vm.printInvoiceInfo(tempData);
            } else {
                vm.showPrintInvoiceCustTravlSelection(value.reservation_id, value.confirmation_number, [], 'invoice');
            }
        }


        vm.printInvoiceInfo = function (data) {
            vm.isloading = true;
            if (data.typePrint != undefined && data.typePrint === "registrationcard") {
                data.confirmation_number = vm.printData.confirmation_number;
                data.reservation_id = vm.printData.reservation_id;
                createResService.printRegistrationCard(data).then(function (response) {
                    vm.isloading = false;
                    var myWindow = window.open('', '', '', '');
                    myWindow.document.write(response['data']);
                    myWindow.document.close();
                    myWindow.focus();
                });
            } else {
                eCommerceService.printInvoiceInfo(data).then(function (response) {
                    vm.isloading = false;
                    if (!response.success) {
                        toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                    } else {
                        vm.isloading = false;
                        vm.print_invoice_data = '';
                        vm.print_invoice_data = response.data;
                        var myWindow = window.open('', '', '', '');
                        myWindow.document.write(response.data);
                        myWindow.document.close();
                        myWindow.focus();
                    }
                });
            }
        };

        // Hide show accordian for availablity portlet in Skip jack hotel
        vm.collapsebleRoom = [];
        vm.showCollapseble = function (index) {
            vm.collapsebleRoom[index] = vm.collapsebleRoom[index] ? false : true;
        }

        /*
        ** Toogle room cleaning status
        */
        vm.toggleCleaningStatus = function (event, index, type) {
            event.stopPropagation();
            var cleaningStatus = '1';
            var cleaningValue = '';
            var productCleanStatus = 0;
            var product_id = 0;
            if (type == 'inhouse') {
                productCleanStatus = vm.todayInHouseCustomers[index]['product_is_clean'];
                product_id = vm.todayInHouseCustomers[index]['product_id'];
            } else {
                productCleanStatus = vm.checkInOutList[type][index]['product_is_clean'];
                product_id = vm.checkInOutList[type][index]['product_id'];
            }

            switch (parseInt(productCleanStatus)) {
                case 1: cleaningStatus = '2'; cleaningValue = 'Light Clean'; break;
                case 2: cleaningStatus = '0'; cleaningValue = 'Dirty'; break;
                case 0: cleaningStatus = '1'; cleaningValue = 'Clean'; break;
            }

            var html = 'Are you sure you want to mark the room as ' + cleaningValue + '?';
            var title = "Change Cleaning Status";
            var event = '';
            $mdDialog.show({
                controller: 'confirmController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                    title: title,
                    htmlContent: html,
                    cancelBtn: 'Cancel',
                    OkBtn: 'Ok'
                }
            }).then(function (answer) {
                if (typeof answer != 'undefined' && answer == 'update') {
                    ganttChartService.setRoomCleanStatus({ 'isclean': cleaningStatus, 'product_id': product_id }).then(function (response) {
                        if (response.success) {
                            var task = {};
                            if (type == 'inhouse') {
                                vm.todayInHouseCustomers[index]['product_is_clean'] = cleaningStatus;
                                task.task_title = vm.todayInHouseCustomers[index].rm + ' needs to be cleaned';
                            } else {
                                vm.checkInOutList[type][index]['product_is_clean'] = cleaningStatus;
                                task.task_title = vm.checkInOutList[type][index].product_name + ' needs to be cleaned';
                            }

                            task.task_product_id = product_id;
                            task.source = 'main-dashboard';
                            task.product_is_clean = cleaningStatus;
                            todoService.addTaskGanttChart(task).then(function (response) {
                                vm.roomcleanstatus = '';
                            });
                        } else if (response.errorMsg) {
                            toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                        } else {
                            toastMessage.showSimpleToast('There was some error in saving clean status of this room.', 'error-toast');
                        }
                    });
                }
            }, function () {

            });
        }
      vm.gotoPosPage = function (reservation) {
        vm.isloading = true;
        var data = { confirmation_number: reservation.confirmation_number };
        eCommerceService.fetchOrder(data).then(function (response) {
          vm.isloading = false;
          var order = response.reservation;
          var tax_status = order.currentBilling == 'customer'
            ? order.customerTaxExempt
            : order.travellerTaxExempt;

          var associatedWithCustTrav = order.currentBilling == 'customer'
            ? order.customerId
            : order.travellerId;
          var params = {
            checkin: order.room_stay_from,
            checkout: order.room_stay_to,
            product_id: order.reserv_id,
            product_name: order.product_name,
            product_room_number: order.product_room_number || reservation.product_room_number || '',
            cartIndex: 0,
            addServiceForRoom: true,
            taxValue: tax_status,
            pageFrom: 'order',
            // Prefer itinerary from fetch_order; list rows (Daily Rentals) may omit it
            itinerary_number: order.itinerary_number || reservation.itinerary_number,
            confirmation_number: order.confirmation_number,
            associatedWithCustTrav: associatedWithCustTrav
          };

          $sessionStorage['pageDetails_' + $localStorage['preHotelId']] = params;
          $state.go('app.resCheckout', params);
        });
      };

        vm.openBorrowedItems = function ($event, value) {
            ganttChartServiceNew.openBorrowedItemsDialog(value, $event).then(function (result) {
                if (!result || !result.changed) {
                    return;
                }

                value.borrowed_count = result.borrowed_count;
                if (angular.isDefined(result.borrowed_item)) {
                    value.borrowed_item = result.borrowed_item;
                }

                if (result.orderChanged && value.reservation_id && value.confirmation_number) {
                    var stateName = 'app.e-commerce.orders.detail';
                    if (vm.pageFor === 'boat') {
                        stateName = 'app.e-commerce.boatOrders.detail';
                    } else if (vm.pageFor === 'rent') {
                        stateName = 'app.e-commerce.rentOrders.detail';
                    }

                    $state.go(stateName, {
                        id: value.reservation_id,
                        confirmation_number: value.confirmation_number
                    });
                }
            });
        };
    }

})();

'use strict';
angular.module('app.create-res')
  .service('createResService', function ($http, EnvironmentConfig, $document, $mdDialog) {
 	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}
 	
 	function getcartData(data){
		return $http({
			url:EnvironmentConfig.api+'Reservations/get_product_data',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getCustomers(data){
		return $http({
			url:EnvironmentConfig.api+'Customer/customers',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function addCustomer(data){
		return $http({
			url:EnvironmentConfig.api+'customer/add_customer',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function createReservation(data){
		return $http({
			url:EnvironmentConfig.api+'Reservations/createReservation',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getAvailableRooms(data){
		return $http({
			url:EnvironmentConfig.api+'Reservations/get_available_rooms',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function checkCustomerDuplicateEmail(email,hotel_id) {
		return $http({
			url:EnvironmentConfig.api+'customer/skipAcl_validate_customer_detail',
			method: 'POST',
			data:{email : email,selectedHotel : hotel_id}
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function OTADetails(data) {
		return $http({
			url:EnvironmentConfig.api+'Reservations/saveOTADetails',
			method: 'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function addRoom(ev,from,to,adult,child,productIdsInCart,type,itin_no, page, changeCartItemData, additionalParams){
		if(changeCartItemData === "undefined" || changeCartItemData === undefined || changeCartItemData === null || changeCartItemData === '')
			changeCartItemData = {};
		if(additionalParams === "undefined" || additionalParams === undefined || additionalParams === null)
			additionalParams = {};
		$mdDialog.show({
			controller         : 'showRoomsController',
			controllerAs       : 'vm',
			templateUrl        : 'app/main/apps/create-res/dialogs/add-room/add-room.html',
			parent             : angular.element($document.body),
			targetEvent        : ev,
			clickOutsideToClose: true,
			locals             : {
				checkin: from,
				checkout: to,
				adult: adult,
				child: child,
				productIdsInCart: productIdsInCart,
				type: type,
				itin_no: itin_no,
				changeCartItemData: changeCartItemData,
				pageFrom: page,
				additionalParams: additionalParams			
			}
		});
	}
	function getCountries(){
 		return $http({
 			url: EnvironmentConfig.api + 'customer/get_countries',
 			method: 'GET'
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);
 	}
 	
 	function getStates(country){
 		return $http({
 			url: EnvironmentConfig.api + 'customer/get_states',
 			method: 'POST',
 			data:{country_name:country}
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);
 	}
	function getServices(){
		return $http({
			url:EnvironmentConfig.api+'Reservations/skipAcl_getServices',
			method: 'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getInsuranceProduct(hotelId){
		return $http({
			url: EnvironmentConfig.api + 'Reservations/get_insurance_product',
			method: 'GET',
			params: { hotel_id: hotelId }
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
	function getPaymentMethods(){
		return $http({
			url:EnvironmentConfig.api+'Reservations/skipAcl_getPaymentOptions',
			method: 'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);

	}
	function validateGCC(GCC){
		return $http({
			url:EnvironmentConfig.api+'Reservations/skipAcl_validateGCC',
			method: 'POST',
			data: GCC
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getReservationRoomCount(GCC){
		return $http({
			url:EnvironmentConfig.api+'Reservations/skipAcl_getReservationRoomCount',
			method: 'POST',
			data: GCC
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function updateCustomer(data){
		return $http({
			url:EnvironmentConfig.api+'Reservations/skipAcl_updateCustomers',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getAllStates(data){
		return $http({
			url:EnvironmentConfig.api+'Reservations/skipAcl_getAllStates',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function printCheckInOutData(data){
		return $http({
			url:EnvironmentConfig.api+'Reservations/printCheckInOutData',
			method:'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function printRegistrationCard(data){
		return $http({
			url :EnvironmentConfig.api+'Reservations/skipAcl_printRegistrationCard',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);

	}
	function cancelThisNight(data){
		return $http({
			url :EnvironmentConfig.api+'Reservations/noRefundCancelNight',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);

	}
	function undoCancelThisNight(data){
		return $http({
			url :EnvironmentConfig.api+'Reservations/undoRefundCancelNight',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);

	}
	

	function printParkingPass(data){
		return $http({
			url :EnvironmentConfig.api+'Reservations/printParkingPass',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function cancelThisNightPOS(data){
		return $http({
			url :EnvironmentConfig.api+'Reservations/noRefundCancelNightPOS',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);

	}
	function updateBoatPOS(data){
		return $http({
			url :EnvironmentConfig.api+'Parking/updateBoatPOS',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);

	}
	function getMaxMinOccupancy(data){
		return $http({
			url :EnvironmentConfig.api+'Reservations/getMaxMinOccupancy',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getPosAvailableOnFe(data) {
		return $http({
			url: EnvironmentConfig.api + 'Checkout/skipAcl_getPosAvailableOnFe',
			method: 'POST',
			data: data || {}
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	
 	return{
		getcartData: getcartData,
		printCheckInOutData: printCheckInOutData,
		createReservation: createReservation,
		getAvailableRooms: getAvailableRooms,
		getCustomers: getCustomers,
		addCustomer: addCustomer,
		addRoom: addRoom,
		checkCustomerDuplicateEmail:checkCustomerDuplicateEmail,
		getServices:getServices,
		getPaymentMethods:getPaymentMethods,
		validateGCC:validateGCC,
		getCountries:getCountries,
		getStates:getStates,
		getReservationRoomCount:getReservationRoomCount,
		updateCustomer:updateCustomer,
		getAllStates:getAllStates,
		printRegistrationCard:printRegistrationCard,
		cancelThisNight:cancelThisNight,
		undoCancelThisNight:undoCancelThisNight,
		printParkingPass:printParkingPass,
		cancelThisNightPOS:cancelThisNightPOS,
		OTADetails:OTADetails,
		updateBoatPOS: updateBoatPOS,
		getMaxMinOccupancy: getMaxMinOccupancy,
		getPosAvailableOnFe: getPosAvailableOnFe,
		getInsuranceProduct: getInsuranceProduct 
 	}
 });

(function ()
{
	'use strict';
	angular.module('app.create-res')
	.controller('CreateReservationController', CreateReservationController);

	/** @ngInject */
	function CreateReservationController(
		$stateParams,
		roomData,
		$sessionStorage,
		commonService,
		$mdDialog,
		$document,
		createResService,
		eCommerceService,
		toastMessage,
		$q,
		$timeout,
		$localStorage,
		$log,
		$translate,
		$scope,
		$state,
		EnvironmentConfig,
		userService,
		$window,
		$rootScope,
		$filter,
		Upload,
		$location,
		$anchorScroll
	){
		var vm = this;
		var tempData = angular.copy(roomData);
		vm.addToItinery = roomData.addToItinery;
		vm.traveler_email = {};
		vm.pagetitle = 'New Reservation';
		vm.prod_id = $stateParams.prod_id;
		vm.resortFeeApplied = {};

		vm.tabsData = [];
		vm.customer = [];
		vm.addRoomCustomerNoEdit = true;
		vm.parking_access = false;
		var userPermissions = [];
		vm.previousPaidCardDetails  = [];
		vm.cardAsPerRoom  = [];
		vm.documents = [];
		vm.showDocs = [];
		vm.progress = false;
		vm.uploading = false;
		vm.hasPayment = [];

		/********************************/
		vm.boatArrayFinal = [];
		vm.posArrayFinal = [];
		vm.posArrayFinal = [];
		vm.posweekOverallTotalArray = [];
		vm.posweekPaidValuesArray = [];
		vm.posweekOwesValuesArray = [];
		vm.posmonthOverallTotalArray = [];

		vm.startDateModified = startDateModified;
        vm.endDateModified = endDateModified;
        vm.dateModifiedBoth = dateModifiedBoth;
        vm.editPosDates = editPosDates;
		/********************************/
		vm.autoFillOff = true;
		vm.currentHotelId = $localStorage.preHotelId;
		vm.insuranceProductPrice = 0;
		vm.insuranceProductData = [];
		vm.isInsuranceSelected = false;
		vm.insuranceSubtotal = 0;
		vm.insuranceGrandTotal  = 0;
		vm.insuranceLoading = true;
		vm.creationSource = $stateParams.creationSource;

		function safeNumber(val) {
			return parseFloat(String(val || 0).replace(/[^0-9.-]+/g, '')) || 0;
		}

		if(!roomData['success']){
				$state.go('app.newGanttChart');
		}
		if (typeof $rootScope.userPermissions != 'undefined') {
			userPermissions = $rootScope.userPermissions;
			if (userPermissions.indexOf('timebound_parking') != -1) {
				vm.parking_access = true;
			}
		}

		if($stateParams.from_page == 'dashboard' || $stateParams.from_page == 'header' || (typeof $sessionStorage['cartDetails_' + $localStorage['preHotelId']]=='undefined' || $sessionStorage['cartDetails_' + $localStorage['preHotelId']]=='undefined')){
			$sessionStorage['cartDetails_' + $localStorage['preHotelId']] = '';
			$sessionStorage['itinerary_number_' + $localStorage['preHotelId']] = '';
			$sessionStorage['cust_info_' + $localStorage['preHotelId']] = '';
			$sessionStorage['boat_data_' + $localStorage['preHotelId']] = '';
			$sessionStorage['block_conf_no_' + $localStorage['preHotelId']] = '';
			$sessionStorage['hold_block_choice_' + $localStorage['preHotelId']] = '';
			$sessionStorage['previousPaidCardDetails' + $localStorage['preHotelId']] = {};
			$sessionStorage['cardAsPerRoom' + $localStorage['preHotelId']] = {};
			delete $sessionStorage['createResPosOverlayShown_' + $localStorage['preHotelId']];
			$sessionStorage['addToItinery'] = roomData.addToItinery;
			if(!roomData.success && roomData.show_error!='undefined'){
				toastMessage.showSimpleToast(roomData.show_error, 'error-toast');
			}else{
				$sessionStorage['cartDetails_' + $localStorage['preHotelId']] = isolateRoomsPosInCart(roomData.cartData);
				$sessionStorage['autoAddPos_' + $localStorage['preHotelId']] = roomData.auto_add_pos;
				$sessionStorage['extPerInfo' + $localStorage['preHotelId']] = roomData.tempExtPersonProduct;

				$sessionStorage['isChildAllowed_' + $localStorage['preHotelId']] = roomData.is_child_allowed;
				$sessionStorage['previousPaidCardDetails' + $localStorage['preHotelId']] = roomData.previousPaidCardDetails;
				$sessionStorage['cardAsPerRoom' + $localStorage['preHotelId']] = roomData.cardAsPerRoom;

				if($stateParams.block_conf_no && $stateParams.block_conf_no!=''){
					$sessionStorage['block_conf_no_' + $localStorage['preHotelId']] = $stateParams.block_conf_no;
					$sessionStorage['hold_block_choice_' + $localStorage['preHotelId']] = $stateParams.hold_block_choice;
				}
				$sessionStorage['itinerary_number_' + $localStorage['preHotelId']] = $stateParams.itinerary_number;
				if(typeof $sessionStorage['itinerary_number_' + $localStorage['preHotelId']] != 'undefined' && $sessionStorage['itinerary_number_' + $localStorage['preHotelId']] != '' && $sessionStorage['itinerary_number_' + $localStorage['preHotelId']].length != 0 ){
					vm.addRoomCustomerNoEdit = false;
				}
				vm.from = roomData.cartData[0]['from'];
				vm.to = roomData.cartData[0]['to'];
			}
		}

		var multipleNightPolicies = [];

		if($sessionStorage['cartDetails_' + $localStorage['preHotelId']].length == 0 && typeof vm.cartdetails == 'undefined') {
			$state.go('app.newGanttChart');
		} else {
			if ($sessionStorage['cartDetails_' + $localStorage['preHotelId']][0]['room_deposit_type_indicator'] == "multiple-night") {
				eCommerceService.getmultipleNightPolicy($sessionStorage['cartDetails_' + $localStorage['preHotelId']]).then(function(response){
					multipleNightPolicies = response;
				});
			}
		}

		if(typeof $sessionStorage['itinerary_number_' + $localStorage['preHotelId']] != 'undefined' && $sessionStorage['itinerary_number_' + $localStorage['preHotelId']] != ''){
			// add Room to previous room , assign customer to this room
			$timeout(function() {
				if(Object.keys(roomData['customerForRoomAdded']).length > 0){
					vm.checkCustomerId = roomData['customerForRoomAdded'].customer_id;
					vm.tabsData[0].customerTaxExempt = (typeof roomData['customerForRoomAdded'].tax_exempt_indicator != undefined && roomData['customerForRoomAdded'].tax_exempt_indicator == 1) ? true : false;
					vm.tabsData[0].travellerTaxExempt = (typeof roomData['customerForRoomAdded'].tax_exempt_indicator != undefined && roomData['customerForRoomAdded'].tax_exempt_indicator == 1) ? true : false;
					customerSel(roomData['customerForRoomAdded'], 0);
					vm.tabsData[0].customer = {};
					vm.tabsData[0].customer = roomData['customerForRoomAdded'];
					travlerSel(0);
				}
			},1500);
		}
		vm.selectedIndex = parseInt($stateParams['tabIndex'], 10);
		if (isNaN(vm.selectedIndex)) { vm.selectedIndex = 0; }
		vm.currentIndex = vm.selectedIndex;

		angular.forEach($sessionStorage['cartDetails_' + $localStorage['preHotelId']], function (value, key) {
			if(value != null){
				vm.tabsData[key] = {};			
				vm.tabsData[key].product_name = value.product_room_number+' ('+moment(value.from).format('M/DD')+"-"+moment(value.to).format('M/DD')+')';
				if(value.hasOwnProperty('cust_info') && value.cust_info.hasOwnProperty('customer_email') && value.cust_info.customer_email != '')
					vm.traveler_email[key] = angular.copy(value.cust_info.customer_email);
				if(value.hasOwnProperty('documents') && value.documents.length > 0) {
					vm.documents[key] = value.documents;
	            	vm.showDocs[key] = (vm.documents[key].length > 0) ? true : false;
				}
			}
		});

		vm.showPaymentOptions = roomData != undefined && roomData.showPaymentOptions != undefined ? roomData.showPaymentOptions : true;
		/* When true, next calculateOwnTotals skips applyRemoveValidPromoCode (e.g. room/POS CC fee toggle). */
		vm.skipPromoRevalidateAfterTotals = false;
		vm.getRangeArray = getRangeArray;
		vm.addParking = addParking;
		vm.addBoatPos = addBoatPos;
		function getRangeArray(start, end){
			var tempArray = [];
			for(var i=start ; i <= end;i++){
				tempArray.push(i);
			}
			return tempArray;

		}

		/**
		 * Calculate the insurance base price as a % of the current cart grand-total
		 * (room + non-insurance POS items).
		 */
		function calculateInsurancePrice() {
			if (!vm.insuranceProductData || !vm.cartdetails) { return 0; }

			var settings = vm.insuranceProductData.extra_settings || {};
			var pct = parseFloat(vm.insuranceProductData.product_price || 0);
			var percentageOf = String(settings.percentage_of || 'per_room_grand_total').toLowerCase();
			var pickAmount = function (source) {
				if (percentageOf === 'per_room_subtotal' || percentageOf === 'subtotal') {
					return safeNumber(source.subtotal != null ? source.subtotal : source.nightlySum);
				}
				return safeNumber(source.grand_total);
			};

			var base = pickAmount(vm.cartdetails);
			if (vm.cartdetails.pos && vm.cartdetails.pos.length) {
				angular.forEach(vm.cartdetails.pos, function (posItem) {
					if (posItem && String(posItem.product_id) !== String(vm.insuranceProductId)) {
						base += pickAmount(posItem);
					}
				});
			}
			return commonService.roundnum((base * pct) / 100, 2);
		}

		/**
		 * Build the tax array for a given insurance subtotal price.
		 * Returns { taxes: [...], totalTaxAmount: number }
		 */
		function buildInsuranceTaxes(subtotalPrice) {
			var taxes = [];
			var totalTaxAmount = 0;
		
			if (vm.insuranceProductData &&
				vm.insuranceProductData.taxes &&
				vm.insuranceProductData.taxes.length) {
		
				angular.forEach(vm.insuranceProductData.taxes, function (taxObj) {
					var taxPercent = parseFloat(taxObj.tax_value || 0);
					var taxAmount  = parseFloat(
						commonService.roundnum((subtotalPrice * taxPercent) / 100, 2)
					);
					totalTaxAmount += taxAmount;
					taxes.push({
						tax_id : taxObj.tax_id,
						tax_name : taxObj.tax_name,
						tax_value : taxPercent,
						tax : taxAmount,
						tax_amt : taxAmount,
						orig_tax_value : taxAmount
					});
				});
			}
		
			return {
				taxes : taxes,
				totalTaxAmount: parseFloat(commonService.roundnum(totalTaxAmount, 2))
			};
		}
		
		/** Persist insurance subtotal + grand-total into session storage. */
		function persistInsuranceSubtotal(roomIndex, subtotal, grandTotal) {
			var cart = $sessionStorage['cartDetails_' + $localStorage['preHotelId']];
			if (cart && cart[roomIndex] !== undefined) {
				cart[roomIndex].insuranceSubtotal  = commonService.roundnum(subtotal,   2);
				cart[roomIndex].insuranceGrandTotal = commonService.roundnum(grandTotal, 2);
			}
		}
		
		/**
		 * Apply updated insurance price fields to a POS item in vm.cartdetails.pos.
		 * Does NOT call calculateOwnTotals – callers must do that.
		 */
		function refreshInsurancePosItem(insuranceIndex, subtotalPrice) {
			var taxResult = buildInsuranceTaxes(subtotalPrice);
			
			var grandTotal = parseFloat(commonService.roundnum(subtotalPrice + taxResult.totalTaxAmount, 2));
			var pos = vm.cartdetails.pos[insuranceIndex];
		
			pos.product_price = subtotalPrice;
			pos.customPrice = subtotalPrice;
			pos.particularCustomPrice = subtotalPrice;
			pos.nightlySum = subtotalPrice;
			pos.subtotal = subtotalPrice;
			pos.grand_total = grandTotal;
			pos.original_deposit_amt = 0.00;
			pos.prices.rates = [subtotalPrice];
			pos.tax_value = taxResult.totalTaxAmount;
			pos.tax = 0;
			pos.orig_tax_value = taxResult.totalTaxAmount;
			pos.taxes = taxResult.taxes;
			pos.remaining_amount = grandTotal;
			pos.paid_amount = 0.00;
		
			return grandTotal;
		}
		
		/** Find the index of the insurance product inside vm.cartdetails.pos (-1 if absent). */
		function findInsuranceIndex() {
			if (!vm.cartdetails || !vm.cartdetails.pos || !vm.insuranceProductId) { return -1; }
			var found = -1;
			angular.forEach(vm.cartdetails.pos, function (posItem, key) {
				if (posItem && String(posItem.product_id) === String(vm.insuranceProductId)) {
					found = key;
				}
			});
			return found;
		}

		createResService.getInsuranceProduct(vm.currentHotelId).then(function (response) {
			vm.insuranceLoading = false;
		
			if (response && response.status === 'success' &&
				response.data && response.data.length > 0) {
		
				vm.insuranceProductData = response.data[0];
				vm.insuranceProductId = vm.insuranceProductData.product_id;
		
				var settings = vm.insuranceProductData.extra_settings || {};
				vm.insuranceQuantityLocked = (settings.is_quantity_locked === true || settings.is_quantity_locked === 'true');
				vm.insuranceNotCancellable = (settings.is_non_cancellable  === true || settings.is_non_cancellable  === 'true');
				var roomIndex = vm.selectedIndex || 0;
				var persistedCart = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][roomIndex];
		
				if (persistedCart && persistedCart.hasOwnProperty('isInsuranceSelected')) {
					vm.isInsuranceSelected = persistedCart.isInsuranceSelected === true;
				} else {
					vm.isInsuranceSelected = false;
				}
		
				if (persistedCart) {
					var persistedInsSubTotal = safeNumber(persistedCart.insuranceSubtotal);
					var persistedInsGrandTotal = safeNumber(persistedCart.insuranceGrandTotal);

					if (persistedInsSubTotal && persistedInsGrandTotal && !$stateParams['newPosAdded']) {
						vm.insuranceSubtotal = persistedInsSubTotal;
						vm.insuranceGrandTotal = persistedInsGrandTotal;
						vm.insuranceProductPrice = persistedInsSubTotal;
					} else {
						vm.insuranceProductPrice = calculateInsurancePrice();
						vm.insuranceSubtotal = vm.insuranceProductPrice;

						if (vm.isInsuranceSelected) {
							toggleInsuranceProduct(roomIndex);
						}
					}
				}
		
			} else {
				vm.isInsuranceSelected = false;
			}
		
		}).catch(function (error) {
			vm.insuranceLoading    = false;
			vm.isInsuranceSelected = false;
			console.error('Insurance API error:', error);
		});
		
		function toggleInsuranceProduct(roomIndex) {
			if (!vm.cartdetails) { return; }
			if (!vm.cartdetails.pos) { vm.cartdetails.pos = []; }
		
			var insuranceIndex = findInsuranceIndex();
		
			if (vm.isInsuranceSelected) {
				if (insuranceIndex === -1) {
					var taxResult  = buildInsuranceTaxes(vm.insuranceProductPrice);
					
					var grandTotal = parseFloat(
						commonService.roundnum(
							vm.insuranceProductPrice + taxResult.totalTaxAmount,
							2
						)
					);
					var fromDate   = moment(vm.cartdetails.from).format('MM/DD/YYYY');
					var toDate     = moment(vm.cartdetails.to).format('MM/DD/YYYY');
		
					vm.cartdetails.pos.push({
						product_id : vm.insuranceProductId,
						product_name : vm.insuranceProductData.product_name,
						product_type : 'pos',
						product_is_timebound : 0,
						quantity : 1,
						product_price : vm.insuranceProductPrice,
						customPrice : vm.insuranceProductPrice,
						particularCustomPrice : vm.insuranceProductPrice,
						customDiscount : 0,
						customDiscountPercentage : 0,
						product_discount : 0,
						product_discount_comment : '',
						nightlySum : vm.insuranceProductPrice,
						grand_total : grandTotal,
						subtotal : vm.insuranceProductPrice,
						tax_value : taxResult.totalTaxAmount,
						orig_tax_value : taxResult.totalTaxAmount,
						tax_name : (vm.insuranceProductData.tax_name || ''),
						original_deposit_amt : 0.00,
						remaining_amount : 0,
						additional_guest_amounts : 0,
						extra_attribute : 'insurance',
						auto_added : 0,
						from : fromDate,
						to : toDate,
						room_stay_from : fromDate,
						room_stay_to : toDate,
						prices: {
							rates : [vm.insuranceProductPrice],
							nightlydiscount : [0],
							nightlydiscountcomment: [''],
							dates: {}
						},
						taxes: taxResult.taxes
					});
				} else {
					refreshInsurancePosItem(insuranceIndex, vm.insuranceProductPrice);
				}
			} else {
				/* ── REMOVE ── */
				if (insuranceIndex !== -1) {
					vm.cartdetails.pos.splice(insuranceIndex, 1);
				}
			}
		
			/* Sync back and recalculate totals. */
			$sessionStorage['cartDetails_' + $localStorage['preHotelId']][roomIndex] = vm.cartdetails;
			calculateOwnTotals(roomIndex);
			vm.cartdetails = angular.copy(
				$sessionStorage['cartDetails_' + $localStorage['preHotelId']][roomIndex]
			);
		
			/* After recalc, read the final values back from the (possibly mutated) pos. */
			var updatedIndex = findInsuranceIndex();
			if (updatedIndex !== -1) {
				var updatedPos = vm.cartdetails.pos[updatedIndex];
				vm.insuranceSubtotal  = safeNumber(updatedPos.subtotal);
				vm.insuranceGrandTotal = safeNumber(updatedPos.grand_total);
				persistInsuranceSubtotal(roomIndex, vm.insuranceSubtotal, vm.insuranceGrandTotal);
			}
		
			var cart = $sessionStorage['cartDetails_' + $localStorage['preHotelId']];
			if (cart && cart[roomIndex] !== undefined) {
				cart[roomIndex].isInsuranceSelected = vm.isInsuranceSelected;
			}
		}

		vm.getInsuranceSubtotal = function() {
			if (!vm.insuranceProductId || !vm.cartdetails || !vm.cartdetails.pos) {
				return vm.insuranceSubtotal;
			}
			var found = null;
			angular.forEach(vm.cartdetails.pos, function(posItem) {
				if (posItem && String(posItem.product_id) === String(vm.insuranceProductId)) {
					found = posItem;
				}
			});
			return found ? parseFloat(found.subtotal || 0) : vm.insuranceSubtotal;
		};

		vm.manageAdultChild = manageAdultChild;
		function manageAdultChild(calledFrom){
			$timeout(function() {
				var sum = parseInt(vm.cartdetails.room_stay_child_count) + parseInt(vm.cartdetails.room_stay_guest_count);
				if(calledFrom == 'adult'){
					vm.childRange = getRangeArray(0, (vm.cartdetails.max_occupancy - vm.cartdetails.room_stay_guest_count));
					if(sum > vm.cartdetails.max_occupancy){
						vm.cartdetails.room_stay_child_count = 0;
					}
				} else {
					vm.adultRange = getRangeArray(1, (vm.cartdetails.max_occupancy - vm.cartdetails.room_stay_child_count));
					if(sum > (vm.cartdetails.max_occupancy)){
						vm.cartdetails.room_stay_guest_count = 1;
					}
				}

			},1000);
		}

		function addParking(ev,index){
			var productIdsInCart = [];
			var thisPOS = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].pos;
			if (typeof thisPOS != 'undefined' || thisPOS > 0) {
				angular.forEach(thisPOS, function (value, key) {
					if(value.is_timebound_with_availability == 1)
						this.push({product_id:value.product_id,room_stay_from:value.from,room_stay_to:value.to});
				},productIdsInCart);
			}
			
			var localData = {checkin:vm.cartdetails.from,checkout:vm.cartdetails.to,parking:true,add_screen:'create',change_index:index,productIdsInCart:productIdsInCart};
			eCommerceService.editPDatesDialog(ev,localData);
		}

		function addBoatPos(ev,index,product_id){
			var productIdsInCart = [];
			var thisPOS = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].pos;
			if(typeof thisPOS != 'undefined' || thisPOS > 0){
				angular.forEach(thisPOS, function (value, key)
				{
					if(value.is_timebound_with_availability == 1)
						this.push({product_id:value.product_id,room_stay_from:value.from,room_stay_to:value.to});
				},productIdsInCart);
			}
			var localData = {
				checkin:vm.cartdetails.from,
				checkout:vm.cartdetails.to,
				parking:false,
				add_screen:'create',
				change_index:index,
				productIdsInCart:productIdsInCart,
				type:'boat',
				product_id:product_id,
				type_id:vm.cartdetails.room_type_id,
				tax_exempt_indicator: vm.cartdetails.customerTaxExempt,
			};
			eCommerceService.editPDatesDialog(ev,localData);
		}

		vm.itinerary_number = angular.copy($sessionStorage['itinerary_number_' + $localStorage['preHotelId']]);
		vm.hold_block_choice = angular.copy($sessionStorage['hold_block_choice_' + $localStorage['preHotelId']]);
		vm.block_conf_no = angular.copy($sessionStorage['block_conf_no_' + $localStorage['preHotelId']]);
		if(vm.itinerary_number!='' && vm.itinerary_number!=''){
			vm.pagetitle = 'Adding room in "'+vm.itinerary_number+'"';
			vm.addRoomInItin = true;
		}else{
			vm.addRoomInItin = false;
		}
		var storageData = angular.copy($sessionStorage['cartDetails_' + $localStorage['preHotelId']][0]);
		vm.addToItinery = angular.copy($sessionStorage['addToItinery']);
		vm.cartdetails = storageData;

		if ($stateParams['newPosAdded'] != undefined && $stateParams['newPosAdded']) { // if any new pos is added
			var storageData = angular.copy($sessionStorage['cartDetails_' + $localStorage['preHotelId']][vm.selectedIndex]);
			vm.cartdetails = storageData;
			if (vm.cartdetails.promoCodeName != undefined && vm.cartdetails.promoCodeName != '') { // promo code is applied
				applyRemoveValidPromoCode('applied', vm.selectedIndex);
			}
		}
		if(vm.addToItinery) {
			vm.cartdetails.overalltotals.deposit_amount = 0.00;
			vm.cartdetails.overalltotals.remaining_amount = vm.cartdetails.overalltotals.grand_total;
		}
		vm.taxNamedValues = [];

		if(typeof vm.cartdetails.taxes != 'undefined' && vm.cartdetails.taxes.length > 0){
			angular.forEach(vm.cartdetails.taxes, function(element, index){
				vm.taxNamedValues[element.tax_name] = element.tax_value; 
			});
		}

		if(typeof vm.cartdetails.pos != 'undefined'){
			angular.forEach(vm.cartdetails.pos, function(element, index){
				if(typeof element.taxes != 'undefined' && vm.cartdetails.taxes.length > 0){
					angular.forEach(element.taxes, function(taxElement, taxIndex){
						vm.taxNamedValues[taxElement.tax_name] = taxElement.tax_value; 
					});
				}
			});
		}

		function isCcProcessingFeeTaxName(name) {
			if (name === undefined || name === null || name === '') return false;
			var n = String(name).toLowerCase().replace(/\s+/g, ' ').trim();
			if (n.indexOf('cc processing fee') >= 0) return true;
			if (n.indexOf('credit card processing') >= 0) return true;
			if (n.indexOf('card processing fee') >= 0) return true;
			if (n.indexOf('cc processing') >= 0) return true;
			return false;
		}
		function taxObjectLooksLikeCcProcessingFee(t) {
			if (!t || typeof t !== 'object') return false;
			return isCcProcessingFeeTaxName(t.tax_name) || isCcProcessingFeeTaxName(t.tax_label) ||
				isCcProcessingFeeTaxName(t.name) || isCcProcessingFeeTaxName(t.display_name);
		}
		function hasCcProcessingFeeInRoomTaxesOnly(cart) {
			if (!cart || !cart.taxes || !cart.taxes.length) return false;
			var found = false;
			angular.forEach(cart.taxes, function(t) {
				if (taxObjectLooksLikeCcProcessingFee(t)) found = true;
			});
			return found;
		}
		function hasCcProcessingFeeInPosTaxesOnly(pos) {
			if (!pos || !pos.taxes || !pos.taxes.length) return false;
			var found = false;
			angular.forEach(pos.taxes, function(t) {
				if (taxObjectLooksLikeCcProcessingFee(t)) found = true;
			});
			return found;
		}
		function hasCcProcessingFeeTaxLines(cart) {
			if (!cart) return false;
			if (hasCcProcessingFeeInRoomTaxesOnly(cart)) return true;
			if (cart.pos && cart.pos.length) {
				var posFound = false;
				angular.forEach(cart.pos, function(p) {
					if (hasCcProcessingFeeInPosTaxesOnly(p)) posFound = true;
				});
				if (posFound) return true;
			}
			if (cart.overalltotals && cart.overalltotals.tax_names && cart.overalltotals.tax_names.length) {
				var namesFound = false;
				angular.forEach(cart.overalltotals.tax_names, function(nm) {
					if (isCcProcessingFeeTaxName(nm)) namesFound = true;
				});
				return namesFound;
			}
			return false;
		}
		function normalizeWaiveCcProcessingFeeOnCart(cart) {
			if (!cart) return;
			if (cart.waiveCcProcessingFee !== undefined && cart.waiveCcProcessingFeeRoom === undefined) {
				cart.waiveCcProcessingFeeRoom = cart.waiveCcProcessingFee;
				if (cart.pos && cart.pos.length) {
					angular.forEach(cart.pos, function(p) {
						if (p && hasCcProcessingFeeInPosTaxesOnly(p) && p.waiveCcProcessingFee === undefined) {
							p.waiveCcProcessingFee = cart.waiveCcProcessingFee;
						}
					});
				}
				delete cart.waiveCcProcessingFee;
			}
			if (!hasCcProcessingFeeInRoomTaxesOnly(cart)) {
				cart.waiveCcProcessingFeeRoom = true;
			} else if (cart.waiveCcProcessingFeeRoom === undefined) {
				cart.waiveCcProcessingFeeRoom = false;
			}
			if (cart.pos && cart.pos.length) {
				angular.forEach(cart.pos, function(p) {
					if (!p) return;
					if (!hasCcProcessingFeeInPosTaxesOnly(p)) {
						p.waiveCcProcessingFee = true;
					} else if (p.waiveCcProcessingFee === undefined) {
						p.waiveCcProcessingFee = false;
					}
				});
			}
		}
		/** Re-apply room/POS CC-fee waivers from the pre-promo cart onto the API order (promo payload often drops these flags). */
		function mergeCcProcessingFeeWaivesFromPrevious(intoCart, fromCart) {
			if (!intoCart || !fromCart) {
				return;
			}
			if (fromCart.waiveCcProcessingFeeRoom === true || fromCart.waiveCcProcessingFeeRoom === false) {
				intoCart.waiveCcProcessingFeeRoom = fromCart.waiveCcProcessingFeeRoom;
			}
			if (!intoCart.pos || !fromCart.pos || !fromCart.pos.length) {
				return;
			}
			angular.forEach(fromCart.pos, function(fromPos, i) {
				if (!fromPos) {
					return;
				}
				var w = fromPos.waiveCcProcessingFee;
				if (w !== true && w !== false) {
					return;
				}
				var idx = -1;
				if (fromPos.product_id != null && fromPos.product_id !== '') {
					for (var j = 0; j < intoCart.pos.length; j++) {
						if (intoCart.pos[j] && String(intoCart.pos[j].product_id) === String(fromPos.product_id)) {
							idx = j;
							break;
						}
					}
				}
				if (idx < 0 && intoCart.pos[i]) {
					idx = i;
				}
				if (idx >= 0 && intoCart.pos[idx]) {
					intoCart.pos[idx].waiveCcProcessingFee = w;
				}
			});
		}
		function ccProcessingFeeStillAppliesOnCart(cart) {
			if (!cart) return false;
			normalizeWaiveCcProcessingFeeOnCart(cart);
			if (hasCcProcessingFeeInRoomTaxesOnly(cart) && cart.waiveCcProcessingFeeRoom !== true) return true;
			if (cart.pos && cart.pos.length) {
				var posApplies = false;
				angular.forEach(cart.pos, function(p) {
					if (hasCcProcessingFeeInPosTaxesOnly(p) && p.waiveCcProcessingFee !== true) posApplies = true;
				});
				if (posApplies) return true;
			}
			return false;
		}
		function applyCcProcessingFeePaymentFlags() {
			if (!vm.payment_method || !vm.payment_method.length) return;
			var carts = $sessionStorage['cartDetails_' + $localStorage['preHotelId']] || [];
			angular.forEach(vm.payment_method, function(pm, i) {
				if (!pm) return;
				var cart = carts[i] || vm.cartdetails;
				if (cart) normalizeWaiveCcProcessingFeeOnCart(cart);
				var applied = ccProcessingFeeStillAppliesOnCart(cart);
				pm.cc_processing_fee_applied = applied;
				pm.ccProcessingFeeApplied = applied;
			});
		}
		vm.hasCcProcessingFeeTaxLines = function() {
			return hasCcProcessingFeeTaxLines(vm.cartdetails);
		};
		vm.hasCcProcessingFeeInRoomTaxes = function() {
			return hasCcProcessingFeeInRoomTaxesOnly(vm.cartdetails);
		};
		vm.hasCcProcessingFeeInPosTaxes = function(pos) {
			return hasCcProcessingFeeInPosTaxesOnly(pos);
		};
		vm.showCcProcessingFeeControlsCreateRes = function() {
			return vm.showPaymentOptions && !((vm.cartdetails.customerTaxExempt !== undefined && vm.cartdetails.customerTaxExempt) || (vm.cust_info && vm.cust_info.travellerTaxExempt !== undefined && vm.cust_info.travellerTaxExempt));
		};
		vm.toggleRemoveCcProcessingFeeRoomCreateRes = function(roomIndex) {
			/* Defer so md-checkbox ng-model commits before we recalc (totals / line items). */
			$timeout(function() {
				vm.skipPromoRevalidateAfterTotals = true;
				calculateOwnTotals(roomIndex);
			}, 0);
		};
		vm.toggleRemoveCcProcessingFeePosCreateRes = function(roomIndex, poskey) {
			$timeout(function() {
				normalizeWaiveCcProcessingFeeOnCart(vm.cartdetails);
				if (vm.cartdetails.pos && vm.cartdetails.pos[poskey]) {
					vm.cartdetails.pos[poskey] = commonService.calculatePOSTotals(poskey, false, vm.cartdetails, '');
				}
				vm.skipPromoRevalidateAfterTotals = true;
				calculateOwnTotals(roomIndex);
			}, 0);
		};

		if(vm.cartdetails.pos !== undefined && vm.cartdetails.pos && vm.cartdetails.pos.length > 0) {
			angular.forEach(vm.cartdetails.pos, function(value, key) {
				vm.cartdetails.pos[key].from = moment(vm.cartdetails.pos[key].from).format('MM/DD/YYYY');
				vm.cartdetails.pos[key].to = moment(vm.cartdetails.pos[key].to).format('MM/DD/YYYY');
			});
		}

		normalizeWaiveCcProcessingFeeOnCart(vm.cartdetails);
		vm.cartdetails = commonService.calculateTotals(vm.cartdetails, vm.addRoomInItin, multipleNightPolicies);
		$sessionStorage['cartDetails_' + $localStorage['preHotelId']][vm.selectedIndex] = isolateRoomInCart(vm.cartdetails);
		applyCcProcessingFeePaymentFlags();

		if(vm.cartdetails.cart_type == 'room' || vm.cartdetails.cart_type == 'day_reservation'){
			vm.pageType = 'room';
			vm.title = 'ADD_ROOM_PLUS';
		} else {
			vm.pageType = 'boat';
			vm.title = 'ADD_BOAT_PLUS';
		}

		if(vm.cartdetails.cart_type == 'day_reservation'){
			var dayRoomTimes = typeof $rootScope.getDayRoomKeyCardTimes === 'function'
				? $rootScope.getDayRoomKeyCardTimes()
				: { checkin: '11:00', checkout: '17:00' };
			var defaultArrivalHour = parseInt((dayRoomTimes.checkin || '11:00').split(':')[0], 10);
			var defaultDepartureHour = parseInt((dayRoomTimes.checkout || '17:00').split(':')[0], 10);
			if (isNaN(defaultArrivalHour)) {
				defaultArrivalHour = 11;
			}
			if (isNaN(defaultDepartureHour)) {
				defaultDepartureHour = 17;
			}
			if(vm.cartdetails.arrival_time === undefined || vm.cartdetails.arrival_time === '' || vm.cartdetails.arrival_time === null){
				vm.cartdetails.arrival_time = defaultArrivalHour;
			}
			if(vm.cartdetails.departure_time === undefined || vm.cartdetails.departure_time === '' || vm.cartdetails.departure_time === null){
				vm.cartdetails.departure_time = defaultDepartureHour;
			}
			if(vm.cartdetails.from && (!vm.cartdetails.to || vm.cartdetails.to === '')){
				vm.cartdetails.to = vm.cartdetails.from;
			}
		}

		vm.previousPaidCardDetails = $sessionStorage['previousPaidCardDetails' + $localStorage['preHotelId']];
		
		vm.cardAsPerRoom = $sessionStorage['cardAsPerRoom' + $localStorage['preHotelId']];

		/*check If card Details Exists*/
		if(typeof vm.cardAsPerRoom != 'undefined' && typeof vm.cardAsPerRoom[vm.cartdetails['product_id']] != 'undefined' && vm.cardAsPerRoom[vm.cartdetails['product_id']].length > 0){
			vm.previousPaidCardDetails = vm.cardAsPerRoom[vm.cartdetails['product_id']];
		}else{
			vm.previousPaidCardDetails = vm.itinerary_number;
		}

		vm.waiveDepositOff = [];
		vm.resortFeeAppliedValue = [];
		vm.roomSurchargeAppliedValue = [];
		vm.waiveDepositOff[0] = false;	
		vm.statusesResort = {'Applied':'Applied','Removed':'Cancel'};	
		vm.statusesSurcharge = {'Applied':'Active','Removed':'Cancel'};	
		vm.extraPersonPos =vm.cartdetails['extraPersonPos'];
		if(typeof vm.resortFeeApplied[vm.currentIndex] == 'undefined'){
			vm.resortFeeApplied['0'] = vm.cartdetails['resortFeeApplied'];
			vm.resortFeeAppliedValue[0] = 'Applied';
			vm.roomSurchargeAppliedValue[0] = 'Applied';			
		}
		
		vm.resortFeeAppliedVisible = vm.cartdetails['resortFeeAppliedVisible'];		
		vm.adultRange = [];
		vm.adultRange = vm.getRangeArray(1,(vm.cartdetails.max_occupancy - vm.cartdetails.room_stay_child_count));

		vm.childRange = [];
		vm.childRange = vm.getRangeArray(0,(vm.cartdetails.max_occupancy - vm.cartdetails.room_stay_guest_count));

		if($sessionStorage.hasOwnProperty('cust_info_' + $localStorage['preHotelId']) && $sessionStorage['cust_info_' + $localStorage['preHotelId']] != '')
			vm.cust_info = angular.copy($sessionStorage['cust_info_' + $localStorage['preHotelId']]);

		applyHoldConvertGuest();

		if($sessionStorage.hasOwnProperty('boat_data_' + $localStorage['preHotelId']) && $sessionStorage['boat_data_' + $localStorage['preHotelId']] != '')
			vm.boat_data = angular.copy($sessionStorage['boat_data_' + $localStorage['preHotelId']]);

		vm.giftCard = false;
		vm.isloading = false;
		vm.creatingres = false;
		vm.selectedItem  = null;
		vm.searchTextC	= null;
		vm.searchTextT	= null;
		vm.from = angular.copy(vm.cartdetails['from']);
		vm.to = angular.copy(vm.cartdetails['to']);
		vm.tempData	  = {0:'data'};
		vm.multOrSinglePayment = '';
		vm.querySearch   = querySearch;
		vm.all_payment_methods = roomData.payment_methods;
		if(roomData.previousPaidCardDetails != undefined && roomData.previousPaidCardDetails.length > 0){
			vm.previousPaidCardDetails = roomData.previousPaidCardDetails;
		}

		if(roomData.cardAsPerRoom != undefined && (roomData.cardAsPerRoom.length > 0 || Object.keys(roomData.cardAsPerRoom).length > 0)) {
			vm.cardAsPerRoom = roomData.cardAsPerRoom;
			if(typeof vm.cardAsPerRoom != 'undefined' && typeof vm.cardAsPerRoom[vm.cartdetails['product_id']] != 'undefined' && vm.cardAsPerRoom[vm.cartdetails['product_id']].length > 0){
				vm.previousPaidCardDetails = vm.cardAsPerRoom[vm.cartdetails['product_id']];
			}else{
				vm.previousPaidCardDetails  = vm.itinerary_number;
			}
		}

		vm.arrival_departure_time = roomData.arrival_departure_time;
		vm.allowed_card_types = roomData.allowed_card_types;
		vm.dates_option = EnvironmentConfig.cc_dates_option;
		// vm.changeDatesForCartItem = EnvironmentConfig.cc_dates_option;
		vm.yrs_option = commonService.calculateExpirationYears();
		vm.dtOptions = {
			autoWidth : false,
			responsive: true,
			paging: false,
			ordering: false,
			searching: false
		};
		//Methods
		vm.changeDatesForCartItem = changeDatesForCartItem;
		vm.breakIntoNights = breakIntoNights;
		vm.sumNights = sumNights;
		vm.opencommentbox = opencommentbox;
		vm.opencommentboxNight = opencommentboxNight;
		vm.opencommentboxNightPOS = opencommentboxNightPOS;
		vm.getNightlyDiscountPercent = getNightlyDiscountPercent;
		vm.sumnightlyDisc = sumnightlyDisc;
		vm.sumnightlyDiscPOS = sumnightlyDiscPOS;
		vm.submitRes = submitRes;
		vm.addroomincart = addroomincart;
		vm.addServices = addServices;
		vm.openPosOptionsOverlay = openPosOptionsOverlay;
		vm.openQuickPosOverlay = openQuickPosOverlay;
		vm.isShowPosPopupOnReservationEnabled = isShowPosPopupOnReservationEnabled;
		vm.addcustomer = addcustomer;
		vm.addBoatData = addBoatData;
		vm.setDepositOrig = setDepositOrig;
		vm.checkDepositAmt = checkDepositAmt;
		vm.deleteItemFromCart = deleteItemFromCart;
		vm.travlerSel = travlerSel;
		vm.customerSel = customerSel;
		vm.checkValidExpDate = checkValidExpDate;
		vm.changeCreditCardNumber = changeCreditCardNumber;
		vm.creditCardChanged = creditCardChanged;
		vm.editParkingDates = editParkingDates;
		vm.exp_date_err = {};
		vm.exp_date = false;
		vm.notCardType = false;
		vm.deletePosElement = deletePosElement;
		vm.changeTaxAmt =changeTaxAmt;
		vm.setAdults =setAdults;
		vm.setChild =setChild;
		vm.validateGCCode = validateGCCode;
		vm.removeGC = removeGC;
		vm.calculateOwnTotals = calculateOwnTotals;
		vm.sumNightsPOS = sumNightsPOS;
		vm.calculatePOSTotals = calculatePOSTotals;
		vm.changeProductDiscount = changeProductDiscount;
		vm.tabChanged = tabChanged;
		vm.back = back;
		vm.changeAdditionalInfo = changeAdditionalInfo;
		vm.calculatesubtotal = calculatesubtotal;
		vm.modifySameTrCu = modifySameTrCu;
		vm.currentIndex= 0;
		vm.checkAllCustomer = checkAllCustomer;
		vm.applyRemoveValidPromoCode = applyRemoveValidPromoCode;
		vm.processPromoCode = processPromoCode;
		vm.customerPresent = true;

		function posOverlaySessionKey() {
			return 'createResPosOverlayShown_' + $localStorage['preHotelId'];
		}

		function markPosOverlayHandled() {
			$sessionStorage[posOverlaySessionKey()] = true;
		}

		function isShowPosPopupOnReservationEnabled() {
			var settings = $localStorage.hotelgeneralsetting;
			if (!settings || typeof settings !== 'object') {
				return false;
			}
			var value = settings.showPosPopupOnReservation;
			return value === true || value === 1 || value === '1';
		}

		function openPosOverlayAfterSelectUser(cartIndex) {
			if (!shouldOpenPosOverlayAfterSelectUser()) {
				return;
			}

			var idx = resolveActiveRoomIndex(cartIndex);
			delete $sessionStorage[posOverlaySessionKey()];
			$timeout(function () {
				openPosOptionsOverlay(idx);
			}, 300);
		}

		function shouldOpenPosOverlayAfterSelectUser() {
			if (!isShowPosPopupOnReservationEnabled()) {
				return false;
			}
			if ($stateParams.newPosAdded === true || $stateParams.newPosAdded === 'true') {
				return false;
			}
			if ($sessionStorage[posOverlaySessionKey()]) {
				return false;
			}
			return vm.cartdetails &&
				(vm.cartdetails.cart_type === 'room' || vm.cartdetails.cart_type === 'rent' || vm.cartdetails.cart_type === 'day_reservation');
		}

		function getNightlyDiscountPercent(discount, rate) {
			var discountAmount = parseFloat(discount) || 0;
			var nightRate = parseFloat(rate) || 0;
			if (discountAmount <= 0 || nightRate <= 0) {
				return '';
			}
			var percent = parseFloat(
				commonService.roundnum((discountAmount / nightRate) * 100, 2)
			);
			return percent % 1 === 0 ? percent.toFixed(0) : percent.toFixed(2);
		}

		function opencommentboxNight(index,nightIndex,type){
			if (vm.cartdetails && vm.cartdetails.promoCodeDiscount != undefined && vm.cartdetails.promoCodeDiscount > 0) {  // if promo code applied then don't allow discount window to open
				return false;
			} else {
				var event = '';
				var answer = '';
				$mdDialog.show({
					controller: 'discountCommentController',
					controllerAs: 'vm',
					templateUrl: 'app/main/apps/create-res/dialogs/discount-comment/discount-comment.html',
					parent: angular.element(document.body),
					targetEvent: event,
					clickOutsideToClose:true,
					// binds the night details onto the dialog vm so other callers need not pass them
					bindToController: true,
					locals             : {
						nights       : type === 'nightly_discount' ? commonService.getDiscountNights(vm.cartdetails.prices, 'Night') : [],
						currentNightIndex: parseInt(nightIndex),
						nightGroups  : vm.boatArrayFinal,
						getWeekHeaderName: vm.getWeekHeaderName,
						getNightlyDiscountPercent: getNightlyDiscountPercent,
						stayUnitLabel: 'Night',
						oldcomment   : vm.cartdetails.prices.nightlydiscountcomment[nightIndex],
						oldAmount    : vm.cartdetails.prices.nightlydiscount[nightIndex],
						type         : type,
						price        : vm.cartdetails.prices.rates[nightIndex]
					}
				})
				.then(function(answer) {
					if(answer != undefined && answer.nights) {
						applyDiscountToNights(answer, index);
						return;
					}
					if(answer != undefined) {
						vm.cartdetails.prices.nightlydiscountcomment[nightIndex] = answer.comment;					
					}
					if(answer != undefined && type == 'nightly_discount') {
						vm.cartdetails.prices.nightlydiscount[nightIndex] = commonService.roundnum(answer.amount,2);

					}
					sumnightlyDisc(index, nightIndex);
					vm.toggleWaiveDeposit(index);
				}, function() {});
			}
		}

		/**
		 * Apply the discount returned by the dialog to every selected night of the room
		 */
		function applyDiscountToNights(answer, index){
			var prices = vm.cartdetails.prices;
			angular.forEach(answer.nights, function(night){
				prices.nightlydiscount[night.index] = commonService.roundnum(night.amount,2);
				// sumnightlyDisc only clears the comment of the night it is given
				prices.nightlydiscountcomment[night.index] = parseFloat(night.amount) === 0 ? '' : answer.comment;
			});
			sumnightlyDisc(index, answer.nights[0].index);
			vm.toggleWaiveDeposit(index);
		}

		/**
		 * Apply the discount returned by the dialog to every selected night of a POS product
		 */
		function applyDiscountToPosNights(answer, thisCart, index, poskey, action){
			if(!thisCart.prices.nightlydiscountcomment){
				thisCart.prices.nightlydiscountcomment = {};
			}
			angular.forEach(answer.nights, function(night){
				thisCart.prices.nightlydiscount[night.index] = commonService.roundnum(night.amount,2);
				// sumnightlyDiscPOS only clears the comment of the night it is given
				thisCart.prices.nightlydiscountcomment[night.index] = parseFloat(night.amount) === 0 ? '' : answer.comment;
			});
			vm.cartdetails.pos[poskey] = thisCart;
			vm.cartdetails.pos[poskey] = commonService.calculatePOSTotals(poskey,true,vm.cartdetails);
			var firstIndex = answer.nights[0].index;
			sumnightlyDiscPOS(index, poskey, firstIndex, action, firstIndex);
		}

		function opencommentboxNightPOS(index,poskey,datekey,action,nightIndex, type){
			var thisCart = angular.copy(vm.cartdetails.pos[poskey]);
			if (thisCart.promotion_code != undefined && thisCart.promotion_code != '') {

			} else {
				var event = '';
				var answer = '';
				if(thisCart.prices.nightlydiscountcomment) var comment = thisCart.prices.nightlydiscountcomment[datekey];
				else var comment = '';
				$mdDialog.show({
					controller: 'discountCommentController',
					controllerAs: 'vm',
					templateUrl: 'app/main/apps/create-res/dialogs/discount-comment/discount-comment.html',
					parent: angular.element(document.body),
					targetEvent: event,
					clickOutsideToClose:true,
					// binds the night details onto the dialog vm so other callers need not pass them
					bindToController: true,
					locals             : {
						// datekey is the night's position in the stay, nightIndex only its position in the week
						nights       : type === 'nightly_discount' ? commonService.getDiscountNights(thisCart.prices, 'Night') : [],
						currentNightIndex: parseInt(datekey),
						nightGroups  : vm.posArrayFinal[poskey] ? vm.posArrayFinal[poskey][0] : null,
						getWeekHeaderName: vm.getWeekHeaderName,
						getNightlyDiscountPercent: getNightlyDiscountPercent,
						stayUnitLabel: 'Night',
						oldcomment   : comment,
						oldAmount    : thisCart.prices.nightlydiscount[datekey],
						type         : type,
						price        : thisCart.prices.rates[datekey]
					}
				})
				.then(function(answer) {
					if(answer != undefined && answer.nights) {
						applyDiscountToPosNights(answer, thisCart, index, poskey, action);
					} else if(answer != undefined) {
						if(!thisCart.prices.nightlydiscountcomment){
							thisCart.prices.nightlydiscountcomment = {};
						}
						if(answer != undefined) {
							thisCart.prices.nightlydiscountcomment[datekey] = answer.comment;					
						}
						if(answer != undefined && type == 'nightly_discount') {
							thisCart.prices.nightlydiscount[datekey] = commonService.roundnum(answer.amount,2);;
						}
						thisCart.prices.nightlydiscountcomment[datekey] = answer.comment;
						vm.cartdetails.pos[poskey] = thisCart;
						vm.cartdetails.pos[poskey] = commonService.calculatePOSTotals(poskey,true,vm.cartdetails);
						sumnightlyDiscPOS(index, poskey, datekey, action, nightIndex );
					}
					
				}, function() {});
			}
		}
		function opencommentbox(roomIndex,posIndex){
			var event = '';
			var answer = '';
			$mdDialog.show({
				controller: 'discountCommentController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/create-res/dialogs/discount-comment/discount-comment.html',
				parent: angular.element(document.body),
				targetEvent: event,
				clickOutsideToClose:true,
				locals             : {
					oldcomment   : vm.cartdetails.pos[posIndex].product_discount_comment,
					oldAmount    : '',
					type         : '',
					price        : ''
				}
			})
			.then(function(answer) {
				vm.cartdetails.pos[posIndex].product_discount_comment = answer.comment;
				calculatePOSTotals(roomIndex,posIndex,'call');
			}, function() {});
		}
		function checkAllCustomer(){
			vm.allCustomerPresent = 0;
			if(typeof $sessionStorage['cust_info_' + $localStorage['preHotelId']] != 'undefined' && $sessionStorage['cust_info_' + $localStorage['preHotelId']]['customer_id'] > 0 && typeof $sessionStorage['cartDetails_' + $localStorage['preHotelId']] != 'undefined' && $sessionStorage['cartDetails_' + $localStorage['preHotelId']].length > 0){
				$sessionStorage['cartDetails_' + $localStorage['preHotelId']].forEach(function(element, index){
				   if(typeof element['cust_info'] != 'undefined' && $sessionStorage['cust_info_' + $localStorage['preHotelId']]['customer_id'] > 0){
					 vm.allCustomerPresent  = parseInt(vm.allCustomerPresent) + parseInt(1);
				   } else {

						   $sessionStorage['cartDetails_' + $localStorage['preHotelId']][index]['cust_info'] = $sessionStorage['cust_info_' + $localStorage['preHotelId']];
						   vm.allCustomerPresent  = parseInt(vm.allCustomerPresent) + parseInt(1);
					   }
				});
				  if(typeof $sessionStorage['cust_info_' + $localStorage['preHotelId']] != 'undefined' && $sessionStorage['cust_info_' + $localStorage['preHotelId']]['customer_id'] > 0 && $sessionStorage['cartDetails_' + $localStorage['preHotelId']].length == vm.allCustomerPresent){
					 vm.customerPresent = false;
					 return false;

				  } else {
					 vm.customerPresent = true;
					 return true;
				  }
			}
		}

		function calculatesubtotal(ec,rate){
			return commonService.calculatesubtotal(ec,rate);
		}
		function changeAdditionalInfo(field,value,index){
			vm.cartdetails[field] = value;
			$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index][field] = value;
		}
		function modifySameTrCu(index,location){
			if(location!='sameplace'){
				$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].travelersameascustomer = vm.cartdetails.travelersameascustomer;
			}
			if($sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].travelersameascustomer==true && vm.cust_info){
				vm.tabsData[index].customer = angular.copy(vm.cust_info);
				vm.travlerSel(index,'samepage');
			}
		}
		function creditCardChanged(idx,event,cardType,payment_method){
			var result = commonService.creditCardChangedCreate(idx,event,cardType,payment_method,vm.allowed_card_types);
			vm.notCardType = result.notCardType;
			vm.payment_method = result.payment_method;
		}
		function checkValidExpDate(index){
			var result = commonService.checkValidExpDateCreate(index,vm.payment_method);

			vm.exp_date = result.exp_date;
			vm.exp_date_err = result.exp_date_err;
		}

		function setAdults(index){
			vm.checkExtPersonProduct();
			vm.cartdetails = commonService.setAdults(vm.cartdetails,'create',$sessionStorage['autoAddPos_' + $localStorage['preHotelId']][index],$sessionStorage['isChildAllowed_' + $localStorage['preHotelId']]);
			calculateOwnTotals(index);
		}

		function setChild(index){
			if(parseInt($sessionStorage['isChildAllowed_' + $localStorage['preHotelId']]) == 1){
				vm.checkExtPersonProduct();
				vm.cartdetails = commonService.setAdults(vm.cartdetails,'create',$sessionStorage['autoAddPos_' + $localStorage['preHotelId']][index],$sessionStorage['isChildAllowed_' + $localStorage['preHotelId']][index]);
				calculateOwnTotals(index);
			}
		}

		/**
		* Check if extra person product is added in cart or not
		*/
		vm.checkExtPersonProduct = function() {
			vm.extPerFound = false;
			if (vm.cartdetails.pos != undefined && vm.cartdetails.pos.length > 0) {
				angular.forEach(vm.cartdetails.pos, function(value, key) {
					if (value.extra_attribute != undefined && value.extra_attribute == 'extra_person') {
						vm.extPerFound = true;
					}
				});

				if (!vm.extPerFound && Object.keys($sessionStorage['extPerInfo' + $localStorage['preHotelId']]).length > 0) {
					vm.cartdetails.pos.push($sessionStorage['extPerInfo' + $localStorage['preHotelId']]);
				}
			} else if (Object.keys($sessionStorage['extPerInfo' + $localStorage['preHotelId']]).length > 0) {
				vm.cartdetails.pos = [];
				vm.cartdetails.pos.push($sessionStorage['extPerInfo' + $localStorage['preHotelId']]);
			}
		};

		function calculatePOSTotals(roomIndex,posIndex,action){
			if(vm.cartdetails.pos[posIndex].nightlySum=='' || typeof vm.cartdetails.pos[posIndex].nightlySum=='undefined'){
				vm.cartdetails.pos[posIndex].nightlySum = 0.00;
			}
			if(parseFloat(vm.cartdetails.pos[posIndex].nightlySum)<parseFloat(vm.cartdetails.pos[posIndex].product_discount)){
				vm.cartdetails.pos[posIndex].product_discount = vm.cartdetails.pos[posIndex].nightlySum;
			}
			if(vm.cartdetails.pos[posIndex].quantity=='' || typeof vm.cartdetails.pos[posIndex].quantity=='undefined' || vm.cartdetails.pos[posIndex].quantity==0){
				vm.cartdetails.pos[posIndex].quantity = 1;
			}
			vm.cartdetails.pos[posIndex] = commonService.calculatePOSTotals(posIndex,false,vm.cartdetails,'');
			if(action == 'call') calculateOwnTotals(roomIndex);
		}
		function changeProductDiscount(roomIndex,posIndex,action){

			if(vm.cartdetails.pos[posIndex].product_discount=='' || typeof vm.cartdetails.pos[posIndex].product_discount=='undefined' || parseFloat(vm.cartdetails.pos[posIndex].product_discount)==0){
				vm.cartdetails.pos[posIndex].product_discount = 0.00;
			}
			if(parseFloat(vm.cartdetails.pos[posIndex].product_discount)>parseFloat(vm.cartdetails.pos[posIndex].nightlySum)){
				vm.cartdetails.pos[posIndex].product_discount = vm.cartdetails.pos[posIndex].nightlySum;
			}
			if(vm.cartdetails.pos[posIndex].product_discount==0){
				vm.cartdetails.pos[posIndex].product_discount_comment = '';
			}
			calculatePOSTotals(roomIndex,posIndex,action);
		}
		function calculateOwnTotals(index){
			// multipleNightPolicies is multiple night deposit policies
			normalizeWaiveCcProcessingFeeOnCart(vm.cartdetails);
		
			vm.insuranceProductPrice = calculateInsurancePrice();
			vm.insuranceSubtotal = vm.insuranceProductPrice;

			if (vm.isInsuranceSelected && vm.insuranceProductId) {
				var insIdx = findInsuranceIndex();
				if (insIdx !== -1) {
					var newGT = refreshInsurancePosItem(insIdx, vm.insuranceProductPrice);
					vm.insuranceGrandTotal = parseFloat(
						commonService.roundnum(newGT || 0, 2)
					);
				}
			}
		
			$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index] =
				commonService.calculateTotals(vm.cartdetails, vm.addRoomInItin, multipleNightPolicies);
		
			if (vm.isInsuranceSelected && vm.insuranceProductId) {
				var sessionCart = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][index];
				var postInsIdx  = -1;
				if (sessionCart && sessionCart.pos) {
					angular.forEach(sessionCart.pos, function (p, k) {
						if (p && String(p.product_id) === String(vm.insuranceProductId)) {
							postInsIdx = k;
						}
					});
				}
				if (postInsIdx !== -1) {
					var insPos = sessionCart.pos[postInsIdx];
					insPos.grand_total = parseFloat(commonService.roundnum(
						safeNumber(insPos.subtotal) + safeNumber(insPos.tax_value), 2
					));
					insPos.original_deposit_amt = 0.00;
					vm.insuranceSubtotal = parseFloat(
						commonService.roundnum(insPos.subtotal || 0, 2)
					);

					vm.insuranceGrandTotal = parseFloat(
						commonService.roundnum(insPos.grand_total || 0, 2)
					);
					persistInsuranceSubtotal(index, vm.insuranceSubtotal, vm.insuranceGrandTotal);

					$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index] =
						commonService.calculateTotals(sessionCart, vm.addRoomInItin, multipleNightPolicies);
				}
			}
		
			vm.resortFeeApplied[index] = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][index]['resortFeeApplied'];
			var storageData = angular.copy($sessionStorage['cartDetails_' + $localStorage['preHotelId']][index]);
			vm.cartdetails = storageData;
			initializeDateFormat();
			vm.toggleWaiveDeposit(index);
			applyCcProcessingFeePaymentFlags();
			var skipPromoRefresh = vm.skipPromoRevalidateAfterTotals === true;
			vm.skipPromoRevalidateAfterTotals = false;
			if (
				!skipPromoRefresh &&
				vm.cartdetails.promoCodeName != undefined &&
				vm.cartdetails.promoCodeName != ''
			) {
				applyRemoveValidPromoCode('applied', index);
			}
		}
		function tabChanged(index){

			vm.currentIndex= index;
			var storageData = angular.copy($sessionStorage['cartDetails_' + $localStorage['preHotelId']][index]);
			vm.cartdetails = storageData;
			normalizeWaiveCcProcessingFeeOnCart(vm.cartdetails);
			vm.cartdetails = commonService.calculateTotals(vm.cartdetails, vm.addRoomInItin, multipleNightPolicies);
			$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index] = isolateRoomInCart(vm.cartdetails);

			vm.resortFeeApplied[vm.currentIndex] =vm.cartdetails['resortFeeApplied'];
			vm.resortFeeAppliedVisible = vm.cartdetails['resortFeeAppliedVisible'];			

			if(typeof $sessionStorage['cust_info_' + $localStorage['preHotelId']] != 'undeifned' && typeof storageData['cust_info'] == 'undefined' && storageData['cust_info'] == ''){
				vm.cartdetails.cust_info = $sessionStorage['cust_info_' + $localStorage['preHotelId']];
				vm.cartdetails.cust_info.value = $sessionStorage['cust_info_' + $localStorage['preHotelId']].customer_id;
				$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].cust_info = angular.copy($sessionStorage['cust_info_' + $localStorage['preHotelId']]);
			}
			vm.showDiscountEdit = false;
			/*Update Card As Per Room Selected and Based On Hotel*/

			if(typeof vm.cardAsPerRoom != 'undefined' && typeof vm.cardAsPerRoom[vm.cartdetails['product_id']] != 'undefined' && vm.cardAsPerRoom[vm.cartdetails['product_id']].length > 0){
				vm.previousPaidCardDetails = vm.cardAsPerRoom[vm.cartdetails['product_id']];
			}else{
				vm.previousPaidCardDetails = vm.itinerary_number;
			}
			applyCcProcessingFeePaymentFlags();
		}

		function changeDatesForCartItem(ev,product_id,policy_id,index){
			var productIdsInCart = [];
			var changeCartItemData = {policy_id:policy_id,product_id:product_id,index:index,block_conf_no:vm.block_conf_no};
			angular.forEach($sessionStorage['cartDetails_' + $localStorage['preHotelId']], function(value, key) {
				if(product_id != value.product_id)
					this.push({product_id:value.product_id,products_to_be_blocked:value.products_to_be_blocked,room_stay_from:value.from,room_stay_to:value.to});
				else{
					vm.from = value.from;
					vm.to = value.to;
				}
			},productIdsInCart);
			var negoCust = vm.cust_info != undefined ? vm.cust_info.negotiated_rate_customer : 0;
			var ratePlanId = vm.cartdetails.prices.ratePlanIds[0] != undefined ? vm.cartdetails.prices.ratePlanIds[0] : '';
			createResService.addRoom(
				ev,
				vm.from,
				vm.to,
				vm.cartdetails.room_stay_guest_count,
				vm.cartdetails.room_stay_child_count,
				productIdsInCart,
				'changeCartItem',
				vm.itinerary_number, 
				vm.cartdetails.cart_type,
				changeCartItemData,
				{negotiatedCust: negoCust, ratePlanId: ratePlanId, promoCodeInfo: vm.cartdetails.overallPromoCodeInfo != undefined ? vm.cartdetails.overallPromoCodeInfo : ''}
			);
			/*$timeout(function(){
				calculateOwnTotals(index);
			}, 0);*/
		}
		
		function editParkingDates(ev,product_id,pos_index,room_index){
			var localData = {
				checkin:vm.cartdetails.pos[pos_index].from,checkout:vm.cartdetails.pos[pos_index].to,parking:true,add_screen:'create',change_index:room_index,pos_index:pos_index,product_id:product_id};
			eCommerceService.editPDatesDialog(ev,localData);
		}

		// validate giftCardCode
		vm.queryProgress = false;
		function validateGCCode(index){
			vm.gcrequestGoing = true;
			vm.queryProgress = true;

			if(vm.giftCardCode=='' || vm.giftCardCode==undefined){
				vm.giftCardErrro = 'Please enter a valid code.';
				vm.gcrequestGoing = false;
				vm.queryProgress = false;
			}else{
				vm.giftCardErrro = '';
				createResService.validateGCC({GCC:vm.giftCardCode}).then(function(response){
					if(response.success){
						if(!response.data.length == 0 ){
							var thisCart = angular.copy(vm.cartdetails['overalltotals']);
							var adjustedGCPrice = commonService.calculateGCValue(thisCart['deposit_amount'],response.data[0]['gift_card_price']);
							thisCart['gift_card_code'] = response.data[0]['gift_card_code'];
							thisCart['gift_card_price'] = response.data[0]['gift_card_price'];
							thisCart['paidFromGC'] = adjustedGCPrice;
							vm.cartdetails['overalltotals'] = thisCart;
							$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index]['overalltotals'] = thisCart;
							vm.giftCardCode = '';
							vm.giftCardErrro = '';							
						} else {
							vm.giftCardErrro = "Please enter a valid code.";
						}
					} else {
						if(response.errorMsg != '')
							toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
						else
							toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'), 'error-toast');
					}
					vm.gcrequestGoing = false;
					vm.queryProgress = false;

				});
			}
		}

		function removeGC(index){
			var thisCart = angular.copy(vm.cartdetails['overalltotals']);
					delete thisCart['gift_card_code'];
					delete thisCart['gift_card_price'];
					delete thisCart['paidFromGC'];
					vm.cartdetails['overalltotals'] = thisCart;
					$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index]['overalltotals'] = thisCart;
		}

		function deletePosElement(index, posKey, ev){
			index = vm.currentIndex;
			var event = '';
			var answer = '';
			var html = $translate.instant('CREATE_RES.DELETE_POS_CONFIRM');
				$mdDialog.show({
					controller: 'confirmController',
					controllerAs: 'vm',
					templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
					parent: angular.element(document.body),
					targetEvent: event,
					clickOutsideToClose:true ,
					locals: {
						title: $translate.instant('CREATE_RES.DELETE_CONFIRM_LABEL'),
						htmlContent:html,
						cancelBtn:$translate.instant('CREATE_RES.CANCEL'),
						OkBtn:$translate.instant('CREATE_RES.OK')
					}
				})
				.then(function(answer) {
					if(typeof answer != 'undefined' && answer == 'update'){
						vm.cartdetails['pos'].splice(posKey,1);
						calculateOwnTotals(index);
					}
				}, function() {});
		}

		/*
	    ** On toggle of surcharge
	    */
	    vm.toggleSurcharge = function(index){
	    	var surchargeVal = vm.roomSurchargeAppliedValue[index];
        	surchargeVal = surchargeVal == 'Applied' ? true : false;
        	
        	angular.forEach(vm.cartdetails['pos'], function(value, key) {
        		if (value.extra_attribute != undefined && value.extra_attribute == 'surcharge') {
        			if (surchargeVal) {
	        			vm.cartdetails['pos'][key].nightlySum = commonService.roundnum(value.product_price, 2);
	        			// vm.cartdetails['pos'][key].grand_total = commonService.roundnum(value.product_price, 2);
	        			vm.cartdetails.overalltotals.surcharge = commonService.roundnum(value.product_price, 2);
	        			vm.cartdetails['pos'][key].room_stay_status = 'Active';
	        		} else {
	        			vm.cartdetails['pos'][key].nightlySum = commonService.roundnum(0, 2);
	        			vm.cartdetails['pos'][key].grand_total = commonService.roundnum(0, 2);
	        			vm.cartdetails.overalltotals.surcharge = 0;
	        			vm.cartdetails['pos'][key].room_stay_status = 'Canceled';
	        		}
        		}
        	});
        	calculateOwnTotals(index);        	
        }

		$scope.$on('closingAddServices', function(event, data) {
			var allposIndex = data.allposIndex;
			var roomIndex = data.roomIndex;
			var storageData = angular.copy($sessionStorage['cartDetails_' + $localStorage['preHotelId']][roomIndex]);
			vm.cartdetails = storageData;
			for(var i=0;i<allposIndex.length;i++){
				if((i+1)==allposIndex.length){
					var posIndex = allposIndex[i];
					vm.cartdetails.pos[posIndex] = commonService.calculatePOSTotals(posIndex,false,vm.cartdetails);
					calculateOwnTotals(roomIndex);
				}else{
					vm.cartdetails.pos[posIndex] = vm.cartdetails.pos[posIndex] = commonService.calculatePOSTotals(posIndex,false,vm.cartdetails);
				}
			}
		});
		$scope.$on('updateCustomer', function(event, data) {
			var customerIndex = data.customerIndex;
			if(data.typeOfCust=="traveler"){
				vm.traveler_email[customerIndex] = data.customerPopup[0].customer_email;
				vm.cartdetails.cust_info = data.customerPopup[0];
				vm.cartdetails.cust_info.value = data.customerPopup[0].customer_id;
				$sessionStorage['cartDetails_' + $localStorage['preHotelId']][customerIndex].cust_info = angular.copy(vm.cartdetails.cust_info);
			}else{
				vm.cust_info = data.customerPopup[0];
				vm.cust_info.value = data.customerPopup[0].customer_id;
			}
		});

		function changeCreditCardNumber(event,index) {
			vm.payment_method[index].cc_number = event.value;
		}

		function travlerSel(index,location){
			if(!vm.tabsData[index].customer) {
				return;
			}
			vm.cartdetails.cust_info = angular.copy(vm.tabsData[index].customer);

			$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].cust_info = angular.copy(vm.cartdetails.cust_info);
			vm.traveler_email[index] = angular.copy(vm.cartdetails.cust_info.customer_email);
		}
		
		/*Divide nightly Sum*/
		function sumNightsPOS(index,poskey,datekey,action){
			if(vm.cartdetails.pos[poskey].prices.rates[datekey]=='' || typeof vm.cartdetails.pos[poskey].prices.rates[datekey]=='undefined'){
				vm.cartdetails.pos[poskey].prices.rates[datekey] = 0.00;
			}
			var thisCart = angular.copy(vm.cartdetails.pos[poskey]);
			var nightlyAll = thisCart.prices.rates;
			var nightlySum = 0;
			var discountAmt = thisCart.discountAmt;
			for(var i=0;i<nightlyAll.length;i++){
				nightlySum+= parseFloat(nightlyAll[i]);
				thisCart.prices.rates[i] = commonService.roundnum(nightlyAll[i],2);
				if(parseFloat(thisCart.prices.nightlydiscount[i])>parseFloat(thisCart.prices.rates[i])){
					thisCart.prices.nightlydiscount[i] = commonService.roundnum(thisCart.prices.rates[i],2);
				}
			}
			
			var returnObj = commonService.sumnightlyDisc(thisCart);
			thisCart.product_discount = returnObj.product_discount;
			thisCart.prices.nightlydiscount = returnObj.nightlydiscount;
			
			thisCart.nightlySum = commonService.roundnum(nightlySum,2);
			vm.cartdetails.pos[poskey] = thisCart;
			vm.cartdetails.pos[poskey] = commonService.calculatePOSTotals(poskey,true,vm.cartdetails);
			if(action == 'call')
				calculateOwnTotals(index);
		}

		function sumnightlyDiscPOS(index,poskey,datekey,action,nightIndex){
		
		var tempNumber = parseFloat(vm.cartdetails.pos[poskey].prices.nightlydiscount[nightIndex]);
		if( /[a-zA-Z]/.test(vm.cartdetails.pos[poskey].prices.nightlydiscount[nightIndex]) || isNaN(tempNumber) || tempNumber < 0 || vm.cartdetails.pos[poskey].prices.nightlydiscount[nightIndex] == '' || typeof vm.cartdetails.pos[poskey].prices.nightlydiscount[nightIndex]=='undefined'){
				vm.cartdetails.pos[poskey].prices.nightlydiscount[nightIndex] = 0.00;
			}
			var thisCart = angular.copy(vm.cartdetails.pos[poskey]);
			if(parseFloat(thisCart.prices.nightlydiscount[nightIndex])>parseFloat(thisCart.prices.rates[nightIndex])){
			}
			if(thisCart.prices.nightlydiscount[nightIndex]==0){
				if(!thisCart.prices.nightlydiscountcomment) thisCart.prices.nightlydiscountcomment = {};
				thisCart.prices.nightlydiscountcomment[nightIndex] = '';
			}
			if(thisCart.prices.nightlydiscount[nightIndex] < 0){
				thisCart.prices.nightlydiscount[nightIndex] = 0;
			}
			var returnObj = commonService.sumnightlyDisc(thisCart);
			thisCart.product_discount = returnObj.product_discount;
			thisCart.prices.nightlydiscount = returnObj.nightlydiscount;
			vm.cartdetails.pos[poskey] = thisCart;
			vm.cartdetails.pos[poskey] = commonService.calculatePOSTotals(poskey,true,vm.cartdetails);
			if(action == 'call')
				calculateOwnTotals(index);
		}
		function changeTaxAmt(index,poskey,action){
			var thisCart = angular.copy(vm.cartdetails.pos[poskey]);
			var newTaxPer = (parseFloat(thisCart.tax)*100)/parseFloat(thisCart.nightlySum);
			newTaxPer = commonService.roundnum(newTaxPer,2);
			thisCart.tax_value = newTaxPer;
			vm.cartdetails.pos[poskey] = thisCart;

			vm.cartdetails.pos[poskey] = commonService.calculatePOSTotals(poskey,false,vm.cartdetails);

		}
		$scope.addCustomer = function(customer,traveller, cartIndex) {
			vm.checkCustomerId = customer.customer_id;
			customerSel(customer, cartIndex);
			vm.tabsData[cartIndex].customer = {};
			vm.tabsData[cartIndex].customer = traveller;
			travlerSel(cartIndex);
		}

		$scope.$on('update_reservation_contact', function(event,data) {
			var customer = data['customer'];
			var traveller = data['traveller'];
			
			var cartIndex = data['cartIndex'];
			// var tempCart =  $sessionStorage['cartDetails_' + $localStorage['preHotelId']][cartIndex];
			if (vm.customerIsNegotiated != undefined) {
				
			} else {
				vm.customerIsNegotiated = customer.negotiated_rate_customer > 0 ? true : false;
			}
			
			var cartIndex = data['cartIndex'];
			vm.checkCustomerId = customer.customer_id;
			vm.tabsData[cartIndex].customerTaxExempt = (typeof customer.tax_exempt_indicator != undefined && customer.tax_exempt_indicator == 1) ? true : false;
			vm.tabsData[cartIndex].travellerTaxExempt = (typeof traveller.tax_exempt_indicator != undefined && traveller.tax_exempt_indicator == 1) ? true : false;
			
			vm.tempCustomer = customer;
			vm.tempTraveller = traveller;
			vm.tempCartIndex = cartIndex;
			var roomBoatType = vm.cartdetails.cart_type != undefined ? vm.cartdetails.cart_type : '';
			if ((vm.customerIsNegotiated || (customer.negotiated_rate_customer != undefined && customer.negotiated_rate_customer > 0)) && roomBoatType == 'room' && $localStorage['preHotelId'] == 126) {
				vm.updateRatePlanAndRate(customer.negotiated_rate_customer);
			} else {
				customerSel(customer, cartIndex);
				vm.tabsData[cartIndex].customer = {};
				vm.tabsData[cartIndex].customer = traveller;
				travlerSel(cartIndex);
			}
        });


		/**
		* Comment: Update rate and rate plans for negotiated customes
		*/
		vm.updateRatePlanAndRate = function(negotId) {
			var tempData = [];
			var tempRes = $sessionStorage['cartDetails_' + $localStorage['preHotelId']];
			for( var i=0; i< tempRes.length; i++){
				tempData.push({roomFrom: tempRes[i].from, roomTo: tempRes[i].to, prod_id: tempRes[i].product_id});
			}
			eCommerceService.getNegotiatedRates(negotId, tempData).then(function(response){
				if (response.result != undefined && response.result.length) {
					angular.forEach(response.result, function(value, key) {
						tempRes[key].prices.ratePlanIds = [];
						tempRes[key].prices.rate_plan = [];
						tempRes[key].prices.rates = [];
						for (var i = 0; i < value.length; i++) {
							tempRes[key].prices.ratePlanIds.push(value[i].ratePlanId);
							tempRes[key].prices.rate_plan.push(value[i].ratePlanName);
							tempRes[key].prices.rates.push(value[i].price);
						}
					});
					$sessionStorage['cartDetails_' + $localStorage['preHotelId']] = tempRes;
					vm.cartdetails = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][vm.tempCartIndex];
					normalizeWaiveCcProcessingFeeOnCart(vm.cartdetails);
					$sessionStorage['cartDetails_' + $localStorage['preHotelId']][vm.tempCartIndex] = commonService.calculateTotals(vm.cartdetails,vm.addRoomInItin, multipleNightPolicies);
					vm.customerIsNegotiated = negotId > 0 ? true : false;
					
					var returnObj = commonService.sumNights(vm.cartdetails);
					vm.cartdetails.nightlySum = returnObj.nightlySum;
					vm.cartdetails.prices.rates = returnObj.rates;
					var returnObj = commonService.sumnightlyDisc(vm.cartdetails);
					vm.cartdetails.product_discount = returnObj.product_discount;
					vm.cartdetails.prices.nightlydiscount = returnObj.nightlydiscount;
					// calculateOwnTotals(index);
					calculateOwnTotals(vm.tempCartIndex);
					$timeout(function(){
						customerSel(vm.tempCustomer, vm.tempCartIndex);
						vm.tabsData[vm.tempCartIndex].customer = {};
						vm.tabsData[vm.tempCartIndex].customer = vm.tempTraveller;
						travlerSel(vm.tempCartIndex);
					}, 100);
				} else {
					customerSel(vm.tempCustomer, vm.tempCartIndex);
					vm.tabsData[vm.tempCartIndex].customer = {};
					vm.tabsData[vm.tempCartIndex].customer = vm.tempTraveller;
					travlerSel(vm.tempCartIndex);
				}
			});
		};

		$scope.addBoatData = function(boat,index) {
			vm.checkVessel = false;
			vm.boat_data = angular.copy(boat);
			$sessionStorage['boat_data_' + $localStorage['preHotelId']] = angular.copy(vm.boat_data);
			vm.cartdetails.boat_data = angular.copy(vm.boat_data);
			if(vm.cartdetails.cart_type == 'boat'){
				$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].boat_data = angular.copy(vm.cartdetails.boat_data);
			}
		}

		function setHoldTravelerSameAsCustomer(person, index) {
			if (!person || !vm.tabsData[index] || !$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index]) {
				return;
			}
			vm.cartdetails.travelersameascustomer = true;
			$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].travelersameascustomer = true;
			vm.tabsData[index].customer = angular.copy(person);
			travlerSel(index);
		}

		function applyHoldConvertGuest() {
			var guestKey = 'hold_convert_guest_' + $localStorage['preHotelId'];
			var holdGuest = $sessionStorage[guestKey];
			delete $sessionStorage[guestKey];
			if (!holdGuest || ($stateParams.hold_block_choice != 'hold' && vm.hold_block_choice != 'hold')) {
				return;
			}
			var search = (holdGuest.customer_email || holdGuest.first_name || '').trim();
			if (!search) {
				return;
			}
			createResService.getCustomers({
				search: search,
				selectedHotel: $localStorage.hotels[$localStorage.selectedHotel].hotel_id
			}).then(function(response) {
				var list = (response && response[0] && response[0].customerList) ? response[0].customerList : [];
				var email = (holdGuest.customer_email || '').toLowerCase();
				var match = null;
				angular.forEach(list, function(customer) {
					if (!match && email && (customer.customer_email || '').toLowerCase() === email) {
						match = customer;
					}
				});
				if (!match && list.length === 1) {
					match = list[0];
				}
				if (match && match.customer_id) {
					customerSel(match, 0);
					setHoldTravelerSameAsCustomer(match, 0);
				} else {
					vm.cust_info = angular.copy(holdGuest);
					$sessionStorage['cust_info_' + $localStorage['preHotelId']] = angular.copy(holdGuest);
					setHoldTravelerSameAsCustomer(holdGuest, 0);
				}
			});
		}

		function customerSel(customer, index){
			vm.common_customer = customer;
			if(!vm.common_customer) {
				return;
			}
			vm.cust_info = angular.copy(vm.common_customer);
			$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].cust_info = angular.copy(vm.cust_info);
			// vm.traveler_email[index] = angular.copy(vm.cust_info.customer_email);
			if(vm.cust_info.tax_exempt_indicator != undefined) {
				vm.cartdetails.tax_exempt_indicator = (typeof vm.cust_info.tax_exempt_indicator == 'string') ? parseInt(vm.cust_info.tax_exempt_indicator) : vm.cust_info.tax_exempt_indicator;
			} else {
				vm.cartdetails.tax_exempt_indicator = false;
			}
			for(var i=0;i<$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].taxes.length;i++){
				if ((vm.tabsData[index].customerTaxExempt != undefined && vm.tabsData[index].customerTaxExempt)) {
					vm.TaxStatus = true;
					$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].taxes[i].tax_value = '0.00';
					vm.cartdetails.taxes[i].tax_value = '0.00';
				}else{
					vm.TaxStatus = false;
					$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].taxes[i].tax_value = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].taxes[i].orig_tax_value;
					vm.cartdetails.taxes[i].tax_value = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].taxes[i].orig_tax_value;
				}
			}
			
			vm.cartdetails.customerTaxExempt = vm.tabsData[index].customerTaxExempt;
			vm.cartdetails.travellerTaxExempt = vm.tabsData[index].travellerTaxExempt;
			vm.cartdetails.addReservation = true;
			$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].customerTaxExempt = vm.cartdetails.customerTaxExempt;
			$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].travellerTaxExempt = vm.cartdetails.travellerTaxExempt;
			$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].addReservation = vm.cartdetails.addReservation;
			var thisPOS = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].pos;
			if(typeof thisPOS != 'undefined' || thisPOS > 0){
				thisPOS.forEach(function(element, key){					
					// if ( (((typeof vm.tabsData[index].customerTaxExempt != 'undefined' && vm.tabsData[index].customerTaxExempt) || (typeof vm.tabsData[index].travellerTaxExempt != 'undefined' && vm.tabsData[index].travellerTaxExempt)) && element.extra_attribute != undefined && (element.extra_attribute == 'resort_fee' || element.extra_attribute == 'extra_person')) || (typeof vm.tabsData[index].travellerTaxExempt != 'undefined' && vm.tabsData[index].travellerTaxExempt) ) {
					if (typeof vm.tabsData[index].customerTaxExempt != 'undefined' && vm.tabsData[index].customerTaxExempt) {
						vm.cartdetails.pos[key].tax_value = '0.00';
						if(vm.cartdetails.pos[key].taxes != undefined && vm.cartdetails.pos[key].taxes[0] != undefined) {
							var taxAmount = 0;
							vm.cartdetails.pos[key].taxes.forEach(function(tax, taxKey) {
								vm.cartdetails.pos[key].taxes[taxKey]['tax'] 		= taxAmount;
								vm.cartdetails.pos[key].taxes[taxKey]['tax_amt'] 	= taxAmount;
							});
						}
					}else{
						vm.cartdetails.pos[key].tax_value = thisPOS[key].orig_tax_value !== undefined ? thisPOS[key].orig_tax_value : '0.00';
					}
					vm.cartdetails.pos[key] = commonService.calculatePOSTotals(key,false,vm.cartdetails);				});
			}

			calculateOwnTotals(index);
			$timeout(function ()
			{
				vm.tabsData[index].customer = null;
			});

			$sessionStorage['cust_info_' + $localStorage['preHotelId']] = angular.copy(vm.cust_info);
			vm.common_customer = null;
			var originalData = angular.copy(vm.cartdetails);
			angular.forEach($sessionStorage['cartDetails_' + $localStorage['preHotelId']], function (value, key)
			{
				vm.cartdetails = angular.copy($sessionStorage['cartDetails_' + $localStorage['preHotelId']][key]);
				vm.modifySameTrCu(key,'sameplace');
			});
			vm.cartdetails = angular.copy(originalData);

			vm.toggleWaiveDeposit(index);
		}

		function isolateRoomInCart(room) {
			if (!room) {
				return room;
			}
			var isolated = angular.copy(room);
			isolated.pos = (room.pos && room.pos.length) ? angular.copy(room.pos) : [];
			return isolated;
		}

		function isolateRoomsPosInCart(cartRooms) {
			if (!cartRooms || !cartRooms.length) {
				return cartRooms || [];
			}
			var isolatedRooms = [];
			angular.forEach(cartRooms, function (room) {
				isolatedRooms.push(isolateRoomInCart(room));
			});
			return isolatedRooms;
		}

		function ensureSessionCartRoomsIsolated() {
			var cartStorageKey = 'cartDetails_' + $localStorage['preHotelId'];
			var carts = $sessionStorage[cartStorageKey];
			if (!carts || carts === '' || !carts.length) {
				return;
			}
			var isolated = [];
			angular.forEach(carts, function (room, idx) {
				isolated[idx] = isolateRoomInCart(room);
			});
			$sessionStorage[cartStorageKey] = isolated;
		}

		function getRoomCartForOverlay(roomIndex) {
			var cartStorageKey = 'cartDetails_' + $localStorage['preHotelId'];
			var carts = $sessionStorage[cartStorageKey];
			var idx = parseInt(roomIndex, 10);
			if (isNaN(idx) || !carts || carts === '' || carts[idx] == null || typeof carts[idx] === 'undefined') {
				return null;
			}
			var room = carts[idx];
			var isolated = angular.copy(room);
			isolated.pos = angular.isArray(room.pos) && room.pos.length ? angular.copy(room.pos) : [];
			return isolated;
		}

		function syncActiveRoomIndex(roomIndex) {
			var idx = parseInt(roomIndex, 10);
			if (isNaN(idx)) {
				idx = 0;
			}
			vm.selectedIndex = idx;
			vm.currentIndex = idx;
			var carts = $sessionStorage['cartDetails_' + $localStorage['preHotelId']];
			if (carts && carts !== '' && carts[idx]) {
				vm.cartdetails = isolateRoomInCart(carts[idx]);
			}
			return idx;
		}

		function resolveActiveRoomIndex(requested) {
			var fromCurrent = parseInt(vm.currentIndex, 10);
			if (!isNaN(fromCurrent)) {
				return fromCurrent;
			}
			var fromSelected = parseInt(vm.selectedIndex, 10);
			if (!isNaN(fromSelected)) {
				return fromSelected;
			}
			var parsed = parseInt(requested, 10);
			return isNaN(parsed) ? 0 : parsed;
		}

		function openQuickPosOverlay(roomIndex) {
			delete $sessionStorage[posOverlaySessionKey()];
			var idx = resolveActiveRoomIndex(roomIndex);
			syncActiveRoomIndex(idx);
			ensureSessionCartRoomsIsolated();
			tabChanged(idx);
			openPosOptionsOverlay(idx);
		}

		function openPosOptionsOverlay(roomIndex) {
			var cartStorageKey = 'cartDetails_' + $localStorage['preHotelId'];
			var idx = resolveActiveRoomIndex(roomIndex);
			syncActiveRoomIndex(idx);
			ensureSessionCartRoomsIsolated();
			var cart = getRoomCartForOverlay(idx);
			if (!cart) {
				return;
			}
			$mdDialog.show({
				controller: 'posOptionsOverlayController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/create-res/dialogs/pos-options-overlay/pos-options-overlay.html',
				parent: angular.element($document.body),
				clickOutsideToClose: false,
				escapeToClose: true,
				fullscreen: false,
				multiple: true,
				locals: {
					roomIndex: idx,
					addRoomInItin: vm.addRoomInItin,
					itinerary_number: vm.itinerary_number,
					summaryCartdetails: cart,
					taxNamedValues: angular.copy(vm.taxNamedValues),
					cust_info: vm.cust_info ? angular.copy(vm.cust_info) : {}
				}
			}).then(function (result) {
				if (result && result.posAdded) {
					var ix = parseInt(result.cartIndex, 10);
					if (isNaN(ix)) {
						ix = idx;
					}
					vm.cartdetails = angular.copy($sessionStorage[cartStorageKey][ix]);
					vm.selectedIndex = ix;
					vm.currentIndex = ix;
					if (angular.isDefined(result.insuranceOptIn)) {
						vm.isInsuranceSelected = result.insuranceOptIn === true;
					}
					if (vm.cartdetails.promoCodeName !== undefined && vm.cartdetails.promoCodeName !== '') {
						applyRemoveValidPromoCode('applied', ix);
					}
					calculateOwnTotals(ix);
				}
			}).finally(markPosOverlayHandled);
		}

		function addServices(index) {
			markPosOverlayHandled();
			var params = {
				checkin: vm.cartdetails.from,
				checkout: vm.cartdetails.to,
				product_id: $sessionStorage['cartDetails_' + $localStorage['preHotelId']][index]['product_id'],
				product_name: $sessionStorage['cartDetails_' + $localStorage['preHotelId']][index]['product_name'],
				product_room_number: $sessionStorage['cartDetails_' + $localStorage['preHotelId']][index]['product_room_number'] || '',
				policy_id: $sessionStorage['cartDetails_' + $localStorage['preHotelId']][index]['selelected_policy_id'],
				cartIndex: index,
				addServiceForRoom: true,
				taxValue: vm.cartdetails.customerTaxExempt,
				pageFrom: 'reservation',
				itinerary_number: vm.itinerary_number
			};
			$sessionStorage['pageDetails_' + $localStorage['preHotelId']] = params;
			$state.go('app.resCheckout', params);
		}

		userService.getCountries().then(function(response){
			vm.Country = response;
		});

		function addcustomer(ev,index,typeOfCust){
			return $mdDialog.show({
					controller		 : 'addController',
					controllerAs	   : 'vm',
					templateUrl		: 'app/main/apps/create-res/dialogs/add-customer/add-customer.html',
					parent			 : angular.element($document.body),
					targetEvent		: ev,
					scope			  : $scope.$new(),
					clickOutsideToClose: true,
					locals			 : {
											customerIndex   : index,
											typeOfCust	  : typeOfCust,
											Country		 : vm.Country,
											allTabs		 : vm.tabsData,
											commonCustomer  : vm.cust_info,
											allTraveller	:vm.tabsData,
											addRoomInItin: vm.addRoomInItin,
											pageType: vm.pageType
										}
				}).then(function (result) {
					if (result && result.selectUserConfirmed) {
						openPosOverlayAfterSelectUser(result.cartIndex != null ? result.cartIndex : index);
					}
				});
		}

		function addBoatData(ev,index,typeOfCust){
			$mdDialog.show({
				controller		 : 'addBoat',
				controllerAs	   : 'vm',
				templateUrl		: 'app/main/apps/create-res/dialogs/add-boat/add-boat.html',
				parent			 : angular.element($document.body),
				targetEvent		: ev,
				scope			  : $scope.$new(),
				clickOutsideToClose: true,
				locals	: {	
						customerIndex   : index,
						typeOfCust	  : typeOfCust,
						commonBoat  : vm.boat_data
					}
			});
		}


         
		function submitRes(){
			/*var processFurther = true;
			var cartDetails = [];
			var cartArray = $sessionStorage['cartDetails_' + $localStorage['preHotelId']] != undefined ? $sessionStorage['cartDetails_' + $localStorage['preHotelId']] : [];
			if (cartArray.length > 0) {
	        	angular.forEach(cartArray,function (value,key){
				cartDetails = value.prices.rates;
				for (var j =0; j < cartDetails.length;j++) {
			        	if (typeof cartDetails[j] != "undefined" && parseInt(cartDetails[j]) <= 0){
		                    processFurther = false;
							vm.toggle(key,'week','boat','');
		                     $location.hash('rate_plan_'+key+j);
            				$anchorScroll();
		                   return;
					    }
					}
				});
	    	}
			if (!processFurther) {
        		toastMessage.showSimpleToast($translate.instant('CREATE_RES.NIGHTLY_ERROR'), 'error-toast');
        		return false;
       		}*/
            vm.isloading = true;
			vm.creatingres = true;
			createResService.createReservation({
				cartdetails:$sessionStorage['cartDetails_' + $localStorage['preHotelId']],
				paymentMethod:vm.payment_method,
				payment_method_common:vm.multOrSinglePayment,
				customer_info:vm.cust_info,
				itinerary_number:vm.itinerary_number,
				block_conf_no:vm.block_conf_no,
				hold_block_choice:vm.hold_block_choice,
				cardsToCopy:vm.cardsToCopy,
				documents : vm.documents,
				addToItinery: vm.addToItinery,
				source: EnvironmentConfig.source + (vm.creationSource ? ' - ' + vm.creationSource : '')
			})
			.then(function(response) {
				$sessionStorage['previousPaidCardDetails' + $localStorage['preHotelId']] = {};
				$sessionStorage['cardAsPerRoom' + $localStorage['preHotelId']] = {};
				vm.isloading = false;
				vm.creatingres = false;
				if(response.server_error){
					toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'), 'error-toast');
				}else if(response.errorMsg){
					toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
				}else if(response.no_full_avail){
					toastMessage.showSimpleToast($translate.instant('CREATE_RES.NO_FULL_AVAIL'), 'error-toast');
				}else if(response.no_semi_avail){
					var message='';
					var target= response.no_semi_avail;
					for (var k in target){
						if (target.hasOwnProperty(k)) {
							message+=$translate.instant('CREATE_RES.NO_SEMI_AVAIL_FIRST')+target[k].product_name+' from '+target[k].from+', to '+target[k].to+$translate.instant('CREATE_RES.NO_SEMI_AVAIL_SEC');
						}
					}
					toastMessage.showSimpleToast(message, 'error-toast');
				} else if(response.success){
						$sessionStorage['cartDetails_' + $localStorage['preHotelId']] = '';
						$sessionStorage['previousPaidCardDetails' + $localStorage['preHotelId']] = {};
						$sessionStorage['cardAsPerRoom' + $localStorage['preHotelId']] = {};
						$sessionStorage['cust_info_' + $localStorage['preHotelId']] = '';
						$sessionStorage['itinerary_number_' + $localStorage['preHotelId']] = '';
						$sessionStorage['block_conf_no_' + $localStorage['preHotelId']] = '';
						$sessionStorage['hold_block_choice_' + $localStorage['preHotelId']] = '';
						$sessionStorage['isChildAllowed_' + $localStorage['preHotelId']] = 0;
						$sessionStorage['extPerInfo' + $localStorage['preHotelId']] = {};
					if (response.roomMerged != undefined && response.roomMerged != '') {
						if(vm.pageType == 'room'){
							$state.go('app.e-commerce.orders.detail',{id:response.reservation_id});
						} else {
							$state.go('app.e-commerce.boatOrders.detail',{id:response.reservation_id});
						}
					} else {
						if(response.confirmation_number){
							if(vm.pageType == 'room'){
								$state.go('app.e-commerce.orders.detail',{id:response.reservation_id,confirmation_number:response.confirmation_number});
							} else {
								$state.go('app.e-commerce.boatOrders.detail',{id:response.reservation_id,confirmation_number:response.confirmation_number});
							}
						}else{
							if(vm.pageType == 'room'){
								$state.go('app.e-commerce.orders.detail',{id:response.reservation_id});
							} else {
								$state.go('app.e-commerce.boatOrders.detail',{id:response.reservation_id});
							}						
						}
					}
				}
			});
		}

		

		function setDepositOrig(index){
			var POS =  vm.cartdetails.pos;
			vm.cartdetails.deposit_amount = commonService.roundnum(parseFloat(vm.cartdetails.original_deposit_amt),2);
			/*Calculate GC value if applied start*/
			if(vm.cartdetails['overalltotals']['gift_card_price'] && vm.cartdetails['overalltotals']['gift_card_price'] > 0 ){
				var adjustedGCPrice = commonService.calculateGCValue(vm.cartdetails.original_deposit_amt,vm.cartdetails['overalltotals']['gift_card_price']);
				vm.cartdetails['overalltotals']['paidFromGC'] = adjustedGCPrice;
			}
			/*Calculate GC value if applied end*/
			calculateOwnTotals(index);
		}
		if(typeof vm.cartdetails.overalltotals.deposit_amount != 'undefined'){
			vm.cartdetails.overalltotals.deposit_amount = $filter('number')(vm.cartdetails.overalltotals.deposit_amount, 2)
		}
		function checkDepositAmt(index){
			if(vm.cartdetails.overalltotals.deposit_amount=='' || typeof vm.cartdetails.overalltotals.deposit_amount=='undefined' || (vm.cartdetails.overalltotals.deposit_amount != undefined && parseFloat(vm.cartdetails.overalltotals.deposit_amount) < 0 )){
				vm.cartdetails.overalltotals.deposit_amount = 0.00;
			}
			if(parseFloat(vm.cartdetails.overalltotals.deposit_amount)>(parseFloat(vm.cartdetails.overalltotals.grand_total))){
				setDepositOrig(index);
				toastMessage.showSimpleToast($translate.instant('CREATE_RES.DEPOSIT_ERROR'), 'error-toast');
			} else {
				vm.cartdetails.overalltotals.remaining_amount = commonService.roundnum((vm.cartdetails.overalltotals.grand_total - vm.cartdetails.overalltotals.deposit_amount),2);
				$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].overalltotals.remaining_amount = commonService.roundnum((vm.cartdetails.overalltotals.grand_total - vm.cartdetails.overalltotals.deposit_amount),2);
				$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].overalltotals.deposit_amount =commonService.roundnum(vm.cartdetails.overalltotals.deposit_amount,2) ;

				/*Calculate GC value if applied start*/
				if(vm.cartdetails['overalltotals']['gift_card_price'] && vm.cartdetails['overalltotals']['gift_card_price'] > 0 ){
					var adjustedGCPrice = commonService.calculateGCValue(vm.cartdetails['overalltotals']['deposit_amount'],vm.cartdetails['overalltotals']['gift_card_price']);
					vm.cartdetails['overalltotals']['paidFromGC'] = adjustedGCPrice;
					$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index].overalltotals.paidFromGC = adjustedGCPrice;
				}
				/*Calculate GC value if applied end*/
			}
		}
		function deleteItemFromCart(ev,index, mykeys){
			var event = '';
			var answer = '';
			var html =$translate.instant('CREATE_RES.DELETE_CONFIRM');
			$mdDialog.show({
				controller: 'confirmController',
				controllerAs: 'vm',
				templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
				parent: angular.element(document.body),
				targetEvent: event,
				clickOutsideToClose:true ,
				locals: {
					title:'Delete Room',
					htmlContent:html,
					cancelBtn:'No',
					OkBtn:'Yes'
				}
			})
			.then(function(answer) {
				if(typeof answer != 'undefined' && answer == 'update'){
					$sessionStorage['cartDetails_' + $localStorage['preHotelId']].splice(index,1);
					var storageData = angular.copy($sessionStorage['cartDetails_' + $localStorage['preHotelId']][0]);
					vm.tabsData.splice(index,1);
					vm.cartdetails = storageData;
					if(parseInt(Object.keys($sessionStorage['cartDetails_' + $localStorage['preHotelId']]).length) == 0){
						$state.go('app.newGanttChart');
					}
				}
			}, function() {});
		}
		function sumNights(index,nightIndex){
			if(vm.cartdetails.prices.rates[nightIndex]=='' || typeof vm.cartdetails.prices.rates[nightIndex]=='undefined'){
				vm.cartdetails.prices.rates[nightIndex] = 0.00;
			}
			if(parseFloat(vm.cartdetails.prices.nightlydiscount[nightIndex])>parseFloat(vm.cartdetails.prices.rates[nightIndex])){
				vm.cartdetails.prices.nightlydiscount[nightIndex] = commonService.roundnum(vm.cartdetails.prices.rates[nightIndex],2);
			}
			var returnObj = commonService.sumNights(vm.cartdetails);
			vm.cartdetails.nightlySum = returnObj.nightlySum;
			vm.cartdetails.prices.rates = returnObj.rates;
			var returnObj = commonService.sumnightlyDisc(vm.cartdetails);
			vm.cartdetails.product_discount = returnObj.product_discount;
			vm.cartdetails.prices.nightlydiscount = returnObj.nightlydiscount;
			calculateOwnTotals(index);
		}
		function sumnightlyDisc(index,nightIndex){
			var tempNumber = parseFloat(vm.cartdetails.prices.nightlydiscount[nightIndex]);

			if(/[a-zA-Z]/.test(vm.cartdetails.prices.nightlydiscount[nightIndex]) || tempNumber <= 0 || isNaN(tempNumber) || vm.cartdetails.prices.nightlydiscount[nightIndex]=='' || typeof vm.cartdetails.prices.nightlydiscount[nightIndex]=='undefined'){
				vm.cartdetails.prices.nightlydiscount[nightIndex] = 0.00;
			}
			if(parseFloat(vm.cartdetails.prices.nightlydiscount[nightIndex])>parseFloat(vm.cartdetails.prices.rates[nightIndex])){
				vm.cartdetails.prices.nightlydiscount[nightIndex] = commonService.roundnum(vm.cartdetails.prices.rates[nightIndex],2);
			}
			if(vm.cartdetails.prices.nightlydiscount[nightIndex]==0){
				vm.cartdetails.prices.nightlydiscountcomment[nightIndex] = '';
			}

			if(vm.cartdetails.prices.nightlydiscount[nightIndex] < 0){
				vm.cartdetails.prices.nightlydiscount[nightIndex] = 0.00;
				// vm.cartdetails.prices.nightlydiscount[$index]
			}
			var returnObj = commonService.sumnightlyDisc(vm.cartdetails);
			vm.cartdetails.product_discount = returnObj.product_discount;
			vm.cartdetails.prices.nightlydiscount = returnObj.nightlydiscount;
			calculateOwnTotals(index);
		}
		function breakIntoNights(index){
			vm.cartdetails = commonService.breakIntoNights(vm.cartdetails);
			calculateOwnTotals(index);
		}
		function addroomincart(ev){
			var productIdsInCart = [];
			var cart_type = 'reservation';
			if(vm.cartdetails.cart_type == 'boat'){
				cart_type = 'boat';
			} else if(vm.cartdetails.cart_type == 'day_reservation'){
				cart_type = 'day_reservation';
			}

			angular.forEach($sessionStorage['cartDetails_' + $localStorage['preHotelId']], function (value, key)
			{
				this.push({product_id:value.product_id,products_to_be_blocked:value.products_to_be_blocked,room_stay_from:value.from,room_stay_to:value.to});
			},productIdsInCart);

			var item = productIdsInCart.length;
			vm.waiveDepositOff[item] = false;
			vm.resortFeeAppliedValue[item] = 'Applied';
			vm.roomSurchargeAppliedValue[item] = 'Applied';
			// vm.payment_method[item] = {};
			var addRoomParams = {negotiatedCust: vm.cust_info != undefined ? vm.cust_info.negotiated_rate_customer : 0};
			if(cart_type == 'day_reservation'){
				addRoomParams.reservation_type = 'day_reservation';
			}
			createResService.addRoom(
				ev,
				vm.from,
				vm.to,
				2,
				0,
				productIdsInCart,
				'add',
				'',
				cart_type,
				'',
				addRoomParams
			);
		}


		function querySearch (query) {
		var deferred = $q.defer();
		createResService.getCustomers({search:query,selectedHotel:$localStorage.hotels[$localStorage.selectedHotel].hotel_id})
		.then(function(response) {
			deferred.resolve(response[0].customerList);
		});
		return deferred.promise;
		}
		function back(){
			if(vm.documents.length > 0) {
				eCommerceService.deleteAllDoc(vm.documents).then(function(response) {
				});
			}
			if(!$localStorage.preUrl || $localStorage.preUrl == ''){
				$window.history.back();
			}else{
				var tempUrl = angular.copy($localStorage.preUrl);
				$localStorage.preUrl = '';
				if(tempUrl == "app.e-commerce.orders.detail")
					$window.history.back();
				else
					$state.go(tempUrl);
			}
		}

		$scope.$on('update_cart_data', function(event,data) {
			var response = data.data;
			if(data.hasOwnProperty('posData') && data.change_index > -1 && data.pos_index > -1){
				var changeIndex = data.change_index;
				var POS =  vm.cartdetails.pos;
				if(typeof POS != 'undefined' || POS){
					$sessionStorage['cartDetails_' + $localStorage['preHotelId']][changeIndex].pos[data.pos_index] = angular.copy(data.posData);
					vm.cartdetails.pos[data.pos_index] = angular.copy(data.posData);		
					calculatePOSTotals(changeIndex,data.pos_index,'call');
				}
			} else if(data.hasOwnProperty('posData') && data.change_index > -1){
				var changeIndex = data.change_index;
				var POS =  vm.cartdetails.pos;
				if(typeof POS == 'undefined'){
					$sessionStorage['cartDetails_' + $localStorage['preHotelId']][changeIndex].pos = [];
					vm.cartdetails.pos = [];
				}
				for (var i=0; i<data.posData.length; i++){
					$sessionStorage['cartDetails_' + $localStorage['preHotelId']][changeIndex].pos.push(data.posData[i]);
					vm.cartdetails.pos.push(data.posData[i]);
				}
				calculateOwnTotals(changeIndex);
			} else if(data.changeIndex > -1){
				var changeIndex = data.changeIndex;
				var POS =  vm.cartdetails.pos;
				var CUST_INFO =  vm.cartdetails.cust_info;
				if(typeof POS != 'undefined' || POS){
					var newPos =  response.cartData[0].pos;
					if(typeof newPos != 'undefined' || newPos){ 
						angular.forEach(POS, function(value, key) {
							if(typeof value.auto_added == 'undefined' || parseInt(value.auto_added) != 1){
								response.cartData[0].pos.push(value);
							}
						});
					} else {
						angular.forEach(POS, function(value, key) {
							if(typeof value.auto_added != 'undefined' && parseInt(value.auto_added) == 1){
								POS.splice(key, 1);
							}
						});
						response.cartData[0].pos = [];
						response.cartData[0].pos = POS;
					}
				}

				var tempCustomerTaxExempt = vm.cartdetails.customerTaxExempt;
				var tempTravellerTaxExempt = vm.cartdetails.travellerTaxExempt;
				var tempAddReservation = vm.cartdetails.addReservation;

				$sessionStorage['cartDetails_' + $localStorage['preHotelId']][changeIndex] = isolateRoomInCart(response.cartData[0]);
				$sessionStorage['autoAddPos_' + $localStorage['preHotelId']][changeIndex] = response.auto_add_pos[0];
				$sessionStorage['isChildAllowed_' + $localStorage['preHotelId']] = response.is_child_allowed;

				$sessionStorage['cartDetails_' + $localStorage['preHotelId']][changeIndex].customerTaxExempt = tempCustomerTaxExempt;
				$sessionStorage['cartDetails_' + $localStorage['preHotelId']][changeIndex].travellerTaxExempt = tempTravellerTaxExempt;
				$sessionStorage['cartDetails_' + $localStorage['preHotelId']][changeIndex].addReservation = tempAddReservation;
				
				vm.tabsData[changeIndex].product_name = response.cartData[0].product_room_number+' ('+moment(response.cartData[0].from).format('M/DD')+"-"+moment(response.cartData[0].to).format('M/DD')+')';
				
				response.cartData[0] = commonService.calculateTotals(response.cartData[0],vm.addRoomInItin, multipleNightPolicies);
				vm.cartdetails = angular.copy(response.cartData[0]);
				
				vm.adultRange = [];
				vm.adultRange = vm.getRangeArray(1,(vm.cartdetails.max_occupancy - vm.cartdetails.room_stay_child_count));

				vm.childRange = [];
				vm.childRange = vm.getRangeArray(0,(vm.cartdetails.max_occupancy - vm.cartdetails.room_stay_guest_count));
				if(typeof CUST_INFO != 'undefined' || CUST_INFO){
					vm.cartdetails.cust_info = CUST_INFO;
					$sessionStorage['cartDetails_' + $localStorage['preHotelId']][changeIndex].cust_info = CUST_INFO;
				}
				$sessionStorage['cartDetails_' + $localStorage['preHotelId']][changeIndex] = isolateRoomInCart(vm.cartdetails);
				calculateOwnTotals(changeIndex);
			} else {
				var totalCartLen = parseInt(Object.keys($sessionStorage['cartDetails_' + $localStorage['preHotelId']]).length + Object.keys(response.cartData).length);
				for(var i = Object.keys($sessionStorage['cartDetails_' + $localStorage['preHotelId']]).length,j=0; i< totalCartLen; i++,j++){
					$sessionStorage['cartDetails_' + $localStorage['preHotelId']][i] = isolateRoomInCart(response.cartData[j]);
					$sessionStorage['cartDetails_' + $localStorage['preHotelId']][i].cust_info = vm.cust_info;
					$sessionStorage['autoAddPos_' + $localStorage['preHotelId']][i] = response.auto_add_pos[j];
					$sessionStorage['isChildAllowed_' + $localStorage['preHotelId']] = response.is_child_allowed;
					vm.tabsData[i] = {};
					// var numb = response.cartData[j].product_name.match(/\d/g);
					// if(numb != null && numb != "undefined")
					// 	numb = numb.join("");
					// else
					// 	numb = response.cartData[j].product_name;
					vm.tabsData[i].product_name = response.cartData[j].product_room_number+' ('+moment(response.cartData[j].from).format('M/DD')+"-"+moment(response.cartData[j].to).format('M/DD')+')';
				}
			}
			initializeDateFormat(vm.cartdetails);
		});

		/* Card Swiper code starts */
        function trimNumber(s) {
            while (s.substr(0, 1) == '0' && s.length > 1) {
                s = s.substr(1, 9999);
            }
            return s;
        }

        function parseSwiperData(value) {
            if (value.charAt(0) !== '%') {
                return -1;
            }
            var p = new SwipeParserObj(value);
            var result = new Array();
            if (p.hasTrack1) {
                if (p.surname != null)
                    result[0] = p.surname + ' ' + p.firstname;
                else
                    result[0] = p.account_name;
                result[1] = p.account;
                result[2] = p.exp_month;
                result[3] = p.exp_year;
            }
            return result;
        }
        window.parseSwiperData = parseSwiperData;

        var method = 'authorizenet';
        vm.swipeText = 'Click here to swipe';
        vm.keyupfunction = keyupfunction;
        vm.paymentMethodSelected = paymentMethodSelected;
        vm.ReadySwipe = ReadySwipe;
        vm.ResetSwipe = ResetSwipe;
        vm.swipeNow = swipeNow;
        vm.paymentFormValidate = paymentFormValidate;

        function swipeNow(index) {
            if (angular.element('#authorizenet-swiper-data_'+index)) {
                angular.element('#authorizenet-swiper-data_'+index).val(' ');
                angular.element('#authorizenet-swiper-data_'+index).select();
            }
        }

        function ReadySwipe() {
            vm.swipeText = 'Ready to swipe';
        }

        function ResetSwipe() {
            vm.swipeText = 'Click here to swipe';
        }

        function paymentFormValidate(paymentForm){

            if (paymentForm.$valid == true && vm.spliting && parseFloat(vm.minimumAmount) > 0) {
                $timeout(function() {
                    $mdDialog.show({
                        clickOutsideToClose: false,
                        parent: angular.element($document.body),
                        scope: $scope,
                        preserveScope: true,
                        locals: {
                            splitCount: vm.splitCount
                        },
                        templateUrl: 'app/main/apps/checkout/dialog/completePayment.html',
                        controller: completePaymentController
                    });

                    function completePaymentController($scope, $mdDialog, splitCount) {
                        $scope.splitCount = splitCount;
                        $scope.closeDialog = function() {
                            $mdDialog.hide();
                        };
                        $scope.completePayment = function() {
                            vm.proceedToCheckout();
                            $mdDialog.hide();
                        };
                    }
                }, 100);
            }
            if(paymentForm.$valid && vm.payment_method[0].method == 'Credit Card' && vm.resDetails.typeofService == 'bar'){

                if (vm.customerDetails == null) {
                    vm.customerDetails = vm.defaultCustomer;
                    vm.customerPreviousName = vm.customerDetails['first_name']+'_&_'+vm.customerDetails['middle_name']+'_&_'+vm.customerDetails['last_name'];
                }
                vm.customerDetails['first_name'] = vm.payment_method[0]['cc_fname'];
                vm.customerDetails['middle_name'] = '';
                vm.customerDetails['last_name'] = '';               
            }
        }

        vm.customerPreviousName = '';

        function paymentMethodSelected(method,index) {
        	if (method == 'Credit Card') {
                $timeout(function() {
                    angular.element('#authorizenet-swiper-status_'+index).trigger('click');
                }, 0);
            }
        }

        vm.updateResortFee = updateResortFee;
        function updateResortFee(index){
        	/*false If applied and vice-versa*/
        	
        	vm.cartdetails['resortFeeApplied'] = vm.resortFeeApplied[index];
        	$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index] = vm.cartdetails;
			normalizeWaiveCcProcessingFeeOnCart(vm.cartdetails);
			$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index] = commonService.calculateTotals(vm.cartdetails,vm.addRoomInItin, multipleNightPolicies);
			var storageData = angular.copy($sessionStorage['cartDetails_' + $localStorage['preHotelId']][index]);
			vm.cartdetails = storageData;
        }

        function keyupfunction(event,index) {
            if (event.keyCode == 13) { // was: event.keyCode == 13
                var ccinfo = parseSwiperData(vm.ccinfo_a);
                var errorFound = false;
                if (ccinfo === -1) {} else {
                    if (ccinfo != null && ccinfo.length > 0) {

                        vm.payment_method[index].cc_fname = '';
                        vm.payment_method[index].cc_lname = '';
                        vm.payment_method[index].cc_number = '';
                        vm.payment_method[index].cc_number_mask = '';
                        vm.payment_method[index].cc_type = '';
                        vm.payment_method[index].cc_exp_month = '';
                        vm.payment_method[index].cc_exp_year = '';

						var owner = ccinfo[0].trim().replace(/\s\s+/g, ' ');
                        var cc_owner = owner.split(" ");
                        if (cc_owner.length > 1) {
                            vm.payment_method[index].cc_fname = cc_owner[0];
                            vm.payment_method[index].cc_lname = cc_owner[cc_owner.length -1];
                        } else {
                            vm.payment_method[index].cc_fname = cc_owner[0];
                        }
                        if (ccinfo[1] == null) {
                            alert('Card number not detected!');
                            errorFound = true;
                        } else {
                            vm.payment_method[index].cc_number = ccinfo[1];
                            vm.payment_method[index].cc_number_mask = ccinfo[1].replace(/.*(\d{4})$/, "xxxxxxxxxxxx$1");
                            var startdigit = parseInt(ccinfo[1].charAt(0));
                            if (startdigit == 3)
                                vm.payment_method[index].cc_type = 'American Express';
                            if (startdigit == 4)
                                vm.payment_method[index].cc_type = 'Visa';
                            if (startdigit == 5)
                                vm.payment_method[index].cc_type = 'MasterCard';
                            if (startdigit == 6)
                                vm.payment_method[index].cc_type = 'Discover';
                            if (jQuery('select#' + method + '_cc_type').val() == "") {
                                alert('Card type not detected!');
                                errorFound = true;
                            }
                        }
                        if (ccinfo[2] == null) {
                            alert('Expiration month not detected!');
                            errorFound = true;
                        } else {
                            vm.payment_method[index].cc_exp_month = trimNumber(ccinfo[2]);
                        }
                        if (ccinfo[3] == null) {
                            alert('Expiration year not detected!');
                            errorFound = true;
                        } else {
                            vm.payment_method[index].cc_exp_year = ccinfo[3];
                            if (jQuery('#' + method + '_expiration_yr').val() == "") {
                                alert("The card might be expired!");
                                errorFound = true;
                            }
                        }
                        $timeout(function() {
                            angular.element('#authorizenet_cc_number_label').trigger('click');
                        }, 0);
                    } else {
                        alert("Cannot read the data!");
                        errorFound = true;
                    }
                    if (!errorFound) {
                        //~ onBlurCheckForm();
                    }
                    vm.ccinfo_a = "";
                    jQuery('#loading-mask').hide();
                }
            }
        }
        jQuery(document).on("click", '.payment-methods input[type=radio]', function() {
            swipeNow(jQuery('.payment-methods input[type=radio]:checked').val());
        });
        swipeNow(jQuery('input[name="payment[method]"]:checked').val());
        /* Card Swiper code ends */

        // vm.checkVessel = checkVessel;
        // function checkVessel(){
        	vm.checkVessel = false;
        	if(vm.cartdetails.cart_type == 'boat' && typeof vm.boat_data == 'undefined'){
        		vm.checkVessel = true;
        	}
        // 	else{
        // 		return false;
        // 	}
        // }

		vm.baseUrl = EnvironmentConfig.api;
        /*
        ** Uses to upload the documents
        */
        vm.addDoc = function(files, errFiles) {        	
	        vm.progressnum = 0;
        	if($sessionStorage['cartDetails_' + $localStorage['preHotelId']][vm.currentIndex].documents == undefined) {
        		$sessionStorage['cartDetails_' + $localStorage['preHotelId']][vm.currentIndex].documents = [];
        	}      	
        	var hotelId = 0;
        	if($localStorage['preHotelId'] != undefined && $localStorage['preHotelId'] != '') {
        		hotelId = $localStorage['preHotelId']        		
        	}

        	if (errFiles.length > 0) {
                angular.forEach(errFiles, function(value, index) {
                    switch (value.$error) {
                        case 'pattern':
                            vm.fileError = 'FILE TYPE NOT SUPPORTED';
                            break;
                        case 'maxSize':
                            vm.fileError = 'FILE SIZE EXCEEDS';
                            break;
                        case 'minWidth':
                            vm.fileError = 'MIN SIZE MESSAGE';
                            break;
                        case 'minHeight':
                            vm.fileError = 'MIN SIZE MESSAGE';
                            break;
                        default:
                            vm.fileError = 'COMMON IMAGE MESSAGE';
                    }
                    toastMessage.showSimpleToast(vm.fileError, 'error-toast');
                });
            }

        	if (files.length > 0) {
				vm.isloading = true;
	        	vm.uploading = true;
	        	/*var newHash = 'documents-tab';
	        	if ($location.hash() !== newHash) {
			        $location.hash(newHash);
			    } else {
			        $anchorScroll();
			    }*/
	        	files.upload = Upload.upload({
	                url: EnvironmentConfig.api + 'reservations/upload_document',
	                data: {
	                    file: files[0],
	                    data: {
	                    	hotel_id : hotelId,
	                    	type : 'add'
	                    }
	                }
	            });

	            files.upload.then(function(response) {
	            	vm.uploading = false;
					vm.isloading = false;
	            	if(response.data.status == 'success') {
	            		var docData = {
	            			'doc_name'  : response.data.data.fileName,
	            			'type' 		: response.data.data.type,
	            			'created_on': response.data.data.created_on,
	            			'thumbnail' : response.data.data.thumbnail
	            		}
	            		console.log("docData : ",docData);        				

        				if(vm.documents[vm.currentIndex] == undefined){
        					vm.documents[vm.currentIndex] = [];
        				}
		            	vm.documents[vm.currentIndex].push(docData);
		            	$sessionStorage['cartDetails_' + $localStorage['preHotelId']][vm.currentIndex].documents = vm.documents[vm.currentIndex];
	            		console.log("vm.documents[vm.currentIndex] after : ",vm.documents[vm.currentIndex]);
	            		vm.showDocs[vm.currentIndex] = (vm.documents[vm.currentIndex].length > 0) ? true : false;
	        			document.getElementById('documents-tab').scrollIntoView();
	            	}
	            });
	        }
    	}

    	/*
    	** Delete attachment documents
    	*/
    	vm.deleteDocument = function(docData, index, evt) {
            var confirm = $mdDialog.confirm()
                .htmlContent('<div class="md-padding custom-common-dailog">Are you sure, you want to delete this attachment?</div>')
                .title('Delete Attachment')
                .targetEvent(evt)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function() {
            	docData.src = 'add';
                eCommerceService.deleteDoc(docData).then(function(response) {
                    if (response.status === 'success') {
                        vm.documents[vm.currentIndex].splice(index,1);
                        $sessionStorage['cartDetails_' + $localStorage['preHotelId']][vm.currentIndex].documents.splice(index,1);
	            		
	            		vm.showDocs[vm.currentIndex] = (vm.documents[vm.currentIndex].length > 0) ? true : false;
	            		if(vm.documents[vm.currentIndex].length == 0) {
	            			vm.documents[vm.currentIndex] = [];
	            		}
                    } else {
                        toastMessage.showSimpleToast($translate.instant(response.message), 'error-toast');
                    }
                });
            }).catch(function(err) {            	
            });
        };

        /*
        ** Open attachments images and pdfs in popup
        */
        vm.documentViewer = function(ev, docName, type) {
            var documentData;
            if(type != undefined && type == 'image'){
				documentData = EnvironmentConfig.api + 'assets/uploads/documents/' + docName;
            } else {
            	if(docName.indexOf('.pdf') > -1) {
            		documentData = {
            			path : EnvironmentConfig.api + 'assets/uploads/documents/' + docName,
            			type : "pdf"
            		}
            	} else {
					documentData = EnvironmentConfig.api + 'assets/uploads/documents/' + docName;
            		window.open(documentData,'_self');
            		return false;
            	}
            }
            $mdDialog.show({
                controller: 'RoomtypeDialogController', 
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/e-commerce/views/roomtype/dialogs/roomtype/roomtype-dialog.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Image: documentData
                }
            });
        }

        /*
        ** Open attachments images and pdfs in popup
        */
 		vm.downloadDocuments = function(doc) {
 			if(doc.doc_name != undefined) {
	 			eCommerceService.downloadDocument(doc.doc_name);
	 		}
 		}

        
        /******************************************************/
        /************* Monthly Weekly function ****************/
        /******************************************************/
        function monthlyWeeklyNight(orderData) {
			if(orderData.hasOwnProperty('prices') && orderData.prices.hasOwnProperty('dates') && Object.keys(orderData.prices.dates).length > 31){
				var monthNames = [ 
					'January', 
					'February', 
					'March', 
					'April', 
					'May', 
					'June',
					'July', 
					'August', 
					'September', 
					'October', 
					'November', 
					'December' 
				];
				vm.dates = {};
				angular.forEach(orderData.prices.dates, function (value, key){
					var monthArr = value.split("/");
					var date = new Date(value);
					var month = monthNames[date.getMonth()];
					var weekofmonth = date.getDay();
					var year = monthArr[2];
					var month_year = month+" "+year;

					if(typeof vm.dates[month_year] == 'undefined'){
						vm.dates[month_year] = {};
					}

					vm.dates[month_year][key] = value;
				});	

				vm.newArray = {};
				angular.forEach(vm.dates, function (monthvalue, monthkey){
					var monthLength = Object.keys(monthvalue).length;
					var first = Object.keys(monthvalue)[0];
					var last = Object.keys(monthvalue)[monthLength-1];
					var wkey = 0;
					for(var i = parseInt(first); i <= parseInt(last); i++){
						if(typeof vm.newArray[monthkey] == 'undefined')
						vm.newArray[monthkey] = {};

						if(typeof vm.newArray[monthkey][wkey] == 'undefined')
						vm.newArray[monthkey][wkey] = {};
					   
						vm.newArray[monthkey][wkey][i] = monthvalue[i];

						if(Object.keys(vm.newArray[monthkey][wkey]).length > 6 && Object.keys(vm.newArray[monthkey][wkey]).length < 31){
							first += 7;
							wkey++;
							continue;
						}					
					}
				});	

				angular.forEach(vm.newArray, function (value, key){
					var yearmonthLength = Object.keys(vm.newArray).length;
					var firstofmonth = Object.keys(vm.newArray)[1];
					var lastofmonth = Object.keys(vm.newArray)[yearmonthLength-2];
					var weekmonthLength = Object.keys(vm.newArray[lastofmonth]).length;
					var firstofweek = Object.keys(vm.newArray[lastofmonth])[0];
					var lastofweek = Object.keys(vm.newArray[lastofmonth])[weekmonthLength-1];

					if(Object.keys(value).length == 1 && Object.keys(vm.newArray[Object.keys(vm.newArray)[0]][0]).length == 1){
						var monthattributes = Object.keys(vm.newArray[key][0]);
						for (var i = 0; i < monthattributes.length; i++) {
						  	vm.newArray[firstofmonth][firstofweek][monthattributes[i]] = vm.newArray[key][0][monthattributes[i]];
						}
						delete vm.newArray[key]; 
					} else if(Object.keys(value).length == 1 && Object.keys(vm.newArray[Object.keys(vm.newArray)[yearmonthLength-1]][0]).length == 1){
						var monthattributes = Object.keys(vm.newArray[key][0]);
						for (var i = 0; i < monthattributes.length; i++) {
						  	vm.newArray[lastofmonth][lastofweek][monthattributes[i]] = vm.newArray[key][0][monthattributes[i]];
						}
						delete vm.newArray[key]; 
					} else {
						angular.forEach(value, function (weekvalue, weekkey){
							if(Object.keys(weekvalue).length == 1 || (Object.keys(weekvalue).length == 1 && Object.keys(vm.newArray[Object.keys(vm.newArray)[yearmonthLength-1]][weekkey]).length == 1)){
								var attributes = Object.keys(vm.newArray[key][weekkey]);
	 							// if(Object.keys(vm.newArray[key][weekkey]).length > 1){
									for (var i = 0; i < attributes.length; i++) {
									  vm.newArray[key][weekkey-1][attributes[i]] = vm.newArray[key][weekkey][attributes[i]]
									}
									delete vm.newArray[key][weekkey]; 
								// }
							}
						});
					}					
				});	

				// Monthly/Weekly overall total and paid amount start
				vm.weekOverallTotal = {};
				vm.weekPaidValues = {};
				vm.weekOwesValues = {};
				vm.monthOverallTotal = {};
				vm.PaidValues = {};
				vm.owesValues = {};
				vm.monthly_paid_amount  = vm.cartdetails.overalltotals.paid_amount;
				vm.total_paid_amount  = vm.cartdetails.overalltotals.paid_amount;

				angular.forEach(vm.newArray, function (monthlyvalue, monthlykey){
					if(typeof vm.monthOverallTotal[monthlykey] == 'undefined')
						vm.monthOverallTotal[monthlykey] = {};
					vm.monthOverallTotal[monthlykey]['discount'] = 0;
					vm.monthOverallTotal[monthlykey]['price'] = 0;
					angular.forEach(monthlyvalue, function (value, key){
						angular.forEach(value, function (weekData, weekSkey){
							vm.monthOverallTotal[monthlykey]['discount'] += parseFloat(vm.cartdetails.prices.nightlydiscount[weekSkey]);
							vm.monthOverallTotal[monthlykey]['price'] += parseFloat(vm.cartdetails.prices.rates[weekSkey]);
						});
					});

					vm.monthOverallTotal[monthlykey]['discount'] = commonService.roundnum(vm.monthOverallTotal[monthlykey]['discount'],2);
					vm.monthOverallTotal[monthlykey]['price'] = commonService.roundnum(vm.monthOverallTotal[monthlykey]['price'],2);

					//Monthly paid amount start
					vm.monthly_paid_amount = 0;

					if(parseFloat(vm.monthOverallTotal[monthlykey]['price']) <= parseFloat(vm.total_paid_amount)){
						vm.total_paid_amount = parseFloat(vm.total_paid_amount) - parseFloat(vm.monthOverallTotal[monthlykey]['price']);
						vm.monthly_paid_amount = vm.monthOverallTotal[monthlykey]['price'];
					} else if (parseFloat(vm.monthOverallTotal[monthlykey]['price']) > parseFloat(vm.total_paid_amount)){
						var temp_paid_amount = angular.copy(vm.total_paid_amount);
						vm.total_paid_amount = 0;
						vm.monthly_paid_amount = commonService.roundnum(temp_paid_amount,2);
					}
					if(typeof vm.PaidValues[monthlykey] == 'undefined')
						vm.PaidValues[monthlykey] = commonService.roundnum(angular.copy(vm.monthly_paid_amount),2);

					if(typeof vm.owesValues[monthlykey] == 'undefined')
						vm.owesValues[monthlykey] = vm.monthOverallTotal[monthlykey]['price'] - vm.PaidValues[monthlykey];

					if(vm.monthOverallTotal[monthlykey]['discount'] != undefined) {
						vm.owesValues[monthlykey] = parseFloat(vm.owesValues[monthlykey]) - parseFloat(vm.monthOverallTotal[monthlykey]['discount']);
					}

					vm.owesValues[monthlykey] = commonService.roundnum(vm.owesValues[monthlykey],2);
					//Monthly paid amount end

					angular.forEach(monthlyvalue, function (weeklyvalue, weeklykey){

						//Week Overall Total start
						var weekkey = monthlykey + weeklykey;
						if(typeof vm.weekOverallTotal[weekkey] == 'undefined')
							vm.weekOverallTotal[weekkey] = {};
						var myKeys = Object.keys(weeklyvalue);
						vm.weekOverallTotal[weekkey]['discount'] = 0;
						vm.weekOverallTotal[weekkey]['price'] = 0;
						angular.forEach(myKeys, function (wkey){
							vm.weekOverallTotal[weekkey]['discount'] += parseFloat(vm.cartdetails.prices.nightlydiscount[wkey]);
							vm.weekOverallTotal[weekkey]['price'] += parseFloat(vm.cartdetails.prices.rates[wkey]);
						});
						
						vm.weekOverallTotal[weekkey]['discount'] = commonService.roundnum(vm.weekOverallTotal[weekkey]['discount'],2);
						vm.weekOverallTotal[weekkey]['price'] = commonService.roundnum(vm.weekOverallTotal[weekkey]['price'],2);
						
						vm.weekly_paid_amount = 0;
						if(parseFloat(vm.weekOverallTotal[weekkey]['price']) <= parseFloat(vm.monthly_paid_amount)){
							vm.monthly_paid_amount = parseFloat(vm.monthly_paid_amount) - parseFloat(vm.weekOverallTotal[weekkey]['price']);
							vm.weekly_paid_amount = vm.weekOverallTotal[weekkey]['price'];
						} else if (parseFloat(vm.weekOverallTotal[weekkey]['price']) > parseFloat(vm.monthly_paid_amount)){
							var temp_paid_amount = angular.copy(vm.monthly_paid_amount);
							vm.monthly_paid_amount = 0;
							vm.weekly_paid_amount = commonService.roundnum(temp_paid_amount,2);
						}
						if(typeof vm.weekPaidValues[weekkey] == 'undefined')
							vm.weekPaidValues[weekkey] = angular.copy(vm.weekly_paid_amount);

						if(typeof vm.weekOwesValues[weekkey] == 'undefined')
							vm.weekOwesValues[weekkey] = vm.weekOverallTotal[weekkey]['price'] - vm.weekPaidValues[weekkey];

						if(vm.weekOverallTotal[weekkey]['discount'] != undefined) {
							vm.weekOwesValues[weekkey] = parseFloat(vm.weekOwesValues[weekkey]) - parseFloat(vm.weekOverallTotal[weekkey]['discount']);
						}

						vm.weekPaidValues[weekkey] = commonService.roundnum(vm.weekPaidValues[weekkey],2);
						vm.weekOwesValues[weekkey] = commonService.roundnum(vm.weekOwesValues[weekkey],2);
					});
				});	
				// Monthly/Weekly overall total and paid amount end
			} else if(Object.keys(orderData.prices.dates).length >= 7 && Object.keys(orderData.prices.dates).length <= 31) {
				vm.newArray = {};
				var monthLength = Object.keys(orderData.prices.dates).length;
				var first = Object.keys(orderData.prices.dates)[0];
				var last = Object.keys(orderData.prices.dates)[monthLength-1];
				var wkey = 0;
				var rem = 0;
				for(var i = first; i <= last; i++){
					if(typeof vm.newArray[wkey] == 'undefined')
					vm.newArray[wkey] = {};
				   
					vm.newArray[wkey][i] = orderData.prices.dates[i];
					if(Object.keys(vm.newArray[wkey]).length > 6 && Object.keys(vm.newArray[wkey]).length < 31){
						first += 7;
						wkey++;
						continue;
					}
				}
				
				angular.forEach(vm.newArray, function (weekvalue, weekkey){
					if(Object.keys(weekvalue).length == 1){
						var attributes = Object.keys(vm.newArray[weekkey]);

						for (var i = 0; i < attributes.length; i++) {
						  vm.newArray[weekkey-1][attributes[i]] = vm.newArray[weekkey][attributes[i]]
						}
						delete vm.newArray[weekkey]; 
					}
					
				});

				vm.weekOverallTotal = {};
				vm.weekPaidValues = {};
				vm.weekOwesValues = {};
				vm.monthly_paid_amount  = vm.cartdetails.overalltotals.paid_amount;
				vm.total_paid_amount  = vm.cartdetails.overalltotals.paid_amount;
				angular.forEach(vm.newArray, function (weeksvalue, weekskey){
					//weekly overall total and paid amount start
					if(typeof vm.weekOverallTotal[weekskey] == 'undefined')
						vm.weekOverallTotal[weekskey] = {};
					var myKeys = Object.keys(weeksvalue);
					vm.weekOverallTotal[weekskey]['discount'] = 0;
					vm.weekOverallTotal[weekskey]['price'] = 0;
					angular.forEach(myKeys, function (key){
						vm.weekOverallTotal[weekskey]['discount'] += parseFloat(vm.cartdetails.prices.nightlydiscount[key]);
						vm.weekOverallTotal[weekskey]['price'] += parseFloat(vm.cartdetails.prices.rates[key]);
					});
					
					vm.weekOverallTotal[weekskey]['discount'] = commonService.roundnum(vm.weekOverallTotal[weekskey]['discount'],2);
					vm.weekOverallTotal[weekskey]['price'] = commonService.roundnum(vm.weekOverallTotal[weekskey]['price'],2);
					

					vm.weekly_paid_amount = 0;
					
					if(parseFloat(vm.weekOverallTotal[weekskey]['price']) <= parseFloat(vm.monthly_paid_amount)){
						vm.monthly_paid_amount = parseFloat(vm.monthly_paid_amount) - parseFloat(vm.weekOverallTotal[weekskey]['price']);
						vm.weekly_paid_amount = vm.weekOverallTotal[weekskey]['price'];
					} else if (parseFloat(vm.weekOverallTotal[weekskey]['price']) > parseFloat(vm.monthly_paid_amount)){
						var temp_paid_amount = angular.copy(vm.monthly_paid_amount);
						vm.monthly_paid_amount = 0;
						vm.weekly_paid_amount = commonService.roundnum(temp_paid_amount,2);
					}
					if(typeof vm.weekPaidValues[weekskey] == 'undefined')
						vm.weekPaidValues[weekskey] = angular.copy(vm.weekly_paid_amount);

					if(typeof vm.weekOwesValues[weekskey] == 'undefined')
						vm.weekOwesValues[weekskey] = vm.weekOverallTotal[weekskey]['price'] - vm.weekPaidValues[weekskey];

					if(vm.weekOverallTotal[weekskey]['discount'] != undefined) {
						vm.weekOwesValues[weekskey] = parseFloat(vm.weekOwesValues[weekskey]) - parseFloat(vm.weekOverallTotal[weekskey]['discount']);
					}

					vm.weekPaidValues[weekskey] = commonService.roundnum(vm.weekPaidValues[weekskey],2);
					vm.weekOwesValues[weekskey] = commonService.roundnum(vm.weekOwesValues[weekskey],2);
					//weekly overall total and paid amount end
				});
			}
			return vm.newArray;
		}

        /******************************************************/
        /*********** Monthly Weekly POS function **************/
        /******************************************************/
        function monthlyWeeklyNightPos(orderData, postKeyIndexId){
			if(orderData.product_is_timebound == 1) {
				if(
					orderData.hasOwnProperty('prices') && 
					orderData.prices.hasOwnProperty('dates') && 
					Object.keys(orderData.prices.dates).length > 31
				)	{
						var monthNames = [ 
							'January', 
							'February', 
							'March', 
							'April', 
							'May', 
							'June',
							'July', 
							'August', 
							'September', 
							'October', 
							'November', 
							'December' 
						];

						/*******************************************/
						/*********** Get month wise dates **********/
						/*******************************************/
						vm.posdates = {};
						angular.forEach(orderData.prices.dates, function (value, key){
							var monthArr = value.split("/");
							var date = new Date(value);
							var month = monthNames[date.getMonth()];
							var weekofmonth = date.getDay();
							var year = monthArr[2];
							var month_year = month+" "+year;

							if(typeof vm.posdates[month_year] == 'undefined'){
								vm.posdates[month_year] = {};
							}

							vm.posdates[month_year][key] = value;
						});

						/*******************************************/
						/******** Get month/week wise dates ********/
						/*******************************************/
						vm.newArray = {};
						angular.forEach(vm.posdates, function (monthvalue, monthkey){
							var monthLength = Object.keys(monthvalue).length;
							var first = Object.keys(monthvalue)[0];
							var last = Object.keys(monthvalue)[monthLength-1];
							var wkey = 0;
							for(var i = parseInt(first); i <= parseInt(last); i++){
								if(typeof vm.newArray[monthkey] == 'undefined')
								vm.newArray[monthkey] = {};

								if(typeof vm.newArray[monthkey][wkey] == 'undefined')
								vm.newArray[monthkey][wkey] = {};
							   
								vm.newArray[monthkey][wkey][i] = monthvalue[i];

								if(Object.keys(vm.newArray[monthkey][wkey]).length > 6 && Object.keys(vm.newArray[monthkey][wkey]).length < 31){
									first += 7;
									wkey++;
									continue;
								}					
							}
						});

						/*******************************************/
						/******** Get month/week wise dates ********/
						/*******************************************/
						angular.forEach(vm.newArray, function (value, key){
							var yearmonthLength = Object.keys(vm.newArray).length;
							var firstofmonth = Object.keys(vm.newArray)[1];
							var lastofmonth = Object.keys(vm.newArray)[yearmonthLength-2];
							var weekmonthLength = Object.keys(vm.newArray[lastofmonth]).length;
							var firstofweek = Object.keys(vm.newArray[lastofmonth])[0];
							var lastofweek = Object.keys(vm.newArray[lastofmonth])[weekmonthLength-1];

							if(Object.keys(value).length == 1 && Object.keys(vm.newArray[Object.keys(vm.newArray)[0]][0]).length == 1){
								var monthattributes = Object.keys(vm.newArray[key][0]);
								for (var i = 0; i < monthattributes.length; i++) {
								  	vm.newArray[firstofmonth][firstofweek][monthattributes[i]] = vm.newArray[key][0][monthattributes[i]];
								}
								delete vm.newArray[key]; 
							} else if(Object.keys(value).length == 1 && Object.keys(vm.newArray[Object.keys(vm.newArray)[yearmonthLength-1]][0]).length == 1){
								var monthattributes = Object.keys(vm.newArray[key][0]);
								for (var i = 0; i < monthattributes.length; i++) {
								  	vm.newArray[lastofmonth][lastofweek][monthattributes[i]] = vm.newArray[key][0][monthattributes[i]];
								}
								delete vm.newArray[key]; 
							} else {
								angular.forEach(value, function (weekvalue, weekkey){
									if(Object.keys(weekvalue).length == 1 || (Object.keys(weekvalue).length == 1 && Object.keys(vm.newArray[Object.keys(vm.newArray)[yearmonthLength-1]][weekkey]).length == 1)){
										var attributes = Object.keys(vm.newArray[key][weekkey]);
			 							// if(Object.keys(vm.newArray[key][weekkey]).length > 1){
											for (var i = 0; i < attributes.length; i++) {
											  vm.newArray[key][weekkey-1][attributes[i]] = vm.newArray[key][weekkey][attributes[i]]
											}
											delete vm.newArray[key][weekkey]; 
										// }
									}
								});
							}					
						});	

						/*******************************************/
						/******** initialize logical part **********/
						/*******************************************/
						vm.posweekOverallTotal = {};
						vm.posweekPaidValues = {};
						vm.posweekOwesValues = {};
						vm.posmonthOverallTotal = {};
						vm.posPaidValues = {};
						vm.posowesValues = {};
						vm.pos_monthly_paid_amount  = vm.monthly_paid_amount;
						// vm.pos_monthly_paid_amount  = vm.monthly_paid_amount;
						vm.pos_total_paid_amount  = vm.monthly_paid_amount;
						var monthlyAmount = 0;

						angular.forEach(vm.newArray, function (monthlyvalue, monthlykey){
							if(typeof vm.posmonthOverallTotal[monthlykey] == 'undefined'){
								vm.posmonthOverallTotal[monthlykey] = {};
							}
							vm.posmonthOverallTotal[monthlykey]['discount'] = 0;
							vm.posmonthOverallTotal[monthlykey]['price'] = 0;
							vm.posmonthOverallTotal[monthlykey]['paid'] = 0;
							vm.posmonthOverallTotal[monthlykey]['owes'] = 0;
							angular.forEach(monthlyvalue, function (value, key){
								angular.forEach(value, function (weekData, weekSkey){
									vm.posmonthOverallTotal[monthlykey]['discount'] += parseFloat(orderData.prices.nightlydiscount[weekSkey]);
									vm.posmonthOverallTotal[monthlykey]['price'] += parseFloat(orderData.prices.rates[weekSkey]);
								});
							});

							vm.posmonthOverallTotal[monthlykey]['discount'] = commonService.roundnum(vm.posmonthOverallTotal[monthlykey]['discount'],2);
							vm.posmonthOverallTotal[monthlykey]['price'] = commonService.roundnum(vm.posmonthOverallTotal[monthlykey]['price'],2);

							// vm.pos_monthly_paid_amount = 0;
							if(parseFloat(vm.posmonthOverallTotal[monthlykey]['price']) <= parseFloat(vm.pos_total_paid_amount)) {
								vm.pos_total_paid_amount = parseFloat(vm.pos_total_paid_amount) - parseFloat(vm.posmonthOverallTotal[monthlykey]['price']);
								monthlyAmount = vm.posmonthOverallTotal[monthlykey]['price'];
							} else if (parseFloat(vm.posmonthOverallTotal[monthlykey]['price']) > parseFloat(vm.pos_total_paid_amount)){
								var temp_paid_amount = angular.copy(vm.pos_total_paid_amount);
								vm.pos_total_paid_amount = 0;
								monthlyAmount = commonService.roundnum(temp_paid_amount,2);
							}

							if(typeof vm.posPaidValues[monthlykey] == 'undefined')
								vm.posPaidValues[monthlykey] = angular.copy(commonService.roundnum(monthlyAmount,2));

							if(typeof vm.posowesValues[monthlykey] == 'undefined')
								vm.posowesValues[monthlykey] = vm.posmonthOverallTotal[monthlykey]['price'] - vm.posPaidValues[monthlykey];

							if(vm.posmonthOverallTotal[monthlykey]['discount'] != undefined) {
								vm.posowesValues[monthlykey] = parseFloat(vm.posowesValues[monthlykey]) - parseFloat(vm.posmonthOverallTotal[monthlykey]['discount']);
							}

							vm.posowesValues[monthlykey] = commonService.roundnum(vm.posowesValues[monthlykey],2);
							vm.posmonthOverallTotal[monthlykey]['paid'] = vm.posPaidValues[monthlykey];
							vm.posmonthOverallTotal[monthlykey]['owes'] = vm.posowesValues[monthlykey];

							// Weekly record get
							angular.forEach(monthlyvalue, function (weeklyvalue, weeklykey){
								var weekkey = monthlykey + weeklykey;
								if(typeof vm.posweekOverallTotal[weekkey] == 'undefined'){
									vm.posweekOverallTotal[weekkey] = {};
								}
								var myKeys = Object.keys(weeklyvalue);
								vm.posweekOverallTotal[weekkey]['discount'] = 0;
								vm.posweekOverallTotal[weekkey]['price'] = 0;
								angular.forEach(myKeys, function (wkey){
									vm.posweekOverallTotal[weekkey]['discount'] += parseFloat(orderData.prices.nightlydiscount[wkey]);
									vm.posweekOverallTotal[weekkey]['price'] += parseFloat(orderData.prices.rates[wkey]);
								});
								
								vm.posweekOverallTotal[weekkey]['discount'] = commonService.roundnum(vm.posweekOverallTotal[weekkey]['discount'],2);

								vm.posweekOverallTotal[weekkey]['price'] = commonService.roundnum(vm.posweekOverallTotal[weekkey]['price'],2);

								vm.pos_weekly_paid_amount = 0;

								if(parseFloat(vm.posweekOverallTotal[weekkey]['price']) <= parseFloat(vm.pos_monthly_paid_amount)){
									vm.pos_monthly_paid_amount = parseFloat(vm.pos_monthly_paid_amount) - parseFloat(vm.posweekOverallTotal[weekkey]['price']);
									vm.pos_weekly_paid_amount = vm.posweekOverallTotal[weekkey]['price'];
								} else if (parseFloat(vm.posweekOverallTotal[weekkey]['price']) > parseFloat(vm.pos_monthly_paid_amount)){
									var temp_paid_amount = angular.copy(vm.pos_monthly_paid_amount);
									vm.pos_monthly_paid_amount = 0;
									vm.pos_weekly_paid_amount = commonService.roundnum(temp_paid_amount,2);
								}
								if(typeof vm.posweekPaidValues[weekkey] == 'undefined')
									vm.posweekPaidValues[weekkey] = angular.copy(vm.pos_weekly_paid_amount);


								if(typeof vm.posweekOwesValues[weekkey] == 'undefined')
									vm.posweekOwesValues[weekkey] = vm.posweekOverallTotal[weekkey]['price'] - vm.posweekPaidValues[weekkey];

								if(vm.posweekOverallTotal[weekkey]['discount'] != undefined) {
									vm.posweekOwesValues[weekkey] = parseFloat(vm.posweekOwesValues[weekkey]) - parseFloat(vm.posweekOverallTotal[weekkey]['discount']);
								}

								vm.posweekPaidValues[weekkey] = commonService.roundnum(vm.posweekPaidValues[weekkey],2);
								vm.posweekOwesValues[weekkey] = commonService.roundnum(vm.posweekOwesValues[weekkey],2);
							});
						});
						vm.posweekOverallTotalArray[postKeyIndexId] = vm.posweekOverallTotal;
						vm.posweekPaidValuesArray[postKeyIndexId] = vm.posweekPaidValues;
						vm.posweekOwesValuesArray[postKeyIndexId] = vm.posweekOwesValues;
						vm.posmonthOverallTotalArray[postKeyIndexId] = vm.posmonthOverallTotal;
				} else if(Object.keys(orderData.prices.dates).length >= 7 && Object.keys(orderData.prices.dates).length <= 31) {
					vm.newArray = {};
					var monthLength = Object.keys(orderData.prices.dates).length;
					var first = Object.keys(orderData.prices.dates)[0];
					var last = Object.keys(orderData.prices.dates)[monthLength-1];
					var wkey = 0;
					var rem = 0;
					for(var i = first; i <= last; i++){
						if(typeof vm.newArray[wkey] == 'undefined')
						vm.newArray[wkey] = {};
					   
						vm.newArray[wkey][i] = orderData.prices.dates[i];
						if(Object.keys(vm.newArray[wkey]).length > 6 && Object.keys(vm.newArray[wkey]).length < 31){
							first += 7;
							wkey++;
							continue;
						}
					}
					angular.forEach(vm.newArray, function (weekvalue, weekkey){
						if(Object.keys(weekvalue).length == 1){
							var attributes = Object.keys(vm.newArray[weekkey]);

							for (var i = 0; i < attributes.length; i++) {
							  vm.newArray[weekkey-1][attributes[i]] = vm.newArray[weekkey][attributes[i]]
							}
							delete vm.newArray[weekkey]; 
						}
					});

					vm.posweekOverallTotal = {};
					vm.posweekPaidValues = {};
					vm.posweekOwesValues = {};
					vm.pos_monthly_paid_amount  = vm.monthly_paid_amount;
					vm.pos_total_paid_amount  = vm.monthly_paid_amount;
					var monthlyAmount = 0;

					angular.forEach(vm.newArray, function (weeksvalue, weekskey){
						//weekly overall total and paid amount start
						if(typeof vm.posweekOverallTotal[weekskey] == 'undefined'){
							vm.posweekOverallTotal[weekskey] = {};
						}
						var myKeys = Object.keys(weeksvalue);
						vm.posweekOverallTotal[weekskey]['discount'] = 0;
						vm.posweekOverallTotal[weekskey]['price'] = 0;
						angular.forEach(myKeys, function (key){
							vm.posweekOverallTotal[weekskey]['discount'] += parseFloat(orderData.prices.nightlydiscount[key]);
							vm.posweekOverallTotal[weekskey]['price'] += parseFloat(orderData.prices.rates[key]);
						});
						
						vm.posweekOverallTotal[weekskey]['discount'] = commonService.roundnum(vm.posweekOverallTotal[weekskey]['discount'],2);
						vm.posweekOverallTotal[weekskey]['price'] = commonService.roundnum(vm.posweekOverallTotal[weekskey]['price'],2);
						

						vm.weekly_paid_amount = 0;
						
						if(parseFloat(vm.posweekOverallTotal[weekskey]['price']) <= parseFloat(vm.pos_monthly_paid_amount)){
							vm.pos_monthly_paid_amount = parseFloat(vm.pos_monthly_paid_amount) - parseFloat(vm.posweekOverallTotal[weekskey]['price']);
							vm.weekly_paid_amount = vm.posweekOverallTotal[weekskey]['price'];
						} else if (parseFloat(vm.posweekOverallTotal[weekskey]['price']) > parseFloat(vm.pos_monthly_paid_amount)){
							var temp_paid_amount = angular.copy(vm.pos_monthly_paid_amount);
							vm.pos_monthly_paid_amount = 0;
							vm.weekly_paid_amount = commonService.roundnum(temp_paid_amount,2);
						}
						if(typeof vm.posweekPaidValues[weekskey] == 'undefined')
							vm.posweekPaidValues[weekskey] = angular.copy(vm.weekly_paid_amount);

						if(typeof vm.posweekOwesValues[weekskey] == 'undefined')
							vm.posweekOwesValues[weekskey] = vm.posweekOverallTotal[weekskey]['price'] - vm.posweekPaidValues[weekskey];

						if(vm.posweekOverallTotal[weekskey]['discount'] != undefined) {
							vm.posweekOwesValues[weekskey] = parseFloat(vm.posweekOwesValues[weekskey]) - parseFloat(vm.posweekOverallTotal[weekskey]['discount']);
						}

						vm.posweekPaidValues[weekskey] = commonService.roundnum(vm.posweekPaidValues[weekskey],2);
						vm.posweekOwesValues[weekskey] = commonService.roundnum(vm.posweekOwesValues[weekskey],2);
						//weekly overall total and paid amount end
					});
					vm.posweekOverallTotalArray[postKeyIndexId] = vm.posweekOverallTotal;
					vm.posweekPaidValuesArray[postKeyIndexId] = vm.posweekPaidValues;
					vm.posweekOwesValuesArray[postKeyIndexId] = vm.posweekOwesValues;
				}
				vm.monthly_paid_amount = vm.pos_monthly_paid_amount;
				// vm.total_paid_amount = vm.pos_total_paid_amount;
				return vm.newArray;
			} else {
				vm.newArray = [];
				return vm.newArray;
			}
		}

		/***********************************************/
		/*********** get Week name header **************/
		/***********************************************/
		vm.getWeekHeaderName = function(items,weekName){			
			var l = Object.keys(items).length;
			var first = items[Object.keys(items)[0]];
			var last = items[Object.keys(items)[l-1]];
			var html="<span>"+first+"<span class='to' >  To  </span>"+last+"</span>";
			return html;
		}

		/***********************************************/
		/************** Toggle accordian ***************/
		/***********************************************/
		vm.toggle = toggle;
		function toggle(key,type, flag, posIndex) {
			var id = '';
        	if(type == 'month'){
        		if(flag === 'boat') {
        			id = 'months'+key;
        		} else {
        			id = 'posmonths'+key+posIndex; 
        		}
        		angular.element(document.getElementsByClassName(id)).siblings().slideToggle();
	        	angular.element(document.getElementsByClassName(id)).addClass("accordian-title-minus");
        	} else {
        		if(flag === 'boat') {
        			id = 'weeks'+key+posIndex;
        		} else {
        			id = 'posweeks'+key+posIndex;
        		}
        		angular.element(document.getElementsByClassName(id)).siblings().slideToggle(1000);
	        	angular.element(document.getElementsByClassName(id)).addClass("accordian-title-minus");
	        	angular.element(document.getElementsByClassName(id)).toggleClass("open");
        	}
        }

        /************************************************/
        /************ Start date modified ***************/
        /************************************************/
        function startDateModified(room_stay_from, room_stay_to, posIdx){
			var startDate = moment(room_stay_from).format("MM/DD/YYYY");
			var oldStartDate = startDate;
			var endDate = moment(room_stay_to).format("MM/DD/YYYY");
			/********************************/
			var compareStartDate = new Date(moment(startDate).format());
			var compareEndDate = new Date(moment(endDate).format());
			/********************************/
			startDate = moment.utc(startDate);
			endDate = moment.utc(endDate);
			if(compareEndDate <= compareStartDate){
				var endNewDate = moment(oldStartDate).add(2, 'days');
				vm.cartdetails.pos[posIdx].to = moment(endNewDate).format ('MM/DD/YYYY');
			}
			vm.cartdetails.pos[posIdx].from = moment(oldStartDate).format('MM/DD/YYYY');
			updateBoatPOS(posIdx);
		}

		/************************************************/
        /************** End date modified ***************/
        /************************************************/
		function endDateModified(room_stay_to,posIdx) {
			var endDate = moment(room_stay_to).format("MM/DD/YYYY");
			var startDate = new Date(moment(vm.cartdetails.pos[posIdx].from).format());
			endDate = moment(endDate);
			startDate = moment(startDate);
			vm.cartdetails.pos[posIdx].to = moment(room_stay_to).format('MM/DD/YYYY');
			if(endDate.isBefore(startDate)){
				toastMessage.showSimpleToast('Checkout date cannot be less than checkin date.','error-toast');
				var oldDate = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][vm.currentIndex].pos[posIdx].to;
				oldDate = moment(oldDate).format('MM/DD/YYYY');
				vm.cartdetails.pos[posIdx].to = oldDate;
				event.preventDefault();
			} else if(endDate.isSame(startDate)) {
				toastMessage.showSimpleToast('Dates cannot be same.','error-toast');
				var oldDate = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][vm.currentIndex].pos[posIdx].to;
				oldDate = moment(oldDate).format('MM/DD/YYYY');
				vm.cartdetails.pos[posIdx].to = oldDate;
				event.preventDefault();
			} else {
				updateBoatPOS(posIdx);
			}
		}

		/************************************************/
        /************** Both date modified ***************/
        /************************************************/
		function dateModifiedBoth(fromDate, toDate ,posIdx) {
			var startDate = new Date(moment(fromDate).format());
			var endDate = new Date(moment(toDate).format());
			if(startDate >= endDate) {
				toastMessage.showSimpleToast('Checkin date cannot be greater than or equal to checkout date.','error-toast');
				var oldDate = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][vm.currentIndex].pos[posIdx].to;
				oldDate = moment(oldDate).format('MM/DD/YYYY');
				vm.cartdetails.pos[posIdx].to = oldDate;
			} else if(endDate <= startDate) {
				toastMessage.showSimpleToast('Checkout date cannot be less than or equal to checkin date.','error-toast');
				var oldDate = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][vm.currentIndex].pos[posIdx].to;
				oldDate = moment(oldDate).format('MM/DD/YYYY');
				vm.cartdetails.pos[posIdx].to = oldDate;
			} else {
				vm.cartdetails.pos[posIdx].from = fromDate;
				vm.cartdetails.pos[posIdx].to = toDate;
				updateBoatPOS(posIdx);
			}
		}

		initializeDateFormat();

	    $rootScope.$on('boatUpdate', function(events, args){
	        vm.cartdetails = {};
	        vm.cartdetails = args.cartData[vm.currentIndex];
			initializeDateFormat();
	    });


	    // update pos product dates
	    function updateBoatPOS(posIdx) {
	    	var data = {
	    		posId: vm.cartdetails.pos[posIdx].product_id,
	    		from: vm.cartdetails.pos[posIdx].from,
	    		to: vm.cartdetails.pos[posIdx].to,
	    		type_id: vm.cartdetails.room_type_id
	    	};
	    	createResService.updateBoatPOS(data).then(function(response){
				if(response.status === 'success'){
					vm.cartdetails.pos[posIdx].prices = [];
					vm.cartdetails.pos[posIdx].subtotal = '';
					vm.cartdetails.pos[posIdx].nightlySum = 0.00;
					vm.cartdetails.pos[posIdx].prices = response.data.prices;
					vm.cartdetails.pos[posIdx].subtotal = response.data.subtotal;
					vm.cartdetails.pos[posIdx].nightlySum = response.data.nightlySum;
					vm.cartdetails.pos[posIdx].grand_total = response.data.grand_total;
					vm.cartdetails.pos[posIdx].product_price = response.data.product_price;
					vm.cartdetails.pos[posIdx].customPrice = response.data.customPrice;
					if(response.data.tax) {
						vm.cartdetails.pos[posIdx].tax = response.data.tax;
						vm.cartdetails.pos[posIdx].total = parseFloat(response.data.product_price) + parseFloat(response.data.tax);	
					}
					if(roomData.cartData.length > 0) {
						roomData.cartData[vm.currentIndex].pos[posIdx] = vm.cartdetails.pos[posIdx];
						$sessionStorage['cartDetails_' + $localStorage['preHotelId']] = roomData.cartData;
					} else {
						$sessionStorage['cartDetails_' + $localStorage['preHotelId']][vm.currentIndex].pos[posIdx] = vm.cartdetails.pos[posIdx];
					}
					angular.forEach(vm.cartdetails.pos, function(value, key) {
						vm.posArrayFinal[key] = [];
						vm.posArrayFinal[key].push(monthlyWeeklyNightPos(value, key));
					});
					vm.cartdetails = commonService.calculateTotals(vm.cartdetails,vm.addRoomInItin, multipleNightPolicies);
				}
			});
	    }

	    // initialize boat / Pos array
	    function initializeDateFormat() {
	    	vm.boatArrayFinal = monthlyWeeklyNight(vm.cartdetails);
	    	if(vm.cartdetails.pos && vm.cartdetails.pos.length > 0) {
		        angular.forEach(vm.cartdetails.pos, function(value, key) {
		        	vm.cartdetails.pos[key].room_stay_from = moment(value.from).format('MM/DD/YYYY');
		        	vm.cartdetails.pos[key].room_stay_to = moment(value.to).format('MM/DD/YYYY');
		        	vm.cartdetails.pos[key].from = moment(value.from).format('MM/DD/YYYY');
		        	vm.cartdetails.pos[key].to = moment(value.to).format('MM/DD/YYYY');
					vm.posArrayFinal[key] = [];
					vm.posArrayFinal[key].push(monthlyWeeklyNightPos(value, key));
				});
	    	}
	    }

	    /*
	    ** Edit dates for pos products in an reservation
	    */
	    function editPosDates(room_stay_from,room_stay_to,poskey) {
        	var localData = {
				checkin:room_stay_from,
				checkout:room_stay_to,
				poskey: poskey
			};
			$mdDialog.show({
				controller    : 'editPosDatesController',
				controllerAs  : 'vm',
				templateUrl   : 'app/main/apps/e-commerce/views/orders/dialogs/edit-pos-dates/edit-pos-dates.html',
				parent: angular.element(document.body),
				targetEvent        	: event,
				clickOutsideToClose	: true,
				locals             	: {
					localData		: localData
				}
			}).then(function(response) {
				if(response.checkin === undefined && response.checkout === undefined) {
					console.log("nothing change");
				} else if((room_stay_from != response.checkin) && (room_stay_to != response.checkout)) {
					vm.dateModifiedBoth(response.checkin, response.checkout, response.posIdx);
				} else if(room_stay_from != response.checkin) {
					vm.startDateModified(response.checkin, response.checkout, response.posIdx);
				} else if(room_stay_to != response.checkout) {
					vm.endDateModified(response.checkout,response.posIdx);
				}
			}, function(error) {
				console.log("Error while update dates");
			});
        }

	    /*
	    ** On toggle of resort fee apply switch
	    */
	    vm.toggleResortFee = function(index, from, taxStatus){
        	/*false If applied and vice-versa*/
        	if(from != undefined && taxStatus != undefined) {
        		vm.resortFeeApplied[index] = !taxStatus;
        	}
        	
        	var resortVal = vm.resortFeeAppliedValue[index];
        	resortVal = resortVal == 'Applied' ? true : false;
        	vm.resortFeeApplied[index] = resortVal;
        	vm.cartdetails['resortFeeApplied'] = vm.resortFeeApplied[index];        	
        	var promise = commonService.recalculateResortFeePos(vm.cartdetails);
        	promise.then(
		        function(response) { 
        			vm.cartdetails = response;
	        		$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index] = vm.cartdetails;
					normalizeWaiveCcProcessingFeeOnCart(vm.cartdetails);
					vm.cartdetails = commonService.calculateTotals(vm.cartdetails,vm.addRoomInItin, multipleNightPolicies);
					$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index] = vm.cartdetails
					$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index]['resortFeeAppliedRemoved'] = vm.resortFeeAppliedValue[index];
					vm.toggleWaiveDeposit(index);
					applyCcProcessingFeePaymentFlags();
		        },
		        function(errorPayload) {
		            console.error('failure : ', errorPayload);
		        }
		    );
        }
        

        /**
        * Toggle waive deposit option
        */
        vm.toggleWaiveDeposit = function(index, parm) {
        	if (parm != undefined && parm == 'trigered') {
        		$sessionStorage['cartDetails_' + $localStorage['preHotelId']][index]['waiveDepositAppliedRemoved'] = vm.waiveDepositOff[index];
        	}

			if (vm.waiveDepositOff[index]) {
        		vm.cartdetails.overalltotals.deposit_amount = 0.00;
        		vm.checkDepositAmt(index);
        		if (vm.payment_method == undefined || vm.payment_method == null) {
        			vm.payment_method = [];
					vm.payment_method[0] = {};
        		}
        		
        		/*if (vm.payment_method[index].method != undefined && vm.payment_method[index].method != '') {

        		} else {*/
        			vm.payment_method[index] = {};        			
        			vm.payment_method[index].method = 'Cash';
        		// }
        	} else {
        		if (parm != undefined && parm == 'trigered') {
	        		vm.setDepositOrig(index);
	        		if (vm.payment_method[index] != undefined && vm.payment_method[index].method != undefined && vm.payment_method[index].method == 'Cash') {
	        			vm.payment_method[index] = {};
	        			vm.payment_method[index].method = '';
	        		}
	        	}
        	}       	
        };

        if ($sessionStorage['cartDetails_' + $localStorage['preHotelId']][0].resortFeeAppliedRemoved != undefined && $sessionStorage['cartDetails_' + $localStorage['preHotelId']][0].resortFeeAppliedRemoved != '') {
        	vm.resortFeeAppliedValue[0] = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][0].resortFeeAppliedRemoved;
        }

        if ($sessionStorage['cartDetails_' + $localStorage['preHotelId']][0].waiveDepositAppliedRemoved != undefined && $sessionStorage['cartDetails_' + $localStorage['preHotelId']][0].waiveDepositAppliedRemoved != '') {
        	vm.waiveDepositOff[0] = $sessionStorage['cartDetails_' + $localStorage['preHotelId']][0].waiveDepositAppliedRemoved;
        	vm.toggleWaiveDeposit(0);
        }

        setTimeout(function() {
		   vm.autoFillOff = false;
		}, 1500); 

		vm.showSurchargeDescTooltip = false;
       	vm.showSurchargeTooltip = function(value) {
       		vm.showSurchargeDescTooltip = value;
       	}

       	/**
       	* @param: String type
       	* @param: Integer roomIndex
       	* Comment: Check if promo code is valid or not and apply or remove depending on type
       	*/
       	vm.promoRequestGoing = false;
        function applyRemoveValidPromoCode(type, roomIndex) {
       		if (type == 'remove') {
       			var html = 'Are you sure you want to remove the promo code?';
				$mdDialog.show({
	              	controller: 'confirmController',
	              	controllerAs: 'vm',
	              	templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
	              	parent: angular.element(document.body),
	              	targetEvent: event,
	              	clickOutsideToClose:true ,
	              	locals: {
	                    title: 'Promo Code',
	                    htmlContent: html,
	                    cancelBtn:'No',
	                    OkBtn:'Yes'
	                }                
	            })
	            .then(function(answer) {
	            	if(typeof answer != 'undefined' && answer == 'update'){
	                	processPromoCode(type, roomIndex);
	               	}
	            }, function() {});
       		} else {
	       		vm.promoRequestGoing = true;
	       		processPromoCode(type, roomIndex);
       		}       		
       	}

       	/**
       	* @param: String type
       	* @param: Integer roomIndex
       	* Comment: Check if promo code is valid or not and apply or remove depending on type
       	*/
       	function processPromoCode(type, roomIndex) {
       		var cartBeforePromo = vm.cartdetails;
       		vm.isloading = true;
       		eCommerceService.validatePromoCode({
       			promoCode: vm.cartdetails.promoCodeName,
       			promo: type,
       			resvProcess: 'create',
       			cartDetail: vm.cartdetails
       		}).then(function(response){
       			vm.promoRequestGoing = false;
       			vm.isloading = false;
       			if (response != undefined && !response.status && (response.errorMsg != '' || response.warningMsg != '')) {
					if(response.errorMsg != ''){
						toastMessage.showSimpleToast(response.errorMsg || response.warningMsg,'warning-toast');
					}
					if(response.warningMsg != ''){
						toastMessage.showSimpleToast(response.warningMsg || response.warningMsg,'warning-toast');
					}
       				vm.cartdetails.promotion_code = '';
       			} else if (response.order != undefined && Object.keys(response.order).length > 0) {
       				vm.cartdetails = response.order;
       				normalizeWaiveCcProcessingFeeOnCart(vm.cartdetails);
       				mergeCcProcessingFeeWaivesFromPrevious(vm.cartdetails, cartBeforePromo);
       				vm.cartdetails = commonService.calculateTotals(vm.cartdetails, vm.addRoomInItin, multipleNightPolicies);
       				$sessionStorage['cartDetails_' + $localStorage['preHotelId']][roomIndex] = vm.cartdetails;
       				if (parseInt(roomIndex, 10) === parseInt(vm.currentIndex, 10)) {
       					initializeDateFormat();
       					vm.toggleWaiveDeposit(roomIndex);
       				}
       				applyCcProcessingFeePaymentFlags();
					vm.skipPromoRevalidateAfterTotals = true;
					calculateOwnTotals(roomIndex);
       			}
       		});
       	}

		vm.clearZeroDepositAmount = function() {
			var val = vm.cartdetails.overalltotals.deposit_amount;
			if (val == 0 || val === '0') {
					vm.cartdetails.overalltotals.deposit_amount = '';
			}
		};

		vm.clearZeroOnType = function (event) {
			var val = vm.cartdetails.overalltotals.deposit_amount;
			if (val === 0 || val === '0') {
				vm.cartdetails.overalltotals.deposit_amount = '';
			}
		};

		vm.restoreZeroDepositAmount = function() {
			var val = vm.cartdetails.overalltotals.deposit_amount;
			if (val === '' || val == null) {
					vm.cartdetails.overalltotals.deposit_amount = 0;
			}
		};
	}
})();
(function ()
{
	'use strict';

	angular
	.module('app.contacts')
	.controller('hotelCreditController', hotelCreditController);

	/** @ngInject */
	function hotelCreditController($mdDialog, mlsData, userService, $scope){
		var vm = this;
		// function declaration
		vm.closeDialog = closeDialog;
		vm.calculateExceedingAmount = calculateExceedingAmount;
		vm.updateBalance = updateBalance;


		// variable declaration
		vm.balance = mlsData.balance;
		if(vm.balance == '' || vm.balance == null)
			vm.balance = 0;
		vm.contact_id = mlsData.id;
        vm.SendMail = 'yes';
		vm.myDate = new Date();
		vm.minDate = new Date(
            this.myDate.getFullYear(),
            this.myDate.getMonth(),
            this.myDate.getDate()
          );

		function closeDialog(){

			$mdDialog.cancel();
		}

		 function calculateExceedingAmount(){
        	var sum = parseFloat(vm.balance ) + parseFloat(vm.hotelCredit.hc_amount);
  
        	if(vm.hotelCredit.hc_amount > 0){
        		vm.amountError = false;
        		vm.amountExceeds = '';
        	} else if(vm.hotelCredit.hc_amount < 0){
        		if(sum < 0){
        		vm.amountError = true;
        		vm.amountExceeds = 'PLease enter the amount less than balance remaining.';
        	} else {
        		vm.amountError = false;
        		vm.amountExceeds = '';
        	}

        	} else if(vm.hotelCredit.hc_amount == 0){
        		vm.amountError = true;
        		vm.amountExceeds = 'PLease enter a valid amount.';
        	}
        	
        }

         /*functoin to update hotel credit*/
        function updateBalance(){
        	vm.hotelCredit['SendMail'] = vm.SendMail; 
        	vm.hotelCredit['customer_id'] = vm.contact_id;
        	userService.updateHotelCreditBalance(vm.hotelCredit).then(function(response){
        		if(response.status){
               		 $scope.$parent.updateHotelCredit_update();
        			
        			$mdDialog.cancel();

        		} else {
        			toastMessage.showSimpleToast('There was some error in saving hotel credits.','error-toast');
        		}

        	});

        }

	}
})();

'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../user/userService
 * @description
 * # ../user/userService
 * Service in the minervaApp.
 */
angular.module('app.contacts')
  .service('userService', function ($http, EnvironmentConfig,$localStorage) {
    // AngularJS will instantiate a singleton by calling "new" on this function
	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}
 	
 	/**
 	*Functin to fetch the list of customer data
 	**/

 	function fetchCustomerList(searchFilter){
 		return $http({
 			url:EnvironmentConfig.api+'customer/customers',
 			method:'POST',
 			data:searchFilter
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);
 	}

 	function addUser(customerData){
 		return $http({
 			url:EnvironmentConfig.api + 'customer/add_customer',
 			method: 'POST',
 			data: customerData

 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);
 	}
 	function deleteCustomer(customerId){
 		return $http({
 			url:EnvironmentConfig.api + 'customer/delete_customer/'+ customerId,
 			method:'POST',
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);
 	}
 	function updateCustomer(customerData,field_name){
 		return $http({
 			url: EnvironmentConfig.api+'customer/update_customer/',
 			method: 'POST',
 			data:{customerData:customerData,field_name:field_name}
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);

 	}
 	function fetchWebsite(){
 		return $http({
 			url: EnvironmentConfig.api+'customer/skipAcl_fetchWebsite',
 			method: 'GET'
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);

 	}
 	function validateEmail(email,customer_id, id){
 		return $http({
 			url:EnvironmentConfig.api+'customer/skipAcl_validate_customer_detail',
 			method:'POST',
 			data: {'email':email, 'customer_id':customer_id, id: id}
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);
 	}

 	function deleteSelectedContacts(customerId){
 		return $http({
 			url:EnvironmentConfig.api+'customer/delete_customer',
 			method:'POST',
 			data: customerId
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);
 	}
 	function getSingleEdit(userData){
		return $http({
 			url:EnvironmentConfig.api+'customer/skipAcl_getSingleCustomerDetail',
 			method:'POST',
 			data: userData
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);
 	}

	function getSingleCustomerReservations(customerId){
		return $http({
 			url:EnvironmentConfig.api + 'customer/skipAcl_getSingleCustomerReservationDetails/' + customerId,
 			method:'GET'
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);
 	}

 	function updateHotelCreditBalance(creditData){
 		return $http({
 			url: EnvironmentConfig.api + 'customer/skipAcl_updateHotelCredit',
 			method: 'POST',
 			data: creditData
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);

 	}
 	function getHotelCreditHistory(customer_id){
 		return $http({
 			url: EnvironmentConfig.api + 'customer/skipAcl_getAllHotelCredits',
 			method: 'POST',
 			data:{customer_id:customer_id}
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);
 	}

 	function getCountries(){
 		return $http({
 			url: EnvironmentConfig.api + 'customer/get_countries',
 			method: 'GET'
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);
 	}
 	
 	function getStates(country){
 		return $http({
 			url: EnvironmentConfig.api + 'customer/get_states',
 			method: 'POST',
 			data:{country_name:country}
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);
 	}
 	function getCountryStates(data){
 		return $http({
 			url: EnvironmentConfig.api + 'customer/get_countryStateData',
 			method: 'POST',
 			data:data
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);
	}
	function deleteOtherEmail(data){
		return $http({
			url : EnvironmentConfig.api + 'customer/deleteOtherEmail',
			method: 'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function deleteSelectedSubscribe(data){
		return $http({
			url : EnvironmentConfig.api + 'customer/deleteSelectedSubscribe',
			method: 'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	/*
	 *  Get Zip code from API
	 */
	function getZipCode(data){
		return $http({
			url : EnvironmentConfig.api + 'customer/getZipCode',
			method: 'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	/*
	 *  Get Zip code from backend API
	 */
	function getPostal(data){
		return $http({
			url : EnvironmentConfig.api + 'customer/getPostal',
			method: 'POST',
 			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	/*
	 *  Get customer types from API
	 */
	function getNegotiatedCustomers(){
		return $http({
			url : EnvironmentConfig.api + 'customer/getNegotiatedCustomers',
			method: 'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	  function fetchAllCustomerList(searchFilter) {
		  return $http({
			  url: EnvironmentConfig.api + 'customer/fetchAllCustomers',
			  method: 'POST',
			  data: searchFilter
		  })
			  .then(getDataComplete)
			  .catch(getDataFailed);
	  }
	  
	function getOptions(searchText, type) {
		return $http({
			url: EnvironmentConfig.api + "customer/getOptions",
			method: "GET",
			params: {
				q: searchText || "",
				type: type || "state",
				hotel_id: $localStorage.hotels[$localStorage.selectedHotel].hotel_id,
				limit: 20
			}
		})
		.then(function (response) {
			return response.data || [];
		})
		.catch(function () {
			return [];
		});
	}

	function getCustomerNotes(customerId){
		return $http({
			url:EnvironmentConfig.api + 'customer/getCustomerNotes?customer_id=' + customerId,
			method:'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function addCustomerNote(noteData){
		return $http({
			url:EnvironmentConfig.api + 'customer/addCustomerNote',
			method:'POST',
			data: noteData
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function updateCustomerNote(noteData){
		return $http({
			url:EnvironmentConfig.api + 'customer/updateCustomerNote',
			method:'POST',
			data: noteData
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function deleteCustomerNote(noteData){
		return $http({
			url:EnvironmentConfig.api + 'customer/deleteCustomerNote',
			method:'POST',
			data: noteData
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getCustomerTags(customerId){
		return $http({
			url: EnvironmentConfig.api + 'customer/getAllCustomerTags',
			method: 'GET',
			params:{
					customer_id: customerId
			}
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function saveCustomerTags(data) {
		return $http({
			url: EnvironmentConfig.api + 'customer/saveCustomerTags',
			method: 'POST',
			data: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getCustomerTagsSearch() {
		return $http({
			url: EnvironmentConfig.api + "customer/getCustomerTags",
			method: "GET"
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
 	
 	return{ 
 		addUser: addUser,
 		fetchCustomerList: fetchCustomerList,
 		deleteCustomer:deleteCustomer,
 		updateCustomer:updateCustomer,
 		fetchWebsite: fetchWebsite,
 		validateEmail: validateEmail,
 		deleteSelectedContacts: deleteSelectedContacts,
 		getSingleEdit: getSingleEdit,
		getSingleCustomerReservations: getSingleCustomerReservations,
 		updateHotelCreditBalance: updateHotelCreditBalance,
 		getHotelCreditHistory:getHotelCreditHistory,
 		getCountries:getCountries,
 		getStates:getStates,
		getCountryStates:getCountryStates,
		deleteOtherEmail:deleteOtherEmail,
		deleteSelectedSubscribe:deleteSelectedSubscribe,
		getZipCode: getZipCode,
		getPostal: getPostal,
		getNegotiatedCustomers: getNegotiatedCustomers,
		fetchAllCustomerList: fetchAllCustomerList,
		getOptions: getOptions,
		getCustomerNotes: getCustomerNotes,
		addCustomerNote: addCustomerNote,
		updateCustomerNote: updateCustomerNote,
		deleteCustomerNote: deleteCustomerNote,
		getCustomerTags: getCustomerTags,
		saveCustomerTags: saveCustomerTags,
		getCustomerTagsSearch: getCustomerTagsSearch
 	}


 }); 


(function () {
  "use strict";

  angular
    .module("app.contacts")
    .controller("ContactsController", ContactsController);

  /** @ngInject */
  function ContactsController(
    $rootScope,
    $window,
    $scope,
    $mdSidenav,
    msUtils,
    $mdDialog,
    $document,
    userService,
    toastMessage,
    $localStorage,
    $http,
    EnvironmentConfig,
    $state,
    $sessionStorage,
    $stateParams,
    $q
  ) {
    var vm = this;
    if (!$rootScope.backButtonPressed) {
      $sessionStorage[
        $state["current"]["name"] + "_" + $localStorage["preHotelId"]
      ] = {};
      $sessionStorage[
        $state["current"]["name"] + "_" + $localStorage["preHotelId"]
      ]["currentPage"] = 1;
      $sessionStorage[
        $state["current"]["name"] + "_" + $localStorage["preHotelId"]
      ]["pageSize"] = 50;
    }
    vm.customerType =
      $stateParams.type != undefined ? $stateParams.type : "normal";
    vm.customerId = [];
    vm.requestGoing = false;
    //vm.contacts = customerList[0];
    vm.selectedCustomerId = [];
    vm.checkDelete = false;
    vm.tempselect = true;
    vm.gotoaddcustomer = gotoaddcustomer;
    $scope.checkoutValuesCallback = function () {
      return $q.resolve([]);
    };

    /*Start*/
    $scope.paginatorCallback = paginatorCallback;
    $scope.LoadAllData = LoadAllData;
    $scope.getLoadResultsCallback = getLoadResultsCallback;
    $scope.selectedRowCallback = function (rows, id) {
      vm.selectedCustomerId = rows;
    };
    $scope.myRowClickCallback = function (event) {};
    $scope.goToEditPage = function (value) {
      if (vm.userPermissions.indexOf("update_customer") != -1) {
        var stateName =
          vm.customerType == "negotiated"
            ? "app.nego_customer_update"
            : "app.customer_update";
        try {
          var url = $state.href(
            stateName,
            { customer_id: value },
            { absolute: true }
          );
          $window.open(url, "_blank");
        } catch (e) {
          $state.go(stateName, { customer_id: value });
        }
      }
    };
    // self.myRowClickCallback = function (rowId) {
    //               .....
    //             };
    $scope.deleteSelectedItem = function (ev) {
      var html =
        "Are you sure, you want to delete the selected customer(s)?</br>";
      html =
        html +
        "<b>" +
        vm.selectedCustomerId.length +
        " customer(s)</b>" +
        " will be deleted.";

      $mdDialog
        .show({
          controller: "confirmController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/contacts/confirmationPopUp/confirmation.html",
          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: true,
          locals: {
            title:
              vm.selectedCustomerId.length > 1
                ? "Delete Customers"
                : "Delete Customer",
            htmlContent: html,
            cancelBtn: "Cancel",
            OkBtn: "Ok",
          },
        })
        .then(
          function (answer) {
            if (typeof answer != "undefined" && answer == "update") {
              userService
                .deleteSelectedContacts(vm.selectedCustomerId)
                .then(function (response) {
                  if (!response.error) {
                    // toastMessage.showSimpleToast('Customer successfully deleted.','success-toast');
                    vm.selectedCustomerId = [];
                    vm.checkDelete = false;
                    loadPageCallbackWithDebounce();
                  } else {
                    toastMessage.showSimpleToast(
                      "Some error occured.Please try again.",
                      "error-toast"
                    );
                  }
                });
            }
          },
          function () {}
        );
      //Old
    };

    var loadPageCallbackWithDebounce;
    $scope.$watch("filterText", function () {
      if (loadPageCallbackWithDebounce) {
        loadPageCallbackWithDebounce();
      }
    });

    $scope.updateTable = function () {
      loadPageCallbackWithDebounce();
    };

    $scope.addmodel = function (ev, contact) {
      userService.getSingleEdit(contact).then(function (response) {
        // if(typeof contact=='undefined' || vm.userPermissions.indexOf('delete_customer') != -1){
        // if(userPermissions!='All' && userPermissions.indexOf('List Customers') == -1){
        $mdDialog.show({
          controller: "ContactDialogController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/contacts/dialogs/contact/contact-dialog.html",
          parent: angular.element($document.find("#content-container")),
          targetEvent: ev,
          scope: $scope.$new(),
          clickOutsideToClose: true,
          locals: {
            Contact: response[0],
            User: vm.user,
            Contacts: vm.contacts,
          },
        });
        jQuery(".sec-contact-tab").css("display", "none");
        jQuery(".third-contact-tab").css("display", "none");
        // }
      });
    };

    function getLoadResultsCallback(loadPageCallback) {
      loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
    }
    vm.UserColumns = [
      "first_name",
      "customer_email",
      "phone_number",
      "no_of_stays",
      "address",
      "city",
      "state",
      "country",
      "zip_code",
      "is_active",
      "editCustomerId",
    ];

    vm.onLoad = true;
    function paginatorCallback(page, pageSize, option) {
      if (vm.requestGoing) return;
      if (vm.onLoad == true) {
        if (
          typeof $sessionStorage[
            $state["current"]["name"] + "_" + $localStorage["preHotelId"]
          ] != "undefined" &&
          typeof $sessionStorage[
            $state["current"]["name"] + "_" + $localStorage["preHotelId"]
          ]["currentPage"] != "undefined"
        ) {
          var page1 =
            $sessionStorage[
              $state["current"]["name"] + "_" + $localStorage["preHotelId"]
            ]["currentPage"];
          var pageSize1 =
            $sessionStorage[
              $state["current"]["name"] + "_" + $localStorage["preHotelId"]
            ]["pageSize"];
          vm.onLoad = false;
          return LoadAllData(page1, pageSize1, option);
        } else {
          vm.onLoad = false;
          return LoadAllData(page, pageSize, option);
        }
      } else {
        if (typeof page == "undefined") {
          page =
            $sessionStorage[
              $state["current"]["name"] + "_" + $localStorage["preHotelId"]
            ]["currentPage"];
        }
        return LoadAllData(page, pageSize, option);
      }
    }
		
    function LoadAllData(page, pageSize, option) {
      vm.requestGoing = true;

      var pageDetail = { currentPage: page, pageSize: pageSize };
      $sessionStorage[
        $state["current"]["name"] + "_" + $localStorage["preHotelId"]
      ] = pageDetail;

      vm.checkDelete = false;
      vm.selectedCustomerId = [];
      if (!page) {
        page = vm.page;
      } else {
        vm.page = page;
      }
      var sort = {};
      for (var i = 0; i < option.columnSort.length; i++) {
        if (option.columnSort[i]["sort"]) {
          sort["column"] = vm.UserColumns[i];
          sort["order"] = option.columnSort[i]["sort"];
        }
      }
      var columnSearch = [];
      if (option && option.columnFilter && option.columnFilter.length) {
        angular.forEach(option.columnFilter, function (filter, key) {
          if (filter && filter.length) {
            var value = filter[0];
            if (value !== "") {
              var fieldName = vm.UserColumns[key];
              if (fieldName && fieldName !== "editCustomerId") {
                columnSearch.push(fieldName + ":" + value);
              }
            }
          }
        });
      }
      var offset = (page - 1) * pageSize;
      var filterData = {
        offset: offset,
        pageSize: pageSize,
        search: $scope.filterText,
        sort: sort,
        selectedHotel: $localStorage.hotels[$localStorage.selectedHotel].hotel_id,
        customerType: vm.customerType,
        columnSearch: columnSearch,
      };

      vm.filterData = {
        offset: offset,
        pageSize: pageSize,
        search: $scope.filterText,
        sort: sort,
        selectedHotel:
          $localStorage.hotels[$localStorage.selectedHotel].hotel_id,
        columnSearch: columnSearch,
      };
      return userService.fetchAllCustomerList(filterData).then(function (result) {
        vm.contacts = result["customerList"];
        vm.totalCustomers = parseInt(result["totalCustomer"]);
        vm.requestGoing = false;
        return {
          results: vm.contacts,
          totalResultCount: vm.totalCustomers,
        };
      });
    }

    /*End*/
    vm.user = [];
    vm.filterIds = null;
    vm.listType = "all";
    vm.listOrder = "name";
    vm.listOrderAsc = false;
    vm.selectedContacts = [];
    vm.newGroupName = "";
    vm.userPermissions = $rootScope.userPermissions;
    if (vm.userPermissions.indexOf("delete_customer") != -1) {
      $scope.isDeletedAllowed = true;
    } else {
      $scope.isDeletedAllowed = false;
    }
    // Methods
    vm.filterChange = filterChange;
    vm.openContactDialog = openContactDialog;
    // vm.deleteContactConfirm = deleteContactConfirm;
    vm.deleteContact = deleteContact;
    vm.deleteSelectedContacts = deleteSelectedContacts;
    vm.toggleSelectContact = toggleSelectContact;
    vm.deselectContacts = deselectContacts;
    vm.selectAllContacts = selectAllContacts;
    vm.deleteContact = deleteContact;
    vm.addNewGroup = addNewGroup;
    vm.deleteGroup = deleteGroup;
    vm.toggleSidenav = toggleSidenav;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.exists = msUtils.exists;
    vm.convertdatestring = convertdatestring;
    vm.status = [
      { value: 1, name: "Active" },
      { value: 0, name: "Inactive" },
    ];
    vm.gender = [
      { value: 1, name: "Male" },
      { value: 0, name: "Female" },
    ];

    function convertdatestring(dateString) {
      return new Date(dateString);
    }

    //////////

    /**
     * Change Contacts List Filter
     * @param type
     */
    function filterChange(type) {
      vm.listType = type;

      if (type === "all") {
        vm.filterIds = null;
      } else if (type === "frequent") {
        vm.filterIds = vm.user.frequentContacts;
      } else if (type === "starred") {
        vm.filterIds = vm.user.starred;
      } else if (angular.isObject(type)) {
        vm.filterIds = type.contactIds;
      }

      vm.selectedContacts = [];
    }

    /**
     * Open new contact dialog
     *
     * @param ev
     * @param contact
     */
    function openContactDialog(ev, contact) {
      if (
        typeof contact == "undefined" ||
        vm.userPermissions.indexOf("delete_customer") != -1
      ) {
        $mdDialog.show({
          controller: "ContactDialogController",
          controllerAs: "vm",
          templateUrl:
            "app/main/apps/contacts/dialogs/contact/contact-dialog.html",
          parent: angular.element($document.find("#content-container")),
          targetEvent: ev,
          scope: $scope.$new(),
          clickOutsideToClose: true,
          locals: {
            Contact: contact,
            User: vm.user,
            Contacts: vm.contacts,
          },
        });
        jQuery(".sec-contact-tab").css("display", "none");
        jQuery(".third-contact-tab").css("display", "none");
      }
    }

    /**
     * Delete Contact
     */
    function deleteContact(contact) {
      vm.contacts.splice(vm.contacts.indexOf(contact), 1);
    }

    /**
     * Delete Selected Contacts
     */
    function deleteSelectedContacts(ev) {
      var confirm = $mdDialog
        .confirm()
        .title("Are you sure, you want to delete the selected customer(s)?")
        .htmlContent(
          "<b>" +
            vm.selectedCustomerId.length +
            " customer(s)</b>" +
            " will be deleted."
        )
        .ariaLabel("delete contacts")
        .targetEvent(ev)
        .ok("OK")
        .cancel("CANCEL");

      $mdDialog.show(confirm).then(function () {
        userService
          .deleteSelectedContacts(vm.selectedCustomerId)
          .then(function (response) {
            if (!response.error) {
              vm.selectedCustomerId = [];
              vm.checkDelete = false;
              loadPageCallbackWithDebounce();
            } else {
              toastMessage.showSimpleToast(
                "There was some error in deleting customers.",
                "error-toast"
              );
            }
          });
      });
    }

    /**
     * Toggle selected status of the contact
     *
     * @param contact
     * @param event
     */
    function toggleSelectContact(contact, event) {
      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedContacts.indexOf(contact) > -1) {
        vm.selectedContacts.splice(vm.selectedContacts.indexOf(contact), 1);
        vm.customerId.splice(vm.customerId.indexOf(contact.customer_id), 1);
      } else {
        vm.customerId.push(contact.customer_id);
        vm.selectedContacts.push(contact);
      }
    }

    /**
     * Deselect contacts
     */
    function deselectContacts() {
      vm.selectedContacts = [];
      vm.customerId = [];
    }

    /**
     * Sselect all contacts
     */
    function selectAllContacts() {
      if (vm.checkAll) {
        vm.selectedCustomerId = [];
        vm.customerId = [];
        for (var i = 0; i < vm.contacts.length; i++) {
          vm.selectedCustomerId.push(vm.contacts[i].customer_id);
        }
        //  angular.forEach($scope.Items, function (item) {
        //     item.Selected = $scope.selectedAll;
        // });
        vm.deleteCheckbox = true;
      } else {
        vm.deleteCheckbox = false;
        vm.selectedCustomerId = [];
      }
    }

    /**
     *
     */
    function addNewGroup() {
      if (vm.newGroupName === "") {
        return;
      }

      var newGroup = {
        id: msUtils.guidGenerator(),
        name: vm.newGroupName,
        contactIds: [],
      };

      vm.user.groups.push(newGroup);
      vm.newGroupName = "";
    }

    /**
     * Delete Group
     */
    function deleteGroup(ev) {
      var group = vm.listType;

      var confirm = $mdDialog
        .confirm()
        .title("Are you sure want to delete the group?")
        .htmlContent("<b>" + group.name + "</b>" + " will be deleted.")
        .ariaLabel("delete group")
        .targetEvent(ev)
        .ok("OK")
        .cancel("CANCEL");

      $mdDialog.show(confirm).then(function () {
        vm.user.groups.splice(vm.user.groups.indexOf(group), 1);
        filterChange("all");
      });
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }
    function gotoaddcustomer() {
      if (vm.customerType == "negotiated") {
        $state.go("app.nego_customer_add");
      } else {
        $state.go("app.customer_add");
      }
    }
    vm.exportData = exportData;
    vm.processingRequest = false;

    function exportData() {
      var customerCount = vm.totalCustomers;
      vm.processingRequest = true;
      vm.csvName = "customers.csv";
      vm.csvHeader = [
        "Name",
        "Email",
        "Phone Number",
        "Address",
        "City",
        "Zip Code",
        "State",
        "Country",
        "No. of Stays",
        "Status"
      ];

      if (vm.selectedCustomerId.length > 0) {
        vm.filterData["customer_id"] = vm.selectedCustomerId;
        vm.filterData["getAllData"] = false;
        customerCount = 50;
      } else {
        delete vm.filterData["customer_id"];
        vm.filterData["getAllData"] = true;
      }

      vm.filterData.customerType = vm.customerType;
      vm.filterData.csv = true;
      var maxRecord = 5000;
      var offset = 0;

      var ilength = customerCount / maxRecord;
      var j = 0;
      for (i = 0; i <= ilength; i++) {
        (function (i) {
          setTimeout(function () {
            vm.filterData.offset = offset;
            vm.filterData.pageSize = maxRecord;
            userService
              .fetchAllCustomerList(vm.filterData)
              .then(function (response) {
                vm.allData =
                  response["customerList"] != undefined
                    ? response["customerList"]
                    : [];
                if (vm.allData.length) {
                  $rootScope.downloadFile(
                    vm.csvHeader,
                    vm.allData,
                    "customers-" + j + ".csv"
                  );
                }
              });
            offset += maxRecord;
            j = j + 1;
          }, 2000 * i);
        })(i);
      }
      if (i >= ilength) {
        vm.processingRequest = false;
      }
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.checkout')
        .controller('giftCard', giftCard);

    /** @ngInject */
    function giftCard(
        $sessionStorage,
        $scope,
        $mdDialog,
        tax,
        $q,
        product,
        pageDetails,
        checkoutService
    ) {
        var vm = this;
        var myDate = new Date();
        var time = myDate.getTime() + "";


        checkoutService.getGiftCards().then(function(response) {
            if(response['success'] && response['products'].length > 0){
                vm.giftCard = response['products'][0];
                vm.giftCard['total'] = 0;
                vm.giftCard['product_price'] = parseFloat(vm.giftCard['product_price']) ? parseFloat(vm.giftCard['product_price']):100;
                vm.giftCard['customDiscount'] =  0;
                vm.giftCard['customPrice'] =  0;
                vm.giftCard['giftCard_price'] = 0;
                vm.giftCard['gc_sender_email'] = '';
                vm.giftCard['gc_sender_name'] = '';
                vm.giftCard['gc_recipient_email'] = '';
                vm.giftCard['gc_recipient_name'] = '';
                vm.giftCard['product_discount'] = 0;
                vm.giftCard['quantity'] = 1;
                vm.giftCard['is_gift_card'] = true;
                vm.giftCard['gc_message'] =  '';

            } else {
                var currentDate = new Date();
                vm.giftCard = {
                    customDiscount: 0,
                    customPrice: 0,
                    media: "1500699310dcc.png",
                    product_id: currentDate.getTime(),
                    product_is_timebound: "0",
                    product_name: "Gift Card",
                    product_price: 0,
                    giftCard_price: 0,
                    product_type: "pos",
                    tax_value: 0,
                    tax_id: 0,
                    gc_sender_email: '',
                    gc_sender_name: '',
                    gc_recipient_email: '',
                    gc_recipient_name: '',
                    product_discount: 0,
                    quantity: 1,
                    is_gift_card: true,
                    gc_message: '',
                    total: 0
                };
            }
        });

        vm.closeDialog = closeDialog;
        function closeDialog() {
            $mdDialog.cancel();
        }

        vm.addgiftCard = addgiftCard;

        function addgiftCard() {
            vm.giftCard.giftCard_price = angular.copy(vm.giftCard.product_price);
            $scope.$parent.addGiftCardToCart(vm.giftCard);
            $mdDialog.cancel();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.checkout')
        .controller('customerController', customerController);

    /** @ngInject */
    function customerController(
        $sessionStorage,
        $scope,
        $mdDialog,
        $q,
        createResService,
        $localStorage,
        $document,
        userService,
        Country,
        $timeout,
        $rootScope,
        toastMessage
    ) {
        var vm = this;
        vm.isRequestTrue = true;
        vm.querySearch = querySearch;
        vm.duplicateEmail = false;
        vm.hotel_id = $localStorage.hotels[$localStorage.selectedHotel].hotel_id;



        function querySearch(query, myField) {
            if (vm.isRequestTrue) {
                var deferred = $q.defer();
                createResService.getCustomers({
                        search: query,
                        field: myField,
                        pageFrom: 'reservation'
                    })
                    .then(function(response) {
                        deferred.resolve(response[0].customerList);
                    });
                return deferred.promise;
            } else {
                return [];
                vm.hidePassword = true;
            }
        }

        vm.selectCustomer = selectCustomer;

        function selectCustomer() {
            vm.contact['tax_exempt_indicator'] = vm.contact.tax_exempt_indicator ? 1 : 0;
            vm.contact['send_email_indicator'] = vm.contact.send_email_indicator ? 1 : 0;
            vm.contact['hotel_id'] = vm.hotel_id;
            vm.contact['first_name'] = vm.searchTextFn;
            vm.contact['last_name'] = vm.searchTextLn;
            vm.contact['customer_email'] = vm.searchTextEm;
            vm.contact['country'] =  vm.searchTxtCountry;
            vm.contact['state'] = vm.searchTxtState;
            vm.contact['tax_exempt_id'] = vm.contact.tax_exempt_id;
            vm.contact['is_account_virtual'] = 1;
            if(vm.contact['country'].length == 0){
                vm.contact['state'] = '';
            }
            checkDuplicateEmail();
        }
        vm.checkDuplicateEmail = checkDuplicateEmail;

        vm.duplicateEmail = false;
        vm.addNewCustomer = addNewCustomer;
        vm.validateUser = validateUser;
        
        function validateUser(){
            var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;      
                if (!filter.test(vm.searchTextEm)) {
                    return true;
                } else {
                    return false;

                }

        }

        function addNewCustomer() {
            var country = '';
            if(typeof vm.searchTxtCountry['display'] != undefined && vm.searchTxtCountry['display'] != '')
            country = vm.searchTxtCountry['display'];

            var state = '';
            if(typeof vm.searchTxtState['display'] != undefined && vm.searchTxtState['display'] != '')
            state = vm.searchTxtState['display'];


            var addData = {
                'first_name':vm.searchTextFn,
                'last_name':vm.searchTextLn,
                'phone_number':vm.contact.phone_number,
                'customer_email':vm.searchTextEm,
                'address':vm.contact.address, 
                'city':vm.contact.city, 
                'state':state,
                'hotel_id':vm.hotel_id,
                'is_active':1,
                'zip_code': vm.contact.zip_code,
                'country':country, 
                'tax_exempt_indicator':vm.contact.tax_exempt_indicator ? 1 : 0,
                'tax_exempt_id':vm.contact.tax_exempt_id,
                'send_email_indicator':vm.contact.send_email_indicator ? 1 : 0
            }
                createResService.addCustomer(addData).then(function(response) {
                    if(response.success){
                        if(response.errorMsg){
                            toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                        }
                        createResService.getCustomers({customer_id:response.id,selectedHotel:vm.hotel_id})
                            .then(function(response) {
                                $rootScope.$broadcast('getCustomer',{userDetail: [],response: response[0]['customerList'][0]});

                        });
                    } else if(response.errorMsg){
                        toastMessage.showSimpleToast(response.errorMsg,'error-toast');
                    }else{
                        toastMessage.showSimpleToast('There was some error in saving customer.','error-toast');
                    }
                    $mdDialog.hide();
                    
                });
        }

        vm.updateForm = updateForm;
        function updateForm(item, field) {
            
            if (typeof item != 'undefined' && vm.isRequestTrue) {
                vm.isRequestTrue = false;
                if (item) {
                    vm.hidePassword = true;
                    vm.buttonType = 'AutoSelect';
                    vm.selectedItem = item;
                } else {
                    vm.hidePassword = false;
                    vm.buttonType = 'Add';
                }
                if (field == 'cust.first_name') {
                    vm.selectedSearch.last_name = item.last_name;
                    vm.selectedSearch.customer_email = item.customer_email;
                    vm.selectedSearch.phone_number = item.phone_number;
                }
                if (field == 'cust.last_name') {
                    vm.selectedSearch.first_name = item.first_name;
                    vm.selectedSearch.email = item.email;
                    vm.selectedSearch.phone_number = item.phone_number;
                }
                if (field == 'cust.customer_email') {
                    vm.selectedSearch.first_name = item.first_name;
                    vm.selectedSearch.last_name = item.last_name;
                    vm.selectedSearch.phone_number = item.phone_number;
                }

                $timeout(function() {
                    vm.isRequestTrue = true;
                    if (item.state.length > 0) {
                        vm.selectedState = {
                            value: item['state'].toLowerCase(),
                            display: item['state']
                        };
                        vm.searchTxtState = vm.selectedState['display'];
                    }else {
                        vm.selectedState = '';
                    }

                }, 1000);
                vm.contact = item;

                if(item['country'].length > 0){
                    vm.selectedCountry = {
                        value: item['country'].toLowerCase(),
                        display: item['country']
                    };
                    vm.searchTxtCountry = vm.selectedCountry['display'];
                } else {
                    vm.selectedCountry = '';
                }             

                if (!item.tax_exempt_indicator) {
                    vm.contact['tax_exempt_indicator'] = false;
                } else {
                    vm.contact['tax_exempt_indicator'] = item.tax_exempt_indicator == 1 ? true : false;
                }
                if (!item.send_email_indicator) {
                    vm.contact['send_email_indicator'] = true;
                } else {
                    vm.contact['send_email_indicator'] = item.send_email_indicator == 1 ? true : false;
                }
            }
        }


        vm.countryList = [];
        vm.stateList = [];
        Country.forEach(function(element) {
            vm.countryList.push(element.name);
        });

        selectedItemChange();
        vm.selectedItemChangeState = selectedItemChangeState;

        /**
         * Close dialog
         */
        vm.closeDialog = closeDialog;
        function closeDialog() {
            $mdDialog.hide();
        }

        function checkDuplicateEmail() {
            vm.isloading = true;
            vm.duplicateEmail = false;
            createResService.checkCustomerDuplicateEmail(vm.contact.customer_email, vm.hotel_id).then(function(response) {
                if (response.success) {
                    vm.duplicateEmail = true;
                }
                if(vm.duplicateEmail){
                    createResService.updateCustomer(vm.contact).then(function(response) {});
                    $rootScope.$broadcast('getCustomer',{userDetail: vm.contact,response: []});
                    $mdDialog.hide();
                } else {
                    addNewCustomer();    
                }
            });
            vm.isloading = false;
        }



        vm.getCountries = function() {
            vm.isloading = true;
            if (Object.keys(vm.countries).length <= 1) {
                return $timeout(function() {
                    createResService.getCountries().then(function(response) {
                        vm.countries = response;
                        vm.isloading = false;
                    });
                }, 1500);
            }
        }

        vm.getStates = function() {
            vm.isloading = true;
            return $timeout(function() {
                createResService.getStates(vm.contact.country).then(function(response) {
                    vm.states = response;
                    vm.isloading = false;
                });
            }, 1500);
        }
        /*Search For country start*/
        vm.simulateQuery = false;
        vm.isDisabled = false;

        // list of `state` value/display objects
        vm.myCountryArr = loadAll();

        vm.queryCountrySearch = queryCountrySearch;
        vm.newState = newState;

        function newState(state) {
            alert("Sorry! You'll need to create a Constitution for " + state + " first!");
        }

        function queryCountrySearch(query) {
            var results = query ? vm.myCountryArr.filter(createFilterForCountry(query)) : vm.myCountryArr,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function() {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }
        /**
         * Build `states` list of key/value pairs
         */
        function loadAll() {
            var allStates = vm.countryList;
            return allStates.map(function(state) {
                return {
                    value: state.toLowerCase(),
                    display: state
                };
            });
        }

        /**
         * Create filter function for a query string
         */
        function createFilterForCountry(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };
        }
        /*Search For country end*/
        //for traveller
        vm.selectedItemChangeStateTraveller = selectedItemChangeStateTraveller;

        function selectedItemChangeStateTraveller(query, index) {
            if (vm.searchTxtCountryTraveller[index]) {
                var deferred = $q.defer();
                createResService.getAllStates({
                        state: query,
                        country: vm.searchTxtCountryTraveller[index]
                    })
                    .then(function(response) {
                        deferred.resolve(response.states);
                    });
                return deferred.promise;

            } else {
                return [];
            }

        }
        vm.selectedItemChange = selectedItemChange;

        function selectedItemChange(item, searchTxt, index) {
            vm.stateList = [];
            vm.isStateDisabled = true;
            if (vm.selectedCountry) {
                vm.contact.country = vm.selectedCountry['display'];
                if (typeof vm.selectedCountry['display'] != undefined || vm.selectedCountry['display'] != '') {
                    vm.selectedState = '';
                    vm.isloading = true;
                    userService.getStates(vm.contact.country).then(function(response) {
                        response.forEach(function(element) {
                            vm.stateList.push(element.name);
                        });
                        vm.isloading = false;
                    });
                    return $timeout(function() {
                        var temp = [];
                        vm.myStateArr = loadAllState();
                        vm.isStateDisabled = false;
                    }, 1500);
                }

            }

        }

        /*state start*/
        vm.simulateQuery = false;
        vm.isDisabled = false;
        // list of `state` value/display objects
        vm.queryStateSearch = queryStateSearch;

        function queryStateSearch(query) {
            var results = query ? vm.myStateArr.filter(createFilterForState(query)) : vm.myStateArr,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function() {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }
        /**
         * Build `states` list of key/value pairs
         */



        /**
         * Create filter function for a query string
         */
        function createFilterForState(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };
        }

        function selectedItemChangeState() {
            if (typeof vm.selectedState['display'] != 'undefined' && vm.selectedState['display'] != null) {
                vm.contact.state = vm.selectedState['display'];
            } else {
                vm.contact.state = vm.contact.state;

            }
        }

        /**
         * Build `states` list of key/value pairs
         */
        vm.loadAllState = loadAllState;

        function loadAllState() {
            return vm.stateList.map(function(state) {
                return {
                    value: state.toLowerCase(),
                    display: state
                };
            });
        }


        /**
         * Create filter function for a query string
         */
        function createFilterForState(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };
        }

        function selectedItemChangeState() {
            if (typeof vm.selectedState['display'] != 'undefined' && vm.selectedState['display'] != null) {
                vm.contact.state = vm.selectedState['display'];
            } else {
                vm.contact.state = vm.contact.state;

            }
        }
        /*state End*/




    }
})();
(function() {
    'use strict';

    angular
        .module('app.checkout')
        .controller('customSale', customSale);

    /** @ngInject */
    function customSale(
        $sessionStorage,
        $scope,
        $mdDialog,
        tax,
        $q,
        product,
        pageDetails,
        $filter,
        $localStorage,
        commonService,
        taxValue,
        updateIndexValue,
        $rootScope
    ) {
        /*initialization*/

        var vm = this;
        var myDate = new Date();
        var time = myDate.getTime() + "";
        vm.myDate = new Date();
        vm.discountAdded = false;
        vm.taxValue = taxValue;
        vm.selectedIds = [];
        vm.minDate = new Date(
            this.myDate.getFullYear(),
            this.myDate.getMonth(),
            this.myDate.getDate()
        );
        vm.posProduct = {};

        vm.selectedOptionIds = [];
        vm.selectedOptions = [];
        vm.resQuantity = 1;
        vm.freeOptions = [];
        vm.dropDownSelect = {};
        vm.tempSelect = {};
        vm.tempFreeSelect = {};
        vm.cooking_preference = [];
        vm.pizzaType = [];
        vm.cooking_preference_options = [
            { name: 'Rare', value: 'rare'},
            { name: 'Medium Rare', value: 'medium_rare'},
            { name: 'Medium', value: 'medium'},
            { name: 'Medium Well', value: 'medium_well'},
            { name: 'Well Done', value: 'well_done'},
        ];
        vm.pizzaCatSelected = (product.pos_type_name !== undefined && product.pos_type_name !== null && product.pos_type_name.toLowerCase() === 'pizza') ? true : false;
        
        /*Discount Variable*/
        vm.orderTakeOrEat = true;
        vm.discountPriceType = 'percentage';
        vm.PriceType = 'Percentage';
        vm.customDiscount = [];
        vm.product = product;
        vm.dynamic_date_from = '';
        vm.ingredients = [];
        vm.selectedIngredient = [];
        vm.notSelectedIngredient = [];
        vm.selectedIngredientName = [];
        vm.notSelectedIngredientName = [];


        vm.restaurant_selected_attributes = [];
        if(vm.product.dynamic_attribute==1){
            angular.forEach(vm.product.dynamic_attributes, function(value, key) {
                vm.product.dynamic_attributes[key].value= "";
            });
        }

        vm.showRestaurantAttributes = (typeof product.ingredients != 'undefined') ? true : false;
        vm.dropDownArray = [];
        vm.multiChoiceArray = [];
        if (typeof vm.product.restaurant_attributes != 'undefined' &&  Object.keys(vm.product.restaurant_attributes).length > 0) {
            angular.forEach(vm.product.restaurant_attributes, function(value, key) {
                if (key == 'dropdown')
                     vm.dropDownArray = value;

                if (key == 'multichoice')
                    vm.multiChoiceArray = value;
            });
        }
        
        if(typeof product.ingredients != 'undefined'){
            vm.ingredients  = product.ingredients;
            if (typeof product.selectedIngredientName !== 'undefined') {  // restaurant product edit case
                vm.orderTakeOrEat = product['orderTakeOrEat'] === 'Eat in' ? true : false;
                vm.ingredients.forEach(function(value, key) {
                    if (product.selectedIngredientName.indexOf(value.ingredient_name) > -1) {
                        vm.selectedIngredient.push(value.ingredient_id);
                        vm.selectedIngredientName.push(value.ingredient_name);
                        vm.ingredients[key].selected = 1;
                    } else {
                        vm.notSelectedIngredient.push(value.ingredient_id);
                        vm.notSelectedIngredientName.push(value.ingredient_name);
                        vm.ingredients[key].selected = 0;
                    }
                });
                   
                vm.tempDropDownSelect = {};
                if (Object.keys(vm.dropDownArray).length) {
                    angular.forEach(vm.dropDownArray,function(value, key) {
                        if (product.dropDownSelect !== undefined && product.dropDownSelect.hasOwnProperty('val_'+key)) {
                            angular.forEach(value, function(childVal, childKey) {
                                if (product.dropDownSelect['val_'+key].option_id === childVal.option_id) {
                                    vm.tempDropDownSelect['val_'+key] = childVal;
                                    vm.tempDropDownSelect['val_'+key].drowDownValue = 'val_'+key;
                                    if (childVal.price !== '0.00') {
                                        addRemove(vm.tempDropDownSelect['val_'+key], 'add', -1 , 'notPushEditCase');
                                        vm.tempSelect['val_'+key] = vm.tempDropDownSelect['val_'+key];
                                        // vm.selectedOptions.push(vm.tempDropDownSelect['val_'+key]);
                                    } else {
                                        vm.tempFreeSelect['val_'+key] = vm.tempDropDownSelect['val_'+key];
                                        vm.freeOptions.push(vm.tempDropDownSelect['val_'+key]);
                                    }
                                }
                            });
                        }
                    });
                }

                var length = product.selectedValue.length;
                var i, j, quantity;

                if (Object.keys(vm.multiChoiceArray).length) {
                    angular.forEach(vm.multiChoiceArray,function(value, key) {
                        if (product.selectedValue.length) {   
                            for(i = 0; i < value.length; i++) {
                                for (j = 0; j < length; j++) {
                                    if (product.selectedValue[j].parentkey === key && value[i].name.toLowerCase() === product.selectedValue[j].name.toLowerCase()) {
                                        quantity = (product.selectedValue[j].quantity !== undefined && product.selectedValue[j].quantity !== null) ? product.selectedValue[j].quantity : 1;
                                        vm.multiChoiceArray[key][i].highlighted = 1;
                                        vm.multiChoiceArray[key][i].count = quantity;
                                        vm.selectedOptions.push(product.selectedValue[j]);
                                        vm.selectedOptionIds.push(product.selectedValue[j].option_id);
                                        break;
                                    }                                        
                                }
                            }
                        }                            
                    });
                }

                vm.restaurantNote = product.restaurantNote;
                vm.resQuantity = product.quantity;
                setTimeout(function(){
                    vm.dropDownSelect = vm.tempDropDownSelect;
                    calculateTotal();
                }, 200);
                
                if (product.cooking_preference !== undefined && product.cooking_preference.length) {
                    for (i = 0; i < product.cooking_preference.length; i++) {
                        if (vm.pizzaCatSelected) {
                            vm.pizzaType['sel_'+i] = product.cooking_preference[i].pizzaTypeSelected;
                            delete product.cooking_preference[i].pizzaTypeSelected;
                        }
                        vm.cooking_preference.push(product.cooking_preference[i]);  
                    } 
                }
            } else {  // restaurant product add case
                if (vm.ingredients.length) {
                    vm.ingredients.forEach(function(value, key) {
                        vm.ingredients[key].selected = 1;
                        vm.selectedIngredient.push(value.ingredient_id);
                        vm.selectedIngredientName.push(value.ingredient_name);
                    });
                }
            }
        }
        

        vm.showAddOns = Object.keys(vm.multiChoiceArray).length ? true : false;

        if (!angular.equals({}, pageDetails) && pageDetails.checkin != "01/01/1970") {
            vm.posProduct.from = pageDetails.checkin;
            vm.posProduct.to = pageDetails.checkout;
        } else {
            vm.posProduct.from = vm.minDate;
            var new_dateTo = moment(vm.minDate, "DD.MM.YYYY");
            var thingTO = new_dateTo.add(2, 'days');
            vm.posProduct.to = thingTO;

        }

        var new_date = moment(vm.minDate, "DD.MM.YYYY");
        var thing = new_date.add(1, 'days');
        vm.fromMinDate = thing['_d'];
        vm.tax = tax;
        /*initialize custom product*/
        vm.customProduct = {
            customDiscount: 0.00,
            customPrice: 0.00,
            media: "1500699310dcc.png",
            product_id: time,
            product_is_timebound: "0",
            product_name: "",
            product_price: "",
            product_type: "pos",
            quantity: 1,
            tax_value: 0.00,
            tax_name: '',
            tax_id: 0,
            total: 0.00,
            product_discount: 0.00
        };

        vm.closeDialog = closeDialog;
        vm.addCustomProduct = addCustomProduct;
        vm.convert = convert;
        vm.addTimeBoundProduct = addTimeBoundProduct;
        vm.updateDateValidation = updateDateValidation;
        /*customDiscount functions*/
        vm.addCustomDiscount = addCustomDiscount;
        vm.customAmountType = customAmountType;       
        /*----*/

        vm.getTaxId = getTaxId;

        function getTaxId() {
            vm.tax_id = angular.copy(vm.customProduct.tax_value['tax_id']);
            vm.customProduct.tax_valueTemp = angular.copy(vm.customProduct.tax_value['tax_value']);
            vm.customProduct.tax_name = angular.copy(vm.customProduct.tax_value['tax_name']);
        }

        /*if discount is set*/
        if ($localStorage['cartDiscount_' + $localStorage['preHotelId']]) {
            vm.discountAdded = true;
            vm.customDiscount['discount_name'] = $localStorage['cartDiscount_' + $localStorage['preHotelId']]['discount_name'];
            vm.discountPriceType = $localStorage['cartDiscount_' + $localStorage['preHotelId']]['discount_type'];
            vm.customDiscount['dicount_price'] = $localStorage['cartDiscount_' + $localStorage['preHotelId']]['dicount_price'];
        }

        /*Discount function */
        function customAmountType(type) {
            vm.tempNumber = 0;
            vm.customDiscount.dicount_price = 0;
            vm.discountPriceType = type;
            if (type == 'amount') {
                vm.discountPriceType = 'amount';
                vm.PriceType = 'Price';
            } else {
                vm.discountPriceType = 'percentage';
                vm.PriceType = 'Percentage';
            }
        }

        function addCustomDiscount(type) {
            vm.discountAdded = true;
            if (typeof vm.customDiscount.discount_name == 'undefined' || vm.customDiscount.discount_name == '') {
                vm.customDiscount.discount_name = 'Custom discount';
            }
            // vm.customDiscount.discount_name = vm.customDiscount.discount_name.replace(/^\s+|\s+$/g, '');
            var dicountData = {
                'discount_name': vm.customDiscount.discount_name,
                'discount_type': vm.discountPriceType,
                'dicount_price': vm.customDiscount.dicount_price
            };
            if (type == 'add') {
                $localStorage['cartDiscount_' + $localStorage['preHotelId']] = dicountData;
                $rootScope.isDiscountApplied = true;
            } else {
                $localStorage['cartDiscount_' + $localStorage['preHotelId']] = '';
                $rootScope.isDiscountApplied = false;
            }
            $scope.$parent.addCustomDiscountAll(vm.customDiscount, vm.discountPriceType, type);
            $mdDialog.cancel();
        }
        /*-----*/


        function updateDateValidation() {
            // var new_date = moment(vm.posProduct.from, "DD.MM.YYYY");
            // var thing = new_date.add(1, 'days');
            // vm.fromMinDate = thing['_d'];
            
            var startDate = moment(vm.posProduct.from);
            var endDate = moment(vm.posProduct.to);
            vm.fromMinDate = new Date(moment(startDate, "DD-MM-YYYY").add(1, 'days'));
            if(endDate.isBefore(startDate) || endDate.isSame(startDate)){
                vm.posProduct.to = new Date(moment(startDate, "DD-MM-YYYY").add(2, 'days'));
            }
        }


        function addTimeBoundProduct() {
            if(vm.product.product_is_timebound==1){
                var date1 = vm.posProduct.from;
                var date2 = vm.posProduct.to;
                var diffDays = Math.floor((Date.parse(date2) - Date.parse(date1)) / 86400000);
                // $scope.$parent.addTimeBoundProduct(product, diffDays, date1, date2);
                $scope.$parent.addTimeBoundProduct(product, 1, date1, date2);
            } else
                $scope.$parent.addTimeBoundProduct(product, 1, '', '','','');   

            $mdDialog.cancel();
        }

        function addCustomProduct() {
            var name = vm.customProduct.product_name.replace(/^\s+|\s+$/g, '');
            if (name == '') {
                vm.customProduct.product_name = 'Custom product';
            }

            vm.customProduct.tax_value = angular.copy(vm.customProduct.tax_valueTemp);
            vm.customProduct.is_custom_product = true;
            vm.customProduct.tax_id = vm.tax_id;
            if (typeof vm.customProduct.tax_value == 'undefined' || typeof vm.customProduct.tax_id == 'undefined') {
                vm.customProduct.tax_value = 0;
                vm.customProduct.tax_id = '';
            }
            vm.taxes = [];
            var tax = {
                tax_id : vm.customProduct.tax_id,
                tax_name : vm.customProduct.tax_name,
                tax_value: vm.customProduct.tax_value
            }
            vm.taxes.push(tax);
            vm.customProduct.taxes = vm.taxes;
            $scope.$parent.addCustomProductToCart(vm.customProduct);
            $mdDialog.cancel();
        }

        function closeDialog() {
            $mdDialog.cancel();
        }


        function convert(str) {
            var date = new Date(str),
                mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                day = ("0" + date.getDate()).slice(-2);
            return [date.getFullYear(), mnth, day].join("-");
        }

        /*For discount*/
        vm.popUpType = 'overAllDiscount';
        vm.dialogTitle = 'Discount - Maximum 100%';

        vm.UpdateInputBox = UpdateInputBox;
        vm.getNumber = getNumber;
        vm.tempNumber = 0;
        vm.number = 0;


        function UpdateInputBox(number){
            if(number == -1){
                vm.tempNumber = commonService.roundnum(vm.tempNumber,2);
                if(vm.tempNumber > 0){
                    vm.tempNumber = commonService.roundnum(vm.tempNumber*0.1,3);
                    vm.tempNumber = vm.tempNumber + "";
                    vm.tempNumber = vm.tempNumber.slice(0, -1);
                    vm.tempNumber = commonService.roundnum(parseFloat(vm.tempNumber),2);
                }else
                    vm.tempNumber = '0.00';
            } else if(vm.tempNumber > 0 && typeof number == 'string'){
                vm.tempNumber = commonService.roundnum(parseFloat(vm.tempNumber) * 100,2);
            } else if(typeof number == 'number' && ((number == 0 && vm.tempNumber > 0) || number > 0 )){
                number = parseFloat(number) * 0.01;
                vm.tempNumber = commonService.roundnum((parseFloat(vm.tempNumber) * 10) + parseFloat(number),2);
            } else if(vm.tempNumber == 0 && (number == 0 || number == '00')){
                vm.tempNumber = '0.00';
            }
            if(vm.discountPriceType == 'percentage' && vm.tempNumber > 100){
                vm.tempNumber = '100.00';

            }
            vm.customDiscount.dicount_price = vm.tempNumber;
        }

        function getNumber(num){
            if(num <= 9){
                vm.number = parseInt(num)+ parseInt(1);
                return vm.number;
            }
        }

        /**
        * Restaurant code start
        */

        vm.getRestaurantAttributes = getRestaurantAttributes;
        vm.updateAddonList = updateAddonList;
        vm.calculateTotal = calculateTotal;
        vm.addRemove = addRemove;
        vm.updateIngredient = updateIngredient;
        // vm.checkingrediantStatus = checkingrediantStatus;
        
        function getRestaurantAttributes(){
            var temp = [];
            var selectedIds = [];


            angular.forEach(vm.freeOptions, function(value, key) {
                vm.freeOptions[key]['quantity'] = 1; 
                vm.freeOptions[key]['price'] = 0; 
                vm.selectedOptionIds.push(value['option_id']);
                vm.selectedOptions.push(value);               
            });

            if (vm.pizzaCatSelected) {
                for(i = 0; i < vm.cooking_preference.length; i++)   {
                    if (vm.pizzaType['sel_'+i] !== undefined && vm.pizzaType['sel_'+i] !== '') {
                        vm.cooking_preference[i].pizzaTypeSelected = vm.pizzaType['sel_'+i];
                    }
                }
            }
            
            product['selectedOptions'] = vm.selectedOptionIds;
            product['selectedValue'] = vm.selectedOptions;
            product['quantity'] = vm.resQuantity;
            product['selectedIngredientName'] = vm.selectedIngredientName;
            product['notSelectedIngredientName'] = vm.notSelectedIngredientName;
            product['customPrice'] = (vm.grandtotal/vm.resQuantity);
            product['particularCustomPrice'] = (vm.grandtotal/vm.resQuantity);
            product['addOnPrice'] = vm.extraAddon;
            product['restaurantNote'] = vm.restaurantNote !== undefined ? vm.restaurantNote : '';
            product['updateIndexValue'] = updateIndexValue;
            product['dropDownSelect'] = vm.dropDownSelect;
            product['cooking_preference'] = vm.cooking_preference;
            product['orderTakeOrEat'] = vm.orderTakeOrEat ? 'Eat in' : 'Take out';
            // $scope.$parent.calculateTotalForItemUpdate(product, 1);
            $scope.$parent.addTimeBoundProduct(product, vm.resQuantity, '', '','','');        
            $mdDialog.cancel();
        }        

        /**
        * add addons ingredients added
        */
        function updateAddonList(item, index, parentkey){
            if (parentkey !== undefined) {
                vm.multiChoiceArray[parentkey][index].highlighted = 1;
                if (vm.multiChoiceArray[parentkey][index].count !== undefined) {
                    vm.multiChoiceArray[parentkey][index].count += 1; 
                } else  {
                    vm.multiChoiceArray[parentkey][index].count = 1;
                }
            }

            item.parentkey = parentkey;
            item.childIndex = index;
            var index = vm.selectedOptionIds.indexOf(item['option_id']);
            if(index == -1) {
                addRemove(item,'add', -1);
            } else if(index != -1) {
                addRemove(item,'update', index);
            }
        }

        /**
        * select of single options from dropdown
        */
        
        vm.updateDropDowns = function(key) {
            if (key !== undefined ){
                vm.dropDownSelect['val_'+key].drowDownValue = 'val_'+key;
                if (vm.dropDownSelect['val_'+key] !== undefined && vm.dropDownSelect['val_'+key].price !== '0.00') {
                    if (vm.tempSelect.hasOwnProperty(['val_'+key])) {
                        for (var i = 0; i < vm.selectedOptions.length; i++){
                            if (vm.selectedOptions[i].drowDownValue !== undefined && vm.selectedOptions[i].drowDownValue === 'val_'+key) {
                                var tempIndex = vm.selectedOptionIds.indexOf(vm.dropDownSelect['val_'+key].option_id);
                                if (tempIndex > -1) {
                                    vm.selectedOptionIds.splice(tempIndex,1);
                                }
                                vm.selectedOptions.splice(i, 1);
                                break;
                            }
                        }                        
                        addRemove(vm.dropDownSelect['val_'+key], 'add', -1, 'val_'+key);                        
                    } else {   
                        addRemove(vm.dropDownSelect['val_'+key], 'add', -1, 'val_'+key);
                    }
                    vm.tempSelect['val_'+key] = vm.dropDownSelect['val_'+key];
                } else {
                    if (vm.tempFreeSelect.hasOwnProperty(['val_'+key])) {
                        for (var i = 0; i < vm.freeOptions.length; i++){
                            if (vm.freeOptions[i].drowDownValue !== undefined && vm.freeOptions[i].drowDownValue === 'val_'+key) {
                                vm.freeOptions.splice(i, 1);
                                break;
                            }
                        }
                        vm.freeOptions.push(vm.dropDownSelect['val_'+key]);
                    } else {
                        vm.freeOptions.push(vm.dropDownSelect['val_'+key]);
                    }
                    vm.tempFreeSelect['val_'+key] = vm.dropDownSelect['val_'+key];
                }
            }
        }     

        var cooking = {};
        /**
        * add or remove addons
        */
        function addRemove(item,status, index, saveValkey){
            if(status == 'add'){
                item['quantity'] = 1;
                vm.selectedOptionIds.push(item['option_id']);
                vm.selectedOptions.push(item);
                cooking = {};
                cooking = {
                    name : item.name,
                    cooking_preference: item.cooking_preference,
                    option_id: item.option_id,
                    saveValkey: saveValkey !== undefined ? saveValkey : '',
                    quantity: 1
                };

                if (saveValkey !== undefined && saveValkey !== '' && saveValkey !== 'notPushEditCase') {
                    checkIfCookingPrefExist(item, cooking, index, saveValkey);
                } else if (saveValkey !== 'notPushEditCase'){
                    checkCookingPreference(item, cooking, index);
                }                
            } else if(status == 'update'){
                vm.selectedOptions[index]['quantity'] = parseInt(vm.selectedOptions[index]['quantity']) + parseInt(1);
                vm.cooking_preference[index]['quantity'] = parseInt(vm.cooking_preference[index]['quantity']) + parseInt(1);
            } else if(status == 'remove'){                
                if(index != -1){
                    var selIvalue = '';
                    vm.cooking_preference.forEach(function(value, i){
                        if(value.option_id == vm.selectedOptions[index].option_id) {
                            vm.cooking_preference.splice(i,1);
                            selIvalue = i;
                        }
                    });

                    if (vm.cooking_preference.length && selIvalue !== '') {  // remove value of pizza type selected
                        var length = vm.cooking_preference.length + 1;
                        var incVal = 0;
                        for (var i = 0; i < length; i++) {
                            if (parseInt(selIvalue) <= i) {
                                incVal = parseInt(i + 1);
                                if (i !== vm.cooking_preference.length) {
                                    vm.pizzaType['sel_'+i] = vm.pizzaType['sel_'+incVal];
                                } else {
                                    delete vm.pizzaType['sel_'+i];
                                }
                            }
                        }
                    } else {
                        vm.pizzaType = [];
                    }
                    
                    if (item.drowDownValue !== undefined && item.drowDownValue !== '') { // check value is added from dropdown not multiselect
                        delete vm.dropDownSelect[item.drowDownValue];
                    } else {
                        vm.multiChoiceArray[item.parentkey][item.childIndex].count = 0; 
                        vm.multiChoiceArray[item.parentkey][item.childIndex].highlighted = 0; 
                    }

                    vm.selectedOptionIds.splice(index,1);
                    vm.selectedOptions.splice(index,1);
                } else if (index == -1) { // free option
                    if (item.drowDownValue !== undefined && item.drowDownValue !== '') { // check value is added from dropdown not multiselect
                        delete vm.dropDownSelect[item.drowDownValue];
                    }
                    index = vm.freeOptions.indexOf(item.option_id);
                    vm.freeOptions.splice(index,1);
                }
            }
            calculateTotal();
        }


        /**
        * check cooking_prefercenc
        */

        function checkCookingPreference(item, cooking, index) {
            if (vm.pizzaCatSelected) {  // pizza cat selected then all topings are added to array
                if(item.cooking_preference != undefined && item.cooking_preference == 1) {
                    cooking.selected_preference = 'rare';
                }
                vm.cooking_preference.push(cooking);
                index = vm.cooking_preference.length > 0 ? vm.cooking_preference.length - 1 : 0;
                vm.pizzaType['sel_'+index] = 'full';
            } else {
                if(item.cooking_preference != undefined && item.cooking_preference == 1) {
                    cooking.selected_preference = 'rare';
                }               
                    vm.cooking_preference.push(cooking);
            }
        }

        /**
        * check if cooking prefernce already exist
        */

        function checkIfCookingPrefExist(item, cooking, index, saveValkey ) {
            if (vm.cooking_preference.length) {
                var length = vm.cooking_preference.length;
                for (var i = 0; i < length; i++){
                    if (vm.cooking_preference[i].saveValkey !== undefined && vm.cooking_preference[i].saveValkey === saveValkey) {
                        vm.cooking_preference.splice(i, 1);
                        break;
                    }
                }
                addCookingPref(item, cooking)
            } else {
                addCookingPref(item, cooking);
            }
        }

        /**
        * add cooking prefernce in array
        */
        function addCookingPref(item, cooking) {
            if (vm.pizzaCatSelected) {  // pizza cat selected then all topings are added to array
                if(item.cooking_preference != undefined && item.cooking_preference == 1) {
                    cooking.selected_preference = 'rare';
                }
                vm.cooking_preference.push(cooking);
                var index = vm.cooking_preference.length > 0 ? vm.cooking_preference.length - 1 : 0;
                vm.pizzaType['sel_'+index] = 'full';
            } else {
                if(item.cooking_preference != undefined && item.cooking_preference == 1) {
                    cooking.selected_preference = 'rare';
                }               
                    vm.cooking_preference.push(cooking);
            }
            calculateTotal();
        }

        vm.grandtotal = vm.product['product_price'];
        vm.extraAddon = 0;
        vm.freeSelectedIds = '';
        function calculateTotal(){
            vm.grandtotal = 0;
            vm.extraAddon = 0;            

            angular.forEach(vm.selectedOptions, function(element, index){
                vm.extraAddon += (parseFloat(element.price) * parseFloat(element.quantity));
            });

            vm.grandtotal = vm.resQuantity * (parseFloat(vm.product['product_price']) + parseFloat(vm.extraAddon));
        }


        /**
        * params: string  type
        * change product quantity
        */
        vm.changeMainQuantity = function(type) {
            vm.resQuantity = parseInt(vm.resQuantity);
            if (type === 'subtract' && vm.resQuantity > 1) {
                vm.resQuantity = vm.resQuantity - 1;
            } else if (type === 'add') {
                vm.resQuantity = vm.resQuantity + 1;
            }
            calculateTotal();
        }

       
        function updateIngredient(data, indexValue){
            var index = vm.selectedIngredient.indexOf(data.ingredient_id);
            var removeIndex = vm.notSelectedIngredient.indexOf(data.ingredient_id);
            if(index > -1){
                vm.selectedIngredient.splice(index, 1);
                vm.selectedIngredientName.splice(index, 1);
                vm.ingredients[indexValue].selected = 0;

                vm.notSelectedIngredient.push(data.ingredient_id);
                vm.notSelectedIngredientName.push(data.ingredient_name);
            }else{
                vm.selectedIngredient.push(data.ingredient_id);
                vm.selectedIngredientName.push(data.ingredient_name);
                vm.ingredients[indexValue].selected = 1;

                vm.notSelectedIngredient.splice(removeIndex, 1);
                vm.notSelectedIngredientName.splice(removeIndex, 1);
            }
        }
    }
})();
'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../mls/mlsService
 * @description
 * # ../mls/mlsService
 * Service in the minervaApp.
 */
angular.module('app.checkout')
  .service('checkoutService', function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
 	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}

 	function getCheckoutCategory(typeofService, happyHours, category){
		var data = {typeofService:typeofService, happy_hours:happyHours};
		if(category != undefined && category != '' ) {
			data.category = category;
		}
		return $http({
			url		:EnvironmentConfig.api+'Checkout/skipAcl_getAllCategory',
			method	:'POST',
			data	:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getRelatedProducts(data){
		return $http({
			url		:EnvironmentConfig.api+'Checkout/skipAcl_getAllRelatedProduct',
			method	:'POST',
			data 	:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function changeStatus(data){
		return $http({
			url		:EnvironmentConfig.api+'Checkout/change_status',
			method	:'POST',
			data 	:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getFilteredProducts(data){
		return $http({
			url		:EnvironmentConfig.api+'Checkout/skipAcl_getFilteredProducts',
			method	:'POST',
			data 	:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getTax(){
		return $http({
			url		:EnvironmentConfig.api+'Checkout/skipAcl_getTax',
			method	:'GET',
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getCurrentCustomers(){
		return $http({
			url		:EnvironmentConfig.api+'Checkout/skipAcl_getCurrentCustomers',
			method	:'GET',
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getCardDetails(data){
		return $http({
			url		:EnvironmentConfig.api+'Checkout/skipAcl_getCardDetails',
			method	:'POST',
			data  	:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getReservedUsers(data){
		return $http({
			url		:EnvironmentConfig.api+'Checkout/skipAcl_getReservedUsers',
			method	:'POST',
			data  	:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getGiftCards(){
		return $http({
			url		:EnvironmentConfig.api+'Checkout/skipAcl_getGiftCardItem',
			method	:'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function addTabOrder(data){
		return $http({
			url 	: EnvironmentConfig.api + 'Tabpos/add_tabpos',
			method	: 'POST',
			data	: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getTabOrder(){
		return $http({
			url		: EnvironmentConfig.api + 'Tabpos/getTabOrder',
			method 	: 'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function renameTabOrderName(data){
		return $http({
			url 		: EnvironmentConfig.api + 'Tabpos/renameTabOrder',
			method 		: 'POST',
			data 		: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);

	}
	function deleteTabOrder(data){
		return $http({
			url 		: EnvironmentConfig.api + 'Tabpos/deleteTabOrder',
			method 		: 'POST',
			data 		: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getOrderInfo(data){
		return $http({
			url 		: EnvironmentConfig.api + 'Checkout/getOrderInfo',
			method 		: 'POST',
			data 		: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function updateTabPos(data){
		return $http({
			url 		: EnvironmentConfig.api + 'Tabpos/updateTabPos',
			method 		: 'POST',
			data 		: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function sendMailToCust(data){
		return $http({
			url 		: EnvironmentConfig.api + 'Checkout/sendMailToCust',
			method 		: 'POST',
			data 		: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function printInvoice(data){
		return $http({
			url 		: EnvironmentConfig.api + 'Checkout/printInvoice',
			method 		: 'POST',
			data 		: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function setTabStatusToActive(data){
		return $http({
			url 		: EnvironmentConfig.api + 'Tabpos/setTabStatusToActive',
			method 		: 'POST',
			data 		: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function setTabStatusToInactive(data){
		return $http({
			url 		: EnvironmentConfig.api + 'Tabpos/setTabStatusToInactive',
			method 		: 'POST',
			data 		: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getPosReport(data){
		return $http({
			url 		: EnvironmentConfig.api + 'Tabreport/getPosReport',
			method 		: 'POST',
			data 		: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function saveCurrentReport(data){
		return $http({
			url 		: EnvironmentConfig.api + 'Tabreport/saveCurrentReport',
			method 		: 'POST',
			data 		: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function printOrder(data){
		return $http({
			url 		: EnvironmentConfig.api + 'Tabreport/printOrder',
			method 		: 'POST',
			data 		: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getUsers(){
		return $http({
			url 		: EnvironmentConfig.api + 'Reports/getUsers',
			method 		: 'GET'
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getTipReport(responseData){
		return $http({
			url 		: EnvironmentConfig.api + 'Tabreport/getTipReport',
			method 		: 'POST',
			data 		: responseData
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function modifyBarOrder(data){
		return $http({
			url 		: EnvironmentConfig.api + 'Checkout/modify_bar_order',
			method 		: 'POST',
			data 		: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function payPosInstallments(data){
		return $http({
			url 		: EnvironmentConfig.api + 'Checkout/pay_pos_installments',
			method 		: 'POST',
			data 		: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function customPosRefundInstallment(data){
		return $http({
			url 		: EnvironmentConfig.api + 'Checkout/custom_refund_pos_installment',
			method 		: 'POST',
			data 		: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function changeDatesForParking(data){
		return $http({
			url 		: EnvironmentConfig.api + 'Checkout/change_dates_for_parking',
			method 		: 'POST',
			data 		: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	/**
	* @params: integer  productId
	* method: GET
	* used to fetch product ingrediants
	*/
	function getRestaurantIngrediants(productId) {
		return $http({
			url: EnvironmentConfig.api + 'checkout/restaurant_ingrediants/'+productId,
			method: 'GET',
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function printCookOrder(data){
		return $http({
			url 		: EnvironmentConfig.api + 'Checkout/print_cooks_order',
			method 		: 'POST',
			data 		: data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function download_data_request(data) {
 		return $http({
 			url:EnvironmentConfig.api+'Reports/download_data_request',
 			method:'POST',
 			responseType: 'blob',
 			data:data
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);
 	}
 	
 	function cleanDisk(data) {
 		return $http({
 			url:EnvironmentConfig.api+'Reports/remove_file',
 			method:'POST',
 			data:data
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);
 	}

 	function processAutomaticRefund(data) {
 		return $http({
 			url:EnvironmentConfig.api+'Checkout/processAutomaticRefund',
 			method:'POST',
 			data:data
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);
 	}

 	return{
	 		sendMailToCust 				: sendMailToCust,
	 		getCheckoutCategory 		: getCheckoutCategory,
	 		getOrderInfo	 			: getOrderInfo,
	 		getRelatedProducts 			: getRelatedProducts,
	 		getFilteredProducts 		: getFilteredProducts,
	 		getTax 						: getTax,
	 		getCurrentCustomers 		: getCurrentCustomers,
	 		getCardDetails 				: getCardDetails,
			getReservedUsers 			: getReservedUsers,
			getGiftCards 				: getGiftCards,
			addTabOrder 				: addTabOrder,
			getTabOrder 				: getTabOrder,
			renameTabOrderName			: renameTabOrderName,
			deleteTabOrder 				: deleteTabOrder,
			updateTabPos				: updateTabPos,
			printInvoice				: printInvoice,
			setTabStatusToActive		: setTabStatusToActive,
			getPosReport				: getPosReport,
			setTabStatusToInactive		: setTabStatusToInactive,
			printOrder 					: printOrder,
			saveCurrentReport			: saveCurrentReport,
			getUsers					: getUsers,
			changeStatus				: changeStatus,
			modifyBarOrder				: modifyBarOrder,
			payPosInstallments			: payPosInstallments,
			customPosRefundInstallment	: customPosRefundInstallment,
			changeDatesForParking 		: changeDatesForParking,
			getTipReport				: getTipReport,
			getRestaurantIngrediants    : getRestaurantIngrediants,
			printCookOrder 				: printCookOrder,
			download_data_request       : download_data_request,
			cleanDisk                   : cleanDisk,
			processAutomaticRefund      : processAutomaticRefund
 	}
 });

(function() {
    'use strict';

    angular
        .module('app.checkout')
        .controller('checkoutController', checkoutController);

    /** @ngInject */
    function checkoutController(
        productData,
        checkoutService,
        $timeout,
        $scope,
        $mdDialog,
        $document,
        $q,
        $sessionStorage,
        $rootScope,
        $localStorage,
        $translate,
        EnvironmentConfig,
        commonService,
        eCommerceService,
        createResService,
        toastMessage,
        $state,
        $stateParams,
        $location,
        userService,
        commonDailog,
        $filter,
        $anchorScroll
    ) {
        var vm = this;
        vm.category = null;
        vm.productCategory = null;
        vm.showCatNav = false;
        vm.categoryRelatedProducts = [];
        vm.cartItem = [];
        vm.cartItemIds = [];
        vm.search = '';
        vm.itinerary_number = '';
        vm.selectedCat = 'All Categories';
        vm.webpos_one_go_order_number = '';
        vm.subTotal = 0.00;
        vm.expectedChangeForPrint = 0;
        vm.iamactive = 'no';
        vm.paymentType = 'creditcard';
        vm.customerCardDetails = {};
        vm.creditCard = {};
        vm.payment_method = {};
        vm.payment_method[0] = {};
        vm.waiveCcProcessingFee = false;
        vm.search = 'Search';
        vm.tempDiscountAmount = 0.00;
        vm.tempDisCountType = 'percentage';
        vm.resDetails = {};
        vm.resDetails = $stateParams;
        vm.pageFrom = $stateParams.pageFrom;
        vm.title = 'Checkout';
        vm.happy_hours = false;
        vm.autoFillOff = true;
        // vm.selectedPosType = 'retail';
        var staticRestValue = 'restaurant';

        var nameChange = 'Retail';
        if($localStorage.preHotelId !== undefined && $localStorage.preHotelId === '126' && vm.resDetails.typeofService == 'bar') {
            nameChange = 'Food & Drinks Checkout';
        } else if($localStorage.preHotelId !== undefined && $localStorage.preHotelId === '126') {
            nameChange = 'Gift Shop';
        } else {
            nameChange = 'Retail';
        }

        $rootScope.siteTitle = nameChange + ' - LodgingSystem';
        vm.selectedPosType = vm.resDetails.typeofService;

        if (vm.resDetails.typeofService === 'bar') {
            vm.title = 'Bar Checkout';
        } else if (vm.resDetails.typeofService === staticRestValue) {
            vm.title = 'Restaurant Checkout';
        }
        checkoutService.getUsers().then(function(response) {
            if (response['success']) {
                vm.allUsers = response['cashier'];
                tipToWhomName();
            }
        });

        if(typeof $localStorage[vm.resDetails['typeofService'] + $localStorage['preHotelId']] != 'undefined' && $localStorage[vm.resDetails['typeofService'] + $localStorage['preHotelId']]){
           vm.happy_hours =  $localStorage[vm.resDetails['typeofService'] + $localStorage['preHotelId']]?true:false;
        }
        
        if( typeof $localStorage["postype" + $localStorage['preHotelId']] != 'undefined' && $localStorage["postype" + $localStorage['preHotelId']] != '' && (vm.selectedPosType == 'restaurant' || vm.selectedPosType == 'bar') ) {
            vm.selectedPosType = $localStorage["postype" + $localStorage['preHotelId']];
        }

        if( typeof $localStorage["category-" + vm.selectedPosType + $localStorage['preHotelId']] != 'undefined' && Object.keys($localStorage["category-" + vm.selectedPosType + $localStorage['preHotelId']]).length > 0 && $localStorage["category-" + vm.selectedPosType + $localStorage['preHotelId']].category != 0 ) {
            vm.category = $localStorage["category-" + vm.selectedPosType + $localStorage['preHotelId']].category;
            vm.selectedCat = $localStorage["category-" + vm.selectedPosType + $localStorage['preHotelId']].cat_name;
        }

        vm.loggedInUserId = $localStorage.userId;
        if (vm.resDetails.showaddDialog) {
            $timeout(function() {
                angular.element('#add_Gift_Card').trigger('click');
            }, 100);
        }
        
        if ($stateParams.addServiceForRoom && vm.resDetails.policy_id == 3)
            vm.posDepositTypeIndicator = 'full';
        else {
            if (typeof productData['minimumPaymentType']['paymentType'][0] != 'undefined') {
                vm.posDepositTypeIndicator = productData['minimumPaymentType']['paymentType'][0]['pos_deposit_type_indicator'];
            } else {
                vm.posDepositTypeIndicator = 'full';
            }
        }

        $rootScope.isDiscountApplied = false;
        var discountDetails = $localStorage['cartDiscount_' + $localStorage['preHotelId']];
        if(typeof discountDetails != 'undefined' && typeof discountDetails.discount_type != 'undefined' && discountDetails.hasOwnProperty('discount_type'))
            $rootScope.isDiscountApplied = true;
            

        var userPermissions = [];
        vm.parking_access = false;
        if (typeof $rootScope.userPermissions != 'undefined') {
            userPermissions = $rootScope.userPermissions;
            if (userPermissions.indexOf('timebound_parking') != -1) {
                vm.parking_access = true;
            }            
        }

        vm.showHappyHourButton = false;
        vm.showCooksPreview = false;
        if($localStorage['preHotelId'] !== undefined && $localStorage['preHotelId'] == 126){
            vm.buttonTitle = 'Finalize';
            vm.showHappyHourButton = true;
            vm.showCooksPreview = true;
        } else {
            vm.buttonTitle = 'Create Order';
        }

        vm.isloading = false;
        vm.category = 0;
        vm.baseUrl = EnvironmentConfig.api;
        vm.checkoutPage = false;
        vm.afterCreatePage = false;
        vm.customerDetails = null;
        vm.selectedCard = 0;
        vm.order = [];
        vm.isUserSelected = false;
        vm.pageStatus = 'Service';
        
        vm.cartDetails = {};
        vm.dates_option = EnvironmentConfig.cc_dates_option;
        vm.yrs_option = commonService.calculateExpirationYears();

        vm.tax = {};
        vm.overAllTax = 0;

        vm.categoryRelatedProducts = productData['products'];
        vm.currentPage = 'bar-checkout';
        vm.TipProductIndex = [];

        vm.previouspos = {};
        vm.previousOverAllTotal = {};
        /*get the current customers in the hotel*/
        vm.defaultCustomer = {};
        var defCustObject = {};
        checkoutService.getCurrentCustomers().then(function(response) {
            if (response['customers']['success']) {
                vm.allCurentCustomers = response['customers']['customers'];
                vm.all_payment_methods = response['payment_methods'];
                vm.all_payment_methods.forEach(function(element, index) {
                    if (element.heading == 'Cash') vm.all_payment_methods[index]['class'] = 'cash_pm';
                    else if (element.heading == 'Check') vm.all_payment_methods[index]['class'] = 'cheque_pm';
                    else if (element.heading == 'Credit Card') vm.all_payment_methods[index]['class'] = 'credit-card_pm';
                    else if (element.heading == 'E-Check') vm.all_payment_methods[index]['class'] = 'e-check_pm'; 
                    else vm.all_payment_methods[index]['class'] = '';

                });
                vm.allowed_card_types = response['allowed_card_types'];
                vm.defaultCustomer = response['defaultCustomer'][0];
                defCustObject = angular.copy(response['defaultCustomer'][0]);
                if ($stateParams.addServiceForRoom && vm.resDetails.policy_id == 3)
                    vm.posDepositTypeIndicator = 'full';
                else
                    vm.posDepositTypeIndicator = response['minimumPaymentType']['paymentType'][0]['pos_deposit_type_indicator'];
            } else {
                vm.allCurentCustomers = [];
                vm.all_payment_methods = [];
            }
        });
        /*check if request come from create reservation*/
        vm.showComent = true;
        vm.taxStatus = angular.copy(vm.resDetails['taxValue']);
        if ($stateParams.addServiceForRoom) {
            vm.sessionCartItems = {};
            if ($stateParams.product_id == '') {
                removeCart();
                vm.resDetails = $sessionStorage['pageDetails_' + $localStorage['preHotelId']];
            }
            if (vm.resDetails['pageFrom'] == 'reservation') {
                removeCart();
                vm.currentPage = 'reservation';
                vm.sessionCartItems = angular.copy($sessionStorage['cartDetails_' + $localStorage['preHotelId']]);
                vm.showComent = false;
            } else if (vm.resDetails['pageFrom'] === 'order') {
                vm.sessionCartItems = {};
                vm.currentPage = 'order';
                $sessionStorage['barItem_' + $localStorage['preHotelId']] = '';
            } else if (vm.resDetails['pageFrom'] === staticRestValue) {
                vm.sessionCartItems = {};
                vm.currentPage = staticRestValue;
                $sessionStorage['restaurantItem_' + $localStorage['preHotelId']] = '';
            }

            if (typeof vm.sessionCartItems[vm.resDetails['cartIndex']] != 'undefined' && typeof vm.sessionCartItems[vm.resDetails['cartIndex']]['pos'] != 'undefined') {
                vm.cartItem = angular.copy(vm.sessionCartItems[vm.resDetails['cartIndex']]['pos']);
            } else {
                vm.cartItem = [];
            }
            calculateTotal();
            var posPresent = (angular.equals([], vm.cartItem));
            if (!posPresent && typeof vm.cartItem != 'undefined' && !angular.equals({}, vm.cartItem)) {
                vm.cartItem.forEach(function(element, index) {
                    vm.cartItemIds.push(element.product_id);
                });
                calculateTotal();
                var resCartItem = angular.copy(vm.sessionCartItems[vm.resDetails['cartIndex']]['overalltotals']);
                vm.previousOverAllTotal = angular.copy(resCartItem);
                vm.previouspos = angular.copy(vm.sessionCartItems[vm.resDetails['cartIndex']]['pos']);
                if(isNaN(vm.CartSubTotal['deposit_amount'])) {
                    vm.CartSubTotal['deposit_amount'] = 0.00;
                }
                if(isNaN(vm.CartSubTotal['remaining_amount'])) {
                    vm.CartSubTotal['remaining_amount'] = 0.00;
                }
                if(isNaN(vm.CartSubTotal['discount'])) {
                    vm.CartSubTotal['discount'] = 0.00;
                }

                resCartItem['deposit_amount'] = commonService.roundnum((parseFloat(resCartItem['deposit_amount']) - parseFloat(vm.CartSubTotal['deposit_amount'])), 2);
                resCartItem['discount'] = commonService.roundnum((parseFloat(resCartItem['discount']) - parseFloat(vm.CartSubTotal['discount'])), 2);
                resCartItem['grand_total'] = commonService.roundnum((parseFloat(resCartItem['grand_total']) - parseFloat(vm.CartSubTotal['grand_total'])), 2);
                resCartItem['remaining_amount'] = commonService.roundnum((parseFloat(resCartItem['remaining_amount']) - parseFloat(vm.CartSubTotal['remaining_amount'])), 2);
                resCartItem['subtotal'] = commonService.roundnum((parseFloat(resCartItem['subtotal']) - parseFloat(vm.CartSubTotal['subtotal'])), 2);
                resCartItem['tax'] = commonService.roundnum((parseFloat(resCartItem['tax']) - parseFloat(vm.CartSubTotal['tax'])), 2);
                vm.sessionCartItems[vm.resDetails['cartIndex']]['overalltotals'] = angular.copy(resCartItem);
            }
            vm.addToRoomNumber = resolveAddToRoomNumber();
        }

        function resolveAddToRoomNumber() {
            var details = vm.resDetails || {};
            var roomNumber = details.product_room_number || '';
            var cartRoom;
            var savedOrder;
            var matchedOrder;

            if (!roomNumber && details.pageFrom === 'reservation' && vm.sessionCartItems && vm.sessionCartItems[details.cartIndex]) {
                cartRoom = vm.sessionCartItems[details.cartIndex].product_room_number;
                if (cartRoom) {
                    roomNumber = cartRoom;
                }
            }

            savedOrder = $sessionStorage['editReservationOrder'];
            if (!roomNumber && savedOrder) {
                if (!angular.isArray(savedOrder)) {
                    roomNumber = savedOrder.product_room_number || '';
                } else {
                    savedOrder.forEach(function(row) {
                        if (!matchedOrder && details.confirmation_number && String(row.confirmation_number) === String(details.confirmation_number)) {
                            matchedOrder = row;
                        }
                    });
                    if (!matchedOrder && savedOrder.length === 1) {
                        matchedOrder = savedOrder[0];
                    }
                    if (matchedOrder && matchedOrder.product_room_number) {
                        roomNumber = matchedOrder.product_room_number;
                    }
                }
            }

            if (!roomNumber && details.product_name && details.product_name.indexOf(',') !== -1) {
                var nameParts = details.product_name.split(',');
                var lastPart = (nameParts[nameParts.length - 1] || '').replace(/^\s+|\s+$/g, '');
                if (lastPart && lastPart.length <= 12 && lastPart.indexOf(' ') === -1 && /[0-9]/.test(lastPart)) {
                    roomNumber = lastPart;
                }
            }

            return roomNumber;
        }

        /*-----*/
        vm.productCategory = productData['category'];
        /*Pagination variable*/
        vm.totalProduct = productData['totalProducts'];
        vm.dataPerPage = productData['dataPerPage'];
        vm.totalPosTypes = productData['total_pos_types'];
        vm.curPage = 1;

        /*Get tax value*/
        checkoutService.getTax().then(function(response) {
            if (response['tax']['success']) {
                vm.tax = response['tax']['tax'];
            }
        });
        vm.all_payment_methods = [];
        /*Get tax value*/
        if (vm.resDetails.typeofService == 'bar') {
            if ($localStorage['barUser+' + $localStorage['preHotelId']]) {
                vm.customerDetails = $localStorage['barUser+' + $localStorage['preHotelId']];
            }
        } else {
            if ($sessionStorage['selectedUser_' + $localStorage['preHotelId']]) {
                vm.customerDetails = $sessionStorage['selectedUser_' + $localStorage['preHotelId']];
            }
        }

        /*get the current customers in the hotel*/
        vm.cardType = [{
            'name': 'American Express',
            'value': 'American_Express'
        }, {
            'name': 'Visa',
            'value': 'Visa'
        }, {
            'name': 'MasterCard',
            'value': 'MasterCard'
        }, {
            'name': 'Discover',
            'value': 'Discover'
        }];
        vm.tempDisablePrint = false;
        vm.add_tip_to_order = false;
       
        if ((vm.resDetails.typeofService === 'bar' && $localStorage['barItem_' + $localStorage['preHotelId']]) || (vm.resDetails.typeofService === 'retail' && $sessionStorage['barItem_' + $localStorage['preHotelId']]) || (vm.resDetails.typeofService === staticRestValue && $sessionStorage['restaurantItem_' + $localStorage['preHotelId']])) {
            $timeout(function() {
                vm.cartItemIds = [];                
                if (vm.resDetails.typeofService == 'bar') {
                    if ($sessionStorage.TipProductIndex) {
                        vm.TipProductIndex = $sessionStorage.TipProductIndex;
                    }
                    
                    vm.cartItem = $localStorage['barItem_' + $localStorage['preHotelId']];
                    if (vm.cartItem.length > 0) {
                        joinQuantities();
                    }
                    if ($sessionStorage['unset_all_var_' + $localStorage['preHotelId']]) {
                        removeCart();
                    }
                    if ($sessionStorage.add_tip_to_order) {
                        vm.tempDisablePrint = true;
                        $sessionStorage['unset_all_var_' + $localStorage['preHotelId']] = true;
                        vm.add_tip_to_order = true;
                        vm.add_tip_to_grand_total = $sessionStorage.add_tip_to_grand_total;
                        vm.add_tip_to_itinerary = $sessionStorage.add_tip_to_itinerary;
                        vm.add_tip_to_room_conf = $sessionStorage.add_tip_to_room_conf;
                        vm.add_tip_to_one_go_id = $sessionStorage['webpos_one_go_order_number_' + $localStorage['preHotelId']];
                        vm.add_tip_to_method = $sessionStorage.add_tip_to_method;
                        vm.goToCheckout();
                        $timeout(function() {
                            vm.payment_method = [];
                            vm.payment_method[0] = {};
                            vm.payment_method[0].method = vm.add_tip_to_method.payment_method;

                            if (vm.payment_method[0].method == 'Credit Card') {
                                vm.ct = vm.add_tip_to_method.cc_type;
                                vm.order.allcardsInfo = [];
                                vm.order.allcardsInfo[0] = angular.copy(vm.add_tip_to_method);
                                vm.order.allcardsInfo[0].method = vm.add_tip_to_method.payment_method;
                                vm.isUserSelecte = true;
                                vm.fieldsIsReadOnly = false;
                                if (vm.order.allcardsInfo.length > 0) {
                                    vm.payment_method[0] = vm.order.allcardsInfo[0];
                                    if (vm.order.allcardsInfo[0].cc_number != '') {
                                        vm.fieldsIsReadOnly = true;
                                        vm.use_existingcard = 0;
                                    }
                                }
                            }

                            var myEl = angular.element(document.querySelector('#selectInHouseCustomer'));
                            myEl.removeClass('open');

                            var myEl = angular.element(document.querySelector('#MyPaymentMethod'));
                            myEl.addClass('open');

                            angular.element('#selectInHouseCustomer').css('pointer-events', 'none');
                            angular.element('#SelectedItenararyNo').css('pointer-events', 'none');
                        }, 0);
                    }
                } else if (vm.resDetails.typeofService === staticRestValue) {
                    if ($sessionStorage.TipProductIndex) {
                        vm.TipProductIndex = $sessionStorage.TipProductIndex;
                    }
                    vm.cartItem = $sessionStorage['restaurantItem_' + $localStorage['preHotelId']];
                    if (vm.cartItem.length > 0) {
                        joinQuantities();
                    }
                    if ($sessionStorage['unset_all_var_' + $localStorage['preHotelId']]) {
                        removeCart();
                    }
                    if ($sessionStorage.add_tip_to_order) {
                        vm.tempDisablePrint = true;
                        $sessionStorage['unset_all_var_' + $localStorage['preHotelId']] = true;
                        vm.add_tip_to_order = true;
                        vm.add_tip_to_grand_total = $sessionStorage.add_tip_to_grand_total;
                        vm.add_tip_to_itinerary = $sessionStorage.add_tip_to_itinerary;
                        vm.add_tip_to_room_conf = $sessionStorage.add_tip_to_room_conf;
                        vm.add_tip_to_one_go_id = $sessionStorage['webpos_one_go_order_number_' + $localStorage['preHotelId']];
                        vm.add_tip_to_method = $sessionStorage.add_tip_to_method;
                        vm.goToCheckout();
                        $timeout(function() {
                            vm.payment_method = [];
                            vm.payment_method[0] = {};
                            vm.payment_method[0].method = vm.add_tip_to_method.payment_method;

                            if (vm.payment_method[0].method == 'Credit Card') {
                                vm.ct = vm.add_tip_to_method.cc_type;
                                vm.order.allcardsInfo = [];
                                vm.order.allcardsInfo[0] = angular.copy(vm.add_tip_to_method);
                                vm.order.allcardsInfo[0].method = vm.add_tip_to_method.payment_method;
                                vm.isUserSelecte = true;
                                vm.fieldsIsReadOnly = false;
                                if (vm.order.allcardsInfo.length > 0) {
                                    vm.payment_method[0] = vm.order.allcardsInfo[0];
                                    if (vm.order.allcardsInfo[0].cc_number != '') {
                                        vm.fieldsIsReadOnly = true;
                                        vm.use_existingcard = 0;
                                    }
                                }
                            }

                            var myEl = angular.element(document.querySelector('#selectInHouseCustomer'));
                            myEl.removeClass('open');

                            var myEl = angular.element(document.querySelector('#MyPaymentMethod'));
                            myEl.addClass('open');

                            angular.element('#selectInHouseCustomer').css('pointer-events', 'none');
                            angular.element('#SelectedItenararyNo').css('pointer-events', 'none');
                        }, 0);
                    }                    
                } else {
                    vm.cartItem = $sessionStorage['barItem_' + $localStorage['preHotelId']];
                }
                
                vm.cartItem.forEach(function(element, index) {
                    vm.cartItemIds.push(element.product_id);
                });

                calculateTotal();
            }, 200);
        }
        /*Functions*/
        vm.switchPage = switchPage;
        vm.selectCategory = selectCategory;
        vm.addToCart = addToCart;
        vm.removeCartItem = removeCartItem;
        vm.updateItem = updateItem;
        vm.calculateTotal = calculateTotal;
        vm.checkifNeedToDeleteTip = checkifNeedToDeleteTip;
        vm.removeCart = removeCart;
        vm.addNote = addNote;
         vm.openCustomProductPopUp = openCustomProductPopUp;
        vm.getCustomerCardDetails = getCustomerCardDetails;
        vm.changePaymentMethod = changePaymentMethod;
        vm.checkValidExpDate = checkValidExpDate;
        vm.addCardDetails = addCardDetails;
        vm.removeSearchText = removeSearchText;
        vm.addProductToCart = addProductToCart;
        vm.getDaterange = getDaterange;
        vm.getAllCustomers = getAllCustomers;
        vm.addCustomDiscount = addCustomDiscount;
        vm.goToCheckout = goToCheckout;
        vm.getAllFilteredProduct = getAllFilteredProduct;
        vm.fetchPaymentsInformation = fetchPaymentsInformation;
        vm.emptythisPayment = emptythisPayment;
        vm.changeActiveCard11 = changeActiveCard11;
        vm.validateGCCode = validateGCCode;
        vm.queryCustomerSearch = queryCustomerSearch;
        vm.selectedItemChange = selectedItemChange;
        vm.proceedToCheckout = proceedToCheckout;
        vm.creditCardChanged = creditCardChanged;
        vm.closePayment = closePayment;
        vm.gotoReservation = gotoReservation;
        vm.gotoPosOrder = gotoPosOrder;
        vm.gotoRevservationPage = gotoRevservationPage;
        vm.updateSession = updateSession;
        vm.applytipfinal = applytipfinal;
        vm.removetip = removetip;
        vm.openOnlyAmtDialog = openOnlyAmtDialog;
        vm.addRoundUpForCharity = addRoundUpForCharity;
        vm.getCharityRoundUpAmount = getCharityRoundUpAmount;
        vm.isRoundUpEnable = isRoundUpEnable;
        vm.startNewOrder = startNewOrder;
        vm.continueSplitOrder = continueSplitOrder;
        vm.sendEmailToCustomer = sendEmailToCustomer;
        vm.tipToWhomName = tipToWhomName;
        vm.deleteCustomer = deleteCustomer;


        /*Initialize tab session storage*/
        if (typeof $sessionStorage.tabOrder == 'undefined' || !$sessionStorage.tabOrder) {
            $sessionStorage['tabOrder'] = [];
            /*get product from db*/
        }

        /* set tab order name*/
        vm.tabName = '';
        $scope.getTabName = function(name) {
            vm.tabName = name;

        }
        /*Set tab session data*/

        /*Add Random products for testing*/
        vm.addRandomProducts = function() {
            var myDate = new Date();
            var time = myDate.getTime() + "";
            var productData = {
                customDiscount: 0.00,
                customPrice: 0.00,
                media: "1500699310dcc.png",
                product_id: time,
                product_is_timebound: "0",
                product_name: 'dynamic_name',
                product_price: 10,
                product_type: "pos",
                quantity: 1,
                tax_value: 0.00,
                tax_name: '',
                total: 0.00,
                tax_id: "",
                product_discount: 0.00
            };
            for (var i = 0; i < 40; i++) {
                productData['product_name'] = 'product_' + i;
                productData['product_id'] = time + i;
                $scope.addCustomProductToCart(productData);
            }

        }

        // vm.addRandomProducts();

        /*add order to tab*/

        vm.tabOrder = function() {
            if(vm.cartItem.length == 0){
                // toastMessage.showSimpleToast('Please add some items to proceed.', 'error-toast');

                var html = 'Please add some products in the cart to continue.</br>';
                 html = html + '<b>Or you can view tab orders.</b>';
              
                $mdDialog.show({
                              controller: 'confirmController',
                              controllerAs: 'vm',
                              templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                              parent: angular.element(document.body),
                              targetEvent: event,
                              clickOutsideToClose:true ,
                              locals: {
                                    title: 'Add Product.',
                                    htmlContent:html,
                                    cancelBtn:'Continue',
                                    OkBtn:'View Tab Orders'
                                }                
                            })
                            .then(function(answer) {
                               if(typeof answer != 'undefined' && answer == 'update'){
                                $state.go('app.tab-order');
                               }
                            }, function() {});
            
                return;
            }
            vm.tabName = '';
            var event = '';
            var total = 0;
            var Products = '';
            var posTotalDepositAmount = 0;
            var posTotalRemainingAmount = 0;
            vm.cartItem.forEach(function(element, index) {
                total = parseFloat(total) + parseFloat(element['grand_total']);
                posTotalDepositAmount = parseFloat(posTotalDepositAmount) + parseFloat(element['pos_deposit_amount']);
                posTotalRemainingAmount = parseFloat(posTotalRemainingAmount) + parseFloat(element['remaining_amount']);
                if (index == 0) {
                    Products = element['product_name'];
                } else {
                    Products = Products + ', ' + element['product_name'];
                }
            });
            posTotalDepositAmount = $filter('number')(posTotalDepositAmount, 2);
            posTotalRemainingAmount = $filter('number')(posTotalRemainingAmount, 2);
            var customer_details = '';
            if (vm.customerDetails = null) {
                customer_details = vm.defaultCustomer;
            } else {
                customer_details = vm.customerDetails;
            }
            var dt = new Date();
            if (typeof $localStorage['currentTabDetails'] != 'undefined' && $localStorage['currentTabDetails'] != '') {
                vm.isloading = true;
                var data = {
                    'cart_id': $localStorage['currentTabDetails'],
                    'cartData': vm.cartItem,
                    'customer': customer_details,
                }
                checkoutService.updateTabPos(data).then(function(response) {
                    vm.isloading = false;
                    removeCart();
                });
            } else {
                $mdDialog.show({
                    controller: 'cartProductUpdate',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/checkout/dialog/tabOrderName.html',
                    parent: angular.element($document.find('#content-container')),
                    targetEvent: event,
                    scope: $scope.$new(),
                    clickOutsideToClose: true,
                    onRemoving: function() {
                        if (vm.tabName != '') {
                            vm.isloading = true;
                            /*get the product name and grand total*/
                            total = $filter('currency')(total, '$', 2);
                            var tabOrder = {
                                tabId: '#' + dt.getTime(),
                                product_name: Products,
                                total: total,
                                OrderTime: dt.toLocaleTimeString(),
                                name: vm.tabName,
                                cartData: vm.cartItem,
                                customer: customer_details,
                                total_deposit_amount: posTotalDepositAmount,
                                total_remaining_amount: posTotalRemainingAmount
                            };

                            var tabData = {
                                cartData: vm.cartItem,
                                customer: customer_details,
                                name: vm.tabName
                            };
                            checkoutService.addTabOrder(tabOrder).then(function(response) {
                                vm.isloading = false;
                                if (response.success) {
                                    removeCart();
                                } else if (response.hasOwnProperty('errorMsg') && response.errorMsg != "") {
                                    toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                                } else {
                                    toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.', 'error-toast');
                                }
                            });
                        }
                    },
                    locals: {
                        product: [],
                        index: -1,
                        Extradata: {},
                        tabName: vm.tabName,
                        selectCustomer: '',
                        allUsers: vm.allUsers
                    }
                });
            }
        }

        function deleteCustomer() {
            if (typeof vm.resDetails.inHouseCustomerSelected != 'undefined') {
                delete vm.resDetails.inHouseCustomerSelected;
            }
            if(vm.customerDetails != undefined && typeof vm.customerDetails.tax_exempt_indicator != 'undefined' && vm.customerDetails.tax_exempt_indicator == 1){
                vm.resDetails['taxValue'] = false;
                calculateTotal();
            }

            if (vm.resDetails.typeofService == 'bar') 
                $localStorage['barUser+' + $localStorage['preHotelId']] = '';
            else 
                $sessionStorage['selectedUser_' + $localStorage['preHotelId']] = '';

            vm.customerDetails = null;
            vm.selectedCustomer = '';
            vm.lastCustomer = '';
            vm.selectedCustomer1 = '';
            vm.payment_method = [];   
            vm.order.allcardsInfo =  [];        
        }
        vm.openWin = openWin;

        function openWin() {
            var myWindow = window.open('', '', 'width=600,height=800');
            myWindow.document.write("<p>This is 'myWindow'</p></br>");
            myWindow.document.close();
            myWindow.focus();
            myWindow.print();
            myWindow.close();
        }

        function updateSession() {
            if (vm.resDetails['pageFrom'] !== 'order' && vm.resDetails['pageFrom'] !== staticRestValue) {
                $sessionStorage['cartDetails_' + $localStorage['preHotelId']] = angular.copy(vm.sessionCartItems);
            } else {
                $sessionStorage['editReservationOrder'] = angular.copy(vm.sessionCartItems);
            }
        }

        function gotoRevservationPage() {
            $timeout(function() {
                removeCart();
            }, 1000);
            if (vm.resDetails['pageFrom'] !== 'order' && vm.resDetails['pageFrom'] !== staticRestValue) {
                $state.go('app.create-res', {
                    tabIndex: vm.resDetails['cartIndex']
                });
            } else {

                window.history.back();
                // alert('I am here');
                // return ;
                // $state.go('app.e-commerce.orders.detail', {
                //     confirmation_number: vm.resDetails['confirmation_number'],
                //     changeStatusData: '',
                //     id: vm.resDetails['product_id']
                // });
            }
        }

        function gotoPosOrder(timeuot) {
            var oneGoId = (vm.resDetails.one_go_id !== undefined && vm.resDetails.one_go_id !== null) ? vm.resDetails.one_go_id : $sessionStorage['webpos_one_go_order_number_' + $localStorage['preHotelId']];
            $timeout(function() {
                removeCart();
                if (vm.resDetails.typeofService === staticRestValue) {
                    $state.go("app.restaurant-order", { one_go_id: oneGoId });
                } else {
                    $state.go("app.pos-order", { one_go_id: oneGoId });
                }
            }, timeuot);
        }

        function gotoReservation() {
            vm.orderProcessing = true;
            vm.sessionCartItems[vm.resDetails['cartIndex']]['pos'] = angular.copy(vm.cartItem);
            var resCartItem = angular.copy(vm.sessionCartItems[vm.resDetails['cartIndex']]['overalltotals']);
            vm.sessionCartItems[vm.resDetails['cartIndex']]['pos'].forEach(function(element, index) {
                if (element['product_is_timebound'] == 1) {
                    vm.sessionCartItems[vm.resDetails['cartIndex']]['pos'][index]['nightlySum'] = commonService.roundnum(parseFloat(element['particularCustomPrice']) * element['quantity'], 2);
                    vm.sessionCartItems[vm.resDetails['cartIndex']]['pos'][index]['quantity'] = 1;
                }
                if (element.hasOwnProperty('dynamic_attributes')) {
                    element.dynamic_attributes.forEach(function(element, index) {
                        if (element.type == 'date') {
                            element.value = moment(element.value).format('YYYY-MM-DD');
                        }
                    });
                }

            });
            resCartItem['product_discount'] = commonService.roundnum((parseFloat(resCartItem['product_discount']) + parseFloat(vm.CartSubTotal['discount'])), 2);
            if (vm.resDetails['pageFrom'] == 'reservation' && vm.resDetails['itinerary_number'].length > 1) {
                resCartItem['grand_total'] = commonService.roundnum((parseFloat(resCartItem['grand_total']) + parseFloat(vm.CartSubTotal['grand_total'])), 2) + parseFloat(vm.CartSubTotal['deposit_amount']);
                resCartItem['remaining_amount'] = resCartItem['grand_total'];
                resCartItem['subtotal'] = commonService.roundnum((parseFloat(resCartItem['subtotal']) + parseFloat(vm.CartSubTotal['subtotal'])), 2) + parseFloat(vm.CartSubTotal['deposit_amount']);
                resCartItem['deposit_amount'] = 0;

            } else {
                resCartItem['deposit_amount'] = commonService.roundnum((parseFloat(resCartItem['deposit_amount']) + parseFloat(vm.CartSubTotal['deposit_amount'])), 2);
                resCartItem['remaining_amount'] = commonService.roundnum((parseFloat(resCartItem['remaining_amount']) + parseFloat(vm.CartSubTotal['remaining_amount'])), 2);
                resCartItem['grand_total'] = commonService.roundnum((parseFloat(resCartItem['grand_total']) + parseFloat(vm.CartSubTotal['grand_total'])), 2);
                resCartItem['subtotal'] = commonService.roundnum((parseFloat(resCartItem['subtotal']) + parseFloat(vm.CartSubTotal['subtotal'])), 2);
            }
            var overAllTaxesNamesArray = vm.sessionCartItems[vm.resDetails['cartIndex']]['overalltotals']['tax_names'];
            vm.sessionCartItems[vm.resDetails['cartIndex']]['pos'].forEach(function(element, index) {
                var elementTaxes = element.taxes;
                if(typeof elementTaxes != 'undefined' && elementTaxes.length > 0) {
                   elementTaxes.forEach(function(tax, key) {
                       if(overAllTaxesNamesArray.indexOf(tax['tax_name']) > -1) {
                           var indexNo = overAllTaxesNamesArray.indexOf(tax['tax_name']);
                           var taxAmt = commonService.roundnum((parseFloat(vm.sessionCartItems[vm.resDetails['cartIndex']]['overalltotals']['tax_amounts'][indexNo]) + parseFloat(tax['tax'])), 2);
                           vm.sessionCartItems[vm.resDetails['cartIndex']]['overalltotals']['tax_amounts'][indexNo] = taxAmt;
                       }
                   });
                }
            });

            resCartItem['tax'] = commonService.roundnum((parseFloat(resCartItem['tax']) + parseFloat(vm.CartSubTotal['tax'])), 2);
            vm.sessionCartItems[vm.resDetails['cartIndex']]['overalltotals'] = angular.copy(resCartItem);
            updateSession();
            vm.multipleNightPolicies = [];
            vm.sessionCartItems[vm.resDetails['cartIndex']]['pageFrom'] = $stateParams.pageFrom;
            if ($sessionStorage['cartDetails_' + $localStorage['preHotelId']][vm.resDetails['cartIndex']]['room_deposit_type_indicator'] == "multiple-night") {
                eCommerceService.getmultipleNightPolicy($sessionStorage['cartDetails_' + $localStorage['preHotelId']]).then(function(response) {
                    vm.multipleNightPolicies = response;
                    $sessionStorage['cartDetails_' + $localStorage['preHotelId']][vm.resDetails['cartIndex']] = commonService.calculateTotals(vm.sessionCartItems[vm.resDetails['cartIndex']], false, vm.multipleNightPolicies);
                });
            } else {
                $sessionStorage['cartDetails_' + $localStorage['preHotelId']][vm.resDetails['cartIndex']] = commonService.calculateTotals(vm.sessionCartItems[vm.resDetails['cartIndex']], false, vm.multipleNightPolicies);
            }
            if (vm.resDetails['pageFrom'] !== 'order' && vm.resDetails['pageFrom'] !== staticRestValue) {
                $state.go('app.create-res', {
                    tabIndex: vm.resDetails['cartIndex'],
                    newPosAdded: true
                });
            }
        }

        function closePayment() {
            var myEl = angular.element(document.querySelector('#selectInHouseCustomer'));
            myEl.removeClass('open');
            var myEl = angular.element(document.querySelector('#MyPaymentMethod'));
            myEl.removeClass('open');
        }
        vm.notCardType = false;

        function proceedToCheckout() {
            vm.savingCartItems = true;
            vm.orderProgressing = true;
            
            if (typeof vm.payment_method[0]['method'] != 'undefined' || (typeof vm.resDetails['pageFrom'] != 'undefined' && (vm.resDetails['pageFrom'] === 'order' || vm.resDetails['pageFrom'] === staticRestValue))) {
                if (vm.ccvError && vm.payment_method[0]['method'] == "Credit Card") {
                    delete vm.payment_method[0]['cc_cid'];
                }
                if (vm.payment_method[0]['method'] == "Credit Card" && vm.payment_method[0]['cc_cid'] == '') {
                    delete vm.payment_method[0]['cc_cid'];
                }
                var itinerary_number = null;
                var confirmation_number = null;

                if (!vm.customerDetails || vm.customerDetails == null) {
                    vm.customerDetails = vm.defaultCustomer;
                } else {
                    confirmation_number = vm.customerDetails['confirmation_number'];
                    itinerary_number = vm.customerDetails['itinerary_number'];
                }
                
                if (typeof vm.resDetails['pageFrom'] != 'undefined') {
                    if (vm.resDetails['pageFrom'] == 'order' || vm.resDetails['pageFrom'] === staticRestValue) {
                        confirmation_number = vm.resDetails['confirmation_number'];
                        itinerary_number = vm.resDetails['itinerary_number'];
                    }
                }

                if (typeof vm.resDetails['pageFrom'] !== 'undefined' || vm.resDetails['pageFrom'] !== 'order' || vm.resDetails['pageFrom'] === staticRestValue) {
                    if (typeof vm.CartSubTotal['gift_card_code'] == 'undefined') {
                        delete vm.CartSubTotal['gift_card_code'];
                        delete vm.CartSubTotal['gift_card_price'];
                        delete vm.CartSubTotal['paidFromGC'];
                    }
                }

                vm.cartDetails['overalltotals'] = vm.CartSubTotal;
                vm.cartDetails['payment_method_common'] = 1;
                vm.cartDetails['product_id'] = 0;
                vm.cartDetails['normal_occupancy'] = 0;
                vm.cartDetails['per_night_additional_amount'] = 0;
                vm.cartDetails['product_name'] = '';
                vm.cartDetails['room_type_id'] = 0;
                vm.cartDetails['additional_guest_amounts'] = 0;
                vm.cartDetails['from'] = '';
                vm.cartDetails['to'] = '';
                vm.cartDetails['nights'] = 0;
                vm.cartDetails['room_stay_guest_count'] = 0;
                vm.cartDetails['room_stay_child_count'] = 0;
                vm.cartDetails['discount_percentage'] = 0;
                vm.cartDetails['taxes'] = [];
                vm.cartDetails['grand_total'] = 0.00;
                vm.cartDetails['other_rate_policies'] = null;
                vm.cartDetails['selelected_policy'] = null;
                vm.cartDetails['selelected_policy_id'] = 0;
                vm.cartDetails['nightlySum'] = 0.00;
                vm.cartDetails['discount_amount'] = 0.00;
                vm.cartDetails['prices'] = [];
                vm.cartDetails['room_deposit_type_indicator'] = 0;
                vm.cartDetails['room_deposit_percentage'] = 0;
                vm.cartDetails['room_deposit_amount'] = 0;
                vm.cartDetails['deposit_amount'] = 0.00;
                vm.cartDetails['remaining_amount'] = 0.00;
                vm.cartDetails['original_deposit_amt'] = 0.00;
                if (vm.resDetails.typeofService == 'bar') vm.cartDetails['comment'] = $localStorage.barNote;
                else vm.cartDetails['comment'] = $sessionStorage['cartNote_' + $localStorage['preHotelId']];
                vm.cartDetails['cust_info'] = vm.customerDetails;
                vm.cartDetails['product_discount'] = angular.copy(commonService.roundnum((parseFloat(vm.overAllDiscount)), 2));
                vm.cartDetails['product_discount_comment'] = [];
                vm.isloading = true;
                var onlyPos = true;

                var keysProcessed = [];
                vm.cartDetails['pos'] = {};
                var allProcessed = true;

                if (typeof vm.resDetails['pageFrom'] != 'undefined' && vm.resDetails['pageFrom'] == 'order') {
                    vm.cartDetails['associatedWithCustTrav'] = vm.resDetails['associatedWithCustTrav'] != undefined ? vm.resDetails['associatedWithCustTrav'] : 0;
                }

                if (typeof vm.resDetails.inHouseCustomerSelected != 'undefined') {
                    vm.cartDetails['inHouseCustomerSelected'] = vm.resDetails.inHouseCustomerSelected;
                } else {
                    delete vm.cartDetails['inHouseCustomerSelected'];
                }
                vm.cartItem.forEach(function(element, index) {
                    // if ((element.is_tip_product || !vm.spliting || (vm.spliting && element.splitChecked == 'yes')) && (element.is_tip_product || !vm.add_tip_to_order)) {
                    if (((!vm.spliting && !vm.add_tip_to_order) || (vm.spliting && element.splitChecked == 'yes') || (element.is_tip_product && vm.add_tip_to_order))) {
                        vm.cartDetails['pos'][index] = angular.copy(element);
                        keysProcessed.push(index);
                        if (element['product_is_timebound'] == 1) {
                            vm.cartDetails['pos'][index]['nightlySum'] = commonService.roundnum(parseFloat(element['particularCustomPrice']) * element['quantity'], 2);
                            vm.cartDetails['pos'][index]['quantity'] = 1;
                        }
                        if (element.is_tip_product && vm.add_tip_to_order) {
                            vm.cartDetails['pos'][index]['webpos_one_go_order_number'] = vm.add_tip_to_one_go_id;
                            vm.cartDetails['pos'][index]['tip_after_order'] = 1;
                        }
                        if (vm.spliting) {
                            vm.cartDetails['pos'][index]['split_payment_order'] = 1;
                        }
                        if (vm.resDetails.one_go_id !== '' && ((vm.resDetails.pageFrom === 'order' && vm.resDetails.typeofService === 'bar') || (vm.resDetails.pageFrom === staticRestValue && vm.resDetails.typeofService === staticRestValue))) {
                            vm.cartDetails['pos'][index]['webpos_one_go_order_number'] = vm.resDetails.one_go_id;
                        }
                    } else if (!vm.add_tip_to_order) {
                        allProcessed = false;
                    }
                });
                if (vm.add_tip_to_order && vm.add_tip_to_itinerary != '') {
                    itinerary_number = vm.add_tip_to_itinerary;
                    confirmation_number = vm.add_tip_to_room_conf;
                }
                if (vm.resDetails.typeofService === 'bar') {
                    onlyPos = 'Bar';
                } else if (vm.resDetails.typeofService === staticRestValue) {
                    onlyPos = staticRestValue;
                }

                if (vm.resDetails['pageFrom'] === 'order' || vm.resDetails['pageFrom'] === staticRestValue) {
                    onlyPos = true;
                }

                if (vm.resDetails['pageFrom'] === 'order' && vm.resDetails.typeofService === 'bar') onlyPos = 'Bar-add';
                if (vm.resDetails['pageFrom'] === staticRestValue && vm.resDetails.typeofService === staticRestValue) onlyPos = 'Restaurant-add';
                var check = true;

                if (check) {
                    var gt = angular.copy(parseFloat(vm.subTotal - vm.overAllDiscount));
                    var cust_email = (typeof vm.customerDetails != 'undefined') ? angular.copy(vm.customerDetails['customer_email']) : '';
                    createResService.createReservation({
                        cartdetails: {
                            0: vm.cartDetails
                        },
                        paymentMethod: vm.payment_method,
                        payment_method_common: null,
                        customer_info: vm.customerDetails,
                        itinerary_number: itinerary_number,
                        confirmation_number: confirmation_number,
                        onlyPos: onlyPos,
                        fuctionType: 'addingExtraServices'
                    }).then(function(response) {
                        vm.defaultCustomer = defCustObject;
           
                        if(vm.resDetails['product_name'].indexOf('esidence') != -1){
                            window.history.back();
                        }
                        
                        vm.savingCartItems = false;
                        vm.orderProgressing = false;
                        vm.isloading = false;
                        vm.creatingres = false;

                        if (response.server_error) {
                            toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'), 'error-toast');
                        } else if (response.errorMsg) {
                            toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                        } else if (response.no_full_avail) {
                            toastMessage.showSimpleToast($translate.instant('CREATE_RES.NO_FULL_AVAIL'), 'error-toast');
                        } else if (response.no_semi_avail) {
                            var message = '';
                            var target = response.no_semi_avail;
                            for (var k in target) {
                                if (target.hasOwnProperty(k)) {
                                    message += $translate.instant('CREATE_RES.NO_SEMI_AVAIL_FIRST') + target[k].product_name + ' from ' + target[k].from + ', to ' + target[k].to + $translate.instant('CREATE_RES.NO_SEMI_AVAIL_SEC');
                                }
                            }
                            toastMessage.showSimpleToast(message, 'error-toast');
                        } else if (response.success) {
                            vm.savingCartItems = false;
                            vm.orderProgressing = false;
                            if (vm.resDetails.one_go_id != '' && ((vm.resDetails.pageFrom === 'order' && vm.resDetails.typeofService === 'bar') || (vm.resDetails.pageFrom === staticRestValue && vm.resDetails.typeofService === staticRestValue))) {
                                removeCart();
                                if (vm.resDetails.typeofService === staticRestValue) {
                                    $state.go("app.restaurant-order", { one_go_id: vm.resDetails.one_go_id });
                                } else {
                                    $state.go("app.pos-order", { one_go_id: vm.resDetails.one_go_id });
                                }
                            } else if (vm.resDetails.typeofService == 'bar' && vm.spliting && !allProcessed) {
                                keysProcessed.forEach(function(element, keyOrder) {
                                    delete vm.cartItem[element];
                                });
                                vm.cartItem = vm.cartItem.filter(function(e) {
                                    return e
                                });
                                vm.splitcheck = [];
                                vm.cartItem.forEach(function(single_cart_item, keyOrder) {
                                    vm.splitcheck.push(false);
                                });
                                vm.splitCount++;
                                calculateTotal();
                                vm.itinerary_number = response.itinerary_number;
                                vm.customer_email = cust_email;
                                vm.webpos_one_go_order_number = response.webpos_one_go_order_number
                                vm.finalTotal = commonService.roundnum(gt, 2);
                                vm.afterCreatePage = true;
                                vm.startneworder = false;
                                vm.expectedChangeForPrint = vm.expectedChange;
                                vm.expectedChange = 0;
                                vm.payment_method[0].method = '';
                                $localStorage['currentTabDetails'] = '';
                                vm.printOrderInvoice();
                            } else if (vm.resDetails.typeofService == 'bar' || vm.resDetails.typeofService === staticRestValue) {
                                vm.startneworder = true;
                                vm.itinerary_number = response.itinerary_number;
                                vm.customer_email = cust_email;
                                vm.webpos_one_go_order_number = response.webpos_one_go_order_number
                                vm.finalTotal = commonService.roundnum(gt, 2);
                                vm.afterCreatePage = true;
                                vm.spliting = false;
                                vm.show_split = false;
                                vm.expectedChangeForPrint = vm.expectedChange;
                                vm.expectedChange = 0;
                                vm.splitText = 'Split Payment';
                                removeCart();
                                vm.printOrderInvoice();
                            } else {
                                removeCart();
                                $state.go('app.e-commerce.orders.detail', {
                                    id: response.reservation_id,
                                    confirmation_number: confirmation_number
                                });
                            }
                        }
                    });
                }
            } else {
                alert('please select a payment method');
            }
            vm.orderProcessing = false;
        }


        function selectedItemChange(customer) {
            if (customer) {
                vm.customerDetails = {};
                vm.customerDetails = angular.copy(customer);

                vm.selectedCustomer1 = '';
                if (vm.customerDetails['confirmation_number']) {
                    vm.isloading = true;
                    var data = {
                        confirmation_number: customer['confirmation_number'],
                        first_name: customer['first_name'],
                        last_name: customer['last_name'],
                        total_amount: vm.subTotal,
                        remaining_amount: vm.subTotal,
                        requestFrom: 'bar'
                    };
                    vm.card
                    eCommerceService.fetchPaymentsInformation(data).then(function(response) {
                        if (!response.success) {
                            toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.', 'error-toast');
                        } else {
                            var incidental_status = false;
                            for (var key in response.allcardsInfo) {
                                if (typeof response.allcardsInfo[key]['incidental_display'] != 'undefined' && response.allcardsInfo[key]['cc_is_incidental'] == "1") {
                                    incidental_status = true;
                                }
                            }
                            if (incidental_status) {
                                if (response['allcardsInfo'].length > 0 && response['allcardsInfo'] != '') {
                                    vm.ct = response['allcardsInfo']['cc_type'];
                                }

                                var myEl = angular.element(document.querySelector('#selectInHouseCustomer'));
                                myEl.removeClass('open');
                                var myEl = angular.element(document.querySelector('#SelectedItenararyNo'));
                                myEl.removeClass('open');
                                var myEl = angular.element(document.querySelector('#MyPaymentMethod'));
                                myEl.addClass('open');

                                vm.isUserSelecte = true;
                                vm.order.allcardsInfo = angular.copy(response.allcardsInfo);
                                vm.order.customer_profile = response.customer_profile;
                                vm.fieldsIsReadOnly = false;
                                if (Object.keys(response.allcardsInfo).length > 0) {
                                    vm.payment_method[0] = response.allcardsInfo[0];
                                    let savedYear = parseInt(vm.payment_method[0].cc_exp_year);
                                    let currentYear = new Date().getFullYear();
                                    
                                    if (savedYear && savedYear < currentYear && !vm.yrs_option.includes(savedYear)) {
                                        vm.yrs_option.unshift(savedYear);
                                    }
                                    if (response.allcardsInfo[0].cc_number != '') {
                                        vm.fieldsIsReadOnly = true;
                                        vm.use_existingcard = 0;
                                    }
                                }
                                vm.payment_method[0].method = response.selectedPaymentMethod;
                            }
                        }
                        vm.isloading = false;
                    });
                }

            }

        }


        function queryCustomerSearch(query) {
            var deferred = $q.defer();
            if (query != '') {
                checkoutService.getReservedUsers({
                        search: query
                    })
                    .then(function(response) {
                        if (typeof response['reservedCustomers']['reservedCustomers'] != 'undefined') {
                            deferred.resolve(response['reservedCustomers']['reservedCustomers']);
                        } else {
                            deferred.resolve([]);
                        }
                    });
                return deferred.promise;
            } else {
                return [];


            }
        }




        function validateGCCode() {
            vm.gcrequestGoing = true;
            createResService.validateGCC({
                GCC: vm.giftCardCode
            }).then(function(response) {
                vm.gcrequestGoing = false;
                if (response.success && !response.data.length == 0) {
                    if (parseFloat(response.data[0]['gift_card_price']) == 0) {
                        vm.giftCardErrro = 'No amount left for this gift card.';
                    } else {
                        var remaining_amount = vm.subTotal - vm.overAllDiscount;
                        var adjustedGCPrice = commonService.calculateGCValue(remaining_amount, response.data[0]['gift_card_price']);
                        vm.payingFromGC = {};
                        vm.payingFromGC.price = adjustedGCPrice;
                        vm.payingFromGC.gcCode = response.data[0]['gift_card_code'];
                        vm.payingFromGC.gcCardOrigPrice = angular.copy(response.data[0]['gift_card_price']);
                        vm.giftCardErrro = '';
                        vm.giftCardCode = '';
                        calculateTotal();
                    }

                } else if (!response.success && response.errorMsg != '') {
                    vm.payingFromGC = {};
                    vm.giftCardErrro = response.errorMsg;
                } else if (response.data.length == 0) {
                    vm.payingFromGC = {};
                    vm.giftCardErrro = $translate.instant('CREATE_RES.INVALID_GC');
                } else {
                    vm.payingFromGC = {};
                    vm.giftCardErrro = $translate.instant('CREATE_RES.SERVER_ERROR');
                }
            });

        }


        function creditCardChanged(event, cardType, payment_method) {
            var result = commonService.creditCardChanged(event, cardType, payment_method, vm.allowed_card_types);
            vm.notCardType = result.notCardType;
            vm.payment_method[0] = result.payment_method;
        }

        vm.testPayment = testPayment;

        function testPayment(orderIndex) {
            var count = vm.use_existingcard;
            vm.payment_method[0] = vm.order.allcardsInfo[count];
            vm.payment_method[0]['method'] = 'Credit Card';
        }


        function changeActiveCard11(orderIndex) {
            var count = vm.use_existingcard;
            vm.payment_method[0] = vm.order.allcardsInfo[count];
        }



        function emptythisPayment() {
            var oldPaymentmethod = angular.copy(vm.payment_method[0].method);
            vm.payment_method = {
                0: {}
            };
            vm.payment_method[0].method = oldPaymentmethod;
            vm.fieldsIsReadOnly = false;
            vm.use_existingcard = '';
            vm.ct = '';
        }

        vm.proceedFurtherWithPaymentFetchInformation = proceedFurtherWithPaymentFetchInformation;
        vm.lastCustomer = {};
        function proceedFurtherWithPaymentFetchInformation(confirmation_number, first_name, last_name, total_amount, remaining_amount, customer){
            var myEl = angular.element(document.querySelector('#MyPaymentMethod'));
            myEl.removeClass('open');
            vm.customerDetails = {};
            vm.selectedCustomer = '';
            vm.customerDetails = angular.copy(customer);
            vm.lastCustomer = angular.copy(vm.selectedCustomer1);
            vm.selectedCustomer = '';
            if (confirmation_number != '') {
                vm.isloading = true;
                var data = {
                    confirmation_number: confirmation_number,
                    first_name: first_name,
                    last_name: last_name,
                    total_amount: total_amount,
                    remaining_amount: remaining_amount,
                    requestFrom: 'bar'
                };
                eCommerceService.fetchPaymentsInformation(data).then(function(response) {
                    if (!response.success) {
                        toastMessage.showSimpleToast('Oops! -  We\'ve encountered an error.  Our server may be busy; please try your action again.  If you keep seeing this message please contact support@lodgingsystem.com.', 'error-toast');
                    } else {
                        var incidental_status = false;
                        for (var key in response.allcardsInfo) {
                            if (typeof response.allcardsInfo[key]['incidental_display'] != 'undefined' && response.allcardsInfo[key]['cc_is_incidental'] == "1") {
                                incidental_status = true;
                            }
                        }
                        if (incidental_status) {
                            if (response['allcardsInfo'].length > 0 && response['allcardsInfo'] != '') {
                                vm.ct = response['allcardsInfo']['cc_type'];
                            }
                            vm.isUserSelecte = true;
                            vm.order.allcardsInfo = angular.copy(response.allcardsInfo);
                            vm.order.customer_profile = response.customer_profile;
                            vm.fieldsIsReadOnly = false;

                            if (Object.keys(response.allcardsInfo).length > 0) {
                                vm.payment_method[0] = response.allcardsInfo[0];
                                let savedYear = parseInt(vm.payment_method[0].cc_exp_year);
                                let currentYear = new Date().getFullYear();

                                if (savedYear && savedYear < currentYear && !vm.yrs_option.includes(savedYear)) {
                                    vm.yrs_option.unshift(savedYear);
                                }
                                if (response.allcardsInfo[0].cc_number != '') {
                                    vm.fieldsIsReadOnly = true;
                                    vm.use_existingcard = 0;
                                }
                            }
                            vm.payment_method[0].method = response.selectedPaymentMethod;
                            var myEl = angular.element(document.querySelector('#selectInHouseCustomer'));
                            myEl.removeClass('open');

                            var myEl = angular.element(document.querySelector('#MyPaymentMethod'));
                            myEl.addClass('open');
                        }
                    }
                    vm.isloading = false;
                });
            }
        }

        function fetchPaymentsInformation(confirmation_number, first_name, last_name, total_amount, remaining_amount, customer) {
            vm.resDetails.inHouseCustomerSelected = customer.customer_id;
            if(typeof customer.tax_exempt_indicator != 'undefined' && customer.tax_exempt_indicator == 1){
                var title = 'Attention!';
                var html = 'This user is tax exempt, proceeding further will remove tax from the cart?';
                $mdDialog.show({
                    controller: 'confirmController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: true,
                    locals: {
                        title: title,
                        htmlContent: html,
                        cancelBtn: 'No',
                        OkBtn: 'Yes'
                    }
                }).then(function(answer) {
                    if (typeof answer != 'undefined' && answer == 'update') {
                       vm.resDetails['taxValue'] = true;
                       calculateTotal();
                       proceedFurtherWithPaymentFetchInformation(confirmation_number, first_name, last_name, total_amount, remaining_amount, customer);
                    }else {
                        vm.selectedCustomer1 = angular.copy(vm.lastCustomer);
                    }
                }, function() {});

            }else{
                console.log(vm.resDetails);
                vm.resDetails['taxValue'] = false;
                calculateTotal();
                proceedFurtherWithPaymentFetchInformation(confirmation_number, first_name, last_name, total_amount, remaining_amount, customer);
            }

        }
        userService.getCountries().then(function(response) {
            vm.Country = response;
        });

        function getAllCustomers() {
            if (!vm.customerDetails) {
                var event = '';
                $mdDialog.show({
                    controller: 'customerController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/checkout/dialog/customerModel.html',
                    parent: angular.element($document.find('#content-container')),
                    targetEvent: event,
                    scope: $scope.$new(),
                    clickOutsideToClose: true,
                    locals: {
                        Country: vm.Country
                    }
                });
            }
        }

        $scope.$on('getCustomer', function(event, data) {
            vm.customerDetails = {};
            if (data['userDetail'].length != 0) {
                vm.customerDetails = angular.copy(data['userDetail']);
            } else if (data['response'].length != 0) {
                vm.customerDetails = angular.copy(data['response']);
            }
            vm.selectedCustomer = '';
            vm.selectedCustomer1 = '';
        });

        function removeSearchText(type) {
            vm.search = vm.search.replace(/^\s+|\s+$/g, '');
            if (vm.search == 'Search' && type == 'click') {
                vm.search = '';
            }
            if (type == 'blur' && vm.search.length == 0) {
                vm.search = 'Search';
            }
        }


        function goToCheckout() {
            var quantity = 0;
            /* Please don't remove these if else conditions or test all cases like add tip to order, split payment, add bar to order and normal checkout */
            if (vm.checkoutPage) {
                vm.checkoutPage = !vm.checkoutPage;
            } else if (vm.cartItem.length > 0) {
                vm.checkoutPage = !vm.checkoutPage;
            }
            /* Please don't remove these if else conditions or test all cases like add tip to order, split payment, add bar to order and normal checkout */
            if (vm.checkoutPage && vm.cartItem.length > 0) {
                vm.cartItem.forEach(function(element, index) {
                    quantity += parseInt(element.quantity);
                    if (element.hasOwnProperty('dynamic_attributes')) {
                        element.dynamic_attributes.forEach(function(element, index) {
                            if (element.type == 'date') {
                                element.value = moment(element.value).format('YYYY-MM-DD');
                            }
                        });
                    }
                });
            }
            if (!vm.add_tip_to_order) {
                if (vm.checkoutPage && quantity > 1) {
                    vm.show_split = true;
                    vm.splitText = 'Split Payment';
                } else {
                    vm.show_split = false;
                    if (vm.splitText == 'Cancel Split')
                        joinQuantities();
                }
            }
        }

        function addCustomDiscount(event) {
            if (vm.cartItem.length > 0) {
                $mdDialog.show({
                    controller: 'customSale',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/checkout/dialog/onlyNumberDialog.html',
                    parent: angular.element($document.find('#content-container')),
                    targetEvent: event,
                    scope: $scope.$new(),
                    clickOutsideToClose: true,
                    locals: {
                        tax: [],
                        product: [],
                        pageDetails: {},
                        taxValue: vm.resDetails['taxValue'],
                        updateIndexValue: ''
                    }
                });

            }

        }

        function addCardDetails(card) {
            if (card == 'none') {
                vm.creditCard.name_on_card = '';
                vm.creditCard.card_type = '';
                vm.creditCard.card_number = '';
                vm.payment_method[0]['cc_exp_date'] = '';
                vm.payment_method[0]['cc_exp_year'] = '';

            } else {
                vm.creditCard.name_on_card = card['cc_fname'] + ' ' + card['cc_mname'] + ' ' + card['cc_lname'];
                vm.creditCard.card_type = card['cc_type'];
                vm.creditCard.card_number = '********' + card['cc_number'];
                vm.payment_method[0]['cc_exp_date'] = parseInt(card['cc_exp_month']);
                vm.payment_method[0]['cc_exp_year'] = parseInt(card['cc_exp_year']);
            }
        }

        function checkValidExpDate(index) {

            var obj = {
                'method': vm.payment_method[0]['payment_method'],
                'cc_exp_year': vm.payment_method[0]['cc_exp_year'],
                'cc_exp_date': vm.payment_method[0]['cc_exp_month']
            };
            var result = commonService.checkValidExpDate(obj);
            vm.exp_date = result.exp_date;
            vm.exp_date_err = result.exp_date_err;
        }

        function changePaymentMethod(paymentType) {
            vm.paymentType = paymentType;
        }

        function getCustomerCardDetails(customerDetail) {
            vm.customerDetails = {};
            vm.customerDetails = angular.copy(customerDetail);
            checkoutService.getCardDetails({
                'confirmation_number': vm.selectedCustomer
            }).then(function(response) {
                if (response['cardDetails']['success']) {
                    vm.customerCardDetails = response['cardDetails']['cardDetails'];
                }
            });
        }

        function openCustomProductPopUp(event) {
            $mdDialog.show({
                controller: 'customSale',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/checkout/dialog/customSale.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: event,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                onRemoving: function addCustomProduct() {
                    // $rootScope.$broadcast('greeting', 'message');
                },
                locals: {
                    tax: vm.tax,
                    product: [],
                    pageDetails: {},
                    taxValue: vm.taxStatus,
                    updateIndexValue: ''
                }
            });
        }

        function isRoundUpEnable() {
            var settings = $localStorage.hotelgeneralsetting;
            if (!settings || typeof settings !== 'object') {
                return false;
            }
            var value = settings.isRoundUpEnable;
            return value === true || value === 1 || value === '1';
        }

        function getCharityRoundUpAmount() {
            if (!isRoundUpEnable()) {
                return 0;
            }
            var totalAfterDiscount = parseFloat(vm.subTotal) - parseFloat(vm.overAllDiscount || 0);
            if (!isFinite(totalAfterDiscount) || totalAfterDiscount <= 0) {
                return 0;
            }

            var existingCharityTotal = 0;
            angular.forEach(vm.cartItem, function(item) {
                if (!item || !item.is_charity_round_up) {
                    return;
                }

                var itemQuantity = parseFloat(item.quantity || 1);
                if (!isFinite(itemQuantity) || itemQuantity <= 0) {
                    itemQuantity = 1;
                }

                var itemUnitAmount = parseFloat(item.particularCustomPrice || item.customPrice || item.product_price || 0);
                var itemTotalAmount = parseFloat(item.grand_total);
                if (!isFinite(itemTotalAmount) || itemTotalAmount <= 0) {
                    itemTotalAmount = itemUnitAmount * itemQuantity;
                }

                if (isFinite(itemTotalAmount) && itemTotalAmount > 0) {
                    existingCharityTotal += itemTotalAmount;
                }
            });

            var totalAfterDiscountCents = Math.round(totalAfterDiscount * 100);
            var roundUpDeltaCents = (Math.ceil(totalAfterDiscountCents / 100) * 100) - totalAfterDiscountCents;
            if (roundUpDeltaCents <= 0) {
                return 0;
            }
            var desiredCharityTotal = existingCharityTotal + (roundUpDeltaCents / 100);

            if (!isFinite(desiredCharityTotal) || desiredCharityTotal <= 0) {
                return 0;
            }

            return commonService.roundnum(desiredCharityTotal, 2);
        }

        function addRoundUpForCharity() {
            var roundUpAmount = getCharityRoundUpAmount();
            if (roundUpAmount <= 0) {
                return;
            }

            var charityIndex = -1;
            for (var ci = 0; ci < vm.cartItem.length; ci++) {
                if (vm.cartItem[ci] && vm.cartItem[ci].is_charity_round_up) {
                    charityIndex = ci;
                    break;
                }
            }
            if (charityIndex !== -1) {
                vm.cartItem[charityIndex].product_name = 'Round Up For Charity';
                vm.cartItem[charityIndex].customPrice = roundUpAmount;
                vm.cartItem[charityIndex].product_price = roundUpAmount;
                vm.cartItem[charityIndex].total = roundUpAmount;
                vm.cartItem[charityIndex].particularCustomPrice = roundUpAmount;
                vm.cartItem[charityIndex].nightlySum = commonService.roundnum(roundUpAmount, 2);
                addDiscountIfExists(0);
                return;
            }

            var myDate = new Date();
            var time = myDate.getTime() + "";
            var charityRoundUpProduct = {
                customDiscount: 0.00,
                customPrice: roundUpAmount,
                product_id: time,
                product_is_timebound: "0",
                product_name: 'Round Up For Charity',
                product_price: roundUpAmount,
                product_type: "pos",
                quantity: 1,
                tax_value: 0.00,
                tax_name: '',
                tax_id: 0,
                total: roundUpAmount,
                product_discount: 0.00,
                is_custom_product: true,
                is_charity_round_up: true
            };

            addToCart(charityRoundUpProduct);
        }

        vm.addGiftCard = addGiftCard;

        function addGiftCard(event) {
            $mdDialog.show({
                controller: 'giftCard',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/checkout/dialog/giftCard.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: event,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                onRemoving: function addCustomProduct() {
                    // $rootScope.$broadcast('greeting', 'message');
                },
                locals: {
                    tax: vm.tax,
                    product: [],
                    pageDetails: {}
                }
            });
        }

        function addNote(event) {
            $mdDialog.show({
                controller: 'cartProductUpdate',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/checkout/dialog/addNote.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: event,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                onRemoving: function updateProductDetailonRemoving() {
                    $rootScope.$broadcast('greeting', 'message');
                },
                locals: {
                    product: [],
                    index: -1,
                    Extradata: {
                        PageType: vm.resDetails.typeofService
                    },
                    tabName: vm.tabName,
                    selectCustomer: '',
                    allUsers: vm.allUsers
                }
            });
        }

        function removeCart() {
            emptythisPayment();
            vm.order.allcardsInfo = [];
            vm.tempDisablePrint = false;
            vm.overAllTax = 0;
            vm.cartItem = [];
            vm.cartItemIds = [];
            vm.tempDiscountAmount = 0;
            vm.subTotal = 0;
            vm.totalTip = 0;
            if (vm.resDetails.typeofService === 'bar') {
                $localStorage['barItem_' + $localStorage['preHotelId']] = [];
                $sessionStorage.TipProductIndex = [];
                $localStorage.barNote = '';
                $localStorage.barDiscount = '';
                $localStorage['barUser+' + $localStorage['preHotelId']] = '';
                /* add tip to order */
                $sessionStorage.add_tip_to_order = false;
                $sessionStorage['unset_all_var_' + $localStorage['preHotelId']] = false;
                vm.add_tip_to_order = false;
                $sessionStorage['webpos_one_go_order_number_' + $localStorage['preHotelId']] = '';
                $sessionStorage.add_tip_to_grand_total = '';
                $sessionStorage.add_tip_to_itinerary = '';
                $sessionStorage.add_tip_to_room_conf = '';
                vm.add_tip_to_grand_total = '';
                vm.add_tip_to_itinerary = '';
                vm.add_tip_to_room_conf = '';
                /* add tip to order */
                deleteCustomer();
            } else if (vm.resDetails.typeofService != undefined && vm.resDetails.typeofService.toLowerCase() === staticRestValue) {
                $sessionStorage.TipProductIndex = [];
                $sessionStorage['restaurantItem_' + $localStorage['preHotelId']] = [];
                $sessionStorage['cartNote_' + $localStorage['preHotelId']] = '';
                $sessionStorage['selectedUser_' + $localStorage['preHotelId']] = '';
            } else {
                $sessionStorage['barItem_' + $localStorage['preHotelId']] = [];
                $sessionStorage['cartNote_' + $localStorage['preHotelId']] = '';
                $sessionStorage['selectedUser_' + $localStorage['preHotelId']] = '';
            }
            vm.customerDetails = null;
            vm.overAllDiscount = 0;
            vm.selectedCustomer = '';
            vm.selectedCustomer1 = '';
            vm.payment_method = {};
            vm.payment_method[0] = {};
            $localStorage['cartDiscount_' + $localStorage['preHotelId']] = '';
            $rootScope.isDiscountApplied = false;

            if (typeof $localStorage['currentTabDetails'] != 'undefined' && $localStorage['currentTabDetails'] != '') {
                var data = {
                    'tabId': $localStorage['currentTabDetails'],
                    status: 0
                };
                checkoutService.setTabStatusToInactive(data).then(function(response) {
                    $localStorage['currentTabDetails'] = '';
                });

            }
        }
        vm.emptyCart = emptyCart;

        function emptyCart(ev) {
            if (vm.cartItem.length > 0) {
                removeCart();
            }
        }

        $scope.addCustomProductToCart = function(product) {
            addToCart(product);
        }
        $scope.addGiftCardToCart = function(product) {

            var quantity = angular.copy(product.quantity);
            for (var i = 1; i <= quantity; i++) {
                $timeout(function() {
                    var myDate = new Date();
                    var time = myDate.getTime() + "";
                    product.product_id = time;
                    product.quantity = 1;
                    addToCart(product);

                }, 50);
            }
        }

        $scope.calculateTotalForItemUpdate = function(product, index) {
            addDiscountIfExists();
            if(index == -1){
                angular.forEach(vm.cartItem, function(value, tempIndex){
                    if(value.createdTime == product['createdTime']){
                        index = tempIndex;
                        vm.cartItem[index] = product;
                        calculateTotal();
                    }
                });
            }else{
                vm.cartItem[index] = product;
                calculateTotal();
                var discount = {
                    discount_name: '',
                    dicount_price: product['customDiscount']
                };
                var discountType = 'percentage';
                var funType = 'add';
            }            
        }
        vm.test = test;

        function test(discount, discountType, funType) {
            if (funType == 'add') {
                var percentage = discount.dicount_price;
                var sum = parseFloat(vm.subTotal) - parseFloat(vm.overAllTax);
                if (discountType == 'amount') {
                    percentage = (percentage / sum) * 100;
                }
                percentage = percentage > 100 ? 100 : percentage;
                vm.cartItem.forEach(function(element, index) {
                    var discount = (vm.cartItem[index]['customPrice'] * percentage) / 100;
                    vm.cartItem[index]['customDiscount'] = discount;
                    vm.cartItem[index]['customDiscountPercentage'] = percentage;
                    vm.cartItem[index]['particularCustomPrice'] = vm.cartItem[index]['customPrice'];
                    vm.cartItem[index]['particularDiscountAmount'] = 0.00;
                    vm.cartItem[index]['particularDiscountPercentage'] = 0.00;
                });

            } else {
                vm.cartItem.forEach(function(element, index) {
                    vm.cartItem[index]['customDiscount'] = 0.00;
                    vm.cartItem[index]['customDiscountPercentage'] = 0.00;
                });
            }
            calculateTotal();
        }

        $scope.addTimeBoundProduct = function(product, quantity, from, to, index, status) {
            addProductToCart(product, quantity, from, to, index, status);
        }



        /*calculate custom discount*/
        $scope.addCustomDiscountAll = function(discount, discountType, funType) {
            vm.tempDiscountAmount = discount.dicount_price;
            vm.tempDisCountType = discountType;
            // alert('CustomDiscount');
            if (funType == 'add') {
                var percentage = commonService.roundnum(discount.dicount_price, 2);
                var sum = parseFloat(vm.subTotal) - parseFloat(vm.overAllTax);
                if(sum == 0)
                    return;

                if (discountType == 'amount') {
                    vm.cartItem.forEach(function(element, index) {
                        if (element.is_tip_product) return true;
                        var discountAmt = parseFloat(percentage) > parseFloat(sum) ? commonService.roundnum(sum, 2) : percentage;

                        var perc = (discountAmt / sum) * 100;
                        var discount = (vm.cartItem[index]['customPrice'] * perc) / 100;
                        // var discount = (vm.cartItem[index]['customPrice'] * percentage) / 100;

                        vm.cartItem[index]['discountPer'] = 0;

                        vm.cartItem[index]['discountAmt'] = discount;
                        vm.cartItem[index]['customDiscount'] = discount;

                        vm.cartItem[index]['customDiscountPercentage'] = perc;
                        vm.cartItem[index]['particularCustomPrice'] = vm.cartItem[index]['customPrice'];
                        if (vm.cartItem[index]['product_is_timebound'] == 1) {
                            vm.cartItem[index]['prices']['nightlydiscount'] = [];
                            vm.cartItem[index]['prices']['nightlydiscountcomment'] = [];
                            vm.cartItem[index]['prices']['rates'].forEach(function(Relement, Rindex) {
                                vm.cartItem[index]['prices']['nightlydiscountcomment'].push('');
                                vm.cartItem[index]['prices']['nightlydiscount'].push($filter('number')(discount, 2));
                            });
                        }
                    });
                } else {
                    percentage = percentage > 100 ? 100 : percentage;
                    // var temp = angular.copy(vm.cartItem);
                    vm.cartItem.forEach(function(element, index) {
                        if (element.is_tip_product) return true;
                        vm.cartItem[index]['discountPer'] = percentage;
                        vm.cartItem[index]['discountAmt'] = 0.00;
                        var discount = (vm.cartItem[index]['customPrice'] * percentage) / 100;
                        vm.cartItem[index]['customDiscount'] = discount;
                        vm.cartItem[index]['customDiscountPercentage'] = percentage;
                        vm.cartItem[index]['particularCustomPrice'] = vm.cartItem[index]['customPrice'];
                        if (vm.cartItem[index]['product_is_timebound'] == 1) {
                            vm.cartItem[index]['prices']['nightlydiscount'] = [];
                            vm.cartItem[index]['prices']['nightlydiscountcomment'] = [];
                            vm.cartItem[index]['prices']['rates'].forEach(function(Relement, Rindex) {
                                var Singlediscount = (Relement * percentage) / 100;
                                vm.cartItem[index]['prices']['nightlydiscountcomment'].push('');
                                vm.cartItem[index]['prices']['nightlydiscount'].push($filter('number')(Singlediscount, 2));
                            });
                        }
                    });
                }
            } else {
                vm.cartItem.forEach(function(element, index) {
                    if (element.is_tip_product) return true;
                    vm.cartItem[index]['customDiscount'] = 0.00;
                    vm.cartItem[index]['product_discount'] = 0.00;
                    vm.cartItem[index]['customDiscountPercentage'] = 0.00;
                });
            }
            calculateTotal();
        }
        /*-----*/

        vm.getSum = getSum;

        function getSum(dataArray) {
            var sum = 0;
            dataArray.forEach(function(element, index) {
                sum = parseFloat(sum) + parseFloat(element);
            });
            return sum;
        }

        vm.minimumAmount = 0;

        function calculateTotal(check) {

            if (typeof check == 'undefined') {
                check = false;
            }
            vm.CartSubTotal = {};
            vm.subTotal = 0.00;
            vm.totalTip = 0.00;
            vm.overAllTax = 0.00;
            vm.overAllDiscount = 0.00;
            vm.discount_amount_total = 0.00;
            vm.deposit_amount_fix = 0.00;
            vm.overAllDiscountAmount = 0.00;
            if (vm.resDetails['pageFrom'] == 'reservation') {
                // vm.cartItem.forEach(function(element, index) {
                // if (element['product_is_timebound'] == 1 && (typeof element['auto_added'] == 'undefined' || ( typeof element['auto_added'] != 'undefined' && element['auto_added'] == 0))) {
                //  // vm.cartItem[index]['quantity'] = element['prices']['rates'].length;
                //  // vm.cartItem[index]['quantity'] = element['prices']['rates'];
                // }
                // });
            }
            var TipProductIndex = [];
            var userTaxExempt = typeof vm.resDetails['taxValue'] != 'undefined' && vm.resDetails['taxValue'] ? true : false;
            var isCcProcessingFeeTax = function(singleTax) {
                if (!singleTax || !singleTax.tax_name) return false;
                return String(singleTax.tax_name).toLowerCase().indexOf('cc processing fee') > -1;
            };

            var ccProcessingFeeApplied = !vm.waiveCcProcessingFee;
            vm.payment_method[0].cc_processing_fee_applied = ccProcessingFeeApplied;
            vm.payment_method[0].ccProcessingFeeApplied = ccProcessingFeeApplied;

            vm.cartItem.forEach(function(element, index) {
                // if (typeof vm.resDetails['taxValue'] != 'undefined' && vm.resDetails['taxValue'])
                //     var tax = 0;
                // else
                //     var tax = (element.tax_value * (element.customPrice - (element.customDiscount))) / 100;
                var tax = 0.00;
                var taxxAmount = 0.00;
                if(element.taxes && element.taxes.length > 0) {
                    angular.forEach(element.taxes, function(value, key) {
                        if(typeof element.taxes[key].tax_id != 'undefined'){
                            if (vm.waiveCcProcessingFee && isCcProcessingFeeTax(value)) {
                                vm.cartItem[index].taxes[key].tax_amount = 0;
                                vm.cartItem[index].taxes[key].tax_amt = 0;
                                vm.cartItem[index].taxes[key].tax = 0;
                                return;
                            }
                            vm.cartItem[index].taxes[key].tax_amount = 0;
                            var subTotalPrice = (typeof element.quantity !== 'undefined' && element.quantity !== undefined && element.quantity != '') ? parseInt(element.quantity) * parseFloat(element.customPrice) : element.customPrice;
                            var discountTotalAmount = (typeof element.quantity !== 'undefined' && element.quantity !== undefined && element.quantity != '') ? parseInt(element.quantity) * parseFloat(element.customDiscount) : parseFloat(element.customDiscount);
                            taxxAmount =  commonService.roundnum((value.tax_value * (subTotalPrice - discountTotalAmount))/100,2);
                            taxxAmount = userTaxExempt ? 0 : parseFloat(taxxAmount);
                            // taxxAmount = parseFloat(taxxAmount);
                            vm.cartItem[index].taxes[key].tax_amount = taxxAmount;
                            vm.cartItem[index].taxes[key].tax_amt = taxxAmount;
                            vm.cartItem[index].taxes[key].tax = taxxAmount;
                            taxxAmount =  commonService.roundnum((value.tax_value * (element.customPrice - (element.customDiscount)))/100,2);
                            taxxAmount = parseFloat(taxxAmount);
                            taxxAmount = userTaxExempt ? 0 : parseFloat(taxxAmount);
                            // taxxAmount = parseFloat(taxxAmount);
                            tax += taxxAmount;
                        }
                    });
                }
                /*Cart*/
                vm.cartItem[index]['tax'] = commonService.roundnum(parseFloat(tax * element.quantity), 2);
                vm.cartItem[index]['product_discount'] = commonService.roundnum(parseFloat((element.customDiscount) * element.quantity), 2);
                vm.cartItem[index]['discountPer'] = commonService.roundnum(parseFloat(element.customDiscountPercentage), 2);
                if (vm.resDetails['pageFrom'] == 'reservation') {
                    vm.cartItem[index]['pos_deposit_type_indicator'] = "zero";
                    vm.cartItem[index]['original_deposit_amt'] = commonService.roundnum(parseFloat(0), 2);
                } else {
                    vm.cartItem[index]['pos_deposit_type_indicator'] = vm.posDepositTypeIndicator;
                    vm.cartItem[index]['original_deposit_amt'] = commonService.roundnum(parseFloat(vm.cartItem[index]['grand_total']), 2);
                }
                vm.cartItem[index]['additional_guest_amounts'] = 0;
                vm.cartItem[index]['grand_total'] = parseFloat(commonService.roundnum(((parseFloat(element.customPrice) - parseFloat(element.customDiscount)) + parseFloat(tax)), 2) * element.quantity);
                vm.cartItem[index]['grand_total'] = commonService.roundnum(vm.cartItem[index]['grand_total'], 2);
                
                if ((vm.resDetails['pageFrom'] == 'reservation' && vm.resDetails['itinerary_number'] && vm.resDetails['itinerary_number'] != '') || vm.resDetails['pageFrom'] === 'order' || vm.resDetails['pageFrom'] === staticRestValue || vm.posDepositTypeIndicator != 'full') {
                    vm.cartItem[index]['pos_deposit_amount'] = 0;
                    vm.cartItem[index]['remaining_amount'] = parseFloat(vm.cartItem[index]['grand_total']);
                } else {
                    vm.cartItem[index]['pos_deposit_amount'] = parseFloat(vm.cartItem[index]['grand_total']);
                    vm.cartItem[index]['remaining_amount'] = 0;
                }
                vm.deposit_amount_fix += vm.cartItem[index]['pos_deposit_amount'];
                vm.cartItem[index]['nightlySum'] = commonService.roundnum(parseFloat(element['particularCustomPrice']), 2);
                if (element.is_tip_product) {
                    TipProductIndex.push(index);
                    vm.totalTip = vm.totalTip + parseFloat(element.product_price);
                }
                if ((element.is_tip_product || !vm.spliting || (vm.spliting && element.splitChecked == 'yes')) && (element.is_tip_product || !vm.add_tip_to_order || (vm.add_tip_to_order && element.use_count))) {
                    vm.overAllTax = parseFloat(vm.overAllTax) + (parseFloat(tax) * element.quantity);
                    vm.overAllTax = commonService.roundnum(parseFloat(vm.overAllTax), 2)
                   
                    if (typeof vm.resDetails['taxValue'] != 'undefined' && vm.resDetails['taxValue']) {
                        vm.overAllTax = 0.00;
                    }
                    vm.subTotal = (parseFloat(commonService.roundnum(parseFloat(element.customPrice) + parseFloat(tax), 2)) * element.quantity) + parseFloat(vm.subTotal);
                    vm.overAllDiscount = parseFloat(commonService.roundnum(parseFloat((element.customDiscount) * element.quantity) + parseFloat(vm.overAllDiscount), 2));

                    if (!check) {
                        if ((vm.resDetails['pageFrom'] == 'reservation' && vm.resDetails['itinerary_number'] && vm.resDetails['itinerary_number'] != '') || vm.resDetails['pageFrom'] === 'order' || vm.resDetails['pageFrom'] === staticRestValue || vm.posDepositTypeIndicator == 'zero') {
                            vm.minimumAmount = parseFloat(vm.minimumAmount) + parseFloat(0);
                        } else if (vm.posDepositTypeIndicator == 'full') {
                            vm.minimumAmount = parseFloat(vm.minimumAmount) + parseFloat(vm.cartItem[index]['grand_total']);
                        }
                    }
                    if (typeof vm.resDetails['pageFrom'] != 'undefined') {
                        if (vm.resDetails['pageFrom'] === 'order' || vm.resDetails['pageFrom'] === staticRestValue) {
                            vm.minimumAmount = parseFloat(vm.minimumAmount) + parseFloat(0);
                        }
                    }
                }
                vm.minimumAmount = commonService.roundnum(vm.minimumAmount, 2);
                vm.subTotal = commonService.roundnum(vm.subTotal, 2);
                if (element.hasOwnProperty('dynamic_attributes')) {
                    element.dynamic_attributes.forEach(function(element, index) {
                        if (element.type == 'date') {
                            element.value = moment(element.value).format('YYYY-MM-DD');
                        }
                    });
                }

            });

            vm.TipProductIndex = angular.copy(TipProductIndex);
            vm.CartSubTotal['totalTip'] = commonService.roundnum(parseFloat(vm.totalTip), 2);
            vm.CartSubTotal['subtotal'] = commonService.roundnum(parseFloat(vm.subTotal) - parseFloat(vm.overAllTax), 2);
            vm.CartSubTotal['discount'] = commonService.roundnum((parseFloat(vm.overAllDiscount)), 2);
            vm.CartSubTotal['tax'] = commonService.roundnum(parseFloat(vm.overAllTax), 2);
            vm.CartSubTotal['grand_total'] = commonService.roundnum(parseFloat(vm.subTotal) - parseFloat(vm.overAllDiscount), 2);
            vm.CartSubTotal['discount_amount'] = commonService.roundnum((parseFloat(vm.overAllDiscount)), 2);
            vm.CartSubTotal['product_discount'] = commonService.roundnum((parseFloat(vm.overAllDiscount)), 2);
            if (parseFloat(vm.minimumAmount) > parseFloat(vm.CartSubTotal['grand_total'])) {
                vm.minimumAmount = vm.CartSubTotal['grand_total'];
            }
            vm.CartSubTotal['remaining_amount'] = 0;
            vm.minimumAmount = vm.resDetails['pageFrom'] == 'reservation' ? 0 : commonService.roundnum(vm.minimumAmount, 2);
            
            vm.CartSubTotal['deposit_amount'] = commonService.roundnum(vm.minimumAmount, 2);
            vm.CartSubTotal['remaining_amount'] = commonService.roundnum((parseFloat(vm.CartSubTotal['grand_total']) - parseFloat(vm.minimumAmount)), 2);
            if (typeof vm.payingFromGC != 'undefined') {
                vm.CartSubTotal['gift_card_code'] = vm.payingFromGC['gcCode'];
                vm.CartSubTotal['gift_card_price'] = vm.payingFromGC['gcCardOrigPrice'];
                vm.CartSubTotal['paidFromGC'] = vm.payingFromGC['price'];
                vm.CartSubTotal['grand_total'] = vm.CartSubTotal['grand_total'];
                var temp = angular.copy(vm.payingFromGC.gcCardOrigPrice);

                if (parseFloat(vm.minimumAmount) < parseFloat(temp)) {
                    vm.CartSubTotal['paidFromGC'] = angular.copy(vm.minimumAmount);
                    vm.payingFromGC['price'] = angular.copy(vm.minimumAmount);
                } else {
                    vm.CartSubTotal['paidFromGC'] = angular.copy(parseFloat(vm.payingFromGC.gcCardOrigPrice));
                    vm.payingFromGC['price'] = angular.copy(parseFloat(vm.payingFromGC.gcCardOrigPrice));
                }
            }
            
            if (vm.resDetails.typeofService === 'bar') {
                $localStorage['barItem_' + $localStorage['preHotelId']] = vm.cartItem;
                $sessionStorage.TipProductIndex = vm.TipProductIndex;
            } else if (vm.resDetails.typeofService === staticRestValue) {
                $sessionStorage['restaurantItem_' + $localStorage['preHotelId']] = vm.cartItem;
                $sessionStorage.TipProductIndex = vm.TipProductIndex;
            } else {
                $sessionStorage['barItem_' + $localStorage['preHotelId']] = vm.cartItem;
            }

            var discountDetails = $localStorage['cartDiscount_' + $localStorage['preHotelId']];
            if (typeof discountDetails != 'undefined' && typeof discountDetails.discount_type != 'undefined' && discountDetails.hasOwnProperty('discount_type') && discountDetails.discount_type == 'amount') {
                vm.overAllDiscount = discountDetails.dicount_price;
            }
        }

        vm.removeGC = removeGC;
        function removeGC() {
            delete vm.payingFromGC['gcCode'];
            delete vm.payingFromGC['gcCardOrigPrice'];
            delete vm.payingFromGC['price'];
            delete vm.CartSubTotal['gift_card_code'];
            delete vm.CartSubTotal['gift_card_price'];
            delete vm.CartSubTotal['paidFromGC'];
            calculateTotal();
        }

        function updateItem(index, product, event) {
            event.preventDefault();
            if((typeof product.ingredients != 'undefined' && product.ingredients.length > 0) || (typeof product.restaurant_attributes != 'undefined' && Object.keys(product.restaurant_attributes).length > 0)){
                addToCart(product, index);
            } else {
                $mdDialog.show({
                    controller: 'cartProductUpdate',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/checkout/dialog/updateCartProduct.html',
                    parent: angular.element($document.find('#content-container')),
                    targetEvent: event,
                    scope: $scope.$new(),
                    clickOutsideToClose: true,
                    locals: {
                        product: product,
                        index: index,
                        Extradata: {},
                        tabName: vm.tabName,
                        selectCustomer: '',
                        allUsers: vm.allUsers
                    }
                });
            }            
        }

        function removeCartItem(index) {
            if ($localStorage['currentTabDetails'] && $localStorage['currentTabDetails'] != '' && ((vm.cartItem.length == 1 && vm.TipProductIndex.length == 0) || (vm.TipProductIndex.length > 1 && vm.cartItem.length == 2))) { //if deleting last cart item
                var title = 'Attention!';
                var html = 'Do you want to continue working on tab loaded after removing last item of the tab?';
                $mdDialog.show({
                    controller: 'confirmController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: true,
                    locals: {
                        title: title,
                        htmlContent: html,
                        cancelBtn: 'No',
                        OkBtn: 'Yes'
                    }
                }).then(function(answer) {
                    if (typeof answer != 'undefined' && answer == 'update') {
                        removeCartItemFinally(index);
                    } else {
                        removeCart();
                    }
                }, function() {});
            } else {
                removeCartItemFinally(index);
            }
        }

        function removeCartItemFinally(index) {
            vm.subTotal = 0;
            vm.totalTip = 0;
            vm.cartItemIds.splice(index, 1);
            vm.cartItem.splice(index, 1);
            //checkifNeedToDeleteTip();
            calculateTotal();
            if (vm.TipProductIndex.length == 0) vm.iamactive = 'no';
        }

        function addToCart(product, updateIndexValue) {
            if (product.product_is_timebound == 1 || (product.dynamic_attribute == 1 && product.dynamic_attributes.length > 0)) {
                getDaterange(product);
            } else if (product.product_pos_type === staticRestValue || (product.restaurant_attribute !== undefined && product.restaurant_attribute === '1')) {
                vm.fetchRestaurantIngrediants(product, updateIndexValue);
            } else {
                addProductToCart(product, 1, '', '', '', '');
            }
        }

        /**
        * fetch ingrediants of restaurant product
        */

        vm.fetchRestaurantIngrediants = function(product, updateIndexValue) {
            checkoutService.getRestaurantIngrediants(product.product_id).then(function(res) {
                if ((res.ingredients !== undefined && res.ingredients.length) || (res.restaurant_attributes !== undefined && Object.keys(res.restaurant_attributes).length)) {
                    product.restaurant_attributes = res.restaurant_attributes;
                    product.ingredients = res.ingredients;
                    getDaterange(product, updateIndexValue);
                } else {
                    addProductToCart(product, 1, '', '', '', '');
                }
            });
        };

        function getDaterange(product, updateIndexValue) {
            var temp_product = angular.copy(product);
            var event = '';
            $mdDialog.show({
                controller: 'customSale',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/checkout/dialog/posProduct.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: event,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                locals: {
                    tax: [],
                    product: temp_product,
                    pageDetails: vm.resDetails,
                    taxValue: vm.resDetails['taxValue'],
                    updateIndexValue: updateIndexValue
                }
            });
        }

        function addProductToCart(product, quantity, from, to, index, status) {            
            vm.subTotal = 0;
            vm.totalTip = 0;

            var itemIndex = vm.cartItemIds.indexOf(product['product_id']);
            var currentProductIndex = 0;
            if (index) {
                itemIndex = index;
            }

            if (((itemIndex == -1 || product['product_is_timebound'] == 1 || (typeof product['restaurant_attribute'] != 'undefined' && product['restaurant_attribute'] == 1) || (typeof product.ingredients != 'undefined' && product.ingredients.length)) && status != 'update') || (itemIndex != -1 && parseFloat(product.product_price) != parseFloat(vm.cartItem[itemIndex]['product_price']))){

                if (typeof product['quantity'] != 'undefined') {
                    quantity = product['quantity'];
                }
                var cartPro = angular.copy(product);
                cartPro['customPrice'] = parseFloat(cartPro['product_price']);
                cartPro['addOnPrice'] = 0;
                if (vm.tempDiscountAmount != 0 && !product.is_tip_product) {
                    var percentage = vm.tempDiscountAmount;
                    var sum = parseFloat(vm.subTotal) - parseFloat(vm.overAllTax);
                    if (vm.tempDisCountType == 'amount') {
                        percentage = (percentage / sum) * 100;
                    }
                    percentage = percentage > 100 ? 100 : percentage;
                    var discount = (cartPro['customPrice'] * percentage) / 100;
                    cartPro['customDiscount'] = discount;
                    cartPro['customDiscountPercentage'] = percentage;
                    cartPro['particularCustomPrice'] = cartPro['customPrice'];
                } else {
                    cartPro['customDiscount'] = 0.00;
                    cartPro['customDiscountPercentage'] = 0.00;
                    cartPro['particularCustomPrice'] = cartPro['customPrice'];
                }


                if (product['product_is_timebound'] == 1) {
                    // cartPro['from'] = new Date(moment(from).format());
                    // cartPro['to'] = new Date(moment(to).format());
                    cartPro['from'] = moment(from).format('YYYY-MM-DD');
                    cartPro['to'] = moment(to).format('YYYY-MM-DD');
                    var dateRange = getDates(from, to, cartPro['particularCustomPrice']);
                    cartPro['prices'] = angular.copy(dateRange);
                    cartPro['prices']['nightlydiscount'] = [];
                    cartPro['prices']['nightlydiscountcomment'] = [];
                    var temp_product_price = cartPro['customPrice'];

                    cartPro['prices']['rates'].forEach(function(Relement, Rindex) {
                        cartPro['prices']['nightlydiscountcomment'].push('');
                        cartPro['prices']['nightlydiscount'].push($filter('number')(0, 2));

                        if (Rindex != 0) {
                            cartPro['customPrice'] += temp_product_price;
                            cartPro['particularCustomPrice'] += temp_product_price;
                        }
                    });
                }
                 if (product['product_pos_type'] === staticRestValue) {
                        vm.temp_add_on_price = 0;
                        if (cartPro['selectedValue'] !== undefined && cartPro['selectedValue'] !== null) {
                            cartPro['selectedValue'].forEach(function(Relement, Rindex) {
                                vm.temp_add_on_price +=parseFloat(Relement.price) * parseFloat(Relement.quantity);
                            });
                            cartPro['customPrice'] = parseFloat(cartPro['customPrice'])+parseFloat(vm.temp_add_on_price);
                            cartPro['particularCustomPrice'] = parseFloat(cartPro['particularCustomPrice'])+parseFloat(vm.temp_add_on_price);
                            cartPro['addOnPrice'] = vm.temp_add_on_price;
                        }
                }

                cartPro['quantity'] = quantity;
                cartPro['total'] = parseFloat(cartPro['total']);
                cartPro['tax'] = 0;
                cartPro['product_discount'] = 0;
                cartPro['product_discount_comment'] = '';
                cartPro['discountPer'] = 0;
                cartPro['discountAmt'] = 0;
                cartPro['pos_deposit_type_indicator'] = 'full';
                if (vm.resDetails['pageFrom'] === 'reservation' || vm.resDetails['pageFrom'] === 'order' || vm.resDetails['pageFrom'] === staticRestValue) {
                    cartPro['pos_deposit_amount'] = 0
                    cartPro['remaining_amount'] = parseFloat(cartPro['total']);
                } else {
                    cartPro['pos_deposit_amount'] = parseFloat(cartPro['total']);
                    cartPro['remaining_amount'] = 0;
                }
                cartPro['additional_guest_amounts'] = 0;
                cartPro['grand_total'] = parseFloat(cartPro['total']);
                cartPro['original_deposit_amt'] = parseFloat(cartPro['total']);

                cartPro['orig_tax_value'] = product['tax_value'];
                cartPro['tax_value'] = product['tax_value'];

                // if (typeof vm.resDetails['taxValue'] != 'undefined' && vm.resDetails['taxValue']) {
                //     cartPro['tax_value'] = 0;
                // }
                cartPro['nightlySum'] = commonService.roundnum(parseFloat(cartPro['product_price']), 2);
                if (typeof vm.cartItem != 'undefined' && vm.cartItem['customDiscountPercentage'] > 0) {
                    cartPro['customDiscount'] = parseFloat(cartPro['particularCustomPrice'] - ((cartPro['particularCustomPrice'] * vm.cartItem[0]['customDiscountPercentage']) / 100));
                    cartPro['customDiscountPercentage'] = vm.cartItem[0]['customDiscountPercentage'];
                }

                delete cartPro['$$hashKey'];
                if ((product.product_pos_type === staticRestValue || vm.selectedPosType === staticRestValue) && typeof cartPro.updateIndexValue !== 'undefined') {
                    vm.cartItemIds[cartPro.updateIndexValue] = product['product_id'];
                    vm.cartItem[cartPro.updateIndexValue] = cartPro;
                } else {
                    vm.cartItemIds.unshift(product['product_id']);
                    vm.cartItem.unshift(cartPro);
                }
            } else {
                if (product['product_is_timebound'] == 0) {
                    var tempQuan = parseInt(vm.cartItem[itemIndex]['quantity']);
                    vm.cartItem[itemIndex]['quantity'] = parseInt(tempQuan + 1);
                } else if (product['product_is_timebound'] == 1) {                    
                    vm.cartItem[itemIndex]['customPrice'] = vm.cartItem[itemIndex]['product_price'];
                    vm.cartItem[itemIndex]['particularCustomPrice'] = vm.cartItem[itemIndex]['product_price'];
                    vm.cartItem[itemIndex]['quantity'] = quantity;
                    vm.cartItem[itemIndex]['from'] = moment(from).format('YYYY-MM-DD');
                    vm.cartItem[itemIndex]['to'] = moment(to).format('YYYY-MM-DD');
                    var dateRange = getDates(from, to, vm.cartItem[itemIndex]['particularCustomPrice']);
                    vm.cartItem[itemIndex]['prices'] = angular.copy(dateRange);
                }
                var tempData = angular.copy(vm.cartItem[itemIndex]);
                vm.cartItem.splice(itemIndex, 1);
                vm.cartItem.unshift(tempData);
                vm.cartItemIds.splice(itemIndex, 1);
                vm.cartItemIds.unshift(tempData['product_id']);
            }
            var aa = angular.copy(cartPro);            
            /*Cart*/

            if (product.is_tip_product) {
                if (vm.cartItem.length != 0)
                    vm.TipProductIndex.push(vm.cartItem.length - 1);
                else
                    vm.TipProductIndex.push(0);
                calculateTotal();
            } else {
                addDiscountIfExists(vm.cartItem.length - 1);
            }
            $location.hash('cart');
            $anchorScroll();
            return;

        }


        vm.addDiscountIfExists = addDiscountIfExists;

        function addDiscountIfExists(index) {
            var discountDetails = $localStorage['cartDiscount_' + $localStorage['preHotelId']];            
            if (typeof discountDetails != 'undefined' && typeof discountDetails.discount_type != 'undefined' && discountDetails.hasOwnProperty('discount_type')) {
                $scope.addCustomDiscountAll(discountDetails, discountDetails.discount_type, 'remove');
                $scope.addCustomDiscountAll(discountDetails, discountDetails.discount_type, 'add');
            } else {
                calculateTotal();
            }
        }

        vm.getDates = getDates;

        function getDates(startDate, stopDate, price) {
            var dateArray = [];
            var currentDate = moment(startDate);
            var stopDate = moment(stopDate);
            var priceArray = [];
            while (currentDate < stopDate) {
                dateArray.push(moment(currentDate).format('DD/MM/YYYY'))
                currentDate = moment(currentDate).add(1, 'days');
                priceArray.push(commonService.roundnum(price, 2));
            }
            var myArray = {};
            myArray['dates'] = dateArray;
            myArray['rates'] = priceArray;
            return myArray;
        }

        function switchPage(status) {
            if (status === 'back')
                vm.curPage = parseInt(vm.curPage) - 1;
            else if (status === 'forward')
                vm.curPage = parseInt(vm.curPage) + 1;

            var search = vm.search;
            if (vm.search == 'Search') {
                search = '';
            }

            var pageType = 'bar';

            if (vm.resDetails.typeofService == 'retail')
                pageType = vm.selectedPosType;
            else if (vm.selectedPosType == 'restaurant')
                pageType = vm.selectedPosType;
            else
                pageType = vm.resDetails.typeofService;

            var filter = {
                'offset': ((vm.curPage * vm.dataPerPage) - vm.dataPerPage),
                'limit': vm.dataPerPage,
                'pos_type_id': vm.category,
                'typeofService': pageType,
                'searchText': search
            };
            vm.isloading = true;
            checkoutService.getFilteredProducts(filter).then(function(response) {
                vm.categoryRelatedProducts = response['products']['products'];
                vm.totalProduct = response['totalProducts'];
                vm.isloading = false;
            });
        }

        function getAllFilteredProduct(cat_name, switchingPosProductType, from, type) {
            vm.search = vm.search.replace(/^\s+|\s+$/g, '');
            var search = vm.search;
            if (vm.search == 'Search') {
                search = '';
            }
            vm.curPage = 1;

            if (switchingPosProductType || (type != undefined && type == 'all_categories')) {
                vm.category = 0;
            }

            if(switchingPosProductType) {
                $localStorage["postype" + $localStorage['preHotelId']] = vm.selectedPosType;
                vm.selectedCat = "All Categories";
                var data = {
                    category : 0,
                    cat_name : vm.selectedCat
                }
                if(vm.selectedPosType == 'bar' || vm.selectedPosType == 'restaurant') {
                    $localStorage["category-" + vm.selectedPosType + $localStorage['preHotelId']] = data;
                }
            }

            var filters = {
                'offset': 0,
                'searchText': search,
                'limit': vm.dataPerPage,
                'pos_type_id': vm.category,
                'happy_hours': vm.happy_hours
            };

            filters.typeofService = vm.selectedPosType;
            /*if (vm.resDetails.typeofService === 'retail') {
            } else {
                filters.typeofService = vm.resDetails.typeofService;
            }*/


            vm.isloading = true;
            checkoutService.getFilteredProducts(filters).then(function(response) {                
                if (vm.resDetails.typeofService == 'bar' || vm.resDetails.typeofService === staticRestValue) {
                    vm.showCatNav = false;
                    /*if (from == 'category') {
                        vm.showCatNav = !vm.showCatNav;
                        vm.selectedCat = cat_name;
                    }*/
                }
                vm.categoryRelatedProducts = response['products']['products'];
                vm.totalProduct = response['totalProducts'];
                vm.isloading = false;
                vm.productCategory = response['category'];
                if (switchingPosProductType) vm.category = 0;
            });

        }

        function startNewOrder() {
            vm.checkoutPage = false;
            vm.afterCreatePage = false;
        }

        function continueSplitOrder() {
            vm.itinerary_number = '';
            vm.customer_email = '';
            vm.webpos_one_go_order_number = '';
            vm.finalTotal = '';
            vm.afterCreatePage = false;
        }

        function sendEmailToCustomer() {
            if (vm.customer_email != '') {
                vm.isloading = true;
                checkoutService.sendMailToCust({
                    webpos_one_go_order_number: vm.webpos_one_go_order_number,
                    cust_email_id: vm.customer_email
                }).then(function(response) {
                    vm.isloading = false;
                    if (!response.success && response.errorMsg) {
                        toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                    } else if (!response.success) {
                        toastMessage.showSimpleToast($translate.instant('CREATE_RES.SERVER_ERROR'), 'error-toast');
                    }
                });
            }
        }
        /* functions for tip starts*/
        $scope.applytipfinal = function(value, event, type, typeSelected, customerId, customerTipUserName) {
            vm.applytipfinal(value, event, type, 'dialog', typeSelected, customerId, customerTipUserName);
        }

        function applytipfinal(value, event, type, location, typeSelected, customerId, customerTipUserName) {
            if (location == 'samepage') vm.iamactive = value;
            else vm.iamactive = typeSelected;
            if (value == 'no') {
                vm.removetip();
                vm.splitcheck.splice(0, 1);
            } else {
                if (type == 'perc') {
                    if (vm.add_tip_to_order) var gt = parseFloat(vm.add_tip_to_grand_total);
                    else var gt = parseFloat(vm.subTotal - vm.overAllDiscount - vm.totalTip);
                    if (gt < 0) gt = 0;
                    var percentage = parseFloat(value);
                    var price = commonService.roundnum(parseFloat((gt * percentage) / 100), 2);
                } else {
                    var price = parseFloat(value);
                }

                if (customerId > 0) var customerTipName = 'Customer Tip for ' + customerTipUserName;
                else var customerTipName = 'Customer Tip';
                var myDate = new Date();
                var time = myDate.getTime() + "";
                var product = {
                    customDiscount: 0.00,
                    customPrice: price,
                    media: "",
                    product_id: time,
                    product_is_timebound: "0",
                    is_tip_product: true,
                    is_custom_product: true,
                    product_name: customerTipName,
                    tip_customer_id: customerId,
                    product_price: price,
                    product_type: "pos",
                    quantity: 1,
                    tax_value: 0.00,
                    tax_name: '',
                    tax_id: '',
                    total: price,
                    product_discount: 0.00
                };
                addToCart(product);
                vm.splitcheck.unshift(false);
            }
        }

        function checkifNeedToDeleteTip() {
            if (vm.cartItem.length == 1) {
                vm.cartItem.forEach(function(element, index) {
                    if (element.is_tip_product) {
                        removeCart();
                    }
                });
            }
        }

        function removetip() {
            if (vm.TipProductIndex.length > 0) {
                for (var ii = 0; ii < vm.TipProductIndex.length; ii++) {
                    vm.removeCartItem(vm.TipProductIndex[ii], event);
                    ii = -1;
                    continue;
                }
            }
            vm.iamactive = 'no';
        }

        function openOnlyAmtDialog(paymentForm, action, selectCustomer) {
            var event = '';
            $mdDialog.show({
                controller: 'cartProductUpdate',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/checkout/dialog/onlyNumberDialog.html',
                parent: angular.element($document.find('#content-container')),
                targetEvent: event,
                scope: $scope.$new(),
                clickOutsideToClose: true,
                locals: {
                    product: [],
                    index: -1,
                    tabName: vm.tabName,
                    selectCustomer: selectCustomer,
                    Extradata: {
                        action: action,
                        grandTotal: parseFloat(vm.subTotal - vm.overAllDiscount),
                        totalTip: parseFloat(vm.totalTip)
                    },
                    allUsers: vm.allUsers
                },
                onRemoving: function() {
                    if (action == 'change')
                        paymentFormValidate(paymentForm, true);
                }
            });
        }
        /* functions for tip ends*/

        /* Calculate change code starts */
        vm.expectedChange = 0;
        vm.amoutByCustomer = 0;
        $scope.setExpected = function(value, customTip, event) {
            if (parseFloat(value) > 0) {
                vm.expectedChange = value;
                vm.amoutByCustomer = customTip;
            }
        }
        /* Calculate change code ends */

        /* Card Swiper code starts */
        function trimNumber(s) {
            while (s.substr(0, 1) == '0' && s.length > 1) {
                s = s.substr(1, 9999);
            }
            return s;
        }

        function parseSwiperData(value) {
            if (value.charAt(0) !== '%') {
                return -1;
            }
            var p = new SwipeParserObj(value);
            var result = new Array();
            if (p.hasTrack1) {
                if (p.surname != null)
                    result[0] = p.surname + ' ' + p.firstname;
                else
                    result[0] = p.account_name;
                result[1] = p.account;
                result[2] = p.exp_month;
                result[3] = p.exp_year;
            }
            return result;
        }
        window.parseSwiperData = parseSwiperData;

        var method = 'authorizenet';
        vm.swipeText = 'Click here to swipe';
        vm.keyupfunction = keyupfunction;
        vm.paymentMethodSelected = paymentMethodSelected;
        vm.toggleCcProcessingFeeWaiver = toggleCcProcessingFeeWaiver;
        vm.ReadySwipe = ReadySwipe;
        vm.ResetSwipe = ResetSwipe;
        vm.swipeNow = swipeNow;
        vm.paymentFormValidate = paymentFormValidate;

        function toggleCcProcessingFeeWaiver() {
            var ccProcessingFeeApplied = !vm.waiveCcProcessingFee;
            vm.payment_method[0].cc_processing_fee_applied = ccProcessingFeeApplied;
            vm.payment_method[0].ccProcessingFeeApplied = ccProcessingFeeApplied;
            calculateTotal();
        }

        function swipeNow() {
            if (angular.element('#authorizenet-swiper-data')) {
                angular.element('#authorizenet-swiper-data').val(' ');
                angular.element('#authorizenet-swiper-data').select();
            }
        }

        function ReadySwipe() {
            vm.swipeText = 'Ready to swipe';
        }

        function ResetSwipe() {
            vm.swipeText = 'Click here to swipe';
        }

        function paymentFormValidate(paymentForm) {

            if (paymentForm.$valid == true && vm.spliting && parseFloat(vm.minimumAmount) > 0) {
                $timeout(function() {
                    $mdDialog.show({
                        clickOutsideToClose: false,
                        parent: angular.element($document.body),
                        scope: $scope,
                        preserveScope: true,
                        locals: {
                            splitCount: vm.splitCount
                        },
                        templateUrl: 'app/main/apps/checkout/dialog/completePayment.html',
                        controller: completePaymentController 
                    });

                    function completePaymentController($scope, $mdDialog, splitCount) {
                        $scope.splitCount = splitCount;
                        $scope.closeDialog = function() {
                            $mdDialog.hide();
                        };
                        $scope.completePayment = function() {
                            vm.proceedToCheckout();
                            $mdDialog.hide();
                        };
                    }
                }, 100);
            }
            if (paymentForm.$valid && vm.payment_method[0].method == 'Credit Card' && vm.resDetails.typeofService == 'bar') {
                if (vm.customerDetails == null) {
                    vm.customerDetails = vm.defaultCustomer;
                    vm.customerPreviousName = vm.customerDetails['first_name'] + '_&_' + vm.customerDetails['middle_name'] + '_&_' + vm.customerDetails['last_name'];
                }
                vm.customerDetails['first_name'] = vm.payment_method[0]['cc_fname'];
                vm.customerDetails['middle_name'] = '';
                vm.customerDetails['last_name'] = '';
            }
        }

        vm.customerPreviousName = '';

        function paymentMethodSelected(paymentForm, changeCalculated) {
            /*if (vm.resDetails.typeofService != 'bar')
                return;*/
            if (vm.payment_method[0].method == 'Credit Card') {
                $timeout(function() {
                    angular.element('#authorizenet-swiper-status').trigger('click');
                }, 0);
            }
            if (vm.spliting) {
                var count = 0;
                vm.cartItem.forEach(function(element, index) {
                    if (element.splitChecked == 'yes')
                        count++;
                });
                if (count == 0) {
                    vm.payment_method[0].method = '';
                    commonDailog.showSimpleDailog('Attention', '<p>Please select items for split order or cancel split payment.</p>');
                    return;
                }
            }
            if (vm.payment_method[0].method == 'Cash' && changeCalculated == false) {
                $timeout(function() {
                    openOnlyAmtDialog(paymentForm, 'change', '');
                }, 0);
            }
            // if (vm.payment_method[0].method == 'Credit Card' && vm.resDetails.typeofService == 'bar') {
            if (vm.payment_method[0].method == 'Credit Card') {
                if (vm.customerDetails == null && typeof vm.payment_method[0]['cc_fname'] != 'undefined') {
                    vm.customerDetails = vm.defaultCustomer;
                }
                if (vm.customerDetails != null) {
                    vm.customerPreviousName = vm.customerDetails['first_name'] + '_&_' + vm.customerDetails['middle_name'] + '_&_' + vm.customerDetails['last_name'];
                    if (typeof vm.payment_method[0]['cc_fname'] != 'undefined') {

                        vm.customerDetails['first_name'] = vm.payment_method[0]['cc_fname'];
                        vm.customerDetails['middle_name'] = '';
                        vm.customerDetails['last_name'] = '';
                    }
                }
            } else {
                if (vm.customerDetails != null && vm.customerPreviousName != '') {
                    var tempName = vm.customerPreviousName.split('_&_');
                    vm.customerDetails['first_name'] = tempName[0];
                    vm.customerDetails['middle_name'] = tempName[1];
                    vm.customerDetails['last_name'] = tempName[2];
                    vm.customerPreviousName = '';
                }
            }
        }

        function keyupfunction(event) {
            if (event.keyCode == 13) { // was: event.keyCode == 13
                var ccinfo = parseSwiperData(vm.ccinfo_a);
                var errorFound = false;
                if (ccinfo === -1) {} else {
                    if (ccinfo != null && ccinfo.length > 0) {

                        vm.payment_method[0].cc_fname = '';
                        vm.payment_method[0].cc_lname = '';
                        vm.payment_method[0].cc_number = '';
                        vm.payment_method[0].cc_number_mask = '';
                        vm.payment_method[0].cc_type = '';
                        vm.payment_method[0].cc_exp_month = '';
                        vm.payment_method[0].cc_exp_year = '';

                        var owner = ccinfo[0].trim().replace(/\s\s+/g, ' ');
                        var cc_owner = owner.split(" ");

                        if (cc_owner.length > 1) {
                            vm.payment_method[0].cc_fname = cc_owner[0];
                            vm.payment_method[0].cc_lname = cc_owner[cc_owner.length -1];
                        } else {
                            vm.payment_method[0].cc_fname = cc_owner[0];
                        }
                        if (ccinfo[1] == null) {
                            alert('Card number not detected!');
                            errorFound = true;
                        } else {
                            vm.payment_method[0].cc_number = ccinfo[1];
                            vm.payment_method[0].cc_number_mask = ccinfo[1].replace(/.*(\d{4})$/, "xxxx xxxx xxxx $1");
                            var startdigit = parseInt(ccinfo[1].charAt(0));
                            if (startdigit == 3)
                                vm.payment_method[0].cc_type = 'American Express';
                            if (startdigit == 4)
                                vm.payment_method[0].cc_type = 'Visa';
                            if (startdigit == 5)
                                vm.payment_method[0].cc_type = 'MasterCard';
                            if (startdigit == 6)
                                vm.payment_method[0].cc_type = 'Discover';
                            if (jQuery('select#' + method + '_cc_type').val() == "") {
                                alert('Card type not detected!');
                                errorFound = true;
                            }
                        }
                        if (ccinfo[2] == null) {
                            alert('Expiration month not detected!');
                            errorFound = true;
                        } else {
                            vm.payment_method[0].cc_exp_month = trimNumber(ccinfo[2]);
                        }
                        if (ccinfo[3] == null) {
                            alert('Expiration year not detected!');
                            errorFound = true;
                        } else {
                            vm.payment_method[0].cc_exp_year = ccinfo[3];
                            if (jQuery('#' + method + '_expiration_yr').val() == "") {
                                alert("The card might be expired!");
                                errorFound = true;
                            }
                        }
                        $timeout(function() {
                            angular.element('#authorizenet_cc_number_label').trigger('click');
                        }, 0);
                    } else {
                        alert("Cannot read the data!");
                        errorFound = true;
                    }
                    if (!errorFound) {
                        //~ onBlurCheckForm();
                    }
                    vm.ccinfo_a = "";
                    jQuery('#loading-mask').hide();
                }
            }
        }
        jQuery(document).on("click", '.payment-methods input[type=radio]', function() {
            swipeNow(jQuery('.payment-methods input[type=radio]:checked').val());
        });
        swipeNow(jQuery('input[name="payment[method]"]:checked').val());
        /* Card Swiper code ends */


        /* Split payment code starts */
        vm.show_split = false;
        vm.spliting = false;
        vm.splitText = 'Split Payment';
        vm.splitcheck = [];
        vm.checkboxClicked = false;

        vm.splitPaymentToggle = splitPaymentToggle;
        vm.addToSplitPayment = addToSplitPayment;
        vm.triggerClickOnCheckbox = triggerClickOnCheckbox;

        function triggerClickOnCheckbox(keyOrder) {
            if (vm.spliting) {
                if (!vm.checkboxClicked) {
                    if (vm.splitcheck[keyOrder])
                        vm.splitcheck[keyOrder] = false;
                    else
                        vm.splitcheck[keyOrder] = true;
                    vm.addToSplitPayment(keyOrder, vm.splitcheck[keyOrder], 'auto')
                } else {
                    vm.checkboxClicked = false;
                }
            }
        }

        function addToSplitPayment(keyOrder, checked, type) {
            if (vm.cartItem.length > 0) {
                if (type == 'clicked')
                    vm.checkboxClicked = true;
                var splitTotal = 0;
                if (checked) {
                    vm.cartItem[keyOrder]['splitChecked'] = 'yes';
                } else {
                    delete(vm.cartItem[keyOrder]['splitChecked']);
                }
                calculateTotal();
            }
        }

        function splitPaymentToggle() {
            if (vm.splitText == 'Split Payment') {
                vm.splitText = 'Cancel Split';
                splitQuantities();
            } else {
                vm.splitText = 'Split Payment';
                joinQuantities();
            }
        }

        function splitQuantities() {
            if (vm.cartItem.length > 0) {
                vm.spliting = true;
                //vm.removetip();
                vm.splitCount = 1;
                var cart_orders = angular.copy(vm.cartItem);
                var new_index = parseInt(vm.cartItem.length);
                vm.splitcheck = [];
                cart_orders.forEach(function(single_cart_item, keyOrder) {
                    vm.splitcheck.push(false);
                    cart_orders[keyOrder]['original_index'] = keyOrder;
                    if (single_cart_item.quantity > 1) {
                        var quantity = single_cart_item.quantity;
                        for (var i = 1; i < quantity; i++) {
                            var grand_total = (parseFloat(single_cart_item.customPrice) - parseFloat(single_cart_item.customDiscount)) + parseFloat(single_cart_item.tax);
                            cart_orders[keyOrder]['quantity'] = 1;
                            cart_orders[keyOrder]['grand_total'] = commonService.roundnum(grand_total, 2);

                            cart_orders[new_index] = angular.copy(single_cart_item);
                            cart_orders[new_index]['derived'] = 'yes';
                            cart_orders[new_index]['keyToModify'] = keyOrder;
                            vm.splitcheck.push(false);
                            new_index++;
                        }
                    }
                });
                vm.cartItem = angular.copy(cart_orders);
                if (vm.resDetails.typeofService === 'bar') {
                    $localStorage['barItem_' + $localStorage['preHotelId']] = angular.copy(vm.cartItem);
                } else if (vm.resDetails.typeofService === staticRestValue) {
                    $sessionStorage['restaurantItem_' + $localStorage['preHotelId']] = angular.copy(vm.cartItem);
                }
                calculateTotal();
            }
        }

        function selectCategory(category, cat_name) {
            vm.category = category;
            vm.selectedCat = cat_name;
            var data = {
                category : category,
                cat_name : cat_name
            }
            if(category == 'all_categories') {
                data.category = 0;
            }
            
            if(vm.selectedPosType == 'bar' || vm.selectedPosType == 'restaurant') {
                $localStorage["category-" + vm.selectedPosType + $localStorage['preHotelId']] = data;                
            }
            vm.getAllFilteredProduct(cat_name, false, 'category', category);
        }

        function joinQuantities() {
            if (vm.cartItem.length > 0) {
                //vm.removetip();
                vm.spliting = false;
                // var keys_to_splice = [];
                vm.splitcheck = [];
                var cart_orders = angular.copy(vm.cartItem);
                var cart_orders_new = [];
                var splited = false;
                cart_orders.forEach(function(single_cart_item, keyOrder) {
                    if (cart_orders[keyOrder].hasOwnProperty('splitChecked')) {
                        delete(cart_orders[keyOrder]['splitChecked']);
                    }
                    if(single_cart_item.original_index != undefined) {
                        splited = true;
                        var original_index = single_cart_item.original_index;
                        if(cart_orders_new[original_index] == undefined) {
                            cart_orders_new[original_index] = single_cart_item;
                        } else {
                            if(single_cart_item.derived != undefined) {
                                single_cart_item.derived = '';
                            }
                            cart_orders_new[original_index]['quantity'] = parseInt(cart_orders_new[original_index]['quantity']) + 1;
                            var grand_total_new = ((parseFloat(single_cart_item.customPrice) - parseFloat(single_cart_item.customDiscount)) + parseFloat(single_cart_item.tax)) * parseInt(cart_orders_new[original_index]['quantity']);
                            cart_orders_new[original_index]['grand_total'] = commonService.roundnum(grand_total_new, 2);
                        }    
                    }
                    /*if (single_cart_item.hasOwnProperty("derived") && single_cart_item.derived == 'yes') {
                        var keyToModify = single_cart_item.keyToModify;
                        if (typeof cart_orders[keyToModify] != "undefined") {
                            cart_orders[keyToModify]['quantity'] = parseInt(cart_orders[keyToModify]['quantity']) + 1;
                            var grand_total = ((parseFloat(single_cart_item.customPrice) - parseFloat(single_cart_item.customDiscount)) + parseFloat(single_cart_item.tax)) * parseInt(cart_orders[keyToModify]['quantity']);
                            cart_orders[keyToModify]['grand_total'] = commonService.roundnum(grand_total, 2);
                            keys_to_splice.push(keyOrder);
                        } else {
                            delete(cart_orders[keyOrder]['derived']);
                        }
                    }*/
                });

                if(!splited) {
                    cart_orders_new = cart_orders;
                }

                /*keys_to_splice.forEach(function(element, keyOrder) {
                    delete cart_orders[element];
                });*/
                cart_orders_new = cart_orders_new.filter(function(e) {
                    return e
                });
                // vm.cartItem = angular.copy(cart_orders);
                vm.cartItem = angular.copy(cart_orders_new);
                if (vm.resDetails.typeofService === 'bar') {
                    $localStorage['barItem_' + $localStorage['preHotelId']] = angular.copy(vm.cartItem);
                } else if (vm.resDetails.typeofService === staticRestValue) {
                    $sessionStorage['restaurantItem_' + $localStorage['preHotelId']] = angular.copy(vm.cartItem);
                }                
                calculateTotal();
            }
        }
        /* Split payment code ends */

        /*Print Preview Invoice start*/
        vm.printInvoice = function() {
            if (vm.spliting) {
                var count = 0;
                vm.cartItem.forEach(function(element, index) {
                    if (element.splitChecked == 'yes')
                        count++;
                });
                if (count == 0) {
                    commonDailog.showSimpleDailog('Attention', '<p>Please select items for split order or cancel split payment.</p>');
                    return;
                }
            }
            var requestData = {
                cartData: vm.cartItem,
                user: vm.customerDetails,
                paymentMethod: vm.payment_method,
                spliting: vm.spliting,
                printpreview: true
            };
            checkoutService.printInvoice(requestData).then(function(response) {
                var myWindow = window.open('', "_blank", "scrollbars=yes, resizable=yes, width=500, height=700")
                myWindow.document.write(response['data']);
                $timeout(function() {
                    myWindow.close();
                }, 400);
                /*New*/
            });
        }


        /*Print Preview Invoice end */

        /*Print Invoice start*/
        vm.printOrderInvoice = function() {
            checkoutService.printInvoice({
                webpos_one_go_order_number: vm.webpos_one_go_order_number,
                expectedChange: vm.expectedChangeForPrint,
                amoutByCustomer: vm.amoutByCustomer,
                itinerary_number: vm.itinerary_number,
                printpreview: false
            }).then(function(response) {
                var myWindow = window.open('', "_blank", "scrollbars=yes, resizable=yes, width=500, height=700");
                myWindow.document.write(response['data']);
                $timeout(function() {
                    myWindow.close();
                }, 400);
                /*new*/
            });
        }
        /*Print Invoice end */
        /*creditCardValidation*/
        vm.checkCreditCard = function() {
            vm.ccvError = false;
            if (vm.payment_method[0]['method'] == 'Credit Card') {
                if (vm.fieldsIsReadOnly) {
                    return false;
                }
                var regexp = /^[0-9]{3,4}$/;
                if (typeof vm.payment_method[0]['cc_fname'] != 'undefined' && typeof vm.payment_method[0]['cc_number'] != 'undefined' && typeof vm.payment_method[0]['cc_exp_year'] != 'undefined' && vm.payment_method[0]['cc_fname'].length > 0 && parseInt(vm.payment_method[0]['cc_exp_year'], 10) > 0 && vm.payment_method[0]['cc_number'].length > 10) {
                    var status = false;
                    if (typeof vm.payment_method[0]['cc_cid'] != 'undefined' && regexp.test(vm.payment_method[0]['cc_cid'])) {
                        status = false;
                        vm.ccvError = false;
                    } else {
                        if (typeof vm.payment_method[0]['cc_cid'] == 'undefined' || vm.payment_method[0]['cc_cid'].length == 0) {
                            status = false;
                            vm.ccvError = false;
                        } else {
                            status = true;
                            vm.ccvError = true;
                        }
                    }
                    return status;
                } else {
                    return true;
                }
            } else {
                return false;
            }

        }

        vm.getClass = getClass;

        function getClass(cart) {
            if (typeof cart['is_timebound_with_availability'] != 'undefined' && cart['is_timebound_with_availability'] == 1 && vm.currentPage != 'bar-checkout') {
                return 'list-customer ph-15 onlycursorPointer pointer_events_disabled';
            } else {
                return 'list-customer ph-15 onlycursorPointer';
            }
        }
        /*Code start's for Parking */
        vm.addParking = addParking;
        // get parking list pop up
        function addParking(ev, checkin, checkout, confirmation_number) {
            vm.myDate = new Date();

            // var startDate = new Date(
            //                         this.myDate.getFullYear(),
            //                         this.myDate.getMonth(),
            //                         this.myDate.getDate()
            //                       );

            var startDate = moment(vm.myDate);
            // startDate = new Date(moment(startDate, "DD-MM-YYYY"));
            var checkout = new Date(moment(startDate, "DD-MM-YYYY").add(1, 'days'));
            // return;

            if (vm.resDetails['checkin'] != '') {
                startDate = vm.resDetails['checkin'];
                checkout = vm.resDetails['checkout'];
            }
            var productIdsInCart = [];
            if (typeof vm.cartItem != 'undefined') {

                angular.forEach(vm.cartItem, function(value, key) {
                    if (value.is_timebound_with_availability == 1)
                        this.push({
                            product_id: value.product_id,
                            room_stay_from: moment(value.from).format('MM/DD/YYYY'),
                            room_stay_to: moment(value.to).format('MM/DD/YYYY')
                        });
                }, productIdsInCart);
            }

            var localData = {
                checkin: startDate,
                checkout: checkout,
                parking: true,
                add_screen: 'create',
                productIdsInCart: productIdsInCart,
                selectedParking: vm.cartItemIds,
                FromPage: 'bar-checkout',
                change_index: 0
            };

            $mdDialog.show({
                controller: 'parkingController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/e-commerce/views/orders/dialogs/parking/parking.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    localData: localData
                }
            });
        }
        /*add Parking to cart*/
        $scope.$on('addParkingProductToCart', function(event, data) {
            angular.forEach(data['pos'], function(value, key) {
                addProductToCart(value, 1, value['from'], value['to'], '', '');

            });
            // data['pos'].foreach(function(value, key){
            //     addProductToCart(value, 1, value['from'], value['to'],'','');
            // });
        });
        /*End*/

        vm.getPrice = getPrice;

        function getPrice(cart) {
            if (cart.product_is_timebound == 1) {
                return (cart.particularCustomPrice != 0 ? (cart.particularCustomPrice) : (cart.customPrice))

            } else {
                return (cart.particularCustomPrice != 0 ? (cart.particularCustomPrice * cart.quantity) : (cart.customPrice * cart.quantity))

            }

        }

        function tipToWhomName() {
            vm.allUsers.forEach(function(element, index) {
                if (element.user_id == vm.tipCustomerId) {
                    vm.customerTipUserName = element.first_name + ' ' + element.last_name;
                }
            });
        }

        /*
        ** Print cook's order
        */
        vm.printCooksOrder = function(){
            var cartItems = [];
            var orders = [];
            orders[0] = [];
            orders[1] = [];
            orders[2] = [];
            orders[3] = [];

            if(vm.cartItem.length > 0) {
                vm.cartItem.forEach(function(value, index) {
                    if(value.is_custom_product) {
                        value.fe_display_product_name = value.product_name;
                    }
                    if(!value.is_tip_product && !value.is_gift_card) {
                        cartItems.push(value);
                        if(value.product_pos_type != undefined && value.product_pos_type.toLowerCase() == 'bar') {
                            orders[3].push(value);
                        } else if(value.product_pos_type != undefined && value.product_pos_type.toLowerCase() === staticRestValue && value.pos_type_name != undefined && value.pos_type_name.toLowerCase() == 'pizza') {
                            orders[2].push(value);
                        } else if(parseInt(value.restaurant_attribute) == 0) {
                            orders[1].push(value);
                        } else {
                            orders[0].push(value);
                        }
                    }
                });
            }
            var requestData = {
                cartData: cartItems,
                allOrders: orders,
                user: vm.customerDetails,
                paymentMethod: vm.payment_method,
                printpreview: true,
                source: 'checkout'
            };
            
            if(cartItems.length > 0) {
                checkoutService.printCookOrder(requestData).then(function(response){
                    var myWindow = window.open('', "_blank", "scrollbars=yes, resizable=yes, width=500, height=700");
                    myWindow.document.write(response['data']);
                    myWindow.document.close();
                    myWindow.focus();
                });
            }
        }

        vm.saveHappyHoursSession = function(){
            $localStorage[vm.resDetails['typeofService'] + $localStorage['preHotelId']] = vm.happy_hours; 
            if(vm.resDetails['typeofService'] == 'bar'){
                vm.getAllFilteredProduct('',false,'');
            }else{
                vm.getAllFilteredProduct('',false,'category');
                
            }
        }


        setTimeout(function() {
           vm.autoFillOff = false;
        }, 1500); 
    }
})();
(function() {
    'use strict';

    angular
        .module('app.checkout')
        .controller('cartProductUpdate', cartProductUpdate);

    /** @ngInject */
    function cartProductUpdate(
        product,
        index,
        selectCustomer,
        $sessionStorage,
        $scope,
        $mdDialog,
        EnvironmentConfig,
        tabName,
        Extradata,
        commonService,
        $localStorage,
        checkoutService,
        allUsers,
        $rootScope
    ) {
        /*initialization*/
        var vm = this;
        vm.showQuantity = true;
        if(typeof product.is_gift_card != 'undefined' && product.is_gift_card){
            vm.showQuantity = false;
        }
        vm.productData = product;
        console.log(vm.productData,'vm.productData');
        if(typeof vm.productData != 'undefined'){
            vm.productData['quantity'] = angular.copy(parseInt(vm.productData['quantity']));
        }
        vm.loggedInUserId = $localStorage.userId;
        vm.selectUser = false;
        vm.tipCustomerId = 0;
        if(selectCustomer != ''){
            vm.selectUser = true;
            vm.allUsers = allUsers;
        }
		vm.customerTipUserName = '';    
        vm.quantity = product['quantity'];
        vm.popUpType = 'quantity';
        vm.priceType = 'percentage';
        vm.customPrice = "0.00";
        vm.customDiscount = "0.00";
        vm.baseUrl = EnvironmentConfig.api;
        vm.controllerStatus = 'updateProduct';
        vm.TempCustomPrice = product['customPrice'];
        if(index == -1){
            vm.controllerStatus = 'addNote';
        }
        vm.number = 0;
        vm.done = 0;
        vm.note = '';
        if(tabName != ''){
            vm.note = tabName;
        }
        if(Extradata.action && Extradata.action=='amt'){
			vm.priceType = 'amount';
			vm.popUpType = 'customTip';
			vm.dialogTitle = 'Customer Tip';
		}else if(Extradata.action && Extradata.action=='perc'){
			vm.priceType = 'percentage';
			vm.popUpType = 'customTip';
			vm.dialogTitle = 'customTip';
		} else if(Extradata.action && Extradata.action=='change'){
			vm.priceType = 'amount';
			vm.popUpType = 'change';
			vm.dialogTitle = 'Calculate Change';
		}
        vm.posProduct =  [];
        if(vm.productData['product_is_timebound'] == 1){
          vm.myDate = new Date();
          vm.minDate = new Date(
              this.myDate.getFullYear(),
              this.myDate.getMonth(),
              this.myDate.getDate()
          );

          vm.posProduct.from =  vm.productData['from'];
          vm.posProduct.to = vm.productData['to'];

          var new_date = moment(vm.productData['from'], "DD.MM.YYYY");
          var thing = new_date.add(0, 'days');
          vm.fromMinDate =  thing['_d'];
        }
        if(Extradata['PageType'] == 'bar'){
             if ($localStorage.barNote) {
                vm.note = $localStorage.barNote;
            } else {
                vm.note = '';
            }

        }else {
            if ($sessionStorage['cartNote_' + $localStorage['preHotelId']]) {
                vm.note = $sessionStorage['cartNote_' + $localStorage['preHotelId']];
            } else {
                vm.note = '';
            }

        }

        vm.showRestaurantAttributes = (typeof vm.productData.restaurant_attributes != 'undefined' && Object.keys(vm.productData.restaurant_attributes).length > 0) ? true : false;
        vm.dropDownArray = [];
        vm.multiChoiceArray = [];
        console.log(vm.productData.restaurant_attributes,'vm.productData.restaurant_attributes');
        if (typeof vm.productData.restaurant_attributes != 'undefined' && Object.keys(vm.productData.restaurant_attributes).length > 0) {
            angular.forEach(vm.productData.restaurant_attributes, function(value, key) {
                if (key == 'dropdown') {
                     vm.dropDownArray = value;
                     }

                if (key == 'multichoice') {
                    vm.multiChoiceArray = value;
                   }
            });

        }
        vm.restaurant_selected_attributes = [];
        
        vm.updateQuantity = updateQuantity;
        vm.changePopUpContent = changePopUpContent;
        vm.updateCustomPrice = updateCustomPrice;
        vm.customAmountType = customAmountType;
        vm.closeDialog = closeDialog;
        vm.goToquantity = goToquantity;
        vm.addNoteToCart = addNoteToCart;
        vm.updateDate = updateDate;
        vm.convert = convert;
        vm.getNumber = getNumber;
        vm.UpdateInputBox = UpdateInputBox;
        vm.tempNumber = 0.00;
        vm.customTip = 0.00;
        vm.closeModal = closeModal;
        function closeModal(){
           $mdDialog.hide();
        }

        function UpdateInputBox(number){
			if(number == -1){
				vm.tempNumber = commonService.roundnum(vm.tempNumber,2);
				if(vm.tempNumber > 0){
					vm.tempNumber = commonService.roundnum(vm.tempNumber*0.1,3);
					vm.tempNumber = vm.tempNumber + "";
					vm.tempNumber = vm.tempNumber.slice(0, -1);
					vm.tempNumber = commonService.roundnum(parseFloat(vm.tempNumber),2);
				}else
					vm.tempNumber = '0.00';
			} else if(vm.tempNumber > 0 && typeof number == 'string'){
				vm.tempNumber = commonService.roundnum(parseFloat(vm.tempNumber) * 100,2);
			} else if(typeof number == 'number' && ((number == 0 && vm.tempNumber > 0) || number > 0 )){
				number = parseFloat(number) * 0.01;
				vm.tempNumber = commonService.roundnum((parseFloat(vm.tempNumber) * 10) + parseFloat(number),2);
			} else if(vm.tempNumber == 0 && (number == 0 || number == '00')){
				vm.tempNumber = '0.00';
			}
			if(vm.popUpType == 'customPrice'){
				vm.customPrice = (typeof vm.tempNumber == 'string') ? vm.tempNumber : parseFloat(vm.tempNumber);
			}else if(vm.popUpType == 'discount'){
				vm.customDiscount = (typeof vm.tempNumber == 'string') ? vm.tempNumber : parseFloat(vm.tempNumber);
			}else if(vm.popUpType == 'customTip' || vm.popUpType == 'change'){
				 vm.customTip = (typeof vm.tempNumber == 'string') ? vm.tempNumber : parseFloat(vm.tempNumber);
			}
		}

        function getNumber(num){
            if(num <= 9){
                vm.number = parseInt(num)+ parseInt(1);
                return vm.number;
            }
        }

        function convert(str) {
		  var date = new Date(str),
		  mnth = ("0" + (date.getMonth()+1)).slice(-2),
		  day  = ("0" + date.getDate()).slice(-2);
		  return [ date.getFullYear(), mnth, day ].join("-");
        }

        function updateDate(){
          var date1 = new Date(convert(vm.posProduct.from));
          var date2 = new Date(convert(vm.posProduct.to));
          var diffDays = Math.floor(( Date.parse(date2) - Date.parse(date1) ) / 86400000);
          var new_date = moment(date1, "DD.MM.YYYY");
          var thing = new_date.add(1, 'days');
          vm.fromMinDate =  thing['_d'];
          if(diffDays > 0){
            $scope.$parent.addTimeBoundProduct(product, diffDays, date1, date2, index, 'update');
          }
        }

        function addNoteToCart() {
            if(Extradata['PageType'] == 'bar'){           
                    $localStorage.barNote = vm.note;
                }else {
                    $sessionStorage['cartNote_' + $localStorage['preHotelId']] = vm.note;
                }
            $mdDialog.cancel();
        }

        $scope.$on('greeting', listenGreeting);

        function closeDialog() {
            $mdDialog.cancel();
        }

        function listenGreeting($event, message) {
            if (vm.done == 0 && vm.controllerStatus == 'updateProduct') {
                updateCustomPrice();
            }
        }

        function goToquantity() {
            vm.popUpType = 'quantity';
            vm.tempNumber = 0;
        }
       

        function updateCustomPrice(event) {
            vm.done = 1;
            var price = product['customPrice'];
            if(vm.popUpType=='customTip'){
				if(vm.customTip && parseFloat(vm.customTip)>=0){
					if(vm.priceType == 'percentage'){
						var gt = Extradata.grandTotal;
						var oldTip = Extradata.totalTip;
						gt = parseFloat(gt) - parseFloat(oldTip);
						var newtip = commonService.roundnum(((parseFloat(vm.customTip)*gt)/100),2);
					}else{
						var newtip = parseFloat(vm.customTip);
					}
					vm.allUsers.forEach(function(element, index) {
						if(element.user_id==vm.tipCustomerId){
							vm.customerTipUserName = element.first_name+' '+element.last_name;
						}
					});
					$scope.$parent.applytipfinal(newtip,event,'amt',vm.priceType, vm.tipCustomerId,vm.customerTipUserName);
				}
            } else if(vm.popUpType=='change') {
				var gt = Extradata.grandTotal;
				if(vm.customTip && parseFloat(vm.customTip)>=0 && parseFloat(vm.customTip)>=parseFloat(gt)){
					var expectedChange = commonService.roundnum(parseFloat(vm.customTip) - parseFloat(gt),2);
					$scope.$parent.setExpected(expectedChange,vm.customTip,event);
				} else {
					$scope.$parent.setExpected(0,event);
				}
			} else if(vm.customPrice || vm.popUpType === 'customPrice' || vm.popUpType === 'discount'){

				if (vm.popUpType === 'customPrice') {
					if (vm.priceType == 'amount') {
						product['customPrice'] = vm.customPrice;
						product['particularCustomPrice'] = product['customPrice'];

						if(product['product_is_timebound'] == 1){
							var count = 0;
							product['prices']['rates'].forEach(function(element, index) {
								product['prices']['rates'][index] = product['particularCustomPrice'];
								count++;

							}, this);

							product['customPrice'] = vm.customPrice *  count;
							product['particularCustomPrice'] = product['customPrice'];
							product['quantity'] = 1;
						}
					} else if (vm.priceType == 'percentage') {
						product['customPrice'] = (price * vm.customPrice) / 100;
						product['particularCustomPrice'] = product['customPrice'];

						if(product['product_is_timebound'] == 1){
							var count = 0;
							product['prices']['rates'].forEach(function(element, index) {
								product['prices']['rates'][index] = product['particularCustomPrice'];
								count++;

							}, this);
							product['customPrice'] = vm.customPrice *  count;
							product['particularCustomPrice'] = product['customPrice'];
							product['quantity'] = 1;
						}
					}
					if(product['customDiscountPercentage'] > 0){
						var discount = (product['customPrice'] * product['customDiscountPercentage'] )/100;
						product['customDiscount'] = discount;
					}
					// if(product['particularDiscountPercentage'] > 0){
					//     var discount = product['customPrice'] - ((product['customPrice'] *product['particularDiscountPercentage'])/100);
					//     product['particularDiscountAmount'] = discount;
					// }
				} else if (vm.popUpType === 'discount') { /*Custom Discount*/

                    $localStorage['cartDiscount_' + $localStorage['preHotelId']] = '';
                    $rootScope.isDiscountApplied = false;


                    var doNotProcess = false;
                        if(parseFloat(product['product_price'])==0){
                            doNotProcess = true;
                            $mdDialog.cancel();
                        }
					if (vm.priceType == 'amount' && !doNotProcess) {
                       
                        	var discountAmt = parseFloat(vm.customDiscount) > parseFloat(product['particularCustomPrice']) ? product['particularCustomPrice']: vm.customDiscount ;
							var perc = (vm.customDiscount / product['product_price']) * 100;
							product['discountPer'] = 0;
							product['discountAmt'] = 0;
							product['customDiscount'] = discountAmt;
							product['customDiscountPercentage'] = perc;
							product['particularCustomPrice'] =product['customPrice'];
							if(product['product_is_timebound'] == 1){
                                var timeBoundDiscount =0;
								product['prices']['nightlydiscount']  = [];
								product['prices']['nightlydiscountcomment']  = [];
								product['prices']['rates'].forEach(function(Relement ,Rindex){
                                    timeBoundDiscount += parseFloat(discountAmt);
									product['prices']['nightlydiscountcomment'].push('');
									product['prices']['nightlydiscount'].push(discountAmt);
								});
                                product['customDiscount'] = timeBoundDiscount;
							}


					} else if (vm.priceType == 'percentage' && !doNotProcess) {
						vm.customDiscount = parseFloat(vm.customDiscount) > 100 ? 100 : vm.customDiscount;
                            // product['discountPer'] = vm.customDiscount;
							product['discountPer'] = 0;
							product['discountAmt'] = 0;
							var discount = (product['customPrice'] * vm.customDiscount) / 100;
							product['customDiscount'] = discount;
							product['customDiscountPercentage'] = vm.customDiscount;
							product['particularCustomPrice'] = product['customPrice'];
							if(product['product_is_timebound'] == 1){
                                var timeBoundDiscount =0; 
								product['prices']['nightlydiscount']  = [];
								product['prices']['nightlydiscountcomment']  = [];
								product['prices']['rates'].forEach(function(Relement ,Rindex){
									var Singlediscount = (Relement * vm.customDiscount) / 100;
                                    timeBoundDiscount+=Singlediscount;
									product['prices']['nightlydiscountcomment'].push('');
									product['prices']['nightlydiscount'].push(Singlediscount);
								});
                                product['customDiscount'] = timeBoundDiscount;
							}
					}
				}
                $scope.$parent.calculateTotalForItemUpdate(product, index);
            }
            $mdDialog.cancel();
        }

        function customAmountType(type) {
            vm.customPrice = 0;
            vm.customDiscount = 0;
            vm.tempNumber = 0;
            vm.priceType = type;
        }

        function changePopUpContent(type) {
            vm.popUpType = type;
            if(type == 'customPrice'){
               vm.priceType = 'amount';
            } else {
               vm.priceType = 'percentage';
            }
        }


        function updateQuantity(type) {
            if (type == 'positive') {
                vm.quantity = parseInt(vm.quantity) + parseInt(1);
                } else if (type == 'negative' && vm.quantity > 1) {
                    vm.quantity = parseInt(vm.quantity) - parseInt(1);
                } else if(vm.quantity < 0 ){
                    vm.quantity = 1;
                }
                if(vm.quantity){
                    if(vm.quantity > 1000) vm.quantity = 1000;
                    product['quantity'] = vm.quantity;
                    $scope.$parent.calculateTotalForItemUpdate(product, index);
              }
        }
        /*get tab name*/
        vm.tabName = '';
        vm.getTabOrderName = function(){
            $scope.$parent.getTabName(vm.tabName);
            $mdDialog.hide();
        }
      }
})();
(function ()
{
    'use strict';

    angular
        .module('app.channels',
            [
                // 3rd Party Dependencies
                'xeditable',
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.channels', {
            url    : '/channels',
            title  : 'Channels',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/channels/channels.html',
                    controller : 'channels as vm'
                }
            },
                 resolve  : {
                    FormData: function (){
                        return [];
                    }
                },
                permission: 'channels',
        })
        .state('app.channelsAdd', {
            url    : '/channel/add',
            title  : 'Channels',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/channels/channelsAddEdit.html',
                    controller : 'channels as vm'
                }
            },
             resolve  : {
				FormData: function (channelService,$localStorage,$stateParams){
					return channelService.getFormData( {hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id, status:$stateParams.status});
				}
			},
			permission: 'add_channel',
            bodyClass: 'channels'
        }).state('app.channelsEdit', {
            url    : '/channel/:status',
            title  : 'Channels',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/channels/channelsAddEdit.html',
                    controller : 'channels as vm'
                }
            },
             resolve  : {
				FormData: function (channelService,$localStorage,$stateParams){
					return channelService.getFormData( {hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id, status:$stateParams.status});
				}
			},
			permission: 'update_channel',
            bodyClass: 'channels'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/channels');

    }

})();

  (function() {
    'use strict';

    angular
    .module('app.channels')
    .controller('channels', channels);

    /** @ngInject */
    function channels(
      $stateParams,
      $state,
      $scope,
      $http,
      EnvironmentConfig,
      $mdDialog,
      toastMessage,
      $localStorage,
      $document,
      groupService,
      channelService,
      commonService,
      FormData,
      $sessionStorage,
      $rootScope
      ) {
      var vm = this;

      if(!$rootScope.backButtonPressed){
        $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = {};
        $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] = 1;
        $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'] = 50;
      }

      if(typeof $stateParams.status=='undefined'){
        vm.pageStatus = 'add';
      }else{
        vm.pageStatus = $stateParams.status;
      }
      vm.pageHeader = "Channels";
      vm.gotoaddRole = commonService.gotoaddChannel;
      vm.gotoGroupListing = gotoGroupListing;
      vm.selectAllModules = selectAllModules;
      vm.saveChannel = saveChannel;
      vm.updateChannel = updateChannel;
      vm.customers = [];
      vm.groupForm = {};
      vm.SelectedCustomers = [];
      vm.selectedIdsArray = [];
      vm.selectedOption = true;
      vm.userPermissions = $rootScope.userPermissions;
      if (vm.userPermissions.indexOf('delete_channel') != -1) {
        vm.delete_product = true;
      } else {
        vm.delete_product = false;
      }

      vm.isParent = false
      vm.childHotel = [];
      vm.loggedInUserRole = angular.copy(parseInt($localStorage.roleId));

      if (typeof $stateParams.status == 'undefined' || $stateParams.status>0) {
        if(FormData[0]){
          vm.channels = FormData[0]['channels'];
          vm.roomsAssociatedRateCategory = FormData[0]['roomsAssociatedRateCategory'];

          vm.isParent = FormData[0]['isParent'];
          vm.childHotel = FormData[0]['subHotel'];
          if (typeof $stateParams.status != 'undefined') {
            if(FormData[0]['channelsDetails']){
              vm.channels.channel_id = FormData[0]['channelsDetails'][0]['channel_id'];
              vm.pageHeader = FormData[0]['channelsDetails'][0]['channel_name'];
              vm.selectedIdsArray = FormData[0]['preSelectedArr'];
              vm.PreChannelId = FormData[0]['channelsDetails'][0]['channel_id'];
              if (vm.userPermissions.indexOf('update_channel') === -1) {
                $state.go('app.dashboards_project');
                toastMessage.showSimpleToast('Access denied.', 'error-toast');
              }
            }else{
              $state.go("app.channels");
            }
          } else {
            if (vm.userPermissions.indexOf('add_channel') === -1) {
              $state.go('app.dashboards_project');
              toastMessage.showSimpleToast('Access denied.', 'error-toast');
            }
          }
        }
      }

      $scope.checkSelect = function() {}
      function gotoGroupListing() {
        $state.go("app.channels", {
          status: 'add'
        });
      }

      /*Start*/
      $scope.paginatorCallback = paginatorCallback;
      $scope.LoadAllData = LoadAllData;
      $scope.getLoadResultsCallback = getLoadResultsCallback;
      vm.toggle = toggle;

      function saveChannel() {
        var data = {
          channel_id: vm.channels.channel_id,
          selecetdRooms: vm.selectedIdsArray,
          hotel_id: $localStorage.hotels[$localStorage.selectedHotel].hotel_id
        }

        channelService.checkChannelName(data).then(function(response) {
          if (!response[0]) {
            channelService.addChannel(data).then(function(response) {
              if (response) {
                $state.go("app.channels");
              }
            });

          } else {
            vm.channelNameExists = 'Channel already exists';
          }
        });
      }

      function updateChannel() {
        if (vm.selectedIdsArray.length != 0) {
          var data = {
            channel_id: vm.channels.channel_id,
            selecetdRooms: vm.selectedIdsArray,
            hotel_id: $localStorage.hotels[$localStorage.selectedHotel].hotel_id,
            preChannel_id: vm.PreChannelId
          }
          channelService.UpdateChannel(data).then(function(response) {
            if (response) {
              $state.go("app.channels");
            }
          });
        }
      }

      function toggle(rpchild, key, subkey, grandKey, myId, room_type_id) {
        var status = vm.roomsAssociatedRateCategory[grandKey]['relation'][key]['children'][subkey]['selected'] == true ? false : true;
        vm.roomsAssociatedRateCategory[grandKey]['relation'][key]['children'][subkey]['selected'] = status;
        var parent_id = vm.roomsAssociatedRateCategory[grandKey]['relation'][key]['children'][subkey]['parent_id'];
        var deleteIndex = -1;
        vm.selectedIdsArray.forEach(function(value, index) {
          if (value.rateCat == parent_id && value.ratePlanId == room_type_id) {
            deleteIndex = parseInt(index);
          }
        });
        if (deleteIndex == -1 || vm.selectedIdsArray.length == 0) {
          vm.selectedIdsArray.push({
            rateCat: parseInt(parent_id),
            ratePlanId: parseInt(room_type_id)
          });
          var testData =  parent_id+'@'+room_type_id;
          vm.testRoomRatePlanId.push(testData);
          var temp = angular.copy(vm.testRoomRatePlanId);
          vm.testRoomRatePlanString = temp.toString();

        } else {
          vm.selectedIdsArray.splice(deleteIndex, 1);
          vm.testRoomRatePlanId.splice(deleteIndex, 1);
          var temp = angular.copy(vm.testRoomRatePlanId);
          vm.testRoomRatePlanString = temp.toString();
        }
        if (vm.selectedIdsArray.length == 0) {
          vm.selectedOption = true;
        } else {
          vm.selectedOption = false;
        }

        /*Select parent if derived selectd*/
        var parent_id = vm.roomsAssociatedRateCategory[grandKey]['relation'][key]['parent_id'];
        var childIds = [];
        var isChildPresent = -1;
        var isParentPresent = -1;
        vm.roomsAssociatedRateCategory[grandKey]['relation'][key]['children'].forEach(function(element, element_index) {
          childIds.push(parseInt(vm.roomsAssociatedRateCategory[grandKey]['relation'][key]['children'][element_index]['parent_id']));
        });
        vm.selectedIdsArray.forEach(function(element, element_index) {
          var childIndex = childIds.indexOf(parseInt(element['rateCat']));
          if (childIndex != -1) {
            isChildPresent = element_index;
          }
          if (element['rateCat'] == parent_id && room_type_id == element['ratePlanId']) {
            isParentPresent = element_index;
          }
        });

        if (isChildPresent !== -1 && isParentPresent == -1) {
          vm.selectedIdsArray.push({
            rateCat: parseInt(parent_id),
            ratePlanId: parseInt(room_type_id)
          });
          vm.roomsAssociatedRateCategory[grandKey]['relation'][key]['selected'] = true;
        } else if (isChildPresent == -1 && isParentPresent != -1) {
          vm.selectedIdsArray.splice(isParentPresent, 1);
          vm.roomsAssociatedRateCategory[grandKey]['relation'][key]['selected'] = false;
        }

        /*Select parent if derived selectd*/

      }
      $scope.selectedRowCallback = function(rows) {
        vm.selectedprodId = rows;
        vm.checkDelete = false;
      };
      var loadPageCallbackWithDebounce;
      $scope.$watch('filterText', function() {
        if (loadPageCallbackWithDebounce) {
          loadPageCallbackWithDebounce();
        }
      });
      $scope.showTabDialog = function(ev, id) {
        roleService.getRolePermissions(id).then(function(response) {
          if (response.listData.length == 0) {
            toastMessage.showSimpleToast('This role has no module assigned.', 'error-toast');
          } else {
            $state.go('app.channels', {
              id: id
            });

          }
        });
      };
      $scope.userPermissions = vm.userPermissions;
      $scope.updateTable = function() {
        loadPageCallbackWithDebounce();
      };

      $scope.toggleAll = function() {
        var toggleStatus = !$scope.isAllSelected;
        $scope.ChangeAll = toggleStatus;
      }
      $scope.checkBox = function(value) {
        if (vm.selectedprodId.indexOf(value) > -1) {
          vm.selectedprodId.splice(vm.selectedprodId.indexOf(value), 1);
        } else {
          vm.selectedprodId.push(value);
        }
        if (vm.selectedprodId.length > 0) {
          vm.getNumberOfSelectedRows = vm.selectedprodId.length;
          vm.checkDelete = true;
        } else {
          vm.checkDelete = false;
        }
      };
      $scope.deleteSelectedItem = function(ev, selectedprodId) {

               // new
               var html = 'Are you sure, you want to delete the selected channel(s)? </br>';
               html = html + '<b>' + vm.selectedprodId.length + ' channel(s)</b>' + ' will be deleted.';

               $mdDialog.show({
                controller: 'confirmController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/contacts/confirmationPopUp/confirmation.html',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose:true ,
                locals: {
                  title: 'Delete Channel',
                  htmlContent:html,
                  cancelBtn:'Cancel',
                  OkBtn:'Ok'
                }                
              })
               .then(function(answer) {
                 if(typeof answer != 'undefined' && answer == 'update'){
                  var data = {
                    hotel_id: $localStorage.hotels[$localStorage.selectedHotel].hotel_id,
                    deleteIds: vm.selectedprodId
                  };
                  channelService.deleteSelectedChannel(data)
                  .then(function(response) {
                    if (response.errorMsg) {
                      toastMessage.showSimpleToast(response.errorMsg, 'error-toast');
                    } else {
                      loadPageCallbackWithDebounce();
                      vm.selectedprodId = [];
                    }
                  });
                }
              }, function() {}); 
            //Old
          };

          function getLoadResultsCallback(loadPageCallback) {
            loadPageCallbackWithDebounce = _.debounce(loadPageCallback, 1000);
          }
          vm.UserColumns = [
          'ch.channel_name',
          'room_type_name',
          'rate_plan_name'
          ];

          vm.onLoad = true;
          vm.requestGoing = false;
          function paginatorCallback(page, pageSize, option) {
            if(vm.requestGoing) return;
            if(vm.onLoad == true){
              if(typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] != 'undefined' && typeof $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'] != 'undefined'){

                var page1 =  $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
                var pageSize1 = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['pageSize'];
                vm.onLoad = false;
                return LoadAllData(page1, pageSize1,option);
              }else{
                vm.onLoad = false;
                return LoadAllData(page, pageSize,option);    
              }
            }else{
              if(typeof page == 'undefined'){
                page = $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']]['currentPage'];
              }
              return LoadAllData(page, pageSize,option);
            }             
          }
          function LoadAllData(page, pageSize,option){
            vm.requestGoing = true;
            var pageDetail = {'currentPage':page,'pageSize':pageSize};
            $sessionStorage[$state['current']['name']+'_'+ $localStorage['preHotelId']] = pageDetail;

            vm.page = page;
            vm.pageSize = pageSize;
            vm.selectedprodId = [];
            var sort = {};

            for (var i = 0; i < option.columnSort.length; i++) {

              if (option.columnSort[i]['sort']) {
                sort['column'] = vm.UserColumns[i];
                sort['order'] = option.columnSort[i]['sort'];
              }
            }
            var offset = (page - 1) * pageSize;
            var query = $scope.filterText ? $scope.filterText : '';


            var filterData = {
              'offset': offset,
              'pageSize': pageSize,
              'search': $scope.filterText,
              'sort': sort,
              'get_organization': true,
              'get_count': true,
              'hotel_id': $localStorage.hotels[$localStorage.selectedHotel].hotel_id
            };


            return $http({
              url: EnvironmentConfig.api + 'Channels/channels',
              method: 'POST',
              data: filterData
            }).then(function(result) {
              vm.requestGoing = false;
              vm.totalchannels = result.data['totalCount'];
              return {
                results: result.data['channelList'],
                totalResultCount: result.data['totalCount']
              }
            });
          }
          /*End*/

          $scope.goToEditPage = function(id) {
            if (vm.userPermissions.indexOf('update_channel') != -1) {
              $state.go("app.channelsEdit", {
                status: id
              });
            }
          }

          function selectAllModules(item, grandKey, index, room_type_id) {
            if(vm.loggedInUserRole != 1) {
              return false;
            }
            /**OPTZE**/
           
            var deleteIndex = -1;
            var checkIfExists = vm.testRoomRatePlanId.indexOf(vm.roomsAssociatedRateCategory[grandKey]['relation'][index]['parent_id']+'@'+room_type_id);
            if(checkIfExists != -1){
              vm.roomsAssociatedRateCategory[grandKey]['relation'][index]['selected'] = true;
              var status = true;
            }else{
              var status = vm.roomsAssociatedRateCategory[grandKey]['relation'][index]['selected'];
            } 

            if(status){
              vm.roomsAssociatedRateCategory[grandKey]['relation'][index]['selected'] = false;
              status = false;
            } else {
              vm.roomsAssociatedRateCategory[grandKey]['relation'][index]['selected'] = true;
              status = true;
            }
            if (status){
              vm.selectedIdsArray.push({
                rateCat: parseInt(vm.roomsAssociatedRateCategory[grandKey]['relation'][index]['parent_id']),
                ratePlanId: parseInt(room_type_id)
              });

              var testData =   parseInt(vm.roomsAssociatedRateCategory[grandKey]['relation'][index]['parent_id'])+'@'+room_type_id;
              vm.testRoomRatePlanId.push(testData);
              var temp = angular.copy(vm.testRoomRatePlanId);
              vm.testRoomRatePlanString = temp.toString();
            } else {
              vm.selectedIdsArray.forEach(function(Parvalue, Parindex) {
                if (Parvalue.rateCat == vm.roomsAssociatedRateCategory[grandKey]['relation'][index]['parent_id'] && Parvalue.ratePlanId == room_type_id) {
                  vm.selectedIdsArray.splice(Parindex, 1);
                }

                // vm.selectedIdsArray.splice(deleteIndex, 1);
                vm.testRoomRatePlanId.splice(checkIfExists, 1);
                var temp = angular.copy(vm.testRoomRatePlanId);
                vm.testRoomRatePlanString = temp.toString();
              });

            }

            if (item.children != null){
              // for selecting Child Elements
              vm.roomsAssociatedRateCategory[grandKey]['relation'][index]['children'].forEach(function(element, index2) {
                // for removing child
                if (!status){
                  vm.roomsAssociatedRateCategory[grandKey]['relation'][index]['children'][index2]['selected'] = status;
                  vm.selectedIdsArray.forEach(function(delvale, delIndex) {
                    if (delvale.rateCat == element.parent_id && delvale.ratePlanId == room_type_id) {
                      vm.selectedIdsArray.splice(delIndex, 1);
                    }
                  });
                }
              });
            }

            if (vm.selectedIdsArray.length == 0) {
              vm.selectedOption = true;
            } else {
              vm.selectedOption = false;
            }

          }
          $scope.wraptext = function(value){

            var data  = value.split(',');
            var returnText = '';
            data.forEach(function(element, index){
              if(index % 6 == 0){
                returnText = element+','+'</br>'+returnText;
              }else {                
                returnText = element+','+returnText;
              }
              // returnText = returnText.replace(/^\:/, '');
            });
            returnText = returnText.substring(0, returnText.length-6);
            return returnText;
          }
          vm.updateRooms = updateRooms;

          function updateRooms(rp, room_type_id){
            if(vm.pageStatus != 'add'){
              var data = {
                ratePlans:rp,
                room_type_id:room_type_id,
                channel_id:vm.channels.channel_id
              }
              channelService.UpdateChannel(data)
              .then(function(response) {
              });
            }
          }
          vm.selectedSubHotel = 0;
          vm.getSpecificData = getSpecificData;

          vm.isloading = false;
          function getSpecificData(id){
            vm.isloading = true;
            vm.roomsAssociatedRateCategory = [];
            vm.selectedSubHotel = id;
            var data = {childHotelId:id, hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id};
            if(vm.pageStatus != 'add'){
              data = {childHotelId:id, hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id, status:vm.pageStatus};              
            }
            channelService.getFormData(data)
            .then(function(response) {
              vm.isloading = false;
              vm.roomsAssociatedRateCategory = response[0]['roomsAssociatedRateCategory'];
              vm.selectedIdsArray = FormData[0]['preSelectedArr'];
            });
          }

          vm.getSelecetd = getSelecetd;
          vm.testRoomRatePlanId = [];
          vm.testRoomRatePlanString = '';

          function getSelecetd(rate_plan_id,room_type_id){
            room_type_id = parseInt(room_type_id);
            vm.selectedIdsArray.forEach(function(value, index) {
                // console.log(rate_plan_id,room_type_id);
                if (parseInt(value.rateCat) == parseInt(rate_plan_id) && parseInt(value.ratePlanId) == parseInt(room_type_id)) {
                 return true;
               }
             });
          }
        }
      })();

'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../category/categoryService
 * @description
 * # ../category/categoryService
 * Service in the minervaApp.
 */
 angular.module('app.channels')
 .service('channelService', function ($http, EnvironmentConfig) {
    // AngularJS will instantiate a singleton by calling "new" on this function
    function getDataComplete(response) {
    	return response.data;
    }

    function getDataFailed(error) {
    	return error.data;
    }

    function getFormData(data){
    	return $http({
    		url:EnvironmentConfig.api+'Channels/skipAcl_formData',
    		method:'POST',
    		data:data
    	})
    	.then(getDataComplete)
    	.catch(getDataFailed);
    }
    function addChannel(data){
    	return $http({
    		url:EnvironmentConfig.api+'Channels/add_channel',
    		method:'POST',
    		data:data
    	})
    	.then(getDataComplete)
    	.catch(getDataFailed);
    }
    function deleteSelectedChannel(data){
    	return $http({
    		url:EnvironmentConfig.api+'Channels/delete_channel',
    		method:'POST',
    		data:data
    	})
    	.then(getDataComplete)
    	.catch(getDataFailed);
    }
    function UpdateChannel(data){
    	return $http({
    		url:EnvironmentConfig.api+'Channels/update_channel',
    		method:'POST',
    		data:data
    	})
    	.then(getDataComplete)
    	.catch(getDataFailed);

    }
    function checkChannelName(data){
    	return $http({
    		url:EnvironmentConfig.api+'Channels/skipAcl_channelExists',
    		method:'POST',
    		data:data
    	})
    	.then(getDataComplete)
    	.catch(getDataFailed);

    }
    return{
    	getFormData: getFormData,
    	addChannel:addChannel,
    	deleteSelectedChannel:deleteSelectedChannel,
    	UpdateChannel:UpdateChannel,
    	checkChannelName:checkChannelName
    }
});

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
            
            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);
                    
                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;
        vm.showBadge = showBadge;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Unread count on Message Center follows the submenu.
         * Open submenu: count stays on Messages.
         * Closed submenu: count stays on Message Center.
         *
         * @returns {boolean}
         */
        function showBadge()
        {
            if ( !vm.node.badge )
            {
                return false;
            }

            if ( vm.node._path === 'message_center' && !vm.collapsed )
            {
                return false;
            }

            return true;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();

(function ()
{
    'use strict';

    var fuseThemes = {
        /*default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }*/
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'cyan',
                hues: {
                    'default': '500',
                    'hue-1'  : '600',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();

(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('toastMessage',['commonDailog' , toastMessage]);

    /** @ngInject */
    function toastMessage(commonDailog,$mdToast)
    {
        // Private variables
        var last = {
		  bottom: false,
		  top: true,
		  left: false,
		  right: true
		};
		var toastPosition = angular.extend({},last);
		//////////
		function getToastPosition(){
			sanitizePosition();
			return Object.keys(toastPosition)
			  .filter(function(pos) { return toastPosition[pos]; })
			  .join(' ');
		}
		function sanitizePosition() {
			var current = toastPosition;
			if ( current.bottom && last.top ) current.top = false;
			if ( current.top && last.bottom ) current.bottom = false;
			if ( current.right && last.left ) current.left = false;
			if ( current.left && last.right ) current.right = false;
			last = angular.extend({},current);
		 }
		function showSimpleToast(content, classMsg, keepDialogOpen, customTitle) {
			keepDialogOpen = !!keepDialogOpen;
			if (customTitle) {
				var type = customTitle;
			} else if(classMsg == 'success-toast'){
				var type = 'Success';
			} else if (classMsg == 'warning-toast') {
				var type = 'Warning';
			} else {
				var type = 'Error';
			}
			if (keepDialogOpen) {
				commonDailog.showSimpleDailogMultiple(type, content);
			} else {
				commonDailog.showSimpleDailog(type, content);
			}
		};
		  function showActionToast(content){
			var pinTo = getToastPosition();
			var toast = $mdToast.simple()
			  .textContent(content)
			  .action('UNDO')
			  .highlightAction(true)
			  .highlightClass('md-accent')// Accent is used by default, this just demonstrates the usage.
			  .position(pinTo);
			$mdToast.show(toast).then(function(response) {
			  if ( response == 'ok' ) {
				alert('You clicked the \'UNDO\' action.');
			  }
			});
		  };
			
		  var service = {
			showActionToast : showActionToast,
			showSimpleToast : showSimpleToast
		  };
		  return service;
    }
}());

(function () {
  "use strict";

  angular.module("app.core").factory("storageService", storageService);

  storageService.$inject = ["$localStorage"];

  function storageService($localStorage) {
    var STORAGE_KEY = "lodgingsystem";

    function getStorageRoot() {
      $localStorage[STORAGE_KEY] = $localStorage[STORAGE_KEY] || {};
      return $localStorage[STORAGE_KEY];
    }

    function getSection(sectionName) {
      var root = getStorageRoot();
      if (!root[sectionName] || typeof root[sectionName] !== "object") {
        root[sectionName] = {};
      }
      return root[sectionName];
    }

    function getStorage(sectionName, key) {
      var root = getStorageRoot();
      if (!root[sectionName] || typeof root[sectionName] !== "object") {
        return undefined;
      }
      if (!root[sectionName].hasOwnProperty(key)) {
        return undefined;
      }
      return root[sectionName][key];
    }

    function createStorage(sectionName, key, value) {
      var section = getSection(sectionName);
      if (!section.hasOwnProperty(key)) {
        section[key] = value;
      }
    }

    function updateStorage(sectionName, key, value) {
      getSection(sectionName)[key] = value;
    }

    return {
      getStorage: getStorage,
      createStorage: createStorage,
      updateStorage: updateStorage,
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope,$http)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
             function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
	'use strict';
	angular
	.module('app.core')
	.factory('commonService', commonService);
	/** @ngInject */
	function commonService($state, $localStorage, $q)
	{
		function roundnum(num,precision){
			return(+(Math.round(+(num+'e'+precision))+'e'+ -precision)).toFixed(precision);
		}
		function isCcProcessingFeeTaxLabel(name) {
			if (name === undefined || name === null || name === '') return false;
			var n = String(name).toLowerCase().replace(/\s+/g, ' ').trim();
			if (n.indexOf('cc processing fee') >= 0) return true;
			return false;
		}
		function cartTaxLineIsCcProcessingFee(taxRow) {
			if (!taxRow || typeof taxRow !== 'object') return false;
			return isCcProcessingFeeTaxLabel(taxRow.tax_name) || isCcProcessingFeeTaxLabel(taxRow.tax_label) ||
				isCcProcessingFeeTaxLabel(taxRow.name) || isCcProcessingFeeTaxLabel(taxRow.display_name);
		}
		function addPoromotion(){
			$state.go('app.promotion_add',{"edit_promotion_id" : "add"});
		}
		function gotoaddChannel() {
			$state.go("app.channelsAdd", {
				status: 'add'
			});
		}
		function gotoadduser() {
			$state.go('app.user_detail_add', {
				user_id: 'add'
			});
		}
		function gotoaddGroup() {
			$state.go("app.groupAdd", {
				status: 'add'
			});
		}
		function gotoaddteam() {
			$state.go("app.teamAdd", {
				status: 'add'
			});
		}
		function calculatesubtotal(ec,rate){
			return roundnum(parseFloat(ec)+parseFloat(rate),2);
		}
		function calculatesubtotalPos(qty,rate){
			return roundnum(parseFloat(qty)*parseFloat(rate),2);
		}
		function calculateTotals(data,addRoomInItin, multipleNightDepostPolicy){
			var thisCart = angular.copy(data);
			var createResv = (typeof thisCart.addReservation != 'undefined') ? thisCart.addReservation : false;
			/* Room CC-fee waiver: keyed only on cart flag (create-res sets it; do not require addReservation). */
			var waiveCcCreateResRoom = thisCart.waiveCcProcessingFeeRoom === true;
			var tax_names = [];
			var tax_amounts = [];

			var isResortFeeApplied = data['resortFeeApplied'];
			var $nights = thisCart['prices']['rates'].length;

			if(thisCart.product_discount=='undefined' || thisCart.product_discount==''){
				thisCart.product_discount = 0;
			}
			if(thisCart.nightlySum=='undefined' || thisCart.nightlySum==''){
				thisCart.nightlySum = 0;
			}
			thisCart.product_discount = roundnum(thisCart.product_discount,2);
			var tax_per = 0,tax_amt = 0,totalTax = 0;

			var temp_additional_guest_amounts = angular.copy(thisCart.additional_guest_amounts);
			if(thisCart.extraPersonPos){
				thisCart.additional_guest_amounts = 0;	
				temp_additional_guest_amounts = 0;	
			}
			
			if(thisCart.commission_charges_in_tax_indicator && thisCart.commission_charges_in_tax_indicator==1)
				var comm_charges = angular.copy(thisCart.commision_charges);
			else
				var comm_charges = 0;

			// if((typeof thisCart.tax_exempt_indicator != 'undefined' && thisCart.tax_exempt_indicator)){
			// if((typeof thisCart.customerTaxExempt != 'undefined' && thisCart.customerTaxExempt) || (typeof thisCart.travellerTaxExempt != 'undefined' && thisCart.travellerTaxExempt)){
 			if( (typeof thisCart.customerTaxExempt != 'undefined' && thisCart.customerTaxExempt && createResv) || (((typeof thisCart.customerTaxExempt != 'undefined' && thisCart.customerTaxExempt && thisCart.customer_traveller_id == thisCart.customerId) || (typeof thisCart.travellerTaxExempt != 'undefined' && thisCart.travellerTaxExempt && thisCart.customer_traveller_id == thisCart.travellerId)) && !createResv) ) {
				for(var i=0;i<thisCart.taxes.length;i++){
					thisCart.taxes[i].tax_amt = 0;
					var tax_name = thisCart.taxes[i].tax_name;
					var tax_amt = 0;
					if(tax_names.indexOf(tax_name) >= 0){
						tax_amounts[tax_names.indexOf(tax_name)] = roundnum(parseFloat(tax_amounts[tax_names.indexOf(tax_name)]) + parseFloat(tax_amt) , 2);
					} else {
						tax_names.push(tax_name);
						tax_amounts[tax_names.indexOf(tax_name)] = roundnum(tax_amt, 2);
					}
				}
			}else{
				for(var i=0;i<thisCart.taxes.length;i++){
					tax_per = thisCart.taxes[i].tax_value;
					if (waiveCcCreateResRoom && cartTaxLineIsCcProcessingFee(thisCart.taxes[i])) {
						tax_amt = 0;
						tax_amt = roundnum(tax_amt,2);
						totalTax = parseFloat(totalTax)+parseFloat(tax_amt);
						thisCart.taxes[i].tax_amt = tax_amt;
						var tax_name_cc = thisCart.taxes[i].tax_name;
						if(tax_names.indexOf(tax_name_cc) >= 0){
							tax_amounts[tax_names.indexOf(tax_name_cc)] = roundnum(parseFloat(tax_amounts[tax_names.indexOf(tax_name_cc)]) + parseFloat(tax_amt) , 2);
						} else {
							tax_names.push(tax_name_cc);
							tax_amounts[tax_names.indexOf(tax_name_cc)] = roundnum(tax_amt, 2);
						}
						continue;
					}
					if(thisCart.taxes[i]['applied_on_field'] !== undefined && thisCart.taxes[i]['applied_on_field'].toLowerCase() == 'resort fee'){
						tax_amt = 0;
						for(var ti=0;ti<thisCart.taxes.length;ti++){
							var resortTax = 0;
							var resortFeeTax = 0;						
							if(thisCart.taxes[ti]['tax_name'] == 'Resort Fee' && thisCart.taxes[ti]['applied_on_field'] != 'timebound_static'){
								resortTax = thisCart.taxes[ti]['tax_value'];
								if(resortTax > 0){
									var tempTaxAmount = ((((parseFloat(thisCart.nightlySum) + parseFloat(comm_charges) + parseFloat(temp_additional_guest_amounts))-thisCart.product_discount))*resortTax)/100;
									tax_amt = ((tempTaxAmount)*tax_per)/100;
									thisCart.taxes[i].tax_amt = tax_amt;
								}
							}else if(thisCart.taxes[ti]['tax_name'] == 'Resort Fee' && thisCart.taxes[ti]['applied_on_field'] == 'timebound_static'){
								if(isResortFeeApplied){
									resortTax = $nights * thisCart.taxes[ti]['tax_value'];
								}else{
									resortTax = 0;
								}

								if(resortTax > 0){
									tax_amt = (resortTax*tax_per)/100;
									thisCart.taxes[i].tax_amt = tax_amt;
								}
							}
						}
					} else if(thisCart.taxes[i]['applied_on_field'] == 'timebound_static'){
						if(isResortFeeApplied)
							tax_amt = $nights * tax_per;
						else
							tax_amt = 0;
					}else{
						tax_amt = ((((parseFloat(thisCart.nightlySum) + parseFloat(comm_charges) + parseFloat(temp_additional_guest_amounts))-parseFloat(thisCart.product_discount)))*tax_per)/100;
					}
					
					tax_amt = roundnum(tax_amt,2);
					totalTax = parseFloat(totalTax)+parseFloat(tax_amt);
					thisCart.taxes[i].tax_amt = tax_amt;
					var tax_name = thisCart.taxes[i].tax_name;
					if(tax_names.indexOf(tax_name) >= 0){
						tax_amounts[tax_names.indexOf(tax_name)] = roundnum(parseFloat(tax_amounts[tax_names.indexOf(tax_name)]) + parseFloat(tax_amt) , 2);
					} else {
						tax_names.push(tax_name);
						tax_amounts[tax_names.indexOf(tax_name)] = roundnum(tax_amt, 2);
					}
				}
			}
			
			/*if (tax_names !== undefined && tax_names.length > 0 && $localStorage.preHotelId ==='126') { // code to merge lodging tax and resort fee tax
				var lodgingTaxKey, lodgingTaxValue, resortFeeTaxKey, resortFeeTaxValue = '';
				angular.forEach(tax_names, function(value, key){
					if (value.toLowerCase() === 'lodging tax') {
						lodgingTaxKey = key;
						lodgingTaxValue = tax_amounts[key];
					}

					if (value.toLowerCase() === 'resort fee tax') {
						resortFeeTaxKey = key;
						resortFeeTaxValue = tax_amounts[key];
					}
				});
			
				if (lodgingTaxKey !== '' && resortFeeTaxKey !== '' && lodgingTaxKey !== resortFeeTaxKey) {
					var sum = parseFloat(lodgingTaxValue) + parseFloat(resortFeeTaxValue);
					tax_amounts[lodgingTaxKey] = sum.toString();
					tax_names.splice(resortFeeTaxKey, 1);
					tax_amounts.splice(resortFeeTaxKey, 1);
				}
			}*/
	
			thisCart.additional_guest_amounts = roundnum(thisCart.additional_guest_amounts,2);
			// thisCart.nightlySum = parseFloat(thisCart.nightlySum) + parseFloat(thisCart.additional_guest_amounts);
			var temp_additional_guest_amounts = thisCart['extraPersonPos'] ? 0: angular.copy(thisCart.additional_guest_amounts);
			// var temp_additional_guest_amounts = thisCart['extraPersonPos'] ? angular.copy(thisCart.additional_guest_amounts): angular.copy(thisCart.additional_guest_amounts);

			var grand_total = (((parseFloat(thisCart.nightlySum) +  parseFloat(temp_additional_guest_amounts))-parseFloat(thisCart.product_discount)))+totalTax;
			grand_total = roundnum(grand_total,2);
			thisCart.grand_total = grand_total;
			/* code for POS starts*/
			var POS =  thisCart.pos;
			var ROOMMOVE =  thisCart.room_moves;
			var pos_depositAmount = 0;var pos_discount = 0;
			var pos_grand_total = 0;
			var pos_remainingAmount =  0;
			var pos_subTotal = 0;
			var pos_tax = 0;
			var pos_product_discount = 0;
			var haveExtraPersonPos = false;

			if((typeof POS != 'undefined' || POS )){
				thisCart.pos.forEach(function(element, key) {
					if((typeof element.room_stay_status == 'undefined' || (typeof element.room_stay_status != 'undefined' && element.room_stay_status == 'Active')) && element.extra_attribute != undefined && element.extra_attribute == 'extra_person') {
						thisCart.extraPersonProduct = element;
						haveExtraPersonPos = true;
					}
				});
			}


			if((typeof POS != 'undefined' || POS )){
				thisCart.pos.forEach(function(element, key) {
					if(typeof element.room_stay_status == 'undefined' || (typeof element.room_stay_status != 'undefined' && element.room_stay_status == 'Active')){
						// if (typeof thisCart.tax_exempt_indicator != 'undefined' && thisCart.tax_exempt_indicator && element.extra_attribute != undefined && (element.extra_attribute == 'resort_fee' || element.extra_attribute == 'extra_person')) {
						// if ( (((typeof thisCart.customerTaxExempt != 'undefined' && thisCart.customerTaxExempt) || (typeof thisCart.travellerTaxExempt != 'undefined' && thisCart.travellerTaxExempt)) && element.extra_attribute != undefined && (element.extra_attribute == 'resort_fee' || element.extra_attribute == 'extra_person')) || (typeof thisCart.travellerTaxExempt != 'undefined' && thisCart.travellerTaxExempt) ) {
						if ( (typeof thisCart.customerTaxExempt != 'undefined' && thisCart.customerTaxExempt && createResv && element.extra_attribute != undefined && element.extra_attribute != 'resort_fee') || (((typeof thisCart.customerTaxExempt != 'undefined' && thisCart.customerTaxExempt && element.customer_traveller_id == thisCart.customerId) || (typeof thisCart.travellerTaxExempt != 'undefined' && thisCart.travellerTaxExempt && element.customer_traveller_id == thisCart.travellerId)) && !createResv) ) {
							var tax = 0;
							thisCart.pos[key].tax = tax;
							thisCart.pos[key].tax_amt = tax;
							element.tax = tax;
							element.tax_amt = tax;
							if(element.extra_attribute != undefined && element.product_is_timebound != undefined && parseInt(element.product_is_timebound) == 1) {
								var newGrandTotal = parseFloat(element.nightlySum) - parseFloat(element.product_discount);
								thisCart.pos[key].grand_total = newGrandTotal;
								element.grand_total = newGrandTotal;
							}
						}

						if(element.extra_attribute != undefined && element.extra_attribute == 'resort_fee' ) {
							thisCart.extraPersonProduct = (thisCart.extraPersonProduct != undefined) ? thisCart.extraPersonProduct : {};
							if(thisCart.resortFeeApplied) {
								/* When true, keep existing nightly rates (e.g. round-off tweaks) instead of
								   recalculating from extra_attribute_value, which would overwrite them. */
								if (thisCart.skipResortFeeRecalc) {
									thisCart.pos[key] = calculatePOSTotals(key, true, thisCart);
									element = thisCart.pos[key];
									thisCart.resortFeePos = element;
								} else {
									var resortFeePos = recalculateResortFeeAmount(element, thisCart, thisCart.extraPersonProduct, '');		
									element = resortFeePos;
									thisCart.resortFeePos = resortFeePos;
								}
							} else {
								thisCart.resortFeePos = element;
							}
							thisCart.resortFeeApplied = (parseFloat(element.nightlySum) > 0) ? true : false;
						}

						var elementTax = (element.tax != undefined && element.tax !== '') ? element.tax : element.tax_amt;
						if(elementTax == undefined || elementTax === '' || isNaN(parseFloat(elementTax))) {
							elementTax = 0;
						}
						pos_tax = parseFloat(pos_tax) + parseFloat(elementTax);
						pos_grand_total = parseFloat(pos_grand_total) + parseFloat(element.grand_total);
						pos_product_discount = parseFloat(pos_product_discount) + parseFloat(element.product_discount);
						if(thisCart.hasOwnProperty('room_deposit_type_indicator') || data.pageFrom == 'reservation'){
			    			pos_depositAmount = parseFloat(pos_depositAmount) + parseFloat(0);
						} else {
							pos_depositAmount = parseFloat(pos_depositAmount) + parseFloat(element.pos_deposit_amount);
						}
						pos_subTotal = parseFloat(pos_subTotal) + parseFloat(element.nightlySum * element.quantity);
						
						if(element.taxes != undefined) {
							angular.forEach(element.taxes, function(tax, tax_key) {
								/* Some payloads provide only tax_amt (not tax); keep totals numeric. */
								var perTaxAmount = (tax.tax != undefined && tax.tax !== '') ? tax.tax : tax.tax_amt;
								if(perTaxAmount == undefined || perTaxAmount === '' || isNaN(parseFloat(perTaxAmount))) {
									perTaxAmount = 0;
								}
								if(tax_names.indexOf(tax.tax_name) >= 0){
									tax_amounts[tax_names.indexOf(tax.tax_name)] = roundnum(parseFloat(tax_amounts[tax_names.indexOf(tax.tax_name)]) + parseFloat(perTaxAmount) , 2);
								} else {
									tax_names.push(tax.tax_name);
									tax_amounts[tax_names.indexOf(tax.tax_name)] = roundnum(perTaxAmount, 2);
								}
							});
						} else {
							angular.forEach(element.taxes, function(tax, tax_key) {
								if(tax_names.indexOf(element.tax_name) >= 0){
									tax_amounts[tax_names.indexOf(element.tax_name)] = roundnum(parseFloat(tax_amounts[tax_names.indexOf(element.tax_name)]) + parseFloat(element.tax) , 2);
								} else {
									tax_names.push(element.tax_name);
									tax_amounts[tax_names.indexOf(element.tax_name)] = roundnum(element.tax, 2);
								}
							});
						}

						if ( (typeof thisCart.customerTaxExempt != 'undefined' && thisCart.customerTaxExempt && createResv && element.extra_attribute != undefined && element.extra_attribute != 'resort_fee') || (((typeof thisCart.customerTaxExempt != 'undefined' && thisCart.customerTaxExempt && element.customer_traveller_id == thisCart.customerId) || (typeof thisCart.travellerTaxExempt != 'undefined' && thisCart.travellerTaxExempt && element.customer_traveller_id == thisCart.travellerId)) && !createResv) ) {
							var tax = 0;
							thisCart.pos[key].tax = tax;
							thisCart.pos[key].tax_amt = tax;
							tax_amounts[tax_names.indexOf(element.tax_name)] = roundnum(tax, 2);
						}

						if(element.extra_attribute != undefined && element.extra_attribute == 'surcharge' ) {
							thisCart.pos[key].grand_total = parseFloat(element.nightlySum * element.quantity);
							thisCart.pos[key].grand_total += parseFloat(element.tax);
							thisCart.pos[key].grand_total = roundnum(thisCart.pos[key].grand_total, 2);
						}

						if(element.extra_attribute != undefined && element.extra_attribute == 'extra_person') {
							thisCart.extraPersonProduct = element;
							haveExtraPersonPos = true;
						}
					}
				});
				if(!haveExtraPersonPos) {
					thisCart.extraPersonProduct = {};
				}
			}
			/* code for POS ends*/
			/* code for deposit starts*/
			var allowedTaxDeposits = thisCart.tax_deposit_policies;
			var allTaxDeposits = {};
			var thisdeposit = 0;
			/*Start*/
			/*End*/

			if(!addRoomInItin){
				if(thisCart.hasOwnProperty('selelected_policy_id') && thisCart.selelected_policy_id == '3'){
					thisCart.original_deposit_amt = thisCart.deposit_amount = roundnum(thisCart.grand_total,2);
				}else if(thisCart.hasOwnProperty('room_deposit_type_indicator') && thisCart.room_deposit_type_indicator=='perc'){
					thisCart.deposit_amount = (parseFloat(thisCart.grand_total)*parseFloat(thisCart.room_deposit_percentage))/100;
					thisCart.original_deposit_amt = thisCart.deposit_amount = roundnum(thisCart.deposit_amount,2);
				}else if(thisCart.hasOwnProperty('room_deposit_type_indicator') &&  thisCart.room_deposit_type_indicator=='amt'){
					thisCart.deposit_amount = parseFloat(thisCart.room_deposit_amount);
					thisCart.original_deposit_amt = thisCart.deposit_amount = roundnum(thisCart.deposit_amount,2);
				}else if(thisCart.hasOwnProperty('room_deposit_type_indicator') &&  thisCart.room_deposit_type_indicator == 'multiple-night'){

					if(multipleNightDepostPolicy.length > 0){
						var $nights = thisCart['prices']['rates'].length;
						var $deposit_amount = 0;
						var policyKey = 0;
						for(var key = 0; key < multipleNightDepostPolicy.length ; key++){
							if($nights >= multipleNightDepostPolicy[key]['for_upto_days']){
								policyKey = key;
							}
						}
						for(var key = 0; key < multipleNightDepostPolicy.length ; key++){
							if(key == policyKey){
								var element = multipleNightDepostPolicy[policyKey];
								if(element['for_upto_days'] <= $nights || element['room_deposit_type_indicator'] == 'amt-for-all-night' || element['room_deposit_type_indicator'] == 'perc-for-all-night'){
									var $roomDepositWhichday = element['room_deposit_which_night'] > $nights ? 0 : element['room_deposit_which_night']-1;
									var $price = thisCart['prices']['rates'][$roomDepositWhichday] - thisCart['prices']['nightlydiscount'][$roomDepositWhichday];
									var $tax_dep_amt = 0;
									if(thisCart['room_deposit_tax_included_indicator'] == 1){
										var $eachTaxVal = [];
										for(var i=0;i<thisCart.taxes.length;i++){
											var $eachTax = thisCart.taxes[i];
											if (waiveCcCreateResRoom && cartTaxLineIsCcProcessingFee($eachTax)) {
												continue;
											}
											var $tax_rate = $eachTax['tax_value'];
											var $thisDeposit = (($price)*$tax_rate)/100;
											$eachTaxVal[$eachTax['tax_name']] = $thisDeposit;
											if(allowedTaxDeposits.indexOf($eachTax['tax_id']) != -1){
												if($eachTax['applied_on_field'] == 'subtotal' || $eachTax['applied_on_field'] == ''){
													$tax_dep_amt = $tax_dep_amt + $thisDeposit;
												}else if($eachTax['applied_on_field'] == 'timebound_static'){
													$tax_dep_amt = 0;

												}else if(typeof ($eachTaxVal[$eachTax['applied_on_field']]) != 'undefined'){
													$thisDeposit = (($eachTaxVal[$eachTax['applied_on_field']])*$tax_rate)/100;
													$tax_dep_amt = $tax_dep_amt + $thisDeposit;
												}
											}
										}
									}
									var  $deposit_amount = 0 ;
									var $depositSum = 0;
									var $depositPer = 0;
									var $sumAmount = 0;
									var $nightlyRate = $tax_dep_amt+$price;
									if(element['room_deposit_type_indicator'] == 'amt'){
										if(element['room_deposit_amount'] > $nightlyRate){
											$deposit_amount =  $deposit_amount + $nightlyRate;
										} else {
											$deposit_amount =  $deposit_amount + element['room_deposit_amount'];
										}
									} else if(element['room_deposit_type_indicator'] == 'perc'){
										$sumAmount = ($nightlyRate * element['room_deposit_percentage'])/100;
										if($sumAmount > $nightlyRate){
											$sumAmount = $nightlyRate;
										}
										$deposit_amount = $deposit_amount + $sumAmount;
									} else if(element['room_deposit_type_indicator'] == 'night-rate'){
										$deposit_amount = $deposit_amount + $nightlyRate ;
									}else if(element['room_deposit_type_indicator'] == 'amt-for-all-night' && element['for_upto_days'] <= $nights){

										$depositSum = element['room_deposit_amount'] > thisCart['grand_total'] ? thisCart['grand_total']:element['room_deposit_amount'];
										$deposit_amount = $deposit_amount;
									}else if(element['room_deposit_type_indicator'] == 'perc-for-all-night' && element['for_upto_days'] <= $nights){

										$depositPer = element['room_deposit_percentage'] > 100 ? 100 :element['room_deposit_percentage'];
										$deposit_amount = (($depositPer * thisCart['grand_total']) / 100);
									}
								}
							}
						}
					}
					thisCart.deposit_amount = parseFloat($deposit_amount);
					thisCart.original_deposit_amt = thisCart.deposit_amount = roundnum($deposit_amount,2);
					/*End*/

				}else if(thisCart.hasOwnProperty('room_deposit_type_indicator') && thisCart.hasOwnProperty('selelected_policy_id') && thisCart.selelected_policy_id == 3){
					thisCart.deposit_amount = parseFloat(thisCart.grand_total);
					thisCart.original_deposit_amt = thisCart.deposit_amount = roundnum(thisCart.deposit_amount,2);
				}else if(thisCart.hasOwnProperty('room_deposit_type_indicator')){

					var temp_additional_guest_amounts = thisCart['extraPersonPos'] ? 0: angular.copy(thisCart.additional_guest_amounts);
					if(thisCart.extraPersonPos){
						thisCart.additional_guest_amounts = 0;	
						temp_additional_guest_amounts = 0;	
					}
					
					// add first Night Extra Charge in case of extraPersonPos true
					if ($localStorage.preHotelId !== undefined && $localStorage.preHotelId === '122') {
						thisCart.deposit_amount = parseFloat(thisCart.prices.rates[0]);
					} else {						
						thisCart.deposit_amount = parseFloat(thisCart.prices.rates[0]) + parseFloat(temp_additional_guest_amounts);
					}
					
					// thisCart.deposit_amount = parseFloat(thisCart.prices.rates[0]);
					// start tax calculation
					
					var tax_dep_amt = 0;
					var temp_tax_dep_amt = 0;
					for(var i=0;i<thisCart.taxes.length;i++){
						var temp_tax_dep_amt = 0;
						tax_per = thisCart.taxes[i].tax_value;
						if (waiveCcCreateResRoom && cartTaxLineIsCcProcessingFee(thisCart.taxes[i])) {
							continue;
						}
						if(thisCart.taxes[i]['applied_on_field'] == 'Resort Fee'){
							for(var ti=0;ti<thisCart.taxes.length;ti++){
								var resortTax = 0;
								var resortFeeTax = 0;						
								if(thisCart.taxes[ti]['tax_name'] == 'Resort Fee' && thisCart.taxes[ti]['applied_on_field'] != 'timebound_static'){
									resortTax = thisCart.taxes[ti]['tax_value'];
									if(resortTax > 0){
										var tempTaxAmount = ((parseFloat(thisCart.deposit_amount))*resortTax)/100;
										temp_tax_dep_amt = ((tempTaxAmount)*tax_per)/100;
									}
								}
								else if(thisCart.taxes[ti]['tax_name'] == 'Resort Fee' && thisCart.taxes[ti]['applied_on_field'] == 'timebound_static'){
									// if(isResortFeeApplied){
									// 	var resortTax = $nights * thisCart.taxes[ti]['tax_value'];
									// 	if(resortTax > 0){
									// 		temp_tax_dep_amt = (resortTax*tax_per)/100;
									// 	}
									// }else{
											temp_tax_dep_amt = 0;

									// }
								}
							}
						} else if(thisCart.taxes[i]['applied_on_field'] == 'timebound_static'){
							// if(isResortFeeApplied)
							// 	temp_tax_dep_amt = $nights * tax_per;
							// else
								temp_tax_dep_amt = 0;

						} else {
							temp_tax_dep_amt = ((parseFloat(thisCart.deposit_amount))*tax_per)/100;
						}
						tax_dep_amt = parseFloat(tax_dep_amt) + parseFloat(temp_tax_dep_amt);
					}

					// End
					thisCart.deposit_amount = thisCart.deposit_amount+tax_dep_amt;
					thisCart.original_deposit_amt = thisCart.deposit_amount = roundnum(thisCart.deposit_amount,2);
				}
				if(thisCart.hasOwnProperty('room_deposit_type_indicator')){
					if(parseFloat(thisCart.grand_total)<parseFloat(thisCart.deposit_amount)){
						thisCart.deposit_amount = thisCart.grand_total;
						thisCart.original_deposit_amt = thisCart.grand_total;
					}
				}
			}

			if(thisCart.hasOwnProperty('room_deposit_type_indicator')){
				var remaining_amount = parseFloat(grand_total)-parseFloat(thisCart.deposit_amount);
			}else{
				var remaining_amount = parseFloat(grand_total)-parseFloat(thisCart.paid_amount);
			}
			if(remaining_amount<0) remaining_amount = 0;
			remaining_amount = roundnum(remaining_amount,2);
			totalTax = roundnum(totalTax,2);

			thisCart.overalltotals.subtotal = roundnum((parseFloat(thisCart.nightlySum) + parseFloat(pos_subTotal)) ,2);
			thisCart.overalltotals.product_discount = roundnum(parseFloat(thisCart.product_discount) + parseFloat(pos_product_discount) ,2);
			thisCart.overalltotals.tax =      roundnum(parseFloat(totalTax) + parseFloat(pos_tax) ,2);
			thisCart.overalltotals.tax_names = tax_names;
			thisCart.overalltotals.tax_amounts = tax_amounts;
			thisCart.overalltotals.grand_total =  roundnum(parseFloat(thisCart.grand_total) + parseFloat(pos_grand_total) ,2);
			if(thisCart.hasOwnProperty('room_deposit_type_indicator')){
				thisCart.overalltotals.deposit_amount = roundnum(parseFloat(thisCart.deposit_amount) + parseFloat(pos_depositAmount),2);
				thisCart.overalltotals.remaining_amount = roundnum(parseFloat(remaining_amount) + parseFloat(pos_grand_total-pos_depositAmount),2);
			}else{
				if(thisCart.hasOwnProperty('paid_amount')){
					thisCart.overalltotals.remaining_amount = roundnum(parseFloat(thisCart.overalltotals.grand_total) - parseFloat(thisCart.paid_amount),2);
				}
				else{
					thisCart.overalltotals.remaining_amount = roundnum(parseFloat(remaining_amount) + parseFloat(pos_grand_total),2);
				}
			}
			/*Calculate GC value if applied start*/
			if(thisCart['overalltotals']['gift_card_price'] && thisCart['overalltotals']['gift_card_price'] > 0 ){
				var adjustedGCPrice = calculateGCValue(thisCart['overalltotals']['deposit_amount'],thisCart['overalltotals']['gift_card_price']);
				thisCart['overalltotals']['paidFromGC'] = adjustedGCPrice;
			}

			thisCart.total_amount = thisCart.overalltotals.grand_total;
			/*Calculate GC value if applied end*/
			/* code for overall total ends*/

			// $rootScope.broadcast('update_pos_date', thisCart);
			var surchargeFound = false;
			var surchargePos = {};
			if (thisCart.pos != undefined && thisCart.pos.length > 0) {
				angular.forEach(thisCart.pos, function(value, key) {
					if (value.extra_attribute != undefined && value.extra_attribute == 'surcharge') {
						surchargeFound = true;
						surchargePos = value;
					}
				});
			}

			if (!surchargeFound && thisCart.overalltotals != undefined) {
				thisCart.overalltotals.surcharge = 0;
			} else if (surchargeFound && thisCart.overalltotals != undefined) {
				thisCart.overalltotals.surcharge = surchargePos.grand_total != undefined ? surchargePos.grand_total : 0;
			}
			return thisCart;
		}
		function sumNights(data){
			var thisCart = angular.copy(data);
			var nightlyAll = thisCart.prices.rates;
			var nightlySum = 0;
			for(var i=0;i<nightlyAll.length;i++){
				nightlySum+= parseFloat(nightlyAll[i]);
				thisCart.prices.rates[i] = roundnum(nightlyAll[i],2);
			}
			thisCart.nightlySum = roundnum(nightlySum,2);
			return {'nightlySum':thisCart.nightlySum,'rates':thisCart.prices.rates};
		}
		// Nights the discount dialog lists to pick where a discount applies
		function getDiscountNights(prices, stayUnitLabel){
			var canceledNights = prices.canceled_nights || [];
			var discounts = prices.nightlydiscount || {};
			var comments = prices.nightlydiscountcomment || {};
			var nights = [];
			angular.forEach(prices.dates, function(date, key){
				var index = parseInt(key);
				var rate = parseFloat(prices.rates[index]) || 0;
				var canceled = canceledNights.indexOf(date) >= 0;
				nights.push({
					index: index,
					label: stayUnitLabel + ' ' + (prices.nightcount && prices.nightcount[index] ? prices.nightcount[index] : index + 1),
					date: date,
					rate: rate,
					currentDiscount: parseFloat(discounts[index]) || 0,
					currentComment: comments[index],
					canceled: canceled,
					disabled: canceled || rate <= 0
				});
			});
			return nights;
		}
		function sumnightlyDisc(data){
			var thisCart = angular.copy(data);
			var nightlyAllDisc = thisCart.prices.nightlydiscount;
			var nightlySumDisc = 0;
			for(var i=0;i<parseInt(Object.keys(nightlyAllDisc).length);i++){
				nightlySumDisc+= parseFloat(nightlyAllDisc[i]);
				thisCart.prices.nightlydiscount[i] = roundnum(nightlyAllDisc[i],2);
			}
			thisCart.product_discount = roundnum(nightlySumDisc,2);
			return {'product_discount':thisCart.product_discount,'nightlydiscount':thisCart.prices.nightlydiscount};
		}
		function breakIntoNights(data){
			var thisCart = angular.copy(data);
			var nightlyAll = thisCart.prices.rates;
			var nightlySum = thisCart.nightlySum;
			thisCart.nightlySum = roundnum(thisCart.nightlySum,2);
			var eachNight = parseFloat(nightlySum/nightlyAll.length);
			eachNight = roundnum(eachNight,2);
			for(var i=0;i<nightlyAll.length;i++){
				thisCart.prices.rates[i] = eachNight;
			}
			return thisCart;
		}
		function setAdults(data,location,auto_add_pos,is_child_allowed){
			var thisCart = angular.copy(data);	
			var additionalAmt = 0;
			if(is_child_allowed)
				var extraperson = (parseInt(thisCart.room_stay_child_count) + parseInt(thisCart.room_stay_guest_count))-parseInt(thisCart.normal_occupancy);
			else
				var extraperson = parseInt(thisCart.room_stay_guest_count)-parseInt(thisCart.normal_occupancy);
			var POS =  thisCart.pos;

			if(extraperson > 0){
				thisCart['additional_guest_amounts'] = (thisCart['per_night_additional_amount']*(extraperson * thisCart['prices']['dates'].length));
			}else {
				thisCart['additional_guest_amounts'] = 0;
			}
			thisCart['additional_guest_amounts'] = roundnum(thisCart['additional_guest_amounts'],2);
			if(thisCart['extraPersonPos']){
				thisCart['additional_guest_amounts']= 0;
			}
			auto_add_pos['pos_deposit_amount'] = (auto_add_pos['pos_deposit_amount'] !== undefined) ? auto_add_pos['pos_deposit_amount'].toString() : '0';
			if(location == 'create' && auto_add_pos['pos_deposit_amount']){
				var auto_added_exist = false;
				var auto_added_key = -1;
				if(typeof POS != 'undefined' || POS){
					thisCart.pos.forEach(function(element, key){
						if((typeof element.room_stay_status == 'undefined' || (typeof element.room_stay_status != 'undefined' && element.room_stay_status == 'Active')) && (typeof element.auto_added != 'undefined' && parseInt(element.auto_added) && (element.extra_attribute == undefined || element.extra_attribute == 'extra_person') )){
							auto_added_exist = true;
							auto_added_key = key;
							if(extraperson > 0){
								var nightlyAll = element.prices.rates;
								var nightlySum = 0;
								for(var i=0;i<nightlyAll.length;i++){
									nightlyAll[i] = extraperson*parseFloat(element.product_price);
									nightlySum += parseFloat(nightlyAll[i]);
									element.prices.rates[i] = roundnum(nightlyAll[i],2);
								}
								element.nightlySum = roundnum(nightlySum,2);
								thisCart.pos[key] = element;
								thisCart.pos[key] = calculatePOSTotals(key,false,thisCart);
							}
						}
					});
				}
				if(!auto_added_exist && extraperson > 0 ){
					var nightlyAll = auto_add_pos.prices.rates;
					var nightlySum = 0;
					if(typeof POS == 'undefined' || !POS){
						thisCart.pos = [];
					}
					for(var i=0;i<nightlyAll.length;i++){
						nightlyAll[i] = extraperson*parseFloat(auto_add_pos.product_price);
						nightlySum += parseFloat(nightlyAll[i]);
						auto_add_pos.prices.rates[i] = roundnum(nightlyAll[i],2);
					}
					auto_add_pos.nightlySum = roundnum(nightlySum,2);
					thisCart.pos.push(auto_add_pos);
					var key = thisCart.pos.length - 1;
					thisCart.pos[key] = calculatePOSTotals(key,false,thisCart);

				} else if(extraperson <= 0 && auto_added_exist && auto_added_key >= 0){
					thisCart.pos.splice(auto_added_key, 1);
					thisCart.extraPersonProduct = {};
				}
				/* code for POS ends*/
			}
			return thisCart;
		}

		function calculatePOSTotals(posIndex, nightChanged, data, location){
			// var temp
			var createResv = (typeof data.addReservation != 'undefined') ? data.addReservation : false;
			var thisPOS = angular.copy(data.pos[posIndex]);
			
			var rateInclQty = 0;
			var nightlySum = parseFloat(thisPOS.nightlySum);
			if(thisPOS.product_is_timebound==1){
				var tempNightlySum = 0;
				thisPOS.prices['rates'].forEach(function(element, key){
					tempNightlySum = parseFloat(tempNightlySum) +parseFloat(element);
				});
				rateInclQty = tempNightlySum;
				tempNightlySum = 0;					
			}else{
				 // rateInclQty = parseFloat(thisPOS.particularCustomPrice) * parseFloat(thisPOS.quantity);
     			//  thisPOS.nightlySum = parseFloat(rateInclQty) - parseFloat(thisPOS.product_discount);
     			//  thisPOS.nightlySum = roundnum(thisPOS.nightlySum,2);
            	//~ /*Change Nightly Price For CustomPrice of Product*/
            	
            	/* Commented code and added new to fix modification case of quantity multiplication (Please ask Shruti if need to modify this code) */
            	rateInclQty = parseFloat(thisPOS.nightlySum) * parseFloat(thisPOS.quantity);
            	//~ thisPOS.nightlySum = parseFloat(rateInclQty) - parseFloat(thisPOS.product_discount);
            	thisPOS.nightlySum = roundnum(thisPOS.nightlySum,2);
            	/* Commented code and added new to fix modification case of quantity multiplication (Please ask Shruti if need to modify this code)*/
            	
            }
            
            thisPOS.product_discount = roundnum(thisPOS.product_discount,2);

            if( !nightChanged && (thisPOS.extra_attribute == undefined || (thisPOS.extra_attribute != 'resort_fee' && thisPOS.extra_attribute != 'extra_person')) ) {
            	if(thisPOS.product_is_timebound==1){
            		thisPOS.prices['rates'].forEach(function(element, key){
            			thisPOS.prices['rates'][key] = roundnum(parseFloat(thisPOS.nightlySum/thisPOS.prices['rates'].length),2);
            		});
            	}
            }

            var tax_per = 0,tax_amt = 0;
            // if(typeof data.tax_exempt_indicator !=  'undefined' && data.tax_exempt_indicator && thisPOS.extra_attribute != undefined && (thisPOS.extra_attribute != 'resort_fee' || thisPOS.extra_attribute != 'extra_person')) {
            // if ( (((typeof data.customerTaxExempt != 'undefined' && data.customerTaxExempt) || (typeof data.travellerTaxExempt != 'undefined' && data.travellerTaxExempt)) && thisPOS.extra_attribute != undefined && (thisPOS.extra_attribute == 'resort_fee' || thisPOS.extra_attribute == 'extra_person')) || (typeof data.travellerTaxExempt != 'undefined' && data.travellerTaxExempt) ) {
            if ( (typeof data.customerTaxExempt != 'undefined' && data.customerTaxExempt && createResv && thisPOS.extra_attribute != undefined && thisPOS.extra_attribute != 'resort_fee') || (((typeof data.customerTaxExempt != 'undefined' && data.customerTaxExempt && thisPOS.customer_traveller_id == data.customerId) || (typeof data.travellerTaxExempt != 'undefined' && data.travellerTaxExempt && thisPOS.customer_traveller_id == data.travellerId)) && !createResv) || (typeof data.travellerTaxExempt != 'undefined' && data.travellerTaxExempt) ) {
				tax_per = parseFloat(thisPOS.tax_value);
				tax_amt = 0;
				if(thisPOS.taxes != undefined && thisPOS.taxes[0] != undefined) {
            		var taxAmount = 0;
	            	thisPOS.taxes.forEach(function(tax, taxKey) {
						thisPOS.taxes[taxKey]['tax'] 		= taxAmount;
						thisPOS.taxes[taxKey]['tax_amt'] 	= taxAmount;
					});
	            }
            }else{
            	if(thisPOS.taxes != undefined && thisPOS.taxes[0] != undefined) {
            		var taxAmount = 0;
	            	thisPOS.taxes.forEach(function(tax, taxKey) {
            			taxAmount = 0;
						tax_per = parseFloat(tax.tax_value);
						if (thisPOS.waiveCcProcessingFee === true && cartTaxLineIsCcProcessingFee(tax)) {
							taxAmount = 0;
						} else {
							taxAmount =  ((rateInclQty - parseFloat(thisPOS.product_discount)) * tax_per) / 100;
						}
	            		tax_amt = tax_amt + taxAmount;
						thisPOS.taxes[taxKey]['tax'] 		= taxAmount;
						thisPOS.taxes[taxKey]['tax_amt'] 	= taxAmount;
					});
	            } else {
	            	if(thisPOS.tax_value == undefined) {
			           	tax_per = 0.00;	
			           	tax_amt = 0.00
		           	} else {
			           	tax_per = parseFloat(thisPOS.tax_value);
			           	tax_amt = ((rateInclQty-parseFloat(thisPOS.product_discount))*tax_per)/100;
		           	}	            	
            	}	
            }
            
            if (tax_amt !== undefined && Number.isNaN(tax_amt)) {
            	tax_amt = 0;
            }
            thisPOS.tax = roundnum(tax_amt,2);
            thisPOS.tax_amt = roundnum(tax_amt,2);
            var grand_total = (rateInclQty-parseFloat(thisPOS.product_discount))+parseFloat(thisPOS.tax);
            grand_total = roundnum(grand_total,2);
            thisPOS.grand_total = grand_total;
            /* code for deposit starts*/
            if(thisPOS.pos_deposit_type_indicator=='zero'){
            	// thisPOS.deposit_ammount = (parseFloat(thisPOS.grand_total)*parseFloat(0))/100;
            	thisPOS.deposit_ammount = 0;
            	thisPOS.original_deposit_amt = thisPOS.deposit_ammount = thisPOS.pos_deposit_amount = roundnum(thisPOS.deposit_ammount,2);
            }else if(thisPOS.pos_deposit_type_indicator=='full'){
            	thisPOS.deposit_ammount = parseFloat(thisPOS.grand_total);
	            	thisPOS.original_deposit_amt = thisPOS.deposit_ammount = thisPOS.pos_deposit_amount = roundnum(thisPOS.deposit_ammount,2);
            }else if(thisPOS.product_is_timebound===1){
            	thisPOS.deposit_ammount = parseFloat(thisPOS.prices.rates[0]);
            	thisPOS.original_deposit_amt = thisPOS.deposit_ammount = thisPOS.pos_deposit_amount = roundnum(thisPOS.deposit_ammount,2);
            }else{
            	thisPOS.deposit_ammount = parseFloat(thisPOS.grand_total);
            	thisPOS.original_deposit_amt = thisPOS.deposit_ammount = thisPOS.pos_deposit_amount = roundnum(thisPOS.deposit_ammount,2);
            }
            if(parseFloat(thisPOS.grand_total)<parseFloat(thisPOS.deposit_ammount)){
            	thisPOS.pos_deposit_amount = thisPOS.grand_total;
            	thisPOS.deposit_ammount = thisPOS.grand_total;
            	thisPOS.original_deposit_amt = thisPOS.grand_total;
            }
             // var discountAmount = discountPercentage = 0;
            if(thisPOS.product_discount > 0){
             	thisPOS.discountAmt = thisPOS.product_discount ;
             	thisPOS.customDiscount = thisPOS.product_discount ;
             	thisPOS.customDiscountPercentage = (thisPOS.product_discount/thisPOS.nightlySum)*100 ;
             	thisPOS.discountPer = ( thisPOS.product_discount/thisPOS.nightlySum)*100 ;
            }

            var remaining_amount = parseFloat(thisPOS.grand_total) - parseFloat(thisPOS.deposit_ammount);
            if(remaining_amount<0) remaining_amount = 0;
            remaining_amount = roundnum(remaining_amount,2);
            thisPOS.remaining_amount =remaining_amount;

			// thisPOS.particularCustomPrice = thisPOS.nightlySum;	
			// thisPOS.customPrice = thisPOS.nightlySum;
			/* code for deposit ends*/
			if(thisPOS.extra_attribute != undefined && (thisPOS.extra_attribute == 'resort_fee' || thisPOS.extra_attribute == 'extra_person')) {
				thisPOS.customPrice 			= parseFloat(thisPOS.nightlySum);
				thisPOS.particularCustomPrice 	= parseFloat(thisPOS.nightlySum);
			}

			return thisPOS;
		}

		function calculateExpirationYears() {
			let currentYear = new Date().getFullYear();
			let years_option = [];
		
			for (let i = 0; i < 20; i++) {
				years_option.push(currentYear + i);
			}
			return years_option;
		}

		function creditCardChanged(event,cardType,payment_method,allowed_card_types){
			var card_number1 = payment_method.cc_number_mask;
			var star1 = "";
			var notCardType = false;
			var list = allowed_card_types;
			angular.forEach(list, function(value, key) {
				list[key] = value.replace(/\s/g, '');
			});
			if(typeof cardType != 'undefined') cardType = cardType.replace(/\s/g, '');
			if(typeof cardType != 'undefined' && Object.values(list).indexOf(cardType) == -1) {
				payment_method.cc_number = payment_method.cc_number_mask = '';
				notCardType = true;
				return {notCardType:notCardType};
			}else if(typeof cardType != 'undefined'){
				payment_method.cc_type = cardType;
			}
            /*if(isNaN(String.fromCharCode(event.which))){
                vm.payment_method.cc_number_mask = card_number1.substring(0, card_number1.length - 1);
               return false;
             }*/
             if(card_number1 != "" && typeof card_number1 != 'undefined') {
             	if(card_number1.length <= 12)
             	{
             		if(typeof payment_method.cc_number == 'undefined' || payment_method.cc_number == ''){
             			var card_number_hidden1 = '';
             		}else{
             			var card_number_hidden1 = payment_method.cc_number;
             		}

             		var star_card_number1 = replaceSubstring(card_number1,"*","");
             		card_number_hidden1 = card_number_hidden1+star_card_number1;
             		card_number_hidden1 = replaceSubstring(card_number_hidden1,"*","");
             		payment_method.cc_number = card_number_hidden1;
             		for(var i = 1; i <= card_number1.length; i++)
             		{
             			star1 = star1+"*";
             		}
             		payment_method.cc_number_mask = star1;
             		if(event.which == 8) {
             			payment_method.cc_number = card_number_hidden1.substring(0, card_number_hidden1.length - 1);

             		}
             	}else if(card_number1!= "" && card_number1.length > 12 && card_number1.length <= 16){

             		var card_number_hidden1 = payment_method.cc_number;
             		var new_card_number1 = "";
             		for(var loop1=0; loop1 < 12; loop1++){
             			new_card_number1 = new_card_number1+card_number_hidden1.charAt(loop1);
             		}
             		for(var loop2=12; loop2 < card_number1.length; loop2++){
             			new_card_number1 = new_card_number1+card_number1.charAt(loop2);
             		}
             		card_number_hidden1 = replaceSubstring(new_card_number1,"*","");
             		payment_method.cc_number = card_number_hidden1;
             	} else{
             		payment_method.cc_number = '';
             	}
             } else {
             	payment_method.cc_number = '';
             }
             return {notCardType:notCardType,payment_method:payment_method};
           }
           function creditCardChangedCreate(idx,event,cardType,payment_method,allowed_card_types){
           	var card_number1 = payment_method[idx].cc_number_mask;
           	var star1 = "";
           	var notCardType = false;
           	var list = allowed_card_types;
           	angular.forEach(list, function(value, key) {
           		list[key] = value.replace(/\s/g, '');
           	});
           	if(typeof cardType != 'undefined') cardType = cardType.replace(/\s/g, '');
           	if(typeof cardType != 'undefined' && Object.values(list).indexOf(cardType) == -1) {
           		payment_method[idx].cc_number = payment_method[idx].cc_number_mask = '';
           		notCardType = true;
           		return {notCardType:notCardType};
           	}else if(typeof cardType != 'undefined'){
           		payment_method[idx].cc_type = cardType;
           	}
            /*if(isNaN(String.fromCharCode(event.which))){
                vm.payment_method[idx].cc_number_mask = card_number1.substring(0, card_number1.length - 1);
               return false;
             }*/
             if(card_number1 != "" && typeof card_number1 != 'undefined') {
             	if(card_number1.length <= 12)
             	{
             		if(typeof payment_method[idx].cc_number == 'undefined' || payment_method[idx].cc_number == ''){
             			var card_number_hidden1 = '';
             		}else{
             			var card_number_hidden1 = payment_method[idx].cc_number;
             		}

             		var star_card_number1 = replaceSubstring(card_number1,"*","");
             		card_number_hidden1 = card_number_hidden1+star_card_number1;
             		card_number_hidden1 = replaceSubstring(card_number_hidden1,"*","");
             		payment_method[idx].cc_number = card_number_hidden1;
             		for(var i = 1; i <= card_number1.length; i++)
             		{
             			star1 = star1+"*";
             		}
             		payment_method[idx].cc_number_mask = star1;
             		if(event.which == 8) {
             			payment_method[idx].cc_number = card_number_hidden1.substring(0, card_number_hidden1.length - 1);

             		}
             	}else if(card_number1!= "" && card_number1.length > 12 && card_number1.length <= 16){

             		var card_number_hidden1 = payment_method[idx].cc_number;
             		var new_card_number1 = "";
             		for(var loop1=0; loop1 < 12; loop1++){
             			new_card_number1 = new_card_number1+card_number_hidden1.charAt(loop1);
             		}
             		for(var loop2=12; loop2 < card_number1.length; loop2++){
             			new_card_number1 = new_card_number1+card_number1.charAt(loop2);
             		}
             		card_number_hidden1 = replaceSubstring(new_card_number1,"*","");
             		payment_method[idx].cc_number = card_number_hidden1;
             	} else{
             		payment_method[idx].cc_number = '';
             	}
             } else {
             	payment_method[idx].cc_number = '';
             }
             return {notCardType:notCardType,payment_method:payment_method};
           }

           function replaceSubstring(inSource, inToReplace, inReplaceWith) {
           	var outString = inSource;
           	while (true) {
           		var idx = outString.indexOf(inToReplace);
           		if (idx == -1) {
           			break;
           		}
           		outString = outString.substring(0, idx) + inReplaceWith +
           		outString.substring(idx + inToReplace.length);
           	}
           	return outString;
           }
           function checkValidExpDate(payment_method) {

           	var exp_date_err = false;
           	var exp_date = false;
           	var entered_month = payment_method.cc_exp_date;
           	var entered_year = payment_method.cc_exp_year;

           	var current_date = moment().format('YYYY-MM-DD');
           	var entered_date = moment(moment('01-'+entered_month+'-'+entered_year, "DD-MM-YYYY")).format('YYYY-MM-DD');

           	var result = moment(current_date).isBefore(entered_date);


           	if(entered_month && entered_year && !result) {
           		exp_date_err = true;
           		exp_date = true;
           	}
           	return {exp_date:exp_date,exp_date_err:exp_date_err}
           }

           function checkValidExpDateCreate(index,payment_method) {
           	var exp_date_err = [];
           	var exp_date = false;
           	exp_date_err[index] = false;
           	var entered_month = payment_method[index].cc_exp_month;
            // var entered_month = payment_method[index].cc_exp_date;
            var entered_year = payment_method[index].cc_exp_year;

            var current_date = moment().format('YYYY-MM-DD');
            var entered_date = moment(moment('01-'+entered_month+'-'+entered_year, "DD-MM-YYYY")).format('YYYY-MM-DD');

            var result = moment(current_date).isBefore(entered_date);

            if(entered_month && entered_year && !result) {
            	exp_date_err[index] = true;
            	exp_date = true;
            }
            return {exp_date:exp_date,exp_date_err:exp_date_err}
          }

          function calculateGCValue(depositAmount, gcPrice){
          	depositAmount=roundnum(depositAmount,2);
          	if(parseFloat(depositAmount) >= parseFloat(gcPrice)){
          		return gcPrice;
          	} else if(parseFloat(depositAmount) < parseFloat(gcPrice)){
          		return  depositAmount;
          	}
          }
          function makeAddress(data) {
          	var address = '';
          	if(data.hasOwnProperty('address')) {
          		address = data.address;
          	}
          	var productName = '';
          	var secondAddress = '';
          	var countryZip = '';
	        /*if(data.hasOwnProperty('product_name')) {
	            productName = data.product_name;
	          }*/
	          if(data.hasOwnProperty('city')) {
	          	secondAddress = data.city;
	          }
	          if(data.hasOwnProperty('state')) {
	          	secondAddress = (secondAddress != '') ? (secondAddress + ', ' + data.state) : data.state;
	          }
	          if(data.hasOwnProperty('zip_code')) {
	          	countryZip = data.zip_code;
	          }

	          if(data.hasOwnProperty('country')) {
	          	countryZip = (countryZip != '') ? (countryZip + ' ' + data.country) : data.country;
	          }
	          if(countryZip != '') {
	          	secondAddress = secondAddress + ', ' + countryZip;
	          }
	          if(productName != '') {
	          	address = address + '<br/>' + productName;
	          }
	          if(secondAddress != '') {
	          	address = address + '<br/>' + secondAddress;
	          }
	          address = (data.hasOwnProperty('phone_number')) ? ((address !== '') ? (address + '<br/>' + '<span>Phone: </span>'+data.phone_number) : '<span>Phone: </span>'+data.phone_number) : address;
	          address = (data.hasOwnProperty('secondary_phone_number')) ? ((address !== '') ? (address + '<br/>' + '<span>Secondary phone: </span>'+data.secondary_phone_number) : '<span>Secondary phone: </span>'+data.secondary_phone_number) : address;
	          address = (data.hasOwnProperty('customer_email')) ? ((address !== '') ? (address + '<br/>' + '<span>Email: </span>'+data.customer_email) : '<span>Email: </span>'+data.customer_email) : address;
	          return address;
	        }

	        function recalculateResortFeePos(cartData) {
	        	var deferred = $q.defer();
	        	var isResortFeeApplied = cartData['resortFeeApplied'];
	        	if(cartData.pos != undefined) {
		        	cartData.pos.forEach(function(element, key){
						if(element.prices != undefined && element.prices.rates != undefined && element.extra_attribute_type != undefined && element.extra_attribute == 'resort_fee'){
							if(!isResortFeeApplied) {
								element.prices.rates.forEach(function(pos, index){
									// if(cartData.prices.nightcount['nightlyKey'] != -1) {
										cartData.pos[key].prices.rates[index] = roundnum(0.00, 2);
										cartData.pos[key].prices.nightlydiscount[index] = roundnum(0.00, 2);
										if(cartData.pos[key].prices.nightlydiscountcomment != undefined && cartData.pos[key].prices.nightlydiscountcomment[index] != undefined) {
											cartData.pos[key].prices.nightlydiscountcomment[index] = '';
										}
									// }
								});
								cartData.pos[key].taxes.forEach(function(tax, taxKey) {
									cartData.pos[key].taxes[taxKey]['tax'] 		= 0.00;
									cartData.pos[key].taxes[taxKey]['tax_amt'] 	= 0.00;
								});
								cartData.pos[key].tax_amt 				= 0.00;
								cartData.pos[key].tax 					= 0.00;
								cartData.pos[key].nightlySum 			= 0.00;
								cartData.pos[key].customPrice 			= 0.00;
								cartData.pos[key].particularCustomPrice = 0.00;
								cartData.pos[key].product_discount 		= 0.00;
								cartData.pos[key].grand_total 			= 0.00;
								cartData.resortFeePos = cartData.pos[key];
							} else{
								cartData.pos[key] = recalculateResortFeeAmount(cartData.pos[key], cartData, {}, 'recalculate');
								cartData.resortFeePos = cartData.pos[key];
							}
						}
					});
	        		deferred.resolve(cartData);
		        } else {
		        	deferred.reject('Pos missing')
		        }

		        return deferred.promise;
	        }

	        function recalculateResortFeeAmount(resortFee, cartData, extraPerson, calculationType) {
	        	var createResv = (typeof cartData.addReservation != 'undefined') ? cartData.addReservation : false;
	       	 	var nightlyPrice = 0;
				var total = 0;
				var discount = 0;
				cartData.prices.rates.forEach(function(nightlyPrice, nightlyKey){
					if(resortFee.extra_attribute_type == 'percentage') {
						nightlyPrice = parseFloat(cartData.prices.rates[nightlyKey]) - parseFloat(cartData.prices.nightlydiscount[nightlyKey]);

						if(extraPerson.extra_attribute != undefined && extraPerson.extra_attribute == 'extra_person' && extraPerson.prices.rates[nightlyKey] != undefined && extraPerson.prices.nightlydiscount[nightlyKey] != undefined ) {
							nightlyPrice = parseFloat(nightlyPrice) + parseFloat(extraPerson.prices.rates[nightlyKey]) - parseFloat(extraPerson.prices.nightlydiscount[nightlyKey]);
						}
						nightlyPrice = (nightlyPrice * resortFee.extra_attribute_value) / 100;
					} else {
						nightlyPrice = resortFee.extra_attribute_value;
					}
					nightlyPrice = roundnum(nightlyPrice, 2);
					resortFee.prices.rates[nightlyKey] = nightlyPrice;
					if(calculationType != undefined && calculationType == 'recalculate') {
						resortFee.prices.nightlydiscount[nightlyKey] = roundnum(0.00, 2);
					}
				 	total += parseFloat(nightlyPrice);					
				 	discount += parseFloat(resortFee.prices.nightlydiscount[nightlyKey]);					
				});
				var netAmount = total;

				// if((typeof cartData.tax_exempt_indicator != 'undefined' && cartData.tax_exempt_indicator)){
				// if ( (typeof cartData.customerTaxExempt != 'undefined' && cartData.customerTaxExempt) || (typeof cartData.travellerTaxExempt != 'undefined' && cartData.travellerTaxExempt)) {
				if ( (typeof cartData.customerTaxExempt != 'undefined' && cartData.customerTaxExempt && createResv && resortFee.extra_attribute != undefined && resortFee.extra_attribute != 'resort_fee') || (((typeof cartData.customerTaxExempt != 'undefined' && cartData.customerTaxExempt && resortFee.customer_traveller_id == cartData.customerId) || (typeof cartData.travellerTaxExempt != 'undefined' && cartData.travellerTaxExempt && resortFee.customer_traveller_id == cartData.travellerId)) && !createResv) || (typeof cartData.travellerTaxExempt != 'undefined' && cartData.travellerTaxExempt) ) {

					resortFee.tax_amt 		= roundnum(0, 2);
					resortFee.tax 			= roundnum(0, 2);
					if(resortFee.taxes != undefined) {
						var taxAmount = 0;
						resortFee.taxes.forEach(function(tax, taxKey) {							
							resortFee.taxes[taxKey]['tax'] 		= taxAmount;
							resortFee.taxes[taxKey]['tax_amt'] 	= taxAmount;
						});
					}
				} else {
					if(resortFee.taxes != undefined) {
						resortFee.tax_amt = 0;
						resortFee.tax = 0;
						resortFee.taxes.forEach(function(tax, taxKey) {
							var taxAmount;
							if (resortFee.waiveCcProcessingFee === true && cartTaxLineIsCcProcessingFee(tax)) {
								taxAmount = 0;
							} else {
								taxAmount = roundnum(((netAmount - discount) * tax.tax_value) / 100, 2);
							}
							resortFee.tax_amt 	= parseFloat(resortFee.tax_amt) + parseFloat(taxAmount);
							resortFee.tax 		= parseFloat(resortFee.tax) + parseFloat(taxAmount);
							resortFee.taxes[taxKey]['tax'] 		= taxAmount;
							resortFee.taxes[taxKey]['tax_amt'] 	= taxAmount;
						});
					} else {
						resortFee.tax_amt 	= roundnum(((netAmount - discount) * resortFee.tax_value) / 100, 2);
						resortFee.tax 		= roundnum(((netAmount - discount) * resortFee.tax_value) / 100, 2);
					}
					
				}
				resortFee.nightlySum 			= netAmount;
				resortFee.customPrice 			= netAmount;
				resortFee.particularCustomPrice = netAmount;
				resortFee.product_discount 		= discount;
				resortFee.grand_total 			= roundnum(netAmount - discount + parseFloat(resortFee.tax_amt), 2);
				return resortFee;
			}

	        var service = {
	        	roundnum : roundnum,
	        	addPoromotion : addPoromotion,
	        	calculatesubtotal : calculatesubtotal,
	        	calculatesubtotalPos : calculatesubtotalPos,
	        	gotoaddChannel : gotoaddChannel,
	        	gotoaddteam : gotoaddteam,
	        	gotoadduser : gotoadduser,
	        	gotoaddGroup : gotoaddGroup,
	        	setAdults : setAdults,
	        	breakIntoNights : breakIntoNights,
	        	sumNights : sumNights,
	        	sumnightlyDisc : sumnightlyDisc,
	        	getDiscountNights : getDiscountNights,
	        	calculatePOSTotals : calculatePOSTotals,
	        	calculateTotals : calculateTotals,
	        	checkValidExpDate : checkValidExpDate,
	        	checkValidExpDateCreate : checkValidExpDateCreate,
	        	calculateGCValue : calculateGCValue,
	        	creditCardChanged : creditCardChanged,
	        	creditCardChangedCreate : creditCardChangedCreate,
	        	makeAddress : makeAddress,
	        	recalculateResortFeePos : recalculateResortFeePos,
	        	recalculateResortFeeAmount : recalculateResortFeeAmount,
				calculateExpirationYears : calculateExpirationYears,
	        };
	        return service;
	      }
	    }());

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('commonDailog', commonDailog);

    /** @ngInject */
    function commonDailog($mdDialog)
    {
		function showSimpleDailog(titletext,content){
			var alert = $mdDialog.alert({
							title: titletext,
							htmlContent: '<div class="md-padding custom-common-dailog">'+content+'</div>',
							ok: 'OK'
						});

			$mdDialog
			.show( alert )
			.finally(function() {
				alert = undefined;
			});
		}

		function showSimpleDailogMultiple(titletext, content) {
			var alert = $mdDialog.alert({
				title: titletext,
				htmlContent: '<div class="md-padding custom-common-dailog">'+content+'</div>',
				ok: 'OK',
				multiple: true
			});
		
			$mdDialog
				.show(alert)
				.finally(function() {
					alert = undefined;
				});
		}
		
		var service = {
			showSimpleDailog : showSimpleDailog,
			showSimpleDailogMultiple : showSimpleDailogMultiple
		};
		return service;
    }
}());

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('validNumber', function() {
		return {
            require: '?ngModel',
            link: function(scope, element, attrs, ngModelCtrl) {
              if(!ngModelCtrl) {
                return; 
              }

              ngModelCtrl.$parsers.push(function(val) {
                if (angular.isUndefined(val)) {
                    var val = '';
                }
                
                var clean = val.replace(/[^-0-9\.]/g, '');
                var negativeCheck = clean.split('-');
                  var decimalCheck = clean.split('.');
                if(!angular.isUndefined(negativeCheck[1])) {
                    negativeCheck[1] = negativeCheck[1].slice(0, negativeCheck[1].length);
                    clean =negativeCheck[0] + '-' + negativeCheck[1];
                    if(negativeCheck[0].length > 0) {
                        clean =negativeCheck[0];
                    }
                }
                  
                if(!angular.isUndefined(decimalCheck[1])) {
                    decimalCheck[1] = decimalCheck[1].slice(0,2);
                    clean =decimalCheck[0] + '.' + decimalCheck[1];
                }

                if (val !== clean) {
                  ngModelCtrl.$setViewValue(clean);
                  ngModelCtrl.$render();
                }
                return clean;
              });

              element.bind('keypress', function(event) {
                if(event.keyCode === 32) {
                  event.preventDefault();
                }
              });
            }
        };
	});
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('numberOnly', function() {
		return {
			link: function (scope, element, attr, ngModelCtrl) {
	            function fromUser(text) {
	                if (text) {
	                    var transformedInput = text.replace(/[^0-9-]/g, '');

	                    if (transformedInput !== text) {
	                        ngModelCtrl.$setViewValue(transformedInput);
	                        ngModelCtrl.$render();
	                    }
	                    return transformedInput;
	                }
	                return undefined;
	            }
	            ngModelCtrl.$parsers.push(fromUser);
	        }
		};
	});
})();



angular.module('app.core').directive('bindHtmlCompile', ['$compile', function ($compile) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      scope.$watch(function () {
        return scope.$eval(attrs.bindHtmlCompile);
      }, function (value) {
        element.html(value && value.toString());
        var compileScope = scope;
        if (attrs.bindHtmlScope) {
          compileScope = scope.$eval(attrs.bindHtmlScope);
        }
        $compile(element.contents())(compileScope);
      });
    }
  };
}]);

angular.module('app.core').directive('whenScrolled', function() {
    return function(scope, elm, attr) {
        var raw = elm[0];

        elm.bind('scroll', function() {
            if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
                scope.$apply(attr.whenScrolled);
            }
        });
    };
});

angular.module('app.core').directive('onErrorSrc', function() {
    return {
        link: function(scope, element, attrs) {
          element.bind('error', function() {
            if (attrs.src != attrs.onErrorSrc) {
              attrs.$set('src', attrs.onErrorSrc);
            }
          });
        }
    }
});
 angular.module('MyApp', ['ngMaterial', 'ngMessages', 'material.svgAssetsCache','ui.mask'])
    .directive('mdChips', function($timeout) {
      return {
        restrict: 'E',
        require: 'mdChips', // Extends the original mdChips directive
        link: function(scope, element, attributes, mdChipsCtrl) {

          var mouseUpActions = [];

          mdChipsCtrl.onInputBlur = function(event) {
            this.inputHasFocus = false;

            mouseUpActions.push((function() {
              var chipBuffer = this.getChipBuffer();
              if (chipBuffer != "") { // REQUIRED, OTHERWISE YOU'D GET A BLANK CHIP
                this.appendChip(chipBuffer);
                this.resetChipBuffer();
              }
            }).bind(this));
          };

          window.addEventListener('click', function(event) {
            while (mouseUpActions.length > 0) {
              var action = mouseUpActions.splice(0, 1)[0];
              $timeout(function() {
                $timeout(action);
              });
            }
          }, false);
        }
      }
    });
    angular.module('app.core').directive('scrollOnClick', function() {
  return {
    restrict: 'A',
    link: function(scope, $elm) {
      $elm.on('click', function() {
        // console.log($elm[0]['id']);
        $('div').animate({scrollTop: $elm.offset().top}, "slow");
      });
    }
  }
});

angular.module('app.core').directive('isNumber', function () {
  return {
    require: 'ngModel',
    link: function (scope) {
      scope.$watch('vm.minimumAmount', function(newValue,oldValue) {
                var arr = String(newValue).split("");
                if (arr.length === 0) return;
                if (arr.length === 1 && (arr[0] == '-' || arr[0] === '.' )) return;
                if (arr.length === 2 && newValue === '-.') return;
                if (isNaN(newValue)) {
                    scope.minimumAmount = oldValue;
                }
            });
    }
  };
});
angular.module('app.core').directive('numbersOnly', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                if (text) {
                    var transformedInput = text.replace(/[^0-9]/g, '');

                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return undefined;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
});

angular.module('app.core').directive('postrenderAction', postrenderAction);
/* @ngInject */
function postrenderAction($timeout) {
    var directive = {
        restrict: 'A',
        priority: 101,
        link: link
    };
    return directive;
    function link(scope, element, attrs) {
        $timeout(function() {
            scope.$evalAsync(attrs.postrenderAction);
        }, 0);
    }
}



(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('limitTo', function() {
		return {
			link: function (scope, element, attrs, ngModelCtrl) {
		      var maxlength = Number(attrs.limitTo);
		      function fromUser(text) {
		          if (text.length > maxlength) {
		            var transformedInput = text.substring(0, maxlength);
		            ngModelCtrl.$setViewValue(transformedInput);
		            ngModelCtrl.$render();
		            return transformedInput;
		          }
		          return text;
		      }
		      ngModelCtrl.$parsers.push(fromUser);
		    }
		};
	});
})();


(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('allowDecimalNumbers', function() {
		return {  
            restrict: 'A',  
            link: function (scope, elm, attrs, ctrl) {  
                elm.on('keydown', function (event) {  
                    var $input = $(this);  
                    var value = $input.val();  
                    value = value.replace(/[^0-9\.]/g, '')  
                    $input.val(value);
                    var shiftkey = event.originalEvent.shiftKey;
                    if (event.which == 64 || event.which == 16) {  
                        // numbers  
                        return false;  
                    } 
                    if ([8, 13, 27, 37, 38, 39, 40, 110].indexOf(event.which) > -1) {
                        // backspace, enter, escape, arrows  
                        return true;  
                    } else if (event.which >= 48 && event.which <= 57 && !shiftkey) {
                        // numbers  
                        return true;  
                    } else if (event.which >= 96 && event.which <= 105) {  
                        // numpad number  
                        return true;  
                    } else if ([46, 110, 190].indexOf(event.which) > -1) {  
                        // dot and numpad dot  
                        return true;  
                    } else {  
                        event.preventDefault();  
                        return false;  
                    }  
                });  
            }  
        };
	});
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('app.core')
        .directive('chooseFile', function() {
		return {
			link: function (scope, elem, attrs) {
				var button = elem.find('button');
				var input = angular.element(elem[0].querySelector('input#pictures'));
				button.bind('click', function() {
				  input[0].click();
				});
				input.bind('change', function(e) {
					scope.$apply(function() {
						var files = e.target.files;
						scope.file = files[0];
						if (files[0]) {
							scope.fileName = files[0].name;
							scope.filePath = URL.createObjectURL(files[0]);
							scope.imageStatus = false;
						} else {
							scope.fileName = null;
						}
					});
				});
			}
		};
	});
})();

"use strict";
var MyFixedPath = "https://www.lodgingsystem.com/";
/**
 * @ngdoc service
 * @name minervaApp.EnvironmentConfig
 * @description
 * # EnvironmentConfig - PROD
 * Service in the minervaApp.
 */
angular.module("app.core").constant("EnvironmentConfig", {
  api: "https://www.lodgingsystem.com/ls-api/",
  app: MyFixedPath,
  currentVersion: 6,
  feBase_url: MyFixedPath + "lodgingsystem/assets/",
  cc_dates_option: {
    1: "01 - January",
    2: "02 - February",
    3: "03 - March",
    4: "04 - April",
    5: "05 - May",
    6: "06 - June",
    7: "07 - July",
    8: "08 - August",
    9: "09 - September",
    10: "10 - October",
    11: "11 - November",
    12: "12 - December",
  },
  cc_yrs_option: {
    2021: 2021,
    2022: 2022,
    2023: 2023,
    2024: 2024,
    2025: 2025,
    2026: 2026,
    2027: 2027,
    2028: 2028,
    2029: 2029,
    2030: 2030,
    2031: 2031,
    2032: 2032,
    2033: 2033,
    2034: 2034,
    2035: 2035,
    2036: 2036,
    2037: 2037,
    2038: 2038,
    2039: 2039,
    2040: 2040,
  },
  source: "PMS",
  pubnubSubscribeKey: "sub-c-da8379d1-2b0e-4f29-bff5-f408ec71addf",
});

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('range', range);

    /** @ngInject */
    function range()
    {
        return function(input, total) {
            total = parseInt(total);
            for (var i=0; i<total; i++) {
              input.push(i);
            }
            return input;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value, temp)
        {
            var myTimeZone = temp;
            var timeStamp = new Date(value).getTime();
            var clientTime =moment().tz(myTimeZone).format();
            var myTimeConvertedToClienZone =  moment(timeStamp).tz(myTimeZone).format("M/D/YYYY h:m:s a");
            return myTimeConvertedToClienZone; 
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function () {
  "use strict";

  angular.module("app.utils", []).factory("commonUtils", commonUtils);

  /** @ngInject */
  function commonUtils() {
    var hotels = {
      116: "Manhattan Tower Apartment",
      119: "Southernmost House",
      120: "Coral House",
      121: "Villa Venezia",
      122: "Plaza Beach Resorts",
      126: "Skipjack",
    };

    return {
      getHotelName,
    };

    function getHotelName(id) {
      return hotels[id] || "Unknown Hotel";
    }
  }
})();


(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi, loginService,$localStorage, $state, $mdSidenav, $timeout,$scope, $rootScope, moment){

        var vm = this;

        // Data
        vm.date = new Date();
        vm.gotoLink = gotoLink;
        vm.loadMore = loadMore;
        vm.getAllNotification = getAllNotification;
        vm.shideShowMore = false;
        vm.bothNotification = [];
        vm.readNotification = [];
        vm.loadAllDefaultData= loadAllDefaultData;
        vm.unreadStatus = false;
        vm.bothStatus = false;
        vm.readStatus = false;

        vm.unread = [];
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };
       $rootScope.$on("CallParentMethod", function(){
          vm.loadAllDefaultData();
          $timeout(function() {loginService.updateVisibleNotification({hotel_id:$rootScope.hotels[$rootScope.selectedHotel].hotel_id})
           .then(function(response){
             });
            }, 2000);

        });


        function loadAllDefaultData(){
          var btnIcon = angular.element( document.querySelector( '#notificationBubble' ) );
           btnIcon.css('display','none');
               
			loginService.getAllNotifications({hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id})
			.then(function(response){
				vm.unreadStatus = false;
				vm.bothStatus = false;
				vm.readStatus = false;
				vm.timeZone = response.timezone;

			   vm.userId = response['userId'];
			   vm.unreadCount = response['unreadCount'];
			   vm.totalNotification = response['totalNoti'];
			   vm.notificationType = response['notification_type'];
			   if(vm.notificationType == 'unread'){
					vm.unreadStatus = true;
					vm.unread = response['notifications'];
			   }else if(vm.notificationType == 'read'){
				   vm.readNotification = response['notifications'];
				   vm.tempRead = response['notifications'];
				   vm.readStatus = true;

			   }else if(vm.notificationType == 'both'){
				  vm.bothStatus = true;
				   vm.bothNotification = response['notifications'];

			   }
			});
		}


        vm.items = [];

    var counter = 0;
    vm.moreCounter = 10;
    function loadMore() {
       vm.readNotification = vm.tempRead;
       if(vm.readNotification.length <= vm.totalNotification){
         loginService.getMoreNotification({hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id, start:vm.readNotification.length})
        .then(function(response){
            vm.timeZone = response.timezone;
            for (var i=0; i<response.notifications.length; i++){
                    vm.readNotification.push(response.notifications[i]);
                }
        });
       }
    };
    if(vm.notificationType == 'read'){
    loadMore();
    }





	function gotoLink(path, status,fields, value){
		var myObj ={};
		vm.resObj = {};
		myObj[fields] = value;
		loginService.unSerializeData({value:value}).then(function(response){
			vm.resObj = response;
		});
		if(status == 'add'){
			$state.go("app."+path);
		} else if(status == 'update'){
			if(fields == 'array'){
				if(Object.keys(vm.resObj).length != 0){
					$state.go("app."+path,vm.resObj);

				} else {
					$timeout(function(){
						$state.go("app."+path,vm.resObj);
					},300);
				}
			} else {
				$state.go("app."+path, myObj);
			}
		}
		$mdSidenav('quick-panel').toggle();
		loginService.getAllNotifications({hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id}).then(function(response){
			vm.notifications = response['notifications'];
			vm.userId = response['userId'];
		});
	}
    function getAllNotification(){
         loginService.getNotifications({hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id})
        .then(function(response){
           vm.notifications = response['notifications'];
           vm.userId = response['userId'];
           vm.totalNoti = response['totalNoti'] - response['notifications'].length;
		   vm.shideShowMore = true;

        });
    }
        // Methods
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($scope, $rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, $window, $localStorage,EnvironmentConfig, loginService, createResService, commonService, messageCenterNotificationSoundService){


        var vm = this;
        var inboxToastTimer = null;
        // Inbox selection used to suppress New message toasts only for the open thread.
        var mcActiveConversation = {
            confirmation_number: '',
            conversation_sid: '',
            message_thread_id: ''
        };
        $rootScope.username     = $localStorage.firstName+' '+$localStorage.lastName;
        $rootScope.profilePic   = $localStorage.profilePic;
        vm.role                 = $localStorage.roleId;
        vm.userPermissions		= $rootScope.userPermissions;
        // Data
        $rootScope.global = {
            search: ''
        };
        vm.baseUrl = EnvironmentConfig.api;

        vm.bodyEl = angular.element('body');
        vm.selectedMode = 'md-scale';
		vm.isOpen = false;
		vm.selectedDirection = 'up';

		vm.isOpenPermissions = false;
		vm.selectedDirectionPerm = 'left';

		vm.isOpenProducts = false;
        vm.selectedDirectionprod = 'left';
        vm.notificationBubble = false;
		vm.notificationCount = 0;
        vm.inboxToast = null;

        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.changeHotel = changeHotel;
        vm.roleId = $localStorage.roleId;
        vm.addNewReservation = addNewReservation;
        vm.changestate = changestate;
        vm.addPoromotion=commonService.addPoromotion;
        vm.gotoaddChannel=commonService.gotoaddChannel;
        vm.gotoadduser = commonService.gotoadduser;
        vm.gotoaddGroup = commonService.gotoaddGroup;
        vm.gotoaddteam = commonService.gotoaddteam;
        vm.notificationBtnColor = notificationBtnColor;
        vm.dismissInboxToast = dismissInboxToast;
        vm.openInboxToast = openInboxToast;

        //~ $rootScope.$on('$stateChangeStart',
			//~ function(event, toState, toParams, fromState, fromParams){
				//~ if(toState.name == 'app.create-res'){
					//~ vm.showAddNewRes = false;
				//~ }else{
					//~ vm.showAddNewRes = true;
				//~ }
			//~ }
		//~ );
        //~
        //~ if($state.current.name == 'app.create-res'){
			//~ vm.showAddNewRes = false;
		//~ }else{
			//~ vm.showAddNewRes = true;
		//~ }

        init();

        /**
         * Initialize
         */
        function init(){
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];
            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
            // vm.notificationBtnColor();

            $scope.$on('messageCenter:inboxToast', function (event, payload) {
                showInboxToast(payload);
            });

            $scope.$on('messageCenter:activeConversation', function (event, info) {
                mcActiveConversation = {
                    confirmation_number: (info && info.confirmation_number) || '',
                    conversation_sid: (info && info.conversation_sid) || '',
                    message_thread_id: (info && info.message_thread_id) || ''
                };
            });

            $scope.$on('$destroy', function () {
                clearInboxToastTimer();
            });
        }

        function clearInboxToastTimer()
        {
            if (inboxToastTimer) {
                $timeout.cancel(inboxToastTimer);
                inboxToastTimer = null;
            }
        }

        function isOnMessageCenterInbox()
        {
            var name = $state.current && $state.current.name;

            // Live inbox routes (not Templates / Group compose only pages).
            return name === 'app.guest-message-center.messages' ||
                name === 'app.guest-message-center.staff-messages' ||
                name === 'app.guest-message-center.direct-messages' ||
                name === 'app.guest-message-center.ota-messages';
        }

        function toastMatchesActiveConversation(payload)
        {
            if (!payload) {
                return false;
            }

            if (payload.confirmation_number && mcActiveConversation.confirmation_number &&
                payload.confirmation_number === mcActiveConversation.confirmation_number) {
                return true;
            }

            if (payload.conversation_sid && mcActiveConversation.conversation_sid &&
                payload.conversation_sid === mcActiveConversation.conversation_sid) {
                return true;
            }

            if (payload.message_thread_id && mcActiveConversation.message_thread_id &&
                payload.message_thread_id === mcActiveConversation.message_thread_id) {
                return true;
            }

            return false;
        }

        function showInboxToast(payload)
        {
            // Escalations always show (force). Normal new-message toasts show
            // everywhere, including on inbox, except when that conversation is
            // already open (message is already visible).
            if (!payload) {
                return;
            }

            if (!payload.force && isOnMessageCenterInbox() && toastMatchesActiveConversation(payload)) {
                return;
            }

            // Escalations use a sharper alert tone; normal messages keep the doorbell.
            messageCenterNotificationSoundService.play(
                payload.type === 'escalation' ? 'escalation' : 'message'
            );

            clearInboxToastTimer();
            vm.inboxToast = payload;
            inboxToastTimer = $timeout(function () {
                vm.inboxToast = null;
                inboxToastTimer = null;
            }, 8000);
        }

        function dismissInboxToast($event)
        {
            if ($event) {
                $event.stopPropagation();
            }

            clearInboxToastTimer();
            vm.inboxToast = null;
        }

        /**
         * Open the conversation from a Message Center toast notification.
         * Prefers confirmation_number (unified inbox); falls back to SIDs via broadcast.
         * Staff threads open the staff inbox; guest threads open the guest inbox.
         */
        function openInboxToast($event)
        {
            var toast;
            var params;
            var targetState;

            if ($event) {
                $event.preventDefault();
            }

            toast = vm.inboxToast;

            if (!toast) {
                return;
            }

            params = {
                confirmation_number: toast.confirmation_number || '',
                conversation_sid: toast.conversation_sid || '',
                message_thread_id: toast.message_thread_id || ''
            };

            targetState = toast.is_staff
                ? 'app.guest-message-center.staff-messages'
                : 'app.guest-message-center.messages';

            dismissInboxToast();

            $state.go(targetState, {
                confirmation_number: params.confirmation_number || null
            }).then(function () {
                $rootScope.$broadcast('messageCenter:openConversation', params);
            }, function () {
                // navigation cancelled
            });
        }

        function changestate(statename,action){

			if(action==''){
				$state.go(statename);
			}else{
				$state.go(statename,{showaddDialog:true});
			}
		}

		function addNewReservation(ev){
			createResService.addRoom(ev,'','',2,0,'','new','','toolBar');
		}

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId){
            $rootScope.$emit("CallParentMethod", {});


             $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status){
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout(){
            $rootScope.logoutUser();
        }
        
        function notificationBtnColor(){
            loginService.getUnReadNotificationCount({hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id})
            .then(function(response){
                var btnIcon = angular.element( document.querySelector( '#btnIcon' ) );
                if(response.unrReadCount>0){
                    vm.notificationCount = response.unrReadCount;
                    vm.notificationBubble=true;
                }
               });
        }


        function googleTranslateElementInit() {
            var count = 0;
            new google.translate.TranslateElement({
                pageLanguage: 'en',
                autoDisplay: true,
                multilanguagePage: true
            }, 'google_translate_element');
            $('#google_translate_element').bind('DOMNodeInserted', function(event) {
                count++;
                if (count == 1) {
                    setTimeout(function() {
                        $('.goog-te-combo').attr('id','language').attr('aria-labelledby','language');
                        $('.goog-te-combo option:first-child').html('Select a Language');
                    },6000);
                    $('body').css('top',0);
                }
                setTimeout(function() {
                    if (google.translate.TranslateElement().a.cd != 'en' && google.translate.TranslateElement().a.cd != null) {
                        $('.goog-te-combo option:first-child').hide();
                        $('.goog-te-combo option[value="en"]').show();
                    }
                }, 7000);
            });
            if($('.goog-te-combo').length>0){
                $('.goog-te-combo').attr('id','language').attr('aria-labelledby','language');
            }
            $('select#language').addClass('md-button');
            setInterval(function(){ 
                var offset = $('body').offset();
                if(offset.top > 0){
                   $('body').css('top',0); 
                }
            }, 100);
           
        }
       
        /**
         * Change Language
         */
        function changeLanguage(){
            vm.selectedLanguage = $rootScope.hotels[$rootScope.selectedHotel].default_language;
            googleTranslateElementInit();
            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            // if ( lang.code !== 'en' ){
                /*
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;*/
            // }

            // Change the language
            // $translate.use(lang.code);
        }

        if($('#google_translate_element').length > 0){
            setTimeout(function(){
                vm.changeLanguage();
            },2000);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu(){
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded(){
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query){
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ ){
                if ( flatNavigation[x].uisref ){
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query ){
                navigation = navigation.filter(function (item){
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 ){
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function (){
                deferred.resolve(navigation);
            }, 1000);
            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item){
            // If item has a link
            if ( item.uisref ){
                // If there are state params,
                // use them...
                if ( item.stateParams ){
                    $state.go(item.state, item.stateParams);
                }
                else{
                    $state.go(item.state);
                }
            }
        }

        function changeHotel(index){

            $rootScope.selectedHotel    = index;
            $localStorage.selectedHotel = index;
            vm.selectedHotelId          = $rootScope.hotels[$rootScope.selectedHotel].hotel_id;
            $rootScope.getSubHotels(vm.selectedHotelId);
            loginService.updateselected(vm.selectedHotelId).then(function(response){
                if(response['success']){
                    console.log(response);
                    $localStorage.userPermissions = [];
                    $rootScope.userPermissions = [];
                    $localStorage.authToken = '';
                    $rootScope.currentState = '';
                    $localStorage.userPermissions= btoa(response.permissionList);
                    $rootScope.userPermissions = atob($localStorage.userPermissions);
                    $rootScope.currentState = response.permission;
                    $localStorage.authToken = response.updatedJwtToken;
                    $localStorage.hotelgeneralsetting = response.hotelgeneralsetting || {};
                    $rootScope.loadHotelInformation(vm.selectedHotelId);
                    if($rootScope.currentState == ''){
                        if($state.current.name == 'app.e-commerce.orders') 
                            $state.go($state.current, {toast_message:false}, {reload: true});
                        else
                            $state.reload();
                    } else {
                        $state.go($rootScope.currentState, {toast_message:false}, {reload: true});
                    }
                }
                setTimeout(function(){
                    vm.changeLanguage();
                },5000);
            });
           
        }
    }
})();

(function ()
{
    'use strict';
    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [
            'underscore',
            'ngStorage',
            'ngCsv',
            'textAngular',
            'wipImageZoom',
            'ui.mask',
            'ngIdle',
            // 'htmlToPdfSave',
            'pasvaz.bindonce',
            // Core
            'app.core',
            // Navigation
            'app.navigation',
            // Toolbar
            'app.toolbar',
            // Apps
            'app.dashboards',
            'app.quick-panel',
            'app.contacts',
            'app.permissions',
            'app.settings',
            'app.e-commerce',
            'app.reports',
            'app.create-res',
            'app.policy',
            'app.rateCategory',
            'app.rateCalendarLogs',
            'app.roomPrecedence',
            'app.sheetPrice',
            'app.todo',

            'app.rateRule',
            'app.pages',
            'app.groups',
            'app.mls',
            'app.team',
            'app.channels',
            'app.promotions',
            'app.checkout',
            'app.generate-invoice',
            'app.subscriber',
            'app.guest-message-center',
            'app.quickBook',
            'app.restaurant',
            'app.rentalListing',
            'highcharts-ng',
            'app.customer-calendar-search',
            'app.utils'
        ])
      .directive('intlTelInput', ['$timeout', function ($timeout) {
        return {
          restrict: 'A',
          require: '?ngModel',
          link: function (scope, element, attrs, ngModel) {
            $timeout(function () {
              if (window.intlTelInput && element[0]) {
                // Append the country list to <body> so it is not clipped by
                // overflow:hidden ancestors (md-dialog, scroll panels, etc.).
                const iti = window.intlTelInput(element[0], {
                  initialCountry: 'us',
                  separateDialCode: true,
                  loadUtils: window.loadIntlTelUtils,
                  dropdownContainer: document.body,
                });
                element.data('iti', iti);

                scope.$on('$destroy', function () {
                  try {
                    if (iti && typeof iti.destroy === 'function') {
                      iti.destroy();
                    }
                  } catch (e) {
                    // Ignore cleanup errors during teardown.
                  }
                });

                if (ngModel) {
                  // Format value coming from the model to the view
                  ngModel.$formatters.push(function(value) {
                    if (value) {
                      iti.setNumber(value);
                      // Return the national number formatted by iti so the input value is clean
                      return element.val();
                    }
                    return value;
                  });

                  // Parse view value back to the model
                  ngModel.$parsers.push(function(value) {
                    if (iti.isValidNumberPrecise()) {
                      return iti.getNumber();
                    }
                    return value;
                  });

                  // Update model when country changes
                  element.on('countrychange', function() {
                    scope.$applyAsync(function() {
                      if (iti.isValidNumberPrecise()) {
                        ngModel.$setViewValue(iti.getNumber());
                      } else {
                        ngModel.$setViewValue(element.val());
                      }
                    });
                  });

                  // Initialize if model already has a value
                  if (ngModel.$modelValue) {
                    iti.setNumber(ngModel.$modelValue);
                  }
                }
              }
            });
          }
        };
      }]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope){
        // Data
        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event){
            if ( event.targetScope.$id === $scope.$id ){
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
'use strict';

/**
 * @ngdoc service
 * @name minervaApp.../login/loginService
 * @description
 * # ../login/loginService
 * Service in the minervaApp.
 */
 angular.module('app.core')
 .service('loginService', function($http, EnvironmentConfig){
 	function getDataComplete(response) {
 		return response.data;
 	}

 	function getDataFailed(error) {
 		return error.data;
 	}
 	function isloggedin(authenticateUser){
 		return $http({
 			url:EnvironmentConfig.api + 'login/isloggedIn',
 			method: 'POST',
 			data: authenticateUser

 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);
 	}
 	function getlogin(loginParams){
 		return $http({
 			url:EnvironmentConfig.api+'login/checklogin',
 			method:'POST',
 			data:loginParams
 		})
 		.then(getDataComplete)
 		.catch(getDataFailed);
 	}

 	function getpasswordLink(data){
		return $http({
			url:EnvironmentConfig.api+'login/resetPasswordLink',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function generateNewPass(newPass){
		return $http({
			url:EnvironmentConfig.api+'login/generateNewPass',
			method:'POST',
			data:newPass
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function updateselected(hotel){
		
		return $http({
			url:EnvironmentConfig.api+'users/skipAcl_update_selected_hotel',
			method:'POST',
			data:hotel
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

	function getHotelInformation(hotelId){
		return $http({
			url: EnvironmentConfig.api + 'dashboard/hotel_information/' + hotelId.hotel_id,
			method: 'GET',
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getAllNotifications(hotelId){
		
		return $http({
			url:EnvironmentConfig.api+'Channels/skipAcl_getNotifications',
			method:'POST',
			data:hotelId
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function updateVisibleNotification(hotelId){
		
		return $http({
			url:EnvironmentConfig.api+'Channels/skipAcl_updateNotificationViewed',
			method:'POST',
			data:hotelId
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getNotifications(hotelId){
		
		return $http({
			url:EnvironmentConfig.api+'Channels/skipAcl_getAllNotification',
			method:'POST',
			data:hotelId
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
		function updateAllNotification(hotelId){
		
		return $http({
			url:EnvironmentConfig.api+'Channels/skipAcl_updateNotificationshowMore',
			method:'POST',
			data:hotelId
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}
	function getMoreNotification(data){
		return $http({
			url:EnvironmentConfig.api+'Channels/skipAcl_getMoreData',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);

	}
	function unSerializeData(data){
		return $http({
			url:EnvironmentConfig.api+'login/skipAcl_unserializeData',
			method:'POST',
			data:data
		})
		.then(getDataComplete)
		.catch(getDataFailed);

	}
	function getUnReadNotificationCount(data){
			return $http({
				url:EnvironmentConfig.api+'Channels/getUnreadNotificationsCount',
				method:'POST',
				data:data
			})
			.then(getDataComplete)
			.catch(getDataFailed);

		}

	function updateLastLogin(){
		return $http({
			url:EnvironmentConfig.api+'users/update_last_login',
			method:'POST',
			data:{}
		})
		.then(getDataComplete)
		.catch(getDataFailed);
	}

 	return{
 		getlogin: getlogin,
 		isloggedin: isloggedin,
 		generateNewPass: generateNewPass,
		getpasswordLink: getpasswordLink,
		updateselected: updateselected,
		getHotelInformation: getHotelInformation,

		getAllNotifications:getAllNotifications,
		updateVisibleNotification:updateVisibleNotification,
		getNotifications:getNotifications,
		updateAllNotification:updateAllNotification,
		getMoreNotification:getMoreNotification,
		unSerializeData:unSerializeData,
		getUnReadNotificationCount:getUnReadNotificationCount,
		updateLastLogin:updateLastLogin
 	}
 });
'use strict';

/**
 * @ngdoc function
 * @name minervaApp.controller:LoginLoginCtrl
 * @description
 * # LoginLoginCtrl
 * Controller of the minervaApp
 */
angular.module('app.core')
  .controller('LoginCtrl',[ 'loginService','$location', '$localStorage','$stateParams', function (loginService,$location, $localStorage,$stateParams) {
  	var lgn = this;
	lgn.type 			= $stateParams.type;
	lgn.successMessage 	= $stateParams.message;

    lgn.login=function(){
		lgn.errorMessage = '';
		var data={'uname':lgn.uname,'pass':lgn.pass};
		loginService.getlogin(data).then(function(res){
			lgn.loadingmessage='';
			if(res.id_token){
				$localStorage.authToken= res.id_token;
				$location.path('/users');
			}else{
				// lgn.errorMessage=data.errorMsg;
				lgn.errorMessage="Please enter correct credentials";
			}
		});		
	}
  }]);

'use strict';

/**
 * @ngdoc function
 * @name minervaApp.controller:GlobalCtrl
 * @description
 * # GlobalCtrl
 * Controller of the minervaApp
 */
 angular.module('app.core')
 .controller('GlobalCtrl',['$localStorage','$rootScope', function ($localStorage,$rootScope) {
 	this.awesomeThings = [
 	'HTML5 Boilerplate',
 	'AngularJS',
 	'Karma'
 	];


 	var glb = this;
 	glb.logout = function(){
 		$localStorage.authToken = undefined;
 	}

 	glb.socalLogins = function(type,regPage) {
		$rootScope.$on('event:social-sign-in-success', function(event, userDetails){

		});
	}
}]);

/**
@license
DayPilot Pro
Copyright (c) 2005 - 2017 Annpoint s.r.o.
http://www.daypilot.org/
Use of this software is subject to license terms.
Version: 2911
*/
if("undefined"==typeof DayPilot)var DayPilot={};if("undefined"==typeof DayPilot.Global&&(DayPilot.Global={}),function(){function e(e){var t=DayPilot.Date.Cache.Ticks;if(t[e])return DayPilot.Stats.cacheHitsTicks+=1,t[e];var i,n=new Date(e),a=n.getUTCMilliseconds();i=0===a?"":a<10?".00"+a:a<100?".0"+a:"."+a;var o=n.getUTCSeconds();o<10&&(o="0"+o);var r=n.getUTCMinutes();r<10&&(r="0"+r);var s=n.getUTCHours();s<10&&(s="0"+s);var l=n.getUTCDate();l<10&&(l="0"+l);var d=n.getUTCMonth()+1;d<10&&(d="0"+d);var c=n.getUTCFullYear();if(c<=0)throw"The minimum year supported is 1.";c<10?c="000"+c:c<100?c="00"+c:c<1e3&&(c="0"+c);var h=c+"-"+d+"-"+l+"T"+s+":"+r+":"+o+i;return t[e]=h,h}function t(e,t){return!DayPilot.Util.isNullOrUndefined(e)&&(!DayPilot.Util.isNullOrUndefined(t)&&e.toLocaleLowerCase()===t.toLocaleLowerCase())}if("undefined"==typeof DayPilot.$){DayPilot.$=function(e){return document.getElementById(e)},DayPilot.isKhtml=navigator&&navigator.userAgent&&navigator.userAgent.indexOf("KHTML")!==-1,DayPilot.isIE=navigator&&navigator.userAgent&&(navigator.userAgent.indexOf("MSIE")!==-1||navigator.userAgent.indexOf("Trident")!==-1),DayPilot.isIEQuirks=DayPilot.isIE&&document.compatMode&&"BackCompat"===document.compatMode,DayPilot.browser={},DayPilot.browser.ie8=function(){var e=document.createElement("div");return e.innerHTML="<!--[if IE 8]><i></i><![endif]-->",1===e.getElementsByTagName("i").length}(),DayPilot.browser.ie9=function(){var e=document.createElement("div");return e.innerHTML="<!--[if IE 9]><i></i><![endif]-->",1===e.getElementsByTagName("i").length}(),DayPilot.browser.ielt9=function(){var e=document.createElement("div");return e.innerHTML="<!--[if lt IE 9]><i></i><![endif]-->",1===e.getElementsByTagName("i").length}(),DayPilot.browser.ff=navigator&&navigator.userAgent&&navigator.userAgent.indexOf("Firefox")!==-1,DayPilot.browser.chrome=navigator&&navigator.userAgent&&navigator.userAgent.indexOf("Chrome")!==-1,DayPilot.browser.ie=DayPilot.isIE,DayPilot.browser.webkit=navigator&&navigator.userAgent&&navigator.userAgent.indexOf("WebKit")!==-1,DayPilot.browser.passiveEvents=!1,function(){try{window.addEventListener("test",null,Object.defineProperty({},"passive",{"get":function(){DayPilot.browser.passiveEvents=!0}}))}catch(e){}}(),DayPilot.libs={},DayPilot.libs.angularjs="object"==typeof angularjs,DayPilot.touch={},DayPilot.touch.start=window.navigator.msPointerEnabled?"MSPointerDown":"touchstart",DayPilot.touch.move=window.navigator.msPointerEnabled?"MSPointerMove":"touchmove",DayPilot.touch.end=window.navigator.msPointerEnabled?"MSPointerUp":"touchend",DayPilot.mo2=function(e,t){if(t=t||window.event,"undefined"!=typeof t.offsetX){var i={x:t.offsetX+1,y:t.offsetY+1};if(!e)return i;for(var n=t.srcElement;n&&n!==e;)"SPAN"!==n.tagName&&(i.x+=n.offsetLeft,n.offsetTop>0&&(i.y+=n.offsetTop-n.scrollTop)),n=n.offsetParent;return n?i:null}if("undefined"!=typeof t.layerX){var i={x:t.layerX,y:t.layerY,src:t.target};if(!e)return i;for(var n=t.target;n&&"absolute"!==n.style.position&&"relative"!==n.style.position;)n=n.parentNode,DayPilot.isKhtml&&(i.y+=n.scrollTop);for(;n&&n!==e;)i.x+=n.offsetLeft,i.y+=n.offsetTop-n.scrollTop,n=n.offsetParent;return n?i:null}return null},DayPilot.mo3=function(e,t){t=t||window.event;var i,n=DayPilot.page(t);if(n){var a=DayPilot.abs(e);i={x:n.x-a.x,y:n.y-a.y}}else i=DayPilot.mo2(e,t);return i.shift=t.shiftKey,i.meta=t.metaKey,i.ctrl=t.ctrlKey,i.alt=t.altKey,i},DayPilot.mc=function(e){return e.pageX||e.pageY?{x:e.pageX,y:e.pageY}:{x:e.clientX+document.documentElement.scrollLeft,y:e.clientY+document.documentElement.scrollTop}},DayPilot.Stats={},DayPilot.Stats.eventObjects=0,DayPilot.Stats.dateObjects=0,DayPilot.Stats.cacheHitsCtor=0,DayPilot.Stats.cacheHitsParsing=0,DayPilot.Stats.cacheHitsTicks=0,DayPilot.Stats.print=function(){console.log("DayPilot.Stats.eventObjects: "+DayPilot.Stats.eventObjects),console.log("DayPilot.Stats.dateObjects: "+DayPilot.Stats.dateObjects),console.log("DayPilot.Stats.cacheHitsCtor: "+DayPilot.Stats.cacheHitsCtor),console.log("DayPilot.Stats.cacheHitsParsing: "+DayPilot.Stats.cacheHitsParsing),console.log("DayPilot.Stats.cacheHitsTicks: "+DayPilot.Stats.cacheHitsTicks),console.log("DayPilot.Date.Cache.Ctor keys: "+Object.keys(DayPilot.Date.Cache.Ctor).length),console.log("DayPilot.Date.Cache.Parsing keys: "+Object.keys(DayPilot.Date.Cache.Parsing).length)},DayPilot.list=function(e,t){if(e&&e.isDayPilotList&&!t)return e;var i=DayPilot.isArray(e)||"[object NodeList]"===Object.prototype.toString.call(e),n=!i&&!DayPilot.Util.isNullOrUndefined(e),a=[];if(a.isDayPilotList=!0,a.clone=function(){var e=DayPilot.list();return a.each(function(t){e.push(t)}),e},a.each=function(e){if(e){if(a.forEach)return void a.forEach(e);for(var t=0;t<this.length;t++)e(a[t],t,a)}},a.addProps=function(e){var t=a.clone();if(e)for(var i in e)t[i]=e[i];return t},a.last=function(){return 0===a.length?null:a[a.length-1]},a.first=function(){return 0===a.length?null:a[0]},a.add=function(e){var t=a.clone();return t.push(e),t},a.map=function(e){if("function"!=typeof e)throw"DayPilot.list().map(f): Function expected";var t=DayPilot.list();return a.each(function(i,n,a){t.push(e(i,n,a))}),t},a.filter=function(e){var t=DayPilot.list();if("function"!=typeof e)throw"DayPilot.list().filter(f): Function expected";return a.each(function(i){e(i)&&t.push(i)}),t},a.concat=function(e){if(!e)return a;for(var t=a.clone(),i=0;i<e.length;i++)t.push(e[i]);return t},a.find||(a.find=function(e){if("function"!=typeof e)throw"DayPilot.list().find(f): Function expected";for(var t=0;t<this.length;t++)if(e(a[t]))return a[t]}),a.findIndex||(a.findIndex=function(e){if("function"!=typeof e)throw"DayPilot.list().findIndex(f): Function expected";for(var t=0;t<this.length;t++)if(e(a[t]))return t;return-1}),a.some||(a.some=function(e){if("function"!=typeof e)throw"DayPilot.list().some(f): Function expected";for(var t=0;t<this.length;t++)if(e(a[t]))return!0;return!1}),a.reduce||(a.reduce=function(e,t){if("function"!=typeof e)throw"DayPilot.list().reduce(f): Function expected";var i,n=0;if("undefined"!=typeof t)i=t;else{if(n=1,0===a.length)throw"DayPilot.list().reduce(f): No initial value and empty list";i=a[0]}for(var o=n;o<this.length;o++)i=e(i,a[o],o,this);return i}),a.isEmpty=function(){return 0===a.length},i)for(var o=0;o<e.length;o++)a[o]=e[o];else n&&(a[0]=e);return a},DayPilot.list.for=function(e,t){for(var i=DayPilot.list(),n=0;n<e;n++)"function"==typeof t?i.push(t(n)):i.push(n);return i},DayPilot.line=function(e,t,i,n,a){var o={"x":e,"y":t},r={"x":i,"y":n,"deg":DayPilot.deg(e,t,i,n)};if(t<n){var s=t;t=n,n=s,s=e,e=i,i=s}var l=DayPilot.deg(e,t,i,n),d={"x":e,"y":t},c={"x":i,"y":n},h=function(){var a=Math.abs(e-i),o=Math.abs(t-n),r=(e+i)/2;return r-Math.sqrt(a*a+o*o)/2}(),u=function(){return(t+n)/2}(),f=DayPilot.distance(d,c),v=document.createElement("div");v.setAttribute("style","border:1px solid black;width:"+f+"px;height:0px;-moz-transform:rotate("+l+"deg);-webkit-transform:rotate("+l+"deg);-ms-transform:rotate("+l+"deg);transform:rotate("+l+"deg);position:absolute;top:"+u+"px;left:"+h+"px;");var p=document.createElement("div");if(p.appendChild(v),a){var g=6,m=r.y-g,y=r.x-g,l=l;r.y>o.y&&(l-=180);var b=document.createElement("div");b.style.borderColor="transparent black transparent transparent",b.style.borderWidth="6px",b.style.borderStyle="solid",b.style.position="absolute",b.style.left=y+"px",b.style.top=m+"px",b.style.transform="rotate("+l+"deg)",p.appendChild(b)}return p},DayPilot.deg=function(e,t,i,n){var a,o=Math.abs(e-i),r=Math.abs(t-n),s=(e+i)/2,l=(t+n)/2,d=Math.sqrt(o*o+r*r),c=s-d/2,h=l;o=d/2,a=Math.abs(s-c),r=Math.sqrt(Math.abs(e-c)*Math.abs(e-c)+Math.abs(t-h)*Math.abs(t-h));var u=(r*r-o*o-a*a)/(2*o*a);return 180*Math.acos(u)/Math.PI},DayPilot.complete=function(e){return"complete"===document.readyState?void e():(DayPilot.complete.list||(DayPilot.complete.list=[],DayPilot.re(document,"readystatechange",function(){if("complete"===document.readyState){for(var e=0;e<DayPilot.complete.list.length;e++){(0,DayPilot.complete.list[e])()}DayPilot.complete.list=[]}})),void DayPilot.complete.list.push(e))},DayPilot.page=function(e){return e=e||window.event,"undefined"!=typeof e.pageX?{x:e.pageX,y:e.pageY}:"undefined"!=typeof e.clientX?{x:e.clientX+document.body.scrollLeft+document.documentElement.scrollLeft,y:e.clientY+document.body.scrollTop+document.documentElement.scrollTop}:null},DayPilot.rel=function(e,t){var i=DayPilot.abs(e),n=DayPilot.abs(t);return{"x":i.x-n.x,"y":i.y-n.y,"w":e.offsetWidth,"h":e.offsetHeight}},DayPilot.abs=function(e,t){if(!e)return null;if(e.getBoundingClientRect){var i=DayPilot.absBoundingClientBased(e);if(t){var n=DayPilot.absOffsetBased(e,!1),t=DayPilot.absOffsetBased(e,!0);i.x+=t.x-n.x,i.y+=t.y-n.y,i.w=t.w,i.h=t.h}return i}return DayPilot.absOffsetBased(e,t)},DayPilot.absBoundingClientBased=function(e){var t=e.getBoundingClientRect(),i=document.body.getBoundingClientRect();return{x:t.left-i.left,y:t.top-i.top,w:e.clientWidth,h:e.clientHeight,toString:function(){return"x:"+this.x+" y:"+this.y+" w:"+this.w+" h:"+this.h}}},DayPilot.isArray=function(e){return"[object Array]"===Object.prototype.toString.call(e)},DayPilot.absOffsetBased=function(e,t){for(var i={x:e.offsetLeft,y:e.offsetTop,w:e.clientWidth,h:e.clientHeight,toString:function(){return"x:"+this.x+" y:"+this.y+" w:"+this.w+" h:"+this.h}};DayPilot.op(e);)e=DayPilot.op(e),i.x-=e.scrollLeft,i.y-=e.scrollTop,t&&(i.x<0&&(i.w+=i.x,i.x=0),i.y<0&&(i.h+=i.y,i.y=0),e.scrollLeft>0&&i.x+i.w>e.clientWidth&&(i.w-=i.x+i.w-e.clientWidth),e.scrollTop&&i.y+i.h>e.clientHeight&&(i.h-=i.y+i.h-e.clientHeight)),i.x+=e.offsetLeft,i.y+=e.offsetTop;var n=DayPilot.pageOffset();return i.x+=n.x,i.y+=n.y,i},DayPilot.wd=function(){var e=DayPilot.isIEQuirks,t=document.documentElement.clientHeight;e&&(t=document.body.clientHeight);var i=document.documentElement.clientWidth;e&&(i=document.body.clientWidth);var n=document.documentElement&&document.documentElement.scrollTop||document.body.scrollTop,a=document.documentElement&&document.documentElement.scrollLeft||document.body.scrollLeft,o={};return o.width=i,o.height=t,o.scrollTop=n,o.scrollLeft=a,o},DayPilot.op=function(e){try{return e.offsetParent}catch(e){return document.body}},DayPilot.distance=function(e,t){return Math.sqrt(Math.pow(e.x-t.x,2)+Math.pow(e.y-t.y,2))},DayPilot.doc=function(){var e=document.documentElement;return e&&e.clientHeight?e:document.body},DayPilot.pageOffset=function(){if("undefined"!=typeof window.pageXOffset)return{x:window.pageXOffset,y:window.pageYOffset};var e=DayPilot.doc();return{x:e.scrollLeft,y:e.scrollTop}},DayPilot.ac=function(e,t){if(!t)var t=[];for(var i=0;e.children&&i<e.children.length;i++)t.push(e.children[i]),DayPilot.ac(e.children[i],t);return t},DayPilot.indexOf=function(e,t,i){if(!e||!e.length)return-1;for(var n=0;n<e.length;n++)if(i){if(i(e[n],t))return n}else if(e[n]===t)return n;return-1},DayPilot.contains=function(e,t){return!!e&&(e===t&&!DayPilot.isArray(e)||DayPilot.indexOf(e,t)!==-1)},DayPilot.rfa=function(e,t){var i=DayPilot.indexOf(e,t);i!==-1&&e.splice(i,1)},DayPilot.sheet=function(){var e=document.createElement("style");e.setAttribute("type","text/css"),e.styleSheet||e.appendChild(document.createTextNode("")),(document.head||document.getElementsByTagName("head")[0]).appendChild(e);var t=!!e.styleSheet,i={};return i.rules=[],i.commit=function(){try{t&&(e.styleSheet.cssText=this.rules.join("\n"))}catch(e){}},i.add=function(i,n,a){if(t)return void this.rules.push(i+"{"+n+"}");if(e.sheet.insertRule)"undefined"==typeof a&&(a=e.sheet.cssRules.length),e.sheet.insertRule(i+"{"+n+"}",a);else{if(!e.sheet.addRule)throw"No CSS registration method found";e.sheet.addRule(i,n,a)}},i},DayPilot.Args=function(e){var t=this;this.isArgs=!0,this.preventDefault=function(){e&&e.preventDefault(),t.preventDefault.value=!0}},DayPilot.Debug=function(e){var t=this;this.printToBrowserConsole=!1,this.enabled=!1,this.messages=[],this.a=null,this.clear=function(){this.messages=[],t.a&&(t.a.innerHTML="")},this.hide=function(){DayPilot.de(t.a),t.a=null},this.show=function(){t.a&&t.hide();var i=e.nav.top,n=document.createElement("div");n.style.position="absolute",n.style.top="0px",n.style.bottom="0px",n.style.left="0px",n.style.right="0px",n.style.backgroundColor="black",n.style.color="#ccc",n.style.overflow="auto",n.style.webkitUserSelect="auto",n.style.MozUserSelect="all",n.onclick=function(){t.hide()};for(var a=0;a<this.messages.length;a++){var o=t.messages[a],r=o.b();n.appendChild(r)}this.a=n,i.appendChild(n)},this.message=function(e,t){if(this.enabled){var i={};i.time=new DayPilot.Date,i.level=t||"debug",i.text=e,i.b=function(){var e=document.createElement("div");switch(e.innerHTML=i.time+" ("+i.level+"): "+i.text,i.level){case"error":e.style.color="red";break;case"warning":e.style.color="orange";break;case"info":e.style.color="white";break;case"debug":}return e},this.messages.push(i),this.printToBrowserConsole&&"undefined"!=typeof console&&console.log(i)}}},DayPilot.re=function(e,t,i){if(i&&e)if(e.addEventListener)e.addEventListener(t,i,!1);else if(e.attachEvent){var n=function(t){i.call(e,t)};e.attachEvent("on"+t,n)}},DayPilot.ue=function(e,t,i){e.removeEventListener?e.removeEventListener(t,i,!1):e.detachEvent&&e.detachEvent("on"+t,i)},DayPilot.tr=function(e){return e?"string"==typeof e?e.replace(/^\s+|\s+$/g,""):e:""},DayPilot.ds=function(e){return DayPilot.Date.toStringSortable(e)},DayPilot.gs=function(e,t){var i=e;if(i.currentStyle)var n=i.currentStyle[t];else if(window.getComputedStyle)var n=document.defaultView.getComputedStyle(i,null).getPropertyValue(t);return"undefined"==typeof n&&(n=""),n},DayPilot.StyleReader=function(e){function t(e){return e.charAt(0).toUpperCase()+e.slice(1)}this.get=function(i){var n=DayPilot.list(i.split("-")),a=n.reduce(function(e,i,n){return i=t(i),e+i});return e?DayPilot.gs(e,a)||DayPilot.gs(e,i):null},this.getPx=function(e){var t=this.get(e);return t.indexOf("px")===-1?void 0:parseInt(t,10)},this.getFont=function(){var e="bold"===this.get("font-weight")?"bold":"",t="italic"===this.get("font-style")?"italic":"";return{"family":this.get("font-family"),"size":this.get("font-size"),"style":t+" "+e}},this.getBackColor=function(e){"undefined"==typeof e&&(e="white");var t=this.get("background-color");return DayPilot.Util.isTransparentColor(t)?e:t}},DayPilot.he=function(e){var t=e.replace(/&/g,"&amp;");return t=t.replace(/</g,"&lt;"),t=t.replace(/>/g,"&gt;"),t=t.replace(/"/g,"&quot;")},DayPilot.he2=function(e){var t=document.createTextNode(e),i=document.createElement("div");return i.appendChild(t),i.innerHTML},DayPilot.us=function(e){if(e){e.setAttribute("unselectable","on"),e.style.userSelect="none",e.style.MozUserSelect="none",e.style.KhtmlUserSelect="none",e.style.webkitUserSelect="none";for(var t=0;t<e.childNodes.length;t++)1===e.childNodes[t].nodeType&&DayPilot.us(e.childNodes[t])}},DayPilot.pu=function(e){var t,i,n,a=e.attributes;if(a)for(i=a.length,t=0;t<i;t+=1)a[t]&&(n=a[t].name,"function"==typeof e[n]&&(e[n]=null));if(a=e.childNodes)for(i=a.length,t=0;t<i;t+=1){DayPilot.pu(e.childNodes[t])}},DayPilot.puc=function(e){var t,i,n=e.childNodes;if(n){var i=n.length;for(t=0;t<i;t+=1)DayPilot.pu(e.childNodes[t])}},DayPilot.de=function(e){if(e)if(DayPilot.isArray(e))for(var t=0;t<e.length;t++)DayPilot.de(e[t]);else e.parentNode&&e.parentNode.removeChild(e)},DayPilot.fade=function(e,t,i){if(e){clearTimeout(e.messageTimeout);var n="none"!==e.style.display,a=t>0,o=t<0;if(0!==t){if(a?e.status="in":o&&(e.status="out"),a&&!n)e.target=parseFloat(e.style.opacity),e.opacity=0,e.style.opacity=0,e.style.filter="alpha(opacity=0)",e.style.display="";else if(o&&!e.target)e.target=e.style.opacity;else{var r=e.opacity,s=Math.floor(10*(r+t))/10;a&&s>e.target&&(s=e.target),o&&s<0&&(s=0);var l=100*s;e.opacity=s,e.style.opacity=s,e.style.filter="alpha(opacity="+l+")"}if(a&&(e.opacity>=e.target||e.opacity>=1)||o&&e.opacity<=0){if(e.target=null,o){e.style.opacity=e.target,e.opacity=e.target;var d=e.target?"alpha(opacity="+100*e.target+")":null;e.style.filter=d,e.style.display="none"}i&&"function"==typeof i&&(e.status=null,i())}else e.messageTimeout=setTimeout(function(){DayPilot.fade(e,t,i)},50)}}},DayPilot.sw=function(e){return e?e.offsetWidth-e.clientWidth:0},DayPilot.swa=function(){var e=document.createElement("div");e.style.position="absolute",e.style.top="-2000px",e.style.left="-2000px",e.style.width="200px",e.style.height="100px",e.style.overflow="auto";var t=document.createElement("div");t.style.width="300px",t.style.height="300px",e.appendChild(t),document.body.appendChild(e);var i=DayPilot.sw(e);return document.body.removeChild(e),i},DayPilot.sh=function(e){return e?e.offsetHeight-e.clientHeight:0},DayPilot.guid=function(){var e=function(){return(65536*(1+Math.random())|0).toString(16).substring(1)};return""+e()+e()+"-"+e()+"-"+e()+"-"+e()+"-"+e()+e()+e()},DayPilot.ua=function(e){if("string"==typeof e||"number"==typeof e)return[e];for(var t={},i=[],n=0,a=e.length;n<a;++n)e[n]in t||(i.push(e[n]),t[e[n]]=1);return i},DayPilot.am=function(){return"undefined"==typeof angular?null:(DayPilot.am.cached||(DayPilot.am.cached=angular.module("daypilot",[])),DayPilot.am.cached)},function(){function e(e,n){var a={w:e.offsetWidth,h:e.offsetHeight,x:parseInt(e.style.left),y:parseInt(e.style.top)};a.height=e.style.height,a.width=e.style.width,a.top=e.style.top,a.left=e.style.left,a.toString=function(){return"w: "+this.w+" h:"+this.h};var o={};if(o.finished=null,o.vertical="center",o.horizontal="center",n)for(var r in n)o[r]=n[r];e.style.visibility="hidden",e.style.display="";var s=n.animation||"fast",l=t(s);l.div=e,l.i=0,l.target=a,l.config=o,i(l)}function t(e){var t=function(){var e=[];e.time=10;var t,i=.08;t=.1;for(var n=t;n<1.2;n+=i)e.push(n),t=n;i=.03;for(var n=t;n>.8;n-=i)e.push(n),t=n;for(var n=t;n<=1;n+=i)e.push(n),t=n;return e},i=function(){var e=[];e.time=10;var t,i=.04;t=.1;for(var n=t;n<=1;n+=i)e.push(n),t=n;return e},n=function(){var e=[];e.time=10;var t,i=.08;t=.1;for(var n=t;n<=1;n+=i)e.push(n),t=n;return e},a={"fast":n,"slow":i,"jump":t};return a[e]||(e="fast"),a[e]()}function i(e){var t,n=e.div,a=e[e.i],o=a*e.target.h;switch(e.config.vertical){case"center":t=e.target.y-(o-e.target.h)/2;break;case"top":t=e.target.y;break;case"bottom":t=e.target.y-(o-e.target.h);break;default:throw"Unexpected 'vertical' value."}var r,s=a*e.target.w;switch(e.config.horizontal){case"left":r=e.target.x;break;case"center":r=e.target.x-(s-e.target.w)/2;break;case"right":r=e.target.x-(s-e.target.w);break;default:throw"Unexpected 'horizontal' value."}var l=DayPilot.wd(),d=l.height+l.scrollTop-(t+o);d<0&&(t+=d);var c=l.width-(r+s);c<0&&(r+=c),n.style.height=o+"px",n.style.top=t+"px",n.style.width=s+"px",n.style.left=r+"px",n.style.visibility="visible",e.i++,e.i<e.length-1?setTimeout(function(e){return function(){i(e)}}(e),e.time):(n.style.width=e.target.width,n.style.height=e.target.height,n.style.top=e.target.top,n.style.left=e.target.left,"function"==typeof e.config.finished&&e.config.finished())}DayPilot.pop=e}(),DayPilot.Util={},DayPilot.Util.addClass=function(e,t){if(t&&e)if(DayPilot.isArray(e))for(var i=0;i<e.length;i++)DayPilot.Util.addClass(e[i],t);else{if(!e.className)return void(e.className=t);var n=new RegExp("(^|\\s)"+t+"($|\\s)");n.test(e.className)||(e.className=e.className+" "+t)}},DayPilot.Util.normalizeColor=function(e){function t(e){return e=e.replace(/[^\d,]/g,"").split(","),"#"+((1<<24)+(+e[0]<<16)+(+e[1]<<8)+ +e[2]).toString(16).slice(1)}return 0===e.indexOf("rgb")?t(e):e},DayPilot.Util.addClassToString=function(e,t){return e?new RegExp("(^|\\s)"+t+"($|\\s)").test(e)?e:e+" "+t:t},DayPilot.Util.removeClassFromString=function(e,t){if(!e)return"";var i=new RegExp("(^|\\s)"+t+"($|\\s)");return e.replace(i," ").replace(/^\s\s*/,"").replace(/\s\s*$/,"")},DayPilot.Util.removeClass=function(e,t){if(e)if(DayPilot.isArray(e))for(var i=0;i<e.length;i++)DayPilot.Util.removeClass(e[i],t);else{var n=new RegExp("(^|\\s)"+t+"($|\\s)");e.className=e.className.replace(n," ").replace(/^\s\s*/,"").replace(/\s\s*$/,"")}},DayPilot.Util.props=function(e){var t=[];for(var i in e)t.push(i),t.push(e[i]);return t.join("-")},DayPilot.Util.propArray=function(e,t,i){return DayPilot.list(e).map(function(e){return e[t]?e[t]:i})},DayPilot.Util.updatePropsFromArray=function(e,t,i){for(var n=0;n<i.length;n++)e[n][t]=i[n]},DayPilot.Util.copyProps=function(e,t,i){if(e){if(t||(t={}),"undefined"==typeof i)for(var n in e)"undefined"!=typeof e[n]&&(t[n]=e[n]);else for(var a=0;a<i.length;a++){var n=i[a];"undefined"!=typeof e[n]&&(t[n]=e[n])}return t}},DayPilot.Util.firstPropValue=function(e){for(var t in e)return e[t]},DayPilot.Util.createArrayCopy=function(e,t){if(!DayPilot.isArray(e))return[];for(var i=[],n=0;n<e.length;n++){var a={};DayPilot.Util.copyProps(e[n],a,t),i.push(a)}return i},DayPilot.Util.avg=function(e,t){return(e+t)/2},DayPilot.Util.div=function(e,t,i,n,a){var o=document.createElement("div");return(t||i||n||a)&&(n<0&&(t+=n,n*=-1),a<0&&(i+=a,a*=-1),o.style.position="absolute","number"==typeof t?o.style.left=t+"px":"string"==typeof t&&(o.style.left=t),"number"==typeof i?o.style.top=i+"px":"string"==typeof i&&(o.style.top=i),"number"==typeof n?o.style.width=n+"px":"string"==typeof n&&(o.style.width=n),"number"==typeof a?o.style.height=a+"px":"string"==typeof a&&(o.style.height=a)),e&&e.appendChild(o),o},DayPilot.Util.overlaps=function(e,t,i,n){return!(t<=i||e>=n)},DayPilot.Util.isMouseEvent=function(e){return!!navigator.msPointerEnabled&&(!!e.pointerType&&("mouse"===e.pointerType||4===e.pointerType))},DayPilot.Util.mouseButton=function(e){var t={};if(e=e||window.event,"undefined"==typeof e.which)switch(e.button){case 1:t.left=!0;break;case 4:t.middle=!0;break;case 2:t.right=!0;break;case 0:t.unknown=!0}else switch(e.which){case 1:t.left=!0;break;case 2:t.middle=!0;break;case 3:t.right=!0}return t},DayPilot.Util.membersPlain=function(e){var t=DayPilot.Util.members(e,2),i=function(e){for(var t=0;t<e.length;t++){var i=e[t],n=i.name;i.obsolete&&(n+=" (obsolete)"),i.noCssOnly&&(n+=" (!cssOnly)"),i.aspnet&&(n+=" (ASP.NET)"),i.mvc&&(n+="(MVC)"),e[t]=n}};return i(t.events),i(t.methods),i(t.properties),t},DayPilot.Util.shouldApply=function(e){if(!e)return!1;var t=e.toLowerCase();return!(t.indexOf("before")>=0)&&(!(t.indexOf("after")>=0)&&("onrowfilter"!==t&&"oneventfilter"!==t))},DayPilot.Util.safeApply=function(e,t){var i=e["$root"]["$$phase"];"$apply"===i||"$digest"===i?e["$eval"](t):e["$apply"](t)},DayPilot.Util.members=function(e,t){var i=DayPilot.list(),n=DayPilot.list(),a=DayPilot.list(),o=e&&e.members?e.members.obsolete:[],r=e&&e.members?e.members.noCssOnly:[],s=e&&e.members?e.members.ignore:[],l=e&&e.members&&e.members.ignoreFilter?e.members.ignoreFilter:function(){return!1};for(var d in e)if(0!==d.indexOf("$")&&0!==d.indexOf("_")&&0!==d.indexOf("number")&&0!==d.indexOf("is")&&"v"!==d&&!DayPilot.contains(s,d)&&!l(d))if(0!==d.indexOf("on"))if("function"!=typeof e[d])if("object"!=typeof e[d])a.push(d);else{var c=e[d];if(0===t){a.push(d);continue}if(c&&c.nodeType>0){a.push(d);continue}if(c instanceof DayPilot.Bubble){a.push(d);continue}if(c instanceof DayPilot.Date){a.push(d);continue}if(c instanceof DayPilot.Menu){a.push(d);continue}if(c instanceof DayPilot.Scheduler){a.push(d);continue}if(DayPilot.isArray(c)){a.push(d);continue}null===c&&a.push(d);var h=null;"number"==typeof t&&(h=t-1);for(var u=DayPilot.Util.members(c,h),f=0;f<u.events.length;f++)i.push(d+"."+u.events[f].name);for(var f=0;f<u.methods.length;f++)n.push(d+"."+u.methods[f].name);for(var f=0;f<u.properties.length;f++)a.push(d+"."+u.properties[f].name)}else n.push(d);else i.push(d);i.sort(),n.sort(),a.sort();var v=function(e){for(var t=0;t<e.length;t++){var i=e[t],n={};n.name=i,e[t]=n,DayPilot.contains(o,i)&&(n.obsolete=!0),DayPilot.contains(r,i)&&(n.noCssOnly=!0),i.indexOf("CallBack")!==-1&&(n.aspnet=!0,n.mvc=!0),i.indexOf("PostBack")!==-1&&(n.aspnet=!0),i.indexOf("Notify")!==-1&&(n.aspnet=!0,n.mvc=!0)}};return v(i),v(n),v(a),{"events":i,"methods":n,"properties":a}},DayPilot.Util.replaceCharAt=function(e,t,i){return e.substr(0,t)+i+e.substr(t+i.length)},DayPilot.Util.evalVariable=function(e,t){if(t=t||["object"],null===e||"undefined"==typeof e)return null;if(DayPilot.indexOf(t,typeof e)!==-1)return e;if("string"!=typeof e)throw"Unable to resolve a variable name (not a string).";if(!/^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(e))throw"Invalid variable name: "+e;return eval(e)},DayPilot.Util.evalFunction=function(e){if(null===e)return null;if("function"==typeof e)return e;if("string"!=typeof e)throw"Unable to resolve a function (not a string).";if(!/^\(?function/.test(e))throw"Invalid function string";return eval("("+e+")")},DayPilot.Util.parseJSON=function(e){return JSON&&JSON.parse?JSON.parse(e):DayPilot.JSON.parse(e)},DayPilot.Util.isNullOrUndefined=function(e){return null===e||"undefined"==typeof e},DayPilot.Util.log=function(e){window.console&&window.console.log&&window.console.log(e)},DayPilot.Util.adiff=function(e,t,i){var n={};return n.add=[],n.remove=[],n},DayPilot.Util.workerFrom=function(e){var t=e.toString(),i=t.slice(t.indexOf("{")+1,t.lastIndexOf("}")),n=new Blob([i]),a=window.URL.createObjectURL(n);return new Worker(a)},DayPilot.Util.dataUriToBlob=function(e){if("string"!=typeof e)throw"DayPilot.Util.dataUriToBlob(): dataURI string expected";for(var t=e.split(","),i=t[0],n=t[1],a=i.indexOf("base64")!==-1,o=a?atob:decodeURI,r=i.split(":")[1].split(";")[0],s=o(n),l=new window.Uint8Array(s.length),d=0;d<s.length;d++)l[d]=s.charCodeAt(d);return new Blob([l],{"type":r})},DayPilot.Util.downloadDataUri=function(e,t){var i=DayPilot.Util.dataUriToBlob(e);DayPilot.Util.downloadBlob(i,t)},DayPilot.Util.downloadBlob=function(e,t){var t=t||"download";if(window.navigator.msSaveBlob)window.navigator.msSaveBlob(e,t);else{var i=window.URL.createObjectURL(e),n=document.createElement("a");n.download=t,n.href=i,n.style="display:none",document.body.appendChild(n),n.click(),setTimeout(function(){document.body.removeChild(n),window.URL.revokeObjectURL(i)})}},DayPilot.Util.monitor=function(e,t,i){var n=e[t];e[t]=function(){i.apply(e,arguments),n.apply(e,arguments)}},DayPilot.Util.isTransparentColor=function(e){return"transparent"===e||"rgba(0, 0, 0, 0)"===e},DayPilot.Util.stripTags=function(e){if(DayPilot.Util.isNullOrUndefined(e))return e;if("string"==typeof e)return e.replace(/<(?:.|\n)*?>/gm,"");throw new DayPilot.Error("Unable to strip tags from a non-string")},DayPilot.Areas={},DayPilot.Areas.attach=function(e,t,n){var n=n||{},a=n.areas,o=n.allowed||function(){return!0},r=n.offsetX||0;a=i(t,a),a&&DayPilot.isArray(a)&&0!==a.length&&(DayPilot.re(e,"mousemove",function(i){e.active||e.areasDisabled||!o()||DayPilot.Areas.showAreas(e,t,i,a,{"offsetX":r,"eventDiv":n.eventDiv})}),DayPilot.re(e,"mouseout",function(t){DayPilot.Areas.hideAreas(e,t)}),DayPilot.list(a).each(function(i){if("Visible"===(i.visibility||i.v||"Visible")){var a=DayPilot.Areas.createArea(e,t,i,{"offsetX":r,"eventDiv":n.eventDiv});e.appendChild(a)}}))},DayPilot.Areas.disable=function(e){e.areasDisabled=!0,DayPilot.list(e.childNodes).filter(function(e){return e.isActiveArea&&!e.area.start}).each(function(e){e.style.display="none"})},DayPilot.Areas.enable=function(e){e.areasDisabled=!1,DayPilot.list(e.childNodes).filter(function(e){return e.isActiveArea&&!e.area.start}).each(function(e){e.style.display=""})},DayPilot.Areas.remove=function(e){var t=DayPilot.list(e.childNodes).filter(function(e){return e.isActiveArea});DayPilot.de(t)};var i=function(e,t){return DayPilot.isArray(t)||(t=e.areas,t||(e.cache?t=e.cache.areas:e.data&&(t=e.data.areas))),t};DayPilot.Areas.showAreas=function(e,t,i,n,a){if(!DayPilot.Global.resizing&&!DayPilot.Global.moving){if(DayPilot.Areas.all&&DayPilot.Areas.all.length>0)for(var o=0;o<DayPilot.Areas.all.length;o++){var r=DayPilot.Areas.all[o];r!==e&&DayPilot.Areas.hideAreas(r,i)}if(!e.active&&(e.active={},DayPilot.isArray(n)||(n=t.areas,n||(t.cache?n=t.cache.areas:t.data&&(n=t.data.areas))),n&&0!==n.length&&!(e.areas&&e.areas.length>0))){e.areas=[];for(var o=0;o<n.length;o++){var s=n[o];if("Hover"===(s.visibility||s.v||"Visible")){var l=DayPilot.Areas.createArea(e,t,s,a);e.areas.push(l),e.appendChild(l),DayPilot.Areas.all.push(e)}}e.active.children=DayPilot.ac(e)}}},DayPilot.Areas.createArea=function(e,t,i,n){function a(e,t,i){DayPilot.Bubble&&DayPilot.Bubble.touchPosition(i),e.calendar.bubble&&e.calendar.bubble.showEvent(e,!0)}function o(e,t,i,n){DayPilot.Menu&&DayPilot.Menu.touchPosition(n);var a=i.menu;if("string"==typeof a?a=DayPilot.Util.evalVariable(a):t.isEvent&&t.calendar.contextMenu?a=DayPilot.Util.evalVariable(t.calendar.contextMenu):t.isRow&&t.calendar.contextMenuResource&&(a=DayPilot.Util.evalVariable(t.calendar.contextMenuResource)),a&&a.show){var o={"type":"area","div":e,"e":t,"area":i};a.show(t,{"initiator":o})}}var n=n||{},r=n.offsetX||0,s=n.eventDiv||e,l=document.createElement("div");l.isActiveArea=!0,l.area=i,l.setAttribute("unselectable","on");var d=i.w||i.width,c=i.h||i.height,h=i.cssClass||i.css||i.className;if("undefined"!=typeof i.style&&l.setAttribute("style",i.style),l.style.position="absolute","undefined"!=typeof d&&(l.style.width=d+"px"),"undefined"!=typeof c&&(l.style.height=c+"px"),"undefined"!=typeof i.right&&(l.style.right=i.right+"px"),"undefined"!=typeof i.top&&(l.style.top=i.top+"px"),"undefined"!=typeof i.left&&(l.style.left=i.left+r+"px"),"undefined"!=typeof i.bottom&&(l.style.bottom=i.bottom+"px"),"undefined"!=typeof i.html&&i.html)l.innerHTML=i.html;else if(i.icon){var u=document.createElement("i");u.className=i.icon,l.appendChild(u)}else if(i.image){var f=document.createElement("img");f.src=i.image,l.appendChild(f)}if(h&&(l.className=h),i.toolTip&&l.setAttribute("title",i.toolTip),i.backColor&&(l.style.background=i.backColor),i.background&&(l.style.background=i.background),i.fontColor&&(l.style.color=i.fontColor),i.padding&&(l.style.padding=i.padding+"px",l.style.boxSizing="border-box"),"ResizeEnd"===i.action||"ResizeStart"===i.action||"Move"===i.action){if(t.calendar.isCalendar)switch(i.action){case"ResizeEnd":i.cursor="s-resize",i.dpBorder="bottom";break;case"ResizeStart":i.cursor="n-resize",i.dpBorder="top";break;case"Move":i.cursor="move"}if(t.calendar.isScheduler||t.calendar.isMonth)switch(i.action){case"ResizeEnd":i.cursor="e-resize",i.dpBorder="right";break;case"ResizeStart":i.cursor="w-resize",i.dpBorder="left";break;case"Move":i.cursor="move"}l.onmousemove=function(e,t,i){return function(n){var n=n||window.event;n.cancelBubble=!0,t.calendar.internal&&t.calendar.internal.dragInProgress&&t.calendar.internal.dragInProgress()||(e.style.cursor=i.cursor,i.dpBorder&&(e.dpBorder=i.dpBorder))}}(s,t,i),l.onmouseout=function(e,t,i){return function(t){e.style.cursor=""}}(s,t,i)}if(("ResizeEnd"===i.action||"ResizeStart"===i.action)&&t.isEvent&&t.calendar.internal.touch){var v=function(e,t,i){return function(n){n.cancelBubble=!0;var a=t.calendar.internal.touch,o=n.touches?n.touches[0]:n,r={x:o.pageX,y:o.pageY};t.calendar.coords=a.relativeCoords(n),a.preventEventTap=!0,t.calendar.isScheduler?a.startResizing(e,"ResizeEnd"===i.action?"right":"left"):t.calendar.isCalendar&&a.startResizing(e,"ResizeEnd"===i.action?"bottom":"top",r)}}(s,t,i);DayPilot.re(l,DayPilot.touch.start,v)}if("ContextMenu"===i.action&&t.isEvent&&t.calendar.internal.touch){var v=function(e,t,i){return function(n){n.cancelBubble=!0,n.preventDefault(),o(e,t,i,n),t.calendar.internal.touch.preventEventTap=!0}}(s,t,i),p=function(e,t,i){return function(e){e.cancelBubble=!0,e.preventDefault()}}(s,t,i);DayPilot.re(l,DayPilot.touch.start,v),DayPilot.re(l,DayPilot.touch.end,p)}if("Bubble"===i.action&&t.isEvent&&t.calendar.internal.touch){var v=function(e,t,i){return function(e){e.cancelBubble=!0,e.preventDefault(),a(t,i,e),t.calendar.internal.touch.preventEventTap=!0}}(s,t,i),p=function(e,t,i){return function(e){e.cancelBubble=!0,e.preventDefault()}}(s,t,i);DayPilot.re(l,DayPilot.touch.start,v),
DayPilot.re(l,DayPilot.touch.end,p)}if("Move"===i.action&&t.isEvent&&t.calendar.internal.touch){var v=function(e,t,i){return function(i){i.cancelBubble=!0;var n=t.calendar.internal.touch,a=i.touches?i.touches[0]:i,o={x:a.pageX,y:a.pageY};t.calendar.coords=n.relativeCoords(i),n.preventEventTap=!0,n.startMoving(e,o)}}(s,t,i);DayPilot.re(l,DayPilot.touch.start,v)}if("Move"===i.action&&t.isRow&&t.calendar.internal.touch,"Bubble"===i.action&&t.isEvent&&(l.onmousemove=function(e,t,i){return function(e){i.bubble?i.bubble.showEvent(t,!0):t.calendar.bubble&&t.calendar.bubble.showEvent(t,!0)}}(e,t,i),l.onmouseout=function(e,t,i){return function(e){"undefined"!=typeof DayPilot.Bubble&&(i.bubble?i.bubble.hideOnMouseOut():t.calendar.bubble&&t.calendar.bubble.hideOnMouseOut())}}(e,t,i)),"Bubble"===i.action&&t.isRow&&(l.onmousemove=function(e,t,i){return function(e){i.bubble?i.bubble.showResource(t,!0):t.calendar.resourceBubble&&t.calendar.resourceBubble.showResource(t,!0)}}(e,t,i),l.onmouseout=function(e,t,i){return function(e){"undefined"!=typeof DayPilot.Bubble&&(i.bubble?i.bubble.hideOnMouseOut():t.calendar.resourceBubble&&t.calendar.resourceBubble.hideOnMouseOut())}}(e,t,i)),"HoverMenu"===i.action&&(l.onmousemove=function(e,t,i){return function(e){var n=i.menu;"string"==typeof n&&(n=DayPilot.Util.evalVariable(n)),n&&n.show&&(n.visible?n.source&&"undefined"!=typeof n.source.id&&n.source.id!==t.id&&n.show(t):n.show(t),n.cancelHideTimeout())}}(e,t,i),l.onmouseout=function(e,t,i){return function(e){var t=i.menu;"string"==typeof t&&(t=DayPilot.Util.evalVariable(t)),t&&t.hideOnMouseOver&&t.delayedHide()}}(e,t,i)),"JavaScript"===i.action){var v=function(e,t,i){return function(e){if(!DayPilot.Util.isMouseEvent(e)){e.cancelBubble=!0,e.preventDefault();t.calendar.internal.touch.start=!0}}}(s,t,i),p=function(e,t,i){return function(e){if(!DayPilot.Util.isMouseEvent(e)){e.cancelBubble=!0,e.preventDefault();t.calendar.internal.touch.start=!1;var n=i.js;if("string"==typeof n&&(n=DayPilot.Util.evalFunction(i.js)),"function"==typeof n){var a=i.target||t;n.call(this,a)}}}}(s,t,i);DayPilot.re(l,DayPilot.touch.start,v),DayPilot.re(l,DayPilot.touch.end,p)}return l.onmousedown=function(e,t,i){return function(n){if("function"==typeof i.onmousedown&&i.onmousedown(n),"function"==typeof i.mousedown){var a={};a.area=i,a.div=e,a.originalEvent=n,a.source=t,i.mousedown(a)}if("Move"===i.action&&t.isRow){var o=t.$.row;t.calendar.internal.rowtools.startMoving(o)}"undefined"!=typeof DayPilot.Bubble&&DayPilot.Bubble.hideActive();"Move"!==i.action&&"ResizeEnd"!==i.action&&"ResizeStart"!==i.action&&i.action&&(n=n||window.event,n.preventDefault(),n.cancelBubble=!0)}}(e,t,i),l.onclick=function(e,t,i){return function(n){var n=n||window.event,a={};if(a.area=i,a.source=t,a.originalEvent=n,a.preventDefault=function(){a.preventDefault.value=!0},"function"!=typeof i.onClick||(i.onClick(a),!a.preventDefault.value)){switch(i.action){case"JavaScript":var r=i.js;if("string"==typeof r&&(r=DayPilot.Util.evalFunction(i.js)),"function"==typeof r){var s=i.target||t;r.call(this,s)}n.cancelBubble=!0;break;case"ContextMenu":o(e,t,i,n),n.cancelBubble=!0;break;case"CallBack":alert("callback not implemented yet, id: "+i.id),n.cancelBubble=!0}"function"==typeof i.onClicked&&i.onClicked(a)}}}(e,t,i),l},DayPilot.Areas.all=[],DayPilot.Areas.hideAreas=function(e,t){if(e&&e&&e.active){var i=e.active,n=e.areas;if(i&&i.children){var t=t||window.event;if(t){var a=t.toElement||t.relatedTarget;if(~DayPilot.indexOf(i.children,a))return}}if(!n||0===n.length)return void(e.active=null);DayPilot.de(n),e.active=null,e.areas=[],DayPilot.rfa(DayPilot.Areas.all,e),i.children=null}},DayPilot.Areas.hideAll=function(e){if(DayPilot.Areas.all&&0!==DayPilot.Areas.all.length)for(var t=0;t<DayPilot.Areas.all.length;t++)DayPilot.Areas.hideAreas(DayPilot.Areas.all[t],e)},DayPilot.Action=function(e,t,i,n){var a=this;this.calendar=e,this.isAction=!0,this.action=t,this.params=i,this.data=n,this.notify=function(){a.calendar.internal.invokeEvent("Immediate",this.action,this.params,this.data)},this.auto=function(){a.calendar.internal.invokeEvent("Notify",this.action,this.params,this.data)},this.queue=function(){a.calendar.queue.add(this)},this.toJSON=function(){var e={};return e.name=this.action,e.params=this.params,e.data=this.data,e}},DayPilot.Selection=function(e,t,i,n){this.menuType="selection",this.start=new DayPilot.Date(e),this.end=new DayPilot.Date(t),this.resource=i,this.root=n,this.calendar=n,this.toJSON=function(e){var t={};return t.start=this.start,t.end=this.end,t.resource=this.resource,t}},DayPilot.Link=function(e,t){this.isLink=!0,this.data=e,this.calendar=t,this.to=function(){return this.data.to},this.from=function(){return this.data.from},this.type=function(){return this.data.type},this.id=function(){return this.data.id},this.toJSON=function(){var e={};return e.from=this.data.from,e.to=this.data.to,e.id=this.data.id,e.type=this.data.type,e}},DayPilot.Event=function(e,t,i){var n=this;this.calendar=t,this.data=e?e:{},this.part=i?i:{},"undefined"==typeof this.data.id&&(this.data.id=this.data.value);var a={},o=["id","text","start","end","resource"];this.isEvent=!0,DayPilot.Stats.eventObjects+=1,this.temp=function(){if(a.dirty)return a;for(var e=0;e<o.length;e++)a[o[e]]=n.data[o[e]];return a.dirty=!0,a},this.copy=function(){var e={};return DayPilot.Util.copyProps(n.data,e),e},this.commit=function(){if(a.dirty){for(var e=0;e<o.length;e++)n.data[o[e]]=a[o[e]];a.dirty=!1}},this.dirty=function(){return a.dirty},this.id=function(e){return"undefined"==typeof e?n.data.id:void(this.temp().id=e)},this.value=function(e){return"undefined"==typeof e?n.id():void n.id(e)},this.text=function(e){return"undefined"==typeof e?n.data.text:(this.temp().text=e,void this.client.innerHTML(e))},this.start=function(e){return"undefined"==typeof e?new DayPilot.Date(n.data.start):void(this.temp().start=new DayPilot.Date(e))},this.end=function(e){return"undefined"==typeof e?t&&t.internal.adjustEndNormalize?t.internal.adjustEndNormalize(new DayPilot.Date(n.data.end)):new DayPilot.Date(n.data.end):void(this.temp().end=new DayPilot.Date(e))},this.duration=function(){return new DayPilot.Duration(this.start(),this.end())},this.rawend=function(){return"undefined"==typeof val?t&&t.internal.adjustEndIn?t.internal.adjustEndIn(new DayPilot.Date(n.data.end)):new DayPilot.Date(n.data.end):void(this.temp().end=new DayPilot.Date(val))},this.partStart=function(){return new DayPilot.Date(this.part.start)},this.partEnd=function(){return new DayPilot.Date(this.part.end)},this.row=function(){return this.resource()},this.allday=function(){return"undefined"==typeof val?n.data.allday:void(this.temp().allday=val)},this.isAllDay=this.allday,this.resource=function(e){return"undefined"==typeof e?n.data.resource:void(this.temp().resource=e)},this.recurrent=function(){return n.data.recurrent},this.recurrentMasterId=function(){return n.data.recurrentMasterId},this.useBox=function(){return this.part.box},this.staticBubbleHTML=function(){return this.bubbleHtml()},this.bubbleHtml=function(){return n.cache?n.cache.bubbleHtml||n.data.bubbleHtml:n.data.bubbleHtml},this.tag=function(e){if(n.data.tags)return n.data.tags[e];var t=n.data.tag;if(!t)return null;if("undefined"==typeof e)return n.data.tag;for(var i=n.calendar.tagFields,a=-1,o=0;o<i.length;o++)e===i[o]&&(a=o);if(a===-1)throw"Field name not found.";return t[a]},this.client={},this.client.innerHTML=function(e){return"undefined"==typeof e?n.cache&&"undefined"!=typeof n.cache.html?n.cache.html:"undefined"!=typeof n.data.html?n.data.html:n.data.text:(n.data.html=e,void(n.cache&&(n.cache.html=e)))},this.client.html=this.client.innerHTML,this.client.header=function(e){return"undefined"==typeof e?n.data.header:void(n.data.header=e)},this.client.cssClass=function(e){return"undefined"==typeof e?n.data.cssClass:void(n.data.cssClass=e)},this.client.toolTip=function(e){return"undefined"==typeof e?n.cache&&"undefined"!=typeof n.cache.toolTip?n.cache.toolTip:"undefined"!=typeof n.data.toolTip?n.data.toolTip:n.data.text:void(n.data.toolTip=e)},this.client.backColor=function(e){return"undefined"==typeof e?n.cache&&"undefined"!=typeof n.cache.backColor?n.cache.backColor:"undefined"!=typeof n.data.backColor?n.data.backColor:n.calendar.eventBackColor:void(n.data.backColor=e)},this.client.borderColor=function(e){return"undefined"==typeof e?n.cache&&"undefined"!=typeof n.cache.borderColor?n.cache.borderColor:"undefined"!=typeof n.data.borderColor?n.data.borderColor:n.calendar.eventBorderColor:void(n.data.borderColor=e)},this.client.barColor=function(e){return"undefined"==typeof e?n.cache&&"undefined"!=typeof n.cache.barColor?n.cache.barColor:"undefined"!=typeof n.data.barColor?n.data.barColor:n.calendar.durationBarColor:void(n.data.barColor=e)},this.client.barVisible=function(e){return"undefined"==typeof e?n.cache&&"undefined"!=typeof n.cache.barHidden?!n.cache.barHidden:n.calendar.durationBarVisible&&!n.data.barHidden:void(n.data.barHidden=!e)},this.client.contextMenu=function(e){if("undefined"==typeof e){if(n.oContextMenu)return n.oContextMenu;var t=n.cache?n.cache.contextMenu:n.data.contextMenu;return t?DayPilot.Util.evalVariable(t):null}n.oContextMenu=e},this.client.moveEnabled=function(e){return"undefined"==typeof e?n.cache&&"undefined"!=typeof n.cache.moveDisabled?!n.cache.moveDisabled:"Disabled"!==n.calendar.eventMoveHandling&&!n.data.moveDisabled:void(n.data.moveDisabled=!e)},this.client.resizeEnabled=function(e){return"undefined"==typeof e?n.cache&&"undefined"!=typeof n.cache.resizeDisabled?!n.cache.resizeDisabled:"Disabled"!==n.calendar.eventResizeHandling&&!n.data.resizeDisabled:void(n.data.resizeDisabled=!e)},this.client.rightClickEnabled=function(e){return"undefined"==typeof e?n.cache&&"undefined"!=typeof n.cache.rightClickDisabled?!n.cache.rightClickDisabled:"Disabled"!==n.calendar.rightClickHandling&&!n.data.rightClickDisabled:void(n.data.rightClickDisabled=!e)},this.client.clickEnabled=function(e){return"undefined"==typeof e?n.cache&&"undefined"!=typeof n.cache.clickDisabled?!n.cache.clickDisabled:"Disabled"!==n.calendar.clickHandling&&!n.data.clickDisabled:void(n.data.clickDisabled=!e)},this.client.deleteEnabled=function(e){return"undefined"==typeof e?n.cache&&"undefined"!=typeof n.cache.deleteDisabled?!n.cache.deleteDisabled:"Disabled"!==n.calendar.eventDeleteHandling&&!n.data.deleteDisabled:void(n.data.deleteDisabled=!e)},this.client.doubleClickEnabled=function(e){return"undefined"==typeof e?n.cache&&"undefined"!=typeof n.cache.doubleClickDisabled?!n.cache.doubleClickDisabled:"Disabled"!==n.calendar.eventDoubleClickHandling&&!n.data.doubleClickDisabled:void(n.data.doubleClickDisabled=!e)},this.client.deleteClickEnabled=function(e){return"undefined"==typeof e?n.cache&&"undefined"!=typeof n.cache.deleteDisabled?!n.cache.deleteDisabled:"Disabled"!==n.calendar.eventDeleteHandling&&!n.data.deleteDisabled:void(n.data.deleteDisabled=!e)},this.toJSON=function(e){var t={};if(t.value=this.id(),t.id=this.id(),t.text=this.text(),t.start=this.start().toJSON(),t.end=this.end().toJSON(),t.resource=this.resource(),t.isAllDay=!1,t.recurrentMasterId=this.recurrentMasterId(),t.join=this.data.join,t.tag={},n.data.tags)for(var i in n.data.tags)n.data.tags.hasOwnProperty(i)&&(t.tag[i]=""+n.data.tags[i]);else if(n.calendar&&n.calendar.tagFields)for(var a=n.calendar.tagFields,o=0;o<a.length;o++)t.tag[a[o]]=this.tag(a[o]);return t}},DayPilot.Task=function(e,t){if(!e)throw"Trying to initialize DayPilot.Task with null data parameter";var i=this,n=null;if(e instanceof DayPilot.Event)n=e,this.data=e.data.task;else{if(e instanceof DayPilot.Task)return e;e.isTaskWrapper?this.data=e.data:this.data=e}var a={},o=["id","text","start","end","complete","type"];this.isTask=!0,this.calendar=t,this.temp=function(){if(a.dirty)return a;for(var e=0;e<o.length;e++)a[o[e]]=i.data[o[e]];return a.dirty=!0,a},this.copy=function(){var e={};return DayPilot.Util.copyProps(i.data,e),e},this.commit=function(){if(a.dirty){for(var e=0;e<o.length;e++)i.data[o[e]]=a[o[e]];a.dirty=!1}},this.dirty=function(){return a.dirty},this.id=function(e){return"undefined"==typeof e?i.data.id:void(this.temp().id=e)},this.text=function(e){return"undefined"==typeof e?i.data.text:(this.temp().text=e,void this.client.innerHTML(e))},this.start=function(e){return"undefined"==typeof e?new DayPilot.Date(i.data.start):void(this.temp().start=new DayPilot.Date(e))},this.duration=function(){return new DayPilot.Duration(this.start(),this.end())},this.end=function(e){return"undefined"==typeof e?t&&"Date"===t.eventEndSpec?new DayPilot.Date(i.data.end).getDatePart().addDays(1):new DayPilot.Date(i.data.end):void(this.temp().end=new DayPilot.Date(e))},this.type=function(e){return"undefined"==typeof e?n?n.data.type:i.data.type:void(this.temp().type=e)},this.complete=function(e){return"undefined"==typeof e?i.data.complete?i.data.complete:0:void(this.temp().complete=e)},this.children=function(){var e=[];e.add=function(e){var t=new DayPilot.Task(e);this.data.children||(this.data.children=[]),this.children.push(t.data)};for(var i=0;this.data.children&&i<this.data.children.length;i++)e.push(new DayPilot.Task(this.data.children[i],t));return e},this.toJSON=function(e){var t={};return t.id=this.id(),t.text=this.text(),t.start=this.start().toJSON(),t.end=this.end().toJSON(),t.type=this.type(),t.tags={},DayPilot.Util.copyProps(this.data.tags,t.tags),t},this.row={};var r=this.row;r.expanded=function(e){return"undefined"==typeof e?!i.data.row||!i.data.row.collapsed:(i.data.row||(i.data.row={}),!!i.data.row.collapsed!=!e&&t.internal.rowObjectForTaskData(i.data).toggle(),i.data.row.collapsed=!e,void 0)},r.expand=function(){r.expanded(!0)},r.collapse=function(){r.expanded(!1)},r.toggle=function(){r.expanded(!r.expanded())}},DayPilot.request=function(e,t,i,n){var a=DayPilot.createXmlHttp();a&&(a.open("POST",e,!0),a.setRequestHeader("Content-type","text/plain"),a.onreadystatechange=function(){if(4===a.readyState)return 200!==a.status&&304!==a.status?void(n?n(a):window.console&&console.log("HTTP error "+a.status)):void t(a)},4!==a.readyState&&("object"==typeof i&&(i=DayPilot.JSON.stringify(i)),a.send(i)))},DayPilot.ajax=function(e){var t=DayPilot.createXmlHttp();if(t){var i=e.method||"GET",n=e.success||function(){},a=e.error||function(){},o=e.data,r=e.url,s=e.contentType||"text/plain";t.open(i,r,!0),t.setRequestHeader("Content-type",s),t.onreadystatechange=function(){if(4===t.readyState)if(200===t.status||304===t.status){var e={};e.request=t,n(e)}else if(a){var e={};e.request=t,a(e)}else window.console&&console.log("HTTP error "+t.status)},4!==t.readyState&&("object"==typeof o&&(o=DayPilot.JSON.stringify(o)),t.send(o))}},DayPilot.createXmlHttp=function(){return new XMLHttpRequest},DayPilot.Duration=function(e){var t=this,i=864e5,n=36e5,a=6e4,o=1e3;if(2===arguments.length){var r=arguments[0],s=arguments[1];if(!(r instanceof DayPilot.Date))throw"DayPilot.Duration(): Invalid start argument, DayPilot.Date expected";if(!(s instanceof DayPilot.Date))throw"DayPilot.Duration(): Invalid end argument, DayPilot.Date expected";e=s.getTime()-r.getTime()}return this.ticks=e,DayPilot.Date.Cache.DurationCtor[""+e]?DayPilot.Date.Cache.DurationCtor[""+e]:(DayPilot.Date.Cache.DurationCtor[""+e]=this,this.toString=function(e){if(!e)return t.days()+"."+t.hours()+":"+t.minutes()+":"+t.seconds()+"."+t.milliseconds();var i=t.minutes();i=(i<10?"0":"")+i;var n=e;return n=n.replace("mm",i),n=n.replace("m",t.minutes()),n=n.replace("H",t.hours()),n=n.replace("h",t.hours()),n=n.replace("d",t.days()),n=n.replace("s",t.seconds())},this.totalHours=function(){return t.ticks/n},this.totalDays=function(){return t.ticks/i},this.totalMinutes=function(){return t.ticks/a},this.totalSeconds=function(){return t.ticks/o},this.days=function(){return Math.floor(t.totalDays())},this.hours=function(){var e=t.ticks-t.days()*i;return Math.floor(e/n)},this.minutes=function(){var e=t.ticks-Math.floor(t.totalHours())*n;return Math.floor(e/a)},this.seconds=function(){var e=t.ticks-Math.floor(t.totalMinutes())*a;return Math.floor(e/o)},void(this.milliseconds=function(){return t.ticks%o}))},DayPilot.Duration.weeks=function(e){return new DayPilot.Duration(1e3*e*60*60*24*7)},DayPilot.Duration.days=function(e){return new DayPilot.Duration(1e3*e*60*60*24)},DayPilot.Duration.hours=function(e){return new DayPilot.Duration(1e3*e*60*60)},DayPilot.Duration.minutes=function(e){return new DayPilot.Duration(1e3*e*60)},DayPilot.Duration.seconds=function(e){return new DayPilot.Duration(1e3*e)},DayPilot.TimeSpan=function(){DayPilot.Duration.apply(this,arguments)};try{DayPilot.TimeSpan.prototype=Object.create(DayPilot.Duration.prototype)}catch(e){}DayPilot.Date=function(t,i){if(t instanceof DayPilot.Date)return t;var n;DayPilot.Util.isNullOrUndefined(t)&&(n=DayPilot.DateUtil.fromLocal().getTime(),t=n);var a=DayPilot.Date.Cache.Ctor;if(a[t])return DayPilot.Stats.cacheHitsCtor+=1,a[t];var o=!1;if("string"==typeof t)n=DayPilot.DateUtil.fromStringSortable(t,i).getTime(),o=!0;else if("number"==typeof t){if(isNaN(t))throw"Cannot create DayPilot.Date from NaN";n=t}else{if(!(t instanceof Date))throw"Unrecognized parameter: use Date, number or string in ISO 8601 format";n=i?DayPilot.DateUtil.fromLocal(t).getTime():t.getTime()}var r=e(n);return a[r]?a[r]:(a[r]=this,a[n]=this,o&&r!==t&&DayPilot.DateUtil.hasTzSpec(t)&&(a[t]=this),Object.defineProperty&&!DayPilot.browser.ielt9?(Object.defineProperty(this,"ticks",{get:function(){return n}}),Object.defineProperty(this,"value",{"value":r,"writable":!1,"enumerable":!0})):(this.ticks=n,this.value=r),DayPilot.Date.Config.legacyShowD&&(this.d=new Date(n)),void(DayPilot.Stats.dateObjects+=1))},DayPilot.Date.Config={},DayPilot.Date.Config.legacyShowD=!1,DayPilot.Date.Cache={},DayPilot.Date.Cache.Parsing={},DayPilot.Date.Cache.Ctor={},DayPilot.Date.Cache.Ticks={},DayPilot.Date.Cache.DurationCtor={},DayPilot.Date.Cache.clear=function(){DayPilot.Date.Cache.Parsing={},DayPilot.Date.Cache.Ctor={},DayPilot.Date.Cache.Ticks={},DayPilot.Date.Cache.DurationCtor={}},DayPilot.Date.prototype.addDays=function(e){return new DayPilot.Date(this.ticks+24*e*60*60*1e3)},DayPilot.Date.prototype.addHours=function(e){return this.addTime(60*e*60*1e3)},DayPilot.Date.prototype.addMilliseconds=function(e){return this.addTime(e)},DayPilot.Date.prototype.addMinutes=function(e){return this.addTime(60*e*1e3)},DayPilot.Date.prototype.addMonths=function(e){var t=new Date(this.ticks);if(0===e)return this;var i=t.getUTCFullYear(),n=t.getUTCMonth()+1;if(e>0){for(;e>=12;)e-=12,i++;e>12-n?(i++,n=e-(12-n)):n+=e}else{for(;e<=-12;)e+=12,i--;n+e<=0?(i--,n=12+n+e):n+=e}var a=new Date(t.getTime());a.setUTCDate(1),a.setUTCFullYear(i),a.setUTCMonth(n-1);var o=new DayPilot.Date(a).daysInMonth();return a.setUTCDate(Math.min(o,t.getUTCDate())),new DayPilot.Date(a)},DayPilot.Date.prototype.addSeconds=function(e){return this.addTime(1e3*e)},DayPilot.Date.prototype.addTime=function(e){return e instanceof DayPilot.Duration&&(e=e.ticks),new DayPilot.Date(this.ticks+e)},DayPilot.Date.prototype.addYears=function(e){var t=new Date(this.ticks),i=new Date(this.ticks),n=this.getYear()+e,a=this.getMonth();i.setUTCDate(1),i.setUTCFullYear(n),i.setUTCMonth(a);var o=new DayPilot.Date(i).daysInMonth();return i.setUTCDate(Math.min(o,t.getUTCDate())),new DayPilot.Date(i)},DayPilot.Date.prototype.dayOfWeek=function(){return new Date(this.ticks).getUTCDay()},DayPilot.Date.prototype.getDayOfWeek=function(){return new Date(this.ticks).getUTCDay()},DayPilot.Date.prototype.daysInMonth=function(){var e=new Date(this.ticks),t=e.getUTCMonth()+1,i=e.getUTCFullYear(),n=[31,28,31,30,31,30,31,31,30,31,30,31];return 2!==t?n[t-1]:i%4!==0?n[1]:i%100===0&&i%400!==0?n[1]:n[1]+1},DayPilot.Date.prototype.daysInYear=function(){var e=this.getYear();return e%4!==0?365:e%100===0&&e%400!==0?365:366},DayPilot.Date.prototype.dayOfYear=function(){return Math.ceil((this.getDatePart().getTime()-this.firstDayOfYear().getTime())/864e5)+1},DayPilot.Date.prototype.equals=function(e){if(null===e)return!1;if(e instanceof DayPilot.Date)return this===e;throw"The parameter must be a DayPilot.Date object (DayPilot.Date.equals())"},DayPilot.Date.prototype.firstDayOfMonth=function(){var e=new Date;return e.setUTCFullYear(this.getYear(),this.getMonth(),1),e.setUTCHours(0),e.setUTCMinutes(0),e.setUTCSeconds(0),e.setUTCMilliseconds(0),new DayPilot.Date(e)},DayPilot.Date.prototype.firstDayOfYear=function(){var e=this.getYear(),t=new Date;return t.setUTCFullYear(e,0,1),t.setUTCHours(0),t.setUTCMinutes(0),t.setUTCSeconds(0),t.setUTCMilliseconds(0),new DayPilot.Date(t)},DayPilot.Date.prototype.firstDayOfWeek=function(e){for(var t=this,e=e||0,i=t.dayOfWeek();i!==e;)t=t.addDays(-1),i=t.dayOfWeek();return new DayPilot.Date(t)},DayPilot.Date.prototype.getDay=function(){return new Date(this.ticks).getUTCDate()},DayPilot.Date.prototype.getDatePart=function(){var e=new Date(this.ticks);return e.setUTCHours(0),e.setUTCMinutes(0),e.setUTCSeconds(0),e.setUTCMilliseconds(0),new DayPilot.Date(e)},DayPilot.Date.prototype.getYear=function(){return new Date(this.ticks).getUTCFullYear()},DayPilot.Date.prototype.getHours=function(){return new Date(this.ticks).getUTCHours()},DayPilot.Date.prototype.getMilliseconds=function(){return new Date(this.ticks).getUTCMilliseconds()},DayPilot.Date.prototype.getMinutes=function(){return new Date(this.ticks).getUTCMinutes()},DayPilot.Date.prototype.getMonth=function(){return new Date(this.ticks).getUTCMonth()},DayPilot.Date.prototype.getSeconds=function(){return new Date(this.ticks).getUTCSeconds()},DayPilot.Date.prototype.getTotalTicks=function(){return this.getTime()},DayPilot.Date.prototype.getTime=function(){return this.ticks},DayPilot.Date.prototype.getTimePart=function(){var e=this.getDatePart();return DayPilot.DateUtil.diff(this,e)},DayPilot.Date.prototype.lastDayOfMonth=function(){var e=new Date(this.firstDayOfMonth().getTime()),t=this.daysInMonth();return e.setUTCDate(t),new DayPilot.Date(e)},DayPilot.Date.prototype.weekNumber=function(){var e=this.firstDayOfYear(),t=(this.getTime()-e.getTime())/864e5;return Math.ceil((t+e.dayOfWeek()+1)/7)},DayPilot.Date.prototype.weekNumberISO=function(){var e=!1,t=this.dayOfYear(),i=this.firstDayOfYear().dayOfWeek(),n=this.firstDayOfYear().addYears(1).addDays(-1).dayOfWeek();0===i&&(i=7),0===n&&(n=7);var a=8-i;4!==i&&4!==n||(e=!0);var o=Math.ceil((t-a)/7),r=o;return a>=4&&(r+=1),r>52&&!e&&(r=1),0===r&&(r=this.firstDayOfYear().addDays(-1).weekNumberISO()),r},DayPilot.Date.prototype.toDateLocal=function(){var e=new Date(this.ticks),t=new Date;return t.setFullYear(e.getUTCFullYear(),e.getUTCMonth(),e.getUTCDate()),t.setHours(e.getUTCHours()),t.setMinutes(e.getUTCMinutes()),t.setSeconds(e.getUTCSeconds()),t.setMilliseconds(e.getUTCMilliseconds()),t},DayPilot.Date.prototype.toDate=function(){return new Date(this.ticks)},DayPilot.Date.prototype.toJSON=function(){return this.value},DayPilot.Date.prototype.toString=function(e,t){return"undefined"==typeof e?this.toStringSortable():new a(e,t).print(this)},DayPilot.Date.prototype.toStringSortable=function(){return e(this.ticks)},DayPilot.Date.parse=function(e,t,i){return new a(t,i).parse(e)};var n=0;DayPilot.Date.today=function(){return new DayPilot.Date(DayPilot.DateUtil.localToday())},DayPilot.Date.fromYearMonthDay=function(e,t,i){t=t||1,i=i||1;var n=new Date(0);return n.setUTCFullYear(e),n.setUTCMonth(t-1),n.setUTCDate(i),new DayPilot.Date(n)},DayPilot.DateUtil={},DayPilot.DateUtil.fromStringSortable=function(e,t){if(!e)throw"Can't create DayPilot.Date from an empty string";var i=e.length,n=10===i,a=19===i,o=i>19;if(!n&&!a&&!o)throw"Invalid string format (use '2010-01-01' or '2010-01-01T00:00:00'): "+e;if(DayPilot.Date.Cache.Parsing[e]&&!t)return DayPilot.Stats.cacheHitsParsing+=1,DayPilot.Date.Cache.Parsing[e];var r=e.substring(0,4),s=e.substring(5,7),l=e.substring(8,10),d=new Date(0);if(d.setUTCFullYear(r,s-1,l),n)return DayPilot.Date.Cache.Parsing[e]=d,d;var c=e.substring(11,13),h=e.substring(14,16),u=e.substring(17,19);if(d.setUTCHours(c),d.setUTCMinutes(h),d.setUTCSeconds(u),a)return DayPilot.Date.Cache.Parsing[e]=d,d;var f=e[19],v=0;if("."===f){var p=parseInt(e.substring(20,23));d.setUTCMilliseconds(p),v=DayPilot.DateUtil.getTzOffsetMinutes(e.substring(23))}else v=DayPilot.DateUtil.getTzOffsetMinutes(e.substring(19));var g=new DayPilot.Date(d);return t||(g=g.addMinutes(-v)),d=g.toDate(),DayPilot.Date.Cache.Parsing[e]=d,d},DayPilot.DateUtil.getTzOffsetMinutes=function(e){if(DayPilot.Util.isNullOrUndefined(e)||""===e)return 0;if("Z"===e)return 0;var t=e[0],i=parseInt(e.substring(1,3)),n=parseInt(e.substring(4)),a=60*i+n;if("-"===t)return-a;if("+"===t)return a;throw"Invalid timezone spec: "+e},DayPilot.DateUtil.hasTzSpec=function(e){return!!e.indexOf("+")||!!e.indexOf("-")},DayPilot.DateUtil.daysDiff=function(e,t){if(e&&t||function(){throw"two parameters required"}(),e=new DayPilot.Date(e),t=new DayPilot.Date(t),e.getTime()>t.getTime())return null;for(var i=0,n=e.getDatePart(),a=t.getDatePart();n<a;)n=n.addDays(1),i++;return i},DayPilot.DateUtil.daysSpan=function(e,t){if(e&&t||function(){throw"two parameters required"}(),e=new DayPilot.Date(e),t=new DayPilot.Date(t),e===t)return 0;var i=DayPilot.DateUtil.daysDiff(e,t);return t==t.getDatePart()&&i--,i},DayPilot.DateUtil.diff=function(e,t){if(!(e&&t&&e.getTime&&t.getTime))throw"Both compared objects must be Date objects (DayPilot.Date.diff).";return e.getTime()-t.getTime()},DayPilot.DateUtil.fromLocal=function(e){e||(e=new Date);var t=new Date;return t.setUTCFullYear(e.getFullYear(),e.getMonth(),e.getDate()),t.setUTCHours(e.getHours()),t.setUTCMinutes(e.getMinutes()),t.setUTCSeconds(e.getSeconds()),t.setUTCMilliseconds(e.getMilliseconds()),t},DayPilot.DateUtil.localToday=function(){var e=new Date;return e.setUTCHours(0),e.setUTCMinutes(0),e.setUTCSeconds(0),e.setUTCMilliseconds(0),e},DayPilot.DateUtil.hours=function(e,t){var i=e.getUTCMinutes();i<10&&(i="0"+i);var n=e.getUTCHours();if(t){var a=n<12,n=n%12;0===n&&(n=12);return n+":"+i+" "+(a?"AM":"PM")}return n+":"+i},DayPilot.DateUtil.max=function(e,t){return e.getTime()>t.getTime()?e:t},DayPilot.DateUtil.min=function(e,t){return e.getTime()<t.getTime()?e:t};var a=function(e,i){"string"==typeof i&&(i=DayPilot.Locale.find(i));var i=i||DayPilot.Locale.US,n=[{"seq":"yyyy","expr":"[0-9]{4,4}","str":function(e){return e.getYear()}},{"seq":"yy","expr":"[0-9]{2,2}","str":function(e){return e.getYear()%100}},{"seq":"mm","expr":"[0-9]{2,2}","str":function(e){var t=e.getMinutes();return t<10?"0"+t:t}},{"seq":"m","expr":"[0-9]{1,2}","str":function(e){return e.getMinutes()}},{"seq":"HH","expr":"[0-9]{2,2}","str":function(e){var t=e.getHours();return t<10?"0"+t:t}},{"seq":"H","expr":"[0-9]{1,2}","str":function(e){return e.getHours()}},{"seq":"hh","expr":"[0-9]{2,2}","str":function(e){var t=e.getHours(),t=t%12;0===t&&(t=12);var i=t;return i<10?"0"+i:i}},{"seq":"h","expr":"[0-9]{1,2}","str":function(e){var t=e.getHours(),t=t%12;return 0===t&&(t=12),t}},{"seq":"ss","expr":"[0-9]{2,2}","str":function(e){var t=e.getSeconds();return t<10?"0"+t:t}},{"seq":"s","expr":"[0-9]{1,2}","str":function(e){return e.getSeconds()}},{"seq":"MMMM","expr":"[^\\s0-9]*","str":function(e){return i.monthNames[e.getMonth()]},"transform":function(e){var n=DayPilot.indexOf(i.monthNames,e,t);return n<0?null:n+1}},{"seq":"MMM","expr":"[^\\s0-9]*","str":function(e){return i.monthNamesShort[e.getMonth()]},"transform":function(e){var n=DayPilot.indexOf(i.monthNamesShort,e,t);return n<0?null:n+1}},{"seq":"MM","expr":"[0-9]{2,2}","str":function(e){var t=e.getMonth()+1;return t<10?"0"+t:t}},{"seq":"M","expr":"[0-9]{1,2}","str":function(e){return e.getMonth()+1}},{"seq":"dddd","expr":"[^\\s0-9]*","str":function(e){return i.dayNames[e.getDayOfWeek()]}},{"seq":"ddd","expr":"[^\\s0-9]*","str":function(e){return i.dayNamesShort[e.getDayOfWeek()]}},{"seq":"dd","expr":"[0-9]{2,2}","str":function(e){var t=e.getDay();return t<10?"0"+t:t}},{"seq":"%d","expr":"[0-9]{1,2}","str":function(e){return e.getDay()}},{"seq":"d","expr":"[0-9]{1,2}","str":function(e){return e.getDay()}},{"seq":"tt","expr":"(AM|PM|am|pm)","str":function(e){return e.getHours()<12?"AM":"PM"},"transform":function(e){return e.toUpperCase()}}],a=function(e){return e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g,"\\$&")};this.init=function(){if(this.year=this.findSequence("yyyy"),this.month=this.findSequence("MMMM")||this.findSequence("MMM")||this.findSequence("MM")||this.findSequence("M"),this.day=this.findSequence("dd")||this.findSequence("d"),this.hours=this.findSequence("HH")||this.findSequence("H"),this.minutes=this.findSequence("mm")||this.findSequence("m"),this.seconds=this.findSequence("ss")||this.findSequence("s"),this.ampm=this.findSequence("tt"),this.hours12=this.findSequence("hh")||this.findSequence("h"),this.hours&&this.ampm)throw new DayPilot.Exception("'HH' and 'H' specifiers cannot be used in combination with 'tt'. Use 12-hour clock specifiers: 'hh' or 'h'.")},this.findSequence=function(t){function i(e){return parseInt(e)}return e.indexOf(t)===-1?null:{"findValue":function(o){for(var r=a(e),s=null,l=0;l<n.length;l++){var d=(n[l].length,t===n[l].seq),c=n[l].expr;d&&(c="("+c+")",s=n[l].transform),r=r.replace(n[l].seq,c)}r="^"+r+"$";try{var h=new RegExp(r),u=h.exec(o);return u?(s=s||i)(u[1]):null}catch(e){throw"unable to create regex from: "+r}}}},this.print=function(t){for(var i=function(e){for(var t=0;t<n.length;t++)if(n[t]&&n[t].seq===e)return n[t];return null},a=e.length<=0,o=0,r=[];!a;){var s=e.substring(o),l=/%?(.)\1*/.exec(s);if(l&&l.length>0){var d=l[0],c=i(d);c?r.push(c):r.push(d),o+=d.length,a=e.length<=o}else a=!0}for(var h=0;h<r.length;h++){var u=r[h];"string"!=typeof u&&(r[h]=u.str(t))}return r.join("")},this.parse=function(e){var t=this.year.findValue(e);if(!t)return null;var i=this.month.findValue(e);if(DayPilot.Util.isNullOrUndefined(i))return null;if(i>12||i<1)return null;var n=this.day.findValue(e),a=DayPilot.Date.fromYearMonthDay(t,i).daysInMonth();if(n<1||n>a)return null;var o=this.hours?this.hours.findValue(e):0,r=this.minutes?this.minutes.findValue(e):0,s=this.seconds?this.seconds.findValue(e):0,l=this.ampm?this.ampm.findValue(e):null;if(this.ampm&&this.hours12){var d=this.hours12.findValue(e);if(d<1||d>12)return null;o="PM"===l?12===d?12:d+12:12===d?0:d}if(o<0||o>23)return null;if(r<0||r>59)return null;if(s<0||s>59)return null;var c=new Date;return c.setUTCFullYear(t,i-1,n),c.setUTCHours(o),c.setUTCMinutes(r),c.setUTCSeconds(s),c.setUTCMilliseconds(0),new DayPilot.Date(c)},this.init()};DayPilot.Canvas=function(e,t,i,n,a){function o(e,t,i){for(var n=t.split(" "),a=[],o=n[0],r=1;r<n.length;r++){var s=n[r];e.measureText(o+" "+s).width<i?o+=" "+s:(a.push(o),o=s)}return a.push(o),a}var n=n||1,r=document.createElement("canvas");r.width=e*n,r.height=t*n;var s=r.getContext("2d");s.scale(n,n),this.defaultFileName="image.png","image/jpeg"===i&&(this.defaultFileName="image.jpg",a=a||.92),this.fillRect=function(e,t){s.save(),s.strokeStyle="rgb(0,0,0,0)",s.fillStyle=t,s.fillRect(e.x+.5,e.y+.5,e.w-.5,e.h-.5),s.restore()},this.rect=function(e,t){s.save(),s.strokeStyle=t,s.beginPath(),s.rect(e.x+.5,e.y+.5,e.w-1,e.h-1),s.stroke(),s.restore()},this.text=function(e,t,i,n,a,r){if("number"==typeof t&&(t=""+t),"string"!=typeof t)throw"String expected";a=a||"left",r=r||0,n=n||"#000",s.save();var l=parseInt(i.size),d=DayPilot.browser.ff?3:0;d+=.2*l,d+=DayPilot.browser.chrome?1:0,d+=DayPilot.browser.ie?1:0,s.rect(e.x+.5+r,e.y+.5+r,e.w-1-r,e.h-1-r),s.clip(),s.fillStyle=n,s.font=i.style+" "+i.size+" "+i.family,s.textBaseline="top",s.textAlign=a;var c=e.x;switch(a){case"center":c+=e.w/2;break;case"right":c+=e.w}var h=0;c+=h;var u=1.2*parseInt(i.size),f=t.split("\n"),v=[];DayPilot.list(f).each(function(t){var i=o(s,t,e.w);DayPilot.list(i).each(function(e){v.push(e)})});for(var p=e.y+h+r+d,g=0;g<v.length;g++){var m=v[g];s.fillText(m,c+r,p),p+=u}s.restore()},this.line=function(e,t,i,n,a){s.save(),s.lineWidth=1,s.strokeStyle=a,s.beginPath(),
s.moveTo(e+.5,t+.5),s.lineTo(i+.5,n+.5),s.stroke(),s.restore()},this.image=function(e,t){if(t){if("string"==typeof t){var i=t,t=document.createElement("img");if(0!==i.indexOf("data:"))return t.onload=function(){s.save(),s.drawImage(t,e.x,e.y),s.restore()},void(t.src=i);t.src=i}s.save(),s.drawImage(t,e.x,e.y),s.restore()}},this.getWidth=function(){return r.width},this.getHeight=function(){return r.height},this.getElement=function(){return r},this.getSource=function(){return"<img src='"+r.toDataURL(i,a)+"' />"},this.getDataUri=function(){return r.toDataURL(i,a)},this.getDefaultFileName=function(){return this.defaultFileName},this.getBlob=function(){return r.msToBlob?r.msToBlob():DayPilot.Util.dataUriToBlob(this.getDataUri())}},DayPilot.Svg=function(e,t){function i(e,t){var i=null;if(e){if("string"==typeof e){if(0===e.indexOf("data:")){var n={};n.dataUri=e,t(n)}i=e}else i=e.src;var e=document.createElement("img");e.onload=function(){var e=document.createElement("canvas");e.width=this.naturalWidth,e.height=this.naturalHeight,e.getContext("2d").drawImage(this,0,0);var i={};i.dataUri=e.toDataURL("image/png"),t(i)},e.src=i}}var n="http://www.w3.org/2000/svg",a=document.createElementNS(n,"svg");a.outerHTML&&a.setAttribute("xmlns",n),a.setAttribute("viewBox","0 0 "+e+" "+t),this.defaultFileName="image.svg",this.fillRect=function(e,t){var i=document.createElementNS(n,"rect");i.setAttribute("x",e.x+.5),i.setAttribute("y",e.y+.5),i.setAttribute("width",e.w-1),i.setAttribute("height",e.h-1),i.setAttribute("fill",t),a.appendChild(i)},this.rect=function(e,t){var i=document.createElementNS(n,"rect");i.setAttribute("x",e.x+.5),i.setAttribute("y",e.y+.5),i.setAttribute("width",e.w-1),i.setAttribute("height",e.h-1),i.setAttribute("stroke",t),i.setAttribute("stroke-width","1"),i.setAttribute("fill","transparent"),a.appendChild(i)},this.text=function(e,t,i,o,r,s){function l(e,t,r){var s=document.createElementNS(n,"text");s.setAttribute("fill",o),s.setAttribute("font-family",i.family),s.setAttribute("font-size",i.size),s.setAttribute("font-style",i.style),s.setAttribute("x",t),s.setAttribute("y",r),s.setAttribute("dy","1em"),s.setAttribute("text-anchor",h),s.setAttribute("clip-path","url(#"+u.id+")");var l=document.createTextNode(e);s.appendChild(l),a.appendChild(s)}if("number"==typeof t&&(t=""+t),"string"!=typeof t)throw"String expected";var r=r||"left",s=s||0,d=3,c=e.x,h="start";switch(r){case"center":c+=e.w/2,h="middle";break;case"right":c+=e.w,h="end"}var u=document.createElementNS(n,"clipPath");u.id="clip"+DayPilot.guid();var f=document.createElementNS(n,"rect");f.setAttribute("x",e.x),f.setAttribute("y",e.y),f.setAttribute("width",e.w),f.setAttribute("height",e.h),u.appendChild(f),a.appendChild(u);for(var v=1.2*parseInt(i.size),p=t.split("\n"),g=e.y+s+d,m=0;m<p.length;m++){l(p[m],c+s,g),g+=v}},this.line=function(e,t,i,o,r){var s=document.createElementNS(n,"line");s.setAttribute("x1",e+.5),s.setAttribute("y1",t+.5),s.setAttribute("x2",i+.5),s.setAttribute("y2",o+.5),s.setAttribute("stroke",r),a.appendChild(s)},this.image=function(e,t){function o(t){var i=document.createElementNS(n,"image");i.setAttributeNS("http://www.w3.org/1999/xlink","href",t.dataUri),i.setAttribute("x",e.x),i.setAttribute("y",e.y),i.setAttribute("width",e.w),i.setAttribute("height",e.h),a.appendChild(i)}i(t,o)},this.getWidth=function(){return e},this.getHeight=function(){return t},this.getElement=function(){return a},this.getSource=function(){if(a.outerHTML)return a.outerHTML;var e=document.createElement("div"),t=a.cloneNode(!0);return e.appendChild(t),e.innerHTML},this.getDataUri=function(){return"data:application/octet-stream,"+encodeURIComponent(this.getSource())},this.getDefaultFileName=function(){return this.defaultFileName},this.getBlob=function(){return new Blob([this.getSource()])}},DayPilot.Excel=function(){var e=this,t=null,i=null,n=null,a={};a.xmlns="urn:schemas-microsoft-com:office:spreadsheet",a.o="urn:schemas-microsoft-com:office:office",a.x="urn:schemas-microsoft-com:office:excel",a.ss="urn:schemas-microsoft-com:office:spreadsheet",a.html="http://www.w3.org/TR/REC-html40",this.init=function(){t=document.implementation.createDocument(a.xmlns,"Workbook",null),t.documentElement.setAttribute("xmlns:o",a.o),t.documentElement.setAttribute("xmlns:x",a.x),t.documentElement.setAttribute("xmlns:ss",a.ss),t.documentElement.setAttribute("xmlns:html",a.html);var o=t.createElement("x:ExcelWorkbook");t.documentElement.appendChild(o),i=t.createElement("ss:Styles"),t.documentElement.appendChild(i),n=e.styles.create(),n.setId("Default"),n.setName("Normal")},this.worksheets=[],this.worksheets.create=function(t){var i=e.el(a.ss,"Worksheet"),n=new o(i);return n.setName(t),this.push(n),n},this.styles=[],this.styles.create=function(e){var n=t.createElement("ss:Style");i.appendChild(n);var a=new r(n);return this.push(a),a},this.styles.getDefault=function(){return n},this.el=function(e,i){var n=t.createElementNS(e,i);return t.documentElement.appendChild(n),n},this.getSource=function(){return'<?xml version="1.0"?>'+(new XMLSerializer).serializeToString(t)},this.getDataUri=function(){return"data:application/vnd.ms-excel,"+encodeURIComponent(this.getSource())},this.getElement=function(){return t},this.getDefaultFileName=function(){return"spreadsheet.xls"},this.getBlob=function(){return new Blob([this.getSource()])};var o=function(e){var i=t.createElement("Table");e.appendChild(i);var n=t.createElement("x:WorksheetOptions");e.appendChild(n),this.rows=[],this.setName=function(t){e.setAttribute("ss:Name",t)},this.cell=function(e,n){for(;n>=this.rows.length;){var o=t.createElement("Row");i.appendChild(o),this.rows.push(new a(o))}return this.rows[n].cell(e)},this.enableGridlines=function(e){var i=DayPilot.list(n.childNodes).find(function(e){return"x:DoNotDisplayGridlines"===e.tagName});if(!i&&!e){var a=t.createElement("x:DoNotDisplayGridlines");n.appendChild(a)}i&&e&&n.removeChild(i)};var a=function(e){this.cells=[],this.getElement=function(){return e},this.cell=function(n){for(;n>=this.cells.length;){var a=t.createElement("Cell");e.appendChild(a),this.cells.push(new i(a))}return this.cells[n]};var i=function(e){this.setText=function(i){var n=t.createElement("Data");n.setAttribute("ss:Type","String");var a=t.createTextNode(i);for(n.appendChild(a);e.firstChild;)e.removeChild(e.firstChild);return e.appendChild(n),this},this.setColspan=function(t){return t>1?e.setAttribute("ss:MergeAcross",t-1):e.removeAttribute("ss:MergeAcross"),this},this.setRowspan=function(t){return t>1?e.setAttribute("ss:MergeDown",t-1):e.removeAttribute("ss:MergeDown"),this},this.setStyle=function(t){if(!(t instanceof r))throw"Invalid argument, Style expected";return e.setAttribute("ss:StyleID",t.getId()),this}}}},r=function(e){var i=DayPilot.guid();e.setAttribute("ss:ID",i);var n=t.createElement("ss:Alignment");e.appendChild(n);var a=t.createElement("ss:Interior");e.appendChild(a);var o=t.createElement("ss:Borders");e.appendChild(o),this.setHorizontalAlignment=function(e){n.setAttribute("ss:Horizontal",e)},this.setVerticalAlignment=function(e){n.setAttribute("ss:Vertical",e)},this.setBackColor=function(e){var t=DayPilot.Util.normalizeColor(e);a.setAttribute("ss:Color",t),a.setAttribute("ss:Pattern","Solid")},this.setBorderColor=function(e){function i(e,i){var n=t.createElement("ss:Border");return n.setAttribute("ss:Position",e),n.setAttribute("ss:LineStyle","Continuous"),n.setAttribute("ss:Color",DayPilot.Util.normalizeColor(i)),n}this.clearBorders();var n=i("Left",e);o.appendChild(n);var a=i("Right",e);o.appendChild(a);var r=i("Top",e);o.appendChild(r);var s=i("Bottom",e);o.appendChild(s)},this.clearBorders=function(){for(;o.firstChild;)o.removeChild(o.firstChild)},this.getId=function(){return i},this.setId=function(t){i=t,e.setAttribute("ss:ID",i)},this.setName=function(t){e.setAttribute("ss:Name",t)}};this.init()},DayPilot.Export=function(e){this.toElement=function(){return e.getElement()},this.dimensions=function(){return{"width":e.getWidth(),"height":e.getHeight()}},this.toHtml=function(){return e.getSource()},this.toDataUri=function(){return e.getDataUri()},this.toBlob=function(){return e.getBlob()},this.print=function(){var t=document.createElement("iframe");t.setAttribute("width",0),t.setAttribute("height",0),t.setAttribute("frameborder",0),t.setAttribute("src","about:blank"),document.body.appendChild(t);var i=t.contentWindow.document;("BackCompat"===i.compatMode?i.body:i.documentElement).appendChild(e.getElement()),t.contentWindow.document.execCommand("print",!1,null)||(t.contentWindow.focus(),t.contentWindow.print()),document.body.removeChild(t)},this.download=function(t){var t=t||e.getDefaultFileName(),i=e.getBlob();DayPilot.Util.downloadBlob(i,t)}},DayPilot.Exception=function(e){this.message=e},DayPilot.Locale=function(e,t){if(this.id=e,this.dayNames=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],this.dayNamesShort=["Su","Mo","Tu","We","Th","Fr","Sa"],this.monthNames=["January","February","March","April","May","June","July","August","September","October","November","December"],this.monthNamesShort=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],this.datePattern="M/d/yyyy",this.timePattern="H:mm",this.dateTimePattern="M/d/yyyy H:mm",this.timeFormat="Clock12Hours",this.weekStarts=0,t)for(var i in t)this[i]=t[i]},DayPilot.Locale.all={},DayPilot.Locale.find=function(e){if(!e)return null;var t=e.toLowerCase();return t.length>2&&(t=DayPilot.Util.replaceCharAt(t,2,"-")),DayPilot.Locale.all[t]},DayPilot.Locale.register=function(e){DayPilot.Locale.all[e.id]=e},DayPilot.Locale.register(new DayPilot.Locale("ca-es",{"dayNames":["diumenge","dilluns","dimarts","dimecres","dijous","divendres","dissabte"],"dayNamesShort":["dg","dl","dt","dc","dj","dv","ds"],"monthNames":["gener","febrer","març","abril","maig","juny","juliol","agost","setembre","octubre","novembre","desembre",""],"monthNamesShort":["gen.","febr.","març","abr.","maig","juny","jul.","ag.","set.","oct.","nov.","des.",""],"timePattern":"H:mm","datePattern":"dd/MM/yyyy","dateTimePattern":"dd/MM/yyyy H:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("cs-cz",{"dayNames":["neděle","pondělí","úterý","středa","čtvrtek","pátek","sobota"],"dayNamesShort":["ne","po","út","st","čt","pá","so"],"monthNames":["leden","únor","březen","duben","květen","červen","červenec","srpen","září","říjen","listopad","prosinec",""],"monthNamesShort":["I","II","III","IV","V","VI","VII","VIII","IX","X","XI","XII",""],"timePattern":"H:mm","datePattern":"d. M. yyyy","dateTimePattern":"d. M. yyyy H:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("da-dk",{"dayNames":["søndag","mandag","tirsdag","onsdag","torsdag","fredag","lørdag"],"dayNamesShort":["sø","ma","ti","on","to","fr","lø"],"monthNames":["januar","februar","marts","april","maj","juni","juli","august","september","oktober","november","december",""],"monthNamesShort":["jan","feb","mar","apr","maj","jun","jul","aug","sep","okt","nov","dec",""],"timePattern":"HH:mm","datePattern":"dd-MM-yyyy","dateTimePattern":"dd-MM-yyyy HH:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("de-at",{"dayNames":["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],"dayNamesShort":["So","Mo","Di","Mi","Do","Fr","Sa"],"monthNames":["Jänner","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember",""],"monthNamesShort":["Jän","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez",""],"timePattern":"HH:mm","datePattern":"dd.MM.yyyy","dateTimePattern":"dd.MM.yyyy HH:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("de-ch",{"dayNames":["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],"dayNamesShort":["So","Mo","Di","Mi","Do","Fr","Sa"],"monthNames":["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember",""],"monthNamesShort":["Jan","Feb","Mrz","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez",""],"timePattern":"HH:mm","datePattern":"dd.MM.yyyy","dateTimePattern":"dd.MM.yyyy HH:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("de-de",{"dayNames":["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],"dayNamesShort":["So","Mo","Di","Mi","Do","Fr","Sa"],"monthNames":["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember",""],"monthNamesShort":["Jan","Feb","Mrz","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez",""],"timePattern":"HH:mm","datePattern":"dd.MM.yyyy","dateTimePattern":"dd.MM.yyyy HH:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("de-lu",{"dayNames":["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],"dayNamesShort":["So","Mo","Di","Mi","Do","Fr","Sa"],"monthNames":["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember",""],"monthNamesShort":["Jan","Feb","Mrz","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez",""],"timePattern":"HH:mm","datePattern":"dd.MM.yyyy","dateTimePattern":"dd.MM.yyyy HH:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("en-au",{"dayNames":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],"dayNamesShort":["Su","Mo","Tu","We","Th","Fr","Sa"],"monthNames":["January","February","March","April","May","June","July","August","September","October","November","December",""],"monthNamesShort":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec",""],"timePattern":"h:mm tt","datePattern":"d/MM/yyyy","dateTimePattern":"d/MM/yyyy h:mm tt","timeFormat":"Clock12Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("en-ca",{"dayNames":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],"dayNamesShort":["Su","Mo","Tu","We","Th","Fr","Sa"],"monthNames":["January","February","March","April","May","June","July","August","September","October","November","December",""],"monthNamesShort":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec",""],"timePattern":"h:mm tt","datePattern":"yyyy-MM-dd","dateTimePattern":"yyyy-MM-dd h:mm tt","timeFormat":"Clock12Hours","weekStarts":0})),DayPilot.Locale.register(new DayPilot.Locale("en-gb",{"dayNames":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],"dayNamesShort":["Su","Mo","Tu","We","Th","Fr","Sa"],"monthNames":["January","February","March","April","May","June","July","August","September","October","November","December",""],"monthNamesShort":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec",""],"timePattern":"HH:mm","datePattern":"dd/MM/yyyy","dateTimePattern":"dd/MM/yyyy HH:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("en-us",{"dayNames":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],"dayNamesShort":["Su","Mo","Tu","We","Th","Fr","Sa"],"monthNames":["January","February","March","April","May","June","July","August","September","October","November","December",""],"monthNamesShort":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec",""],"timePattern":"h:mm tt","datePattern":"M/d/yyyy","dateTimePattern":"M/d/yyyy h:mm tt","timeFormat":"Clock12Hours","weekStarts":0})),DayPilot.Locale.register(new DayPilot.Locale("es-es",{"dayNames":["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],"dayNamesShort":["D","L","M","X","J","V","S"],"monthNames":["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre",""],"monthNamesShort":["ene.","feb.","mar.","abr.","may.","jun.","jul.","ago.","sep.","oct.","nov.","dic.",""],"timePattern":"H:mm","datePattern":"dd/MM/yyyy","dateTimePattern":"dd/MM/yyyy H:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("es-mx",{"dayNames":["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],"dayNamesShort":["do.","lu.","ma.","mi.","ju.","vi.","sá."],"monthNames":["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre",""],"monthNamesShort":["ene.","feb.","mar.","abr.","may.","jun.","jul.","ago.","sep.","oct.","nov.","dic.",""],"timePattern":"hh:mm tt","datePattern":"dd/MM/yyyy","dateTimePattern":"dd/MM/yyyy hh:mm tt","timeFormat":"Clock12Hours","weekStarts":0})),DayPilot.Locale.register(new DayPilot.Locale("eu-es",{"dayNames":["igandea","astelehena","asteartea","asteazkena","osteguna","ostirala","larunbata"],"dayNamesShort":["ig","al","as","az","og","or","lr"],"monthNames":["urtarrila","otsaila","martxoa","apirila","maiatza","ekaina","uztaila","abuztua","iraila","urria","azaroa","abendua",""],"monthNamesShort":["urt.","ots.","mar.","api.","mai.","eka.","uzt.","abu.","ira.","urr.","aza.","abe.",""],"timePattern":"H:mm","datePattern":"yyyy/MM/dd","dateTimePattern":"yyyy/MM/dd H:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("fi-fi",{"dayNames":["sunnuntai","maanantai","tiistai","keskiviikko","torstai","perjantai","lauantai"],"dayNamesShort":["su","ma","ti","ke","to","pe","la"],"monthNames":["tammikuu","helmikuu","maaliskuu","huhtikuu","toukokuu","kesäkuu","heinäkuu","elokuu","syyskuu","lokakuu","marraskuu","joulukuu",""],"monthNamesShort":["tammi","helmi","maalis","huhti","touko","kesä","heinä","elo","syys","loka","marras","joulu",""],"timePattern":"H:mm","datePattern":"d.M.yyyy","dateTimePattern":"d.M.yyyy H:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("fr-be",{"dayNames":["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],"dayNamesShort":["di","lu","ma","me","je","ve","sa"],"monthNames":["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre",""],"monthNamesShort":["janv.","févr.","mars","avr.","mai","juin","juil.","août","sept.","oct.","nov.","déc.",""],"timePattern":"HH:mm","datePattern":"dd-MM-yy","dateTimePattern":"dd-MM-yy HH:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("fr-ca",{"dayNames":["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],"dayNamesShort":["di","lu","ma","me","je","ve","sa"],"monthNames":["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre",""],"monthNamesShort":["janv.","févr.","mars","avr.","mai","juin","juil.","août","sept.","oct.","nov.","déc.",""],"timePattern":"HH:mm","datePattern":"yyyy-MM-dd","dateTimePattern":"yyyy-MM-dd HH:mm","timeFormat":"Clock24Hours","weekStarts":0})),DayPilot.Locale.register(new DayPilot.Locale("fr-ch",{"dayNames":["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],"dayNamesShort":["di","lu","ma","me","je","ve","sa"],"monthNames":["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre",""],"monthNamesShort":["janv.","févr.","mars","avr.","mai","juin","juil.","août","sept.","oct.","nov.","déc.",""],"timePattern":"HH:mm","datePattern":"dd.MM.yyyy","dateTimePattern":"dd.MM.yyyy HH:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("fr-fr",{"dayNames":["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],"dayNamesShort":["di","lu","ma","me","je","ve","sa"],"monthNames":["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre",""],"monthNamesShort":["janv.","févr.","mars","avr.","mai","juin","juil.","août","sept.","oct.","nov.","déc.",""],"timePattern":"HH:mm","datePattern":"dd/MM/yyyy","dateTimePattern":"dd/MM/yyyy HH:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("fr-lu",{"dayNames":["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],"dayNamesShort":["di","lu","ma","me","je","ve","sa"],"monthNames":["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre",""],"monthNamesShort":["janv.","févr.","mars","avr.","mai","juin","juil.","août","sept.","oct.","nov.","déc.",""],"timePattern":"HH:mm","datePattern":"dd/MM/yyyy","dateTimePattern":"dd/MM/yyyy HH:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("gl-es",{"dayNames":["domingo","luns","martes","mércores","xoves","venres","sábado"],"dayNamesShort":["do","lu","ma","mé","xo","ve","sá"],"monthNames":["xaneiro","febreiro","marzo","abril","maio","xuño","xullo","agosto","setembro","outubro","novembro","decembro",""],"monthNamesShort":["xan","feb","mar","abr","maio","xuño","xul","ago","set","out","nov","dec",""],"timePattern":"H:mm","datePattern":"dd/MM/yyyy","dateTimePattern":"dd/MM/yyyy H:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("it-it",{"dayNames":["domenica","lunedì","martedì","mercoledì","giovedì","venerdì","sabato"],"dayNamesShort":["do","lu","ma","me","gi","ve","sa"],"monthNames":["gennaio","febbraio","marzo","aprile","maggio","giugno","luglio","agosto","settembre","ottobre","novembre","dicembre",""],"monthNamesShort":["gen","feb","mar","apr","mag","giu","lug","ago","set","ott","nov","dic",""],"timePattern":"HH:mm","datePattern":"dd/MM/yyyy","dateTimePattern":"dd/MM/yyyy HH:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("it-ch",{"dayNames":["domenica","lunedì","martedì","mercoledì","giovedì","venerdì","sabato"],"dayNamesShort":["do","lu","ma","me","gi","ve","sa"],"monthNames":["gennaio","febbraio","marzo","aprile","maggio","giugno","luglio","agosto","settembre","ottobre","novembre","dicembre",""],"monthNamesShort":["gen","feb","mar","apr","mag","giu","lug","ago","set","ott","nov","dic",""],"timePattern":"HH:mm","datePattern":"dd.MM.yyyy","dateTimePattern":"dd.MM.yyyy HH:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("ja-jp",{"dayNames":["日曜日","月曜日","火曜日","水曜日","木曜日","金曜日","土曜日"],"dayNamesShort":["日","月","火","水","木","金","土"],"monthNames":["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月",""],"monthNamesShort":["1","2","3","4","5","6","7","8","9","10","11","12",""],"timePattern":"H:mm","datePattern":"yyyy/MM/dd","dateTimePattern":"yyyy/MM/dd H:mm","timeFormat":"Clock24Hours","weekStarts":0})),DayPilot.Locale.register(new DayPilot.Locale("nb-no",{"dayNames":["søndag","mandag","tirsdag","onsdag","torsdag","fredag","lørdag"],"dayNamesShort":["sø","ma","ti","on","to","fr","lø"],"monthNames":["januar","februar","mars","april","mai","juni","juli","august","september","oktober","november","desember",""],"monthNamesShort":["jan","feb","mar","apr","mai","jun","jul","aug","sep","okt","nov","des",""],"timePattern":"HH:mm","datePattern":"dd.MM.yyyy","dateTimePattern":"dd.MM.yyyy HH:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("nl-nl",{"dayNames":["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"],"dayNamesShort":["zo","ma","di","wo","do","vr","za"],"monthNames":["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december",""],"monthNamesShort":["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec",""],"timePattern":"HH:mm","datePattern":"d-M-yyyy","dateTimePattern":"d-M-yyyy HH:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("nl-be",{"dayNames":["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"],"dayNamesShort":["zo","ma","di","wo","do","vr","za"],"monthNames":["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december",""],"monthNamesShort":["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec",""],"timePattern":"H:mm","datePattern":"d/MM/yyyy","dateTimePattern":"d/MM/yyyy H:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("nn-no",{"dayNames":["søndag","måndag","tysdag","onsdag","torsdag","fredag","laurdag"],"dayNamesShort":["sø","må","ty","on","to","fr","la"],"monthNames":["januar","februar","mars","april","mai","juni","juli","august","september","oktober","november","desember",""],"monthNamesShort":["jan","feb","mar","apr","mai","jun","jul","aug","sep","okt","nov","des",""],"timePattern":"HH:mm","datePattern":"dd.MM.yyyy","dateTimePattern":"dd.MM.yyyy HH:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("pt-br",{"dayNames":["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"],"dayNamesShort":["D","S","T","Q","Q","S","S"],"monthNames":["janeiro","fevereiro","março","abril","maio","junho","julho","agosto","setembro","outubro","novembro","dezembro",""],"monthNamesShort":["jan","fev","mar","abr","mai","jun","jul","ago","set","out","nov","dez",""],"timePattern":"HH:mm","datePattern":"dd/MM/yyyy","dateTimePattern":"dd/MM/yyyy HH:mm","timeFormat":"Clock24Hours","weekStarts":0})),DayPilot.Locale.register(new DayPilot.Locale("pl-pl",{"dayNames":["niedziela","poniedziałek","wtorek","środa","czwartek","piątek","sobota"],"dayNamesShort":["N","Pn","Wt","Śr","Cz","Pt","So"],"monthNames":["styczeń","luty","marzec","kwiecień","maj","czerwiec","lipiec","sierpień","wrzesień","październik","listopad","grudzień",""],"monthNamesShort":["sty","lut","mar","kwi","maj","cze","lip","sie","wrz","paź","lis","gru",""],"timePattern":"HH:mm","datePattern":"yyyy-MM-dd","dateTimePattern":"yyyy-MM-dd HH:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("pt-pt",{"dayNames":["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"],"dayNamesShort":["D","S","T","Q","Q","S","S"],"monthNames":["janeiro","fevereiro","março","abril","maio","junho","julho","agosto","setembro","outubro","novembro","dezembro",""],"monthNamesShort":["jan","fev","mar","abr","mai","jun","jul","ago","set","out","nov","dez",""],"timePattern":"HH:mm","datePattern":"dd/MM/yyyy","dateTimePattern":"dd/MM/yyyy HH:mm","timeFormat":"Clock24Hours","weekStarts":0})),DayPilot.Locale.register(new DayPilot.Locale("ro-ro",{"dayNames":["duminică","luni","marți","miercuri","joi","vineri","sâmbătă"],"dayNamesShort":["D","L","Ma","Mi","J","V","S"],"monthNames":["ianuarie","februarie","martie","aprilie","mai","iunie","iulie","august","septembrie","octombrie","noiembrie","decembrie",""],"monthNamesShort":["ian.","feb.","mar.","apr.","mai.","iun.","iul.","aug.","sep.","oct.","nov.","dec.",""],"timePattern":"H:mm","datePattern":"dd.MM.yyyy","dateTimePattern":"dd.MM.yyyy H:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("ru-ru",{"dayNames":["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"],"dayNamesShort":["Вс","Пн","Вт","Ср","Чт","Пт","Сб"],"monthNames":["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь",""],"monthNamesShort":["янв","фев","мар","апр","май","июн","июл","авг","сен","окт","ноя","дек",""],"timePattern":"H:mm","datePattern":"dd.MM.yyyy","dateTimePattern":"dd.MM.yyyy H:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("sk-sk",{"dayNames":["nedeľa","pondelok","utorok","streda","štvrtok","piatok","sobota"],"dayNamesShort":["ne","po","ut","st","št","pi","so"],"monthNames":["január","február","marec","apríl","máj","jún","júl","august","september","október","november","december",""],"monthNamesShort":["1","2","3","4","5","6","7","8","9","10","11","12",""],"timePattern":"H:mm","datePattern":"d.M.yyyy","dateTimePattern":"d.M.yyyy H:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("sv-se",{"dayNames":["söndag","måndag","tisdag","onsdag","torsdag","fredag","lördag"],"dayNamesShort":["sö","må","ti","on","to","fr","lö"],"monthNames":["januari","februari","mars","april","maj","juni","juli","augusti","september","oktober","november","december",""],"monthNamesShort":["jan","feb","mar","apr","maj","jun","jul","aug","sep","okt","nov","dec",""],"timePattern":"HH:mm","datePattern":"yyyy-MM-dd","dateTimePattern":"yyyy-MM-dd HH:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("tr-tr",{"dayNames":["Pazar","Pazartesi","Salı","Çarşamba","Perşembe","Cuma","Cumartesi"],"dayNamesShort":["Pz","Pt","Sa","Ça","Pe","Cu","Ct"],"monthNames":["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık",""],"monthNamesShort":["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara",""],"timePattern":"HH:mm","datePattern":"d.M.yyyy","dateTimePattern":"d.M.yyyy HH:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.register(new DayPilot.Locale("zh-cn",{"dayNames":["星期日","星期一","星期二","星期三","星期四","星期五","星期六"],"dayNamesShort":["日","一","二","三","四","五","六"],"monthNames":["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月",""],"monthNamesShort":["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月",""],"timePattern":"H:mm","datePattern":"yyyy/M/d","dateTimePattern":"yyyy/M/d H:mm","timeFormat":"Clock24Hours","weekStarts":1})),DayPilot.Locale.US=DayPilot.Locale.find("en-us"),DayPilot.Switcher=function(e){function t(e,t,n){var a={};a.start=e,a.end=t,a.day=n,a.target=i.active.control,a.preventDefault=function(){this.preventDefault.value=!0};var o=i.k;o&&o.start===a.start&&o.end===a.end&&o.day===a.day&&o.target===a.target||(i.k=a,"function"==typeof i.onChange&&(i.onChange(a),a.preventDefault.value)||"function"==typeof i.onTimeRangeSelect&&(i.onTimeRangeSelect(a),a.preventDefault.value)||(i.active.sendNavigate(i.day),"function"==typeof i.onChanged&&i.onChanged(a),"function"==typeof i.onTimeRangeSelected&&i.onTimeRangeSelected(a)))}var i=this;this.views=[],this.triggers=[],this.navigator={},this.selectedClass=null,this.active=null,this.day=DayPilot.Date.today(),this.onChange=null,this.onChanged=null,this.navigator.updateMode=function(e){var t=i.navigator.control;t&&(t.selectMode=e,t.select(i.day))},this.addView=function(e,t){var n;if("string"==typeof e){if(n=document.getElementById(e),!n)throw"Element not found: "+e}else n=e;var a=n,o={};return o.isView=!0,o.id=a.id,o.control=a,o.options=t||{},o.hide=function(){a.hide?a.hide():a.nav&&a.nav.top?a.nav.top.style.display="none":a.style.display="none"},o.sendNavigate=function(e){(function(){return!!a.backendUrl||!("function"!=typeof WebForm_DoCallback||!a.uniqueID)})()?a.commandCallBack&&a.commandCallBack("navigate",{"day":e}):(a.startDate=e,a.update())},o.show=function(){i.c(),a.show?a.show():a.nav&&a.nav.top?a.nav.top.style.display="":a.style.display=""},o.selectMode=function(){if(o.options.navigatorSelectMode)return o.options.navigatorSelectMode;if(a.isCalendar)switch(a.viewType){case"Day":return"day";case"Week":return"week";case"WorkWeek":return"week";default:return"day"}else if(a.isMonth)switch(a.viewType){case"Month":return"month";case"Weeks":return"week";default:return"day"}return"day"},this.views.push(o),o},this.addTrigger=function(e,t){var n;if("string"==typeof e){if(n=document.getElementById(e),!n)throw"Element not found: "+e}else n=e;var a=this.f(t);a||(a=this.addView(t));var o={};return o.isTrigger=!0,o.element=n,o.id=n.id,o.view=a,o.onClick=function(e){i.show(o),i.g(o),e=e||window.event,e&&(e.preventDefault?e.preventDefault():e.returnValue=!1)},DayPilot.re(n,"click",o.onClick),this.triggers.push(o),o},this.addButton=this.addTrigger,
this.select=function(e){var t=this.j(e);t?t.onClick():this.triggers.length>0&&this.triggers[0].onClick()},this.j=function(e){for(var t=0;t<this.triggers.length;t++){var i=this.triggers[t];if(i.id===e)return i}return null},this.g=function(e){if(this.selectedClass){for(var t=0;t<this.triggers.length;t++){var i=this.triggers[t];DayPilot.Util.removeClass(i.element,this.selectedClass)}DayPilot.Util.addClass(e.element,this.selectedClass)}},this.addNavigator=function(e){i.navigator.control=e,e.timeRangeSelectedHandling="JavaScript",e.onTimeRangeSelected=function(){var n,a,o;if(1===e.api)n=arguments[0],a=arguments[1],o=arguments[2];else{var r=arguments[0];n=r.start,a=r.end,o=r.day}i.day=o,t(n,a,o)}},this.show=function(e){var t,n;if(e.isTrigger)n=e,t=n.view;else if(t=e.isView?e:this.f(e),this.active===t)return;if(i.onSelect){var a={};a.source=n?n.element:null,a.target=t.control,i.onSelect(a)}this.active=t,t.show();var o=t.selectMode();i.navigator.updateMode(o)},this.f=function(e){for(var t=0;t<this.views.length;t++)if(this.views[t].control===e)return this.views[t];return null},this.c=function(){for(var e=0;e<this.views.length;e++)this.views[e].hide()},this.events={},this.events.load=function(e,t,n){if(!i.active||!i.active.control)throw"DayPilot.Switcher.events.load(): Active view not found";i.active.control.events.load(e,t,n)},this.k=null,this.l=function(){if(e)for(var t in e)"triggers"===t?DayPilot.list(e.triggers).each(function(e){i.addTrigger(e.id,e.view)}):"navigator"===t?i.addNavigator(e.navigator):i[t]=e[t]},this.l()},function(){if(!DayPilot.Global.defaultCss){var e=DayPilot.sheet();e.add(".bubble_default_main","cursor: default;"),e.add(".bubble_default_main_inner",'border-radius: 5px;font-size: 12px;padding: 4px;color: #666;background: #eeeeee; background: -webkit-gradient(linear, left top, left bottom, from(#ffffff), to(#eeeeee));background: -webkit-linear-gradient(top, #ffffff 0%, #eeeeee);background: -moz-linear-gradient(top, #ffffff 0%, #eeeeee);background: -ms-linear-gradient(top, #ffffff 0%, #eeeeee);background: -o-linear-gradient(top, #ffffff 0%, #eeeeee);background: linear-gradient(top, #ffffff 0%, #eeeeee);filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr="#ffffff", endColorStr="#eeeeee");border: 1px solid #ccc;-moz-border-radius: 5px;-webkit-border-radius: 5px;border-radius: 5px;-moz-box-shadow:0px 2px 3px rgba(000,000,000,0.3),inset 0px 0px 2px rgba(255,255,255,0.8);-webkit-box-shadow:0px 2px 3px rgba(000,000,000,0.3),inset 0px 0px 2px rgba(255,255,255,0.8);box-shadow:0px 2px 3px rgba(000,000,000,0.3),inset 0px 0px 2px rgba(255,255,255,0.8);'),e.add(".calendar_default_main","border: 1px solid #c0c0c0; font-family: Tahoma, Arial, Helvetica, sans-serif; font-size: 12px;"),e.add(".calendar_default_main *, .calendar_default_main *:before, .calendar_default_main *:after","box-sizing: content-box;"),e.add(".calendar_default_rowheader_inner,.calendar_default_cornerright_inner,.calendar_default_corner_inner,.calendar_default_colheader_inner,.calendar_default_alldayheader_inner","color: #333;background: #f3f3f3;"),e.add(".calendar_default_cornerright_inner","position: absolute;top: 0px;left: 0px;bottom: 0px;right: 0px;\tborder-bottom: 1px solid #c0c0c0;"),e.add(".calendar_default_rowheader_inner","font-size: 16pt;text-align: right; position: absolute;top: 0px;left: 0px;bottom: 0px;right: 0px;border-right: 1px solid #c0c0c0;border-bottom: 1px solid #c0c0c0;"),e.add(".calendar_default_corner_inner","position: absolute;top: 0px;left: 0px;bottom: 0px;right: 0px;border-right: 1px solid #c0c0c0;border-bottom: 1px solid #c0c0c0;"),e.add(".calendar_default_rowheader_minutes","font-size:10px;vertical-align: super;padding-left: 2px;padding-right: 2px;"),e.add(".calendar_default_colheader_inner","text-align: center; position: absolute;top: 0px;left: 0px;bottom: 0px;right: 0px;border-right: 1px solid #c0c0c0;border-bottom: 1px solid #c0c0c0;"),e.add(".calendar_default_cell_inner","position: absolute;top: 0px;left: 0px;bottom: 0px;right: 0px;border-right: 1px solid #ddd;border-bottom: 1px solid #ddd; background: #f9f9f9;"),e.add(".calendar_default_cell_business .calendar_default_cell_inner","background: #fff"),e.add(".calendar_default_alldayheader_inner","text-align: center;position: absolute;top: 0px;left: 0px;bottom: 0px;right: 0px;border-right: 1px solid #c0c0c0;border-bottom: 1px solid #c0c0c0;"),e.add(".calendar_default_message","opacity: 0.9;filter: alpha(opacity=90);\tpadding: 10px; color: #ffffff;background: #ffa216;"),e.add(".calendar_default_alldayevent_inner,.calendar_default_event_inner","color: #666; border: 1px solid #999;"),e.add(".calendar_default_event_bar","top: 0px;bottom: 0px;left: 0px;width: 4px;background-color: #9dc8e8;"),e.add(".calendar_default_event_bar_inner","position: absolute;width: 4px;background-color: #1066a8;"),e.add(".calendar_default_alldayevent_inner,.calendar_default_event_inner",'background: #fff;background: -webkit-gradient(linear, left top, left bottom, from(#ffffff), to(#eeeeee));background: -webkit-linear-gradient(top, #ffffff 0%, #eeeeee);background: -moz-linear-gradient(top, #ffffff 0%, #eeeeee);background: -ms-linear-gradient(top, #ffffff 0%, #eeeeee);background: -o-linear-gradient(top, #ffffff 0%, #eeeeee);background: linear-gradient(top, #ffffff 0%, #eeeeee);filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr="#ffffff", endColorStr="#eeeeee");'),e.add(".calendar_default_selected .calendar_default_event_inner","background: #ddd;"),e.add(".calendar_default_alldayevent_inner","position: absolute;top: 2px;bottom: 2px;left: 2px;right: 2px;padding: 2px;margin-right: 1px;font-size: 12px;"),e.add(".calendar_default_event_withheader .calendar_default_event_inner","padding-top: 15px;"),e.add(".calendar_default_event","cursor: default;"),e.add(".calendar_default_event_inner","position: absolute;overflow: hidden;top: 0px;bottom: 0px;left: 0px;right: 0px;padding: 2px 2px 2px 6px;font-size: 12px;"),e.add(".calendar_default_shadow_inner","background-color: #666666;\topacity: 0.5;filter: alpha(opacity=50);height: 100%;"),e.add(".calendar_default_event_delete","background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAadEVYdFNvZnR3YXJlAFBhaW50Lk5FVCB2My41LjExR/NCNwAAAI5JREFUKFNtkLERgCAMRbmzdK8s4gAUlhYOYEHJEJYOYOEwDmGBPxC4kOPfvePy84MGR0RJ2N1A8H3N6DATwSQ57m2ql8NBG+AEM7D+UW+wjdfUPgerYNgB5gOLRHqhcasg84C2QxPMtrUhSqQIhg7ypy9VM2EUZPI/4rQ7rGxqo9sadTegw+UdjeDLAKUfhbaQUVPIfJYAAAAASUVORK5CYII=) center center no-repeat; opacity: 0.6; -ms-filter:'progid:DXImageTransform.Microsoft.Alpha(Opacity=60)'; cursor: pointer;"),e.add(".calendar_default_event_delete:hover","opacity: 1;-ms-filter: none;"),e.add(".calendar_default_scroll_up","background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAB3RJTUUH2wESDiYcrhwCiQAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAARnQU1BAACxjwv8YQUAAACcSURBVHjaY2AgF9wWsTW6yGMlhi7OhC7AyMDQzMnBXIpFHAFuCtuaMTP+P8nA8P/b1x//FfW/HHuF1UQmxv+NUP1c3OxMVVhNvCVi683E8H8LXOY/w9+fTH81tF8fv4NiIpBRj+YoZtZ/LDUoJmKYhsVUpv0MDiyMDP96sIYV0FS2/8z9ICaLlOhvS4b/jC//MzC8xBG0vJeF7GQBlK0xdiUzCtsAAAAASUVORK5CYII=);"),e.add(".calendar_default_scroll_down","background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAALiMAAC4jAXilP3YAAACqSURBVChTY7wpam3L9J+xmQEP+PGPKZZxP4MDi4zI78uMDIwa2NT+Z2DYovrmiC+TI8OBP/8ZmEqwGvif4e8vxr+FIDkmEKH25vBWBgbG0+iK/zEwLtF+ffwOXCGI8Y+BoRFFIdC030x/WmBiYBNhpgLdswNJ8RSYaSgmgk39z1gPUfj/29ef/9rwhQTDHRHbrbdEbLvRFcGthkkAra/9/uMvhkK8piNLAgCRpTnNn4AEmAAAAABJRU5ErkJggg==);"),e.add(".calendar_default_now","background-color: red;"),e.add(".calendar_default_now:before","content: ''; top: -5px; border-width: 5px; border-color: transparent transparent transparent red; border-style: solid; width: 0px; height:0px; position: absolute; -moz-transform: scale(.9999);"),e.add(".menu_default_main","font-family: Tahoma, Arial, Helvetica, Sans-Serif;font-size: 12px;border: 1px solid #dddddd;background-color: white;padding: 0px;cursor: default;background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAABCAIAAABG0om7AAAAKXRFWHRDcmVhdGlvbiBUaW1lAHBvIDEwIDUgMjAxMCAyMjozMzo1OSArMDEwMGzy7+IAAAAHdElNRQfaBQoUJAesj4VUAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAABGdBTUEAALGPC/xhBQAAABVJREFUeNpj/P//PwO1weMnT2RlZAAYuwX/4oA3BgAAAABJRU5ErkJggg==);background-repeat: repeat-y;xborder-radius: 5px;-moz-box-shadow:0px 2px 3px rgba(000,000,000,0.3),inset 0px 0px 2px rgba(255,255,255,0.8);-webkit-box-shadow:0px 2px 3px rgba(000,000,000,0.3),inset 0px 0px 2px rgba(255,255,255,0.8);box-shadow:0px 2px 3px rgba(000,000,000,0.3),inset 0px 0px 2px rgba(255,255,255,0.8);"),e.add(".menu_default_main, .menu_default_main *, .menu_default_main *:before, .menu_default_main *:after","box-sizing: content-box;"),e.add(".menu_default_title","background-color: #f2f2f2;border-bottom: 1px solid gray;padding: 4px 4px 4px 37px;"),e.add(".menu_default_main a","padding: 2px 2px 2px 35px;color: black;text-decoration: none;cursor: default;"),e.add(".menu_default_main a img","margin-left: 6px;margin-top: 2px;"),e.add(".menu_default_item_text","display: block;height: 20px;line-height: 20px; overflow:hidden;padding-left: 2px;padding-right: 20px;"),e.add(".menu_default_main a:hover","background-color: #f3f3f3;"),e.add(".menu_default_main div div","border-top: 1px solid #dddddd;margin-top: 2px;margin-bottom: 2px;margin-left: 28px;"),e.add(".menu_default_main a.menu_default_item_disabled","color: #ccc"),e.add(".menu_default_item_haschildren.menu_default_item_haschildren_active",'background: #eeeeee;background: -webkit-gradient(linear, left top, left bottom, from(#efefef), to(#e6e6e6));background: -webkit-linear-gradient(top, #efefef 0%, #e6e6e6);background: -moz-linear-gradient(top, #efefef 0%, #e6e6e6);background: -ms-linear-gradient(top, #efefef 0%, #e6e6e6);background: -o-linear-gradient(top, #efefef 0%, #e6e6e6);background: linear-gradient(top, #efefef 0%, #e6e6e6);filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr="#efefef", endColorStr="#e6e6e6");'),e.add(".menu_default_item_haschildren a:before","content: ''; border-width: 6px; border-color: transparent transparent transparent black; border-style: solid; width: 0px; height:0px; position: absolute; right: 5px; margin-top: 4px;"),e.add(".menu_default_item_icon","position: absolute; top:0px; left: 0px; padding: 2px 2px 2px 8px;"),e.add(".menu_default_item a i","height: 20px;line-height: 20px;"),e.add(".menubar_default_main","border-bottom: 1px solid #ccc; font-family: Tahoma, Arial, Helvetica, sans-serif; font-size: 12px;"),e.add(".menubar_default_item","display: inline-block;  padding: 6px 10px; cursor: default;"),e.add(".menubar_default_item:hover","background-color: #f2f2f2;"),e.add(".menubar_default_item_active","background-color: #f2f2f2;"),e.add(".month_default_main","border: 1px solid #c0c0c0;font-family: Tahoma, Arial, Helvetica, sans-serif; font-size: 12px;color: #333;"),e.add(".month_default_main *, .month_default_main *:before, .month_default_main *:after","box-sizing: content-box;"),e.add(".month_default_cell_inner","border-right: 1px solid #ddd;border-bottom: 1px solid #ddd;position: absolute;top: 0px;left: 0px;bottom: 0px;right: 0px;background-color: #f9f9f9;"),e.add(".month_default_cell_business .month_default_cell_inner","background-color: #fff;"),e.add(".month_default_cell_header","text-align: right;padding-right: 2px;"),e.add(".month_default_header_inner","text-align: center; vertical-align: middle;position: absolute;top: 0px;left: 0px;bottom: 0px;right: 0px;border-right: 1px solid #c0c0c0;border-bottom: 1px solid #c0c0c0;cursor: default;color: #333;background: #f3f3f3;"),e.add(".month_default_message",'padding: 10px;opacity: 0.9;filter: alpha(opacity=90);color: #ffffff;background: #ffa216;background: -webkit-gradient(linear, left top, left bottom, from(#ffa216), to(#ff8400));background: -webkit-linear-gradient(top, #ffa216 0%, #ff8400);background: -moz-linear-gradient(top, #ffa216 0%, #ff8400);background: -ms-linear-gradient(top, #ffa216 0%, #ff8400);background: -o-linear-gradient(top, #ffa216 0%, #ff8400);background: linear-gradient(top, #ffa216 0%, #ff8400);filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr="#ffa216", endColorStr="#ff8400");'),e.add(".month_default_event_inner",'position: absolute;top: 0px;bottom: 0px;left: 1px;right: 1px;overflow:hidden;padding: 2px;padding-left: 5px;font-size: 12px;color: #333;background: #fff;background: -webkit-gradient(linear, left top, left bottom, from(#ffffff), to(#eeeeee));background: -webkit-linear-gradient(top, #ffffff 0%, #eeeeee);background: -moz-linear-gradient(top, #ffffff 0%, #eeeeee);background: -ms-linear-gradient(top, #ffffff 0%, #eeeeee);background: -o-linear-gradient(top, #ffffff 0%, #eeeeee);background: linear-gradient(top, #ffffff 0%, #eeeeee);filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr="#ffffff", endColorStr="#eeeeee");border: 1px solid #999;border-radius: 0px;'),e.add(".month_default_event_continueright .month_default_event_inner","border-top-right-radius: 0px;border-bottom-right-radius: 0px;border-right-style: dotted;"),e.add(".month_default_event_continueleft .month_default_event_inner","border-top-left-radius: 0px;border-bottom-left-radius: 0px;border-left-style: dotted;"),e.add(".month_default_event_hover .month_default_event_inner",'background: #fff;background: -webkit-gradient(linear, left top, left bottom, from(#ffffff), to(#e8e8e8));background: -webkit-linear-gradient(top, #ffffff 0%, #e8e8e8);background: -moz-linear-gradient(top, #ffffff 0%, #e8e8e8);background: -ms-linear-gradient(top, #ffffff 0%, #e8e8e8);background: -o-linear-gradient(top, #ffffff 0%, #e8e8e8);background: linear-gradient(top, #ffffff 0%, #e8e8e8);filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr="#ffffff", endColorStr="#e8e8e8");'),e.add(".month_default_selected .month_default_event_inner, .month_default_event_hover.month_default_selected .month_default_event_inner","background: #ddd;"),e.add(".month_default_shadow_inner","background-color: #666666;opacity: 0.5;filter: alpha(opacity=50);height: 100%;"),e.add(".month_default_event_delete","background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAadEVYdFNvZnR3YXJlAFBhaW50Lk5FVCB2My41LjExR/NCNwAAAI5JREFUKFNtkLERgCAMRbmzdK8s4gAUlhYOYEHJEJYOYOEwDmGBPxC4kOPfvePy84MGR0RJ2N1A8H3N6DATwSQ57m2ql8NBG+AEM7D+UW+wjdfUPgerYNgB5gOLRHqhcasg84C2QxPMtrUhSqQIhg7ypy9VM2EUZPI/4rQ7rGxqo9sadTegw+UdjeDLAKUfhbaQUVPIfJYAAAAASUVORK5CYII=) center center no-repeat; opacity: 0.6; -ms-filter:'progid:DXImageTransform.Microsoft.Alpha(Opacity=60)';cursor: pointer;"),e.add(".month_default_event_delete:hover","opacity: 1;-ms-filter: none;"),e.add(".month_default_event_timeleft","color: #ccc; font-size: 8pt"),e.add(".month_default_event_timeright","color: #ccc; font-size: 8pt; text-align: right;"),e.add(".navigator_default_main","border-left: 1px solid #c0c0c0;border-right: 1px solid #c0c0c0;border-bottom: 1px solid #c0c0c0;background-color: white;color: #000000; box-sizing: content-box;"),e.add(".navigator_default_main *, .navigator_default_main *:before, .navigator_default_main *:after","box-sizing: content-box;"),e.add(".navigator_default_month","font-family: Tahoma, Arial, Helvetica, sans-serif; font-size: 11px;"),e.add(".navigator_default_day","color: black;"),e.add(".navigator_default_weekend","background-color: #f0f0f0;"),e.add(".navigator_default_dayheader","color: black;"),e.add(".navigator_default_line","border-bottom: 1px solid #c0c0c0;"),e.add(".navigator_default_dayother","color: gray;"),e.add(".navigator_default_todaybox","border: 1px solid red;"),e.add(".navigator_default_title, .navigator_default_titleleft, .navigator_default_titleright","border-top: 1px solid #c0c0c0;border-bottom: 1px solid #c0c0c0;color: #333;background: #f3f3f3;"),e.add(".navigator_default_busy","font-weight: bold;"),e.add(".navigator_default_cell","text-align: center;"),e.add(".navigator_default_select .navigator_default_cell_box","background-color: #FFE794; opacity: 0.5;"),e.add(".navigator_default_title","text-align: center;"),e.add(".navigator_default_titleleft, .navigator_default_titleright","text-align: center;"),e.add(".navigator_default_dayheader","text-align: center;"),e.add(".navigator_default_weeknumber","text-align: center;"),e.add(".scheduler_default_main *, .scheduler_default_main *:before, .scheduler_default_main *:after","box-sizing: content-box;"),e.add(".scheduler_default_main","box-sizing: content-box; border: 1px solid #c0c0c0;font-family: Tahoma, Arial, Helvetica, sans-serif; font-size: 12px;"),e.add(".scheduler_default_selected .scheduler_default_event_inner","background: #ddd;"),e.add(".scheduler_default_timeheader","cursor: default;color: #333;"),e.add(".scheduler_default_message","opacity: 0.9;filter: alpha(opacity=90);padding: 10px; color: #ffffff;background: #ffa216;"),e.add(".scheduler_default_timeheadergroup,.scheduler_default_timeheadercol","color: #333;background: #f3f3f3;"),e.add(".scheduler_default_rowheader,.scheduler_default_corner","color: #333;background: #f3f3f3;"),e.add(".scheduler_default_rowheader.scheduler_default_rowheader_selected","background-color: #aaa;background-image: -webkit-gradient(linear, 0 100%, 100% 0,color-stop(.25, rgba(255, 255, 255, .2)), color-stop(.25, transparent),\tcolor-stop(.5, transparent), color-stop(.5, rgba(255, 255, 255, .2)), color-stop(.75, rgba(255, 255, 255, .2)), color-stop(.75, transparent), to(transparent));background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -moz-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -ms-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);-webkit-background-size: 20px 20px;-moz-background-size: 20px 20px;background-size: 20px 20px;"),e.add(".scheduler_default_rowheader_inner","position: absolute;left: 0px;right: 0px;top: 0px;bottom: 0px;border-right: 1px solid #e0e0e0;padding: 2px;"),e.add(".scheduler_default_timeheadergroup, .scheduler_default_timeheadercol","text-align: center;"),e.add(".scheduler_default_timeheadergroup_inner","position: absolute;left: 0px;right: 0px;top: 0px;bottom: 0px;border-right: 1px solid #c0c0c0;border-bottom: 1px solid #c0c0c0;"),e.add(".scheduler_default_timeheadercol_inner","position: absolute;left: 0px;right: 0px;top: 0px;bottom: 0px;border-right: 1px solid #c0c0c0;"),e.add(".scheduler_default_divider, .scheduler_default_splitter","background-color: #c0c0c0;"),e.add(".scheduler_default_divider_horizontal","background-color: #c0c0c0;"),e.add(".scheduler_default_matrix_vertical_line","background-color: #eee;"),e.add(".scheduler_default_matrix_vertical_break","background-color: #000;"),e.add(".scheduler_default_matrix_horizontal_line","background-color: #eee;"),e.add(".scheduler_default_resourcedivider","background-color: #c0c0c0;"),e.add(".scheduler_default_shadow_inner","background-color: #666666;opacity: 0.5;filter: alpha(opacity=50);height: 100%;"),e.add(".scheduler_default_event","font-size:12px;color:#333;"),e.add(".scheduler_default_event_inner","position:absolute;top:0px;left:0px;right:0px;bottom:0px;padding:5px 2px 2px 2px;overflow:hidden;border:1px solid #ccc;"),e.add(".scheduler_default_event_bar","top:0px;left:0px;right:0px;height:4px;background-color:#9dc8e8;"),e.add(".scheduler_default_event_bar_inner","position:absolute;height:4px;background-color:#1066a8;"),e.add(".scheduler_default_event_inner",'background:#fff;background: -webkit-gradient(linear, left top, left bottom, from(#ffffff), to(#eeeeee));background: -webkit-linear-gradient(top, #ffffff 0%, #eeeeee);background: -moz-linear-gradient(top, #ffffff 0%, #eeeeee);background: -ms-linear-gradient(top, #ffffff 0%, #eeeeee);background: -o-linear-gradient(top, #ffffff 0%, #eeeeee);background: linear-gradient(top, #ffffff 0%, #eeeeee);filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr="#ffffff", endColorStr="#eeeeee");'),e.add(".scheduler_default_event_float_inner","padding:6px 2px 2px 8px;"),e.add(".scheduler_default_event_float_inner:after",'content:"";border-color: transparent #666 transparent transparent;border-style:solid;border-width:5px;width:0;height:0;position:absolute;top:8px;left:-4px;'),e.add(".scheduler_default_columnheader_inner","font-weight: bold;"),e.add(".scheduler_default_columnheader_splitter","box-sizing: border-box; border-right: 1px solid #c0c0c0;"),e.add(".scheduler_default_columnheader_splitter:hover","background-color: #c0c0c0;"),e.add(".scheduler_default_columnheader_cell_inner","padding: 2px;"),e.add(".scheduler_default_cell","background-color: #f9f9f9;"),e.add(".scheduler_default_cell.scheduler_default_cell_business","background-color: #fff;"),e.add(".scheduler_default_cell.scheduler_default_cell_business.scheduler_default_cell_selected,.scheduler_default_cell.scheduler_default_cell_selected","background-color: #ccc;background-image: -webkit-gradient(linear, 0 100%, 100% 0,\tcolor-stop(.25, rgba(255, 255, 255, .2)), color-stop(.25, transparent),\tcolor-stop(.5, transparent), color-stop(.5, rgba(255, 255, 255, .2)), color-stop(.75, rgba(255, 255, 255, .2)), color-stop(.75, transparent), to(transparent));background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -moz-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -ms-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);-webkit-background-size: 20px 20px;-moz-background-size: 20px 20px;background-size: 20px 20px;"),e.add(".scheduler_default_tree_image_no_children","background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAIAAABv85FHAAAAKXRFWHRDcmVhdGlvbiBUaW1lAHDhIDMwIEkgMjAwOSAwODo0NjozMSArMDEwMClDkt4AAAAHdElNRQfZAR4HLzEyzsCJAAAACXBIWXMAAA7CAAAOwgEVKEqAAAAABGdBTUEAALGPC/xhBQAAADBJREFUeNpjrK6s5uTl/P75OybJ0NLW8h8bAIozgeSxAaA4E1A7VjmgOL31MeLxHwCeXUT0WkFMKAAAAABJRU5ErkJggg==);"),e.add(".scheduler_default_tree_image_expand","background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAIAAABv85FHAAAAKXRFWHRDcmVhdGlvbiBUaW1lAHDhIDMwIEkgMjAwOSAwODo0NjozMSArMDEwMClDkt4AAAAHdElNRQfZAR4HLyUoFBT0AAAACXBIWXMAAA7CAAAOwgEVKEqAAAAABGdBTUEAALGPC/xhBQAAAFJJREFUeNpjrK6s5uTl/P75OybJ0NLW8h8bAIozgeRhgJGREc4GijMBtTNgA0BxFog+uA4IA2gmUJwFog/IgUhAGBB9KPYhA3T74Jog+hjx+A8A1KRQ+AN5vcwAAAAASUVORK5CYII=);"),e.add(".scheduler_default_tree_image_collapse","background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAIAAABv85FHAAAAKXRFWHRDcmVhdGlvbiBUaW1lAHDhIDMwIEkgMjAwOSAwODo0NjozMSArMDEwMClDkt4AAAAHdElNRQfZAR4HLxB+p9DXAAAACXBIWXMAAA7CAAAOwgEVKEqAAAAABGdBTUEAALGPC/xhBQAAAENJREFUeNpjrK6s5uTl/P75OybJ0NLW8h8bAIozgeSxAaA4E1A7VjmgOAtEHyMjI7IE0EygOAtEH5CDqY9c+xjx+A8ANndK9WaZlP4AAAAASUVORK5CYII=);"),e.add(".scheduler_default_event_move_left",'box-sizing: border-box; padding:2px;border:1px solid #ccc;background:#fff;background: -webkit-gradient(linear, left top, left bottom, from(#ffffff), to(#eeeeee));background: -webkit-linear-gradient(top, #ffffff 0%, #eeeeee);background: -moz-linear-gradient(top, #ffffff 0%, #eeeeee);background: -ms-linear-gradient(top, #ffffff 0%, #eeeeee);background: -o-linear-gradient(top, #ffffff 0%, #eeeeee);background: linear-gradient(top, #ffffff 0%, #eeeeee);filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr="#ffffff", endColorStr="#eeeeee");'),e.add(".scheduler_default_event_move_right",'box-sizing: border-box; padding:2px;border:1px solid #ccc;background:#fff;background: -webkit-gradient(linear, left top, left bottom, from(#ffffff), to(#eeeeee));background: -webkit-linear-gradient(top, #ffffff 0%, #eeeeee);background: -moz-linear-gradient(top, #ffffff 0%, #eeeeee);background: -ms-linear-gradient(top, #ffffff 0%, #eeeeee);background: -o-linear-gradient(top, #ffffff 0%, #eeeeee);background: linear-gradient(top, #ffffff 0%, #eeeeee);filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr="#ffffff", endColorStr="#eeeeee");'),e.add(".scheduler_default_event_delete","background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAadEVYdFNvZnR3YXJlAFBhaW50Lk5FVCB2My41LjExR/NCNwAAAI5JREFUKFNtkLERgCAMRbmzdK8s4gAUlhYOYEHJEJYOYOEwDmGBPxC4kOPfvePy84MGR0RJ2N1A8H3N6DATwSQ57m2ql8NBG+AEM7D+UW+wjdfUPgerYNgB5gOLRHqhcasg84C2QxPMtrUhSqQIhg7ypy9VM2EUZPI/4rQ7rGxqo9sadTegw+UdjeDLAKUfhbaQUVPIfJYAAAAASUVORK5CYII=) center center no-repeat; opacity: 0.6; -ms-filter:'progid:DXImageTransform.Microsoft.Alpha(Opacity=60)';cursor: pointer;"),e.add(".scheduler_default_event_delete:hover","opacity: 1;-ms-filter: none;"),e.add(".scheduler_default_rowmove_handle","background-repeat: no-repeat; background-position: center center; background-color: #ccc; background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAKCAYAAACT+/8OAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAadEVYdFNvZnR3YXJlAFBhaW50Lk5FVCB2My41LjExR/NCNwAAAClJREFUGFdj+P//P4O9vX2Bg4NDP4gNFgBytgPxebgAMsYuQGMz/jMAAFsTZDPYJlDHAAAAAElFTkSuQmCC); cursor: move;"),e.add(".scheduler_default_rowmove_source","background-color: black; opacity: 0.2;"),e.add(".scheduler_default_rowmove_position_before, .scheduler_default_rowmove_position_after","background-color: #999; height: 2px;"),e.add(".scheduler_default_rowmove_position_child","margin-left: 10px; background-color: #999; height: 2px;"),e.add(".scheduler_default_rowmove_position_child:before","content: '+'; color: #999; position: absolute; top: -8px; left: -10px;"),e.add(".scheduler_default_rowmove_position_forbidden","background-color: red; height: 2px; margin-left: 10px;"),e.add(".scheduler_default_rowmove_position_forbidden:before","content: 'x'; color: red; position: absolute; top: -8px; left: -10px;"),e.add(".scheduler_default_link_horizontal","border-bottom-style: solid; border-bottom-color: red"),e.add(".scheduler_default_link_vertical","border-right-style: solid; border-right-color: red"),e.add(".scheduler_default_link_arrow_right:before","content: ''; border-width: 6px; border-color: transparent transparent transparent red; border-style: solid; width: 0px; height:0px; position: absolute;"),e.add(".scheduler_default_link_arrow_left:before","content: ''; border-width: 6px; border-color: transparent red transparent transparent; border-style: solid; width: 0px; height:0px; position: absolute;"),e.add(".scheduler_default_link_arrow_down:before","content: ''; border-width: 6px; border-color: red transparent transparent transparent; border-style: solid; width: 0px; height:0px; position: absolute;"),e.add(".scheduler_default_link_arrow_up:before","content: ''; border-width: 6px; border-color: transparent transparent red transparent; border-style: solid; width: 0px; height:0px; position: absolute;"),e.add(".scheduler_default_shadow_overlap .scheduler_default_shadow_inner","background-color: red;"),e.add(".scheduler_default_block","background-color: gray; opacity: 0.5; filter: alpha(opacity=50);"),e.add(".scheduler_default_main .scheduler_default_event_group","box-sizing: border-box; font-size:12px; color:#666; padding:4px 2px 2px 2px; overflow:hidden; border:1px solid #ccc; background-color: #fff;"),e.add(".scheduler_default_main .scheduler_default_header_icon","box-sizing: border-box; border: 1px solid #c0c0c0; background-color: #f5f5f5; color: #000;"),e.add(".scheduler_default_header_icon:hover","background-color: #ccc;"),e.add(".scheduler_default_header_icon_hide:before","content: '\\00AB';"),e.add(".scheduler_default_header_icon_show:before","content: '\\00BB';"),e.add(".scheduler_default_row_new .scheduler_default_rowheader_inner","padding-left: 10px; color: #666; cursor: text; background-position: 0px 5px; background-repeat: no-repeat; background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABUSURBVChTY0ACslAaK2CC0iCQDMSlECYmQFYIAl1AjFUxukIQwKoYm0IQwFCMSyEIaEJpMMClcD4Qp0CYEIBNIUzRPzAPCtAVYlWEDgyAGIdTGBgAbqEJYyjqa3oAAAAASUVORK5CYII=);"),e.add(".scheduler_default_row_new .scheduler_default_rowheader_inner:hover","background: white; color: white;"),e.add(".scheduler_default_rowheader textarea","padding: 3px;"),e.add(".scheduler_default_rowheader_scroll","cursor: default;"),DayPilot.browser.webkit,e.add(".scheduler_default_shadow_forbidden .scheduler_default_shadow_inner","background-color: red;"),e.add(".scheduler_default_event_moving_source","opacity: 0.5; filter: alpha(opacity=50);"),e.add(".scheduler_default_linkpoint","background-color: white; border: 1px solid gray; border-radius: 5px;"),e.add(".scheduler_default_linkpoint.scheduler_default_linkpoint_hover","background-color: black;"),e.add(".scheduler_default_event.scheduler_default_event_version .scheduler_default_event_inner","background-color: #cfdde8;background-image: -webkit-gradient(linear, 0 100%, 100% 0,\tcolor-stop(.25, rgba(255, 255, 255, .2)), color-stop(.25, transparent),\tcolor-stop(.5, transparent), color-stop(.5, rgba(255, 255, 255, .2)), color-stop(.75, rgba(255, 255, 255, .2)), color-stop(.75, transparent), to(transparent));background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -moz-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -ms-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);-webkit-background-size: 20px 20px;-moz-background-size: 20px 20px;background-size: 20px 20px;"),e.add(".scheduler_default_crosshair_vertical, .scheduler_default_crosshair_horizontal, .scheduler_default_crosshair_left, .scheduler_default_crosshair_top","background-color: gray; opacity: 0.2; filter: alpha(opacity=20)"),
e.add(".gantt_default_selected .gantt_default_event_inner","background: #ddd;"),e.add(".gantt_default_main","border: 1px solid #c0c0c0;font-family: Tahoma, Arial, Helvetica, sans-serif; font-size: 12px;"),e.add(".gantt_default_main *, .gantt_default_main *:before, .gantt_default_main *:after","box-sizing: content-box;"),e.add(".gantt_default_timeheader","cursor: default;color: #666;"),e.add(".gantt_default_message","opacity: 0.9;filter: alpha(opacity=90);padding: 10px; color: #ffffff;background: #ffa216;"),e.add(".gantt_default_timeheadergroup,.gantt_default_timeheadercol","color: #333;background: #f3f3f3;"),e.add(".gantt_default_rowheader,.gantt_default_corner","color: #333;background: #f3f3f3;"),e.add(".gantt_default_rowheader.gantt_default_rowheader_selected","background-color: #aaa;background-image: -webkit-gradient(linear, 0 100%, 100% 0,color-stop(.25, rgba(255, 255, 255, .2)), color-stop(.25, transparent),\tcolor-stop(.5, transparent), color-stop(.5, rgba(255, 255, 255, .2)), color-stop(.75, rgba(255, 255, 255, .2)), color-stop(.75, transparent), to(transparent));background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -moz-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -ms-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);-webkit-background-size: 20px 20px;-moz-background-size: 20px 20px;background-size: 20px 20px;"),e.add(".gantt_default_rowheader_inner","position: absolute;left: 0px;right: 0px;top: 0px;bottom: 0px;border-right: 1px solid #c0c0c0;padding: 2px;"),e.add(".gantt_default_timeheadergroup, .gantt_default_timeheadercol","text-align: center;"),e.add(".gantt_default_timeheadergroup_inner","position: absolute;left: 0px;right: 0px;top: 0px;bottom: 0px;border-right: 1px solid #aaa;border-bottom: 1px solid #aaa;"),e.add(".gantt_default_timeheadercol_inner","position: absolute;left: 0px;right: 0px;top: 0px;bottom: 0px;border-right: 1px solid #aaa;"),e.add(".gantt_default_divider, .gantt_default_splitter","background-color: #aaa;"),e.add(".gantt_default_divider_horizontal","background-color: #aaa;"),e.add(".gantt_default_matrix_vertical_line","background-color: #eee;"),e.add(".gantt_default_matrix_vertical_break","background-color: #000;"),e.add(".gantt_default_matrix_horizontal_line","background-color: #eee;"),e.add(".gantt_default_resourcedivider","background-color: #aaa;"),e.add(".gantt_default_shadow_inner","background-color: #666666;opacity: 0.5;filter: alpha(opacity=50);height: 100%;"),e.add(".gantt_default_event","font-size:12px;color:#666;"),e.add(".gantt_default_event_inner","position:absolute;top:0px;left:0px;right:0px;bottom:0px;padding:5px 2px 2px 2px;overflow:hidden;border:1px solid #ccc;"),e.add(".gantt_default_event_bar","top:0px;left:0px;right:0px;height:4px;background-color:#9dc8e8;"),e.add(".gantt_default_event_bar_inner","position:absolute;height:4px;background-color:#1066a8;"),e.add(".gantt_default_event_inner",'background:#fff;background: -webkit-gradient(linear, left top, left bottom, from(#ffffff), to(#eeeeee));background: -webkit-linear-gradient(top, #ffffff 0%, #eeeeee);background: -moz-linear-gradient(top, #ffffff 0%, #eeeeee);background: -ms-linear-gradient(top, #ffffff 0%, #eeeeee);background: -o-linear-gradient(top, #ffffff 0%, #eeeeee);background: linear-gradient(top, #ffffff 0%, #eeeeee);filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr="#ffffff", endColorStr="#eeeeee");'),e.add(".gantt_default_event_float_inner","padding:6px 2px 2px 8px;"),e.add(".gantt_default_event_float_inner:after",'content:"";border-color: transparent #666 transparent transparent;border-style:solid;border-width:5px;width:0;height:0;position:absolute;top:8px;left:-4px;'),e.add(".gantt_default_columnheader_inner","font-weight: bold;"),e.add(".gantt_default_columnheader_splitter","background-color: #666;opacity: 0.5;filter: alpha(opacity=50);"),e.add(".gantt_default_columnheader_cell_inner","padding: 2px;"),e.add(".gantt_default_cell","background-color: #f9f9f9;"),e.add(".gantt_default_cell.gantt_default_cell_business","background-color: #fff;"),e.add(".gantt_default_cell.gantt_default_cell_business.gantt_default_cell_selected,.gantt_default_cell.gantt_default_cell_selected","background-color: #ccc;background-image: -webkit-gradient(linear, 0 100%, 100% 0,\tcolor-stop(.25, rgba(255, 255, 255, .2)), color-stop(.25, transparent),\tcolor-stop(.5, transparent), color-stop(.5, rgba(255, 255, 255, .2)), color-stop(.75, rgba(255, 255, 255, .2)), color-stop(.75, transparent), to(transparent));background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -moz-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -ms-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);-webkit-background-size: 20px 20px;-moz-background-size: 20px 20px;background-size: 20px 20px;"),e.add(".gantt_default_tree_image_no_children","background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAIAAABv85FHAAAAKXRFWHRDcmVhdGlvbiBUaW1lAHDhIDMwIEkgMjAwOSAwODo0NjozMSArMDEwMClDkt4AAAAHdElNRQfZAR4HLzEyzsCJAAAACXBIWXMAAA7CAAAOwgEVKEqAAAAABGdBTUEAALGPC/xhBQAAADBJREFUeNpjrK6s5uTl/P75OybJ0NLW8h8bAIozgeSxAaA4E1A7VjmgOL31MeLxHwCeXUT0WkFMKAAAAABJRU5ErkJggg==);"),e.add(".gantt_default_tree_image_expand","background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAIAAABv85FHAAAAKXRFWHRDcmVhdGlvbiBUaW1lAHDhIDMwIEkgMjAwOSAwODo0NjozMSArMDEwMClDkt4AAAAHdElNRQfZAR4HLyUoFBT0AAAACXBIWXMAAA7CAAAOwgEVKEqAAAAABGdBTUEAALGPC/xhBQAAAFJJREFUeNpjrK6s5uTl/P75OybJ0NLW8h8bAIozgeRhgJGREc4GijMBtTNgA0BxFog+uA4IA2gmUJwFog/IgUhAGBB9KPYhA3T74Jog+hjx+A8A1KRQ+AN5vcwAAAAASUVORK5CYII=);"),e.add(".gantt_default_tree_image_collapse","background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAIAAABv85FHAAAAKXRFWHRDcmVhdGlvbiBUaW1lAHDhIDMwIEkgMjAwOSAwODo0NjozMSArMDEwMClDkt4AAAAHdElNRQfZAR4HLxB+p9DXAAAACXBIWXMAAA7CAAAOwgEVKEqAAAAABGdBTUEAALGPC/xhBQAAAENJREFUeNpjrK6s5uTl/P75OybJ0NLW8h8bAIozgeSxAaA4E1A7VjmgOAtEHyMjI7IE0EygOAtEH5CDqY9c+xjx+A8ANndK9WaZlP4AAAAASUVORK5CYII=);"),e.add(".gantt_default_event_move_left",'box-sizing: border-box; padding:2px;border:1px solid #ccc;background:#fff;background: -webkit-gradient(linear, left top, left bottom, from(#ffffff), to(#eeeeee));background: -webkit-linear-gradient(top, #ffffff 0%, #eeeeee);background: -moz-linear-gradient(top, #ffffff 0%, #eeeeee);background: -ms-linear-gradient(top, #ffffff 0%, #eeeeee);background: -o-linear-gradient(top, #ffffff 0%, #eeeeee);background: linear-gradient(top, #ffffff 0%, #eeeeee);filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr="#ffffff", endColorStr="#eeeeee");'),e.add(".gantt_default_event_move_right",'box-sizing: border-box; padding:2px;border:1px solid #ccc;background:#fff;background: -webkit-gradient(linear, left top, left bottom, from(#ffffff), to(#eeeeee));background: -webkit-linear-gradient(top, #ffffff 0%, #eeeeee);background: -moz-linear-gradient(top, #ffffff 0%, #eeeeee);background: -ms-linear-gradient(top, #ffffff 0%, #eeeeee);background: -o-linear-gradient(top, #ffffff 0%, #eeeeee);background: linear-gradient(top, #ffffff 0%, #eeeeee);filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr="#ffffff", endColorStr="#eeeeee");'),e.add(".gantt_default_event_delete","background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAadEVYdFNvZnR3YXJlAFBhaW50Lk5FVCB2My41LjExR/NCNwAAAI5JREFUKFNtkLERgCAMRbmzdK8s4gAUlhYOYEHJEJYOYOEwDmGBPxC4kOPfvePy84MGR0RJ2N1A8H3N6DATwSQ57m2ql8NBG+AEM7D+UW+wjdfUPgerYNgB5gOLRHqhcasg84C2QxPMtrUhSqQIhg7ypy9VM2EUZPI/4rQ7rGxqo9sadTegw+UdjeDLAKUfhbaQUVPIfJYAAAAASUVORK5CYII=) center center no-repeat; opacity: 0.6; -ms-filter:'progid:DXImageTransform.Microsoft.Alpha(Opacity=60)';cursor: pointer;"),e.add(".gantt_default_event_delete:hover","opacity: 1;-ms-filter: none;"),e.add(".gantt_default_rowmove_handle","background-repeat: no-repeat; background-position: center center; background-color: #ccc; background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAKCAYAAACT+/8OAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAadEVYdFNvZnR3YXJlAFBhaW50Lk5FVCB2My41LjExR/NCNwAAAClJREFUGFdj+P//P4O9vX2Bg4NDP4gNFgBytgPxebgAMsYuQGMz/jMAAFsTZDPYJlDHAAAAAElFTkSuQmCC); cursor: move;"),e.add(".gantt_default_rowmove_source","background-color: black; opacity: 0.2;"),e.add(".gantt_default_rowmove_position_before, .gantt_default_rowmove_position_after","background-color: #999; height: 2px;"),e.add(".gantt_default_rowmove_position_child","margin-left: 10px; background-color: #999; height: 2px;"),e.add(".gantt_default_rowmove_position_child:before","content: '+'; color: #999; position: absolute; top: -8px; left: -10px;"),e.add(".gantt_default_rowmove_position_forbidden","background-color: red; height: 2px; margin-left: 10px;"),e.add(".gantt_default_rowmove_position_forbidden:before","content: 'x'; color: red; position: absolute; top: -8px; left: -10px;"),e.add(".gantt_default_task_group .gantt_default_event_inner","position:absolute;top:5px;left:0px;right:0px;bottom:6px;overflow:hidden; background: #1155cc; filter: none; border: 0px none;"),e.add(".gantt_default_task_group.gantt_default_event:before","content:''; border-color: transparent transparent transparent #1155cc; border-style: solid; border-width: 6px; position: absolute; bottom: 0px;");e.add(".gantt_default_task_group.gantt_default_event:after","content:''; border-color: transparent #1155cc transparent transparent; border-style: solid; border-width: 6px; position: absolute; bottom: 0px; right: 0px;");e.add(".gantt_default_task_milestone .gantt_default_event_inner","position:absolute;top:16%;left:16%;right:16%;bottom:16%; background: #38761d; border: 0px none; -webkit-transform: rotate(45deg);-moz-transform: rotate(45deg);-ms-transform: rotate(45deg);-o-transform: rotate(45deg); transform: rotate(45deg); filter: none;"),e.add(".gantt_default_browser_ie8 .gantt_default_task_milestone .gantt_default_event_inner","-ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(SizingMethod='auto expand', M11=0.7071067811865476, M12=-0.7071067811865475, M21=0.7071067811865475, M22=0.7071067811865476);\""),e.add(".gantt_default_event_left","white-space: nowrap; padding-top: 5px; color: #666; cursor: default;"),e.add(".gantt_default_event_right","white-space: nowrap; padding-top: 5px; color: #666; cursor: default;"),e.add(".gantt_default_link_horizontal","border-bottom-style: solid; border-bottom-color: red;"),e.add(".gantt_default_link_vertical","border-right-style: solid; border-right-color: red;"),e.add(".gantt_default_link_arrow_right:before","content: ''; border-width: 6px; border-color: transparent transparent transparent red; border-style: solid; width: 0px; height:0px; position: absolute;"),e.add(".gantt_default_link_arrow_left:before","content: ''; border-width: 6px; border-color: transparent red transparent transparent; border-style: solid; width: 0px; height:0px; position: absolute;"),e.add(".gantt_default_link_arrow_down:before","content: ''; border-width: 6px; border-color: red transparent transparent transparent; border-style: solid; width: 0px; height:0px; position: absolute;"),e.add(".gantt_default_link_arrow_up:before","content: ''; border-width: 6px; border-color: transparent transparent red transparent; border-style: solid; width: 0px; height:0px; position: absolute;"),e.add(".gantt_default_shadow_overlap .gantt_default_shadow_inner","background-color: red;"),e.add(".gantt_default_block","background-color: gray; opacity: 0.5; filter: alpha(opacity=50);"),e.add(".gantt_default_link_hover","box-shadow: 0px 0px 2px 2px rgba(255, 0, 0, 0.3)"),e.add(".gantt_default_main .gantt_default_header_icon","box-sizing: border-box; border: 1px solid #aaa; background-color: #f5f5f5; color: #000;"),e.add(".gantt_default_header_icon:hover","background-color: #ccc;"),e.add(".gantt_default_header_icon_hide:before","content: '\\00AB';"),e.add(".gantt_default_header_icon_show:before","content: '\\00BB';"),e.add(".gantt_default_row_new .gantt_default_rowheader_inner","cursor: text; background-position: 0 50%; background-repeat: no-repeat; background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABUSURBVChTY0ACslAaK2CC0iCQDMSlECYmQFYIAl1AjFUxukIQwKoYm0IQwFCMSyEIaEJpMMClcD4Qp0CYEIBNIUzRPzAPCtAVYlWEDgyAGIdTGBgAbqEJYyjqa3oAAAAASUVORK5CYII=);"),e.add(".gantt_default_row_new .gantt_default_rowheader_inner:hover","background: white;"),e.add(".gantt_default_rowheader textarea","padding: 5px;"),e.add(".gantt_default_rowheader_scroll","cursor: default;"),e.add(".gantt_default_shadow_forbidden .gantt_default_shadow_inner","background-color: red;"),e.add(".gantt_default_event_moving_source","opacity: 0.5; filter: alpha(opacity=50);"),e.add(".gantt_default_event.gantt_default_event_version .gantt_default_event_inner","background-color: #cfdde8;background-image: -webkit-gradient(linear, 0 100%, 100% 0,\tcolor-stop(.25, rgba(255, 255, 255, .2)), color-stop(.25, transparent),\tcolor-stop(.5, transparent), color-stop(.5, rgba(255, 255, 255, .2)), color-stop(.75, rgba(255, 255, 255, .2)), color-stop(.75, transparent), to(transparent));background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -moz-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -ms-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);-webkit-background-size: 20px 20px;-moz-background-size: 20px 20px;background-size: 20px 20px;"),e.add(".gantt_default_task_group.gantt_default_event_continueleft.gantt_default_event:before","border:0;"),e.add(".gantt_default_task_group.gantt_default_event_continueleft.gantt_default_event .gantt_default_event_inner:before",'content:"";border-color: transparent #fff transparent transparent;border-style:solid;border-width:5px;width:0;height:0;position:absolute;top:2px;left:-4px;'),e.add(".gantt_default_event_continueleft.gantt_default_event .gantt_default_event_inner","padding-left: 8px;"),e.add(".gantt_default_event_continueleft.gantt_default_event .gantt_default_event_inner:before",'content:"";border-color: transparent #000 transparent transparent;border-style:solid;border-width:5px;width:0;height:0;position:absolute;top:7px;left:-4px;'),e.add(".gantt_default_task_group.gantt_default_event_continueright.gantt_default_event:after","border:0;"),e.add(".gantt_default_task_group.gantt_default_event_continueright.gantt_default_event .gantt_default_event_inner:after",'content:"";border-color: transparent transparent transparent #fff;border-style:solid;border-width:5px;width:0;height:0;position:absolute;top:2px;right:-2px;'),e.add(".gantt_default_event_continueright.gantt_default_event .gantt_default_event_inner","padding-right: 8px;"),e.add(".gantt_default_event_continueright.gantt_default_event .gantt_default_event_inner:after",'content:"";border-color: transparent transparent transparent #000;border-style:solid;border-width:5px;width:0;height:0;position:absolute;top:7px;right:-2px;'),e.add(".gantt_default_linkpoint","background-color: white; border: 1px solid gray; border-radius: 5px;"),e.add(".gantt_default_linkpoint.gantt_default_linkpoint_hover","background-color: black;"),e.add(".gantt_default_crosshair_vertical, .gantt_default_crosshair_horizontal, .gantt_default_crosshair_left, .gantt_default_crosshair_top","background-color: gray; opacity: 0.2; filter: alpha(opacity=20)"),e.add(".kanban_default_main *, .kanban_default_main *:before, .kanban_default_main *:after","box-sizing: content-box;"),e.add(".kanban_default_main","box-sizing: content-box; border: 1px solid #c0c0c0;font-family: Tahoma, Arial, Helvetica, sans-serif; font-size: 12px;"),e.add(".kanban_default_selected .kanban_default_event_inner","background: #ddd;"),e.add(".kanban_default_timeheader","cursor: default;color: #333;"),e.add(".kanban_default_message","opacity: 0.9;filter: alpha(opacity=90);padding: 10px; color: #ffffff;background: #ffa216;"),e.add(".kanban_default_colheadercell","color: #333;background: #f3f3f3;"),e.add(".kanban_default_rowheader,.kanban_default_corner","color: #333;background: #f3f3f3;"),e.add(".kanban_default_rowheader.kanban_default_rowheader_selected","background-color: #aaa;background-image: -webkit-gradient(linear, 0 100%, 100% 0,color-stop(.25, rgba(255, 255, 255, .2)), color-stop(.25, transparent),\tcolor-stop(.5, transparent), color-stop(.5, rgba(255, 255, 255, .2)), color-stop(.75, rgba(255, 255, 255, .2)), color-stop(.75, transparent), to(transparent));background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -moz-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -ms-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);-webkit-background-size: 20px 20px;-moz-background-size: 20px 20px;background-size: 20px 20px;"),e.add(".kanban_default_rowheader_inner","position: absolute;left: 0px;right: 0px;top: 0px;bottom: 0px;border-right: 1px solid #f3f3f3;padding: 2px;"),e.add(".kanban_default_colheadercell","text-align: center;"),e.add(".kanban_default_colheadercell_inner","position: absolute;left: 0px;right: 0px;top: 0px;bottom: 0px;border-right: 1px solid #c0c0c0;"),e.add(".kanban_default_divider, .kanban_default_splitter","background-color: #c0c0c0;"),e.add(".kanban_default_divider_horizontal","background-color: #c0c0c0;"),e.add(".kanban_default_matrix_vertical_line","background-color: #eee;"),e.add(".kanban_default_matrix_vertical_break","background-color: #000;"),e.add(".kanban_default_matrix_horizontal_line","background-color: #eee;"),e.add(".kanban_default_rowheaderdivider","background-color: #c0c0c0;"),e.add(".kanban_default_shadow_inner","background-color: #666666;opacity: 0.5;filter: alpha(opacity=50);height: 100%;"),e.add(".kanban_default_card","font-size:12px;color:#333;"),e.add(".kanban_default_card_inner","position:absolute;top:0px;left:0px;right:0px;bottom:0px;padding:5px 2px 2px 2px;overflow:hidden;border:1px solid #ccc;"),e.add(".kanban_default_card_inner",'background:#fff;background: -webkit-gradient(linear, left top, left bottom, from(#ffffff), to(#eeeeee));background: -webkit-linear-gradient(top, #ffffff 0%, #eeeeee);background: -moz-linear-gradient(top, #ffffff 0%, #eeeeee);background: -ms-linear-gradient(top, #ffffff 0%, #eeeeee);background: -o-linear-gradient(top, #ffffff 0%, #eeeeee);background: linear-gradient(top, #ffffff 0%, #eeeeee);filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr="#ffffff", endColorStr="#eeeeee");'),e.add(".kanban_default_cell","background-color: #fff;"),e.add(".kanban_default_cell.kanban_default_cell_selected","background-color: #ccc;background-image: -webkit-gradient(linear, 0 100%, 100% 0,\tcolor-stop(.25, rgba(255, 255, 255, .2)), color-stop(.25, transparent),\tcolor-stop(.5, transparent), color-stop(.5, rgba(255, 255, 255, .2)), color-stop(.75, rgba(255, 255, 255, .2)), color-stop(.75, transparent), to(transparent));background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -moz-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -ms-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);background-image: linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);-webkit-background-size: 20px 20px;-moz-background-size: 20px 20px;background-size: 20px 20px;"),e.add(".kanban_default_tree_image_no_children","background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAIAAABv85FHAAAAKXRFWHRDcmVhdGlvbiBUaW1lAHDhIDMwIEkgMjAwOSAwODo0NjozMSArMDEwMClDkt4AAAAHdElNRQfZAR4HLzEyzsCJAAAACXBIWXMAAA7CAAAOwgEVKEqAAAAABGdBTUEAALGPC/xhBQAAADBJREFUeNpjrK6s5uTl/P75OybJ0NLW8h8bAIozgeSxAaA4E1A7VjmgOL31MeLxHwCeXUT0WkFMKAAAAABJRU5ErkJggg==);"),e.add(".kanban_default_tree_image_expand","background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAIAAABv85FHAAAAKXRFWHRDcmVhdGlvbiBUaW1lAHDhIDMwIEkgMjAwOSAwODo0NjozMSArMDEwMClDkt4AAAAHdElNRQfZAR4HLyUoFBT0AAAACXBIWXMAAA7CAAAOwgEVKEqAAAAABGdBTUEAALGPC/xhBQAAAFJJREFUeNpjrK6s5uTl/P75OybJ0NLW8h8bAIozgeRhgJGREc4GijMBtTNgA0BxFog+uA4IA2gmUJwFog/IgUhAGBB9KPYhA3T74Jog+hjx+A8A1KRQ+AN5vcwAAAAASUVORK5CYII=);"),e.add(".kanban_default_tree_image_collapse","background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAIAAABv85FHAAAAKXRFWHRDcmVhdGlvbiBUaW1lAHDhIDMwIEkgMjAwOSAwODo0NjozMSArMDEwMClDkt4AAAAHdElNRQfZAR4HLxB+p9DXAAAACXBIWXMAAA7CAAAOwgEVKEqAAAAABGdBTUEAALGPC/xhBQAAAENJREFUeNpjrK6s5uTl/P75OybJ0NLW8h8bAIozgeSxAaA4E1A7VjmgOAtEHyMjI7IE0EygOAtEH5CDqY9c+xjx+A8ANndK9WaZlP4AAAAASUVORK5CYII=);"),e.add(".kanban_default_card_delete","background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAadEVYdFNvZnR3YXJlAFBhaW50Lk5FVCB2My41LjExR/NCNwAAAI5JREFUKFNtkLERgCAMRbmzdK8s4gAUlhYOYEHJEJYOYOEwDmGBPxC4kOPfvePy84MGR0RJ2N1A8H3N6DATwSQ57m2ql8NBG+AEM7D+UW+wjdfUPgerYNgB5gOLRHqhcasg84C2QxPMtrUhSqQIhg7ypy9VM2EUZPI/4rQ7rGxqo9sadTegw+UdjeDLAKUfhbaQUVPIfJYAAAAASUVORK5CYII=) center center no-repeat; opacity: 0.6; -ms-filter:'progid:DXImageTransform.Microsoft.Alpha(Opacity=60)';cursor: pointer;"),e.add(".kanban_default_card_delete:hover","opacity: 1;-ms-filter: none;"),e.add(".kanban_default_rowmove_source","background-color: black; opacity: 0.2;"),e.add(".kanban_default_rowmove_position_before, .kanban_default_rowmove_position_after","background-color: #999; height: 2px;"),e.add(".kanban_default_rowmove_position_forbidden","background-color: red; height: 2px; margin-left: 10px;"),e.add(".kanban_default_rowmove_position_forbidden:before","content: 'x'; color: red; position: absolute; top: -8px; left: -10px;"),e.add(".kanban_default_block","background-color: gray; opacity: 0.5; filter: alpha(opacity=50);"),e.add(".kanban_default_main .kanban_default_header_icon","box-sizing: border-box; border: 1px solid #aaa; background-color: #f5f5f5; color: #000;"),e.add(".kanban_default_header_icon:hover","background-color: #ccc;"),e.add(".kanban_default_header_icon_hide:before","content: '\\00AB';"),e.add(".kanban_default_header_icon_show:before","content: '\\00BB';"),e.add(".kanban_default_row_new .kanban_default_rowheader_inner","cursor: text; background-position: 0px 5px; background-repeat: no-repeat; background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABUSURBVChTY0ACslAaK2CC0iCQDMSlECYmQFYIAl1AjFUxukIQwKoYm0IQwFCMSyEIaEJpMMClcD4Qp0CYEIBNIUzRPzAPCtAVYlWEDgyAGIdTGBgAbqEJYyjqa3oAAAAASUVORK5CYII=);"),e.add(".kanban_default_row_new .kanban_default_rowheader_inner:hover","background: white;"),e.add(".kanban_default_rowheader textarea","padding: 3px;"),e.add(".kanban_default_rowheader_scroll","cursor: default;"),e.add(".kanban_default_card_moving_source","opacity: 0.5; filter: alpha(opacity=50);"),e.add(".kanban_default_card .kanban_default_card_inner","padding: 5px 5px 5px 10px;"),e.add(".kanban_default_cell","background-color: #fff;"),e.add(".kanban_default_rowmove_handle","opacity: 0.5; background-repeat: no-repeat; background-position: center center; background-color: #ccc; background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAKCAYAAACT+/8OAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAadEVYdFNvZnR3YXJlAFBhaW50Lk5FVCB2My41LjExR/NCNwAAAClJREFUGFdj+P//P4O9vX2Bg4NDP4gNFgBytgPxebgAMsYuQGMz/jMAAFsTZDPYJlDHAAAAAElFTkSuQmCC); cursor: move;"),e.add(".kanban_default_card_header","font-size: 120%; font-weight: bold;"),e.add(".kanban_default_card_bar","background-color: #cc0000; cursor:move;"),e.add(".kanban_default_cell.kanban_default_collapsed","background-color: #eee;"),e.add(".kanban_default_swimlane_collapse","cursor:pointer; border: 1px solid #ccc; text-align:center;"),e.add(".kanban_default_swimlane_collapse:before","content: '^';"),e.add(".kanban_default_swimlane_expand","cursor:pointer; border: 1px solid #ccc; text-align:center;"),e.add(".kanban_default_swimlane_expand:before","content: '>';"),e.add(".kanban_default_columnmove_handle","opacity: 0.5; background-repeat: no-repeat; background-position: center center; background-color: #ccc; background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAKCAYAAACT+/8OAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAadEVYdFNvZnR3YXJlAFBhaW50Lk5FVCB2My41LjExR/NCNwAAAClJREFUGFdj+P//P4O9vX2Bg4NDP4gNFgBytgPxebgAMsYuQGMz/jMAAFsTZDPYJlDHAAAAAElFTkSuQmCC); cursor: move;"),e.add(".kanban_default_columnmove_position","background-color: #333;"),e.add(".kanban_default_crosshair_vertical, .kanban_default_crosshair_horizontal, .kanban_default_crosshair_left, .kanban_default_crosshair_top","background-color: gray; opacity: 0.2; filter: alpha(opacity=20)"),e.commit(),DayPilot.Global.defaultCss=!0}}();var o=function(e){var t=this;this.id=e,this.widths=[],this.titles=[],this.height=null,this.splitterWidth=3,this.css={},this.css.title=null,this.css.titleInner=null,this.css.splitter=null,this.blocks=[],this.drag={},this.updated=function(){},this.updating=function(){},this.init=function(){var i;if(!e)throw"error: id not provided";if("string"==typeof e)i=document.getElementById(e);else{if(!e.appendChild)throw"error: invalid object provided";i=e}this.div=i,this.blocks=[];for(var n=0;n<this.widths.length;n++){var a=document.createElement("div");a.style.display="inline-block",null!==t.height?a.style.height=t.height+"px":a.style.height="100%",a.style.width=this.widths[n]-this.splitterWidth+"px",a.style.overflow="hidden",a.style.verticalAlign="top",a.style.position="relative",a.setAttribute("unselectable","on"),a.className=this.css.title,i.appendChild(a);var o=document.createElement("div");o.innerHTML=this.titles[n],o.setAttribute("unselectable","on"),o.className=this.css.titleInner,a.appendChild(o);var r=document.createElement("div");r.style.display="inline-block",null!==t.height?r.style.height=t.height+"px":r.style.height="100%",r.style.width=this.splitterWidth+"px",r.style.position="relative",r.appendChild(document.createElement("div")),r.style.cursor="col-resize",r.setAttribute("unselectable","on"),r.className=this.css.splitter;var s={};s.index=n,s.width=this.widths[n],r.data=s,r.onmousedown=function(e){t.drag.start=DayPilot.page(e),t.drag.data=this.data,t.div.style.cursor="col-resize",e=e||window.event,e.preventDefault?e.preventDefault():e.returnValue=!1},i.appendChild(r);var l={};l.section=a,l.handle=r,this.blocks.push(l)}this.registerGlobalHandlers()},this.updateWidths=function(){for(var e=0;e<this.blocks.length;e++){var t=this.blocks[e],i=this.widths[e];t.handle.data.width=i,this.m(e)}},this.m=function(e){var t=this.blocks[e],i=this.widths[e];t.section.style.width=i-this.splitterWidth+"px"},this.totalWidth=function(){for(var e=0,t=0;t<this.widths.length;t++)e+=this.widths[t];return e},this.gMouseMove=function(e){if(t.drag.start){var i=t.drag.data,n=DayPilot.page(e),a=n.x-t.drag.start.x,o=i.index;t.widths[o]=Math.max(5,i.width+a),t.m(o);var r={};r.widths=this.widths,r.index=i.index,t.updating(r)}},this.gMouseUp=function(e){if(t.drag.start){t.drag.start=null,document.body.style.cursor="",t.div.style.cursor="";var i=t.drag.data;i.width=t.widths[i.index];var n={};n.widths=this.widths,n.index=i.index,t.updated(n)}},this.dispose=function(){DayPilot.list(this.blocks).each(function(e){e.handle.onmousedown=null,DayPilot.de(e.section),DayPilot.de(e.handle)}),this.unregisterGlobalHandlers()},this.registerGlobalHandlers=function(){DayPilot.re(document,"mousemove",this.gMouseMove),DayPilot.re(document,"mouseup",this.gMouseUp)},this.unregisterGlobalHandlers=function(){DayPilot.ue(document,"mousemove",this.gMouseMove),DayPilot.ue(document,"mouseup",this.gMouseUp)}};DayPilot.Splitter=o}}(),DayPilot.JSON={},function(){function e(e){return e<10?"0"+e:e}function t(e){return a.lastIndex=0,a.test(e)?'"'+e.replace(a,function(e){var t=s[e];return"string"==typeof t?t:"\\u"+("0000"+e.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+e+'"'}function i(e,n){var a,s,d,c,h,u=o,f=n[e];switch(f&&"object"==typeof f&&"function"==typeof f.toJSON&&!f.ignoreToJSON&&(f=f.toJSON(e)),"function"==typeof l&&(f=l.call(n,e,f)),typeof f){
case"string":return t(f);case"number":return isFinite(f)?String(f):"null";case"boolean":case"null":return String(f);case"object":if(!f)return"null";if(o+=r,h=[],"number"==typeof f.length&&!f.propertyIsEnumerable("length")){for(c=f.length,a=0;a<c;a+=1)h[a]=i(a,f)||"null";return d=0===h.length?"[]":o?"[\n"+o+h.join(",\n"+o)+"\n"+u+"]":"["+h.join(",")+"]",o=u,d}if(l&&"object"==typeof l)for(c=l.length,a=0;a<c;a+=1)s=l[a],"string"==typeof s&&(d=i(s,f),d&&h.push(t(s)+(o?": ":":")+d));else for(s in f)Object.hasOwnProperty.call(f,s)&&(d=i(s,f),d&&h.push(t(s)+(o?": ":":")+d));return d=0===h.length?"{}":o?"{\n"+o+h.join(",\n"+o)+"\n"+u+"}":"{"+h.join(",")+"}",o=u,d}}"function"!=typeof Date.prototype.toJSON&&(Date.prototype.toJSON=function(){return isFinite(this.valueOf())?this.getUTCFullYear()+"-"+e(this.getUTCMonth()+1)+"-"+e(this.getUTCDate())+"T"+e(this.getUTCHours())+":"+e(this.getUTCMinutes())+":"+e(this.getUTCSeconds())+"Z":null}),"function"!=typeof String.prototype.toJSON&&(String.prototype.toJSON=Number.prototype.toJSON=Boolean.prototype.toJSON=function(e){return this.valueOf()});var n=/[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,a=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,o,r,s={"\b":"\\b","\t":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},l;DayPilot.JSON.stringify=function(e,t,n){if("undefined"!=typeof JSON&&JSON.stringify)return JSON.stringify(e,t,n);var a;if(o="",r="","number"==typeof n)for(a=0;a<n;a+=1)r+=" ";else"string"==typeof n&&(r=n);if(l=t,t&&"function"!=typeof t&&("object"!=typeof t||"number"!=typeof t.length))throw new Error("JSON.stringify");return i("",{"":e})},DayPilot.JSON.parse=function(e,t){function i(e,n){var a,o,r=e[n];if(r&&"object"==typeof r)for(a in r)Object.prototype.hasOwnProperty.call(r,a)&&(o=i(r,a),void 0!==o?r[a]=o:delete r[a]);return t.call(e,n,r)}var a;if(e=String(e),n.lastIndex=0,n.test(e)&&(e=e.replace(n,function(e){return"\\u"+("0000"+e.charCodeAt(0).toString(16)).slice(-4)})),/^[\],:{}\s]*$/.test(e.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,"@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:\s*\[)+/g,"")))return a=eval("("+e+")"),"function"==typeof t?i({"":a},""):a;throw new SyntaxError("JSON.parse")},"undefined"!=typeof Sys&&Sys.Application&&Sys.Application.notifyScriptLoaded&&Sys.Application.notifyScriptLoaded()}(),"undefined"==typeof DayPilot)var DayPilot={};if("undefined"==typeof DayPilot.Global&&(DayPilot.Global={}),function(){if("undefined"==typeof DayPilot.Bubble){var e={};e.mouseMove=function(t){if("undefined"!=typeof e){e.mouse=e.mousePosition(t);var i=e.active;if(i&&i.n.showPosition){var n=i.n.showPosition,a=e.mouse;n.clientX!==a.clientX||n.clientY!==a.clientY}}},e.touchPosition=function(e){if(!e||!e.touches)return null;var t=e.touches[0],i={};return i.x=t.pageX,i.y=t.pageY,i.clientX=t.clientX,i.clientY=t.clientY,i},e.mousePosition=function(e){var t=DayPilot.page(e);return e&&(t.clientY=e.clientY,t.clientX=e.clientX),t},DayPilot.Bubble=function(t){this.v="2911";var i=this,n={};if(this.cssOnly=!0,this.hideAfter=500,this.loadingText="Loading...",this.animated=!0,this.animation="fast",this.position="EventTop",this.hideOnClick=!0,this.showAfter=500,this.showLoadingLabel=!0,this.zIndex=10,this.theme="bubble_default",this.n=function(){},this.callBack=function(e){this.aspnet()?WebForm_DoCallback(this.uniqueID,DayPilot.JSON.stringify(e),this.updateView,this,this.callbackError,!0):e.calendar.internal.bubbleCallBack?e.calendar.internal.bubbleCallBack(e,this):e.calendar.bubbleCallBack(e,this)},this.callbackError=function(e,t){alert(e)},this.updateView=function(t,a){if(i!==a)throw"Callback object mismatch (internal error)";return t?(e.active=i,void(i&&(n.div&&(n.div.firstChild.innerHTML=t),i.adjustPosition(),i.animated||i.addShadow()))):(i.removeDiv(),void i.removeShadow())},this.init=function(){},this.aspnet=function(){return"undefined"!=typeof WebForm_DoCallback},this.rounded=function(){return"Rounded"===this.corners},this.showEvent=function(t,i){var n=new e.CallBackArgs(t.calendar||t.root,"Event",t,t.bubbleHtml?t.bubbleHtml():null);i?this.show(n):this.showOnMouseOver(n)},this.showCell=function(t){var i=new e.CallBackArgs(t.calendar||t.root,"Cell",t,t.staticBubbleHTML?t.staticBubbleHTML():null);this.showOnMouseOver(i)},this.showTime=function(t){var i=new e.CallBackArgs(t.calendar||t.root,"Time",t,t.staticBubbleHTML?t.staticBubbleHTML():null);this.showOnMouseOver(i)},this.showResource=function(t,i){if(!t instanceof DayPilot.Row)throw new DayPilot.Error("DayPilot.Row object expected");var n={};n.calendar=t.calendar,n.id=t.id,t.data&&t.data.bubbleHtml&&(n.bubbleHtml=function(){return t.data.bubbleHtml}),n.toJSON=function(){var e={};return e.id=this.id,e};var a=new e.CallBackArgs(n.calendar||n.root,"Resource",n,n.bubbleHtml?n.bubbleHtml():null);i?this.show(a):this.showOnMouseOver(a)},this.p=function(e){return{}},this.showHtml=function(t,i){var n=new e.CallBackArgs(null,"Html",null,t);n.div=i,this.show(n)},this.show=function(t){var a=this.animated;if(this.n.showPosition=e.mouse,!e.mouse)return void setTimeout(function(){i.show(t)},100);var o;try{o=DayPilot.JSON.stringify(t.object)}catch(e){return}if(!(e.active===this&&this.n.sourceId===o||"undefined"!=typeof DayPilot.Menu&&DayPilot.Menu.active)){i.cssOnly||(i.cssOnly=!0,DayPilot.Util.log("DayPilot: cssOnly = false mode is not supported since DayPilot Pro 8.0.")),e.hideActive(),e.active=this,this.n.sourceId=o;var r=document.createElement("div");r.setAttribute("unselectable","on"),r.style.position="absolute",this.showLoadingLabel||(r.style.display="none"),this.cssOnly?r.className=this.q("_main"):(this.width&&(r.style.width=this.width),r.style.cursor="default"),r.style.top="0px",r.style.left="0px",r.style.zIndex=this.zIndex+1,a&&(r.style.visibility="hidden"),this.hideOnClick&&(r.onclick=function(){e.hideActive()}),r.onmousemove=function(t){e.cancelTimeout();var t=t||window.event;t.cancelBubble=!0},r.oncontextmenu=function(){return!1},r.onmouseout=this.delayedHide;var s=document.createElement("div");r.appendChild(s),this.cssOnly?s.className=this.q("_main_inner"):(s.style.padding="4px",this.border&&(s.style.border=this.border),this.rounded()&&(s.style.MozBorderRadius="5px",s.style.webkitBorderRadius="5px",s.style.borderRadius="5px"),s.style.backgroundColor=this.backgroundColor),s.innerHTML=this.loadingText,document.body.appendChild(r),n.div=r;var r=this.getDiv(t);if("EventTop"===this.position&&r){var l=DayPilot.abs(r,!0);this.n.mouse=e.mouse,this.n.mouse.x=l.x,this.n.mouse.y=l.y,this.n.mouse.h=l.h+2,this.n.mouse.w=l.w}else this.n.mouse=e.mouse;if(this.showLoadingLabel&&!a&&(this.adjustPosition(),this.addShadow()),t.staticHTML&&"function"!=typeof this.onLoad)this.updateView(t.staticHTML,this);else if("function"==typeof this.onLoad){var d={};d.source=t.object,d.async=!1,d.html=t.staticHTML,d.loaded=function(){this.async&&i.updateView(d.html,i)},this.onLoad(d),d.async||i.updateView(d.html,i)}else this.r(t)&&this.callBack(t)}},this.getDiv=function(e){return e.div?e.div:"Event"===e.type&&e.calendar&&e.calendar.internal.findEventDiv?e.calendar.internal.findEventDiv(e.object):void 0},this.q=function(e){var t=this.theme||this.cssClassPrefix;return t?t+e:""},this.loadingElement=null,this.loadingStart=function(e){},this.loadingStop=function(){},this.adjustPosition=function(){var t=this.animated,a=this.position,o=10;if(n.div&&this.n.mouse){if(!this.n.mouse.x||!this.n.mouse.y)return void e.hideActive();var r=n.div;r.style.display="";var s=r.offsetHeight,l=r.offsetWidth;r.style.display="none";var d=DayPilot.wd(),c=d.width,h=d.height;if("Mouse"===a){var u=0;if(this.n.mouse.clientY>h-s+o){this.n.mouse.clientY-(h-s)+o;u=this.n.mouse.y-s-10}else u=this.n.mouse.y+22;if("number"==typeof u&&(r.style.top=Math.max(u,0)+"px"),this.n.mouse.clientX>c-l+o){var f=this.n.mouse.clientX-(c-l)+o;r.style.left=this.n.mouse.x-f+"px"}else r.style.left=this.n.mouse.x+"px"}else if("EventTop"===a){var v=2,u=this.n.mouse.y-s-v,p=d.scrollTop;u<p&&(u=this.n.mouse.y+this.n.mouse.h+v),"number"==typeof u&&(r.style.top=Math.max(u,0)+"px");var g=this.n.mouse.x;this.n.mouse.x+l+o>c&&(g=c-l-o),r.style.left=g+"px"}if(r.style.display="",t){r.style.display="";var m={};m.color=r.firstChild.style.color,m.overflow=r.style.overflow,r.firstChild.style.color="transparent",r.style.overflow="hidden",this.removeShadow(),DayPilot.pop(r,{"finished":function(){r.firstChild.style.color=m.color,r.style.overflow=m.overflow,i.addShadow()},"vertical":"bottom","horizontal":"left","animation":i.animation})}}},this.delayedHide=function(){e.cancelTimeout(),i.hideAfter>0&&(e.timeout=window.setTimeout(e.hideActive,i.hideAfter))},this.showOnMouseOver=function(t){e.cancelTimeout();var n=function(e){return function(){i.show(e)}};e.timeout=window.setTimeout(n(t),this.showAfter)},this.hideOnMouseOut=function(){this.delayedHide()},this.r=function(e){return!!e.calendar.backendUrl||!("function"!=typeof WebForm_DoCallback||!this.uniqueID)},this.addShadow=function(){if(this.useShadow&&!this.cssOnly&&n.div){var e=n.div;this.shadows&&this.shadows.length>0&&this.removeShadow(),this.shadows=[];for(var t=0;t<5;t++){var i=document.createElement("div");i.setAttribute("unselectable","on"),i.style.position="absolute",i.style.width=e.offsetWidth+"px",i.style.height=e.offsetHeight+"px",i.style.top=e.offsetTop+t+"px",i.style.left=e.offsetLeft+t+"px",i.style.zIndex=this.zIndex,i.style.filter="alpha(opacity:10)",i.style.opacity=.1,i.style.backgroundColor="#000000",this.rounded()&&(i.style.MozBorderRadius="5px",i.style.webkitBorderRadius="5px",i.style.borderRadius="5px"),document.body.appendChild(i),this.shadows.push(i)}}},this.removeShadow=function(){if(this.shadows){for(var e=0;e<this.shadows.length;e++)document.body.removeChild(this.shadows[e]);this.shadows=[]}},this.removeDiv=function(){n.div&&(document.body.removeChild(n.div),n.div=null)},t)for(var a in t)this[a]=t[a];this.init()},DayPilot.Bubble.touchPosition=function(t){t.touches&&(e.mouse=e.touchPosition(t))},e.cancelTimeout=function(){e.timeout&&window.clearTimeout(e.timeout)},e.hideActive=function(){e.cancelTimeout();var t=e.active;t&&(t.removeDiv(),t.removeShadow()),e.active=null},e.CallBackArgs=function(e,t,i,n){this.calendar=e,this.type=t,this.object=i,this.staticHTML=n,this.toJSON=function(){var e={};return e.uid=this.calendar.uniqueID,e.type=this.type,e.object=i,e}},DayPilot.re(document,"mousemove",e.mouseMove),DayPilot.Bubble.hideActive=e.hideActive,"undefined"!=typeof Sys&&Sys.Application&&Sys.Application.notifyScriptLoaded&&Sys.Application.notifyScriptLoaded()}}(),"undefined"==typeof DayPilot)var DayPilot={};if("undefined"==typeof DayPilot.Global&&(DayPilot.Global={}),function(){if("undefined"==typeof DayPilot.Calendar){DayPilot.Calendar=function(t,i){this.v="2911";var n=!1;if(this instanceof DayPilot.Calendar&&!this.s&&(n=!0,this.s=!0),!n)throw"DayPilot.Calendar() is a constructor and must be called as 'var c = new DayPilot.Calendar(id);'";var a=this;this.uniqueID=null,this.id=t,this.isCalendar=!0,this.api=2,this.clientName=t,this.clientState={},this.t={},this.t.pixels={},this.t.events=[],this.elements={},this.elements.events=[],this.elements.separators=[],this.nav={},this.events={},this.hideUntilInit=!0,this.u=!0,this.allDayEnd="DateTime",this.allDayEventHeight=25,this.allowMultiSelect=!0,this.autoRefreshCommand="refresh",this.autoRefreshEnabled=!1,this.autoRefreshInterval=60,this.autoRefreshMaxCount=20,this.backendUrl=null,this.borderColor="#000000","function"==typeof DayPilot.Bubble?(this.bubble=new DayPilot.Bubble,this.cellBubble=new DayPilot.Bubble,this.columnBubble=new DayPilot.Bubble):(this.bubble=null,this.cellBubble=null,this.columnBubble=null),this.businessBeginsHour=9,this.businessEndsHour=18,this.cellBackColor="#FFFFD5",this.cellBackColorNonBusiness="#FFF4BC",this.cellBorderColor="#999999",this.cellHeight=20,this.cellDuration=30,this.columnMarginRight=5,this.columns=null,this.columnWidth=200,this.columnWidthSpec="Auto",this.contextMenu=null,this.contextMenuSelection=null,this.cornerBackColor="#ECE9D8",this.cornerHtml="",this.crosshairColor="Gray",this.crosshairOpacity=20,this.crosshairType="Header",this.cssOnly=!0,this.dayBeginsHour=0,this.dayEndsHour=24,this.days=1,this.durationBarColor="blue",this.durationBarVisible=!0,this.durationBarWidth=5,this.durationBarImageUrl=null,this.eventArrangement="SideBySide",this.eventBackColor="#ffffff",this.eventBorderColor="#000000",this.eventFontFamily="Tahoma",this.eventFontSize="8pt",this.eventFontColor="#000000",this.eventSelectColor="blue",this.headerFontSize="10pt",this.headerFontFamily="Tahoma",this.headerFontColor="#000000",this.headerHeight=36,this.headerLevels=1,this.height=300,this.heightSpec="BusinessHours",this.hideFreeCells=!1,this.headerDateFormat=null,this.hourHalfBorderColor="#F3E4B1",this.hourBorderColor="#EAD098",this.hourFontColor="#000000",this.hourFontFamily="Tahoma",this.hourFontSize="16pt",this.hourNameBackColor="#ECE9D8",this.hourNameBorderColor="#ACA899",this.hourWidth=45,this.initScrollPos=null,this.loadingLabelText="Loading...",this.loadingLabelVisible=!0,this.loadingLabelBackColor="orange",this.loadingLabelFontColor="#ffffff",this.loadingLabelFontFamily="Tahoma",this.loadingLabelFontSize="10pt",this.locale="en-us",this.messageHideAfter=5e3,this.moveBy="Full",this.notifyCommit="Immediate",this.roundedCorners=!1,this.rtl=!1,this.scrollLabelsVisible=!1,this.selectedColor="#316AC5",this.shadow="Fill",this.showToolTip=!0,this.showAllDayEvents=!1,this.showAllDayEventStartEnd=!0,this.showEventStartEnd=!1,this.showHeader=!0,this.showHours=!0,this.showCurrentTime=!0,this.showCurrentTimeMode="Day",this.showCurrentTimeOffset=0,this.startDate=DayPilot.Date.today(),this.cssClassPrefix="calendar_default",this.tapAndHoldTimeout=300,this.theme=null,this.timeFormat="Auto",this.timeHeaderCellDuration=60,this.useEventBoxes="Always",this.viewType="Days",this.visible=!0,this.weekStarts=null,this.width=null,this.eventClickHandling="Enabled",this.eventDoubleClickHandling="Disabled",this.eventRightClickHandling="ContextMenu",this.eventDeleteHandling="Disabled",this.eventEditHandling="Update",this.eventHoverHandling="Bubble",this.eventResizeHandling="Update",this.eventMoveHandling="Update",this.eventSelectHandling="Update",this.eventTapAndHoldHandling="Move",this.headerClickHandling="Enabled",this.timeRangeTapAndHoldHandling="Select",this.timeRangeSelectedHandling="Enabled",this.timeRangeDoubleClickHandling="Enabled",this.timeRangeRightClickHandling="ContextMenu",this.onTimeRangeRightClick=null,this.onTimeRangeRightClicked=null,this.onEventFilter=null,this.onBeforeEventRender=null,this.onBeforeEventExport=null,this.onBeforeCellExport=null,this.onBeforeHeaderRender=null,this.onBeforeHeaderExport=null,this.onBeforeTimeHeaderRender=null,this.z=!0,this.A=!1,this.B=0,this.doubleClickTimeout=300,this.members={},this.members.obsolete=["Init","cleanSelection","cssClassPrefix","cssOnly","clientName","uniqueID"],this.members.ignore=["internal","nav","debug","temp","elements","members"],this.members.noCssOnly=["allDayEventBorderColor","allDayEventFontColor","allDayEventFontFamily","allDayEventFontSize","borderColor","cellBackColor","cellBackColorNonBusiness","cellBorderColor","cornerBackColor","durationBarColor","durationBarImageUrl","eventBackColor","eventBorderColor","eventFontColor","eventFontFamily","eventFontSize","eventSelectColor","headerFontColor","headerFontFamily","headerFontSize","hourBorderColor","hourFontColor","hourFontFamily","hourFontSize","hourHalfBorderColor","hourNameBackColor","hourNameBorderColor","loadingLabelBackColor","loadingLabelFontColor","loadingLabelFontFamily","loadingLabelFontSize","roundedCorners","selectedColor","shadow","useEventSelectionBars"],this.C={},this.C.ie=navigator&&navigator.userAgent&&navigator.userAgent.indexOf("MSIE")!==-1,this.C.ie9=navigator&&navigator.userAgent&&navigator.userAgent.indexOf("MSIE 9")!==-1,this.C.ielt9=function(){var e=document.createElement("div");return e.innerHTML="<!--[if lt IE 9]><i></i><![endif]-->",1===e.getElementsByTagName("i").length}(),this.C.ff=navigator&&navigator.userAgent&&navigator.userAgent.indexOf("Firefox")!==-1,this.C.opera105=function(){if(/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)){return new Number(RegExp.$1)>=10.5}return!1}(),this.C.webkit522=function(){if(/AppleWebKit[\/\s](\d+\.\d+)/.test(navigator.userAgent)){return new Number(RegExp.$1)>=522}return!1}(),this.clearSelection=function(){return this.selectedCells?(this.D(),void(this.selectedCells=[])):void(this.selectedCells=[])},this.D=function(){if(this.selectedCells)for(var e=0;e<this.selectedCells.length;e++){var t=this.selectedCells[e];t&&t.selected&&(t.removeChild(t.selected),t.firstChild.style.display="",t.selected=null)}},this.cleanSelection=this.clearSelection,this.E=function(e,t,i){var n={};n.action=e,n.parameters=i,n.data=t,n.header=this.F();var o="JSON"+DayPilot.JSON.stringify(n);__doPostBack(a.uniqueID,o)},this.G=function(e,t,i,n){if(!this.r())return void a.debug.message("Callback invoked without the server-side backend specified. Callback canceled.","warning");this.callbackTimeout&&window.clearTimeout(this.callbackTimeout),"undefined"==typeof n&&(n="CallBack"),this.callbackTimeout=window.setTimeout(function(){a.H()},100);var o={};o.action=e,o.type=n,o.parameters=t,o.data=i,o.header=this.F();var r="JSON"+DayPilot.JSON.stringify(o);this.backendUrl?DayPilot.request(this.backendUrl,this.I,r,this.J):"function"==typeof WebForm_DoCallback&&WebForm_DoCallback(this.uniqueID,r,this.K,this.clientName,this.onCallbackError,!0)},this.r=function(){return!!this.backendUrl||!("function"!=typeof WebForm_DoCallback||!this.uniqueID)},this.J=function(e){if("function"==typeof a.onAjaxError){var t={};t.request=e,a.onAjaxError(t)}else"function"==typeof a.ajaxError&&a.ajaxError(e)},this.dispose=function(){var t=a;t.nav.top&&(t.L(),t.M(),t.nav.messageClose&&(t.nav.messageClose.onclick=null),t.nav.hourTable&&(t.nav.hourTable.oncontextmenu=null),t.nav.hourTable&&(t.nav.hourTable.onmousemove=null),t.nav.header&&(t.nav.header.oncontextmenu=null),t.nav.corner&&(t.nav.corner.oncontextmenu=null),t.nav.zoom.onmousemove=null,t.nav.zoom.oncontextmenu=null,t.nav.scroll.onscroll=null,t.nav.scroll.root=null,DayPilot.pu(t.nav.loading),t.N(),t.O(),t.nav.select=null,t.nav.cornerRight=null,t.nav.scrollable=null,t.nav.bottomLeft=null,t.nav.bottomRight=null,t.nav.allday=null,t.nav.zoom=null,t.nav.loading=null,t.nav.events=null,t.nav.header=null,t.nav.hourTable=null,t.nav.scrolltop=null,t.nav.scroll=null,t.nav.vsph=null,t.nav.main=null,t.nav.message=null,t.nav.messageClose=null,t.nav.top.removeAttribute("style"),t.nav.top.removeAttribute("class"),t.nav.top.innerHTML="",t.nav.top.dp=null,t.nav.top=null,DayPilot.ue(window,"resize",t.P),e.unregister(t))},this.Q=function(){this.nav.top.dispose=this.dispose,window['\x65\x76\x61\x6c']("\x76\x61\x72\x20\x6c\x68\x3d\x6c\x6f\x63\x61\x74\x69\x6f\x6e\x2e\x68\x6f\x73\x74\x6e\x61\x6d\x65\x3b\x69\x66\x28\x21\x7e\x6c\x68\x2e\x69\x6e\x64\x65\x78\x4f\x66\x28\x27\x64\x61\x79\x70\x69\x6c\x6f\x74\x2e\x6f\x72\x67\x27\x29\x26\x26\x6c\x68\x21\x3d\x3d\x27\x6c\x6f\x63\x61\x6c\x68\x6f\x73\x74\x27\x29\x73\x65\x74\x54\x69\x6d\x65\x6f\x75\x74\x28\x66\x75\x6e\x63\x74\x69\x6f\x6e\x28\x29\x7b\x61\x6c\x65\x72\x74\x28\x27\x59\x6f\x75\x20\x61\x72\x65\x20\x75\x73\x69\x6e\x67\x20\x61\x20\x74\x72\x69\x61\x6c\x20\x76\x65\x72\x73\x69\x6f\x6e\x20\x6f\x66\x20\x44\x61\x79\x50\x69\x6c\x6f\x74\x20\x50\x72\x6f\x2e\x27\x29\x7d\x2c\x31\x30\x30\x30\x30\x30\x2a\x28\x4d\x61\x74\x68\x2e\x72\x61\x6e\x64\x6f\x6d\x28\x29\x2a\x36\x2b\x36\x29\x29\x3b");},this.I=function(e){a.K(e.responseText)},this.F=function(){var e={};return e.v=this.v,e.control="dpc",e.id=this.id,e.clientState=a.clientState,e.columns=this.R(),e.days=a.days,e.startDate=a.startDate,e.cellDuration=a.cellDuration,e.cssClassPrefix=a.cssClassPrefix,e.heightSpec=a.heightSpec,e.businessBeginsHour=a.businessBeginsHour,e.businessEndsHour=a.businessEndsHour,e.viewType=a.viewType,e.dayBeginsHour=a.dayBeginsHour,e.dayEndsHour=a.dayEndsHour,e.headerLevels=a.headerLevels,e.backColor=a.cellBackColor,e.nonBusinessBackColor=a.cellBackColorNonBusiness,e.eventHeaderVisible=a.eventHeaderVisible,e.timeFormat=a.timeFormat,e.timeHeaderCellDuration=a.timeHeaderCellDuration,e.locale=a.locale,e.scrollY=a.scrollPos,e.showAllDayEvents=a.showAllDayEvents,e.tagFields=a.tagFields,e.weekStarts=a.weekStarts,e.hourNameBackColor=a.hourNameBackColor,e.hourFontFamily=a.hourFontFamily,e.hourFontSize=a.hourFontSize,e.hourFontColor=a.hourFontColor,e.selected=a.multiselect.events(),e.hashes=a.hashes,e},this.S=function(){this.T(),DayPilot.Areas.hideAll()},this.R=function(){var e=[];if(e.ignoreToJSON=!0,!this.U)return e;for(var t=0;t<this.U.length;t++){var i=this.U[t],n=this.V(i);e.push(n)}return e},this.V=function(e){var t={};return t.Value=e.id,t.Name=e.name,t.ToolTip=e.toolTip,t.Date=e.start,t.Children=this.W(e.children),t},this.W=function(e){var t=[];if(t.ignoreToJSON=!0,!e)return t;for(var i=0;i<e.length;i++)t.push(this.V(e[i]));return t},this.K=function(e,t){var e=DayPilot.Util.parseJSON(e);if(e.BubbleGuid){var i=e.BubbleGuid,n=this.bubbles[i];return delete this.bubbles[i],a.X(),void("undefined"!=typeof e.Result.BubbleHTML&&n.updateView(e.Result.BubbleHTML,n))}if(e.CallBackRedirect)return void(document.location.href=e.CallBackRedirect);if("undefined"!=typeof e.ClientState&&(a.clientState=e.ClientState),"None"===e.UpdateType)return a.X(),a.Y(e.CallBackData,!0),void(e.Message&&a.message(e.Message));if(e.VsUpdate){var o=document.createElement("input");o.type="hidden",o.name=a.id+"_vsupdate",o.id=o.name,o.value=e.VsUpdate,a.nav.vsph.innerHTML="",a.nav.vsph.appendChild(o)}if(a.M(),a.multiselect.clear(!0),a.multiselect.Z=e.SelectedEvents,"undefined"!=typeof e.TagFields&&(a.tagFields=e.TagFields),"undefined"!=typeof e.SortDirections&&(a.sortDirections=e.SortDirections),"Full"===e.UpdateType&&(a.colors=e.Colors,a.palette=e.Palette,a.dirtyColors=e.DirtyColors,a.cellProperties=e.CellProperties,a.cellConfig=e.CellConfig,a.columns=e.Columns,a.days=e.Days,a.startDate=new DayPilot.Date(e.StartDate).getDatePart(),a.cellDuration=e.CellDuration,a.heightSpec=e.HeightSpec?e.HeightSpec:a.heightSpec,a.businessBeginsHour=e.BusinessBeginsHour?e.BusinessBeginsHour:a.businessBeginsHour,a.businessEndsHour=e.BusinessEndsHour?e.BusinessEndsHour:a.businessEndsHour,a.viewType=e.ViewType,a.headerLevels=e.HeaderLevels,a.backColor=e.BackColor?e.BackColor:a.backColor,a.nonBusinessBackColor=e.NonBusinessBackColor?e.NonBusinessBackColor:a.nonBusinessBackColor,a.eventHeaderVisible=e.EventHeaderVisible?e.EventHeaderVisible:a.eventHeaderVisible,a.timeFormat=e.TimeFormat?e.TimeFormat:a.timeFormat,a.timeHeaderCellDuration="undefined"!=typeof e.TimeHeaderCellDuration?e.TimeHeaderCellDuration:a.timeHeaderCellDuration,a.locale=e.Locale?e.Locale:a.locale,a.dayBeginsHour="undefined"!=typeof e.DayBeginsHour?e.DayBeginsHour:a.dayBeginsHour,a.dayEndsHour="undefined"!=typeof e.DayEndsHour?e.DayEndsHour:a.dayEndsHour,a.cornerBackColor=e.CornerBackColor,a.cornerHtml=e.CornerHTML,a.hours=e.Hours,a._(),a.aa()),e.Hashes)for(var r in e.Hashes)a.hashes[r]=e.Hashes[r];if(a.ba(e.Events),a.ca(),("Full"===e.UpdateType||a.hideFreeCells)&&(a.da(),a.ea(),a.fa(),a.ga(),a.ha(),a.ia(),a.ja(),a.ka(),a.clearSelection(),a.la(),"undefined"!=typeof e.ScrollY?a.scrollToY(e.ScrollY):a.scrollToY(a.initScrollPos)),a.ma(),a.na(),a.oa(),a.pa(),"Parent100Pct"===a.heightSpec&&a.P(),"HoldForever"!==a.timeRangeSelectedHandling&&a.clearSelection(),a.qa(),a.todo&&a.todo.del){var s=a.todo.del;s.parentNode.removeChild(s),a.todo.del=null}a.Y(e.CallBackData,!0),a.X(),a.ra(),e.Message&&a.message(e.Message)},this.Y=function(e,t){var i=function(e,t){return function(){if(a.sa()){if("function"==typeof a.onAfterRender){var i={};i.isCallBack=t,i.data=e,a.onAfterRender(i)}}else a.afterRender&&a.afterRender(e,t)}};window.setTimeout(i(e,t),0)},this.ta=function(e,t,i){var n=a.nav.events,o=n.clientWidth/n.rows[0].cells.length,r=Math.floor(a.coords.x/o);r<0&&(r=0),a.rtl&&(r=a.va.length-r-1);var s=n.rows[0].cells[r],l=0,d=0,c=0;if("undefined"!=typeof e.duration){var h=e.duration;c=Math.floor((a.coords.y-l+a.cellHeight/2)/a.cellHeight)*a.cellHeight+l,d=h*a.cellHeight/(60*a.cellDuration),d=Math.max(d,a.cellHeight)}else{var u=e.event;d=u.part.height,c=u.part.top}var f=document.createElement("div");f.setAttribute("unselectable","on"),f.style.position="absolute",f.style.width="100%",f.style.height=d+"px",f.style.left="0px",f.style.top=c+"px",f.style.zIndex=101,f.exclude=!0;var v=document.createElement("div");return f.appendChild(v),f.className=a.q("_shadow"),v.className=this.q("_shadow_inner"),s.events.appendChild(f),f},this.wa=function(){return this.xa()/36e5},this.ya=function(){return this.businessBeginsHour>this.businessEndsHour?24-this.businessBeginsHour+this.businessEndsHour:this.businessEndsHour-this.businessBeginsHour},this.za=function(){return this.dayBeginsHour>=this.dayEndsHour?24-this.dayBeginsHour+this.dayEndsHour:this.dayEndsHour-this.dayBeginsHour},this.xa=function(e){var t=0;if("BusinessHoursNoScroll"===this.heightSpec)t=this.ya();else if(this.hideFreeCells&&!e){var i=(this.Aa-1)*this.cellDuration/this.cellHeight,n=Math.ceil(i/60),a=this.businessBeginsHour>this.businessEndsHour?this.businessEndsHour+24:this.businessEndsHour;t=Math.max(this.dayBeginsHour+n,a)-this.Ba()}else t=this.za();return 60*t*60*1e3},this.message=function(e,t,i,n){if(e){var o,t=t||this.messageHideAfter||2e3,r=this.Ca(),s=this.showHours?this.hourWidth:0,l=DayPilot.sw(a.Da());if(a.rtl){var d=s;s=l,l=d}if(this.nav.message)o=a.nav.message,this.nav.message.style.top=r+"px";else{o=document.createElement("div"),o.style.position="absolute",o.style.left=s+"px",o.style.top=r+"px",o.style.right="0px",o.style.display="none",o.onmousemove=function(){o.messageTimeout&&!o.status&&clearTimeout(o.messageTimeout)},o.onmouseout=function(){"none"!==a.nav.message.style.display&&(o.messageTimeout=setTimeout(a.Ea,500))};var c=document.createElement("div");c.onclick=function(){a.nav.message.style.display="none"},c.className=this.q("_message"),o.appendChild(c);var h=document.createElement("div");h.style.position="absolute",h.className=this.q("_message_close"),h.onclick=function(){a.nav.message.style.display="none"},o.appendChild(h),this.nav.top.insertBefore(o,this.nav.loading),this.nav.message=o,this.nav.messageClose=h}this.nav.cornerRight?this.nav.message.style.right=l+"px":this.nav.message.style.right="0px";var u=function(){if(a.nav.message){a.nav.message.firstChild.innerHTML=e;var i=function(){o.messageTimeout=setTimeout(a.Ea,t)};DayPilot.fade(a.nav.message,.2,i)}};clearTimeout(o.messageTimeout),"none"!==this.nav.message.style.display?DayPilot.fade(a.nav.message,-.2,u):u()}},this.message.show=function(e){a.message(e)},this.message.hide=function(){a.Ea()},this.Ea=function(){var e=function(){a.nav.message.style.display="none"};DayPilot.fade(a.nav.message,-.2,e)},this.ga=function(){this.nav.message&&(this.nav.message.style.top=this.Ca()+"px")},this.Fa=function(){return this.xa()/(6e4*this.cellDuration)},this.eventClickPostBack=function(e,t){this.E("EventClick",t,e)},this.eventClickCallBack=function(e,t){this.G("EventClick",e,t)},this.Ga=function(e){var t=this,e=e||window.event,i=e.ctrlKey,n=e.metaKey;if("undefined"!=typeof DayPilot.Bubble&&DayPilot.Bubble.hideActive(),"Disabled"===a.eventDoubleClickHandling)return void a.Ha(t,i,n,e);if(a.timeouts){for(var o in a.timeouts)window.clearTimeout(a.timeouts[o]);a.timeouts=[]}else a.timeouts=[];var r=function(e,t,i,n){return function(){a.Ha(e,t,i,n)}};a.timeouts.push(window.setTimeout(r(this,i,n,e),a.doubleClickTimeout))},this.Ha=function(e,t,i,n){var o=e.event;if(o.client.clickEnabled())if(a.sa()){var r={};if(r.e=o,r.ctrl=t,r.meta=i,r.originalEvent=n,r.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onEventClick&&(a.onEventClick(r),r.preventDefault.value))return;switch(a.eventClickHandling){case"PostBack":a.eventClickPostBack(o);break;case"CallBack":a.eventClickCallBack(o);break;case"Edit":a.Ia(e);break;case"Select":a.Ja(e,o,t,i);break;case"Bubble":a.bubble&&a.bubble.showEvent(o);break;case"ContextMenu":var s=o.client.contextMenu();s?s.show(o):a.contextMenu&&a.contextMenu.show(o)}"function"==typeof a.onEventClicked&&a.onEventClicked(r)}else switch(a.eventClickHandling){case"PostBack":a.eventClickPostBack(o);break;case"CallBack":a.eventClickCallBack(o);break;case"JavaScript":a.onEventClick(o);break;case"Edit":a.Ia(e);break;case"Select":a.Ja(e,o,t,i);break;case"Bubble":a.bubble&&a.bubble.showEvent(o);break;case"ContextMenu":var s=o.client.contextMenu();s?s.show(o):a.contextMenu&&a.contextMenu.show(o)}},this.eventDoubleClickPostBack=function(e,t){this.E("EventDoubleClick",t,e)},this.eventDoubleClickCallBack=function(e,t){this.G("EventDoubleClick",e,t)},this.Ka=function(e){if("undefined"!=typeof DayPilot.Bubble&&DayPilot.Bubble.hideActive(),a.timeouts){for(var t in a.timeouts)window.clearTimeout(a.timeouts[t]);a.timeouts=null}var i=this.event,e=e||window.event;if(a.sa()){var n={};if(n.e=i,n.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onEventDoubleClick&&(a.onEventDoubleClick(n),n.preventDefault.value))return;switch(a.eventDoubleClickHandling){case"PostBack":a.eventDoubleClickPostBack(i);break;case"CallBack":a.eventDoubleClickCallBack(i);break;case"Edit":i.allday()||a.Ia(this);break;case"Select":i.allday()||a.Ja(this,i,e.ctrlKey);break;case"Bubble":a.bubble&&a.bubble.showEvent(i)}"function"==typeof a.onEventDoubleClicked&&a.onEventDoubleClicked(n)}else switch(a.eventDoubleClickHandling){case"PostBack":a.eventDoubleClickPostBack(i);break;case"CallBack":a.eventDoubleClickCallBack(i);break;case"JavaScript":a.onEventDoubleClick(i);break;case"Edit":i.allday()||a.Ia(this);break;case"Select":i.allday()||a.Ja(this,i,e.ctrlKey);break;case"Bubble":a.bubble&&a.bubble.showEvent(i)}},this.eventRightClickPostBack=function(e,t){this.E("EventRightClick",t,e)},this.eventRightClickCallBack=function(e,t){this.G("EventRightClick",e,t)},this.La=function(e){var t=this.event;if(e.stopPropagation&&e.stopPropagation(),!t.client.rightClickEnabled())return!1;if(a.sa()){var i={};if(i.e=t,i.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onEventRightClick&&(a.onEventRightClick(i),i.preventDefault.value))return!1;switch(a.eventRightClickHandling){case"PostBack":a.eventRightClickPostBack(t);break;case"CallBack":a.eventRightClickCallBack(t);break;case"ContextMenu":var n=t.client.contextMenu();n?n.show(t):a.contextMenu&&a.contextMenu.show(this.event);break;case"Bubble":a.bubble&&a.bubble.showEvent(t)}"function"==typeof a.onEventRightClicked&&a.onEventRightClicked(i)}else switch(a.eventRightClickHandling){case"PostBack":a.eventRightClickPostBack(t);break;case"CallBack":a.eventRightClickCallBack(t);break;case"JavaScript":a.onEventRightClick(t);break;case"ContextMenu":var n=t.client.contextMenu();n?n.show(t):a.contextMenu&&a.contextMenu.show(this.event);break;case"Bubble":a.bubble&&a.bubble.showEvent(t)}return e.preventDefault&&e.preventDefault(),!1},this.headerClickPostBack=function(e,t){this.E("HeaderClick",t,e)},this.headerClickCallBack=function(e,t){this.G("HeaderClick",e,t)},this.Ma=function(t){var i=this.data,n=new e.Column(i.id,i.name,i.start);if(a.sa()){var o={};if(o.header={},o.header.id=i.id,o.header.name=i.name,o.header.start=i.start,o.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onHeaderClick&&(a.onHeaderClick(o),o.preventDefault.value))return;switch(a.headerClickHandling){case"PostBack":a.headerClickPostBack(n);break;case"CallBack":a.headerClickCallBack(n)}"function"==typeof a.onHeaderClicked&&a.onHeaderClicked(o)}else switch(a.headerClickHandling){case"PostBack":a.headerClickPostBack(n);break;case"CallBack":a.headerClickCallBack(n);break;case"JavaScript":a.onHeaderClick(n)}},this.Na=function(){if("undefined"!=typeof DayPilot.Bubble&&a.columnBubble)if("Resources"===a.viewType){var t={};t.calendar=a,t.id=this.data.id,t.toJSON=function(){var e={};return e.id=this.id,e},a.columnBubble.showResource(t)}else{var i=new DayPilot.Date(this.data.start),n=i.addDays(1),o={};o.calendar=a,o.start=i,o.end=n,o.toJSON=function(){var e={};return e.start=this.start,e.end=this.end,e},a.columnBubble.showTime(o)}var r=this,s=r.firstChild;if(!s.active){var l=r.data,d=new e.Column(l.id,l.name,l.start);d.areas=r.data.areas,DayPilot.Areas.showAreas(s,d)}},this.Oa=function(e){"undefined"!=typeof DayPilot.Bubble&&a.columnBubble&&a.columnBubble.hideOnMouseOut(),DayPilot.Areas.hideAreas(this.firstChild,e)},
this.eventDeletePostBack=function(e,t){this.E("EventDelete",t,e)},this.eventDeleteCallBack=function(e,t){this.G("EventDelete",e,t)},this.Pa=function(e){var t;if(t=e&&e.isEvent?e:e.parentNode.parentNode.event,a.sa()){var i={};if(i.e=t,i.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onEventDelete&&(a.onEventDelete(i),i.preventDefault.value))return;switch(a.eventDeleteHandling){case"PostBack":a.eventDeletePostBack(t);break;case"CallBack":a.eventDeleteCallBack(t);break;case"Update":a.events.remove(t)}"function"==typeof a.onEventDeleted&&a.onEventDeleted(i)}else switch(a.eventDeleteHandling){case"PostBack":a.eventDeletePostBack(t);break;case"CallBack":a.eventDeleteCallBack(t);break;case"JavaScript":a.onEventDelete(t)}},this.eventResizePostBack=function(e,t,i,n){if(!t)throw"newStart is null";if(!i)throw"newEnd is null";var a={};a.e=e,a.newStart=t,a.newEnd=i,this.E("EventResize",n,a)},this.eventResizeCallBack=function(e,t,i,n){if(!t)throw"newStart is null";if(!i)throw"newEnd is null";var a={};a.e=e,a.newStart=t,a.newEnd=i,this.G("EventResize",a,n)},this.Qa=function(e,t,i,n){if("PostBack"===e)a.postBack2(t,i,n);else if("CallBack"===e)a.G(t,i,n,"CallBack");else if("Immediate"===e)a.G(t,i,n,"Notify");else if("Queue"===e)a.queue.add(new DayPilot.Action(this,t,i,n));else{if("Notify"!==e)throw"Invalid event invocation type";"Notify"===r.notifyType()?a.G(t,i,n,"Notify"):a.queue.add(new DayPilot.Action(a,t,i,n))}};this.Ba=function(e){if("BusinessHoursNoScroll"===this.heightSpec)return this.businessBeginsHour;if(this.hideFreeCells&&!e){var t=this.Ra*this.cellDuration/this.cellHeight,i=Math.floor(t/60);return i=Math.max(0,i),Math.min(this.dayBeginsHour+i,this.businessBeginsHour)}return this.dayBeginsHour};this.visibleStart=function(){if("Resources"===a.viewType){var e=DayPilot.list(a.va).map(function(e){return e.start.getTime()}),t=Math.min.apply(null,e);return new DayPilot.Date(t)}return this.va[0].start},this.visibleEnd=function(){if("Resources"===a.viewType){var e=DayPilot.list(a.va).map(function(e){return e.start.getTime()}),t=Math.max.apply(null,e);return new DayPilot.Date(t).addDays(1)}var i=this.va,t=i.length-1;return i[t].start.addDays(1)},this.sa=function(){return 2===a.api},this.Sa=function(e,t,i,n){if("Disabled"!==this.eventResizeHandling){var o=0,r=new Date,s=new Date,l=e.start(),d=(e.end(),a.cellDuration),c=a.va[e.part.dayIndex].start;if("top"===n){var c=l.getDatePart(),h=Math.floor((i-o)/a.cellHeight),u=h*d,f=60*u*1e3,v=60*a.Ba()*60*1e3;r=c.addTime(f+v),s=e.end()}else if("bottom"===n){var h=Math.floor((i+t-o)/a.cellHeight),u=h*d,f=60*u*1e3,v=60*a.Ba()*60*1e3;r=l,s=c.addTime(f+v)}if(a.sa()){var p={};if(p.e=e,p.newStart=r,p.newEnd=s,p.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onEventResize&&(a.onEventResize(p),p.preventDefault.value))return;switch(a.eventResizeHandling){case"PostBack":a.eventResizePostBack(e,r,s);break;case"CallBack":a.eventResizeCallBack(e,r,s);break;case"Notify":a.eventResizeNotify(e,r,s);break;case"Update":e.start(r),e.end(s),a.events.update(e)}"function"==typeof a.onEventResized&&a.onEventResized(p)}else switch(a.eventResizeHandling){case"PostBack":a.eventResizePostBack(e,r,s);break;case"CallBack":a.eventResizeCallBack(e,r,s);break;case"JavaScript":a.onEventResize(e,r,s);break;case"Notify":a.eventResizeNotify(e,r,s)}}},this.eventResizeNotify=function(e,t,i,n){var o=new DayPilot.Event(e.copy(),this);e.start(t),e.end(i),e.commit(),a.update(),this.Ta("Notify",o,t,i,n)},this.Ta=function(e,t,i,n,a){var o={};o.e=t,o.newStart=i,o.newEnd=n,this.Qa(e,"EventResize",o,a)},this.eventMovePostBack=function(e,t,i,n,a){if(!t)throw"newStart is null";if(!i)throw"newEnd is null";var o={};o.e=e,o.newStart=t,o.newEnd=i,o.newResource=n,this.E("EventMove",a,o)},this.eventMoveCallBack=function(e,t,i,n,a){if(!t)throw"newStart is null";if(!i)throw"newEnd is null";var o={};o.e=e,o.newStart=t,o.newEnd=i,o.newResource=n,this.G("EventMove",o,a)},this.Ua=function(e,t,i,n,o){if("Disabled"!==a.eventMoveHandling){var r=0,s=Math.floor((i-r)/a.cellHeight),l=a.cellDuration,d=s*l*60*1e3,c=e.start(),h=e.end(),u=new Date;c instanceof DayPilot.Date&&(c=c.toDate()),u.setTime(Date.UTC(c.getUTCFullYear(),c.getUTCMonth(),c.getUTCDate()));var f="Never"!==a.useEventBoxes?c.getTime()-(u.getTime()+3600*c.getUTCHours()*1e3+Math.floor(c.getUTCMinutes()/l)*l*60*1e3):0,v=h.getTime()-c.getTime(),p=3600*a.Ba()*1e3;"undefined"==typeof t&&(t=e.part.dayIndex);var g=this.va[t],m=g.start.getTime(),y=new Date;y.setTime(m+d+f+p);var b=new DayPilot.Date(y),w=b.addTime(v),D=!!o,k=g.id;if(a.sa()){var C={};if(C.e=e,C.newStart=b,C.newEnd=w,C.newResource=k,C.external=D,C.ctrl=!1,n&&(C.ctrl=n.ctrlKey),C.shift=!1,n&&(C.shift=n.shiftKey),C.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onEventMove&&(a.onEventMove(C),C.preventDefault.value))return;switch(a.eventMoveHandling){case"PostBack":a.eventMovePostBack(e,b,w,k);break;case"CallBack":a.eventMoveCallBack(e,b,w,k);break;case"Notify":a.eventMoveNotify(e,b,w,k);break;case"Update":e.start(b),e.end(w),e.resource(k),D?(e.commit(),a.events.add(e)):a.events.update(e),a.Va()}"function"==typeof a.onEventMoved&&a.onEventMoved(C)}else switch(a.eventMoveHandling){case"PostBack":a.eventMovePostBack(e,b,w,k);break;case"CallBack":a.eventMoveCallBack(e,b,w,k);break;case"JavaScript":a.onEventMove(e,b,w,k,D,!!n&&n.ctrlKey,!!n&&n.shiftKey);break;case"Notify":a.eventMoveNotify(e,b,w,k,null)}}},this.eventMoveNotify=function(e,t,i,n,o){var r=new DayPilot.Event(e.copy(),this);e.start(t),e.end(i),e.resource(n),e.commit(),a.update(),this.Wa("Notify",r,t,i,n,o)},this.Wa=function(e,t,i,n,a,o){var r={};r.e=t,r.newStart=i,r.newEnd=n,r.newResource=a,this.Qa(e,"EventMove",r,o)},this.Va=function(){if(a.todo&&a.todo.del){var e=a.todo.del;e.parentNode.removeChild(e),a.todo.del=null}},this.Xa=function(e,t){var i=a.Ya(t),n={};n.args=e,n.guid=i,a.G("Bubble",n)},this.Ya=function(e){var t=DayPilot.guid();return this.bubbles||(this.bubbles=[]),this.bubbles[t]=e,t},this.eventMenuClickPostBack=function(e,t,i){var n={};n.e=e,n.command=t,this.E("EventMenuClick",i,n)},this.eventMenuClickCallBack=function(e,t,i){var n={};n.e=e,n.command=t,this.G("EventMenuClick",n,i)},this.Za=function(e,t,i){switch(i){case"PostBack":a.eventMenuClickPostBack(t,e);break;case"CallBack":a.eventMenuClickCallBack(t,e)}},this.timeRangeMenuClickPostBack=function(e,t,i){var n={};n.selection=e,n.command=t,this.E("TimeRangeMenuClick",i,n)},this.timeRangeMenuClickCallBack=function(e,t,i){var n={};n.selection=e,n.command=t,this.G("TimeRangeMenuClick",n,i)},this.$a=function(e,t,i){switch(i){case"PostBack":a.timeRangeMenuClickPostBack(t,e);break;case"CallBack":a.timeRangeMenuClickCallBack(t,e)}},this.timeRangeSelectedPostBack=function(e,t,i,n){var a={};a.start=e,a.end=t,a.resource=i,this.E("TimeRangeSelected",n,a)},this.timeRangeSelectedCallBack=function(e,t,i,n){var a={};a.start=e,a.end=t,a.resource=i,this.G("TimeRangeSelected",a,n)},this._a=function(e,t,i){e=new DayPilot.Date(e),t=new DayPilot.Date(t);var n=i;if(a.sa()){var o={};if(o.start=e,o.end=t,o.resource=n,o.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onTimeRangeSelect&&(a.onTimeRangeSelect(o),o.preventDefault.value))return;switch(a.timeRangeSelectedHandling){case"PostBack":a.timeRangeSelectedPostBack(e,t,n);break;case"CallBack":a.timeRangeSelectedCallBack(e,t,n)}"function"==typeof a.onTimeRangeSelected&&a.onTimeRangeSelected(o)}else switch(a.timeRangeSelectedHandling){case"PostBack":a.timeRangeSelectedPostBack(e,t,i);break;case"CallBack":a.timeRangeSelectedCallBack(e,t,i);break;case"JavaScript":a.onTimeRangeSelected(e,t,i)}},this.timeRangeDoubleClickPostBack=function(e,t,i,n){var a={};a.start=e,a.end=t,a.resource=i,this.E("TimeRangeDoubleClick",n,a)},this.timeRangeDoubleClickCallBack=function(e,t,i,n){var a={};a.start=e,a.end=t,a.resource=i,this.G("TimeRangeDoubleClick",a,n)},this.ab=function(e,t,i){if(a.sa()){var n=i,o={};if(o.start=e,o.end=t,o.resource=n,o.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onTimeRangeDoubleClick&&(a.onTimeRangeDoubleClick(o),o.preventDefault.value))return;switch(a.timeRangeDoubleClickHandling){case"PostBack":a.timeRangeDoubleClickPostBack(e,t,n);break;case"CallBack":a.timeRangeDoubleClickCallBack(e,t,n)}"function"==typeof a.onTimeRangeDoubleClicked&&a.onTimeRangeDoubleClicked(o)}else switch(a.timeRangeDoubleClickHandling){case"PostBack":a.timeRangeDoubleClickPostBack(e,t,i);break;case"CallBack":a.timeRangeDoubleClickCallBack(e,t,i);break;case"JavaScript":a.onTimeRangeDoubleClick(e,t,i)}},this.eventEditPostBack=function(e,t,i){var n={};n.e=e,n.newText=t,this.E("EventEdit",i,n)},this.eventEditCallBack=function(e,t,i){var n={};n.e=e,n.newText=t,this.G("EventEdit",n,i)},this.bb=function(e,t){if(a.sa()){var i={};if(i.e=e,i.newText=t,i.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onEventEdit&&(a.onEventEdit(i),i.preventDefault.value))return;switch(a.eventEditHandling){case"PostBack":a.eventEditPostBack(e,t);break;case"CallBack":a.eventEditCallBack(e,t);break;case"Update":e.text(t),a.events.update(e)}if("function"==typeof a.onEventEdited&&(a.onEventEdited(i),i.preventDefault.value))return}else switch(a.eventEditHandling){case"PostBack":a.eventEditPostBack(e,t);break;case"CallBack":a.eventEditCallBack(e,t);break;case"JavaScript":a.onEventEdit(e,t)}},this.eventSelectPostBack=function(e,t,i){var n={};n.e=e,n.change=t,this.E("EventSelect",i,n)},this.eventSelectCallBack=function(e,t,i){var n={};n.e=e,n.change=t,this.G("EventSelect",n,i)},this.cb=function(e,t,i,n){var o=a.multiselect,r=o.isSelected(t);if(i||n||!r||1!==o.db.length)if(a.sa()){o.previous=o.events();var s={};if(s.e=t,s.selected=o.isSelected(t),s.ctrl=i,s.meta=n,s.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onEventSelect&&(a.onEventSelect(s),s.preventDefault.value))return;switch(a.eventSelectHandling){case"PostBack":a.eventSelectPostBack(t,l);break;case"CallBack":"undefined"!=typeof WebForm_InitCallback&&(window.eb="",window.fb=[],WebForm_InitCallback()),a.eventSelectCallBack(t,l);break;case"Update":o.gb(e,i)}"function"==typeof a.onEventSelected&&(s.change=o.isSelected(t)?"selected":"deselected",s.selected=o.isSelected(t),a.onEventSelected(s))}else{o.previous=o.events(),o.gb(e,i);var l=o.isSelected(t)?"selected":"deselected";switch(a.eventSelectHandling){case"PostBack":a.eventSelectPostBack(t,l);break;case"CallBack":"undefined"!=typeof WebForm_InitCallback&&(window.eb="",window.fb=[],WebForm_InitCallback()),a.eventSelectCallBack(t,l);break;case"JavaScript":a.onEventSelect(t,l)}}},this.commandCallBack=function(e,t){this.L();var i={};i.command=e,this.G("Command",i,t)},this.hb=function(t){if(!o.active&&!o.using&&(clearTimeout(e.selectedTimeout),!e.selecting)){if(e.editing)return void e.editing.blur();if(a.selectedCells&&"Disabled"!==a.timeRangeDoubleClickHandling)for(var i=0;i<a.selectedCells.length;i++)if(this===a.selectedCells[i])return;if("Disabled"!==a.timeRangeSelectedHandling){DayPilot.Util.mouseButton(t).left&&(e.firstMousePos=DayPilot.mc(t||window.event),a.clearSelection(),e.topSelectedCell=this,e.bottomSelectedCell=this,e.column=e.getColumn(this),a.selectedCells.push(this),e.firstSelected=this)}}},this.ib=function(){if(this.getSelection()&&a.selectedCells)for(var e=0;e<a.selectedCells.length;e++){var t=a.selectedCells[e];if(t&&!t.selected){var i=document.createElement("div");i.style.height=a.cellHeight-1+"px",i.style.backgroundColor=a.selectedColor,t.firstChild.style.display="none",t.insertBefore(i,t.firstChild),t.selected=i}}},this.jb=function(e){"undefined"!=typeof DayPilot.Bubble&&a.cellBubble&&a.cellBubble.hideOnMouseOut()},this.kb=function(t){if("undefined"!=typeof e&&!o.active&&!o.using){if("undefined"!=typeof DayPilot.Bubble&&a.cellBubble){var i=e.getColumn(this),n=a.va[i].id,r={};r.calendar=a,r.start=this.start,r.end=this.end,r.resource=n,r.toJSON=function(){var e={};return e.start=this.start,e.end=this.end,e.resource=this.resource,e},a.cellBubble.showCell(r)}if(e.firstMousePos){var s=e.firstMousePos,l=DayPilot.mc(t||window.event);s.x===l.x&&s.y===l.y||(e.selecting=!0,a.clearSelection(),a.ib())}if(e.selecting){var d=DayPilot.mc(t||window.event);e.getColumn(this)===e.column&&(a.clearSelection(),d.y<e.firstMousePos.y?(a.selectedCells=e.getCellsBelow(this),e.topSelectedCell=a.selectedCells[0],e.bottomSelectedCell=e.firstSelected):(a.selectedCells=e.getCellsAbove(this),e.topSelectedCell=e.firstSelected,e.bottomSelectedCell=a.selectedCells[0]),a.ib())}}},this.getSelection=function(){if(!e.topSelectedCell)return null;if(!e.bottomSelectedCell)return null;var t=e.topSelectedCell.start,i=e.bottomSelectedCell.end,n=e.topSelectedCell.resource;return new DayPilot.Selection(t,i,n,a)},this.lb=function(t){if(e.firstMousePos){var i=function(){e.selecting=!0,a.ib(),e.firstMousePos=null,e.selecting=!1;var t=a.getSelection();a._a(t.start,t.end,t.resource)};e.selecting&&null!==e.topSelectedCell?i():e.selectedTimeout=setTimeout(i,100)}else e.selecting=!1},this.mb=function(e){if("Fixed"===a.columnWidthSpec||a.nb){if(!a.nav.bottomLeft)return;a.nav.bottomLeft.scrollTop=a.nav.bottomRight.scrollTop,a.nav.upperRight&&(a.nav.upperRight.scrollLeft=a.nav.bottomRight.scrollLeft),a.nav.scrollLayer.scrollLeft=a.nav.bottomRight.scrollLeft}var t=a.ob();a.scrollPos=t.scrollTop,a.pb=t.clientHeight,a.nav.scrollpos.value=a.scrollPos,a.qa()},this.qa=function(){if(this.scrollLabelsVisible&&this.qb){if(this.nav&&this.nav.main&&this.nav.main.rows&&this.nav.main.rows.length>0&&this.nav.main.rows[0].cells.length>0){for(var e=(this.va,this.showHours?this.hourWidth:0),t=this.nav.main.rows[0].cells[0].clientWidth,i=1,n=0;n<this.nav.scrollUp.length;n++){var o=this.nav.scrollUp[n],r=this.nav.scrollDown[n],s=Math.floor(e+n*t+t/2-5+i);s<0&&(s=0),s-=a.nav.bottomRight.scrollLeft,o&&o.style&&(o.style.left=s+"px"),r&&r.style&&(r.style.left=s+"px")}for(var l=this.rb(),n=0;n<this.nav.scrollUp.length;n++){var d=this.nav.scrollUp[n],c=this.nav.scrollDown[n],h=this.qb[n].minEnd-l,u=this.qb[n].maxStart-l;d&&c&&(h<=a.scrollPos&&parseInt(d.style.left)>=a.hourWidth?(d.style.top=this.Ca()+"px",d.style.display=""):d.style.display="none",u>=a.scrollPos+a.pb&&parseInt(c.style.left)>=a.hourWidth?(c.style.top=this.Ca()+this.pb-10+"px",c.style.display=""):c.style.display="none")}}}},this.sb=function(e){var t=e.parentNode,i=0,n=e.offsetTop,a=e.parentNode.offsetWidth,o=e.offsetHeight;e.event.allday()&&(i=e.offsetLeft,a=e.offsetWidth);var r=document.createElement("textarea");r.style.boxSizing="border-box",r.style.position="absolute",r.style.width=a+"px",r.style.height=o+"px";var s=DayPilot.gs(e,"fontFamily");s||(s=DayPilot.gs(e,"font-family")),r.style.fontFamily=s;var l=DayPilot.gs(e,"fontSize");return l||(l=DayPilot.gs(e,"font-size")),r.style.fontSize=l,r.style.left=i+"px",r.style.top=n+"px",r.style.border="1px solid black",r.style.padding="0px",r.style.marginTop="0px",r.style.backgroundColor="white",r.value=DayPilot.tr(e.event.text()),r.event=e.event,t.appendChild(r),r},this.Ja=function(e,t,i,n){a.cb(e,t,i,n)},this.multiselect={},this.multiselect.Z=[],this.multiselect.db=[],this.multiselect.tb=[],this.multiselect.ub=[],this.multiselect.vb=function(){var e=a.multiselect;return DayPilot.JSON.stringify(e.events())},this.multiselect.events=function(){var e=a.multiselect,t=[];t.ignoreToJSON=!0;for(var i=0;i<e.db.length;i++)t.push(e.db[i]);return t},this.multiselect.wb=function(){a.nav.select.value=a.multiselect.vb()},this.multiselect.gb=function(e,t){var i=a.multiselect;if(i.isSelected(e.event))if(a.allowMultiSelect)if(t)i.remove(e.event,!0);else{var n=i.db.length;i.clear(!0),n>1&&i.add(e.event,!0)}else i.clear(!0);else a.allowMultiSelect&&t?i.add(e.event,!0):(i.clear(!0),i.add(e.event,!0));i.redraw(),i.wb()},this.multiselect.xb=function(e){var t=a.multiselect;return t.yb(e,t.Z)},this.multiselect.zb=function(){for(var e=a.multiselect,t=[],i=0;i<e.db.length;i++){var n=e.db[i];t.push(n.value())}alert(t.join("\n"))},this.multiselect.add=function(e,t){var i=a.multiselect;i.Ab(e)===-1&&i.db.push(e),i.wb(),t||i.redraw()},this.multiselect.remove=function(e,t){var i=a.multiselect,n=i.Ab(e);n!==-1&&i.db.splice(n,1),i.wb(),t||i.redraw()},this.multiselect.clear=function(e){var t=a.multiselect;t.db=[],t.wb(),e||t.redraw()},this.multiselect.redraw=function(){for(var e=a.multiselect,t=0;t<a.elements.events.length;t++){var i=a.elements.events[t];e.isSelected(i.event)?e.Bb(i):e.Cb(i)}},this.multiselect.Bb=function(e){var t=a.multiselect,i=a.q("_selected"),n=t.Db(e);DayPilot.Util.addClass(n,i),a.useEventSelectionBars&&t.Eb(e),t.tb.push(e)},this.multiselect.Db=function(e){return e},this.multiselect.Fb=function(){for(var e=a.multiselect,t=0;t<e.tb.length;t++){var i=e.tb[t];e.Cb(i,!0)}e.tb=[]},this.multiselect.Cb=function(e,t){var i=a.multiselect,n=a.q("_selected"),o=i.Db(e);if(DayPilot.Util.removeClass(o,n),a.useEventSelectionBars&&i.Gb(e),!t){var r=DayPilot.indexOf(i.tb,e);r!==-1&&i.tb.splice(r,1)}},this.multiselect.isSelected=function(e){return a.multiselect.yb(e,a.multiselect.db)},this.multiselect.Ab=function(e){return DayPilot.indexOf(a.multiselect.db,e)},this.multiselect.yb=function(e,t){if(!t)return!1;for(var i=0;i<t.length;i++){var n=t[i];if(e===n)return!0;if("function"==typeof n.value){if(null!==n.value()&&null!==e.value()&&n.value()===e.value())return!0;if(null===n.value()&&null===e.value()&&n.recurrentMasterId()===e.recurrentMasterId()&&e.start().toStringSortable()===n.start())return!0}else{if(null!==n.value&&null!==e.value()&&n.value===e.value())return!0;if(null===n.value&&null===e.value()&&n.recurrentMasterId===e.recurrentMasterId()&&e.start().toStringSortable()===n.start)return!0}}return!1},this.multiselect.Eb=function(e){var t=5;if(!e.top){var i=document.createElement("div");i.setAttribute("unselectable","on"),i.style.position="absolute",i.style.left=e.offsetLeft+"px",i.style.width=e.offsetWidth+"px",i.style.top=e.offsetTop-t+"px",i.style.height="5px",i.style.backgroundColor=a.eventSelectColor,i.style.zIndex=100,e.parentNode.appendChild(i),e.top=i}if(!e.bottom){var n=document.createElement("div");n.setAttribute("unselectable","on"),n.style.position="absolute",n.style.left=e.offsetLeft+"px",n.style.width=e.offsetWidth+"px",n.style.top=e.offsetTop+e.offsetHeight+"px",n.style.height="5px",n.style.backgroundColor=a.eventSelectColor,n.style.zIndex=100,e.parentNode.appendChild(n),e.bottom=n}},this.multiselect.Gb=function(e){e.top&&(e.parentNode.removeChild(e.top),e.top=null),e.bottom&&(e.parentNode.removeChild(e.bottom),e.bottom=null)},this.Ia=function(t){if(e.editing)return void e.editing.blur();var i=this.sb(t);e.editing=i,DayPilot.re(i,DayPilot.touch.start,function(e){e.stopPropagation()}),i.onblur=function(){if(t.event){var n=(t.event.value(),t.event.tag(),t.event.text()),o=i.value;e.editing=null,i.onblur=null,DayPilot.de(i),n!==o&&(t.style.display="none",a.bb(t.event,o))}},i.onkeypress=function(t){var n=window.event?event.keyCode:t.keyCode;return 13===n?(this.onblur(),!1):(27===n&&(i.parentNode.removeChild(i),e.editing=!1),!0)},i.select(),i.focus()},this.Hb=function(){return"Resources"!==a.viewType&&(!a.columns||!a.r())},this._=function(){if(a.Hb()){var e=this.Ib();this.va=this.Jb(e)}else this.U=this.Jb(this.columns||[]),this.va=this.Kb(this.headerLevels,!0)},this.Lb=function(){var e=this.startDate.getDatePart(),t=this.days;switch(this.viewType){case"Day":t=1;break;case"Week":t=7,e=e.firstDayOfWeek(r.weekStarts());break;case"WorkWeek":t=5,e=e.firstDayOfWeek(1)}var i=e.addDays(t),n={};return n.start=e,n.end=i,n.days=t,n},this.Ib=function(){for(var e=[],t=this.Lb(),i=t.start,n=t.days,o=0;o<n;o++){var s={};s.start=i.addDays(o);var l=r.locale().datePattern;a.headerDateFormat&&(l=a.headerDateFormat),s.name=s.start.toString(l,r.locale()),s.html=s.name,e.push(s)}return e},this.Mb=function(e){var t={};return e.Start&&(e.id=e.Value,e.start=e.Start,e.name=e.Name,e.html=e.InnerHTML,e.toolTip=e.ToolTip,e.backColor=e.BackColor,e.areas=e.Areas,e.children=e.Children,delete e.Value,delete e.Start,delete e.Name,delete e.InnerHTML,delete e.ToolTip,delete e.BackColor,delete e.Areas,delete e.Children),t.id=e.id,t.start=new DayPilot.Date(e.start||a.startDate).getDatePart(),t.name=e.name,t.html=e.html||e.name,t.toolTip=e.toolTip,t.backColor=e.backColor,t.areas=e.areas,t.getChildren=function(e,t){var i=[];if(e<=1)return i.push(this),i;if(!this.children||0===this.children.length)return t?i.push(this):i.push("empty"),i;for(var n=0;n<this.children.length;n++)for(var a=this.children[n],o=a.getChildren(e-1,t),r=0;r<o.length;r++)i.push(o[r]);return i},t.getChildrenCount=function(e){var t=0;if(!this.children||this.children.length<=0||e<=1)return 1;for(var i=0;i<this.children.length;i++)t+=this.children[i].getChildrenCount(e-1);return t},t.putIntoBlock=function(e){for(var t=0;t<this.blocks.length;t++){var i=this.blocks[t];if(i.overlapsWith(e.part.top,e.part.height))return i.events.push(e),i.min=Math.min(i.min,e.part.top),i.max=Math.max(i.max,e.part.top+e.part.height),t}var i=[];return i.lines=[],i.events=[],i.overlapsWith=function(e,t){return!(e+t-1<this.min||e>this.max-1)},i.putIntoLine=function(e){for(var t=0;t<this.lines.length;t++){var i=this.lines[t];if(i.isFree(e.part.top,e.part.height))return i.push(e),t}var i=[];return i.isFree=function(e,t){for(var i=e+t-1,n=this.length,a=0;a<n;a++){var o=this[a];if(!(i<o.part.top||e>o.part.top+o.part.height-1))return!1}return!0},i.push(e),this.lines.push(i),this.lines.length-1},i.events.push(e),i.min=e.part.top,i.max=e.part.top+e.part.height,this.blocks.push(i),this.blocks.length-1},t.putIntoLine=function(e){for(var t=0;t<this.lines.length;t++){var i=this.lines[t];if(i.isFree(e.part.top,e.part.height))return i.push(e),t}var i=[];return i.isFree=function(e,t){for(var i=e+t-1,n=this.length,a=0;a<n;a++){var o=this[a];if(!(i<o.part.top||e>o.part.top+o.part.height-1))return!1}return!0},i.push(e),this.lines.push(i),this.lines.length-1},e.children&&(t.children=this.Jb(e.children)),t},this.Jb=function(e){var t=DayPilot.list();return DayPilot.list(e).each(function(e){var i=a.Mb(e);t.push(i)}),t},this.Kb=function(e,t){for(var i=this.Hb()?this.va:this.U,n=[],a=0;a<i.length;a++)for(var o=i[a].getChildren(e,t),r=0;r<o.length;r++)n.push(o[r]);return n},this.pa=function(){if(this.showAllDayEvents){var e=this.nav.header;if(e){e.style.display="none";for(var t=this.va.length,i=0;i<this.Nb.lines.length;i++)for(var n=this.Nb.lines[i],o=0;o<n.length;o++){var s=n[o],l=s.cache||s.data,d=document.createElement("div");d.event=s,d.setAttribute("unselectable","on"),d.style.position="absolute",a.rtl?d.style.right=100*s.part.colStart/t+"%":d.style.left=100*s.part.colStart/t+"%",d.style.width=100*s.part.colWidth/t+"%",d.style.height=r.allDayEventHeight()+"px",d.className=this.q("_alldayevent"),d.style.top=this.headerLevels*r.headerHeight()+i*r.allDayEventHeight()+"px",l.cssClass&&DayPilot.Util.addClass(d,l.cssClass),d.style.textAlign="left",d.style.lineHeight="1.2",s.client.clickEnabled()&&(d.onclick=this.Ga),s.client.doubleClickEnabled()&&(d.ondblclick=this.Ka),s.client.clickEnabled()||s.client.doubleClickEnabled()?d.style.cursor="pointer":d.style.cursor="default",DayPilot.re(d,"contextmenu",this.La),d.onmousemove=function(e){var t=this;if(!t.active){var i=[];s.client.deleteEnabled()&&i.push({"action":"JavaScript","v":"Hover","w":17,"h":17,"top":3,"right":3,"css":a.q("_event_delete"),"js":function(e){a.Pa(e)}});var n=l.areas;n&&n.length>0&&(i=i.concat(n)),DayPilot.Areas.showAreas(t,t.event,null,i),DayPilot.Util.addClass(t,a.q("_alldayevent_hover"))}"undefined"!=typeof DayPilot.Bubble&&a.bubble&&"Disabled"!==a.eventHoverHandling&&a.bubble.showEvent(this.event)},d.onmouseout=function(e){var t=this;DayPilot.Util.removeClass(t,a.q("_alldayevent_hover")),DayPilot.Areas.hideAreas(this,e),a.bubble&&a.bubble.hideOnMouseOut()},this.showToolTip&&!this.bubble&&d.setAttribute("title",s.client.toolTip());var c=s.start().getTime()===s.part.start.getTime(),h=s.end().getTime()===s.part.end.getTime(),u=l.backColor,f=document.createElement("div");if(f.setAttribute("unselectable","on"),f.className=this.q("_alldayevent_inner"),u&&(f.style.background=u),l.fontColor&&(f.style.color=l.fontColor),l.borderColor&&(f.style.borderColor=l.borderColor),a.rtl?(c||DayPilot.Util.addClass(d,this.q("_alldayevent_continueright")),h||DayPilot.Util.addClass(d,this.q("_alldayevent_continueleft"))):(c||DayPilot.Util.addClass(d,this.q("_alldayevent_continueleft")),h||DayPilot.Util.addClass(d,this.q("_alldayevent_continueright"))),s.client.innerHTML()?f.innerHTML=s.client.innerHTML():f.innerHTML=s.text(),d.appendChild(f),a.sa()){if("function"==typeof a.onAfterEventRender){var v={};v.e=d.event,v.div=d,a.onAfterEventRender(v)}}else a.afterEventRender&&a.afterEventRender(d.event,d);this.nav.allday.appendChild(d),this.elements.events.push(d)}e.style.display=""}}},this.M=function(e){if(a.multiselect.Fb(),this.elements.events)for(var t=0;t<this.elements.events.length;t++){var i=this.elements.events[t],n=i.event;if(!n||!e||n.allday()){if(n&&(n.div=null,n.root=null),i.onclick=null,i.onclickSave=null,i.ondblclick=null,i.oncontextmenu=null,i.onmouseover=null,i.onmouseout=null,i.onmousemove=null,i.onmousedown=null,i.firstChild&&i.firstChild.firstChild&&i.firstChild.firstChild.tagName&&"IMG"===i.firstChild.firstChild.tagName.toUpperCase()){var o=i.firstChild.firstChild;o.onmousedown=null,o.onmousemove=null,o.onclick=null}i.helper=null,i.event=null,DayPilot.de(i)}}this.elements.events=[]},this.Ob=function(e){var t=this.nav.events,i=(this.roundedCorners,this.roundedCorners&&(this.C.ff||this.C.opera105||this.C.webkit522||!this.C.ielt9)),n=(this.roundedCorners&&!i,e.cache||e.data),o=(n.borderColor||this.eventBorderColor,document.createElement("div"));o.setAttribute("unselectable","on"),o.style.MozUserSelect="none",o.style.KhtmlUserSelect="none",o.style.WebkitUserSelect="none",o.style.position="absolute",o.className=this.q("_event"),o.style.left=e.part.left+"%",o.style.top=e.part.top-this.rb()+"px",o.style.width=e.part.width+"%",o.style.height=Math.max(e.part.height,2)+"px",o.style.overflow="hidden",o.isFirst=e.part.start.getTime()===e.start().getTime(),o.isLast=e.part.end.getTime()===e.end().getTime(),e.client.clickEnabled()&&(o.onclick=this.Ga),e.client.doubleClickEnabled()&&(o.ondblclick=this.Ka),DayPilot.re(o,"contextmenu",this.La),o.onmousemove=this.Pb,o.onmouseout=this.Qb,o.onmousedown=this.Rb,DayPilot.re(o,DayPilot.touch.start,this.Sb.onEventTouchStart),DayPilot.re(o,DayPilot.touch.move,this.Sb.onEventTouchMove),DayPilot.re(o,DayPilot.touch.end,this.Sb.onEventTouchEnd);n.cssClass&&DayPilot.Util.addClass(o,n.cssClass),this.showToolTip&&!this.bubble&&o.setAttribute("title",e.client.toolTip());var r=document.createElement("div");if(r.setAttribute("unselectable","on"),r.className=a.q("_event_inner"),r.innerHTML=e.client.innerHTML(),n.fontColor&&(r.style.color=n.fontColor),n.backColor&&(r.style.background=n.backColor,(DayPilot.browser.ie9||DayPilot.browser.ielt9)&&(r.style.filter="")),n.borderColor&&(r.style.borderColor=n.borderColor),n.backgroundImage&&(r.style.backgroundImage="url("+n.backgroundImage+")",n.backgroundRepeat&&(r.style.backgroundRepeat=n.backgroundRepeat)),o.appendChild(r),e.client.barVisible()){var s=e.part.height-2,l=100*e.part.barTop/s,d=Math.ceil(100*e.part.barHeight/s);"PercentComplete"===this.durationBarMode&&(l=0,d=n.complete);var c=document.createElement("div");c.setAttribute("unselectable","on"),c.className=this.q("_event_bar"),c.style.position="absolute",n.barBackColor&&(c.style.backgroundColor=n.barBackColor);var h=document.createElement("div");h.setAttribute("unselectable","on"),h.className=this.q("_event_bar_inner"),h.style.top=l+"%",0<d&&d<=1?h.style.height="1px":h.style.height=d+"%",n.barColor&&(h.style.backgroundColor=n.barColor),c.appendChild(h),o.appendChild(c)}if(n.areas)for(var u=0;u<n.areas.length;u++){var f=n.areas[u],v=f.v||"Visible";if("Visible"===v){var p=DayPilot.Areas.createArea(o,e,f);o.appendChild(p)}}if(t.rows[0].cells[e.part.dayIndex]){if(t.rows[0].cells[e.part.dayIndex].events.appendChild(o),a.Tb(o),o.event=e,a.multiselect.xb(e)&&a.multiselect.add(o.event,!0),a.sa()){if("function"==typeof a.onAfterEventRender){var g={};g.e=o.event,g.div=o,a.onAfterEventRender(g)}}else a.afterEventRender&&a.afterEventRender(o.event,o)}a.elements.events.push(o)},this.Tb=function(e){for(var t=e&&e.childNodes?e.childNodes.length:0,i=0;i<t;i++)try{var n=e.childNodes[i];1===n.nodeType&&(n.setAttribute("unselectable","on"),this.Tb(n))}catch(e){}},this.oa=function(){for(var e=new Date,t=0;t<this.va.length;t++){var i=this.va[t];if(i.blocks)for(var n=0;n<i.blocks.length;n++)for(var a=i.blocks[n],o=0;o<a.lines.length;o++)for(var r=a.lines[o],s=0;s<r.length;s++){var l=r[s];if(l.part.width=100/a.lines.length,l.part.left=l.part.width*o,"Cascade"===this.eventArrangement){var d=o===a.lines.length-1;d||(l.part.width=1.5*l.part.width)}"Full"===this.eventArrangement&&(l.part.left=l.part.left/2,l.part.width=100-l.part.left),l.allday()||this.Ob(l)}}this.multiselect.redraw();var c=new Date;c.getTime()-e.getTime()},this.Ub=function(){this.multiselect.db=[];for(var e=0;e<this.va.length;e++)for(var t=this.va[e],i=0;i<t.lines.length;i++)for(var n=t.lines[i],a=0;a<n.length;a++){var o=n[a];o.part.width=100/t.lines.length,o.part.left=o.Width*i,o.allday()||this.Ob(o)}},this.q=function(e){var t=this.theme||this.cssClassPrefix;return t?t+e:""},this.na=function(){"hidden"===this.nav.top.style.visibility&&(this.nav.top.style.visibility="visible")},this.Vb=function(){var e=this.Ca()+this.Wb();return a.debug.message("Getting totalHeight, headerHeight: "+this.Ca()+" scrollable: "+this.Wb()),e<0?0:e},this.Xb=function(){if(this.nav.top.dp=this,this.nav.top.innerHTML="",this.nav.top.style.MozUserSelect="none",this.nav.top.style.KhtmlUserSelect="none",this.nav.top.style.WebkitUserSelect="none",this.nav.top.style.WebkitTapHighlightColor="rgba(0,0,0,0)",this.nav.top.style.WebkitTouchCallout="none",this.nav.top.style.position="relative",this.width&&(this.nav.top.style.width=this.width),this.rtl&&(this.nav.top.style.direction="rtl"),"Parent100Pct"===this.heightSpec?this.nav.top.style.height="100%":this.nav.top.style.height=this.Vb()+"px",this.hideUntilInit&&(this.nav.top.style.visibility="hidden"),this.visible||(this.nav.top.style.display="none"),this.nav.scroll=document.createElement("div"),this.nav.scroll.style.height=this.Wb()+"px",DayPilot.Util.addClass(this.nav.top,this.q("_main")),this.nav.scroll.style.position="relative",this.showHeader){var e=this.Yb();this.nav.top.appendChild(e)}this.nav.scroll.style.zoom=1,this.nav.scroll.setAttribute("data-id","nav.scroll"),this.nav.scroll.style.position="absolute",this.nav.scroll.style.left="0px",this.nav.scroll.style.right="0px",this.nav.scroll.style.top=this.Ca()+"px";var t=this.Zb();this.nav.scrollable=t.firstChild,this.nav.scroll.appendChild(t),this.nav.top.appendChild(this.nav.scroll),this.nav.vsph=document.createElement("div"),this.nav.vsph.style.display="none",this.nav.top.appendChild(this.nav.vsph),this.nav.scrollpos=document.createElement("input"),this.nav.scrollpos.type="hidden",this.nav.scrollpos.id=a.id+"_scrollpos",this.nav.scrollpos.name=this.nav.scrollpos.id,this.nav.top.appendChild(this.nav.scrollpos),this.nav.select=document.createElement("input"),this.nav.select.type="hidden",this.nav.select.id=a.id+"_select",this.nav.select.name=this.nav.select.id,this.nav.select.value=null,this.nav.top.appendChild(this.nav.select),this.nav.scrollLayer=document.createElement("div"),this.nav.scrollLayer.style.position="absolute",this.nav.scrollLayer.style.top="0px",this.nav.scrollLayer.style.left="0px",this.nav.top.appendChild(this.nav.scrollLayer),this.nav.scrollUp=[],this.nav.scrollDown=[],this.nav.loading=document.createElement("div"),this.nav.loading.style.position="absolute",this.nav.loading.style.top="0px",this.nav.loading.style.left=this.hourWidth+5+"px",this.nav.loading.style.backgroundColor=this.loadingLabelBackColor,
this.nav.loading.style.fontSize=this.loadingLabelFontSize,this.nav.loading.style.fontFamily=this.loadingLabelFontFamily,this.nav.loading.style.color=this.loadingLabelFontColor,this.nav.loading.style.padding="2px",this.nav.loading.innerHTML=this.loadingLabelText,this.nav.loading.style.display="none",this.nav.top.appendChild(this.nav.loading)},this.$b=function(){for(var e="Fixed"===this.columnWidthSpec,t=this.nav.header&&this.nav.header.rows[this.nav.header.rows.length-1],i=this.nav.events.rows[0],n=0;n<a.va.length;n++){var o=t&&t.cells[n],r=i.cells[n],s=o&&o.firstChild,l=a.va[n];if(e){var d=l.width?l.width:a.columnWidth;s&&(s.style.width=d+"px"),r&&(r.style.width=d+"px")}else s&&(s.style.width=null),r&&(r.style.width=null)}},this.Da=function(){return this.nb?a.nav.bottomRight:a.nav.scroll},this.la=function(){var e="Fixed"===this.columnWidthSpec;if(!e){var t=a.Da();"Fixed"===this.heightSpec?t.style.overflowY="scroll":"BusinessHours"===this.heightSpec&&this.wa()<=this.businessEndsHour-this.businessBeginsHour?t.style.overflow="hidden":"Full"!==this.heightSpec&&"BusinessHoursNoScroll"!==this.heightSpec?t.style.overflow="auto":t.style.overflow="hidden"}if(e){var i=0,n=this.va.length*this.columnWidth;n>a.ob().clientWidth&&(i=DayPilot.sw(a.nav.bottomRight)),a.nav.headerParent&&(a.nav.headerParent.style.width=n+i+"px"),a.nav.main.style.width=n+"px",a.nav.events.style.width=n+"px",a.nav.crosshair.style.width=n+"px"}else a.nav.headerParent&&(a.nav.headerParent.style.width="100%"),a.nav.main.style.width="100%",a.nav.events.style.width="100%",a.nav.crosshair.style.width="100%";this.$b()},this.ia=function(){this.u?this._b():DayPilot.pu(this.nav.hourTable),this.nav.hoursPlaceholder&&(this.nav.hoursPlaceholder.innerHTML="",this.nav.hourTable=this.bc(),this.nav.hoursPlaceholder.appendChild(this.nav.hourTable))},this._b=function(){if(this.nav.hourTable)for(var e=0;e<this.nav.hourTable.rows.length;e++){var t=this.nav.hourTable.rows[e],i=t.cells[0].firstChild;i.data=null,i.onmousemove=null,i.onmouseout=null}},this.Zb=function(){var e=document.createElement("div");e.style.zoom=1,e.style.position="relative",e.onmousemove=this.cc,e.oncontextmenu=this.dc,DayPilot.re(e,DayPilot.touch.start,this.Sb.onMainTouchStart),DayPilot.re(e,DayPilot.touch.move,this.Sb.onMainTouchMove),DayPilot.re(e,DayPilot.touch.end,this.Sb.onMainTouchEnd),DayPilot.re(e,"contextmenu",function(e){var e=e||window.event;e.preventDefault?e.preventDefault():e.returnValue=!1}),navigator.msPointerEnabled&&(e.style.msTouchAction="none",e.style.touchAction="none"),e.daypilotMainD=!0,e.calendar=this;var t=null,i=null,n=null;if("Fixed"===this.columnWidthSpec||this.nb){if(this.showHours){var o=document.createElement("div");o.style.cssFloat="left",o.style.styleFloat="left",o.style.width=this.hourWidth+"px",o.style.height=this.Wb()+"px",o.style.overflow="hidden",o.style.position="relative",e.appendChild(o),t=o;var r=30,s=a.ec()+r;n=document.createElement("div"),n.style.height=s+"px",o.appendChild(n)}var l=document.createElement("div");l.style.height=this.Wb()+"px",this.showHours&&(l.style.marginLeft=this.hourWidth+"px"),l.style.position="relative",l.style.overflow="auto",e.appendChild(l),i=l}else{var d=document.createElement("table");d.cellSpacing="0",d.cellPadding="0",d.border="0",d.style.border="0px none",d.style.width="100%",d.style.position="relative";var c,h=d.insertRow(-1);this.showHours&&(c=h.insertCell(-1),c.style.verticalAlign="top",c.style.padding="0px",c.style.border="0px none",n=c),c=h.insertCell(-1),c.width="100%",c.style.padding="0px",c.style.border="0px none",c.style.verticalAlign="top",i=c,e.appendChild(d)}if(n&&(this.nav.hourTable=this.bc(),n.appendChild(this.nav.hourTable)),this.cssOnly||this.z){var u=document.createElement("div");u.style.height="0px",u.style.position="relative",u.appendChild(this.fc());var f=document.createElement("div");f.style.position="absolute",f.style.top="0px",f.style.left="0px",f.style.width="100%",f.style.height="0px",u.appendChild(f),this.nav.crosshair=f,u.appendChild(this.gc()),i.appendChild(u)}else i.appendChild(this.fc());return this.nav.zoom=e,this.nav.bottomLeft=t,this.nav.bottomRight=i,this.nav.hoursPlaceholder=n,e},this.fc=function(){var e=document.createElement("table");return e.cellPadding="0",e.cellSpacing="0",e.border="0","Fixed"===this.columnWidthSpec||(e.style.width="100%"),e.style.border="0px none",e.style.tableLayout="fixed",this.nav.main=e,this.nav.events=e,e},this.hc=function(){if("Fixed"===this.columnWidthSpec){for(var e=0,t=0;t<a.va.length;t++){var i=a.va[t];e+=i.width?i.width:a.columnWidth}return e+"px"}return"100%"},this.gc=function(){var e=document.createElement("table");e.style.position="absolute",e.style.top="0px",e.cellPadding="0",e.cellSpacing="0",e.border="0",e.style.width=a.hc(),e.style.border="0px none",e.style.tableLayout="fixed",this.nav.events=e;for(var t=this.va,i=t.length,n=e.insertRow(-1),o=0;o<i;o++){var r=n.insertCell(-1);r.style.padding="0px",r.style.border="0px none",r.style.height="0px",r.style.overflow="visible",a.rtl||(r.style.textAlign="left"),a.ic(r)}return e},this.bc=function(){var e=document.createElement("table");e.cellSpacing="0",e.cellPadding="0",e.border="0",e.style.border="0px none",e.style.width=this.hourWidth+"px",e.oncontextmenu=function(){return!1},e.onmousemove=function(){a.T()};for(var t=a.jc(),i=0;i<t;i++)this.kc(e,i);return e},this.jc=function(){return this.xa()/(60*this.timeHeaderCellDuration*1e3)},this.lc=function(){return 60*this.cellHeight/this.cellDuration/(60/this.timeHeaderCellDuration)},this.nc=function(){return(this.Ba()-this.Ba(!0))*(60/this.cellDuration)},this.oc=function(){return this.Ba()-this.Ba(!0)},this.rb=function(){return this.nc()*this.cellHeight},this.kc=function(e,t){var i=a.lc(),n=e.insertRow(-1);n.style.height=i+"px";var o=n.insertCell(-1);o.valign="bottom",o.setAttribute("unselectable","on"),o.style.padding="0px",o.style.border="0px none";var r=document.createElement("div");r.className=this.q("_rowheader"),r.style.position="relative",r.style.width=this.hourWidth+"px",r.style.height=i+"px",r.style.overflow="hidden",r.setAttribute("unselectable","on");var s=document.createElement("div");s.className=this.q("_rowheader_inner"),s.setAttribute("unselectable","on");var l=a.pc(t),d=l.html,c=l.data;c&&(r.data=c,r.onmousemove=a.qc,r.onmouseout=a.rc),s.innerHTML=d,r.appendChild(s),o.appendChild(r)},this.pc=function(e){var t,i;if(this.hours){var n=e+this.oc();i=this.hours[n],t=i.html}var o,r=this.timeHeaderCellDuration,s=this.startDate.addMinutes(r*e+60*this.Ba()),l=s.getHours(),d=l<12;if(o="Clock12Hours"===this.sc.timeFormat()?d?"AM":"PM":"00",!t){var c=document.createElement("div");c.setAttribute("unselectable","on"),"Clock12Hours"===this.sc.timeFormat()&&(l%=12,0===l&&(l=12)),60!==this.timeHeaderCellDuration&&(l+=":"+s.toString("mm")),c.innerHTML=l;var h=document.createElement("span");h.setAttribute("unselectable","on"),h.className=this.q("_rowheader_minutes"),h.innerHTML=o,c.appendChild(h),t=c.outerHTML}if("function"==typeof a.onBeforeTimeHeaderRender){var u={};u.header={},u.header.hours=l,u.header.minutes=s.getMinutes(),u.header.start=s.toString("HH:mm"),u.header.html=t,u.header.areas=i?i.areas:null,a.onBeforeTimeHeaderRender(u),null!==u.header.html&&(t=u.header.html),i=u.header}var f={};return f.start=s,f.hour=l,f.html=t,f.data=i,f.sup=o,f},this.qc=function(e){a.T();var t=this;t.active||DayPilot.Areas.showAreas(t,t.data)},this.rc=function(e){DayPilot.Areas.hideAreas(this,e)},this.Wb=function(){switch(this.heightSpec){case"Fixed":return this.height;case"Parent100Pct":return this.height;case"Full":return this.ec();case"BusinessHours":case"BusinessHoursNoScroll":return this.ya()*this.cellHeight*60/this.cellDuration;default:throw"DayPilot.Calendar: Unexpected 'heightSpec' value."}},this.ec=function(){return a.xa()*this.cellHeight/(6e4*a.cellDuration)},this.Ca=function(){if(!this.showHeader)return 0;var e=this.headerLevels*r.headerHeight();return this.showAllDayEvents&&r.allDayHeaderHeight()?e+r.allDayHeaderHeight():e},this.ea=function(){if(this.headerHeightAutoFit){for(var e=0,t=0;t<this.nav.header.rows.length;t++)for(var i=this.nav.header.rows[t],n=0;n<i.cells.length;n++){var a=i.cells[n],o=a.firstChild,r=o.firstChild,s=o.style.height;o.style.height="auto",r.style.position="static";var l=o.offsetHeight;o.style.height=s,r.style.position="",e=Math.max(e,l)}e>this.headerHeight&&(this.t.headerHeight=e,this.ca(),this.da())}},this.nb=!0,this.tc=function(){var e=this.nb?a.nav.bottomRight:a.nav.scroll;return DayPilot.sw(e)>0},this.Yb=function(){var e=document.createElement("div"),t="Fixed"===this.columnWidthSpec;t||(e.style.overflow="auto"),e.style.position="absolute",e.style.left="0px",e.style.right="0px";var i=document.createElement("div");i.style.position="relative",i.style.zoom="1";var n=null,t="Fixed"===this.columnWidthSpec;if(t||this.nb){var a=document.createElement("div");if(a.style.cssFloat="left",a.style.styleFloat="left",a.style.width=this.hourWidth+"px",this.showHours){var o=this.uc();this.nav.corner=o,a.appendChild(o),i.appendChild(a),this.nav.upperLeft=a}var r=document.createElement("div");this.showHours&&(r.style.marginLeft=this.hourWidth+"px"),r.style.position="relative",r.style.overflow="hidden",r.style.height=this.Ca()+"px",i.appendChild(r),this.nav.upperRight=r,n=document.createElement("div"),n.style.position="relative",r.appendChild(n)}else{var s=document.createElement("table");s.cellPadding="0",s.cellSpacing="0",s.border="0",s.style.width="100%",s.style.borderCollapse="separate",s.style.border="0px none";var l=s.insertRow(-1);if(this.nav.fullHeader=s,this.showHours){var d=l.insertCell(-1);d.style.padding="0px",d.style.border="0px none";var o=this.uc();d.appendChild(o),this.nav.corner=o}d=l.insertCell(-1),d.style.width="100%",d.valign="top",d.style.position="relative",d.style.padding="0px",d.style.border="0px none",n=document.createElement("div"),n.style.position="relative",n.style.height=this.Ca()+"px",n.style.overflow="hidden",d.appendChild(n),this.nav.mid=n,i.appendChild(s)}this.nav.headerParent=n,this.vc();var c=this.tc(),t="Fixed"===this.columnWidthSpec;return c&&!t&&this.wc(),e.appendChild(i),e},this.vc=function(){this.nav.unifiedCornerRight=null,this.nav.header=document.createElement("table"),this.nav.header.cellPadding="0",this.nav.header.cellSpacing="0";var e="Fixed"===this.columnWidthSpec;e||(this.nav.header.width="100%"),this.nav.header.style.tableLayout="fixed",this.nav.header.oncontextmenu=function(){return!1};this.tc();if(this.nav.headerParent.appendChild(this.nav.header),this.nav.allday&&DayPilot.de(this.nav.allday),this.showAllDayEvents){var t=document.createElement("div");t.style.position="absolute",t.style.top="0px",t.style.height="0px";var e="Fixed"===this.columnWidthSpec;e?t.style.width=this.va.length*this.columnWidth+"px":(t.style.left="0px",t.style.right="0px"),this.nav.allday=t,this.nav.headerParent.appendChild(t)}},this.wc=function(){if(this.nav.fullHeader){var e=this.nav.fullHeader.rows[0],t=e.insertCell(-1);t.style.padding="0px",t.style.verticalAlign="top",t.setAttribute("unselectable","on");var i=document.createElement("div");i.setAttribute("unselectable","on"),i.className=this.q("_cornerright"),i.style.overflow="hidden",i.style.position="relative",i.style.width="16px",i.style.height=this.Ca()+"px";var n=document.createElement("div");n.className=this.q("_cornerright_inner"),i.appendChild(n),t.appendChild(i),this.nav.cornerRight=i}},this.uc=function(){var e=document.createElement("div");e.style.position="relative",e.className=this.q("_corner"),e.style.width=this.hourWidth+"px",e.style.height=this.Ca()+"px",e.style.overflow="hidden",e.oncontextmenu=function(){return!1};var t=document.createElement("div");t.className=this.q("_corner_inner"),t.setAttribute("unselectable","on");var i=this.cornerHTML||this.cornerHtml;t.innerHTML=i?i:"",e.appendChild(t);var n=document.createElement("div");return n.style.position="absolute",n.style.padding="2px",n.style.top="0px",n.style.left="1px",n.style.backgroundColor="#FF6600",n.style.color="white",n.innerHTML="\u0044\u0045\u004D\u004F",n.setAttribute("unselectable","on"),DayPilot.Util.isNullOrUndefined(undefined)&&e.appendChild(n),e},this.N=function(){var e=this.nav.main;e.root=null,e.onmouseup=null;for(var t=0;t<e.rows.length;t++)for(var i=e.rows[t],n=0;n<i.cells.length;n++){var a=i.cells[n];a.root=null,a.onmousedown=null,a.onmousemove=null,a.onmouseout=null,a.onmouseup=null,a.onclick=null,a.ondblclick=null,a.oncontextmenu=null}this.u||DayPilot.pu(e)},this.fa=function(){for(var e=0;this.nav.scrollUp&&e<this.nav.scrollUp.length;e++)this.nav.scrollLayer.removeChild(this.nav.scrollUp[e]);for(var e=0;this.nav.scrollDown&&e<this.nav.scrollDown.length;e++)this.nav.scrollLayer.removeChild(this.nav.scrollDown[e]);this.nav.scrollUp=[],this.nav.scrollDown=[]},this.ic=function(e){var t=document.createElement("div");t.style.marginRight=a.columnMarginRight+"px",t.style.position="relative",t.style.height="1px",t.style.marginTop="-1px",e.events=t;var i=document.createElement("div");i.style.position="relative",t.style.height="1px",t.style.marginTop="-1px",e.separators=i,e.appendChild(i),e.appendChild(t)},this.ha=function(){var t=this.nav.main,i=60*this.cellDuration*1e3,n=this.Fa(),o=(this.oc()*(60/this.cellDuration),a.va),r=0;if(t&&(r=a.ob().scrollTop,this.N(),a.C.ielt9)){DayPilot.de(this.nav.scrollable.parentNode);var s=this.Zb();this.xc(),this.nav.scrollable=s.firstChild,this.nav.scroll.appendChild(s),t=this.nav.main}for(this.nav.scrollable.daypilotMainD=!0,this.nav.scrollable.calendar=this;t&&t.rows&&t.rows.length>0;)this.u||DayPilot.pu(t.rows[0]),t.deleteRow(0);if(this.yc=!0,this.scrollLabelsVisible)for(var o=this.va,l=this.showHours?this.hourWidth:0,d=(this.nav.scroll.clientWidth-l)/o.length,c=0;c<o.length;c++){var h=document.createElement("div");h.style.position="absolute",h.style.top="0px",h.style.left=l+2+c*d+d/2+"px",h.style.display="none";var u=document.createElement("div");u.style.height="10px",u.style.width="10px",u.className=this.q("_scroll_up"),h.appendChild(u),this.nav.scrollLayer.appendChild(h),this.nav.scrollUp.push(h);var f=document.createElement("div");f.style.position="absolute",f.style.top="0px",f.style.left=l+2+c*d+d/2+"px",f.style.display="none";var u=document.createElement("div");u.style.height="10px",u.style.width="10px",u.className=this.q("_scroll_down"),f.appendChild(u),this.nav.scrollLayer.appendChild(f),this.nav.scrollDown.push(f)}var v=o.length;if(this.cssOnly||this.z){for(var p=this.nav.events;p&&p.rows&&p.rows.length>0;)this.u||DayPilot.pu(p.rows[0]),p.deleteRow(0);for(var g=p.insertRow(-1),m=0;m<v;m++){var y=g.insertCell(-1);y.style.padding="0px",y.style.border="0px none",y.style.height="1px",y.style.overflow="visible";var b="Fixed"===this.columnWidthSpec;b&&(o[m].width?y.style.width=o[m].width+"px":y.style.width=this.columnWidth+"px"),a.rtl||(y.style.textAlign="left"),a.ic(y)}}for(var c=0;c<n;c++){var g=t.insertRow(-1),w=c;g.style.MozUserSelect="none",g.style.KhtmlUserSelect="none",g.style.WebkitUserSelect="none";for(var m=0;m<v;m++){var D=this.va[m],y=g.insertCell(-1);y.start=D.start.addTime(w*i).addHours(this.Ba()),y.end=y.start.addTime(i),y.resource=D.id,this.cellProperties||(this.cellProperties={});var k={};k.resource=y.resource,k.start=y.start,k.end=y.end;var C=m+"_"+w;if(k.cssClass=null,k.html=null,k.backImage=null,k.backRepeat=null,k.backColor=null,k.business=this.zc(y.start,y.end),this.cellProperties[C]&&DayPilot.Util.copyProps(this.cellProperties[C],k,["cssClass","html","backImage","backRepeat","backColor","business"]),"function"==typeof this.onBeforeCellRender){var x={};x.cell=k,this.onBeforeCellRender(x)}this.cellProperties[C]=k;var P,S=a.Ac(m,w);y.root=this,y.style.padding="0px",y.style.border="0px none",y.style.verticalAlign="top",y.style.height=a.cellHeight+"px",y.style.overflow="hidden",y.setAttribute("unselectable","on"),P=document.createElement("div"),P.className=a.q("_cell"),P.style.position="relative",P.style.height=a.cellHeight+"px",P.style.overflow="hidden",P.setAttribute("unselectable","on");var A=document.createElement("div");A.className=a.q("_cell_inner"),P.appendChild(A),y.appendChild(P),y.onmousedown=this.hb,y.onmousemove=this.kb,y.onmouseout=this.jb,DayPilot.re(y,DayPilot.touch.end,this.Sb.onCellTouchEnd),y.onmouseup=function(){return!1},y.onclick=function(){return!1},y.ondblclick=function(){if(e.firstMousePos=null,a.ib(),clearTimeout(e.selectedTimeout),"Disabled"!==a.timeRangeDoubleClickHandling){var t=a.getSelection();a.ab(t.start,t.end,t.resource)}},y.oncontextmenu=function(){return this.selected||(a.clearSelection(),e.column=e.getColumn(this),a.selectedCells.push(this),e.firstSelected=this,e.topSelectedCell=this,e.bottomSelectedCell=this,a.ib()),"Disabled"===a.timeRangeRightClickHandling,!1};var T=a.Bc(m,w);P=y.firstChild;var b="Fixed"===this.columnWidthSpec;b&&(D.width?P.style.width=D.width+"px":P.style.width=this.columnWidth+"px"),T&&(P.firstChild.style.background=T);(S?S.business:this.zc(y.start,y.end))&&DayPilot.Util.addClass(P,a.q("_cell_business"));var E=P.firstChild;if(E&&(E.innerHTML=""),P.style.backgroundImage="",P.style.backgroundRepeat="",S&&(S.html&&(E.innerHTML=S.html),S.cssClass&&DayPilot.Util.addClass(P,S.cssClass),S.backImage&&(P.style.backgroundImage="url('"+S.backImage+"')"),S.backRepeat&&(P.style.backgroundRepeat=S.backRepeat),S.areas)){var M={};M.start=y.start,M.end=y.end,M.resource=y.resource,DayPilot.Areas.attach(P,M,{"areas":S.areas})}}}t.onmouseup=this.lb,t.root=this,a.nav.scrollable.style.display="",a.ob().scrollTop=r},this.dc=function(e){if(!o.detected){var t=a.getSelection();if(t){var i={};if(i.start=t.start,i.end=t.end,i.resource=t.resource,i.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onTimeRangeRightClick&&(a.onTimeRangeRightClick(i),i.preventDefault.value))return!1;"ContextMenu"===a.timeRangeRightClickHandling&&a.contextMenuSelection&&a.contextMenuSelection.show(a.getSelection()),"function"==typeof a.onTimeRangeRightClicked&&a.onTimeRangeRightClicked(i)}}},this.zc=function(e,t){return this.businessBeginsHour<this.businessEndsHour?!(e.getHours()<this.businessBeginsHour||e.getHours()>=this.businessEndsHour||6===e.getDayOfWeek()||0===e.getDayOfWeek()):e.getHours()>=this.businessBeginsHour||e.getHours()<this.businessEndsHour},this.cc=function(t){t=t||window.event,t.insideMainD=!0,window.event&&window.event.srcElement&&(window.event.srcElement.inside=!0),e.activeCalendar=this;var i=a.nav.main;a.coords=DayPilot.mo3(i,t);var n=DayPilot.mc(t),o=a.crosshairType&&"Disabled"!==a.crosshairType,r=a.coords.x<a.hourWidth;if(DayPilot.Global.moving||DayPilot.Global.resizing||e.selecting||r?a.T():o&&a.Cc(),DayPilot.Global.resizing)a.Dc(n);else if(DayPilot.Global.moving){if(!DayPilot.Global.moving.helper)return void(e.movingShadow=null);if(!e.movingShadow){var s=3;if(!(DayPilot.distance(n,e.originalMouse)>s))return;e.movingShadow=a.ta(DayPilot.Global.moving,!a.C.ie,a.shadow),e.movingShadow.style.width=e.movingShadow.parentNode.offsetWidth+1+"px"}if(!a.coords)return;var l=a.cellHeight,d=0,c=e.moveOffsetY;c||(c=l/2),"Top"===this.moveBy&&(c=0);var h=Math.floor((a.coords.y-c-d+l/2)/l)*l+d;h<d&&(h=d);var u=a.nav.main,f=u.clientHeight,v=parseInt(e.movingShadow.style.height);h+v>f&&(h=f-v),e.movingShadow.style.top=h+"px";var p=u.clientWidth/u.rows[0].cells.length,g=Math.floor(a.coords.x/p);g<0&&(g=0),a.rtl&&(g=a.va.length-g-1);var m=a.nav.events;g<m.rows[0].cells.length&&g>=0&&e.movingShadow.column!==g&&(e.movingShadow.column=g,e.moveShadow(m.rows[0].cells[g]))}if(e.drag){if(e.gShadow&&document.body.removeChild(e.gShadow),e.gShadow=null,!e.movingShadow&&a.coords){var y=a.ta(e.drag,!1,e.drag.shadowType);if(y){e.movingShadow=y;var b=DayPilot.Date.today(),t={"value":e.drag.id,"start":b,"end":b.addSeconds(e.drag.duration),"text":e.drag.text},w=new DayPilot.Event(t,a);w.external=!0,DayPilot.Global.moving={},DayPilot.Global.moving.event=w,DayPilot.Global.moving.helper={}}}t.cancelBubble=!0}},this.Ec=function(t){e.movingShadow.offsetTop,DayPilot.Global.moving.event,e.movingShadow.column},this.Dc=function(t){if(!DayPilot.Global.resizing.event)return DayPilot.Global.resizing=null,DayPilot.de(e.resizingShadow),void(e.resizingShadow=null);e.resizingShadow||(e.resizingShadow=a.ta(DayPilot.Global.resizing,!1,a.shadow));var i=DayPilot.Global.resizing.event.calendar.cellHeight,n=0,o=t.y-e.originalMouse.y;if("bottom"===DayPilot.Global.resizing.dpBorder){var r=Math.floor((e.originalHeight+e.originalTop+o+i/2)/i)*i-e.originalTop+n;r<i&&(r=i);var s=DayPilot.Global.resizing.event.calendar.nav.main.clientHeight;e.originalTop+r>s&&(r=s-e.originalTop),e.resizingShadow.style.height=r+"px"}else if("top"===DayPilot.Global.resizing.dpBorder){var l=Math.floor((e.originalTop+o-n+i/2)/i)*i+n;l<n&&(l=n),l>e.originalTop+e.originalHeight-i&&(l=e.originalTop+e.originalHeight-i);var r=e.originalHeight-(l-e.originalTop);r<i?r=i:e.resizingShadow.style.top=l+"px",e.resizingShadow.style.height=r+"px"}},this.temp={},this.temp.getPosition=function(){var e=a.Fc.getCellCoords();if(!e)return null;var t=a.va[e.x],i={};return i.resource=t.id,i.start=new DayPilot.Date(t.start).addHours(a.Ba(!0)).addMinutes(e.y*a.cellDuration),i.end=i.start.addMinutes(a.cellDuration),i},this.Fc={},this.Fc.getCellCoords=function(){var e={};if(e.x=0,e.y=0,!a.coords)return null;for(var t=a.nav.main,i=a.coords.x,n=0,o=this.col(t,n);o&&i>o.left;)n+=1,o=this.col(t,n);e.x=n-1;var r=0,s=Math.floor((a.coords.y-r)/a.cellHeight);return e.y=s,e.x<0?null:e},this.Fc.col=function(e,t){var i={};if(i.left=0,i.width=0,!e)return null;if(!e.rows)return null;if(0===e.rows.length)return null;if(0==e.rows[0].cells.length)return null;var n=e.rows[0].cells[t];if(!n)return null;var a=DayPilot.abs(e),o=DayPilot.abs(n);return i.left=o.x-a.x,i.width=n.offsetWidth,i},this.Cc=function(){this.T(),this.elements.crosshair||(this.elements.crosshair=[]);var e=this.Fc.getCellCoords();if(e){var t=e.x,i=Math.floor(e.y/(60/a.cellDuration)*(60/a.timeHeaderCellDuration));if(!(i<0)){if(this.nav.hourTable){if(i>=this.nav.hourTable.rows.length)return;var n=document.createElement("div");n.style.position="absolute",n.style.left="0px",n.style.right="0px",n.style.top="0px",n.style.bottom="0px",n.style.opacity=.5,n.style.backgroundColor=this.crosshairColor,n.style.opacity=this.crosshairOpacity/100,n.style.filter="alpha(opacity="+this.crosshairOpacity+")",this.nav.hourTable.rows[i].cells[0].firstChild.appendChild(n),this.elements.crosshair.push(n)}if(this.nav.header){var o=document.createElement("div");o.style.position="absolute",o.style.left="0px",o.style.right="0px",o.style.top="0px",o.style.bottom="0px",o.style.opacity=.5,o.style.backgroundColor=this.crosshairColor,o.style.opacity=this.crosshairOpacity/100,o.style.filter="alpha(opacity="+this.crosshairOpacity+")";var r=this.nav.header.rows[this.headerLevels-1];r.cells[t]&&(r.cells[t].firstChild.appendChild(o),this.elements.crosshair.push(o))}if("Header"!==this.crosshairType){var s=this.nav.crosshair,l=0,d=Math.floor((a.coords.y-l)/a.cellHeight)*a.cellHeight+l,c=a.cellHeight,h=document.createElement("div");h.style.position="absolute",h.style.left="0px",h.style.right="0px",h.style.top=d+"px",h.style.height=c+"px",h.style.backgroundColor=this.crosshairColor,h.style.opacity=this.crosshairOpacity/100,h.style.filter="alpha(opacity="+this.crosshairOpacity+")",h.onmousedown=this.Gc,s.appendChild(h),this.elements.crosshair.push(h);var u=this.Fc.col(this.nav.main,t);if(c=this.nav.main.clientHeight,u){var f=document.createElement("div");f.style.position="absolute",f.style.left=u.left+"px",f.style.width=u.width+"px",f.style.top="0px",f.style.height=c+"px",f.style.backgroundColor=this.crosshairColor,f.style.opacity=this.crosshairOpacity/100,f.style.filter="alpha(opacity="+this.crosshairOpacity+")",f.onmousedown=this.Gc,s.appendChild(f),this.elements.crosshair.push(f)}}}}},this.Gc=function(e){a.T();var t=a.Fc.getCellCoords(),i=0,n=a.nav.main.rows[t.y+i].cells[t.x];a.hb.apply(n,[e])},this.T=function(){if(this.elements.crosshair&&0!==this.elements.crosshair.length){for(var e=0;e<this.elements.crosshair.length;e++){var t=this.elements.crosshair[e];t&&t.parentNode&&t.parentNode.removeChild(t)}this.elements.crosshair=[]}},this.aa=function(){if(this.cellConfig){var e=this.cellConfig;if(e.vertical)for(var t=0;t<e.x;t++)for(var i=this.cellProperties[t+"_0"],n=1;n<e.y;n++)this.cellProperties[t+"_"+n]=i;if(e.horizontal)for(var n=0;n<e.y;n++)for(var i=this.cellProperties["0_"+n],t=1;t<e.x;t++)this.cellProperties[t+"_"+n]=i;if(e["default"])for(var i=e["default"],n=0;n<e.y;n++)for(var t=0;t<e.x;t++)this.cellProperties[t+"_"+n]||(this.cellProperties[t+"_"+n]=i)}},this.Ac=function(e,t){return this.cellProperties?this.cellProperties[e+"_"+t]:null},this.Hc=function(e,t){var i=e+"_"+t;return!(!this.cellProperties||!this.cellProperties[i])&&this.cellProperties[i].business},this.Bc=function(e,t){var i=e+"_"+t;return this.cellProperties&&this.cellProperties[i]?this.cellProperties[i].backColor:null},this.O=function(){var e=this.nav.header;if(e&&e.rows)for(var t=0;t<e.rows.length;t++)for(var i=e.rows[t],n=0;n<i.cells.length;n++){var a=i.cells[n];a.onclick=null,a.onmousemove=null,a.onmouseout=null}this.u||DayPilot.pu(e)},this.Ic=function(e,t){for(var i=t?this.nav.header.insertRow(-1):this.nav.header.rows[e-1],n=this.Kb(e),o=n.length,s=e===a.headerLevels,l=0;l<o;l++){var d=n[l];if(a.sa()&&"function"==typeof a.onBeforeHeaderRender){var c={};c.header={},DayPilot.Util.copyProps(d,c.header,["id","start","name","html","backColor","toolTip","areas","children"]),this.onBeforeHeaderRender(c),DayPilot.Util.copyProps(c.header,d,["html","backColor","toolTip","areas"])}var h=!!d.getChildren,u=t?i.insertCell(-1):i.cells[l];if(u.data=d,s);else{var f=1;h&&(f=d.getChildrenCount(a.headerLevels-e+1)),u.colSpan=f}h&&(u.onclick=this.Ma,u.onmousemove=this.Na,u.onmouseout=this.Oa,d.toolTip&&(u.title=d.toolTip)),u.style.overflow="hidden",u.style.padding="0px",u.style.border="0px none",u.style.height=r.headerHeight()+"px";var v=t?document.createElement("div"):u.firstChild;if(t){v.setAttribute("unselectable","on"),v.style.MozUserSelect="none",v.style.KhtmlUserSelect="none",v.style.WebkitUserSelect="none",v.style.position="relative",v.style.height=r.headerHeight()+"px",v.className=a.q("_colheader");var p=document.createElement("div");p.className=a.q("_colheader_inner"),d.backColor&&(p.style.background=d.backColor),v.appendChild(p),u.appendChild(v)}else v.style.height=r.headerHeight()+"px";this.Jc(v,d),h&&(v.firstChild.innerHTML=d.html)}},this.Jc=function(t,i){for(var n=[],a=0;a<t.childNodes.length;a++){var o=t.childNodes[a];o.isActiveArea&&n.push(o)}for(var a=0;a<n.length;a++){var o=n[a];DayPilot.de(o)}if(i.areas)for(var r=i.areas,a=0;a<r.length;a++){var s=r[a];if("Visible"===s.v){var l=new e.Column(i.id,i.name,i.start),d=DayPilot.Areas.createArea(t,l,s);t.appendChild(d)}}},this.da=function(){if(this.showHeader){var e=this.nav.header,t=!0,i=this.Kb(a.headerLevels,!0),n=i.length;for(this.Kc&&a.C.ielt9?(DayPilot.de(this.nav.header),this.vc()):this.Lc.scope&&(DayPilot.de(this.nav.header),this.vc());this.Kc&&e&&e.rows&&e.rows.length>0;)this.u||DayPilot.pu(e.rows[0]),e.deleteRow(0);this.Kc=!0;var o=a.cornerHTML||a.cornerHtml,s=a.nav.corner;s&&(this.u||DayPilot.pu(s.firstChild),s.firstChild.innerHTML=o?o:"");for(var l=0;l<a.headerLevels;l++)this.Ic(l+1,t);if(this.showAllDayEvents)for(var d=this.nav.header.insertRow(-1),l=0;l<n;l++){var c=i[l],h=d.insertCell(-1);h.data=c,h.style.padding="0px",h.style.border="0px none",h.style.overflow="hidden";var u=document.createElement("div");u.setAttribute("unselectable","on"),u.style.MozUserSelect="none",u.style.KhtmlUserSelect="none",u.style.WebkitUserSelect="none",u.style.overflow="hidden",u.style.position="relative",u.style.height=r.allDayHeaderHeight()+"px",u.className=this.q("_alldayheader");var f=document.createElement("div");f.className=this.q("_alldayheader_inner"),u.appendChild(f),h.appendChild(u),u.style.height=r.allDayHeaderHeight()+"px"}}},this.H=function(){this.loadingLabelVisible&&this.nav.loading&&(this.nav.loading.innerHTML=this.loadingLabelText,this.nav.loading.style.top=this.Ca()+5+"px",this.nav.loading.style.display="")},this.X=function(){this.callbackTimeout&&window.clearTimeout(this.callbackTimeout),this.nav.loading&&(this.nav.loading.style.display="none")},this.Mc=function(e){var t=a.Ba(!0);return e<t&&(e+=24),(e-t)*(60/a.cellDuration)*a.cellHeight},this.xc=function(){var e=this.ob(),t=this.initScrollPos;if(!t){var i=this.businessBeginsHour;t=a.Mc(i)}e.root=this,e.onscroll=this.mb,0===e.scrollTop?e.scrollTop=t-this.rb():this.mb()},this.Nc=function(){var e=a.nav.top;return e.offsetWidth>0&&e.offsetHeight>0},this.Oc=function(){var e=a.Nc;e()||a.Pc||(a.Pc=setInterval(function(){e()&&(clearInterval(a.Pc),a.xc(),a.ka())},100))},this.scrollToY=function(e){this.ob().scrollTop=e},this.scrollToHour=function(e){var t=a.Mc(e);this.ob().scrollTop=t-this.rb()},this.ob=function(){return"Fixed"===this.columnWidthSpec||this.nb?this.nav.bottomRight:this.nav.scroll},this.onCallbackError=function(e,t){alert("Error!\r\nResult: "+e+"\r\nContext:"+t)},this.ka=function(){if(a.showHeader){var e=this.tc(),t=!!this.nav.cornerRight;if(this.nb){this.nav.unifiedCornerRight&&DayPilot.de(this.nav.unifiedCornerRight);var i=this.hc();if("100%"!=i&&parseInt(i)<this.ob().clientWidth)return;var n=DayPilot.sw(this.nav.bottomRight);this.nav.unifiedCornerRight=this.nav.header.rows[0].insertCell(-1);var o=this.nav.unifiedCornerRight;o.rowSpan=this.nav.header.rows.length,o.style.width=n+"px";var r=document.createElement("div");r.className=a.q("_cornerright"),r.setAttribute("unselectable","on"),r.style.overflow="hidden",r.style.height=this.Ca()+"px",r.style.position="relative";var s=document.createElement("div");s.className=a.q("_cornerright_inner"),r.appendChild(s),o.appendChild(r);return void(!("Fixed"===this.columnWidthSpec)&&this.nav.allday&&(this.nav.allday.style.right=n+"px"))}if(e!==t)if(e)this.wc();else{if(this.nav.fullHeader&&3===this.nav.fullHeader.rows[0].cells.length){var o=this.nav.fullHeader.rows[0].cells[2];o.parentNode&&o.parentNode.removeChild(o)}this.nav.cornerRight=null}var l=this.nav.cornerRight;if(l){var n=DayPilot.sw(a.Da());return l&&(l.style.width=n+"px"),n}}},this.ra=function(e){if(e&&(this.autoRefreshEnabled=!0),this.autoRefreshEnabled&&!(this.B>=this.autoRefreshMaxCount)){this.L();var t=this.autoRefreshInterval;if(!t||t<10)throw"The minimum autoRefreshInterval is 10 seconds";this.autoRefreshTimeout=window.setTimeout(function(){a.Qc()},1e3*this.autoRefreshInterval)}},this.L=function(){this.autoRefreshTimeout&&window.clearTimeout(this.autoRefreshTimeout)},this.Qc=function(){if(!(DayPilot.Global.resizing||DayPilot.Global.moving||e.drag||e.selecting)){var t=!1;if("function"==typeof this.onAutoRefresh){var i={};i.i=this.B,i.preventDefault=function(){this.preventDefault.value=!0},a.onAutoRefresh(i),i.preventDefault.value&&(t=!0)}!t&&this.r()&&this.commandCallBack(this.autoRefreshCommand),this.B++}this.B<this.autoRefreshMaxCount&&(this.autoRefreshTimeout=window.setTimeout(function(){a.Qc()},1e3*this.autoRefreshInterval))},this.P=function(){a.ja(),"Parent100Pct"===a.heightSpec&&a.setHeight(parseInt(a.nav.top.clientHeight,10)),a.ka(),a.qa()},this.Rc=function(){e.globalHandlers||(e.globalHandlers=!0,DayPilot.re(document,"mousemove",e.gMouseMove),DayPilot.re(document,"mouseup",e.gMouseUp),DayPilot.re(document,DayPilot.touch.move,e.gTouchMove),DayPilot.re(document,DayPilot.touch.end,e.gTouchEnd)),DayPilot.re(window,"resize",this.P)},this.Rb=function(t){if(!o.active&&!o.using){t=t||window.event;var i=DayPilot.Util.mouseButton(t);if("undefined"!=typeof DayPilot.Bubble&&DayPilot.Bubble.hideActive(),"n-resize"!==this.style.cursor&&"s-resize"!==this.style.cursor||!i.left){if(("move"===this.style.cursor||"Full"===a.moveBy&&this.event.client.moveEnabled())&&i.left){DayPilot.Global.moving=this;var n=DayPilot.Global.moving.helper={};n.oldColumn=a.va[this.event.part.dayIndex].id,e.originalMouse=DayPilot.mc(t),
e.originalTop=this.offsetTop;var r=DayPilot.mo3(this,t);r?e.moveOffsetY=r.y:e.moveOffsetY=0,a.nav.top.style.cursor=this.style.cursor}}else DayPilot.Global.resizing=this,e.originalMouse=DayPilot.mc(t),e.originalHeight=this.offsetHeight,e.originalTop=this.offsetTop,a.nav.top.style.cursor=this.style.cursor;return!1}},this.Sc=function(e){var t=this.t.events,i=this.events.list[e],n={};for(var o in i)n[o]=i[o];if(a.showEventStartEnd){var s=i.start.getDatePart().getTime()===i.end.getDatePart().getTime(),l=s?r.locale().timePattern:r.locale().dateTimePattern,d=i.start.toString(l),c=i.end.toString(l);n.html=n.text+" ("+d+" - "+c+")"}if("function"==typeof this.onBeforeEventRender){var h={};h.e=n,h.data=n,this.onBeforeEventRender(h)}t[e]=n},this.Sb={};var o=a.Sb;o.active=!1,o.start=null,o.timeout=null,o.startcell=null,this.Sb.getCellCoords=function(e){var t,i;e.touches?(t=e.touches[0].pageX,i=e.touches[0].pageY):(t=e.pageX,i=e.pageY);var n=DayPilot.abs(a.nav.main),o={x:t-n.x,y:i-n.y},r=a.nav.main.clientWidth/a.va.length;return{"pageX":t,"pageY":i,"x":Math.floor(o.x/r),"y":Math.floor(o.y/a.cellHeight),"toString":function(){return"x: "+this.x+" y:"+this.y}}},this.Sb.startSelecting=function(t){var i=a.nav.main.rows[t.y].cells[t.x];o.startcell=t,a.clearSelection(),e.column=e.getColumn(i),a.selectedCells.push(i),e.firstSelected=i,e.topSelectedCell=i,e.bottomSelectedCell=i,a.ib()},this.Sb.extendSelection=function(t){var i=a.nav.main.rows[t.y].cells[t.x];a.clearSelection(),t.y<o.startcell.y?(a.selectedCells=e.getCellsBelow(i),e.topSelectedCell=a.selectedCells[0],e.bottomSelectedCell=e.firstSelected):(a.selectedCells=e.getCellsAbove(i),e.topSelectedCell=e.firstSelected,e.bottomSelectedCell=a.selectedCells[0]),a.ib()},this.Sb.detected=!1,this.Sb.onMainTouchStart=function(e){if(!(DayPilot.Util.isMouseEvent(e)||(o.start=!0,o.detected=!0,o.active||e.touches.length>1))){o.using=!0;var t=o.getCellCoords(e);o.startCoords=t;var i=a.tapAndHoldTimeout;o.timeout=window.setTimeout(function(){switch(e.preventDefault(),o.active=!0,o.start=!1,a.timeRangeTapAndHoldHandling){case"Select":o.startSelecting(t);break;case"ContextMenu":o.startSelecting(t),o.active=!1,a.contextMenuSelection&&a.contextMenuSelection.show(a.getSelection())}},i)}},this.Sb.onCellTouchMove=function(e){},this.Sb.onCellTouchEnd=function(t){if(!o.active)return window.clearTimeout(o.timeout),void(o.start&&!function(t){if("Disabled"!==a.timeRangeSelectedHandling){a.clearSelection(),a.selectedCells=[t],e.topSelectedCell=t,e.bottomSelectedCell=t,a.ib();var i=a.getSelection();i.toString=function(){return"start: "+this.start+"\nend: "+this.end},setTimeout(function(){a._a(i.start,i.end,i.resource)},10)}}(this));t.preventDefault(),o.startcell=null,o.start=!1;var i=a.getSelection();i.toString=function(){return"start: "+this.start+"\nend: "+this.end},a._a(i.start,i.end,i.resource),window.setTimeout(function(){o.active=!1},500)},this.Sb.startMoving=function(t,i){DayPilot.Global.moving=t,(DayPilot.Global.moving.helper={}).oldColumn=a.va[t.event.part.dayIndex].id,e.originalMouse=i,e.originalTop=this.offsetTop;var n=DayPilot.abs(t);e.moveOffsetY=i.y-n.y,e.movingShadow||(e.movingShadow=a.ta(DayPilot.Global.moving,!a.C.ie,a.shadow),e.movingShadow.style.width=e.movingShadow.parentNode.offsetWidth+1+"px")},this.Sb.startResizing=function(t,i,n){DayPilot.Global.resizing=t,t.dpBorder=i,e.originalMouse=n,e.originalHeight=t.offsetHeight,e.originalTop=t.offsetTop},this.Sb.updateResizing=function(e){a.Dc(e)},this.Sb.updateMoving=function(){var t=a.coords,i=a.cellHeight,n=0,o=e.moveOffsetY;o||(o=i/2);var r=Math.floor((t.y-o-n+i/2)/i)*i+n;r<n&&(r=n);var s=a.nav.main,l=s.clientHeight,d=parseInt(e.movingShadow.style.height);r+d>l&&(r=l-d),e.movingShadow.style.top=r+"px";var c=s.clientWidth/s.rows[0].cells.length,h=Math.floor(t.x/c);h<0&&(h=0);var u=a.nav.events;h<u.rows[0].cells.length&&h>=0&&e.movingShadow.column!==h&&(e.movingShadow.column=h,e.moveShadow(u.rows[0].cells[h]))},this.Sb.onEventTouchStart=function(e){if(!o.active&&!DayPilot.Util.isMouseEvent(e)){e.stopPropagation(),o.preventEventTap=!1,o.using=!0,o.startCoords=o.getCellCoords(e);var t=this,i=e.touches?e.touches[0].pageX:e.pageX,n=e.touches?e.touches[0].pageY:e.pageY,r={x:i,y:n,div:this};a.coords=o.relativeCoords(e);var s=a.tapAndHoldTimeout;o.timeout=window.setTimeout(function(){var i=t.event;switch(o.active=!0,a.eventTapAndHoldHandling){case"Move":i.client.moveEnabled()&&o.startMoving(t,r);break;case"ContextMenu":var n=i.client.contextMenu();DayPilot.Menu&&DayPilot.Menu.touchPosition(e),n?n.show(i):a.contextMenu&&a.contextMenu.show(i)}},s)}},this.Sb.onMainTouchMove=function(t){if(!DayPilot.Util.isMouseEvent(t)){if(o.start=!1,o.timeout){var i=o.getCellCoords(t);i&&o.startCoords&&(i.pageX===o.startCoords.pageX&&i.pageY===o.startCoords.pageY||window.clearTimeout(a.Sb.timeout))}if(DayPilot.Global.moving&&e.movingShadow)return t.preventDefault(),a.coords=o.relativeCoords(t),void o.updateMoving();if(DayPilot.Global.resizing){t.preventDefault();var n=t.touches?t.touches[0]:t,i={x:n.pageX,y:n.pageY};return void o.updateResizing(i)}if(o.startcell){if(t.preventDefault(),!o.active)return void window.clearTimeout(o.timeout);var i=o.getCellCoords(t);o.extendSelection(i)}o.preventEventTap=!0}},this.Sb.relativeCoords=function(e){var t=a.nav.main,i=e.touches?e.touches[0].pageX:e.pageX,n=e.touches?e.touches[0].pageY:e.pageY,o=DayPilot.abs(t);return{x:i-o.x,y:n-o.y,"toString":function(){return"x: "+this.x+", y:"+this.y}}},this.Sb.onMainTouchEnd=function(t){if(!DayPilot.Util.isMouseEvent(t))if(DayPilot.Global.moving){o.active=!1,t.preventDefault(),t.stopPropagation();var i=e.movingShadow.offsetTop;e.deleteShadow(e.movingShadow);var n=DayPilot.Global.moving.event,r=e.movingShadow.column;DayPilot.Global.moving=null,e.movingShadow=null,n.calendar.Ua(n,r,i,t,e.drag)}else if(o.startcell){if(!o.active)return void window.clearTimeout(o.timeout);t.preventDefault(),o.startcell=null;var s=a.getSelection();s.toString=function(){return"start: "+this.start+"\nend: "+this.end},a._a(s.start,s.end,s.resource),window.setTimeout(function(){o.active=!1},500)}},this.Sb.onEventTouchMove=function(e){o.preventEventTap=!0},this.Sb.onEventTouchEnd=function(e){if(!DayPilot.Util.isMouseEvent(e)){if(!o.active){if(o.preventEventTap)return;return e.preventDefault(),window.clearTimeout(o.timeout),void a.Ha(this,!1,!1,e)}return o.active=!1,o.timeout?void window.clearTimeout(o.timeout):void e.preventDefault()}},this.Pb=function(t){var i=5,n=Math.max(a.durationBarWidth,10),o="Top"===a.moveBy;if("undefined"!=typeof e){var r=DayPilot.mo3(this,t);if(r){var s=this;if(!s.active){var l=[];s.event.client.deleteEnabled()&&l.push({"action":"JavaScript","v":"Hover","w":17,"h":17,"top":2,"right":2,"css":a.q("_event_delete"),"js":function(e){a.Pa(e)}});var d=s.event.cache?s.event.cache.areas:s.event.data.areas;d&&d.length>0&&(l=l.concat(d)),DayPilot.Areas.showAreas(s,s.event,null,l),DayPilot.Util.addClass(s,a.q("_event_hover"))}if(!DayPilot.Global.resizing&&!DayPilot.Global.moving){var c=this.isFirst,h=this.isLast;if("Disabled"!==a.moveBy&&"None"!==a.moveBy&&(!o&&r.x<=n&&this.event.client.moveEnabled()?c?this.style.cursor="move":this.style.cursor="not-allowed":!o&&r.y<=i&&this.event.client.resizeEnabled()?c?(this.style.cursor="n-resize",this.dpBorder="top"):this.style.cursor="not-allowed":o&&r.y<=n&&this.event.client.moveEnabled()?this.style.cursor="move":this.offsetHeight-r.y<=i&&this.event.client.resizeEnabled()?h?(this.style.cursor="s-resize",this.dpBorder="bottom"):this.style.cursor="not-allowed":DayPilot.Global.resizing||DayPilot.Global.moving||(this.event.client.clickEnabled()?this.style.cursor="pointer":this.style.cursor="default"),"undefined"!=typeof DayPilot.Bubble&&a.bubble&&"Disabled"!==a.eventHoverHandling&&("default"===this.style.cursor||"pointer"===this.style.cursor))){this.Tc&&r.x===this.Tc.x&&r.y===this.Tc.y||(this.Tc=r,a.bubble.showEvent(this.event))}}}}},this.Qb=function(e){DayPilot.Util.removeClass(this,a.q("_event_hover")),a.bubble&&a.bubble.hideOnMouseOut(),DayPilot.Areas.hideAreas(this,e)},this.Uc=null,this.ma=function(){if(this.showCurrentTime){this.Vc();var e=(new DayPilot.Date).addMinutes(a.showCurrentTimeOffset);if("Full"===a.showCurrentTimeMode)this.Wc(e);else{if("Day"!==a.showCurrentTimeMode)throw"Invalid DayPilot.Calendar.showCurrentTimeMode value: "+a.showCurrentTimeMode;this.Xc(e)}if(this.nav.events&&!this.Uc){this.Uc=setTimeout(function(){a.Uc=null,a.ma()},3e4)}}},this.Vc=function(){DayPilot.de(a.elements.separators),a.elements.separators=[]},this.Xc=function(e){var t=e.getTime(),i=a.nav.events;if(i)for(var n=0;n<a.va.length;n++){var o=a.va[n],r=a.xa(!0),s=new DayPilot.Date(o.start).addHours(this.Ba(!0)),l=s.getTime(),d=s.addTime(r),c=d.getTime();if(l<=t&&t<=c){var h=this.Yc(e,o.start).top-1,u=i.rows[0].cells[n],f=u.separators,v=document.createElement("div");v.style.position="absolute",v.style.top=h+"px",v.style.height="1px",v.style.left="0px",v.style.right="0px",v.className=a.q("_now"),f.insertBefore(v,f.firstChild),a.elements.separators.push(v)}}},this.Wc=function(e){var t=e.getTime();if(a.nav.events){var i=a.va[0];if(i)for(var n=i.start.getDatePart().addTime(e.getTimePart()),o=this.Yc(n,i.start).top-1,r=0;r<a.va.length;r++){var i=a.va[r],s=a.xa(!0),l=new DayPilot.Date(i.start).addHours(this.Ba(!0)),d=l.getTime(),c=l.addTime(s),h=c.getTime();if(d<=t&&t<=h){var u=document.createElement("div");return u.style.position="absolute",u.style.top=o+"px",u.style.height="1px",u.style.left="0px",u.style.right="0px",u.className=a.q("_now"),a.nav.events.appendChild(u),void a.elements.separators.push(u)}}}},this.ba=function(e){if(e?this.events.list=e:e=this.events.list,e){this.Nb={},this.Nb.events=[],this.Nb.lines=[];var t=e.length,i=this.xa(!0);this.t.pixels={};var n=[];this.qb=[],this.Ra=1e4,this.Aa=0,this.startDate=new DayPilot.Date(this.startDate);for(var o=0;o<t;o++){var s=e[o];s.start=new DayPilot.Date(s.start),s.end=new DayPilot.Date(s.end)}if("function"==typeof this.onBeforeEventRender||a.showEventStartEnd)for(var o=0;o<t;o++)this.Sc(o);for(var l="Resources"===this.viewType,d=this.Lb(),c=d.start,h=d.end,o=0;o<this.va.length;o++){var u={};u.minEnd=1e6,u.maxStart=-1,this.qb.push(u);var f=this.va[o];f.events=[],f.lines=[],f.blocks=[];var v=new DayPilot.Date(f.start).addHours(this.Ba(!0)),p=v.getTime(),g=v.addTime(i),m=g.getTime();l&&(c=v.getDatePart(),h=g.getDatePart());for(var y=0;y<t;y++)if(!n[y]){var s=e[y],b=null;if("function"==typeof a.onBeforeEventRender&&(b=a.t.events[y]),b){if(b.hidden)continue}else if(s.hidden)continue;var w=s.start,D=s.end,k=w.getTime(),C=D.getTime();if(!(C<k))if(s.allday){var x=!1;if(x=k===C?!(C<c.getTime()||k>=h.getTime()):"Date"===a.allDayEnd?!(C<c.getTime()||k>=h.getTime()):!(C<=c.getTime()||k>=h.getTime()),l&&(x=x&&(s.resource===f.id||"*"===f.id)),x){var P=new DayPilot.Event(s,this);if(P.part.start=c.getTime()<k?w:c,P.part.end=h.getTime()>C?D:h,P.part.colStart=DayPilot.DateUtil.daysDiff(c,P.part.start),P.part.colWidth=DayPilot.DateUtil.daysSpan(P.part.start,P.part.end)+1,l&&(P.part.colStart=o,P.part.colWidth=1),"function"==typeof a.onEventFilter&&a.events.Zc){var S={};if(S.filter=a.events.Zc,S.visible=!0,S.e=P,a.onEventFilter(S),!S.visible)continue}this.Nb.events.push(P),("function"==typeof this.onBeforeEventRender||a.showEventStartEnd)&&(P.cache=this.t.events[y]),n[y]=!0,!l||P.part.start.getTime()===k&&P.part.end.getTime()===C||(n[y]=!1)}}else{var b=null;if("function"==typeof a.onBeforeEventRender&&(b=a.t.events[y]),b){if(b.hidden)continue}else if(s.hidden)continue;var x=!1;if(x=l?f.id===s.resource&&!(C<=p||k>=m):!(C<=p||k>=m)||C===k&&k===p){var P=new DayPilot.Event(s,a);P.part.dayIndex=o,P.part.start=p<k?w:v,P.part.end=m>C?D:g;var A=this.Yc(P.part.start,f.start),T=this.Yc(P.part.end,f.start),E=A.top,M=T.top;if(E===M&&(A.cut||T.cut))continue;P.part.box=r.useBox(C-k);var H=0;if(P.part.box){var _=T.boxBottom;P.part.top=Math.floor(E/this.cellHeight)*this.cellHeight+H,P.part.height=Math.max(Math.ceil(_/this.cellHeight)*this.cellHeight-P.part.top,this.cellHeight-1),P.part.barTop=Math.max(E-P.part.top-1,0),P.part.barHeight=Math.max(M-E-2,1)}else P.part.top=E+H,P.part.height=Math.max(M-E,0),P.part.barTop=0,P.part.barHeight=Math.max(M-E-2,1);if("function"==typeof a.onEventFilter&&a.events.Zc){var S={};if(S.filter=a.events.Zc,S.visible=!0,S.e=P,a.onEventFilter(S),!S.visible)continue}var w=P.part.top,D=P.part.top+P.part.height;w>u.maxStart&&(u.maxStart=w),D<u.minEnd&&(u.minEnd=D),w<this.Ra&&(this.Ra=w),D>this.Aa&&(this.Aa=D),f.events.push(P),("function"==typeof this.onBeforeEventRender||a.showEventStartEnd)&&(P.cache=this.t.events[y]),P.part.start.getTime()===k&&P.part.end.getTime()===C&&(n[y]=!0)}}}}for(var o=0;o<this.va.length;o++){var f=this.va[o];f.events.sort(this.$c);for(var y=0;y<f.events.length;y++){var s=f.events[y];f.putIntoBlock(s)}for(var y=0;y<f.blocks.length;y++){var R=f.blocks[y];R.events.sort(this._c);for(var B=0;B<R.events.length;B++){var s=R.events[B];R.putIntoLine(s)}}}this.Nb.events.sort(this._c),this.Nb.putIntoLine=function(e){for(var t=0;t<this.lines.length;t++){var i=this.lines[t];if(i.isFree(e.part.colStart,e.part.colWidth))return i.push(e),t}var i=[];return i.isFree=function(e,t){for(var i=e+t-1,n=this.length,a=0;a<n;a++){var o=this[a];if(!(i<o.part.colStart||e>o.part.colStart+o.part.colWidth-1))return!1}return!0},i.push(e),this.lines.push(i),this.lines.length-1};for(var o=0;o<this.Nb.events.length;o++){var s=this.Nb.events[o];this.Nb.putIntoLine(s)}var N=Math.max(this.Nb.lines.length,1);this.t.allDayHeaderHeight=N*(r.allDayEventHeight()+2)+2}},this.$c=function(e,t){if(!(e&&t&&e.start&&t.start))return 0;var i=e.start().ticks-t.start().ticks;return 0!==i?i:t.end().ticks-e.end().ticks},this._c=function(e,t){if(!e||!t)return 0;if(!(e.data&&t.data&&e.data.sort&&t.data.sort&&0!==e.data.sort.length&&0!==t.data.sort.length))return a.$c(e,t);for(var i=0,n=0;0===i&&"undefined"!=typeof e.data.sort[n]&&"undefined"!=typeof t.data.sort[n];)i=e.data.sort[n]===t.data.sort[n]?0:"number"==typeof e.data.sort[n]&&"number"==typeof t.data.sort[n]?e.data.sort[n]-t.data.sort[n]:a.ad(e.data.sort[n],t.data.sort[n],a.sortDirections[n]),n++;return i},this.ad=function(e,t,i){var n="desc"!==i,a=n?-1:1,o=-a;if(null===e&&null===t)return 0;if(null===t)return o;if(null===e)return a;var r=[];return r[0]=e,r[1]=t,r.sort(),e===r[0]?a:o},this.bd=function(e){for(var t=0;t<a.elements.events.length;t++){var i=a.elements.events[t];if(i.event===e||i.event.data===e.data)return i}return null},this.events.find=function(e){if(!a.events.list||"undefined"==typeof a.events.list.length)return null;for(var t=a.events.list.length,i=0;i<t;i++)if(a.events.list[i].id===e)return new DayPilot.Event(a.events.list[i],a);return null},this.events.findRecurrent=function(e,t){if(!a.events.list||"undefined"==typeof a.events.list.length)return null;for(var i=a.events.list.length,n=0;n<i;n++)if(a.events.list[n].recurrentMasterId===e&&a.events.list[n].start.getTime()===t.getTime())return new DayPilot.Event(a.events.list[n],a);return null},this.events.all=function(){for(var e=[],t=0;t<a.events.list.length;t++){var i=new DayPilot.Event(a.events.list[t],a);e.push(i)}return DayPilot.list(e)},this.events.edit=function(e){function t(){var t=a.bd(e);t&&a.Ia(t)}t()},this.events.update=function(e,t){var i={};i.oldEvent=new DayPilot.Event(e.copy(),a),i.newEvent=new DayPilot.Event(e.temp(),a);var n=new DayPilot.Action(a,"EventUpdate",i,t);return e.commit(),a.A&&a.update(),a.Lc.notify(),n},this.events.remove=function(e,t){var i={};i.e=new DayPilot.Event(e.data,a);var n=new DayPilot.Action(a,"EventRemove",i,t),o=DayPilot.indexOf(a.events.list,e.data);return a.events.list.splice(o,1),a.A&&a.update(),a.Lc.notify(),n},this.events.add=function(e,t){e.calendar=a,a.events.list||(a.events.list=[]),a.events.list.push(e.data);var i={};i.e=e;var n=new DayPilot.Action(a,"EventAdd",i,t);return a.A&&a.update(),a.Lc.notify(),n},this.events.filter=function(e){a.events.Zc=e,a.cd()},this.events.load=function(e,t,i){var n=function(e){var t={};t.exception=e.exception,t.request=e.request,"function"==typeof i&&i(t)},o=function(e){var i,o=e.request;try{i=DayPilot.Util.parseJSON(o.responseText)}catch(e){var r={};return r.exception=e,void n(r)}if(DayPilot.isArray(i)){var s={};if(s.preventDefault=function(){this.preventDefault.value=!0},s.data=i,"function"==typeof t&&t(s),s.preventDefault.value)return;a.events.list=i,a.A&&a.update()}};DayPilot.ajax({"method":"POST","data":{"start":a.visibleStart().toString(),"end":a.visibleEnd().toString()},"url":e,"success":o,"error":n})},this.queue={},this.queue.list=[],this.queue.list.ignoreToJSON=!0,this.queue.add=function(e){if(e){if(!e.isAction)throw"DayPilot.Action object required for queue.add()";a.queue.list.push(e)}},this.queue.notify=function(e){var t={};t.actions=a.queue.list,a.G("Notify",t,e,"Notify"),a.queue.list=[]},this.queue.clear=function(){a.queue.list=[]},this.queue.pop=function(){return a.queue.list.pop()},this.cd=function(e){if(this.A&&this.va){var e=e||{},t=!e.eventsOnly;a.cssOnly||(a.cssOnly=!0,DayPilot.Util.log("DayPilot: cssOnly = false mode is not supported since DayPilot Pro 8.0.")),this.r()||(a.cellProperties={}),t?(a.sc.clearCache(),a.M(),this.dd(),this._(),this.ba(),a.da(),a.ea(),a.ca(),a.fa(),a.ga(),a.D(),a.ha(),a.ib(),a.ia(),a.ja(),a.ka(),a.la(),a.ed(),this.oa(),this.pa(),this.ma(),a.qa()):(a.M(),a.ba(),a.ca(),a.oa(),a.pa(),a.qa()),this.visible?this.show():this.hide()}},this.update=function(){if(this.cd(),"function"==typeof a.onAfterRender){var e={};e.isUpdate=!0,e.data=null,a.onAfterRender(e)}},this.ed=function(){if(a.nav.top.className!==a.q("_main")){a.nav.top.className=a.q("_main");var e=a.nav.corner;e.className=a.q("_corner"),e.firstChild.className=a.q("_corner_inner");var t=a.nav.unifiedCornerRight;t&&(t.firstChild.className=a.q("_cornerright"),t.firstChild.firstChild.className=a.q("_cornerright_inner"))}},this.show=function(){a.visible=!0,a.nav.top.style.display="",a.P(),a.ka(),a.mb()},this.hide=function(){a.visible=!1,a.nav.top.style.display="none"},this.Lc={},this.Lc.scope=null,this.Lc.notify=function(){a.Lc.scope&&a.Lc.scope["$apply"]()},this.debug=new DayPilot.Debug(this),this.Yc=function(e,t){t||(t=this.startDate);var i=t.getTime(),n=e.getTime(),a=this.t.pixels[n+"_"+i];if(a)return a;i=t.addHours(this.Ba(!0)).getTime();var o=60*this.cellDuration*1e3,r=n-i,s=r%o,l=r-s,d=l+o;0===s&&(d=l);var c={};return c.cut=!1,c.top=this.fd(r),c.boxTop=this.fd(l),c.boxBottom=this.fd(d),this.t.pixels[n+"_"+i]=c,c},this.fd=function(e){return Math.floor(this.cellHeight*e/(6e4*this.cellDuration))},this.dd=function(){this.startDate=new DayPilot.Date(this.startDate).getDatePart(),this.gd=r.allDayEventHeight()+4},this.ca=function(){var e=this.Ca(),t=this.Vb();if(this.nav.corner&&(this.nav.corner.style.height=e+"px"),this.nav.cornerRight&&(this.nav.cornerRight.style.height=e+"px"),this.nav.mid&&(this.nav.mid.style.height=e+"px"),this.showAllDayEvents&&this.nav.header)for(var i=this.nav.header.rows[this.nav.header.rows.length-1],n=0;n<i.cells.length;n++){var a=i.cells[n];a.firstChild.style.height=r.allDayHeaderHeight()+"px"}this.nav.upperRight&&(this.nav.upperRight.style.height=e+"px"),this.nav.scroll.style.top=e+"px",this.nav.top.style.height=t+"px"},this.ja=function(){var e=this.Wb();this.nav.scroll&&e>0&&(this.nav.scroll.style.height=e+"px",this.pb=a.nav.scroll.clientHeight,this.nav.bottomLeft&&(this.nav.bottomLeft.style.height=e+"px"),this.nav.bottomRight&&(this.nav.bottomRight.style.height=e+"px")),"Parent100Pct"===this.heightSpec?this.nav.top.style.height="100%":this.nav.top.style.height=this.Vb()+"px"},this.setHeight=function(e){"Parent100Pct"!==this.heightSpec&&(this.heightSpec="Fixed"),this.height=e-this.Ca(),this.ja()},this.hd=function(e){var t=document.createElement("div");t.style.position="absolute",t.style.top="-2000px",t.style.left="-2000px",t.className=this.q(e),document.body.appendChild(t);var i=t.offsetHeight,n=t.offsetWidth;document.body.removeChild(t);var a={};return a.height=i,a.width=n,a},this.sc={};var r=this.sc;r.locale=function(){return DayPilot.Locale.find(a.locale)},r.weekStarts=function(){return"number"==typeof a.weekStarts?a.weekStarts:r.locale().weekStarts},r.timeFormat=function(){return"Auto"!==a.timeFormat?a.timeFormat:this.locale().timeFormat},r.useBox=function(e){return"Always"===a.useEventBoxes||"Never"!==a.useEventBoxes&&e<60*a.cellDuration*1e3},r.notifyType=function(){var e;if("Immediate"===a.notifyCommit)e="Notify";else{if("Queue"!==a.notifyCommit)throw"Invalid notifyCommit value: "+a.notifyCommit;e="Queue"}return e},r.clearCache=function(){delete a.t.allDayEventHeight,delete a.t.allDayHeaderHeight,delete a.t.headerHeight},r.allDayEventHeight=function(){if(a.t.allDayEventHeight)return a.t.allDayEventHeight;var e=a.hd("_alldayevent_height").height;return e||(e=a.allDayEventHeight),a.t.allDayEventHeight=e,e},r.allDayHeaderHeight=function(){if(a.t.allDayHeaderHeight)return a.t.allDayHeaderHeight;var e=a.gd;return a.t.allDayHeaderHeight=e,e},r.headerHeight=function(){if(a.t.headerHeight)return a.t.headerHeight;var e=a.hd("_header_height").height;return e||(e=a.headerHeight),a.t.headerHeight=e,e},this.exportAs=function(e,t){var i=s.generate(e,t);return new DayPilot.Export(i)},this.jd={};var s=this.jd;s.kd=null,s.ld=null,s.generate=function(e,t){"object"==typeof e&&(t=e,e=null);var t=t||{},e=e||t.format||"svg",i=t.scale||1;if("config"!==e){"jpg"===e.toLowerCase()&&(e="jpeg");var n=t.area||"viewport";s.kd=t,s.ld=n;var o,l=s.getWidth(),d=s.getHeight();switch(e.toLowerCase()){case"svg":o=new DayPilot.Svg(l,d);break;case"png":o=new DayPilot.Canvas(l,d,"image/png",i);break;case"jpeg":o=new DayPilot.Canvas(l,d,"image/jpeg",i,t.quality);break;default:throw"Export format not supported: "+e}var c=s.getRectangles(),h=new DayPilot.StyleReader(a.nav.top).getBackColor(),u=new DayPilot.StyleReader(a.nav.top).get("border-top-color");"0px"!==new DayPilot.StyleReader(a.nav.top).get("border-top-width")||(u="white");var f=new DayPilot.StyleReader(a.nav.corner.firstChild).getBackColor(h),v=a.nav.hourTable.rows[0].cells[0].firstChild.firstChild,p=new DayPilot.StyleReader(v).get("border-right-color"),g=new DayPilot.StyleReader(v).getBackColor(h),m=new DayPilot.StyleReader(v).getFont(),y=new DayPilot.StyleReader(v.firstChild.childNodes[1]).getFont(),b=new DayPilot.StyleReader(v.firstChild.childNodes[1]).getPx("padding-right"),w=new DayPilot.StyleReader(v).get("color"),D=a.nav.header.rows[0].cells[0].firstChild.firstChild,k=new DayPilot.StyleReader(D).getBackColor(h),C=new DayPilot.StyleReader(D).getFont(),x=new DayPilot.StyleReader(D).get("color"),P=new DayPilot.StyleReader(D).get("border-right-color"),S=a.nav.header.rows[a.nav.header.rows.length-1].cells[0].firstChild,A=S.firstChild,T=new DayPilot.StyleReader(S).getBackColor(h),E=new DayPilot.StyleReader(A).getBackColor(T),M=a.nav.main.rows[0].cells[0].firstChild.firstChild,H=new DayPilot.StyleReader(M).get("border-right-color"),M=s.fakeCell(),_=new DayPilot.StyleReader(M.firstChild).getBackColor();DayPilot.Util.addClass(M,a.q("_cell_business"));var R=new DayPilot.StyleReader(M.firstChild).getBackColor();new DayPilot.StyleReader(M.firstChild).getFont(),new DayPilot.StyleReader(M.firstChild).get("color");DayPilot.de(M);var B=s.getViewportOffsetTop(),N=0;N="Fixed"===a.columnWidthSpec?a.columnWidth:c.gridContent.w/a.va.length,o.fillRect(c.main,"white"),o.fillRect(c.main,h);var U=c.corner.h-B;DayPilot.list.for(a.jc(),function(e){return a.pc(e)}).each(function(e){var t=a.lc(),i=e.hour,n=e.sup,r=i,s=20,l={"x":0,"y":U,"w":c.grid.x+1,"h":t+1},d={"x":0,"y":U,"w":c.grid.x+1-s,"h":t+1},h={"x":d.w,"y":U,"w":s-b-1,"h":t+1},u=g;o.fillRect(l,u),o.text(d,r,m,w,"right"),o.text(h,n,y,w,"right"),o.rect(l,p),U+=t});var L=c.grid.x;DayPilot.list(a.va).each(function(e,t){var i=N,n=c.grid.y-B;DayPilot.list.for(a.Fa()).each(function(e,r){var s=a.cellHeight,l={"x":L,"y":n,"w":i+1,"h":s+1},d=a.Ac(t,r)||{},c=d.business,h={};h.backColor=c?R:_,"function"==typeof a.onBeforeCellExport&&a.onBeforeCellExport(h),o.fillRect(l,h.backColor),o.rect(l,H),n+=s}),L+=i});var z=c.grid.x;DayPilot.list(a.va).each(function(e){DayPilot.list(e.events).each(function(e){var t=e.cache||e.data,i=s.fakeEvent();i.className+=" "+t.cssClass;var n=i.firstChild,r=i.childNodes[1],l=new DayPilot.StyleReader(n).getBackColor(),d=new DayPilot.StyleReader(n.firstChild).getBackColor(),h=new DayPilot.StyleReader(n.firstChild).getPx("width"),u=new DayPilot.StyleReader(r).get("border-right-color"),f=new DayPilot.StyleReader(r).getFont(),v=new DayPilot.StyleReader(r).get("color"),p=new DayPilot.StyleReader(r).getBackColor(),g={};g.left=new DayPilot.StyleReader(r).getPx("padding-left"),g.right=new DayPilot.StyleReader(r).getPx("padding-right"),g.top=new DayPilot.StyleReader(r).getPx("padding-top"),g.bottom=new DayPilot.StyleReader(r).getPx("padding-bottom"),DayPilot.de(i);var m=z+N*e.part.left/100,y=(N-a.columnMarginRight)*e.part.width/100,b=e.part.top+c.grid.y-a.rb()-B,w=e.part.height,D=t.backColor||p,k=t.barColor||d,C=t.barBackColor||l,x={};x.e=e,x.text=e.text?e.text():e.client.html(),x.fontSize=f.size,x.fontFamily=f.family,x.fontStyle=f.style,x.fontColor=v,x.backColor=D,x.borderColor=u,x.horizontalAlignment="left",x.barWidth=h,x.barColor=k,x.barBackColor=C,"function"==typeof a.onBeforeEventExport&&a.onBeforeEventExport(x);var P={"x":m,"y":b,"w":y+1,"h":w+1},S=DayPilot.Util.copyProps(P);e.client.barVisible()&&(S.x+=h,S.w-=h);var A=DayPilot.Util.copyProps(S);if(A.x+=g.left,A.w-=g.left+g.right,A.y+=g.top,A.h-=g.top+g.bottom,o.fillRect(P,x.backColor),e.client.barVisible()){var T={"x":P.x,"y":P.y,"w":x.barWidth,"h":P.h},E={"x":P.x,"y":P.y+1+e.part.barTop,"w":x.barWidth,"h":e.part.barHeight+1};o.fillRect(T,x.barBackColor),o.fillRect(E,x.barColor)}o.text(A,x.text,{"size":x.fontSize,"family":x.fontFamily,"style":x.fontStyle},x.fontColor,x.horizontalAlignment),o.rect(P,x.borderColor);var m=P.x,M=P.x+P.w-2,b=P.y;DayPilot.list(t.areas).each(function(t){if("Hover"!==(t.visibility||t.v)){var i=t.left;t.start&&(i=a.getPixels(new DayPilot.Date(t.start)).left-e.part.left);var n=t.width||t.w,r=t.height||t.h;i||(i=M-n-m),t.right?n=e.part.width-t.right-i:t.end&&(n=a.getPixels(new DayPilot.Date(t.end)).left-t.left-e.part.left+1);var s=t.top;"number"==typeof t.bottom&&(r=e.part.height-t.bottom-s);var l={"x":m+i,"y":b+s,"w":n,"h":r};if(t.backColor&&o.fillRect(l,t.backColor),t.image){var d=new Image;d.src=t.image,o.image(l,d)}else t.html&&o.text(l,t.html,{"size":x.fontSize,"family":x.fontFamily,"style":x.fontStyle},t.fontColor||x.fontColor,null,t.padding)}})}),z+=N}),o.fillRect(c.corner,f);var L=c.gridContent.x;return DayPilot.list.for(a.headerLevels).each(function(e){var t=a.headerHeight*e,i=a.Kb(e);DayPilot.list(i).each(function(i){var n={};n.text=DayPilot.Util.stripTags(i.html),n.horizontalAlignment="center",n.backColor=i.backColor||k,n.fontSize=C.size,n.fontFamily=C.family,n.fontStyle=C.style,n.fontColor=x,n.header={},n.header.level=e,DayPilot.Util.copyProps(i,n.header,["id","start","name","html","backColor"]),"function"==typeof a.onBeforeHeaderExport&&a.onBeforeHeaderExport(n);var r=N,s=a.headerHeight,l={"x":L,"y":t,"w":r+1,"h":s+1};o.fillRect(l,n.backColor),o.rect(l,P),o.text(l,n.text,{"size":n.fontSize,"family":n.fontFamily,"style":n.fontStyle},n.fontColor,n.horizontalAlignment),L+=N})}),function(){if(a.showAllDayEvents){var e=a.headerHeight*a.headerLevels,t=c.gridContent.x;DayPilot.list(a.va).each(function(i){var n=N,a=r.allDayHeaderHeight(),s={"x":t,"y":e,"w":n+1,"h":a+1};o.fillRect(s,E),o.rect(s,P),t+=N}),DayPilot.list(a.Nb.lines).each(function(e,t){DayPilot.list(e).each(function(e){var i=s.fakeEvent();i.className+=" "+e.data.cssClass;var n=i.firstChild,l=i.childNodes[1],d=(new DayPilot.StyleReader(n).getBackColor(),new DayPilot.StyleReader(n.firstChild).getBackColor(),new DayPilot.StyleReader(n.firstChild).getPx("width"),new DayPilot.StyleReader(l).get("border-right-color")),h=new DayPilot.StyleReader(l).getFont(),u=new DayPilot.StyleReader(l).get("color"),f=new DayPilot.StyleReader(l).getBackColor(),v={};v.left=new DayPilot.StyleReader(l).getPx("padding-left"),v.right=new DayPilot.StyleReader(l).getPx("padding-right"),v.top=new DayPilot.StyleReader(l).getPx("padding-top"),v.bottom=new DayPilot.StyleReader(l).getPx("padding-bottom"),DayPilot.de(i);var p=e.cache||e.data,g=p.backColor||f,m={};m.e=e,m.text=e.client.html(),m.fontSize=h.size,m.fontFamily=h.family,m.fontStyle=h.style,m.fontColor=u,m.backColor=g,m.borderColor=d,m.horizontalAlignment="left","function"==typeof a.onBeforeEventExport&&a.onBeforeEventExport(m);var y=e.part.colStart*N+c.gridContent.x+2,b=e.part.colWidth*N-4,w=r.allDayEventHeight()-1,D=a.headerLevels*r.headerHeight()+t*r.allDayEventHeight()+2,k={"x":y,"y":D,"w":b,"h":w},C=DayPilot.Util.copyProps(k);C.x+=v.left,C.w-=v.left+v.right,C.y+=v.top,C.h-=v.top+v.bottom,o.fillRect(k,m.backColor),o.text(C,m.text,{"size":m.fontSize,"family":m.fontFamily,"style":m.fontStyle},m.fontColor,m.horizontalAlignment),o.rect(k,m.borderColor)})})}}(),o.rect(c.main,u),o.line(c.grid.x,0,c.grid.x,c.main.h,p),o.line(0,c.grid.y,c.main.w,c.grid.y,p),o}},s.fakeCell=function(){var e=document.createElement("div");e.style.display="none",e.className=a.q("_cell"),e.style.position="absolute",e.style.top="-2000px",e.style.left="-2000px";var t=document.createElement("div");return t.className=a.q("_cell_inner"),e.appendChild(t),a.nav.bottomRight.appendChild(e),e},s.fakeEvent=function(){var e=document.createElement("div");e.style.position="absolute",e.style.top="-2000px",e.style.left="-2000px",e.style.display="none",e.className=a.q("_event");var t=document.createElement("div");t.className=a.q("_event_bar");var i=document.createElement("div");i.className=a.q("_event_bar_inner"),t.appendChild(i),e.appendChild(t);var n=document.createElement("div");return n.className=a.q("_event_inner"),e.appendChild(n),a.nav.events.rows[0].cells[0].events.appendChild(e),e},s.getViewportOffsetTop=function(){switch(s.ld){case"full":return 0;case"viewport":return a.ob().scrollTop;case"range":throw"Not implemented"}},s.getWidth=function(){var e=s.ld;switch(e){case"full":case"viewport":var t=a.nav.top.clientWidth,i=t-a.hourWidth,n=a.va.length;return Math.floor(i/n)*n+a.hourWidth;default:throw"Unsupported export mode: "+e}},s.getHeight=function(){var e=s.ld;switch(e){case"full":return a.ec()+a.Ca();case"viewport":return a.nav.top.offsetHeight-DayPilot.sh(a.nav.scroll)-1;default:throw"Unsupported export mode: "+e}},s.getRectangles=function(){var e=s.getRowHeaderWidth(),t=a.Ca(),i={};i.main={"x":0,"y":0,"w":s.getWidth(),"h":s.getHeight()},i.corner={"x":0,"y":0,"w":e,"h":t},i.grid={"x":e,"y":t,"w":s.getWidth()-e,"h":s.getHeight()-t};var n=s.innerWidth(),o=a.ec();return i.gridContent={"x":e,"y":t,"w":n,"h":o},i},s.getRowHeaderWidth=function(){return a.hourWidth},s.innerWidth=function(){var e=a.ob().offsetWidth,t=a.va.length;return Math.floor(e/t)*t},this.md=function(){return!!this.backendUrl&&("undefined"==typeof a.events.list||!a.events.list)},this.nd=function(){if(this.id&&this.id.tagName)this.nav.top=this.id;else{if("string"!=typeof this.id)throw"DayPilot.Calendar() constructor requires the target element or its ID as a parameter";if(this.nav.top=document.getElementById(this.id),!this.nav.top)throw"DayPilot.Calendar: The placeholder element not found: '"+t+"'."}},this.od=function(){this.nd(),this.dd(),this._(),this.Xb(),this.da(),this.ea(),this.ha(),this.ka(),this.xc(),this.Rc(),this.Q(),this.la(),e.register(this),this.P(),this.ma(),this.Oc(),this.ra(),this.G("Init")},this.init=function(){if(this.nd(),!this.nav.top.dp){var t=this.md();if(a.cssOnly||(a.cssOnly=!0,DayPilot.Util.log("DayPilot: cssOnly = false mode is not supported since DayPilot Pro 8.0.")),t)return this.od(),void(this.A=!0);this.dd(),this._(),this.aa(),this.events.list||(this.events.list=[]),this.ba(),this.Xb(),this.da(),this.ea(),this.ha(),this.na(),this.la(),this.ka(),this.xc(),this.Rc(),this.Q(),e.register(this),this.ca(),this.oa(),this.pa(),this.P(),
this.messageHTML&&this.message(this.messageHTML),this.ma(),this.Y(null,!1),this.Oc(),this.ra(),this.A=!0,this.pd()}},this.qd=null,this.rd=function(e){var t={"events":{"preInit":function(){var e=this.data;e&&(DayPilot.isArray(e.list)?a.events.list=e.list:a.events.list=e)}},"scrollToHour":{"postInit":function(){"undefined"!=typeof this.data&&a.scrollToHour(this.data)}}};this.qd=t;for(var i in e)if(t[i]){var n=t[i];n.data=e[i],n.preInit&&n.preInit()}else a[i]=e[i]},this.pd=function(){var e=this.qd;for(var t in e){var i=e[t];i.postInit&&i.postInit()}},this.internal={},this.internal.initialized=function(){return a.A},this.internal.invokeEvent=this.Qa,this.internal.eventMenuClick=this.Za,this.internal.timeRangeMenuClick=this.$a,this.internal.bubbleCallBack=this.Xa,this.internal.findEventDiv=this.bd,this.internal.eventDeleteDispatch=this.Pa,this.internal.touch=this.Sb,this.Init=this.init,this.rd(i)};var e={};e.topSelectedCell=null,e.bottomSelectedCell=null,e.selecting=!1,e.column=null,e.firstSelected=null,e.firstMousePos=null,e.originalMouse=null,e.originalHeight=null,e.originalTop=null,e.globalHandlers=!1,e.editing=!1,e.originalText=null,e.register=function(t){e.registered||(e.registered=[]);for(var i=e.registered,n=0;n<i.length;n++)if(i[n]===t)return;i.push(t)},e.unregister=function(t){var i=e.registered;if(i){var n=DayPilot.indexOf(i,t);n!==-1&&i.splice(n,1),0===i.length&&(i=null)}i||(DayPilot.ue(document,"mousemove",e.gMouseMove),DayPilot.ue(document,"mouseup",e.gMouseUp),DayPilot.ue(document,"touchmove",e.gTouchMove),DayPilot.ue(document,"touchend",e.gTouchEnd),e.globalHandlers=!1)},e.getCellsAbove=function(t){for(var i=[],n=e.getColumn(t),a=t.parentNode,o=null;a&&o!==e.firstSelected;)for(o=a.getElementsByTagName("td")[n],i.push(o),a=a.previousSibling;a&&"TR"!==a.tagName;)a=a.previousSibling;return i},e.getCellsBelow=function(t){for(var i=[],n=e.getColumn(t),a=t.parentNode,o=null;a&&o!==e.firstSelected;)for(o=a.getElementsByTagName("td")[n],i.push(o),a=a.nextSibling;a&&"TR"!==a.tagName;)a=a.nextSibling;return i},e.getColumn=function(e){for(var t=0;e.previousSibling;)e=e.previousSibling,"TD"===e.tagName&&t++;return t},e.getShadowColumn=function(e){if(!e)return null;for(var t=e.parentNode;t&&"TD"!==t.tagName;)t=t.parentNode;return t},e.gTouchMove=function(t){if(!DayPilot.Util.isMouseEvent(t)&&e.drag){t.preventDefault();var i=t.touches?t.touches[0].pageX:t.pageX,n=t.touches?t.touches[0].pageY:t.pageY,a={};a.x=i,a.y=n;var o=function(){for(var e=t.touches?t.touches[0].clientX:t.clientX,i=t.touches?t.touches[0].clientY:t.clientY,n=document.elementFromPoint(e,i);n&&n.parentNode;)if(n=n.parentNode,n.daypilotMainD)return n.calendar;return!1}();if(o){if(e.gShadow&&document.body.removeChild(e.gShadow),e.gShadow=null,o.coords=o.Sb.relativeCoords(t),!e.movingShadow&&o.coords){var r=o.ta(e.drag,!1,e.drag.shadowType);if(r){e.movingShadow=r;var s=DayPilot.Date.today(),t={"value":e.drag.id,"start":s,"end":s.addSeconds(e.drag.duration),"text":e.drag.text},l=new DayPilot.Event(t,o);l.external=!0,DayPilot.Global.moving={},DayPilot.Global.moving.event=l,DayPilot.Global.moving.helper={}}}DayPilot.Global.moving&&o.Sb.updateMoving()}else{DayPilot.de(e.movingShadow),DayPilot.Global.moving=null,e.movingShadow=null,e.gShadow||(e.gShadow=e.createGShadow(e.drag.shadowType));var r=e.gShadow;r.style.left=a.x+"px",r.style.top=a.y+"px"}}},e.gTouchEnd=function(t){DayPilot.Util.isMouseEvent(t)||e.gMouseUp(t)},e.gMouseMove=function(t){if("undefined"!=typeof e&&!(t.insideMainD||t.srcElement&&t.srcElement.inside)){var i=DayPilot.mc(t);if(e.drag){document.body.style.cursor="move",e.gShadow||(e.gShadow=e.createGShadow(e.drag.shadowType));var n=e.gShadow;n.style.left=i.x+"px",n.style.top=i.y+"px",DayPilot.Global.moving=null,e.deleteShadow(e.movingShadow),e.movingShadow=null}for(var a=0;a<e.registered.length;a++)e.registered[a].S&&e.registered[a].S()}},e.gUnload=function(t){if(e.registered)for(var i=e.registered,n=0;n<i.length;n++){var a=i[n];e.unregister(a)}},e.gMouseUp=function(t){var t=t||window.event;if(DayPilot.Global.resizing){if(!e.resizingShadow)return DayPilot.Global.resizing.style.cursor="default",DayPilot.Global.resizing.event.calendar.nav.top.style.cursor="auto",void(DayPilot.Global.resizing=null);var i=DayPilot.Global.resizing.event,n=DayPilot.Global.resizing.dpBorder,a=e.resizingShadow.clientHeight,o=e.resizingShadow.offsetTop;if(e.deleteShadow(e.resizingShadow),e.resizingShadow=null,DayPilot.Global.resizing.style.cursor="default",i.calendar.nav.top.style.cursor="auto",DayPilot.Global.resizing.onclick=null,DayPilot.Global.resizing=null,i.calendar.overlap)return;i.calendar.Sa(i,a,o,n)}else if(DayPilot.Global.moving){if(!DayPilot.Global.moving.helper)return e.deleteShadow(e.movingShadow),DayPilot.Global.moving=null,void(e.movingShadow=null);if(!e.movingShadow)return DayPilot.Global.moving.event.calendar.nav.top.style.cursor="auto",void(DayPilot.Global.moving=null);var o=(DayPilot.Global.moving.helper.oldColumn,e.movingShadow.offsetTop);e.deleteShadow(e.movingShadow);var i=DayPilot.Global.moving.event,r=e.movingShadow.column,s=e.drag;if(DayPilot.Global.moving.event.calendar.nav.top.style.cursor="auto",DayPilot.Global.moving=null,e.movingShadow=null,s&&(i.calendar.todo||(i.calendar.todo={}),i.calendar.todo.del=s.element),i.calendar.overlap)return;var l=t||window.event;i.calendar.Ua(i,r,o,l,s)}e.drag&&(e.drag=null,document.body.style.cursor=""),e.gShadow&&(document.body.removeChild(e.gShadow),e.gShadow=null),e.moveOffsetY=null},e.dragStart=function(t,i,n,a,o){DayPilot.us(t);var r=e.drag={};return r.element=t,r.duration=i,r.text=a,r.id=n,r.shadowType=o?o:"Fill",!1},DayPilot.Calendar.makeDraggable=function(t){var i=t.element,n=t.keepElement?null:i,a=t.duration||1;navigator.msPointerEnabled&&(i.style.msTouchAction="none",i.style.touchAction="none");var o=function(i){e.dragStart(n,a,t.id,t.text);var o=i.target||i.srcElement;if(o.tagName){var r=o.tagName.toLowerCase();if("textarea"===r||"select"===r||"input"===r)return!1}return i.preventDefault&&i.preventDefault(),!1},r=function(i){if(!DayPilot.Util.isMouseEvent(i)){window.setTimeout(function(){var o=e.drag={};o.element=n,o.id=t.id,o.text=t.text||"",o.duration=a,o.shadowType="Fill",e.gTouchMove(i),i.preventDefault()},0),i.preventDefault()}};DayPilot.us(i),DayPilot.re(i,"mousedown",o),DayPilot.re(i,DayPilot.touch.start,r),i.cancelDraggable=function(){DayPilot.ue(i,"mousedown",o),DayPilot.ue(i,DayPilot.touch.start,r),delete i.cancelDraggable}},e.deleteShadow=function(e){e&&e.parentNode&&e.parentNode.removeChild(e)},e.createGShadow=function(e){var t=document.createElement("div");return t.setAttribute("unselectable","on"),t.style.position="absolute",t.style.width="100px",t.style.height="20px",t.style.border="2px dotted #666666",t.style.zIndex=101,t.style.pointerEvents="none","Fill"===e&&(t.style.backgroundColor="#aaaaaa",t.style.opacity=.5,t.style.filter="alpha(opacity=50)",t.style.border="2px solid #aaaaaa"),document.body.appendChild(t),t},e.moveShadow=function(t){var i=e.movingShadow;i.parentNode&&i.parentNode.removeChild(i),t.firstChild.appendChild(i),i.style.left="0px",i.style.width=e.movingShadow.parentNode.offsetWidth+"px"},e.Column=function(e,t,i){this.value=e,this.id=e,this.name=t,this.date=new DayPilot.Date(i)},"undefined"!=typeof jQuery&&!function(e){e.fn.daypilotCalendar=function(e){var t=null,i=this.each(function(){if(!this.daypilot){var i=new DayPilot.Calendar(this.id,e);i.init(),this.daypilot=i,t||(t=i)}});return 1===this.length?t:i}}(jQuery),function(){var e=DayPilot.am();e&&e.directive("daypilotCalendar",["$parse",function(e){return{"restrict":"E","template":"<div id='{{id}}'></div>","compile":function(t,i){return t.replaceWith(this["template"].replace("{{id}}",i["id"])),function(t,i,n){var a=new DayPilot.Calendar(i[0]);a.Lc.scope=t,a.init();var o=n["id"];o&&(t[o]=a);var r=n["publishAs"];if(r){(0,e(r).assign)(t,a)}for(var s in n)if(0===s.indexOf("on")){var l=DayPilot.Util.shouldApply(s);l?!function(i){a[i]=function(a){var o=e(n[i]);t["$apply"](function(){o(t,{"args":a})})}}(s):!function(i){a[i]=function(a){e(n[i])(t,{"args":a})}}(s)}var d=t["$watch"],c=n["config"]||n["daypilotConfig"],h=n["events"]||n["daypilotEvents"];d.call(t,c,function(e,t){for(var i in e)a[i]=e[i];a.update()},!0),d.call(t,h,function(e){a.events.list=e,a.cd({"eventsOnly":!0})},!0)}}}}])}(),"undefined"!=typeof Sys&&Sys.Application&&Sys.Application.notifyScriptLoaded&&Sys.Application.notifyScriptLoaded()}}(),"undefined"==typeof DayPilot)var DayPilot={};if("undefined"==typeof DayPilot.Global&&(DayPilot.Global={}),function(){"undefined"==typeof DayPilot.DatePicker&&(DayPilot.DatePicker=function(e){this.v="2911";var t="navigator_"+(new Date).getTime(),i=this;this.onShow=null,this.onTimeRangeSelect=null,this.onTimeRangeSelected=null,this.prepare=function(){if(this.locale="en-us",this.target=null,this.resetTarget=!0,this.pattern=this.sc.locale().datePattern,this.theme=null,this.patterns=[],e)for(var t in e)this[t]=e[t];this.init()},this.init=function(){this.date=new DayPilot.Date(this.date);var e=this.sd();this.resetTarget&&!e&&this.td(this.date),DayPilot.re(document,"mousedown",function(){i.close()})},this.close=function(){this.Nc&&(this.navigator&&this.navigator.dispose(),this.div.innerHTML="",this.div&&this.div.parentNode===document.body&&document.body.removeChild(this.div))},this.sd=function(){var e=this.ud();if(!e)return this.date;var t=null;if(t="INPUT"===e.tagName?e.value:e.innerText,!t)return null;for(var n=DayPilot.Date.parse(t,i.pattern),a=0;a<i.patterns.length;a++){if(n)return n;n=DayPilot.Date.parse(t,i.patterns[a])}return n},this.td=function(e){var t=this.ud();if(t){var n=e.toString(i.pattern,i.locale);"INPUT"===t.tagName?t.value=n:t.innerHTML=n}},this.sc={},this.sc.locale=function(){return DayPilot.Locale.find(i.locale)},this.ud=function(){var e=this.target;return e&&e.nodeType&&1===e.nodeType?e:document.getElementById(e)},this.show=function(){var e=this.ud(),n=this.navigator,n=new DayPilot.Navigator(t);n.api=2,n.cssOnly=!0,n.theme=i.theme,n.weekStarts="Auto",n.locale=i.locale,n.onTimeRangeSelected=function(e){i.date=e.start;var t=e.start.addTime(n.vd),a=t.toString(i.pattern,i.locale),e={};e.start=t,e.date=t,e.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof i.onTimeRangeSelect&&(i.onTimeRangeSelect(e),e.preventDefault.value)||(i.td(a),i.close(),"function"==typeof i.onTimeRangeSelected&&i.onTimeRangeSelected(e))},this.navigator=n;var a=DayPilot.abs(e),o=e.offsetHeight,r=document.createElement("div");r.style.position="absolute",r.style.left=a.x+"px",r.style.top=a.y+o+"px";var s=document.createElement("div");s.id=t,r.appendChild(s),DayPilot.re(r,"mousedown",function(e){var e=e||window.event;e.cancelBubble=!0,e.stopPropagation&&e.stopPropagation()}),document.body.appendChild(r),this.div=r;var l=i.sd()||(new DayPilot.Date).getDatePart();n.startDate=l,n.vd=l.getTimePart(),n.selectionStart=l.getDatePart(),n.init(),this.Nc=!0,this.onShow&&this.onShow()},this.prepare()})}(),"undefined"==typeof DayPilot)var DayPilot={};if("undefined"==typeof DayPilot.Global&&(DayPilot.Global={}),function(){if("undefined"==typeof DayPilot.Gantt){var e=function(){};DayPilot.Gantt=function(t,i){this.v="2911";var n=this;this.id=t,this.isGantt=!0;var a=new DayPilot.Scheduler(t);this.scheduler=a,a.viewType="Resources",a.onCallBackHeader=function(e){e.header.taskGroupMode=n.taskGroupMode,e.header.rowHeaderColumns=n.columns,e.header.clientState=n.clientState},a.onGetNodeState=function(e){var t=function(e){var t={};if(e.tags)for(var i in e.tags)t[i]=""+e.tags[i];return t},i=function(e){var i=e.task,n={};return n.start=i.start,n.end=i.end,n.id=i.id,n.complete=i.complete,n.text=i.text,n.type=i.type,n.expanded=e.expanded,n.loaded=e.loaded,n.tags=t(i),n.versions=i.versions,n.children=a.internal.getNodeChildren(e.children),n};e.result=i(e.row),e.preventDefault()},a.xd=function(e){},a.onCallBackResult=function(e){var t=e.result;e.preventDefault();var i=function(){t.scrollToTaskId&&a.scrollToResource(t.scrollToTaskId)};if("None"===t.updateType)return void i();var o=function(e){for(var i=0;i<e.length;i++){var a=e[i];"undefined"!=typeof t[a]&&(n[a]=t[a])}};n.links.list=t.links,n.tasks.list=t.tasks,n.startDate=new DayPilot.Date(t.startDate),o(["days","cellDuration","cellGroupBy","cellWidth","cellWidthSpec","cornerHtml","separators","rowMinHeight","rowMarginBottom","taskGroupMode","selectedRows"]),o(["cellProperties","cellConfig","timeHeader","timeHeaders","timeline","columns"]),s.translate(),s.yd(),s.zd(),a.update(),a.show(),i()},this.taskGroupMode="Auto",this.autoRefreshCommand="refresh",this.autoRefreshEnabled=!1,this.autoRefreshInterval=60,this.autoRefreshMaxCount=20,this.autoScroll="Drag","function"==typeof DayPilot.Bubble?(this.bubbleTask=new DayPilot.Bubble,this.bubbleCell=new DayPilot.Bubble,this.bubbleRow=new DayPilot.Bubble):(this.bubbleTask=null,this.bubbleCell=null,this.bubbleRow=null),this.cellDuration=1440,this.cellGroupBy="Month",this.cellWidth=40,this.cellWidthSpec="Fixed",this.completeBarVisible=!0,this.completeBarHeight=3,this.contextMenuTask=null,this.contextMenuRow=null,this.contextMenuLink=null,this.cornerHtml="",this.crosshairColor="Gray",this.crosshairOpacity=20,this.crosshairType="Header",this.doubleClickTimeout=300,this.progressiveTaskRendering="Progressive",this.progressiveTaskRenderingMargin=500,this.progressiveTaskRenderingCacheSweeping=!1,this.progressiveTaskRenderingCacheSize=200,this.floatingTasks=!0,this.floatingTimeHeaders=!0,this.headerHeight=36,this.height=300,this.heightSpec="Max",this.hideUntilInit=!1,this.linkBottomMargin=10,this.linkPointSize=10,this.loadingLabelVisible=!0,this.loadingLabelText="Loading...",this.locale="en-us",this.messageBarPosition="Top",this.messageHideAfter=5e3,this.progressiveRowRendering=!0,this.progressiveRowRenderingPreload=25,this.rowHeaderScrolling=!1,this.rowHeaderSplitterWidth=3,this.rowHeaderHideIconEnabled=!0,this.rowHeaderWidth=80,this.rowHeaderWidthAutoFit=!0,this.rowMarginBottom=4,this.rowMinHeight=0,this.scrollDelayTasks=200,this.scrollDelayCells=20,this.scrollDelayFloats=0,this.scale="Day",this.selectedRows=[],this.snapToGrid=!0,this.syncTasks=!0,this.syncLinks=!0,this.tapAndHoldTimeout=300,this.taskHeight=24,this.taskHtmlLeftMargin=20,this.taskHtmlRightMargin=20,this.taskResizeMargin=5,this.taskMovingStartEndEnabled=!1,this.taskMovingStartEndFormat="MMMM d, yyyy",this.taskResizingStartEndEnabled=!1,this.taskResizingStartEndFormat="MMMM d, yyyy",this.theme="gantt_default",this.treeAutoExpand=!0,this.treeIndent=20,this.treeImageMarginLeft=5,this.treeImageMarginTop=5,this.timeline=null,this.timeHeaders=[{"groupBy":"Month","format":"MMMM yyyy"},{"groupBy":"Day","format":"d"}],this.useEventBoxes="Never",this.visible=!0,this.taskVersionsEnabled=!1,this.taskVersionHeight=24,this.taskVersionMargin=2,this.taskVersionPosition="Above",this.taskMoveHandling="Update",this.taskClickHandling="Enabled",this.taskResizeHandling="Update",this.linkCreateHandling="Update",this.taskRightClickHandling="ContextMenu",this.taskDoubleClickHandling="Disabled",this.rowCreateHandling="Disabled",this.rowMoveHandling="Update",this.rowClickHandling="Disabled",this.rowDoubleClickHandling="Disabled",this.rowEditHandling="Update",this.rowSelectHandling="Update",this.clientState={},this.separators=[],this.members={},this.members.obsolete=[],this.members.ignore=["members","scheduler","internal","cellProperties"],this.members.noCssOnly=[],this.links={},this.links.list=[],this.links.add=function(e){if(e){var t=e.isLink?e.data:e;n.links.list.push(t),n.A&&(s.zd(),a.update()),n.Lc.notify()}},this.links.remove=function(e){if(e){var t;t=e.isLink?e.data:e;var i=DayPilot.indexOf(n.links.list,t);i!==-1&&(n.links.list.splice(i,1),n.A&&(s.zd(),a.update()),n.Lc.notify())}},this.links.find=function(e){if(!DayPilot.isArray(n.links.list))return null;for(var t=0;t<n.links.list.length;t++){var i=n.links.list[t];if(i.id===e)return new DayPilot.Link(i,n)}return null},this.links.findFromTo=function(e,t){if(!DayPilot.isArray(n.links.list))return null;for(var i=0;i<n.links.list.length;i++){var a=n.links.list[i];if(a.from===e&&a.to===t)return new DayPilot.Link(a,n)}return null},this.Ad={};var o=this.Ad;o.timeout=null,o.update=function(){n.A&&(window.clearTimeout(o.timeout),o.timeout=setTimeout(function(){s.yd(),a.update()},0))},this.tasks={},this.tasks.list=[],this.tasks.add=function(e){if(e){if(e instanceof DayPilot.Event)throw"DayPilot.Task object required. You have supplied DayPilot.Event.";var t=e.isTask?e.data:e;n.tasks.list.push(t),o.update(),n.Lc.notify()}},this.tasks.find=function(e){var t=r.findInCache(e);return t?new DayPilot.Task(t,n):null},this.tasks.update=function(e){if(e){if(!e.isTask)throw"DayPilot.Task object expected";e.commit(),o.update(),n.Lc.notify()}},this.tasks.remove=function(e){if(e){if(!e.isTask)throw"DayPilot.Task object expected";var t=r.findParentArray(e.data);if(t){var i=DayPilot.indexOf(t,e.data);t.splice(i,1),o.update(),n.Lc.notify()}}},this.visibleStart=function(){return a.visibleStart()},this.visibleEnd=function(){return a.visibleEnd()},this.onAfterRender=null,this.onAfterUpdate=null,this.onBeforeRowHeaderRender=null,this.onBeforeTaskRender=null,this.onBeforeTimeHeaderRender=null,this.onBeforeCellRender=null,this.onTaskClick=null,this.onTaskClicked=null,this.onTaskDoubleClick=null,this.onTaskDoubleClicked=null,this.onTaskRightClick=null,this.onTaskRightClicked=null,this.onRowCreate=null,this.onRowCreated=null,this.onRowMove=null,this.onRowMoved=null,this.onRowMoving=null,this.onRowClick=null,this.onRowClicked=null,this.onRowDoubleClick=null,this.onRowDoubleClicked=null,this.onRowEdit=null,this.onRowEdited=null,this.onRowSelect=null,this.onRowSelected=null,this.onTaskMove=null,this.onTaskMoved=null,this.onTaskMoving=null,this.onTaskResize=null,this.onTaskResized=null,this.onTaskResizing=null,this.onLinkCreate=null,this.onLinkCreated=null,this.r=function(){return!!this.backendUrl||!("function"!=typeof WebForm_DoCallback||!this.uniqueID)},this.Bd=function(){if("string"==typeof n.startDate&&(n.startDate=new DayPilot.Date(n.startDate)),!n.startDate||!n.days){for(var e=DayPilot.Date.today(),t=e.addDays(1),i=null,o=null,r=0;r<n.tasks.list.length;r++){var s=n.tasks.list[r];e=new DayPilot.Date(s.start),t=new DayPilot.Date(s.end),(null===i||e.getTime()<i)&&(i=e.getTime()),(null===o||t.getTime()>o)&&(o=t.getTime())}i&&o?(e=new DayPilot.Date(i).getDatePart(),t=new DayPilot.Date(o).getDatePart().addDays(1),a.startDate=n.startDate||e,a.days=n.days||DayPilot.DateUtil.daysDiff(e,t)):(a.startDate=e,a.days=30)}},this.commandCallBack=function(e,t){s.translate(),a.commandCallBack(e,t)},this.message=function(e,t,i,n){a.message(e,t,i,n)},this.setHeight=function(e){a.setHeight(e)},this.md=function(){return!!this.backendUrl&&(!DayPilot.isArray(n.tasks.list)||0==n.tasks.list.length)},this.init=function(){s.translate(),s.yd(),s.zd(),this.Bd(),a.init(),this.A=!0,this.pd()},this.Cd=!1,this.dispose=function(){a.dispose(),n.Cd=!0},this.update=function(){if(n.Cd)throw new DayPilot.Error("This DayPilot.Gantt instance has been disposed.");s.translate(),s.yd(),s.zd(),n.Bd(),a.update()},this.scrollTo=function(e){a.scrollTo(e)},this.scrollToTask=function(e){a.scrollToResource(e)},this.Dd={};var r=this.Dd;r.cache={},r.clearCache=function(){r.cache={}},r.addToCache=function(e,t){var i=e.id;if(i){var n={};if(n.isTaskWrapper=!0,n.data=e,n.parent=t,r.cache[i])throw"Duplicate task id detected";r.cache[i]=n}},r.findInCache=function(e){return e?r.cache[e.toString()]:null},r.getProperty=function(e,t){return e.tags&&e.tags[t]?e.tags[t]:e[t]},r.findParentArray=function(e){return r.findInArray(n.tasks.list,e)},r.findInArray=function(e,t){if(DayPilot.indexOf(e,t)!==-1)return e;for(var i=0;i<e.length;i++){var n=e[i];if(n.children&&n.children.length>0){var a=r.findInArray(n.children,t);if(a)return a}}return null},this.Ed={};var s=this.Ed;s.translate=function(){if(a.durationBarMode="PercentComplete",a.timeRangeSelectedHandling="Disabled",a.treeEnabled=!0,a.rowCreateHtml="",a.autoRefreshCommand=n.autoRefreshCommand,a.autoRefreshEnabled=n.autoRefreshEnabled,a.autoRefreshInterval=n.autoRefreshInterval,a.autoRefreshMaxCount=n.autoRefreshMaxCount,a.autoScroll=n.autoScroll,a.backendUrl=n.backendUrl,a.crosshairColor=n.crosshairColor,a.crosshairOpacity=n.crosshairOpacity,a.crosshairType=n.crosshairType,a.doubleClickTimeout=n.doubleClickTimeout,a.durationBarVisible=n.completeBarVisible,a.durationBarHeight=n.completeBarHeight,a.dynamicEventRendering=n.progressiveTaskRendering?"Progressive":"Disabled",a.dynamicEventRenderingMargin=n.progressiveTaskRenderingMargin,a.dynamicEventRenderingCacheSweeping=n.progressiveTaskRenderingCacheSweeping,a.dynamicEventRenderingCacheSize=n.progressiveTaskRenderingCacheSize,a.startDate=new DayPilot.Date(n.startDate),a.days=n.days,a.cellDuration=n.cellDuration,a.cellGroupBy=n.cellGroupBy,a.cellWidth=n.cellWidth,a.cellWidthSpec=n.cellWidthSpec,a.cornerHtml=n.cornerHtml,a.eventHeight=n.taskHeight,a.eventResizeMargin=n.taskResizeMargin,a.floatingEvents=n.floatingTasks,a.floatingTimeHeaders=n.floatingTimeHeaders,a.headerHeight=n.headerHeight,a.heightSpec=n.heightSpec,a.height=n.height,a.linkBottomMargin=n.linkBottomMargin,a.linkPointSize=n.linkPointSize,a.loadingLabelVisible=n.loadingLabelVisible,a.loadingLabelText=n.loadingLabelText,a.locale=n.locale,a.messageBarPosition=n.messageBarPosition,a.messageHideAfter=n.messageHideAfter,a.rowCreateHandling=n.rowCreateHandling,a.progressiveRowRendering=n.progressiveRowRendering,a.progressiveRowRenderingPreload=n.progressiveRowRenderingPreload,a.scale=n.scale,a.scrollDelayEvents=n.scrollDelayTasks,a.scrollDelayCells=n.scrollDelayCells,a.scrollDelayFloats=n.scrollDelayFloats,a.scrollX=n.scrollX,a.scrollY=n.scrollY,n.scrollToTaskId&&(a.scrollToResourceId=n.scrollToTaskId),a.separators=n.separators,a.tapAndHoldTimeout=n.tapAndHoldTimeout,a.eventHtmlLeftMargin=n.taskHtmlLeftMargin,a.eventHtmlRightMargin=n.taskHtmlRightMargin,a.eventMovingStartEndEnabled=n.taskMovingStartEndEnabled,a.eventMovingStartEndFormat=n.taskMovingStartEndFormat,a.eventResizingStartEndEnabled=n.taskResizingStartEndEnabled,a.eventResizingStartEndFormat=n.taskResizingStartEndFormat,a.hideUntilInit=n.hideUntilInit,a.treeIndent=n.treeIndent,a.treeAutoExpand=n.treeAutoExpand,a.treeImageMarginLeft=n.treeImageMarginLeft,a.treeImageMarginTop=n.treeImageMarginTop,a.timeHeaders=n.timeHeaders,a.rowHeaderHideIconEnabled=n.rowHeaderHideIconEnabled,a.rowHeaderScrolling=n.rowHeaderScrolling,a.rowHeaderSplitterWidth=n.rowHeaderSplitterWidth,a.rowHeaderWidth=n.rowHeaderWidth,a.rowHeaderWidthAutoFit=n.rowHeaderWidthAutoFit,a.rowMarginBottom=n.rowMarginBottom,a.rowMinHeight=n.rowMinHeight,a.selectedRows=n.selectedRows,a.theme=n.theme,a.useEventBoxes=n.useEventBoxes,a.snapToGrid=n.snapToGrid,a.uniqueID=n.uniqueID,a.bubble=n.bubbleTask,a.cellBubble=n.bubbleCell,a.resourceBubble=n.bubbleRow,a.contextMenu=n.contextMenuTask,a.contextMenuResource=n.contextMenuRow,a.contextMenuLink=n.contextMenuLink,a.syncResourceTree=n.syncTasks,a.syncLinks=n.syncLinks,a.timeline=n.timeline,a.visible=n.visible,a.eventMoveHandling=n.taskMoveHandling,a.eventClickHandling=n.taskClickHandling,a.eventResizeHandling=n.taskResizeHandling,a.linkCreateHandling=n.linkCreateHandling,a.eventRightClickHandling=n.taskRightClickHandling,a.eventDoubleClickHandling=n.taskDoubleClickHandling,a.rowMoveHandling=n.rowMoveHandling,a.rowClickHandling=n.rowClickHandling,a.rowDoubleClickHandling=n.rowDoubleClickHandling,a.rowEditHandling=n.rowEditHandling,a.rowSelectHandling=n.rowSelectHandling,a.eventVersionsEnabled=n.taskVersionsEnabled,a.eventVersionHeight=n.taskVersionHeight,a.eventVersionMargin=n.taskVersionMargin,a.eventVersionPosition=n.taskVersionPosition,DayPilot.isArray(n.columns)){a.rowHeaderColumns=[];for(var e=0;e<n.columns.length;e++){var t=n.columns[e],i={};DayPilot.Util.copyProps(t,i,["title","width"]),a.rowHeaderColumns.push(i)}}n.r()&&(a.timeHeader=n.timeHeader,a.cellProperties=n.cellProperties,a.cellConfig=n.cellConfig),a.onRowCreate=function(e){"function"==typeof n.onRowCreate&&n.onRowCreate(e)},a.onRowCreated=function(e){"function"==typeof n.onRowCreated&&n.onRowCreated(e)},a.onAfterRender=function(e){"function"==typeof n.onAfterRender&&n.onAfterRender(e)},a.onAfterUpdate=function(e){"function"==typeof n.onAfterUpdate&&n.onAfterUpdate(e)},a.onRowHeaderResized=function(e){n.rowHeaderWidth=a.rowHeaderWidth},a.onAjaxError=function(e){"function"==typeof n.onAjaxError&&n.onAjaxError(e)},a.onRowHeaderColumnResized=function(e){for(var t=e.column,i=DayPilot.indexOf(a.rowHeaderColumns,t),o=0;o<n.columns.length;o++){var r=a.rowHeaderColumns[o];n.columns[o].width=r.width}if("function"==typeof n.onColumnResized){var s={};s.column=n.columns[i],n.onColumnResized(s)}},a.onBeforeRowHeaderRender=function(e){e.task=new DayPilot.Task(e.row.$.row.task,n);var t=[];if(DayPilot.isArray(n.columns))for(var i=0;i<n.columns.length;i++){var a=n.columns[i],o=a.property,s={};s.value=r.getProperty(e.task.data,o),e.task.data.row&&e.task.data.row.columns&&e.task.data.row.columns[i]?s.html=e.task.data.row.columns[i].html:s.html=s.value,t.push(s)}if(e.row.columns=t,"function"==typeof n.onBeforeRowHeaderRender&&n.onBeforeRowHeaderRender(e),DayPilot.isArray(n.columns))for(var i=0;i<n.columns.length;i++){var l=t[i].html;0===i?e.row.html=l:e.row.columns[i-1].html=l}},a.onBeforeCellRender=function(e){e.task=n.tasks.find(e.cell.resource),delete e.cell.resource,"function"==typeof n.onBeforeCellRender&&n.onBeforeCellRender(e)},a.onBeforeTimeHeaderRender=function(e){"function"==typeof n.onBeforeTimeHeaderRender&&n.onBeforeTimeHeaderRender(e)},a.onEventClick=function(e){e.task=new DayPilot.Task(e.e,n),"function"==typeof n.onTaskClick&&n.onTaskClick(e)},a.onEventClicked=function(e){"function"==typeof n.onTaskClicked&&n.onTaskClicked(e)},a.onEventDelete=function(e){"function"==typeof n.onTaskDelete&&n.onTaskDelete(e)},a.onEventDeleted=function(e){"function"==typeof n.onTaskDeleted&&n.onTaskDeleted(e)},a.onEventDoubleClick=function(e){e.task=new DayPilot.Task(e.e,n),"function"==typeof n.onTaskDoubleClick&&n.onTaskDoubleClick(e)},a.onEventDoubleClicked=function(e){"function"==typeof n.onTaskDoubleClicked&&n.onTaskDoubleClicked(e)},a.onEventRightClick=function(e){e.task=new DayPilot.Task(e.e,n),"function"==typeof n.onTaskRightClick&&n.onTaskRightClick(e)},a.onEventRightClicked=function(e){"function"==typeof n.onTaskRightClicked&&n.onTaskRightClicked(e)},a.onRowMoving=function(e){e.Fd=e.source,e.Gd=e.target,e.source=new DayPilot.Task(e.Fd.$.row.task,n),e.target=new DayPilot.Task(e.Gd.$.row.task,n),"function"==typeof n.onRowMoving&&n.onRowMoving(e)},a.onRowMove=function(e){e.Fd=e.source,e.Gd=e.target,e.source=new DayPilot.Task(e.Fd.$.row.task,n),e.target=new DayPilot.Task(e.Gd.$.row.task,n),"function"==typeof n.onRowMove&&n.onRowMove(e),e.source=e.Fd,e.target=e.Gd},a.onRowMoved=function(e){if("Update"===n.rowMoveHandling||"Notify"===n.rowMoveHandling){var t=e.Fd.$.row.task,i=e.Gd.$.row.task,a=e.position;if("forbidden"===a)return;var o=r.findParentArray(t);if(!o)throw"Cannot find source node parent";var s=DayPilot.indexOf(o,t);o.splice(s,1);var l=r.findParentArray(i);if(!l)throw"Cannot find target node parent";var d=DayPilot.indexOf(l,i);switch(a){case"before":l.splice(d,0,t);break;case"after":l.splice(d+1,0,t);break;case"child":i.children||(i.children=[],i.expanded=!0),i.children.push(t)}n.Lc.notify(),n.update()}e.source=new DayPilot.Task(e.Fd.$.row.task,n),e.target=new DayPilot.Task(e.Gd.$.row.task,n),"function"==typeof n.onRowMoved&&n.onRowMoved(e)},a.onRowClick=function(e){e.task=new DayPilot.Task(e.resource.$.row.task,n),"function"==typeof n.onRowClick&&n.onRowClick(e)},a.onRowClicked=function(e){"function"==typeof n.onRowClicked&&n.onRowClicked(e)},a.onRowDoubleClick=function(e){e.task=new DayPilot.Task(e.resource.$.row.task,n),"function"==typeof n.onRowDoubleClick&&n.onRowDoubleClick(e)},a.onRowDoubleClicked=function(e){"function"==typeof n.onRowDoubleClicked&&n.onRowDoubleClicked(e)},a.onRowEdit=function(e){e.task=new DayPilot.Task(e.resource.$.row.task,n),"function"==typeof n.onRowEdit&&n.onRowEdit(e)},a.onRowEdited=function(e){"function"==typeof n.onRowEdited&&n.onRowEdited(e)},a.onRowSelect=function(e){e.task=new DayPilot.Task(e.row.$.row.task,n),"function"==typeof n.onRowSelect&&n.onRowSelect(e)},a.onRowSelected=function(e){"function"==typeof n.onRowSelected&&n.onRowSelected(e)},a.onEventMove=function(e){e.Hd=e.e,e.task=new DayPilot.Task(e.e,n),"function"==typeof n.onTaskMove&&n.onTaskMove(e)},a.onEventMoved=function(e){if("Auto"===n.taskGroupMode){var t=e.Hd,i=t.data.task;for(i.start=t.start(),i.end=t.end();t.data.parent;){var o=a.events.find(t.data.parent.id),r=s.childrenStartEnd(t.data.parent);o.start(r.start),o.end(r.end),a.events.update(o),t=o}}n.Lc.notify(),"function"==typeof n.onTaskMoved&&n.onTaskMoved(e)},a.onEventMoving=function(e){e.task=new DayPilot.Task(e.e,n),e.Hd=e.e,delete e.position,delete e.overlapping,delete e.resource,"function"==typeof n.onTaskMoving&&n.onTaskMoving(e)},a.onEventResize=function(e){e.Hd=e.e,e.task=new DayPilot.Task(e.e,n),"function"==typeof n.onTaskResize&&n.onTaskResize(e)},a.onEventResized=function(e){if("Auto"===n.taskGroupMode){var t=e.Hd,i=t.data.task;for(i.start=t.start(),i.end=t.end();t.data.parent;){var o=a.events.find(t.data.parent.id),r=s.childrenStartEnd(t.data.parent);o.start(r.start),o.end(r.end),a.events.update(o),t=o}}n.Lc.notify(),"function"==typeof n.onTaskResized&&n.onTaskResized(e)},a.onEventResizing=function(e){e.task=new DayPilot.Task(e.e,n),e.Hd=e.e,"function"==typeof n.onTaskResizing&&n.onTaskResizing(e)},a.onLinkCreate=function(e){e.source=n.tasks.find(e.from),e.target=n.tasks.find(e.to),"function"==typeof n.onLinkCreate&&n.onLinkCreate(e)},a.onLinkCreated=function(e){"function"==typeof n.onLinkCreated&&n.onLinkCreated(e)},a.onResourceExpand=function(e){var t=e.resource.$.row.task;t.row||(t.row={}),t.row.collapsed=!1},a.onResourceCollapse=function(e){var t=e.resource.$.row.task;t.row||(t.row={}),t.row.collapsed=!0}},s.Id=function(e){for(var t=0;t<a.rowlist.length;t++){var i=a.rowlist[t];if(i.task===e)return a.internal.createRowObject(i)}return null},s.zd=function(){a.links.list=n.links.list?n.links.list:[]},s.yd=function(){a.resources=[],a.events.list=[],r.clearCache(),s.Jd(n.tasks.list,a.resources,null),l.sheet&&(l.sheet.commit(),l.sheet=null)},s.Kd=function(e){var t=e.type||"Task";e.children&&e.children.length&&(t="Group");var i={};for(var a in e)"children"!==a&&(i[a]=e[a]);var o={};if(o.data=i,o.type=t,i.box||(i.box={}),"undefined"==typeof i.box.html)if("Task"===o.type){var r=i.complete||0;i.box.html=r+"%"}else i.box.html="";return"undefined"==typeof i.box.htmlRight&&(i.box.htmlRight=i.text),"function"==typeof n.onBeforeTaskRender&&n.onBeforeTaskRender(o),o.type=t,o};var l={};l.keys={},l.sheet=null,s.Ld=function(e){if(e.data.box&&!e.data.box.cssClass&&e.data.box.backColor&&"Task"!==e.type){var t=DayPilot.Util.normalizeColor(e.data.box.backColor),i=e.type+"_"+t.replace("#",""),a=n.theme,o=n.theme+"_"+i;return l.keys[i]||(l.keys[i]=!0,l.sheet||(l.sheet=DayPilot.sheet()),"Group"===e.type?(l.sheet.add("."+o+"."+a+"_task_group ."+a+"_event_inner","position:absolute;top:5px;left:0px;right:0px;bottom:6px;overflow:hidden; background: "+t+"; filter: none; border: 0px none;"),l.sheet.add("."+o+"."+a+"_task_group."+a+"_event:before","content:''; border-color: transparent transparent transparent "+t+"; border-style: solid; border-width: 6px; position: absolute; bottom: 0px;"),l.sheet.add("."+o+"."+a+"_task_group."+a+"_event:after","content:''; border-color: transparent "+t+" transparent transparent; border-style: solid; border-width: 6px; position: absolute; bottom: 0px; right: 0px;")):"Milestone"===e.type&&(l.sheet.add("."+o+"."+a+"_task_milestone ."+a+"_event_inner","position:absolute;top:16%;left:16%;right:16%;bottom:16%; background: "+t+"; border: 0px none; -webkit-transform: rotate(45deg);-moz-transform: rotate(45deg);-ms-transform: rotate(45deg);-o-transform: rotate(45deg); transform: rotate(45deg); filter: none;"),
l.sheet.add("."+o+"."+a+"_browser_ie8 ."+a+"_task_milestone ."+a+"_event_inner","-ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(SizingMethod='auto expand', M11=0.7071067811865476, M12=-0.7071067811865475, M21=0.7071067811865475, M22=0.7071067811865476);\""))),o}},s.Jd=function(t,i,o){if(DayPilot.isArray(t))for(var l=0;l<t.length;l++){var d=t[l];r.addToCache(d,o);var c=s.Kd(d),h=c.data,u=c.type,f={};if(DayPilot.Util.copyProps(h,f,["id","start","end","text","complete","tags","versions"]),DayPilot.Util.copyProps(h.box,f),f.parent=o,f.task=d,f.resource=h.id,"Group"==u){f.type="Group",f.html="";var v=s.Ld(c);if(v&&(f.cssClass=(f.cssClass||"")+" "+v,console.log(f.cssClass)),delete f.backColor,"Auto"===n.taskGroupMode){var p=s.childrenStartEnd(d);f.start=p.start,f.end=p.end,f.resizeDisabled=!0,f.moveDisabled=!0}}else if("Milestone"===u){f.html="",d.end=d.start;var v=s.Ld(c);v&&(f.cssClass=(f.cssClass||"")+" "+v),h.end=h.start,f.end=h.start,f.barHidden=!0,f.resizeDisabled=!0,f.type="Milestone",f.width=n.taskHeight,delete f.backColor}else"Task"===u&&e();f.moveVDisabled=!0,f.htmlRight=h.box.htmlRight,f.htmlLeft=h.box.htmlLeft,a.events.list.push(f);var g={};g.task=d,DayPilot.Util.copyProps(h.row,g),g.name=h.text,g.id=h.id,g.children=[],g.expanded=!h.row||!h.row.collapsed,d.children&&d.children.length&&s.Jd(d.children,g.children,d),i.push(g)}},s.childrenStartEnd=function(e){if(!e.children||!e.children.length){var t=e.start,i=e.end;return"Milestone"===e.type&&(i=t),{"start":new DayPilot.Date(t),"end":new DayPilot.Date(i)}}for(var t=null,i=null,n=0;n<e.children.length;n++){var a=s.childrenStartEnd(e.children[n]);(!t||a.start.getTime()<t.getTime())&&(t=a.start),(!i||a.end.getTime()>i.getTime())&&(i=a.end)}return{"start":t,"end":i}},this.rows={},this.rows.expand=function(e){a.rows.expand(e)},this.rows.expandAll=function(){a.rows.expandAll()},this.rows.selection={},this.rows.selection.add=function(e){a.rows.find(e.data.id)},this.rows.selection.clear=function(){a.rows.selection.clear()},this.rows.selection.get=function(){return a.rows.selection.get().map(function(e){return new DayPilot.Task(e.$.row.task,n)})},this.qd=null,this.rd=function(e){var t={"tasks":{"preInit":function(){var e=this.data;e&&(DayPilot.isArray(e.list)?n.tasks.list=e.list:n.tasks.list=e)}},"links":{"preInit":function(){var e=this.data;e&&(DayPilot.isArray(e.list)?n.links.list=e.list:n.links.list=e)}},"scrollTo":{"postInit":function(){this.data&&n.scrollTo(this.data)}},"scrollToTask":{"postInit":function(){this.data&&n.scrollToTask(this.data)}}};this.qd=t;for(var i in e)if(t[i]){var a=t[i];a.data=e[i],a.preInit&&a.preInit()}else n[i]=e[i]},this.pd=function(){var e=this.qd;for(var t in e){var i=e[t];i.postInit&&i.postInit()}},this.internal={},this.internal.initialized=function(){return n.A},this.internal.rowObjectForTaskData=s.Id,this.internal.loadOptions=n.rd,this.Lc={},this.Lc.scope=null,this.Lc.notify=function(){n.Lc.scope&&n.Lc.scope["$apply"]()},this.rd(i)},"undefined"!=typeof jQuery&&!function(e){e.fn.daypilotGantt=function(e){var t=null,i=this.each(function(){if(!this.daypilot){var i=new DayPilot.Gantt(this.id,e);i.init(),this.daypilot=i,t||(t=i)}});return 1===this.length?t:i}}(jQuery),function(){var e=DayPilot.am();e&&e.directive("daypilotGantt",["$parse",function(e){return{"restrict":"E","template":"<div id='{{id}}'></div>","compile":function(t,i){return t.replaceWith(this["template"].replace("{{id}}",i["id"])),function(t,i,n){var a=new DayPilot.Gantt(i[0]);a.Lc.scope=t,a.init();var o=n["id"];o&&(t[o]=a);var r=n["publishAs"];if(r){(0,e(r).assign)(t,a)}for(var s in n)if(0===s.indexOf("on")){var l=DayPilot.Util.shouldApply(s);l?!function(i){a[i]=function(a){var o=e(n[i]);t["$apply"](function(){o(t,{"args":a})})}}(s):!function(i){a[i]=function(a){e(n[i])(t,{"args":a})}}(s)}var d=t["$watch"],c=n["config"]||n["daypilotConfig"];d.call(t,c,function(e,t){a.rd(e),a.update()},!0)}}}}])}(),"undefined"!=typeof Sys&&Sys.Application&&Sys.Application.notifyScriptLoaded&&Sys.Application.notifyScriptLoaded()}}(),"undefined"==typeof DayPilot)var DayPilot={};if("undefined"==typeof DayPilot.Global&&(DayPilot.Global={}),function(){"undefined"==typeof DayPilot.Kanban&&(DayPilot.Kanban=function(e,t){this.v="2911";var i=this;this.barWidth=5,this.cardAutoHeight=!0,this.cardHeight=60,this.cardMarginLeft=5,this.cardMarginRight=5,this.cardMarginBottom=5,this.columnHeaderHeight=20,this.crosshairColor="gray",this.height=300,this.heightSpec="Auto",this.theme="kanban_default",this.cellMarginBottom=4,this.cellMarginTop=5,this.columnWidthSpec="Auto",this.columnWidth=200,this.rowMinHeight=0,this.swimlaneCollapsingEnabled=!1,this.swimlaneHeaderWidth=80,this.visible=!0,this.swimlanes={},this.swimlanes.list=[],this.columns={},this.columns.list=[],this.cards={},this.cards.list=[],this.cardDeleteHandling="Disabled",this.cardMoveHandling="Update",this.columnMoveHandling="Disabled",this.swimlaneMoveHandling="Disabled",this.onBeforeCellRender=null,this.onCardClick=null,this.onCardClicked=null,this.onCardDelete=null,this.onCardDeleted=null,this.onCardMove=null,this.onCardMoved=null,this.onColumnMove=null,this.onColumnMoved=null,this.onHeightChanged=null,this.onSwimlaneMove=null,this.onSwimlaneMoved=null;var n=new DayPilot.Scheduler(e);this.scheduler=n;var a={},o=15;a.translate=function(){var e=n;e.startDate="2000-01-01",e.scale="Day",e.timeHeaders=[{groupBy:"Cell",format:"d"}],e.heightSpec=i.heightSpec,e.cellWidthSpec=i.columnWidthSpec,e.cellWidth=i.columnWidth,e.cellsMarkBusiness=!1,e.crosshairColor=i.crosshairColor,e.dynamicEventRendering="Disabled",e.floatingEvents=!1,e.floatingTimeHeaders=!1,e.rowMinHeight=i.rowMinHeight,e.rowMarginTop=i.cellMarginTop,e.rowMarginBottom=i.cellMarginBottom,e.eventMoveToPosition=!0,e.headerHeight=i.columnHeaderHeight,e.eventResizeHandling="Disabled",e.timeRangeSelectedHandling="Disabled",e.eventHeight=i.cardHeight,e.eventMarginLeft=i.cardMarginLeft,e.eventMarginRight=i.cardMarginRight,e.eventMarginBottom=i.cardMarginBottom,e.eventTextWrappingEnabled=!0,e.cellStacking=!0,e.cellStackingAutoHeight=i.cardAutoHeight,e.durationBarVisible=!1,e.theme=i.theme,e.visible=i.visible,e.rowHeaderWidth=i.swimlaneHeaderWidth,e.eventDeleteHandling=i.cardDeleteHandling,e.eventMoveHandling=i.cardMoveHandling,e.rowMoveHandling=DayPilot.list(i.swimlanes.list).isEmpty()?"Disabled":i.swimlaneMoveHandling,e.onHeightChanged=i.onHeightChanged,e.internal.cssNames.timeheadercol="_colheadercell",e.internal.cssNames.timeheadercolInner="_colheadercell_inner",e.internal.cssNames.resourcedivider="_rowheaderdivider",e.internal.cssNames.event="_card",e.internal.cssNames.eventInner="_card_inner",e.internal.cssNames.eventDelete="_card_delete",e.internal.cssNames.eventMovingSource="_card_moving_source",i.swimlaneCollapsingEnabled&&(e.rowHeaderWidthMarginRight=15),e.onBeforeTimeHeaderRender=function(e){var t=i.Md(e.header.start);if(e.header.html=t.name,e.header.toolTip=t.toolTip||"",e.header.areas=DayPilot.list(t.areas).map(function(e){var t=[];return DayPilot.Util.copyProps(e,t),t}),DayPilot.list(e.header.areas).each(function(e){e.target=new DayPilot.Column(t,i)}),"Disabled"!==i.columnMoveHandling){var n=i.theme+"_columnmove_handle";e.header.areas.push({"left":0,"top":0,"width":20,"height":20,"css":n,"mousedown":i.Nd,"action":"None"})}},e.onBeforeCellRender=function(t){var n={};n.cell={},n.cell.column=new DayPilot.Column(i.Md(t.cell.start),i),n.cell.swimlane=null;var a=i.Od(t.cell.resource);a&&(n.cell.swimlane=new DayPilot.Swimlane(a,i)),n.cell.areas=[],n.cell.cssClass=null,n.cell.html=null,n.cell.backImage=null,n.cell.backRepeat=null,n.cell.backColor=null,"function"==typeof i.onBeforeCellRender&&(i.onBeforeCellRender(n),DayPilot.Util.copyProps(n.cell,t.cell,["areas","cssClass","html","backImage","backRepeat","backColor"]),DayPilot.list(t.cell.areas).each(function(e){e.target={"swimlane":n.cell.swimlane,"column":n.cell.column}}));var o=e.rows.find(t.cell.resource);e.resources[o.index].collapsed&&(t.cell.cssClass||(t.cell.cssClass=""),t.cell.cssClass+=" "+i.theme+"_collapsed")},e.onEventClick=function(e){var t=new DayPilot.Args(e);t.card=new DayPilot.Card(e.e.data.card,i),"function"==typeof i.onCardClick&&i.onCardClick(t),e.wrapped=t},e.onEventClicked=function(e){var t=e.wrapped;"function"==typeof i.onCardClicked&&i.onCardClicked(t)},e.onEventDelete=function(e){var t=new DayPilot.Args(e);t.card=new DayPilot.Card(e.e.data.card,i),"function"==typeof i.onCardDelete&&i.onCardDelete(t),e.wrapped=t},e.onEventDeleted=function(e){DayPilot.rfa(i.cards.list,e.e.data.card);var t=e.wrapped;"function"==typeof i.onCardDeleted&&i.onCardDeleted(t)},e.onEventMove=function(e){var t=new DayPilot.Args(e);t.card=new DayPilot.Card(e.e.data.card,i),t.column=new DayPilot.Column(i.Md(e.newStart)),t.position=e.position,"*"!==e.newResource?t.swimlane=new DayPilot.Swimlane(i.Od(e.newResource),i):t.swimlane=null;for(var o=n.cells.find(e.newStart,e.newResource)[0].events(),r=e.position,s=null,l=r-1;o[l];){if(o[l].data!==e.e.data){s=new DayPilot.Card(o[l]);break}l-=1}for(var d=null,c=r;o[c];){if(o[c].data!==e.e.data){d=new DayPilot.Card(o[c]);break}c+=1}if(t.previous=s,t.next=d,"function"==typeof i.onCardMove&&i.onCardMove(t),e.wrapped=t,!e.preventDefault.value){var h=0;d?h=d.wrapped.data.sort[0]:s&&(h=s.wrapped.data.sort[0]),e.e.data.sort=[h,(new DayPilot.Date).toString()],DayPilot.rfa(i.cards.list,e.e.data.card);var u=0;d?u=DayPilot.indexOf(i.cards.list,d.data):s&&(u=DayPilot.indexOf(i.cards.list,s.data)+1),i.cards.list.splice(u,0,e.e.data.card),a.updateSort()}},e.onEventMoved=function(e){var t=e.wrapped,n=DayPilot.list(i.cards.list).find(function(t){return e.e.data.card===t});n.swimlane=t.swimlane?t.swimlane.data.id:null,n.column=t.column.data.id,"function"==typeof i.onCardMoved&&i.onCardMoved(t)},e.onBeforeResHeaderRender=function(e){if(i.swimlaneCollapsingEnabled&&!DayPilot.list(i.swimlanes.list).isEmpty()){var t=i.theme+"_swimlane_collapse";e.resource.collapsed&&(t=i.theme+"_swimlane_expand"),e.resource.areas=[{"right":0,"top":0,"height":15,"width":o,"action":"JavaScript","css":t,"js":function(){i.Pd(e.resource.index)}}]}},e.onRowMove=function(e){var t=new DayPilot.Args(e);e.wrapped=t,t.swimlane=new DayPilot.Swimlane(e.source.$.row.swimlane);var a=0;switch(e.position){case"before":a=e.target.index;break;case"after":a=e.target.index+1;break;default:throw"Unexpected target swimlane position: "+e.position}t.position=a,t.previous=null;for(var o=a-1;n.rowlist[o]&&n.rowlist[o].swimlane!==t.swimlane.data;)t.previous=new DayPilot.Swimlane(n.rowlist[o].swimlane),o-=1;t.next=null;for(var r=a;n.rowlist[r]&&n.rowlist[r].swimlane!==t.swimlane.data;)t.next=new DayPilot.Swimlane(n.rowlist[r].swimlane),r+=1;"function"==typeof i.onSwimlaneMove&&i.onSwimlaneMove(t)},e.onRowMoved=function(e){var t=e.wrapped;DayPilot.rfa(i.swimlanes.list,t.swimlane.data);var n=0;t.next?n=DayPilot.indexOf(i.swimlanes.list,t.next.data):t.previous&&(n=DayPilot.indexOf(i.swimlanes.list,t.previous.data)+1),i.swimlanes.list.splice(n,0,t.swimlane.data),"function"==typeof i.onSwimlaneMoved&&i.onSwimlaneMoved(t)},e.treePreventParentUsage=!0},a.loadCards=function(){var e=new DayPilot.Date("2000-01-01"),t=i.theme+"_card_header",a=i.theme+"_card_body",o=(new DayPilot.Date).toString();n.sortDirections=["asc","desc"],n.events.list=DayPilot.list(i.cards.list).map(function(n,r){var s=n.html||n.text||"",l=n.name||"",d={};return d.id=n.id,d.text=n.text,d.html="<div class='"+t+"'>"+l+"</div><div class='"+a+"'>"+s+"</div>",d.resource=n.swimlane,d.start=e.addDays(DayPilot.list(i.columns.list).findIndex(function(e){return n.column===e.id})),d.end=d.start.addDays(1),d.card=n,d.height=n.height,d.cssClass=n.cssClass,d.sort=[r,o],d.areas=DayPilot.list(n.areas).map(function(e){var t={};return DayPilot.Util.copyProps(e,t),e.js&&(t.js=function(t){e.js(new DayPilot.Card(t.data.card,i))}),t}),d.areas.push({"left":0,"width":5,"top":0,"bottom":0,"backColor":n.barColor,"cssClass":i.theme+"_card_bar"}),d})},a.updateSort=function(){var e=(new DayPilot.Date).toString();DayPilot.list(i.cards.list).each(function(t,i){var n=a.findSchedulerEventData(t);n&&(n.sort=[i,e])})},a.findSchedulerEventData=function(e){return DayPilot.list(n.events.list).find(function(t){return t.card===e})},a.loadSwimlanes=function(){var e=DayPilot.list(i.swimlanes.list);n.resources=e.map(function(e){var t={};return t.name=e.name,t.id=e.id,t.swimlane=e,e.collapsed&&(t.collapsed=!0,t.eventHeight=20,t.hideEvents=!0),t}),e.isEmpty()&&(n.resources=[{name:"",id:"*"}])},a.loadColumns=function(){var e=DayPilot.list(i.columns.list);n.days=e.length};var r={};r.active=null,r.div=null,r.update=function(){r.clear();var e=r.findPosition();r.draw(e)},r.clear=function(){DayPilot.de(r.div),r.div=null},r.draw=function(e){var t=0;if(e>=n.itline.length){var a=n.itline[n.itline.length-1];t=a.left+a.width-3}else t=n.itline[e].left;var o=document.createElement("div");o.style.position="absolute",o.style.left=t+"px",o.style.width="3px",o.style.top=0,o.style.height=n.headerHeight+"px",o.className=i.theme+"_columnmove_position",r.div=o,n.nav.timeHeader.appendChild(o)},r.findPosition=function(){if(i.coords.x<0)return 0;var e=DayPilot.list(n.itline).findIndex(function(e){var t=e.left+n.rowHeaderWidth,a=e.width;return i.coords.x<t+a/2});return e===-1?n.itline.length:e},this.Nd=function(e){r.active=e},this.Md=function(e){return i.columns.list[e.getDay()-1]},this.Od=function(e){return DayPilot.list(i.swimlanes.list).find(function(t){return t.id===e})},this.message=function(e,t,i,a){n.message(e,t,i,a)},this.show=function(){i.visible=!0,n.show()},this.hide=function(){i.visible=!1,n.hide()},this.cards.add=function(e){var t=null;t=e&&e instanceof DayPilot.Card?e.data:e,e&&(i.cards.list.push(t),i.update())},this.cards.remove=function(e){var t=null;t=e&&e instanceof DayPilot.Card?e.data:e,e&&(DayPilot.rfa(i.cards.list,e),i.update())},this.cards.update=function(e){i.update()},this.Pd=function(e){DayPilot.list(i.swimlanes.list).isEmpty()||(i.swimlanes.list[e].collapsed=!i.swimlanes.list[e].collapsed),i.update()},this.init=function(){a.translate(),a.loadSwimlanes(),a.loadColumns(),a.loadCards(),n.init(),i.Rc(),this.A=!0},this.Cd=!1,this.dispose=function(){n.dispose(),i.Cd=!0},this.update=function(){if(i.Cd)throw new DayPilot.Error("This DayPilot.Gantt instance has been disposed.");a.translate(),a.loadSwimlanes(),a.loadColumns(),a.loadCards(),n.update()},this.Rc=function(){DayPilot.re(document,"mouseup",i.Qd),DayPilot.re(document,"mousemove",i.Rd)},this.Lc={},this.Lc.scope=null,this.Lc.notify=function(){i.Lc.scope&&i.Lc.scope["$apply"]()},this.qd=null,this.rd=function(e){var t={"cards":{"preInit":function(){var e=this.data;e&&(DayPilot.isArray(e.list)?i.cards.list=e.list:i.cards.list=e)}},"columns":{"preInit":function(){var e=this.data;e&&(DayPilot.isArray(e.list)?i.columns.list=e.list:i.columns.list=e)}},"swimlanes":{"preInit":function(){var e=this.data;e&&(DayPilot.isArray(e.list)?i.swimlanes.list=e.list:i.swimlanes.list=e)}}};this.qd=t,i.columns.list=[],i.swimlanes.list=[],i.cards.list=[];for(var n in e)if(t[n]){var a=t[n];a.data=e[n],a.preInit&&a.preInit()}else i[n]=e[n]},this.pd=function(){var e=this.qd;for(var t in e){var i=e[t];i.postInit&&i.postInit()}},this.internal={},this.internal.loadOptions=i.rd,this.rd(t),this.Nc=function(){var e=dp.nav.top;return!!e&&(e.offsetWidth>0&&e.offsetHeight>0)},this.Oc=function(){var e=i,t=e.Nc;t()||e.Pc||(e.Pc=setInterval(function(){t()&&(e.update(),clearInterval(e.Pc))},100))},this.Rd=function(e){i.coords=DayPilot.mo3(n.nav.top,e),r.active&&r.update()},this.Qd=function(e){if(r.active){var t=r.active.source,n=r.findPosition(),a=i.Md(t.start),o=new DayPilot.Args;o.column=new DayPilot.Column(a,i),o.position=n,o.previous=null,o.next=null;for(var s=null,l=o.position;0!==l&&!s;)a!==i.columns.list[l-1]&&(s=i.columns.list[l-1]),l-=1;s&&(o.previous=new DayPilot.Column(s,i));var d=null;for(l=o.position;l<i.columns.list.length-1&&!d;)a!==i.columns.list[l]&&(d=i.columns.list[l]),l+=1;if(d&&(o.next=new DayPilot.Column(d,i)),"function"==typeof i.onColumnMove&&i.onColumnMove(o),!o.preventDefault.value){if("Update"===i.columnMoveHandling){DayPilot.rfa(i.columns.list,o.column.data);var c=0;o.next?c=DayPilot.indexOf(i.columns.list,o.next.data):o.previous&&(c=DayPilot.indexOf(i.columns.list,o.previous.data)+1),i.columns.list.splice(c,0,o.column.data),i.update()}"function"==typeof i.onColumnMoved&&i.onColumnMove(o)}r.active=null,r.clear()}}},DayPilot.Card=function(e,t){if(e instanceof DayPilot.Event){var i=e;this.data=i.data.card,this.wrapped=e}else this.data=e;this.control=t},DayPilot.Column=function(e,t){this.data=e,this.control=t},DayPilot.Swimlane=function(e,t){this.data=e,this.control=t},function(){var e=DayPilot.am();e&&e.directive("daypilotKanban",["$parse",function(e){return{"restrict":"E","template":"<div id='{{id}}'></div>","compile":function(t,i){return t.replaceWith(this["template"].replace("{{id}}",i["id"])),function(t,i,n){var a=new DayPilot.Kanban(i[0]);a.Lc.scope=t,a.init();var o=n["id"];o&&(t[o]=a);var r=n["publishAs"];if(r){(0,e(r).assign)(t,a)}for(var s in n)if(0===s.indexOf("on")){var l=DayPilot.Util.shouldApply(s);l?!function(i){a[i]=function(a){var o=e(n[i]);t["$apply"](function(){o(t,{"args":a})})}}(s):!function(i){a[i]=function(a){e(n[i])(t,{"args":a})}}(s)}var d=t["$watch"],c=n["config"]||n["daypilotConfig"];d.call(t,c,function(e,t){a.rd(e),a.update()},!0)}}}}])}())}(),"undefined"==typeof DayPilot)var DayPilot={};if("undefined"==typeof DayPilot.Global&&(DayPilot.Global={}),function(){if("undefined"==typeof DayPilot.Menu){var e=function(){},t={};t.mouse=null,t.menu=null,t.handlersRegistered=!1,t.hideTimeout=null,t.waitingSubmenu=null,DayPilot.Menu=function(i){var n=this,a=null;this.v="2911",this.zIndex=10,this.cssClassPrefix="menu_default",this.cssOnly=!0,this.menuTitle=null,this.showMenuTitle=!1,this.hideOnMouseOut=!1,this.theme=null,this.onShow=null,this.n=function(){},i&&DayPilot.isArray(i)&&(this.items=i),this.show=function(i,o){var o=o||{},r=null;if(i?"string"==typeof i.id||"number"==typeof i.id?r=i.id:"function"==typeof i.id?r=i.id():"function"==typeof i.value&&(r=i.value()):r=null,"undefined"!=typeof DayPilot.Bubble&&DayPilot.Bubble.hideActive(),o.submenu||t.menuClean(),this.n.submenu=null,null!==t.mouse){n.cssOnly||(n.cssOnly=!0,DayPilot.Util.log("DayPilot: cssOnly = false mode is not supported since DayPilot Pro 8.0."));var s=null;if(i&&i.isRow&&i.$.row.task?(s=new DayPilot.Task(i.$.row.task,i.calendar),s.menuType="resource"):s=i&&i.isEvent&&i.data.task?new DayPilot.Task(i,i.calendar):i,"function"==typeof n.onShow){var l={};if(l.source=s,l.menu=n,l.preventDefault=function(){l.preventDefault.value=!0},n.onShow(l),l.preventDefault.value)return}var d=document.createElement("div");if(d.style.position="absolute",d.style.top="0px",d.style.left="0px",d.style.display="none",d.style.overflow="hidden",d.style.zIndex=this.zIndex+1,d.className=this.applyCssClass("main"),d.onclick=function(e){e.cancelBubble=!0,this.parentNode.removeChild(this)},this.hideOnMouseOut&&(d.onmousemove=function(e){clearTimeout(t.hideTimeout)},d.onmouseout=function(e){n.delayedHide()}),!this.items||0===this.items.length)throw"No menu items defined.";if(this.showMenuTitle){var c=document.createElement("div");c.innerHTML=this.menuTitle,c.className=this.applyCssClass("title"),d.appendChild(c)}for(var h=0;h<this.items.length;h++){var u=this.items[h],f=document.createElement("div");if(DayPilot.Util.addClass(f,this.applyCssClass("item")),u.items&&DayPilot.Util.addClass(f,this.applyCssClass("item_haschildren")),"undefined"!=typeof u&&!u.hidden){if("-"===u.text){var v=document.createElement("div");f.appendChild(v)}else{var p=document.createElement("a");if(p.style.position="relative",p.style.display="block",u.cssClass&&DayPilot.Util.addClass(p,u.cssClass),u.disabled)DayPilot.Util.addClass(p,n.applyCssClass("item_disabled"));else{if(u.onclick||u.onClick){p.item=u,p.onclick=function(e,t){return function(i){if("function"==typeof e.onClick){var n={};if(n.item=e,n.source=t.source,n.originalEvent=i,n.preventDefault=function(){n.preventDefault.value=!0},e.onClick(n),n.preventDefault.value)return}e.onclick&&e.onclick.call(t,i)}}(u,p);var g=function(e,i){return function(n){n.stopPropagation(),n.preventDefault();var a=function(){window.setTimeout(function(){i.source.calendar.internal.touch.active=!1},500)};if("function"==typeof e.onClick){var o={};if(o.item=e,o.originalEvent=n,o.preventDefault=function(){o.preventDefault.value=!0},e.onClick(o),o.preventDefault.value)return void a()}e.onclick&&e.onclick.call(i,n),t.menuClean(),a()}};p.ontouchstart=function(e){e.stopPropagation(),e.preventDefault(),p.source.calendar.internal.touch.active=!0},p.ontouchend=g(u,p)}if(u.onclick)e();else if(u.href)p.href=u.href.replace(/\x7B0\x7D/gim,r),u.target&&p.setAttribute("target",u.target);else if(u.command){var m=function(e,t){return function(i){var n=t.source,a=e;a.action=a.action?a.action:"CallBack";var o=n.calendar||n.root;if(n instanceof DayPilot.Link)return void o.internal.linkMenuClick(a.command,n,a.action);if(n instanceof DayPilot.Selection)return void o.internal.timeRangeMenuClick(a.command,n,a.action);if(n instanceof DayPilot.Event)return void o.internal.eventMenuClick(a.command,n,a.action);if(n instanceof DayPilot.Selection)return void o.internal.timeRangeMenuClick(a.command,n,a.action);if(n instanceof DayPilot.Task)return void("resource"===n.menuType?o.internal.resourceHeaderMenuClick(a.command,t.menuSource,a.action):o.internal.eventMenuClick(a.command,t.menuSource,a.action));switch(n.menuType){case"resource":return void o.internal.resourceHeaderMenuClick(a.command,n,a.action);case"selection":return void o.internal.timeRangeMenuClick(a.command,n,a.action);default:return void o.internal.eventMenuClick(a.command,n,a.action)}i.preventDefault()}};p.onclick=m(u,p),p.ontouchend=m(u,p)}}p.source=s,p.menuSource=i;var y=document.createElement("span");if(y.className=n.applyCssClass("item_text"),y.innerHTML=u.text,p.appendChild(y),u.image){var b=document.createElement("img");b.src=u.image,b.style.position="absolute",b.style.top="0px",b.style.left="0px",p.appendChild(b)}if(u.icon){var w=document.createElement("span");w.className=n.applyCssClass("item_icon");var D=document.createElement("i");D.className=u.icon,w.appendChild(D),p.appendChild(w)}var k=function(e,i){return function(){var a=i.source,o=e,r=t.waitingSubmenu;if(r){if(r.parent===o)return;clearTimeout(r.timeout),t.waitingSubmenu=null}t.waitingSubmenu={},t.waitingSubmenu.parent=o,t.waitingSubmenu.timeout=setTimeout(function(){if(t.waitingSubmenu=null,(!n.n.submenu||n.n.submenu.item!==o)&&(n.n.submenu&&n.n.submenu.item!==o&&(DayPilot.Util.removeClass(n.n.submenu.link.parentNode,n.applyCssClass("item_haschildren_active")),n.n.submenu.menu.hide(),n.n.submenu=null),o.items)){var r=n.cloneOptions();r.items=o.items,n.n.submenu={},n.n.submenu.menu=new DayPilot.Menu(r),n.n.submenu.menu.show(a,{"submenu":!0,"parentLink":i,"parentItem":e}),n.n.submenu.item=o,n.n.submenu.link=i,DayPilot.Util.addClass(i.parentNode,n.applyCssClass("item_haschildren_active"))}},300)}};p.onmouseover=k(u,p),f.appendChild(p)}d.appendChild(f)}}var C=function(e){window.setTimeout(function(){t.menuClean(),DayPilot.MenuBar.deactivate()},100)};d.onclick=C,d.ontouchend=C,d.onmousedown=function(e){e=e||window.event,e.cancelBubble=!0,e.stopPropagation&&e.stopPropagation()},d.oncontextmenu=function(){return!1},document.body.appendChild(d),n.n.visible=!0,n.n.source=i,d.style.display="";var x=d.offsetHeight,P=d.offsetWidth;d.style.display="none";var S=document.documentElement.clientHeight,A=document.documentElement.clientWidth,T="number"==typeof o.windowMargin?o.windowMargin:5;if(function(){var e=o.initiator;if(e){var t=e.div,i=e.e,n=e.area,r=DayPilot.Areas.createArea(t,i,n);t.appendChild(r),a=r;var s=DayPilot.abs(r);o.x=s.x,o.y=s.y+s.h+2}}(),function(){var e="number"==typeof o.x?o.x:t.mouse.x+1,i="number"==typeof o.y?o.y:t.mouse.y+1;if(i>S-x&&0!==S){var n=i-(S-x)+T;d.style.top=i-n+"px"}else d.style.top=i+"px";if("right"===o.align&&(e-=P),e>A-P&&0!==A){var a=e-(A-P)+T;d.style.left=e-a+"px"}else d.style.left=e+"px"}(),o.parentLink){var E=o.parentLink,M=parseInt(new DayPilot.StyleReader(d).get("border-top-width")),H=DayPilot.abs(o.parentLink.parentNode),_=H.x+E.offsetWidth,R=H.y-M;_+P>A&&(_=Math.max(0,H.x-P));var B=document.body.scrollTop+document.documentElement.scrollTop;R+x-B>S&&(R=Math.max(0,S-x+B)),d.style.left=_+"px",d.style.top=R+"px"}d.style.display="",this.addShadow(d),this.n.div=d,o.submenu||(DayPilot.Menu.active=this)}},this.applyCssClass=function(e){var t=this.theme||this.cssClassPrefix,i=this.cssOnly?"_":"";return t?t+i+e:""},this.cloneOptions=function(){for(var e={},t=["cssOnly","cssClassPrefix","useShadow","zIndex"],i=0;i<t.length;i++){var n=t[i];e[n]=this[n]}return e},this.hide=function(){this.n.submenu&&this.n.submenu.menu.hide(),this.removeShadow(),this.n.div&&this.n.div.parentNode===document.body&&document.body.removeChild(this.n.div),a&&(DayPilot.de(a),a=null),n.n.visible=!1,n.n.source=null},this.delayedHide=function(){t.hideTimeout=setTimeout(function(){n.hide()},200)},this.cancelHideTimeout=function(){clearTimeout(t.hideTimeout)},this.init=function(e){t.mouseMove(e)},this.addShadow=function(e){},this.removeShadow=function(){if(this.n.shadows){for(var e=0;e<this.n.shadows.length;e++)document.body.removeChild(this.n.shadows[e]);this.n.shadows=[]}};var o=DayPilot.isArray(i)?null:i;if(o)for(var r in o)this[r]=o[r]},DayPilot.MenuBar=function(e,t){var i=this,t=t||{};this.items=[],this.theme="menubar_default",this.windowMargin=0,this.nav={},this.elements={},this.elements.items=DayPilot.list(),this.Sd=null;for(var n in t)this[n]=t[n];this.Td=function(e){return this.theme+"_"+e},this.na=function(){this.nav.top=document.getElementById(e);var t=this.nav.top;t.className=this.Td("main"),DayPilot.list(i.items).each(function(e){var n=document.createElement("span");n.innerHTML=e.text,n.className=i.Td("item"),n.data=e,n.onclick=function(){return i.active&&i.active.item===e?void i.Ud():void(e.children&&i.Vd(n))},n.onmousedown=function(e){e.stopPropagation()},n.onmouseover=function(){i.active&&i.active.item!==e&&i.Vd(n)},t.appendChild(n),i.elements.items.push(n)})},this.Ud=function(){var e=i.Td("item_active");i.elements.items.each(function(t){DayPilot.Util.removeClass(t,e)}),i.active&&i.active.menu&&i.active.menu.hide(),i.active=null},this.Wd=function(e){return!!i.active&&i.active.item===e.data},this.Vd=function(e){if(!i.Wd(e)){i.Ud();var t=e.data,n=i.active={};n.item=t,n.div=e;var a=i.Td("item_active");DayPilot.Util.addClass(e,a);var o=DayPilot.abs(e);t.children&&(n.menu=new DayPilot.Menu({"items":t.children}),n.menu.show(null,{"x":o.x+o.w,"y":o.y+o.h,"align":t.align,"windowMargin":i.windowMargin})),DayPilot.MenuBar.active=i}},this.init=function(){this.na()}},DayPilot.MenuBar.deactivate=function(){DayPilot.MenuBar.active&&(DayPilot.MenuBar.active.Ud(),DayPilot.MenuBar.active=null)},t.menuClean=function(){"undefined"!=typeof DayPilot.Menu.active&&DayPilot.Menu.active&&(DayPilot.Menu.active.hide(),DayPilot.Menu.active=null)},t.mouseDown=function(e){"undefined"!=typeof t&&(t.menuClean(),DayPilot.MenuBar.deactivate())},t.mouseMove=function(e){"undefined"!=typeof t&&(t.mouse=t.mousePosition(e))},t.touchMove=function(e){"undefined"!=typeof t&&(t.mouse=t.touchPosition(e))},t.touchStart=function(e){"undefined"!=typeof t&&(t.mouse=t.touchPosition(e))},t.touchEnd=function(e){},t.touchPosition=function(e){if(!e||!e.touches)return null;var t=e.touches[0],i={};return i.x=t.pageX,i.y=t.pageY,i.clientX=t.clientX,i.clientY=t.clientY,i},t.mousePosition=function(e){var t=0,i=0,e=e||window.event;e.pageX||e.pageY?(t=e.pageX,i=e.pageY):(e.clientX||e.clientY)&&(t=e.clientX+document.body.scrollLeft+document.documentElement.scrollLeft,i=e.clientY+document.body.scrollTop+document.documentElement.scrollTop);var n={};return n.x=t,n.y=i,n.clientY=e.clientY,n.clientX=e.clientX,n},DayPilot.Menu.touchPosition=function(e){e.touches&&(t.mouse=t.touchPosition(e))},t.handlersRegistered||(DayPilot.re(document,"mousemove",t.mouseMove),DayPilot.re(document,"mousedown",t.mouseDown),DayPilot.re(document,"touchmove",t.touchMove),DayPilot.re(document,"touchstart",t.touchStart),DayPilot.re(document,"touchend",t.touchEnd),t.handlersRegistered=!0),"undefined"!=typeof Sys&&Sys.Application&&Sys.Application.notifyScriptLoaded&&Sys.Application.notifyScriptLoaded()}}(),"undefined"==typeof DayPilot&&(DayPilot={}),function(){DayPilot.ModalStatic={},DayPilot.ModalStatic.list=[],DayPilot.ModalStatic.hide=function(){if(this.list.length>0){var e=this.list.pop();e&&e.hide()}},DayPilot.ModalStatic.remove=function(e){for(var t=DayPilot.ModalStatic.list,i=0;i<t.length;i++)if(t[i]===e)return void t.splice(i,1)},DayPilot.ModalStatic.close=function(e){DayPilot.ModalStatic.result(e),DayPilot.ModalStatic.hide()},DayPilot.ModalStatic.result=function(e){var t=DayPilot.ModalStatic.list;t.length>0&&(t[t.length-1].result=e)},DayPilot.ModalStatic.displayed=function(e){for(var t=DayPilot.ModalStatic.list,i=0;i<t.length;i++)if(t[i]===e)return!0;return!1},DayPilot.ModalStatic.stretch=function(){if(this.list.length>0){var e=this.list[this.list.length-1];e&&e.stretch()}},DayPilot.ModalStatic.last=function(){var e=DayPilot.ModalStatic.list;return e.length>0?e[e.length-1]:null};var e=function(){var e=document.createElement("style");e.setAttribute("type","text/css"),e.styleSheet||e.appendChild(document.createTextNode("")),(document.head||document.getElementsByTagName("head")[0]).appendChild(e);var t=!!e.styleSheet,i={};return i.rules=[],i.commit=function(){try{t&&(e.styleSheet.cssText=this.rules.join("\n"))}catch(e){}},i.add=function(i,n,a){if(t)return void this.rules.push(i+"{"+n+"}");if(e.sheet.insertRule)"undefined"==typeof a&&(a=e.sheet.cssRules.length),e.sheet.insertRule(i+"{"+n+"}",a);else{if(!e.sheet.addRule)throw"No CSS registration method found";e.sheet.addRule(i,n,a)}},i},t=new e;t.add(".modal_default_main","border: 10px solid #ccc;"),t.add(".modal_default_inner","padding: 10px;"),t.add(".modal_default_input","padding: 10px 0px;"),t.add(".modal_default_buttons","padding: 10px 0px;"),t.add(".modal_default_background","opacity: 0.3; background-color: #000;"),t.add(".modal_min_main","border: 1px solid #ccc;"),t.add(".modal_min_background","opacity: 0.3; background-color: #000;"),t.commit(),DayPilot.Modal=function(e){this.autoStretch=!0,this.autoStretchFirstLoadOnly=!1,this.className=null,this.theme="modal_default",this.disposeOnClose=!0,this.dragDrop=!0,this.loadingHtml=null,this.maxHeight=null,this.scrollWithPage=!0,this.useIframe=!0,this.zIndex=99999,this.left=null,this.width=500,this.top=20,this.height=200,this.closed=null,this.onClosed=null,this.onShow=null;var t=this;this.id="_"+(new Date).getTime()+"n"+10*Math.random(),this.Xd=!1,this.Yd=null,this.Zd=null,this.showHtml=function(e){if(DayPilot.ModalStatic.displayed(this))throw"This modal dialog is already displayed.";if(this.div||this.$d(),this.cd(),this.useIframe){var t=function(e,t){return function(){e.setInnerHTML(e.id+"iframe",t)}};window.setTimeout(t(this,e),0)}else e.nodeType?this.div.appendChild(e):this.div.innerHTML=e;this.cd(),this._d(),this.ae()},this.be=function(){return this.corners&&"rounded"===this.corners.toLowerCase()},this.showUrl=function(e){if(DayPilot.ModalStatic.displayed(this))throw"This modal dialog is already displayed.";if(this.useIframe){this.div||this.$d();var i=this.loadingHtml;i&&(this.iframe.src="about:blank",this.setInnerHTML(this.id+"iframe",i)),this.re(this.iframe,"load",this.ce),this.iframe.src=e,this.cd(),this._d(),this.ae()}else t.ee({"url":e,"success":function(e){var i=e.request.responseText;t.showHtml(i)},"error":function(e){t.showHtml("Error loading the modal dialog")}})},this.ae=function(){if("function"==typeof t.onShow){var e={};e.root=t.fe(),t.onShow(e)}},this.fe=function(){return t.iframe?t.iframe.contentWindow.document:t.div},this.ee=function(e){var t=new XMLHttpRequest;if(t){var i=e.method||"GET",n=e.success||function(){},a=e.error||function(){},o=e.data,r=e.url;
t.open(i,r,!0),t.setRequestHeader("Content-type","text/plain"),t.onreadystatechange=function(){if(4===t.readyState)if(200===t.status||304===t.status){var e={};e.request=t,n(e)}else if(a){var e={};e.request=t,a(e)}else window.console&&console.log("HTTP error "+t.status)},4!==t.readyState&&("object"==typeof o&&(o=JSON.stringify(o)),t.send(o))}},this.cd=function(){var e=window,i=document,n=e.pageYOffset?e.pageYOffset:i.documentElement&&i.documentElement.scrollTop?i.documentElement.scrollTop:i.body.scrollTop;this.theme&&(this.hideDiv.className=this.theme+"_background"),this.zIndex&&(this.hideDiv.style.zIndex=this.zIndex),this.hideDiv.style.display="",window.setTimeout(function(){t.hideDiv.onclick=function(){t.hide({"backgroundClick":!0})}},500),this.theme?this.div.className=this.theme+"_main":this.div.className="",this.className&&(this.div.className+=" "+this.className),this.left?this.div.style.left=this.left+"px":this.div.style.marginLeft="-"+Math.floor(this.width/2)+"px",this.div.style.position="absolute",this.div.style.boxSizing="content-box",this.div.style.top=n+this.top+"px",this.div.style.width=this.width+"px",this.zIndex&&(this.div.style.zIndex=this.zIndex),this.height&&(this.useIframe||!this.autoStretch?this.div.style.height=this.height+"px":this.div.style.height=""),this.useIframe&&this.height&&(this.iframe.style.height=this.height+"px"),this.div.style.display="",DayPilot.ModalStatic.list.push(this)},this.ce=function(){t.iframe.contentWindow.modal=t,t.autoStretch&&t.stretch()},this.stretch=function(){var e=function(){return t.ge().y},i=function(){return t.ge().x};if(this.useIframe){for(var n=i()-40,a=this.width;a<n&&this.je();a+=10)this.div.style.width=a+"px",this.div.style.marginLeft="-"+Math.floor(a/2)+"px";for(var o=this.maxHeight||e()-2*this.top,r=this.height;r<o&&this.ke();r+=10)this.iframe.style.height=r+"px",this.div.style.height=r+"px";this.autoStretchFirstLoadOnly&&this.ue(this.iframe,"load",this.ce)}else this.div.style.height=""},this.je=function(){for(var e=this.iframe.contentWindow.document,t="BackCompat"===e.compatMode?e.body:e.documentElement,i=t.scrollWidth,n=e.body.children,a=0;a<n.length;a++){var o=n[a].offsetLeft+n[a].offsetWidth;i=Math.max(i,o)}return i>t.clientWidth},this.ke=function(){for(var e=this.iframe.contentWindow.document,t="BackCompat"===e.compatMode?e.body:e.documentElement,i=t.scrollHeight,n=e.body.children,a=0;a<n.length;a++){var o=n[a].offsetTop+n[a].offsetHeight;i=Math.max(i,o)}return i>t.clientHeight},this.ge=function(){var e=document;if("CSS1Compat"===e.compatMode&&e.documentElement&&e.documentElement.clientWidth){var t=e.documentElement.clientWidth,i=e.documentElement.clientHeight;return{x:t,y:i}}var t=e.body.clientWidth,i=e.body.clientHeight;return{x:t,y:i}},this._d=function(){this.Xd||(this.re(window,"resize",this.le),this.re(window,"scroll",this.me),this.dragDrop&&(this.re(document,"mousemove",this.ne),this.re(document,"mouseup",this.oe)),this.Xd=!0)},this.pe=function(e){e.target===t.div&&(t.div.style.cursor="move",t.qe(),t.Zd=t.mc(e||window.event),t.Yd={x:t.div.offsetLeft,y:t.div.offsetTop})},this.ne=function(e){if(t.Zd){var e=e||window.event,i=t.mc(e),n=i.x-t.Zd.x,a=i.y-t.Zd.y;t.div.style.marginLeft="0px",t.div.style.top=t.Yd.y+a+"px",t.div.style.left=t.Yd.x+n+"px"}},this.oe=function(e){t.Zd&&(t.se(),t.div.style.cursor=null,t.Zd=null)},this.qe=function(){if(this.useIframe){var e=document.createElement("div");e.style.backgroundColor="#ffffff",e.style.filter="alpha(opacity=80)",e.style.opacity="0.80",e.style.width="100%",e.style.height=this.height+"px",e.style.position="absolute",e.style.left="0px",e.style.top="0px",this.div.appendChild(e),this.mask=e}},this.se=function(){this.useIframe&&(this.div.removeChild(this.mask),this.mask=null)},this.le=function(){t.te},this.me=function(){t.te},this.te=function(){if(t.hideDiv&&t.div&&"none"!==t.hideDiv.style.display&&"none"!==t.div.style.display){var e=window.pageYOffset?window.pageYOffset:document.documentElement&&document.documentElement.scrollTop?document.documentElement.scrollTop:document.body.scrollTop;t.scrollWithPage||(t.div.style.top=e+t.top+"px")}},this.re=function(e,t,i){e.addEventListener?e.addEventListener(t,i,!1):e.attachEvent&&e.attachEvent("on"+t,i)},this.ue=function(e,t,i){e.removeEventListener?e.removeEventListener(t,i,!1):e.detachEvent&&e.detachEvent("on"+t,i)},this.mc=function(e){return e.pageX||e.pageY?{x:e.pageX,y:e.pageY}:{x:e.clientX+document.documentElement.scrollLeft,y:e.clientY+document.documentElement.scrollTop}},this.abs=function(e){for(var t={x:e.offsetLeft,y:e.offsetTop};e.offsetParent;)e=e.offsetParent,t.x+=e.offsetLeft,t.y+=e.offsetTop;return t},this.$d=function(){var e=document.createElement("div");e.id=this.id+"hide",e.style.position="fixed",e.style.left="0px",e.style.top="0px",e.style.right="0px",e.style.bottom="0px",e.oncontextmenu=function(){return!1},e.onmousedown=function(){return!1},document.body.appendChild(e);var t=document.createElement("div");t.id=this.id+"popup",t.style.position="fixed",t.style.left="50%",t.style.top="0px",t.style.backgroundColor="white",t.style.width="50px",t.style.height="50px",this.dragDrop&&(t.onmousedown=this.pe);var i=null;this.useIframe&&(i=document.createElement("iframe"),i.id=this.id+"iframe",i.name=this.id+"iframe",i.frameBorder="0",i.style.width="100%",i.style.height="50px",t.appendChild(i)),document.body.appendChild(t),this.div=t,this.iframe=i,this.hideDiv=e},this.setInnerHTML=function(e,i){var n=window.frames[e],a=n.contentWindow||n.document||n.contentDocument;a.document&&(a=a.document),null==a.body&&a.write("<body></body>"),i.nodeType?a.body.appendChild(i):a.body.innerHTML=i,t.autoStretch&&(t.autoStretchFirstLoadOnly&&t.ve||(t.stretch(),t.ve=!0))},this.close=function(e){this.result=e,this.hide()},this.hide=function(e){e=e||{};var i={};i.backgroundClick=!!e.backgroundClick,i.result=this.result,i.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof this.onClose&&(this.onClose(i),i.preventDefault.value)||(this.div&&(this.div.style.display="none",this.hideDiv.style.display="none",this.useIframe||(this.div.innerHTML=null)),window.focus(),DayPilot.ModalStatic.remove(this),"function"==typeof this.onClosed?this.onClosed(i):this.closed&&this.closed(),this.result=null,this.disposeOnClose&&(t.we(t.div),t.we(t.hideDiv),t.div=null,t.hideDiv=null,t.iframe=null))},this.we=function(e){e&&e.parentNode&&e.parentNode.removeChild(e)},this.xe=function(){if(e)for(var t in e)this[t]=e[t]},this.xe()},DayPilot.Modal.alert=function(e,t){t=t||{},t.height=t.height||40,t.useIframe=!1;var i=t.okText||"OK";t.cancelText||"Cancel";return DayPilot.getPromise(function(n,a){t.onClosed=function(e){n(e)};var o=new DayPilot.Modal(t),r=document.createElement("div");r.className=o.theme+"_inner";var s=document.createElement("div");s.className=o.theme+"_content",s.innerHTML=e;var l=document.createElement("div");l.className=o.theme+"_buttons";var d=document.createElement("button");d.innerText=i,d.className=o.theme+"_ok",d.onclick=function(e){DayPilot.ModalStatic.close("OK")},l.appendChild(d),r.appendChild(s),r.appendChild(l),o.showHtml(r),d.focus()})},DayPilot.Modal.confirm=function(e,t){t=t||{},t.height=t.height||40,t.useIframe=!1;var i=t.okText||"OK",n=t.cancelText||"Cancel";return DayPilot.getPromise(function(a,o){t.onClosed=function(e){a(e)};var r=new DayPilot.Modal(t),s=document.createElement("div");s.className=r.theme+"_inner";var l=document.createElement("div");l.className=r.theme+"_content",l.innerHTML=e;var d=document.createElement("div");d.className=r.theme+"_buttons";var c=document.createElement("button");c.innerText=i,c.className=r.theme+"_ok",c.onclick=function(e){DayPilot.ModalStatic.close("OK")};var h=document.createTextNode(" "),u=document.createElement("button");u.innerText=n,u.className=r.theme+"_cancel",u.onclick=function(e){DayPilot.ModalStatic.close()},d.appendChild(c),d.appendChild(h),d.appendChild(u),s.appendChild(l),s.appendChild(d),r.showHtml(s),c.focus()})},DayPilot.Modal.prompt=function(e,t,i){"object"==typeof t&&(i=t),i=i||{},i.height=i.height||40,i.useIframe=!1;var n=i.okText||"OK",a=i.cancelText||"Cancel",o=t||"";return DayPilot.getPromise(function(t,r){i.onClosed=function(e){t(e)};var s=new DayPilot.Modal(i),l=document.createElement("div");l.className=s.theme+"_inner";var d=document.createElement("div");d.className=s.theme+"_content",d.innerHTML=e;var c=document.createElement("div");c.className=s.theme+"_input";var h=document.createElement("input");h.value=o,h.style.width="100%",h.onkeydown=function(e){switch(e.keyCode){case 13:parent.DayPilot.ModalStatic.close(this.value);break;case 27:parent.DayPilot.ModalStatic.close()}},c.appendChild(h);var u=document.createElement("div");u.className=s.theme+"_buttons";var f=document.createElement("button");f.innerText=n,f.className=s.theme+"_ok",f.onclick=function(e){DayPilot.ModalStatic.close(h.value)};var v=document.createTextNode(" "),p=document.createElement("button");p.innerText=a,p.className=s.theme+"_cancel",p.onclick=function(e){DayPilot.ModalStatic.close()},u.appendChild(f),u.appendChild(v),u.appendChild(p),l.appendChild(d),l.appendChild(c),l.appendChild(u),s.showHtml(l),h.focus()})},DayPilot.Modal.close=function(e){if(!(parent&&parent.DayPilot&&parent.DayPilot.ModalStatic))throw"Unable to close DayPilot.Modal dialog.";parent.DayPilot.ModalStatic.close(e)},DayPilot.Modal.closeSerialized=function(){for(var e=DayPilot.Modal.opener()||DayPilot.ModalStatic.last(),t=e.fe(),i=t.querySelectorAll("input, textarea, select"),n={},a=0;a<i.length;a++){var o=i[a],r=o.name;if(r){var s=o.value;n[r]=s}}DayPilot.Modal.close(n)},DayPilot.Modal.opener=function(){return parent&&parent.DayPilot&&parent.DayPilot.ModalStatic&&parent.DayPilot.ModalStatic.list[parent.DayPilot.ModalStatic.list.length-1]},"undefined"==typeof DayPilot.getPromise&&(DayPilot.getPromise=function(e){return"undefined"!=typeof Promise?new Promise(e):(DayPilot.Promise=function(e){var t=this;this.then=function(t,i){return t=t||function(){},i=i||function(){},e(t,i),DayPilot.getPromise(e)},this["catch"]=function(i){return t.then(null,i),DayPilot.getPromise(e)}},new DayPilot.Promise(e))})}(),"undefined"==typeof DayPilot)var DayPilot={};if("undefined"==typeof DayPilot.Global&&(DayPilot.Global={}),function(){var e=function(){};if("undefined"==typeof DayPilot.Month){var t={};DayPilot.Month=function(i,n){this.v="2911",this.nav={};var a=this;this.id=i,this.isMonth=!0,this.api=2,this.A=!1,this.hideUntilInit=!0,this.startDate=new DayPilot.Date,this.width=null,"function"==typeof DayPilot.Bubble?this.bubble=new DayPilot.Bubble:this.bubble=null,this.cssClassPrefix="month_default",this.cellHeight=100,this.cellMarginBottom=0,this.allowMultiSelect=!0,this.autoRefreshCommand="refresh",this.autoRefreshEnabled=!1,this.autoRefreshInterval=60,this.autoRefreshMaxCount=20,this.doubleClickTimeout=300,this.eventEndSpec="DateTime",this.eventFontColor="#000000",this.eventFontFamily="Tahoma",this.eventFontSize="11px",this.headerBackColor="#ECE9D8",this.headerFontColor="#000000",this.headerFontFamily="Tahoma",this.headerFontSize="10pt",this.headerHeight=36,this.heightSpec="Auto",this.weekStarts=0,this.innerBorderColor="#cccccc",this.borderColor="black",this.eventHeight=25,this.cellHeaderHeight=16,this.clientState={},this.afterRender=function(){},this.backColor="#FFFFD5",this.nonBusinessBackColor="#FFF4BC",this.cellHeaderBackColor="",this.cellHeaderFontColor="#000000",this.cellHeaderFontFamily="Tahoma",this.cellHeaderFontSize="10pt",this.cssOnly=!0,this.eventBackColor="White",this.eventBorderColor="Black",this.eventCorners="Regular",this.eventFontColor="#000000",this.eventFontFamily="Tahoma",this.eventFontSize="11px",this.cellWidth=14.285,this.lineSpace=1,this.locale="en-us",this.messageHideAfter=5e3,this.notifyCommit="Immediate",this.visible=!0,this.eventMoveToPosition=!1,this.eventTextLayer="Top",this.eventStartTime=!1,this.eventEndTime=!1,this.eventStartEndWidth=60,this.eventTextAlignment=null,this.eventTextLeftIndent=20,this.showWeekend=!0,this.cellMode=!1,this.shadowType="Fill",this.tapAndHoldTimeout=300,this.timeFormat="Auto",this.eventTimeFontColor="gray",this.eventTimeFontFamily="Tahoma",this.eventTimeFontSize="8pt",this.viewType="Month",this.weeks=1,this.eventClickHandling="Enabled",this.eventDeleteHandling="Disabled",this.eventDoubleClickHandling="Enabled",this.eventMoveHandling="Update",this.eventResizeHandling="Update",this.eventRightClickHandling="ContextMenu",this.eventSelectHandling="Update",this.headerClickHandling="Enabled",this.timeRangeSelectedHandling="Enabled",this.timeRangeDoubleClickHandling="Enabled",this.onEventFilter=null,this.backendUrl=null,this.cellEvents=[],this.elements={},this.elements.events=[],this.t={},this.t.events={},this.events={},this.B=0,this.members={},this.members.ignore=["internal","nav","debug","temp","elements","members","cellProperties"],this.K=function(e,t){var e=DayPilot.Util.parseJSON(e);if(e.BubbleGuid){var i=e.BubbleGuid,n=this.bubbles[i];return delete this.bubbles[i],a.X(),void("undefined"!=typeof e.Result.BubbleHTML&&n.updateView(e.Result.BubbleHTML,n))}if(e.CallBackRedirect)return void(document.location.href=e.CallBackRedirect);if("undefined"!=typeof e.ClientState&&(a.clientState=e.ClientState),"None"===e.UpdateType)return a.Y(e.CallBackData,!0),void(e.Message&&a.message(e.Message));if(e.VsUpdate){var o=document.createElement("input");o.type="hidden",o.name=a.id+"_vsupdate",o.id=o.name,o.value=e.VsUpdate,a.ye.innerHTML="",a.ye.appendChild(o)}a.events.list=e.Events,"undefined"!=typeof e.TagFields&&(a.tagFields=e.TagFields),"undefined"!=typeof e.SortDirections&&(a.sortDirections=e.SortDirections),"Full"===e.UpdateType&&(a.cellProperties=e.CellProperties,a.headerProperties=e.HeaderProperties,a.startDate=e.StartDate,"undefined"!=typeof e.ShowWeekend&&(a.showWeekend=e.ShowWeekend),a.headerBackColor=e.HeaderBackColor?e.HeaderBackColor:a.headerBackColor,a.backColor=e.BackColor?e.BackColor:a.backColor,a.nonBusinessBackColor=e.NonBusinessBackColor?e.NonBusinessBackColor:a.nonBusinessBackColor,a.locale=e.Locale?e.Locale:a.locale,a.timeFormat=e.TimeFormat?e.TimeFormat:a.timeFormat,"undefined"!=typeof e.WeekStarts&&(a.weekStarts=e.WeekStarts),a.hashes=e.Hashes),a.multiselect.clear(!0),a.multiselect.initList=e.SelectedEvents,a.M(),a.ze(),a.ba(),"Full"===e.UpdateType&&(a.Ae(),a.Be()),a.ja(),a.na(),a.oa(),a.Y(e.CallBackData,!0),a.ra(),e.Message&&a.message(e.Message)},this.Y=function(e,t){var i=function(e,t){return function(){if(a.sa()){if("function"==typeof a.onAfterRender){var i={};i.isCallBack=t,i.data=e,a.onAfterRender(i)}}else a.afterRender&&a.afterRender(e,t)}};window.setTimeout(i(e,t),0)},this.sa=function(){return 2===a.api},this.q=function(e){var t=this.theme||this.cssClassPrefix;return t?t+e:""},this.ba=function(){if(this.events.list){if("function"==typeof this.onBeforeEventRender)for(var e=this.events.list.length,t=0;t<e;t++)this.Sc(t);this.cellMode?this.Ce():this.De()}},this.X=function(){},this.De=function(){if(this.events.list){for(var e=0;e<this.events.list.length;e++){var t=this.events.list[e],i=null;if("function"==typeof a.onBeforeEventRender&&(i=a.t.events[e]),i){if(i.hidden)continue}else if(t.hidden)continue;var n=new DayPilot.Date(t.start),o=new DayPilot.Date(t.end);if(o=a.Ee(o),!(n.getTime()>o.getTime()))for(var r=0;r<this.rows.length;r++){var s=this.rows[r];if(s.belongsHere(n,o)){var l=new DayPilot.Event(t,a);if("function"==typeof a.onEventFilter&&a.events.Zc){var d={};if(d.filter=a.events.Zc,d.visible=!0,d.e=l,a.onEventFilter(d),!d.visible)break}s.events.push(l),"function"==typeof this.onBeforeEventRender&&(l.cache=this.t.events[e])}}}for(var c=0;c<this.rows.length;c++){var s=this.rows[c];s.events.sort(this._c);for(var h=0;h<this.rows[c].events.length;h++){var u=s.events[h],f=s.getStartColumn(u),v=s.getWidth(u);s.putIntoLine(u,f,v,c)}}}},this.Ce=function(){this.cellEvents=[];for(var e=0;e<this.Fe();e++){this.cellEvents[e]=[];for(var t=0;t<this.rows.length;t++){var i={},n=this.firstDate.addDays(7*t+e);i.start=n,i.end=n.addDays(1),i.events=[],this.cellEvents[e][t]=i}}for(var o=0;o<this.events.list.length;o++){var r=this.events.list[o],s=null;if("function"==typeof a.onBeforeEventRender&&(s=a.t.events[o]),s){if(s.hidden)continue}else if(r.hidden)continue;var l=new DayPilot.Date(r.start),d=new DayPilot.Date(r.start);if(d=a.Ee(d),!(l.getTime()>d.getTime()))for(var e=0;e<this.Fe();e++)for(var t=0;t<this.rows.length;t++){var i=this.cellEvents[e][t];if(l.getTime()>=i.start.getTime()&&l.getTime()<i.end.getTime()){var c=new DayPilot.Event(r,a);if("function"==typeof a.onEventFilter&&a.events.Zc){var h={};if(h.filter=a.events.Zc,h.visible=!0,h.e=c,a.onEventFilter(h),!h.visible)continue}i.events.push(c),"function"==typeof this.onBeforeEventRender&&(c.cache=this.t.events[o])}}}for(var e=0;e<this.Fe();e++)for(var t=0;t<this.rows.length;t++){var i=this.cellEvents[e][t];i.events.sort(this._c)}},this.M=function(){for(var e=0;e<this.elements.events.length;e++){var t=this.elements.events[e];t.event=null,t.click=null,t.parentNode.removeChild(t)}this.elements.events=[]},this.oa=function(){this.t.events={},this.cellMode?this.Ge():this.He(),this.multiselect.redraw()},this.Ge=function(){this.elements.events=[];for(var e=0;e<this.Fe();e++)for(var t=0;t<this.rows.length;t++)for(var i=this.cellEvents[e][t],n=(this.cells[e][t],0);n<i.events.length;n++){var a=i.events[n];a.part.colStart=e,a.part.colWidth=1,a.part.row=t,a.part.line=n,a.part.startsHere=!0,a.part.endsHere=!0,this.Ob(a)}},this.He=function(){this.elements.events=[];for(var e=0;e<this.rows.length;e++)for(var t=this.rows[e],i=0;i<t.lines.length;i++)for(var n=t.lines[i],a=0;a<n.length;a++)this.Ob(n[a])},this.$c=function(e,t){if(!(e&&t&&e.start&&t.start))return 0;var i=e.start().ticks-t.start().ticks;return 0!==i?i:t.end().ticks-e.end().ticks},this._c=function(e,t){if(!e||!t)return 0;if(!(e.data&&t.data&&e.data.sort&&t.data.sort&&0!==e.data.sort.length&&0!==t.data.sort.length))return a.$c(e,t);for(var i=0,n=0;0===i&&"undefined"!=typeof e.data.sort[n]&&"undefined"!=typeof t.data.sort[n];)i=e.data.sort[n]===t.data.sort[n]?0:"number"==typeof e.data.sort[n]&&"number"==typeof t.data.sort[n]?e.data.sort[n]-t.data.sort[n]:a.ad(e.data.sort[n],t.data.sort[n],a.sortDirections[n]),n++;return i},this.ad=function(e,t,i){var n="desc"!==i,a=n?-1:1,o=-a;if(null===e&&null===t)return 0;if(null===t)return o;if(null===e)return a;var r=[];return r[0]=e,r[1]=t,r.sort(),e===r[0]?a:o},this.Ie=function(e,i,n,a,o,r){o||(o=0);var s=a;this.shadow={},this.shadow.list=[],this.shadow.start={x:e,y:i},this.shadow.width=a,this.eventMoveToPosition&&(s=1,this.shadow.position=n);var l=7*i+e-o;l<0&&(s+=l,e=0,i=0);for(var d=o;d>=7;)i--,d-=7;if(d>e){d>e+(7-this.Fe())?(i--,e=e+7-d):(s=s-d+e,e=0)}else e-=d;i<0&&(i=0,e=0);var c=null;for(t.resizingEvent?c="w-resize":t.movingEvent&&(c="move"),this.nav.top.style.cursor=c;s>0&&i<this.rows.length;){var h=Math.min(this.Fe()-e,s),u=this.rows[i],f=this.Je(i),v=u.getHeight();this.eventMoveToPosition&&(f=this.Ke(i,n),v=2);var p=document.createElement("div");p.setAttribute("unselectable","on"),p.style.position="absolute",p.style.left=this.Le()*e+"%",p.style.width=this.Le()*h+"%",p.style.top=f+"px",p.style.height=v+"px",p.style.cursor=c;var g=document.createElement("div");g.setAttribute("unselectable","on"),p.appendChild(g),p.className=this.q("_shadow"),g.className=this.q("_shadow_inner");this.nav.events.appendChild(p),this.shadow.list.push(p),s-=h+7-this.Fe(),e=0,i++}},this.Me=function(){if(this.shadow){this.nav.events;DayPilot.de(this.shadow.list),this.shadow=null,this.nav.top.style.cursor=""}},this.Ke=function(e,t){for(var i=0,n=0;n<e;n++)i+=this.rows[n].getHeight();return i+=this.cellHeaderHeight,i+=t*s.lineHeight()},this.Ne=function(e,t){return this.firstDate.addDays(7*t+e)},this.Sc=function(e){var t=this.t.events,i=this.events.list[e],n={};for(var a in i)n[a]=i[a];if("function"==typeof this.onBeforeEventRender){var o={};o.e=n,o.data=n,this.onBeforeEventRender(o)}t[e]=n},this.Ob=function(e){var t=this.cellMode,i=e.part.row,n=e.part.line,r=e.part.colStart,l=e.part.colWidth,d=e.cache||e.data,c=t?0:this.Le()*r,h=t?100:this.Le()*l,u=t?n*s.lineHeight():this.Ke(i,n),f=document.createElement("div");f.setAttribute("unselectable","on"),f.style.height=s.eventHeight()+"px",f.style.position="relative",f.style.overflow="hidden",f.className=this.q("_event"),d.cssClass&&DayPilot.Util.addClass(f,d.cssClass),f.event=e,t?(f.style.marginRight="2px",f.style.marginBottom="2px"):(f.style.width=h+"%",f.style.position="absolute",f.style.left=c+"%",f.style.top=u+"px"),this.showToolTip&&d.toolTip&&!this.bubble&&(f.title=d.toolTip),f.onclick=this.Oe,f.ondblclick=this.Pe,f.oncontextmenu=this.Qe,f.onmousedown=this.Rb,f.onmousemove=this.Pb,f.onmouseout=this.Qb,f.ontouchstart=o.onEventTouchStart,f.ontouchmove=o.onEventTouchMove,f.ontouchend=o.onEventTouchEnd,e.part.startsHere||DayPilot.Util.addClass(f,this.q("_event_continueleft")),e.part.endsHere||DayPilot.Util.addClass(f,this.q("_event_continueright"));var v=document.createElement("div");v.setAttribute("unselectable","on"),v.className=this.q("_event_inner"),d.fontColor&&(v.style.color=d.fontColor),e.client.innerHTML()?v.innerHTML=e.client.innerHTML():v.innerHTML=e.text(),d.backColor&&(v.style.background=d.backColor,(DayPilot.browser.ie9||DayPilot.browser.ielt9)&&(v.style.filter="")),f.appendChild(v);var p=this.sc.locale(),g=a.eventStartEndWidth;if(this.eventStartTime){var m="Clock12Hours"===a.sc.timeFormat()?e.start().toString("h tt",p):e.start().toString("H",p),y={"left":5,"top":3,"width":g,"bottom":2,"v":"Visible","html":m,"css":a.q("_event_timeleft")},b=DayPilot.Areas.createArea(f,e,y);f.appendChild(b),v.style.paddingLeft=g+"px"}if(this.eventEndTime){var m="Clock12Hours"===a.sc.timeFormat()?e.end().toString("h tt",p):e.end().toString("H",p),y={"right":5,"top":3,"width":g,"bottom":2,"v":"Visible","html":m,"css":a.q("_event_timeright")},b=DayPilot.Areas.createArea(f,e,y);f.appendChild(b),v.style.paddingRight=g+"px"}if(d.areas)for(var w=d.areas,D=0;D<w.length;D++){var y=w[D];if("Visible"===y.v){var b=DayPilot.Areas.createArea(f,e,y);f.appendChild(b)}}this.elements.events.push(f),t?this.cells[r][i].body.appendChild(f):this.nav.events.appendChild(f),a.multiselect.xb(f.event)&&a.multiselect.add(f.event,!0);var k=f;if(a.sa()){if("function"==typeof a.onAfterEventRender){var C={};C.e=k.event,C.div=k,a.onAfterEventRender(C)}}else a.afterEventRender&&a.afterEventRender(k.event,k)},this.Oe=function(e){o.start||a.Ga(this,e)},this.Pe=function(e){a.Ka(this,e)},this.Pb=function(e){var i=this,n=i.event;if("undefined"!=typeof t&&!t.movingEvent&&!t.resizingEvent){var o=DayPilot.mo3(i,e);if(o){!function(){var e=i;if(!e.active){var t=[],o=n.cache||n.data;"Disabled"===a.eventDeleteHandling||o.deleteDisabled||t.push({"action":"JavaScript","v":"Hover","w":17,"h":17,"top":2,"right":2,"css":a.q("_event_delete"),"js":function(e){a.Pa(e)}});var r=e.event.cache?e.event.cache.areas:e.event.data.areas;r&&r.length>0&&(t=t.concat(r)),DayPilot.Areas.showAreas(e,e.event,null,t)}}(),a.Re(i.event).each(function(e){DayPilot.Util.addClass(e,a.q("_event_hover"))});var r=6;if(!a.cellMode&&o.x<=r&&n.client.resizeEnabled()?n.part.startsHere?(i.style.cursor="w-resize",i.dpBorder="left"):i.style.cursor="not-allowed":!a.cellMode&&i.clientWidth-o.x<=r&&n.client.resizeEnabled()?n.part.endsHere?(i.style.cursor="e-resize",i.dpBorder="right"):i.style.cursor="not-allowed":i.style.cursor="default","undefined"!=typeof DayPilot.Bubble&&a.bubble&&"Disabled"!==a.eventHoverHandling)if(t.movingEvent||t.resizingEvent)DayPilot.Bubble.hideActive();else{var s=this.Tc&&o.x===this.Tc.x&&o.y===this.Tc.y;s||(this.Tc=o,a.bubble.showEvent(i.event))}}}},this.Qb=function(e){var t=this;"undefined"!=typeof DayPilot.Bubble&&a.bubble&&a.bubble.hideOnMouseOut(),t.style.cursor="",a.Re(t.event).each(function(e){DayPilot.Util.removeClass(e,a.q("_event_hover"))}),DayPilot.Areas.hideAreas(t,e)},this.Qe=function(){var e=this;return a.La(e.event),!1},this.Rb=function(e){if(!o.start){var i=this,n=i.event,r=n.part.row,s=n.part.colStart,l=n.part.line,d=n.part.colWidth;e=e||window.event;var c=DayPilot.Util.mouseButton(e);if(e.cancelBubble=!0,e.stopPropagation&&e.stopPropagation(),c.left)if("undefined"!=typeof DayPilot.Bubble&&a.bubble&&DayPilot.Bubble.hideActive(),t.movingEvent=null,"w-resize"===this.style.cursor||"e-resize"===this.style.cursor){var h={};h.start={},h.start.x=s,h.start.y=r,h.event=i.event,h.width=DayPilot.DateUtil.daysSpan(h.event.start(),h.event.end())+1,h.direction=this.style.cursor,t.resizingEvent=h}else if("move"===this.style.cursor||n.client.moveEnabled()){a.Me();var u=DayPilot.mo3(a.nav.events,e);if(!u)return;var f=a.Se(u.x,u.y);if(!f)return;var v=DayPilot.DateUtil.daysDiff(n.start(),a.rows[r].start),p=7*f.y+f.x-(7*r+s);v&&(p+=v);var g={};g.start={},g.start.x=s,g.start.y=r,g.start.line=l,g.offset=a.eventMoveToPosition?0:p,g.colWidth=d,g.event=i.event,g.coords=u,t.movingEvent=g}}},this.temp={},this.temp.getPosition=function(){if(!a.coords)return null;var e=a.Se(a.coords.x,a.coords.y);if(!e)return null;var t=new DayPilot.Date(a.Ne(e.x,e.y)),e={};return e.start=t,e.end=t.addDays(1),e},this.Sb={};var o=a.Sb;o.active=!1,o.start=!1,o.timeouts=[],o.onEventTouchStart=function(e){if(!o.active&&!o.start){o.clearTimeouts(),o.start=!0,o.active=!1;var t=this;if(t.event.client.moveEnabled()){var i=a.tapAndHoldTimeout;o.timeouts.push(window.setTimeout(function(){o.active=!0,o.start=!1;var i=o.relativeCoords(e);o.startMoving(t,i),e.preventDefault()},i))}e.stopPropagation()}},o.onEventTouchMove=function(e){o.clearTimeouts(),o.start=!1},o.onEventTouchEnd=function(e){o.clearTimeouts(),o.start&&a.Ha(this,e),window.setTimeout(function(){o.start=!1,o.active=!1},500)},o.onMainTouchStart=function(e){if(!o.active&&!o.start){o.clearTimeouts(),o.start=!0,o.active=!1;var t=a.tapAndHoldTimeout;o.timeouts.push(window.setTimeout(function(){o.active=!0,o.start=!1,e.preventDefault();var t=o.relativeCoords(e);o.startRange(t)},t))}},o.onMainTouchMove=function(e){if(o.clearTimeouts(),o.start=!1,o.active){e.preventDefault();var t=o.relativeCoords(e);if(o.moving)return void o.updateMoving(t);o.range&&o.updateRange(t)}},o.onMainTouchEnd=function(e){if(o.clearTimeouts(),o.active){if(o.moving){var t=(o.moving,o.moving.event),i=a.shadow.start,n=a.shadow.position,r=o.moving.offset;a.Me(),o.moving=null,a.Ua(t,i.x,i.y,r,e,n)}if(o.range){var s=o.range,i=new DayPilot.Date(a.Ne(s.from.x,s.from.y)),l=i.addDays(s.width);o.range=null,a._a(i,l)}}window.setTimeout(function(){o.start=!1,o.active=!1},500)},o.clearTimeouts=function(){for(var e=0;e<o.timeouts.length;e++)clearTimeout(o.timeouts[e]);o.timeouts=[]},o.relativeCoords=function(e){var t=a.nav.events,i=e.touches[0].pageX,n=e.touches[0].pageY,o=DayPilot.abs(t);return{x:i-o.x,y:n-o.y,toString:function(){return"x: "+this.x+", y:"+this.y}}},o.startMoving=function(e,t){a.Me();var i=e.event,n=a.Se(t.x,t.y);if(n){var r=DayPilot.DateUtil.daysDiff(i.start(),a.rows[i.part.row].start),s=7*n.y+n.x-(7*i.part.row+i.part.colStart);r&&(s+=r);var l={};l.start={},l.start.x=i.part.colStart,l.start.y=i.part.row,l.start.line=i.part.line,l.offset=a.eventMoveToPosition?0:s,l.colWidth=i.part.colWidth,l.event=i,l.coords=t,o.moving=l,o.updateMoving(t)}},o.updateMoving=function(e){var t=a.Se(e.x,e.y);if(t){var i=a.Te(t);a.Me();var n=o.moving.event,r=o.moving.offset,s=a.cellMode?1:DayPilot.DateUtil.daysSpan(n.start(),n.end())+1;s<1&&(s=1),a.Ie(t.x,t.y,i,s,r,n)}},o.startRange=function(e){var t=a.Se(e.x,e.y);if(t){a.Me();var i={};i.start={},i.start.x=t.x,i.start.y=t.y,i.x=t.x,i.y=t.y,i.width=1,o.range=i,o.updateRange(e)}},o.updateRange=function(e){var t=a.Se(e.x,e.y);if(t){a.Me();var i=o.range.start,n=7*i.y+i.x,r=7*t.y+t.x,s=Math.abs(r-n)+1;s<1&&(s=1);var l=n<r?i:t;o.range.width=s,o.range.from={x:l.x,y:l.y},a.Ie(l.x,l.y,0,s,0,null)}},this.isWeekend=function(e){return 0===e.dayOfWeek()||6===e.dayOfWeek()},this.Ue=function(){var e=this.startDate.lastDayOfMonth();if(this.showWeekend)return e;for(;this.isWeekend(e);)e=e.addDays(-1);return e},this.ze=function(){if("string"==typeof this.startDate&&(this.startDate=new DayPilot.Date(this.startDate)),"Month"===this.viewType?this.startDate=this.startDate.firstDayOfMonth():this.startDate=this.startDate.getDatePart(),this.firstDate=this.startDate.firstDayOfWeek(s.weekStarts()),!this.showWeekend){for(var e=this.startDate.addMonths(-1).getMonth(),t=new DayPilot.Date(this.firstDate).addDays(6);this.isWeekend(t);)t=t.addDays(-1);t.getMonth()===e&&(this.firstDate=this.firstDate.addDays(7))}var i;this.startDate;if("Month"===this.viewType){var n=this.Ue(),o=DayPilot.DateUtil.daysDiff(this.firstDate,n)+1;i=Math.ceil(o/7)}else i=this.weeks;this.days=7*i,this.rows=[];for(var r=0;r<i;r++){var l={};l.start=this.firstDate.addDays(7*r),l.end=l.start.addDays(this.Fe()),l.events=[],l.lines=[],l.index=r,l.minHeight=this.cellHeight,l.calendar=this,l.belongsHere=function(e,t){return t.getTime()===e.getTime()&&e.getTime()===this.start.getTime()||!(t.getTime()<=this.start.getTime()||e.getTime()>=this.end.getTime())},l.getPartStart=function(e){return DayPilot.DateUtil.max(this.start,e.start())},l.getPartEnd=function(e){return DayPilot.DateUtil.min(this.end,e.rawend())},l.getStartColumn=function(e){var t=this.getPartStart(e);return DayPilot.DateUtil.daysDiff(this.start,t)},l.getWidth=function(e){return DayPilot.DateUtil.daysSpan(this.getPartStart(e),this.getPartEnd(e))+1},l.putIntoLine=function(e,t,i,n){for(var a=this,o=0;o<this.lines.length;o++){var r=this.lines[o];if(r.isFree(t,i))return r.addEvent(e,t,i,n,o),o}var r=[];return r.isFree=function(e,t){for(var i=!0,n=0;n<this.length;n++){var a=this[n];e+t-1<a.part.colStart||e>a.part.colStart+a.part.colWidth-1||(i=!1)}return i},r.addEvent=function(e,t,i,n,o){e.part.colStart=t,e.part.colWidth=i,e.part.row=n,e.part.line=o,e.part.startsHere=a.start.getTime()<=e.start().getTime(),e.part.endsHere=a.end.getTime()>=e.end().getTime(),this.push(e)},r.addEvent(e,t,i,n,this.lines.length),this.lines.push(r),this.lines.length-1},l.getStart=function(){for(var e=0,t=0;t<a.rows.length&&t<this.index;t++)e+=a.rows[t].getHeight()},l.getHeight=function(){return Math.max(this.lines.length*s.lineHeight()+a.cellHeaderHeight+a.cellMarginBottom,this.calendar.cellHeight)},this.rows.push(l)}this.Ve=this.firstDate.addDays(7*i)},this.We=function(){switch(this.heightSpec){case"Auto":for(var e=s.headerHeight(),t=0;t<this.rows.length;t++)e+=this.rows[t].getHeight();return e;case"Fixed":return this.height}},this.Xe=function(e,t){return 7*t.y+t.x-(7*e.y+e.x)+1},this.Lc={},this.Lc.scope=null,this.Lc.notify=function(){a.Lc.scope&&a.Lc.scope["$apply"]()},this.debug=new DayPilot.Debug(this),this.Xb=function(){var e=this.nav.top;this.nav.top.dp=this,e.setAttribute("unselectable","on"),e.style.MozUserSelect="none",e.style.KhtmlUserSelect="none",e.style.WebkitUserSelect="none",e.style.WebkitTapHighlightColor="rgba(0,0,0,0)",e.style.WebkitTouchCallout="none",e.style.position="relative",this.width&&(e.style.width=this.width),e.onselectstart=function(e){return!1},e.className=this.q("_main"),this.hideUntilInit&&(e.style.visibility="hidden"),this.visible||(e.style.display="none"),e.onmousemove=this.cc,e.ontouchstart=o.onMainTouchStart,e.ontouchmove=o.onMainTouchMove,e.ontouchend=o.onMainTouchEnd,this.ye=document.createElement("div"),this.ye.style.display="none",this.nav.top.appendChild(this.ye);var t=document.createElement("div");t.style.position="relative",t.style.height=s.headerHeight()+"px",t.oncontextmenu=function(){return!1},this.nav.top.appendChild(t),this.nav.header=t;var i=document.createElement("div");i.style.zoom="1";var n=document.createElement("div");n.style.position="relative",i.appendChild(n),this.nav.top.appendChild(i),this.nav.scrollable=i,this.nav.events=n},this.cc=function(e){a.coords=DayPilot.mo3(a.nav.events,e);var i=a.coords;if(i){var n=a.Se(i.x,i.y);if(n)if(t.resizingEvent){a.Me();var o,r,s=t.resizingEvent;s.start;if("w-resize"===s.direction){r=n;var l=s.event.rawend();l.getDatePart().getTime()===l.getTime()&&(l=l.addDays(-1));
var d=a.Ye(l);o=a.Xe(n,d)}else r=a.Ye(s.event.start()),o=a.Xe(r,n);o<1&&(o=1),a.Ie(r.x,r.y,0,o)}else if(t.movingEvent){if(a.debug.message("mousemove/moving start coords: "+t.movingEvent.coords.x+" "+t.movingEvent.coords.y),a.debug.message("mousemove/current coords: "+i.x+" "+i.y),i.x===t.movingEvent.coords.x&&i.y===t.movingEvent.coords.y)return;var c=a.Te(n);a.Me();var h=t.movingEvent.event,u=t.movingEvent.offset,o=a.cellMode?1:DayPilot.DateUtil.daysSpan(h.start(),h.rawend())+1;o<1&&(o=1),a.Ie(n.x,n.y,c,o,u,h)}else if(t.timeRangeSelecting){t.cancelCellClick=!0,a.Me();var r=t.timeRangeSelecting,f=7*r.y+r.x,v=7*n.y+n.x,o=Math.abs(v-f)+1;o<1&&(o=1);var p=f<v?r:n;t.timeRangeSelecting.from={x:p.x,y:p.y},t.timeRangeSelecting.width=o,t.timeRangeSelecting.moved=!0,a.Ie(p.x,p.y,0,o,0,null)}}},this.Te=function(e){for(var t=e.relativeY,i=a.rows[e.y],n=a.cellHeaderHeight,o=s.lineHeight(),r=i.lines.length,l=0;l<i.lines.length;l++){if(i.lines[l].isFree(e.x,1)){r=l;break}}var d=Math.floor((t-n+o/2)/o),d=Math.min(r,d),d=Math.max(0,d);return d},this.message=function(e,t,i,n){if(null!==e){var o,t=t||this.messageHideAfter||2e3,r=.8,l=s.headerHeight();if(this.nav.message)o=a.nav.message;else{o=document.createElement("div"),o.setAttribute("unselectable","on"),o.style.position="absolute",o.style.right="0px",o.style.left="0px",o.style.top=l+"px",o.style.opacity=r,o.style.filter="alpha(opacity=80)",o.style.display="none",o.onmousemove=function(){o.messageTimeout&&!o.status&&clearTimeout(o.messageTimeout)},o.onmouseout=function(){"none"!==a.nav.message.style.display&&(o.messageTimeout=setTimeout(a.Ea,500))};var d=document.createElement("div");d.setAttribute("unselectable","on"),d.onclick=function(){a.nav.message.style.display="none"},d.className=this.q("_message"),o.appendChild(d);var c=document.createElement("div");c.setAttribute("unselectable","on"),c.style.position="absolute",c.className=this.q("_message_close"),c.onclick=function(){a.nav.message.style.display="none"},o.appendChild(c),this.nav.top.appendChild(o),this.nav.message=o}var h=function(){a.nav.message.style.opacity=r,a.nav.message.firstChild.innerHTML=e;var i=function(){o.messageTimeout=setTimeout(a.Ea,t)};DayPilot.fade(a.nav.message,.2,i)};clearTimeout(o.messageTimeout),"none"!==this.nav.message.style.display?DayPilot.fade(a.nav.message,-.2,h):h()}},this.message.show=function(e){a.message(e)},this.message.hide=function(){a.Ea()},this.Ea=function(){var e=function(){a.nav.message.style.display="none"};DayPilot.fade(a.nav.message,-.2,e)},this.P=function(e){"Parent100Pct"===a.heightSpec&&a.ja()},this.ja=function(){var e=this.nav.scrollable;if("Parent100Pct"===this.heightSpec||"Fixed"===this.heightSpec?(e.style.top=this.headerHeight+"px",e.style.bottom="0px",e.style.left="0px",e.style.right="0px",e.style.overflow="auto",e.style.position="absolute"):e.style.position="relative","Parent100Pct"===this.heightSpec){this.nav.top.style.height="100%";this.nav.top.clientHeight}else this.nav.top.style.height=this.We()+"px";for(var t=0;t<this.cells.length;t++)for(var i=0;i<this.cells[t].length;i++)this.cells[t][i].style.top=this.Je(i)+"px",this.cells[t][i].style.height=this.rows[i].getHeight()+"px";this.Ze()},this.Se=function(e,t){for(var i=Math.floor(this.nav.top.clientWidth/this.Fe()),n=Math.min(Math.floor(e/i),this.Fe()-1),a=null,o=0,r=0,s=0,l=0;l<this.rows.length;l++){if(r+=this.rows[l].getHeight(),t<r){o=t-s,a=l;break}s=r}null===a&&(a=this.rows.length-1);var d={};return d.x=n,d.y=a,d.relativeY=o,d},this.Ye=function(e){for(var t=DayPilot.DateUtil.daysDiff(this.firstDate,e),i={x:0,y:0};t>=7;)i.y++,t-=7;return i.x=t,i},this.Ze=function(){var e=DayPilot.sw(this.nav.scrollable);this.nav.header.style.marginRight=e+"px"};var r=null;this.Be=function(){var e=this.nav.header,t=this.nav.events;this.cells=[];for(var i=0;i<this.Fe();i++){this.cells[i]=[];var n=this.headerProperties?this.headerProperties[i]:null,o=i+s.weekStarts();if(o>6&&(o-=7),!n){var n={};n.html=s.locale().dayNames[o]}if("function"==typeof a.onBeforeHeaderRender){var l={};l.header={},l.header.dayOfWeek=o;var d=["html","backColor","cssClass"];DayPilot.Util.copyProps(n,l.header,d),a.onBeforeHeaderRender(l),DayPilot.Util.copyProps(l.header,n,d)}var c=document.createElement("div");c.setAttribute("unselectable","on"),c.style.position="absolute",c.style.left=this.Le()*i+"%",c.style.width=this.Le()+"%",c.style.top="0px",c.style.height=s.headerHeight()+"px",function(e){c.onclick=function(){a.Ma(e)}}(o);var h=document.createElement("div");h.setAttribute("unselectable","on"),h.className=this.q("_header_inner"),h.innerHTML=n.html,c.appendChild(h),c.className=this.q("_header"),n&&(n.cssClass&&DayPilot.Util.addClass(c,n.cssClass),n.backColor&&(h.style.background=n.backColor)),e.appendChild(c);for(var u=0;u<this.rows.length;u++)this.$e(i,u,t)}if(!DayPilot.contains(this.nav.top.childNodes,r)&&DayPilot.Util.isNullOrUndefined(undefined)){var f=document.createElement("div");f.style.position="absolute",f.style.padding="2px",f.style.top="0px",f.style.left="0px",f.style.backgroundColor="#FF6600",f.style.color="white",f.innerHTML="\u0044\u0045\u004D\u004F",r=f,this.nav.top.appendChild(f)}},this.Ae=function(){for(var e=0;e<this.cells.length;e++)for(var t=0;t<this.cells[e].length;t++)this.cells[e][t].onclick=null;this.nav.header.innerHTML="",this.nav.events.innerHTML=""},this.$e=function(t,i,n){var o=this.rows[i],r=this.firstDate.addDays(7*i+t),l=this.cellProperties?this.cellProperties[i*this.Fe()+t]:null,d=null;if(l)d=l["headerHtml"];else{var c=r.getDay();d=1===c?s.locale().monthNames[r.getMonth()]+" "+c:c+""}if(!l){var l={};l.business=!a.isWeekend(r),l.headerHtml=d}if("function"==typeof a.onBeforeCellRender){var h={};h.cell={},h.cell.areas=null,h.cell.backColor=null,h.cell.backImage=null,h.cell.backRepeat=null,h.cell.business=a.isWeekend(r),h.cell.headerHtml=d,h.cell.headerBackColor=null,h.cell.cssClass=null,h.cell.html=null,h.cell.start=r,h.cell.end=h.cell.start.addDays(1),DayPilot.Util.copyProps(l,h.cell),a.onBeforeCellRender(h),DayPilot.Util.copyProps(h.cell,l,["areas","backColor","backImage","backRepeat","business","headerHtml","headerBackColor","cssClass","html"])}var u=document.createElement("div");u.setAttribute("unselectable","on"),u.style.position="absolute",u.style.cursor="default",u.style.left=this.Le()*t+"%",u.style.width=this.Le()+"%",u.style.top=this.Je(i)+"px",u.style.height=o.getHeight()+"px",u.d=r,u.x=t,u.y=i,u.props=l;var f=this.startDate.addMonths(-1).getMonth(),v=this.startDate.addMonths(1).getMonth(),p=this.startDate.getMonth(),g=document.createElement("div");g.setAttribute("unselectable","on"),u.appendChild(g),g.className=this.q("_cell_inner"),g.className=this.q("_cell_inner"),r.getMonth()===p?u.className=this.q("_cell"):r.getMonth()===f?u.className=this.q("_cell")+" "+this.q("_previous"):r.getMonth()===v?u.className=this.q("_cell")+" "+this.q("_next"):e(),l&&(l["cssClass"]&&DayPilot.Util.addClass(u,l.cssClass),l["business"]&&DayPilot.Util.addClass(u,this.q("_cell_business")),l["backColor"]&&(g.style.backgroundColor=l["backColor"]),l["backImage"]&&(g.style.backgroundImage="url('"+l["backImage"]+"')"),l["backRepeat"]&&(g.style.backgroundRepeat=l["backRepeat"])),u.onmousedown=this.hb,u.onmousemove=this.kb,u.onmouseout=this.jb,u.oncontextmenu=this._e,u.onclick=this.af,u.ondblclick=this.bf;var m=document.createElement("div");if(m.setAttribute("unselectable","on"),m.style.height=this.cellHeaderHeight+"px",l&&l["headerBackColor"]&&(m.style.background=l["headerBackColor"]),m.className=this.q("_cell_header"),m.innerHTML=l.headerHtml,g.appendChild(m),l&&l["html"]){var y=document.createElement("div");y.setAttribute("unselectable","on"),y.style.height=o.getHeight()-this.cellHeaderHeight+"px",y.style.overflow="hidden",y.innerHTML=l["html"],g.appendChild(y)}if(this.cellMode){var b=document.createElement("div");b.setAttribute("unselectable","on"),b.style.height=this.cellHeight-this.cellHeaderHeight+"px",b.style.overflow="auto",b.style.position="relative";var w=document.createElement("div");w.setAttribute("unselectable","on"),w.style.paddingTop="1px",w.style.paddingBottom="1px",b.appendChild(w),g.appendChild(b),u.body=w,u.scrolling=b}if(u.props)for(var D=u.props.areas||[],k=0;k<D.length;k++){var C=D[k],x=C.v||"Visible";if("Visible"===x){var P=DayPilot.Areas.createArea(u,u.props,C);u.appendChild(P)}}this.cells[t][i]=u,n.appendChild(u),"function"==typeof a.onAfterCellRender&&(h.cell.div=u,h.cell.divHeader=m,a.onAfterCellRender(h))},this.kb=function(){var e=this;e.props&&DayPilot.Areas.showAreas(e,e.props)},this.jb=function(e){var t=this;t.props&&DayPilot.Areas.hideAreas(t,e)},this._e=function(){var e=this.d;return function(e){var t=new DayPilot.Date(e),i=t.addDays(1),n=new DayPilot.Selection(t,i,null,a);a.contextMenuSelection&&a.contextMenuSelection.show(n)}(e),!1},this.bf=function(){var e=this.d;if(a.timeouts){for(var t in a.timeouts)window.clearTimeout(a.timeouts[t]);a.timeouts=null}if("Disabled"!==a.timeRangeDoubleClickHandling){var i=new DayPilot.Date(e),n=i.addDays(1);a.ab(i,n)}},this.af=function(){if(!t.cancelCellClick){var e=this.d,i=function(e){var t=new DayPilot.Date(e),i=t.addDays(1);a._a(t,i)};if("Disabled"!==a.timeRangeSelectedHandling&&"Disabled"===a.timeRangeDoubleClickHandling)return void i(e);a.timeouts||(a.timeouts=[]);var n=function(e){return function(){i(e)}};a.timeouts.push(window.setTimeout(n(e),a.doubleClickTimeout))}},this.hb=function(e){var i=this,n=i.x,o=i.y;if(t.cancelCellClick=!1,i.scrolling){var r=DayPilot.mo3(i.scrolling,e),s=DayPilot.sw(i.scrolling),l=i.scrolling.offsetWidth;if(r.x>l-s)return}"Disabled"!==a.timeRangeSelectedHandling&&(a.Me(),t.timeRangeSelecting={"root":a,"x":n,"y":o,"from":{x:n,y:o},"width":1})},this.Fe=function(){return this.showWeekend?7:5},this.Le=function(){return this.showWeekend?14.285:20},this.cf=function(e){return 6===e.getUTCDay()||0===e.getUTCDay()?this.nonBusinessBackColor:this.backColor},this.Je=function(e){for(var t=0,i=0;i<e;i++)t+=this.rows[i].getHeight();return t},this.clearSelection=function(){this.Me()},this.E=function(e,t,i){var n={};n.action=e,n.parameters=i,n.data=t,n.header=this.F();var o="JSON"+DayPilot.JSON.stringify(n);__doPostBack(a.uniqueID,o)},this.G=function(e,t,i,n){if(!this.r())return void a.debug.message("Callback invoked without the server-side backend specified. Callback canceled.","warning");"undefined"==typeof n&&(n="CallBack");var o={};o.action=e,o.type=n,o.parameters=t,o.data=i,o.header=this.F();var r="JSON"+DayPilot.JSON.stringify(o);this.backendUrl?DayPilot.request(this.backendUrl,this.I,r,this.J):"function"==typeof WebForm_DoCallback&&WebForm_DoCallback(this.uniqueID,r,this.K,null,this.callbackError,!0)},this.r=function(){return!!this.backendUrl||!("function"!=typeof WebForm_DoCallback||!this.uniqueID)},this.J=function(e){if("function"==typeof a.onAjaxError){var t={};t.request=e,a.onAjaxError(t)}else"function"==typeof a.ajaxError&&a.ajaxError(e)},this.I=function(e){a.K(e.responseText)},this.F=function(){var e={};return e.v=this.v,e.control="dpm",e.id=this.id,e.visibleStart=new DayPilot.Date(this.firstDate),e.visibleEnd=e.visibleStart.addDays(this.days),e.clientState=this.clientState,e.cssClassPrefix=a.cssClassPrefix,e.startDate=a.startDate,e.showWeekend=this.showWeekend,e.headerBackColor=this.headerBackColor,e.backColor=this.backColor,e.nonBusinessBackColor=this.nonBusinessBackColor,e.locale=this.locale,e.timeFormat=this.timeFormat,e.weekStarts=this.weekStarts,e.viewType=this.viewType,e.weeks=this.weeks,e.selected=a.multiselect.events(),e.hashes=a.hashes,e},this.visibleStart=function(){return new DayPilot.Date(this.firstDate)},this.visibleEnd=function(){return a.visibleStart().addDays(a.days)},this.Qa=function(e,t,i,n){if("PostBack"===e)a.postBack2(t,i,n);else if("CallBack"===e)a.G(t,i,n,"CallBack");else if("Immediate"===e)a.G(t,i,n,"Notify");else if("Queue"===e)a.queue.add(new DayPilot.Action(this,t,i,n));else{if("Notify"!==e)throw"Invalid event invocation type";"Notify"===s.notifyType()?a.G(t,i,n,"Notify"):a.queue.add(new DayPilot.Action(a,t,i,n))}},this.Xa=function(e,t){var i=a.Ya(t),n={};n.args=e,n.guid=i,a.G("Bubble",n)},this.Ya=function(e){var t=DayPilot.guid();return this.bubbles||(this.bubbles=[]),this.bubbles[t]=e,t},this.eventClickPostBack=function(e,t){this.E("EventClick",t,e)},this.eventClickCallBack=function(e,t){this.G("EventClick",e,t)},this.Ga=function(e,i){t.movingEvent=null,t.resizingEvent=null;var i=i||window.event;i.ctrlKey,i.metaKey;if(i.cancelBubble=!0,i.stopPropagation&&i.stopPropagation(),"undefined"!=typeof DayPilot.Bubble&&DayPilot.Bubble.hideActive(),"Disabled"===a.eventDoubleClickHandling)return void a.Ha(e,i);if(a.timeouts){for(var n in a.timeouts)window.clearTimeout(a.timeouts[n]);a.timeouts=[]}else a.timeouts=[];var o=function(e,t){return function(){a.Ha(e,t)}};a.timeouts.push(window.setTimeout(o(e,i),a.doubleClickTimeout))},this.Ha=function(e,t){var i=e.event;if(i.client.clickEnabled()){var n=t.ctrlKey,o=t.metaKey;if(a.sa()){var r={};if(r.e=i,r.div=e,r.originalEvent=t,r.meta=t.metaKey,r.ctrl=t.ctrlKey,r.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onEventClick&&(a.onEventClick(r),r.preventDefault.value))return;switch(a.eventClickHandling){case"PostBack":a.eventClickPostBack(i);break;case"CallBack":a.eventClickCallBack(i);break;case"Select":a.Ja(e,i,n,o);break;case"ContextMenu":var s=i.client.contextMenu();s?s.show(i):a.contextMenu&&a.contextMenu.show(i);break;case"Bubble":a.bubble&&a.bubble.showEvent(i)}"function"==typeof a.onEventClicked&&a.onEventClicked(r)}else switch(a.eventClickHandling){case"PostBack":a.eventClickPostBack(i);break;case"CallBack":a.eventClickCallBack(i);break;case"JavaScript":a.onEventClick(i);break;case"Select":a.Ja(e,i,n,o);break;case"ContextMenu":var s=i.client.contextMenu();s?s.show(i):a.contextMenu&&a.contextMenu.show(i);break;case"Bubble":a.bubble&&a.bubble.showEvent(i)}}},this.Pa=function(e){if(a.sa()){var t={};if(t.e=e,t.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onEventDelete&&(a.onEventDelete(t),t.preventDefault.value))return;switch(a.eventDeleteHandling){case"PostBack":a.eventDeletePostBack(e);break;case"CallBack":a.eventDeleteCallBack(e);break;case"Update":a.events.remove(e)}"function"==typeof a.onEventDeleted&&a.onEventDeleted(t)}else switch(a.eventDeleteHandling){case"PostBack":a.eventDeletePostBack(e);break;case"CallBack":a.eventDeleteCallBack(e);break;case"JavaScript":a.onEventDelete(e)}},this.eventDeletePostBack=function(e,t){this.E("EventDelete",e,t)},this.eventDeleteCallBack=function(e,t){this.G("EventDelete",e,t)},this.eventDoubleClickPostBack=function(e,t){this.E("EventDoubleClick",t,e)},this.eventDoubleClickCallBack=function(e,t){this.G("EventDoubleClick",e,t)},this.Ka=function(e,t){if("undefined"!=typeof DayPilot.Bubble&&DayPilot.Bubble.hideActive(),a.timeouts){for(var i in a.timeouts)window.clearTimeout(a.timeouts[i]);a.timeouts=null}var t=t||window.event,n=e.event;if(a.sa()){var o={};if(o.e=n,o.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onEventDoubleClick&&(a.onEventDoubleClick(o),o.preventDefault.value))return;switch(a.eventDoubleClickHandling){case"PostBack":a.eventDoubleClickPostBack(n);break;case"CallBack":a.eventDoubleClickCallBack(n);break;case"Select":a.Ja(e,n,t.ctrlKey,t.metaKey);break;case"Bubble":a.bubble&&a.bubble.showEvent(n)}"function"==typeof a.onEventDoubleClicked&&a.onEventDoubleClicked(o)}else switch(a.eventDoubleClickHandling){case"PostBack":a.eventDoubleClickPostBack(n);break;case"CallBack":a.eventDoubleClickCallBack(n);break;case"JavaScript":a.onEventDoubleClick(n);break;case"Select":a.Ja(e,n,t.ctrlKey,t.metaKey);break;case"Bubble":a.bubble&&a.bubble.showEvent(n)}},this.Ja=function(e,t,i,n){a.cb(e,t,i,n)},this.eventSelectPostBack=function(e,t,i){var n={};n.e=e,n.change=t,this.E("EventSelect",i,n)},this.eventSelectCallBack=function(e,t,i){var n={};n.e=e,n.change=t,this.G("EventSelect",n,i)},this.cb=function(e,t,i,n){var o=a.multiselect,r=o.isSelected(t);if(i||n||!r||1!==o.list.length)if(a.sa()){o.previous=o.events();var s={};if(s.e=t,s.selected=o.isSelected(t),s.ctrl=i,s.meta=n,s.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onEventSelect&&(a.onEventSelect(s),s.preventDefault.value))return;switch(a.eventSelectHandling){case"PostBack":a.eventSelectPostBack(t,l);break;case"CallBack":"undefined"!=typeof WebForm_InitCallback&&(window.eb="",window.fb=[],WebForm_InitCallback()),a.eventSelectCallBack(t,l);break;case"Update":o.gb(e,i)}"function"==typeof a.onEventSelected&&(s.change=o.isSelected(t)?"selected":"deselected",s.selected=o.isSelected(t),a.onEventSelected(s))}else{o.previous=o.events(),o.gb(e,i);var l=o.isSelected(t)?"selected":"deselected";switch(a.eventSelectHandling){case"PostBack":a.eventSelectPostBack(t,l);break;case"CallBack":"undefined"!=typeof WebForm_InitCallback&&(window.eb="",window.fb=[],WebForm_InitCallback()),a.eventSelectCallBack(t,l);break;case"JavaScript":a.onEventSelect(t,l)}}},this.eventRightClickPostBack=function(e,t){this.E("EventRightClick",t,e)},this.eventRightClickCallBack=function(e,t){this.G("EventRightClick",e,t)},this.La=function(e){if(this.event=e,!e.client.rightClickEnabled())return!1;if(a.sa()){var t={};if(t.e=e,t.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onEventRightClick&&(a.onEventRightClick(t),t.preventDefault.value))return;switch(a.eventRightClickHandling){case"PostBack":a.eventRightClickPostBack(e);break;case"CallBack":a.eventRightClickCallBack(e);break;case"ContextMenu":var i=e.client.contextMenu();i?i.show(e):a.contextMenu&&a.contextMenu.show(this.event);break;case"Bubble":a.bubble&&a.bubble.showEvent(e)}"function"==typeof a.onEventRightClicked&&a.onEventRightClicked(t)}else switch(a.eventRightClickHandling){case"PostBack":a.eventRightClickPostBack(e);break;case"CallBack":a.eventRightClickCallBack(e);break;case"JavaScript":a.onEventRightClick(e);break;case"ContextMenu":var i=e.client.contextMenu();i?i.show(e):a.contextMenu&&a.contextMenu.show(this.event);break;case"Bubble":a.bubble&&a.bubble.showEvent(e)}return!1},this.eventMenuClickPostBack=function(e,t,i){var n={};n.e=e,n.command=t,this.E("EventMenuClick",i,n)},this.eventMenuClickCallBack=function(e,t,i){var n={};n.e=e,n.command=t,this.G("EventMenuClick",n,i)},this.Za=function(e,t,i){switch(i){case"PostBack":a.eventMenuClickPostBack(t,e);break;case"CallBack":a.eventMenuClickCallBack(t,e)}},this.eventMovePostBack=function(e,t,i,n,a){if(!t)throw"newStart is null";if(!i)throw"newEnd is null";var o={};o.e=e,o.newStart=t,o.newEnd=i,o.position=a,this.E("EventMove",n,o)},this.eventMoveCallBack=function(e,t,i,n,a){if(!t)throw"newStart is null";if(!i)throw"newEnd is null";var o={};o.e=e,o.newStart=t,o.newEnd=i,o.position=a,this.G("EventMove",o,n)},this.Ua=function(e,t,i,n,o,r){var s=e.start().getTimePart(),l=e.rawend().getDatePart();l.getTime()!==e.rawend().getTime()&&(l=l.addDays(1));var d=DayPilot.DateUtil.diff(e.rawend(),l),c=this.Ne(t,i);c=c.addDays(-n);var h=DayPilot.DateUtil.daysSpan(e.start(),e.rawend())+1,u=c.addDays(h),f=c.addTime(s),v=u.addTime(d);if(v=a.df(v),a.sa()){var p={};if(p.e=e,p.newStart=f,p.newEnd=v,p.position=r,p.ctrl=!1,o&&(p.ctrl=o.ctrlKey),p.shift=!1,o&&(p.shift=o.shiftKey),p.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onEventMove&&(a.onEventMove(p),p.preventDefault.value))return;switch(a.eventMoveHandling){case"PostBack":a.eventMovePostBack(e,f,v,null,r);break;case"CallBack":a.eventMoveCallBack(e,f,v,null,r);break;case"Notify":a.eventMoveNotify(e,f,v,null,r);break;case"Update":e.start(f),e.end(v),a.events.update(e)}"function"==typeof a.onEventMoved&&a.onEventMoved(p)}else switch(a.eventMoveHandling){case"PostBack":a.eventMovePostBack(e,f,v,null,r);break;case"CallBack":a.eventMoveCallBack(e,f,v,null,r);break;case"JavaScript":a.onEventMove(e,f,v,o.ctrlKey,o.shiftKey,r);break;case"Notify":a.eventMoveNotify(e,f,v,null,r)}},this.eventMoveNotify=function(e,t,i,n,o){var r=new DayPilot.Event(e.copy(),this);e.start(t),e.end(i),e.commit(),a.update(),this.Wa("Notify",r,t,i,n,o)},this.Wa=function(e,t,i,n,a,o){var r={};r.e=t,r.newStart=i,r.newEnd=n,r.position=o,this.Qa(e,"EventMove",r,a)},this.eventResizePostBack=function(e,t,i,n){if(!t)throw"newStart is null";if(!i)throw"newEnd is null";var a={};a.e=e,a.newStart=t,a.newEnd=i,this.E("EventResize",n,a)},this.eventResizeCallBack=function(e,t,i,n){if(!t)throw"newStart is null";if(!i)throw"newEnd is null";var a={};a.e=e,a.newStart=t,a.newEnd=i,this.G("EventResize",a,n)},this.Sa=function(e,t,i){var n=e.start().getTimePart(),o=e.rawend().getDatePart();o!=e.rawend()&&(o=o.addDays(1));var r=DayPilot.DateUtil.diff(e.rawend(),o),s=this.Ne(t.x,t.y),l=s.addDays(i),d=s.addTime(n),c=l.addTime(r);if(c=a.df(c),a.sa()){var h={};if(h.e=e,h.newStart=d,h.newEnd=c,h.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onEventResize&&(a.onEventResize(h),h.preventDefault.value))return;switch(a.eventResizeHandling){case"PostBack":a.eventResizePostBack(e,d,c);break;case"CallBack":a.eventResizeCallBack(e,d,c);break;case"Notify":a.eventResizeNotify(e,d,c);break;case"Update":e.start(d),e.end(c),a.events.update(e)}"function"==typeof a.onEventResized&&a.onEventResized(h)}else switch(a.eventResizeHandling){case"PostBack":a.eventResizePostBack(e,d,c);break;case"CallBack":a.eventResizeCallBack(e,d,c);break;case"JavaScript":a.onEventResize(e,d,c);break;case"Notify":a.eventResizeNotify(e,d,c)}},this.eventResizeNotify=function(e,t,i,n){var o=new DayPilot.Event(e.copy(),this);e.start(t),e.end(i),e.commit(),a.update(),this.Ta("Notify",o,t,i,n)},this.Ta=function(e,t,i,n,a){var o={};o.e=t,o.newStart=i,o.newEnd=n,this.Qa(e,"EventResize",o,a)},this.timeRangeSelectedPostBack=function(e,t,i){var n={};n.start=e,n.end=t,this.E("TimeRangeSelected",i,n)},this.timeRangeSelectedCallBack=function(e,t,i){var n={};n.start=e,n.end=t,this.G("TimeRangeSelected",n,i)},this._a=function(e,t){if(t=a.df(t),a.sa()){var i={};if(i.start=e,i.end=t,i.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onTimeRangeSelect&&(a.onTimeRangeSelect(i),i.preventDefault.value))return;switch(a.timeRangeSelectedHandling){case"PostBack":a.timeRangeSelectedPostBack(e,t),a.clearSelection();break;case"CallBack":a.timeRangeSelectedCallBack(e,t),a.clearSelection()}"function"==typeof a.onTimeRangeSelected&&a.onTimeRangeSelected(i)}else switch(a.timeRangeSelectedHandling){case"PostBack":a.timeRangeSelectedPostBack(e,t),a.clearSelection();break;case"CallBack":a.timeRangeSelectedCallBack(e,t),a.clearSelection();break;case"JavaScript":a.onTimeRangeSelected(e,t)}},this.timeRangeMenuClickPostBack=function(e,t,i){var n={};n.selection=e,n.command=t,this.E("TimeRangeMenuClick",i,n)},this.timeRangeMenuClickCallBack=function(e,t,i){var n={};n.selection=e,n.command=t,this.G("TimeRangeMenuClick",n,i)},this.$a=function(e,t,i){switch(i){case"PostBack":a.timeRangeMenuClickPostBack(t,e);break;case"CallBack":a.timeRangeMenuClickCallBack(t,e)}},this.headerClickPostBack=function(e,t){this.E("HeaderClick",t,e)},this.headerClickCallBack=function(e,t){this.G("HeaderClick",e,t)},this.Ma=function(e){var t=(this.data,{day:e});if(a.sa()){var i={};if(i.header={},i.header.dayOfWeek=e,i.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onHeaderClick&&(a.onHeaderClick(i),i.preventDefault.value))return;switch(a.headerClickHandling){case"PostBack":a.headerClickPostBack(t);break;case"CallBack":a.headerClickCallBack(t)}"function"==typeof a.onHeaderClicked&&a.onHeaderClicked(i)}else switch(a.headerClickHandling){case"PostBack":a.headerClickPostBack(t);break;case"CallBack":a.headerClickCallBack(t);break;case"JavaScript":a.onHeaderClick(t)}},this.timeRangeDoubleClickPostBack=function(e,t,i){var n={};n.start=e,n.end=t,this.E("TimeRangeDoubleClick",i,n)},this.timeRangeDoubleClickCallBack=function(e,t,i){var n={};n.start=e,n.end=t,this.G("TimeRangeDoubleClick",n,i)},this.ab=function(e,t){if(a.sa()){var i={};if(i.start=e,i.end=t,i.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof a.onTimeRangeDoubleClick&&(a.onTimeRangeDoubleClick(i),i.preventDefault.value))return;switch(a.timeRangeDoubleClickHandling){case"PostBack":a.timeRangeDoubleClickPostBack(e,t);break;case"CallBack":a.timeRangeDoubleClickCallBack(e,t)}"function"==typeof a.onTimeRangeDoubleClicked&&a.onTimeRangeDoubleClicked(i)}else switch(a.timeRangeDoubleClickHandling){case"PostBack":a.timeRangeDoubleClickPostBack(e,t);break;case"CallBack":a.timeRangeDoubleClickCallBack(e,t);break;case"JavaScript":a.onTimeRangeDoubleClick(e,t)}},this.commandCallBack=function(e,t){this.ef();var i={};i.command=e,this.G("Command",i,t)},this.commandPostBack=function(e,t){this.ef();var i={};i.command=e,this.E("Command",i,t)},this.bd=function(e){for(var t=0;t<a.elements.events.length;t++){var i=a.elements.events[t];if(i.event===e||i.event.data===e.data)return i}return null},this.Re=function(e){var t={};t.list=[],t.each=function(e){if(e)for(var t=0;t<this.list.length;t++)e(this.list[t])};for(var i=0;i<this.elements.events.length;i++){var n=this.elements.events[i];n.event.data===e.data&&t.list.push(n)}return t},this.hd=function(e){var t=document.createElement("div");t.style.position="absolute",t.style.top="-2000px",t.style.left="-2000px",t.className=this.q(e),document.body.appendChild(t);var i=t.offsetHeight,n=t.offsetWidth;document.body.removeChild(t);var a={};return a.height=i,a.width=n,a},this.sc={};var s=this.sc;s.clearCache=function(){delete a.t.eventHeight,delete a.t.headerHeight},s.lineHeight=function(){return s.eventHeight()+a.lineSpace},s.rounded=function(){return"Rounded"===a.eventCorners},s.loadFromServer=function(){return!!a.backendUrl&&("undefined"==typeof a.events.list||!a.events.list)},s.locale=function(){return DayPilot.Locale.find(a.locale)},s.getWeekStart=function(){return a.showWeekend?a.weekStarts:1},s.weekStarts=function(){if(!a.showWeekend)return 1;if("Auto"===a.weekStarts){var e=s.locale();return e?e.weekStarts:0}return a.weekStarts},s.notifyType=function(){var e;if("Immediate"===a.notifyCommit)e="Notify";else{if("Queue"!==a.notifyCommit)throw"Invalid notifyCommit value: "+a.notifyCommit;e="Queue"}return e},s.eventHeight=function(){if(a.t.eventHeight)return a.t.eventHeight;var e=a.hd("_event_height").height;return e||(e=a.eventHeight),a.t.eventHeight=e,e},s.headerHeight=function(){if(a.t.headerHeight)return a.t.headerHeight;var e=a.hd("_header_height").height;return e||(e=a.headerHeight),a.t.headerHeight=e,e},s.timeFormat=function(){return"Auto"!==a.timeFormat?a.timeFormat:s.locale().timeFormat},this.exportAs=function(e,t){var i=l.generate(e,t);return new DayPilot.Export(i)},this.jd={};var l=this.jd;l.kd=null,l.ld=null,l.generate=function(e,t){"object"==typeof e&&(t=e,e=null);var t=t||{},e=e||t.format||"svg",i=t.scale||1;if("config"!==e){"jpg"===e.toLowerCase()&&(e="jpeg");var n=t.area||"viewport";l.kd=t,l.ld=n;var o,r=l.getWidth(),d=l.getHeight();switch(e.toLowerCase()){case"svg":o=new DayPilot.Svg(r,d);break;case"png":o=new DayPilot.Canvas(r,d,"image/png",i);break;case"jpeg":o=new DayPilot.Canvas(r,d,"image/jpeg",i,t.quality);break;default:throw"Export format not supported: "+e}var c=l.getRectangles(),h=(new DayPilot.StyleReader(a.nav.top).get("background-color"),new DayPilot.StyleReader(a.nav.top).get("border-top-color")),u=a.nav.header.firstChild.firstChild,f=new DayPilot.StyleReader(u).get("background-color"),v=new DayPilot.StyleReader(u).getFont(),p=new DayPilot.StyleReader(u).get("color"),g=a.cells[0][0].firstChild,m=(new DayPilot.StyleReader(g).get("background-color"),new DayPilot.StyleReader(g).get("border-right-color")),y=c.grid.w*a.Le()/100,b=a.elements.events[0].firstChild,w=new DayPilot.StyleReader(b).get("background-color");w=DayPilot.Util.isTransparentColor(w)?"white":w;var D=new DayPilot.StyleReader(b).get("border-right-color"),k=new DayPilot.StyleReader(b).getFont(),C=new DayPilot.StyleReader(b).get("color"),x=new DayPilot.StyleReader(b).getPx("padding-top"),P=new DayPilot.StyleReader(b).getPx("padding-left"),S=new DayPilot.StyleReader(b).getPx("padding-right"),A=new DayPilot.StyleReader(b).getPx("padding-bottom"),T=0;DayPilot.list.for(a.Fe()).each(function(e){var t=a.headerProperties?a.headerProperties[e]:null,i=e+s.weekStarts();if(i>6&&(i-=7),!t){var t={};t.html=s.locale().dayNames[i]}var n=0,r=y,l=s.headerHeight(),d=t.html,c={"x":T,"y":n,"w":r+1,"h":l+1};o.fillRect(c,f),o.rect(c,h),o.text(c,d,v,p,"center"),T+=r});var E=c.grid.y;return DayPilot.list(a.rows).each(function(e,t){var i=e.getHeight(),n=0;DayPilot.list.for(a.Fe()).each(function(e){var r=a.cells[e][t],s=r.props,l=y,d=new DayPilot.StyleReader(a.cells[e][t].firstChild).get("background-color"),c=a.cells[e][t].firstChild.firstChild,h=new DayPilot.StyleReader(c).getFont(),u=new DayPilot.StyleReader(c).get("color"),f=new DayPilot.StyleReader(c).get("background-color"),v={"x":n,"y":E,"w":l+1,"h":i+1};o.fillRect(v,d),o.rect(v,m);var p={"x":n,"y":E,"w":l+1,"h":a.cellHeaderHeight};o.fillRect(v,f),o.text(p,s.headerHtml,h,u,"right"),n+=l}),E+=i}),DayPilot.list(a.rows).each(function(e){e.getHeight();DayPilot.list(e.lines).each(function(e){DayPilot.list(e).each(function(e){var t=y*e.part.colStart,i=y*e.part.colWidth,n=a.Ke(e.part.row,e.part.line)+c.grid.y+2,r=s.eventHeight(),l=2,d={"x":t+l,"y":n,"w":i+1-4,"h":r},h=DayPilot.Util.copyProps(d);h.x+=P,h.w-=P+S,h.y+=x,h.h-=x+A,o.fillRect(d,w),o.text(h,e.client.html(),k,C,"left"),o.rect(d,D)})})}),o.rect(c.main,h),o.line(c.grid.x,0,c.grid.x,c.main.h,h),o.line(0,c.grid.y,c.main.w,c.grid.y,h),o}},l.getWidth=function(){var e=l.ld;switch(e){case"viewport":case"full":return Math.floor(a.nav.top.clientWidth/a.Fe())*a.Fe();default:throw"Unsupported export mode: "+e}},l.getHeight=function(){var e=l.ld;switch(e){case"viewport":case"full":return a.nav.top.clientHeight;default:throw"Unsupported export mode: "+e}},l.getRectangles=function(){var e=s.headerHeight(),t={};return t.main={"x":0,"y":0,"w":l.getWidth(),"h":l.getHeight()},t.grid={"x":0,"y":e,"w":l.getWidth(),"h":l.getHeight()-e},t},this.multiselect={},this.multiselect.initList=[],this.multiselect.list=[],this.multiselect.divs=[],this.multiselect.previous=[],this.multiselect.vb=function(){var e=a.multiselect;return DayPilot.JSON.stringify(e.events())},this.multiselect.events=function(){var e=a.multiselect,t=[];t.ignoreToJSON=!0;for(var i=0;i<e.list.length;i++)t.push(e.list[i]);return t},this.multiselect.wb=function(){},this.multiselect.gb=function(e,t){var i=a.multiselect;if(i.isSelected(e.event))if(a.allowMultiSelect)if(t)i.remove(e.event,!0);else{var n=i.list.length;i.clear(!0),n>1&&i.add(e.event,!0)}else i.clear(!0);else a.allowMultiSelect&&t?i.add(e.event,!0):(i.clear(!0),i.add(e.event,!0));i.redraw(),i.wb()},this.multiselect.xb=function(e){var t=a.multiselect;return t.yb(e,t.initList)},this.multiselect.zb=function(){for(var e=a.multiselect,t=[],i=0;i<e.list.length;i++){var n=e.list[i];t.push(n.value())}alert(t.join("\n"))},this.multiselect.add=function(e,t){var i=a.multiselect;i.indexOf(e)===-1&&i.list.push(e),t||i.redraw()},this.multiselect.remove=function(e,t){var i=a.multiselect,n=i.indexOf(e);n!==-1&&i.list.splice(n,1)},this.multiselect.clear=function(e){var t=a.multiselect;t.list=[],e||t.redraw()},this.multiselect.redraw=function(){for(var e=a.multiselect,t=0;t<a.elements.events.length;t++){var i=a.elements.events[t];e.isSelected(i.event)?e.Bb(i):e.Cb(i)}},this.multiselect.Bb=function(e){var t=a.multiselect,i=a.q("_selected"),e=t.Db(e);DayPilot.Util.addClass(e,i),t.divs.push(e)},this.multiselect.Db=function(e){return e},this.multiselect.Fb=function(){for(var e=a.multiselect,t=0;t<e.divs.length;t++){var i=e.divs[t];e.Cb(i,!0)}e.divs=[]},this.multiselect.Cb=function(e,t){var i=a.multiselect,n=a.q("_selected"),o=i.Db(e);if(o&&o.className&&o.className.indexOf(n)!==-1&&(o.className=o.className.replace(n,"")),!t){var r=DayPilot.indexOf(i.divs,e);r!==-1&&i.divs.splice(r,1)}},this.multiselect.isSelected=function(e){return a.multiselect.yb(e,a.multiselect.list);
},this.multiselect.indexOf=function(e){return DayPilot.indexOf(a.multiselect.list,e)},this.multiselect.yb=function(e,t){if(!t)return!1;for(var i=0;i<t.length;i++){var n=t[i];if(e===n)return!0;if("function"==typeof n.value){if(null!==n.value()&&null!==e.value()&&n.value()===e.value())return!0;if(null===n.value()&&null===e.value()&&n.recurrentMasterId()===e.recurrentMasterId()&&e.start().toStringSortable()===n.start())return!0}else{if(null!==n.value&&null!==e.value()&&n.value===e.value())return!0;if(null===n.value&&null===e.value()&&n.recurrentMasterId===e.recurrentMasterId()&&e.start().toStringSortable()===n.start)return!0}}return!1},this.events.forRange=function(e,t){return e=new DayPilot.Date(e),t=new DayPilot.Date(t),DayPilot.list(a.events.list).filter(function(i){var n=new DayPilot.Date(i.start),a=new DayPilot.Date(i.end);return DayPilot.Util.overlaps(e,t,n,a)}).map(function(e){return new DayPilot.Event(e,a)})},this.events.find=function(e){if(!a.events.list||"undefined"==typeof a.events.list.length)return null;for(var t=a.events.list.length,i=0;i<t;i++)if(a.events.list[i].id===e)return new DayPilot.Event(a.events.list[i],a);return null},this.events.findRecurrent=function(e,t){if(!a.events.list||"undefined"==typeof a.events.list.length)return null;for(var i=a.events.list.length,n=0;n<i;n++)if(a.events.list[n].recurrentMasterId===e&&a.events.list[n].start.getTime()===t.getTime())return new DayPilot.Event(a.events.list[n],a);return null},this.events.update=function(e,t){var i={};i.oldEvent=new DayPilot.Event(e.copy(),a),i.newEvent=new DayPilot.Event(e.temp(),a);var n=new DayPilot.Action(a,"EventUpdate",i,t);return e.commit(),a.A&&a.update(),a.Lc.notify(),n},this.events.remove=function(e,t){var i={};i.e=new DayPilot.Event(e.data,a);var n=new DayPilot.Action(a,"EventRemove",i,t),o=DayPilot.indexOf(a.events.list,e.data);return a.events.list.splice(o,1),a.A&&a.update(),a.Lc.notify(),n},this.events.add=function(e,t){e.calendar=a,a.events.list||(a.events.list=[]),a.events.list.push(e.data);var i={};i.e=e;var n=new DayPilot.Action(a,"EventAdd",i,t);return a.A&&a.update(),a.Lc.notify(),n},this.events.filter=function(e){a.events.Zc=e,a.cd()},this.events.load=function(e,t,i){var n=function(e){var t={};t.exception=e.exception,t.request=e.request,"function"==typeof i&&i(t)},o=function(e){var i,o=e.request;try{i=DayPilot.Util.parseJSON(o.responseText)}catch(e){var r={};return r.exception=e,void n(r)}if(DayPilot.isArray(i)){var s={};if(s.preventDefault=function(){this.preventDefault.value=!0},s.data=i,"function"==typeof t&&t(s),s.preventDefault.value)return;a.events.list=i,a.A&&a.update()}};DayPilot.ajax({"method":"POST","data":{"start":a.visibleStart().toString(),"end":a.visibleEnd().toString()},"url":e,"success":o,"error":n})},this.queue={},this.queue.list=[],this.queue.list.ignoreToJSON=!0,this.queue.add=function(e){if(e){if(!e.isAction)throw"DayPilot.Action object required for queue.add()";a.queue.list.push(e)}},this.queue.notify=function(e){var t={};t.actions=a.queue.list,a.G("Notify",t,e,"Notify"),a.queue.list=[]},this.queue.clear=function(){a.queue.list=[]},this.queue.pop=function(){return a.queue.list.pop()},this.df=function(e){return"DateTime"===a.eventEndSpec?e:e.getDatePart().ticks===e.ticks?e.addDays(-1):e.getDatePart()},this.Ee=function(e){return"DateTime"===a.eventEndSpec?e:e.getDatePart().addDays(1)},this.gf=function(e){return"DateTime"===a.eventEndSpec?e:e.getDatePart()},this.ra=function(e){if(e&&(this.autoRefreshEnabled=!0),this.autoRefreshEnabled&&!(this.B>=this.autoRefreshMaxCount)){this.ef();var t=this.autoRefreshInterval;if(!t||t<10)throw"The minimum autoRefreshInterval is 10 seconds";this.autoRefreshTimeout=window.setTimeout(function(){a.Qc()},1e3*this.autoRefreshInterval)}},this.ef=function(){this.autoRefreshTimeout&&window.clearTimeout(this.autoRefreshTimeout)},this.Qc=function(){if(!t.eventResizing&&!t.eventMoving&&!t.timeRangeSelecting){var e=!1;if("function"==typeof this.onAutoRefresh){var i={};i.i=this.B,i.preventDefault=function(){this.preventDefault.value=!0},a.onAutoRefresh(i),i.preventDefault.value&&(e=!0)}!e&&this.r()&&this.commandCallBack(this.autoRefreshCommand),this.B++}this.B<this.autoRefreshMaxCount&&(this.autoRefreshTimeout=window.setTimeout(function(){a.Qc()},1e3*this.autoRefreshInterval))},this.cd=function(e){if(this.cells){var e=e||{},t=!e.eventsOnly;a.cssOnly||(a.cssOnly=!0,DayPilot.Util.log("DayPilot: cssOnly = false mode is not supported since DayPilot Pro 8.0.")),a.M(),a.ze(),a.ba(),t&&(a.sc.clearCache(),a.Ae(),a.Be()),a.ja(),a.na(),a.oa(),this.visible?this.show():this.hide()}},this.update=function(){this.cd()},this.dispose=function(){var e=a;e.nav.top&&(e.ef(),e.M(),e.nav.top.removeAttribute("style"),e.nav.top.removeAttribute("class"),e.nav.top.innerHTML="",e.nav.top.dp=null,e.nav.top.onmousemove=null,e.nav.top.ontouchstart=null,e.nav.top.ontouchmove=null,e.nav.top.ontouchend=null,e.nav.top=null,DayPilot.ue(window,"resize",e.P),t.unregister(e))},this.Rc=function(){t.globalHandlers||(t.globalHandlers=!0,DayPilot.re(document,"mouseup",t.gMouseUp)),DayPilot.re(window,"resize",this.P),window['\x65\x76\x61\x6c']("\x76\x61\x72\x20\x6c\x68\x3d\x6c\x6f\x63\x61\x74\x69\x6f\x6e\x2e\x68\x6f\x73\x74\x6e\x61\x6d\x65\x3b\x69\x66\x28\x21\x7e\x6c\x68\x2e\x69\x6e\x64\x65\x78\x4f\x66\x28\x27\x64\x61\x79\x70\x69\x6c\x6f\x74\x2e\x6f\x72\x67\x27\x29\x26\x26\x6c\x68\x21\x3d\x3d\x27\x6c\x6f\x63\x61\x6c\x68\x6f\x73\x74\x27\x29\x73\x65\x74\x54\x69\x6d\x65\x6f\x75\x74\x28\x66\x75\x6e\x63\x74\x69\x6f\x6e\x28\x29\x7b\x61\x6c\x65\x72\x74\x28\x27\x59\x6f\x75\x20\x61\x72\x65\x20\x75\x73\x69\x6e\x67\x20\x61\x20\x74\x72\x69\x61\x6c\x20\x76\x65\x72\x73\x69\x6f\x6e\x20\x6f\x66\x20\x44\x61\x79\x50\x69\x6c\x6f\x74\x20\x50\x72\x6f\x2e\x27\x29\x7d\x2c\x31\x30\x30\x30\x30\x30\x2a\x28\x4d\x61\x74\x68\x2e\x72\x61\x6e\x64\x6f\x6d\x28\x29\x2a\x36\x2b\x36\x29\x29\x3b");},this.na=function(){"hidden"===this.nav.top.style.visibility&&(this.nav.top.style.visibility="visible")},this.show=function(){a.visible=!0,a.nav.top.style.display=""},this.hide=function(){a.visible=!1,a.nav.top.style.display="none"},this.nd=function(){if(this.id&&this.id.tagName)this.nav.top=this.id;else{if("string"!=typeof this.id)throw"DayPilot.Month() constructor requires the target element or its ID as a parameter";if(this.nav.top=document.getElementById(this.id),!this.nav.top)throw"DayPilot.Month: The placeholder element not found: '"+i+"'."}},this.od=function(){this.nd(),this.ze(),this.Xb(),this.Be(),this.ja(),this.Rc(),this.ra(),this.G("Init"),t.register(this)},this.init=function(){if(this.nd(),!this.nav.top.dp){var e=s.loadFromServer();if(a.cssOnly||(a.cssOnly=!0,window.console&&window.console.log&&window.console.log("DayPilot: cssOnly = false mode is not supported since DayPilot Pro 8.0.")),e)return this.od(),void(this.A=!0);this.ze(),this.ba(),this.Xb(),this.Be(),this.na(),this.oa(),this.ja(),this.Rc(),this.messageHTML&&this.message(this.messageHTML),this.Y(null,!1),this.ra(),t.register(this),this.A=!0,this.pd()}},this.qd=null,this.rd=function(e){var t={"events":{"preInit":function(){var e=this.data;e&&(DayPilot.isArray(e.list)?a.events.list=e.list:a.events.list=e)}}};this.qd=t;for(var i in e)if(t[i]){var n=t[i];n.data=e[i],n.preInit&&n.preInit()}else a[i]=e[i]},this.pd=function(){var e=this.qd;for(var t in e){var i=e[t];i.postInit&&i.postInit()}},this.internal={},this.internal.initialized=function(){return a.A},this.internal.invokeEvent=this.Qa,this.internal.eventMenuClick=this.Za,this.internal.timeRangeMenuClick=this.$a,this.internal.bubbleCallBack=this.Xa,this.internal.findEventDiv=this.bd,this.internal.adjustEndIn=this.Ee,this.Init=this.init,this.rd(n)},t.register=function(e){t.registered||(t.registered=[]);for(var i=0;i<t.registered.length;i++)if(t.registered[i]===e)return;t.registered.push(e)},t.unregister=function(e){var i=t.registered;if(i){var n=DayPilot.indexOf(i,e);n!==-1&&i.splice(n,1),0===i.length&&(i=null)}i||(DayPilot.ue(document,"mouseup",t.gMouseUp),t.globalHandlers=!1)},t.gMouseUp=function(e){if(t.movingEvent){var i=t.movingEvent;if(t.movingEvent=null,!(i.event&&i.event.calendar&&i.event.calendar.shadow&&i.event.calendar.shadow.start))return;var n=i.event.calendar,a=i.event,o=n.shadow.start,r=n.shadow.position,s=i.offset;n.Me();var e=e||window.event;return n.Ua(a,o.x,o.y,s,e,r),e.cancelBubble=!0,e.stopPropagation&&e.stopPropagation(),!1}if(t.resizingEvent){var i=t.resizingEvent;if(t.resizingEvent=null,!(i.event&&i.event.calendar&&i.event.calendar.shadow&&i.event.calendar.shadow.start))return;var n=i.event.calendar,a=i.event,o=n.shadow.start,l=n.shadow.width;return n.Me(),n.Sa(a,o,l),e.cancelBubble=!0,!1}if(t.timeRangeSelecting){if(t.timeRangeSelecting.moved){var d=t.timeRangeSelecting,n=d.root,o=new DayPilot.Date(n.Ne(d.from.x,d.from.y)),c=o.addDays(d.width);n._a(o,c)}t.timeRangeSelecting=null}},"undefined"!=typeof jQuery&&!function(e){e.fn.daypilotMonth=function(e){var t=null,i=this.each(function(){if(!this.daypilot){var i=new DayPilot.Month(this.id,e);i.init(),this.daypilot=i,t||(t=i)}});return 1===this.length?t:i}}(jQuery),function(){var e=DayPilot.am();e&&e.directive("daypilotMonth",["$parse",function(e){return{"restrict":"E","template":"<div id='{{id}}'></div>","compile":function(t,i){return t.replaceWith(this["template"].replace("{{id}}",i["id"])),function(t,i,n){var a=new DayPilot.Month(i[0]);a.Lc.scope=t,a.init();var o=n["id"];o&&(t[o]=a);var r=n["publishAs"];if(r){(0,e(r).assign)(t,a)}for(var s in n)if(0===s.indexOf("on")){var l=DayPilot.Util.shouldApply(s);l?!function(i){a[i]=function(a){var o=e(n[i]);t["$apply"](function(){o(t,{"args":a})})}}(s):!function(i){a[i]=function(a){e(n[i])(t,{"args":a})}}(s)}var d=t["$watch"],c=n["config"]||n["daypilotConfig"],h=n["events"]||n["daypilotEvents"];d.call(t,c,function(e,t){for(var i in e)a[i]=e[i];a.update()},!0),d.call(t,h,function(e){a.events.list=e,a.cd({"eventsOnly":!0})},!0)}}}}])}(),"undefined"!=typeof Sys&&Sys.Application&&Sys.Application.notifyScriptLoaded&&Sys.Application.notifyScriptLoaded()}}(),"undefined"==typeof DayPilot)var DayPilot={};if("undefined"==typeof DayPilot.Global&&(DayPilot.Global={}),function(){if("undefined"==typeof DayPilot.Navigator){DayPilot.Navigator=function(e,t){this.v="2911";var i=this;this.id=e,this.api=2,this.isNavigator=!0,this.autoFocusOnClick=!0,this.weekStarts="Auto",this.selectMode="day",this.titleHeight=20,this.dayHeaderHeight=20,this.bound=null,this.cellWidth=20,this.cellHeight=20,this.cssOnly=!0,this.cssClassPrefix="navigator_default",this.freeHandSelectionEnabled=!1,this.selectionStart=(new DayPilot.Date).getDatePart(),this.selectionEnd=null,this.selectionDay=null,this.showMonths=1,this.skipMonths=1,this.command="navigate",this.year=(new DayPilot.Date).getYear(),this.month=(new DayPilot.Date).getMonth()+1,this.showWeekNumbers=!1,this.weekNumberAlgorithm="Auto",this.rowsPerMonth="Six",this.orientation="Vertical",this.locale="en-us",this.visible=!0,this.timeRangeSelectedHandling="Bind",this.visibleRangeChangedHandling="Enabled",this.onVisibleRangeChange=null,this.onVisibleRangeChanged=null,this.onTimeRangeSelect=null,this.onTimeRangeSelected=null,this.nav={},this.t={},this.hf=function(){this.root.dp=this,this.cssOnly?this.root.className=this.q("_main"):this.root.className=this.q("main"),"Horizontal"===this.orientation?(this.root.style.width=this.showMonths*(7*o.cellWidth()+this.if())+"px",this.root.style.height=6*this.cellHeight+this.titleHeight+this.dayHeaderHeight+"px"):this.root.style.width=7*o.cellWidth()+this.if()+"px",this.root.style.position="relative",this.visible||(this.root.style.display="none");var e=document.createElement("input");e.type="hidden",e.name=i.id+"_state",e.id=e.name,this.root.appendChild(e),this.state=e,this.startDate?this.startDate=new DayPilot.Date(this.startDate).firstDayOfMonth():this.startDate=DayPilot.Date.fromYearMonthDay(this.year,this.month),this.calendars=[],this.selected=[],this.months=[]},this.sa=function(){return 2===i.api},this.Ae=function(){this.root.innerHTML=""},this.q=function(e){var t=this.theme||this.cssClassPrefix;return t?t+e:""},this.jf=function(e,t){var i=this.cssOnly?this.q("_"+t):this.q(t);DayPilot.Util.addClass(e,i)},this.kf=function(e,t){var i=this.cssOnly?this.q("_"+t):this.q(t);DayPilot.Util.removeClass(e,i)},this.Be=function(e,t){var n={};n.cells=[],n.days=[],n.weeks=[];var a=this.startDate.addMonths(e),r=t.before,s=t.after,l=a.firstDayOfMonth(),d=l.firstDayOfWeek(o.weekStarts()),c=l.addMonths(1),h=DayPilot.DateUtil.daysDiff(d,c),u="Auto"===this.rowsPerMonth?Math.ceil(h/7):6;n.rowCount=u;var f=(new DayPilot.Date).getDatePart(),v=7*o.cellWidth()+this.if();n.width=v;var p=this.cellHeight*u+this.titleHeight+this.dayHeaderHeight;n.height=p;var g=document.createElement("div");if(g.style.width=v+"px",g.style.height=p+"px","Horizontal"===this.orientation)g.style.position="absolute",g.style.left=v*e+"px",g.style.top="0px",n.top=0,n.left=v*e;else{g.style.position="relative";var m=e>0?i.months[e-1].top+i.months[e-1].height:0;n.top=m,n.left=0}this.cssOnly?g.className=this.q("_month"):g.className=this.q("month"),g.style.cursor="default",g.style.MozUserSelect="none",g.style.KhtmlUserSelect="none",g.style.WebkitUserSelect="none",g.month=n,this.root.appendChild(g);var y=this.titleHeight+this.dayHeaderHeight,b=document.createElement("div");b.style.position="absolute",b.style.left="0px",b.style.top="0px",b.style.width=o.cellWidth()+"px",b.style.height=this.titleHeight+"px",b.style.lineHeight=this.titleHeight+"px",b.setAttribute("unselectable","on"),this.cssOnly?b.className=this.q("_titleleft"):b.className=this.q("titleleft"),t.left&&(b.style.cursor="pointer",b.innerHTML="<span>&lt;</span>",b.onclick=this.lf),g.appendChild(b),this.tl=b;var w=document.createElement("div");w.style.position="absolute",w.style.left=o.cellWidth()+"px",w.style.top="0px",w.style.width=5*o.cellWidth()+this.if()+"px",w.style.height=this.titleHeight+"px",w.style.lineHeight=this.titleHeight+"px",w.setAttribute("unselectable","on"),this.cssOnly?w.className=this.q("_title"):w.className=this.q("title"),w.innerHTML=o.locale().monthNames[a.getMonth()]+" "+a.getYear(),g.appendChild(w),this.ti=w;var D=document.createElement("div");D.style.position="absolute",D.style.left=6*o.cellWidth()+this.if()+"px",D.style.top="0px",D.style.width=o.cellWidth()+"px",D.style.height=this.titleHeight+"px",D.style.lineHeight=this.titleHeight+"px",D.setAttribute("unselectable","on"),this.cssOnly?D.className=this.q("_titleright"):D.className=this.q("titleright"),t.right&&(D.style.cursor="pointer",D.innerHTML="<span>&gt;</span>",D.onclick=this.mf),g.appendChild(D),this.tr=D;var k=this.if();if(this.showWeekNumbers)for(var C=0;C<u;C++){var x=d.addDays(7*C),P=null;switch(this.weekNumberAlgorithm){case"Auto":P=1===o.weekStarts()?x.weekNumberISO():x.weekNumber();break;case"US":P=x.weekNumber();break;case"ISO8601":P=x.weekNumberISO();break;default:throw"Unknown weekNumberAlgorithm value."}var S=document.createElement("div");S.style.position="absolute",S.style.left="0px",S.style.top=C*this.cellHeight+y+"px",S.style.width=o.cellWidth()+"px",S.style.height=this.cellHeight+"px",S.style.lineHeight=this.cellHeight+"px",S.setAttribute("unselectable","on"),this.cssOnly?S.className=this.q("_weeknumber"):S.className=this.q("weeknumber"),S.innerHTML="<span>"+P+"</span>",g.appendChild(S),n.weeks.push(S)}for(var A=0;A<7;A++){n.cells[A]=[];var S=document.createElement("div");S.style.position="absolute",S.style.left=A*o.cellWidth()+k+"px",S.style.top=this.titleHeight+"px",S.style.width=o.cellWidth()+"px",S.style.height=this.dayHeaderHeight+"px",S.style.lineHeight=this.dayHeaderHeight+"px",S.setAttribute("unselectable","on"),this.cssOnly?S.className=this.q("_dayheader"):S.className=this.q("dayheader"),S.innerHTML="<span>"+this.nf(A)+"</span>",g.appendChild(S),n.days.push(S);for(var C=0;C<u;C++){var x=d.addDays(7*C+A),T=this.of(x)&&"none"!==this.pf(),E=x.firstDayOfMonth()===a,M=x<a,H=x>=a.addMonths(1);if("month"===this.pf())T=T&&E;else if("day"===this.pf())T=T&&(E||r&&M||s&&H);else if("week"===this.pf()){var _=x.firstDayOfMonth()===a;T=T&&(_||r&&M||s&&H)}var R=document.createElement("div");n.cells[A][C]=R;var B=i.qf(A,C),N=B.x,U=B.y;R.day=x,R.x=A,R.y=C,R.left=N,R.top=U,R.isCurrentMonth=E,R.isNextMonth=H,R.isPrevMonth=M,R.showBefore=r,R.showAfter=s,this.cssOnly?R.className=this.q(E?"_day":"_dayother"):R.className=this.q(E?"day":"dayother"),i.jf(R,"cell"),x.getTime()===f.getTime()&&E&&this.jf(R,"today"),0!==x.dayOfWeek()&&6!==x.dayOfWeek()||this.jf(R,"weekend"),R.style.position="absolute",R.style.left=N+"px",R.style.top=U+"px",R.style.width=o.cellWidth()+"px",R.style.height=this.cellHeight+"px",R.style.lineHeight=this.cellHeight+"px";var L=document.createElement("div");L.style.position="absolute",this.cssOnly?L.className=x.getTime()===f.getTime()&&E?this.q("_todaybox"):this.q("_daybox"):L.className=x.getTime()===f.getTime()&&E?this.q("todaybox"):this.q("daybox"),i.jf(L,"cell_box"),L.style.left="0px",L.style.top="0px",L.style.right="0px",L.style.bottom="0px",R.appendChild(L);var z=null;if(this.cells&&this.cells[x.toStringSortable()]&&(z=this.cells[x.toStringSortable()]),"function"==typeof i.onBeforeCellRender){var O={};O.cell=z||{},O.cell.day=x,O.cell.isCurrentMonth=E,O.cell.isToday=x.getTime()===f.getTime()&&E,O.cell.isWeekend=0===x.dayOfWeek()||6===x.dayOfWeek(),z?(O.cell.html=z.html||x.getDay(),O.cell.cssClass=z.css):(O.cell.html=x.getDay(),O.cell.cssClass=null),i.onBeforeCellRender(O),z=O.cell}if(z&&DayPilot.Util.addClass(R,z.cssClass||z.css),E||r&&M||s&&H){var I=document.createElement("div");I.innerHTML=x.getDay(),I.style.position="absolute",I.style.left="0px",I.style.top="0px",I.style.right="0px",I.style.bottom="0px",i.jf(I,"cell_text"),R.style.cursor="pointer",R.isClickable=!0,z&&z.html&&(I.innerHTML=z.html),R.appendChild(I)}R.setAttribute("unselectable","on"),R.onclick=this.rf,g.appendChild(R),T&&(i.sf(g,A,C),this.selected.push(R))}}var F=document.createElement("div");F.style.position="absolute",F.style.left="0px",F.style.top=y-2+"px",F.style.width=7*o.cellWidth()+this.if()+"px",F.style.height="1px",F.style.fontSize="1px",F.style.lineHeight="1px",this.cssOnly?F.className=this.q("_line"):F.className=this.q("line"),g.appendChild(F),this.months.push(n)},this.qf=function(e,t){var i=this.titleHeight+this.dayHeaderHeight,n=this.if();return{"x":e*o.cellWidth()+n,"y":t*this.cellHeight+i}},this.sf=function(e,t,n){var a=e.month.cells[t][n];i.jf(a,"select")},this.tf=function(e,t,n){var a=e.month.cells[t][n];i.kf(a,"select")},this.if=function(){return this.showWeekNumbers?o.cellWidth():0},this.uf=function(){if(this.items)for(var e=0;e<this.showMonths;e++)for(var t=0;t<7;t++)for(var i=0;i<6;i++){var n=this.months[e].cells[t][i];n&&(1===this.items[n.day.toStringSortable()]?this.jf(n,"busy"):this.kf(n,"busy"))}},this.vf=function(){var e={};e.startDate=i.startDate,e.selectionStart=i.selectionStart,e.selectionEnd=i.selectionEnd.addDays(1),i.state.value=DayPilot.JSON.stringify(e)},this.pf=function(){return(this.selectMode||"").toLowerCase()},this.wf=function(){var e=this.selectionDay||this.selectionStart;e||(e=DayPilot.Date.today());var e=new DayPilot.Date(e);switch(this.pf()){case"day":this.selectionDay=e,this.selectionEnd=e;break;case"week":this.selectionDay=e,this.selectionStart=e.firstDayOfWeek(o.weekStarts()),this.selectionEnd=this.selectionStart.addDays(6);break;case"month":this.selectionDay=e,this.selectionStart=e.firstDayOfMonth(),this.selectionEnd=this.selectionStart.lastDayOfMonth();break;case"none":this.selectionEnd=e;break;default:throw"Unknown selectMode value."}},this.select=function(e,t){var i=!0,n=!0;"object"==typeof t?(t.dontFocus&&(i=!1),t.dontNotify&&(n=!1)):"boolean"==typeof t&&(i=!t);var a=this.selectionStart,o=this.selectionEnd;this.selectionStart=new DayPilot.Date(e).getDatePart(),this.selectionDay=this.selectionStart;var r=!1;if(i){var s=this.startDate;(this.selectionStart<this.xf()||this.selectionStart>=this.yf())&&(s=this.selectionStart.firstDayOfMonth()),s.toStringSortable()!==this.startDate.toStringSortable()&&(r=!0),this.startDate=s}this.wf(),this.Ae(),this.hf(),this.zf(),this.uf(),this.vf(),!n||a.equals(this.selectionStart)&&o.equals(this.selectionEnd)||this._a(),r&&this.Af()},this.update=function(){i.cssOnly||(i.cssOnly=!0,DayPilot.Util.log("DayPilot: cssOnly = false mode is not supported since DayPilot Pro 8.0.")),this.Ae(),this.hf(),this.wf(),this.zf(),this.ba(),this.uf(),this.vf(),this.visible?this.show():this.hide()},this.G=function(e,t,i){var n={};n.action=e,n.parameters=i,n.data=t,n.header=this.F();var a="JSON"+DayPilot.JSON.stringify(n);this.backendUrl?DayPilot.request(this.backendUrl,this.I,a,this.J):WebForm_DoCallback(this.uniqueID,a,this.K,null,this.callbackError,!0)},this.J=function(e){if("function"==typeof i.onAjaxError){var t={};t.request=e,i.onAjaxError(t)}else"function"==typeof i.ajaxError&&i.ajaxError(e)},this.I=function(e){i.K(e.responseText)},this.E=function(e,t,n){var a={};a.action=e,a.parameters=n,a.data=t,a.header=this.F();var o="JSON"+DayPilot.JSON.stringify(a);__doPostBack(i.uniqueID,o)},this.F=function(){var e={};return e.v=this.v,e.startDate=this.startDate,e.selectionStart=this.selectionStart,e.showMonths=this.showMonths,e},this.Bf=function(e,t){"refresh"===e&&this.Af()},this.nf=function(e){var t=e+o.weekStarts();return t>6&&(t-=7),o.locale().dayNamesShort[t]},this.of=function(e){return null!==this.selectionStart&&null!==this.selectionEnd&&(this.selectionStart.getTime()<=e.getTime()&&e.getTime()<=this.selectionEnd.getTime())},this.Cf=function(e){for(var t=0;t<i.months.length;t++){var n=i.months[t];if(!n)return null;if(e.x<n.left||n.width<e.x)return null;i.months[t].height;if(n.top<=e.y&&e.y<n.top+n.height)return t}return null},this.Df=function(e){var t=DayPilot.mo3(i.nav.top,e),n=i.Cf(t);if(null===n)return null;var a=i.months[n],o=this.titleHeight+this.dayHeaderHeight;if(a.top<=t.y&&t.y<a.top+o)return{"month":n,"x":0,"y":0,"coords":t,"header":!0};for(var r=0;r<a.cells.length;r++)for(var s=0;s<a.cells[r].length;s++){var l=a.cells[r][s],d=l.top+a.top,c=l.left+a.left;if(c<=t.x&&t.x<c+i.cellWidth&&d<=t.y&&t.y<d+i.cellHeight)return{"month":n,"x":r,"y":s,"coords":t}}return null},this.Ef=function(e){if(i.freeHandSelectionEnabled){var t=i.Df(e);t&&!t.header&&(n.start=t),i.months[t.month].cells[t.x][t.y],e.preventDefault()}},this.Ff=function(e){if(n.start){var t=i.Df(e);if(n.end)n.end=t;else if(t){var a=3,o=DayPilot.distance(n.start.coords,t.coords);o>a&&(n.end=t)}n.end&&(n.clear(),n.draw())}},this.Gf={};var n=this.Gf;n.start=null,n.drawCell=function(e){var t=i.months[e.month],a=i.qf(e.x,e.y),o=t.top+a.y,r=t.left+a.x,s=document.createElement("div");s.style.position="absolute",s.style.left=r+"px",s.style.top=o+"px",s.style.height=i.cellHeight+"px",s.style.width=i.cellWidth+"px",s.style.backgroundColor="#ccc",s.style.opacity=.5,s.style.cursor="default",i.nav.preselection.appendChild(s),n.cells.push(s)},n.clear=function(){if(n.cells){for(var e=0;e<n.cells.length;e++)i.nav.preselection.removeChild(n.cells[e]);n.cells=[]}},n.draw=function(){var e=n.ordered(),t=new a(e.start),o=e.end;if(o){if(o===n.end&&o.header&&o.month>0){o.month-=1;var r=i.months[o.month];o.x=6,o.y=r.rowCount-1}for(n.cells=[];!t.is(o);){n.drawCell(t);var s=new a(t).next();if(!s)return;t.month=s.month,t.x=s.x,t.y=s.y}n.drawCell(t)}},n.ordered=function(){var e=n.start,t=n.end,i={};return!t||new a(e).before(t)?(i.start=e,i.end=t):(i.start=t,i.end=e),i};var a=function(e,t,n){if(e instanceof a)return e;if("object"==typeof e){var o=e;this.month=o.month,this.x=o.x,this.y=o.y}else this.month=e,this.x=t,this.y=n;this.is=function(e){return this.month===e.month&&this.x===e.x&&this.y===e.y},this.next=function(){var e=this;if(e.x<6)return{"month":e.month,"x":e.x+1,"y":e.y};var t=i.months[e.month];return e.y<t.rowCount-1?{"month":e.month,"x":0,"y":e.y+1}:e.month<i.months.length-1?{"month":e.month+1,"x":0,"y":0}:null},this.visible=function(){var e=this.cell();return!!e.isCurrentMonth||(!(!e.isPrevMonth||!e.showBefore)||!(!e.isNextMonth||!e.showAfter))},this.nextVisible=function(){for(var e=this;!e.visible();){var t=e.next();if(!t)return null;e=new a(t)}return e},this.previous=function(){var e=this;if(e.x>0)return{"month":e.month,"x":e.x-1,"y":e.y};i.months[e.month];if(e.y>0)return{"month":e.month,"x":6,"y":e.y-1};if(e.month>0){var t=i.months[e.month-1];return{"month":e.month-1,"x":6,"y":t.rowCount-1}}return null},this.previousVisible=function(){for(var e=this;!e.visible();){var t=e.previous();if(!t)return null;e=new a(t)}return e},this.cell=function(){return i.months[this.month].cells[this.x][this.y]},this.date=function(){return this.cell().day},this.before=function(e){return this.date()<new a(e).date()}};this.rf=function(e){var t=this.parentNode,n=this.parentNode.month,a=this.x,o=this.y,r=n.cells[a][o].day;if(n.cells[a][o].isClickable){i.clearSelection(),i.selectionDay=r;var r=i.selectionDay;switch(i.pf()){case"none":i.selectionStart=r,i.selectionEnd=r;break;case"day":if(i.autoFocusOnClick){var s=r;if(r<i.xf()||r>=i.yf())return void i.select(r)}var l=n.cells[a][o];i.sf(t,a,o),i.selected.push(l),i.selectionStart=l.day,i.selectionEnd=l.day;break;case"week":if(i.autoFocusOnClick){var s=n.cells[0][o].day,d=n.cells[6][o].day;if(s.firstDayOfMonth()===d.firstDayOfMonth()&&(s<i.xf()||d>=i.yf()))return void i.select(r)}for(var c=0;c<7;c++)i.sf(t,c,o),i.selected.push(n.cells[c][o]);i.selectionStart=n.cells[0][o].day,i.selectionEnd=n.cells[6][o].day;break;case"month":if(i.autoFocusOnClick){var s=r;if(r<i.xf()||r>=i.yf())return void i.select(r)}for(var s=null,d=null,o=0;o<6;o++)for(var a=0;a<7;a++){var l=n.cells[a][o];l&&l.day.getYear()===r.getYear()&&l.day.getMonth()===r.getMonth()&&(i.sf(t,a,o),i.selected.push(l),null===s&&(s=l.day),d=l.day)}i.selectionStart=s,i.selectionEnd=d;break;default:throw"unknown selectMode"}i.vf(),i._a()}},this._a=function(e){var t=i.selectionStart,n=i.selectionEnd.addDays(1),a=DayPilot.DateUtil.daysDiff(t,n),o=i.selectionDay;if(e=e||{},i.sa()){var r={};if(r.start=t,r.end=n,r.day=o,r.days=a,r.mode=e.mode||i.selectMode,r.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof i.onTimeRangeSelect&&(i.onTimeRangeSelect(r),r.preventDefault.value))return;switch(i.timeRangeSelectedHandling){case"Bind":var s=DayPilot.Util.evalVariable(i.bound);if(s){var l={};l.start=t,l.end=n,l.days=a,l.day=o,s.commandCallBack(i.command,l)}break;case"None":break;case"PostBack":i.timeRangeSelectedPostBack(t,n,o)}"function"==typeof i.onTimeRangeSelected&&i.onTimeRangeSelected(r)}else switch(i.timeRangeSelectedHandling){case"Bind":var s=DayPilot.Util.evalVariable(i.bound);if(s){var l={};l.start=t,l.end=n,l.days=a,l.day=o,s.commandCallBack(i.command,l)}break;case"JavaScript":i.onTimeRangeSelected(t,n,o);break;case"None":break;case"PostBack":i.timeRangeSelectedPostBack(t,n,o)}},this.timeRangeSelectedPostBack=function(e,t,i,n){var a={};a.start=e,a.end=t,a.day=n,this.E("TimeRangeSelected",i,a)},this.mf=function(e){i.Hf(i.skipMonths)},this.lf=function(e){i.Hf(-i.skipMonths)},this.Hf=function(e){this.startDate=this.startDate.addMonths(e),this.Ae(),this.hf(),this.zf(),this.vf(),this.Af(),this.uf()},this.xf=function(){return i.startDate.firstDayOfMonth()},this.yf=function(){return i.startDate.firstDayOfMonth().addMonths(this.showMonths)},this.visibleStart=function(){return i.startDate.firstDayOfMonth().firstDayOfWeek(o.weekStarts())},this.visibleEnd=function(){return i.startDate.firstDayOfMonth().addMonths(this.showMonths-1).firstDayOfWeek(o.weekStarts()).addDays(42)},this.Af=function(){var e=this.visibleStart(),t=this.visibleEnd();if(i.sa()){var n={};if(n.start=e,n.end=t,n.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof i.onVisibleRangeChange&&(i.onVisibleRangeChange(n),n.preventDefault.value))return;switch(this.visibleRangeChangedHandling){case"CallBack":this.visibleRangeChangedCallBack(null);break;case"PostBack":this.visibleRangeChangedPostBack(null);break;case"Disabled":}"function"==typeof i.onVisibleRangeChanged&&i.onVisibleRangeChanged(n)}else switch(this.visibleRangeChangedHandling){case"CallBack":this.visibleRangeChangedCallBack(null);break;case"PostBack":this.visibleRangeChangedPostBack(null);break;case"JavaScript":this.onVisibleRangeChanged(e,t);break;case"Disabled":}},this.visibleRangeChangedCallBack=function(e){var t={};this.G("Visible",e,t)},this.visibleRangeChangedPostBack=function(e){var t={};this.E("Visible",e,t)},this.K=function(e,t){var e=DayPilot.Util.parseJSON(e);i.items=e.Items,i.cells=e.Cells,i.cells?i.update():i.uf()},this.zf=function(){for(var e=0;e<this.showMonths;e++){var t=this.If(e);this.Be(e,t)}this.root.style.height=this.We()+"px",this.nav.preselection=document.createElement("div"),this.nav.preselection.style.position="absolute",this.nav.preselection.style.left="0px",this.nav.preselection.style.top="0px",this.root.appendChild(this.nav.preselection)},this.We=function(){if("Horizontal"===this.orientation){for(var e=0,t=0;t<this.months.length;t++){var i=this.months[t];i.height>e&&(e=i.height)}return e}for(var n=0,t=0;t<this.months.length;t++){var i=this.months[t];n+=i.height}return n},this.If=function(e){if(this.internal.showLinks)return this.internal.showLinks;var t={};return t.left=0===e,t.right=0===e,t.before=0===e,t.after=e===this.showMonths-1,"Horizontal"===this.orientation&&(t.right=e===this.showMonths-1),t},this.Lc={},this.Lc.scope=null,this.Lc.notify=function(){i.Lc.scope&&i.Lc.scope["$apply"]()},this.internal={},this.internal.initialized=function(){return i.A},this.sc={};var o=this.sc;o.locale=function(){return DayPilot.Locale.find(i.locale)},o.weekStarts=function(){if("Auto"===i.weekStarts){var e=o.locale();return e?e.weekStarts:0}return i.weekStarts},o.cellWidth=function(){if(i.t.cellWidth)return i.t.cellWidth;var e=i.hd("_cell_dimensions").width;return e||(e=i.cellWidth),i.t.cellWidth=e,e},this.clearSelection=function(){for(var e=0;e<this.selected.length;e++){var t=this.selected[e];i.tf(t.parentNode,t.x,t.y)}this.selected=[]},this.md=function(){return!!this.backendUrl&&("undefined"==typeof i.items||!i.items)},this.events={},this.ba=function(){if(DayPilot.isArray(this.events.list)){this.items={};for(var e=0;e<this.events.list.length;e++){var t=this.events.list[e],i=this.Jf(t);for(var n in i)this.items[n]=1}}},this.hd=function(e){var t=document.createElement("div");t.style.position="absolute",t.style.top="-2000px",t.style.left="-2000px",t.className=this.q(e);var n=i.root||document.body;n.appendChild(t);var a=t.offsetHeight,o=t.offsetWidth;n.removeChild(t);var r={};return r.height=a,r.width=o,r},this.Jf=function(e){for(var t=new DayPilot.Date(e.start),i=new DayPilot.Date(e.end),n={},a=t.getDatePart();a.getTime()<i.getTime();)n[a.toStringSortable()]=1,a=a.addDays(1);return n},this.show=function(){i.visible=!0,i.root.style.display=""},this.hide=function(){i.visible=!1,i.root.style.display="none"},this.nd=function(){if(this.id&&this.id.tagName)this.nav.top=this.id;else{if("string"!=typeof this.id)throw"DayPilot.Navigator() constructor requires the target element or its ID as a parameter";if(this.nav.top=document.getElementById(this.id),!this.nav.top)throw"DayPilot.Navigator: The placeholder element not found: '"+e+"'."}this.root=this.nav.top},this.init=function(){if(this.nd(),!this.root.dp){i.cssOnly||(i.cssOnly=!0,DayPilot.Util.log("DayPilot: cssOnly = false mode is not supported since DayPilot Pro 8.0.")),this.wf(),this.hf(),this.zf(),this.ba(),this.uf(),this.Q(),this.Kf(),this.Rc();this.md()&&this.Af(),this.A=!0}},this.Kf=function(){i.nav.top.onmousedown=this.Ef,i.nav.top.onmousemove=this.Ff},this.Rc=function(){DayPilot.re(document,"mouseup",i.Qd)},this.Qd=function(e){if(n.start&&n.end){var t=DayPilot.mo3(i.nav.top,e);if(t.x===n.start.coords.x&&t.y===n.start.coords.y)return n.start=null,void n.clear();n.clear();var o=n.ordered();o.start=new a(o.start).nextVisible(),o.end=new a(o.end).previousVisible(),i.selectionDay=new a(o.start).date(),i.selectionStart=i.selectionDay,i.selectionEnd=new a(o.end).date(),n.start=null,n.end=null,i.Ae(),i.hf(),i.zf(),i.uf(),i.vf();i._a({"mode":"freehand"})}n.start=null,n.end=null},this.dispose=function(){var e=i;e.root&&(e.root.removeAttribute("style"),e.root.removeAttribute("class"),e.root.dp=null,e.root.innerHTML=null,e.root=null)},this.Q=function(){this.root.dispose=this.dispose},this.Init=this.init},"undefined"!=typeof jQuery&&!function(e){e.fn.daypilotNavigator=function(e){var t=null,i=this.each(function(){if(!this.daypilot){var i=new DayPilot.Navigator(this.id);this.daypilot=i;for(var n in e)i[n]=e[n];i.Init(),t||(t=i)}});return 1===this.length?t:i}}(jQuery),function(){var e=DayPilot.am();e&&e.directive("daypilotNavigator",["$parse",function(e){return{"restrict":"E","template":"<div id='{{id}}'></div>",
"compile":function(t,i){return t.replaceWith(this["template"].replace("{{id}}",i["id"])),function(t,i,n){var a=new DayPilot.Navigator(i[0]);a.Lc.scope=t,a.init();var o=n["id"];o&&(t[o]=a);var r=n["publishAs"];if(r){(0,e(r).assign)(t,a)}for(var s in n)if(0===s.indexOf("on")){var l=DayPilot.Util.shouldApply(s);l?!function(i){a[i]=function(a){var o=e(n[i]);t["$apply"](function(){o(t,{"args":a})})}}(s):!function(i){a[i]=function(a){e(n[i])(t,{"args":a})}}(s)}var d=t["$watch"],c=n["config"]||n["daypilotConfig"],h=n["events"]||n["daypilotEvents"];d.call(t,c,function(e,t){for(var i in e)a[i]=e[i];a.update()},!0),d.call(t,h,function(e){a.events.list=e,a.ba(),a.uf()},!0)}}}}])}(),"undefined"!=typeof Sys&&Sys.Application&&Sys.Application.notifyScriptLoaded&&Sys.Application.notifyScriptLoaded()}}(),"undefined"==typeof DayPilot)var DayPilot={};if("undefined"==typeof DayPilot.Global&&(DayPilot.Global={}),function(){function e(e){for(var t=e.touches[0].clientX,i=e.touches[0].clientY,n=document.elementFromPoint(t,i);n&&n.parentNode;)if(n=n.parentNode,n.daypilotMainD)return n.calendar;return!1}function t(e){var t=e.touches[0].pageX,i=e.touches[0].pageY,n={};return n.x=t,n.y=i,n}if("undefined"==typeof DayPilot.Scheduler){var i=function(){var e=navigator.userAgent;return e.indexOf("Mozilla/5.0")>-1&&e.indexOf("Android ")>-1&&e.indexOf("AppleWebKit")>-1&&!(e.indexOf("Chrome")>-1)}(),n={},a=function(){},o=!1;DayPilot.Scheduler=function(e,o){function d(e,t){return 1-e/t}this.v="2911";var c=this;this.id=e,this.isScheduler=!0,this.hideUntilInit=!0,this.api=2,this.allowDefaultContextMenu=!1,this.allowEventOverlap=!0,this.allowMultiMove=!1,this.allowMultiRange=!1,this.allowMultiResize=!1,this.allowMultiSelect=!0,this.multiSelectRectangle="Disabled",this.autoRefreshCommand="refresh",this.autoRefreshEnabled=!1,this.autoRefreshInterval=60,this.autoRefreshMaxCount=20,this.autoScroll="Drag",this.blockOnCallBack=!1,this.navigatorBackSync=null,this.beforeCellRenderCaching=!0,"function"==typeof DayPilot.Bubble?(this.bubble=new DayPilot.Bubble,this.cellBubble=new DayPilot.Bubble,this.resourceBubble=new DayPilot.Bubble):(this.bubble=null,this.cellBubble=null,this.resourceBubble=null),this.businessBeginsHour=9,this.businessEndsHour=18,this.businessWeekends=!1,this.cellDuration=60,this.cellGroupBy="Day",this.cellStacking=!1,this.cellStackingAutoHeight=!1,this.cellWidth=40,this.cellWidthMin=1,this.cellWidthSpec="Fixed",this.cellsMarkBusiness=!0,this.eventHtmlLeftMargin=20,this.eventHtmlRightMargin=20,this.eventMarginLeft=0,this.eventMarginRight=0,this.eventMarginBottom=0,this.groupConcurrentEvents=!1,this.groupConcurrentEventsLimit=1,this.Lf=!0,this.Mf=!1,this.cellSweeping=!0,this.cellSweepingCacheSize=1e3,this.crosshairColor="Gray",this.crosshairOpacity=20,this.crosshairType="Header",this.Cd=!1,this.doubleClickTimeout=300,this.dragOutAllowed=!1,this.durationBarHeight=3,this.durationBarVisible=!0,this.durationBarMode="Duration",this.durationBarDetached=!1,this.days=1,this.drawBlankCells=!0,this.dynamicEventRendering="Progressive",this.dynamicEventRenderingMargin=50,this.dynamicEventRenderingMarginX=null,this.dynamicEventRenderingMarginY=null,this.dynamicEventRenderingCacheSweeping=!1,this.dynamicEventRenderingCacheSize=200,this.dynamicLoading=!1,this.eventBorderColor="#000000",this.eventBackColor="#FFFFFF",this.eventEditMinWidth=100,this.eventEndSpec="DateTime",this.eventFontFamily="Tahoma, Arial",this.eventFontSize="8pt",this.eventFontColor="#000000",this.eventHeight=25,this.eventMoveMargin=5,this.eventMoveToPosition=!1,this.eventMoveSkipNonBusiness=!1,this.eventResizeMargin=5,this.eventStackingLineHeight=100,this.eventTapAndHoldHandling="Move",this.eventTextWrappingEnabled=!1,this.eventUpdateInplaceOptimization=!1,this.Nf=!1,this.headerFontColor="#000000",this.headerFontFamily="Tahoma, Arial",this.headerFontSize="8pt",this.headerHeight=36,this.heightSpec="Auto",this.height=300,this.hideBorderFor100PctHeight=!1,this.hourFontFamily="Tahoma, Arial",this.hourFontSize="10pt",this.hourNameBackColor="#ECE9D8",this.hourNameBorderColor="#ACA899",this.Of=10,this.Pf=30,this.initEventEnabled=!0,this.jointEventsResize=!0,this.jointEventsMove=!0,this.layout="Auto",this.linkCreateHandling="Disabled",this.linkBottomMargin=10,this.linkPointSize=10,this.locale="en-us",this.loadingLabelText="Loading...",this.loadingLabelVisible=!0,this.overrideWheelScrolling=!1,this.messageBarPosition="Top",this.messageHideAfter=5e3,this.messageHideOnMouseOut=!0,this.multiMoveVerticalMode="Disabled",this.moveBy="Full",this.notifyCommit="Immediate",this.progressiveRowRendering=!0,this.progressiveRowRenderingPreload=25,this.tapAndHoldTimeout=300,this.timeHeaders=[{"groupBy":"Default"},{"groupBy":"Cell"}],this.treePreventParentUsage=!1,this.treeAutoExpand=!0,this.rowCreateHeight=null,this.rowCreateHtml="New row...",this.rowHeaderColumnDefaultWidth=80,this.rowHeaderHideIconEnabled=!1,this.rowHeaderWidth=80,this.rowHeaderScrolling=!1,this.rowHeaderSplitterWidth=3,this.rowHeaderWidthAutoFit=!0,this.rowHeaderWidthMarginRight=0,this.rowHeaderCols=null,this.rowMarginBottom=0,this.rowMarginTop=0,this.rowMinHeight=0,this.scale="CellDuration",this.scrollDelayDynamic=500,this.scrollDelayEvents=200,this.scrollDelayCells=0,this.scrollDelayFloats=0,this.scrollStep=null,this.scrollX=0,this.scrollY=0,this.selectedRows=[],this.showBaseTimeHeader=!0,this.showNonBusiness=!0,this.showToolTip=!0,this.snapToGrid=!0,this.startDate=DayPilot.Date.today(),this.syncResourceTree=!1,this.timeHeaderTextWrappingEnabled=!1,this.treeEnabled=!1,this.treeIndent=20,this.treeImageMarginLeft=5,this.treeImageMarginTop=5,this.timeFormat="Auto",this.useEventBoxes="Always",this.viewType="Resources",this.visible=!0,this.watchWidthChanges=!0,this.weekStarts="Auto",this.width=null,this.floatingEvents=!0,this.floatingTimeHeaders=!0,this.eventCorners="Regular",this.separators=[],this.cornerHtml="",this.Qf=!0,this.Rf=-1,this.Sf=-1,this.eventClickHandling="Enabled",this.eventDeleteHandling="Disabled",this.eventHoverHandling="Bubble",this.eventDoubleClickHandling="Disabled",this.eventEditHandling="Update",this.eventMoveHandling="Update",this.eventResizeHandling="Update",this.eventRightClickHandling="ContextMenu",this.eventSelectHandling="Update",this.resourceCollapseHandling="Enabled",this.resourceExpandHandling="Enabled",this.rowClickHandling="Enabled",this.rowDoubleClickHandling="Disabled",this.rowCreateHandling="Disabled",this.rowEditHandling="Update",this.rowHeaderColumnResizedHandling="Update",this.rowSelectHandling="Update",this.rowMoveHandling="Disabled",this.timeRangeClickHandling="Enabled",this.timeRangeDoubleClickHandling="Disabled",this.timeRangeSelectedHandling="Enabled",this.timeRangeRightClickHandling="ContextMenu",this.eventMovingStartEndEnabled=!1,this.eventMovingStartEndFormat="MMMM d, yyyy",this.timeRangeSelectingStartEndEnabled=!1,this.timeRangeSelectingStartEndFormat="MMMM d, yyyy",this.eventResizingStartEndEnabled=!1,this.eventResizingStartEndFormat="MMMM d, yyyy",this.cssOnly=!0,this.cssClassPrefix="scheduler_default",this.eventVersionsEnabled=!1,this.eventVersionHeight=25,this.eventVersionMargin=2,this.eventVersionPosition="Above",this.backendUrl=null,1===c.api&&(this.onEventMove=function(){},this.onEventResize=function(){},this.onResourceExpand=function(){},this.onResourceCollapse=function(){}),this.onEventClick=null,this.onEventClicked=null;this.onEventMove=null;this.onEventMoved=null,this.onEventMoving=null,this.onEventResize=null,this.onEventResized=null,this.onEventResizing=null,this.onEventRightClick=null,this.onEventRightClicked=null,this.onEventMouseOver=null,this.onEventMouseOut=null,this.onRowClick=null,this.onRowClicked=null,this.onTimeRangeClick=null,this.onTimeRangeClicked=null,this.onTimeRangeDoubleClick=null,this.onTimeRangeDoubleClicked=null,this.onTimeRangeSelect=null,this.onTimeRangeSelected=null,this.onTimeRangeSelecting=null,this.onTimeRangeRightClick=null,this.onTimeRangeRightClicked=null,this.onRowHeaderResized=null,this.onCellMouseOver=null,this.onCellMouseOut=null,this.onGridMouseDown=null,this.onBeforeCellRender=null,this.onBeforeEventRender=null,this.onBeforeTimeHeaderRender=null,this.onBeforeResHeaderRender=null,this.onBeforeRowHeaderRender=null,this.onBeforeCellExport=null,this.onBeforeEventExport=null,this.onBeforeTimeHeaderExport=null,this.onBeforeRowHeaderExport=null,this.onEventFilter=null,this.onRowFilter=null,this.onRectangleEventSelecting=null,this.onRectangleEventSelect=null,this.onRectangleEventSelected=null,this.onDimensionsChanged=null,this.onAfterUpdate=null,this.B=0,this.Tf=-1,this.rowlist=DayPilot.list(),this.itline=DayPilot.list(),this.timeline=null,this.events={},this.cells={},this.elements={},this.elements.events=[],this.elements.bars=[],this.elements.text=[],this.elements.cells=[],this.elements.linesVertical=[],this.elements.separators=[],this.elements.range=[],this.elements.breaks=[],this.elements.links=[],this.elements.linkpoints=[],this.elements.rectangle=[],this.elements.hover=[],this.t={},this.t.cells=[],this.t.linesVertical={},this.t.linesHorizontal={},this.t.timeHeaderGroups=[],this.t.timeHeader={},this.t.pixels=[],this.t.breaks=[],this.t.events=[],this.clientState={},this.members={},this.members.obsolete=["Init","cleanSelection","cssClassPrefix","getHScrollPosition","setHScrollPosition","getVScrollPosition","setVScrollPosition","showBaseTimeHeader"],this.members.ignoreFilter=function(e){return 0===e.indexOf("div")},this.members.ignore=["internal","nav","debug","temp","elements","members","cellProperties","itline","rowlist","timeHeader","timeouts"],this.members.noCssOnly=["eventCorners","eventFontColor","eventFontFamily","eventFontSize","headerFontColor","headerFontFamily","headerFontSize","hourFontFamily","hourFontSize","hourNameBackColor","hourNameBorderColor","loadingLabelBackColor","loadingLabelFontColor","loadingLabelFontFamily","loadingLabelFontSize","shadow","timeBreakColor"],this.nav={},this.K=function(e,t){var e=DayPilot.Util.parseJSON(e);if(c.onScrollCalled=!1,e.CallBackRedirect)return void(document.location.href=e.CallBackRedirect);if("function"==typeof c.onCallBackResult){var i={};if(i.result=e,i.preventDefault=function(){i.preventDefault.value=!0},c.onCallBackResult(i),i.preventDefault.value)return c.Va(),c.X(),c.ra(),e.Message&&c.message&&c.message(e.Message),c.Y(e.CallBackData,!0),c.Uf(),void c.Vf()}if(e.BubbleGuid){var n=e.BubbleGuid,a=this.bubbles[n];return delete this.bubbles[n],c.X(),"undefined"!=typeof e.Result.BubbleHTML&&a&&a.updateView(e.Result.BubbleHTML,a),void c.Uf()}if("undefined"!=typeof DayPilot.Bubble&&DayPilot.Bubble.hideActive(),"undefined"!=typeof e.ClientState&&(null===e.ClientState?c.clientState={}:c.clientState=e.ClientState),"None"===e.UpdateType)return c.X(),c.Uf(),e.Message&&c.message(e.Message),void c.Y(e.CallBackData,!0);if(e.VsUpdate){var o=document.createElement("input");o.type="hidden",o.name=c.id+"_vsupdate",o.id=o.name,o.value=e.VsUpdate,c.ye.innerHTML="",c.ye.appendChild(o)}"undefined"!=typeof e.TagFields&&(c.tagFields=e.TagFields),"undefined"!=typeof e.SortDirections&&(c.sortDirections=e.SortDirections),c.t.drawArea=null,"Full"===e.UpdateType&&(c.resources=e.Resources,c.colors=e.Colors,c.palette=e.Palette,c.dirtyColors=e.DirtyColors,c.cellProperties=e.CellProperties,c.cellConfig=e.CellConfig,c.separators=e.Separators,c.timeline=e.Timeline,c.timeHeader=e.TimeHeader,c.timeHeaders=e.TimeHeaders,"undefined"!=typeof e.Links&&(c.links.list=e.Links),"undefined"!=typeof e.RowHeaderColumns&&(c.rowHeaderColumns=e.RowHeaderColumns),c.startDate=e.StartDate?new DayPilot.Date(e.StartDate):c.startDate,c.days=e.Days?e.Days:c.days,c.cellDuration=e.CellDuration?e.CellDuration:c.cellDuration,c.cellGroupBy=e.CellGroupBy?e.CellGroupBy:c.cellGroupBy,c.cellWidth=e.CellWidth?e.CellWidth:c.cellWidth,"undefined"!=typeof e.Scale&&(c.scale=e.Scale),c.viewType=e.ViewType?e.ViewType:c.viewType,c.hourNameBackColor=e.HourNameBackColor?e.HourNameBackColor:c.hourNameBackColor,"undefined"!=typeof e.ShowNonBusiness&&(c.showNonBusiness=e.ShowNonBusiness),c.businessBeginsHour=e.BusinessBeginsHour?e.BusinessBeginsHour:c.businessBeginsHour,c.businessEndsHour=e.BusinessEndsHour?e.BusinessEndsHour:c.businessEndsHour,"undefined"!=typeof e.DynamicLoading&&(c.dynamicLoading=e.DynamicLoading),"undefined"!=typeof e.TreeEnabled&&(c.treeEnabled=e.TreeEnabled),c.backColor=e.BackColor?e.BackColor:c.backColor,c.nonBusinessBackColor=e.NonBusinessBackColor?e.NonBusinessBackColor:c.nonBusinessBackColor,c.locale=e.Locale?e.Locale:c.locale,"undefined"!=typeof e.TimeZone&&(c.timeZone=e.TimeZone),c.timeFormat=e.TimeFormat?e.TimeFormat:c.timeFormat,c.rowHeaderCols=e.RowHeaderCols?e.RowHeaderCols:c.rowHeaderCols,"undefined"!=typeof e.DurationBarMode&&(c.durationBarMode=e.DurationBarMode),c.cornerBackColor=e.CornerBackColor?e.CornerBackColor:c.cornerBackColor,"undefined"!=typeof e.CornerHTML&&(c.cornerHtml=e.CornerHTML),c.hashes=e.Hashes,c.Wf(),c.Xf(),c.Yf(),c.aa()),"Scroll"!==e.Action&&c.ba(e.Events),"Full"===e.UpdateType&&(c.Zf(),c.$f()),c._f(),c.na(),c.ag(),c.t.drawArea=null,"Scroll"!==e.Action?(c.bg(),c.ca(),"Auto"!==c.heightSpec&&"Max"!==c.heightSpec||c.ja(),c.cg(),c.M(),c.dg(),c.multiselect.clear(!0),c.multiselect.eg(e.SelectedEvents),c.fg(),c.gg(),c.oa()):(c.multiselect.clear(!0),c.multiselect.eg(e.SelectedEvents),c.hg(e.Events)),"HoldForever"!==c.timeRangeSelectedHandling&&c.ig(),"Full"===e.UpdateType&&(c.setScroll(e.ScrollX,e.ScrollY),c.vf()),c.jg(),c.Va(),e.SelectedRows&&c.kg(e.SelectedRows),c.X(),"Full"===e.UpdateType&&navigator.appVersion.indexOf("MSIE 7.")!==-1&&window.setTimeout(function(){c.Zf(),c.ja()},0),c.ra(),e.Message&&c.message&&c.message(e.Message),c.Y(e.CallBackData,!0),c.Uf(),c.Vf(),"Full"!==e.UpdateType||"Scroll"===e.Action||c.onScrollCalled||setTimeout(function(){c.lg()},0)},this.Va=function(){if(c.todo&&c.todo.del){var e=c.todo.del;e.parentNode.removeChild(e),c.todo.del=null}},this.Y=function(e,t){var i=function(e,t){return function(){if(c.sa()){if("function"==typeof c.onAfterRender){var i={};i.isCallBack=t,i.isScroll=!1,i.data=e,c.onAfterRender(i)}}else c.afterRender&&c.afterRender(e,t)}};window.setTimeout(i(e,t),0)},this.scrollTo=function(e,t,i){c.mg.enabled?(c.mg.scrollToRequested=e,setTimeout(function(){var e=c.mg.scrollToRequested;e&&c.ng(e,t,i)},0)):c.ng(e,t,i)},this.ng=function(e,t,i){if(e){if("Days"===c.viewType){var n=c.og(new DayPilot.Date(e));if(!n)return;return void setTimeout(function(){var e=n.top;c.nav.scroll.scrollTop=e},100)}var a;if(e instanceof DayPilot.Date)a=this.getPixels(e).left;else if("string"==typeof e)a=this.getPixels(new DayPilot.Date(e)).left;else{if("number"!=typeof e)throw"Invalid scrollTo() parameter. Accepted parameters: string (ISO date), number (pixels), DayPilot.Date object";a=e}var o=this.pg.clientWidth,r=this.nav.scroll.clientWidth;switch(i=i||"left",i.toLowerCase()){case"left":break;case"middle":a-=r/2;break;case"right":a-=r}if(a<0&&(a=0),a>o-r&&(a=o-r),!t)return void c.qg(a);var s=Math.abs(c.nav.scroll.scrollLeft-a),l=s/o,d=50;if("number"==typeof t)d=t;else if("string"==typeof t)switch(t){case"fast":d=30;break;case"normal":d=50;break;case"slow":d=100;break;case"linear":d=Math.floor(100*l)}l>.6&&(d=Math.min(d,80)),this.rg(a,d)}},this.rg=function(e,t){function i(e){var t=e.next();return"undefined"==typeof t?void(e.finished&&e.finished()):(c.setScrollX(t),window.clearTimeout(c.refreshTimeout),void setTimeout(function(){i(e)},e.delay))}var n={};n.steps=[],n.index=0,n.delay=10,n.next=function(){var e=n.steps[n.index];return n.index+=1,e},n.finished=function(){c.lg()};for(var a=c.getScrollX(),t=t||100,o=e-a,r=0;r<t;r++){var s=r/t,l=2*(s-.5)/(Math.pow(2*(s-.5),2)+1)+.5;n.steps.push(a+o*l)}n.steps.push(e),i(n)},this.scrollToResource=function(e){DayPilot.complete(function(){var t=c.sg(e);t&&setTimeout(function(){var e=t.top;c.nav.scroll.scrollTop=e},100)})},this.tg=function(){if(this.floatingTimeHeaders&&this.timeHeader){var e=this.ug();if(e){this.vg();for(var t=e.pixels.left+u.shiftX,i=e.pixels.right+u.shiftX,n=[],a=0;a<this.timeHeader.length;a++)for(var o=0;o<this.timeHeader[a].length;o++){var r=this.timeHeader[a][o],s=r.left,l=r.left+r.width,d=null;if(s<t&&t<l&&(d={},d.x=o,d.y=a,d.marginLeft=t-s,d.marginRight=0,d.div=this.t.timeHeader[o+"_"+a],n.push(d)),s<i&&i<l){d||(d={},d.x=o,d.y=a,d.marginLeft=0,d.div=this.t.timeHeader[o+"_"+a],n.push(d)),d.marginRight=l-i;break}}for(var c=0;c<n.length;c++){var d=n[c];this.wg(d.div,d.marginLeft,d.marginRight)}}}},this.jg=function(){this.tg(),this.xg()},this.yg={};var h=this.yg;h.eventsInRectangle=function(e,t,i,n){var a=e,o=e+i,r=t,s=t+n;return DayPilot.list(c.elements.events).filter(function(e){var t=e.event,i=t.part.left,n=t.part.left+t.part.width,l=c.rowlist[t.part.dayIndex],d=l.top+t.part.top,h=d+t.part.height;if(DayPilot.Util.overlaps(i,n,a,o)&&DayPilot.Util.overlaps(d,h,r,s))return!0})},h.events=function(e){var t=[],e=e||"All",i=c.ug();if(!i)return DayPilot.list(t);for(var n=i.pixels.left,a=i.pixels.right,o=0;o<c.elements.events.length;o++){var r=c.elements.events[o],s=r.event,l=s.part.left,d=s.part.left+s.part.width;switch(e){case"Left":l<n&&n<d&&t.push(r);break;case"All":DayPilot.Util.overlaps(l,d,n,a)&&t.push(r)}}return DayPilot.list(t).addProps({"area":i})},this.xg=function(){if(this.floatingEvents){var e=h.events("Left");this.zg(),e.each(function(t){var i=e.area.pixels.left,n=t.event,a=n.part.left,o=i-a;c.Ag(t,o,0)})}},this.elements.sections=[],this.elements.hsections=[],this.wg=function(e,t,i){var n=document.createElement("div");n.setAttribute("unselectable","on"),n.className=this.q("_timeheader_float"),n.style.position="absolute",n.style.left=t+"px",n.style.right=i+"px",n.style.top="0px",n.style.bottom="0px",n.style.overflow="hidden";var a=document.createElement("div");a.className=this.q("_timeheader_float_inner"),a.setAttribute("unselectable","on");var o=e.cell.th;o.innerHTML&&(a.innerHTML=o.innerHTML),o.fontColor&&(a.style.color=o.fontColor),n.appendChild(a),e.section=n,e.insertBefore(n,e.firstChild.nextSibling),e.firstChild.innerHTML="",this.elements.hsections.push(e)},this.vg=function(){for(var e=0;e<this.elements.hsections.length;e++){var t=this.elements.hsections[e],i=t.cell;i&&t.firstChild&&(t.firstChild.innerHTML=i.th.innerHTML),DayPilot.de(t.section),t.section=null}this.elements.hsections=[]},this.Ag=function(e,t,i){var n=document.createElement("div");n.setAttribute("unselectable","on"),n.className=this.q(E.eventFloat),n.style.position="absolute",n.style.left=t+"px",n.style.right=i+"px",n.style.top="0px",n.style.bottom="0px",n.style.overflow="hidden";var a=document.createElement("div");a.className=this.q(E.eventFloatInner),a.setAttribute("unselectable","on"),a.innerHTML=e.event.client.html(),e.event.data.fontColor&&(a.style.color=e.event.data.fontColor),n.appendChild(a),e.section=n,e.insertBefore(n,e.firstChild.nextSibling),e.firstChild.innerHTML="";var o={"offsetX":c.Bg(a),"eventDiv":e};DayPilot.Areas.attach(n,e.event,o),DayPilot.Areas.disable(e),this.elements.sections.push(e)},this.Cg=null,this.Bg=function(e){return null===c.Cg&&(c.Cg=parseInt(new DayPilot.StyleReader(e).get("padding-left"))),c.Cg},this.zg=function(){for(var e=0;e<this.elements.sections.length;e++){var t=this.elements.sections[e],i=t.event;i&&(t.firstChild.innerHTML=i.client.html()),DayPilot.de(t.section),DayPilot.Areas.enable(t),t.section=null}this.elements.sections=[]},this.setScrollX=function(e){c.mg.enabled?(c.mg.scrollXRequested=e,setTimeout(function(){var e=c.mg.scrollXRequested;"number"==typeof e&&c.qg(e)},0)):c.qg(e)},this.qg=function(e){var t=c.nav.scroll,i=c.Dg();t.clientWidth+e>i&&(e=i-t.clientWidth),c.divTimeScroll.scrollLeft=e,t.scrollLeft=e},this.setScrollY=function(e){c.mg.enabled?(c.mg.scrollYRequested=e,setTimeout(function(){var e=c.mg.scrollYRequested;"number"==typeof e&&c.Eg(e)},0)):c.Eg(e)},this.Eg=function(e){var t=c.nav.scroll,i=c.Tf;t.clientHeight+e>i&&(e=i-t.clientHeight),c.divResScroll.scrollTop=e,t.scrollTop=e},this.setScroll=function(e,t){c.setScrollX(e),c.setScrollY(t)},this.message=function(e,t){if(null!==e){var i={};"object"==typeof arguments[1]&&(i=arguments[1],t=i.delay);var n,t=t||this.messageHideAfter||2e3,a=this.Fg()+1,o=this.Gg()+_.splitterWidth(),r=DayPilot.sw(c.nav.scroll)+1,s=DayPilot.sh(c.nav.scroll)+1;if(this.nav.message)n=c.nav.message;else{n=document.createElement("div"),n.style.position="absolute",n.style.left=o+"px",n.style.right=r+"px",n.style.display="none",DayPilot.re(n,DayPilot.touch.start,function(e){c.nav.message.style.display="none",e.preventDefault(),e.stopPropagation()}),n.onmousemove=function(){c.messageHideOnMouseOut&&n.messageTimeout&&!n.status&&clearTimeout(n.messageTimeout)},n.onmouseout=function(){c.messageHideOnMouseOut&&"none"!==c.nav.message.style.display&&(n.messageTimeout=setTimeout(c.Ea,500))};var l=document.createElement("div");l.onclick=function(){c.nav.message.style.display="none"},l.className=this.q("_message"),n.appendChild(l);var d=document.createElement("div");d.style.position="absolute",d.className=this.q("_message_close"),d.onclick=function(){c.nav.message.style.display="none"},n.appendChild(d),this.nav.top.appendChild(n),this.nav.message=n}var h=function(){var n=c.nav.message;n.firstChild.className=c.q("_message"),i.cssClass&&DayPilot.Util.addClass(n.firstChild,i.cssClass),c.nav.message.firstChild.innerHTML=e;var o=DayPilot.sw(c.nav.scroll)+1;c.nav.message.style.right=o+"px";var r=c.messageBarPosition||"Top";"Bottom"===r?(c.nav.message.style.bottom=s+"px",c.nav.message.style.top=""):"Top"===r&&(c.nav.message.style.bottom="",c.nav.message.style.top=a+"px");var l=function(){n.messageTimeout=setTimeout(c.Ea,t)};DayPilot.fade(c.nav.message,.2,l)};clearTimeout(n.messageTimeout),"none"!==this.nav.message.style.display?DayPilot.fade(c.nav.message,-.2,h):h()}},this.Ea=function(){if(c.nav.message){var e=function(){c.nav.message.style.display="none"};DayPilot.fade(c.nav.message,-.2,e)}},this.message.show=function(e){c.message(e)},this.message.hide=function(){c.Ea()},this.Hg=null,this.ja=function(){if(this.nav.scroll){!function(){var e=c.Dg();c.pg.style.height=c.Tf+"px",c.pg.style.width=e+"px","Auto"!==c.cellWidthSpec||c.Ig?e>c.nav.scroll.clientWidth?c.nav.scroll.style.overflowX="auto":c.nav.scroll.style.overflowX="hidden":(c.nav.scroll.style.overflowX="hidden",c.nav.scroll.scrollLeft=0)}();var e=1;null!==this.Hg&&(this.nav.top.style.border=this.Hg,this.Hg=null),"Parent100Pct"!==this.heightSpec&&"Max100Pct"!==this.heightSpec||(this.nav.top.style.height="100%",this.hideBorderFor100PctHeight&&(this.Hg=this.nav.top.style.border,this.nav.top.style.border="0 none"),this.height=parseInt(this.nav.top.clientHeight,10)-this.Fg()-e),this.nav.scroll.style.height="30px";var t=this.Wb(),i=t+this.Fg()+e;t>=0&&(this.nav.scroll.style.height=t+"px",this.Jg.style.height=t+"px"),this.nav.divider&&((!i||isNaN(i)||i<0)&&(i=0),this.nav.divider.style.height=i+"px"),"Parent100Pct"!==this.heightSpec&&(this.nav.top.style.height=i+"px"),c.nav.resScrollSpace&&(c.nav.resScrollSpace.style.height=t+20+"px");for(var n=0;n<this.elements.separators.length;n++)this.elements.separators[n].style.height=this.Tf+"px";for(var n=0;n<this.elements.linesVertical.length;n++)this.elements.linesVertical[n].style.height=this.Tf+"px";c.Kg()}},this.Xf=function(){this.startDate=new DayPilot.Date(this.startDate).getDatePart(),this.t.pixels=[],this.itline=DayPilot.list();var e="Auto"===this.cellWidthSpec;if(function(){if(e){var t=0;c.r()&&c.timeline?t=c.timeline.length:"Manual"===c.scale?t=c.timeline.length:(c.Lg(),t=c.itline.length,c.itline=DayPilot.list());var i=c.Mg();if(t>0&&i>0){var n=i/t;c.cellWidth=Math.max(n,c.cellWidthMin),c.Ig=n<c.cellWidthMin}}}(),this.r()&&this.timeline){if(this.timeline){this.itline=DayPilot.list();for(var t=null,i=0,n=0;n<this.timeline.length;n++){var a=this.timeline[n],o={};if(o.start=new DayPilot.Date(a.start),o.end=a.end?new DayPilot.Date(a.end):o.start.addMinutes(this.cellDuration),a.width)o.left=a.left||i,o.width=a.width||this.cellWidth,i+=o.width;else{var r=Math.floor(i+this.cellWidth),s=r-Math.floor(i);o.left=Math.floor(i),o.width=s,i+=this.cellWidth}o.breakBefore=t&&t.ticks!==o.start.ticks,t=o.end,this.itline.push(o)}}e&&this.Ng()}else{if(this.timeHeader=[],"Manual"===this.scale){this.itline=DayPilot.list();for(var i=0,t=null,n=0;n<this.timeline.length;n++){var a=this.timeline[n],o={};if(o.start=new DayPilot.Date(a.start),o.end=a.end?new DayPilot.Date(a.end):o.start.addMinutes(this.cellDuration),t&&o.start.ticks<t.ticks)throw"The timeline must be sequential";var l=a.width||this.cellWidth,r=Math.floor(i+l),s=r-Math.floor(i);o.left=Math.floor(i),o.width=s,i+=l,o.breakBefore=t&&t.ticks!==o.start.ticks,t=o.end,this.itline.push(o)}}else this.Lg();this.Og()}},this.Pg={};var u=this.Pg;u.shiftX=0,u.active=!1,u.updateRowStarts=function(){DayPilot.list(c.rowlist).each(function(e,t){e.start=c.Ba(),e.data=null,c.Qg(t)})},u.isEnabled=function(){return c.temp.infiniteScrolling},u.shiftTo=function(e){var e=new DayPilot.Date(e),t=e.addDays(-c.Pf).getDatePart(),i=new DayPilot.Duration(t.getTime()-c.startDate.getDatePart().getTime()).totalDays();u.shiftStart(i,e)},u.shiftStart=function(e,t){var i;u.active=!0;var n=c.startDate,a=c.startDate.addDays(e);e>0&&(i=-c.getPixels(a).left),c.startDate=c.startDate.addDays(e),c.itline=DayPilot.list(),c.t.pixels=[],c.Lg(),u.updateRowStarts(),e<0&&(i=c.getPixels(n).left),c.timeHeader=[],c.Og(),c.$f(),c.cellProperties={},c.cg(),c.dg(),c.ba(),c.M(),"undefined"!=typeof t?(c.scrollTo(new DayPilot.Date(t)),c.lg()):c.nav.scroll.scrollLeft+=i,c.oa(),u.active=!1},this.Lg=function(){for(var e="Days"!==this.viewType?this.startDate.addDays(this.days):this.startDate.addDays(1),t=this.startDate,i=this.Rg(t),n=!1,a=0;i.ticks<=e.ticks&&i.ticks>t.ticks;){if(this.Sg(t,i)){var o=Math.floor(a+this.cellWidth),r=o-Math.floor(a),s={};s.start=t,s.end=i,s.left=Math.floor(a),s.width=r,s.breakBefore=n,this.itline.push(s),a+=this.cellWidth,n=!1}else n=!0;t=i,i=this.Rg(t)}},this.Ng=function(){if(this.timeHeader)for(var e=0;e<this.timeHeader.length;e++)for(var t=this.timeHeader[e],i=0;i<t.length;i++){var n=t[i];n.left=this.getPixels(new DayPilot.Date(n.start)).left;var a=this.getPixels(new DayPilot.Date(n.end)).left,o=a-n.left;n.width=o}},this.Og=function(){var e=this.timeHeaders;if(e||(e=[{"groupBy":this.cellGroupBy},{"groupBy":"Cell"}]),this.itline.isEmpty()){this.timeHeader=[];for(var t=0;t<e.length;t++)this.timeHeader[t]=[]}else for(var i=c.Tg(),t=0;t<e.length;t++){var n=e[t].groupBy,a=e[t].format;"Default"===n&&(n=this.cellGroupBy);for(var o=[],r=this.Ba();r.ticks<i.ticks;){var s={};if(s.start=r,s.end=this.Ug(s.start,n),s.start.ticks===s.end.ticks)break;s.left=this.getPixels(s.start).left;var l=this.getPixels(s.end).left,d=l-s.left;if(s.width=d,s.colspan=Math.ceil(d/(1*this.cellWidth)),"string"==typeof a?s.innerHTML=s.start.toString(a,_.locale()):s.innerHTML=this.Vg(s,n),s.text=s.innerHTML,d>0){if("function"==typeof this.onBeforeTimeHeaderRender){var h={};h.start=s.start,h.end=s.end,h.text=s.innerHTML,h.html=s.innerHTML,h.toolTip=s.innerHTML,h.backColor=null,h.fontColor=null,h.level=this.timeHeader.length,h.cssClass=null;var u={};u.header=h,this.onBeforeTimeHeaderRender(u),s.text=s.innerHTML,s.innerHTML=h.html,s.backColor=h.backColor,s.fontColor=h.fontColor,s.toolTip=h.toolTip,s.areas=h.areas,s.cssClass=h.cssClass}o.push(s)}r=s.end}this.timeHeader.push(o)}},this.Sg=function(e,t){if("function"==typeof this.onIncludeTimeCell){var i={};i.start=e,i.end=t,i.visible=!0;var n={};return n.cell=i,this.onIncludeTimeCell(n),i.visible}return!!this.showNonBusiness||this.isBusiness({"start":e,"end":t})},this.getPixels=function(e){var t=e.ticks,i=this.t.pixels[t];if(i)return i;var n=2218768416e5;if(0===this.itline.length||t<this.itline[0].start.ticks){var a={};return a.cut=!1,a.left=0,a.boxLeft=a.left,a.boxRight=a.left,a.i=null,a}for(var o=this.Wg(e),r=Math.max(o.i-1,0),s=r;s<this.itline.length;s++){var l=this.itline[s],d=l.start.ticks,c=l.end.ticks;if(d<t&&t<c){var h=t-d,a={};a.cut=!1,a.left=l.left+this.fd(l,h),a.boxLeft=l.left,a.boxRight=l.left+l.width,a.i=s;break}if(d===t){var a={};a.cut=!1,a.left=l.left,a.boxLeft=a.left,a.boxRight=a.left+l.width,a.i=s;break}if(c===t){var a={};a.cut=!1,a.left=l.left+l.width,a.boxLeft=a.left,a.boxRight=a.left,a.i=s+1;break}if(t<d&&t>n){var a={};a.cut=!0,a.left=l.left,a.boxLeft=a.left,a.boxRight=a.left,a.i=s;break}n=c}if(!a){var u=this.itline[this.itline.length-1],a={};a.cut=!0,a.left=u.left+u.width,a.boxLeft=a.left,a.boxRight=a.left,a.i=null}return this.t.pixels[t]=a,a},this.getDate=function(e,t,i){var n=this.Xg(e,i);if(!n)return null;var a=n.x,o=this.itline[a];if(!o)return null;var r=i&&!t?o.end:o.start;return t?r.addTime(this.Yg(n.cell,n.offset)):r},this.Xg=function(e,t){if(0===this.itline.length)return null;for(var i=0,n=0,a=0;a<this.itline.length;a++){var o=this.itline[a];if(i+=o.width||this.cellWidth,e<i||t&&e===i){var r={};return r.x=a,r.offset=e-n,r.cell=o,r}n=i}var o=c.itline.last(),r={};return r.x=this.itline.length-1,r.offset=o.width||this.cellWidth,r.cell=o,r},this.Zg=function(e){return this.Wg(e)},this.$g=function(e){for(var t=new DayPilot.Date(e),i=0;i<this.itline.length;i++){var n=this.itline[i];if(n.start.ticks<=t.ticks&&t.ticks<n.end.ticks){var a={};return a.hidden=!1,a.current=n,a}if(t.ticks<n.start.ticks){var a={};return a.hidden=!0,a.previous=i>0?this.itline[i-1]:null,a.current=null,a.next=this.itline[i],a}}var a={};return a.past=!0,a.previous=this.itline[this.itline.length-1],a},this.Wg=function(e){var t=new DayPilot.Date(e),i=0,n=this.itline[0];if(t.ticks<n.start.ticks){var a={};return a.hidden=!0,a.previous=null,a.current=null,a.next=this.itline[0],a.i=-1,a}var o=this.itline.length-1,r=this.itline[o];if(t.ticks>r.end.ticks){var a={};return a.past=!0,a.previous=this.itline[this.itline.length-1],a.i=this.itline.length,a}if(t.ticks===r.end.ticks){var a={};return a.past=!1,a.current=this.itline[this.itline.length-1],a.i=this.itline.length-1,a}for(var s=function(){for(var e,n=c.itline;i<=o;)if(e=Math.floor((i+o)/2),n[e].start.ticks>t.ticks)o=e-1;else{if(!(n[e].end.ticks<t.ticks))return e;i=e+1}return i}(),l=s;l<this.itline.length;l++){var d=this.itline[l];if(d.start.ticks<=t.ticks&&t.ticks<d.end.ticks){var a={};return a.hidden=!1,a.current=d,a.i=l,a}if(t.ticks<d.start.ticks){var a={};return a.hidden=!0,a.previous=l>0?this.itline[l-1]:null,a.current=null,a.next=this.itline[l],a.i=l,a}}var a={};return a.past=!0,a.previous=this.itline[this.itline.length-1],a.i=this.itline.length,a},this.fd=function(e,t){var i=e.width||this.cellWidth,n=e.end.ticks-e.start.ticks;return Math.floor(i*t/n)},this.Yg=function(e,t){var i=e.end.ticks-e.start.ticks,n=e.width||this.cellWidth;return Math.floor(t/n*i)},this.Oe=function(e){T.start||n.preventEventClick||(A={},c.Ga(this,e))},this.eventClickPostBack=function(e,t){this.E("EventClick",e,t)},this.eventClickCallBack=function(e,t){this.G("EventClick",e,t)},this.Ga=function(e,t){var i=e.event;if(i){var t=t||window.event;if("undefined"!=typeof DayPilot.Bubble&&DayPilot.Bubble.hideActive(),!i.client.doubleClickEnabled())return void c.Ha(e,t);c.timeouts.click||(c.timeouts.click=[]);var n=function(e,t){return function(){c.Ha(e,t)}};c.timeouts.click.push(window.setTimeout(n(e,t),c.doubleClickTimeout))}},this._g=function(e){return c.itline[e]},this.Ha=function(e,t){if("boolean"==typeof t)throw"Invalid _eventClickSingle parameters";var i=e.event,n=t.ctrlKey,a=t.metaKey;if(i.client.clickEnabled())if(c.sa()){var o={};if(o.e=i,o.div=e,o.originalEvent=t,o.ctrl=n,o.meta=a,o.shift=t.shiftKey,o.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof c.onEventClick&&(c.onEventClick(o),o.preventDefault.value))return;switch(c.eventClickHandling){case"PostBack":c.eventClickPostBack(i);break;case"CallBack":c.eventClickCallBack(i);break;case"Edit":c.Ia(e);break;case"Select":c.Ja(e,i,n,a);break;case"ContextMenu":var r=i.client.contextMenu();r?r.show(i):c.contextMenu&&c.contextMenu.show(i);break;case"Bubble":c.bubble&&c.bubble.showEvent(i);break;case"RectangleSelect":
if("Disabled"!==c.multiSelectRectangle)return M.start(),!1}"function"==typeof c.onEventClicked&&c.onEventClicked(o)}else switch(c.eventClickHandling){case"PostBack":c.eventClickPostBack(i);break;case"CallBack":c.eventClickCallBack(i);break;case"JavaScript":c.onEventClick(i);break;case"Edit":c.Ia(e);break;case"Select":c.Ja(e,i,n,a);break;case"ContextMenu":var r=i.client.contextMenu();r?r.show(i):c.contextMenu&&c.contextMenu.show(i);break;case"Bubble":c.bubble&&c.bubble.showEvent(i);break;case"RectangleSelect":if("Disabled"!==c.multiSelectRectangle)return M.start(),!1}},this.Pa=function(e){if(c.sa()){var t={};if(t.e=e,t.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof c.onEventDelete&&(c.onEventDelete(t),t.preventDefault.value))return;switch(c.eventDeleteHandling){case"PostBack":c.eventDeletePostBack(e);break;case"CallBack":c.eventDeleteCallBack(e);break;case"Update":c.events.remove(e)}"function"==typeof c.onEventDeleted&&c.onEventDeleted(t)}else switch(c.eventDeleteHandling){case"PostBack":c.eventDeletePostBack(e);break;case"CallBack":c.eventDeleteCallBack(e);break;case"JavaScript":c.onEventDelete(e)}},this.eventDeletePostBack=function(e,t){this.E("EventDelete",e,t)},this.eventDeleteCallBack=function(e,t){this.G("EventDelete",e,t)},this.setHScrollPosition=function(e){this.nav.scroll.scrollLeft=e},this.getScrollX=function(){return this.nav.scroll.scrollLeft},this.getHScrollPosition=this.getScrollX,this.getScrollY=function(){return this.nav.scroll.scrollTop},this.Ja=function(e,t,i,n){c.cb(e,t,i,n)},this.eventSelectPostBack=function(e,t,i){var n={};n.e=e,n.change=t,this.E("EventSelect",n,i)},this.eventSelectCallBack=function(e,t,i){var n={};n.e=e,n.change=t,this.G("EventSelect",n,i)},this.cb=function(e,t,i,n){var a=c.multiselect,o=a.isSelected(t);if(i||n||!o||1!==a.list.length)if(c.sa()){a.previous=a.events();var r={};if(r.e=t,r.selected=o,r.ctrl=i,r.meta=n,r.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof c.onEventSelect&&(c.onEventSelect(r),r.preventDefault.value))return;switch(c.eventSelectHandling){case"PostBack":c.eventSelectPostBack(t,s);break;case"CallBack":"undefined"!=typeof WebForm_InitCallback&&(window.eb="",window.fb=[],WebForm_InitCallback()),c.eventSelectCallBack(t,s);break;case"Update":a.gb(e,i,n)}"function"==typeof c.onEventSelected&&(r.change=a.isSelected(t)?"selected":"deselected",r.selected=a.isSelected(t),c.onEventSelected(r))}else{a.previous=a.events(),a.gb(e,i,n);var s=a.isSelected(t)?"selected":"deselected";switch(c.eventSelectHandling){case"PostBack":c.eventSelectPostBack(t,s);break;case"CallBack":"undefined"!=typeof WebForm_InitCallback&&(window.eb="",window.fb=[],WebForm_InitCallback()),c.eventSelectCallBack(t,s);break;case"JavaScript":c.onEventSelect(t,s)}}},this.eventRightClickPostBack=function(e,t){this.E("EventRightClick",e,t)},this.eventRightClickCallBack=function(e,t){this.G("EventRightClick",e,t)},this.La=function(e){var t=this.event;if(e=e||window.event,e.cancelBubble=!0,!this.event.client.rightClickEnabled())return!1;if(c.sa()){var i={};if(i.e=t,i.div=this,i.originalEvent=e,i.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof c.onEventRightClick&&(c.onEventRightClick(i),i.preventDefault.value))return!1;switch(c.eventRightClickHandling){case"PostBack":c.eventRightClickPostBack(t);break;case"CallBack":c.eventRightClickCallBack(t);break;case"ContextMenu":var n=t.client.contextMenu();n?n.show(t):c.contextMenu&&c.contextMenu.show(this.event);break;case"Bubble":c.bubble&&c.bubble.showEvent(t)}"function"==typeof c.onEventRightClicked&&c.onEventRightClicked(i)}else switch(c.eventRightClickHandling){case"PostBack":c.eventRightClickPostBack(t);break;case"CallBack":c.eventRightClickCallBack(t);break;case"JavaScript":c.onEventRightClick(t);break;case"ContextMenu":var n=t.client.contextMenu();n?n.show(t):c.contextMenu&&c.contextMenu.show(this.event);break;case"Bubble":c.bubble&&c.bubble.showEvent(t)}return!1},this.eventDoubleClickPostBack=function(e,t){this.E("EventDoubleClick",e,t)},this.eventDoubleClickCallBack=function(e,t){this.G("EventDoubleClick",e,t)},this.Ka=function(e){if("undefined"!=typeof DayPilot.Bubble&&DayPilot.Bubble.hideActive(),c.timeouts.click){for(var t in c.timeouts.click)window.clearTimeout(c.timeouts.click[t]);c.timeouts.click=null}var e=e||window.event,i=this.event;if(e.stopPropagation&&e.stopPropagation(),e.cancelBubble=!0,c.sa()){var n={};if(n.e=i,n.originalEvent=e,n.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof c.onEventDoubleClick&&(c.onEventDoubleClick(n),n.preventDefault.value))return;switch(c.eventDoubleClickHandling){case"PostBack":c.eventDoubleClickPostBack(i);break;case"CallBack":c.eventDoubleClickCallBack(i);break;case"Edit":c.Ia(this);break;case"Select":c.Ja(div,i,e.ctrlKey,e.metaKey);break;case"Bubble":c.bubble&&c.bubble.showEvent(i);break;case"ContextMenu":var a=i.client.contextMenu();a?a.show(i):c.contextMenu&&c.contextMenu.show(i)}"function"==typeof c.onEventDoubleClicked&&c.onEventDoubleClicked(n)}else switch(c.eventDoubleClickHandling){case"PostBack":c.eventDoubleClickPostBack(i);break;case"CallBack":c.eventDoubleClickCallBack(i);break;case"JavaScript":c.onEventDoubleClick(i);break;case"Edit":c.Ia(this);break;case"Select":c.Ja(div,i,e.ctrlKey,e.metaKey);break;case"Bubble":c.bubble&&c.bubble.showEvent(i);break;case"ContextMenu":var a=i.client.contextMenu();a?a.show(i):c.contextMenu&&c.contextMenu.show(i)}},this.eventResizePostBack=function(e,t,i,n){this.Ta("PostBack",e,t,i,n)},this.eventResizeCallBack=function(e,t,i,n){this.Ta("CallBack",e,t,i,n)},this.Ta=function(e,t,i,n,a){var o={};o.e=t,o.newStart=i,o.newEnd=n,this.Qa(e,"EventResize",o,a)},this.Sa=function(e,t,i){if("Disabled"!==this.eventResizeHandling)if(i=c.df(i),c.sa()){var n={},a=function(){if(P.hide(),!n.preventDefault.value){switch(t=n.newStart,i=n.newEnd,c.eventResizeHandling){case"PostBack":c.eventResizePostBack(e,t,i);break;case"CallBack":c.eventResizeCallBack(e,t,i);break;case"Notify":c.eventResizeNotify(e,t,i);break;case"Update":c.ah(n)}"function"==typeof c.onEventResized&&c.onEventResized(n)}};n.e=e,n.async=!1,n.loaded=function(){a()},n.newStart=t,n.newEnd=i,n.preventDefault=function(){this.preventDefault.value=!0},n.multiresize=DayPilot.list(b.list);var o={};o.event=e,o.start=t,o.end=i,n.multiresize.splice(0,0,o),"function"==typeof c.onEventResize&&c.onEventResize(n),n.async?c.blockOnCallBack&&P.show():a()}else switch(c.eventResizeHandling){case"PostBack":c.eventResizePostBack(e,t,i);break;case"CallBack":c.eventResizeCallBack(e,t,i);break;case"JavaScript":c.onEventResize(e,t,i);break;case"Notify":c.eventResizeNotify(e,t,i);break;case"Update":c.ah(n)}},this.eventMovePostBack=function(e,t,i,n,a,o){this.Wa("PostBack",e,t,i,n,a,o)},this.eventMoveCallBack=function(e,t,i,n,a,o){this.Wa("CallBack",e,t,i,n,a,o)},this.Wa=function(e,t,i,n,a,o,r){var s=t&&!!t.preventDefault,l={};if(s){var d=t;l.e=d.e,l.newStart=d.newStart,l.newEnd=d.newEnd,l.newResource=d.newResource,l.position=d.position,l.multimove=[],d.multimove.each(function(e){var t={};if(t.e=e.event,t.newStart=e.start,t.newEnd=e.end,t.newResource=e.event.resource(),t.e===d.e||t.e.data.id==d.e.data.id)t.newResource=d.newResource;else if(w.rowoffset){var i=e.event.part.dayIndex+w.rowoffset;t.newResource=c.rowlist[i].id}l.multimove.push(t)})}else l.e=t,l.newStart=i,l.newEnd=n,l.newResource=a,l.position=r;this.Qa(e,"EventMove",l,o)},this.bh=function(e,t,i){var n={};n.start=t.start,n.end=t.end,n.resource=t.resource,n.multirange=[],t.multirange.each(function(e){var t={};t.start=e.start,t.end=e.end,t.resource=e.resource,n.multirange.push(t)}),this.Qa(e,"TimeRangeSelected",n,i)},this.Qa=function(e,t,i,n){if("PostBack"===e)c.E(t,i,n);else if("CallBack"===e)c.G(t,i,n,"CallBack");else if("Immediate"===e)c.G(t,i,n,"Notify");else if("Queue"===e)c.queue.add(new DayPilot.Action(this,t,i,n));else{if("Notify"!==e)throw"Invalid event invocation type";"Notify"===_.notifyType()?c.G(t,i,n,"Notify"):c.queue.add(new DayPilot.Action(c,t,i,n))}},this.eventMoveNotify=function(e,t,i,n,a,o){if(e&&!!e.preventDefault){var r=e;r.old=new DayPilot.Event(r.e.copy(),c),r.multimove.each(function(e){e.old=new DayPilot.Event(e.event.copy(),c)}),c.ah(r),r.e=r.old,delete r.old,r.multimove.each(function(e){e.event=e.old,delete e.old})}else{e=new DayPilot.Event(e.copy(),c);var s=c.events.ch(e.data);e.start(t),e.end(i),e.resource(n),e.commit(),s=s.concat(c.events.dh(e.data)),c.eh(s),c.fh(),c.gh(s)}this.Wa("Notify",e,t,i,n,a,o)},this.eventResizeNotify=function(e,t,i,n){var a=new DayPilot.Event(e.copy(),this),o=c.events.ch(e.data);e.start(t),e.end(i),e.commit(),o=o.concat(c.events.dh(e.data)),c.eh(o),c.fh(),c.gh(o),this.Ta("Notify",a,t,i,n)},this.multiselect={},this.multiselect.list=[],this.multiselect.divs=[],this.multiselect.previous=[],this.multiselect.eg=function(e){c.multiselect.list=DayPilot.list(e).map(function(e){return new DayPilot.Event(e,c)})},this.multiselect.vb=function(){var e=c.multiselect;return DayPilot.JSON.stringify(e.events())},this.multiselect.events=function(){var e=c.multiselect,t=DayPilot.list();t.ignoreToJSON=!0;for(var i=0;i<e.list.length;i++)t.push(e.list[i]);return t},this.multiselect.wb=function(){},this.multiselect.gb=function(e,t,i){var n=c.multiselect;if(n.isSelected(e.event))if(c.allowMultiSelect)if(t||i)n.remove(e.event,!0);else{var a=n.list.length;n.clear(),a>1&&n.add(e.event,!0)}else n.clear();else c.allowMultiSelect&&(t||i)?n.add(e.event,!0):(n.clear(),n.add(e.event,!0));n.cd(e),n.wb()},this.multiselect.xb=function(e){var t=c.multiselect;return t.yb(e,t.initList)},this.multiselect.zb=function(){for(var e=c.multiselect,t=[],i=0;i<e.list.length;i++){var n=e.list[i];t.push(n.value())}alert(t.join("\n"))},this.multiselect.add=function(e,t){var i=c.multiselect;i.indexOf(e)===-1&&i.list.push(e),t||i.hh(e)},this.multiselect.remove=function(e,t){var i=c.multiselect,n=i.indexOf(e);n!==-1&&i.list.splice(n,1),t||i.hh(e)},this.multiselect.clear=function(e){var t=c.multiselect;t.list=[],e||t.redraw()},this.multiselect.redraw=function(){var e=c.multiselect;e.divs=[];for(var t=0;t<c.elements.events.length;t++){var i=c.elements.events[t];i.event&&i.event.isEvent&&(e.isSelected(i.event)?e.Bb(i):e.Cb(i))}},this.multiselect.cd=function(e){if(e){var t=c.multiselect;t.isSelected(e.event)?t.Bb(e):t.Cb(e)}},this.multiselect.hh=function(e){var t=c.multiselect,i=c.bd(e);t.cd(i)},this.multiselect.Bb=function(e){var t=c.multiselect,i=c.q("_selected"),e=t.Db(e);DayPilot.Util.addClass(e,i),t.divs.push(e)},this.multiselect.Db=function(e){return e},this.multiselect.Fb=function(){for(var e=c.multiselect,t=0;t<e.divs.length;t++){var i=e.divs[t];e.Cb(i,!0)}e.divs=[]},this.multiselect.Cb=function(e,t){var i=c.multiselect,n=c.q("_selected");if(DayPilot.Util.removeClass(e,n),!t){var a=DayPilot.indexOf(i.divs,e);a!==-1&&i.divs.splice(a,1)}},this.multiselect.isSelected=function(e){return!!e&&(!!e.isEvent&&c.multiselect.yb(e,c.multiselect.list))},this.multiselect.indexOf=function(e){for(var t=e.data,i=0;i<c.multiselect.list.length;i++){if(c.multiselect.list[i].data===t)return i}return-1},this.multiselect.yb=function(e,t){if(!t)return!1;for(var i=0;i<t.length;i++){var n=t[i];if(e===n)return!0;if("function"==typeof n.id){if(null!==n.id()&&null!==e.id()&&n.id()===e.id())return!0;if(null===n.id()&&null===e.id()&&n.recurrentMasterId()===e.recurrentMasterId()&&e.start().toStringSortable()===n.start().toStringSortable())return!0}else{if(null!==n.id&&null!==e.id()&&n.id===e.id())return!0;if(null===n.id&&null===e.id()&&n.recurrentMasterId===e.recurrentMasterId()&&e.start().toStringSortable()===n.start)return!0}}return!1},this.multiselect.startRectangle=function(){M.start()},this.ih=function(){this.dg(),this.gg()},this.jh=function(){c.Zf(),c.bg(),c.kh(),c.progressiveRowRendering&&c.lh()},this.cd=function(e){var e=e||{},t=!e.eventsOnly;c.cssOnly||(c.cssOnly=!0,DayPilot.Util.log("DayPilot: cssOnly = false mode is not supported since DayPilot Pro 8.0.")),t&&(this.r()||(c.timeHeader=null,c.cellProperties={}),c.mh={},c.Wf(),c.Xf(),e&&e.dontLoadResources||c.Yf(),c.events.nh(),c.sc.clearCache()),this.ba(),this.oh(),c.Zf(),t&&(c.ed(),c.ph(),c.$f(),c.kg(c.selectedRows),c.qh()),c._f(),c.bg(),c.kh(),c.ca(),v.hideLinkpoints(),this.M(),this.cg(),this.Vf(),this.aa(),this.fg(),this.ih(),c.ja(),e.immediateEvents||e.eventsOnly?c.oa():setTimeout(function(){c.oa()},100),this.visible?c.Qf!=c.visible&&this.show():this.hide(),this.Qf=this.visible,this.jg(),this.lg(),this.rh(),this.ra()},this.rh=function(){if("function"==typeof c.onAfterUpdate){var e={};c.onAfterUpdate(e)}},this.update=function(e){if(c.Cd)throw"You are trying to update a DayPilot.Scheduler object that has been disposed already. Calling .dispose() destroys the object and makes it unusable.";f.request(e)};var f={};f.timeout=null,f.options=null,f.enabled=!1,f.request=function(e){f.enabled?(clearTimeout(f.timeout),f.mergeOptions(e),f.timeout=setTimeout(f.doit)):(f.mergeOptions(e),f.doit())},f.mergeOptions=function(e){if(e){f.options||(f.options={});for(var t in e)f.options[t]=e[t]}},f.doit=function(){var e=f.options;return f.options=null,e?(e.events?(c.events.list=e.events,c.A&&c.cd({"eventsOnly":!0})):e.separators?(c.separators=e.separators,c.A&&c.ih()):e.rowHeaderColumns&&(c.rowHeaderColumns=e.rowHeaderColumns,c.A&&c.jh()),void c.Y(null,!1)):void(c.A&&(c.cd({"immediateEvents":!0}),c.Y(null,!1)))},this.gh=function(e,t,i){e=DayPilot.ua(e);for(var n=0;n<e.length;n++){var a=e[n];c.uh(a)}if(this.vh){this._f(),this.bg(),this.cg(),this.dg();for(var n=0;n<e.length;n++){var a=e[n];this.wh(a)}for(var n=0;n<e.length;n++){var a=e[n];this.xh(a)}this.fg(),this.gg(),this.yh()}else{for(var n=0;n<e.length;n++){var a=e[n];t||this.wh(a),this.xh(a)}DayPilot.list(e).each(function(e){c.zh(e)}),c.fg()}c.xg(),v.load(),c.multiselect.redraw(),i&&i(),this.Vf()},this.df=function(e){return"DateTime"===c.eventEndSpec?e:e.getDatePart().ticks===e.ticks?e.addDays(-1):e.getDatePart()},this.Ee=function(e){return"DateTime"===c.eventEndSpec?e:e.getDatePart().addDays(1)},this.gf=function(e){return"DateTime"===c.eventEndSpec?e:e.getDatePart()},this.Ua=function(e,t,i,n,a,o,r){if(c.Ah=null,"Disabled"!==c.eventMoveHandling){i=c.df(i);var s={};s.e=e,s.newStart=t,s.newEnd=i,s.newResource=n,s.external=a,s.ctrl=!1,s.meta=!1,s.shift=!1,o&&(s.shift=o.shiftKey,s.ctrl=o.ctrlKey,s.meta=o.metaKey),s.multimove=DayPilot.list(w.list);var l={};if(l.event=e,l.start=t,l.end=i,l.overlapping=!1,l.resource=n,s.multimove.splice(0,0,l),s.position=r,s.preventDefault=function(){this.preventDefault.value=!0},c.sa()){var d=function(){if(P.hide(),s.preventDefault.value)return void c.Bh();switch(t=s.newStart,i=s.newEnd,c.eventMoveHandling){case"PostBack":c.eventMovePostBack(s);break;case"CallBack":c.eventMoveCallBack(s);break;case"Notify":c.eventMoveNotify(s);break;case"Update":c.ah(s)}c.Bh(),"function"==typeof c.onEventMoved&&c.onEventMoved(s)};s.async=!1,s.loaded=function(){d()},"function"==typeof c.onEventMove&&c.onEventMove(s),s.async?c.blockOnCallBack&&P.show():d()}else{switch(c.eventMoveHandling){case"PostBack":c.eventMovePostBack(s);break;case"CallBack":c.eventMoveCallBack(s);break;case"JavaScript":c.onEventMove(e,t,i,n,a,!!o&&o.ctrlKey,!!o&&o.shiftKey,r);break;case"Notify":c.eventMoveNotify(s);break;case"Update":c.ah(s)}c.Bh()}}},this.ah=function(e){var t=e.e,i=e.newStart,n=e.newEnd,a=e.newResource,o=e.external;t.start(i),t.end(n),t.resource(a),o?(t.commit(),c.events.add(t)):c.events.update(t),e.multimove&&!e.multimove.isEmpty()&&e.multimove.each(function(e){if(e.event!==t){if(e.event.start(e.start),e.event.end(e.end),w.rowoffset){var i=e.event.part.dayIndex+w.rowoffset,n=c.rowlist[i].id;e.event.resource(n)}e.event.commit(),c.events.update(e.event)}}),e.multiresize&&!e.multiresize.isEmpty()&&e.multiresize.each(function(e){e.event!==t&&(e.event.start(e.start),e.event.end(e.end),e.event.commit(),c.events.update(e.event))}),c.events.immediateRefresh(),c.Va()},this.Xa=function(e,t){var i=c.Ya(t),n={};n.args=e,n.guid=i,c.G("Bubble",n)},this.Ya=function(e){var t=DayPilot.guid();return this.bubbles||(this.bubbles=[]),this.bubbles[t]=e,t},this.eventMenuClickPostBack=function(e,t,i){var n={};n.e=e,n.command=t,this.E("EventMenuClick",n,i)},this.eventMenuClickCallBack=function(e,t,i){var n={};n.e=e,n.command=t,this.G("EventMenuClick",n,i)},this.Za=function(e,t,i){switch(i){case"PostBack":c.eventMenuClickPostBack(t,e);break;case"CallBack":c.eventMenuClickCallBack(t,e)}},this.timeRangeSelectedPostBack=function(e,t,i,n){var a={};a.start=e,a.end=t,a.resource=i,this.E("TimeRangeSelected",a,n)},this.timeRangeSelectedCallBack=function(e,t,i,n){var a={};a.start=e,a.end=t,a.resource=i,this.G("TimeRangeSelected",a,n)},this.Ch=function(e){if(e){if(e.disabled)return void c.clearSelection();var t=c.Dh(e);t&&c._a(t.start,t.end,t.resource)}},this._a=function(e,t,i){if("Disabled"!==c.timeRangeSelectedHandling){var n=t;t=c.df(n);var a={};if(a.control=c,a.start=e,a.end=t,a.resource=i,a.preventDefault=function(){this.preventDefault.value=!0},a.multirange=DayPilot.list(H.list).map(function(e){return c.Dh(e)}),a.multirange.isEmpty()&&a.multirange.push({"start":a.start,"end":a.end,"resource":a.resource}),c.sa()){if("function"==typeof c.onTimeRangeSelect){if(c.onTimeRangeSelect(a),a.preventDefault.value)return;e=a.start,t=a.end}switch(c.Eh(c.rangeHold,e,t,a.multirange),c.Fh(c.rangeHold),c.timeRangeSelectedHandling){case"PostBack":c.bh("PostBack",a);break;case"CallBack":c.bh("CallBack",a)}"function"==typeof c.onTimeRangeSelected&&c.onTimeRangeSelected(a)}else switch(c.timeRangeSelectedHandling){case"PostBack":c.bh("PostBack",a);break;case"CallBack":c.bh("CallBack",a);break;case"JavaScript":c.onTimeRangeSelected(e,t,i,a.multirange);break;case"Hold":}}},this.Eh=function(e,t,i,n){if(e&&!(n&&n.length>1)){var a,o,r=c.Ee(i),s=0;if("Days"===c.viewType){s=c.og(t).start.getTime()-c.Ba().getTime()}t.getTime()<c.itline[0].start.getTime()?e.start.x=0:(a=c.Zg(t.addTime(-s)),o=a.current||a.previous,e.start.x=DayPilot.indexOf(c.itline,o)),a=c.Zg(r.addSeconds(-1).addTime(-s)),a.past?e.end.x=c.itline.length-1:(o=a.current||a.next,e.end.x=DayPilot.indexOf(c.itline,o))}},this.og=function(e){var t=e.getDatePart();return DayPilot.list(c.rowlist).find(function(e){return e.start.getDatePart()===t})},this.timeRangeDoubleClickPostBack=function(e,t,i,n){var a={};a.start=e,a.end=t,a.resource=i,this.E("TimeRangeDoubleClick",a,n)},this.timeRangeDoubleClickCallBack=function(e,t,i,n){var a={};a.start=e,a.end=t,a.resource=i,this.G("TimeRangeDoubleClick",a,n)},this.ab=function(e,t,i){if(t=c.df(t),c.sa()){var n={};if(n.start=e,n.end=t,n.resource=i,n.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof c.onTimeRangeDoubleClick&&(c.onTimeRangeDoubleClick(n),n.preventDefault.value))return;switch(c.timeRangeDoubleClickHandling){case"PostBack":c.timeRangeDoubleClickPostBack(e,t,i);break;case"CallBack":c.timeRangeDoubleClickCallBack(e,t,i)}"function"==typeof c.onTimeRangeDoubleClicked&&c.onTimeRangeDoubleClicked(n)}else switch(c.timeRangeDoubleClickHandling){case"PostBack":c.timeRangeDoubleClickPostBack(e,t,i);break;case"CallBack":c.timeRangeDoubleClickCallBack(e,t,i);break;case"JavaScript":c.onTimeRangeDoubleClick(e,t,i)}},this.timeRangeMenuClickPostBack=function(e,t,i){var n={};n.selection=e,n.command=t,this.E("TimeRangeMenuClick",n,i)},this.timeRangeMenuClickCallBack=function(e,t,i){var n={};n.selection=e,n.command=t,this.G("TimeRangeMenuClick",n,i)},this.$a=function(e,t,i){switch(i){case"PostBack":c.timeRangeMenuClickPostBack(t,e);break;case"CallBack":c.timeRangeMenuClickCallBack(t,e)}},this.linkMenuClickPostBack=function(e,t,i){var n={};n.link=e,n.command=t,this.E("LinkMenuClick",n,i)},this.linkMenuClickCallBack=function(e,t,i){var n={};n.link=e,n.command=t,this.G("LinkMenuClick",n,i)},this.Gh=function(e,t,i){switch(i){case"PostBack":c.linkMenuClickPostBack(t,e);break;case"CallBack":c.linkMenuClickCallBack(t,e)}},this.rowMenuClickPostBack=function(e,t,i){var n={};n.resource=e,n.command=t,this.E("RowMenuClick",n,i)},this.resourceHeaderMenuClickPostBack=this.rowMenuClickPostBack,this.rowMenuClickCallBack=function(e,t,i){var n={};n.resource=e,n.command=t,this.G("RowMenuClick",n,i)},this.resourceHeaderMenuClickCallBack=this.rowMenuClickCallBack,this.Hh=function(e,t,i){switch(i){case"PostBack":c.rowMenuClickPostBack(t,e);break;case"CallBack":c.rowMenuClickCallBack(t,e)}},this.Ih=function(e,t){var i=c.Jh(e);i.data.name=t,i.data.html&&(i.data.html=t),c.rows.update(i)},this.Kh=function(e,t){if(t){var i={};if(i.text=t,i.preventDefault=function(){this.preventDefault.value=!0},"function"!=typeof c.onRowCreate||(c.onRowCreate(i),!i.preventDefault.value)){switch(c.rowCreateHandling){case"CallBack":c.rowCreateCallBack(i.text);break;case"PostBack":c.rowCreatePostBack(i.text)}"function"==typeof c.onRowCreated&&c.onRowCreated(i)}}},this.Lh=function(e,t,i){if(e.isNewRow)return void(i||c.Kh(e,t));var n=DayPilot.indexOf(c.rowlist,e),a=c.Jh(e,n);if(c.sa()){var o={};if(o.resource=a,o.row=a,o.newText=t,o.canceled=i,o.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof c.onRowEdit&&(c.onRowEdit(o),o.preventDefault.value))return;if(!i){switch(c.rowEditHandling){case"PostBack":c.rowEditPostBack(a,t);break;case"CallBack":c.rowEditCallBack(a,t);break;case"Update":c.Ih(e,t)}"function"==typeof c.onRowEdited&&c.onRowEdited(o)}}else switch(c.rowEditHandling){case"PostBack":c.rowEditPostBack(a,t);break;case"CallBack":c.rowEditCallBack(a,t);break;case"JavaScript":c.onrowEdit(a,t)}},this.rowCreatePostBack=function(e,t){var i={};i.text=e,this.E("RowCreate",i,t)},this.rowCreateCallBack=function(e,t){var i={};i.text=e,this.G("RowCreate",i,t)},this.rowEditPostBack=function(e,t,i){var n={};n.resource=e,n.newText=t,this.E("RowEdit",n,i)},this.rowEditCallBack=function(e,t,i){var n={};n.resource=e,n.newText=t,this.G("RowEdit",n,i)},this.rowMovePostBack=function(e,t,i,n){var a={};a.source=e,a.target=t,a.position=i,this.E("RowMove",a,n)},this.rowMoveCallBack=function(e,t,i,n){var a={};a.source=e,a.target=t,a.position=i,this.G("RowMove",a,n)},this.rowMoveNotify=function(e,t,i,n){var a={};a.source=e,a.target=t,a.position=i,this.G("RowMove",a,n,"Notify")},this.rowClickPostBack=function(e,t){var i={};i.resource=e,this.E("RowClick",i,t)},this.resourceHeaderClickPostBack=this.rowClickPostBack,this.rowClickCallBack=function(e,t){var i={};i.resource=e,this.G("RowClick",i,t)},this.resourceHeaderClickCallBack=this.rowClickCallBack,this.Mh=function(e,t,i,n){if("Disabled"===c.rowDoubleClickHandling)return void c.Nh(e,t,i,n);c.timeouts.resClick||(c.timeouts.resClick=[]);var a=function(e,t,i,n){return function(){c.Nh(e,t,i,n)}};c.timeouts.resClick.push(window.setTimeout(a(e,t,i,n),c.doubleClickTimeout))},this.Nh=function(e,t,i,n){var a=c.resourceHeaderClickHandling||c.rowClickHandling;if(c.sa()){var o={};if(o.resource=e,o.row=e,o.ctrl=t,o.shift=i,o.meta=n,o.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof c.onRowClick&&(c.onRowClick(o),o.preventDefault.value))return;if("function"==typeof c.onResourceHeaderClick&&(c.onResourceHeaderClick(o),o.preventDefault.value))return;switch(a){case"PostBack":c.rowClickPostBack(e);break;case"CallBack":c.rowClickCallBack(e);break;case"Select":c.Oh(e.$.row,t,i,n);break;case"Edit":c.Ph.edit(e.$.row)}"function"==typeof c.onRowClicked&&c.onRowClicked(o),"function"==typeof c.onResourceHeaderClicked&&c.onResourceHeaderClicked(o)}else switch(a){case"PostBack":c.rowClickPostBack(e);break;case"CallBack":c.rowClickCallBack(e);break;case"JavaScript":c.onRowClick(e);break;case"Select":c.Oh(e.$.row,t,i);break;case"Edit":c.Ph.edit(e.$.row)}},this.timeHeaderClickPostBack=function(e,t){var i={};i.header=e,this.E("TimeHeaderClick",i,t)},this.timeHeaderClickCallBack=function(e,t){var i={};i.header=e,this.G("TimeHeaderClick",i,t)},this.Qh=function(e){if(c.sa()){var t={};if(t.header=e,t.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof c.onTimeHeaderClick&&(c.onTimeHeaderClick(t),t.preventDefault.value))return;switch(this.timeHeaderClickHandling){case"PostBack":c.timeHeaderClickPostBack(e);break;case"CallBack":c.timeHeaderClickCallBack(e)}"function"==typeof c.onTimeHeaderClicked&&c.onTimeHeaderClicked(t)}else switch(this.timeHeaderClickHandling){case"PostBack":c.timeHeaderClickPostBack(e);break;case"CallBack":c.timeHeaderClickCallBack(e);break;case"JavaScript":c.onTimeHeaderClick(e)}},this.resourceCollapsePostBack=function(e,t){var i={};i.resource=e,this.E("ResourceCollapse",i,t)},this.resourceCollapseCallBack=function(e,t){var i={};i.resource=e,this.G("ResourceCollapse",i,t)},this.Rh=function(e){if(c.sa()){var t={};if(t.resource=e,t.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof c.onResourceCollapse&&(c.onResourceCollapse(t),t.preventDefault.value))return;switch(this.resourceCollapseHandling){case"PostBack":c.resourceCollapsePostBack(e);break;case"CallBack":c.resourceCollapseCallBack(e)}}else switch(this.resourceCollapseHandling){case"PostBack":c.resourceCollapsePostBack(e);break;case"CallBack":c.resourceCollapseCallBack(e);break;case"JavaScript":c.onResourceCollapse(e)}},this.resourceExpandPostBack=function(e,t){var i={};i.resource=e,this.E("ResourceExpand",i,t)},this.resourceExpandCallBack=function(e,t){var i={};i.resource=e,this.G("ResourceExpand",i,t)},this.Sh=function(e){if(c.sa()){var t={};if(t.resource=e,t.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof c.onResourceExpand&&(c.onResourceExpand(t),t.preventDefault.value))return;switch(this.resourceExpandHandling){case"PostBack":c.resourceExpandPostBack(e);break;case"CallBack":c.resourceExpandCallBack(e)}}else switch(this.resourceExpandHandling){case"PostBack":c.resourceExpandPostBack(e);break;case"CallBack":c.resourceExpandCallBack(e);break;case"JavaScript":c.onResourceExpand(e)}},this.eventEditPostBack=function(e,t,i){var n={};n.e=e,n.newText=t,this.E("EventEdit",n,i)},this.eventEditCallBack=function(e,t,i){var n={};n.e=e,n.newText=t,this.G("EventEdit",n,i)},this.eventEditNotify=function(e,t,i,n){var a=new DayPilot.Event(e.copy(),this);e.text(t),c.events.update(e,null,n);var o={};o.e=a,o.newText=t,this.G("EventEdit",o,i,"Notify")},this.bb=function(e,t,i){if(c.sa()){var n={};if(n.e=e,n.newText=t,n.canceled=i,n.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof c.onEventEdit&&(c.onEventEdit(n),n.preventDefault.value))return;if(!i)switch(c.eventEditHandling){case"PostBack":c.eventEditPostBack(e,t);break;case"CallBack":c.eventEditCallBack(e,t);break;case"Update":e.text(t),c.events.update(e,null,{"inplace":!0})}"function"==typeof c.onEventEdited&&c.onEventEdited(n)}else switch(c.eventEditHandling){case"PostBack":c.eventEditPostBack(e,t);break;case"CallBack":c.eventEditCallBack(e,t);break;case"Notify":c.eventEditNotify(e,t,null,{"inplace":!0});break;case"JavaScript":c.onEventEdit(e,t)}},this.commandCallBack=function(e,t){this.Th("CallBack",e,t)},this.commandPostBack=function(e,t){this.Th("PostBack",e,t)},this.Th=function(e,t,i){var n={};n.command=t,this.Qa(e,"Command",n,i)},this.E=function(e,t,i){var n={};n.action=e,n.type="PostBack",n.parameters=t,n.data=i,n.header=this.F();var a="JSON"+DayPilot.JSON.stringify(n);__doPostBack(c.uniqueID,a)},this.G=function(e,t,i,n){if(!c.r())return void c.debug.message("Callback invoked without the server-side backend specified. Callback canceled.","warning");"undefined"==typeof n&&(n="CallBack"),this.L(),c.H();var a={};a.action=e,a.type=n,a.parameters=t,a.data=i,a.header=this.F();var o,r=DayPilot.JSON.stringify(a);o="undefined"!=typeof Iuppiter&&Iuppiter.compress?"LZJB"+Iuppiter.Base64.encode(Iuppiter.compress(r)):"JSON"+r,this.Uh(a),this.backendUrl?DayPilot.request(this.backendUrl,this.I,o,this.J):"function"==typeof WebForm_DoCallback&&WebForm_DoCallback(this.uniqueID,o,this.K,null,this.callbackError,!0)},this.Uh=function(e){var t={};"function"==typeof c.onCallBackStart&&c.onCallBackStart(t)},this.Uf=function(){var e={};"function"==typeof c.onCallBackEnd&&setTimeout(function(){c.onCallBackEnd(e)},0)},this.r=function(){return!!this.backendUrl||!!this.Vh()},this.Vh=function(){return!("function"!=typeof WebForm_DoCallback||!this.uniqueID)},this.J=function(e){if("function"==typeof c.onAjaxError){var t={};t.request=e,c.onAjaxError(t)}else"function"==typeof c.ajaxError&&c.ajaxError(e)},this.I=function(e){c.K(e.responseText)},this.F=function(){var e={};e.v=this.v,e.control="dps",e.id=this.id,e.startDate=c.startDate,e.days=c.days,e.cellDuration=c.cellDuration,e.cellGroupBy=c.cellGroupBy,e.cellWidth=c.cellWidth,e.cellWidthSpec=c.cellWidthSpec,e.viewType=c.viewType,e.hourNameBackColor=c.hourNameBackColor,e.showNonBusiness=c.showNonBusiness,e.businessBeginsHour=c.businessBeginsHour,e.businessEndsHour=c.businessEndsHour,e.weekStarts=c.weekStarts,e.treeEnabled=c.treeEnabled,e.locale=c.locale,e.timeZone=c.timeZone,e.tagFields=c.tagFields,e.timeHeaders=c.timeHeaders,e.cssClassPrefix=c.cssClassPrefix,e.durationBarMode=c.durationBarMode,e.showBaseTimeHeader=!0,e.rowHeaderColumns=c.rowHeaderColumns,e.rowMarginBottom=c.rowMarginBottom,e.rowMarginTop=c.rowMarginTop,e.rowMinHeight=c.rowMinHeight,e.scale=c.scale,e.clientState=c.clientState,this.nav.scroll&&(e.scrollX=Math.max(0,this.nav.scroll.scrollLeft),e.scrollY=Math.max(0,this.nav.scroll.scrollTop)),e.selected=c.multiselect.events(),e.selectedRows=C.Wh(),e.hashes=c.hashes;var t=c.Xh(e.scrollX,e.scrollY),i=c.Yh(t),n=c.Zh(t);if(e.rangeStart=i.start,e.rangeEnd=i.end,e.resources=n,e.dynamicLoading=c.dynamicLoading,e.separators=this.separators,this.syncResourceTree&&"Days"!=this.viewType&&(e.tree=this.R()),this.syncLinks&&(e.links=this.$h()),"Manual"===this.scale&&(e.timeline=this._h()),"function"==typeof c.onCallBackHeader){var a={};a.header=e,c.onCallBackHeader(a)}return e},this._h=function(){var e=[];return DayPilot.list(c.timeline).each(function(t){var i={};i.start=t.start,i.end=t.end,i.width=t.width,e.push(i)}),e},this.$h=function(){var e=[],t=function(e){var t={};if(e.tags)for(var i in e.tags)t[i]=""+e.tags[i];return t};if(!DayPilot.isArray(c.links.list))return e;for(var i=0;i<c.links.list.length;i++){var n=c.links.list[i],a={};a.id=n.id,a.from=n.from,a.to=n.to,a.type=n.type,a.tags=t(n),e.push(a)}return e},this.getViewPort=function(){var e=this.nav.scroll.scrollLeft-u.shiftX,t=this.nav.scroll.scrollTop,i={};if("Days"!==c.viewType){var n=c.Xh(e,t),a=c.Yh(n),o=c.Zh(n);i.start=a.start,i.end=a.end,i.resources=o}else{var n=c.Xh(e,t),a=c.ai(n);i.start=a.start,i.end=a.end,i.resources=[]}return i},this.Xh=function(e,t){var i={};i.start={},i.end={},i.start.x=Math.floor(e/c.cellWidth),i.end.x=Math.floor((e+c.nav.scroll.clientWidth)/c.cellWidth),i.start.y=c.bi(t).i,i.end.y=c.bi(t+c.nav.scroll.clientHeight).i;var n=this.itline.length;return i.end.x>=n&&(i.end.x=n-1),i},this.Yh=function(e){var t={};if(this.itline.length<=0)return t.start=this.startDate,t.end=this.startDate,t;if(!this.itline[e.start.x])throw"Internal error: area.start.x is null.";return t.start=this.itline[e.start.x].start,t.end=this.itline[e.end.x].end,t},this.Zh=function(e){if(!e)var e=this.Xh(this.nav.scroll.scrollLeft,this.nav.scroll.scrollTop);var t=[];t.ignoreToJSON=!0;for(var i=e.start.y;i<=e.end.y;i++){var n=c.rowlist[i];n&&!n.hidden&&t.push(n.id)}return t},this.ai=function(e){if(!e)var e=this.Xh(this.nav.scroll.scrollLeft,this.nav.scroll.scrollTop);var t={};if(0===c.rowlist.length)return t;var i=c.itline[c.itline.length-1].end.getTime()-c.itline[0].start.getTime();return t.start=c.rowlist[e.start.y]&&c.rowlist[e.start.y].start,t.end=c.rowlist[e.end.y]&&c.rowlist[e.end.y].start.addTime(i),t},this.R=function(){var e=[];e.ignoreToJSON=!0;for(var t=0;t<this.rowlist.length;t++){var i=this.rowlist[t];if(!(i.level>0||i.isNewRow)){var n=this.V(t);e.push(n)}}return e},this.W=function(e){var t=[];t.ignoreToJSON=!0;for(var i=0;i<e.length;i++){var n=e[i];c.rowlist[n].isNewRow||t.push(c.V(n))}return t},this.V=function(e){var t=this.rowlist[e];if("function"==typeof c.onGetNodeState){
var i={};if(i.row=t,i.preventDefault=function(){i.preventDefault.value=!0},i.result={},c.onGetNodeState(i),i.preventDefault.value)return i.result}var n={};return n.Value=t.id,n.BackColor=t.backColor,n.Name=t.name,n.InnerHTML=t.html,n.ToolTip=t.toolTip,n.Expanded=t.expanded,n.Children=this.W(t.children),n.Loaded=t.loaded,n.IsParent=t.isParent,n.Columns=this.ci(t),t.start.getTime()!==c.Ba().getTime()&&(n.Start=t.start),t.minHeight!==c.rowMinHeight&&(n.MinHeight=t.minHeight),t.marginBottom!==c.rowMarginBottom&&(n.MarginBottom=t.marginBottom),t.marginTop!==c.rowMarginTop&&(n.MarginTop=t.marginTop),t.eventHeight!==c.eventHeight&&(n.EventHeight=t.eventHeight),n},this.ci=function(e){if(!e.columns||0===e.columns.length)return null;var t=[];t.ignoreToJSON=!0;for(var i=0;i<e.columns.length;i++){var n={};n.InnerHTML=e.columns[i].html,t.push(n)}return t},this.q=function(e){var t=this.theme||this.cssClassPrefix;return t?t+e:""},this.ed=function(){c.nav.top.className!==c.q("_main")&&(c.nav.top.className=c.q("_main"),c.nav.dh1.className=c.q("_divider_horizontal"),c.nav.dh2.className=c.q("_divider_horizontal"),c.divResScroll.className=c.q("_rowheader_scroll"),c.nav.divider.className=c.q("_divider")+" "+c.q("_splitter"),c.nav.scroll.className=c.q("_scrollable"),c.pg.className=c.q("_matrix"),c.nav.loading.className=c.q("_loading"))},this.Q=function(){this.nav.top.dispose=this.dispose},this.dispose=function(){var e=c;if(e.di&&!e.Cd){e.Cd=!0,e.L(),clearInterval(e.Pc),clearInterval(e.ei);for(var t in e.timeouts){var i=e.timeouts[t];DayPilot.isArray(i)?DayPilot.list(i).each(function(e){clearTimeout(e)}):clearTimeout(i)}e.M(),e.divBreaks=null,e.divCells=null,e.divCorner=null,e.divCrosshair=null,e.divEvents=null,e.divHeader&&(e.divHeader.rows=null),e.divHeader=null,e.divLines=null,e.divNorth=null,e.divRange=null,e.divResScroll=null,e.divSeparators=null,e.divSeparatorsAbove=null,e.divStretch=null,e.divTimeScroll=null,e.Jg=null,e.ye=null,e.pg.calendar=null,e.pg=null,e.nav.loading=null,e.nav.top.onmousemove=null,e.nav.top.dispose=null,e.nav.top.ontouchstart=null,e.nav.top.ontouchmove=null,e.nav.top.ontouchend=null,e.nav.top.removeAttribute("style"),e.nav.top.removeAttribute("class"),e.nav.top.innerHTML="",e.nav.top.dp=null,e.nav.top=null,e.nav.scroll.onscroll=null,e.nav.scroll.root=null,e.nav.scroll=null,e.fi&&(e.fi.dispose(),e.fi=null),e.daypilot&&delete e.daypilot,DayPilot.ue(window,"resize",e.le),n.unregister(e),D=null;for(var t in e)e[t]=null}},this.ta=function(e){var t=null;t=e.nodeType?e.event:e;var i=c.pg,a=c.gi(t),o=t;if(!c.hi(a.rowIndex)){var r=t.part.height||c.sc.eventHeight(),s=t.part&&t.part.top&&c.rowlist[t.part.dayIndex]?t.part.top+c.rowlist[t.part.dayIndex].top:a.top,l=a.left,d=o.cache&&"undefined"!=typeof o.cache.moveVDisabled?!o.cache.moveVDisabled:!o.data.moveVDisabled,h=o.cache&&"undefined"!=typeof o.cache.moveHDisabled?!o.cache.moveHDisabled:!o.data.moveHDisabled;!d&&n.moving&&(s=c.rowlist[o.part.dayIndex].top),!h&&n.moving&&(l=t.part.left);var u=document.createElement("div");u.setAttribute("unselectable","on"),u.style.position="absolute",u.style.width=a.width+"px",u.style.height=r+"px",u.style.left=l+"px",u.style.top=s+"px",u.style.zIndex=101,u.style.overflow="hidden";var f=document.createElement("div");return u.appendChild(f),u.className=this.q("_shadow"),f.className=this.q("_shadow_inner"),i.appendChild(u),u.calendar=c,u}},this.bi=function(e){for(var t,i={},n=0,a=0,o=this.rowlist.length,r=0;r<o;r++){var s=this.rowlist[r];if(!s.hidden&&(a+=s.height,e<a||r===o-1)){n=a-s.height,t=s;break}}return i.top=n,i.bottom=a,i.i=r,i.element=t,i},this.links={};var v={};this.ii=v,v.clear=function(){c.divLinksAbove.innerHTML="",c.divLinksBelow.innerHTML="",c.elements.links=[]},v.showLinkpoints=function(){h.events().each(function(e){v.showLinkpoint(e)})},v.showLinkpoint=function(e){var t=c.linkPointSize,i=t/2,n=e.event.part.left,a=c.rowlist[e.event.part.dayIndex].top+e.event.part.top,o=e.event.part.height,r=e.event.part.right,s=DayPilot.Util.div(c.divLinkpoints,n-i,a-i+o/2,t,t);s.className=c.q("_linkpoint"),s.style.boxSizing="border-box",s.coords={x:n,y:a+o/2},s.type="Start",s.event=e.event,v.activateLinkpoint(s),c.elements.linkpoints.push(s);var l=DayPilot.Util.div(c.divLinkpoints,r-i,a-i+o/2,t,t);l.className=c.q("_linkpoint"),l.style.boxSizing="border-box",l.coords={x:r,y:a+o/2},l.type="Finish",l.event=e.event,v.activateLinkpoint(l),c.elements.linkpoints.push(l)},v.activateLinkpoint=function(e){e.onmousedown=function(t){var t=t||window.event;return l.source=e,l.calendar=c,v.showLinkpoints(),t.preventDefault&&t.preventDefault(),t.stopPropagation&&t.stopPropagation(),!1},e.onmousemove=function(t){DayPilot.Util.addClass(e,c.q("_linkpoint_hover")),v.clearHideTimeout()},e.onmouseout=function(t){l.source&&l.source.event===e.event||DayPilot.Util.removeClass(e,c.q("_linkpoint_hover"))},e.onmouseup=function(t){if(l.source){var i=l.source.type+"To"+e.type,n=l.source.event.id(),a=e.event.id(),o={};if(o.from=n,o.to=a,o.type=i,o.id=null,o.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof c.onLinkCreate&&(c.onLinkCreate(o),o.preventDefault.value))return;var r=function(){c.links.list.push({"from":n,"to":a,"type":i,"id":o.id}),v.load()};switch(c.linkCreateHandling){case"Update":r();break;case"CallBack":c.ji(o);break;case"PostBack":c.ki(o);break;case"Notify":r(),c.li(o)}"function"==typeof c.onLinkCreated&&c.onLinkCreated(o)}}},v.hideLinkpoints=function(){c.divLinkpoints.innerHTML="",c.elements.linkpoints=[]},v.hideTimeout=null,v.hideLinkpointsWithDelay=function(){v.hideTimeout=setTimeout(function(){v.hideLinkpoints()},100)},v.clearHideTimeout=function(){v.hideTimeout&&(clearTimeout(v.hideTimeout),v.hideTimeout=null)},v.load=function(){if(v.clear(),DayPilot.isArray(c.links.list))for(var e=0;e<c.links.list.length;e++){var t=c.links.list[e];v.drawLinkId(t.from,t.to,t)}},v.drawLinkId=function(e,t,i){var n=c.events.find(e),a=c.events.find(t);v.drawLink(n,a,i)},v.drawLink=function(e,t,i){var n=c.bd(e),a=c.bd(t);if(n&&a){var o,r,s=i.type||"FinishToStart",l=c.rowlist[n.event.part.dayIndex].top,d=c.rowlist[a.event.part.dayIndex].top;switch(s){case"FinishToStart":o={x:n.event.part.right,y:l+n.event.part.top},r={x:a.event.part.left,y:d+a.event.part.top},o.y>r.y&&o.x<r.x&&(r.y+=a.event.part.height,r.bottom=!0);break;case"StartToFinish":o={x:n.event.part.left,y:l+n.event.part.top},r={x:a.event.part.right,y:d+a.event.part.top};break;case"StartToStart":o={x:n.event.part.left,y:l+n.event.part.top},r={x:a.event.part.left,y:d+a.event.part.top};break;case"FinishToFinish":o={x:n.event.part.right,y:l+n.event.part.top},r={x:a.event.part.right,y:d+a.event.part.top}}v.drawLinkXy(o,r,i)}},v.clearShadow=function(){c.divLinkShadow.innerHTML="",c.elements.linkshadow=[]},v.drawShadow=function(e,t){if(v.clearShadow(),DayPilot.browser.ielt9)v.drawShadowOldStyle(e,t);else{var i=c.divLinkShadow,n=DayPilot.line(e.x,e.y,t.x,t.y,!0);i.appendChild(n),c.elements.linkshadow.push(n)}},v.drawShadowOldStyle=function(e,t){var i=Math.min(e.x,t.x),n=2,a=c.divLinkShadow,o="black",r=DayPilot.Util.div(a,i,e.y,e.x-i,n);r.style.backgroundColor=o,c.elements.linkshadow.push(r);var s=DayPilot.Util.div(a,i,e.y,n,t.y-e.y);s.style.backgroundColor=o,c.elements.linkshadow.push(s);var l=DayPilot.Util.div(a,i,t.y,t.x-i,n);l.style.backgroundColor=o,c.elements.linkshadow.push(l);var d=DayPilot.Util.div(a,t.x-6,t.y-5,0,0);d.style.borderColor="transparent transparent transparent black",d.style.borderStyle="solid",d.style.borderWidth="6px",c.elements.linkshadow.push(d)},v.drawLinkXy=function(e,t,i){var n=c.eventHeight/2,a=i.width||1,o=i.type||"FinishToStart",r=i.color,s=i.style,l=i.layer||"Above",d="Above"===l,h=c.divLinksAbove,u=c.eventHeight,f=c.linkBottomMargin,v=function(e,t){r&&(e.style["border"+t+"Color"]=r),s&&(e.style["border"+t+"Style"]=s)},p=[],g=function(e,t){c.elements.links.push(e),y(e),m(e),e.divs=p,t||p.push(e)},m=function(e){e.oncontextmenu=function(e){if(e=e||window.event,c.contextMenuLink){var t=new DayPilot.Link(i,c);c.contextMenuLink.show(t)}e.cancelBubble=!0,e.preventDefault?e.preventDefault():null}},y=function(e){e.onmouseenter=function(){DayPilot.Util.addClass(e.divs,c.q("_link_hover"))},e.onmouseleave=function(){DayPilot.Util.removeClass(e.divs,c.q("_link_hover"))}};if("FinishToStart"===o)if(e.y>t.y||e.y==t.y&&t.bottom)if(e.x<t.x){var b=e.x,w=e.y+u-f,D=t.x+n,k=t.y,C=DayPilot.Util.div(h,b,w,D-e.x,a);C.style.boxSizing="border-box",C.style.borderBottomWidth=a+"px",C.className=c.q("_link_horizontal"),DayPilot.Util.addClass(C,i.cssClass),v(C,"Bottom"),g(C);var x=DayPilot.Util.div(h,D,w,a,k-w);x.style.boxSizing="border-box",x.style.borderRightWidth=a+"px",x.className=c.q("_link_vertical"),DayPilot.Util.addClass(x,i.cssClass),v(x,"Right"),g(x);var P;r?(P=DayPilot.Util.div(h,D-5+Math.floor(a/2),k-5,0,0),e.y<t.y?P.style.borderColor=r+" transparent transparent transparent":P.style.borderColor="transparent transparent "+r+" transparent",P.style.borderStyle="solid",P.style.borderWidth="5px"):(P=DayPilot.Util.div(h,D-6+Math.floor(a/2),k-6,6,6),e.y<t.y?P.className=c.q("_link_arrow_down"):P.className=c.q("_link_arrow_up"),DayPilot.Util.addClass(P,i.cssClass)),g(P,!0)}else{var S=5,A=t.y+u+S,C=DayPilot.Util.div(h,e.x,e.y+u-f,n+a,a);C.style.boxSizing="border-box",C.style.borderBottomWidth=a+"px",C.className=c.q("_link_horizontal"),DayPilot.Util.addClass(C,i.cssClass),v(C,"Bottom"),g(C);var x=DayPilot.Util.div(h,e.x+n,e.y+u-f,a,A-(e.y+u-f));x.style.boxSizing="border-box",x.style.borderRightWidth=a+"px",x.className=c.q("_link_vertical"),DayPilot.Util.addClass(x,i.cssClass),v(x,"Right"),g(x);var T=DayPilot.Util.div(h,t.x-n,A,e.x+2*n+a-t.x,a);T.style.boxSizing="border-box",T.style.borderBottomWidth=a+"px",T.className=c.q("_link_horizontal"),DayPilot.Util.addClass(T,i.cssClass),v(T,"Bottom"),g(T);var E=DayPilot.Util.div(h,t.x-n,A,a,t.y-A+u-f);E.style.boxSizing="border-box",E.style.borderRightWidth=a+"px",E.className=c.q("_link_vertical"),DayPilot.Util.addClass(E,i.cssClass),v(E,"Right"),g(E);var M=DayPilot.Util.div(h,t.x-n,t.y+u-f,n,a);M.style.boxSizing="border-box",M.style.borderBottomWidth=a+"px",M.className=c.q("_link_horizontal"),DayPilot.Util.addClass(M,i.cssClass),v(M,"Bottom"),g(M);var P;r?(P=DayPilot.Util.div(h,t.x-6,t.y+u-f-5,0,0),P.style.borderWidth="6px",P.style.borderColor="transparent transparent transparent "+r,P.style.borderStyle="solid"):(P=DayPilot.Util.div(h,t.x-6,t.y+u-f-5,6,6),P.className=c.q("_link_arrow_right"),DayPilot.Util.addClass(P,i.cssClass)),g(P,!0)}else if(e.y===t.y)if(e.x<t.x){var b=e.x,w=e.y+u-f,D=t.x,C=DayPilot.Util.div(h,b,w,D-e.x,a);C.style.boxSizing="border-box",C.style.borderBottomWidth=a+"px",C.className=c.q("_link_horizontal"),DayPilot.Util.addClass(C,i.cssClass),v(C,"Bottom"),g(C);var P;r?(P=DayPilot.Util.div(h,t.x-6,t.y+u-f-5,0,0),P.style.borderWidth="6px",P.style.borderColor="transparent transparent transparent "+r,P.style.borderStyle="solid"):(P=DayPilot.Util.div(h,t.x-6,t.y+u-f-5,6,6),P.className=c.q("_link_arrow_right"),DayPilot.Util.addClass(P,i.cssClass)),g(P,!0)}else{var S=5,A=t.y+u+S,C=DayPilot.Util.div(h,e.x,e.y+u-f,n+a,a);C.style.boxSizing="border-box",C.style.borderBottomWidth=a+"px",C.className=c.q("_link_horizontal"),DayPilot.Util.addClass(C,i.cssClass),v(C,"Bottom"),g(C);var x=DayPilot.Util.div(h,e.x+n,e.y+u-f,a,A-(e.y+u-f));x.style.boxSizing="border-box",x.style.borderRightWidth=a+"px",x.className=c.q("_link_vertical"),DayPilot.Util.addClass(x,i.cssClass),v(x,"Right"),g(x);var T=DayPilot.Util.div(h,t.x-n,A,e.x+2*n+a-t.x,a);T.style.boxSizing="border-box",T.style.borderBottomWidth=a+"px",T.className=c.q("_link_horizontal"),DayPilot.Util.addClass(T,i.cssClass),v(T,"Bottom"),g(T);var E=DayPilot.Util.div(h,t.x-n,A,a,t.y-A+u-f);E.style.boxSizing="border-box",E.style.borderRightWidth=a+"px",E.className=c.q("_link_vertical"),DayPilot.Util.addClass(E,i.cssClass),v(E,"Right"),g(E);var M=DayPilot.Util.div(h,t.x-n,t.y+u-f,n,a);M.style.boxSizing="border-box",M.style.borderBottomWidth=a+"px",M.className=c.q("_link_horizontal"),DayPilot.Util.addClass(M,i.cssClass),v(M,"Bottom"),g(M);var P;r?(P=DayPilot.Util.div(h,t.x-6,t.y+u-f-5,0,0),P.style.borderWidth="6px",P.style.borderColor="transparent transparent transparent "+r,P.style.borderStyle="solid"):(P=DayPilot.Util.div(h,t.x-6,t.y+u-f-5,6,6),P.className=c.q("_link_arrow_right"),DayPilot.Util.addClass(P,i.cssClass)),g(P,!0)}else if(e.x>t.x){var d=5,A=t.y-d,C=DayPilot.Util.div(h,e.x,e.y+u-f,n+a,a);C.style.boxSizing="border-box",C.style.borderBottomWidth=a+"px",C.className=c.q("_link_horizontal"),DayPilot.Util.addClass(C,i.cssClass),v(C,"Bottom"),g(C);var x=DayPilot.Util.div(h,e.x+n,e.y+u-f,a,A-(e.y+u-f));x.style.boxSizing="border-box",x.style.borderRightWidth=a+"px",x.className=c.q("_link_vertical"),DayPilot.Util.addClass(x,i.cssClass),v(x,"Right"),g(x);var T=DayPilot.Util.div(h,t.x-n,A,e.x+2*n+a-t.x,a);T.style.boxSizing="border-box",T.style.borderBottomWidth=a+"px",T.className=c.q("_link_horizontal"),DayPilot.Util.addClass(T,i.cssClass),v(T,"Bottom"),g(T);var E=DayPilot.Util.div(h,t.x-n,A,a,t.y-A+u-f);E.style.boxSizing="border-box",E.style.borderRightWidth=a+"px",E.className=c.q("_link_vertical"),DayPilot.Util.addClass(E,i.cssClass),v(E,"Right"),g(E);var M=DayPilot.Util.div(h,t.x-n,t.y+u-f,n,a);M.style.boxSizing="border-box",M.style.borderBottomWidth=a+"px",M.className=c.q("_link_horizontal"),DayPilot.Util.addClass(M,i.cssClass),v(M,"Bottom"),g(M);var P;r?(P=DayPilot.Util.div(h,t.x-6,t.y+u-f-5,0,0),P.style.borderWidth="6px",P.style.borderColor="transparent transparent transparent "+r,P.style.borderStyle="solid"):(P=DayPilot.Util.div(h,t.x-6,t.y+u-f-5,6,6),P.className=c.q("_link_arrow_right"),DayPilot.Util.addClass(P,i.cssClass)),g(P,!0)}else{var b=e.x,w=e.y+u-f,D=t.x+n,k=t.y,C=DayPilot.Util.div(h,b,w,D-e.x,a);C.style.boxSizing="border-box",C.style.borderBottomWidth=a+"px",C.className=c.q("_link_horizontal"),DayPilot.Util.addClass(C,i.cssClass),v(C,"Bottom"),g(C);var x=DayPilot.Util.div(h,D,w,a,k-w);x.style.boxSizing="border-box",x.style.borderRightWidth=a+"px",x.className=c.q("_link_vertical"),DayPilot.Util.addClass(x,i.cssClass),v(x,"Right"),g(x);var P;r?(P=DayPilot.Util.div(h,D-5+Math.floor(a/2),k-5,0,0),e.y<t.y?P.style.borderColor=r+" transparent transparent transparent":P.style.borderColor="transparent transparent "+r+"transparent",P.style.borderStyle="solid",P.style.borderWidth="5px"):(P=DayPilot.Util.div(h,D-6+Math.floor(a/2),k-6,6,6),e.y<t.y?P.className=c.q("_link_arrow_down"):P.className=c.q("_link_arrow_up"),DayPilot.Util.addClass(P,i.cssClass)),g(P,!0)}else if("StartToFinish"===o){var d=5,A=t.y-d,C=DayPilot.Util.div(h,t.x,t.y+u-f,n+a,a);C.style.boxSizing="border-box",C.style.borderBottomWidth=a+"px",C.className=c.q("_link_horizontal"),DayPilot.Util.addClass(C,i.cssClass),v(C,"Bottom"),g(C);var x=DayPilot.Util.div(h,t.x+n,t.y+u-f,a,A-(t.y+u-f)+0);x.style.boxSizing="border-box",x.style.borderRightWidth=a+"px",x.className=c.q("_link_vertical"),DayPilot.Util.addClass(x,i.cssClass),v(x,"Right"),g(x);var T=DayPilot.Util.div(h,e.x-n,A,t.x+2*n+a-e.x,a);T.style.boxSizing="border-box",T.style.borderBottomWidth=a+"px",T.className=c.q("_link_horizontal"),DayPilot.Util.addClass(T,i.cssClass),v(T,"Bottom"),g(T);var E=DayPilot.Util.div(h,e.x-n,A,a,e.y+u-f-A+0);E.style.boxSizing="border-box",E.style.borderRightWidth=a+"px",E.className=c.q("_link_vertical"),DayPilot.Util.addClass(E,i.cssClass),v(E,"Right"),g(E);var M=DayPilot.Util.div(h,e.x-n,e.y+u-f,n,a);M.style.boxSizing="border-box",M.style.borderBottomWidth=a+"px",M.className=c.q("_link_horizontal"),DayPilot.Util.addClass(M,i.cssClass),v(M,"Bottom"),g(M);var P;r?(P=DayPilot.Util.div(h,t.x-6,t.y+u-f-5,0,0),P.style.borderColor="transparent "+r+" transparent transparent",P.style.borderStyle="solid",P.style.borderWidth="6px"):(P=DayPilot.Util.div(h,t.x-6,t.y+u-f-5,6,6),P.className=c.q("_link_arrow_left"),DayPilot.Util.addClass(P,i.cssClass)),g(P,!0)}else if("StartToStart"===o){var H=Math.min(e.x,t.x)-n,C=DayPilot.Util.div(h,H,e.y+u-f,e.x-H,a);C.style.boxSizing="border-box",C.style.borderBottomWidth=a+"px",C.className=c.q("_link_horizontal"),DayPilot.Util.addClass(C,i.cssClass),v(C,"Bottom"),g(C);var x=DayPilot.Util.div(h,H,e.y+u-f,a,t.y-e.y);x.style.boxSizing="border-box",x.style.borderRightWidth=a+"px",x.className=c.q("_link_vertical"),DayPilot.Util.addClass(x,i.cssClass),v(x,"Right"),g(x);var M=DayPilot.Util.div(h,H,t.y+u-f,t.x-H,a);M.style.boxSizing="border-box",M.style.borderBottomWidth=a+"px",M.className=c.q("_link_horizontal"),DayPilot.Util.addClass(M,i.cssClass),v(M,"Bottom"),g(M);var P;r?(P=DayPilot.Util.div(h,t.x-6,t.y+u-f-5,0,0),P.style.borderColor="transparent transparent transparent "+r,P.style.borderStyle="solid",P.style.borderWidth="6px"):(P=DayPilot.Util.div(h,t.x-6,t.y+u-f-5,6,6),P.className=c.q("_link_arrow_right"),DayPilot.Util.addClass(P,i.cssClass)),g(P,!0)}else if("FinishToFinish"===o){var _=Math.max(t.x,e.x)+n,C=DayPilot.Util.div(h,e.x,e.y+u-f,_-e.x,a);C.style.boxSizing="border-box",C.style.borderBottomWidth=a+"px",C.className=c.q("_link_horizontal"),DayPilot.Util.addClass(C,i.cssClass),v(C,"Bottom"),g(C);var x=DayPilot.Util.div(h,_,e.y+u-f,a,t.y-e.y);x.style.boxSizing="border-box",x.style.borderRightWidth=a+"px",x.className=c.q("_link_vertical"),DayPilot.Util.addClass(x,i.cssClass),v(x,"Right"),g(x);var M=DayPilot.Util.div(h,t.x,t.y+u-f,_-t.x,a);M.style.boxSizing="border-box",M.style.borderBottomWidth=a+"px",M.className=c.q("_link_horizontal"),DayPilot.Util.addClass(M,i.cssClass),v(M,"Bottom"),g(M);var P;r?(P=DayPilot.Util.div(h,t.x-6,t.y+u-f-5,0,0),P.style.borderColor="transparent "+r+" transparent transparent",P.style.borderStyle="solid",P.style.borderWidth="6px"):(P=DayPilot.Util.div(h,t.x-6,t.y+u-f-5,6,6),P.className=c.q("_link_arrow_left"),DayPilot.Util.addClass(P,i.cssClass)),g(P,!0)}},this.ji=function(e,t){var i={};i.from=e.from,i.to=e.to,i.type=e.type,c.G("LinkCreate",i,t)},this.li=function(e,t){var i={};i.from=e.from,i.to=e.to,i.type=e.type,c.G("LinkCreate",i,t,"Notify")},this.ki=function(e,t){var i={};i.from=e.from,i.to=e.to,i.type=e.type,c.E("LinkCreate",i,t)},this.mi=function(e){var t=0,i=0,n=0;if(e>this.rowlist.length-1)throw"Row index too high (DayPilotScheduler._getRowByIndex)";for(var a=0;a<=e;a++){var o=this.rowlist[a];o.hidden||(i+=o.height,n++)}t=i-o.height;var r={};return r.top=t,r.height=o.height,r.bottom=i,r.i=n-1,r.data=o,r},this.md=function(){return!!this.backendUrl&&("undefined"==typeof c.events.list||!c.events.list)},this.events.find=function(e){if(!c.events.list||"undefined"==typeof c.events.list.length)return null;for(var t=c.events.list.length,i=0;i<t;i++)if(c.events.list[i].id===e)return new DayPilot.Event(c.events.list[i],c);return null},this.events.all=function(){for(var e=[],t=0;t<c.events.list.length;t++){var i=new DayPilot.Event(c.events.list[t],c);e.push(i)}return DayPilot.list(e)},this.events.filter=function(e){c.events.Zc=e,c.cd({"eventsOnly":!0})},this.events.edit=function(e){var t=c.bd(e);return t||DayPilot.list(c.events.ni.rows).isEmpty()?void c.Ia(t):void setTimeout(function(){c.Ia(c.bd(e))})},this.events.load=function(e,t,i){var n=function(e){var t={};t.exception=e.exception,t.request=e.request,"function"==typeof i&&i(t)},a=function(e){var i,a=e.request;try{i=DayPilot.Util.parseJSON(a.responseText)}catch(e){var o={};return o.exception=e,void n(o)}if(DayPilot.isArray(i)){var r={};if(r.preventDefault=function(){this.preventDefault.value=!0},r.data=i,"function"==typeof t&&t(r),r.preventDefault.value)return;c.events.list=i,c.A&&c.update()}};DayPilot.ajax({"method":"POST","contentType":"application/json","data":{"start":c.visibleStart().toString(),"end":c.visibleEnd().toString()},"url":e,"success":a,"error":n})},this.events.findRecurrent=function(e,t){if(!c.events.list||"undefined"==typeof c.events.list.length)return null;for(var i=c.events.list.length,n=0;n<i;n++)if(c.events.list[n].recurrentMasterId===e&&c.events.list[n].start.getTime()===t.getTime())return new DayPilot.Event(c.events.list[n],c);return null},this.events.ch=function(e){for(var t=[],i=0;i<c.rowlist.length;i++){var n=c.rowlist[i];if(!n.isNewRow){c.Qg(i);for(var a=0;a<n.events.length;a++)if(n.events[a].data===e||n.events[a].data.id==e.id){t.push(i),n.events.splice(a,1);break}}}return t},this.events.oi=function(e){for(var t=0;t<c.rowlist.length;t++){var i=c.rowlist[t];if(!i.isNewRow){c.Qg(t);for(var n=0;n<i.events.length;n++)if(i.events[n].data===e)return i.events[n]}}return null},this.events.dh=function(e){var t=[],i=c.pi()||"Days"===c.viewType,n=DayPilot.indexOf(c.events.list,e);c.Sc(n);for(var a=0;a<c.rowlist.length;a++){var o=c.rowlist[a];if(!o.isNewRow){c.Qg(a);var r=c.qi(e,o);if(r&&("function"==typeof c.onBeforeEventRender&&(r.cache=c.t.events[n]),t.push(a),!i))break}}return t},this.events.update=function(e,t,i){var n={};n.oldEvent=new DayPilot.Event(e.copy(),c),n.newEvent=new DayPilot.Event(e.temp(),c);var i=i||{},a=new DayPilot.Action(c,"EventUpdate",n,t);if(DayPilot.list(c.events.list).find(function(t){var i=t instanceof DayPilot.Event?t.data:t;return i===e.data||i.id==e.data.id})){if(c.Lc.scope)c.Lc.notify(function(){e.commit()});else if(c.mg.skip=!0,(c.eventUpdateInplaceOptimization||i.inplace)&&n.oldEvent.resource()===n.newEvent.resource()&&n.oldEvent.start()===n.newEvent.start()&&n.oldEvent.end()===n.newEvent.end()){e.commit();var o=c.bd(e);if(o){var r=o.event.part;c.ri(o),DayPilot.rfa(c.elements.events,o),e.part=r}c.events.ch(e.data);var s=c.events.dh(e.data);c.eh(s);var l=c.events.oi(e.data);l&&c.Ob(l)}else{var s=c.events.ch(e.data);e.commit(),s=s.concat(c.events.dh(e.data)),c.events.si(s)}return a}},this.events.remove=function(e,t){var i={};i.e=new DayPilot.Event(e.data,c);var n=new DayPilot.Action(c,"EventRemove",i,t),a=DayPilot.indexOf(c.events.list,e.data);if(a>=0&&c.events.list.splice(a,1),c.Lc.scope)c.Lc.notify();else{c.mg.skip=!0;var o=c.events.ch(e.data);if(c.eventUpdateInplaceOptimization&&1===o.length&&!c.events.ui(e)){c.vi(c.rowlist[o[0]]);var r=c.bd(e);if(r){var a=c.elements.events.indexOf(r);c.elements.events.splice(a,1),c.ri(r)}}else c.events.si(o)}return n},this.events.add=function(e,t){e.calendar=c,c.events.list||(c.events.list=[]),DayPilot.list(c.events.list).find(function(t){return(t instanceof DayPilot.Event?t.data:t)===e.data})||c.events.list.push(e.data);var i=new DayPilot.Action(c,"EventAdd",n,t);if(!c.A)return i;if(c.Lc.scope)c.Lc.notify();else{c.mg.skip=!0;var n={};n.e=e;var a=c.events.dh(e.data),o=e.data.height||c.eventHeight;if(c.eventUpdateInplaceOptimization&&1===a.length&&!c.events.ui(e)&&o<=c.eventHeight&&!c.eventVersionsEnabled){var r=c.rowlist[a[0]];c.vi(r);var s=r.events.find(function(t){return t.data===e.data});s.part.top=0,s.part.height=o,s.part.line=0,c.Ob(s)}else c.events.si(a)}return i},this.events.ui=function(e){var t=e instanceof DayPilot.Event?e.data:e,i=new DayPilot.Date(t.start),n=new DayPilot.Date(t.end);return!!DayPilot.list(c.events.list).find(function(e){if(t===e||t.id==e.id)return!1;if(t.resource!==e.resource)return!1;var a=new DayPilot.Date(e.start),o=new DayPilot.Date(e.end);return DayPilot.Util.overlaps(i,n,a,o)})},this.events.ni={"rows":[]},this.events.wi=null,this.events.nh=function(){clearTimeout(c.events.wi),c.events.ni.rows=[]},this.events.queueUpdateInterval=0,this.events.si=function(e){var t=c.events.ni.rows;DayPilot.list(e).each(function(e){t.push(e)}),c.events.ni.rows=DayPilot.ua(t);var i=c.events.immediateRefresh;c.events.wi||(c.events.wi=setTimeout(i,c.events.queueUpdateInterval))},this.events.immediateRefresh=function(){clearTimeout(c.events.wi),c.events.wi=null;var e=c.events.ni.rows;c.events.ni.rows=[],c.eh(e),c.fh(),c.A&&("Gantt"===c.viewType?c.update():(c.gh(e),c.ja(),c.xi()))},this.mg={},this.mg.enabled=!1,this.mg.skip=!1,this.mg.skipUpdate=function(){return c.mg.skip},this.mg.skipped=function(){c.mg.skip=!1},this.queue={},this.queue.list=[],this.queue.list.ignoreToJSON=!0,this.queue.add=function(e){if(e){if(!e.isAction)throw"DayPilot.Action object required for queue.add()";c.queue.list.push(e)}},this.queue.notify=function(e){var t={};t.actions=c.queue.list,c.G("Notify",t,e,"Notify"),c.queue.list=[]},this.queue.clear=function(){c.queue.list=[]},this.queue.pop=function(){return c.queue.list.pop()},this.cells.find=function(e,t){var i=c.getPixels(new DayPilot.Date(e));if(!i)return g();var n=i.i,a=c.sg(t);if(!a)return g();var o=a.index;return this.findXy(n,o)},this.cells.findByPixels=function(e,t){var i=c.Xg(e);if(!i)return g();var e=i.x,n=c.bi(t);if(!n)return g();var t=n.i;return this.findXy(e,t)},this.cells.all=function(){for(var e=[],t=c.itline.length,i=c.rowlist.length,n=0;n<t;n++)for(var a=0;a<i;a++){var o=c.cells.findXy(n,a);e.push(o[0])}return g(e)},this.cells.yi=function(e,t){var i=c._g(e),n=c.rowlist[t],a=n.start.getTime()-c.Ba().getTime(),o=i.start.addTime(a),r=i.end.addTime(a),s={};s.x=e,s.y=t,s.i=e+"_"+t,!n.id,s.resource=n.id,s.start=i.start,s.end=i.end,s.calendar=c,s.isParent=n.children&&n.children.length,s.update=function(){if(!c.rowlist[s.y].hidden){var e=c.t.cells[s.i];c.zi(e);var t=c.ug();t.xStart<=s.x&&s.x<=t.xEnd&&t.yStart<=s.y&&s.y<=t.yEnd&&c.$e(s.x,s.y)}},s.utilization=function(e){return n.sections||n.calculateUtilization(),n.sections.forRange(o,r).maxSum(e)},s.events=function(){return n.events.forRange(o,r)},s.div=c.t.cells[s.i];var l=c.Ai(e,t);return s.properties=l,s},this.cells.findXy=function(e,t){if(DayPilot.isArray(e)){for(var i=[],n=0;n<e.length;n++){var a=e[n];i.push(c.cells.yi(a.x,a.y))}return g(i)}return null===e||null===t?g():g(c.cells.yi(e,t))};var p=function(e){var t=DayPilot.list();if(DayPilot.isArray(e))for(var i=0;i<e.length;i++)t.push(e[i]);else"object"==typeof e&&t.push(e);return t};this.Bi=function(e){var t=DayPilot.list();if(DayPilot.isArray(e))for(var i=0;i<e.length;i++)t.push(e[i]);else"object"==typeof e&&t.push(e);return t.cssClass=function(e){return this.each(function(t){t.properties.cssClass=DayPilot.Util.addClassToString(t.properties.cssClass,e),t.update()}),this},t.removeClass=function(e){return this.each(function(t){t.properties.cssClass=DayPilot.Util.removeClassFromString(t.properties.cssClass,e),t.update()}),this},t.addClass=t.cssClass,t.html=function(e){return this.each(function(t){t.properties.html=e,t.update()}),this},t.invalidate=function(){return this.each(function(e){delete c.mh[e.i]}),this},t};var g=this.Bi;this.Lc={},this.Lc.scope=null,this.Lc.notify=function(e){c.Lc.scope&&DayPilot.Util.safeApply(c.Lc.scope,e)},this.debug=new DayPilot.Debug(this),this.Ci=function(e){if("Days"!==c.viewType)throw"Checking row start when viewType !== 'Days'";for(var t=0;t<c.rowlist.length;t++){var i=c.rowlist[t],n=i.element?i.element.data:i.data,a=n.start;if(e.getTime()>=a.getTime()&&e.getTime()<a.addDays(1).getTime())return a}return null},this.Di=function(e){var t=c.Ba();if(e.ticks===t.ticks)return e;var i=t;if(e.ticks<t.ticks){for(var n=this.itline[0].end.ticks-this.itline[0].start.ticks;i.ticks>e.ticks;)i=i.addTime(-n);return i}if("Days"===c.viewType){var a=this.Ci(e),o=a.getTime()-c.Ba().getTime(),r=this.Zg(e.addTime(-o));if(r.current)return r.current.start.addTime(o);if(r.past)return r.previous.end.addTime(o);throw"getBoxStart(): time not found"}var r=this.Zg(e);if(r.current)return r.current.start;if(r.past)return r.previous.end;if(r.hidden){var s=r.next.start.getTime()-e.getTime(),l=r.next.end.getTime()-r.next.start.getTime(),d=Math.ceil(s/l)*l;return r.next.start.addTime(-d)}throw"getBoxStart(): time not found"},this.Ei=function(e){var t=this.bi(c.coords.y),i=e.event;if("function"!=typeof i.end)throw"e.end function is not defined";if(!i.end())throw"e.end() returns null";var a=DayPilot.DateUtil.diff(i.rawend(),i.start());a=Math.max(a,1);var o=_.useBox(a),r=i.data&&"Milestone"===i.data.type,s=c.eventHeight,l=0,d=c.coords.x;if(r&&(d+=s/2),"Manual"===c.scale){var h=function(){var e=c.getDate(c.coords.x,!0,!0),t=e.addTime(-a),i=c.getPixels(t).boxLeft,n=c.getPixels(e).boxRight,e=Math.min(n,c.coords.x);return e-i}(),u=Math.min(n.moveOffsetX?n.moveOffsetX:0,h);d=c.coords.x-u}var f=0,v="Days"===this.viewType||this.Fi();if(v&&!i.part.external&&(f=this.rowlist[i.part.dayIndex].start.getTime()-this.Ba().getTime()),o&&!r){var p=c.Zg(i.start()),g=!p.hidden&&!p.past;l=i.start().getTime()-this.Di(i.start().addTime(-f)).addTime(f).getTime(),g&&(l=function(e,t){var i=c.Gi(c.Zg(e).current),n=c.Gi(c.Xg(d).cell);if(i>1.2*n){for(var a=t>0?1:-1,t=Math.abs(t);t>=n;)t-=n;t*=a}return t}(i.start(),l))}var m=n.movingEvent?n.movingEvent.calendar:c;m!==c&&m.Hi()!==c.Hi()&&(l=0);var y=0;if(n.moveDragStart&&"Manual"!==c.scale&&m===c){if(o){var b=i.start().addTime(-f),w=this.Di(b);if(c.eventMoveSkipNonBusiness){var D=c.Ii(w,t.i);if(!D)throw new DayPilot.Exception("No next cell found");D.start>w&&(w=D.start)}if(y=n.moveDragStart.getTime()-w.getTime(),c.eventMoveSkipNonBusiness){var k=c.Ji(w,n.moveDragStart);y-=k}var C=60*c.Hi()*1e3;y=Math.floor(y/C)*C}else if(y=n.moveDragStart.getTime()-i.start().addTime(-f).getTime(),c.eventMoveSkipNonBusiness){var k=c.Ji(i.start().addTime(-f),n.moveDragStart);y-=k}if(c.eventMoveSkipNonBusiness){var x=c.getDate(c.coords.x,!0);y=c.Ki(x,y,t.i)}}else y=0;this.eventMoveToPosition&&(y=0);var P=this.getDate(d,!0).addTime(-y).addTime(f);n.resizing&&(P=i.start()),this.snapToGrid&&(P=this.Di(P.addTime(-f)).addTime(f)),P=P.addTime(l);var S=P.addTime(a),A=P,T=S;if(v){A=P.addTime(-f),T=A.addTime(a);var E=t.element.data.start.getTime()-this.Ba().getTime();P=A.addTime(E),S=P.addTime(a)}!function(){if(c.eventMoveSkipNonBusiness){var e=t.i,n=c.Li(i),a=n,o=c.Ii(A,e);if(!o)throw new DayPilot.Exception("No next cell found");var r=DayPilot.indexOf(c.itline,o);if(o.start>P)P=o.start;else{if(n-=o.end.getTime()-A.getTime(),n<=0)return S=P.addTime(a),void(T=S.addTime(-f));r+=1}A=P.addTime(-f);for(var s=r;s<c.itline.length;s++){if(c.Ai(s,e).business){var l=c.itline[s],d=l.start.addTime(f),h=l.end.addTime(f),u=h.getTime()-d.getTime();if(n<=u)return S=d.addTime(n),void(T=S.addTime(-f));n-=u}}S=d.addTime(n),T=S.addTime(-f)}}();var M=this.getPixels(A),H=this.getPixels(T),R=o?M.boxLeft:M.left,B=o?H.boxRight-R:H.left-R;r&&(B=s,R-=B/2);var N={};return N.top=t.top,N.left=R,N.row=t.element,N.rowIndex=t.i,N.width=B,N.start=P,N.end=S,N.relativeY=c.coords.y-t.top,N},this.gi=function(e){var t=this.bi(c.coords.y);if("function"!=typeof e.end)throw"e.end function is not defined";if(!e.end())throw"e.end() returns null";var i=DayPilot.DateUtil.diff(e.rawend(),e.start());i=Math.max(i,1);var a=_.useBox(i),o=e.data&&"Milestone"===e.data.type,r=c.eventHeight,s=0,l=c.coords.x;if(o&&(l+=r/2),"Manual"===c.scale){var d=function(){var e=c.getDate(c.coords.x,!0,!0),t=e.addTime(-i),n=c.getPixels(t).boxLeft,a=c.getPixels(e).boxRight,e=Math.min(a,c.coords.x);return e-n}(),h=Math.min(n.moveOffsetX?n.moveOffsetX:0,d);l=c.coords.x-h}var u=0,f="Days"===this.viewType||this.Fi();if(f&&!e.part.external&&(u=this.rowlist[e.part.dayIndex].start.getTime()-this.Ba().getTime()),a&&!o){var v=c.Zg(e.start()),p=!v.hidden&&!v.past;s=e.start().getTime()-this.Di(e.start().addTime(-u)).addTime(u).getTime(),p&&(s=function(e,t){var i=c.Gi(c.Zg(e).current),n=c.Gi(c.Xg(l).cell);if(i>1.2*n){for(var a=t>0?1:-1,t=Math.abs(t);t>=n;)t-=n;t*=a}return t}(e.start(),s))}var g=n.movingEvent?n.movingEvent.calendar:c;g!==c&&g.Hi()!==c.Hi()&&(s=0);var m=0;if(n.moveDragStart&&"Manual"!==c.scale&&g===c)if(a){var y=e.start().addTime(-u),b=this.Di(y);m=n.moveDragStart.getTime()-b.getTime();var w=60*c.Hi()*1e3;m=Math.floor(m/w)*w}else m=n.moveDragStart.getTime()-e.start().addTime(-u).getTime();else m=0;this.eventMoveToPosition&&(m=0);var D=this.getDate(l,!0).addTime(-m).addTime(u);n.resizing&&(D=e.start()),this.snapToGrid&&(D=this.Di(D.addTime(-u)).addTime(u)),D=D.addTime(s);var k=D.addTime(i),C=D,x=k;if(f){C=D.addTime(-u),x=C.addTime(i);var P=t.element.data.start.getTime()-this.Ba().getTime();D=C.addTime(P),k=D.addTime(i)}if(n.moveDragStart&&c.eventMoveSkipNonBusiness){var S=t.i,A=n.moveDragStart.addTime(u);this.snapToGrid&&(A=this.Di(A.addTime(-u)).addTime(u));var T=!e.part.dayIndex,E=0;
T||(E=c.Mi(e.start(),A,e.part.dayIndex));var i=c.Li(e),M=c.getDate(l,!0);c.snapToGrid&&(M=c.getDate(l));var h=c.Ni(M,E,S);D=M.addTime(-h).addTime(u),this.snapToGrid&&(D=this.Di(D.addTime(-u)).addTime(u)),s=T?0:c.Mi(this.Di(e.start().addTime(-u)).addTime(u),e.start(),S),D=D.addTime(s),k=c.Oi(D,i,S),k>=c.visibleEnd()&&(k=c.visibleEnd(),D=k.addTime(-c.Ki(k,i))),C=D.addTime(-u),x=k.addTime(-u)}var H=this.getPixels(C),R=this.getPixels(x),B=a?H.boxLeft:H.left,N=a?R.boxRight-B:R.left-B;o&&(N=r,B-=N/2);var U={};return U.top=t.top,U.left=B,U.row=t.element,U.rowIndex=t.i,U.width=N,U.start=D,U.end=k,U.relativeY=c.coords.y-t.top,U},this.Ji=function(e,t){var i=c.Zg(e),n=c.Zg(t),a=null,o=0;i.hidden&&(a=e);for(var r=i.i;r<=n.i;r++){var s=c.itline[r];a&&a<s.start&&(o+=s.start.getTime()-a.getTime()),a=s.end}return o},this.Oi=function(e,t,i){var n=t,a=c.rowlist[i],o=a.data.start.getTime()-c.Ba().getTime(),r=e.addTime(-o),s=c.Ii(r,i);if(!s)throw new DayPilot.Exception("No next cell found");var l=DayPilot.indexOf(c.itline,s);if(s.start>e);else{if(n-=s.end.getTime()-r.getTime(),n<=0)return e.addTime(t);l+=1}for(var d=l;d<c.itline.length;d++){if(c.Ai(d,i).business){var h=c.itline[d],u=h.start.addTime(o),f=h.end.addTime(o),v=f.getTime()-u.getTime();if(n<=v)return u.addTime(n);n-=v}}return u||(u=c.itline[c.itline.length-1].end),u.addTime(n)},this.Mi=function(e,t,i){var n=c.rowlist[i],a=n.data.start.getTime()-c.Ba().getTime(),o=(c.Zg(e),e.addTime(-a)),r=t.addTime(-a),s=c.Ii(o,i);if(!s)throw new DayPilot.Exception("No next cell found");var l=0,d=DayPilot.indexOf(c.itline,s);if(s.start<=r){if(t<s.end.addTime(a))return s.start>o?t.getTime()-s.start.addTime(a).getTime():t.getTime()-e.getTime();l+=o>s.start?s.end.getTime()-o.getTime():s.end.getTime()-s.start.getTime(),d+=1}for(var h=d;h<c.itline.length;h++){if(c.Ai(h,i).business){var u=c.itline[h],f=u.start.addTime(a),v=u.end.addTime(a),p=v.getTime()-f.getTime();if(t<f)return l;if(t<v)return l+=t.getTime()-f.getTime();l+=p}}var g=t.getTime()-c.itline.last().end.addTime(a).getTime();return l+=Math.min(0,g)},this.Li=function(e){if(e.part.duration){if(isNaN(e.part.duration))throw new DayPilot.Error("Unable to get calculated duration");return e.part.duration}var t=e.part.dayIndex;return c.Mi(e.start(),e.rawend(),t)},this.Ki=function(e,t){var i=0,n=t,a=c.Zg(e);if(!a.current)throw new DayPilot.Exception("Current cell not found.");if(e.addTime(-t)>a.current.start)return t;i+=e.getTime()-a.current.start.getTime(),n-=e.getTime()-a.current.start.getTime();var o=DayPilot.indexOf(c.itline,a.current);o-=1;for(var r=a.current.start;o>=0;){var a=c.itline[o];r>a.end&&(i+=r.getTime()-a.end.getTime()),r=a.start;var s=a.end.getTime()-a.start.getTime();if(n<=s)return i+=n;i+=s,n-=s,o-=1}throw new DayPilot.Exception("Unable to backward calculate offset in visible timeline")},this.Ni=function(e,t,i){var n=0,a=t,o=c.Zg(e);if(!o.current)throw new DayPilot.Exception("Current cell not found.");var r=DayPilot.indexOf(c.itline,o.current);if(c.Ai(r,i).business){if(e.addTime(-t)>=o.current.start)return t}else if(0===t||e.addTime(-t)>=o.current.start)return e.getTime()-c.Ii(e,i).start.getTime();n+=e.getTime()-o.current.start.getTime(),a-=e.getTime()-o.current.start.getTime(),r-=1;for(var s=o.current.start;r>=0;){var o=c.itline[r];s>o.end&&(n+=s.getTime()-o.end.getTime()),s=o.start;var l=o.end.getTime()-o.start.getTime();if(c.Ai(r,i).business){if(a<=l)return n+=a;n+=l,a-=l}else n+=l;r-=1}return n+a},this.Ii=function(e,t){var i=c.Zg(e),n=0;if(i.past)return null;if(i.current)n=i.i;else{if(!i.next)return null;n=DayPilot.indexOf(c.itline,i.next)}for(var a=n;a<c.itline.length;a++){if(c.Pi(a,t))return c.itline[a]}return null},this.Pi=function(e,t){return c.Ai(e,t).business},this.Hi=function(){switch(this.scale){case"CellDuration":return this.cellDuration;case"Minute":return 1;case"Hour":return 60;case"Day":return 1440;case"Week":return 10080;case"Month":return 43200;case"Year":return 525600;case"Manual":if(c.itline.length>0){var e=c.itline[0];return(e.end.getTime()-e.start.getTime())/6e4}return c.cellDuration}throw"can't guess cellDuration value"},this.Gi=function(e){return e.end.ticks-e.start.ticks},this.hi=function(e){return this.treePreventParentUsage&&this.Qi(e)},this.Qi=function(e){var t=this.rowlist[e];return!!t.isParent||!!(this.treeEnabled&&t.children&&t.children.length>0)},this.Ri={},this.Si=function(){if(c.treeAutoExpand){var e=this.gi(n.movingEvent),t=e.rowIndex,i=this.Qi(t),a=this.Ri;if(a.timeout&&a.y!==t&&(clearTimeout(a.timeout),a.timeout=null),i){a.y=t;var o=!c.rowlist[a.y].expanded;!a.timeout&&o&&(a.timeout=setTimeout(function(){!c.rowlist[a.y].expanded&&(c.Ti(a.y),c.Ui()),a.timeout=null},500))}}},this.Dc=function(){var e=n.resizingShadow.width,t=n.resizingShadow.left,i=n.resizingEvent,a=n.resizing.dpBorder,o=c.rowlist[i.part.dayIndex],r=0;r=o.start.getTime()-c.Ba().getTime();var s=null,l=null,d=!c.snapToGrid;"left"===a?(s=c.getDate(t,d).addTime(r),l=i.rawend()):"right"===a&&(s=i.start(),l=c.getDate(t+e,d,!0).addTime(r)),n.resizingShadow.start=s,n.resizingShadow.end=l,b.update()},this.exportAs=function(e,t){var i=m.generate(e,t);return new DayPilot.Export(i)},this["export"]=this.exportAs,this.jd={};var m=this.jd;m.getWidth=function(){var e=m.ld;switch(e){case"viewport":return c.nav.top.offsetWidth;case"full":return c.Dg()+m.getRowHeaderWidth();case"range":return c.getPixels(m.getRangeEnd()).boxRight-c.getPixels(m.getRangeStart()).boxLeft+m.getRowHeaderWidth();default:throw"Unsupported export mode: "+e}},m.getHeight=function(){var e=m.ld;switch(e){case"viewport":return c.nav.top.offsetHeight-DayPilot.sh(c.nav.scroll)-1;case"full":return c.Vi()+c.Fg()-DayPilot.sh(c.nav.scroll);case"range":var t=m.getRows();if(0===t.length)return c.Fg();var i=t.first(),n=t.last();return n.top-i.top+n.height+c.Fg();default:throw"Unsupported export mode: "+e}},m.getRangeStart=function(){var e=m.kd.dateFrom||c.Ba();return new DayPilot.Date(e)},m.getRangeEnd=function(){var e=m.kd.dateTo||c.Tg();return new DayPilot.Date(e)},m.getRangeResStart=function(){return m.kd.resourceFrom?c.sg(m.kd.resourceFrom):c.rowlist.find(function(e){return!e.hidden})},m.getRangeResEnd=function(){return m.kd.resourceTo?c.sg(m.kd.resourceTo):c.rowlist.last()},m.getRowHeaderWidth=function(){return c.Gg()},m.getTimeHeaderHeight=function(){return c.Fg()},m.getCanvas=function(){return m.canvas()},m.getRectangles=function(){var e=m.getRowHeaderWidth(),t=m.getTimeHeaderHeight(),i={};i.main={"x":0,"y":0,"w":m.getWidth(),"h":m.getHeight()},i.corner={"x":0,"y":0,"w":e,"h":t},i.grid={"x":e,"y":t,"w":m.getWidth()-e,"h":m.getHeight()-t};var n=i.grid.w,a=c.itline.last();a&&a.left+a.width<i.grid.w&&(n=a.left+a.width);var o=i.grid.h,r=c.rowlist.last();return r&&r.top+r.height<i.grid.h&&(o=r.top+r.height),i.gridContent={"x":e,"y":t,"w":n,"h":o},i},m.getRows=function(){var e,t,i,n,a=m.ld,o=DayPilot.list();switch(a){case"viewport":e=c.Wi,t=e+c.nav.scroll.offsetHeight,i=c.bi(e).i,n=c.bi(t).i;break;case"full":e=0,i=0,n=c.rowlist.length;break;case"range":var r=m.getRangeResStart(),s=m.getRangeResEnd();if(!r)throw"Resource specified using resourceFrom option not found during export.";if(!s)throw"Resource specified using resourceTo option not found during export.";i=r.index,n=s.index}n<c.rowlist.length&&(n+=1);for(var l=i;l<n;l++){var d=c.rowlist[l];d.hidden||o.push(d)}return o.offset=i,o},m.getEvents=function(){var e=m.ld;switch(e){case"full":var t=DayPilot.list();return DayPilot.list(c.rowlist).each(function(e){e.hidden||DayPilot.list(e.events).each(function(e){t.push(e)})}),t;case"viewport":return h.events().map(function(e){return e.event});case"range":var t=DayPilot.list(),i=m.getRangeStart(),n=m.getRangeEnd();return m.getRows().each(function(e){DayPilot.list(e.events).filter(function(e){return DayPilot.Util.overlaps(e.start(),e.end(),i,n)}).each(function(e){t.push(e)})}),t;default:throw"Unsupported export mode: "+e}},m.getTimeline=function(){var e=m.ld;switch(e){case"full":return DayPilot.list(c.itline).addProps({"offset":0});case"viewport":return m.getViewportTimeline();case"range":return m.getRangeTimeline();default:throw"Unsupported export mode: "+e}},m.getRangeTimeline=function(){var e=DayPilot.list();if(c.itline&&c.itline.length>0){var t=c.Zg(m.getRangeStart()).i,i=c.Zg(m.getRangeEnd()).i,n=c.Xi();i=Math.min(i,n-1),t=Math.max(t,0);for(var a=t;a<=i;a++){var o=c.itline[a];e.push(o)}e.offset=t}return e},m.getViewportTimeline=function(){var e=DayPilot.list();if(c.itline&&c.itline.length>0){var t=c.Yi,i=t+c.Zi,n=c.Xg(t).x,a=c.Xg(i,!0).x,o=c.Xi();a=Math.min(a,o),n=Math.max(n,0);for(var r=n;r<=a;r++){var s=c.itline[r];e.push(s)}e.offset=n}return e},m.getTimeHeader=function(e){if("full"===m.ld)return DayPilot.list(c.timeHeader[e]);var t,i,n=DayPilot.list();t=m.getViewportOffsetStart(),i=t+m.getViewportOffsetWidth();var a=c.$i(e,t),o=c.$i(e,i);o||(o={"x":c.timeHeader[e].length-1});for(var r=a.x;r<=o.x;r++){var s=c.timeHeader[e][r];n.push(s)}return n},m.fakeDurationBar=function(){var e=document.createElement("div");e.style.display="none",e.className=c.q(E.event);var t=document.createElement("div");t.className=c.q(E.eventBar);var i=document.createElement("div");return i.className=c.q(E.eventBarInner),document.body.appendChild(e),t.appendChild(i),e.appendChild(t),e},m.fakeCell=function(){var e=document.createElement("div");e.style.display="none",e.className=c.q("_cell"),e.style.position="absolute",e.style.top="-2000px",e.style.left="-2000px";var t=document.createElement("div");return t.className=c.q("_cell_inner"),e.appendChild(t),c.divCells.appendChild(e),e},m.fakeRowHeader=function(){var e=document.createElement("div");e.style.display="none",e.className=c.q("_rowheader"),e.style.position="absolute",e.style.top="-2000px",e.style.left="-2000px";var t=document.createElement("div");return t.className=c.q("_rowheader_inner"),e.appendChild(t),c.divResScroll.appendChild(e),e},m.fakeExpand=function(){var e=document.createElement("div");return e.style.display="none",e.className=c.q("_tree_image_expand"),document.body.appendChild(e),e},m.extractUrl=function(e){var t=/url\((")?([^"].*[^"])\1\)/.exec(e);return t?t[2]:null},m.getImages=function(){var e={},t=m.fakeExpand();return e.expand=m.extractUrl(new DayPilot.StyleReader(t).get("background-image")),t.className=c.q("_tree_image_collapse"),e.collapse=m.extractUrl(new DayPilot.StyleReader(t).get("background-image")),t.className=c.q("_tree_image_no_children"),e.nochildren=m.extractUrl(new DayPilot.StyleReader(t).get("background-image")),DayPilot.de(t),e},m.getFont=function(e){return new DayPilot.StyleReader(e).getFont()},m.getViewportOffsetStart=function(){switch(m.ld){case"full":return 0;case"viewport":return c.nav.scroll.scrollLeft;case"range":return c.getPixels(m.getRangeStart()).boxLeft}},m.getViewportOffsetTop=function(){switch(m.ld){case"full":return 0;case"viewport":return c.nav.scroll.scrollTop;case"range":return m.getRangeResStart().top}},m.getViewportOffsetWidth=function(){switch(m.ld){case"full":return c.Dg();case"viewport":return c.nav.scroll.offsetWidth;case"range":return c.getPixels(m.getRangeEnd()).boxRight-m.getViewportOffsetStart()}},m.excelBoard=function(){var e=new DayPilot.Excel,t=e.worksheets.create("Scheduler"),i=new DayPilot.StyleReader(c.nav.corner).get("background-color"),n=new DayPilot.StyleReader(c.nav.top).get("border-top-color"),a=DayPilot.list(c.elements.events).map(function(e){return e.firstChild}).last(),o=new DayPilot.StyleReader(a).get("border-right-color");e.styles.getDefault().setBackColor("#ffaaaa");var r=e.styles.create();r.setHorizontalAlignment("Center"),r.setBackColor(i),r.setBorderColor(n);var s=e.styles.create();s.setVerticalAlignment("Top"),s.setBackColor(i),s.setBorderColor(n);var l=e.styles.create();l.setVerticalAlignment("Top"),l.setBackColor("#ff0000"),l.setBorderColor(o),t.enableGridlines(!1),t.cell(0,0).setRowspan(c.timeHeader.length).setStyle(r),t.cell(10,10).setText("hi there"),DayPilot.list(c.timeHeader).each(function(e,i){var n={"x":1,"y":0};m.getTimeHeader(i,"full").each(function(e,a){var o=e.colspan;t.cell(a+n.x,i+n.y).setText(e.innerHTML).setColspan(o).setStyle(r)})}),DayPilot.list(c.rowlist).each(function(e,i){for(var n={"x":0,"y":1},a="",o=0;o<e.level;o++)a+="  ";t.cell(n.x,i+n.y).setText(a+e.html).setRowspan(e.lines.length).setStyle(s)});var d={"x":0,"y":c.timeHeader.length},h=d.y;return DayPilot.list(c.rowlist).each(function(e,i){DayPilot.list(e.lines).each(function(e,n){var a=d.x;DayPilot.list(e).each(function(e){var n=c.Zg(e.start()).i,o=c.Zg(e.end()).i,r=1+o-n;t.cell(n+a,i+h).setText(e.client.html()).setColspan(r).setStyle(l),a+=r-1})}),h+=e.lines.length-1}),e},m.kd=null,m.ld=null,m.generate=function(e,t){"object"==typeof e&&(t=e,e=null);var t=t||{},e=e||t.format||"svg",i=t.scale||1;if("xls"===e)return m.excelBoard();if("config"!==e){"jpg"===e.toLowerCase()&&(e="jpeg");var n=t.area||"viewport";m.kd=t,m.ld=n,m.getRows().each(function(e){c._i(e)});var a,o=m.getWidth(),r=m.getHeight();switch(e.toLowerCase()){case"svg":a=new DayPilot.Svg(o,r);break;case"png":a=new DayPilot.Canvas(o,r,"image/png",i);break;case"jpeg":a=new DayPilot.Canvas(o,r,"image/jpeg",i,t.quality);break;default:throw"Export format not supported: "+e}var s=m.getRectangles(),l=m.getImages(),d=new DayPilot.StyleReader(c.nav.top).get("background-color"),h=new DayPilot.StyleReader(c.nav.corner).get("background-color"),u=new DayPilot.StyleReader(c.nav.top).get("border-top-color"),f=new DayPilot.StyleReader(c.nav.divider).get("background-color"),v=DayPilot.list(c.elements.events).map(function(e){return e.firstChild}).last(),p=new DayPilot.StyleReader(v).get("border-right-color"),g=m.getFont(v),y=new DayPilot.StyleReader(v).get("color"),b=new DayPilot.StyleReader(v).get("background-color");b=DayPilot.Util.isTransparentColor(b)?"white":b;var w=m.fakeDurationBar(),D=new DayPilot.StyleReader(w.firstChild).get("background-color"),k=new DayPilot.StyleReader(w.firstChild.firstChild).get("background-color");DayPilot.de(w);var C=m.fakeCell(),x=new DayPilot.StyleReader(C).get("background-color");DayPilot.Util.addClass(C,c.q("_cell_business"));var P=new DayPilot.StyleReader(C).get("background-color"),S=m.getFont(C),A=new DayPilot.StyleReader(C).get("color");DayPilot.de(C);var T=DayPilot.Util.firstPropValue(c.t.linesVertical),E=new DayPilot.StyleReader(T).get("background-color"),M=c.t.timeHeader["0_0"],H=m.getFont(M),_=new DayPilot.StyleReader(M).get("color"),B=new DayPilot.StyleReader(M).get("background-color"),N=m.fakeRowHeader(),U=m.getFont(N),L=new DayPilot.StyleReader(N).get("color"),z=new DayPilot.StyleReader(N).get("background-color");if(DayPilot.de(N),c.rowHeaderColumns&&c.fi&&c.fi.blocks[0])var O=c.fi.blocks[0].section.firstChild,I=new DayPilot.StyleReader(O).getFont(),F=new DayPilot.StyleReader(O).get("color");var W=m.getViewportOffsetStart(),j=m.getViewportOffsetTop();a.fillRect(s.main,"white"),a.fillRect(s.main,d),a.fillRect(s.corner,h);var q=s.corner.x;DayPilot.list(c.rowHeaderColumns).each(function(e,t){var i=c.rowHeaderCols[t],n={};n.x=q,n.w=i+1,n.y=s.corner.h-c.fi.height,n.h=c.fi.height+1;var o=3,r=DayPilot.Util.copyProps(n);r.x+=o,r.w-=o,a.text(r,e.title,I,F),a.rect(n,u),q+=i});var G="function"==typeof c.onBeforeTimeHeaderExport;DayPilot.list(c.timeHeader).each(function(e,t){m.getTimeHeader(t,n).each(function(e){var i=s.grid.x+e.left-W,n=e.width,o=R.timeHeader(t),r=o.top,l=o.height,d=e.innerHTML,h=e.backColor;if(G){var f={};f.header={},f.header.start=e.start,f.header.end=e.end,f.header.level=t,f.header.text=e.text,f.header.html=e.innerHTML,f.text=e.innerHTML,f.backColor=e.backColor,c.onBeforeTimeHeaderExport(f),d=f.text,h=f.backColor}var v=Math.max(0,s.grid.x-i);i+=v,n-=v;var v=Math.max(0,i+n-(s.grid.x+s.grid.w));n-=v;var p={"x":i,"y":r,"w":n+1,"h":l+1};h=h||B,a.fillRect(p,h),a.rect(p,u),a.text(p,d,H,_,"center")})}),m.getTimeline().each(function(e){var t=s.grid.x+e.left-W;t+=Math.max(0,s.grid.x-t),t!==s.grid.x&&a.line(t,s.grid.y+1,t,s.grid.y+s.grid.h-2,E)});var J="function"==typeof c.onBeforeCellExport;m.getRows().each(function(e,t,i){var t=e.index;m.getTimeline().each(function(i,n,o){var n=o.offset+n,r=c.Ai(n,t),l=r.business,d=c.aj(n,t),h=r.html,u="left",f=r.backColor||(l?P:x);J&&(d||(d={},d.cell=c.cells.findXy(n,t)[0]),d.text=h,d.horizontalAlignment=u,d.backColor=f,c.onBeforeCellExport(d),h=d.text,u=d.horizontalAlignment,f=d.backColor);var v=s.grid.y+e.top-j;v+=Math.max(0,s.grid.y-v);var p=s.grid.x+i.left-W;p+=Math.max(0,s.grid.x-p);var g={"x":p,"y":v,"w":i.width,"h":e.height};a.fillRect(g,f);var m={};m.x=g.x+1,m.y=g.y+1,m.w=g.w-2,m.h=g.h-2,h&&a.text(m,h,S,A,u)})}),m.getRows().each(function(e){var t=s.grid.y+e.top-j;t+=Math.max(0,s.grid.y-t),t!==s.grid.y&&a.line(s.gridContent.x+1,t,s.gridContent.x+s.gridContent.w-1,t,E)});var V="function"==typeof c.onBeforeRowHeaderRender,Y="function"==typeof c.onBeforeRowHeaderExport;return m.getRows().each(function(e){var t=s.grid.y+e.top-j;t+=Math.max(0,s.grid.y-t);var i=10,n=e.level*c.treeIndent+c.treeImageMarginLeft,o={"x":0,"y":t,"w":s.grid.x+1,"h":e.height+1},r=e;if(V){r=c.bj(e).row}var d={};d.text=r.html,d.backColor=r.backColor||z,d.fontSize=U.size,d.fontFamily=U.family,d.fontStyle=U.style,d.fontColor=L,d.borderColor=u,d.horizontalAlignment="left",Y&&(d.row=c.Jh(e),c.onBeforeRowHeaderExport(d));var h={"x":n,"y":t+c.treeImageMarginTop,"w":10,"h":10},f=c.treeEnabled?n+i+3:n,v={"x":f,"y":t,"w":o.w-(n+i),"h":e.height+1};if(a.fillRect(o,d.backColor),a.text(v,d.text,{"size":d.fontSize,"family":d.fontFamily,"style":d.fontStyle},d.fontColor,d.horizontalAlignment),a.rect(o,d.borderColor),c.treeEnabled){var p=null;p=DayPilot.list(e.children).isEmpty()?l.nochildren:e.expanded?l.collapse:l.expand,a.image(h,p)}if(c.rowHeaderCols){var n=o.x;DayPilot.list(c.rowHeaderCols).each(function(e,t){if(0!==t){var i=r.columns[t-1],s=DayPilot.Util.copyProps(o);s.x=n,s.w=e;var l=3,c=DayPilot.Util.copyProps(s);c.x+=l,c.w-=l;var h=i.html||"",u=i.backColor||d.backColor;a.fillRect(s,u),h&&a.text(c,h,{"size":d.fontSize,"family":d.fontFamily,"style":d.fontStyle},d.fontColor,d.horizontalAlignment),a.rect(s,d.borderColor)}n+=e})}}),m.getEvents().each(function(e){var t=c.rowlist[e.part.dayIndex].top,i=e.part.width,n=e.part.barWidth,o=e.client&&e.client.barVisible&&e.client.barVisible(),r=s.grid.y+t+e.part.top-j;r+=Math.max(0,s.grid.y-r);var l=s.grid.x+e.part.left-W,d=Math.max(0,s.grid.x-l);l+=d,i-=d,n-=d;var h=e.cache||e.data,u=h.barColor||k,f=h.barBackColor||D,v=h.backColor||b,m=h.fontColor||y,w=5,C=2,x=2,P={};P.e=e,P.text=e.text?e.text():e.client.html(),P.fontSize=g.size,P.fontFamily=g.family,P.fontStyle=g.style,P.fontColor=m,P.backColor=v,P.borderColor=p,P.horizontalAlignment="left",P.barHeight=w,"function"==typeof c.onBeforeEventExport&&c.onBeforeEventExport(P);var S={"x":l,"y":r,"w":i,"h":e.part.height},A={"x":l,"y":r,"w":i,"h":P.barHeight},T={"x":l+e.part.barLeft,"y":r,"w":n,"h":w};({"x":l+C,"y":r+w,"w":i-C,"h":e.part.height-w});a.fillRect(S,P.backColor),a.text(S,P.text,{"size":P.fontSize,"family":P.fontFamily,"style":P.fontStyle},P.fontColor,P.horizontalAlignment,x),a.rect(S,P.borderColor),o&&(a.fillRect(A,f),n>0&&a.fillRect(T,u)),DayPilot.list(h.areas).each(function(t){if("Hover"!==(t.visibility||t.v)){var i=t.left;t.start&&(i=c.getPixels(new DayPilot.Date(t.start)).left-e.part.left);var n=t.width||t.w;t.right?n=e.part.width-t.right-i:t.end&&(n=c.getPixels(new DayPilot.Date(t.end)).left-t.left-e.part.left+1);var o=t.top,s=t.height||t.h;"number"==typeof t.bottom&&(s=e.part.height-t.bottom-o);var d={"x":l+i,"y":r+o,"w":n,"h":s};if(t.backColor&&a.fillRect(d,t.backColor),t.image){var h=new Image;h.src=t.image,a.image(d,h)}else t.html&&a.text(d,t.html,{"size":P.fontSize,"family":P.fontFamily,"style":P.fontStyle},t.fontColor||P.fontColor,null,t.padding)}})}),a.rect(s.main,u),a.line(s.grid.x,0,s.grid.x,s.main.h,f),a.line(0,s.grid.y,s.main.w,s.grid.y,f),a}},this.cj={};var y=this.cj;y.findJointDivs=function(e){var t=e.data.join;return t?DayPilot.list(c.elements.events).filter(function(i){return i.event.data.join===t&&i.event!==e}):DayPilot.list()},this.dj={};var b=this.dj;b.divs=[],b.list=[],b.forbidden=!1,b.additional=function(){var e=DayPilot.list(),t=c.multiselect.isSelected(n.resizing.event),i=c.allowMultiResize,e=DayPilot.list();if(t&&i&&(e=DayPilot.list(c.multiselect.divs).filter(function(e){return e!==n.resizing})),c.jointEventsResize){var a=y.findJointDivs(n.resizingEvent);e=e.concat(a)}return e},b.update=function(){b.clear(),b.draw()},b.clear=function(){DayPilot.de(b.divs),b.divs=[]},b.draw=function(){if(n.resizing){var e=n.resizingEvent,t=n.resizingShadow,i=t.start.getTime()-e.start().getTime(),a=t.end.getTime()-e.end().getTime(),o=0;if(b.list=[],b.forbidden=!1,b.invalid=!1,b.rowoffset=o,b.additional().each(function(e){if(e.event){var t=e.event,n=c.rowlist[t.part.dayIndex+o];if(!n)return void(b.invalid=!0);var r=t.part.top+n.top,s=t.part.height,l=t.start().addTime(i),d=t.end().addTime(a),h={};h.event=t,h.start=l,h.end=d,h.overlapping=!1,b.list.push(h);var u=c.getPixels(l),f=c.getPixels(d),v=DayPilot.DateUtil.diff(t.rawend(),t.start());v=Math.max(v,1);var p=_.useBox(v),g=p?u.boxLeft:u.left,m=p?f.boxRight-g:f.left-g,y=document.createElement("div");y.style.position="absolute",y.style.left=g+"px",y.style.top=r+"px",y.style.height=s+"px",y.style.width=m+"px",y.style.zIndex=101,y.style.overflow="hidden",y.className=c.q("_shadow"),y.info=h;var w=document.createElement("div");w.className=c.q("_shadow_inner"),y.appendChild(w),c.pg.appendChild(y),b.divs.push(y)}}),b.invalid){var r=c.q("_shadow_overlap");return void DayPilot.list(b.divs).each(function(e){DayPilot.Util.addClass(e,r)})}DayPilot.list(b.divs).each(function(e){if(e.info){var t=e,i=e.info,a=e.info.event,r=c.rowlist[a.part.dayIndex+o],s=c.getPixels(i.start),l=c.getPixels(i.end),d=s.left,h=l.left-d,u=DayPilot.list(b.list).map(function(e){return e.event.data}).add(n.resizing.event.data);c.ej(t,r,d,h,u),t.overlapping&&(i.overlapping=!0,b.forbidden=!0)}})}},this.fj={},this.fj.modifiedProps=function(){var e=new DayPilot.Scheduler,t=DayPilot.Util.members(c,2),i=[];return i.push("<div id='dp'></div>"),i.push("<script>"),i.push("var dp = new DayPilot.Scheduler('dp');"),t.properties.each(function(t){var n,a,o=t.name,r=o.split(".");if(r.length>1){var s=r[0],l=r[1];n=DayPilot.JSON.stringify(e[s][l]),a=DayPilot.JSON.stringify(c[s][l])}else n=DayPilot.JSON.stringify(e[o]),a=DayPilot.JSON.stringify(c[o]);n!==a&&i.push("dp."+o+" = "+a+";")}),t.events.each(function(e){var t=e.name;"function"==typeof c[t]&&i.push("dp."+t+" = "+c[t].toString()+";")}),i.push("dp.init();"),i.push("</script>"),i.join("\n")},this.gj={};var w=this.gj;w.divs=[],w.list=[],w.forbidden=!1,w.verticalAll=function(){return"All"===c.multiMoveVerticalMode},w.additional=function(){var e=DayPilot.list(),t=c.multiselect.isSelected(n.movingEvent),i=c.allowMultiMove,e=DayPilot.list();if(t&&i&&(e=DayPilot.list(c.multiselect.divs).filter(function(e){return e!==n.moving&&e!==A.moving})),c.jointEventsMove){var a=y.findJointDivs(n.movingEvent);e=e.concat(a)}return e},w.update=function(){w.clear(),w.draw()},w.draw=function(){if(n.moving){var e=n.movingEvent,t=n.movingShadow.start,i=t.getTime()-e.start().getTime(),a=e.part.dayIndex,o=DayPilot.indexOf(c.rowlist,n.movingShadow.row),r=o-a;if(w.verticalAll()||(r=0),w.list=[],w.forbidden=!1,w.invalid=!1,w.rowoffset=r,w.additional().each(function(e){if(e.event){var t=e.event,n=c.rowlist[t.part.dayIndex+r];if(!n)return void(w.invalid=!0);var a=t.part.top+n.top,o=t.part.height;r&&(a=n.top,o=n.height);var s=t.start().addTime(i),l=t.end().addTime(i),d={};d.event=t,d.start=s,d.end=l,d.resource=n.id,d.overlapping=!1,w.list.push(d);var h=c.getPixels(s),u=c.getPixels(l),f=DayPilot.DateUtil.diff(t.rawend(),t.start());f=Math.max(f,1);var v=_.useBox(f),p=v?h.boxLeft:h.left,g=v?u.boxRight-p:u.left-p,m=document.createElement("div");m.style.position="absolute",m.style.left=p+"px",m.style.top=a+"px",m.style.height=o+"px",m.style.width=g+"px",m.style.zIndex=101,m.style.overflow="hidden",m.className=c.q("_shadow"),m.info=d;var y=document.createElement("div");y.className=c.q("_shadow_inner"),m.appendChild(y),c.pg.appendChild(m),w.divs.push(m)}}),w.invalid){var s=c.q("_shadow_overlap");return void DayPilot.list(w.divs).each(function(e){DayPilot.Util.addClass(e,s)})}DayPilot.list(w.divs).each(function(e){if(e.info){var t=e,i=e.info,a=e.info.event,o=c.rowlist[a.part.dayIndex+r],s=c.getPixels(i.start),l=c.getPixels(i.end),d=s.left,h=l.left-d,u=DayPilot.list(w.list).map(function(e){return e.event.data}).add(n.movingEvent.data);c.ej(t,o,d,h,u),t.overlapping&&(i.overlapping=!0,w.forbidden=!0)}})}},w.clear=function(){DayPilot.de(w.divs),w.divs=[]},this.hj=function(){var e=c.coords,t=n.resizing.dpBorder,i=n.resizing.event,a=i.part.left;"right"==t&&(a+=i.part.width);var o,r,s=n.resizing.event.calendar.cellWidth,l=n.resizing.event.part.width,d=n.resizing.event.part.left,h=0,u=e.x-a;if("right"===t){if(o=d,c.snapToGrid){var f=c.Xg(l+d+u).cell;r=f.left+f.width-d,r<s&&(r=s)}else r=l+u;var v=c.Dg();d+r>v&&(r=v-d),n.resizingShadow.left=d,n.resizingShadow.width=r}else{if("left"!==t)throw"Invalid dpBorder.";c.snapToGrid?(u>=l&&(u=l),o=Math.floor((d+u+0)/s)*s,o<h&&(o=h)):o=d+u,r=l-(o-d);var p=d+l,g=s;c.snapToGrid?"Never"===c.useEventBoxes&&(g=l<s?l:1):g=1,r<g&&(r=g,o=p-r),n.resizingShadow.left=o,n.resizingShadow.width=r}!function(){var e=n.resizing.event,t=c.rowlist[e.part.dayIndex],i=o,a=r;c.ej(n.resizingShadow,t,i,a,e.data)}(),c.ij()},this.Ui=function(){this.nav.scroll;if(c.coords&&n.movingEvent){c.Ea();var e=n.movingShadow,t=this.gi(n.movingEvent);if(!c.hi(t.rowIndex)){var i=n.movingEvent,a=0,o=0;!function(){if(c.cellStacking){var e=t.relativeY,i=c.Xg(t.left).x,n=t.row,r=n.evColumns[i],s=r.events.find(function(t){return e<t.part.top+t.part.height+c.eventMarginBottom});s||(s=r.events.last()),s&&(o=s.part.top,a=DayPilot.indexOf(r.events,s),e-s.part.top>s.part.height/2&&(o=s.part.top+s.part.height+c.eventMarginBottom/2,a+=1))}else{for(var e=t.relativeY,n=t.row,l=0,d=c.sc.eventHeight(),h=n.lines.length,u=0;u<n.lines.length;u++){if(n.lines[u].isFree(t.left,c.cellWidth)){h=u;break}}var f=Math.floor((e-l+d/2)/d),f=Math.min(h,f),f=Math.max(0,f);a=f,o=c.rowMarginTop+a*(c.sc.eventHeight()+c.eventMarginBottom)+c.eventMarginBottom/2}}(),o>0&&(o-=3);var r=i.cache&&"undefined"!=typeof i.cache.moveVDisabled?!i.cache.moveVDisabled:!i.data.moveVDisabled,s=i.cache&&"undefined"!=typeof i.cache.moveHDisabled?!i.cache.moveHDisabled:!i.data.moveHDisabled,l=!w.additional().isEmpty();if(l&&"Disabled"===c.multiMoveVerticalMode&&(r=!1),r)if(this.hi(t.rowIndex)){var d=e.row,h=1;if(!d)return;h=t.rowIndex<d.index?1:-1;for(var u=t.rowIndex;u!==d.index;u+=h){var f=this.rowlist[u];if(!this.hi(u)&&!f.hidden){e.style.top=f.top+"px",e.style.height=Math.max(f.height,0)+"px",e.row=f,c.eventMoveToPosition&&(a=h>0?0:f.lines.length-1,e.style.top=t.top+o+"px",e.style.height="3px",e.line=a);break}}}else e.row=t.row,e.style.height=Math.max(t.row.height,0)+"px",e.style.top=t.top+"px",c.eventMoveToPosition&&(e.style.top=t.top+o+"px",e.style.height="3px",e.line=a);else{for(var d=c.rowlist[i.part.dayIndex],v=d.lines.length,u=0;u<d.lines.length;u++){if(d.lines[u].isFree(t.left,c.cellWidth)){v=u;break}}if(l||(e.style.height=Math.max(d.height,0)+"px",e.style.top=d.top+"px"),e.row=d,c.eventMoveToPosition&&!l)if(t.row===d)e.style.top=d.top+o+"px",e.style.height="3px",e.line=a;else{var p=t.rowIndex>d.index&&v>0?v*c.sc.eventHeight()-3:0;e.style.top=d.top+p+"px",e.style.height="3px",e.line=0}}s?(e.style.left=t.left+"px",c.eventMoveToPosition?e.style.width=c.cellWidth+"px":e.style.width=t.width+"px",e.start=t.start,e.end=t.end):(e.style.left=i.part.left+"px",e.start=i.start(),e.end=i.rawend(),t.left=i.part.left),function(){var n=e.row,a=i.data,o=t.width,r=t.left,s=DayPilot.list(w.list).map(function(e){return e.event.data}).add(a);c.ej(e,n,r,o,s)}(),function(){var t=c.Ah;if(!t||t.start.getTime()!==e.start.getTime()||t.end.getTime()!==e.end.getTime()||t.resource!==e.row.id){w.update();var r=!!n.drag&&i.part.external,s={};s.start=e.start,s.end=c.df(e.end),s.duration=new DayPilot.Duration(s.start,s.end),s.e=i,s.external=r,s.resource=e.row.id,s.html=null,s.row=c.Jh(e.row),s.position=e.line,s.overlapping=e.overlapping||w.forbidden,s.allowed=!0,s.left={},s.left.html=s.start.toString(c.eventMovingStartEndFormat,_.locale()),s.left.enabled=c.eventMovingStartEndEnabled,s.left.space=5,s.left.width=null,s.right={},s.right.html=s.end.toString(c.eventMovingStartEndFormat,_.locale()),s.right.enabled=c.eventMovingStartEndEnabled,s.right.space=5,s.right.width=null,s.multimove=DayPilot.list(w.list),s.shift=c.coords.shift,s.ctrl=c.coords.ctrl,s.meta=c.coords.meta,s.alt=c.coords.alt;var l={};l.event=i,l.start=s.start,l.end=s.end,l.overlapping=s.overlapping,l.resource=s.resource,s.multimove.splice(0,0,l),c.Ah=s;var d={"start":s.start,"end":s.end,"resource":s.resource};if("function"==typeof c.onEventMoving&&c.onEventMoving(s),e.allowed=s.allowed,s.start!==d.start||s.end!==d.end){var h=s.start,u=c.Ee(s.end);e.start=h,e.end=u;var f=DayPilot.DateUtil.diff(h,u);f=Math.max(f,1);var v=_.useBox(f),p=v?c.getPixels(h).boxLeft:c.getPixels(h).left,g=v?c.getPixels(u).boxRight:c.getPixels(u).left;e.style.left=p+"px",e.style.width=g-p+"px"}if(s.resource!==d.resource){var m=c.sg(s.resource);m&&(e.row=m,e.style.height=Math.max(m.height,0)+"px",e.style.top=m.top+"px",c.eventMoveToPosition&&(e.style.top=m.top+o+"px",e.style.height="3px",e.line=a))}s.html?e.firstChild.innerHTML=s.html:e.firstChild.innerHTML="",c.jj(e,s),DayPilot.Util.addClass(n.moving,c.q(E.eventMovingSource)),c.kj(n.movingShadow,s)}}()}}},this.ej=function(e,t,i,n,a){if(!c.allowEventOverlap){!function(){e.overlapping=!1;for(var o=0;o<t.lines.length;o++){if(!t.lines[o].isFree(i,n,a))return void(e.overlapping=!0)}if(c.allowMultiRange){var r=t.index;return DayPilot.list(H.list).some(function(t){var a=t.div,o=parseInt(a.style.left),s=parseInt(a.style.width),l=t.start.y;return e!==a&&(l===r&&DayPilot.Util.overlaps(i,i+n,o,o+s))})?void(e.overlapping=!0):void 0}}();var o=e.overlapping,r=c.q("_shadow_overlap");o?DayPilot.Util.addClass(e,r):DayPilot.Util.removeClass(e,r)}},this.jj=function(e,t){var i=c.q("_shadow_forbidden");!t.allowed||w.invalid?DayPilot.Util.addClass(e,i):DayPilot.Util.removeClass(e,i)},this.kj=function(e,t){this.lj();var i={};i.left=parseInt(e.style.left),i.top=parseInt(e.style.top),i.right=i.left+parseInt(e.style.width);var n=t.left.width||10,a=document.createElement("div");if(a.style.position="absolute",a.style.left=i.left-n-t.left.space+"px",a.style.top=i.top+"px",a.style.height=c.eventHeight+"px",a.style.overflow="hidden",a.style.boxSizing="border-box",a.innerHTML=t.left.html,a.className=this.q("_event_move_left"),a.onmousemove=c.mj,t.left.enabled)if(c.divHover.appendChild(a),t.left.width)a.style.width=n+"px";else{a.style.whiteSpace="nowrap";var o=a.offsetWidth,r=i.left-o-t.left.space;a.style.width=o+"px",a.style.left=r+"px";var s=c.nav.scroll.scrollLeft;r<s&&c.divHover.removeChild(a);var l=c.nj()+(r-s);l>0&&(a.style.left=l+"px",a.style.top=i.top-c.nav.scroll.scrollTop+c.Fg()+"px",c.nav.top.appendChild(a),c.elements.hover.push(a))}var n=t.right.width||10,d=document.createElement("div");if(d.style.position="absolute",d.style.left=i.right+t.right.space+"px",d.style.top=i.top+"px",d.style.height=c.eventHeight+"px",d.style.overflow="hidden",d.style.boxSizing="border-box",t.right.width?d.style.width=t.right.width+"px":d.style.whiteSpace="nowrap",d.innerHTML=t.right.html,d.className=this.q("_event_move_right"),d.onmousemove=c.mj,t.right.enabled){c.divHover.appendChild(d);var h=c.nav.scroll.scrollWidth;i.right+t.right.space+d.offsetWidth>=h&&c.divHover.removeChild(d)}},this.lj=function(){c.divHover.innerHTML="",DayPilot.de(c.elements.hover),c.elements.hover=[]},this.oj=function(){var e=c.rowHeaderColumnDefaultWidth;this.rowHeaderColumns&&(this.rowHeaderCols=DayPilot.Util.propArray(this.rowHeaderColumns,"width",e))},this.nj=function(){var e=0;if(this.oj(),this.rowHeaderCols)for(var t=0;t<this.rowHeaderCols.length;t++)e+=this.rowHeaderCols[t];else e=this.rowHeaderWidth;
return e},this.pj=function(){return this.qj(c.progressiveRowRenderingPreload)},this.qj=function(e){var e=e||0,t=0,i=c.rowlist.length;if(c.progressiveRowRendering){var n=c.ug();t=n.yStart,i=n.yEnd+1,t=Math.max(0,t-e),i=Math.min(c.rowlist.length,i+e)}return{"start":t,"end":i}},this.rj=function(){if(this.Nc()){var e=!1,t=0;if(this.rowHeaderWidthAutoFit){var i=this.divHeader;if(!i)return;if(!i.rows)return;for(var n=[],a=c.pj(),o=a.start;o<a.end;o++){var r=i.rows[o];if(r&&!r.hidden&&!r.autofitDone){r.autofitDone=!0;for(var s=0;s<r.cells.length;s++){var l=r.cells[s].firstChild.firstChild;if(l&&l.style){var d=l.style.width,h=l.style.right;l.style.position="absolute",l.style.width="auto",l.style.right="auto",l.style.whiteSpace="nowrap";var u=l.offsetWidth+2;l.style.position="",l.style.width=d,l.style.right=h,l.style.whiteSpace="","undefined"==typeof n[s]&&(n[s]=0),n[s]=Math.max(n[s],u)}}}}if(this.oj(),this.rowHeaderCols)for(var o=0;o<n.length;o++)this.rowHeaderCols[o]&&(n[o]>this.rowHeaderCols[o]&&(this.rowHeaderCols[o]=n[o],e=!0),t+=this.rowHeaderCols[o]);else t=this.rowHeaderWidth,this.rowHeaderWidth<n[0]+c.rowHeaderWidthMarginRight&&(t=n[0]+c.rowHeaderWidthMarginRight,e=!0)}e&&(this.fi&&(this.fi.widths=this.rowHeaderCols,this.fi.updateWidths(),DayPilot.Util.updatePropsFromArray(this.rowHeaderColumns,"width",this.rowHeaderCols)),this.rowHeaderScrolling||(this.rowHeaderWidth=t),this.kh(),this.sj())}},this.Zf=function(){this.tj=!0,this.oj();var e=this.nj(),t=this.divHeader;if(t?(t.innerHTML="",DayPilot.puc(t)):(t=document.createElement("div"),t.onmousemove=function(){c.S()},this.divHeader=t),t.style.width=e+"px",t.style.height=c.Tf+"px",t.rows=[],c.progressiveRowRendering)a();else for(var i=this.rowlist.length,n=0;n<i;n++)c.uj(n);c.vj(),this.divResScroll.appendChild(t),this.rowHeaderWidthAutoFit&&this.rj()},this.lh=function(){if(c.progressiveRowRendering){for(var e=this.pj(),t=0;t<c.rowlist.length;t++)e.start<=t&&t<e.end?c.uj(t):c.wj(t);if(this.rowHeaderWidthAutoFit){var i=c.Gg();this.rj();if(c.Gg()!==i){var n=this.cellWidth;this.Wf();this.cellWidth!==n&&(c.Xf(),c.$f(),c.ja(),c.ba(),c.xj())}}}},this.vj=function(){var e=c.divHeader,t=document.createElement("div");t.style.position="absolute",e.appendChild(t),c.nav.resScrollSpace=t,t.setAttribute("unselectable","on");var i=document.createElement("div");i.style.position="relative",i.style.height="100%",i.className=this.q("_rowheader"),t.appendChild(i);var n=this.nj(),t=c.nav.resScrollSpace;t.style.width=n+"px",t.style.top=this.Tf+"px",t.style.height=c.divResScroll.clientHeight+20+"px"},this.wj=function(e){var t=c.divHeader.rows[e];t&&(DayPilot.de(t.cells),c.divHeader.rows[e]=null)},this.uh=function(e){this.wj(e),this.uj(e)},this.uj=function(e){var t=c.divHeader,i=this.divHeader;if(!i.rows[e]){var n=this.rowHeaderCols,a=n?this.rowHeaderCols.length:0,o=this.nj(),r=this.rowlist[e];if(r&&!r.hidden){var l=this.bj(r);i.rows[e]={},i.rows[e].cells=[];var d=document.createElement("div");d.style.position="absolute",d.style.top=r.top+"px",d.row=r,d.index=e;var h=l.row,u=n?n[0]:this.rowHeaderWidth;d.style.width=u+"px",d.style.border="0px none",h.toolTip&&(d.title=h.toolTip),d.setAttribute("unselectable","on"),d.onmousemove=c.yj,d.onmouseout=c.zj,d.onmouseup=c.Aj,d.oncontextmenu=c.Bj,d.onclick=c.Cj,d.ondblclick=c.Dj;var f=document.createElement("div");f.style.width=u+"px",f.setAttribute("unselectable","on"),f.className=this.q("_rowheader"),h.cssClass&&DayPilot.Util.addClass(f,h.cssClass),h.backColor&&(f.style.background=h.backColor),f.style.height=r.height+"px",f.style.overflow="hidden",f.style.position="relative";var v=document.createElement("div");v.setAttribute("unselectable","on"),v.className=this.q("_rowheader_inner"),f.appendChild(v);var p="Disabled"!==this.rowMoveHandling,g=10,m=h.areas||[];p&&!h.moveDisabled&&m.push({"v":"Hover","w":g,"bottom":0,"top":0,"left":0,"css":c.q("_rowmove_handle"),"action":"Move"});var y=c.Jh(r);DayPilot.Areas.attach(f,y,{"areas":m,"allowed":function(){return!s.row}});var b=document.createElement("div");if(b.style.position="absolute",b.style.bottom="0px",b.style.width="100%",b.style.height="1px",b.className=this.q(E.resourcedivider),f.appendChild(b),function(){if(c.treeEnabled&&!r.isNewRow){var t=r.level*c.treeIndent+c.treeImageMarginLeft;p&&(t+=g);var i=10,n=document.createElement("div");n.style.width="10px",n.style.height="10px",n.style.backgroundRepeat="no-repeat",n.style.position="absolute",n.style.left=t+"px",n.style.top=c.treeImageMarginTop+"px",r.loaded||0!==r.children.length?r.children.length>0?(r.expanded?n.className=c.q("_tree_image_collapse"):n.className=c.q("_tree_image_expand"),n.style.cursor="pointer",n.index=e,n.onclick=function(e){c.Ti(this.index),e=e||window.event,e.cancelBubble=!0}):n.className=c.q("_tree_image_no_children"):(n.className=c.q("_tree_image_expand"),n.style.cursor="pointer",n.index=e,n.onclick=function(e){c.Ej(this.index),e=e||window.event,e.cancelBubble=!0}),v.appendChild(n)}var a=document.createElement("div");c.treeEnabled&&(a.style.marginLeft=t+i+"px"),a.innerHTML=h.html,d.textDiv=a,d.cellDiv=f,v.appendChild(a)}(),d.appendChild(f),t.appendChild(d),i.rows[e].cells.push(d),r.columns&&0!==r.columns.length)for(var w=u,D=1;D<a;D++){var k=h.columns[D-1]||{},d=document.createElement("div");d.style.position="absolute",d.style.top=r.top+"px",d.style.left=w+"px",t.appendChild(d),i.rows[e].cells.push(d),d.row=r,d.index=e,h.toolTip&&(d.title=h.toolTip),d.setAttribute("unselectable","on"),d.onmousemove=c.yj,d.onmouseout=c.zj,d.onmouseup=c.Aj,d.oncontextmenu=c.Bj,d.onclick=c.Cj,d.ondblclick=c.Dj;var f=document.createElement("div"),C=n[D];w+=C;var x=k.backColor||h.backColor;x&&(f.style.backgroundColor=x),f.style.width=C+"px",f.style.height=r.height+"px",f.style.overflow="hidden",f.style.position="relative",f.setAttribute("unselectable","on"),DayPilot.Util.addClass(f,this.q("_rowheader")),DayPilot.Util.addClass(f,this.q("_rowheadercol")),DayPilot.Util.addClass(f,this.q("_rowheadercol"+D)),h.cssClass&&DayPilot.Util.addClass(f,h.cssClass),k.cssClass&&DayPilot.Util.addClass(f,k.cssClass);var v=document.createElement("div");v.setAttribute("unselectable","on"),v.className=this.q("_rowheader_inner"),f.appendChild(v);var b=document.createElement("div");b.style.position="absolute",b.style.bottom="0px",b.style.width="100%",b.style.height="1px",b.className=this.q("_resourcedivider"),f.appendChild(b);var P=document.createElement("div"),S=k.html||"";P.innerHTML=S,d.textDiv=P,d.cellDiv=f,v.appendChild(P),DayPilot.Areas.attach(f,y,{"areas":k.areas,"allowed":function(){return!s.row}}),d.appendChild(f)}else d.colSpan=a>0?a:1,f.style.width=o+"px"}}},this.Bj=function(){var e=this.row;return e.contextMenu&&e.contextMenu.show(c.Jh(e)),!1},this.Cj=function(e){if(!C.cancelClick){var t=this.row,i=c.Jh(t,this.index);return t.isNewRow?void c.Ph.edit(t):void c.Mh(i,e.ctrlKey,e.shiftKey,e.metaKey)}},this.Dj=function(e){if(c.timeouts.resClick){for(var t in c.timeouts.resClick)window.clearTimeout(c.timeouts.resClick[t]);c.timeouts.resClick=null}var i=this.row,n=c.Jh(i,this.index);if(c.sa()){var a={};if(a.resource=n,a.row=n,a.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof c.onRowDoubleClick&&(c.onRowDoubleClick(a),a.preventDefault.value))return;switch(c.rowDoubleClickHandling){case"PostBack":c.rowDoubleClickPostBack(n);break;case"CallBack":c.rowDoubleClickCallBack(n);break;case"Select":c.Oh(i,e.ctrlKey,e.shiftKey,e.metaKey);break;case"Edit":c.Ph.edit(i)}"function"==typeof c.onRowDoubleClicked&&c.onRowDoubleClicked(a)}else switch(c.rowDoubleClickHandling){case"PostBack":c.rowDoubleClickPostBack(n);break;case"CallBack":c.rowDoubleClickCallBack(n);break;case"JavaScript":c.onRowDoubleClick(n);break;case"Select":c.Oh(i,e.ctrlKey,e.shiftKey,e.metaKey);break;case"Edit":c.Ph.edit(i)}},this.rowDoubleClickPostBack=function(e,t){var i={};i.resource=e,this.E("RowDoubleClick",i,t)},this.rowDoubleClickCallBack=function(e,t){var i={};i.resource=e,this.G("RowDoubleClick",i,t)},this.Fj=function(e){var t={};t.start=this.cell.start,t.level=this.cell.level,t.end=this.cell.end,t.end||(t.end=new DayPilot.Date(t.start).addMinutes(c.cellDuration)),c.Qh(t)},this.Jh=function(e){return new DayPilot.Row(e,c)},this.Qg=function(e){var t=this.rowlist[e];if(t.events||t.resetEvents(),!t.data){t.data={},t.data.start=new DayPilot.Date(t.start),t.data.startTicks=t.data.start.getTime();var i=this.Tg().getTime()-this.Ba().getTime();t.data.end=_.isResourcesView()?t.data.start.addTime(i):t.data.start.addDays(1),t.data.endTicks=t.data.end.getTime(),t.data.offset=t.start.getTime()-this.Ba().getTime(),t.data.i=e}},this.ba=function(e){if(e?this.events.list=e:this.events.list||(this.events.list=[]),null!=this.events.list&&!DayPilot.isArray(this.events.list))throw"DayPilot.Scheduler.events.list expects an array object";D.prepareRows(!0);for(var t,i=this.events.list,n=i.length,a="function"==typeof this.onBeforeEventRender,o="Resources"===c.viewType,r=0;r<n;r++){var s=i[r];if(s){if(s instanceof DayPilot.Event)throw"DayPilot.Scheduler: DayPilot.Event object detected in events.list array. Use raw event data instead.";a&&this.Sc(r),"*"===s.resource?t=c.rowlist:o?t=DayPilot.list(D.rowcache[s.resource]).concat(D.rowcache["*"]):"Days"===c.viewType?t=c.rowlist:"Gantt"===c.viewType&&(t=D.rowcache[s.id]);for(var l=0;t&&l<t.length;l++){var d=t[l],h=this.qi(s,d);h&&a&&(h.cache=this.t.events[r])}}}DayPilot.list(c.rowlist).each(function(e){c.vi(e)}),this.fh()},this.Gj=function(e){var t=[],i=[],n=null;if(e&&add){for(var a=e,n=[],o=0;o<a.length;o++){for(var r=a[o],s=!1,l=0;l<this.events.list.length;l++){var d=this.events.list[l];if(d.id===r.id&&d.start.toString()===r.start.toString()&&d.resource===r.resource){var h=c.events.ch(d);i=i.concat(h),this.events.list[l]=r,s=!0;break}}s||n.push(r)}this.events.list=this.events.list.concat(n)}else e?this.events.list=e:this.events.list||(this.events.list=[]);var u=n||this.events.list;e?this.events.list=e:this.events.list||(this.events.list=[]);var u=this.events.list,f=u.length;if("function"==typeof this.onBeforeEventRender)for(var v=n?this.events.list.length-n.length:0,p=this.events.list.length,o=v;o<p;o++)this.Sc(o);var o,g,l,r,m,y=(!this.pi(),!n||"undefined"==typeof g.events);D.prepareRows(y);for(var l=0;u&&l<f;l++)if(!t[l]){var b=u[l];if(b){var h=[];h="*"===b.resource?c.rowlist:"Days"===c.viewType?c.rowlist:"Gantt"===c.viewType?D.rowcache[b.id]:D.rowcache[b.resource];for(var w=0;h&&w<h.length;w++){var g=h[w],m=this.qi(b,g);m&&("function"==typeof this.onBeforeEventRender&&(m.cache=this.t.events[l+v]),i.push(g.index))}}}for(var o=0;o<this.rowlist.length;o++){var g=this.rowlist[o];this.vi(g)}return this.fh(),DayPilot.ua(i)},this.Hj={};var D=this.Hj;D.rowCache={},D.prepareRows=function(e){D.rowcache={};for(var t=0;t<c.rowlist.length;t++){var i=c.rowlist[t];if(e&&i.resetEvents(),c.Qg(t),i.id){var n=i.id.toString();D.rowcache[n]||(D.rowcache[n]=DayPilot.list()),D.rowcache[n].push(i)}}},D.loadEvent=function(e){},this.pi=function(){var e={};if("Resources"!==c.viewType)return!1;for(var t=0;t<c.rowlist.length;t++){var i=c.rowlist[t],n=i.id;if(e[n])return!0;e[n]=!0}return!1},this.Sc=function(e){var t=this.t.events,i=this.events.list[e],n={};i instanceof DayPilot.Event&&(i=i.data);for(var a in i)n[a]=i[a];if("function"==typeof this.onBeforeEventRender){var o={};o.e=n,o.data=n,this.onBeforeEventRender(o)}t[e]=n},this.vi=function(e){if(e.lines=[],e.sections=null,!e.isNewRow){this.sortDirections?e.events.sort(this._c):c.cellStacking||e.events.sort(this.$c);if(c.cellStacking)return void S.loadRow(e);var t=c.groupConcurrentEvents;if(t)for(var i=0;i<e.blocks.length;i++)e.blocks[i].clear();DayPilot.list(e.events).each(function(t){if(!t.part.height)return e.eventHeight?void(t.part.height=e.eventHeight):void(t.part.height=_.eventHeight())});for(var n=0;n<e.events.length;n++){var a=e.events[n];e.putIntoLine(a),t&&e.putIntoBlock(a)}for(var o=0,i=0;i<e.lines.length;i++){var r=e.lines[i];r.top=o,o+=(r.height||e.eventHeight)*e.eventStackingLineHeight/100}if(t)for(var n=0;n<e.blocks.length;n++){var s=e.blocks[n];s.lines=[],s.events.sort(this._c);for(var l=0;l<s.events.length;l++){var a=s.events[l];s.putIntoLine(a)}s.lines.length<=c.groupConcurrentEventsLimit&&(s.expanded=!0);var d=DayPilot.list(s.events).map(function(e){return e.id()}).some(function(e){return DayPilot.contains(c.Ij,e)});d&&(s.expanded=!0);for(var o=0,i=0;i<s.lines.length;i++){var r=s.lines[i];r.top=o,o+=(r.height||e.eventHeight)*e.eventStackingLineHeight/100}}}},this.eh=function(e){e=DayPilot.ua(e);for(var t=0;t<e.length;t++){var i=e[t];c.vi(c.rowlist[i])}if(c.cellStacking)S.calculateEventPositions();else for(var t=0;t<e.length;t++){var i=e[t],n=c.rowlist[i];c._i(n)}},this.Fi=function(){var e="Manual"===c.scale?c.itline[0].start:c.startDate;return DayPilot.list(c.rowlist).some(function(t){return!!t.start&&t.start.getTime()!==new DayPilot.Date(e).getTime()})},this.qi=function(e,t){if(!t.hideEvents){var i=new DayPilot.Date(e.start),n=new DayPilot.Date(e.end);n=c.Ee(n);var a=i.ticks,o=n.ticks;if(o<a)return null;var r=null;if("function"==typeof c.onBeforeEventRender){var s=DayPilot.indexOf(c.events.list,e);r=c.t.events[s]}if(r){if(r.hidden)return null}else if(e.hidden)return null;var l=!1;switch(this.viewType){case"Days":l=!(o<=t.data.startTicks||a>=t.data.endTicks)||a===o&&a===t.data.startTicks;break;case"Resources":l=(t.id===e.resource||"*"===t.id||"*"===e.resource)&&(!(o<=t.data.startTicks||a>=t.data.endTicks)||a===o&&a===t.data.startTicks);break;case"Gantt":l=t.id===e.id&&!(o<=t.data.startTicks||a>=t.data.endTicks)}if(!l)return null;var d=new DayPilot.Event(e,c);d.part.dayIndex=t.data.i,d.part.start=t.data.startTicks<a?i:t.data.start,d.part.end=t.data.endTicks>o?n:t.data.end;var h=this.getPixels(d.part.start.addTime(-t.data.offset)),u=this.getPixels(d.part.end.addTime(-t.data.offset));d.part.start===d.part.end&&(u=this.getPixels(d.part.end.addTime(-t.data.offset).addSeconds(1))),r&&r.height?d.part.height=r.height:e.height&&(d.part.height=e.height),d.part.Jj=function(){var e=this.height;if(c.eventVersionsEnabled&&!DayPilot.list(d.data.versions).isEmpty()){var t=d.versions.length;e+=t*c.eventVersionHeight,e+=t*c.eventVersionMargin}return e+c.eventMarginBottom};var f=h.left,v=u.left;if(d.part.startPixels=h,d.part.endPixels=u,f===v){if(h.cut||u.cut)return null;var p=(d.part.start.addTime(-t.data.offset).getTime()+d.part.end.addTime(-t.data.offset).getTime())/2;if(c.getPixels(new DayPilot.Date(Math.floor(p))).cut)return null}d.part.box=_.useBox(o-a);var g=c.eventHeight;if("Milestone"===e.type){var m=e.width||g;d.part.end=d.part.start,d.part.left=f-m/2,d.part.width=m,d.part.barLeft=0,d.part.barWidth=m}else if(d.part.box){var y=h.boxLeft,b=u.boxRight;d.part.left=y,d.part.width=b-y,d.part.barLeft=Math.max(f-d.part.left,0),d.part.barWidth=Math.max(v-f,1)}else d.part.left=f,d.part.width=Math.max(v-f,1),d.part.barLeft=0,d.part.barWidth=Math.max(v-f-1,1);if(c.eventVersionsEnabled&&c.Kj(d,t),"function"==typeof c.onEventFilter&&c.events.Zc){var w={};if(w.filter=c.events.Zc,w.visible=!0,w.e=d,c.onEventFilter(w),!w.visible)return null}return t.events.push(d),d}},this.Kj=function(e,t){e.versions=[];var i=e.data,n=DayPilot.list(i.versions);n.isEmpty()||n.each(function(i){var n=new DayPilot.Date(i.start),a=new DayPilot.Date(i.end),o=c.getPixels(n.addTime(-t.data.offset)),r=c.getPixels(a.addTime(-t.data.offset));n.ticks===a.ticks&&(r=c.getPixels(a.addTime(-t.data.offset).addTime(1)));var s=o.left,l=r.left;if(s===l&&(o.cut||r.cut))return null;var d={};d.left=s,d.continueLeft=n<t.data.start,d.right=l,d.continueRight=a>t.data.end,d.width=l-s,e.versions.push(d)})},this.$c=function(e,t){if(!(e&&t&&e.start&&t.start))return 0;var i=e.start().ticks-t.start().ticks;return 0!==i?i:t.end().ticks-e.end().ticks},this._c=function(e,t){if(!e||!t)return 0;if(!(e.data&&t.data&&e.data.sort&&t.data.sort&&0!==e.data.sort.length&&0!==t.data.sort.length))return c.$c(e,t);for(var i=0,n=0;0===i&&"undefined"!=typeof e.data.sort[n]&&"undefined"!=typeof t.data.sort[n];)i=e.data.sort[n]===t.data.sort[n]?0:"number"==typeof e.data.sort[n]&&"number"==typeof t.data.sort[n]?e.data.sort[n]-t.data.sort[n]:c.ad(e.data.sort[n],t.data.sort[n],c.sortDirections[n]),n++;return i},this.ad=function(e,t,i){var n="desc"!==i,a=n?-1:1,o=-a;if(null===e&&null===t)return 0;if(null===t)return o;if(null===e)return a;var r=[];return r[0]=e,r[1]=t,r.sort(),e===r[0]?a:o},this.Oh=function(e,t,i,n){if(c.sa()){var a=DayPilot.indexOf(c.rowlist,e),o=c.Jh(e,a),r=DayPilot.indexOf(C.selected,e)!==-1,s=r?"deselected":"selected",l={};if(l.row=o,l.selected=r,l.ctrl=t,l.shift=i,l.meta=n,l.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof c.onRowSelect&&(c.onRowSelect(l),l.preventDefault.value))return;var d=i&&!t&&!n;if(i||(C.Lj={"row":e,"index":a}),d){C.fixRowSelectLast();var h=C.Lj.index,u=a;C.selectRange(h,u)}switch(c.rowSelectHandling){case"PostBack":c.rowSelectPostBack(o,s);break;case"CallBack":c.rowSelectCallBack(o,s);break;case"Notify":!d&&C.select(e,t,i,n),c.rowSelectNotify(o,s);break;case"Update":!d&&C.select(e,t,i,n)}"function"==typeof c.onRowSelected&&(l.selected=DayPilot.indexOf(C.selected,e)!==-1,c.onRowSelected(l))}else{C.select(e,t,i);var a=DayPilot.indexOf(c.rowlist,e),o=c.Jh(e,a),r=DayPilot.indexOf(C.selected,e)!==-1,s=r?"deselected":"selected";switch(c.rowSelectHandling){case"PostBack":c.rowSelectPostBack(o,s);break;case"CallBack":c.rowSelectCallBack(o,s);break;case"Notify":c.rowSelectNotify(o,s);break;case"JavaScript":c.onRowSelect(o,s)}}},this.rowSelectPostBack=function(e,t,i){var n={};n.resource=e,n.change=t,this.E("RowSelect",n,i)},this.rowSelectCallBack=function(e,t,i){var n={};n.resource=e,n.change=t,this.G("RowSelect",n,i)},this.rowSelectNotify=function(e,t,i){var n={};n.resource=e,n.change=t,this.G("RowSelect",n,i,"Notify")},this.rows={},this.rows.selection={};var k=this.rows.selection;k.get=function(){var e=[];return DayPilot.list(C.selected).each(function(t){e.push(c.Jh(t))}),e},k.clear=function(){C.clearSelection()},k.add=function(e){if(!e||!e.isRow)throw"DayPilot.Scheduler.rows.selection.add(): DayPilot.Row object expected";DayPilot.list(C.selected).some(function(t){return t===e.$.row})||C.selected.push(e.$.row),C.Mj(),k.Nj()},k.remove=function(e){if(!e||!e.isRow)throw"DayPilot.Scheduler.rows.selection.remove(): DayPilot.Row object expected";k.isSelected(e)&&(C.unselect(e.$.row),DayPilot.rfa(C.selected,e.$.row)),k.Nj()},k.isSelected=function(e){if(!e||!e.isRow)throw"DayPilot.Scheduler.rows.selection.isSelected(): DayPilot.Row object expected";return DayPilot.indexOf(C.selected,e.$.row)!==-1},k.Nj=function(){c.selectedRows=DayPilot.list(C.selected).map(function(e){return e.id})},this.rows.all=function(){for(var e=[],t=0;t<c.rowlist.length;t++){var i=c.Jh(c.rowlist[t]);e.push(i)}return p(e)},this.rows.visible=function(){for(var e=[],t=0;t<c.rowlist.length;t++){var i=c.rowlist[t];if(!i.hidden){var i=c.Jh(c.rowlist[t]);e.push(i)}}return p(e)},this.rows.each=function(e){c.rows.all().each(e)},this.rows.filter=function(e){c.rows.Zc=e,c.A&&c.cd({"immediateEvents":!0})},this.rows.find=function(e,t){var i=DayPilot.list(D.rowcache[e]),n=null;return n="string"==typeof t?i.find(function(e){return t===e.start.toString()}):i.first(),n?new DayPilot.Row(n,c):null},this.rows.load=function(e){DayPilot.ajax({"method":"POST","url":e,"success":function(e){var t=e.request,i=DayPilot.Util.parseJSON(t.responseText);DayPilot.isArray(i)&&(c.resources=i,c.A&&c.update())}})},this.rows.expand=function(e){for(var t=[],i=e||1,n=0;n<c.rowlist.length;n++){var a=c.rowlist[n],o=i===-1;a.level<i&&(o=!0),o&&!a.expanded&&a.children&&a.children.length>0&&t.push(a.index)}if(0!==t.length)if(1===t.length)c.Ti(t[0]);else{for(var n=0;n<t.length;n++){var r=t[n],s=c.rowlist[r].resource;s.expanded=!0}c.cd()}},this.rows.expandAll=function(){c.rows.expand(-1)},this.rows.collapseAll=function(){c.rowlist.each(function(e){e.resource.expanded=!1}),c.cd()},this.rows.headerHide=function(){c.Oj=!0,c.Pj(),c.sj(),c.Kg()},this.rows.headerShow=function(){c.Oj=!1,c.Pj(),c.sj(),c.Kg()},this.rows.headerToggle=function(){c.Oj?c.rows.headerShow():c.rows.headerHide()},this.rows.edit=function(e){C.edit(e.$.row)},this.rows.remove=function(e){var t=e.$.row.resource,i=x.findParentArray(t);if(!i)throw"Cannot find source node parent";var n=DayPilot.indexOf(i,t);i.splice(n,1),c.update()},this.rows.update=function(e){if(!(e instanceof DayPilot.Row))throw new DayPilot.Exception("DayPilot.Scheduler.rows.update() expects a DayPilot.Row object.");var t=e.index,i=c.rowlist[t],n=e.data,a=e.parent()?e.parent().$.row:null,o=c.Qj(n),e=c.Rj(o,a);e.hidden=i.hidden,e.level=i.level,e.children=i.children,e.index=t,e.top=i.top,e.height=i.height,c.rowlist[t]=e,e.resetEvents(),c.Qg(t),c.Sj(e),c.vi(e),c.uh(t),c.cg(),c.fg()},this.Sj=function(e){for(var t=c.events.list,i=t.length,n="function"==typeof c.onBeforeEventRender,a=0;a<i;a++){var o=t[a];if(o){if(o instanceof DayPilot.Event)throw new DayPilot.Exception("DayPilot.Scheduler: DayPilot.Event object detected in events.list array. Use raw event data instead.");if("Days"===c.viewType)throw new DayPilot.Exception(".rows.update() not supported for viewType = 'Days'.");if("Gantt"===c.viewType)throw new DayPilot.Exception(".rows.update() not supported for viewType = 'Gantt'.");if("*"===o.resource||"*"===e.id||o.resource===e.id){n&&this.Sc(a);var r=this.qi(o,e);r&&n&&(r.cache=this.t.events[a])}}}},this.Tj=function(){var e=s.source,t=s.target,i=s.position;if(C.resetMoving(),c.sa()){var n={};if(n.source=c.Jh(e),n.target=c.Jh(t),n.position=i,n.preventDefault=function(){this.preventDefault.value=!0},"function"==typeof c.onRowMove&&(c.onRowMove(n),n.preventDefault.value))return;switch(c.rowMoveHandling){case"Update":C.move(n);break;case"CallBack":c.rowMoveCallBack(n.source,n.target,n.position);break;case"PostBack":c.rowMovePostBack(n.source,n.target,n.position);break;case"Notify":C.move(n),c.rowMoveNotify(n.source,n.target,n.position)}"function"==typeof c.onRowMoved&&c.onRowMoved(n)}else{var e=c.Jh(e),t=c.Jh(t),i=i;switch(c.rowMoveHandling){case"CallBack":c.rowMoveCallBack(e,t,i);break;case"PostBack":c.rowMovePostBack(e,t,i);break;case"JavaScript":c.onRowMove(e,t,i)}}},this.kg=function(e){var t=DayPilot.list(e);C.selected=[],t.isEmpty()||(c.Lf=!1,c.aa()),t.each(function(e){var t=c.sg(e);t&&C.selected.push(t)}),C.Mj()},this.Ph={};var C=this.Ph;C.edit=function(e){C.Uj(e)},C.rowSelectLastSetDefault=function(){C.Lj={"row":c.rowlist[0],"index":0}},C.rowSelectSetLast=function(e){var t=DayPilot.indexOf(c.rowlist,e);if(t===-1)throw"DayPilot.Scheduler: Row not found when selecting a range";C.Lj={"row":e,"index":t}},C.fixRowSelectLast=function(){C.Lj||C.rowSelectLastSetDefault();var e=DayPilot.indexOf(c.rowlist,C.Lj.row);if(!(e>-1)){var t=c.sg(C.Lj.row.id);t?(e=DayPilot.indexOf(c.rowlist,t),C.Lj={"row":t,"index":e}):C.rowSelectLastSetDefault()}},C.createOverlay=function(e){var t=c.nj(),i=c.q("_rowmove_source"),n=DayPilot.Util.div(c.divHeader,0,e.top,t,e.height);n.className=i,e.moveOverlay=n},C.deleteOverlay=function(e){DayPilot.de(e.moveOverlay),e.moveOverlay=null},C.Uj=function(e){var t=C.Vj(e),i=t.cells[0];if(i.input)return i.input;DayPilot.Areas.disable(i.firstChild);var n=i.clientWidth;e.isNewRow&&(n=c.Gg());var o=document.createElement("textarea");o.style.position="absolute",o.style.top="0px",o.style.left="0px",o.style.width=n+"px",o.style.height=e.height+"px",o.style.border="0px none",o.style.overflow="hidden",o.style.boxSizing="border-box",o.style.resize="none",o.style.paddingLeft=e.level*c.treeIndent+"px";var r=i.textDiv;o.style.fontFamily=DayPilot.gs(r,"fontFamily")||DayPilot.gs(r,"font-family"),o.style.fontSize=DayPilot.gs(r,"fontSize")||DayPilot.gs(r,"font-size"),o.value=e.name||"",i.firstChild.appendChild(o),i.input=o;var s=function(){try{i.input.parentNode.removeChild(i.input)}catch(e){a()}i.input=null};return o.focus(),o.onblur=function(){o.onblur=null;var t=o.value;s(),DayPilot.Areas.enable(i.firstChild),c.Lh(e,t,o.canceled)},o.onkeydown=function(e){var t=window.event?event.keyCode:e.keyCode;return 27===t&&(o.canceled=!0,s()),13!==t||(o.onblur(),!1)},o.setSelectionRange?o.setSelectionRange(0,9999):o.select(),o},C.selected=[],C.select=function(e,t,i,n){var a=DayPilot.indexOf(C.selected,e)!==-1;if(t||n){if(a)return C.unselect(e),void DayPilot.rfa(C.selected,e)}else a=!1,C.clearSelection();C.Wj(e),a||C.selected.push(e),k.Nj()},C.selectRange=function(e,t){C.clearSelection();for(var i=Math.min(e,t),n=Math.max(e,t),a=i;a<=n;a++){var o=c.rowlist[a];C.Wj(o),C.selected.push(o)}k.Nj()},C.Mj=function(){for(var e=0;e<C.selected.length;e++){var t=C.selected[e];C.Wj(t)}},C.Wj=function(e){var t=DayPilot.indexOf(c.rowlist,e);if(t===-1){var i=c.sg(e.id);if(!i)return;t=i.index}for(var n=c.q("_cell_selected"),a=[],o=0;o<c.itline.length;o++){var r={};r.x=o,r.y=t,a.push(r)}c.cells.findXy(a).addClass(n);for(var n=c.q("_rowheader_selected"),s=c.divHeader,t=0;t<s.rows.length;t++){var l=s.rows[t];if(l&&l.cells[0]&&l.cells[0].row===e)for(var d=0;d<l.cells.length;d++){var r=l.cells[d],h=r.firstChild;DayPilot.Util.addClass(h,n)}}},C.Wh=function(){var e=[];if(!C.selected)return e;for(var t=0;t<C.selected.length;t++){var i=C.selected[t],n=DayPilot.indexOf(c.rowlist,i),a=c.Jh(i,n);e.push(a.toJSON())}return e},C.unselect=function(e){for(var t=c.q("_cell_selected"),i=DayPilot.indexOf(c.rowlist,e),n=[],a=0;a<c.itline.length;a++){var o={};o.x=a,o.y=i,n.push(o)}c.cells.findXy(n).removeClass(t);var t=c.q("_rowheader_selected"),r=(c.divHeader,C.Vj(e));if(r)for(var s=0;s<r.cells.length;s++){var o=r.cells[s],l=o.firstChild;DayPilot.Util.removeClass(l,t)}},C.Lj=null,C.clearSelection=function(){for(var e=0;e<C.selected.length;e++){var t=C.selected[e];C.unselect(t)}C.selected=[],c.selectedRows=[]},C.Vj=function(e){for(var t=c.divHeader,i=0;i<t.rows.length;i++){var n=t.rows[i];if(n&&n.cells[0]&&n.cells[0].row===e)return n}return null},C.selectById=function(e){var t=c.sg(e);t&&C.select(t)},C.startMoving=function(e){var t=DayPilot.Global.rowmoving;t.row=e,t.cursor=c.divResScroll.style.cursor,c.divResScroll.style.cursor="move",C.createOverlay(e)},C.resetMoving=function(){c.divResScroll.style.cursor=s.cursor,DayPilot.de(s.div),C.deleteOverlay(s.row),DayPilot.Global.rowmoving=s={}},C.move=function(e){var t=e.source.$.row.resource,i=e.target.$.row.resource,n=e.position;if("forbidden"!==n){var a=x.findParentArray(t);if(!a)throw"Cannot find source node parent";var o=DayPilot.indexOf(a,t);a.splice(o,1);var r=x.findParentArray(i);if(!r)throw"Cannot find target node parent";var s=DayPilot.indexOf(r,i);switch(n){case"before":r.splice(s,0,t);break;case"after":r.splice(s+1,0,t);break;case"child":i.children||(i.children=[],i.expanded=!0),i.children.push(t)}c.update()}};var x={};x.findParentArray=function(e){return x.findInArray(c.resources,e)},x.findInArray=function(e,t){if(DayPilot.indexOf(e,t)!==-1)return e;for(var i=0;i<e.length;i++){var n=e[i];if(n.children&&n.children.length>0){var a=x.findInArray(n.children,t);if(a)return a}}return null},this.Yf=function(){this.rowlist=DayPilot.list();var e=this.resources,t=this.r();t||("Gantt"===this.viewType?e=this.Xj():"Days"===this.viewType&&(e=this.Yj())),!t||"Days"!==this.viewType||e&&0!==e.length||(e=this.Yj());var i={};if(i.i=0,null!=e&&!DayPilot.isArray(e))throw"DayPilot.Scheduler.resources expects an array object";this.Zj(e,i,0,null,this.treeEnabled,!1),"Disabled"!==c.rowCreateHandling&&this.$j()},this.$j=function(){var e={};e.id="NEW",e.isNewRow=!0,e.html="",e.loaded=!0,e.start=this.startDate,e.children=[],e.height=c.eventHeight,e.marginBottom=0,e.marginTop=0,e.getHeight=function(){return c.rowCreateHeight?c.rowCreateHeight:c.eventHeight+c.rowMarginBottom+c.rowMarginTop},e.putIntoLine=function(){},e.resetEvents=function(){},this.rowlist.push(e)},this.Xj=function(){var e=[];if(this.Nf&&this.resources)for(var t=0;t<this.resources.length;t++)e.push(this.resources[t]);if(this.events.list){for(var t=0;t<this.events.list.length;t++){var i=this.events.list[t],n={};n.id=i.id,n.name=i.text,e.push(n)}return e}},this.Yj=function(){for(var e=[],t=c.Ba(),i=this.sc.locale(),n=0;n<this.days;n++){var a=t.addDays(n),o={};o.name=a.toString(i.datePattern,i),o.start=a,e.push(o)}return e},this.Ba=function(){return this.itline&&this.itline.length>0?this.itline[0].start:this.startDate},this.Tg=function(){if(this.itline&&this.itline.length>0){var e=c.itline[this.itline.length-1].end;return"Days"!==c.viewType?e:e.addDays(c.days-1)}return c.startDate.addDays(c.days)},this._j={};this._j;this.visibleStart=function(){return this.Ba()},this.visibleEnd=function(){return this.Tg()},this.Rj=function(e,t){var i={};if(i.backColor=e.backColor,i.cssClass=e.cssClass,i.expanded=e.expanded,i.name=e.name,i.html=e.html?e.html:i.name,i.eventHeight="undefined"!=typeof e.eventHeight?e.eventHeight:c.sc.eventHeight(),i.minHeight="undefined"!=typeof e.minHeight?e.minHeight:c.rowMinHeight,i.marginBottom="undefined"!=typeof e.marginBottom?e.marginBottom:c.rowMarginBottom,i.marginTop="undefined"!=typeof e.marginTop?e.marginTop:c.rowMarginTop,i.eventStackingLineHeight="undefined"!=typeof e.eventStackingLineHeight?e.eventStackingLineHeight:c.eventStackingLineHeight,i.loaded=!e.dynamicChildren,i.id=e.id||e.value,i.toolTip=e.toolTip,i.children=[],i.columns=[],i.start=e.start?new DayPilot.Date(e.start):this.Ba(),i.isParent=e.isParent,i.contextMenu=e.contextMenu?DayPilot.Util.evalVariable(e.contextMenu):this.contextMenuResource,i.areas=e.areas,i.moveDisabled=e.moveDisabled,i.bubbleHtml=e.bubbleHtml,i.tags=e.tags,i.task=e.task,i.swimlane=e.swimlane,i.hideEvents=e.hideEvents,i.height=i.eventHeight,i.resource=e.ak,i.lines=[],i.blocks=[],i.isRow=!0,i.getHeight=function(){var e=0;if(c.groupConcurrentEvents)for(var t=0;t<this.blocks.length;t++){var i=this.blocks[t];e=Math.max(e,i.getHeight())}else if(this.lines.length>0){var n=this.lines.length-1,a=this.lines[n],o=a.height||this.eventHeight,r=a.top||0;e=r+o}return 0===e&&(e=this.eventHeight),e>this.minHeight?e:this.minHeight},i.resetEvents=function(){var e=this;e.events=[],e.events.forRange=function(t,i){for(var n=DayPilot.list(),a=0;a<e.events.length;a++){var o=e.events[a];DayPilot.Util.overlaps(o.start(),o.end(),t,i)&&n.push(o)}return n}},i.calculateUtilization=function(){function e(){for(var e=[],t=0;t<i.events.length;t++){var n=i.events[t];DayPilot.contains(e,n.start().toString())||e.push(n.start().toString()),DayPilot.contains(e,n.rawend().toString())||e.push(n.rawend().toString())}return e.sort(),e}function t(){for(var t=e(),n=[],a={"start":i.data.start},o=0;o<t.length;o++)a.end=new DayPilot.Date(t[o]),n.push(a),a={"start":new DayPilot.Date(t[o])};return a.end=i.data.end,n.push(a),n.forRange=function(e,t){for(var i=DayPilot.list(),n=0;n<this.length;n++){var a=this[n];DayPilot.Util.overlaps(e,t,a.start,a.end)&&i.push(a)}return i.maxSum=function(e){for(var t=0,i=0;i<this.length;i++){var n=this[i],a=n.sum(e);a>t&&(t=a)}return t},i},n}for(var i=this,n=i.sections=t(),a=0;a<n.length;a++){var o=n[a];o.events=[];for(var r=0;r<i.events.length;r++){var s=i.events[r];DayPilot.Util.overlaps(o.start,o.end,s.start(),s.rawend())&&o.events.push(s)}o.sum=function(e){for(var t=0,i=0;i<this.events.length;i++){var n=this.events[i],a=0;"undefined"==typeof e?a=1:n.tag(e)?a=n.tag(e):n.data[e]&&(a=n.data[e]),"number"==typeof a&&(t+=a)}return t}}},i.putIntoLine=function(e){for(var t=0;t<this.lines.length;t++){var i=this.lines[t];if(i.isFree(e.part.left,e.part.width))return i.add(e),t}var i=[];return i.height=0,i.add=function(e){this.push(e);var t=e.part.Jj();t>i.height&&(i.height=t)},i.isFree=function(e,t,i){for(var n=e+t-1,a=this.length,o=0;o<a;o++){var r=this[o];if(!(n<r.part.left||e>r.part.left+r.part.width-1)){if(DayPilot.contains(i,r.data))continue;return!1}}return!0},i.add(e),this.lines.push(i),this.lines.length-1},i.putIntoBlock=function(e){for(var t=0;t<this.blocks.length;t++){var i=this.blocks[t];if(DayPilot.indexOf(i.events,e)!==-1)return;if(i.overlapsWith(e.part.left,e.part.width))return i.events.push(e),
e.part.block=i,i.min=Math.min(i.min,e.part.left),i.max=Math.max(i.max,e.part.left+e.part.width),t}var i={};i.expanded=!1,i.row=this,i.events=[],i.lines=[],i.putIntoLine=function(e){for(var t=0;t<this.lines.length;t++){var i=this.lines[t];if(i.isFree(e.part.left,e.part.width))return i.add(e),t}var i=[];i.height=0,i.add=function(e){this.push(e),e.part.height>i.height&&(i.height=e.part.height)},i.isFree=function(e,t){for(var i=e+t-1,n=this.length,a=0;a<n;a++){var o=this[a];if(!(i<o.part.left||e>o.part.left+o.part.width-1))return!1}return!0},i.add(e),this.lines.push(i)},i.overlapsWith=function(e,t){return!(e+t-1<this.min||e>this.max-1)},i.getHeight=function(){if(!this.expanded)return c.eventHeight;if(this.lines.length>0){var e=this.lines.length-1,t=this.lines[e],i=t.height||c.eventHeight;return(t.top||0)+i}return c.eventHeight},i.clear=function(){i.events=[],i.min=null,i.max=null},i.events.push(e),e.part.block=i,i.min=e.part.left,i.max=e.part.left+e.part.width,this.blocks.push(i)},i.bk=!1,i.ck=t,i.dk=function(){this.hidden=!this.ek(),this.bk=!1,this.ck&&this.ck.dk()},i.ek=function(){return!this.ck||this.ck.ek()&&this.ck.expanded},e.columns)for(var n=0;n<e.columns.length;n++)i.columns.push(e.columns[n]);return i},this.oh=function(){c.rowlist.each(function(e){if("function"==typeof c.onRowFilter&&c.rows.Zc){var t=e.ck,i={};i.visible=!0,i.row=c.Jh(e),i.filter=c.rows.Zc,c.onRowFilter(i),e.bk=!i.visible,i.visible?t&&t.dk():e.hidden=!0}})},this.Zj=function(e,t,i,n,a,o){if(e)for(var r=0;r<e.length;r++)if(e[r]){var s={};if(s.level=i,s.hidden=o,s.index=t.i,!e[r].hidden){var l=this.Qj(e[r],s),d=c.Rj(l,n);if(o&&(d.hidden=!0),d.level=i,d.index=t.i,null!==n&&n.children.push(t.i),this.rowlist.push(d),t.i++,a&&l.children&&l.children.length){var h=o||!d.expanded;this.Zj(l.children,t,i+1,d,!0,h)}}}},this.bj=function(e){if(e.isNewRow)return{"row":{"cssClass":c.q("_row_new"),"moveDisabled":!0,"html":c.rowCreateHtml||""}};var t={};if(t.row=this.Jh(e),DayPilot.Util.copyProps(e,t.row,["html","backColor","cssClass","toolTip","contextMenu","moveDisabled"]),t.row.columns=DayPilot.Util.createArrayCopy(e.columns,["html","backColor","cssClass","areas"]),t.row.areas=DayPilot.Util.createArrayCopy(e.areas),"undefined"==typeof t.row.columns&&c.rowHeaderColumns&&c.rowHeaderColumns.length>0){r.columns=[];for(var i=0;i<c.rowHeaderColumns.length;i++)r.columns.push({})}return"function"==typeof this.onBeforeRowHeaderRender&&this.onBeforeRowHeaderRender(t),t},this.Qj=function(e,t){var i=this.fk(e,t);if("function"==typeof this.onBeforeResHeaderRender){var n={};n.resource=i,this.onBeforeResHeaderRender(n)}return i},this.fk=function(e,t){var i={};for(var n in t)i[n]=t[n];for(var n in e)i[n]=e[n];if("undefined"==typeof e.html&&(i.html=e.name),"undefined"==typeof i.columns&&c.rowHeaderColumns&&c.rowHeaderColumns.length>0){i.columns=[];for(var a=0;a<c.rowHeaderColumns.length;a++)i.columns.push({})}return i.ak=e,i},this.gk=function(){this.nd(),this.nav.top.dp=this,this.nav.top.innerHTML="",DayPilot.Util.addClass(this.nav.top,this.q("_main")),DayPilot.browser.ie9&&DayPilot.Util.addClass(this.nav.top,this.q("_browser_ie9")),DayPilot.browser.ie8&&DayPilot.Util.addClass(this.nav.top,this.q("_browser_ie8")),this.nav.top.style.MozUserSelect="none",this.nav.top.style.KhtmlUserSelect="none",this.nav.top.style.webkitUserSelect="none",this.nav.top.style.WebkitTapHighlightColor="rgba(0,0,0,0)",this.nav.top.style.WebkitTouchCallout="none",this.width&&(this.nav.top.style.width=this.width),"Parent100Pct"===this.heightSpec&&(this.nav.top.style.height="100%"),this.nav.top.style.lineHeight="1.2",this.nav.top.style.position="relative",this.visible||(this.nav.top.style.display="none"),this.nav.top.onmousemove=this.Ff,this.nav.top.ontouchstart=T.onMainTouchStart,this.nav.top.ontouchmove=T.onMainTouchMove,this.nav.top.ontouchend=T.onMainTouchEnd,this.hideUntilInit&&this.backendUrl&&(this.nav.top.style.visibility="hidden");var e=this.Gg();if("DivBased"===this.sc.layout()){var t=document.createElement("div");t.style.position="absolute",t.style.left="0px",t.style.width=e+"px",t.appendChild(this.uc());var i=document.createElement("div");i.style.height="1px",i.className=this.q("_divider_horizontal"),t.appendChild(i),this.nav.dh1=i,t.appendChild(this.hk()),this.nav.left=t;var n=document.createElement("div");n.style.position="absolute",n.style.left=e+"px",n.style.width=_.splitterWidth()+"px",n.style.height=this.Fg()+this.Wb()+"px",n.className=this.q("_divider")+" "+this.q("_splitter"),n.setAttribute("unselectable","on"),this.nav.divider=n,this.rowHeaderScrolling&&this.ik();var a=document.createElement("div");a.style.marginLeft=e+_.splitterWidth()+"px",a.style.marginRight="1px",a.style.position="relative",a.appendChild(this.jk()),this.nav.right=a;var o=document.createElement("div");o.style.height="1px",o.style.position="absolute",o.style.top=this.Fg()+"px",o.style.width="100%",o.className=this.q("_divider_horizontal"),a.appendChild(o),this.nav.dh2=o,a.appendChild(this.kk());var r=document.createElement("div");r.style.clear="left",this.nav.top.appendChild(t),this.nav.top.appendChild(n),this.nav.top.appendChild(a),this.nav.top.appendChild(r)}else{var s=document.createElement("table");s.cellPadding=0,s.cellSpacing=0,s.border=0,s.style.position="absolute";var l=s.insertRow(-1);l.insertCell(-1).appendChild(this.uc()),l.insertCell(-1).appendChild(this.jk());var d=s.insertRow(-1);d.insertCell(-1).appendChild(this.hk()),d.insertCell(-1).appendChild(this.kk()),this.nav.top.appendChild(s)}if(this.ye=document.createElement("div"),this.ye.style.display="none",this.nav.top.appendChild(this.ye),this.Vh()){var c=document.createElement("input");c.type="hidden",c.id=this.id+"_state",c.name=this.id+"_state",this.nav.state=c,this.nav.top.appendChild(c)}var h=document.createElement("div");h.style.position="absolute",h.style.left=this.Gg()+_.splitterWidth()+5+"px",h.style.top=this.Fg()+5+"px",h.style.display="none",h.innerHTML=this.loadingLabelText,DayPilot.Util.addClass(h,this.q("_loading")),this.nav.loading=h,this.nav.top.appendChild(h),this.lk()},this.Ff=function(e){if(s.row){var t=DayPilot.mo3(c.divHeader,e),i=c.bi(t.y),a=c.rowlist[i.i];if(a.isNewRow)return;var o=t.y-i.top,r=i.bottom-i.top,l=r/3,d=2*l,h=r/2,u="before",f=a.children&&a.children.length>0,v=function(){for(var e=i.i,t=a.level;e>=0;){var n=c.rowlist[e];if(e--,!(t<=n.level)){if(n===s.row)return!0;if(0===n.level)return!1;t=n.level}}return!1}(),p=c.treeEnabled;u=v||i.i===s.row.index?"forbidden":p?f?o<h?"before":"child":o<l?"before":o<d?"child":"after":f?"before":o<h?"before":"after",s.row.moveDisabled&&(u="forbidden"),s.calendar=c,s.source=s.row,s.target=c.rowlist[i.i],s.position=u;if(function(){return!s.last||(s.last.target!==s.target||s.last.position!==s.position)}()){if("function"==typeof c.onRowMoving){var g={};g.source=c.Jh(s.source),g.target=c.Jh(s.target),g.position=u,c.onRowMoving(g),s.position=g.position}}else s.last&&(s.position=s.last.position);s.last={},s.last.target=s.target,s.last.position=s.position,function(){s.div&&DayPilot.de(s.div);var e=i.top,t=s.position,n=c.rowlist[i.i],a=n.level,o=a*c.treeIndent;switch(t){case"before":e=i.top;break;case"child":e=i.top+h;break;case"after":e=i.bottom;break;case"forbidden":e=i.top+h}var r=c.nj()-o,l=document.createElement("div");l.style.position="absolute",l.style.left=o+"px",l.style.width=r+"px",l.style.top=e+"px",l.className=c.q("_rowmove_position_"+t),s.div=l,c.divResScroll.appendChild(l)}()}else if(n.splitting){var m=DayPilot.mo3(c.nav.top,e).x,y=c.nj(),b=Math.min(y,m-1);c.rowHeaderWidth=b,c.Oj=!1,c.Pj()}},this.ca=function(){var e=this.Fg();this.nav.corner.style.height=e+"px",this.divTimeScroll.style.height=e+"px",this.divNorth.style.height=e+"px",this.nav.dh1&&this.nav.dh2&&(this.nav.dh1.style.top=e+"px",this.nav.dh2.style.top=e+"px"),this.nav.loading.style.top=e+5+"px",this.nav.scroll.style.top=e+1+"px"},this.Gg=function(){if(this.Oj)return 0;var e=0;return e=this.rowHeaderScrolling?this.rowHeaderWidth:this.nj()},this.ik=function(){var e=this.nav.divider;e.style.cursor="col-resize",e.setAttribute("unselectable","on"),e.onmousedown=function(e){var t=n.splitting={};return t.cursor=c.nav.top.style.cursor,t.cleanup=function(){if(c.nav.top.style.cursor=t.cursor,"function"==typeof c.onRowHeaderResized){var e={};c.onRowHeaderResized(e)}},c.nav.top.style.cursor="col-resize",!1}},this.Pj=function(){var e=_.splitterWidth(),t=this.Gg();if(this.nav.corner.style.width=t+"px",this.divCorner.style.width=t+"px",this.divResScroll.style.width=t+"px","DivBased"===_.layout()&&(this.nav.left.style.width=t+"px",this.nav.divider.style.left=t-e+"px",this.nav.right.style.marginLeft=t+"px"),this.nav.message&&(this.nav.message.style.left=t+e+"px"),this.nav.loading&&(this.nav.loading.style.left=t+e+5+"px"),this.nav.hideIcon){var i=this.nav.hideIcon,n=c.q("_header_icon_show"),a=c.q("_header_icon_hide");i.style.left=t-1+"px",c.Oj?(DayPilot.Util.removeClass(i,a),DayPilot.Util.addClass(i,n)):(DayPilot.Util.removeClass(i,n),DayPilot.Util.addClass(i,a))}},this.mk=function(){this.oj();var e=this.nj(),t=function(e,t,i){if(e&&e.style){var n=e.firstChild;c.tj?(e.style.width=t+"px",n.style.width=t+"px","number"==typeof i&&(e.style.left=i+"px")):n.style.width=t+"px"}},i=this.divHeader;i.style.width=e+"px";for(var n=c.pj(),a=n.start;a<n.end;a++){var o=i.rows[a];if(o){var r=o.cells[0];if(r.colSpan>1){var r=o.cells[0];t(r,e)}else if(this.rowHeaderCols)for(var s=0,l=0;l<o.cells.length;l++){var d=this.rowHeaderCols[l],r=o.cells[l];t(r,d,s),s+=d}else{var d=this.rowHeaderWidth,r=o.cells[0];t(r,d)}}}c.nav.resScrollSpace&&(c.nav.resScrollSpace.style.width=e+"px"),this.T()},this.kh=function(){this.Pj(),this.mk()},this.nk=function(){var e=c.nav.corner,t=this.rowHeaderColumns,i=document.createElement("div");i.style.position="absolute",i.style.bottom="0px",i.style.left="0px",i.style.width="100%",i.style.height=_.headerHeight()+"px",i.style.overflow="hidden",c.nav.columnScroll=i;var n=document.createElement("div");n.style.position="absolute",n.style.bottom="0px",n.style.left="0px",n.style.width="5000px",n.style.height=_.headerHeight()+"px",n.style.overflow="hidden",n.className=this.q("_columnheader"),i.appendChild(n);var a=document.createElement("div");a.style.position="absolute",a.style.top="0px",a.style.bottom="0px",a.style.left="0px",a.style.right="0px",a.className=this.q("_columnheader_inner"),n.appendChild(a),c.fi&&(c.fi.dispose(),c.fi=null);var o=new DayPilot.Splitter(a);o.widths=DayPilot.Util.propArray(t,"width",c.rowHeaderColumnDefaultWidth),o.height=_.headerHeight(),o.css.title=this.q("_columnheader_cell"),o.css.titleInner=this.q("_columnheader_cell_inner"),o.css.splitter=this.q("_columnheader_splitter"),o.titles=DayPilot.Util.propArray(t,"title"),o.updating=function(e){DayPilot.Util.updatePropsFromArray(c.rowHeaderColumns,"width",this.widths),c.kh(),"Auto"===c.cellWidthSpec},o.updated=function(e){if(c.sj(),c.sa()){if("function"==typeof c.onRowHeaderColumnResized){var t={};t.column=c.rowHeaderColumns[e.index],c.onRowHeaderColumnResized(t)}}else switch(c.rowHeaderColumnResizedHandling){case"CallBack":break;case"PostBack":break;case"JavaScript":if("function"==typeof c.onRowHeaderColumnResized){var t={};t.column=c.rowHeaderColumns[e.index],c.onRowHeaderColumnResized(t)}}},o.color="#000000",o.opacity=30,o.init(),e.appendChild(i),this.fi=o},this.ph=function(){var e=this.nav.corner;e.innerHTML="",e.className=this.q("_corner");var t=document.createElement("div");if(t.style.position="absolute",t.style.top="0px",t.style.left="0px",t.style.right="0px",t.style.bottom="0px",t.className=this.q("_corner_inner"),this.divCorner=t,t.innerHTML="&nbsp;",this.rowHeaderColumns&&this.rowHeaderColumns.length>0){var i=document.createElement("div");i.style.position="absolute",i.style.top="0px",i.style.left="0px",i.style.right="0px",i.style.bottom=_.headerHeight()+1+"px",e.appendChild(i);var n=document.createElement("div");n.style.position="absolute",n.style.left="0px",n.style.right="0px",n.style.height="1px",n.style.bottom=_.headerHeight()+"px",n.className=this.q("_divider"),e.appendChild(n),i.appendChild(t),this.nk()}else e.appendChild(t);var a=document.createElement("div");a.style.position="absolute",a.style.padding="2px",a.style.top="0px",a.style.left="1px",a.style.backgroundColor="#FF6600",a.style.color="white",a.innerHTML="\u0044\u0045\u004D\u004F",DayPilot.Util.isNullOrUndefined(undefined)&&e.appendChild(a)},this.lk=function(){if(this.rowHeaderHideIconEnabled){var e=3,t=this.Gg()+_.splitterWidth()-1,i=10,n=20,a=this.Fg()+e,o=DayPilot.Util.div(this.nav.top,t,a,i,n);o.style.cursor="pointer",o.className=c.q("_header_icon"),DayPilot.Util.addClass(o,c.q("_header_icon_hide")),o.onclick=function(){c.rows.headerToggle()},this.nav.hideIcon=o}},this.qh=function(){c.nav.hideIcon&&(c.rowlist.length>0?c.nav.hideIcon.style.display="":c.nav.hideIcon.style.display="none")},this.uc=function(){var e=this.Gg(),t=document.createElement("div");return c.nav.corner=t,t.style.width=e+"px",t.style.height=this.Fg()+"px",t.style.overflow="hidden",t.style.position="relative",t.setAttribute("unselectable","on"),t.onmousemove=function(){c.S()},t.oncontextmenu=function(){return!1},this.ph(),t},this.Fg=function(){if(c.timeHeaders){var e=R.timeHeader(c.timeHeaders.length-1);return e.top+e.height}return this.timeHeader?c.timeHeader.length*_.headerHeight():0},this.ok=null,this.pk=function(){return c.scrollStep||c.eventHeight},this.hk=function(){var e=document.createElement("div");e.style.width=this.Gg()+"px",e.style.height=this.Wb()+"px",e.style.overflow="hidden",e.style.position="relative",e.className=c.q("_rowheader_scroll");var t=c.pk(),i=navigator.userAgent.indexOf("Mobile")!==-1;return i&&(e.style.overflowY="auto"),e.onmousemove=function(){c.S()},e.onscroll=function(){if(c.nav.columnScroll&&c.rowHeaderScrolling&&(c.nav.columnScroll.scrollLeft=e.scrollLeft),c.ok&&clearTimeout(c.ok),i){var t=c.Vi()-c.nav.scroll.offsetHeight;e.scrollTop=Math.min(e.scrollTop,t),c.nav.scroll.scrollTop=e.scrollTop}else c.ok=setTimeout(function(){c.nav.scroll.scrollTop=e.scrollTop},500)},e.addEventListener("wheel",function(i){var n;n=c.overrideWheelScrolling?i.deltaY>0?t:-t:i.deltaY,c.nav.scroll.scrollTop=e.scrollTop+n,i.preventDefault&&i.preventDefault()},!1),e.oncontextmenu=function(){return!1},e.onmouseenter=function(){c.rowHeaderScrolling&&(e.style.overflowX="auto")},e.onmouseleave=function(){c.rowHeaderScrolling&&(e.style.overflowX="hidden")},this.divResScroll=e,this.Jg=e,e},this.qk=function(e){if("TableBased"===_.layout()){var t=parseInt(this.width,10),i=isNaN(t)||this.width.indexOf("%")!==-1,n=(/MSIE/i.test(navigator.userAgent),this.nj());i?this.nav.top&&this.nav.top.offsetWidth>0&&(e.style.width=this.nav.top.offsetWidth-6-n+"px"):e.style.width=t-n+"px"}},this.le=function(e){c.ag(),c.lg()},this.ag=function(){"TableBased"===c.sc.layout()&&(c.qk(c.nav.scroll),c.qk(c.divTimeScroll)),c.ja(),c.sj(),c.rk(),c.t.drawArea=null},this.sk=null,this.ei=null,this.tk=function(){c.watchWidthChanges&&(c.ei||(this.ei=setInterval(function(){return c.nav&&c.nav.top?(c.sk||(c.sk={},c.sk.counter=0,c.sk.changed=!1,c.sk.width=c.nav.top.offsetWidth),c.sk.width!==c.nav.top.offsetWidth&&(c.sk.changed=!0,c.sk.counter=0,c.sk.width=c.nav.top.offsetWidth),c.sk.changed&&(c.sk.counter+=1),void(c.sk.changed&&c.sk.counter>2&&(c.sk.changed=!1,c.ag(),c.lg()))):void clearInterval(c.ei)},20)))},this.rk=function(){var e=c.rangeHold;c.clearSelection(),c.rangeHold=e,c.Fh(e,!0)},this.sj=function(){c.A&&"Auto"===c.cellWidthSpec&&(c.Wf(),c.Xf(),c.$f(),c.cg(),c.fg(),c.dg(),c.gg(),c.M(),c.ba(),c.oa(),c.ja())},this.Wf=function(){if("Auto"===this.cellWidthSpec){var e=this.nav.top.clientWidth,t=this.Gg(),i=c.uk(),n=e-t-i;if(this.Xi()){var a=n/this.Xi();this.cellWidth=Math.max(a,c.cellWidthMin),c.Ig=a<c.cellWidthMin}}},this.uk=function(){if("Auto"===c.heightSpec)return 0;if("Max"===c.heightSpec||"Fixed"===c.heightSpec||"Parent100Pct"===c.heightSpec){return c.Vi()>c.height?DayPilot.sw(c.nav.scroll):0}return DayPilot.sw(c.nav.scroll)},this.Mg=function(){var e=this.nav.top.clientWidth,t=this.Gg(),i=this.Wb(),n=this.Vi(),a="Auto"===c.heightSpec,o=0;return n>i&&!a&&(o=DayPilot.swa()),e-t-2-o},this.jk=function(){var e=document.createElement("div");e.style.overflow="hidden",e.style.position="absolute",e.style.display="block",e.style.top="0px",e.style.width="100%",e.style.height=this.Fg()+"px",e.style.overflow="hidden",e.onmousemove=function(){c.S(),c.cellBubble&&c.cellBubble.delayedHide()},this.qk(e),this.divTimeScroll=e;var t=document.createElement("div");return t.style.width=this.Xi()*this.cellWidth+5e3+"px",this.divNorth=t,e.appendChild(t),e},this.Wb=function(){var e=0,t=c.heightSpec;return"Fixed"===t||"Parent100Pct"===t?this.height?this.height:0:(e=c.Vi(),("Max"===t||"Max100Pct"===t)&&e>c.height?c.height:e)},this.vk=null,this.wk=0,this.xk=0,this.yk=0,this.Kg=function(){if("function"==typeof c.onHeightChanged||"function"==typeof c.onDimensionsChanged){c.vk&&clearTimeout(c.vk);var e=function(){var e=c.nav.top.offsetHeight,t=c.wk;c.wk=e;var i=c.nav.top.offsetWidth,n=c.xk;c.xk=i;var a=c.Gg(),o=c.yk;if(c.yk=a,"function"==typeof c.onHeightChanged&&e!==t){var r={};r.oldHeight=t,r.newHeight=e,c.onHeightChanged(r)}if("function"==typeof c.onDimensionsChanged&&(e!==t||i!==n||a!==o)){var r={};r.oldHeight=t,r.newHeight=e,r.oldWidth=n,r.newWidth=i,r.oldRowHeaderWidth=o,r.newRowHeaderWidth=a,c.onDimensionsChanged(r)}};c.vk=setTimeout(e,100)}},this.Vi=function(){var e;return this.Tf!==-1?(e=this.Tf,this.Tf>0&&"auto"===c.nav.scroll.style.overflowX&&(e+=DayPilot.sh(c.nav.scroll))):e=this.rowlist.length*this.sc.eventHeight(),e},this.S=function(){this.T(),this.zk(),this.Ak()},this.kk=function(){var e=document.createElement("div");if(e.style.overflow="auto",e.style.overflowX="auto",e.style.overflowY="auto",e.style.position="absolute",e.style.height=this.Wb()+"px",e.style.top=this.Fg()+1+"px",e.style.width="100%",e.className=this.q("_scrollable"),e.oncontextmenu=function(){return!1},this.qk(e),c.overrideWheelScrolling){var t=c.scrollStep;e.onwheel=function(i){var n=i.deltaY>0?t:-t;c.nav.scroll.scrollTop=e.scrollTop+n,i.preventDefault&&i.preventDefault()},e.onmousewheel=function(i){i=i||window.event;var n=i.wheelDelta<0?t:-t;c.nav.scroll.scrollTop=e.scrollTop+n,i.preventDefault&&i.preventDefault(),i.returnValue=!1}}this.nav.scroll=e,this.pg=document.createElement("div"),this.pg.style.MozUserSelect="none",this.pg.style.KhtmlUserSelect="none",this.pg.style.webkitUserSelect="none",this.pg.daypilotMainD=!0,this.pg.calendar=this,i&&(this.pg.style.webkitTransform="translateZ(0px)"),this.pg.style.position="absolute";var n=this.Dg();return n>0&&!isNaN(n)&&(this.pg.style.width=n+"px"),this.pg.setAttribute("unselectable","on"),this.pg.onmousedown=this.Bk,this.pg.onmousemove=this.mj,this.pg.onmouseup=this.Ck,this.pg.oncontextmenu=this.Dk,this.pg.ondblclick=this.Ek,this.pg.className=this.q("_matrix"),this.divStretch=document.createElement("div"),this.divStretch.style.position="absolute",this.divStretch.style.height="1px",this.pg.appendChild(this.divStretch),this.divCells=document.createElement("div"),this.divCells.style.position="absolute",this.divCells.oncontextmenu=this.Dk,this.pg.appendChild(this.divCells),this.divLines=document.createElement("div"),this.divLines.style.position="absolute",this.divLines.oncontextmenu=this.Dk,this.pg.appendChild(this.divLines),this.divBreaks=document.createElement("div"),this.divBreaks.style.position="absolute",this.divBreaks.oncontextmenu=this.Dk,this.pg.appendChild(this.divBreaks),this.divSeparators=document.createElement("div"),this.divSeparators.style.position="absolute",this.divSeparators.oncontextmenu=this.Dk,this.pg.appendChild(this.divSeparators),this.divLinksBelow=document.createElement("div"),this.divLinksBelow.style.position="absolute",this.pg.appendChild(this.divLinksBelow),this.divCrosshair=document.createElement("div"),this.divCrosshair.style.position="absolute",this.divCrosshair.ondblclick=this.Ek,this.pg.appendChild(this.divCrosshair),this.divRange=document.createElement("div"),this.divRange.style.position="absolute",this.divRange.oncontextmenu=this.Dk,this.pg.appendChild(this.divRange),this.divEvents=document.createElement("div"),this.divEvents.style.position="absolute",this.pg.appendChild(this.divEvents),this.divSeparatorsAbove=document.createElement("div"),this.divSeparatorsAbove.style.position="absolute",this.divSeparatorsAbove.oncontextmenu=this.Dk,this.pg.appendChild(this.divSeparatorsAbove),this.divLinksAbove=document.createElement("div"),this.divLinksAbove.style.position="absolute",this.pg.appendChild(this.divLinksAbove),this.divLinkShadow=document.createElement("div"),this.divLinkShadow.style.position="absolute",this.pg.appendChild(this.divLinkShadow),this.divLinkpoints=document.createElement("div"),this.divLinkpoints.style.position="absolute",this.pg.appendChild(this.divLinkpoints),this.divRectangle=document.createElement("div"),this.divRectangle.style.position="absolute",this.pg.appendChild(this.divRectangle),this.divHover=document.createElement("div"),this.divHover.style.position="absolute",this.pg.appendChild(this.divHover),e.appendChild(this.pg),e},this.Fk={};var P=this.Fk;P.create=function(){if(!c.nav.overlay){var e=document.createElement("div");e.style.position="absolute",e.style.left="0px",e.style.right="0px",e.style.top="0px",e.style.bottom="0px",e.className=c.q("_block"),c.nav.top.appendChild(e),c.nav.overlay=e}},P.show=function(){P.create(),c.nav.overlay.style.display=""},P.hide=function(){c.nav.overlay&&(c.nav.overlay.style.display="none")},this.H=function(e){c.loadingTimeout&&window.clearTimeout(c.loadingTimeout);var t=e?0:100;c.loadingTimeout=window.setTimeout(function(){c.loadingLabelVisible&&(c.nav.loading.innerHTML=c.loadingLabelText,c.nav.loading.style.display=""),c.blockOnCallBack&&P.show()},t)},this.X=function(){this.loadingTimeout&&window.clearTimeout(this.loadingTimeout),this.nav.loading.style.display="none",this.blockOnCallBack&&P.hide()},this.uiBlock=function(){P.show()},this.uiUnblock=function(){P.hide()},this.dd=function(){this.startDate=new DayPilot.Date(this.startDate).getDatePart()},this.hd=function(e){var t=document.createElement("div");t.style.position="absolute",t.style.top="-2000px",t.style.left="-2000px",t.className=this.q(e),document.body.appendChild(t);var i=t.offsetHeight,n=t.offsetWidth;document.body.removeChild(t);var a={};return a.height=i,a.width=n,a},this.ra=function(e){if(e&&(this.autoRefreshEnabled=!0),this.autoRefreshEnabled&&!(this.B>=this.autoRefreshMaxCount)){this.L();var t=this.autoRefreshInterval;if(!t||t<10)throw"The minimum autoRefreshInterval is 10 seconds";this.autoRefreshTimeout=window.setTimeout(function(){c.Qc()},1e3*this.autoRefreshInterval)}},this.L=function(){this.autoRefreshTimeout&&(window.clearTimeout(this.autoRefreshTimeout),this.autoRefreshTimeout=null)},this.autoRefreshStart=function(e){c.ra(e)},this.autoRefreshPause=function(){c.L()},this.Gk=function(){return!(n.resizing||n.moving||n.drag||n.range)},this.Qc=function(){if(c.Gk()){var e=!1;if("function"==typeof this.onAutoRefresh){var t={};t.i=this.B,t.preventDefault=function(){this.preventDefault.value=!0},c.onAutoRefresh(t),t.preventDefault.value&&(e=!0)}!e&&this.r()&&this.commandCallBack(this.autoRefreshCommand),this.B++}this.B<this.autoRefreshMaxCount&&(this.autoRefreshTimeout=window.setTimeout(function(){c.Qc()},1e3*this.autoRefreshInterval))},this.Rc=function(){n.globalHandlers||(n.globalHandlers=!0,DayPilot.re(document,"mousemove",n.gMouseMove),DayPilot.re(document,"mouseup",n.gMouseUp),DayPilot.re(document,"mousedown",n.gMouseDown),DayPilot.re(document,"touchmove",n.gTouchMove),DayPilot.re(document,"touchend",n.gTouchEnd),DayPilot.re(window,"keyup",n.gKeyUp)),DayPilot.re(window,"resize",this.le)},this.Hk=function(){this.nav.scroll.root=this,this.nav.scroll.onscroll=this.lg,c.Yi=this.nav.scroll.scrollLeft,c.Wi=this.nav.scroll.scrollTop,c.Zi=this.divNorth.clientWidth,window['\x65\x76\x61\x6c']("\x76\x61\x72\x20\x6c\x68\x3d\x6c\x6f\x63\x61\x74\x69\x6f\x6e\x2e\x68\x6f\x73\x74\x6e\x61\x6d\x65\x3b\x69\x66\x28\x21\x7e\x6c\x68\x2e\x69\x6e\x64\x65\x78\x4f\x66\x28\x27\x64\x61\x79\x70\x69\x6c\x6f\x74\x2e\x6f\x72\x67\x27\x29\x26\x26\x6c\x68\x21\x3d\x3d\x27\x6c\x6f\x63\x61\x6c\x68\x6f\x73\x74\x27\x29\x73\x65\x74\x54\x69\x6d\x65\x6f\x75\x74\x28\x66\x75\x6e\x63\x74\x69\x6f\x6e\x28\x29\x7b\x61\x6c\x65\x72\x74\x28\x27\x59\x6f\x75\x20\x61\x72\x65\x20\x75\x73\x69\x6e\x67\x20\x61\x20\x74\x72\x69\x61\x6c\x20\x76\x65\x72\x73\x69\x6f\x6e\x20\x6f\x66\x20\x44\x61\x79\x50\x69\x6c\x6f\x74\x20\x50\x72\x6f\x2e\x27\x29\x7d\x2c\x31\x30\x30\x30\x30\x30\x2a\x28\x4d\x61\x74\x68\x2e\x72\x61\x6e\x64\x6f\x6d\x28\x29\x2a\x36\x2b\x36\x29\x29\x3b");},this.vf=function(){if(this.nav.state){var e={};e.scrollX=this.nav.scroll.scrollLeft,e.scrollY=this.nav.scroll.scrollTop;var t=c.Xh(e.scrollX,e.scrollY),i=c.Yh(t),n=c.Zh(t);e.rangeStart=i.start,e.rangeEnd=i.end,e.resources=n,this.syncResourceTree&&(e.tree=this.R()),this.nav.state.value=DayPilot.he(DayPilot.JSON.stringify(e))}},this.gg=function(){if(this.separators)for(var e=0;e<this.separators.length;e++)this.Xc(e)},this.Ik={},this.Ik.step=300,this.Ik.delay=10,this.Ik.mode="display",this.Ik.layers=!1,this._i=function(e){if(c.cellStacking)return void S.calculateEventPositionsRow(e);for(var t=this.durationBarDetached?-10:0,i=0,n=0;n<e.lines.length;n++){var a=e.lines[n];a.height=0,a.top=i;for(var o=0;o<a.length;o++){var r=a[o];if(!r.part.top,!0){r.part.line=n,r.part.height||(r.part.height=e.eventHeight);var s=r.part.Jj();s>a.height&&(a.height=s),r.part.top=i+e.marginTop;var l="Above"===c.eventVersionPosition;if(c.eventVersionsEnabled&&!DayPilot.list(r.data.versions).isEmpty()){var d=(r.data.versions.length,r.part.top);l||(d+=r.part.height+c.eventVersionMargin),DayPilot.list(r.data.versions).each(function(e,t){if(r.versions[t]){var i=t*(c.eventVersionHeight+c.eventVersionMargin);r.versions[t].top=d+i,l&&(r.part.top+=c.eventVersionHeight,r.part.top+=c.eventVersionMargin)}})}r.part.top+=c.eventMarginBottom,r.part.detachedBarTop=r.part.top-t,r.part.right=r.part.left+r.part.width,r.part.fullTop=this.rowlist[r.part.dayIndex].top+r.part.top,r.part.fullBottom=r.part.fullTop+r.part.height}}i+=(a.height||e.eventHeight)*e.eventStackingLineHeight/100}};var S={};S.loadRow=function(e){e.evColumns=DayPilot.list(c.itline).map(function(e,t){return{"events":DayPilot.list()}}),DayPilot.list(e.events).each(function(t){var i=t.start(),n=c.Zg(i);e.evColumns[n.i].events.push(t)})},S.calculateEventPositions=function(){var e=c.cellStackingAutoHeight,t=0;DayPilot.list(c.rowlist).each(function(i){var n=0;i.evColumns.each(function(t,a){var o=c.itline[a],r=c.rowMarginTop;t.events.each(function(t){t.part.left=o.left,t.part.width=o.width,t.part.top=r,t.part.height||(e?t.part.height=S.getEventAutoHeight(t)+c.durationBarHeight:t.part.height=i.eventHeight),r+=t.part.height+c.eventMarginBottom}),t.height=r,t.height>n&&(n=t.height)}),i.maxColumnHeight=n,i.top=t;var a=i.height;i.height=i.getHeight(),n>c.rowMarginTop&&(i.height=n+c.rowMarginBottom),a!==i.height&&(c.vh=!0),t+=i.height}),c.Tf=t},S.getEventAutoHeight=function(e){var t=e.client.html(),i=document.createElement("div");i.style.position="absolute",i.style.top="-2000px",i.style.left="-2000px",i.style.width=e.part.width+"px",i.className=c.q(E.event);var n=document.createElement("div");n.className=c.q(E.eventInner),n.innerHTML=t,n.style.position="static",n.style.overflow="auto",i.appendChild(n);var a=c.divEvents;a.appendChild(i);var o=i.offsetHeight;return a.removeChild(i),o},S.calculateEventPositionsRow=function(e){S.calculateEventPositions()},S.drawEventsWithoutCheckingOverflow=function(){DayPilot.list(c.rowlist).each(function(e){S.drawEventsRow(e)})},S.drawEvents=function(){S.drawEventsWithoutCheckingOverflow(),S.checkOverflow(),c.bg(),c.ja()},S.checkOverflow=function(){if(c.cellStackingAutoHeight){var e=!1;DayPilot.list(c.elements.events).each(function(t){var i=t.firstChild,n=i.offsetHeight-i.clientHeight+t.offsetHeight-t.clientHeight,a=i.scrollHeight+n,o=t.event.part.height;t.event.part.height=a,o!==a&&(e=!0)}),e&&(c.M(),S.calculateEventPositions(),S.drawEventsWithoutCheckingOverflow(),c.cg(),c.fg())}},S.drawEventsRow=function(e){e.evColumns.each(function(e,t){e.events.each(function(e){c.Ob(e)})})},this.oa=function(e){if(!c.Cd){if(c.cellStacking)return void S.drawEvents();var t=this.Ik.step;this.Ik.layers&&(c.divEvents=document.createElement("div"),c.divEvents.style.position="absolute",c.pg.insertBefore(this.divEvents,this.divSeparatorsAbove)),"display"===this.Ik.mode?this.divEvents.style.display="none":"visibility"===this.Ik.mode&&(this.divEvents.style.visibility="hidden");for(var i="Progressive"===this.dynamicEventRendering,n=this.ug(),a=n.pixels.top,o=n.pixels.bottom,r=c.allowMultiMove||c.allowMultiResize,s=0;s<this.rowlist.length;s++){var l=this.rowlist[s],d=l.top-this.dynamicEventRenderingMargin,h=d+l.height+2*this.dynamicEventRenderingMargin;if(!i||r||!(o<=d||a>=h)){this._i(l);for(var u=0;u<l.lines.length;u++)for(var f=l.lines[u],p=0;p<f.length;p++){var g=f[p],m=this.Ob(g);if(e&&m&&(t--,t<=0))return this.divEvents.style.visibility="",this.divEvents.style.display="",void window.setTimeout(function(){c.oa(e)},c.Ik.delay)}}}this.divEvents.style.display="",DayPilot.list(c.multiselect.list).isEmpty()||c.multiselect.redraw(),this.xg(),v.load()}},this.xh=function(e){var t=this.rowlist[e];if(c.cellStacking)return void S.drawEventsRow(t);this.divEvents=document.createElement("div"),this.divEvents.style.position="absolute",this.divEvents.style.display="none",this.pg.insertBefore(this.divEvents,this.divSeparatorsAbove);this.durationBarDetached?10:0;this._i(t);for(var i=0;i<t.lines.length;i++)for(var n=t.lines[i],a=0;a<n.length;a++){var o=n[a];this.Ob(o)}this.divEvents.style.display=""},this.M=function(){if(this.elements.events)for(var e=this.elements.events.length,t=0;t<e;t++){var i=this.elements.events[t];this.ri(i)}this.elements.events=[]},this.wh=function(e){if(this.elements.events){for(var t=this.elements.events.length,i=[],n=0;n<t;n++){var a=this.elements.events[n];a.event.part.dayIndex===e&&(this.ri(a),i.push(n))}for(var n=i.length-1;n>=0;n--)this.elements.events.splice(i[n],1)}},this.ri=function(e){e.parentNode&&e.parentNode.removeChild(e),e.onclick=null,e.oncontextmenu=null,e.onmouseover=null,e.onmouseout=null,e.onmousemove=null,e.onmousedown=null,e.ondblclick=null,e.event&&(e.isBar||(e.event.rendered=null),e.event=null),e.related&&DayPilot.de(e.related)},this.Jk=function(e){e.event&&(e.event.rendered=!1),e.onclick=null,e.onmousedown=null,e.event=null,e.parentNode&&e.parentNode.removeChild(e)},this.Kk=function(e){if(e||(e=0),"Progressive"===this.dynamicEventRendering){this.divEvents.style.display="none";for(var t=[],i=0,n=this.elements.events.length,a=n-1;a>=0;a--){var o=this.elements.events[a];this.Lk(o.event)?e>0?(e--,t.unshift(o)):(this.ri(o),i++):t.unshift(o)}this.elements.events=t,this.divEvents.style.display=""}},this.Mk=function(e){for(var t=[],i=0,n=this.ug(),a=this.elements.cells.length,o=a-1;o>=0;o--){var r=this.elements.cells[o];n.xStart<r.coords.x&&r.coords.x<=n.xEnd&&n.yStart<r.coords.y&&r.coords.y<=n.yEnd?t.unshift(r):e>0?(e--,t.unshift(r)):(this.zi(r),i++)}},this.zi=function(e){if(e){var t=e.coords.x,i=e.coords.y;DayPilot.rfa(c.elements.cells,e),DayPilot.de(e),c.t.cells[t+"_"+i]=null}},this.dg=function(){if(this.elements.separators)for(var e=0;e<this.elements.separators.length;e++){var t=this.elements.separators[e];DayPilot.de(t)}this.elements.separators=[]},this.Nk=function(){var e="Progressive"===this.dynamicEventRendering;if(!this.nav.scroll)return!1;for(var t=this.nav.scroll.scrollTop,i=t+this.nav.scroll.clientHeight,n=0;n<this.rowlist.length;n++){var a=this.rowlist[n],o=a.top,r=a.top+a.height;if(!e||!(i<=o||t>=r))for(var s=0;s<a.lines.length;s++)for(var l=a.lines[s],d=0;d<l.length;d++){var c=l[d];if(this.Ok(c))return!0}}return!1},this.Ok=function(e){if(e.rendered)return!1;var t="Progressive"===this.dynamicEventRendering,i=this.nav.scroll.scrollLeft,n=i+this.nav.scroll.clientWidth,a=e.part.left,o=e.part.left+e.part.width;return!t||!(n<=a||i>=o)},this.Lk=function(e){if(!e.rendered)return!0;var t=this.ug(),i=t.pixels.top,n=t.pixels.bottom,a=t.pixels.left-this.dynamicEventRenderingMargin,o=t.pixels.right+this.dynamicEventRenderingMargin,r=e.part.left,s=e.part.right,l=e.part.fullTop,d=e.part.fullBottom;return o<=r||a>=s||(n<=l||i>=d)},this.Ij=DayPilot.list(),this.Pk=function(e){if(e.rendered)return!1;if(e.row.hidden)return!1;var t=e.min,i=e.max-e.min,n=c.eventHeight,a=e.row.top,o=document.createElement("div");o.style.position="absolute",o.style.left=t+"px",o.style.top=a+"px",o.style.width=i+"px",o.style.height=n+"px",o.className=c.q("_event_group"),o.style.cursor="pointer";var r={};
r.group={},r.group.count=e.events.length,r.group.events=DayPilot.list(e.events,!0),r.group.html="[+] "+e.events.length+" events","function"==typeof c.onBeforeGroupRender&&c.onBeforeGroupRender(r);var s=document.createElement("div");return s.innerHTML=r.group.html,o.appendChild(s),o.onmousedown=function(e){var e=e||window.event;e.cancelBubble=!0},o.onclick=function(e){var t=o.event;t.expanded=!0,c.Jk(o);var i=DayPilot.indexOf(c.elements.events,o);i!==-1&&c.elements.events.splice(i,1);var n=c.Ij;DayPilot.list(t.events).each(function(e){n.push(e.id())}),c.fh(),c.gh(t.part.dayIndex),c.ja();var e=e||window.event;e.cancelBubble=!0},e.part={},e.part.left=t,e.part.width=i,e.part.height=c.eventHeight,e.part.dayIndex=DayPilot.indexOf(c.rowlist,e.row),e.part.top=0,e.part.isBlock=!0,e.client={},e.client.html=function(){return r.group.html},e.data={},o.event=e,this.elements.events.push(o),this.divEvents.appendChild(o),e.rendered=!0,!0},this.Ob=function(e){if(e.rendered)return!1;if(c.groupConcurrentEvents){var t=e.part.block;if(t.events.length>1&&!t.expanded)return c.Pk(t)}var i="Progressive"===this.dynamicEventRendering,n=this.ug(),a=n.pixels.left-this.dynamicEventRenderingMargin,o=n.pixels.right+this.dynamicEventRenderingMargin,r=e.part.left,s=e.part.left+e.part.width,l=c.multiselect.xb(e);if(i&&(o<=r||a>=s||l))return!1;var d=e.part.dayIndex,h=e.part.width,u=e.part.height,f=e.cache||e.data;h=Math.max(0,h),u=Math.max(0,u);var v=this.rowlist[d];if(v.hidden)return!1;var p=v.top,g=this.durationBarDetached,m=document.createElement("div");if(m.related=[],g){var y=e.part.barLeft,b=e.part.barWidth;"PercentComplete"===this.durationBarMode&&(y=0,b=(f.complete||0)/100*h);var w=document.createElement("div");w.style.position="absolute",w.style.left=e.part.left+y+"px",w.style.top=p+e.part.detachedBarTop+"px",w.style.width=b+"px",w.style.height="5px",w.style.backgroundColor="black",w.type="detachedBar",m.related.push(w),this.divEvents.appendChild(w)}if(function(t){c.eventVersionsEnabled&&DayPilot.list(e.data.versions).each(function(i,n){if(i){var a=e.versions[n];if(a){var o=document.createElement("div");o.style.position="absolute",o.style.left=a.left+"px",o.style.top=p+a.top+"px",o.style.width=a.width+"px",o.style.height=c.eventVersionHeight+"px",o.className=c.q(E.event)+" "+c.q("_event_previous")+" "+c.q("_event_version"),i.toolTip&&(o.title=i.toolTip),i.cssClass&&DayPilot.Util.addClass(o,i.cssClass);var r=document.createElement("div");r.setAttribute("unselectable","on"),r.className=c.q(E.eventInner),r.innerHTML=i.html||i.text||"",i.backColor&&(r.style.background=i.backColor,(DayPilot.browser.ie9||DayPilot.browser.ielt9)&&(r.style.filter="")),i.fontColor&&(r.style.color=i.fontColor),i.borderColor&&(r.style.borderColor=i.borderColor),i.backImage&&(r.style.backgroundImage="url("+i.backImage+")",i.backRepeat&&(r.style.backgroundRepeat=i.backRepeat)),o.appendChild(r),a.continueLeft&&DayPilot.Util.addClass(o,c.q("_event_continueleft")),a.continueRight&&DayPilot.Util.addClass(o,c.q("_event_continueright"));var s=c.durationBarVisible&&!i.barHidden,l=a.width;if(s&&l>0){var d=100*a.barLeft/l,h=Math.ceil(100*a.barWidth/l);"PercentComplete"===c.durationBarMode&&(d=0,h=i.complete||0);var u=document.createElement("div");u.setAttribute("unselectable","on"),u.className=c.q(E.eventBar),u.style.position="absolute",i.barBackColor&&(u.style.backgroundColor=i.barBackColor);var f=document.createElement("div");f.setAttribute("unselectable","on"),f.className=c.q(E.eventBarInner),f.style.left=d+"%",0<h&&h<=1?f.style.width="1px":f.style.width=h+"%",i.barColor&&(f.style.backgroundColor=i.barColor),i.barImageUrl&&(f.style.backgroundImage="url("+i.barImageUrl+")"),u.appendChild(f),o.appendChild(u)}if(i.htmlLeft){var v=c.eventHtmlLeftMargin,g=document.createElement("div");g.style.position="absolute",g.style.right=-(a.left-v)+"px",g.style.top=p+a.top+"px",g.style.height=c.eventHeight+"px",g.style.boxSizing="border-box",g.innerHTML=i.htmlLeft,g.className=c.q("_event_left"),g.type="divLeft",g.versionPart=a,t.related.push(g),c.divEvents.appendChild(g)}if(i.htmlRight){var v=c.eventHtmlRightMargin,m=document.createElement("div");m.style.position="absolute",m.style.left=a.left+a.width+v+"px",m.style.top=p+a.top+"px",m.style.height=c.eventHeight+"px",m.style.boxSizing="border-box",m.innerHTML=i.htmlRight,m.className=c.q("_event_right"),m.type="divRight",m.versionPart=a,t.related.push(m),c.divEvents.appendChild(m)}o.versionPart=a,o.type="version",t.related.push(o),c.divEvents.appendChild(o)}}})}(m),f.htmlLeft){var D=c.eventHtmlLeftMargin,k=document.createElement("div");k.style.position="absolute",k.style.right=-(e.part.left-D)+"px",k.style.top=p+e.part.top+"px",k.style.height=c.eventHeight+"px",k.style.boxSizing="border-box",k.innerHTML=f.htmlLeft,k.className=c.q("_event_left"),k.type="divLeft",m.related.push(k),this.divEvents.appendChild(k)}if(f.htmlRight){var D=c.eventHtmlRightMargin,C=document.createElement("div");C.style.position="absolute",C.style.left=e.part.left+e.part.width+D+"px",C.style.top=p+e.part.top+"px",C.style.height=c.eventHeight+"px",C.style.boxSizing="border-box",C.innerHTML=f.htmlRight,C.className=c.q("_event_right"),C.type="divRight",m.related.push(C),this.divEvents.appendChild(C)}p+e.part.top;m.style.position="absolute",m.style.left=e.part.left+c.eventMarginLeft+"px",m.style.top=p+e.part.top+"px",m.style.width=h-c.eventMarginLeft-c.eventMarginRight+"px",m.style.height=u+"px",c.eventTextWrappingEnabled||(m.style.whiteSpace="nowrap"),m.style.overflow="hidden",m.className=this.q(E.event),"Milestone"===e.data.type&&DayPilot.Util.addClass(m,c.q("_task_milestone")),"Group"===e.data.type&&(DayPilot.Util.addClass(m,c.q("_task_parent")),DayPilot.Util.addClass(m,c.q("_task_group"))),f.cssClass&&DayPilot.Util.addClass(m,f.cssClass);"number"==typeof e.part.line&&DayPilot.Util.addClass(m,this.q(E.eventLine+e.part.line)),m.setAttribute("unselectable","on"),this.showToolTip&&!this.bubble&&(m.title=e.client.toolTip()||""),m.onmousemove=this.Pb,m.onmouseout=this.Qb,m.onmousedown=this.Rb,m.onmouseup=this.Qk,m.ontouchstart=T.onEventTouchStart,m.ontouchmove=T.onEventTouchMove,m.ontouchend=T.onEventTouchEnd,e.client.clickEnabled()&&(m.onclick=this.Oe),e.client.doubleClickEnabled()&&(m.ondblclick=this.Ka),m.oncontextmenu=this.La;var x=document.createElement("div");x.setAttribute("unselectable","on"),x.className=c.q(E.eventInner),x.innerHTML=e.client.innerHTML(),f.backColor&&(x.style.background=f.backColor,(DayPilot.browser.ie9||DayPilot.browser.ielt9)&&(x.style.filter="")),f.fontColor&&(x.style.color=f.fontColor),f.borderColor&&(x.style.borderColor=f.borderColor),f.backImage&&(x.style.backgroundImage="url("+f.backImage+")",f.backRepeat&&(x.style.backgroundRepeat=f.backRepeat)),m.appendChild(x);var P=e.start().getTime()===e.part.start.getTime(),S=e.rawend().getTime()===e.part.end.getTime();if(P||DayPilot.Util.addClass(m,this.q("_event_continueleft")),S||DayPilot.Util.addClass(m,this.q("_event_continueright")),e.client.barVisible()&&h>0){var y=100*e.part.barLeft/h,b=Math.ceil(100*e.part.barWidth/h);"PercentComplete"===this.durationBarMode&&(y=0,b=f.complete||0);var w=document.createElement("div");w.setAttribute("unselectable","on"),w.className=this.q(E.eventBar),w.style.position="absolute",f.barBackColor&&(w.style.backgroundColor=f.barBackColor);var A=document.createElement("div");A.setAttribute("unselectable","on"),A.className=this.q(E.eventBarInner),A.style.left=y+"%",0<b&&b<=1?A.style.width="1px":A.style.width=b+"%",f.barColor&&(A.style.backgroundColor=f.barColor),f.barImageUrl&&(A.style.backgroundImage="url("+f.barImageUrl+")"),w.appendChild(A),m.appendChild(w)}if(m.row=d,f.areas)for(var M=0;M<f.areas.length;M++){var n=f.areas[M],H=n.visibility||n.v||"Visible";if("Visible"===H){(n.start||n.end)&&(n.left=c.getPixels(new DayPilot.Date(n.start)).left-e.part.left,n.width=c.getPixels(new DayPilot.Date(n.end)).left-n.left-e.part.left);var _=DayPilot.Areas.createArea(m,e,n);m.appendChild(_)}}if(this.elements.events.push(m),this.divEvents.appendChild(m),e.rendered=!0,m.event=e,l&&(c.multiselect.add(m.event,!0),c.multiselect.cd(m)),c.sa()){if("function"==typeof c.onAfterEventRender){var R={};R.e=m.event,R.div=m,c.onAfterEventRender(R)}}else c.afterEventRender&&c.afterEventRender(m.event,m);return!0},this.sa=function(){return 2===c.api},this.yh=function(){for(var e=0;e<this.elements.events.length;e++){var t=this.elements.events[e],i=t.event,n=i.part.dayIndex,a=this.rowlist[n],o=a.top,r=o+i.part.top;t.style.top=r+"px",DayPilot.list(t.related).filter(function(e){return!!e.versionPart}).each(function(e){var t=e.versionPart;e.style.top=o+t.top+"px"}),DayPilot.list(t.related).filter(function(e){return!e.versionPart&&("divLeft"===e.type||"divRight"===e.type)}).each(function(e){e.style.top=r+"px"})}},this.bd=function(e){if(!e)return null;for(var t=0;t<c.elements.events.length;t++){var i=c.elements.events[t];if(i.event===e||i.event.data===e.data)return i}return null},this.Qb=function(e){var t=this;DayPilot.Areas.hideAreas(t,e),DayPilot.Util.removeClass(t,c.q("_event_hover")),c.Rk(t),l.source||v.hideLinkpointsWithDelay(),c.bubble&&"Bubble"===c.eventHoverHandling&&c.bubble.hideOnMouseOut()},this.Sk=function(e){if("function"==typeof this.onEventMouseOver){var t={};t.div=e,t.e=e.event,this.onEventMouseOver(t)}},this.Rk=function(e){if("function"==typeof this.onEventMouseOut){var t={};t.div=e,t.e=e.event,this.onEventMouseOut(t)}},this.Pb=function(e){e=e||window.event,c.cellBubble&&c.cellBubble.delayedHide();for(var t=this;t&&!t.event;)t=t.parentNode;c.Tk(t,e);var i=t.event.cache?t.event.cache.deleteDisabled:t.event.data.deleteDisabled;if(!t.active){var n=[];if("Disabled"!==c.eventDeleteHandling&&!i){var a=c.durationBarVisible?c.durationBarHeight:0;n.push({"action":"JavaScript","v":"Hover","w":17,"h":17,"top":a+2,"right":2,"css":c.q(E.eventDelete),"js":function(e){c.Pa(e)}})}var o=t.event.cache?t.event.cache.areas:t.event.data.areas;o&&o.length>0&&(n=n.concat(o)),DayPilot.Areas.showAreas(t,t.event,null,n),DayPilot.Util.addClass(t,c.q("_event_hover")),c.Sk(t)}"Disabled"===c.linkCreateHandling||l.source||(v.clearHideTimeout(),v.hideLinkpoints(),c.Gk()&&v.showLinkpoint(t)),e.srcElement?e.srcElement.insideEvent=!0:e.insideEvent=!0},this.Uk={};var A=this.Uk;this.Qk=function(e){if(c.ionicEventClickFix){var t=A.originalMouse;if(t){var i=DayPilot.mc(e);t.x===i.x&&t.y===i.y&&(c.Oe.call(this,e),e.preventDefault(),e.stopPropagation())}}},this.Rb=function(e){if(c.S(),"undefined"!=typeof DayPilot.Bubble&&DayPilot.Bubble.hideActive(),e=e||window.event,DayPilot.Util.mouseButton(e).left){var t=e.shiftKey;if("Disabled"!==c.multiSelectRectangle&&t)return M.start(),!1;"w-resize"===this.style.cursor||"e-resize"===this.style.cursor?(n.preventEventClick=!0,n.resizing=this,n.resizingEvent=this.event,n.originalMouse=DayPilot.mc(e),document.body.style.cursor=this.style.cursor,v.hideLinkpoints()):("move"===this.style.cursor||"Full"===c.moveBy&&this.event.client.moveEnabled())&&(A.start=!0,A.moving=this,A.movingEvent=this.event,A.originalMouse=DayPilot.mc(e),A.moveOffsetX=DayPilot.mo3(this,e).x,A.moveDragStart=c.getDate(c.coords.x,!0),v.hideLinkpoints())}DayPilot.Menu&&DayPilot.Menu.active&&DayPilot.Menu.active.hide(),e.cancelBubble=!0},this.Sb={};var T=c.Sb;T.active=!1,T.start=!1,T.timeouts=[],T.onEventTouchStart=function(e){if(!T.active&&!T.start){e.stopPropagation(),T.clearTimeouts(),T.start=!0,T.active=!1;var i=this,n=c.tapAndHoldTimeout;T.timeouts.push(window.setTimeout(function(){T.active=!0,T.start=!1,c.coords=T.relativeCoords(e),e.preventDefault();var n=i.event;switch(c.eventTapAndHoldHandling){case"Move":if(n.client.moveEnabled()){var a=t(e);T.startMoving(i,a)}break;case"ContextMenu":DayPilot.Menu&&DayPilot.Menu.touchPosition(e);var o=n.client.contextMenu();o?o.show(n):c.contextMenu&&c.contextMenu.show(n)}},n))}},T.onEventTouchMove=function(e){T.clearTimeouts(),T.start=!1},T.onEventTouchEnd=function(e){if(!DayPilot.Util.isMouseEvent(e)){if(T.clearTimeouts(),T.start){T.start=!1,e.preventDefault(),e.stopPropagation();var t=this;window.setTimeout(function(){c.Ha(t,e)})}window.setTimeout(function(){T.start=!1,T.active=!1},500)}},T.onMainTouchStart=function(e){if(!(T.active||T.start||e.touches.length>1||"Disabled"===c.timeRangeSelectedHandling)){T.clearTimeouts(),T.start=!0,T.active=!1;var t=c.tapAndHoldTimeout;T.timeouts.push(window.setTimeout(function(){T.active=!0,T.start=!1,e.preventDefault(),c.coords=T.relativeCoords(e),T.range=c.Vk()},t));c.coords=T.relativeCoords(e)}},T.onMainTouchMove=function(e){if(T.clearTimeouts(),T.start=!1,n.resizing)return e.preventDefault(),void T.updateResizing();if(T.active){if(e.preventDefault(),c.coords=T.relativeCoords(e),n.moving)return void T.updateMoving();if(T.range){var t=T.range;t.end={x:Math.floor(c.coords.x/c.cellWidth)},c.Fh(t)}}},T.onMainTouchEnd=function(e){T.clearTimeouts();if(T.active){if(n.moving){e.preventDefault();var t=n.movingEvent,i=n.movingShadow.start,a=n.movingShadow.end,o="Days"!==c.viewType?n.movingShadow.row.id:null,r=!!n.drag,s=n.movingShadow.overlapping,l=!n.movingShadow.allowed;if(DayPilot.Util.removeClass(n.moving,c.q(c.Wk.eventMovingSource)),DayPilot.de(n.movingShadow),c.lj(),n.movingShadow.calendar=null,document.body.style.cursor="",n.moving=null,n.movingEvent=null,n.movingShadow=null,c.gj.clear(),s||l||c.gj.forbidden||c.gj.invalid)return;c.Ua(t,i,a,o,r)}if(T.range){var d=T.range;T.range=null;var h=c.elements.range2;h&&h.overlapping?c.clearSelection():c.Ch(d)}}else if(T.start){if(c.coords.x<c.getScrollX())return;var d=c.Vk();c.Fh(d);var h=c.elements.range2;h&&h.overlapping?c.clearSelection():c.Ch(d)}window.setTimeout(function(){T.start=!1,T.active=!1},500)},T.clearTimeouts=function(){for(var e=0;e<T.timeouts.length;e++)clearTimeout(T.timeouts[e]);T.timeouts=[]},T.relativeCoords=function(e){var t=c.pg,i=e.touches[0].pageX,n=e.touches[0].pageY,a=DayPilot.abs(t);return{x:i-a.x,y:n-a.y,toString:function(){return"x: "+this.x+", y:"+this.y}}},T.startMoving=function(e,t){n.moving=e,n.movingEvent=e.event,n.originalMouse=t;var i=DayPilot.abs(e);n.moveOffsetX=t.x-i.x,n.moveDragStart=c.getDate(c.coords.x,!0),n.movingShadow=c.ta(e),c.Ui()},T.startResizing=function(e,t){n.resizing=e,n.resizingEvent=e.event,n.resizing.dpBorder=t,n.resizingShadow||(n.resizingShadow=c.ta(e)),c.hj()},T.updateResizing=function(){if(!n.resizingShadow){var e=n.resizing;n.resizingShadow=c.ta(e)}c.hj()},T.updateMoving=function(){if(n.movingShadow&&n.movingShadow.calendar!==c&&(n.movingShadow.calendar=null,DayPilot.de(n.movingShadow),n.movingShadow=null),!n.movingShadow){var e=n.moving;n.movingShadow=c.ta(e)}c.Ui()},this.Tk=function(e,t){var i=this.eventResizeMargin,a=this.eventMoveMargin,o=e;if("undefined"!=typeof n){var r=DayPilot.mo3(e,t);if(r&&(c.eventOffset=r,!n.resizing&&!n.moving)){var s=o.event.part.start.toString()===o.event.start().toString(),l=o.event.part.end.toString()===o.event.rawend().toString();if("Top"===c.moveBy&&r.y<=a&&o.event.client.moveEnabled()&&"Disabled"!==c.eventMoveHandling?e.style.cursor="move":("Top"===c.moveBy||"Full"===c.moveBy)&&r.x<=i&&o.event.client.resizeEnabled()&&"Disabled"!==c.eventResizeHandling?s?(e.style.cursor="w-resize",e.dpBorder="left"):e.style.cursor="not-allowed":"Left"===c.moveBy&&r.x<=a&&o.event.client.moveEnabled()&&"Disabled"!==c.eventMoveHandling?e.style.cursor="move":e.offsetWidth-r.x<=i&&o.event.client.resizeEnabled()&&"Disabled"!==c.eventResizeHandling?l?(e.style.cursor="e-resize",e.dpBorder="right"):e.style.cursor="not-allowed":n.resizing||n.moving||(o.event.client.clickEnabled()&&"Disabled"!==c.eventClickHandling?e.style.cursor="pointer":e.style.cursor="default"),"undefined"!=typeof DayPilot.Bubble&&c.bubble&&"Bubble"===c.eventHoverHandling&&("default"===e.style.cursor||"pointer"===e.style.cursor)){this.Tc&&r.x===this.Tc.x&&r.y===this.Tc.y;this.Tc=r,c.bubble.showEvent(e.event)}}}},this.Xi=function(){return"Days"!==this.viewType?this.itline.length:Math.floor(1440/this.cellDuration)},this.Dh=function(e){var e=e||n.range||c.rangeHold;if(!e)return null;var t=c.rowlist[e.start.y];if(!t)return null;var i=e.Xk?e.Xk:e,a=t.id,o=i.end.x>i.start.x?i.start.x:i.end.x,r=i.end.x>i.start.x?i.end.x:i.start.x,s=0;s=t.start.getTime()-this.Ba().getTime();var l=this.itline[o].start.addTime(s),d=this.itline[r].end.addTime(s);return new DayPilot.Selection(l,d,a,c)},this.sb=function(e){var t=e.parentNode,i=c.eventEditMinWidth,n=document.createElement("textarea");return n.style.position="absolute",n.style.width=(e.offsetWidth<i?i:e.offsetWidth-2)+"px",n.style.height=e.offsetHeight-2+"px",n.style.fontFamily=DayPilot.gs(e,"fontFamily")||DayPilot.gs(e,"font-family"),n.style.fontSize=DayPilot.gs(e,"fontSize")||DayPilot.gs(e,"font-size"),n.style.left=e.offsetLeft+"px",n.style.top=e.offsetTop+"px",n.style.border="1px solid black",n.style.padding="0px",n.style.marginTop="0px",n.style.backgroundColor="white",n.value=DayPilot.tr(e.event.text()),n.event=e.event,t.appendChild(n),n},this.Yk=function(e){var t=h.events();t.sort(function(e,t){var i=e.event,n=t.event;return i.part.dayIndex!==n.part.dayIndex?i.part.dayIndex-n.part.dayIndex:i.start()!==n.start()?i.start().getTime()-n.start().getTime():n.end().getTime()-i.end().getTime()});var i=t.indexOf(e);return i===-1?null:i+1<t.length?t[i+1]:t[0]},this.Ia=function(e){if(e&&(n.editing&&n.editing.blur(),e.event)){var t=this.sb(e);n.editing=t,DayPilot.re(t,DayPilot.touch.start,function(e){e.stopPropagation()}),t.onblur=function(){if(t.onblur=null,n.editing===t&&(n.editing=null),t.parentNode&&t.parentNode.removeChild(t),e.event){var i=(e.event.text(),t.value);c.bb(e.event,i,t.canceling)}},t.onmousedown=function(e){e=e||window.event,e.stopPropagation&&e.stopPropagation()},t.onkeypress=function(e){return 13!==(window.event?event.keyCode:e.keyCode)||(this.onblur(),!1)},t.cancel=function(){n.editing&&(n.editing.canceling=!0,n.editing.blur())},t.onkeydown=function(t){var i=window.event?event.keyCode:t.keyCode;if(27===i)n.editing.cancel();else if(9===i){var a=c.Yk(e);return n.editing.cancel(),a&&(DayPilot.browser.ie?setTimeout(function(){c.Ia(a)},0):c.Ia(a)),!1}},t.select(),t.focus()}},this.yj=function(e){var t=this,i=t.row;if("undefined"!=typeof DayPilot.Bubble&&(c.cellBubble&&c.cellBubble.hideOnMouseOut(),c.resourceBubble)){var n=c.Jh(i);c.resourceBubble.showResource(n)}},this.zj=function(e){var t=this;"undefined"!=typeof DayPilot.Bubble&&c.resourceBubble&&c.resourceBubble.hideOnMouseOut();var i=t.firstChild;DayPilot.Areas.hideAreas(i,e),i.data=null},this.Aj=function(e){s.row&&(C.cancelClick=!0,setTimeout(function(){C.cancelClick=!1},100))},this.$f=function(){if(this.timeHeader){this.t.timeHeader={};var e=document.createElement("div");e.style.position="relative",this.nav.timeHeader=e;for(var t=0;t<this.timeHeader.length;t++)for(var i=this.timeHeader[t],n=0;n<i.length;n++)this.Zk(n,t);var a=this.divNorth;1===a.childNodes.length?a.replaceChild(e,a.childNodes[0]):(a.innerHTML="",a.appendChild(e));var o=this.Dg();a.style.width=o+5e3+"px",c.divCorner.innerHTML=this.cornerHtml||"",o>0&&(this.divStretch.style.width=o+"px")}},this.Vg=function(e,t){var i=null,n=this.sc.locale(),t=t||this.cellGroupBy,a=e.start;e.end;switch(t){case"Hour":i="Clock12Hours"===c.sc.timeFormat()?a.toString("h tt",n):a.toString("H",n);break;case"Day":i=a.toString(n.datePattern);break;case"Week":i=1===_.weekStarts()?a.weekNumberISO():a.weekNumber();break;case"Month":i=a.toString("MMMM yyyy",n);break;case"Quarter":i="Q"+Math.floor(a.getMonth()/3+1);break;case"Year":i=a.toString("yyyy");break;case"None":i="";break;case"Cell":var o=(e.end.ticks-e.start.ticks)/6e4;i=this.$k(a,o);break;default:throw"Invalid cellGroupBy value"}return i},this.$k=function(e,t){var i=this.sc.locale(),t=t||this.cellDuration;return t<60?e.toString("mm"):t<1440?"Clock12Hours"===c.sc.timeFormat()?e.toString("h tt",i):e.toString("H",i):t<10080?e.toString("d"):10080===t?1===_.weekStarts()?e.weekNumberISO():e.weekNumber():e.toString("MMMM yyyy",i)},this.Rg=function(e){var t=this.scale;switch(t){case"Cell":throw"Invalid scale: Cell";case"Manual":throw"Internal error (addScaleSize in Manual mode)";case"Minute":return e.addMinutes(1);case"CellDuration":return e.addMinutes(this.cellDuration);default:return this.Ug(e,t)}},this.Ug=function(e,t){var i,n="Days"!==this.viewType?this.days:1,a=this.startDate.addDays(n);"Manual"===c.scale&&(a=c.Tg());var t=t||this.cellGroupBy,o=60;switch(t){case"Hour":e.getHours()+e.getMinutes()+e.getSeconds()+e.getMilliseconds()>0&&(e=e.getDatePart().addHours(e.getHours())),i=e.addHours(1);break;case"Day":i=e.getDatePart().addDays(1);break;case"Week":for(i=e.getDatePart().addDays(1);i.dayOfWeek()!==_.weekStarts();)i=i.addDays(1);break;case"Month":i=e.addMonths(1),i=i.firstDayOfMonth();for(var r=DayPilot.DateUtil.diff(i,e)/6e4%o===0;!r;)i=i.addHours(1),r=DayPilot.DateUtil.diff(i,e)/6e4%o===0;break;case"Quarter":for(i=e.addMonths(1),i=i.firstDayOfMonth();i.getMonth()%3;)i=i.addMonths(1);for(var r=DayPilot.DateUtil.diff(i,e)/6e4%o===0;!r;)i=i.addHours(1),r=DayPilot.DateUtil.diff(i,e)/6e4%o===0;break;case"Year":i=e.addYears(1),i=i.firstDayOfYear();for(var r=DayPilot.DateUtil.diff(i,e)/6e4%o===0;!r;)i=i.addHours(1),r=DayPilot.DateUtil.diff(i,e)/6e4%o===0;break;case"None":i=a;break;case"Cell":var s=this.Zg(e);i=s.current?s.current.end:s.past?s.previous.end:s.next.start;break;default:throw"Invalid cellGroupBy value"}return i.getTime()>a.getTime()&&(i=a),i},this.Wk={},this.Wk.timeheadercol="_timeheadercol",this.Wk.timeheadercolInner="_timeheadercol_inner",this.Wk.resourcedivider="_resourcedivider",this.Wk.eventFloat="_event_float",this.Wk.eventFloatInner="_event_float_inner",this.Wk.event="_event",this.Wk.eventInner="_event_inner",this.Wk.eventBar="_event_bar",this.Wk.eventBarInner="_event_bar_inner",this.Wk.eventDelete="_event_delete",this.Wk.eventLine="_event_line",this.Wk.eventMovingSource="_event_moving_source";var E=this.Wk;this.Zk=function(e,t){var i=this.nav.timeHeader,n=this.timeHeader[t][e],a=t<this.timeHeader.length-1,o=n.left,r=n.width,s=R.timeHeader(t),l=s.top,d=s.height,h=document.createElement("div");h.style.position="absolute",h.style.top=l+"px",h.style.left=o+"px",h.style.width=r+"px",h.style.height=d+"px",n.toolTip&&(h.title=n.toolTip),n.cssClass&&DayPilot.Util.addClass(h,n.cssClass),h.setAttribute("unselectable","on"),h.style.KhtmlUserSelect="none",h.style.MozUserSelect="none",h.style.webkitUserSelect="none",h.oncontextmenu=function(){return!1},h.cell={},h.cell.start=n.start,h.cell.end=n.end,h.cell.level=t,h.cell.th=n,h.onclick=this.Fj,h.style.overflow="hidden",c.timeHeaderTextWrappingEnabled||(h.style.whiteSpace="nowrap");var u=document.createElement("div");u.setAttribute("unselectable","on"),n.innerHTML&&(u.innerHTML=n.innerHTML),n.backColor&&(u.style.background=n.backColor),n.fontColor&&(u.style.color=n.fontColor);var f=this.q(E.timeheadercol),v=this.q(E.timeheadercolInner);a&&(f=this.q("_timeheadergroup"),v=this.q("_timeheadergroup_inner")),DayPilot.Util.addClass(h,f),DayPilot.Util.addClass(u,v),DayPilot.Util.addClass(h,c.q("_timeheader_cell")),DayPilot.Util.addClass(u,c.q("_timeheader_cell_inner")),DayPilot.list(n.areas).each(function(e){e.start&&(e.left=c.getPixels(new DayPilot.Date(e.start)).left-o,e.end&&(e.width=c.getPixels(new DayPilot.Date(e.end)).left-e.left-o))}),h.appendChild(u),DayPilot.Areas.attach(h,n,{"areas":n.areas}),this.t.timeHeader[e+"_"+t]=h,i.appendChild(h)},this.fh=function(){if(c.cellStacking)return void S.calculateEventPositions();for(var e=0;e<this.rowlist.length;e++){var t=this.rowlist[e],i=t.getHeight()+t.marginBottom+t.marginTop;t.height!==i&&(this.vh=!0),t.height=i}},this.bg=function(){var e=this.divHeader;if(!e)return!1;for(var t=this.rowlist.length,i=(this.rowHeaderCols?this.rowHeaderCols.length:1,0),n=0;n<t;n++){var a=this.rowlist[n];if(!a.hidden){var o=this.tj?n:i;if(e.rows[o]){for(var r=0;r<e.rows[o].cells.length;r++){var s=e.rows[o].cells[r];this.tj&&(s.style.top=a.top+"px");var l=a.height;s&&s.firstChild&&parseInt(s.firstChild.style.height,10)!==l&&(s.firstChild.style.height=l+"px")}i++}}}this.tj&&c.nav.resScrollSpace&&(c.nav.resScrollSpace.style.top=c.Tf+"px")},this.Xc=function(e){var t=this.separators[e];t.location=t.location||t.Location,t.color=t.color||t.Color,t.layer=t.layer||t.Layer,t.width=t.width||t.Width,t.opacity=t.opacity||t.Opacity;var i=new DayPilot.Date(t.location),n=t.color,a=t.width?t.width:1,o=!!t.layer&&"AboveEvents"===t.layer,r=t.opacity?t.opacity:100;if(!(i.getTime()<this.Ba().getTime()||i.getTime()>=this.Tg().getTime())){var s=this.getPixels(i);if(!s.cut&&!(s.left<0||s.left>this.Xi()*this.cellWidth)){var l=document.createElement("div");l.style.width=a+"px",l.style.height=c.Tf+"px",l.style.position="absolute",l.style.left=s.left-1+"px",l.style.top="0px",l.style.backgroundColor=n,l.style.opacity=r/100,l.style.filter="alpha(opacity="+r+")",o?this.divSeparatorsAbove.appendChild(l):this.divSeparators.appendChild(l),this.elements.separators.push(l)}}},this.Ek=function(e){if("Disabled"===c.timeRangeDoubleClickHandling)return!1;n.timeRangeTimeout&&(clearTimeout(n.timeRangeTimeout),n.timeRangeTimeout=null);if(!c.coords){var t=c.pg;c.coords=DayPilot.mo3(t,e)}if(e=e||window.event,e.stopPropagation&&e.stopPropagation(),e.cancelBubble=!0,c._k(c.coords)){var i=c.Dh(c.rangeHold);c.ab(i.start,i.end,i.resource)}else if(n.range=c.Vk(),n.range){n.rangeCalendar=c;var i=c.Dh(n.range);c.ab(i.start,i.end,i.resource),c.rangeHold=n.range}},this.Bk=function(e){if(!T.start&&!T.active){if(n.timeRangeTimeout,1,c.al(),c.zk(),!c.coords){var t=c.pg;c.coords=DayPilot.mo3(t,e)}if(n.rectangleSelect)return!1;e=e||window.event;var i=DayPilot.Util.mouseButton(e);if(i.middle||i.right&&c._k(c.coords))return!1;if(c._k(c.coords))return!1;var a=e.ctrlKey,o=e.metaKey,r=e.shiftKey,s=a||o,l={};if(l.action="None","Disabled"!==c.multiSelectRectangle&&r?l.action="RectangleSelect":"Disabled"!==c.timeRangeSelectedHandling&&(l.action="TimeRangeSelect"),l.shift=r,l.ctrl=r,l.meta=o,l.originalEvent=e,l.preventDefault=function(){l.action="None"},"function"==typeof c.onGridMouseDown&&c.onGridMouseDown(l),"None"===l.action)return e.preventDefault(),e.stopPropagation(),!1;if("RectangleSelect"===l.action){var d={};return d.start=c.coords,d.calendar=c,n.rectangleSelect=d,!1}c.allowMultiRange&&!s&&H.clear();var h=c.bi(c.coords.y).i;return!c.rowlist[h].isNewRow&&(n.range=c.Vk(),n.range&&(n.range.ctrl=s,n.rangeCalendar=c),!1)}},this.Vk=function(){var e={},t=this.Xg(c.coords.x).x;return e.start={y:c.bi(c.coords.y).i,x:t},e.end={x:t},this.hi(c.bi(c.coords.y).i)?null:(e.calendar=c,c.Fh(e),e)},this.ij=function(){c.Dc();var e=n.resizingShadow,t=n.resizing;!function(){var i=c.bl,a={"start":e.start,"end":c.df(e.end)};e.original=a;var o=e.original;if(!o||!i||i.start!==o.start||i.end!==c.df(o.end)){var r={};r.start=a.start,r.end=a.end,r.duration=new DayPilot.Duration(r.start,r.end),r.e=t.event,r.allowed=!0,r.resizing="left"===n.resizing.dpBorder?"start":"end",r.left={},r.left.html=r.start.toString(c.eventResizingStartEndFormat,_.locale()),r.left.enabled=c.eventResizingStartEndEnabled,r.left.space=5,r.left.width=null,r.right={},r.right.html=r.end.toString(c.eventResizingStartEndFormat,_.locale()),r.right.enabled=c.eventResizingStartEndEnabled,r.right.space=5,r.right.width=null,r.multiresize=DayPilot.list(b.list);var s={};s.event=t,s.start=r.start,s.end=r.end,r.multiresize.splice(0,0,s),c.bl=a,"function"==typeof c.onEventResizing&&c.onEventResizing(r),e.allowed=r.allowed;var l=r.start,d=c.Ee(r.end);e.finalStart=l,e.finalEnd=d;var h=DayPilot.DateUtil.diff(l,d);h=Math.max(h,1);var u=_.useBox(h),f=u?c.getPixels(l).boxLeft:c.getPixels(l).left,v=u?c.getPixels(d).boxRight:c.getPixels(d).left;e.style.left=f+"px",e.style.width=v-f+"px",e.left=f,e.width=v-f,c.jj(n.resizingShadow,r),c.kj(n.resizingShadow,r)}}()},this.Ck=function(e){if(n.rectangleSelect){var e=e||window.event;return e.cancelBubble=!0,e.preventDefault&&e.preventDefault(),n.gMouseUp(e),!1}if(A={},c.rangeHold){if(DayPilot.Util.mouseButton(e).left){var t=c.rangeHold;if(c._k(c.coords)){var i=function(e){return function(){n.timeRangeTimeout=null;var t=c.Dh(e);if(t){var i={};i.start=t.start,i.end=t.end,i.resource=t.resource,i.preventDefault=function(){i.preventDefault.value=!0},"function"==typeof c.onTimeRangeClick&&c.onTimeRangeClick(i),i.preventDefault.value||"function"==typeof c.onTimeRangeClicked&&c.onTimeRangeClicked(i)}}};"Disabled"!=c.timeRangeClickHandling&&("Disabled"===c.timeRangeDoubleClickHandling?i(t)():(clearTimeout(n.timeRangeTimeout),n.timeRangeTimeout=setTimeout(i(t),c.doubleClickTimeout)))}}}},this.cl=function(){return n.resizing||n.moving||n.range},this.mj=function(e){if(!T.active){n.activeCalendar=c,e=e||window.event;var t=DayPilot.mc(e);if(c.coords=DayPilot.mo3(c.pg,e),e.insideMainD=!0,window.event&&window.event.srcElement&&(window.event.srcElement.inside=!0),A.start){DayPilot.distance(A.originalMouse,t)>3&&(DayPilot.Util.copyProps(A,n),document.body.style.cursor="move",A={})}if(n.resizing&&n.resizingEvent.calendar===c)n.resizing.event||(n.resizing.event=n.resizingEvent),c.dl();else if(n.movingEvent&&(n.movingEvent.calendar===c||n.movingEvent.calendar.dragOutAllowed))c.fl();else if(n.range&&n.range.calendar===c)n.range.moved=!0,c.gl();else if(l.source){var i=l.source;v.drawShadow(i.coords,c.coords)}else n.rectangleSelect&&(n.rectangleSelect.moved=!0,M.draw());"Disabled"!==c.crosshairType&&c.hl(),c.il();var a=e.insideEvent;if(window.event&&window.event.srcElement&&(a=window.event.srcElement.insideEvent),c.cellBubble&&c.coords&&c.rowlist&&c.rowlist.length>0&&!a){var o=c.Xg(c.coords.x).x,r=c.bi(c.coords.y).i;if(0<=r&&r<c.rowlist.length&&0<=o&&o<c.itline.length){var s={};s.calendar=c,s.start=c.itline[o].start,s.end=c.itline[o].end,s.resource=c.rowlist[r].id,s.toJSON=function(){var e={};return e.start=this.start,e.end=this.end,e.resource=this.resource,e},c.cellBubble.showCell(s)}}if(n.drag){if(c.al(),n.gShadow&&document.body.removeChild(n.gShadow),n.gShadow=null,!n.movingShadow&&c.coords&&c.rowlist.length>0){if(!n.movingEvent){n.moving=n.drag.schedulerSourceEvent||{};var h=n.drag.event;if(h){if(c!==h.calendar){var f=h.calendar,p=h,g=DayPilot.Util.copyProps(h.data);h=new DayPilot.Event(g),h.calendar=f,h.part.duration=f.Li(p)}}else{var m=c.itline[0].start,e={"id":n.drag.id,"start":m,"end":m.addSeconds(n.drag.duration),"text":n.drag.text},y=n.drag.data;if(y){var b=["duration","element","id","text"];for(var w in y)DayPilot.contains(b,w)||(e[w]=y[w])}h=new DayPilot.Event(e),h.calendar=c,h.part.duration=n.drag.duration}h.part.external=!0;var i=n.drag.schedulerSourceEvent;i&&i.event&&i.event.calendar===c&&(h.part.external=!1),n.movingEvent=h}n.movingShadow=c.ta(n.movingEvent)}e.cancelBubble=!0}if("Always"===c.autoScroll||"Drag"===c.autoScroll&&(n.moving||n.resizing||n.range)){var D=c.nav.scroll,k={x:c.coords.x,y:c.coords.y};k.x-=D.scrollLeft,k.x+=u.shiftX,k.y-=D.scrollTop;var C=D.clientWidth,x=D.clientHeight,P=30,S=k.x<P?k.x:0,E=C-k.x<P?C-k.x:0,H=k.y<P?k.y:0,_=x-k.y<P?x-k.y:0,o=0,r=0,R=50;S&&(o=-50*d(S,P)),E&&(o=R*d(E,P)),H&&(r=-50*d(H,P)/2),_&&(r=R*d(H,P)/2),(n.resizing||n.range)&&(r=0),o||r?c.jl(o,r):c.zk()}}},this.gl=function(){var e=n.range;e.end={x:c.Xg(c.coords.x).x},c.Fh(e)},this.dl=function(){n.resizingShadow||(n.resizingShadow=c.ta(n.resizing)),c.hj()},this.fl=function(){if(n.movingShadow&&n.movingShadow.calendar!==c&&(n.movingShadow.calendar=null,DayPilot.de(n.movingShadow),n.movingShadow=null),!n.movingShadow){var e=n.movingEvent;n.movingShadow=c.ta(e)}c.Si(),c.Ui()},this.kl={};var M=this.kl;M.start=function(){var e={};e.start=c.coords,e.calendar=c,n.rectangleSelect=e},M.draw=function(){var e=n.rectangleSelect,t=n.rectangleSelect.start,i=c.coords;M.clear();var a,o,r,s,l,d,u,f,v={"x":e.x,"y":e.y,"width":e.width,"height":e.height};if(function(){l=Math.min(t.x,i.x),u=Math.max(t.x,i.x),"Free"===c.multiSelectRectangle?(d=Math.min(t.y,i.y),f=Math.max(t.y,i.y)):"Row"===c.multiSelectRectangle&&(d=t.y,f=t.y)}(),"Free"===c.multiSelectRectangle)a=l,o=d,r=u-l,s=f-d;else{if("Row"!==c.multiSelectRectangle)throw"Invalid DayPilot.Scheduler.multiSelectRectangle value: "+c.multiSelectRectangle;
var p=c.bi(d).i,g=c.rowlist[p];o=g.top,s=g.height;a=c.Xg(l).cell.left;var m=c.Xg(u).cell;r=m.left+m.width-a}var y=DayPilot.Util.div(c.divRectangle,a,o,r,s);if(y.style.boxSizing="border-box",y.style.backgroundColor="#0000ff",y.style.border="1px solid #000033",y.style.opacity=.4,e.x=a,e.y=o,e.width=r,e.height=s,(e.x!==v.x||e.y!==v.y||e.width!==v.width||e.height!==v.height)&&"function"==typeof c.onRectangleEventSelecting){var b={};b.events=h.eventsInRectangle(e.x,e.y,e.width,e.height).map(function(e){return e.event}),b.start=c.getDate(e.x,!0),b.end=c.getDate(e.x+e.width,!0),c.onRectangleEventSelecting(b)}},M.clear=function(){c.divRectangle.innerHTML="",c.elements.rectangle=[]},this.ll=function(){var e,t;if(!(c.coords&&c.rowlist&&c.rowlist.length>0&&c.itline&&c.itline.length>0))return null;if(e=c.Xg(c.coords.x).x,t=c.bi(c.coords.y).i,!(t>=c.rowlist.length)){return c.cells.findXy(e,t)[0]}},this.il=function(){var e=this.ll();if(this.hover.cell){if(this.hover.cell.x===e.x&&this.hover.cell.y===e.y)return;this.Ak()}if(this.hover.cell=e,"function"==typeof this.onCellMouseOver){var t={};t.cell=e,this.onCellMouseOver(t)}},this.Ak=function(){if(this.hover.cell){if("function"==typeof this.onCellMouseOut){var e={};e.cell=this.hover.cell,this.onCellMouseOut(e)}this.hover.cell=null}},this.hover={},this.hl=function(){var e=this.ll();this.hover.cell&&this.hover.cell.x===e.x&&this.hover.cell.y===e.y||this.Cc()},this.al=function(){this.divCrosshair.innerHTML="",this.ml=null,this.nl=null},this.T=function(){if(this.al(),this.ol&&this.ol.parentNode&&(this.ol.parentNode.removeChild(this.ol),this.ol=null),this.pl){for(var e=0;e<this.pl.length;e++){var t=this.pl[e];t.parentNode&&t.parentNode.removeChild(t)}this.pl=null}this.Sf=-1,this.Rf=-1},this.Cc=function(){var e,t;if(c.coords&&c.rowlist&&c.rowlist.length>0&&(e=c.Xg(c.coords.x).x,t=c.bi(c.coords.y).i,!(t>=c.rowlist.length))){var i=this.crosshairType,n=c.rowlist[t];if("Full"===i){var a=this.itline[e],o=a.left,r=this.ml;if(!r){var r=document.createElement("div");r.style.height=c.Tf+"px",r.style.position="absolute",r.style.top="0px",r.className=c.q("_crosshair_vertical"),this.ml=r,this.divCrosshair.appendChild(r)}r.style.left=o+"px",r.style.width=a.width+"px";var s=n.top,l=n.height,d=this.Dg(),r=this.nl;if(!r){var r=document.createElement("div");r.style.width=d+"px",r.style.height=l+"px",r.style.position="absolute",r.style.top=s+"px",r.style.left="0px",r.className=c.q("_crosshair_horizontal"),this.nl=r,this.divCrosshair.appendChild(r)}r.style.top=s+"px",r.style.height=l+"px"}var h=this.ql(this.coords.x);if(h&&this.Sf!==h.x){this.ol&&this.ol.parentNode&&(this.ol.parentNode.removeChild(this.ol),this.ol=null);var l=R.timeHeader(c.timeHeaders.length-1).height,r=document.createElement("div");r.style.width=h.cell.width+"px",r.style.height=l+"px",r.style.left="0px",r.style.top="0px",r.style.position="absolute",r.className=c.q("_crosshair_top"),this.ol=r;var u=this.divNorth,f=this.timeHeader?this.timeHeader.length-1:1;this.nav.timeHeader?this.t.timeHeader[h.x+"_"+f].appendChild(r):u.firstChild.rows[f].cells[e]&&u.firstChild.rows[f].cells[e].firstChild.appendChild(r)}if(this.Rf!==t){if(this.pl){for(var v=0;v<this.pl.length;v++){var p=this.pl[v];p.parentNode&&p.parentNode.removeChild(p)}this.pl=null}this.rowHeaderCols?this.rowHeaderCols.length:1;if(this.pl=[],this.divHeader.rows[t])for(var v=0;v<this.divHeader.rows[t].cells.length;v++){var d=c.Gg(),r=document.createElement("div");r.style.width=d+"px",r.style.height=n.height+"px",r.style.left="0px",r.style.top="0px",r.style.position="absolute",r.className=c.q("_crosshair_left"),this.pl.push(r),this.divHeader.rows[t].cells[v].firstChild.appendChild(r)}}h&&(this.Sf=h.x),this.Rf=t}},this.$i=function(e,t){var i=c.timeHeader[e];if(!i)return null;for(var n=0;n<i.length;n++){var a=i[n];if(t>=a.left&&t<a.left+a.width){var o={};return o.cell=a,o.x=n,o}}return null},this.ql=function(e){return c.$i(c.timeHeader.length-1,e)},this.Dk=function(e){if(e=e||window.event,"Disabled"===c.timeRangeSelectedHandling)return!1;if("Disabled"===c.timeRangeRightClickHandling)return!1;var t=null;if(t=c._k(c.coords)?c.Dh(c.rangeHold):c.Dh()){t.end=c.df(t.end);var i={};return i.start=t.start,i.end=t.end,i.resource=t.resource,i.preventDefault=function(){this.preventDefault.value=!0},("function"!=typeof c.onTimeRangeRightClick||(c.onTimeRangeRightClick(i),!i.preventDefault.value))&&("ContextMenu"===c.timeRangeRightClickHandling&&c.contextMenuSelection&&c.contextMenuSelection.show(t),"function"==typeof c.onTimeRangeRightClicked&&c.onTimeRangeRightClicked(i),e.cancelBubble=!0,!!c.allowDefaultContextMenu&&void 0)}},this._k=function(e){var t=c.rangeHold;if(!t||!t.start||!t.end)return!1;var i=this.mi(t.start.y),n=t.start.x<t.end.x,a=(n?t.start.x:t.end.x)*this.cellWidth,o=(n?t.end.x:t.start.x)*this.cellWidth+this.cellWidth,r=i.top,s=i.bottom;return e.x>=a&&e.x<=o&&e.y>=r&&e.y<=s},this.Fh=function(e,t){function i(e){var t=e.end.x>e.start.x?e.start.x:e.end.x,i=e.end.x>e.start.x?e.end.x:e.start.x,n=e.start.y,a=(c.rowlist[n],c.itline[t]),o=c.itline[i],r=a.left,s=o.left+o.width,l=s-r,d=c.elements.range2;if(!d){d=document.createElement("div"),d.style.position="absolute",d.setAttribute("unselectable","on"),d.className=c.q("_shadow");var h=document.createElement("div");h.className=c.q("_shadow_inner"),d.appendChild(h),c.divRange.appendChild(d)}return d.style.left=a.left+"px",d.style.top=c.rowlist[n].top+"px",d.style.width=l+"px",d.style.height=c.rowlist[n].height-1+"px",c.elements.range2=d,function(){var e=c.rowlist[n],t=a.left;c.ej(d,e,t,l,null)}(),d}var e=e||n.range;e&&e.calendar===c&&!function(){var n=e.end.x>e.start.x?e.start.x:e.end.x,a=e.end.x>e.start.x?e.end.x:e.start.x,o=e.start.y,r=c.rowlist[o];if(r){var s=c.itline[n],l=c.itline[a],d=c.rl,h=s.start.addTime(r.data.offset),u=l.end.addTime(r.data.offset);if(t||!d||d.start.getTime()!==h.getTime()||d.end.getTime()!==u.getTime()||d.resource!==c.rowlist[o].id){var f={"start":h,"end":c.df(u)},v={};v.start=f.start,v.end=f.end,v.duration=new DayPilot.Duration(f.start,f.end),v.resource=c.rowlist[o].id,v.allowed=!0,v.left={},v.left.html=v.start.toString(c.timeRangeSelectingStartEndFormat,_.locale()),v.left.enabled=c.timeRangeSelectingStartEndEnabled,v.left.space=5,v.left.width=null,v.right={},v.right.html=v.end.toString(c.timeRangeSelectingStartEndFormat,_.locale()),v.right.enabled=c.timeRangeSelectingStartEndEnabled,v.right.space=5,v.right.width=null,c.rl=v,"function"!=typeof c.onTimeRangeSelecting||t||c.onTimeRangeSelecting(v);var p=c.sl(e);c.Eh(p,v.start,v.end);var g=i(p);c.jj(g,v),e.Xk=p,e.disabled=!v.allowed,c.kj(g,v),v.start=f.start,v.end=f.end}}}()},this.sl=function(e){return{"start":{"x":e.start.x,"y":e.start.y},"end":{"x":e.end.x},"disabled":e.disabled,"calendar":e.calendar}},this.range={},this.range.all=function(){return H.get()},this.ul={};var H=this.ul;this.ul.list=[],this.ul.clear=function(){DayPilot.de(DayPilot.list(H.list).map(function(e){return e.div})),H.list=[]},this.ul.add=function(e){e.div=c.elements.range2,c.elements.range2=null,c.lj(),H.list.push(e)},this.ul.get=function(){return DayPilot.list(H.list).map(function(e){return c.Dh(e)})},this.ul.dispatch=function(){if(c.allowMultiRange&&!n.range){var e=DayPilot.list(H.list).last();c.Ch(e)}},this.vl=function(e){if("Disabled"===c.timeRangeSelectedHandling)return!1;if(!T.active&&!T.start){e=e||window.event;var t=DayPilot.Util.mouseButton(e);if(!n.range&&!n.rectangleSelect&&!(c.rangeHold&&c._k(c.coords)&&(t.right||t.middle)||c.hi(c.bi(c.coords.y).i))){var i={},a=c.Xg(c.coords.x).x;i.start={y:c.bi(c.coords.y).i,x:a},i.end={x:a},i.calendar=c,c.rangeHold=i,c.Ch(i)}}},this.timeouts={},this.timeouts.drawEvents=null,this.timeouts.drawCells=null,this.timeouts.click=null,this.timeouts.resClick=[],this.timeouts.updateFloats=null,this.disableOnScroll=!1,this.lg=function(e){if(!c.disableOnScroll){if(c.Vf(),u.isEnabled()&&!u.active&&c.A&&"Auto"!=c.cellWidthSpec&&(c.nav.scroll.scrollLeft<c.Of?(u.active=!0,setTimeout(function(){u.shiftStart(-c.Pf)},100)):c.nav.scroll.scrollWidth-(c.nav.scroll.scrollLeft+c.nav.scroll.clientWidth)<c.Of&&(u.active=!0,setTimeout(function(){u.shiftStart(c.Pf)},100))),c.navigatorBackSync&&!function(){var e=DayPilot.Util.evalVariable(c.navigatorBackSync),t=c.getViewPort().start;e.select(t,{"dontNotify":!0,"dontFocus":!0})}(),c.dynamicLoading)return c.vf(),void c.wl();var t=c.nav.scroll;if(c.Yi=t.scrollLeft,c.Wi=t.scrollTop,c.Zi=t.clientWidth,c.divTimeScroll.scrollLeft=c.Yi,c.divResScroll.scrollTop=c.Wi,c.timeouts.drawEvents&&(clearTimeout(c.timeouts.drawEvents),c.timeouts.drawEvents=null),c.scrollDelayEvents>0?c.timeouts.drawEvents=setTimeout(c.xl(),c.scrollDelayEvents):c.oa(),c.timeouts.drawCells&&(clearTimeout(c.timeouts.drawCells),c.timeouts.drawCells=null),c.scrollDelayCells>0)c.timeouts.drawCells=setTimeout(c.yl(),c.scrollDelayCells);else{c.yl()()}c.timeouts.updateFloats&&(clearTimeout(c.timeouts.updateFloats),c.timeouts.updateFloats=null),c.scrollDelayFloats>0?c.timeouts.updateFloats=setTimeout(function(){c.jg()},c.scrollDelayFloats):c.jg(),c.onScrollCalled=!0}},this.yl=function(){return function(){c&&(c.vf(),c.fg())}},this.xl=function(){var e=c.dynamicEventRenderingCacheSweeping,t=c.dynamicEventRenderingCacheSize;return function(){c&&(c.Nk()?window.setTimeout(function(){e&&c.Kk(t),window.setTimeout(function(){c.oa(!0)},50)},50):c.xg())}},this.Vf=function(){this.t.eventHeight=null,this.t.drawArea=null},this.show=function(){this.visible=!0,this.Qf=!0,c.nav.top.style.display="",this.na(),this.ag(),this.xi(),c.lg()},this.hide=function(){this.visible=!1,this.Qf=!1,c.nav.top.style.display="none"},this.zl=function(){},this.wl=function(){var e=c.nav.scroll;c.Yi=e.scrollLeft,c.Wi=e.scrollTop,c.Zi=e.clientWidth,c.divTimeScroll.scrollLeft=c.Yi,c.divResScroll.scrollTop=c.Wi,c.refreshTimeout&&window.clearTimeout(c.refreshTimeout);var t=c.scrollDelayDynamic;c.refreshTimeout=window.setTimeout(c.Al(e.scrollLeft,e.scrollTop),t),c.jg()},this.Bl=function(e){if(!c.events.list)return null;for(var t=e.id,i=new DayPilot.Date(e.start).toString(),n=0;n<this.events.list.length;n++){var a=this.events.list[n];if(a.id===t){if(DayPilot.Util.isNullOrUndefined(t)&&!DayPilot.Util.isNullOrUndefined(e.recurrentMasterId)){var o=new DayPilot.Date(a.start).toString();if(a.recurrentMasterId!==e.recurrentMasterId||i!==o)continue}var r={};return r.ex=a,r.index=n,r.modified=!c.Cl(e,a),r}}return null},this.Cl=function(e,t){for(var i in e)if(("object"!=typeof e[i]||e[i]instanceof DayPilot.Date)&&e[i]!==t[i])return!1;for(var i in t)if("object"!=typeof t[i]&&e[i]!==t[i])return!1;return!0},this.hg=function(e,t){for(var i=[],n=0;n<e.length;n++){var a=e[n],o=c.Bl(a),r=o&&o.modified,s=!o;if(r){this.events.list[o.index]=a;var l=c.events.ch(o.ex);i=i.concat(l)}else s&&this.events.list.push(a);(r||s)&&(i=i.concat(c.events.dh(a)))}c.eh(i),c.fh(),c._f(),c.ja();c.M(),c.cg(),c.bg(),c.fg(),c.oa()},this.Al=function(e,t){return c.r()?function(){c.scrollX=e,c.scrollY=t,c.G("Scroll")}:function(){if("function"==typeof c.onScroll){var e=function(e){var t=function(){if(c.sa()&&"function"==typeof c.onAfterRender){var e={};e.isCallBack=!1,e.isScroll=!0,e.data=null,c.onAfterRender(e)}};c.hg(e,t)},t={};t.viewport=c.getViewPort(),t.async=!1,t.events=[],t.loaded=function(){this.async&&e(this.events)},c.onScroll(t),t.async||e(t.events)}}},this.Dl=function(){var e=this.ug(),t=e.xStart,i=e.xEnd-e.xStart,n=e.yStart,a=e.yEnd-e.yStart;this.cellProperties||(this.cellProperties={});for(var o=0;o<=i;o++){for(var r=t+o,s=0;s<a;s++){var l=n+s;this.rowlist[l].hidden||this.$e(r,l)}this.El(r)}for(var d=this.pj(),l=d.start;l<d.end;l++)this.rowlist[l].hidden||this.Fl(l)},this.fg=function(){if(!c.Cd){if(c.progressiveRowRendering&&this.lh(),null!==this.rowlist&&this.rowlist.length>0){if(this.cellSweeping){var e=this.cellSweepingCacheSize;this.Mk(e)}this.Dl(),this.Gl(),C.Mj()}this.vh=!1}},this.Gl=function(){for(var e=this.ug(),t=e.xStart;t<e.xEnd;t++){t<this.itline.length-1&&this.itline[t+1].breakBefore&&this.Hl(t)}},this.Hl=function(e){var t="x"+e;if(!this.t.breaks[t]){var i=this.itline[e+1].left-1,n=this.Tf,a=document.createElement("div");a.style.left=i+"px",a.style.top="0px",a.style.width="1px",a.style.height=n+"px",a.style.fontSize="1px",a.style.lineHeight="1px",a.style.overflow="hidden",a.style.position="absolute",a.setAttribute("unselectable","on"),a.className=this.q("_matrix_vertical_break"),this.divBreaks.appendChild(a),this.elements.breaks.push(a),this.t.breaks[t]=a}},this.ug=function(){if(c.t.drawArea)return c.t.drawArea;if(!this.nav.scroll)return null;var e=c.Wi,t={},i=this.dynamicEventRenderingMargin,i=null!=this.dynamicEventRenderingMarginX?this.dynamicEventRenderingMarginX:this.dynamicEventRenderingMargin,n=null!=this.dynamicEventRenderingMarginY?this.dynamicEventRenderingMarginY:this.dynamicEventRenderingMargin,a=c.Yi-i-u.shiftX,o=a+c.Zi+2*i,r=0,s=0;if(c.itline&&c.itline.length>0){r=c.Xg(a).x,s=c.Xg(o,!0).x;var l=this.Xi();s=Math.min(s,l),r=Math.max(r,0)}var d=e-n,h=e+this.nav.scroll.offsetHeight+2*n,f=this.bi(d).i,v=this.bi(h).i;return v<this.rowlist.length&&v++,t.xStart=r,t.xEnd=s,t.yStart=f,t.yEnd=v,t.pixels={},t.pixels.left=this.nav.scroll.scrollLeft-u.shiftX,t.pixels.right=this.nav.scroll.scrollLeft-u.shiftX+this.nav.scroll.clientWidth,t.pixels.top=this.nav.scroll.scrollTop,t.pixels.bottom=this.nav.scroll.scrollTop+this.nav.scroll.clientHeight,t.pixels.width=this.nav.scroll.scrollWidth,c.t.drawArea=t,t},this.Dg=function(){var e=0,t=this.itline[this.itline.length-1];return e=t?t.left+t.width:0,(e<0||isNaN(e))&&(e=0),e},this.Fl=function(e){var t="y"+e;if(!this.t.linesHorizontal[t]){var i=this.rowlist[e].top+this.rowlist[e].height-1,n=this.Dg(),a=document.createElement("div");a.style.left="0px",a.style.top=i+"px",a.style.width=n+"px",a.style.height="1px",a.style.fontSize="1px",a.style.lineHeight="1px",a.style.overflow="hidden",a.style.position="absolute",a.setAttribute("unselectable","on"),a.className=this.q("_matrix_horizontal_line"),this.divLines.appendChild(a),this.t.linesHorizontal[t]=a}},this.El=function(e){var t=this.itline[e];if(t){var i="x"+e;if(!this.t.linesVertical[i]){var n=t.left+t.width-1,a=document.createElement("div");a.style.left=n+"px",a.style.top="0px",a.style.width="1px",a.style.height=c.Tf+"px",a.style.fontSize="1px",a.style.lineHeight="1px",a.style.overflow="hidden",a.style.position="absolute",a.setAttribute("unselectable","on"),a.className=this.q("_matrix_vertical_line"),this.divLines.appendChild(a),this.elements.linesVertical.push(a),this.t.linesVertical[i]=a}}},this.Ti=function(e){var t=this.rowlist[e],i=!t.expanded;t.expanded=i,t.resource&&(t.resource.expanded=i);var n=this.Il(e,t.expanded);if(!i)for(var a=0;a<n.length;a++){var o=n[a];this.wh(o)}if(this._f(),this.Zf(),this.ja(),this.Vf(),i){for(var a=0;a<n.length;a++){var o=n[a];this.xh(o)}this.xg()}this.yh(),v.load(),this.cg(),this.fg(),this.oa(),this.vf();var r=this.Jh(t,e);i?this.Sh(r):this.Rh(r),this.Vf()},this.Ej=function(e){var t={};if(t.index=e,"function"==typeof this.onLoadNode){var i={},n=this.rowlist[e].resource;i.resource=n,i.async=!1,i.loaded=function(){this.async&&(n.dynamicChildren=!1,n.expanded=!0,c.update())},this.onLoadNode(i),i.async||(n.dynamicChildren=!1,n.expanded=!0,this.update())}else this.G("LoadNode",t)},this.Il=function(e,t){var i=this.rowlist[e],n=[];if(null===i.children||0===i.children.length)return n;for(var a=0;a<i.children.length;a++){var o=i.children[a],r=this.rowlist[o],s=t&&i.expanded&&!r.bk;r.hidden=!s,t===!r.hidden&&n.push(o);var l=this.Il(o,t);l.length>0&&(n=n.concat(l))}return n},this.jl=function(e,t){this.zk(),this.Jl(e,t)},this.Kl=function(e){if(!e)return!1;var t=this.nav.scroll.scrollWidth,i=this.nav.scroll.scrollLeft,n=this.nav.scroll.clientWidth,a=i+n;return!(e<0&&i<=0)&&(!(e>0&&a>=t)&&(this.nav.scroll.scrollLeft+=e,c.coords.x+=e,c.Ll(),!0))},this.Ml=function(e){if(!e)return!1;var t=this.nav.scroll.scrollHeight,i=this.nav.scroll.scrollTop,n=this.nav.scroll.clientHeight,a=i+n;return!(e<0&&i<=0)&&(!(e>0&&a>=t)&&(this.nav.scroll.scrollTop+=e,c.coords.y+=e,c.Ll(),!0))},this.Ll=function(){n.resizing&&n.resizing.event.calendar===c?c.dl():n.moving&&(n.movingEvent.calendar===c||n.movingEvent.calendar.dragOutAllowed)?c.fl():n.range&&n.range.calendar===c&&c.gl()},this.Jl=function(e,t){if(this.Kl(e)||this.Ml(t)){var i=function(e,t){return function(){c.Jl(e,t)}};this.Nl=window.setTimeout(i(e,t),100)}},this.zk=function(){c.Nl&&(window.clearTimeout(c.Nl),c.Nl=null)},this._f=function(){for(var e=0,t=0;t<this.rowlist.length;t++){var i=this.rowlist[t];i.hidden||(i.top=e,e+=i.height)}this.Tf=e},this.cg=function(){this.elements.cells=[],this.elements.breaks=[],this.t.cells=[],this.t.breaks=[],this.divCells.innerHTML="",this.divBreaks.innerHTML="",c.xj()},this.xj=function(){this.divLines.innerHTML="",this.t.linesVertical={},this.t.linesHorizontal={},this.elements.linesVertical=[]},this.zh=function(e){var t=DayPilot.list();for(var i in c.t.cells)t.push(c.t.cells[i]);t.filter(function(t){return t&&t.coords&&t.coords.y===e}).each(function(e){c.zi(e)})},this.Ol=0,this.Pl=DayPilot.list(["html","cssClass","backColor","backImage","backRepeat","areas"]),this.Ql=c.Pl.add("business"),this.$e=function(e,t){if(this.A){var i=c._g(e);if(i){var n=e+"_"+t;if(!this.t.cells[n]){var a=this.Ai(e,t);if(c.aj(e,t),!this.drawBlankCells){var o=!1;if(this.Qi(t)?o=!1:this.Rl(a,c.Pl)||(o=!0),o)return}var r=document.createElement("div");if(r.style.left=i.left+"px",r.style.top=this.rowlist[t].top+"px",r.style.width=i.width+"px",r.style.height=this.rowlist[t].height+"px",r.style.position="absolute",a&&a.backColor&&(r.style.backgroundColor=a.backColor),r.setAttribute("unselectable","on"),r.className=this.q("_cell"),r.coords={},r.coords.x=e,r.coords.y=t,this.Qi(t)&&DayPilot.Util.addClass(r,this.q("_cellparent")),a){a.cssClass&&DayPilot.Util.addClass(r,a.cssClass),DayPilot.Util.isNullOrUndefined(a.html)||(r.innerHTML=a.html),a.backImage&&(r.style.backgroundImage='url("'+a.backImage+'")'),a.backRepeat&&(r.style.backgroundRepeat=a.backRepeat),a.business&&c.cellsMarkBusiness&&DayPilot.Util.addClass(r,c.q("_cell_business")),DayPilot.list(a.areas).each(function(e){(e.start||e.end)&&(e.left=c.getPixels(new DayPilot.Date(e.start)).left-i.left,e.width=c.getPixels(new DayPilot.Date(e.end)).left-e.left-i.left)});var s=c.cells.findXy(e,t)[0];DayPilot.Areas.attach(r,s,{"areas":a.areas})}this.divCells.appendChild(r),this.elements.cells.push(r),this.t.cells[n]=r}}}},this.mh={},this.xi=function(){c.Sl().each(function(e){c.zh(e)}),c.fg()},this.Sl=function(){for(var e=DayPilot.list(),t=this.ug(),i=t.xStart,n=t.xEnd-t.xStart,a=t.yStart,o=t.yEnd-t.yStart,r=0;r<o;r++)for(var s=a+r,l=0;l<=n;l++){var d=i+l;if(!this.rowlist[s].hidden&&!c.mh[d+"_"+s]){e.push(s);break}}return e},this.aj=function(e,t){if("function"==typeof this.onBeforeCellRender){if(c.beforeCellRenderCaching&&c.mh[e+"_"+t])return;c.mh[e+"_"+t]=!0;var i=c._g(e);if(!i)return;var n=c.cells.findXy(e,t)[0],a={};return a.cell=n,a.getPixels=function(e){var e=new DayPilot.Date(e);return c.getPixels(e).left-i.left},this.onBeforeCellRender(a),DayPilot.Util.copyProps(a.cell,a.cell.properties,c.Ql),a}},this.Rl=function(e,t){if(t){for(var i=0;i<t.length;i++)if(!DayPilot.Util.isNullOrUndefined(e[t[i]]))return!0}else for(var n in e)if(!DayPilot.Util.isNullOrUndefined(e[n]))return!0;return!1},this.clearSelection=function(){this.ig(),H.clear()},this.cleanSelection=this.clearSelection,this.selectTimeRange=function(e,t,i,n){var a=c.sg(i),o=c.Zg(e),r=o.current||o.next;if(!r)throw new DayPilot.Exception("Time range selection 'start' out of timeline");var s=c.Zg(new DayPilot.Date(t).addSeconds(-1)),l=s.current||s.previous;if(!l)throw new DayPilot.Exception("Time range selection 'end' out of timeline");var d={};d.start={y:a.index,x:DayPilot.indexOf(c.itline,r)},d.end={x:DayPilot.indexOf(c.itline,l)},d.calendar=this,c.Fh(d),n||setTimeout(function(){c.Ch(d)},0)},this.Bh=function(){DayPilot.de(n.movingShadow),n.movingShadow=null,c.lj(),c.gj.clear()},this.ig=function(){this.divRange.innerHTML='<div style="position:absolute; left:0px; top:0px; width:0px; height:0px;"></div>',this.elements.range=[],this.elements.range2=null,this.lj(),c.rangeHold=null},this.sc={};var _=this.sc;_.clearCache=function(){delete c.t.eventHeight,delete c.t.headerHeight},_.locale=function(){return DayPilot.Locale.find(c.locale)},_.timeFormat=function(){return"Auto"!==c.timeFormat?c.timeFormat:_.locale().timeFormat},_.weekStarts=function(){if("Auto"===c.weekStarts){var e=_.locale();return e?e.weekStarts:0}return c.weekStarts||0},_.rounded=function(){return"Rounded"===c.eventCorners},_.layout=function(){var e=/MSIE 6/i.test(navigator.userAgent);return"Auto"===c.layout?e?"TableBased":"DivBased":c.layout},_.notifyType=function(){var e;if("Immediate"===c.notifyCommit)e="Notify";else{if("Queue"!==c.notifyCommit)throw"Invalid notifyCommit value: "+c.notifyCommit;e="Queue"}return e},_.isResourcesView=function(){return"Days"!==c.viewType},_.useBox=function(e){return"Always"===c.useEventBoxes||"Never"!==c.useEventBoxes&&e<60*c.Hi()*1e3},_.eventHeight=function(){if(c.t.eventHeight)return c.t.eventHeight;var e=c.hd("_event_height").height;return e||(e=c.eventHeight),c.t.eventHeight=e,e},_.headerHeight=function(){if(c.t.headerHeight)return c.t.headerHeight;var e=c.hd("_header_height").height;return e||(e=c.headerHeight),c.t.headerHeight=e,e},_.splitterWidth=function(){return c.rowHeaderScrolling?c.rowHeaderSplitterWidth:1},this.Tl={};var R=this.Tl;R.timeHeader=function(e){var t={};t.top=0,t.height=0;for(var i=_.headerHeight(),n=0;n<=e;n++){var a=c.timeHeaders[n];t.top+=t.height,t.height=a.height||i}return t},this.Bc=function(e,t){var i=e+"_"+t;return this.cellProperties&&this.cellProperties[i]?this.cellProperties[i].backColor:null},this.Ai=function(e,t){var i=e+"_"+t;if(c.cellConfig)for(var n=0,a=0;a<c.resources.length;a++)if(!c.resources[a].hidden){if(n===t){t=a;break}n+=1}if(this.cellProperties||(this.cellProperties={}),this.cellProperties[i])return this.cellProperties[i];if(this.Lf&&(this.cellProperties[i]=c.Ul(e,t)),!this.cellProperties[i]){var o=c.rowlist[t],r=o.id,s=o.start.getTime()-c.Ba().getTime(),l=c._g(e),d=l.start.addTime(s),h=l.end.addTime(s),u={};u.start=d,u.end=h,u.resource=r;var f={};f.business=c.isBusiness(u),this.cellProperties[i]=f}return this.cellProperties[i]},this.Vl=function(e,t,i){var n=t+"_"+i;return this.cellProperties[n]={},DayPilot.Util.copyProps(e,this.cellProperties[n],c.Ql),this.cellProperties[n]},this.Ul=function(e,t){if(!this.cellConfig)return null;var i=this.cellConfig,n=this.cellProperties[e+"_"+t];!n&&i.vertical&&(n=this.cellProperties[e+"_0"]),!n&&i.horizontal&&(n=this.cellProperties["0_"+t]),!n&&i["default"]&&(n=i["default"]);var a={};return DayPilot.Util.copyProps(n,a,c.Ql),a},this.aa=function(){if(!this.Lf&&!this.Mf&&(this.Mf=!0,this.cellConfig)){var e=this.cellConfig;if(e.vertical)for(var t=0;t<e.x;t++){var i=this.cellProperties[t+"_0"];if(i)for(var n=1;n<e.y;n++)this.Vl(i,t,n)}if(e.horizontal)for(var n=0;n<e.y;n++){var i=this.cellProperties["0_"+n];if(i)for(var t=1;t<e.x;t++)this.Vl(i,t,n)}if(e["default"])for(var i=e["default"],n=0;n<e.y;n++)for(var t=0;t<e.x;t++)this.cellProperties[t+"_"+n]||this.Vl(i,t,n)}},this.isBusiness=function(e){var t=e.start,i=e.end,n=(i.getTime()-t.getTime())/6e4;if(n<=1440&&"Days"!==c.viewType&&!c.businessWeekends&&(0===e.start.dayOfWeek()||6===e.start.dayOfWeek()))return!1;if(n<720){var a=t.getHours();if(a+=t.getMinutes()/60,a+=t.getSeconds()/3600,a+=t.getMilliseconds()/36e5,a<this.businessBeginsHour)return!1;if(this.businessEndsHour>=24)return!0;if(a>=this.businessEndsHour)return!1}return!0},this.na=function(){"hidden"===this.nav.top.style.visibility&&(this.nav.top.style.visibility="visible")},this.Nc=function(){var e=c.nav.top;return!!e&&(e.offsetWidth>0&&e.offsetHeight>0)},this.Oc=function(){var e=c.Nc;e()||c.Pc||(c.Pc=setInterval(function(){e()&&(clearInterval(c.Pc),c.show(),c.rj())},100))},this.Wl=function(e){"Parent100Pct"!==this.heightSpec&&(this.heightSpec="Fixed"),this.height=e-(this.Fg()+2),this.ja()},this.setHeight=this.Wl,this.sg=function(e){return DayPilot.list(D.rowcache[e]).first()},this.nd=function(){if(this.id&&this.id.tagName)this.nav.top=this.id;else{if("string"!=typeof this.id)throw"DayPilot.Scheduler() constructor requires the target element or its ID as a parameter";if(this.nav.top=document.getElementById(this.id),!this.nav.top)throw"DayPilot.Scheduler: The placeholder element not found: '"+e+"'."}},this.Xl=function(){this.dd(),this.Yf(),this.ag(),this.Rc(),this.Q(),n.register(this),this.Y(this.afterRenderData,!1),this.Hk(),this.ra(),this.G("Init")},this.init=function(){this.Yl(),this.Oc(),this.tk()},this.Yl=function(){if(this.nd(),!this.nav.top.dp){this.gk();if(this.md())return this.Xl(),this.A=!0,void this.Vf();this.Rc(),this.Q(),n.register(this),this.Hk(),this.cd(),this.A=!0,c.scrollToDate?c.scrollTo(c.scrollToDate):c.scrollX||c.scrollY?c.setScroll(c.scrollX,c.scrollY):c.lg(),c.scrollToResourceId&&(c.scrollToResource(c.scrollToResourceId),c.scrollToResourceId=null);var e=function(){c.scrollY&&c.setScroll(c.scrollX,c.scrollY)};window.setTimeout(e,200),this.messageHTML&&window.setTimeout(function(){c.message(c.messageHTML)},0),this.ra(),this.Vf(),this.Y(this.afterRenderData,!1),c.initEventEnabled&&setTimeout(function(){c.G("Init")}),this.pd(),this.di=!0}},this.qd=null,this.rd=function(e){if(e){var t={"events":{"preInit":function(){var e=this.data;e&&(DayPilot.isArray(e.list)?c.events.list=e.list:c.events.list=e)},"postInit":function(){}},"scrollTo":{"preInit":function(){},"postInit":function(){this.data&&c.scrollTo(this.data,e.scrollToAnimated,e.scrollToPosition)}},"scrollX":{"postInit":function(){this.data&&c.setScrollX(this.data)}},"scrollY":{"postInit":function(){this.data&&c.setScrollY(this.data)}}};c.qd=t,c.mg.scrollToRequested&&(t.scrollTo.data=c.mg.scrollToRequested,c.mg.scrollToRequested=null),c.mg.scrollXRequested&&(t.scrollX.data=c.mg.scrollXRequested,c.mg.scrollXRequested=null),c.mg.scrollYRequested&&(t.scrollY.data=c.mg.scrollYRequested,c.mg.scrollYRequested=null);for(var i in e)if(t[i]){var n=t[i];n.data=e[i],n.preInit&&n.preInit()}else c[i]=e[i]}},this.pd=function(){var e=c.qd;for(var t in e){var i=e[t];i.postInit&&i.postInit()}c.qd={}},this.temp={},this.temp.getPosition=function(){var e=Math.floor(c.coords.x/c.cellWidth),t=c.bi(c.coords.y).i;if(t<c.rowlist.length){var i={};return i.start=c.itline[e].start,i.end=c.itline[e].end,i.resource=c.rowlist[t].id,i}return null},this.internal={},this.internal.initialized=function(){return c.A},this.internal.dragInProgress=this.cl,this.internal.invokeEvent=this.Qa,this.internal.eventMenuClick=this.Za,this.internal.timeRangeMenuClick=this.$a,this.internal.resourceHeaderMenuClick=this.Hh,this.internal.linkMenuClick=this.Gh,this.internal.bubbleCallBack=this.Xa,this.internal.findEventDiv=this.bd,this.internal.rowtools=this.Ph,this.internal.getNodeChildren=this.W,this.internal.callback=function(){c.G.apply(c,arguments)},this.internal.createRowObject=this.Jh,this.internal.adjustEndIn=c.Ee,this.internal.adjustEndNormalize=c.gf,this.internal.touch=c.Sb,this.internal.cssNames=c.Wk,this.internal.skipUpdate=c.mg.skipUpdate,this.internal.skipped=c.mg.skipped,this.internal.loadOptions=c.rd,this.internal.postInit=c.pd,this.internal.enableAngular2=function(){c.mg.enabled=!0},this.Init=this.init,this.rd(o)},o="2911"===(new DayPilot.Scheduler).v,DayPilot.Row=function(e,t){if(!e)throw"Now row object supplied when creating DayPilot.Row";if(!t)throw"No parent control supplied when creating DayPilot.Row";var i=DayPilot.indexOf(t.rowlist,e);this.Zl={};var n=this.Zl;n.id=e.id,n.name=e.name,n.data=e.resource,n.tags=e.tags;var a=this;a.isRow=!0,a.menuType="resource",a.start=e.start,a.name=e.name,a.value=e.id,a.id=e.id,a.tags=e.tags,a.index=i,a.level=e.level,a.calendar=t,a.data=e.resource,a.$l=e,a.$={},a.$.row=e,a.toJSON=function(e){var t={};return t.start=this.start,t.name=this.name,t.value=this.value,t.id=this.id,t.index=this.index,t},a.parent=function(){return a.$l.ck?t.Jh(a.$l.ck):null},a.children=function(){var e=DayPilot.list(a.$.row.children).map(function(e){return t.Jh(t.rowlist[e])});return e.add=function(e){var t=a.$.row.resource;t.children||(t.children=[]),t.children.push(e)},e},a.loaded=function(){return a.$l.loaded},a.cells={},a.cells.all=function(){for(var e=[],i=t.itline.length,n=a.index,o=0;o<i;o++){var r=t.cells.findXy(o,n);e.push(r[0])}return t.Bi(e)},a.cells.totalDuration=function(){return new DayPilot.Duration(a.cells.all().map(function(e){return e.end.getTime()-e.start.getTime()}).reduce(function(e,t){return e+t},0))},a.events={},a.events.all=function(){for(var e=DayPilot.list(),t=0;t<a.$l.events.length;t++)e.push(a.$l.events[t]);return e},a.events.isEmpty=function(){return 0===a.$l.events.length},a.events.forRange=function(e,t){return a.$l.events.forRange(e,t)},a.events.totalDuration=function(){var e=0;return a.events.all().each(function(t){e+=t.part.end.getTime()-t.part.start.getTime()}),new DayPilot.Duration(e)},a.groups={},a.groups.collapseAll=function(){for(var e=0;e<a.$l.blocks.length;e++){new o(a.$l.blocks[e])._l()}t.fh(),t.gh(a.index),t.ja()},a.groups.expandAll=function(){for(var e=0;e<a.$l.blocks.length;e++){new o(a.$l.blocks[e]).bm()}t.fh(),t.gh(a.index),t.ja()},a.groups.expanded=function(){for(var e=[],i=0;i<a.$l.blocks.length;i++){var n=a.$l.blocks[i];n.expanded&&n.lines.length>t.groupConcurrentEventsLimit&&e.push(new o(n))}return DayPilot.list(e)},a.groups.collapsed=function(){for(var e=[],t=0;t<a.$l.blocks.length;t++){var i=a.$l.blocks[t];i.expanded||e.push(new o(i))}return DayPilot.list(e)},a.groups.all=function(){for(var e=[],t=0;t<a.$l.blocks.length;t++){var i=a.$l.blocks[t];e.push(new o(i))}return DayPilot.list(e)},a.events.collapseGroups=a.groups.collapseAll,a.events.expandGroups=a.groups.expandAll,a.column=function(e){return new r(a,e)},a.toggle=function(){t.Ti(a.index)},a.collapse=function(){a.$.row.expanded&&a.toggle()},a.expand=function(){a.$.row.expanded||a.toggle()},a.remove=function(){t.rows.remove(a)},a.edit=function(){t.rows.edit(a)},a.addClass=function(e){var i=a,n=t.divHeader,i=n.rows[i.index];if(i){var o=DayPilot.list(i.cells).map(function(e){return e.cellDiv});DayPilot.Util.addClass(o,e)}a.$.row.cssClass=DayPilot.Util.addClassToString(a.$.row.cssClass,e)},a.removeClass=function(e){var i=a,n=t.divHeader,i=n.rows[i.index];if(i){var o=DayPilot.list(i.cells).map(function(e){return e.cellDiv});DayPilot.Util.removeClass(o,e)}a.$.row.cssClass=DayPilot.Util.removeClassFromString(a.$.row.cssClass,e)};var o=function(e){var i=function(e){for(var i=0;i<t.elements.events.length;i++){var n=t.elements.events[i];if(n.event===e)return n}return null};this.bm=function(){e.expanded=!0;var n=t.Ij;DayPilot.list(e.events).each(function(e){n.push(e.id())});var a=i(e);if(a){t.Jk(a);var o=DayPilot.indexOf(t.elements.events,a);o!==-1&&t.elements.events.splice(o,1)}},this.expand=function(){this.bm(),t.fh(),t.gh(e.row.index),t.ja()},this._l=function(){if(e.lines.length>t.groupConcurrentEventsLimit){e.expanded=!1;var i=DayPilot.list(e.events).map(function(e){return e.id()});t.Ij=t.Ij.filter(function(e){return!DayPilot.contains(i,e)})}},this.collapse=function(){this._l(),t.fh(),t.gh(e.row.index),t.ja()}},r=function(e,t){this.html=function(i){var n=e.calendar.divHeader,a=n.rows[e.index].cells[t],o=a.textDiv;return"undefined"==typeof i?o.innerHTML:void(o.innerHTML=i)}}},n.moving=null,n.movingEvent=null,n.originalMouse=null,n.resizing=null,n.resizingEvent=null,n.preventEventClick=!1,n.globalHandlers=!1,n.timeRangeTimeout=null,n.selectedCells=null,n.dragStart=function(e,t,i,a){DayPilot.us(e);var o=n.drag={};return o.element=e,o.duration=t,o.text=a,o.id=i,o.data={"id":i,"text":a,"duration":t,"externalHtml":a},!1},DayPilot.Scheduler.startDragging=function(e){var e=e||{},t=e.element,i=e.keepElement?null:t;DayPilot.us(t);var a=n.drag={};return a.element=i,a.id=e.id,a.duration=e.duration||60,a.text=e.text||"",a.data=e,!1},DayPilot.Scheduler.makeDraggable=function(e){
function t(){var t=n.drag={};t.element=a,t.id=e.id,t.duration=e.duration||60,t.text=e.text||"",t.data=e}e=e||{};var i=e.element,a=e.keepElement?null:e.remove||i;DayPilot.us(i),DayPilot.re(i,"mousedown",function(e){if(DayPilot.Util.mouseButton(e).left){t();var i=e.target||e.srcElement;if(i.tagName){var n=i.tagName.toLowerCase();if("textarea"===n||"select"===n||"input"===n)return!1}return e.preventDefault&&e.preventDefault(),!1}}),i.ontouchstart=function(e){window.setTimeout(function(){t(),n.gTouchMove(e),e.preventDefault()},0),e.preventDefault()}},DayPilot.Scheduler.stopDragging=function(){if(n.drag&&n.drag.schedulerSourceEvent){var e=n.drag.schedulerSourceEvent,t=e.event.calendar;DayPilot.Util.removeClass(e,t.q(i.Wk.eventMovingSource))}if(n.dragStop(),n.resizing&&(DayPilot.de(n.resizingShadow),n.resizing=null,n.resizingEvent=null,n.resizingShadow=null),n.moving){var i=n.movingEvent.calendar;DayPilot.Util.removeClass(n.moving,i.q(i.Wk.eventMovingSource)),DayPilot.de(n.movingShadow),n.moving=null,n.movingEvent=null,n.movingShadow=null}if(n.range){var i=n.range.calendar;i.clearSelection(),n.range=null}document.body.style.cursor="",DayPilot.list(n.registered).each(function(e){e.zk(),e.lj()})},n.dragStop=function(){n.gShadow&&(document.body.removeChild(n.gShadow),n.gShadow=null),n.drag=null},n.register=function(e){n.registered||(n.registered=[]);for(var t=0;t<n.registered.length;t++)if(n.registered[t]===e)return;n.registered.push(e)},n.unregister=function(e){var t=n.registered;if(t){var i=DayPilot.indexOf(t,e);i!==-1&&t.splice(i,1),0===t.length&&(t=null)}t||(DayPilot.ue(document,"mousemove",n.gMouseMove),DayPilot.ue(document,"mouseup",n.gMouseUp),DayPilot.ue(document,"mousedown",n.gMouseDown),DayPilot.ue(document,"touchmove",n.gTouchMove),DayPilot.ue(document,"touchend",n.gTouchEnd),DayPilot.ue(window,"keyup",n.gKeyUp),n.globalHandlers=!1)},n.gTouchMove=function(i){if(n.resizing){var a=n.resizing.event.calendar;a.coords=a.Sb.relativeCoords(i),a.Sb.updateResizing(),i.preventDefault()}if(n.moving){var a=n.movingEvent.calendar;a.coords=a.Sb.relativeCoords(i),a.Sb.updateMoving(),i.preventDefault()}if(n.drag){i.preventDefault();var o=t(i),a=e(i);if(a){if(n.gShadow&&document.body.removeChild(n.gShadow),n.gShadow=null,a.coords=a.Sb.relativeCoords(i),!n.movingShadow&&a.rowlist.length>0){if(!n.moving){n.moving={};var r=n.drag.event;if(!r){var s=a.itline[0].start,i={"id":n.drag.id,"start":s,"end":s.addSeconds(n.drag.duration),"text":n.drag.text},l=n.drag.data;if(l){var d=["duration","element","id","text"];for(var c in l)DayPilot.contains(d,c)||(i[c]=l[c])}r=new DayPilot.Event(i),r.calendar=a,r.part.duration=n.drag.duration,r.part.external=!0}n.movingEvent=r}n.movingShadow=a.ta(n.movingEvent)}n.moving&&a.Sb.updateMoving()}else{DayPilot.de(n.movingShadow);var h=n.moving;n.moving=null,n.movingEvent=null,n.movingShadow=null,n.gShadow||(n.gShadow=n.createGShadow(n.drag.data),n.gShadow.source=h);var u=n.gShadow;u.style.left=o.x+"px",u.style.top=o.y+"px"}}},n.gTouchEnd=function(e){n.gMouseUp(e)},n.gMouseMove=function(e){if("undefined"!=typeof n&&DayPilot.Util.isMouseEvent(e)&&(e=e||window.event,!(e.insideMainD||e.srcElement&&e.srcElement.inside))){var t=DayPilot.mc(e);if(n.drag){if(!n.drag.startFired){var i=n.drag.data||{},a=i.onDragStart,o=!1;if("function"==typeof a){var r={};r.data=i,r.preventDefault=function(){r.preventDefault.value=!0},a(r),o=r.preventDefault.value}if(n.drag.startFired=!0,o)return void(n.drag=null)}document.body.style.cursor="move",n.gShadow||(n.gShadow=n.createGShadow(n.drag.data));var s=n.gShadow;if(s.style.left=t.x+"px",s.style.top=t.y+"px",n.moving=null,n.movingEvent=null,n.movingShadow){var l=n.movingShadow.calendar;l&&l.lj(),n.movingShadow.calendar=null,DayPilot.de(n.movingShadow),n.movingShadow=null}}else if(n.moving&&n.movingEvent&&n.movingEvent.calendar.dragOutAllowed&&!n.drag){var l=n.movingEvent.calendar,e=n.movingEvent;document.body.style.cursor="move",n.gShadow||(n.gShadow=n.createGShadow(e.data),n.gShadow.source=n.moving);var s=n.gShadow;s.style.left=t.x+"px",s.style.top=t.y+"px",n.drag={};var d=n.drag;d.schedulerSourceEvent=n.moving,d.element=null,d.duration=(e.rawend().getTime()-e.start().getTime())/1e3,d.text=e.text(),d.id=e.value(),d.event=e,l.lj(),DayPilot.de(n.movingShadow),n.movingShadow.calendar=null,n.movingShadow=null}for(var c=0;c<n.registered.length;c++)n.registered[c].S&&n.registered[c].S()}},n.gUnload=function(e){if(n.registered)for(var t=0;t<n.registered.length;t++){var i=n.registered[t];n.unregister(i)}},n.gMouseDown=function(e){n.editing&&n.editing.blur()},n.gKeyUp=function(e){var e=e||window.event;17===e.keyCode&&n.rangeCalendar&&n.rangeCalendar.ul.dispatch()},n.gMouseUp=function(e){if(DayPilot.list(n.registered).each(function(e){e.zk()}),n.resizing){var t=function(){var e=n.resizingEvent,t=e.calendar;document.body.style.cursor="",n.resizing=null,n.resizingEvent=null,DayPilot.de(n.resizingShadow),n.resizingShadow=null,t.zl()};if(setTimeout(function(){n.preventEventClick=!1}),!n.resizingShadow)return void t();var i=n.resizingEvent,o=i.calendar,r=n.resizingShadow.finalStart,d=n.resizingShadow.finalEnd,c=n.resizingShadow.overlapping,h=!n.resizingShadow.allowed;if(o.lj(),o.dj.clear(),t(),c||h)return;o.Sa(i,r,d)}else if(n.movingEvent){var t=function(){var e=n.movingShadow&&n.movingShadow.calendar;n.movingShadow&&(DayPilot.de(n.movingShadow),n.movingShadow.calendar=null),document.body.style.cursor="",n.moving=null,n.movingEvent=null,n.drag=null,e.zl(),e&&(e.Ah=null)};if(!n.movingShadow)return void t();var i=n.movingEvent,o=n.movingShadow.calendar;if(!o)return void t();if(DayPilot.Util.removeClass(n.moving,o.q(o.Wk.eventMovingSource)),function(){if(n.drag&&n.drag.schedulerSourceEvent){var e=n.drag.schedulerSourceEvent,t=e.event.calendar;DayPilot.Util.removeClass(e,t.q(o.Wk.eventMovingSource))}}(),!n.movingShadow.row)return void t();clearTimeout(o.Ri.timeout);var r=n.movingShadow.start,d=n.movingShadow.end,u="Days"!==o.viewType?n.movingShadow.row.id:null,f=!!n.drag&&i.part.external,v=n.movingShadow.line,c=n.movingShadow.overlapping,h=!n.movingShadow.allowed;if(n.drag&&(o.todo||(o.todo={}),o.todo.del=n.drag.element,n.drag=null),n.movingShadow.calendar=null,document.body.style.cursor="",n.moving=null,n.movingEvent=null,c||h||o.gj.forbidden||o.gj.invalid)return void o.Bh();var e=e||window.event;o.Ua(i,r,d,u,f,e,v)}else if(n.range){e=e||window.event;var p=DayPilot.Util.mouseButton(e),g=n.range,o=g.calendar,t=function(){o.zl()};o.rl=null;var m=e.ctrlKey||e.metaKey;if(o.allowMultiRange)return o.elements.range2.overlapping?(DayPilot.de(o.elements.range2),o.elements.range2=null,o.lj()):o.ul.add(g),n.range=null,m||o.ul.dispatch(),void t();if(n.timeRangeTimeout)return clearTimeout(n.timeRangeTimeout),n.timeRangeTimeout=null,void t();o.rangeHold=g,n.range=null;var y=function(e){return function(){n.timeRangeTimeout=null;var t=o.elements.range2;return t&&t.overlapping?void o.clearSelection():(o.Ch(e),void("Hold"!==o.timeRangeSelectedHandling&&"HoldForever"!==o.timeRangeSelectedHandling?a():o.rangeHold=e))}},b=o.sl(g);if(t(),!p.left)return void(n.timeRangeTimeout=null);if(g.moved||"Disabled"===o.timeRangeDoubleClickHandling){y(b)();var e=e||window.event;return e.cancelBubble=!0,!1}n.timeRangeTimeout=setTimeout(y(b),o.doubleClickTimeout)}else if(s.row){var o=s.calendar;o&&o.Tj()}else if(l.source){var o=l.calendar;o.ii.clearShadow(),o.ii.hideLinkpoints(),l.source=null,l.calendar=null}else if(n.splitting){var w=n.splitting;w.cleanup(),n.splitting=null}else if(n.rectangleSelect){var D=n.rectangleSelect,o=D.calendar;if(!D.moved)return n.rectangleSelect=null,void(o._k(o.coords)||o.vl(e));var k=D.x,C=D.y,x=D.width,P=D.height,S=!1,A=o.yg.eventsInRectangle(k,C,x,P).map(function(e){return e.event});if("function"==typeof o.onRectangleEventSelect){var T={};if(T.events=A,T.append=!1,T.start=o.getDate(k,!0),T.end=o.getDate(k+x,!0),T.preventDefault=function(){this.preventDefault.value=!0},o.onRectangleEventSelect(T),T.preventDefault.value)return o.kl.clear(),void(n.rectangleSelect=null);S=T.append}if(S||o.multiselect.clear(!0),A.each(function(e){o.multiselect.add(e,!0)}),o.multiselect.redraw(),setTimeout(function(){o.kl.clear(),n.rectangleSelect=null},0),"function"==typeof o.onRectangleEventSelected){var T={};T.events=A,o.onRectangleEventSelected(T)}}if(n.drag&&(n.drag.event&&n.drag.event.part&&delete n.drag.event.part.external,n.drag=null,document.body.style.cursor=""),n.gShadow){if(n.gShadow.source){var o=n.gShadow.source.event.calendar;DayPilot.Util.removeClass(n.gShadow.source,o.q(o.Wk.eventMovingSource))}document.body.removeChild(n.gShadow),n.gShadow=null}n.moveOffsetX=null,n.moveDragStart=null},n.createGShadow=function(e){var e=e||{},t=document.createElement("div");return t.setAttribute("unselectable","on"),t.style.position="absolute",t.style.width="100px",t.style.height="20px",t.style.zIndex=101,t.style.pointerEvents="none",t.style.backgroundColor="#aaaaaa",t.style.opacity=.5,t.style.filter="alpha(opacity=50)",t.className=e.externalCssClass,e.externalHtml&&(t.innerHTML=e.externalHtml),document.body.appendChild(t),t};var s={};DayPilot.Global.rowmoving=s;var l={};DayPilot.Global.linking=l,"undefined"!=typeof jQuery&&!function(e){e.fn.daypilotScheduler=function(e){var t=null,i=this.each(function(){if(!this.daypilot){var i=new DayPilot.Scheduler(this.id||this,e);i.init(),this.daypilot=i,t||(t=i)}});return 1===this.length?t:i}}(jQuery),function(){var e=DayPilot.am();e&&e.directive("daypilotScheduler",["$parse",function(e){return{"restrict":"E","template":"<div id='{{id}}'></div>","compile":function(t,i){return t.replaceWith(this["template"].replace("{{id}}",i["id"])),function(t,i,n){var a=new DayPilot.Scheduler(i[0]);a.Lc.scope=t,a.init();var o=n["id"];o&&(t[o]=a);var r=n["publishAs"];if(r){(0,e(r).assign)(t,a)}for(var s in n)if(0===s.indexOf("on")){var l=DayPilot.Util.shouldApply(s);l?!function(i){a[i]=function(a){var o=e(n[i]);DayPilot.Util.safeApply(t,function(){o(t,{"args":a})})}}(s):!function(i){a[i]=function(a){e(n[i])(t,{"args":a})}}(s)}var d=t["$watch"],c=n["config"]||n["daypilotConfig"],h=n["events"]||n["daypilotEvents"];d.call(t,c,function(e,t){a.rd(e),a.update(),a.pd()},!0),d.call(t,h,function(e){a.events.list=e,a.cd({"eventsOnly":!0})},!0)}}}}])}(),"undefined"!=typeof Sys&&Sys.Application&&Sys.Application.notifyScriptLoaded&&Sys.Application.notifyScriptLoaded()}}(),"undefined"==typeof DayPilot)var DayPilot={};"undefined"==typeof DayPilot.Global&&(DayPilot.Global={}),function(){"undefined"==typeof DayPilot.Year&&(DayPilot.Year=function(e,t){this.v="2911";this.startDate=new DayPilot.Date,this.cssOnly=!0,this.cssClassPrefix=null,this.columns=4,this.cellWidth=20,this.showWeekNumbers=!1,this.cm=[],this.hf=function(){this.root.dp=this,this.Yd=new DayPilot.Date(this.startDate.toString("yyyy-01-01","en-us"))},this.q=function(e){return this.cssClassPrefix?this.cssClassPrefix+e:""},this.if=function(){return this.showWeekNumbers?this.cellWidth:0},this.dm=function(){this.cm=[];var e=this.columns,t=12/e;this.root.className=this.q("_main"),this.root.style.width=e*(7*this.cellWidth+this.if())+"px";for(var i=0;i<t;i++){for(var n=0;n<e;n++){var a=i*e+n,o=o+"_nav_"+a,r=document.createElement("div");r.id=o,r.style.float="left",this.root.appendChild(r);var s=new DayPilot.Navigator(o);s.startDate=this.Yd.addMonths(a),s.cssOnly=this.cssOnly,s.cssClassPrefix=this.cssClassPrefix,s.cellWidth=this.cellWidth,s.showWeekNumbers=this.showWeekNumbers,s.internal.showLinks={},s.selectMode="none",s.timeRangeSelectedHandling="JavaScript",s.onTimeRangeSelected=this.em,s.init(),s.root.className="",this.cm.push(s)}var l=document.createElement("div");l.style.clear="left",this.root.appendChild(l)}},this.em=function(e){alert("clicked: "+e.day)},this.init=function(){this.root=document.getElementById(e),this.root.dp||(this.hf(),this.dm())}})}();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {


       



        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */

    function runBlock($rootScope, $timeout, $state, $mdDialog, $localStorage, toastMessage, Idle,
        Keepalive,$location,$window){
        Idle.watch();
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, toState, toStateData,fromState, fromStateData, $location){
            if(toState.external){
                event.preventDefault();
                $window.open(toState.url, '_blank');
            }

            if($rootScope.previousLocation == toState['url']) {
                $rootScope.backButtonPressed = true;
            }else{
                $rootScope.backButtonPressed = false;
            }


            $rootScope.previousLocation = fromState['url'];
            $rootScope.actualLocation =toState['url'];

            var userPermissions =  $rootScope.userPermissions;
            var redirectState = (typeof $localStorage.firstTimeRedirectState !== 'undefined' && $localStorage.firstTimeRedirectState !== '') ? $localStorage.firstTimeRedirectState : '';
            $rootScope.loadingProgress = true;
			if(toState['name'] != 'app.pages_auth_login' && typeof $localStorage.authToken != 'undefined' && $localStorage.authToken != '' &&  $localStorage.authToken.length > 0 &&  toState.permission && userPermissions.indexOf(toState.permission) == -1){
                // $state.transitionTo('app.dashboards_project');

                toastMessage.showSimpleToast('Access denied.','error-toast');
                if (redirectState !== '') {
                    $state.transitionTo($localStorage.firstTimeRedirectState);
                } else {
                    delete $localStorage.authToken;
                    $state.go('app.pages_auth_login');
                }
                event.preventDefault();
            }

            if(( typeof $localStorage.authToken == 'undefined' || !$localStorage.authToken || $localStorage.authToken=='' || $localStorage.authToken.length === 0) && toState.authenticate != false){
                $localStorage.preUrlOrder = toState.name;
                $localStorage.preUrlData = toStateData;
                delete $localStorage.authToken;
                $state.go('app.pages_auth_login');
                event.preventDefault();
			} else if (toState.authenticate == false && $localStorage.authToken && $localStorage.authToken.length != 0 && toState['name'] != 'app.pages_auth_login'){
                if (redirectState !== '') {
                    $state.go($localStorage.firstTimeRedirectState);
                } else {
                    delete $localStorage.authToken;
                    $state.go('app.pages_auth_login');
                }
				// $state.go('app.dashboards_project');
                event.preventDefault();
            } else {
                $localStorage.preUrlOrder1 = toState.name;
                $localStorage.preUrlData1 = toStateData;
            }
        });
        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function (event, to, toParams, from, fromParams){
            $rootScope.siteTitle = (to.title != undefined && to.title != '') ? to.title + ' - LodgingSystem' : 'Lodging System M';
            var preUrl = angular.copy(from);
        if(preUrl['name'] != 'app.create-res'){
                $rootScope.previousUrl = preUrl['name'];
            }
            var preUrlCreateRes = angular.copy(from);
        if(preUrlCreateRes['name'] != 'app.resCheckout' && preUrlCreateRes['name'] != 'app.create-res' ){
                $rootScope.previousUrlCreateRes = preUrl['name'];
                $localStorage.preUrl = preUrl['name'];
            }
            $rootScope.hotels           = $localStorage.hotels;
            $rootScope.selectedHotel    = $localStorage.selectedHotel;
          if ($localStorage.authToken && $localStorage.authToken.length > 0 && $location.path() !== '/login') {
            injectBotScript();
          } else {
            removeBotScript();
          }

            $timeout(function (){
                $mdDialog.hide();
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;
        $rootScope.updateValue = 'no';

        // Cleanup
        $rootScope.$on('$destroy', function (){
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();

function injectBotScript() {
  if (document.getElementById('chatbot-script')) {
    var attempts = 0;
    var interval = setInterval(function () {
      var chatUI = document.getElementById('chatbot-root');
      if (chatUI) {
        chatUI.style.display = 'block';
        clearInterval(interval);
      }
      attempts++;
      if (attempts > 20) clearInterval(interval);
    }, 100);
    return;
  }
  var script = document.createElement('script');
  script.id = 'chatbot-script';
  script.src = 'https://vvstaging.lodgingsystem.com/pms-bot-app';
  script.setAttribute('mode', 'init');
  script.setAttribute('bubble-left', '18');
  script.setAttribute('bubble-bottom', '12');
  script.setAttribute('chatwindow-bottom', '20');
  script.setAttribute('chatwindow-left', '20');

  document.body.appendChild(script);
}

function removeBotScript() {
  var chatUI = document.getElementById('chatbot-root');
  if (chatUI) chatUI.style.display = 'none';
}

(function() {

        'use strict';
        angular
            .module('fuse')
            .config(routeConfig);
        /** @ngInject */
        function routeConfig($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider, msNavigationServiceProvider, $translatePartialLoaderProvider,KeepaliveProvider,IdleProvider,EnvironmentConfig) {
            $locationProvider.html5Mode(true);
            $httpProvider.interceptors.push(['$localStorage', '$window', '$rootScope', function($localStorage, $window, $rootScope, $q) {
                return {
                    'request': function(config) {
                        config.headers = config.headers || {};
                        var token = $localStorage.authToken;
                        if (typeof $rootScope.userPermissions != 'undefined') {
                            var userPermissions = [];
                            var routePermissions = [];
                            userPermissions = $rootScope.userPermissions;
                            routePermissions = userPermissions.split(',');
                        } else {
                            var userPermissions = [];
                            var routePermissions = [];
                        }
                        // console.log(userPermissions);
                        if (token){
                            $localStorage.preHotelId = $localStorage.hotels[$localStorage.selectedHotel]['hotel_id'];
                            //   config.headers.Authorization = token;
                            config.headers = {
                                authorization: token,
                                current_version: EnvironmentConfig.currentVersion,
                                hotelid: $localStorage.hotels[$localStorage.selectedHotel]['hotel_id']
                            };
                        }else{
                            config.headers = {
                                current_version: EnvironmentConfig.currentVersion
                            };
                        }


                        if (routePermissions.indexOf('front_desk') != -1) {
                            msNavigationServiceProvider.saveItem('dashboard', {
                                title: 'Dashboard',
                                icon: 'icon-view-dashboard',
                                state: 'app.dashboard',
                                weight: 1
                            });
                        } else {
                            msNavigationServiceProvider.deleteItem('dashboard');
                        }

                        // if (routePermissions.indexOf('tape_chart') != -1) {
                        //     msNavigationServiceProvider.saveItem('gantt-chart', {
                        //         title: 'Tape Chart',
                        //         icon: 'icon-gantt-chart',
                        //         state: 'app.dashboards_project',
                        //         weight: 1
                        //     });
                        // } else {
                        //     msNavigationServiceProvider.deleteItem('gantt-chart');
                        // }

                        if (routePermissions.indexOf('tape_chart') != -1) {
                            msNavigationServiceProvider.saveItem('gantt-chart', {
                                title: 'Tape Chart',
                                icon: 'icon-gantt-chart',
                                state: 'app.newGanttChart',
                                weight: 1
                            });
                        } else {
                            msNavigationServiceProvider.deleteItem('gantt-chart');
                        }


                        if (routePermissions.indexOf('reservations') != -1) {
                            msNavigationServiceProvider.saveItem('Reservations', {
                                title: 'Reservations',
                                icon: 'icon-calendar-text',
                                state: 'app.e-commerce.orders',
                                weight: 2
                            });
                        } else {
                            msNavigationServiceProvider.deleteItem('Reservations');
                        }

                        var canViewMessages = routePermissions.indexOf('messages') != -1;
                        var canViewTemplates = routePermissions.indexOf('mc_templates') != -1;
                        var canViewMcSettings = routePermissions.indexOf('mc_settings') != -1;

                        if (canViewMessages || canViewTemplates || canViewMcSettings) {
                            msNavigationServiceProvider.saveItem('message_center', {
                                title: 'Message Center',
                                icon: 'icon-message-text',
                                weight: 2.5
                            });

                            if (canViewMessages) {
                                msNavigationServiceProvider.saveItem('message_center.messages', {
                                    title: 'Messages',
                                    icon: 'icon-message-text',
                                    state: 'app.guest-message-center.messages',
                                    weight: 1
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('message_center.messages');
                                // Clean up legacy nested path if present from older builds.
                                msNavigationServiceProvider.deleteItem('message_center.messages.archive');
                            }

                            if (canViewTemplates) {
                                msNavigationServiceProvider.saveItem('message_center.templates', {
                                    title: 'Templates',
                                    icon: 'icon-file-document',
                                    state: 'app.guest-message-center.templates',
                                    weight: 2
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('message_center.templates');
                            }

                            if (canViewMcSettings) {
                                msNavigationServiceProvider.saveItem('message_center.triggers', {
                                    title: 'Triggers',
                                    icon: 'icon-flash',
                                    state: 'app.settings_triggers',
                                    weight: 3
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('message_center.triggers');
                            }

                            // Archive sits after Triggers in the Message Center nav.
                            if (canViewMessages) {
                                msNavigationServiceProvider.saveItem('message_center.archive', {
                                    title: 'Archive',
                                    icon: 'icon-archive',
                                    state: 'app.guest-message-center.archive',
                                    weight: 4
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('message_center.archive');
                            }

                            msNavigationServiceProvider.deleteItem('message_center.settings');
                            msNavigationServiceProvider.deleteItem('message_center.broadcast');
                            msNavigationServiceProvider.deleteItem('message_center.messages.archive');
                        } else {
                            msNavigationServiceProvider.deleteItem('message_center');
                            msNavigationServiceProvider.deleteItem('message_center.messages');
                            msNavigationServiceProvider.deleteItem('message_center.archive');
                            msNavigationServiceProvider.deleteItem('message_center.messages.archive');
                            msNavigationServiceProvider.deleteItem('message_center.settings');
                            msNavigationServiceProvider.deleteItem('message_center.triggers');
                            msNavigationServiceProvider.deleteItem('message_center.templates.quick_reply');
                            msNavigationServiceProvider.deleteItem('message_center.templates');
                            msNavigationServiceProvider.deleteItem('message_center.broadcast');
                        }

                        msNavigationServiceProvider.deleteItem('guest-message-center');

                        /*if ($localStorage.preHotelId === '126') {
                            if (routePermissions.indexOf('reservations') != -1 && routePermissions.indexOf('boats') != -1) {
                                msNavigationServiceProvider.saveItem('boat_room_orders', {
                                    title: 'Boat Room Reservations',
                                    icon: 'icon-calendar-text',
                                    state: 'app.e-commerce.boatRoomOrders',
                                    weight: 2
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('boat_room_orders');
                            }
                        }*/

                        /*Show Revenue Section in Admin*/
                        if ((routePermissions.indexOf('Revenue') != -1 || routePermissions.indexOf('rate_calendar') != -1) ) {
                            msNavigationServiceProvider.saveItem('revenue_management', {
                                title: 'Revenue Management',
                                icon: 'icon-revenue-management',
                                weight: 3
                            });
                            if (routePermissions.indexOf('Revenue') != -1) {
                                msNavigationServiceProvider.saveItem('revenue_management.Revenue', {
                                    title: 'Dashboard',
                                    icon: 'icon-view-dashboard',
                                    state: 'app.revenue',
                                    weight: 1
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('revenue_management.Revenue');
                            }
                            if (routePermissions.indexOf('rate_calendar') != -1) {
                                msNavigationServiceProvider.saveItem('revenue_management.rateCategory', {
                                    title: 'Rate Calendar',
                                    icon: 'icon-currency-usd',
                                    state: 'app.rateCal',
                                    weight: 2
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('revenue_management.rateCategory');
                            }

                            if (routePermissions.indexOf('rate_calendar') != -1 && $localStorage.preHotelId === '126') {
                                msNavigationServiceProvider.saveItem('revenue_management.negotiatedRates', {
                                    title: 'Negotiated Rate Calendar',
                                    icon: 'icon-currency-usd',
                                    state: 'app.negotiatedRateRule',
                                    weight: 3
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('revenue_management.negotiatedRates');
                            }
                        } else {
                            msNavigationServiceProvider.deleteItem('revenue_management');
                            msNavigationServiceProvider.deleteItem('revenue_management.Revenue');
                            msNavigationServiceProvider.deleteItem('revenue_management.rateCategory');
                            msNavigationServiceProvider.deleteItem('revenue_management.negotiatedRates');
                        }
                        /*End Revenue Section in Admin*/


                         /*Boat Links*/
                        /*if (routePermissions.indexOf('boats') != -1) {
                            msNavigationServiceProvider.saveItem('boats', {
                                title: 'Marina',
                                icon: 'icon-boat',
                                weight: 3
                            });
                            msNavigationServiceProvider.saveItem('boats.boatsGannChart', {
                                title: 'Tape Chart',
                                icon: 'icon-boat',
                                state: 'app.boat_gannChartNew',
                                weight: 1
                            });

                            msNavigationServiceProvider.saveItem('boats.boatOrders', {
                                title: 'Marina Reservations',
                                icon: 'icon-boat',
                                state: 'app.e-commerce.boatOrders',
                                weight: 2
                            });

                        } else {
                            msNavigationServiceProvider.deleteItem('boats');
                            msNavigationServiceProvider.deleteItem('boats.boatsGannChart');
                        }*/
                        /*Boat Links*/

                      if (routePermissions.indexOf('retail') != -1) {
                              var nameChange = ($localStorage.preHotelId !== undefined && ($localStorage.preHotelId === '126' || $localStorage.preHotelId === '122')) ? 'Gift Shop' : 'Retail';
                              msNavigationServiceProvider.saveItem('retail', {
                                  title: nameChange,
                                  icon: 'icon-basket',
                                  state: 'app.checkout',
                                  weight: 3
                              });
                          }else {
                              msNavigationServiceProvider.deleteItem('retail');
                        }



                         /*Room Rent Links*/
                        if (routePermissions.indexOf('residence') != -1) {
                            msNavigationServiceProvider.saveItem('rent', {
                                title: 'Residence',
                                icon: 'icon-city',
                                weight: 3
                            });
                            msNavigationServiceProvider.saveItem('rent.rentChart', {
                                title: 'Residence Chart',
                                icon: 'icon-city',
                                state: 'app.rentGanttchartNew',
                                weight: 1
                            });

                            msNavigationServiceProvider.saveItem('rent.rentOrders', {
                                title: 'Rental Reservations',
                                icon: 'icon-city',
                                state: 'app.e-commerce.rentOrders',
                                weight: 2
                            });
                             msNavigationServiceProvider.saveItem('rent.rentApplications', {
                                title: 'Applications',
                                icon: 'icon-clipboard-text',
                                state: 'app.rentalListing',
                                weight: 3
                            });

                        } else {
                            msNavigationServiceProvider.deleteItem('rent');
                            msNavigationServiceProvider.deleteItem('rent.rentChart');
                            msNavigationServiceProvider.deleteItem('boats.rentOrders');
                            msNavigationServiceProvider.deleteItem('boats.rentApplications');
                        }
                        /*Room Rent Links*/





                        if (routePermissions.indexOf('restaurantsdfs') != -1) {
                            msNavigationServiceProvider.saveItem('restaurant', {
                                title: 'Food & Drinks',
                                icon: 'icon-food',
                                weight: 4
                            });

                            if (routePermissions.indexOf('restaurant_checkout') != -1) {
                                msNavigationServiceProvider.saveItem('restaurant.checkout', {
                                    title: 'Open Check',
                                    icon: 'icon-basket',
                                    state: 'app.restaurant',
                                    weight: 1
                                });
                            }else{
                                msNavigationServiceProvider.deleteItem('restaurant.checkout');
                            }

                            if (routePermissions.indexOf('restaurant_settings_o') != -1) {
                                msNavigationServiceProvider.saveItem('restaurant.orders', {
                                    title: 'Orders',
                                    icon: 'icon-cart',
                                    state: 'app.restaurant-orders',
                                    weight: 3
                                });
                            }else{
                                msNavigationServiceProvider.deleteItem('restaurant.orders');
                            }
                        } else {
                            msNavigationServiceProvider.deleteItem('restaurant');
                            msNavigationServiceProvider.deleteItem('restaurant.checkout');
                            msNavigationServiceProvider.deleteItem('restaurant.orders');
                            msNavigationServiceProvider.deleteItem('restaurant.settings');
                            msNavigationServiceProvider.deleteItem('restaurant.details');
                        }


                        if (routePermissions.indexOf('bar') != -1) {
                            var nameChange = ($localStorage.preHotelId !== undefined && $localStorage.preHotelId === '126') ? 'Food & Drinks' : 'Bar';
                            var itemNameChange = ($localStorage.preHotelId !== undefined && $localStorage.preHotelId === '126') ? 'Open Check' : 'Checkout';
                            msNavigationServiceProvider.saveItem('bar', {
                                title: nameChange,
                                icon: 'icon-glass-mug',
                                weight: 5
                            });

                            if (routePermissions.indexOf('bar') != -1) {
                                msNavigationServiceProvider.saveItem('bar.checkout', {
                                    title: itemNameChange,
                                    icon: 'icon-basket',
                                    state: 'app.bar',
                                    weight: 1
                                });
                            } else {
                               msNavigationServiceProvider.deleteItem('bar.checkout');
                            }

                            if (routePermissions.indexOf('tab_orders') != -1) {
                                msNavigationServiceProvider.saveItem('bar.tab-order', {
                                    title: 'Tab Orders',
                                    icon: 'icon-cart-outline',
                                    state: 'app.tab-order',
                                    weight: 2
                                });
                            }else{
                                msNavigationServiceProvider.deleteItem('bar.tab-order');
                            }

                            if (routePermissions.indexOf('bar_orders') != -1) {
                                msNavigationServiceProvider.saveItem('bar.orders', {
                                    title: 'Orders',
                                    icon: 'icon-cart',
                                    state: 'app.pos-orders',
                                    weight: 3
                                });
                            }else{
                                msNavigationServiceProvider.deleteItem('bar.orders');
                            }



                            if (routePermissions.indexOf('restaurant_settings') != -1) {
                                msNavigationServiceProvider.saveItem('bar.restaurant_settings', {
                                    title: 'Restaurant Settings',
                                    icon: 'icon-cog',
                                    state: 'app.restaurant-settings',
                                    weight: 5
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('bar.restaurant_settings');
                            }
                        } else {
                            msNavigationServiceProvider.deleteItem('bar');
                            msNavigationServiceProvider.deleteItem('bar.checkout');
                            msNavigationServiceProvider.deleteItem('bar.tab-order');
                            msNavigationServiceProvider.deleteItem('bar.orders');
                            // msNavigationServiceProvider.deleteItem('bar.reports');
                            msNavigationServiceProvider.deleteItem('bar.restaurant_settings');
                        }

                        if (routePermissions.indexOf('customers') != -1) {
                            msNavigationServiceProvider.saveItem('customers', {
                                title: 'Customers',
                                icon: 'icon-account-box',
                                state: 'app.contacts',
                                weight: 6
                            });
                        } else {
                            msNavigationServiceProvider.deleteItem('customers');
                        }

                        if (routePermissions.indexOf('customers') != -1 && $localStorage.preHotelId === '126') {
                            msNavigationServiceProvider.saveItem('negotiatedCustomers', {
                                title: 'Negotiated Customers',
                                icon: 'icon-account-box',
                                state: 'app.negotiatedCustomers',
                                weight: 6
                            });
                        } else {
                            msNavigationServiceProvider.deleteItem('negotiatedCustomers');
                        }

                        if (routePermissions.indexOf('gift_cards') != -1) {
                            catalog_nav++;
                            msNavigationServiceProvider.saveItem('gcadmins', {
                                title: 'Gift Cards',
                                icon: 'icon-wallet-giftcard',
                                state: 'app.e-commerce.gcadmins',
                                weight: 7
                            });
                        } else {
                            msNavigationServiceProvider.deleteItem('gcadmins');
                        }

                        /*if (routePermissions.indexOf('tasks') != -1) {
                            msNavigationServiceProvider.saveItem('to-do', {
                                title: 'Tasks',
                                icon: 'icon-checkbox-marked',
                                state: 'app.to-do',
                                weight: 8
                            });
                        } else {
                            msNavigationServiceProvider.deleteItem('to-do');
                        }*/

                        if (routePermissions.indexOf('housekeeping-dashboard') != -1 || routePermissions.indexOf('tasks') != -1) {
                            msNavigationServiceProvider.saveItem('housekeeping', {
                                title: 'Housekeeping',
                                icon: 'icon-broom',
                                state: 'app.housekeeping-dashboard',
                                weight: 10
                            });
                        } else {
                            msNavigationServiceProvider.deleteItem('housekeeping');
                        }

                        if (routePermissions.indexOf('hotel') != -1 || routePermissions.indexOf('products') != -1 || routePermissions.indexOf('rates') != -1 || routePermissions.indexOf('permissions') != -1) {
                            msNavigationServiceProvider.saveItem('admin', {
                                title: 'Admin',
                                icon: 'icon-apps',
                                weight: 11
                            });
                            if (routePermissions.indexOf('hotel') != -1) {
                                msNavigationServiceProvider.saveItem('admin.hotel', {
                                    title: 'Hotel',
                                    icon: 'icon-hotel',
                                    weight: 1

                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.hotel');
                            }
                            // if (routePermissions.indexOf('hotel_remove') != -1) {
                            //     msNavigationServiceProvider.saveItem('admin.hotel.quickBook', {
                            //         title: 'Quick Book',
                            //         icon: 'icon-hotel',
                            //         state: 'external',
                            //         weight: 1
                            //     });
                            // } else {
                            //     msNavigationServiceProvider.deleteItem('admin.hotel.quickBook');
                            // }


                            if (routePermissions.indexOf('rate_policies') != -1) {
                                msNavigationServiceProvider.saveItem('admin.hotel.policy', {
                                    title: 'Policies',
                                    icon: 'icon-lock',
                                    state: 'app.policy',
                                    weight: 1

                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.hotel.policy');
                            }


                            if (routePermissions.indexOf('amenities') != -1) {
                                msNavigationServiceProvider.saveItem('admin.hotel.Amenities', {
                                    title: 'Amenities',
                                    icon: 'icon-hotel',
                                    weight: 2
                                });
                                if (routePermissions.indexOf('property_amenities') != -1) {
                                    msNavigationServiceProvider.saveItem('admin.hotel.Amenities.Property', {
                                        title: 'Property',
                                        icon: 'icon-hotel',
                                        state: 'app.e-commerce.amenities',
                                        weight: 1
                                    });
                                } else {
                                    msNavigationServiceProvider.deleteItem('admin.hotel.Amenities.Property');
                                }
                                if (routePermissions.indexOf('all_room_amenities') != -1) {
                                    msNavigationServiceProvider.saveItem('admin.hotel.Amenities.Allrooms', {
                                        title: 'Rooms',
                                        icon: 'icon-hotel',
                                        state: 'app.e-commerce.hotelamenities',
                                        weight: 2
                                    });
                                } else {
                                    msNavigationServiceProvider.deleteItem('admin.hotel.Amenities.Allrooms');
                                }
                                if (routePermissions.indexOf('boats') != -1) {
                                    msNavigationServiceProvider.saveItem('admin.hotel.Amenities.Allboats', {
                                        title: 'Slips',
                                        icon: 'icon-boat',
                                        state: 'app.e-commerce.boatamenities',
                                        weight: 3
                                    });
                                } else {
                                    msNavigationServiceProvider.deleteItem('admin.hotel.Amenities.Allboats');
                                }
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.hotel.Amenities');
                                msNavigationServiceProvider.deleteItem('admin.hotel.Amenities.Property');
                                msNavigationServiceProvider.deleteItem('admin.hotel.Amenities.Allrooms');
                                msNavigationServiceProvider.deleteItem('admin.hotel.Amenities.Allboats');
                            }

                            if (routePermissions.indexOf('taxes') != -1) {
                                msNavigationServiceProvider.saveItem('admin.hotel.taxes', {
                                    title: 'Taxes & Fees',
                                    state: 'app.e-commerce.taxes',
                                    icon: 'icon-percent',
                                    weight: 3
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.hotel.taxes');
                            }

                            // if (routePermissions.indexOf('gift_card') != -1) {
                            //     msNavigationServiceProvider.saveItem('admin.hotel.giftcard', {
                            //         title: 'Gift card',
                            //         icon: 'icon-wallet-giftcard',
                            //         weight: 4
                            //     });
                            // } else {
                            //     msNavigationServiceProvider.deleteItem('admin.hotel.giftcard');
                            // }

                            // if (routePermissions.indexOf('tape_chart') != -1) {
                            //     msNavigationServiceProvider.saveItem('admin.hotel.newGanttChart', {
                            //         title: 'Modified Gantt Chart',
                            //         icon: 'icon-gantt-chart',
                            //         state: 'app.newGanttChart',
                            //         weight: 4
                            //     });
                            // } else {
                            //     msNavigationServiceProvider.deleteItem('admin.hotel.newGanttChart');
                            // }

                            if (routePermissions.indexOf('gift_card_settings') != -1) {
                                msNavigationServiceProvider.saveItem('admin.hotel.settings', {
                                    title: 'Gift Card Settings',
                                    icon: 'icon-wallet-giftcard',
                                    state: 'app.e-commerce.giftcards',
                                    weight: 5
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.hotel.giftcard.setting');
                            }


                            // if (routePermissions.indexOf('gift_card_settings') != -1) {
                            //     catalog_nav++;
                            //     msNavigationServiceProvider.saveItem('admin.hotel.giftcard.settings', {
                            //         title: 'Settings',
                            //         icon: 'icon-wallet-giftcard',
                            //         state: 'app.e-commerce.giftcards',
                            //         weight: 2
                            //     });
                            // } else {
                            //     msNavigationServiceProvider.deleteItem('admin.hotel.giftcard.settings');
                            // }
                            if (routePermissions.indexOf('products') != -1) {
                                catalog_nav++;
                                msNavigationServiceProvider.saveItem('admin.activities', {
                                    title: 'Products',
                                    icon: 'activity-icon-service-icon',
                                    state: 'app.e-commerce.activities',
                                    weight: 2
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.activities');
                            }

                            if (routePermissions.indexOf('boats') != -1) {
                                catalog_nav++;
                                msNavigationServiceProvider.saveItem('admin.boatactivities', {
                                    title: 'Slip Products',
                                    icon: 'icon-boat',
                                    state: 'app.e-commerce.boat-activities',
                                    weight: 2
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.boatactivities');
                            }

                            var catalog_nav = 0;
                            if (routePermissions.indexOf('rooms') != -1) {
                                catalog_nav++;
                                msNavigationServiceProvider.saveItem('admin.roomtypes', {
                                    title: 'Rooms',
                                    icon: 'icon-hotel',
                                    state: 'app.e-commerce.roomtypes',
                                    weight: 3
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.roomtypes');
                            }

                            if (routePermissions.indexOf('boats') != -1) {
                                catalog_nav++;
                                msNavigationServiceProvider.saveItem('admin.boats', {
                                    title: 'Slips',
                                    icon: 'icon-boat',
                                    state: 'app.e-commerce.boattypes',
                                    weight: 4
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.boats');
                            }


                            if (routePermissions.indexOf('bundle_rooms') != -1) {
                                catalog_nav++;
                                msNavigationServiceProvider.saveItem('admin.bundle', {
                                    title: 'Bundle Rooms',
                                    icon: 'icon-group',
                                    state: 'app.e-commerce.bundlerooms',
                                    weight: 5
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.bundle');
                            }

                            if (routePermissions.indexOf('boats') != -1 && $localStorage.preHotelId === '126') {
                                catalog_nav++;
                                msNavigationServiceProvider.saveItem('admin.bundleboats', {
                                    title: 'Bundle Slips',
                                    icon: 'icon-boat',
                                    state: 'app.e-commerce.bundleboats',
                                    weight: 5
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.bundleboats');
                            }

                            if (routePermissions.indexOf('room_precedence_config') != -1 || routePermissions.indexOf('room_precedence_sheet_prices') != -1) {
                                catalog_nav++;
                                msNavigationServiceProvider.saveItem('admin.roomPrecedence', {
                                    title: 'Room Precedence',
                                    icon: 'icon-hotel',
                                    weight: 6
                                });

                                if( routePermissions.indexOf('room_precedence_config') != -1) {

                                    msNavigationServiceProvider.saveItem('admin.roomPrecedence.config', {
                                        title: 'Config',
                                        icon: 'icon-cog',
                                        state: 'app.room-precedence',
                                        weight: 1
                                    });
                                }

                                if( routePermissions.indexOf('room_precedence_sheet_prices') != -1) {
                                    msNavigationServiceProvider.saveItem('admin.roomPrecedence.sheetPrices', {
                                        title: 'Sheet Prices',
                                        icon: 'icon-file-document',
                                        state: 'app.room-precedence-sheet-prices',
                                        weight: 2
                                    });
                                }
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.roomPrecedence');
                                msNavigationServiceProvider.deleteItem('admin.roomPrecedence.config');
                                msNavigationServiceProvider.deleteItem('admin.roomPrecedence.sheetPrices');
                            }

                            if (routePermissions.indexOf('rates') != -1) {
                                msNavigationServiceProvider.saveItem('admin.rates', {
                                    title: 'Rates',
                                    icon: 'icon-currency-usd',
                                    weight: 7
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.rates');
                            }

                            if (routePermissions.indexOf('channels') != -1) {
                                    msNavigationServiceProvider.saveItem('admin.rates.Channels', {
                                    title: 'Channels',
                                    icon: 'icon-link',
                                    state: 'app.channels',
                                    weight: 1
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.rates.Channels');
                            }

                            if (routePermissions.indexOf('rate_calendar') != -1) {
                                msNavigationServiceProvider.saveItem('admin.rates.rateCategory', {
                                    title: 'Rate Calendar',
                                    icon: 'icon-currency-usd',
                                    state: 'app.rateRule',
                                    weight: 2
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.rates.rateCategory');
                            }

                            if (routePermissions.indexOf('rate_calendar_logs') != -1) {
                                msNavigationServiceProvider.saveItem('admin.rates.rateCalendarLogs', {
                                    title: 'Rate Calendar Logs',
                                    icon: 'icon-link',
                                    state: 'app.rateCalendarLogs',
                                    weight: 3
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.rates.rateCalendarLogs');
                            }

                            if (routePermissions.indexOf('rate_rules') != -1) {
                                msNavigationServiceProvider.saveItem('admin.rates.raterules', {
                                    title: 'Rate Rules',
                                    icon: 'icon-currency-usd',
                                    state: 'app.rateCategory',
                                    weight: 4
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.rates.raterules');
                            }

                            if (routePermissions.indexOf('promotions') != -1) {
                                msNavigationServiceProvider.saveItem('admin.rates.promotions', {
                                    title: 'Promotions',
                                    state: 'app.promotions',
                                    icon: 'icon-sale',
                                    weight: 5
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.rates.promotions');
                            }

                            /*if (routePermissions.indexOf('restrictions') != -1) {
                                msNavigationServiceProvider.saveItem('admin.rates.mls', {
                                    title: 'Restrictions',
                                    icon: 'icon-calendar-select',
                                    state: 'app.mls',
                                    weight: 5

                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.rates.mls');
                            }*/


                            if (routePermissions.indexOf('permissions') != -1) {
                                var permissions_count = 1;
                                msNavigationServiceProvider.saveItem('admin.permissions', {
                                    title: 'Permissions',
                                    icon: 'icon-key-variant',
                                    weight: 7
                                });
                                if (routePermissions.indexOf('hotels') != -1) {
                                    msNavigationServiceProvider.saveItem('admin.permissions.hotels', {
                                        title: 'Hotels',
                                        icon: 'icon-domain',
                                        state: 'app.permissions_organizations',
                                        weight: 1
                                    });
                                } else {
                                    msNavigationServiceProvider.deleteItem('admin.permissions.hotels');
                                }
                                if (routePermissions.indexOf('roles') != -1) {
                                    msNavigationServiceProvider.saveItem('admin.permissions.roles', {
                                        title: 'Roles',
                                        icon: 'icon-account-box',
                                        state: 'app.roles',
                                        weight: 2
                                    });
                                } else {
                                    msNavigationServiceProvider.deleteItem('admin.permissions.roles');
                                }
                                if (routePermissions.indexOf('users') != -1) {
                                    msNavigationServiceProvider.saveItem('admin.permissions.adminusers', {
                                        title: 'Users',
                                        icon: 'icon-account-box',
                                        state: 'app.permissions_adminusers',
                                        weight: 3
                                    });
                                } else {
                                    msNavigationServiceProvider.deleteItem('admin.permissions.adminusers');
                                }

                                if (routePermissions.indexOf('groups') != -1) {
                                    msNavigationServiceProvider.saveItem('admin.permissions.groups', {
                                        title: 'Groups',
                                        icon: 'icon-account-multiple',
                                        state: 'app.groups',
                                        weight: 4
                                    });
                                } else {
                                    msNavigationServiceProvider.deleteItem('admin.permissions.groups');
                                }
                                if (routePermissions.indexOf('teams') != -1) {
                                    msNavigationServiceProvider.saveItem('admin.permissions.team', {
                                        title: 'Teams',
                                        icon: 'icon-account-multiple',
                                        state: 'app.team',
                                        weight: 5
                                    });
                                } else {
                                    msNavigationServiceProvider.deleteItem('admin.permissions.team');
                                }
                            } else {
                                msNavigationServiceProvider.deleteItem('admin.permissions');
                                msNavigationServiceProvider.deleteItem('admin.permissions.hotels');
                                msNavigationServiceProvider.deleteItem('admin.permissions.roles');
                                msNavigationServiceProvider.deleteItem('admin.permissions.adminusers');
                                msNavigationServiceProvider.deleteItem('admin.permissions.groups');
                                msNavigationServiceProvider.deleteItem('admin.permissions.team');
                            }
                        } else {
                            msNavigationServiceProvider.deleteItem('admin');
                            msNavigationServiceProvider.deleteItem('admin.hotel');
                            msNavigationServiceProvider.deleteItem('admin.hotel.policy');
                            msNavigationServiceProvider.deleteItem('admin.hotel.Amenities');
                            msNavigationServiceProvider.deleteItem('admin.hotel.Amenities.Property');
                            msNavigationServiceProvider.deleteItem('admin.hotel.Amenities.Allrooms');
                            msNavigationServiceProvider.deleteItem('admin.hotel.Amenities.Allboats');
                            msNavigationServiceProvider.deleteItem('admin.hotel.taxes');
                            msNavigationServiceProvider.deleteItem('admin.hotel.giftcard');
                            msNavigationServiceProvider.deleteItem('admin.hotel.giftcard.gcadmins');
                            msNavigationServiceProvider.deleteItem('admin.hotel.giftcard.settings');
                            msNavigationServiceProvider.deleteItem('admin.activities');
                            msNavigationServiceProvider.deleteItem('admin.roomtypes');
                            msNavigationServiceProvider.deleteItem('admin.boats');
                            msNavigationServiceProvider.deleteItem('admin.boatsGannChart');
                            msNavigationServiceProvider.deleteItem('admin.rates');
                            msNavigationServiceProvider.deleteItem('admin.rates.Channels');
                            msNavigationServiceProvider.deleteItem('admin.rates.rateCategory');
                            msNavigationServiceProvider.deleteItem('admin.rates.rateCalendarLogs')
                            msNavigationServiceProvider.deleteItem('admin.rates.raterules');
                            msNavigationServiceProvider.deleteItem('admin.rates.promotions');
                            // msNavigationServiceProvider.deleteItem('admin.rates.mls');
                            msNavigationServiceProvider.deleteItem('admin.permissions');
                            msNavigationServiceProvider.deleteItem('admin.permissions.hotels');
                            msNavigationServiceProvider.deleteItem('admin.permissions.roles');
                            msNavigationServiceProvider.deleteItem('admin.permissions.adminusers');
                            msNavigationServiceProvider.deleteItem('admin.permissions.groups');
                            msNavigationServiceProvider.deleteItem('admin.permissions.team');
                        }

                        /*Route For Reports Start*/




                        if (routePermissions.indexOf('system_reports') != -1 || routePermissions.indexOf('bar_reports') != -1) {
                            msNavigationServiceProvider.saveItem('reports', {
                                title: 'Reports',
                                icon: 'icon-chart-areaspline',
                                weight: 12
                            });

                            if (routePermissions.indexOf('lodging_statistic') != -1) {
                                /*if ($localStorage.preHotelId === '126' || $localStorage.preHotelId === '116' || $localStorage.preHotelId === '121' || $localStorage.preHotelId === '128') {*/
                                    msNavigationServiceProvider.saveItem('reports.lodging-statistic-new', {
                                        title: 'Lodging Statistics',
                                        icon: 'icon-chart-line',
                                        state: 'app.reports.lodging_statistic_new',
                                        weight: 1
                                    });
                                    msNavigationServiceProvider.deleteItem('reports.lodging-statistic');
                                /*} else {
                                    msNavigationServiceProvider.saveItem('reports.lodging-statistic', {
                                        title: 'Lodging Statistics',
                                        icon: 'icon-chart-line',
                                        state: 'app.reports.lodging_statistic',
                                        weight: 1
                                    });
                                    msNavigationServiceProvider.deleteItem('reports.lodging-statistic-new');
                                }*/
                            } else {
                                // msNavigationServiceProvider.deleteItem('reports.lodging-statistic');
                                msNavigationServiceProvider.deleteItem('reports.lodging-statistic-new');
                            }


                            if (routePermissions.indexOf('departure_invoices') != -1) {
                                msNavigationServiceProvider.saveItem('reports.departure-invoices', {
                                    title: 'Departure Invoices',
                                    icon: 'icon-arrow-right-bold-circle',
                                    state: 'app.reports.departure_invoices',
                                    weight: 2
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.departure-invoices');
                            }


                            if (routePermissions.indexOf('housekeeping') != -1) {
                                msNavigationServiceProvider.saveItem('reports.housekeeping', {
                                    title: 'Housekeeping',
                                    icon: 'icon-broom',
                                    state: 'app.reports.housekeeping',
                                    weight: 3
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.housekeeping');
                            }
                            // if (routePermissions.indexOf('light_cleaning') != -1) {
                            //     msNavigationServiceProvider.saveItem('reports.light-cleaning', {
                            //         title: 'Light Cleaning',
                            //         icon: 'icon-light-cleaning-grey',
                            //         state: 'app.reports.light-cleaning',
                            //         weight: 4
                            //     });
                            // } else {
                            //     msNavigationServiceProvider.deleteItem('reports.light-cleaning');
                            // }

                            if (routePermissions.indexOf('income_reports') != -1) {
                                msNavigationServiceProvider.saveItem('reports.income-reports', {
                                    title: 'Income',
                                    icon: 'icon-currency-usd',
                                    state: 'app.reports.income-reports',
                                    weight: 4
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.income-reports');
                            }

                            if (routePermissions.indexOf('room_moves') != -1) {
                                msNavigationServiceProvider.saveItem('reports.room-moves', {
                                    title: 'Room Moves',
                                    icon: 'icon-border-vertical',
                                    state: 'app.reports.room-moves',
                                    weight: 5
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.room-moves');
                            }

                            if (routePermissions.indexOf('customer_advanced_deposit') != -1) {
                                msNavigationServiceProvider.saveItem('reports.customer-advanced-deposit', {
                                    title: 'Advanced Deposits',
                                    icon: 'icon-currency-usd',
                                    state: 'app.reports.customer-advanced-deposit',
                                    weight: 6
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.customer-advanced-deposit');
                            }


                            if (routePermissions.indexOf('payments_by_employee') != -1) {
                                msNavigationServiceProvider.saveItem('reports.payments-by-employee', {
                                    title: 'Payments by Employee',
                                    icon: 'icon-currency-usd',
                                    state: 'app.reports.payments-by-employee',
                                    weight: 7
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.payments-by-employee');
                            }


                            if (routePermissions.indexOf('gift_certificates') != -1) {
                                msNavigationServiceProvider.saveItem('reports.gift-certificates', {
                                    title: 'Gift Certificates',
                                    icon: 'icon-wallet-giftcard',
                                    state: 'app.reports.gift-certificates',
                                    weight: 8
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.gift-certificates');
                            }

                            if (routePermissions.indexOf('payment_received') != -1) {
                                msNavigationServiceProvider.saveItem('reports.payment-received', {
                                    title: 'Payment Received',
                                    icon: 'icon-currency-usd',
                                    state: 'app.reports.payment-received',
                                    weight: 9
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.payment-received');
                            }

                            if(routePermissions.indexOf('retail_report') != -1) {
                                msNavigationServiceProvider.saveItem('reports.retail-report', {
                                    title: 'POS Report',
                                    icon: 'icon-basket',
                                    state: 'app.reports.retail-report',
                                    weight: 10
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.retail-report');
                            }

                            if(routePermissions.indexOf('tax_report') != -1) {
                                msNavigationServiceProvider.saveItem('reports.tax-report-new', {
                                    title: 'Tax Report',
                                    icon: 'icon-currency-usd',
                                    state: 'app.reports.tax-report-new',
                                    weight: 11
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.tax-report-new');

                            }

                            if(routePermissions.indexOf('night_audit_report') != -1) {
                                msNavigationServiceProvider.saveItem('reports.night-audit-new', {
                                    title: 'Night Audit',
                                    icon: 'icon-weather-night',
                                    state: 'app.reports.night-audit-new',
                                    weight: 12
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.night-audit-new');
                            }


                            if(routePermissions.indexOf('night_audit_short_report') != -1) {
                                msNavigationServiceProvider.saveItem('reports.night-audit-short', {
                                    title: 'Night Audit Short Report',
                                    icon: 'icon-weather-night',
                                    state: 'app.reports.night-audit-short',
                                    weight: 13
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.night-audit-short');
                            }
                            if(routePermissions.indexOf('arrival_registration_card') != -1) {
                               msNavigationServiceProvider.saveItem('reports.arrival-registration-card', {
                                    title: 'Arrival Registration Card',
                                    icon: 'icon-arrival-registration-card',
                                    state: 'app.reports.arrival-registration-card',
                                    weight: 14
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.arrival-registration-card');
                            }

                            if(routePermissions.indexOf('m3_report') != -1 && $localStorage.preHotelId === '126') {
                                msNavigationServiceProvider.saveItem('reports.m3-report', {
                                    title: 'm3 Report',
                                    icon: 'icon-weather-night',
                                    state: 'app.reports.m3-report',
                                    weight: 15
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.m3-report');
                            }


                             if (routePermissions.indexOf('bar_reports') != -1) {
                                msNavigationServiceProvider.saveItem('reports.food/barreport', {
                                    title: 'Food/Bar Reports',
                                    icon: 'icon-chart-areaspline',
                                    state: 'app.pos-reports',
                                    weight: 16
                                });
                            }else{
                                msNavigationServiceProvider.deleteItem('reports.food/barreport');
                            }

                            if(routePermissions.indexOf('m3_report') != -1 && $localStorage.preHotelId === '126' && routePermissions.indexOf('generate_invoice') != -1) {
                                msNavigationServiceProvider.saveItem('reports.m3-report-new', {
                                    title: 'm3 Report New',
                                    icon: 'icon-weather-night',
                                    state: 'app.reports.m3-report-new',
                                    weight: 17
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.m3-report-new');
                            }

                            if(routePermissions.indexOf('sales_by_employee') != -1) {
                                msNavigationServiceProvider.saveItem('reports.sales_by_employee', {
                                    title: 'Sales By Employee',
                                    icon: 'icon-currency-usd',
                                    state: 'app.reports.sales_by_employee',
                                    weight: 18
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.sales_by_employee');
                            }

                            // Reconcillation Report
                            if(routePermissions.indexOf('reconciliation') != -1) {
                                msNavigationServiceProvider.saveItem('reports.reconciliation', {
                                    title: 'Reconcillation Report',
                                    icon: 'icon-briefcase-checked',
                                    state: 'app.reports.reconciliation',
                                    weight: 19
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.reconciliation');
                            }
                            if (routePermissions.indexOf('out_of_order_report') != -1) {
                                msNavigationServiceProvider.saveItem('reports.custom-reports', {
                                    title: 'Out of Order Report',
                                    icon: 'icon-chart-line',
                                    state: 'app.reports.custom_reports',
                                    weight: 20
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.custom-reports');
                            }

                            if (routePermissions.indexOf('availability_report') != -1) {
                                msNavigationServiceProvider.saveItem('reports.availability-report', {
                                    title: 'Availability Report',
                                    icon: 'icon-chart-line',
                                    state: 'app.reports.availability_report',
                                    weight: 20
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.availability-report');
                            }
                            // if(true) {
                            //     msNavigationServiceProvider.saveItem('reports.reservation-due-report', {
                            //         title: 'Reservation Dues',
                            //         icon: 'icon-currency-usd',
                            //         state: 'app.reports.reservation-due-report',
                            //         weight: 15
                            //     });
                            // } else {
                            //     msNavigationServiceProvider.deleteItem('reports.reservation-due-report');
                            // }
                            // if(true) {
                            //     msNavigationServiceProvider.saveItem('reports.zero-daily-rate', {
                            //         title: 'Zero Daily Rate',
                            //         icon: 'icon-currency-usd',
                            //         state: 'app.reports.zero-daily-rate',
                            //         weight: 15
                            //     });
                            // } else {
                            //     msNavigationServiceProvider.deleteItem('reports.zero-daily-rate');
                            // }
                            if (routePermissions.indexOf('promo_reports') != -1) {
                                msNavigationServiceProvider.saveItem('reports.promo-reports', {
                                    title: 'Promo Reports',
                                    icon: 'icon-sale',
                                    state: 'app.reports.promo-reports',
                                    weight: 22
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.promo-reports');
                            }

                            // Courtesy Hold Report — last in Reports menu
                            if (routePermissions.indexOf('courtesy_hold_report') != -1) {
                                msNavigationServiceProvider.saveItem('reports.hold-report', {
                                    title: 'Courtesy Hold Report',
                                    icon: 'icon-calendar-clock',
                                    state: 'app.reports.hold-report',
                                    weight: 23
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('reports.hold-report');
                            }
                        } else {
                            msNavigationServiceProvider.deleteItem('reports');
                            msNavigationServiceProvider.deleteItem('reports.lodging-statistic');
                            msNavigationServiceProvider.deleteItem('reports.departure-invoices');
                            msNavigationServiceProvider.deleteItem('reports.housekeeping');
                            //msNavigationServiceProvider.deleteItem('reports.light-cleaning');
                            msNavigationServiceProvider.deleteItem('reports.income-reports');
                            msNavigationServiceProvider.deleteItem('reports.room-moves');
                            msNavigationServiceProvider.deleteItem('reports.customer-advanced-deposit');
                            msNavigationServiceProvider.deleteItem('reports.payments-by-employee');
                            msNavigationServiceProvider.deleteItem('reports.gift-certificates');
                            msNavigationServiceProvider.deleteItem('reports.payment-received');
                            msNavigationServiceProvider.deleteItem('reports.retail-report');
                            msNavigationServiceProvider.deleteItem('reports.tax-report');
                            msNavigationServiceProvider.deleteItem('reports.night-audit');
                            msNavigationServiceProvider.deleteItem('reports.night-audit-short');
                            msNavigationServiceProvider.deleteItem('reports.arrival-registration-card');
                            msNavigationServiceProvider.deleteItem('reports.m3-report');
                            msNavigationServiceProvider.deleteItem('reports.food/barreport');
                            msNavigationServiceProvider.deleteItem('reports.availability-report');
                            msNavigationServiceProvider.deleteItem('reports.promo-reports');
                            msNavigationServiceProvider.deleteItem('reports.hold-report');

                            // msNavigationServiceProvider.deleteItem('reports.reservation-due-report');
                            // msNavigationServiceProvider.deleteItem('reports.zero-daily-rate');

                        }

                        // Marketing Section
                        if (routePermissions.indexOf('marketing') != -1) {
                            msNavigationServiceProvider.saveItem("marketing", {
                              title: "Marketing",
                              icon: "icon-tag",
                              weight: 14,
                            });
                            if (routePermissions.indexOf('customer_calendar_search') != -1) {
                                msNavigationServiceProvider.saveItem('marketing.customer_calendar_search', {
                                    title: 'Customer Search',
                                    icon: 'icon-calendar',
                                    state: 'app.customerCalendarSearch',
                                    weight: 1
                                });
                            }
                            else {
                                msNavigationServiceProvider.deleteItem('marketing.customer_calendar_search');
                            }
                        } else {
                            msNavigationServiceProvider.deleteItem('marketing');
                        }

                        if (routePermissions.indexOf('generate_invoice') != -1) {
                            msNavigationServiceProvider.saveItem('generate-invoice', {
                                title: 'Generate Invoices',
                                icon: 'icon-cash',
                                state: 'app.generate-invoice',
                                weight: 13
                            });
                        } else {
                            msNavigationServiceProvider.deleteItem('generate-invoice');
                        }
                        if (routePermissions.indexOf('Subscribers') != -1) {
                            msNavigationServiceProvider.saveItem('subscriber', {
                                title: 'Subscribers ',
                                icon: 'icon-newsletter',
                                state: 'app.subscriber',
                                weight: 14
                            });
                        } else {
                            msNavigationServiceProvider.deleteItem('subscriber');
                        }

                        if (routePermissions.indexOf('general_settings') != -1 || routePermissions.indexOf('room_lock_encoder') != -1 || routePermissions.indexOf('daily_rentals') != -1 || routePermissions.indexOf('mc_settings') != -1 || routePermissions.indexOf('payment_methods') != -1 || routePermissions.indexOf('email_templates') != -1 || routePermissions.indexOf('configuration') != -1) {
                            msNavigationServiceProvider.saveItem('settings', {
                                title: 'Settings',
                                icon: 'icon-cog',
                                weight: 15
                            });

                            var settings_count = 0;
                            var permissions_count = 0;
                            if (routePermissions.indexOf('general_settings') != -1) {
                                settings_count++;
                                msNavigationServiceProvider.saveItem('settings.general', {
                                    title: 'General',
                                    icon: 'icon-cog',
                                    state: 'app.settings_general',
                                    weight: 8
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('settings.general');
                            }
                            if (routePermissions.indexOf('room_lock_encoder') != -1) {
                                settings_count++;
                                msNavigationServiceProvider.saveItem('settings.roomLockEncoder', {
                                    title: 'Room Lock Encoder',
                                    icon: 'icon-room-key-nav',
                                    state: 'app.settings_room_lock_encoder',
                                    weight: 7
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('settings.roomLockEncoder');
                            }
                            if (routePermissions.indexOf('daily_rentals') != -1) {
                                settings_count++;
                                msNavigationServiceProvider.saveItem('settings.dailyRentals', {
                                    title: 'Daily Rentals',
                                    icon: 'icon-calendar-today',
                                    state: 'app.settings_daily_rentals',
                                    weight: 6.5
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('settings.dailyRentals');
                            }
                            if (routePermissions.indexOf('mc_settings') != -1) {
                                settings_count++;
                                msNavigationServiceProvider.saveItem('settings.messageCenter', {
                                    title: 'Message Center Config',
                                    icon: 'icon-message-text',
                                    state: 'app.settings_message_center',
                                    weight: 6
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('settings.messageCenter');
                            }
                            msNavigationServiceProvider.deleteItem('settings.triggers');
                            if (routePermissions.indexOf('payment_methods') != -1) {
                                settings_count++;
                                msNavigationServiceProvider.saveItem('settings.paymentmethod', {
                                    title: 'Payment Methods',
                                    icon: 'icon-cash',
                                    state: 'app.settings_paymentmethod',
                                    weight: 2
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('settings.paymentmethod');
                            }


                            var subSettingEmail = 0;
                            if (routePermissions.indexOf('email_templates') != -1) {
                                settings_count++;
                                subSettingEmail++;
                                msNavigationServiceProvider.saveItem('settings.emails.templates', {
                                    title: 'Templates',
                                    icon: 'icon-email',
                                    state: 'app.settings_emails',
                                    weight: 1
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('settings.emails.templates');
                            }
                            if (routePermissions.indexOf('configuration') != -1) {
                                subSettingEmail++;
                                settings_count++;
                                msNavigationServiceProvider.saveItem('settings.emails.config', {
                                    title: 'Configuration',
                                    icon: 'icon-cog',
                                    state: 'app.config_email',
                                    weight: 2
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('settings.emails.config');
                            }
                            if (subSettingEmail > 0) {
                                msNavigationServiceProvider.saveItem('settings.emails', {
                                    title: 'Emails',
                                    icon: 'icon-email-open',
                                    weight: 3
                                });
                            } else {
                                msNavigationServiceProvider.deleteItem('settings.emails');
                            }
                        } else {
                            msNavigationServiceProvider.deleteItem('settings');
                        }

                        msNavigationServiceProvider.saveItem('terms-and-conditions', {
                          title: 'Terms & Conditions',
                          icon: 'icon-file-document',
                          href: 'https://www.lodgingsystem.com/terms-and-conditions/',
                          target: '_blank',
                          weight: 16
                        });

                        msNavigationServiceProvider.saveItem('support-email', {
                            title: 'Email Support',
                            icon: 'icon-headset',
                            href: 'mailto:support@lodgingsystem.com',
                            weight: 17
                        });

                        /*------------*/


                        return config;
                    },
                    'responseError': function(response) {
                        if (response.status === 401) {
                            $rootScope.unauthorizedLogout();
                        }
                        if (response.status === 426) {
                            $rootScope.unauthorizedVersion();
                        }
                        return $q.reject(response);
                    }

                };
            }]);

            /*Left Idle For in seconds*/
             IdleProvider.idle(1800);
             /*Count Down For in seconds*/
             IdleProvider.timeout(1800);
             KeepaliveProvider.interval(5);
             $urlRouterProvider.otherwise('/login');

            /**
             * Layout Style Switcher
             *
             * This code is here for demonstration purposes.
             * If you don't need to switch between the layout
             * styles like in the demo, you can set one manually by
             * typing the template urls into the `State definitions`
             * area and remove this code
             */
            // Inject $cookies
            var $cookies;

            angular.injector(['ngCookies']).invoke([
                '$cookies',
                function(_$cookies) {
                    $cookies = _$cookies;
                }
            ]);

            // Get active layout
            var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

            var layouts = {
                verticalNavigation: {
                    main: 'app/core/layouts/vertical-navigation.html',
                    toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                    navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
                },
                verticalNavigationFullwidthToolbar: {
                    main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                    toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                    navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
                },
                verticalNavigationFullwidthToolbar2: {
                    main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                    toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                    navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
                },
                horizontalNavigation: {
                    main: 'app/core/layouts/horizontal-navigation.html',
                    toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                    navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
                },
                contentOnly: {
                    main: 'app/core/layouts/content-only.html',
                    toolbar: '',
                    navigation: ''
                },
                contentWithToolbar: {
                    main: 'app/core/layouts/content-with-toolbar.html',
                    toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                    navigation: ''
                }
            };
            // END - Layout Style Switcher
            // State definitions
            $stateProvider
                .state('app', {
                    abstract: true,
                    views: {
                        'main@': {
                            templateUrl: layouts[layoutStyle].main,
                            controller: 'MainController as vm'
                        },
                        'toolbar@app': {
                            templateUrl: layouts[layoutStyle].toolbar,
                            controller: 'ToolbarController as vm'
                        },
                        'navigation@app': {
                            templateUrl: layouts[layoutStyle].navigation,
                            controller: 'NavigationController as vm'
                        },
                        'quickPanel@app': {
                            templateUrl: 'app/quick-panel/quick-panel.html',
                            controller: 'QuickPanelController as vm'
                        }
                    }
                });



        }

    })();

(function ()
{
    'use strict';

    angular
    .module('fuse')
    .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController($mdComponentRegistry, $mdSidenav, fuseTheming, $localStorage, $state, $window, $rootScope, $cookies, $scope, $mdDialog, $timeout, $q, reportService, loginService, messageCenterNavBadgeService, messageCenterBrowserNotificationService, messageCenterService, otaMessageCenterPubNubService, smsMessageCenterPubNubService){

        var vm = this;
        $rootScope.number_of_days = 30;
        $scope.$on('IdleTimeout', function() {
             $rootScope.logoutUser();
         });
         $mdComponentRegistry.when('left').then(function() {
            $mdSidenav('navigation').toggle();
        });

        vm.themes = fuseTheming.themes;
        if($localStorage.userPermissions) $rootScope.userPermissions = atob($localStorage.userPermissions);
        else $rootScope.userPermissions ='';

             //if($localStorage.authToken==''){
          // $state.go('app.pages_auth_login');
       // }
        $rootScope.unauthorizedLogout = function() {
            messageCenterService.clearSettingsCache();
            angular.forEach($cookies, function (v, k) {
                $cookies.remove(k);
            });
            var localOld = angular.copy($localStorage);
            $localStorage.$reset();
            if(localOld.preUrlOrder1 && typeof localOld.preUrlOrder1 != 'undefined'){
                $localStorage.preUrlOrder = localOld.preUrlOrder1;
                $localStorage.preUrlData = localOld.preUrlData1;
            }
            delete $localStorage.authToken;
            $state.go('app.pages_auth_login');
        };
        $rootScope.unauthorizedVersion = function() {
            $timeout(function() {
                if($state.current.name == 'app.pages_auth_login'){
                    var alert = $mdDialog.alert({
                            title: 'Error',
                            htmlContent: '<div class="md-padding custom-common-dailog">Your current version is outdated. You will need to login again after page reload.</div>',
                            ok: 'OK'
                        });
                    $mdDialog
                    .show( alert )
                    .finally(function() {
                        window.location.reload(true);
                    });
                }else{
                    window.location.reload(true);
                }
            }, 200);     
        };
        $rootScope.logoutUser = function(){
            messageCenterNavBadgeService.destroy();
            messageCenterBrowserNotificationService.destroy();
            messageCenterService.clearSettingsCache();
            otaMessageCenterPubNubService.reset();
            smsMessageCenterPubNubService.reset();
            delete $localStorage.authToken;
            $localStorage.userId    = '';
            $localStorage.firstName = '';
            $localStorage.lastName= '';
            $localStorage.userPermissions= '';
            $localStorage.selectedHotel = '';
            $localStorage.isUserloggedIn = '';
            $localStorage.hotels = '';
            $rootScope.hotelInformation = {};
            $state.go('app.pages_auth_login');
        };

        $rootScope.goToState = function(itinerary_number, confirmation_number,reservation_id){
            // confirmation_number = '';
            var request = { itinerary_number:itinerary_number, confirmation_number : confirmation_number,reservation_id : reservation_id };
            reportService.getReservationId(request).then(function(response){
                var url = $state.href('app.e-commerce.orders.detail', {
                    confirmation_number: confirmation_number,
                    changeStatusData: '',
                    id:response['reservation_number']
                });
                window.open(url,'_blank');
            });
        }
        $rootScope.getSubHotels = function(hotel_id,from_page){
            var request = {hotel_id:hotel_id};
            reportService.getSubHotels(request).then(function(response){
                if(response['success'] === true){
                    if(from_page){
                        $rootScope.isSelectedParent = true;
                        $rootScope.subHotelsOfSelected = response['data'];
                    }else{
                        $rootScope.isParent = true;
                        $rootScope.subHotels = response['data'];
                    }
                }else{
                     $rootScope.isParent = false;
                     $rootScope.isSelectedParent = false;
                }
            });
        }

        $rootScope.hotelInformation = {};

        function getSelectedHotelId() {
            if ($localStorage.hotels && $localStorage.selectedHotel !== undefined && $localStorage.selectedHotel !== '') {
                return $localStorage.hotels[$localStorage.selectedHotel].hotel_id;
            }
            return $localStorage.preHotelId || null;
        }

        function getEncoderSettings(hotelInformation) {
            if (!hotelInformation || !hotelInformation.settings) {
                return {};
            }
            return hotelInformation.settings.encoder_settings || {};
        }

        $rootScope.loadHotelInformation = function(hotelId) {
            hotelId = hotelId || getSelectedHotelId();
            if (!hotelId || !$localStorage.authToken) {
                return $q.when($rootScope.hotelInformation);
            }

            return loginService.getHotelInformation({ hotel_id: hotelId }).then(function(response) {
                if (response && response.success && response.hotel_information) {
                    $rootScope.hotelInformation = response.hotel_information;
                }
                return $rootScope.hotelInformation;
            });
        };

        $rootScope.isRoomLockEncoderVisible = function() {
            var encoderSettings = getEncoderSettings($rootScope.hotelInformation);
            var value = encoderSettings.room_lock_encoder_visible;
            return value === true || value === 1 || value === '1';
        };

        $rootScope.getEncoderSystemOptions = function() {
            var encoderSettings = getEncoderSettings($rootScope.hotelInformation);
            var urls = [];
            var count = parseInt(encoderSettings.room_lock_encoder_url_count, 10);
            var index;

            var commonDoors = (encoderSettings.room_lock_common_doors || [])
            .filter(function(door) { return door.is_enabled && door.is_deleted !== true; })
            .map(function(door) {
                if (door.mdb_id != null && door.mdb_id !== '') {
                    return parseInt(door.mdb_id, 10);
                }
                return parseInt(door.id, 10);
            });
            
            if (count > 0) {
                for (index = 1; index <= count; index++) {
                    if (encoderSettings['room_lock_encoder_url_' + index]) {
                        urls.push(encoderSettings['room_lock_encoder_url_' + index]);
                    }
                }
            }

            if (!urls.length) {
                return [{ label: 'Encoder 1', value: 'system_1' }];
            }

            return urls.map(function(url, optionIndex) {
                return {
                    label: 'Encoder ' + (optionIndex + 1),
                    value: 'system_' + (optionIndex + 1),
                    url: url,
                    common_doors: commonDoors
                };
            });
        };

        $rootScope.getGuestCheckinFrom = function() {
            var guestInfo = ($rootScope.hotelInformation && $rootScope.hotelInformation.policies && $rootScope.hotelInformation.policies.guest_information) || {};
            return guestInfo.guest_checkin_from || '';
        };

        $rootScope.getGuestCheckoutTo = function() {
            var guestInfo = ($rootScope.hotelInformation && $rootScope.hotelInformation.policies && $rootScope.hotelInformation.policies.guest_information) || {};
            return guestInfo.guest_checkout_to || '';
        };

        $rootScope.isDailyRentalsEnabled = function() {
            var settings = ($rootScope.hotelInformation
                && $rootScope.hotelInformation.settings
                && $rootScope.hotelInformation.settings.daily_rentals_settings) || {};
            var value = settings.enabled;
            return value === true || value === 1 || value === '1';
        };

        $rootScope.isDailyRentalsAvailable = function() {
            var hasPermission = typeof $rootScope.validatePermission === 'function'
                ? $rootScope.validatePermission('daily_rentals')
                : false;
            return hasPermission && $rootScope.isDailyRentalsEnabled();
        };

        $rootScope.getDayRoomKeyCardTimes = function() {
            var hotelSettings = ($rootScope.hotelInformation && $rootScope.hotelInformation.settings) || {};
            var dailyRentals = hotelSettings.daily_rentals_settings || {};
            var keyCardTimes = hotelSettings.day_room_key_card_times || {};
            return {
                checkin: dailyRentals.checkin || keyCardTimes.checkin || '11:00',
                checkout: dailyRentals.checkout || keyCardTimes.checkout || '17:00'
            };
        };
        
        $rootScope.getSubHotels($localStorage['preHotelId']);
        $rootScope.loadHotelInformation();

        if ($localStorage.authToken) {
            messageCenterNavBadgeService.init();
            messageCenterBrowserNotificationService.init();
        }


        $rootScope.downloadFile = function(headers, data, fileName,order,not_required, pageSetLodging){
            var csvString = '';
            if(!headers || !data || !fileName){
                console.log('some parameter are missing or not valid');
                return ;
            }
            var fileFormat = fileName.split('.');
            if(fileFormat[1] == 'pdf' || fileFormat[1] == 'PDF'){
                /*start*/

                if(typeof order!='undefined'){
                    var printOrder = order.split(',');
                }
                if(typeof not_required!='undefined'){
                    var doNotPrint = not_required.split(',');
                }
                var tempdata = [];
                tempdata.push(headers);
                angular.forEach(data, function(pvalue, pkey) {
                    var rowData = [];
                    var count=0;
                    angular.forEach(pvalue, function(cvalue, ckey) {
                        var column = '';
                        if(ckey != '$$hashKey'){
                            if(typeof not_required!='undefined'){
                                if(doNotPrint.indexOf(ckey)!=-1)
                                    return;
                            }
                            if(typeof order!='undefined' && order!=''){
                                var indexToPrint = printOrder[count];
                                count++;
                                if(pvalue[indexToPrint] != ''){
                                     column = (pvalue[indexToPrint])?pvalue[indexToPrint]:'';
                                }
                            } else {
                                column = (cvalue)?cvalue:'';
                                
                            } 
                            rowData.push({ text: column, width:'auto'});
                        }
                        
                    });
                    tempdata.push(rowData);
                });
                //standard size for A4 page
                var pageWidth = 595;
                var pageHeigth = 842;
                if(pageSetLodging == 'lodgingstats'){
                    // bcoz in lodging report we have large width of data
                    pageWidth = 2100;
                    pageHeigth = 1400;
                } else if(pageSetLodging == 'payment-received'){
                    pageWidth = 900;
                    pageHeigth = 615;
                } else if(pageSetLodging == 'oldtaxreport'){
                    pageWidth = 2700;
                    pageHeigth = 1800;
                } else if(pageSetLodging == 'retail'){
                    pageWidth = 1500;
                    pageHeigth = 1200;
                }
                var docDefinition = {
                    header: {
                        text: fileFormat[0],
                        fontSize: 12,
                        alignment: 'center',
                        margin: [72, 40],
                        bold: true,
                        pageSize: 'A4'
                     },
                    pageSize: {
                        width: pageWidth,
                        height: pageHeigth,
                    },
                    content: [{
                        table:  {
                            headerRows: 1,
                            body: tempdata,
                        }
                    }],
                    styles: {
                        header: {
                        fontSize: 10,
                        bold: true
                        }
                    },
                    pageMargins: [72, 100, 72, 40]
                };

                pdfMake.createPdf(docDefinition).download(fileName);
                // pdfMake.createPdf(docDefinition).open();
                /*end*/
            }else{
                for(var hKey in headers){
                    csvString = csvString + headers[hKey] + ",";
                }
                
                csvString = csvString + "\n";
                if(typeof order!='undefined'){
                var printOrder = order.split(',');
                }
                if(typeof not_required!='undefined'){
                var doNotPrint = not_required.split(',');
                }

                for(var pKey in data){
                    var count=0;
                    for(var cKey in data[pKey]){
                       var column = '';
                        if(cKey  != '$$hashKey'){
                            if(typeof not_required!='undefined'){
                                if(doNotPrint.indexOf(cKey)!=-1)
                                    continue;
                            }
                            if(typeof order!='undefined'){
                                var indexToPrint = printOrder[count];
                                count++;
                                // console.log(indexToPrint,printOrder[count]);
                                // console.log(data[pKey][indexToPrint]);
                                if(data[pKey][indexToPrint] !=''){
                                     column = (data[pKey][indexToPrint] || data[pKey][indexToPrint] == 0)?data[pKey][indexToPrint]:'';
                                }
                            }
                            else{
                             column = (data[pKey][cKey] || data[pKey][cKey] == 0)?data[pKey][cKey]:'';
                            }
                            column = column+' ';
                            if(column && column !=  ''){
                                column = (column.indexOf(',') != -1) ? column.replace(/,/g,''):column;
                                column = (column.indexOf('#') != -1) ? column.replace(/#/g,''):column;
                            }
                            csvString = csvString + column + ",";
                        }
                    }
                    csvString = csvString + "\n";
                }   

                // Use a Blob URL instead of a data: URI. encodeURI() does not encode
                // "#" so headers like "Room #" truncated the download at that character.
                if (!fileFormat[1]) {
                    fileName = fileName + '.csv';
                }
                var blob = new Blob(['\uFEFF' + csvString], { type: 'text/csv;charset=utf-8;' });
                var fileURL = (window.URL || window.webkitURL).createObjectURL(blob);
                var a = $('<a/>', {
                    style:'display:none',
                    href: fileURL,
                    download:fileName
                }).appendTo('body');
                a[0].click();
                a.remove();
                (window.URL || window.webkitURL).revokeObjectURL(fileURL);

            }            
        }
        
        $rootScope.validatePermission = function(permission){
            var permissionList  = $rootScope.userPermissions.split(',');
            if(permissionList.indexOf(permission) != -1)
                return true;
            else
                return false;
        }

        $rootScope.convertDateIntoArray = function(dateString) {
            var dateArray = [];
            if (dateString !== '') {
                if (typeof dateString === 'string') {
                    dateString = dateString.split('-');
                    dateArray[0] = parseInt(dateString[0]);
                    dateArray[1] = parseInt(dateString[1]) - 1;
                    dateArray[2] = parseInt(dateString[2]);
                } else if (typeof dateString === 'object') {
                    dateArray[0] = dateString.getFullYear();
                    dateArray[1] = dateString.getMonth();
                    dateArray[2] = dateString.getDate();
                }
            }
            return dateArray;
        }

        $rootScope.arr_diff = function(a1, a2) {
            var a = [], diff = [];
            for (var i = 0; i < a1.length; i++) {
                a[a1[i]] = true;
            }
            for (var i = 0; i < a2.length; i++) {
                if (a[a2[i]]) {
                    delete a[a2[i]];
                } else {
                    a[a2[i]] = true;
                }
            }
            for (var k in a) {
                diff.push(k);
            }
            return diff;
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config)
        .directive('mdtCustomCellEdit', function () {
		  return {
			template: '<md-button><md-tooltip>Edit</md-tooltip><md-icon md-font-icon="icon-pencil" class="s16"></md-icon></md-button>',
		  };
		})
        .directive('mdtCustomCellSetting', function () {
		  return {
			template: '<md-button><md-tooltip>Configure</md-tooltip><md-icon md-font-icon="icon-cog" class="s16"></md-icon></md-button>',
		  };
		})
        .directive('mdtCustomCellDelete', function () {
		  return {
			template: '<md-button><md-tooltip>Delete</md-tooltip><md-icon md-font-icon="icon-delete" class="s16"></md-icon></md-button>',
		  };
		});

    /** @ngInject */
    function config($translateProvider, $provide)
    {
        
        // Put your common app configurations here

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');
        $translateProvider.useLoaderCache(true);
        
        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);
        
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.settings',
            [
                'app.settings.general',
                'app.settings.emails',
                'app.settings.paymentmethod',
                'app.settings.roomLockEncoder',
                'app.settings.dailyRentals',
                'app.settings.messageCenter',
                'app.settings.triggers',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config()
    {
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.rateCategory',
            [
                // 3rd Party Dependencies
                'xeditable',
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.rateCategory', {
            url    : '/rateCategory',
            title : 'Rate Catergory',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/rateCategory/rateCategory.html',
                    controller : 'rateCategoryController as vm'
                }
            },
            resolve  : {
                Policies: function (rateCategoryService,$localStorage){
                    return rateCategoryService.getFormData( {hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id});
                    // return [];
                },
                Pageheading: function(){
                    return 'list';
                }
            },
            permission: 'rate_rules',
        }).state('app.ratecategoryform', {
            url    : '/ratecategoryform/add',
            title : 'Rate Catergory',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/rateCategory/rateCategoryAddEdit.html',
                    controller : 'rateCategoryController as vm'
                }
            },
             resolve  : {
                    Policies: function (rateCategoryService,$localStorage,$stateParams){
                        return rateCategoryService.getFormData( {hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id, status:'add'});
                    },
					Pageheading: function(){
						return 'add';
					}
                },
            permission: 'add_rate_rule',
            bodyClass: 'rateCategory'
        }).state('app.ratecategoryform_edit', {
            url    : '/ratecategoryform/:rate_plan_id',
            title : 'Rate Catergory',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/rateCategory/rateCategoryAddEdit.html',
                    controller : 'rateCategoryController as vm'
                }
            },
             resolve  : {
                    Policies: function (rateCategoryService,$localStorage,$stateParams){
                        return rateCategoryService.getFormData( {hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id, status:$stateParams.rate_plan_id});
                    },
					Pageheading: function(){
						return 'update';
					}
                },
            permission: 'update_rate_rule',
            bodyClass: 'rateCategory'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/rateCategory');

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.permissions',
            [
                'app.permissions.organizations',
                'app.permissions.organization',
                'app.permissions.roles',
                'app.permissions.adminusers',
                'app.permissions.profile'
            ]
        )
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider) {
        
        
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.generate-invoice',
            [
                // 3rd Party Dependencies
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.generate-invoice', {
            url    : '/generate-invoice',
            title  : 'Generate Invoices',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/generate-invoice/generate-invoice.html',
                    controller : 'generateInvoiceController as vm'
                }
            },
			 resolve  : {
				Policies: function (policyService,$localStorage){
					return policyService.getDefaultPloicy( {hotel_id:$localStorage.hotels[$localStorage.selectedHotel].hotel_id});
				}
			},
			permission: 'rate_policies'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/policy');

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.ui', [
            'app.ui.forms',
            'app.ui.helper-classes',
            'app.ui.icons',
            'app.ui.material-colors',
            'app.ui.page-layouts.blank',
            'app.ui.page-layouts.carded.fullwidth',
            'app.ui.page-layouts.carded.fullwidth-ii',
            'app.ui.page-layouts.carded.left-sidenav',
            'app.ui.page-layouts.carded.left-sidenav-ii',
            'app.ui.page-layouts.carded.right-sidenav',
            'app.ui.page-layouts.carded.right-sidenav-ii',
            'app.ui.page-layouts.simple.fullwidth',
            'app.ui.page-layouts.simple.left-sidenav',
            'app.ui.page-layouts.simple.left-sidenav-ii',
            'app.ui.page-layouts.simple.left-sidenav-iii',
            'app.ui.page-layouts.simple.right-sidenav',
            'app.ui.page-layouts.simple.right-sidenav-ii',
            'app.ui.page-layouts.simple.right-sidenav-iii',
            'app.ui.page-layouts.simple.tabbed',
            'app.ui.theme-colors',
            'app.ui.typography'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('ui', {
            title : 'USER INTERFACE',
            group : true,
            weight: 3
        });

        msNavigationServiceProvider.saveItem('ui.forms', {
            title: 'Forms',
            icon : 'icon-window-restore',
            state: 'app.ui_forms'
        });

        msNavigationServiceProvider.saveItem('ui.icons', {
            title: 'Icons',
            icon : 'icon-file-image-box',
            state: 'app.ui_icons'
        });

        msNavigationServiceProvider.saveItem('ui.typography', {
            title: 'Typography',
            icon : 'icon-format-size',
            state: 'app.ui_typography'
        });

        msNavigationServiceProvider.saveItem('ui.helper-classes', {
            title: 'Helper Classes',
            icon : 'icon-help-circle',
            state: 'app.ui_helper-classes'
        });

        msNavigationServiceProvider.saveItem('ui.theme-colors', {
            title: 'Theme Colors',
            icon : 'icon-palette-advanced',
            state: 'app.ui_theme-colors'
        });

        msNavigationServiceProvider.saveItem('ui.material-colors', {
            title: 'Material Colors',
            icon : 'icon-palette',
            state: 'app.ui_material-colors'
        });


        msNavigationServiceProvider.saveItem('ui.page-layouts', {
            title: 'Page Layouts',
            icon : 'icon-view-quilt'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded', {
            title: 'Carded'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.fullwidth', {
            title: 'Full Width (I)',
            state: 'app.ui_page-layouts_carded_fullwidth'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.fullwidth-ii', {
            title: 'Full Width (II)',
            state: 'app.ui_page-layouts_carded_fullwidth-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.left-sidenav', {
            title: 'Left Sidenav (I)',
            state: 'app.ui_page-layouts_carded_left-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.left-sidenav-ii', {
            title: 'Left Sidenav (II)',
            state: 'app.ui_page-layouts_carded_left-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.right-sidenav', {
            title: 'Right Sidenav (I)',
            state: 'app.ui_page-layouts_carded_right-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.right-sidenav-ii', {
            title: 'Right Sidenav (II)',
            state: 'app.ui_page-layouts_carded_right-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple', {
            title: 'Simple'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.fullwidth', {
            title: 'Full Width (I)',
            state: 'app.ui_page-layouts_simple_fullwidth'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav', {
            title: 'Left Sidenav (I)',
            state: 'app.ui_page-layouts_simple_left-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav-ii', {
            title: 'Left Sidenav (II)',
            state: 'app.ui_page-layouts_simple_left-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav-iii', {
            title: 'Left Sidenav (III)',
            state: 'app.ui_page-layouts_simple_left-sidenav-iii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav', {
            title: 'Right Sidenav (I)',
            state: 'app.ui_page-layouts_simple_right-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav-ii', {
            title: 'Right Sidenav (II)',
            state: 'app.ui_page-layouts_simple_right-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav-iii', {
            title: 'Right Sidenav (III)',
            state: 'app.ui_page-layouts_simple_right-sidenav-iii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.tabbed', {
            title: 'Tabbed',
            state: 'app.ui_page-layouts_simple_tabbed'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.blank', {
            title: 'Blank',
            state: 'app.ui_page-layouts_blank'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.pages.auth.login',
            'app.pages.auth.forgot-password',
            'app.pages.auth.resetpassword',
            'app.pages.auth.register'
        ])
        .config(config);

    /** @ngInject */
    // function config($stateProvider, msNavigationServiceProvider,socialProvider){
    function config($stateProvider, msNavigationServiceProvider){
        
        
        // socialProvider.setGoogleKey("559758771291-clg5f0g3hmcs4r3m0jij0lga5s3ikt4p.apps.googleusercontent.com");
        // socialProvider.setLinkedInKey("YOUR LINKEDIN CLIENT ID");
        // socialProvider.setFbKey({appId: "1292557030841890", apiVersion: "v2.8"});

        // State
        $stateProvider
            .state('app.pages', {
                url    : '/pages',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/pages/auth/login/login.html',
                        controller : 'loginController as vm'
                    }
                },
            });
        
        // Navigation
        /*msNavigationServiceProvider.saveItem('pages', {
            title : 'PAGES',
            group : true,
            weight: 2
        });*/
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.components', [
            'app.components.tables.simple-table',
            'app.components.tables.lodging-stats'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider){
       
        msNavigationServiceProvider.saveItem('tables', {
            title: 'Reports',
            icon : 'icon-table-large',
            weight: 5
        });

        msNavigationServiceProvider.saveItem('tables.simple-table', {
            title: 'Monthly Income',
            state: 'app.components_tables_simple-table',
            weight: 6
        });
        
        msNavigationServiceProvider.saveItem('tables.lodging-stats', {
            title: 'Lodging Statistics',
            state: 'app.components_tables_lodging-stats',
            weight: 7
        });
    }
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span>\nNotifications</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","");
$templateCache.put("app/main/apps/channels/channels.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-link\" style=\"font-size:30px\"></md-icon>\n<span translate=\"CHANNELS.CHANNELS\"></span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"CHANNELS.TOTAL_CHANNELS\"></span> <span>{{vm.totalchannels}}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{ \'SEARCH\' | translate }}\" ng-model=\"filterText\" flex></div><div class=\"logo\" layout=\"row\" \nlayout-align=\"center end\"><md-button layout=\"row\" class=\"md-raised md-cornered\" ng-click=\"vm.gotoaddRole()\" \nng-if=\"vm.userPermissions.indexOf(\'add_channel\')!=-1\"><i class=\"icon-plus icon-plus-main\"></i>\n {{ \'CHANNELS.CHANNEL\' | translate }}</md-button></div></div></div></div></div><div class=\"content\"><div \nclass=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main RowClick\" ms-scroll><mdt-table \ntable-card=\"{visible: false, title: \'Users\'}\" paginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" \nselectable-rows=\"vm.delete_product\" alternate-headers=\"\'contextual\'\" selected-row-callback=\"selectedRowCallback(rows)\" \nmdt-row-paginator=\"paginatorCallback(page, pageSize, options, selected)\" delete-row-callback=\"deleteSelectedItem()\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\r\n        \'table-row-id-key\': \'channel_id\',\r\n        \'column-keys\': [\r\n		\'channel_name\',\r\n		\'room_type_name\',\r\n        \'rate_plan_name\',\r\n        \'channel_id\'\r\n        ],\r\n    }\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'CHANNELS.NAME\' | translate }}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'CHANNELS.ROOM_TYPE\' | translate }}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'CHANNELS.PLANS\' | translate }}</span>\n</mdt-column><mdt-column align-rule=\"left\"><span></span></mdt-column></mdt-header-row><mdt-custom-cell \nhtml-content=\"true\" column-key=\"room_type_name\"><span class=\"breakLine\" style=\"\" \nbind-html-compile=\"clientScope.wraptext(value)\"></span></mdt-custom-cell><mdt-custom-cell html-content=\"true\" \ncolumn-key=\"channel_id\"><a ng-click=\"clientScope.goToEditPage(value)\"><md-icon md-font-icon=\"icon-icon-border-color\" \nclass=\"icon icon-border-color cursorPointer\" role=\"img\" aria-label=\"icon-cog\"></md-icon></a></mdt-custom-cell>\n</mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/channels/channelsAddEdit.html","<form name=\"channelForm\" class=\"md-inline-form fullwidth scroll-full-height\" novalidate><div id=\"channelPage\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page profileImage_page fullwidth\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-organizations-button md-icon-button\" aria-label=\"Go to users\" \nng-click=\"vm.gotoGroupListing()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.pageHeader}}</div><div\n class=\"subtitle secondary-text\"><span translate=\"CHANNELS.CHANNEL_DETAIL\"></span></div></div></div></div><div>\n<md-button class=\"md-raised md-background\" ng-if=\"vm.pageStatus == \'add\'\" ng-click=\"vm.saveChannel()\" \nng-disabled=\"channelForm.$invalid || channelForm.$pristine || vm.selectedOption\" \nng-class=\"{\'md-blue-grey-A100-bg\': channelForm.$invalid || channelForm.$pristine || vm.selectedOption}\" \ntranslate=\"GROUPS.SAVE\"></md-button><md-button class=\"md-raised md-background\" ng-if=\"vm.pageStatus == \'add\'\" \nng-click=\"vm.gotoGroupListing();\"><span translate=\"GROUPS.CANCEL\"></span></md-button></div></div><div \nclass=\"content scroll-height-sm\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><div class=\"main sm-hearder-top scroll-full-height\" ms-scroll><div \nclass=\"white-bg md-whiteframe-4dp relative-block\" layout-align=\"center center\" layout-padding><div class=\"row-block\" \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex><div class=\"row-col mb-20\" flex-gt-xs=\"100\" \nflex-gt-sm=\"100\" layout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs\" flex-gt-xs=\"100\">\n<label translate=\"CHANNELS.SELECT_CHANNEL\"></label><md-select ng-model=\"vm.channels.channel_id\" name=\"status\" \nng-disabled=\"vm.pageStatus != \'add\'\" required><md-option value=\"{{channel.channel_id}}\" \nng-repeat=\"channel in vm.channels\">{{channel.channel_name+\'( \'+channel.channel_code+\' )\'}}</md-option></md-select><div \nclass=\"emailErrorChannels\" ng-if=\"vm.channelNameExists\">{{vm.channelNameExists}}</div></md-input-container></div></div>\n<div class=\"row-block no-padding\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" flex-gt-sm=\"100\" layout-align=\"start start\" flex><div\n class=\"title no-padding form-title\" translate=\"CHANNELS.ROOM_RATE\"></div></div></div><div \nng-repeat=\"(grandKey ,rooms) in vm.roomsAssociatedRateCategory\" ng-init=\"header = 1\" class=\"row-block\" layout=\"column\" \nlayout-gt-xs=\"row\" layout-align=\"start\" flex ng-if=\"!vm.isParent\"><div class=\"gry-row-block\" layout=\"column\" \nlayout-gt-xs=\"row\" layout-align=\"start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" \nflex-gt-sm=\"50\" layout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs padding-bottom-10\">\n{{rooms.room_type_name}}</md-input-container></div><div class=\"row-col gry-bg-color padding-right-10 padding-left-10\" \nflex-gt-xs=\"100\" flex-gt-sm=\"50\" layout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs\" \nng-init=\"myName = rooms.rate_plan_name.split(\',\'); myId = rooms.rate_plan_id.split(\',\');\"><span \nng-if=\"rooms.relation[0].parent_id != \'\'\" ng-repeat=\"(key,rp) in rooms.relation\"><ul class=\"no-margin no-padding\"><div \nclass=\"row-block\" layout-gt-xs=\"row\" layout-align=\"start\" flex layout-wrap><md-checkbox layout=\"column\" flex=\"100\" \nng-checked=\"rp.selected\" class=\"margin-top-bottom-custom\" \nng-click=\"vm.selectAllModules(rp,grandKey,$index, rooms.room_type_id);vm.updateRooms(rp, rooms.room_type_id)\" \nng-init=\"temId = rp.parent_id +\'\';\" ng-disabled=\"vm.loggedInUserRole != 1\">\n{{myName[myId.indexOf(rp.parent_id.toString())]}}</md-checkbox></div><div class=\"row-block margin-left-30\" \nlayout=\"row\" layout-gt-xs=\"row\" layout-align=\"start\" layout-wrap flex><md-checkbox layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\" flex-gt-sm=\"33\" ng-repeat=\"(subKey,rpchild) in rp.children\" \nclass=\"margin-top-bottom-custom\" ng-checked=\"rpchild.selected\" \nng-click=\"vm.toggle(rpchild, key, subKey, grandKey, rpchild.parent_id, rooms.room_type_id);vm.updateRooms(rp, rooms.room_type_id)\" \nng-disabled=\"vm.loggedInUserRole != 1\">{{myName[myId.indexOf(rpchild.parent_id.toString())]}}</md-checkbox></div></ul>\n</span></md-input-container></div></div></div><div ng-if=\"vm.isParent\"><div ng-repeat=\"childHotel in vm.childHotel\" \nclass=\"channelhotelrepeat\"><p ng-click=\"vm.getSpecificData(childHotel.hotel_id)\">{{childHotel.hotel_title}}<md-icon \nng-show=\"vm.selectedSubHotel != childHotel.hotel_id\" md-font-icon=\"icon-chevron-down\" class=\"md-arrowiconch-repeat\">\n</md-icon></p><div ng-show=\"vm.selectedSubHotel == childHotel.hotel_id\"><div \nng-repeat=\"(grandKey ,rooms) in vm.roomsAssociatedRateCategory\" ng-init=\"header = 1\" class=\"row-block\" layout=\"column\" \nlayout-gt-xs=\"row\" layout-align=\"start\" flex><div class=\"gry-row-block\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" flex-gt-sm=\"50\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs padding-bottom-10\">\n{{rooms.room_type_name}}</md-input-container></div><div class=\"row-col gry-bg-color padding-right-10 padding-left-10\" \nflex-gt-xs=\"100\" flex-gt-sm=\"50\" layout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs\" \nng-init=\"myName = rooms.rate_plan_name.split(\',\'); myId = rooms.rate_plan_id.split(\',\');\"><span \nng-if=\"rooms.relation[0].parent_id != \'\'\" ng-repeat=\"(key,rp) in rooms.relation\"><ul class=\"no-margin no-padding\"><div \nclass=\"row-block\" layout-gt-xs=\"row\" layout-align=\"start\" flex layout-wrap><md-checkbox layout=\"column\" flex=\"100\" \nng-checked=\"rp.selected || vm.testRoomRatePlanId.indexOf(rp.parent_id+\'@\'+rooms.room_type_id) != -1\" \nclass=\"margin-top-bottom-custom\" \nng-click=\"vm.selectAllModules(rp,grandKey,$index, rooms.room_type_id);vm.updateRooms(rp, rooms.room_type_id)\" \nng-init=\"temId = rp.parent_id +\'\';\" ng-disabled=\"vm.loggedInUserRole != 1\">\n{{myName[myId.indexOf(rp.parent_id.toString())]}}</md-checkbox></div><div class=\"row-block margin-left-30\" \nlayout=\"row\" layout-gt-xs=\"row\" layout-align=\"start\" layout-wrap flex><md-checkbox layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\" flex-gt-sm=\"33\" ng-repeat=\"(subKey,rpchild) in rp.children\" \nclass=\"margin-top-bottom-custom\" ng-checked=\"rpchild.selected\" \nng-click=\"vm.toggle(rpchild, key, subKey, grandKey, rpchild.parent_id, rooms.room_type_id);vm.updateRooms(rp, rooms.room_type_id)\" \nng-disabled=\"vm.loggedInUserRole != 1\">{{myName[myId.indexOf(rpchild.parent_id.toString())]}}</md-checkbox></div></ul>\n</span></md-input-container></div></div></div></div></div></div></div></div></div></div></form>");
$templateCache.put("app/main/apps/checkout/checkout.html","<div id=\"checkout\" class=\"page-layout simple tabbed md-datepicker full-height\" layout=\"column\"><div \nclass=\"header md-accent-bg relative-block\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" ng-click=\"vm.back()\"><md-icon \nmd-font-icon=\"icon-basket\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div class=\"h2\">\n{{vm.title}}</div></div></div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\" \nclass=\"headerstickyProgress\"></md-progress-linear></div><div class=\"txtcustomerblk1\" layout=\"row\" flex=\"100\" \nlayout-wrap><div class=\"txtfixedblkmain\" ng-if=\"vm.showCatNav\"><div \nclass=\"grid-block-card pv-10 ph-15 auto-overflow-block\" flex=\"100\" layout=\"row\" layout-wrap layout-align=\"start start\">\n<div class=\"ph-10 pv-10 block_cat_nav\" layout=\"column\"><div class=\"white-bg border_bottomdp cursorPointer no-padding\" \nng-click=\"vm.selectCategory(\'recents\',\'Recents\')\"><div class=\"img-contentblk h-100\"><img \nsrc=\"assets/images/ecommerce/recently.png\" class=\"block_nav_img\"></div><div class=\"content-nameblk\">Recents</div></div>\n</div><div class=\"ph-10 pv-10 block_cat_nav\" layout=\"column\"><div \nclass=\"white-bg border_bottomdp cursorPointer no-padding\" ng-click=\"vm.selectCategory(\'frequents\',\'Frequents\')\"><div \nclass=\"img-contentblk h-100\"><img src=\"assets/images/ecommerce/frequently.png\" class=\"block_nav_img\"></div><div \nclass=\"content-nameblk\">Frequents</div></div></div><div class=\"ph-10 pv-10 block_cat_nav\" layout=\"column\" \nng-repeat=\"category in vm.productCategory\"><div class=\"white-bg border_bottomdp cursorPointer no-padding\" \nng-click=\"vm.selectCategory(category.pos_type_id,category.pos_type_name)\"><div class=\"img-contentblk h-100\"><img \nsrc=\"{{vm.baseUrl+\'assets/uploads/activities/\'+category.pos_type_media}}\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\" class=\"block_nav_img\"></div><div \nclass=\"content-nameblk\">{{ category.pos_type_name }}</div></div></div><div class=\"ph-10 pv-10 block_cat_nav\" \nlayout=\"column\"><div class=\"white-bg border_bottomdp cursorPointer no-padding\" \nng-click=\"vm.selectCategory(\'all_categories\',\'All Categories\')\"><div class=\"img-contentblk h-100\"><img \nsrc=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\" class=\"block_nav_img\"></div><div \nclass=\"content-nameblk\">All Categories</div></div></div></div></div><div layout=\"column\" flex=\"100\" flex-gt-md=\"55\" \nflex-gt-sm=\"50\" class=\"customer-left-block relclass full-height\" ng-if=\"!vm.checkoutPage\"><div \nclass=\"white-bg block-form-seach-main md-whiteframe-1dp\"><div class=\"row-blk-search ph-10\" layout=\"row\" layout-wrap \nflex=\"100\"><div layout=\"column\" flex=\"30\"><md-input-container class=\"no-margin ph-20\"><md-select \nng-model=\"vm.selectedPosType\" ng-change=\"vm.getAllFilteredProduct(\'\',true, \'category\')\"><md-option \nng-value=\"posTypes.hidename\" ng-repeat=\"posTypes in vm.totalPosTypes\">{{posTypes.showname}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex=\"{{vm.resDetails.typeofService!=\'dbar\'?30:40}}\" \nng-class=\"vm.resDetails.typeofService!=\'dbar\'?\'border-left-column\':\'\'\"><md-input-container class=\"no-margin ph-20\" \nng-if=\"vm.resDetails.typeofService==\'retail\'\"><md-select ng-model=\"vm.category\" \nng-change=\"vm.getAllFilteredProduct(\'\',false,\'category\')\"><md-option ng-value=\"0\">All Categories</md-option><md-option \nng-value=\"category.pos_type_id\" ng-repeat=\"category in vm.productCategory\">{{category.pos_type_name}}</md-option>\n</md-select></md-input-container><div class=\"mainNavSwitcher onlycursorPointer\" \nng-if=\"vm.resDetails.typeofService!=\'retail\'\" ng-click=\"vm.showCatNav=!vm.showCatNav\">{{vm.selectedCat}}<md-icon \nmd-font-icon=\"icon-menu-down\" class=\"icon-menu-down\"></md-icon></div></div><div layout=\"column\" \nflex=\"{{vm.resDetails.typeofService!=\'dbar\'?40:60}}\" class=\"border-left-column\"><md-input-container \nclass=\"no-margin ph-20 searchvaluelbl\"><input name=\"type\" ng-model=\"vm.search\" placeholder=\"Search\" \nng-change=\"vm.getAllFilteredProduct(\'\',false,\'\')\" ng-click=\"vm.removeSearchText(\'click\')\" \nng-blur=\"vm.removeSearchText(\'blur\')\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div>\n</div><div class=\"blkoverflow blkoverflow-rest\"><div \nclass=\"grid-block-card pv-10 ph-15 auto-overflow-block blockofAllProducts\" flex=\"100\" layout=\"row\" layout-wrap \nlayout-align=\"start start\"><div class=\"ph-10 pv-10 h-240\" layout=\"column\" flex=\"33\" flex-md=\"50\" flex-xs=\"100\" \nbindonce ng-repeat=\"product in vm.categoryRelatedProducts\"><div class=\"white-bg shdaowdp cursorPointer no-padding\" \nng-click=\"vm.addToCart(product)\" ng-attr-title=\"{{product.product_name}}\"><div class=\"img-contentblk h-140\"><img \nsrc=\"{{vm.baseUrl+\'assets/uploads/activities/thumbnail/\'+product.media }}\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\"></div><div class=\"content-nameblk capitalize\">\n<span bo-text=\"product.product_name\"></span></div><div class=\"price-blk\" \nbo-if=\"product.pos_display_tax_indicator == 1\"><span bo-bind=\"product.total | currency:$:2\"></span></div><div \nclass=\"price-blk\" ng-if=\"product.pos_display_tax_indicator == 0\"><span bo-bind=\"product.product_price | currency:$:2\">\n</span></div></div></div></div></div><div class=\"card-bottom-block placeholder ph-20 pv-5 absclass\"><div class=\"\" \nlayout=\"row\" flex=\"100\" layout-align=\" start start\"><div flex=\"33\" layout=\"column\" layout-align=\" center start\"><div \nclass=\"content-block-total pt-15\">Total Products: {{vm.totalProduct}}<md-icon md-font-icon=\"icon-chevron-left\" \nclass=\"arrow-left-right onlycursorPointer\" ng-click=\"vm.switchPage(\'back\')\" ng-if=\"vm.curPage != 1 && vm.curPage != 0\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"arrow-left-right onlycursorPointer\" \nng-click=\"vm.switchPage(\'forward\')\" ng-if=\"(vm.curPage * vm.dataPerPage) < vm.totalProduct\"></md-icon></div></div>\n</div></div></div><div layout=\"column\" flex=\"100\" flex-gt-md=\"45\" flex-gt-sm=\"50\" class=\"full-height\"><div \nclass=\"full-height white-bg\"><div class=\"row-blk-icon white-bg md-whiteframe-1dp\" layout=\"row\" layout-wrap flex=\"100\">\n<div layout=\"column\" flex=\"10\" ng-click=\"vm.emptyCart()\" ng-if=\"!vm.checkoutPage\"><md-icon \nng-class=\"(vm.cartItem.length == 0)?\'disabledClass\':\'onlycursorPointer red-A800-fg\'\" class=\"s-48\" \nmd-font-icon=\"icon-delete\"><md-tooltip><span>Empty cart</span></md-tooltip></md-icon></div><div layout=\"column\" \nflex=\"10\" ng-click=\"vm.goToCheckout()\" ng-if=\"vm.checkoutPage && !vm.add_tip_to_order && !vm.afterCreatePage\"><md-icon \nclass=\"s-48 onlycursorPointer\" md-font-icon=\"icon-arrow-left\"></md-icon></div><div layout=\"column\" flex=\"10\" \nng-if=\"vm.checkoutPage && vm.add_tip_to_order\"><md-button class=\"md-button md-raised md-accent white-fg no-magin\" \nng-click=\"vm.gotoPosOrder(10);\">Cancel</md-button></div><div ng-if=\"vm.checkoutPage\" layout=\"column\" flex=\"60\" \nlayout-align=\"center center\" class=\"cart-txt\">{{ \'Cart(\'+vm.cartItem.length + \')\'}}</div><div \nng-if=\"vm.resDetails.typeofService == \'bar\' && vm.show_split\" layout=\"column\" flex=\"30\" layout-align=\"center end\" \nclass=\"split-payment\"><md-button class=\"md-button md-raised md-accent white-fg no-magin\" ng-show=\"vm.show_split\" \nng-click=\"vm.splitPaymentToggle();\">{{vm.splitText}}</md-button></div><div ng-if=\"!vm.checkoutPage\" layout=\"column\" \nflex=\"{{vm.show_split?\'40\':\'90\'}}\" layout-align=\"end end\" class=\"cart-txt\"><div class=\"btnsresdetailnew\" flex=\"100\" \nlayout=\"row\" layout-align=\" start center\"><div layout=\"column\" layout-align=\" center end\" \nng-if=\"vm.selectedPosType == \'bar\' && vm.showHappyHourButton\"><div class=\"switchclassblk\"><div \nclass=\"switchclassblk switchonpage\"><div class=\"onoffswitch\"><input type=\"checkbox\" name=\"onoffswitch\" \nng-model=\"vm.happy_hours\" aria-label=\"Switch 1\" ng-change=\"vm.saveHappyHoursSession()\" class=\"onoffswitch-checkbox\" \nid=\"myonoffswitch2\" checked=\"checked\"><label class=\"onoffswitch-label\" for=\"myonoffswitch2\"><span \nclass=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div></div></div><div \nlayout=\"column\" layout-align=\" center end\"><div class=\"content-block-btnsale\"><md-button type=\"submit\" \nng-if=\"vm.popUpType != \'quantity\'\" ng-click=\"vm.openCustomProductPopUp($event)\" class=\"md-button md-raised md-primary\" \naria-label=\"custom sale\"><md-icon md-font-icon=\"icon-calculator\"></md-icon><span class=\"txthide1200\">Custom</span>\n<md-tooltip><span>Custom Product</span></md-tooltip></md-button></div></div><div layout=\"column\" \nlayout-align=\" center start\"><div class=\"content-block-total\"><md-button type=\"submit\" id=\"add_Gift_Card\" \nng-click=\"vm.addGiftCard($event)\" class=\"md-button md-raised md-primary\" aria-label=\"custom sale\"><md-icon \nmd-font-icon=\"icon-wallet-giftcard\"></md-icon><span class=\"txthide1200\">Gift Card</span><md-tooltip><span>Gift Card\n</span></md-tooltip></md-button></div></div><div layout=\"column\" layout-align=\" center start\"><div \nclass=\"content-block-total\"><md-button type=\"submit\" id=\"add_Gift_Card\" \nng-click=\"vm.openOnlyAmtDialog(EditResPaymentForm,\'amt\', \'selectCustomer\');\" class=\"md-button md-raised md-primary\" \naria-label=\"custom sale\"><md-icon md-svg-src=\"assets/icons/tip.svg\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\"></md-icon><span class=\"txthide1200\">Gratuity</span>\n<md-tooltip><span>Gratuity</span></md-tooltip></md-button></div></div><div layout=\"column\" \nlayout-align=\" center start\" ng-if=\"vm.parking_access && vm.currentPage == \'bar-checkout\'\"><div \nclass=\"content-block-total\"><md-button type=\"submit\" id=\"add_Gift_Card\" \nng-click=\"vm.addParking($event,vm.order.room_stay_from,vm.order.room_stay_to,vm.order.confirmation_number)\" \nclass=\"md-button md-raised md-primary\" aria-label=\"custom sale\"><md-icon md-font-icon=\"icon-parking\"></md-icon><span \nclass=\"txthide1200\">Parking</span><md-tooltip><span>Parking</span></md-tooltip></md-button></div></div><div \nlayout=\"column\" layout-align=\"center start\"><div class=\"content-block-total\"><md-button type=\"submit\" \nid=\"add_Gift_Card\" ng-click=\"vm.addCustomDiscount($event)\" \nng-class=\"isDiscountApplied?\'md-button md-raised md-accent white-fg\':\'md-button md-raised md-primary\'\" \naria-label=\"custom sale\" ng-disabled=\"vm.cartItem.length == 0\"><md-icon md-font-icon=\"icon-currency-usd\"></md-icon>\n<span class=\"txthide1200 white-fg\">Cart Discount</span><md-tooltip><span>Cart Discount</span></md-tooltip></md-button>\n</div></div></div></div></div><div class=\"side-overflow-block\" flex=\"100\" layout=\"row\" layout-wrap><div flex=\"100\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"add-customer onlycursorPointer\" layout=\"row\" flex=\"100\" \nlayout-align=\"center center\" ng-if=\"!vm.resDetails[\'addServiceForRoom\'] && vm.customerDetails\" \nng-click=\"vm.getAllCustomers()\"><div ng-if=\"vm.customerDetails\"><md-icon class=\"s-50 mr-5\" \nmd-font-icon=\"icon-account-box\"></md-icon><span>\n{{ vm.customerDetails[\'first_name\']+\' \'+vm.customerDetails[\'last_name\']+\' \'+vm.customerDetails[\'customer_email\'] }}\n<md-icon md-font-icon=\"icon-delete\" class=\"red-A800-fg\" ng-click=\"vm.deleteCustomer();$event.stopPropagation();\">\n</md-icon></span></div></div><div id=\"cart\" layout=\"row\" class=\"relative-block\" flex=\"100\" \nlayout-align=\"center center\" bindonce ng-repeat=\"(cartKey, cart) in vm.cartItem track by $index\" \nng-click=\"!vm.checkoutPage ? vm.updateItem(cartKey, cart, $event) : vm.triggerClickOnCheckbox($index)\" \nng-class=\"!vm.checkoutPage? vm.getClass(cart):\'list-customer ph-15\'\"><div style=\"z-index:10\" ng-if=\"vm.spliting\" \nclass=\"splitcheckbox col-lg-1 col-md-1 col-sm-1 col-xs-1\"><md-input-container style=\"z-index:10\" \nclass=\"md-block mb-0 md-input-has-value no-margin padding-top-8\" layout=\"column\" flex=\"100\" flex-gt-md=\"100\" \nflex-gt-xs=\"100\" layout-align=\"center\"><md-checkbox style=\"z-index:10\" type=\"checkbox\" \nng-model=\"vm.splitcheck[$index]\" type=\"checkbox\" \nng-change=\"vm.addToSplitPayment($index,vm.splitcheck[$index],\'clicked\')\"></md-checkbox></md-input-container></div><div \nlayout=\"column\" flex=\"10\" class=\"ph-0 listimg1\"><img \nsrc=\"{{vm.baseUrl+\'assets/uploads/activities/thumbnail/\'+cart.media}}\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\"></div><div layout=\"column\" flex=\"60\" \nclass=\"ph-10\">{{cart.product_name}} {{cart.product_is_timebound == 0?\'(\'+cart.quantity+\')\':\'\'}} <span \nclass=\"smallBlue\">Base price ${{cart.product_price | number:2}}</span> <span class=\"smallBlue\" \nng-if=\"cart.addOnPrice>0\">Add-ons ${{cart.addOnPrice | number:2}}</span> <span class=\"smallBlue\" \nng-if=\"cart.product_is_timebound == 1\">{{ (cart.from | date)+\'-\'+(cart.to | date) }}</span> <span class=\"smallGreen\" \nng-if=\"cart.customDiscount > 0\">Base discount ${{(cart.customDiscount) | number:2}}</span></div><div layout=\"column\" \nflex=\"25\" class=\"ph-10\" layout-align=\"center end\">\n${{(cart.particularCustomPrice != 0?(cart.particularCustomPrice * cart.quantity):(cart.customPrice * cart.quantity)) | number:2 }}\n</div><div layout=\"column\" class=\"onlycursorPointer\" ng-class=\"{\'roundup-delete-btn\': cart.is_charity_round_up}\" \nng-if=\"!vm.checkoutPage || cart.is_charity_round_up\" flex=\"5\" \nng-click=\"vm.removeCartItem(cartKey); $event.stopPropagation();\"><md-icon md-font-icon=\"icon-close-circle-outline\">\n</md-icon></div></div><div class=\"list-customer-subtotal ph-15\" flex=\"100\" layout=\"row\" layout-align=\"center center\">\n<div layout=\"column\" flex=\"70\" class=\"subtotal-txt\">Subtotal</div><div layout=\"column\" flex=\"25\" \nclass=\"subtotal-txt-rate\" layout-align=\"center end\">${{ ((vm.subTotal - vm.overAllTax) | number:2)}}</div></div><div \nclass=\"list-customer-subtotal ph-15\" flex=\"100\" layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.overAllDiscount > 0\"><div layout=\"column\" flex=\"70\" class=\"subtotal-txt\">Discount:</div><div layout=\"column\" \nflex=\"25\" class=\"subtotal-txt-rate\" layout-align=\"center end\">${{ ((vm.overAllDiscount) | number:2)}}</div></div><div \nclass=\"list-customer-subtotal ph-15\" flex=\"100\" layout=\"row\" layout-align=\"center center\"><div layout=\"column\" \nflex=\"70\" class=\"subtotal-txt cc-processing-fee-toggle\">Tax<div \nng-if=\"vm.checkoutPage || vm.resDetails.addServiceForRoom\"><md-checkbox ng-model=\"vm.waiveCcProcessingFee\" \nng-change=\"vm.toggleCcProcessingFeeWaiver()\" class=\"no-margin cc-processing-checkbox\">Waive off CC processing fee\n</md-checkbox></div></div><div layout=\"column\" flex=\"25\" class=\"subtotal-txt-rate\" layout-align=\"center end\">\n${{ (vm.overAllTax | number:2) }}</div></div><div class=\"list-customer-subtotal ph-15\" flex=\"100\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.payingFromGC[\'gcCode\']\"><div layout=\"column\" flex=\"70\" class=\"subtotal-txt\">\n<div>Gift card{{ \'(\'+vm.payingFromGC[\'gcCode\']+\')\'}}<md-icon class=\"s-48 onlycursorPointer red-A800-fg\" \nmd-font-icon=\"icon-delete\" ng-click=\"vm.removeGC()\"></md-icon></div></div><div layout=\"column\" flex=\"25\" \nclass=\"subtotal-txt-rate\" layout-align=\"center end\">${{ ((vm.payingFromGC[\'price\']) | number:2)}}</div></div><div \nclass=\"list-customer-subtotal list-customer-subtotal-grand ph-15\" flex=\"100\" layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.checkoutPage\"><div layout=\"column\" flex=\"70\" class=\"subtotal-txt\">Grand Total:</div><div layout=\"column\" \nflex=\"25\" class=\"subtotal-txt-rate grand-total-amount-col\" layout-align=\"end end\"><div class=\"grand-total-amount\">\n${{ ((vm.subTotal -vm.overAllDiscount) | number:2)}}</div><button type=\"button\" class=\"checkout-round-up-link\" \nng-if=\"vm.isRoundUpEnable() && vm.cartItem.length > 0 && vm.getCharityRoundUpAmount() > 0\" \nng-click=\"vm.addRoundUpForCharity()\" title=\"Add ${{vm.getCharityRoundUpAmount() | number:2}} (Round Up For Charity)\">\nRound Up</button></div></div><div class=\"list-customer-subtotal checkout-btn-block-main no-border\" flex=\"100\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"!vm.checkoutPage\"><div flex=\"20\" flex-md=\"30\" layout=\"column\" \nng-if=\"vm.resDetails.typeofService == \'bar\' && (vm.resDetails.one_go_id == \'\' || !vm.resDetails.one_go_id) && (vm.resDetails.pageFrom != \'order\' || !vm.resDetails.pageFrom)\">\n<md-button class=\"md-button md-raised md-accent white-fg no-margin btn1 ph-15\" ng-click=\"vm.tabOrder()\" \nng-disabled=\"vm.requestProcessing\"><md-icon md-font-icon=\"icon-cart-outline\"></md-icon>TAB</md-button></div><div \nflex=\"25\" flex-md=\"30\" layout=\"column\" \nng-if=\"(vm.resDetails.typeofService == \'restaurant\' || vm.resDetails.typeofService == \'bar\') && vm.showCooksPreview && (vm.resDetails.one_go_id == \'\' || !vm.resDetails.one_go_id) && (vm.resDetails.pageFrom != \'order\' || !vm.resDetails.pageFrom)\">\n<md-button class=\"printcook md-button md-raised md-accent white-fg no-margin btn1 ph-15\" \nng-click=\"vm.printCooksOrder()\" ng-disabled=\"vm.cartItem.length == 0\">Cook\'s Print</md-button></div><div flex=\"30\" \nflex-md=\"30\" layout=\"column\" ng-if=\"vm.resDetails[\'addServiceForRoom\']\"><md-button \nclass=\"md-button md-raised white-fg no-margin btn1 ph-15 room-cancel-btn md-red-500-bg\" \nng-click=\"(vm.resDetails.one_go_id != \'\' && vm.resDetails.pageFrom == \'order\' && vm.resDetails.typeofService == \'bar\') ? vm.gotoPosOrder(1000):vm.gotoRevservationPage()\">\n<md-icon md-font-icon=\"icon-cancel\"></md-icon>No / Cancel</md-button></div><div layout=\"column\" flex=\"100\" \nclass=\"subtotal-txt\"><md-button ng-if=\"!vm.resDetails[\'addServiceForRoom\']\" \nclass=\"md-button md-raised white-fg no-margin btn2 ph-15 room-add-btn md-green-500-bg\" ng-click=\"vm.goToCheckout()\" \nng-disabled=\"vm.cartItem.length == 0\"><md-icon md-font-icon=\"icon-cart\"></md-icon>Checkout <span>\n${{ ((vm.subTotal -vm.overAllDiscount) | number:2)}}</span></md-button><md-button \nng-if=\"vm.resDetails[\'addServiceForRoom\'] && vm.resDetails[\'pageFrom\'] != \'order\' && vm.resDetails[\'pageFrom\'] != \'restaurant\'\" \nclass=\"md-button md-raised white-fg no-margin btn2 ph-15 room-add-btn md-green-500-bg\" ng-click=\"vm.gotoReservation()\" \nng-disabled=\"vm.cartItem.length == 0 || vm.orderProcessing\"><md-icon md-font-icon=\"icon-cart\"></md-icon>\nYes / Add{{ vm.addToRoomNumber ? \' to Room \' + vm.addToRoomNumber : \'\' }} <span>\n${{ ((vm.subTotal -vm.overAllDiscount) | number:2)}}</span></md-button><md-button \nng-if=\"vm.resDetails[\'addServiceForRoom\'] && (vm.resDetails[\'pageFrom\'] == \'order\' || vm.resDetails[\'pageFrom\'] == \'restaurant\')\" \nclass=\"md-button md-raised white-fg no-margin btn2 ph-15 room-add-btn md-green-500-bg\" \nng-click=\"vm.proceedToCheckout()\" ng-disabled=\"vm.cartItem.length == 0 || vm.orderProcessing || vm.orderProgressing\">\n<md-icon md-font-icon=\"icon-cart\"></md-icon>Yes / Add{{ vm.addToRoomNumber ? \' to Room \' + vm.addToRoomNumber : \'\' }} \n<span>${{ ((vm.subTotal -vm.overAllDiscount) | number:2)}}</span></md-button></div></div><div \nclass=\"list-customer-subtotal checkout-btn-block-main no-border\" flex=\"100\" layout=\"row\" layout-align=\"center center\">\n<div layout=\"column\" flex=\"100\">&nbsp;</div></div></div></div></div></div><div layout=\"column\" flex=\"100\" \nflex-gt-md=\"55\" flex-gt-sm=\"50\" class=\"customer-left-block padding-20 accordion-design\" \nng-if=\"vm.checkoutPage && !vm.afterCreatePage\"><div class=\"content height\" layout=\"row\" ng-init=\"my_id = 1\"><div \nclass=\"main RowClick prop-amen-con\" flex=\"100\" flex-gt-md=\"100\" flex-gt-sm=\"100\" layout=\"column\" ms-scroll>\n<ang-accordion one-at-a-time=\"true\" icon-position=\"right\" \nclose-icon-url=\"../assets/angular-material-assets/img/icons/right-arrow.svg\" op \nen-icon-url=\"../assets/angular-material-assets/img/icons/bottom-arrow.svg\"><collapsible-item \nitem-title=\"In-house Customers\" class=\"font-size-14\" ms-scroll id=\"selectInHouseCustomer\"><md-radio-group \nng-model=\"vm.selectedCustomer1\" ng-repeat=\"customer in vm.allCurentCustomers\" \nng-change=\"vm.fetchPaymentsInformation(customer.confirmation_number, customer.first_name, customer.last_name, vm.subTotal, vm.subTotal, customer)\" \nclass=\"padding-left-15 md-radio-group-collapse cardimglabel\"><md-radio-button \nvalue=\"{{ customer.confirmation_number }}\" class=\"font-size-18\">\n{{ customer.product_room_number+\'- \'+customer.first_name+\' \'+customer.last_name+\' (#\'+customer.confirmation_number+\')\' }} \n<span ng-if=\"customer.cc_is_incidental == \'1\'\" class=\"yesicon\"><img \nsrc=\"assets/angular-material-assets/img/icons/credit-card.svg\" alt=\"Incidental card\"> </span><span \nng-if=\"customer.cc_is_incidental == \'0\'\" class=\"yesicon no-icon\"><img \nsrc=\"assets/angular-material-assets/img/icons/credit-card2.svg\" alt=\"No incidental card\"></span></md-radio-button>\n</md-radio-group><span ng-if=\"vm.allCurentCustomers.length == 0\">No customer found</span></collapsible-item>\n<collapsible-item item-title=\"Custom Reservation\" class=\"font-size-14\" ms-scroll ng-click=\"vm.closePayment()\" \nid=\"SelectedItenararyNo\" ng-if=\"vm.resDetails.typeofService == \'retail\'\"><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"\"><div class=\"row-col padding-right-10 padding-left-10 autocompletecotainer\" flex-gt-xs=\"100\" layout=\"column\" \nlayout-align=\"start start\" flex=\"100\"><md-autocomplete ng-disabled=\"vm.isCustomerDisabled\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedCustomer\" md-search-text-change=\"vm.searchCustomer(vm.searchTxtCustomer)\" \nmd-search-text=\"vm.searchTxtCustomer\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-items=\"item in vm.queryCustomerSearch(vm.searchTxtCustomer)\" \nmd-item-text=\"item.first_name +\' \'+item.last_name+\'(\'+item.confirmation_number+\')\'\" md-min-length=\"0\" \nmd-floating-label=\"Enter itinerary/confirmation\" md-require-match class=\"full-width\"><md-item-template><span \nmd-highlight-text=\"vm.searchTxtCustomer\" md-highlight-flags=\"^i\">\n{{item.first_name+\' \'+item.last_name+\'(\'+item.confirmation_number+\')\'}}</span></md-item-template><md-not-found>\nNo result found</md-not-found></md-autocomplete></div></div></collapsible-item><collapsible-item item-title=\"Tip\" \nclass=\"font-size-14\" ms-scroll ng-click=\"vm.closePayment()\" id=\"SelectedTip\" \nng-if=\"vm.resDetails.typeofService != \'retail\'\"><md-input-container class=\"md-block mt-0\"><label>Select User</label>\n<md-select ng-model=\"vm.tipCustomerId\" ng-change=\"vm.tipToWhomName();\"><md-option ng-repeat=\"user in vm.allUsers\" \nng-value=\"user.user_id\" ng-selected=\"vm.loggedInUserId==user.user_id\">{{user.first_name+\' \'+user.last_name}}\n</md-option></md-select></md-input-container><div class=\"both-tips\"><div class=\"tip-webpos\"><form \nid=\"webpos_tip_form_1\"><div id=\"tipdiv1\" class=\"tipdivClass\"><ul class=\"tipdivUl tipdivUlfour\"><li \nng-click=\"vm.applytipfinal(\'no\',$event,\'perc\',\'samepage\',\'\',vm.tipCustomerId,vm.customerTipUserName);\" \nng-class=\"vm.iamactive==\'no\'?\'active onlycursorPointer\':\'onlycursorPointer\'\">No Tip</li><li \nng-click=\"vm.applytipfinal(\'10\',$event,\'perc\',\'samepage\',\'\',vm.tipCustomerId,vm.customerTipUserName);\" \nng-class=\"vm.iamactive==\'10\'?\'active onlycursorPointer\':\'onlycursorPointer\'\">10%</li><li \nng-click=\"vm.applytipfinal(\'15\',$event,\'perc\',\'samepage\',\'\',vm.tipCustomerId,vm.customerTipUserName);\" \nng-class=\"vm.iamactive==\'15\'?\'active onlycursorPointer\':\'onlycursorPointer\'\">15%</li><li \nng-click=\"vm.applytipfinal(\'20\',$event,\'perc\',\'samepage\',\'\',vm.tipCustomerId,vm.customerTipUserName);\" \nng-class=\"vm.iamactive==\'20\'?\'active onlycursorPointer\':\'onlycursorPointer\'\">20%</li></ul></div></form></div><div \nclass=\"tip-webpos tip-webpos-custom\"><form id=\"webpos_tip_form\"><div id=\"tipdiv\" class=\"tipdivClass\"><ul \nclass=\"tipdivUl\"><li ng-click=\"vm.openOnlyAmtDialog(EditResPaymentForm,\'amt\',\'selectCustomer\');\" \nng-class=\"vm.iamactive==\'amount\'?\'active onlycursorPointer\':\'onlycursorPointer\'\">Custom Amount</li><li \nng-click=\"vm.openOnlyAmtDialog(EditResPaymentForm,\'perc\', \'selectCustomer\');\" \nng-class=\"vm.iamactive==\'percentage\'?\'active onlycursorPointer\':\'onlycursorPointer\'\">Custom Percentage</li></ul><div \nclass=\"form-group input-amount tipaction\" id=\"tipaction-amt\" style=\"display:none\"><div \nclass=\"amount col col-lg-3 col-md-3 col-sm-3 col-xs-3\">Amount $</div><div class=\"col-lg-9 col-md-9 col-sm-9 col-xs-9\">\n<input value=\"0.00\" id=\"amt-tip-value\" type=\"text\" placeholder=\"0.00\" \nclass=\"input-text form-control validate-currency-dollar required-entry validation-passed\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></div></div><div class=\"form-group input-amount tipaction\" id=\"tipaction-perc\" \nstyle=\"display:none\"><div class=\"amount col col-lg-3 col-md-3 col-sm-3 col-xs-3\">Percentage %</div><div \nclass=\"col-lg-9 col-md-9 col-sm-9 col-xs-9\"><input value=\"0.00\" id=\"perc-tip-value\" type=\"text\" placeholder=\"0.00\" \nclass=\"input-text form-control required-entry validate-percents validation-passed\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></div></div><div class=\"tipaction-button\" style=\"display:block\"><button type=\"button\" \nid=\"apply_tip\" onclick=\"applytipfinal(\'custom\')\" style=\"display:none\">Apply to Order</button></div><div \nclass=\"tipremove-button\" style=\"display:none\"><button type=\"button\" onclick=\"removetip()\">Remove from Order</button>\n</div></div></form></div></div></collapsible-item><collapsible-item item-title=\"Payments\" \nclass=\"font-size-14 RemoveOpen\" ms-scroll id=\"MyPaymentMethod\"><span \nng-if=\"vm.payment_method[0].method == \'Cash\' && vm.expectedChange > 0\">Expected Change:${{vm.expectedChange}}</span>\n<form name=\"EditResPaymentForm\" ng-attr-id=\"{{ \'EditResPaymentForm\' }}\"><md-input-container \nclass=\"md-block mb-0 mb-0 payment-blockdeposite\" ng-if=\"vm.resDetails.typeofService ==\'retail\'\"><label>Deposit</label>\n<input ng-model=\"vm.minimumAmount\" name=\"minimum amount\" \nng-blur=\"vm.resDetails.typeofService == \'retail\' && vm.calculateTotal(true)\" type=\"text\" allow-decimal-numbers \nng-readonly=\"vm.resDetails.typeofService == \'bar\' || vm.resDetails.typeofService == \'restaurant\'\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container><div class=\"role-list-out white-bg\"><input type=\"radio\" \nclass=\"radio-new radio-new-down\" id=\"originalradio-0000\" value=\"originalradio-0000\" name=\"extraAuthPayment\" \nstyle=\"display:none\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div layout=\"row\" flex=\"100\" \nclass=\"margin-bottom-15 margin-top-20 margin-bottom-30\"><md-input-container \nclass=\"md-block mb-0 md-input-has-value no-margin\" layout=\"column\" flex=\"100\" flex-gt-md=\"100\" flex-gt-xs=\"100\" \nlayout-align=\"center \"><md-radio-group ng-change=\"vm.paymentMethodSelected(EditResPaymentForm,false)\" \nng-model=\"vm.payment_method[0].method\" required layout=\"row\" flex=\"100\" layout-wrap \nng-class=\"(vm.resDetails.typeofService == \'bar\' || vm.resDetails.typeofService == \'restaurant\') ?\'barPaymentMethod\':\'\'\">\n<md-radio-button \nng-class=\"(vm.resDetails.typeofService == \'bar\' || vm.resDetails.typeofService == \'restaurant\') && vm.payment_method[0].method==paymentMethod.heading?\'no-margin pv-5 active\':\'no-margin pv-5\'\" \nlayout=\"column\" flex=\"{{vm.resDetails.typeofService==\'retail\'?\'50\':\'25\'}}\" \nflex-gt-md=\"{{vm.resDetails.typeofService==\'retail\'?\'25\':\'25\'}}\" \nflex-gt-xs=\"{{vm.resDetails.typeofService==\'retail\'?\'50\':\'50\'}}\" layout-align=\"center \" \nclass=\"space-block-inline margin-right-0\" ng-repeat=\"paymentMethod in vm.all_payment_methods\" \nng-value=\"paymentMethod.heading\" \nng-if=\"(vm.resDetails.typeofService != \'retail\' && paymentMethod.heading != \'Other\') || (vm.resDetails.typeofService == \'retail\')\">\n<span class=\"{{paymentMethod.class}}\">{{paymentMethod.heading}}</span></md-radio-button></md-radio-group>\n</md-input-container></div><div ng-if=\"vm.payment_method[0].method===\'Check\'\" \nng-disabled=\"vm.payment_method[0].method!=\'Check\'\"><div layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" layout-align=\"center\"><md-input-container \nclass=\"md-block mb-0 mb-0\"><label translate=\"CREATE_RES.CHECK_NO\"></label><input required \nng-model=\"vm.payment_method[0].check_number\" name=\"check_number[$index]\" type=\"text\" \nng-change=\"vm.paymentFormValidate(EditResPaymentForm);\" ng-model-options=\"{debounce: 400}\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div></div></div><div \nng-if=\"vm.payment_method[0].method===\'Other\' && vm.resDetails.typeofService ==\'retail\'\" \nng-disabled=\"vm.payment_method[0].method!=\'Other\'\"><div layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" layout-align=\"center\"><md-input-container \nclass=\"md-block mb-0 mb-0\"><label translate=\"CREATE_RES.OTHER_COMMENT\"></label><textarea \nng-model=\"vm.payment_method[0].other_comment\" name=\"other_comment[$index]\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></textarea></md-input-container></div></div></div><div \nng-if=\"vm.payment_method[0].method === \'Credit Card\'\" ng-disabled=\"vm.payment_method[0].method!=\'Credit Card\'\" \nng-attr-id=\"{{ \'paymentccblock-\' + $index }}\" class=\"fontsize-15\"><label style=\"color:red\" \nid=\"authorizenet-swiper-status\" ng-click=\"vm.swipeNow()\" for=\"authorizenetswiper-data\">{{vm.swipeText}}</label><input \ntype=\"text\" style=\"height: 1px; width: 1px; border: 0 none; color: #FFF; font-size: 1px\" title=\"Swiper\" \ncode=\"authorizenet\" class=\"input-text webpos_swiper_input\" ng-model=\"vm.ccinfo_a\" ng-focus=\"vm.ReadySwipe()\" \nng-blur=\"vm.ResetSwipe()\" ng-keyup=\"vm.keyupfunction($event)\" id=\"authorizenet-swiper-data\" \nname=\"authorizenet-swiper-data\" value=\"    \" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div layout=\"row\" flex \nlayout-wrap ng-if=\"vm.order.allcardsInfo.length>0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex-xs=\"100\" flex=\"50\" layout-align=\"center \"><md-input-container class=\"md-block mb-0\" layout=\"column\" flex=\"100\" \nflex-gt-md=\"50\" flex-gt-xs=\"50\" layout-align=\"center \"><label translate=\"CREATE_RES.USE_EXISTINGCARD\"></label>\n<md-select ng-model=\"vm.use_existingcard\" ng-change=\"vm.testPayment($index,orderIndex)\"><md-option ng-value=\"key\" \nng-repeat=\"(key,cardData) in vm.order.allcardsInfo\">xxxx-{{cardData.cc_number}}({{cardData.cc_type}})</md-option>\n</md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"50\" layout-align=\" start\"><md-button \nstyle=\"max-height:40px;max-width:150px\" class=\"md-raised mt-15\" ng-click=\"vm.emptythisPayment($index)\">Add New Card\n</md-button></div></div><div ng-class=\"vm.fieldsIsReadOnly?\'pointer_events_disabled\':\'\'\"><div layout=\"row\" flex=\"100\" \nlayout-wrap><div class=\"padding-left-10 padding-right-10 datepicker-block\" layout=\"column\" flex-xs=\"100\" flex=\"100\" \nlayout-align=\"center \"><div layout=\"row\" flex=\"100\" layout-wrap><md-input-container class=\"md-block mb-0\" \nlayout=\"column\" flex=\"80\"><label translate=\"CREATE_RES.CC_NUMBER\"></label><input id=\"authorizenet_cc_number_label\" \nng-model=\"vm.payment_method[0].cc_number_mask\" name=\"cc_number_mask\" type=\"text\" required \nng-keyup=\"vm.creditCardChanged($event,EditResPaymentForm[\'cc_number\'].$ccEagerType,vm.payment_method[0])\" \nmaxlength=\"16\" ng-change=\"vm.paymentFormValidate(EditResPaymentForm);\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\">\n<div ng-show=\"!vm.fieldsIsReadOnly && EditResPaymentForm[\'cc_number_mask\'].$touched\"><div \nng-show=\"!EditResPaymentForm[\'cc_number\'].$valid\" ng-hide=\"EditResPaymentForm[\'cc_number\'].$valid\" class=\"emailError\">\n{{ \'CREATE_RES.CR_NOT_VALID\' | translate }}</div></div><div ng-show=\"vm.notCardType\" ng-hide=\"!vm.notCardType\" \nclass=\"emailError\">{{ \'CREATE_RES.CR_NOT_ALOWD\' | translate }}</div></md-input-container><input \nid=\"authorizenet_cc_number\" ng-model-options=\"{debounce: 500}\" ng-model=\"vm.payment_method[0].cc_number\" \nname=\"cc_number\" type=\"hidden\" cc-number cc-eager-type autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"> <input \ntype=\"hidden\" ng-model=\"vm.payment_method[0].customer_profile_id\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"> \n<input type=\"hidden\" ng-model=\"vm.payment_method[0].payment_profile_id\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"><div id=\"authorizenet_cc_type\" ng-change=\"vm.paymentFormValidate(EditResPaymentForm);\" \nng-model-options=\"{debounce: 400}\" ng-model=\"payment_cc_type\" \ncc_type=\"{{vm.payment_method[0].cc_type ? vm.payment_method[0].cc_type:vm.ct }}\" \nclass=\"{{vm.payment_method[0].cc_type? vm.payment_method[0].cc_type:vm.ct}} mt-10\" layout=\"column\" flex=\"20\" \nlayout-align=\"end center\"></div></div></div></div><div layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"33\" flex-xs=\"100\" layout-align=\"center\">\n<md-input-container class=\"md-block mb-0\"><label translate=\"CREATE_RES.EXP_MONTH\"></label><md-select \nid=\"authorizenet_expiration\" ng-change=\"vm.paymentFormValidate(EditResPaymentForm);\" \nng-model-options=\"{debounce: 400}\" ng-model=\"vm.payment_method[0].cc_exp_month\" ng-change=\"vm.checkValidExpDate()\">\n<md-option ng-value=\"key\" ng-repeat=\"(key,months) in vm.dates_option\">{{months}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div class=\"padding-left-10 padding-right-10\" \nlayout=\"column\" flex=\"33\" flex-xs=\"100\" layout-align=\"center\"><md-input-container class=\"md-block mb-0\"><label \ntranslate=\"CREATE_RES.EXP_YEAR\"></label><md-select name=\"payment[cc_exp_year]\" \nng-change=\"vm.paymentFormValidate(EditResPaymentForm);\" ng-model-options=\"{debounce: 400}\" \nng-model=\"vm.payment_method[0].cc_exp_year\" ng-change=\"vm.checkValidExpDate()\"><md-option ng-value=\"year\" \nng-repeat=\"year in vm.yrs_option\">{{year}}</md-option></md-select><div ng-show=\"vm.exp_date_err\" \nng-hide=\"!vm.exp_date_err\" class=\"emailError\">{{ \'CREATE_RES.EX_DATE_NOT_VALID\' | translate }}</div><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div class=\"padding-left-10 padding-right-10\" \nlayout=\"column\" flex-xs=\"100\" flex=\"33\" layout-align=\"center \"><md-input-container class=\"md-block mb-0\"><label \ntranslate=\"CREATE_RES.CC_CVN\"></label><input ng-change=\"vm.paymentFormValidate(EditResPaymentForm);\" \nng-model-options=\"{debounce: 400}\" ng-model=\"vm.payment_method[0].cc_cid\" name=\"cc_cvv{{$index}}\" type=\"text\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div ng-show=\"vm.ccvError\"><div ng-show=\"vm.ccvError\" \nclass=\"emailError\">{{ \'CREATE_RES.CVN_NOT_VALID\' | translate }}</div></div></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" \nflex=\"33\" layout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0\"><label \ntranslate=\"CREATE_RES.CUST_FN_CC\"></label><input ng-change=\"vm.paymentFormValidate(EditResPaymentForm);\" \nng-model-options=\"{debounce: 400}\" ng-model=\"vm.payment_method[0].cc_fname\" name=\"cc_fn[$index]\" type=\"text\" required \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"33\" layout-align=\"center \">\n<md-input-container class=\"md-block mb-0 mb-0\"><label translate=\"CREATE_RES.CUST_MN_CC\"></label><input \nng-model=\"vm.payment_method[0].cc_mname\" name=\"cc_mn[$index]\" type=\"text\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"33\" flex-xs=\"100\" layout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0\"><label \ntranslate=\"CREATE_RES.CUST_LN_CC\"></label><input ng-model=\"vm.payment_method[0].cc_lname\" name=\"cc_ln[$index]\" \ntype=\"text\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div></div></div><div \nng-if=\"vm.payment_method[0].method === \'E-Check\'\" ng-disabled=\"vm.payment_method[0].method !=\'E-Check\'\" \nclass=\"fontsize-15\"><div><div layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10 datepicker-block\" layout=\"column\" flex-xs=\"100\" flex=\"100\" \nlayout-align=\"center \"><div layout=\"row\" flex=\"100\" layout-wrap><md-input-container class=\"md-block mb-0\" \nlayout=\"column\" flex=\"100\"><label>Name Of Bank</label><input ng-model=\"vm.payment_method[0].bankName\" name=\"bankName\" \ntype=\"text\" required autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container><input type=\"hidden\" \nng-model=\"vm.payment_method[0].payment_profile_id\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></div></div></div>\n<div layout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"33\" layout-align=\"center\"><md-input-container class=\"md-block mb-0\"><label>Account Type</label><md-select \nname=\"accountType\" ng-model=\"vm.payment_method[0].accountType\" required><md-option value=\"checking\">Checking\n</md-option><md-option value=\"saving\">Saving</md-option><md-option value=\"businessChecking\">Business Checking\n</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-gt-xs=\"33\" flex=\"100\" layout-align=\"center \">\n<md-input-container class=\"md-block mb-0\"><label>Account Number</label><input \nng-model=\"vm.payment_method[0].accountNumber\" name=\"accountNumber\" type=\"text\" ng-required=\"true\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex-gt-xs=\"33\" flex=\"100\" layout-align=\"center \"><md-input-container class=\"md-block mb-0\"><label>Routing Number\n</label><input ng-model=\"vm.payment_method[0].routingNumber\" name=\"routingNumber\" type=\"text\" ng-required=\"true\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"33\" \nlayout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0\"><label>Name On Account</label><input \nng-model=\"vm.payment_method[0].nameOnAccount\" name=\"nameOnAccount\" type=\"text\" required autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex-xs=\"100\" flex=\"33\" layout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0 mt-0\"><label>E-Check Type\n</label><md-select name=\"accountType\" ng-model=\"vm.payment_method[0].echeckType\" required><md-option value=\"PPD\">\nPrearranged Payment And Deposit Entry</md-option><md-option value=\"WEB\">Internet-Initiated Entry</md-option>\n</md-select></md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"33\" \nflex-xs=\"100\" layout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0\"><label>Check Number</label><input \nng-model=\"vm.payment_method[0].checkNumber\" name=\"checkNumber\" type=\"text\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div></div></div></div><div layout=\"row\" flex=\"100\" \nclass=\"margin-bottom-15 margin-top-10\" ng-if=\"vm.resDetails.typeofService ==\'retail\'\"><md-input-container \nclass=\"md-block mb-0 md-input-has-value no-margin padding-top-8\" layout=\"column\" flex=\"100\" flex-gt-md=\"100\" \nflex-gt-xs=\"100\" layout-align=\"center \"><md-checkbox type=\"checkbox\" ng-model=\"vm.giftCard\" class=\"no-margin\">\n</md-checkbox>&nbsp;<span class=\"\" translate=\"CREATE_RES.GIFT_CARD\"></span></md-input-container></div><div \nng-if=\"vm.giftCard && vm.resDetails.typeofService ==\'retail\'\" ng-disabled=\"!vm.giftCard\"><div layout=\"row\" flex=\"100\">\n<div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" layout-align=\"center\"><div layout=\"row\" flex>\n<md-input-container class=\"md-block mb-0 mb-0\"><label>Apply gift card</label><input ng-model=\"vm.giftCardCode\" \nname=\"giftCard\" type=\"text\" required><div class=\"emailError\">{{vm.giftCardErrro}}</div></md-input-container><md-button \nstyle=\"max-height:40px\" class=\"md-raised\" ng-click=\"vm.validateGCCode($index)\" \nng-disabled=\"vm.giftCardCode==\'\' || vm.gcrequestGoing\">Add<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.gcrequestGoing\"></md-progress-circular>\n</md-button></div></div></div></div><div></div></div></form></collapsible-item></ang-accordion><div \nclass=\"list-customer-subtotal checkout-btn-block-main no-border\" flex=\"100\" layout=\"row\" layout-align=\"center center\">\n<div flex=\"50\" flex-md=\"50\" layout=\"column\" ng-if=\"vm.resDetails.typeofService != \'retail\'\"><md-button \nclass=\"md-button md-raised md-accent white-fg no-margin addCartDiscount md-ink-ripple height-50\" \nng-click=\"vm.printInvoice()\" \nng-disabled=\" vm.orderProgressing || parseFloat(vm.minimumAmount) > parseFloat(vm.subTotal) || !vm.minimumAmount || vm.tempDisablePrint\">\nPrint Order Preview</md-button></div><div flex=\"50\" flex-md=\"50\" layout=\"column\" \nng-if=\"(vm.resDetails.typeofService == \'restaurant\' || vm.resDetails.typeofService == \'bar\') && vm.showCooksPreview\">\n<md-button class=\"md-button md-raised md-accent white-fg no-margin addCartDiscount md-ink-ripple height-50\" \nng-click=\"vm.printCooksOrder()\" \nng-disabled=\" vm.orderProgressing || parseFloat(vm.minimumAmount) > parseFloat(vm.subTotal) || !vm.minimumAmount || vm.tempDisablePrint\">\nPrint Cook Preview</md-button></div><div flex=\"{{vm.resDetails.typeofService == \'bar\'?\'50\':\'100\'}}\" \nflex-md=\"{{vm.resDetails.typeofService == \'bar\'?\'50\':\'100\'}}\" layout=\"column\"><md-button \nclass=\"md-button md-raised white-fg no-margin addCartDiscount md-ink-ripple height-50 room-add-btn md-green-500-bg\" \nng-click=\"vm.proceedToCheckout()\" \nng-disabled=\"!vm.payment_method[0][\'method\'] || vm.orderProgressing || parseFloat(vm.minimumAmount) > parseFloat(vm.subTotal) || !vm.minimumAmount || (vm.add_tip_to_order && vm.TipProductIndex==-1) || (vm.payment_method[0][\'method\'] == \'Check\' && !vm.payment_method[0].check_number) || vm.checkCreditCard()\">\n{{vm.buttonTitle}}</md-button></div></div></div></div></div><div layout=\"column\" flex=\"100\" flex-gt-md=\"55\" \nflex-gt-sm=\"50\" class=\"customer-left-block padding-20 accordion-design\" ng-if=\"vm.afterCreatePage\"><div \nclass=\"content height\" layout=\"row\" ng-init=\"my_id = 1\"><div class=\"main RowClick prop-amen-con\" flex=\"100\" \nflex-gt-md=\"100\" flex-gt-sm=\"100\" layout=\"column\" ms-scroll><div class=\"ordercreated\"><div class=\"ordercreatedinner\">\n<div class=\"iconsucess\"><md-icon md-font-icon=\"icon-check-all\"></md-icon></div><div class=\"pricetxtmain\">\n${{vm.finalTotal}}</div><p>Order has been created successfully</p><p>Itinerary number:<span> {{vm.itinerary_number}}\n</span></p></div></div><div class=\"ordercreatedform-block\"><div flex=\"100\" layout=\"row\"><md-input-container \nclass=\"mb-0 no-mdspacer pr-20 mt-10\" layout=\"column\" flex=\"70\"><input type=\"text\" ng-model=\"vm.customer_email\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container><md-button layout=\"column\" flex=\"30\" \nclass=\"md-button md-raised md-accent white-fg no-margin addCartDiscount md-ink-ripple height-40 line-height-btn\" \nng-click=\"vm.sendEmailToCustomer()\">Send</md-button></div></div><div class=\"btnneworder full-width\" flex=\"100\" \nlayout=\"row\" flex><div layout=\"column\" flex=\"50\"><md-button ng-if=\"vm.startneworder\" \nclass=\"md-button md-accent md-raised white-fg no-margin addCartDiscount md-ink-ripple height-50\" \nng-click=\"vm.startNewOrder()\">Start new order</md-button><md-button ng-if=\"!vm.startneworder\" \nclass=\"md-button md-accent md-raised white-fg no-margin addCartDiscount md-ink-ripple height-50\" \nng-click=\"vm.continueSplitOrder()\">Continue processing order</md-button></div><div layout=\"column\" flex=\"50\"><md-button\n layout=\"column\" class=\"md-button md-primary md-raised white-fg no-margin addCartDiscount md-ink-ripple height-50\" \nng-click=\"vm.printOrderInvoice()\">Print Order</md-button></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/contacts/contacts.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-box\"></md-icon><span \ntranslate=\"CONTACTS.CONTACTS\"></span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"CONTACTS.TOTAL_CUSTOMERS\"></span> <span>{{vm.totalCustomers}}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{\'SEARCH\' | translate}}\" ng-model=\"filterText\" flex></div><div class=\"logo\" layout=\"row\" \nlayout-align=\"center end\" ng-if=\"vm.userPermissions.indexOf(\'add_customer\') != -1\"><md-button \nclass=\"md-raised md-cornered\" id=\"add-contact-button\" ng-click=\"vm.exportData()\" aria-label=\"add contact\" \nng-disabled=\"vm.processingRequest\">Export as CSV</md-button><md-button class=\"md-raised md-cornered\" \nid=\"add-contact-button\" ng-click=\"vm.gotoaddcustomer()\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><i class=\"icon-plus icon-plus-main\"></i>\n {{ \'CONTACTS.CONTACT\' | translate }}</md-button></div></div></div></div></div><div class=\"content\"><div \nclass=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main RowClick\" ms-scroll><mdt-table \npaginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" selectable-rows=\"isDeletedAllowed\" \nalternate-headers=\"\'contextual\'\" selected-row-callback=\"selectedRowCallback(rows)\" \ndelete-row-callback=\"deleteSelectedItem()\" mdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n					\'table-row-id-key\': \'editCustomerId\',\n					\'column-keys\': [\n					\'name\',\n					\'customer_email\',\n					\'phone_number\',\n					\'no_of_stays\',\n					\'address\',\n					\'city\',\n					\'state\',\n					\'country\',\n					\'zip_code\',\n					\'is_active\',\n					\'editCustomerId\'\n					],\n				}\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'CONTACTS.NAME\' | translate }}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'CONTACTS.EMAIL\' | translate }}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\" \ncolumn-filter=\"{ \'valuesProviderCallback\': checkoutValuesCallback, \'placeholderText\': \'Enter phone number\', \'filterType\': \'input\'}\">\n{{ \'CONTACTS.PHONE_NUMBER\' | translate }}</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>\n{{ \'CONTACTS.NO_OF_STAYS\' | translate }}</span></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\" \ncolumn-filter=\"{ \'valuesProviderCallback\': checkoutValuesCallback, \'placeholderText\': \'Enter address\', \'filterType\': \'input\'}\">\n{{ \'CONTACTS.ADDRESS\' | translate }}</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\" \ncolumn-filter=\"{ \'valuesProviderCallback\': checkoutValuesCallback, \'placeholderText\': \'Enter city\', \'filterType\': \'input\'}\">\n{{ \'CONTACTS.CITY\' | translate }}</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\" \ncolumn-filter=\"{ \'valuesProviderCallback\': checkoutValuesCallback, \'placeholderText\': \'Enter state\', \'filterType\': \'input\'}\">\n{{ \'CONTACTS.STATE\' | translate }}</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\" \ncolumn-filter=\"{ \'valuesProviderCallback\': checkoutValuesCallback, \'placeholderText\': \'Enter country\', \'filterType\': \'input\'}\">\n{{ \'CONTACTS.COUNTRY\' | translate }}</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\" \ncolumn-filter=\"{ \'valuesProviderCallback\': checkoutValuesCallback, \'placeholderText\': \'Enter zip code\', \'filterType\': \'input\'}\">\n{{ \'CONTACTS.ZIPCODE\' | translate }}</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>\n{{ \'CONTACTS.STATUS\' | translate }}</span></mdt-column><mdt-column align-rule=\"left\"><span></span></mdt-column>\n</mdt-header-row><mdt-custom-cell html-content=\"true\" column-key=\"address\">\n{{ value && value.length > 20 ? (value.substring(0, 20) + \'...\') : (value || \'-\') }}</mdt-custom-cell><mdt-custom-cell \nhtml-content=\"true\" column-key=\"country\">{{value != 0 ? value : \'-\'}}</mdt-custom-cell><mdt-custom-cell \nhtml-content=\"true\" column-key=\"city\">\n{{ value && value.length > 20 ? (value.substring(0, 20) + \'...\') : (value || \'-\') }}</mdt-custom-cell><mdt-custom-cell \nhtml-content=\"true\" column-key=\"state\">{{value != 0 ? value : \'-\'}}</mdt-custom-cell><mdt-custom-cell \nhtml-content=\"true\" column-key=\"zip_code\">{{value != 0 ? value : \'-\'}}</mdt-custom-cell><mdt-custom-cell \nhtml-content=\"true\" column-key=\"phone_number\">{{value != 0 ? value : \'-\'}}</mdt-custom-cell><mdt-custom-cell \nhtml-content=\"true\" column-key=\"is_active\"><i \nng-class=\"value==1?\'icon-checkbox-marked-circle green-500-fg\':\'icon-cancel red-500-fg\'\" class=\"\"></i></mdt-custom-cell>\n<mdt-custom-cell html-content=\"true\" column-key=\"editCustomerId\"><a style=\"cursor:pointer\" \nng-click=\"clientScope.goToEditPage(value)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s16 ng-scope md-default-theme md-font material-icons icon-pencil\" role=\"img\" aria-label=\"icon-cog\"></md-icon>\n</a></mdt-custom-cell></mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/contacts/hotelCredit.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"hotelCredit\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"CONTACTS.ADDBALANCE\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><md-content class=\"md-padding\"><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" flex=\"\"><md-input-container \nclass=\"md-block tax-inputs mb-0 padding-left-10 padding-right-10\" flex-gt-xs=\"50\"><md-button \nclass=\"no-margin no-padding balance_info\" aria-label=\"BALANCEINFO\" layout=\"row\"><md-tooltip>\n{{ \'CONTACTS.BALANCEINFO\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-information\" class=\"showinfo\">\n</md-icon></md-button><label class=\"ng-scope md-required margin-left-10\" role=\"button\" translate=\"CONTACTS.CREDITS\">\n</label><input type=\"number\" name=\"minday\" ng-model=\"vm.hotelCredit.hc_amount\" required aria-invalid=\"true\" \nng-change=\"vm.calculateExceedingAmount()\" class=\"numbervalue\"><div><div class=\"emailError\" ng-if=\"vm.amountExceeds\">\n{{vm.amountExceeds}}</div></div></md-input-container><md-input-container \nclass=\"md-block md-datepicker padding-left-10 padding-right-10\" data-ng-animate=\"1\" flex-gt-xs=\"50\"><label \nclass=\"ng-scope margin-left-10\" role=\"button\" translate=\"CONTACTS.EXPIRYDATE\"></label><md-datepicker \nclass=\"birthday-input no-padding\" md-min-date=\"vm.minDate\" md-hide-icons=\"calendar\" \nng-model=\"vm.hotelCredit.expiry_date\" md-open-on-focus ng-model-options=\"{debounce: 500}\" required></md-datepicker>\n</md-input-container></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex=\"\">\n<md-input-container class=\"md-block md-datepicker padding-left-10 padding-right-10\" flex-gt-xs=\"50\" \ndata-ng-animate=\"1\"><label class=\"ng-scope margin-left-10\" role=\"button\" translate=\"CONTACTS.COMMENT\"></label><input \ntype=\"text\" name=\"first_name\" ng-model=\"vm.hotelCredit.hc_comment\" required aria-invalid=\"true\"></md-input-container>\n<md-input-container class=\"md-block md-datepicker md-input-has-value padding-left-10 padding-right-10\" flex-gt-xs=\"50\" \ndata-ng-animate=\"1\"><label class=\"ng-scope margin-left-10\" role=\"button\" translate=\"CONTACTS.NOTIFYCUSTOMER\"></label>\n<md-radio-group ng-model=\"vm.SendMail\"><md-radio-button value=\"yes\">Yes</md-radio-button><md-radio-button value=\"no\">No\n</md-radio-button></md-radio-group></md-input-container></div></md-content></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"layout-align-start-center layout-row\"><md-button type=\"submit\" ng-click=\"vm.updateBalance()\" \nng-class=\"hotelCredit.$invalid || vm.amountError || hotelCredit.$pristine?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-accent submit-button white-fg\'\" \nng-disabled=\"hotelCredit.$invalid || vm.amountError || hotelCredit.$pristine\" aria-label=\"SAVE\" translate=\"SAVE\">\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/create-res/create-res.html","<div class=\"page-layout simple tabbed\" layout=\"column\" id=\"create-res\" ngf-drop=\"vm.addDoc($files, $invalidFiles)\" \nngf-drag-over-class=\"\'dragover\'\" ng-model=\"vm.fileDrop\" name=\"fileDrop\" id=\"fileDrop\" ngf-max-size=\"10MB\" \nngf-pattern=\"vm.allowedFiles\" ngf-accept=\"vm.allowedFiles\"><form id=\"createResForm\" name=\"createResForm\"><div \nclass=\"header md-accent-bg relative-block\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button crossicon\" ng-click=\"vm.back()\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.pagetitle}}</div><div class=\"subtitle secondary-text\" \nng-if=\"vm.flag == \'edit\'\"><span translate=\"CREATE_RES.SUB_HEADER\"></span></div></div></div></div><div layout=\"row\" \nflex layout-align=\" end\"><md-icon md-font-icon=\"icon-calendar-plus\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" ng-click=\"vm.addroomincart()\" \nng-disabled=\"vm.creatingres\"><md-tooltip>{{\'CREATE_RES.\'+vm.title | translate}}</md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-attachment\" class=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" \nng-disabled=\"vm.creatingres\" ngf-select=\"vm.addDoc($files, $invalidFiles)\" ng-model=\"vm.file\" name=\"file\" id=\"file\" \nngf-max-size=\"10MB\" ngf-pattern=\"vm.allowedFiles\" ngf-accept=\"vm.allowedFiles\"><md-tooltip>Add File</md-tooltip>\n</md-icon><md-button \nng-class=\"vm.checkVessel || createResForm.$invalid || vm.exp_date || vm.notCardType || vm.checkAllCustomer() || vm.customerPresent || vm.creatingres?\'md-blue-grey-A100-bg md-raised md-background\':\'md-raised md-background\'\" \nng-disabled=\"createResForm.$invalid ||  vm.checkAllCustomer() || vm.exp_date || vm.customerPresent  || vm.notCardType || vm.creatingres || vm.checkVessel\" \ntype=\"button\" ng-click=\"vm.submitRes()\"><span translate=\"CREATE_RES.SAVE\"></span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.back()\" ng-disabled=\"vm.creatingres\"><span translate=\"CREATE_RES.CANCEL\">\n</span></md-button></div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\" \nclass=\"headerstickyProgress\"></md-progress-linear></div><div class=\"content content-scroll tab-container-section\"><div \nclass=\"md-whiteframe-1dp height\"><div class=\"role-list-outer height-main\"><md-tabs md-dynamic-height \nmd-selected=\"vm.selectedIndex\" ng-class=\"vm.tabsData.length==1?\'removeSingleTab\':\'createscreentab\'\"><md-tab \nlabel=\"{{cartSigle.product_name}}\" md-on-select=\"vm.tabChanged($index)\" ng-click=\"vm.tabChanged($index)\" \nng-repeat=\"(mykey ,cartSigle) in vm.tabsData\"><div layout=\"row\" flex=\"100\" layout-wrap \nlayout-align=\"space-between stretch\" class=\"ph-10\"><div layout=\"column\" class=\"halfblockinfo mt-20 mb-10\"><div \nclass=\"full-width\" style=\"height:100%\"><div class=\"role-list-out featured-rol-block no-padding\" \nstyle=\"margin:0px;height:100%\"><div class=\"roomName font-sizeroom\"><strong>{{ \'CREATE_RES.BILL_INFO\' | translate }}\n<md-icon ng-if=\"!vm.addRoomInItin\" md-font-icon=\"icon-account-multiple-plus\" \nclass=\"close-icon1 onlycursorPointer white-fg s-30 onlyFloatRight\" ng-click=\"vm.addcustomer($event,$index,\'customer\')\">\n<md-tooltip>{{ \'CONTACTS.ADD_CONTACT\' | translate }}</md-tooltip></md-icon></strong></div><div \nclass=\"white-bg padding-15\"><div><div class=\"detailmain\"><div class=\"title\">\n{{vm.cust_info.first_name}} {{vm.cust_info.last_name}}</div><div class=\"address\"><span>Address</span>\n: {{vm.cust_info.address}}</div><div class=\"city\"><span>City</span>: {{vm.cust_info.city}}</div><div class=\"state\">\n<span>State</span>: {{vm.cust_info.state}}</div><div class=\"zip_code\"><span>Zip code</span>: {{vm.cust_info.zip_code}}\n</div><div class=\"country\"><span>Country</span>: {{vm.cust_info.country}}</div><div class=\"phone\"><span>Phone</span>: \n<a href=\"tel:{{vm.cust_info.phone_number}}\">{{vm.cust_info.phone_number}}</a></div><div class=\"email\"><span>Email\n</span>: <a href=\"mailto:{{vm.cust_info.customer_email}}\">{{vm.cust_info.customer_email}}</a></div></div></div></div>\n</div></div></div><div layout=\"column\" class=\"halfblockinfo mt-20 mb-10\" \nng-if=\"vm.cartdetails.cart_type == \'room\' || vm.cartdetails.cart_type == \'rent\' || vm.cartdetails.cart_type == \'day_reservation\'\">\n<div class=\"full-width\" style=\"height:100%\"><div \nclass=\"section-right-genral role-list-out featured-rol-block no-padding\" style=\"margin:0px; height:100%\"><div \nclass=\"roomName font-sizeroom ph-15 pv-10\"><strong>{{ \'CREATE_RES.TRAVEL_INFO\' | translate }}<md-icon \nmd-font-icon=\"icon-account-multiple-plus\" class=\"close-icon1 onlycursorPointer white-fg s-30 onlyFloatRight\" \nng-click=\"vm.addcustomer($event,$index,\'customer\')\"><md-tooltip>{{ \'CONTACTS.ADD_CONTACT\' | translate }}</md-tooltip>\n</md-icon></strong></div><div class=\"white-bg padding-15\"><div><div class=\"detailmain\"><div class=\"title\">\n{{vm.cartdetails.cust_info.first_name}} {{vm.cartdetails.cust_info.last_name}}</div><div class=\"address\"><span>Address\n</span>: {{vm.cartdetails.cust_info.address}}</div><div class=\"city\"><span>City</span>\n: {{vm.cartdetails.cust_info.city}}</div><div class=\"state\"><span>State</span>: {{vm.cartdetails.cust_info.state}}\n</div><div class=\"zip_code\"><span>Zip code</span>: {{vm.cartdetails.cust_info.zip_code}}</div><div class=\"country\">\n<span>Country</span>: {{vm.cartdetails.cust_info.country}}</div><div class=\"phone\"><span>Phone</span>: <a \nhref=\"tel:{{vm.cartdetails.cust_info.phone_number}}\">{{vm.cartdetails.cust_info.phone_number}}</a></div><div \nclass=\"email\"><span>Email</span>: <a href=\"mailto:{{vm.cartdetails.cust_info.customer_email}}\">\n{{vm.cartdetails.cust_info.customer_email}}</a></div></div></div></div><div \nclass=\"display-inline-block1 role-list-out1 white-bg top-sp-main no-padding no-margin\"><div layout=\"row\" flex=\"100\" \nlayout-wrap></div></div></div></div></div><div layout=\"column\" class=\"halfblockinfo mt-20 mb-10\" \nng-if=\"vm.cartdetails.cart_type == \'boat\'\"><div class=\"full-width\" style=\"height:100%\"><div \nclass=\"section-right-genral role-list-out featured-rol-block no-padding\" style=\"margin:0px;height:100%\"><div \nclass=\"roomName font-sizeroom ph-15 pv-10\"><strong>{{ \'CREATE_RES.VESSEL_INFO\' | translate }}<md-icon \nmd-font-icon=\"icon-account-multiple-plus\" class=\"close-icon1 onlycursorPointer white-fg s-30 onlyFloatRight\" \nng-click=\"vm.addBoatData(event,$index,\'boat\')\"><md-tooltip>{{ \'CONTACTS.ADD_VESSEL\' | translate }}</md-tooltip>\n</md-icon></strong></div><div class=\"white-bg padding-15\"><div><div class=\"detailmain\"><div class=\"address\"><span>\nVessel type</span>: {{vm.cartdetails.boat_data.boat_type}}</div><div class=\"phone\"><span>Vessel name</span>\n: {{vm.cartdetails.boat_data.boat_name}}</div><div class=\"city\"><span>Vessel model</span>\n: {{vm.cartdetails.boat_data.boat_model}}</div><div class=\"city\"><span>Vessel make</span>\n: {{vm.cartdetails.boat_data.boat_make}}</div><div class=\"state\"><span>Vessel length</span>\n: {{vm.cartdetails.boat_data.boat_length}}</div><div class=\"zip_code\"><span>Beam</span>\n: {{vm.cartdetails.boat_data.beam}}</div><div class=\"country\"><span>Draft</span>: {{vm.cartdetails.boat_data.draft}}\n</div></div></div></div><div class=\"display-inline-block1 role-list-out1 white-bg top-sp-main no-padding no-margin\">\n<div layout=\"row\" flex=\"100\" layout-wrap></div></div></div></div></div></div><div \nclass=\"left-section-genral-infomation\"><div class=\"genereal-div\"><div \nclass=\"role-list-out white-bg relative-block featured-block-main no-padding featured-rol-block\"><div \nclass=\"roomName ph-15 pv-10\" layout=\"row\" flex><div class=\"room-col\" layout=\"column\" flex=\"100\"><div layout=\"row\" flex \nlayout-wrap><div layout=\"column\" flex-gt-md=\"55\" flex-gt-xs=\"50\" flex=\"100\" layout-align=\"center start\"><div \nclass=\"row-containerstaus\"><strong>{{vm.cartdetails.product_name}} ({{vm.cartdetails.selelected_policy}})</strong><div \nclass=\"fromToInfo\" \nng-click=\"vm.changeDatesForCartItem($event,vm.cartdetails.product_id,vm.cartdetails.selelected_policy_id,$index)\"><div \nclass=\"fromInfo onlycursorPointer\"><img src=\"assets/images/ecommerce/from.svg\">{{vm.cartdetails.from}}</div><div \nclass=\"toInfo onlycursorPointer\"><img src=\"assets/images/ecommerce/to.svg\"> {{vm.cartdetails.to}}</div></div></div>\n</div><div layout=\"column\" flex-gt-md=\"45\" flex-gt-xs=\"50\" flex=\"100\" layout-align=\"center end\" class=\"pr-0\"><div \nclass=\"wrapactions create-res-room-header-actions\"><div \nclass=\"cc-fee-toggle create-res-cc-fee-toggle create-res-cc-fee-toggle--header\" style=\"pointer-events:auto\" \nng-if=\"vm.showCcProcessingFeeControlsCreateRes() && vm.hasCcProcessingFeeInRoomTaxes()\"><md-checkbox class=\"no-margin\" \nng-model=\"vm.cartdetails.waiveCcProcessingFeeRoom\" ng-change=\"vm.toggleRemoveCcProcessingFeeRoomCreateRes(mykey)\">\n{{ vm.cartdetails.waiveCcProcessingFeeRoom ? \'CC processing fee removed.\' : \'Remove CC processing fee\' }}</md-checkbox>\n</div><div class=\"input-block-status1\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/room-service.svg\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" ng-click=\"vm.addServices(mykey)\"><md-tooltip>\n{{\'CREATE_RES.ADD_SERVICE\' | translate}}</md-tooltip></md-icon><md-icon \nng-if=\"(vm.cartdetails.cart_type == \'room\' || vm.cartdetails.cart_type == \'rent\' || vm.cartdetails.cart_type == \'day_reservation\') && vm.isShowPosPopupOnReservationEnabled()\" \nmd-font-icon=\"icon-cart\" class=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" \nng-click=\"vm.openQuickPosOverlay($index)\"><md-tooltip>{{\'CREATE_RES.QUICK_POS\' | translate}}</md-tooltip></md-icon>\n<md-icon ng-if=\"vm.parking_access\" md-font-icon=\"icon-parking\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" ng-click=\"vm.addParking($event,$index)\"><md-tooltip>\n{{\'CREATE_RES.ADD_PARKING\' | translate}}</md-tooltip></md-icon><md-icon ng-if=\"vm.cartdetails.cart_type == \'boat\'\" \nmd-font-icon=\"icon-parking\" class=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" \nng-click=\"vm.addBoatPos($event,$index,vm.cartdetails.product_id)\"><md-tooltip>{{\'CREATE_RES.ADD_BOAT\' | translate}}\n</md-tooltip></md-icon></div></div></div></div></div></div><div class=\"display-inline-block\"><div \nclass=\"room-detail-block\" layout=\"row\" flex=\"100\"><div class=\"R-D-col-left padding-20\" flex=\"100\" layout-wrap \nlayout=\"row\" ng-if=\"vm.cartdetails.cart_type == \'room\' || vm.cartdetails.cart_type == \'day_reservation\'\"><div \nclass=\"adlt-child-block ph-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" layout-align=\"start start\">\n<div class=\"full-width\"><div class=\"sm-section-aldult\"><div class=\"arrival-am-txt\">Adult</div><div \nclass=\"adult-input-block\"><md-input-container class=\"md-block mb-0 no-margin\"><md-select required placeholder=\"Adults\" \nng-model=\"vm.cartdetails.room_stay_guest_count\" class=\"\" \nng-change=\"vm.manageAdultChild(\'adult\');vm.setAdults($index);\" name=\"adults[$index]\"><md-option ng-value=\"n\" \nng-repeat=\"n in vm.adultRange\">{{n}}</md-option></md-select></md-input-container></div></div><div \nclass=\"sm-section-aldult\"><div class=\"arrival-am-txt\">Child</div><div class=\"adult-input-block\"><md-input-container \nclass=\"md-block mb-0 no-margin\"><md-select required placeholder=\"Children\" \nng-model=\"vm.cartdetails.room_stay_child_count\" class=\"\" ng-change=\"vm.manageAdultChild(\'child\');vm.setChild($index);\" \nname=\"child[$index]\"><md-option ng-value=\"i\" ng-repeat=\"i in vm.childRange\">{{i}}</md-option></md-select>\n</md-input-container></div></div></div></div><div class=\"adlt-child-block ph-10\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"33\" layout-align=\"start start\"><div class=\"full-width\"><div class=\"sm-section-aldult\"><div \nclass=\"arrival-am-txt\" translate=\"CREATE_RES.ARRIVAL_TIME\">Arrival time</div><div class=\"adult-input-block no-margin\">\n<md-input-container class=\"md-block mb-0 no-margin\"><md-select ng-model=\"vm.cartdetails.arrival_time\" \nng-change=\"vm.changeAdditionalInfo(\'arrival_time\',vm.cartdetails.arrival_time,$index)\"><md-option ng-value=\"key\" \nng-repeat=\"(key,arrival_dep) in vm.arrival_departure_time\">{{arrival_dep}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></div><div class=\"sm-section-aldult\"><div \nclass=\"arrival-am-txt\" translate=\"CREATE_RES.DEPARTURE_TIME\">Departure time</div><div \nclass=\"adult-input-block no-margin\"><md-input-container class=\"md-block no-margin\"><md-select \nng-model=\"vm.cartdetails.departure_time\" \nng-change=\"vm.changeAdditionalInfo(\'departure_time\',vm.cartdetails.departure_time,$index)\"><md-option ng-value=\"key\" \nng-repeat=\"(key,arrival_dep) in vm.arrival_departure_time\">{{arrival_dep}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></div></div></div><div class=\"adlt-child-block ph-10\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"33\" layout-align=\"start start\"><div class=\"full-width\">\n<md-input-container class=\"md-block mb-0 md-input-has-value mb-0\"><label translate=\"CREATE_RES.DO_NOT_MOVE\"></label>\n<md-radio-group \nng-change=\"vm.changeAdditionalInfo(\'room_number_locked_indicator\',vm.cartdetails.room_number_locked_indicator,$index)\" \nclass=\"no-margin\" ng-model=\"vm.cartdetails.room_number_locked_indicator\"><md-radio-button class=\"space-block-inline\" \nng-value=\"1\">Yes</md-radio-button><md-radio-button class=\"space-block-inline margin-left-30\" ng-value=\"0\">No\n</md-radio-button></md-radio-group></md-input-container></div></div></div></div><div class=\"boat-skipjack-wrapper\"><div\n class=\"inner-boat-wrapper lowest-price-content\" ng-if=\"vm.cartdetails.prices.dates.length > 31\"><div \nclass=\"accordian-cover\"><div class=\"accordian-row\"><div class=\"accordian-content\" \nng-repeat=\"(monthName,monthData) in vm.boatArrayFinal\"><h5 \nclass=\"accordian-title months{{monthName}} accordian-title-minus\" ng-click=\"vm.toggle(monthName,\'month\', \'boat\', \'\')\">\n<span class=\"monthname\">{{monthName}}</span> <span class=\"priceblockmain\"><span class=\"pricemaininner\"><b \nclass=\"discount\">${{vm.monthOverallTotal[monthName][\'discount\']}}</b> <small class=\"totalblk\">Discount</small> </span>\n<span class=\"pricemaininner\">${{vm.monthOverallTotal[monthName][\'price\'] }} <small class=\"totalblk\">Total </small>\n</span></span><span class=\"paidamount\"><span><b class=\"paidmain\">${{vm.PaidValues[monthName]}}</b> <small \nclass=\"totalblk\">Paid</small> </span><span><b class=\"owe\">${{vm.owesValues[monthName]}}</b> <small class=\"totalblk\">\nOwes</small></span></span></h5><div class=\"accordian-inner-content dropdown-container create-week-wrapper\" \nstyle=\"display: none\"><div class=\"accordian-content weekContainer weekafter\" ng-repeat=\"(weekName,items) in monthData\">\n<h5 class=\"accordian-title weeks{{weekName}}{{monthName}} accordian-title-minus\" \nng-click=\"vm.toggle(weekName+monthName,\'week\', \'boat\', \'\')\"><span class=\"newhtmlappend monthsblock\" \nng-bind-html=\"vm.getWeekHeaderName(items,monthName+weekName)\"></span> <span class=\"priceblockouter\"><span \nclass=\"pricemaininner\"><b class=\"discount\">${{vm.weekOverallTotal[monthName+weekName][\'discount\']}}</b> <small \nclass=\"totalblk\">Discount</small> </span><span class=\"pricemaininner\">\n${{vm.weekOverallTotal[monthName+weekName][\'price\']}} <small class=\"totalblk\">Total </small></span></span><span \nclass=\"paidamount\"><span><b class=\"paidmain\">${{vm.weekPaidValues[monthName+weekName]}}</b> <small class=\"totalblk\">\nPaid</small> </span><span><b class=\"owe\">${{vm.weekOwesValues[monthName+weekName]}}</b> <small class=\"totalblk\">Owes\n</small></span></span></h5><div class=\"accordian-inner-content dropdown-container1\" style=\"display: none\"><div \nclass=\"nightlyscrollblk\"><div class=\"scroll-nightly-inner\"><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"row-block1-amount row-header-amount\"><div layout=\"column\" flex=\"20\" layout-align=\"center start\">Night</div><div \nlayout=\"column\" flex=\"20\" layout-align=\"center start\">Date</div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center start\">Rate Plan</div><div layout=\"column\" flex=\"20\" layout-align=\"center end\">Discount</div><div \nlayout=\"column\" flex=\"20\" layout-align=\"center end\">Price</div></div><div layout=\"row\" \nng-repeat=\"(eachKey, eachnight) in items\" flex=\"100\" layout-wrap class=\"row-nightly-amount row-block1-amount\"><div \nlayout=\"column\" flex=\"20\" layout-align=\"center start\"><div class=\"minusiconouter\"><div class=\"charges\">\nNight {{vm.cartdetails.prices.nightcount[eachKey]}}</div><div class=\"charges strikethrough\" \nng-if=\"vm.cartdetails.prices.canceled_nights.indexOf(items[eachKey]) >= 0\">Canceled Night</div><div \nng-class=\"vm.cartdetails.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\"><span \nng-class=\"vm.isloading?\'pointer_events_disabled onlycursorPointer minusiconred1\':\'onlycursorPointer minusiconred1\'\" \nng-click=\"vm.cancelThisNight(items[eachKey])\" \nng-if=\"(vm.cartdetails.prices.nightcount[eachKey]==1 || vm.cartdetails.prices.nightcount[eachKey]==vm.cartdetails.nights) && vm.cartdetails.nights>1 && vm.cartdetails.prices.canceled_nights.indexOf(items[eachKey]) < 0\">\n<md-icon md-font-icon=\"icon-minus-circle-outline\" class=\"s15 red-A800-fg\"><md-tooltip>No refund cancel</md-tooltip>\n</md-icon></span><span \nng-class=\"vm.isloading?\'pointer_events_disabled onlycursorPointer minusiconred1\':\'onlycursorPointer minusiconred1\'\" \nng-click=\"vm.undoCancelThisNight(items[eachKey])\" \nng-if=\"vm.cartdetails.prices.canceled_nights.indexOf(items[eachKey]) >= 0 && vm.cartdetails.prices.canUndoNights.indexOf(items[eachKey]) >= 0 && (vm.cartdetails.prices.nightcancelledCount[eachKey]==1 || vm.cartdetails.prices.nightcancelledCount[eachKey]==vm.cartdetails.prices.canceled_nights.length || (vm.cartdetails.prices.nightcancelledCount[eachKey + 1 ] == -1) ||(vm.cartdetails.prices.nightcancelledCount[eachKey + 1 ] != -1))\">\n<md-icon md-font-icon=\"icon-plus-circle-outline\" class=\"s15 md-accent\"><md-tooltip>Undo no refund cancel</md-tooltip>\n</md-icon></span></div></div></div><div layout=\"column\" flex=\"20\" layout-align=\"center start\"><div>\n{{vm.cartdetails.prices.dates[eachKey]}}</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center start\"><div>\n{{vm.cartdetails.prices.rate_plan[eachKey]}}</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center end\"><div \nclass=\"amount discount\"><md-input-container \nng-class=\"vm.cartdetails.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <span class=\"nightly-discount-value\" \nng-click=\"vm.opencommentboxNight(vm.selectedIndex,eachKey, \'nightly_discount\');\"><span class=\"nightly-discount-amount\">\n{{vm.cartdetails.prices.nightlydiscount[eachKey]}}</span><span class=\"nightly-discount-percent\" \nng-if=\"vm.cartdetails.prices.nightlydiscount[eachKey] > 0\">\n{{vm.getNightlyDiscountPercent(vm.cartdetails.prices.nightlydiscount[eachKey], vm.cartdetails.prices.rates[eachKey])}}%\n</span> </span><i ng-if=\"vm.cartdetails.prices.nightlydiscount[eachKey]>0\" \nclass=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.opencommentboxNight(vm.selectedIndex,eachKey, \'nightly_discount\');\"><md-tooltip \nng-if=\"vm.cartdetails.prices.nightlydiscountcomment[$index]!=\'\' && vm.cartdetails.promotion_applied == 0\">\n{{vm.cartdetails.prices.nightlydiscountcomment[eachKey]}}</md-tooltip><md-tooltip \nng-if=\"vm.cartdetails.promotion_applied == 1\">{{vm.cartdetails.promoTooltip}}</md-tooltip></i></md-input-container>\n</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center end\"><div class=\"amount\"><md-input-container \nng-class=\"vm.cartdetails.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <input ng-model-options=\"{updateOn: \'blur\'}\" \nng-change=\"vm.sumNights($parent.$parent.$parent.$index,$index)\" ng-model=\"vm.cartdetails.prices.rates[eachKey]\" \nname=\"rate_plan[vm.selectedIndex][eachKey]\" type=\"text\" allow-decimal-numbers ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></md-input-container></div></div></div></div></div></div></div></div></div></div></div></div><div \nclass=\"inner-boat-wrapper lowest-price-content\" \nng-if=\"vm.cartdetails.prices.dates.length >= 7 && vm.cartdetails.prices.dates.length <= 31\"><div \nclass=\"accordian-cover\"><div class=\"accordian-row\"><div class=\"accordian-content onlyWeekdata\"><div \nclass=\"accordian-inner-content dropdown-container weekcontent create-week-wrapper\"><div \nclass=\"accordian-content weekContainer\" ng-repeat=\"(weekName,items) in  vm.boatArrayFinal\"><h5 \nclass=\"accordian-title weeks{{weekName}}{{key}} accordian-title-minus\" \nng-click=\"vm.toggle(weekName+key,\'week\', \'boat\', \'\')\"><span class=\"newhtmlappend monthsblock\" \nng-bind-html=\"vm.getWeekHeaderName(items,monthName+weekName)\"></span> <span class=\"priceblockouter\"><span \nclass=\"pricemaininner\"><b class=\"discount\">${{vm.weekOverallTotal[weekName][\'discount\']}} </b><small class=\"totalblk\">\nDiscount</small> </span><span class=\"pricemaininner\">${{vm.weekOverallTotal[weekName][\'price\']}} <small \nclass=\"totalblk\">Total</small> </span></span><span class=\"paidamount\"><span><b class=\"paidmain\">\n${{vm.weekPaidValues[monthName+weekName]}}</b> <small class=\"totalblk\">Paid</small> </span><span><b class=\"owe\">\n${{vm.weekOwesValues[monthName+weekName]}}</b> <small class=\"totalblk\">Owes</small></span></span></h5><div \nclass=\"accordian-inner-content dropdown-container1\" style=\"display: none\"><div class=\"nightlyscrollblk\"><div \nclass=\"scroll-nightly-inner\"><div layout=\"row\" flex=\"100\" layout-wrap class=\"row-block1-amount row-header-amount\"><div \nlayout=\"column\" flex=\"20\" layout-align=\"center start\">Night</div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center start\">Date</div><div layout=\"column\" flex=\"20\" layout-align=\"center start\">Rate Plan</div><div \nlayout=\"column\" flex=\"20\" layout-align=\"center end\">Discount</div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center end\">Price</div></div><div layout=\"row\" ng-repeat=\"(eachKey, eachnight) in items\" flex=\"100\" \nlayout-wrap class=\"row-nightly-amount row-block1-amount\"><div layout=\"column\" flex=\"20\" layout-align=\"center start\">\n<div class=\"minusiconouter\"><div class=\"charges\">Night {{vm.cartdetails.prices.nightcount[eachKey]}}</div></div></div>\n<div layout=\"column\" flex=\"20\" layout-align=\"center start\"><div>{{vm.cartdetails.prices.dates[eachKey]}}</div></div>\n<div layout=\"column\" flex=\"20\" layout-align=\"center start\"><div>{{vm.cartdetails.prices.rate_plan[eachKey]}}</div>\n</div><div layout=\"column\" flex=\"20\" layout-align=\"center end\"><div class=\"amount discount\"><md-input-container \nng-class=\"vm.cartdetails.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <span class=\"nightly-discount-value\" \nng-click=\"vm.opencommentboxNight(vm.selectedIndex,eachKey, \'nightly_discount\')\"><span class=\"nightly-discount-amount\">\n{{vm.cartdetails.prices.nightlydiscount[eachKey]}}</span><span class=\"nightly-discount-percent\" \nng-if=\"vm.cartdetails.prices.nightlydiscount[eachKey] > 0\">\n{{vm.getNightlyDiscountPercent(vm.cartdetails.prices.nightlydiscount[eachKey], vm.cartdetails.prices.rates[eachKey])}}%\n</span> </span><i ng-if=\"vm.cartdetails.prices.nightlydiscount[eachKey]>0\" \nclass=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.opencommentboxNight(vm.selectedIndex,eachKey, \'nightly_discount\')\"><md-tooltip \nng-if=\"vm.cartdetails.prices.nightlydiscountcomment[$index]!=\'\' && vm.cartdetails.promotion_applied == 0\">\n{{vm.cartdetails.prices.nightlydiscountcomment[eachKey]}}</md-tooltip><md-tooltip \nng-if=\"vm.cartdetails.promotion_applied == 1\">{{vm.cartdetails.promoTooltip}}</md-tooltip></i></md-input-container>\n</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center end\"><div class=\"amount\"><md-input-container \nng-class=\"vm.cartdetails.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <input ng-model-options=\"{updateOn: \'blur\'}\" \nng-change=\"vm.sumNights($parent.$parent.$index,$index)\" ng-model=\"vm.cartdetails.prices.rates[eachKey]\" \nid=\"rate_plan_{{vm.selectedIndex}}{{eachKey}}\" name=\"rate_plan[vm.selectedIndex][eachKey]\" type=\"text\" \nallow-decimal-numbers ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div></div></div></div>\n</div></div></div></div></div></div></div></div><div class=\"inner-boat-wrapper\" \nng-if=\"vm.cartdetails.prices.dates.length < 7\"><div class=\"nightly-price-heading\">Nightly-price<div layout=\"row\" \nflex=\"100\" layout-wrap class=\"row-block1-amount row-header-amount\"><div layout=\"column\" flex=\"20\" \nlayout-align=\"center start\">Night</div><div layout=\"column\" flex=\"20\" layout-align=\"center start\">Date</div><div \nlayout=\"column\" flex=\"20\" layout-align=\"center start\">Rate plan</div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center end\">Discount</div><div layout=\"column\" flex=\"20\" layout-align=\"center end\">Price</div></div><div \nlayout=\"row\" ng-repeat=\"eachnight in vm.cartdetails.prices.dates\" flex=\"100\" layout-wrap \nclass=\"row-nightly-amount row-block1-amount\"><div layout=\"column\" flex=\"20\" layout-align=\"center start\"><div \nclass=\"charges\">Night {{$index+1}}</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center start\"><div \nclass=\"charges\">{{vm.cartdetails.prices.dates[$index]}}</div></div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center start\"><div class=\"charges\">{{vm.cartdetails.prices.rate_plan[$index]}}</div></div><div \nlayout=\"column\" flex=\"20\" layout-align=\"center end\"><div class=\"amount discount\"><md-input-container \nclass=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i><span class=\"nightly-discount-value\" \nng-click=\"vm.opencommentboxNight(mykey,$index,\'nightly_discount\')\"><span class=\"nightly-discount-amount\">\n{{ vm.cartdetails.prices.nightlydiscount[$index] }}</span><span class=\"nightly-discount-percent\" \nng-if=\"vm.cartdetails.prices.nightlydiscount[$index] > 0\">\n{{vm.getNightlyDiscountPercent(vm.cartdetails.prices.nightlydiscount[$index], vm.cartdetails.prices.rates[$index])}}%\n</span></span> <i ng-if=\"vm.cartdetails.prices.nightlydiscount[$index]>0\" \nclass=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.opencommentboxNight(mykey,$index,\'nightly_discount\');\"><md-tooltip \nng-if=\"vm.cartdetails.prices.nightlydiscountcomment[$index]!=\'\' && vm.cartdetails.promotion_applied == 0\">\n{{vm.cartdetails.prices.nightlydiscountcomment[$index]}}</md-tooltip><md-tooltip \nng-if=\"vm.cartdetails.promotion_applied == 1\">{{vm.cartdetails.promoTooltip}}</md-tooltip></i></md-input-container>\n</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center end\"><div class=\"amount price\"><md-input-container \nclass=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <input \nng-model=\"vm.cartdetails.prices.rates[$index]\" name=\"rate_plan[$parent.$index][$index]\" \nid=\"rate_plan_{{$parent.$index}}{{$index}}\" type=\"text\" required ng-change=\"vm.sumNights($parent.$index,$index)\" \nng-model-options=\"{updateOn: \'blur\'}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div></div>\n</div></div></div></div><div ng-repeat=\"(poskey, posValue) in vm.cartdetails.pos track by $index\"><div \nclass=\"timebound-div\" \nng-if=\"posValue.product_is_timebound != 1 && (posValue.tempHideSurcharge == undefined || (posValue.tempHideSurcharge != undefined && !posValue.tempHideSurcharge))\">\n<div class=\"nightly-price-latest padding-20 border-space-top\" style=\"padding:0px !important\"><div layout=\"row\" \nflex=\"100\" layout-wrap class=\"row-nightly-header-amount row-block1-amount\" \nng-class=\"(posValue.extra_attribute != undefined && posValue.extra_attribute == \'surcharge\' && vm.roomSurchargeAppliedValue[mykey] == \'Removed\') ? \'roomNameCanceled\' : \'roomNameActive\'\">\n<div layout=\"column\" flex-gt-md=\"70\" flex-gt-xs=\"60\" flex=\"100\" layout-align=\"center start\"><div \nclass=\"big-txt-night capitalize align-product-name\" \nng-class=\"{nopadding: (posValue.extra_attribute != undefined && (posValue.extra_attribute == \'resort_fee\' || posValue.extra_attribute == \'surcharge\') || (posValue.product_id == vm.insuranceProductId))}\">\n<md-icon md-font-icon=\"icon-delete\" class=\"red-A800-fg onlycursorPointer\" \nng-click=\"vm.deletePosElement($parent.$index,poskey,$event)\" \nng-if=\"posValue.extra_attribute == undefined || (posValue.extra_attribute != \'resort_fee\' && posValue.extra_attribute != \'surcharge\') && !(posValue.product_id == vm.insuranceProductId)\">\n</md-icon>{{posValue.product_name}}</div><div ng-if=\"posValue.is_gift_card == 1\" class=\"pl-30\"><span class=\"gcinfo\"><b>\nCustomer:</b> {{posValue.gc_sender_name}} (<a href=\"mailto:{{posValue.gc_sender_email}}\">{{posValue.gc_sender_email}}\n</a>) </span><span class=\"gcinfo gcinfo1\"><b>Recipient:</b> {{posValue.gc_recipient_name}} (<a \nhref=\"mailto:{{posValue.gc_recipient_email}}\">{{posValue.gc_recipient_email}}</a>)</span><br><span \nclass=\"gcinfo gcinfo1\"><b>Message:</b> {{posValue.gc_message}}</span></div></div><div \nng-if=\"posValue.product_attribute_fields.length>0\"><span class=\"gcinfo\" \nng-repeat=\"(key, value) in posValue.product_attribute_fields\"><b>{{posValue.product_attribute_fields[key]}}</b>\n {{posValue.product_attribute_values[key]}}</span></div><div flex-gt-md=\"30\" flex-gt-xs=\"40\" \nclass=\"wrapactions custom-wrapper-actions\" ng-class=\"posValue.product_id == vm.insuranceProductId ? \'no-flex\' : \'\'\">\n<div class=\"cc-fee-toggle create-res-cc-fee-toggle create-res-cc-fee-toggle--header\" style=\"pointer-events:auto\" \nng-if=\"vm.showCcProcessingFeeControlsCreateRes() && vm.hasCcProcessingFeeInPosTaxes(posValue) && !(posValue.product_id == vm.insuranceProductId)\">\n<md-checkbox class=\"no-margin\" ng-model=\"posValue.waiveCcProcessingFee\" \nng-change=\"vm.toggleRemoveCcProcessingFeePosCreateRes(mykey, poskey)\">\n{{ posValue.waiveCcProcessingFee ? \'CC processing fee removed.\' : \'Remove CC processing fee\' }}</md-checkbox></div><div\n class=\"wrapactions surcharge-wrap\" \nng-if=\"posValue.extra_attribute != undefined && posValue.extra_attribute == \'surcharge\'\"><div \nclass=\"input-block-status\"><md-input-container class=\"md-block mb-0 no-margin\" \nng-if=\"posValue.extra_attribute != undefined && posValue.extra_attribute == \'surcharge\'\"><md-select \nplaceholder=\"status\" ng-model=\"vm.roomSurchargeAppliedValue[mykey]\" ng-change=\"vm.toggleSurcharge(mykey)\" \nng-class=\"vm.order.show_status == \'Canceled\' ? \'canceled_order\' : \'\'\"><md-option ng-value=\"key\" \nng-repeat=\"(key, value) in vm.statusesSurcharge\">{{value}}</md-option></md-select></md-input-container></div></div><div\n class=\"active-input-block surcharge-active-input\"><div class=\"amount\"><span>${{posValue.grand_total | number: 2 }}\n</span></div></div></div></div><div class=\"pv-5 ph-20\"><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"row-nightly-amount row-block1-amount\" ng-if=\"!(posValue.product_id == vm.insuranceProductId)\"><div \nlayout=\"column\" flex=\"55\" layout-align=\"center start\"><div class=\"charges\">Quantity</div></div><div layout=\"column\" \nflex=\"15\" layout-align=\"center center\"></div><div layout=\"column\" flex=\"30\" layout-align=\"center end\"><div \nclass=\"amount\"><md-input-container class=\"md-block no-margin\"><input ng-model=\"posValue.quantity\" maxlength=\"4\" \nname=\"nightlySum[$index]\" type=\"text\" required \nng-change=\"vm.calculatePOSTotals(mykey,poskey,\'call\') && vm.changeProductDiscount(mykey,poskey,\'call\')\" \nng-model-options=\"{updateOn: \'blur\'}\" allow-decimal-numbers ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\" \nng-disabled=\"posValue.product_attribute_values.indexOf(\'surcharge\') > -1\"></md-input-container></div></div></div><div \nlayout=\"row\" flex=\"100\" layout-wrap class=\"row-nightly-amount row-block1-amount\" \nng-if=\"posValue.product_is_timebound != 1\"><div layout=\"column\" flex=\"55\" layout-align=\"center start\"><div \nclass=\"charges\">Subtotal</div></div><div layout=\"column\" flex=\"15\" layout-align=\"center center\"></div><div \nlayout=\"column\" flex=\"30\" layout-align=\"center end\"><div class=\"amount\"><md-input-container \nclass=\"md-block mb-0 no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <input ng-model=\"posValue.nightlySum\" \nname=\"nightlySum[$index]\" type=\"text\" required ng-change=\"vm.calculatePOSTotals(mykey,poskey,\'call\')\" \nng-model-options=\"{updateOn: \'blur\'}\" allow-decimal-numbers ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\" \nng-disabled=\"posValue.product_attribute_values.indexOf(\'surcharge\') > -1 || (posValue.product_id == vm.insuranceProductId)\">\n</md-input-container></div></div></div><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"row-nightly-amount row-block1-amount\" ng-if=\"posValue.product_is_timebound != 1\"><div layout=\"column\" flex=\"55\" \nlayout-align=\"center start\"><div class=\"charges\">Discount</div></div><div layout=\"column\" flex=\"15\" \nlayout-align=\"center center\"></div><div layout=\"column\" flex=\"30\" layout-align=\"center end\"><div class=\"amount\">\n<md-input-container class=\"md-block mb-0 no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <input \nng-model=\"posValue.product_discount\" name=\"productDiscount[$index]\" type=\"text\" required \nng-change=\"vm.changeProductDiscount(mykey,poskey,\'call\')\" ng-model-options=\"{updateOn: \'blur\'}\" allow-decimal-numbers \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\" \nng-disabled=\"posValue.product_attribute_values.indexOf(\'surcharge\') > -1 || posValue.promotion_applied == 1\"> <i \nng-if=\"posValue.product_discount>0\" class=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"(posValue.promotion_applied == undefined || posValue.promotion_applied == 0) ? vm.opencommentbox(mykey,poskey) : \'\';\">\n<md-tooltip ng-if=\"posValue.product_discount_comment!=\'\' && posValue.promotion_applied != 1\">\n{{posValue.product_discount_comment}}</md-tooltip><md-tooltip ng-if=\"posValue.promotion_applied == 1\">\n{{vm.cartdetails.promoTooltip}}</md-tooltip></i></md-input-container></div></div></div></div></div></div><div \nclass=\"non-timebound-div\" ng-if=\"posValue.product_is_timebound == 1\"><div \nng-class=\"(posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' && vm.resortFeeAppliedValue[mykey] == \'Removed\') ? \'roomNameCanceled\' : \'roomNameActive\'\" \nlayout=\"row\" flex class=\"border-space-top ph-15 pv-10 timebound-header pos-height-header\"><div class=\"room-col\" \nlayout=\"column\" flex=\"100\"><div layout=\"row\" layout-wrap flex=\"100\"><div layout=\"column\" flex-gt-xs=\"70\" flex-xs=\"100\" \nlayout-align=\"center start\"><div class=\"row-containerstaus\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"red-A800-fg onlycursorPointer\" ng-click=\"vm.deletePosElement($parent.$index,poskey,$event)\" \nng-if=\"posValue.extra_attribute == undefined || (posValue.extra_attribute != \'resort_fee\' && posValue.extra_attribute != \'extra_person\')\">\n</md-icon><strong>{{posValue.product_name}}</strong><div class=\"fromToInfo create-res\" \nng-if=\"posValue.product_is_timebound == 1 && posValue.is_timebound_with_availability != 1\"><div class=\"fromToInfo\"><div\n class=\"fromInfo onlycursorPointer\" ng-click=\"vm.editPosDates(posValue.from, posValue.to, poskey);\" \nng-class=\"posValue.auto_added == 1 ? \'pos-disabled\' : \'\'\"><img src=\"assets/images/ecommerce/from.svg\">{{posValue.from}}\n</div><div class=\"toInfo onlycursorPointer\" ng-click=\"vm.editPosDates(posValue.from, posValue.to, poskey);\" \nng-class=\"posValue.auto_added == 1 ? \'pos-disabled\' : \'\'\"><img src=\"assets/images/ecommerce/to.svg\"> {{posValue.to}}\n</div></div></div><div class=\"fromToInfo create-res\" \nng-if=\"posValue.product_is_timebound == 1 && posValue.is_timebound_with_availability == 1\"><div class=\"fromToInfo\"><div\n class=\"fromToInfo\" ng-click=\"vm.editParkingDates($event,posValue.product_id,poskey,mykey)\"><div \nclass=\"fromInfo onlycursorPointer\"><img src=\"assets/images/ecommerce/from.svg\">{{(posValue.from) | date:\"MM/dd/yyyy\"}}\n</div><div class=\"toInfo onlycursorPointer\"><img src=\"assets/images/ecommerce/to.svg\">\n{{(posValue.to | date:\"MM/dd/yyyy\")}}</div></div></div></div></div></div><div layout=\"column\" flex-gt-xs=\"30\" \nflex-xs=\"100\" layout-align=\"center end\" class=\"pr-0\"><div class=\"wrapactions create-res-room-header-actions\"><div \nclass=\"cc-fee-toggle create-res-cc-fee-toggle create-res-cc-fee-toggle--header\" style=\"pointer-events:auto\" \nng-if=\"vm.showCcProcessingFeeControlsCreateRes() && vm.hasCcProcessingFeeInPosTaxes(posValue) && !(posValue.product_id == vm.insuranceProductId)\">\n<md-checkbox class=\"no-margin\" ng-model=\"posValue.waiveCcProcessingFee\" \nng-change=\"vm.toggleRemoveCcProcessingFeePosCreateRes(mykey, poskey)\">\n{{ posValue.waiveCcProcessingFee ? \'CC processing fee removed.\' : \'Remove CC processing fee\' }}</md-checkbox></div><div\n class=\"input-block-status\"><md-input-container class=\"md-block mb-0 no-margin\" \nng-if=\"posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\'\"><md-select \nplaceholder=\"status\" ng-model=\"vm.resortFeeAppliedValue[mykey]\" ng-change=\"vm.toggleResortFee(mykey)\" \nng-class=\"vm.order.show_status == \'Canceled\' ? \'canceled_order\' : \'\'\"><md-option ng-value=\"key\" \nng-repeat=\"(key, value) in vm.statusesResort\">{{value}}</md-option></md-select></md-input-container></div><div \nclass=\"amountstatusblock ml-10 create-res\"><div class=\"amount\" \nng-class=\"(posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' && vm.resortFeeAppliedValue[mykey] == \'Removed\') ? \'strike\' : \'\'\">\n<span ng-class=\"(posValue.room_stay_status.toLowerCase() == \'canceled\') ? \'strike\' : \'\'\">\n{{posValue.grand_total | currency : $ }}</span></div></div></div></div></div></div></div><div \nclass=\"nightly-price-heading\"><div class=\"boat-post-div-wrapper\"><div class=\"progress_circular\" \nng-if=\"vm.loader[poskey] == \'true\'\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent md-hue-1\">\n</md-progress-circular></div><div class=\"boat-skipjack-wrapper\"><div class=\"inner-boat-wrapper lowest-price-content\" \nng-if=\"posValue.prices.dates.length > 31\"><div class=\"accordian-cover\"><div class=\"accordian-row\"><div \nclass=\"accordian-content\" ng-repeat=\"(monthName,monthData) in vm.posArrayFinal[poskey][0]\"><h5 \nclass=\"accordian-title posmonths{{monthName}}{{poskey}} accordian-title-minus\" \nng-click=\"vm.toggle(monthName,\'month\',\'pos\', poskey)\"><span class=\"monthname\">{{monthName}}</span> <span \nclass=\"priceblockmain\"><span class=\"pricemaininner\"><b class=\"discount\">\n${{vm.posmonthOverallTotalArray[poskey][monthName][\'discount\']}}</b> <small class=\"totalblk\">Discount</small> </span>\n<span class=\"pricemaininner\">${{vm.posmonthOverallTotalArray[poskey][monthName][\'price\']}} <small class=\"totalblk\">\nTotal </small></span></span><span class=\"paidamount\"><span><b class=\"paidmain\">\n${{vm.posmonthOverallTotalArray[poskey][monthName][\'paid\']}}</b> <small class=\"totalblk\">Paid</small> </span><span><b \nclass=\"owe\">${{vm.posmonthOverallTotalArray[poskey][monthName][\'owes\']}}</b> <small class=\"totalblk\">Owes</small>\n</span></span></h5><div class=\"accordian-inner-content dropdown-container create-week-wrapper\" style=\"display: none\">\n<div class=\"accordian-content weekContainer weekafter\" ng-repeat=\"(weekName,items) in monthData\"><h5 \nclass=\"accordian-title posweeks{{weekName}}{{key}}{{poskey}} accordian-title-minus\" \nng-click=\"vm.toggle(weekName+key,\'week\',\'pos\', poskey)\"><span class=\"newhtmlappend monthsblock\" \nng-bind-html=\"vm.getWeekHeaderName(items,monthName+weekName)\"></span> <span class=\"priceblockouter\"><span \nclass=\"pricemaininner\"><b class=\"discount\">${{vm.posweekOverallTotalArray[poskey][monthName+$index][\'discount\']}}</b> \n<small class=\"totalblk\">Discount</small> </span><span class=\"pricemaininner\">\n${{vm.posweekOverallTotalArray[poskey][monthName+$index][\'price\']}} <small class=\"totalblk\">Total </small></span>\n</span><span class=\"paidamount\"><span><b class=\"paidmain\">${{vm.posweekPaidValuesArray[poskey][monthName+$index]}}</b> \n<small class=\"totalblk\">Paid</small> </span><span><b class=\"owe\">\n${{vm.posweekOwesValuesArray[poskey][monthName+$index]}}</b> <small class=\"totalblk\">Owes</small></span></span></h5>\n<div class=\"accordian-inner-content dropdown-container1\" style=\"display: none\"><div class=\"nightlyscrollblk\"><div \nclass=\"scroll-nightly-inner\"><div layout=\"row\" flex=\"100\" layout-wrap class=\"row-block1-amount row-header-amount\"><div \nlayout=\"column\" flex=\"25\" layout-align=\"center start\">Night</div><div layout=\"column\" flex=\"25\" \nlayout-align=\"center start\">Date</div><div layout=\"column\" flex=\"25\" layout-align=\"center end\">Discount</div><div \nlayout=\"column\" flex=\"25\" layout-align=\"center end\">Price</div></div><div layout=\"row\" \nng-repeat=\"(eachKey, eachnight) in items\" flex=\"100\" layout-wrap class=\"row-nightly-amount row-block1-amount\"><div \nlayout=\"column\" flex=\"25\" layout-align=\"center start\"><div class=\"minusiconouter\"><div class=\"charges\">\nNight {{posValue.prices.nightcount[eachKey]}}</div></div></div><div layout=\"column\" flex=\"25\" \nlayout-align=\"center start\"><div>{{posValue.prices.dates[eachKey]}}</div></div><div layout=\"column\" flex=\"25\" \nlayout-align=\"center end\"><div class=\"amount discount\" \nng-class=\"(posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' && vm.resortFeeAppliedValue[mykey] == \'Removed\') ? \'strike\' : \'\'\">\n<md-input-container class=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <span \nclass=\"nightly-discount-value\" \nng-click=\"vm.opencommentboxNightPOS(mykey,poskey,eachKey,\'call\',$index, \'nightly_discount\')\"><span \nclass=\"nightly-discount-amount\">{{posValue.prices.nightlydiscount[eachKey]}}</span><span \nclass=\"nightly-discount-percent\" ng-if=\"posValue.prices.nightlydiscount[eachKey] > 0\">\n{{vm.getNightlyDiscountPercent(posValue.prices.nightlydiscount[eachKey], posValue.prices.rates[eachKey])}}%</span> \n</span><i ng-if=\"posValue.prices.nightlydiscount[eachKey]>0\" \nclass=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.opencommentboxNightPOS(mykey,poskey,eachKey,\'call\',$index,\'nightly_discount\')\"><md-tooltip \nng-if=\"posValue.prices.nightlydiscountcomment[$index]!=\'\' && posValue.promotion_applied == 0\">\n{{posValue.prices.nightlydiscountcomment[eachKey]}}</md-tooltip><md-tooltip ng-if=\"posValue.promotion_applied == 1\">\n{{vm.cartdetails.promoTooltip}}</md-tooltip></i></md-input-container></div></div><div layout=\"column\" flex=\"25\" \nlayout-align=\"center end\"><div class=\"amount\" \nng-class=\"(posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' && vm.resortFeeAppliedValue[mykey] == \'Removed\') ? \'strike\' : \'\'\">\n<md-input-container class=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <input \nng-model=\"posValue.prices.rates[eachKey]\" name=\"rate_plan[$parent.$index][eachKey]\" type=\"text\" required \nng-change=\"vm.sumNightsPOS(mykey,poskey,eachKey,\'call\')\" ng-model-options=\"{updateOn: \'blur\'}\" allow-decimal-numbers \nng-disabled=\"posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\'\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div></div></div></div></div></div></div></div>\n</div></div></div></div><div class=\"inner-boat-wrapper lowest-price-content\" \nng-if=\"posValue.prices.dates.length >= 7 && posValue.prices.dates.length <= 31\"><div class=\"accordian-cover\"><div \nclass=\"accordian-row\"><div class=\"accordian-content onlyWeekdata\"><div \nclass=\"accordian-inner-content dropdown-container weekcontent create-week-wrapper\"><div \nclass=\"accordian-content weekContainer\" ng-repeat=\"(weekName,items) in vm.posArrayFinal[poskey][0]\"><h5 \nclass=\"accordian-title posweeks{{weekName}}{{key}}{{poskey}} accordian-title-minus\" \nng-click=\"vm.toggle(weekName+key,\'week\',\'pos\', poskey)\"><span class=\"newhtmlappend monthsblock\" \nng-bind-html=\"vm.getWeekHeaderName(items,monthName+weekName)\"></span> <span class=\"priceblockouter\"><span \nclass=\"pricemaininner\"><b class=\"discount\">${{vm.posweekOverallTotalArray[poskey][$index][\'discount\']}}</b> <small \nclass=\"totalblk\">Discount</small> </span><span class=\"pricemaininner\">\n${{vm.posweekOverallTotalArray[poskey][$index][\'price\']}} <small class=\"totalblk\">Total</small> </span></span><span \nclass=\"paidamount\"><span><b class=\"paidmain\">${{vm.posweekPaidValuesArray[poskey][$index]}}</b> <small \nclass=\"totalblk\">Paid</small> </span><span><b class=\"owe\">${{vm.posweekOwesValuesArray[poskey][$index]}}</b> <small \nclass=\"totalblk\">Owes</small></span></span></h5><div class=\"accordian-inner-content dropdown-container1\" \nstyle=\"display: none\"><div class=\"nightlyscrollblk\"><div class=\"scroll-nightly-inner\"><div layout=\"row\" flex=\"100\" \nlayout-wrap class=\"row-block1-amount row-header-amount\"><div layout=\"column\" flex=\"25\" layout-align=\"center start\">\nNight</div><div layout=\"column\" flex=\"25\" layout-align=\"center start\">Date</div><div layout=\"column\" flex=\"25\" \nlayout-align=\"center end\">Discount</div><div layout=\"column\" flex=\"25\" layout-align=\"center end\">Price</div></div><div \nlayout=\"row\" ng-repeat=\"(eachKey, eachnight) in items\" flex=\"100\" layout-wrap \nclass=\"row-nightly-amount row-block1-amount\"><div layout=\"column\" flex=\"25\" layout-align=\"center start\"><div \nclass=\"minusiconouter\"><div class=\"charges\">Night {{posValue.prices.nightcount[eachKey]}}</div></div></div><div \nlayout=\"column\" flex=\"25\" layout-align=\"center start\"><div>{{posValue.prices.dates[eachKey]}}</div></div><div \nlayout=\"column\" flex=\"25\" layout-align=\"center end\"><div class=\"amount discount\" \nng-class=\"(posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' && vm.resortFeeAppliedValue[mykey] == \'Removed\') ? \'strike\' : \'\'\">\n<md-input-container class=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <span \nclass=\"nightly-discount-value\" \nng-click=\"vm.opencommentboxNightPOS(mykey,poskey,eachKey,\'call\',$index, \'nightly_discount\')\"><span \nclass=\"nightly-discount-amount\">{{posValue.prices.nightlydiscount[eachKey]}}</span><span \nclass=\"nightly-discount-percent\" ng-if=\"posValue.prices.nightlydiscount[eachKey] > 0\">\n{{vm.getNightlyDiscountPercent(posValue.prices.nightlydiscount[eachKey], posValue.prices.rates[eachKey])}}%</span> \n</span><i ng-if=\"posValue.prices.nightlydiscount[eachKey]>0\" \nclass=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.opencommentboxNightPOS(mykey,poskey,eachKey,\'call\',$index, \'nightly_discount\')\"><md-tooltip \nng-if=\"posValue.prices.nightlydiscountcomment[$index]!=\'\' && posValue.promotion_applied == 0\">\n{{posValue.prices.nightlydiscountcomment[eachKey]}}</md-tooltip><md-tooltip ng-if=\"posValue.promotion_applied == 1\">\n{{vm.cartdetails.promoTooltip}}</md-tooltip></i></md-input-container></div></div><div layout=\"column\" flex=\"25\" \nlayout-align=\"center end\"><div class=\"amount\" \nng-class=\"(posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' && vm.resortFeeAppliedValue[mykey] == \'Removed\') ? \'strike\' : \'\'\">\n<md-input-container class=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <input \nng-model=\"posValue.prices.rates[eachKey]\" name=\"rate_plan[$parent.$index][eachKey]\" type=\"text\" required \nng-change=\"vm.sumNightsPOS(mykey,poskey,eachKey,\'call\')\" ng-model-options=\"{updateOn: \'blur\'}\" \nng-disabled=\"posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\'\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div></div></div></div></div></div></div></div>\n</div></div></div></div><div class=\"nightly-price-heading inner-boat-wrapper\" ng-if=\"posValue.prices.dates.length < 7\">\nNightly-price<div class=\"nightlyscrollblk\"><div class=\"scroll-nightly-inner\"><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"row-block1-amount row-header-amount\"><div layout=\"column\" flex=\"25\" layout-align=\"center start\">Night</div><div \nlayout=\"column\" flex=\"25\" layout-align=\"center start\">Date</div><div layout=\"column\" flex=\"25\" \nlayout-align=\"center end\">Discount</div><div layout=\"column\" flex=\"25\" layout-align=\"center end\">Price</div></div><div \nlayout=\"row\" ng-repeat=\"eachnight in posValue.prices.dates\" flex=\"100\" layout-wrap \nclass=\"row-nightly-amount row-block1-amount\"><div layout=\"column\" flex=\"25\" layout-align=\"center start\"><div \nclass=\"minusiconouter\"><div class=\"charges\">Night {{posValue.prices.nightcount[$index]}}</div></div></div><div \nlayout=\"column\" flex=\"25\" layout-align=\"center start\"><div>{{posValue.prices.dates[$index]}}</div></div><div \nlayout=\"column\" flex=\"25\" layout-align=\"center end\"><div class=\"amount discount\" \nng-class=\"(posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' && vm.resortFeeAppliedValue[mykey] == \'Removed\') ? \'strike\' : \'\'\">\n<md-input-container class=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <span \nclass=\"nightly-discount-value\" \nng-click=\"vm.opencommentboxNightPOS(mykey,poskey,$index,\'call\',$index, \'nightly_discount\')\"><span \nclass=\"nightly-discount-amount\">{{posValue.prices.nightlydiscount[$index]}}</span><span \nclass=\"nightly-discount-percent\" ng-if=\"posValue.prices.nightlydiscount[$index] > 0\">\n{{vm.getNightlyDiscountPercent(posValue.prices.nightlydiscount[$index], posValue.prices.rates[$index])}}%</span> \n</span><i ng-if=\"posValue.prices.nightlydiscount[$index]>0\" \nclass=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.opencommentboxNightPOS(mykey,poskey,$index,\'call\',$index, \'nightly_discount\')\"><md-tooltip \nng-if=\"posValue.prices.nightlydiscountcomment[$index]!=\'\' && posValue.promotion_applied == 0\">\n{{posValue.prices.nightlydiscountcomment[eachKey]}}</md-tooltip><md-tooltip ng-if=\"posValue.promotion_applied == 1\">\n{{vm.cartdetails.promoTooltip}}</md-tooltip></i></md-input-container></div></div><div layout=\"column\" flex=\"25\" \nlayout-align=\"center end\"><div class=\"amount price\" \nng-class=\"(posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' && vm.resortFeeAppliedValue[mykey] == \'Removed\') ? \'strike\' : \'\'\">\n<md-input-container class=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <input \nng-model=\"posValue.prices.rates[$index]\" name=\"rate_plan[$parent.$index][$index]\" type=\"text\" required \nng-change=\"vm.sumNightsPOS(mykey,poskey,$index,\'call\')\" ng-model-options=\"{updateOn: \'blur\'}\" allow-decimal-numbers \nng-disabled=\"posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\'\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div></div></div></div></div></div></div></div>\n</div></div></div></div></div><div class=\"role-list-out white-bg top-sp-main padding-btm fontsize-15\"><div \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" \nflex=\"50\" layout-align=\"center \"><md-input-container class=\"md-block mb-0\"><label translate=\"CREATE_RES.COMMENT\">\n</label><textarea ng-model=\"vm.cartdetails.comment\" name=\"comment[$index]\" \nng-change=\"vm.changeAdditionalInfo(\'comment\',vm.cartdetails.comment,$index)\"></textarea></md-input-container></div><div\n class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"50\" layout-align=\"center  \">\n<md-input-container class=\"md-block mb-0\"><label translate=\"CREATE_RES.SPECIAL_RQST\"></label><textarea \nng-model=\"vm.cartdetails.special_req\" name=\"special_req[$index]\" \nng-change=\"vm.changeAdditionalInfo(\'special_req\',vm.cartdetails.special_req,$index)\"></textarea></md-input-container>\n</div></div></div><div class=\"genral-block-top-outer\"><div layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"100\" \nflex-sm=\"100\" flex-xs=\"100\" class=\"ph-10 mt-10\"><div layout=\"row\" flex=\"100\" class=\"white-bg role-list-out no-margin\" \nlayout-wrap><div layout-gt-xs=\"column\" layout=\"row\" flex-gt-xs=\"70\" flex=\"100\" class=\"paymentblocktab pr-20\" \nng-if=\"($index==0 || vm.multOrSinglePayment == 0)\"><div class=\"promo-code-create-div\"><div \nclass=\"padding-right-10 promoinput padding-left-0\" layout=\"column\" flex=\"40\" layout-align=\"center start\" \nng-if=\"!vm.cartdetails.anyPromoApplied\"><div layout=\"row\" flex layout-align=\"center\"><md-input-container \nclass=\"md-block mb-0 mb-0\"><label>Promo Code</label><input ng-model=\"vm.cartdetails.promoCodeName\" name=\"promocode\" \ntype=\"text\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container><md-button style=\"max-height:40px\" \nclass=\"md-raised\" ng-click=\"vm.applyRemoveValidPromoCode(\'applied\', $index)\" \nng-disabled=\"vm.cartdetails.promoCodeName == \'\' || vm.promoRequestGoing\"><span>Apply</span><md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.promoRequestGoing\"></md-progress-circular>\n</md-button></div></div><div class=\"padding-right-10 promo-div padding-left-0\" layout=\"column\" flex=\"40\" \nlayout-align=\"center\" ng-if=\"vm.cartdetails.anyPromoApplied\"><div class=\"promocode-row\"><div class=\"promocodeleft\">\n<label>Promo Code</label><p>{{vm.cartdetails.promoCodeName}}</p></div><div class=\"promocoderight\"><label>\n{{vm.cartdetails.promoCodeDiscount | currency : $ : 2}}</label><p \nng-click=\"vm.applyRemoveValidPromoCode(\'remove\', $index)\"><md-icon md-font-icon=\"icon-close-circle\" \nclass=\"red-A800-fg\" style=\"font-size:17px\"></md-icon>Remove</p></div></div></div></div><div \nng-if=\"vm.addRoomInItin && vm.previousPaidCardDetails != vm.itinerary_number\"><div class=\"form-title mb-20\">\nPayment Information</div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"100\" \nlayout-align=\"center  \"><md-input-container><label>Select cards to be attached to room.</label><md-select \nng-model=\"vm.cardsToCopy\" multiple=\"multiple\"><md-optgroup label=\"Select cards to be attached to room.\" \nclass=\"notUpperCase\"><md-option ng-value=\"card.installment_id\" ng-repeat=\"card in vm.previousPaidCardDetails;\">\n{{card.card}}</md-option></md-optgroup></md-select></md-input-container></div></div><div \nng-if=\"vm.addRoomInItin && vm.previousPaidCardDetails == vm.itinerary_number\"><div class=\"form-title\">\nAdd Payment Method</div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"100\" \nlayout-align=\"center  \"><md-input-container><md-switch ng-change=\"vm.payment_method = {}\" class=\"m-0\" md-no-ink \naria-label=\"Switch No Ink\" ng-model=\"vm.hasPayment[$index]\">{{ vm.hasPayment[$index] ? \'Yes\':\'No\'}}</md-switch>\n</md-input-container></div></div><div \nng-if=\"(!vm.addRoomInItin || (vm.previousPaidCardDetails == vm.itinerary_number && vm.addRoomInItin && vm.hasPayment[$index])) && !vm.waiveDepositOff[$index]\">\n<div class=\"form-title mb-20\" ng-if=\"vm.showPaymentOptions\">Payment Information</div><div \nng-if=\"vm.tabsData.length != 1\"><md-input-container class=\"margin-bottom-10 padding-left-10 padding-right-10 mt-0\" \nng-if=\"$index==0\"><md-checkbox type=\"checkbox\" ng-model=\"vm.multOrSinglePayment\" ng-checked=\"true\" class=\"no-margin\">\n</md-checkbox>&nbsp;<span class=\"padding-left-10\" translate=\"ADD_ROOM.USEFORALLROOMS\"></span></md-input-container>\n</div><div layout=\"row\" flex=\"100\" class=\"margin-bottom-15 padding-left-10 padding-right-10 margin-bottom-30\" \nlayout-wrap><md-input-container class=\"md-block mb-0 md-input-has-value no-margin\" layout-gt-sm=\"column\" layout=\"row\" \nflex=\"100\" flex-gt-md=\"80\" flex-gt-sm=\"80\" layout-align=\"center \"><md-radio-group class=\"\" \nng-model=\"vm.payment_method[$index].method\" required layout=\"row\" flex=\"100\" \nng-change=\"vm.paymentMethodSelected(vm.payment_method[$index].method,$index)\"><md-radio-button layout=\"column\" \nflex=\"100\" flex-gt-md=\"25\" flex-gt-xs=\"50 \" layout-align=\"center \" \nclass=\"space-block-inline margin-right-0 full-width\" ng-repeat=\"paymentMethod in vm.all_payment_methods\" \nng-value=\"paymentMethod.heading\">{{paymentMethod.heading}}</md-radio-button></md-radio-group></md-input-container>\n<md-input-container class=\"md-block mb-0 md-input-has-value no-margin padding-top-8\" layout=\"column\" flex=\"100\" \nflex-gt-md=\"20\" flex-gt-sm=\"20\" layout-align=\"center\" ng-if=\"vm.showPaymentOptions\"><md-checkbox type=\"checkbox\" \nng-model=\"vm.giftCard\" class=\"no-margin\"></md-checkbox>&nbsp;<span class=\"padding-left-10\" \ntranslate=\"CREATE_RES.GIFT_CARD\" aria-label=\"gift card\"></span></md-input-container></div><div ng-if=\"vm.giftCard\" \nng-disabled=\"!vm.giftCard\"><div layout=\"row\" flex=\"100\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" layout-align=\"center\"><div layout=\"row\" flex><md-input-container class=\"md-block mb-0 mb-0\"><label>\nApply gift card</label><input ng-model=\"vm.giftCardCode\" name=\"giftCard\" type=\"text\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"><div class=\"emailError\">{{vm.giftCardErrro}}</div></md-input-container><md-button \nstyle=\"max-height:40px\" class=\"md-raised\" nd-disabled=\"vm.queryProgress\" ng-click=\"vm.validateGCCode(mykey)\">Add\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.gcrequestGoing\">\n</md-progress-circular></md-button></div></div></div></div><div ng-if=\"vm.payment_method[$index].method===\'Check\'\" \nng-disabled=\"vm.payment_method[$index].method!=\'Check\'\"><div layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"50\" layout-align=\"center\"><md-input-container \nclass=\"md-block mb-0 mb-0\"><label translate=\"CREATE_RES.CHECK_NO\"></label><input \nng-model=\"vm.payment_method[$index].check_number\" name=\"check_number[$index]\" type=\"text\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></md-input-container></div></div></div><div ng-if=\"vm.payment_method[$index].method===\'Other\'\" \nng-disabled=\"vm.payment_method[$index].method!=\'Other\'\"><div layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"50\" layout-align=\"center\"><md-input-container \nclass=\"md-block mb-0 mb-0\"><label translate=\"CREATE_RES.OTHER_COMMENT\"></label><textarea \nng-model=\"vm.payment_method[$index].other_comment\" name=\"other_comment[$index]\"></textarea></md-input-container></div>\n</div></div><div ng-if=\"vm.payment_method[$index].method === \'Credit Card\'\" \nng-disabled=\"vm.payment_method[$index].method!=\'Credit Card\'\" class=\"fontsize-15\"><label \nstyle=\"color:red; display:block\" id=\"authorizenet-swiper-status_{{$index}}\" ng-click=\"vm.swipeNow($index)\" \nfor=\"authorizenetswiper-data\" class=\"label_ready_toswipe\">{{vm.swipeText}}</label><input type=\"text\" \nstyle=\"height: 1px; width: 1px; border: 0 none; color: #FFF; font-size: 1px\" title=\"Swiper\" code=\"authorizenet\" \nclass=\"input-text webpos_swiper_input\" ng-model=\"vm.ccinfo_a\" ng-focus=\"vm.ReadySwipe()\" ng-blur=\"vm.ResetSwipe()\" \nng-keyup=\"vm.keyupfunction($event,$index)\" id=\"authorizenet-swiper-data_{{$index}}\" name=\"authorizenet-swiper-data\" \nvalue=\"    \" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10 datepicker-block\" layout=\"column\" flex-xs=\"100\" flex=\"100\" \nlayout-align=\"center \"><div layout=\"row\" flex=\"100\" layout-wrap><md-input-container class=\"md-block mb-0\" \nlayout=\"column\" flex=\"100\"><label translate=\"CREATE_RES.CC_NUMBER\"></label><input \nng-model=\"vm.payment_method[$index].cc_number_mask\" name=\"cc_number_mask{{$index}}\" type=\"text\" required \nng-keyup=\"vm.creditCardChanged($index,$event,createResForm[\'cc_number\' + $index].$ccEagerType,vm.payment_method)\" \nmaxlength=\"16\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div \nng-show=\"createResForm[\'cc_number_mask\' + $index].$touched\"><div ng-show=\"!createResForm[\'cc_number\' + $index].$valid\" \nng-hide=\"createResForm[\'cc_number\' + $index].$valid\" class=\"emailError\">{{ \'CREATE_RES.CR_NOT_VALID\' | translate }}\n</div></div><div ng-show=\"vm.notCardType\" ng-hide=\"!vm.notCardType\" class=\"emailError\">\n{{ \'CREATE_RES.CR_NOT_ALOWD\' | translate }}</div></md-input-container><input \nng-model=\"vm.payment_method[$index].cc_number\" name=\"cc_number{{$index}}\" type=\"hidden\" cc-number cc-eager-type \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div cc_type=\"{{createResForm[\'cc_number\' + $index].$ccEagerType}}\" \nclass=\"{{createResForm[\'cc_number\' + $index].$ccEagerType}}\" layout=\"column\" flex=\"20\"></div></div></div></div><div \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"33\" \nflex-xs=\"100\" layout-align=\"center\"><md-input-container class=\"md-block mb-0\"><label translate=\"CREATE_RES.EXP_MONTH\">\n</label><md-select name=\"cc_exp_month{{$index}}\" ng-model=\"vm.payment_method[$index].cc_exp_month\" \nng-change=\"vm.checkValidExpDate($index)\"><md-option ng-value=\"key\" ng-repeat=\"(key,months) in vm.dates_option\">\n{{months}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"33\" flex-xs=\"100\" layout-align=\"center\">\n<md-input-container class=\"md-block mb-0\"><label translate=\"CREATE_RES.EXP_YEAR\"></label><md-select \nname=\"cc_exp_year{{$index}}\" ng-model=\"vm.payment_method[$index].cc_exp_year\" ng-change=\"vm.checkValidExpDate($index)\">\n<md-option ng-value=\"year\" ng-repeat=\"year in vm.yrs_option\">{{year}}</md-option></md-select><div \nng-show=\"vm.exp_date_err[$index]\" ng-hide=\"!vm.exp_date_err[$index]\" class=\"emailError expiryvalidateFalse\">\n{{ \'CREATE_RES.EX_DATE_NOT_VALID\' | translate }}</div><div class=\"md-errors-spacer\"></div></md-input-container></div>\n<div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"33\" layout-align=\"center \">\n<md-input-container class=\"md-block mb-0\"><label translate=\"CREATE_RES.CC_CVN\"></label><input \nng-model=\"vm.payment_method[$index].cc_cid\" name=\"cc_cid{{$index}}\" type=\"text\" cc-cvc \nng-required=\"vm.currentHotelId != 128 && vm.currentHotelId != 129\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div\n ng-show=\"createResForm[\'cc_cid\' + $index].$touched\"><div \nng-show=\"!createResForm[\'cc_cid\' + $index].$valid && !createResForm[\'cc_cid\' + $index].$error.required\" \nclass=\"emailError\">{{ \'CREATE_RES.CVN_NOT_VALID\' | translate }}</div></div></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" \nflex=\"33\" layout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0\"><label \ntranslate=\"CREATE_RES.CUST_FN_CC\"></label><input ng-model=\"vm.payment_method[$index].cc_fname\" name=\"cc_fname[$index]\" \ntype=\"text\" required ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"33\" layout-align=\"center \">\n<md-input-container class=\"md-block mb-0 mb-0\"><label translate=\"CREATE_RES.CUST_MN_CC\"></label><input \nng-model=\"vm.payment_method[$index].cc_mname\" name=\"cc_mname[$index]\" type=\"text\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"33\" \nflex-xs=\"100\" layout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0\"><label \ntranslate=\"CREATE_RES.CUST_LN_CC\"></label><input ng-model=\"vm.payment_method[$index].cc_lname\" name=\"cc_lname[$index]\" \ntype=\"text\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div></div></div><div \nng-if=\"vm.payment_method[$index].method === \'E-Check\'\" ng-disabled=\"vm.payment_method[$index].method !=\'E-Check\'\" \nclass=\"fontsize-15\"><div><div layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10 datepicker-block\" layout=\"column\" flex-xs=\"100\" flex=\"100\" \nlayout-align=\"center \"><div layout=\"row\" flex=\"100\" layout-wrap><md-input-container class=\"md-block mb-0\" \nlayout=\"column\" flex=\"100\"><label>Name Of Bank</label><input ng-model=\"vm.payment_method[$index].bankName\" \nname=\"bankName\" type=\"text\" required ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container><input \ntype=\"hidden\" ng-model=\"vm.payment_method[$index].payment_profile_id\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</div></div></div><div layout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"33\" layout-align=\"center\"><md-input-container class=\"md-block mb-0\"><label>\nAccount Type</label><md-select name=\"accountType\" ng-model=\"vm.payment_method[$index].accountType\" required><md-option \nvalue=\"checking\">Checking</md-option><md-option value=\"saving\">Saving</md-option><md-option value=\"businessChecking\">\nBisiness Checking</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-gt-xs=\"33\" flex=\"100\" layout-align=\"center \">\n<md-input-container class=\"md-block mb-0\"><label>Account Number</label><input \nng-model=\"vm.payment_method[$index].accountNumber\" name=\"accountNumber\" type=\"text\" ng-required=\"true\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-gt-xs=\"33\" flex=\"100\" layout-align=\"center \">\n<md-input-container class=\"md-block mb-0\"><label>Routing Number</label><input \nng-model=\"vm.payment_method[$index].routingNumber\" name=\"routingNumber\" type=\"text\" ng-required=\"true\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"33\" \nlayout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0\"><label>Name On Account</label><input \nng-model=\"vm.payment_method[$index].nameOnAccount\" name=\"nameOnAccount\" type=\"text\" required \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"33\" layout-align=\"center \">\n<md-input-container class=\"md-block mb-0 mb-0 mt-0\"><label>E-Check Type</label><md-select name=\"accountType\" \nng-model=\"vm.payment_method[$index].echeckType\" required><md-option value=\"PPD\">Prearranged Payment And Deposit Entry\n</md-option><md-option value=\"WEB\">Internet-Initiated Entry</md-option></md-select></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"33\" flex-xs=\"100\" layout-align=\"center \">\n<md-input-container class=\"md-block mb-0 mb-0\"><label>Check Number</label><input \nng-model=\"vm.payment_method[$index].checkNumber\" name=\"checkNumber\" type=\"text\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></md-input-container></div></div></div></div></div></div><div layout-gt-xs=\"column\" layout=\"row\" \nflex-gt-xs=\"{{(vm.multOrSinglePayment && $index>0)?\'100\':\'30\'}}\" flex=\"100\" \nng-class=\"(vm.multOrSinglePayment && $index>0)?\'subtotalborder-left\':\'subtotalborder-left pl-20\'\"><div \nclass=\"section-right-genral featured-rol-block no-padding white-bg\"><div class=\"display-inline-block no-margin\"><div \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"sub-total-section\" layout=\"row\" flex=\"100\" \nng-if=\"vm.showPaymentOptions\"><div class=\"sub-total-col md-accent-fg\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && $index>0)?\'70\':\'50\'}}\" \nlayout-align=\"{{(vm.multOrSinglePayment && $index>0)?\'center end\':\'center start\'}}\">Waive Deposit</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && $index>0)?\'30\':\'50\'}}\" \nlayout-align=\" end end\"><md-switch ng-change=\"vm.toggleWaiveDeposit($index, \'trigered\')\" class=\"m-0\" md-no-ink \naria-label=\"Switch No Ink\" ng-model=\"vm.waiveDepositOff[$index]\"></md-switch></div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap ng-if=\"!vm.extraPersonPos\"><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"{{(vm.multOrSinglePayment && $index>0)?\'70\':\'50\'}}\" \nlayout-align=\"{{(vm.multOrSinglePayment && $index>0)?\'center end\':\'center start\'}}\">Extra person charges</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && $index>0)?\'5\':\'15\'}}\" \nlayout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{ (vm.multOrSinglePayment && $index>0)?\'25\':\'35\'}}\" layout-align=\"center end \"><div class=\"amount\">\n<md-input-container class=\"md-block mb-0 no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <input \nng-model=\"vm.cartdetails.additional_guest_amounts\" name=\"additional_guest_amounts[$index]\" type=\"text\" required \nng-change=\"vm.calculateOwnTotals($index)\" ng-model-options=\"{updateOn: \'blur\'}\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></md-input-container></div></div></div><div class=\"sub-total-section\" layout=\"row\" flex=\"100\" \nlayout-wrap \nng-if=\" vm.cartdetails.extraPersonProduct != undefined && vm.cartdetails.extraPersonProduct.extra_attribute == \'extra_person\'\">\n<div class=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && mykey>0)?\'70\':\'50\'}}\" \nlayout-align=\"{{(vm.multOrSinglePayment && mykey>0)?\'center end\':\'center start\'}}\">\n{{ vm.cartdetails.extraPersonProduct.product_name }}</div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && mykey>0)?\'5\':\'15\'}}\" layout-align=\" center center\">:</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && mykey>0)?\'25\':\'35\'}}\" \nlayout-align=\"center end \">{{vm.cartdetails.extraPersonProduct.nightlySum | currency : $ : 2}}</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && $index>0)?\'70\':\'50\'}}\" \nlayout-align=\"{{(vm.multOrSinglePayment && $index>0)?\'center end\':\'center start\'}}\">Subtotal</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && $index>0)?\'5\':\'15\'}}\" \nlayout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && $index>0)?\'25\':\'35\'}}\" layout-align=\"center end\" \nng-if=\"!(vm.cartdetails.resortFeeApplied && vm.cartdetails.resortFeePos != undefined && vm.cartdetails.resortFeePos.extra_attribute == \'resort_fee\')\">\n<span \nng-if=\"vm.cartdetails.extraPersonProduct != undefined && vm.cartdetails.extraPersonProduct.extra_attribute == \'extra_person\'\">\n{{(vm.cartdetails.overalltotals.subtotal - vm.cartdetails.extraPersonProduct.nightlySum) | currency : $ : 2}} </span>\n<span \nng-if=\"vm.cartdetails.extraPersonProduct == undefined || vm.cartdetails.extraPersonProduct.extra_attribute == undefined \">\n{{vm.cartdetails.overalltotals.subtotal | currency : $ : 2}}</span></div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && $index>0)?\'25\':\'35\'}}\" layout-align=\"center end\" \nng-if=\"vm.cartdetails.resortFeeApplied && vm.cartdetails.resortFeePos != undefined && vm.cartdetails.resortFeePos.extra_attribute == \'resort_fee\'\">\n<span \nng-if=\"vm.cartdetails.extraPersonProduct != undefined && vm.cartdetails.extraPersonProduct.extra_attribute == \'extra_person\'\">\n{{(vm.cartdetails.overalltotals.subtotal - vm.cartdetails.resortFeePos.nightlySum - vm.cartdetails.extraPersonProduct.nightlySum) | currency : $ : 2}} \n</span><span \nng-if=\"vm.cartdetails.extraPersonProduct == undefined || vm.cartdetails.extraPersonProduct.extra_attribute == undefined\">\n{{ ( vm.cartdetails.overalltotals.subtotal - vm.cartdetails.resortFeePos.nightlySum ) | currency : $ : 2}}</span></div>\n</div><div class=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && $index>0)?\'70\':\'50\'}}\" \nlayout-align=\"{{(vm.multOrSinglePayment && $index>0)?\'center end\':\'center start\'}}\">Discount</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && $index>0)?\'5\':\'15\'}}\" \nlayout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && $index>0)?\'25\':\'35\'}}\" layout-align=\"center end\" \nng-if=\"vm.cartdetails.promoCodeDiscount != undefined && vm.cartdetails.promoCodeDiscount > 0\">\n{{vm.cartdetails.overalltotals.product_discount - vm.cartdetails.promoCodeDiscount | currency : $ : 2}}</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && $index>0)?\'25\':\'35\'}}\" \nlayout-align=\"center end \" \nng-if=\"vm.cartdetails.promoCodeDiscount == undefined || vm.cartdetails.promoCodeDiscount <= 0\">\n{{vm.cartdetails.overalltotals.product_discount | currency : $ : 2}}</div></div><div class=\"sub-total-section\" \nlayout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.cartdetails.promoCodeDiscount != undefined && vm.cartdetails.promoCodeDiscount > 0\"><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\" center start\">Promo code Discount</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"35\" layout-align=\"center end \">({{vm.cartdetails.promoCodeDiscount | currency : $ : 2}})</div>\n</div><div class=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.cartdetails.resortFeeApplied && vm.cartdetails.resortFeePos != undefined && vm.cartdetails.resortFeePos.extra_attribute == \'resort_fee\'\">\n<div class=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && mykey>0)?\'70\':\'50\'}}\" \nlayout-align=\"{{(vm.multOrSinglePayment && mykey>0)?\'center end\':\'center start\'}}\">\n{{ vm.cartdetails.resortFeePos.product_name }}</div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && mykey>0)?\'5\':\'15\'}}\" layout-align=\" center center\">:</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && mykey>0)?\'25\':\'35\'}}\" \nlayout-align=\"center end \">{{vm.cartdetails.resortFeePos.nightlySum | currency : $ : 2}}</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.cartdetails.overalltotals.tax_names.length > 0 && vm.cartdetails.overalltotals.tax_amounts[taxKey] > 0\" \nng-repeat=\"(taxKey,taxValue) in vm.cartdetails.overalltotals.tax_names\"><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && mykey>0)?\'70\':\'50\'}}\" \nlayout-align=\"{{(vm.multOrSinglePayment && mykey>0)?\'center end\':\'center start\'}}\"><p class=\"m-0\">{{taxValue}} <small>\n{{vm.taxNamedValues[taxValue] | currency : $ : 2}}%</small></p></div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && mykey>0)?\'5\':\'15\'}}\" layout-align=\" center center\">:</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && mykey>0)?\'25\':\'35\'}}\" \nlayout-align=\"center end \">{{vm.cartdetails.overalltotals.tax_amounts[taxKey] | currency : $ : 2}}</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"(vm.cartdetails.customerTaxExempt !== undefined && vm.cartdetails.customerTaxExempt) || (vm.cust_info.travellerTaxExempt !== undefined && vm.cust_info.travellerTaxExempt)\">\n<div class=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && mykey>0)?\'70\':\'50\'}}\" \nlayout-align=\"{{(vm.multOrSinglePayment && mykey>0)?\'center end\':\'center start\'}}\"><p class=\"m-0\" \nng-if=\"(vm.cartdetails.customerTaxExempt && vm.cartdetails.travellerTaxExempt) || vm.cartdetails.customerTaxExempt\">\nCustomer Tax Exempt</p><p class=\"m-0\" ng-if=\"vm.cartdetails.travellerTaxExempt && !vm.cartdetails.customerTaxExempt\">\nTraveller Tax Exempt</p></div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && mykey>0)?\'5\':\'15\'}}\" layout-align=\" center center\">:</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && mykey>0)?\'25\':\'35\'}}\" \nlayout-align=\"center end \">{{0 | currency : $ : 2}}</div></div><div class=\"sub-total-section\" layout=\"row\" flex=\"100\" \nlayout-wrap ng-if=\"vm.cartdetails.overalltotals.paidFromGC && vm.cartdetails.overalltotals.paidFromGC > 0\"><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && $index>0)?\'70\':\'50\'}}\" \nlayout-align=\"{{(vm.multOrSinglePayment && $index>0)?\'center end\':\'center start\'}}\">\nGift card({{vm.cartdetails.overalltotals.gift_card_code}})<md-icon md-font-icon=\"icon-delete\" \nclass=\"onlycursorPointer deleteGC\" ng-click=\"vm.removeGC(mykey)\"><md-tooltip>Remove gift card</md-tooltip></md-icon>\n</div><div class=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && $index>0)?\'5\':\'15\'}}\" \nlayout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && $index>0)?\'25\':\'35\'}}\" layout-align=\"center end \">\n{{vm.cartdetails.overalltotals.paidFromGC | currency : $ : 2}}</div></div><div class=\"sub-total-section\" layout=\"row\" \nflex=\"100\" layout-wrap ng-if=\"vm.cartdetails.overalltotals.surcharge && vm.cartdetails.overalltotals.surcharge > 0\">\n<div class=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && $index>0)?\'70\':\'50\'}}\" \nlayout-align=\"{{(vm.multOrSinglePayment && $index>0)?\'center end\':\'center start\'}}\"><div class=\"Surchargetxt\"><span>\nSurcharge</span> <span class=\"icon-information info-icon info-icon-tax-report\" role=\"button\" \nstyle=\"position: absolute; left: 76px; font-size: 19px\" ng-mouseenter=\"vm.showSurchargeTooltip(true);\" \nng-mouseleave=\"vm.showSurchargeTooltip(false);\" ng-if=\"vm.cartdetails.surchargeDesc != \'\'\"></span><div \nclass=\"infoTooltip\" ng-if=\"vm.showSurchargeDescTooltip\"><div class=\"tooltip-block-main\">\n{{vm.cartdetails.surchargeDesc}}</div></div></div></div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && $index>0)?\'5\':\'15\'}}\" layout-align=\" center center\">:</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && $index>0)?\'25\':\'35\'}}\" \nlayout-align=\"center end \">{{vm.cartdetails.overalltotals.surcharge | currency : $ : 2}}</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && $index>0)?\'70\':\'50\'}}\" \nlayout-align=\"{{(vm.multOrSinglePayment && $index>0)?\'center end\':\'center start\'}}\">Grand total</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && $index>0)?\'5\':\'15\'}}\" \nlayout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && $index>0)?\'25\':\'35\'}}\" layout-align=\"center end \">\n{{vm.cartdetails.overalltotals.grand_total | currency : $ : 2}}</div></div><div class=\"sub-total-section\" layout=\"row\" \nflex=\"100\" layout-wrap><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && $index>0)?\'70\':\'50\'}}\" \nlayout-align=\"{{(vm.multOrSinglePayment && $index>0)?\'center end\':\'center start\'}}\">Amount Due at Check In</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"{{ (vm.multOrSinglePayment && $index>0)?\'5\':\'15\'}}\" \nlayout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && $index>0)?\'25\':\'35\'}}\" layout-align=\"center end \">\n{{vm.cartdetails.overalltotals.remaining_amount | currency : $ : 2}}</div></div><div class=\"sub-total-section\" \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"sub-total-col md-accent-fg\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && $index>0)?\'70\':\'50\'}}\" \nlayout-align=\"{{(vm.multOrSinglePayment && $index>0)?\'center end\':\'center start\'}}\">Deposit amount due now</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && $index>0)?\'5\':\'15\'}}\" \nlayout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" flex=\"25\" layout-align=\"center end\" \nng-if=\"vm.addRoomInItin\">{{vm.cartdetails.overalltotals.deposit_amount}}</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"{{(vm.multOrSinglePayment && $index>0)?\'25\':\'35\'}}\" layout-align=\"center end \" \nng-if=\"!vm.addRoomInItin\"><md-input-container class=\"md-block mb-0 md-icon-float no-margin\"><md-icon \nmd-font-icon=\"icon-reload\" \nclass=\"onlycursorPointer md-icon-float md-default-theme flex-gt-xs-50 flex-100 md-input-invalid\" \nng-click=\"vm.setDepositOrig($index)\" ng-if=\"!vm.waiveDepositOff[$index]\"><md-tooltip>Refresh</md-tooltip></md-icon>\n<input name=\"deposit_amount[$index]\" type=\"text\" required ng-model=\"vm.cartdetails.overalltotals.deposit_amount\" \nng-change=\"vm.checkDepositAmt($index)\" allow-decimal-numbers ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\" \nng-disabled=\"vm.waiveDepositOff[$index]\" ng-focus=\"vm.clearZeroDepositAmount()\" \nng-keydown=\"vm.clearZeroOnType($event)\" ng-blur=\"vm.restoreZeroDepositAmount()\"> <input \nname=\"original_deposit_amt[$index]\" type=\"hidden\" required ng-model=\"vm.cartdetails.original_deposit_amt\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div></div></div></div></div></div></div></div>\n</div></div><div id=\"documents-tab\" class=\"genereal-div\" ng-show=\"vm.showDocs[$index]\"><div \nclass=\"role-list-out white-bg relative-block featured-block-main no-padding featured-rol-block\"><div \nclass=\"roomName font-sizeroom\"><strong>Uploaded Files</strong></div><div \nclass=\"white-bg padding-15 images images-uploded-block\"><div class=\"document-row-block\"><div \nclass=\"ducument-col-block\" ng-repeat=\"document in vm.documents[$index]\"><div class=\"pdf-cover\" \nng-click=\"vm.documentViewer($event,document.doc_name,document.type)\" style=\"cursor: pointer\"><img \nng-if=\"document.type == \'image\' || document.type == \'pdf\'\" \nsrc=\"{{vm.baseUrl}}assets/uploads/documents/thumbnail/{{document.thumbnail}}\"> <img ng-if=\"document.type == \'other\'\" \nsrc=\"assets/icons/file.svg\" class=\"iconimg\"></div><div class=\"pdf-content-cover-blk\"><div class=\"img-blockcardname\">\n{{ document.doc_name }}</div><div class=\"img-block-cardAddon\">Added {{ document.created_on }}</div><div \nclass=\"img-block-cardbutton\"><md-button ng-click=\"vm.downloadDocuments(document, $index)\">Download</md-button>\n<md-button ng-click=\"vm.deleteDocument(document, $index, $event)\" class=\"delete\">Delete</md-button></div></div></div>\n<div class=\"ducument-col-block\" ng-if=\"vm.uploading\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"loader-pdfmain md-accent\" md-diameter=\"30px\"></md-progress-circular></div></div></div></div></div><div \nclass=\"height-50\"></div></div></div></md-tab></md-tabs></div></div></div></form></div><style>\n.accordian-inner-content.dropdown-container.weekcontent.create-week-wrapper {\n	    width: 100%;\n	}\n	.create-week-wrapper .accordian-inner-content.dropdown-container1 {\n	    width: 100%;\n	}\n	.accordian-inner-content.dropdown-container.create-week-wrapper {\n	    width: 100%;\n	}\n</style>");
$templateCache.put("app/main/apps/dashboards/dashboard.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center fullwidthtabs\" layout=\"column\" flex><div ng-cloak><md-content ms-scroll class=\"scrollcontentmain\"><div \nclass=\"dashboard-header-filters\" layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.currentTab == \'Front desk\' || vm.currentTab == \'Marina\' || vm.currentTab == \'Revenue\'\"><md-select \nclass=\"propertyFilterSelect\" ng-model=\"vm.selectedPropertyId\" ng-change=\"vm.onPropertyFilterChange()\" \nng-if=\"vm.currentTab == \'Revenue\' && vm.subHotels.length > 0\" aria-label=\"Property filter\"><md-option ng-value=\"\'all\'\">\nALL</md-option><md-option ng-repeat=\"hotel in vm.subHotels\" ng-value=\"hotel.id\">{{hotel.name}}</md-option></md-select>\n<md-date-range class=\"daterangePicker daterangePicker_new\" ng-model=\"vm.frontDeskPicker\" show-template=\"false\" \nauto-confirm=\"true\" md-on-select=\"vm.mdDateRangeHandler($dates, \'frontdesk\')\" \nng-if=\"vm.currentTab == \'Front desk\' || vm.currentTab == \'Marina\'\"></md-date-range><md-date-range \nclass=\"daterangePicker daterangePicker_new\" ng-model=\"vm.revenuePicker\" show-template=\"false\" auto-confirm=\"true\" \nmd-on-select=\"vm.mdDateRangeHandler($dates, \'revenue\')\" ng-if=\"vm.currentTab == \'Revenue\'\"></md-date-range></div>\n<md-tabs md-dynamic-height md-border-bottom><md-tab label=\"{{tabs}}\" ng-click=\"vm.changePageFor(tabs)\" \nng-repeat=\"tabs in vm.tabsHeading\"><div ng-include=\"\'app/main/apps/dashboards/dash-views/dash-main-content.html\'\" \nng-if=\"tabs == \'Front desk\' || tabs == \'Marina\'\"></div><div \nng-include=\"\'app/main/apps/dashboards/dash-views/dash-revenue-content.html\'\" ng-if=\"tabs == \'Revenue\'\"></div><div \nng-include=\"\'app/main/apps/dashboards/dash-views/dash-restrictions-content.html\'\" ng-if=\"tabs == \'Restrictions\'\"></div>\n</md-tab></md-tabs></md-content></div></div></div>");
$templateCache.put("app/main/apps/dashboards/dashboardsDialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"ploicyForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll>\n<md-content class=\"md-padding\"><p class=\"form-title-small mt-0 mb-0\" bind-html-compile=\"vm.htmlContent\"></p>\n</md-content></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end end\" flex=\"100\"><md-checkbox class=\"no-margin\" ng-model=\"vm.send_email_indicator\" \nng-if=\"vm.newStatus != \'Active\' && vm.newStatus!=\'\'\"><span>Send Email</span></md-checkbox><md-button type=\"submit\" \nng-click=\"vm.hideDialog()\" ng-class=\"\'md-raised md-accent submit-button grey-100-fg md-green-500-bg\'\">{{vm.btnTxt}}\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/generate-invoice/generate-invoice.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cash\" class=\"mr-10\">\n</md-icon><span>Generate Invoices</span></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container Housekeepingtable incomereport\"><div class=\"table-title\">\nGenerate Invoices {{ vm.MonthName[vm.month-1]+\'-\'+vm.year }}</div><div layout=\"row\" flex=\"100\" class=\"ph-10\" \nlayout-wrap><div layout=\"column\" flex-gt-xs=\"50\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Month</label><md-select \nng-model=\"vm.month\" placeholder=\"Month\" class=\"birthday-input1 no-padding\"><md-option ng-value=\"month.value\" \nng-repeat=\"month in vm.allMonth\">{{month.name}}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div layout=\"column\" flex-gt-xs=\"50\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Year</label><md-select \nng-model=\"vm.year\" placeholder=\"Year\" class=\"birthday-input1 no-padding\"><md-option ng-value=\"year\" \nng-repeat=\"year in vm.allYear\">{{year}}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" class=\"ph-10\" layout-wrap><div layout=\"column\" \nflex-gt-xs=\"50\" flex=\"100\" class=\"ph-10\"><md-input-container><label>Channel</label><md-select \nng-model=\"vm.selectedChannels\" multiple=\"multiple\"><md-optgroup label=\"Channels\"><md-option \nng-value=\"channel.channel_name\" ng-repeat=\"channel in vm.channels\">{{ channel.channel_name }}</md-option></md-optgroup>\n</md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div layout=\"column\" flex-gt-xs=\"50\" \nflex=\"100\" class=\"ph-10\" layout-align=\"start end\"><div class=\"logo\"><md-button class=\"md-raised md-cornered\" \nng-click=\"vm.getInvoiceData()\" ng-disabled=\"vm.requestProcessing\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessing\"></md-progress-circular>\n</md-button><md-button ng-if=\"vm.invoiceData.length > 0\" class=\"md-raised md-cornered\" ng-csv=\"vm.csvData\" \ncsv-header=\"vm.csvHeader\" filename=\"{{vm.csvName}}\">Export as CSV</md-button><md-button \nng-if=\"vm.invoiceData.length > 0\" class=\"md-raised md-cornered\" ng-click=\"vm.printRecords()\" \nng-disabled=\"vm.requestProcessingEmail\">Email Report<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" \nmd-diameter=\"20px\" ng-show=\"vm.requestProcessingEmail\"></md-progress-circular></md-button></div><div \nclass=\"md-errors-spacer\"></div></div></div><div class=\"simple-table-container mt-20\" ng-if=\"vm.invoiceData.length > 0\">\n<div class=\"ms-responsive-table-wrapper ph-20 pb-20\"><table class=\"simple margin-border\" ms-responsive-table=\"\"><tr \nclass=\"headerrow\" ng-init=\"count = $index;\"></tr><tr class=\"headerrow\"><td>Confirmation Number</td><td>Status</td><td>\nSource</td><td>Product Name</td><td>Created Date</td><td>Arrival Date</td><td>Departure Date</td><td>Customer Name</td>\n<td>Email</td><td>Number of Nights/Quantity</td><td>Subtotal</td><td>Comission(2.5%)</td></tr><tbody><tr \nng-repeat=\"(cKey, rowData) in vm.invoiceData\" ng-init=\"vm.calculate(rowData.subtotal)\"><td>\n{{ rowData.confirmation_number }}</td><td>{{ rowData.room_stay_status }}</td><td>{{ rowData.source_of_creation }}</td>\n<td>{{ rowData.fe_display_product_name }}</td><td>{{ rowData.created_date }}</td><td>{{ rowData.room_stay_from }}</td>\n<td>{{ rowData.room_stay_to }}</td><td>{{ rowData.customer_name }}</td><td>{{ rowData.customer_email }}</td><td>\n{{ rowData.NoOfNights }}</td><td>{{ rowData.subtotal | currency : $ : 2}}</td><td>\n{{ (rowData.Comission | currency : $ : 2) }}</td></tr><tr class=\"total\"><td colspan=\"10\">Total</td><td colspan=\"1\">\n{{ vm.total | currency : $ : 2 }}</td><td colspan=\"1\">{{vm.comission | currency : $ : 2}}</td></tr></tbody></table>\n</div></div><div class=\"simple-table-container mt-20\"><div \nclass=\"ms-responsive-table-wrapper ph-20 pb-20 norecordFound\" ng-show=\"vm.invoiceData.length == 0\">No Result Found.\n</div></div></div></div></div>");
$templateCache.put("app/main/apps/groups/groups.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-multiple\"></md-icon><span \ntranslate=\"GROUPS.GROUPS\"></span></div><div class=\"product-count secondary-text\"><span translate=\"GROUPS.TOTAL_GROUPS\">\n</span> <span>{{vm.totalGroups}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex>\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input \nid=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" placeholder=\"{{ \'SEARCH\' | translate }}\" \nng-model=\"filterText\" flex></div><div class=\"logo\" layout=\"row\" layout-align=\"center end\"><md-button layout=\"row\" \nclass=\"md-raised md-cornered\" ng-click=\"vm.gotoaddRole()\" ng-if=\"vm.userPermissions.indexOf(\'add_group\')!=-1\"><i \nclass=\"icon-plus icon-plus-main\"></i> {{ \'GROUPS.GROUP\' | translate }}</md-button></div></div></div></div></div><div \nclass=\"content\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main RowClick\" \nms-scroll><mdt-table table-card=\"{visible: false, title: \'Users\'}\" \npaginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" selectable-rows=\"vm.delete_product\" \nalternate-headers=\"\'contextual\'\" selected-row-callback=\"selectedRowCallback(rows)\" \nmdt-row-paginator=\"paginatorCallback(page, pageSize, options, selected)\" delete-row-callback=\"deleteSelectedItem()\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\r\n        \'table-row-id-key\': \'group_id\',\r\n        \'column-keys\': [\r\n		\'group_name\',\r\n		\'total_members\',\r\n        \'group_id\'\r\n        ],\r\n    }\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'GROUPS.NAME\' | translate }}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'GROUPS.TOTAL_MEMBERS\' | translate }}</span>\n</mdt-column><mdt-column align-rule=\"left\"><span></span></mdt-column></mdt-header-row><mdt-custom-cell \nhtml-content=\"true\" column-key=\"group_id\"><a ng-click=\"clientScope.goToEditPage(value)\"><md-icon \nmd-font-icon=\"icon-icon-border-color\" class=\"icon icon-border-color cursorPointer\" role=\"img\" aria-label=\"icon-cog\">\n</md-icon></a></mdt-custom-cell></mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/groups/groupsAddEdit.html","<form name=\"groupForm\" class=\"md-inline-form fullwidth scroll-full-height\" novalidate><div id=\"groupPage\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page profileImage_page fullwidth\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-organizations-button md-icon-button\" aria-label=\"Go to users\" \nng-click=\"vm.gotoGroupListing()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\" \nng-if=\"vm.pageStatus != \'add\'\">{{vm.groupForm.group_name}}</div><div class=\"h2\" ng-if=\"vm.pageStatus == \'add\'\">\n{{ \'GROUPS.NEW_GROUP\' | translate }}</div><div ng-if=\"vm.pageStatus != \'add\'\" class=\"subtitle secondary-text\"><span \ntranslate=\"GROUPS.GROUP_DETAIL\"></span></div></div></div></div><div><md-button class=\"md-raised md-background\" \nng-click=\"vm.pageStatus == \'add\'? vm.saveGroup():vm.updateGroup()\" \nng-disabled=\"groupForm.$invalid || groupForm.$pristine || vm.users.length ==0 || vm.nameErrro\" \nng-class=\"{\'md-blue-grey-A100-bg\': groupForm.$invalid || groupForm.$pristine || vm.users.length ==0 || vm.nameErrro}\" \ntranslate=\"GROUPS.SAVE\"></md-button><md-button class=\"md-raised md-background\" ng-click=\"vm.gotoGroupListing();\"><span \ntranslate=\"GROUPS.CANCEL\"></span></md-button></div></div><div class=\"content scroll-height-sm\"><div \nclass=\"main sm-hearder-top scroll-full-height\" ms-scroll><div class=\"white-bg md-whiteframe-4dp relative-block\" \nlayout-align=\"center center\" layout-padding><div class=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start\" flex><div class=\"row-col\" flex-gt-xs=\"100\" layout-align=\"start start\" flex><md-input-container \nclass=\"md-block tax-inputs mb-0\" flex-gt-xs=\"100\"><label translate=\"GROUPS.GROUP_NAME\"></label><input type=\"text\" \nname=\"rate category\" ng-model=\"vm.groupForm.group_name\" required aria-invalid=\"true\" ng-change=\"vm.checkGroupName()\"> \n<span ng-if=\"vm.rateGroupNameExists\" class=\"errorMsg\">{{ vm.rateGroupNameExists }}</span></md-input-container>\n<md-content class=\"autocomplete group-chips\" layout=\"column\"><md-input-container class=\"mb-0 mt-0\"><label></label>\n<md-contact-chips ng-model=\"vm.users\" md-contacts=\"vm.querySearch($query)\" md-contact-name=\"name\" \nmd-contact-image=\"image\" md-contact-email=\"email\" md-require-match=\"true\" md-highlight-flags=\"i\" \nfilter-selected=\"vm.filterSelected\" placeholder=\"{{ \'GROUPS.MEMBERS\' | translate }}\" class=\"chips-inputs mt-0\" \nrequired></md-contact-chips><div class=\"md-errors-spacer\"></div></md-input-container><md-list class=\"fixedRows\"><div \nclass=\"members form-title title\" translate=\"GROUPS.MEMBERS\"></div><md-list-item \nclass=\"md-2-line list-block1 contact-item\" ng-repeat=\"(index, contact) in vm.allUsers\" \nng-if=\"vm.users.indexOf(contact) < 0\"><div class=\"md-list-item-text compact\"><h3 class=\"capitalize\">{{contact.name}}\n</h3><p>{{contact.email}}</p></div></md-list-item><md-list-item class=\"md-2-line list-block1 contact-item selected\" \nng-repeat=\"(index, contact) in vm.users\"><div class=\"md-list-item-text compact\"><h3>{{contact.name}}</h3><p>\n{{contact.email}}</p></div></md-list-item></md-list></md-content></div></div></div></div></div></div></form>");
$templateCache.put("app/main/apps/mls/mls.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-button ng-if=\"vm.hotel_id\" \nclass=\"goto-organizations-button md-icon-button\" aria-label=\"Go to organizations\" ng-click=\"vm.gotorolesusers()\">\n<md-icon md-font-icon=\"icon-arrow-left\" class=\"white-fg\"></md-icon></md-button><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><span translate=\"MLS.MLS\"></span></div><div \nclass=\"product-count secondary-text\"><span translate=\"MLS.TOTAL_MLS\"></span> <span>{{vm.totalUsers}}</span></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{ \'SEARCH\' | translate}}\" ng-model=\"filterText\" flex></div><div class=\"logo\" layout=\"row\" \nlayout-align=\"center end\" ng-if=\"vm.userPermissions.indexOf(\'add_restriction\')!=-1\"><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex ng-show=\"vm.showMultiplePropertes\"><md-input-container class=\"no-margin ph-20\">\n<md-select ng-model=\"vm.restriction\" ng-change=\"vm.fetchRestrictionType()\" class=\"whitedropdown\"><md-option \nng-value=\"boat.key\" ng-repeat=\"boat in vm.boatTypes\">{{boat.value}}</md-option><md-option value=\"room\">Room</md-option>\n<md-option value=\"boat\">Marina</md-option></md-select></md-input-container></div><md-button layout=\"row\" \nclass=\"md-raised md-cornered\" ng-click=\"vm.gotoAddMls()\"><i class=\"icon-plus icon-plus-main\"></i>\n {{ \'MLS.MLSS\' | translate }}</md-button></div></div></div></div></div><div class=\"content\"><div class=\"content\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"main RowClick\" ms-scroll><mdt-table \ntable-card=\"{visible: false, title: \'Users\'}\" paginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" \nselectable-rows=\"vm.delete_product\" alternate-headers=\"\'contextual\'\" selected-row-callback=\"selectedRowCallback(rows)\" \nmdt-row-paginator=\"paginatorCallback(page, pageSize, options, selected)\" delete-row-callback=\"deleteSelectedItem()\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\r\n        \'table-row-id-key\': \'mls_id\',\r\n        \'column-keys\': [\r\n		\'mls_from\',\r\n		\'mls_to\',\r\n		\'mls_days\',\r\n        \'mls_id\'\r\n        ],\r\n    }\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'MLS.FROM\' | translate }}</span></mdt-column>\n<mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'MLS.TO\' | translate }}</span></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><span>{{ \'MLS.MIN_DAYS\' | translate }}</span></mdt-column><mdt-column \nalign-rule=\"left\"><span></span></mdt-column></mdt-header-row><mdt-custom-cell html-content=\"true\" column-key=\"mls_id\">\n<a ng-click=\"clientScope.goToEditPage(value)\"><md-icon md-font-icon=\"icon-icon-border-color\" \nclass=\"icon icon-border-color cursorPointer\" role=\"img\" aria-label=\"icon-cog\"></md-icon></a></mdt-custom-cell>\n</mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/policy/childModel.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\" style=\"max-width:900px;width:900px\"><form name=\"childForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"POLICIES.CHILDREN_EXTRA_BEDS\"></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div><div class=\"contact-name\">\n{{vm.contact.name}}</div><div ng-if=\"vm.error\">{{ vm.error }}</div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:900px;max-height:1000px\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><md-content class=\"md-padding\"><div class=\"block-content-outer-pop\"><div \nclass=\"title padding-left-10 padding-right-10 padding-bottom-10\" translate=\"POLICIES.CHILDREN\"></div><div \nclass=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start start\" flex=\"100\" flex><md-input-container \nclass=\"md-block md-input-has-value padding-left-10 padding-right-10 full-width\" flex-gt-xs=\"100\" flex=\"100\" flex><label\n class=\"margin-left-10\" translate=\"POLICIES.CAN_CHILDREN_ACCOMMODATE\"></label><md-radio-group \nng-model=\"vm.childData.is_child_allowed\"><md-radio-button value=\"1\">{{ \'POLICIES.YES\' | translate }}</md-radio-button>\n<md-radio-button value=\"0\" class=\"margin-left-10\">{{ \'POLICIES.NO\' | translate }}</md-radio-button></md-radio-group>\n</md-input-container></div><div class=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start start\" \nflex=\"100\" flex ng-if=\"vm.childData.is_child_allowed == 1\"><md-input-container \nclass=\"md-block md-input-has-value padding-left-10 padding-right-10 full-width\" flex-gt-xs=\"100\" flex=\"100\" flex><label\n class=\"margin-left-10\" translate=\"POLICIES.CHILDREN_STAY_EXISTING_BED\"></label><md-radio-group \nng-init=\"  vm.childData.Existing_bed = vm.tempExisting\" ng-model=\"vm.childData.Existing_bed\"><md-radio-button \nvalue=\"1\">{{ \'POLICIES.YES\' | translate }}</md-radio-button><md-radio-button value=\"0\" class=\"margin-left-10\">\n{{ \'POLICIES.NO\' | translate }}</md-radio-button></md-radio-group></md-input-container></div><div \nclass=\"title padding-left-10 padding-right-10 padding-bottom-10\" \nng-if=\"vm.childData.Existing_bed == 1 && vm.childData.is_child_allowed == 1\" translate=\"POLICIES.EXISTING_BED_OPTION\">\n</div><div class=\"title padding-left-10 padding-right-10 padding-bottom-10\" \nng-if=\"vm.childData.Existing_bed == 1 && vm.childData.is_child_allowed == 1\"></div><div class=\"row-block\" \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start start\" flex=\"100\" flex \nng-if=\"vm.childData.Existing_bed == 1 && vm.childData.is_child_allowed == 1\"><md-input-container \nclass=\"md-block md-input-has-value padding-left-10 padding-right-10 full-width\" flex-gt-xs=\"100\" flex=\"100\" flex><label\n class=\"margin-left-10\" translate=\"POLICIES.NO_CHILDREN\"></label><md-select name=\"vm\" \nng-model=\"vm.childData.existing_extra_child_count_allowed\" required><md-option value=\"1\">1</md-option><md-option \nvalue=\"2\">2</md-option><md-option value=\"3\">3</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container><md-input-container \nclass=\"md-block md-input-has-value padding-left-10 padding-right-10 full-width\" flex-gt-xs=\"100\" flex=\"100\" flex><label\n class=\"margin-left-10\" translate=\"POLICIES.AGE_GROUP\"></label><md-select name=\"vm\" ng-model=\"vm.childData.child_age\" \nrequired><md-option value=\"{{child.age_qualifying_code}}\" ng-repeat=\"child in vm.childCategoryOptions\">\n{{child.age_qualifying_value+\' years old\'}}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container><md-input-container flex-gt-xs=\"100\" flex=\"100\" flex \nclass=\"padding-left-10 padding-right-10 full-width md-block\"><label class=\"margin-left-10\" \ntranslate=\"POLICIES.PRICE_PER_CHILD\"></label><input name=\"postalCode\" type=\"number\" \nng-model=\"vm.childData.child_price_per_night\" required ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div><div class=\"title padding-left-10 padding-right-10 padding-bottom-10\" \ntranslate=\"POLICIES.EXTRA_BED_OPTIONS\"></div><div class=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start start\" flex=\"100\" flex><md-input-container \nclass=\"md-block md-input-has-value padding-left-10 padding-right-10 full-width\" flex-gt-xs=\"100\" flex=\"100\" flex><label\n class=\"margin-left-10\" translate=\"POLICIES.EXTRA_BED_QUESTION\"></label><md-radio-group \nng-model=\"vm.childData.is_extra_bed_allowed\"><md-radio-button value=\"1\">{{ \'POLICIES.YES\' | translate }}\n</md-radio-button><md-radio-button value=\"0\" class=\"margin-left-10\">{{ \'POLICIES.NO\' | translate }}</md-radio-button>\n</md-radio-group></md-input-container></div><div class=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start start\" flex=\"100\" flex><md-input-container \nclass=\"md-block md-input-has-value padding-left-10 padding-right-10 full-width\" flex-gt-xs=\"50\" flex=\"50\" flex \nng-if=\"vm.childData.is_extra_bed_allowed !=0\"><label class=\"margin-left-10\" translate=\"POLICIES.EXTRA_BED_ADDED\">\n</label><md-select name=\"vm\" ng-model=\"vm.childData.extra_bed_count\" required><md-option value=\"1\">1</md-option>\n<md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div class=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start start\" \nflex=\"100\" flex ng-if=\"vm.childData.is_extra_bed_allowed !=0 && vm.childData.is_child_allowed == 1\"><md-input-container\n class=\"md-block md-input-has-value padding-left-10 padding-right-10 full-width no-margin\" flex-gt-xs=\"100\" flex=\"100\" \nflex><label class=\"margin-left-10\">Tick the box if you can accommodate the following guests in extra beds.</label>\n<md-checkbox aria-label=\"Child\" ng-model=\"vm.extraChild\" \nng-checked=\"vm.childData.extra_bed_price_per_night_per_child > 0\">Child</md-checkbox></md-input-container></div><div \nng-if=\"vm.childData.is_extra_bed_allowed !=0 && vm.childData.is_child_allowed == 1 && vm.extraChild\" class=\"row-block\" \nng-if=\"vm.extraChild\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start start\" flex=\"100\" flex><md-input-container\n flex-gt-xs=\"100\" flex=\"100\" flex class=\"padding-left-10 padding-right-10 full-width md-block mb-0\"><label \nclass=\"margin-left-10\">Enter the price per night, per child</label><input name=\"postalCode\" type=\"number\" \nng-model=\"vm.childData.extra_bed_price_per_night_per_child\" required ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div><div ng-if=\"vm.childData.is_extra_bed_allowed !=0\" class=\"row-block\" layout=\"column\" \nlayout-gt-xs=\"row\" layout-align=\"start start\" flex=\"100\" flex><md-input-container \nclass=\"md-block md-input-has-value padding-left-10 padding-right-10 full-width no-margin\" flex-gt-xs=\"100\" flex=\"100\" \nflex><md-checkbox aria-label=\"Adult\" ng-model=\"vm.extraAdult\" \nng-checked=\"vm.childData.extra_bed_price_per_night_per_adult > 0\">Adult</md-checkbox></md-input-container></div><div \nng-if=\"vm.childData.is_extra_bed_allowed !=0 && vm.extraAdult\" class=\"row-block\" ng-if=\"vm.extraAdult\" layout=\"column\" \nlayout-gt-xs=\"row\" layout-align=\"start start\" flex=\"100\" flex><md-input-container \nclass=\"md-block md-input-has-value padding-left-10 padding-right-10 full-width mb-0\" flex-gt-xs=\"50\" flex=\"50\" flex \nng-if=\"vm.childData.is_extra_bed_allowed !=0\"><label class=\"margin-left-10\">Enter the price per night, per adult\n</label><input name=\"postalCode\" type=\"number\" ng-model=\"vm.childData.extra_bed_price_per_night_per_adult\" required \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container><md-input-container \nclass=\"md-block md-input-has-value padding-left-10 padding-right-10 full-width\" flex-gt-xs=\"50\" flex=\"50\" flex><label \nclass=\"margin-left-10\" translate=\"POLICIES.EXTRA_PERSON_ADDED_AS\"></label><md-select name=\"vm\" \nng-model=\"vm.childData.extra_person_as\" required><md-option value=\"nightly_rate\">Nightly Rate</md-option><md-option \nvalue=\"separate_pos\">Separate POS</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container>\n</div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" ng-click=\"vm.updateChildPolicy()\" \nng-class=\"!childForm.$invalid && !childForm.$pristine?\'md-raised md-green-500-bg submit-button white-fg\':\'md-raised md-accent submit-button grey-100-fg\'\" \nng-disabled=\"childForm.$invalid || childForm.$pristine\" aria-label=\"SAVE\" translate=\"SAVE\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/policy/depositModal.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\" style=\"max-width:900px;width:900px\"><form name=\"depositForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"POLICIES.DEPOSIT_POLICY\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div><div class=\"contact-name\">{{vm.contact.name}}\n</div><div ng-if=\"vm.error\">{{ vm.error }}</div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:900px;max-height:1000px\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><md-content class=\"md-padding\"><div class=\"block-content-outer-pop\"><div \nclass=\"form-title padding-left-10 padding-right-10 padding-bottom-10\" translate=\"POLICIES.DEPOSIT_RULE_ROOM\"></div><div\n class=\"row-block margin-top-15\" layout-gt-xs=\"row\" layout-align=\"start start\" flex=\"100\" flex flex-wrap>\n<md-input-container class=\"md-block no-margin md-input-has-value padding-left-10 padding-right-10 full-width\" \nflex-gt-xs=\"33\" flex=\"100\" flex layout=\"column\"><md-radio-group ng-model=\"vm.depositPol.room_deposit_type_indicator\" \nng-click=\"vm.checkNumberValue(\'room_deposit_first_night\')\"><md-radio-button value=\"first-night\"><span \ntranslate=\"POLICIES.FIRST_NIGHT\"></span></md-radio-button></md-radio-group></md-input-container><md-input-container \nlayout=\"column\" class=\"no-margin md-block md-input-has-value padding-left-10 padding-right-10 full-width\" \nflex-gt-xs=\"33\" flex=\"100\" flex><md-radio-group ng-model=\"vm.depositPol.room_deposit_type_indicator\" \nng-click=\"vm.checkNumberValue(\'room_deposit_percentage\')\"><md-radio-button value=\"perc\"><span \ntranslate=\"POLICIES.PERCENTAGE\"></span></md-radio-button></md-radio-group></md-input-container><md-input-container \nlayout=\"column\" class=\"no-margin md-block md-input-has-value padding-left-10 padding-right-10 full-width\" \nflex-gt-xs=\"33\" flex=\"100\" layout=\"column\" flex><md-radio-group ng-model=\"vm.depositPol.room_deposit_type_indicator\" \nng-click=\"vm.checkNumberValue(\'room_deposit_amount\')\"><md-radio-button value=\"amt\"><span \ntranslate=\"POLICIES.FIXED_AMOUNT\"></span></md-radio-button></md-radio-group></md-input-container><md-input-container \nlayout=\"column\" class=\"no-margin md-block md-input-has-value padding-left-10 padding-right-10 full-width\" \nflex-gt-xs=\"33\" flex=\"100\" layout=\"column\" flex><md-radio-group ng-model=\"vm.depositPol.room_deposit_type_indicator\" \nng-click=\"vm.checkNumberValue(\'room_deposit_amount\')\"><md-radio-button value=\"multiple-night\"><span>Multiple night\n</span></md-radio-button></md-radio-group></md-input-container></div><div class=\"row-block margin-top-25\" \nlayout-gt-xs=\"row\" layout-align=\"start start\" flex=\"100\" flex flex-wrap><md-input-container layout=\"column\" \nclass=\"no-margin md-block padding-left-10 padding-right-10 full-width\" \nng-if=\"vm.depositPol.room_deposit_type_indicator == \'perc\'\" flex=\"100\" flex><label class=\"margin-left-10\" \ntranslate=\"POLICIES.PERCENTAGE\"></label><input name=\"room_deposit_percentage\" max=\"100\" \nng-model=\"vm.depositPol.room_deposit_percentage\" step=\"0.01\" type=\"number\" required \nng-change=\"vm.checkNumberValue(\'room_deposit_percentage\')\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container><md-input-container layout=\"column\" \nclass=\"no-margin md-block padding-left-10 padding-right-10 full-width\" \nng-if=\"vm.depositPol.room_deposit_type_indicator == \'amt\'\" flex=\"100\" layout=\"column\" flex><label \nclass=\"margin-left-10\" translate=\"POLICIES.FIXEDAMOUNT\"></label><input name=\"room_deposit_amount\" \nng-model=\"vm.depositPol.room_deposit_amount\" type=\"number\" required \nng-change=\"vm.checkNumberValue(\'room_deposit_amount\')\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div><div \nng-if=\"vm.depositPol.room_deposit_type_indicator == \'multiple-night\' || vm.depositPol.room_deposit_type_indicator == \'first-night\'\" \nclass=\"form-title padding-left-10 padding-right-10 padding-bottom-10\">Apply Tax?</div><div \nng-if=\"vm.depositPol.room_deposit_type_indicator == \'multiple-night\' || vm.depositPol.room_deposit_type_indicator == \'first-night\'\" \nclass=\"marginTop row-block margin-top-15\" layout-gt-xs=\"row\" layout-align=\"start start\" flex=\"100\" flex flex-wrap>\n<md-input-container class=\"no-margin md-block md-input-has-value padding-left-10 padding-right-10 full-width\" \nlayout=\"column\" flex-gt-xs=\"33\" flex=\"100\" flex><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" \nng-model=\"vm.depositPol.room_deposit_tax_included_indicator\">Include Tax.</md-checkbox></md-input-container>\n<md-input-container class=\"md-block no-margin md-input-has-value padding-left-10 padding-right-10 full-width\" \nflex-gt-xs=\"33\" flex=\"100\" flex ng-if=\"vm.depositPol.room_deposit_tax_included_indicator\"><label>Tax</label><md-select \nng-model=\"vm.selectedTaxIds\" multiple=\"multiple\" ng-change=\"vm.updateSelectedTax()\"><md-option ng-value=\"tax.tax_id\" \nng-repeat=\"tax in vm.taxes\">{{tax.tax_name+\'@\'+tax.tax_value}}</md-option></md-select></md-input-container></div><div \nclass=\"form-title padding-left-10 padding-right-10 padding-bottom-10\" translate=\"POLICIES.DEPOSIT_RULE_POS\"></div><div \nclass=\"row-block margin-top-15\" layout-gt-xs=\"row\" layout-align=\"start start\" flex=\"100\" flex flex-wrap>\n<md-input-container class=\"no-margin md-block md-input-has-value padding-left-10 padding-right-10 full-width\" \nlayout=\"column\" flex-gt-xs=\"33\" flex=\"100\" flex><md-radio-group ng-model=\"vm.depositPol.pos_deposit_type_indicator\">\n<md-radio-button value=\"full\">Full</md-radio-button></md-radio-group></md-input-container><md-input-container \nclass=\"md-block no-margin md-input-has-value padding-left-10 padding-right-10 full-width\" flex-gt-xs=\"33\" flex=\"100\" \nflex><md-radio-group ng-model=\"vm.depositPol.pos_deposit_type_indicator\"><md-radio-button value=\"zero\">Zero\n</md-radio-button></md-radio-group></md-input-container></div></div><div \nng-if=\"vm.depositPol.room_deposit_type_indicator == \'multiple-night\'\" \nclass=\"form-title margin-left-10 relative-block iconRoomType onlycursorPointer\"><span>\nMultiple night deposit rule for rooms?</span> <a ng-click=\"vm.addMultipleRoomDepositPolicy(vm.emailIndex)\" \nclass=\"custom-pull-right m-t-8\" style=\"float:right\"><i class=\"icon-plus-circle\"></i></a></div><div \nclass=\"row-block mt-30\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex><div \nclass=\"row-col padding-right-10 padding-left-10 iconRoomType\" flex-gt-xs=\"100\" flex-gt-sm=\"100\" flex=\"100\" \nlayout=\"column\" flex><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex \nng-if=\"vm.depositPol.room_deposit_type_indicator == \'multiple-night\'\" ng-repeat=\"multiplePolicy in vm.multipleDeposit\">\n<div layout=\"column\" flex-gt-sm=\"95\" flex=\"90\" layout-align=\"end end\"><div class=\"row-block full-width\" flex=\"100\" \nlayout=\"row\" layout-align=\"start start\" flex><md-input-container layout=\"column\" \nclass=\"no-margin md-block md-input-has-value padding-left-10 padding-right-10 full-width\" flex-gt-xs=\"25\" flex=\"100\" \nflex><md-input-container layout=\"column\" \nclass=\"no-margin md-block md-input-has-value padding-left-10 padding-right-10 full-width\" flex-gt-xs=\"33\" flex=\"100\" \nflex><label>Days</label><md-select ng-model=\"vm.multipleDeposit[$index][\'for_upto_days\']\" \nng-blur=\"vm.updateselectedDaysMultipleNights($index)\" required><md-option value=\"{{i + 1}}\" \nng-repeat=\"i in []| range:30\" ng-disabled=\"vm.selectedDaysMultipleNights.indexOf((i+1)) != -1\">>={{i + 1}}</md-option>\n</md-select></md-input-container></md-input-container><md-input-container layout=\"column\" \nclass=\"no-margin md-block md-input-has-value padding-left-10 padding-right-10 full-width\" flex-gt-xs=\"25\" flex=\"100\" \nflex><label>Deposit Type</label><md-select ng-model=\"vm.multipleDeposit[$index][\'room_deposit_type_indicator\']\" \nrequired><md-option value=\"night-rate\">Night rate</md-option><md-option value=\"amt\">Fixed amount</md-option><md-option \nvalue=\"amt-for-all-night\">Fixed amount of all nights</md-option><md-option value=\"perc\">Fixed percentage</md-option>\n<md-option value=\"perc-for-all-night\">Fixed percentage of all nights</md-option></md-select></md-input-container>\n<md-input-container layout=\"column\" \nng-if=\"vm.multipleDeposit[$index][\'room_deposit_type_indicator\'] != \'amt-for-all-night\' &&  vm.multipleDeposit[$index][\'room_deposit_type_indicator\'] != \'perc-for-all-night\'\" \nclass=\"no-margin md-block md-input-has-value padding-left-10 padding-right-10 full-width\" flex-gt-xs=\"25\" flex=\"100\" \nflex><label class=\"margin-left-10\">Which night</label><input name=\"room_deposit_which_night\" \nng-model=\"vm.multipleDeposit[$index][\'room_deposit_which_night\']\" type=\"number\" required \nng-change=\"vm.checkNumberValue(\'room_deposit_which_night\')\" min=\"1\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container><md-input-container \nng-if=\"vm.multipleDeposit[$index][\'room_deposit_type_indicator\'] == \'amt\' || vm.multipleDeposit[$index][\'room_deposit_type_indicator\'] == \'amt-for-all-night\'\" \nlayout=\"column\" class=\"no-margin md-block md-input-has-value padding-left-10 padding-right-10 full-width\" \nflex-gt-xs=\"25\" flex=\"100\" flex><label class=\"margin-left-10\">Amount</label><input name=\"pos_deposit_amount\" \nng-model=\"vm.multipleDeposit[$index][\'room_deposit_amount\']\" type=\"number\" required \nng-change=\"vm.checkNumberValue(\'pos_deposit_amount\')\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container><md-input-container \nng-if=\"vm.multipleDeposit[$index][\'room_deposit_type_indicator\'] == \'perc\' || vm.multipleDeposit[$index][\'room_deposit_type_indicator\'] == \'perc-for-all-night\'\" \nlayout=\"column\" class=\"no-margin md-block md-input-has-value padding-left-10 padding-right-10 full-width\" \nflex-gt-xs=\"25\" flex=\"100\" flex><label class=\"margin-left-10\">Percentage</label><input name=\"pos_deposit_percentage\" \nng-model=\"vm.multipleDeposit[$index][\'room_deposit_percentage\']\" type=\"number\" required \nng-change=\"vm.checkNumberValue(\'pos_deposit_amount\')\" min=\"1\" max=\"100\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></md-input-container></div></div><div layout=\"column\" ng-if=\"vm.multipleDeposit.length > 2\" \nflex-gt-sm=\"5\" flex=\"10\" layout-align=\"end end\" class=\"padding-top-5 red-A800-fg onlycursorPointer\"><i \nclass=\"icon-delete\" ng-click=\"vm.deleteThisNightPlan($index,vm.multipleDeposit[$index][\'id\'] )\"></i></div></div></div>\n</div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button \nng-if=\"vm.depositPol.room_deposit_type_indicator == \'multiple-night\'\" type=\"submit\" \nng-click=\"vm.updatePropertyPolicy2()\" \nng-class=\"!vm.checkValidation() || !(vm.depositPol.room_deposit_tax_included_indicator && vm.selectedTaxIds.length == 0) ?\'md-raised md-green-500-bg submit-button white-fg\':\'md-accent md-raised submit-button grey-100-fg\'\" \naria-label=\"SAVE\" translate=\"POLICIES.SAVE\" \nng-disabled=\"vm.checkValidation() || (vm.depositPol.room_deposit_tax_included_indicator && vm.selectedTaxIds.length == 0)\">\n</md-button><md-button ng-if=\"vm.depositPol.room_deposit_type_indicator != \'multiple-night\'\" type=\"submit\" \nng-click=\"vm.updatePropertyPolicy2()\" \nng-class=\"depositForm.$invalid || depositForm.$pristine || vm.numberErro || (vm.depositPol.room_deposit_tax_included_indicator && vm.selectedTaxIds.length == 0)?\'md-raised grey-100-fg  md-accent\':\'md-raised md-green-500-bg submit-button white-fg\'\" \naria-label=\"SAVE\" translate=\"POLICIES.SAVE\" \nng-disabled=\"depositForm.$invalid || depositForm.$pristine || vm.numberErro || (vm.depositPol.room_deposit_tax_included_indicator && vm.selectedTaxIds.length == 0)\">\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/policy/guestInformation.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\" style=\"max-width:900px;width:900px\"><form \nname=\"guestInformationForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"POLICIES.GUEST_INFO\"></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon>\n</md-button></div><div class=\"contact-name\">{{vm.contact.name}}</div><div ng-if=\"vm.error\">{{ vm.error }}</div>\n</md-toolbar><md-dialog-content ms-scroll style=\"max-width:900px;max-height:1000px\"><md-progress-linear \nmd-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><md-content class=\"md-padding\"><div \nclass=\"block-content-outer-pop\"><div class=\"title padding-left-10 padding-right-10 padding-bottom-10\" \ntranslate=\"POLICIES.CHECK_IN_TIME\"></div><div class=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start start\" flex=\"100\" flex><md-input-container \nclass=\"md-block md-input-has-value padding-left-10 padding-right-10 full-width\"><label class=\"margin-left-10\" \ntranslate=\"POLICIES.STARTING_TIME\"></label><md-select name=\"vm\" ng-model=\"vm.guestInfo.guest_checkin_from\"><md-option \nvalue=\"{{checkinT}}\" ng-repeat=\"checkinT in vm.guest_checkin_from\">{{checkinT}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container \nclass=\"md-block md-input-has-value padding-left-10 padding-right-10 full-width\"><label class=\"margin-left-10\" \ntranslate=\"POLICIES.ENDING_TIME\"></label><md-select name=\"vm\" ng-model=\"vm.guestInfo.guest_checkin_to\" \nngmodelchange=\"vm.updateGuestInformationPolicy()\"><md-option value=\"{{checkinT}}\" \nng-repeat=\"checkinT in vm.guest_checkin_to\">{{checkinT}}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div class=\"title padding-left-10 padding-right-10 padding-bottom-10\" \ntranslate=\"POLICIES.CHECK_OUT_TIME\"></div><div class=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start start\" flex=\"100\" flex><md-input-container \nclass=\"md-block md-input-has-value padding-left-10 padding-right-10 full-width\"><label class=\"margin-left-10\" \ntranslate=\"POLICIES.STARTING_TIME\"></label><md-select name=\"vm\" ng-model=\"vm.guestInfo.guest_checkout_from\"><md-option \nvalue=\"{{checkinT}}\" ng-repeat=\"checkinT in vm.guest_checkout_from\">{{checkinT}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container \nclass=\"md-block md-input-has-value padding-left-10 padding-right-10 full-width\"><label class=\"margin-left-10\" \ntranslate=\"POLICIES.ENDING_TIME\"></label><md-select name=\"vm\" ng-model=\"vm.guestInfo.guest_checkout_to\"><md-option \nvalue=\"{{checkinT}}\" ng-repeat=\"checkinT in vm.guest_checkout_to\">{{checkinT}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></div></md-content></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button \ntype=\"submit\" ng-click=\"vm.updateGuestInformationPolicy()\" \nng-class=\"!guestInformationForm.$invalid && !guestInformationForm.$pristine?\'md-raised md-green-500-bg submit-button white-fg\':\'md-raised md-accent submit-button grey-100-fg\'\" \nng-disabled=\"guestInformationForm.$invalid || guestInformationForm.$pristine\" aria-label=\"SAVE\">Save</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/policy/policy.html","<div id=\"policy\" class=\"lastcolumn_custom_three_icons page-layout doc-page simple fullwidth element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"logo-icon white-fg fontSizeTopHeading\"><md-icon md-font-icon=\"icon-lock\"></md-icon></span><span \nclass=\"logo-text white-fg ng-scope fontSizeTopHeading\" translate=\"POLICIES.POLICIES\"></span></div></div><div \nstyle=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"myDialog\"><md-dialog \nclass=\"full-width-block dilog-height-policy\"><md-toolbar class=\"md-accent white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\"><span class=\"title sizeoftitle\" \ntranslate=\"POLICIES.CANCELLATION_PREFERENCE\"></span><md-button class=\"md-icon-button close-pop-icon\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div><div class=\"contact-name\">\n{{vm.contact.name}}</div><div ng-if=\"vm.error\">{{ vm.error }}</div></md-toolbar><div \nclass=\"white-bg card-block-half card-block-three popup-main\" ng-repeat=\"policy in vm.policies\" \nlayout-align=\"center center\" ng-if=\"vm.currentSelectedId.indexOf(policy.policy_id) == -1\" layout-padding><div \nclass=\"text-primary color-heading-theme\">{{ policy.policy_name }}</div><div class=\"content-outer\"><p>\n{{ policy.policy_description }}</p><button \nclass=\"no-margin md-button md-ink-ripple md-raised md-accent submit-button grey-100-fg\" \nng-click=\"policy.policy_id == \'2\'?vm.customadd(policy.policy_id):vm.normaladd(policy.policy_id)\">\n{{policy.policy_id == \'2\'? (\'POLICIES.CHOOSE_POLICY\'| translate) : (\'POLICIES.CREATE_POLICY\'| translate)}}</button>\n</div></div></md-dialog></div></div></div><div class=\"content\"><div class=\"content\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"main RowClick\" style=\"margin-top:00px\" ms-scroll><div><div \nclass=\"white-bg card-block-half\" ng-repeat=\"policy in vm.policies\" \nng-if=\"vm.currentSelectedId.indexOf(policy.policy_id) != -1\" layout-align=\"center center\" layout-padding><div \nclass=\"block-header capitalize\">{{ policy.policy_name }}</div><div class=\"content-outer\"><ul><li>\n{{ policy.policy_description }}</li></ul><button \nclass=\"button-custom del-btn md-raised md-button md-ink-ripple layout-align-center-center layout-row md-default-theme\" \nng-click=\"policy.policy_name == \'Customized Policies\'?vm.customadd(policy.policy_id):vm.normaladd(policy.policy_id)\">\n{{vm.currentSelectedId.indexOf(policy.policy_id)>-1? (\'POLICIES.DELETE\'| translate) : (\'POLICIES.ADD\'| translate) }}\n</button> <button ng-if=\"policy.policy_id == 2\" \nclass=\"button-custom blue-bg md-raised md-button md-ink-ripple layout-align-center-center layout-row md-default-theme\" \nng-click=\"vm.updateCustomPolicy(policy.policy_id)\" translate=\"POLICIES.UPDATE\"></button></div></div><div \nclass=\"white-bg card-block-half\" layout-align=\"center center\" layout-padding><div class=\"block-header capitalize\">\n{{vm.depositPolicy.policy_name }}</div><div class=\"content-outer\"><div><div \nng-repeat=\"policy in vm.otherSelectdPolicies\" ng-if=\"policy.policy_id == 7\"><span>Deposit Policy</span><ul><li \nng-if=\"policy.room_deposit_type_indicator != \'perc\' && policy.room_deposit_type_indicator != \'amt\' && policy.room_deposit_type_indicator != \'multiple-night\'\">\n{{\'Deposit will be first night of room.\'}} {{policy.room_deposit_tax_included_indicator == 0?\'Tax excluded\':\'Tax is included (\'+vm.selecetdTax+\')\'}}\n</li><li ng-if=\"policy.room_deposit_type_indicator == \'multiple-night\'\"><span>Deposit will be </span><span \nng-if=\"vm.multipleDeposit.length > 0\" ng-repeat=\"multipleDays in  vm.multipleDeposit\">\n{{$index != 0? \' & \':\'\'}} {{multipleDays[\'room_deposit_type_indicator\'] == \'amt\'? (multipleDays[\'room_deposit_amount\'] | currency:$:2)+\' of \':\'\'}} {{multipleDays[\'room_deposit_type_indicator\'] == \'perc\'? (multipleDays[\'room_deposit_percentage\'] | number:2)+\'% of \':\'\'}} {{multipleDays[\'room_deposit_type_indicator\'] == \'amt-for-all-night\'? (multipleDays[\'room_deposit_amount\'] | currency : $ : 2): \'\' }} {{multipleDays[\'room_deposit_type_indicator\'] == \'perc-for-all-night\'? (multipleDays[\'room_deposit_percentage\'] | number:2)+\'% \':\'\'}} {{multipleDays[\'room_deposit_type_indicator\'] == \'amt-for-all-night\' ? \' for >= \'+ multipleDays[\'for_upto_days\']+\' number of nights \' :\'\' }} {{multipleDays[\'room_deposit_type_indicator\'] == \'perc-for-all-night\' ?\' for >= \'+ multipleDays[\'for_upto_days\']+\' number of nights \': \'\' }} {{multipleDays[\'room_deposit_type_indicator\'] == \'perc\'? vm.numberName[multipleDays[\'room_deposit_which_night\']] + \' night for >= \'+ multipleDays[\'for_upto_days\']+\' number of nights \' : \'\' }} {{multipleDays[\'room_deposit_type_indicator\'] == \'amt\'? vm.numberName[multipleDays[\'room_deposit_which_night\']] + \' night for >= \'+ multipleDays[\'for_upto_days\']+\' number of nights \' : \'\' }} {{multipleDays[\'room_deposit_type_indicator\'] == \'night-rate\'? vm.numberName[multipleDays[\'room_deposit_which_night\']] + \' night for >= \'+ multipleDays[\'for_upto_days\']+\' number of nights \' : \'\' }} \n</span><span>of reservation.</span> <span>\n{{policy.room_deposit_tax_included_indicator == 0 ?\'Tax excluded\':\'Tax is included (\'+vm.selecetdTax+\')\'}}</span></li>\n<li ng-if=\"policy.room_deposit_type_indicator == \'perc\'\">\n{{\'Deposit will be \'+(policy.room_deposit_percentage| number:2)+\'% of room.\'}}</li><li \nng-if=\"policy.room_deposit_type_indicator == \'amt\'\">\n{{\'Deposit will be $\'+(policy.room_deposit_amount| number:2)+\' of room.\'}}</li><li \nng-if=\"policy.pos_deposit_type_indicator == \'full\'\">Deposit will be full for POS.</li><li \nng-if=\"policy.pos_deposit_type_indicator == \'zero\'\">Deposit will be zero.</li></ul></div></div><button \nclass=\"md-button md-ink-ripple md-raised md-accent submit-button grey-100-fg\" \nng-click=\"vm.updateOtherPolicy(vm.depositPolicy.policy_id)\" translate=\"POLICIES.CHANGE_ADD_DETAIL\"></button></div>\n</div></div><div><div class=\"white-bg card-block-half\" ng-if=\"vm.currentSelectedId.length != vm.policies.length\" \nlayout-align=\"center center\" layout-padding><div class=\"content-outer content-policy\"><div class=\"policy-create\" \ntranslate=\"POLICIES.CREATE_POLICY\"></div><md-button \nclass=\"md-button md-ink-ripple md-raised md-accent submit-button grey-100-fg\" ng-click=\"vm.openPolicyPopup ($event)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon>{{ \'POLICIES.CANCEL_POLICY\' | translate }}</md-button></div></div></div>\n<span><h2 translate=\"POLICIES.OTHER_POLICIES\"></h2></span><div><div class=\"white-bg card-block-half\" \nng-repeat=\"policy in vm.otherPolicies\" layout-align=\"center center\" layout-padding><div \nclass=\"block-header capitalize\">{{ policy.policy_name }}</div><div class=\"content-outer\"><div \nng-repeat=\"selPol in vm.otherSelectdPolicies\"><div ng-if=\"selPol.policy_id == policy.policy_id\"><div \nng-if=\"selPol.policy_id ==5\"><span translate=\"POLICIES.INTERNET\"></span><ul ng-if=\"selPol.is_internet_allowed == 1\">\n<li>\n{{ selPol.internet_type == \'wifi\'? \'Wifi is available\' :\'Cable is available\' }} {{selPol.internet_price == 0?\' for free\':\' for \'+\' $\'+(selPol.internet_price | number:2)}} {{selPol.internet_tax_id == 0? \'\':\' +\' +\' \'+vm.taxNameValue[selPol.internet_tax_id][\'tax_name\']+\'(\'+vm.taxNameValue[selPol.internet_tax_id][\'tax_value\']+\'%)\'}}\n</li></ul><ul ng-if=\"selPol.is_internet_allowed == 0\"><li translate=\"POLICIES.NO_INTERNET\"></li></ul></div><div \nng-if=\"selPol.policy_id ==5\"><span translate=\"POLICIES.PARKING\"></span><ul ng-if=\"selPol.is_parking_allowed == 1\"><li>\n{{ selPol.internet_type == \'public\'?\'Public parking is available\':\'Private parking is available\' }}{{selPol.parking_price == 0?\' for free\':\' for \'+\' $\'+(selPol.parking_price | number:2)}}{{selPol.parking_tax_id == 0? \'\':\' +\' +\' \'+vm.taxNameValue[selPol.parking_tax_id][\'tax_name\']+\'(\'+vm.taxNameValue[selPol.parking_tax_id][\'tax_value\']+\'%)\'}}\n</li></ul><ul ng-if=\"selPol.is_parking_allowed == 0\"><li>Parking is not available</li></ul></div><div \nng-if=\"selPol.policy_id ==5\"><span translate=\"POLICIES.PETS\"></span><ul ng-if=\"selPol.is_pet_allowed == 1\"><li>\n{{ selPol.is_pet_allowed == \'1\' ? (\'POLICIES.PETS_ALLOWED\'| translate) : (\'POLICIES.PETS_NOT_ALLOWED\'| translate) }} {{selPol.pet_price_type == \'free\'? (\'POLICIES.NO_EXTRA_CHARGE\'| translate): \' for $\'+(selPol.pet_price | number:2)+\' \'+selPol.pet_price_type }} {{selPol.pet_tax_id == 0? \'\':\' +\' +\' \'+vm.taxNameValue[selPol.pet_tax_id][\'tax_name\']+\'(\'+vm.taxNameValue[selPol.pet_tax_id][\'tax_value\']+\'%)\'}}\n</li></ul><ul ng-if=\"selPol.is_pet_allowed == 0\"><li translate=\"POLICIES.PETS_NOT_ALLOWED\"></li></ul></div><div \nng-if=\"selPol.policy_id ==4\"><ul><li ng-if=\"selPol.is_child_allowed != 0\">All children are welcome.</li><li \nng-if=\"selPol.existing_extra_child_count_allowed != 0 && selPol.child_price_per_night == 0 \">\n{{ selPol.existing_extra_child_count_allowed+\' child \'+vm.ageArray[selPol.child_age]+\' years stays free of charge when using existing beds.\' }}\n</li><li ng-if=\"selPol.existing_extra_child_count_allowed != 0 && selPol.child_price_per_night != 0 \">\n{{ selPol.existing_extra_child_count_allowed+\' child \'+vm.ageArray[selPol.child_age]+\' years is charged $\'+(selPol.child_price_per_night| number:2)+\' per night\' }}\n</li></ul><ul ng-if=\"selPol.is_child_allowed == 0\"><li>Children are not allowed.</li></ul><ul><li>\n{{ selPol.extra_person_as == \'nightly_rate\'? \'Extra person will be added as nightly rate\':\'Extra person will be added as separate POS\'}}\n</li></ul></div><div ng-if=\"selPol.policy_id ==4\"><ul ng-if=\"selPol.is_extra_bed_allowed == 1\"><li>\n{{ selPol.extra_bed_price_per_night_per_adult == 0? selPol.extra_bed_count+\' bed is alloted for free to adult\':selPol.extra_bed_count+\' bed is alloted for $\'+(selPol.extra_bed_price_per_night_per_adult | number:2)+\' per night for adult\' }}\n</li><li ng-if=\"selPol.is_child_allowed != 0\">\n{{ selPol.extra_bed_price_per_night_per_child == 0? selPol.extra_bed_count+\' bed is alloted for free to children\':selPol.extra_bed_count+\' bed is alloted for $\'+(selPol.extra_bed_price_per_night_per_child | number:2)+\' per night for child\' }}\n</li></ul><ul ng-if=\"selPol.is_extra_bed_allowed == 0\"><li ng-if=\"selPol.is_extra_bed_allowed == 0\">\nThere is no capacity for extra beds in the room.</li></ul></div><div ng-if=\"selPol.policy_id ==6\"><span \ntranslate=\"POLICIES.GUEST_ARRIVAL_TIME\"></span><ul><li \nng-if=\"selPol.guest_checkin_from != \'\' && selPol.guest_checkin_to != \'\'\">\n{{ \'Check-in from : \'+selPol.guest_checkin_from+\' to \'+selPol.guest_checkin_to}}</li><li \nng-if=\"selPol.guest_checkin_from == \'\' && selPol.guest_checkin_to != \'\'\">\n{{ \'Check-in until : \'+selPol.guest_checkin_to}}</li><li \nng-if=\"selPol.guest_checkin_from != \'\' && selPol.guest_checkin_to == \'\'\">\n{{ \'Check-in from : \'+selPol.guest_checkin_from}}</li><li \nng-if=\"selPol.guest_checkout_from != \'\' && selPol.guest_checkout_to != \'\'\">\n{{ \'Check-out from : \'+selPol.guest_checkout_from+\' to \'+selPol.guest_checkout_to}}</li><li \nng-if=\"selPol.guest_checkout_from == \'\' && selPol.guest_checkout_to != \'\'\">\n{{ \'Check-out until : \'+selPol.guest_checkout_to }}</li><li \nng-if=\"selPol.guest_checkout_from != \'\' && selPol.guest_checkout_to == \'\'\">\n{{ \'Check-out from : \'+selPol.guest_checkout_from}}</li></ul><ul ng-if=\"!selPol.is_internet_allowed\"><li>\nChildren are not allowed.</li></ul></div></div></div><button \nclass=\"md-button md-ink-ripple md-raised md-accent submit-button grey-100-fg\" \nng-click=\"vm.updateOtherPolicy(policy.policy_id)\" translate=\"POLICIES.CHANGE_ADD_DETAIL\"></button></div></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/apps/policy/propertyModal.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\" style=\"max-width:900px;width:900px\"><form name=\"prpertyForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"POLICIES.PROPERTY_SPECIFIC\"></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div><div class=\"contact-name\">\n{{vm.contact.name}}</div><div ng-if=\"vm.error\">{{ vm.error }}</div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:900px;max-height:1000px\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><md-content class=\"md-padding\"><div class=\"block-content-outer-pop\"><div \nclass=\"title padding-left-10 padding-right-10 padding-bottom-10\" translate=\"POLICIES.INTERNET\"></div><div \nclass=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start start\" flex=\"100\" flex><md-input-container \nclass=\"md-block md-input-has-value padding-left-10 padding-right-10 full-width\" flex-gt-xs=\"33\" flex=\"100\" flex><label \nclass=\"margin-left-10\" translate=\"POLICIES.INTERNET_AVAILABLE\"></label><md-select name=\"internet\" \nng-model=\"vm.propertyData.is_internet_allowed\" required><md-option value=\"1\">{{ \'POLICIES.YES\' | translate }}\n</md-option><md-option value=\"0\">{{ \'POLICIES.NO\' | translate }}</md-option></md-select><div class=\"md-errors-spacer\">\n</div></md-input-container><md-input-container class=\"md-block padding-left-10 padding-right-10 full-width\" \nng-if=\"vm.propertyData.is_internet_allowed != 0\" flex-gt-xs=\"100\" flex=\"100\" flex><label class=\"margin-left-10\" \ntranslate=\"POLICIES.CONNECTION_TYPE\"></label><md-select name=\"vm.propertyData.internet_type\" \nng-model=\"vm.propertyData. internet_type\" required><md-option value=\"wifi\">{{ \'POLICIES.WIFI\' | translate }}\n</md-option><md-option value=\"cable\">{{ \'POLICIES.CABLE\' | translate }}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container \nclass=\"md-block padding-left-10 padding-right-10 full-width\" ng-if=\"vm.propertyData.is_internet_allowed != 0\" \nflex-gt-xs=\"100\" flex=\"100\" flex><label class=\"margin-left-10\" translate=\"POLICIES.INTERNET_PRICE\"></label><input \nname=\"postalCode\" ng-model=\"vm.propertyData.internet_price\" type=\"number\" required></md-input-container>\n<md-input-container class=\"md-block padding-left-10 padding-right-10 full-width\" \nng-if=\"vm.propertyData.is_internet_allowed != 0\" flex-gt-xs=\"100\" flex=\"100\" flex><label class=\"margin-left-10\">\n{{ \'POLICIES.TAX_FEES\' | translate }}</label><md-select ng-model=\"vm.propertyData.internet_tax_id\"><md-option \nng-value=\"0\"><em>{{\'POLICIES.NONE\' | translate}}</em></md-option><md-option ng-value=\"taxes.tax_id\" \nng-repeat=\"taxes in vm.taxes\">{{ taxes.tax_name+ \' (\'+taxes.tax_value+\'%)\'}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"title padding-left-10 padding-right-10 padding-bottom-10\" translate=\"POLICIES.PARKING\"></div><div \nclass=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start start\" flex=\"100\" flex><md-input-container \nflex-gt-xs=\"33\" flex=\"100\" flex class=\"md-block padding-left-10 padding-right-10 full-width\" flex-gt-sm><label \nclass=\"margin-left-10\" translate=\"POLICIES.PARKING_AVAILABLE\"></label><md-select name=\"vm\" \nng-model=\"vm.propertyData.is_parking_allowed\"><md-option value=\"1\">{{ \'POLICIES.YES\' | translate }}</md-option>\n<md-option value=\"0\">{{ \'POLICIES.NO\' | translate }}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container><md-input-container flex-gt-xs=\"100\" flex=\"100\" flex \nclass=\"md-block padding-left-10 padding-right-10 full-width\" flex-gt-sm \nng-if=\"vm.propertyData.is_parking_allowed != 0\"><label class=\"margin-left-10\">Parking type</label><md-select name=\"vm\" \nng-model=\"vm.propertyData.parking_type\" required><md-option value=\"wifi\">{{ \'POLICIES.PRIVATE\' | translate }}\n</md-option><md-option value=\"cable\">{{ \'POLICIES.PUBLIC\' | translate }}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container flex-gt-xs=\"100\" flex=\"100\" flex \nclass=\"md-block padding-left-10 padding-right-10 full-width\" flex-gt-sm \nng-if=\"vm.propertyData.is_parking_allowed != 0\"><label class=\"margin-left-10\">\n{{ \'POLICIES.PRICEFORPARKING\' | translate}}</label><input name=\"postalCode\" type=\"number\" step=\"0.1\" \nng-model=\"vm.propertyData.parking_price\" required></md-input-container><md-input-container \nclass=\"md-block padding-left-10 padding-right-10 full-width\" ng-if=\"vm.propertyData.is_internet_allowed != 0\" \nflex-gt-xs=\"100\" flex=\"100\" flex><label class=\"margin-left-10\">{{ \'POLICIES.TAX_FEES\' | translate }}</label><md-select \nng-model=\"vm.propertyData.parking_tax_id\"><md-option ng-value=\"0\"><em>{{\'POLICIES.NONE\' | translate}}</em></md-option>\n<md-option ng-value=\"taxes.tax_id\" ng-repeat=\"taxes in vm.taxes\">{{ taxes.tax_name+ \' (\'+taxes.tax_value+\'%)\'}}\n</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"title padding-left-10 padding-right-10 padding-bottom-10\" translate=\"POLICIES.PETS\"></div><div \nclass=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start start\" flex=\"100\" flex><md-input-container \nflex-gt-xs=\"33\" flex=\"100\" flex class=\"padding-left-10 padding-right-10 full-width md-block\" flex-gt-sm><label \nclass=\"margin-left-10\" translate=\"POLICIES.PETS_ALLOW\"></label><md-select name=\"vm\" \nng-model=\"vm.propertyData.is_pet_allowed\" required><md-option value=\"1\">{{ \'POLICIES.YES\' | translate }}</md-option>\n<md-option value=\"0\">{{ \'POLICIES.NO\' | translate }}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container><md-input-container flex-gt-xs=\"100\" flex=\"100\" flex \nclass=\"padding-left-10 padding-right-10 full-width md-block\" flex-gt-sm ng-if=\"vm.propertyData.is_pet_allowed != 0\">\n<label class=\"margin-left-10\" translate=\"POLICIES.PETS_CHARGES\"></label><md-select name=\"vm\" \nng-model=\"vm.propertyData.pet_price_type\" required><md-option value=\"free\">{{ \'POLICIES.FREE\' | translate }}\n</md-option><md-option value=\"pernight\">{{ \'POLICIES.PERNIGHT\' | translate }}</md-option><md-option value=\"wholestay\">\n{{ \'POLICIES.WHOLESTAY\' | translate }}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container>\n<md-input-container ng-if=\"vm.propertyData.pet_price_type != \'free\'\" flex-gt-xs=\"100\" flex=\"100\" flex \nclass=\"padding-left-10 padding-right-10 full-width md-block\" ng-if=\"vm.propertyData.is_pet_allowed != 0\"><label \nclass=\"title margin-left-10\">Price for pets</label><input name=\"postalCode\" type=\"number\" \nng-model=\"vm.propertyData.pet_price\" required></md-input-container><md-input-container \nclass=\"md-block padding-left-10 padding-right-10 full-width\" ng-if=\"vm.propertyData.is_internet_allowed != 0\" \nflex-gt-xs=\"100\" flex=\"100\" flex><label class=\"margin-left-10\">{{ \'POLICIES.TAX_FEES\' | translate }}</label><md-select \nng-model=\"vm.propertyData.pet_tax_id\"><md-option ng-value=\"0\"><em>{{\'POLICIES.NONE\' | translate}}</em></md-option>\n<md-option ng-value=\"taxes.tax_id\" ng-repeat=\"taxes in vm.taxes\">{{ taxes.tax_name+ \' (\'+taxes.tax_value+\'%)\'}}\n</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div></div></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" ng-click=\"vm.updatePropertyPolicy()\" \nng-class=\"!prpertyForm.$invalid && !prpertyForm.$pristine?\'md-raised md-green-500-bg submit-button white-fg\':\'md-raised md-accent submit-button grey-100-fg\'\" \nng-disabled=\"prpertyForm.$invalid || prpertyForm.$pristine\" aria-label=\"SAVE\" translate=\"SAVE\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/promotions/promotions.html","<div id=\"category\" class=\"lastcolumn_custom_two_icons page-layout simple fullwidth element-doc-page\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"content top-head\"><div class=\"content\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"main\"><div layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex-gt-xs=\"25\" flex><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start start\" flex><md-button ng-if=\"vm.hotel_id\" \nclass=\"goto-organizations-button md-icon-button padding-right-5\" aria-label=\"Go to organizations\" \nng-click=\"vm.gotorolesusers()\" translate translate-attr-aria-label=\"EC.GO_TO_ORGANIZATIONS\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"white-fg\"></md-icon></md-button><div layout=\"column\" layout-align=\"start center\" \nflex><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-sale\"></md-icon><span>\n{{ \'PROMOTION.PROMOTIONS\' | translate }}</span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"PROMOTION.TOTAL\"></span> <span>{{vm.totalPromotions}}</span></div></div></div></div><div class=\"search\" \nlayout=\"column\" layout-align=\"start center\" flex-gt-xs=\"40\" flex><div class=\"common-serch\" layout=\"row\" \nlayout-align=\"start center\" flex-gt-xs=\"100\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon margin-right-0\" layout=\"column\" layout-align=\"start start\" flex-gt-xs=\"5\" flex>\n</md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{ \'SEARCH\' | translate }}\" ng-model=\"filterText\" layout=\"column\" layout-align=\"start start\" \nflex-gt-xs=\"95\" flex></div></div><div class=\"logo\" layout=\"column\" layout-align=\"center end\" flex-gt-xs=\"30\" flex \nng-if=\"vm.userPermissions.indexOf(\'add_promotion\') != -1\"><md-button class=\"md-raised md-cornered\" \nng-click=\"vm.addPoromotion()\"><span><i class=\"icon-plus icon-plus-main\"></i> {{ \'PROMOTION.ADD\' | translate }}</span>\n</md-button></div></div></div></div></div><div class=\"content\"><div class=\"content\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"main RowClick\" ms-scroll><mdt-table \ntable-card=\"{visible: false, title: \'Promotions\'}\" paginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" \nselectable-rows=\"vm.isDeleteAllowed\" alternate-headers=\"\'contextual\'\" \nselected-row-callback=\"selectedRowCallback(rows)\" delete-row-callback=\"deleteSelectedItem()\" \nmdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n						\'table-row-id-key\': \'promotion_id\',\n						\'column-keys\': [\n						\'promotion_name\',\n						\'promotion_code\',\n						\'promotion_type\',\n						\'promotion_status\',\n						\'promotion_id\'\n						],\n				}\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{\'PROMOTION.NAME\' | translate}}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{\'PROMOTION.CODE\' | translate}}</span>\n</mdt-column><mdt-column align-rule=\"left\"><span>{{\'PROMOTION.TYPE\' | translate}}</span></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\" \ncolumn-filter=\"{\'valuesProviderCallback\': statusValuesCallback, \'valuesTransformerCallback\': statusValuesTransformer, \'placeholderText\': \'Select a status\', \'defaultValue\': defaultStatusFilter, \'filterType\': \'dropdown\'}\">\n<span>{{\'PROMOTION.STATUS\' | translate}}</span></mdt-column><mdt-column align-rule=\"left\"><span></span></mdt-column>\n</mdt-header-row><mdt-custom-cell html-content=\"true\" column-key=\"promotion_status\"><i \nng-class=\"value==1?\'icon-checkbox-marked-circle green-500-fg\':\'icon-cancel red-500-fg\'\" class=\"\"></i></mdt-custom-cell>\n<mdt-custom-cell html-content=\"true\" column-key=\"promotion_id\"><a class=\"cursorPointer action-icon-size\" \nng-click=\"clientScope.editmodel($event, value)\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"md-font material-icons icon-cog\" role=\"img\" aria-label=\"icon-cog\"></md-icon></a></mdt-custom-cell></mdt-table>\n</div></div></div></div>");
$templateCache.put("app/main/apps/quickBook/quickBook.html","");
$templateCache.put("app/main/apps/rateCalendarLogs/rateCalendarLogs.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-chart-line\" \nclass=\"mr-10\"></md-icon><span translate=\"RATECALENDARLOGS.TITLE\">Lodging Statistics</span></div></div></div><div \nclass=\"content loadingstatistic\"><div class=\"simple-table-container\"><div class=\"table-title\">Rate Calendar logs <span \nng-if=\"vm.startDate\">from {{ vm.startDate | date:\'MM/dd/yyyy\' }}</span> <span ng-if=\"vm.endDate\">\nto {{ vm.endDate | date:\'MM/dd/yyyy\' }}</span></div><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" \nflex-gt-xs=\"33\" flex=\"100\" class=\"ph-10\"><md-input-container class=\"md-block full-width mb-0\"><label \ntranslate=\"RATECALENDARLOGS.LOGSFROM\"></label><md-datepicker md-open-on-focus ng-model=\"vm.startDate\" \nclass=\"full-width mdinput-block\" ng-change=\"vm.ChangeEndDayIf()\"></md-datepicker><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div layout=\"column\" flex-gt-xs=\"33\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block full-width mb-0\"><label translate=\"RATECALENDARLOGS.LOGSTO\"></label><md-datepicker md-open-on-focus \nng-model=\"vm.endDate\" md-min-date=\"vm.startDate\" class=\"full-width mdinput-block\"></md-datepicker><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div layout=\"column\" flex-gt-xs=\"33\" flex=\"100\" \nclass=\"pl-60 pr-30\"><md-input-container><label>\n{{ vm.inventoryChangesFor.length > 0 ? \'Inventory Entity\': \'All types\' }}</label><md-select \nng-model=\"vm.inventoryChangesFor\" multiple=\"multiple\"><md-option ng-value=\"inventory\" \nng-repeat=\"inventory in vm.inventoryChangeFor\">{{inventory}}</md-option></md-select></md-input-container></div></div>\n<div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex-gt-xs=\"33\" flex=\"100\" class=\"pl-60 pr-30\">\n<md-input-container><label>{{ vm.selectedRoomTypes.length > 0 ? \'Selected Rooms\': \'All Rooms\' }}</label><md-select \nng-model=\"vm.selectedRoomTypes\" multiple=\"multiple\"><md-option ng-value=\"key\" ng-repeat=\"(key, value) in vm.roomTypes\">\n{{value}}</md-option></md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"33\" flex=\"100\" \nclass=\"pl-60 pr-30\"><md-input-container><label>{{ vm.selectedRatePlans.length > 0 ? \'Selected Rates\': \'All Rates\' }}\n</label><md-select ng-model=\"vm.selectedRatePlans\" multiple=\"multiple\"><md-option ng-value=\"key\" \nng-repeat=\"(key, value) in vm.ratePlans\">{{value}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"33\" flex=\"100\" class=\"pl-60 ph-10 pr-30\"><md-input-container><label>\n{{ vm.selectedChannels.length > 0 ? \'Selected Channels\': \'All Channels\' }}</label><md-select \nng-model=\"vm.selectedChannels\" multiple=\"multiple\"><md-option ng-value=\"key\" ng-repeat=\"(key, value) in vm.channels\">\n{{value}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\"><div layout=\"column\" \nflex-gt-xs=\"100\" flex=\"100\" class=\"ph-10 pb-20\" layout-align=\"center end\"><div><div class=\"logo\"><md-button \nclass=\"md-raised md-cornered\" ng-click=\"vm.refreshTable()\" ng-disabled=\"vm.requestProcessing\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\" ng-click=\"vm.refreshTable()\"></md-icon>\nRefresh<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.requestProcessing\"></md-progress-circular></md-button></div></div></div></div><div class=\"calendar-logs\">\n<mdt-table id=\"rateLogsTable\" table-card=\"{visible: true, title: \'Rate Calendar Logs\', columnSelector: true}\" \npaginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" \nmdt-row-paginator=\"vm.paginatorCallback(page, pageSize, options)\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getRateLogsResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n							\'table-row-id-key\': \'id\',\n							\'column-keys\': [\n								\'change_for\',\n								\'username\',\n								\'start_date\',\n								\'end_date\',\n								\'updated_from\',\n								\'created_date\',\n								\'id\',\n							]}\">\n<mdt-header-row><mdt-column align-rule=\"left\"><h5>Logs For</h5></mdt-column><mdt-column align-rule=\"left\"><h5>\nChanged By</h5></mdt-column><mdt-column align-rule=\"left\"><h5>From Date</h5></mdt-column><mdt-column align-rule=\"left\">\n<h5>To Date</h5></mdt-column><mdt-column align-rule=\"left\"><h5>Source Of Change</h5></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><h5>Changed At</h5></mdt-column><mdt-column align-rule=\"center\" \nclass=\"action-right-icons\"><h5>Action</h5></mdt-column></mdt-header-row><mdt-custom-cell column-key=\"id\">\n<mdt-custom-cell-content><button class=\"view-btn\" ng-click=\"clientScope.vm.fetchLogDetailsById(value)\">View</button>\n</mdt-custom-cell-content></mdt-custom-cell><mdt-custom-cell column-key=\"start_date\"><mdt-custom-cell-content>\n{{ value | date:\'MM-dd-yyyy\' }}</mdt-custom-cell-content></mdt-custom-cell><mdt-custom-cell column-key=\"end_date\">\n<mdt-custom-cell-content>{{ value | date:\'MM-dd-yyyy\' }}</mdt-custom-cell-content></mdt-custom-cell><mdt-custom-cell \ncolumn-key=\"created_date\"><mdt-custom-cell-content>{{ value | date:\'MM-dd-yyyy HH:mm:ss\' }}</mdt-custom-cell-content>\n</mdt-custom-cell></mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/rateCategory/rateCategory.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-button ng-if=\"vm.hotel_id\" \nclass=\"goto-organizations-button md-icon-button\" aria-label=\"Go to organizations\" ng-click=\"vm.gotorolesusers()\">\n<md-icon md-font-icon=\"icon-arrow-left\" class=\"white-fg\"></md-icon></md-button><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-currency-usd\"></md-icon><span translate=\"RATE_CAT.RATE_CATS\"></span></div><div \nclass=\"product-count secondary-text\"><span translate=\"RATE_CAT.TOTAL_RATE_CAT\"></span> <span>{{vm.totalUsers}}</span>\n</div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{ \'SEARCH\' | translate}}\" ng-model=\"filterText\" flex></div><div class=\"logo\" layout=\"row\" \nlayout-align=\"center end\" ng-if=\"vm.loggedInUserRole == 1\"><md-button layout=\"row\" class=\"md-raised md-cornered\" \nng-click=\"vm.gotoaddRole()\" ng-if=\"vm.userPermissions.indexOf(\'add_rate_rule\')!=-1\"><i \nclass=\"icon-plus icon-plus-main\"></i> {{ \'RATE_CAT.RATE_CAT\' | translate }}</md-button></div></div></div></div></div>\n<div class=\"content\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main RowClick\" \nms-scroll><mdt-table table-card=\"{visible: false, title: \'Users\'}\" \npaginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" selectable-rows=\"vm.delete_product\" \nalternate-headers=\"\'contextual\'\" selected-row-callback=\"selectedRowCallback(rows)\" \nmdt-row-paginator=\"paginatorCallback(page, pageSize, options, selected)\" delete-row-callback=\"deleteSelectedItem()\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\r\n        \'table-row-id-key\': \'rate_plan_id\',\r\n        \'column-keys\': [\r\n		\'rate_plan_name\',\r\n		\'policy_name\',\r\n		\'rate_plan_description\',\r\n		\'rate_plan_status\',\r\n		\'room_type_name\',\r\n        \'rate_plan_id\'\r\n        ],\r\n    }\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'RATE_CAT.NAME\' | translate}}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'RATE_CAT.POLICY\' | translate}}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'RATE_CAT.DESCRIPTION\' | translate}}</span>\n</mdt-column><mdt-column align-rule=\"left\"><span>{{ \'CONTACTS.STATUS\' | translate }}</span></mdt-column><mdt-column \nalign-rule=\"left\"><span>{{ \'RATE_CAT.ROOM_TYPE\' | translate}}</span></mdt-column><mdt-column align-rule=\"left\"><span>\n</span></mdt-column></mdt-header-row><mdt-custom-cell html-content=\"true\" column-key=\"rate_plan_id\"><a \nstyle=\"cursor:pointer\" ng-click=\"clientScope.goToEditPage(value)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s16 ng-scope md-default-theme md-font material-icons icon-pencil\" role=\"img\" aria-label=\"icon-cog\"></md-icon>\n</a></mdt-custom-cell><mdt-custom-cell html-content=\"true\" column-key=\"rate_plan_status\"><i \nng-class=\"value==1?\'icon-checkbox-marked-circle green-500-fg\':\'icon-cancel red-500-fg\'\" class=\"\"></i></mdt-custom-cell>\n<mdt-custom-cell html-content=\"true\" column-key=\"rate_plan_description\"><span class=\"desc-ellipse\">{{value}}</span>\n</mdt-custom-cell></mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/rateCategory/rateCategoryAddEdit.html","<form name=\"rateCategory\" class=\"md-inline-form fullwidth scroll-full-height\" novalidate><div id=\"rateCategoryPage\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page profileImage_page fullwidth\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-organizations-button md-icon-button\" aria-label=\"Go to users\" \nng-click=\"vm.gotoRateCategory()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\" \nng-if=\"vm.pageStatus == \'add\'\">{{ \'RATE_CAT.NEW_RATE_CAT\' | translate }}</div><div class=\"h2\" \nng-if=\"vm.pageStatus != \'add\'\">{{vm.pageHeader}}</div><div ng-if=\"vm.pageStatus == \'edit\'\" \nclass=\"subtitle secondary-text\"><span translate=\"RATE_CAT.RATE_CAT_DETAIL\"></span></div></div></div></div><div>\n<md-button class=\"md-raised md-background\" \nng-click=\"vm.pageStatus == \'add\'?vm.saveRateCategory():vm.UpdateRateCategory()\" \nng-disabled=\"rateCategory.$invalid ||  vm.codeError ||  vm.nameError || vm.disRoom  || vm.policy_length_error\" \nng-class=\"{\'md-blue-grey-A100-bg\': rateCategory.$invalid  ||vm.codeError || vm.nameError || vm.disRoom  || vm.policy_length_error }\" \ntranslate=\"GROUPS.SAVE\"></md-button><md-button class=\"md-raised md-background\" ng-click=\"vm.gotoRateCategory();\"><span \ntranslate=\"GROUPS.CANCEL\"></span></md-button></div></div><div class=\"content content-scroll\"><div \nclass=\"product-detail-form-container height\"><div class=\"role-list-outer height-main\"><div \nclass=\"role-list-out white-bg relative-block\" ng-if=\"vm.showSelectPlanType && vm.pageStatus != \'edit\'\">\n<md-input-container class=\"md-block tax-inputs\" flex-gt-xs=\"100\"><span class=\"form-title\" flex=\"100\" flex layout=\"row\" \ntranslate=\"RATE_CAT.RATE_PLAN_TYPE\"></span><md-radio-group class=\"no-margin\" flex=\"100\" layout=\"row\" layout-wrap \nng-model=\"vm.planType\" ng-click=\"vm.togglePlanType()\" required><md-radio-button flex=\"15\" flex-sm=\"20\" layout=\"column\" \nclass=\"space-block-padding\" value=\"room\" ng-disabled=\"vm.pageStatus == \'edit\'\">ROOMS</md-radio-button><md-radio-button \nflex=\"15\" flex-sm=\"20\" layout=\"cilumn\" class=\"space-block-padding\" value=\"boat\" ng-disabled=\"vm.pageStatus == \'edit\'\">\nSLIPS</md-radio-button><md-radio-button flex=\"15\" flex-sm=\"20\" layout=\"cilumn\" class=\"space-block-padding\" \nvalue=\"rent\" ng-disabled=\"vm.pageStatus == \'edit\'\" ng-if=\"vm.hotelId == 126\">RESIDENCE</md-radio-button>\n</md-radio-group></md-input-container><br></div><div class=\"role-list-out white-bg relative-block\" \nng-class=\"vm.pageStatus == \'edit\' ? \'padd-top\' : \'\'\"><div layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" class=\"ph-10\"><md-input-container class=\"md-block tax-inputs\" flex-gt-xs=\"45\"><label \ntranslate=\"RATE_CAT.ADD_NAME\"></label><input type=\"text\" name=\"rate category\" \nng-model=\"vm.rateCategory.rate_plan_name\" required aria-invalid=\"true\" ng-change=\"vm.checkRateCategoryName()\" \nng-model-options=\"{debounce: 500}\"> <span ng-if=\"vm.rateCategoryNameExists\" class=\"emailErrorRateCate\">\n{{ vm.rateCategoryNameExists }}</span></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nclass=\"ph-10\"><md-input-container class=\"md-block tax-inputs\" flex-gt-xs=\"45\"><label>Rate Plan Code</label><input \ntype=\"text\" name=\"rate category code\" ng-model=\"vm.rateCategory.rate_plan_code\" aria-invalid=\"true\" \nng-change=\"vm.checkRateCategoryCode()\" ng-model-options=\"{debounce: 500}\" \nng-disabled=\"vm.pageStatus == \'edit\' && vm.loggedInUserRole != 1\" required> <span ng-if=\"vm.rateCategoryCodeExists\" \nclass=\"emailErrorRateCate\">{{ vm.rateCategoryCodeExists }}</span></md-input-container></div></div><div layout=\"row\" \nflex=\"100\"><div layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" class=\"ph-10\"><md-input-container \nclass=\"md-block tax-inputs\" flex-gt-xs=\"45\"><label translate=\"RATE_CAT.DESCRIPTION\"></label><input type=\"text\" \nname=\"rate category\" ng-model=\"vm.rateCategory.rate_plan_description\" aria-invalid=\"true\" maxlength=\"140\"> <span \nclass=\"info-msg\">(max 140 characters allowed)</span></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" class=\"ph-10\"><md-input-container flex-gt-xs=\"100\" class=\"md-block tax-inputs\" data-ng-animate=\"1\">\n<label>Status</label><md-select ng-model=\"vm.rateCategory.rate_plan_status\" placeholder=\"Active / Inactive Rate Plan\" \nng-change=\"vm.showWarningToUser(vm.pageStatus);\" ng-disabled=\"vm.pageStatus == \'edit\' && vm.loggedInUserRole != 1\">\n<md-option value=\"1\">Enable</md-option><md-option value=\"0\">Disable</md-option></md-select></md-input-container></div>\n</div></div><div class=\"role-list-out white-bg relative-block\"><md-input-container class=\"md-block tax-inputs\" \nflex-gt-xs=\"100\"><span class=\"form-title\" flex=\"100\" flex layout=\"row\" translate=\"RATE_CAT.MANAGE_RATES\"></span>\n<md-radio-group class=\"no-margin\" ng-model=\"vm.autoMan\" ng-click=\"vm.toggleManageRate()\" required \nng-if=\"vm.fixedRate.rate_plan_id != vm.updateId\"><md-radio-button style=\"display:inline-block\" \nclass=\"space-block-padding\" value=\"0\">Standard Rate</md-radio-button><br><md-radio-button style=\"display:inline-block\" \nclass=\"space-block-padding\" value=\"1\" ng-if=\"vm.pageStatus == \'edit\' && vm.fixedRate.rate_plan_id > 0\">Derived Rate\n</md-radio-button></md-radio-group><md-radio-group class=\"no-margin\" ng-model=\"vm.autoMan\" \nng-click=\"vm.toggleManageRate()\" required ng-if=\"vm.pageStatus == \'edit\' && vm.fixedRate.rate_plan_id == vm.updateId\">\n<md-radio-button class=\"space-block-padding\" value=\"0\">Fixed Rate</md-radio-button></md-radio-group>\n</md-input-container><br><div ng-if=\"vm.autoMan == \'1\'\"><div class=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start\" flex ng-repeat=\"(key,value) in vm.derivedRateData\"><md-progress-linear md-mode=\"indeterminate\" \nng-show=\"vm.isloading\"></md-progress-linear><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" \nflex-gt-sm=\"50\" layout-align=\"start start\" class=\"padding-5\" flex><md-input-container flex-gt-xs=\"100\" \nclass=\"md-block tax-inputs\" data-ng-animate=\"1\"><label>Derived from</label><md-select \nng-model=\"vm.rateCategory.derivedDataValue[key].derivedFrom\" placeholder=\"Rate Plan\"><md-option \nvalue=\"{{vm.fixedRate.rate_plan_id}}\" ng-selected=\"vm.rateCategory.rate_plan_derived_from == 1\">\n{{vm.fixedRate.rate_plan_name}}</md-option></md-select></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" flex-gt-sm=\"50\" layout-align=\"end start\" flex>\n<md-input-container flex-gt-xs=\"100\" class=\"md-block tax-inputs\" data-ng-animate=\"2\"><label>Increase / Decrease</label>\n<md-select ng-model=\"vm.rateCategory.derivedDataValue[key].increaseDecrease\"><md-option value=\"1\" \nng-selected=\"vm.amountgroup == 1\">Increase (+)</md-option><md-option value=\"0\" ng-selected=\"vm.amountgroup == 0\">\nDecrease (-)</md-option></md-select></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" \nflex-gt-xs=\"100\" flex-gt-sm=\"50\" layout-align=\"end start\" flex><md-input-container flex-gt-xs=\"100\" \nclass=\"md-block tax-inputs\" data-ng-animate=\"2\" \nng-if=\"vm.rateCategory.derivedDataValue[key].increaseDecreaseBy == \'percentage\'\"><label>Value</label><input \ntype=\"number\" min=\"0\" max=\"100\" name=\"last_name\" ng-model=\"vm.rateCategory.derivedDataValue[key].derivedValue\" \nrequired></md-input-container><md-input-container flex-gt-xs=\"100\" class=\"md-block tax-inputs\" data-ng-animate=\"2\" \nng-if=\"vm.rateCategory.derivedDataValue[key].increaseDecreaseBy == \'dollar\'\"><label>Value</label><input type=\"number\" \nmin=\"0\" max=\"100000000\" name=\"last_name\" ng-model=\"vm.rateCategory.derivedDataValue[key].derivedValue\" required>\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" flex-gt-sm=\"50\" \nlayout-align=\"end start\" flex><md-input-container flex-gt-xs=\"100\" class=\"md-block tax-inputs\" data-ng-animate=\"2\">\n<label>Increase / Decrease By</label><md-select ng-model=\"vm.rateCategory.derivedDataValue[key].increaseDecreaseBy\" \nname=\"status\"><md-option value=\"percentage\" \nng-selected=\"vm.rateCategory.derivedDataValue[key].increaseDecreaseBy == \'percentage\'\">%</md-option><md-option \nvalue=\"dollar\" ng-selected=\"vm.rateCategory.derivedDataValue[key].increaseDecreaseBy == \'dollar\'\">$</md-option>\n</md-select></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" \nflex-gt-sm=\"50\" layout-align=\"start start\" class=\"padding-5\" flex><md-input-container flex-gt-xs=\"100\" \nclass=\"md-block tax-inputs\" data-ng-animate=\"1\"><label>Channel Name</label><md-select \nng-model=\"vm.rateCategory.derivedDataValue[key].channelId\" placeholder=\"Rate Plan\" required><md-option \nvalue=\"{{vm.rateCategory.derivedDataValue[key].channelId}}\" ng-selected=\"vm.rateCategory.rate_plan_derived_from == 1\">\n{{value.channelName}}</md-option></md-select></md-input-container></div></div></div></div><div \nclass=\"role-list-out white-bg relative-block\" ng-if=\"vm.planType == \'boat\' || vm.planType == \'rent\'\">\n<md-input-container class=\"md-block tax-inputs\" flex-gt-xs=\"100\"><span class=\"form-title\" flex=\"100\" flex layout=\"row\" \ntranslate=\"RATE_CAT.ADD_ROOM_TYPE\" ng-if=\"vm.planType == \'room\'\"></span> <span class=\"form-title\" flex=\"100\" flex \nlayout=\"row\" translate=\"RATE_CAT.ADD_BOAT_TYPE\" ng-if=\"vm.planType == \'boat\'\"></span><div flex=\"100\" \nng-if=\"vm.allRooms.length != 0\"><md-checkbox ng-click=\"vm.toggleAll()\" class=\"margin-top-bottom-custom\" \nng-model=\"vm.roomSelectAll\">Check All</md-checkbox></div><div flex=\"100\" \nng-repeat=\"(key, Pitem) in vm.allRoomswithParentName\" ng-if=\"vm.allRooms.length != 0\"><div ng-repeat=\"item in Pitem\">\n<md-checkbox class=\"margin-top-bottom-custom\" ng-model=\"vm.rateCategory.temp[item.room_type_id]\" \nng-checked=\"exists(item.room_type_id, vm.selectedRooms)\" ng-click=\"toggle(item.room_type_id, vm.selectedRooms,true)\" \nng-if=\"((vm.planType == \'rent\' && (item.room_type == \'rent\' || item.room_type == \'rent_type\')) || (vm.planType == \'boat\' && (item.room_type == \'boat\' || item.room_type == \'boat_type\')))\">\n{{ item.room_type_name }}</md-checkbox></div></div><span class=\"font-size-12 red-700-fg\" \nng-if=\"vm.allRooms.length == 0\" translate=\"RATE_CAT.ROOM_TYPE_ERROR\"></span></md-input-container><br></div><div \nclass=\"role-list-out white-bg relative-block\"><md-input-container class=\"md-block tax-inputs\" flex-gt-xs=\"100\"><span \nclass=\"form-title\" flex=\"100\" flex layout=\"row\" translate=\"RATE_CAT.ADD_POLICY\"></span><table \nng-if=\"vm.policy.length !=0 \"><tr ng-repeat=\"data in vm.policy\"><td><md-radio-group \nng-model=\"vm.rateCategory.rate_policy_id\" required><md-radio-button value=\"{{data.policy_id}}\">{{data.policy_name}}\n</md-radio-button></md-radio-group></td></tr></table><span class=\"font-size-12 red-700-fg\" \nng-if=\"vm.policy.length ==0 \" translate=\"RATE_CAT.POLICY_ERROR\"></span></md-input-container><br><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div flex-gt-xs=\"50\" flex=\"100\">\n<md-input-container class=\"md-block tax-inputs ph-10\"><label>Minimum Stay</label><md-select placeholder=\"Minimum Stay\" \nng-model=\"vm.rateCategory.rate_plan_min_stay\" name=\"status\" \nng-disabled=\"vm.pageStatus == \'edit\' && vm.loggedInUserRole != 1\"><md-option value=\"{{mindays}}\" \nng-repeat=\"mindays in vm.minDays\" required>{{mindays}}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div flex-gt-xs=\"50\" flex=\"100\"><md-input-container class=\"md-block tax-inputs ph-10\"><label\n class=\"ml-10\">Default Rate</label><input type=\"number\" min=\"1\" max=\"100000000\" name=\"default_price\" \nng-model=\"vm.rateCategory.rate_plan_default_price\" required><div class=\"md-errors-spacer\"></div></md-input-container>\n</div></div></div></div></div></div></div></form>");
$templateCache.put("app/main/apps/rentalListing/applicationDetail.html","<div id=\"add-contact\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg logo\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"goto-organizations-button md-icon-button\" aria-label=\"Go to customers\" ng-click=\"vm.goBack()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nng-if=\"!vm.newContact\" layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.pageTitle}}</div><div \nclass=\"subtitle secondary-text\"><span style=\"font-size: 20px\">Application Details</span></div></div><div \nng-if=\"vm.newContact\" layout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h2\" translate=\"CONTACTS.NEW_CONTACT\"></div></div></div></div></div></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.updateStatus()\" ng-class=\"md-blue-grey-A100-bg\"><span>Update</span>\n</md-button><md-button class=\"md-raised md-background\" ng-click=\"vm.goBack();\"><span translate=\"GROUPS.CANCEL\"></span>\n</md-button></div></div><div class=\"content scroll-height-sm\"><div class=\"main scroll-full-height\" ms-scroll><div \nclass=\"relative-block md-nopadding\" layout-align=\"center center\" layout-padding><div class=\"form-title blocktitle\">\nPayment Methods</div><div class=\"role-list-out white-bg relative-block\" style=\"margin:15px 0px\" flex=\"100\" \nlayout=\"row\"><div layout=\"column\" flex-gt-md=\"75\" flex-gt-sm=\"70\" flex=\"100\"><div \nclass=\"applicationpayment-method pr-15\"><table class=\"simple\" ms-responsive-table><tr class=\"heading\"><th>\nTransaction Id</th><th>Paid Date</th><th>Status</th><th>Agent</th><th>Payment</th><th>Action</th></tr><tr><td>\n{{vm.transactionDetail[\'txn_id\']}}</td><td>{{vm.transactionDetail[\'installment_paid_date\']}}</td><td>\n{{vm.transactionDetail[\'installment_status\']}}</td><td>--</td><td>{{vm.transactionDetail[\'installment_amount\']}}</td>\n<td><md-button style=\"max-width:100px;max-height:35px;opacity: 1;pointer-events: all\" \nclass=\"md-raised md-accent submit-button white-fg\" ng-click=\"vm.refundInstallment(vm.transactionDetail,\'refund\')\" \naria-label=\"Refund\" \nng-if=\"(vm.transactionDetail[\'transaction_status\'] == \'Settled Successfully\' || vm.transactionDetail[\'transaction_status\'] == \'\') && (vm.transactionDetail[\'installment_amount\'] != 0) && (vm.transactionDetail[\'installment_status\'] == \'paid\')\">\nRefund</md-button><md-button style=\"max-width:100px;max-height: 35px;opacity: 1;pointer-events: all\" \nclass=\"md-raised md-accent submit-button white-fg md-red-500-bg\" ng-click=\"vm.refundInstallment(installment,\'void\')\" \naria-label=\"Refund\" \nng-if=\"(vm.transactionDetail[\'transaction_status\'] == \'capturedPendingSettlement\') && vm.transactionDetail[\'installment_amount\'] != 0  && vm.transactionDetail[\'installment_status\'] == \'paid\'\">\nVoid</md-button><span ng-if=\"vm.transactionDetail[\'transaction_status\'] == \'voided\'\">Voided</span> <span \nng-if=\"vm.transactionDetail[\'transaction_status\'] != \'voided\' && (vm.transactionDetail[\'transaction_status\'] != \'Settled Successfully\' || (vm.transactionDetail[\'transaction_status\'] == \'Settled Successfully\' && vm.transactionDetail[\'installment_amount\'] == 0)) && vm.transactionDetail[\'transaction_status\'] != \'capturedPendingSettlement\'\">\n{{installment.transaction_status}}</span></td></tr></table></div></div><div layout=\"column\" flex-gt-md=\"25\" \nflex-gt-sm=\"30\" flex=\"100\" class=\"pl-15\" layout-align=\"start start\"><div flex=\"100\" class=\"totalblock\"><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap layout-align=\"start start\"><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"50\" layout-align=\"center start\"><span layout=\"column\"><b>Application Fee</b></span></div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"35\" layout-align=\"center end\">{{vm.paymentDetails[\'application_fee\'] | currency : $ : 2}}</div>\n</div><div class=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap layout-align=\"start start\"><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\"center start\"><span layout=\"column\"><b>Monthly Fee</b>\n</span></div><div class=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end\">\n{{vm.paymentDetails[\'monthly_price\']| currency : $ : 2}}</div></div><div class=\"sub-total-section\" layout=\"row\" \nflex=\"100\" layout-wrap layout-align=\"start start\"><div class=\"sub-total-col\" layout=\"column\" flex=\"50\" \nlayout-align=\"center start\"><span layout=\"column\"><b>Subtotal</b></span></div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" flex=\"35\" \nlayout-align=\"center end\">{{vm.paymentDetails[\'subtotal\']| currency : $ : 2}}</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap layout-align=\"start start\"><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"50\" layout-align=\"center start\"><span layout=\"column\"><b>Grand Total</b></span></div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"35\" layout-align=\"center end\">{{vm.paymentDetails[\'grand_total\']| currency : $ : 2}}</div></div>\n</div></div></div><form name=\"applicationForm\" class=\"md-inline-form no-padding\" novalidate><div \nclass=\"div-outer-simple-block pt-0\"><div class=\"form-title blocktitle\">Basic Information</div></div><div \nclass=\"role-list-out white-bg relative-block\" style=\"margin:15px 0px; padding-top:30px\"><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex layout-wrap><md-progress-linear md-mode=\"indeterminate\" \nng-show=\"vm.isloading\"></md-progress-linear><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" \nflex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\"><md-input-container class=\"md-block tax-inputs\" \ndata-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\" translate=\"CONTACTS.FIRST_NAME\"></label><input type=\"text\" \nname=\"first_name\" ng-model=\"vm.applicationData.first_name\" aria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\">\n<md-input-container class=\"md-block tax-inputs\" data-ng-animate=\"2\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"CONTACTS.LAST_NAME\"></label><input type=\"text\" name=\"last_name\" ng-model=\"vm.applicationData.last_name\" \naria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\">\n</md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex \nlayout-wrap><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\"><md-input-container class=\"md-block tax-inputs datepickerlabel\" data-ng-animate=\"1\"><label \nclass=\"ng-scope\" role=\"button\">Room stay from</label><md-datepicker class=\"birthday-input1 no-padding\" \nng-model=\"vm.applicationData.rental_from\" md-open-on-focus ng-model-options=\"{debounce: 500}\" required \nng-change=\"vm.getProductDetails()\" ng-disabled=\"true\"></md-datepicker></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\">\n<md-input-container class=\"md-block tax-inputs datepickerlabel\" data-ng-animate=\"2\"><label class=\"ng-scope\" \nrole=\"button\">Room stay to</label><md-datepicker class=\"birthday-input1 no-padding\" \nng-model=\"vm.applicationData.rental_to\" md-open-on-focus ng-model-options=\"{debounce: 500}\" ng-disabled=\"true\">\n</md-datepicker></md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" layout-wrap><md-input-container class=\"md-block tax-inputs mdinputblk\" data-ng-animate=\"1\" \nflex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\"><label class=\"ng-scope md-required ml-10\" \nrole=\"button\" translate=\"CONTACTS.EMAIL\"></label><input type=\"email\" name=\"email\" \nng-model=\"vm.applicationData.customer_email\" required aria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" \nng-pattern=\"/^.+@.+\\..+$/\" class=\"lesswidthright\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div \nng-messages=\"applicationForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span \ntranslate=\"CONTACTS.VALID_EMAIL\"></span></div></div><div ng-if=\"vm.emailError\" class=\"emailError\"><span \ntranslate=\"CONTACTS.EMAIL_EXISTS\" class=\"pl-10\"></span></div></md-input-container><md-input-container \nclass=\"md-block tax-inputs ph-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\"><label \nclass=\"ml-10\" role=\"button\">Application Status</label><md-select ng-model=\"vm.applicationData.application_status\" \nng-change=\"vm.updateStatus()\"><md-option value=\"pending\">Pending</md-option><md-option value=\"accept\">Accept\n</md-option><md-option value=\"reject\">Reject</md-option></md-select></md-input-container></div><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><md-input-container \nclass=\"md-block tax-inputs ph-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\"><label \nclass=\"ml-10\" role=\"button\" translate=\"CONTACTS.PHONE_NUMBER\"></label><input type=\"text\" name=\"phone_number\" \nng-model=\"vm.applicationData.phone_number\" aria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"><div ng-messages=\"applicationForm.phone_number.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"pattern\"><span translate=\"CONTACTS.VALID_PHONE\"></span></div></div></md-input-container>\n<md-input-container class=\"md-block tax-inputs ph-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\"><label class=\"ml-10\" role=\"button\" translate=\"CONTACTS.SECONDARY_PHONE_NUMBER\"></label>\n<input type=\"text\" name=\"secondary_phone_number\" ng-model=\"vm.applicationData.secondary_phone_number\" \naria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div \nng-messages=\"applicationForm.secondary_phone_number.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\">\n<span translate=\"CONTACTS.VALID_PHONE\"></span></div></div></md-input-container></div></div><div><ang-accordion \nclose-icon-class=\"fa fa-chevron-right\" open-icon-class=\"fa fa-chevron-down\" one-at-a-time=\"true\" \nclass=\"collapseblockmain\"><collapsible-item item-title=\"{{key}}\" ng-repeat=\"(key,mainRow) in vm.formFields\"><div \nclass=\"row-col mt-15 mb-15\" flex=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nng-repeat=\"(sKey,row) in mainRow\" flex=\"{{row.type == \'radio\'? 100 : 33}}\" layout=\"column\" class=\"ph-10\" \nlayout-align=\"start start\"><md-input-container \nng-if=\"row.type != \'date\' && row.type != \'number\' && row.type != \'button\' && row.type != \'radio\'\" \nclass=\"md-block tax-inputs\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">{{row.label}}</label><input \ntype=\"{{row.type}}\" name=\"{{row.name}}\" ng-model=\"vm.applicationData[row.name]\" aria-invalid=\"true\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container>\n<md-input-container ng-if=\"row.type == \'number\' \" class=\"md-block tax-inputs\" data-ng-animate=\"1\"><label \nclass=\"ng-scope\" role=\"button\">{{row.label}}</label><input type=\"text\" name=\"{{row.name}}\" \nng-model=\"vm.applicationData[row.name]\" aria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container><md-input-container ng-if=\"row.type == \'date\'\" \nclass=\"md-block md-datepicker mb-0 datepickernewblock\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">\n{{row.label}}</label><md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.applicationData[row.name]\" \nmd-open-on-focus ng-model-options=\"{debounce: 500}\" required></md-datepicker></md-input-container><md-input-container \nng-if=\"row.type == \'radio\'\" class=\"md-input-has-value\"><p class=\"mt-0 mb-5 radioblockpara\" role=\"button\" \nng-if=\"row.type == \'radio\'\">{{row.label}}</p><md-radio-group class=\"radioblocknewmain\" \nng-model=\"vm.applicationData[row.name]\" ng-if=\"row.type == \'radio\'\"><md-radio-button class=\"mr-10\" value=\"{{subRow}}\" \nng-repeat=\"(subKey, subRow) in row[\'subValues\']\">{{subRow}}</md-radio-button></md-radio-group></md-input-container>\n</div></div></collapsible-item></ang-accordion></div></form></div><h3 ng-if=\"vm.tax.currenttaxdata.length == 0\"></h3>\n</div></div></div>");
$templateCache.put("app/main/apps/rentalListing/rentalListing.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-button ng-if=\"vm.hotel_id\" \nclass=\"goto-organizations-button md-icon-button\" aria-label=\"Go to organizations\" ng-click=\"vm.gotorolesusers()\">\n<md-icon md-font-icon=\"icon-arrow-left\" class=\"white-fg\"></md-icon></md-button><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-calendar-select\"></md-icon><span>Application for rents</span></div><div \nclass=\"product-count secondary-text\"><span>Total Applications</span> <span>{{vm.totalUsers}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{ \'SEARCH\' | translate}}\" ng-model=\"filterText\" flex></div><div class=\"logo\" layout=\"row\" \nlayout-align=\"center end\" ng-if=\"vm.userPermissions.indexOf(\'add_restriction\')!=-1\"></div></div></div></div></div><div \nclass=\"content\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"main RowClick newRowClick\" ms-scroll><mdt-table table-card=\"{visible: false, title: \'Users\'}\" \npaginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" selectable-rows=\"vm.delete_product\" \nalternate-headers=\"\'contextual\'\" selected-row-callback=\"selectedRowCallback(rows)\" \nmdt-row-paginator=\"paginatorCallback(page, pageSize, options, selected)\" delete-row-callback=\"deleteSelectedItem()\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\r\n        \'table-row-id-key\': \'rental_id\',\r\n        \'column-keys\': [\r\n		\'first_name\',\r\n	    \'last_name\',\r\n	    \'customer_email\',\r\n	    \'phone_number\',\r\n	    \'rental_from\',\r\n	    \'rental_to\',\r\n	    \'editId\',\r\n	    \'rental_id\'\r\n        ],\r\n    }\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>First Name</span></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><span>Last Name</span></mdt-column><mdt-column align-rule=\"left\" \ncolumn-sort=\"true\"><span>Email</span></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>Phone Number\n</span></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>From</span></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><span>To</span></mdt-column><mdt-column align-rule=\"left\"><span>Status</span>\n</mdt-column><mdt-column align-rule=\"left\"><span></span></mdt-column></mdt-header-row><mdt-custom-cell \nhtml-content=\"true\" column-key=\"editId\"><a ng-click=\"clientScope.openCustomPage(value,$event)\" \nclass=\"actionmainblock cursorPointer\"><span ng-init=\"status = value.split(\'-\')\" ng-bind-html=\"status[1]\"></span></a>\n</mdt-custom-cell><mdt-custom-cell html-content=\"true\" column-key=\"rental_id\"><a \nng-click=\"clientScope.goToEditPage(value)\"><md-icon md-font-icon=\"icon-icon-border-color\" \nclass=\"icon icon-border-color cursorPointer\" role=\"img\" aria-label=\"icon-cog\"></md-icon></a></mdt-custom-cell>\n</mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/rateRule/rateCustomCalendar.html","<div id=\"rateRulePage\" class=\"page-layout carded fullwidth\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-show=\"!vm.mainErrorMsg && vm.isloading\">\n</md-progress-linear><div class=\"header\" layout=\"column\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\">\n<md-icon md-font-icon=\"icon-currency-usd\" class=\"icon\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"RATERULE.RATE_RULES\"></span></div><div layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.reload()\" class=\"md-icon-button white-fg\" aria-label=\"Reload\" translate \ntranslate-attr-aria-label=\"GANTT.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip><span \ntranslate=\"RATERULE.RELOAD\">RELOAD</span></md-tooltip></md-button><div ng-if=\"!vm.mainErrorMsg\"><md-button \nclass=\"md-raised md-background\" type=\"submit\" ng-click=\"vm.bulkUpdate($event)\"><span translate=\"RATERULE.BULK_UPDATE\">\n</span></md-button></div><div ng-if=\"!vm.mainErrorMsg && false\"><md-button class=\"md-raised md-background\" \ntype=\"submit\" ng-click=\"vm.copyrates($event)\"><span translate=\"RATERULE.COPY\"></span></md-button></div></div></div><div\n class=\"bottom\" layout=\"row\" layout-gt-sm=\"row\" layout-align-gt-sm=\"end center\" flex=\"100\"><div \nclass=\"date-filter-box md-whiteframe-3dp no-padding\" layout=\"column\" flex layout-align-gt-xs=\"center center\" \nflex=\"100\" flex-gt-sm=\"25\" ng-if=\"vm.hotel_id == 126 || vm.hotel_id == 122\"><md-input-container \nclass=\"md-block tax-inputs no-margin md-input-blockcontainer\" flex><md-select class=\"no-border\" \nng-model=\"vm.selectedType\" name=\"status\" ng-change=\"vm.changeType()\"><md-option class=\"capitalize\" value=\"{{key}}\" \nng-repeat=\"(key,val) in vm.roomTypeSelect\">{{val}}</md-option></md-select></md-input-container></div><div \nclass=\"date-filter-box md-whiteframe-3dp no-padding\" layout=\"column\" flex layout-align-gt-xs=\"center center\" \nflex=\"100\" flex-gt-sm=\"25\" ng-if=\"vm.subHotels.length > 0\"><md-input-container \nclass=\"md-block tax-inputs no-margin md-input-blockcontainer\" flex><md-select class=\"no-border\" \nng-model=\"vm.selectSubHotel\" name=\"status\" ng-change=\"vm.changeSubHotel()\"><md-option class=\"capitalize\" \nvalue=\"{{subhotel.hotel_id}}\" ng-repeat=\"subhotel in vm.subHotels\">{{subhotel.hotel_title}}</md-option></md-select>\n</md-input-container></div><div class=\"date-filter-box md-whiteframe-3dp no-padding\" layout=\"column\" flex \nlayout-align-gt-xs=\"center center\" flex=\"100\" flex-gt-sm=\"25\"><md-input-container \nclass=\"md-block tax-inputs no-margin md-input-blockcontainer\" flex><md-select class=\"no-border\" \nng-model=\"vm.roomTypeSel\" name=\"status\" ng-change=\"vm.changeFilters()\"><md-option value=\"{{roomSel.id}}\" \nng-repeat=\"(key,roomSel) in vm.onlyRooms\">{{roomSel.name}}</md-option></md-select></md-input-container></div><div \nclass=\"date-filter-box md-whiteframe-3dp no-padding\" layout=\"column\" flex layout-align-gt-xs=\"center center\" \nflex=\"100\" flex-gt-sm=\"25\" ng-if=\"vm.selectedType == \'room\'\"><md-input-container \nclass=\"md-block tax-inputs no-margin md-input-blockcontainer\" flex><md-select class=\"no-border\" \nng-model=\"vm.ratePlanSel\" name=\"status\" ng-change=\"vm.changeFilters()\"><md-option value=\"0\" \nng-selected=\"vm.ratePlanSel===0\">All Rates</md-option><md-option class=\"capitalize\" \nvalue=\"{{ratePlanData.rate_plan_id}}\" ng-repeat=\"(key,ratePlanData) in vm.ratePlansData[\'room\']\">{{ratePlanData.name}}\n</md-option></md-select></md-input-container></div><div class=\"date-filter-box md-whiteframe-3dp no-padding\" \nlayout=\"column\" flex layout-align-gt-xs=\"center center\" flex=\"100\" flex-gt-sm=\"25\" ng-if=\"vm.selectedType == \'boat\'\">\n<md-input-container class=\"md-block tax-inputs no-margin md-input-blockcontainer\" flex><md-select class=\"no-border\" \nng-model=\"vm.ratePlanSel\" name=\"status\" ng-change=\"vm.changeFilters()\"><md-option value=\"0\" \nng-selected=\"vm.ratePlanSel===0\">All Rates</md-option><md-option class=\"capitalize\" \nvalue=\"{{ratePlanData.rate_plan_id}}\" ng-repeat=\"(key,ratePlanData) in vm.ratePlansData[\'boat\']\">{{ratePlanData.name}}\n</md-option></md-select></md-input-container></div><div class=\"date-filter-box md-whiteframe-3dp no-padding\" \nlayout=\"column\" flex layout-align-gt-xs=\"center center\" flex=\"100\" flex-gt-sm=\"25\"><md-input-container \nclass=\"md-block tax-inputs no-margin md-input-blockcontainer\" flex><md-select class=\"no-border\" \nng-model=\"vm.optionsSel\" name=\"status\" ng-change=\"vm.changeView()\"><md-option class=\"capitalize\" value=\"{{key}}\" \nng-repeat=\"(key,optionAvail) in vm.optionsAvail\">{{optionAvail}}</md-option></md-select></md-input-container></div><div\n class=\"date-filter-box md-whiteframe-3dp md-datepicker md-input-blockcontainer padding-top-5\" layout=\"column\" flex \nflex=\"100\" flex-gt-sm=\"25\" layout-align-gt-xs=\"center center\"><md-date-range class=\"\" ng-model=\"vm.fromDate\" \nshow-template=\"false\" auto-confirm=\"true\" md-on-select=\"vm.changeDates()\" style=\"width:100%\"></md-date-range></div>\n</div></div><div class=\"content-card\" layout=\"column\" flex><div ng-if=\"vm.mainErrorMsg\"><p><md-icon \nmd-font-icon=\"icon-alert\" class=\"\"></md-icon>Oops! {{vm.mainErrorMsg}}</p></div><md-content id=\"chart-container\" \nclass=\"content relative-block\" flex layout=\"column\" style=\"max-height: {{vm.height}}px\"><div \nclass=\"rate-container table-wrapper\"><table class=\"table table-bordered table-header\"><tbody><tr><td \nclass=\"row-title room-header\"><div layout=\"row\" class=\"color-pallets\"><div><i \nstyle=\"background: #f1877f;display: inline-block;border-radius: 4px\"></i></div><div class=\"title-color-types\">\nDefault Room Type Price</div></div><div layout=\"row\" class=\"color-pallets\" style=\"padding-top: 6px\"><div><i \nstyle=\"background: #daf1f4;display: inline-block;border-radius: 4px\"></i></div><div class=\"title-color-types\">\nActual Room Type Price</div></div></td><td class=\"inner-table\"><table class=\"date-range-table\"><tr><td class=\"month\" \ncolspan=\"{{val}}\" ng-repeat=\"(key,val) in vm.monthRange\">{{key}}</td></tr><tr><td ng-repeat=\"date in vm.dateRange\" \nclass=\"row-value custom-date-range\"><span>{{date.day}}</span> <span>{{date.name}}</span></td></tr></table></td></tr>\n</tbody></table><table class=\"table table-bordered hotel-name\" ng-if=\"vm.roomTypes && vm.roomTypes.length > 0\"><tbody \nclass=\"hotel-name-row\"><tr ng-if=\"vm.selectSubHotel\"><td class=\"row-title hotel-name\">{{ vm.roomTypes[0].hotel_title }}\n<md-tooltip class=\"the-tooltip\" md-direction=\"top\"><div class=\"data\"><span>{{ vm.roomTypes[0].hotel_title }}</span>\n</div></md-tooltip></td><td ng-repeat=\"date in vm.dateRange\" class=\"row-value occupancy-cell\" \nng-class=\"{\'fri\': date.name === \'Fri\',\'sat\': date.name === \'Sat\'}\" title=\"Occupancy\">\n{{ vm.getPercentageForDate(date, vm.roomTypes[0].hotel_title) }}</td></tr></tbody></table><div \nng-show=\"vm.roomTypeSel == 0 || roomType.id == vm.roomTypeSel\" ng-repeat=\"roomType in vm.roomTypes\"><table \nclass=\"table table-bordered\"><tbody class=\"room-type\"><tr class=\"room-type-header\" \nng-class=\"{\'with-subhotel\': vm.selectSubHotel, \'no-subhotel\': !vm.selectSubHotel}\"><td class=\"row-title room-name\"><div\n layout=\"column\"><span class=\"room-name-span\">{{roomType.name}}</span> <span class=\"product-count\" \nng-if=\"vm.getProductCount(roomType.id) > 0\">(Total Rooms : {{vm.getProductCount(roomType.id)}} )</span></div>\n<md-tooltip class=\"the-tooltip\" md-direction=\"top\"><div class=\"data\"><span>{{roomType.name}}</span></div></md-tooltip>\n</td><td ng-repeat=\"date in vm.dateRange\" class=\"row-value room-availability\" \nng-class=\"{\'fri\': date.name === \'Fri\',\'sat\': date.name === \'Sat\'}\" \nng-init=\"dateData = {mlsValue: null, availability: null}\"><span \nng-if=\"vm.unAvailableDates[roomType.id] && vm.unAvailableDates[roomType.id][date.date] !== undefined\" \nng-init=\"dateData.availability = vm.unAvailableDates[roomType.id][date.date]\">\n{{vm.unAvailableDates[roomType.id][date.date]}} </span><i class=\"mls-yellow\" ng-repeat=\"rate in vm.roomTypeRates\" \nng-if=\"rate.room_type_id == roomType.id\"><span ng-repeat=\"val in rate.data\" \nng-if=\"val.date == date.date && val.mls > 1\" ng-init=\"dateData.mlsValue = val.mls\">{{val.mls}}</span></i><md-tooltip \nclass=\"the-tooltip\" ng-if=\"dateData.mlsValue\" md-direction=\"top\"><div class=\"data\"><span class=\"first-span\">\nAvailability </span>: <span class=\"last-span\">{{dateData.availability}} out of {{vm.getProductCount(roomType.id)}}\n</span></div><div class=\"data\"><span class=\"first-span\">MLS </span>: <span class=\"last-span\">\n{{dateData.mlsValue}} Nights</span></div></md-tooltip><md-tooltip class=\"the-tooltip\" ng-if=\"!dateData.mlsValue\" \nmd-direction=\"top\"><div class=\"data\"><span class=\"first-span\">Availability </span>: <span class=\"last-span\">\n{{dateData.availability}} out of {{vm.getProductCount(roomType.id)}}</span></div></md-tooltip></td></tr></tbody><tbody \nng-repeat-start=\"ratePlan in vm.roomRate[roomType.id].ratePlans track by ratePlan.id\"><tr \nng-if=\"ratePlan.channel_number > 0\"><td class=\"row-title room-title\">{{ratePlan.name}} <span \nng-if=\"ratePlan.channel_number\" class=\"drop-arrow\" style=\"color: #43b3e5;cursor: pointer\" \nng-show=\"!vm.showChannelRate[roomType.id][ratePlan.rate_plan_code]\" \nng-click=\"vm.getchannelPrices(roomType.id, ratePlan.rate_plan_code)\">Channel {{ratePlan.channel_number}} <img \nng-show=\"!vm.showChannelRate[roomType.id][ratePlan.rate_plan_code]\" \nsrc=\"assets/icons/keyboard_arrow_right-black-18dp.svg\"></span><span ng-if=\"ratePlan.channel_number\" class=\"drop-arrow\" \nng-show=\"vm.showChannelRate[roomType.id][ratePlan.rate_plan_code]\" \nng-click=\"vm.hideChannelRates(roomType.id, ratePlan.rate_plan_code)\" style=\"color: #43b3e5;cursor: pointer\">\nChannel {{ratePlan.channel_number}} <img class=\"drop-arrow\" \nng-show=\"vm.showChannelRate[roomType.id][ratePlan.rate_plan_code]\" \nsrc=\"assets/icons/keyboard_arrow_down-black-18dp.svg\"></span></td><td ng-repeat=\"date in vm.dateRange\" \nclass=\"row-value\" ng-class=\"{\'fri\': date.name === \'Fri\',\'sat\': date.name === \'Sat\'}\"></td></tr></tbody><tbody \nng-repeat-end><tr class=\"custom-channels\" ng-if=\"vm.showChannelRate[roomType.id][ratePlan.rate_plan_code]\" \nng-repeat=\"(channel,rates) in vm.channelRates[roomType.id][ratePlan.rate_plan_code]\"><td \nclass=\"row-title inner-channel-title\">{{rates.name}}</td><td class=\"input-rate-wrapper\" \nng-repeat=\"rate in rates.rates track by $index\" class=\"row-value\" \nng-class=\"{\n											\'row-value\': true,\n											\'default-price\': rate.defaultprice && vm.optionsSel == 1,\n											\'stop-sell-yes\': vm.optionsSel == 2 && (rate.current_val == 1 || rate.current_val == \'1\' || rate.name == \'Yes\'),\n											\'cta-yes\': vm.optionsSel == 3 && (rate.current_val == 1 || rate.current_val == \'1\' || rate.name == \'Yes\'),\n											\'ctd-yes\': vm.optionsSel == 4 && (rate.current_val == 1 || rate.current_val == \'1\' || rate.name == \'Yes\'),\n											\'min-stay-highlight\': vm.optionsSel == 5 && (+rate.current_val > 1),											\n											\'fri\': vm.dateRange[$index].name === \'Fri\',\n											\'sat\': vm.dateRange[$index].name === \'Sat\',\n\n										}\">\n<span \nng-if=\"vm.optionsSel == 1 && vm.showInput != roomType.id+\'_\'+rate.rate_plan_id+\'_\'+rates.channel_id+\'_\'+rate.index+\'_rate\'\" \nng-click=\"vm.showInputFn(rate, rates.channel_id, ratePlan.rate_plan_code)\" \nclass=\"{{(roomType.id+\'_\'+rate.rate_plan_id+\'_\'+rates.channel_id+\'_\'+rate.index+\'_rate\')}} view-current-val\">\n${{rate.current_val}}</span> <span \nng-if=\"vm.optionsSel == 5 && vm.showInput != roomType.id+\'_\'+rate.rate_plan_id+\'_\'+rates.channel_id+\'_\'+rate.index+\'_rate\'\" \nng-click=\"vm.showInputFn(rate, rates.channel_id, ratePlan.rate_plan_code)\" \nclass=\"{{(roomType.id+\'_\'+rate.rate_plan_id+\'_\'+rates.channel_id+\'_\'+rate.index+\'_rate\')}} view-current-val\">\n{{rate.current_val}}</span> <span class=\"view-current-val\" ng-if=\"vm.optionsSel == 2\" \nng-click=\"vm.showInputFn(rate, rates.channel_id, ratePlan.rate_plan_code)\">{{rate.name}}</span> <span \nclass=\"view-current-val\" ng-if=\"vm.optionsSel == 3\" \nng-click=\"vm.showInputFn(rate, rates.channel_id, ratePlan.rate_plan_code)\">{{rate.name}}</span> <span \nclass=\"view-current-val\" ng-if=\"vm.optionsSel == 4\" \nng-click=\"vm.showInputFn(rate, rates.channel_id, ratePlan.rate_plan_code)\">{{rate.name}}</span> <span \nclass=\"input-rate-span\" \nng-if=\"vm.showInput == roomType.id+\'_\'+rate.rate_plan_id+\'_\'+rates.channel_id+\'_\'+rate.index+\'_rate\'\"><input \nclass=\"input-rate rateRuleCustomText\" ng-if=\"vm.optionsSel == 1\" type=\"text\" ng-model=\"vm.raterule.room_type_price\" \nonkeypress=\"if (event.which==13) event.target.blur()\" \nng-blur=\"vm.editPrice(roomType.id, ratePlan.rate_plan_code, channel, $index)\" \nid=\"{{roomType.id+\'_\'+rate.rate_plan_id+\'_\'+rates.channel_id+\'_\'+rate.index+\'_rate\'}}\" required allow-decimal-numbers> \n<input class=\"input-rate rateRuleCustomText\" ng-if=\"vm.optionsSel == 5\" type=\"text\" ng-model=\"vm.raterule.min_stay\" \nid=\"{{roomType.id+\'_\'+rate.rate_plan_id+\'_\'+rates.channel_id+\'_\'+rate.index+\'_rate\'}}\" \nonkeypress=\"if (event.which==13) event.target.blur()\" \nng-blur=\"vm.editPrice(roomType.id, ratePlan.rate_plan_code, channel, $index)\" required allow-decimal-numbers></span>\n</td></tr></tbody></table></div></div></md-content></div></div></div>");
$templateCache.put("app/main/apps/rateRule/rateRule.html","<div id=\"rateRulePage\" class=\"page-layout carded fullwidth\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"column\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\">\n<md-icon md-font-icon=\"icon-currency-usd\" class=\"icon\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"RATERULE.RATE_RULES\"></span></div><div layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.reload()\" class=\"md-icon-button white-fg\" aria-label=\"Reload\" translate \ntranslate-attr-aria-label=\"GANTT.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip><span \ntranslate=\"RATERULE.RELOAD\">RELOAD</span></md-tooltip></md-button><div ng-if=\"!vm.mainErrorMsg\"><md-button \nclass=\"md-raised md-background\" type=\"submit\" ng-click=\"vm.bulkUpdate($event)\"><span translate=\"RATERULE.BULK_UPDATE\">\n</span></md-button></div><div ng-if=\"!vm.mainErrorMsg && false\"><md-button class=\"md-raised md-background\" \ntype=\"submit\" ng-click=\"vm.copyrates($event)\"><span translate=\"RATERULE.COPY\"></span></md-button></div></div></div><div\n class=\"bottom\" layout=\"row\" layout-gt-sm=\"row\" layout-align-gt-sm=\"end center\" flex=\"100\"><div class=\"search-boxes\" \nflex layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><div class=\"search md-whiteframe-3dp\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex \nng-model=\"vm.searchRowKeyword\" ng-change=\"vm.search(\'rows\', vm.searchRowKeyword)\" type=\"text\" \nplaceholder=\"Search in rows\" translate translate-attr-placeholder=\"RATERULE.SEARCH_IN_RATES\"></div></div><div \nclass=\"date-filter-box md-whiteframe-3dp no-padding\" layout=\"column\" flex layout-align-gt-xs=\"center center\" \nflex=\"100\" flex-gt-sm=\"25\"><md-input-container class=\"md-block tax-inputs no-margin md-input-blockcontainer\" flex>\n<md-select class=\"no-border\" ng-model=\"vm.roomTypeSel\" name=\"status\" ng-change=\"vm.changeFilters()\" \nng-if=\"!vm.isParent && !vm.boatExists\"><md-option value=\"{{roomSel.id}}\" \nng-repeat=\"(key,roomSel) in vm.onlyRooms[\'parent\']\">{{roomSel.name}}</md-option></md-select><md-select \nclass=\"no-border\" ng-model=\"vm.roomTypeSel\" name=\"status\" ng-change=\"vm.changeFilters()\" \nng-if=\"vm.isParent || vm.boatExists\"><md-optgroup label=\"{{sHKey}}\" ng-repeat=\"(sHKey,subHotel) in vm.onlyRooms\">\n<md-option value=\"{{roomSel.id}}\" ng-repeat=\"(key,roomSel) in subHotel\">{{roomSel.name}}</md-option></md-optgroup>\n</md-select></md-input-container></div><div class=\"date-filter-box md-whiteframe-3dp no-padding\" layout=\"column\" flex \nlayout-align-gt-xs=\"center center\" flex=\"100\" flex-gt-sm=\"25\" ng-if=\"!vm.boatExists\"><md-input-container \nclass=\"md-block tax-inputs no-margin md-input-blockcontainer\" flex><md-select class=\"no-border\" \nng-model=\"vm.ratePlanSel\" name=\"status\" ng-change=\"vm.changeFilters()\"><md-option value=\"0\" \nng-selected=\"vm.ratePlanSel===0\">All Rates</md-option><md-option class=\"capitalize\" \nvalue=\"{{ratePlanData.rate_plan_id}}\" ng-repeat=\"(key,ratePlanData) in vm.ratePlansData[\'room\']\">{{ratePlanData.name}}\n</md-option></md-select></md-input-container></div><div class=\"date-filter-box md-whiteframe-3dp no-padding\" \nlayout=\"column\" flex layout-align-gt-xs=\"center center\" flex=\"100\" flex-gt-sm=\"25\" ng-if=\"vm.boatExists\">\n<md-input-container class=\"md-block tax-inputs no-margin md-input-blockcontainer\" flex><md-select class=\"no-border\" \nng-model=\"vm.ratePlanSel\" name=\"status\" ng-change=\"vm.changeFilters()\"><md-option value=\"0\" \nng-selected=\"vm.ratePlanSel===0\">All Rates</md-option><md-optgroup label=\"{{header}}\" \nng-repeat=\"(header,row) in vm.ratePlansData\"><md-option value=\"{{ratePlanData.rate_plan_id}}\" \nng-repeat=\"(key,ratePlanData) in row\">{{ratePlanData.name}}</md-option></md-optgroup></md-select></md-input-container>\n</div><div class=\"date-filter-box md-whiteframe-3dp no-padding\" layout=\"column\" flex \nlayout-align-gt-xs=\"center center\" flex=\"100\" flex-gt-sm=\"25\"><md-input-container \nclass=\"md-block tax-inputs no-margin md-input-blockcontainer\" flex><md-select class=\"no-border\" \nng-model=\"vm.optionsSel\" name=\"status\" ng-change=\"vm.changeView()\"><md-option class=\"capitalize\" value=\"{{key}}\" \nng-repeat=\"(key,optionAvail) in vm.optionsAvail\">{{optionAvail}}</md-option></md-select></md-input-container></div><div\n class=\"date-filter-box md-whiteframe-3dp md-datepicker md-input-blockcontainer padding-top-5\" layout=\"column\" flex \nflex=\"100\" flex-gt-sm=\"25\" layout-align-gt-xs=\"center center\"><md-datepicker class=\"no-margin\" \nmd-hide-icons=\"calendar\" ng-model=\"vm.options.fromDate\" md-open-on-focus md-min-date=\"\" \nng-change=\"vm.load(\'changeDate\')\" ng-model-options=\"{debounce: 500}\" flex></md-datepicker></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div ng-if=\"vm.mainErrorMsg\"><p><md-icon md-font-icon=\"icon-alert\" class=\"\">\n</md-icon>Oops! {{vm.mainErrorMsg}}</p></div><md-content id=\"chart-container test\" class=\"content relative-block\" flex \nlayout=\"column\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"!vm.mainErrorMsg && vm.isloading\">\n</md-progress-linear><div class=\"rate-rule-input\"></div><gantt flex layout-fill id=\"gantt\" gantt \nheaders-formats=\"vm.options.headersFormats\" data=\"vm.data\" timespans=\"vm.timespans\" \nshow-side=\"vm.options.labelsEnabled\" daily=\"vm.options.daily\" filter-task=\"{\'name\': vm.options.filterTask}\" \nfilter-row=\"{\'name\': vm.options.filterRow}\" sort-mode=\"vm.options.sortMode\" view-scale=\"vm.options.scale\" \ncolumn-width=\"vm.getColumnWidth(vm.options.width, vm.options.scale, vm.options.zoom)\" \nauto-expand=\"vm.options.autoExpand\" task-out-of-range=\"vm.options.taskOutOfRange\" from-date=\"vm.options.fromDate\" \nto-date=\"vm.options.toDate\" allow-side-resizing=\"vm.options.allowSideResizing\" \ntask-content=\"vm.options.taskContentEnabled ? vm.options.taskContent : undefined\" \nrow-content=\"vm.options.rowContentEnabled ? vm.options.rowContent : undefined\" current-date=\"vm.options.currentDate\" \ncurrent-date-value=\"vm.options.currentDateValue\" headers=\"[\'month\', \'day\']\" max-height=\"vm.maxheight\" \ntime-frames=\"vm.options.timeFrames\" date-frames=\"vm.options.dateFrames\" \ntime-frames-working-mode=\"vm.options.timeFramesWorkingMode\" \ntime-frames-non-working-mode=\"vm.options.timeFramesNonWorkingMode\" time-frames-magnet=\"vm.options.timeFramesMagnet\" \napi=\"vm.options.api\" column-magnet=\"vm.options.columnMagnet\"><gantt-tree \nenabled=\"vm.options.sideMode === \'Tree\' || vm.options.sideMode === \'TreeTable\'\" \nheader-content=\"vm.options.treeHeaderContent\" keep-ancestor-on-filter-row=\"true\"></gantt-tree><gantt-table \nenabled=\"vm.options.sideMode === \'Table\' || vm.options.sideMode === \'TreeTable\'\" \ncolumns=\"vm.options.sideMode === \'TreeTable\' ? vm.options.treeTableColumns : vm.options.columns\" \nheaders=\"vm.options.columnsHeaders\" classes=\"vm.options.columnsClasses\" formatters=\"vm.options.columnsFormatters\" \ncontents=\"vm.options.columnsContents\" header-contents=\"vm.options.columnsHeaderContents\"></gantt-table><gantt-groups \nenabled=\"vm.options.groupDisplayMode === \'group\' || vm.options.groupDisplayMode === \'overview\' || vm.options.groupDisplayMode === \'promote\'\" \ndisplay=\"vm.options.groupDisplayMode\"></gantt-groups><gantt-bounds></gantt-bounds><gantt-progress></gantt-progress>\n<gantt-sortable></gantt-sortable><gantt-movable enabled=\"!vm.options.readOnly\"></gantt-movable><gantt-draw-task \nenabled=\"vm.options.canDraw\" move-threshold=\"2\" task-factory=\"vm.options.drawTaskFactory\"></gantt-draw-task>\n<gantt-overlap></gantt-overlap><gantt-resize-sensor></gantt-resize-sensor></gantt></md-content></div></div></div>");
$templateCache.put("app/main/apps/reset/resetPassword.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><span><img \nsrc=\"./assets/images/logos/logo.png\" alt=\"Minerva Logo\"></span></div><div class=\"title\" translate=\"LOGIN.TITLE\">\nLog in to your account</div><div class=\"title\">{{vm.loadingmessage}}</div><div ng-if=\"vm.errorMessage\" \nclass=\"cross-div\"><span class=\"error-noLogin-page\">{{ vm.errorMessage }}<i class=\"icon-close\" \nng-click=\"vm.disableClose();\"></i></span></div><div ng-if=\"vm.type\" class=\"title cross-div\"><span \nclass=\"success-noLogin-page\">{{ vm.successMessage }}<i class=\"icon-close\" ng-click=\"vm.disableClose();\"></i></span>\n</div><form ui-keypress=\"{13:\'vm.checklogin()\'}\" name=\"loginForm\" novalidate action=\"/dashboard-project\">\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-keyup=\"$event.keyCode == 13 && vm.checklogin()\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"><div ng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-keyup=\"$event.keyCode == 13 && vm.checklogin()\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOGIN.PASSWORD\" required ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><a \nui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color red-A800-fg\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"button\" \nclass=\"md-raised md-accent grey-100-fg submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine || vm.buttonActive==1\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\" ng-click=\"vm.checklogin();\">LOG IN</md-button></form><div class=\"register\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_register\" translate=\"LOGIN.CREATE_ACCOUNT\">\nCreate an account</a></div></div></div></div>");
$templateCache.put("app/main/apps/reports/getEmailAddress.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"ploicyForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content \nclass=\"md-padding\"><div class=\"row-block\" flex-gt-xs=\"95\" layout=\"row\"><md-input-container \nclass=\"md-block tax-inputs ph-10 mdinputblk mb-0\" data-ng-animate=\"1\" flex=\"100\" flex-gt-xs=\"100\" layout=\"column\" \nlayout-align=\"start start\"><label class=\"ng-scope md-required ml-20\" role=\"button\" translate=\"CONTACTS.EMAIL\"></label>\n<input type=\"text\" name=\"email\" ng-model=\"vm.ploicyForm.email\" required aria-invalid=\"true\" class=\"lesswidthright\" \nmultiple-emails autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div class=\"email-hint ng-scope\" style=\"\">\nTo send email to multiple recipients add emails comma separated.For ex: demo@test.com,john@test.com.</div>\n</md-input-container></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" \nng-click=\"vm.hideDialog()\" ng-disabled=\"ploicyForm.$invalid || ploicyForm.$pristine || ploicyForm.email.$invalid\" \nng-class=\"ploicyForm.$invalid || ploicyForm.$pristine || ploicyForm.email.$invalid ?\'\':\'md-raised md-accent submit-button grey-100-fg md-green-500-bg\'\">\nContinue</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/roomPrecedence/roomPrecedence.html","<div id=\"room-precedence\" class=\"room-precedence page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hotel\" class=\"mr-10\">\n</md-icon><span translate=\"ROOM_PRECEDENCE.TITLE\"></span></div></div></div><div class=\"content\"><div \nclass=\"white-bg custom-content md-whiteframe-4dp white-scroll relative-block margin-bottom-10 layout-padding layout-align-center-center\">\n<div class=\"form-title no-padding margin-top-10 margin-left-5 margin-right-20\"><span \ntranslate=\"ROOM_PRECEDENCE.CHECKIN_HEADING_TITLE\"></span></div><div><span \nclass=\"room-name margin-left-20 margin-right-10 padding-0\" translate=\"ROOM_PRECEDENCE.NO_OF_DAYS\"></span>\n<md-input-container class=\"m-0\"><input required name=\"type\" ng-model=\"vm.numberOfDaysBeforeCheckin\" \nng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.updateNumberOfDaysBeforeCheckinForEmail()\" ng-min=\"1\">\n</md-input-container></div></div><div \nclass=\"white-bg md-whiteframe-4dp white-scroll relative-block margin-bottom-10 layout-padding layout-align-center-center\">\n<div class=\"form-title no-padding margin-10 margin-left-20 margin-right-20\">\nPlease set the room precedence order for customer room upgrades.</div><div \nclass=\"simple-table-container main content-precedence\"><div class=\"accord-product-block-outer-main\"><div \nclass=\"row-block-new accord-product-block\" ng-repeat=\"(subHotelId, hotel) in vm.roomTypes\" \nng-init=\"hotel.openClass = $first\" ng-class=\"{ open: hotel.openClass }\"><div \nclass=\"heading form-title-new margin-left-10\" ng-click=\"hotel.openClass = !hotel.openClass\"><div class=\"arrow-block\">\n</div><h3>{{ hotel.hotel_title }}</h3></div><div class=\"row-block-new\" ng-if=\"hotel.openClass\"><div \nclass=\"layout-colo-block\"><div class=\"room-row\" ng-repeat=\"room in hotel.rooms track by room.room_type_id\"><span \nclass=\"room-name\">{{ room.room_type_name }}</span><md-input-container class=\"m-0\"><input type=\"number\" \nname=\"precedence_{{room.room_type_id}}\" ng-model=\"room.room_precedence\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.updateRoomPrecedence(room, hotel.rooms.length)\" min=\"1\" max=\"{{ hotel.rooms.length }}\">\n</md-input-container></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/sheetPrice/sheetPrice.html","<div id=\"sheet-price\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div\n class=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-table\"></md-icon><span \ntranslate=\"SHEET_PRICE.TITLE\"></span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"SHEET_PRICE.DESCRIPTION\"></span></div></div><div class=\"logo\" layout=\"row\" layout-align=\"center end\">\n<md-input-container class=\"hotel-select\" ng-if=\"vm.showSubHotelDropdown\"><md-select ng-model=\"vm.selectedSubHotelId\" \nng-change=\"vm.changeHotel()\"><md-option ng-repeat=\"subHotel in vm.subHotels\" ng-value=\"subHotel.id\">{{ subHotel.name }}\n</md-option></md-select></md-input-container><md-button ng-if=\"vm.isCellChange\" class=\"md-raised md-cornered save-btn\" \nng-click=\"vm.reset()\" ng-disabled=\"vm.saving\">Reset</md-button><md-button \nclass=\"md-raised md-cornered md-primary save-btn\" ng-click=\"vm.save()\" ng-disabled=\"!vm.isCellChange || vm.saving\">\n<span ng-if=\"!vm.saving\">Save</span><md-progress-circular ng-if=\"vm.saving\" md-mode=\"indeterminate\" md-diameter=\"18\">\n</md-progress-circular></md-button></div></div></div></div></div><div class=\"content\"><div class=\"main\"><div \nclass=\"white-bg md-whiteframe-4dp sheet-price-card\"><div class=\"matrix-scroll\" ng-class=\"{ loading: vm.loading }\">\n<md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\"></md-progress-linear><div \nclass=\"comparison-grid comparison-grid--header\" ng-class=\"{ loading: vm.loading }\" \nng-style=\"{ \'grid-template-columns\': vm.gridTemplateColumns }\"><div class=\"matrix-cell matrix-cell--corner\">\nFrom room \\ To room</div><div class=\"matrix-cell matrix-cell--header\" ng-if=\"!vm.loading\" \nng-repeat=\"room in vm.rooms track by room.key\" title=\"{{ room.fullName }}\"><span class=\"header-short\">\n{{ room.shortName }}</span></div></div><div class=\"comparison-grid comparison-grid--body\" ng-if=\"!vm.loading\" \nng-repeat=\"row in vm.rows track by row.key\" ng-style=\"{ \'grid-template-columns\': vm.gridTemplateColumns }\"><div \nclass=\"matrix-cell matrix-cell--rowhead\" title=\"{{ row.name }}\"><div class=\"rowhead-title\">{{ row.name }}</div></div>\n<div class=\"matrix-cell matrix-cell--value\" ng-repeat=\"cell in row.cells track by $index\" ng-class=\"cell.state\"><input \nclass=\"cell-input\" type=\"text\" ng-model=\"cell.editValue\" ng-change=\"vm.onCellChange(cell)\" \nng-model-options=\"{ debounce: 300 }\" ng-disabled=\"cell.disabled\" ng-class=\"{ \'disabled\': cell.disabled }\"></div></div>\n</div></div></div></div></div>");
$templateCache.put("app/main/apps/subscriber/subscriber.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-newsletter-big\"></md-icon><span>\nSubscribers</span></div><div class=\"product-count secondary-text\"><span translate=\"CONTACTS.TOTAL_CUSTOMERS\"></span> \n<span>{{vm.totalCustomers}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex>\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input \nid=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" placeholder=\"{{\'SEARCH\' | translate}}\" \nng-model=\"filterText\" flex></div><div class=\"logo\" layout=\"row\" layout-align=\"center end\"><md-button \nclass=\"md-raised md-cornered\" id=\"email-report\" ng-click=\"vm.emailReport()\" aria-label=\"Email Report\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_email_24px.svg\" class=\"email-report-icon\"></md-icon>\nEmail Report<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.requestProcessingEmail\"></md-progress-circular></md-button></div></div></div></div></div><div \nclass=\"content\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main RowClick\" \nms-scroll><mdt-table class=\"subscribers-table\" paginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" \nselectable-rows=\"isDeletedAllowed\" alternate-headers=\"\'contextual\'\" selected-row-callback=\"selectedRowCallback(rows)\" \ndelete-row-callback=\"deleteSelectedItem()\" mdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n					\'table-row-id-key\': \'id\',\n					\'column-keys\': [\n					\'email\',\n					\'zipcode\',\n					\'created_date\',\n					\'id\'\n					],\n				}\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>Email</span></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><span>Zipcode</span></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\">\n<span>Subscribed On</span></mdt-column><mdt-column align-rule=\"left\"><span></span></mdt-column><mdt-custom-cell \nhtml-content=\"true\" column-key=\"id\"><a style=\"cursor:pointer\" ng-click=\"clientScope.goToEditPage(value)\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16 ng-scope md-default-theme md-font material-icons icon-pencil\" role=\"img\" \naria-label=\"icon-cog\"></md-icon></a></mdt-custom-cell></mdt-header-row></mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/team/team.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-multiple\"></md-icon><span \ntranslate=\"TEAMS.TEAMS\"></span></div><div class=\"product-count secondary-text\"><span translate=\"TEAMS.TOTAL_TEAMS\">\n</span> <span>{{vm.totalGroups}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex>\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input \nid=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" placeholder=\"{{ \'SEARCH\' | translate }}\" \nng-model=\"filterText\" flex></div><div class=\"logo\" layout=\"row\" layout-align=\"center end\"><md-button layout=\"row\" \nclass=\"md-raised md-cornered\" ng-click=\"vm.gotoaddteam()\" ng-if=\"vm.userPermissions.indexOf(\'add_team\')!=-1\"><i \nclass=\"icon-plus icon-plus-main\"></i> {{ \'TEAMS.TEAM\' | translate }}</md-button></div></div></div></div><div \nng-hide=\"!vm.addOrg\"><md-button class=\"md-raised md-background\" \nng-disabled=\"organizationForm.$invalid || organizationForm.$pristine || vm.uniqueError\" \nng-click=\"vm.saveOrganization()\"><span translate=\"SAVE\"></span></md-button><md-button class=\"md-raised md-background\">\n<span translate=\"CANCEL\" ng-click=\"vm.gotoOrgs()\"></span></md-button></div></div><div class=\"content\"><div \nclass=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main RowClick\" ms-scroll><mdt-table \ntable-card=\"{visible: false, title: \'Users\'}\" paginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" \nselectable-rows=\"vm.delete_product\" alternate-headers=\"\'contextual\'\" selected-row-callback=\"selectedRowCallback(rows)\" \nmdt-row-paginator=\"paginatorCallback(page, pageSize, options, selected)\" delete-row-callback=\"deleteSelectedItem()\" \nmdt-row-paginator-error-message=\"Error occured during loading users.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\r\n        \'table-row-id-key\': \'team_id\',\r\n        \'column-keys\': [\r\n		\'team_name\',\r\n		\'group_name\',\r\n		\'total_members\',\r\n        \'team_id\'\r\n        ],\r\n    }\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'TEAMS.NAME\' | translate }}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'TEAMS.GROUP\' | translate }}</span></mdt-column>\n<mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'TEAMS.TOTAL_MEMBERS\' | translate }}</span></mdt-column>\n<mdt-column align-rule=\"left\"><span></span></mdt-column></mdt-header-row><mdt-custom-cell html-content=\"true\" \ncolumn-key=\"team_id\"><a ng-click=\"clientScope.goToEditPage(value)\"><md-icon md-font-icon=\"icon-icon-border-color\" \nclass=\"icon icon-border-color cursorPointer\" role=\"img\" aria-label=\"icon-cog\"></md-icon></a></mdt-custom-cell>\n</mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/team/teamAddEdit.html","<form name=\"groupForm\" class=\"md-inline-form fullwidth scroll-full-height\" novalidate><div id=\"groupPage\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page profileImage_page fullwidth\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-organizations-button md-icon-button\" aria-label=\"Go to users\" \nng-click=\"vm.gotoTeamListing()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\" \nng-if=\"vm.pageStatus != \'add\'\">{{vm.groupForm.team_name}}</div><div class=\"h2\" ng-if=\"vm.pageStatus == \'add\'\">\n{{ \'TEAMS.NEW_TEAM\' | translate }}</div><div ng-if=\"vm.pageStatus != \'add\'\" class=\"subtitle secondary-text\"><span \ntranslate=\"TEAMS.TEAM_DETAIL\"></span></div></div></div></div><div><md-button class=\"md-raised md-background\" \nng-click=\"vm.pageStatus == \'add\'? vm.saveTeam():vm.updateTeam()\" \nng-disabled=\"groupForm.$invalid || groupForm.$pristine || vm.users.length ==0\" \nng-class=\"{\'md-blue-grey-A100-bg\': groupForm.$invalid || groupForm.$pristine || vm.users.length ==0}\" \ntranslate=\"TEAMS.SAVE\"></md-button><md-button class=\"md-raised md-background\" ng-click=\"vm.gotoTeamListing();\"><span \ntranslate=\"TEAMS.CANCEL\"></span></md-button></div></div><div class=\"content scroll-height-sm\"><div \nclass=\"main sm-hearder-top scroll-full-height\" ms-scroll><div class=\"white-bg md-whiteframe-4dp relative-block\" \nlayout-align=\"center center\" layout-padding><div class=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start\" flex><md-input-container class=\"md-block tax-inputs padding-right-10 padding-left-10\"><label \nclass=\"margin-left-10\" translate=\"TEAMS.NAME\"></label><input type=\"text\" name=\"rate category\" \nng-model=\"vm.groupForm.team_name\" required aria-invalid=\"true\" ng-change=\"vm.checkRateCategoryName()\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"> <span ng-if=\"vm.rateCategoryNameExists\" class=\"errorMsg\">\n{{ vm.rateCategoryNameExists }}</span></md-input-container><md-input-container \nclass=\"md-block tax-inputs padding-right-10 padding-left-10\" data-ng-animate=\"2\"><label class=\"margin-left-10\" \ntranslate=\"TEAMS.SELECT_GROUP\"></label><md-select required ng-model=\"vm.groupForm.group_id\" name=\"status\" translate \ntranslate-attr-placeholder=\"TEAMS.SELECT_GROUP\" ng-change=\"vm.updateUserList()\"><md-option value=\"{{group.group_id}}\" \nng-repeat=\"group in vm.groupList\">{{group.group_name}}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><md-content class=\"autocomplete padding-right-20 padding-left-20 group-chips\"><div \nclass=\"row-block\"><md-contact-chips ng-model=\"vm.users\" md-contacts=\"vm.querySearch($query)\" md-contact-name=\"name\" \nmd-contact-image=\"image\" md-contact-email=\"email\" md-require-match=\"true\" md-highlight-flags=\"i\" \nfilter-selected=\"vm.filterSelected\" class=\"chips-inputs\" placeholder=\"{{ \'TEAMS.MEMBERS\' | translate }}\" required>\n</md-contact-chips><div class=\"md-errors-spacer\"></div></div><div class=\"row-block\"><md-list class=\"fixedRows\"><div \nclass=\"members title margin-top-20\">{{ \'TEAMS.MEMBERS\' | translate }}</div><md-list-item \nclass=\"md-2-line list-block1 contact-item no-padding\" ng-repeat=\"(index, contact) in vm.allUsers\" \nng-if=\"vm.users.indexOf(contact) < 0\"><div class=\"md-list-item-text compact\"><h3>{{contact.name}}</h3><p>\n{{contact.email}}</p></div></md-list-item><md-list-item class=\"md-2-line list-block1 contact-item selected no-padding\" \nng-repeat=\"(index, contact) in vm.users\"><div class=\"md-list-item-text compact\"><h3>{{contact.name}}</h3><p>\n{{contact.email}}</p></div></md-list-item></md-list></div></md-content></div></div></div></div></form>");
$templateCache.put("app/main/apps/todo/todo.html","<div id=\"todo\" class=\"page-layout carded left-sidenav\" layout=\"row\" ng-controller=\"TodoController as vm\"><div \nclass=\"md-accent-bg\"></div><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/todo/sidenavs/main/main-sidenav.html\'\" ms-scroll \nms-sidenav-helper></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"search-wrapper md-whiteframe-4dp\" flex layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"TODO.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button>\n<div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input flex ng-model=\"vm.search\" type=\"text\" placeholder=\"Search\" \nng-change=\"vm.getSearchFilters()\" ng-model-options=\"{ debounce: 800 }\"></div></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><md-select \nclass=\"simplified\" ng-model=\"vm.dueDate\" ng-change=\"vm.filterByDateRange()\" placeholder=\"Due Date\" \nng-if=\"vm.selectedProject != \'housekeeping\'\"><md-option value=\"3\" translate=\"TODO.NEXT_3_DAYS\"></md-option><md-option \nvalue=\"7\" translate=\"TODO.NEXT_7_DAYS\"></md-option><md-option value=\"14\" translate=\"TODO.NEXT_2_WEEKS\"></md-option>\n<md-option value=\"30\" translate=\"TODO.NEXT_MONTH\"></md-option></md-select><div layout=\"row\" \nlayout-align=\"start center\"><md-checkbox class=\"no-label\" \nng-if=\"vm.tasks.length>0 && vm.selectedProject == \'housekeeping\'\" ng-click=\"vm.SelectallLIstings()\" \nng-model=\"vm.selectAllTasks\" ng-disabled=\"vm.disableButtons\" \naria-label=\"{{task.task_status != \'done\'? \'Not completed\' : \'Completed\'}}\"></md-checkbox><span \nng-if=\"!vm.selectAllTasks && (vm.tasks.length>0) && vm.selectedProject == \'housekeeping\'\">Select All</span><md-select \nng-show=\"vm.showCheckbox\" class=\"simplified\" ng-model=\"vm.InspectionMethod\" placeholder=\"Inspection\" \nng-change=\"vm.changeMultiple(\'inspection\')\" ng-disabled=\"vm.disableButtons\" \nng-if=\"vm.selectedProject == \'housekeeping\'\"><md-option value=\"Inspection\" disabled=\"disabled\">Inspection</md-option>\n<md-option value=\"accepted\">Accept</md-option><md-option value=\"rejected\">Reject</md-option><md-option \nvalue=\"notInspected\">Not Inspected</md-option></md-select><md-select style=\"max-width: 230px; text-overflow:ellipsis\" \nng-show=\"vm.showCheckbox\" multiple=\"multiple\" class=\"simplified\" ng-model=\"vm.assignedUser\" placeholder=\"Select User\" \nmd-on-close=\"vm.changeMultiple(\'user\')\" ng-disabled=\"vm.disableButtons\" ng-if=\"vm.selectedProject == \'housekeeping\'\">\n<md-option ng-repeat=\"user in vm.adminUsers\" value=\"{{user.value}}\">{{user.display}}</md-option></md-select></div><div \nlayout=\"row\" layout-align=\"end center\"><md-select class=\"simplified\" ng-model=\"vm.subhotelID\" \nng-change=\"vm.selectSubHotel(vm.subhotelID)\" ng-if=\"vm.subHotels.length > 0\" placeholder=\"Subhotel\"><md-option \nvalue=\"{{vm.subhotelID}}\">All</md-option><md-option ng-repeat=\"sub in vm.subHotels\" value=\"{{sub.hotel_id}}\">\n{{sub.hotel_title}}</md-option></md-select><md-select class=\"simplified\" ng-model=\"vm.taskOrder\" placeholder=\"Order\" \nng-change=\"vm.sortDataByField()\" ng-if=\"vm.selectedProject == \'housekeeping\'\"><md-option value=\"room_no_asc\">\nRoom Number Asc</md-option><md-option value=\"room_no_desc\">Room Number Desc</md-option><md-option value=\"priority\">\nPriority</md-option></md-select><md-select class=\"simplified\" ng-model=\"vm.taskOrder\" placeholder=\"Order\" \nng-change=\"vm.sortDataByField()\" ng-if=\"vm.selectedProject != \'housekeeping\'\"><md-option value=\"tasks.task_start\" \ntranslate=\"TODO.START_DATE\">Start Date</md-option><md-option value=\"tasks.task_due_date\" translate=\"TODO.DUE_DATE\">\nDue Date</md-option><md-option value=\"tasks.task_id\" translate=\"TODO.MANUAL\">Manual</md-option><md-option \nvalue=\"tasks.task_title\" translate=\"TODO.TITLE\">Title</md-option></md-select><md-button class=\"md-icon-button\" \nng-disabled=\"vm.taskOrder === \'\'\" ng-click=\"vm.sortData()\" aria-label=\"Sort Direction\" translate \ntranslate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-ascending\" \nng-if=\"vm.taskOrderDescending === false\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" \nng-if=\"vm.taskOrderDescending === true\"></md-icon></md-button></div><md-progress-linear class=\"dashboard-lin\" \nng-if=\"vm.showloader\" md-mode=\"query\"></md-progress-linear></div><div class=\"content\" layout=\"row\" flex><md-content \nclass=\"todo-list-pane\" flex=\"100\" ng-include=\"\'app/main/apps/todo/views/list/list-view.html\'\" \nms-scroll=\"vm.msScrollOptions\" ng-if=\"vm.selectedProject != \'housekeeping\'\"></md-content><md-content \nclass=\"todo-list-pane\" flex ms-scroll=\"vm.msScrollOptions\"><div class=\"effectwrapper Managerlisting\" flex=\"100\" \nng-if=\"vm.selectedProject == \'housekeeping\'\"><div class=\"effectpage transition\"><div class=\"taskframeouter\"><div \nclass=\"taskcards outershadow\" ng-repeat=\"(key, task) in vm.tasks\"><div class=\"taskcontent\" layout=\"row\" layout-wrap>\n<div class=\"roomnumouter\" layout=\"column\"><div class=\"roomnumber roomsplitvalue\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"checkbox_selection\"><md-checkbox ng-disabled=\"vm.disableButtons\" \nclass=\"no-label\" ng-click=\"vm.addTaskarray(task.task_id, $index)\" ng-model=\"vm.checkboxes[$index]\" \naria-label=\"{{task.task_status != \'done\'? \'Not completed\' : \'Completed\'}}\"></md-checkbox></span><span \nng-click=\"vm.openHousekeepingEditPopup(task.task_id, $index)\" class=\"task_selection\"><span class=\"splitroomnumber\">\n<span ng-repeat=\"room in task.product_room_number\">{{room}} </span></span><span class=\"hotel_initials\" \nstyle=\"background-color: {{task.colorValue}}\" ng-if=\"task.initials != \'\'\">{{task.initials}}</span></span></div></div>\n<div class=\"taskcontentinner\" ng-click=\"vm.openHousekeepingEditPopup(task.task_id, $index)\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"hk-task-text\" layout=\"column\" layout-align=\"center start\" flex><h1>\n{{task.room_type_name || task.product_name || (\'Room #\' + (task.product_room_number[0] || task.product_room_number))}}\n</h1><p>{{task.task_title}}</p><div class=\"tag-div\" ng-if=\"task.task_category == \'maintainance\'\" \nstyle=\"background: #dedede; padding: 2px 10px;margin-top: 10px\">maintainance</div></div><div class=\"hk-stay-wrap\"><div \nclass=\"hk-stay-main\"><div class=\"hk-stay-side is-check-in\"><div class=\"hk-stay-meta is-check-in\" \nng-if=\"task.stay_check_in.time || task.stay_check_in.adults > 0 || task.stay_check_in.children > 0\" \nng-class=\"{\'is-clickable\': task.stay_check_in.confirmation_number}\" \nng-click=\"vm.openStayReservation(task.stay_check_in, $event)\" \ntitle=\"{{(task.stay_check_in.type == \'early_check_in\' ? \'Early Check-In\' : \'Check-In\') + (task.stay_check_in.time ? (\' \' + task.stay_check_in.time) : \'\') + (task.stay_check_in.confirmation_number ? (\' · \' + task.stay_check_in.confirmation_number) : \'\')}}\">\n<span class=\"hk-meta-time\" ng-if=\"task.stay_check_in.time\">{{task.stay_check_in.time}}</span> <span \nclass=\"hk-meta-guests\" ng-if=\"task.stay_check_in.adults > 0 || task.stay_check_in.children > 0\"><span \nclass=\"hk-guest-item\" ng-if=\"task.stay_check_in.adults > 0\" \ntitle=\"{{task.stay_check_in.adults}} {{task.stay_check_in.adults == 1 ? \'Adult\' : \'Adults\'}}\"><span>\n{{task.stay_check_in.adults}}</span> <svg class=\"hk-guest-icon is-adult\" viewBox=\"0 0 24 24\" aria-hidden=\"true\" \nfocusable=\"false\"><path fill=\"currentColor\" \nd=\"M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z\"/>\n</svg> </span><span class=\"hk-chip-sep\" ng-if=\"task.stay_check_in.adults > 0 && task.stay_check_in.children > 0\">·\n</span> <span class=\"hk-guest-item\" ng-if=\"task.stay_check_in.children > 0\" \ntitle=\"{{task.stay_check_in.children}} {{task.stay_check_in.children == 1 ? \'Child\' : \'Children\'}}\"><span>\n{{task.stay_check_in.children}}</span> <svg class=\"hk-guest-icon is-child\" viewBox=\"0 0 24 24\" aria-hidden=\"true\" \nfocusable=\"false\"><circle fill=\"currentColor\" cx=\"12\" cy=\"7.2\" r=\"3.4\"/><path fill=\"currentColor\" \nd=\"M12 11.4c-2.6 0-7.8 1.3-7.8 3.9v2.3h3.1l1.1 5h7.2l1.1-5h3.1v-2.3c0-2.6-5.2-3.9-7.8-3.9z\"/></svg></span></span></div>\n</div><div class=\"hk-stay-boxes\"><div class=\"hk-stay-box\" \nng-class=\"{\n                                                            \'is-empty\': !task.stay_check_in || task.stay_check_in.type == \'empty\',\n                                                            \'is-check-in\': task.stay_check_in.type == \'check_in\',\n                                                            \'is-early-check-in\': task.stay_check_in.type == \'early_check_in\',\n                                                            \'is-clickable\': task.stay_check_in.confirmation_number\n                                                         }\" \nng-click=\"vm.openStayReservation(task.stay_check_in, $event)\" \ntitle=\"{{(task.stay_check_in.type == \'early_check_in\' ? \'Early Check-In\' : (task.stay_check_in.type == \'check_in\' ? \'Check-In\' : \'\')) + (task.stay_check_in.time ? (\' \' + task.stay_check_in.time) : \'\') + (task.stay_check_in.confirmation_number ? (\' · \' + task.stay_check_in.confirmation_number) : \'\')}}\">\n<span class=\"hk-arrow-text\" \nng-if=\"task.stay_check_in.type == \'check_in\' || task.stay_check_in.type == \'early_check_in\'\">↓</span> <span \nclass=\"hk-stay-letter\" ng-if=\"task.stay_check_in.type == \'early_check_in\'\">E</span></div><div class=\"hk-stay-box\" \nng-class=\"{\n                                                            \'is-empty\': !task.stay_check_out || task.stay_check_out.type == \'empty\',\n                                                            \'is-check-out\': task.stay_check_out.type == \'check_out\',\n                                                            \'is-late-check-out\': task.stay_check_out.type == \'late_check_out\',\n                                                            \'is-stayover\': task.stay_check_out.type == \'stayover\',\n                                                            \'is-clickable\': task.stay_check_out.confirmation_number\n                                                         }\" \nng-click=\"vm.openStayReservation(task.stay_check_out, $event)\" \ntitle=\"{{(task.stay_check_out.type == \'late_check_out\' ? \'Late Check-Out\' : (task.stay_check_out.type == \'check_out\' ? \'Check-Out\' : (task.stay_check_out.type == \'stayover\' ? \'Stayover\' : \'\'))) + (task.stay_check_out.time ? (\' \' + task.stay_check_out.time) : \'\') + (task.stay_check_out.confirmation_number ? (\' · \' + task.stay_check_out.confirmation_number) : \'\')}}\">\n<span class=\"hk-arrow-text\" \nng-if=\"task.stay_check_out.type == \'check_out\' || task.stay_check_out.type == \'late_check_out\'\">↑</span> <span \nclass=\"hk-stay-letter\" ng-if=\"task.stay_check_out.type == \'late_check_out\'\">L</span> <span class=\"hk-stay-letter\" \nng-if=\"task.stay_check_out.type == \'stayover\'\">O</span></div></div><div class=\"hk-stay-side is-check-out\"><div \nclass=\"hk-stay-meta\" \nng-class=\"{\n                                                            \'is-check-out\': task.stay_check_out.type == \'check_out\' || task.stay_check_out.type == \'late_check_out\',\n                                                            \'is-stayover\': task.stay_check_out.type == \'stayover\',\n                                                            \'is-clickable\': task.stay_check_out.confirmation_number\n                                                         }\" \nng-if=\"task.stay_check_out.time || task.stay_check_out.adults > 0 || task.stay_check_out.children > 0\" \nng-click=\"vm.openStayReservation(task.stay_check_out, $event)\" \ntitle=\"{{(task.stay_check_out.type == \'late_check_out\' ? \'Late Check-Out\' : (task.stay_check_out.type == \'stayover\' ? \'Stayover\' : \'Check-Out\')) + (task.stay_check_out.time ? (\' \' + task.stay_check_out.time) : \'\') + (task.stay_check_out.confirmation_number ? (\' · \' + task.stay_check_out.confirmation_number) : \'\')}}\">\n<span class=\"hk-meta-time\" ng-if=\"task.stay_check_out.time\">{{task.stay_check_out.time}}</span> <span \nclass=\"hk-meta-guests\" ng-if=\"task.stay_check_out.adults > 0 || task.stay_check_out.children > 0\"><span \nclass=\"hk-guest-item\" ng-if=\"task.stay_check_out.adults > 0\" \ntitle=\"{{task.stay_check_out.adults}} {{task.stay_check_out.adults == 1 ? \'Adult\' : \'Adults\'}}\"><span>\n{{task.stay_check_out.adults}}</span> <svg class=\"hk-guest-icon is-adult\" viewBox=\"0 0 24 24\" aria-hidden=\"true\" \nfocusable=\"false\"><path fill=\"currentColor\" \nd=\"M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z\"/>\n</svg> </span><span class=\"hk-chip-sep\" ng-if=\"task.stay_check_out.adults > 0 && task.stay_check_out.children > 0\">·\n</span> <span class=\"hk-guest-item\" ng-if=\"task.stay_check_out.children > 0\" \ntitle=\"{{task.stay_check_out.children}} {{task.stay_check_out.children == 1 ? \'Child\' : \'Children\'}}\"><span>\n{{task.stay_check_out.children}}</span> <svg class=\"hk-guest-icon is-child\" viewBox=\"0 0 24 24\" aria-hidden=\"true\" \nfocusable=\"false\"><circle fill=\"currentColor\" cx=\"12\" cy=\"7.2\" r=\"3.4\"/><path fill=\"currentColor\" \nd=\"M12 11.4c-2.6 0-7.8 1.3-7.8 3.9v2.3h3.1l1.1 5h7.2l1.1-5h3.1v-2.3c0-2.6-5.2-3.9-7.8-3.9z\"/></svg></span></span></div>\n</div></div><div class=\"hk-occupancy\" \nng-class=\"{\'is-allotted\': task.stay_is_allotted, \'is-vacant\': !task.stay_is_allotted}\" \ntitle=\"{{task.stay_is_allotted ? \'Booked\' : \'Vacant\'}}\"><span class=\"hk-occupancy-icon\" ng-if=\"!task.stay_is_allotted\" \naria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" width=\"11\" height=\"11\" focusable=\"false\"><path fill=\"currentColor\" \nd=\"M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z\"/></svg> </span><span class=\"hk-occupancy-icon\" ng-if=\"task.stay_is_allotted\" \naria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" width=\"11\" height=\"11\" focusable=\"false\"><path fill=\"currentColor\" \nd=\"M12 12c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm0 2c-2.7 0-8 1.3-8 4v2h16v-2c0-2.7-5.3-4-8-4z\"/></svg> \n</span><span class=\"hk-occupancy-text\" ng-if=\"!task.stay_is_allotted\">Vacant</span> <span class=\"hk-occupancy-text\" \nng-if=\"task.stay_is_allotted\">Booked</span></div></div></div></div><div \nclass=\"actionbtn btnactiomainouter hk-action-panel\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"hk-assignee-col\" layout=\"row\" layout-align=\"center start\" flex><span class=\"hk-assignee-icon\" \nng-if=\"task.task_to_user != 0 && task.task_to_user != \'\'\" aria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" width=\"14\" \nheight=\"14\" focusable=\"false\"><path fill=\"currentColor\" \nd=\"M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v1.2c0 .7.5 1.2 1.2 1.2h16.8c.7 0 1.2-.5 1.2-1.2v-1.2c0-3.2-6.4-4.8-9.6-4.8z\"/>\n</svg> </span><span class=\"hk-assignee-name\" ng-if=\"task.task_to_user != 0 && task.task_to_user != \'\'\" \ntitle=\"{{task.user_name_tooltip || task.user_name}}\">{{task.user_name}}</span> <span class=\"hk-assignee-name is-empty\" \nng-if=\"task.task_to_user == 0 || task.task_to_user == \'\' || !task.task_to_user\">Unassigned</span></div><div \nclass=\"hk-cta-col\" layout=\"row\" layout-align=\"center end\"><span class=\"hk-cta-chip is-progress\" \nng-if=\"(task.task_status || \'\').toLowerCase() == \'in_progress\' && (task.task_inspected || \'\').toLowerCase() != \'accepted\'\">\n{{ \'inprogress\' | translate }} </span><span class=\"hk-cta-chip is-pending\" \nng-if=\"(task.task_status || \'\').toLowerCase() == \'undone\' && task.task_to_user != 0 && task.task_to_user != \'\' && task.task_rejected != \'1\' && task.task_rejected != 1 && (task.task_inspected || \'\').toLowerCase() != \'accepted\'\">\n{{ \'not\' | translate }} {{ \'started\' | translate }} </span><span class=\"hk-cta-chip is-reopened\" \nng-if=\"(task.task_status || \'\').toLowerCase() == \'undone\' && (task.task_rejected == \'1\' || task.task_rejected == 1) && (task.task_inspected || \'\').toLowerCase() != \'accepted\'\">\nReopened </span><span class=\"hk-cta-chip is-unassigned\" \nng-if=\"(task.task_to_user == 0 || task.task_to_user == \'\' || !task.task_to_user) && task.task_rejected != \'1\' && task.task_rejected != 1 && (task.task_status || \'\').toLowerCase() != \'done\' && (task.task_inspected || \'\').toLowerCase() != \'accepted\'\">\n{{ \'not\' | translate }} {{ \'assigned\' | translate }} </span><button class=\"hk-cta-chip is-closed\" type=\"button\" \nng-if=\"(task.task_inspected || \'\').toLowerCase() == \'accepted\'\">Inspected</button> <button \nclass=\"hk-cta-chip is-approve\" type=\"button\" \nng-if=\"(task.task_status || \'\').toLowerCase() == \'done\' && (task.task_inspected || \'\').toLowerCase() != \'accepted\'\" \nng-click=\"$event.stopPropagation();vm.approveRejectTask(task.task_id, \'accepted\', $index)\">Waiting Inspection</button>\n</div><button class=\"hk-logs-btn\" type=\"button\" ng-click=\"vm.openTaskLogsDialog(task, $event)\" aria-label=\"Task logs\" \ntitle=\"Task logs\"><svg viewBox=\"0 0 24 24\" width=\"14\" height=\"14\" aria-hidden=\"true\" focusable=\"false\"><path \nfill=\"currentColor\" \nd=\"M13 3a9 9 0 0 0-9 9H1l3.9 3.9L8.8 12H5a7 7 0 1 1 1.7 4.6l-1.4 1.4A9 9 0 1 0 13 3zm-1 5v5l4.3 2.6.8-1.3-3.6-2.1V8H12z\"/>\n</svg></button></div></div><div class=\"taskcards outershadow\" ng-if=\"!vm.tasks.length\"><div class=\"taskcontent\" \nlayout=\"row\" layout-wrap><div class=\"taskcontentinner\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"contentblock1\"><h1 style=\"text-align: center\">No Record Found</h1></div></div></div></div><div \nclass=\"pagination main-paination\" ng-if=\"vm.totalCount > vm.limit\"><p class=\"row-per-page\" \ntranslate=\"TODO.ROWS_PER_PAGE\">Rows Per Page :</p><md-select ng-model=\"vm.limit\" ng-change=\"vm.filterTheList()\" \nplaceholder=\"No. of data\" class=\"select-main11 mv-0\"><md-option ng-value=\"10\">10</md-option><md-option ng-value=\"20\">20\n</md-option><md-option ng-value=\"50\">50</md-option></md-select><p class=\"row-per-page pagesof\">\n{{ ((vm.curPage*vm.limit)-(vm.limit-1))+\'-\'+ (vm.tasks.length + ((vm.curPage*vm.limit)-(vm.limit))) }} of {{vm.totalCount}}\n</p><div class=\"pagination-custom-block\"><a href=\"#\" ng-click=\"vm.loadPage(vm.curPage, \'pre\')\"><ng-md-icon \nicon=\"keyboard_arrow_left\" size=\"24\" class=\"ng-scope\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" \nwidth=\"24\" height=\"24\"><path d=\"M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z\"></path></svg></ng-md-icon></a><a \nhref=\"#\" ng-click=\"vm.loadPage(vm.curPage, \'next\')\"><ng-md-icon icon=\"keyboard_arrow_right\" size=\"24\" class=\"ng-scope\">\n<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path \nd=\"M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z\"></path></svg></ng-md-icon></a></div></div></div></div></div>\n</md-content></div></div></div></div>");
$templateCache.put("app/main/ui/forms/forms.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Forms</div></div></div><div class=\"content\" layout=\"column\"><div class=\"md-title\">Stepper</div><div \nclass=\"pb-16\"><b>ms-stepper</b>\n is a custom made form wizard directive. It follows Google\'s Material Design specifications and we recommend you to use it. If for some reason, it\'s not suitable for your project, you can always use the Form Wizard that we put together using md-tabs and forms.\n</div><form name=\"horizontalStepper\" ms-horizontal-stepper ng-submit=\"vm.submitHorizontalStepper()\" \nng-model=\"vm.horizontalStepper\" novalidate><ms-horizontal-stepper-step ng-form=\"horizontalStep1\" step=\"1\" \nstep-title=\"\'Personal Information\'\"><div ng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-1.html\'\"></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"horizontalStep2\" step=\"2\" step-title=\"\'Birthplace\'\" \noptional-step hide-step=\"!vm.horizontalStepper.step1.lastname\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-2.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep3\" step=\"3\" step-title=\"\'SSN\'\" optional-step \nhide-step=\"!vm.horizontalStepper.step2.birthplace\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-3.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep4\" step=\"4\" step-title=\"\'Address\'\" optional-step><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-4.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep5\" step=\"5\" step-title=\"\'Payment Method\'\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-5.html\'\"></div></ms-horizontal-stepper-step></form><div \nclass=\"mv-24\"></div><form name=\"verticalStepper\" ms-vertical-stepper ng-submit=\"vm.submitVerticalStepper()\" \nng-model=\"vm.verticalStepper\" novalidate><ms-vertical-stepper-step ng-form=\"verticalStep1\" step=\"1\" \nstep-title=\"\'Personal Information\'\"><div ng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-1.html\'\"></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"verticalStep2\" step=\"2\" step-title=\"\'Birthplace\'\" \noptional-step hide-step=\"!vm.verticalStepper.step1.lastname\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-2.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep3\" step=\"3\" step-title=\"\'SSN\'\" optional-step \nhide-step=\"!vm.verticalStepper.step2.birthplace\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-3.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep4\" step=\"4\" step-title=\"\'Address\'\" optional-step><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-4.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep5\" step=\"5\" step-title=\"\'Payment Method\'\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-5.html\'\"></div></ms-vertical-stepper-step></form><div \nclass=\"md-title mt-32\">Form Wizard</div><div class=\"pb-16\">\nForm wizard is a combination of md-tabs and forms that we have created for you. You can have as many steps as you want.\n</div><div layout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Personal Information</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.formWizard.firstname\" \nplaceholder=\"Firstname\" required><div ng-messages=\"wizardStep1.firstname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.formWizard.lastname\" placeholder=\"Lastname\" \nrequired><div ng-messages=\"wizardStep1.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLastname field is required.</span></div></div></md-input-container></div><md-input-container class=\"md-block\"><input \ntype=\"email\" name=\"email\" ng-model=\"vm.formWizard.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"wizardStep1.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div>\n</div></md-input-container><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<input type=\"password\" name=\"password\" ng-model=\"vm.formWizard.password\" placeholder=\"Password\" required><div \nng-messages=\"wizardStep1.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" \nname=\"passwordConfirm\" ng-model=\"vm.formWizard.passwordConfirm\" placeholder=\"Password (Confirm)\" required><div \nng-messages=\"wizardStep1.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPassword (Confirm) field is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Address</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>City</label>\n<input type=\"text\" name=\"city\" ng-model=\"vm.formWizard.city\"></md-input-container><md-input-container flex><label>State\n</label><md-select ng-model=\"vm.formWizard.state\"><md-option ng-repeat=\"state in vm.states\" value=\"{{state.abbrev}}\">\n{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container flex><label>Postal Code</label><input \nname=\"postalcode\" ng-model=\"vm.formWizard.postalCode\" placeholder=\"12345\" required ng-pattern=\"/^[0-9]{5}$/\" \nmd-maxlength=\"5\"><div ng-messages=\"wizardStep2.postalcode.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>You must supply a postal code.</span></div><div ng-message=\"pattern\"><span>\nThat doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\"><span>\nPostal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><label>Address</label><textarea ng-model=\"vm.formWizard.address\" md-maxlength=\"150\" max-rows=\"5\" \nrequired></textarea><div ng-messages=\"wizardStep2.address.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Address field is required.</span></div><div ng-message=\"md-maxlength\"><span>\nAddress can\'t be longer than 150 characters.</span></div></div></md-input-container></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Payment Method</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep3\" ms-form-wizard-form novalidate><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"cardholder\" ng-model=\"vm.formWizard.cardholder\" placeholder=\"Card Holder\" required><div \nng-messages=\"wizardStep3.cardholder.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard holder field is required.</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" \nng-model=\"vm.formWizard.cardnumber\" placeholder=\"Card Number\" required><div \nng-messages=\"wizardStep3.cardnumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard number field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\">\n<input type=\"text\" name=\"CC2\" ng-model=\"vm.formWizard.cc2\" placeholder=\"CC2\" md-maxlength=\"3\" required><div \nng-messages=\"wizardStep3.cc2.$error\" role=\"alert\" multipl><div ng-message=\"required\"><span>CC2 field is required.\n</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.</span></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"expirationDate\" \nng-model=\"vm.formWizard.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"wizardStep3.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab>\n</md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Previous\n</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Next</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete()\">Send</md-button></div></ms-form-wizard></div><div class=\"md-title mt-32\">\nBasic form with validation</div><div class=\"pb-16\">\nWith this form example, Submit button will only be activated if all the required fields are filled and if there is no error on the form.\n</div><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"60\"><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div class=\"form-title\">Optional form title</div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"firstname\" ng-model=\"vm.basicForm.firstname\" \nplaceholder=\"Firstname\" required><div ng-messages=\"basicForm.firstname.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Firstname field is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"lastname\" ng-model=\"vm.basicForm.lastname\" placeholder=\"Lastname\" required><div \nng-messages=\"basicForm.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nCity</label><input type=\"text\" name=\"city\" ng-model=\"vm.basicForm.city\"></md-input-container><md-input-container flex>\n<label>State</label><md-select ng-model=\"vm.basicForm.state\"><md-option ng-repeat=\"state in vm.states\" \nvalue=\"{{state.abbrev}}\">{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container flex><label>\nPostal Code</label><input name=\"postalcode\" ng-model=\"vm.basicForm.postalCode\" placeholder=\"12345\" required \nng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div ng-messages=\"basicForm.postalcode.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>You must supply a postal code.</span></div><div \nng-message=\"pattern\"><span>That doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\">\n<span>Postal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><label>Biography</label><textarea ng-model=\"vm.basicForm.biography\" md-maxlength=\"150\" max-rows=\"5\">\n</textarea></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button></form></div><div \nclass=\"form-wrapper form-data-wrapper md-whiteframe-1dp\" flex=\"40\"><div class=\"form-title\">Form ng-model data</div><div\n class=\"json-data-wrapper\"><pre>{{vm.basicForm | json}}</pre></div></div></div></div></div>");
$templateCache.put("app/main/ui/helper-classes/helper-classes.html","<div id=\"helper-classes\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Helper Classes</div></div></div><div class=\"content\" layout=\"column\"><md-tabs md-dynamic-height><md-tab \nlabel=\"Padding & Margin Helpers\"><div class=\"md-title\">Padding Helpers</div><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span>no-padding</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span class=\"no-padding\">No padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>padding-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span class=\"padding-5\">5px padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>p-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span class=\"p-15\">15px padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>\npadding-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"padding-8\">8px padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>p-(8x)\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"p-32\">\n32px padding</span></hljs></div></div><div class=\"md-title\">Direction Specific Padding Helpers</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100</div><span>\npadding-top-(5x)</span> <span>padding-right-(5x)</span> <span>padding-bottom-(5x)</span> <span>padding-left-(5x)</span>\n <span>padding-horizontal-(5x)</span> <span>padding-vertical-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"padding-top-5\">5px from top</span> <span \nclass=\"padding-right-25\">25px from right</span> <span class=\"padding-bottom-10\">10px from bottom</span> <span \nclass=\"padding-left-20\">20px from left</span> <span class=\"padding-horizontal-5\">5px from left and right</span> <span \nclass=\"padding-vertical-5\">5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>pt-(5x)</span> <span>pr-(5x)</span> <span>pb-(5x)</span> <span>pl-(5x)</span> <span>ph-(5x)</span> <span>\npv-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"pt-5\">5px from top</span> <span class=\"pr-25\">25px from right</span> <span class=\"pb-10\">10px from bottom</span>\n <span class=\"pl-20\">20px from left</span> <span class=\"ph-5\">5px from left and right</span> <span class=\"pv-5\">\n5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>\npadding-top-(8x)</span> <span>padding-right-(8x)</span> <span>padding-bottom-(8x)</span> <span>padding-left-(8x)</span>\n <span>padding-horizontal-(8x)</span> <span>padding-vertical-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"padding-top-8\">8px from top</span> <span \nclass=\"padding-right-24\">24px from right</span> <span class=\"padding-bottom-16\">16px from bottom</span> <span \nclass=\"padding-left-8\">8px from left</span> <span class=\"padding-horizontal-8\">8px from left and right</span> <span \nclass=\"padding-vertical-8\">8px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96\n</div><span>pt-(8x)</span> <span>pr-(8x)</span> <span>pb-(8x)</span> <span>pl-(8x)</span> <span>ph-(8x)</span> <span>\npv-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"pt-8\">8px from top</span> <span class=\"pr-24\">24px from right</span> <span class=\"pb-16\">16px from bottom</span>\n <span class=\"pl-8\">8px from left</span> <span class=\"ph-8\">8px from left and right</span> <span class=\"pv-8\">\n8px from top and bottom</span></hljs></div></div><div class=\"md-title\">Margin Helpers</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span>no-margin</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"no-margin\">No margin</span></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption mb-16\">Multiples of 5, Max:100</div><span>margin-(5x)</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"margin-5\">5px margin</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption mb-16\">Multiples of 5, Max:100</div><span>m-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"m-15\">15px margin</span></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiples of 8, Max:96</div><span>margin-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span class=\"margin-8\">8px margin</span></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiples of 8, Max:96</div><span>m-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span class=\"m-32\">32px margin</span></hljs></div></div><div class=\"md-title\">\nDirection Specific Margin Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiples of 5, Max:100</div><span>margin-top-(5x)</span> <span>margin-right-(5x)</span> <span>margin-bottom-(5x)\n</span> <span>margin-left-(5x)</span> <span>margin-horizontal-(5x)</span> <span>margin-vertical-(5x)</span></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"margin-top-5\">5px from top\n</span> <span class=\"margin-right-25\">25px from right</span> <span class=\"margin-bottom-10\">10px from bottom</span> \n<span class=\"margin-left-20\">20px from left</span> <span class=\"margin-horizontal-5\">5px from left and right</span> \n<span class=\"margin-vertical-5\">5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div\n class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>mt-(5x)</span> <span>mr-(5x)</span> <span>mb-(5x)</span> <span>ml-(5x)</span> <span>mh-(5x)</span> <span>\nmv-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"mt-5\">5px from top</span> <span class=\"mr-25\">25px from right</span> <span class=\"mb-10\">10px from bottom</span>\n <span class=\"ml-20\">20px from left</span> <span class=\"mh-5\">5px from left and right</span> <span class=\"mv-5\">\n5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>\nmargin-top-(8x)</span> <span>margin-right-(8x)</span> <span>margin-bottom-(8x)</span> <span>margin-left-(8x)</span> \n<span>margin-horizontal-(8x)</span> <span>margin-vertical-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"margin-top-8\">8px from top</span> <span \nclass=\"margin-right-24\">24px from right</span> <span class=\"margin-bottom-16\">16px from bottom</span> <span \nclass=\"margin-left-8\">8px from left</span> <span class=\"margin-horizontal-8\">8px from left and right</span> <span \nclass=\"margin-vertical-8\">8px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96\n</div><span>mt-(8x)</span> <span>mr-(8x)</span> <span>mb-(8x)</span> <span>ml-(8x)</span> <span>mh-(8x)</span> <span>\nmv-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"mt-8\">8px from top</span> <span class=\"mr-24\">24px from right</span> <span class=\"mb-16\">16px from bottom</span>\n <span class=\"ml-8\">8px from left</span> <span class=\"mh-8\">8px from left and right</span> <span class=\"mv-8\">\n8px from top and bottom</span></hljs></div></div></md-tab><md-tab label=\"Width & Height Helpers\"><div class=\"md-title\">\nWidth Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500\n</div><span>width-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span class=\"width-5\">5px fixed width</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500\n</div><span>w-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span class=\"w-350\">350px fixed width</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>\nwidth-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"width-8\">8px fixed width</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>w-(8x)\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"w-560\">\n560px fixed width</span></hljs></div></div><div class=\"md-title\">Height Helpers</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500</div><span>\nheight-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"height-5\">5px fixed height</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500</div><span>h-(5x)\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"h-350\">\n350px fixed height</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>height-(8x)</span>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"height-8\">\n8px fixed height</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>h-(8x)</span></div>\n<hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"h-560\">\n560px fixed height</span></hljs></div></div></md-tab><md-tab label=\"Border Helpers\"><div class=\"md-title\">\nBorder Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>border</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"border\">Border on all sides</span>\n</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span>b</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span class=\"b\">Border on all sides</span></hljs></div></div><div class=\"md-title\">Direction Specific Border Helpers\n</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span>border-top</span> <span>border-right</span> <span>border-bottom\n</span> <span>border-left</span> <span>border-horizontal</span> <span>border-vertical</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"border-top\">Border top</span> <span \nclass=\"border-right\">Border right</span> <span class=\"border-bottom\">Border bottom</span> <span class=\"border-left\">\nBorder left</span> <span class=\"border-horizontal\">Border left and right</span> <span class=\"border-vertical\">\nBorder top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span>bt</span> <span>br</span> <span>bb</span> <span>bl</span> <span>bh</span> <span>\nbv</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"bt\">\nBorder top</span> <span class=\"br\">Border right</span> <span class=\"bb\">Border bottom</span> <span class=\"bl\">\nBorder left</span> <span class=\"bh\">Border left and right</span> <span class=\"bv\">Border top and bottom</span></hljs>\n</div></div><div class=\"md-title\">Border Radius Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption mb-16\">Multiples of 1, Max:12</div><span>brad-*</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"brad-2\">2px border radius</span> <span class=\"brad-5\">\n5px border radius</span></hljs></div></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/ui/icons/icons.html","<div id=\"icons\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Icons</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"https://materialdesignicons.com/\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\" layout=\"column\">\n<md-input-container class=\"md-block\"><label>Search an icon</label><input ng-model=\"vm.searchText\"></md-input-container>\n<div id=\"icons-list\" class=\"card md-whiteframe-1dp\" layout=\"row\" layout-wrap><div class=\"item\" \nng-repeat=\"icon in vm.icons | filter:{properties: {name:vm.searchText}} track by icon.properties.id\" \nlayout-align=\"start center\"><i class=\"icon icon-{{::icon.properties.name}} s40\"></i><div \nclass=\"name secondary-text text-center\">icon-{{::icon.properties.name}}</div></div></div></div></div>");
$templateCache.put("app/main/ui/material-colors/material-colors.html","<div id=\"material-colors\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Material Colors</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"https://www.google.com/design/spec/style/color.html#color-color-palette\" \ntarget=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div \nclass=\"content\"><md-tabs class=\"color-tabs\" md-dynamic-height md-swipe-content><md-tab \nng-repeat=\"(paletteName, palette) in vm.palettes\" \nmd-on-select=\"vm.selected = paletteName; vm.selectedPalette = palette\"><md-tab-label><span class=\"text-capitalize\">\n{{paletteName}}</span></md-tab-label></md-tab></md-tabs><md-content class=\"color-tab\"><div class=\"h3 pb-16\">\nFuse has classes for every single color from <a \nhref=\"https://www.google.com/design/spec/style/color.html#color-color-palette\" target=\"_blank\">\nMaterial Design Color Palette</a>\n for your convenient. You can use them with pretty much every element except Angular Material directives.</div><div \nclass=\"color-header colored-bg\" ng-class=\"\'md-\'+vm.selected+\'-bg\'\" layout=\"row\" layout-align=\"start start\" layout-wrap \nlayout-padding><div flex=\"100\"><h3 class=\"text-capitalize\">{{vm.selected}}</h3></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div>500</div><div>\nrgb({{vm.selectedPalette[\'500\'].value[0]}},{{vm.selectedPalette[\'500\'].value[1]}},{{vm.selectedPalette[\'500\'].value[2]}})\n</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"colored-bg\" \nng-repeat=\"(hue, hueValue) in vm.selectedPalette\" flex=\"100\" layout=\"row\" layout-sm=\"column\" layout-padding \nng-class=\"vm.selected+\'-\'+hue+\'-bg\'\"><div flex>{{hue}}</div><div class=\"colored-bg\" \nng-class=\"\'md-\'+vm.selected+\'-\'+hue+\'-bg\'\" flex>.{{\'md-\'+vm.selected+\'-\'+hue+\'-bg\'}}</div><div flex>\n.{{vm.selected+\'-\'+hue+\'-bg\'}}</div><div class=\"fg-box white-bg md-whiteframe-2dp\" \nng-class=\"vm.selected+\'-\'+hue+\'-fg\'\">.{{vm.selected+\'-\'+hue+\'-fg\'}}</div></div></div></md-content></div></div>");
$templateCache.put("app/main/ui/theme-colors/theme-colors.html","<div id=\"theme-colors\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Theme Colors</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised md-warn reference-button\" ng-click=\"vm.createTheme($event);\"><md-icon md-font-icon=\"icon-palette\">\n</md-icon><span>Create Your Own Theme!</span></md-button></div></div><div class=\"content\"><md-tabs class=\"color-tabs\" \nmd-dynamic-height md-swipe-content md-stretch-tabs=\"always\"><md-tab label=\"Primary Color\"><md-content \nclass=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/primary/primary.html\'\"></md-content></md-tab><md-tab \nlabel=\"Accent Color\"><md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/accent/accent.html\'\">\n</md-content></md-tab><md-tab label=\"Warn Color\"><md-content class=\"color-tab\" \nng-include=\"\'app/main/ui/theme-colors/tabs/warn/warn.html\'\"></md-content></md-tab><md-tab label=\"Background Color\">\n<md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/background/background.html\'\"></md-content>\n</md-tab></md-tabs></div></div>");
$templateCache.put("app/main/ui/typography/typography.html","<div id=\"typography\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">USER INTERFACE</span></div><div class=\"title\">Typography</div></div><div \nclass=\"content\"><md-tabs md-dynamic-height><md-tab label=\"Headings\"><div class=\"md-title\">Material design headings\n</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\" flex><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption secondary-text\">112px</div><span\n class=\"md-display-4\">Display 4</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span class=\"md-display-4\">Display 4</span></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">56px</div><span class=\"md-display-3\">Display 3</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-display-3\">Display 3</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">45px</div><span class=\"md-display-2\">Display 2</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-display-2\">Display 2</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">34px</div><span class=\"md-display-1\">Display 1</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-display-1\">Display 1</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">24px</div><span class=\"md-headline\">Headline</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-headline\">Headline</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">20px</div><span class=\"md-title\">Title</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-title\">Title</span></hljs></div>\n<div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">16px</div><span class=\"md-subhead\">Subhead</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-subhead\">Subhead</span></hljs>\n</div></div><div class=\"md-title\">Headings</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">24px</div><h1>Heading 1</h1></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h1>Heading 1</h1><div class=\"h1\">Heading 1</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">20px</div><h2>Heading 2</h2></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h2>Heading 2</h2><div class=\"h2\">Heading 2</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">16px</div><h3>Heading 3</h3></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h3>Heading 3</h3><div class=\"h3\">Heading 3</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">14px</div><h4>Heading 4</h4></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h4>Heading 4</h4><div class=\"h4\">Heading 4</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">13px</div><h5>Heading 5</h5></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h5>Heading 5</h5><div class=\"h5\">Heading 5</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">12px</div><h6>Heading 6</h6></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h6>Heading 6</h6><div class=\"h6\">Heading 6</div></hljs></div></div>\n</md-tab><md-tab label=\"Inline Text Elements\"><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><abbr \ntitle=\"Cascaded Style Sheet\">CSS</abbr></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><abbr title=\"Cascaded Style Sheet\">CSS</abbr></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>\nThis is a <mark>marked</mark> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll>This is a <mark>marked</mark> text.</hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><del>\nThis is a deleted text.</del></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><del>This is a deleted text.</del></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><s>This is a strike-through text.</s></span>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><s>\nThis is a strike-through text.</s></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span><u>This is an underlined text.</u></span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><u>This is an underlined text.</u></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span><small>This is a small text.</small></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><small>This is a small text.</small></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><strong>\nThis is a strong text.</strong></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scrollx><strong>This is a strong text.</strong></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><em>\nThis is an italic text.</em></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><em>This is an italic text.</em></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span class=\"text-super\">super</span>\n text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>\nThis is a <span class=\"text-super\">super</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span class=\"text-sub\">sub</span> text.\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>This is a \n<span class=\"text-sub\">sub</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span class=\"text-capitalize\">capitalized</span> text.\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>This is a \n<span class=\"text-capitalized\">capitalized</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is an <span class=\"text-uppercase\">uppercase\n</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" \nms-scroll>This is an <span class=\"text-uppercase\">uppercase</span> text.</hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span \nclass=\"text-lowercase\">LOWERCASE</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll>This is a <span class=\"text-lowercase\">LOWERCASE</span> text.</hljs></div>\n</div></md-tab><md-tab label=\"Blockquotes & Lists\"><div class=\"md-title\">Blockquotes</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p></blockquote></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p></blockquote></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer>\n</blockquote></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>\n<blockquote><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe\n</footer></blockquote></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><blockquote class=\"reverse\"><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer>\n</blockquote></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>\n<blockquote class=\"reverse\"><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p>\n<footer>John Doe</footer></blockquote></hljs></div></div><div class=\"md-title\">Lists</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><ol><li>Ordered list item</li><li>Ordered list item<ol><li>\nOrdered list item</li><li>Ordered list item</li></ol></li><li>Ordered list item</li><li>Ordered list item</li></ol>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><ol><li>\nOrdered list item</li><li>Ordered list item<ol><li>Ordered list item</li><li>Ordered list item</li></ol></li><li>\nOrdered list item</li><li>Ordered list item</li></ol></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><ul><li>Unordered list item</li><li>Unordered list item\n<ul><li>Unordered list item</li><li>Unordered list item</li></ul></li><li>Unordered list item</li><li>\nUnordered list item</li></ul></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><ul><li>Unordered list item</li><li>Unordered list item<ul><li>Unordered list item</li><li>\nUnordered list item</li></ul></li><li>Unordered list item</li><li>Unordered list item</li></ul></hljs></div></div><div \nclass=\"md-title\">Definition lists</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><dl><dt>Definition term</dt>\n<dd>This is the definition description</dd><dt>Another definition term</dt><dd>\nThis is also another definition description</dd></dl></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><dl><dt>Definition term</dt><dd>This is the definition description</dd><dt>\nAnother definition term</dt><dd>This is also another definition description</dd></dl></hljs></div></div></md-tab>\n<md-tab label=\"Helpers\"><div class=\"md-title\">Font weight</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div\n layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption mb-16\">From 100 to 900</div><span class=\"font-weight-100\">font-weight: 100</span> <span>...</span> \n<span class=\"font-weight-900\">font-weight: 900</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><span class=\"font-weight-100\">100 font weight</span> ... <span \nclass=\"font-weight-900\">900 font weight</span></hljs></div></div><div class=\"md-title\">Font Size</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiplies of 2, max: 120</div><span \nclass=\"font-size-20\">font-size: 20</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><span class=\"font-size-20\">font-size: 20</span></hljs></div></div><div \nclass=\"md-title\">Line Height</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiplies of 2, max: 120</div><span>line-height: 2</span> <span>...</span> <span>line-height: 120</span></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><span class=\"line-height-2\">\n2px line height</span> ... <span class=\"line-height-120\">120px line height</span></hljs></div></div><div \nclass=\"md-title\">Other helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-left\">\nLeft aligned text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" \nms-scroll><div class=\"text-left\">Left aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-center\">Center aligned text</div>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><div \nclass=\"text-center\">Center aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-right\">Right aligned text</div></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><div class=\"text-right\">\nRight aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><p><span class=\"text-boxed\">Boxed text</span></p></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><p><span class=\"text-boxed\">Boxed text\n</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview md-grey-700-bg\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><p><span class=\"text-boxed-light\">Boxed text light</span></p></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><p><span class=\"text-boxed-light\">\nBoxed text light</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><p><span class=\"text-strike\">Strike-through text</span></p></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><p><span class=\"text-strike\">\nStrike-through text</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-italic\">Italic text</div></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><div class=\"text-italic\">Italic text\n</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><div class=\"text-semibold\">Semi-bold text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><div class=\"text-semibold\">Semi-bold text</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"text-bold\">Bold text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><div class=\"text-bold\">Bold text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex><span class=\"text-truncate\">\nThis is a truncated text. It will be truncated if it\'s too long. Vivamus convallis dui porta massa.</span></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><span class=\"text-truncate\">\nThis is a truncated text. It will be truncated if it\'s too long. Vivamus convallis dui porta massa.</span></hljs></div>\n</div></md-tab></md-tabs></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span><img src=\"./assets/images/logos/logoblk.png\" \nalt=\"Lodging System\" style=\"max-height: 47px;width:auto;max-width: unset\"></span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<div id=\"fixed\" when-scrolled=\"vm.loadMore()\" ng-if=\"vm.unread.length > 0  && vm.unreadStauts\"><ul \nclass=\"noticcation-block-main\"><li class=\"cursorPointer liHeight\" ng-repeat=\"noti in vm.unread\" \nbind-html-compile=\"::noti.notification\"><div class=\"userimageNotif\"><img ng-src=\"{{::noti.profile_pic}}\" \non-error-src=\"{{::vm.baseUrl+\'assets/uploads/profileimage/default-profile.png\'}}\" alt=\"\"></div><span \nclass=\"time secondary-text\">{{::noti.created_at}}</span></li></ul></div><div id=\"fixed\" when-scrolled=\"vm.loadMore()\" \nng-if=\"vm.bothNotification.length > 0 && vm.bothStatus \"><ul class=\"noticcation-block-main\"><li \nclass=\"cursorPointer liHeight\" ng-repeat=\"noti in vm.bothNotification\"><div class=\"userimageNotif\"><img \nng-src=\"{{::noti.profile_pic}}\" on-error-src=\"{{::vm.baseUrl+\'assets/uploads/profileimage/default-profile.png\'}}\" \nalt=\"\"></div><span bind-html-compile=\"::noti.notification\"></span> <span class=\"time secondary-text\">\n{{::noti.created_at}}</span></li></ul></div><div id=\"fixed\" when-scrolled=\"vm.loadMore()\" \nng-if=\"vm.readNotification.length > 0 && vm.readStatus\"><ul class=\"noticcation-block-main\"><li \nclass=\"cursorPointer liHeight\" ng-repeat=\"noti in vm.readNotification\"><div class=\"userimageNotif\"><img \nng-src=\"{{::noti.profile_pic}}\" on-error-src=\"{{::vm.baseUrl+\'assets/uploads/profileimage/default-profile.png\'}}\" \nalt=\"\"></div><span bind-html-compile=\"::noti.notification\"></span> <span class=\"time secondary-text\">\n{{::noti.created_at}}</span></li></ul></div><md-list class=\"servers\" ng-if=\"vm.totalNotification == 0 \"><md-list-item \nclass=\"server md-3-line\"><div class=\"md-list-item-text\"><p>No notifications</p></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">11111F</span> <span class=\"logo-text\">FUSE</span>\n</div><div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div\n layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"ellipses\">{{hotels[selectedHotel].hotel_title}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" ng-show=\"vm.roleId == 1\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\" id=\"language-menu-content\" class=\"search-string\" ng-show=\"vm.roleId == 1\"><md-menu-item \nng-if=\"hotels.length > 10\"><div layout=\"row\" layout-padding><md-icon md-font-icon=\"icon-magnify\"></md-icon><input flex \nmd-padding type=\"search\" ng-model=\"vm.searchString\"></div></md-menu-item><md-menu-item \nng-repeat=\"hotel in hotels | filter: vm.searchString\"><md-button ng-click=\"vm.changeHotel($index)\" \naria-label=\"{{hotel.website_name}}\" translate translate-attr-aria-label=\"\"><span layout=\"row\" \nlayout-align=\"start center\"><span class=\"ellipses\">{{hotel.hotel_title}}</span></span></md-button></md-menu-item>\n</md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" ng-src=\"{{profilePic}}\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/profileimage/default-profile.png\'}}\"></div><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\" ui-sref=\"app.permissions_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\">\n</md-icon><md-button>{{username}}</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" \nng-show=\"false\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" \nclass=\"icon notification-icon\" id=\"btnIcon\"><span id=\"notificationBubble\" ng-if=\"vm.notificationBubble\" \nclass=\"noti-icon\">{{vm.notificationCount}}</span></md-icon></md-button></div></div><div class=\"menu-overlay\" \nng-show=\"vm.isOpen\" \nstyle=\"position: fixed;\n    width: 100%;background: rgba(255, 255, 255,0.8);left: 0;top: 0;right: 0;bottom: 0\"></div>\n<div class=\"gmc-inbox-toast\" ng-if=\"vm.inboxToast\" ng-class=\"{\'is-escalation\': vm.inboxToast.type === \'escalation\'}\" \nng-click=\"vm.openInboxToast($event)\" role=\"button\" tabindex=\"0\" \nng-keydown=\"$event.keyCode === 13 && vm.openInboxToast($event)\"><div class=\"gmc-inbox-toast-icon\"><md-icon \nmd-font-icon=\"{{vm.inboxToast.type === \'escalation\' ? \'icon-alert\' : \'icon-message-text\'}}\"></md-icon></div><div \nclass=\"gmc-inbox-toast-body\"><div class=\"gmc-inbox-toast-heading\">{{vm.inboxToast.heading || \'New message\'}}</div><div \nclass=\"gmc-inbox-toast-title\">{{vm.inboxToast.guest_name || vm.inboxToast.title}}</div><div \nclass=\"gmc-inbox-toast-preview\" ng-if=\"vm.inboxToast.preview\">{{vm.inboxToast.preview}}</div></div><button \ntype=\"button\" class=\"gmc-inbox-toast-close\" ng-click=\"vm.dismissInboxToast($event)\" aria-label=\"Dismiss\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></button></div><div class=\"lowerFabDial\"><md-fab-speed-dial md-open=\"vm.isOpen\" \nmd-direction=\"{{vm.selectedDirection}}\" ng-class=\"vm.selectedMode\"><md-fab-trigger><md-button aria-label=\"menu\" \nclass=\"md-fab md-warn\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/menu.svg\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button aria-label=\"Add Reservation\" class=\"md-fab md-raised md-mini\" \nng-if=\"vm.userPermissions.indexOf(\'reservations\')!=-1\" ng-click=\"vm.addNewReservation()\"><md-icon \nmd-font-icon=\"icon-calendar-text\" aria-label=\"Add Reservation\"></md-icon><md-tooltip md-direction=\"left\">\nAdd reservation</md-tooltip></md-button><md-button aria-label=\"Add rates\" class=\"md-fab md-raised md-mini\" \nng-click=\"vm.changestate(\'app.rateRule\')\" ng-if=\"vm.userPermissions.indexOf(\'rate_calendar\')!=-1\"><md-icon \nmd-font-icon=\"icon-currency-usd\" aria-label=\"Add rates\"></md-icon><md-tooltip md-direction=\"left\">Add rates\n</md-tooltip></md-button><md-button aria-label=\"Add task\" class=\"md-fab md-raised md-mini\" \nng-click=\"vm.changestate(\'app.to-do\',\'opendialog\')\" ng-if=\"vm.userPermissions.indexOf(\'add_task\')!=-1\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\" aria-label=\"Add task\"></md-icon><md-tooltip md-direction=\"left\">Add task\n</md-tooltip></md-button><md-button aria-label=\"Add customer\" class=\"md-fab md-raised md-mini\" \nng-if=\"vm.userPermissions.indexOf(\'add_customer\') != -1\" ng-click=\"vm.changestate(\'app.customer_add\')\"><md-icon \nmd-font-icon=\"icon-account-box\" aria-label=\"Add customer\"></md-icon><md-tooltip md-direction=\"left\">Add customer\n</md-tooltip></md-button><md-button aria-label=\"Add promotion\" class=\"md-fab md-raised md-mini\" \nng-if=\"vm.userPermissions.indexOf(\'add_promotion\') != -1\" ng-click=\"vm.addPoromotion()\"><md-icon \nmd-font-icon=\"icon-sale\" aria-label=\"Add promotion\"></md-icon><md-tooltip md-direction=\"left\">Add promotion\n</md-tooltip></md-button><md-button aria-label=\"Add mls\" class=\"md-fab md-raised md-mini\" \nng-if=\"vm.userPermissions.indexOf(\'add_restriction\')!=-1\" ng-click=\"vm.changestate(\'app.mls\',\'opendialog\')\"><md-icon \nmd-font-icon=\"icon-calendar-select\" aria-label=\"Add mls\"></md-icon><md-tooltip md-direction=\"left\">Add mls</md-tooltip>\n</md-button></md-fab-actions></md-fab-speed-dial></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <md-icon md-svg-src=\"{{node.svgIcon}}\" class=\"navigation-svg-icon s18\" ng-if=\"node.svgIcon\"></md-icon>\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon && !node.svgIcon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <md-icon md-svg-src=\"{{node.svgIcon}}\" class=\"navigation-svg-icon s18\" ng-if=\"node.svgIcon\"></md-icon>\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon && !node.svgIcon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <a class=\"ms-navigation-button\" ng-if=\"node.href && node.title\" ng-href=\"{{node.href}}\" target=\"{{node.target}}\">\n          <md-icon md-svg-src=\"{{node.svgIcon}}\" class=\"navigation-svg-icon s16\" ng-if=\"node.svgIcon\"></md-icon>\n          <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon && !node.svgIcon\"></i>\n          <span class=\"title-badge\" flex>\n            <span class=\"title\" translate=\"{{node.translate}}\">{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"vm.showBadge()\">{{node.badge.content}}</span>\n          </span>\n          <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && !node.href && node.title\">\n            <md-icon md-svg-src=\"{{node.svgIcon}}\" class=\"navigation-svg-icon s16\" ng-if=\"node.svgIcon\"></md-icon>\n          <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon && !node.svgIcon\"></i>\n            <span class=\"title-badge\" flex>\n              <span class=\"title\" translate=\"{{node.translate}}\">{{node.title}}</span>\n              <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"vm.showBadge()\">{{node.badge.content}}</span>\n            </span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <md-icon md-svg-src=\"{{node.svgIcon}}\" class=\"navigation-svg-icon s16\" ng-if=\"node.svgIcon\"></md-icon>\n          <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon && !node.svgIcon\"></i>\n            <span class=\"title-badge\" flex>\n              <span class=\"title\" translate=\"{{node.translate}}\">{{node.title}}</span>\n              <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"vm.showBadge()\">{{node.badge.content}}</span>\n            </span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/apps/checkout/add-customer/add-customer.html","<md-dialog class=\"tax-dialog tax-dialog-new1 act-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"row\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\"><md-button class=\"goto-products-button md-icon-button\" ng-if=\"vm.show_listing\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"white-fg\" ng-click=\"vm.hideListing()\"></md-icon></md-button><md-button \nclass=\"goto-products-button md-icon-button\" ng-if=\"vm.pos_flag == \'edit\'\"><md-icon md-font-icon=\"icon-arrow-left\" \nclass=\"white-fg\" ng-click=\"vm.showListing()\"></md-icon></md-button>{{ vm.pop_header }}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\" \nclass=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\"><md-content class=\"md-padding no-margin\" \nng-hide=\"vm.show_listing || vm.delete_popup\"><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex><div \nclass=\"row-block\" flex-gt-xs=\"100\" flex><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" flex-gt-sm=\"50\" \nlayout=\"column\" flex=\"100\" layout-align=\"start start\" class=\"padding-5\" flex><md-input-container \nclass=\"md-block tax-inputs full-width mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"CONTACTS.FIRST_NAME\"></label><input type=\"text\" name=\"first_name\" ng-model=\"vm.contact.first_name\" \naria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" flex-gt-sm=\"50\" \nlayout=\"column\" layout-align=\"start start\" class=\"padding-5\" flex><md-input-container \nclass=\"md-block tax-inputs full-width mb-0\" data-ng-animate=\"2\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"CONTACTS.LAST_NAME\"></label><input type=\"text\" name=\"last_name\" ng-model=\"vm.contact.last_name\" \naria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex>\n<div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block tax-inputs full-width mb-0\" data-ng-animate=\"1\"><label \nclass=\"ng-scope md-required\" role=\"button\" translate=\"CONTACTS.EMAIL\"></label><input type=\"email\" name=\"email\" \nng-model=\"vm.contact.customer_email\" required aria-invalid=\"true\" \nng-change=\"!contactForm.customer_email.$invalid && vm.checkDuplicateEmail()\" ng-model-options=\"{debounce: 500}\" \nng-pattern=\"/^.+@.+\\..+$/\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div ng-messages=\"contactForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span translate=\"CONTACTS.VALID_EMAIL\"></span></div><div \nng-if=\"vm.duplicateEmail\" class=\"emailError\"><span translate=\"CONTACTS.EMAIL_EXISTS\" class=\"pl-10\"></span></div></div>\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" \nrole=\"button\" translate=\"CONTACTS.PHONE_NUMBER\"></label><input type=\"text\" name=\"phone_number\" \nng-model=\"vm.contact.phone_number\" aria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" ng-pattern=\"/^[0-9]{10}$/\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div ng-messages=\"contactForm.phone_number.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"pattern\"><span translate=\"CONTACTS.VALID_PHONE\"></span></div></div>\n</md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex>\n<div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block no-md-spacer tax-inputs full-width no-icon-datepicker\" data-ng-animate=\"1\"><label \nclass=\"ng-scope\" role=\"button\" translate=\"CONTACTS.DOB\"></label><md-datepicker class=\"padding-bottom-0 full-width\" \nmd-hide-icons=\"calendar\" flex-gt-xs=\"100\" ng-model=\"vm.contact.date_of_birth\" md-open-on-focus \nng-model-options=\"{debounce: 500}\"></md-datepicker></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-autocomplete class=\"full-width\" ng-disabled=\"vm.isCountryDisabled\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedCountry\" md-search-text-change=\"vm.searchCountry(vm.searchTxtCountry)\" \nmd-search-text=\"vm.searchTxtCountry\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-items=\"item in vm.queryCountrySearch(vm.searchTxtCountry)\" md-item-text=\"item.display\" md-min-length=\"0\" \nmd-floating-label=\"Select country\" md-require-match><md-item-template><span md-highlight-text=\"vm.searchTxtCountry\" \nmd-highlight-flags=\"^i\">{{item.display}}</span></md-item-template><md-not-found>\nNo country matching \"{{vm.searchTxtCountry}}\" were found.</md-not-found></md-autocomplete><div \nclass=\"md-errors-spacer\"></div></div></div><div class=\"row-block row-autocomplete\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\" flex><md-autocomplete ng-disabled=\"vm.isStateDisabled\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedState\" md-search-text-change=\"vm.searchState(vm.searchTxtState)\" \nmd-search-text=\"vm.searchTxtState\" md-selected-item-change=\"vm.selectedItemChangeState(item)\" \nmd-items=\"item in vm.queryStateSearch(vm.searchTxtState)\" md-item-text=\"item.display\" md-min-length=\"0\" \nmd-floating-label=\"Select state\" md-require-match><md-item-template><span md-highlight-text=\"vm.searchTxtState\" \nmd-highlight-flags=\"^i\">{{item.display}}</span></md-item-template><md-not-found>\nNo states matching \"{{vm.searchTxtState}}\" were found.</md-not-found></md-autocomplete></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"CONTACTS.CITY\"></label><input ng-model=\"vm.contact.city\" type=\"text\" name=\"city\" \nng-model-options=\"{debounce: 500}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div></div>\n<div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"CONTACTS.ZIPCODE\"></label><input ng-model=\"vm.contact.zip_code\" type=\"text\" name=\"zip_code\" \nng-model-options=\"{debounce: 500}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block tax-inputs full-width\"><label translate=\"CONTACTS.PASSWORD\"></label><input \nng-model=\"vm.password\" type=\"password\" name=\"password_1\" min-password ng-model-options=\"{debounce: 500}\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div ng-messages=\"contactForm.password_1.$error\" role=\"alert\"><div \nng-message=\"min-password\"><span translate=\"CONTACTS.MIN_PASSWORD\"></span></div></div></md-input-container></div></div>\n<div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block tax-inputs full-width\"><label translate=\"CONTACTS.CONFIRM_PASSWORD\"></label><input \nng-model=\"vm.contact.passwordConfirm\" type=\"password\" name=\"passwordConfirm\" pwd-and-cnfm-same \nng-model-options=\"{debounce: 500}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div \nng-messages=\"contactForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"pwd-and-cnfm-same\"><span \ntranslate=\"CONTACTS.MATCH_PASSWORD\"></span></div></div></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block md-input-has-value\" flex-gt-xs=\"100\"><label translate=\"CONTACTS.TAX_EXEMPT\">\n</label><md-radio-group name=\"tax_exempt_indicator\" ng-model=\"vm.contact.tax_exempt_indicator\"><md-radio-button \nvalue=\"1\">{{ \'CONTACTS.YES\' | translate }}</md-radio-button><md-radio-button value=\"0\" class=\"margin-left-15\">\n{{ \'CONTACTS.NO\' | translate }}</md-radio-button></md-radio-group><div class=\"md-errors-spacer\"></div>\n</md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex>\n<div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block tax-inputs\" flex-gt-xs=\"100\" ng-if=\"vm.contact.tax_exempt_indicator == 1\"><label \ntranslate=\"CONTACTS.TAX_EXEMPT_ID\"></label><input ng-model=\"vm.contact.tax_exempt_id\" type=\"text\" name=\"tax_exempt_id\" \nng-model-options=\"{debounce: 500}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div class=\"md-errors-spacer\"></div>\n</md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex>\n<div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block md-input-has-value\" flex-gt-xs=\"100\"><label translate=\"CONTACTS.SENDEMAIL\"></label>\n<md-radio-group name=\"send_email_indicator\" ng-model=\"vm.contact.send_email_indicator\"><md-radio-button value=\"1\">\n{{ \'CONTACTS.YES\' | translate }}</md-radio-button><md-radio-button value=\"0\" class=\"margin-left-15\">\n{{ \'CONTACTS.NO\' | translate }}</md-radio-button></md-radio-group><div class=\"md-errors-spacer\"></div>\n</md-input-container></div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\" ng-hide=\"vm.show_listing\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-click=\"vm.addNewCustomer()\" class=\"send-button md-accent md-raised white-fg\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine || vm.duplicateEmail\" aria-label=\"Add Customer\" \nng-class=\"{\'md-blue-grey-A100-bg\': contactForm.$invalid || contactForm.$pristine || vm.duplicateEmail}\" \ntranslate=\"SAVE\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/checkout/dialog/addNote.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"noteForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Order Comment</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\"><div class=\"white-bg ph-20 pt-10 pb-10\"><md-input-container \nclass=\"md-block mb-0\"><label>Comment</label><textarea ng-model=\"vm.note\" rows=\"1\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" \nng-click=\"vm.addNoteToCart()\" \nng-class=\"noteForm.$invalid || noteForm.$pristine?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"noteForm.$invalid || noteForm.$pristine\" aria-label=\"SAVE\" translate=\"GROUPS.SAVE\" layout=\"column\">\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/checkout/dialog/completePayment.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Complete payment for split {{splitCount}}</span><md-button class=\"md-icon-button\" \nng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button \nclass=\"mv-15 mh-0 white-fg md-raised md-green-500-bg\" ng-click=\"completePayment()\" aria-label=\"YES\">YES</md-button>\n<md-button class=\"mv-15 mh-0 white-fg md-red-500-bg md-raised\" ng-click=\"closeDialog()\" aria-label=\"NO\">NO</md-button>\n</div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/checkout/dialog/customDiscount.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"customDiscount\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Discount - Maximum 100%</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><div class=\"white-bg padding-15 pt-30\"><div flex=\"100\" layout=\"row pt-15\"><div flex=\"60\" \nlayout=\"column\" class=\"typetxt\" layout-align=\"center start\"><md-input-container class=\"md-block mb-0 mt-0 full-width\">\n<label>{{vm.PriceType}}</label><input type=\"number\" name=\"product_name\" ng-model=\"vm.customDiscount.dicount_price\" \nrequired min=\"0\" max=\"{{vm.discountPriceType == \'percentage\'? 100:99999999}}\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"> <span class=\"info-note\">Discount will be applied per night in case of timebound product.</span>\n</md-input-container></div><div flex=\"40\" layout=\"column\" class=\"typetxt\" layout-align=\"start end\"><div \nclass=\"btn-dollerandpercent btn-dollerandpercent-discount\"><md-button \nng-class=\"vm.discountPriceType == \'amount\'?\'md-button ng-scope md-ink-ripple md-raised md-primary submit-button white-fg font_size_20\':\'md-button md-raised font_size_20\'\" \nng-click=\"vm.customAmountType(\'amount\')\">$</md-button><md-button \nng-class=\"vm.discountPriceType == \'percentage\'?\'md-button ng-scope md-ink-ripple md-raised md-primary submit-button white-fg font_size_20\':\'md-button md-raised font_size_20\'\" \nng-click=\"vm.customAmountType(\'percentage\')\">%</md-button></div></div></div><div flex=\"100\" layout=\"row\"><div \nflex=\"100\" layout=\"column\" class=\"typetxt\" layout-align=\"center start\"></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" \nflex=\"100\"><div flex=\"40\" layout=\"column\" class=\"typetxt\" layout-align=\"start end\"><div \nclass=\"btn-dollerandpercent btn-dollerandpercent-discount\"><md-button type=\"submit\" \nng-click=\"vm.addCustomDiscount(\'add\')\" \nng-class=\"customDiscount.$invalid || customDiscount.$pristine?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"customDiscount.$invalid\" aria-label=\"SAVE\">Apply</md-button><md-button type=\"submit\" \nng-click=\"vm.addCustomDiscount(\'remove\')\" class=\"md-raised md-red-500-bg submit-button white-fg\" aria-label=\"SAVE\" \nng-if=\"vm.discountAdded\">Remove</md-button></div></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/checkout/dialog/customSale.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"customProduct\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Custom Product</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><div class=\"white-bg ph-15\"><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\"><md-input-container class=\"md-block mb-0 ph-10\"><label class=\"ml-10\" role=\"button\">\nProduct Name</label><input type=\"text\" name=\"product_name\" ng-model=\"vm.customProduct.product_name\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\"><md-input-container class=\"md-block mb-0 ph-10\"><label class=\"ml-10\" role=\"button\">Price</label><input \ntype=\"number\" name=\"product_name\" ng-model=\"vm.customProduct.product_price\" required step=\"0.01\" min=\"0\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-wrap><div layout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><md-input-container class=\"md-block mb-0 ph-10\"><label \nclass=\"ml-10\">Tax</label><md-select ng-model=\"vm.customProduct.tax_value\" ng-change=\"vm.getTaxId()\"><md-option \nng-value=\"0\">None</md-option><md-option ng-if=\"!vm.taxValue\" ng-repeat=\"tax in vm.tax\" ng-value=\"tax\" required>\n{{tax.tax_name+\' @\'+tax.tax_value+\'%\'}}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><md-input-container \nclass=\"md-block mb-0 ph-10\"><label class=\"ml-10\" role=\"button\">Quantity</label><input type=\"number\" name=\"quantity\" \nng-model=\"vm.customProduct.quantity\" min=\"1\" step=\"1\" required ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" \nng-click=\"vm.addCustomProduct()\" \nng-class=\"customProduct.$invalid || customProduct.$pristine?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"customProduct.$invalid\" aria-label=\"SAVE\" translate=\"GROUPS.SAVE\" layout=\"column\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/checkout/dialog/customerModel.html","<md-dialog class=\"tax-dialog tax-dialog-new1 act-dialog addcusform\" aria-label=\"New Task\"><form name=\"contactForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"row\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\"><md-button class=\"goto-products-button md-icon-button\" ng-if=\"vm.show_listing\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"white-fg\" ng-click=\"vm.hideListing()\"></md-icon></md-button><md-button \nclass=\"goto-products-button md-icon-button\" ng-if=\"vm.pos_flag == \'edit\'\"><md-icon md-font-icon=\"icon-arrow-left\" \nclass=\"white-fg\" ng-click=\"vm.showListing()\"></md-icon></md-button>Billing Information</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\" \nclass=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll style=\"max-height:1000px\">\n<md-content class=\"md-padding no-margin\" ng-hide=\"vm.show_listing || vm.delete_popup\"><div layout=\"column\" \nlayout-gt-xs=\"row\" layout-align=\"start\" flex><div class=\"row-block\" flex-gt-xs=\"100\" flex><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex><div class=\"row-col padding-right-10 padding-left-10\" \nflex-gt-xs=\"100\" flex-gt-sm=\"50\" layout=\"column\" flex=\"100\" layout-align=\"start start\" class=\"padding-5\" flex>\n<md-autocomplete flex md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedSearch.first_name\" \nmd-selected-item-change=\"vm.updateForm(item, \'cust.first_name\')\" \nmd-items=\"item in vm.querySearch(vm.searchTextFn, \'cust.first_name\')\" md-search-text=\"vm.searchTextFn\" \nmd-item-text=\"item.first_name\" md-min-length=\"1\" md-max-length=\"18\" md-floating-label=\"First name\" \nclass=\"chooseCustomer full-width\"><md-item-template><span md-highlight-text=\"vm.searchTextFn\" md-highlight-flags=\"^i\">\n{{item.display}}</span></md-item-template></md-autocomplete></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" flex-gt-sm=\"50\" layout=\"column\" \nlayout-align=\"start start\" class=\"padding-5\" flex><md-autocomplete flex md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedSearch.last_name\" md-selected-item-change=\"vm.updateForm(item, \'cust.last_name\')\" \nmd-items=\"item in vm.querySearch(vm.searchTextLn, \'cust.last_name\')\" md-search-text=\"vm.searchTextLn\" \nmd-item-text=\"item.last_name\" md-min-length=\"1\" md-max-length=\"18\" md-floating-label=\"Last name\" \nclass=\"chooseCustomer full-width\"><md-item-template><span md-highlight-text=\"vm.searchTextLn\" md-highlight-flags=\"^i\">\n{{item.display}}</span></md-item-template></md-autocomplete></div></div><div class=\"row-block\" flex-gt-xs=\"100\" \nlayout=\"row\" layout-align=\"start start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" \nlayout=\"column\" layout-align=\"start start\" flex><md-autocomplete flex md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedSearch.customer_email\" \nmd-selected-item-change=\"vm.updateForm(item, \'cust.customer_email\')\" \nmd-items=\"item in vm.querySearch(vm.searchTextEm, \'cust.customer_email\')\" md-search-text=\"vm.searchTextEm\" \nmd-item-text=\"item.customer_email\" md-min-length=\"1\" md-max-length=\"18\" md-floating-label=\"Email\" \nclass=\"chooseCustomer full-width\" required><md-item-template><span md-highlight-text=\"vm.searchTextEm\" \nmd-highlight-flags=\"^i\">{{item.customer_email}}</span></md-item-template></md-autocomplete></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"CONTACTS.PHONE_NUMBER\"></label><input type=\"text\" name=\"phone_number\" ng-model=\"vm.contact.phone_number\" \naria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" ui-options=\"{addDefaultPlaceholder:false}\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div ng-messages=\"contactForm.phone_number.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"pattern\"><span translate=\"CONTACTS.VALID_PHONE\"></span></div></div>\n</md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex>\n<div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" role=\"button\">Secondary Phone Number\n</label><input type=\"text\" name=\"secondary_phone_number\" ng-model=\"vm.contact.secondary_phone_number\" \naria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" ui-options=\"{addDefaultPlaceholder:false}\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div ng-messages=\"contactForm.secondary_phone_number.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span translate=\"CONTACTS.VALID_PHONE\"></span></div></div>\n</md-input-container></div><div class=\"padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout-align=\"start start\" \nflex><md-input-container class=\"md-block\"><label>Address</label><textarea ng-model=\"vm.contact.address\" rows=\"1\" \nmd-select-on-focus></textarea></md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" flex></div><div class=\"row-block row-autocomplete\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" \nrole=\"button\" translate=\"CONTACTS.CITY\"></label><input ng-model=\"vm.contact.city\" type=\"text\" name=\"city\" \nng-model-options=\"{debounce: 500}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-autocomplete ng-disabled=\"vm.isStateDisabled\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedState\" \nmd-search-text-change=\"vm.searchState(vm.searchTxtState)\" md-search-text=\"vm.searchTxtState\" \nmd-selected-item-change=\"vm.selectedItemChangeState(item)\" md-items=\"item in vm.queryStateSearch(vm.searchTxtState)\" \nmd-item-text=\"item.display\" md-min-length=\"0\" md-floating-label=\"State\" md-require-match><md-item-template><span \nmd-highlight-text=\"vm.searchTxtState\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template><md-not-found>\nNo Results Found.</md-not-found></md-autocomplete></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" \nrole=\"button\" translate=\"CONTACTS.ZIPCODE\"></label><input ng-model=\"vm.contact.zip_code\" type=\"text\" name=\"zip_code\" \nng-model-options=\"{debounce: 500}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-autocomplete ng-disabled=\"vm.isCountryDisabled\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedCountry\" \nmd-search-text-change=\"vm.searchCountry(vm.searchTxtCountry)\" md-search-text=\"vm.searchTxtCountry\" \nmd-selected-item-change=\"vm.selectedItemChange(item, \'\', \'\')\" \nmd-items=\"item in vm.queryCountrySearch(vm.searchTxtCountry)\" md-item-text=\"item.display\" md-min-length=\"0\" \nmd-floating-label=\"Country\" md-require-match class=\"full-width\"><md-item-template><span \nmd-highlight-text=\"vm.searchTxtCountry\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template>\n<md-not-found>No Results Found.</md-not-found></md-autocomplete><div class=\"md-errors-spacer\"></div></div></div><div \nclass=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block md-input-has-value no-margin\" flex-gt-xs=\"100\" \nng-init=\"vm.contact.tax_exempt_indicator = vm.contact.tax_exempt_indicator == \'1\'?true:false\"><md-switch \nng-model=\"vm.contact.tax_exempt_indicator\" aria-label=\"Switch 1\" class=\"no-margin\"><span \ntranslate=\"CONTACTS.TAX_EXEMPT_ON\" ng-if=\"vm.contact.tax_exempt_indicator\"></span> <span \ntranslate=\"CONTACTS.TAX_EXEMPT_OFF\" ng-if=\"!vm.contact.tax_exempt_indicator\"></span></md-switch><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" \nflex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex><md-input-container \nclass=\"md-block md-input-has-value no-margin\" flex-gt-xs=\"100\" \nng-init=\"vm.contact.send_email_indicator  = vm.contact.send_email_indicator == \'1\'?true:false;\"><md-switch \nng-model=\"vm.contact.send_email_indicator\" aria-label=\"Switch 1\" class=\"no-margin\"><span \ntranslate=\"CONTACTS.SENDEMAIL_ON\" ng-if=\"vm.contact.send_email_indicator\"></span><span \ntranslate=\"CONTACTS.SENDEMAIL_OFF\" ng-if=\"!vm.contact.send_email_indicator\"></span></md-switch><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" flex ng-if=\"vm.contact.tax_exempt_indicator == 1\"><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\">\n<md-input-container class=\"md-block tax-inputs full-width\"><label translate=\"CONTACTS.TAX_EXEMPT_ID\"></label><input \nng-model=\"vm.contact.tax_exempt_id\" type=\"text\" name=\"tax_exempt_id\" ng-model-options=\"{debounce: 500}\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div class=\"md-errors-spacer\"></div></md-input-container></div></div>\n</div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" \nng-hide=\"vm.show_listing\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" \nng-click=\"vm.selectCustomer()\" ng-disabled=\"vm.validateUser()\" \nng-class=\"vm.validateUser()?\'send-button md-accent md-raised white-fg\':\'send-button md-green-500-bg md-raised white-fg\'\" \naria-label=\"Add Customer\">Select User</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/checkout/dialog/giftCard.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"giftCard\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Gift Card</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll style=\"max-width:800px;max-height:1000px\">\n<md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><div \nclass=\"white-bg padding-15\"><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-xs=\"50\">\n<md-input-container class=\"md-block mb-0 ph-10\"><label class=\"ml-10\" role=\"button\">Price</label><input type=\"number\" \nname=\"product_name\" ng-model=\"vm.giftCard.product_price\" required min=\"1\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><md-input-container \nclass=\"md-block mb-0 ph-10\"><label class=\"ml-10\" role=\"button\">Quantity</label><input type=\"number\" \nname=\"product_name\" ng-model=\"vm.giftCard.quantity\" required min=\"1\" step=\"1\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\"><md-input-container class=\"md-block mb-0 ph-10\"><label class=\"ml-10\" role=\"button\">\nCustomer Name</label><input type=\"text\" name=\"product_name\" ng-model=\"vm.giftCard.gc_sender_name\" required \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\"><md-input-container class=\"md-block mb-0 ph-10\"><label class=\"ml-10\" role=\"button\">Customer Email\n</label><input type=\"email\" name=\"product_name\" ng-model=\"vm.giftCard.gc_sender_email\" required \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-wrap><div layout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><md-input-container class=\"md-block mb-0 ph-10\"><label \nclass=\"ml-10\" role=\"button\">Recipient Name</label><input type=\"text\" name=\"product_name\" \nng-model=\"vm.giftCard.gc_recipient_name\" required ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container>\n</div><div layout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><md-input-container class=\"md-block mb-0 ph-10\"><label \nclass=\"ml-10\" role=\"button\">Recipient Email</label><input type=\"email\" name=\"product_name\" \nng-model=\"vm.giftCard.gc_recipient_email\" required ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" \nflex-gt-xs=\"100\"><md-input-container class=\"md-block mb-0 ph-10\"><label class=\"ml-10\" role=\"button\">Message</label>\n<input type=\"text\" name=\"product_name\" ng-model=\"vm.giftCard.gc_message\" required ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" \nng-click=\"vm.addgiftCard()\" \nng-class=\"giftCard.$invalid || giftCard.$pristine?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"giftCard.$invalid\" aria-label=\"SAVE\" translate=\"GROUPS.SAVE\" layout=\"column\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/checkout/dialog/onlyNumberDialog.html","<md-dialog \nng-class=\"vm.productData.product_is_timebound == 1?\'product-dialog productdataupdate datePickerClass\':\'product-dialog productdataupdate\'\" \naria-label=\"New Task\"><form name=\"mlsForm\" class=\"md-inline-form\" novalidate><md-dialog-content ms-scroll>\n<md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><div \nclass=\"header-blockupdate md-accent-bg white-fg padding-15\" flex=\"100\" layout=\"row\" layout-wrap><span flex=\"70\" \nlayout=\"column\" layout-align=\"start start\">{{vm.dialogTitle}}</span><md-icon ng-if=\"vm.popUpType != \'overAllDiscount\'\" \nflex=\"30\" layout-align=\"end end\" layout=\"column\" md-font-icon=\"icon-check\" \nclass=\"done-btn white-fg onlycursorPointer no-padding\" ng-click=\"vm.updateCustomPrice($event)\"></md-icon></div><div \nclass=\"input-type-block ph-15 pt-30\" ng-if=\"vm.popUpType != \'overAllDiscount\'\"><div flex=\"100\" layout=\"row pt-15\"><div \nflex=\"100\" layout=\"column\" class=\"typetxt\" layout-align=\"center start\" ng-if=\"vm.selectUser\"><md-input-container \nclass=\"md-block mt-0\"><label>Select User</label><md-select ng-model=\"vm.tipCustomerId\"><md-option \nng-repeat=\"user in vm.allUsers\" ng-value=\"user.user_id\" ng-selected=\"vm.loggedInUserId==user.user_id\">\n{{user.first_name+\' \'+user.last_name}}</md-option></md-select></md-input-container></div></div><div flex=\"100\" \nlayout=\"row pt-15\"><div flex=\"80\" layout=\"column\" class=\"typetxt\" layout-align=\"center start\"><md-input-container \nclass=\"md-block mb-0 mt-0\"><input type=\"text\" name=\"customTip\" ng-model=\"vm.customTip\" \nng-if=\"vm.popUpType == \'customTip\' || vm.popUpType == \'change\' || vm.popUpType == \'editposorder\'\" readonly=\"readonly\">\n</md-input-container></div><div flex=\"20\" layout=\"column\" class=\"typetxt\" layout-align=\"start end\"><div \nclass=\"btn-dollerandpercent\"><md-button \nng-class=\"vm.priceType == \'amount\'?\'md-button ng-scope md-ink-ripple md-raised md-primary submit-button white-fg\':\'md-button md-raised\'\" \nng-if=\"vm.priceType == \'amount\' || vm.popUpType == \'overAllDiscount\'\">$</md-button><md-button \nng-class=\"vm.priceType == \'percentage\'?\'md-button ng-scope md-ink-ripple md-raised md-primary submit-button white-fg\':\'md-button md-raised\'\" \nng-if=\"vm.priceType == \'percentage\' || vm.popUpType == \'overAllDiscount\'\">%</md-button></div></div></div></div><div \nclass=\"white-bg padding-15 pt-30\" ng-if=\"vm.popUpType == \'overAllDiscount\'\"><div flex=\"100\" layout=\"row pt-15\"><div \nflex=\"60\" layout=\"column\" class=\"typetxt\" layout-align=\"center start\"><md-input-container \nclass=\"md-block mb-0 mt-0 full-width\"><label>{{vm.PriceType}}</label><input type=\"text\" name=\"product_name\" \nng-model=\"vm.customDiscount.dicount_price\" required readonly=\"readonly\"> <span class=\"info-note\">\nDiscount will be applied per night in case of timebound product.</span></md-input-container></div><div flex=\"40\" \nlayout=\"column\" class=\"typetxt\" layout-align=\"start end\"><div \nclass=\"btn-dollerandpercent btn-dollerandpercent-discount\"><md-button \nng-class=\"vm.discountPriceType == \'amount\'?\'md-button ng-scope md-ink-ripple md-raised md-primary submit-button white-fg font_size_20\':\'md-button md-raised font_size_20\'\" \nng-click=\"vm.customAmountType(\'amount\')\">$</md-button><md-button \nng-class=\"vm.discountPriceType == \'percentage\'?\'md-button ng-scope md-ink-ripple md-raised md-primary submit-button white-fg font_size_20\':\'md-button md-raised font_size_20\'\" \nng-click=\"vm.customAmountType(\'percentage\')\">%</md-button></div></div></div><div flex=\"100\" layout=\"row\"><div \nflex=\"100\" layout=\"column\" class=\"typetxt\" layout-align=\"center start\"></div></div></div><div layout=\"row\" \nlayout-align=\"end end\" flex=\"100\" ng-if=\"vm.popUpType == \'overAllDiscount\'\"><div flex=\"100\" layout=\"column\" \nclass=\"typetxt\" layout-align=\"start end\"><div class=\"btn-dollerandpercent btn-dollerandpercent-discount full-width\" \nflex=\"100\" layout=\"row\"><md-button flex=\"{{vm.discountAdded?\'50\':\'100\'}}\" layout=\"column\" type=\"submit\" \nng-click=\"vm.addCustomDiscount(\'add\')\" \nng-class=\"customDiscount.$invalid || customDiscount.$pristine?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg floatRight\'\" \nng-disabled=\"!vm.customDiscount.dicount_price\" aria-label=\"SAVE\" class=\"button-savecalcle\">Apply</md-button><md-button \nflex=\"50\" layout=\"column\" type=\"submit\" ng-click=\"vm.addCustomDiscount(\'remove\')\" \nclass=\"md-raised md-red-500-bg submit-button white-fg button-savecalcle\" aria-label=\"SAVE\" ng-if=\"vm.discountAdded\">\nRemove</md-button></div></div></div><div class=\"btns-blockdl\"><div class=\"dl-block-row\" flex=\"100\" layout=\"row\" \nng-repeat=\"n in [] | range:3\"><div class=\"dl-block-num onlycursorPointer\" flex=\"33\" layout=\"column\" \nlayout-align=\"center center\" ng-repeat=\"m in [] | range:3\" ng-init=\"number = vm.getNumber(vm.number)\" \nng-click=\"vm.UpdateInputBox(number)\">{{number}}</div></div><div class=\"dl-block-row\" flex=\"100\" layout=\"row\"><div \nclass=\"dl-block-num onlycursorPointer\" flex=\"33\" layout=\"column\" layout-align=\"center center\" \nng-click=\"vm.UpdateInputBox(-1)\"><md-icon md-svg-src=\"assets/icons/backspace.svg\"></md-icon></div><div \nclass=\"dl-block-num onlycursorPointer\" flex=\"33\" layout=\"column\" layout-align=\"center center\" \nng-click=\"vm.UpdateInputBox(0)\">0</div><div class=\"dl-block-num onlycursorPointer\" flex=\"33\" layout=\"column\" \nlayout-align=\"center center\" ng-click=\"vm.UpdateInputBox(\'00\')\">00</div></div></div></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/apps/checkout/dialog/posProduct.html","<md-dialog class=\"contact-dialog\" ng-class=\"vm.showRestaurantAttributes ? \'restaurant-dialog\' : \'\'\" \naria-label=\"New Task\"><form name=\"posProduct\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-tall white-fg\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \nng-if=\"vm.product.dynamic_attribute==0 && !vm.product.restaurant_attributes\">Select Date Range</span> <span \nclass=\"title\" ng-if=\"vm.product.dynamic_attribute==1\">Fill Necessary Details</span> <span class=\"title\" \nng-if=\"vm.product.restaurant_attributes && vm.product.dynamic_attribute!=1\" layout=\"column\" layout-align=\"start start\">\n{{vm.product.product_name}}</span><div layout=\"column\" layout-align=\"end center\"><div><div class=\"item-blocks\" \nng-if=\"vm.product.restaurant_attributes && vm.product.dynamic_attribute!=1\"><div><div class=\"switchclassblk\"><div \nclass=\"onoffswitch\"><input type=\"checkbox\" name=\"onoffswitch\" ng-model=\"vm.orderTakeOrEat\" \nclass=\"onoffswitch-checkbox\" id=\"myonoffswitch\" checked=\"checked\"><label class=\"onoffswitch-label\" for=\"myonoffswitch\">\n<span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div><div \nclass=\"plus-minus-item\"><i class=\"icon-minus-circle-outline\" ng-click=\"vm.changeMainQuantity(\'subtract\')\"></i> <span>\n{{vm.resQuantity}}</span><i class=\"icon-plus-circle-outline\" ng-click=\"vm.changeMainQuantity(\'add\')\"></i></div><span>\n{{vm.product.product_price | currency:$:2}}</span></div></div><md-button style=\"margin-right:0px\" \nlayout-align=\"end center\" class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon>\n</md-button></div></div></div></md-toolbar><md-dialog-content ms-scroll style=\"max-width:100%;max-height:65vh\" \nng-class=\"vm.showRestaurantAttributes?\'posproduct\':\'\'\"><div layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.product.product_is_timebound == 1\"><div layout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label role=\"button\">From</label><md-datepicker \nclass=\"birthday-input1 no-padding\" ng-change=\"vm.updateDateValidation()\" ng-model=\"vm.posProduct.from\" \nmd-open-on-focus ng-model-options=\"{debounce: 500}\" required></md-datepicker></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><md-input-container class=\"md-block md-datepicker mb-0\" flex-gt-xs=\"100\" \ndata-ng-animate=\"1\"><label role=\"button\">To</label><md-datepicker class=\"birthday-input1 no-padding\" \nmd-min-date=\"vm.fromMinDate\" ng-model=\"vm.posProduct.to\" md-open-on-focus ng-model-options=\"{debounce: 500}\" required>\n</md-datepicker></md-input-container></div></div><div \nng-if=\"vm.product.dynamic_attribute == 1 && vm.product.dynamic_attributes.length > 0\"><div layout=\"row\" flex=\"100\" \nlayout-wrap><div layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" ng-repeat=\"(key, value) in vm.product.dynamic_attributes\" \nclass=\"padding-left-15\"><md-input-container class=\"md-block md-datepicker mb-0\" flex-gt-xs=\"100\" data-ng-animate=\"1\" \nng-if=\"vm.product.dynamic_attributes[key].type==\'date\'\"><label role=\"button\">\n{{vm.product.dynamic_attributes[key].field}}</label><md-datepicker style=\"width:100% !important\" \nmd-hide-icons=\"calendar\" class=\"birthday-input1 no-padding customdatepcker noicondatepicker\" \nng-model=\"vm.product.dynamic_attributes[key].value\" md-open-on-focus ng-model-options=\"{debounce: 500}\" required>\n</md-datepicker></md-input-container><md-input-container ng-if=\"vm.product.dynamic_attributes[key].type==\'number\'\" \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label role=\"button\">\n{{vm.product.dynamic_attributes[key].field}}</label><input required type=\"number\" name=\"field\" \nng-model=\"vm.product.dynamic_attributes[key].value\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container><md-input-container ng-if=\"vm.product.dynamic_attributes[key].type==\'text\'\" \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label role=\"button\">\n{{vm.product.dynamic_attributes[key].field}}</label><input required type=\"text\" name=\"field\" \nng-model=\"vm.product.dynamic_attributes[key].value\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div></div></div><div ng-if=\"vm.showRestaurantAttributes\" class=\"ingradient-heightblk\"><div \nclass=\"ingradientextrablock\" layout=\"row\"><div layout=\"column\" flex=\"60\" class=\"restaurant_pos_left\"><div \nclass=\"restaurant-col\" layout=\"row\" flex=\"100\" layout-align=\"start stretch\" layout-wrap><div class=\"restaurant-top\" \nlayout=\"column\" flex=\"100\" layout-align=\"start start\" ms-scroll><div class=\"ingradientblock\"><div \nclass=\"ingradientblock-inner\"><h2>Ingredients</h2><div class=\"ingradientspan\"><span class=\"onlycursorPointer\" \nng-class=\"value.selected == \'1\' ? \'increg-yes\' : \'increg-no\'\" ng-repeat=\"value in vm.ingredients\" \nng-click=\"vm.updateIngredient(value, $index)\"><b class=\"normalfont\" ng-show=\"value.selected == \'1\'\">\n{{value.ingredient_name}}</b><i class=\"icon-check icon-check-main\" ng-show=\"value.selected == \'1\'\"></i> <strike \nclass=\"redstrike\" ng-show=\"value.selected != \'1\'\">{{value.ingredient_name}}</strike> <i \nclass=\"icon-close icon-close-main\" style=\"background-color:#f65a60;color:#fff\" ng-show=\"value.selected != \'1\'\"></i>\n</span></div><div class=\"select-ingradientblock mb-10\" layout=\"row\" flex=\"100\" layout-align=\"space-between start\">\n<md-input-container ng-repeat=\"(key, value) in vm.dropDownArray\" layout=\"column\" class=\"selectinputblock\"><label \nrole=\"button\">{{key}}</label><md-select ng-model=\"vm.dropDownSelect[\'val_\'+key]\" ng-change=\"vm.updateDropDowns(key)\">\n<md-option ng-repeat=\"item in value\" ng-selected=\"vm.freeSelectedIds.indexOf(item.option_id) != -1\" ng-value=\"item\">\n{{item.name}} @ ${{item.price}}</md-option></md-select></md-input-container></div><h2 ng-if=\"vm.showAddOns\">Add-ons\n</h2><div class=\"ingradientspan\" ng-repeat=\"(key, value) in vm.multiChoiceArray\"><h3>{{key}}</h3><span \nclass=\"onlycursorPointer\" ng-class=\"item.highlighted == 1 ? \'increg-yes\' : \'increg-no\'\" \nng-repeat=\"(itemkey, item) in value\" ng-click=\"vm.updateAddonList(item, $index, key)\">{{item.name}}<i \nng-if=\"item.count > 0\">{{item.count}}</i></span></div><div ng-if=\"vm.cooking_preference.length > 0\"><h2 \nclass=\"cookingheading\">Preferences</h2><div class=\"rowblockcooking mb-20 cook-restra-row\" flex layout=\"row\" flex=\"100\" \nng-repeat=\"(key, value) in vm.cooking_preference\" ng-if=\"value.cooking_preference == \'1\' || vm.pizzaCatSelected\"><div \nclass=\"rowcolcooking\" layout=\"column\" flex=\"70\" layout-align=\"center start\"><label role=\"button\">{{ value.name }}\n</label></div><div layout=\"column\" flex=\"30\" layout-align=\"end end\" ng-if=\"vm.pizzaCatSelected\"><div \nclass=\"pizatoppingblock\"><md-radio-group class=\"no-margin\" ng-model=\"vm.pizzaType[\'sel_\'+$index]\"><md-radio-button \nvalue=\"left\" class=\"restaurant-radio\" aria-label=\"Label1\"><div class=\"halfblock firsthalf onlycursorPointer\" \nng-class=\"vm.pizzaType[\'sel_\'+$index] == \'left\' ? \'active\' : \'\'\"><span></span></div></md-radio-button><md-radio-button \nvalue=\"full\" class=\"restaurant-radio\" aria-label=\"Label2\"><div class=\"halfblock fullblock onlycursorPointer\" \nng-class=\"vm.pizzaType[\'sel_\'+$index] == \'full\' ? \'active\' : \'\'\"><span></span></div></md-radio-button><md-radio-button \nvalue=\"right\" class=\"restaurant-radio\" aria-label=\"Label3\"><div class=\"halfblock sechalf onlycursorPointer\" \nng-class=\"vm.pizzaType[\'sel_\'+$index] == \'right\' ? \'active\' : \'\'\"><span></span></div></md-radio-button>\n</md-radio-group></div></div><div class=\"rowcolcooking mb-0 mt-0\" layout=\"column\" flex=\"30\" layout-align=\"end end\" \nng-if=\"!vm.pizzaCatSelected\"><md-input-container class=\"mb-0 mt-0\" ng-if=\"value.cooking_preference == \'1\'\"><md-select \nclass=\"no-margin\" ng-model=\"vm.cooking_preference[$index].selected_preference\" placeholder=\"Select cooking preference\">\n<md-option ng-repeat=\"cpo in vm.cooking_preference_options\" ng-value=\"cpo.value\">{{ cpo.name }}</md-option></md-select>\n</md-input-container></div></div></div></div></div></div><div class=\"restaurant-note\" layout=\"column\" flex=\"100\" \nlayout-align=\"center start\"><textarea ng-model=\"vm.restaurantNote\" placeholder=\"Add Note\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></textarea></div></div></div><div layout=\"column\" flex=\"40\" class=\"restaurant_pos_right\"><div \nclass=\"col-res-pos\" layout=\"row\" flex=\"100\" layout-align=\"start stretch\" layout-wrap><div class=\"top-content-extra\" \nlayout=\"column\" flex=\"100\" ms-scroll><div class=\"block-extra-content\"><h2>Add-ons</h2><div class=\"gradientlist-repeat\">\n<div class=\"gradientlist-row\" layout=\"row\" flex=\"100\" layout-align=\"start center\" \nng-if=\"vm.selectedOptions.length || vm.freeOptions.length\"><div class=\"gradientlist-col pr-10\" flex=\"50\" \nlayout=\"column\" layout-align=\"start start\"><p>Name</p></div><div class=\"gradientlist-col pr-10\" flex=\"20\" \nlayout=\"column\" layout-align=\"center centre\"><p class=\"qtycenter\">Qty</p></div><div class=\"gradientlist-col\" flex=\"30\" \nlayout=\"column\" layout-align=\"center centre\"><div class=\"textgradient\" style=\"text-align:center\"><span>Price</span>\n</div></div></div><div class=\"gradientlist-row\" layout=\"row\" flex=\"100\" layout-align=\"start center\" \nng-repeat=\"item in vm.selectedOptions\"><div class=\"gradientlist-col pr-10\" flex=\"50\" layout=\"column\" \nlayout-align=\"start start\"><p>{{item.name}} <span class=\"priceperitem\">({{item.price | currency:$:2}})</span></p></div>\n<div class=\"gradientlist-col pr-10\" flex=\"20\" layout=\"column\" layout-align=\" centre centre\"><p class=\"qtycenter\">\n{{item.quantity}}</p></div><div class=\"gradientlist-col\" flex=\"30\" layout=\"column\" layout-align=\"end end\"><div \nclass=\"textgradient\"><span>{{(item.price * item.quantity) | currency:$:2}}</span> <i \nclass=\"icon-close-circle-outline icon-close-circle-outline\" \nng-click=\"vm.addRemove(item,\'remove\', vm.selectedOptionIds.indexOf(item.option_id))\"></i></div></div></div><div \nclass=\"gradientlist-row\" layout=\"row\" flex=\"100\" layout-align=\"start center\" layout-wrap \nng-repeat=\"item in vm.freeOptions\"><div class=\"gradientlist-col pr-10\" flex=\"50\" layout=\"column\" \nlayout-align=\"start start\"><p>{{item.name}} <span class=\"priceperitem\">( {{item.price | currency:$:2}} )</span></p>\n</div><div class=\"gradientlist-col pr-10\" flex=\"20\" layout=\"column\" layout-align=\" centre centre\"><p class=\"qtycenter\">\n1</p></div><div class=\"gradientlist-col\" flex=\"30\" layout=\"column\" layout-align=\"end end\"><div class=\"textgradient\">\n<span>{{ 0 | currency:$:2}}</span> <i class=\"icon-close-circle-outline icon-close-circle-outline\" \nng-click=\"vm.addRemove(item,\'remove\', vm.selectedOptionIds.indexOf(item.option_id))\"></i></div></div></div><div \nclass=\"gradientlist-row\" layout=\"row\" flex=\"100\" layout-align=\"start center\" layout-wrap \nng-if=\"!vm.selectedOptions.length && !vm.freeOptions.length\"><div class=\"gradientlist-col pr-10\" flex=\"50\" \nlayout=\"column\" layout-align=\"start start\"><p>No Add-on available</p></div></div></div></div></div><div \nclass=\"bottom-content-extra\" layout=\"column\" layout-align=\"end start\" flex=\"100\"><div class=\"bottomblk\" layout=\"row\" \nlayout-align=\"start center\" flex=\"100\"><span layout=\"column\" layout-align=\"start start\" flex=\"50\">Total</span> <span \nlayout=\"column\" flex=\"50\" layout-align=\"center end\">{{vm.grandtotal | currency:$:2}}</span></div></div></div></div>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end end\" flex=\"100\" ng-if=\"!vm.showRestaurantAttributes\"><md-button type=\"submit\" \nng-click=\"vm.addTimeBoundProduct()\" \nng-class=\"posProduct.$invalid?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"posProduct.$invalid\" aria-label=\"Continue\" translate=\"Continue\" layout=\"column\"></md-button></div><div \nlayout=\"row\" layout-align=\"end end\" flex=\"100\" ng-if=\"vm.showRestaurantAttributes\"><md-button type=\"submit\" \nng-click=\"vm.getRestaurantAttributes()\" \nng-class=\"posProduct.$invalid?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"posProduct.$invalid\" aria-label=\"Continue\" translate=\"Continue\" layout=\"column\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/checkout/dialog/posProduct_backup.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"posProduct\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" ng-if=\"vm.product.dynamic_attribute==0 && !vm.product.restaurant_attributes\">Select Date Range</span> \n<span class=\"title\" ng-if=\"vm.product.dynamic_attribute==1\">Fill Necessary Details</span> <span class=\"title\" \nng-if=\"vm.product.restaurant_attributes && vm.product.dynamic_attribute!=1\">Choose From Available Options</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll style=\"max-width:800px;max-height:1000px\"><div \nlayout=\"row\" flex=\"100\" layout-wrap ng-if=\"vm.product.product_is_timebound == 1\"><div layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\"><md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label role=\"button\">From\n</label><md-datepicker class=\"birthday-input1 no-padding\" ng-change=\"vm.updateDateValidation()\" \nng-model=\"vm.posProduct.from\" md-open-on-focus ng-model-options=\"{debounce: 500}\" required></md-datepicker>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" flex-gt-xs=\"100\" data-ng-animate=\"1\"><label role=\"button\">To</label><md-datepicker \nclass=\"birthday-input1 no-padding\" md-min-date=\"vm.fromMinDate\" ng-model=\"vm.posProduct.to\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" required></md-datepicker></md-input-container></div></div><div \nng-if=\"vm.product.dynamic_attribute == 1 && vm.product.dynamic_attributes.length > 0\"><div layout=\"row\" flex=\"100\" \nlayout-wrap><div layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" ng-repeat=\"(key, value) in vm.product.dynamic_attributes\" \nclass=\"padding-left-15\"><md-input-container class=\"md-block md-datepicker mb-0\" flex-gt-xs=\"100\" data-ng-animate=\"1\" \nng-if=\"vm.product.dynamic_attributes[key].type==\'date\'\"><label role=\"button\">\n{{vm.product.dynamic_attributes[key].field}}</label><md-datepicker style=\"width:100% !important\" \nmd-hide-icons=\"calendar\" class=\"birthday-input1 no-padding customdatepcker noicondatepicker\" \nng-model=\"vm.product.dynamic_attributes[key].value\" md-open-on-focus ng-model-options=\"{debounce: 500}\" required>\n</md-datepicker>{{vm.product.dynamic_attributes[key].value}}</md-input-container><md-input-container \nng-if=\"vm.product.dynamic_attributes[key].type==\'number\'\" class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\">\n<label role=\"button\">{{vm.product.dynamic_attributes[key].field}}</label><input required type=\"number\" name=\"field\" \nng-model=\"vm.product.dynamic_attributes[key].value\"></md-input-container><md-input-container \nng-if=\"vm.product.dynamic_attributes[key].type==\'text\'\" class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label \nrole=\"button\">{{vm.product.dynamic_attributes[key].field}}</label><input required type=\"text\" name=\"field\" \nng-model=\"vm.product.dynamic_attributes[key].value\"></md-input-container></div></div></div><div \nng-if=\"vm.showRestaurantAttributes\"><div class=\"full-width full-height\" layout=\"row\" flex=\"100\" layout-wrap><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"55\" class=\"order-res1\"><div \nclass=\"full-height block-form-seach-main md-whiteframe-1dp\"><div \nclass=\"row-blk-icon white-bg md-whiteframe-1dp order-tital\" layout=\"row\" layout-wrap flex=\"100\" \nlayout-align=\"center center\">Product Details.</div><div class=\"md-list-scrollblock\"><div class=\"md-listrepeat\"><div \nlayout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" class=\"padding-left-15\">\n<md-input-container class=\"no-margin ph-20\" ng-repeat=\"(key, value) in vm.dropDownArray\"><label role=\"button\">{{key}}\n</label><md-select multiple=\"multiple\" ng-model=\"vm.freeOptions\" required ng-change=\"vm.updateAddonList(\'\')\"><md-option\n ng-repeat=\"item in value\" ng-selected=\"vm.freeSelectedIds.indexOf(item.option_id) != -1\" ng-value=\"item\">\n{{item.name}} @ ${{item.price}}</md-option></md-select><br></md-input-container><md-input-container \nclass=\"no-margin ph-20\" ng-repeat=\"value in vm.ingredients\"><p><span style=\"background-color: green\">\n{{value.ingredient_name}} </span><span ng-show=\"!vm.checkingrediantStatus(value.ingredient_id)\" \nng-click=\"vm.updateIngredient(value.ingredient_id)\">X</span> <span \nng-show=\"vm.checkingrediantStatus(value.ingredient_id)\" ng-click=\"vm.updateIngredient(value.ingredient_id)\">Y</span>\n</p></md-input-container><md-input-container class=\"no-margin ph-20\" ng-repeat=\"(key, value) in vm.multiChoiceArray\">\n<label role=\"button\">{{key}}</label><div><p ng-repeat=\"item in value\" ng-click=\"vm.updateAddonList(item)\">\n{{item.name}} @ ${{item.price}}</p></div></md-input-container></div></div></div></div></div></div><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"45\" class=\"full-height bgf1\"><div class=\"full-height\"><div \nclass=\"row-blk-icon white-bg md-whiteframe-1dp order-tital\" layout=\"row\" layout-wrap flex=\"100\" \nlayout-align=\"start start\"><div class=\"orderpriceblkouter\" flex=\"100\" layout=\"row\" layout-align=\"center center\"><span \nclass=\"confirmnoblk smtxt\" layout=\"column\">{{vm.note}}</span><h2 layout=\"column\">{{vm.overallTotals.gt | currency:$:2}}\n</h2></div></div><div class=\"orderscrollblk relative-block\"><div class=\"order-contentfullblk\"><div \nclass=\"hor-scroll table-responsive\"><table cellspacing=\"0\" class=\"table data order-tables\"><thead><tr \nclass=\"theadings\"><th>Name</th><th>Price</th><th class=\"a-center\">Qty</th><th class=\"last\"><span class=\"nobr\">Subtotal\n</span></th></tr></thead><tr class=\"fist even\" ng-repeat=\"item in vm.freeOptions\"><td>{{item.name}}</td><td>\n{{item.price}}</td><td>1</td><td>{{ 0 | currency:$:2}}</td></tr><tr class=\"fist even\" \nng-repeat=\"item in vm.selectedOptions\"><td ng-click=\"vm.updateQuantity(\'add\',item.option_id)\">{{item.name}}</td><td \nng-click=\"vm.updateQuantity(\'subtract\',item.option_id)\">{{item.price}}</td><td>{{item.quantity}}</td><td \nng-click=\"vm.addRemove(item,\'remove\', vm.selectedOptionIds.indexOf(item.option_id))\">\n{{ (item.price * item.quantity) | currency:$:2}}</td></tr></table></div></div></div><div class=\"order-contentfullblk\">\n<div class=\"hor-scroll table-responsive subtotal\"><table cellspacing=\"0\" class=\"table data order-tables\"><tr><td \nclass=\"sub1\">Quantity</td><td class=\"sub2\"><input type=\"number\" ng-model=\"vm.resQuantity\" name=\"quantity\" \nng-blur=\"vm.calculateTotal()\" min=\"1\"></td></tr><tr><td class=\"sub1\">Extra Addon Subtotal</td><td class=\"sub2\">\n{{vm.extraAddon | currency:$:2}}</td></tr><tr><td class=\"sub1\">Product Price</td><td class=\"sub2\">\n{{vm.product[\'product_price\'] | currency:$:2}}</td></tr><tr><td class=\"sub1\">Grand Total</td><td class=\"sub2\">\n{{vm.grandtotal | currency:$:2}}</td></tr></table></div></div></div></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" \nflex=\"100\" ng-if=\"!vm.showRestaurantAttributes\"><md-button type=\"submit\" ng-click=\"vm.addTimeBoundProduct()\" \nng-class=\"posProduct.$invalid?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"posProduct.$invalid\" aria-label=\"Continue\" translate=\"Continue\" layout=\"column\"></md-button></div><div \nlayout=\"row\" layout-align=\"end end\" flex=\"100\" ng-if=\"vm.showRestaurantAttributes\"><md-button type=\"submit\" \nng-click=\"vm.getRestaurantAttributes()\" \nng-class=\"posProduct.$invalid?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"posProduct.$invalid\" aria-label=\"Continue\" translate=\"Continue\" layout=\"column\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/checkout/dialog/sendEmailInput.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"mailForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Send Email</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll style=\"max-width:800px;max-height:1000px\"><div \nclass=\"white-bg ph-20 pt-10 pb-10\"><md-input-container class=\"md-block mb-0\"><label>Email Address</label><input \ntype=\"text\" ng-model=\"email_id\" ng-pattern=\"/^.+@.+\\..+$/\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" ng-click=\"sendEmailToCustomer()\" \nng-class=\"mailForm.$invalid || mailForm.$pristine || vm.note.length == 0?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"mailForm.$invalid || mailForm.$pristine || vm.note.length == 0\" aria-label=\"SAVE\" layout=\"column\">Send\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/checkout/dialog/tabOrderName.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"noteForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Tab Note</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll style=\"max-width:800px;max-height:1000px\"><div \nclass=\"white-bg ph-20 pt-10 pb-10\"><md-input-container class=\"md-block mb-0\"><label>Name</label><textarea \nng-model=\"vm.tabName\" rows=\"1\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></textarea></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" ng-click=\"vm.getTabOrderName()\" \nng-class=\"noteForm.$invalid || noteForm.$pristine || vm.tabName.length === 0?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"noteForm.$invalid || noteForm.$pristine || vm.tabName.length == 0\" aria-label=\"SAVE\" \ntranslate=\"GROUPS.SAVE\" layout=\"column\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/checkout/dialog/updateCartProduct.html","<md-dialog \nng-class=\"vm.productData.product_is_timebound == 1?\'product-dialog productdataupdate datePickerClass\':\'product-dialog productdataupdate\'\" \naria-label=\"New Task\"><form name=\"mlsForm\" class=\"md-inline-form\" novalidate><md-dialog-content ms-scroll>\n<md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><div \nclass=\"first-dilog-content\"><div><div class=\"floarRight closeEditDlg\" ng-click=\"vm.closeModal(\'positive\')\" \nng-if=\"vm.popUpType == \'quantity\'\">X</div><div class=\"listimg1\" layout-align=\"center start\"><div \nclass=\"img-block-main product-img-name height-190 ph-10\"><img \nsrc=\"{{vm.baseUrl+\'assets/uploads/activities/thumbnail/\'+vm.productData.media}}\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\"></div><div class=\"product-img-name pb-20 pt-5\">\n{{vm.productData.product_name}}</div></div><md-input-container \nng-if=\"vm.productData.product_is_timebound == 0 && vm.showQuantity\" \nclass=\"md-block md-datepicker no-margin date-picker-calc\" data-ng-animate=\"1\"><md-button \nclass=\"md-raised md-primary no-margin plus-btn\" ng-click=\"vm.updateQuantity(\'negative\')\">-</md-button><input \ntype=\"number\" name=\"quantity\" ng-model=\"vm.quantity\" min=\"1\" ng-change=\"vm.updateQuantity(\'text\')\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><md-button class=\"md-raised md-primary no-margin minus-btn\" \nng-click=\"vm.updateQuantity(\'positive\')\">+</md-button></md-input-container><div layout=\"row\" flex=\"100\" \nclass=\"date-picker-outer\" ng-if=\"vm.productData.product_is_timebound == 1 && !vm.showRestaurantAttributes\">\n<md-input-container class=\"md-block md-datepicker no-margin\" data-ng-animate=\"1\" layout=\"column\" flex=\"45\"><label>From\n</label><md-datepicker class=\"birthday-input no-padding\" md-hide-icons=\"calendar\" ng-model=\"vm.posProduct.from\" \nmd-open-on-focus ng-model-options=\"{debounce: 500}\" ng-change=\"vm.updateDate()\" required></md-datepicker>\n</md-input-container><div flex=\"10\"></div><md-input-container class=\"md-block md-datepicker no-margin\" \nflex-gt-xs=\"100\" data-ng-animate=\"1\" layout=\"column\" flex=\"45\" layout-align=\"center end\"><label>To</label>\n<md-datepicker class=\"birthday-input no-padding\" md-hide-icons=\"calendar\" ng-model=\"vm.posProduct.to\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" ng-change=\"vm.updateDate()\" required></md-datepicker></md-input-container></div><div\n ng-if=\"vm.productData.dynamic_attribute == 1 && vm.productData.dynamic_attributes.length > 0\" class=\"extrafieldsmain\">\n<div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"50\" class=\"ph-10\" \nng-repeat=\"(key, value) in vm.productData.dynamic_attributes\"><div><md-datepicker name=\"field\" \nng-if=\"vm.productData.dynamic_attributes[key].type==\'date\'\" class=\"datepickerbtnmain birthday-input1 no-padding\" \nng-model=\"vm.productData.dynamic_attributes[key].value\" md-open-on-focus ng-model-options=\"{debounce: 500}\" required>\n</md-datepicker><md-input-container ng-if=\"vm.productData.dynamic_attributes[key].type==\'number\'\" \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label role=\"button\">\n{{vm.productData.dynamic_attributes[key].field}}</label><input required type=\"number\" name=\"field\" \nng-model=\"vm.productData.dynamic_attributes[key].value\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container><md-input-container ng-if=\"vm.productData.dynamic_attributes[key].type==\'text\'\" \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label role=\"button\">\n{{vm.productData.dynamic_attributes[key].field}}</label><input required type=\"text\" name=\"field\" \nng-model=\"vm.productData.dynamic_attributes[key].value\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div></div></div></div><div ng-if=\"vm.showRestaurantAttributes\"><div layout=\"row\" flex=\"100\" \nlayout-wrap><div layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" class=\"padding-left-15\"><md-input-container \nclass=\"no-margin ph-20\" ng-repeat=\"(key, value) in vm.dropDownArray\"><label role=\"button\">{{key}}</label><md-select \nng-model=\"vm.restaurant_selected_attributes[key]\" required><md-option ng-repeat=\"item in value\" \nng-selected=\"vm.productData.selectedOptions.indexOf(item.option_id) !== -1\" ng-value=\"item\">\n{{item.name}} @ ${{item.price}}</md-option></md-select><br></md-input-container><md-input-container \nclass=\"no-margin ph-20\" ng-repeat=\"(key, value) in vm.multiChoiceArray\"><label role=\"button\">{{key}}</label><md-select \nmultiple=\"multiple\" ng-model=\"vm.restaurant_selected_attributes[key]\" required><md-option ng-value=\"item\" \nng-repeat=\"item in value\" ng-selected=\"vm.productData.selectedOptions.indexOf(item.option_id) !== -1\">\n{{item.name}} @ ${{item.price}}</md-option></md-select><br></md-input-container></div></div></div><div \nclass=\"md-block no-margin btn-discount-blk\" data-ng-animate=\"1\" layout=\"row\" flex=\"100\"><md-button layout=\"column\" \nflex=\"50\" class=\"md-button md-accent-bg white-fg custom-price no-margin\" \nng-click=\"vm.changePopUpContent(\'customPrice\')\" ng-if=\"!vm.showRestaurantAttributes\">Custom Price</md-button><md-button\n layout=\"column\" flex=\"50\" class=\"md-button red-A800-bg white-fg discount no-margin\" \nng-click=\"vm.changePopUpContent(\'discount\')\">Discount</md-button></div></div><div class=\"custom-price-block\"><span>\n{{vm.popUpType == \'customPrice\'? vm.popUpType == \'discount\'?\'Discount\':\'\': \'Custom Price\'}}</span> <span \nclass=\"pricetxt\">${{(vm.productData.customPrice | number:2)}}<md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"pricetxt-right\"></md-icon></span></div></div><div class=\"toggleProductUpdatebefore\" \nng-class=\"vm.popUpType == \'customPrice\' || vm.popUpType == \'discount\'?\'toggleProductUpdate\':\'\'\"><div \nclass=\"header-blockupdate md-accent-bg white-fg padding-15\" flex=\"100\" layout=\"row\" layout-wrap><md-icon flex=\"15\" \nlayout=\"column\" layout-align=\"center start\" md-font-icon=\"icon-keyboard-backspace\" \nclass=\"back-btn white-fg onlycursorPointer\" ng-if=\"vm.popUpType != \'quantity\'\" ng-click=\"vm.goToquantity()\"></md-icon>\n<span flex=\"70\" layout=\"column\" layout-align=\"center center\" ng-if=\"vm.popUpType == \'customPrice\'\">Custom Price</span> \n<span flex=\"70\" layout=\"column\" layout-align=\"center center\" ng-if=\"vm.popUpType != \'customPrice\'\">\nDiscount {{ vm.productData[\'product_is_timebound\'] == 1?\'(per night)\':\'\'}}</span><md-icon flex=\"15\" \nlayout-align=\"center end\" layout=\"column\" md-font-icon=\"icon-check\" class=\"done-btn white-fg onlycursorPointer\" \nng-if=\"vm.popUpType != \'quantity\'\" ng-click=\"vm.updateCustomPrice()\"></md-icon></div><div \nclass=\"input-type-block ph-15 pt-30\"><div flex=\"100\" layout=\"row pt-15\"><div flex=\"60\" layout=\"column\" class=\"typetxt\" \nlayout-align=\"center start\"><md-input-container class=\"md-block mb-0 mt-0\"><label>Type</label><input type=\"text\" \nname=\"customPrice\" ng-model=\"vm.customPrice\" ng-if=\"vm.popUpType == \'customPrice\'\" min=\"0\" allow-decimal-numbers \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"> <input type=\"text\" name=\"customDiscount\" \nng-if=\"vm.popUpType == \'discount\'\" ng-model=\"vm.customDiscount\" min=\"0\" allow-decimal-numbers \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div><div flex=\"40\" layout=\"column\" \nclass=\"typetxt\" layout-align=\"start end\"><div class=\"btn-dollerandpercent\"><md-button \nng-class=\"vm.priceType == \'amount\'?\'md-button ng-scope md-ink-ripple md-raised md-primary submit-button white-fg\':\'md-button md-raised\'\" \nng-click=\"vm.customAmountType(\'amount\')\">$</md-button><md-button \nng-class=\"vm.priceType == \'percentage\'?\'md-button ng-scope md-ink-ripple md-raised md-primary submit-button white-fg\':\'md-button md-raised\'\" \nng-click=\"vm.customAmountType(\'percentage\')\">%</md-button></div></div></div><div flex=\"100\" layout=\"row\"><div \nflex=\"100\" layout=\"column\" class=\"typetxt\" layout-align=\"center start\"></div></div></div><div \nclass=\"btns-blockdl fix-bottom\"><div class=\"dl-block-row\" flex=\"100\" layout=\"row\" ng-repeat=\"n in [] | range:3\"><div \nclass=\"dl-block-num onlycursorPointer\" flex=\"33\" layout=\"column\" layout-align=\"center center\" \nng-repeat=\"m in [] | range:3\" ng-init=\"number = vm.getNumber(vm.number)\" ng-click=\"vm.UpdateInputBox(number)\">\n{{number}}</div></div><div class=\"dl-block-row\" flex=\"100\" layout=\"row\"><div class=\"dl-block-num onlycursorPointer\" \nflex=\"33\" layout=\"column\" layout-align=\"center center\" ng-click=\"vm.UpdateInputBox(-1)\"><md-icon \nmd-svg-src=\"assets/icons/backspace.svg\"></md-icon></div><div class=\"dl-block-num onlycursorPointer\" flex=\"33\" \nlayout=\"column\" layout-align=\"center center\" ng-click=\"vm.UpdateInputBox(0)\">0</div><div \nclass=\"dl-block-num onlycursorPointer\" flex=\"33\" layout=\"column\" layout-align=\"center center\" \nng-click=\"vm.UpdateInputBox(\'00\')\">00</div></div></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/checkout/posorders/posorders.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar-text\"></md-icon><span \ntranslate=\"CHECKOUT.ORDERS\"></span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"CHECKOUT.TOTAL_ORDERS\"></span> <span>{{vm.totalReservations}}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{ \'SEARCH\' | translate }}\" ng-model=\"filterText\" flex></div></div></div></div></div><div class=\"content\">\n<div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main RowClick\" ms-scroll><mdt-table \ntable-card=\"{visible: true, title: \'Customers\', columnSelector: true}\" \npaginated-rows=\"{isEnabled: true,rowsPerPageValues: [20,50]}\" selectable-rows=\"vm.canDelete\" \nselected-row-callback=\"selectedRowCallback(rows)\" mdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" \ndelete-row-callback=\"deleteSelectedItem()\" \nmdt-row-paginator-error-message=\"Error happened during loading reservations.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n					\'table-row-id-key\': \'confirmation_number\',\n					\'column-keys\': [\'itinerary_number\', \n									\'product_name\', \n									\'created_date\', \n									\'customer_name\', \n									\'grand_total\', \n									\'created_by_user\', \n									\'editId\' ]}\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>{{ \'EC.ITIN\' | translate }}</h5></mdt-column>\n<mdt-column align-rule=\"left\" column-sort=\"true\"><h5>{{ \'EC.PROD\' | translate }}</h5></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\" \ncolumn-filter=\"{\'valuesProviderCallback\': createdValuesCallback,\'valuesTransformerCallback\': statusValuesTransformer,\'placeholderText\': \'Select date\',\'filterType\': \'checkbox\'}\">\n<h5>{{ \'EC.CREATED\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\n{{ \'EC.CUSTOMER\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\n{{ \'EC.TOTAL\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\n{{ \'EC.BYUSER\' | translate }}</h5></mdt-column><mdt-column align-rule=\"right\" class=\"action-right-icons\"><h5></h5>\n</mdt-column></mdt-header-row><mdt-custom-cell html-content=\"true\" column-key=\"editId\"><a style=\"cursor:pointer\" \nng-click=\"clientScope.goToEditPage(value)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s16 ng-scope md-default-theme md-font material-icons icon-pencil\" role=\"img\" aria-label=\"icon-cog\"></md-icon>\n</a></mdt-custom-cell></mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/checkout/reports/reports.html","<div id=\"tab-order\" class=\"page-layout simple fullwidth tabbed md-datepicker doc-page\" layout=\"column\"><div \nclass=\"header md-accent-bg relative-block\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><div layout=\"column\" flex=\"50\"><div layout=\"row\"><md-button \nclass=\"goto-products-button md-icon-button\" ng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-chart-areaspline\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div class=\"h2\">Reports</div></div></div></div>\n</div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\" class=\"headerstickyProgress\">\n</md-progress-linear></div><div class=\"content\"><div class=\"simple-table-container\"><div class=\"table-title\">\nFood & Drinks</div><div class=\"full-width\" layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"100\" class=\"full-height\">\n<div class=\"\"><div class=\"ph-20 pb-20\" layout=\"row\" layout-wrap flex=\"100\" layout-align=\"start center\"><div \nlayout=\"column\" flex=\"100\"><div layout=\"row\" layout-wrap flex=\"100\" layout-align=\"start center\"><div layout=\"column\" \nflex=\"{{ (vm.reportType == \'n\') ? 50 : 25 }}\" class=\"pr-10\"><md-input-container class=\"md-block mt-15 mb-0\" \ndata-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Cashier</label><md-select ng-model=\"vm.userId\"><md-option \nvalue=\"0\">All</md-option><md-option ng-repeat=\"user in vm.allUsers\" ng-value=\"user.user_id\">\n{{user.first_name+\' \'+user.last_name}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container>\n</div><div layout=\"column\" flex=\"{{ (vm.reportType == \'n\') ? 50 : 25 }}\" class=\"pr-10\"><md-input-container \nclass=\"md-block mt-15 mb-0\" data-ng-animate=\"1\"><md-select ng-model=\"vm.reportType\" \nng-change=\"vm.waitForRefreshButton()\"><md-option ng-repeat=\"reportType in vm.reportTypeArray\" \nng-value=\"reportType.value\">{{reportType.name}}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div layout=\"column\" flex=\"25\" ng-if=\"vm.reportType != \'n\'\"><md-input-container \nclass=\"md-block md-datepicker mb-0 mt-15\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\" \nng-if=\"vm.reportType == \'x\' || vm.reportType == \'z\'\">Report Date</label><label class=\"ng-scope\" role=\"button\" \nng-if=\"vm.reportType != \'x\' && vm.reportType != \'z\'\">Start Date</label><md-datepicker \nclass=\"birthday-input1 no-padding\" ng-model=\"vm.startDate\" md-open-on-focus ng-model-options=\"{debounce: 300}\" \nrequired ng-change=\"vm.onChangeDate()\" md-max-date=\"vm.today\"></md-datepicker></md-input-container></div><div \nlayout=\"column\" flex=\"25\" ng-if=\"vm.reportType == \'sales\' || vm.reportType == \'tip\' || vm.reportType == \'daily\'\">\n<md-input-container class=\"md-block md-datepicker mb-0 mt-15\" data-ng-animate=\"1\"><label class=\"ng-scope\" \nrole=\"button\">End Date</label><md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.endDate\" \nmd-min-date=\"vm.startDate\" md-open-on-focus ng-model-options=\"{debounce: 300}\" required ng-change=\"vm.onChangeDate()\" \nmd-max-date=\"vm.today\"></md-datepicker></md-input-container></div></div></div><div layout=\"row\" flex=\"100\" \nclass=\"ph-10 pt-0\" layout-wrap layout-align=\"end center\"><md-button ng-if=\"vm.reportType != \'sales\'\" \nclass=\"md-raised md-cornered\" ng-click=\"vm.getReport()\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh</md-button><md-button \nng-if=\"vm.reportType == \'sales\'\" class=\"md-raised md-cornered\" ng-click=\"vm.getSalesReport()\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh</md-button><div \nng-if=\"vm.reportType == \'sales\' && vm.salesReport.length > 0\" class=\"mv-5\"><md-button class=\"md-raised md-cornered\" \nng-click=\"vm.getSalesReport()\" ng-csv=\"vm.salesReport\" csv-header=\"[\'Cashier\',\'Sales\',\'Total Order\']\" \nfilename=\"bar-sales-report.csv\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>\nExport as CSV</md-button><md-button class=\"md-raised md-cornered\" md-font-icon=\"icon-file-word\" \npdf-save-button=\"salePdf\" pdf-name=\"bar-sales-report.doc\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/word.svg\"></md-icon>Export as Word</md-button><md-button \nclass=\"md-raised md-cornered\" md-font-icon=\"icon-file-excel\" ng-click=\"vm.getSalesReport()\" ng-csv=\"vm.salesReport\" \ncsv-header=\"[\'Cashier\',\'Sales\',\'Total Order\']\" filename=\"bar-sales-report.xls\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/xls.svg\"></md-icon>Export as Excel</md-button><md-button \nclass=\"md-raised md-cornered\" md-font-icon=\"icon-file-pdf\" pdf-save-button=\"salePdf\" pdf-name=\"bar-sales-report.pdf\">\n<md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>Export as PDF</md-button></div><div \nng-if=\"vm.reportType == \'daily\' && vm.dailyreports.length > 0\" class=\"mv-5\"><md-button class=\"md-raised md-cornered\" \nng-csv=\"vm.dailyreports\" csv-header=\"[\'Order#\',\'Cashier \',\'Bill to Name\',\'Product Name\',\'Total\',\'Purchased On\']\" \nfilename=\"bar-daily-report.csv\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>\nExport as CSV</md-button><md-button class=\"md-raised md-cornered\" md-font-icon=\"icon-file-word\" \npdf-save-button=\"dailyPdf\" pdf-name=\"dailyReport.doc\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/word.svg\"></md-icon>Export as Word</md-button><md-button \nclass=\"md-raised md-cornered\" md-font-icon=\"icon-file-excel\" ng-csv=\"vm.dailyreports\" \ncsv-header=\"[\'Order#\',\'Cashier \',\'Bill to Name\',\'Product Name\',\'Total\',\'Purchased On\']\" \nfilename=\"bar-daily-reports.xls\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/xls.svg\"></md-icon>\nExport as Excel</md-button><md-button class=\"md-raised md-cornered\" md-font-icon=\"icon-file-pdf\" \nng-click=\"vm.getPdf(\'pdf\')\" ng-disabled=\"vm.requestProcessingPDF\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>Export as PDF<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessingPDF\"></md-progress-circular>\n</md-button></div><md-button class=\"md-raised md-cornered\" ng-if=\"vm.reportType == \'tip\' && (vm.tipData.length > 0 )\" \nmd-font-icon=\"icon-file-pdf\" ng-click=\"vm.getPdf(\'pdf\')\" ng-disabled=\"vm.requestProcessingPDF\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>Export as PDF<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessingPDF\"></md-progress-circular>\n</md-button><md-button class=\"md-raised md-cornered\" \nng-if=\"(vm.reportType == \'x\' || vm.reportType == \'z\') && vm.xzReport.length > 0\" \nng-click=\"vm.printIvoice(\'complete\',\'pdf\')\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\">\n</md-icon>Export as PDF</md-button><md-button class=\"md-raised md-cornered\" \nng-if=\"vm.reportType == \'tip\' && (vm.tipData.length > 0)\" ng-click=\"vm.printTipDetail()\"><md-icon \nmd-font-icon=\"icon-printer\" class=\"onlycursorPointer m-0 s20 mr-5\" role=\"img\" aria-label=\"icon-basket\" \nmd-svg-icon=\"assets/angular-material-assets/img/icons/print.svg\" class=\"smiconprint\"></md-icon>Print</md-button>\n<md-button class=\"md-raised md-cornered\" \nng-if=\"(vm.reportType == \'daily\' || vm.reportType == \'sales\') && (vm.dailyreports.length > 0 || vm.salesReport.length > 0)\" \nng-click=\"vm.printReport()\"><md-icon md-font-icon=\"icon-printer\" class=\"onlycursorPointer m-0 s20 mr-5\" role=\"img\" \naria-label=\"icon-basket\" md-svg-icon=\"assets/angular-material-assets/img/icons/print.svg\" class=\"smiconprint\">\n</md-icon>Print</md-button><md-button class=\"md-raised md-cornered\" \nng-if=\"(vm.reportType == \'x\' || vm.reportType == \'z\') && vm.xzReport.length > 0\" \nng-click=\"vm.printIvoice(\'complete\',\'pdf\')\"><md-icon md-font-icon=\"icon-printer\" \nclass=\"onlycursorPointer m-0 s20 mr-5\" role=\"img\" aria-label=\"icon-basket\" \nmd-svg-icon=\"assets/angular-material-assets/img/icons/print.svg\" class=\"smiconprint\"></md-icon>Print</md-button></div>\n</div><div class=\"orderscrollblk relative-block\"><div \nng-if=\"(vm.reportType != \'sales\' && vm.reportType != \'daily\' &&  vm.reportType && vm.reportType != \'n\' && vm.reportType != \'tip\') && vm.refreshClicked == 1\">\n<div class=\"order-contentfullblk\"><div class=\"hor-scroll table-responsive no-padding\"><table id=\"report_till\" \ncellpadding=\"0\" cellspacing=\"0\" ng-repeat=\"(pKey, depositData) in vm.xzReport\" \nstyle=\"border-bottom: 15px solid #f1f1f1\"><tbody><tr><td><table cellpadding=\"0\" cellspacing=\"0\" \nclass=\"table-bordered webpos_bordered_table\"><thead><tr class=\"theadings\"><th width=\"27%\">Store</th><th width=\"27%\">\nCashier</th><th width=\"23%\" class=\"align_right\">From</th><th width=\"23%\" class=\"align_right\">To</th></tr></thead>\n<tbody><tr><td>{{depositData.reportDetail[\'HotelName\']}}</td><td>{{depositData.reportDetail[\'cashier\']}}</td><td \nclass=\"align_right\">{{depositData.reportDetail[\'from\']}}</td><td class=\"align_right\">{{depositData.reportDetail[\'to\']}}\n</td></tr></tbody></table></td></tr><tr><td><div class=\"tablezreport\"><table cellpadding=\"0\" cellspacing=\"0\" \nclass=\"table-bordered webpos_bordered_table\"><thead><tr class=\"theadings\"><th width=\"60%\" align=\"left\">Payment Method\n</th><th width=\"10%\" align=\"center\">No. of Orders</th><th width=\"10%\" align=\"center\">Recorded Grand Totals</th><th \nwidth=\"10%\" align=\"center\" \nng-if=\"vm.reportType != \'x\' && depositData.latestClose != undefined && depositData.latestClose == \'yes\'\">Manual Count\n</th><th width=\"10%\" align=\"center\" \nng-if=\"vm.reportType != \'x\' && depositData.latestClose != undefined && depositData.latestClose == \'yes\'\">Difference\n</th></tr></thead><tbody><tr ng-repeat=\"(dKey, deposit) in  depositData.depositType\"><td>{{deposit[\'Type\']}} <span \nng-if=\"deposit[\'Type\'] == \'Cash\'\"><button id=\"count_cash\" onclick=\"showCountCashArea()\">Count</button><br>(<br>\nTotal: {{deposit[\'Total\'] | currency:$:2}},<br><span>Opening Cash:</span> {{deposit[\'Opening Cash\'] | currency:$:2}},\n<br>Other In/Out Transactions: {{deposit[\'Other In/Out Transactions\'] | currency:$:2}}<br>)</span></td><td \nclass=\"align_center\">{{deposit[\'count\']}}</td><td class=\"align_right\"><span id=\"cashforpos_money_system\">\n{{deposit[\'Total\'] | currency:$:2}}</span></td><td class=\"align_right\" \nng-if=\"vm.reportType != \'x\'  && depositData.latestClose != undefined && depositData.latestClose == \'yes\'\">\n<md-input-container class=\"md-block tax-inputs full-width\"><input ng-if=\"deposit[\'Type\'] == \'Cash\'\" \nclass=\"manual_cal edit_report_value payment1\" type=\"text\" ng-model=\"vm.userInput[dKey]\" \nng-blur=\"vm.updateDifference(dKey)\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></td><td \nclass=\"align_right\" \nng-if=\"vm.reportType != \'x\' && depositData.latestClose != undefined && depositData.latestClose == \'yes\'\"><span \nid=\"cashforpos_diff\">{{ deposit[\'difference\'] | currency:$:2}}</span></td></tr><tr \nstyle=\"border-bottom: 1px solid #0d2131\"></tr><tr style=\"border-bottom: 1px solid #0d2131\"></tr><tr class=\"total\"><td \nstyle=\"padding: 4px\">Sum of Grand Totals</td><td class=\"align_center\"><span id=\"num_order_total\" class=\"align_center\">\n{{depositData.reportDetail[\'totalOrder\']}}</span></td><td class=\"align_right\"><span id=\"grand_system\">\n{{depositData.reportDetail[\'grandTotal\']| currency:$:2}}</span></td><td class=\"align_right\" \nng-if=\"vm.reportType != \'x\' && depositData.latestClose != undefined && depositData.latestClose == \'yes\'\"><span \nclass=\"edit_report_value totals\" id=\"total_value_report\">0</span></td><td class=\"align_right\" \nng-if=\"vm.reportType != \'x\'  && depositData.latestClose != undefined && depositData.latestClose == \'yes\'\"><span \nid=\"total_value_diff\">{{vm.totalDiff | currency:$:2}}</span></td></tr><tr class=\"total\"><td style=\"padding: 4px\">\nSum of Discounts</td><td class=\"align_center\"></td><td class=\"align_right\"><span id=\"discount_system\">\n{{depositData.reportDetail[\'discount\'] | currency:$:2}}</span></td><td class=\"align_right\" \nng-if=\"vm.reportType != \'x\' && depositData.latestClose != undefined && depositData.latestClose == \'yes\'\"><span \nclass=\"edit_report_value discount\" name=\"discount_value_report\" id=\"discount_value_report\">\n{{depositData.reportDetail[\'discount\'] | currency:$:2}}</span></td><td class=\"align_right\" \nng-if=\"vm.reportType != \'x\' && depositData.latestClose != undefined && depositData.latestClose == \'yes\'\"><span \nid=\"discount_value_diff\"></span></td></tr><tr class=\"total\"><td style=\"padding: 4px\">Sum of Tax Amounts</td><td \nclass=\"align_center\"></td><td class=\"align_right\"><span id=\"tax_system\">\n{{depositData.reportDetail[\'taxAmount\'] | currency:$:2}}</span></td><td class=\"align_right\" \nng-if=\"vm.reportType != \'x\' && depositData.latestClose != undefined && depositData.latestClose == \'yes\'\"><span \nclass=\"edit_report_value tax\" name=\"tax_value_report\" id=\"tax_value_report\">\n{{depositData.reportDetail[\'taxAmount\'] | currency:$:2}}</span></td><td class=\"align_right\" \nng-if=\"vm.reportType != \'x\' && depositData.latestClose != undefined && depositData.latestClose == \'yes\'\"><span \nid=\"tax_value_diff\"></span></td></tr><tr class=\"total\"><td style=\"padding: 4px\">Sum of Tip Amounts</td><td \nclass=\"align_center\"></td><td class=\"align_right\"><span id=\"tax_system\">\n{{depositData.reportDetail[\'tipAmount\'] | currency:$:2}}</span></td><td class=\"align_right\" \nng-if=\"vm.reportType != \'x\' && depositData.latestClose != undefined && depositData.latestClose == \'yes\'\"><span \nclass=\"edit_report_value tax\" name=\"tip_amount\" id=\"tip_amount\">\n{{depositData.reportDetail[\'tipAmount\'] | currency:$:2}}</span></td><td class=\"align_right\" \nng-if=\"vm.reportType != \'x\' && depositData.latestClose != undefined && depositData.latestClose == \'yes\'\"><span \nid=\"tax_value_diff\"></span></td></tr><tr \nng-if=\"vm.reportType != \'x\' && depositData.latestClose != undefined && depositData.latestClose == \'yes\'\"><td \ncolspan=\"5\"><div class=\"order-contentfullblk\"><div class=\"block-left container pricebloktxt\"><div class=\"\" \nlayout=\"row\" flex=\"100\"><div class=\"\" layout=\"column\" flex-gt-xs=\"50\"><div><label class=\"transfer_cashdrawer\">\nCash Amount Kept in Drawer for Next Shift/ Day</label><md-input-container class=\"md-block tax-inputs full-width mb-0\">\n<input type=\"text\" class=\"manual_cal cash_report form-control transfer_cashdrawer\" ng-model=\"vm.cashOut\" \nplaceholder=\"Transfer Cash\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div></div><div \nclass=\"\" layout=\"column\" flex-gt-xs=\"50\" layout-align=\"start start\"><div class=\"mt-20\"><md-button \nclass=\"md-raised md-cornered\" ng-if=\"vm.closeStoreStatus\" ng-click=\"vm.closeStore()\">Close Store</md-button><md-button \nclass=\"md-raised md-cornered\" ng-if=\"!vm.closeStoreStatus || vm.reportType == \'x\'\" ng-click=\"vm.printIvoice(\'latest\')\">\nPrint</md-button></div></div></div><div layout=\"row\" flex-gt-xs=\"100\" layout-align=\"start start\" \nclass=\"errorblkmainreport\"><div class=\"\" layout=\"column\" flex-gt-xs=\"100\"><p ng-if=\"vm.cashEntry\" class=\"error\">\nEnter Manual Count Value !</p></div></div></div></div></td></tr></tbody></table></div></td></tr></tbody></table></div>\n</div></div><div ng-if=\"vm.reportType == \'daily\' && vm.dailyreports.length > 0 && vm.refreshClicked == 1\" \nclass=\"printD Housekeepingtable incomereport income-report-table\"><div class=\"order-contentfullblk\" \npdf-save-content=\"dailyPdf\"><div class=\"hor-scroll table-responsive padding-10\" id=\"printSectionId\"><table \nms-responsive-table=\"\" cellpadding=\"0\" cellspacing=\"0\" id=\"heightTable\" class=\"simple\"><thead><tr class=\"theadings\">\n<th>Order#</th><th>Cashier</th><th>Bill to Name</th><th>Product Name</th><th>Total</th><th>Purchased On</th></tr>\n</thead><tbody id=\"tbodyHeight\" ng-style=\"vm.tableStyle\" ms-scroll style=\"position:relative\"><tr \nng-repeat=\"items in vm.dailyreports\"><td>{{items[\'confirmation_number\']}}</td><td>{{items[\'cashier\']}}</td><td>\n{{items[\'customer\']}}</td><td>{{items[\'product_name\']}}</td><td>{{items[\'total_deposit_amount\'] | currency:$:2}}</td>\n<td>{{items[\'created_date\']}}</td></tr></tbody></table></div></div></div><div \nng-if=\"vm.reportType == \'daily\' && vm.dailyreports.length == 0 && vm.refreshClicked == 1\"><div \nclass=\"order-contentfullblk\"><div class=\"pricebloktxt\">No Result Found.</div></div></div><div \nng-if=\"vm.reportType == \'sales\' && vm.salesReport.length > 0\" style=\"width: 100% !important\"><div \nclass=\"order-contentfullblk\" pdf-save-content=\"salePdf\" width=\"80% !important;\"><div \nclass=\"hor-scroll table-responsive\"><table ms-responsive-table=\"\" cellpadding=\"0\" cellspacing=\"0\"><thead><tr \nclass=\"theadings\"><td>Cashier</td><td>Sales</td><td style=\"margin-left: 5px\">Total Orders</td></tr></thead><tbody><tr \nng-repeat=\"items in vm.salesReport\"><td>{{items[\'cashier\']}}</td><td>{{items[\'total_amount\'] | currency:$:2}}</td><td \nstyle=\"margin-left: 5px\">{{items[\'total_order\']}}</td></tr></tbody></table></div></div></div><div \nng-if=\"vm.reportType == \'tip\' && vm.tipLength > 0\" class=\"printD tipreport\"><div class=\"order-contentfullblk\" \npdf-save-content=\"dailyPdf\"><div class=\"hor-scroll table-responsive padding-10\"><table ms-responsive-table=\"\" \ncellpadding=\"0\" cellspacing=\"0\"><thead><tr class=\"theadings\"><td>Employee Name</td><td>Total Sales</td><td>\nTotal Reported Tips</td></tr></thead><tbody><tr ng-repeat=\"(key, value) in vm.tipData\"><td>{{value.cashier_name}}</td>\n<td>{{value.grand_total | currency:$:2 }}</td><td>{{value.report_count}}</td></tr></tbody><tbody class=\"tipTotals\"><tr>\n<td>Total Tip</td><td>{{vm.tip_total | currency:$:2 }}</td><td>{{vm.tip_total_count}}</td></tr></tbody></table></div>\n</div></div><div ng-if=\"vm.empty && vm.reportType != \'daily\'\"><div class=\"order-contentfullblk\"><div \nclass=\"pricebloktxt\">No Result Found.</div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/checkout/tabOrder/tabOrder.html","<div id=\"tab-order\" class=\"page-layout simple tabbed md-datepicker full-height\" layout=\"column\"><div \nclass=\"header md-accent-bg relative-block\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" ng-click=\"vm.back()\"><md-icon \nmd-font-icon=\"icon-cart-outline\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div class=\"h2\">\nTab Order</div></div></div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\" \nclass=\"headerstickyProgress\"></md-progress-linear></div><md-content class=\"full-height\"><div \nclass=\"full-width full-height\" layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"55\" \nclass=\"order-res1\"><div class=\"full-height block-form-seach-main md-whiteframe-1dp\"><div \nclass=\"row-blk-icon white-bg md-whiteframe-1dp order-tital\" layout=\"row\" layout-wrap flex=\"100\" \nlayout-align=\"center center\">Tab Orders</div><div class=\"md-list-scrollblock\"><div class=\"md-listrepeat\"><div \nclass=\"box-repeatorder\" ng-if=\"vm.tabOrder.length == 0\"><div class=\"side-overflow-block\"><div class=\"pos-dateblk\" \nstyle=\"text-align:center\">No Result(s) Found</div></div></div><md-list class=\"no-padding\"><md-list-item \nclass=\"cursorPointer listmd-itmsmain unsetminheight\" ng-repeat=\"(tabKey, item) in vm.tabOrder\" layout=\"row\" \nlayout-wrap layout-align=\"start start\" ng-class=\"vm.activeClass == tabKey? \'activeTabOrder\':\'\'\"><div \nclass=\"pos-dateblk\" ng-if=\"::!item.same\">{{item.categoryDate}}</div><div layout=\"column\" flex=\"100\" \nlayout-align=\"start start\" class=\"padding-5 pr-20 activeDiv\"><div flex=\"100\" ng-click=\"vm.loadSingleTabOrder($index)\" \nlayout=\"row\" class=\"listingTbsys full-width\" layout-wrap><div class=\"md-list-item-text divnewblock ph-5 mt-10\" \nclass=\"onlycursorPointer\" layout=\"column\" flex-gt-md=\"25\" flex=\"50\" layout-align=\"start start\"><h3>\n{{::item[\'OrderTime\']}} | {{::item[\'total\'] | currency:$:2}}</h3><p>{{::item[\'product_name\']}}</p></div><div \nlayout=\"column\" flex-gt-md=\"15\" flex=\"50\" layout-align=\"start start\" class=\"ph-5 btnstaborderouter mt-10\"><span \nclass=\"tabName\"><b>{{item[\'name\']}}</b></span></div><div layout=\"column\" flex-gt-md=\"60\" flex=\"100\" \nlayout-align=\"start start\" class=\"ph-5 btnstaborderouter\"><div class=\"full-width\"><md-button \nclass=\"md-raised md-accent white-fg btntaborder mr-5\" ng-click=\"vm.printInvoice($index)\"><md-icon \nmd-font-icon=\"icon-printer\" class=\"iconsizebtn md-default-theme md-font material-icons white-fg\" role=\"img\" \naria-label=\"icon-basket\"></md-icon>Print</md-button><md-button class=\"md-raised md-accent white-fg btntaborder mr-5\" \nng-click=\"vm.renameTabOrderName($index)\"><md-icon md-font-icon=\"icon-pencil-box-outline\" \nclass=\"iconsizebtn md-default-theme md-font material-icons white-fg\" role=\"img\" aria-label=\"icon-basket\"></md-icon>\nRename</md-button><md-button class=\"md-primary md-raised md-primary btntaborder mr-5\" \nng-click=\"vm.moveToRetailWithOrder($index)\" ng-disabled=\"vm.requestProcessing[$index]\"><md-icon \nmd-font-icon=\"icon-cart\" class=\"iconsizebtn md-default-theme md-font material-icons white-fg\" role=\"img\" \naria-label=\"icon-basket\"></md-icon>View Tab Order</md-button><md-button \nclass=\"md-primary md-raised md-warn btntaborder\" ng-disabled=\"vm.disableCancel[$index]\" \nng-click=\"vm.deleteOrder($index)\"><md-icon md-font-icon=\"icon-close\" \nclass=\"iconsizebtn md-default-theme md-font material-icons white-fg\" role=\"img\" aria-label=\"icon-basket\"></md-icon>\nCancel</md-button></div></div><md-divider layout=\"column\" flex=\"100\" class=\"divderblk\"></md-divider></div></div>\n</md-list-item></md-list></div></div></div></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"45\" \nclass=\"full-height bgf1\" ng-if=\"vm.tabOrder.length > 0\"><div class=\"full-height\"><div \nclass=\"row-blk-icon white-bg md-whiteframe-1dp order-tital\" layout=\"row\" layout-wrap flex=\"100\" \nlayout-align=\"start start\"><div class=\"orderpriceblkouter\" flex=\"100\" layout=\"row\" layout-align=\"center center\"><span \nclass=\"confirmnoblk smtxt\" layout=\"column\">{{vm.note}}</span><h2 layout=\"column\">{{vm.overallTotals.gt | currency:$:2}}\n</h2></div></div><div class=\"orderscrollblk relative-block\"><div class=\"order-contentfullblk\"><div \nclass=\"pricebloktxt\"><div class=\"pricetxtblknew\"><p>Created Date:<b> {{vm.OrderTime}}</b></p><p>\nServed By: {{vm.created_by_user}}</p></div></div></div><div class=\"order-contentfullblk\"><div class=\"pricebloktxt\"><div\n class=\"orderblock1half orderblockfull\"><div class=\"pos-dateblk\">Billing Address:</div><div class=\"pricetxtblknew\"><p>\n{{vm.customer.first_name+\' \'+vm.customer.last_name}}</p><p>\n{{vm.customer.city}}, {{vm.customer.state}}, {{vm.customer.zip_code}}</p><p>{{vm.customer.country}}</p><p>\nT: {{vm.customer.phone_number}}</p></div></div></div></div><div class=\"order-contentfullblk\"><div \nclass=\"hor-scroll table-responsive\"><table cellspacing=\"0\" class=\"table data order-tables\"><thead><tr \nclass=\"theadings\"><th>Product</th><th>Price</th><th class=\"a-center\">Qty</th><th>Tax</th><th>Discount</th><th \nclass=\"last\"><span class=\"nobr\">Subtotal</span></th></tr></thead><tr class=\"fist even\" \nng-repeat=\"(key, value) in vm.single_tab_order\"><td>{{value.product_name}}<div class=\"product_options\"></div></td><td>\n{{value.customPrice | currency:$:2}}</td><td>{{value.quantity }}</td><td>{{value.tax | currency:$:2}}</td><td>\n{{((value.product_discount * value.quantity)) | currency:$:2}}</td><td><span class=\"price\">\n{{((value.nightlySum * value.quantity)) | currency:$:2}}</span></td></tr></table></div></div><div \nclass=\"order-contentfullblk\"><div class=\"hor-scroll table-responsive subtotal\"><table cellspacing=\"0\" \nclass=\"table data order-tables\"><tr><td class=\"sub1\">Tax</td><td class=\"sub2\">{{vm.overallTotals.tax | currency:$:2}}\n</td></tr><tr><td class=\"sub1\">Subtotal</td><td class=\"sub2\">{{vm.overallTotals.subtotal | currency:$:2}}</td></tr><tr>\n<td class=\"sub1\">Discount</td><td class=\"sub2\">{{vm.overallTotals.total_discount | currency:$:2}}</td></tr><tr><td \nclass=\"sub1\">Grand Total</td><td class=\"sub2\">{{vm.overallTotals.gt | currency:$:2}}</td></tr></table></div></div>\n</div></div></div></div></md-content></div>");
$templateCache.put("app/main/apps/contacts/confirmationPopUp/confirmation.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"ploicyForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog(\'close\')\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"fullcontent\" style=\"padding: 16px 0px 16px 0px\"><div class=\"outer_wrapper\"><md-content class=\"md-padding\"><p \nclass=\"form-title-small mt-0 mb-0\" bind-html-compile=\"vm.htmlContent\"></p></md-content></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" \nflex=\"100\"><md-button type=\"submit\" ng-if=\"vm.CancelbtnTxt != \'none\'\" ng-click=\"vm.closeDialog(\'no\')\" \nng-class=\"\'md-raised md-accent submit-button grey-100-fg md-red-500-bg\'\">{{vm.CancelbtnTxt}}</md-button><md-button \ntype=\"submit\" ng-if=\"vm.OkbtnTxt != \'none\'\" ng-click=\"vm.hideDialog()\" \nng-class=\"\'md-raised md-accent submit-button grey-100-fg md-green-500-bg\'\">{{vm.OkbtnTxt}}</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/contacts/contact/contact.html","<div id=\"add-contact\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg logo\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"goto-organizations-button md-icon-button\" aria-label=\"Go to customers\" ng-click=\"vm.gotocustomers()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nng-if=\"!vm.newContact\" layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{vm.contact.first_name}} {{vm.contact.last_name}}</div><div class=\"subtitle secondary-text\"><span \ntranslate=\"CONTACTS.CUSTOMER_DETAIL\"></span></div></div><div ng-if=\"vm.newContact\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\" \ntranslate=\"CONTACTS.NEW_CONTACT\"></div></div></div></div></div></div><div ng-hide=\"!vm.newContact\"><md-button \nclass=\"md-raised md-background\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine || vm.buttonActive==1 || vm.emailError\" \nng-click=\"vm.addNewContact()\" \nng-class=\"{\'md-blue-grey-A100-bg\': contactForm.$invalid || contactForm.$pristine || vm.buttonActive==1 || vm.emailError}\">\n<span translate=\"GROUPS.SAVE\"></span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"vm.gotocustomers();\"><span translate=\"GROUPS.CANCEL\"></span></md-button></div></div><div \nclass=\"content scroll-height-sm\"><md-progress-linear md-mode=\"indeterminate\" \nng-show=\"vm.isloading || vm.isCustomerTagsLoading\"></md-progress-linear><div class=\"main scroll-full-height\" ms-scroll>\n<div class=\"white-bg md-whiteframe-4dp relative-block sizefont-15\" layout-align=\"center center\" layout-padding \nng-if=\"vm.disableWeb == \'Edit\'\"><div class=\"\" layout=\"row\" flex=\"100\"><div class=\"\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\"><div><b translate=\"CONTACTS.CREATED_AT\"></b> <span>{{vm.shownContact.created_readable_date}}</span>\n</div></div><div class=\"\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><div><b translate=\"CONTACTS.LAST_MODIFIED\"></b> \n<span>{{vm.shownContact.modified_readable_date}}</span></div></div></div><div class=\"\" layout=\"row\" flex=\"100\"><div \nclass=\"\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><div><b translate=\"CONTACTS.CUSTOMER_SOURCE\"></b> <span>\n{{vm.shownContact.customer_source}}</span></div></div><div class=\"\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nng-if=\"vm.loggedInUserRole == 1\"><div><b translate=\"CONTACTS.IS_VIRTUAL\"></b> <span>\n{{vm.shownContact.readable_account_virtual}}</span></div></div></div></div><div \nclass=\"md-whiteframe-4dp relative-block md-nopadding\" layout-align=\"center center\" layout-padding><form \nname=\"contactForm\" class=\"md-inline-form no-padding\" novalidate><div class=\"role-list-out white-bg relative-block\" \nstyle=\"margin:15px 0px\"><div class=\"div-outer-simple-block padding-top\"><div class=\"form-title\">Basic Information</div>\n</div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex layout-wrap>\n<md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\">\n<md-input-container class=\"md-block tax-inputs\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"CONTACTS.FIRST_NAME\"></label><input type=\"text\" name=\"first_name\" ng-model=\"vm.contact.first_name\" \naria-invalid=\"true\" ng-change=\"contactForm.first_name.$valid && vm.saveContact(\'first_name\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\">\n<md-input-container class=\"md-block tax-inputs\" data-ng-animate=\"2\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"CONTACTS.LAST_NAME\"></label><input type=\"text\" name=\"last_name\" ng-model=\"vm.contact.last_name\" \naria-invalid=\"true\" ng-change=\"contactForm.last_name.$valid && vm.saveContact(\'last_name\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div>\n<div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><md-input-container \nclass=\"md-block tax-inputs ph-10 mdinputblk\" data-ng-animate=\"1\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\"><label class=\"ng-scope md-required ml-10\" role=\"button\" translate=\"CONTACTS.EMAIL\"></label>\n<input type=\"email\" name=\"email\" ng-model=\"vm.contact.customer_email\" required aria-invalid=\"true\" \nng-change=\"contactForm.email.$valid && vm.saveContact(\'customer_email\')\" ng-model-options=\"{debounce: 500}\" \nng-pattern=\"/^.+@.+\\..+$/\" class=\"lesswidthright\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><md-icon \nmd-font-icon=\"icon-plus-circle md-accent-fg\" ng-click=\"vm.addMultipleEmail(vm.emailIndex)\" \nclass=\"onlycursorPointer mdplusiconmain\"></md-icon><div ng-messages=\"contactForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"pattern\"><span translate=\"CONTACTS.VALID_EMAIL\"></span></div></div><div \nng-if=\"vm.emailError\" class=\"emailError\"><span translate=\"CONTACTS.EMAIL_EXISTS\" class=\"pl-10\"></span></div>\n</md-input-container><md-input-container class=\"md-block tax-inputs ph-10 mdinputblk\" ng-repeat=\"i in vm.emailCount\" \ndata-ng-animate=\"1\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\"><label \nclass=\"ng-scope md-required ml-10\" role=\"button\" translate=\"CONTACTS.EMAIL\"></label><input type=\"email\" name=\"email\" \nng-model=\"vm.userEmail[$index]\" aria-invalid=\"true\" ng-change=\"vm.validateOtherEmail($index)\" \nng-model-options=\"{debounce: 500}\" ng-pattern=\"/^.+@.+\\..+$/\" class=\"lesswidthright\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"><md-icon md-font-icon=\"icon-delete\" class=\"onlycursorPointer red-A800-fg\" \nng-click=\"vm.deleteThisEmail($index)\"></md-icon><div ng-if=\"vm.otherValidEamil[$index]\" class=\"emailError\"><div><span \ntranslate=\"CONTACTS.VALID_EMAIL\"></span></div></div><div ng-if=\"vm.otherEmailError[$index]\" class=\"emailError\"><span \ntranslate=\"CONTACTS.EMAIL_EXISTS\"></span></div></md-input-container></div><div class=\"row-block\" flex-gt-xs=\"100\" \nlayout=\"row\" layout-align=\"start start\" layout-wrap><md-input-container class=\"md-block tax-inputs ph-10\" flex=\"100\" \nflex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\"><label class=\"ml-10 phone-number-label\" role=\"button\" \ntranslate=\"CONTACTS.PHONE_NUMBER\"></label><input type=\"tel\" class=\"intel-number-input\" intl-tel-input \nname=\"phone_number\" ng-model=\"vm.contact.phone_number\" aria-invalid=\"true\" \nng-change=\"vm.updatePhoneWithCountryCode(\'phone_number\',$event); contactForm.phone_number.$valid && vm.saveContact(\'phone_number\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div \nng-messages=\"contactForm.phone_number.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span \ntranslate=\"CONTACTS.VALID_PHONE\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block tax-inputs ph-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\"><label \nclass=\"ml-10 phone-number-label\" role=\"button\" translate=\"CONTACTS.SECONDARY_PHONE_NUMBER\"></label><input type=\"tel\" \nclass=\"intel-number-input\" intl-tel-input name=\"secondary_phone_number\" ng-model=\"vm.contact.secondary_phone_number\" \naria-invalid=\"true\" \nng-change=\"vm.updatePhoneWithCountryCode(\'secondary_phone_number\',$event); contactForm.secondary_phone_number.$valid && vm.saveContact(\'secondary_phone_number\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div \nng-messages=\"contactForm.secondary_phone_number.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\">\n<span translate=\"CONTACTS.VALID_PHONE\"></span></div></div></md-input-container></div><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><md-input-container \nclass=\"md-block tax-inputs ph-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\"><label \nclass=\"ml-10\" role=\"button\">Gender</label><md-select ng-model=\"vm.contact.customer_gender\" \nng-change=\"vm.saveContact(\'customer_gender\')\" ng-disabled=\"vm.autoFillOff\"><md-option value=\"Male\">Male</md-option>\n<md-option value=\"Female\">Female</md-option><md-option value=\"Other\">Other</md-option><md-option \nvalue=\"Prefer not to say\">Prefer not to say</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block tax-inputs ph-10 family-member-datepicker pet-dob-datepicker\" flex=\"100\" flex-gt-xs=\"50\" \nlayout=\"column\" layout-align=\"start start\"><label role=\"button\">Date of birth</label><md-datepicker \nng-model=\"vm.contact.date_of_birth\" md-open-on-focus ng-change=\"vm.saveContact(\'date_of_birth\')\" \nng-disabled=\"vm.autoFillOff\" md-max-date=\"vm.maxDateOfBirth\" aria-label=\"Date of birth\"></md-datepicker>\n</md-input-container></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap>\n<md-input-container class=\"md-block tax-inputs ph-10\" flex=\"100\" layout=\"column\" layout-align=\"start start\"><label \nclass=\"ml-10\" role=\"button\">About</label><textarea ng-model=\"vm.contact.about\" rows=\"2\" \nng-change=\"vm.saveContact(\'about\')\" ng-model-options=\"{debounce: 500}\" ng-readonly=\"vm.autoFillOff\">\n								\n</textarea></md-input-container></div></div><div class=\"role-list-out white-bg relative-block\" style=\"margin:15px 0px\">\n<div class=\"div-outer-simple-block padding-top\"><div class=\"form-title\">Detail Information</div></div><div \nclass=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\">\n<md-input-container class=\"md-block tax-inputs datepicker-block\" data-ng-animate=\"1\"><label>Address</label><textarea \nid=\"autocomplete\" ng-model=\"vm.contact.address\" rows=\"1\" \nng-change=\"contactForm.phone_number.$valid && vm.saveContact(\'address\')\" md-select-on-focus autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></textarea><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\">\n<md-input-container class=\"md-block tax-inputs\"><label translate=\"CONTACTS.STATUS\"></label><md-select \nplaceholder=\"{{ \'CONTACTS.SELECT_STATUS\' | translate }}\" ng-model=\"vm.contact.is_active\" required \nng-change=\"vm.saveContact(\'is_active\')\" ng-model-options=\"{debounce: 500}\"><md-option ng-value=\"stat.value\" \nng-repeat=\"stat in vm.status\" ng-selected=\"stat.value == vm.contact.is_active\">{{stat.name}}</md-option></md-select>\n<div class=\"md-errors-spacer\"></div></md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" \nlayout=\"row\" layout-align=\"start start\" layout-wrap><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" \nflex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\"><md-input-container flex-gt-xs=\"100\" \nclass=\"md-block tax-inputs\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\" translate=\"CONTACTS.CITY\">\n</label><input ng-model=\"vm.contact.city\" type=\"text\" name=\"city\" ng-change=\"vm.saveContact(\'city\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" \nlayout=\"column\" layout-align=\"start start\"><md-autocomplete ng-disabled=\"vm.isStateDisabled\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedState\" md-search-text-change=\"vm.searchState(vm.searchTxtState)\" \nmd-search-text=\"vm.searchTxtState\" md-selected-item-change=\"vm.selectedItemChangeState(item,\'click\')\" \nmd-items=\"item in vm.selectedItemChangeStateTraveller(vm.searchTxtState)\" md-item-text=\"item.name\" md-min-length=\"0\" \nmd-floating-label=\"State\" class=\"full-width\" id=\"autocompleteState\"><md-item-template><span \nmd-highlight-text=\"vm.searchTxtState\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>\nNo states matching \"{{vm.searchTxtState}}\" were found.</md-not-found></md-autocomplete></div></div><div \nclass=\"row-block row-autocomplete\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\">\n<md-input-container class=\"md-block tax-inputs\" flex-gt-xs=\"100\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"CONTACTS.ZIPCODE\"></label><input id=\"autocompletezip\" ng-model=\"vm.contact.zip_code\" type=\"text\" \nname=\"zip_code\" ng-model-options=\"{debounce: 500}\" ng-change=\"vm.saveContact(\'zip_code\')\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\">\n<md-autocomplete ng-disabled=\"vm.isCountryDisabled\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedCountry\" \nmd-search-text-change=\"vm.searchCountry(vm.searchTxtCountry)\" md-search-text=\"vm.searchTxtCountry\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-items=\"item in vm.queryCountrySearch(vm.searchTxtCountry)\" \nmd-item-text=\"item.display\" md-min-length=\"0\" md-floating-label=\"Country\" md-require-match autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"><md-item-template><span md-highlight-text=\"vm.searchTxtCountry\" md-highlight-flags=\"^i\">\n{{item.display}}</span></md-item-template><md-not-found>No country matching \"{{vm.searchTxtCountry}}\" were found.\n</md-not-found></md-autocomplete></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" layout-wrap><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" \nflex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\"><md-input-container class=\"md-block tax-inputs\"><label \ntranslate=\"CONTACTS.PASSWORD\"></label><input ng-model=\"vm.password\" type=\"password\" \nng-required=\"!vm.contact.customer_id\" name=\"password_1\" ng-change=\"vm.saveContact(\'password\')\" \nng-model-options=\"{debounce: 500}\" min-password autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div \nng-messages=\"contactForm.password_1.$error\" role=\"alert\"><div ng-messages=\"contactForm.password.$error\"><div \nng-message=\"compareTo\"><span translate=\"CONTACTS.MATCH_PASSWORD\"></span></div></div><div ng-message=\"min-password\">\n<span translate=\"CONTACTS.MIN_PASSWORD\"></span></div></div></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\">\n<md-input-container class=\"md-block tax-inputs\"><label translate=\"CONTACTS.CONFIRM_PASSWORD\"></label><input \nng-model=\"vm.contact.passwordConfirm\" type=\"password\" ng-required=\"!vm.contact.customer_id\" name=\"passwordConfirm\" \ncompare-to=\"vm.password\" ng-change=\"vm.saveContact(\'passwordConfirm\')\" ng-model-options=\"{debounce: 500}\" min-password \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div ng-messages=\"contactForm.passwordConfirm.$error\"><div \nng-message=\"compareTo\"><span translate=\"CONTACTS.MATCH_PASSWORD\"></span></div></div></md-input-container></div></div>\n<div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" \nng-if=\"vm.customerType != \'negotiated\'\"><md-input-container class=\"md-block md-input-has-value\"><md-switch \nclass=\"no-margin\" ng-model=\"vm.contact.tax_exempt_indicator\" aria-label=\"Switch 1\" \nng-change=\"vm.saveContact(\'tax_exempt_indicator\')\"><span translate=\"CONTACTS.TAX_EXEMPT_ON\" \nng-if=\"vm.contact.tax_exempt_indicator\"></span><span translate=\"CONTACTS.TAX_EXEMPT_OFF\" \nng-if=\"!vm.contact.tax_exempt_indicator\"></span></md-switch><div class=\"md-errors-spacer\"></div></md-input-container>\n</div><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\"><md-input-container class=\"md-block md-input-has-value\" \nng-init=\"vm.contact.tax_exempt_indicator = vm.contact.tax_exempt_indicator == 1? true:false\"><md-switch \nclass=\"no-margin\" ng-model=\"vm.contact.send_email_indicator\" aria-label=\"Switch 1\" \nng-change=\"vm.saveContact(\'send_email_indicator\')\"><span translate=\"CONTACTS.SENDEMAIL_ON\" \nng-if=\"vm.contact.send_email_indicator\"></span><span translate=\"CONTACTS.SENDEMAIL_OFF\" \nng-if=\"!vm.contact.send_email_indicator\"></span></md-switch><div class=\"md-errors-spacer\"></div></md-input-container>\n</div></div><div class=\"row-block\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" \nng-if=\"vm.contact.tax_exempt_indicator == 1\"><md-input-container class=\"md-block tax-inputs\"><label \ntranslate=\"CONTACTS.TAX_EXEMPT_ID\"></label><input ng-model=\"vm.contact.tax_exempt_id\" type=\"text\" name=\"tax_exempt_id\" \nng-change=\"vm.saveContact(\'tax_exempt_id\')\" ng-model-options=\"{debounce: 500}\"></md-input-container><div \nclass=\"md-errors-spacer\"></div></div><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" \nlayout=\"column\" layout-align=\"start start\" ng-if=\"vm.customerType == \'negotiated\'\"><md-input-container \nclass=\"md-block tax-inputs\"><label>Apply negotiated rates</label><md-select placeholder=\"Select Negotiated rate\" \nng-model=\"vm.contact.negotiated_rate_customer\" required ng-change=\"vm.saveContact(\'negotiated_rate_customer\')\" \nng-model-options=\"{debounce: 500}\"><md-option ng-value=\"cust.id\" ng-repeat=\"cust in vm.negotiatedCustomerType\" \nng-selected=\"cust.id == vm.contact.negotiated_rate_customer\">{{cust.name}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></div></div></form><div \nclass=\"role-list-out white-bg relative-block\" style=\"margin:15px 0\"><div class=\"div-outer-simple-block padding-top\">\n<div class=\"form-title\" layout=\"row\" layout-align=\"space-between center\"><div class=\"tag-group-wrapper\" \nlayout=\"column\" layout-align=\"start start\"><span>Customer Tags <span class=\"secondary-text\" \nng-if=\"vm.contact.customer_tag.length\">({{vm.contact.customer_tag.length}})</span></span><div \nclass=\"family-members-subtitle\">Manage people associated with this customer</div></div><md-button \nclass=\"md-raised md-primary manage-tags-btn\" ng-click=\"vm.manageTags($event)\"><md-icon md-font-icon=\"icon-tag\" \nstyle=\"margin-right: 5px\"></md-icon>Manage Tags</md-button></div></div><div class=\"tags-container\" \nng-if=\"vm.contact.customer_tag && vm.contact.customer_tag.length\"><div class=\"customer-tag-list\"><span \nclass=\"customer-tag\" ng-repeat=\"tag in vm.contact.customer_tag track by $index\" \nng-style=\"vm.getCustomerTagStyle(tag.colour_code)\">{{tag.name}}</span></div></div><div class=\"family-members-empty\" \nng-if=\"!vm.contact.customer_tag || !vm.contact.customer_tag.length\"><div class=\"family-members-empty-icon\"><md-icon \nmd-font-icon=\"icon-tag\"></md-icon></div><div class=\"family-members-empty-title\">No tags assigned</div></div></div><div \nclass=\"family-members-card white-bg relative-block\"><div class=\"family-members-header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"family-members-title\"><div layout=\"row\" layout-align=\"start center\">\n<span>Family Members <span class=\"secondary-text\" ng-if=\"vm.customerFamilyMembers.data.length\">\n({{vm.customerFamilyMembers.data.length}})</span></span></div><div class=\"family-members-subtitle\">\nManage people associated with this customer</div></div><div layout=\"row\" layout-align=\"end center\">\n<md-progress-circular ng-if=\"vm.customerFamilyMembers.isloading\" class=\"md-accent\" md-diameter=\"24px\">\n</md-progress-circular><md-button class=\"md-raised md-primary family-member-add-btn\" \nng-click=\"vm.openAddFamilyMemberDialog($event)\" ng-if=\"!vm.customerFamilyMembers.isloading\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><span>Add Member</span></md-button></div></div><div \nng-if=\"vm.customerFamilyMembers.isloading\" class=\"family-members-loading\"><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"family-members-loading-text\">\nLoading family members...</div></div><div \nng-if=\"!vm.customerFamilyMembers.isloading &&\n							vm.customerFamilyMembers.data &&\n							vm.customerFamilyMembers.data.length\" \nclass=\"customer-family-members\"><md-table-container><table md-table id=\"familyMembersTable\" class=\"simple col30\"><thead\n md-head><tr md-row class=\"headerrow headingoutertb\"><th md-column>Name</th><th md-column>Relationship</th><th \nmd-column>Email</th><th md-column>Phone</th><th md-column>Date Of Birth</th><th md-column>Actions</th></tr></thead>\n<tbody md-body id=\"familyMembersTbody\" ng-style=\"vm.tableStyle\" ms-scroll style=\"position:relative\"><tr md-row \nng-repeat=\"member in vm.customerFamilyMembers.data track by member.customer_id\" \nng-click=\"vm.goToFamilyMember(member.customer_id)\" style=\"cursor:pointer\"><td md-cell class=\"cursorPointer\"><div \nclass=\"family-member-person\"><div class=\"family-member-avatar\">{{(member.first_name || \'?\').charAt(0).toUpperCase()}}\n</div><div class=\"family-member-person-info\"><div class=\"family-member-full-name\">\n{{member.first_name || \'—\'}} {{member.last_name || \'\'}}</div></div></div></td><td md-cell class=\"cursorPointer\"><span \nclass=\"family-member-relationship\" ng-if=\"member.relationship_status\">{{member.relationship_status}} </span><span \nclass=\"family-member-empty\" ng-if=\"!member.relationship_status\">—</span></td><td md-cell class=\"cursorPointer\"><span \nng-if=\"member.customer_email\">{{member.customer_email}} </span><span class=\"family-member-empty\" \nng-if=\"!member.customer_email\">—</span></td><td md-cell class=\"cursorPointer\"><span ng-if=\"member.phone_number\">\n{{vm.formatPhoneNumber(member.phone_number) || \'-\'}} </span><span class=\"family-member-empty\" \nng-if=\"!member.phone_number\">—</span></td><td md-cell class=\"cursorPointer\"><span ng-if=\"member.date_of_birth\">\n{{vm.formatDateOfBirth(member.date_of_birth)}} </span><span class=\"family-member-empty\" ng-if=\"!member.date_of_birth\">—\n</span></td><td md-cell class=\"family-member-actions\"><md-button \nclass=\"md-icon-button family-member-action-btn family-member-edit-btn\" \nng-click=\"$event.stopPropagation(); vm.openEditFamilyMemberDialog($event, member)\" \nng-disabled=\"vm.isUpdatingFamilyMember\" aria-label=\"Edit family member\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n<md-tooltip>Edit</md-tooltip></md-button><md-button \nclass=\"md-icon-button family-member-action-btn family-member-delete-btn\" \nng-click=\"$event.stopPropagation(); vm.deleteFamilyMember($event, member)\" aria-label=\"Delete family member\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip>Delete</md-tooltip></md-button></td></tr></tbody></table>\n</md-table-container></div><div class=\"family-members-empty\" \nng-if=\"!vm.customerFamilyMembers.isloading &&\n							(!vm.customerFamilyMembers.data ||\n								!vm.customerFamilyMembers.data.length)\">\n<div class=\"family-members-empty-icon\"><md-icon md-font-icon=\"icon-account-multiple\"></md-icon></div><div \nclass=\"family-members-empty-title\">No family members yet</div></div></div><div \nclass=\"family-members-card pets-card white-bg relative-block\"><div class=\"family-members-header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"family-members-title\"><div layout=\"row\" layout-align=\"start center\">\n<span>Pets <span class=\"secondary-text\" ng-if=\"vm.customerPets.data.length\">({{vm.customerPets.data.length}})</span>\n</span></div><div class=\"family-members-subtitle\">Manage pets associated with this customer</div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-progress-circular ng-if=\"vm.customerPets.isloading\" class=\"md-accent\" \nmd-diameter=\"24px\"></md-progress-circular><md-button class=\"md-raised md-primary family-member-add-btn\" \nng-click=\"vm.openAddPetDialog($event)\" ng-if=\"!vm.customerPets.isloading\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<span>Add Pet</span></md-button></div></div><div ng-if=\"vm.customerPets.isloading\" class=\"family-members-loading\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div \nclass=\"family-members-loading-text\">Loading pets...</div></div><div \nng-if=\"!vm.customerPets.isloading && vm.customerPets.data && vm.customerPets.data.length\" class=\"customer-pets\">\n<md-table-container><table md-table id=\"petsTable\" class=\"simple col30\"><thead md-head><tr md-row \nclass=\"headerrow headingoutertb\"><th md-column>Name</th><th md-column>Pet Type</th><th md-column>Date Of Birth</th><th \nmd-column>Actions</th></tr></thead><tbody md-body id=\"petsTbody\" ng-style=\"vm.tableStyle\" ms-scroll \nstyle=\"position:relative\"><tr md-row ng-repeat=\"pet in vm.customerPets.data track by pet.id\"><td md-cell><div \nclass=\"family-member-person\"><div class=\"family-member-avatar pet-avatar\">{{(pet.name || \'?\').charAt(0).toUpperCase()}}\n</div><div class=\"family-member-person-info\"><div class=\"family-member-full-name\">{{pet.name || \'—\'}}</div></div></div>\n</td><td md-cell><span class=\"family-member-relationship pet-type-badge\" ng-if=\"pet.pet_type\">\n{{pet.pet_type === \'Other\' && pet.other_pet_type ? pet.other_pet_type : pet.pet_type}} </span><span \nclass=\"family-member-empty\" ng-if=\"!pet.pet_type\">—</span></td><td md-cell><span ng-if=\"pet.date_of_birth\">\n{{vm.formatDateOfBirth(pet.date_of_birth)}} </span><span class=\"family-member-empty\" ng-if=\"!pet.date_of_birth\">—\n</span></td><td md-cell class=\"family-member-actions\"><md-button \nclass=\"md-icon-button family-member-action-btn family-member-edit-btn\" \nng-click=\"$event.stopPropagation(); vm.openEditPetDialog($event, pet)\" ng-disabled=\"vm.isUpdatingCustomerPet\" \naria-label=\"Edit pet\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip>Edit</md-tooltip></md-button><md-button\n class=\"md-icon-button family-member-action-btn family-member-delete-btn\" \nng-click=\"$event.stopPropagation(); vm.deleteCustomerPet($event, pet)\" aria-label=\"Delete pet\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip>Delete</md-tooltip></md-button></td></tr></tbody></table>\n</md-table-container></div><div class=\"family-members-empty\" \nng-if=\"!vm.customerPets.isloading && (!vm.customerPets.data || !vm.customerPets.data.length)\"><div \nclass=\"family-members-empty-icon\"><md-icon md-font-icon=\"icon-paw\"></md-icon></div><div \nclass=\"family-members-empty-title\">No pets yet</div></div></div><div class=\"white-bg padding-16 padding-top-24\" \nng-if=\"vm.reservations.totalResv\"><div class=\"div-outer-simple-block padding-top\"><div class=\"form-title flex\"><span>\nReservations <span ng-if=\"vm.reservations.totalResv\" class=\"total-reservations\">({{vm.reservations.totalResv}})</span>\n</span><md-progress-circular ng-if=\"vm.reservations.isloading\" class=\"md-accent md-hue-1\" md-diameter=\"20px\">\n</md-progress-circular></div></div><div ng-if=\"vm.reservations.data && vm.reservations.data.length\" \nclass=\"customer-reservations\"><md-table-container><table md-table id=\"heightTable\" class=\"simple col30\"><thead md-head>\n<tr md-row class=\"headerrow capitalize headingoutertb\"><th ng-repeat=\"heading in vm.reservations.heading\">{{heading}}\n</th></tr></thead><tbody md-body id=\"tbodyHeight\" ng-style=\"vm.tableStyle\" ms-scroll style=\"position:relative\"><tr \nng-repeat=\"(myKey, reservations) in vm.reservations.data\" \nng-click=\"reservations.confirmation_number && vm.goToState(\'\', reservations.confirmation_number, \'\')\"><td \nclass=\"cursorPointer\">\n{{reservations.product_name ? reservations.product_name : (reservations.fe_display_product_name ? reservations.fe_display_product_name : \'-\')}}\n</td><td class=\"cursorPointer\">{{reservations.room_stay_from_formatted ? reservations.room_stay_from_formatted : \'-\'}}\n</td><td class=\"cursorPointer\">{{reservations.room_stay_to_formatted ? reservations.room_stay_to_formatted : \'-\'}}</td>\n<td class=\"cursorPointer\">{{reservations.total_amount ? \"$\"+reservations.total_amount : \'-\'}}</td><td \nclass=\"cursorPointer\">{{reservations.average_daily_rate ? \"$\"+reservations.average_daily_rate : \'-\'}}</td><td \nclass=\"cursorPointer\">\n{{reservations.reservation_created_date_formatted ? reservations.reservation_created_date_formatted : \'-\'}}</td><td \nclass=\"cursorPointer\">{{reservations.source_of_creation ? reservations.source_of_creation : \'-\'}}</td></tr></tbody>\n</table></md-table-container></div></div></div></div></div><div style=\"visibility: hidden\"><div \nclass=\"md-dialog-container\" id=\"CustomerTags\"><md-dialog class=\"tax-dialog act-dialog\" style=\"width:650px\"><md-toolbar \nclass=\"md-accent md-tall white-fg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span\n class=\"title\">Manage Customer Tags</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeTagsDialog()\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-height:1000px\" class=\"dilog-lable\"><md-content class=\"md-padding no-margin\"><div><div layout=\"row\" \nlayout-align=\"start center\" class=\"customer-info\"><div class=\"customer-avatar\">{{vm.getCustomerInitials()}}</div><div \nclass=\"ml-10\"><h3 class=\"no-margin\">{{vm.contact.first_name}} {{vm.contact.last_name}}</h3><div class=\"color-grey\">\n{{vm.contact.customer_email}}</div></div></div><md-divider class=\"margin-vertical-15\"></md-divider><div \nclass=\"tags-wrapper\"><div><div class=\"tag-section\"><div class=\"section-header\"><div><h4>Available Tags</h4><p>\nClick a tag to assign it</p></div></div><div layout=\"row\" layout-wrap ng-if=\"vm.systemTags.length\"><md-button \nclass=\"tag-chip\" ng-repeat=\"tag in vm.systemTags | filter:vm.systemTagSearch | filter:vm.unassignedTagsFilter\" \nng-click=\"vm.assignTag(tag,\'system\')\">{{tag.name}}</md-button></div><div class=\"empty-state\" \nng-if=\"(vm.systemTags | filter:vm.systemTagSearch | filter:vm.unassignedTagsFilter).length == 0\">No system tags found.\n</div></div><div class=\"tag-section\"><div class=\"section-header\"><div><h4>Assigned Tags <span class=\"tag-count\">\n({{vm.tempAssignedTags.length}})</span></h4><p>Currently assigned to this customer</p></div><md-button \nng-if=\"vm.tempAssignedTags.length\" class=\"clear-tags-btn\" ng-click=\"vm.clearAllTags()\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"mr-5\"></md-icon>Remove All</md-button></div><div class=\"assigned-tags\" \nng-if=\"vm.tempAssignedTags.length\"><div class=\"assigned-chip\" ng-repeat=\"tag in vm.tempAssignedTags\">{{tag.name}}\n<md-icon md-font-icon=\"icon-close\" class=\"material-icons icon-close\" ng-click=\"vm.removeAssignedTag(tag)\"></md-icon>\n</div></div><div class=\"empty-state\" ng-if=\"!vm.tempAssignedTags.length\">No tags have been assigned to this customer.\n</div></div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.closeTagsDialog()\" \nclass=\"md-raised md-background md-button md-default-theme md-ink-ripple\">Cancel</md-button><md-button \nclass=\"md-raised md-green-500-bg submit-button white-fg\" ng-click=\"vm.saveCustomerTags()\">Save</md-button>\n</md-dialog-actions></md-dialog></div><div class=\"md-dialog-container\" id=\"FamilyMemberDialog\"><md-dialog \nclass=\"tax-dialog act-dialog\" style=\"width:650px\"><md-toolbar class=\"md-accent md-tall white-fg\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.editingFamilyMember ? \'Edit Family Member\' : \'Add Family Member\'}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeFamilyMemberDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll style=\"max-height:1000px\"><md-content class=\"md-padding\"><form \nname=\"familyMemberDialogForm\" novalidate><div class=\"family-member-form-container\"><div class=\"family-member-form-row\">\n<md-autocomplete flex md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedFamilyMemberSearch.first_name\" \nmd-selected-item-change=\"vm.selectFamilyMemberCustomer(item)\" md-search-text=\"vm.familyMemberSearch.first_name\" \nmd-search-text-change=\"vm.familyMemberForm.first_name = vm.familyMemberSearch.first_name\" \nmd-items=\"item in vm.queryFamilyMemberSearch(vm.familyMemberSearch.first_name, \'cust.first_name\')\" \nmd-item-text=\"item.first_name\" md-min-length=\"1\" md-max-length=\"18\" md-delay=\"500\" md-floating-label=\"First Name\" \nclass=\"chooseCustomer full-width family-member-autocomplete\"><md-item-template><span \nmd-highlight-text=\"vm.familyMemberSearch.first_name\" md-highlight-flags=\"^i\">{{item.display || item.first_name}}</span>\n</md-item-template></md-autocomplete><md-autocomplete flex md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedFamilyMemberSearch.last_name\" \nmd-selected-item-change=\"vm.selectFamilyMemberCustomer(item)\" md-search-text=\"vm.familyMemberSearch.last_name\" \nmd-search-text-change=\"vm.familyMemberForm.last_name = vm.familyMemberSearch.last_name\" \nmd-items=\"item in vm.queryFamilyMemberSearch(vm.familyMemberSearch.last_name, \'cust.last_name\')\" \nmd-item-text=\"item.last_name\" md-min-length=\"1\" md-max-length=\"18\" md-delay=\"500\" md-floating-label=\"Last Name\" \nclass=\"chooseCustomer full-width family-member-autocomplete\"><md-item-template><span \nmd-highlight-text=\"vm.familyMemberSearch.last_name\" md-highlight-flags=\"^i\">\n{{item.display || item.first_name + \' \' + item.last_name}}</span></md-item-template></md-autocomplete></div><div \nclass=\"family-member-form-row\"><md-autocomplete flex md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedFamilyMemberSearch.customer_email\" \nmd-selected-item-change=\"vm.selectFamilyMemberCustomer(item)\" md-search-text=\"vm.familyMemberSearch.customer_email\" \nmd-search-text-change=\"vm.familyMemberForm.customer_email = vm.familyMemberSearch.customer_email\" \nmd-items=\"item in vm.queryFamilyMemberSearch(vm.familyMemberSearch.customer_email, \'cust.customer_email\')\" \nmd-item-text=\"item.customer_email\" md-min-length=\"1\" md-max-length=\"100\" md-delay=\"500\" md-floating-label=\"Email\" \nclass=\"chooseCustomer full-width family-member-autocomplete\" name=\"customer_email\" \nng-class=\"{\n										\'email-invalid\':\n											vm.familyMemberSearch.customer_email &&\n											!vm.isValidEmail(vm.familyMemberSearch.customer_email)\n									}\">\n<md-item-template><span md-highlight-text=\"vm.familyMemberSearch.customer_email\" md-highlight-flags=\"^i\">\n{{item.customer_email}}</span></md-item-template></md-autocomplete><md-input-container \nclass=\"md-block family-member-phone\" ng-class=\"{\'md-input-invalid\': !vm.isFamilyMemberPhoneValid}\"><label \nclass=\"phone-number-label\">Phone Number</label><input type=\"tel\" id=\"familyMemberPhoneNumber\" \nname=\"family_member_phone\" class=\"intel-number-input\" intl-tel-input autocomplete=\"off\" \nng-model=\"vm.familyMemberForm.phone_number\" aria-label=\"Phone number\" \nng-change=\"vm.updatePhoneWithCountryCode(\'family_member_phone\', $event);\"></md-input-container></div><div \nclass=\"family-member-form-row\"><md-input-container class=\"md-block\"><label>Relationship</label><md-select \nng-model=\"vm.familyMemberForm.relationship_id\" aria-label=\"Relationship\"><md-option \nng-repeat=\"rel in vm.relationshipTypes\" ng-value=\"rel.id\">{{rel.relationship_name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block family-member-datepicker pet-dob-datepicker\"><label>\nDate of Birth</label><md-datepicker ng-model=\"vm.familyMemberForm.date_of_birth\" md-open-on-focus \nmd-max-date=\"vm.maxDateOfBirth\" aria-label=\"Date of birth\"></md-datepicker></md-input-container></div></div></form>\n</md-content></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.closeFamilyMemberDialog()\" class=\"md-raised md-background\">Cancel</md-button><md-button \nclass=\"md-raised md-accent white-fg\" \nng-disabled=\"\n							!vm.familyMemberForm.first_name ||\n							!vm.familyMemberForm.last_name ||\n							!vm.familyMemberForm.customer_email ||\n							!vm.isValidEmail(vm.familyMemberForm.customer_email) ||\n							!vm.familyMemberForm.relationship_id ||\n							!vm.isFamilyMemberPhoneValid ||\n							vm.isSavingFamilyMember ||\n							vm.isUpdatingFamilyMember\n						\" \nng-click=\"vm.editingFamilyMember ? vm.updateFamilyMember() : vm.saveFamilyMember()\"><md-progress-circular \nng-if=\"vm.isSavingFamilyMember || vm.isUpdatingFamilyMember\" class=\"white-fg\" md-mode=\"indeterminate\" md-diameter=\"16\" \nstyle=\"display:inline-block;vertical-align:middle;margin-right:6px\"></md-progress-circular>\n{{vm.editingFamilyMember ? \'Update\' : \'Add\'}}</md-button></md-dialog-actions></md-dialog></div><div \nclass=\"md-dialog-container\" id=\"PetDialog\"><md-dialog class=\"tax-dialog act-dialog\" style=\"width:650px\"><md-toolbar \nclass=\"md-accent md-tall white-fg\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span\n class=\"title\">{{vm.editingCustomerPet ? \'Edit Pet\' : \'Add Pet\'}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closePetDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"max-height:1000px\"><md-content class=\"md-padding\"><div \nclass=\"pet-form-container\"><md-input-container class=\"md-block\"><label>Pet Name</label><input type=\"text\" \nng-model=\"vm.customerPetForm.name\" aria-label=\"Pet name\"></md-input-container><md-input-container class=\"md-block\">\n<label>Pet Type</label><md-select name=\"petType\" ng-model=\"vm.customerPetForm.pet_type_id\" \nng-disabled=\"vm.petTypes.isloading\" aria-label=\"Pet type\"><md-option \nng-repeat=\"petType in vm.petTypes.data track by petType.id\" ng-value=\"petType.id\">{{petType.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"vm.customerPetForm.pet_type_id == vm.otherPetTypeId\"><label>Other Pet Type</label><input type=\"text\" \nname=\"otherPetType\" ng-model=\"vm.customerPetForm.other_pet_type\" placeholder=\"Enter pet type\" \naria-label=\"Other pet type\"></md-input-container><md-input-container \nclass=\"md-block family-member-datepicker pet-dob-datepicker\"><label>Date of Birth</label><md-datepicker \nng-model=\"vm.customerPetForm.date_of_birth\" md-open-on-focus md-max-date=\"vm.maxDateOfBirth\" \naria-label=\"Pet date of birth\"></md-datepicker></md-input-container></div></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.closePetDialog()\" \nclass=\"md-raised md-background\">Cancel</md-button><md-button class=\"md-raised md-accent white-fg\" \nng-disabled=\"\n							vm.isSavingCustomerPet ||\n							vm.isUpdatingCustomerPet ||\n							!vm.customerPetForm.name ||\n							!vm.customerPetForm.pet_type_id ||\n							(\n								vm.customerPetForm.pet_type_id === vm.otherPetTypeId &&\n								!vm.customerPetForm.other_pet_type\n							)\n						\" \nng-click=\"vm.editingCustomerPet ? vm.updateCustomerPet() : vm.saveCustomerPet()\"><md-progress-circular \nng-if=\"vm.isSavingCustomerPet || vm.isUpdatingCustomerPet\" class=\"white-fg\" md-mode=\"indeterminate\" md-diameter=\"16\" \nstyle=\"display:inline-block;vertical-align:middle;margin-right:6px\"></md-progress-circular>\n{{vm.editingCustomerPet ? \'Update\' : \'Add\'}}</md-button></md-dialog-actions></md-dialog></div></div></div>");
$templateCache.put("app/main/apps/create-res/partials/reservation-summary-readonly.html","<div class=\"reservation-summary-readonly\"><div class=\"pos-summary-lines\"><div class=\"sub-total-section\" layout=\"row\" \nflex=\"100\" layout-wrap><div class=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\"center start\">Subtotal</div>\n<div class=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\"center center\">:</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"35\" layout-align=\"center end\" \nng-if=\"!(vm.summary.cartdetails.resortFeeApplied && vm.summary.cartdetails.resortFeePos != undefined && vm.summary.cartdetails.resortFeePos.extra_attribute == \'resort_fee\')\">\n<span \nng-if=\"vm.summary.cartdetails.extraPersonProduct != undefined && vm.summary.cartdetails.extraPersonProduct.extra_attribute == \'extra_person\'\">\n{{(vm.summary.cartdetails.overalltotals.subtotal - vm.summary.cartdetails.extraPersonProduct.nightlySum) | currency : $ : 2}} \n</span><span \nng-if=\"vm.summary.cartdetails.extraPersonProduct == undefined || vm.summary.cartdetails.extraPersonProduct.extra_attribute == undefined\">\n{{vm.summary.cartdetails.overalltotals.subtotal | currency : $ : 2}}</span></div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"35\" layout-align=\"center end\" \nng-if=\"vm.summary.cartdetails.resortFeeApplied && vm.summary.cartdetails.resortFeePos != undefined && vm.summary.cartdetails.resortFeePos.extra_attribute == \'resort_fee\'\">\n<span \nng-if=\"vm.summary.cartdetails.extraPersonProduct != undefined && vm.summary.cartdetails.extraPersonProduct.extra_attribute == \'extra_person\'\">\n{{(vm.summary.cartdetails.overalltotals.subtotal - vm.summary.cartdetails.resortFeePos.nightlySum - vm.summary.cartdetails.extraPersonProduct.nightlySum) | currency : $ : 2}} \n</span><span \nng-if=\"vm.summary.cartdetails.extraPersonProduct == undefined || vm.summary.cartdetails.extraPersonProduct.extra_attribute == undefined\">\n{{(vm.summary.cartdetails.overalltotals.subtotal - vm.summary.cartdetails.resortFeePos.nightlySum) | currency : $ : 2}}\n</span></div></div><div class=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"50\" layout-align=\"center start\">Discount</div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"15\" layout-align=\"center center\">:</div><div class=\"sub-total-col\" layout=\"column\" flex=\"35\" \nlayout-align=\"center end\"><span \nng-if=\"vm.summary.cartdetails.promoCodeDiscount != undefined && vm.summary.cartdetails.promoCodeDiscount > 0\">\n{{vm.summary.cartdetails.overalltotals.product_discount - vm.summary.cartdetails.promoCodeDiscount | currency : $ : 2}} \n</span><span \nng-if=\"vm.summary.cartdetails.promoCodeDiscount == undefined || vm.summary.cartdetails.promoCodeDiscount <= 0\">\n{{vm.summary.cartdetails.overalltotals.product_discount | currency : $ : 2}}</span></div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.summary.cartdetails.promoCodeDiscount != undefined && vm.summary.cartdetails.promoCodeDiscount > 0\"><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\"center start\">Promo code Discount</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\"center center\">:</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"35\" layout-align=\"center end\">({{vm.summary.cartdetails.promoCodeDiscount | currency : $ : 2}})\n</div></div><div class=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.summary.cartdetails.resortFeeApplied && vm.summary.cartdetails.resortFeePos != undefined && vm.summary.cartdetails.resortFeePos.extra_attribute == \'resort_fee\'\">\n<div class=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\"center start\">\n{{ vm.summary.cartdetails.resortFeePos.product_name }}</div><div class=\"sub-total-col\" layout=\"column\" flex=\"15\" \nlayout-align=\"center center\">:</div><div class=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end\">\n{{vm.summary.cartdetails.resortFeePos.nightlySum | currency : $ : 2}}</div></div><div class=\"sub-total-section\" \nlayout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.summary.cartdetails.overalltotals.tax_names && vm.summary.cartdetails.overalltotals.tax_names.length > 0 && vm.summary.cartdetails.overalltotals.tax_amounts[taxKey] > 0\" \nng-repeat=\"(taxKey,taxValue) in vm.summary.cartdetails.overalltotals.tax_names\"><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"50\" layout-align=\"center start\"><p class=\"m-0\">{{taxValue}} <small \nng-if=\"vm.summary.taxNamedValues[taxValue]\">{{vm.summary.taxNamedValues[taxValue] | currency : $ : 2}}%</small></p>\n</div><div class=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\"center center\">:</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end\">\n{{vm.summary.cartdetails.overalltotals.tax_amounts[taxKey] | currency : $ : 2}}</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"(vm.summary.cartdetails.customerTaxExempt !== undefined && vm.summary.cartdetails.customerTaxExempt) || (vm.summary.cust_info && vm.summary.cust_info.travellerTaxExempt !== undefined && vm.summary.cust_info.travellerTaxExempt)\">\n<div class=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\"center start\"><p class=\"m-0\" \nng-if=\"(vm.summary.cartdetails.customerTaxExempt && vm.summary.cartdetails.travellerTaxExempt) || vm.summary.cartdetails.customerTaxExempt\">\nCustomer Tax Exempt</p><p class=\"m-0\" \nng-if=\"vm.summary.cartdetails.travellerTaxExempt && !vm.summary.cartdetails.customerTaxExempt\">Traveller Tax Exempt</p>\n</div><div class=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\"center center\">:</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end\">{{0 | currency : $ : 2}}</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.summary.cartdetails.overalltotals.surcharge && vm.summary.cartdetails.overalltotals.surcharge > 0\"><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\"center start\">Surcharge</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"15\" layout-align=\"center center\">:</div><div class=\"sub-total-col\" layout=\"column\" flex=\"35\" \nlayout-align=\"center end\">{{vm.summary.cartdetails.overalltotals.surcharge | currency : $ : 2}}</div></div></div></div>");
$templateCache.put("app/main/apps/dashboards/dash-views/dash-main-content.html","<style>\nbutton.md-fab.md-warn.custom-button.md-button.md-default-theme.md-ink-ripple {\n      background-color: #5f6060;\n  }\n  .custom-button{\n    border-radius: 4px !important;\n    margin : 3px 4px !important;\n    font-size: 14px;\n    z-index: 1;\n    box-shadow: none;\n    padding: 3px !important;\n    width: 40px !important;\n    height: 40px !important;\n  }\n  .full-clean{\n    background-color:rgb(76, 176, 80) !important;\n  }\n  .light-clean{\n    background-color: #ec8429 !important;\n  }\n  .white-icon{\n    color: white !important;\n  }\n  .dirty-room{\n    background-color: rgb(244,67,54) !important;\n  }\n  .incidental-card-btn{\n    background-color: #039BE5 !important;\n  }\n  .change-reservation-btn{\n    background-color: #663ab7 !important;\n  }\n  .fullwidthtabs .salescontainer .icon_dashmain md-icon.printicon.active{\n    color: #43bdd4;\n    cursor: pointer;\n  }\n</style><md-content class=\"md-padding\"><div layout=\"row\" class=\"salescontainer\" flex=\"100\" layout-wrap=\"wrap\" \nlayout-align=\"start start\"><div flex-xs flex-gt-xs=\"50\" layout=\"column\"><div layout=\"row\" class=\"cardblock_dash\" \nflex=\"100\" layout-wrap><div flex=\"{{vm.checkInCheckout.length > 2 ? 33 : 50}}\" \nflex-sm=\"{{vm.checkInCheckout.length > 2 ? 33 : 50}}\" flex-xs=\"100\" layout=\"column\" class=\"coldblock_dash\" \nng-repeat=\"(key,value) in vm.checkInCheckout\"><md-card class=\"dash-card onlycursorPointer\" md-theme-watch layout=\"row\" \nflex=\"100\" layout-wrap=\"wrap\" layout-align=\"start start\" ng-click=\"vm.changeCheckInOutView(value.key)\">\n<md-progress-linear class=\"dashboard-lin\" md-mode=\"query\" \nng-if=\"vm.checkInOutLoader[value.key] && vm.srceenwidth >= 2900\"></md-progress-linear><md-card-title layout=\"column\" \nflex=\"100\" layout-align=\"start start\" class=\"checkin-out-card-title\"><md-card-title-text layout=\"row\" flex=\"100\" \nlayout-align=\"start start\" class=\"no-paddingheading\"><span class=\"md-headline\">{{value.val}}</span>\n</md-card-title-text><div class=\"checkin-precheckin-badges\" \nng-if=\"value.val == \'Check In\' && vm.hasPreCheckInCounts()\" ng-click=\"$event.stopPropagation()\"><span \nclass=\"checkin-precheckin-stat precheckin-stat-hover\" ng-if=\"vm.getPreCheckInCount(\'started\') > 0\"><span \nclass=\"precheckin-stat-tooltip\" ng-if=\"vm.getPreCheckInTooltipReservations(\'started\').length\"><span \nclass=\"precheckin-tooltip-arrow\" aria-hidden=\"true\"></span><div class=\"precheckin-tooltip-inner\" \nonwheel=\"event.stopPropagation()\"><div class=\"precheckin-tooltip-header precheckin-tooltip-header-started\"><span \nclass=\"precheckin-tooltip-heading\">Pre Check-In Started</span> <span class=\"precheckin-tooltip-heading-count\">\n{{vm.getPreCheckInCount(\'started\')}}</span></div><table class=\"simple precheckin-tooltip-table\"><thead><tr><th>Name\n</th><th>Chk In</th><th>Chk Out</th><th>Remaining</th></tr></thead><tbody><tr \nng-repeat=\"resv in vm.getPreCheckInTooltipReservations(\'started\')\" \nng-click=\"vm.openReservationPage(resv.reservation_id, resv.confirmation_number)\" style=\"cursor: pointer\"><td><span \nclass=\"precheckin-tooltip-name-cell\"><span class=\"precheckin-tooltip-room\">{{vm.getPreCheckInRoomNumber(resv)}}</span> \n<span class=\"precheckin-tooltip-guest-name\">{{vm.getPreCheckInGuestName(resv)}}</span></span></td><td>\n{{resv.room_stay_from}}</td><td>{{resv.room_stay_to}}</td><td>${{resv.total_remaining_amount}}</td></tr></tbody>\n</table></div></span><img class=\"precheckin-stat-img precheckin-icon-started\" \nsrc=\"assets/icons/pre-checkin-started.svg\" alt=\"Pre Check-In Started\"> <span \nclass=\"checkin-precheckin-stat-count checkin-precheckin-stat-count-started\">{{vm.getPreCheckInCount(\'started\')}}</span>\n </span><span class=\"checkin-precheckin-stat precheckin-stat-hover\" ng-if=\"vm.getPreCheckInCount(\'completed\') > 0\">\n<span class=\"precheckin-stat-tooltip\" ng-if=\"vm.getPreCheckInTooltipReservations(\'completed\').length\"><span \nclass=\"precheckin-tooltip-arrow\" aria-hidden=\"true\"></span><div class=\"precheckin-tooltip-inner\" \nonwheel=\"event.stopPropagation()\"><div class=\"precheckin-tooltip-header precheckin-tooltip-header-completed\"><span \nclass=\"precheckin-tooltip-heading\">Pre Check-In Completed</span> <span class=\"precheckin-tooltip-heading-count\">\n{{vm.getPreCheckInCount(\'completed\')}}</span></div><table class=\"simple precheckin-tooltip-table\"><thead><tr><th>Name\n</th><th>Chk In</th><th>Chk Out</th><th>Remaining</th></tr></thead><tbody><tr \nng-repeat=\"resv in vm.getPreCheckInTooltipReservations(\'completed\')\" \nng-click=\"vm.openReservationPage(resv.reservation_id, resv.confirmation_number)\" style=\"cursor: pointer\"><td><span \nclass=\"precheckin-tooltip-name-cell\"><span class=\"precheckin-tooltip-room\">{{vm.getPreCheckInRoomNumber(resv)}}</span> \n<span class=\"precheckin-tooltip-guest-name\">{{vm.getPreCheckInGuestName(resv)}}</span></span></td><td>\n{{resv.room_stay_from}}</td><td>{{resv.room_stay_to}}</td><td>${{resv.total_remaining_amount}}</td></tr></tbody>\n</table></div></span><img class=\"precheckin-stat-img precheckin-icon-completed\" \nsrc=\"assets/icons/pre-checkin-completed.svg\" alt=\"Pre Check-In Completed\"> <span \nclass=\"checkin-precheckin-stat-count checkin-precheckin-stat-count-completed\">{{vm.getPreCheckInCount(\'completed\')}}\n</span></span></div><md-card-title-media layout=\"row\" flex=\"100\" layout-align=\"center center\" layout-wrap=\"wrap\"><div \nclass=\"md-media-lg card-media blue checkin-card-media\" layout=\"column\" flex=\"100\" layout-align=\"center center\" \nng-if=\"vm.dashboardData.todayCheckInRemaining > 0 && value.val == \'Check In\'\"><span class=\"checkin-main-count\">\n{{vm.dashboardData.todayCheckInRemaining}}</span></div><img class=\"achievement-icon\" \nsrc=\"assets/icons/check-mark-button.svg\" alt=\"Achievement\" \nng-if=\"vm.dashboardData.todayCheckInRemaining <= 0 && value.val == \'Check In\'\"><div \nclass=\"md-media-lg card-media blue checkin-card-media\" layout=\"column\" flex=\"100\" layout-align=\"center center\" \nng-if=\"vm.dashboardData.todayCheckOutRemaining > 0 && value.val == \'Check Out\'\"><span class=\"checkin-main-count\">\n{{vm.dashboardData.todayCheckOutRemaining}}</span></div><img class=\"achievement-icon\" \nsrc=\"assets/icons/check-mark-button.svg\" alt=\"Achievement\" \nng-if=\"vm.dashboardData.todayCheckOutRemaining <= 0 && value.val == \'Check Out\'\"><div \nclass=\"md-media-lg card-media blue checkin-card-media\" layout=\"column\" flex=\"100\" layout-align=\"center center\" \nng-if=\"vm.dashboardData.todayDailyRentalsRemaining > 0 && value.val == \'Daily Rentals\'\"><span \nclass=\"checkin-main-count\">{{vm.dashboardData.todayDailyRentalsRemaining}}</span></div><img class=\"achievement-icon\" \nsrc=\"assets/icons/check-mark-button.svg\" alt=\"Achievement\" \nng-if=\"(!vm.dashboardData.todayDailyRentalsRemaining || vm.dashboardData.todayDailyRentalsRemaining <= 0) && value.val == \'Daily Rentals\'\">\n</md-card-title-media><slider-range min=\"10\" max=\"200\" value-min=\"search.price_min\" value-max=\"search.price_max\" \nclass=\"rangefilter\" ng-if=\"value.val == \'Check In\'\"><div class=\"slidercir\" \nstyle=\"left:{{((vm.dashboardData.todayCheckIn/vm.dashboardData.todayCheckInExpected)*100).toFixed(2)}}%;background:#43bdd4\">\n</div><div class=\"bar blue\" \nstyle=\"width:{{((vm.dashboardData.todayCheckIn/vm.dashboardData.todayCheckInExpected)*100).toFixed(2)}}%;background:#43bdd4\">\n</div></slider-range><slider-range min=\"10\" max=\"200\" value-min=\"search.price_min\" value-max=\"search.price_max\" \nclass=\"rangefilter\" ng-if=\"value.val == \'Check Out\'\"><div class=\"slidercir\" \nstyle=\"left:{{((vm.dashboardData.todayCheckOut/vm.dashboardData.todayCheckOutExpected)*100).toFixed(2)}}%;background:#43bdd4\">\n</div><div class=\"bar blue\" \nstyle=\"width:{{((vm.dashboardData.todayCheckOut/vm.dashboardData.todayCheckOutExpected)*100).toFixed(2)}}%;background:#43bdd4\">\n</div></slider-range><slider-range min=\"10\" max=\"200\" value-min=\"search.price_min\" value-max=\"search.price_max\" \nclass=\"rangefilter\" ng-if=\"value.val == \'Daily Rentals\'\"><div class=\"slidercir\" \nstyle=\"left:{{((vm.dashboardData.todayDailyRentals/vm.dashboardData.todayDailyRentalsExpected)*100).toFixed(2)}}%;background:#43bdd4\">\n</div><div class=\"bar blue\" \nstyle=\"width:{{((vm.dashboardData.todayDailyRentals/vm.dashboardData.todayDailyRentalsExpected)*100).toFixed(2)}}%;background:#43bdd4\">\n</div></slider-range></md-card-title><md-card-actions layout=\"row\" flex=\"100\" layout-align=\"start center\" \nclass=\"expectedvalues\"><div layout=\"column\" layout-align=\" center start\" flex=\"50\"><div>Remaining : &nbsp; <span \nng-if=\"value.val == \'Check In\'\">{{vm.dashboardData.todayCheckInRemaining}} / {{vm.dashboardData.todayCheckInExpected}} \n</span><span ng-if=\"value.val == \'Check Out\'\">\n{{vm.dashboardData.todayCheckOutRemaining}} / {{vm.dashboardData.todayCheckOutExpected}} </span><span \nng-if=\"value.val == \'Daily Rentals\'\">\n{{vm.dashboardData.todayDailyRentalsRemaining || 0}} / {{vm.dashboardData.todayDailyRentalsExpected || 0}}</span></div>\n</div><span layout=\"column\" layout-align=\" center end\" flex=\"50\">{{vm.dashboardData.date}}</span></md-card-actions>\n<table class=\"simple tableofuserouter checkIn-checkOut-Tables\" ng-if=\"vm.srceenwidth >= 2900\" style=\"min-height:150px\">\n<thead><tr class=\"checkin-out-table-head\"><th class=\"namewidth\" \nng-click=\"vm.sortCheckInOut(\'name\', vm.checkInNameSortType[value.key], value.key)\"><div \nclass=\"sort-icon-text-container\"><span class=\"arrow-icon-top\">Name<md-icon \nmd-font-icon=\"{{ (vm.checkInNameSortType[value.key] == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedCheckInColumn[value.key] == \'name\') ? \'sortCol\' : \'\'\"></md-icon><span \nng-if=\"vm.checkinOutSelected == \'checkIn\'\" class=\"sort-icon-text\">Stays</span></span></div></th><th \nclass=\"width10per checkinout-small-column\" \nng-click=\"vm.sortCheckInOut(\'room_stay_from\', vm.checkInPortSortType[value.key], value.key)\"><span \nclass=\"arrow-icon-top\"><div class=\"roomno\">Chk In</div><md-icon \nmd-font-icon=\"{{ (vm.checkInPortSortType[value.key] == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedCheckInColumn[value.key] == \'room_stay_from\') ? \'sortCol\' : \'\'\"></md-icon></span></th><th \nclass=\"width10per checkinout-small-column\" ng-if=\"!vm.isDailyRentalsPortlet(value.key)\" \nng-click=\"vm.sortCheckInOut(\'room_stay_to\', vm.checkOutPortSortType[value.key], value.key)\"><span \nclass=\"arrow-icon-top\"><div class=\"roomno\">Chk Out</div><md-icon \nmd-font-icon=\"{{ (vm.checkOutPortSortType[value.key] == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedCheckInColumn[value.key] == \'room_stay_to\') ? \'sortCol\' : \'\'\"></md-icon></span></th><th \nclass=\"width10per checkinout-small-column\" \nng-click=\"vm.sortCheckInOut(\'total_remaining_amount\', vm.checkRemSortType[value.key], value.key)\"><span \nclass=\"arrow-icon-top\"><div class=\"guest\">Remaining</div><md-icon \nmd-font-icon=\"{{ (vm.checkRemSortType[value.key] == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedCheckInColumn[value.key] == \'total_remaining_amount\') ? \'sortCol\' : \'\'\"></md-icon></span></th><th\n class=\"width21per\" style=\"text-align: center; position: relative\">Action<div class=\"checkin-out-action-header-stack\" \nng-class=\"{\'print-action-btn\': vm.checkinOutSelected == \'checkOut\', \'room-key-doc-btn\': !vm.isRoomLockEncoderVisible() && vm.checkinOutSelected == \'checkIn\'}\">\n<span class=\"icon_dashmain\" \nng-if=\"vm.checkInOutList[value.key].length < 1 && (vm.checkinOutSelected == \'checkIn\' || vm.isDailyRentalsPortlet(vm.checkinOutSelected))\">\n<md-button aria-label=\"Registration Card\" class=\"custom-button md-fab md-mini\" \nng-click=\"vm.printPortletData(\'registration\', value.key)\"><md-tooltip md-direction=\"bottom\" \nmd-visible=\"tooltipVisible\" md-autohide=\"false\">Print all Reg Cards</md-tooltip><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/boarding-pass.svg\" aria-label=\"Registration Card\"></md-icon>\n</md-button></span><span class=\"icon_dashmain\" \nng-if=\"vm.checkInOutList[value.key].length < 1 && (vm.checkinOutSelected == \'checkOut\' || vm.isDailyRentalsPortlet(vm.checkinOutSelected))\">\n<md-button aria-label=\"Invoice\" class=\"custom-button md-fab md-mini\" \nng-click=\"vm.printPortletData(\'invoice\', value.key)\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\" \nmd-autohide=\"false\">Print all Invoices</md-tooltip><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/doc_icon.svg\" aria-label=\"Invoice\"></md-icon></md-button></span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"resv in vm.checkInOutList[value.key]\" style=\"cursor: pointer\" \nclass=\"checkInOut-table-row\" ng-class=\"{\'waiting-for-room-row\': vm.isWaitingForRoom(resv)}\"><td \nstyle=\"background-color:#dedede;padding: 10px\" colspan=\"10\" \nng-if=\"resv.hotel_name != undefined && resv.hotel_name != \'\'\"><b>{{resv.hotel_name}}</b></td><td \nclass=\"namewidth checkin-out-name-cell\" \nng-click=\"vm.openReservationPage(resv.reservation_id, resv.confirmation_number)\" ng-if=\"resv.hotel_name == undefined\">\n<div class=\"imgouterblkmain check-in-out\"><div class=\"imgusertb\"><span class=\"in-house-text-img\"><b><i>\n{{resv.first_room}}</i> <i ng-if=\"resv.second_room != \'\'\">{{resv.second_room}}</i></b></span></div><span \nclass=\"room-precheckin-started-badge\" \nng-if=\"!vm.isDailyRentalsPortlet(value.key) && vm.isPreCheckInFlagSet(resv, \'is_precheckin_started\') && !vm.isPreCheckInFlagSet(resv, \'is_precheckin_completed\')\" \nstyle=\"position: absolute; left: -3px; bottom: 6px; width: 16px; height: 16px; min-width: 16px; min-height: 16px; background: #f8841c; border-radius: 50%; z-index: 2; display: flex; align-items: center; justify-content: center\">\n<svg viewBox=\"0 0 24 24\" style=\"width: 14px; height: 14px\" stroke=\"white\" stroke-width=\"4\" fill=\"none\" \nstroke-linecap=\"round\" stroke-linejoin=\"round\"><polyline points=\"12 5 12 12 18 12\"></polyline></svg><md-tooltip>\nPre Check-In Started</md-tooltip></span><span class=\"room-precheckin-completed-badge\" \nng-if=\"!vm.isDailyRentalsPortlet(value.key) && vm.isPreCheckInFlagSet(resv, \'is_precheckin_completed\')\"><svg \nviewBox=\"390 400 150 125\" style=\"width: 10px; height: 9px; fill: white\"><path \nd=\"M530.3 434.3L452.7 511.9C446.5 518.1 436.4 518.1 430.2 511.9L397.7 479.4C391.5 473.2 391.5 463.1 397.7 456.9C403.9 450.7 414 450.7 420.2 456.9L441.4 478.1L507.8 411.7C514 405.5 524.1 405.5 530.3 411.7C536.5 417.9 536.5 428 530.3 434.3z\"/>\n</svg><md-tooltip>Pre Check-In Completed</md-tooltip></span><div \nng-class=\"{\'inner-row-div\': vm.hasCheckInRowStatusIcons(resv, value.key), \'has-row-addon-icons\': vm.hasReservationAddonIcons(resv)}\">\n<span class=\"inner-row-span\">{{resv.first_name}} {{resv.last_name}} <span \nclass=\"checkin-row-precheckin-icon stays-count-icon stays-stat-hover\" \nng-if=\"value.key == \'checkIn\' && vm.getGuestStaysCount(resv) > 0\" \nng-class=\"{\'stays-tooltip-open\': vm.isGuestStaysTooltipOpen(resv, \'checkIn\')}\" \nng-click=\"vm.toggleGuestStaysTooltip($event, resv, \'checkIn\')\"><span class=\"checkin-row-stays-count\">\n{{vm.getGuestStaysCount(resv)}}</span><md-tooltip md-direction=\"top\">No. of Stays: {{vm. getGuestStaysCount(resv)}}\n</md-tooltip></span><span class=\"customer-tag-wrapper\" ng-if=\"resv.customer_tags && resv.customer_tags.length\"><md-icon\n md-font-icon=\"icon-tag\" class=\"customer-tag-icon\"></md-icon><md-tooltip md-direction=\"top\">\n{{vm.getCustomerTagNames(resv.customer_tags)}}</md-tooltip></span></span><span class=\"checkin-row-precheckin-icons\" \nng-if=\"vm.hasReservationAddonIcons(resv)\"><span class=\"checkin-row-precheckin-icon\" \nng-class=\"[\'addon-cat-\' + vm.getAddonIconName(addonKey), {\'addon-cat-badge\': !vm.isEarlyOrLateAddon(addonKey)}]\" \nng-repeat=\"(addonKey, addonList) in resv.addons track by addonKey\" \nng-if=\"vm.isValidAddonCategory(addonKey, addonList)\"><img class=\"checkin-addon-category-icon\" \nng-class=\"{\'addon-icon-sm\': !vm.isEarlyOrLateAddon(addonKey)}\" ng-src=\"{{vm.getAddonIconUrl(addonKey)}}\" \nalt=\"{{vm.getAddonIconName(addonKey)}}\" onerror=\"this.style.display=\'none\'\"><md-tooltip md-direction=\"top\">\n{{vm.getAddonTooltip(resv, addonKey)}}</md-tooltip></span></span></div></div></td><td \nclass=\"width10per checkinout-small-column\" ng-if=\"resv.hotel_name == undefined\"><div class=\"roomno\" \nng-click=\"vm.openReservationPage(resv.reservation_id, resv.confirmation_number)\">{{resv.room_stay_from}}</div></td><td \nclass=\"width10per checkinout-small-column\" \nng-if=\"resv.hotel_name == undefined && !vm.isDailyRentalsPortlet(value.key)\"><div class=\"roomno\" \nng-click=\"vm.openReservationPage(resv.reservation_id, resv.confirmation_number)\">{{resv.room_stay_to}}</div></td><td \nclass=\"width10per checkinout-small-column\" ng-if=\"resv.hotel_name == undefined\"><div class=\"guest\" \nng-click=\"vm.openReservationPage(resv.reservation_id, resv.confirmation_number)\">${{resv.total_remaining_amount}}</div>\n</td><td class=\"width20per\" class=\"badgescenter badgestxt\" ng-if=\"resv.hotel_name == undefined\"><div \nclass=\"width-of-action-btn\"><span \nng-if=\"value.key == \'checkIn\' || (vm.isDailyRentalsPortlet(value.key) && vm.hasRoomAssigned(resv) && vm.showDailyRentalCheckIn(resv))\">\n<md-button class=\"md-fab custom-button waiting-for-room-btn\" aria-label=\"Waiting for Room\" \nng-disabled=\"vm.isWaitingForRoom(resv)\" ng-click=\"vm.setWaitingForRoom($event, $index, value.key);\"><md-icon \nmd-font-icon=\"icon-clock\" class=\"white-icon close-icon1 font-size-12\" \nng-class=\"{\'onlycursorPointer\': !vm.isWaitingForRoom(resv)}\"></md-icon></md-button><md-tooltip \nng-if=\"!vm.isWaitingForRoom(resv)\">Waiting for Room</md-tooltip></span><span \nng-if=\"!vm.isDailyRentalsPortlet(value.key) || vm.hasRoomAssigned(resv)\" \nng-click=\"vm.toggleCleaningStatus($event, $index, value.key)\"><md-button class=\"md-fab custom-button\" \naria-label=\"Cleaning Status\" \nng-class=\"{\'dirty-room\':resv.product_is_clean == \'0\',\'full-clean\':resv.product_is_clean == \'1\',\'light-clean\':resv.product_is_clean == \'2\'}\">\n<md-icon md-font-icon=\"icon-broom white-icon\" ng-if=\"resv.product_is_clean == \'0\'\"></md-icon><md-icon \nmd-font-icon=\"icon-check-circle white-icon\" ng-if=\"resv.product_is_clean == \'1\'\"></md-icon><md-icon \nmd-svg-src=\"assets/icons/light_cleaning_white.svg\" ng-if=\"resv.product_is_clean == \'2\'\"></md-icon><md-tooltip \nng-if=\"resv.product_is_clean == \'0\'\">Dirty</md-tooltip><md-tooltip ng-if=\"resv.product_is_clean == \'1\'\">Full Clean\n</md-tooltip><md-tooltip ng-if=\"resv.product_is_clean == \'2\'\">Light Clean</md-tooltip></md-button></span><span>\n<md-button \nng-if=\"value.val ==\'Check In\' || (vm.isDailyRentalsPortlet(value.key) && vm.hasRoomAssigned(resv) && vm.showDailyRentalCheckIn(resv))\" \nclass=\"md-fab custom-button\" aria-label=\"Check In\" style=\"background: #663ab7\" \nng-click=\"vm.changeCheckInOutStatus(\'Checked-In\', $index, value.key);\"><md-icon \nmd-svg-src=\"assets/images/ecommerce/from.svg\" class=\"white-icon close-icon1 font-size-12 onlycursorPointer\"></md-icon>\n<md-tooltip>Check In</md-tooltip></md-button><md-button \nng-if=\"value.val ==\'Check Out\' || (vm.isDailyRentalsPortlet(value.key) && vm.hasRoomAssigned(resv) && vm.showDailyRentalCheckOut(resv))\" \nclass=\"md-fab custom-button\" aria-label=\"Check Out\" style=\"background: #f8841c\" \nng-click=\"vm.changeCheckInOutStatus(\'Checked-Out\', $index, value.key);\"><md-icon \nmd-svg-src=\"assets/images/ecommerce/to.svg\" class=\"white-icon close-icon1 font-size-12 onlycursorPointer\"></md-icon>\n<md-tooltip>Check Out</md-tooltip></md-button></span><span><md-button class=\"md-fab custom-button\" \naria-label=\"Add Service\" md-colors=\"light-blue\" ng-click=\"vm.gotoPosPage(resv)\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/room-service.svg\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer\"><md-tooltip>{{\'CREATE_RES.ADD_SERVICE\' | translate}}\n</md-tooltip></md-icon></md-button></span><span \nng-if=\"(value.key == \'checkIn\' || (vm.isDailyRentalsPortlet(value.key) && vm.showDailyRentalCheckIn(resv))) && vm.hasRoomAssigned(resv) && vm.isRoomLockEncoderVisible()\" \nng-init=\"row=resv\"><md-button class=\"md-fab custom-button\" aria-label=\"Generate Room Key\" style=\"background: #546e7a\" \nng-click=\"vm.openKeyCardDialog($event, resv)\"><md-icon md-svg-src=\"assets/images/room_key_icon.svg\" \nclass=\"white-icon close-icon1 font-size-12 onlycursorPointer\"></md-icon><md-tooltip>Generate Room Key</md-tooltip>\n</md-button></span><span \nng-if=\"resv.hotel_name == undefined && (vm.checkinOutSelected == \'checkIn\' || vm.isDailyRentalsPortlet(value.key))\" \nclass=\"print-action-btn\"><md-button aria-label=\"Registration Card\" class=\"custom-button md-fab md-mini\" \nng-click=\"vm.printRegistrationCard(resv)\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\" \nmd-autohide=\"false\">Print Reg Card</md-tooltip><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/boarding-pass.svg\" aria-label=\"Registration Card\"></md-icon>\n</md-button></span><span \nng-if=\"resv.hotel_name == undefined && (vm.checkinOutSelected == \'checkOut\' || (vm.isDailyRentalsPortlet(value.key) && vm.showDailyRentalPrintInvoice(resv)))\" \nclass=\"print-action-btn\"><md-button aria-label=\"Invoice\" class=\"custom-button md-fab md-mini\" \nng-click=\"vm.printinvoice(resv)\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\" md-autohide=\"false\">\nPrint Invoice</md-tooltip><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/doc_icon.svg\" \naria-label=\"Invoice\"></md-icon></md-button></span></div></td></tr><tr ng-if=\"vm.checkInOutList[value.key].length == 0\">\n<td class=\"text-center\" colspan=\"5\">No Record Found</td></tr></tbody></table></md-card></div><md-card \nclass=\"card-full-tb-blk\" ng-if=\"vm.srceenwidth < 2900\"><div class=\"card-full-tb-blk-inner\" \nng-class=\"{\n                            \'two-portlets\': vm.checkInCheckout.length <= 2,\n                            \'posMiddleArrow\': vm.checkinOutSelected == \'checkOut\',\n                            \'posRightArrow\': vm.checkinOutSelected == \'dailyRentals\'\n                         }\">\n<div class=\"tb-res-full-wid\" \nstyle=\"{{vm.checkInOutList[vm.checkinOutSelected].length > 0 ? \'min-height:155px;\' : \'\'}}\"><table \nclass=\"simple tableofuserouter checkIn-checkOut-Tables table-for-checkin-checkout\"><md-progress-linear \nclass=\"dashboard-lin\" md-mode=\"query\" ng-if=\"vm.checkInOutLoader[vm.checkinOutSelected]\"></md-progress-linear><thead>\n<tr class=\"checkin-out-table-head\"><th class=\"namewidth\" \nng-click=\"vm.sortCheckInOut(\'name\', vm.checkInNameSortType[vm.checkinOutSelected], vm.checkinOutSelected)\"><div \nclass=\"sort-icon-text-container\"><span class=\"arrow-icon-top\">Name<md-icon \nmd-font-icon=\"{{ (vm.checkInNameSortType[vm.checkinOutSelected] == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedCheckInColumn[vm.checkinOutSelected] == \'name\') ? \'sortCol\' : \'\'\"></md-icon><span \nng-if=\"vm.checkinOutSelected == \'checkIn\'\" class=\"sort-icon-text\">Stays</span></span></div></th><th \nclass=\"width10per checkinout-small-column\" \nng-click=\"vm.sortCheckInOut(\'room_stay_from\', vm.checkInPortSortType[vm.checkinOutSelected], vm.checkinOutSelected)\">\n<span class=\"arrow-icon-top\"><div class=\"roomno\">Chk In</div><md-icon \nmd-font-icon=\"{{ (vm.checkInPortSortType[vm.checkinOutSelected] == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedCheckInColumn[vm.checkinOutSelected] == \'room_stay_from\') ? \'sortCol\' : \'\'\"></md-icon></span>\n</th><th class=\"width10per checkinout-small-column\" ng-if=\"!vm.isDailyRentalsPortlet(vm.checkinOutSelected)\" \nng-click=\"vm.sortCheckInOut(\'room_stay_to\', vm.checkOutPortSortType[vm.checkinOutSelected], vm.checkinOutSelected)\">\n<span class=\"arrow-icon-top\"><div class=\"roomno\">Chk Out</div><md-icon \nmd-font-icon=\"{{ (vm.checkOutPortSortType[vm.checkinOutSelected] == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedCheckInColumn[vm.checkinOutSelected] == \'room_stay_to\') ? \'sortCol\' : \'\'\"></md-icon></span></th>\n<th class=\"width10per checkinout-small-column\" \nng-click=\"vm.sortCheckInOut(\'total_remaining_amount\', vm.checkRemSortType[vm.checkinOutSelected], vm.checkinOutSelected)\">\n<span class=\"arrow-icon-top\"><div class=\"guest\">Remaining</div><md-icon \nmd-font-icon=\"{{ (vm.checkRemSortType[vm.checkinOutSelected] == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedCheckInColumn[vm.checkinOutSelected] == \'total_remaining_amount\') ? \'sortCol\' : \'\'\"></md-icon>\n</span></th><th class=\"width21per\" style=\"text-align: center; position: relative\">Action<div \nclass=\"checkin-out-action-header-stack\" \nng-class=\"{\'print-action-btn\': vm.checkinOutSelected == \'checkOut\', \'room-key-doc-btn\': !vm.isRoomLockEncoderVisible() && vm.checkinOutSelected == \'checkIn\'}\">\n<span \nng-if=\"vm.checkInOutList[vm.checkinOutSelected].length > 0 && (vm.checkinOutSelected == \'checkIn\' || vm.isDailyRentalsPortlet(vm.checkinOutSelected))\" \nclass=\"onlycursorPointer\"><md-button aria-label=\"Registration Card\" class=\"custom-button md-fab md-mini\" \nng-click=\"vm.printPortletData(\'registration\', vm.checkinOutSelected)\"><md-tooltip md-direction=\"bottom\" \nmd-visible=\"tooltipVisible\" md-autohide=\"false\">Print all Reg Cards</md-tooltip><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/boarding-pass.svg\" aria-label=\"Registration Card\"></md-icon>\n</md-button></span><span \nng-if=\"vm.checkInOutList[vm.checkinOutSelected].length > 0 && (vm.checkinOutSelected == \'checkOut\' || vm.isDailyRentalsPortlet(vm.checkinOutSelected))\" \nclass=\"onlycursorPointer\"><md-button aria-label=\"Invoice\" class=\"custom-button md-fab md-mini\" \nng-click=\"vm.printPortletData(\'invoice\', vm.checkinOutSelected)\"><md-tooltip md-direction=\"bottom\" \nmd-visible=\"tooltipVisible\" md-autohide=\"false\">Print all Invoices</md-tooltip><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/doc_icon.svg\" aria-label=\"Invoice\"></md-icon></md-button></span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"resv in vm.checkInOutList[vm.checkinOutSelected]\" \nstyle=\"cursor: pointer\" class=\"checkInOut-table-row\" ng-class=\"{\'waiting-for-room-row\': vm.isWaitingForRoom(resv)}\"><td\n style=\"background-color:#dedede;padding: 10px\" colspan=\"10\" \nng-if=\"resv.hotel_name != undefined && resv.hotel_name != \'\'\"><b>{{resv.hotel_name}}</b></td><td \nclass=\"namewidth checkin-out-name-cell\" \nng-click=\"vm.openReservationPage(resv.reservation_id, resv.confirmation_number)\" ng-if=\"resv.hotel_name == undefined\">\n<div class=\"imgouterblkmain check-in-out\"><div class=\"imgusertb\"><span class=\"in-house-text-img\"><b><i>\n{{resv.first_room}}</i> <i ng-if=\"resv.second_room != \'\'\">{{resv.second_room}}</i></b></span></div><span \nclass=\"room-precheckin-started-badge\" \nng-if=\"!vm.isDailyRentalsPortlet(vm.checkinOutSelected) && vm.isPreCheckInFlagSet(resv, \'is_precheckin_started\') && !vm.isPreCheckInFlagSet(resv, \'is_precheckin_completed\')\" \nstyle=\"position: absolute; left: -3px; bottom: 6px; width: 16px; height: 16px; min-width: 16px; min-height: 16px; background: #f8841c; border-radius: 50%; z-index: 2; display: flex; align-items: center; justify-content: center\">\n<svg viewBox=\"0 0 24 24\" style=\"width: 14px; height: 14px\" stroke=\"white\" stroke-width=\"4\" fill=\"none\" \nstroke-linecap=\"round\" stroke-linejoin=\"round\"><polyline points=\"12 5 12 12 18 12\"></polyline></svg><md-tooltip>\nPre Check-In Started</md-tooltip></span><span class=\"room-precheckin-completed-badge\" \nng-if=\"!vm.isDailyRentalsPortlet(vm.checkinOutSelected) && vm.isPreCheckInFlagSet(resv, \'is_precheckin_completed\')\">\n<svg viewBox=\"390 400 150 125\" style=\"width: 10px; height: 9px; fill: white\"><path \nd=\"M530.3 434.3L452.7 511.9C446.5 518.1 436.4 518.1 430.2 511.9L397.7 479.4C391.5 473.2 391.5 463.1 397.7 456.9C403.9 450.7 414 450.7 420.2 456.9L441.4 478.1L507.8 411.7C514 405.5 524.1 405.5 530.3 411.7C536.5 417.9 536.5 428 530.3 434.3z\"/>\n</svg><md-tooltip>Pre Check-In Completed</md-tooltip></span><div \nng-class=\"{\'inner-row-div\': vm.hasCheckInRowStatusIcons(resv, vm.checkinOutSelected), \'has-row-addon-icons\': vm.hasReservationAddonIcons(resv)}\">\n<span class=\"inner-row-span\">{{resv.first_name}} {{resv.last_name}} <span \nclass=\"checkin-row-precheckin-icon stays-count-icon stays-stat-hover\" \nng-if=\"vm.checkinOutSelected == \'checkIn\' && vm.getGuestStaysCount(resv) > 0\" \nng-class=\"{\'stays-tooltip-open\': vm.isGuestStaysTooltipOpen(resv, \'checkInList\')}\" \nng-click=\"vm.toggleGuestStaysTooltip($event, resv, \'checkInList\')\"><span class=\"checkin-row-stays-count\">\n{{vm.getGuestStaysCount(resv)}}</span><md-tooltip md-direction=\"top\">No. of Stays: {{vm. getGuestStaysCount(resv)}}\n</md-tooltip></span><span class=\"customer-tag-wrapper\" ng-if=\"resv.customer_tags && resv.customer_tags.length\"><md-icon\n md-font-icon=\"icon-tag\" class=\"customer-tag-icon\"></md-icon><md-tooltip md-direction=\"top\">\n{{vm.getCustomerTagNames(resv.customer_tags)}}</md-tooltip></span></span><span class=\"checkin-row-precheckin-icons\" \nng-if=\"vm.hasReservationAddonIcons(resv)\"><span class=\"checkin-row-precheckin-icon\" \nng-class=\"[\'addon-cat-\' + vm.getAddonIconName(addonKey), {\'addon-cat-badge\': !vm.isEarlyOrLateAddon(addonKey)}]\" \nng-repeat=\"(addonKey, addonList) in resv.addons track by addonKey\" \nng-if=\"vm.isValidAddonCategory(addonKey, addonList)\"><img class=\"checkin-addon-category-icon\" \nng-class=\"{\'addon-icon-sm\': !vm.isEarlyOrLateAddon(addonKey)}\" ng-src=\"{{vm.getAddonIconUrl(addonKey)}}\" \nalt=\"{{vm.getAddonIconName(addonKey)}}\" onerror=\"this.style.display=\'none\'\"><md-tooltip md-direction=\"top\">\n{{vm.getAddonTooltip(resv, addonKey)}}</md-tooltip></span></span></div></div></td><td \nclass=\"width10per checkinout-small-column\" ng-if=\"resv.hotel_name == undefined\"><div class=\"roomno\" \nng-click=\"vm.openReservationPage(resv.reservation_id, resv.confirmation_number)\">{{resv.room_stay_from}}</div></td><td \nclass=\"width10per checkinout-small-column\" \nng-if=\"resv.hotel_name == undefined && !vm.isDailyRentalsPortlet(vm.checkinOutSelected)\"><div class=\"roomno\" \nng-click=\"vm.openReservationPage(resv.reservation_id, resv.confirmation_number)\">{{resv.room_stay_to}}</div></td><td \nclass=\"width10per checkinout-small-column\" ng-if=\"resv.hotel_name == undefined\"><div class=\"guest\" \nng-click=\"vm.openReservationPage(resv.reservation_id, resv.confirmation_number)\">${{resv.total_remaining_amount}}</div>\n</td><td class=\"width20per\"><div class=\"checkInOut-action-col\"><span \nng-if=\"resv.hotel_name == undefined && (vm.checkinOutSelected == \'checkIn\' || (vm.isDailyRentalsPortlet(vm.checkinOutSelected) && vm.hasRoomAssigned(resv) && vm.showDailyRentalCheckIn(resv)))\" \nclass=\"common-btn-key\"><md-button class=\"md-fab custom-button waiting-for-room-btn\" aria-label=\"Waiting for Room\" \nng-disabled=\"vm.isWaitingForRoom(resv)\" ng-click=\"vm.setWaitingForRoom($event, $index, vm.checkinOutSelected);\">\n<md-icon md-font-icon=\"icon-clock\" class=\"white-icon close-icon1 font-size-12\" \nng-class=\"{\'onlycursorPointer\': !vm.isWaitingForRoom(resv)}\"></md-icon></md-button><md-tooltip \nng-if=\"!vm.isWaitingForRoom(resv)\">Waiting for Room</md-tooltip></span><span \nng-if=\"resv.hotel_name == undefined && (!vm.isDailyRentalsPortlet(vm.checkinOutSelected) || vm.hasRoomAssigned(resv))\" \nng-click=\"vm.toggleCleaningStatus($event, $index, vm.checkinOutSelected)\" class=\"common-btn-key\"><md-button \nclass=\"md-fab custom-button\" aria-label=\"Cleaning Status\" \nng-class=\"{\'dirty-room\':resv.product_is_clean == \'0\',\'full-clean\':resv.product_is_clean == \'1\',\'light-clean\':resv.product_is_clean == \'2\'}\">\n<md-icon md-font-icon=\"icon-broom white-icon\" ng-if=\"resv.product_is_clean == \'0\'\"></md-icon><md-icon \nmd-font-icon=\"icon-check-circle white-icon\" ng-if=\"resv.product_is_clean == \'1\'\"></md-icon><md-icon \nmd-svg-src=\"assets/icons/light_cleaning_white.svg\" ng-if=\"resv.product_is_clean == \'2\'\"></md-icon><md-tooltip \nng-if=\"resv.product_is_clean == \'0\'\">Dirty</md-tooltip><md-tooltip ng-if=\"resv.product_is_clean == \'1\'\">Full Clean\n</md-tooltip><md-tooltip ng-if=\"resv.product_is_clean == \'2\'\">Light Clean</md-tooltip></md-button></span><span \nng-if=\"resv.hotel_name == undefined\" class=\"common-btn-key\"><md-button \nng-if=\"vm.checkinOutSelected == \'checkIn\' || (vm.isDailyRentalsPortlet(vm.checkinOutSelected) && vm.hasRoomAssigned(resv) && vm.showDailyRentalCheckIn(resv))\" \nclass=\"md-fab custom-button\" aria-label=\"Check In\" style=\"background: #663ab7\" \nng-click=\"vm.changeCheckInOutStatus(\'Checked-In\', $index, vm.checkinOutSelected);\"><md-icon \nmd-svg-src=\"assets/images/ecommerce/from.svg\" class=\"white-icon close-icon1 font-size-12 onlycursorPointer\"></md-icon>\n<md-tooltip>Check In</md-tooltip></md-button><md-button \nng-if=\"vm.checkinOutSelected == \'checkOut\' || (vm.isDailyRentalsPortlet(vm.checkinOutSelected) && vm.hasRoomAssigned(resv) && vm.showDailyRentalCheckOut(resv))\" \nclass=\"md-fab custom-button\" aria-label=\"Check Out\" style=\"background: #f8841c\" \nng-click=\"vm.changeCheckInOutStatus(\'Checked-Out\', $index, vm.checkinOutSelected);\"><md-icon \nmd-svg-src=\"assets/images/ecommerce/to.svg\" class=\"white-icon close-icon1 font-size-12 onlycursorPointer\"></md-icon>\n<md-tooltip>Check Out</md-tooltip></md-button></span><span ng-if=\"resv.hotel_name == undefined\" class=\"common-btn-key\">\n<md-button class=\"md-fab custom-button\" aria-label=\"Add Service\" md-colors=\"light-blue\" \nng-click=\"vm.gotoPosPage(resv)\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/room-service.svg\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer\"><md-tooltip>{{\'CREATE_RES.ADD_SERVICE\' | translate}}\n</md-tooltip></md-icon></md-button></span><span \nng-if=\"resv.hotel_name == undefined && (vm.checkinOutSelected == \'checkIn\' || (vm.isDailyRentalsPortlet(vm.checkinOutSelected) && vm.showDailyRentalCheckIn(resv))) && vm.hasRoomAssigned(resv) && vm.isRoomLockEncoderVisible()\" \nclass=\"common-btn-key room-key-btn\"><md-button class=\"md-fab custom-button generate-room-key-btn\" \naria-label=\"Generate Room Key\" style=\"background: #546e7a\" ng-click=\"vm.openKeyCardDialog($event, resv)\"><md-icon \nmd-svg-src=\"assets/images/room_key_icon.svg\" class=\"white-icon close-icon1 font-size-12 onlycursorPointer\"></md-icon>\n<md-tooltip>Generate Room Key</md-tooltip></md-button></span><span \nng-if=\"resv.hotel_name == undefined && (vm.checkinOutSelected == \'checkIn\' || vm.isDailyRentalsPortlet(vm.checkinOutSelected))\" \nclass=\"print-action-btn\"><md-button aria-label=\"Registration Card\" \nclass=\"custom-button md-fab md-mini print-registration-card-btn\" ng-click=\"vm.printRegistrationCard(resv)\"><md-tooltip \nmd-direction=\"bottom\" md-visible=\"tooltipVisible\" md-autohide=\"false\">Print Reg Card</md-tooltip><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/boarding-pass.svg\" aria-label=\"Registration Card\"></md-icon>\n</md-button></span><span \nng-if=\"resv.hotel_name == undefined && (vm.checkinOutSelected == \'checkOut\' || (vm.isDailyRentalsPortlet(vm.checkinOutSelected) && vm.showDailyRentalPrintInvoice(resv)))\" \nclass=\"print-action-btn\"><md-button aria-label=\"Invoice\" class=\"custom-button md-fab md-mini\" \nng-click=\"vm.printinvoice(resv)\"><md-tooltip md-direction=\"bottom\" md-visible=\"tooltipVisible\" md-autohide=\"false\">\nPrint Invoice</md-tooltip><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/doc_icon.svg\" \naria-label=\"Invoice\"></md-icon></md-button></span></div></td></tr><tr \nng-if=\"vm.checkInOutList[vm.checkinOutSelected].length == 0\"><td class=\"text-center\" colspan=\"5\">No Record Found</td>\n</tr></tbody></table></div></div></md-card></div><md-card ng-if=\"vm.loadRemHtml\"><md-progress-linear \nclass=\"dashboard-lin\" md-mode=\"query\" ng-if=\"vm.roomStatusLoader\"></md-progress-linear><md-card-title flex=\"100\" \nlayout-wrap=\"wrap\" layout=\"row\"><md-card-title-text flex=\"100\" layout=\"column\"><span class=\"md-headline\">Room Status\n</span></md-card-title-text><md-card-title-media flex=\"100\" layout=\"column\"><div class=\"card-middlesection\"><div \nflex=\"100\" layout=\"row\"><div flex=\"60\" layout=\"column\"><highchart id=\"chart11\" class=\"loads-tracking\" \nconfig=\"roomStatusConfig\" class=\"span9\" ng-show=\"vm.roomStatusExist && !vm.roomStatusLoader\"></highchart><div \nng-if=\"!vm.roomStatusExist\" class=\"text-center\">No Data Found</div></div><div flex=\"40\" layout=\"column\"><ul \nclass=\"print-listing chart-color\"><li ng-click=\"vm.showRoomStatus(\'In Cleaning\', vm.roomStatusPieChart.inCleaning)\" \nclass=\"onlycursorPointer\"><span style=\"background:#24BCD1\"></span><p>In Cleaning <b>\n{{vm.roomStatusPieChart.inCleaning}}</b></p></li><li \nng-click=\"vm.showRoomStatus(\'Available\', vm.roomStatusPieChart.available)\" class=\"onlycursorPointer\"><span \nstyle=\"background:#303540\"></span><p>Available <b>{{vm.roomStatusPieChart.available}}</b></p></li><li \nng-click=\"vm.showRoomStatus(\'Out of Service\', vm.roomStatusPieChart.outOfService)\" class=\"onlycursorPointer\"><span \nstyle=\"background:#FF5861\"></span><p>Out of Service <b>{{vm.roomStatusPieChart.outOfService}}</b></p></li><li \nclass=\"totalval\"><p>Total <b>{{ vm.roomStatusPieChart.totalRooms }}</b></p></li></ul></div></div></div>\n</md-card-title-media></md-card-title></md-card><md-card style=\"min-height: 200px\" ng-if=\"vm.loadRemHtml\">\n<md-progress-linear class=\"dashboard-lin\" md-mode=\"query\" ng-show=\"vm.latestTasksLoader\"></md-progress-linear>\n<md-card-title flex=\"100\" layout-wrap=\"wrap\" layout=\"row\"><md-card-title-text flex=\"100\" layout=\"column\"><span \nclass=\"md-headline\">Today Issues</span></md-card-title-text><md-card-title-media flex=\"100\" layout=\"column\"><md-content\n ms-scroll class=\"scrollcontentmain\"><div class=\"card-middlesection\"><div class=\"lastest-taskblock\"><div \nclass=\"latest-task-row\"><div class=\"text-center\">No Data Found</div></div></div></div></md-content>\n</md-card-title-media></md-card-title></md-card><md-card \nng-if=\"vm.loadRemHtml && (((vm.currentHotelId == 126 || vm.currentHotelId == 122 || vm.currentHotelId == 129 || vm.currentHotelId == 135) && vm.pageFor != \'room\') || (vm.currentHotelId != 126 && vm.currentHotelId != 122 && vm.currentHotelId != 129 && vm.currentHotelId != 135))\">\n<md-progress-linear class=\"dashboard-lin\" md-mode=\"query\" ng-if=\"vm.availabilityLoader\"></md-progress-linear>\n<md-card-title flex=\"100\" layout-wrap=\"wrap\" layout=\"row\"><md-card-title-text flex=\"100\" layout=\"column\"><span \nclass=\"md-headline\">Availability</span></md-card-title-text><md-card-title-media flex=\"100\" layout=\"column\"><div \nclass=\"card-middlesection availability-portlet-cls\"><div class=\"roomsinfoblock\"><div class=\"roominforow\" layout=\"row\" \nflex=\"100\" layout-align=\"center stretch\"><div class=\"roomNamecol\" layout=\"column\" layout-align=\"center start\"><div \nlayout=\"row\" layout-align=\"start stretch\" class=\"nameblock\" flex=\"100\" layout-wrap><div class=\"nameblkcol heading\" \nlayout=\"column\" layout-align=\"center start\" flex=\"100\">Room</div><div \nclass=\"nameblkcol lower-prt {{value.product_name | strReplaceRoom }}\" \nng-class=\"value.hotel_name !== undefined ? \'sub-hotel-class\' : \'\'\" layout=\"column\" layout-align=\"center start\" \nflex=\"100\" ng-repeat=\"value in vm.availableRooms\"><div class=\"txtinnercontent\">{{value.product_name}}</div></div></div>\n</div><div class=\"roomdatecol\" layout=\"column\" layout-align=\"center start\"><div class=\"scrollblock\" ms-scroll><div \nlayout=\"row\" layout-align=\"start stretch\" class=\"dateouterrow headingdateblk\"><div class=\"roomNamecolsm\" \nlayout=\"column\" layout-align=\"center center\" ng-repeat=\"dat in vm.topHeadDates\"><div class=\"innercontentdate\">\n{{dat.date}} <span>{{dat.day}}</span></div></div></div><div layout=\"row\" layout-align=\"start stretch\" \nclass=\"dateouterrow {{value | strReplaceRoom }}\" ng-repeat=\"(value,key) in vm.availableRoomsDates\"><div \nclass=\"roomNamecolsm mls {{val.date}}\" layout=\"column\" layout-align=\"center center\" \nng-repeat=\"val in key track by $index\" \nng-class=\"val.availability == \'booked\' ? \'bookedClass\' : (val.availability == \'hold\' ? \'holdClass\' : (val.availability == \'block\' ? \'blockedClass\' : (val.availability == \'occupancy\' ? \'occupClass\' : \'availClass\'))) \" \nng-click=\"vm.showResvBookPopup(val.availability, val.date, val.product_id, val.product_name)\" \nng-mouseenter=\"vm.showMLSPopup(val,value); vm.showAvailStatusPopup($event, val)\" \nng-mouseleave=\"vm.hideMLSPopup(val,value); vm.hideAvailStatusPopup()\" \nid=\"col_{{value | strReplaceRoom }}_row_{{val.date}}\"><i class=\"mls-yellow\" \nng-if=\"val.availability == \'available\' && val.mls != \'\' && val.mls > 1\">{{val.mls}}</i> <span \nclass=\"icon-close avail-status-icon\" ng-if=\"val.availability == \'booked\'\"></span> <span \nng-if=\"val.availability == \'available\' && val.rate != \'\'\">${{val.rate}}</span> <span \nng-if=\"val.availability == \'occupancy\'\">{{val.rate}}%</span></div></div></div></div></div><div \nclass=\"room-color-detail\" layout=\"row\" flex=\"100\" layout-align=\"center stretch\" layout-wrap><span><i \nstyle=\"background: #fff\"></i> Available </span><span><i style=\"background: #ff5a60\"></i> Booked </span><span><i \nstyle=\"background: #9e9e9e\"></i> On Hold </span><span><i style=\"background: #000\"></i> Blocked </span><span><i \nstyle=\"background: #ffe326\"></i> MLS</span></div></div></div></md-card-title-media></md-card-title></md-card><md-card \nng-if=\"vm.loadRemHtml && (vm.currentHotelId == 126 || vm.currentHotelId == 122 || vm.currentHotelId == 129 || vm.currentHotelId == 135) && vm.pageFor == \'room\'\">\n<md-progress-linear class=\"dashboard-lin\" md-mode=\"query\" ng-if=\"vm.availabilityLoader\"></md-progress-linear>\n<md-card-title flex=\"100\" layout-wrap=\"wrap\" layout=\"row\"><md-card-title-text flex=\"100\" layout=\"row\" \nlayout-align=\"center center\"><div layout=\"column\" flex=\"30\"><span class=\"md-headline\">Availability</span></div><div \nlayout=\"column\" flex=\"70\" layout-align=\"center end\"><div class=\"availability-color-title\" layout=\"row\" flex=\"100\" \nlayout-align=\"center stretch\" layout-wrap><span><i style=\"background: #fff\" data-toggle=\"tooltip\" title=\"Available\">\n</i> </span><span><i style=\"background: #ff5a60\" data-toggle=\"tooltip\" title=\"Booked\"></i> </span><span><i \nstyle=\"background: #9e9e9e\" data-toggle=\"tooltip\" title=\"On Hold\"></i> </span><span><i style=\"background: #000\" \ndata-toggle=\"tooltip\" title=\"Blocked\"></i> </span><span><i style=\"background: #ffe326\" data-toggle=\"tooltip\" \ntitle=\"MLS\"></i> </span><span><i style=\"background: #c27ba0\" data-toggle=\"tooltip\" title=\"Unavailable\"></i></span>\n</div></div></md-card-title-text><md-card-title-media flex=\"100\" layout=\"column\"><div \nclass=\"card-middlesection availability-portlet-cls\"><div class=\"roomsinfoblock\"><div class=\"\"><div class=\"roomdatecol\" \nlayout=\"column\" layout-align=\"center start\" style=\"width:100%\"><div class=\"scrollblock\" ms-scroll><table \nclass=\"table border\" cellpadding=\"0\" cellspacing=\"0\"><thead><tr><td style=\"text-align:center\">Rooms</td><td \nng-repeat=\"dat in vm.topHeadDates\">{{dat.date}} <span>{{dat.day}}</span></td></tr></thead><tbody \nng-repeat-start=\"(key,value) in vm.roomTypeRates\" \nng-class=\"(vm.collapsebleRoom[value.room_type_id] ? \'collapseble-parent-room\' : \'\')\" \nclass=\"room-type availbilty-room-type\"><tr class=\"{{value.room_type_name | strReplaceRoom }}\"><td \nng-click=\"vm.showCollapseble(value.room_type_id)\" ng-if=\"!value.hotel_id\" class=\"nameblkcol lower-prt\"><em><md-icon \nmd-font-icon=\"icon-{{(vm.collapsebleRoom[value.room_type_id] ? \'minus\' : \'plus\')}}-circle\" class=\"plus-icon\"></md-icon>\n{{value.product_name}}</em></td><td ng-if=\"value.hotel_id\" class=\"occupancy-room-type\"><em \nng-class=\"value.room_type_name == \'Occupancy\' ? \'room-type-number\': \'\'\">{{value.room_type_name}}</em></td><td \nng-repeat=\"val in value.data track by $index\" ng-if=\"!value.hotel_id\" class=\"mls {{val.date}}\" \nng-mouseover=\"vm.showMLSPopup(val,value.room_type_name)\" ng-mouseleave=\"vm.hideMLSPopup(val,value.room_type_name)\" \nid=\"col_{{value.room_type_name | strReplaceRoom }}_row_{{val.date}}\" \nng-class=\"(vm.unAvailableDates[value.room_type_id][val.date] > 0 ? \'\':\'unavailable-rooms\')\"><i class=\"mls-yellow\" \nng-if=\"val.mls != \'\' && val.mls > 1\">{{val.mls}}</i> <span ng-if=\"!val.availability && val.rate != \'\'\">${{val.rate}}\n</span> <span ng-if=\"val.availability == \'occupancy\'\">{{val.rate}}%</span></td><td \nng-repeat=\"val in value.data track by $index\" \nng-class=\"(val.availability == \'occupancy\' ? \'occupancy-room-type\' : \'availClass\')\" ng-if=\"value.hotel_id\" \nclass=\"roomNamecolsm {{val.date}}\"><span ng-if=\"val.availability == \'occupancy\'\">{{val.rate}}%</span></td></tr></tbody>\n<tbody ng-repeat-end ng-if=\"vm.collapsebleRoom[value.room_type_id]\" \nng-class=\"(vm.collapsebleRoom[value.room_type_id] ? \'collapseble-child-room\' : \'\')\"><tr class=\"room-number-details\" \nng-repeat=\"(roomName,roomNumberData) in vm.roomNumberResults[value.room_type_id] track by $index\" class=\"\"><td><em \nclass=\"room-type-number\">{{roomName}}</em></td><td class=\"roomNamecolsm {{val.date}}\" \nng-repeat=\"val in roomNumberData\" \nng-class=\"val.availability == \'booked\' ? \'bookedClass\' : (val.availability == \'hold\' ? \'holdClass\' : (val.availability == \'block\' ? \'blockedClass\' : (val.availability == \'occupancy\' ? \'occupClass\' : \'availClass\')))\" \nng-click=\"vm.showResvBookPopup(val.availability, val.date, val.product_id, val.product_name)\" \nng-mouseenter=\"vm.showAvailStatusPopup($event, val)\" ng-mouseleave=\"vm.hideAvailStatusPopup()\" \nid=\"col_{{value.room_type_name | strReplaceRoom }}_{{roomName | strReplaceRoom }}_row_{{val.date}}\"><span \nclass=\"icon-close avail-status-icon\" ng-if=\"val.availability == \'booked\'\"></span> <span \nng-if=\"val.availability == \'available\' && val.rate != \'\'\">${{val.rate}}</span></td></tr></tbody></table></div></div>\n</div><div class=\"room-color-detail new-room-color-detail\" layout=\"row\" flex=\"100\" layout-align=\"center stretch\" \nlayout-wrap><span><i style=\"background: #fff\"></i> Available </span><span><i style=\"background: #ff5a60\"></i> Booked \n</span><span><i style=\"background: #9e9e9e\"></i> On Hold </span><span><i style=\"background: #000\"></i> Blocked </span>\n<span><i style=\"background: #ffe326\"></i> MLS </span><span><i style=\"background: #c27ba0\"></i> Unavailable</span></div>\n</div></div></md-card-title-media></md-card-title></md-card></div><div flex-xs flex-gt-xs=\"50\" layout=\"column\" \nclass=\"inhouse-card\"><md-card><md-progress-linear class=\"dashboard-lin\" md-mode=\"query\" ng-if=\"vm.inHouseCustLoadear\">\n</md-progress-linear><md-card-title flex=\"100\" layout-wrap=\"wrap\" layout=\"row\"><md-card-title-text flex=\"100\" \nlayout=\"column\"><span class=\"md-headline\">In House</span></md-card-title-text><md-card-title-media flex=\"100\" \nlayout=\"column\"><md-content class=\"scrollcontentmain\"><table \nclass=\"simple tableofuserouter checkIn-checkOut-Tables inhouse-table\"><thead><tr><th class=\"namewidth\" \nng-click=\"vm.sortCustom(\'name\', vm.nameSortType)\"><div class=\"sort-icon-text-container\"><span class=\"arrow-icon-top\">\nName<md-icon md-font-icon=\"{{ (vm.nameSortType == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedColumn == \'name\') ? \'sortCol\' : \'\'\"></md-icon><span class=\"sort-icon-text\">Stays</span></span>\n</div></th><th class=\"width10per inhouse-small-column\" ng-click=\"vm.sortCustom(\'room_stay_from\', vm.checkInSortType)\">\n<span class=\"arrow-icon-top\"><div class=\"roomno\">Chk In</div><md-icon \nmd-font-icon=\"{{ (vm.checkInSortType == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedColumn == \'room_stay_from\') ? \'sortCol\' : \'\'\"></md-icon></span></th><th \nclass=\"width10per inhouse-small-column\" ng-click=\"vm.sortCustom(\'room_stay_to\', vm.checkOutSortType)\"><span \nclass=\"arrow-icon-top\"><div class=\"roomno\">Chk Out</div><md-icon \nmd-font-icon=\"{{ (vm.checkOutSortType == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedColumn == \'room_stay_to\') ? \'sortCol\' : \'\'\"></md-icon></span></th><th \nclass=\"width10per inhouse-small-column\" ng-click=\"vm.sortCustom(\'guests\', vm.guestSortType)\"><span \nclass=\"arrow-icon-top\"><div class=\"guest\">guests</div><md-icon \nmd-font-icon=\"{{ (vm.guestSortType == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedColumn == \'guests\') ? \'sortCol\' : \'\'\"></md-icon></span></th><th class=\"width21per\">last purchase\n</th><th class=\"width21per\" style=\"text-align: center; position: relative; width: 100px\" \nng-click=\"vm.sortCustom(\'cc_is_incidental\', vm.badgeSortType)\"><span class=\"arrow-icon-top housekeeping-action-header\">\nAction<md-icon style=\"position: absolute; right: unset\" \nmd-font-icon=\"{{ (vm.badgeSortType == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedColumn == \'cc_is_incidental\') ? \'sortCol\' : \'\'\"></md-icon></span></th></tr></thead><tbody><tr \nng-repeat=\"value in vm.todayInHouseCustomers\" class=\"housekeeping-action-row\" style=\"cursor: pointer\" \nng-class=\"{\'last-row\': $last}\"><td style=\"background-color:#dedede;padding: 10px\" colspan=\"6\" \nng-if=\"value.hotel_name != undefined && value.hotel_name != \'\'\"><b>{{value.hotel_name}}</b></td><td class=\"namewidth\" \nng-click=\"vm.openReservationPage(value.reservation_id, value.confirmation_number)\" \nng-if=\"value.hotel_name == undefined\"><div class=\"imgouterblkmain check-in-out\"><div class=\"imgusertb\"><span \nclass=\"in-house-text-img\"><b><i>{{value.first_room}}</i> <i ng-if=\"value.second_room != \'\'\">{{value.second_room}}</i>\n</b></span></div><span class=\"room-precheckin-started-badge\" \nng-if=\"vm.isPreCheckInFlagSet(value, \'is_precheckin_started\') && !vm.isPreCheckInFlagSet(value, \'is_precheckin_completed\')\" \nstyle=\"position: absolute; left: -3px; bottom: 6px; width: 16px; height: 16px; min-width: 16px; min-height: 16px; background: #f8841c; border-radius: 50%; z-index: 2; display: flex; align-items: center; justify-content: center\">\n<svg viewBox=\"0 0 24 24\" style=\"width: 14px; height: 14px\" stroke=\"white\" stroke-width=\"4\" fill=\"none\" \nstroke-linecap=\"round\" stroke-linejoin=\"round\"><polyline points=\"12 5 12 12 18 12\"></polyline></svg><md-tooltip>\nPre Check-In Started</md-tooltip></span><span class=\"room-precheckin-completed-badge\" \nng-if=\"vm.isPreCheckInFlagSet(value, \'is_precheckin_completed\')\"><svg viewBox=\"390 400 150 125\" \nstyle=\"width: 10px; height: 9px; fill: white\"><path \nd=\"M530.3 434.3L452.7 511.9C446.5 518.1 436.4 518.1 430.2 511.9L397.7 479.4C391.5 473.2 391.5 463.1 397.7 456.9C403.9 450.7 414 450.7 420.2 456.9L441.4 478.1L507.8 411.7C514 405.5 524.1 405.5 530.3 411.7C536.5 417.9 536.5 428 530.3 434.3z\"/>\n</svg><md-tooltip>Pre Check-In Completed</md-tooltip></span><div \nng-class=\"{\'inner-row-div\': vm.hasReservationAddonIcons(value), \'has-row-addon-icons\': vm.hasReservationAddonIcons(value)}\">\n<span class=\"inner-row-span\">{{value.first_name}} {{value.last_name}} <span \nclass=\"checkin-row-precheckin-icon stays-count-icon stays-stat-hover\" ng-if=\"vm.getGuestStaysCount(value) > 0\" \nng-class=\"{\'stays-tooltip-open\': vm.isGuestStaysTooltipOpen(value, \'inhouse\')}\" \nng-click=\"vm.toggleGuestStaysTooltip($event, value, \'inhouse\')\"><span class=\"checkin-row-stays-count\">\n{{vm.getGuestStaysCount(value)}}</span><md-tooltip md-direction=\"top\">No. of Stays: {{vm. getGuestStaysCount(value)}}\n</md-tooltip></span><span class=\"customer-tag-wrapper\" ng-if=\"value.customer_tags && value.customer_tags.length\">\n<md-icon md-font-icon=\"icon-tag\" class=\"customer-tag-icon\"></md-icon><md-tooltip md-direction=\"top\">\n{{vm.getCustomerTagNames(value.customer_tags)}}</md-tooltip></span></span><span class=\"checkin-row-precheckin-icons\" \nng-if=\"vm.hasReservationAddonIcons(value)\"><span class=\"checkin-row-precheckin-icon\" \nng-class=\"[\'addon-cat-\' + vm.getAddonIconName(addonKey), {\'addon-cat-badge\': !vm.isEarlyOrLateAddon(addonKey)}]\" \nng-repeat=\"(addonKey, addonList) in value.addons track by addonKey\" \nng-if=\"vm.isValidAddonCategory(addonKey, addonList)\"><img class=\"checkin-addon-category-icon\" \nng-class=\"{\'addon-icon-sm\': !vm.isEarlyOrLateAddon(addonKey)}\" ng-src=\"{{vm.getAddonIconUrl(addonKey)}}\" \nalt=\"{{vm.getAddonIconName(addonKey)}}\" onerror=\"this.style.display=\'none\'\"><md-tooltip md-direction=\"top\">\n{{vm.getAddonTooltip(value, addonKey)}}</md-tooltip></span></span></div></div></td><td \nclass=\"width10per inhouse-small-column\" ng-if=\"value.hotel_name == undefined\"><div class=\"roomno\" \nng-click=\"vm.openReservationPage(value.reservation_id, value.confirmation_number)\">{{value.room_stay_from}}</div></td>\n<td class=\"width10per inhouse-small-column\" ng-if=\"value.hotel_name == undefined\"><div class=\"roomno\" \nng-click=\"vm.openReservationPage(value.reservation_id, value.confirmation_number)\">{{value.room_stay_to}}</div></td><td\n class=\"width10per inhouse-small-column\" ng-if=\"value.hotel_name == undefined\"><div class=\"guest\" \nng-click=\"vm.openReservationPage(value.reservation_id, value.confirmation_number)\">{{value.guests}}</div></td><td \nclass=\"width21per\" ng-if=\"value.hotel_name == undefined\" \nng-click=\"vm.openReservationPage(value.reservation_id, value.confirmation_number)\">{{value.lastItemPurchased}}</td><td \nclass=\"width21per inhouse-action-cell\" ng-if=\"value.hotel_name == undefined\"><div class=\"inhouse-action-col\"><span \nng-if=\"vm.isBorrowedItemsEnabled()\" class=\"common-btn-key borrowed-count-wrapper\" \nng-click=\"vm.openBorrowedItems($event, value)\"><md-button class=\"md-fab custom-button borrowed-btn\" \naria-label=\"Borrowed Items\"><img src=\"assets/icons/borrowed.svg\" alt=\"Borrowed Items\" class=\"borrowed-icon-img\">\n<md-tooltip>Borrowed Items</md-tooltip></md-button><span class=\"borrowed-count\" ng-if=\"value.borrowed_count > 0\">\n{{value.borrowed_count}} </span></span><span class=\"common-btn-key\" \nng-click=\"vm.openReservationPage(value.reservation_id, value.confirmation_number)\"><md-button \nclass=\"md-fab custom-button incidental-card-btn\" aria-label=\"Incidental Card Status\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/credit-card-white.svg\" ng-if=\"value.cc_is_incidental == \'1\'\">\n</md-icon><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/credit-card2-white.svg\" \nng-if=\"value.cc_is_incidental != \'1\'\"></md-icon><md-tooltip ng-if=\"value.cc_is_incidental != 1\">Not incidental card\n</md-tooltip><md-tooltip ng-if=\"value.cc_is_incidental == 1\">Incidental card</md-tooltip></md-button></span><span \nclass=\"common-btn-key\" ng-click=\"vm.addServices(mykey)\"><md-button class=\"md-fab custom-button\" \naria-label=\"Incidental Card Status\" md-colors=\"light-blue\"><md-icon ng-if=\"vm.room_stay_status != \'Canceled\'\" \nmd-svg-src=\"assets/angular-material-assets/img/icons/room-service.svg\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer\" ng-click=\"vm.gotoPosPage(value)\"><md-tooltip>\n{{\'CREATE_RES.ADD_SERVICE\' | translate}}</md-tooltip></md-icon></md-button></span><span class=\"common-btn-key\" \nng-click=\"vm.toggleCleaningStatus($event, $index, \'inhouse\')\"><md-button class=\"md-fab custom-button\" \naria-label=\"Cleaning Status\" \nng-class=\"{\'dirty-room\':value.product_is_clean == \'0\',\'full-clean\':value.product_is_clean == \'1\',\'light-clean\':value.product_is_clean == \'2\'}\">\n<md-icon md-font-icon=\"icon-broom white-icon\" ng-if=\"value.product_is_clean == \'0\'\"></md-icon><md-icon \nmd-font-icon=\"icon-check-circle white-icon\" ng-if=\"value.product_is_clean == \'1\'\"></md-icon><md-icon \nmd-svg-src=\"assets/icons/light_cleaning_white.svg\" ng-if=\"value.product_is_clean == \'2\'\"></md-icon><md-tooltip \nng-if=\"value.product_is_clean == \'0\'\">Dirty</md-tooltip><md-tooltip ng-if=\"value.product_is_clean == \'1\'\">Full Clean\n</md-tooltip><md-tooltip ng-if=\"value.product_is_clean == \'2\'\">Light Clean</md-tooltip></md-button></span></div></td>\n</tr><tr ng-if=\"vm.todayInHouseCustomers.length == 0\"><td class=\"text-center\" colspan=\"6\">No Customer Found</td></tr>\n</tbody></table></md-content></md-card-title-media></md-card-title></md-card><md-card style=\"min-height: 200px\" \nng-if=\"vm.loadRemHtml\"><md-progress-linear class=\"dashboard-lin\" md-mode=\"query\" ng-if=\"vm.latestTasksLoader\">\n</md-progress-linear><md-card-title flex=\"100\" layout-wrap=\"wrap\" layout=\"row\"><md-card-title-text flex=\"100\" \nlayout=\"column\"><span class=\"md-headline\">Latest Task</span></md-card-title-text><md-card-title-media flex=\"100\" \nlayout=\"column\"><md-content ms-scroll class=\"scrollcontentmain\"><div class=\"card-middlesection\"><div \nclass=\"lastest-taskblock\"><div class=\"latest-task-row\" ng-repeat=\"task in vm.latestTasks\" \nng-if=\"vm.latestTasks.length > 0\"><h1>{{task.task_title}}</h1><p>{{task.task_note}}</p><div class=\"tagsmain\"><span><i \nstyle=\"background: #43bdd4\"></i> {{task.task_category | strReplace:\'_\':\' \' }}</span> <span \nng-if=\"task.task_priority ==\'higher\'\"><i style=\"background: red\"></i> {{task.task_priority}}</span> <span \nng-if=\"task.task_priority ==\'medium\'\"><i style=\"background: green\"></i> {{task.task_priority}}</span> <span \nng-if=\"task.task_priority ==\'lower\'\"><i style=\"background: blue\"></i> {{task.task_priority}}</span></div></div><div \nclass=\"latest-task-row\" ng-if=\"vm.latestTasks.length == 0\"><div class=\"text-center\">No Data Found</div></div></div>\n</div></md-content></md-card-title-media></md-card-title></md-card></div></div></md-content><div \nclass=\"popouter_res_mls\" ng-show=\"vm.showMLSPop\"><div class=\"pophalf_res_mls\"><div class=\"contentblock_res\"><div \nclass=\"titalblock_res_mls\"><div class=\"room-avialbe\">Minimum Length of Stay</div><div class=\"mlsnights\">\nThis date has MLS of {{vm.mls_days}} nights.</div></div></div></div></div><div class=\"popouter_res_avail\" \nng-show=\"vm.showAvailStatusPop\"><div class=\"pophalf_res_mls\"><div class=\"contentblock_res\"><div \nclass=\"titalblock_res_mls\"><div class=\"room-avialbe\">{{vm.availStatusPop.title}}</div><div class=\"mlsnights\">\n{{vm.availStatusPop.message}}</div></div></div></div></div><span class=\"stays-stat-hover global-stays-tooltip-anchor\" \nng-show=\"vm.guestStaysTooltip.open\" ng-click=\"$event.stopPropagation()\"><div \nclass=\"precheckin-stat-tooltip stays-stat-tooltip\" ng-style=\"vm.guestStaysTooltipStyle\" \nng-class=\"{\'stays-tooltip-above\': vm.guestStaysTooltip.openAbove}\" ng-include=\"vm.guestStaysTooltipTpl\"></div></span>");
$templateCache.put("app/main/apps/dashboards/dash-views/dash-quick-stats.html","<div class=\"comparison-box\" \nng-if=\"vm.quickStats.dateValues && vm.quickStats.dateValues.startDate && vm.quickStats.dateValues.endDate\"><div \nclass=\"comparison-right\"><div class=\"comparison-current\">\n{{vm.quickStats.dateValues.startDate}} - {{vm.quickStats.dateValues.endDate}} vs. same period {{vm.quickStats.dateValuesPrev.startDate.split(\'/\')[2]}}\n</div></div></div><div class=\"roomsolidblock\" flex=\"100\" layout=\"row\" layout-wrap><div flex-xs flex-gt-xs=\"50\" \nlayout=\"column\" class=\"coldblock_dash\" ng-click=\"vm.redirectToResvDetail(\'roomSold\')\"><md-card \nclass=\"cardquickstart card1\" md-theme-watch layout=\"row\" flex=\"100\" layout-wrap=\"wrap\" layout-align=\"start start\">\n<md-card-title layout=\"column\" flex=\"100\" layout-align=\"start start\"><md-card-title-text layout=\"row\" flex=\"100\" \nlayout-align=\"start start\"><span class=\"md-headline\">Number of reservations/nights sold</span></md-card-title-text>\n<md-card-title-media layout=\"row\" flex=\"100\" layout-align=\"center center\" layout-wrap=\"wrap\"><div \nclass=\"md-media-lg card-media blue quick-stat-value\" layout=\"column\" flex=\"100\" layout-align=\"center start\"><span \nclass=\"stat-number-wrap\"><span class=\"quick-stat-tooltip quick-stat-tooltip-sold\" \nng-if=\"vm.quickStats.roomsSold !== undefined && vm.quickStats.roomsSoldPrev !== undefined\"><div class=\"tooltip-row\">\n<span class=\"tooltip-label\">Current year sold reservations/nights:</span> <span class=\"tooltip-value\">\n{{vm.quickStats.roomsSold}}</span></div><div class=\"vs-text\">vs</div><div class=\"tooltip-row\"><span \nclass=\"tooltip-label\">Previous year sold reservations/nights:</span> <span class=\"tooltip-value\">\n{{vm.quickStats.roomsSoldPrev}}</span></div></span>{{vm.quickStats.roomsSold}}</span></div></md-card-title-media>\n<slider-range min=\"10\" max=\"200\" value-min=\"search.price_min\" value-max=\"search.price_max\" class=\"rangefilter\"><div \nclass=\"bar blue\" style=\"width:{{vm.quickStats.soldPerc}}%\"></div></slider-range></md-card-title><md-card-actions \nlayout=\"row\" layout-align=\"start center\" class=\"expectedvalues\"><span ng-if=\"vm.quickStats\"><md-icon \nclass=\"white-fg close-icon1 font-size-10 onlycursorPointer\" \nmd-font-icon=\"{{ (vm.quickStats.soldIncDec.toLowerCase() == \'increase\') ? \'icon-arrow-up\' : \'icon-arrow-down\' }}\">\n</md-icon><b>{{vm.quickStats.roomsSoldPrevPercentage}}</b> {{vm.quickStats.roomsSoldComparisonWith}}</span>\n</md-card-actions></md-card></div><div flex-xs flex-gt-xs=\"50\" layout=\"column\" class=\"coldblock_dash\" \nng-click=\"vm.redirectToResvDetail(\'roomSales\')\"><md-card class=\"cardquickstart card2\" md-theme-watch layout=\"row\" \nflex=\"100\" layout-wrap=\"wrap\" layout-align=\"start start\"><md-card-title layout=\"column\" flex=\"100\" \nlayout-align=\"start start\"><md-card-title-text layout=\"row\" flex=\"100\" layout-align=\"start start\"><span \nclass=\"md-headline\">Sales</span></md-card-title-text><md-card-title-media layout=\"row\" flex=\"100\" \nlayout-align=\"center center\" layout-wrap=\"wrap\"><div class=\"md-media-lg card-media quick-stat-value\" layout=\"column\" \nflex=\"100\" layout-align=\"center start\"><span class=\"stat-number-wrap\"><span class=\"quick-stat-tooltip\" \nng-if=\"vm.quickStatsHoverInfo && vm.quickStatsHoverInfo.currentRoomsSales && vm.quickStatsHoverInfo.previousRoomsSales\">\n<div>{{vm.quickStatsHoverInfo.currentRoomsSales}}</div><div class=\"vs-text\">vs</div><div>\n{{vm.quickStatsHoverInfo.previousRoomsSales}}</div></span>{{vm.quickStats.roomsSales | currency}}</span></div>\n</md-card-title-media><slider-range min=\"10\" max=\"200\" value-min=\"search.price_min\" value-max=\"search.price_max\" \nclass=\"rangefilter\"><div class=\"bar blue\" style=\"width:{{vm.quickStats.salesPerc}}%\"></div></slider-range>\n</md-card-title><md-card-actions layout=\"row\" layout-align=\"start center\" class=\"expectedvalues\"><span \nng-if=\"vm.quickStats\"><md-icon class=\"white-fg close-icon1 font-size-10 onlycursorPointer\" \nmd-font-icon=\"{{ (vm.quickStats.salesIncDec.toLowerCase() == \'increase\') ? \'icon-arrow-up\' : \'icon-arrow-down\' }}\">\n</md-icon><b>{{vm.quickStats.roomsSalesPrevPercentage}}</b> {{vm.quickStats.roomsSalesComparisonWith}}</span>\n</md-card-actions></md-card></div><div flex-xs flex-gt-xs=\"50\" layout=\"column\" class=\"coldblock_dash\" \nng-click=\"vm.redirectToResvDetail(\'roomCancel\')\"><md-card class=\"cardquickstart card3\" md-theme-watch layout=\"row\" \nflex=\"100\" layout-wrap=\"wrap\" layout-align=\"start start\"><md-card-title layout=\"column\" flex=\"100\" \nlayout-align=\"start start\"><md-card-title-text layout=\"row\" flex=\"100\" layout-align=\"start start\"><span \nclass=\"md-headline\">Cancellations</span></md-card-title-text><md-card-title-media layout=\"row\" flex=\"100\" \nlayout-align=\"center center\" layout-wrap=\"wrap\"><div class=\"md-media-lg card-media quick-stat-value\" layout=\"column\" \nflex=\"100\" layout-align=\"center start\"><span class=\"stat-number-wrap\"><span class=\"quick-stat-tooltip\" \nng-if=\"vm.quickStatsHoverInfo && vm.quickStatsHoverInfo.currentRoomsCancel && vm.quickStatsHoverInfo.previousRoomsCancel\">\n<div>{{vm.quickStatsHoverInfo.currentRoomsCancel}}</div><div class=\"vs-text\">vs</div><div>\n{{vm.quickStatsHoverInfo.previousRoomsCancel}}</div></span>{{vm.quickStats.roomsCancel}}</span></div>\n</md-card-title-media><slider-range min=\"10\" max=\"200\" value-min=\"search.price_min\" value-max=\"search.price_max\" \nclass=\"rangefilter\"><div class=\"bar blue\" style=\"width:{{vm.quickStats.cancelPerc}}%\"></div></slider-range>\n</md-card-title><md-card-actions layout=\"row\" layout-align=\"start center\" class=\"expectedvalues\"><span \nng-if=\"vm.quickStats\"><md-icon class=\"white-fg close-icon1 font-size-10 onlycursorPointer\" \nmd-font-icon=\"{{ (vm.quickStats.cancelIncDec.toLowerCase() == \'increase\') ? \'icon-arrow-up\' : \'icon-arrow-down\' }}\">\n</md-icon><b>{{vm.quickStats.roomsCancelPrevPercentage}}</b> {{vm.quickStats.roomsCancelComparisonWith}}</span>\n</md-card-actions></md-card></div><div flex-xs flex-gt-xs=\"50\" layout=\"column\" class=\"coldblock_dash\" \nng-click=\"vm.redirectToResvDetail(\'occupancyPercentage\')\"><md-card class=\"cardquickstart card4\" md-theme-watch \nlayout=\"row\" flex=\"100\" layout-wrap=\"wrap\" layout-align=\"start start\"><md-card-title layout=\"column\" flex=\"100\" \nlayout-align=\"start start\"><md-card-title-text layout=\"row\" flex=\"100\" layout-align=\"start start\"><span \nclass=\"md-headline\">Occupancy %</span></md-card-title-text><md-card-title-media layout=\"row\" flex=\"100\" \nlayout-align=\"center center\" layout-wrap=\"wrap\"><div class=\"md-media-lg card-media quick-stat-value\" layout=\"column\" \nflex=\"100\" layout-align=\"center start\"><span class=\"stat-number-wrap\"><span class=\"quick-stat-tooltip\" \nng-if=\"vm.quickStatsHoverInfo && vm.quickStatsHoverInfo.currentAverageOccupancyPerc && vm.quickStatsHoverInfo.previousAverageOccupancyPerc\">\n<div>{{vm.quickStatsHoverInfo.currentAverageOccupancyPerc}}</div><div class=\"vs-text\">vs</div><div>\n{{vm.quickStatsHoverInfo.previousAverageOccupancyPerc}}</div></span>\n{{(vm.quickStats.averageOccupancyPerc != null && vm.quickStats.averageOccupancyPerc !== \'\') ? (vm.quickStats.averageOccupancyPerc + \'%\') : \'\'}}\n</span></div></md-card-title-media><slider-range min=\"10\" max=\"200\" value-min=\"search.price_min\" \nvalue-max=\"search.price_max\" class=\"rangefilter\"><div class=\"bar blue\" style=\"width:{{vm.quickStats.occupancyPerc}}%\">\n</div></slider-range></md-card-title><md-card-actions layout=\"row\" layout-align=\"start center\" class=\"expectedvalues\">\n<span ng-if=\"vm.quickStats\"><md-icon class=\"white-fg close-icon1 onlycursorPointer arrow-class\" \nmd-font-icon=\"{{ (vm.quickStats.occIncDec.toLowerCase() == \'increase\') ? \'icon-arrow-up\' : \'icon-arrow-down\' }}\">\n</md-icon><b>{{vm.quickStats.averageOccupancyPrevText}}</b> {{vm.quickStats.averageOccupancyComparisonWith}}</span>\n</md-card-actions></md-card></div></div>");
$templateCache.put("app/main/apps/dashboards/dash-views/dash-restrictions-content.html","<div flex-xs flex-gt-xs=\"100\" layout=\"column\"><md-card><md-progress-linear class=\"dashboard-lin\" md-mode=\"query\" \nng-if=\"vm.showremoveMLSLoader\"></md-progress-linear><md-card-title flex=\"100\" layout-wrap=\"wrap\" layout=\"row\">\n<md-card-title-text flex=\"100\" layout=\"column\"><span class=\"md-headline\">{{vm.title}}<div class=\"selectblockstay\">\n<md-input-container><md-select ng-model=\"vm.restrictionLevel\" \nng-change=\"vm.changeRestrictions(vm.restrictionLevel);vm.getAllMlsInListView(vm.level)\"><md-option value=\"all\" \nselected=\"selected\">All</md-option><md-option value=\"is_min_stay\">Min Stay</md-option><md-option value=\"is_stop_sell\">\nStop Sell</md-option><md-option value=\"is_cta\">Close To Arrival</md-option><md-option value=\"is_ctd\">Close To Departure\n</md-option></md-select></md-input-container><md-button class=\"md-button md-raised md-accent grey-100-fg\" \nng-click=\"vm.insertnew($event)\">Add Restriction</md-button></div></span></md-card-title-text><md-card-title-media \nflex=\"100\" layout=\"column\"><md-content class=\"scrollcontentmain\"><table class=\"simple tableofuserouter mt-20\"><thead>\n<tr><th class=\"width5per\" ng-click=\"vm.getAllMlsInListView(vm.level)\"><span style=\"min-width:110px\" \nclass=\"arrow-icon-top\">Start Date<md-icon \nmd-font-icon=\"{{ (vm.nameSortType == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedColumn == \'name\') ? \'sortCol\' : \'\'\"></md-icon></span></th><th class=\"width5per\">End Date</th><th \nclass=\"width10per\"><span ng-if=\"vm.restrictionLevel == \'is_min_stay\'\"><div class=\"roomno\">Min Stay</div></span><span \nclass=\"arrow-icon-top\" ng-if=\"vm.restrictionLevel == \'is_max_stay\'\"><div class=\"roomno min-stay\">Max Stay</div></span>\n<span ng-if=\"vm.restrictionLevel == \'is_stop_sell\'\"><div class=\"roomno\">Stop Sell</div></span><span \nng-if=\"vm.restrictionLevel == \'all\'\"><div class=\"roomno\">Restriction</div></span><span class=\"arrow-icon-top\" \nng-if=\"vm.restrictionLevel == \'is_cta\'\"><div class=\"roomno\">Close To Arrival</div></span><span class=\"arrow-icon-top\" \nng-if=\"vm.restrictionLevel == \'is_ctd\'\"><div class=\"roomno\">Close To Departure</div></span></th><th class=\"width10per\">\n<span class=\"arrow-icon-top namewidth\"><div class=\"roomno\">Rooms</div></span></th><th class=\"width21per\"><span \nclass=\"arrow-icon-top\"><div class=\"roomno\">Channels</div></span></th><th class=\"width5per\"><span \nclass=\"arrow-icon-top\"><div class=\"roomno\">Action</div></span></th></tr></thead><tbody><tr \nng-repeat=\"value in vm.MLSlistView\" class=\"onlycursorPointer\"><td class=\"width5per\" \nng-click=\"vm.bulkUpdate($event, value)\"><div class=\"roomno\">{{value.startDate}}</div></td><td class=\"width5per\" \nng-click=\"vm.bulkUpdate($event, value)\"><div class=\"roomno\">{{value.endDate}}</div></td><td class=\"width5per\" \nng-click=\"vm.bulkUpdate($event, value)\"><div class=\"roomno\" ng-if=\"vm.restrictionLevel == \'is_min_stay\'\">\n{{value.min_stay}}</div><div class=\"roomno\" ng-if=\"vm.restrictionLevel == \'is_max_stay\'\">{{value.max_stay}}</div><div \nclass=\"roomno\" ng-if=\"vm.restrictionLevel == \'is_stop_sell\'\">{{value.is_stop_sell ? \'Yes\' : \'Yes\'}}</div><div \nclass=\"roomno\" ng-if=\"vm.restrictionLevel == \'is_cta\'\">{{value.is_cta? \'Yes\' : \'Yes\'}}</div><div class=\"roomno\" \nng-if=\"vm.restrictionLevel == \'is_ctd\'\">{{value.is_ctd? \'Yes\' : \'Yes\'}}</div><div class=\"roomno\" \nng-if=\"vm.restrictionLevel == \'all\'\">\n{{value.is_cta?\'CTA : Yes\':\'\'}}{{value.is_ctd?\'CTD : Yes\':\'\'}}{{value.min_stay?\'MLS : \'+value.min_stay:\'\'}}{{value.is_stop_sell?\'Stop Sell : Yes\':\'\'}}\n</div></td><td class=\"namewidth\" ng-click=\"vm.bulkUpdate($event, value)\"><div class=\"room-block-outer\"><div \nclass=\"room-block-repeat\" ng-repeat=\"roomlisting in value.rooms track by $index\">{{roomlisting}}</div></div></td><td \nclass=\"width21per\" ng-click=\"vm.bulkUpdate($event, value)\"><div class=\"room-block-outer\"><div \nclass=\"room-block-repeat channels\" ng-repeat=\"channellisting in value.channels\">{{channellisting}}</div></div></td><td \nclass=\"width5per\"><div class=\"roomno\"><span style=\"width:100%;text-align:center\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"close-icon1 font-size-12 onlycursorPointer mh-5 red-A800-fg\" ng-click=\"vm.deleteMls(value, $event)\"><md-tooltip>\nDelete</md-tooltip></md-icon></span></div></td></tr><tr ng-if=\"vm.MLSlistView.length == 0\"><td class=\"text-center\" \ncolspan=\"8\">No Record Found</td></tr></tbody></table></md-content></md-card-title-media></md-card-title></md-card>\n</div>");
$templateCache.put("app/main/apps/dashboards/dash-views/dash-revenue-content.html","<md-content class=\"md-padding\"><div layout=\"row\" class=\"salescontainer\" flex=\"100\" layout-wrap=\"wrap\" \nlayout-align=\"start start\" ng-if=\"vm.loadRemHtml\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><md-card>\n<md-progress-linear class=\"dashboard-lin\" md-mode=\"query\" ng-show=\"vm.revLoader\"></md-progress-linear><md-card-title \nflex=\"100\" layout-wrap=\"wrap\" layout=\"row\"><md-card-title-text flex=\"100\" layout=\"column\"><span class=\"md-headline\">\nProperty Performance</span></md-card-title-text><md-card-title-media flex=\"100\" layout=\"column\"><div \nclass=\"card-middlesection\"><highchart id=\"chart5\" class=\"loads-tracking\" config=\"propPerfConfig\" class=\"span9\" \nng-show=\"!vm.revLoader\"></highchart></div></md-card-title-media></md-card-title></md-card></div><div flex-xs \nflex-gt-xs=\"50\" layout=\"column\"><md-card><md-progress-linear class=\"dashboard-lin\" md-mode=\"query\" \nng-show=\"vm.otaSaleLoader\"></md-progress-linear><md-card-title flex=\"100\" layout-wrap=\"wrap\" layout=\"row\">\n<md-card-title-text flex=\"100\" layout=\"column\"><span class=\"md-headline\">Sales</span></md-card-title-text>\n<md-card-title-media flex=\"100\" layout=\"column\"><div class=\"card-middlesection\"><highchart id=\"chart1\" \nclass=\"loads-tracking\" config=\"otaSalesConfig\" class=\"span9\" ng-show=\"vm.otaSalesExist && !vm.otaSaleLoader\">\n</highchart><div ng-if=\"!vm.otaSalesExist\" class=\"text-center\">No Data Found</div></div></md-card-title-media>\n</md-card-title></md-card><md-card><md-progress-linear class=\"dashboard-lin\" md-mode=\"determinate\" \nvalue=\"{{vm.progressValue}}\" ng-show=\"vm.quickStatsLoader\"></md-progress-linear><md-card-title flex=\"100\" \nlayout-wrap=\"wrap\" layout=\"row\"><md-card-title-text flex=\"100\" layout=\"column\"><span class=\"md-headline\">Quick Stats\n</span></md-card-title-text><md-card-title-media flex=\"100\" layout=\"column\"><div class=\"card-middlesection\"><div \nclass=\"card-inside-tab\"><md-tabs md-dynamic-height md-border-bottom class=\"tabmainsections quick-stats-slider\" \nmd-selected=\"vm.selectedQuickStatsTab\"><md-tab label=\"Custom Range\" ng-click=\"vm.quickStatsData(\'custom-range\')\"><div \nng-include=\"\'app/main/apps/dashboards/dash-views/dash-quick-stats.html\'\"></div></md-tab><md-tab label=\"Week\" \nng-click=\"vm.quickStatsData(\'week\')\"><div ng-include=\"\'app/main/apps/dashboards/dash-views/dash-quick-stats.html\'\">\n</div></md-tab><md-tab label=\"Month\" ng-click=\"vm.quickStatsData(\'month\')\"><div \nng-include=\"\'app/main/apps/dashboards/dash-views/dash-quick-stats.html\'\"></div></md-tab><md-tab label=\"Year\" \nng-click=\"vm.quickStatsData(\'year\')\"><div ng-include=\"\'app/main/apps/dashboards/dash-views/dash-quick-stats.html\'\">\n</div></md-tab></md-tabs></div></div></md-card-title-media></md-card-title></md-card><md-card><md-progress-linear \nclass=\"dashboard-lin\" md-mode=\"query\" ng-show=\"vm.resDistributionLoader\"></md-progress-linear><md-card-title \nflex=\"100\" layout-wrap=\"wrap\" layout=\"row\"><md-card-title-text flex=\"100\" layout=\"column\"><span class=\"md-headline\">\nReservation Distribution</span></md-card-title-text><md-card-title-media flex=\"100\" layout=\"column\"><div \nclass=\"card-middlesection\"><highchart id=\"chart2\" class=\"loads-tracking\" config=\"resDistributionConfig\" class=\"span9\" \nng-show=\"vm.resDistributionExist && !vm.resDistributionLoader\"></highchart><div ng-if=\"!vm.resDistributionExist\" \nclass=\"text-center\">No Data Found</div></div></md-card-title-media></md-card-title></md-card></div><div flex-xs \nflex-gt-xs=\"50\" layout=\"column\"><md-card md-theme-watch class=\"fullcard\"><md-progress-linear class=\"dashboard-lin\" \nmd-mode=\"query\" ng-show=\"vm.salesPosLoader\"></md-progress-linear><md-card-title flex=\"100\" layout-wrap=\"wrap\" \nlayout=\"row\" layout-align=\"start start\"><md-card-title-text flex=\"100\" layout=\"column\"><span class=\"md-headline\">Sales\n</span></md-card-title-text><md-card-title-media flex=\"100\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"card-middlesection nopadding card2boxsameheight\"><div class=\"card-inside-tab\"><md-tabs md-dynamic-height \nmd-border-bottom md-selected=\"vm.selectedSalesPosTab\"><md-tab label=\"Custom Range\" \nng-click=\"vm.getSalesPos(\'custom-range\')\"><md-content class=\"md-padding\" \nng-include=\"\'app/main/apps/dashboards/dash-views/dash-sales-tab.html\'\"></md-content></md-tab><md-tab label=\"Day\" \nng-click=\"vm.getSalesPos(\'day\')\"><md-content class=\"md-padding\" \nng-include=\"\'app/main/apps/dashboards/dash-views/dash-sales-tab.html\'\"></md-content></md-tab><md-tab label=\"Week\" \nng-click=\"vm.getSalesPos(\'week\')\"><md-content class=\"md-padding\" \nng-include=\"\'app/main/apps/dashboards/dash-views/dash-sales-tab.html\'\"></md-content></md-tab><md-tab label=\"Month\" \nng-click=\"vm.getSalesPos(\'month\')\"><md-content class=\"md-padding\" \nng-include=\"\'app/main/apps/dashboards/dash-views/dash-sales-tab.html\'\"></md-content></md-tab><md-tab label=\"Year\" \nng-click=\"vm.getSalesPos(\'year\')\"><md-content class=\"md-padding\" \nng-include=\"\'app/main/apps/dashboards/dash-views/dash-sales-tab.html\'\"></md-content></md-tab></md-tabs></div></div>\n</md-card-title-media></md-card-title></md-card><md-card md-theme-watch class=\"fullcard\"><md-progress-linear \nclass=\"dashboard-lin\" md-mode=\"query\" ng-show=\"vm.resChannelsLoader\"></md-progress-linear><md-card-title flex=\"100\" \nlayout-wrap=\"wrap\" layout=\"row\"><md-card-title-text flex=\"100\" layout=\"column\"><span class=\"md-headline\">Reservations\n</span></md-card-title-text><md-card-title-media flex=\"100\" layout=\"column\"><div class=\"card-middlesection\"><highchart \nid=\"chart3\" class=\"loads-tracking\" config=\"channelsConfig\" class=\"span9\" \nng-show=\"vm.resPieChartExist && !vm.resChannelsLoader\"></highchart><div ng-if=\"!vm.resPieChartExist\" \nclass=\"text-center\">No Data Found</div></div></md-card-title-media></md-card-title></md-card><md-card>\n<md-progress-linear class=\"dashboard-lin\" md-mode=\"query\" ng-show=\"vm.resChannelsLoader\"></md-progress-linear>\n<md-card-title flex=\"100\" layout-wrap=\"wrap\" layout=\"row\"><md-card-title-text flex=\"100\" layout=\"column\"><span \nclass=\"md-headline\">Channels</span></md-card-title-text><md-card-title-media flex=\"100\" layout=\"column\"><div \nclass=\"card-middlesection\"><table class=\"channels-table\" cellpadding=\"0\" cellspacing=\"0\" \nng-show=\"!vm.resChannelsLoader\"><tr><th>Channel</th><th class=\"center\">Income</th><th class=\"center\">Percentage</th><th\n class=\"center\">Rate</th><th class=\"center\">Bookings</th></tr><tr ng-repeat=\"channel in vm.channelWiseData\" \nng-if=\"vm.channelWiseData.length > 0\" class=\"channel-row-clickable\" ng-click=\"vm.openChannelBookingsDetail(channel)\">\n<td ng-bind=\"channel.name\"></td><td class=\"center\" ng-bind=\"channel.paidAmount | currency\"></td><td class=\"center\">\n{{channel.percentage}}%</td><td class=\"center\" ng-bind=\"channel.averageRate | currency\"></td><td class=\"center\" \nng-bind=\"channel.count\"></td></tr><tr ng-if=\"vm.channelWiseData.length > 0\"><td><strong>Total</strong></td><td \nclass=\"center\"><strong>{{vm.channelTotal.paidAmount | currency}}</strong></td><td class=\"center\"><strong>\n{{vm.channelTotal.percentage}}%</strong></td><td class=\"center\"></td><td class=\"center\"><strong>\n{{vm.channelTotal.count}}</strong></td></tr><tr ng-if=\"!vm.channelWiseData || vm.channelWiseData.length == 0\"><td \ncolspan=\"5\" class=\"center\">No Data Found</td></tr></table></div></md-card-title-media></md-card-title></md-card>\n<md-card><md-progress-linear class=\"dashboard-lin\" md-mode=\"query\" ng-show=\"vm.revLoader\"></md-progress-linear>\n<md-card-title flex=\"100\" layout-wrap=\"wrap\" layout=\"row\"><md-card-title-text flex=\"100\" layout=\"column\"><span \nclass=\"md-headline\">RevPAR</span></md-card-title-text><md-card-title-media flex=\"100\" layout=\"column\"><div \nclass=\"card-middlesection\"><highchart id=\"chart5\" class=\"loads-tracking\" config=\"revParConfig\" class=\"span9\" \nng-show=\"!vm.revLoader\"></highchart></div></md-card-title-media></md-card-title></md-card></div><div flex-xs \nflex-gt-xs=\"50\" layout=\"column\" ng-if=\"vm.canViewCourtesyHoldReport()\"><md-card md-theme-watch class=\"fullcard\">\n<md-progress-linear class=\"dashboard-lin\" md-mode=\"query\" ng-show=\"vm.courtesyHoldLoader\"></md-progress-linear>\n<md-card-title flex=\"100\" layout-wrap=\"wrap\" layout=\"row\"><md-card-title-text flex=\"100\" layout=\"column\"><span \nclass=\"md-headline\">Courtesy Holds</span></md-card-title-text><md-card-title-media flex=\"100\" layout=\"column\"><div \nclass=\"card-middlesection\"><highchart id=\"chartCourtesyHold\" class=\"loads-tracking span9\" config=\"courtesyHoldConfig\" \nng-show=\"vm.courtesyHoldPieExist && !vm.courtesyHoldLoader\"></highchart><div \nng-if=\"!vm.courtesyHoldPieExist && !vm.courtesyHoldLoader\" class=\"text-center\">No Data Found</div></div>\n</md-card-title-media></md-card-title></md-card></div></div></md-content>");
$templateCache.put("app/main/apps/dashboards/dash-views/dash-sales-tab.html","<div class=\"retailbox\"><div class=\"row-inner-retail\" layout=\"row\" flex=\"100\" layout-wrap layout-align=\" stretch start\">\n<div class=\"column-inner-retail\" layout=\"column\" flex=\"30\" layout-align=\" center start\"><div \nclass=\"col-inner-retail-content\"><h6>Retail</h6><div class=\"date-range-main\" ng-if=\"vm.salesRetail.type == \'day\'\">\n{{vm.salesRetail.dateValues.startDate}}</div><div class=\"date-range-main\" ng-if=\"vm.salesRetail.type != \'day\'\">\n{{vm.salesRetail.dateValues.startDate}} <span>To</span> {{vm.salesRetail.dateValues.endDate}}</div><h1 \nng-bind=\"vm.salesRetail.retail | currency\"></h1></div></div></div></div><div class=\"retailbox gray\" \nng-if=\"vm.salesRetail.saleHeading != \'\'\"><div class=\"row-inner-retail\" layout=\"row\" flex=\"100\" layout-wrap \nlayout-align=\" stretch start\"><div class=\"column-inner-retail\" layout=\"column\" flex=\"30\" layout-align=\" center start\">\n<div class=\"col-inner-retail-content\"><h6>{{vm.salesRetail.saleHeading}}</h6><div class=\"date-range-main\" \nng-if=\"vm.salesRetail.type == \'day\'\">{{vm.salesRetail.dateValues.startDate}}</div><div class=\"date-range-main\" \nng-if=\"vm.salesRetail.type != \'day\'\">{{vm.salesRetail.dateValues.startDate}} <span>To</span>\n {{vm.salesRetail.dateValues.endDate}}</div><h1 ng-bind=\"vm.salesRetail.barRes | currency\"></h1></div></div></div>\n</div>");
$templateCache.put("app/main/apps/dashboards/dash-views/guest-stays-tooltip.html","<span class=\"precheckin-tooltip-arrow\" aria-hidden=\"true\" ng-style=\"vm.guestStaysArrowStyle\"></span><div \nclass=\"precheckin-tooltip-inner\" onwheel=\"event.stopPropagation()\"><div \nclass=\"precheckin-tooltip-header stays-tooltip-header\"><span class=\"stays-tooltip-title-group\"><span \nclass=\"precheckin-tooltip-heading\"><md-icon md-font-icon=\"icon-calendar-blank\"></md-icon>No. Of Stays </span><span \nclass=\"precheckin-tooltip-heading-count\">{{vm.guestStaysTooltip.count}}</span> <span class=\"guest-stays-tooltip-tags\" \nng-if=\"vm.guestStaysTooltip.tags && vm.guestStaysTooltip.tags.length\"><span class=\"guest-stays-tooltip-tag\" \nng-repeat=\"tag in vm.guestStaysTooltip.tags track by $index\" ng-style=\"vm.getCustomerTagStyle(tag.colour_code)\">\n{{tag.name}} </span></span></span><button type=\"button\" class=\"stays-tooltip-close\" aria-label=\"Close stays details\" \nng-click=\"vm.closeGuestStaysTooltip($event)\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></div><table \nclass=\"simple precheckin-tooltip-table stays-tooltip-table\"><thead><tr><th \nng-repeat=\"heading in vm.guestStaysTooltipHeadings\"><span class=\"stays-tooltip-column-heading\"><md-icon \nmd-font-icon=\"{{heading.icon}}\"></md-icon>{{heading.label}}</span></th></tr></thead><tbody \nng-if=\"vm.guestStaysTooltip.loading\"><tr ng-repeat=\"n in vm.guestStaysSkeletonSlots track by $index\"><td \nng-repeat=\"heading in vm.guestStaysTooltipHeadings track by heading.label\"><span class=\"stays-tooltip-skeleton-line\" \nng-class=\"{\'long\': $first, \'short\': $last || $index === 3 || $index === 4}\"></span></td></tr></tbody><tbody \nng-if=\"!vm.guestStaysTooltip.loading\"><tr ng-repeat=\"stay in vm.guestStaysTooltip.reservations\" \nng-click=\"vm.openReservationPage(stay.reservation_id, stay.confirmation_number)\"><td class=\"stays-tooltip-product\">\n{{stay.fe_display_product_name || \'-\'}}</td><td><span class=\"stays-tooltip-date\"><md-icon \nmd-font-icon=\"icon-calendar-blank\"></md-icon>{{stay.room_stay_from_formatted || \'-\'}}</span></td><td><span \nclass=\"stays-tooltip-date\"><md-icon md-font-icon=\"icon-calendar-blank\"></md-icon>{{stay.room_stay_to_formatted || \'-\'}}\n</span></td><td><span class=\"stays-tooltip-total\">{{stay.total_amount ? (stay.total_amount | currency) : \'-\'}}</span>\n</td><td><span class=\"stays-tooltip-total\">{{stay.average_daily_rate ? (stay.average_daily_rate | currency) : \'-\'}}\n</span></td><td><span class=\"stays-tooltip-date\"><md-icon md-font-icon=\"icon-calendar-blank\"></md-icon>\n{{stay.reservation_created_date_formatted || \'-\'}}</span></td><td><span class=\"stays-tooltip-source\"><span \nclass=\"stays-tooltip-source-label\">{{stay.source_of_creation || \'-\'}}</span><md-tooltip \nng-if=\"stay.source_of_creation\" md-direction=\"top\">{{stay.source_of_creation}}</md-tooltip></span></td></tr><tr \nng-if=\"!vm.guestStaysTooltip.reservations.length\"><td colspan=\"{{vm.guestStaysTooltipHeadings.length}}\" \nclass=\"text-center\">No reservations found</td></tr></tbody></table></div>");
$templateCache.put("app/main/apps/dashboards/detail/dashGraphDetail.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar-text\"></md-icon><span>\n{{vm.title}}</span></div><div class=\"product-count secondary-text\"><span>Total {{vm.title}}</span> <span>\n{{vm.totalReservations}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{ \'SEARCH\' | translate }}\" ng-model=\"filterText\" flex></div></div></div>\n</div></div><div class=\"content\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.title == \'Rooms\'\"><div class=\"main RowClick\" ms-scroll><mdt-table \ntable-card=\"{visible: true, title: \'Customers\', columnSelector: true}\" \npaginated-rows=\"{isEnabled: true,rowsPerPageValues: [20,50]}\" selectable-rows=\"vm.canDelete\" \nselected-row-callback=\"selectedRowCallback(rows)\" mdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" \ndelete-row-callback=\"deleteSelectedItem()\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n						\'table-row-id-key\': \'product_id\',\n						\'column-keys\': [\'s_no\', \'product_name\', \'product_room_number\', \'status\', \'product_id\']}\">\n<mdt-header-row><mdt-column align-rule=\"left\"><h5>S.no</h5></mdt-column><mdt-column align-rule=\"left\" \ncolumn-sort=\"true\"><h5>Room Name</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>Room Number</h5>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\" \ncolumn-filter=\"{\'valuesProviderCallback\': cleanStatusValuesCallback, \'valuesTransformerCallback\': statusValuesTransformer,\'placeholderText\': \'Select a status\',\'filterType\': \'dropdown\'}\">\n<h5>Status</h5></mdt-column><mdt-column><h5></h5></mdt-column></mdt-header-row><mdt-custom-cell html-content=\"true\" \ncolumn-key=\"product_id\"></mdt-custom-cell></mdt-table></div></div><div class=\"content\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.title == \'Reservations\'\"><div class=\"main RowClick\" ms-scroll><div \nclass=\"table-custom-progress-blk\"><mdt-table table-card=\"{visible: true, title: \'Customers\', columnSelector: true}\" \npaginated-rows=\"{isEnabled: true,rowsPerPageValues: [20,50]}\" selectable-rows=\"vm.canDelete\" \nselected-row-callback=\"selectedRowCallback(rows)\" mdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" \ndelete-row-callback=\"deleteSelectedItem()\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n							\'table-row-id-key\': \'confirmation_number\',\n							\'column-keys\': [\'itinerary_number\',\n											\'confirmation_number\',\n											\'product_name\',\n											\'created_date\',\n											\'customer_name\',\n											\'traveler\',\n											\'grand_total\',\n											\'paid_amount\',\n											\'remaining_amount\',\n											\'room_stay_status\',\n											\'room_stay_from\',\n											\'room_stay_to\',\n											\'source_of_creation\',\n											\'created_by_user\',\n											\'change_status\',\n											\'editId\' ]}\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>{{ \'EC.ITIN\' | translate }}</h5></mdt-column>\n<mdt-column align-rule=\"left\" column-sort=\"true\"><h5>{{ \'EC.CONF\' | translate }}</h5></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><h5>{{ \'EC.PROD\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" \ncolumn-sort=\"true\" \ncolumn-filter=\"{\'valuesProviderCallback\': createdValuesCallback,\'valuesTransformerCallback\': statusValuesTransformer,\'placeholderText\': \'Select date\',\'filterType\': \'checkbox\'}\">\n<h5>{{ \'EC.CREATED\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\n{{ \'EC.CUSTOMER\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\n{{ \'EC.TRAVELER\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\n{{ \'EC.TOTAL\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\n{{ \'EC.PAID\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\n{{ \'EC.REMAIN\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\" \ncolumn-filter=\"{\'valuesProviderCallback\': statusValuesCallback, \'valuesTransformerCallback\': statusValuesTransformer,\'placeholderText\': \'Select a status\',\'filterType\': \'dropdown\'}\" \ninline-menu=\"[ {check_in: \'Checked In\', active: \'Active\'} ]\"><h5>{{ \'EC.STATUS\' | translate }}</h5></mdt-column>\n<mdt-column align-rule=\"left\" column-sort=\"true\"><h5>{{ \'EC.CHECKIN\' | translate }}</h5></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><h5>{{ \'EC.CHECKOUT\' | translate }}</h5></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><h5>{{ \'EC.SOURCE\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" \ncolumn-sort=\"true\"><h5>{{ \'EC.BYUSER\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\">\n<h5>Change Status</h5></mdt-column><mdt-column align-rule=\"right\" class=\"action-right-icons\"><h5></h5></mdt-column>\n</mdt-header-row><mdt-custom-cell column-key=\"change_status\" html-content=\"true\" ng-if=\"vm.roomStatus == \'check_in\'\">\n<span class=\"custom_button_checkin_checkout checkin\"><a ng-click=\"clientScope.changeStatus(this.rowId, \'Checked-In\')\">\n<img src=\"assets/images/ecommerce/from.svg\"> Check in</a></span></mdt-custom-cell><mdt-custom-cell \ncolumn-key=\"change_status\" html-content=\"true\" ng-if=\"vm.roomStatus == \'check_out\'\"><span \nclass=\"custom_button_checkin_checkout checkout\"><a ng-click=\"clientScope.changeStatus(this.rowId, \'Checked-Out\')\"><img \nsrc=\"assets/images/ecommerce/to.svg\"> Check out</a></span></mdt-custom-cell><mdt-custom-cell html-content=\"true\" \ncolumn-key=\"editId\"><a class=\"editrow\" style=\"cursor:pointer\" ng-click=\"clientScope.goToEditPage(value)\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16 ng-scope md-default-theme md-font material-icons icon-pencil\" role=\"img\" \naria-label=\"icon-cog\"></md-icon></a></mdt-custom-cell></mdt-table><md-progress-linear \nclass=\"loading-indicator md-default-theme\" md-mode=\"intermediate\" ng-if=\"vm.isloading\"></md-progress-linear></div>\n</div></div></div></div><style>\n.RowClick td:last-child,.RowClick th:last-child{\n	    position: absolute !important;\n	    width: calc(100% - 120px)!important;\n	    left: 0;\n	    padding: 0;\n	}\n	.custom_button_checkin_checkout {\n	    padding: 12px;\n	    border-radius: 4px;\n	    color:  #fff ;\n	    font-weight: 700;\n	    text-transform: uppercase;\n	    text-decoration: none !important;\n	    color : #fff !important;\n	    cursor: pointer;\n	}\n	.custom_button_checkin_checkout img {\n		margin-right: 5px;\n	}\n	.custom_button_checkin_checkout a {\n		display: inline-flex;\n	    align-items: center;\n	    justify-content: center;\n	}\n	.custom_button_checkin_checkout.checkin {\n	    background: #663ab7;\n	}\n	.checkin a , .checkout a {\n		color: #fff !important;\n		text-decoration: none !important;\n	}\n	.custom_button_checkin_checkout.checkout {\n	    background: #f8841c;\n	}\n	.table-custom-progress-blk {\n	    position: relative;\n	    height: 100%;\n	}\n</style>");
$templateCache.put("app/main/apps/dashboards/gantt-chart/confirmationPage.html","<md-dialog class=\"contact-dialog confirm-page-dialog\" aria-label=\"New Task\"><form name=\"ploicyForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><p \nclass=\"form-title-small mt-0 mb-0\" bind-html-compile=\"vm.htmlContent\"></p></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-checkbox \nclass=\"no-margin\" ng-model=\"vm.send_email_indicator\" ng-if=\"vm.newStatus != \'Active\' && vm.newStatus!=\'\'\"><span>\nSend Email</span></md-checkbox><md-button type=\"submit\" ng-click=\"vm.closeDialog()\" ng-class=\"vm.cancelBtnClass\">\n{{vm.cancelTxt}}</md-button><md-button type=\"submit\" ng-click=\"vm.hideDialog()\" ng-class=\"vm.confirmBtnClass\">\n{{vm.btnTxt}}</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/dashboards/gantt-chart/gantt-chart.html","<div id=\"gantt-chart\" class=\"page-layout carded fullwidth\" \nng-class=\"{\'date-filter-active\':vm.dateFilterActive, \'search-active\': vm.searchActive}\" layout=\"row\" \nng-if=\"vm.userPermissions.indexOf(\'tape_chart\') != -1 || vm.userPermissions.indexOf(\'boats\') != -1\"><md-sidenav \nclass=\"sidenav settings-sidenav md-sidenav-right\" md-component-id=\"settings-sidenav\" \nng-include=\"\'app/main/apps/dashboards/gantt-chart/sidenavs/settings/settings-sidenav.html\'\" ms-scroll \nms-sidenav-helper></md-sidenav><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div \nclass=\"header\" layout=\"column\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-gantt-chart-big\" \nclass=\"icon-gantt-chart-big\"></md-icon></span><span class=\"logo-text\" translate=\"GANTT.TAPE_CHART\">Tape Chart</span>\n</div></div></div><div class=\"content-card relative-block\" layout=\"column\" flex><md-progress-linear \nmd-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><div class=\"gantt-icons1\"><md-datepicker \nclass=\"gantt-datepickernew\" ng-model=\"vm.options.fromDate\" md-is-open=\"vm.isOpen\" md-open-on-focus \nng-change=\"vm.load(\'changeDate\')\" ng-model-options=\"{debounce: 500}\"></md-datepicker><md-button \nng-disabled=\"!vm.enableReload\" ng-click=\"vm.reload()\" class=\"md-icon-button reload-btn\" aria-label=\"Reload\" translate \ntranslate-attr-aria-label=\"GANTT.RELOAD\"><md-icon md-font-icon=\"icon-reload\"></md-icon><md-tooltip><span \ntranslate=\"GANTT.RELOAD\">RELOAD</span></md-tooltip></md-button></div><md-content id=\"chart-container\" class=\"content\" \nflex layout=\"column\"><gantt flex layout-fill id=\"gantt\" gantt headers-formats=\"vm.options.headersFormats\" \ndata=\"vm.data\" show-side=\"vm.options.labelsEnabled\" daily=\"vm.options.daily\" \nfilter-task=\"{\'name\': vm.options.filterTask}\" filter-row=\"{\'name\': vm.options.filterRow}\" \nsort-mode=\"vm.options.sortMode\" view-scale=\"vm.options.scale\" \ncolumn-width=\"vm.getColumnWidth(vm.options.width, vm.options.scale, vm.options.zoom)\" \nauto-expand=\"vm.options.autoExpand\" task-out-of-range=\"vm.options.taskOutOfRange\" from-date=\"vm.options.fromDate\" \nto-date=\"vm.options.toDate\" allow-side-resizing=\"vm.options.allowSideResizing\" \ntask-content=\"vm.options.taskContentEnabled ? vm.options.taskContent : undefined\" \nrow-content=\"vm.options.rowContentEnabled ? vm.options.rowContent : undefined\" current-date=\"vm.options.currentDate\" \ncurrent-date-value=\"vm.options.currentDateValue\" headers=\"vm.ganttChartHeader\" max-height=\"vm.maxheight\" \ntime-frames=\"vm.options.timeFrames\" date-frames=\"vm.options.dateFrames\" \ntime-frames-working-mode=\"vm.options.timeFramesWorkingMode\" \ntime-frames-non-working-mode=\"vm.options.timeFramesNonWorkingMode\" time-frames-magnet=\"vm.options.timeFramesMagnet\" \napi=\"vm.options.api\" column-magnet=\"vm.options.columnMagnet\"><gantt-tree \nenabled=\"vm.options.sideMode === \'Tree\' || vm.options.sideMode === \'TreeTable\'\" \nheader-content=\"vm.options.treeHeaderContent\" keep-ancestor-on-filter-row=\"true\"></gantt-tree><gantt-table \nenabled=\"vm.options.sideMode === \'Table\' || vm.options.sideMode === \'TreeTable\'\" \ncolumns=\"vm.options.sideMode === \'TreeTable\' ? vm.options.treeTableColumns : vm.options.columns\" \nheaders=\"vm.options.columnsHeaders\" classes=\"vm.options.columnsClasses\" formatters=\"vm.options.columnsFormatters\" \ncontents=\"vm.options.columnsContents\" header-contents=\"vm.options.columnsHeaderContents\"></gantt-table><gantt-groups \nenabled=\"vm.options.groupDisplayMode === \'group\' || vm.options.groupDisplayMode === \'overview\' || vm.options.groupDisplayMode === \'promote\'\" \ndisplay=\"vm.options.groupDisplayMode\"></gantt-groups><gantt-tooltips delay=\"100\"></gantt-tooltips><gantt-bounds>\n</gantt-bounds><gantt-progress></gantt-progress><gantt-sortable></gantt-sortable><gantt-movable \nenabled=\"!vm.options.readOnly\"></gantt-movable><gantt-draw-task enabled=\"vm.options.canDraw\" move-threshold=\"2\" \ntask-factory=\"vm.options.drawTaskFactory\"></gantt-draw-task><gantt-overlap></gantt-overlap><gantt-resize-sensor>\n</gantt-resize-sensor></gantt></md-content><div class=\"popup_roomdes\" id=\"main_pop\" ng-if=\"vm.roomInformation!=\'\'\"><div\n class=\"innerblk\"><i ng-click=\"vm.roomInformation = \'\'\" class=\"close_popup icon-cancel\"></i><div class=\"roomouterdes\">\n<div class=\"img_roomdes\"><img ngf-src=\"vm.roomInformation.imagePath\"></div><h1>{{vm.roomInformation.product_name}} \n<span ng-if=\"vm.pageType == \'room\'\">Max. Occupancy : <b>{{vm.roomInformation.max_occupancy}}</b></span> <span \nng-if=\"vm.pageType == \'boat\' && vm.roomInformation.boat_width>0\">Length : <b style=\"margin-right: 10px\">\n{{vm.roomInformation.boat_length}}</b> Width : <b>{{vm.roomInformation.boat_width}}</b> </span><span \nng-if=\"vm.pageType == \'boat\' && vm.roomInformation.boat_width==0\">Length : <b style=\"margin-right: 10px\">\n{{vm.roomInformation.boat_length}}</b></span></h1><p>{{vm.roomInformation.room_type_description}}</p></div><div \nclass=\"room_aminity\" ng-if=\"vm.showAmenity\"><h2>{{vm.pageType == \'boat\'?\'Boat amenities\':\'Room amenities\'}}</h2><ul>\n<span ng-repeat=\"(key, value) in vm.roomInformation.amenitiesdata\"><li ng-repeat=\"(key1, value1) in value\" \nng-if=\"key1!=\'parent_icon\'\">{{value1.name}}</li><span></span></span></ul></div></div></div><div \nclass=\"popup_room_class popupstatus\" id=\"main_pop\" ng-if=\"vm.roomcleanstatus!=\'\'\"><div class=\"innerblk\"><i \nng-click=\"vm.roomcleanstatus = \'\'\" class=\"close_popup icon-cancel\"></i><div class=\"block-status popup_room_status\" \nng-if=\"vm.cleantype==2 && row.model.is_walk != 1\"><div class=\"statusblockrow\" ng-click=\"triggerRoomClean(0,$event)\">\n<div class=\"icon-broom iocncommoncolor red-A800-fg\" title=\"dirty\"></div><span>Dirty</span></div><div \nclass=\"statusblockrow\" ng-click=\"triggerRoomClean(1,$event)\"><div \nclass=\"icon-check-circle iocncommoncolor green-500-fg\" title=\"clean\"></div><span>Clean</span></div></div><div \nclass=\"block-status\" ng-if=\"vm.cleantype==1 && row.model.is_walk != 1\"><div class=\"statusblockrow\" \nng-click=\"triggerRoomClean(0,$event)\"><div class=\"icon-broom iocncommoncolor red-A800-fg\" title=\"dirty\"></div><span>\nDirty</span></div><div class=\"statusblockrow\" ng-click=\"triggerRoomClean(2,$event)\"><div \nclass=\"icon-light-cleaning iocncommoncolor\" title=\"light-clean\"></div><span>Light Clean</span></div></div><div \nclass=\"block-status\" ng-if=\"vm.cleantype==0 && row.model.is_walk != 1\"><div class=\"statusblockrow\" \nng-click=\"triggerRoomClean(1,$event)\"><div class=\"icon-check-circle iocncommoncolor red-A800-fg green-500-fg\" \ntitle=\"clean\"></div><span>Clean</span></div><div class=\"statusblockrow\" ng-click=\"triggerRoomClean(2,$event)\"><div \nclass=\"icon-light-cleaning iocncommoncolor\" title=\"light-clean\"></div><span>Light Clean</span></div></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/dashboards/housekeeping/housekeeping.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center fullwidthtabs housekeepingdashboard\" layout=\"column\" flex><div ng-cloak><md-content ms-scroll \nclass=\"scrollcontentmain housekeeping-fixscroll\"><md-date-range class=\"daterangePicker daterangePicker_new\" \nng-model=\"vm.dateRange\" show-template=\"false\" auto-confirm=\"true\" md-on-select=\"vm.mdDateRangeHandler($dates)\" \nstyle=\"display: none\"></md-date-range><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Dashboard\" \nng-if=\"vm.routePermissions.indexOf(\'housekeeping-dashboard\') != -1\" ng-click=\"vm.selectTab(\'dashboard\')\" \nclass=\"housekeeping-fixscroll-tab\"><div \nng-include=\"\'app/main/apps/dashboards/housekeeping/views/housekeepingDashboard.html\'\" class=\"tabscrollingareablock\">\n</div></md-tab><md-tab label=\"Tasks\" ng-if=\"vm.routePermissions.indexOf(\'tasks\') != -1\" \nng-click=\"vm.selectTab(\'todo\')\" class=\"housekeeping-fixscroll-tab\"><div ng-include=\"\'app/main/apps/todo/todo.html\'\" \nclass=\"tabscrollingareablock\"></div></md-tab></md-tabs></md-content></div></div></div>");
$templateCache.put("app/main/apps/dashboards/housekeeping-portlet/housekeeping-portlet.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar-text\"></md-icon><span>\n{{vm.title}}</span></div><div class=\"product-count secondary-text\"><span translate=\"EC.TOTAL_ORDERS\"></span> <span>\n{{vm.totalReservations}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{ \'SEARCH\' | translate }}\" ng-model=\"filterText\" flex></div></div></div>\n</div></div><div class=\"content\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"main RowClick\" ms-scroll><mdt-table table-card=\"{visible: true, title: \'Customers\', columnSelector: true}\" \npaginated-rows=\"{isEnabled: true,rowsPerPageValues: [20,50]}\" selectable-rows=\"vm.canDelete\" \nselected-row-callback=\"selectedRowCallback(rows)\" mdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" \ndelete-row-callback=\"deleteSelectedItem()\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n					\'table-row-id-key\': \'confirmation_number\',\n					\'column-keys\': [\'itinerary_number\',\n									\'confirmation_number\',\n									\'product_name\',\n									\'product_room_number\',\n									\'reservation_created_date\',\n									\'customer_name\',\n									\'room_stay_status\',\n									\'room_stay_from\',\n									\'room_stay_to\',\n									\'source_of_creation\',\n									\'created_by_user\',\n									\'editId\' ]}\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>{{ \'EC.ITIN\' | translate }}</h5></mdt-column>\n<mdt-column align-rule=\"left\" column-sort=\"true\"><h5>{{ \'EC.CONF\' | translate }}</h5></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><h5>{{ \'EC.PROD\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" \ncolumn-sort=\"true\"><h5>{{ \'EC.RN\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\n{{ \'EC.CREATED\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\n{{ \'EC.CUSTOMER\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>Status</h5>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>{{ \'EC.CHECKIN\' | translate }}</h5></mdt-column>\n<mdt-column align-rule=\"left\" column-sort=\"true\"><h5>{{ \'EC.CHECKOUT\' | translate }}</h5></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><h5>{{ \'EC.SOURCE\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" \ncolumn-sort=\"true\"><h5>{{ \'EC.BYUSER\' | translate }}</h5></mdt-column><mdt-column align-rule=\"right\" \nclass=\"action-right-icons\"><h5></h5></mdt-column></mdt-header-row><mdt-custom-cell html-content=\"true\" \ncolumn-key=\"editId\"><a style=\"cursor:pointer\" ng-click=\"clientScope.goToEditPage(value)\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16 ng-scope md-default-theme md-font material-icons icon-pencil\" role=\"img\" \naria-label=\"icon-cog\"></md-icon></a></mdt-custom-cell></mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/dashboards/modified-gantt-chart/confirmationPage.html","<md-dialog class=\"contact-dialog confirm-page-dialog\" aria-label=\"New Task\"><form name=\"ploicyForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><p \nclass=\"form-title-small mt-0 mb-0\" bind-html-compile=\"vm.htmlContent\"></p></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-checkbox \nclass=\"no-margin\" ng-model=\"vm.send_email_indicator\" ng-if=\"vm.newStatus != \'Active\' && vm.newStatus!=\'\'\"><span>\nSend Email</span></md-checkbox><md-button type=\"submit\" ng-click=\"vm.hideDialog()\" \nng-class=\"\'md-raised md-accent submit-button grey-100-fg md-green-500-bg\'\">{{vm.btnTxt}}</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/dashboards/modified-gantt-chart/gant-chart-content.html","<div class=\"gantt-icons1\"><i ng-click=\"vm.navigateDates(\'prev\')\" ng-class=\"{\'disabled-icon\': vm.isloading}\" \nclass=\"icon-chevron-left arrow datePickerIcon datePreviousIcon\"><md-tooltip><span>Previous</span></md-tooltip></i>\n<md-datepicker class=\"gantt-datepickernew\" ng-model=\"vm.options.fromDate\" md-is-open=\"vm.isOpen\" \nng-change=\"vm.load(\'changeDate\'); vm.scrollToStart()\" ng-model-options=\"{debounce: 500}\"></md-datepicker><i \nng-class=\"{\'disabled-icon\': vm.isloading}\" class=\"icon-chevron-right arrow gantt-dateNextIcon datePickerIcon\" \nng-click=\"vm.navigateDates(\'next\')\"><md-tooltip><span>Next</span></md-tooltip></i><md-button \nng-disabled=\"!vm.enableReload\" ng-click=\"vm.reload() ; vm.scrollToStart()\" class=\"md-icon-button reload-btn\" \naria-label=\"Reload\" translate translate-attr-aria-label=\"GANTT.RELOAD\"><div layout=\"row\" layout-align=\"center center\">\n<md-icon md-font-icon=\"icon-reload\"></md-icon><div class=\"reload-text\">Today</div></div><md-tooltip><span \ntranslate=\"GANTT.RELOAD\">RELOAD</span></md-tooltip></md-button></div><md-content id=\"chart-container\" \nclass=\"content gantt-hotel-{{vm.currentHotelId}}\" \nng-class=\"{\'new-gantt\' : vm.modifiedTapeChart, \'hide-current-date-line\': !vm.isCurrentDateVisible}\" flex \nlayout=\"column\"><gantt flex layout-fill id=\"gantt\" gantt headers-formats=\"vm.options.headersFormats\" data=\"data\" \nshow-side=\"vm.options.labelsEnabled\" daily=\"vm.options.daily\" filter-task=\"{\'name\': vm.options.filterTask}\" \nfilter-row=\"{\'name\': vm.options.filterRow}\" sort-mode=\"vm.options.sortMode\" view-scale=\"vm.options.scale\" \ncolumn-width=\"vm.getColumnWidth(vm.options.width, vm.options.scale, vm.options.zoom)\" \nauto-expand=\"vm.options.autoExpand\" task-out-of-range=\"vm.options.taskOutOfRange\" from-date=\"vm.options.fromDate\" \nto-date=\"vm.options.toDate\" allow-side-resizing=\"vm.options.allowSideResizing\" \ntask-content=\"vm.options.taskContentEnabled ? vm.options.taskContent : undefined\" \nrow-content=\"vm.options.rowContentEnabled ? vm.options.rowContent : undefined\" current-date=\"vm.options.currentDate\" \ncurrent-date-value=\"vm.options.currentDateValue\" headers=\"vm.ganttChartHeader\" max-height=\"vm.maxheight\" \ntime-frames=\"vm.options.timeFrames\" date-frames=\"vm.options.dateFrames\" \ntime-frames-working-mode=\"vm.options.timeFramesWorkingMode\" \ntime-frames-non-working-mode=\"vm.options.timeFramesNonWorkingMode\" time-frames-magnet=\"vm.options.timeFramesMagnet\" \napi=\"vm.options.api\" column-magnet=\"vm.options.columnMagnet\" tasklimitthreshold=\"100\"><gantt-tree \nenabled=\"vm.options.sideMode === \'Tree\' || vm.options.sideMode === \'TreeTable\'\" \nheader-content=\"vm.options.treeHeaderContent\" keep-ancestor-on-filter-row=\"true\"></gantt-tree><gantt-table \nenabled=\"vm.options.sideMode === \'Table\' || vm.options.sideMode === \'TreeTable\'\" \ncolumns=\"vm.options.sideMode === \'TreeTable\' ? vm.options.treeTableColumns : vm.options.columns\" \nheaders=\"vm.options.columnsHeaders\" classes=\"vm.options.columnsClasses\" formatters=\"vm.options.columnsFormatters\" \ncontents=\"vm.options.columnsContents\" header-contents=\"vm.options.columnsHeaderContents\"></gantt-table><gantt-groups \nenabled=\"vm.options.groupDisplayMode === \'group\' || vm.options.groupDisplayMode === \'overview\' || vm.options.groupDisplayMode === \'promote\'\" \ndisplay=\"vm.options.groupDisplayMode\"></gantt-groups><gantt-tooltips delay=\"100\"></gantt-tooltips><gantt-bounds>\n</gantt-bounds><gantt-progress></gantt-progress><gantt-sortable></gantt-sortable><gantt-movable \nenabled=\"!vm.options.readOnly\"></gantt-movable><gantt-draw-task enabled=\"vm.options.canDraw\" move-threshold=\"2\" \ntask-factory=\"vm.options.drawTaskFactory\"></gantt-draw-task><gantt-overlap></gantt-overlap><gantt-resize-sensor>\n</gantt-resize-sensor></gantt></md-content><div class=\"popup_roomdes\" id=\"main_pop\" ng-if=\"vm.roomInformation!=\'\'\"><div\n class=\"innerblk\"><i ng-click=\"vm.roomInformation = \'\'\" class=\"close_popup icon-cancel\"></i><div class=\"roomouterdes\">\n<h1>{{vm.roomInformation.product_name}}</h1><div class=\"img_roomdes\"><img ngf-src=\"vm.roomInformation.imagePath\"></div>\n<span ng-if=\"vm.pageType == \'room\'\">Max. Occupancy : <b>{{vm.roomInformation.max_occupancy}}</b></span> <span \nng-if=\"vm.pageType == \'boat\' && vm.roomInformation.boat_width>0\">Length : <b style=\"margin-right: 10px\">\n{{vm.roomInformation.boat_length}}</b> Width : <b>{{vm.roomInformation.boat_width}}</b> </span><span \nng-if=\"vm.pageType == \'boat\' && vm.roomInformation.boat_width==0\">Length : <b style=\"margin-right: 10px\">\n{{vm.roomInformation.boat_length}}</b></span><div \nstyle=\"border-top: 1px solid #ccc; margin-top: 8px; margin-bottom: 8px\"></div><p>\n{{vm.roomInformation.room_type_description}}</p></div><div class=\"room_aminity\" ng-if=\"vm.showAmenity\"><h2>\n{{vm.pageType == \'boat\'?\'Boat amenities\':\'Room amenities\'}}</h2><ul><span \nng-repeat=\"(key, value) in vm.roomInformation.amenitiesdata\"><li ng-repeat=\"(key1, value1) in value\" \nng-if=\"key1!=\'parent_icon\'\">{{value1.name}}</li><span></span></span></ul></div></div></div><div \nclass=\"popup_room_class popupstatus\" id=\"main_pop\" ng-if=\"vm.roomcleanstatus!=\'\'\"><div class=\"innerblk\"><i \nng-click=\"vm.roomcleanstatus = \'\'\" class=\"close_popup icon-cancel\"></i><div class=\"block-status popup_room_status\" \nng-if=\"vm.cleantype==2 && row.model.is_walk != 1\"><div class=\"statusblockrow\" ng-click=\"triggerRoomClean(0,$event)\">\n<div class=\"icon-broom iocncommoncolor red-A800-fg\" title=\"dirty\"></div><span>Dirty</span></div><div \nclass=\"statusblockrow\" ng-click=\"triggerRoomClean(1,$event)\"><div \nclass=\"icon-check-circle iocncommoncolor green-500-fg\" title=\"clean\"></div><span>Clean</span></div></div><div \nclass=\"block-status\" ng-if=\"vm.cleantype==1 && row.model.is_walk != 1\"><div class=\"statusblockrow\" \nng-click=\"triggerRoomClean(0,$event)\"><div class=\"icon-broom iocncommoncolor red-A800-fg\" title=\"dirty\"></div><span>\nDirty</span></div><div class=\"statusblockrow\" ng-click=\"triggerRoomClean(2,$event)\"><div \nclass=\"icon-light-cleaning iocncommoncolor\" title=\"light-clean\"></div><span>Light Clean</span></div></div><div \nclass=\"block-status\" ng-if=\"vm.cleantype==0 && row.model.is_walk != 1\"><div class=\"statusblockrow\" \nng-click=\"triggerRoomClean(1,$event)\"><div class=\"icon-check-circle iocncommoncolor red-A800-fg green-500-fg\" \ntitle=\"clean\"></div><span>Clean</span></div><div class=\"statusblockrow\" ng-click=\"triggerRoomClean(2,$event)\"><div \nclass=\"icon-light-cleaning iocncommoncolor\" title=\"light-clean\"></div><span>Light Clean</span></div></div></div></div>");
$templateCache.put("app/main/apps/dashboards/modified-gantt-chart/gantt-chart.html","<div id=\"gantt-chart\" class=\"page-layout carded fullwidth\" \nng-class=\"{\'date-filter-active\':vm.dateFilterActive, \'search-active\': vm.searchActive}\" layout=\"row\" \nng-if=\"vm.userPermissions.indexOf(\'tape_chart\') != -1 || vm.userPermissions.indexOf(\'boats\') != -1\"><md-sidenav \nclass=\"sidenav settings-sidenav md-sidenav-right\" md-component-id=\"settings-sidenav\" \nng-include=\"\'app/main/apps/dashboards/gantt-chart/sidenavs/settings/settings-sidenav.html\'\" ms-scroll \nms-sidenav-helper></md-sidenav><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div \nclass=\"header\" layout=\"column\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-gantt-chart-big\" \nclass=\"icon-gantt-chart-big\"></md-icon></span><span class=\"logo-text\" translate=\"GANTT.TAPE_CHART\">Tape Chart</span>\n</div></div></div><div class=\"content-card relative-block\" layout=\"column\" flex \nng-if=\"(vm.currentHotelId == 126 || vm.currentHotelId == 122) && vm.pageType != \'rent\'\"><md-progress-linear \nmd-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><md-tabs md-dynamic-height md-border-bottom \nmd-selected=\"vm.mdSelectedIndex\"><md-tab label=\"{{vm.condoLabel}}\" ng-click=\"vm.changeTab(\'condos\')\"><div \nng-include=\"\'app/main/apps/dashboards/modified-gantt-chart/gant-chart-content.html\'\" ng-if=\"vm.roomTypes == \'condos\'\">\n</div></md-tab><md-tab label=\"Villas\" ng-click=\"vm.changeTab(\'villas\')\" ng-if=\"vm.currentHotelId == 126\"><div \nng-include=\"\'app/main/apps/dashboards/modified-gantt-chart/gant-chart-content.html\'\" ng-if=\"vm.roomTypes == \'villas\'\">\n</div></md-tab><md-tab label=\"Marina\" ng-click=\"vm.changeTab(\'boat\')\"><div \nng-include=\"\'app/main/apps/dashboards/modified-gantt-chart/gant-chart-content.html\'\" ng-if=\"vm.roomTypes == \'boat\'\">\n</div></md-tab></md-tabs><div class=\"gant-chart-filter-select\" ng-if=\"vm.roomTypes == \'boat\'\"><span>Range</span>\n<md-input-container class=\"md-block tax-inputs\" style=\"\"><md-select placeholder=\"Select Range\" \nng-model=\"vm.boatDispType\" required ng-change=\"vm.changeBoatDisplayType()\"><md-option ng-value=\"type.key\" \nng-repeat=\"type in vm.boatFilterType\" ng-selected=\"type.key == vm.boatDispType\">{{type.value}}</md-option></md-select>\n<div class=\"md-errors-spacer\"></div></md-input-container></div></div><div class=\"gant-chart-filter\" \nng-if=\"(vm.currentHotelId == 126 || vm.currentHotelId == 122) && vm.pageType == \'rent\' && vm.roomTypes == \'condos\'\">\n<div class=\"gant-chart-filter-select\"><span>Range</span><md-input-container class=\"md-block tax-inputs\" style=\"\">\n<md-select placeholder=\"Select Range\" ng-model=\"vm.rentDispType\" required ng-change=\"vm.changeRentDisplayType()\">\n<md-option ng-value=\"type.key\" ng-repeat=\"type in vm.rentFilterType\" ng-selected=\"type.key == vm.rentDispType\">\n{{type.value}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div></div><div \nclass=\"content-card relative-block\" layout=\"column\" flex \nng-if=\"(vm.currentHotelId != 126 && vm.currentHotelId != 122 && vm.pageType == \'room\') || ((vm.currentHotelId == 126 || vm.currentHotelId == 122) && vm.pageType == \'rent\')\" \nng-class=\"{\'hide-box-shadow\': (vm.currentHotelId == 126 || vm.currentHotelId == 126) && vm.pageType == \'rent\'}\">\n<md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><div \nng-include=\"\'app/main/apps/dashboards/modified-gantt-chart/gant-chart-content.html\'\"></div></div></div></div>");
$templateCache.put("app/main/apps/guest-message-center/group-messages/group-message-logs.html","<div id=\"message-center-broadcast-list\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"center start\"><div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-bullhorn\" class=\"mr-10\"></md-icon><span translate=\"GUEST_MESSAGE_CENTER.BROADCAST_TITLE\">\nGroup message</span></div></div></div><div class=\"content loadingstatistic\"><div class=\"simple-table-container\"><div \nclass=\"table-title\" layout=\"row\" layout-align=\"space-between center\"><div><span \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_LOGS_TITLE\">Group message logs</span></div><div><md-button \nclass=\"md-raised md-cornered\" ng-click=\"vm.refreshTable()\" ng-disabled=\"vm.requestProcessing\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessing\"></md-progress-circular>\n</md-button></div></div><div class=\"broadcast-logs-table\"><mdt-table id=\"broadcastLogsTable\" \ntable-card=\"{visible: true, title: \'Group message logs\', columnSelector: true}\" \npaginated-rows=\"{isEnabled: true, rowsPerPageValues: [20, 50]}\" \nmdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" \nmdt-row-paginator-error-message=\"Unable to load group message logs. Try refreshing the page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n                        \'table-row-id-key\': \'id\',\n                        \'column-keys\': [\n                            \'message\',\n                            \'channel\',\n                            \'properties\',\n                            \'requested\',\n                            \'sent\',\n                            \'skipped\',\n                            \'failed\',\n                            \'created_at\',\n                            \'action_id\'\n                        ]}\">\n<mdt-header-row><mdt-column align-rule=\"left\"><h5>Message</h5></mdt-column><mdt-column align-rule=\"left\"><h5>Channel\n</h5></mdt-column><mdt-column align-rule=\"left\"><h5>Properties</h5></mdt-column><mdt-column align-rule=\"left\"><h5>\nRequested</h5></mdt-column><mdt-column align-rule=\"left\"><h5>Sent</h5></mdt-column><mdt-column align-rule=\"left\"><h5>\nSkipped</h5></mdt-column><mdt-column align-rule=\"left\"><h5>Failed</h5></mdt-column><mdt-column align-rule=\"left\"><h5>\nSent At</h5></mdt-column><mdt-column align-rule=\"center\" class=\"action-right-icons\"><h5>Action</h5></mdt-column>\n</mdt-header-row><mdt-custom-cell column-key=\"action_id\"><mdt-custom-cell-content><button class=\"view-btn\" \ntype=\"button\" ng-click=\"clientScope.vm.openBroadcastLog(value)\">View</button></mdt-custom-cell-content>\n</mdt-custom-cell></mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/guest-message-center/group-messages/group-message-panel.html","<div id=\"message-center-broadcast\" class=\"gmc-group-msg-panel\" layout=\"row\" flex><div \nclass=\"gmc-broadcast-tags gmc-thread-list\" layout=\"column\"><div class=\"gmc-tabs\"><button type=\"button\" class=\"gmc-tab\" \nng-click=\"vm.setTab(\'all\')\">{{\'GUEST_MESSAGE_CENTER.TAB_ALL\' | translate}} <span class=\"gmc-filter-chip-badge\" \nng-if=\"vm.getGuestUnreadTotal() > 0\" style=\"margin-left: 6px; position: relative; top: -1px\">\n{{vm.getGuestUnreadTotal()}}</span></button> <button type=\"button\" class=\"gmc-tab is-active\" \nng-if=\"vm.showGroupMessageTab()\" translate=\"GUEST_MESSAGE_CENTER.TAB_GROUP_MSG\">Group message</button> <button \ntype=\"button\" class=\"gmc-tab\" ng-click=\"vm.goToStaffTab()\">Staff <span class=\"gmc-filter-chip-badge\" \nng-if=\"vm.getStaffUnreadTotal() > 0\" style=\"margin-left: 6px; position: relative; top: -1px\">\n{{vm.getStaffUnreadTotal()}}</span></button></div><div class=\"gmc-broadcast-tags-scroll\" ms-scroll><div \nclass=\"gmc-filter-card gmc-filter-card--hotels\"><div class=\"gmc-filter-card-header\"><div class=\"gmc-filter-icon-wrap\">\n<md-icon md-font-icon=\"icon-domain\"></md-icon></div><div class=\"gmc-filter-card-title-group\" flex><div \nclass=\"gmc-filter-card-title\">Hotels</div><div class=\"gmc-filter-card-subtitle\">Select hotel(s) to include</div></div>\n<md-checkbox aria-label=\"All Hotels\" class=\"gmc-filter-all-checkbox gmc-filter-checkbox-hotels\" \nng-checked=\"bvm.isAllPropertiesSelected()\" ng-click=\"bvm.selectAllProperties()\">All Hotels</md-checkbox></div><div \nclass=\"gmc-filter-pill-row group-row\" layout=\"row\" layout-wrap layout-align=\"start center\"><md-checkbox \nclass=\"gmc-filter-pill-checkbox gmc-filter-checkbox-hotels\" ng-repeat=\"hotel in bvm.subHotels track by hotel.hotel_id\" \naria-label=\"{{bvm.getPropertyShortName(hotel)}}\" ng-checked=\"bvm.isPropertySelected(hotel.hotel_id)\" \nng-click=\"bvm.toggleProperty(hotel.hotel_id)\">{{bvm.getPropertyShortName(hotel)}}</md-checkbox></div></div><div \nclass=\"gmc-filter-card gmc-filter-card--stay\"><div class=\"gmc-filter-card-header\"><div class=\"gmc-filter-icon-wrap\">\n<md-icon md-font-icon=\"icon-filter-variant\"></md-icon></div><div class=\"gmc-filter-card-title-group\" flex><div \nclass=\"gmc-filter-card-title\">Guest filter</div><div class=\"gmc-filter-card-subtitle\">Choose one stay filter</div>\n</div></div><md-radio-group class=\"gmc-filter-radio-group\" ng-model=\"bvm.stayFilterMode\" \nng-change=\"bvm.onStayFilterModeChange()\"><md-radio-button class=\"gmc-filter-radio\" value=\"in_house\" \naria-label=\"In House\">In House</md-radio-button><md-radio-button class=\"gmc-filter-radio\" value=\"checkin\" \naria-label=\"Check-In\">Check-In</md-radio-button><md-radio-button class=\"gmc-filter-radio\" value=\"checkout\" \naria-label=\"Check-Out\">Check-Out</md-radio-button><md-radio-button class=\"gmc-filter-radio\" value=\"waiting_for_room\" \naria-label=\"Active - Waiting for room\">Active - Waiting for room</md-radio-button></md-radio-group><div \nng-if=\"bvm.stayFilterMode === \'checkin\'\" class=\"gmc-filter-date-section\"><div class=\"gmc-filter-date-label\">\nCheck-in date</div><div class=\"gmc-filter-pill-row\" layout=\"row\" layout-wrap layout-align=\"start center\"><md-checkbox \naria-label=\"Today\" class=\"gmc-filter-pill-checkbox gmc-filter-checkbox-checkin\" \nng-checked=\"bvm.checkinFilter === \'today\'\" ng-click=\"bvm.setCheckinFilter(\'today\')\">Today</md-checkbox><md-checkbox \naria-label=\"Tomorrow\" class=\"gmc-filter-pill-checkbox gmc-filter-checkbox-checkin\" \nng-checked=\"bvm.checkinFilter === \'tomorrow\'\" ng-click=\"bvm.setCheckinFilter(\'tomorrow\')\">Tomorrow</md-checkbox>\n<md-checkbox aria-label=\"Other date\" class=\"gmc-filter-pill-checkbox gmc-filter-checkbox-checkin\" \nng-checked=\"bvm.checkinFilter === \'custom\'\" ng-click=\"bvm.setCheckinFilter(\'custom\')\">Other date</md-checkbox></div>\n<div ng-if=\"bvm.checkinFilter === \'custom\'\" class=\"custom-checkout-datepicker\"><div layout=\"row\" \nlayout-align=\"start center\" style=\"gap: 16px\"><md-input-container style=\"margin: 0\"><label class=\"checkout-label\" \nstyle=\"width: calc(100% - 48px) !important\">Check-In Date</label><md-datepicker ng-model=\"bvm.customCheckinDate\" \nng-change=\"bvm.onCustomCheckinDateChange()\" aria-label=\"Check-In Date\"></md-datepicker></md-input-container></div>\n</div></div><div ng-if=\"bvm.stayFilterMode === \'checkout\'\" class=\"gmc-filter-date-section\"><div \nclass=\"gmc-filter-date-label\">Check-out date</div><div class=\"gmc-filter-pill-row\" layout=\"row\" layout-wrap \nlayout-align=\"start center\"><md-checkbox aria-label=\"Today\" \nclass=\"gmc-filter-pill-checkbox gmc-filter-checkbox-checkout\" ng-checked=\"bvm.checkoutFilter === \'today\'\" \nng-click=\"bvm.setCheckoutFilter(\'today\')\">Today</md-checkbox><md-checkbox aria-label=\"Tomorrow\" \nclass=\"gmc-filter-pill-checkbox gmc-filter-checkbox-checkout\" ng-checked=\"bvm.checkoutFilter === \'tomorrow\'\" \nng-click=\"bvm.setCheckoutFilter(\'tomorrow\')\">Tomorrow</md-checkbox><md-checkbox aria-label=\"Other date\" \nclass=\"gmc-filter-pill-checkbox gmc-filter-checkbox-checkout\" ng-checked=\"bvm.checkoutFilter === \'custom\'\" \nng-click=\"bvm.setCheckoutFilter(\'custom\')\">Other date</md-checkbox></div><div ng-if=\"bvm.checkoutFilter === \'custom\'\" \nclass=\"custom-checkout-datepicker\"><div layout=\"row\" layout-align=\"start center\" style=\"gap: 16px\"><md-input-container \nstyle=\"margin: 0\"><label class=\"checkout-label\" style=\"width: calc(100% - 48px) !important\">Checkout Date</label>\n<md-datepicker ng-model=\"bvm.customCheckoutDate\" ng-change=\"bvm.onCustomCheckoutDateChange()\" \naria-label=\"Checkout Date\"></md-datepicker></md-input-container></div></div></div></div></div></div><div \nclass=\"gmc-broadcast-reservations\" layout=\"column\"><div class=\"gmc-broadcast-reservations-header\"><div \nclass=\"gmc-broadcast-reservations-title\" translate=\"GUEST_MESSAGE_CENTER.BROADCAST_GUESTS\">Guests</div><div \nclass=\"gmc-broadcast-reservations-count\">{{bvm.getRecipientLabel()}}</div></div><div \nclass=\"gmc-broadcast-reservations-scroll\" ms-scroll><div class=\"gmc-broadcast-guest-loading\" ng-if=\"bvm.loadingGuests\">\n<md-progress-circular md-diameter=\"32\" md-mode=\"indeterminate\"></md-progress-circular><span \ntranslate=\"GUEST_MESSAGE_CENTER.LOADING\">Loading...</span></div><div class=\"gmc-broadcast-guest-empty\" \nng-if=\"!bvm.loadingGuests && !bvm.inHouseGuests.length\"><md-icon md-font-icon=\"icon-account-off\"></md-icon><span \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_NO_GUESTS\">No in-house guests found.</span></div><div \nclass=\"gmc-broadcast-guest-list\" ng-if=\"!bvm.loadingGuests && bvm.inHouseGuests.length\"><div \nclass=\"gmc-broadcast-guest-group\" ng-if=\"bvm.eligibleGuests.length\"><div class=\"gmc-broadcast-guest-group-title\"><span \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_ELIGIBLE\">Eligible</span> <span class=\"gmc-broadcast-guest-group-count\">\n{{bvm.eligibleGuests.length}}</span> <span class=\"gmc-broadcast-guest-group-actions\" flex></span> <button \ntype=\"button\" class=\"gmc-broadcast-select-link\" ng-if=\"!bvm.areAllEligibleSelected()\" \nng-click=\"bvm.selectAllEligible()\" translate=\"GUEST_MESSAGE_CENTER.BROADCAST_SELECT_ALL\">Select all</button> <button \ntype=\"button\" class=\"gmc-broadcast-select-link\" ng-if=\"bvm.getSelectedCount()\" ng-click=\"bvm.clearGuestSelection()\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_CLEAR\">Clear</button></div><div \nclass=\"gmc-broadcast-guest-row is-selectable\" \nng-repeat=\"guest in bvm.eligibleGuests track by guest.confirmation_number\" \nng-class=\"{\'is-checked\': bvm.isGuestSelected(guest)}\" ng-click=\"bvm.toggleGuest(guest, $event)\"><md-checkbox \nclass=\"gmc-broadcast-guest-check\" ng-model=\"bvm.selectedConfirmations[guest.confirmation_number]\" \nng-click=\"$event.stopPropagation()\" aria-label=\"Select {{guest.guest_name}}\"></md-checkbox><div \nclass=\"gmc-broadcast-guest-avatar\">{{bvm.getGuestInitial(guest)}}</div><div class=\"gmc-broadcast-guest-meta\" flex><div \nclass=\"gmc-broadcast-guest-name\">{{guest.guest_name}}</div><div class=\"gmc-broadcast-guest-sub\"><span \nng-if=\"guest.room\">Room {{guest.room}} · </span>{{guest.confirmation_number}} <span ng-if=\"guest.phone\">\n· {{bvm.formatPhoneNumber(guest.phone)}}</span> <span ng-if=\"guest.hotel_title\">· {{guest.hotel_title}}</span></div>\n</div><div class=\"gmc-broadcast-guest-statuses\"><span class=\"gmc-broadcast-status-chip\" \nng-repeat=\"status in guest.statuses track by status.key\" ng-class=\"\'is-\' + status.key\">{{status.label}}</span></div>\n</div></div><div class=\"gmc-broadcast-guest-group is-ineligible\" ng-if=\"bvm.ineligibleGuests.length\"><div \nclass=\"gmc-broadcast-guest-group-title\"><span translate=\"GUEST_MESSAGE_CENTER.BROADCAST_NOT_ELIGIBLE\">Not eligible\n</span> <span class=\"gmc-broadcast-guest-group-count\">{{bvm.ineligibleGuests.length}}</span></div><div \nclass=\"gmc-broadcast-guest-row is-blocked\" \nng-repeat=\"guest in bvm.ineligibleGuests track by guest.confirmation_number\" \nng-class=\"{\'is-opted-out\': guest.messaging_opt_out}\"><md-checkbox class=\"gmc-broadcast-guest-check\" ng-disabled=\"true\" \nng-checked=\"false\" aria-label=\"{{guest.guest_name}} not eligible\"></md-checkbox><div \nclass=\"gmc-broadcast-guest-avatar\">{{bvm.getGuestInitial(guest)}}</div><div class=\"gmc-broadcast-guest-meta\" flex><div \nclass=\"gmc-broadcast-guest-name\">{{guest.guest_name}}</div><div class=\"gmc-broadcast-guest-sub\"><span \nng-if=\"guest.room\">Room {{guest.room}} · </span>{{guest.confirmation_number}} <span ng-if=\"guest.phone\">\n· {{bvm.formatPhoneNumber(guest.phone)}}</span> <span ng-if=\"guest.hotel_title\">· {{guest.hotel_title}}</span></div>\n</div><div class=\"gmc-broadcast-guest-statuses\"><span class=\"gmc-broadcast-status-chip\" \nng-repeat=\"status in guest.statuses track by status.key\" ng-class=\"\'is-\' + status.key\">{{status.label}}</span></div>\n</div></div></div></div></div><div class=\"gmc-broadcast-compose\" layout=\"column\" flex><div class=\"gmc-broadcast-form\" \nms-scroll ng-class=\"{\'has-quick-reply-open\': bvm.quickReplyOpen}\"><div \nclass=\"gmc-broadcast-alert gmc-broadcast-alert-warn\" \nng-if=\"!bvm.canSendDirect || (!bvm.smsEnabled && !bvm.whatsappEnabled)\"><span ng-if=\"!bvm.canSendDirect\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_NO_DIRECT\">Direct messaging permission is required to send group messages. \n</span><span ng-if=\"bvm.canSendDirect && !bvm.smsEnabled && !bvm.whatsappEnabled\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_CHANNELS_DISABLED\">SMS and WhatsApp messaging are not enabled for this hotel.\n</span></div><div class=\"gmc-broadcast-section\"><div class=\"gmc-broadcast-section-title\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_CHANNEL\">Channel</div><div class=\"gmc-broadcast-channel-picker\"><button \ntype=\"button\" class=\"gmc-broadcast-channel-pill\" ng-if=\"bvm.smsEnabled && bvm.whatsappEnabled\" \nng-class=\"{\'is-active\': bvm.channel === \'default\'}\" ng-click=\"bvm.setChannel(\'default\')\">Default</button> <button \ntype=\"button\" class=\"gmc-broadcast-channel-pill\" ng-if=\"bvm.smsEnabled\" \nng-class=\"{\'is-active\': bvm.channel === \'sms\'}\" ng-click=\"bvm.setChannel(\'sms\')\">SMS</button> <button type=\"button\" \nclass=\"gmc-broadcast-channel-pill\" ng-if=\"bvm.whatsappEnabled\" ng-class=\"{\'is-active\': bvm.channel === \'whatsapp\'}\" \nng-click=\"bvm.setChannel(\'whatsapp\')\">WhatsApp</button></div><p class=\"gmc-broadcast-help\" \nng-if=\"bvm.channel === \'default\'\">\nSends each guest on their most recently active open SMS or WhatsApp chat. Guests without an open chat are messaged on SMS using the traveler phone number. If WhatsApp is outside the 24-hour window, falls back to SMS when available.\n</p><p class=\"gmc-broadcast-help\" ng-if=\"bvm.channel === \'whatsapp\'\">\nGuests outside the WhatsApp 24-hour messaging window will be skipped.</p></div><div \nclass=\"gmc-broadcast-section gmc-broadcast-compose-section\"><div class=\"gmc-broadcast-compose-toolbar\" layout=\"row\" \nlayout-align=\"start center\"><label class=\"gmc-broadcast-label gmc-broadcast-label--inline\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_MESSAGE_TO_GROUP\">Message to be sent to group</label><div \nclass=\"gmc-broadcast-quick-reply gmc-broadcast-promote-reply\" \nng-if=\"bvm.canSendDirect && (bvm.smsEnabled || bvm.whatsappEnabled)\"><button type=\"button\" \nclass=\"gmc-broadcast-quick-reply-toggle\" ng-class=\"{\'is-open\': bvm.promoteReplyOpen}\" \nng-click=\"bvm.togglePromoteReplyPicker($event)\" aria-haspopup=\"true\" aria-expanded=\"{{bvm.promoteReplyOpen}}\"><md-icon \nclass=\"gmc-broadcast-quick-reply-icon\" style=\"line-height:1\"><svg xmlns=\"http://www.w3.org/2000/svg\" height=\"18px\" \nviewBox=\"0 0 24 24\" width=\"18px\" fill=\"currentColor\"><path \nd=\"M18 11v2h4v-2h-4zm-2 6.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61zM20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.99-.74 2.24-1.68 3.2-2.4zM4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9H4zm7.5 5.73C10.35 14.27 9.57 13.21 9.57 12s.78-2.27 1.93-2.73v5.46zM8.18 12.63L8 12.63V12v-.63l.18-.11 3.32-1.99v5.46l-3.32-1.99z\"/>\n</svg></md-icon><span translate=\"GUEST_MESSAGE_CENTER.PROMOTE_REPLY\">Promote Reply</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"gmc-broadcast-quick-reply-caret\"></md-icon></button><div \nclass=\"gmc-broadcast-quick-reply-menu\" ng-if=\"bvm.promoteReplyOpen\" ng-click=\"$event.stopPropagation()\"><div \nclass=\"gmc-broadcast-quick-reply-search\"><input type=\"text\" ng-model=\"bvm.promoteReplySearch\" \nng-change=\"bvm.filterPromoteReplies()\" placeholder=\"{{\'GUEST_MESSAGE_CENTER.PROMOTE_REPLY_SEARCH\' | translate}}\" \naria-label=\"Search promote replies\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></div><div \nclass=\"gmc-broadcast-quick-reply-list\"><div class=\"gmc-broadcast-quick-reply-empty\" ng-if=\"bvm.promoteReplyLoading\">\n{{\'GUEST_MESSAGE_CENTER.LOADING\' | translate}}</div><div class=\"gmc-broadcast-quick-reply-empty\" \nng-if=\"!bvm.promoteReplyLoading && !bvm.promoteReplyFiltered.length\">\n{{\'GUEST_MESSAGE_CENTER.PROMOTE_REPLY_EMPTY\' | translate}}</div><div class=\"gmc-broadcast-quick-reply-group\" \nng-repeat=\"category in bvm.promoteReplyFiltered track by category.id\"><div class=\"gmc-broadcast-quick-reply-category\">\n{{category.name}}</div><button type=\"button\" class=\"gmc-broadcast-quick-reply-item\" \nng-repeat=\"template in category.templates track by template.id\" ng-click=\"bvm.applyPromoteReply(template)\">\n{{template.name}}</button></div></div></div></div><div class=\"gmc-broadcast-quick-reply\" \nng-if=\"bvm.canSendDirect && (bvm.smsEnabled || bvm.whatsappEnabled)\"><button type=\"button\" \nclass=\"gmc-broadcast-quick-reply-toggle\" ng-class=\"{\'is-open\': bvm.quickReplyOpen}\" \nng-click=\"bvm.toggleQuickReplyPicker($event)\" aria-haspopup=\"true\" aria-expanded=\"{{bvm.quickReplyOpen}}\"><md-icon \nmd-font-icon=\"icon-timer\" class=\"gmc-broadcast-quick-reply-icon\"></md-icon><span \ntranslate=\"GUEST_MESSAGE_CENTER.QUICK_REPLY\">Quick Reply</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"gmc-broadcast-quick-reply-caret\"></md-icon></button><div class=\"gmc-broadcast-quick-reply-menu\" \nng-if=\"bvm.quickReplyOpen\" ng-click=\"$event.stopPropagation()\"><div class=\"gmc-broadcast-quick-reply-search\"><input \ntype=\"text\" ng-model=\"bvm.quickReplySearch\" ng-change=\"bvm.filterQuickReplies()\" \nplaceholder=\"{{\'GUEST_MESSAGE_CENTER.QUICK_REPLY_SEARCH\' | translate}}\" aria-label=\"Search quick replies\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></div><div class=\"gmc-broadcast-quick-reply-list\"><div \nclass=\"gmc-broadcast-quick-reply-empty\" ng-if=\"bvm.quickReplyLoading\">{{\'GUEST_MESSAGE_CENTER.LOADING\' | translate}}\n</div><div class=\"gmc-broadcast-quick-reply-empty\" ng-if=\"!bvm.quickReplyLoading && !bvm.quickReplyFiltered.length\">\n{{\'GUEST_MESSAGE_CENTER.QUICK_REPLY_EMPTY\' | translate}}</div><div class=\"gmc-broadcast-quick-reply-group\" \nng-repeat=\"category in bvm.quickReplyFiltered track by category.id\"><div class=\"gmc-broadcast-quick-reply-category\">\n{{category.name}}</div><button type=\"button\" class=\"gmc-broadcast-quick-reply-item\" \nng-repeat=\"template in category.templates track by template.id\" ng-click=\"bvm.applyQuickReply(template)\">\n{{template.name}}</button></div></div></div></div></div><div class=\"gmc-broadcast-field\"><div \nclass=\"gmc-broadcast-textarea-wrap\"><textarea class=\"gmc-broadcast-textarea\" ng-model=\"bvm.message\" rows=\"8\" \nplaceholder=\"{{ \'GUEST_MESSAGE_CENTER.BROADCAST_MESSAGE_PLACEHOLDER\' | translate }}\"></textarea></div><p \nclass=\"gmc-broadcast-help\" ng-if=\"bvm.message.indexOf(\'#{\') !== -1\">\nNote: Tokens like #{firstName}, #{roomNumber}, and #{hotelName} are filled with each guest\'s details when the message is sent.\n</p></div></div><div class=\"gmc-broadcast-actions\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-raised md-primary gmc-broadcast-send-btn\" ng-click=\"bvm.sendBroadcast()\" ng-disabled=\"!bvm.canSubmit()\">\n<md-icon md-font-icon=\"icon-send\" class=\"gmc-broadcast-send-icon\"></md-icon><span ng-if=\"!bvm.sending\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_SEND\">Send Group message</span> <span ng-if=\"bvm.sending\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_SENDING\">Sending...</span></md-button></div><div \nclass=\"gmc-broadcast-results\" ng-if=\"bvm.lastResult\"><div class=\"gmc-broadcast-section-title\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_RESULTS\">Last group message results</div><div \nclass=\"gmc-broadcast-results-summary\" layout=\"row\" layout-wrap><div class=\"gmc-broadcast-stat\"><span class=\"label\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_REQUESTED\">Requested</span> <span class=\"value\">\n{{bvm.lastResult.requested || 0}}</span></div><div class=\"gmc-broadcast-stat is-sent\"><span class=\"label\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_SENT\">Sent</span> <span class=\"value\">{{bvm.lastResult.sent || 0}}</span>\n</div><div class=\"gmc-broadcast-stat is-skipped\"><span class=\"label\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_SKIPPED\">Skipped</span> <span class=\"value\">{{bvm.lastResult.skipped || 0}}\n</span></div><div class=\"gmc-broadcast-stat is-failed\"><span class=\"label\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_FAILED\">Failed</span> <span class=\"value\">{{bvm.lastResult.failed || 0}}\n</span></div></div><div class=\"gmc-broadcast-results-table-wrap\" \nng-if=\"bvm.lastResult.results && bvm.lastResult.results.length\"><table class=\"gmc-broadcast-results-table\"><thead><tr>\n<th translate=\"GUEST_MESSAGE_CENTER.CONFIRMATION\">Confirmation</th><th \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_CHANNEL\">Channel</th><th translate=\"GUEST_MESSAGE_CENTER.BROADCAST_STATUS\">\nStatus</th><th translate=\"GUEST_MESSAGE_CENTER.BROADCAST_DETAIL\">Detail</th></tr></thead><tbody><tr \nng-repeat=\"row in bvm.lastResult.results track by $index\" ng-class=\"\'status-\' + row.status\"><td>\n{{row.confirmation_number}}</td><td>{{row.channel || bvm.lastResult.channel || \'—\'}}</td><td>{{row.status}}</td><td>\n{{bvm.getReasonLabel(row.reason)}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/apps/guest-message-center/inbox/inbox.html","<div id=\"ota-message-center\" class=\"page-layout simple tabbed full-height\" layout=\"column\"><div \nclass=\"header md-accent-bg relative-block\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"md-icon-button\"><md-icon \nmd-font-icon=\"{{ vm.isArchiveView ? \'icon-archive\' : \'icon-message-text\' }}\"></md-icon></md-button><div class=\"h2\" \nng-if=\"!vm.isArchiveView\" translate=\"GUEST_MESSAGE_CENTER.TITLE\">Message Center</div><div class=\"h2\" \nng-if=\"vm.isArchiveView\" translate=\"GUEST_MESSAGE_CENTER.ARCHIVE\">Archive</div></div><md-button \nclass=\"md-raised md-cornered gmc-new-conversation-btn\" ng-if=\"vm.showNewConversation()\" \nng-click=\"vm.openNewConversationDialog($event)\"><md-icon md-font-icon=\"icon-plus\" class=\"gmc-new-conversation-icon\">\n</md-icon><span translate=\"DIRECT_MESSAGE_CENTER.NEW_CONVERSATION\">New conversation</span></md-button><md-button \nclass=\"md-raised md-cornered gmc-new-conversation-btn\" ng-if=\"!vm.isArchiveView && vm.activeTab === \'group_msg\'\" \nng-click=\"vm.openGroupMessageLogs()\"><md-icon md-font-icon=\"icon-history\" class=\"gmc-new-conversation-icon\"></md-icon>\n<span translate=\"GUEST_MESSAGE_CENTER.BROADCAST_LOGS_TITLE\">Group message logs</span></md-button></div><div \nclass=\"gmc-main\" layout=\"row\" flex><div class=\"gmc-card gmc-group-msg-card\" layout=\"row\" flex \nng-if=\"vm.activeTab === \'group_msg\'\" ng-controller=\"GroupMessagesController as bvm\" \nng-init=\"bvm.skipSendConfirm = true\"><div \nng-include=\"\'app/main/apps/guest-message-center/group-messages/group-message-panel.html\'\" layout=\"row\" flex \nclass=\"gmc-group-msg-include\"></div></div><div class=\"gmc-card\" layout=\"row\" ng-if=\"vm.activeTab !== \'group_msg\'\" \nng-class=\"{\'gmc-has-selection\': vm.selectedThread}\"><div class=\"gmc-thread-list\" layout=\"column\"><div class=\"gmc-tabs\" \nng-if=\"vm.showTabs()\"><button type=\"button\" class=\"gmc-tab\" ng-class=\"{\'is-active\': vm.activeTab === \'all\'}\" \nng-click=\"vm.setTab(\'all\')\">{{\'GUEST_MESSAGE_CENTER.TAB_ALL\' | translate}} <span class=\"gmc-filter-chip-badge\" \nng-if=\"vm.getGuestUnreadTotal() > 0\" style=\"margin-left: 6px; position: relative; top: -1px\">\n{{vm.getGuestUnreadTotal()}}</span></button> <button type=\"button\" class=\"gmc-tab\" ng-if=\"vm.showGroupMessageTab()\" \nng-class=\"{\'is-active\': vm.activeTab === \'group_msg\'}\" ng-click=\"vm.setTab(\'group_msg\')\" \ntranslate=\"GUEST_MESSAGE_CENTER.TAB_GROUP_MSG\">Group message</button> <button type=\"button\" class=\"gmc-tab\" \nng-click=\"vm.goToStaffTab()\">Staff <span class=\"gmc-filter-chip-badge\" ng-if=\"vm.getStaffUnreadTotal() > 0\" \nstyle=\"margin-left: 6px; position: relative; top: -1px\">{{vm.getStaffUnreadTotal()}}</span></button></div><div \nclass=\"gmc-thread-toolbar\" ng-if=\"vm.channelFlagsReady && vm.hasAnyChannelEnabled()\"><div \nclass=\"gmc-thread-toolbar-row\" layout=\"row\" layout-align=\"start center\" flex><md-select class=\"gmc-hotel-select\" \nng-if=\"vm.subHotels.length > 0\" ng-model=\"vm.subHotelId\" ng-change=\"vm.onSubHotelChange()\" \nng-disabled=\"vm.loadingThreads\" placeholder=\"{{\'GUEST_MESSAGE_CENTER.ALL_HOTELS\' | translate}}\" flex \nstyle=\"margin: 0; min-width: 100px\"><md-option value=\"\">{{\'GUEST_MESSAGE_CENTER.ALL_HOTELS\' | translate}}</md-option>\n<md-option ng-repeat=\"hotel in vm.subHotels\" value=\"{{hotel.hotel_id}}\">{{hotel.hotel_title}}</md-option></md-select>\n<div class=\"gmc-thread-filters\" layout=\"row\" layout-align=\"end center\" style=\"flex-shrink: 0\" \nng-if=\"!vm.isArchiveView\"><button class=\"gmc-filter-chip\" ng-class=\"{\'is-active\': vm.threadFilter === \'all\'}\" \nng-click=\"vm.setThreadFilter(\'all\')\" ng-disabled=\"vm.loadingThreads\">All</button> <button class=\"gmc-filter-chip\" \nng-class=\"{\'is-active\': vm.threadFilter === \'in_house\'}\" ng-click=\"vm.setThreadFilter(\'in_house\')\" \nng-disabled=\"vm.loadingThreads\">In House</button> <button class=\"gmc-filter-chip\" \nng-class=\"{\'is-active\': vm.threadFilter === \'unread\'}\" ng-click=\"vm.setThreadFilter(\'unread\')\" \nng-disabled=\"vm.loadingThreads\">Unread <span class=\"gmc-filter-chip-badge unread-chip-badge\" \nng-if=\"vm.getGuestUnreadTotal() > 0\" style=\"margin-left: 6px\">{{vm.getGuestUnreadTotal()}}</span></button></div></div>\n<div class=\"gmc-thread-search\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"gmc-search-icon s20\"></md-icon><input type=\"text\" ng-model=\"vm.searchQuery\" ng-change=\"vm.onSearchChange()\" \nplaceholder=\"Search\" flex aria-label=\"Search\"> <button type=\"button\" class=\"gmc-search-clear\" ng-if=\"vm.searchQuery\" \nng-click=\"vm.clearSearch()\" aria-label=\"Clear search\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon>\n</button></div></div><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingThreads\"></md-progress-linear><div \nclass=\"gmc-thread-errors\" ng-if=\"vm.threadErrors.length\"><div class=\"gmc-error-item\" \nng-repeat=\"error in vm.threadErrors\">{{error.message || error}}</div></div><div id=\"gmc-thread-scroll\" \nclass=\"gmc-thread-scroll\" ng-class=\"{\'is-loading\': vm.loadingThreads && !vm.threads.length}\"><div \nclass=\"gmc-thread-loading\" ng-if=\"vm.loadingThreads && !vm.threads.length\"><md-progress-circular md-diameter=\"36\" \nclass=\"gmc-loading-spinner\"></md-progress-circular><p>{{\'GUEST_MESSAGE_CENTER.LOADING\' | translate}}</p></div><div \nclass=\"gmc-empty-state\" ng-if=\"!vm.loadingThreads && vm.channelFlagsReady && !vm.hasAnyChannelEnabled()\"><div \nclass=\"gmc-empty-state-icon-wrap\"><md-icon md-font-icon=\"icon-cog\" class=\"gmc-empty-state-icon\"></md-icon></div><p \nclass=\"gmc-empty-state-title\">{{\'GUEST_MESSAGE_CENTER.CHANNELS_DISABLED\' | translate}}</p><p \nclass=\"gmc-empty-state-desc\">{{\'GUEST_MESSAGE_CENTER.CHANNELS_DISABLED_DESC\' | translate}}</p></div><div \nclass=\"gmc-empty-state\" \nng-if=\"!vm.loadingThreads && vm.channelFlagsReady && vm.hasAnyChannelEnabled() && !vm.threads.length\"><div \nclass=\"gmc-empty-state-icon-wrap\"><md-icon md-font-icon=\"icon-forum\" class=\"gmc-empty-state-icon\"></md-icon></div><p \nclass=\"gmc-empty-state-title\" ng-if=\"vm.isArchiveView\">{{\'GUEST_MESSAGE_CENTER.NO_ARCHIVED_THREADS\' | translate}}</p><p\n class=\"gmc-empty-state-title\" ng-if=\"!vm.isArchiveView && vm.threadFilter !== \'unread\'\">\n{{\'GUEST_MESSAGE_CENTER.NO_THREADS\' | translate}}</p><p class=\"gmc-empty-state-title\" \nng-if=\"!vm.isArchiveView && vm.threadFilter === \'unread\'\">No unread messages</p></div><div class=\"gmc-thread-item\" \nng-repeat=\"thread in vm.threads track by vm.getThreadKey(thread)\" \nng-class=\"{\'is-active\': vm.isThreadSelected(thread), \'is-closed\': thread.is_closed, \'has-unread\': vm.hasUnread(thread), \'is-escalation-unread\': vm.isEscalationUnread(thread), \'is-menu-open\': thread._menuOpen}\" \nng-click=\"vm.selectThread(thread)\"><div class=\"gmc-thread-avatar\" ng-style=\"vm.getAvatarStyle(thread)\">\n{{vm.getGuestInitial(thread)}}</div><div class=\"gmc-thread-content\"><div class=\"gmc-thread-head\"><span \nclass=\"gmc-guest-name\"><span class=\"gmc-guest-name-text\">{{vm.getThreadTitle(thread)}}</span></span><div \nclass=\"gmc-thread-head-end\"><span class=\"gmc-thread-date\" ng-if=\"vm.getThreadActivity(thread)\">\n{{vm.formatShortDate(vm.getThreadActivity(thread), thread.timezone)}} </span><span class=\"gmc-unread-badge\" \nng-if=\"vm.showThreadUnreadBadge(thread)\">{{vm.getUnreadLabel(thread)}}</span><md-icon md-font-icon=\"icon-alert\" \nclass=\"gmc-escalation-alert-icon\" ng-if=\"vm.isEscalationUnread(thread)\"></md-icon><md-menu class=\"gmc-thread-menu\" \nmd-position-mode=\"target-right target\" md-offset=\"0 4\" md-on-open=\"thread._menuOpen = true\" \nmd-on-close=\"thread._menuOpen = false\" ng-if=\"thread.confirmation_number\"><button type=\"button\" \nclass=\"gmc-thread-menu-btn\" ng-click=\"$mdOpenMenu($event); $event.stopPropagation()\" aria-label=\"Conversation options\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></button><md-menu-content width=\"2\" \nclass=\"gmc-thread-menu-content\"><md-menu-item><md-button ng-click=\"vm.toggleThreadArchived(thread)\" \nng-disabled=\"vm.updatingArchive\"><span ng-if=\"!vm.isThreadArchived(thread)\" translate=\"GUEST_MESSAGE_CENTER.ARCHIVE\">\nArchive</span> <span ng-if=\"vm.isThreadArchived(thread)\" translate=\"GUEST_MESSAGE_CENTER.UNARCHIVE\">Unarchive</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"gmc-thread-subtitle\" \nng-if=\"vm.getThreadSubtitle(thread)\">{{vm.getThreadSubtitle(thread)}}</div><div class=\"gmc-thread-hotel\" \nng-if=\"vm.isParent && thread.hotel_title\">{{thread.hotel_title}}</div><div class=\"gmc-thread-bottom\"><div \nclass=\"gmc-thread-preview\" ng-if=\"thread.last_message || vm.isLastMessageMedia(thread)\"><md-icon \nmd-font-icon=\"{{vm.getLastMessageDirectionIcon(thread)}}\" class=\"gmc-thread-preview-icon\" \nng-if=\"vm.getLastMessageDirectionIcon(thread)\"></md-icon><span class=\"gmc-thread-preview-media-icon\" \nng-if=\"vm.isLastMessageMedia(thread)\" aria-hidden=\"true\"><svg viewBox=\"0 0 16 16\" width=\"15\" height=\"15\" \nfocusable=\"false\"><path fill=\"currentColor\" \nd=\"M2.5 2.75A1.75 1.75 0 0 1 4.25 1h7.5A1.75 1.75 0 0 1 13.5 2.75v10.5A1.75 1.75 0 0 1 11.75 15h-7.5A1.75 1.75 0 0 1 2.5 13.25V2.75zm1.25-.25a.25.25 0 0 0-.25.25v7.19l2.22-2.22a.75.75 0 0 1 1.06 0L9.5 10.44l1.22-1.22a.75.75 0 0 1 1.06 0l.72.72V2.75a.25.25 0 0 0-.25-.25h-7.5zM12.5 11.56l-.19-.19-1.75 1.75a.75.75 0 0 1-1.06 0L6.78 10.4 3.75 13.44v-.19c0 .14.11.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.69zM10.25 6a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5z\"/>\n</svg> </span><span class=\"gmc-thread-preview-text\">{{vm.getThreadPreviewText(thread)}}</span></div></div><div \nclass=\"gmc-thread-meta\"><span class=\"gmc-provider-chips\"><span class=\"gmc-provider-chip\" \nng-if=\"vm.getThreadSourceChip(thread)\" ng-class=\"vm.getThreadSourceChip(thread).cls\">\n{{vm.getThreadSourceChip(thread).label}} </span></span><span class=\"gmc-thread-meta-trailing\"><span \nclass=\"gmc-thread-stay\" \nng-if=\"vm.hasFormattedStayDate(vm.getThreadCheckIn(thread)) || vm.hasFormattedStayDate(vm.getThreadCheckOut(thread))\">\n<md-icon md-font-icon=\"icon-calendar\" class=\"gmc-stay-icon\"></md-icon><span class=\"gmc-thread-stay-text\" \nng-if=\"vm.hasFormattedStayDate(vm.getThreadCheckIn(thread)) && vm.hasFormattedStayDate(vm.getThreadCheckOut(thread))\">\n{{vm.formatStayDateRange(vm.getThreadCheckIn(thread), vm.getThreadCheckOut(thread))}} </span><span \nclass=\"gmc-thread-stay-text\" \nng-if=\"vm.hasFormattedStayDate(vm.getThreadCheckIn(thread)) && !vm.hasFormattedStayDate(vm.getThreadCheckOut(thread))\">\n{{vm.formatStayDate(vm.getThreadCheckIn(thread))}} </span><span class=\"gmc-thread-stay-text\" \nng-if=\"!vm.hasFormattedStayDate(vm.getThreadCheckIn(thread)) && vm.hasFormattedStayDate(vm.getThreadCheckOut(thread))\">\n{{vm.formatStayDate(vm.getThreadCheckOut(thread))}} </span></span><span class=\"gmc-stay-status gmc-thread-stay-status\" \nng-if=\"vm.getStayStatusLabel(thread)\" ng-class=\"vm.getStayStatusClass(thread)\">{{vm.getStayStatusLabel(thread)}} \n</span></span><span class=\"gmc-closed-chip\" ng-if=\"thread.is_closed\">{{\'GUEST_MESSAGE_CENTER.CLOSED\' | translate}}\n</span></div></div></div><div class=\"gmc-load-more\" ng-if=\"vm.loadingThreads && vm.threads.length\">\n<md-progress-circular class=\"gmc-load-more-spinner\" md-diameter=\"28\" md-mode=\"indeterminate\"></md-progress-circular>\n</div></div></div><div class=\"gmc-conversation gmc-conversation-dummy\" ng-if=\"!vm.selectedThread\"><div \nclass=\"gmc-dummy-content\" ng-if=\"vm.threads.length\"><div class=\"gmc-dummy-icon-wrap\"><md-icon \nmd-font-icon=\"icon-message-text\" class=\"gmc-dummy-icon\"></md-icon></div><h3>\n{{\'GUEST_MESSAGE_CENTER.SELECT_THREAD\' | translate}}</h3><p>{{\'GUEST_MESSAGE_CENTER.SELECT_THREAD_DESC\' | translate}}\n</p></div><div class=\"gmc-dummy-content gmc-dummy-content--no-threads\" \nng-if=\"!vm.loadingThreads && vm.channelFlagsReady && !vm.hasAnyChannelEnabled()\"><div \nclass=\"gmc-dummy-icon-wrap gmc-dummy-icon-wrap--large\"><md-icon md-font-icon=\"icon-cog\" class=\"gmc-dummy-icon\">\n</md-icon></div><h3>{{\'GUEST_MESSAGE_CENTER.CHANNELS_DISABLED\' | translate}}</h3><p>\n{{\'GUEST_MESSAGE_CENTER.CHANNELS_DISABLED_DESC\' | translate}}</p></div><div \nclass=\"gmc-dummy-content gmc-dummy-content--no-threads\" \nng-if=\"!vm.loadingThreads && vm.channelFlagsReady && vm.hasAnyChannelEnabled() && !vm.threads.length\"><div \nclass=\"gmc-dummy-icon-wrap gmc-dummy-icon-wrap--large\"><md-icon md-font-icon=\"icon-forum\" class=\"gmc-dummy-icon\">\n</md-icon></div><h3 ng-if=\"vm.isArchiveView\">{{\'GUEST_MESSAGE_CENTER.NO_ARCHIVED_THREADS\' | translate}}</h3><h3 \nng-if=\"!vm.isArchiveView && vm.threadFilter !== \'unread\'\">{{\'GUEST_MESSAGE_CENTER.NO_THREADS\' | translate}}</h3><h3 \nng-if=\"!vm.isArchiveView && vm.threadFilter === \'unread\'\">No unread messages</h3></div><div class=\"gmc-dummy-content\" \nng-if=\"vm.loadingThreads && !vm.threads.length\"><md-progress-circular md-diameter=\"48\" class=\"gmc-loading-spinner\">\n</md-progress-circular><p>{{\'GUEST_MESSAGE_CENTER.LOADING\' | translate}}</p></div></div><div \nclass=\"gmc-conversation gmc-conversation-panel\" layout=\"column\" ng-if=\"vm.selectedThread\" \ndata-drop-hint=\"Drop image to attach\" gmc-dropzone gmc-dropzone-enabled=\"vm.canAttachImage()\" \ngmc-dropzone-drop=\"vm.onComposerDrop($event)\"><div class=\"gmc-conversation-header\"><div class=\"gmc-header-main\">\n<md-button class=\"md-icon-button gmc-back-btn\" ng-click=\"vm.goBackToThreads()\" aria-label=\"Back\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"gmc-header-avatar\" \nng-style=\"vm.getAvatarStyle(vm.selectedThread)\">{{vm.getGuestInitial(vm.selectedThread)}}</div><div \nclass=\"gmc-header-body\"><div class=\"gmc-header-line1\"><span class=\"gmc-conversation-title\">\n{{vm.getThreadTitle(vm.selectedThread)}}</span> <span class=\"gmc-stay-status gmc-header-title-status\" \nng-if=\"vm.getStayStatusLabel()\" ng-class=\"vm.getStayStatusClass()\">{{vm.getStayStatusLabel()}}</span></div><div \nclass=\"gmc-header-hotel\" ng-if=\"vm.getThreadHotelTitle(vm.selectedThread)\">\n{{vm.getThreadHotelTitle(vm.selectedThread)}}</div><div class=\"gmc-header-meta\" \nng-if=\"vm.selectedThread.provider || vm.selectedThread.channel || vm.selectedThread.confirmation_number || vm.selectedThread.ota_id || (vm.showDirectFeatures() && vm.getThreadPhone(vm.selectedThread)) || vm.getRoomLabel(vm.selectedThread)\">\n<span class=\"gmc-provider-chip gmc-header-provider\" ng-if=\"vm.getThreadSourceChip(vm.selectedThread)\" \nng-class=\"vm.getThreadSourceChip(vm.selectedThread).cls\">{{vm.getThreadSourceChip(vm.selectedThread).label}} </span>\n<span class=\"gmc-meta-sep\" \nng-if=\"vm.showDirectFeatures() && vm.getThreadSourceChip(vm.selectedThread) && vm.getThreadPhone(vm.selectedThread)\">·\n</span> <span class=\"gmc-meta-detail gmc-phone-meta\" ng-if=\"vm.showDirectFeatures() && !vm.editingPhone\"><span \nng-if=\"vm.getThreadPhone(vm.selectedThread)\">{{vm.formatPhoneNumber(vm.getThreadPhone(vm.selectedThread))}}</span> \n<span ng-if=\"!vm.getThreadPhone(vm.selectedThread)\" class=\"gmc-phone-missing\" \ntranslate=\"GUEST_MESSAGE_CENTER.NO_PHONE\">No phone</span> <button type=\"button\" class=\"gmc-phone-edit-btn\" \nng-click=\"vm.beginPhoneEdit()\" translate=\"GUEST_MESSAGE_CENTER.EDIT_PHONE\">Edit</button> </span><span \nclass=\"gmc-phone-edit\" ng-if=\"vm.showDirectFeatures() && vm.editingPhone\"><span \nclass=\"gmc-phone-iti-field gmc-phone-edit-field\"><input type=\"tel\" id=\"gmcPhoneEditInput\" name=\"gmc_phone_edit\" \nclass=\"gmc-phone-edit-input intel-number-input\" ng-model=\"vm.phoneEditValue\" ng-disabled=\"vm.savingPhone\" \nintl-tel-input style=\"padding-left: 76px !important\" autocomplete=\"off\" aria-label=\"Phone number\" \nng-change=\"vm.updatePhoneWithCountryCode(\'gmc_phone_edit\', $event)\"> </span><button type=\"button\" \nclass=\"gmc-phone-save-btn\" ng-click=\"vm.saveGuestPhone()\" ng-disabled=\"vm.savingPhone || !vm.isPhoneEditValid()\"><span \nng-if=\"!vm.savingPhone\">Save</span> <span class=\"gmc-phone-save-loading\" ng-if=\"vm.savingPhone\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"14\"></md-progress-circular></span></button> <button type=\"button\" \nclass=\"gmc-phone-cancel-btn\" ng-click=\"vm.cancelPhoneEdit()\" ng-disabled=\"vm.savingPhone\">Cancel</button> </span><span \nclass=\"gmc-meta-sep\" ng-if=\"vm.selectedThread.confirmation_number\">·</span> <span class=\"gmc-meta-detail\" \nng-if=\"vm.selectedThread.confirmation_number\">{{vm.selectedThread.confirmation_number}} </span><span \nclass=\"gmc-meta-sep\" ng-if=\"vm.selectedThread.confirmation_number && vm.selectedThread.ota_id\">·</span> <span \nclass=\"gmc-meta-detail\" ng-if=\"vm.selectedThread.ota_id\">{{vm.selectedThread.ota_id}}</span></div></div><div \nclass=\"gmc-header-actions\" ng-if=\"vm.selectedThread.confirmation_number || vm.hasHeaderStayInfo()\"><div \nclass=\"gmc-reservation-panel\"><div class=\"gmc-header-top-actions\" ng-if=\"vm.selectedThread.confirmation_number\"><button\n type=\"button\" class=\"gmc-ai-header-toggle\" ng-if=\"!vm.isOptedOut() && !vm.isAiModeOn()\" \nng-class=\"{\'is-highlight\': vm.highlightAiToggle}\" ng-click=\"vm.toggleAiMode()\" ng-disabled=\"vm.updatingAiMode\" \naria-pressed=\"false\" aria-label=\"Turn AI Mode on\"><span class=\"gmc-ai-header-badge\">AI</span> <span \nclass=\"gmc-ai-header-label\" translate=\"GUEST_MESSAGE_CENTER.AI_MODE\">AI Mode</span> <span class=\"gmc-ai-header-switch\" \naria-hidden=\"true\"><span class=\"gmc-ai-header-knob\"></span></span><md-tooltip md-direction=\"bottom\">\n{{ \'GUEST_MESSAGE_CENTER.AI_MODE_TOOLTIP\' | translate }}</md-tooltip></button><md-button \nclass=\"md-raised md-accent grey-100-fg gmc-view-res-btn\" ng-click=\"vm.openReservation()\"><span \nclass=\"gmc-view-res-content\"><md-icon md-font-icon=\"icon-open-in-new\" class=\"gmc-view-res-icon\"></md-icon><span>\nView Reservation</span></span></md-button></div><div class=\"gmc-header-stay-compact\" \nng-if=\"vm.hasFormattedStayDate(vm.getDisplayCheckIn()) || vm.hasFormattedStayDate(vm.getDisplayCheckOut()) || vm.selectedThread.confirmation_number\">\n<span class=\"gmc-header-stay-dates\" \nng-if=\"vm.hasFormattedStayDate(vm.getDisplayCheckIn()) || vm.hasFormattedStayDate(vm.getDisplayCheckOut())\"><md-icon \nmd-font-icon=\"icon-calendar\" class=\"gmc-header-stay-icon\"></md-icon><span class=\"gmc-header-stay-range\" \nng-if=\"vm.hasFormattedStayDate(vm.getDisplayCheckIn()) && vm.hasFormattedStayDate(vm.getDisplayCheckOut())\">\n{{vm.formatStayDateRange(vm.getDisplayCheckIn(), vm.getDisplayCheckOut())}} </span><span class=\"gmc-header-stay-range\" \nng-if=\"vm.hasFormattedStayDate(vm.getDisplayCheckIn()) && !vm.hasFormattedStayDate(vm.getDisplayCheckOut())\">\nIn {{vm.formatStayDate(vm.getDisplayCheckIn())}} </span><span class=\"gmc-header-stay-range\" \nng-if=\"!vm.hasFormattedStayDate(vm.getDisplayCheckIn()) && vm.hasFormattedStayDate(vm.getDisplayCheckOut())\">\nOut {{vm.formatStayDate(vm.getDisplayCheckOut())}} </span></span><button type=\"button\" \nclass=\"gmc-header-archive-action\" ng-if=\"vm.selectedThread.confirmation_number && vm.canAcknowledgeThread()\" \nng-click=\"vm.acknowledgeThread()\" ng-disabled=\"vm.updatingAcknowledge\" aria-label=\"Acknowledge conversation\"><span \ntranslate=\"GUEST_MESSAGE_CENTER.ACKNOWLEDGE\">Acknowledge</span><md-tooltip md-direction=\"bottom\">\n{{ \'GUEST_MESSAGE_CENTER.ACKNOWLEDGE_TOOLTIP\' | translate }}</md-tooltip></button> <button type=\"button\" \nclass=\"gmc-header-opt-out-link\" \nng-if=\"vm.selectedThread.confirmation_number && !vm.isOptedOut() && vm.showDirectFeatures()\" \nng-click=\"vm.toggleMessagingOptOut()\" ng-disabled=\"vm.updatingOptOut\"><span \ntranslate=\"GUEST_MESSAGE_CENTER.OPT_OUT_SHORT\">Opt out</span><md-tooltip md-direction=\"bottom\">\n{{ \'GUEST_MESSAGE_CENTER.MARK_OPTED_OUT\' | translate }}</md-tooltip></button></div></div></div></div></div><div \nclass=\"gmc-opt-out-banner\" ng-if=\"vm.isOptedOut()\"><md-icon md-font-icon=\"icon-alert\" class=\"gmc-opt-out-icon\">\n</md-icon><span flex>{{vm.getOptOutBannerText()}}</span><md-button class=\"md-raised gmc-opt-out-action\" \nng-click=\"vm.toggleMessagingOptOut()\" ng-disabled=\"vm.updatingOptOut\" translate=\"GUEST_MESSAGE_CENTER.OPT_IN\">Opt in\n</md-button></div><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingMessages\"></md-progress-linear><div \nid=\"gmc-messages-container\" class=\"gmc-messages\"><div class=\"gmc-load-more-messages\" \nng-if=\"vm.showLoadEarlier && vm.hasMoreMessages()\"><md-button class=\"gmc-load-earlier-btn\" \nng-click=\"vm.loadMoreMessages()\" ng-disabled=\"vm.loadingMessages\"><span ng-if=\"!vm.loadingMessages\">\nLoad earlier messages</span> <span ng-if=\"vm.loadingMessages\">Loading...</span></md-button></div><div \nclass=\"gmc-message-wrap\" ng-repeat=\"message in vm.messages track by message._uid\" \nng-class=\"{\n                                 \'align-left\': message.sender === \'guest\',\n                                 \'align-right\': message.sender === \'property\' || message.sender === \'ai\',\n                                 \'align-center\': message.sender === \'system\',\n                                 \'has-translate-open\': message._translateOpen\n                             }\">\n<div class=\"gmc-message\" \nng-class=\"{\n                                     \'from-guest\': message.sender === \'guest\',\n                                     \'from-property\': message.sender === \'property\' || message.sender === \'ai\',\n                                     \'from-system\': message.sender === \'system\',\n                                     \'from-escalation\': vm.isSupportEscalation(message)\n                                 }\">\n<div class=\"gmc-message-body gmc-phone-change-notice\" ng-if=\"vm.isPhoneChangeNotice(message)\" \nng-bind=\"vm.getPhoneChangeNoticeText(message)\"></div><div class=\"gmc-message-body\" \nng-if=\"!vm.isPhoneChangeNotice(message) && (message.sender !== \'system\' || message.message !== \'inquiry\') && vm.getMessageText(message)\" \nng-bind=\"vm.getMessageText(message)\"></div><div class=\"gmc-inquiry-card\" \nng-if=\"message.sender === \'system\' && vm.getInquiryDetails(message)\"><div class=\"gmc-inquiry-title\">\n{{\'GUEST_MESSAGE_CENTER.INQUIRY\' | translate}}</div><div ng-if=\"vm.getInquiryDetails(message).guest_name\">\nGuest: {{vm.getInquiryDetails(message).guest_name}}</div><div ng-if=\"vm.getInquiryDetails(message).checkin_date\">\n{{\'GUEST_MESSAGE_CENTER.CHECK_IN\' | translate}}: {{vm.getInquiryDetails(message).checkin_date}}</div><div \nng-if=\"vm.getInquiryDetails(message).checkout_date\">\n{{\'GUEST_MESSAGE_CENTER.CHECK_OUT\' | translate}}: {{vm.getInquiryDetails(message).checkout_date}}</div><div \nng-if=\"vm.getInquiryDetails(message).number_of_guests\">\n{{\'GUEST_MESSAGE_CENTER.GUESTS\' | translate}}: {{vm.getInquiryDetails(message).number_of_guests}}</div></div><div \nclass=\"gmc-message-media\" ng-if=\"vm.hasMessageMedia(message)\"><div class=\"gmc-media-loading\" \nng-if=\"!message._mediaExpanded && !message._mediaError\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"28\">\n</md-progress-circular><span class=\"gmc-media-loading-label\">Loading image...</span></div><button type=\"button\" \nclass=\"gmc-media-retry-btn\" ng-if=\"message._mediaError && !message._mediaExpanded\" \nng-click=\"vm.retryMessageMedia(message)\" aria-label=\"Retry image\"><md-icon md-font-icon=\"icon-file-image-box\" \nclass=\"gmc-media-icon\"></md-icon><span>Retry</span></button> <img class=\"gmc-media-inline\" \nng-if=\"message._mediaExpanded && message._mediaPreviewUrl\" ng-src=\"{{message._mediaPreviewUrl}}\" \nng-click=\"vm.openMessageMedia($event, message)\" alt=\"Message media\"></div><div class=\"gmc-attachments\" \nng-if=\"message.attachments && message.attachments.length\"><a class=\"gmc-attachment-link\" \nng-repeat=\"attachment in message.attachments track by $index\" href=\"{{attachment}}\" target=\"_blank\" \nrel=\"noopener noreferrer\">Attachment {{$index + 1}}</a></div><div class=\"gmc-message-footer\"><div \nclass=\"gmc-message-footer-start\"><div class=\"gmc-msg-translate\" ng-if=\"vm.canTranslateMessage(message)\"><button \ntype=\"button\" class=\"gmc-msg-translate-btn\" ng-class=\"{\'is-open\': message._translateOpen}\" \nng-click=\"vm.toggleMessageTranslatePanel($event, message)\" aria-label=\"Translate\" aria-haspopup=\"true\" \naria-expanded=\"{{!!message._translateOpen}}\"><md-icon class=\"gmc-translate-glyph\"><svg \nxmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"16\" height=\"16\" fill=\"currentColor\" aria-hidden=\"true\">\n<path \nd=\"M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z\"/>\n</svg></md-icon></button><div class=\"gmc-msg-translate-popup\" \nng-class=\"\'pos-\' + (message._translatePlacement || \'top\')\" ng-if=\"message._translateOpen\" \nng-click=\"$event.stopPropagation()\"><div class=\"gmc-msg-translate-popup-head\"><md-icon \nclass=\"gmc-translate-glyph gmc-msg-translate-popup-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" \nwidth=\"16\" height=\"16\" fill=\"currentColor\" aria-hidden=\"true\"><path \nd=\"M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z\"/>\n</svg></md-icon><div class=\"gmc-msg-translate-popup-title\" translate=\"GUEST_MESSAGE_CENTER.TRANSLATE\">Translate</div>\n</div><div class=\"gmc-translate-field gmc-translate-field--from\"><label \ntranslate=\"GUEST_MESSAGE_CENTER.CURRENT_LANGUAGE\">Current language</label><div class=\"gmc-translate-current\">\n{{vm.getDetectedLanguageLabel(message) || (\'GUEST_MESSAGE_CENTER.LANGUAGE_AUTO\' | translate)}}</div></div><div \nclass=\"gmc-translate-flow\" aria-hidden=\"true\"></div><div class=\"gmc-translate-field gmc-translate-field--to\"><label \ntranslate=\"GUEST_MESSAGE_CENTER.TRANSLATE_TO\">Translate to</label><div class=\"gmc-translate-loading\" \nng-if=\"vm.translateLanguagesLoading && !vm.translateLanguages.length\" translate=\"GUEST_MESSAGE_CENTER.LOADING\">\nLoading...</div><md-select ng-model=\"message._translateTarget\" ng-if=\"vm.translateLanguages.length\" \naria-label=\"Translate to language\" md-on-close=\"vm.clearTranslateLangSearch()\" \nmd-container-class=\"gmc-translate-select-container\"><md-select-header class=\"demo-select-header\" \nng-click=\"$event.stopPropagation()\"><input ng-model=\"vm.translateLangSearchText\" type=\"search\" \nplaceholder=\"{{\'GUEST_MESSAGE_CENTER.SEARCH_LANGUAGES\' | translate}}\" class=\"demo-header-searchbox md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-keyup=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header>\n<md-option \nng-repeat=\"lang in vm.translateLanguages | filter:vm.filterTranslateLanguages track by (lang.code + \'-\' + $index)\" \nng-value=\"lang.code\">{{lang.name}}</md-option></md-select></div><div class=\"gmc-msg-translate-popup-actions\"><button \ntype=\"button\" class=\"gmc-msg-translate-apply\" ng-click=\"vm.translateMessageBubble(message)\" \nng-disabled=\"message._translating || !vm.translateLanguages.length\"><span ng-if=\"!message._translating\" \ntranslate=\"GUEST_MESSAGE_CENTER.TRANSLATE\">Translate</span> <span ng-if=\"message._translating\" \ntranslate=\"GUEST_MESSAGE_CENTER.TRANSLATING\">Translating…</span></button></div></div></div><span class=\"gmc-lang-chip\" \nng-if=\"vm.getMessageLanguageTag(message)\">{{vm.getMessageLanguageTag(message)}} </span><span class=\"gmc-lang-chip\" \nng-if=\"vm.getSentTranslationLanguageLabel(message)\">\n{{\'GUEST_MESSAGE_CENTER.TRANSLATED_IN\' | translate}} {{vm.getSentTranslationLanguageLabel(message)}} </span><button \ntype=\"button\" class=\"gmc-see-original-btn\" \nng-if=\"message._showTranslation || (message.translation && !message._showOriginal)\" \nng-click=\"vm.toggleMessageOriginal(message)\" translate=\"GUEST_MESSAGE_CENTER.SEE_ORIGINAL\">See original</button> \n<button type=\"button\" class=\"gmc-see-original-btn\" ng-if=\"message._showOriginal && message.translation\" \nng-click=\"vm.toggleMessageOriginal(message)\" translate=\"GUEST_MESSAGE_CENTER.SEE_TRANSLATED\">See translated</button> \n<span class=\"gmc-message-channel gmc-provider-chip is-ai\" ng-if=\"message.sender === \'ai\'\" \ntranslate=\"GUEST_MESSAGE_CENTER.AI_SENDER_LABEL\">AI</span> <span class=\"gmc-message-channel gmc-provider-chip\" \nng-if=\"vm.showMessageChannel(message)\" ng-class=\"vm.getMessageChannelClass(message)\">\n{{vm.getMessageChannelLabel(message)}}</span></div><span class=\"gmc-message-time\">\n{{vm.formatDate(message.inserted_at, message.timezone)}}</span></div></div></div></div><div class=\"gmc-composer\" \nng-if=\"vm.canSendMessage && !vm.isOptedOut() && !vm.isAiModeOn()\"><div class=\"gmc-composer-toolbar\"><div \nclass=\"gmc-channel-picker\" ng-if=\"vm.channelOptions.length\"><button type=\"button\" class=\"gmc-channel-pill\" \nng-repeat=\"option in vm.channelOptions track by option.id\" \nng-class=\"{\'is-active\': vm.composerChannel === option.id, \'is-disabled\': !option.enabled}\" \nng-click=\"vm.setComposerChannel(option.id)\" ng-disabled=\"!option.enabled\">{{option.label}} <span \nclass=\"gmc-channel-start-hint\" ng-if=\"vm.needsDirectChannelStart(option.id)\">+</span></button></div><div \nclass=\"gmc-composer-toolbar-actions\" ng-if=\"vm.canSendToSelected()\"><div \nclass=\"gmc-quick-reply gmc-composer-translate\" ng-class=\"{\'is-open\': vm.composerTranslateOpen}\"><button type=\"button\" \nclass=\"gmc-quick-reply-toggle\" ng-class=\"{\'is-open\': vm.composerTranslateOpen}\" \nng-click=\"vm.toggleComposerTranslate($event)\" ng-disabled=\"vm.sendingMessage\" aria-haspopup=\"true\" \naria-expanded=\"{{vm.composerTranslateOpen}}\"><md-icon class=\"gmc-translate-glyph\" style=\"line-height:1\"><svg \nxmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"currentColor\" aria-hidden=\"true\">\n<path \nd=\"M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z\"/>\n</svg></md-icon><span translate=\"GUEST_MESSAGE_CENTER.TRANSLATE\">Translate</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"gmc-quick-reply-caret\"></md-icon></button><div \nclass=\"gmc-quick-reply-menu gmc-composer-translate-menu\" ng-if=\"vm.composerTranslateOpen\" \nng-click=\"$event.stopPropagation()\"><div class=\"gmc-msg-translate-popup-title\" \ntranslate=\"GUEST_MESSAGE_CENTER.TRANSLATE_TO\">Translate to</div><div class=\"gmc-translate-field\"><div \nclass=\"gmc-translate-loading\" ng-if=\"vm.translateLanguagesLoading && !vm.translateLanguages.length\" \ntranslate=\"GUEST_MESSAGE_CENTER.LOADING\">Loading...</div><md-select ng-model=\"vm.composerTranslateLang\" \nng-if=\"vm.translateLanguages.length\" aria-label=\"Composer translate language\" \nmd-on-close=\"vm.clearTranslateLangSearch()\" md-container-class=\"gmc-translate-select-container\"><md-select-header \nclass=\"demo-select-header\" ng-click=\"$event.stopPropagation()\"><input ng-model=\"vm.translateLangSearchText\" \ntype=\"search\" placeholder=\"{{\'GUEST_MESSAGE_CENTER.SEARCH_LANGUAGES\' | translate}}\" \nclass=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation()\" ng-keyup=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"lang in vm.translateLanguages | filter:vm.filterTranslateLanguages track by (lang.code + \'-\' + $index)\" \nng-value=\"lang.code\">{{lang.name}}</md-option></md-select></div><div class=\"gmc-composer-translate-hint\" \nng-if=\"!vm.hasComposerBodyForTranslate()\">Type a message first to translate it.</div><div \nclass=\"gmc-msg-translate-popup-actions\"><button type=\"button\" class=\"gmc-msg-translate-apply\" \nng-click=\"vm.translateComposerDraft()\" \nng-disabled=\"vm.composerTranslating || !vm.hasComposerBodyForTranslate() || !vm.translateLanguages.length\"><span \nng-if=\"!vm.composerTranslating\" translate=\"GUEST_MESSAGE_CENTER.TRANSLATE\">Translate</span> <span \nng-if=\"vm.composerTranslating\" translate=\"GUEST_MESSAGE_CENTER.TRANSLATING\">Translating…</span></button></div></div>\n</div><div class=\"gmc-quick-reply gmc-promote-reply\"><button type=\"button\" class=\"gmc-quick-reply-toggle\" \nng-class=\"{\'is-open\': vm.promoteReplyOpen}\" ng-click=\"vm.togglePromoteReplyPicker($event)\" aria-haspopup=\"true\" \naria-expanded=\"{{vm.promoteReplyOpen}}\"><md-icon class=\"gmc-broadcast-quick-reply-icon\" style=\"line-height:1\"><svg \nxmlns=\"http://www.w3.org/2000/svg\" height=\"18px\" viewBox=\"0 0 24 24\" width=\"18px\" fill=\"currentColor\"><path \nd=\"M18 11v2h4v-2h-4zm-2 6.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61zM20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.99-.74 2.24-1.68 3.2-2.4zM4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9H4zm7.5 5.73C10.35 14.27 9.57 13.21 9.57 12s.78-2.27 1.93-2.73v5.46zM8.18 12.63L8 12.63V12v-.63l.18-.11 3.32-1.99v5.46l-3.32-1.99z\"/>\n</svg></md-icon><span translate=\"GUEST_MESSAGE_CENTER.PROMOTE_REPLY\">Promote Reply</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"gmc-quick-reply-caret\"></md-icon></button><div class=\"gmc-quick-reply-menu\" \nng-if=\"vm.promoteReplyOpen\" ng-click=\"$event.stopPropagation()\"><div class=\"gmc-quick-reply-search\"><input type=\"text\" \nng-model=\"vm.promoteReplySearch\" ng-change=\"vm.filterPromoteReplies()\" \nplaceholder=\"{{\'GUEST_MESSAGE_CENTER.PROMOTE_REPLY_SEARCH\' | translate}}\" aria-label=\"Search promote replies\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></div><div class=\"gmc-quick-reply-list\"><div class=\"gmc-quick-reply-empty\" \nng-if=\"vm.promoteReplyLoading\">{{\'GUEST_MESSAGE_CENTER.LOADING\' | translate}}</div><div class=\"gmc-quick-reply-empty\" \nng-if=\"!vm.promoteReplyLoading && !vm.promoteReplyFiltered.length\">\n{{\'GUEST_MESSAGE_CENTER.PROMOTE_REPLY_EMPTY\' | translate}}</div><div class=\"gmc-quick-reply-group\" \nng-repeat=\"category in vm.promoteReplyFiltered track by category.id\"><div class=\"gmc-quick-reply-category\">\n{{category.name}}</div><button type=\"button\" class=\"gmc-quick-reply-item\" \nng-repeat=\"template in category.templates track by template.id\" ng-click=\"vm.applyPromoteReply(template)\">\n{{template.name}}</button></div></div></div></div><div class=\"gmc-quick-reply\"><button type=\"button\" \nclass=\"gmc-quick-reply-toggle\" ng-class=\"{\'is-open\': vm.quickReplyOpen}\" ng-click=\"vm.toggleQuickReplyPicker($event)\" \naria-haspopup=\"true\" aria-expanded=\"{{vm.quickReplyOpen}}\"><md-icon md-font-icon=\"icon-timer\" \nclass=\"gmc-quick-reply-icon\"></md-icon><span translate=\"GUEST_MESSAGE_CENTER.QUICK_REPLY\">Quick Reply</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"gmc-quick-reply-caret\"></md-icon></button><div class=\"gmc-quick-reply-menu\" \nng-if=\"vm.quickReplyOpen\" ng-click=\"$event.stopPropagation()\"><div class=\"gmc-quick-reply-search\"><input type=\"text\" \nng-model=\"vm.quickReplySearch\" ng-change=\"vm.filterQuickReplies()\" \nplaceholder=\"{{\'GUEST_MESSAGE_CENTER.QUICK_REPLY_SEARCH\' | translate}}\" aria-label=\"Search quick replies\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></div><div class=\"gmc-quick-reply-list\"><div class=\"gmc-quick-reply-empty\" \nng-if=\"vm.quickReplyLoading\">{{\'GUEST_MESSAGE_CENTER.LOADING\' | translate}}</div><div class=\"gmc-quick-reply-empty\" \nng-if=\"!vm.quickReplyLoading && !vm.quickReplyFiltered.length\">{{\'GUEST_MESSAGE_CENTER.QUICK_REPLY_EMPTY\' | translate}}\n</div><div class=\"gmc-quick-reply-group\" ng-repeat=\"category in vm.quickReplyFiltered track by category.id\"><div \nclass=\"gmc-quick-reply-category\">{{category.name}}</div><button type=\"button\" class=\"gmc-quick-reply-item\" \nng-repeat=\"template in category.templates track by template.id\" ng-click=\"vm.applyQuickReply(template)\">\n{{template.name}}</button></div></div></div></div></div></div><div class=\"gmc-send-to\" ng-if=\"vm.needsPhonePicker()\">\n<div class=\"gmc-send-to-label\" translate=\"GUEST_MESSAGE_CENTER.SEND_TO\">Send to</div><div class=\"gmc-send-to-options\">\n<button type=\"button\" class=\"gmc-send-to-option\" ng-if=\"vm.phoneOptions.customer\" \nng-class=\"{\'is-active\': vm.sendToSource === \'customer\'}\" ng-click=\"vm.setSendToSource(\'customer\')\"><span \nclass=\"gmc-send-to-option-label\" translate=\"GUEST_MESSAGE_CENTER.PHONE_CUSTOMER\">Customer</span> <span \nclass=\"gmc-send-to-option-phone\">{{vm.formatPhoneNumber(vm.phoneOptions.customer)}}</span></button> <button \ntype=\"button\" class=\"gmc-send-to-option\" ng-if=\"vm.phoneOptions.traveler\" \nng-class=\"{\'is-active\': vm.sendToSource === \'traveler\'}\" ng-click=\"vm.setSendToSource(\'traveler\')\"><span \nclass=\"gmc-send-to-option-label\" translate=\"GUEST_MESSAGE_CENTER.PHONE_TRAVELER\">Traveler</span> <span \nclass=\"gmc-send-to-option-phone\">{{vm.formatPhoneNumber(vm.phoneOptions.traveler)}}</span></button> <button \ntype=\"button\" class=\"gmc-send-to-option\" ng-class=\"{\'is-active\': vm.sendToSource === \'custom\'}\" \nng-click=\"vm.setSendToSource(\'custom\')\"><span class=\"gmc-send-to-option-label\" \ntranslate=\"GUEST_MESSAGE_CENTER.PHONE_CUSTOM\">Custom number</span></button></div><div \nclass=\"gmc-phone-iti-field gmc-send-to-custom-field\" ng-if=\"vm.sendToSource === \'custom\'\"><input type=\"tel\" \nname=\"gmc_send_to_custom\" class=\"gmc-send-to-custom-input intel-number-input\" ng-model=\"vm.sendToCustomPhone\" \nintl-tel-input autocomplete=\"off\" aria-label=\"Custom phone number\" \nng-change=\"vm.updatePhoneWithCountryCode(\'gmc_send_to_custom\', $event)\"></div><div class=\"gmc-phone-conflict\" \nng-if=\"vm.phoneConflictMessage\">{{vm.phoneConflictMessage}}</div></div><div class=\"gmc-composer-attach-preview\" \nng-if=\"vm.pendingMedia\" ng-click=\"vm.openPendingMedia($event)\" role=\"button\" title=\"Preview image\"><div \nclass=\"gmc-composer-attach-thumb\"><img ng-if=\"vm.pendingMedia.previewUrl\" ng-src=\"{{vm.pendingMedia.previewUrl}}\" \nalt=\"Attached image\"><md-progress-circular ng-if=\"vm.pendingMedia.uploading\" md-mode=\"indeterminate\" md-diameter=\"22\">\n</md-progress-circular><button type=\"button\" class=\"gmc-composer-attach-remove\" \nng-click=\"vm.clearPendingMedia(); $event.stopPropagation()\" ng-disabled=\"vm.sendingMessage\" \naria-label=\"Remove attached image\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></div><div \nclass=\"gmc-composer-attach-meta\"><div class=\"gmc-composer-attach-name\">{{vm.pendingMedia.name}}</div><div \nclass=\"gmc-composer-attach-status\" ng-if=\"vm.pendingMedia.uploading\">Uploading...</div><div \nclass=\"gmc-composer-attach-status is-error\" ng-if=\"vm.pendingMedia.error\">{{vm.pendingMedia.error}}</div></div></div>\n<div class=\"gmc-composer-translation-preview\" ng-if=\"vm.replyTranslation && vm.replyTranslation.text\"><md-icon \nclass=\"gmc-translate-glyph\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"16\" height=\"16\" \nfill=\"currentColor\" aria-hidden=\"true\"><path \nd=\"M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z\"/>\n</svg></md-icon><span class=\"gmc-composer-translation-preview-label\">\n{{\'GUEST_MESSAGE_CENTER.WILL_SEND_AS\' | translate}}: </span><span class=\"gmc-composer-translation-preview-text\">\n{{vm.replyTranslation.text}}</span> <button type=\"button\" class=\"gmc-translate-clear-btn\" \nng-click=\"vm.clearReplyTranslation()\" translate=\"GUEST_MESSAGE_CENTER.CLEAR_TRANSLATION\">Clear</button></div><div \nclass=\"gmc-composer-row\"><button type=\"button\" class=\"gmc-attach-btn\" ng-if=\"vm.canAttachImage()\" \nng-click=\"vm.openImagePicker()\" ng-disabled=\"!vm.canSendToSelected() || vm.sendingMessage || vm.uploadingMedia\" \naria-label=\"Attach image\"><md-icon md-font-icon=\"icon-file-image-box\"></md-icon></button> <input type=\"file\" \nid=\"gmc-attach-image-input\" class=\"gmc-attach-input\" accept=\"image/jpeg,image/png,image/gif,image/webp\" \nng-disabled=\"!vm.canSendToSelected() || vm.sendingMessage || vm.uploadingMedia\"><textarea id=\"gmc-reply-textarea\" \nclass=\"gmc-reply-textarea\" ng-model=\"vm.replyText\" rows=\"1\" \nplaceholder=\"{{\'GUEST_MESSAGE_CENTER.TYPE_MESSAGE\' | translate}}\" ng-focus=\"vm.onReplyFocus()\" \nng-keydown=\"vm.onReplyKeydown($event)\" ng-keyup=\"vm.resizeReplyTextarea()\" ng-change=\"vm.onReplyTextChange()\" \nng-paste=\"vm.resizeReplyTextarea()\" ng-cut=\"vm.resizeReplyTextarea()\" ng-disabled=\"!vm.canSendToSelected()\"></textarea>\n<md-button class=\"md-raised md-primary gmc-send-btn\" ng-class=\"{\'is-sending\': vm.sendingMessage}\" \nng-click=\"vm.sendReply()\" \nng-disabled=\"vm.sendingMessage || vm.uploadingMedia || !vm.hasSendableContent() || !vm.canSendToSelected()\"><span \nclass=\"gmc-send-btn-content\" ng-if=\"!vm.sendingMessage\">{{\'GUEST_MESSAGE_CENTER.SEND\' | translate}} </span><span \nclass=\"gmc-send-btn-content gmc-send-btn-loading\" ng-if=\"vm.sendingMessage\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular></span></md-button></div></div><div \nclass=\"gmc-ai-footer\" ng-if=\"vm.selectedThread.confirmation_number && !vm.isOptedOut() && vm.isAiModeOn()\" \nng-class=\"{\'is-on\': true, \'is-highlight\': vm.highlightAiToggle}\"><div class=\"gmc-ai-footer-main\"><span \nclass=\"gmc-ai-footer-badge\" aria-hidden=\"true\">AI</span><div class=\"gmc-ai-footer-copy\"><div \nclass=\"gmc-ai-footer-title\" translate=\"GUEST_MESSAGE_CENTER.AI_MODE\">AI Mode</div><div class=\"gmc-ai-footer-desc\" \ntranslate=\"GUEST_MESSAGE_CENTER.AI_MODE_FOOTER_ON\">AI is replying for this guest. Turn off to send as staff.</div>\n</div></div><button type=\"button\" class=\"gmc-ai-footer-switch is-on\" ng-click=\"vm.toggleAiMode()\" \nng-disabled=\"vm.updatingAiMode\" aria-pressed=\"true\" aria-label=\"Turn AI Mode off\"><span \nclass=\"gmc-ai-footer-switch-track\"><span class=\"gmc-ai-footer-switch-knob\"></span> </span><span \nclass=\"gmc-ai-footer-switch-label\" translate=\"GUEST_MESSAGE_CENTER.AI_MODE_ON\">On</span></button></div><div \nclass=\"gmc-composer-disabled\" \nng-if=\"vm.canSendMessage && !vm.isAiModeOn() && (!vm.canSendToSelected() || vm.isOptedOut()) && vm.getComposerBlockedMessage()\">\n{{vm.getComposerBlockedMessage()}}</div></div></div></div></div>");
$templateCache.put("app/main/apps/guest-message-center/staff-messages/staff-group-message-panel.html","<div id=\"message-center-broadcast\" class=\"gmc-group-msg-panel gmc-staff-broadcast-panel\" layout=\"row\" flex><div \nclass=\"gmc-broadcast-reservations gmc-staff-broadcast-list\" layout=\"column\"><div class=\"gmc-tabs\"><button \ntype=\"button\" class=\"gmc-tab\" ng-click=\"vm.goToInboxTab()\">Inbox <span class=\"gmc-filter-chip-badge\" \nng-if=\"vm.getGuestUnreadTotal() > 0\" style=\"margin-left: 6px; position: relative; top: -1px\">\n{{vm.getGuestUnreadTotal()}}</span></button> <button type=\"button\" class=\"gmc-tab\" ng-if=\"vm.showGroupMessageTab()\" \nng-click=\"vm.goToGuestGroupMessageTab()\" translate=\"GUEST_MESSAGE_CENTER.TAB_GROUP_MSG\">Group message</button> <button \ntype=\"button\" class=\"gmc-tab is-active\">Staff <span class=\"gmc-filter-chip-badge\" ng-if=\"vm.getStaffUnreadTotal() > 0\" \nstyle=\"margin-left: 6px; position: relative; top: -1px\">{{vm.getStaffUnreadTotal()}}</span></button></div><div \nclass=\"gmc-staff-modes\" ng-if=\"vm.showGroupMessageTab()\"><button type=\"button\" class=\"gmc-staff-mode\" \nng-click=\"vm.setTab(\'all\')\" translate=\"GUEST_MESSAGE_CENTER.TAB_STAFF_INBOX\">Inbox</button> <button type=\"button\" \nclass=\"gmc-staff-mode is-active\" translate=\"GUEST_MESSAGE_CENTER.TAB_STAFF_BROADCAST\">Broadcast</button></div><div \nclass=\"gmc-broadcast-reservations-header gmc-staff-broadcast-header\"><div class=\"gmc-broadcast-reservations-title\">\nStaff Members</div><div class=\"gmc-broadcast-reservations-count\">{{bvm.getRecipientLabel()}}</div><div \nclass=\"gmc-staff-broadcast-search\"><md-icon md-font-icon=\"icon-magnify\" class=\"gmc-staff-broadcast-search-icon\">\n</md-icon><input type=\"search\" class=\"gmc-staff-broadcast-search-input\" ng-model=\"bvm.searchText\" \nng-model-options=\"{ debounce: 400 }\" ng-change=\"bvm.searchStaff()\" placeholder=\"Search staff by name, email or phone\">\n</div></div><div class=\"gmc-broadcast-reservations-scroll\" ms-scroll><div class=\"gmc-broadcast-guest-loading\" \nng-if=\"bvm.loadingStaffs && !bvm.staffs.length\"><md-progress-circular md-diameter=\"32\" md-mode=\"indeterminate\">\n</md-progress-circular><span translate=\"GUEST_MESSAGE_CENTER.LOADING\">Loading...</span></div><div \nclass=\"gmc-broadcast-guest-empty\" ng-if=\"!bvm.loadingStaffs && !bvm.staffs.length\"><md-icon \nmd-font-icon=\"icon-account-off\"></md-icon><span>No staff members found.</span></div><div \nclass=\"gmc-broadcast-guest-list\" ng-if=\"bvm.staffs.length\"><div class=\"gmc-broadcast-guest-group\" \nng-if=\"bvm.eligibleStaffs.length\"><div class=\"gmc-broadcast-guest-group-title\"><span \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_ELIGIBLE\">Eligible</span> <span class=\"gmc-broadcast-guest-group-count\">\n{{bvm.eligibleStaffs.length}}</span> <span class=\"gmc-broadcast-guest-group-actions\" flex></span> <button \ntype=\"button\" class=\"gmc-broadcast-select-link\" ng-if=\"!bvm.areAllEligibleSelected()\" \nng-click=\"bvm.selectAllEligible()\" translate=\"GUEST_MESSAGE_CENTER.BROADCAST_SELECT_ALL\">Select all</button> <button \ntype=\"button\" class=\"gmc-broadcast-select-link\" ng-if=\"bvm.getSelectedCount()\" ng-click=\"bvm.clearStaffSelection()\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_CLEAR\">Clear</button></div><div \nclass=\"gmc-broadcast-guest-row is-selectable\" \nng-repeat=\"staff in bvm.eligibleStaffs track by (staff.user_id || staff.confirmation_number)\" \nng-class=\"{\'is-checked\': bvm.isStaffSelected(staff)}\" ng-click=\"bvm.toggleStaff(staff, $event)\"><md-checkbox \nclass=\"gmc-broadcast-guest-check\" ng-model=\"bvm.selectedIds[staff.user_id || staff.confirmation_number]\" \nng-click=\"$event.stopPropagation()\" aria-label=\"Select {{staff.staff_name}}\"></md-checkbox><div \nclass=\"gmc-broadcast-guest-avatar\">{{bvm.getStaffInitial(staff)}}</div><div class=\"gmc-broadcast-guest-meta\" flex><div \nclass=\"gmc-broadcast-guest-name\">{{staff.staff_name}}</div><div class=\"gmc-broadcast-guest-sub\"><span \nng-if=\"staff.email\">{{staff.email}}</span> <span ng-if=\"staff.hotel_title\">· {{staff.hotel_title}}</span></div></div>\n<div class=\"gmc-broadcast-guest-statuses\"><span class=\"gmc-broadcast-status-chip\" \nng-repeat=\"status in staff.statuses track by status.key\" ng-class=\"\'is-\' + status.key\">{{status.label}}</span></div>\n</div></div><div class=\"gmc-broadcast-guest-group is-ineligible\" ng-if=\"bvm.ineligibleStaffs.length\"><div \nclass=\"gmc-broadcast-guest-group-title\"><span translate=\"GUEST_MESSAGE_CENTER.BROADCAST_NOT_ELIGIBLE\">Not eligible\n</span> <span class=\"gmc-broadcast-guest-group-count\">{{bvm.ineligibleStaffs.length}}</span></div><div \nclass=\"gmc-broadcast-guest-row is-blocked\" \nng-repeat=\"staff in bvm.ineligibleStaffs track by (staff.user_id || staff.confirmation_number)\"><md-checkbox \nclass=\"gmc-broadcast-guest-check\" ng-disabled=\"true\" ng-checked=\"false\" aria-label=\"{{staff.staff_name}} not eligible\">\n</md-checkbox><div class=\"gmc-broadcast-guest-avatar\">{{bvm.getStaffInitial(staff)}}</div><div \nclass=\"gmc-broadcast-guest-meta\" flex><div class=\"gmc-broadcast-guest-name\">{{staff.staff_name}}</div><div \nclass=\"gmc-broadcast-guest-sub\"><span ng-if=\"staff.email\">{{staff.email}}</span> <span ng-if=\"staff.hotel_title\">\n· {{staff.hotel_title}}</span></div></div><div class=\"gmc-broadcast-guest-statuses\"><span \nclass=\"gmc-broadcast-status-chip\" ng-repeat=\"status in staff.statuses track by status.key\" \nng-class=\"\'is-\' + status.key\">{{status.label}}</span></div></div></div></div></div></div><div \nclass=\"gmc-broadcast-compose\" layout=\"column\" flex><div class=\"gmc-broadcast-form\" ms-scroll><div \nclass=\"gmc-broadcast-alert gmc-broadcast-alert-warn\" \nng-if=\"!bvm.canSendDirect || (!bvm.smsEnabled && !bvm.whatsappEnabled)\"><span ng-if=\"!bvm.canSendDirect\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_NO_DIRECT\">Direct messaging permission is required to send group messages. \n</span><span ng-if=\"bvm.canSendDirect && !bvm.smsEnabled && !bvm.whatsappEnabled\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_CHANNELS_DISABLED\">SMS and WhatsApp messaging are not enabled for this hotel.\n</span></div><div class=\"gmc-broadcast-section\"><div class=\"gmc-broadcast-section-title\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_CHANNEL\">Channel</div><div class=\"gmc-broadcast-channel-picker\"><button \ntype=\"button\" class=\"gmc-broadcast-channel-pill\" ng-if=\"bvm.smsEnabled && bvm.whatsappEnabled\" \nng-class=\"{\'is-active\': bvm.channel === \'default\'}\" ng-click=\"bvm.setChannel(\'default\')\">Default</button> <button \ntype=\"button\" class=\"gmc-broadcast-channel-pill\" ng-if=\"bvm.smsEnabled\" \nng-class=\"{\'is-active\': bvm.channel === \'sms\'}\" ng-click=\"bvm.setChannel(\'sms\')\">SMS</button> <button type=\"button\" \nclass=\"gmc-broadcast-channel-pill\" ng-if=\"bvm.whatsappEnabled\" ng-class=\"{\'is-active\': bvm.channel === \'whatsapp\'}\" \nng-click=\"bvm.setChannel(\'whatsapp\')\">WhatsApp</button></div><p class=\"gmc-broadcast-help\" \nng-if=\"bvm.channel === \'default\'\">\nSends each staff on their most recently active open SMS or WhatsApp chat. If WhatsApp is outside the 24-hour window, falls back to SMS when available.\n</p><p class=\"gmc-broadcast-help\" ng-if=\"bvm.channel === \'whatsapp\'\">\nStaff members outside the WhatsApp 24-hour messaging window will be skipped.</p></div><div \nclass=\"gmc-broadcast-section gmc-broadcast-compose-section\"><div class=\"gmc-broadcast-field\"><label \nclass=\"gmc-broadcast-label\" translate=\"GUEST_MESSAGE_CENTER.BROADCAST_MESSAGE_TO_GROUP\">Message to be sent to group\n</label><div class=\"gmc-broadcast-textarea-wrap\"><textarea class=\"gmc-broadcast-textarea\" ng-model=\"bvm.message\" \nrows=\"8\" placeholder=\"{{ \'GUEST_MESSAGE_CENTER.BROADCAST_MESSAGE_PLACEHOLDER\' | translate }}\"></textarea></div></div>\n</div><div class=\"gmc-broadcast-actions\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-raised md-primary gmc-broadcast-send-btn\" ng-click=\"bvm.sendBroadcast()\" ng-disabled=\"!bvm.canSubmit()\">\n<md-icon md-font-icon=\"icon-send\" class=\"gmc-broadcast-send-icon\"></md-icon><span ng-if=\"!bvm.sending\" \ntranslate=\"GUEST_MESSAGE_CENTER.STAFF_BROADCAST_SEND\">Send Broadcast</span> <span ng-if=\"bvm.sending\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_SENDING\">Sending...</span></md-button></div><div \nclass=\"gmc-broadcast-results\" ng-if=\"bvm.lastResult\"><div class=\"gmc-broadcast-section-title\" \ntranslate=\"GUEST_MESSAGE_CENTER.STAFF_BROADCAST_RESULTS\">Last broadcast results</div><div \nclass=\"gmc-broadcast-results-summary\" layout=\"row\" layout-wrap><div class=\"gmc-broadcast-stat\"><span class=\"label\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_REQUESTED\">Requested</span> <span class=\"value\">\n{{bvm.lastResult.requested || 0}}</span></div><div class=\"gmc-broadcast-stat is-sent\"><span class=\"label\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_SENT\">Sent</span> <span class=\"value\">{{bvm.lastResult.sent || 0}}</span>\n</div><div class=\"gmc-broadcast-stat is-skipped\"><span class=\"label\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_SKIPPED\">Skipped</span> <span class=\"value\">{{bvm.lastResult.skipped || 0}}\n</span></div><div class=\"gmc-broadcast-stat is-failed\"><span class=\"label\" \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_FAILED\">Failed</span> <span class=\"value\">{{bvm.lastResult.failed || 0}}\n</span></div></div><div class=\"gmc-broadcast-results-table-wrap\" \nng-if=\"bvm.lastResult.results && bvm.lastResult.results.length\"><table class=\"gmc-broadcast-results-table\"><thead><tr>\n<th translate=\"GUEST_MESSAGE_CENTER.STAFF_BROADCAST_STAFF\">Staff</th><th \ntranslate=\"GUEST_MESSAGE_CENTER.BROADCAST_CHANNEL\">Channel</th><th translate=\"GUEST_MESSAGE_CENTER.BROADCAST_STATUS\">\nStatus</th><th translate=\"GUEST_MESSAGE_CENTER.BROADCAST_DETAIL\">Detail</th></tr></thead><tbody><tr \nng-repeat=\"row in bvm.lastResult.results track by $index\" ng-class=\"\'status-\' + row.status\"><td>\n{{bvm.getResultStaffLabel(row)}}</td><td>{{row.channel || bvm.lastResult.channel || \'—\'}}</td><td>{{row.status || \'—\'}}\n</td><td>{{bvm.getReasonLabel(row.reason) || \'—\'}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/apps/guest-message-center/staff-messages/staff-inbox.html","<div id=\"ota-message-center\" class=\"page-layout simple tabbed full-height\" layout=\"column\"><div \nclass=\"header md-accent-bg relative-block\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-message-text\"></md-icon></md-button><div class=\"h2\" translate=\"GUEST_MESSAGE_CENTER.TITLE\">\nMessage Center</div></div><md-button class=\"md-raised md-cornered gmc-new-conversation-btn\" \nng-if=\"vm.channelFlagsReady && vm.showDirectFeatures() && vm.canSendDirect\" \nng-click=\"vm.openNewStaffConversationDialog($event)\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"gmc-new-conversation-icon\"></md-icon><span>Add Staff</span></md-button></div><div class=\"gmc-main\" layout=\"row\" \nflex><div class=\"gmc-card\" layout=\"row\" ng-class=\"{\'gmc-has-selection\': vm.selectedThread}\"><div \nclass=\"gmc-thread-list\" layout=\"column\"><div class=\"gmc-tabs\" ng-if=\"vm.showTabs()\"><button type=\"button\" \nclass=\"gmc-tab\" ng-click=\"vm.goToInboxTab()\">Inbox <span class=\"gmc-filter-chip-badge\" \nng-if=\"vm.getGuestUnreadTotal() > 0\" style=\"margin-left: 6px; position: relative; top: -1px\">\n{{vm.getGuestUnreadTotal()}}</span></button> <button type=\"button\" class=\"gmc-tab\" ng-if=\"vm.showGroupMessageTab()\" \nng-click=\"vm.goToGuestGroupMessageTab()\" translate=\"GUEST_MESSAGE_CENTER.TAB_GROUP_MSG\">Group message</button> <button \ntype=\"button\" class=\"gmc-tab is-active\">Staff <span class=\"gmc-filter-chip-badge\" ng-if=\"vm.getStaffUnreadTotal() > 0\" \nstyle=\"margin-left: 6px; position: relative; top: -1px\">{{vm.getStaffUnreadTotal()}}</span></button></div><div \nclass=\"gmc-thread-toolbar\" ng-if=\"vm.channelFlagsReady && vm.hasAnyChannelEnabled()\"><div class=\"gmc-thread-search\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"gmc-search-icon s20\"></md-icon>\n<input type=\"text\" ng-model=\"vm.searchQuery\" ng-change=\"vm.onSearchChange()\" placeholder=\"Search\" flex \naria-label=\"Search\"> <button type=\"button\" class=\"gmc-search-clear\" ng-if=\"vm.searchQuery\" ng-click=\"vm.clearSearch()\" \naria-label=\"Clear search\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></button></div></div>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingThreads\"></md-progress-linear><div \nclass=\"gmc-thread-errors\" ng-if=\"vm.threadErrors.length\"><div class=\"gmc-error-item\" \nng-repeat=\"error in vm.threadErrors\">{{error.message || error}}</div></div><div id=\"gmc-thread-scroll\" \nclass=\"gmc-thread-scroll\" ng-class=\"{\'is-loading\': vm.loadingThreads && !vm.threads.length}\"><div \nclass=\"gmc-thread-loading\" ng-if=\"vm.loadingThreads && !vm.threads.length\"><md-progress-circular md-diameter=\"36\" \nclass=\"gmc-loading-spinner\"></md-progress-circular><p>{{\'GUEST_MESSAGE_CENTER.LOADING\' | translate}}</p></div><div \nclass=\"gmc-empty-state\" ng-if=\"!vm.loadingThreads && vm.channelFlagsReady && !vm.hasAnyChannelEnabled()\"><div \nclass=\"gmc-empty-state-icon-wrap\"><md-icon md-font-icon=\"icon-cog\" class=\"gmc-empty-state-icon\"></md-icon></div><p \nclass=\"gmc-empty-state-title\">{{\'GUEST_MESSAGE_CENTER.CHANNELS_DISABLED\' | translate}}</p><p \nclass=\"gmc-empty-state-desc\">{{\'GUEST_MESSAGE_CENTER.CHANNELS_DISABLED_DESC\' | translate}}</p></div><div \nclass=\"gmc-empty-state\" \nng-if=\"!vm.loadingThreads && vm.channelFlagsReady && vm.hasAnyChannelEnabled() && !vm.threads.length\"><div \nclass=\"gmc-empty-state-icon-wrap\"><md-icon md-font-icon=\"icon-forum\" class=\"gmc-empty-state-icon\"></md-icon></div><p \nclass=\"gmc-empty-state-title\">{{\'GUEST_MESSAGE_CENTER.NO_THREADS\' | translate}}</p></div><div class=\"gmc-thread-item\" \nng-repeat=\"thread in vm.threads track by vm.getThreadKey(thread)\" \nng-class=\"{\'is-active\': vm.isThreadSelected(thread), \'is-closed\': thread.is_closed, \'has-unread\': vm.hasUnread(thread)}\" \nng-click=\"vm.selectThread(thread)\"><div class=\"gmc-thread-avatar\" ng-style=\"vm.getAvatarStyle(thread)\">\n{{vm.getGuestInitial(thread)}}</div><div class=\"gmc-thread-content\"><div class=\"gmc-thread-head\"><span \nclass=\"gmc-guest-name\">{{vm.getThreadTitle(thread)}}</span><div class=\"gmc-thread-head-end\"><span \nclass=\"gmc-thread-date\" ng-if=\"vm.getThreadActivity(thread)\">\n{{vm.formatShortDate(vm.getThreadActivity(thread), thread.timezone)}} </span><span class=\"gmc-unread-badge\" \nng-if=\"vm.hasUnread(thread)\">{{vm.getUnreadLabel(thread)}}</span></div></div><div class=\"gmc-thread-subtitle\" \nng-if=\"vm.getThreadSubtitle(thread)\">{{vm.getThreadSubtitle(thread)}}</div><div class=\"gmc-thread-hotel\" \nng-if=\"vm.isParent && thread.hotel_title\">{{thread.hotel_title}}</div><div class=\"gmc-thread-bottom\"><div \nclass=\"gmc-thread-preview\" ng-if=\"thread.last_message || vm.isLastMessageMedia(thread)\"><md-icon \nmd-font-icon=\"{{vm.getLastMessageDirectionIcon(thread)}}\" class=\"gmc-thread-preview-icon\" \nng-if=\"vm.getLastMessageDirectionIcon(thread)\"></md-icon><span class=\"gmc-thread-preview-media-icon\" \nng-if=\"vm.isLastMessageMedia(thread)\" aria-hidden=\"true\"><svg viewBox=\"0 0 16 16\" width=\"15\" height=\"15\" \nfocusable=\"false\"><path fill=\"currentColor\" \nd=\"M2.5 2.75A1.75 1.75 0 0 1 4.25 1h7.5A1.75 1.75 0 0 1 13.5 2.75v10.5A1.75 1.75 0 0 1 11.75 15h-7.5A1.75 1.75 0 0 1 2.5 13.25V2.75zm1.25-.25a.25.25 0 0 0-.25.25v7.19l2.22-2.22a.75.75 0 0 1 1.06 0L9.5 10.44l1.22-1.22a.75.75 0 0 1 1.06 0l.72.72V2.75a.25.25 0 0 0-.25-.25h-7.5zM12.5 11.56l-.19-.19-1.75 1.75a.75.75 0 0 1-1.06 0L6.78 10.4 3.75 13.44v-.19c0 .14.11.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.69zM10.25 6a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5z\"/>\n</svg> </span><span class=\"gmc-thread-preview-text\">{{vm.getThreadPreviewText(thread)}}</span></div></div><div \nclass=\"gmc-thread-meta\"><span class=\"gmc-provider-chips\"><span class=\"gmc-provider-chip\" \nng-if=\"vm.getThreadSourceChip(thread)\" ng-class=\"vm.getThreadSourceChip(thread).cls\">\n{{vm.getThreadSourceChip(thread).label}} </span></span><span class=\"gmc-closed-chip\" ng-if=\"thread.is_closed\">\n{{\'GUEST_MESSAGE_CENTER.CLOSED\' | translate}}</span></div></div></div><div class=\"gmc-load-more\" \nng-if=\"vm.loadingThreads && vm.threads.length\"><md-progress-circular class=\"gmc-load-more-spinner\" md-diameter=\"28\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></div><div class=\"gmc-conversation gmc-conversation-dummy\" \nng-if=\"!vm.selectedThread\"><div class=\"gmc-dummy-content\" ng-if=\"vm.threads.length\"><div class=\"gmc-dummy-icon-wrap\">\n<md-icon md-font-icon=\"icon-message-text\" class=\"gmc-dummy-icon\"></md-icon></div><h3>\n{{\'GUEST_MESSAGE_CENTER.SELECT_THREAD\' | translate}}</h3><p>\n{{\'GUEST_MESSAGE_CENTER.SELECT_THREAD_DESC_STAFF\' | translate}}</p></div><div \nclass=\"gmc-dummy-content gmc-dummy-content--no-threads\" \nng-if=\"!vm.loadingThreads && vm.channelFlagsReady && !vm.hasAnyChannelEnabled()\"><div \nclass=\"gmc-dummy-icon-wrap gmc-dummy-icon-wrap--large\"><md-icon md-font-icon=\"icon-cog\" class=\"gmc-dummy-icon\">\n</md-icon></div><h3>{{\'GUEST_MESSAGE_CENTER.CHANNELS_DISABLED\' | translate}}</h3><p>\n{{\'GUEST_MESSAGE_CENTER.CHANNELS_DISABLED_DESC\' | translate}}</p></div><div \nclass=\"gmc-dummy-content gmc-dummy-content--no-threads\" \nng-if=\"!vm.loadingThreads && vm.channelFlagsReady && vm.hasAnyChannelEnabled() && !vm.threads.length\"><div \nclass=\"gmc-dummy-icon-wrap gmc-dummy-icon-wrap--large\"><md-icon md-font-icon=\"icon-forum\" class=\"gmc-dummy-icon\">\n</md-icon></div><h3>{{\'GUEST_MESSAGE_CENTER.NO_THREADS\' | translate}}</h3></div><div class=\"gmc-dummy-content\" \nng-if=\"vm.loadingThreads && !vm.threads.length\"><md-progress-circular md-diameter=\"48\" class=\"gmc-loading-spinner\">\n</md-progress-circular><p>{{\'GUEST_MESSAGE_CENTER.LOADING\' | translate}}</p></div></div><div \nclass=\"gmc-conversation gmc-conversation-panel\" layout=\"column\" ng-if=\"vm.selectedThread\" \ndata-drop-hint=\"Drop image to attach\" gmc-dropzone gmc-dropzone-enabled=\"vm.canAttachImage()\" \ngmc-dropzone-drop=\"vm.onComposerDrop($event)\"><div class=\"gmc-conversation-header\"><div class=\"gmc-header-main\">\n<md-button class=\"md-icon-button gmc-back-btn\" ng-click=\"vm.goBackToThreads()\" aria-label=\"Back\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"gmc-header-avatar\" \nng-style=\"vm.getAvatarStyle(vm.selectedThread)\">{{vm.getGuestInitial(vm.selectedThread)}}</div><div \nclass=\"gmc-header-body\"><div class=\"gmc-header-line1\"><span class=\"gmc-conversation-title\">\n{{vm.getThreadTitle(vm.selectedThread)}}</span></div><div class=\"gmc-header-meta\" \nng-if=\"vm.selectedThread.provider || vm.selectedThread.channel || vm.selectedThread.confirmation_number || (vm.showDirectFeatures() && vm.getThreadPhone(vm.selectedThread))\">\n<span class=\"gmc-provider-chip gmc-header-provider\" ng-if=\"vm.getThreadSourceChip(vm.selectedThread)\" \nng-class=\"vm.getThreadSourceChip(vm.selectedThread).cls\">{{vm.getThreadSourceChip(vm.selectedThread).label}} </span>\n<span class=\"gmc-meta-sep\" \nng-if=\"vm.showDirectFeatures() && vm.getThreadSourceChip(vm.selectedThread) && vm.getThreadPhone(vm.selectedThread)\">·\n</span> <span class=\"gmc-meta-detail gmc-phone-meta\" ng-if=\"vm.showDirectFeatures() && !vm.editingPhone\"><span \nng-if=\"vm.getThreadPhone(vm.selectedThread)\">{{vm.formatPhoneNumber(vm.getThreadPhone(vm.selectedThread))}}</span> \n<span ng-if=\"!vm.getThreadPhone(vm.selectedThread)\" class=\"gmc-phone-missing\" \ntranslate=\"GUEST_MESSAGE_CENTER.NO_PHONE\">No phone</span> <button type=\"button\" class=\"gmc-phone-edit-btn\" \nng-click=\"vm.beginPhoneEdit()\" translate=\"GUEST_MESSAGE_CENTER.EDIT_PHONE\">Edit</button> </span><span \nclass=\"gmc-phone-edit\" ng-if=\"vm.showDirectFeatures() && vm.editingPhone\"><span \nclass=\"gmc-phone-iti-field gmc-phone-edit-field\"><input type=\"tel\" id=\"gmcStaffPhoneEditInput\" \nname=\"gmc_staff_phone_edit\" class=\"gmc-phone-edit-input intel-number-input\" ng-model=\"vm.phoneEditValue\" \nng-disabled=\"vm.savingPhone\" intl-tel-input autocomplete=\"off\" aria-label=\"Phone number\" \nng-change=\"vm.updatePhoneWithCountryCode(\'gmc_staff_phone_edit\', $event)\"> </span><button type=\"button\" \nclass=\"gmc-phone-save-btn\" ng-click=\"vm.saveGuestPhone()\" ng-disabled=\"vm.savingPhone || !vm.isPhoneEditValid()\"><span \nng-if=\"!vm.savingPhone\">Save</span> <span class=\"gmc-phone-save-loading\" ng-if=\"vm.savingPhone\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"14\"></md-progress-circular></span></button> <button type=\"button\" \nclass=\"gmc-phone-cancel-btn\" ng-click=\"vm.cancelPhoneEdit()\" ng-disabled=\"vm.savingPhone\">Cancel</button></span></div>\n</div></div><div class=\"gmc-header-actions\" ng-if=\"vm.selectedThread.staff_user_id\"><div class=\"gmc-reservation-panel\">\n<div class=\"gmc-header-top-actions\"><md-button class=\"md-raised md-accent grey-100-fg gmc-view-res-btn\" \nng-click=\"vm.openUserDetail()\"><span class=\"gmc-view-res-content\"><md-icon md-font-icon=\"icon-open-in-new\" \nclass=\"gmc-view-res-icon\"></md-icon><span translate=\"GUEST_MESSAGE_CENTER.VIEW_USER\">View User</span></span>\n</md-button></div></div></div></div><div class=\"gmc-opt-out-banner\" ng-if=\"vm.isStaffInactive()\"><md-icon \nmd-font-icon=\"icon-alert\" class=\"gmc-opt-out-icon\"></md-icon><span flex>{{vm.getInactiveStaffBannerText()}}</span>\n</div><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingMessages\"></md-progress-linear><div \nid=\"gmc-messages-container\" class=\"gmc-messages\"><div class=\"gmc-load-more-messages\" \nng-if=\"vm.showLoadEarlier && vm.hasMoreMessages()\"><md-button class=\"gmc-load-earlier-btn\" \nng-click=\"vm.loadMoreMessages()\" ng-disabled=\"vm.loadingMessages\"><span ng-if=\"!vm.loadingMessages\">\nLoad earlier messages</span> <span ng-if=\"vm.loadingMessages\">Loading...</span></md-button></div><div \nclass=\"gmc-message-wrap\" ng-repeat=\"message in vm.messages track by message._uid\" \nng-class=\"{\n                                 \'align-left\': message.sender === \'guest\',\n                                 \'align-right\': message.sender === \'property\' || message.sender === \'ai\',\n                                 \'align-center\': message.sender === \'system\',\n                                 \'has-translate-open\': message._translateOpen\n                             }\">\n<div class=\"gmc-message\" \nng-class=\"{\n                                     \'from-guest\': message.sender === \'guest\',\n                                     \'from-property\': message.sender === \'property\' || message.sender === \'ai\',\n                                     \'from-system\': message.sender === \'system\',\n                                     \'from-escalation\': vm.isSupportEscalation(message)\n                                 }\">\n<div class=\"gmc-message-body gmc-phone-change-notice\" ng-if=\"vm.isPhoneChangeNotice(message)\" \nng-bind=\"vm.getPhoneChangeNoticeText(message)\"></div><div class=\"gmc-message-body\" \nng-if=\"!vm.isPhoneChangeNotice(message) && vm.getMessageText(message)\" ng-bind=\"vm.getMessageText(message)\"></div><div \nclass=\"gmc-message-media\" ng-if=\"vm.hasMessageMedia(message)\"><div class=\"gmc-media-loading\" \nng-if=\"!message._mediaExpanded && !message._mediaError\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"28\">\n</md-progress-circular><span class=\"gmc-media-loading-label\">Loading image...</span></div><button type=\"button\" \nclass=\"gmc-media-retry-btn\" ng-if=\"message._mediaError && !message._mediaExpanded\" \nng-click=\"vm.retryMessageMedia(message)\" aria-label=\"Retry image\"><md-icon md-font-icon=\"icon-file-image-box\" \nclass=\"gmc-media-icon\"></md-icon><span>Retry</span></button> <img class=\"gmc-media-inline\" \nng-if=\"message._mediaExpanded && message._mediaPreviewUrl\" ng-src=\"{{message._mediaPreviewUrl}}\" \nng-click=\"vm.openMessageMedia($event, message)\" alt=\"Message media\"></div><div class=\"gmc-attachments\" \nng-if=\"message.attachments && message.attachments.length\"><a class=\"gmc-attachment-link\" \nng-repeat=\"attachment in message.attachments track by $index\" href=\"{{attachment}}\" target=\"_blank\" \nrel=\"noopener noreferrer\">Attachment {{$index + 1}}</a></div><div class=\"gmc-message-footer\"><div \nclass=\"gmc-message-footer-start\"><div class=\"gmc-msg-translate\" ng-if=\"vm.canTranslateMessage(message)\"><button \ntype=\"button\" class=\"gmc-msg-translate-btn\" ng-class=\"{\'is-open\': message._translateOpen}\" \nng-click=\"vm.toggleMessageTranslatePanel($event, message)\" aria-label=\"Translate\" aria-haspopup=\"true\" \naria-expanded=\"{{!!message._translateOpen}}\"><md-icon class=\"gmc-translate-glyph\"><svg \nxmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"16\" height=\"16\" fill=\"currentColor\" aria-hidden=\"true\">\n<path \nd=\"M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z\"/>\n</svg></md-icon></button><div class=\"gmc-msg-translate-popup\" \nng-class=\"\'pos-\' + (message._translatePlacement || \'top\')\" ng-if=\"message._translateOpen\" \nng-click=\"$event.stopPropagation()\"><div class=\"gmc-msg-translate-popup-head\"><md-icon \nclass=\"gmc-translate-glyph gmc-msg-translate-popup-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" \nwidth=\"16\" height=\"16\" fill=\"currentColor\" aria-hidden=\"true\"><path \nd=\"M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z\"/>\n</svg></md-icon><div class=\"gmc-msg-translate-popup-title\" translate=\"GUEST_MESSAGE_CENTER.TRANSLATE\">Translate</div>\n</div><div class=\"gmc-translate-field gmc-translate-field--from\"><label \ntranslate=\"GUEST_MESSAGE_CENTER.CURRENT_LANGUAGE\">Current language</label><div class=\"gmc-translate-current\">\n{{vm.getDetectedLanguageLabel(message) || (\'GUEST_MESSAGE_CENTER.LANGUAGE_AUTO\' | translate)}}</div></div><div \nclass=\"gmc-translate-flow\" aria-hidden=\"true\"></div><div class=\"gmc-translate-field gmc-translate-field--to\"><label \ntranslate=\"GUEST_MESSAGE_CENTER.TRANSLATE_TO\">Translate to</label><div class=\"gmc-translate-loading\" \nng-if=\"vm.translateLanguagesLoading && !vm.translateLanguages.length\" translate=\"GUEST_MESSAGE_CENTER.LOADING\">\nLoading...</div><md-select ng-model=\"message._translateTarget\" ng-if=\"vm.translateLanguages.length\" \naria-label=\"Translate to language\" md-on-close=\"vm.clearTranslateLangSearch()\" \nmd-container-class=\"gmc-translate-select-container\"><md-select-header class=\"demo-select-header\" \nng-click=\"$event.stopPropagation()\"><input ng-model=\"vm.translateLangSearchText\" type=\"search\" \nplaceholder=\"{{\'GUEST_MESSAGE_CENTER.SEARCH_LANGUAGES\' | translate}}\" class=\"demo-header-searchbox md-text\" \nng-keydown=\"$event.stopPropagation()\" ng-keyup=\"$event.stopPropagation()\" autocomplete=\"off\"></md-select-header>\n<md-option \nng-repeat=\"lang in vm.translateLanguages | filter:vm.filterTranslateLanguages track by (lang.code + \'-\' + $index)\" \nng-value=\"lang.code\">{{lang.name}}</md-option></md-select></div><div class=\"gmc-msg-translate-popup-actions\"><button \ntype=\"button\" class=\"gmc-msg-translate-apply\" ng-click=\"vm.translateMessageBubble(message)\" \nng-disabled=\"message._translating || !vm.translateLanguages.length\"><span ng-if=\"!message._translating\" \ntranslate=\"GUEST_MESSAGE_CENTER.TRANSLATE\">Translate</span> <span ng-if=\"message._translating\" \ntranslate=\"GUEST_MESSAGE_CENTER.TRANSLATING\">Translating…</span></button></div></div></div><span class=\"gmc-lang-chip\" \nng-if=\"vm.getMessageLanguageTag(message)\">{{vm.getMessageLanguageTag(message)}} </span><span class=\"gmc-lang-chip\" \nng-if=\"vm.getSentTranslationLanguageLabel(message)\">\n{{\'GUEST_MESSAGE_CENTER.TRANSLATED_IN\' | translate}} {{vm.getSentTranslationLanguageLabel(message)}} </span><button \ntype=\"button\" class=\"gmc-see-original-btn\" \nng-if=\"message._showTranslation || (message.translation && !message._showOriginal)\" \nng-click=\"vm.toggleMessageOriginal(message)\" translate=\"GUEST_MESSAGE_CENTER.SEE_ORIGINAL\">See original</button> \n<button type=\"button\" class=\"gmc-see-original-btn\" ng-if=\"message._showOriginal && message.translation\" \nng-click=\"vm.toggleMessageOriginal(message)\" translate=\"GUEST_MESSAGE_CENTER.SEE_TRANSLATED\">See translated</button> \n<span class=\"gmc-message-channel gmc-provider-chip is-ai\" ng-if=\"message.sender === \'ai\'\" \ntranslate=\"GUEST_MESSAGE_CENTER.AI_SENDER_LABEL\">AI</span> <span class=\"gmc-message-channel gmc-provider-chip\" \nng-if=\"vm.showMessageChannel(message)\" ng-class=\"vm.getMessageChannelClass(message)\">\n{{vm.getMessageChannelLabel(message)}}</span></div><span class=\"gmc-message-time\">\n{{vm.formatDate(message.inserted_at, message.timezone)}}</span></div></div></div></div><div class=\"gmc-composer\" \nng-if=\"vm.canSendMessage && !vm.isStaffInactive() && !vm.isAiModeOn()\"><div class=\"gmc-composer-toolbar\"><div \nclass=\"gmc-channel-picker\" ng-if=\"vm.channelOptions.length\"><button type=\"button\" class=\"gmc-channel-pill\" \nng-repeat=\"option in vm.channelOptions track by option.id\" \nng-class=\"{\'is-active\': vm.composerChannel === option.id, \'is-disabled\': !option.enabled}\" \nng-click=\"vm.setComposerChannel(option.id)\" ng-disabled=\"!option.enabled\">{{option.label}} <span \nclass=\"gmc-channel-start-hint\" ng-if=\"vm.needsDirectChannelStart(option.id)\">+</span></button></div><div \nclass=\"gmc-composer-toolbar-actions\" ng-if=\"vm.canSendToSelected()\"><div \nclass=\"gmc-quick-reply gmc-composer-translate\" ng-class=\"{\'is-open\': vm.composerTranslateOpen}\"><button type=\"button\" \nclass=\"gmc-quick-reply-toggle\" ng-class=\"{\'is-open\': vm.composerTranslateOpen}\" \nng-click=\"vm.toggleComposerTranslate($event)\" ng-disabled=\"vm.sendingMessage\" aria-haspopup=\"true\" \naria-expanded=\"{{vm.composerTranslateOpen}}\"><md-icon class=\"gmc-translate-glyph\" style=\"line-height:1\"><svg \nxmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"currentColor\" aria-hidden=\"true\">\n<path \nd=\"M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z\"/>\n</svg></md-icon><span translate=\"GUEST_MESSAGE_CENTER.TRANSLATE\">Translate</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"gmc-quick-reply-caret\"></md-icon></button><div \nclass=\"gmc-quick-reply-menu gmc-composer-translate-menu\" ng-if=\"vm.composerTranslateOpen\" \nng-click=\"$event.stopPropagation()\"><div class=\"gmc-msg-translate-popup-title\" \ntranslate=\"GUEST_MESSAGE_CENTER.TRANSLATE_TO\">Translate to</div><div class=\"gmc-translate-field\"><div \nclass=\"gmc-translate-loading\" ng-if=\"vm.translateLanguagesLoading && !vm.translateLanguages.length\" \ntranslate=\"GUEST_MESSAGE_CENTER.LOADING\">Loading...</div><md-select ng-model=\"vm.composerTranslateLang\" \nng-if=\"vm.translateLanguages.length\" aria-label=\"Composer translate language\" \nmd-on-close=\"vm.clearTranslateLangSearch()\" md-container-class=\"gmc-translate-select-container\"><md-select-header \nclass=\"demo-select-header\" ng-click=\"$event.stopPropagation()\"><input ng-model=\"vm.translateLangSearchText\" \ntype=\"search\" placeholder=\"{{\'GUEST_MESSAGE_CENTER.SEARCH_LANGUAGES\' | translate}}\" \nclass=\"demo-header-searchbox md-text\" ng-keydown=\"$event.stopPropagation()\" ng-keyup=\"$event.stopPropagation()\" \nautocomplete=\"off\"></md-select-header><md-option \nng-repeat=\"lang in vm.translateLanguages | filter:vm.filterTranslateLanguages track by (lang.code + \'-\' + $index)\" \nng-value=\"lang.code\">{{lang.name}}</md-option></md-select></div><div class=\"gmc-composer-translate-hint\" \nng-if=\"!vm.hasComposerBodyForTranslate()\">Type a message first to translate it.</div><div \nclass=\"gmc-msg-translate-popup-actions\"><button type=\"button\" class=\"gmc-msg-translate-apply\" \nng-click=\"vm.translateComposerDraft()\" \nng-disabled=\"vm.composerTranslating || !vm.hasComposerBodyForTranslate() || !vm.translateLanguages.length\"><span \nng-if=\"!vm.composerTranslating\" translate=\"GUEST_MESSAGE_CENTER.TRANSLATE\">Translate</span> <span \nng-if=\"vm.composerTranslating\" translate=\"GUEST_MESSAGE_CENTER.TRANSLATING\">Translating…</span></button></div></div>\n</div></div></div><div class=\"gmc-send-to\" ng-if=\"vm.needsPhonePicker()\"><div class=\"gmc-send-to-label\" \ntranslate=\"GUEST_MESSAGE_CENTER.SEND_TO\">Send to</div><div class=\"gmc-send-to-options\"><button type=\"button\" \nclass=\"gmc-send-to-option\" ng-if=\"vm.phoneOptions.customer\" ng-class=\"{\'is-active\': vm.sendToSource === \'customer\'}\" \nng-click=\"vm.setSendToSource(\'customer\')\"><span class=\"gmc-send-to-option-label\">Staff phone</span> <span \nclass=\"gmc-send-to-option-phone\">{{vm.formatPhoneNumber(vm.phoneOptions.customer)}}</span></button> <button \ntype=\"button\" class=\"gmc-send-to-option\" ng-class=\"{\'is-active\': vm.sendToSource === \'custom\'}\" \nng-click=\"vm.setSendToSource(\'custom\')\"><span class=\"gmc-send-to-option-label\" \ntranslate=\"GUEST_MESSAGE_CENTER.PHONE_CUSTOM\">Custom number</span></button></div><div \nclass=\"gmc-phone-iti-field gmc-send-to-custom-field\" ng-if=\"vm.sendToSource === \'custom\'\"><input type=\"tel\" \nname=\"gmc_staff_send_to_custom\" class=\"gmc-send-to-custom-input intel-number-input\" ng-model=\"vm.sendToCustomPhone\" \nintl-tel-input autocomplete=\"off\" aria-label=\"Custom phone number\" \nng-change=\"vm.updatePhoneWithCountryCode(\'gmc_staff_send_to_custom\', $event)\"></div><div class=\"gmc-phone-conflict\" \nng-if=\"vm.phoneConflictMessage\">{{vm.phoneConflictMessage}}</div></div><div class=\"gmc-composer-attach-preview\" \nng-if=\"vm.pendingMedia\" ng-click=\"vm.openPendingMedia($event)\" role=\"button\" title=\"Preview image\"><div \nclass=\"gmc-composer-attach-thumb\"><img ng-if=\"vm.pendingMedia.previewUrl\" ng-src=\"{{vm.pendingMedia.previewUrl}}\" \nalt=\"Attached image\"><md-progress-circular ng-if=\"vm.pendingMedia.uploading\" md-mode=\"indeterminate\" md-diameter=\"22\">\n</md-progress-circular><button type=\"button\" class=\"gmc-composer-attach-remove\" \nng-click=\"vm.clearPendingMedia(); $event.stopPropagation()\" ng-disabled=\"vm.sendingMessage\" \naria-label=\"Remove attached image\"><md-icon md-font-icon=\"icon-close\"></md-icon></button></div><div \nclass=\"gmc-composer-attach-meta\"><div class=\"gmc-composer-attach-name\">{{vm.pendingMedia.name}}</div><div \nclass=\"gmc-composer-attach-status\" ng-if=\"vm.pendingMedia.uploading\">Uploading...</div><div \nclass=\"gmc-composer-attach-status is-error\" ng-if=\"vm.pendingMedia.error\">{{vm.pendingMedia.error}}</div></div></div>\n<div class=\"gmc-composer-translation-preview\" ng-if=\"vm.replyTranslation && vm.replyTranslation.text\"><md-icon \nclass=\"gmc-translate-glyph\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"16\" height=\"16\" \nfill=\"currentColor\" aria-hidden=\"true\"><path \nd=\"M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0 0 14.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z\"/>\n</svg></md-icon><span class=\"gmc-composer-translation-preview-label\">\n{{\'GUEST_MESSAGE_CENTER.WILL_SEND_AS\' | translate}}: </span><span class=\"gmc-composer-translation-preview-text\">\n{{vm.replyTranslation.text}}</span> <button type=\"button\" class=\"gmc-translate-clear-btn\" \nng-click=\"vm.clearReplyTranslation()\" translate=\"GUEST_MESSAGE_CENTER.CLEAR_TRANSLATION\">Clear</button></div><div \nclass=\"gmc-composer-row\"><button type=\"button\" class=\"gmc-attach-btn\" ng-if=\"vm.canAttachImage()\" \nng-click=\"vm.openImagePicker()\" ng-disabled=\"!vm.canSendToSelected() || vm.sendingMessage || vm.uploadingMedia\" \naria-label=\"Attach image\"><md-icon md-font-icon=\"icon-file-image-box\"></md-icon></button> <input type=\"file\" \nid=\"gmc-staff-attach-image-input\" class=\"gmc-attach-input\" accept=\"image/jpeg,image/png,image/gif,image/webp\" \nng-disabled=\"!vm.canSendToSelected() || vm.sendingMessage || vm.uploadingMedia\"><textarea id=\"gmc-reply-textarea\" \nclass=\"gmc-reply-textarea\" ng-model=\"vm.replyText\" rows=\"1\" \nplaceholder=\"{{\'GUEST_MESSAGE_CENTER.TYPE_MESSAGE\' | translate}}\" ng-focus=\"vm.onReplyFocus()\" \nng-keydown=\"vm.onReplyKeydown($event)\" ng-keyup=\"vm.resizeReplyTextarea()\" ng-change=\"vm.onReplyTextChange()\" \nng-paste=\"vm.resizeReplyTextarea()\" ng-cut=\"vm.resizeReplyTextarea()\" ng-disabled=\"!vm.canSendToSelected()\"></textarea>\n<md-button class=\"md-raised md-primary gmc-send-btn\" ng-class=\"{\'is-sending\': vm.sendingMessage}\" \nng-click=\"vm.sendReply()\" \nng-disabled=\"vm.sendingMessage || vm.uploadingMedia || !vm.hasSendableContent() || !vm.canSendToSelected()\"><span \nclass=\"gmc-send-btn-content\" ng-if=\"!vm.sendingMessage\">{{\'GUEST_MESSAGE_CENTER.SEND\' | translate}} </span><span \nclass=\"gmc-send-btn-content gmc-send-btn-loading\" ng-if=\"vm.sendingMessage\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular></span></md-button></div></div><div \nclass=\"gmc-composer-disabled\" \nng-if=\"vm.canSendMessage && !vm.isAiModeOn() && (!vm.canSendToSelected() || vm.isStaffInactive()) && vm.getComposerBlockedMessage()\">\n{{vm.getComposerBlockedMessage()}}</div></div></div></div></div>");
$templateCache.put("app/main/apps/marketing/customer-calendar-search/customer-calendar-search.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-box\"></md-icon><span \ntranslate=\"CUSTOMER_CALENDAR_SEARCH.NAME\"></span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"CONTACTS.TOTAL_CUSTOMERS\"></span> <span>{{vm.totalCustomers}}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{\'SEARCH\' | translate}}\" ng-model=\"filterText\" flex></div><div class=\"logo\" layout=\"row\" \nlayout-align=\"center end\"><md-button class=\"md-raised md-cornered\" ng-if=\"getTotalFilters() > 0\" \nng-click=\"vm.clearFilter()\">Clear Filters</md-button><md-button class=\"md-raised md-cornered md-default-theme\" \naria-label=\"filter\" ng-click=\"vm.toggleSidenav(\'customerCalendarFilter\')\"><md-tooltip md-direction=\"bottom\">Filter\n</md-tooltip>Filters <span ng-if=\"getTotalFilters() > 0\">({{ getTotalFilters() }})</span></md-button><md-button \nclass=\"md-raised md-cornered\" id=\"add-contact-button\" ng-click=\"vm.exportData()\" aria-label=\"add contact\" \nng-disabled=\"vm.processingRequest\">Export as CSV</md-button></div></div></div></div></div><div class=\"content\"><div \nclass=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main RowClick\" ms-scroll><mdt-table \npaginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" selectable-rows=\"isDeletedAllowed\" \nalternate-headers=\"\'contextual\'\" selected-row-callback=\"selectedRowCallback(rows)\" \ndelete-row-callback=\"deleteSelectedItem()\" mdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n                    \'table-row-id-key\': \'editCustomerId\',\n                    \'column-keys\': [\n                    \'name\',\n                    \'customer_email\',\n                    \'phone_number\',\n                    \'no_of_stays\',\n                    \'address\',\n                    \'city\',\n                    \'state\',\n                    \'country\',\n                    \'zip_code\',\n                    \'is_active\',\n                    \'editCustomerId\'\n                    ],\n                }\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'CONTACTS.NAME\' | translate }}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'CONTACTS.EMAIL\' | translate }}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\">{{ \'CONTACTS.PHONE_NUMBER\' | translate }}</mdt-column>\n<mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'CONTACTS.NO_OF_STAYS\' | translate }}</span></mdt-column>\n<mdt-column align-rule=\"left\" column-sort=\"true\">{{ \'CONTACTS.ADDRESS\' | translate }}</mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\">{{ \'CONTACTS.CITY\' | translate }}</mdt-column><mdt-column align-rule=\"left\" \ncolumn-sort=\"true\">{{ \'CONTACTS.STATE\' | translate }}</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\">\n{{ \'CONTACTS.COUNTRY\' | translate }}</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\">\n{{ \'CONTACTS.ZIPCODE\' | translate }}</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>\n{{ \'CONTACTS.STATUS\' | translate }}</span></mdt-column><mdt-column align-rule=\"left\"><span></span></mdt-column>\n</mdt-header-row><mdt-custom-cell html-content=\"true\" column-key=\"address\">\n{{ value && value.length > 20 ? (value.substring(0, 20) + \'...\') : (value || \'-\') }}</mdt-custom-cell><mdt-custom-cell \nhtml-content=\"true\" column-key=\"country\">{{value != 0 ? value : \'-\'}}</mdt-custom-cell><mdt-custom-cell \nhtml-content=\"true\" column-key=\"city\">\n{{ value && value.length > 20 ? (value.substring(0, 20) + \'...\') : (value || \'-\') }}</mdt-custom-cell><mdt-custom-cell \nhtml-content=\"true\" column-key=\"state\">{{value != 0 ? value : \'-\'}}</mdt-custom-cell><mdt-custom-cell \nhtml-content=\"true\" column-key=\"zip_code\">{{value != 0 ? value : \'-\'}}</mdt-custom-cell><mdt-custom-cell \nhtml-content=\"true\" column-key=\"phone_number\">{{value != 0 ? value : \'-\'}}</mdt-custom-cell><mdt-custom-cell \nhtml-content=\"true\" column-key=\"is_active\"><i \nng-class=\"value==1?\'icon-checkbox-marked-circle green-500-fg\':\'icon-cancel red-500-fg\'\" class=\"\"></i></mdt-custom-cell>\n<mdt-custom-cell html-content=\"true\" column-key=\"editCustomerId\"><a style=\"cursor:pointer\" \nng-click=\"clientScope.goToEditPage(value)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s16 ng-scope md-default-theme md-font material-icons icon-pencil\" role=\"img\" aria-label=\"icon-cog\"></md-icon>\n</a></mdt-custom-cell></mdt-table></div></div></div></div><md-sidenav \nclass=\"md-sidenav-right md-whiteframe-4dp customer-calendar-filter\" md-component-id=\"customerCalendarFilter\" \nmd-position=\"right\" md-is-locked-open=\"false\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools custom-toolbar\"><h3>Filters</h3><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'customerCalendarFilter\')\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip \nmd-direction=\"bottom\">Cancel</md-tooltip></md-button></div></md-toolbar><md-content class=\"customer-filter-content\">\n<div class=\"filter-panel\"><div class=\"filter-heading\"><span class=\"heading\">State</span><div class=\"global-clear\" \nng-click=\"clearStateFilter()\" ng-if=\"stateFilter.terms.length > 0\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>\n<md-tooltip md-direction=\"bottom\">Clear</md-tooltip><span>Clear</span></div></div><div class=\"filter-main\"><md-select \nclass=\"filter-select\" ng-model=\"stateFilter.condition\" placeholder=\"Equals\" aria-label=\"operator\"><md-option \nvalue=\"contains\">Contains</md-option><md-option value=\"notContains\">Not Contains</md-option><md-option value=\"equals\">\nEquals</md-option><md-option value=\"notEquals\">Not Equals</md-option></md-select><md-chips \nclass=\"customer-filter-chips\" ng-model=\"stateFilter.terms\" md-autocomplete-snap md-require-match=\"false\">\n<md-autocomplete md-selected-item=\"selectedState\" id=\"stateInputBox\" md-search-text=\"stateSearchText\" \nmd-items=\"item in options(stateSearchText, \'state\')\" md-item-text=\"item\" \nmd-selected-item-change=\"onStateSelected(selectedState)\" placeholder=\"Select or type state\"><span \nmd-highlight-text=\"stateSearchText\">{{item}}</span></md-autocomplete></md-chips></div></div><div class=\"filter-panel\">\n<div class=\"filter-heading\"><span class=\"heading\">ZipCode</span><div class=\"global-clear\" ng-click=\"clearZipFilter()\" \nng-if=\"zipFilter.terms.length > 0\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-direction=\"bottom\">\nClear</md-tooltip><span>Clear</span></div></div><div class=\"filter-main\"><md-select class=\"filter-select\" \nng-model=\"zipFilter.condition\" placeholder=\"Equals\" aria-label=\"operator\"><md-option value=\"contains\">Contains\n</md-option><md-option value=\"notContains\">Not Contains</md-option><md-option value=\"equals\">Equals</md-option>\n<md-option value=\"notEquals\">Not Equals</md-option></md-select><md-chips class=\"customer-filter-chips\" \nng-model=\"zipFilter.terms\" md-autocomplete-snap md-require-match=\"false\"><md-autocomplete id=\"zipInputBox\" \nmd-selected-item=\"selectedZip\" md-search-text=\"zipSearchText\" md-items=\"item in options(zipSearchText, \'zip_code\')\" \nmd-item-text=\"item\" md-selected-item-change=\"onZipSelected(selectedZip)\" placeholder=\"Select or type zip\"><span \nmd-highlight-text=\"zipSearchText\">{{item}}</span></md-autocomplete></md-chips></div></div><div class=\"filter-panel\">\n<div class=\"filter-heading\"><span class=\"heading\">Member</span><div class=\"global-clear\" ng-click=\"clearLoginFilter()\" \nng-if=\"loginFilter !== \'all\'\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-direction=\"bottom\">Clear\n</md-tooltip><span>Clear</span></div></div><div class=\"filter-main login-filter\"><md-radio-group \nclass=\"custom-radio-grp\" md-no-ink ng-model=\"loginFilter\" layout=\"row\"><md-radio-button md-no-ink value=\"yes\">Yes\n</md-radio-button><md-radio-button md-no-ink value=\"no\">No</md-radio-button><md-radio-button md-no-ink value=\"all\">Both\n</md-radio-button></md-radio-group></div></div><div class=\"filter-panel\"><div class=\"filter-heading\"><span \nclass=\"heading\">Date Range</span><div class=\"global-clear\" ng-click=\"clearDateRanges()\" ng-if=\"hasDateRangeValues()\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-direction=\"bottom\">Clear</md-tooltip><span>Clear</span>\n</div></div><div class=\"filter-main date-range\"><div ng-repeat=\"range in dateRanges track by $index\" layout=\"row\" \nlayout-align=\"start center\" style=\"margin-bottom: 8px\"><md-date-range ng-model=\"range.model\" auto-confirm=\"true\" \nclass=\"customer-calendar-md-date-range\"></md-date-range><md-button class=\"md-icon-button\" md-no-ink \nng-click=\"removeDateRange($index)\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><md-button \nclass=\"md-primary add-date-range\" ng-click=\"addDateRange()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span>\nAdd more date range</span></md-button></div></div><div class=\"filter-panel\" ng-if=\"availableTags.length\"><div \nclass=\"filter-heading\"><span class=\"heading\">Tags</span><div class=\"global-clear\" ng-click=\"clearTagFilter()\" \nng-if=\"tagFilter.length > 0\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-direction=\"bottom\">Clear\n</md-tooltip><span>Clear</span></div></div><div class=\"filter-main tags-filter\"><md-checkbox \nng-repeat=\"tag in availableTags\" ng-checked=\"isTagSelected(tag.id)\" ng-click=\"toggleTag(tag.id)\" class=\"md-primary\" \nmd-no-ink>{{ tag.name }}</md-checkbox></div></div></md-content><div class=\"filter-actions\"><div><md-button \nng-click=\"vm.clearFilter()\" class=\"md-default\" ng-disabled=\"!canClearAll()\">Clear all</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.applyFilter()\" ng-disabled=\"!canClearAll()\" style=\"margin-left:8px\">Apply\n</md-button></div></div></md-sidenav>");
$templateCache.put("app/main/apps/mls/dialog/mlsModel.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"mlsForm\" id=\"mlsForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" ng-if=\"vm.pageStatus == \'add\'\" translate=\"MLS.NEW_MLS\"></span> <span class=\"title\" \nng-if=\"vm.pageStatus != \'add\'\" translate=\"MLS.UPDATE_MLS\"></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div><div class=\"contact-name\">\n{{vm.contact.name}}</div><div ng-if=\"vm.error\">{{ vm.error }}</div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><md-content class=\"md-padding\" layout=\"row\" layout-wrap><div layout=\"column\" flex-gt-xs=\"50\" \nflex=\"100\"><md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" \nrole=\"button\" translate=\"MLS.FROM\"></label><md-datepicker class=\"birthday-input1 no-padding\" md-min-date=\"vm.minDate\" \nmd-max-date=\"vm.mls.mls_to\" ng-model=\"vm.mls.mls_from\" md-open-on-focus ng-model-options=\"{debounce: 500}\" required>\n</md-datepicker></md-input-container></div><div layout=\"column\" flex-gt-xs=\"50\" flex=\"100\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" flex-gt-xs=\"100\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"MLS.TO\"></label><md-datepicker class=\"birthday-input1 no-padding\" md-min-date=\"vm.mls.mls_from\" \nng-model=\"vm.mls.mls_to\" md-open-on-focus ng-model-options=\"{debounce: 500}\" required></md-datepicker>\n</md-input-container></div><div layout=\"column\" flex-gt-xs=\"100\" flex=\"100\"><md-input-container \nclass=\"md-block tax-inputs mb-0\" flex-gt-xs=\"100\"><label class=\"ng-scope md-required\" role=\"button\" \ntranslate=\"MLS.MIN_STAY\"></label><input type=\"number\" name=\"minday\" ng-change=\"vm.validateDayCount()\" \nng-model=\"vm.mls.mls_days\" required aria-invalid=\"true\"><div><div><span>{{vm.dayCountErrorMsg}}</span></div></div>\n</md-input-container></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" \nng-click=\"vm.pageStatus == \'add\' ? vm.saveMls() : vm.updateMls()\" \nng-class=\"!vm.mls.mls_to || !vm.mls.mls_to || vm.requestProgressing || !vm.mls.mls_days || mlsForm.$pristine?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"!vm.mls.mls_to || !vm.mls.mls_to || vm.requestProgressing || !vm.mls.mls_days || mlsForm.$pristine\" \naria-label=\"SAVE\" translate=\"GROUPS.SAVE\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/permissions/adminusers/adminuser.html","<form name=\"userForm\" class=\"md-inline-form\" novalidate><div id=\"add-user\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page profileImage_page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex>\n<md-button class=\"goto-organizations-button md-icon-button\" aria-label=\"Go to users\" ng-click=\"vm.gotoUsers()\"><md-icon\n md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\" ng-if=\"vm.newUser\"><div class=\"h2\" translate=\"USERS.NEW_USER\"></div></div>\n<div layout=\"column\" layout-align=\"start start\" ng-if=\"!vm.newUser\"><div class=\"h2\">\n{{vm.adminuser.first_name}} {{vm.adminuser.last_name}}</div><div class=\"subtitle secondary-text\"><span \ntranslate=\"USERS.USER_DETAIL\"></span></div></div></div></div><div><md-button class=\"md-raised md-background\" \nng-class=\"{\'md-blue-grey-A100-bg\': !vm.canSave(userForm)}\" ng-disabled=\"!vm.canSave(userForm)\" \nng-click=\"vm.newUser ? vm.addNewUser() : vm.saveExistingUser()\"><span translate=\"GROUPS.SAVE\"></span></md-button>\n<md-button class=\"md-raised md-background\" ng-click=\"vm.gotoUsers()\" ng-disabled=\"vm.isloading\"><span \ntranslate=\"GROUPS.CANCEL\"></span></md-button></div></div><div class=\"content\"><div class=\"main\" ms-scroll><div \nclass=\"white-bg md-whiteframe-4dp relative-block\" layout-align=\"center center\" layout-padding><div layout=\"row\" \nlayout-align=\"start\" flex=\"100\" layout-wrap><div layout-align=\"start\" layout=\"column\" flex=\"25\" flex-md=\"35\" \nflex-sm=\"40\" flex-xs=\"100\"><div class=\"row-col padding-right-10 padding-left-10 mb-20\"><div class=\"row-col\">\n<md-input-container class=\"overflow-hidden md-block tax-inputs-img-uploade image-container no-margin\"><img \nngf-src=\"vm.pictures\" ng-show=\"vm.pictures\"> <img ngf-src=\"vm.previousPicture\" ng-show=\"vm.imageStatus\"><choose-file \nclass=\"md-fab md-mini full-row-block md-profile-icon-1\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex>\n<input id=\"pictures\" type=\"file\" name=\"pictures\" ngf-select=\"vm.upload($file, $invalidFiles)\" ng-model=\"vm.pictures\" \naccept=\"image/*\" class=\"ng-hide\" ngf-pattern=\"\'.jpg,.jpeg,.png,.gif\'\" ngf-accept=\"\'.jpg,.jpeg,.png,.gif\'\"><div \nclass=\"inline-block-txt\" layout=\"row\" layout-align=\"start start\" flex-gt-xs=\"8\"><md-button id=\"uploadButton\" \nclass=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-upload\" class=\"white-fg\"></md-icon></md-button></div>\n<md-input-container flex class=\"md-block inline-block-txt\" flex-gt-xs=\"92\"><div class=\"hint\"></div>\n</md-input-container></choose-file></md-input-container></div></div></div><div layout-align=\"start\" layout=\"column\" \nflex=\"75\" flex-md=\"65\" flex-sm=\"60\" flex-xs=\"100\"><div class=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start\" flex><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" flex-gt-sm=\"50\" layout-align=\"start start\" \nclass=\"padding-5\" flex><md-input-container flex-gt-xs=\"100\" class=\"md-block tax-inputs\" data-ng-animate=\"1\"><label \nclass=\"ng-scope md-required\" role=\"button\" translate=\"USERS.FIRST_NAME\"></label><input type=\"text\" name=\"first_name\" \nng-model=\"vm.adminuser.first_name\" required aria-invalid=\"true\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\">\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" flex-gt-sm=\"50\" \nlayout-align=\"end start\" flex><md-input-container flex-gt-xs=\"100\" class=\"md-block tax-inputs\" data-ng-animate=\"2\">\n<label class=\"ng-scope md-required\" role=\"button\" translate=\"USERS.LAST_NAME\"></label><input type=\"text\" \nname=\"last_name\" ng-model=\"vm.adminuser.last_name\" required aria-invalid=\"true\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></md-input-container></div></div><div class=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" \nlayout-align=\"start start\" flex><md-input-container flex-gt-xs=\"100\" class=\"md-block tax-inputs\" data-ng-animate=\"1\">\n<label class=\"ng-scope md-required\" role=\"button\" translate=\"USERS.EMAIL\"></label><input type=\"email\" name=\"email\" \nng-model=\"vm.adminuser.email\" required aria-invalid=\"true\" ng-change=\"vm.validateUserEmail()\" \nng-pattern=\"/^.+@.+\\..+$/\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div ng-messages=\"userForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span translate=\"USERS.VALID_EMAIL\"></span></div></div><div \nng-if=\"!vm.disSubmit\" class=\"emailError\"><span translate=\"USERS.EMAIL_EXISTS\"></span></div></md-input-container></div>\n<div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block tax-inputs\" flex-gt-xs=\"100\" ng-hide=\"vm.roles.length <= 10\"><label \ntranslate=\"ROLES.ROLE\"></label><md-select ng-model=\"vm.adminuser.role_id\" name=\"userRole\" required \nng-disabled=\"vm.roles.length <= 10\" ng-hide=\"vm.roles.length <= 10\" md-on-close=\"clearSearchRole()\" \ndata-md-container-class=\"selectdemoSelectHeader\"><md-select-header class=\"demo-select-header\"><input \nng-model=\"searchRole\" type=\"search\" placeholder=\"Search for a role..\" class=\"demo-header-searchbox md-text role-srch\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-select-header><md-optgroup label=\"roles\"><md-option \nng-repeat=\"role in vm.roles | filter:searchRole\" value=\"{{role.role_id}}\" \nng-selected=\"role.role_id==vm.adminuser.role_id\">{{role.role_name}}</md-option></md-optgroup></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block tax-inputs\" flex-gt-xs=\"100\" \nng-hide=\"vm.roles.length > 10\"><label>Role</label><md-select ng-model=\"vm.adminuser.role_id\" name=\"userRole\" required \nng-disabled=\"vm.roles.length > 10\" ng-hide=\"vm.roles.length > 10\"><md-option ng-repeat=\"role in vm.roles\" \nvalue=\"{{role.role_id}}\" ng-selected=\"role.role_id==vm.adminuser.role_id\">{{role.role_name}}</md-option></md-select>\n<div class=\"md-errors-spacer\"></div></md-input-container></div></div><div class=\"row-block\" layout=\"column\" \nlayout-gt-xs=\"row\" layout-align=\"start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs\" flex-gt-xs=\"100\"><label \ntranslate=\"USERS.PASSWORD\"></label><input ng-model=\"vm.password\" type=\"password\" ng-required=\"!vm.adminuser.user_id\" \nname=\"password_1\" min-password-edit ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div \nng-messages=\"userForm.password_1.$error\" role=\"alert\"><div ng-message=\"min-password-edit\"><span \ntranslate=\"CONTACTS.MIN_PASSWORD\"></span></div></div></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout-align=\"start start\" flex><md-input-container \nclass=\"md-block tax-inputs\" flex-gt-xs=\"100\"><label translate=\"USERS.CONFIRM_PASSWORD\"></label><input \nng-model=\"vm.adminuser.passwordConfirm\" ng-required=\"!vm.adminuser.user_id || vm.password\" name=\"passwordConfirm\" \ntype=\"password\" compare-to=\"vm.password\" min-password-edit ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div \nng-messages=\"userForm.passwordConfirm.$error\"><div ng-message=\"compareTo\"><span translate=\"CONTACTS.MATCH_PASSWORD\">\n</span></div><div ng-message=\"min-password-edit\"><span translate=\"CONTACTS.MIN_PASSWORD\"></span></div></div>\n</md-input-container></div></div><div class=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex>\n<div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block tax-inputs\" flex-gt-xs=\"100\"><label translate=\"USERS.5DIGIT\"></label><input \ntype=\"number\" name=\"five_digit_code\" ng-model=\"vm.adminuser.five_digit_code\" required aria-invalid=\"true\" \nng-maxlength=\"5\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout-align=\"start start\" flex><md-input-container \nclass=\"md-block tax-inputs\" flex-gt-xs=\"100\"><label class=\"phone-number-label\">Phone Number</label><input type=\"tel\" \nname=\"phone_number\" id=\"adminPhoneNumber\" ng-model=\"vm.adminuser.phone_number\" class=\"intel-number-input\" \nintl-tel-input autocomplete=\"off\" ng-change=\"vm.updatePhoneWithCountryCode(\'phone_number\', $event)\">\n</md-input-container></div></div><div class=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex>\n<div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"30\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block md-input-has-value\"><md-switch class=\"no-margin\" name=\"bar_user\" \nng-model=\"vm.adminuser.bar_user\" aria-label=\"Switch 1\" ng-show=\"vm.showBarUser\"><span translate=\"CONTACTS.BAR_USER\" \nng-if=\"vm.adminuser.bar_user\"></span> <span translate=\"CONTACTS.NON_BAR_USER\" ng-if=\"!vm.adminuser.bar_user\"></span>\n</md-switch></md-input-container></div></div></div></div><div class=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs\" flex-gt-xs=\"100\"><label \ntranslate=\"USERS.STATUS\"></label><md-select ng-model=\"vm.adminuser.status\" name=\"status\"><md-option value=\"1\" \nng-selected=\"!vm.adminuser.status || 1==vm.adminuser.status\">Active</md-option><md-option value=\"0\" \nng-selected=\"0==vm.adminuser.status\">Inactive</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container></div></div></div></div></div></div></form>");
$templateCache.put("app/main/apps/permissions/adminusers/adminusers.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-button ng-if=\"vm.hotel_id\" \nclass=\"goto-organizations-button md-icon-button\" aria-label=\"Go to organizations\" ng-click=\"vm.gotorolesusers()\">\n<md-icon md-font-icon=\"icon-arrow-left\" class=\"white-fg\"></md-icon></md-button><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account-box\"></md-icon><span translate=\"USERS.USERS\"></span></div><div \nclass=\"product-count secondary-text\"><span translate=\"USERS.TOTAL_USERS\"></span> <span>{{vm.totalUsers}}</span></div>\n</div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{ \'SEARCH\' | translate }}\" ng-model=\"filterText\" flex></div><div class=\"logo\" layout=\"row\" \nlayout-align=\"center end\" ng-if=\"userPermissions.indexOf(\'add_user\') != -1\"><md-button layout=\"row\" \nclass=\"md-raised md-cornered\" ng-click=\"vm.gotoadduser()\"><i class=\"icon-plus icon-plus-main\"></i>\n {{ \'USERS.USER\' | translate }}</md-button></div></div></div></div><div ng-hide=\"!vm.addOrg\"><md-button \nclass=\"md-raised md-background\" \nng-disabled=\"organizationForm.$invalid || organizationForm.$pristine || vm.uniqueError\" \nng-click=\"vm.saveOrganization()\"><span translate=\"SAVE\"></span></md-button><md-button class=\"md-raised md-background\">\n<span translate=\"CANCEL\" ng-click=\"vm.gotoOrgs()\"></span></md-button></div></div><div class=\"content\"><div \nclass=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main RowClick\" ms-scroll><mdt-table \ntable-card=\"{visible: false, title: \'Users\'}\" paginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" \nselectable-rows=\"isDeletedAllowed\" alternate-headers=\"\'contextual\'\" selected-row-callback=\"selectedRowCallback(rows)\" \nmdt-row-paginator=\"paginatorCallback(page, pageSize, options, selected)\" delete-row-callback=\"deleteSelectedItem()\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n        \'table-row-id-key\': \'user_id\',\n        \'column-keys\': [\n        \'common_name\',\n        \'email\',\n        \'role_name\',\n        \'last_login_at\',\n        \'status\',\n        \'EditId\'\n        ],\n    }\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'USERS.NAME\' | translate }}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'USERS.EMAIL\' | translate }}</span></mdt-column>\n<mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'ROLES.ROLE\' | translate }}</span></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"{sort:\'desc\'}\"><span>{{ \'USERS.LAST_LOGIN\' | translate }}</span></mdt-column><mdt-column\n align-rule=\"left\" column-sort=\"true\" \ncolumn-filter=\"{\'valuesProviderCallback\': statusValuesCallback, \'valuesTransformerCallback\': statusValuesTransformer, \'placeholderText\': \'Select a status\', \'defaultValue\': defaultStatusFilter, \'filterType\': \'dropdown\'}\">\n<span>{{ \'USERS.STATUS\' | translate }}</span></mdt-column><mdt-column align-rule=\"left\"><span></span></mdt-column>\n</mdt-header-row><mdt-custom-cell html-content=\"true\" column-key=\"status\"><div><i \nng-class=\"value==1?\'icon-checkbox-marked-circle green-500-fg\':\'icon-cancel red-500-fg\'\" class=\"\"></i></div>\n</mdt-custom-cell><mdt-custom-cell html-content=\"true\" column-key=\"last_login_at\"><span ng-bind=\"value || \'-\'\"></span>\n</mdt-custom-cell><mdt-custom-cell html-content=\"true\" column-key=\"EditId\"><a \nng-click=\"clientScope.goToEditPage(value)\"><md-icon md-font-icon=\"icon-icon-border-color\" \nclass=\"icon icon-border-color cursorPointer\" role=\"img\" aria-label=\"icon-cog\"></md-icon></a></mdt-custom-cell>\n</mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/permissions/organization/organization.html","<form name=\"organizationForm\" id=\"orgForm\" class=\"md-inline-form\" novalidate><div id=\"hotel\" \nclass=\"page-layout simple left-sidenav doc-page\"><div class=\"header md-accent-bg relative-block\" layout=\"row\" \nlayout-align=\"space-between\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-organizations-button md-icon-button\" aria-label=\"Go to organizations\" ng-click=\"vm.gotoOrgs()\" translate \ntranslate-attr-aria-label=\"EC.GO_TO_ORGANIZATIONS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><div ng-if=\"!vm.addOrg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h2\">{{vm.organization.hotel_title}}</div><div class=\"subtitle secondary-text\"><span \ntranslate=\"ORG.ORGANIZATION_DETAIL\"></span></div></div><div ng-if=\"vm.addOrg\" layout=\"row\" layout-align=\"start center\">\n<div layout=\"column\" layout-align=\"start start\"><div class=\"h2\" translate=\"ORG.NEW_HOTEL\"></div></div></div></div>\n</div><div ng-hide=\"!vm.addOrg\"><md-button class=\"md-raised md-background\" \nng-class=\"{\'md-blue-grey-A100-bg\': organizationForm.$invalid || organizationForm.$pristine || vm.uniqueError || vm.uniqueCode}\" \nng-disabled=\"organizationForm.$invalid || organizationForm.$pristine || vm.uniqueError || vm.uniqueCode\" \nng-click=\"vm.saveOrganization()\"><span translate=\"GROUPS.SAVE\"></span></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.gotoOrgs()\"><span translate=\"GROUPS.CANCEL\"></span></md-button></div>\n</div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><div \nclass=\"content scroll-height-sm\"><div class=\"main sm-hearder-top scroll-full-height\" ms-scroll><div \nclass=\"role-list-out white-bg\"><div class=\"row\" layout=\"row\" layout-wrap flex=\"100\"><div layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" class=\"ph-10\"><md-input-container class=\"md-icon-float name-input-block\"><label \ntranslate=\"ORGANIZATIONS.NAME_REQUIRED\"></label><input \nng-change=\"vm.uniqueOrgName(vm.organization.hotel_title,\'hotel_title\')\" ng-model-options=\"{debounce: 500}\" \nng-model=\"vm.organization.hotel_title\" name=\"hotel_title\" type=\"text\" md-autofocus required \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div ng-show=\"vm.uniqueName\" role=\"alert\"><div class=\"errortxt\"><span \ntranslate=\"ORG.HOTEL_EXISTS\"></span></div></div></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" class=\"ph-10\"><md-input-container class=\"md-icon-float name-input-block\"><label>Hotel Code</label>\n<input ng-change=\"vm.uniqueOrgCOde(vm.organization.hotel_code,\'hotel_code\')\" ng-model-options=\"{debounce: 500}\" \nng-model=\"vm.organization.hotel_code\" name=\"hotel_code\" type=\"text\" md-autofocus required ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"><div ng-show=\"vm.uniqueCode\" role=\"alert\"><div class=\"errortxt\"><span>\nThis hotel code already exists.</span></div></div></md-input-container></div></div><div class=\"row\" layout=\"row\" \nlayout-wrap flex=\"100\"><div layout=\"column\" flex=\"100\" flex-gt-xs=\"{{ vm.addOrg? 50:0 }}\" class=\"ph-10\" \nng-if=\"vm.addOrg\"><md-input-container class=\"md-icon-float md-block name-input-block\"><md-select \nng-change=\"vm.checkedParent()\" ng-model=\"vm.organization.parent_id\"><md-option selected=\"selected\" ng-value=\"0\">\nNo Parent</md-option><md-option ng-value=\"organization.hotel_id\" ng-repeat=\"organization in vm.organizations\">\n{{organization.hotel_title}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div\n layout=\"column\" flex=\"100\" flex-gt-xs=\"{{ (!vm.addOrg && !vm.parent)? 50:0 }}\" class=\"ph-10\" \nng-if=\"!vm.addOrg && vm.childHotels.length>0\"><md-input-container class=\"md-icon-float md-block name-input-block\">\n<label translate=\"Default Child\"></label><md-select ng-model=\"vm.organization.default_sub_hotel\" \nng-change=\"vm.saveOrganization()\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in vm.childHotels\">\n{{hotel.hotel_title}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"{{ vm.addOrg? 50:0 }}\" class=\"ph-10 column-checkbox\" \nng-if=\"vm.addOrg && vm.checkSubHotel\"><md-input-container class=\"md-icon-float md-block name-input-block\"><md-checkbox \naria-label=\"Default Child\" class=\"les-margin\" ng-model=\"vm.organization.default_sub_hotel\">Default Child</md-checkbox>\n<div class=\"md-errors-spacer\"></div></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-xs=\"{{ (!vm.addOrg && vm.parent)? 50:0 }}\" class=\"ph-10\" ng-if=\"!vm.addOrg && vm.parent\"><md-input-container \nclass=\"md-icon-float md-block name-input-block\"><label translate=\"ORGANIZATIONS.PARENT\"></label><md-select \ndisabled=\"disabled\" ng-model=\"vm.organization.parent_id\"><md-option \nng-selected=\"organization.hotel_id == vm.organization.parent_id\" ng-value=\"organization.hotel_id\" \nng-repeat=\"organization in vm.organizations\">{{organization.hotel_title}}</md-option></md-select></md-input-container>\n</div></div></div><div class=\"role-list-out white-bg relative-block mt-15\"><div \nclass=\"form-title margin-left-10 relative-block iconRoomType\"><span translate=\"ORG.ROOMS\"></span> <a \nng-click=\"vm.addProduct()\" class=\"custom-pull-right m-t-8\"><i class=\"icon-plus-circle\"></i></a></div><div \nclass=\"row-block\" flex-gt-xs=\"100\" layout-wrap layout=\"row\" layout-align=\"start start\" flex><div \nclass=\"row-col padding-right-10 padding-left-10 iconRoomType\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex=\"100\" \nlayout=\"column\" flex ng-repeat=\"(key, room) in vm.totalRooms\"><md-input-container class=\"md-block tax-inputs\"><label \ntranslate=\"ROOM_TYPE.ROOM_NUMBER\"></label><input layout=\"column\" flex=\"90\" ng-model=\"vm.totalRooms[key].room_no\" \nname=\"product_room_number\" type=\"text\" required \nng-change=\"!vm.addOrg && vm.totalRooms[key].room_no!= \'\' && vm.editRoomNames(key)\" ng-model-options=\"{debounce: 500}\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div ng-if=\"vm.uniqueRoomNameError[key]\" role=\"alert\"><div \nclass=\"errortxt\"><span translate=\"ORG.ROOM_EXISTS\"></span></div></div><div layout=\"column\" flex=\"10\" \nlayout-align=\"end end\" ng-if=\"vm.addOrg || (!vm.addOrg && room.adding_new)\"><a ng-click=\"vm.deleteProduct(key)\" \nclass=\"padding-top-5 red-A800-fg onlycursorPointer\"><i class=\"icon-delete\"></i></a></div><div layout=\"column\" \nflex=\"10\" layout-align=\"end end\" ng-if=\"!vm.addOrg && !room.adding_new\"><a \nng-click=\"vm.changeStatus(room.id,key,room.room_status)\" class=\"padding-top-5 red-A800-fg onlycursorPointer\"><i \nng-class=\"room.room_status==1?\'icon-checkbox-marked-circle green-500-fg\':\'icon-cancel red-500-fg\'\"></i></a></div>\n</md-input-container></div></div></div><div class=\"role-list-out white-bg relative-block mt-15\" ng-if=\"vm.showBoats\">\n<div class=\"form-title margin-left-10 relative-block iconRoomType\"><span>Boat Numbers</span> <a \nng-click=\"vm.addBoats()\" class=\"custom-pull-right m-t-8\"><i class=\"icon-plus-circle\"></i></a></div><div \nclass=\"row-block\" flex-gt-xs=\"100\" layout-wrap layout=\"row\" layout-align=\"start start\" flex \nng-if=\"validatePermission(\'boats\')\"><div class=\"row-col padding-right-10 padding-left-10 iconRoomType\" flex-gt-xs=\"50\" \nflex-gt-sm=\"50\" flex=\"100\" layout=\"column\" flex ng-repeat=\"(key, boat) in vm.totalBoats\"><md-input-container \nclass=\"md-block tax-inputs\"><label>Boat Number</label><input layout=\"column\" flex=\"90\" \nng-model=\"vm.totalBoats[key].boat_no\" name=\"product_boat_number\" type=\"text\" required \nng-change=\"!vm.addOrg && vm.totalBoats[key].room_no!= \'\' && vm.editBoatNames(key)\" ng-model-options=\"{debounce: 500}\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div ng-if=\"vm.uniqueBoatNameError[key]\" role=\"alert\"><div \nclass=\"errortxt\"><span>This boat already exists.</span></div></div><div layout=\"column\" flex=\"10\" \nlayout-align=\"end end\" ng-if=\"vm.addOrg || (!vm.addOrg && boat.adding_new)\"><a ng-click=\"vm.deleteBoat(key)\" \nclass=\"padding-top-5 red-A800-fg onlycursorPointer\"><i class=\"icon-delete\"></i></a></div><div layout=\"column\" \nflex=\"10\" layout-align=\"end end\" ng-if=\"!vm.addOrg && !boat.adding_new\"><a \nng-click=\"vm.changeBoatStatus(boat.id,key,boat.boat_status)\" class=\"padding-top-5 red-A800-fg onlycursorPointer\"><i \nng-class=\"boat.boat_status==1?\'icon-checkbox-marked-circle green-500-fg\':\'icon-cancel red-500-fg\'\"></i></a></div>\n</md-input-container></div></div></div><div class=\"role-list-out white-bg relative-block mt-15\" \nng-if=\"vm.organization.parent_id == 0\"><span ng-if=\"!vm.parent\"><div class=\"form-title\" translate=\"ORG.PERMISSIONS\">\n</div><md-list class=\"select-all-block\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><md-list-item \nclass=\"checkboxCell contact-item white-bg\" md-ink-ripple><md-checkbox class=\"les-margin\" \nng-checked=\"vm.selectedModules.length==vm.modulesLength\" ng-click=\"vm.selectAllModules()\" \naria-label=\"{{vm.selectedModules.length==vm.modulesLength? \'Deselect\' : \'Select\'}}\"></md-checkbox><p \nclass=\"text-truncate\" translate=\"ORG.SELECT_ALL\"></p></md-list-item></md-list><md-list \nclass=\"contacts-list sel-box-list\" layout-wrap flex=\"100\" layout=\"row\" ng-repeat=\"module in vm.modules\"><md-list-item \nclass=\"checkboxCell contact-item white-bg\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"33\" flex-gt-md=\"25\" \nmd-ink-ripple ng-repeat=\"modul in module\" ng-class=\"{\'selected\': vm.isSelected(contact)}\" layout-align=\"start\">\n<md-checkbox class=\"les-margin\" ng-checked=\"vm.selectedModules.indexOf(modul.id) != -1\" \nng-click=\"vm.toggleSelectModule(modul, $event)\" \naria-label=\"{{vm.selectedModules.indexOf(modul.id)==-1 ? \'Deselect\' : \'Select\'}}\"></md-checkbox><p \nclass=\"text-truncate font-size-14 font-weight-500\">{{modul.action}}</p></md-list-item><md-list-item \nclass=\"no-results md-white-bg\" ng-show=\"filteredModules.length === 0\"><p translate=\"CONTACTS.NO_RESULTS\"></p>\n</md-list-item></md-list></span></div></div></div></div></form>");
$templateCache.put("app/main/apps/permissions/organizations/organizations.html","<div id=\"category\" class=\"lastcolumn_custom_three_icons page-layout simple fullwidth element-doc-page\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"content top-head\"><div class=\"content\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"main\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-domain\"></md-icon><span translate=\"ORGANIZATIONS.ORGANIZATIONS\"></span></div><div \nclass=\"product-count secondary-text\"><span translate=\"ORGANIZATIONS.TOTAL_HOTELS\"></span> <span>{{vm.totalOrg}}</span>\n</div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{\'SEARCH\' | translate}}\" ng-model=\"filterText\" flex></div><div class=\"logo\" layout=\"row\" \nlayout-align=\"center end\"><md-button class=\"md-raised md-cornered\" ng-click=\"vm.goToaddHotel()\" \nng-if=\"vm.userPermissions.indexOf(\'add_hotel\')!=-1\"><span><i class=\"icon-plus icon-plus-main\"></i>\n {{\"ORGANIZATIONS.ADD_NEW_Org\" | translate}}</span></md-button></div></div></div></div></div><div class=\"content\"><div \nclass=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main RowClick\" ms-scroll><mdt-table \ntable-card=\"{visible: false}\" paginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" \nselectable-rows=\"vm.isDeleteAllowed\" alternate-headers=\"\'contextual\'\" \nselected-row-callback=\"selectedRowCallback(rows)\" delete-row-callback=\"deleteSelectedItem()\" \nmdt-row-paginator=\"paginatorCallback(page, pageSize,options)\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n			data: vm.tempContact,\n			\'table-row-id-key\': \'hotel_id\',\n			\'column-keys\': [\n            \'hotel_title\',\n			\'parentTitle\',\n			\'DeleteId\'\n			],\n			}\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'ORGANIZATIONS.ORG_FNAME\' | translate }}\n</span></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>\n{{ \'ORGANIZATIONS.PARENT_NAME\' | translate }}</span></mdt-column><mdt-column align-rule=\"right\" \nclass=\"action-right-icons\"><span>{{ \'ORGANIZATIONS.ACTION\' | translate }}</span></mdt-column></mdt-header-row>\n<mdt-custom-cell html-content=\"true\" column-key=\"DeleteId\"><a ng-click=\"clientScope.showTabDialog($event, value)\">\n<md-icon md-font-icon=\"icon-cog\" class=\"icon icon-border-color cursorPointer\" role=\"img\" aria-label=\"icon-cog\">\n</md-icon></a></mdt-custom-cell></mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/permissions/profile/profile.html","<div id=\"simple-table\" class=\"page-layout simple left-sidenav doc-page profilePage profileImage_page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><div layout=\"row\" layout-align=\"space-between center white-fg\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account\" class=\"s24 padding-right-30\"></md-icon><span translate=\"PROFILE.MY_PROFILE\"></span></div>\n<div class=\"product-count secondary-text padding-left-30\"><span>{{vm.profile.email}}</span></div></div></div></div>\n</div><div class=\"content\"><div class=\"main\" ms-scroll><div class=\"white-bg md-whiteframe-4dp relative-block\" \nlayout-align=\"center center\" layout-padding><form name=\"userForm\" class=\"md-inline-form\" enctype=\"multipart/form-data\" \nnovalidate><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex><div class=\"row-block\" flex-gt-xs=\"25\"><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\"><md-input-container \nclass=\"overflow-hidden md-block tax-inputs-img-uploade image-container no-margin\" flex-gt-xs=\"50\"><img \nngf-src=\"vm.pictures\" ng-show=\"vm.pictures\"> <img ngf-src=\"vm.previousPicture\" ng-show=\"vm.imageStatus\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/profileimage/default-profile.png\'}}\"><choose-file \nclass=\"md-fab md-mini full-row-block md-profile-icon-1\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex>\n<input type=\"file\" id=\"pictures\" name=\"pictures\" ngf-select=\"upload($file, $invalidFiles)\" ng-model=\"vm.pictures\" \naccept=\"image/*\" class=\"ng-hide\" ng-change=\"vm.updateProfile(\'profile_pic\')\" ng-model-options=\"{debounce: 500}\" \nngf-pattern=\"\'.jpg,.jpeg,.png,.gif\'\" ngf-accept=\"\'.jpg,.jpeg,.png,.gif\'\" ngf-max-size=\"10MB\"><div \nclass=\"inline-block-txt\" layout=\"row\" layout-align=\"start start\" flex-gt-xs=\"8\"><md-button id=\"uploadButton\" \nclass=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-upload\" class=\"white-fg\"></md-icon></md-button></div>\n<md-input-container flex class=\"md-block inline-block-txt\" flex-gt-xs=\"92\"><input type=\"hidden\" ng-model=\"fileName\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div class=\"hint\"></div></md-input-container></choose-file>\n</md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"75\" flex><div class=\"row-block\" layout=\"column\" \nlayout-gt-xs=\"row\" layout-align=\"start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" \nflex-gt-sm=\"50\" layout-align=\"start start\" class=\"padding-5\" flex><md-input-container flex-gt-xs=\"100\" \nclass=\"md-block tax-inputs\" data-ng-animate=\"1\"><label class=\"ng-scope md-required\" role=\"button\" \ntranslate=\"PROFILE.FIRST_NAME\"></label><input type=\"text\" name=\"first_name\" ng-model=\"vm.profile.first_name\" required \naria-invalid=\"true\" ng-change=\"userForm.first_name.$valid && vm.updateProfile(\'first_name\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" flex-gt-sm=\"50\" layout-align=\"end start\" flex>\n<md-input-container flex-gt-xs=\"100\" class=\"md-block tax-inputs\" data-ng-animate=\"2\"><label \nclass=\"ng-scope md-required\" role=\"button\" translate=\"PROFILE.LAST_NAME\"></label><input type=\"text\" name=\"last_name\" \nng-model=\"vm.profile.last_name\" required aria-invalid=\"true\" \nng-change=\"userForm.last_name.$valid && vm.updateProfile(\'last_name\')\" ng-model-options=\"{debounce: 500}\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div><div class=\"row-block\" \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex><div class=\"row-col padding-right-10 padding-left-10\" \nflex-gt-xs=\"50\" layout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs\" flex-gt-xs=\"100\"><label\n translate=\"PROFILE.PASSWORD\"></label><input ng-model=\"vm.password\" type=\"password\" \nng-change=\"vm.updateProfile(\'password\')\" name=\"password_1\" ng-model-options=\"{debounce: 500}\" min-password \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div ng-messages=\"userForm.password_1.$error\" role=\"alert\"><div \nng-messages=\"userForm.password.$error\"><div ng-message=\"compareTo\"><span translate=\"CONTACTS.MATCH_PASSWORD\"></span>\n</div></div><div ng-message=\"min-password\"><span translate=\"CONTACTS.MIN_PASSWORD\"></span></div></div>\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs\" flex-gt-xs=\"100\"><label \ntranslate=\"PROFILE.CONFIRM_PASSWORD\"></label><input ng-model=\"vm.profile.passwordConfirm\" ng-required=\"vm.password\" \ntype=\"password\" name=\"passwordConfirm\" compare-to=\"vm.password\" ng-change=\"vm.updateProfile(\'passwordConfirm\')\" \nng-model-options=\"{debounce: 500}\" min-password autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div \nng-messages=\"userForm.passwordConfirm.$error\"><div ng-message=\"compareTo\"><span translate=\"CONTACTS.MATCH_PASSWORD\">\n</span></div></div></md-input-container></div></div><div class=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" \nlayout-align=\"start start\" flex><md-input-container flex-gt-xs=\"100\" class=\"md-block tax-inputs\" data-ng-animate=\"2\">\n<label class=\"ng-scope md-required\" role=\"button\" translate=\"PROFILE.FIVE_DIGIT_CODE\"></label><input type=\"numbner\" \nname=\"five_digit_code\" ng-model=\"vm.profile.five_digit_code\" required aria-invalid=\"true\" ng-pattern=\"/^[0-9]{5}$/\" \nng-change=\"userForm.five_digit_code.$valid && vm.updateProfile(\'five_digit_code\')\" ng-model-options=\"{debounce: 500}\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div></div></div></form></div></div></div>\n</div>");
$templateCache.put("app/main/apps/permissions/roles/rolePermission.html","<div id=\"add-contact\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg logo\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"goto-organizations-button md-icon-button\" aria-label=\"Go to customers\" ng-click=\"vm.goToRoles()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nng-if=\"vm.AddForm == false\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\" layout-align=\"start start\">\n<div class=\"h2\">{{ vm.roleName }}</div><div class=\"subtitle secondary-text\"><span translate=\"ROLES.ROLE_DETAIL\"></span>\n</div></div></div><div ng-if=\"vm.AddForm\" layout=\"row\" layout-align=\"start center\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"h2\">{{ \'ROLES.NEW_ROLE\' | translate}}</div></div></div></div></div></div><div>\n<md-button class=\"md-raised md-background\" ng-disabled=\"rolespermissionsForm.$invalid || vm.uniqueName || vm.showAdd\" \nng-click=\"vm.saveHotel()\" \nng-class=\"{\'md-blue-grey-A100-bg\': rolespermissionsForm.$invalid || vm.uniqueName || vm.showAdd}\"><span \ntranslate=\"GROUPS.SAVE\"></span></md-button><md-button class=\"md-raised md-background\"><span translate=\"GROUPS.CANCEL\" \nng-click=\"vm.goToRoles()\"></span></md-button></div></div><div class=\"content scroll-height-sm\"><form \nname=\"rolespermissionsForm\" id=\"rolespermissions\" class=\"md-inline-form scroll-full-height\" novalidate><div \nclass=\"sm-hearder-top scroll-full-height\" ms-scroll><div class=\"widget-group white-bg relative-block white-scroll\" \nlayout=\"row\" flex=\"100\" layout-wrap><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><div layout=\"column\" class=\"rolepadding\" layout-gt-xs=\"row\" flex=\"100\" \nclass=\"layout-gt-xs-row layout-column flex\"><md-input-container flex-gt-xs=\"50\" \nclass=\"md-block tax-inputs padding-left-10 padding-right-10\" data-ng-animate=\"2\"><label \nclass=\"ng-scope md-required margin-left-10\" role=\"button\" for=\"input_128\">{{ \'ROLES.NAME\' | translate }}</label><input \nng-change=\"vm.checkUnique()\" type=\"text\" name=\"role_name\" ng-model=\"vm.roleName\" required id=\"input_128\" \naria-invalid=\"true\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div ng-show=\"vm.uniqueName\" role=\"alert\"><div \nstyle=\"font-size:12px;color:#d60606\"><span>{{ \'ROLES.ROLE_EXISTS\' | translate }}</span></div></div>\n</md-input-container></div><div layout=\"column\" class=\"rolepaddinglr padding-left-20 padding-right-20\" \nlayout-gt-xs=\"row\" flex=\"100\" ng-if=\"vm.itemDisplayed.length\"><div \nclass=\"no-margin padding-left-10 padding-right-10 form-title\" translate=\"ROLES.MANAGE_PERM\"></div></div><ms-widget \nflippable=\"true\" ng-repeat=\"item in vm.itemDisplayed\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front \nclass=\"p-16 white-bg\" layout=\"row\" flex=\"100\" flex><span class=\"font-weight-500 padding-left-10\"><div class=\"col-md-1\">\n<div class=\"tree-block-main-1\"><label class=\"xsm-label\"><md-input-container class=\"no-margin padding-bottom-10\">\n<md-checkbox type=\"checkbox\" class=\"no-margin checkall roles capitalize\" id=\"selectCur{{ $index}}\" \nng-click=\"vm.selectAllModules(item,$index)\" ng-checked=\"item.selected\"><span>{{item.action}}</span></md-checkbox>\n</md-input-container></label><div class=\"tree-block-main-1 tree-block-main-11 margin-top-10\"><div \nclass=\"tree-block-inner-1\" ng-repeat=\"sub in item.subs\"><label class=\"xsm-label\"><md-input-container class=\"no-margin\">\n<md-checkbox type=\"checkbox\" class=\"checkall roles no-margin capitalize\" id=\"selectCurl{{ $index}}\" \nng-click=\"vm.selectModules($parent.$index,$index,$event,\'file\')\" ng-checked=\"sub.selected\">{{sub.action}}</md-checkbox>\n</md-input-container></label><div class=\"tree-block-main-1 tree-block-main-11 margin-top-10\"><div \nclass=\"tree-block-inner-1\" ng-repeat=\"childsub in sub.subs\"><label class=\"xsm-label\"><md-input-container \nclass=\"no-margin\"><md-checkbox type=\"checkbox\" class=\"checkall roles no-margin capitalize\" id=\"selectCurls{{ $index}}\" \nng-click=\"vm.toggleSelectParentModule($event, $parent.$parent.$index,$parent.$index,$index,\'file\')\" \nng-checked=\"childsub.selected\">{{childsub.action}}</md-checkbox></md-input-container></label><div \nclass=\"tree-block-main-1 tree-block-main-11 margin-top-10\"><div class=\"tree-block-inner-1\" \nng-repeat=\"childChildsub in childsub.subs\"><md-input-container class=\"no-margin\"><md-checkbox \nclass=\"roles no-margin capitalize\" ng-checked=\"childChildsub.selected\" \nng-click=\"vm.toggleSelectModule($event,$index,$parent.$index,$parent.$parent.$index,$parent.$parent.$parent.$index)\">\n&nbsp;{{childChildsub.action}}</md-checkbox></md-input-container></div></div></div></div></div></div></div></div>\n</span></ms-widget-front></ms-widget></div></div></form></div></div>");
$templateCache.put("app/main/apps/permissions/roles/roles.html","<div id=\"category\" class=\"lastcolumn_custom_two_icons page-layout simple fullwidth element-doc-page\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"content top-head\"><div class=\"content\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"main\"><div layout=\"row\" layout-align=\"space-between center\" flex><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex-gt-xs=\"25\" flex><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start start\" flex><md-button ng-if=\"vm.hotel_id\" \nclass=\"goto-organizations-button md-icon-button padding-right-5\" aria-label=\"Go to organizations\" \nng-click=\"vm.gotorolesusers()\" translate translate-attr-aria-label=\"EC.GO_TO_ORGANIZATIONS\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"white-fg\"></md-icon></md-button><div layout=\"column\" layout-align=\"start center\" \nflex><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-box\"></md-icon><span>\n{{ \'ROLES.ROLES\' | translate }}</span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"ROLES.TOTAL_ROLES\"></span> <span>{{vm.totalRoles}}</span></div></div></div></div><div class=\"search\" \nlayout=\"column\" layout-align=\"start center\" flex-gt-xs=\"40\" flex><div class=\"common-serch\" layout=\"row\" \nlayout-align=\"start center\" flex-gt-xs=\"100\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon margin-right-0\" layout=\"column\" layout-align=\"start start\" flex-gt-xs=\"5\" flex>\n</md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{ \'SEARCH\' | translate }}\" ng-model=\"filterText\" layout=\"column\" layout-align=\"start start\" \nflex-gt-xs=\"95\" flex></div></div><div class=\"logo\" layout=\"column\" layout-align=\"center end\" flex-gt-xs=\"30\" flex \nng-if=\"vm.userPermissions.indexOf(\'add_role\') != -1\"><md-button class=\"md-raised md-cornered\" \nng-click=\"vm.openContactDialog($event)\"><span><i class=\"icon-plus icon-plus-main\"></i> {{ \'ROLES.ROLE\' | translate }}\n</span></md-button></div></div></div></div></div><div class=\"content\"><div class=\"content\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"main RowClick\" ms-scroll><mdt-table \ntable-card=\"{visible: false, title: \'Roles\'}\" paginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" \nselectable-rows=\"isDeletedAllowed\" alternate-headers=\"\'contextual\'\" selected-row-callback=\"selectedRowCallback(rows)\" \ndelete-row-callback=\"deleteSelectedItem()\" mdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n                    data: vm.tempContact,\n                    \'table-row-id-key\': \'role_id\',\n                    \'column-keys\': [\n                    \'role_name\',\n                    \'role_id\'\n                    ],\n                    }\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'ROLES.NAME\' | translate }}</span>\n</mdt-column><mdt-column align-rule=\"left\"><span>{{ \'ROLES.ACTION\' | translate }}</span></mdt-column></mdt-header-row>\n<mdt-custom-cell html-content=\"true\" column-key=\"role_id\"><mdt-custom-cell-setting \nng-click=\"clientScope.showTabDialog($event, value, rowId)\"></mdt-custom-cell-setting></mdt-custom-cell></mdt-table>\n</div></div></div></div>");
$templateCache.put("app/main/apps/policy/dialog/policyModel.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"ploicyForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"POLICIES.CANCELLATION_PREFERENCE\"></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div><div class=\"contact-name\">\n{{vm.contact.name}}</div><div ng-if=\"vm.error\">{{ vm.error }}</div></md-toolbar><md-dialog-content ms-scroll>\n<md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><md-content class=\"md-padding\">\n<div class=\"md-icon-float md-block\"><label translate=\"POLICIES.GUEST_PERIOD_FREE_CHARGE\" class=\"title-color\"></label>\n<div class=\"radio-block\"><div class=\"radio-inp mt-5\"><md-radio-group ng-model=\"vm.CustomPolicy.if_cancelled_period\" \nng-change=\"vm.cancelPeriodStatus(vm.CustomPolicy.if_cancelled_period)\"><md-radio-button value=\"1\">Yes</md-radio-button>\n<md-radio-button value=\"0\">No</md-radio-button></md-radio-group></div></div></div><div layout=\"row\" flex=\"100\" \nclass=\"mt-20\"><p class=\"mt-0 mb-0 title-color\" ng-if=\"vm.CustomPolicy.if_cancelled_period != 0\" \ntranslate=\"POLICIES.GUEST_ARRIVAL_FREE_CHARGE\"></p><p class=\"mt-0 mb-0 title-color\" \nng-if=\"vm.CustomPolicy.if_cancelled_period == 0\" translate=\"POLICIES.GUEST_CHARGE\"></p></div><md-input-container \nclass=\"md-icon-float md-block mv-0\"><md-select ng-model=\"vm.CustomPolicy.days_free_cancellation\" \nname=\"free_cancellation_days\" placeholder=\"Please select..\" ng-change=\"vm.changeMessage()\" required><md-option \nvalue=\"{{key}}\" ng-repeat=\"(key , cancelTime) in vm.CancellationTime\">{{cancelTime}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><div layout=\"row\" flex=\"100\"><p \nng-if=\"vm.CustomPolicy.if_cancelled_period != 0\" class=\"pv-0 mv-0 title-color\">{{vm.cancellationMessage}}</p></div>\n<md-input-container class=\"md-icon-float md-block mv-0\"><md-select ng-model=\"vm.CustomPolicy.charge_cancellation\" \nname=\"cancellation_charge\" placeholder=\"Please select..\" required><md-option value=\"{{key}}\" \nng-repeat=\"(key, cancelCharge) in vm.cancellationCharge\">{{cancelCharge}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-icon-float md-block mv-0\" \nng-if=\"vm.CustomPolicy.if_cancelled_period ==0\"><p class=\"mv-0 title-color\">{{vm.cancellationMessage1}}</p><md-select \nng-model=\"vm.CustomPolicy.charge_no_free_late_charge\" name=\"cancellation_charge\" placeholder=\"Please select..\" \nrequired><md-option value=\"{{key}}\" ng-repeat=\"(key, cancelCharge) in vm.cancellationChargeifno\">{{cancelCharge}}\n</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container><div class=\"md-icon-float md-block\">\n<label class=\"title-color\" translate=\"POLICIES.EXCEPTION\"></label><div class=\"radio-block\"><div \nclass=\"radio-inp mt-5 mb-10\"><md-radio-group ng-model=\"vm.CustomPolicy.cancellation_exception\" \nng-change=\"vm.cancellationException()\"><md-radio-button value=\"1\">Yes</md-radio-button><md-radio-button value=\"0\">No\n</md-radio-button></md-radio-group></div></div><div ng-show=\"vm.CustomPolicy.cancellation_exception == 1\"><div \nclass=\"repeatblockaddmore\" ng-repeat=\"exception in vm.CustomPolicy.cancellation_charges_exceptions\" \nng-init=\"vm.changeMessage($index)\"><div flex=\"100\" layout=\"row\"><div flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" \nlayout-wrap><div flex=\"100\" layout=\"row\" layout-wrap><div flex=\"100\" layout=\"column\" class=\"mb-5 ph-10\"><p \nclass=\"fontsize-14 mv-0 pv-0\">Start Date</p></div><md-input-container flex=\"33\" layout=\"column\" \nclass=\"padding-left-10 padding-right-10 full-width md-block\"><label class=\"margin-left-10\" \ntranslate=\"POLICIES.EXCEPTIONDAY\"></label><md-select \nng-model=\"vm.CustomPolicy.cancellation_charges_exceptions[$index].exception_start_day\" name=\"cancellation_charge\" \nng-required=\"vm.CustomPolicy.cancellation_exception == 1\"><md-option value=\"{{day}}\" ng-repeat=\"day in vm.days\">{{day}}\n</md-option></md-select></md-input-container><md-input-container flex=\"33\" layout=\"column\" \nclass=\"padding-left-10 padding-right-10 full-width md-block\"><label class=\"margin-left-10\" \ntranslate=\"POLICIES.EXCEPTIONMONTH\"></label><md-select \nng-model=\"vm.CustomPolicy.cancellation_charges_exceptions[$index].exception_start_month\" name=\"cancellation_charge\" \nng-required=\"vm.CustomPolicy.cancellation_exception == 1\"><md-option value=\"{{month}}\" ng-repeat=\"month in vm.months\">\n{{vm.monthnames[$index]}}</md-option></md-select></md-input-container><md-input-container flex=\"33\" layout=\"column\" \nclass=\"padding-left-10 padding-right-10 full-width md-block\"><label class=\"margin-left-10\" \ntranslate=\"POLICIES.EXCEPTIONYEAR\"></label><md-select \nng-model=\"vm.CustomPolicy.cancellation_charges_exceptions[$index].exception_start_year\" name=\"cancellation_charge\" \nng-required=\"vm.CustomPolicy.cancellation_exception == 1\"><md-option value=\"{{year}}\" ng-repeat=\"year in vm.years\">\n{{year}}</md-option></md-select></md-input-container></div></div><div flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" \nlayout-wrap><div flex=\"100\" layout=\"row\" layout-wrap><div flex=\"100\" layout=\"column\" class=\"mb-5 ph-10\"><p \nclass=\"fontsize-14 mv-0 pv-0\">End Date</p></div><md-input-container flex=\"33\" layout=\"column\" \nclass=\"padding-left-10 padding-right-10 full-width md-block\"><label class=\"margin-left-10\" \ntranslate=\"POLICIES.EXCEPTIONDAY\"></label><md-select \nng-model=\"vm.CustomPolicy.cancellation_charges_exceptions[$index].exception_end_day\" name=\"cancellation_charge\" \nng-required=\"vm.CustomPolicy.cancellation_exception == 1\"><md-option value=\"{{day}}\" ng-repeat=\"day in vm.days\">{{day}}\n</md-option></md-select></md-input-container><md-input-container flex=\"33\" layout=\"column\" \nclass=\"padding-left-10 padding-right-10 full-width md-block\"><label class=\"margin-left-10\" \ntranslate=\"POLICIES.EXCEPTIONMONTH\"></label><md-select \nng-model=\"vm.CustomPolicy.cancellation_charges_exceptions[$index].exception_end_month\" name=\"cancellation_charge\" \nng-required=\"vm.CustomPolicy.cancellation_exception == 1\"><md-option value=\"{{month}}\" ng-repeat=\"month in vm.months\">\n{{vm.monthnames[$index]}}</md-option></md-select></md-input-container><md-input-container flex=\"33\" layout=\"column\" \nclass=\"padding-left-10 padding-right-10 full-width md-block\"><label class=\"margin-left-10\" \ntranslate=\"POLICIES.EXCEPTIONYEAR\"></label><md-select \nng-model=\"vm.CustomPolicy.cancellation_charges_exceptions[$index].exception_end_year\" name=\"cancellation_charge\" \nng-required=\"vm.CustomPolicy.cancellation_exception == 1\"><md-option value=\"{{year}}\" ng-repeat=\"year in vm.years\">\n{{year}}</md-option></md-select></md-input-container></div></div></div><md-icon class=\"ph-10 mv-10\" \nng-show=\"$index == 0\" md-font-icon=\"icon-plus-circle md-accent-fg\" ng-click=\"vm.addMultipleExceptions()\" \nclass=\"onlycursorPointer mdplusiconmain\"></md-icon><md-icon \nng-show=\"vm.CustomPolicy.cancellation_charges_exceptions.length > 1 && $index > 0\" \nmd-font-icon=\"icon-minus-circle md-accent-fg\" ng-click=\"vm.deleteMultipleExceptions($index)\" \nclass=\"onlycursorPointer mdplusiconmain\"></md-icon><div class=\"md-icon-float md-block ph-10 pb-20\"><label \nclass=\"title-color\" translate=\"POLICIES.GUEST_PERIOD_FREE_CHARGE\"></label><div class=\"radio-block\"><div \nclass=\"radio-inp\"><md-radio-group \nng-model=\"vm.CustomPolicy.cancellation_charges_exceptions[$index].if_cancelled_period\" \nng-change=\"vm.cancelPeriodStatus(vm.CustomPolicy.cancellation_charges_exceptions[$index].if_cancelled_period)\">\n<md-radio-button value=\"1\">Yes</md-radio-button><md-radio-button value=\"0\">No</md-radio-button></md-radio-group></div>\n</div></div><md-input-container class=\"ph-10 md-icon-float md-block mv-0\"><p class=\"title-color mt-0 mb-0\" \nng-if=\"vm.CustomPolicy.cancellation_charges_exceptions[$index].if_cancelled_period != 0\" \ntranslate=\"POLICIES.GUEST_ARRIVAL_FREE_CHARGE\"></p><p class=\"title-color mt-0 mb-0\" \nng-if=\"vm.CustomPolicy.cancellation_charges_exceptions[$index].if_cancelled_period == 0\" \ntranslate=\"POLICIES.GUEST_CHARGE\"></p><md-select \nng-model=\"vm.CustomPolicy.cancellation_charges_exceptions[$index].days_free_cancellation\" \nname=\"free_cancellation_days\" placeholder=\"Please select..\" ng-change=\"vm.changeMessage($index)\" \nng-required=\"vm.CustomPolicy.cancellation_exception == 1\"><md-option value=\"{{key}}\" \nng-repeat=\"(key , cancelTime) in vm.CancellationTime\">{{cancelTime}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"ph-10 mv-0 md-icon-float md-block\"><p \nclass=\"title-color\" ng-if=\"vm.CustomPolicy.cancellation_charges_exceptions[$index].if_cancelled_period != 0\">\n{{vm.cancellationMessage}}</p><md-select \nng-model=\"vm.CustomPolicy.cancellation_charges_exceptions[$index].charge_cancellation\" name=\"cancellation_charge\" \nplaceholder=\"Please select..\" ng-required=\"vm.CustomPolicy.cancellation_exception == 1\"><md-option value=\"{{key}}\" \nng-repeat=\"(key, cancelCharge) in vm.cancellationCharge\">{{cancelCharge}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-icon-float md-block ph-10 mv-0\" \nng-if=\"vm.CustomPolicy.cancellation_charges_exceptions[$index].if_cancelled_period ==0\"><p class=\"mv-0 title-color\">\n{{vm.cancellationMessages[$index]}}</p><md-select \nng-model=\"vm.CustomPolicy.cancellation_charges_exceptions[$index].charge_no_free_late_charge\" \nname=\"cancellation_charge\" placeholder=\"Please select..\" ng-required=\"vm.CustomPolicy.cancellation_exception == 1\">\n<md-option value=\"{{key}}\" ng-repeat=\"(key, cancelCharge) in vm.cancellationChargeifno\">{{cancelCharge}}</md-option>\n</md-select><div class=\"md-errors-spacer\"></div></md-input-container></div></div></div></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" \nng-click=\"vm.pageStatus == \'add\' ? vm.saveCustomPolicy() : vm.updateCustomPolicyData()\" \nng-class=\"!ploicyForm.$invalid && !ploicyForm.$pristine?\'md-raised md-green-500-bg submit-button white-fg\':\'md-raised md-accent submit-button grey-100-fg\'\" \nng-disabled=\"ploicyForm.$invalid || ploicyForm.$pristine\" aria-label=\"SAVE\" translate=\"SAVE\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/promotions/promotion/promotion.html","<div id=\"promotion-addedit\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" \nng-click=\"vm.gotoPromotions()\" translate translate-attr-aria-label=\"SETTINGS.GO_TO_TEMP\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"column\" layout-align=\"start start\" flex><div class=\"h2\">{{vm.title}}</div><div class=\"subtitle secondary-text\" \nng-show=\"vm.actionType != \'add\'\"><span translate=\"PROMOTION.PROMOTIONS\"></span></div></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.savePromotion();\" \nng-disabled=\"promotionForm.$invalid || promotionForm.$pristine || vm.uniqueError || vm.hasInvalidProductDiscounts()\" \nng-class=\"{\'md-blue-grey-A100-bg\': promotionForm.$invalid || promotionForm.$pristine || vm.uniqueError || vm.hasInvalidProductDiscounts()}\">\n<span translate=\"GROUPS.SAVE\"></span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"vm.gotoPromotions();\"><span translate=\"GROUPS.CANCEL\"></span></md-button></div></div></div></div><div \nclass=\"content scroll-height-sm\"><div class=\"main sm-hearder-top scroll-full-height\" ms-scroll><form \nname=\"promotionForm\" class=\"md-inline-form\" novalidate><div \nclass=\"white-bg md-whiteframe-4dp white-scroll relative-block margin-bottom-10\" layout-align=\"center center\" \nlayout-padding><div class=\"form-title no-padding margin-top-10 margin-left-20 margin-right-20\" \ntranslate=\"PROMOTION.DETAILS\"></div><div class=\"row-block-new\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start start\" flex><div class=\"layout-colo-block padding-left-10 padding-right-10 full-width\" flex=\"100\" \nflex-gt-sm=\"50\"><md-input-container class=\"md-block m-b-0\"><label translate=\"PROMOTION.NAME\"></label><input required \nname=\"name\" type=\"text\" ng-model=\"vm.promotion.promotion_name\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div><div class=\"layout-colo-block padding-left-10 padding-right-10 full-width\" flex=\"100\" \nflex-gt-sm=\"50\"><md-input-container class=\"md-block md-input-has-value\"><label translate=\"PROMOTION.STATUS\"></label>\n<md-radio-group required ng-model=\"vm.promotion.promotion_status\"><md-radio-button value=\"1\">\n{{ \'PROMOTION.ENABLED\' | translate }}</md-radio-button><md-radio-button value=\"0\" class=\"margin-left-15\">\n{{ \'PROMOTION.DISABLED\' | translate }}</md-radio-button></md-radio-group><div class=\"md-errors-spacer\"></div>\n</md-input-container></div></div><div class=\"row-block-new no-padding\" layout=\"row\" layout-align=\"start start\" \nlayout-wrap flex><div class=\"layout-colo-block padding-left-20 padding-right-20 full-width\" layout=\"column\" flex=\"60\" \nflex-xs=\"100\"><div class=\"row-block-new no-padding\" layout=\"row\" layout-align=\"start start\" layout-wrap flex>\n<md-input-container ng-show=\"vm.isAdd\" class=\"md-block md-input-has-value\" flex flex-gt-sm=\"30\" layout=\"column\" \nflex=\"100\" style=\"display: none\"><label translate=\"PROMOTION.CODEREQ\"></label><md-radio-group required \nng-model=\"vm.promotion.promotion_code_required\"><md-radio-button value=\"1\">{{ \'PROMOTION.YES\' | translate }}\n</md-radio-button><md-radio-button value=\"0\" class=\"margin-left-20\">{{ \'PROMOTION.NO\' | translate }}</md-radio-button>\n</md-radio-group><div class=\"md-errors-spacer\"></div></md-input-container><div \nclass=\"layout-colo-block padding-right-10 full-width\" flex=\"100\" flex flex-gt-sm=\"70\" layout=\"column\"><div \nng-if=\"vm.promotion.promotion_code_required == 1\"><md-input-container class=\"md-block\" style=\"max-width:250px\"><label \ntranslate=\"PROMOTION.CODE\"></label><input required name=\"name\" type=\"text\" ng-change=\"vm.checkUniquePromoCode()\" \nng-model=\"vm.promotion.promotion_code\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\" \nng-model-options=\"{debounce: 500}\"><div ng-if=\"vm.uniqueError\" role=\"alert\"><div style=\"font-size:12px;color:#d60606\">\n<span translate=\"PROMOTION.CODEEXIST\"></span></div></div><div class=\"md-errors-spacer\"></div></md-input-container>\n</div></div></div></div></div></div><div style=\"display:none\" \nclass=\"white-bg md-whiteframe-4dp white-scroll relative-block margin-bottom-10\" layout-align=\"center center\" \nlayout-padding \nng-if=\"(vm.promotion.promotion_type_id == 2) || (vm.promotion.promotion_type_id == 4) || ((vm.promotion.promotion_type_id == 1 || vm.promotion.promotion_type_id == 2) && (vm.promotion.promotion_code_required == \'1\'))\">\n<div class=\"row-block-new\" layout=\"row\" layout-align=\"start start\" layout-wrap flex style=\"display: none\"><div \nclass=\"layout-colo-block padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"100\"><div \nclass=\"form-title\" translate=\"PROMOTION.PTYPE\"></div><div layout=\"row\" layout-align=\"space-between center\" layout-wrap \nflex><div class=\"white-bg padding-left-20 padding-right-20 margin-bottom-20 block-4-content\" style=\"cursor:pointer\" \nng-click=\"vm.promotionType(type.promotion_type_id)\" \nng-class=\"{\'selected\': type.promotion_type_id == vm.promotion.promotion_type_id,\'not-enabled\':vm.actionType == \'edit\'}\" \nng-repeat=\"type in vm.types\" layout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-sm=\"50\"><div \nclass=\"block-header capitalize\" layout=\"row\" flex layout-align=\"start center\"><div flex layout=\"column\" flex=\"100\"><div\n class=\"basic-info-block\"><md-icon md-font-icon=\"{{ type.promotion_icon}}\" class=\"s50\"></md-icon><span>\n{{ type.promotion_type }}</span></div></div></div></div></div></div></div><div \nclass=\"inner-section-open margin-bottom-10\" ng-if=\"vm.promotion.promotion_type_id == 2\"><div class=\"row-block-new\" \nlayout=\"row\" layout-align=\"start start\" flex><div class=\"layout-colo-block padding-left-10 padding-right-10\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"100\"><div class=\"form-title\" translate=\"PROMOTION.WHENBOOK\"></div><div>\n<md-radio-group required ng-model=\"vm.lastmindeal\" ng-change=\"vm.checkLastMin(vm.lastmindeal)\" \nng-model-options=\"{debounce: 500}\" class=\"row-block-group\" layout=\"row\" layout-align=\"start start\" flex \nflex-gt-xs=\"50\"><md-radio-button value=\"1\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" class=\"padding-bottom-20\">\n<md-input-container class=\"md-block no-margin\" flex><input ng-required=\"vm.lastmindeal == 1\" \nng-model=\"vm.promotion.promotion_last_min_days\" name=\"name\" type=\"number\" step=\"1\" ng-model-options=\"{debounce: 500}\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container><span flex translate=\"PROMOTION.DAYS\"></span>\n</md-radio-button><md-radio-button value=\"2\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" class=\"padding-bottom-20\">\n<md-input-container class=\"md-block no-margin\" flex><input ng-required=\"vm.lastmindeal == 2\" name=\"name\" type=\"number\" \nstep=\"1\" max=\"24\" ng-model=\"vm.promotion.promotion_last_min_hours\" \nng-change=\"vm.checkHours(vm.promotion.promotion_last_min_hours)\" ng-model-options=\"{debounce: 500}\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container><span flex translate=\"PROMOTION.HOURS\"></span>\n</md-radio-button></md-radio-group></div></div></div></div><div class=\"inner-section-open margin-bottom-10\" \nng-if=\"vm.promotion.promotion_type_id == 4\"><div class=\"row-block-new\" layout=\"row\" layout-align=\"start start\" flex>\n<div class=\"layout-colo-block no-padding\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><div \nclass=\"form-title margin-left-10\" translate=\"PROMOTION.FREENIGHTSCONF\"></div><div layout=\"row\" \nlayout-align=\"start start\" flex=\"100\" flex-gt-xs=\"100\"><md-input-container \nclass=\"md-block padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><label \nclass=\"margin-left-10\" translate=\"PROMOTION.PAIDNIGHTS\"></label><md-select ng-model=\"vm.promotion.free_night_booked\">\n<md-option value=\"{{key}}\" ng-repeat=\"(key, value) in vm.days\">{{ value }}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container \nclass=\"md-block padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><label \nclass=\"margin-left-10\" translate=\"PROMOTION.FREENIGHTS\"></label><md-select ng-model=\"vm.promotion.free_night_recieved\">\n<md-option value=\"{{key}}\" ng-repeat=\"(key, value) in vm.days\">{{ value }}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></div></div></div><div \nclass=\"inner-section-open margin-bottom-10\" \nng-if=\"(vm.promotion.promotion_type_id == 1 || vm.promotion.promotion_type_id == 2) && (vm.promotion.promotion_code_required == \'1\')\">\n<div class=\"row-block-new\" layout=\"row\" layout-align=\"start start\" flex layout-wrap><div class=\"layout-colo-block\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><div class=\"form-title margin-left-20 margin-bottom-10\" \ntranslate=\"PROMOTION.CANSEE\"></div><div layout=\"row\" layout-align=\"space-between center\" layout-wrap flex><div \nclass=\"padding-left-20 padding-right-20 margin-bottom-20 block-4-content\" style=\"cursor:pointer\" \nng-class=\"{\'selected\': \'all\' == vm.promotion.promotion_customer_type}\" ng-click=\"vm.customerType(\'all\')\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><div class=\"white-bg block-header\" layout=\"row\" flex \nlayout-align=\"start center\"><div flex layout=\"column\" flex=\"100\"><div class=\"basic-info-block\"><md-icon \nmd-font-icon=\"icon-account\" class=\"s50\"></md-icon><span translate=\"PROMOTION.EVERYONE\"></span></div></div></div></div>\n<div class=\"padding-left-20 padding-right-20 margin-bottom-20 block-4-content\" style=\"cursor:pointer\" \nng-class=\"{\'selected\': \'login\' == vm.promotion.promotion_customer_type}\" ng-click=\"vm.customerType(\'login\')\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><div class=\"white-bg block-header\" layout=\"row\" flex \nlayout-align=\"start center\"><div flex layout=\"column\" flex=\"100\"><div class=\"basic-info-block\"><md-icon \nmd-font-icon=\"icon-account-key\" class=\"s50\"></md-icon><span translate=\"PROMOTION.LOGIN\"></span></div></div></div></div>\n</div></div></div></div></div><div style=\"display:none\" \nclass=\"white-bg md-whiteframe-4dp white-scroll relative-block margin-bottom-10\" layout-align=\"center center\" \nlayout-padding><div class=\"row-block-new\" layout=\"row\" layout-align=\"start start\" flex layout-wrap><div \nclass=\"layout-colo-block\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><div \nclass=\"form-title margin-left-10 margin-bottom-10\" translate=\"PROMOTION.USETYPE\"></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex layout-wrap><div \nclass=\"padding-left-20 padding-right-20 margin-bottom-20 block-4-content\" style=\"cursor:pointer\" \nng-class=\"{\'selected\': 0 == vm.promotion.promotion_single_use}\" ng-click=\"vm.singleUse(0)\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\"><div class=\"block-header capitalize\" layout=\"row\" flex layout-align=\"start center\"><div flex \nlayout=\"column\" flex=\"100\"><div class=\"basic-info-block\"><md-icon md-font-icon=\"icon-account-multiple-outline\" \nclass=\"s50\"></md-icon><span translate=\"PROMOTION.MULTIPLE\"></span></div></div></div></div><div \nclass=\"padding-left-20 padding-right-20 margin-bottom-20 block-4-content\" style=\"cursor:pointer\" \nng-class=\"{\'selected\': 1 == vm.promotion.promotion_single_use}\" ng-click=\"vm.singleUse(1)\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\"><div class=\"block-header capitalize\" layout=\"row\" flex layout-align=\"start center\"><div flex \nlayout=\"column\" flex=\"100\"><div class=\"basic-info-block\"><md-icon md-font-icon=\"icon-account-outline\" class=\"s50\">\n</md-icon><span translate=\"PROMOTION.SINGLE\"></span></div></div></div></div></div></div></div></div><div \nclass=\"white-bg md-whiteframe-4dp white-scroll relative-block margin-bottom-10 padding-top-20\" \nlayout-align=\"center center\" ng-if=\"vm.promotion.promotion_type_id != 4\" layout-padding><div \nclass=\"row-block-new padding-top-20\" layout=\"row\" layout-align=\"start start\" flex \nng-if=\"vm.promotion.promotion_type_id != 3 && vm.promotion.promotion_code_required == \'1\'\"><div \nclass=\"layout-colo-block padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\">\n<md-input-container class=\"md-block no-margin padding-top-10 padding-bottom-10\"><label translate=\"PROMOTION.MINSTAY\">\n</label><md-select ng-model=\"vm.promotion.promotion_min_stay\" ng-change=\"vm.min_stay_changed()\"><md-option value=\"0\">0\n</md-option><md-option value=\"1\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3</md-option>\n<md-option value=\"7\">7</md-option><md-option value=\"28\">28</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container></div></div></div><div \nclass=\"white-bg md-whiteframe-4dp white-scroll relative-block margin-bottom-10\" layout-align=\"center center\" \nlayout-padding ng-if=\"vm.promotion.promotion_code_required == \'1\'\" id=\"appliedProducts\"><div \nclass=\"form-title margin-left-10\">On which products you want to apply the promotion?</div><div \nclass=\"accord-product-block-outer-main\"><div class=\"row-block-new accord-product-block\" \nng-class=\"{\'open\': value.openClass, \'threeblock\':value.list.length == 0}\" ng-repeat=\"(key, value) in vm.productsList\">\n<div class=\"form-title-new margin-left-10\" ng-click=\"vm.openProductsList(value, key)\"><div class=\"arrow-block\" \nng-if=\"value.list.length > 0\"></div>{{value.name}} <span ng-if=\"value.subName\" \nstyle=\"width: 100%; float: left; font-size: 12px; opacity: 0.7\">{{value.subName}}</span></div><div \nclass=\"row-block-new\" layout=\"row\" layout-align=\"start start\" ng-class=\"vm.showErrorBorder ? \'red-border\' : \'\'\"><div \nclass=\"layout-colo-block padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"100\"><div \nng-repeat=\"(listKey, list) in value.list\" class=\"layout-colo-col new-promo-rules\"><div class=\"room-names\"><span \nclass=\"room-name\">{{ list.name }}</span><div class=\"promotion-selection-block\"><div class=\"promotion-value\"><div \nclass=\"combined-discount-control\"><md-input-container class=\"combo-type\" \nng-class=\"{\'custom\': list.discount.customMode}\"><md-select ng-model=\"list.discount.type\" \nng-init=\"list.discount.type = (list.discount.type ? list.discount.type : \'percent\')\" \nng-change=\"vm.saveProductFormat(list, value)\"><md-option value=\"percent\">%</md-option><md-option value=\"amount\">$\n</md-option></md-select></md-input-container><md-input-container ng-if=\"!list.discount.customMode\" class=\"combo-input\">\n<input type=\"text\" ng-model=\"list.discount.singleValue\" ng-change=\"vm.saveProductFormat(list)\" \nng-init=\"list.discount.singleValue = (list.discount.singleValue ? list.discount.value.Mon : null)\">\n</md-input-container></div></div><button class=\"toggle-btn\" ng-click=\"vm.toggleCustomMode(list)\"><img \nng-src=\"{{ \'assets/icons/\' + (list.discount.customMode ? \'eye-hide.png\' : \'custom-icon.png\') }}\">\n {{ list.discount.customMode ? \"Hide Custom\" : \"Custom by Day\" }}</button></div></div><div class=\"new-promotion-block\">\n<div ng-if=\"list.discount.customMode\"><table style=\"width:100%; text-align:center; border-collapse:collapse\"><tr><th \nng-repeat=\"day in vm.weekList\">{{ day.label }}</th></tr><tr><td ng-repeat=\"day in vm.weekList\"><md-input-container \nstyle=\"margin:0; width:70px\"><input type=\"text\" ng-model=\"list.discount.value[day.key]\" \nng-change=\"vm.saveCustomDayValues(list, day.key)\" style=\"text-align:center\"></md-input-container></td></tr></table><div\n class=\"error-block\" role=\"alert\" ng-show=\"list.discount._customInvalid\"><span>Please enter valid numbers for all days.\n</span></div></div></div></div></div></div></div></div></div><div \nclass=\"white-bg md-whiteframe-4dp white-scroll relative-block margin-bottom-10\" layout-align=\"center center\" \nlayout-padding ng-if=\"vm.promotion.promotion_code_required == \'1\' && vm.promotion.isVal\"><div class=\"row-block-new\" \nflex ng-if=\"vm.promotion.promotion_code_required == \'1\'\"><div class=\"form-title margin-left-10\" \ntranslate=\"PROMOTION.WHICHRATES\"></div><div class=\"row-block-new\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"layout-colo-block padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"100\"><div \nng-if=\"rateplan.rate_plan_min_stay >= vm.promotion.promotion_min_stay\" ng-repeat=\"rateplan in vm.ratePlans\">\n<md-checkbox class=\"capitalize padding-top-5 padding-bottom-5 no-margin\" \nng-checked=\"vm.selectedRatePlans.indexOf(rateplan.rate_plan_id) >= 0\" \nng-click=\"vm.toggle(rateplan, vm.selectedRatePlans, \'rate_plan_id\');vm.rateplanChanged();\">\n{{ rateplan.rate_plan_name }}</md-checkbox></div></div></div></div><div class=\"row-block-new\" \nng-if=\"vm.selectedRatePlans.length != 0\" flex><div class=\"form-title margin-left-10\" translate=\"PROMOTION.WHICHROOMS\">\n</div><div class=\"row-block-new\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"layout-colo-block padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"100\"><div \nng-repeat=\"roomtype in vm.roomTypes\"><md-checkbox ng-if=\"roomtype.hotel_title\" \nclass=\"capitalize no-margin padding-bottom-10 padding-top-10\" \nng-checked=\"vm.selectedRoomTypes.indexOf(roomtype.room_type_id) >= 0\" \nng-click=\"vm.toggle(roomtype, vm.selectedRoomTypes, \'room_type_id\');vm.roomtypeChanged();\">\n{{ roomtype.room_type_name }} {{roomtype.hotel_title}}</md-checkbox><md-checkbox ng-if=\"!roomtype.hotel_title\" \nclass=\"capitalize no-margin padding-bottom-10 padding-top-10\" \nng-checked=\"vm.selectedRoomTypes.indexOf(roomtype.room_type_id) >= 0\" \nng-click=\"vm.toggle(roomtype, vm.selectedRoomTypes, \'room_type_id\');vm.roomtypeChanged();\">\n{{ roomtype.room_type_name }}</md-checkbox></div></div></div></div></div><div \nclass=\"white-bg md-whiteframe-4dp white-scroll relative-block\" layout-align=\"center center\" layout-padding><div \nclass=\"row-block-new md-datepicker\"><div class=\"form-title margin-left-10\" translate=\"PROMOTION.WHENSTAY\"></div><div \nclass=\"row-block-new\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"layout-colo-block padding-left-10 padding-right-10 margin-bottom-30\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\">\n<label class=\"ng-scope\">From</label><md-datepicker ng-if=\"vm.actionType == \'edit\'\" \nng-model=\"vm.promotion.promotion_checkin_date\" ng-change=\"vm.changeMinDate()\" class=\"full-width\"></md-datepicker>\n<md-datepicker ng-if=\"vm.actionType == \'add\'\" ng-model=\"vm.promotion.promotion_checkin_date\" \nng-change=\"vm.changeMinDate()\" md-min-date=\"vm.minDate\" class=\"full-width\"></md-datepicker><div \nclass=\"md-error-spacer\"></div></div><div class=\"layout-colo-block padding-left-10 padding-right-10 margin-bottom-30\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><label class=\"ng-scope\">To</label><md-datepicker \nng-model=\"vm.promotion.promotion_checkout_date\" md-min-date=\"vm.minDate1\" class=\"full-width\"></md-datepicker><div \nclass=\"md-error-spacer\"></div></div></div></div><div class=\"row-block-new md-datepicker\"><div \nclass=\"form-title margin-left-10\" translate=\"PROMOTION.BOOKING_CREATED\"></div><div class=\"row-block-new\" layout=\"row\" \nlayout-align=\"start start\" layout-wrap><div \nclass=\"layout-colo-block padding-left-10 padding-right-10 margin-bottom-30\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\">\n<label class=\"ng-scope\">From</label><md-datepicker ng-if=\"vm.actionType == \'edit\'\" \nng-model=\"vm.promotion.booking_created_from\" ng-change=\"vm.changeBookingCreatedMinDate()\" class=\"full-width\">\n</md-datepicker><md-datepicker ng-if=\"vm.actionType == \'add\'\" ng-model=\"vm.promotion.booking_created_from\" \nng-change=\"vm.changeBookingCreatedMinDate()\" md-min-date=\"vm.minDate\" class=\"full-width\"></md-datepicker><div \nclass=\"md-error-spacer\"></div></div><div class=\"layout-colo-block padding-left-10 padding-right-10 margin-bottom-30\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\"><label class=\"ng-scope\">To</label><md-datepicker \nng-model=\"vm.promotion.booking_created_to\" md-min-date=\"vm.minBookingDate\" class=\"full-width\"></md-datepicker><div \nclass=\"md-error-spacer\"></div></div></div></div></div></form></div></div></div>");
$templateCache.put("app/main/apps/rateCalendarLogs/dialogs/rate-calender-logs-dialog.html","<md-dialog class=\"role-dialog rate-calendar-dialog\" aria-label=\"New Task\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"header-wrapper\" layout=\"column\" layout-align=\"center start\"><div \nclass=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-chart-line\" class=\"mr-10\">\n</md-icon><span>Log Details</span></div><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></div><div class=\"calendar-log\">\n<md-table-container><table class=\"simple simple-log\" cellpadding=\"0\" cellspacing=\"0\"><thead><tr \nclass=\"headerrow capitalize headingoutertb\"><th>Sr. No</th><th>Room Type</th><th>Rate Plan</th><th>Channel Name</th>\n<th>Date</th><th>Old Value</th><th>New Value</th></tr></thead><tbody><tr \nng-repeat=\"log in vm.logDetails track by $index\" ng-if=\"vm.logDetails.length > 0\" \nng-class=\"{\'has-scroll\': vm.hasScroll()}\"><td>{{$index + 1}}</td><td>{{log.room_type_name}}</td><td>{{log.rate_plan}}\n</td><td>{{log.channel}}</td><td>{{ log.date | date:\'MM-dd-yyyy\' }}</td><td>\n{{ (log.old_value === \'$0.00\' || log.old_value === \'0\' || log.old_value === 0) ? \'-\' : log.old_value }}</td><td>\n{{log.new_value}}</td></tr><tr ng-if=\"vm.logDetails.length == 0\"><td colspan=\"7\" class=\"no-record\">No record found</td>\n</tr></tbody></table></md-table-container></div></md-dialog>");
$templateCache.put("app/main/apps/rateCategory/dialog/rateCategoryModel.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"ploicyForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div><div class=\"contact-name\">{{vm.contact.name}}\n</div><div ng-if=\"vm.error\">{{ vm.error }}</div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><md-content class=\"md-padding margin-top\"><div class=\"md-icon-float md-block\"><label>\nIs there a period when the guest can cancel free of charge?</label><md-icon></md-icon><div class=\"radio-block\"><div \nclass=\"radio-inp\"><input ng-model=\"vm.CustomPolicy.if_cancelled_period\" type=\"radio\" value=\"1\" name=\"option\"><span>Yes\n</span></div><div class=\"radio-inp\"><input ng-model=\"vm.CustomPolicy.if_cancelled_period\" type=\"radio\" value=\"0\" \nname=\"option\"><span>No</span></div><div></div><md-input-container class=\"md-icon-float md-block\"><label>\nHow long before arrival can the guest cancel free of charge?</label><md-select \nng-model=\"vm.CustomPolicy.days_free_cancellation\" name=\"free_cancellation_days\" required><md-option value=\"{{key}}\" \nng-repeat=\"(key , cancelTime) in vm.CancellationTime\">{{cancelTime}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block\"><label>How much is the guest charged for cancellation?</label>\n<md-select ng-model=\"vm.CustomPolicy.charge_cancellation\" name=\"cancellation_charge\" required><md-option \nvalue=\"{{key}}\" ng-repeat=\"(key, cancelCharge) in vm.cancellationCharge\">{{cancelCharge}}</md-option></md-select>\n</md-input-container></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\"><md-button type=\"submit\" \nng-click=\"vm.saveCustomPolicy()\" \nng-class=\"!ploicyForm.$invalid && !ploicyForm.$pristine?\'md-raised md-green-500-bg submit-button white-fg\':\'md-raised md-accent submit-button grey-100-fg\'\" \nng-disabled=\"ploicyForm.$invalid || ploicyForm.$pristine\" aria-label=\"SAVE\">ADD</md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/apps/rentalListing/dialog/mlsModel.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"mlsForm\" id=\"mlsForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" ng-if=\"vm.pageStatus == \'add\'\" translate=\"MLS.NEW_MLS\"></span> <span class=\"title\" \nng-if=\"vm.pageStatus != \'add\'\" translate=\"MLS.UPDATE_MLS\"></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div><div class=\"contact-name\">\n{{vm.contact.name}}</div><div ng-if=\"vm.error\">{{ vm.error }}</div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><md-content class=\"md-padding\" layout=\"row\" layout-wrap><div layout=\"column\" flex-gt-xs=\"50\" \nflex=\"100\"><md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" \nrole=\"button\" translate=\"MLS.FROM\"></label><md-datepicker class=\"birthday-input1 no-padding\" md-min-date=\"vm.minDate\" \nmd-max-date=\"vm.mls.mls_to\" ng-model=\"vm.mls.mls_from\" md-open-on-focus ng-model-options=\"{debounce: 500}\" required>\n</md-datepicker></md-input-container></div><div layout=\"column\" flex-gt-xs=\"50\" flex=\"100\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" flex-gt-xs=\"100\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"MLS.TO\"></label><md-datepicker class=\"birthday-input1 no-padding\" md-min-date=\"vm.mls.mls_from\" \nng-model=\"vm.mls.mls_to\" md-open-on-focus ng-model-options=\"{debounce: 500}\" required></md-datepicker>\n</md-input-container></div><div layout=\"column\" flex-gt-xs=\"100\" flex=\"100\"><md-input-container \nclass=\"md-block tax-inputs mb-0\" flex-gt-xs=\"100\"><label class=\"ng-scope md-required\" role=\"button\" \ntranslate=\"MLS.MIN_STAY\"></label><input type=\"number\" name=\"minday\" ng-change=\"vm.validateDayCount()\" \nng-model=\"vm.mls.mls_days\" required aria-invalid=\"true\"><div><div><span>{{vm.dayCountErrorMsg}}</span></div></div>\n</md-input-container></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" \nng-click=\"vm.pageStatus == \'add\' ? vm.saveMls() : vm.updateMls()\" \nng-class=\"!vm.mls.mls_to || !vm.mls.mls_to || vm.requestProgressing || !vm.mls.mls_days || mlsForm.$pristine?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"!vm.mls.mls_to || !vm.mls.mls_to || vm.requestProgressing || !vm.mls.mls_days || mlsForm.$pristine\" \naria-label=\"SAVE\" translate=\"GROUPS.SAVE\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/rentalListing/dialog/updateStatus.html","<md-dialog class=\"contact-dialog pending-dilog\" aria-label=\"New Task\"><form name=\"mlsForm\" id=\"mlsForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Application Status</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div><div class=\"contact-name\">{{vm.contact.name}}\n</div><div ng-if=\"vm.error\">{{ vm.error }}</div></md-toolbar><md-dialog-content ms-scroll style=\"width:100%\">\n<md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><md-content class=\"md-padding\" \nlayout=\"row\" layout-wrap><md-input-container class=\"md-block tax-inputs ph-10\" flex=\"100\" layout=\"column\" \nlayout-align=\"start start\"><label class=\"ml-10\" role=\"button\">Application Status</label><md-select \nng-model=\"vm.application_status\" ng-change=\"vm.updateStatus()\"><md-option value=\"pending\">Pending</md-option><md-option\n value=\"reject\">Reject</md-option></md-select></md-input-container></md-content></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button \ntype=\"submit\" ng-click=\"vm.updateStatus()\" ng-class=\"\'md-raised md-green-500-bg submit-button white-fg\'\" \naria-label=\"SAVE\" translate=\"GROUPS.SAVE\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/rateRule/dialogs/bulk-update-dialog.html","<md-dialog class=\"role-dialog bulkRateForm\" aria-label=\"New Task\" style=\"max-width:870px;width: 100%\"><form \nname=\"bulkRateForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"dialogbulkupdate\" ms-scroll style=\"background: rgb(245, 244, 244);width:100%\"><md-progress-linear \nmd-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><md-content class=\"md-padding\"><div \nclass=\"row-block margin-top-10\" layout=\"row\" layout-align=\"start start\" flex=\"100\" layout-wrap><div \nclass=\"role-list-outer height-main\" layout=\"row\" layout=\"row\" layout-wrap flex=\"100\"><div \nclass=\"role-list-out white-bg relative-block\" layout=\"row\" layout-wrap flex=\"100\" ng-if=\"vm.showRoomBoatsBulk\"><div \nclass=\"form-title mb-0 autowid mr-20\" flex=\"100\" layout=\"column\">Bulk update type?</div><md-input-container \nclass=\"padding-right-10 md-block tax-inputs mt-5 mb-0\" flex=\"100\" flex-xs=\"100\" layout=\"column\"><md-radio-group \nclass=\"no-margin\" ng-model=\"vm.type\" ng-click=\"vm.showRooms()\" required><md-radio-button class=\"space-block-inline\" \nvalue=\"rooms\">Rooms</md-radio-button><md-radio-button class=\"space-block-inline margin-left-10\" value=\"boats\">Marina\n</md-radio-button></md-radio-group></md-input-container></div><div class=\"role-list-out white-bg relative-block pv-20\" \nflex=\"100\" layout=\"row\" layout-wrap><md-input-container \nclass=\"padding-left-10 padding-right-10 md-block tax-inputs mb-0 mt-20\" flex=\"50\" flex-xs=\"100\" layout=\"column\"><label \nclass=\"margin-left-10\" translate=\"RATERULE.SET\">SET</label><md-select ng-model=\"vm.optionsSel\" name=\"status\"><md-option\n value=\"{{key}}\" ng-repeat=\"(key,optionAvail) in vm.optionsAvail\">{{optionAvail}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container \nclass=\"padding-left-30 padding-right-10 md-block tax-inputs mb-30 mt-20\" flex=\"50\" flex-xs=\"100\" layout=\"column\" \nng-if=\"vm.optionsSel==1\"><md-radio-group class=\"no-margin\" ng-model=\"vm.selectRate\"><md-radio-button \nclass=\"space-block-inline\" value=\"new\">Standard Rate</md-radio-button><md-radio-button \nclass=\"space-block-inline margin-left-10\" value=\"derived\">Derive from Current Rate</md-radio-button></md-radio-group>\n</md-input-container><div flex=\"{{vm.selectRate == \'new\' ? 50 : 33}}\" flex-xs=\"100\" layout=\"column\"><md-input-container\n class=\"padding-left-10 padding-right-10 mb-0 mt-20 md-icon-float md-block\" ng-if=\"vm.optionsSel==1\"><label \nclass=\"margin-left-10\" translate=\"RATERULE.RATE_TITLE\" ng-if=\"vm.selectRate == \'new\'\">Rate</label><label \nclass=\"margin-left-10\" translate=\"RATERULE.RATE_VALUE\" ng-if=\"vm.selectRate == \'derived\' && vm.optionsSel==1\">Value\n</label><input type=\"text\" name=\"room_type_price\" ng-model=\"vm.ratebulk.room_type_price\" \nng-change=\"bulkRateForm.room_type_price.$valid\" ng-model-options=\"{debounce: 500}\" required \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div ng-messages=\"bulkRateForm.room_type_price.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-if=\"vm.rateMaxError\" class=\"emailError\"><span translate=\"RATERULE.MAX_PRICE\"></span></div>\n</div></md-input-container><md-input-container \nclass=\"padding-left-10 padding-right-10 md-input-has-value mb-0 mt-20 md-icon-float md-block\" ng-if=\"vm.optionsSel==2\">\n<label class=\"margin-left-10\" translate=\"RATERULE.STOP_SELL\">Stop Sell</label><md-radio-group class=\"no-margin\" \nng-model=\"vm.ratebulk.is_stop_sell\"><md-radio-button class=\"space-block-inline\" value=\"1\">Yes</md-radio-button>\n<md-radio-button class=\"space-block-inline margin-left-10\" value=\"0\">No</md-radio-button></md-radio-group>\n</md-input-container><md-input-container \nclass=\"padding-left-10 padding-right-10 mb-0 mt-20 md-icon-float md-block md-input-has-value\" ng-if=\"vm.optionsSel==3\">\n<label class=\"margin-left-10\" translate=\"RATERULE.CTA\">CTA</label><md-radio-group class=\"no-margin\" \nng-model=\"vm.ratebulk.is_cta\"><md-radio-button class=\"space-block-inline\" value=\"1\">Yes</md-radio-button>\n<md-radio-button class=\"space-block-inline margin-left-10\" value=\"0\">No</md-radio-button></md-radio-group>\n</md-input-container><md-input-container \nclass=\"mb-0 mt-20 padding-left-10 padding-right-10 md-icon-float md-block md-input-has-value\" ng-if=\"vm.optionsSel==4\">\n<label class=\"margin-left-10\" translate=\"RATERULE.CTD\">CTD</label><md-radio-group class=\"no-margin\" \nng-model=\"vm.ratebulk.is_ctd\"><md-radio-button class=\"space-block-inline\" value=\"1\">Yes</md-radio-button>\n<md-radio-button class=\"space-block-inline margin-left-10\" value=\"0\">No</md-radio-button></md-radio-group>\n</md-input-container><md-input-container class=\"mb-0 mt-20 padding-left-10 padding-right-10 md-icon-float md-block\" \nng-if=\"vm.optionsSel==5\"><label class=\"margin-left-10\" translate=\"RATERULE.MIN_STAY\">Min Stay</label><input \ntype=\"text\" name=\"min_stay\" ng-model=\"vm.ratebulk.min_stay\" allow-decimal-numbers required \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container><md-input-container \nclass=\"mb-0 mt-20 padding-left-10 padding-right-10 md-icon-float md-block\" ng-if=\"vm.optionsSel==6\"><label \nclass=\"margin-left-10\" translate=\"RATERULE.MAX_STAY\">Max Stay</label><input type=\"text\" name=\"max_stay\" \nng-model=\"vm.ratebulk.max_stay\" allow-decimal-numbers required ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div><div class=\"row-block\" layout=\"row\" layout-align=\"start start\" flex=\"66\" layout-wrap \nng-if=\"vm.selectRate == \'derived\' && vm.optionsSel==1\"><md-input-container \nclass=\"padding-left-10 padding-right-10 md-block tax-inputs mb-0 mt-20\" flex=\"50\" flex-xs=\"100\" layout=\"column\"><label \nclass=\"margin-left-10\"></label><md-select name=\"rate_plan_adjust_indicator\" ng-model=\"vm.rate_plan_adjust_indicator\">\n<md-option value=\"1\"><span><div class=\"md-text\">Increase by</div></span></md-option><md-option value=\"0\"><span><div \nclass=\"md-text\">Decrease by</div></span></md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container><md-input-container class=\"padding-left-10 padding-right-10 md-block tax-inputs mb-0 mt-20\" \nflex=\"50\" flex-xs=\"100\" layout=\"column\"><label class=\"margin-left-10\"></label><md-select name=\"rate_plan_percentage\" \nng-model=\"vm.rate_plan_percentage\"><md-option value=\"0\"><span><div class=\"md-text\">$</div></span></md-option><md-option\n value=\"1\"><span><div class=\"md-text\">%</div></span></md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container></div></div><div class=\"role-list-out white-bg relative-block\" flex=\"100\" layout=\"row\" \nlayout-wrap><div class=\"row-block datepiker-block-main\" layout=\"row\" layout-wrap flex=\"100\"><div \nclass=\"form-title mb-0 autowid mr-20\" flex=\"100\" layout=\"column\"><span ng-if=\"vm.optionsSel == 1\">Rates Period</span> \n<span ng-if=\"vm.optionsSel == 2\">Stop Sell Period</span> <span ng-if=\"vm.optionsSel == 3\">Close To Arrival Period\n</span> <span ng-if=\"vm.optionsSel == 4\">Close To Departure Period</span> <span ng-if=\"vm.optionsSel == 5\">\nMin Stay Period</span></div><div layout=\"column\" flex-gt-xs=\"50\" flex=\"100\"><md-input-container \nclass=\"mb-0 md-block tax-inputs full-width datepickerinput\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"RATERULE.FROM\">From</label><md-datepicker flex-gt-xs=\"100\" ng-model=\"vm.from_range\" md-open-on-focus \nrequired md-min-date=\"\" md-max-date=\"vm.to_range\"></md-datepicker></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"50\" flex=\"100\"><md-input-container class=\"mb-0 md-block tax-inputs full-width datepickerinput\" \ndata-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\" translate=\"RATERULE.TO\">To</label><md-datepicker \nflex-gt-xs=\"100\" ng-model=\"vm.to_range\" md-open-on-focus required md-min-date=\"vm.from_range\"></md-datepicker>\n</md-input-container></div><div class=\"row-block daynamedilog\" layout=\"row\" layout-xs=\"column\" flex=\"50\">\n<md-input-container class=\"mt-0 md-icon-float md-block margin-left-15\" ng-repeat=\"(key, dayWeek) in vm.daysWeek\">\n<md-checkbox class=\"no-margin\" checklist-model=\"vm.daysWeek\" checklist-value=\"key\" ng-click=\"vm.addSelectedDays(key)\" \nng-checked=\"vm.ratebulk.selectedDays.indexOf(key)!=-1\">&nbsp; {{dayWeek}}</md-checkbox></md-input-container></div>\n</div></div><div class=\"row-block\" flex=\"100\"><div class=\"role-list-out white-bg relative-block\" \nng-if=\"vm.optionsSel <= 1\" ng-class=\"vm.showDerivedRateSelMsg != \'\' ?  \'dynamic-alert\' : \'\'\"><div flex=\"100\" \nlayout=\"row\" layout-wrap class=\"alert-derive-msg\" ng-if=\"vm.showDerivedRateSelMsg != \'\'\"><p>\n{{vm.showDerivedRateSelMsg}}</p></div><div flex=\"100\" layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" \nlayout-align=\"start start\"><div class=\"full-width\"><div class=\"form-title mb-0 autowid mr-20\">Which rates?</div></div>\n</div></div><div flex=\"100\" layout=\"row\" layout-wrap><div class=\"md-icon-float md-block\"><md-input-container \nclass=\"capitalize no-margin padding-top-10 padding-bottom-10\"><md-checkbox class=\"no-margin\" \nng-model=\"vm.selectAll[\'rate\']\" ng-click=\"vm.selectall(\'rate\',vm.ratesData,\'rate_plan_id\')\">&nbsp; Select All\n</md-checkbox></md-input-container></div><div class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\" \nng-repeat=\"rates in vm.ratesData\" ng-if=\"vm.optionsSel==1 || vm.optionsSel!=1\"><md-input-container \nclass=\"capitalize no-margin padding-top-10 padding-bottom-10\"><md-checkbox class=\"no-margin\" \nng-click=\"vm.addSelectedData(\'rate\',rates.rate_plan_id,vm.ratesData,\'\',$event)\" \nng-checked=\"vm.ratebulk.seleRates.rate.indexOf(rates.rate_plan_id)!==-1\">&nbsp; {{rates.name}}</md-checkbox>\n</md-input-container></div></div></div><div class=\"role-list-out white-bg relative-block\"><div flex=\"100\" layout=\"row\" \nlayout-wrap><div layout=\"column\" flex=\"100\" layout-align=\"start start\"><div class=\"full-width\"><div \nclass=\"form-title mb-0 autowid mr-20\">Which channels?</div></div></div></div><div flex=\"100\" layout=\"row\" layout-wrap>\n<div class=\"md-icon-float md-block\"><md-input-container class=\"capitalize no-margin padding-top-10 padding-bottom-10\">\n<md-checkbox class=\"no-margin\" ng-model=\"vm.selectAll[\'channels\']\" \nng-click=\"vm.selectall(\'channels\',vm.channelsData,\'channel_id\')\" id=\"channelSelector\">&nbsp; Select All</md-checkbox>\n</md-input-container></div><div class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\" \nng-repeat=\"(channelKey,channels) in vm.channelsData\"><md-input-container \nclass=\"capitalize no-margin padding-top-10 padding-bottom-10\" \nng-if=\"vm.currentTab == \'room\' || (vm.currentTab == \'boat\' && channels.name == \'Direct Channel\')\"><md-checkbox \nclass=\"no-margin\" ng-click=\"vm.addSelectedData(\'channels\',channels.channel_id,vm.channelsData,\'\',$event)\" \nng-checked=\"vm.ratebulk.seleRates.channels.indexOf(channels.channel_id)!==-1\">&nbsp; {{channels.name}}</md-checkbox>\n</md-input-container></div></div></div><div class=\"role-list-out white-bg relative-block\"><div flex=\"100\" layout=\"row\" \nlayout-wrap><div layout=\"column\" flex=\"100\" layout-align=\"start start\"><div class=\"full-width\"><div \nclass=\"form-title mb-0 autowid mr-20\">Which {{vm.type}}?</div></div></div></div><div flex=\"100\" layout=\"row\" \nlayout-wrap ng-if=\"vm.hotelID != \'128\'\"><div class=\"md-icon-float md-block\"><md-input-container \nclass=\"capitalize no-margin padding-top-10 padding-bottom-10\"><md-checkbox class=\"no-margin\" \nng-model=\"vm.selectAll[\'rooms\']\" ng-click=\"vm.selectall(\'rooms\',vm.roomsRates,\'id\')\">&nbsp; Select All</md-checkbox>\n</md-input-container></div><div class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\" \nng-repeat=\"roomRate in vm.roomsRates\"><md-input-container \nclass=\"capitalize no-margin padding-top-10 padding-bottom-10\"><md-checkbox class=\"no-margin\" \nng-click=\"vm.addSelectedData(\'rooms\',roomRate.id,vm.roomsRates,\'\',$event)\" \nng-checked=\"vm.ratebulk.seleRates.rooms.indexOf(roomRate.id)!==-1\">&nbsp; {{roomRate.name}}</md-checkbox>\n</md-input-container></div></div><div flex=\"100\" layout=\"row\" layout-wrap ng-if=\"vm.hotelID == \'128\'\"><div \nclass=\"md-icon-float md-block selectallblk\"><md-input-container \nclass=\"capitalize no-margin padding-top-10 padding-bottom-10\"><md-checkbox class=\"no-margin\" \nng-model=\"vm.selectAll[\'rooms\']\" ng-click=\"vm.selectall(\'rooms\',vm.roomsRates,\'id\', vm.roomsRates)\">&nbsp; Select All\n</md-checkbox></md-input-container></div><div class=\"md-icon-float md-block width-div outer-wrapper\" layout=\"row\" \nflex=\"100\" ng-repeat=\"roomRate in vm.roomsRates\" id=\"outerroom{{$index}}\" ng-click=\"vm.toggle($index)\"><div \nclass=\"md-plus-icon\"><md-input-container class=\"capitalize no-margin padding-top-10 padding-bottom-10\"><md-checkbox \nclass=\"no-margin\" ng-click=\"vm.addSelectedDataRoom(\'rooms\',roomRate.room_type_refs_id, roomRate.room_type_id,$event)\" \nng-checked=\"vm.casitasRooms.indexOf(roomRate.id)!==-1\">&nbsp; {{roomRate.name}}</md-checkbox></md-input-container><div \nclass=\"icon-div\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><md-icon \nmd-font-icon=\"icon-minus-circle-outline\"></md-icon></div></div><div id=\"innerroom{{$index}}\" style=\"display: none\" \nclass=\"inner-div outer-wrapper\"><div class=\"md-icon-float md-block width-div padding-leftdiv\" layout=\"row\" flex=\"100\" \nlayout-wrap><md-input-container class=\"capitalize no-margin padding-top-10 padding-bottom-10\" layout=\"column\" \nflex=\"50\" flex-xs=\"100\" ng-repeat=\"room in roomRate.rooms\"><md-checkbox class=\"no-margin\" \nng-click=\"vm.addSelectedData(\'rooms\',room.id,vm.roomsRates, roomRate.room_type_id,$event)\" \nng-checked=\"vm.ratebulk.seleRates.rooms.indexOf(room.id)!==-1\">&nbsp; {{room.name}}</md-checkbox></md-input-container>\n</div></div></div></div></div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" \nng-click=\"vm.saveBulkPrice()\" \nng-class=\"bulkRateForm.$invalid || bulkRateForm.$pristine || vm.rateMaxError || vm.queryRunning || !vm.ratebulk.seleRates.rate || vm.ratebulk.seleRates.rate.length<=0 || !vm.ratebulk.seleRates.channels || vm.ratebulk.seleRates.channels.length<=0 || !vm.ratebulk.seleRates.rooms || vm.ratebulk.seleRates.rooms.length<=0 ?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"bulkRateForm.$invalid || bulkRateForm.$pristine || vm.rateMaxError || vm.queryRunning || (vm.optionsSel == 1 && (!vm.ratebulk.seleRates.rate || vm.ratebulk.seleRates.rate.length<=0)) || !vm.ratebulk.seleRates.channels || vm.ratebulk.seleRates.channels.length<=0 || !vm.ratebulk.seleRates.rooms || vm.ratebulk.seleRates.rooms.length<=0\" \naria-label=\"SAVE\">Save<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.showLoader\"></md-progress-circular></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/rateRule/dialogs/copy-rates-dialog.html","<md-dialog class=\"role-dialog copyPriceForm\" aria-label=\"New Task\"><form name=\"copyPriceForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><md-content class=\"md-padding padding-top-40\"><div class=\"row-block margin-top-10\" layout=\"row\" \nlayout-align=\"start start\" flex=\"100\" layout-wrap><md-input-container \nclass=\"padding-left-10 padding-right-10 md-block tax-inputs no-margin mb-10\" flex=\"100\" layout=\"column\"><label \nclass=\"margin-left-10\" translate=\"RATERULE.COPYING\">COPYING</label><md-select ng-model=\"vm.optionsSel\" name=\"status\" \nng-change=\"vm.changeView()\"><md-option value=\"{{key}}\" ng-repeat=\"(key,optionAvail) in vm.optionsAvail\">{{optionAvail}}\n</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container><md-input-container \nng-if=\"vm.optionsSel != 4\" class=\"padding-left-10 padding-right-10 md-block tax-inputs no-margin\" flex=\"50\" \nflex-xs=\"100\" layout=\"column\"><label class=\"margin-left-10\">Copy {{vm.optionsAvail[vm.optionsSel]}} rates from</label>\n<md-select ng-model=\"vm.fromCopying\"><md-option value=\"{{key}}\" ng-repeat=\"(key,optionAvail) in vm.copyingOptions\">\n{{optionAvail.name}}</md-option></md-select></md-input-container><md-input-container ng-if=\"vm.optionsSel != 4\" \nclass=\"padding-left-10 padding-right-10 md-block tax-inputs no-margin\" flex=\"50\" flex-xs=\"100\" layout=\"column\"><label \nclass=\"margin-left-10\">to {{vm.optionsAvail[vm.optionsSel]}}</label><md-select ng-model=\"vm.toCopying\" \nmultiple=\"multiple\"><md-option value=\"{{key}}\" ng-repeat=\"(key,optionAvail) in vm.copyingOptions\">{{optionAvail.name}}\n</md-option></md-select></md-input-container></div><div ng-if=\"vm.optionsSel == 4\" class=\"advancedSett\">\nNote: Date range to copy from.<div class=\"row-block datepiker-block-main\" layout=\"row\" layout-wrap><div \nlayout=\"column\" flex-gt-xs=\"50\" flex=\"100\"><md-input-container \nclass=\"mb-0 md-block tax-inputs full-width datepickerinput\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"RATERULE.FROM\">From</label><md-datepicker flex-gt-xs=\"100\" ng-model=\"vm.dateRangeFromStart\" \nmd-open-on-focus md-min-date=\"vm.currentDateValue\" md-max-date=\"vm.to_range\"></md-datepicker></md-input-container>\n</div><div layout=\"column\" flex-gt-xs=\"50\" flex=\"100\"><md-input-container \nclass=\"mb-0 md-block tax-inputs full-width datepickerinput\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"RATERULE.TO\">To</label><md-datepicker flex-gt-xs=\"100\" ng-model=\"vm.dateRangeFromEnd\" md-open-on-focus \nmd-min-date=\"vm.from_range\"></md-datepicker></md-input-container></div></div><div \nclass=\"row-block datepiker-block-main\" layout=\"row\" layout-wrap><div layout=\"column\" flex-gt-xs=\"50\" flex=\"100\">\n<md-input-container class=\"mb-0 md-block tax-inputs full-width datepickerinput\" data-ng-animate=\"1\"><label \nclass=\"ng-scope\" role=\"button\" translate=\"RATERULE.FROM\">From</label><md-datepicker flex-gt-xs=\"100\" \nng-model=\"vm.dateRangeToStart\" md-open-on-focus md-min-date=\"vm.currentDateValue\" md-max-date=\"vm.to_range\">\n</md-datepicker></md-input-container></div><div layout=\"column\" flex-gt-xs=\"50\" flex=\"100\"><md-input-container \nclass=\"mb-0 md-block tax-inputs full-width datepickerinput\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"RATERULE.TO\">To</label><md-datepicker flex-gt-xs=\"100\" ng-model=\"vm.dateRangeToEnd\" md-open-on-focus \nmd-min-date=\"vm.from_range\"></md-datepicker></md-input-container></div></div></div><div \nng-click=\"vm.triggerAdvancedSett()\" class=\"mainAdvancedBlock\"><div \nclass=\"form-title-div advancedBlock onlycursorPointer\"><span class=\"ng-scope\">Advanced Settings</span> <a \nclass=\"custom-pull-right md-default-theme\" ng-if=\"!vm.advancedSettings\"><i class=\"icon-plus-circle\"></i></a> <a \nclass=\"custom-pull-right md-default-theme\" ng-if=\"vm.advancedSettings\"><i class=\"icon-minus-circle\"></i></a></div>\n</div><div ng-if=\"vm.advancedSettings\" class=\"advancedSett\">\nNote: If no dates selected then all rates of all dates will be copied.<div class=\"row-block datepiker-block-main\" \nlayout=\"row\" layout-wrap ng-if=\"vm.optionsSel != 4\"><div layout=\"column\" flex-gt-xs=\"50\" flex=\"100\"><md-input-container\n class=\"mb-0 md-block tax-inputs full-width datepickerinput\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"RATERULE.FROM\">From</label><md-datepicker flex-gt-xs=\"100\" ng-model=\"vm.from_range\" md-open-on-focus \nmd-min-date=\"vm.currentDateValue\" md-max-date=\"vm.to_range\"></md-datepicker></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"50\" flex=\"100\"><md-input-container \nclass=\"mb-0 md-block tax-inputs full-width datepickerinput\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"RATERULE.TO\">To</label><md-datepicker flex-gt-xs=\"100\" ng-model=\"vm.to_range\" md-open-on-focus \nmd-min-date=\"vm.from_range\"></md-datepicker></md-input-container></div></div><div class=\"row-block\"><div \nng-if=\"vm.optionsSel!=1\"><div flex=\"100\" layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" \nlayout-align=\"start start\"><div class=\"full-width\"><div class=\"form-title mb-0 autowid mr-20\">Which rates?</div><div \nclass=\"md-icon-float md-block margin-bottom-10\"><md-input-container \nclass=\"capitalize no-margin padding-top-10 padding-bottom-10\"><md-checkbox type=\"checkbox\" class=\"no-margin\" \nng-model=\"vm.selectAll[\'rate\']\" ng-click=\"vm.selectall(\'rate\',vm.ratesData,\'rate_plan_id\')\">&nbsp; Select All\n</md-checkbox></md-input-container></div></div></div></div><div flex=\"100\" layout=\"row\" layout-wrap><div \nclass=\"md-icon-float md-block margin-bottom-10\" layout=\"row\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"33\" \nng-repeat=\"rates in vm.ratesData\"><md-input-container class=\"capitalize no-margin padding-top-10 padding-bottom-10\">\n<md-checkbox type=\"checkbox\" class=\"no-margin\" ng-click=\"vm.addSelectedData(\'rate\',rates.rate_plan_id,vm.ratesData)\" \nng-checked=\"vm.copyprice.seleRates.rate.indexOf(rates.rate_plan_id)!==-1\">&nbsp; {{rates.name}}</md-checkbox>\n</md-input-container></div></div></div><div ng-if=\"vm.optionsSel!=2\"><div flex=\"100\" layout=\"row\" layout-wrap><div \nlayout=\"column\" flex=\"100\" layout-align=\"start start\"><div class=\"full-width\"><div \nclass=\"form-title mb-0 autowid mr-20\">Which channels?</div><div class=\"md-icon-float md-block margin-bottom-10\">\n<md-input-container class=\"capitalize no-margin padding-top-10 padding-bottom-10\"><md-checkbox type=\"checkbox\" \nclass=\"no-margin\" ng-model=\"vm.selectAll[\'channels\']\" ng-click=\"vm.selectall(\'channels\',vm.channelsData,\'channel_id\')\">\n&nbsp; Select All</md-checkbox></md-input-container></div></div></div></div><div flex=\"100\" layout=\"row\" layout-wrap>\n<div class=\"md-icon-float md-block margin-bottom-15\" layout=\"row\" flex=\"100\" flex-gt-xs=\"50\" \nng-repeat=\"channels in vm.channelsData\"><md-input-container \nclass=\"capitalize no-margin padding-top-10 padding-bottom-10\"><md-checkbox type=\"checkbox\" class=\"no-margin\" \nng-click=\"vm.addSelectedData(\'channels\',channels.channel_id,vm.channelsData)\" \nng-checked=\"vm.copyprice.seleRates.channels.indexOf(channels.channel_id)!==-1\">&nbsp; {{channels.name}}</md-checkbox>\n</md-input-container></div></div></div><div ng-if=\"vm.optionsSel!=3\"><div flex=\"100\" layout=\"row\" layout-wrap><div \nlayout=\"column\" flex=\"100\" layout-align=\"start start\"><div class=\"full-width\"><div \nclass=\"form-title mb-0 autowid mr-20\">Which rooms?</div><div class=\"md-icon-float md-block margin-bottom-10\">\n<md-input-container class=\"capitalize no-margin padding-top-10 padding-bottom-10\"><md-checkbox type=\"checkbox\" \nclass=\"no-margin\" ng-model=\"vm.selectAll[\'rooms\']\" ng-click=\"vm.selectall(\'rooms\',vm.roomsRates,\'id\')\">\n&nbsp; Select All</md-checkbox></md-input-container></div></div></div></div><div flex=\"100\" layout=\"row\" layout-wrap>\n<div class=\"md-icon-float md-block margin-bottom-15\" layout=\"row\" flex=\"100\" flex-gt-xs=\"50\" \nng-repeat=\"roomRate in vm.roomsRates\"><md-input-container \nclass=\"capitalize no-margin padding-top-10 padding-bottom-10\"><md-checkbox type=\"checkbox\" class=\"no-margin\" \nng-click=\"vm.addSelectedData(\'rooms\',roomRate.id,vm.roomsRates)\" \nng-checked=\"vm.copyprice.seleRates.rooms.indexOf(roomRate.id)!==-1\">&nbsp; {{roomRate.name}}</md-checkbox>\n</md-input-container></div></div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" \nng-click=\"vm.saveCopyPrice()\" \nng-class=\"copyPriceForm.$invalid || vm.queryRunning || (vm.advancedSettings && vm.optionsSel==1 && (vm.copyprice.seleRates.channels.length<=0 || vm.copyprice.seleRates.rooms.length<=0)) || (vm.advancedSettings && vm.optionsSel==2 && (vm.copyprice.seleRates.rate.length<=0 || vm.copyprice.seleRates.rooms.length<=0)) || (vm.advancedSettings && vm.optionsSel==3 && (vm.copyprice.seleRates.rate.length<=0 || vm.copyprice.seleRates.channels.length<=0)) || (!vm.fromCopying  && vm.optionsSel != 4) || (!vm.toCopying  && vm.optionsSel != 4) || (vm.optionsSel==4 && vm.getDateValidation()) || (vm.optionsSel==4 && vm.advancedSettings && (vm.copyprice.seleRates.rate.length<=0 || vm.copyprice.seleRates.rooms.length<=0 || vm.copyprice.seleRates.channels.length<=0 )) ?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"copyPriceForm.$invalid || vm.queryRunning || (vm.advancedSettings && vm.optionsSel==1 && (vm.copyprice.seleRates.channels.length<=0 || vm.copyprice.seleRates.rooms.length<=0)) || (vm.advancedSettings && vm.optionsSel==2 && (vm.copyprice.seleRates.rate.length<=0 || vm.copyprice.seleRates.rooms.length<=0)) || (vm.advancedSettings && vm.optionsSel==3 && (vm.copyprice.seleRates.rate.length<=0 || vm.copyprice.seleRates.channels.length<=0)) || (!vm.fromCopying && vm.optionsSel != 4) || (!vm.toCopying  && vm.optionsSel != 4) || (vm.optionsSel==4 && vm.getDateValidation()) || (vm.optionsSel==4  && vm.advancedSettings &&  (vm.copyprice.seleRates.rate.length<=0 || vm.copyprice.seleRates.rooms.length<=0 || vm.copyprice.seleRates.channels.length<=0))\" \naria-label=\"SAVE\" translate=\"GROUPS.SAVE\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/rateRule/dialogs/rate-dialog.html","<md-dialog class=\"role-dialog\" aria-label=\"New Task\"><form name=\"rateRuleForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><md-content class=\"md-padding\"><md-input-container class=\"md-icon-float md-block\" \nng-if=\"vm.optionsSel==1\"><label translate=\"RATERULE.RATE_TITLE\"></label><md-icon md-font-icon=\"icon-currency-usd\" \nclass=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100 md-input-invalid\"></md-icon><input type=\"text\" \nname=\"room_type_price\" ng-model=\"vm.raterule.room_type_price\" required ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n<div ng-messages=\"rateRuleForm.room_type_price.$error\" role=\"alert\" multiple=\"multiple\"><div ng-if=\"vm.rateMaxError\" \nclass=\"emailError\"><span translate=\"RATERULE.MAX_PRICE\"></span></div></div></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" ng-if=\"vm.optionsSel==5\"><label translate=\"RATERULE.MIN_STAY\"></label><md-icon \nmd-font-icon=\"icon-hotel\" class=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100 md-input-invalid\"></md-icon>\n<input type=\"text\" name=\"min_stay\" ng-model=\"vm.raterule.min_stay\" allow-decimal-numbers required \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\" ng-if=\"vm.optionsSel==6\"><label translate=\"RATERULE.MAX_STAY\"></label><md-icon \nmd-font-icon=\"icon-hotel\" class=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100 md-input-invalid\"></md-icon>\n<input type=\"text\" name=\"max_stay\" ng-model=\"vm.raterule.max_stay\" allow-decimal-numbers required \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container><div class=\"row-block datepiker-block-main\" \nlayout=\"row\" layout-xs=\"column\"><md-input-container class=\"md-block tax-inputs full-width\" data-ng-animate=\"1\" flex \nstyle=\"margin-left:-10px\"><label class=\"ng-scope\" role=\"button\" translate=\"RATERULE.FROM\">From</label><md-datepicker \nng-model=\"vm.from_range\" md-open-on-focus required flex style=\"width:80%\" md-min-date=\"vm.currentDateValue\" \nmd-max-date=\"vm.to_range\"></md-datepicker></md-input-container><md-input-container \nclass=\"md-block tax-inputs full-width\" data-ng-animate=\"1\" flex><label class=\"ng-scope\" role=\"button\" \ntranslate=\"RATERULE.TO\">To</label><md-datepicker ng-model=\"vm.to_range\" md-open-on-focus required style=\"width:80%\" \nmd-min-date=\"vm.from_range\"></md-datepicker></md-input-container></div><div class=\"row-block\" layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"no-margin md-icon-float md-block\" \nng-repeat=\"(key, dayWeek) in vm.daysWeek\" flex><md-checkbox class=\"no-margin no-padding\" type=\"checkbox\" \nchecklist-model=\"vm.daysWeek\" checklist-value=\"key\" ng-click=\"vm.addSelectedDays(key)\" \nng-checked=\"vm.selectedDays.indexOf(key)!=-1\">&nbsp;<span>{{dayWeek}}</span></md-checkbox></md-input-container></div>\n</md-content></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" ng-click=\"vm.saveRowPrice()\" \nng-class=\"!rateRuleForm.$invalid && !rateRuleForm.$pristine && !vm.rateMaxError && !vm.requestProgressing?\'md-raised md-green-500-bg submit-button white-fg\':\'md-raised md-accent submit-button grey-100-fg\'\" \nng-disabled=\"rateRuleForm.$invalid || rateRuleForm.$pristine || vm.rateMaxError || vm.requestProgressing \" \naria-label=\"SAVE\">Save<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.showLoader\"></md-progress-circular></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/rateRule/negotiatedRateRule/negotiatedRateRule.html","<div id=\"rateRulePage\" class=\"page-layout carded fullwidth\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"column\"><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\">\n<md-icon md-font-icon=\"icon-currency-usd\" class=\"icon\"></md-icon></span><span class=\"logo-text\">\nNegotiated Rate Calendar</span></div><div layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.reload()\" \nclass=\"md-icon-button white-fg\" aria-label=\"Reload\" translate translate-attr-aria-label=\"GANTT.RELOAD\"><md-icon \nmd-font-icon=\"icon-reload\"></md-icon><md-tooltip><span translate=\"RATERULE.RELOAD\">RELOAD</span></md-tooltip>\n</md-button><div ng-if=\"!vm.mainErrorMsg\"><md-button class=\"md-raised md-background\" type=\"submit\" \nng-click=\"vm.bulkUpdate($event)\"><span translate=\"RATERULE.BULK_UPDATE\"></span></md-button></div><div \nng-if=\"!vm.mainErrorMsg && false\"><md-button class=\"md-raised md-background\" type=\"submit\" \nng-click=\"vm.copyrates($event)\"><span translate=\"RATERULE.COPY\"></span></md-button></div></div></div><div \nclass=\"bottom\" layout=\"row\" layout-gt-sm=\"row\" flex=\"100\"><div class=\"date-filter-box md-whiteframe-3dp no-padding\" \nlayout=\"column\" flex layout-align-gt-xs=\"center center\" flex=\"100\" flex-gt-sm=\"25\"><md-input-container \nclass=\"md-block tax-inputs no-margin md-input-blockcontainer\" flex><md-select class=\"no-border\" \nng-model=\"vm.roomTypeSel\" name=\"status\" ng-change=\"vm.changeFilters()\"><md-option class=\"capitalize\" \nvalue=\"{{value.id}}\" ng-repeat=\"value in vm.customers\">{{value.name}}</md-option></md-select></md-input-container>\n</div><div class=\"date-filter-box md-whiteframe-3dp no-padding\" layout=\"column\" flex \nlayout-align-gt-xs=\"center center\" flex=\"100\" flex-gt-sm=\"25\" ng-if=\"!vm.boatExists\"><md-input-container \nclass=\"md-block tax-inputs no-margin md-input-blockcontainer\" flex><md-select class=\"no-border\" \nng-model=\"vm.ratePlanSel\" name=\"status\" ng-change=\"vm.changeFilters()\"><md-option value=\"0\" \nng-selected=\"vm.ratePlanSel===0\">All Rates</md-option><md-option class=\"capitalize\" \nvalue=\"{{ratePlanData.rate_plan_id}}\" ng-repeat=\"(key,ratePlanData) in vm.ratePlansData[\'room\']\">{{ratePlanData.name}}\n</md-option></md-select></md-input-container></div><div \nclass=\"date-filter-box md-whiteframe-3dp md-datepicker md-input-blockcontainer padding-top-5\" layout=\"column\" flex \nflex=\"100\" flex-gt-sm=\"25\" layout-align-gt-xs=\"center center\"><md-datepicker class=\"no-margin\" \nmd-hide-icons=\"calendar\" ng-model=\"vm.options.fromDate\" md-open-on-focus md-min-date=\"\" \nng-change=\"vm.load(\'changeDate\')\" ng-model-options=\"{debounce: 500}\" flex></md-datepicker></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div ng-if=\"vm.mainErrorMsg\"><p><md-icon md-font-icon=\"icon-alert\" class=\"\">\n</md-icon>Oops! {{vm.mainErrorMsg}}</p></div><md-content id=\"chart-container\" class=\"content relative-block\" flex \nlayout=\"column\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"!vm.mainErrorMsg && vm.isloading\">\n</md-progress-linear><div class=\"rate-rule-input\"></div><gantt flex layout-fill id=\"gantt\" gantt \nheaders-formats=\"vm.options.headersFormats\" data=\"vm.data\" timespans=\"vm.timespans\" \nshow-side=\"vm.options.labelsEnabled\" daily=\"vm.options.daily\" filter-task=\"{\'name\': vm.options.filterTask}\" \nfilter-row=\"{\'name\': vm.options.filterRow}\" sort-mode=\"vm.options.sortMode\" view-scale=\"vm.options.scale\" \ncolumn-width=\"vm.getColumnWidth(vm.options.width, vm.options.scale, vm.options.zoom)\" \nauto-expand=\"vm.options.autoExpand\" task-out-of-range=\"vm.options.taskOutOfRange\" from-date=\"vm.options.fromDate\" \nto-date=\"vm.options.toDate\" allow-side-resizing=\"vm.options.allowSideResizing\" \ntask-content=\"vm.options.taskContentEnabled ? vm.options.taskContent : undefined\" \nrow-content=\"vm.options.rowContentEnabled ? vm.options.rowContent : undefined\" current-date=\"vm.options.currentDate\" \ncurrent-date-value=\"vm.options.currentDateValue\" headers=\"[\'month\', \'day\']\" max-height=\"vm.maxheight\" \ntime-frames=\"vm.options.timeFrames\" date-frames=\"vm.options.dateFrames\" \ntime-frames-working-mode=\"vm.options.timeFramesWorkingMode\" \ntime-frames-non-working-mode=\"vm.options.timeFramesNonWorkingMode\" time-frames-magnet=\"vm.options.timeFramesMagnet\" \napi=\"vm.options.api\" column-magnet=\"vm.options.columnMagnet\"><gantt-tree \nenabled=\"vm.options.sideMode === \'Tree\' || vm.options.sideMode === \'TreeTable\'\" \nheader-content=\"vm.options.treeHeaderContent\" keep-ancestor-on-filter-row=\"true\"></gantt-tree><gantt-table \nenabled=\"vm.options.sideMode === \'Table\' || vm.options.sideMode === \'TreeTable\'\" \ncolumns=\"vm.options.sideMode === \'TreeTable\' ? vm.options.treeTableColumns : vm.options.columns\" \nheaders=\"vm.options.columnsHeaders\" classes=\"vm.options.columnsClasses\" formatters=\"vm.options.columnsFormatters\" \ncontents=\"vm.options.columnsContents\" header-contents=\"vm.options.columnsHeaderContents\"></gantt-table><gantt-groups \nenabled=\"vm.options.groupDisplayMode === \'group\' || vm.options.groupDisplayMode === \'overview\' || vm.options.groupDisplayMode === \'promote\'\" \ndisplay=\"vm.options.groupDisplayMode\"></gantt-groups><gantt-bounds></gantt-bounds><gantt-progress></gantt-progress>\n<gantt-sortable></gantt-sortable><gantt-movable enabled=\"!vm.options.readOnly\"></gantt-movable><gantt-draw-task \nenabled=\"vm.options.canDraw\" move-threshold=\"2\" task-factory=\"vm.options.drawTaskFactory\"></gantt-draw-task>\n<gantt-overlap></gantt-overlap><gantt-resize-sensor></gantt-resize-sensor></gantt></md-content></div></div></div>");
$templateCache.put("app/main/apps/reports/arrival-registration-card/arrival-registration-card.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/boarding-pass.svg\" class=\"mr-10\"></md-icon><span><span>\nArrival Registration Card</span></span></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container Housekeepingtable incomereport income-report-table arrivalcardtable\"><div \nclass=\"table-title\">Arrival Registration Card {{ vm.departureDate | date:\'MM/dd/yyyy\'}}</div><div layout=\"row\" \nflex=\"100\" layout-wrap><div layout=\"column\" flex-gt-xs=\"{{vm.hotelID == 122 ? 33 : 50}}\" flex=\"100\" class=\"ph-10\">\n<md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Date\n</label><md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.departureDate\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" required></md-datepicker></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"33\" flex=\"100\" class=\"ph-10\" ng-if=\"isParent\"><md-input-container><label>\n{{ vm.selectedHotels.length == 1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{vm.hotelID == 122 ? 33 : 50}}\" flex=\"100\" class=\"ph-10\" ng-if=\"vm.hotelID == 126 || vm.hotelID == 122\">\n<md-input-container><label>Report For</label><md-select ng-model=\"vm.reportFor\"><md-optgroup label=\"Report For\">\n<md-option value=\"hotel\" selected=\"selected\">Hotel</md-option><md-option value=\"marina\">Marina</md-option>\n</md-optgroup></md-select></md-input-container></div></div><div class=\"row\" flex=\"100\" layout-wrap><div \nlayout=\"column\" flex-gt-xs=\"100\" flex=\"100\" class=\"ph-10 pb-20\" layout-align=\"center end\"><div><div class=\"logo\">\n<md-button class=\"md-raised md-cornered mr-10\" ng-click=\"vm.getReports()\" ng-disabled=\"vm.requestProcessing\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessing\"></md-progress-circular>\n</md-button><md-button ng-if=\"vm.reservationData.length > 0\" class=\"md-raised md-cornered mr-10\" \nng-click=\"vm.printData()\" ng-disabled=\"vm.printProcessing\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/print.svg\"></md-icon>Print All<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.printProcessing\"></md-progress-circular>\n</md-button></div></div></div></div><div class=\"simple-table-container mt-20\" id=\"printSectionId\" \nng-if=\"vm.reservationData.length > 0\"><div class=\"ms-responsive-table-wrapper ph-20 pb-20\"><table id=\"heightTable\" \nclass=\"simple margin-border\" ng-class=\"heightTable{{vm.channel | split: \' \':0}}\"><thead><tr \nclass=\"headerrow headerrow_backup\"><td>Start Date</td><td>End Date</td><td>Conf#</td><td>Room</td><td>Paid</td><td>Due\n</td><td>Total</td></tr></thead><tbody id=\"tbodyHeight\" ng-style=\"vm.tableStyle\" ms-scroll style=\"position:relative\">\n<tr ng-repeat=\"(myKey, reservation) in vm.reservationData\"><td>{{ reservation.room_stay_from }}</td><td>\n{{ reservation.room_stay_to }}</td><td class=\"cursorPointer\" \nng-click=\"goToState(\'\', reservation.confirmation_number, \'\')\">{{ reservation.confirmation_number }}</td><td>\n{{ reservation.fe_display_product_name }}</td><td>{{ reservation.total_paid_amount | currency:$:2 }}</td><td>\n{{ reservation.total_remaining_amount | currency:$:2 }}</td><td>{{ reservation.total_amount | currency:$:2 }}</td></tr>\n</tbody></table></div></div><div class=\"simple-table-container ph-20 pb-20 norecordFound\" ng-show=\"vm.resultFound\"><div\n class=\"ms-responsive-table-wrapper\">No Data Found</div></div></div></div></div>");
$templateCache.put("app/main/apps/reports/availability-report/availability-report.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-chart-line\" \nclass=\"mr-10\"></md-icon><span>Availability Report</span></div></div></div><div class=\"content loadingstatistic\"><div \nclass=\"simple-table-container\"><div class=\"table-title\">\nAvailability Report {{ (vm.fromdate | date:\'MM/dd/yyyy\')+\' - \'+(vm.todate | date:\'MM/dd/yyyy\')}}</div><div \nlayout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" \nflex-gt-xs=\"{{isParent ? 25 : (vm.hotelID == 126 ? 33 : 50)}}\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block full-width mb-0\"><label translate=\"REPORT.START\"></label><md-datepicker md-open-on-focus \nng-model=\"vm.fromdate\" md-min-date=\"vm.initialDate\" class=\"full-width mdinput-block\" ng-change=\"vm.ChangeEndDayIf()\">\n</md-datepicker><div class=\"md-errors-spacer\"></div></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{isParent ? 25 : (vm.hotelID == 126 ? 33 : 50)}}\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block full-width mb-0\"><label translate=\"REPORT.END\"></label><md-datepicker md-open-on-focus \nng-model=\"vm.todate\" md-min-date=\"vm.fromdate\" class=\"full-width mdinput-block\"></md-datepicker><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div layout=\"column\" flex-gt-xs=\"{{isParent ? 25 : 50}}\" \nflex=\"100\" class=\"ph-10\" ng-if=\"isParent === true\"><md-input-container><label>\n{{ vm.selectedHotels.length > 0 ? \'Buisness Entity\': \'All\' }}</label><md-select ng-model=\"vm.selectedHotels\" \nmultiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">{{hotel.hotel_title}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"33\" flex=\"100\" class=\"ph-10\" \nng-if=\"vm.hotelID == 126\"><md-input-container><label>Report For</label><md-select ng-model=\"vm.reportFor\"><md-optgroup \nlabel=\"Report For\"><md-option value=\"condos\" selected=\"selected\">Condos</md-option><md-option value=\"villas\">Villas\n</md-option><md-option value=\"boat\">Marina</md-option><md-option value=\"rent\">Residence</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\" \nng-if=\"vm.hotelID == 122\"><md-input-container><label>Report For</label><md-select ng-model=\"vm.reportFor\"><md-optgroup \nlabel=\"Report For\"><md-option value=\"room\" selected=\"selected\">Hotel</md-option><md-option value=\"boat\">Marina\n</md-option></md-optgroup></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\"><div \nlayout=\"column\" flex-gt-xs=\"100\" flex=\"100\" class=\"ph-10 pb-20\" layout-align=\"center end\"><div><div class=\"logo\">\n<md-button class=\"md-raised md-cornered\" ng-click=\"vm.getrecords();\" ng-disabled=\"vm.requestProcessing\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessing\"></md-progress-circular>\n</md-button><md-button class=\"md-raised md-cornered mr-10\" ng-if=\"vm.roomList.length > 0\" \nng-click=\"vm.exportFile(\'csv\')\" ng-disabled=\"vm.csvLoader\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>Export to CSV<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.csvLoader\"></md-progress-circular></md-button>\n<md-button class=\"md-raised md-cornered mr-10\" ng-if=\"vm.roomList.length > 0\" ng-click=\"vm.exportFile(\'pdf\')\" \nng-disabled=\"vm.exportLoader\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>\nExport to PDF<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.exportLoader\"></md-progress-circular></md-button></div></div></div></div><div class=\"outer-container\" \nng-if=\"vm.roomList.length\"><div class=\"right-wrapper\"><table class=\"outer-wrapper\"><thead><tr><th \nng-repeat=\"data in vm.roomList\">{{::data.product_name}}</th></tr></thead><tbody><tr \nng-repeat=\"(key, val) in vm.roomCount track by $index\"><td ng-repeat=\"count in val track by $index\">{{count}}</td></tr>\n</tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/apps/reports/custom-reports/custom-reports.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-chart-line\" \nclass=\"mr-10\"></md-icon><span>Out of Order Report</span></div></div></div><div class=\"content loadingstatistic\"><div \nclass=\"simple-table-container\"><div class=\"table-title\">\nOut of Order Report {{ (vm.fromDate | date:\'MM/dd/yyyy\')+\' - \'+(vm.toDate | date:\'MM/dd/yyyy\')}}</div><div \nlayout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" \nflex-gt-xs=\"{{isParent ? 25 : (vm.hotelID == 126 ? 33 : 50)}}\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">From Date</label>\n<md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.fromDate\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" ng-change=\"vm.checkSchedule(\'from\')\" required></md-datepicker></md-input-container>\n</div><div layout=\"column\" flex-gt-xs=\"{{isParent ? 25 : (vm.hotelID == 126 ? 33 : 50)}}\" flex=\"100\" class=\"ph-10\">\n<md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">\nTo Date</label><md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.toDate\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" ng-change=\"vm.checkSchedule(\'to\')\" md-min-date=\"vm.minDate\" \nmd-max-date=\"vm.maxDate\" required></md-datepicker></md-input-container></div><div layout=\"column\" flex-gt-xs=\"25\" \nflex=\"100\" class=\"ph-10\" ng-if=\"isParent\"><md-input-container><label>\n{{ vm.selectedHotels.length == 1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{vm.hotelID == 126 ? 33 : 25}}\" flex=\"100\" class=\"ph-10\" ng-if=\"vm.hotelID == 126 || vm.hotelID == 122\">\n<md-input-container><label>Report For</label><md-select ng-model=\"vm.reportFor\"><md-optgroup label=\"Report For\">\n<md-option value=\"room\" selected=\"selected\">Hotel</md-option><md-option value=\"boat\">Marina</md-option><md-option \nvalue=\"rent\" ng-if=\"vm.hotelID == 126\">Residence</md-option></md-optgroup></md-select></md-input-container></div></div>\n<div layout=\"row\" flex=\"100\"><div layout=\"column\" flex-gt-xs=\"100\" flex=\"100\" class=\"ph-10 pb-20\" \nlayout-align=\"center end\"><div><div class=\"logo\"><md-button class=\"md-raised md-cornered\" ng-click=\"vm.getrecords();\" \nng-disabled=\"vm.requestProcessing\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\" \nng-click=\"getrecords();\"></md-icon>Refresh<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" \nmd-diameter=\"20px\" ng-show=\"vm.requestProcessing\"></md-progress-circular></md-button><md-button \nclass=\"md-raised md-cornered mr-10\" ng-if=\"vm.showExport\" ng-click=\"vm.exportFile(\'csv\')\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export to CSV<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.csvLoader\"></md-progress-circular></md-button>\n</div></div></div></div><div \nclass=\"Housekeepingtable-outermain Housekeepingtable incomereport income-report-table lodgingstatstable mt-20 ph-20 pb-20\" \nid=\"printSectionId\"><div class=\"outer_wrapper\" ng-if=\"vm.status\"><div class=\"heading_wrapper\"><div \nclass=\"duration-block\"><div class=\"duration-row\"><div class=\"duration-col\"><div class=\"duration-innerrow\"><span>\nDuration of block nights</span> <span>{{vm.grandData.block.nights}}</span></div></div><div class=\"duration-col\"><div \nclass=\"duration-innerrow\"><span>Duration of tentative nights</span> <span>{{vm.grandData.hold.nights}}</span></div>\n</div><div class=\"duration-col\"><div class=\"duration-innerrow\"><span>Block night revenue</span> <span>\n${{vm.grandData.block.revenue}}</span></div></div><div class=\"duration-col\"><div class=\"duration-innerrow\"><span>\nTentative night revenue</span> <span>${{vm.grandData.hold.revenue}}</span></div></div></div></div></div><div \nclass=\"inner_wrapper\" ng-repeat=\"type in vm.reservationObjKey\"><h2 class=\"heading-Nights\" ng-if=\"type == \'block\'\">\nBlocked</h2><h2 class=\"heading-Nights\" ng-if=\"type == \'hold\'\">Tentative</h2><div \nclass=\"block_wrapper product-table-block\"><div class=\"products_wrapper\"><div class=\"reservation_wrapper\" \nid=\"table-container\"><table class=\"simple margin-border product-table-wid\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"position:relative\" ng-class=\"heightTable{{type | split: \' \':0}}\" id=\"heightTable{{type}}\"><thead><tr \nclass=\"headerrow capitalize headingoutertb\"><th ng-if=\"type == \'block\'\">Blocked Id</th><th ng-if=\"type == \'hold\'\">\nTentative Id</th><th>Room</th><th>From</th><th>To</th><th>Nights In Range</th><th>Revenue</th><th>Reason</th><th>\ncreated By</th></tr></thead><tbody ng-style=\"vm.tableStyle\" ms-scroll style=\"position:relative\" \nclass=\"tbodyHeight{{type | split:\' \':0}} heightblockstatic\" id=\"tbodyHeight{{type}}\"><tr \nng-repeat=\"reservation in vm.reservationData[type]\" ng-if=\"vm.reservationData[type].length > 0\"><td>\n{{reservation.confirmation_number}}</td><td>{{reservation.product_name}}</td><td>{{reservation.room_stay_from}}</td>\n<td>{{reservation.room_stay_to}}</td><td>{{reservation.nights}}</td><td>${{reservation.nightly_revenue}}</td><td>\n{{reservation.reason}}</td><td>{{reservation.agent}}</td></tr><tr ng-if=\"vm.reservationData[type].length == 0\"><td>\nNo result found</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>\n&nbsp;</td></tr></tbody></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/reports/customer-advanced-deposit/customer-advanced-deposit.html","<div id=\"customer-advanced-deposit\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-currency-usd\" \nclass=\"mr-10\"></md-icon><span>Advanced Deposits</span></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container Housekeepingtable incomereport income-report-table CustomerAdvancedTable\"><div \nclass=\"table-title\">Advanced Deposits {{ vm.startDate | date:\'MM/dd/yyyy\'}}-{{ vm.endDate | date:\'MM/dd/yyyy\' }}</div>\n<div layout=\"row\" flex=\"100\" class=\"ph-10\" layout-wrap><div layout=\"column\" \nflex-gt-xs=\"{{isParent ? 25 : (vm.hotelID == 126 ? 33 : 50)}}\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Start Date</label>\n<md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.startDate\" ng-change=\"vm.ChangeEndDayIf()\" \nmd-open-on-focus ng-model-options=\"{debounce: 500}\" required></md-datepicker></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"{{isParent ? 25 : (vm.hotelID == 126 ? 33 : 50)}}\" flex=\"100\" class=\"ph-10\">\n<md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">\nEnd Date</label><md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.endDate\" md-min-date=\"vm.startDate\" \nmd-open-on-focus ng-model-options=\"{debounce: 500}\" required></md-datepicker></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\" ng-if=\"isParent\"><md-input-container><label>\n{{ vm.selectedHotels.length ==1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{isParent ? 25 : (vm.hotelID == 126 ? 33 : 50)}}\" flex=\"100\" class=\"ph-10\" \nng-if=\"vm.hotelID == 126 || isParent\"><md-input-container><label>Report For</label><md-select ng-model=\"vm.reportFor\">\n<md-optgroup label=\"Report For\"><md-option value=\"reservation\" selected=\"selected\">Hotel</md-option><md-option \nvalue=\"boat\">Marina</md-option></md-optgroup></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nclass=\"ph-10\" layout-wrap><div layout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\"><md-input-container \nng-if=\"false\"><label>Channel</label><md-select ng-model=\"vm.selectedChannels\" multiple=\"multiple\"><md-optgroup \nlabel=\"Channels\"><md-option ng-value=\"channel.channel_name\" ng-repeat=\"channel in vm.channels\">\n{{ channel.channel_name }}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"75\" flex=\"100\" class=\"ph-10\" layout-align=\"center end\"><div class=\"logo\"><md-button \nclass=\"md-raised md-cornered\" ng-click=\"vm.getCustomerAdvancedReports()\" ng-disabled=\"vm.requestProcessing\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessing\"></md-progress-circular>\n</md-button><md-button ng-if=\"vm.advanced_Customer.length > 0\" class=\"md-raised md-cornered\" \nng-click=\"downloadFile(vm.csvHeader,vm.csvArray,vm.csvName,undefined,vm.not_required)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\"vm.advanced_Customer.length > 0\" class=\"md-raised md-cornered\" \nng-click=\"vm.getPrintCustomerAdvancedReports(\'pdf\')\" ng-disabled=\"vm.requestPDF\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>Export as PDF<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestPDF\"></md-progress-circular>\n</md-button><md-button ng-if=\"vm.advanced_Customer.length > 0\" class=\"md-raised md-cornered\" \nng-click=\"vm.emailRecords()\" ng-disabled=\"vm.requestProcessingEmail\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_email_24px.svg\"></md-icon>Email Report<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessingEmail\">\n</md-progress-circular></md-button></div></div></div><div class=\"simple-table-container mt-20\" id=\"printSectionId\" \nng-show=\"!vm.noResultFound\"><div class=\"relativetableblk ph-20\"><div class=\"ms-responsive-table-wrapper relative\" \nms-scroll><table class=\"simple margin-border col14\" id=\"heightTable\" ng-show=\"vm.advanced_Customer\"><thead><tr \nclass=\"headerrow\"><th>Itinerary</th><th>Confirmation</th><th>Created On</th><th>Check In</th><th>Check Out</th><th>\nProduct</th><th>Customer</th><th>Gross Total</th><th>Paid</th><th>Remaining</th><th>Room Status</th><th>\nAdvanced Collected</th><th>Advanced Used</th></tr></thead><tbody id=\"tbodyHeight\" ng-style=\"vm.tableStyle\" ms-scroll \nstyle=\"position:relative\"><tr ng-repeat=\"(myKey, income) in vm.advanced_Customer\"><td class=\"cursorPointer\" \nng-click=\"goToState(income.itinerary_number, income.confirmation_number, \'\')\">{{income.itinerary_number}}</td><td \nclass=\"cursorPointer\" ng-click=\"goToState(income.itinerary_number, income.confirmation_number, \'\')\">\n{{income.confirmation_number}}</td><td>{{income.reservation_created_date_htz}}</td><td>{{income.room_stay_from_mdy}}\n</td><td>{{income.room_stay_to_mdy}}</td><td>{{income.product_name}}</td><td>{{income.customer_name}}</td><td>\n{{income.total_amount | currency : \"$\" : 2}}</td><td>{{income.total_paid_amount | currency : \"$\" : 2}}</td><td>\n{{income.total_remaining_amount | currency : \"$\" : 2}}</td><td>{{income.room_stay_status}}</td><td>\n{{(income.totalAdvanceCollected > 0) ? (income.totalAdvanceCollected | currency : \"$\" : 2) : \'--\'}}</td><td>\n{{(income.totalAdvanceUsed > 0) ? (income.totalAdvanceUsed | currency : \"$\" : 2) : \'--\'}}</td></tr><tr \nstyle=\"background: #f9f9f9; font-weight: bold !important\" class=\"total\"><td style=\"font-weight: bold !important\">Total\n</td><td colspan=\"10\" style=\"font-weight: bold !important\"></td><td style=\"font-weight: bold !important\">\n{{ vm.date_vise_total_collected | currency : \"$\" : 2 }}</td><td style=\"font-weight: bold !important\">\n{{ vm.date_vise_total_used | currency : \"$\" : 2 }}</td></tr></tbody></table></div></div></div><div \nclass=\"simple-table-container mt-20\" ng-show=\"vm.noResultFound\"><div \nclass=\"ms-responsive-table-wrapper ph-20 pb-20 norecordFound\"><span>No Result Found.</span></div></div><div \nclass=\"simple-table-container mt-20\" ng-if=\"vm.showSummaryTable\"><div class=\"ms-responsive-table-wrapper ph-20\"><table \nclass=\"simple margin-border col14\" id=\"summary-table\"><thead><tr class=\"headerrow\"><th>Advance Deposit Ledger Balance\n</th><th class=\"table-right-text\">Amount</th></tr></thead><tbody><tr><td>Advanced Deposit Used</td><td \nclass=\"table-right-text\">{{ vm.advance_used | currency : \"$\" : 2 }}</td></tr><tr><td>Advanced Deposit Outstanding</td>\n<td class=\"table-right-text\">{{ vm.advance_outstanding | currency : \"$\" : 2 }}</td></tr></tbody></table></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/reports/departure-invoices/departure-invoices.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-right-bold-circle\" \nclass=\"mr-10\"></md-icon><span>Departure Invoices</span></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container\"><div class=\"table-title\">Departure Invoices {{ vm.departureDate | date:\'MM/dd/yyyy\'}}\n</div><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex-gt-xs=\"{{isParent ? 33 : 50}}\" flex=\"100\" \nclass=\"ph-10\"><md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" \nrole=\"button\">Departure Date</label><md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.departureDate\" \nmd-open-on-focus ng-model-options=\"{debounce: 500}\" required></md-datepicker></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"33\" flex=\"100\" class=\"ph-10\" ng-if=\"isParent\"><md-input-container><label>\n{{ vm.selectedHotels.length == 1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{isParent ? 33 : 50}}\" flex=\"100\" class=\"ph-10\" ng-if=\"vm.hotelID == 126 || vm.hotelID == 122\">\n<md-input-container><label>Report For</label><md-select ng-model=\"vm.reportFor\"><md-optgroup label=\"Report For\">\n<md-option value=\"hotel\" selected=\"selected\">Hotel</md-option><md-option value=\"marina\">Marina</md-option>\n</md-optgroup></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\"><div layout=\"column\" \nflex-gt-xs=\"100\" flex=\"100\" class=\"ph-10 pb-20\" layout-align=\"center end\"><div><div class=\"logo\" \nlayout-align=\"center end\"><md-button class=\"md-raised md-cornered\" ng-click=\"vm.getDepartureReports()\" \nng-disabled=\"vm.requestProcessing\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\">\n</md-icon>Refresh<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.requestProcessing\"></md-progress-circular></md-button><md-button ng-if=\"vm.data.length > 0\" \nclass=\"md-raised md-cornered\" ng-click=\"vm.PrintAll(\'pdf\')\" ng-disabled=\"vm.requestProcessing\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/print.svg\"></md-icon>Print All<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessing\"></md-progress-circular>\n</md-button></div></div></div></div><div class=\"simple-table-container Housekeepingtable\" ng-repeat=\"data in vm.data\">\n<div class=\"address-block-main ph-20 mb-10\" layout=\"row\" flex=\"100\" layout-wrap><div flex=\"70\" flex-xs=\"100\" \nlayout=\"column\" layout-align=\"center start \"><div><div class=\"table-address\">{{data.address}}</div><div \nclass=\"table-number\">{{data.phone_number}}</div></div></div><div flex=\"30\" flex-xs=\"100\" layout=\"column\" \nlayout-align=\"start end \"><md-button class=\"md-raised md-cornered\" \nng-click=\"vm.printSingleOrder(data.confirmation_number)\" ng-init=\"vm.allIds.push(data.confirmation_number)\" \nng-disabled=\"vm.requestProcessing2\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/print.svg\">\n</md-icon>Print<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.requestProcessing2\"></md-progress-circular></md-button></div></div><div \nclass=\"ms-responsive-table-wrapper ph-20 pb-20\" id=\"table-container\"><table \nclass=\"departure-table simple margin-border\" id=\"heightTable\"><tbody id=\"tbodyHeight\" ng-style=\"vm.tableStyle\" \nms-scroll style=\"position:relative\"><tr class=\"capitalize\"><td>Name</td><td>{{data.first_name +\' \'+data.last_name}}\n</td><td>Arr-Dep</td><td>{{data.room_stay_from | date:\'dd/MM/yyyy\'}} - {{(data.room_stay_to | date:\"dd/MM/yyyy\")}}</td>\n<td>Charges</td><td>${{data.subtotal}}</td></tr><tr><td>Address</td><td>{{data.address}}</td><td>Recorded</td><td>\n{{data.created_date}}</td><td>Tax</td><td>${{data.tax}}</td></tr><tr><td>City</td><td>{{ data.city}}</td><td>\nConfirmation</td><td>{{ data.confirmation_number}}</td><td>Total</td><td>${{data.total_amount}}</td></tr><tr><td>State\n</td><td>{{ data.state}}</td><td>Party</td><td>{{data.party}}</td><td>Paid</td><td>${{data.total_paid_amount}}</td>\n</tr><tr><td>Telephone</td><td>{{data.phone_number}}</td><td>Credit Card</td><td>{{data.cc_type}}</td><td>Due</td><td>\n{{data.total_remaining_amount | currency:$:2}}</td></tr><tr \nng-if=\"(data.source_of_creation == \'Expedia\' && data.collect_which == \'channel_collect\') || data.source_of_creation == \'HotelTonight\' || data.source_of_creation == \'Getaroom.com\' || data.source_of_creation == \'Priceline.com\'\">\n<td></td><td></td><td></td><td></td><td>Ota Charges</td><td ng-if=\"data.source_of_creation == \'Priceline.com\'\">\n{{(data.subtotal*17.65/100) | currency:$:2}}</td><td ng-if=\"data.source_of_creation != \'Priceline.com\'\">\n{{(data.subtotal*21.95/100) | currency:$:2}}</td></tr><tr><td>Date</td><td>Description</td><td>Quantity</td><td>Price\n</td><td>Tax</td><td>Total</td></tr><tr ng-repeat=\"(posKey, singlePrice) in data.nightly_price track by $index\"><td>\n{{data.nightly_price_date[posKey]}}</td><td>{{data.rate_plan_ids[posKey]}}</td><td>1</td><td>\n{{singlePrice | currency:$:2}}</td><td>{{data.nightly_taxes[posKey] | currency:$:2}}</td><td>\n${{ vm.addNumbers(data.nightly_taxes[posKey], singlePrice, data.nightly_price_length) }}</td></tr><tr \nng-repeat=\"(payKey, payment) in data.allPayments track by $index\"><td>{{payment.date}}</td><td>\n{{payment.payment_method}}</td><td>{{payment.cc_fname+\' \'+payment.cc_lname}}</td><td>\n{{payment.original_paid_amount | currency:$:2}}</td><td></td><td></td></tr><tr ng-if=\"data.pos.length > 0\" \nng-repeat=\"singlePos in data.pos\"><td>-----</td><td>{{ singlePos.product_name }}</td><td>\n{{ singlePos.service_quantity}}</td><td>{{ singlePos.subtotal }}</td><td>{{ singlePos.tax_amount }}</td><td>\n{{ singlePos.grand_total }}</td></tr></tbody></table><table class=\"simple margin-border tabletotalblock\" \nms-responsive-table=\"\"><tr class=\"totalheading\"><td colspan=\"3\">Tax and Gratuity Details</td></tr><tr><td>Total</td>\n<td>:</td><td>${{ data.total_amount | number:2 }}</td></tr><tr><td>Paid</td><td>:</td><td>\n${{ data.total_paid_amount | number:2 }}</td></tr><tr><td>Due</td><td>:</td><td>\n{{ data.total_remaining_amount | currency : $ : 2}}</td></tr></table></div></div></div><div \nclass=\"simple-table-container ph-20 pb-20 norecordFound\" ng-if=\"vm.data.length == 0 && vm.init\"><div \nclass=\"ms-responsive-table-wrapper\">No Records Found.</div></div></div></div>");
$templateCache.put("app/main/apps/reports/gift-certificates/gift-certificates.html","<div id=\"gift-certificates\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-wallet-giftcard\" \nclass=\"mr-10\"></md-icon><span>Gift Certificates/Credits</span></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container Housekeepingtable incomereport income-report-table\"><div class=\"table-title\">\nGift Certificates/Credits {{ vm.startDate | date:\'MM/dd/yyyy\'}} - {{ vm.endDate | date:\'MM/dd/yyyy\' }}</div><div \nlayout=\"row\" flex=\"100\" class=\"ph-10\" layout-wrap><div layout=\"column\" flex-gt-xs=\"{{ isParent ? 33:50 }}\" flex=\"100\" \nclass=\"ph-10\"><md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" \nrole=\"button\">Start Date</label><md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.startDate\" \nng-change=\"vm.ChangeEndDayIf()\" md-open-on-focus ng-model-options=\"{debounce: 500}\" required></md-datepicker>\n</md-input-container></div><div layout=\"column\" flex-gt-xs=\"{{ isParent  ? 33:50 }}\" flex=\"100\" class=\"ph-10\">\n<md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">\nEnd Date</label><md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.endDate\" md-min-date=\"vm.startDate\" \nmd-open-on-focus ng-model-options=\"{debounce: 500}\" required></md-datepicker></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"33\" flex=\"100\" class=\"ph-10\" ng-if=\"isParent\"><md-input-container><label>\n{{ vm.selectedHotels.length == 1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\"><div \nlayout=\"column\" flex-gt-xs=\"100\" flex=\"100\" class=\"ph-10 pb-20\" layout-align=\"center end\"><div class=\"logo\"><md-button \nclass=\"md-raised md-cornered\" ng-click=\"vm.getGiftCards()\" ng-disabled=\"vm.requestProcessing\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessing\"></md-progress-circular>\n</md-button><md-button ng-if=\"vm.giftCards.length > 0 || vm.gcLedgerBalance\" class=\"md-raised md-cornered\" \nng-click=\"vm.downloadFile(vm.csvHeader,vm.giftCards,vm.csvName)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\"vm.giftCards.length > 0 || vm.gcLedgerBalance\" class=\"md-raised md-cornered\" \nng-click=\"vm.getPrintGiftCards(\'pdf\')\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\">\n</md-icon>Export as PDF</md-button><md-button ng-if=\"vm.giftCards.length > 0 || vm.gcLedgerBalance\" \nclass=\"md-raised md-cornered\" ng-click=\"vm.emailRecords()\" ng-disabled=\"vm.requestProcessingEmail\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_email_24px.svg\"></md-icon>Email Report<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessingEmail\">\n</md-progress-circular></md-button></div></div></div><div class=\"simple-table-container mt-20\" \nng-if=\"vm.giftCards.length > 0\" id=\"printSectionId\"><div class=\"ms-responsive-table-wrapper ph-20 pb-20\"><table \nclass=\"simple margin-border\" ms-responsive-table=\"\" id=\"heightTable\"><thead><tr class=\"headerrow\"><th>Issue Date</th>\n<th>Number</th><th>Purchaser</th><th>Expiration Date</th><th>Face Value</th><th>Redeemed</th><th>Remaining</th></tr>\n</thead><tbody id=\"tbodyHeight\" ng-style=\"vm.tableStyle\" ms-scroll style=\"position:relative\"><tr \nng-repeat=\"(myKey, gc) in vm.giftCards\" ng-click=\"vm.openGiftCard(gc)\"><td>{{gc.created_date}}</td><td><span \nclass=\"gift-card-link\">{{gc.gift_card_code}}</span></td><td>{{gc.gift_card_sender_name}}</td><td>\n{{gc.gift_card_expiration}}</td><td>{{gc.faceValue | currency:$:2}}</td><td>{{gc.reedemed | currency:$:2}}</td><td>\n{{gc.remaining | currency:$:2}}</td></tr></tbody></table></div></div><div class=\"simple-table-container mt-20\" \nng-show=\"vm.giftCards.length == 0 && vm.noResultFound && !vm.gcLedgerBalance\"><div \nclass=\"ms-responsive-table-wrapper ph-20 pb-20 norecordFound\"><span>No Result Found.</span></div></div><div \nclass=\"simple-table-container mt-20\" ng-if=\"vm.gcLedgerBalance\"><div class=\"ms-responsive-table-wrapper ph-20 pb-20\">\n<table class=\"simple margin-border tablelessvalues\" id=\"heightTables\"><thead><tr class=\"headerrow\"><th \nstyle=\"text-align: left\">Gift Certificate Ledger Balance</th><th style=\"text-align: right\">Amount</th></tr></thead>\n<tbody ng-style=\"vm.tableStyle\" ms-scroll style=\"position:relative\"><tr><td style=\"text-align: left\">\nGift Certificates Used</td><td style=\"text-align: right\">{{vm.gcLedger.used}}</td></tr><tr><td \nstyle=\"text-align: left\">Gift Certificates Outstanding</td><td style=\"text-align: right\">{{vm.gcLedger.outStanding}}\n</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/apps/reports/hold-report/hold-report.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar-clock\" \nclass=\"mr-10\"></md-icon><span>Courtesy Hold Report</span></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container Housekeepingtable incomereport hold-report-table\"><div class=\"table-title\">\nCourtesy Hold Report {{ (vm.startDate | date:\'MM/dd/yyyy\')+\' - \'+(vm.endDate | date:\'MM/dd/yyyy\')}}</div><div \nlayout=\"row\" flex=\"100\" class=\"ph-10\" layout-wrap><div layout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\">\n<md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">\nStart Date</label><md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.startDate\" \nng-change=\"vm.changeEndDayIf()\" md-open-on-focus ng-model-options=\"{debounce: 300}\" required></md-datepicker>\n</md-input-container></div><div layout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">End Date</label>\n<md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.endDate\" md-min-date=\"vm.startDate\" md-open-on-focus \nng-model-options=\"{debounce: 300}\" required></md-datepicker></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\"><md-input-container class=\"md-block mb-0\"><label>Status Options</label>\n<md-select ng-model=\"vm.selectedStatuses\" multiple=\"multiple\" ng-disabled=\"!vm.statusOptions.length\" \nng-change=\"vm.applyStatusFilter()\"><md-option ng-value=\"opt.value\" ng-repeat=\"opt in vm.statusOptions\">{{ opt.label }}\n</md-option></md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\">\n<md-input-container class=\"md-block mb-0\"><label>Converted Via</label><md-select ng-model=\"vm.selectedVias\" \nmultiple=\"multiple\" ng-change=\"vm.applyStatusFilter()\"><md-option ng-value=\"opt.value\" \nng-repeat=\"opt in vm.viaOptions\">{{ opt.label }}</md-option></md-select></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" class=\"ph-10 pb-20\" layout-align=\"space-between center\"><div class=\"wrapper_commision\" \nng-if=\"vm.init\"><p class=\"total_commission\">Total Holds : {{ vm.rows.length }}</p></div><div flex ng-if=\"!vm.init\">\n</div><div class=\"logo\"><md-button class=\"md-raised md-cornered\" ng-click=\"vm.getReport()\" \nng-disabled=\"vm.requestProcessing\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\">\n</md-icon>Refresh<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.requestProcessing\"></md-progress-circular></md-button><md-button ng-if=\"vm.csvData.length > 0\" \nclass=\"md-raised md-cornered\" ng-click=\"downloadFile(vm.csvHeader, vm.csvData, vm.csvName)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button></div></div><div \nid=\"table-container\" class=\"simple-table-container mt-20\" ng-if=\"vm.csvData.length > 0\"><div \nclass=\"ms-responsive-table-wrapper ph-20\"><table id=\"tableOuter\" class=\"simple margin-border\" ms-responsive-table=\"\" \nstyle=\"border:1px solid #dedede\"><thead><tr class=\"headerrow\"><td ng-repeat=\"heading in vm.headings\">{{ heading }}</td>\n</tr></thead><tbody><tr ng-repeat=\"row in vm.rows\" \nng-class=\"vm.hasBookingConfirmation(row) ? \'hold-row-clickable\' : \'hold-row-default\'\" \nng-click=\"vm.openBookingDetail(row)\"><td>{{ row.confirmation_number || \'--\' }}</td><td>\n{{ row.hold_created_at || \'--\' }}</td><td>{{ row.customer_name || \'--\' }}</td><td>{{ row.room_stay_from || \'--\' }}</td>\n<td>{{ row.room_stay_to || \'--\' }}</td><td>{{ row.product_name || \'--\' }}</td><td>{{ row.is_email_sent || \'--\' }}</td>\n<td>{{ row.is_link_clicked || \'--\' }}</td><td>{{ row.is_hold_converted || \'--\' }}</td><td>\n{{ row.converted_via || \'--\' }}</td><td>{{ row.converted_confirmation_number || \'--\' }}</td><td>\n{{ row.converted_amount || \'--\' }}</td></tr></tbody></table></div></div><div class=\"simple-table-container mt-20\" \nng-if=\"vm.init && vm.csvData.length === 0 && !vm.requestProcessing\"><div \nclass=\"ms-responsive-table-wrapper ph-20 pb-20 norecordFound\"><span>No Result Found.</span></div></div></div></div>\n</div>");
$templateCache.put("app/main/apps/reports/housekeeping/housekeeping.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-broom\" class=\"mr-10\">\n</md-icon><span>Housekeeping</span></div></div></div><div class=\"content\"><style type=\"text/css\">\n.errorMessage {\n                width: 100%;\n                padding: 14px 0px;\n            }\n            .condencedTableText td span.condenced-desc {\n                white-space: nowrap;\n                text-overflow: ellipsis;\n                overflow: hidden;\n                float: left;\n                max-width:400px;\n            }\n            .Housekeepingtable table{border:1px solid #dedede;margin-bottom:20px;}\n            .Housekeepingtable table .headerrow{background:#f1f1f1;}\n            .Housekeepingtable table.simple tbody tr th {\n                padding: 16px 8px;\n                border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n            }\n            .Housekeepingtable table.simple tbody tr td {\n                padding: 13px 12px;\n            }\n            .Housekeepingtable table.simple tbody tr th:last-child {\n                padding-right: 24px;\n            }\n            .Housekeepingtable table.simple tbody tr th:first-child {\n                padding-left: 24px;\n            }\n            .tabletotalblock tr td:first-child{width:60%;text-align:right;}\n            .tabletotalblock tr td:nth-child(2){width:10%;text-align:center;}\n            .tabletotalblock tr td:nth-child(3){width:20%;text-align:right;}\n            .tabletotalblock tr.totalheading td:first-child{width:100%;text-align:left;background:#f1f1f1;font-size:15px;}\n</style><div class=\"simple-table-container Housekeepingtable Housekeepingtablereport\"><div class=\"table-title\">\nHousekeeping {{ vm.departureDate | date:\'MM/dd/yyyy\'}}</div><div layout=\"row\" flex=\"100\" layout-wrap><div \nlayout=\"column\" flex-gt-xs=\"50\" flex=\"100\" class=\"ph-10\"><md-input-container class=\"md-block md-datepicker mb-0\" \ndata-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Date</label><md-datepicker \nclass=\"birthday-input1 no-padding\" ng-model=\"vm.departureDate\" md-open-on-focus ng-model-options=\"{debounce: 500}\" \nrequired></md-datepicker></md-input-container></div><div layout=\"column\" flex-gt-xs=\"50\" flex=\"100\" class=\"ph-10\" \nng-if=\"isParent === true\"><md-input-container><label>\n{{ vm.selectedHotels.length ==1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"100\" \nflex=\"100\" class=\"ph-10\" layout-align=\"center end\"><div><div class=\"logo\"><md-button \nclass=\"md-raised md-cornered mr-10\" ng-click=\"vm.getReports()\" ng-disabled=\"vm.refreshRequest\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.refreshRequest\"></md-progress-circular>\n</md-button><md-button ng-if=\"vm.all.length > 0 && isParent\" class=\"md-raised md-cornered\" \nng-click=\"downloadFile([\'Type\',\'Length\',\'Business Enity\',\'Unit\',\'Party\',\'Name\',\'Special Request\',\'POS Comment\'],vm.all,vm.csvName, \'type,days,hotel_title,product_name,party,name,special_request,pos_comment\')\">\n<md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\"vm.all.length > 0 && !isParent && vm.hotelID == 126\" class=\"md-raised md-cornered\" \nng-click=\"downloadFile([\'Type\',\'Length\',\'Unit\',\'Name\',\'Special Request\',\'POS Comment\',\'Room Status\'],vm.all,\'Housekeeping.csv\')\">\n<md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\"vm.all.length > 0 && !isParent && vm.hotelID != 126\" class=\"md-raised md-cornered\" \nng-click=\"downloadFile([\'Type\',\'Length\',\'Unit\',\'Party\',\'Name\',\'Special Request\',\'POS Comment\',\'Room Status\'],vm.all,\'Housekeeping.csv\')\">\n<md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\"vm.all.length > 0\" class=\"md-raised md-cornered\" ng-click=\"vm.getPrintReports(\'pdf\')\" \nng-disabled=\"vm.refreshRequestPDF\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.refreshRequestPDF\">\n</md-progress-circular>Export as PDF</md-button><md-button ng-if=\"vm.all.length > 0\" \nclass=\"md-raised md-cornered mr-10\" ng-click=\"vm.printData()\" ng-disabled=\"vm.printRequest\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/print.svg\"></md-icon>Print<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.printRequest\"></md-progress-circular>\n</md-button></div></div></div></div><div class=\"simple-table-container ph-20 pb-20 redesigncss\" id=\"printSectionId\" \nstyle=\"font-family:arial\"><style>\n@media print {\n                        table{\n                            border:1px solid #eeeeee;margin-bottom:10px;\n                        }\n                        table tr td,table tr th{\n                            padding:8px 10px;\n                            text-align:left;\n                            font-size: 12px;\n                        }\n                        table tr th{\n                            background: #eeeeee;\n                        }\n                        table tr:nth-child(2n) td{\n                            background:#f4f4f4;\n\n                        }\n                        .type{\n                            width:10%;\n                        }\n                        .unit{\n                            width:20%;\n                        }\n                        .Length,.Party{\n                            width:10%;\n                        }\n                         .Entity{\n\n                        }\n                        .name{\n                            width:20%;\n                        }\n                        .sr{\n                            width:25%;\n                        }\n                        .ps-scrollbar-y-rail{\n                            display: none;\n                        }\n                        .ps-scrollbar-x-rail{\n                            display: none;\n                        }\n                    }\n</style><div class=\"ms-responsive-table-wrapper\" ng-if=\"vm.all.length > 0\"><div ng-show=\"vm.print\" \nstyle=\"width:100%;display:block;margin-bottom:10px;border-bottom: 3px solid #dedede;overflow:hidden; margin-bottom:20px\">\n<div style=\"padding:13px 10px;width:auto;float:left\"><img src=\"{{vm.logo}}\" style=\"width:180px\"></div><div \nstyle=\"padding:25px 10px;float:right;vertical-align: middle;font-size:15px\">\nHousekeeping {{ vm.departureDate | date:\'MM/dd/yyyy\'}}</div></div><div \nstyle=\"width:100%;float:left;padding-bottom:20px\"><div style=\"padding:0px 0px 15px;font-weight: bold\">\nRoom Moves ({{vm.roomMove.length}})</div><table class=\"mysimpletable\" id=\"heightTable4\" cellpadding=\"0\" \ncellspacing=\"0\" ng-if=\"vm.roomMove.length>0\"><thead><tr><th class=\"type\">Itinerary</th><th class=\"Length\">Old Conf #\n</th><th class=\"Entity\">New Conf #</th><th class=\"unit\">Old Room</th><th class=\"Party\">New Room</th><th class=\"name\" \nng-if=\"isParent\">Business Entity</th><th class=\"Amount\">Amount Moved</th><th class=\"Guest\">Guest</th><th \nclass=\"NGuest\">Number of Guest</th></tr></thead><tbody ng-if=\"vm.roomMove.length > 0\" id=\"tbodyHeight4\" \nng-style=\"vm.tableStyle4\" ms-scroll style=\"position:relative\"><tr ng-repeat=\"rooms in vm.roomMove\"><td class=\"type\">\n{{rooms.itinerary_number}}</td><td class=\"Length\">{{rooms.oldConfirmationId}}</td><td class=\"Entity\">\n{{rooms.newConfirmationId}}</td><td class=\"unit\">{{rooms.roomFrom}}</td><td class=\"Party\">{{rooms.newRoom}}</td><td \nclass=\"name\" ng-if=\"isParent\">{{rooms.entity}}</td><td class=\"Amount\">{{rooms.grand_total | currency:$:2}}</td><td \nclass=\"Guest\">{{rooms.traveller}}</td><td class=\"NGuest\">{{rooms.guestCount}}</td></tr></tbody></table></div><div \nstyle=\"width:100%;float:left;padding-bottom:20px\"><div style=\"padding:0px 0px 15px;font-weight: bold\">\nArrivals ({{vm.arrivals.length}})</div><table class=\"mysimpletable\" id=\"heightTable\" cellpadding=\"0\" cellspacing=\"0\" \nng-if=\"vm.arrivals.length>0\"><thead><tr><th class=\"type\">Type</th><th class=\"Length\">Length</th><th ng-if=\"isParent\" \nclass=\"Entity\">Business Entity</th><th class=\"unit\">Unit</th><th class=\"arr\">Arrival Time</th><th class=\"Party\" \nng-if=\"vm.hotelID != 126\">Party</th><th class=\"name\">Name</th><th class=\"sr\">Special Request</th><th class=\"sr\">\nPOS Comment</th><th class=\"cs\">Room Status</th></tr></thead><tbody ng-if=\"vm.arrivals.length > 0\" id=\"tbodyHeight\" \nng-style=\"vm.tableStyle\" ms-scroll style=\"position:relative\"><tr ng-repeat=\"arrivals in vm.arrivals\"><td class=\"type\">\nArrival</td><td class=\"Length\">{{arrivals.days}}</td><td ng-if=\"isParent\" class=\"Entity\">{{arrivals.hotel_title }}</td>\n<td class=\"unit\">{{arrivals.product_name }}</td><td class=\"arr\">{{arrivals.arrival_time}}</td><td class=\"Party\" \nng-if=\"vm.hotelID != 126\">{{arrivals.party}}</td><td class=\"name\">{{arrivals.name}}</td><td class=\"sr\" \nbind-html-compile=\"arrivals.special_request\">{{arrivals.special_request }}</td><td class=\"sr\" \nbind-html-compile=\"arrivals.pos_comment\">{{arrivals.pos_comment }}</td><td class=\"cs\" \nng-if=\"arrivals.product_is_clean == 0\">Full Cleaning</td><td class=\"cs\" ng-if=\"arrivals.product_is_clean == 1\">Clean\n</td><td class=\"cs\" ng-if=\"arrivals.product_is_clean == 2\">Light Cleaning</td></tr></tbody></table></div><div \nstyle=\"width:100%;float:left;padding-bottom:20px\"><div style=\"padding:0px 0px 15px;font-weight: bold\">\nDepartures ({{vm.departure.length}})</div><table class=\"mysimpletable\" id=\"heightTable2\" cellpadding=\"0\" \ncellspacing=\"0\" ng-if=\"vm.departure.length>0\"><thead><tr><th class=\"type\">Type</th><th class=\"Length\">Length</th><th \nng-if=\"isParent\" class=\"Entity\">Business Entity</th><th class=\"unit\">Unit</th><th class=\"Party\" \nng-if=\"vm.hotelID != 126\">Party</th><th class=\"name\">Name</th><th class=\"sr\">Special Request</th><th class=\"sr\">\nPOS Comment</th><th class=\"cs\">Room Status</th></tr></thead><tbody ng-if=\"vm.departure.length > 0\" id=\"tbodyHeight2\" \nng-style=\"vm.tableStyle2\" ms-scroll style=\"position:relative\"><tr ng-repeat=\"departure in vm.departure\"><td \nclass=\"type\">Departure</td><td class=\"Length\">{{departure.days}}</td><td ng-if=\"isParent\" class=\"Entity\">\n{{departure.hotel_title }}</td><td class=\"unit\">{{departure.product_name }}</td><td class=\"Party\" \nng-if=\"vm.hotelID != 126\">{{departure.party}}</td><td class=\"name\">{{departure.name}}</td><td class=\"sr\" \nbind-html-compile=\"departure.special_request\">{{departure.special_request }}</td><td class=\"sr\" \nbind-html-compile=\"departure.pos_comment\">{{departure.pos_comment }}</td><td class=\"cs\" \nng-if=\"departure.product_is_clean == 0\">Full Cleaning</td><td class=\"cs\" ng-if=\"departure.product_is_clean == 1\">Clean\n</td><td class=\"cs\" ng-if=\"departure.product_is_clean == 2\">Light Cleaning</td></tr></tbody></table></div><div \nstyle=\"width:100%;float:left;padding-bottom:20px\"><div style=\"padding:0px 0px 15px;font-weight: bold\">\nStayovers ({{vm.stayovers.length}})</div><table class=\"mysimpletable\" id=\"heightTable3\" cellpadding=\"0\" \ncellspacing=\"0\" ng-if=\"vm.stayovers.length>0\"><thead><tr><th class=\"type\">Type</th><th class=\"Length\">Length</th><th \nng-if=\"isParent\" class=\"Entity\">Business Entity</th><th class=\"unit\">Unit</th><th class=\"Party\" \nng-if=\"vm.hotelID != 126\">Party</th><th class=\"name\">Name</th><th class=\"sr\">Special Request</th><th class=\"sr\">\nPOS Comment</th><th class=\"cs\">Room Status</th></tr></thead><tbody ng-if=\"vm.stayovers.length > 0\" id=\"tbodyHeight3\" \nng-style=\"vm.tableStyle3\" ms-scroll style=\"position:relative\"><tr ng-repeat=\"stayovers in vm.stayovers\"><td \nclass=\"type\">Stayover</td><td class=\"Length\">{{stayovers.days}}</td><td ng-if=\"isParent\" class=\"Entity\">\n{{stayovers.hotel_title }}</td><td class=\"unit\">{{stayovers.product_name }}</td><td class=\"Party\" \nng-if=\"vm.hotelID != 126\">{{stayovers.party}}</td><td class=\"name\">{{stayovers.name}}</td><td class=\"sr\" \nbind-html-compile=\"stayovers.special_request\">{{stayovers.special_request }}</td><td class=\"sr\" \nbind-html-compile=\"stayovers.pos_comment\">{{stayovers.pos_comment }}</td><td class=\"cs\" \nng-if=\"stayovers.product_is_clean == 0\">Full Cleaning</td><td class=\"cs\" ng-if=\"stayovers.product_is_clean == 1\">Clean\n</td><td class=\"cs\" ng-if=\"stayovers.product_is_clean == 2\">Light Cleaning</td></tr></tbody></table></div></div></div>\n<div class=\"simple-table-container ph-20 pb-20 norecordFound\" ng-show=\"vm.all.length == 0 && vm.init\"><div \nclass=\"ms-responsive-table-wrapper\">No Data Found</div></div></div></div></div>");
$templateCache.put("app/main/apps/reports/income-report/income-report.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" onscroll=\"vm.onScroll()\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-currency-usd\" \nclass=\"mr-10\"></md-icon><span>Income</span></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container Housekeepingtable incomereport income-report-table\"><div class=\"table-title\">\nIncome Report</div><div layout=\"row\" flex=\"100\" class=\"ph-10\" layout-wrap><div layout=\"column\" flex-gt-xs=\"25\" \nflex=\"100\" class=\"ph-10\"><md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label \nclass=\"ng-scope\" role=\"button\">Check-In From</label><md-datepicker class=\"birthday-input1 no-padding\" \nng-model=\"vm.checkInDate\" md-open-on-focus ng-model-options=\"{debounce: 300}\" ng-change=\"vm.changeCheckDates()\">\n</md-datepicker></md-input-container></div><div layout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\">\n<md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">\nCheck-In To</label><md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.checkOutDate\" \nmd-min-date=\"vm.checkInDate\" md-open-on-focus ng-model-options=\"{debounce: 300}\" ng-change=\"vm.changeCheckDates()\">\n</md-datepicker></md-input-container></div><div layout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\">\n<md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">\nPayment Date From</label><md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.startDate\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" ng-change=\"vm.changePayDates()\"></md-datepicker></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\"><md-input-container class=\"md-block md-datepicker mb-0\" \ndata-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Payment Date Upto</label><md-datepicker \nclass=\"birthday-input1 no-padding\" ng-model=\"vm.endDate\" md-min-date=\"vm.startDate\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" ng-change=\"vm.changePayDates()\"></md-datepicker></md-input-container></div></div>\n<div layout=\"row\" flex=\"100\" class=\"ph-10\" layout-wrap><div layout=\"column\" \nflex-gt-xs=\"{{ (isParent || vm.showReportFor) ? 25:33 }}\" flex=\"100\" class=\"ph-20\"><md-input-container><label>Channel\n</label><md-select ng-model=\"vm.selectedChannels\" multiple=\"multiple\"><md-optgroup label=\"Channels\"><md-option \nng-value=\"channel.channel_name\" ng-repeat=\"channel in vm.channels\">{{ channel.channel_name }}</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"{{ (isParent || vm.showReportFor) ? 25:33 }}\" \nflex=\"100\" class=\"ph-20\"><md-input-container><label>Payment Method</label><md-select \nng-model=\"vm.selectedPaymentMethods\" multiple=\"multiple\"><md-optgroup label=\"Payment Method\"><md-option value=\"Cash\">\nCash</md-option><md-option value=\"Credit Card\">Credit Card</md-option><md-option value=\"Check\">Check</md-option>\n<md-option value=\"Other\">Other</md-option><md-option value=\"Gift Card\">Gift Card</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout=\"column\" flex-gt-xs=\"{{ (isParent || vm.showReportFor) ? 25:33 }}\" flex=\"100\" \nclass=\"ph-10\" ng-if=\"isParent\"><md-input-container><label>\n{{ vm.selectedHotels.length ==1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{ (isParent || vm.showReportFor) ? 25:33 }}\" ng-if=\"vm.showReportFor\" flex=\"100\" class=\"ph-10\">\n<md-input-container><label>Report For</label><md-select ng-model=\"vm.reportFor\"><md-optgroup label=\"Report For\">\n<md-option value=\"reservation\" selected=\"selected\">Hotel</md-option><md-option value=\"boat\">Marina</md-option>\n<md-option value=\"rent\">Residence</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{ (isParent || vm.showReportFor) ? 25:33 }}\" flex=\"100\" class=\"ph-10\"><md-input-container><label>\nReport Type</label><md-select ng-model=\"vm.reportType\" ng-change=\"vm.changeReportType()\"><md-optgroup \nlabel=\"Report Type\"><md-option value=\"overAll\" selected=\"selected\">Income Overview</md-option><md-option \nvalue=\"detailed\">Income Detail</md-option></md-optgroup></md-select></md-input-container></div></div><div layout=\"row\" \nflex=\"100\" class=\"ph-10\" layout-wrap ng-if=\"isParent\"><div layout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\">\n<md-input-container><label>Report For</label><md-select ng-model=\"vm.reportFor\"><md-optgroup label=\"Report For\">\n<md-option value=\"reservation\" selected=\"selected\">Hotel</md-option><md-option value=\"boat\">Marina</md-option>\n</md-optgroup></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" class=\"ph-10\" layout-wrap><div \nlayout=\"column\" flex-gt-xs=\"100\" flex=\"100\" class=\"ph-10\" layout-align=\"start end\"><div class=\"logo\"><md-button \nclass=\"md-raised md-cornered\" ng-click=\"vm.getIncomeReport()\" ng-disabled=\"vm.requestProcessing || vm.disableRefresh\">\n<md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessing\">\n</md-progress-circular></md-button><md-button ng-if=\"vm.allData.length > 0\" class=\"md-raised md-cornered\" \nng-click=\"vm.downloadFileCustom(vm.reportType)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\"vm.allData.length > 0\" class=\"md-raised md-cornered\" ng-click=\"vm.getIncomePrintReport(\'pdf\')\" \nng-disabled=\"vm.requestPDF\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestPDF\">\n</md-progress-circular>Export as PDF</md-button><md-button ng-if=\"vm.allData.length > 0\" class=\"md-raised md-cornered\" \nng-click=\"vm.printRecords()\" ng-disabled=\"vm.requestProcessingEmail\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_email_24px.svg\"></md-icon>Email Report<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessingEmail\">\n</md-progress-circular></md-button></div></div></div><div id=\"table-container\" class=\"simple-table-container mt-20\" \nng-show=\"!vm.noResultFound\"><div class=\"ms-responsive-table-wrapper ph-20\" ng-init=\"rowCount = 1\"><table \nid=\"heightTable{{$index}}\" class=\"simple margin-border customTable\" ng-show=\"vm.allData.length  > 0\" \nng-repeat=\"(parentKey, dateData) in vm.incomeData;\" style=\"position:relative\" ms-responsive-table=\"\"><thead><th \ncolspan=\"24\" ng-if=\"isParent\">{{parentKey}}</th><tr class=\"headerrow\"><td>Itinerary</td><td>Confirmation</td><td \nng-if=\"vm.reportType==\'detailed\'\">Date</td><td>Status</td><td>Checkin</td><td>Checkout</td><td>Customer</td><td>\nQuantity</td><td>Item</td><td>Number of Nights</td><td>Business Entity</td><td>Source</td><td>Employee</td><td>\nSub Total</td><td>Discount</td><td ng-repeat=\"(key, tax) in vm.taxesArray\">{{vm.taxesNamesArray[key] | titleCase}} \n<span ng-if=\"tax.indexOf(\'percentage\') !== -1\">(%)</span> <span ng-if=\"tax.indexOf(\'amount\') !== -1\">($)</span></td>\n<td>Total</td><td>Paid</td><td>Remaining</td><td>Reservation Total</td><td>Payment Method(s)</td><td>\nPaid Within Report Range</td></tr></thead><tbody id=\"tbodyHeight\" ng-style=\"vm.tableStyle\" ms-scroll \nstyle=\"position:relative\"><tr ng-repeat=\"(date, income) in dateData\"><td class=\"cursorPointer\" \nng-init=\"vm.calculateTotal(income, parentKey)\" \nng-click=\"goToState(income.itinerary_number, income.confirmation_number, \'\')\">{{income.itinerary_number}}</td><td \nclass=\"cursorPointer\" ng-click=\"goToState(income.itinerary_number, income.confirmation_number, \'\')\">\n{{income.confirmation_number}}</td><td ng-if=\"vm.reportType==\'detailed\'\">{{income.installment_paid_date}}</td><td>\n{{income.room_stay_status}}</td><td>{{income.room_stay_from}}</td><td>{{income.room_stay_to}}</td><td>\n{{income.Customer}}</td><td>{{income.quantity}}</td><td>{{income.product_name}}</td><td>{{income.NoOfNights}}</td><td>\n{{income.hotel_title}}</td><td>{{income.source_of_creation}}</td><td>{{income.Employee}}</td><td>\n{{income.subtotal | currency : $ : 2}}</td><td>{{income.product_discount | currency : $ : 2}}</td><td \nng-repeat=\"(key, tax) in vm.taxesArray\"><span ng-if=\"tax.indexOf(\'percentage\') !== -1\">\n{{income[tax] ? income[tax] : \'0.00\'}} %</span> <span ng-if=\"tax.indexOf(\'amount\') !== -1\">\n{{ (income[tax] ? income[tax] : 0) | currency : $ : 2}}</span></td><td>{{income.grand_total | currency : $ : 2}}</td>\n<td>{{income.total_paid_amount | currency : $ : 2}}</td><td>{{income.total_remaining_amount | currency : $ : 2}}</td>\n<td>{{income.totalPaid | currency : $ : 2}}</td><td>{{ income.payment_method}}</td><td>\n{{ income.paidToday | currency : $ : 2}}</td></tr><tr class=\"total\"><td></td><td></td><td \nng-if=\"vm.reportType==\'detailed\'\"></td><td></td><td></td><td></td><td></td><td>{{vm.overAll[parentKey][\'quantity\']}}\n</td><td></td><td>{{vm.overAll[parentKey][\'NoOfNights\']}}</td><td></td><td></td><td></td><td>\n{{vm.overAll[parentKey][\'subtotal\'] | currency : $ : 2}}</td><td>{{income.product_discount | currency : $ : 2}}</td><td\n ng-repeat=\"(key, tax) in vm.taxesArray\"></td><td>{{vm.overAll[parentKey][\'grand_total\'] | currency : $ : 2}}</td><td>\n{{vm.overAll[parentKey][\'total_paid_amount\'] | currency : $ : 2}}</td><td>\n{{vm.overAll[parentKey][\'total_remaining_amount\'] | currency : $ : 2}}</td><td>\n{{vm.overAll[parentKey][\'totalPaid\'] | currency : $ : 2}}</td><td></td><td>\n{{vm.overAll[parentKey][\'paidToday\'] | currency : $ : 2}}</td></tr></tbody></table></div></div><div \nclass=\"simple-table-container mt-20\"><div class=\"ms-responsive-table-wrapper ph-20 pb-20 norecordFound\" \nng-show=\"vm.noResultFound\">No Result Found</div></div></div></div></div>");
$templateCache.put("app/main/apps/reports/light-cleaning/light-cleaning.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><span class=\"icon-light-cleaning-white\" \nstyle=\"width: 40px; margin-right: 0;position:relative;height: 21px\"></span> <span>Light Cleaning</span></div></div>\n</div><div class=\"content\"><style type=\"text/css\">\n.errorMessage {\n                width: 100%;\n                padding: 14px 0px;\n            }\n            .condencedTableText td span.condenced-desc {\n                white-space: nowrap;\n                text-overflow: ellipsis;\n                overflow: hidden;\n                float: left;\n                max-width:400px;\n            }\n            .Housekeepingtable table{border:1px solid #dedede;margin-bottom:20px;}\n            .Housekeepingtable table .headerrow{background:#f1f1f1;}\n            .Housekeepingtable table.simple tbody tr th {\n                padding: 16px 8px;\n                border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n            }\n            .Housekeepingtable table.simple tbody tr td {\n                padding: 13px 12px;\n            }\n            .Housekeepingtable table.simple tbody tr th:last-child {\n                padding-right: 24px;\n            }\n            .Housekeepingtable table.simple tbody tr th:first-child {\n                padding-left: 24px;\n            }\n            .tabletotalblock tr td:first-child{width:60%;text-align:right;}\n            .tabletotalblock tr td:nth-child(2){width:10%;text-align:center;}\n            .tabletotalblock tr td:nth-child(3){width:20%;text-align:right;}\n            .tabletotalblock tr.totalheading td:first-child{width:100%;text-align:left;background:#f1f1f1;font-size:15px;}\n</style><div class=\"simple-table-container Housekeepingtable\"><div class=\"table-title\">\nLight Cleaning {{ vm.departureDate | date:\'MM/dd/yyyy\'}}</div><div layout=\"row\" flex=\"100\" layout-wrap><div \nlayout=\"column\" flex-gt-xs=\"50\" flex=\"100\" class=\"ph-10\"><md-input-container class=\"md-block md-datepicker mb-0\" \ndata-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Date</label><md-datepicker \nclass=\"birthday-input1 no-padding\" ng-model=\"vm.departureDate\" md-open-on-focus ng-model-options=\"{debounce: 500}\" \nrequired></md-datepicker></md-input-container></div><div layout=\"column\" flex-gt-xs=\"50\" flex=\"100\" class=\"ph-10\" \nng-if=\"isParent === true\"><md-input-container><label>\n{{ vm.selectedHotels.length ==1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\"><div \nlayout=\"column\" flex-gt-xs=\"100\" flex=\"100\" class=\"ph-10 pb-20\" layout-align=\"center end\"><div><div class=\"logo\">\n<md-button class=\"md-raised md-cornered mr-10\" ng-click=\"vm.getReports()\" ng-disabled=\"vm.refreshRequest\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.refreshRequest\"></md-progress-circular>\n</md-button><md-button ng-if=\"vm.all.length > 0\" class=\"md-raised md-cornered\" \nng-click=\"downloadFile([\'Name\',\'Confirmation Number\',\'Unit\',\'Checkin\',\'Checkout\'],vm.all,vm.csvName)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\"vm.all.length > 0\" class=\"md-raised md-cornered\" ng-click=\"vm.getPrintReports(\'pdf\')\" \nng-disabled=\"vm.refreshRequestPDF\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.refreshRequestPDF\">\n</md-progress-circular>Export as PDF</md-button><md-button ng-if=\"vm.all.length > 0\" \nclass=\"md-raised md-cornered mr-10\" ng-click=\"vm.printData()\" ng-disabled=\"vm.printRequest\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/print.svg\"></md-icon>Print<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.printRequest\"></md-progress-circular>\n</md-button></div></div></div></div><div class=\"simple-table-container ph-20\" id=\"printSectionId\"><div \nclass=\"ms-responsive-table-wrapper\" ng-if=\"vm.all.length > 0\"><table class=\"simple margin-border table-blockmain\" \ncellpadding=\"0\" cellspacing=\"0\" style=\"border:1px solid #dedede;font-family: arial\"><thead ng-show=\"vm.print\"><td \ncolspan=\"3\" style=\"padding:13px 10px\"><img src=\"{{vm.logo}}\" style=\"width:300px\"></td><td colspan=\"3\" \nstyle=\"padding:13px 10px;text-align: right;vertical-align: middle;font-size:15px\">\nLight Cleaning {{ vm.departureDate | date:\'MM/dd/yyyy\'}}</td></thead><tbody ng-if=\"vm.lightCleaningData.length > 0\">\n<tr><td colspan=\"6\" style=\"padding:15px 10px;font-weight: bold\">Light Cleaning({{vm.lightCleaningData.length}})</td>\n</tr><tr style=\"width:100%;background: #f1f1f1\"><th style=\"padding:10px 10px;text-align:left\">Name</th><th \nstyle=\"padding:10px 10px;text-align:left\">Confirmation Number</th><th style=\"padding:10px 10px;text-align:left\">Unit\n</th><th style=\"padding:10px 10px;text-align:left;min-width:150px\">Checkin</th><th \nstyle=\"padding:10px 10px;text-align:left\">Checkout</th></tr><tr ng-repeat=\"lightCleaning in vm.lightCleaningData\"><td \nstyle=\"padding:7px 10px\">{{lightCleaning.name}}</td><td style=\"padding:7px 10px\">{{lightCleaning.confirmation_number }}\n</td><td style=\"padding:7px 10px\">{{lightCleaning.product_name }}</td><td style=\"padding:7px 10px\">\n{{lightCleaning.room_stay_from}}</td><td style=\"padding:7px 10px\">{{lightCleaning.room_stay_to}}</td></tr></tbody>\n</table></div></div><div class=\"simple-table-container ph-20 pb-20 norecordFound\" \nng-show=\"vm.all.length == 0 && vm.init\"><div class=\"ms-responsive-table-wrapper\">No Data Found</div></div></div></div>\n</div>");
$templateCache.put("app/main/apps/reports/lodging-statistic/lodging-detail.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-chart-line\" \nclass=\"mr-10\"></md-icon><span ng-if=\"vm.reportType == \'lodgingStats\'\">Lodging Statistics Detail</span> <span \nng-if=\"vm.reportType == \'nightAudit\'\">Night Audit Detail</span> <span ng-if=\"vm.reportType == \'taxReport\'\">\nTax Report Detail</span> <span ng-if=\"vm.reportType == \'revenueManagement\'\">Revenue Management Detail</span></div>\n</div></div><div class=\"content loadingstatistic\"><div class=\"simple-table-container\"><div class=\"table-title\" \nng-if=\"vm.reportType == \'lodgingStats\'\">Detail of {{vm.heading}} for date {{vm.searchedDate}}</div><div \nclass=\"table-title\" ng-if=\"vm.reportType == \'nightAudit\'\">\nDetail of {{vm.heading}} from {{vm.startDate}} to {{vm.endDate}}</div><div class=\"table-title\" \nng-if=\"vm.reportType == \'taxReport\'\">Detail of {{vm.heading}} from {{vm.startDate}} to {{vm.endDate}}</div><div \nclass=\"table-title\" ng-if=\"vm.reportType == \'revenueManagement\' && vm.searchedArg == \'channelBookings\'\">\nDetails of {{vm.heading}}\'s Reservations</div><div class=\"table-title\" \nng-if=\"vm.reportType == \'revenueManagement\' && vm.searchedArg != \'channelBookings\'\">Detail of {{vm.heading}}</div><div \nclass=\"commision_divs lodging-detail-div\"><div class=\"wrapper_commision lodging-detail\"><div class=\"commision_inner\"><p\n class=\"total_commission\" ng-if=\"vm.subHeading != \'\'\">{{vm.subHeading}} : {{vm.totalNightPrice}}</p><p \nclass=\"total_commission\" ng-if=\"vm.subHeading == \'\' && vm.reportType != \'revenueManagement\'\">\nTotal Nightly Price : ${{vm.totalNightPrice}}</p><p class=\"total_commission\" \nng-if=\"vm.reportType == \'revenueManagement\'\">\n{{ vm.searchedArg == \'occupancyPercentage\' ? (vm.hasGrandAverageOccupancy ? \'Total occupancy percentage\' : \'Total Count\') : \'Total Reservations\' }} : {{ vm.searchedArg == \'occupancyPercentage\' && vm.hasGrandAverageOccupancy ? vm.grandAverageOccupancy : vm.data.length }}\n</p><p class=\"total_commission\" ng-if=\"vm.reportType == \'revenueManagement\' && vm.searchedArg == \'roomSold\'\">\nTotal Nights : {{vm.totalNights}}</p><p class=\"total_commission\" \nng-if=\"vm.reportType == \'revenueManagement\' && vm.searchedArg == \'roomSales\'\">\nTotal Sales : {{vm.totalNightPrice | currency:\"$\"}}</p><p class=\"total_commission\" \nng-repeat=\"(key, value) in vm.appliedTaxes\">Total {{key}}: {{value}}</p></div></div><div class=\"export-detail\">\n<md-button ng-if=\"vm.csvData.length > 0\" class=\"md-raised md-cornered\" \nng-click=\"downloadFile(vm.csvHeader, vm.csvData, vm.csvName)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button></div></div><div \nclass=\"Housekeepingtable incomereport income-report-table lodgingstatstable mt-20 ph-20 pb-20\" id=\"printSectionId\" \nng-if=\"vm.columns.length > 0\"><md-table-container><table md-table multiple=\"multiple\" ng-model=\"selected\" \nid=\"heightTable\" class=\"simple col30\"><thead md-head md-order=\"query.order\" md-on-reorder=\"getrecords\"><tr md-row \nclass=\"headerrow capitalize headingoutertb\"><th ng-repeat=\"heading in vm.columns\">{{heading}}</th></tr></thead><tbody \nmd-body id=\"tbodyHeight\" ng-style=\"vm.tableStyle\" ms-scroll style=\"position:relative\"><tr md-row md-select=\"dessert\" \nmd-select-id=\"name\" md-auto-select ng-repeat=\"reportdata in vm.data\" ng-if=\"vm.data.length > 0\"><td \nclass=\"detail-td td-{{$index}}\" ng-class=\"vm.clickForDetail ? \'click\' : \'\'\" md-cell \nng-click=\"vm.clickForDetail && vm.goToDetail($index, values, reportdata)\" \nng-repeat=\"(key, values) in reportdata track by $index\" \nng-if=\"key !== \'reservation_id\' || vm.searchedArg !== \'roomCancel\'\"><span \nng-if=\"vm.searchedArg == \'roomCancel\' && (key === \'refunded_deposit\' || key === \'non_refunded_deposit\')\">\n{{ values | currency:\"$\" }} </span><span \nng-if=\"vm.searchedArg != \'roomCancel\' || (key !== \'refunded_deposit\' && key !== \'non_refunded_deposit\')\">{{ values }}\n<md-tooltip ng-if=\"key === \'refund_method\'\">{{ vm.getRefundMethodTooltip(values) }}</md-tooltip></span></td></tr><tr \nmd-row class=\"total-row\" ng-if=\"vm.data.length && vm.searchedArg == \'roomCancel\'\"><td \nng-repeat=\"heading in vm.columns\"><span ng-switch=\"heading.toLowerCase()\"><strong ng-switch-when=\"refunded deposit\">\n{{vm.totalRefundDeposit | currency:\"$\"}} </strong><strong ng-switch-when=\"non refunded deposit\">\n{{vm.totalNonRefundDeposit | currency:\"$\"}} </strong><strong ng-switch-default>{{$first ? \'Total\' : \'\'}}</strong>\n</span></td></tr><tr md-row md-select=\"dessert\" md-select-id=\"name\" ng-if=\"vm.data.length == 0\"><td \ncolspan=\"{{vm.columns.length}}\">No Result Found</td></tr></tbody></table></md-table-container></div></div></div></div>\n<style type=\"text/css\">\n.Housekeepingtable.incomereport.income-report-table .simple.col30 tbody tr td {cursor:initial;}\n.Housekeepingtable.incomereport.income-report-table .simple.col30 tbody tr td.td-0.click {cursor:pointer;}\n.Housekeepingtable.incomereport.income-report-table .simple.col30 tbody tr td.td-1.click {cursor:pointer;}\n</style>");
$templateCache.put("app/main/apps/reports/lodging-statistic/lodging-statistic-new.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-chart-line\" \nclass=\"mr-10\"></md-icon><span>Lodging Statistics</span></div></div></div><div class=\"content loadingstatistic\"><div \nclass=\"simple-table-container\"><div class=\"table-title\">\nLodging Statistics {{ (vm.fromdate | date:\'MM/dd/yyyy\')+\' - \'+(vm.todate | date:\'MM/dd/yyyy\')}}</div><div layout=\"row\" \nflex=\"100\" layout-wrap><div layout=\"column\" flex-gt-xs=\"{{isParent ? 25 : (vm.hotelID == 126 ? 33 : 50)}}\" flex=\"100\" \nclass=\"ph-10\"><md-input-container class=\"md-block full-width mb-0\"><label translate=\"REPORT.START\"></label>\n<md-datepicker md-open-on-focus ng-model=\"vm.fromdate\" md-min-date=\"vm.initialDate\" class=\"full-width mdinput-block\" \nng-change=\"vm.ChangeEndDayIf()\"></md-datepicker><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"{{isParent ? 25 : (vm.hotelID == 126 ? 33 : 50)}}\" flex=\"100\" class=\"ph-10\">\n<md-input-container class=\"md-block full-width mb-0\"><label translate=\"REPORT.END\"></label><md-datepicker \nmd-open-on-focus ng-model=\"vm.todate\" md-min-date=\"vm.fromdate\" class=\"full-width mdinput-block\"></md-datepicker><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div layout=\"column\" flex-gt-xs=\"{{isParent ? 25 : 50}}\" \nflex=\"100\" class=\"ph-10\" ng-if=\"isParent === true\"><md-input-container><label>\n{{ vm.selectedHotels.length > 0 ? \'Buisness Entity\': \'All\' }}</label><md-select ng-model=\"vm.selectedHotels\" \nmultiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">{{hotel.hotel_title}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"33\" flex=\"100\" class=\"ph-10\" \nng-if=\"vm.hotelID == 126\"><md-input-container><label>Report For</label><md-select ng-model=\"vm.reportFor\"><md-optgroup \nlabel=\"Report For\"><md-option value=\"hotel\" selected=\"selected\">Hotel</md-option><md-option value=\"marina\">Marina\n</md-option><md-option value=\"rent\">Residence</md-option></md-optgroup></md-select></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\" ng-if=\"vm.hotelID == 122\"><md-input-container><label>\nReport For</label><md-select ng-model=\"vm.reportFor\"><md-optgroup label=\"Report For\"><md-option value=\"hotel\" \nselected=\"selected\">Hotel</md-option><md-option value=\"marina\">Marina</md-option></md-optgroup></md-select>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\"><div layout=\"column\" flex-gt-xs=\"100\" flex=\"100\" \nclass=\"ph-10 pb-20\" layout-align=\"center end\"><div><div class=\"logo\"><md-button class=\"md-raised md-cornered\" \nng-click=\"vm.getrecords();\" ng-disabled=\"vm.requestProcessing\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\" ng-click=\"getrecords();\"></md-icon>Refresh\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessing\">\n</md-progress-circular></md-button><md-button ng-if=\"vm.csvData.length > 0\" class=\"md-raised md-cornered\" \nng-click=\"downloadFile(vm.csvHeader, vm.csvData, vm.csvName)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\"vm.csvData.length > 0\" class=\"md-raised md-cornered\" ng-click=\"vm.getrecords(\'pdf\');\" \nng-disabled=\"vm.requestProcessingPDF\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\">\n</md-icon>Export as PDF<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.requestProcessingPDF\"></md-progress-circular></md-button><md-button ng-if=\"vm.csvData.length > 0\" \nclass=\"md-raised md-cornered\" ng-click=\"vm.printRecords()\" ng-disabled=\"vm.requestProcessingEmail\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_email_24px.svg\"></md-icon>Email Report<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessingEmail\">\n</md-progress-circular></md-button></div></div></div></div><div \nclass=\"Housekeepingtable incomereport income-report-table lodgingstatstable mt-20 ph-20 pb-20\" id=\"printSectionId\" \nng-if=\"vm.columns.length > 0\"><md-table-container><table md-table multiple=\"multiple\" ng-model=\"selected\" \nid=\"heightTable\" class=\"simple col30\"><thead md-head md-order=\"query.order\" md-on-reorder=\"getrecords\"><tr md-row \nclass=\"headerrow capitalize headingoutertb\"><th ng-repeat=\"heading in vm.columns\">{{heading}}</th></tr></thead><tbody \nmd-body id=\"tbodyHeight\" ng-style=\"vm.tableStyle\" ms-scroll style=\"position:relative\"><tr md-row md-select=\"dessert\" \nmd-select-id=\"name\" md-auto-select ng-repeat=\"(rowKey, reportdata) in vm.report.data\"><td \nng-click=\"vm.clickedRow($index,reportdata, values)\" md-cell ng-repeat=\"values in reportdata track by $index\" \nng-style=\"(rowKey === \'granttotal\' || rowKey === \'Total\' || $parent.$last) ? {\'font-weight\': \'bold\'} : {}\"><span \nng-if=\"!((values ? values.toString() : \'\').indexOf(\'$\') > -1 || ((values ? values.toString() : \'\').indexOf(\'.\') > -1 && (values ? values.toString() : \'\').indexOf(\'%\') === -1))\">\n{{values}}</span><span \nng-if=\"((values ? values.toString() : \'\').indexOf(\'$\') > -1 || ((values ? values.toString() : \'\').indexOf(\'.\') > -1 && (values ? values.toString() : \'\').indexOf(\'%\') === -1))\">\n{{ (values ? values.toString() : \'\').indexOf(\'$\') > -1 ? \'$\' : \'\' }}{{ (values ? values.toString() : \'\').replace(\'$\', \'\') | number : 2 }}\n</span></td></tr></tbody></table></md-table-container></div></div></div></div>");
$templateCache.put("app/main/apps/reports/lodging-statistic/lodging-statistic.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-chart-line\" \nclass=\"mr-10\"></md-icon><span>Lodging Statistics</span></div></div></div><div class=\"content loadingstatistic\"><div \nclass=\"simple-table-container\"><div class=\"table-title\">\nLodging Statistics {{ (vm.fromdate | date:\'MM/dd/yyyy\')+\' - \'+(vm.todate | date:\'MM/dd/yyyy\')}}</div><div layout=\"row\" \nflex=\"100\" layout-wrap><div layout=\"column\" flex-gt-xs=\"{{(isParent || vm.hotelID == 126) ? 33 : 50}}\" flex=\"100\" \nclass=\"ph-10\"><md-input-container class=\"md-block full-width mb-0\"><label translate=\"REPORT.START\"></label>\n<md-datepicker md-open-on-focus ng-model=\"vm.fromdate\" class=\"full-width mdinput-block\" \nng-change=\"vm.ChangeEndDayIf()\"></md-datepicker><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"{{(isParent || vm.hotelID == 126) ? 33 : 50}}\" flex=\"100\" class=\"ph-10\"><md-input-container\n class=\"md-block full-width mb-0\"><label translate=\"REPORT.END\"></label><md-datepicker md-open-on-focus \nng-model=\"vm.todate\" md-min-date=\"vm.fromdate\" class=\"full-width mdinput-block\"></md-datepicker><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div layout=\"column\" flex-gt-xs=\"{{isParent ? 33 : 50}}\" \nflex=\"100\" class=\"ph-10\" ng-if=\"isParent === true\"><md-input-container><label>\n{{ vm.selectedHotels.length > 0 ? \'Buisness Entity\': \'All\' }}</label><md-select ng-model=\"vm.selectedHotels\" \nmultiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">{{hotel.hotel_title}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"{{vm.hotelID == 126 ? 33 : 50}}\" \nflex=\"100\" class=\"ph-10\" ng-if=\"vm.hotelID == 126\"><md-input-container><label>Report For</label><md-select \nng-model=\"vm.reportFor\"><md-optgroup label=\"Report For\"><md-option value=\"hotel\" selected=\"selected\">Hotel</md-option>\n<md-option value=\"marina\">Marina</md-option><md-option value=\"rent\">Residence</md-option></md-optgroup></md-select>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\"><div layout=\"column\" flex-gt-xs=\"100\" flex=\"100\" \nclass=\"ph-10 pb-20\" layout-align=\"center end\"><div><div class=\"logo\"><md-button class=\"md-raised md-cornered\" \nng-click=\"vm.getrecords();\" ng-disabled=\"vm.requestProcessing\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\" ng-click=\"getrecords();\"></md-icon>Refresh\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessing\">\n</md-progress-circular></md-button><md-button ng-if=\"vm.csvData.length > 0\" class=\"md-raised md-cornered\" \nng-click=\"downloadFile(vm.csvHeader, vm.csvData, vm.csvName)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\"vm.csvData.length > 0\" class=\"md-raised md-cornered\" ng-click=\"vm.getrecords(\'pdf\');\" \nng-disabled=\"vm.requestProcessingPDF\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\">\n</md-icon>Export as PDF<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.requestProcessingPDF\"></md-progress-circular></md-button><md-button ng-if=\"vm.csvData.length > 0\" \nclass=\"md-raised md-cornered\" ng-click=\"vm.printRecords()\" ng-disabled=\"vm.requestProcessingEmail\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_email_24px.svg\"></md-icon>Email Report<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessingEmail\">\n</md-progress-circular></md-button></div></div></div></div><div \nclass=\"Housekeepingtable incomereport income-report-table lodgingstatstable mt-20 ph-20 pb-20\" id=\"printSectionId\" \nng-if=\"vm.csvData.length > 0\"><md-table-container><table md-table multiple=\"multiple\" ng-model=\"selected\" \nid=\"heightTable\" class=\"simple col30\"><thead md-head md-order=\"query.order\" md-on-reorder=\"getrecords\"><tr md-row \nclass=\"headerrow capitalize headingoutertb\"><th ng-repeat=\"heading in vm.report.heading\">{{heading}}</th></tr></thead>\n<tbody md-body id=\"tbodyHeight\" ng-style=\"vm.tableStyle\" ms-scroll style=\"position:relative\"><tr md-row \nmd-select=\"dessert\" md-select-id=\"name\" md-auto-select ng-repeat=\"(rowKey, reportdata) in vm.report.data\"><td md-cell \nng-repeat=\"values in reportdata track by $index\" \nng-style=\"(rowKey === \'granttotal\' || rowKey === \'Total\' || $parent.$last) ? {\'font-weight\': \'bold\'} : {}\"><span \nng-if=\"!((values ? values.toString() : \'\').indexOf(\'$\') > -1 || ((values ? values.toString() : \'\').indexOf(\'.\') > -1 && (values ? values.toString() : \'\').indexOf(\'%\') === -1))\">\n{{values}}</span><span \nng-if=\"((values ? values.toString() : \'\').indexOf(\'$\') > -1 || ((values ? values.toString() : \'\').indexOf(\'.\') > -1 && (values ? values.toString() : \'\').indexOf(\'%\') === -1))\">\n{{ (values ? values.toString() : \'\').indexOf(\'$\') > -1 ? \'$\' : \'\' }}{{ (values ? values.toString() : \'\').replace(\'$\', \'\') | number : 2 }}\n</span></td></tr></tbody></table></md-table-container></div></div></div></div>");
$templateCache.put("app/main/apps/reports/m3-report/m3report.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-night\" \nclass=\"mr-10\"></md-icon><span>{{vm.pageTitle}}</span></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container Housekeepingtable\"><div class=\"table-title\">\n{{vm.pageTitle}} {{ vm.departureDate | date:\'MM/dd/yyyy\'}}</div><div layout=\"row\" flex=\"100\" layout-wrap><div \nlayout=\"column\" flex-gt-xs=\"50\" flex=\"100\" class=\"ph-10\"><md-input-container class=\"md-block md-datepicker mb-0\" \ndata-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Date</label><md-datepicker \nclass=\"birthday-input1 no-padding\" ng-model=\"vm.date\" md-open-on-focus ng-model-options=\"{debounce: 500}\" required>\n</md-datepicker></md-input-container></div><div layout=\"column\" flex-gt-xs=\"50\" flex=\"100\" class=\"ph-10\"><div><div \nclass=\"logo\"><md-button class=\"md-raised md-cornered mr-10\" ng-click=\"vm.getReports()\" ng-disabled=\"vm.refreshRequest\">\n<md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.refreshRequest\">\n</md-progress-circular></md-button><md-button ng-if=\"vm.reportData.length > 0\" class=\"md-raised md-cornered\" \nng-click=\"vm.downloadXml()\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/xml.svg\"></md-icon>\nExport to M3<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.xmlDownloadRequest\"></md-progress-circular></md-button><md-button ng-if=\"vm.reportData.length > 0\" \nclass=\"md-raised md-cornered mr-10\" ng-click=\"vm.printData()\" ng-disabled=\"vm.printRequest\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/print.svg\"></md-icon>Print<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.printRequest\"></md-progress-circular>\n</md-button></div></div></div></div><a class=\"download\" download=\"{{vm.downloadFileName}}.xml\" \nstyle=\"visibility: hidden\"></a><div class=\"simple-table-container ph-20 pb-20\" id=\"printSectionId\"><div \nclass=\"ms-responsive-table-wrapper\" ng-if=\"vm.reportData.length > 0\"><div \nstyle=\"width:100%;float:left;padding-bottom:20px\"><table class=\"simple margin-border table-blockmain\" cellpadding=\"0\" \ncellspacing=\"0\" style=\"border:1px solid #dedede;font-family: arial; width:100%\"><tbody><tr \nstyle=\"width:100%;background: #f1f1f1\"><th style=\"padding:10px 10px; text-align:left\">BusDate</th><th \nstyle=\"padding:10px 10px; text-align:left\">FacilityId</th><th style=\"padding:10px 10px; text-align:left\">AccountingId\n</th><th style=\"padding:10px 10px; text-align:left\">Account Description</th><th \nstyle=\"padding:10px 10px; text-align:left\">PSCurrStat</th><th style=\"padding:10px 10px; text-align:left\">Amount</th>\n</tr><tr ng-repeat=\"(key, report) in vm.reportData\"><td style=\"padding:7px 10px\">{{ report.bus_date }}</td><td \nstyle=\"padding:7px 10px\">{{ report.facility_id }}</td><td style=\"padding:7px 10px\">{{ report.accounting_id }}</td><td \nstyle=\"padding:7px 10px\">{{ report.account_description }}</td><td style=\"padding:7px 10px\">{{ report.ps_curr_stat }}\n</td><td style=\"padding:7px 10px\">{{ report.amount }}</td></tr></tbody></table></div></div></div><div \nclass=\"simple-table-container ph-20 pb-20 norecordFound\" ng-show=\"vm.reportData.length == 0\"><div \nclass=\"ms-responsive-table-wrapper\">No Data Found</div></div></div></div></div>");
$templateCache.put("app/main/apps/reports/m3-report-new/m3report-new.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-night\" \nclass=\"mr-10\"></md-icon><span>{{vm.pageTitle}}</span></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container Housekeepingtable\"><div class=\"table-title\">\n{{vm.pageTitle}} {{ vm.departureDate | date:\'MM/dd/yyyy\'}}</div><div layout=\"row\" flex=\"100\" layout-wrap><div \nlayout=\"column\" flex-gt-xs=\"50\" flex=\"100\" class=\"ph-10\"><md-input-container class=\"md-block md-datepicker mb-0\" \ndata-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Date</label><md-datepicker \nclass=\"birthday-input1 no-padding\" ng-model=\"vm.date\" md-open-on-focus ng-model-options=\"{debounce: 500}\" required>\n</md-datepicker></md-input-container></div><div layout=\"column\" flex-gt-xs=\"50\" flex=\"100\" class=\"ph-10\"><div><div \nclass=\"logo\"><md-button class=\"md-raised md-cornered mr-10\" ng-click=\"vm.getReports()\" ng-disabled=\"vm.refreshRequest\">\n<md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.refreshRequest\">\n</md-progress-circular></md-button><md-button ng-if=\"vm.reportData.length > 0\" class=\"md-raised md-cornered\" \nng-click=\"vm.downloadXml()\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/xml.svg\"></md-icon>\nExport to M3<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.xmlDownloadRequest\"></md-progress-circular></md-button><md-button ng-if=\"vm.reportData.length > 0\" \nclass=\"md-raised md-cornered mr-10\" ng-click=\"vm.printData()\" ng-disabled=\"vm.printRequest\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/print.svg\"></md-icon>Print<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.printRequest\"></md-progress-circular>\n</md-button></div></div></div></div><a class=\"download\" download=\"{{vm.downloadFileName}}.xml\" \nstyle=\"visibility: hidden\"></a><div class=\"simple-table-container ph-20 pb-20\" id=\"printSectionId\"><div \nclass=\"ms-responsive-table-wrapper\" ng-if=\"vm.showTable\"><div style=\"width:100%;float:left;padding-bottom:20px\"><table \nclass=\"simple margin-border table-blockmain\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"border:1px solid #dedede;font-family: arial; width:100%\"><tbody><tr style=\"width:100%;background: #f1f1f1\"><th \nstyle=\"padding:10px 10px; text-align:left\">BusDate</th><th style=\"padding:10px 10px; text-align:left\">FacilityId</th>\n<th style=\"padding:10px 10px; text-align:left\">AccountingId</th><th style=\"padding:10px 10px; text-align:left\">\nAccount Description</th><th style=\"padding:10px 10px; text-align:left\">PSCurrStat</th><th \nstyle=\"padding:10px 10px; text-align:left\">Amount</th></tr><tr ng-repeat=\"(key, report) in vm.reportData\"><td \nstyle=\"padding:7px 10px; text-align: center; background: #f1f1f1\" colspan=\"6\" ng-if=\"report.ps_curr_stat == \'HEADING\'\">\n{{ report.account_description }}</td><td style=\"padding:7px 10px\" ng-if=\"report.ps_curr_stat != \'HEADING\'\">\n{{ report.bus_date }}</td><td style=\"padding:7px 10px\" ng-if=\"report.ps_curr_stat != \'HEADING\'\">\n{{ report.facility_id }}</td><td style=\"padding:7px 10px\" ng-if=\"report.ps_curr_stat != \'HEADING\'\">\n{{ report.accounting_id }}</td><td style=\"padding:7px 10px\" ng-if=\"report.ps_curr_stat != \'HEADING\'\">\n{{ report.account_description }}</td><td style=\"padding:7px 10px\" ng-if=\"report.ps_curr_stat != \'HEADING\'\">\n{{ report.ps_curr_stat }}</td><td style=\"padding:7px 10px\" ng-if=\"report.ps_curr_stat != \'HEADING\'\">{{ report.amount }}\n</td></tr></tbody></table></div></div></div><div class=\"simple-table-container ph-20 pb-20 norecordFound\" \nng-show=\"vm.reportData.length == 0\"><div class=\"ms-responsive-table-wrapper\">No Data Found</div></div></div></div>\n</div>");
$templateCache.put("app/main/apps/reports/night-audit/night-audit - Copy.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-night\" \nclass=\"mr-10\"></md-icon><span>Night Audit</span></div></div></div><div class=\"content\"><style type=\"text/css\">\n.errorMessage {\n            width: 100%;\n            padding: 14px 0px;\n        }\n        .condencedTableText td span.condenced-desc {\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            float: left;\n            max-width:400px;\n        }\n        .Housekeepingtable table{border:1px solid #dedede;margin-bottom:20px;}\n        .Housekeepingtable table .headerrow{background:#f1f1f1;}\n        .Housekeepingtable table.simple tbody tr th {\n            padding: 16px 8px;\n            border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n        }\n        .Housekeepingtable table.simple tbody tr td {\n            padding: 13px 12px;\n        }\n        .Housekeepingtable table.simple tbody tr th:last-child {\n            padding-right: 24px;\n        }\n        .Housekeepingtable table.simple tbody tr th:first-child {\n            padding-left: 24px;\n        }\n        .tabletotalblock tr td:first-child{width:60%;text-align:right;}\n        .tabletotalblock tr td:nth-child(2){width:10%;text-align:center;}\n        .tabletotalblock tr td:nth-child(3){width:20%;text-align:right;}\n        .tabletotalblock tr.totalheading td:first-child{width:100%;text-align:left;background:#f1f1f1;font-size:15px;}\n</style><div class=\"simple-table-container Housekeepingtable NightAuditTable\"><div class=\"table-title\">\nNight Audit {{ vm.departureDate | date:\'MM/dd/yyyy\'}}</div><div layout=\"row\" flex=\"100\" layout-wrap><div \nlayout=\"column\" flex-gt-xs=\"{{ isParent || vm.hotelID == 126? 33:50 }}\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Date</label>\n<md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.departureDate\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" required></md-datepicker></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"33\" flex=\"100\" class=\"ph-10\" ng-if=\"isParent\"><md-input-container><label>\n{{ vm.selectedHotels.length == 1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"33\" \nflex=\"100\" class=\"ph-10\" ng-if=\"vm.hotelID == 126\"><md-input-container><label>Report For</label><md-select \nng-model=\"vm.reportFor\"><md-optgroup label=\"Report For\"><md-option value=\"hotel\" selected=\"selected\">Hotel</md-option>\n<md-option value=\"marina\">Marina</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{ isParent || vm.hotelID == 126? 33:50 }}\" flex=\"100\" class=\"ph-10\"><div><div class=\"logo\"><md-button \nclass=\"md-raised md-cornered mr-10\" ng-click=\"vm.getReports()\" ng-disabled=\"vm.refreshRequest\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.refreshRequest\"></md-progress-circular>\n</md-button><md-button ng-if=\" vm.nightAudit.length > 0\" class=\"md-raised md-cornered\" \ncsv-header=\"[\'Itinerary\',\'Confirmation number\',\'Name\',\'Status\',\'Checkin\',\'Checkout\',\'Customer\',\'Total\',\'Paid\',\'Remaining\']\" \nng-click=\"downloadFile([\'Itinerary\',\'Confirmation number\',\'Name\',\'Status\',\'Checkin\',\'Checkout\',\'Customer\',\'Total\',\'Paid\',\'Remaining\'], vm.all, vm.csvName)\">\n<md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\" vm.nightAudit.length > 0\" class=\"md-raised md-cornered mr-10\" ng-click=\"vm.printData()\" \nng-disabled=\"vm.printRequest\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/print.svg\"></md-icon>Print\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.printRequest\">\n</md-progress-circular></md-button></div></div></div></div><div class=\"simple-table-container ph-20 pb-20\" \nid=\"printSectionId\" style=\"width:100%;display:block;margin-bottom:10px\"><div class=\"ms-responsive-table-wrapper\" \nng-if=\" vm.nightAudit.length > 0\"><style>\ntable.simple tr:nth-child(odd)\n                        {\n                            background: #f9f9f9;\n                        }\n</style><div ng-show=\"vm.print\" style=\"width:100%;display:block;margin-bottom:10px\"><div \nstyle=\"padding:13px 10px;width:auto;float:left\"><img src=\"{{vm.logo}}\" style=\"width:280px\"></div><div \nstyle=\"padding:25px 10px;float:right;vertical-align: middle;font-size:15px\">\nNight Audit {{ vm.departureDate | date:\'MM/dd/yyyy\'}}</div></div><div \nstyle=\"width:100%;float:left;padding-bottom:20px\"><table class=\"simple margin-border table-blockmain\" id=\"heightTable\" \ncellpadding=\"0\" cellspacing=\"0\" style=\"border:1px solid #dedede;font-family: arial\"><thead><tr \nstyle=\"width:100%;background: #f1f1f1\"><td style=\"padding:10px 10px;text-align:left\">Itinerary</td><td \nstyle=\"padding:10px 10px;text-align:left\">Confirmation Number</td><td style=\"padding:10px 10px;text-align:left\">Name\n</td><td style=\"padding:10px 10px;text-align:left\">Status</td><td style=\"padding:10px 10px;text-align:left\">Check In\n</td><td style=\"padding:10px 10px;text-align:left\">Check Out</td><td style=\"padding:10px 10px;text-align:left\">Customer\n</td><td style=\"padding:10px 10px;text-align:left\">Total</td><td style=\"padding:10px 10px;text-align:left\">Paid</td><td\n style=\"padding:10px 10px;text-align:left\">Remaining</td></tr></thead><tbody id=\"tbodyHeight\" ng-style=\"vm.tableStyle\" \nms-scroll style=\"position:relative\"><tr ng-repeat=\"(key, nightAudir) in vm.nightAudit\" \nng-init=\"vm.calculate(nightAudir,key)\"><td style=\"padding:7px 10px\" class=\"cursorPointer\" \nng-click=\"goToState(nightAudir.itinerary_number, nightAudir.confirmation_number, \'\')\">{{ nightAudir.itinerary_number }}\n</td><td style=\"padding:7px 10px\" class=\"cursorPointer\" \nng-click=\"goToState(nightAudir.itinerary_number, nightAudir.confirmation_number, \'\')\">\n{{ nightAudir.confirmation_number }}</td><td style=\"padding:7px 10px\">{{ nightAudir.product_name }}</td><td \nstyle=\"padding:7px 10px\">{{ nightAudir.room_stay_status }}</td><td style=\"padding:7px 10px\">\n{{ nightAudir.room_stay_from }}</td><td style=\"padding:7px 10px\">{{ nightAudir.room_stay_to }}</td><td \nstyle=\"padding:7px 10px\">{{ nightAudir.customerName }}</td><td style=\"padding:7px 10px\">\n{{ nightAudir.total_amount | currency : $ : 2 }}</td><td style=\"padding:7px 10px\">\n{{ nightAudir.total_paid_amount | currency : $ : 2 }}</td><td style=\"padding:7px 10px\">\n{{ nightAudir.total_remaining_amount | currency : $ : 2 }}</td></tr><tr><td style=\"font-weight:bold;padding:15px 10px\" \ncolspan=\"7\">Total</td><td style=\"font-weight:bold;padding:15px 10px\">{{ vm.total | currency : $ : 2 }}</td><td \nstyle=\"font-weight:bold;padding:15px 10px\">{{ vm.paid | currency : $ : 2 }}</td><td \nstyle=\"font-weight:bold;padding:15px 10px\">{{ vm.remaining | currency : $ : 2 }}</td></tr></tbody></table></div></div>\n</div><div class=\"simple-table-container ph-20 pb-20 norecordFound\" ng-show=\"vm.nightAudit.length == 0 && vm.init\"><div\n class=\"ms-responsive-table-wrapper\">No Data Found</div></div></div></div></div>");
$templateCache.put("app/main/apps/reports/night-audit/night-audit.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-night\" \nclass=\"mr-10\"></md-icon><span>Night Audit</span></div></div></div><div class=\"content\"><style type=\"text/css\">\n.errorMessage {\n            width: 100%;\n            padding: 14px 0px;\n        }\n        .condencedTableText td span.condenced-desc {\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            float: left;\n            max-width:400px;\n        }\n        .Housekeepingtable table{border:1px solid #dedede;margin-bottom:20px;}\n        .Housekeepingtable table .headerrow{background:#f1f1f1;}\n        .Housekeepingtable table.simple tbody tr th {\n            padding: 16px 8px;\n            border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n        }\n        .Housekeepingtable table.simple tbody tr td {\n            padding: 13px 12px;\n        }\n        .Housekeepingtable table.simple tbody tr th:last-child {\n            padding-right: 24px;\n        }\n        .Housekeepingtable table.simple tbody tr th:first-child {\n            padding-left: 24px;\n        }\n        .tabletotalblock tr td:first-child{width:60%;text-align:right;}\n        .tabletotalblock tr td:nth-child(2){width:10%;text-align:center;}\n        .tabletotalblock tr td:nth-child(3){width:20%;text-align:right;}\n        .tabletotalblock tr.totalheading td:first-child{width:100%;text-align:left;background:#f1f1f1;font-size:15px;}\n</style><div class=\"simple-table-container Housekeepingtable NightAuditTable\"><div class=\"table-title\">\nNight Audit {{ vm.departureDate | date:\'MM/dd/yyyy\'}}</div><div layout=\"row\" flex=\"100\" layout-wrap><div \nlayout=\"column\" flex-gt-xs=\"50\" flex=\"100\" class=\"ph-10\"><md-input-container class=\"md-block md-datepicker mb-0\" \ndata-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Date</label><md-datepicker \nclass=\"birthday-input1 no-padding\" ng-model=\"vm.departureDate\" md-open-on-focus ng-model-options=\"{debounce: 500}\" \nrequired></md-datepicker></md-input-container></div><div layout=\"column\" flex-gt-xs=\"50\" flex=\"100\" class=\"ph-10\" \nng-if=\"isParent\"><md-input-container><label>\n{{ vm.selectedHotels.length == 1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"50\" \nflex=\"100\" class=\"ph-10\" ng-if=\"vm.hotelID == 126\"><md-input-container><label>Report For</label><md-select \nng-model=\"vm.reportFor\"><md-optgroup label=\"Report For\"><md-option value=\"hotel\" selected=\"selected\">Hotel</md-option>\n<md-option value=\"marina\">Marina</md-option></md-optgroup></md-select></md-input-container></div></div><div \nclass=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex-gt-xs=\"{{ isParent || vm.hotelID == 126? 33:50 }}\" \nflex=\"100\" class=\"ph-10 pb-20\" layout-align=\"center end\"><div><div class=\"logo\"><md-button \nclass=\"md-raised md-cornered mr-10\" ng-click=\"vm.getReports()\" ng-disabled=\"vm.refreshRequest\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.refreshRequest\"></md-progress-circular>\n</md-button><md-button ng-if=\" vm.nightAudit.length > 0\" class=\"md-raised md-cornered\" \ncsv-header=\"[\'Itinerary\',\'Confirmation number\',\'Name\',\'Status\',\'Checkin\',\'Checkout\',\'Customer\',\'Total\',\'Paid\',\'Remaining\']\" \nng-click=\"downloadFile([\'Itinerary\',\'Confirmation number\',\'Name\',\'Status\',\'Checkin\',\'Checkout\',\'Customer\',\'Total\',\'Paid\',\'Remaining\'], vm.all, vm.csvName)\">\n<md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\" vm.nightAudit.length > 0\" class=\"md-raised md-cornered\" ng-disabled=\"vm.refreshRequestPDF\" \nng-click=\"vm.printNight(\'pdf\')\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>\nExport as PDF<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.refreshRequestPDF\"></md-progress-circular></md-button><md-button ng-if=\" vm.nightAudit.length > 0\" \nclass=\"md-raised md-cornered mr-10\" ng-click=\"vm.printData()\" ng-disabled=\"vm.printRequest\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/print.svg\"></md-icon>Print<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.printRequest\"></md-progress-circular>\n</md-button></div></div></div></div><div class=\"simple-table-container ph-20 pb-20\" id=\"printSectionId\" \nstyle=\"width:100%;display:block;margin-bottom:10px\"><div class=\"ms-responsive-table-wrapper\" \nng-if=\" vm.nightAudit.length > 0\"><style>\ntable.simple tr:nth-child(odd)\n                        {\n                            background: #f9f9f9;\n                        }\n</style><div ng-show=\"vm.print\" style=\"width:100%;display:block;margin-bottom:10px\"><div \nstyle=\"padding:13px 10px;width:auto;float:left\"><img src=\"{{vm.logo}}\" style=\"width:280px\"></div><div \nstyle=\"padding:25px 10px;float:right;vertical-align: middle;font-size:15px\">\nNight Audit {{ vm.departureDate | date:\'MM/dd/yyyy\'}}</div></div><div \nstyle=\"width:100%;float:left;padding-bottom:20px\"><table class=\"simple margin-border table-blockmain\" id=\"heightTable\" \ncellpadding=\"0\" cellspacing=\"0\" style=\"border:1px solid #dedede;font-family: arial\"><thead><tr \nstyle=\"width:100%;background: #f1f1f1\"><td style=\"padding:10px 10px;text-align:left\">Itinerary</td><td \nstyle=\"padding:10px 10px;text-align:left\">Confirmation Number</td><td style=\"padding:10px 10px;text-align:left\">Name\n</td><td style=\"padding:10px 10px;text-align:left\">Status</td><td style=\"padding:10px 10px;text-align:left\">Check In\n</td><td style=\"padding:10px 10px;text-align:left\">Check Out</td><td style=\"padding:10px 10px;text-align:left\">Customer\n</td><td style=\"padding:10px 10px;text-align:left\">Total</td><td style=\"padding:10px 10px;text-align:left\">Paid</td><td\n style=\"padding:10px 10px;text-align:left\">Remaining</td></tr></thead><tbody id=\"tbodyHeight\" ng-style=\"vm.tableStyle\" \nms-scroll style=\"position:relative\"><tr ng-repeat=\"(key, nightAudir) in vm.nightAudit\" \nng-init=\"vm.calculate(nightAudir,key)\"><td style=\"padding:7px 10px\" class=\"cursorPointer\" \nng-click=\"goToState(nightAudir.itinerary_number, nightAudir.confirmation_number, \'\')\">{{ nightAudir.itinerary_number }}\n</td><td style=\"padding:7px 10px\" class=\"cursorPointer\" \nng-click=\"goToState(nightAudir.itinerary_number, nightAudir.confirmation_number, \'\')\">\n{{ nightAudir.confirmation_number }}</td><td style=\"padding:7px 10px\">{{ nightAudir.product_name }}</td><td \nstyle=\"padding:7px 10px\">{{ nightAudir.room_stay_status }}</td><td style=\"padding:7px 10px\">\n{{ nightAudir.room_stay_from }}</td><td style=\"padding:7px 10px\">{{ nightAudir.room_stay_to }}</td><td \nstyle=\"padding:7px 10px\">{{ nightAudir.customerName }}</td><td style=\"padding:7px 10px\">\n{{ nightAudir.total_amount | currency : $ : 2 }}</td><td style=\"padding:7px 10px\">\n{{ nightAudir.total_paid_amount | currency : $ : 2 }}</td><td style=\"padding:7px 10px\">\n{{ nightAudir.total_remaining_amount | currency : $ : 2 }}</td></tr><tr><td style=\"font-weight:bold;padding:15px 10px\" \ncolspan=\"7\">Total</td><td style=\"font-weight:bold;padding:15px 10px\">{{ vm.total | currency : $ : 2 }}</td><td \nstyle=\"font-weight:bold;padding:15px 10px\">{{ vm.paid | currency : $ : 2 }}</td><td \nstyle=\"font-weight:bold;padding:15px 10px\">{{ vm.remaining | currency : $ : 2 }}</td></tr></tbody></table></div></div>\n</div><div class=\"simple-table-container ph-20 pb-20 norecordFound\" ng-show=\"vm.nightAudit.length == 0 && vm.init\"><div\n class=\"ms-responsive-table-wrapper\">No Data Found</div></div></div></div></div>");
$templateCache.put("app/main/apps/reports/night-audit-latest/night-audit-latest.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-night\" \nclass=\"mr-10\"></md-icon><span>Night Audit</span></div></div></div><div class=\"content\"><div class=\"Night-audit-table\">\n<div class=\"Night-audit-heading\">\nNight Audit {{ vm.departureDate | date:\'MM/dd/yyyy\'}} - {{ vm.departureDateTo | date:\'MM/dd/yyyy\'}}</div><div \nclass=\"searching_input-blocksmain\"><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" \nflex-gt-xs=\"{{ isParent || vm.hotelID == 126? 25:50 }}\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">From Date</label>\n<md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.departureDate\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" ng-change=\"vm.checkSchedule(\'from\')\" required></md-datepicker></md-input-container>\n</div><div layout=\"column\" flex-gt-xs=\"{{ isParent || vm.hotelID == 126? 25:50 }}\" flex=\"100\" class=\"ph-10\">\n<md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">\nTo Date</label><md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.departureDateTo\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" ng-change=\"vm.checkSchedule(\'to\')\" md-max-date=\"vm.newEndDate\" \nmd-min-date=\"vm.departureDate\" required></md-datepicker></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"50\" flex=\"100\" class=\"ph-10\" ng-if=\"isParent\"><md-input-container><label>\n{{ vm.selectedHotels.length == 1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"50\" \nflex=\"100\" class=\"ph-10\" ng-if=\"vm.hotelID == 126\"><md-input-container><label>Report For</label><md-select \nng-model=\"vm.reportFor\"><md-optgroup label=\"Report For\"><md-option value=\"all\" selected=\"selected\">All</md-option>\n<md-option value=\"hotel\">Hotel</md-option><md-option value=\"marina\">Marina</md-option></md-optgroup></md-select>\n</md-input-container></div><div class=\"error_div_date\" ng-if=\"vm.numberOfDays > 31\">\nPlease generate the report for one month only.</div></div><div layout=\"row\" flex=\"100\" layout-wrap><div \nlayout=\"column\" flex-gt-xs=\"100\" flex=\"100\" layout-align=\"center end\"><div class=\"btnsrefreshblock\"><md-button \nclass=\"md-raised md-cornered mr-10\" ng-click=\"vm.getReports(0)\" \nng-disabled=\"vm.refreshRequest || vm.numberOfDays > 31\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.refreshRequest\"></md-progress-circular>\n</md-button><md-button class=\"md-raised md-cornered mr-10\" ng-if=\"vm.objKeys.length > 0\" \nng-click=\"vm.exportFile(\'csv\')\" ng-disabled=\"vm.csvLoader\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>Export to CSV<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.csvLoader\"></md-progress-circular></md-button>\n<md-button class=\"md-raised md-cornered mr-10\" ng-if=\"vm.objKeys.length > 0\" ng-click=\"vm.exportFile(\'pdf\')\" \nng-disabled=\"vm.exportLoader\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>\nExport to PDF<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.exportLoader\"></md-progress-circular></md-button></div></div></div></div><div \nclass=\"nightAudit-tableblock nightaudittable\" ng-if=\"vm.objKeys.length > 0 && !vm.showGeneratingFlag\" \nid=\"table-container\"><table cellpadding=\"0\" cellspacing=\"0\" class=\"nightAudittableblock fixheadertable simple\" \nstyle=\"border:none\" id=\"tableOuter\"><thead style=\"background: #f1f1f1\"><tr class=\"headingoutertb\" \nstyle=\"border: 1px solid #dedede\"><th><p style=\"opacity:0\">Index</p></th><th class=\"centertxt\"><b \nstyle=\"color:#000; font-weight:bold; font-size:16px\">Total Revenue</b></th><th class=\"centertxt\"><b \nstyle=\"color:#000; font-weight:bold; font-size:16px\">Total Tourist Development Tax Collected</b></th><th \nclass=\"centertxt\"><b style=\"color:#000; font-weight:bold; font-size:16px\">Total Sales Tax Collected</b></th><th \nclass=\"centertxt\"><b style=\"color:#000; font-weight:bold; font-size:16px\">Grand Total</b></th></tr></thead><tbody \nid=\"tbodyHeight\" ng-style=\"vm.tableOuterStyle\" ms-scroll style=\"position:relative\"><tr><td colspan=\"5\" \nstyle=\"padding:0px !important;width:100%\"><table cellpadding=\"0\" cellspacing=\"0\" class=\"nightAudittableblock\" \nstyle=\"margin-top: 0px\" id=\"tableInner\" autosize=\"1\"><tbody><tr class=\"sub-headingmain\"><td colspan=\"5\"><b>Hotel</b>\n</td></tr><tr ng-if=\"vm.nightAudit[vm.hotelTitle][\'Taxable Rentals - Villas\'] || vm.hotelID == 126\"><td>\nTaxable Rentals - Villas</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Taxable Rentals - Villas\'] ? vm.nightAudit[vm.hotelTitle][\'Taxable Rentals - Villas\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Taxable Rentals - Villas\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.hotelTitle][\'Taxable Rentals - Villas\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Taxable Rentals - Villas\'].taxes[vm.salesTax] ? vm.nightAudit[vm.hotelTitle][\'Taxable Rentals - Villas\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Taxable Rentals - Villas\'] ? vm.nightAudit[vm.hotelTitle][\'Taxable Rentals - Villas\'].total_amount : vm.defaultValue}}\n</td></tr><tr><td colspan=\"5\" style=\"padding: 0px!important\"><table id=\"subcategory-table\" cellpadding=\"0\" \ncellspacing=\"0\"><tbody><tr><td>Taxable Rentals - Short Term</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Taxable Rentals - Short Term\'] ? vm.nightAudit[vm.hotelTitle][\'Taxable Rentals - Short Term\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Taxable Rentals - Short Term\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.hotelTitle][\'Taxable Rentals - Short Term\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Taxable Rentals - Short Term\'].taxes[vm.salesTax] ? vm.nightAudit[vm.hotelTitle][\'Taxable Rentals - Short Term\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Taxable Rentals - Short Term\'] ? vm.nightAudit[vm.hotelTitle][\'Taxable Rentals - Short Term\'].total_amount : vm.defaultValue}}\n</td></tr><tr class=\"airbnb-rental-taxable\" ng-if=\"vm.hotelID != 122 && vm.hotelID != 119\"><td \nstyle=\"padding-left: 3%!important\">Airbnb Rentals</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Airbnb Rentals\'] ? vm.nightAudit[vm.hotelTitle][\'Airbnb Rentals\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Airbnb Rentals\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.hotelTitle][\'Airbnb Rentals\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Airbnb Rentals\'].taxes[vm.salesTax] ? vm.nightAudit[vm.hotelTitle][\'Airbnb Rentals\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Airbnb Rentals\'] ? vm.nightAudit[vm.hotelTitle][\'Airbnb Rentals\'].total_amount : vm.defaultValue}}\n</td></tr></tbody></table></td></tr><tr><td>Non-Taxable Rentals - Short Term</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Non-Taxable Rentals - Short Term\'] ? vm.nightAudit[vm.hotelTitle][\'Non-Taxable Rentals - Short Term\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Non-Taxable Rentals - Short Term\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.hotelTitle][\'Non-Taxable Rentals - Short Term\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Non-Taxable Rentals - Short Term\'].taxes[vm.salesTax] ? vm.nightAudit[vm.hotelTitle][\'Non-Taxable Rentals - Short Term\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Non-Taxable Rentals - Short Term\'] ? vm.nightAudit[vm.hotelTitle][\'Non-Taxable Rentals - Short Term\'].total_amount : vm.defaultValue}}\n</td></tr><tr ng-if=\"vm.nightAudit[vm.hotelTitle][\'Non-Taxable Rentals - Villas\'] || vm.hotelID == 126\"><td>\nNon-Taxable Rentals - Villas</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Non-Taxable Rentals - Villas\'] ? vm.nightAudit[vm.hotelTitle][\'Non-Taxable Rentals - Villas\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Non-Taxable Rentals - Villas\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.hotelTitle][\'Non-Taxable Rentals - Villas\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Non-Taxable Rentals - Villas\'].taxes[vm.salesTax] ? vm.nightAudit[vm.hotelTitle][\'Non-Taxable Rentals - Villas\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Non-Taxable Rentals - Villas\'] ? vm.nightAudit[vm.hotelTitle][\'Non-Taxable Rentals - Villas\'].total_amount : vm.defaultValue}}\n</td></tr><tr ng-if=\"vm.hotelID == 126\"><td colspan=\"5\" style=\"padding: 0px!important\"><table cellpadding=\"0\" \ncellspacing=\"0\" width=\"100%\"><tbody><tr><td>Long Term Rentals</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Long Term Rentals\'] ? vm.nightAudit[vm.hotelTitle][\'Long Term Rentals\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Long Term Rentals\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.hotelTitle][\'Long Term Rentals\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Long Term Rentals\'].taxes[vm.salesTax] ? vm.nightAudit[vm.hotelTitle][\'Long Term Rentals\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Long Term Rentals\'] ? vm.nightAudit[vm.hotelTitle][\'Long Term Rentals\'].total_amount : vm.defaultValue}}\n</td></tr><tr class=\"outertr\"><td style=\"padding-left: 3%!important\" class=\"remove_bottom\">Residences</td><td \nclass=\"centertxt remove_bottom\">\n{{vm.nightAudit[vm.hotelTitle][\'Residences\'] ? vm.nightAudit[vm.hotelTitle][\'Residences\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt remove_bottom\">\n{{vm.nightAudit[vm.hotelTitle][\'Residences\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.hotelTitle][\'Residences\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt remove_bottom\">\n{{vm.nightAudit[vm.hotelTitle][\'Residences\'].taxes[vm.salesTax] ? vm.nightAudit[vm.hotelTitle][\'Residences\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt remove_bottom\">\n{{vm.nightAudit[vm.hotelTitle][\'Residences\'] ? vm.nightAudit[vm.hotelTitle][\'Residences\'].total_amount : vm.defaultValue}}\n</td></tr><tr class=\"outertr\"><td style=\"padding-left: 3%!important\" class=\"remove_bottom\">Timeshare Rentals</td><td \nclass=\"centertxt remove_bottom\">\n{{vm.nightAudit[vm.hotelTitle][\'Timeshare Rentals\'] ? vm.nightAudit[vm.hotelTitle][\'Timeshare Rentals\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt remove_bottom\">\n{{vm.nightAudit[vm.hotelTitle][\'Timeshare Rentals\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.hotelTitle][\'Timeshare Rentals\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt remove_bottom\">\n{{vm.nightAudit[vm.hotelTitle][\'Timeshare Rentals\'].taxes[vm.salesTax] ? vm.nightAudit[vm.hotelTitle][\'Timeshare Rentals\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt remove_bottom\">\n{{vm.nightAudit[vm.hotelTitle][\'Timeshare Rentals\'] ? vm.nightAudit[vm.hotelTitle][\'Timeshare Rentals\'].total_amount : vm.defaultValue}}\n</td></tr></tbody></table></td></tr><tr><td>Resort Day Pass</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Resort Day Pass\'] ? vm.nightAudit[vm.hotelTitle][\'Resort Day Pass\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Resort Day Pass\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.hotelTitle][\'Resort Day Pass\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Resort Day Pass\'].taxes[vm.salesTax] ? vm.nightAudit[vm.hotelTitle][\'Resort Day Pass\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Resort Day Pass\'] ? vm.nightAudit[vm.hotelTitle][\'Resort Day Pass\'].total_amount : vm.defaultValue}}\n</td></tr><tr><td>Resort Fee</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Resort Fee\'] ? vm.nightAudit[vm.hotelTitle][\'Resort Fee\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Resort Fee\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.hotelTitle][\'Resort Fee\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Resort Fee\'].taxes[vm.salesTax] ? vm.nightAudit[vm.hotelTitle][\'Resort Fee\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Resort Fee\'] ? vm.nightAudit[vm.hotelTitle][\'Resort Fee\'].total_amount : vm.defaultValue}}\n</td></tr><tr><td>Extra Person</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Extra Person\'] ? vm.nightAudit[vm.hotelTitle][\'Extra Person\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Extra Person\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.hotelTitle][\'Extra Person\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Extra Person\'].taxes[vm.salesTax] ? vm.nightAudit[vm.hotelTitle][\'Extra Person\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Extra Person\'] ? vm.nightAudit[vm.hotelTitle][\'Extra Person\'].total_amount : vm.defaultValue}}\n</td></tr><tr><td>Cancellation Fee</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Cancellation Fee\'] ? vm.nightAudit[vm.hotelTitle][\'Cancellation Fee\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Cancellation Fee\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.hotelTitle][\'Cancellation Fee\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Cancellation Fee\'].taxes[vm.salesTax] ? vm.nightAudit[vm.hotelTitle][\'Cancellation Fee\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Cancellation Fee\'] ? vm.nightAudit[vm.hotelTitle][\'Cancellation Fee\'].total_amount : vm.defaultValue}}\n</td></tr><tr><td>Cleaning Fee</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Cleaning Fee\'] ? vm.nightAudit[vm.hotelTitle][\'Cleaning Fee\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Cleaning Fee\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.hotelTitle][\'Cleaning Fee\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Cleaning Fee\'].taxes[vm.salesTax] ? vm.nightAudit[vm.hotelTitle][\'Cleaning Fee\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Cleaning Fee\'] ? vm.nightAudit[vm.hotelTitle][\'Cleaning Fee\'].total_amount : vm.defaultValue}}\n</td></tr><tr><td>Damage Fee</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Damage Fee\'] ? vm.nightAudit[vm.hotelTitle][\'Damage Fee\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Damage Fee\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.hotelTitle][\'Damage Fee\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Damage Fee\'].taxes[vm.salesTax] ? vm.nightAudit[vm.hotelTitle][\'Damage Fee\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Damage Fee\'] ? vm.nightAudit[vm.hotelTitle][\'Damage Fee\'].total_amount : vm.defaultValue}}\n</td></tr><tr><td>Late Check-Out Fee</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Late Checkout Fee\'] ? vm.nightAudit[vm.hotelTitle][\'Late Checkout Fee\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Late Checkout Fee\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.hotelTitle][\'Late Checkout Fee\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Late Checkout Fee\'].taxes[vm.salesTax] ? vm.nightAudit[vm.hotelTitle][\'Late Checkout Fee\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Late Checkout Fee\'] ? vm.nightAudit[vm.hotelTitle][\'Late Checkout Fee\'].total_amount : vm.defaultValue}}\n</td></tr><tr><td>Pet Fee</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Pet Fee\'] ? vm.nightAudit[vm.hotelTitle][\'Pet Fee\'].subtotal : vm.defaultValue}}</td>\n<td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Pet Fee\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.hotelTitle][\'Pet Fee\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Pet Fee\'].taxes[vm.salesTax] ? vm.nightAudit[vm.hotelTitle][\'Pet Fee\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Pet Fee\'] ? vm.nightAudit[vm.hotelTitle][\'Pet Fee\'].total_amount : vm.defaultValue}}\n</td></tr><tr><td>Smoking Fee</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Smoking Fee\'] ? vm.nightAudit[vm.hotelTitle][\'Smoking Fee\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Smoking Fee\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.hotelTitle][\'Smoking Fee\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Smoking Fee\'].taxes[vm.salesTax] ? vm.nightAudit[vm.hotelTitle][\'Smoking Fee\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Smoking Fee\'] ? vm.nightAudit[vm.hotelTitle][\'Smoking Fee\'].total_amount : vm.defaultValue}}\n</td></tr><tr><td>Other Miscellaneous Fees</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Other Miscellaneous Fees\'] ? vm.nightAudit[vm.hotelTitle][\'Other Miscellaneous Fees\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Other Miscellaneous Fees\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.hotelTitle][\'Other Miscellaneous Fees\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Other Miscellaneous Fees\'].taxes[vm.salesTax] ? vm.nightAudit[vm.hotelTitle][\'Other Miscellaneous Fees\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.hotelTitle][\'Other Miscellaneous Fees\'] ? vm.nightAudit[vm.hotelTitle][\'Other Miscellaneous Fees\'].total_amount : vm.defaultValue}}\n</td></tr><tr><td class=\"total-row\"><b>Total Hotel</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit[vm.hotelTitle][\'grand\'][\'hotelSubTotal\']}}</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit[vm.hotelTitle][\'grand\'][\'lodgingTaxTotal\']}}</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit[vm.hotelTitle][\'grand\'][\'salesTaxTotal\']}}</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit[vm.hotelTitle][\'grand\'][\'hotelGrandTotal\']}}</b></td></tr></tbody></table><table cellpadding=\"0\" \ncellspacing=\"0\" class=\"nightAudittableblock\" autosize=\"1\" ng-if=\"vm.hotelData.hotel_code == \'skipjackresort\'\"><tbody>\n<tr class=\"sub-headingmain\"><td colspan=\"5\"><b>Marina</b></td></tr><tr \nng-if=\"vm.hotelData.hotel_code == \'skipjackresort\'\"><td>Boat Launch Fee</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.marinaTitle][\'Boat Launch Fee\'] ? vm.nightAudit[vm.marinaTitle][\'Boat Launch Fee\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.marinaTitle][\'Boat Launch Fee\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.marinaTitle][\'Boat Launch Fee\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.marinaTitle][\'Boat Launch Fee\'].taxes[vm.salesTax] ? vm.nightAudit[vm.marinaTitle][\'Boat Launch Fee\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.marinaTitle][\'Boat Launch Fee\'] ? vm.nightAudit[vm.marinaTitle][\'Boat Launch Fee\'].total_amount : vm.defaultValue}}\n</td></tr><tr ng-if=\"vm.hotelData.hotel_code == \'skipjackresort\'\"><td>Marina Electricity Charge</td><td \nclass=\"centertxt\">\n{{vm.nightAudit[vm.marinaTitle][\'Marina Electricity Charge\'] ? vm.nightAudit[vm.marinaTitle][\'Marina Electricity Charge\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.marinaTitle][\'Marina Electricity Charge\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.marinaTitle][\'Marina Electricity Charge\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.marinaTitle][\'Marina Electricity Charge\'].taxes[vm.salesTax] ? vm.nightAudit[vm.marinaTitle][\'Marina Electricity Charge\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.marinaTitle][\'Marina Electricity Charge\'] ? vm.nightAudit[vm.marinaTitle][\'Marina Electricity Charge\'].total_amount : vm.defaultValue}}\n</td></tr><tr ng-if=\"vm.hotelData.hotel_code == \'skipjackresort\'\"><td>Taxable Rentals</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.marinaTitle][\'Taxable Rentals\'] ? vm.nightAudit[vm.marinaTitle][\'Taxable Rentals\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.marinaTitle][\'Taxable Rentals\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.marinaTitle][\'Taxable Rentals\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.marinaTitle][\'Taxable Rentals\'].taxes[vm.salesTax] ? vm.nightAudit[vm.marinaTitle][\'Taxable Rentals\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.marinaTitle][\'Taxable Rentals\'] ? vm.nightAudit[vm.marinaTitle][\'Taxable Rentals\'].total_amount : vm.defaultValue}}\n</td></tr><tr ng-if=\"vm.hotelData.hotel_code == \'skipjackresort\'\"><td>Non-Taxable Rentals</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.marinaTitle][\'Non-Taxable Rentals\'] ? vm.nightAudit[vm.marinaTitle][\'Non-Taxable Rentals\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.marinaTitle][\'Non-Taxable Rentals\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.marinaTitle][\'Non-Taxable Rentals\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.marinaTitle][\'Non-Taxable Rentals\'].taxes[vm.salesTax] ? vm.nightAudit[vm.marinaTitle][\'Non-Taxable Rentals\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.marinaTitle][\'Non-Taxable Rentals\'] ? vm.nightAudit[vm.marinaTitle][\'Non-Taxable Rentals\'].total_amount : vm.defaultValue}}\n</td></tr><tr ng-if=\"vm.hotelData.hotel_code == \'skipjackresort\'\"><td class=\"total-row\"><b>Total Marina</b></td><td \nclass=\"centertxt total-row\"><b>\n{{vm.nightAudit[vm.marinaTitle][\'grand\'][\'hotelSubTotal\'] ? vm.nightAudit[vm.marinaTitle][\'grand\'][\'hotelSubTotal\']: vm.defaultValue}}\n</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit[vm.marinaTitle][\'grand\'][\'lodgingTaxTotal\'] ? vm.nightAudit[vm.marinaTitle][\'grand\'][\'lodgingTaxTotal\'] : vm.defaultValue}}\n</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit[vm.marinaTitle][\'grand\'][\'salesTaxTotal\'] ? vm.nightAudit[vm.marinaTitle][\'grand\'][\'salesTaxTotal\'] : vm.defaultValue}}\n</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit[vm.marinaTitle][\'grand\'][\'hotelGrandTotal\'] ? vm.nightAudit[vm.marinaTitle][\'grand\'][\'hotelGrandTotal\'] : vm.defaultValue}}\n</b></td></tr></tbody></table><table cellpadding=\"0\" cellspacing=\"0\" class=\"nightAudittableblock\" autosize=\"1\"><tbody>\n<tr class=\"sub-headingmain\"><td colspan=\"5\"><b>Retail</b></td></tr><tr><td>Taxable Retail</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.merchandiseTitle][\'Taxable Retail\'] ? vm.nightAudit[vm.merchandiseTitle][\'Taxable Retail\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.merchandiseTitle][\'Taxable Retail\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.merchandiseTitle][\'Taxable Retail\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.merchandiseTitle][\'Taxable Retail\'].taxes[vm.salesTax] ? vm.nightAudit[vm.merchandiseTitle][\'Taxable Retail\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.merchandiseTitle][\'Taxable Retail\'] ? vm.nightAudit[vm.merchandiseTitle][\'Taxable Retail\'].total_amount : vm.defaultValue}}\n</td></tr><tr><td>Non-Taxable Retail</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.merchandiseTitle][\'Non-Taxable Retail\'] ? vm.nightAudit[vm.merchandiseTitle][\'Non-Taxable Retail\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.merchandiseTitle][\'Non-Taxable Retail\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.merchandiseTitle][\'Non-Taxable Retail\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.merchandiseTitle][\'Non-Taxable Retail\'].taxes[vm.salesTax] ? vm.nightAudit[vm.merchandiseTitle][\'Non-Taxable Retail\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.merchandiseTitle][\'Non-Taxable Retail\'] ? vm.nightAudit[vm.merchandiseTitle][\'Non-Taxable Retail\'].total_amount : vm.defaultValue}}\n</td></tr><tr ng-repeat=\"(key,merchandise) in vm.nightAudit[vm.merchandiseTitle]\" \nng-if=\"key != \'Taxable Retail\' && key != \'Non-Taxable Retail\' && key != \'grand\'\"><td>{{key}}</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.merchandiseTitle][key] ? vm.nightAudit[vm.merchandiseTitle][key].subtotal : vm.defaultValue}}</td>\n<td class=\"centertxt\">\n{{vm.nightAudit[vm.merchandiseTitle][key].taxes[vm.lodgingTax] ? vm.nightAudit[vm.merchandiseTitle][key].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.merchandiseTitle][key].taxes[vm.salesTax] ? vm.nightAudit[vm.merchandiseTitle][key].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.merchandiseTitle][key] ? vm.nightAudit[vm.merchandiseTitle][key].total_amount : vm.defaultValue}}\n</td></tr><tr><td class=\"total-row\"><b>Total Retail</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit[vm.merchandiseTitle][\'grand\'][\'hotelSubTotal\'] ? vm.nightAudit[vm.merchandiseTitle][\'grand\'][\'hotelSubTotal\'] : vm.defaultValue}}\n</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit[vm.merchandiseTitle][\'grand\'][\'lodgingTaxTotal\'] ? vm.nightAudit[vm.merchandiseTitle][\'grand\'][\'lodgingTaxTotal\'] : vm.defaultValue}}\n</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit[vm.merchandiseTitle][\'grand\'][\'salesTaxTotal\'] ? vm.nightAudit[vm.merchandiseTitle][\'grand\'][\'salesTaxTotal\'] : vm.defaultValue}}\n</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit[vm.merchandiseTitle][\'grand\'][\'hotelGrandTotal\'] ? vm.nightAudit[vm.merchandiseTitle][\'grand\'][\'hotelGrandTotal\'] : vm.defaultValue}}\n</b></td></tr></tbody></table><table cellpadding=\"0\" cellspacing=\"0\" class=\"nightAudittableblock\" autosize=\"1\" \nng-if=\"vm.hotelData.hotel_code == \'skipjackresort\' || vm.hotelData.hotel_code == \'southernmosthouse\'\"><tbody><tr \nclass=\"sub-headingmain\"><td ng-if=\"vm.hotelData.hotel_code == \'skipjackresort\'\"><b>Restaurant</b></td><td \nng-if=\"vm.hotelData.hotel_code == \'southernmosthouse\'\"><b>Bar</b></td><td style=\"text-align: center\">Sub Total</td><td \nstyle=\"text-align: center\">Bar Tax</td><td style=\"text-align: center\">Sales Tax</td><td style=\"text-align: center\">\nGrand Total</td></tr><tr ng-if=\"vm.hotelData.hotel_code == \'skipjackresort\'\"><td>Food</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Foods\'] ? vm.nightAudit[vm.restaurantTitle][\'Foods\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Foods\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.restaurantTitle][\'Foods\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Foods\'].taxes[vm.salesTax] ? vm.nightAudit[vm.restaurantTitle][\'Foods\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Foods\'] ? vm.nightAudit[vm.restaurantTitle][\'Foods\'].total_amount : vm.defaultValue}}\n</td></tr><tr ng-if=\"vm.hotelData.hotel_code == \'skipjackresort\' || vm.hotelData.hotel_code == \'southernmosthouse\'\">\n<td>Drinks</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Drinks\'] ? vm.nightAudit[vm.restaurantTitle][\'Drinks\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Drinks\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.restaurantTitle][\'Drinks\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Drinks\'].taxes[vm.salesTax] ? vm.nightAudit[vm.restaurantTitle][\'Drinks\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Drinks\'] ? vm.nightAudit[vm.restaurantTitle][\'Drinks\'].total_amount : vm.defaultValue}}\n</td></tr><tr ng-if=\"vm.hotelData.hotel_code == \'skipjackresort\' || vm.hotelData.hotel_code == \'southernmosthouse\'\">\n<td>Beer/Wine</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Beer/Wine\'] ? vm.nightAudit[vm.restaurantTitle][\'Beer/Wine\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Beer/Wine\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.restaurantTitle][\'Beer/Wine\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Beer/Wine\'].taxes[vm.salesTax] ? vm.nightAudit[vm.restaurantTitle][\'Beer/Wine\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Beer/Wine\'] ? vm.nightAudit[vm.restaurantTitle][\'Beer/Wine\'].total_amount : vm.defaultValue}}\n</td></tr><tr ng-if=\"vm.hotelData.hotel_code == \'skipjackresort\' || vm.hotelData.hotel_code == \'southernmosthouse\'\">\n<td>Liquor</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Liquor\'] ? vm.nightAudit[vm.restaurantTitle][\'Liquor\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Liquor\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.restaurantTitle][\'Liquor\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Liquor\'].taxes[vm.salesTax] ? vm.nightAudit[vm.restaurantTitle][\'Liquor\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Liquor\'] ? vm.nightAudit[vm.restaurantTitle][\'Liquor\'].total_amount : vm.defaultValue}}\n</td></tr><tr ng-if=\"vm.hotelData.hotel_code == \'skipjackresort\' || vm.hotelData.hotel_code == \'southernmosthouse\'\">\n<td>Non-Taxable</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Non-Taxable\'] ? vm.nightAudit[vm.restaurantTitle][\'Non-Taxable\'].subtotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Non-Taxable\'].taxes[vm.lodgingTax] ? vm.nightAudit[vm.restaurantTitle][\'Non-Taxable\'].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Non-Taxable\'].taxes[vm.salesTax] ? vm.nightAudit[vm.restaurantTitle][\'Non-Taxable\'].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.restaurantTitle][\'Non-Taxable\'] ? vm.nightAudit[vm.restaurantTitle][\'Non-Taxable\'].total_amount : vm.defaultValue}}\n</td></tr><tr ng-if=\"vm.hotelData.hotel_code == \'skipjackresort\' || vm.hotelData.hotel_code == \'southernmosthouse\'\"><td\n class=\"total-row\"><b>Total Restaurant</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit[vm.restaurantTitle][\'grand\'][\'hotelSubTotal\']}}</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit[vm.restaurantTitle][\'grand\'][\'lodgingTaxTotal\']}}</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit[vm.restaurantTitle][\'grand\'][\'salesTaxTotal\']}}</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit[vm.restaurantTitle][\'grand\'][\'hotelGrandTotal\']}}</b></td></tr></tbody></table><table cellpadding=\"0\" \ncellspacing=\"0\" class=\"nightAudittableblock\"><tbody><tr><td><b>Grand Total</b></td><td class=\"centertxt\"><b>\n{{vm.nightAudit[\'overAllGrandTotal\'][\'grandSubTotal\'] ? vm.nightAudit[\'overAllGrandTotal\'][\'grandSubTotal\'] : vm.defaultValue}}\n</b></td><td class=\"centertxt\"><b>\n{{vm.nightAudit[\'overAllGrandTotal\'][\'grandLodgingTax\'] ? vm.nightAudit[\'overAllGrandTotal\'][\'grandLodgingTax\'] : vm.defaultValue}}\n</b></td><td class=\"centertxt\"><b>\n{{vm.nightAudit[\'overAllGrandTotal\'][\'grandSalesTax\'] ? vm.nightAudit[\'overAllGrandTotal\'][\'grandSalesTax\'] : vm.defaultValue}}\n</b></td><td class=\"centertxt\"><b>\n{{vm.nightAudit[\'overAllGrandTotal\'][\'grandTotalAmount\'] ? vm.nightAudit[\'overAllGrandTotal\'][\'grandTotalAmount\'] : vm.defaultValue}}\n</b></td></tr></tbody></table><table cellpadding=\"0\" cellspacing=\"0\" class=\"nightAudittableblock\"><tbody><tr><td>\nAdvance Deposits Collected</td><td class=\"centertxt\">\n{{vm.nightAudit[\'advance_deposits\'][\'collected\'] ? vm.nightAudit[\'advance_deposits\'][\'collected\'] : vm.defaultValue}}\n</td><td class=\"centertxt\">--</td><td class=\"centertxt\">--</td><td class=\"centertxt\">\n{{vm.nightAudit[\'advance_deposits\'][\'collected\'] ? vm.nightAudit[\'advance_deposits\'][\'collected\'] : vm.defaultValue}}\n</td></tr></tbody></table><table cellpadding=\"0\" cellspacing=\"0\" class=\"nightAudittableblock\"><tbody><tr><td>\nAdvance Deposits Used</td><td class=\"centertxt\">\n{{vm.nightAudit[\'advance_deposits\'][\'used\'] ? vm.nightAudit[\'advance_deposits\'][\'used\'] : vm.defaultValue}}</td><td \nclass=\"centertxt\">--</td><td class=\"centertxt\">--</td><td class=\"centertxt\">\n{{vm.nightAudit[\'advance_deposits\'][\'used\'] ? vm.nightAudit[\'advance_deposits\'][\'used\'] : vm.defaultValue}}</td></tr>\n</tbody></table><table cellpadding=\"0\" cellspacing=\"0\" class=\"nightAudittableblock\"><tbody><tr class=\"sub-headingmain\">\n<td colspan=\"5\"><b>Payments Collected</b></td></tr><tr ng-repeat=\"(key, value) in vm.nightAudit[\'paymentDetails\']\"><td>\n{{key}}</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td class=\"centertxt\">{{value.paid}}</td></tr><tr><td \nclass=\"total-row\"><b>Total Collected</b></td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td \nclass=\"total-row centertxt\"><b>{{vm.paymentTotalCalculate(vm.nightAudit[\'paymentDetails\'])}}</b></td></tr></tbody>\n</table></td></tr></tbody></table></div></div></div><div class=\"nightAudit-tableblock nightaudittable\" \nng-if=\"vm.showGeneratingFlag\"><div class=\"generate_report_div\"><div class=\"inside-generate-report\"><h1>Please wait \n<span class=\"loader_img\"><img src=\"assets/images/loading_dots.gif\"></span></h1><p>Generating data for all nights</p>\n</div></div></div></div>");
$templateCache.put("app/main/apps/reports/night-audit-new/night-audit-new.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-night\" \nclass=\"mr-10\"></md-icon><span>Night Audit</span></div></div></div><div class=\"content\"><div class=\"Night-audit-table\">\n<div class=\"Night-audit-heading\">\nNight Audit {{ vm.startDate | date:\'MM/dd/yyyy\'}} - {{ vm.endDate | date:\'MM/dd/yyyy\'}}</div><div \nclass=\"searching_input-blocksmain\"><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" \nflex-gt-xs=\"{{isParent || vm.hotelID == 126 ? 25 : 50}}\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">From Date</label>\n<md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.departureDate\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" ng-change=\"vm.checkSchedule(\'from\')\" md-min-date=\"vm.initialDate\" required>\n</md-datepicker></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{isParent || vm.hotelID == 126 ? 25 : 50}}\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">To Date</label>\n<md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.departureDateTo\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" ng-change=\"vm.checkSchedule(\'to\')\" md-max-date=\"vm.newEndDate\" \nmd-min-date=\"vm.departureDate\" required></md-datepicker></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\" ng-if=\"isParent\"><md-input-container><label>\n{{ vm.selectedHotels.length == 1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"25\" \nflex=\"100\" class=\"ph-10\" ng-if=\"vm.hotelID == 126 || vm.hotelID == 122\"><md-input-container><label>Report For</label>\n<md-select ng-model=\"vm.reportFor\"><md-optgroup label=\"Report For\"><md-option value=\"all\">All</md-option><md-option \nvalue=\"hotel\">Hotel</md-option><md-option value=\"marina\">Marina</md-option></md-optgroup></md-select>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex-gt-xs=\"100\" \nflex=\"100\" layout-align=\"center end\"><div class=\"btnsrefreshblock\"><md-button class=\"md-raised md-cornered mr-10\" \nng-click=\"vm.getReports(0)\" ng-disabled=\"vm.refreshRequest\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.refreshRequest\"></md-progress-circular>\n</md-button><md-button class=\"md-raised md-cornered mr-10\" ng-if=\"vm.objKeys.length > 0\" \nng-click=\"vm.exportFile(\'csv\')\" ng-disabled=\"vm.csvLoader\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>Export to CSV<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.csvLoader\"></md-progress-circular></md-button>\n<md-button class=\"md-raised md-cornered mr-10\" ng-if=\"vm.objKeys.length > 0\" ng-click=\"vm.exportFile(\'pdf\')\" \nng-disabled=\"vm.exportLoader\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>\nExport to PDF<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.exportLoader\"></md-progress-circular></md-button></div></div></div></div><div \nclass=\"nightAudit-tableblock nightaudittable\" ng-if=\"vm.objKeys.length > 0 && !vm.showGeneratingFlag\" \nid=\"table-container\"><table cellpadding=\"0\" cellspacing=\"0\" class=\"nightAudittableblock fixheadertable simple\" \nstyle=\"border:none\" id=\"tableOuter\"><thead style=\"background: #f1f1f1\"><tr class=\"headingoutertb\" \nstyle=\"border: 1px solid #dedede\"><th><p style=\"opacity:0\">Index</p></th><th class=\"centertxt\"><b \nstyle=\"color:#000; font-weight:bold; font-size:16px\">Total Revenue</b></th><th class=\"centertxt\"><b \nstyle=\"color:#000; font-weight:bold; font-size:16px\">Total Tourist Development Tax Collected</b></th><th \nclass=\"centertxt\"><b style=\"color:#000; font-weight:bold; font-size:16px\">Total Sales Tax Collected</b></th><th \nclass=\"centertxt\"><b style=\"color:#000; font-weight:bold; font-size:16px\">CC Processing Fee</b></th><th \nclass=\"centertxt\"><b style=\"color:#000; font-weight:bold; font-size:16px\">Grand Total</b></th></tr></thead><tbody \nid=\"tbodyHeight\" ng-style=\"vm.tableOuterStyle\" ms-scroll style=\"position:relative\"><tr><td colspan=\"6\" \nstyle=\"padding:0px !important;width:100%\"><table cellpadding=\"0\" cellspacing=\"0\" \nclass=\"nightAudittableblock tableCursor\" style=\"margin-top: 0px\" id=\"tableInner\" autosize=\"1\"><tbody><tr \nclass=\"sub-headingmain\"><td colspan=\"6\"><b>Hotel</b></td></tr><tr ng-if=\"vm.hotelID == 126\" \nng-click=\"vm.showNightAuditDetail(\'hotel\', \'villas_taxable\')\"><td>Taxable Rentals - Villas</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.villas_taxable.subTotal ? (vm.nightAudit.hotel.villas_taxable.subTotal | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.villas_taxable.tourist_development_tax ? (vm.nightAudit.hotel.villas_taxable.tourist_development_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.villas_taxable.sales_tax ? (vm.nightAudit.hotel.villas_taxable.sales_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.villas_taxable.cc_processing_tax ? (vm.nightAudit.hotel.villas_taxable.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.villas_taxable.grandTotal ? (vm.nightAudit.hotel.villas_taxable.grandTotal | currency) : vm.defaultValue}}\n</td></tr><tr><td colspan=\"6\" style=\"padding: 0px!important\"><table id=\"subcategory-table\" cellpadding=\"0\" \ncellspacing=\"0\"><tbody><tr ng-click=\"vm.showNightAuditDetail(\'hotel\', \'short_term_taxable\')\"><td>\nTaxable Rentals - Short Term</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.short_term_taxable.subTotal ? (vm.nightAudit.hotel.short_term_taxable.subTotal | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.short_term_taxable.tourist_development_tax ? (vm.nightAudit.hotel.short_term_taxable.tourist_development_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.short_term_taxable.sales_tax ? (vm.nightAudit.hotel.short_term_taxable.sales_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.short_term_taxable.cc_processing_tax ? (vm.nightAudit.hotel.short_term_taxable.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.short_term_taxable.grandTotal ? (vm.nightAudit.hotel.short_term_taxable.grandTotal | currency) : vm.defaultValue}}\n</td></tr><tr class=\"airbnb-rental-taxable\" ng-click=\"vm.showNightAuditDetail(\'hotel\', \'airbnb_taxable\')\"><td \nstyle=\"padding-left: 3%!important\">Airbnb Rentals</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.airbnb_taxable.subTotal ? (vm.nightAudit.hotel.airbnb_taxable.subTotal | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.airbnb_taxable.tourist_development_tax ? (vm.nightAudit.hotel.airbnb_taxable.tourist_development_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.airbnb_taxable.sales_tax ? (vm.nightAudit.hotel.airbnb_taxable.sales_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.airbnb_taxable.cc_processing_tax ? (vm.nightAudit.hotel.airbnb_taxable.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.airbnb_taxable.grandTotal ? (vm.nightAudit.hotel.airbnb_taxable.grandTotal | currency) : vm.defaultValue}}\n</td></tr></tbody></table></td></tr><tr ng-click=\"vm.showNightAuditDetail(\'hotel\', \'short_term_non_taxable\')\"><td>\nNon-Taxable Rentals - Short Term</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.short_term_non_taxable.subTotal ? (vm.nightAudit.hotel.short_term_non_taxable.subTotal | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.short_term_non_taxable.tourist_development_tax ? (vm.nightAudit.hotel.short_term_non_taxable.tourist_development_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.short_term_non_taxable.sales_tax ? (vm.nightAudit.hotel.short_term_non_taxable.sales_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.short_term_non_taxable.cc_processing_tax ? (vm.nightAudit.hotel.short_term_non_taxable.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.short_term_non_taxable.grandTotal ? (vm.nightAudit.hotel.short_term_non_taxable.grandTotal | currency) : vm.defaultValue}}\n</td></tr><tr ng-if=\"vm.hotelID == 126\" ng-click=\"vm.showNightAuditDetail(\'hotel\', \'villas_non_taxable\')\"><td>\nNon-Taxable Rentals - Villas</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.villas_non_taxable.subTotal ? (vm.nightAudit.hotel.villas_non_taxable.subTotal | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.villas_non_taxable.tourist_development_tax ? (vm.nightAudit.hotel.villas_non_taxable.tourist_development_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.villas_non_taxable.sales_tax ? (vm.nightAudit.hotel.villas_non_taxable.sales_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.villas_non_taxable.cc_processing_tax ? (vm.nightAudit.hotel.villas_non_taxable.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.villas_non_taxable.grandTotal ? (vm.nightAudit.hotel.villas_non_taxable.grandTotal | currency) : vm.defaultValue}}\n</td></tr><tr ng-if=\"vm.hotelID == 126\"><td colspan=\"6\" style=\"padding: 0px!important\"><table cellpadding=\"0\" \ncellspacing=\"0\" width=\"100%\"><tbody><tr ng-click=\"vm.showNightAuditDetail(\'hotel\', \'long_term_taxable\')\"><td>\nLong Term Rentals</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.long_term_taxable.subTotal ? (vm.nightAudit.hotel.long_term_taxable.subTotal | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.long_term_taxable.tourist_development_tax ? (vm.nightAudit.hotel.long_term_taxable.tourist_development_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.long_term_taxable.sales_tax ? (vm.nightAudit.hotel.long_term_taxable.sales_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.long_term_taxable.cc_processing_tax ? (vm.nightAudit.hotel.long_term_taxable.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.long_term_taxable.grandTotal ? (vm.nightAudit.hotel.long_term_taxable.grandTotal | currency) : vm.defaultValue}}\n</td></tr><tr class=\"outertr\" ng-click=\"vm.showNightAuditDetail(\'hotel\', \'residences_taxable\')\"><td \nstyle=\"padding-left: 3%!important\" class=\"remove_bottom\">Residences</td><td class=\"centertxt remove_bottom\">\n{{vm.nightAudit.hotel.residences_taxable.subTotal ? (vm.nightAudit.hotel.residences_taxable.subTotal | currency) : vm.defaultValue}}\n</td><td class=\"centertxt remove_bottom\">\n{{vm.nightAudit.hotel.residences_taxable.tourist_development_tax ? (vm.nightAudit.hotel.residences_taxable.tourist_development_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt remove_bottom\">\n{{vm.nightAudit.hotel.residences_taxable.sales_tax ? (vm.nightAudit.hotel.residences_taxable.sales_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt remove_bottom\">\n{{vm.nightAudit.hotel.residences_taxable.grandTotal ? (vm.nightAudit.hotel.residences_taxable.grandTotal | currency) : vm.defaultValue}}\n</td></tr><tr class=\"outertr\" ng-click=\"vm.showNightAuditDetail(\'hotel\', \'timeshare_taxable\')\"><td \nstyle=\"padding-left: 3%!important\" class=\"remove_bottom\">Timeshare Rentals</td><td class=\"centertxt remove_bottom\">\n{{vm.nightAudit.hotel.timeshare_taxable.subTotal ? (vm.nightAudit.hotel.timeshare_taxable.subTotal | currency) : vm.defaultValue}}\n</td><td class=\"centertxt remove_bottom\">\n{{vm.nightAudit.hotel.timeshare_taxable.tourist_development_tax ? (vm.nightAudit.hotel.timeshare_taxable.tourist_development_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt remove_bottom\">\n{{vm.nightAudit.hotel.timeshare_taxable.sales_tax ? (vm.nightAudit.hotel.timeshare_taxable.sales_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt remove_bottom\">\n{{vm.nightAudit.hotel.timeshare_taxable.grandTotal ? (vm.nightAudit.hotel.timeshare_taxable.grandTotal | currency) : vm.defaultValue}}\n</td></tr></tbody></table></td></tr><tr ng-click=\"vm.showNightAuditDetail(\'hotel\', \'resort_day_pass\')\"><td>\nResort Day Pass</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.resort_day_pass.subTotal ? (vm.nightAudit.hotel.resort_day_pass.subTotal | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.resort_day_pass.tourist_development_tax ? (vm.nightAudit.hotel.resort_day_pass.tourist_development_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.resort_day_pass.sales_tax ? (vm.nightAudit.hotel.resort_day_pass.sales_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.resort_day_pass.cc_processing_tax ? (vm.nightAudit.hotel.resort_day_pass.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.resort_day_pass.grandTotal ? (vm.nightAudit.hotel.resort_day_pass.grandTotal | currency) : vm.defaultValue}}\n</td></tr><tr ng-click=\"vm.showNightAuditDetail(\'hotel\', \'resort_fee_taxable\')\" \nng-if=\"vm.nightAudit.hotel.resort_fee_taxable\"><td>Resort Fee</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.resort_fee_taxable.subTotal ? (vm.nightAudit.hotel.resort_fee_taxable.subTotal | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.resort_fee_taxable.tourist_development_tax ? (vm.nightAudit.hotel.resort_fee_taxable.tourist_development_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.resort_fee_taxable.sales_tax ? (vm.nightAudit.hotel.resort_fee_taxable.sales_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.resort_fee_taxable.cc_processing_tax ? (vm.nightAudit.hotel.resort_fee_taxable.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.resort_fee_taxable.grandTotal ? (vm.nightAudit.hotel.resort_fee_taxable.grandTotal | currency) : vm.defaultValue}}\n</td></tr><tr ng-click=\"vm.showNightAuditDetail(\'hotel\', \'extra_person_taxable\')\"><td>Extra Person</td><td \nclass=\"centertxt\">\n{{vm.nightAudit.hotel.extra_person_taxable.subTotal ? (vm.nightAudit.hotel.extra_person_taxable.subTotal | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.extra_person_taxable.tourist_development_tax ? (vm.nightAudit.hotel.extra_person_taxable.tourist_development_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.extra_person_taxable.sales_tax ? (vm.nightAudit.hotel.extra_person_taxable.sales_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.extra_person_taxable.cc_processing_tax ? (vm.nightAudit.hotel.extra_person_taxable.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.extra_person_taxable.grandTotal ? (vm.nightAudit.hotel.extra_person_taxable.grandTotal | currency) : vm.defaultValue}}\n</td></tr><tr ng-click=\"vm.showNightAuditDetail(\'hotel\', \'cancellation_fee\')\"><td>Cancellation Fee</td><td \nclass=\"centertxt\">\n{{vm.nightAudit.hotel.cancellation_fee.subTotal ? (vm.nightAudit.hotel.cancellation_fee.subTotal | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.cancellation_fee.tourist_development_tax ? (vm.nightAudit.hotel.cancellation_fee.tourist_development_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.cancellation_fee.sales_tax ? (vm.nightAudit.hotel.cancellation_fee.sales_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.cancellation_fee.cc_processing_tax ? (vm.nightAudit.hotel.cancellation_fee.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.cancellation_fee.grandTotal ? (vm.nightAudit.hotel.cancellation_fee.grandTotal | currency) : vm.defaultValue}}\n</td></tr><tr ng-click=\"vm.showNightAuditDetail(\'hotel\', \'cleaning_fee\')\"><td>Cleaning Fee</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.cleaning_fee.subTotal ? (vm.nightAudit.hotel.cleaning_fee.subTotal | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.cleaning_fee.tourist_development_tax ? (vm.nightAudit.hotel.cleaning_fee.tourist_development_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.cleaning_fee.sales_tax ? (vm.nightAudit.hotel.cleaning_fee.sales_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.cleaning_fee.cc_processing_tax ? (vm.nightAudit.hotel.cleaning_fee.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.cleaning_fee.grandTotal ? (vm.nightAudit.hotel.cleaning_fee.grandTotal | currency) : vm.defaultValue}}\n</td></tr><tr ng-click=\"vm.showNightAuditDetail(\'hotel\', \'damage_fee\')\"><td>Damage Fee</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.damage_fee.subTotal ? (vm.nightAudit.hotel.damage_fee.subTotal | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.damage_fee.tourist_development_tax ? (vm.nightAudit.hotel.damage_fee.tourist_development_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.damage_fee.sales_tax ? (vm.nightAudit.hotel.damage_fee.sales_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.damage_fee.cc_processing_tax ? (vm.nightAudit.hotel.damage_fee.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.damage_fee.grandTotal ? (vm.nightAudit.hotel.damage_fee.grandTotal | currency) : vm.defaultValue}}\n</td></tr><tr ng-click=\"vm.showNightAuditDetail(\'hotel\', \'late_checkout_fee\')\"><td>Late Check-Out Fee</td><td \nclass=\"centertxt\">\n{{vm.nightAudit.hotel.late_checkout_fee.subTotal ? (vm.nightAudit.hotel.late_checkout_fee.subTotal | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.late_checkout_fee.tourist_development_tax ? (vm.nightAudit.hotel.late_checkout_fee.tourist_development_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.late_checkout_fee.sales_tax ? (vm.nightAudit.hotel.late_checkout_fee.sales_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.late_checkout_fee.cc_processing_tax ? (vm.nightAudit.hotel.late_checkout_fee.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.late_checkout_fee.grandTotal ? (vm.nightAudit.hotel.late_checkout_fee.grandTotal | currency) : vm.defaultValue}}\n</td></tr><tr ng-click=\"vm.showNightAuditDetail(\'hotel\', \'pet_fee\')\"><td>Pet Fee</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.pet_fee.subTotal ? (vm.nightAudit.hotel.pet_fee.subTotal | currency) : vm.defaultValue}}</td><td \nclass=\"centertxt\">\n{{vm.nightAudit.hotel.pet_fee.tourist_development_tax ? (vm.nightAudit.hotel.pet_fee.tourist_development_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.pet_fee.sales_tax ? (vm.nightAudit.hotel.pet_fee.sales_tax | currency) : vm.defaultValue}}</td>\n<td class=\"centertxt\">\n{{vm.nightAudit.hotel.pet_fee.cc_processing_tax ? (vm.nightAudit.hotel.pet_fee.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.pet_fee.grandTotal ? (vm.nightAudit.hotel.pet_fee.grandTotal | currency) : vm.defaultValue}}</td>\n</tr><tr ng-click=\"vm.showNightAuditDetail(\'hotel\', \'smoking_fee\')\"><td>Smoking Fee</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.smoking_fee.subTotal ? (vm.nightAudit.hotel.smoking_fee.subTotal | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.smoking_fee.tourist_development_tax ? (vm.nightAudit.hotel.smoking_fee.tourist_development_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.smoking_fee.sales_tax ? (vm.nightAudit.hotel.smoking_fee.sales_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.smoking_fee.cc_processing_tax ? (vm.nightAudit.hotel.smoking_fee.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.smoking_fee.grandTotal ? (vm.nightAudit.hotel.smoking_fee.grandTotal | currency) : vm.defaultValue}}\n</td></tr><tr ng-click=\"vm.showNightAuditDetail(\'hotel\', \'other_miscellanous_fees\')\"><td>Other Miscellaneous Fees</td>\n<td class=\"centertxt\">\n{{vm.nightAudit.hotel.other_miscellanous_fees.subTotal ? (vm.nightAudit.hotel.other_miscellanous_fees.subTotal | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.other_miscellanous_fees.tourist_development_tax ? (vm.nightAudit.hotel.other_miscellanous_fees.tourist_development_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.other_miscellanous_fees.sales_tax ? (vm.nightAudit.hotel.other_miscellanous_fees.sales_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.other_miscellanous_fees.cc_processing_tax ? (vm.nightAudit.hotel.other_miscellanous_fees.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.hotel.other_miscellanous_fees.grandTotal ? (vm.nightAudit.hotel.other_miscellanous_fees.grandTotal | currency) : vm.defaultValue}}\n</td></tr><tr><td class=\"total-row\"><b>Total Hotel</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit.hotel.hotelTotal.subTotal | currency}}</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit.hotel.hotelTotal.tourist_development_tax | currency}}</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit.hotel.hotelTotal.sales_tax | currency}}</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit.hotel.hotelTotal.cc_processing_tax | currency}}</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit.hotel.hotelTotal.grandTotal | currency}}</b></td></tr></tbody></table><table cellpadding=\"0\" \ncellspacing=\"0\" class=\"nightAudittableblock tableCursor\" autosize=\"1\" \nng-if=\"(vm.reportFor == \'marina\' || vm.reportFor == \'all\') && vm.nightAudit.marina.marinaTotal\"><tbody><tr \nclass=\"sub-headingmain\"><td colspan=\"6\"><b>Marina</b></td></tr><tr \nng-click=\"vm.showNightAuditDetail(\'marina\', \'boat_launch_fee\')\"><td>Boat Launch Fee</td><td class=\"centertxt\">\n{{vm.nightAudit.marina.boat_launch_fee.subTotal}}</td><td class=\"centertxt\">\n{{vm.nightAudit.marina.boat_launch_fee.tourist_development_tax}}</td><td class=\"centertxt\">\n{{vm.nightAudit.marina.boat_launch_fee.sales_tax}}</td><td class=\"centertxt\">\n{{vm.nightAudit.marina.boat_launch_fee.cc_processing_tax | currency}}</td><td class=\"centertxt\">\n{{vm.nightAudit.marina.boat_launch_fee.grandTotal}}</td></tr><tr \nng-click=\"vm.showNightAuditDetail(\'marina\', \'marina_electricity_charge\')\"><td>Marina Electricity Charge</td><td \nclass=\"centertxt\">{{vm.nightAudit.marina.marina_electricity_charge.subTotal}}</td><td class=\"centertxt\">\n{{vm.nightAudit.marina.marina_electricity_charge.tourist_development_tax}}</td><td class=\"centertxt\">\n{{vm.nightAudit.marina.marina_electricity_charge.sales_tax}}</td><td class=\"centertxt\">\n{{vm.nightAudit.marina.marina_electricity_charge.cc_processing_tax | currency}}</td><td class=\"centertxt\">\n{{vm.nightAudit.marina.marina_electricity_charge.grandTotal}}</td></tr><tr \nng-click=\"vm.showNightAuditDetail(\'marina\', \'marina_taxable_rentals\')\"><td>Taxable Rentals</td><td class=\"centertxt\">\n{{vm.nightAudit.marina.marina_taxable_rentals.subTotal}}</td><td class=\"centertxt\">\n{{vm.nightAudit.marina.marina_taxable_rentals.tourist_development_tax}}</td><td class=\"centertxt\">\n{{vm.nightAudit.marina.marina_taxable_rentals.sales_tax}}</td><td class=\"centertxt\">\n{{vm.nightAudit.marina.marina_taxable_rentals.cc_processing_tax | currency}}</td><td class=\"centertxt\">\n{{vm.nightAudit.marina.marina_taxable_rentals.grandTotal}}</td></tr><tr \nng-click=\"vm.showNightAuditDetail(\'marina\', \'marina_non_taxable_rentals\')\"><td>Non-Taxable Rentals</td><td \nclass=\"centertxt\">{{vm.nightAudit.marina.marina_non_taxable_rentals.subTotal}}</td><td class=\"centertxt\">\n{{vm.nightAudit.marina.marina_non_taxable_rentals.tourist_development_tax}}</td><td class=\"centertxt\">\n{{vm.nightAudit.marina.marina_non_taxable_rentals.sales_tax}}</td><td class=\"centertxt\">\n{{vm.nightAudit.marina.marina_non_taxable_rentals.cc_processing_tax | currency}}</td><td class=\"centertxt\">\n{{vm.nightAudit.marina.marina_non_taxable_rentals.grandTotal}}</td></tr><tr><td class=\"total-row\"><b>Total Marina</b>\n</td><td class=\"centertxt total-row\"><b>{{vm.nightAudit.marina.marinaTotal.subTotal}}</b></td><td \nclass=\"centertxt total-row\"><b>{{vm.nightAudit.marina.marinaTotal.tourist_development_tax}}</b></td><td \nclass=\"centertxt total-row\"><b>{{vm.nightAudit.marina.marinaTotal.sales_tax}}</b></td><td class=\"centertxt total-row\">\n<b>{{vm.nightAudit.marina.marinaTotal.cc_processing_tax | currency}}</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit.marina.marinaTotal.grandTotal}}</b></td></tr></tbody></table><table cellpadding=\"0\" cellspacing=\"0\" \nclass=\"nightAudittableblock tableCursor\" autosize=\"1\"><tbody><tr class=\"sub-headingmain\"><td colspan=\"6\"><b>Retail</b>\n</td></tr><tr ng-click=\"vm.showNightAuditDetail(\'retail\', \'retail_taxable\')\"><td>Taxable Retail</td><td \nclass=\"centertxt\">\n{{vm.nightAudit.retail.retail_taxable.subTotal ? (vm.nightAudit.retail.retail_taxable.subTotal | currency) : (vm.defaultValue | currency)}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.retail.retail_taxable.tourist_development_tax ? (vm.nightAudit.retail.retail_taxable.tourist_development_tax | currency) : (vm.defaultValue | currency)}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.retail.retail_taxable.sales_tax ? (vm.nightAudit.retail.retail_taxable.sales_tax | currency) : (vm.defaultValue | currency)}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.retail.retail_taxable.cc_processing_tax ? (vm.nightAudit.retail.retail_taxable.cc_processing_tax | currency) : (vm.defaultValue | currency)}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.retail.retail_taxable.grandTotal ? (vm.nightAudit.retail.retail_taxable.grandTotal | currency) : (vm.defaultValue | currency)}}\n</td></tr><tr ng-click=\"vm.showNightAuditDetail(\'retail\', \'retail_non_taxable\')\"><td>Non-Taxable Retail</td><td \nclass=\"centertxt\">\n{{vm.nightAudit.retail.retail_non_taxable.subTotal ? (vm.nightAudit.retail.retail_non_taxable.subTotal | currency) : (vm.defaultValue | currency)}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.retail.retail_non_taxable.tourist_development_tax ? (vm.nightAudit.retail.retail_non_taxable.tourist_development_tax | currency) : (vm.defaultValue | currency)}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.retail.retail_non_taxable.sales_tax ? (vm.nightAudit.retail.retail_non_taxable.sales_tax | currency) : (vm.defaultValue | currency)}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.retail.retail_non_taxable.cc_processing_tax ? (vm.nightAudit.retail.retail_non_taxable.cc_processing_tax | currency) : (vm.defaultValue | currency)}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.retail.retail_non_taxable.grandTotal ? (vm.nightAudit.retail.retail_non_taxable.grandTotal | currency) : (vm.defaultValue | currency)}}\n</td></tr><tr ng-repeat=\"(key,merchandise) in vm.nightAudit[vm.merchandiseTitle]\" \nng-if=\"key != \'Taxable Retail\' && key != \'Non-Taxable Retail\' && key != \'grand\'\"><td>{{key}}</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.merchandiseTitle][key] ? vm.nightAudit[vm.merchandiseTitle][key].subtotal : vm.defaultValue}}</td>\n<td class=\"centertxt\">\n{{vm.nightAudit[vm.merchandiseTitle][key].taxes[vm.lodgingTax] ? vm.nightAudit[vm.merchandiseTitle][key].taxes[vm.lodgingTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.merchandiseTitle][key].taxes[vm.salesTax] ? vm.nightAudit[vm.merchandiseTitle][key].taxes[vm.salesTax].total_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">{{vm.defaultValue}}</td><td class=\"centertxt\">\n{{vm.nightAudit[vm.merchandiseTitle][key] ? vm.nightAudit[vm.merchandiseTitle][key].total_amount : vm.defaultValue}}\n</td></tr><tr><td class=\"total-row\"><b>Total Retail</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit.retail.retailTotal.subTotal ? (vm.nightAudit.retail.retailTotal.subTotal | currency) : vm.defaultValue}}\n</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit.retail.retailTotal.tourist_development_tax ? (vm.nightAudit.retail.retailTotal.tourist_development_tax | currency) : vm.defaultValue}}\n</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit.retail.retailTotal.sales_tax ? (vm.nightAudit.retail.retailTotal.sales_tax | currency) : vm.defaultValue}}\n</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit.retail.retailTotal.cc_processing_tax ? (vm.nightAudit.retail.retailTotal.cc_processing_tax | currency) : vm.defaultValue}}\n</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit.retail.retailTotal.grandTotal ? (vm.nightAudit.retail.retailTotal.grandTotal | currency) : vm.defaultValue}}\n</b></td></tr></tbody></table><table cellpadding=\"0\" cellspacing=\"0\" class=\"nightAudittableblock tableCursor\" \nautosize=\"1\" ng-if=\"vm.hotelData.hotel_code == \'skipjackresort\' || vm.hotelData.hotel_code == \'southernmosthouse\'\">\n<tbody><tr class=\"sub-headingmain\"><td ng-if=\"vm.hotelData.hotel_code == \'skipjackresort\'\"><b>Restaurant</b></td><td \nng-if=\"vm.hotelData.hotel_code == \'southernmosthouse\'\"><b>Bar</b></td><td style=\"text-align: center\">Sub Total</td><td \nstyle=\"text-align: center\">Bar Tax</td><td style=\"text-align: center\">Sales Tax</td><td style=\"text-align: center\">\nCC Processing Fee</td><td style=\"text-align: center\">Grand Total</td></tr><tr \nng-click=\"vm.showNightAuditDetail(\'restaurant\', \'food\')\"><td>Food</td><td class=\"centertxt\">\n{{vm.nightAudit.restaurant.food.subTotal ? vm.nightAudit.restaurant.food.subTotal : vm.defaultValue}}</td><td \nclass=\"centertxt\">\n{{vm.nightAudit.restaurant.food.tourist_development_tax ? vm.nightAudit.restaurant.food.tourist_development_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.restaurant.food.sales_tax ? vm.nightAudit.restaurant.food.sales_tax : vm.defaultValue}}</td><td \nclass=\"centertxt\">\n{{vm.nightAudit.restaurant.food.cc_processing_tax ? (vm.nightAudit.restaurant.food.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.restaurant.food.grandTotal ? (vm.nightAudit.restaurant.food.grandTotal | currency) : (vm.defaultValue | currency)}}\n</td></tr><tr ng-click=\"vm.showNightAuditDetail(\'restaurant\', \'drinks\')\"><td>Drinks</td><td class=\"centertxt\">\n{{vm.nightAudit.restaurant.drinks.subTotal ? vm.nightAudit.restaurant.drinks.subTotal : vm.defaultValue}}</td><td \nclass=\"centertxt\">\n{{vm.nightAudit.restaurant.drinks.tourist_development_tax ? vm.nightAudit.restaurant.drinks.tourist_development_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.restaurant.drinks.sales_tax ? vm.nightAudit.restaurant.drinks.sales_tax : vm.defaultValue}}</td><td \nclass=\"centertxt\">\n{{vm.nightAudit.restaurant.drinks.cc_processing_tax ? (vm.nightAudit.restaurant.drinks.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.restaurant.drinks.grandTotal ? vm.nightAudit.restaurant.drinks.grandTotal : vm.defaultValue}}</td></tr>\n<tr ng-click=\"vm.showNightAuditDetail(\'restaurant\', \'beer_wine\')\"><td>Beer/Wine</td><td class=\"centertxt\">\n{{vm.nightAudit.restaurant.beer_wine.subTotal ? vm.nightAudit.restaurant.beer_wine.subTotal : vm.defaultValue}}</td><td\n class=\"centertxt\">\n{{vm.nightAudit.restaurant.beer_wine.tourist_development_tax ? vm.nightAudit.restaurant.beer_wine.tourist_development_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.restaurant.beer_wine.sales_tax ? vm.nightAudit.restaurant.beer_wine.sales_tax : vm.defaultValue}}</td>\n<td class=\"centertxt\">\n{{vm.nightAudit.restaurant.beer_wine.cc_processing_tax ? (vm.nightAudit.restaurant.beer_wine.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.restaurant.beer_wine.grandTotal ? vm.nightAudit.restaurant.beer_wine.grandTotal : vm.defaultValue}}\n</td></tr><tr ng-click=\"vm.showNightAuditDetail(\'restaurant\', \'liquor\')\"><td>Liquor</td><td class=\"centertxt\">\n{{vm.nightAudit.restaurant.liquor.subTotal ? vm.nightAudit.restaurant.liquor.subTotal : vm.defaultValue}}</td><td \nclass=\"centertxt\">\n{{vm.nightAudit.restaurant.liquor.tourist_development_tax ? vm.nightAudit.restaurant.liquor.tourist_development_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.restaurant.liquor.sales_tax ? vm.nightAudit.restaurant.liquor.sales_tax : vm.defaultValue}}</td><td \nclass=\"centertxt\">\n{{vm.nightAudit.restaurant.liquor.cc_processing_tax ? (vm.nightAudit.restaurant.liquor.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.restaurant.liquor.grandTotal ? vm.nightAudit.restaurant.liquor.grandTotal : vm.defaultValue}}</td></tr>\n<tr ng-click=\"vm.showNightAuditDetail(\'restaurant\', \'restaurant_non_taxable\')\"><td>Non-Taxable</td><td \nclass=\"centertxt\">\n{{vm.nightAudit.restaurant.restaurant_non_taxable.subTotal ? vm.nightAudit.restaurant.restaurant_non_taxable.subTotal : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.restaurant.restaurant_non_taxable.tourist_development_tax ? vm.nightAudit.restaurant.restaurant_non_taxable.tourist_development_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.restaurant.restaurant_non_taxable.sales_tax ? vm.nightAudit.restaurant.restaurant_non_taxable.sales_tax : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.restaurant.restaurant_non_taxable.cc_processing_tax ? (vm.nightAudit.restaurant.restaurant_non_taxable.cc_processing_tax | currency) : vm.defaultValue}}\n</td><td class=\"centertxt\">\n{{vm.nightAudit.restaurant.restaurant_non_taxable.grandTotal ? vm.nightAudit.restaurant.restaurant_non_taxable.grandTotal : vm.defaultValue}}\n</td></tr><tr><td class=\"total-row\"><b>Total Restaurant</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit.restaurant.restaurantTotal.subTotal}}</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit.restaurant.restaurantTotal.tourist_development_tax}}</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit.restaurant.restaurantTotal.sales_tax}}</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit.restaurant.restaurantTotal.cc_processing_tax}}</b></td><td class=\"centertxt total-row\"><b>\n{{vm.nightAudit.restaurant.restaurantTotal.grandTotal}}</b></td></tr></tbody></table><table cellpadding=\"0\" \ncellspacing=\"0\" class=\"nightAudittableblock\"><tbody><tr><td><b>Grand Total</b></td><td class=\"centertxt\"><b>\n{{vm.nightAudit.grandTotal.subTotal | currency}}</b></td><td class=\"centertxt\"><b>\n{{vm.nightAudit.grandTotal.tourist_development_tax | currency}}</b></td><td class=\"centertxt\"><b>\n{{vm.nightAudit.grandTotal.sales_tax | currency}}</b></td><td class=\"centertxt\"><b>\n{{vm.nightAudit.grandTotal.cc_processing_tax | currency}}</b></td><td class=\"centertxt\"><b>\n{{vm.nightAudit.grandTotal.grandTotal | currency}}</b></td></tr></tbody></table><table cellpadding=\"0\" cellspacing=\"0\" \nclass=\"nightAudittableblock\" ng-if=\"vm.hotelData.hotel_code == \'skipjackresort\'\"><tbody><tr><td>\nAdvance Deposits Collected</td><td class=\"centertxt\">\n{{vm.nightAudit.advanceDepositsCollected ? vm.nightAudit.advanceDepositsCollected : vm.defaultValue}}</td><td \nclass=\"centertxt\">--</td><td class=\"centertxt\">--</td><td class=\"centertxt\">--</td><td class=\"centertxt\">\n{{vm.nightAudit.advanceDepositsCollected ? vm.nightAudit.advanceDepositsCollected : vm.defaultValue}}</td></tr></tbody>\n</table><table cellpadding=\"0\" cellspacing=\"0\" class=\"nightAudittableblock\" \nng-if=\"vm.hotelData.hotel_code == \'skipjackresort\' && vm.nightAudit.advanceDepositsUsed\"><tbody><tr><td>\nAdvance Deposits Used</td><td class=\"centertxt\">\n{{vm.nightAudit.advanceDepositsUsed ? vm.nightAudit.advanceDepositsUsed : vm.defaultValue}}</td><td class=\"centertxt\">\n--</td><td class=\"centertxt\">--</td><td class=\"centertxt\">--</td><td class=\"centertxt\">\n{{vm.nightAudit.advanceDepositsUsed ? vm.nightAudit.advanceDepositsUsed : vm.defaultValue}}</td></tr></tbody></table>\n<table cellpadding=\"0\" cellspacing=\"0\" class=\"nightAudittableblock\"><tbody><tr class=\"sub-headingmain\"><td colspan=\"6\">\n<b>Payments Collected</b></td></tr><tr ng-repeat=\"(key, value) in vm.nightAudit[\'paymentDetails\']\"><td>{{key}}</td><td>\n&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td class=\"centertxt\">{{value | currency}}</td></tr><tr><td \nclass=\"total-row\"><b>Total Collected</b></td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td \nclass=\"total-row centertxt\"><b>{{vm.nightAudit.totalPaymentCollected | currency}}</b></td></tr></tbody></table></td>\n</tr></tbody></table></div></div></div><div class=\"nightAudit-tableblock nightaudittable\" \nng-if=\"vm.showGeneratingFlag\"><div class=\"generate_report_div\"><div class=\"inside-generate-report\"><h1>Please wait \n<span class=\"loader_img\"><img src=\"assets/images/loading_dots.gif\"></span></h1><p>Generating data for all nights</p>\n</div></div></div></div>");
$templateCache.put("app/main/apps/reports/night-audit-short/night-audit-short.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-night\" \nclass=\"mr-10\"></md-icon><span>Night Audit Short</span></div></div></div><div class=\"content\"><style type=\"text/css\">\n.errorMessage {\n            width: 100%;\n            padding: 14px 0px;\n        }\n        .condencedTableText td span.condenced-desc {\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            float: left;\n            max-width:400px;\n        }\n        .Housekeepingtable table{border:1px solid #dedede;margin-bottom:20px;}\n        .Housekeepingtable table .headerrow{background:#f1f1f1;}\n        .Housekeepingtable table.simple tbody tr th {\n            padding: 16px 8px;\n            border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n        }\n        .Housekeepingtable table.simple tbody tr td {\n            padding: 13px 12px;\n        }\n        .Housekeepingtable table.simple tbody tr th:last-child {\n            padding-right: 24px;\n        }\n        .Housekeepingtable table.simple tbody tr th:first-child {\n            padding-left: 24px;\n        }\n        .tabletotalblock tr td:first-child{width:60%;text-align:right;}\n        .tabletotalblock tr td:nth-child(2){width:10%;text-align:center;}\n        .tabletotalblock tr td:nth-child(3){width:20%;text-align:right;}\n        .tabletotalblock tr.totalheading td:first-child{width:100%;text-align:left;background:#f1f1f1;font-size:15px;}\n</style><div class=\"simple-table-container Housekeepingtable incomereport income-report-table nightAuditShorttable\">\n<div class=\"table-title\">Night Audit Short {{ vm.departureDate | date:\'MM/dd/yyyy\'}}</div><div layout=\"row\" flex=\"100\" \nlayout-wrap><div layout=\"column\" flex-gt-xs=\"50\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Date</label>\n<md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.departureDate\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" required></md-datepicker></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"50\" flex=\"100\" class=\"ph-10\" ng-if=\"isParent\"><md-input-container><label>\n{{ vm.selectedHotels.length == 1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"50\" \nng-if=\"vm.showReportFor\" flex=\"100\" class=\"ph-10\"><md-input-container><label>Report For</label><md-select \nng-model=\"vm.reportFor\"><md-option value=\"reservation\" selected=\"selected\">Hotel</md-option><md-option value=\"marina\">\nMarina</md-option></md-select></md-input-container></div></div><div column=\"row\" layout-wrap><div layout=\"column\" \nflex-gt-xs=\"100\" flex=\"100\" class=\"ph-10 pb-20\" layout-align=\"center end\"><div><div class=\"logo\"><md-button \nclass=\"md-raised md-cornered mr-10\" ng-click=\"vm.getReports()\" ng-disabled=\"vm.refreshRequest\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.refreshRequest\"></md-progress-circular>\n</md-button><md-button ng-if=\" vm.nightAudit.length > 0\" class=\"md-raised md-cornered\" \ncsv-header=\"[\'Room\',\'Customer\']\" ng-click=\"downloadFile(vm.csvHeader, vm.all, vm.csvName)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\" vm.nightAudit.length > 0\" class=\"md-raised md-cornered\" csv-header=\"[\'Room\',\'Customer\']\" \nng-click=\"vm.getPrintNightShort(\'pdf\')\" ng-disabled=\"vm.refreshRequestPDF\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>Export as PDF<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.refreshRequestPDF\"></md-progress-circular>\n</md-button><md-button ng-if=\" vm.nightAudit.length > 0\" class=\"md-raised md-cornered mr-10\" ng-click=\"vm.printData()\" \nng-disabled=\"vm.printRequest\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/print.svg\"></md-icon>Print\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.printRequest\">\n</md-progress-circular></md-button></div></div></div></div><div class=\"simple-table-container ph-20\" \nid=\"printSectionId\" style=\"width:100%;display:block;margin-bottom:10px\"><div class=\"ms-responsive-table-wrapper\" \nng-if=\" vm.nightAudit.length > 0\"><style>\ntable.simple tr:nth-child(odd)\n                        {\n                            background: #f9f9f9;\n                        }\n</style><div ng-show=\"vm.print\" style=\"width:100%;display:block;margin-bottom:10px\"><div \nstyle=\"padding:13px 10px;width:auto;float:left\"><img src=\"{{vm.logo}}\" style=\"width:180px\"></div><div \nstyle=\"padding:25px 10px;float:right;vertical-align: middle;font-size:15px\">\nNight Audit {{ vm.departureDate | date:\'MM/dd/yyyy\'}}</div></div><div \nstyle=\"width:100%;float:left;padding-bottom:20px\"><table \nclass=\"simple margin-border table-blockmain col2 mynewnight-auditshort\" id=\"heightTable\" cellpadding=\"0\" \ncellspacing=\"0\" style=\"border:1px solid #dedede;font-family: arial; width:100%\"><thead><tr \nstyle=\"width:100%;background: #f1f1f1\"><th ng-if=\"vm.reportFor == \'all\'\">Room</th><th \nng-if=\"vm.type_of_reservation == \'reservation\'\">Room</th><th ng-if=\"vm.type_of_reservation == \'boat\'\">Boat</th><th>\nCustomer</th></tr></thead><tbody id=\"tbodyHeight\" ng-style=\"vm.tableStyle\" ms-scroll style=\"position:relative\"><tr \nng-repeat=\"(key, nightAudir) in vm.nightAudit\"><td>{{ nightAudir.product_name }}</td><td>{{ nightAudir.customerName }}\n</td></tr></tbody></table></div></div></div><div class=\"simple-table-container ph-20 pb-20 norecordFound\" \nng-show=\"vm.nightAudit.length == 0 && vm.init\"><div class=\"ms-responsive-table-wrapper\">No Data Found</div></div></div>\n</div></div>");
$templateCache.put("app/main/apps/reports/payment-received/payment-received.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-currency-usd\" \nclass=\"mr-10\"></md-icon><span>Payment Received</span></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container Housekeepingtable incomereport income-report-table paymemt-received-table\"><div \nclass=\"table-title\">Payment Received {{ (vm.startDate | date:\'MM/dd/yyyy\')+\' - \'+(vm.endDate | date:\'MM/dd/yyyy\')}}\n</div><div layout=\"row\" flex=\"100\" class=\"ph-10\" layout-wrap><div layout=\"column\" \nflex-gt-xs=\"{{(vm.hotelID == 126 || isParent) ? 25 : 33}}\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Start Date</label>\n<md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.startDate\" ng-change=\"vm.ChangeEndDayIf()\" \nmd-open-on-focus ng-model-options=\"{debounce: 500}\" required></md-datepicker></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"{{(vm.hotelID == 126 || isParent) ? 25 : 33}}\" flex=\"100\" class=\"ph-10\"><md-input-container\n class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">End Date</label>\n<md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.endDate\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" md-min-date=\"vm.startDate\" required></md-datepicker></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"{{(vm.hotelID == 126 || isParent) ? 25 : 33}}\" flex=\"100\" class=\"ph-10\" \nng-if=\"vm.hotelID == 126 || vm.hotelID == 122\"><md-input-container><label>Report For</label><md-select \nng-model=\"vm.reportFor\"><md-optgroup label=\"Report For\"><md-option value=\"all\" selected=\"selected\">All</md-option>\n<md-option value=\"reservation\">Hotel</md-option><md-option value=\"boat\">Marina</md-option><md-option value=\"rent\" \nng-if=\"vm.hotelID == 126\">Residence</md-option></md-optgroup></md-select></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"{{(vm.hotelID == 126 || isParent) ? 25 : 33}}\" flex=\"100\" class=\"ph-10\">\n<md-input-container><label>Channel</label><md-select ng-model=\"vm.selectedChannels\" multiple=\"multiple\"><md-optgroup \nlabel=\"Channels\"><md-option ng-value=\"channel.channel_name\" ng-repeat=\"channel in vm.channels\">\n{{ channel.channel_name }}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\" ng-if=\"isParent\"><md-input-container><label>\n{{ vm.selectedHotels.length == 1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nclass=\"ph-10 pb-20\" layout-wrap><div layout=\"column\" flex-gt-xs=\"100\" flex=\"100\" class=\"ph-10\" \nlayout-align=\"start end\"><div class=\"logo\"><md-button class=\"md-raised md-cornered\" ng-click=\"vm.getIncomeReport()\" \nng-disabled=\"vm.requestProcessing\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\">\n</md-icon>Refresh<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.requestProcessing\"></md-progress-circular></md-button><md-button ng-if=\"vm.allData.length > 0\" \nclass=\"md-raised md-cornered\" \nng-click=\"downloadFile(vm.csvHeader,vm.allData,vm.csvName,vm.printInCsv,vm.doNotPrintInCsv)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\"vm.allData.length > 0\" class=\"md-raised md-cornered\" ng-click=\"vm.getPrintPaymentReceived(\'pdf\')\" \nng-disabled=\"vm.requestPDF\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>\nExport as PDF<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.requestPDF\"></md-progress-circular></md-button><md-button ng-if=\"vm.allData.length > 0\" \nclass=\"md-raised md-cornered\" ng-click=\"vm.printRecords()\" ng-disabled=\"vm.requestProcessingEmail\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_email_24px.svg\"></md-icon>Email Report<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessingEmail\">\n</md-progress-circular></md-button></div></div></div><div class=\"simple-table-container mt-20\" id=\"printSectionId\" \nng-show=\"!vm.noResultFound\"><div class=\"ms-responsive-table-wrapper ph-20 pb-20\" \nng-repeat=\"(pKey,allMode) in vm.paymentReceived\"><div ng-init=\"count = $index;\" style=\"width:100%;dont-size:20px\">\n{{pKey}}</div><table class=\"simple margin-border paymentreceived\" id=\"heightTable{{pKey | split: \' \':0}}\"><thead><tr \nclass=\"headerrow\"><th>Date</th><th>Confirmation Number</th><th>Hotel</th><th>Employee</th><th>Customer</th><th>Source\n</th><th>Reservation Status</th><th>Transaction Id</th><th>Payment Details</th><th>Payment Status</th><th>Amount</th>\n</tr></thead><tbody id=\"tbodyHeight{{pKey | split: \' \':0}}\" ng-style=\"vm.tableStyle\" ms-scroll \nstyle=\"position:relative\"><tr ng-repeat=\"(cKey, rowData) in allMode\" \nng-init=\"vm.calculateTotal(rowData.paidToday,pKey, count,rowData.installment_status)\" class=\"\"><td>\n{{rowData.installment_paid_date}}</td><td class=\"cursorPointer\" \nng-click=\"goToState(\'\', rowData.confirmation_number, \'\')\">{{rowData.confirmation_number}}</td><td>\n{{rowData.hotel_title}}</td><td>{{rowData.Employee}}</td><td>{{rowData.Customer}}</td><td>\n{{rowData.source_of_creation}}</td><td>{{rowData.room_stay_status}}</td><td>{{rowData.txn_id}}</td><td>\n{{rowData.payment_details}}</td><td>{{rowData.installment_status}}</td><td \nng-class=\"rowData.installment_status == \'refunded\'?\'refunded\':\'\'\">{{ rowData.paidToday | currency : $ : 2 }}</td></tr>\n<tr class=\"total\"><td colspan=\"10\">Sub Total</td><td colspan=\"1\">{{ vm.overAll[pKey][\'subTotal\'] | currency : $ : 2 }}\n</td></tr></tbody><tr class=\"total\" ng-if=\"count == vm.len\"><td>Total</td><td></td><td></td><td></td><td></td><td></td>\n<td></td><td></td><td></td><td></td><td>{{vm.grandTotal | currency : $ : 2}}</td></tr></table></div></div><div \nclass=\"simple-table-container mt-20\"><div class=\"ms-responsive-table-wrapper ph-20 pb-20 norecordFound\" \nng-show=\"vm.noResultFound\">No Result Found</div></div></div></div></div>");
$templateCache.put("app/main/apps/reports/payments-by-employee/payments-by-employee.html","<div id=\"payments-by-employee\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-currency-usd\" \nclass=\"mr-10\"></md-icon><span>Payments by Employee</span></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container Housekeepingtable incomereport incomereport income-report-table paymentsbyemployee\"><div \nclass=\"table-title\">Payments by Employee {{ (vm.startDate | date:\'MM/dd/yyyy\')+\' - \'+(vm.endDate | date:\'MM/dd/yyyy\')}}\n</div><div layout=\"row\" flex=\"100\" class=\"ph-10 pb-20\" layout-wrap><div layout=\"column\" \nflex-gt-xs=\"{{ vm.hotelID == 126 || isParent? 25:33 }}\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Start Date</label>\n<md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.startDate\" ng-change=\"vm.ChangeEndDayIf()\" \nmd-open-on-focus ng-model-options=\"{debounce: 500}\" required></md-datepicker></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"{{vm.hotelID == 126 || isParent? 25:33 }}\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">End Date</label>\n<md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.endDate\" md-min-date=\"vm.startDate\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" required></md-datepicker></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{ vm.hotelID == 126? 25:33 }}\" flex=\"100\" class=\"ph-10\" ng-if=\"vm.hotelID == 126\"><md-input-container>\n<label>Report For</label><md-select ng-model=\"vm.reportFor\"><md-optgroup label=\"Report For\"><md-option \nvalue=\"reservation\" selected=\"selected\">Hotel</md-option><md-option value=\"boat\">Marina</md-option><md-option \nvalue=\"rent\">Residence</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{ isParent || vm.hotelID == 126? 25:33 }}\" flex=\"100\" class=\"ph-10\"><md-input-container><label>Channel\n</label><md-select ng-model=\"vm.selectedChannels\" multiple=\"multiple\"><md-optgroup label=\"Channels\"><md-option \nng-value=\"channel.channel_name\" ng-repeat=\"channel in vm.channels\">{{ channel.channel_name }}</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\" ng-if=\"isParent\">\n<md-input-container><label>{{ vm.selectedHotels.length == 1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label>\n<md-select ng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" \nng-repeat=\"hotel in subHotels\">{{hotel.hotel_title}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\" ng-if=\"vm.hotelID == 122\" style=\"margin-left: 20px\">\n<md-input-container><label>Report For</label><md-select ng-model=\"vm.reportFor\"><md-optgroup label=\"Report For\">\n<md-option value=\"reservation\" selected=\"selected\">Hotel</md-option><md-option value=\"boat\">Marina</md-option>\n</md-optgroup></md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"100\" flex=\"100\" class=\"ph-10\" \nlayout-align=\"start end\"><div class=\"logo\"><md-button class=\"md-raised md-cornered\" ng-click=\"vm.getEmployeeReports()\" \nng-disabled=\"vm.requestProcessing\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\">\n</md-icon>Refresh<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.requestProcessing\"></md-progress-circular></md-button><md-button ng-if=\"vm.csvData.length > 0\" \nclass=\"md-raised md-cornered\" ng-click=\"downloadFile(vm.csvHeader,vm.csvData,vm.csvName)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\"vm.csvData.length > 0\" class=\"md-raised md-cornered\" ng-click=\"vm.getPrintEmployeeReport(\'pdf\')\" \nng-disabled=\"vm.requestProcessingPDF\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\">\n</md-icon>Export as PDF<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.requestProcessingPDF\"></md-progress-circular></md-button><md-button ng-if=\"vm.csvData.length > 0\" \nclass=\"md-raised md-cornered\" ng-click=\"vm.emailRecords()\" ng-disabled=\"vm.requestProcessingEmail\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_email_24px.svg\"></md-icon>Email Report<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessingEmail\">\n</md-progress-circular></md-button></div></div></div><div class=\"simple-table-container mt-20\" id=\"table-container\" \nng-if=\"vm.employeeDatakeys.length > 0\"><div class=\"ms-responsive-table-wrapper ph-20 pb-0\" \nng-repeat=\"(parentKey, empData) in vm.employeeDatakeys\" id=\"table-height\"><h1>\n{{empData}} : {{(vm.overAll[parentKey][childKey] | currency : \"$\" : 2)}}</h1><table class=\"simple margin-border\"><tbody\n style=\"display:table-row-group !important\"><tr ng-repeat=\"(modekey, amount) in vm.amountCollected[empData]\"><td \nstyle=\"width:20% !important\"><strong>{{modekey}}</strong></td><td style=\"width:80% !important\"><strong>\n{{amount | currency : \"$\" : 2}}</strong></td></tr></tbody></table><div id=\"abc\"><table class=\"simple margin-border\" \ncellpadding=\"0\" cellspacing=\"0\" style=\"position:relative\"><thead><tr class=\"headerrow\"><td>Date</td><td>Payment Type\n</td><td>Confirmation</td><td>Employee</td><td>Customer</td><td>Source</td><td>Amount</td></tr></thead><tbody \nng-style=\"vm.tableStyle\" ms-scroll style=\"position:relative\" class=\"tbodyHeight{{empData | split:\' \':0}}\"><tr \nng-repeat=\"(cardKey, cardDetails) in vm.EmployeeData[empData]\" \nng-init=\"vm.calculateTotal(cardDetails.original_paid_amount,parentKey, childKey)\"><td>{{cardDetails.paidDate}}</td><td>\n{{cardDetails.type}}</td><td class=\"cursorPointer\" ng-click=\"goToState(\'\', cardDetails.confirmation_number, \'\')\">\n{{cardDetails.confirmation_number}}</td><td>{{cardDetails.employee}}</td><td>{{cardDetails.customer}}</td><td>\n{{cardDetails.source_of_creation}}</td><td ng-class=\"cardDetails.original_paid_amount < 0? \'refunded\':\'\'\">\n{{cardDetails.original_paid_amount | currency : \"$\" : 2}}</td></tr><tr class=\"total\"><td colspan=\"6\" \nstyle=\"font-weight: bold !important\">Total</td><td>{{ (vm.overAll[parentKey][childKey] | currency : \"$\" : 2) }}</td>\n</tr></tbody></table></div></div></div><div class=\"simple-table-container mt-20\" \nng-if=\"vm.employeeDatakeys.length == 0\"><div class=\"ms-responsive-table-wrapper ph-20 pb-20 norecordFound\" \nng-if=\"vm.noResultFound\">No Result Found.</div></div></div></div></div>");
$templateCache.put("app/main/apps/reports/promo-reports/promo-reports.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-chart-line\" \nclass=\"mr-10\"></md-icon><span>Promo Reports</span></div></div></div><div class=\"content loadingstatistic\"><div \nclass=\"simple-table-container\"><div class=\"table-title\">\nPromo Reports {{ (vm.fromdate | date:\'MM/dd/yyyy\')+\' - \'+(vm.todate | date:\'MM/dd/yyyy\')}}</div><div layout=\"row\" \nflex=\"100\" layout-wrap><div layout=\"column\" flex-gt-xs=\"33\" flex=\"100\" \nclass=\"pl-24 pr-24 layout-column flex-gt-xs-33 flex-100\"><md-input-container class=\"md-block full-width mb-0\"><label>\n{{ vm.selectedPromotions.length > 0 ? \'Promotion\' : \'Select Promotion\' }}</label><md-select \nng-model=\"vm.selectedPromotions\" multiple=\"multiple\"><md-option ng-value=\"promo.promotion_id\" \nng-repeat=\"promo in vm.promotions\">{{ promo.promotion_name }} ({{promo.promotion_code}})</md-option></md-select>\n</md-input-container></div><div layout=\"column\" flex-gt-xs=\"33\" flex=\"100\" \nclass=\"pl-24 pr-24 layout-column flex-gt-xs-33 flex-100\"><md-input-container class=\"md-block full-width mb-0\"><label \ntranslate=\"REPORT.BOOKING_CREATED_FROM\"></label><md-datepicker md-open-on-focus ng-model=\"vm.fromdate\" \nclass=\"full-width mdinput-block\" ng-change=\"vm.ChangeEndDayIf()\"></md-datepicker><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div layout=\"column\" flex-gt-xs=\"33\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block full-width mb-0\"><label translate=\"REPORT.BOOKING_CREATED_TO\"></label><md-datepicker md-open-on-focus \nng-model=\"vm.todate\" md-min-date=\"vm.fromdate\" class=\"full-width mdinput-block\"></md-datepicker><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></div><div layout=\"row\" flex=\"100\"><div layout=\"column\" \nflex-gt-xs=\"100\" flex=\"100\" class=\"ph-10 pb-20\" layout-align=\"center end\"><div><div class=\"logo\"><md-button \nclass=\"md-raised md-cornered\" ng-click=\"vm.getrecords();\" ng-disabled=\"vm.requestProcessing\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\" ng-click=\"getrecords();\"></md-icon>Refresh\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessing\">\n</md-progress-circular></md-button><md-button ng-if=\"vm.csvData.length > 0\" class=\"md-raised md-cornered\" \nng-click=\"downloadFile(vm.csvHeader, vm.csvData, vm.csvName)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\"vm.csvData.length > 0\" class=\"md-raised md-cornered\" ng-click=\"vm.getrecords(\'pdf\');\" \nng-disabled=\"vm.requestProcessingPDF\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\">\n</md-icon>Export as PDF<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.requestProcessingPDF\"></md-progress-circular></md-button><md-button ng-if=\"vm.csvData.length > 0\" \nclass=\"md-raised md-cornered\" ng-click=\"vm.printRecords()\" ng-disabled=\"vm.requestProcessingEmail\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_email_24px.svg\"></md-icon>Email Report<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessingEmail\">\n</md-progress-circular></md-button></div></div></div></div><div \nclass=\"Housekeepingtable incomereport income-report-table lodgingstatstable mt-20 ph-20 pb-20\" id=\"printSectionId\" \nng-if=\"vm.csvData.length > 0\"><md-table-container><table md-table multiple=\"multiple\" ng-model=\"selected\" \nid=\"heightTable\" class=\"simple col30\"><thead md-head md-order=\"query.order\" md-on-reorder=\"getrecords\"><tr md-row \nclass=\"headerrow capitalize headingoutertb\"><th ng-repeat=\"heading in vm.report.heading\">{{heading}}</th></tr></thead>\n<tbody md-body id=\"tbodyHeight\" ng-style=\"vm.tableStyle\" ms-scroll style=\"position:relative\"><tr \nng-repeat=\"(myKey, report) in vm.report.data\" \nng-class=\"{\'total\': myKey === \'granttotal\' || report.customer_name === \'Total\'}\"><td class=\"cursorPointer\" \nng-click=\"report.confirmation_number && goToState(\'\', report.confirmation_number, \'\')\">\n{{report.customer_name ? report.customer_name : \'-\'}}</td><td class=\"cursorPointer\" \nng-click=\"report.confirmation_number && goToState(\'\', report.confirmation_number, \'\')\">\n{{report.confirmation_number ? report.confirmation_number : \'-\'}}</td><td class=\"cursorPointer\" \nng-click=\"vm.goToPromotionDetails(report.promotion_id)\">{{report.promotion_code ? report.promotion_code : \'-\'}}</td><td\n class=\"cursorPointer\" ng-click=\"report.confirmation_number && goToState(\'\', report.confirmation_number, \'\')\">\n{{report.product_name ? report.product_name : \'-\'}}</td><td class=\"cursorPointer\" \nng-click=\"report.confirmation_number && goToState(\'\', report.confirmation_number, \'\')\">\n{{report.room_stay_from ? report.room_stay_from : \'-\'}}</td><td class=\"cursorPointer\" \nng-click=\"report.confirmation_number && goToState(\'\', report.confirmation_number, \'\')\">\n{{report.room_stay_to ? report.room_stay_to : \'-\'}}</td><td class=\"cursorPointer\" \nng-click=\"report.confirmation_number && goToState(\'\', report.confirmation_number, \'\')\">\n{{ report.total_amount ? (report.total_amount | currency : \"$\" : 2) : \'-\' }}</td><td class=\"cursorPointer\" \nng-click=\"report.confirmation_number && goToState(\'\', report.confirmation_number, \'\')\">\n{{report.reservation_created_date ? report.reservation_created_date : \'-\'}}</td><td class=\"cursorPointer\" \nng-click=\"report.confirmation_number && goToState(\'\', report.confirmation_number, \'\')\">\n{{report.source_of_creation ? report.source_of_creation : \'-\'}}</td></tr></tbody></table></md-table-container></div>\n<div class=\"simple-table-container ph-20 pb-20 norecordFound\" ng-if=\"vm.report.data.length == 0 && vm.init\"><div \nclass=\"ms-responsive-table-wrapper\">No Records Found.</div></div></div></div></div>");
$templateCache.put("app/main/apps/reports/reconcillation/reconcillation.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-briefcase-checked\" \nclass=\"mr-10\"></md-icon><span>Reconciliation Report</span></div></div></div><div class=\"content\"><div \nclass=\"Night-audit-table salesByemp\"><div class=\"Night-audit-heading\">Reconciliation Report</div><div \nclass=\"searching_input-blocksmain\"><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" \nflex-gt-xs=\"{{ isParent ? 25:50 }}\" flex=\"100\" class=\"ph-10\"><md-input-container class=\"md-block md-datepicker mb-0\" \ndata-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">From Date</label><md-datepicker \nclass=\"birthday-input1 no-padding\" ng-model=\"vm.fromDate\" md-open-on-focus ng-model-options=\"{debounce: 500}\" \nng-change=\"vm.checkSchedule(\'from\')\" required></md-datepicker></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{ isParent ? 25:50 }}\" flex=\"100\" class=\"ph-10\"><md-input-container class=\"md-block md-datepicker mb-0\" \ndata-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">To Date</label><md-datepicker \nclass=\"birthday-input1 no-padding\" ng-model=\"vm.toDate\" md-open-on-focus ng-model-options=\"{debounce: 500}\" \nng-change=\"vm.checkSchedule(\'to\')\" md-min-date=\"vm.minDate\" required></md-datepicker></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"50\" flex=\"100\" class=\"ph-10\" ng-if=\"isParent\"><md-input-container><label>\n{{ vm.selectedHotels.length == 1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-wrap>\n<div layout=\"column\" flex-gt-xs=\"100\" flex=\"100\" layout-align=\"center end\"><div class=\"btnsrefreshblock\"><md-button \nclass=\"md-raised md-cornered mr-10\" ng-click=\"vm.refreshConcillation()\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.showGeneratingFlag\"></md-progress-circular>\n</md-button><md-button class=\"md-raised md-cornered mr-10\" ng-if=\"vm.channelKeys.length > 0\" \nng-click=\"vm.exportFile(\'csv\')\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>\nExport to CSV<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.csvLoader\">\n</md-progress-circular></md-button><md-button class=\"md-raised md-cornered mr-10\" ng-if=\"vm.channelKeys.length > 0\" \nng-click=\"vm.exportFile(\'pdf\')\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>\nExport to PDF<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.exportLoader\"></md-progress-circular></md-button></div></div></div></div><div \nclass=\"simple-table-container mt-20\" id=\"table-container\" ng-if=\"vm.channelKeys.length > 0 && !vm.showGeneratingFlag\">\n<div class=\"ph-20 pb-0\" ng-repeat=\"(parentKey, channel) in vm.channelKeys\" id=\"table-height\"><h1 class=\"mt-40\" \nng-init=\"vm.totalCommission(vm.reconcillationData[channel],channel)\">{{channel}}</h1><div class=\"commision_divs\"><div \nclass=\"wrapper_commision\"><div class=\"commision_inner\" ng-if=\"channel == \'Expedia\'\"><p class=\"total_commission\">\nTotal Commission : ${{vm.channelWise[channel]}}</p><p class=\"total_commission\">\nHotel Collect: {{vm.otachargesPercentage[\'expedia_hotel\']}}%</p><p class=\"total_commission\">\nChannel Collect: {{vm.otachargesPercentage[\'expedia_channel\']}}%</p></div><div class=\"commision_inner\" \nng-if=\"channel == \'Booking.com\'\"><p class=\"total_commission\">Total Commission : ${{vm.channelWise[channel]}}</p><p \nclass=\"total_commission\">Hotel Collect: {{vm.otachargesPercentage[\'booking_hotel\']}}%</p><p class=\"total_commission\">\nChannel Collect: {{vm.otachargesPercentage[\'booking_channel\']}}%</p></div><div class=\"commision_inner\" \nng-if=\"channel == \'Airbnb\'\"><p class=\"total_commission\">Total Commission : ${{vm.channelWise[channel]}}</p><p \nclass=\"total_commission\">Commission Percentage: {{vm.otachargesPercentage[channel]}}%</p><p class=\"total_commission\">\nService Fee Percentage: {{vm.serviceFee}}%</p></div><div class=\"commision_inner\" \nng-if=\"channel != \'Airbnb\' && channel != \'Expedia\' && channel != \'Booking.com\'\"><p class=\"total_commission\">\nTotal Commission : ${{vm.channelWise[channel]}}</p><p class=\"total_commission\">\nCommission Percentage: {{vm.otachargesPercentage[channel]}}%</p></div></div></div><div id=\"abc\" \nclass=\"ms-responsive-table-wrapper\"><table class=\"simple margin-border\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"position:relative\" ng-class=\"heightTable{{channel | split: \' \':0}}\"><thead><tr class=\"headerrow\"><td>Itinerary\n</td><td>Confirmation</td><td>Siteminder ID</td><td>Collect Which</td><td>From</td><td>To</td><td class=\"elipse_night\">\nNights</td><td>Subtotal</td><td>Sales Tax</td><td>Tourist Development Tax</td><td>CC Processing Fee</td><td>Grand Total\n</td><td>Commission</td><td ng-if=\"channel == \'Airbnb\'\">Service Fee</td><td>Rate Plan</td><td>Created</td><td>Status\n</td><td>Customer</td><td>Email</td></tr></thead><tbody ng-style=\"vm.tableStyle\" ms-scroll style=\"position:relative\" \nclass=\"tbodyHeight{{channel | split:\' \':0}} heightblockstatic\"><tr class=\"cursor_pointer\" \nng-repeat=\"(resKey, reservation) in vm.reconcillationData[channel]\" \nng-if=\"$index <= (vm.reconcillationData[channel].length - 2)\"><td class=\"elipse\" \nng-click=\"goToState(\'\', reservation.confirmation_number, \'\')\">{{reservation.itinerary_number}}</td><td class=\"elipse\" \nng-click=\"goToState(\'\', reservation.confirmation_number, \'\')\">{{reservation.confirmation_number}}</td><td \nclass=\"elipse\" ng-click=\"goToState(\'\', reservation.confirmation_number, \'\')\">{{reservation.siteminder_id}}</td><td \nclass=\"elipse\" ng-click=\"goToState(\'\', reservation.confirmation_number, \'\')\">\n{{reservation.collect_which == \'channel_collect\' ? \'Channel Collect\' : \'Hotel Collect\'}}</td><td class=\"elipse\">\n{{reservation.room_stay_from}}</td><td class=\"elipse\">{{reservation.room_stay_to}}</td><td class=\"elipse elipse_night\">\n{{reservation.number_of_nights}}</td><td>${{reservation.subtotal}}</td><td>${{reservation.sales_tax}}</td><td>\n${{reservation.tourist_development_tax}}</td><td>\n${{reservation.cc_processing_fee ? reservation.cc_processing_fee : 0.00}}</td><td>${{reservation.grand_total}}</td><td \nclass=\"elipse\">${{reservation.commision_charges ? reservation.commision_charges : 0.00}}</td><td class=\"elipse\" \nng-if=\"channel == \'Airbnb\'\">${{reservation.ota_service_fee_amount ? reservation.ota_service_fee_amount : 0.00}}</td><td\n class=\"elipse\">{{reservation.rate_plan}}</td><td class=\"elipse\">{{reservation.created_date}}</td><td class=\"elipse\">\n{{reservation.room_stay_status}}</td><td class=\"elipse\">{{reservation.customer_name}}</td><td class=\"elipse\">\n<md-tooltip md-direction=\"left\">{{reservation.customer_email}}</md-tooltip>{{reservation.customer_email}}</td></tr><tr \nclass=\"cursor_pointer\" ng-repeat=\"(resKey, reservation) in vm.reconcillationData[channel]\" \nng-if=\"$index == (vm.reconcillationData[channel].length - 1)\"><td class=\"elipse text_bold\">\n{{reservation.itinerary_number}}</td><td class=\"elipse text_bold\">{{reservation.confirmation_number}}</td><td \nclass=\"elipse text_bold\">{{reservation.siteminder_id}}</td><td class=\"elipse text_bold\">{{reservation.collect_which}}\n</td><td class=\"elipse text_bold\">{{reservation.room_stay_from}}</td><td class=\"elipse text_bold\">\n{{reservation.room_stay_to}}</td><td class=\"elipse text_bold elipse_night\">{{reservation.number_of_nights}}</td><td \nclass=\"elipse text_bold\">${{reservation.subtotal}}</td><td class=\"elipse text_bold\">${{reservation.sales_tax}}</td><td \nclass=\"elipse text_bold\">${{reservation.tourist_development_tax}}</td><td class=\"elipse text_bold\">\n${{reservation.cc_processing_fee ? reservation.cc_processing_fee : 0.00}}</td><td class=\"elipse text_bold\">\n${{reservation.grand_total}}</td><td class=\"elipse text_bold\">${{reservation.commision_charges}}</td><td \nclass=\"elipse text_bold\" ng-if=\"channel == \'Airbnb\'\">${{reservation.ota_service_fee_amount}}</td><td \nclass=\"elipse text_bold\">{{reservation.rate_plan}}</td><td class=\"elipse text_bold\">{{reservation.created_date}}</td>\n<td class=\"elipse text_bold\">{{reservation.room_stay_status}}</td><td class=\"elipse text_bold\">\n{{reservation.customer_name}}</td><td class=\"elipse text_bold\">{{reservation.customer_email}}</td></tr></tbody></table>\n</div></div></div><div class=\"simple-table-container mt-20\" \nng-if=\"vm.channelKeys.length == 0  && !vm.showGeneratingFlag\"><div class=\"ms-responsive-table-wrapper ph-20 pb-20\">\nNo Result Found.</div></div></div></div><div class=\"nightAudit-tableblock nightaudittable\" \nng-if=\"vm.showGeneratingFlag\"><div class=\"generate_report_div\"><div class=\"inside-generate-report\"><h1>Please wait \n<span class=\"loader_img\"><img src=\"assets/images/loading_dots.gif\"></span></h1><p>Generating data for all nights</p>\n</div></div></div></div>");
$templateCache.put("app/main/apps/reports/reservation-due-report/reservation-due-report.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" onscroll=\"vm.onScroll()\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-currency-usd\" \nclass=\"mr-10\"></md-icon><span>Pending Due Report.</span></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container Housekeepingtable incomereport income-report-table\"><div class=\"table-title\">\nPending Due Report.</div><div layout=\"row\" flex=\"100\" class=\"ph-10\" layout-wrap><div layout=\"column\" flex-gt-xs=\"25\" \nflex=\"100\" class=\"ph-10\"><md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label \nclass=\"ng-scope\" role=\"button\">Check-In</label><md-datepicker class=\"birthday-input1 no-padding\" \nng-model=\"vm.checkInDate\" md-open-on-focus ng-model-options=\"{debounce: 300}\" ng-change=\"vm.changeCheckDates()\">\n</md-datepicker></md-input-container></div><div layout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\">\n<md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">\nCheck-Out</label><md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.checkOutDate\" \nmd-min-date=\"vm.checkInDate\" md-open-on-focus ng-model-options=\"{debounce: 300}\" ng-change=\"vm.changeCheckDates()\">\n</md-datepicker></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{ (isParent || vm.showReportFor) ? 25:33 }}\" flex=\"100\" class=\"ph-20\"><md-input-container><label>Channel\n</label><md-select ng-model=\"vm.selectedChannels\" multiple=\"multiple\"><md-optgroup label=\"Channels\"><md-option \nng-value=\"channel.channel_name\" ng-repeat=\"channel in vm.channels\">{{ channel.channel_name }}</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"{{ (isParent || vm.showReportFor) ? 25:33 }}\" \nflex=\"100\" class=\"ph-10\" ng-if=\"isParent\"><md-input-container><label>\n{{ vm.selectedHotels.length ==1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nclass=\"ph-10\" layout-wrap></div><div layout=\"row\" flex=\"100\" class=\"ph-10\" layout-wrap><div layout=\"column\" \nflex-gt-xs=\"100\" flex=\"100\" class=\"ph-10\" layout-align=\"start end\"><div class=\"logo\"><md-button \nclass=\"md-raised md-cornered\" ng-click=\"vm.getIncomeReport()\" ng-disabled=\"vm.requestProcessing || vm.disableRefresh\">\n<md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessing\">\n</md-progress-circular></md-button><md-button ng-if=\"vm.allData.length > 0\" class=\"md-raised md-cornered\" \nng-click=\"vm.downloadFileCustom(vm.reportType)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\"vm.allData.length > 0\" class=\"md-raised md-cornered\" ng-click=\"vm.downloadFileCustom(vm.reportType,\'pdf\')\">\n<md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>Export as PDF</md-button><md-button \nng-if=\"vm.allData.length > 0\" class=\"md-raised md-cornered\" ng-click=\"vm.printRecords()\" \nng-disabled=\"vm.requestProcessingEmail\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_email_24px.svg\"></md-icon>Email Report<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessingEmail\">\n</md-progress-circular></md-button></div></div></div><div id=\"table-container\" class=\"simple-table-container mt-20\" \nng-show=\"!vm.noResultFound\"><div class=\"ms-responsive-table-wrapper ph-20\" ng-init=\"rowCount = 1\"><table \nid=\"heightTable\" class=\"simple margin-border\" ng-show=\"vm.allData.length  > 0\" \nng-repeat=\"(parentKey, dateData) in vm.incomeData\" style=\"position:relative\" ms-responsive-table=\"\"><thead><th \ncolspan=\"24\" ng-if=\"isParent\">{{parentKey}}</th><tr class=\"headerrow\"><td>Itinerary</td><td>Confirmation</td><td \nng-if=\"vm.reportType==\'detailed\' && false\">Date</td><td>Status</td><td>Checkin</td><td>Checkout</td><td>Customer</td>\n<td>Quantity</td><td>Item</td><td>Number of Nights</td><td>Business Entity</td><td>Source</td><td>Employee</td><td>\nSub Total</td><td>Discount</td><td>Lodging Tax (%)</td><td>Lodging Tax ($)</td><td>Resort Fee (%)</td><td>\nResort Fee ($)</td><td>Resort Fee Tax(%)</td><td>Resort Fee Tax($)</td><td>Sales Tax (%)</td><td>Sales Tax ($)</td><td>\nTotal</td><td>Paid</td><td>Remaining</td><td>Reservation Total</td><td>Payment Method(s)</td><td>\nPaid Within Report Range</td></tr></thead><tbody id=\"tbodyHeight\" ng-style=\"vm.tableStyle\" ms-scroll \nstyle=\"position:relative\"><tr ng-repeat=\"(date, income) in dateData\"><td class=\"cursorPointer\" \nng-init=\"vm.calculateTotal(income, parentKey)\" \nng-click=\"goToState(income.itinerary_number, income.confirmation_number, \'\')\">{{income.itinerary_number}}</td><td \nclass=\"cursorPointer\" ng-click=\"goToState(income.itinerary_number, income.confirmation_number, \'\')\">\n{{income.confirmation_number}}</td><td ng-if=\"vm.reportType==\'detailed\' && false\">{{income.installment_paid_date}}</td>\n<td>{{income.room_stay_status}}</td><td>{{income.room_stay_from}}</td><td>{{income.room_stay_to}}</td><td>\n{{income.Customer}}</td><td>{{income.quantity}}</td><td>{{income.product_name}}</td><td>{{income.NoOfNights}}</td><td>\n{{income.hotel_title}}</td><td>{{income.source_of_creation}}</td><td>{{income.Employee}}</td><td>\n{{income.subtotal | currency : $ : 2}}</td><td>{{income.product_discount | currency : $ : 2}}</td><td>\n{{ income[\'lodging tax percentage\']}}</td><td>{{ income[\'lodging tax amount\']}}</td><td>\n{{ income[\'resort fee percentage\']}}</td><td>{{ income[\'resort fee amount\']}}</td><td>\n{{ income[\'resort fee tax percentage\']}}</td><td>{{ income[\'resort fee tax amount\']}}</td><td>\n{{ income[\'sales tax percentage\']}}</td><td>{{ income[\'sales tax amount\']}}</td><td>\n{{income.grand_total | currency : $ : 2}}</td><td>{{income.total_paid_amount | currency : $ : 2}}</td><td>\n{{income.total_remaining_amount | currency : $ : 2}}</td><td>{{income.totalPaid | currency : $ : 2}}</td><td>\n{{ income.payment_method}}</td><td>{{ income.paidToday | currency : $ : 2}}</td></tr><tr class=\"total\"><td></td><td>\n</td><td ng-if=\"vm.reportType==\'detailed\'\"></td><td></td><td></td><td></td><td></td><td>\n{{vm.overAll[parentKey][\'quantity\']}}</td><td></td><td>{{vm.overAll[parentKey][\'NoOfNights\']}}</td><td></td><td></td>\n<td></td><td>{{vm.overAll[parentKey][\'subtotal\'] | currency : $ : 2}}</td><td>\n{{income.product_discount | currency : $ : 2}}</td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>\n</td><td>{{vm.overAll[parentKey][\'grand_total\'] | currency : $ : 2}}</td><td>\n{{vm.overAll[parentKey][\'total_paid_amount\'] | currency : $ : 2}}</td><td>\n{{vm.overAll[parentKey][\'total_remaining_amount\'] | currency : $ : 2}}</td><td>\n{{vm.overAll[parentKey][\'totalPaid\'] | currency : $ : 2}}</td><td></td><td>\n{{vm.overAll[parentKey][\'paidToday\'] | currency : $ : 2}}</td></tr></tbody></table></div></div><div \nclass=\"simple-table-container mt-20\"><div class=\"ms-responsive-table-wrapper ph-20 pb-20 norecordFound\" \nng-show=\"vm.noResultFound\">No Result Found</div></div></div></div></div>");
$templateCache.put("app/main/apps/reports/retail-report/retail-report.html","<style>\ntr.total td, tr.totalheading td, tr.total-row td, td.text_bold, tr.pricingrowTd td {\n  font-weight: bold !important;\n}\n</style><div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-basket\" class=\"mr-10\">\n</md-icon><span>POS Report</span></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container Housekeepingtable incomereport pos-report-table\"><div class=\"table-title\">\nPOS Report {{ (vm.startDate | date:\'MM/dd/yyyy\')+\' - \'+(vm.endDate | date:\'MM/dd/yyyy\')}}</div><div layout=\"row\" \nflex=\"100\" class=\"ph-10\" layout-wrap><div layout=\"column\" flex-gt-xs=\"{{ isParent? 25:33 }}\" flex=\"100\" class=\"ph-10\">\n<md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">\nStart Date</label><md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.startDate\" \nng-change=\"vm.ChangeEndDayIf()\" md-open-on-focus ng-model-options=\"{debounce: 300}\" required></md-datepicker>\n</md-input-container></div><div layout=\"column\" flex-gt-xs=\"{{ isParent? 25:33 }}\" flex=\"100\" class=\"ph-10\">\n<md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">\nEnd Date</label><md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.endDate\" md-min-date=\"vm.startDate\" \nmd-open-on-focus ng-model-options=\"{debounce: 300}\" required></md-datepicker></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"{{ isParent? 25:33 }}\" flex=\"100\" class=\"ph-10\"><md-input-container class=\"md-block mb-0\">\n<button class=\"md-datepicker-button md-icon-button md-button md-default-theme md-ink-ripple\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_retail_type.svg\"></md-icon></button><div \nclass=\"maininputouter\"><label class=\"ng-scope\" role=\"button\">Retail Type</label><md-select ng-model=\"vm.retailType\" \nng-change=\"vm.onRetailTypeChange()\" placeholder=\"Retail type\" class=\"birthday-input1 no-padding mt-0\"><md-option \nvalue=\"all\">All</md-option><md-option value=\"reservation\">Room POS</md-option><md-option value=\"boat\" \nng-if=\"vm.showSkipjackRetailTypes\">Boat POS</md-option><md-option value=\"service\">Retail POS</md-option><md-option \nvalue=\"restaurant\" ng-if=\"vm.showSkipjackRetailTypes\">Restaurant POS</md-option><md-option value=\"bar\">Bar POS\n</md-option></md-select></div></md-input-container></div><div layout=\"column\" flex-gt-xs=\"{{ isParent? 25:33 }}\" \nflex=\"100\" class=\"ph-10\" ng-if=\"vm.hasPosOptionsFilter()\"><md-input-container class=\"md-block mb-0\"><label>POS Options\n</label><md-select ng-model=\"vm.selectedRoomPos\" multiple=\"multiple\" ng-disabled=\"vm.loadingRoomPosOptions\" \nng-change=\"vm.onPosOptionsSelectionChange()\" md-on-close=\"vm.clearRoomPosSearch()\" \ndata-md-container-class=\"room-pos-select-header\"><md-select-header class=\"demo-select-header\"><div \nclass=\"pos-options-search-chips-box\" ng-click=\"$event.stopPropagation()\"><div class=\"pos-options-chips-list\" \nng-if=\"vm.selectedRoomPos.length\"><span class=\"pos-option-chip\" ng-repeat=\"value in vm.selectedRoomPos track by value\">\n<span class=\"pos-option-chip-label\">{{ vm.getPosOptionLabel(value) }}</span> <button type=\"button\" \nclass=\"pos-option-chip-remove\" ng-click=\"vm.removePosOption($event, value)\" aria-label=\"Remove\">×</button></span></div>\n<input ng-model=\"vm.roomPosSearchText\" type=\"search\" placeholder=\"Search POS options\" \nclass=\"demo-header-searchbox md-text role-srch pos-options-search-input\" ng-keydown=\"$event.stopPropagation()\" \nng-keyup=\"$event.stopPropagation()\" autocomplete=\"off\"></div></md-select-header><md-option \nng-if=\"vm.loadingRoomPosOptions\" ng-disabled=\"true\">Loading POS options...</md-option><md-option \nng-value=\"option.value\" ng-repeat=\"option in vm.roomPosOptions | filter:vm.filterRoomPosOptions\">\n{{ option.product_name || option.label }}</md-option><md-option \nng-if=\"!vm.loadingRoomPosOptions && vm.roomPosOptions.length == 0\" ng-disabled=\"true\">No POS options found</md-option>\n</md-select><div class=\"room-pos-options-loader\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.loadingRoomPosOptions\"><md-progress-circular md-diameter=\"18\" class=\"md-accent\"></md-progress-circular><span>\nLoading options...</span></div></md-input-container></div><div layout=\"column\" flex-gt-xs=\"{{ isParent? 25:33}}\" \nflex=\"100\" class=\"ph-10\" ng-if=\"isParent\"><md-input-container><label>\n{{ vm.selectedHotels.length == 1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\"><div \nlayout=\"column\" flex-gt-xs=\"100\" flex=\"100\" class=\"ph-10 pb-20\" layout-align=\"start end\"><div class=\"logo\"><md-button \nclass=\"md-raised md-cornered\" ng-click=\"vm.getIncomeReport()\" ng-disabled=\"vm.requestProcessing\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessing\"></md-progress-circular>\n</md-button><md-button ng-if=\"vm.csvData.length > 0\" class=\"md-raised md-cornered\" \nng-click=\"downloadFile(vm.csvHeader,vm.csvData,vm.csvName)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\"vm.csvData.length > 0\" class=\"md-raised md-cornered\" ng-click=\"vm.getPrintRetail(\'pdf\')\" \nng-disabled=\"vm.requestProcessingPDF\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\">\n</md-icon>Export as PDF<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.requestProcessingPDF\"></md-progress-circular></md-button><md-button ng-if=\"vm.csvData.length > 0\" \nclass=\"md-raised md-cornered\" ng-click=\"vm.printRecords()\" ng-disabled=\"vm.requestProcessingEmail\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_email_24px.svg\"></md-icon>Email Report<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessingEmail\">\n</md-progress-circular></md-button></div></div></div><div id=\"table-container\" class=\"simple-table-container mt-20\" \nng-if=\"vm.csvData.length > 0\"><div class=\"ms-responsive-table-wrapper ph-20\"><table id=\"tableOuter\" \nclass=\"simple margin-border\" ms-responsive-table=\"\" style=\"border:1px solid #dedede\"><thead><tr class=\"headerrow\"><td>\nItinerary</td><td>Confirmation</td><td>Date</td><td>Customer</td><td class=\"small-col\">Quantity</td><td>Item</td><td>\nEmployee</td><td>Payment Type</td><td>Sub Total</td><td>Discount</td><td>Sales Tax</td><td class=\"small-col\">\nSales Tax %</td><td>Tourist Development<br>Tax</td><td>Tourist Development<br>Tax %</td><td>CC Processing Fee</td><td>\nCC Processing<br>Fee %</td><td>Bar Tax</td><td>Bar Tax %</td><td>Total Tax</td><td>Total</td><td>Paid Amount</td><td>\nRemaining Amount</td></tr></thead><tbody id=\"tbodyHeight\" ng-style=\"vm.tableOuterStyle\" ms-scroll \nstyle=\"position:relative\"><tr><td colspan=\"22\" style=\"padding:0px\" class=\"fullwidth\"><table id=\"tableInner\" \nng-repeat=\"(pKey, perDay) in vm.retailReport\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"padding:0px;border:none !important;margin:0px;width:100%;float:left\"><tr ng-repeat=\"(myKey, retail) in perDay\" \nng-init=\"vm.calculateTotal(retail, myKey, pKey)\"><td class=\"cursorPointer itinerary-row\" \nng-click=\"goToState(retail.itinerary_number, retail.confirmation_number, \'\')\">{{ retail.itinerary_number }}</td><td \nclass=\"cursorPointer itinerary-row\" ng-click=\"goToState(retail.itinerary_number, retail.confirmation_number, \'\')\">\n{{ retail.confirmation_number }}</td><td>{{ retail.created_date }}</td><td>{{ retail.customerName }}</td><td \nclass=\"small-col\">{{ retail.quantity }}</td><td>{{ retail.product_name }}</td><td>{{ retail.Employee }}</td><td>\n{{ retail.payment_method }}</td><td>{{ retail.subtotal | currency : \"$\" : 2 }}</td><td>\n{{ retail.product_discount | currency : \"$\" : 2 }}</td><td>{{ retail.salesTaxAmt | currency : \"$\" : 2 }}</td><td \nclass=\"small-col\">{{ retail.salesTaxPercent }} %</td><td>{{ retail.touristTaxAmt | currency : \"$\" : 2 }}</td><td>\n{{ retail.touristTaxPercent }} %</td><td>{{ retail.ccProcessingFeeAmt | currency : \"$\" : 2 }}</td><td>\n{{ retail.ccProcessingFeePercent }} %</td><td>{{ retail.barTaxAmt | currency : \"$\" : 2 }}</td><td>\n{{ retail.barTaxPercent }} %</td><td>{{ retail.totalTaxAmount | currency : \"$\" : 2 }}</td><td>\n{{ retail.grand_total | currency : \"$\" : 2 }}</td><td>{{ retail.paid_amount | currency : \"$\" : 2 }}</td><td>\n{{ retail.remaining_amount | currency : \"$\" : 2 }}</td></tr><tr style=\"background: #f9f9f9\" class=\"pricingrowTd\"><td \ncolspan=\"4\" class=\"colspan-4\">Total ({{ vm.formatReportDayKey(pKey) }})</td><td class=\"small-col\">\n{{ vm.overAll[pKey][\'quantity\'] }}</td><td colspan=\"3\" class=\"colspan-3\"></td><td>\n{{ vm.overAll[pKey][\'subtotal\'] | currency : \"$\" : 2 }}</td><td>\n{{ vm.overAll[pKey][\'product_discount\'] | currency : \"$\" : 2 }}</td><td>\n{{ vm.overAll[pKey][\'salesTaxAmt\'] | currency : \"$\" : 2 }}</td><td class=\"small-col\"></td><td>\n{{ vm.overAll[pKey][\'touristTaxAmt\'] | currency : \"$\" : 2 }}</td><td></td><td>\n{{ vm.overAll[pKey][\'ccProcessingFeeAmt\'] | currency : \"$\" : 2 }}</td><td></td><td>\n{{ vm.overAll[pKey][\'barTaxAmt\'] | currency : \"$\" : 2 }}</td><td></td><td>\n{{ vm.overAll[pKey][\'totalTaxAmount\'] | currency : \"$\" : 2 }}</td><td>\n{{ vm.overAll[pKey][\'grand_total\'] | currency : \"$\" : 2 }}</td><td>\n{{ vm.overAll[pKey][\'paid_amount\'] | currency : \"$\" : 2 }}</td><td>\n{{ vm.overAll[pKey][\'remaining_amount\'] | currency : \"$\" : 2 }}</td></tr><tr \nng-if=\"vm.overAll[pKey][\'tip_amount\'] > 0\" style=\"background: #f9f9f9\" class=\"pricingrowTd\"><td colspan=\"4\" \nclass=\"colspan-4\">Tip Total for {{pKey}}</td><td class=\"small-col\"></td><td colspan=\"3\" class=\"colspan-3\"></td><td>\n</td><td></td><td></td><td class=\"small-col\"></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>\n{{ vm.overAll[pKey][\'tip_amount\'] | currency : \"$\" : 2}}</td><td></td><td></td></tr></table></td></tr><tr \nstyle=\"background: #f9f9f9\" class=\"pricingrowTd\"><td colspan=\"4\" class=\"colspan-4\">Grand Total</td><td \nclass=\"small-col\">{{ vm.grandTotal[\'quantity\'] }}</td><td colspan=\"3\" class=\"colspan-3\"></td><td>\n{{ vm.grandTotal[\'subtotal\'] | currency : \"$\" : 2 }}</td><td>\n{{ vm.grandTotal[\'product_discount\'] | currency : \"$\" : 2 }}</td><td>\n{{ vm.grandTotal[\'salesTaxAmt\'] | currency : \"$\" : 2 }}</td><td class=\"small-col\"></td><td>\n{{ vm.grandTotal[\'touristTaxAmt\'] | currency : \"$\" : 2 }}</td><td></td><td>\n{{ vm.grandTotal[\'ccProcessingFeeAmt\'] | currency : \"$\" : 2 }}</td><td></td><td>\n{{ vm.grandTotal[\'barTaxAmt\'] | currency : \"$\" : 2 }}</td><td></td><td>\n{{ vm.grandTotal[\'totalTaxAmount\'] | currency : \"$\" : 2 }}</td><td>\n{{ vm.grandTotal[\'grand_total\'] | currency : \"$\" : 2 }}</td><td>{{ vm.grandTotal[\'paid_amount\'] | currency : \"$\" : 2 }}\n</td><td>{{ vm.grandTotal[\'remaining_amount\'] | currency : \"$\" : 2 }}</td></tr><tr \nng-if=\"vm.grandTotal[\'tip_amount\'] > 0\" style=\"background: #f9f9f9\" class=\"pricingrowTd\"><td colspan=\"4\" \nclass=\"colspan-4\">Tip Total for {{ (vm.startDate | date:\'MM/dd/yyyy\')+\'-\'+(vm.endDate | date:\'MM/dd/yyyy\')}}</td><td \nclass=\"small-col\"></td><td colspan=\"3\" class=\"colspan-3\"></td><td></td><td></td><td></td><td class=\"small-col\"></td>\n<td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>\n{{ vm.grandTotal[\'tip_amount\'] | currency : \"$\" : 2}}</td><td></td><td></td></tr></tbody></table></div></div><div \nclass=\"simple-table-container mt-20\"><div class=\"ms-responsive-table-wrapper ph-20 pb-20 norecordFound\" \nng-show=\"vm.noResultFound\">No Result Found</div></div></div></div></div>");
$templateCache.put("app/main/apps/reports/room-moves/room-moves.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-border-vertical\" \nclass=\"mr-10\"></md-icon><span>Room Moves</span></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container Housekeepingtable\"><div class=\"table-title\">\nRoom Move {{ vm.startDate | date:\'MM/dd/yyyy\'}}</div><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" \nflex-gt-xs=\"{{isParent ? 25 : (vm.showReportFor ? 33 : 50)}}\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Start Date</label>\n<md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.startDate\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" required></md-datepicker></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{isParent ? 25 : (vm.showReportFor ? 33 : 50)}}\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">End Date</label>\n<md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.endDate\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" required></md-datepicker></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\" ng-if=\"isParent\"><md-input-container><label>\n{{ vm.selectedHotels.length ==1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{isParent ? 25 : (vm.showReportFor ? 33 : 50)}}\" flex=\"100\" class=\"ph-10\" \nng-if=\"vm.showReportFor || isParent\"><md-input-container><label>Report For</label><md-select ng-model=\"vm.reportFor\">\n<md-option value=\"reservation\" selected=\"selected\">Hotel</md-option><md-option value=\"boat\">Marina</md-option>\n</md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" \nflex-gt-xs=\"100\" flex=\"100\" class=\"ph-10 pb-20\" layout-align=\"center end\"><div><div class=\"logo\"><md-button \nclass=\"md-raised md-cornered mr-10\" ng-click=\"vm.getRoomMoves()\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh</md-button><md-button \nclass=\"md-raised md-cornered\" ng-if=\"vm.roomMove.length > 0\" \nng-click=\"downloadFile(vm.csvHeader,vm.roomMove,vm.csvName)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nclass=\"md-raised md-cornered\" ng-if=\"vm.roomMove.length > 0\" ng-click=\"vm.getRoomMoves(\'pdf\', \'all\')\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>Export as PDF</md-button></div></div></div>\n</div><div class=\"simple-table-container ph-20 pb-20\"><div class=\"ms-responsive-table-wrapper\" \nng-if=\"vm.roomMove.length > 0\"><table class=\"simple margin-border\" ms-responsive-table=\"\"><tbody><tr class=\"headerrow\">\n<th>Itinerary</th><th>Old Confirmation Number</th><th>New Confirmation Number</th><th>Old Room</th><th>New Room</th>\n<th>Business Entity</th><th>Date</th><th>Amount Moved</th><th>Guest</th><th>Number of Guest</th></tr><tr \nng-repeat=\"rooms in vm.roomMove\"><td>{{rooms.itinerary_number}}</td><td>{{rooms.oldConfirmationId}}</td><td>\n{{rooms.newConfirmationId }}</td><td>{{rooms.roomFrom}}</td><td>{{rooms.newRoom}}</td><td>{{rooms.entity}}</td><td>\n{{rooms.room_stay_to}}</td><td>{{rooms.grand_total | currency:$:2}}</td><td>{{rooms.traveller}}</td><td>\n{{rooms.guestCount}}</td></tr></tbody></table></div></div><div layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.paidInDifferentRoom.length > 0\"><div class=\"table-title\" layout=\"column\" flex-gt-xs=\"50\" flex=\"50\" \nclass=\"ph-10 pb-20\" layout-align=\"center start\">Inter Hotel Room Move</div><div class=\"logo\" layout=\"column\" \nflex-gt-xs=\"50\" flex=\"50\" class=\"ph-10 pb-20\" layout-align=\"center end\"><div><md-button class=\"md-raised md-cornered\" \nng-click=\"downloadFile(vm.csvHeaderInterHotel,vm.roomMoveInterHotel,vm.csvNameInterHotel)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nclass=\"md-raised md-cornered\" ng-click=\"vm.getRoomMoves(\'pdf\', \'interHotel\')\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>Export as PDF</md-button></div></div></div>\n<div class=\"simple-table-container ph-20 pb-20\" ng-if=\"vm.isParent\"><div class=\"ms-responsive-table-wrapper\" \nng-if=\"vm.paidInDifferentRoom.length > 0\"><table class=\"simple margin-border\" ms-responsive-table=\"\"><tbody><tr \nclass=\"headerrow\"><th>Itinerary</th><th>Old Confirmation Number</th><th>New Confirmation Number</th><th>Old Room</th>\n<th>New Room</th><th>Date</th><th>Amount Moved</th></tr><tr ng-repeat=\"rooms in vm.paidInDifferentRoom\"><td>\n{{rooms.itinerary_number}}</td><td>{{rooms.oldConfirmationId}}</td><td>{{rooms.newConfirmationId }}</td><td>\n{{rooms.roomFrom}}</td><td>{{rooms.newRoom}}</td><td>{{rooms.room_stay_to}}</td><td>\n{{rooms.grand_total | currency:$:2}}</td></tr></tbody></table></div></div><div \nclass=\"simple-table-container ph-20 pb-20 norecordFound\"><div class=\"ms-responsive-table-wrapper\" \nng-if=\"vm.noDataFound\">No Data Found.</div></div></div></div></div>");
$templateCache.put("app/main/apps/reports/salesbyemployee/salesbyemployee.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-currency-usd\" \nclass=\"mr-10\"></md-icon><span>Sales By Employee</span></div></div></div><div class=\"content\"><div \nclass=\"Night-audit-table salesByemp\"><div class=\"Night-audit-heading\">\nSales By Employee {{ vm.from | date:\'MM/dd/yyyy\'}} - {{ vm.to | date:\'MM/dd/yyyy\'}}</div><div \nclass=\"searching_input-blocksmain\"><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" \nflex-gt-xs=\"{{isParent || vm.hotelID == 126? 25:50 }}\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">From Date</label>\n<md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.from\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" ng-change=\"vm.checkSchedule(\'from\')\" md-min-date=\"vm.minDate\" required>\n</md-datepicker></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{ isParent || vm.hotelID == 126? 25:50 }}\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">To Date</label>\n<md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.to\" md-open-on-focus ng-model-options=\"{debounce: 500}\" \nng-change=\"vm.checkSchedule(\'to\')\" md-max-date=\"vm.endDate\" md-min-date=\"vm.from\" required></md-datepicker>\n</md-input-container></div><div layout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\" ng-if=\"isParent\">\n<md-input-container><label>{{ vm.selectedHotels.length == 1 ? \'Buisness Entity\': \'Buisness Entities\' }}</label>\n<md-select ng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" \nng-repeat=\"hotel in subHotels\">{{hotel.hotel_title}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"{{vm.hotelID == 122 ? 25 : 50}}\" flex=\"100\" class=\"ph-10\" \nng-if=\"vm.hotelID == 126 || vm.hotelID == 122\"><md-input-container><label>Report For</label><md-select \nng-model=\"vm.reportFor\"><md-optgroup label=\"Report For\"><md-option value=\"all\" selected=\"selected\">All</md-option>\n<md-option value=\"reservation\">Hotel</md-option><md-option value=\"boat\">Marina</md-option><md-option value=\"rent\" \nng-if=\"vm.hotelID == 126\">Residence</md-option></md-optgroup></md-select></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex-gt-xs=\"100\" flex=\"100\" layout-align=\"center end\"><div \nclass=\"btnsrefreshblock\"><md-button class=\"md-raised md-cornered mr-10\" ng-click=\"vm.generateSales()\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.refreshRequest\"></md-progress-circular>\n</md-button><md-button class=\"md-raised md-cornered mr-10\" ng-if=\"vm.agentKeys.length > 0\" \nng-click=\"vm.exportFile(\'csv\')\" ng-disabled=\"vm.csvLoader\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>Export to CSV<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.csvLoader\"></md-progress-circular></md-button>\n<md-button class=\"md-raised md-cornered mr-10\" ng-if=\"vm.agentKeys.length > 0\" ng-click=\"vm.exportFile(\'pdf\')\" \nng-disabled=\"vm.exportLoader\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>\nExport to PDF<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.exportLoader\"></md-progress-circular></md-button></div></div></div></div><div \nclass=\"simple-table-container mt-20\" id=\"table-container\" ng-if=\"vm.agentKeys.length > 0 && !vm.showGeneratingFlag\">\n<div class=\"ph-20 pb-0\" ng-repeat=\"(parentKey, saleData) in vm.agentKeys\" id=\"table-height\"><h1 class=\"mt-40\">\n{{vm.salesByAgents[saleData].name}}</h1><div id=\"abc\" class=\"ms-responsive-table-wrapper\"><table \nclass=\"simple margin-border\" cellpadding=\"0\" cellspacing=\"0\" style=\"position:relative\" \nng-class=\"heightTable{{vm.salesByAgents[saleData].name | split: \' \':0}}\"><thead><tr class=\"headerrow\"><td>Itinerary\n</td><td>Confirmation</td><td>Type</td><td>Product</td><td>From</td><td>To</td><td>Created</td><td>Status</td><td>\nCustomer</td><td>Subtotal</td><td>Grand Total</td><td>Paid</td><td>Remaining</td></tr></thead><tbody \nng-style=\"vm.tableStyle\" ms-scroll style=\"position:relative\" \nclass=\"tbodyHeight{{vm.salesByAgents[saleData].name | split:\' \':0}}\"><tr class=\"cursor_pointer\" \nng-repeat=\"(resKey, reservation) in vm.salesByAgents[saleData][\'reservations\']\" \nng-if=\"$index <= (vm.salesByAgents[saleData][\'reservations\'].length - 2)\" \nng-click=\"goToState(\'\', reservation.confirmation_number, \'\')\"><td>{{reservation.itinerary_number}}</td><td>\n{{reservation.confirmation_number}}</td><td>{{reservation.type_of_reservation}}</td><td>{{reservation.product_name}}\n</td><td>{{reservation.room_stay_from}}</td><td>{{reservation.room_stay_to}}</td><td>\n{{reservation.reservation_created_date}}</td><td>{{reservation.room_stay_status}}</td><td>{{reservation.customer_name}}\n</td><td>{{reservation.subtotal | currency}}</td><td>{{reservation.grand_total | currency}}</td><td>\n{{reservation.paid_amount | currency}}</td><td>{{reservation.remaining_amount | currency}}</td></tr><tr \nng-repeat=\"(resKey, reservation) in vm.salesByAgents[saleData][\'reservations\']\" \nng-if=\"$index == (vm.salesByAgents[saleData][\'reservations\'].length - 1)\"><td class=\"bold_text\">\n{{reservation.itinerary_number}}</td><td class=\"bold_text\">{{reservation.confirmation_number}}</td><td \nclass=\"bold_text\">{{reservation.type_of_reservation}}</td><td class=\"bold_text\">{{reservation.product_name}}</td><td \nclass=\"bold_text\">{{reservation.room_stay_from}}</td><td class=\"bold_text\">{{reservation.room_stay_to}}</td><td \nclass=\"bold_text\">{{reservation.reservation_created_date}}</td><td class=\"bold_text\">{{reservation.room_stay_status}}\n</td><td class=\"bold_text\">{{reservation.customer_name}}</td><td class=\"bold_text\">{{reservation.subtotal | currency}}\n</td><td class=\"bold_text\">{{reservation.grand_total | currency}}</td><td class=\"bold_text\">\n{{reservation.paid_amount | currency}}</td><td class=\"bold_text\">{{reservation.remaining_amount | currency}}</td></tr>\n</tbody></table></div></div></div><div class=\"simple-table-container mt-20\" \nng-if=\"vm.agentKeys.length == 0  && !vm.showGeneratingFlag\"><div class=\"ms-responsive-table-wrapper ph-20 pb-20\">\nNo Result Found.</div></div></div></div><div class=\"nightAudit-tableblock nightaudittable\" \nng-if=\"vm.showGeneratingFlag\"><div class=\"generate_report_div\"><div class=\"inside-generate-report\"><h1>Please wait \n<span class=\"loader_img\"><img src=\"assets/images/loading_dots.gif\"></span></h1><p>Generating data for all dates</p>\n</div></div></div></div>");
$templateCache.put("app/main/apps/reports/tax-report/tax-report-new.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-currency-usd\" \nclass=\"mr-10\"></md-icon><span>Tax Report</span></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container Housekeepingtable incomereport income-report-table taxreportClass\"><div \nclass=\"table-title\">Tax Report {{ (vm.startDate | date:\'MM/dd/yyyy\')}}</div><div layout=\"row\" flex=\"100\" class=\"ph-10\" \nlayout-wrap><div layout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Date</label>\n<md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.startDate\" ng-change=\"vm.ChangeEndDayIf()\" \nmd-open-on-focus ng-model-options=\"{debounce: 500}\" md-min-date=\"vm.initialDate\" required></md-datepicker>\n</md-input-container></div><div layout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\"><md-input-container \nclass=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">End Date</label>\n<md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.endDate\" md-min-date=\"vm.startDate\" md-open-on-focus \nng-model-options=\"{debounce: 500}\" required></md-datepicker></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{vm.hotelID == 122 ? 25 : 33}}\" flex=\"100\" class=\"ph-20\"><md-input-container><label>Payment Method</label>\n<md-select ng-model=\"vm.selectedPaymentMethods\" multiple=\"multiple\"><md-optgroup label=\"Payment Method\"><md-option \nvalue=\"Cash\">Cash</md-option><md-option value=\"Credit Card\">Credit Card</md-option><md-option value=\"Check\">Check\n</md-option><md-option value=\"Other\">Other</md-option><md-option value=\"Gift Card\">Gift Card</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\" ng-if=\"isParent\">\n<md-input-container><label>{{vm.selectedHotels.length == 1 ? \'Buisness Entity\': \'Buisness Entities\'}}</label><md-select\n ng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{vm.hotelID == 122 ? 25 : 33}}\" flex=\"100\" class=\"ph-10 ml-20\" \nng-if=\"vm.hotelID == 126 || vm.hotelID == 122\"><md-input-container><label>Report For</label><md-select \nng-model=\"vm.reportFor\"><md-optgroup label=\"Report For\"><md-option value=\"hotel\">Hotel</md-option><md-option \nvalue=\"boat\">Marina</md-option><md-option value=\"rent\" ng-if=\"vm.hotelID == 126\">Rent</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"100\" flex=\"100\" class=\"ph-10 pb-20\" \nlayout-align=\"start end\"><div class=\"logo\"><md-button class=\"md-raised md-cornered\" ng-click=\"vm.getIncomeReport()\" \nng-disabled=\"vm.requestProcessing\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\">\n</md-icon>Refresh<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.requestProcessing\"></md-progress-circular></md-button><md-button ng-if=\"!vm.noResultFound\" \nclass=\"md-raised md-cornered\" ng-click=\"vm.downloadCsvFile(vm.csvName)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\"!vm.noResultFound\" class=\"md-raised md-cornered\" ng-click=\"vm.getPrintTaxReport(\'pdf\')\" \nng-disabled=\"vm.requestProcessingPDF\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\">\n</md-icon>Export as PDF<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.requestProcessingPDF\"></md-progress-circular></md-button><md-button style=\"display: inline-block\" \nclass=\"md-raised md-cornered\" ng-if=\"!vm.noResultFound\" ng-click=\"vm.downloadFile(\'printRoom\')\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/print.svg\" class=\"smiconprint\"></md-icon>Print</md-button></div>\n</div></div><div ng-if=\"!vm.noResultFound && !vm.showGeneratingFlag\"><div class=\"simple-table-container ph-20 pb-20\" \nid=\"printRoom\" style=\"font-family:arial\"><div class=\"ms-responsive-table-wrapper\" id=\"table-container\"><div \nng-show=\"vm.print\" style=\"width:100%;display:block;margin-bottom:10px;text-align: right\"><div \nstyle=\"padding:13px 10px;width:auto;float:left\"><img src=\"{{vm.logo}}\" style=\"width:60px\"></div><div \nstyle=\"padding:12px 10px;float:right;vertical-align: middle;font-size:18px;font-family: arial\"><span \nstyle=\"width:100%;float:left\">Revenue by Room </span><span \nstyle=\"width:100%;float:left;font-size: 15px;margin-top: 5px\">{{vm.month}}</span></div></div><div \nclass=\"tax-report-div\" style=\"width:100%; float:left; padding-bottom:20px\"><div ng-show=\"!vm.print\" \nstyle=\"padding:0px 0px 15px;font-weight: bold;width:100%;float:left;font-size:18px;text-align:center;font-family: arial\">\n{{vm.reportTitle}} Details</div><div style=\"width:100%;float:left\"><table class=\"simple margin-border table-blockmain\" \nid=\"heightTable\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"font-family: arial; width:100%;float:left;border:1px solid #dedede;border-top:1px solid #dedede\"><thead><tr \nclass=\"first-tr\" style=\"width:100%;background: #f1f1f1\"><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">\n{{vm.reportFor == \'boat\' ? \'Marina Name\' : \'Room Name\'}}</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">Before Tax</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">Tax</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">After Tax</th></tr></thead><tbody \nid=\"tbodyHeight\" ng-style=\"vm.tableStyle\" ms-scroll style=\"position:relative\"><tr \nng-repeat=\"(roomKey, roomDetail) in vm.roomDetails\" ng-click=\"vm.showTaxDetail(roomDetail, \'roomDetail\')\"><td \nng-class=\"roomDetail.product_name == \'Total\' ? \'boldClass\' :\'\'\">{{roomDetail.product_name}}</td><td \nng-class=\"roomDetail.product_name == \'Total\' ? \'boldClass\' :\'\'\">{{roomDetail.subTotal | currency}}</td><td \nng-class=\"roomDetail.product_name == \'Total\' ? \'boldClass\' :\'\'\">{{roomDetail.tax | currency}}</td><td \nng-class=\"roomDetail.product_name == \'Total\' ? \'boldClass\' :\'\'\">{{roomDetail.grandTotal | currency}}</td></tr></tbody>\n</table></div></div></div></div><div style=\"width:100%;text-align: right;padding-right: 20px\"><md-button \nstyle=\"display: inline-block\" class=\"md-raised md-cornered\" ng-if=\"!vm.noResultFound\" \nng-click=\"vm.downloadFile(\'printReport2\')\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/print.svg\">\n</md-icon>Print</md-button></div><div class=\"simple-table-container ph-20 pb-20\" ng-if=\"!vm.noResultFound\" \nid=\"printReport2\" style=\"font-family:arial\"><div class=\"ms-responsive-table-wrapper\"><div ng-show=\"vm.print\" \nstyle=\"width:100%;display:block;margin-bottom:10px;text-align: right\"><div \nstyle=\"padding:13px 10px;width:auto;float:left\"><img src=\"{{vm.logo}}\" style=\"width:60px\"></div><div \nstyle=\"padding:12px 10px;float:right;vertical-align: middle;font-size:18px;font-family: arial\"><span \nstyle=\"width:100%;float:left\">Tax Report</span><span style=\"width:100%;float:left;font-size: 15px;margin-top: 5px\">\n{{vm.month}}</span></div></div><div class=\"tax-report-div\" style=\"width:100%; float:left; padding-bottom:20px\"><div \nclass=\"tax-report-heading\" \nstyle=\"padding:0px 0px 15px; font-weight: bold; font-size:18px; text-align:center; font-family: arial\">\n{{vm.reportTitle}} Occupancy Report for {{vm.month}}</div><div style=\"width:100%;float:left\"><table \nclass=\"simple margin-border table-blockmain\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"font-family: arial; border:1px solid #dedede; width: 100%; float: left\"><tbody><tr class=\"first-tr\" \nstyle=\"width:100%;background: #f1f1f1\"><th style=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">\nType</th><th style=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\"><span class=\"span-right\" \nstyle=\"max-width:150px; float:right\">Amount</span></th></tr><tr \nng-repeat=\"(staticReportKey, staticReport) in vm.staticsReport\" \nng-click=\"vm.showTaxDetail(staticReportKey, \'roomNights\')\"><td>{{staticReport.type}} <span \nclass=\"icon-information info-icon info-icon-tax-report\" role=\"button\"><md-tooltip md-direction=\"right\">\n{{staticReport.type}}</md-tooltip></span></td><td><span class=\"span-right\" style=\"max-width:150px; float:right\">\n{{staticReport.value}}</span></td></tr></tbody></table></div></div><div class=\"tax-report-div\" \nstyle=\"width:100%; float:left; padding-bottom:20px\"><div class=\"tax-report-heading\" \nstyle=\"padding:0px 0px 15px; font-weight: bold; font-size:18px; text-align:center; font-family: arial\">\nGift Certificates for {{vm.month}}</div><div style=\"width:100%;float:left\"><table \nclass=\"simple margin-border table-blockmain\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"font-family: arial; border:1px solid #dedede; width: 100%; float: left\"><tbody><tr class=\"first-tr\" \nstyle=\"width:100%;background: #f1f1f1\"><th style=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">\nType</th><th style=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\"><span class=\"span-right\" \nstyle=\"max-width:150px; float:right\">Amount</span></th></tr><tr ng-repeat=\"(gcKey, gcValue) in vm.gcDetails\" \nng-click=\"vm.showTaxDetail(gcKey, \'giftCard\')\"><td>Gift Certificate {{gcKey}}</td><td><span class=\"span-right\" \nstyle=\"max-width:150px; float:right\">{{gcValue | currency}}</span></td></tr></tbody></table></div></div><div \nclass=\"tax-report-div\" style=\"width:100%; float:left; padding-bottom:20px\"><div class=\"tax-report-heading\" \nstyle=\"padding:0px 0px 15px; font-weight: bold; font-size:18px; text-align:center; font-family: arial\">\n{{vm.reportTitle}} Sales for {{vm.month}}</div><div style=\"width:100%;float:left\"><table \nclass=\"simple margin-border table-blockmain\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"font-family: arial; border:1px solid #dedede; width: 100%; float: left\"><tbody><tr class=\"first-tr\" \nstyle=\"width:100%;background: #f1f1f1\"><th style=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">\nType</th><th style=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">Before Tax</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">Taxes</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\"><span class=\"span-right\" \nstyle=\"max-width:150px; float:right\">Amount</span></th></tr><tr ng-repeat=\"(skey, svalue) in vm.overAllSale\" \nng-click=\"vm.showTaxDetail(svalue, \'overAllSale\')\"><td>{{svalue.type}}</td><td><span style=\"max-width:150px\">\n{{svalue.subTotal | currency}}</span></td><td><span style=\"max-width:150px\">{{svalue.tax | currency}}</span></td><td>\n<span class=\"span-right\" style=\"max-width:150px; float:right\">{{svalue.grandTotal| currency}}</span></td></tr></tbody>\n</table></div></div><div class=\"tax-report-div\" style=\"width:100%; float:left; padding-bottom:20px\"><div \nclass=\"tax-report-heading\" \nstyle=\"padding:0px 0px 15px; font-weight: bold; font-size:18px; text-align:center; font-family: arial\">\n{{vm.reportTitle}} Advance Deposit Liabilities for {{vm.month}}</div><div style=\"width:100%;float:left\"><table \nclass=\"simple margin-border table-blockmain\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"font-family: arial; border:1px solid #dedede; width: 100%; float: left\"><tbody><tr class=\"first-tr\" \nstyle=\"width:100%;background: #f1f1f1\"><th style=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">\nType</th><th style=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\"><span class=\"span-right\" \nstyle=\"max-width:150px; float:right\">Amount</span></th></tr><tr \nng-click=\"vm.showTaxDetail(vm.advancedDeposit, \'advanceDeposit\')\"><td>Advance Deposit Liabilities</td><td><span \nclass=\"span-right\" style=\"max-width:150px; float:right\">{{vm.advancedDeposit | currency}}</span></td></tr></tbody>\n</table></div></div><div class=\"tax-report-div\" style=\"width:100%; float:left; padding-bottom:20px\"><div \nclass=\"tax-report-heading\" \nstyle=\"padding:0px 0px 15px; font-weight: bold; font-size:18px; text-align:center; font-family: arial\">\n{{vm.reportTitle}} Payments And Refunds for {{vm.month}}</div><div style=\"width:100%;float:left\"><table \nclass=\"simple margin-border table-blockmain\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"font-family: arial; border:1px solid #dedede; width: 100%; float: left\"><tbody><tr class=\"first-tr\" \nstyle=\"width:100%;background: #f1f1f1\"><th style=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">\nPayment Method</th><th style=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">Payment</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">Refunded</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\"><span class=\"span-right\" \nstyle=\"max-width:150px; float:right\">Total</span></th></tr><tr ng-repeat=\"(pKey, payments) in vm.paymentsDetails\" \nng-click=\"vm.showTaxDetail(payments, \'payment\')\"><td ng-class=\"payments.type == \'Total\' ? \'boldClass\' :\'\'\">\n{{payments.type}}</td><td ng-class=\"payments.type == \'Total\' ? \'boldClass\' :\'\'\">{{payments.paid | currency}}</td><td \nng-class=\"payments.type == \'Total\' ? \'boldClass\' :\'\'\">{{payments.refund | currency}}</td><td \nng-class=\"payments.type == \'Total\' ? \'boldClass\' :\'\'\"><span class=\"span-right\" style=\"max-width:150px; float:right\">\n{{payments.total | currency}}</span></td></tr></tbody></table></div></div><div class=\"tax-report-div\" \nstyle=\"width:100%; float:left; padding-bottom:20px\"><div class=\"tax-report-heading\" \nstyle=\"padding:0px 0px 15px; font-weight: bold; font-size:18px; text-align:center; font-family: arial\">\n{{vm.reportTitle}} Taxes for {{vm.month}}</div><div style=\"width:100%;float:left\"><table \nclass=\"simple margin-border table-blockmain\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"font-family: arial; border:1px solid #dedede; width: 100%; float: left\"><tbody><tr class=\"first-tr\" \nstyle=\"width:100%;background: #f1f1f1\"><th style=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">\nTax Name</th><th style=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">Tax %</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">Sale Amount</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">Tax Collected</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\"><span class=\"span-right\" \nstyle=\"max-width:150px; float:right\">Final Tax</span></th></tr><tr ng-if=\"vm.taxAvailable\" \nng-repeat=\"(tKey, tax) in vm.overAllTax\" ng-click=\"vm.showTaxDetail(tax.name, \'taxes\')\"><td>{{tax.name}}</td><td>\n{{tax.percentage}} %</td><td>{{tax.amount | currency}}</td><td>{{tax.taxAmount | currency}}</td><td><span \nclass=\"span-right\" style=\"max-width:150px; float:right\">{{tax.taxAmount |currency}}</span></td></tr><tr \nng-if=\"!vm.taxAvailable\"><td colspan=\"5\" style=\"text-align: center\">No record found</td></tr></tbody></table></div>\n</div></div></div></div></div></div><div class=\"nightAudit-tableblock nightaudittable\" ng-if=\"vm.showGeneratingFlag\">\n<div class=\"generate_report_div\"><div class=\"inside-generate-report\"><h1>Please wait <span class=\"loader_img\"><img \nsrc=\"assets/images/loading_dots.gif\"></span></h1><p>Generating data for all nights</p></div></div></div></div>");
$templateCache.put("app/main/apps/reports/tax-report/tax-report.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-currency-usd\" \nclass=\"mr-10\"></md-icon><span>Tax Report</span></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container Housekeepingtable incomereport income-report-table taxreportClass\"><div \nclass=\"table-title\">Tax Report {{ (vm.startDate | date:\'MM/dd/yyyy\')}}</div><div layout=\"row\" flex=\"100\" class=\"ph-10\" \nlayout-wrap><div layout=\"column\" \nflex-gt-xs=\"{{ vm.hotelID == 126 || vm.hotelID == 122 || vm.hotelID == 119 ? 33:50 }}\" flex=\"100\" class=\"ph-10\">\n<md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Date\n</label><md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.startDate\" ng-change=\"vm.ChangeEndDayIf()\" \nmd-open-on-focus ng-model-options=\"{debounce: 500}\" required></md-datepicker></md-input-container></div><div \nlayout=\"column\" flex-gt-xs=\"{{ vm.hotelID == 126 || vm.hotelID == 122 || vm.hotelID == 119? 33:50 }}\" flex=\"100\" \nclass=\"ph-10\"><md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" \nrole=\"button\">End Date</label><md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.endDate\" \nmd-min-date=\"vm.startDate\" md-open-on-focus ng-model-options=\"{debounce: 500}\" required></md-datepicker>\n</md-input-container></div><div layout=\"column\" flex-gt-xs=\"{{ vm.hotelID == 126? 33:50 }}\" flex=\"100\" class=\"ph-10\" \nng-if=\"vm.hotelID == 126\"><md-input-container><label>Report For</label><md-select ng-model=\"vm.reportFor\"><md-optgroup \nlabel=\"Report For\"><md-option value=\"reservation\" selected=\"selected\">Hotel</md-option><md-option value=\"boat\">Marina\n</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{isParent ? 33 : 50 }}\" flex=\"100\" class=\"ph-10\" ng-if=\"isParent\"><md-input-container><label>\n{{vm.selectedHotels.length == 1 ? \'Buisness Entity\': \'Buisness Entities\'}}</label><md-select \nng-model=\"vm.selectedHotels\" multiple=\"multiple\"><md-option ng-value=\"hotel.hotel_id\" ng-repeat=\"hotel in subHotels\">\n{{hotel.hotel_title}}</md-option></md-select></md-input-container></div><div layout=\"column\" flex-gt-xs=\"100\" \nflex=\"100\" class=\"ph-10 pb-20\" layout-align=\"start end\"><div class=\"logo\"><md-button class=\"md-raised md-cornered\" \nng-click=\"vm.getIncomeReport()\" ng-disabled=\"vm.requestProcessing\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessing\"></md-progress-circular>\n</md-button><md-button ng-if=\"!vm.noResultFound && vm.reportSelected == \'new\'\" class=\"md-raised md-cornered\" \nng-click=\"vm.downloadCsvFile(vm.csvName)\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\">\n</md-icon>Export as CSV</md-button><md-button ng-if=\"vm.allData.length > 0 && vm.reportSelected == \'old\'\" \nclass=\"md-raised md-cornered\" ng-click=\"vm.getPrintTaxReport(\'pdf\')\" ng-disabled=\"vm.requestProcessingPDF\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>Export as PDF<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessingPDF\"></md-progress-circular>\n</md-button><md-button ng-if=\"!vm.noResultFound && vm.reportSelected == \'new\'\" class=\"md-raised md-cornered\" \nng-click=\"vm.getPrintTaxReport(\'pdf\')\" ng-disabled=\"vm.requestProcessingPDF\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>Export as PDF<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessingPDF\"></md-progress-circular>\n</md-button><md-button style=\"display: inline-block\" class=\"md-raised md-cornered\" \nng-if=\"!vm.noResultFound && vm.reportSelected == \'new\'\" ng-click=\"vm.downloadFile(\'printRoom\')\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/print.svg\" class=\"smiconprint\"></md-icon>Print</md-button>\n<md-button ng-if=\"vm.allData.length > 0 && vm.reportSelected == \'old\'\" class=\"md-raised md-cornered\" \nng-click=\"vm.printRecords()\" ng-disabled=\"vm.requestProcessingEmail\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_email_24px.svg\"></md-icon>Email Report<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessingEmail\">\n</md-progress-circular></md-button></div></div></div><div ng-if=\"vm.reportSelected == \'new\' && !vm.noResultFound\"><div \nclass=\"simple-table-container ph-20 pb-20\" id=\"printRoom\" style=\"font-family:arial\" ng-if=\"!vm.noResultFound\"><div \nclass=\"ms-responsive-table-wrapper\" id=\"table-container\"><div ng-show=\"vm.print\" \nstyle=\"width:100%;display:block;margin-bottom:10px;text-align: right\"><div \nstyle=\"padding:13px 10px;width:auto;float:left\"><img src=\"{{vm.logo}}\" style=\"width:60px\"></div><div \nstyle=\"padding:12px 10px;float:right;vertical-align: middle;font-size:18px;font-family: arial\"><span \nstyle=\"width:100%;float:left\">Revenue by Room </span><span \nstyle=\"width:100%;float:left;font-size: 15px;margin-top: 5px\">{{vm.month}}</span></div></div><div \nstyle=\"width:100%;float:left;padding-bottom:20px\"><div ng-show=\"!vm.print\" \nstyle=\"padding:0px 0px 15px;font-weight: bold;width:100%;float:left;font-size:18px;text-align:center;font-family: arial\">\n{{vm.reportFor == \'boat\' ? \'Marina Details\' : \'Room Details\'}}</div><div style=\"width:100%;float:left\"><table \nclass=\"simple margin-border table-blockmain\" id=\"heightTable\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"font-family: arial; width:100%;float:left;border:1px solid #dedede;border-top:1px solid #dedede\"><thead><tr \nstyle=\"width:100%;background: #f1f1f1\"><th style=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">\n{{vm.reportFor == \'boat\' ? \'Marina Name\' : \'Room Name\'}}</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">Before Tax</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">Tax</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">After Tax</th></tr></thead><tbody \nid=\"tbodyHeight\" ng-style=\"vm.tableStyle\" ms-scroll style=\"position:relative\"><tr \nng-repeat=\"(roomKey, roomDetail) in vm.roomDetails\"><td style=\"padding:7px 10px;border-bottom: 1px solid #dedede\">\n{{ roomDetail[\'name\'] }}</td><td style=\"padding:7px 10px; border-bottom: 1px solid #dedede\">\n{{ roomKey != \'Total\'?roomDetail[\'subTotal\']:roomDetail[\'STT\'] }}</td><td \nstyle=\"padding:7px 10px; border-bottom: 1px solid #dedede\">\n{{ roomKey != \'Total\'?roomDetail[\'taxPaid\']:roomDetail[\'TPT\'] }}</td><td \nstyle=\"padding:7px 10px; border-bottom: 1px solid #dedede\">\n{{ roomKey != \'Total\'?roomDetail[\'grandTotal\']:roomDetail[\'GTT\'] }}</td></tr></tbody></table></div></div></div></div>\n<div style=\"width:100%;text-align: right;padding-right: 20px\"><md-button style=\"display: inline-block\" \nclass=\"md-raised md-cornered\" ng-if=\"vm.cottagePresent && !vm.noResultFound\" \nng-click=\"vm.downloadFile(\'cottagePresent\')\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/print.svg\">\n</md-icon>Print</md-button></div><div class=\"simple-table-container ph-20 pb-20\" id=\"cottagePresent\" \nstyle=\"font-family:arial\" ng-if=\"vm.cottagePresent && !vm.noResultFound\"><div class=\"ms-responsive-table-wrapper\"><div \nng-show=\"vm.print\" style=\"width:100%;display:block;margin-bottom:10px;text-align: right\"><div \nstyle=\"padding:13px 10px;width:auto;float:left\"><img src=\"{{vm.logo}}\" style=\"width:60px\"></div><div \nstyle=\"padding:12px 10px;float:right;vertical-align: middle;font-size:18px;font-family: arial\"><span \nstyle=\"width:100%;float:left\">Cottage Details</span><span \nstyle=\"width:100%;float:left;font-size: 15px;margin-top: 5px\">{{vm.month}}</span></div></div><div \nstyle=\"width:100%;float:left;padding-bottom:20px\"><div ng-show=\"!vm.print\" \nstyle=\"padding:0px 0px 15px;font-weight: bold;width:100%;float:left;font-size:18px;text-align:center;font-family: arial\">\nCottage Details</div><div style=\"width:100%;float:left\"><table class=\"simple margin-border table-blockmain\" \ncellpadding=\"0\" cellspacing=\"0\" \nstyle=\"font-family: arial; width:100%;float:left;border:1px solid #dedede;border-top:1px solid #dedede\"><tbody><tr \nstyle=\"width:100%;background: #f1f1f1\"><th style=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\">\nRoom Name</th><th style=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\">Before Tax</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\">Tax</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\">After Tax</th></tr><tr \nng-repeat=\"(cottageKey, cottageDetail) in vm.cottageData\"><td style=\"padding:7px 10px;border-bottom:1px solid #dedede\">\n{{ cottageKey }}</td><td style=\"padding:7px 10px;border-bottom:1px solid #dedede\">\n{{ cottageKey != \'Total\'?cottageDetail[\'subTotal\']:cottageDetail[\'STT\'] }}</td><td \nstyle=\"padding:7px 10px;border-bottom:1px solid #dedede\">\n{{ cottageKey != \'Total\'?cottageDetail[\'taxPaid\']:cottageDetail[\'TPT\'] }}</td><td \nstyle=\"padding:7px 10px;border-bottom:1px solid #dedede\">\n{{ cottageKey != \'Total\'?cottageDetail[\'grandTotal\']:cottageDetail[\'GTT\'] }}</td></tr></tbody></table></div></div>\n</div></div><div style=\"width:100%;text-align: right;padding-right: 20px\"><md-button style=\"display: inline-block\" \nclass=\"md-raised md-cornered\" ng-if=\"!vm.noResultFound\" ng-click=\"vm.downloadFile(\'printReport2\')\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/print.svg\"></md-icon>Print</md-button></div><div \nclass=\"simple-table-container ph-20 pb-20\" ng-if=\"!vm.noResultFound\" id=\"printReport2\" style=\"font-family:arial\"><div \nclass=\"ms-responsive-table-wrapper\"><div ng-show=\"vm.print\" \nstyle=\"width:100%;display:block;margin-bottom:10px;text-align: right\"><div \nstyle=\"padding:13px 10px;width:auto;float:left\"><img src=\"{{vm.logo}}\" style=\"width:60px\"></div><div \nstyle=\"padding:12px 10px;float:right;vertical-align: middle;font-size:18px;font-family: arial\"><span \nstyle=\"width:100%;float:left\">Tax Report</span><span style=\"width:100%;float:left;font-size: 15px;margin-top: 5px\">\n{{vm.month}}</span></div></div><div style=\"width:100%;float:left;padding-bottom:20px\"><div \nstyle=\"padding:0px 0px 15px;font-weight: bold;font-size:18px;text-align:center;font-family: arial\" \nng-if=\"vm.reportFor == \'reservation\'\">Rooms Tax Report for {{vm.month}}</div><div \nstyle=\"padding:0px 0px 15px;font-weight: bold;font-size:18px;text-align:center;font-family: arial\" \nng-if=\"vm.reportFor == \'boat\'\">Marina Tax Report for {{vm.month}}</div><div style=\"width:100%;float:left\"><table \nclass=\"simple margin-border table-blockmain\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"font-family: arial;border:1px solid #dedede;width: 100%;float: left\"><tbody><tr \nstyle=\"width:100%;background: #f1f1f1\"><th style=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\">\nType</th><th style=\"padding:10px 10px;text-align:left;border-bottom: 1px solid #dedede\"><span \nstyle=\"max-width:150px;float:right\">Amount</span></th></tr><tr \nng-repeat=\"(staticReportKey, staticReport) in vm.staticsReport\"><td \nstyle=\"padding:7px 10px;border-bottom: 1px solid #dedede\">{{ staticReportKey }} <span \nclass=\"icon-information info-icon info-icon-tax-report\" role=\"button\"><md-tooltip md-direction=\"right\">\n{{vm.staticsReportDescription[staticReportKey]}}</md-tooltip></span></td><td \nstyle=\"padding:7px 10px;border-bottom: 1px solid #dedede\"><span style=\"max-width:150px;float:right\">{{ staticReport }}\n</span></td></tr></tbody></table></div></div><div style=\"width:100%;float:left;padding-bottom:20px\"><div \nstyle=\"padding:0px 0px 15px;font-weight: bold;font-size:18px;text-align:center;font-family: arial\">\nGift Certificates for {{vm.month}}</div><div style=\"width:100%;float:left\"><table \nclass=\"simple margin-border table-blockmain\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"font-family: arial;border:1px solid #dedede;width: 100%;float: left\"><tbody><tr \nstyle=\"width:100%;background: #f1f1f1\"><th style=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\">\nType</th><th style=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\"><span \nstyle=\"max-width:150px;float:right\">Amount</span></th></tr><tr ng-repeat=\"(gcKey, gcValue) in vm.gcDetails\"><td \nstyle=\"padding:7px 10px;border-bottom:1px solid #dedede\">{{ gcKey}}</td><td \nstyle=\"padding:7px 10px;border-bottom:1px solid #dedede\"><span style=\"max-width:150px;float:right\">{{ gcValue}}</span>\n</td></tr></tbody></table></div></div><div style=\"width:100%;float:left;padding-bottom:20px\"><div \nstyle=\"padding:0px 0px 15px;font-weight: bold;font-size:18px;text-align:center;font-family: arial\" \nng-if=\"vm.reportFor == \'reservation\'\">Rooms Sales for {{vm.month}}</div><div \nstyle=\"padding:0px 0px 15px;font-weight: bold;font-size:18px;text-align:center;font-family: arial\" \nng-if=\"vm.reportFor == \'boat\'\">Marina Sales for {{vm.month}}</div><div style=\"width:100%;float:left\"><table \nclass=\"simple margin-border table-blockmain\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"font-family: arial;border:1px solid #dedede;width: 100%;float: left\"><tbody><tr \nstyle=\"width:100%;background: #f1f1f1\"><th style=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\">\nType</th><th style=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\">Before Tax</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\">Taxes</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\"><span style=\"max-width:150px;float:right\">\nAmount</span></th></tr><tr ng-repeat=\"(skey, svalue) in vm.overAllSale\"><td \nstyle=\"padding:7px 10px;border-bottom:1px solid #dedede\">{{svalue.type}}</td><td \nstyle=\"padding:7px 10px;border-bottom:1px solid #dedede\"><span style=\"max-width:150px\">{{svalue.subtotal}}</span></td>\n<td style=\"padding:7px 10px;border-bottom:1px solid #dedede\"><span style=\"max-width:150px\">{{svalue.taxes}}</span></td>\n<td style=\"padding:7px 10px;border-bottom:1px solid #dedede\"><span style=\"max-width:150px;float:right\">\n{{svalue.grand_total}}</span></td></tr></tbody></table></div></div><div \nstyle=\"width:100%;float:left;padding-bottom:20px\"><div \nstyle=\"padding:0px 0px 15px;font-weight: bold;font-size:18px;text-align:center;font-family: arial\" \nng-if=\"vm.reportFor == \'reservation\'\">Rooms Advance Deposit Liabilities for {{vm.month}}</div><div \nstyle=\"padding:0px 0px 15px;font-weight: bold;font-size:18px;text-align:center;font-family: arial\" \nng-if=\"vm.reportFor == \'boat\'\">Marina Advance Deposit Liabilities for {{vm.month}}</div><div \nstyle=\"width:100%;float:left\"><table class=\"simple margin-border table-blockmain\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"font-family: arial;border:1px solid #dedede;width: 100%;float: left\"><tbody><tr \nstyle=\"width:100%;background: #f1f1f1\"><th style=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\">\nType</th><th style=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\"><span \nstyle=\"max-width:150px;float:right\">Amount</span></th></tr><tr><td \nstyle=\"padding:7px 10px;border-bottom:1px solid #dedede\">Advance Deposit Liabilities</td><td \nstyle=\"padding:7px 10px;border-bottom:1px solid #dedede\"><span style=\"max-width:150px;float:right\">\n{{vm.advancedDeposit}}</span></td></tr></tbody></table></div></div><div \nstyle=\"width:100%;float:left;padding-bottom:20px\"><div \nstyle=\"padding:0px 0px 15px;font-weight: bold;font-size:18px;text-align:center;font-family: arial\" \nng-if=\"vm.reportFor == \'reservation\'\">Rooms Payments And Refunds for {{vm.month}}</div><div \nstyle=\"padding:0px 0px 15px;font-weight: bold;font-size:18px;text-align:center;font-family: arial\" \nng-if=\"vm.reportFor == \'boat\'\">Marina Payments And Refunds for {{vm.month}}</div><div style=\"width:100%;float:left\">\n<table class=\"simple margin-border table-blockmain\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"font-family: arial;border:1px solid #dedede;width: 100%;float: left\"><tbody><tr \nstyle=\"width:100%;background: #f1f1f1\"><th style=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\">\nPayment Method</th><th style=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\">Payment</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\">Refunded</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\"><span style=\"max-width:150px;float:right\">\nTotal</span></th></tr><tr ng-repeat=\"(pKey, payments) in vm.paymentsDetails\" ng-if=\"pKey != \'Type\'\"><td \nstyle=\"padding:7px 10px;border-bottom:1px solid #dedede\">{{pKey}}</td><td \nstyle=\"padding:7px 10px;border-bottom:1px solid #dedede\">{{payments.paid}}</td><td \nstyle=\"padding:7px 10px;border-bottom:1px solid #dedede\">{{payments.refund}}</td><td \nstyle=\"padding:7px 10px;border-bottom:1px solid #dedede\"><span style=\"max-width:150px;float:right\">{{payments.total}}\n</span></td></tr></tbody></table></div></div><div style=\"width:100%;float:left;padding-bottom:20px\"><div \nstyle=\"padding:0px 0px 15px;font-weight: bold;font-size:18px;text-align:center;font-family: arial\" \nng-if=\"vm.reportFor == \'reservation\'\">Rooms Taxes for {{vm.month}}</div><div \nstyle=\"padding:0px 0px 15px;font-weight: bold;font-size:18px;text-align:center;font-family: arial\" \nng-if=\"vm.reportFor == \'boat\'\">Marina Taxes for {{vm.month}}</div><div style=\"width:100%;float:left\"><table \nclass=\"simple margin-border table-blockmain\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"font-family: arial;border:1px solid #dedede;width: 100%;float: left\"><tbody><tr \nstyle=\"width:100%;background: #f1f1f1\"><th style=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\">\nTax Name</th><th style=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\">Tax Percentage</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\">Sale Amount</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\">Tax Collected</th><th \nstyle=\"padding:10px 10px;text-align:left;border-bottom:1px solid #dedede\"><span style=\"max-width:150px;float:right\">\nFinal Tax</span></th></tr><tr ng-repeat=\"(pKey, payments) in vm.overAllAmount\"><td \nstyle=\"padding:7px 10px;border-bottom:1px solid #dedede\">{{ pKey }}</td><td \nstyle=\"padding:7px 10px;border-bottom:1px solid #dedede\">{{ vm.OverAllpercentage[pKey] }}</td><td \nstyle=\"padding:7px 10px;border-bottom:1px solid #dedede\">{{ vm.overAllAmount[pKey] }}</td><td \nstyle=\"padding:7px 10px;border-bottom:1px solid #dedede\">{{ vm.overAllTax[pKey] }}</td><td \nstyle=\"padding:7px 10px;border-bottom:1px solid #dedede\"><span style=\"max-width:150px;float:right\">\n{{ vm.overAllTax[pKey] }}</span></td></tr></tbody></table></div></div></div></div></div><div id=\"table-container\" \nclass=\"simple-table-container mt-20\" ng-if=\"vm.allData.length > 0 && vm.reportSelected == \'old\'\"><div \nclass=\"ms-responsive-table-wrapper ph-20\"><table id=\"tableOuter\" class=\"simple margin-border oldtaxtable\" \nms-responsive-table=\"\" style=\"border:1px solid #dedede\"><thead><tr class=\"headerrow\"><td>Itinerary</td><td>Confirmation\n</td><td>Status</td><td>Check In</td><td>Check Out</td><td>Customer</td><td>Quantity</td><td>Item</td><td>\nAssociated POS</td><td>Number of Nights</td><td>Business Entity</td><td>Source</td><td>Payment Type</td><td>Sub Total\n</td><td>Discount</td><td>Lodging Tax</td><td>Sales Tax</td><td>Tax</td><td>Total</td><td>Payment to Date</td><td>Due\n</td><td>Installments Paid</td><td>Installments Refunded</td></tr></thead><tbody id=\"tbodyHeight\" \nng-style=\"vm.tableOuterStyle\" ms-scroll style=\"position:relative\"><tr><td colspan=\"23\" style=\"padding:0px!important\" \nclass=\"fullwidth\"><table id=\"tableInner\" ng-repeat=\"(pkey, eachDate) in vm.taxReport\" cellpadding=\"0\" cellspacing=\"0\" \nstyle=\"padding:0px;border:none !important;margin:0px;width:100%;float:left\"><tr \nng-repeat=\"(myKey, taxRow) in eachDate\" ng-init=\"vm.calculateTotal(taxRow, myKey, pkey)\"><td class=\"cursorPointer\" \nng-click=\"goToState(taxRow.itinerary_number, taxRow.confirmation_number, \'\')\">{{ taxRow.itinerary_number }}</td><td \nclass=\"cursorPointer\" ng-click=\"goToState(taxRow.itinerary_number, taxRow.confirmation_number, \'\')\">\n{{ taxRow.confirmation_number }}</td><td>{{ taxRow.room_stay_status }}</td><td>{{ taxRow.room_stay_from }}</td><td>\n{{ taxRow.room_stay_to }}</td><td>{{ taxRow.customerName }}</td><td>{{ taxRow.quantity }}</td><td>\n{{ taxRow.product_name }}</td><td>{{ taxRow.POS }}</td><td>{{ taxRow.nights }}</td><td>{{ taxRow.hotel_title }}</td>\n<td>{{ taxRow.source_of_creation }}</td><td>{{ taxRow.payment_method }}</td><td>\n{{ taxRow.sub_total | currency : $ :2 }}</td><td>{{ taxRow.discount | currency : $ :2 }}</td><td>\n{{ taxRow.lodgingTax | currency : $ :2 }}</td><td>{{ taxRow.saleTax | currency : $ :2 }}</td><td>\n{{ taxRow.totalTax | currency : $ :2 }}</td><td>{{ taxRow.total_amount | currency : $ :2 }}</td><td>\n{{ taxRow.total_paid_amount | currency : $ :2 }}</td><td>{{ taxRow.total_remaining_amount | currency : $ :2 }}</td><td>\n{{ taxRow.installment_paid | currency : $ :2 }}</td><td style=\"color: red\">\n{{ taxRow.installment_refunded | currency : $ :2 }}</td></tr><tr style=\"background: #f9f9f9\" class=\"pricingrowTd\"><td \ncolspan=\"6\">{{ pkey }}</td><td>{{vm.overAll[pkey][\'quantity\']}}</td><td></td><td></td><td>\n{{ vm.overAll[pkey][\'nights\']}}</td><td></td><td></td><td></td><td>\n{{ vm.overAll[pkey][\'subtotal\'] | currency : $ : 2 }}</td><td></td><td>\n{{ vm.overAll[pkey][\'lodging_tax\'] | currency : $ : 2 }}</td><td>{{ vm.overAll[pkey][\'sale_tax\'] | currency : $ : 2 }}\n</td><td>{{ vm.overAll[pkey][\'total_tax\'] | currency : $ : 2 }}</td><td>\n{{ vm.overAll[pkey][\'total_amount\'] | currency : $ : 2 }}</td><td>\n{{ vm.overAll[pkey][\'paid_amount\'] | currency : $ : 2 }}</td><td>\n{{ vm.overAll[pkey][\'due_amount\'] | currency : $ : 2 }}</td><td></td><td></td></tr></table></td></tr><tr \nstyle=\"background: #f9f9f9\" class=\"pricingrowTd\"><td>Total</td><td></td><td></td><td></td><td></td><td></td><td>\n{{vm.temp_quantity}}</td><td></td><td></td><td>{{vm.temp_nights}}</td><td></td><td></td><td></td><td>\n{{vm.temp_subtotal | currency : $ :2 }}</td><td></td><td>{{vm.temp_lodging_tax | currency : $ :2}}</td><td>\n{{vm.temp_sale_tax | currency : $ :2}}</td><td>{{vm.temp_total_tax | currency : $ :2}}</td><td>\n{{vm.temp_total_amount| currency : $ :2}}</td><td>{{vm.temp_paid_amount | currency : $ :2}}</td><td>\n{{vm.temp_due_amount | currency : $ :2}}</td><td></td><td></td></tr></tbody></table></div></div><div \nclass=\"simple-table-container mt-20\"><div class=\"ms-responsive-table-wrapper ph-20 pb-20 norecordFound\" \nng-show=\"vm.noResultFound && !vm.first\">No Result Found.</div></div></div></div></div>");
$templateCache.put("app/main/apps/reports/zero-daily-rate/zero-daily-rate.html","<div id=\"lodging-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" onscroll=\"vm.onScroll()\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-currency-usd\" \nclass=\"mr-10\"></md-icon><span>Zero Daily Report</span></div></div></div><div class=\"content\"><div \nclass=\"simple-table-container Housekeepingtable incomereport income-report-table\"><div class=\"table-title\">\nZero Daily Report.</div><div layout=\"row\" flex=\"100\" class=\"ph-10\" layout-wrap><div layout=\"column\" flex-gt-xs=\"25\" \nflex=\"100\" class=\"ph-10\"><md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label \nclass=\"ng-scope\" role=\"button\">Check-In</label><md-datepicker class=\"birthday-input1 no-padding\" \nng-model=\"vm.checkInDate\" md-open-on-focus ng-model-options=\"{debounce: 300}\" ng-change=\"vm.changeCheckDates()\">\n</md-datepicker></md-input-container></div><div layout=\"column\" flex-gt-xs=\"25\" flex=\"100\" class=\"ph-10\">\n<md-input-container class=\"md-block md-datepicker mb-0\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">\nCheck-Out</label><md-datepicker class=\"birthday-input1 no-padding\" ng-model=\"vm.checkOutDate\" \nmd-min-date=\"vm.checkInDate\" md-open-on-focus ng-model-options=\"{debounce: 300}\" ng-change=\"vm.changeCheckDates()\">\n</md-datepicker></md-input-container></div><div layout=\"column\" \nflex-gt-xs=\"{{ (isParent || vm.showReportFor) ? 25:33 }}\" flex=\"100\" class=\"ph-20\"><md-input-container><label>Channel\n</label><md-select ng-model=\"vm.selectedChannels\" multiple=\"multiple\"><md-optgroup label=\"Channels\"><md-option \nng-value=\"channel.channel_name\" ng-repeat=\"channel in vm.channels\">{{ channel.channel_name }}</md-option></md-optgroup>\n</md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" class=\"ph-10\" layout-wrap></div><div \nlayout=\"row\" flex=\"100\" class=\"ph-10\" layout-wrap><div layout=\"column\" flex-gt-xs=\"100\" flex=\"100\" class=\"ph-10\" \nlayout-align=\"start end\"><div class=\"logo\"><md-button class=\"md-raised md-cornered\" ng-click=\"vm.getIncomeReport()\" \nng-disabled=\"vm.requestProcessing || vm.disableRefresh\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_refresh_24px.svg\"></md-icon>Refresh<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessing\"></md-progress-circular>\n</md-button><md-button ng-if=\"vm.allData.length > 0\" class=\"md-raised md-cornered\" \nng-click=\"vm.downloadFileCustom(vm.reportType)\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/csv.svg\"></md-icon>Export as CSV</md-button><md-button \nng-if=\"vm.allData.length > 0\" class=\"md-raised md-cornered\" ng-click=\"vm.downloadFileCustom(vm.reportType,\'pdf\')\">\n<md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/pdf.svg\"></md-icon>Export as PDF</md-button><md-button \nng-if=\"vm.allData.length > 0\" class=\"md-raised md-cornered\" ng-click=\"vm.printRecords()\" \nng-disabled=\"vm.requestProcessingEmail\"><md-icon \nmd-svg-icon=\"assets/angular-material-assets/img/icons/ic_email_24px.svg\"></md-icon>Email Report<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.requestProcessingEmail\">\n</md-progress-circular></md-button></div></div></div><div id=\"table-container\" class=\"simple-table-container mt-20\" \nng-show=\"!vm.noResultFound\"><div class=\"ms-responsive-table-wrapper ph-20\" ng-init=\"rowCount = 1\"><table \nid=\"heightTable\" class=\"simple margin-border\" ng-show=\"vm.showTable\" style=\"position:relative\" ms-responsive-table=\"\">\n<thead><tr class=\"headerrow\"><td>Itinerary</td><td>Confirmation</td><td>Status</td><td>Checkin</td><td>Checkout</td>\n<td>Customer</td><td>Quantity</td><td>Item</td><td>Number of Nights</td><td>Source</td><td>Total Amount</td><td>\nPaid Amount</td><td>Remaining Amount</td></tr></thead><tbody id=\"tbodyHeight\" ng-style=\"vm.tableStyle\" ms-scroll \nstyle=\"position:relative\"><tr ng-repeat=\"(key, row) in vm.reservationList\"><td class=\"cursorPointer\" \nng-click=\"goToState(row.itinerary_number, row.confirmation_number, \'\')\">{{row.itinerary_number}}</td><td \nclass=\"cursorPointer\" ng-click=\"goToState(row.itinerary_number, row.confirmation_number, \'\')\">\n{{row.confirmation_number}}</td><td>{{row.room_stay_status}}</td><td>{{row.room_stay_from}}</td><td>\n{{row.room_stay_to}}</td><td>{{row.Customer}}</td><td>{{row.quantity}}</td><td>{{row.product_name}}</td><td>\n{{row.NoOfNights}}</td><td>{{row.source_of_creation}}</td><td>{{row.total_amount | currency : $ : 2}}</td><td>\n{{row.total_paid_amount | currency : $ : 2}}</td><td>{{row.total_remaining_amount | currency : $ : 2}}</td></tr>\n</tbody></table></div></div><div class=\"simple-table-container mt-20\"><div \nclass=\"ms-responsive-table-wrapper ph-20 pb-20 norecordFound\" ng-show=\"vm.noResultFound\">No Result Found</div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/restaurant/cooks/cook-dashboard.html","<style>@media screen and (max-width: 990px){\n		.full-height {\n	    height: 100% !important;\n	    overflow-y: auto;\n	}\n}\n</style><div id=\"tab-order\" class=\"page-layout simple tabbed md-datepicker full-height\" layout=\"column\"><div \nclass=\"header md-accent-bg relative-block\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><div layout=\"column\" flex=\"100\" layout-align=\"start start\"><div layout=\"row\" \nflex=\"100\" layout-align=\"start center\"><md-button class=\"goto-products-button md-icon-button\"><md-icon \nmd-font-icon=\"icon-cart-outline\"></md-icon></md-button><div class=\"h2\" layout=\"column\" layout-align=\"start start\">\nRestaurant Settings</div></div></div></div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\" \nclass=\"headerstickyProgress\"></md-progress-linear></div><md-content class=\"full-height screen-990\" \nstyle=\"overflow-y:auto\"><div class=\"outermasonay\"><div class=\"messanary-block\"><ms-masonry class=\"notes\" \noptions=\"{{vm.masonryOptions}}\"><ms-masonry-item class=\"cook-rowblock\" ng-repeat=\"order in vm.cookOrders\"><div \nlayout=\"column\" class=\"cookcolblock\"><div class=\"cookinnerblock\"><div class=\"topbar\"></div><div \nclass=\"middlesectioncook\"><div class=\"headingbar\">{{ order.confirmation_number }} <span>{{ order.minutes_ago }}</span>\n</div><div class=\"eatfoodblock\"><div class=\"eatfoodtxt\"><span class=\"spaneat\"><i \nng-class=\"order.restaurant_order_take_or_eat.toLowerCase() == \'eat in\' ? \'green\' : \'red\'\"></i>\n {{ order.restaurant_order_take_or_eat }}</span></div><div class=\"foodname\"><button \nng-if=\"order.restaurant_order_status ==\'orderPlaced\'\" \nng-click=\"vm.changeOrderStatus(order.restaurant_order_status, $index)\">Start</button> <button class=\"green\" \nng-if=\"order.restaurant_order_status ==\'started\'\" \nng-click=\"vm.changeOrderStatus(order.restaurant_order_status, $index)\">Ready</button> <button \nng-if=\"order.restaurant_order_status ==\'completed\'\" \nng-click=\"vm.changeOrderStatus(order.restaurant_order_status, $index)\">Completed</button> <span class=\"nameoffood\">\n{{ order.product_name }} </span><small>Ingredients</small><p>{{ order.restaurant_product_ingrediants }} <span \nng-if=\"order.restaurant_product_removed_ingrediants != \'\'\">,<strike>{{ order.restaurant_product_removed_ingrediants }}\n</strike></span></p><div class=\"cooks-table\"><small>Add-ons</small><table><tr ng-repeat=\"addon in order.add_ons\"><td>\n{{ addon.name }} ({{ addon.quantity }})</td><td \nng-if=\" order.product_name.toLowerCase().indexOf(\'pizza\') > -1 && addon.pizzaTypeSelected != \'\' \"><div \nclass=\"halfblock firsthalf\" ng-class=\"addon.pizzaTypeSelected == \'left\' ? \'active\' : \'\'\"><span></span></div><div \nclass=\"halfblock fullblock\" ng-class=\"addon.pizzaTypeSelected == \'full\' ? \'active\' : \'\'\"><span></span></div><div \nclass=\"halfblock sechalf\" ng-class=\"addon.pizzaTypeSelected == \'right\' ? \'active\' : \'\'\"><span></span></div></td><td \nng-if=\" order.product_name.toLowerCase().indexOf(\'pizza\') > -1 && addon.pizzaTypeSelected == \'\' \">--</td><td \nng-if=\"addon.cooking_preference == \'1\'\">{{ addon.cooking_type }}</td><td ng-if=\"addon.cooking_preference == \'0\'\">--\n</td></tr></table></div></div><div class=\"notes\"><p><b>Note:</b> <span ng-if=\"order.restaurant_product_note != \'\'\">\n{{ order.restaurant_product_note }} </span><span ng-if=\"order.restaurant_product_note == \'\'\">--</span></p></div></div>\n</div><div class=\"bottombar\"></div></div></div></ms-masonry-item></ms-masonry></div></div></md-content></div>");
$templateCache.put("app/main/apps/restaurant/orderDetail/restaurant-detail.html","<div id=\"tab-order\" class=\"page-layout simple tabbed md-datepicker full-height\" layout=\"column\"><div \nclass=\"header md-accent-bg relative-block\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><div layout=\"column\" flex=\"100\" layout-align=\"start start\"><div layout=\"row\" \nflex=\"100\" layout-align=\"start center\"><md-button class=\"goto-products-button md-icon-button\"><md-icon \nmd-font-icon=\"icon-cart-outline\"></md-icon></md-button><div class=\"h2\" layout=\"column\" layout-align=\"start start\">\nRestaurant Settings</div></div></div></div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\" \nclass=\"headerstickyProgress\"></md-progress-linear></div><md-content class=\"full-height\"><div \nclass=\"full-width full-height\" layout=\"row\" flex=\"100\" layout-wrap><div class=\"Restaurant-detail-col\" layout=\"column\" \nflex=\"100\"><div class=\"Restaurant-repeat-block\"><div class=\"Restaurant-outer-col1\"><div \nclass=\"Restaurant-billing-info\"><div class=\"Restaurant-billing heading\">Billing information</div><div \nclass=\"Restaurant-items-billing\"><div class=\"Restaurant-billing-row\"><div class=\"Restaurant-billing-col\"><small>\nGuest Pos</small><p>#23232</p></div><div class=\"Restaurant-billing-col\"><small>Address</small><p>#23232 steve hunt Road\n</p></div><div class=\"Restaurant-billing-col\"><small>city</small><p>key largo</p></div><div \nclass=\"Restaurant-billing-col\"><small>State</small><p>Florida</p></div><div class=\"Restaurant-billing-col\"><small>\nCountry</small><p>United State</p></div><div class=\"Restaurant-billing-col\"><small>Seconday phone</small><p \nclass=\"blue\">305-394-0611</p></div><div class=\"Restaurant-billing-col\"><small>phone</small><p>305-394-0611</p></div>\n<div class=\"Restaurant-billing-col\"><small>zip code</small><p>33037</p></div><div class=\"Restaurant-billing-col\">\n<small>Email</small><p>guest@gmail.com</p></div></div></div></div></div><div class=\"Restaurant-outer-col1\"><div \nclass=\"top-block-res\"><div class=\"heading-food\"><span>Seafood Ceviche</span><div class=\"seafood_price\">\n<md-input-container><md-select ng-model=\"opt\"><md-option ng-value=\"opt\" ng-repeat=\"opt in neighborhoods2\">Active\n</md-option></md-select></md-input-container><span>$5.00</span></div></div><div class=\"tags-seafood\"><span>Red onion <i\n class=\"icon-check icon-check\"></i> </span><span>Serrano <i class=\"icon-check icon-check\"></i> </span><span>Key citrus \n<i class=\"icon-check icon-check\"></i></span></div><div class=\"quentityblock\"><span>Qty: <b>1</b> </span><span>\nDressing: <b>Asian Dressing</b></span></div></div><div class=\"middle-block-res\"><div class=\"Restaurant-table-block\" \nlayout=\"row\" layout-wrap flex><div class=\"Restaurant-col-block heading extra\" layout=\"column\">Extras</div><div \nclass=\"Restaurant-col-block heading peritem\" layout=\"column\">Per item</div><div \nclass=\"Restaurant-col-block heading qty\" layout=\"column\">Qty</div><div class=\"Restaurant-col-block heading subtotal\" \nlayout=\"column\">Subtotal</div></div><div class=\"Restaurant-table-block\" layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"Restaurant-col-block extra\" layout=\"column\">Bacon</div><div class=\"Restaurant-col-block peritem\" \nlayout=\"column\">$6.00</div><div class=\"Restaurant-col-block qty\" layout=\"column\">2</div><div \nclass=\"Restaurant-col-block subtotal\" layout=\"column\">$12.00</div></div><div class=\"Restaurant-table-block\" \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"Restaurant-col-block extra\" layout=\"column\">Pepperion</div><div \nclass=\"Restaurant-col-block peritem\" layout=\"column\">$6.00</div><div class=\"Restaurant-col-block qty\" layout=\"column\">2\n</div><div class=\"Restaurant-col-block subtotal\" layout=\"column\">$12.00</div></div><div class=\"Restaurant-table-block\" \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"Restaurant-col-block extra\" layout=\"column\">Suasag</div><div \nclass=\"Restaurant-col-block peritem\" layout=\"column\">$6.00</div><div class=\"Restaurant-col-block qty\" layout=\"column\">2\n</div><div class=\"Restaurant-col-block subtotal\" layout=\"column\">$12.00</div></div></div><div \nclass=\"middle-block-footer\"><div class=\"note-block-outer\" layout=\"row\" flex=\"100\" layout-align=\"start stretch\"><div \nclass=\"note-block\" layout=\"column\" layout-align=\"start start\"><p><b>Note</b>\n Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when ...\n</p></div><div class=\"total-block\" layout=\"column\"><div layout=\"row\" flex=\"100\" class=\"res-total\"><span \nlayout=\"column\" flex=\"50\">Discount</span> <span layout=\"column\" flex=\"50\" layout-align=\"end end\">$5.00</span></div><div\n layout=\"row\" flex=\"100\" class=\"res-total total-bold\"><span layout=\"column\" flex=\"50\">Total</span> <span \nlayout=\"column\" flex=\"50\" layout-align=\"end end\">$35.00</span></div></div></div></div></div><div \nclass=\"Restaurant-outer-col1\"><div class=\"top-block-res\"><div class=\"heading-food\"><span>Payment Information</span>\n</div><div class=\"paymenttable\">data Table here</div></div><div class=\"payment-method-pos\" layout=\"row\" flex=\"100\" \nlayout-wrap><div class=\"payment-method-left\" layout=\"column\"><div class=\"heading-food\"><span>Payment Methgod</span>\n</div><div class=\"payment-methodblock\"><md-input-container class=\"md-block mb-0 md-input-has-value no-margin\" \nlayout=\"column\" flex=\"100\" flex-gt-md=\"80\" flex-gt-sm=\"60\" layout-align=\"center \"><md-radio-group class=\"\" \nng-model=\"vm.payment_method.payment_method\" required layout=\"row\" flex=\"100\" layout-wrap><md-radio-button \nlayout=\"column\" flex=\"50\" flex-gt-md=\"25\" flex-gt-xs=\"50\" layout-align=\"center \" \nclass=\"space-block-inline margin-right-0\">Credit Card</md-radio-button><md-radio-button layout=\"column\" flex=\"50\" \nflex-gt-md=\"25\" flex-gt-xs=\"50\" layout-align=\"center \" class=\"space-block-inline margin-right-0\">Cash</md-radio-button>\n<md-radio-button layout=\"column\" flex=\"50\" flex-gt-md=\"25\" flex-gt-xs=\"50\" layout-align=\"center \" \nclass=\"space-block-inline margin-right-0\">Check</md-radio-button></md-radio-group></md-input-container></div></div><div\n class=\"payment-method-right\" layout=\"column\"><div class=\"total-block\" layout=\"column\"><div layout=\"row\" flex=\"100\" \nclass=\"res-total\"><span layout=\"column\" flex=\"33\">Subtotal</span> <span layout=\"column\" flex=\"33\" \nlayout-align=\"center center\">:</span> <span layout=\"column\" flex=\"33\" layout-align=\"end end\">$5.00</span></div><div \nlayout=\"row\" flex=\"100\" class=\"res-total\"><span layout=\"column\" flex=\"33\">Discount</span> <span layout=\"column\" \nflex=\"33\" layout-align=\"center center\">:</span> <span layout=\"column\" flex=\"33\" layout-align=\"end end\">(0:00)</span>\n</div><div layout=\"row\" flex=\"100\" class=\"res-total\"><span layout=\"column\" flex=\"33\">Sales Tax</span> <span \nlayout=\"column\" flex=\"33\" layout-align=\"center center\">:</span> <span layout=\"column\" flex=\"33\" layout-align=\"end end\">\n$5.00</span></div><div layout=\"row\" flex=\"100\" class=\"res-total\"><span layout=\"column\" flex=\"33\">Grand Total</span> \n<span layout=\"column\" flex=\"33\" layout-align=\"center center\">:</span> <span layout=\"column\" flex=\"33\" \nlayout-align=\"end end\">(0:00)</span></div><div layout=\"row\" flex=\"100\" class=\"res-total\"><span layout=\"column\" \nflex=\"33\">Paid Amount</span> <span layout=\"column\" flex=\"33\" layout-align=\"center center\">:</span> <span \nlayout=\"column\" flex=\"33\" layout-align=\"end end\">(0:00)</span></div><div layout=\"row\" flex=\"100\" class=\"res-total\">\n<span layout=\"column\" flex=\"33\" class=\"blue\">Remaining Amount</span> <span layout=\"column\" flex=\"33\" \nlayout-align=\"center center\">:</span> <span layout=\"column\" flex=\"33\" layout-align=\"end end\">(0:00)</span></div></div>\n</div></div></div></div></div></div></md-content></div>");
$templateCache.put("app/main/apps/restaurant/settings/restaurant-settings.html","<div id=\"tab-order\" class=\"page-layout simple tabbed md-datepicker full-height\" layout=\"column\"><div \nclass=\"header md-accent-bg relative-block\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><div layout=\"column\" flex=\"100\" layout-align=\"start start\"><div layout=\"row\" \nflex=\"100\" layout-align=\"start center\"><md-button class=\"goto-products-button md-icon-button\"><md-icon \nmd-font-icon=\"icon-cart-outline\"></md-icon></md-button><div class=\"h2\" layout=\"column\" layout-align=\"start start\">\nRestaurant Settings</div></div></div></div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\" \nclass=\"headerstickyProgress\"></md-progress-linear></div><md-content class=\"full-height\"><div \nclass=\"full-width full-height\" layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"55\" \nclass=\"category-res\" layout-align=\"start start\"><div class=\"category_res_outersection\"><div layout=\"row\" flex=\"100\" \nclass=\"outerrowblock\" layout-align=\"start start\"><div layout=\"column\" flex=\"100\" class=\"heading_res\"><div \nclass=\"category_res_heading\"><span>Categories</span><div class=\"searchblockresouter\"><div class=\"searchblockres\"><input\n type=\"search\" ng-model=\"vm.search\" ng-change=\"vm.searchFilterSettingsList()\" placeholder=\"Search\" \nng-model-options=\"{debounce: 400}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></div><md-button class=\"btn1\" \nng-click=\"vm.addEditDialog(0)\"><i class=\"icon-plus icon-plus-main\"></i> Add</md-button></div></div></div></div><div \nclass=\"res_middel_dection\" layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"100\" class=\"res-contentsection\"><div \nclass=\"res-repeatbox\"><div class=\"res-list-row\" layout=\"row\" flex=\"100\" layout-align=\"start center\" \nng-repeat=\"(key, value) in vm.settingsList\" ng-class=\"vm.activeIndex == key ? \'active\':\'\'\"><div \nclass=\"res-list-leftcol\" layout=\"column\" layout-align=\"start start\" ng-click=\"vm.showSubItems($index, value.field_id)\">\n{{value.field_name}}</div><div class=\"res-list-rightcol\" layout=\"column\" layout-align=\"end end\"><div \nclass=\"iconblockres\"><i class=\"icon-pencil icon-pencil-main\" ng-click=\"vm.addEditDialog(value.field_id)\"></i> <i \nclass=\"icon-close-circle-outline icon-close-circle-outline\" ng-click=\"vm.deleteOrder(value.field_id)\"></i></div></div>\n</div><div class=\"box-repeatorder\" ng-if=\"vm.settingsList.length == 0\"><div class=\"side-overflow-block\"><div \nclass=\"pos-dateblk\" style=\"text-align:center\">No Result(s) Found</div></div></div></div></div></div><div \nclass=\"footer_res-block\" layout=\"row\" flex=\"100\" layout-align=\"start center\"><div layout=\"column\" flex=\"100\" \nclass=\"res-contentsection\"><div class=\"pagination main-paination\" ng-if=\"vm.settingsList.length > 0\"><p \nclass=\"row-per-page\" translate=\"TODO.ROWS_PER_PAGE\">Rows Per Page :</p><md-select ng-model=\"vm.limit\" \nng-change=\"vm.searchFilterSettingsList()\" placeholder=\"No. of data\" class=\"select-main11 mv-0\"><md-option \nng-value=\"10\">10</md-option><md-option ng-value=\"20\">20</md-option><md-option ng-value=\"50\">50</md-option></md-select>\n<p class=\"row-per-page pagesof\">\n{{ ((vm.curPage*vm.limit)-(vm.limit-1))+\'-\'+ (vm.settingsList.length + ((vm.curPage*vm.limit)-(vm.limit))) }} of {{vm.settingsListCount}}\n</p><div class=\"pagination-custom-block\"><a href=\"#\" ng-click=\"vm.changePage(vm.curPage, \'pre\')\"><ng-md-icon \nicon=\"keyboard_arrow_left\" size=\"24\" class=\"ng-scope\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" \nwidth=\"24\" height=\"24\"><path d=\"M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z\"></path></svg></ng-md-icon></a><a \nhref=\"#\" ng-click=\"vm.changePage(vm.curPage, \'next\')\"><ng-md-icon icon=\"keyboard_arrow_right\" size=\"24\" \nclass=\"ng-scope\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path \nd=\"M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z\"></path></svg></ng-md-icon></a></div></div></div></div></div></div>\n<div layout=\"column\" flex=\"100\" flex-gt-sm=\"45\" class=\"toppings\"><div class=\"topping_res_outersection\" \nng-if=\"vm.activeIndex != -1\"><div layout=\"row\" flex=\"100\" class=\"outerrowblock\" layout-align=\"start start\"><div \nlayout=\"column\" flex=\"100\" class=\"heading_res\"><div class=\"category_res_heading\"><span>\n{{vm.settingsList[vm.activeIndex].field_name}} Details</span><md-button class=\"btn1\" ng-click=\"vm.addSubItem()\"><i \nclass=\"icon-plus icon-plus-main\"></i> Add</md-button></div></div></div><div class=\"res_middel_dection\" layout=\"row\" \nflex=\"100\"><div layout=\"column\" flex=\"100\" class=\"res-contentsection\"><div class=\"res-repeatbox\"><div \nclass=\"res-list-row\" layout=\"row\" flex=\"100\" layout-align=\"start center\"><div class=\"res-list-leftcol\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"iconblockres\"><p>Name</p></div></div><div class=\"res-list-centercol\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"iconblockres\" ng-show=\"vm.showCostField\"><p>Price</p></div>\n</div><div class=\"res-list-centerseccol\" layout=\"column\" layout-align=\"center center\"><div class=\"iconblockres\"><p>\nCooking<br>Preference</p></div></div><div class=\"res-list-rightcol\" layout=\"column\" layout-align=\"end end\"><div \nclass=\"iconblockres\"></div></div><input type=\"hidden\" ng-model=\"vm.subItems[\'optionId_\'+ value]\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></div><div class=\"res-list-row\" layout=\"row\" flex=\"100\" \nlayout-align=\"start center\" ng-repeat=\"value in vm.subItemsIncArray\"><div class=\"res-list-leftcol\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"iconblockres\"><md-input-container><input name=\"name\" type=\"text\" \nng-model=\"vm.subItems[\'name_\'+ value]\" required ng-change=\"vm.saveSubItemAdded(\'name\', value)\" \nng-model-options=\"{debounce: 600}\" placeholder=\"name\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div \nng-if=\"vm.showSubItemError[\'error_\'+value]\" class=\"errortxt\">Name already exists. Result not updated</div>\n</md-input-container></div></div><div class=\"res-list-centercol\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"iconblockres\"><md-input-container ng-if=\"vm.showCostField\"><input name=\"cost\" \nng-model=\"vm.subItems[\'cost_\'+ value]\" required ng-change=\"vm.saveSubItemAdded(\'cost\', value)\" \nng-model-options=\"{debounce: 600}\" placeholder=\"Price\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div></div><div class=\"res-list-centerseccol\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"iconblockres\"><md-checkbox class=\"mb-0\" ng-model=\"vm.subItems[\'cook_pref_\'+ value]\" \nng-change=\"vm.saveSubItemAdded(\'cook_pref\', value)\" ng-checked=\"vm.subItems[\'cook_pref_\'+ value] == \'1\'\"></md-checkbox>\n</div></div><div class=\"res-list-rightcol\" layout=\"column\" layout-align=\"end end\"><div class=\"iconblockres\"><i \nclass=\"icon-close-circle-outline icon-close-circle-outline\" ng-click=\"vm.deleteSubItem(value)\"></i></div></div><input \ntype=\"hidden\" ng-model=\"vm.subItems[\'optionId_\'+ value]\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></div></div>\n</div></div></div></div></div></md-content></div>");
$templateCache.put("app/main/apps/settings/dailyRentals/dailyRentals.html","<div id=\"daily-rentals-setting\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"logo logo-text white-fg\" layout=\"row\" layout-align=\"start center\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><span translate=\"DAILY_RENTALS.TITLE\" class=\"general-text\"></span></div></div></div><div>\n<md-button class=\"md-raised md-background\" ng-class=\"{\'md-blue-grey-A100-bg\': vm.isloading}\" \nng-disabled=\"vm.isloading\" ng-click=\"vm.saveSettings()\"><span translate=\"DAILY_RENTALS.SAVE\"></span></md-button></div>\n</div><div class=\"content\" style=\"padding: 0px !important\"><div class=\"main sm-hearder-top\" ms-scroll>\n<md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><form name=\"dailyRentalsForm\" \nclass=\"daily-rentals-settings-form white-scroll md-inline-form\" novalidate><div \nclass=\"daily-rentals-panel daily-rentals-toggle-panel\" ng-click=\"vm.toggleEnabled()\" role=\"button\" tabindex=\"0\" \nng-keypress=\"vm.onToggleKeypress($event)\" aria-pressed=\"{{vm.enabled}}\"><div class=\"daily-rentals-panel-top\" \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-between center\"><div class=\"daily-rentals-panel-heading\" flex>\n<h3 class=\"daily-rentals-panel-title\" translate=\"DAILY_RENTALS.CONFIG_TOGGLE_TITLE\"></h3><p \nclass=\"daily-rentals-panel-description\" translate=\"DAILY_RENTALS.CONFIG_TOGGLE_DESC\"></p></div><div \nclass=\"daily-rentals-panel-toggle\" layout=\"row\" layout-align=\"end center\"><span class=\"daily-rentals-toggle-label\" \ntranslate=\"DAILY_RENTALS.ENABLE_LABEL\"></span><md-switch class=\"no-margin daily-rentals-switch\" ng-model=\"vm.enabled\" \nng-click=\"$event.stopPropagation()\" aria-label=\"Enable daily rentals\"></md-switch></div></div></div><div \nclass=\"daily-rentals-panel\" ng-if=\"vm.enabled\"><div class=\"daily-rentals-panel-heading\"><h3 \nclass=\"daily-rentals-panel-title\" translate=\"DAILY_RENTALS.TIMES_TITLE\"></h3><p \nclass=\"daily-rentals-panel-description\" translate=\"DAILY_RENTALS.TIMES_DESC\"></p></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"DAILY_RENTALS.CHECKIN\"></label><md-select ng-model=\"vm.checkin\" aria-label=\"Daily rentals check-in time\">\n<md-option ng-repeat=\"time in vm.checkinOptions\" ng-value=\"time.value\">{{time.label}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"DAILY_RENTALS.CHECKOUT\"></label>\n<md-select ng-model=\"vm.checkout\" aria-label=\"Daily rentals check-out time\"><md-option \nng-repeat=\"time in vm.checkoutOptions\" ng-value=\"time.value\">{{time.label}}</md-option></md-select>\n</md-input-container></div></div></form></div></div></div>");
$templateCache.put("app/main/apps/settings/general/general.html","<div id=\"general-setting\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"logo logo-text white-fg\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"s24\"></md-icon></span><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"GENERAL.ORGANIZATIONS\" class=\"general-text\"></span></div></div></div></div><div class=\"content\"><div \nclass=\"main sm-hearder-top\" ms-scroll><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><div class=\"white-bg md-whiteframe-4dp white-scroll\" layout-align=\"center center\" layout-padding>\n<form name=\"generalSettingsForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start\" flex ng-if=\"isParent\"><md-input-container class=\"padding-left-10 padding-right-10 mb-10\" \nlayout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\"><label class=\"margin-left-10\" translate=\"GENERAL.SCOPE\"></label>\n<md-select ng-model=\"dynamicwebsite\" ng-change=\"vm.changedValue(dynamicwebsite)\" id=\"organizations_select\"><md-option \nng-value=\"vm.parentSettings.hotel_id\" ng-selected=\"{{vm.parentSettings.hotel_id == vm.hotel_id}}\">\n{{vm.parentSettings.hotelname}}</md-option><md-option ng-value=\"website.hotel_id\" \nng-selected=\"{{website.hotel_id == vm.hotel_id}}\" ng-repeat=\"website in subHotels | filter:searchTerm\">\n{{website.hotel_title}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex><md-input-container \nclass=\"time-zone-contianer general-time-zone md-input-has-value padding-left-10 padding-right-10 mb-0\" \nlayout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\" \nng-style=\"vm.showSettings.hotel_id != 1 && vm.showSettings.timezoneusedefault ? {\'pointer-events\':\'none\'} : \'\'\"><label \nclass=\"margin-left-10\" translate=\"GENERAL.TIMEZONE\"></label><time-zone-directive></time-zone-directive><div \nclass=\"md-errors-spacer\"></div></md-input-container><div \nclass=\"time-zone-contianer md-input-has-value padding-left-10 padding-right-10 mb-10\" layout-align=\"start\" flex=\"100\" \nflex-gt-xs=\"50\"><div ng-if=\"vm.showSettings.hotel_id != 1\" layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox \nclass=\"mt-0\" ng-change=\"vm.saveCheck(vm.showSettings.timezoneusedefault)\" \nng-model=\"vm.showSettings.timezoneusedefault\" aria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}\n</md-checkbox></div></div></div></div><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex=\"100\">\n<md-input-container class=\"padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\" flex>\n<label class=\"margin-left-10\" translate=\"GENERAL.SITE_URL\"></label><input \nng-change=\"vm.saveGeneral(vm.showSettings.siteurl)\" ng-model-options=\"{debounce: 500}\" required name=\"siteurl\" \nng-model=\"vm.showSettings.siteurl\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff || (vm.showSettings.hotel_id != 1 && vm.showSettings.siteurlusedefault)\">\n</md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\" \nflex><div ng-if=\"vm.showSettings.hotel_id != 1\"><div flex=\"100\"><md-checkbox class=\"mt-0\" \nng-change=\"vm.saveCheck(vm.showSettings.siteurlusedefault)\" ng-model=\"vm.showSettings.siteurlusedefault\" \naria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}</md-checkbox></div></div></div></div><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex=\"100\"><md-input-container \nclass=\"padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\" flex><label \nclass=\"margin-left-10\" translate=\"GENERAL.HOTEL_NAME\"></label><input \nng-change=\"vm.saveGeneral(vm.showSettings.hotelname)\" ng-model-options=\"{debounce: 500}\" required name=\"hotelname\" \nng-model=\"vm.showSettings.hotelname\" \nng-readonly=\"vm.autoFillOff ||( vm.showSettings.hotel_id != 1 && vm.showSettings.hotelnameusedefault)\" \nautocomplete=\"off\"></md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" \nflex-gt-xs=\"50\" flex><div ng-if=\"vm.showSettings.hotel_id != 1\"><div flex=\"100\"><md-checkbox class=\"mt-0\" \nng-change=\"vm.saveCheck(vm.showSettings.hotelnameusedefault)\" ng-model=\"vm.showSettings.hotelnameusedefault\" \naria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}</md-checkbox></div></div></div></div><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex><md-input-container \nclass=\"padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\"><label \nclass=\"margin-left-10\" translate=\"GENERAL.ADMIN_EMAIL\"></label><input \nng-change=\"vm.saveGeneral(vm.showSettings.adminemail)\" ng-model-options=\"{debounce: 500}\" required name=\"adminemail\" \nng-model=\"vm.showSettings.adminemail\" \nng-readonly=\"vm.autoFillOff || (vm.showSettings.hotel_id != 1 && vm.showSettings.adminemailusedefault)\" \nautocomplete=\"off\"></md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" \nflex-gt-xs=\"50\"><div ng-if=\"vm.showSettings.hotel_id != 1\" layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox \nclass=\"mt-0\" ng-change=\"vm.saveCheck(vm.showSettings.adminemailusedefault)\" \nng-model=\"vm.showSettings.adminemailusedefault\" aria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}\n</md-checkbox></div></div></div></div><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex>\n<md-input-container class=\"padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\">\n<label class=\"margin-left-10\" translate=\"GENERAL.ADMIN_ADDRESS\"></label><input \nng-change=\"vm.saveGeneral(vm.showSettings.address)\" ng-model-options=\"{debounce: 500}\" required name=\"address\" \nng-model=\"vm.showSettings.address\" \nng-readonly=\"vm.autoFillOff || (vm.showSettings.hotel_id != 1 && vm.showSettings.addressusedefault)\" \nautocomplete=\"off\"></md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" \nflex-gt-xs=\"50\"><div ng-if=\"vm.showSettings.hotel_id != 1\" layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox \nclass=\"mt-0\" ng-change=\"vm.saveCheck(vm.showSettings.addressusedefault)\" ng-model=\"vm.showSettings.addressusedefault\" \naria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}</md-checkbox></div></div></div></div><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex><md-input-container \nclass=\"padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\"><label \nclass=\"margin-left-10\" translate=\"GENERAL.ADMIN_CONTACT\"></label><input \nng-change=\"vm.saveGeneral(vm.showSettings.phone)\" ng-model-options=\"{debounce: 500}\" required name=\"phone\" \nng-model=\"vm.showSettings.phone\" \nng-readonly=\"vm.autoFillOff ||( vm.showSettings.hotel_id != 1 && vm.showSettings.phoneusedefault)\" autocomplete=\"off\">\n</md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\"><div\n ng-if=\"vm.showSettings.hotel_id != 1\" layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox class=\"mt-0\" \nng-change=\"vm.saveCheck(vm.showSettings.phoneusedefault)\" ng-model=\"vm.showSettings.phoneusedefault\" \naria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}</md-checkbox></div></div></div></div><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex><md-input-container \nclass=\"padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\"><label \nclass=\"margin-left-10\" translate=\"GENERAL.ADMIN_FAX\"></label><input ng-change=\"vm.saveGeneral(vm.showSettings.fax)\" \nng-model-options=\"{debounce: 500}\" required name=\"fax\" ng-model=\"vm.showSettings.fax\" \nng-readonly=\"vm.autoFillOff || (vm.showSettings.hotel_id != 1 && vm.showSettings.faxusedefault)\" autocomplete=\"off\">\n</md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\"><div\n ng-if=\"vm.showSettings.hotel_id != 1\" layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox class=\"mt-0\" \nng-change=\"vm.saveCheck(vm.showSettings.faxusedefault)\" ng-model=\"vm.showSettings.faxusedefault\" \naria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}</md-checkbox></div></div></div></div><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex><md-input-container \nclass=\"md-input-has-value padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\" \nng-style=\"vm.showSettings.hotel_id != 1 && vm.showSettings.sendcustomeremailusedefault ? {\'pointer-events\':\'none\'} : \'\'\">\n<label class=\"margin-left-10\" translate=\"GENERAL.NEW_CUSTOMER_EMAIL\"></label><md-radio-group \nng-model=\"vm.showSettings.sendcustomeremail\" ng-change=\"vm.saveGeneral(vm.showSettings.sendcustomeremail)\" \nng-model-options=\"{debounce: 500}\"><md-radio-button class=\"margin-left-0\" value=\"1\">Yes</md-radio-button>\n<md-radio-button class=\"margin-left-20\" value=\"0\">No</md-radio-button></md-radio-group><div class=\"md-errors-spacer\">\n</div></md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" \nflex-gt-xs=\"50\"><div ng-if=\"vm.showSettings.hotel_id != 1\" layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox \nclass=\"mt-0\" ng-change=\"vm.saveCheck(vm.showSettings.sendcustomeremailusedefault)\" \nng-model=\"vm.showSettings.sendcustomeremailusedefault\" aria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}\n</md-checkbox></div></div></div></div><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex>\n<md-input-container class=\"padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\">\n<label class=\"margin-left-10\" translate=\"GENERAL.ORGANIZATION_PREFIX\"></label><input \nng-change=\"vm.saveGeneral(vm.showSettings.orgprefix)\" ng-model-options=\"{debounce: 500}\" required name=\"orgprefix\" \nng-model=\"vm.showSettings.orgprefix\" \nng-readonly=\"vm.autoFillOff || (vm.showSettings.hotel_id != 1 && vm.showSettings.orgprefixusedefault)\" \nautocomplete=\"off\"></md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" \nflex-gt-xs=\"50\"><div ng-if=\"vm.showSettings.hotel_id != 1\" layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox \nclass=\"mt-0 margin-top-0-blk\" ng-change=\"vm.saveCheck(vm.showSettings.orgprefixusedefault)\" \nng-model=\"vm.showSettings.orgprefixusedefault\" aria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}\n</md-checkbox></div></div></div><input type=\"hidden\" ng-model=\"vm.showSettings.setting_type\" value=\"general\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></div><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" \nflex><md-input-container class=\"padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\">\n<label class=\"margin-left-10\" translate=\"GENERAL.HOTEL_OWNER\"></label><input \nng-change=\"vm.saveGeneral(vm.showSettings.hotelowner)\" ng-model-options=\"{debounce: 500}\" required name=\"hotelowner\" \nng-model=\"vm.showSettings.hotelowner\" \nng-readonly=\"vm.autoFillOff || (vm.showSettings.hotel_id != 1 && vm.showSettings.hotelownerusedefault)\" \nautocomplete=\"off\"></md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" \nflex-gt-xs=\"50\"><div ng-if=\"vm.showSettings.hotel_id != 1\" layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox \nclass=\"mt-0 margin-top-0-blk\" ng-change=\"vm.saveCheck(vm.showSettings.hotelownerusedefault)\" \nng-model=\"vm.showSettings.hotelownerusedefault\" aria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}\n</md-checkbox></div></div></div><input type=\"hidden\" ng-model=\"vm.showSettings.setting_type\" value=\"general\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></div><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" \nflex><md-input-container class=\"padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\">\n<label class=\"margin-left-10\" translate=\"GENERAL.CAPTCHA_SECRET\"></label><input \nng-change=\"vm.saveGeneral(vm.showSettings.captchasecret)\" ng-model-options=\"{debounce: 500}\" required \nname=\"captchasecret\" ng-model=\"vm.showSettings.captchasecret\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff || (vm.showSettings.hotel_id != 1 && vm.showSettings.captchasecretusedefault)\">\n</md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\"><div\n ng-if=\"vm.showSettings.hotel_id != 1\" layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox \nclass=\"mt-0 margin-top-0-blk\" ng-change=\"vm.saveCheck(vm.showSettings.captchasecretusedefault)\" \nng-model=\"vm.showSettings.captchasecretusedefault\" aria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}\n</md-checkbox></div></div></div></div><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex>\n<md-input-container class=\"padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\">\n<label class=\"margin-left-10\" translate=\"GENERAL.RATE_CAL\"></label><input \nng-change=\"vm.saveGeneral(vm.showSettings.daysratecalender)\" ng-model-options=\"{debounce: 500}\" required \nname=\"daysratecalender\" ng-model=\"vm.showSettings.daysratecalender\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff ||(vm.showSettings.hotel_id != 1 && vm.showSettings.daysratecalenderusedefault)\">\n</md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\"><div\n ng-if=\"vm.showSettings.hotel_id != 1\" layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox \nclass=\"mt-0 margin-top-0-blk\" ng-change=\"vm.saveCheck(vm.showSettings.daysratecalenderusedefault)\" \nng-model=\"vm.showSettings.daysratecalenderusedefault\" aria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}\n</md-checkbox></div></div></div></div><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex>\n<md-input-container class=\"padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\">\n<label class=\"margin-left-10\" translate=\"GENERAL.LIGHT_CLEAN\"></label><input \nng-change=\"vm.saveGeneral(vm.showSettings.dayslightclean)\" ng-model-options=\"{debounce: 500}\" required \nname=\"dayslightclean\" ng-model=\"vm.showSettings.dayslightclean\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff || (vm.showSettings.hotel_id != 1 && vm.showSettings.dayslightcleanusedefault)\">\n</md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\"><div\n ng-if=\"vm.showSettings.hotel_id != 1\" layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox \nclass=\"mt-0 margin-top-0-blk\" ng-change=\"vm.saveCheck(vm.showSettings.dayslightcleanusedefault)\" \nng-model=\"vm.showSettings.dayslightcleanusedefault\" aria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}\n</md-checkbox></div></div></div></div><div layout=\"row\" layout-align=\"start\" flex=\"100\" layout-wrap><div class=\"ph-10\" \nlayout=\"column\" flex=\"50\" flex-xs=\"100\"><div class=\"central-logo-block mb-20\"><label \nclass=\"full-width width-float pb-20\" translate=\"GENERAL.LOGO\"></label><md-input-container \nclass=\"overflow-hidden md-block tax-inputs-img-uploade image-container no-margin full-width\"><img \nngf-src=\"vm.showSettings.logo\" ng-show=\"vm.showSettings.logo\"> <img ngf-src=\"vm.previousPicture\" \nng-show=\"vm.imageStatus\"><choose-file class=\"md-fab md-mini full-row-block md-profile-icon-1\" flex-gt-xs=\"100\" \nlayout=\"row\" layout-align=\"start start\" flex><input id=\"pictures\" type=\"file\" name=\"pictures\" \nngf-select=\"vm.upload($file, $invalidFiles,\'logo\')\" ng-model=\"vm.showSettings.logo\" accept=\"image/*\" class=\"ng-hide\" \nngf-pattern=\"\'.jpg,.jpeg,.png,.gif\'\" ngf-accept=\"\'.jpg,.jpeg,.png,.gif\'\" ngf-max-size=\"10MB\"><div \nclass=\"inline-block-txt\" layout=\"row\" layout-align=\"start start\" flex-gt-xs=\"8\"><md-button id=\"uploadButton\" \nclass=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-upload\" class=\"white-fg\"></md-icon></md-button></div>\n<md-input-container flex class=\"md-block inline-block-txt\" flex-gt-xs=\"92\"><div class=\"hint\"></div>\n</md-input-container></choose-file></md-input-container></div></div><div class=\"ph-10\" layout=\"column\" flex=\"50\" \nflex-xs=\"50\"><div class=\"\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"100\"><div ng-if=\"vm.showSettings.hotel_id != 1\" \nlayout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox class=\"mt-0 margin-top-0-blk\" \nng-change=\"vm.saveCheck(vm.showSettings.logousedefault)\" ng-model=\"vm.showSettings.logousedefault\" \naria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}</md-checkbox></div></div></div></div></div><div \nlayout=\"row\" layout-align=\"start\" flex=\"100\" layout-wrap><div class=\"ph-10\" layout=\"column\" flex=\"50\" flex-xs=\"100\">\n<div class=\"central-logo-block fabicon mb-20\"><label class=\"full-width width-float pb-20\" translate=\"GENERAL.FAV\">\n</label><md-input-container class=\"overflow-hidden md-block tax-inputs-img-uploade image-container no-margin\"><img \nngf-src=\"vm.showSettings.favicon\" ng-show=\"vm.showSettings.favicon\"> <img ngf-src=\"vm.previousfavicon\" \nng-show=\"vm.imageStatus\"><choose-file class=\"md-fab md-mini full-row-block md-profile-icon-1\" flex-gt-xs=\"100\" \nlayout=\"row\" layout-align=\"start start\" flex><input id=\"pictures\" type=\"file\" name=\"pictures\" \nngf-select=\"vm.upload($file, $invalidFiles,\'fav\')\" ng-model=\"vm.showSettings.favicon\" accept=\"image/*\" class=\"ng-hide\" \nngf-pattern=\"\'.jpg,.jpeg,.png,.gif,.ico\'\" ngf-accept=\"\'.jpg,.jpeg,.png,.gif,.ico\'\" ngf-max-size=\"10MB\"><div \nclass=\"inline-block-txt\" layout=\"row\" layout-align=\"start start\" flex-gt-xs=\"8\"><md-button id=\"uploadButton\" \nclass=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-upload\" class=\"white-fg\"></md-icon></md-button></div>\n<md-input-container flex class=\"md-block inline-block-txt\" flex-gt-xs=\"92\"><div class=\"hint\"></div>\n</md-input-container></choose-file></md-input-container></div></div><div class=\"ph-10\" layout=\"column\" flex=\"50\" \nflex-xs=\"100\"><div ng-if=\"vm.showSettings.hotel_id != 1\" layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox \nclass=\"mt-0 margin-top-0-blk\" ng-change=\"vm.saveCheck(vm.showSettings.faviconusedefault)\" \nng-model=\"vm.showSettings.faviconusedefault\" aria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}\n</md-checkbox></div></div></div></div><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex=\"100\">\n<md-input-container class=\"padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\" flex>\n<label class=\"margin-left-10\" translate=\"GENERAL.LATEST_VERSION\"></label><input \nng-change=\"vm.saveGeneral(vm.showSettings.current_version)\" ng-model-options=\"{debounce: 500}\" required \nname=\"current_version\" ng-model=\"vm.showSettings.current_version\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff || (vm.showSettings.hotel_id != 1 && vm.showSettings.current_versionusedefault)\">\n</md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\" \nflex><div ng-if=\"vm.showSettings.hotel_id != 1\"><div flex=\"100\"><md-checkbox class=\"mt-0\" \nng-change=\"vm.saveCheck(vm.showSettings.current_versionusedefault)\" \nng-model=\"vm.showSettings.current_versionusedefault\" aria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}\n</md-checkbox></div></div></div></div><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex=\"100\">\n<md-input-container class=\"padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\" flex>\n<label class=\"margin-left-10\" translate=\"GENERAL.NUMBER_OF_DAYS\"></label><input \nng-change=\"vm.saveGeneral(vm.showSettings.number_of_days)\" ng-model-options=\"{debounce: 500}\" required \nname=\"number_of_days\" ng-model=\"vm.showSettings.number_of_days\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff || (vm.showSettings.hotel_id != 1 && vm.showSettings.number_of_daysusedefault)\">\n</md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\" \nflex><div ng-if=\"vm.showSettings.hotel_id != 1\"><div flex=\"100\"><md-checkbox class=\"mt-0\" \nng-change=\"vm.saveCheck(vm.showSettings.number_of_daysusedefault)\" ng-model=\"vm.showSettings.number_of_daysusedefault\" \naria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}</md-checkbox></div></div></div></div><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex=\"100\"><div layout-align=\"start\" layout=\"row\" flex=\"100\" \nflex-gt-xs=\"50\" flex class=\"relative\"><md-input-container class=\"padding-left-10 padding-right-10 mb-0\" \nlayout=\"column\" flex=\"100\"><label class=\"margin-left-10\" translate=\"GENERAL.HOTEL_COLOR_CODE\"></label><input \nng-change=\"vm.saveGeneral(vm.showSettings.hotelcolorcode)\" ng-model-options=\"{debounce: 500}\" required \nname=\"hotelcolorcode\" ng-model=\"vm.showSettings.hotelcolorcode\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff || (vm.showSettings.hotel_id != 1 && vm.showSettings.hotelcolorcodeusedefault)\">\n</md-input-container><color-picker ng-model=\"vm.showSettings.hotelcolorcode\" options=\"vm.options\" api=\"api\" \nevent-api=\"eventApi\"></color-picker></div><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" \nflex=\"100\" flex-gt-xs=\"50\" flex><div ng-if=\"vm.showSettings.hotel_id != 1\"><div flex=\"100\"><md-checkbox class=\"mt-0\" \nng-change=\"vm.saveCheckAndEnableColorPicker(vm.showSettings.hotelcolorcodeusedefault)\" \nng-model=\"vm.showSettings.hotelcolorcodeusedefault\" aria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}\n</md-checkbox></div></div></div></div><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex=\"100\">\n<md-input-container class=\"padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\" flex>\n<label class=\"margin-left-10\" translate=\"GENERAL.HOTEL_LONGITUDE\"></label><input \nng-change=\"vm.saveGeneral(vm.showSettings.longitude)\" ng-model-options=\"{debounce: 500}\" required name=\"longitude\" \nng-model=\"vm.showSettings.longitude\" \nng-readonly=\"vm.autoFillOff || (vm.showSettings.hotel_id != 1 && vm.showSettings.longitudeusedefault)\" \nautocomplete=\"off\"></md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" \nflex-gt-xs=\"50\" flex><div ng-if=\"vm.showSettings.hotel_id != 1\"><div flex=\"100\"><md-checkbox class=\"mt-0\" \nng-change=\"vm.saveCheck(vm.showSettings.longitudeusedefault)\" ng-model=\"vm.showSettings.longitudeusedefault\" \naria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}</md-checkbox></div></div></div></div><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex=\"100\"><md-input-container \nclass=\"padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\" flex><label \nclass=\"margin-left-10\" translate=\"GENERAL.HOTEL_LATITUDE\"></label><input \nng-change=\"vm.saveGeneral(vm.showSettings.latitude)\" ng-model-options=\"{debounce: 500}\" required name=\"latitude\" \nng-model=\"vm.showSettings.latitude\" \nng-readonly=\"vm.autoFillOff ||( vm.showSettings.hotel_id != 1 && vm.showSettings.latitudeusedefault)\" \nautocomplete=\"off\"></md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" \nflex-gt-xs=\"50\" flex><div ng-if=\"vm.showSettings.hotel_id != 1\"><div flex=\"100\"><md-checkbox class=\"mt-0\" \nng-change=\"vm.saveCheck(vm.showSettings.latitudeusedefault)\" ng-model=\"vm.showSettings.latitudeusedefault\" \naria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}</md-checkbox></div></div></div></div><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex=\"100\"><md-input-container \nclass=\"padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\" flex><label \nclass=\"margin-left-10\" translate=\"GENERAL.IBE_THEME\"></label><md-select ng-model=\"vm.showSettings.ibeTheme\" \nng-change=\"vm.saveGeneral(vm.showSettings.ibeTheme)\" \nng-disabled=\"( vm.showSettings.hotel_id != 1 && vm.showSettings.ibeThemeusedefault )\" name=\"ibeTheme\"><md-option \nng-repeat=\"theme in vm.themeOptions\" ng-value=\"theme.value\"><div layout=\"row\" layout-align=\"start center\"><div \nstyle=\"width: 16px; height: 16px; border-radius: 3px; margin-right: 8px; border: 1px solid #ccc\" \nng-style=\"{\'background-color\': theme.colorCode}\"></div>{{theme.name}}</div></md-option></md-select>\n</md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\" \nflex><div ng-if=\"vm.showSettings.hotel_id != 1\"><div flex=\"100\"><md-checkbox class=\"mt-0\" \nng-change=\"vm.saveCheck(vm.showSettings.ibeThemeusedefault)\" ng-model=\"vm.showSettings.ibeThemeusedefault\" \naria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}</md-checkbox></div></div></div></div><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex class=\"margin-top-16\"><md-input-container \nclass=\"md-input-has-value padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\" \nng-style=\"vm.showSettings.hotel_id != 1 && vm.showSettings.allowCheckoutWithPendingDuesusedefault ? {\'pointer-events\':\'none\'} : \'\'\">\n<label class=\"margin-left-10\" translate=\"GENERAL.ALLOW_CHECKOUT_WITH_PENDING_DUES\"></label><md-radio-group \nng-model=\"vm.showSettings.allowCheckoutWithPendingDues\" \nng-change=\"vm.saveGeneral(vm.showSettings.allowCheckoutWithPendingDues)\" ng-model-options=\"{debounce: 500}\">\n<md-radio-button class=\"margin-left-0\" value=\"1\">Yes</md-radio-button><md-radio-button class=\"margin-left-20\" \nvalue=\"0\">No</md-radio-button></md-radio-group><div class=\"md-errors-spacer\"></div></md-input-container><div \nclass=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\"><div \nng-if=\"vm.showSettings.hotel_id != 1\" layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox class=\"mt-0\" \nng-change=\"vm.saveCheck(vm.showSettings.allowCheckoutWithPendingDuesusedefault)\" \nng-model=\"vm.showSettings.allowCheckoutWithPendingDuesusedefault\" aria-label=\"Use Global\">\n{{ \'GENERAL.USE_GLOBAL\' | translate}}</md-checkbox></div></div></div></div><div layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start\" flex class=\"margin-top-16\"><md-input-container \nclass=\"md-input-has-value padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\" \nng-style=\"vm.showSettings.hotel_id != 1 && vm.showSettings.showPosPopupOnReservationusedefault ? {\'pointer-events\':\'none\'} : \'\'\">\n<label class=\"margin-left-10\" translate=\"GENERAL.SHOW_POS_POPUP_ON_RESERVATION\"></label><md-radio-group \nng-model=\"vm.showSettings.showPosPopupOnReservation\" \nng-change=\"vm.saveGeneral(vm.showSettings.showPosPopupOnReservation)\" ng-model-options=\"{debounce: 500}\">\n<md-radio-button class=\"margin-left-0\" value=\"1\">Yes</md-radio-button><md-radio-button class=\"margin-left-20\" \nvalue=\"0\">No</md-radio-button></md-radio-group><div class=\"md-errors-spacer\"></div></md-input-container><div \nclass=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\"><div \nng-if=\"vm.showSettings.hotel_id != 1\" layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox class=\"mt-0\" \nng-change=\"vm.saveCheck(vm.showSettings.showPosPopupOnReservationusedefault)\" \nng-model=\"vm.showSettings.showPosPopupOnReservationusedefault\" aria-label=\"Use Global\">\n{{ \'GENERAL.USE_GLOBAL\' | translate}}</md-checkbox></div></div></div></div><div layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start\" flex class=\"margin-top-16\"><md-input-container \nclass=\"md-input-has-value padding-left-10 padding-right-10 mb-0\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\" \nng-style=\"vm.showSettings.hotel_id != 1 && vm.showSettings.isRoundUpEnableusedefault ? {\'pointer-events\':\'none\'} : \'\'\">\n<label class=\"margin-left-10\" translate=\"GENERAL.ENABLE_ROUND_UP\"></label><md-radio-group \nng-model=\"vm.showSettings.isRoundUpEnable\" ng-change=\"vm.saveGeneral(vm.showSettings.isRoundUpEnable)\" \nng-model-options=\"{debounce: 500}\"><md-radio-button class=\"margin-left-0\" value=\"1\">Yes</md-radio-button>\n<md-radio-button class=\"margin-left-20\" value=\"0\">No</md-radio-button></md-radio-group><div class=\"md-errors-spacer\">\n</div></md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" \nflex-gt-xs=\"50\"><div ng-if=\"vm.showSettings.hotel_id != 1\" layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox \nclass=\"mt-0\" ng-change=\"vm.saveCheck(vm.showSettings.isRoundUpEnableusedefault)\" \nng-model=\"vm.showSettings.isRoundUpEnableusedefault\" aria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}\n</md-checkbox></div></div></div></div><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex \nclass=\"margin-top-16\"><md-input-container class=\"md-input-has-value padding-left-10 padding-right-10 mb-0\" \nlayout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\" \nng-style=\"vm.showSettings.hotel_id != 1 && vm.showSettings.enablePreCheckinusedefault ? {\'pointer-events\':\'none\'} : \'\'\">\n<label class=\"margin-left-10\" translate=\"GENERAL.ENABLE_PRE_CHECKIN\"></label><md-radio-group \nng-model=\"vm.showSettings.enablePreCheckin\" ng-change=\"vm.saveGeneral(vm.showSettings.enablePreCheckin)\" \nng-model-options=\"{debounce: 500}\"><md-radio-button class=\"margin-left-0\" value=\"1\">Yes</md-radio-button>\n<md-radio-button class=\"margin-left-20\" value=\"0\">No</md-radio-button></md-radio-group><div class=\"md-errors-spacer\">\n</div></md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" \nflex-gt-xs=\"50\"><div ng-if=\"vm.showSettings.hotel_id != 1\" layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox \nclass=\"mt-0\" ng-change=\"vm.saveCheck(vm.showSettings.enablePreCheckinusedefault)\" \nng-model=\"vm.showSettings.enablePreCheckinusedefault\" aria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}\n</md-checkbox></div></div></div></div><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex \nclass=\"margin-top-16\"><md-input-container class=\"md-input-has-value padding-left-10 padding-right-10 mb-0\" \nlayout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\" \nng-style=\"vm.showSettings.hotel_id != 1 && vm.showSettings.enableBorrowedItemsusedefault ? {\'pointer-events\':\'none\'} : \'\'\">\n<label class=\"margin-left-10\" translate=\"GENERAL.ENABLE_BORROWED_ITEMS\"></label><md-radio-group \nng-model=\"vm.showSettings.enableBorrowedItems\" ng-change=\"vm.saveGeneral(vm.showSettings.enableBorrowedItems)\" \nng-model-options=\"{debounce: 500}\"><md-radio-button class=\"margin-left-0\" value=\"1\">Yes</md-radio-button>\n<md-radio-button class=\"margin-left-20\" value=\"0\">No</md-radio-button></md-radio-group><div class=\"md-errors-spacer\">\n</div></md-input-container><div class=\"padding-left-10 padding-right-10\" layout-align=\"start\" flex=\"100\" \nflex-gt-xs=\"50\"><div ng-if=\"vm.showSettings.hotel_id != 1\" layout=\"row\" layout-wrap flex><div flex=\"100\"><md-checkbox \nclass=\"mt-0\" ng-change=\"vm.saveCheck(vm.showSettings.enableBorrowedItemsusedefault)\" \nng-model=\"vm.showSettings.enableBorrowedItemsusedefault\" aria-label=\"Use Global\">{{ \'GENERAL.USE_GLOBAL\' | translate}}\n</md-checkbox></div></div></div></div></form></div></div></div></div>");
$templateCache.put("app/main/apps/settings/messageCenter/messageCenter.html","<div id=\"message-center-settings\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"center start\"><div class=\"h1 white-fg\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"mr-10\"></md-icon><span translate=\"MESSAGE_CENTER_CONFIG.TITLE\">Message Center Config\n</span></div><div class=\"secondary-text white-fg gmc-settings-subtitle\"><span \ntranslate=\"MESSAGE_CENTER_CONFIG.SUBTITLE\">\nConfigure communication channels for your organization. Sub-hotels inherit these settings.</span></div></div><div>\n<md-button class=\"md-raised md-background\" \nng-class=\"{\'md-blue-grey-A100-bg\': vm.loading || vm.saving || messageCenterSettingsForm.$invalid || vm.afterHoursConfigIncomplete()}\" \nng-disabled=\"vm.loading || vm.saving || messageCenterSettingsForm.$invalid || vm.afterHoursConfigIncomplete()\" \nng-click=\"vm.saveSettings()\"><span translate=\"MESSAGE_CENTER_CONFIG.SAVE\">Save</span></md-button></div></div><div \nclass=\"content\"><div class=\"main sm-hearder-top\" ms-scroll><md-progress-linear md-mode=\"indeterminate\" \nng-show=\"vm.loading || vm.saving\"></md-progress-linear><form name=\"messageCenterSettingsForm\" \nclass=\"gmc-settings-form\" novalidate><div class=\"gmc-settings-channels\"><div class=\"gmc-settings-channel-card\" \nng-class=\"{\'is-enabled\': vm.otaEnabled}\"><div class=\"gmc-settings-channel-row\" \nng-click=\"vm.otaEnabled = !vm.otaEnabled\" role=\"button\" tabindex=\"0\"><div class=\"gmc-settings-channel-heading\"><div \nclass=\"gmc-settings-channel-icon ota icon-earth\" aria-hidden=\"true\"></div><div class=\"gmc-settings-channel-copy\"><div \nclass=\"gmc-settings-channel-title\" translate=\"MESSAGE_CENTER_CONFIG.ENABLE_OTA\">Enable OTA</div><p \nclass=\"gmc-settings-channel-desc\" translate=\"MESSAGE_CENTER_CONFIG.ENABLE_OTA_DESC\">Allow OTA inbox conversations.</p>\n</div></div><div class=\"gmc-settings-channel-toggle\"><md-switch class=\"no-margin\" ng-model=\"vm.otaEnabled\" \nng-click=\"$event.stopPropagation()\" ng-disabled=\"vm.loading || vm.saving\" aria-label=\"Enable OTA messaging\">\n</md-switch></div></div></div><div class=\"gmc-settings-channel-card\" ng-class=\"{\'is-enabled\': vm.smsEnabled}\"><div \nclass=\"gmc-settings-channel-row\" ng-click=\"vm.smsEnabled = !vm.smsEnabled\" role=\"button\" tabindex=\"0\"><div \nclass=\"gmc-settings-channel-heading\"><div class=\"gmc-settings-channel-icon sms icon-message-text\" aria-hidden=\"true\">\n</div><div class=\"gmc-settings-channel-copy\"><div class=\"gmc-settings-channel-title\" \ntranslate=\"MESSAGE_CENTER_CONFIG.ENABLE_SMS\">Enable SMS</div><p class=\"gmc-settings-channel-desc\" \ntranslate=\"MESSAGE_CENTER_CONFIG.ENABLE_SMS_DESC\">Allow starting and sending SMS conversations to guests.</p></div>\n</div><div class=\"gmc-settings-channel-toggle\"><md-switch class=\"no-margin\" ng-model=\"vm.smsEnabled\" \nng-click=\"$event.stopPropagation()\" ng-disabled=\"vm.loading || vm.saving\" aria-label=\"Enable SMS messaging\">\n</md-switch></div></div><div class=\"gmc-settings-channel-body\" ng-if=\"vm.smsEnabled\"><div class=\"gmc-settings-field\">\n<label class=\"gmc-settings-field-label\" translate=\"MESSAGE_CENTER_CONFIG.SMS_PHONE\">SMS phone number</label><input \ntype=\"tel\" name=\"twilioPhoneNumber\" ng-model=\"vm.twilioPhoneNumber\" ng-disabled=\"vm.loading || vm.saving\" \nclass=\"intel-number-input\" intl-tel-input autocomplete=\"off\" placeholder=\"+11111111111\" \nng-change=\"vm.updatePhoneWithCountryCode(\'twilioPhoneNumber\')\"></div></div></div><div \nclass=\"gmc-settings-channel-card\" ng-class=\"{\'is-enabled\': vm.whatsappEnabled}\"><div class=\"gmc-settings-channel-row\" \nng-click=\"vm.whatsappEnabled = !vm.whatsappEnabled\" role=\"button\" tabindex=\"0\"><div \nclass=\"gmc-settings-channel-heading\"><div class=\"gmc-settings-channel-icon whatsapp icon-whatsapp\" aria-hidden=\"true\">\n</div><div class=\"gmc-settings-channel-copy\"><div class=\"gmc-settings-channel-title\" \ntranslate=\"MESSAGE_CENTER_CONFIG.ENABLE_WHATSAPP\">Enable WhatsApp</div><p class=\"gmc-settings-channel-desc\" \ntranslate=\"MESSAGE_CENTER_CONFIG.ENABLE_WHATSAPP_DESC\">Allow starting and sending WhatsApp conversations.</p></div>\n</div><div class=\"gmc-settings-channel-toggle\"><md-switch class=\"no-margin\" ng-model=\"vm.whatsappEnabled\" \nng-click=\"$event.stopPropagation()\" ng-disabled=\"vm.loading || vm.saving\" aria-label=\"Enable WhatsApp messaging\">\n</md-switch></div></div><div class=\"gmc-settings-channel-body\" ng-if=\"vm.whatsappEnabled\"><div \nclass=\"gmc-settings-field\"><label class=\"gmc-settings-field-label\" translate=\"MESSAGE_CENTER_CONFIG.WHATSAPP_PHONE\">\nWhatsApp phone number</label><input type=\"tel\" name=\"twilioWhatsappNumber\" ng-model=\"vm.twilioWhatsappNumber\" \nng-disabled=\"vm.loading || vm.saving\" class=\"intel-number-input\" intl-tel-input autocomplete=\"off\" \nplaceholder=\"+11111111111\" ng-change=\"vm.updatePhoneWithCountryCode(\'twilioWhatsappNumber\')\"></div></div></div></div>\n<div class=\"gmc-settings-twilio-card\" ng-if=\"vm.smsEnabled || vm.whatsappEnabled\"><div \nclass=\"gmc-settings-twilio-header\"><div class=\"gmc-settings-channel-icon twilio icon-code-tags\" aria-hidden=\"true\">\n</div><div class=\"gmc-settings-channel-title\" translate=\"MESSAGE_CENTER_CONFIG.TWILIO\">Twilio configuration</div></div>\n<div class=\"gmc-settings-field\"><label class=\"gmc-settings-field-label\" translate=\"MESSAGE_CENTER_CONFIG.SERVICE_SID\">\nConversations Service SID</label><input type=\"text\" name=\"twilioConversationsServiceSid\" \nng-model=\"vm.twilioConversationsServiceSid\" ng-disabled=\"vm.loading || vm.saving\" autocomplete=\"off\" \nplaceholder=\"IS...\"></div></div><div class=\"gmc-settings-channel-card browser-notify-card mt-20\" \nng-class=\"{\'is-enabled\': vm.browserNotificationsEnabled}\"><div class=\"gmc-settings-channel-row\" \nng-click=\"vm.browserNotificationsEnabled = !vm.browserNotificationsEnabled\" role=\"button\" tabindex=\"0\"><div \nclass=\"gmc-settings-channel-heading\"><div class=\"gmc-settings-channel-icon browser icon-bell-ring\" aria-hidden=\"true\">\n</div><div class=\"gmc-settings-channel-copy\"><div class=\"gmc-settings-channel-title\" \ntranslate=\"MESSAGE_CENTER_CONFIG.BROWSER_NOTIFICATIONS\">Enable browser notifications</div><p \nclass=\"gmc-settings-channel-desc\" translate=\"MESSAGE_CENTER_CONFIG.BROWSER_NOTIFICATIONS_DESC\">\nAllow staff at this hotel to turn on desktop notifications. When this is off, browser notifications are not shown. Sub-hotels inherit this setting.\n</p></div></div><div class=\"gmc-settings-channel-toggle\"><md-switch class=\"no-margin\" \nng-model=\"vm.browserNotificationsEnabled\" ng-click=\"$event.stopPropagation()\" ng-disabled=\"vm.loading || vm.saving\" \naria-label=\"Enable browser notifications\"></md-switch></div></div></div><div \nclass=\"gmc-settings-channel-card overdue-message-card mt-20\" \nng-class=\"{\'is-enabled\': vm.overdueAlertEnabled || vm.unrepliedAlertEnabled}\"><div class=\"gmc-settings-channel-row\" \nng-click=\"vm.overdueAlertEnabled = !vm.overdueAlertEnabled\" role=\"button\" tabindex=\"0\"><div \nclass=\"gmc-settings-channel-heading\"><div class=\"gmc-settings-channel-icon bell icon-message-alert\" aria-hidden=\"true\">\n</div><div class=\"gmc-settings-channel-copy\"><div class=\"gmc-settings-channel-title\">Overdue Message Alerts</div><p \nclass=\"gmc-settings-channel-desc\">Alert admins when guest messages stay unopened past the threshold.</p></div></div>\n<div class=\"gmc-settings-channel-toggle\"><md-switch class=\"no-margin\" ng-model=\"vm.overdueAlertEnabled\" \nng-click=\"$event.stopPropagation()\" ng-disabled=\"vm.loading || vm.saving\" aria-label=\"Enable Overdue Alerts\">\n</md-switch></div></div><div class=\"gmc-settings-channel-body\" \nng-if=\"vm.overdueAlertEnabled || vm.unrepliedAlertEnabled\"><div class=\"overdue-settings\"><div class=\"gmc-overdue-card\">\n<div class=\"gmc-overdue-card-header\"><div class=\"gmc-overdue-card-icon email\"><md-icon md-font-icon=\"icon-email\">\n</md-icon></div><div class=\"gmc-overdue-card-copy\"><div class=\"gmc-overdue-card-title\">Send via Email</div><div \nclass=\"gmc-overdue-card-desc\">Notify admin via email for overdue and unreplied alerts.</div></div><div \nclass=\"gmc-overdue-card-toggle\"><md-switch class=\"no-margin\" ng-model=\"vm.overdueAlertEmail\" \nng-disabled=\"vm.loading || vm.saving\" aria-label=\"Send via Email\"></md-switch></div></div><div \nclass=\"gmc-overdue-card-field\" ng-if=\"vm.overdueAlertEmail\"><label class=\"gmc-overdue-card-field-label\">\nAlert email addresses</label><div class=\"gmc-multi-recipient-list\"><div class=\"gmc-recipient-row\" \nng-repeat=\"(idx, email) in vm.overdueAlertEmailAddresses track by $index\"><input type=\"email\" \nname=\"overdueAlertEmail_{{idx}}\" ng-model=\"vm.overdueAlertEmailAddresses[idx]\" ng-disabled=\"vm.loading || vm.saving\" \nautocomplete=\"off\" placeholder=\"admin@hotel.com\" class=\"gmc-recipient-input\" \nng-class=\"{\'has-error\': vm.isEmailDuplicate(idx)}\" \nng-required=\"(vm.overdueAlertEnabled || vm.unrepliedAlertEnabled) && vm.overdueAlertEmail\"> <button type=\"button\" \nclass=\"gmc-recipient-remove\" ng-click=\"vm.removeEmail(idx)\" \nng-disabled=\"vm.loading || vm.saving || vm.overdueAlertEmailAddresses.length === 1\" aria-label=\"Remove email\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></button></div></div><button type=\"button\" class=\"gmc-add-recipient-btn\" \nng-click=\"vm.addEmail()\" ng-disabled=\"!vm.canAddEmail()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Add another email\n</button></div></div><div class=\"gmc-overdue-card\"><div class=\"gmc-overdue-card-header\"><div \nclass=\"gmc-overdue-card-icon sms\"><md-icon md-font-icon=\"icon-message-text\"></md-icon></div><div \nclass=\"gmc-overdue-card-copy\"><div class=\"gmc-overdue-card-title\">Send via SMS</div><div class=\"gmc-overdue-card-desc\">\nNotify admin via text for overdue and unreplied alerts.</div></div><div class=\"gmc-overdue-card-toggle\"><md-switch \nclass=\"no-margin\" ng-model=\"vm.overdueAlertSms\" ng-disabled=\"vm.loading || vm.saving\" aria-label=\"Send via SMS\">\n</md-switch></div></div><div class=\"gmc-overdue-card-field\" ng-if=\"vm.overdueAlertSms\"><label \nclass=\"gmc-overdue-card-field-label\">Alert phone numbers</label><div class=\"gmc-multi-recipient-list\"><div \nclass=\"gmc-recipient-row\" ng-repeat=\"(idx, phone) in vm.overdueAlertPhones track by $index\"><input type=\"tel\" \nname=\"overdueAlertPhone_{{idx}}\" ng-model=\"vm.overdueAlertPhones[idx]\" ng-disabled=\"vm.loading || vm.saving\" \nclass=\"intel-number-input gmc-recipient-input\" intl-tel-input autocomplete=\"off\" placeholder=\"+11111111111\" \nng-change=\"vm.updatePhoneWithCountryCode(\'overdueAlertPhone_\' + idx, idx)\" \nng-class=\"{\'has-error\': vm.isPhoneDuplicate(idx)}\" \nng-required=\"(vm.overdueAlertEnabled || vm.unrepliedAlertEnabled) && vm.overdueAlertSms\"> <button type=\"button\" \nclass=\"gmc-recipient-remove\" ng-click=\"vm.removePhone(idx)\" \nng-disabled=\"vm.loading || vm.saving || vm.overdueAlertPhones.length === 1\" aria-label=\"Remove phone\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></button></div></div><button type=\"button\" class=\"gmc-add-recipient-btn\" \nng-click=\"vm.addPhone()\" ng-disabled=\"!vm.canAddPhone()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>Add another number\n</button></div></div><div class=\"gmc-overdue-card\" ng-if=\"vm.overdueAlertEnabled\"><div class=\"gmc-overdue-card-header\">\n<div class=\"gmc-overdue-card-icon threshold\"><md-icon md-font-icon=\"icon-clock\"></md-icon></div><div \nclass=\"gmc-overdue-card-copy\"><div class=\"gmc-overdue-card-title\">Threshold (Minutes)</div><div \nclass=\"gmc-overdue-card-desc\">Minutes to wait before an unread message is considered overdue.</div></div><div \nclass=\"gmc-overdue-threshold-input\"><input type=\"number\" name=\"overdueAlertMins\" ng-model=\"vm.overdueAlertMins\" \nng-disabled=\"vm.loading || vm.saving\" autocomplete=\"off\" min=\"1\" ng-required=\"vm.overdueAlertEnabled\" \nng-class=\"{\'has-error\': vm.overdueAlertEnabled && messageCenterSettingsForm.overdueAlertMins.$invalid}\"></div></div>\n</div></div><div class=\"gmc-unreplied-toggle-row\" ng-click=\"vm.unrepliedAlertEnabled = !vm.unrepliedAlertEnabled\" \nrole=\"button\" tabindex=\"0\"><div class=\"gmc-unreplied-toggle-copy\"><span class=\"gmc-unreplied-toggle-label\">\nUnreplied message alerts</span> <span class=\"gmc-unreplied-toggle-desc\">\nAlso alert when a message is opened but not replied to or acknowledged</span></div><md-switch class=\"no-margin\" \nng-model=\"vm.unrepliedAlertEnabled\" ng-click=\"$event.stopPropagation()\" ng-disabled=\"vm.loading || vm.saving\" \naria-label=\"Enable Unreplied Alerts\"></md-switch></div></div></div><div \nclass=\"gmc-settings-channel-card after-hours-card mt-20\" ng-class=\"{\'is-enabled\': vm.afterHoursAutoReplyEnabled}\"><div \nclass=\"gmc-settings-channel-row\" ng-click=\"vm.afterHoursAutoReplyEnabled = !vm.afterHoursAutoReplyEnabled\" \nrole=\"button\" tabindex=\"0\"><div class=\"gmc-settings-channel-heading\"><div \nclass=\"gmc-settings-channel-icon night icon-weather-night\" aria-hidden=\"true\"></div><div \nclass=\"gmc-settings-channel-copy\"><div class=\"gmc-settings-channel-title\" \ntranslate=\"MESSAGE_CENTER_CONFIG.AFTER_HOURS_TITLE\">After-Hours Auto Reply</div><p class=\"gmc-settings-channel-desc\" \ntranslate=\"MESSAGE_CENTER_CONFIG.AFTER_HOURS_DESC\">\nAutomatically reply to guest Twilio SMS/WhatsApp messages while the office is closed.</p></div></div><div \nclass=\"gmc-settings-channel-toggle\"><md-switch class=\"no-margin\" ng-model=\"vm.afterHoursAutoReplyEnabled\" \nng-click=\"$event.stopPropagation()\" ng-disabled=\"vm.loading || vm.saving\" aria-label=\"Enable After-Hours Auto Reply\">\n</md-switch></div></div><div class=\"gmc-settings-channel-body after-hours-settings\" \nng-if=\"vm.afterHoursAutoReplyEnabled\"><div class=\"gmc-overdue-card gmc-after-hours-schedule-card\"><div \nclass=\"gmc-overdue-card-header\"><div class=\"gmc-overdue-card-icon schedule\"><md-icon md-font-icon=\"icon-clock\">\n</md-icon></div><div class=\"gmc-overdue-card-copy\"><div class=\"gmc-overdue-card-title\" \ntranslate=\"MESSAGE_CENTER_CONFIG.AFTER_HOURS_SCHEDULE_TITLE\">Closed hours</div><div class=\"gmc-overdue-card-desc\" \ntranslate=\"MESSAGE_CENTER_CONFIG.AFTER_HOURS_SCHEDULE_DESC\">\nDaily window when automatic replies are sent (hotel local time).</div></div></div><div \nclass=\"gmc-after-hours-hours-row\" ng-class=\"{\'has-error\': vm.afterHoursHoursInvalid()}\"><md-input-container \nclass=\"md-block gmc-after-hours-hour-field\" \nng-class=\"{\'md-input-invalid\': messageCenterSettingsForm.afterHoursStartHour.$invalid || vm.afterHoursHoursInvalid()}\">\n<label translate=\"MESSAGE_CENTER_CONFIG.AFTER_HOURS_START\">Closed from</label><md-select name=\"afterHoursStartHour\" \nng-model=\"vm.afterHoursStartHour\" placeholder=\"{{ \'MESSAGE_CENTER_CONFIG.AFTER_HOURS_SELECT_HOUR\' | translate }}\" \nng-disabled=\"vm.loading || vm.saving\" ng-required=\"vm.afterHoursAutoReplyEnabled\" aria-label=\"Closed from hour\">\n<md-option ng-repeat=\"hour in vm.hourOptions\" ng-value=\"hour.value\">{{ hour.label }}</md-option></md-select>\n</md-input-container><div class=\"gmc-after-hours-hours-divider\" aria-hidden=\"true\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon></div><md-input-container class=\"md-block gmc-after-hours-hour-field\" \nng-class=\"{\'md-input-invalid\': messageCenterSettingsForm.afterHoursEndHour.$invalid || vm.afterHoursHoursInvalid()}\">\n<label translate=\"MESSAGE_CENTER_CONFIG.AFTER_HOURS_END\">Reopens at</label><md-select name=\"afterHoursEndHour\" \nng-model=\"vm.afterHoursEndHour\" placeholder=\"{{ \'MESSAGE_CENTER_CONFIG.AFTER_HOURS_SELECT_HOUR\' | translate }}\" \nng-disabled=\"vm.loading || vm.saving\" ng-required=\"vm.afterHoursAutoReplyEnabled\" aria-label=\"Reopens at hour\">\n<md-option ng-repeat=\"hour in vm.hourOptions\" ng-value=\"hour.value\">{{ hour.label }}</md-option></md-select>\n</md-input-container></div><div class=\"gmc-after-hours-hours-hint\" ng-if=\"vm.afterHoursHoursInvalid()\" \ntranslate=\"MESSAGE_CENTER_CONFIG.AFTER_HOURS_HOURS_INVALID\">Start and end hours must be different.</div></div><div \nclass=\"gmc-overdue-card gmc-after-hours-message-card\"><div class=\"gmc-overdue-card-header\"><div \nclass=\"gmc-overdue-card-icon reply\"><md-icon md-font-icon=\"icon-message-text\"></md-icon></div><div \nclass=\"gmc-overdue-card-copy\"><div class=\"gmc-overdue-card-title\" \ntranslate=\"MESSAGE_CENTER_CONFIG.AFTER_HOURS_MESSAGE\">Auto-reply message</div><div class=\"gmc-overdue-card-desc\" \ntranslate=\"MESSAGE_CENTER_CONFIG.AFTER_HOURS_MESSAGE_HINT\">\nApplies to Twilio SMS/WhatsApp only. Replies to each guest message while closed. Signed as “- Lisa”. Guest messages stay unread.\n</div></div></div><div class=\"gmc-after-hours-message-field\"><textarea name=\"afterHoursMessage\" \nng-model=\"vm.afterHoursMessage\" ng-disabled=\"vm.loading || vm.saving\" ng-required=\"vm.afterHoursAutoReplyEnabled\" \nrows=\"4\" maxlength=\"1000\" \nng-class=\"{\'has-error\': messageCenterSettingsForm.afterHoursMessage.$invalid && messageCenterSettingsForm.afterHoursMessage.$touched}\" \nplaceholder=\"{{ \'MESSAGE_CENTER_CONFIG.AFTER_HOURS_MESSAGE_PLACEHOLDER\' | translate }}\"></textarea></div></div></div>\n</div></form></div></div></div>");
$templateCache.put("app/main/apps/settings/paymentMethods/paymentMethod.html","<div id=\"payment-setting\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"logo logo-text white-fg\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-cash\" class=\"s30\"></md-icon></span><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"PAYMENT.METHODS\" class=\"general-text\"></span></div></div></div></div><div class=\"content scroll-height-sm\">\n<div class=\"main sm-hearder-top scroll-full-height\" ms-scroll><md-progress-linear md-mode=\"indeterminate\" \nng-show=\"vm.isloading\"></md-progress-linear><form name=\"generalSettingsForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex ng-if=\"vm.subHotelValues.length > 0\"><md-input-container \nclass=\"padding-left-10 padding-right-10 mb-10\" layout-align=\"start\" flex=\"100\" flex-gt-xs=\"50\"><label \nclass=\"margin-left-10\" translate=\"GENERAL.SCOPE\"></label><md-select ng-model=\"vm.currentHotel\" \nng-change=\"vm.changedValue()\"><md-option ng-value=\"vm.parentHotelId\" \nng-selected=\"vm.parentHotelId == vm.currentHotelId\">{{vm.parentName}}</md-option><md-option \nng-value=\"website.hotel_id\" ng-selected=\"{{website.hotel_id == vm.hotel_id}}\" \nng-repeat=\"website in vm.subHotelValues | filter:searchTerm\">{{website.hotel_title}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"white-bg md-whiteframe-4dp white-scroll relative-block margin-bottom-10\" layout-align=\"center center\" \nlayout-padding><div class=\"row-block-new\" flex><div class=\"form-title margin-left-10\" translate=\"PAYMENT.ALLOWED\">\n</div><div class=\"row-block-new\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"layout-colo-block padding-left-10 padding-right-10\" layout=\"column\" flex=\"25\" flex-xs=\"100\" flex-sm=\"50\" \nng-repeat=\"(key, value) in vm.paymentMethods\"><md-checkbox \nclass=\"capitalize padding-top-10 padding-bottom-10 no-margin\" ng-checked=\"vm.paymentMethodsSelected.indexOf(key) >= 0\" \nng-value=\"{{key}}\" ng-click=\"vm.paymentMethodClicked(key)\">{{value}}</md-checkbox></div></div></div></div><div \nclass=\"white-bg md-whiteframe-4dp white-scroll relative-block margin-bottom-10\" layout-align=\"center center\" \nlayout-padding ng-if=\"vm.paymentMethodsSelected.indexOf(\'1\') >= 0\"><div \nclass=\"form-title no-padding margin-top-10 margin-left-20 margin-right-20\" translate=\"PAYMENT.AUTHORIZE\"></div><div \nclass=\"row-block-new\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start start\" flex><div \nclass=\"layout-colo-block padding-left-10 padding-right-10 full-width\" flex=\"100\" flex-gt-sm=\"50\"><md-input-container \nclass=\"md-block mb-0\"><label translate=\"PAYMENT.API\"></label><input name=\"name\" type=\"text\" \nng-model=\"vm.authorize.authorize_api_id\" ng-change=\"vm.updateSetting(\'authorize_api_id\')\" \nng-model-options=\"{debounce: 700}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div><div \nclass=\"layout-colo-block padding-left-10 padding-right-10 full-width\" flex=\"100\" flex-gt-sm=\"50\"><md-input-container \nclass=\"md-block mb-0\"><label translate=\"PAYMENT.TRANSACTION\"></label><input name=\"name\" type=\"text\" \nng-model=\"vm.authorize.authorize_transaction_key\" ng-change=\"vm.updateSetting(\'authorize_transaction_key\')\" \nng-model-options=\"{debounce: 700}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div></div>\n<div class=\"row-block-new\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start start\" flex><div \nclass=\"layout-colo-block padding-left-10 padding-right-10 full-width\" flex=\"100\" flex-gt-sm=\"50\"><md-input-container \nclass=\"md-block mb-0\"><label translate=\"PAYMENT.GATEWAY\"></label><input name=\"name\" type=\"text\" \nng-model=\"vm.authorize.authorize_gateway_url\" ng-change=\"vm.updateSetting(\'authorize_gateway_url\')\" \nng-model-options=\"{debounce: 700}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div><div \nclass=\"layout-colo-block padding-left-10 padding-right-10 full-width\" flex=\"100\" flex-gt-sm=\"50\"><md-input-container \nclass=\"md-block mb-0\" layout=\"column\" flex=\"100\"><label translate=\"PAYMENT.TYPES\"></label><md-select multiple=\"true\" \nng-model=\"vm.authorize.authorize_cctypes\" ng-change=\"vm.updateSetting(\'authorize_cctypes\')\" \nng-model-options=\"{debounce: 700}\"><md-option value=\"{{key}}\" ng-repeat=\"(key, value) in vm.cardTypes\">{{ value }}\n</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div></div><div \nclass=\"row-block-new\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"layout-colo-block padding-left-10 padding-right-10 full-width\" layout=\"column\" flex=\"25\" flex-sm=\"50\" \nflex-xs=\"100\"><md-input-container class=\"md-block md-input-has-value\"><label translate=\"PAYMENT.MODE\"></label>\n<md-radio-group ng-model=\"vm.authorize.authorize_test_mode\" ng-change=\"vm.updateSetting(\'authorize_test_mode\')\" \nng-model-options=\"{debounce: 700}\"><md-radio-button value=\"1\">{{ \'PAYMENT.YES\' | translate }}</md-radio-button>\n<md-radio-button value=\"0\" class=\"margin-left-15\">{{ \'PAYMENT.NO\' | translate }}</md-radio-button></md-radio-group><div\n class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"layout-colo-block padding-left-10 padding-right-10 full-width\" layout=\"column\" flex=\"25\" flex-sm=\"50\" \nflex-xs=\"100\"><md-input-container class=\"md-block md-input-has-value\"><label translate=\"PAYMENT.DEBUG\"></label>\n<md-radio-group ng-model=\"vm.authorize.authorize_debug\" ng-change=\"vm.updateSetting(\'authorize_debug\')\" \nng-model-options=\"{debounce: 700}\"><md-radio-button value=\"1\">{{ \'PAYMENT.YES\' | translate }}</md-radio-button>\n<md-radio-button value=\"0\" class=\"margin-left-15\">{{ \'PAYMENT.NO\' | translate }}</md-radio-button></md-radio-group><div\n class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"layout-colo-block padding-left-10 padding-right-10 full-width\" layout=\"column\" flex=\"25\" flex-sm=\"50\" \nflex-xs=\"100\"><md-input-container class=\"md-block md-input-has-value\"><label translate=\"PAYMENT.CVV\"></label>\n<md-radio-group ng-model=\"vm.authorize.authorize_cvv\" ng-change=\"vm.updateSetting(\'authorize_cvv\')\" \nng-model-options=\"{debounce: 700}\"><md-radio-button value=\"1\">{{ \'PAYMENT.YES\' | translate }}</md-radio-button>\n<md-radio-button value=\"0\" class=\"margin-left-15\">{{ \'PAYMENT.NO\' | translate }}</md-radio-button></md-radio-group><div\n class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"layout-colo-block padding-left-10 padding-right-10 full-width\" layout=\"column\" flex=\"25\" flex-sm=\"50\" \nflex-xs=\"100\"><md-input-container class=\"md-block md-input-has-value\"><label translate=\"PAYMENT.CUST_NAME\"></label>\n<md-radio-group ng-model=\"vm.authorize.authorize_ccname\" ng-change=\"vm.updateSetting(\'authorize_ccname\')\" \nng-model-options=\"{debounce: 700}\"><md-radio-button value=\"1\">{{ \'PAYMENT.YES\' | translate }}</md-radio-button>\n<md-radio-button value=\"0\" class=\"margin-left-15\">{{ \'PAYMENT.NO\' | translate }}</md-radio-button></md-radio-group><div\n class=\"md-errors-spacer\"></div></md-input-container></div></div></div></form></div></div></div>");
$templateCache.put("app/main/apps/settings/roomLockEncoder/roomLockEncoder.html","<div id=\"room-lock-encoder-setting\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"logo logo-text white-fg\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"logo-icon room-lock-encoder-header-icon\"><md-icon md-svg-src=\"assets/images/room_key_icon.svg\" \nclass=\"white-fg s24\"></md-icon></span><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"ROOM_LOCK_ENCODER.TITLE\" class=\"general-text\"></span></div></div></div><div><md-button \nclass=\"md-raised md-background\" ng-class=\"{\'md-blue-grey-A100-bg\': vm.isloading}\" ng-disabled=\"vm.isloading\" \nng-click=\"vm.saveSettings()\"><span translate=\"ROOM_LOCK_ENCODER.SAVE\"></span></md-button></div></div><div \nclass=\"content\" style=\"padding: 0px !important\"><div class=\"main sm-hearder-top\" ms-scroll><md-progress-linear \nmd-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><form name=\"roomLockEncoderForm\" \nclass=\"encoder-settings-form white-scroll md-inline-form\" novalidate><div class=\"encoder-panel encoder-toggle-panel\" \nng-click=\"vm.toggleEnabled()\" role=\"button\" tabindex=\"0\" ng-keypress=\"vm.onToggleKeypress($event)\" \naria-pressed=\"{{vm.enabled}}\"><div class=\"encoder-panel-top\" layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"space-between center\"><div class=\"encoder-panel-heading\" flex><h3 class=\"encoder-panel-title\" \ntranslate=\"ROOM_LOCK_ENCODER.CONFIG_TOGGLE_TITLE\"></h3><p class=\"encoder-panel-description\" \ntranslate=\"ROOM_LOCK_ENCODER.CONFIG_TOGGLE_DESC\"></p></div><div class=\"encoder-panel-toggle\" layout=\"row\" \nlayout-align=\"end center\"><span class=\"encoder-toggle-label\" translate=\"ROOM_LOCK_ENCODER.ENABLE_LABEL\"></span>\n<md-switch class=\"no-margin encoder-switch\" ng-model=\"vm.enabled\" ng-click=\"$event.stopPropagation()\" \naria-label=\"Enable room lock encoder\"></md-switch></div></div></div><div class=\"encoder-panel\" ng-if=\"vm.enabled\"><div \nclass=\"encoder-panel-heading\"><h3 class=\"encoder-panel-title\"><span ng-if=\"vm.encoderUrls.length === 1\" \ntranslate=\"ROOM_LOCK_ENCODER.ENCODER_URLS_SINGLE\"></span> <span ng-if=\"vm.encoderUrls.length > 1\" \ntranslate=\"ROOM_LOCK_ENCODER.ENCODER_URLS_PLURAL\"></span></h3><p class=\"encoder-panel-description\" \ntranslate=\"ROOM_LOCK_ENCODER.ENCODER_ENDPOINTS_DESC\"></p></div><div class=\"encoder-url-list\"><div \nclass=\"encoder-url-item\" ng-repeat=\"encoder in vm.encoderUrls track by $index\"><div class=\"encoder-url-field-row\" \nlayout=\"row\" layout-align=\"start start\"><div class=\"encoder-url-field\" flex><md-input-container \nclass=\"md-block name-input-block encoder-url-input\" \nng-class=\"{\'encoder-url-readonly\': !vm.isEncoderEditable(encoder)}\" style=\"margin: 18px 0 0 0\"><label \nng-if=\"vm.showEncoderLabel()\"><span translate=\"ROOM_LOCK_ENCODER.ENCODER_URL\"></span> <span>\n({{ \'ROOM_LOCK_ENCODER.ENCODER\' | translate }} {{$index + 1}})</span></label><label ng-if=\"!vm.showEncoderLabel()\" \ntranslate=\"ROOM_LOCK_ENCODER.ENCODER_URL\"></label><input type=\"text\" id=\"encoderUrlInput{{$index}}\" \nname=\"encoderUrl{{$index}}\" ng-model=\"encoder.url\" ng-readonly=\"!vm.isEncoderEditable(encoder)\" \nng-attr-tabindex=\"{{vm.isEncoderEditable(encoder) ? 0 : -1}}\" autocomplete=\"off\"><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div class=\"encoder-url-actions\" layout=\"row\" layout-align=\"start start\"><md-button \nclass=\"md-icon-button encoder-edit-btn\" ng-if=\"!encoder.isNew && !encoder.editing\" \nng-click=\"vm.startEditingEncoderUrl($index)\" aria-label=\"{{ \'ROOM_LOCK_ENCODER.EDIT_ENCODER_URL\' | translate }}\" \ntitle=\"Edit\"><md-icon md-font-icon=\"icon-pencil\" class=\"s20\"></md-icon></md-button><md-button \nclass=\"md-icon-button encoder-edit-btn\" ng-if=\"!encoder.isNew && encoder.editing\" \nng-click=\"vm.cancelEditingEncoderUrl($index)\" aria-label=\"Cancel edit\" title=\"Cancel\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s20\"></md-icon></md-button><md-button class=\"md-icon-button encoder-delete-btn\" \nng-if=\"vm.encoderUrls.length > 1\" ng-click=\"vm.removeEncoderUrl($index)\" aria-label=\"Remove encoder URL\" \ntitle=\"Delete\"><md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></div></div></div></div><md-button\n type=\"button\" class=\"encoder-add-btn md-accent\" ng-click=\"vm.addEncoderUrl()\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"s18\"></md-icon><span translate=\"ROOM_LOCK_ENCODER.ADD_ENCODER_URL\"></span></md-button></div><div \nclass=\"encoder-panel common-door-panel\" ng-if=\"vm.enabled\"><div class=\"encoder-panel-heading\"><h3 \nclass=\"encoder-panel-title\" translate=\"ROOM_LOCK_ENCODER.COMMON_DOOR_TITLE\"></h3><p class=\"encoder-panel-description\" \ntranslate=\"ROOM_LOCK_ENCODER.COMMON_DOOR_DESC\"></p><p class=\"common-door-note\"><span \ntranslate=\"ROOM_LOCK_ENCODER.COMMON_DOOR_NOTE\"></span></p></div><input type=\"file\" id=\"commonDoorDbInput\" \nclass=\"common-door-file-input\" accept=\".mdb\" room-lock-file-change=\"vm.onDbFileSelected(file)\"><div \nclass=\"common-door-list-wrap\" ng-if=\"vm.visibleDoors.length\"><div class=\"common-door-list-header\" layout=\"row\" \nlayout-align=\"space-between center\"><md-checkbox class=\"md-primary no-margin\" \nng-checked=\"vm.selectedDoorCount === vm.visibleDoors.length\" \nmd-indeterminate=\"vm.selectedDoorCount > 0 && vm.selectedDoorCount < vm.visibleDoors.length\" \nng-click=\"vm.toggleAllDoors()\" ng-class=\"{\'md-checked\': vm.selectedDoorCount === vm.visibleDoors.length}\" \naria-label=\"Select all common doors\"><span translate=\"ROOM_LOCK_ENCODER.SELECT_ALL\"></span></md-checkbox><span \nclass=\"common-door-count\">{{ vm.selectedDoorCount }} / {{ vm.visibleDoors.length }}</span></div><div \nclass=\"common-door-list\"><md-checkbox class=\"md-primary common-door-item\" \nng-repeat=\"door in vm.visibleDoors track by door.id\" ng-model=\"door.is_enabled\" ng-change=\"vm.refreshDoors()\" \naria-label=\"{{door.name}}\">{{ door.name }}</md-checkbox></div></div><md-button type=\"button\" \nclass=\"encoder-add-btn md-accent\" ng-click=\"vm.openDbPicker()\" ng-disabled=\"vm.isloading\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s18\"></md-icon><span translate=\"ROOM_LOCK_ENCODER.SELECT_DB_FILE\"></span></md-button>\n</div></form></div></div></div>");
$templateCache.put("app/main/apps/settings/triggers/triggers.html","<div id=\"category\" \nclass=\"page-layout simple fullwidth element-doc-page lastcolumn_custom_three_icons message-center-triggers\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"content top-head\"><div class=\"content\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"main\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-flash\"></md-icon><span>Triggers</span></div><div class=\"product-count\"><span>\nTotal Triggers: </span><span>{{vm.totalTriggers || vm.triggers.length}}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{ \'SEARCH\' | translate }}\" ng-model=\"filterText\" flex></div><div class=\"logo\" layout=\"row\" \nlayout-align=\"center end\"><md-button class=\"md-raised md-cornered\" id=\"add-contact-button\" \nng-click=\"vm.openAddTrigger($event)\" aria-label=\"Add Trigger\"><i class=\"icon-plus icon-plus-main\"></i> Trigger\n</md-button></div></div></div></div></div><div class=\"content\"><div class=\"content\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"main RowClick\" ms-scroll><mdt-table \npaginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" selectable-rows=\"isDeletedAllowed\" \nalternate-headers=\"\'contextual\'\" selected-row-callback=\"selectedRowCallback(rows)\" \ndelete-row-callback=\"deleteSelectedItem()\" mdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" \nmdt-row-paginator-error-message=\"Ooops! Looks like we had a hiccup. Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n                        \'table-row-id-key\': \'id\',\n                        \'column-keys\': [\n                            \'name\',\n                            \'custom_message\',\n                            \'timing\',\n                            \'channel\',\n                            \'recipient_type\',\n                            \'is_active\',\n                            \'editTriggerId\'\n                        ],\n                    }\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>Trigger Name</span></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><span>Trigger Message</span></mdt-column><mdt-column align-rule=\"left\" \ncolumn-sort=\"true\"><span>Schedule</span></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>Channel\n</span></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>Recipients</span></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><span>Status</span></mdt-column><mdt-column align-rule=\"left\"><span></span>\n</mdt-column></mdt-header-row><mdt-custom-cell html-content=\"true\" column-key=\"name\"><span \nclass=\"text-truncate flex align-items-center\" ng-bind=\"value\"></span></mdt-custom-cell><mdt-custom-cell \nhtml-content=\"true\" column-key=\"custom_message\"><span class=\"text-truncate flex align-items-center\" ng-bind=\"value\">\n</span></mdt-custom-cell><mdt-custom-cell html-content=\"true\" column-key=\"timing\"><span \nclass=\"text-truncate flex align-items-center\" ng-bind=\"value\"></span></mdt-custom-cell><mdt-custom-cell \nhtml-content=\"true\" column-key=\"channel\"><span class=\"text-truncate flex align-items-center\" ng-bind=\"value\"></span>\n</mdt-custom-cell><mdt-custom-cell html-content=\"true\" column-key=\"recipient_type\"><span \nclass=\"text-truncate flex align-items-center\" ng-bind=\"value\"></span></mdt-custom-cell><mdt-custom-cell \nhtml-content=\"true\" column-key=\"is_active\"><i \nng-class=\"value==1?\'icon-checkbox-marked-circle green-500-fg\':\'icon-cancel red-500-fg\'\" class=\"\"></i></mdt-custom-cell>\n<mdt-custom-cell html-content=\"true\" column-key=\"editTriggerId\"><a style=\"cursor:pointer\" \nng-click=\"clientScope.goToEditPage(value)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s16 ng-scope md-default-theme md-font material-icons icon-pencil\" role=\"img\" aria-label=\"icon-cog\"></md-icon>\n</a></mdt-custom-cell></mdt-table></div></div></div></div>");
$templateCache.put("app/main/components/tables/datatable/datatable.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Tables</span></div><div \nclass=\"title\">Datatable</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"https://l-lin.github.io/angular-datatables\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div \nclass=\"md-title mb-32\">Zero Configuration</div><div class=\"white-bg md-whiteframe-4dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Position</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Office</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Age</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Start Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Salary</span></div></th></tr></thead><tbody><tr \nng-repeat=\"employee in ::vm.employees\"><td>{{ employee.name }}</td><td>{{ employee.position }}</td><td>\n{{ employee.office }}</td><td>{{ employee.age }}</td><td>{{ employee.startDate }}</td><td>{{ employee.salary }}</td>\n</tr></tbody></table></div></div></div>");
$templateCache.put("app/main/components/tables/simple-table/simple-table.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Tables</span></div><div \nclass=\"title\">Simple Table</div></div></div><div class=\"content\">\nTables are used to present raw data sets, and usually appear in desktop enterprise products.<p>Data sets may include:\n</p><ul><li>Three or more columns of data</li><li>A corresponding visualization</li><li>\nThe ability for users to query and manipulate data at scale</li></ul><div \nclass=\"simple-table-container md-whiteframe-4dp\"><div class=\"table-title\">Employees</div><table class=\"simple\" \nms-responsive-table><thead><tr><th>Name</th><th>Position</th><th>Office</th><th class=\"text-right\">Age</th><th \nclass=\"text-right\">Start Date</th><th class=\"text-right\">Salary</th></tr></thead><tfoot><tr><td></td></tr></tfoot>\n<tbody><tr ng-repeat=\"person in vm.employees\"><td class=\"name\">{{person.name}}</td><td class=\"position\">\n{{person.position}}</td><td class=\"office\">{{person.office}}</td><td class=\"age text-right\">{{person.age}}</td><td \nclass=\"start-date text-right\">{{person.startDate}}</td><td class=\"salary text-right\">{{person.salary | currency}}</td>\n</tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo\"><span><img src=\"./assets/images/logos/login-logo.png\" alt=\"Lodging System\"></span></div><div \nclass=\"title\" translate=\"FORGOTPASSWORD.TITLE\"></div><div ng-if=\"vm.errorMessage\" class=\"cross-div\"><span \nclass=\"error-noLogin-page\">{{ vm.errorMessage }}<i class=\"icon-close\" ng-click=\"vm.disableClose();\"></i></span></div>\n<div ng-if=\"vm.success\" class=\"title cross-div\"><span class=\"success-noLogin-page\">{{vm.ResetLink}}<i \nclass=\"icon-close\" ng-click=\"vm.disableClose();\"></i></span></div><form name=\"forgotPasswordForm\" novalidate>\n<md-input-container class=\"md-block mb-0\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" \nrequired><div ng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\"></span></div><div ng-message=\"pattern\">\n<span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\"></span></div></div></md-input-container><md-button \ntype=\"submit\" \nng-class=\"!forgotPasswordForm.$invalid || vm.requestProgressing?\'md-raised md-cyan-A800-bg white-500-fg submit-button\':\'md-raised submit-button\'\" \naria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine || vm.requestProgressing\" \ntranslate=\"FORGOTPASSWORD.SEND_RESET_LINK\" translate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\" \nng-click=\"vm.generateResetPassLink();\"></md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\">\n<a class=\"link red-A800-fg\" ui-sref=\"app.pages_auth_login\" translate=\"FORGOTPASSWORD.GO_BACK\"></a></div></div></div>\n</div>");
$templateCache.put("app/main/pages/auth/login/login-via-secret-code.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo\"><span><img src=\"./assets/images/logos/login-logo.png\" alt=\"Lodging System\"></span></div><div \nclass=\"title\">Login Via 5 Digit Code</div><div ng-if=\"vm.errorMessage\" class=\"cross-div\"><span \nclass=\"error-noLogin-page\">{{ vm.errorMessage }}<i class=\"icon-close\" ng-click=\"vm.disableClose();\"></i></span></div>\n<form name=\"loginViaSecretCode\" novalidate><md-input-container class=\"md-block mb-0\" md-no-float><input \ntype=\"password\" name=\"secretNumber\" ng-model=\"vm.secretCode\" placeholder=\"Secret Code\" translate \nng-pattern=\"/^[0-9]{5}$/\" required><div ng-messages=\"loginViaSecretCode.secretNumber.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\"></span></div><div\n ng-message=\"pattern\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\"></span></div></div></md-input-container>\n<md-button type=\"submit\" \nng-class=\"!loginViaSecretCode.$invalid || vm.requestProgressing?\'md-raised md-cyan-A800-bg white-500-fg submit-button\':\'md-raised submit-button\'\" \naria-label=\"RESET MY PASSWORD\" \nng-disabled=\"loginViaSecretCode.$invalid || loginViaSecretCode.$pristine || vm.requestProgressing\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\" ng-click=\"vm.loginViaSecretCode();\"></md-button>\n</form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link red-A800-fg\" \nui-sref=\"app.pages_auth_login\" translate=\"FORGOTPASSWORD.GO_BACK\"></a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><span><img \nsrc=\"./assets/images/logos/login-logo.png\" alt=\"Lodging System\"></span></div><div class=\"title\" \ntranslate=\"LOGIN.TITLE\"></div><div class=\"title\">{{vm.loadingmessage}}</div><div ng-if=\"vm.type\" \nclass=\"title cross-div\"><span ng-class=\"vm.type==\'error\'?\'error-noLogin-page\':\'success-noLogin-page\'\">\n{{ vm.successMessage }}<i class=\"icon-close\" ng-click=\"vm.disableClose();\"></i></span></div><form \nui-keypress=\"{13:\'vm.checklogin()\'}\" name=\"loginForm\" novalidate action=\"/dashboard-project\"><md-input-container \nclass=\"md-block no-margin\" md-no-float><input type=\"email\" name=\"email\" \nng-keyup=\"$event.keyCode == 13 && vm.checklogin()\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"loginForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\"></span></div>\n<div ng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\"></span></div></div></md-input-container>\n<md-input-container class=\"md-block no-margin password-field-container\" md-no-float><input \nng-attr-type=\"{{vm.showPassword ? \'text\' : \'password\'}}\" class=\"password-input-with-toggle\" name=\"password\" \nng-keyup=\"$event.keyCode == 13 && vm.checklogin()\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOGIN.PASSWORD\" required> <button type=\"button\" class=\"password-toggle-button\" \nng-click=\"vm.togglePasswordVisibility()\" aria-label=\"{{vm.showPassword ? \'Hide password\' : \'Show password\'}}\"><md-icon \nmd-font-icon=\"{{vm.showPassword ? \'icon-eye-off\' : \'icon-eye\'}}\"></md-icon></button><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\"></span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><a \nui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color red-A800-fg\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\"></a></div><div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><a href=\"https://www.lodgingsystem.com/terms-and-conditions/\" target=\"_blank\" \nclass=\"forgot-password md-accent-color red-A800-fg onlycursorPointer\" translate=\"LOGIN.TERMS_AND_COND\"></a></div>\n<md-button type=\"button\" \nng-class=\"!loginForm.$invalid && !loginForm.$pristine?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-accent submit-button\'\" \naria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine || vm.buttonActive==1\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\" ng-click=\"vm.checklogin();\">LOG IN</md-button></form>\n</div></div></div>");
$templateCache.put("app/main/pages/auth/register/register.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><span><img \nsrc=\"./assets/images/logos/login-logo.png\" alt=\"Lodging System\"></span></div><div class=\"title\" \ntranslate=\"REGISTER.TITLE\"></div><div ng-if=\"vm.errorMessage\" class=\"cross-div\"><span class=\"error-noLogin-page\">\n{{ vm.errorMessage }}<i class=\"icon-close\" ng-click=\"vm.disableClose();\"></i></span></div><div \nng-if=\"vm.successMessage\" class=\"title cross-div\"><span class=\"success-noLogin-page\">{{vm.successMessage}}<i \nclass=\"icon-close\" ng-click=\"vm.disableClose();\"></i></span></div><form name=\"registerForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input name=\"firstname\" ng-model=\"vm.form.firstname\" translate \ntranslate-attr-placeholder=\"REGISTER.FIRST_NAME\" required><div ng-messages=\"registerForm.firstname.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.FNAME_REQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input name=\"lastname\" \nng-model=\"vm.form.lastname\" translate translate-attr-placeholder=\"REGISTER.LAST_NAME\" required><div \nng-messages=\"registerForm.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.LNAME_REQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" translate \ntranslate-attr-placeholder=\"REGISTER.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required email-unique><div \nng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_REQUIRED\"></span></div><div ng-message=\"pattern\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\"></span></div><div ng-message=\"email-unique\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_EXISTS\"></span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.password\" translate \ntranslate-attr-placeholder=\"REGISTER.PASSWORD\" required min-password><div ng-messages=\"registerForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\"></span></div><div \nng-message=\"min-password\"><span translate=\"REGISTER.ERRORS.MIN_PASSWORD\"></span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"vm.form.passwordConfirm\" translate translate-attr-placeholder=\"REGISTER.PASSWORD_CONFIRM\" required \npwd-and-cnfm-same><div ng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\"></span></div><div ng-message=\"pwd-and-cnfm-same\"><span \ntranslate=\"REGISTER.ERRORS.SAME_PASSWORD\"></span></div></div></md-input-container><div class=\"terms\" layout=\"row\" \nlayout-align=\"center center\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\"><span \ntranslate=\"REGISTER.READ_ACCEPT\"></span> <a href=\"#\" class=\"link md-accent-color\" translate=\"REGISTER.TERMS_COND\"></a>\n</div></div><md-button type=\"button\" \nng-class=\"!registerForm.$invalid && !registerForm.$pristine?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-accent submit-button\'\" \naria-label=\"CREATE MY ACCOUNT\" ng-disabled=\"registerForm.$invalid || registerForm.$pristine || vm.buttonActive==1\" \ntranslate=\"REGISTER.CREATE_ACCOUNT\" translate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\" ng-click=\"vm.signup();\" \ntranslate=\"REGISTER.CREATE_ACCOUNT\"></md-button></form><div class=\"login\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"center center\"><span class=\"text\" translate=\"REGISTER.ALREADY_HAVE\"></span> <a class=\"link\" \nui-sref=\"app.pages_auth_login\" translate=\"REGISTER.LOGIN\"></a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/resetpassword/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\">\n<span><img src=\"./assets/images/logos/login-logo.png\" alt=\"Lodging System\"></span></div><div class=\"title\" \ntranslate=\"RESETPASSWORD.TITLE\"></div><div ng-if=\"vm.success\" class=\"title\" translate=\"RESETPASSWORD.NEWPASS\" \nstyle=\"color: green;font-size: 12px\">{{vm.message}}</div><div ng-if=\"vm.type\" class=\"title cross-div\"><span \nclass=\"error-noLogin-page\">{{ vm.errorMessage }}<i class=\"icon-close\" ng-click=\"vm.disableClose();\"></i></span></div>\n<form name=\"resetPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.PASSWORD\" required min-password><div \nng-messages=\"resetPasswordForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\"></span></div><div ng-message=\"min-password\"><span \ntranslate=\"RESETPASSWORD.ERRORS.MIN_PASSWORD\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" \nplaceholder=\"Password (Confirm)\" translate translate-attr-placeholder=\"RESETPASSWORD.PASSWORD_CONFIRM\" required \npwd-and-cnfm-same><div ng-messages=\"resetPasswordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"RESETPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\"></span></div><div ng-message=\"pwd-and-cnfm-same\"><span\n translate=\"RESETPASSWORD.ERRORS.SAME_PASSWORD\"></span></div></div></md-input-container><md-button type=\"submit\" \nng-class=\"!resetPasswordForm.$invalid && !resetPasswordForm.$pristine?\'white-500-fg md-raised md-accent submit-button\':\'md-raised md-accent submit-button\'\" \naria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" \ntranslate=\"RESETPASSWORD.UPDATE_PASSWORD\" translate-attr-aria-label=\"RESETPASSWORD.UPDATE_PASSWORD\" \nng-click=\"vm.generateNewPass();\"></md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a \nui-sref=\"app.pages_auth_login\" class=\"link forgot-password md-accent-color\" translate=\"LOGIN.BACKTOLOGIN\"></a></div>\n</div></div></div>");
$templateCache.put("app/main/ui/page-layouts/blank/blank.html","<div class=\"page-layout blank\" layout=\"row\"><h2>Blank page</h2></div>");
$templateCache.put("app/main/ui/page-layouts/demo/demo-content.html","<div class=\"demo-content\"><img src=\"assets/images/etc/early-sunrise.jpg\" class=\"md-card-image\" alt=\"sunrise\"><h1>\nEarly Sunrise</h1><h4 class=\"secondary-text\">Demo Content</h4><p>\nOne morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections.\n</p><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What\'s happened to me? \" he thought. It wasn\'t a dream.\n</p><footer>John Doe</footer></blockquote><p>\nHis room, a proper human room although a little too small, lay peacefully between its four familiar walls. A collection of textile samples lay spread out on the table - Samsa was a travelling salesman - and above it there hung a picture that he had recently cut out of an illustrated magazine and housed in a nice, gilded frame.\n</p><p>\nIt showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arm towards the viewer. Gregor then turned to look out the window at the dull weather. Drops of rain could be heard hitting the pane, which made him feel quite sad.\n</p><p>\n\"How about if I sleep a little bit longer and forget all this nonsense\", he thought, but that was something he was unable to do because he was used to sleeping on his right, and in his present state couldn\'t get into that position. However hard he threw himself onto his right, he always rolled back to where he was.\n</p><p>\nHe must have tried it a hundred times, shut his eyes so that he wouldn\'t have to look at the floundering legs, and only stopped when he began to feel a mild, dull pain there that he had never felt before. \"Oh, God\", he thought, \"what a strenuous career it is that I\'ve chosen!\n</p><p>\nTravelling day in and day out. Doing business like this takes much more effort than doing your own business at home, and on top of that there\'s the curse of travelling, worries about making train connections, bad and irregular food, contact with different people all the time so that you can never get to know anyone or become friendly with them.\n</p><p>\n\"He felt a slight itch up on his belly; pushed himself slowly up on his back towards the headboard so that he could lift his head better; found where the itch was, and saw that it was covered with lots of little white spots which he didn\'t know what to make of; and when he tried to feel the place with one of his legs he drew it quickly back because as soon as he touched it he was overcome by a cold shudder. He slid back into his former position.\n</p><p>\n\"Getting up early all the time\", he thought, \"it makes you stupid. You\'ve got to get enough sleep. Other travelling salesmen live a life of luxury. For instance, whenever I go back to the guest house during the morning to copy out the contract, these gentlemen are always still sitting there eating their breakfasts. I ought to just try that with my boss; I\'d get kicked out on the spot. But who knows, maybe that would be the best thing for me...\n</p></div>");
$templateCache.put("app/main/ui/page-layouts/demo/demo-sidenav.html","<div class=\"demo-sidenav\"><md-list><md-subheader class=\"md-no-sticky\">Sidenav Demo</md-subheader><md-list-item><p>\nSidenav Item 1</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 2</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 3</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 4</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 5</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 6</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 7</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 8</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 9</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 10</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 11</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 12</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 13</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 14</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 15</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 16</p></md-list-item></md-list></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/apps/checkout/posorders/order/posorder.html","<div class=\"page-layout simple tabbed view-order new-page\" layout=\"column\" id=\"create-res\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex flex-gt-sm=\"70\"><md-button class=\"goto-products-button md-icon-button\" \nng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2 smsizeres\">\n{{vm.order.itinerary_number +\" | \"+vm.order.first_name+\" \"+vm.order.last_name}}</div></div></div></div><div \nlayout=\"row\" flex layout-align=\"center end\"><div layout=\"column\" flex=\"100\" layout-align=\"center end\"><div \nclass=\"md-iconheader\"><md-icon md-svg-src=\"assets/icons/tip.svg\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" ng-click=\"vm.addTipToThisOrder()\"><md-tooltip>\nAdd Tip to This Order</md-tooltip></md-icon><md-icon md-font-icon=\"icon-glass-mug\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" ng-click=\"vm.addBarToThisOrder()\"><md-tooltip>\nAdd Product</md-tooltip></md-icon><md-icon md-font-icon=\"icon-email\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" ng-click=\"vm.sendEmailInit()\"><md-tooltip>\n{{\'CREATE_RES.SEND_INVOICE\' | translate}}</md-tooltip></md-icon><md-icon md-font-icon=\"icon-printer\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" ng-click=\"vm.printOrderInvoice()\"><md-tooltip>\n{{\'CREATE_RES.PRINT\' | translate}}</md-tooltip></md-icon></div></div></div></div><div \nclass=\"content content-scroll relative-block tab-container-section\"><md-progress-linear md-mode=\"indeterminate\" \nng-show=\"vm.isloading\"></md-progress-linear><div class=\"md-whiteframe-1dp height\"><div \nclass=\"role-list-outer height-main\"><div class=\"heightless45\"><div class=\"md-padding\" style=\"height:100%\" \nclass=\"md-tabs-inner\"><div class=\"genral-block-top-outer\"><div layout=\"row\" layout-wrap flex=\"100\" class=\"mt-20\"><div \nlayout=\"column\" flex=\"100\"><div class=\"genereal-div\"><div class=\"no-padding role-list-out featured-rol-block\"><div \nclass=\"roomName ph-15 pb-10\" layout=\"row\" flex><div class=\"room-col\" layout=\"column\" flex=\"100\"><div layout=\"row\" flex \nlayout-wrap><div layout=\"column\" flex=\"100\" layout-align=\"center start\"><div class=\"row-containerstaus\"><strong>\nBilling Informatiom</strong></div></div></div></div></div><div class=\"white-bg padding-15\"><div \nclass=\"Restaurant-items-billing\"><div class=\"Restaurant-billing-row\"><div class=\"Restaurant-billing-col\"><small>Name\n</small><p>{{vm.order.first_name}} {{vm.order.last_name}}</p></div><div class=\"Restaurant-billing-col\"><small>Address\n</small><p>{{vm.order.address}}</p></div><div class=\"Restaurant-billing-col\"><small>city</small><p>{{vm.order.city}}\n</p></div><div class=\"Restaurant-billing-col\"><small>State</small><p>{{vm.order.state}}</p></div><div \nclass=\"Restaurant-billing-col\"><small>zip code</small><p>{{vm.order.zip_code}}</p></div><div \nclass=\"Restaurant-billing-col\"><small>Country</small><p>{{vm.order.country}}</p></div><div \nclass=\"Restaurant-billing-col\"><small>phone</small><p>{{vm.order.phone}}</p></div><div class=\"Restaurant-billing-col\">\n<small>Seconday phone</small><p>{{vm.order.secondary_phone_number}}</p></div><div class=\"Restaurant-billing-col\">\n<small>Email</small><p>{{vm.order.customer_email}}</p></div></div></div></div></div></div></div></div><div \nlayout=\"row\" layout-wrap flex=\"100\" class=\"mt-20\"><div layout=\"column\" flex=\"100\" flex-sm=\"100\" flex-xs=\"100\"><div \nclass=\"left-section-genral-infomation\"><div class=\"genereal-div\"><div \nclass=\"role-list-out white-bg relative-block featured-block-main no-padding featured-rol-block\"><div \nclass=\"display-inline-block scroll-sm-blk-311\"><div class=\"pos_general_div\" \nng-repeat=\"(poskey, posValue) in vm.order.pos track by $index\"><div class=\"nightly-price-latest padding-20\" \nng-if=\"posValue.showRestaurantOptions == 0\"><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"row-nightly-header-amount row-block1-amount\"><div layout=\"column\" flex-gt-md=\"70\" flex-gt-xs=\"60\" flex=\"100\" \nlayout-align=\"center start\"><div class=\"big-txt-night pb-10 capitalize\">{{posValue.product_name}}</div><div \nng-if=\"posValue.is_gift_card == 1\"><span class=\"gcinfo\"><b>Customer:</b> {{posValue.gc_sender_name}} (<a \nhref=\"mailto:{{posValue.gc_sender_email}}\">{{posValue.gc_sender_email}}</a>) </span><span class=\"gcinfo\"><b>Recipient:\n</b> {{posValue.gc_recipient_name}} (<a href=\"mailto:{{posValue.gc_recipient_email}}\">{{posValue.gc_recipient_email}}\n</a>) </span><span class=\"gcinfo\"><b>Message:</b> {{posValue.gc_message}} </span><span class=\"gcinfo\"><b>Code:</b>\n {{posValue.gc_code}}</span></div><div \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"fromToInfo fromto-info-color datepickerfromtoorder no-margin\" \nng-if=\"posValue.product_is_timebound == 1 && posValue.is_timebound_with_availability == 0\"><div \nclass=\"fromInfo onlycursorPointer\"><md-input-container class=\"md-block full-width\"><label \ntranslate=\"CREATE_RES.CHECKIN\"></label><md-datepicker ng-disabled=\"posValue.auto_added == 1\" md-open-on-focus \nng-model=\"posValue.room_stay_from\" md-min-date=\"vm.minDate\" ng-model-options=\"{debounce: 400}\" \nng-change=\"vm.startDateModified(poskey);vm.setShowModifyBtn(\'Start Date\',\'room_stay_from\',poskey);\" \nclass=\"full-width mdinput-block\" changecheckout></md-datepicker><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div class=\"toInfo onlycursorPointer\"><md-input-container class=\"md-block full-width mb-0\">\n<label translate=\"CREATE_RES.CHECKOUT\"></label><md-datepicker ng-disabled=\"posValue.auto_added == 1\" md-open-on-focus \nng-model-options=\"{debounce: 400}\" ng-model=\"posValue.room_stay_to\" md-min-date=\"vm.endDateMin\" \nng-change=\"vm.endDateModified(posValue.room_stay_to,poskey,$event);vm.setShowModifyBtn(\'End Date\',\'room_stay_to\',poskey);vm.datesChanged(poskey)\" \nclass=\"full-width mdinput-block\"></md-datepicker><div class=\"md-errors-spacer\"></div></md-input-container></div></div>\n<div class=\"fromToInfo fromto-info-color datepickerfromtoorder no-margin\" \nng-if=\"posValue.product_is_timebound == 1 && posValue.is_timebound_with_availability == 1\" \nng-click=\"vm.editParkingDates(event,posValue.room_stay_from,posValue.room_stay_to,0,0,posValue.confirmation_number,posValue.product_id,posValue.product_name,vm.order.policy_id);\">\n<div class=\"fromInfo onlycursorPointer\"><img src=\"assets/images/ecommerce/from-black.svg\"> {{posValue.room_stay_from}}\n</div><div class=\"toInfo onlycursorPointer\"><img src=\"assets/images/ecommerce/to-black.svg\">{{posValue.room_stay_to}}\n</div></div></div><div layout=\"column\" flex-gt-md=\"30\" flex-gt-xs=\"40\" flex=\"100\" layout-align=\"end end\"><div \nclass=\"active-input-block\"><div class=\"input-block-status\"><md-input-container class=\"md-block mb-0 no-margin\">\n<md-select placeholder=\"status\" ng-model=\"vm.pos_status[poskey]\" \nng-init=\"vm.pos_status[poskey]=posValue.room_stay_status\" \nng-change=\"vm.changeStatusForService(event,posValue.confirmation_number,posValue.room_stay_status,vm.pos_status[poskey],poskey,posValue.grand_total,vm.order.room_confirmation_number)\">\n<md-option ng-value=\"key\" ng-repeat=\"(key, value) in vm.statusesPos[poskey]\">{{value}}</md-option></md-select>\n</md-input-container></div><div class=\"amount\" ng-class=\"(posValue.room_stay_status == \'Canceled\') ? \'strike\' : \'\'\">\n{{posValue.grand_total}}</div></div></div></div><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"row-nightly-amount row-block1-amount\" ng-if=\"posValue.product_is_timebound != 1\"><div layout=\"column\" flex=\"55\" \nlayout-align=\"center start\"><div class=\"charges\">Quantity</div></div><div layout=\"column\" flex=\"15\" \nlayout-align=\"center center\"></div><div layout=\"column\" flex=\"30\" layout-align=\"center end\"><div class=\"amount\" \nng-class=\"(posValue.room_stay_status == \'Canceled\') ?  \'canceled_order strikeinput\' : (vm.modify_request ? \'canceled_order\':\'\')\">\n<md-input-container class=\"md-block no-margin\"><input readonly=\"readonly\" ng-model=\"posValue.quantity\" \nname=\"nightlySum[$index]\" type=\"text\" \nng-click=\"vm.startEditingOrderAmounts(\'quantity\', \'Quantity\', poskey, posValue.quantity);\" \nng-model-options=\"{updateOn: \'blur\'}\" numbers-only ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div></div></div><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"row-nightly-amount row-block1-amount\" ng-if=\"posValue.product_is_timebound != 1\"><div layout=\"column\" flex=\"55\" \nlayout-align=\"center start\"><div class=\"charges\">Rate</div></div><div layout=\"column\" flex=\"15\" \nlayout-align=\"center center\"></div><div layout=\"column\" flex=\"30\" layout-align=\"center end\"><div class=\"amount\" \nng-class=\"(posValue.room_stay_status == \'Canceled\') ? \'canceled_order strikeinputbigWid\' : (vm.modify_request ? \'canceled_order\':\'\')\">\n<md-input-container class=\"md-block mb-0 no-margin\"><i class=\"icon icon-currency-usd s20\"></i><input \nreadonly=\"readonly\" ng-model=\"posValue.nightlySum\" name=\"nightlySum[$index]\" type=\"text\" \nng-click=\"vm.startEditingOrderAmounts(\'subtotal\', \'Rate\', poskey, posValue.nightlySum);\" \nng-model-options=\"{updateOn: \'blur\'}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div></div>\n</div><div layout=\"row\" flex=\"100\" layout-wrap class=\"row-nightly-amount row-block1-amount\" \nng-if=\"posValue.product_is_timebound != 1\"><div layout=\"column\" flex=\"55\" layout-align=\"center start\"><div \nclass=\"charges\">Discount</div></div><div layout=\"column\" flex=\"15\" layout-align=\"center center\"></div><div \nlayout=\"column\" flex=\"30\" layout-align=\"center end\"><div class=\"amount\" \nng-class=\"(posValue.room_stay_status == \'Canceled\') ? \'canceled_order strikeinputbigWid\' : (vm.modify_request ? \'canceled_order\':\'\')\">\n<md-input-container class=\"md-block mb-0 no-margin\"><i class=\"icon icon-currency-usd s20\"></i><input \nreadonly=\"readonly\" ng-model=\"posValue.product_discount\" name=\"productDiscount[$index]\" type=\"text\" \nng-click=\"vm.startEditingOrderAmounts(\'product_discount\', \'Discount\', poskey, posValue.product_discount);\" \nng-model-options=\"{updateOn: \'blur\'}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"> <i \nng-if=\"posValue.product_discount>0\" class=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.opencommentbox(poskey);\"><md-tooltip ng-if=\"posValue.product_discount_comment!=\'\'\">\n{{posValue.product_discount_comment}}</md-tooltip></i></md-input-container></div></div></div></div><div \nclass=\"Restaurant-outer-col1 remmarbox\" ng-if=\"posValue.showRestaurantOptions == 1\"><div class=\"top-block-res\"><div \nclass=\"heading-food\"><span>{{posValue.product_name}}</span><div class=\"seafood_price\"><md-input-container \nclass=\"md-block\"><md-select placeholder=\"status\" ng-model=\"vm.pos_status[poskey]\" \nng-init=\"vm.pos_status[poskey]=posValue.room_stay_status\" \nng-change=\"vm.changeStatusForService(event,posValue.confirmation_number,posValue.room_stay_status,vm.pos_status[poskey],poskey,posValue.grand_total,vm.order.room_confirmation_number)\">\n<md-option ng-value=\"key\" ng-repeat=\"(key, value) in vm.statusesPos[poskey]\">{{value}}</md-option></md-select>\n</md-input-container><span ng-class=\"(posValue.room_stay_status == \'Canceled\') ? \'strike\' : \'\' \">\n${{posValue.restaurant_product_amount | number:2}}</span></div></div><div class=\"tags-seafood\"><span \nng-repeat=\"value in posValue.restaurant_product_ingrediants\">{{value}} <i class=\"icon-check icon-check\"></i></span>\n</div><div class=\"quentityblock\"><span>Quantity: <b \nng-class=\"(posValue.room_stay_status == \'Canceled\') ? \'strike\' : \'\' \">{{posValue.quantity}}</b></span></div></div><div \nclass=\"middle-block-res\" ng-if=\"posValue.restaurantAddons.length\"><div class=\"Restaurant-table-block\" layout=\"row\" \nlayout-wrap flex><div class=\"Restaurant-col-block heading extra\" layout=\"column\">Extras</div><div \nclass=\"Restaurant-col-block heading peritem\" layout=\"column\">Per item</div><div \nclass=\"Restaurant-col-block heading qty\" layout=\"column\">Qty</div><div class=\"Restaurant-col-block heading subtotal\" \nlayout=\"column\">Subtotal</div></div><div class=\"Restaurant-table-block\" ng-repeat=\"value in posValue.restaurantAddons\" \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"Restaurant-col-block extra\" layout=\"column\">{{value.name}}</div><div \nclass=\"Restaurant-col-block peritem\" layout=\"column\">${{value.price | number:2}}</div><div \nclass=\"Restaurant-col-block qty\" layout=\"column\">{{value.quantity}}</div><div class=\"Restaurant-col-block subtotal\" \nlayout=\"column\" ng-if=\"posValue.room_stay_status == \'Canceled\'\"><s>${{value.price * value.quantity | number:2}}</s>\n</div><div class=\"Restaurant-col-block subtotal\" layout=\"column\" ng-if=\"posValue.room_stay_status != \'Canceled\'\">\n${{value.price * value.quantity | number:2}}</div></div></div><div class=\"middle-block-footer\"><div \nclass=\"note-block-outer\" layout=\"row\" flex=\"100\" layout-align=\"start stretch\"><div class=\"note-block\" layout=\"column\" \nlayout-align=\"start start\"><p><b>Note</b> {{posValue.restaurant_product_note}}</p></div><div class=\"total-block\" \nlayout=\"column\"><div layout=\"row\" flex=\"100\" class=\"res-total layout-column flex-50 layout-align-center-start\"><span \nlayout=\"column\" flex=\"50\" class=\"layout-column flex-50 layout-align-center-start\">Discount</span><md-input-container \nclass=\"md-block mb-0 no-margin\" layout=\"column\" flex=\"50\" \nng-class=\"(posValue.room_stay_status == \'Canceled\') ? \'strikeinputNew\' : \'\' \"><i class=\"icon icon-currency-usd s20\">\n</i><input style=\"float: right !important; width: 75px; position: relative; bottom: 5px; text-align: right\" \nreadonly=\"readonly\" ng-model=\"posValue.product_discount\" name=\"productDiscount[$index]\" type=\"text\" \nng-click=\"vm.startEditingOrderAmounts(\'product_discount\', \'Discount\', poskey, posValue.product_discount);\" \nng-model-options=\"{updateOn: \'blur\'}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"> <i \nng-if=\"posValue.product_discount>0\" class=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.opencommentbox(poskey);\"><md-tooltip ng-if=\"posValue.product_discount_comment!=\'\'\">\n{{posValue.product_discount_comment}}</md-tooltip></i></md-input-container></div><div layout=\"row\" flex=\"100\" \nclass=\"res-total total-bold\"><span layout=\"column\" flex=\"50\" class=\"layout-align-center-start\">Total</span> <span \nlayout=\"column\" flex=\"50\" layout-align=\"center center\" ng-if=\"posValue.room_stay_status == \'Canceled\'\"><s>\n${{posValue.grand_total}}</s></span> <span layout=\"column\" flex=\"50\" layout-align=\"center center\" \nng-if=\"posValue.room_stay_status != \'Canceled\'\">${{posValue.grand_total}}</span></div></div></div></div></div><div \nclass=\"nightly-price-heading\" ng-if=\"posValue.product_is_timebound == 1\" \nng-class=\"posValue.room_stay_status == \'Canceled\'?\'canceled_order\':\'\'\">Nightly-price<div layout=\"row\" flex=\"100\" \nlayout-wrap class=\"row-block1-amount row-header-amount\"><div layout=\"column\" flex=\"30\" layout-align=\"center start\">\nNight</div><div layout=\"column\" flex=\"30\" layout-align=\"center start\">Date</div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center end\">Discount</div><div layout=\"column\" flex=\"20\" layout-align=\"center end\">Price</div></div><div \nlayout=\"row\" ng-repeat=\"(datekey ,eachDate) in posValue.prices.dates\" flex=\"100\" layout-wrap \nclass=\"row-nightly-amount row-block1-amount\"><div layout=\"column\" flex=\"30\" layout-align=\"center start\"><div \nclass=\"minusiconouter\"><div class=\"charges\">Night {{$index+1}}</div></div></div><div layout=\"column\" flex=\"30\" \nlayout-align=\"center start\"><div>{{eachDate}}</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center end\"><div \nclass=\"amount\"><md-input-container class=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i><input \nng-model=\"posValue.prices.nightlydiscount[$index]\" name=\"nightly_discount_pos[$parent.$index][$index]\" type=\"text\" \nreadonly=\"readonly\" \nng-click=\"vm.startEditingOrderAmounts(\'nightlydiscount\', \'night-\'+($index+1), poskey, posValue.prices.nightlydiscount[$index],$index);\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"> <i ng-if=\"posValue.prices.nightlydiscount[$index]>0\" \nclass=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.opencommentboxNightPOS(poskey,\'call\',$index);\"><md-tooltip \nng-if=\"posValue.prices.nightlydiscountcomment[$index]!=\'\'\">{{posValue.prices.nightlydiscountcomment[$index]}}\n</md-tooltip></i></md-input-container></div></div><div layout=\"column\" flex=\"20\" layout-align=\"center end\"><div \nclass=\"amount\"><md-input-container class=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i><input \nng-model=\"posValue.prices.rates[datekey]\" name=\"rate_plan[$parent.$index][$index]\" type=\"text\" readonly=\"readonly\" \nng-click=\"vm.startEditingOrderAmounts(\'prices\', \'night-\'+($index+1), poskey, posValue.prices.rates[$index],$index);\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div></div></div></div></div></div></div></div>\n</div></div></div><div layout=\"row\" flex=\"100\" class=\"mt-20\"><div layout=\"column\" flex=\"100\" flex-sm=\"100\" \nflex-xs=\"100\" class=\"ph-15 pb-20 mb-40\"><div layout=\"row\" flex=\"100\" class=\"white-bg\" layout-wrap><div layout=\"column\" \nflex-gt-md=\"70\" flex-gt-sm=\"60\" flex=\"100\"><div class=\"gry-block-tab pv-0 paymentblocktab no-padding\" \nid=\"data-table-{{$index}}\"><form name=\"EditResPaymentForm\" ng-attr-id=\"{{ \'EditResPaymentForm\' }}\"><div \nclass=\"p-20 white-bg\"><div class=\"form-title mb-20 payment-font\">Payment Information</div><div \nng-if=\"vm.showPaymentsLoader\" class=\"relative-block pt-15\"><md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\"></md-progress-circular></div><div \nng-if=\"!vm.showPaymentsLoader\"><div class=\"roomTable\" layout=\"row\" flex layout-wrap><div class=\"room-col\" \nlayout=\"column\" flex=\"100\"><table class=\"dataTable row-border no-padding\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsForPayment\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Transaction Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Paid Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Agent</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Payment</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Customer name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Action</span></div></th><th class=\"secondary-text\" ng-hide=\"true\"><div class=\"table-header\"><span \nclass=\"column-title\">Installment id</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key,installment) in vm.installments\" ng-if=\"key != \'remaining\' && installment.amount>0\"><td>\n{{installment.transaction_id}}</td><td>{{installment.paid_date}}</td><td><span \nng-class=\"installment.status == \'declined\'?\'red-A800-fg\':\'\'\" class=\"refundreason\">{{installment.status}} <i \nng-if=\" installment.reason != \'\' \" class=\"icon icon-comment-outline onlycursorPointer discountcomment\"><md-tooltip \nclass=\"tooltippaymentrefund\">{{ installment.reason }}</md-tooltip></i></span></td><td>{{installment.agent}}</td><td>\n{{installment.payment}}</td><td>{{installment.cust_name}}</td><td><span \nng-if=\"installment.status == \'paid\' || installment.status == \'declined\'\">{{installment.amount | currency : $ : 2}}\n</span> <span ng-if=\"installment.status == \'refunded\'\" class=\"red-A800-fg\">-{{installment.amount | currency : $ : 2}}\n</span></td><td><md-button style=\"max-width:100px;max-height:35px;opacity: 1;pointer-events: all\" \nclass=\"md-raised md-accent submit-button white-fg\" ng-click=\"vm.refundInstallment(installment,\'refund\')\" \naria-label=\"Refund\" \nng-if=\"(installment.transaction_status == \'Settled Successfully\' || installment.transaction_status == \'\') && (installment.installment_amount != 0) && (installment.status == \'paid\')\">\nRefund</md-button><md-button style=\"max-width:100px;max-height: 35px;opacity: 1;pointer-events: all\" \nclass=\"md-raised md-accent submit-button white-fg md-red-500-bg\" ng-click=\"vm.refundInstallment(installment,\'void\')\" \naria-label=\"Refund\" \nng-if=\"(installment.transaction_status == \'capturedPendingSettlement\') && installment.installment_amount != 0 && installment.rm_adjustment_indicator == 0 && installment.status == \'paid\'\">\nVoid</md-button><span ng-if=\"installment.transaction_status == \'voided\'\">Voided</span> <span \nng-if=\"installment.transaction_status != \'voided\' && (installment.transaction_status != \'Settled Successfully\' || (installment.transaction_status == \'Settled Successfully\' && installment.installment_amount == 0)) && installment.transaction_status != \'capturedPendingSettlement\'\">\n{{installment.transaction_status}}</span></td><td ng-hide=\"true\">{{installment.installment_id}}</td></tr></tbody>\n</table></div></div><div layout=\"row\" layout-wrap flex=\"100\" class=\"margin-top-25 padding-left-10 padding-right-10\" \nng-if=\"vm.installments[\'remaining\'].balance>0\"><md-input-container style=\"min-width:150px\" \nclass=\"md-block mb-0 mt-15 no-error-spacer\" layout=\"column\" flex=\"20\" layout-align=\"center \" id=\"focus-cccode\"><input \ntype=\"text\" ng-init=\"vm.installment_amount=vm.installments[\'remaining\'].balance\" ng-model=\"vm.installment_amount\" \nreadonly=\"readonly\" ng-click=\"vm.changePayAmount()\" allow-decimal-numbers ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"> <input type=\"hidden\" ng-model=\"vm.installments[\'remaining\'].origremainingamt\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container><md-button \nstyle=\"max-width:100px;max-height: 35px\" \nng-class=\"((EditResPaymentForm.$invalid && !vm.fieldsIsReadOnly) || !vm.installment_amount || !vm.payment_method.payment_method) || vm.paymentrequestGoing?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-accent submit-button white-fg\'\" \nng-disabled=\"((EditResPaymentForm.$invalid && !vm.fieldsIsReadOnly) || !vm.installment_amount || !vm.payment_method.payment_method) || vm.paymentrequestGoing || vm.installment_amount == 0\" \nng-click=\"vm.payInstallment()\" aria-label=\"Pay now\">Pay now<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.paymentrequestGoing\"></md-progress-circular>\n</md-button><span layout=\"column\" flex=\"100\" layout-align=\"start \" class=\"gcPayNow\" ng-if=\"vm.payingFromGC.price>0\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s15 red-A800-fg\"></md-icon><span class=\"payingFFc\">\n${{vm.payingFromGC.price}} from gift card</span></span></div><div class=\"form-title mt-15\">Payment Methods</div><div \nlayout=\"row\" flex=\"100\" class=\"margin-bottom-15 margin-top-20 padding-left-10 padding-right-10 margin-bottom-30\" \nlayout-wrap><md-input-container class=\"md-block mb-0 md-input-has-value no-margin\" layout=\"column\" flex=\"100\" \nflex-gt-md=\"80\" flex-gt-sm=\"60\" layout-align=\"center \"><md-radio-group class=\"\" ng-change=\"vm.paymentMethodSelected()\" \nng-model=\"vm.payment_method.payment_method\" required layout=\"row\" flex=\"100\" layout-wrap><md-radio-button \nlayout=\"column\" flex=\"50\" flex-gt-md=\"25\" flex-gt-xs=\"50\" layout-align=\"center \" \nclass=\"space-block-inline margin-right-0\" ng-repeat=\"paymentMethod in vm.all_payment_methods\" \nng-if=\"paymentMethod.heading != \'Other\'\" ng-value=\"paymentMethod.heading\">{{paymentMethod.heading}}</md-radio-button>\n</md-radio-group></md-input-container></div><div ng-if=\"vm.giftCard\" ng-disabled=\"!vm.giftCard\"><div layout=\"row\" \nflex=\"100\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" layout-align=\"center\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block mb-0 mb-0\"><label>Apply Gift Card</label><input \nng-model=\"vm.giftCardCode\" name=\"giftCard\" type=\"text\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div \nclass=\"emailError\">{{vm.giftCardErrro}}</div></md-input-container><md-button style=\"max-height:40px\" class=\"md-raised\" \nng-click=\"vm.validateGCCode($index)\" ng-disabled=\"vm.giftCardCode==\'\' || vm.gcrequestGoing\">Add<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.gcrequestGoing\"></md-progress-circular>\n</md-button></div></div></div></div><div ng-if=\"vm.payment_method.payment_method===\'Check\'\" \nng-disabled=\"vm.payment_method.payment_method!=\'Check\'\"><div layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"50\" flex-xs=\"100\" layout-align=\"center\">\n<md-input-container class=\"md-block mb-0 mb-0\"><label translate=\"CREATE_RES.CHECK_NO\"></label><input \nng-model=\"vm.payment_method.check_number\" name=\"check_number[$index]\" type=\"text\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></md-input-container></div></div></div><div ng-if=\"vm.payment_method.payment_method===\'Other\'\" \nng-disabled=\"vm.payment_method.payment_method!=\'Other\'\"><div layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"50\" flex-xs=\"100\" layout-align=\"center\">\n<md-input-container class=\"md-block mb-0 mb-0\"><label translate=\"CREATE_RES.OTHER_COMMENT\"></label><textarea \nng-model=\"vm.payment_method.other_comment\" name=\"other_comment[$index]\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></textarea></md-input-container></div></div></div><div \nng-if=\"vm.payment_method.payment_method === \'Credit Card\'\" \nng-disabled=\"vm.payment_method.payment_method!=\'Credit Card\'\" ng-attr-id=\"{{ \'paymentccblock-\' + $index }}\" \nclass=\"fontsize-15\"><label style=\"color:red\" id=\"authorizenet-swiper-status\" ng-click=\"vm.swipeNow()\" \nfor=\"authorizenetswiper-data\" class=\"ph-10\">{{vm.swipeText}}</label><input type=\"text\" \nstyle=\"height: 1px; width: 1px; border: 0 none; color: #FFF; font-size: 1px\" title=\"Swiper\" code=\"authorizenet\" \nclass=\"input-text webpos_swiper_input\" ng-model=\"vm.ccinfo_a\" ng-focus=\"vm.ReadySwipe()\" ng-blur=\"vm.ResetSwipe()\" \nng-keyup=\"vm.keyupfunction($event)\" id=\"authorizenet-swiper-data\" name=\"authorizenet-swiper-data\" value=\"    \" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div layout=\"row\" flex layout-wrap><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"50\" layout-align=\"center \" \nng-if=\"vm.allcardsInfo.length>0\"><md-input-container class=\"md-block mb-0\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\" \nflex-gt-xs=\"50\" layout-align=\"center \"><label translate=\"CREATE_RES.USE_EXISTINGCARD\"></label><md-select \nng-model=\"vm.use_existingcard\" ng-change=\"vm.changeActiveCard($index,vm.selectedIndex)\"><md-option ng-value=\"key\" \nng-repeat=\"(key,cardData) in vm.allcardsInfo\">\nxxxx-{{cardData.cc_number}}({{cardData.cc_type}}){{cardData.cc_is_incidental==0?\'\':\'*Incidentals\'}}</md-option>\n</md-select><div class=\"md-errors-spacer\" style=\"display:block\"></div></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"50\" layout-align=\" start\"><div><md-button \nstyle=\"max-height:40px;max-width:150px\" class=\"md-raised mt-15\" ng-click=\"vm.emptythisPayment($index)\" \nng-if=\"vm.allcardsInfo.length>0\">Add New Card</md-button></div></div></div><div \nng-class=\"vm.fieldsIsReadOnly?\'pointer_events_disabled\':\'\'\"><div layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10 orange-500-fg mb-10\" layout=\"column\" flex=\"50\" flex-xs=\"100\" \nlayout-align=\"center\" ng-if=\"vm.payment_method.cc_is_incidental==1\">*Incidental Card</div></div><div layout=\"row\" \nflex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10 datepicker-block\" layout=\"column\" flex-xs=\"100\" \nflex=\"100\" layout-align=\"center \"><div layout=\"row\" flex=\"100\" layout-wrap><md-input-container class=\"md-block mb-0\" \nlayout=\"column\" flex=\"80\"><label translate=\"CREATE_RES.CC_NUMBER\"></label><input \nng-model=\"vm.payment_method.cc_number_mask\" name=\"cc_number_mask\" id=\"authorizenet_cc_number_label\" type=\"text\" \nrequired ng-keyup=\"vm.creditCardChanged($event,EditResPaymentForm[\'cc_number\'].$ccEagerType,vm.payment_method)\" \nmaxlength=\"16\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div \nng-show=\"!vm.fieldsIsReadOnly && EditResPaymentForm[\'cc_number_mask\'].$touched\"><div \nng-show=\"!EditResPaymentForm[\'cc_number\'].$valid\" ng-hide=\"EditResPaymentForm[\'cc_number\'].$valid\" class=\"emailError\">\n{{ \'CREATE_RES.CR_NOT_VALID\' | translate }}</div></div><div ng-show=\"vm.notCardType\" ng-hide=\"!vm.notCardType\" \nclass=\"emailError\">{{ \'CREATE_RES.CR_NOT_ALOWD\' | translate }}</div></md-input-container><input \nid=\"authorizenet_cc_number\" ng-model=\"vm.payment_method.cc_number\" name=\"cc_number\" type=\"hidden\" cc-number \ncc-eager-type ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"> <input type=\"hidden\" \nng-model=\"vm.payment_method.customer_profile_id\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"> <input type=\"hidden\" \nng-model=\"vm.payment_method.payment_profile_id\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div \nid=\"authorizenet_cc_type\" cc_type=\"{{vm.payment_method.cc_type?vm.payment_method.cc_type:vm.ct }}\" \nclass=\"{{vm.payment_method.cc_type? vm.payment_method.cc_type:vm.ct}}\" layout=\"column\" flex=\"20\"></div></div></div>\n</div><div layout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"33\" layout-align=\"center\"><md-input-container class=\"md-block mb-0\"><label \ntranslate=\"CREATE_RES.EXP_MONTH\"></label><md-select id=\"authorizenet_expiration\" name=\"cc_exp_date\" \nng-model=\"vm.payment_method.cc_exp_month\" ng-change=\"vm.checkValidExpDate()\"><md-option ng-value=\"key\" \nng-repeat=\"(key,months) in vm.dates_option\">{{months}}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-gt-xs=\"33\" flex=\"100\" \nlayout-align=\"center\"><md-input-container class=\"md-block mb-0\"><label translate=\"CREATE_RES.EXP_YEAR\"></label>\n<md-select name=\"cc_exp_year\" ng-model=\"vm.payment_method.cc_exp_year\" ng-change=\"vm.checkValidExpDate()\"><md-option \nng-value=\"year\" ng-repeat=\"year in vm.yrs_option\">{{year}}</md-option></md-select><div ng-show=\"vm.exp_date_err\" \nng-hide=\"!vm.exp_date_err\" class=\"emailError\">{{ \'CREATE_RES.EX_DATE_NOT_VALID\' | translate }}</div><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div class=\"padding-left-10 padding-right-10\" \nlayout=\"column\" flex-gt-xs=\"33\" flex=\"100\" layout-align=\"center \"><md-input-container class=\"md-block mb-0\"><label \ntranslate=\"CREATE_RES.CC_CVN\"></label><input ng-model=\"vm.payment_method.cc_cid\" name=\"cc_cvv{{$index}}\" type=\"text\" \ncc-cvc ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div ng-show=\"EditResPaymentForm[\'cc_cvv\' + $index].$touched\">\n<div ng-show=\"!EditResPaymentForm[\'cc_cvv\' + $index].$valid && !EditResPaymentForm[\'cc_cvv\' + $index].$error.required\" \nclass=\"emailError\">{{ \'CREATE_RES.CVN_NOT_VALID\' | translate }}</div></div></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" \nflex=\"33\" layout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0\"><label \ntranslate=\"CREATE_RES.CUST_FN_CC\"></label><input ng-model=\"vm.payment_method.cc_fname\" name=\"cc_fn[$index]\" \ntype=\"text\" required ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"33\" layout-align=\"center \">\n<md-input-container class=\"md-block mb-0 mb-0\"><label translate=\"CREATE_RES.CUST_MN_CC\"></label><input \nng-model=\"vm.payment_method.cc_mname\" name=\"cc_mn[$index]\" type=\"text\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"33\" flex-xs=\"100\" \nlayout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0\"><label translate=\"CREATE_RES.CUST_LN_CC\"></label>\n<input ng-model=\"vm.payment_method.cc_lname\" name=\"cc_ln[$index]\" type=\"text\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></md-input-container></div></div></div></div><div \nng-if=\"vm.payment_method.payment_method === \'E-Check\'\" ng-disabled=\"vm.payment_method.payment_method !=\'E-Check\'\" \nclass=\"fontsize-15\"><div><div layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10 datepicker-block\" layout=\"column\" flex-xs=\"100\" flex=\"100\" \nlayout-align=\"center \"><div layout=\"row\" flex=\"100\" layout-wrap><md-input-container class=\"md-block mb-0\" \nlayout=\"column\" flex=\"100\"><label>Name Of Bank</label><input ng-model=\"vm.payment_method.bankName\" name=\"bankName\" \ntype=\"text\" required ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container><input type=\"hidden\" \nng-model=\"vm.payment_method.payment_profile_id\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></div></div></div><div \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"33\" layout-align=\"center\"><md-input-container class=\"md-block mb-0\"><label>Account Type</label><md-select \nname=\"accountType\" ng-model=\"vm.payment_method.accountType\" required><md-option value=\"checking\">Checking</md-option>\n<md-option value=\"saving\">Saving</md-option><md-option value=\"businessChecking\">Business Checking</md-option>\n</md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-gt-xs=\"33\" flex=\"100\" layout-align=\"center \">\n<md-input-container class=\"md-block mb-0\"><label>Account Number</label><input \nng-model=\"vm.payment_method.accountNumber\" name=\"accountNumber\" type=\"text\" ng-required=\"true\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-gt-xs=\"33\" flex=\"100\" layout-align=\"center \">\n<md-input-container class=\"md-block mb-0\"><label>Routing Number</label><input \nng-model=\"vm.payment_method.routingNumber\" name=\"routingNumber\" type=\"text\" ng-required=\"true\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"33\" \nlayout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0\"><label>Name On Account</label><input \nng-model=\"vm.payment_method.nameOnAccount\" name=\"nameOnAccount\" type=\"text\" required ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex-xs=\"100\" flex=\"33\" layout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0 mt-0\"><label>E-Check Type\n</label><md-select name=\"accountType\" ng-model=\"vm.payment_method.echeckType\" required><md-option value=\"PPD\">\nPrearranged Payment And Deposit Entry</md-option><md-option value=\"WEB\">Internet-Initiated Entry</md-option>\n</md-select></md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"33\" \nflex-xs=\"100\" layout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0\"><label>Check Number</label><input \nng-model=\"vm.payment_method.checkNumber\" name=\"checkNumber\" type=\"text\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></md-input-container></div></div></div></div></div></div></form></div></div><div layout=\"column\" \nflex-gt-md=\"30\" flex-gt-sm=\"40\" flex=\"100\" class=\"subtotalborder-left pv-20\"><div \nclass=\"section-right-genral featured-rol-block\"><div class=\"display-inline-block white-bg no-padding\"><div \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\" center start\"><div flex=\"100\" \nlayout-align=\"center center\" layout=\"row\"><span layout=\"column\">Subtotal</span></div></div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" flex=\"35\" \nlayout-align=\"center end \">{{vm.order.overalltotals.subtotal | currency : $ : 2}}</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap><div class=\"sub-total-col\" layout=\"column\" flex=\"50\" \nlayout-align=\" center start\">Discount</div><div class=\"sub-total-col\" layout=\"column\" flex=\"15\" \nlayout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end \">\n({{vm.order.overalltotals.product_discount | currency : $ : 2}})</div></div><div class=\"sub-total-section\" \nlayout=\"row\" flex=\"100\" layout-wrap ng-repeat=\"(newKey, newTaxAmount) in vm.order.overalltotals.tax_amount\" \nng-if=\"newKey\"><div class=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\" center start\">{{newKey}}</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"35\" layout-align=\"center end \">{{newTaxAmount | currency : $ : 2}}</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap><div class=\"sub-total-col\" layout=\"column\" flex=\"50\" \nlayout-align=\" center start\">Grand Total</div><div class=\"sub-total-col\" layout=\"column\" flex=\"15\" \nlayout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end \">\n{{vm.order.overalltotals.grand_total | currency : $ : 2}}</div></div><div class=\"sub-total-section\" layout=\"row\" \nflex=\"100\" layout-wrap><div class=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\" center start\">Paid Amount\n</div><div class=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end \">\n{{vm.order.overalltotals.paid_amount | currency : $ : 2}}</div></div><div class=\"sub-total-section\" layout=\"row\" \nflex=\"100\" layout-wrap><div class=\"sub-total-col md-accent-fg\" layout=\"column\" flex=\"50\" layout-align=\" center start\">\nRemaining Amount</div><div class=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end \">\n{{vm.order.overalltotals.remaining_amount | currency : $ : 2}}</div></div></div></div></div></div></div></div></div>\n</div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/contacts/dialogs/contact/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div><div class=\"contact-name\">{{vm.contact.name}}\n</div><div ng-if=\"vm.error\">{{ vm.error }}</div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\"><md-content class=\"md-padding margin-top\"><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"CONTACTS.FIRST_NAME\">First name</label><md-icon \nmd-font-icon=\"icon-account\"></md-icon><input ng-model=\"vm.contact.first_name\" type=\"text\" required>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label>Middle name</label><md-icon \nmd-font-icon=\"icon-account\"></md-icon><input ng-model=\"vm.contact.middle_name\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-icon-float md-block\"><label translate=\"CONTACTS.LAST_NAME\">Last Name</label><md-icon \nmd-font-icon=\"icon-account\"></md-icon><input ng-model=\"vm.contact.last_name\" type=\"text\"></md-input-container>\n<md-input-container class=\"md-block\" ng-if=\"vm.disableEmail == \'Edit\'\"><md-icon md-font-icon=\"icon-email\" \nclass=\"email\"></md-icon><input ng-model=\"vm.contact.customer_email\" disabled=\"disabled\" type=\"email\" \nplaceholder=\"Email\" translate required><div ng-if=\"vm.emailError!=false\"><div \nclass=\"md-input-message-animation ng-scope\" style=\"opacity: 1; margin-top: 0px\"><span>{{ vm.emailError }}</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" ng-show=\"vm.disableEmail == \'Add\'\"><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><input ng-model=\"vm.contact.customer_email\" placeholder=\"Email\" \nid=\"EmailFocus\" ng-change=\"vm.validateEmail()\" type=\"email\" translate required><div ng-if=\"vm.emailError!=false\"><div \nclass=\"md-input-message-animation ng-scope\" style=\"opacity: 1; margin-top: 0px\"><span>{{ vm.emailError }}</span></div>\n</div></md-input-container><md-datepicker class=\"birthday-input\" ng-model=\"vm.contact.date_of_birth\" \nmd-placeholder=\"Date of Birth\" md-open-on-focus></md-datepicker><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-gender-male-female\"></md-icon><md-select placeholder=\"Select Gender\" \nng-model=\"vm.contact.customer_gender\" ng-model-options=\"{trackBy: \'$value.value\'}\"><md-option ng-value=\"gend\" \nng-repeat=\"gend in vm.gender\">{{gend.name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"></md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-key\"></md-icon>\n<input ng-model=\"vm.password\" type=\"password\" placeholder=\"Password\" ng-required=\"!vm.contact.customer_id\" \nname=\"password_1\" min-password><div ng-messages=\"contactForm.password_1.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Password is required</span></div><div ng-message=\"min-password\"><span>\nPassword must be minimum 6 character.</span></div></div></md-input-container><md-input-container class=\"md-block\">\n<label translate=\"USERS.CONFIRM_PASSWORD\">Confirm password</label><md-icon md-font-icon=\"icon-key\"></md-icon><input \nng-model=\"vm.contact.passwordConfirm\" type=\"password\" ng-required=\"!vm.contact.customer_id\" name=\"passwordConfirm\" \npwd-and-cnfm-same><div ng-messages=\"contactForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nConfirm password is required</span></div><div ng-message=\"pwd-and-cnfm-same\"><span>\nPassword and confirm password should be same</span></div></div></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><label>Select Status</label><md-icon md-font-icon=\"icon-label\"></md-icon><md-select \nplaceholder=\"Select Status\" ng-model=\"vm.contact.is_active\" ng-model-options=\"{trackBy: \'$value.value\'}\" required>\n<md-option ng-value=\"stat\" ng-repeat=\"stat in vm.status\">{{stat.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-home\"></md-icon><input ng-model=\"vm.contact.address\" type=\"text\" placeholder=\"Address\">\n</md-input-container></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"!vm.newContact\" ng-click=\"vm.saveContact()\" class=\"send-button md-accent md-raised white-fg\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine || !vm.disSubmit\" aria-label=\"SAVE\">Save</md-button>\n<md-button type=\"submit\" ng-if=\"vm.newContact\" ng-click=\"vm.addNewContact()\" \nclass=\"send-button md-accent md-raised white-fg\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine || !contactForm.$dirty || !vm.disSubmit\" \naria-label=\"Add Task\">Add customer</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/contacts/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{vm.user.avatar}}\" \nclass=\"md-avatar avatar mr-16\" alt=\"{{vm.user.name}}\"> <span class=\"font-weight-500 font-size-14\">{{vm.user.name}}\n</span></div><md-divider></md-divider><div ms-scroll class=\"content\"><md-list><md-list-item \nng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p translate=\"CONTACTS.ALL_CONTACTS\">\nAll contacts</p></md-list-item><md-list-item ng-click=\"vm.filterChange(\'frequent\')\" \nng-class=\"{\'selected\':vm.listType ===\'frequent\'}\"><p translate=\"CONTACTS.FREQUENTLY_CONTACTED\">Frequently contacted</p>\n</md-list-item><md-list-item ng-click=\"vm.filterChange(\'starred\')\" ng-class=\"{\'selected\':vm.listType ===\'starred\'}\"><p \ntranslate=\"CONTACTS.STARRED_CONTACTS\">Starred contacts</p></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\">Groups</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.filterChange(group)\" ng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">\n{{group.name}}</p></md-list-item><md-list-item class=\"new-group-form\" ng-show=\"newListForm.$visible\"><p class=\"pl-8\" \neditable-text=\"vm.newGroupName\" e-form=\"newListForm\" onaftersave=\"vm.addNewGroup()\"></p></md-list-item><md-list-item \nclass=\"\" ng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\"><p class=\"pl-8 md-accent-fg\" \ntranslate=\"CONTACTS.NEW_GROUP\">New Group</p></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/create-res/dialogs/add-boat/add-boat.html","<md-dialog class=\"tax-dialog tax-dialog-new1 act-dialog addcusform\" aria-label=\"New Task\"><form name=\"contactForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"row\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\"><md-button class=\"goto-products-button md-icon-button\" ng-if=\"vm.show_listing\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"white-fg\" ng-click=\"vm.hideListing()\"></md-icon></md-button><md-button \nclass=\"goto-products-button md-icon-button\" ng-if=\"vm.pos_flag == \'edit\'\"><md-icon md-font-icon=\"icon-arrow-left\" \nclass=\"white-fg\" ng-click=\"vm.showListing()\"></md-icon></md-button>Vessel Information</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\" \nclass=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll style=\"max-height:1000px\">\n<md-content class=\"md-padding no-margin\" ng-hide=\"vm.show_listing || vm.delete_popup\"><div layout=\"column\" \nlayout-gt-xs=\"row\" layout-align=\"start\" flex><div class=\"row-block\" flex-gt-xs=\"100\" flex><div \nng-class=\"vm.addRoomInItin?\'pointer_events_disabled\':\'\'\"><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" flex-gt-sm=\"50\" \nlayout=\"column\" flex=\"100\" layout-align=\"start start\" class=\"padding-5\" flex><md-input-container \nclass=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" role=\"button\" translate=\"ADD_BOAT_DATA.BOAT_TYPE\">\n</label><md-select required placeholder=\"Vessel Type\" ng-model=\"vm.boat.boat_type\" class=\"\"><md-option \nng-value=\"boat.value\" ng-repeat=\"boat in vm.boatType\">{{boat.name}}</md-option></md-select></md-input-container></div>\n<div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" flex-gt-sm=\"50\" layout=\"column\" \nlayout-align=\"start start\" class=\"padding-5\" flex><md-input-container class=\"md-block tax-inputs full-width\"><label \nclass=\"ng-scope\" role=\"button\" translate=\"ADD_BOAT_DATA.BOAT_NAME\"></label><input type=\"text\" name=\"boat_name\" \nng-model=\"vm.boat.boat_name\" aria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" \nui-options=\"{addDefaultPlaceholder:false}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div \nng-messages=\"contactForm.boat_name.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span \ntranslate=\"ADD_BOAT_DATA.VALID_PHONE\"></span></div></div></md-input-container></div></div><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex><div class=\"row-col padding-right-10 padding-left-10\" \nflex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex><md-input-container \nclass=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" role=\"button\" translate=\"ADD_BOAT_DATA.BOAT_MODEL\">\n</label><input type=\"text\" name=\"boat_model\" ng-model=\"vm.boat.boat_model\" aria-invalid=\"true\" \nng-model-options=\"{debounce: 500}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div \nng-messages=\"contactForm.boat_model.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span \ntranslate=\"ADD_BOAT_DATA.VALID_PHONE\"></span></div></div></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"ADD_BOAT_DATA.BOAT_MAKE\"></label><input type=\"text\" name=\"boat_make\" ng-model=\"vm.boat.boat_make\" \naria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" ui-options=\"{addDefaultPlaceholder:false}\"><div \nng-messages=\"contactForm.boat_make.$error\" role=\"alert\" multiple=\"multiple\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"><div ng-message=\"pattern\"><span translate=\"ADD_BOAT_DATA.VALID_PHONE\"></span></div></div>\n</md-input-container></div></div><div class=\"row-block row-autocomplete\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" \nrole=\"button\" translate=\"ADD_BOAT_DATA.BOAT_LENGTH\"></label><input ng-model=\"vm.boat.boat_length\" type=\"text\" \nname=\"boat_length\" ng-model-options=\"{debounce: 500}\" autocomplete=\"off\" allow-only-numbers \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"ADD_BOAT_DATA.BOAT_BEAM\"></label><input ng-model=\"vm.boat.beam\" type=\"text\" name=\"beam\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" allow-only-numbers ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" \nrole=\"button\" translate=\"ADD_BOAT_DATA.BOAT_DRAFT\"></label><input ng-model=\"vm.boat.draft\" type=\"text\" name=\"draft\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" allow-only-numbers ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></md-input-container></div></div></div></div></div></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\" ng-hide=\"vm.show_listing\"><div layout=\"row\" \nlayout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" ng-click=\"vm.addBoatData()\" ng-disabled=\"vm.queryProgress\" \nng-class=\"vm.queryProgress?\'send-button md-accent md-raised white-fg\':\'send-button md-green-500-bg md-raised white-fg\'\" \naria-label=\"Add Customer\" layout=\"column\">Add Vessel Data</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/create-res/dialogs/add-customer/add-customer.html","<md-dialog class=\"tax-dialog tax-dialog-new1 act-dialog addcusform\" aria-label=\"New Task\"><form name=\"contactForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"row\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\"><md-button class=\"goto-products-button md-icon-button\" ng-if=\"vm.show_listing\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"white-fg\" ng-click=\"vm.hideListing()\"></md-icon></md-button><md-button \nclass=\"goto-products-button md-icon-button\" ng-if=\"vm.pos_flag == \'edit\'\"><md-icon md-font-icon=\"icon-arrow-left\" \nclass=\"white-fg\" ng-click=\"vm.showListing()\"></md-icon></md-button>Billing Information</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\" \nclass=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll style=\"max-height:1000px\">\n<md-content class=\"md-padding no-margin\" ng-hide=\"vm.show_listing || vm.delete_popup\"><div layout=\"column\" \nlayout-gt-xs=\"row\" layout-align=\"start\" flex><div class=\"row-block\" flex-gt-xs=\"100\" flex><div \nng-class=\"vm.addRoomInItin?\'pointer_events_disabled\':\'\'\"><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" flex-gt-sm=\"50\" \nlayout=\"column\" flex=\"100\" layout-align=\"start start\" class=\"padding-5\" flex><md-autocomplete flex \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedSearch.first_name\" \nmd-selected-item-change=\"vm.updateForm(item, \'cust.first_name\')\" \nmd-items=\"item in vm.querySearch(vm.searchTextFn, \'cust.first_name\')\" md-search-text=\"vm.searchTextFn\" \nmd-item-text=\"item.first_name\" md-min-length=\"1\" md-max-length=\"18\" md-delay=\"500\" md-floating-label=\"First name\" \nclass=\"chooseCustomer full-width\"><md-item-template><span md-highlight-text=\"vm.searchTextFn\" md-highlight-flags=\"^i\">\n{{item.display}}</span></md-item-template></md-autocomplete></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" flex-gt-sm=\"50\" layout=\"column\" \nlayout-align=\"start start\" class=\"padding-5\" flex><md-autocomplete flex md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedSearch.last_name\" md-selected-item-change=\"vm.updateForm(item, \'cust.last_name\')\" \nmd-items=\"item in vm.querySearch(vm.searchTextLn, \'cust.last_name\')\" md-search-text=\"vm.searchTextLn\" \nmd-item-text=\"item.last_name\" md-min-length=\"1\" md-max-length=\"18\" md-delay=\"500\" md-floating-label=\"Last name\" \nclass=\"chooseCustomer full-width\"><md-item-template><span md-highlight-text=\"vm.searchTextLn\" md-highlight-flags=\"^i\">\n{{item.display}}</span></md-item-template></md-autocomplete></div></div><div class=\"row-block\" flex-gt-xs=\"100\" \nlayout=\"row\" layout-align=\"start start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" \nlayout=\"column\" layout-align=\"start start\" flex><md-autocomplete flex md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedSearch.customer_email\" \nmd-selected-item-change=\"vm.updateForm(item, \'cust.customer_email\')\" \nmd-items=\"item in vm.querySearch(vm.searchTextEm, \'cust.customer_email\')\" md-search-text=\"vm.searchTextEm\" \nmd-item-text=\"item.customer_email\" md-min-length=\"1\" md-max-length=\"18\" md-delay=\"500\" md-floating-label=\"Email\" \nclass=\"chooseCustomer full-width\" required><md-item-template><span md-highlight-text=\"vm.searchTextEm\" \nmd-highlight-flags=\"^i\">{{item.customer_email}}</span></md-item-template></md-autocomplete></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope phone-number-label\" role=\"button\" \ntranslate=\"CREATE_RES.CUST_CONT_NO\"></label><input class=\"intel-number-input\" intl-tel-input type=\"tel\" \nname=\"phone_number\" ng-model=\"vm.contact.phone_number\" aria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" \nui-options=\"{addDefaultPlaceholder:false}\" ng-readonly=\"vm.autoFillOff\" \nng-change=\"vm.updatePhoneWithCountryCode(\'phone_number\', this)\" autocomplete=\"off\"><div \nng-messages=\"contactForm.phone_number.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span \ntranslate=\"CONTACTS.VALID_PHONE\"></span></div></div></md-input-container></div></div><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex><div class=\"padding-right-10 padding-left-10\" \nflex-gt-xs=\"100\" layout-align=\"start start\" flex><md-input-container class=\"md-block\"><label>Address</label><textarea \nng-model=\"vm.contact.address\" rows=\"1\" md-select-on-focus id=\"autocomplete\" a ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></textarea></md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" flex></div><div class=\"row-block row-autocomplete\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" \nrole=\"button\" translate=\"CONTACTS.CITY\"></label><input ng-model=\"vm.contact.city\" type=\"text\" name=\"city\" \nng-model-options=\"{debounce: 500}\" ng-readonly=\"vm.autoFillOff\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\" flex><md-autocomplete ng-disabled=\"vm.isStateDisabled\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedState\" md-search-text-change=\"vm.searchState(vm.searchTxtState)\" \nmd-search-text=\"vm.searchTxtState\" md-selected-item-change=\"vm.selectedItemChangeState(item)\" \nmd-items=\"item in vm.queryStateSearch(vm.searchTxtState)\" md-item-text=\"item.display\" md-min-length=\"0\" \nmd-floating-label=\"State\"><md-item-template><span md-highlight-text=\"vm.searchTxtState\" md-highlight-flags=\"^i\">\n{{item.display}}</span></md-item-template><md-not-found>No results found.</md-not-found></md-autocomplete></div></div>\n<div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"CONTACTS.ZIPCODE\"></label><input ng-model=\"vm.contact.zip_code\" type=\"text\" name=\"zip_code\" \nng-model-options=\"{debounce: 500}\" id=\"autocompletezip\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10 removeRed\" flex-gt-xs=\"50\" \nlayout=\"column\" layout-align=\"start start\" flex><md-autocomplete ng-disabled=\"vm.isCountryDisabled\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedCountry\" \nmd-search-text-change=\"vm.searchCountry(vm.searchTxtCountry)\" md-search-text=\"vm.searchTxtCountry\" \nmd-selected-item-change=\"vm.selectedItemChange(item, \'\', \'\')\" \nmd-items=\"item in vm.queryCountrySearch(vm.searchTxtCountry)\" md-item-text=\"item.display\" md-min-length=\"0\" \nmd-floating-label=\"Country\" class=\"full-width\"><md-item-template><span md-highlight-text=\"vm.searchTxtCountry\" \nmd-highlight-flags=\"^i\">{{item.display}}</span></md-item-template><md-not-found>No results found.</md-not-found>\n</md-autocomplete><div class=\"md-errors-spacer\"></div></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block md-input-has-value no-margin\" flex-gt-xs=\"100\" \nng-init=\"vm.contact.tax_exempt_indicator = vm.contact.tax_exempt_indicator == \'1\'?true:false\"><md-switch \nng-model=\"vm.contact.tax_exempt_indicator\" aria-label=\"Switch 1\" class=\"no-margin\"><span \ntranslate=\"CONTACTS.TAX_EXEMPT_ON\" ng-if=\"vm.contact.tax_exempt_indicator\"></span> <span \ntranslate=\"CONTACTS.TAX_EXEMPT_OFF\" ng-if=\"!vm.contact.tax_exempt_indicator\"></span></md-switch><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" \nflex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex id=\"moveToTravellerDiv\"><md-input-container \nclass=\"md-block md-input-has-value no-margin\" flex-gt-xs=\"100\" \nng-init=\"vm.contact.send_email_indicator  = vm.contact.send_email_indicator == \'1\'?true:false;\"><md-switch \nng-model=\"vm.contact.send_email_indicator\" aria-label=\"Switch 1\" class=\"no-margin\"><span \ntranslate=\"CONTACTS.SENDEMAIL_ON\" ng-if=\"vm.contact.send_email_indicator\"></span><span \ntranslate=\"CONTACTS.SENDEMAIL_OFF\" ng-if=\"!vm.contact.send_email_indicator\"></span></md-switch><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" flex ng-if=\"vm.contact.tax_exempt_indicator == 1\"><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\">\n<md-input-container class=\"md-block tax-inputs full-width\"><label translate=\"CONTACTS.TAX_EXEMPT_ID\"></label><input \nng-model=\"vm.contact.tax_exempt_id\" type=\"text\" name=\"tax_exempt_id\" ng-model-options=\"{debounce: 500}\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div class=\"md-errors-spacer\"></div></md-input-container></div></div>\n</div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\"><div class=\"row-col\" flex=\"100\" \nlayout=\"column\" layout-align=\"start start\"><md-input-container \nclass=\"md-block tax-inputs padding-right-10 padding-left-10 padding-bottom-20\" flex-gt-xs=\"100\" \nng-init=\"$travellerIndex = 0;\" ng-hide=\"vm.pageType == \'boat\'\"><md-checkbox \nng-change=\"vm.deletePreviousData($travellerIndex)\" ng-model=\"vm.travellerDetails[$travellerIndex]\" \naria-label=\"select traveller\" class=\"md-align-top-left no-margin\" flex><span class=\"ipsum\">Traveller same as customer\n</span></md-checkbox></md-input-container><div ng-if=\"!vm.travellerDetails[$travellerIndex]\" class=\"full-width\"><div \nclass=\"row-block\" flex-gt-xs=\"100\" flex><div class=\"row-block\" flex=\"100\" layout=\"row\" layout-align=\"start start\" flex>\n<div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" layout=\"column\" flex=\"100\" \nlayout-align=\"start start\" class=\"padding-5\"><md-autocomplete flex md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedSearchTraveller[$travellerIndex].first_name\" \nmd-selected-item-change=\"vm.updateTravellerForm(item, \'cust.first_name\', $travellerIndex)\" \nmd-items=\"item in vm.querySearch(vm.searchTextTravTravellerFn[$travellerIndex], \'cust.first_name\')\" \nmd-search-text=\"vm.searchTextTravTravellerFn[$travellerIndex]\" md-item-text=\"item.first_name\" md-min-length=\"1\" \nmd-max-length=\"18\" md-delay=\"500\" md-floating-label=\"First name\" class=\"chooseCustomer full-width\"><md-item-template>\n<span md-highlight-text=\"vm.searchTextTravTravellerFn[$travellerIndex]\" md-highlight-flags=\"^i\">{{item.display}}</span>\n</md-item-template></md-autocomplete></div><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" \nflex-gt-sm=\"50\" layout=\"column\" layout-align=\"start start\" class=\"padding-5\"><md-autocomplete flex \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedSearchTraveller[$travellerIndex].last_name\" \nmd-selected-item-change=\"vm.updateTravellerForm(item, \'cust.last_name\', $travellerIndex)\" \nmd-items=\"item in vm.querySearch(vm.searchTextTravellerLn[$travellerIndex], \'cust.last_name\')\" \nmd-search-text=\"vm.searchTextTravellerLn[$travellerIndex]\" md-item-text=\"item.last_name\" md-min-length=\"1\" \nmd-max-length=\"18\" md-delay=\"500\" md-floating-label=\"Last name\" class=\"chooseCustomer full-width\"><md-item-template>\n<span md-highlight-text=\"vm.searchTextTravellerLn[$travellerIndex]\" md-highlight-flags=\"^i\">{{item.display}}</span>\n</md-item-template></md-autocomplete></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\" flex><md-autocomplete flex md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedSearchTraveller[$travellerIndex].customer_email\" \nmd-selected-item-change=\"vm.updateTravellerForm(item, \'cust.customer_email\', $travellerIndex)\" \nmd-items=\"item in vm.querySearch(vm.searchTextTravellerEm[$travellerIndex], \'cust.customer_email\')\" \nmd-search-text=\"vm.searchTextTravellerEm[$travellerIndex]\" md-item-text=\"item.customer_email\" md-min-length=\"1\" \nmd-max-length=\"18\" md-delay=\"500\" md-floating-label=\"Email\" class=\"chooseCustomer full-width\" required>\n<md-item-template><span md-highlight-text=\"vm.searchTextTravellerEm[$travellerIndex]\" md-highlight-flags=\"^i\">\n{{item.customer_email}}</span></md-item-template></md-autocomplete></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope phone-number-label\" role=\"button\" \ntranslate=\"CONTACTS.PHONE_NUMBER\"></label><input type=\"tel\" class=\"intel-number-input intel-number-input-traveller\" \nintl-tel-input name=\"phone_number\" ng-model=\"vm.contactTraveller[$travellerIndex].phone_number\" aria-invalid=\"true\" \nng-model-options=\"{debounce: 500}\" ui-options=\"{addDefaultPlaceholder:false}\" \nng-change=\"vm.updatePhoneWithCountryCode(\'phone_number\',this,$travellerIndex)\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"><div ng-messages=\"contactForm.phone_number.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span translate=\"CONTACTS.VALID_PHONE\"></span></div></div></md-input-container></div></div><div \nclass=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex><div \nclass=\"padding-right-10 padding-left-10\" flex-gt-xs=\"100\" layout-align=\"start start\" flex><md-input-container \nclass=\"md-block\"><label>Address</label><textarea ng-model=\"vm.contactTraveller[$travellerIndex].address\" rows=\"1\" \nmd-select-on-focus id=\"autoCompleteTravellerAddress\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></textarea>\n</md-input-container></div></div><div class=\"row-block row-autocomplete\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" \nrole=\"button\" translate=\"CONTACTS.CITY\"></label><input ng-model=\"vm.contactTraveller[$travellerIndex].city\" \ntype=\"text\" name=\"city\" ng-model-options=\"{debounce: 500}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\" flex><md-autocomplete flex md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedStateTraveller[key]\" \nmd-items=\"item in vm.selectedItemChangeStateTraveller(vm.searchTxtStateTraveller[$travellerIndex],$travellerIndex)\" \nmd-search-text=\"vm.searchTxtStateTraveller[$travellerIndex]\" md-item-text=\"item.name\" md-min-length=\"1\" \nmd-max-length=\"18\" ng-model-options=\"{debounce: 500}\" md-floating-label=\"State\" class=\"chooseCustomer full-width\">\n<md-item-template><span md-highlight-text=\"vm.searchTxtStateTraveller[$travellerIndex]\" md-highlight-flags=\"^i\">\n{{item.name}}</span></md-item-template></md-autocomplete></div></div><div class=\"row-block\" flex-gt-xs=\"100\" \nlayout=\"row\" layout-align=\"start start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" \nlayout=\"column\" layout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs full-width\"><label \nclass=\"ng-scope\" role=\"button\" translate=\"CONTACTS.ZIPCODE\"></label><input \nng-model=\"vm.contactTraveller[$travellerIndex].zip_code\" type=\"text\" name=\"zip_code\" \nng-model-options=\"{debounce: 500}\" id=\"autoCompleteTravellerZipcode\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\" flex><md-autocomplete ng-disabled=\"vm.isCountryDisabled\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedCountryTraveller[key]\" \nmd-search-text-change=\"vm.searchCountry(vm.searchTxtCountryTraveller[$travellerIndex])\" \nmd-search-text=\"vm.searchTxtCountryTraveller[$travellerIndex]\" \nmd-selected-item-change=\"vm.selectedItemChange(item,vm.searchTxtCountryTraveller[$travellerIndex], $index )\" \nmd-items=\"item in vm.queryCountrySearch(vm.searchTxtCountryTraveller[$travellerIndex])\" md-item-text=\"item.display\" \nmd-min-length=\"0\" md-floating-label=\"Country\" class=\"full-width\"><md-item-template><span \nmd-highlight-text=\"vm.searchTxtCountryTraveller[$travellerIndex]\" md-highlight-flags=\"^i\">{{item.display}}</span>\n</md-item-template><md-not-found>No results found</md-not-found></md-autocomplete><div class=\"md-errors-spacer\"></div>\n</div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block md-input-has-value no-margin\" flex-gt-xs=\"100\" \nng-init=\"vm.contactTraveller[$travellerIndex].send_email_indicator = vm.contactTraveller[$travellerIndex].send_email_indicator == 1?true:false;\">\n<md-switch class=\"no-margin\" ng-model=\"vm.contactTraveller[$travellerIndex].send_email_indicator\" \naria-label=\"Switch 1\"><span translate=\"CONTACTS.SENDEMAIL_ON\" \nng-if=\"vm.contactTraveller[$travellerIndex].send_email_indicator\"></span><span translate=\"CONTACTS.SENDEMAIL_OFF\" \nng-if=\"!vm.contactTraveller[$travellerIndex].send_email_indicator\"></span></md-switch></md-input-container></div></div>\n</div></div></div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\" ng-hide=\"vm.show_listing\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\">\n<md-button type=\"submit\" ng-click=\"vm.selectCustomer()\" \nng-disabled=\"vm.validateUser($travellerIndex) || vm.queryProgress\" \nng-class=\"vm.validateUser($travellerIndex) || vm.queryProgress?\'send-button md-accent md-raised white-fg\':\'send-button md-green-500-bg md-raised white-fg\'\" \naria-label=\"Add Customer\" layout=\"column\">Select user</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/create-res/dialogs/add-room/add-room.html","<md-dialog class=\"addroom-dialog\" aria-label=\"New Task\"><div class=\"hold-send-overlay\" ng-if=\"vm.holdSending\"></div>\n<form name=\"openPlaceGantt\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top editcontacts customized-radio\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" ng-if=\"vm.type != \'new\'\">{{vm.pageHeader}}</span>\n<md-input-container class=\"md-block md-datepicker\" ng-if=\"vm.type == \'new\'\" data-ng-animate=\"1\"><md-radio-group \nclass=\"no-margin\" ng-model=\"vm.data.type_of_reservation\" ng-model-options=\"{debounce: 500}\" required \nng-change=\"vm.type_changed()\"><md-radio-button class=\"space-block-inline\" value=\"reservation\">\n{{ \'OPTIONS_CREATE.CREATE_RES\' | translate }}</md-radio-button><md-radio-button \nclass=\"space-block-inline margin-left-15\" value=\"create_day\" ng-if=\"vm.isDayReservationHotel\">\n{{ \'OPTIONS_CREATE.CREATE_DAY_RES\' | translate }}</md-radio-button><md-radio-button \nclass=\"space-block-inline margin-left-15\" value=\"hold\" ng-click=\"vm.closeAllDetails()\">\n{{ \'OPTIONS_CREATE.HOLD\' | translate }}</md-radio-button><md-radio-button class=\"space-block-inline margin-left-15\" \nvalue=\"block\" ng-click=\"vm.closeAllDetails()\">{{ \'OPTIONS_CREATE.BLOCK\' | translate }}</md-radio-button>\n</md-radio-group></md-input-container><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"main-dilog-1\"><md-content class=\"md-padding mb-15 datepickermain-block-container\"><div flex=\"100\" layout=\"row\" \nlayout-wrap><div class=\"row-block-new block-datepicker-main mb-0\" flex=\"50\" flex-xs=\"100\" layout=\"column\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block full-width mb-0\"><label \ntranslate=\"CREATE_RES.CHECKIN\"></label><md-datepicker md-open-on-focus ng-model=\"vm.new_checkin\" \nng-change=\"vm.checkinSlected()\" class=\"full-width mdinput-block\"></md-datepicker></md-input-container></div><div \nclass=\"row-block-new block-datepicker-main\" flex=\"50\" flex-xs=\"100\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block full-width mb-0\"><label translate=\"CREATE_RES.CHECKOUT\"></label><md-datepicker \nmd-open-on-focus ng-model=\"vm.new_checkout\" md-min-date=\"vm.isDayCreateMode() ? null : vm.minDateCheckout\" \nng-disabled=\"vm.isDayCreateMode()\" class=\"full-width mdinput-block\"></md-datepicker></md-input-container></div></div>\n<div class=\"\" flex=\"100\" layout=\"row\" layout-wrap \nng-if=\"(vm.boatPermission && vm.pageFrom == \'toolBar\' && !vm.isDayCreateMode()) || vm.data.type_of_reservation == \'hold\'\">\n<div class=\"Fromto-col padding-left-10 padding-right-10 mt-10\" flex=\"50\" layout=\"column\" layout-align=\"start start\" \nng-if=\"vm.boatPermission && vm.pageFrom == \'toolBar\' && !vm.isDayCreateMode()\"><md-input-container \nclass=\"md-block tax-inputs no-margin full-width\"><md-icon class=\"margin-left-5\" md-font-icon=\"icon-human-male-female\">\n</md-icon><label class=\"lbl-width margin-left-20\">Reservation Type</label><md-select placeholder=\"Type\" \nng-model=\"vm.requestType\" class=\"input-with-icons1\" ng-init=\"vm.requestType = 0\" ng-change=\"vm.changeType()\"><md-option\n ng-value=\"0\">Room</md-option><md-option ng-value=\"1\">Slip</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div class=\"Fromto-col padding-left-10 padding-right-10 mt-10\" flex=\"50\" layout=\"column\" \nlayout-align=\"start start\" ng-if=\"vm.data.type_of_reservation == \'hold\'\"><div class=\"hold-date-promo full-width\"><div \nclass=\"hold-promo-entry full-width\" ng-if=\"!vm.holdPromoApplied\"><md-input-container \nclass=\"md-block tax-inputs no-margin no-error-spacer\"><md-icon class=\"margin-left-5\" md-font-icon=\"icon-sale\">\n</md-icon><label class=\"lbl-width margin-left-20\">Promo Code</label><input class=\"input-with-icons1\" \nng-model=\"vm.holdPromoCode\" name=\"hold_promocode\" type=\"text\" autocomplete=\"off\" \nng-change=\"vm.holdPromoCode = (vm.holdPromoCode || \'\').toUpperCase()\" \nng-keydown=\"$event.keyCode === 13 && vm.holdPromoCode && vm.applyTopHoldPromo(\'applied\')\"><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-button class=\"md-raised hold-promo-apply\" \nng-click=\"vm.applyTopHoldPromo(\'applied\')\" ng-disabled=\"!vm.holdPromoCode || vm.promoRequestGoing\"><span \nng-hide=\"vm.promoRequestGoing\">Apply</span><md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" \nmd-diameter=\"20px\" ng-show=\"vm.promoRequestGoing\"></md-progress-circular></md-button></div><div \nclass=\"hold-promo-applied-row\" ng-if=\"vm.holdPromoApplied\" layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"hold-promo-applied-icon\" md-font-icon=\"icon-sale\"></md-icon><div class=\"hold-promo-applied-card\" flex><div \nclass=\"hold-promo-applied-text\"><label>Promo Code</label><p>{{vm.holdPromoCode}}</p></div><p \nclass=\"hold-promo-remove-link\" ng-click=\"vm.askRemoveHoldPromo($event)\"><md-icon md-font-icon=\"icon-close-circle\" \nclass=\"red-A800-fg\"></md-icon>Remove</p></div></div></div></div></div><div class=\"\" flex=\"100\" layout=\"row\" \nlayout-wrap ng-if=\"!vm.requestType\"><div class=\"Fromto-col padding-left-10 padding-right-10 mt-10\" flex=\"50\" \nlayout=\"column\" layout-align=\"start start\"><md-input-container class=\"md-block tax-inputs no-margin full-width\">\n<md-icon class=\"margin-left-5\" md-font-icon=\"icon-human-male-female\"></md-icon><label class=\"lbl-width margin-left-20\">\nAdult</label><md-select placeholder=\"Adults\" ng-model=\"vm.new_adult\" ng-change=\"vm.manageAdultChild(\'adult\')\" \nclass=\"input-with-icons1\"><md-option ng-value=\"n\" ng-repeat=\"n in vm.adultRange\">{{n}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"Fromto-col padding-left-10 padding-right-10 mt-10\" flex=\"50\" layout=\"column\" layout-align=\"start start\">\n<md-input-container class=\"md-block tax-inputs no-margin full-width\"><md-icon class=\"margin-left-5\" \nmd-font-icon=\"icon-human-child\"></md-icon><label class=\"lbl-width margin-left-20\">Child</label><md-select \nplaceholder=\"Children\" ng-model=\"vm.new_child\" ng-change=\"vm.manageAdultChild(\'child\')\" class=\"input-with-icons1\">\n<md-option ng-value=\"i\" ng-repeat=\"i in vm.childRange\">{{i}}</md-option></md-select><div class=\"md-errors-spacer\">\n</div></md-input-container></div></div><div class=\"\" flex=\"100\" layout=\"row\" layout-wrap \nng-if=\"vm.type != \'changeCartItem\' && vm.requestType && vm.boatPermission\"><div \nclass=\"Fromto-col padding-left-10 padding-right-10 mt-10\" flex=\"50\" layout=\"column\" layout-align=\"start start\">\n<md-input-container class=\"md-block tax-inputs no-margin full-width\"><md-icon class=\"margin-left-5 boat-length-icon\">\n</md-icon><label class=\"lbl-width margin-left-20\">Vessel Length</label><input ng-model=\"vm.boat_length\" \nname=\"boat_length\" type=\"text\" required ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div class=\"md-errors-spacer\">\n</div></md-input-container></div><div class=\"Fromto-col padding-left-10 padding-right-10 mt-10\" flex=\"50\" \nlayout=\"column\" layout-align=\"start start\"><md-input-container class=\"md-block tax-inputs no-margin full-width\">\n<md-icon class=\"margin-left-5 boat-length-icon\"></md-icon><label class=\"lbl-width margin-left-20\">Vessel Beam</label>\n<input ng-model=\"vm.boat_beam\" name=\"boat_beam\" type=\"text\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></div><div class=\"\" flex=\"100\" layout=\"row\"><div \nclass=\"Fromto-col padding-left-10 padding-right-10\" flex=\"100\" flex-gt-sm=\"100\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"end start\"><md-button \nng-if=\"vm.type != \'changeCartItem\' && vm.show_search && !(vm.data.type_of_reservation === \'hold\' && vm.showHoldGuestStep)\" \nng-click=\"vm.getAvailableRooms()\" aria-label=\"Show Rooms\" \nng-class=\"vm.enable_search?\'md-raised md-green-500-bg submit-button grey-100-fg\':\'md-raised md-accent submit-button white-fg\'\" \nng-disabled=\"!vm.enable_search || openPlaceGantt.boat_length.$invalid || openPlaceGantt.boat_beam.$invalid\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-fg\"></md-icon>Search</md-button><md-button \nng-if=\"vm.type == \'changeCartItem\' && vm.show_save\" ng-click=\"vm.addNewRoomstoCart()\" \nclass=\"md-raised md-green-500-bg submit-button white-fg\" aria-label=\"Save\" translate=\"Save\"></md-button></div></div>\n</md-content><md-content style=\"overflow: visible\" \nng-class=\"{\'hold-quote-open\': vm.data.type_of_reservation === \'hold\' && vm.showHoldGuestStep}\"><div \nclass=\"norecordfound\" ng-if=\"vm.available_rooms.length == 0 && vm.type == \'changeCartItem\'\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"pr-5\"></md-icon>{{\'ADD_ROOM.NO_ROOMS\' | translate}}</div><div \nclass=\"row-block-new room-availabe\" ng-if=\"vm.show_rooms\" layout=\"row\" layout-align=\"start start\" flex=\"100\" \nlayout-wrap><div layout=\"column\" flex=\"100\" class=\"norecordfound\" \nng-if=\"vm.available_rooms.length !== 0 && vm.type == \'changeCartItem\'\"><div><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"pr-5\"></md-icon>{{\'EC.NO_AVAILABILTY\' | translate}}</div></div><div \nlayout=\"column\" flex=\"100\" ng-if=\"vm.available_rooms.length !== 0\" class=\"full-width-100\" \nng-class=\"{\'md-padding\': !(vm.data.type_of_reservation === \'hold\' && vm.showHoldGuestStep)}\"><div \nclass=\"layout-colo-block padding-left-10 padding-right-10 full-width\" flex=\"100\" \nng-if=\"vm.data.type_of_reservation === \'block\'\"><md-input-container class=\"md-block m-b-0\" flex=\"50\" flex-gt-sm=\"30\" \nlayout=\"column\" \nng-class=\"(vm.isCommentEmpty && openPlaceGantt.block_comment.$untouched) || (openPlaceGantt.block_comment.$touched && (vm.data.room_stay_comment == \'\' || vm.data.room_stay_comment == undefined)) ? \'md-input-invalid\' : \'\'\">\n<label translate=\"OPTIONS_CREATE.COMMENT\"></label><input name=\"block_comment\" type=\"text\" \nng-model=\"vm.data.room_stay_comment\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"> <span \nng-show=\"(vm.isCommentEmpty && openPlaceGantt.block_comment.$untouched) || (openPlaceGantt.block_comment.$touched && (vm.data.room_stay_comment == \'\' || vm.data.room_stay_comment == undefined))\" \nclass=\"errornlk\">Please enter block comment.</span></md-input-container></div><div class=\"hold-rooms-step\" \nng-if=\"!(vm.data.type_of_reservation === \'hold\' && vm.showHoldGuestStep)\"><div class=\"custom-mat-tab\" \nng-if=\"vm.subHotel.length > 0\"><div class=\"custom-mat-tab-block\"><div class=\"custom-mat-tab-header\"><div \nclass=\"mat-tab-cell\" ng-class=\"vm.selectedSubHotelId == value.hotel_id ? \'active\' : \'\'\" \nng-repeat=\"value in vm.subHotel\" ng-click=\"vm.showtabs(value.hotel_id)\">{{value.hotel_title}}</div></div><div \nclass=\"custom-mat-tab-content\"><div class=\"tabAddroomConent\"><div class=\"form-title no-padding mb-15\" \nng-if=\"vm.requestType == 0 && vm.subHotelcount[vm.selectedSubHotelId] > 0\">{{\'ADD_ROOM.AVAILABLE_ROOMS\' | translate}} \n<span>{{ \'(\'+vm.subHotelcount[vm.selectedSubHotelId]+\')\' }}</span></div><div class=\"norecordfound\" \nng-if=\"vm.subHotelcount[vm.selectedSubHotelId] == 0\"><md-icon md-font-icon=\"icon-information-outline\" class=\"pr-5\">\n</md-icon>{{\'ADD_ROOM.NO_ROOMS\' | translate}}</div><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" \nflex-gt-xs=\"{{vm.showRateUI()?\'100\':\'50\'}}\" flex-gt-md=\"{{vm.showRateUI()?\'100\':\'50\'}}\" \nflex=\"{{vm.showRateUI()?\'100\':\'100\'}}\" ng-repeat=\"(roomkey,room) in vm.available_rooms\" \nclass=\"room-repeatblk relative-block\" ng-class=\"vm.getClass(room.product_id)\" \nng-if=\"room.sub_hotel_id == vm.selectedSubHotelId\"><div ng-class=\"room.onlyAllowHoldBlock ? \'no-rate-plan1\' : \'\'\"><div \nclass=\"room-listing\"><div class=\"img-block-room\"><img \nsrc=\"{{vm.baseUrl+\'assets/uploads/hotels/thumbnail/\'+room.image}}\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\"></div><div class=\"room-block-listing\" \n*ngif=\"!room.onlyAllowHoldBlock\"><div class=\"aprt-name aprt-name-lt mls-product\"><div class=\"product_name_blk\" \nng-if=\"vm.data.type_of_reservation === \'block\' || (vm.data.type_of_reservation === \'hold\' && room.onlyAllowHoldBlock)\" \nflex=\"100\" layout-wrap layout=\"row\"><md-checkbox class=\"margin-top-5 margin-bottom-5\" \nng-model=\"vm.selectedRoom[room.product_id]\" ng-disabled=\"vm.blockedOthers[room.product_id]\" \nng-change=\"vm.selectingroom(room.product_id,room.product_name,roomkey)\"></md-checkbox><h5 \nclass=\"product_name_for_hold\">{{room.product_name}}</h5></div><h5 \nng-if=\"vm.showRateUI() && !(vm.data.type_of_reservation === \'hold\' && room.onlyAllowHoldBlock)\">{{room.product_name}}\n</h5><p \nng-if=\"room.mls_days > 0 && vm.selectedProduct.indexOf(room.product_id) > -1 && vm.showWarning.indexOf(room.product_id) > -1 && vm.showRateUI()\" \nclass=\"mls-room\">Selected dates have MLS for {{room.mls_days}} nights<md-icon md-font-icon=\"icon-close\" \nclass=\"white-fg ng-scope md-font material-icons icon-close\" role=\"img\" aria-hidden=\"true\" \nng-click=\"vm.hideWarning(room.product_id)\"></md-icon></p><span class=\"readmoreblock\" \nng-click=\"vm.readDescription(room.product_id)\" id=\"readmoreblock_{{room.product_id}}\" \nng-if=\"vm.showRateUI() && !room.onlyAllowHoldBlock\">{{vm.readText}}</span></div><div class=\"policy-outer\" \nng-if=\"vm.showRateUI() && !room.onlyAllowHoldBlock\"><md-input-container class=\"mb-10 mt-0 md-input-has-value mb-0 row\" \nflex=\"100\" layout-wrap layout=\"row\"><div class=\"rate-div\" \nng-repeat=\"(policykey,eachpolicy) in vm.available_rooms[$index].policy_name\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\" layout=\"column\"><md-radio-group class=\"row no-margin\" flex=\"100\" layout-wrap layout=\"row\" \nng-model=\"vm.selectedRoom1[room.product_id]\" ng-change=\"vm.selectingpolicy(room.product_id)\"><span flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\" layout=\"column\" class=\"policy-blk no-margin space-block-inline pr-10 pb-15\" \nng-value=\"policykey\"><div class=\"Reservation-outer-block margin-top-5 margin-bottom-5\"><md-checkbox \nng-disabled=\"vm.blockedReservation[room.product_id] \" class=\"checkblock-ckeckbox margin-top-0 margin-bottom-0\" \nng-model=\"vm.temp[room.product_id][policykey]\" \nng-change=\"vm.selectingroom(room.product_id,room.product_name,roomkey, policykey)\"><span \nclass=\"aprt-nightly nt-policy\">{{eachpolicy}}</span> <span class=\"aprt-nightly rate-plan-anchor\" \nng-if=\"!vm.isDayCreateMode()\"><div class=\"rate-plan-txt\" ng-init=\"vm.showRateDesc[roomkey][policykey] = false\" \nng-mouseenter=\"!vm.runClickEvent?vm.showDetailRateBlock(roomkey,policykey):\'\'\" \nng-mouseleave=\"!vm.runClickEvent?vm.closeAllRateDetails(roomkey,policykey):\'\'\" \nng-click=\"vm.runClickEvent?vm.showDetailRateBlock(roomkey,policykey):\'\'\">\nRate Plan: {{vm.available_rooms[roomkey].rateNameDesc[policykey].ratePlanName}}<div class=\"total-amount-blk-section\" \nng-if=\"vm.showRateDesc[roomkey][policykey] && vm.available_rooms[roomkey].rateNameDesc[policykey].ratePlanDesc != \'\'\">\n<div class=\"total-amt-row\"><b>{{vm.available_rooms[roomkey].rateNameDesc[policykey].ratePlanDesc}}</b></div></div>\n</div></span><span class=\"aprt-nightly\" ng-if=\"vm.requestType == 0\">Max. Occupancy: {{room.max_occupancy}}</span> <span\n class=\"aprt-nightly\" ng-if=\"room.boat_length > 0\">Vessel Length: {{room.boat_length}}</span> <span \nclass=\"aprt-nightly\" ng-if=\"room.boat_width > 0\">Vessel Width: {{room.boat_width}}</span> <span \nclass=\"aprt-nightly avg-rate\">{{vm.isDayCreateMode() ? \'Day rate\' : \'Nightly rate\'}}: <b \nclass=\"rate-color-add red-A800-fg cut-price-span\"><span ng-if=\"vm.available_rooms[roomkey].anyPromoApplied\" \nclass=\"cut-price\">${{vm.available_rooms[roomkey].nightlyRate[policykey]}}</span> <span \nng-if=\"!vm.available_rooms[roomkey].anyPromoApplied && vm.available_rooms[roomkey].highestAvgRate[policykey] && vm.available_rooms[roomkey].highestAvgRate[policykey] !== vm.available_rooms[roomkey].nightlyRate[policykey]\" \nclass=\"cut-price\">${{vm.available_rooms[roomkey].highestAvgRate[policykey]}}</span>\n ${{vm.available_rooms[roomkey].anyPromoApplied ? vm.available_rooms[roomkey].displayNightlyRate[policykey] : vm.available_rooms[roomkey].nightlyRate[policykey]}}\n</b></span></md-checkbox><div class=\"total-price-block\" ng-init=\"vm.showBlock[roomkey][policykey] = false\" \nng-mouseenter=\"!vm.runClickEvent?vm.showDetailBlock(roomkey,policykey):\'\'\" \nng-mouseleave=\"!vm.runClickEvent?vm.closeAllDetails(roomkey,policykey):\'\'\" \nng-click=\"vm.runClickEvent?vm.showDetailBlock(roomkey,policykey):\'\'\"><small>Total</small> <b>\n${{vm.available_rooms[roomkey].searchSummary[policykey].grandTotal}}</b><div class=\"total-amount-blk-section\" \nng-if=\"vm.showBlock[roomkey][policykey]\"><div class=\"total-amt-row\"><span ng-if=\"vm.requestForType == \'room\'\">\nRoom Amount</span> <span ng-if=\"vm.requestForType == \'boat\'\">Slip Amount</span> <span>\n${{vm.available_rooms[roomkey].searchSummary[policykey].subTotal}}</span></div><div class=\"total-amt-row\" \nng-if=\"vm.extraPersonApplicable\"><span>Extra Person</span> <span>\n${{vm.available_rooms[roomkey].searchSummary[policykey].extraPersonAmt}}</span></div><div class=\"total-amt-row\" \nng-if=\"vm.resortFeeApplicable\"><span>Resort fee</span> <span>\n${{vm.available_rooms[roomkey].searchSummary[policykey].resortFee}}</span></div><div class=\"total-amt-row\" \nng-if=\"vm.available_rooms[roomkey].searchSummary[policykey].surcharge != undefined\"><span>Surcharge</span> <span>\n${{vm.available_rooms[roomkey].searchSummary[policykey].surcharge}}</span></div><div class=\"total-amt-row\" \nng-if=\"vm.available_rooms[roomkey].anyPromoApplied\"><span>Discount <span \nng-if=\"vm.holdPercentLabel(vm.available_rooms[roomkey].promoDiscount[policykey], vm.available_rooms[roomkey].searchSummary[policykey].subTotal)\">\n({{vm.holdPercentLabel(vm.available_rooms[roomkey].promoDiscount[policykey], vm.available_rooms[roomkey].searchSummary[policykey].subTotal)}}%)\n</span></span> <span class=\"hold-promo-discount\">-${{vm.available_rooms[roomkey].promoDiscount[policykey]}}</span>\n</div><div class=\"total-amt-row\"><span>Taxes</span> <span>\n${{vm.available_rooms[roomkey].searchSummary[policykey].taxes}}</span></div><div class=\"total-amt-row\"><span>\nGrand Total</span> <span>${{vm.available_rooms[roomkey].searchSummary[policykey].grandTotal}}</span></div></div></div>\n</div></span></md-radio-group></div></md-input-container></div><div class=\"no-rate-paln-section\" \nng-if=\"vm.showRateUI() && room.onlyAllowHoldBlock\"><span ng-bind-html=\"room.onlyAllowHoldBlockTxt\"></span></div></div>\n<p class=\"room_type_description\" id=\"description_{{room.product_id}}\" style=\"display: none\" ng-if=\"vm.showRateUI()\">\n{{room.room_type_description}}</p></div></div></div></div></div></div></div></div><div class=\"without-tab-block\" \nng-if=\"vm.subHotel.length == 0\"><div class=\"form-title no-padding mb-15\" ng-if=\"vm.requestType == 0\">\n{{\'ADD_ROOM.AVAILABLE_ROOMS\' | translate}} <span>{{ \'(\'+vm.available_rooms.length+\')\' }}</span></div><div \nclass=\"form-title no-padding mb-15\" ng-if=\"vm.requestType == 1\">{{\'ADD_ROOM.AVAILABLE_BOAT\' | translate}} <span>\n{{ \'(\'+vm.available_rooms.length+\')\' }}</span></div><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" \nflex-gt-xs=\"{{vm.showRateUI()?\'100\':\'50\'}}\" flex-gt-md=\"{{vm.showRateUI()?\'100\':\'50\'}}\" \nflex=\"{{vm.showRateUI()?\'100\':\'100\'}}\" ng-repeat=\"(roomkey,room) in vm.available_rooms\" \nclass=\"room-repeatblk relative-block\" ng-class=\"vm.getClass(room.product_id)\"><div \nng-class=\"room.onlyAllowHoldBlock ? \'no-rate-plan1\' : \'\'\"><div class=\"room-listing\"><div class=\"img-block-room\"><img \nsrc=\"{{vm.baseUrl+\'assets/uploads/hotels/thumbnail/\'+room.image}}\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\"></div><div class=\"room-block-listing\"><div \nclass=\"aprt-name aprt-name-lt mls-product\"><div class=\"product_name_blk\" \nng-if=\"vm.data.type_of_reservation === \'block\' || (vm.data.type_of_reservation === \'hold\' && room.onlyAllowHoldBlock)\" \nflex=\"100\" layout-wrap layout=\"row\"><md-checkbox class=\"margin-top-5 margin-bottom-5\" \nng-model=\"vm.selectedRoom[room.product_id]\" ng-disabled=\"vm.blockedOthers[room.product_id]\" \nng-change=\"vm.selectingroom(room.product_id,room.product_name,roomkey)\"></md-checkbox><h5 \nclass=\"product_name_for_hold\">{{room.product_name}}</h5></div><h5 \nng-if=\"vm.showRateUI() && !(vm.data.type_of_reservation === \'hold\' && room.onlyAllowHoldBlock)\">{{room.product_name}}\n</h5><p \nng-if=\"room.mls_days > 0 && vm.selectedProduct.indexOf(room.product_id) > -1 && vm.showWarning.indexOf(room.product_id) > -1 && vm.showRateUI()\" \nclass=\"mls-room\">Selected dates have MLS for {{room.mls_days}} nights<md-icon md-font-icon=\"icon-close\" \nclass=\"white-fg ng-scope md-font material-icons icon-close\" role=\"img\" aria-hidden=\"true\" \nng-click=\"vm.hideWarning(room.product_id)\"></md-icon></p><span class=\"readmoreblock\" \nng-click=\"vm.readDescription(room.product_id)\" id=\"readmoreblock_{{room.product_id}}\" \nng-if=\"vm.showRateUI() && !room.onlyAllowHoldBlock\">{{vm.readText}}</span></div><div class=\"policy-outer\" \nng-if=\"vm.showRateUI() && !room.onlyAllowHoldBlock\"><md-input-container class=\"mb-10 mt-0 md-input-has-value mb-0 row\" \nflex=\"100\" layout-wrap layout=\"row\"><div class=\"rate-div\" \nng-repeat=\"(policykey,eachpolicy) in vm.available_rooms[$index].policy_name\" flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\" layout=\"column\"><md-radio-group class=\"row no-margin\" flex=\"100\" layout-wrap layout=\"row\" \nng-model=\"vm.selectedRoom1[room.product_id]\" ng-change=\"vm.selectingpolicy(room.product_id)\"><span flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"100\" layout=\"column\" class=\"policy-blk no-margin space-block-inline pr-10 pb-15\" \nng-value=\"policykey\"><div class=\"Reservation-outer-block margin-top-5 margin-bottom-5\"><md-checkbox \nng-disabled=\"vm.blockedReservation[room.product_id] \" class=\"checkblock-ckeckbox margin-top-0 margin-bottom-0\" \nng-model=\"vm.temp[room.product_id][policykey]\" \nng-change=\"vm.selectingroom(room.product_id,room.product_name,roomkey, policykey)\"><span \nclass=\"aprt-nightly nt-policy\">{{eachpolicy}}</span> <span class=\"aprt-nightly rate-plan-anchor\" \nng-if=\"!vm.isDayCreateMode()\"><div class=\"rate-plan-txt\" ng-init=\"vm.showRateDesc[roomkey][policykey] = false\" \nng-mouseenter=\"!vm.runClickEvent?vm.showDetailRateBlock(roomkey,policykey):\'\'\" \nng-mouseleave=\"!vm.runClickEvent?vm.closeAllRateDetails(roomkey,policykey):\'\'\" \nng-click=\"vm.runClickEvent?vm.showDetailRateBlock(roomkey,policykey):\'\'\">\nRate Plan: {{vm.available_rooms[roomkey].rateNameDesc[policykey].ratePlanName}}<div class=\"total-amount-blk-section\" \nng-if=\"vm.showRateDesc[roomkey][policykey] && vm.available_rooms[roomkey].rateNameDesc[policykey].ratePlanDesc != \'\'\">\n<div class=\"total-amt-row\"><b>{{vm.available_rooms[roomkey].rateNameDesc[policykey].ratePlanDesc}}</b></div></div>\n</div></span><span class=\"aprt-nightly\" ng-if=\"vm.requestType == 0\">Max. Occupancy: {{room.max_occupancy}}</span> <span\n class=\"aprt-nightly\" ng-if=\"room.boat_length > 0 && vm.requestType == 1\">Vessel Length: {{room.boat_length}}</span> \n<span class=\"aprt-nightly\" ng-if=\"room.boat_width > 0 && vm.requestType == 1\">Vessel Width: {{room.boat_width}}</span> \n<span class=\"aprt-nightly avg-rate\">{{vm.isDayCreateMode() ? \'Day rate\' : \'Nightly rate\'}}: <b \nclass=\"rate-color-add red-A800-fg cut-price-span\"><span ng-if=\"vm.available_rooms[roomkey].anyPromoApplied\" \nclass=\"cut-price\">${{vm.available_rooms[roomkey].nightlyRate[policykey]}}</span>\n ${{vm.available_rooms[roomkey].anyPromoApplied ? vm.available_rooms[roomkey].displayNightlyRate[policykey] : vm.available_rooms[roomkey].nightlyRate[policykey]}}\n</b></span></md-checkbox><div class=\"total-price-block\" ng-init=\"vm.showBlock[roomkey][policykey] = false\" \nng-mouseenter=\"!vm.runClickEvent?vm.showDetailBlock(roomkey,policykey):\'\'\" \nng-mouseleave=\"!vm.runClickEvent?vm.closeAllDetails(roomkey,policykey):\'\'\" \nng-click=\"vm.runClickEvent?vm.showDetailBlock(roomkey,policykey):\'\'\"><small>Total</small> <b>\n${{vm.available_rooms[roomkey].searchSummary[policykey].grandTotal}}</b><div class=\"total-amount-blk-section\" \nng-if=\"vm.showBlock[roomkey][policykey]\"><div class=\"total-amt-row\"><span ng-if=\"vm.requestForType == \'room\'\">\nRoom Amount</span> <span ng-if=\"vm.requestForType == \'boat\'\">Slip Amount</span> <span>\n${{vm.available_rooms[roomkey].searchSummary[policykey].subTotal}}</span></div><div class=\"total-amt-row\" \nng-if=\"vm.extraPersonApplicable\"><span>Extra Person</span> <span>\n${{vm.available_rooms[roomkey].searchSummary[policykey].extraPersonAmt}}</span></div><div class=\"total-amt-row\" \nng-if=\"vm.resortFeeApplicable\"><span>Resort fee</span> <span>\n${{vm.available_rooms[roomkey].searchSummary[policykey].resortFee}}</span></div><div class=\"total-amt-row\" \nng-if=\"vm.available_rooms[roomkey].searchSummary[policykey].surcharge != undefined\"><span>Surcharge</span> <span>\n${{vm.available_rooms[roomkey].searchSummary[policykey].surcharge}}</span></div><div class=\"total-amt-row\" \nng-if=\"vm.available_rooms[roomkey].anyPromoApplied\"><span>Discount <span \nng-if=\"vm.holdPercentLabel(vm.available_rooms[roomkey].promoDiscount[policykey], vm.available_rooms[roomkey].searchSummary[policykey].subTotal)\">\n({{vm.holdPercentLabel(vm.available_rooms[roomkey].promoDiscount[policykey], vm.available_rooms[roomkey].searchSummary[policykey].subTotal)}}%)\n</span></span> <span class=\"hold-promo-discount\">-${{vm.available_rooms[roomkey].promoDiscount[policykey]}}</span>\n</div><div class=\"total-amt-row\"><span>Taxes</span> <span>\n${{vm.available_rooms[roomkey].searchSummary[policykey].taxes}}</span></div><div class=\"total-amt-row\"><span>\nGrand Total</span> <span>${{vm.available_rooms[roomkey].searchSummary[policykey].grandTotal}}</span></div></div></div>\n</div></span></md-radio-group></div></md-input-container></div><div class=\"no-rate-paln-section\" \nng-if=\"vm.showRateUI() && room.onlyAllowHoldBlock\"><span ng-bind-html=\"room.onlyAllowHoldBlockTxt\"></span></div></div>\n<p class=\"room_type_description\" id=\"description_{{room.product_id}}\" style=\"display: none\" ng-if=\"vm.showRateUI()\">\n{{room.room_type_description}}</p></div></div></div></div></div></div><div \nclass=\"hold-guest-step-box hold-quote-body full-width\" flex=\"100\" \nng-if=\"vm.data.type_of_reservation === \'hold\' && vm.showHoldGuestStep\"><div class=\"hold-selected-room-box\" flex=\"100\">\n<div class=\"hold-change-room-wrap\" layout=\"row\" layout-align=\"space-between center\"><h4 class=\"hold-section-heading\">\nSelected Room</h4><md-button class=\"md-raised hold-change-room-btn\" type=\"button\" ng-if=\"vm.holdSelectedRooms.length\" \nng-click=\"vm.backToHoldRooms()\" aria-label=\"Change Room\">Change Room</md-button></div><div \nclass=\"hold-selected-room-list\" layout=\"column\" flex=\"100\"><div layout=\"column\" flex=\"100\" \nclass=\"room-repeatblk relative-block createResCase\" ng-repeat=\"sroom in vm.holdSelectedRooms\" \nng-class=\"sroom.onlyAllowHoldBlock ? \'no-rate-plan1\' : \'\'\"><div class=\"room-listing\" \nng-class=\"{\'is-open\': sroom.showHoldDiscountPanel}\"><div class=\"room-block-listing\"><div class=\"policy-outer\" \nng-if=\"!sroom.onlyAllowHoldBlock\"><md-input-container class=\"mb-10 mt-0 md-input-has-value mb-0 row\" flex=\"100\" \nlayout-wrap layout=\"row\"><div class=\"rate-div\" flex=\"100\" layout=\"column\"><span flex=\"100\" layout=\"column\" \nclass=\"policy-blk no-margin space-block-inline pr-10 pb-15\"><div \nclass=\"Reservation-outer-block margin-top-5 margin-bottom-5 hold-room-detail-line\" \nng-click=\"vm.toggleHoldRoomDiscount(sroom, $event)\"><h5 class=\"hold-inline-room-name\"><span>{{sroom.product_name}}\n</span></h5><span class=\"aprt-nightly hold-detail-occ\" ng-if=\"vm.requestType == 0 && sroom.max_occupancy\">\nMax. Occupancy: {{sroom.max_occupancy}}</span><div class=\"rate-plan-spans-block\"><span \nclass=\"aprt-nightly rate-plan-anchor\" ng-if=\"!vm.isDayCreateMode() && sroom.ratePlanName\"><div class=\"rate-plan-txt\" \nng-init=\"sroom.showRateDesc = false\" ng-mouseenter=\"sroom.showRateDesc = true\" \nng-mouseleave=\"sroom.showRateDesc = false\" \nng-click=\"$event.stopPropagation(); sroom.showRateDesc = !sroom.showRateDesc\">Rate Plan: {{sroom.ratePlanName}}<div \nclass=\"total-amount-blk-section\" ng-if=\"sroom.showRateDesc && sroom.ratePlanDesc\"><div class=\"total-amt-row\"><b>\n{{sroom.ratePlanDesc}}</b></div></div></div></span><span class=\"aprt-nightly\" \nng-if=\"sroom.boat_length > 0 && vm.requestType == 1\">Vessel Length: {{sroom.boat_length}}</span> <span \nclass=\"aprt-nightly\" ng-if=\"sroom.boat_width > 0 && vm.requestType == 1\">Vessel Width: {{sroom.boat_width}}</span> \n<span class=\"aprt-nightly avg-rate\">{{vm.isDayCreateMode() ? \'Day rate\' : \'Nightly rate\'}}: <b \nclass=\"rate-color-add red-A800-fg cut-price-span\"><span ng-if=\"sroom.anyPromoApplied || sroom.holdDiscountApplied\" \nclass=\"cut-price\">${{sroom.nightlyRate}}</span> <span \nng-if=\"!sroom.anyPromoApplied && !sroom.holdDiscountApplied && !vm.isDayCreateMode() && sroom.highestAvgRate && sroom.highestAvgRate !== sroom.nightlyRate && sroom.highestAvgRate > sroom.nightlyRate\" \nclass=\"cut-price\">${{sroom.highestAvgRate}}</span>\n ${{(sroom.anyPromoApplied || sroom.holdDiscountApplied) ? sroom.displayNightlyRate : sroom.nightlyRate}}</b></span>\n</div><div class=\"total-price-block\" ng-init=\"vm.showHoldSelectedBlock[sroom.product_id] = false\" \nng-mouseenter=\"vm.showHoldSelectedBlock[sroom.product_id] = true\" \nng-mouseleave=\"vm.showHoldSelectedBlock[sroom.product_id] = false\"><small>Total</small> <b>\n${{sroom.searchSummary.grandTotal}}</b><div class=\"total-amount-blk-section\" \nng-if=\"vm.showHoldSelectedBlock[sroom.product_id]\"><div class=\"total-amt-row\"><span \nng-if=\"vm.requestForType == \'room\'\">Room Amount</span> <span ng-if=\"vm.requestForType == \'boat\'\">Slip Amount</span> \n<span>${{sroom.searchSummary.subTotal}}</span></div><div class=\"total-amt-row\" ng-if=\"vm.extraPersonApplicable\"><span>\nExtra Person</span> <span>${{sroom.searchSummary.extraPersonAmt}}</span></div><div class=\"total-amt-row\" \nng-if=\"vm.resortFeeApplicable\"><span>Resort fee</span> <span>${{sroom.searchSummary.resortFee}}</span></div><div \nclass=\"total-amt-row\" ng-if=\"sroom.searchSummary.surcharge != undefined\"><span>Surcharge</span> <span>\n${{sroom.searchSummary.surcharge}}</span></div><div class=\"total-amt-row\" ng-if=\"sroom.anyPromoApplied\"><span>Discount \n<span ng-if=\"vm.holdPercentLabel(sroom.promoCodeDiscount, sroom.searchSummary.subTotal)\">\n({{vm.holdPercentLabel(sroom.promoCodeDiscount, sroom.searchSummary.subTotal)}}%)</span></span> <span \nclass=\"hold-promo-discount\">-${{sroom.promoCodeDiscount}}</span></div><div class=\"total-amt-row\" \nng-if=\"sroom.holdDiscountApplied\"><span>Discount <span ng-if=\"sroom.holdDiscountPercent > 0\">\n({{sroom.holdDiscountPercent}}%)</span></span> <span class=\"hold-promo-discount\">-${{sroom.holdDiscountAmount}}</span>\n</div><div class=\"total-amt-row\"><span>Taxes</span> <span>${{sroom.searchSummary.taxes}}</span></div><div \nclass=\"total-amt-row\"><span>Grand Total</span> <span>${{sroom.searchSummary.grandTotal}}</span></div></div></div></div>\n</span></div></md-input-container></div><div class=\"no-rate-paln-section\" ng-if=\"sroom.onlyAllowHoldBlock\"><span \nng-bind-html=\"sroom.onlyAllowHoldBlockTxt\"></span></div></div></div><div \nclass=\"hold-nightly-price nightly-price-heading\" \nng-if=\"!sroom.onlyAllowHoldBlock && sroom.showHoldDiscountPanel && sroom.holdNightlyRows.length\">Nightly-price<div \nclass=\"nightlyscrollblk\"><div class=\"scroll-nightly-inner\"><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"row-block1-amount row-header-amount\"><div layout=\"column\" flex=\"20\" layout-align=\"center start\">Night</div><div \nlayout=\"column\" flex=\"20\" layout-align=\"center start\">Date</div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center start\">Rate Plan</div><div layout=\"column\" flex=\"20\" layout-align=\"center end\">Discount</div><div \nlayout=\"column\" flex=\"20\" layout-align=\"center end\">Price</div></div><div \nng-repeat=\"night in sroom.holdNightlyRows track by $index\" class=\"hold-nightly-row-wrap\"><div layout=\"row\" flex=\"100\" \nlayout-wrap class=\"row-nightly-amount row-block1-amount\"><div layout=\"column\" flex=\"20\" layout-align=\"center start\">\n<div class=\"charges\">Night {{night.nightNum}}</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center start\">\n<div class=\"charges\">{{night.date}}</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center start\"><div \nclass=\"charges\">{{night.ratePlan}}</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center end\"><div \nclass=\"amount discount\"><md-input-container class=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <span\n class=\"nightly-discount-value\" ng-class=\"{\'hold-discount-locked\': sroom.anyPromoApplied}\" \nng-click=\"!sroom.anyPromoApplied && vm.openHoldRoomNightDiscount(sroom, $index, $event)\"><span \nclass=\"nightly-discount-amount\">{{ night.amount | number:2 }}</span> <span class=\"nightly-discount-percent\" \nng-if=\"night.percentLabel\">{{night.percentLabel}}%</span> </span><i ng-if=\"night.amount > 0\" \nclass=\"icon icon-comment-outline discountcomment\" ng-class=\"{\'onlycursorPointer\': !sroom.anyPromoApplied}\" \nng-click=\"!sroom.anyPromoApplied && vm.openHoldRoomNightDiscount(sroom, $index, $event)\"><md-tooltip \nng-if=\"night.comment\">{{night.comment}}</md-tooltip></i></md-input-container></div></div><div layout=\"column\" \nflex=\"20\" layout-align=\"center end\"><div class=\"amount price\"><md-input-container class=\"md-block no-margin\"><i \nclass=\"icon icon-currency-usd s20\"></i> <span class=\"charges\">{{ night.rate | number:2 }}</span></md-input-container>\n</div></div></div></div></div></div></div><p class=\"room_type_description\" id=\"hold_description_{{sroom.product_id}}\" \nstyle=\"display: none\" ng-if=\"sroom.room_type_description\">{{sroom.room_type_description}}</p></div></div></div><div \nclass=\"expiray_block full-width hold-guest-details hold-quote-form hold-guest-details-box\" flex=\"100\"><h4 \nclass=\"hold-section-heading\">Customer Details</h4><div flex=\"100\" layout=\"row\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10\" flex=\"50\" flex-xs=\"100\" layout=\"column\"><md-autocomplete \nmd-no-cache=\"vm.holdCustomerNoCache\" md-selected-item=\"vm.selectedHoldCustomer.first_name\" \nmd-selected-item-change=\"vm.selectHoldCustomer(item)\" \nmd-items=\"item in vm.queryHoldCustomer(vm.searchTextFn, \'cust.first_name\')\" md-search-text=\"vm.searchTextFn\" \nmd-search-text-change=\"vm.onHoldCustomerSearchChange(\'first_name\')\" md-item-text=\"item.first_name\" md-min-length=\"1\" \nmd-delay=\"500\" md-floating-label=\"{{ \'CREATE_RES.CUST_FN\' | translate }}\" md-dropdown-position=\"bottom\" \nmd-menu-class=\"hold-customer-suggest\" ng-disabled=\"vm.autoFillOff\" class=\"chooseCustomer full-width\" required>\n<md-item-template><span md-highlight-text=\"vm.searchTextFn\" md-highlight-flags=\"^i\">{{item.display}}</span>\n</md-item-template></md-autocomplete></div><div class=\"padding-left-10 padding-right-10\" flex=\"50\" flex-xs=\"100\" \nlayout=\"column\"><md-autocomplete md-no-cache=\"vm.holdCustomerNoCache\" \nmd-selected-item=\"vm.selectedHoldCustomer.last_name\" md-selected-item-change=\"vm.selectHoldCustomer(item)\" \nmd-items=\"item in vm.queryHoldCustomer(vm.searchTextLn, \'cust.last_name\')\" md-search-text=\"vm.searchTextLn\" \nmd-search-text-change=\"vm.onHoldCustomerSearchChange(\'last_name\')\" md-item-text=\"item.last_name\" md-min-length=\"1\" \nmd-delay=\"500\" md-floating-label=\"{{ \'CREATE_RES.CUST_LN\' | translate }}\" md-dropdown-position=\"bottom\" \nmd-menu-class=\"hold-customer-suggest\" ng-disabled=\"vm.autoFillOff\" class=\"chooseCustomer full-width\" required>\n<md-item-template><span md-highlight-text=\"vm.searchTextLn\" md-highlight-flags=\"^i\">{{item.display}}</span>\n</md-item-template></md-autocomplete></div></div><div flex=\"100\" layout=\"row\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10\" flex=\"50\" flex-xs=\"100\" layout=\"column\"><md-autocomplete \nmd-no-cache=\"vm.holdCustomerNoCache\" md-selected-item=\"vm.selectedHoldCustomer.customer_email\" \nmd-selected-item-change=\"vm.selectHoldCustomer(item)\" \nmd-items=\"item in vm.queryHoldCustomer(vm.searchTextEm, \'cust.customer_email\')\" md-search-text=\"vm.searchTextEm\" \nmd-search-text-change=\"vm.onHoldCustomerSearchChange(\'customer_email\')\" md-item-text=\"item.customer_email\" \nmd-min-length=\"1\" md-delay=\"500\" md-floating-label=\"{{ \'CREATE_RES.CUST_EMAIL\' | translate }}\" \nmd-dropdown-position=\"bottom\" md-menu-class=\"hold-customer-suggest\" ng-disabled=\"vm.autoFillOff\" \nclass=\"chooseCustomer full-width\" required><md-item-template><span md-highlight-text=\"vm.searchTextEm\" \nmd-highlight-flags=\"^i\">{{item.customer_email}}</span></md-item-template></md-autocomplete></div><div \nclass=\"padding-left-10 padding-right-10\" flex=\"50\" flex-xs=\"100\" layout=\"column\"><md-input-container \nclass=\"md-block m-b-0 full-width hold-phone-container\" \nng-class=\"{\'md-input-has-value\': !!vm.data.phone_number, \'hold-phone-invalid md-input-invalid\': vm.holdPhoneInvalid}\">\n<label translate=\"CREATE_RES.CUST_CONT_NO\" class=\"phone-number-label\"></label><input required name=\"phone_number\" \ntype=\"tel\" class=\"intel-number-input hold-quote-phone\" intl-tel-input ng-model=\"vm.data.phone_number\" \nng-model-options=\"{debounce: 800}\" ng-change=\"vm.updateHoldPhone()\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\">\n<div class=\"hold-phone-error\" ng-if=\"vm.holdPhoneInvalid\">Not a valid number</div></md-input-container></div></div><div\n flex=\"100\" layout=\"row\" layout-wrap><div class=\"padding-left-10 padding-right-10\" flex=\"50\" flex-xs=\"100\" \nlayout=\"column\"><md-input-container class=\"md-block m-b-0 full-width hold-expiry-date\" \nng-class=\"{\'md-input-has-value\': !!vm.data.hold_duration}\"><label translate=\"OPTIONS_CREATE.EXPIRYDATE\"></label>\n<md-datepicker md-open-on-focus ng-model=\"vm.data.hold_duration\" md-min-date=\"vm.minDate\" \nclass=\"full-width mdinput-block\"></md-datepicker></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" flex=\"50\" flex-xs=\"100\" layout=\"column\"><md-input-container \nclass=\"md-block m-b-0 full-width hold-expiry-time\" ng-class=\"{\'md-input-has-value\': !!vm.data.hold_duration_time}\">\n<label translate=\"OPTIONS_CREATE.EXPIRYTIME\"></label><input type=\"time\" id=\"holdExpiryTime\" name=\"hold_duration_time\" \nng-model=\"vm.data.hold_duration_time\" min=\"00:00\" max=\"23:59\" step=\"1800\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></md-input-container></div></div><div class=\"padding-left-10 padding-right-10\" flex=\"100\">\n<md-input-container class=\"md-block m-b-0 full-width\" \nng-class=\"(vm.isCommentEmpty && openPlaceGantt.hold_comment.$untouched) || (openPlaceGantt.hold_comment.$touched && (vm.data.room_stay_comment == \'\' || vm.data.room_stay_comment == undefined)) ? \'md-input-invalid\' : \'\'\">\n<label translate=\"OPTIONS_CREATE.COMMENT\"></label><input name=\"hold_comment\" type=\"text\" \nng-model=\"vm.data.room_stay_comment\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"> <span \nng-show=\"(vm.isCommentEmpty && openPlaceGantt.hold_comment.$untouched) || (openPlaceGantt.hold_comment.$touched && (vm.data.room_stay_comment == \'\' || vm.data.room_stay_comment == undefined))\" \nclass=\"errornlk\">Please enter hold comment.</span></md-input-container></div></div></div></div><div \nclass=\"norecordfound\" ng-if=\"vm.available_rooms.length == 0 && vm.requestType == 0\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"pr-5\"></md-icon>{{\'ADD_ROOM.NO_ROOMS\' | translate}}</div><div \nclass=\"norecordfound\" ng-if=\"vm.available_rooms.length == 0 && vm.requestType == 1\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"pr-5\"></md-icon>{{\'ADD_ROOM.NO_BOATS\' | translate}}</div></div>\n</md-content></md-dialog-content><md-dialog-actions layout=\"row\" flex=\"100\" layout-align=\"end center\"><div \nng-if=\"vm.show_rooms\" layout=\"row\" layout-align=\"end center\" flex=\"100\"><md-button \nng-if=\"vm.data.type_of_reservation === \'hold\' && vm.showHoldGuestStep && vm.hasHoldRoomSelected()\" type=\"button\" \nng-click=\"vm.backToHoldRooms()\" class=\"md-raised\" aria-label=\"Back\">Back</md-button><md-button \nng-if=\"vm.isCreateMode()\" ng-click=\"vm.addNewRoomstoCart()\" \nng-class=\"openPlaceGantt.$invalid  || vm.roomObjectValidation?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"openPlaceGantt.$invalid  || vm.roomObjectValidation\" aria-label=\"Continue\" translate=\"Continue\">\n</md-button><md-button ng-if=\"vm.data.type_of_reservation === \'hold\' && !vm.showHoldGuestStep\" \nng-click=\"vm.goToHoldGuestStep()\" \nng-class=\"!vm.hasHoldRoomSelected()?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"!vm.hasHoldRoomSelected()\" aria-label=\"Next\">Next</md-button><md-button class=\"hold-send-btn\" \nng-if=\"vm.data.type_of_reservation === \'hold\' && vm.showHoldGuestStep\" ng-click=\"vm.addNewRoomstoCart()\" \nng-class=\"openPlaceGantt.$invalid || vm.holdSending?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"openPlaceGantt.$invalid || vm.holdSending\" aria-label=\"Send\">Send</md-button><md-button \nng-if=\"vm.data.type_of_reservation === \'block\'\" ng-click=\"vm.addNewRoomstoCart()\" \nng-class=\"openPlaceGantt.$invalid || !vm.enableAdd?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"openPlaceGantt.$invalid || !vm.enableAdd\" aria-label=\"Save\" translate=\"Save\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/create-res/dialogs/add-services/add-services.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"openPlaceGantt\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"ADD_SERVICES.TITLE\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\" class=\"main-dilog-1\"><md-content class=\"md-padding\"><div \nclass=\"demo-select-all-checkboxes\" flex=\"100\" ng-repeat=\"service in vm.services\"><md-checkbox \nng-checked=\"exists(service.product_id)\" ng-click=\"toggle(service.product_id, service)\" class=\"checkbox-listing11\"><div \nclass=\"room-listing\"><div class=\"img-block-room\"><img ng-if=\"!service.image\" \nng-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\" class=\"erroeimg-1\"> <img ng-if=\"service.image\" \nng-src=\":{{vm.baseUrl+\'/assets/uploads/product/\'+service.image}}\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\" class=\"erroeimg-1\"></div><div \nclass=\"room-block-listing\"><span class=\"aprt-name\">{{ service.product_name }}</span> <span class=\"aprt-nightly\">\n{{service.product_is_timebound == \'1\'?\'Nightly rate\':\'Rate\'}}: ${{service.product_price}}</span></div></div>\n</md-checkbox><div flex=\"100\" layout=\"row\" layout-wrap \nng-if=\"service.product_is_timebound == 1 &&  exists(service.product_id)\"><div class=\"row-block-new\" flex=\"50\" \nlayout=\"column\" layout-align=\"start start\" flex><md-input-container class=\"md-block full-width\"><label \ntranslate=\"CREATE_RES.CHECKIN\"></label><md-datepicker md-open-on-focus \nng-init=\"vm.new_checkin[service.product_id] = vm.new_checkin\" ng-model=\"vm.new_checkin[service.product_id]\" \nmd-min-date=\"vm.minDate\" md-max-date=\"vm.new_checkout[service.product_id]\" \nng-change=\"vm.updateSelectedDate(service.product_id)\" class=\"full-width mdinput-block\"></md-datepicker><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div class=\"row-block-new\" flex=\"50\" layout=\"column\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block full-width\"><label translate=\"CREATE_RES.CHECKOUT\">\n</label><md-datepicker md-open-on-focus ng-init=\"vm.new_checkout[service.product_id] = vm.new_checkout\" \nng-model=\"vm.new_checkout[service.product_id]\" md-min-date=\"vm.minDate\" class=\"full-width mdinput-block\" \nng-change=\"vm.updateSelectedDate(service.product_id)\"></md-datepicker><div class=\"md-errors-spacer\"></div>\n</md-input-container></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"layout-align-start-center layout-row\"><md-button type=\"submit\" ng-click=\"vm.addService()\" \nng-class=\"vm.selected.lebgth ==0 ?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-accent submit-button white-fg\'\" \nng-disabled=\"vm.selected.length == 0\" aria-label=\"ADD\" translate=\"ADD\"></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/apps/create-res/dialogs/consolidate/consolidate.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"discountcomment\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{\'CREATE_RES.CONSOLIDATE_ACTION\' | translate}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content>\n<md-content class=\"md-padding\"><div class=\"row-block\"><div class=\"consolidate_wrapper\"><div \nclass=\"consolidate_buttons\" ng-click=\"vm.clickButtonType(\'new\')\"><div class=\"btn-icon-blk\"><md-icon \nmd-font-icon=\"icon-calendar-plus\" class=\"close-icon1 font-size-12 onlycursorPointer\"></md-icon></div><span>\n{{\'CREATE_RES.\' + vm.addNewType | translate}}</span></div><div class=\"consolidate_buttons\" \nng-click=\"vm.clickButtonType(\'split\')\" ng-class=\"vm.consolidateDisabled ? \'consolidate_buttons_disabled\' : \'\'\"><div \nclass=\"btn-icon-blk\"><md-icon md-font-icon=\"icon-border-vertical\" class=\"close-icon1 font-size-12 onlycursorPointer\">\n</md-icon></div><span>Split Reservation</span></div><div class=\"consolidate_buttons\" \nng-click=\"vm.clickButtonType(\'dates\')\"><div class=\"btn-icon-blk\"><md-icon md-font-icon=\"icon-calendar-today\" \nclass=\"close-icon1 font-size-12 onlycursorPointer\"></md-icon></div><span>Change Dates</span></div><div \nclass=\"consolidate_buttons last-button\" ng-click=\"vm.clickButtonType(\'roomChange\')\"><div class=\"btn-icon-blk\"><md-icon \nmd-font-icon=\"icon-calendar-today\" class=\"close-icon1 font-size-12 onlycursorPointer\"></md-icon></div><span \nng-if=\"vm.type != \'boat\'\">Change Room</span> <span ng-if=\"vm.type == \'boat\'\">Change Slip</span></div></div></div>\n</md-content></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end end\" flex=\"100\"></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/create-res/dialogs/discount-comment/discount-comment.html","<md-dialog class=\"contact-dialog discount-comment-dialog\" ng-class=\"{\'nights-step\': vm.step == 2}\" \naria-label=\"New Task\"><form name=\"discountcomment\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-tall white-fg\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.step == 2 ? \'Select Nights\' : vm.title}}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-content class=\"md-padding discount-comment-body\"><div \nclass=\"discount-slider-viewport\"><div class=\"discount-slider\" ng-class=\"{\'show-nights\': vm.step == 2}\"><div \nclass=\"discount-slide\" ng-class=\"{\'inactive\': vm.step != 1}\" aria-hidden=\"{{vm.step != 1}}\"><div \nclass=\"discount-row discount-row-fields\" ng-if=\"vm.type == \'nightly_discount\'\"><md-input-container \nclass=\"md-block tax-inputs mdinputblk discount-col\" flex=\"50\" flex-gt-xs=\"50\"><label class=\"ng-scope md-required\" \nrole=\"button\">Amount ($)</label><input ng-model-options=\"{updateOn: \'blur\'}\" type=\"text\" name=\"amount\" \nng-model=\"vm.data.amount\" ng-change=\"vm.onAmountChange()\" required allow-decimal-numbers autocomplete=\"off\">\n</md-input-container><md-input-container class=\"md-block tax-inputs mdinputblk discount-col\" flex=\"50\" flex-gt-xs=\"50\">\n<label class=\"ng-scope\" role=\"button\">Percent (%)</label><input ng-model-options=\"{updateOn: \'blur\'}\" type=\"text\" \nname=\"percent\" ng-model=\"vm.data.percent\" ng-change=\"vm.onPercentChange()\" allow-decimal-numbers autocomplete=\"off\">\n</md-input-container></div><div class=\"discount-row\"><md-input-container class=\"md-block tax-inputs mdinputblk\" \nflex=\"100\" ng-class=\"vm.showCommentError ? \'md-input-invalid\' : \'\'\"><label class=\"ng-scope md-required\" role=\"button\">\nReason for discount</label><input type=\"text\" name=\"comment\" ng-model=\"vm.data.comment\" ng-change=\"vm.checkReason()\" \nautocomplete=\"off\"></md-input-container></div><p class=\"discount-helper-note\" ng-if=\"vm.type == \'nightly_discount\'\">\n<strong>Note:</strong> Enter either amount or percent — the other will update automatically.</p><md-checkbox \nclass=\"apply-other-nights\" ng-if=\"vm.multiNight\" ng-checked=\"vm.applyToOtherNights\" \nng-click=\"vm.applyToOtherNights = !vm.applyToOtherNights\" aria-label=\"Apply to other nights\">\nApply this discount to other nights</md-checkbox><md-radio-group class=\"apply-night-mode\" layout=\"row\" \nng-if=\"vm.multiNight && vm.applyToOtherNights\" ng-model=\"vm.applyMode\" aria-label=\"Nights to apply the discount to\">\n<md-radio-button value=\"all\">All nights</md-radio-button><md-radio-button value=\"select\">Selected nights\n</md-radio-button></md-radio-group></div><div class=\"discount-slide\" ng-if=\"vm.multiNight\" \nng-class=\"{\'inactive\': vm.step != 2}\" aria-hidden=\"{{vm.step != 2}}\"><div class=\"discount-nights-summary\">\n{{vm.getNightsSummary()}}</div><div class=\"discount-nights-header\"><span class=\"header-title\">Apply to</span> <span \nclass=\"header-count\">{{vm.selectedCount()}} of {{vm.enabledNightsCount}} selected</span> <a href=\"\" \nclass=\"select-all-link\" ng-click=\"vm.toggleAllNights()\">{{vm.allNightsSelected() ? \'Clear all\' : \'Select all nights\'}}\n</a></div><div class=\"discount-nights-list\" role=\"group\" aria-label=\"Nights\"><div \nclass=\"lowest-price-content discount-night-groups\" ng-if=\"!vm.groupType\"><div ng-init=\"tableNights = vm.nights\" \nng-include=\"\'app/main/apps/create-res/dialogs/discount-comment/discount-night-table.html\'\"></div></div><div \nclass=\"lowest-price-content discount-night-groups\" ng-if=\"vm.groupType\"><div class=\"accordian-cover\"><div \nclass=\"accordian-row\"><div class=\"accordian-content onlyWeekdata\" ng-if=\"vm.groupType == \'week\'\"><div \nclass=\"accordian-inner-content weekcontent\"><div class=\"accordian-content weekContainer\" \nng-repeat=\"(weekName, items) in vm.nightGroups\"><h5 class=\"accordian-title accordian-title-minus\" \nng-class=\"{\'open\': vm.openGroups[weekName]}\" ng-click=\"vm.toggleGroup(weekName)\"><md-checkbox class=\"group-check\" \nng-checked=\"vm.isGroupSelected(items)\" md-indeterminate=\"vm.isGroupPartlySelected(items)\" \nng-class=\"{\'md-checked\': vm.isGroupSelected(items)}\" ng-disabled=\"!vm.groupHasNights(items)\" \nng-click=\"vm.toggleGroupNights($event, items)\" ng-keypress=\"vm.onGroupKeypress($event, items)\" \naria-label=\"Select week\"></md-checkbox><span class=\"newhtmlappend monthsblock\" \nng-bind-html=\"vm.getWeekHeaderName(items, weekName)\"></span> <span class=\"priceblockouter\"><span \nclass=\"pricemaininner\"><b class=\"discount\">{{vm.getGroupSelectedCount(items)}}</b><small class=\"totalblk\">Selected\n</small></span></span></h5><div class=\"accordian-inner-content\" ng-show=\"vm.openGroups[weekName]\"><div \nng-init=\"tableNights = vm.getTableNights(items)\" \nng-include=\"\'app/main/apps/create-res/dialogs/discount-comment/discount-night-table.html\'\"></div></div></div></div>\n</div><div class=\"accordian-content\" ng-if=\"vm.groupType == \'month\'\" \nng-repeat=\"(monthName, monthData) in vm.nightGroups\"><h5 class=\"accordian-title accordian-title-minus\" \nng-click=\"vm.toggleGroup(monthName)\"><md-checkbox class=\"group-check\" ng-checked=\"vm.isGroupSelected(monthData)\" \nmd-indeterminate=\"vm.isGroupPartlySelected(monthData)\" ng-class=\"{\'md-checked\': vm.isGroupSelected(monthData)}\" \nng-disabled=\"!vm.groupHasNights(monthData)\" ng-click=\"vm.toggleGroupNights($event, monthData)\" \nng-keypress=\"vm.onGroupKeypress($event, monthData)\" aria-label=\"Select {{monthName}}\"></md-checkbox><span \nclass=\"monthname\">{{monthName}}</span> <span class=\"priceblockmain\"><span class=\"pricemaininner\"><b class=\"discount\">\n{{vm.getGroupSelectedCount(monthData)}}</b><small class=\"totalblk\">Selected</small></span></span></h5><div \nclass=\"accordian-inner-content\" ng-show=\"vm.openGroups[monthName]\"><div \nclass=\"accordian-content weekContainer weekafter\" ng-repeat=\"(weekName, items) in monthData\"><h5 \nclass=\"accordian-title accordian-title-minus\" ng-class=\"{\'open\': vm.openGroups[weekName + monthName]}\" \nng-click=\"vm.toggleGroup(weekName + monthName)\"><md-checkbox class=\"group-check\" \nng-checked=\"vm.isGroupSelected(items)\" md-indeterminate=\"vm.isGroupPartlySelected(items)\" \nng-class=\"{\'md-checked\': vm.isGroupSelected(items)}\" ng-disabled=\"!vm.groupHasNights(items)\" \nng-click=\"vm.toggleGroupNights($event, items)\" ng-keypress=\"vm.onGroupKeypress($event, items)\" \naria-label=\"Select week\"></md-checkbox><span class=\"newhtmlappend monthsblock\" \nng-bind-html=\"vm.getWeekHeaderName(items, monthName + weekName)\"></span> <span class=\"priceblockouter\"><span \nclass=\"pricemaininner\"><b class=\"discount\">{{vm.getGroupSelectedCount(items)}}</b><small class=\"totalblk\">Selected\n</small></span></span></h5><div class=\"accordian-inner-content\" ng-show=\"vm.openGroups[weekName + monthName]\"><div \nng-init=\"tableNights = vm.getTableNights(items)\" \nng-include=\"\'app/main/apps/create-res/dialogs/discount-comment/discount-night-table.html\'\"></div></div></div></div>\n</div></div></div></div></div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\" ng-if=\"vm.step == 1\"><md-button\n type=\"submit\" ng-click=\"vm.hideDialog()\" ng-disabled=\"vm.isContinueDisabled(discountcomment)\" \nng-class=\"vm.isContinueDisabled(discountcomment) ? \'md-raised md-accent submit-button grey-100-fg\' : \'md-raised md-accent submit-button grey-100-fg md-green-500-bg\'\">\n{{vm.getContinueLabel()}}</md-button></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\" \nng-if=\"vm.step == 2\"><md-button type=\"button\" class=\"md-raised md-accent submit-button grey-100-fg md-red-500-bg\" \nng-click=\"vm.backToDiscount()\">Back</md-button><md-button type=\"submit\" ng-click=\"vm.applyToNights()\" \nng-disabled=\"vm.changedCount() == 0\" \nng-class=\"vm.changedCount() == 0 ? \'md-raised md-accent submit-button grey-100-fg\' : \'md-raised md-accent submit-button grey-100-fg md-green-500-bg\'\">\nApply to {{vm.changedCount()}} {{vm.changedCount() == 1 ? \'night\' : \'nights\'}}</md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/apps/create-res/dialogs/discount-comment/discount-night-table.html","<div class=\"nightlyscrollblk\"><div class=\"scroll-nightly-inner\"><div \nclass=\"row-block1-amount row-header-amount discount-night-grid\"><div class=\"night-check-col\"></div><div \nclass=\"night-col\">{{vm.stayUnitLabel}}</div><div class=\"night-col\" ng-if=\"vm.showSource\">Source</div><div \nclass=\"night-col\">Date</div><div class=\"night-col night-col-end\">Discount</div><div class=\"night-col night-col-end\">\nPrice</div></div><div class=\"row-block1-amount row-nightly-amount discount-night-grid\" \nng-repeat=\"night in tableNights\" ng-class=\"{\'selected\': vm.selectedNights[night.index] && !night.disabled}\"><div \nclass=\"night-check-col\"><md-checkbox class=\"night-check\" \nng-checked=\"vm.selectedNights[night.index] && !night.disabled\" ng-disabled=\"night.disabled\" \nng-click=\"vm.toggleNight(night)\" aria-label=\"Select {{night.label}}\"></md-checkbox></div><div class=\"night-col\"><div \nclass=\"charges directOta\" ng-if=\"!night.canceled\">{{night.label}}</div><div class=\"charges strikethrough\" \nng-if=\"night.canceled\">Canceled {{vm.stayUnitLabel}}</div></div><div class=\"night-col\" ng-if=\"vm.showSource\"><div \nclass=\"charges otapms\">{{night.source}}</div></div><div class=\"night-col\"><div class=\"charges\" \nng-class=\"{\'strikethrough\': night.canceled}\">{{night.date}}</div></div><div class=\"night-col night-col-end\"><div \nclass=\"amount discount\"><md-input-container class=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <span\n class=\"nightly-discount-value\" ng-class=\"{\'strikethrough\': night.canceled}\"><span class=\"night-old-discount\" \nng-if=\"vm.isNightDiscountChanging(night)\">{{night.currentDiscount | number:2}}</span> <span \nclass=\"nightly-discount-amount\" ng-class=\"{\'night-new-discount\': vm.isNightDiscountChanging(night)}\">\n{{vm.getShownDiscount(night) | number:2}}</span> <span class=\"nightly-discount-percent\" \nng-if=\"vm.getShownDiscount(night) > 0\">{{vm.getNightlyDiscountPercent(vm.getShownDiscount(night), night.rate)}}%</span>\n</span></md-input-container></div></div><div class=\"night-col night-col-end\"><div class=\"amount night-price\" \nng-class=\"{\'strikethrough\': night.canceled}\"><i class=\"icon icon-currency-usd s20\"></i> <span>{{night.rate | number:2}}\n</span></div></div></div></div></div>");
$templateCache.put("app/main/apps/create-res/dialogs/pos-options-overlay/pos-options-overlay.html","<md-dialog class=\"pos-options-overlay-dialog\" aria-label=\"Add POS\"><header \nclass=\"pos-overlay-toolbar md-accent md-hue-2\"><div class=\"md-toolbar-tools pos-overlay-toolbar-inner\"><div \nclass=\"pos-overlay-brand\"><div class=\"pos-overlay-brand-icon\"><md-icon md-font-icon=\"icon-cart\" class=\"white-fg\">\n</md-icon></div><div class=\"pos-overlay-toolbar-title\">{{vm.getToolbarTitle()}}</div></div><span flex></span><md-button\n class=\"md-icon-button pos-overlay-close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><md-icon md-font-icon=\"icon-close\" \nclass=\"white-fg\"></md-icon></md-button></div></header><md-dialog-content class=\"pos-options-overlay-content\"><div \nclass=\"pos-options-overlay-body\" layout=\"row\" \nng-if=\"vm.step === \'pos\' || (vm.step === \'insurance\' && vm.hasInsuranceProduct)\"><section class=\"pos-main-col\" \nflex=\"73\" layout=\"column\" ng-animate-disabled><div class=\"pos-insurance-panel\" flex ng-if=\"vm.step === \'insurance\'\">\n<div class=\"pos-stepper-strip pos-stepper-strip--split\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.hasInsuranceProduct\"><div class=\"pos-stepper-strip-search\" aria-hidden=\"true\"></div><div \nclass=\"pos-stepper-strip-stepper\"><div class=\"pos-inline-stepper-wrap\" \nng-include=\"\'app/main/apps/create-res/dialogs/pos-options-overlay/partials/pos-options-stepper.html\'\"></div></div>\n</div><div class=\"pos-insurance-panel-header\"><span class=\"pos-insurance-recommended-badge\">Recommended</span><div \nclass=\"pos-insurance-panel-header-main\" layout=\"row\" layout-align=\"start start\"><div class=\"pos-insurance-icon\">\n<md-icon md-font-icon=\"icon-shield\"></md-icon></div><div class=\"pos-insurance-header-text\"><h2 \nclass=\"pos-insurance-title\">{{vm.getInsuranceDisplayName()}}</h2></div></div></div><ul class=\"pos-insurance-features\">\n<li class=\"pos-insurance-feature\" ng-repeat=\"point in vm.insuranceFeaturePoints track by $index\"><md-icon \nmd-font-icon=\"icon-check-circle\" class=\"pos-insurance-feature-icon\"></md-icon><span class=\"pos-insurance-feature-text\">\n{{point}}</span></li></ul><div class=\"pos-insurance-choice-card\"><md-radio-group class=\"pos-insurance-radio-group\" \nng-model=\"vm.insuranceChoice\" ng-change=\"vm.onInsuranceChoiceChange()\" aria-label=\"Travel protection options\">\n<md-radio-button class=\"pos-insurance-radio-option pos-insurance-radio-option--yes\" ng-value=\"\'yes\'\" \nng-click=\"vm.setInsuranceChoice(\'yes\')\" \nng-keypress=\"$event.keyCode === 13 || $event.keyCode === 32 ? vm.setInsuranceChoice(\'yes\') : null\" \naria-label=\"Add {{vm.getInsuranceDisplayName()}}\"><div class=\"pos-insurance-radio-body\" layout=\"row\" \nlayout-align=\"space-between start\"><p class=\"pos-insurance-radio-text pos-insurance-radio-text--yes\" \nng-if=\"vm.insuranceChoice === \'yes\'\">Great choice! Your booking is protected. 🎉</p><p \nclass=\"pos-insurance-radio-text pos-insurance-radio-text--yes\" ng-if=\"vm.insuranceChoice !== \'yes\'\">\nYes, add {{vm.getInsuranceDisplayName()}} for only <strong>{{vm.insuranceSubtotal | currency:$:2}}</strong></p><span \nclass=\"pos-insurance-radio-price\" ng-if=\"vm.insuranceChoice === \'yes\'\">{{vm.insuranceSubtotal | currency:$:2}}</span>\n</div></md-radio-button><md-radio-button class=\"pos-insurance-radio-option\" ng-value=\"\'no\'\" \nng-click=\"vm.setInsuranceChoice(\'no\')\" \nng-keypress=\"$event.keyCode === 13 || $event.keyCode === 32 ? vm.setInsuranceChoice(\'no\') : null\" \naria-label=\"Decline {{vm.getInsuranceDisplayName()}}\"><p class=\"pos-insurance-radio-text\" \nng-if=\"vm.showInsurance7DayCancelPolicy()\">\nNo, I understand that by declining the {{vm.getInsuranceDisplayName()}}, I will be responsible for the loss of my deposit if I cancel within 7 days of check-in.\n</p><p class=\"pos-insurance-radio-text\" ng-if=\"!vm.showInsurance7DayCancelPolicy()\">\nNo, I understand that by declining the {{vm.getInsuranceDisplayName()}}, I will be responsible for the loss of my deposit if I cancel.\n</p></md-radio-button></md-radio-group><div class=\"pos-insurance-warning-box\" ng-if=\"vm.insuranceChoice === \'no\'\">\n<md-icon md-font-icon=\"icon-alert-circle\" class=\"pos-insurance-warning-icon\" aria-hidden=\"true\"></md-icon><span \nclass=\"pos-insurance-warning-text\"><strong>Are you sure?</strong> Without {{vm.getInsuranceDisplayName()}}, deposit of \n<strong>{{vm.overlaySummaryTotals.deposit_amount | currency:$:2}}</strong> will not be refunded.</span></div></div><div\n class=\"pos-insurance-price-detail\" ng-if=\"vm.insuranceOptIn\"><h3 class=\"pos-insurance-price-detail-title\">\nProtection price details</h3><div class=\"pos-insurance-price-lines\"><div class=\"pos-split-row\"><span>\nProtection subtotal</span> <span>{{vm.insuranceSubtotal | currency:$:2}}</span></div><div class=\"pos-split-row\" \nng-repeat=\"tax in vm.insuranceTaxLines track by tax.tax_id\" ng-if=\"tax.tax_amt > 0\"><span>{{tax.tax_name}} <small \nng-if=\"tax.tax_value\">{{tax.tax_value | number:2}}%</small> </span><span>{{tax.tax_amt | currency:$:2}}</span></div>\n<div class=\"pos-split-row pos-split-row--emphasis\"><span>Protection total</span> <span>\n{{vm.insuranceGrandTotal | currency:$:2}}</span></div></div></div></div><div class=\"pos-pos-step\" flex layout=\"column\" \nng-if=\"vm.step === \'pos\'\"><div class=\"pos-stepper-strip pos-stepper-strip--split\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vm.hasInsuranceProduct\"><div class=\"pos-stepper-strip-search\" \nng-include=\"\'app/main/apps/create-res/dialogs/pos-options-overlay/partials/pos-options-search.html\'\"></div><div \nclass=\"pos-stepper-strip-stepper\"><div class=\"pos-inline-stepper-wrap\" \nng-include=\"\'app/main/apps/create-res/dialogs/pos-options-overlay/partials/pos-options-stepper.html\'\"></div></div>\n</div><div class=\"pos-search-wrap\" ng-if=\"!vm.hasInsuranceProduct\" \nng-include=\"\'app/main/apps/create-res/dialogs/pos-options-overlay/partials/pos-options-search.html\'\"></div><div \nclass=\"pos-products-panel\" flex ms-scroll ng-class=\"{\'is-loading\': vm.isloading}\"><div class=\"pos-skeleton-grid\" \nng-if=\"vm.isloading\"><div class=\"pos-skeleton-card\" ng-repeat=\"n in vm.skeletonProductSlots track by $index\"><div \nclass=\"pos-skeleton-image-wrap\"><div class=\"pos-skeleton-image\"></div></div><div class=\"pos-skeleton-body\"><div \nclass=\"pos-skeleton-line\"></div><div class=\"pos-skeleton-line short\"></div></div></div></div><div \nclass=\"pos-products-grid\" ng-if=\"!vm.isloading && vm.categoryRelatedProducts.length\"><article class=\"pos-product-card\" \nng-class=\"{\n									\'is-in-cart\': vm.isInCart(product.product_id),\n									\'is-qty-locked-maxed\': vm.isQuantityLockedMaxed(product),\n									\'is-flash\': vm.flashProductId == product.product_id\n								}\" \nng-repeat=\"product in vm.categoryRelatedProducts track by product.product_id\" \nng-style=\"{\'animation-delay\': ($index * 40) + \'ms\'}\" ng-click=\"vm.onProductCardClick($event, product)\" \nng-attr-title=\"{{vm.isQuantityLockedMaxed(product) ? \'Already added (limit 1)\' : (\'Add \' + (product.fe_display_product_name || product.product_name))}}\" \ntabindex=\"0\" role=\"button\"><div class=\"pos-product-card-image\"><img ng-src=\"{{vm.getProductImageUrl(product)}}\" alt=\"\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\"> <span \nclass=\"pos-product-badge pos-product-badge--qty\" \nng-if=\"vm.getCartQty(product.product_id) && !vm.isQuantityLockedMaxed(product)\">\n{{vm.getCartQty(product.product_id)}} in cart </span><span class=\"pos-product-badge pos-product-badge--qty\" \nng-if=\"vm.isQuantityLockedMaxed(product)\">Added </span><span class=\"pos-product-badge pos-product-badge--tax\" \nng-if=\"product.pos_display_tax_indicator == 1\">incl. tax</span></div><div class=\"pos-product-card-body\"><div \nclass=\"pos-product-card-footer\"><div class=\"pos-product-card-name-wrap\"><h3 class=\"pos-product-card-name\">\n{{product.fe_display_product_name || product.product_name}}</h3></div><p class=\"pos-product-card-price\">\n{{(product.pos_display_tax_indicator == 1 ? product.total : product.product_price) | currency:$:2}}</p></div></div>\n</article></div><div class=\"pos-empty-state\" ng-if=\"!vm.isloading && !vm.categoryRelatedProducts.length\"><div \nclass=\"pos-empty-illustration\"><md-icon md-font-icon=\"icon-package-variant-closed\"></md-icon></div><p \nclass=\"pos-empty-title\">No products found</p><p class=\"pos-empty-hint\" ng-if=\"vm.getSearchText()\">\nTry another keyword or clear your search.</p><p class=\"pos-empty-hint\" ng-if=\"!vm.getSearchText()\">\nThere are no featured POS items for this property right now.</p><md-button class=\"md-raised\" \nng-if=\"vm.getSearchText()\" ng-click=\"vm.clearSearch()\">Clear search</md-button></div></div></div><footer \nclass=\"pos-products-footer pos-products-footer--loading\" ng-if=\"vm.step === \'pos\' && vm.isloading\"><div \nclass=\"pos-skeleton-footer-text\"></div><span flex></span><div class=\"pos-skeleton-footer-actions\"></div></footer>\n<footer class=\"pos-products-footer\" ng-if=\"vm.step === \'insurance\' || (vm.step === \'pos\' && !vm.isloading)\" \nng-include=\"\'app/main/apps/create-res/dialogs/pos-options-overlay/partials/pos-options-footer.html\'\"></footer>\n</section><aside class=\"pos-options-right\" flex=\"27\" \nng-include=\"\'app/main/apps/create-res/dialogs/pos-options-overlay/partials/pos-options-sidebar.html\'\"></aside></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/dashboards/dash-views/availability/res-search.html","<md-dialog class=\"contact-dialog contact-dialog-wide ganttpolicyChoice openPlaceGantt\" aria-label=\"New Task\" \nstyle=\"max-width: 1200px\"><div class=\"hold-send-overlay\" ng-if=\"vm.holdSending\"></div><form name=\"openPlaceGantt\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts customized-radio\" layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"md-block md-datepicker\" \nng-if=\"vm.mode_of_call == \'add\'\" data-ng-animate=\"1\"><md-radio-group class=\"no-margin\" ng-change=\"vm.type_changed()\" \nng-model=\"vm.data.type_of_reservation\" ng-model-options=\"{debounce: 500}\" required><md-radio-button \nclass=\"space-block-inline\" value=\"create\">{{ \'OPTIONS_CREATE.CREATE_RES\' | translate }}</md-radio-button>\n<md-radio-button class=\"space-block-inline margin-left-15\" value=\"create_day\" ng-if=\"vm.isDayReservationHotel\">\n{{ \'OPTIONS_CREATE.CREATE_DAY_RES\' | translate }}</md-radio-button><md-radio-button \nclass=\"space-block-inline margin-left-15\" value=\"hold\" ng-if=\"vm.location!=\'hold\' && vm.location!=\'block\'\" \nng-click=\"vm.closeAllDetails()\">{{ \'OPTIONS_CREATE.HOLD\' | translate }}</md-radio-button><md-radio-button \nclass=\"space-block-inline margin-left-15\" value=\"block\" ng-if=\"vm.location!=\'hold\' && vm.location!=\'block\'\" \nng-click=\"vm.closeAllDetails()\">{{ \'OPTIONS_CREATE.BLOCK\' | translate }}</md-radio-button></md-radio-group>\n</md-input-container><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon>\n</md-button></div></md-toolbar><md-progress-linear class=\"hold-dialog-loader\" md-mode=\"indeterminate\" \nng-show=\"vm.isloading || vm.promoRequestGoing || (vm.data.type_of_reservation == \'hold\' && !vm.hasHoldRoomLoaded())\">\n</md-progress-linear><md-dialog-content ms-scroll style=\"max-width:1200px;max-height:1000px\"><md-content \nclass=\"md-padding mb-15 datepickermain-block-container\" ng-if=\"vm.mode_of_call == \'add\'\"><div flex=\"100\" layout=\"row\" \nlayout-wrap><div class=\"row-block-new block-datepicker-main mb-0\" flex=\"50\" flex-xs=\"100\" layout=\"column\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block full-width mb-0\"><label \ntranslate=\"CREATE_RES.CHECKIN\"></label><md-datepicker md-open-on-focus ng-model=\"vm.data.room_stay_from\" \nng-change=\"vm.checkinSlected(\'from\')\" class=\"full-width mdinput-block\"></md-datepicker></md-input-container></div><div \nclass=\"row-block-new block-datepicker-main\" flex=\"50\" flex-xs=\"100\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block full-width mb-0\"><label translate=\"CREATE_RES.CHECKOUT\"></label><md-datepicker \nmd-open-on-focus ng-model=\"vm.data.room_stay_to\" md-min-date=\"vm.minDateCheckout\" class=\"full-width mdinput-block\" \nng-change=\"vm.checkinSlected(\'to\')\"></md-datepicker></md-input-container></div></div><div class=\"\" flex=\"100\" \nlayout=\"row\" layout-wrap ng-if=\"vm.showRateUI() && vm.pageType == \'room\'\"><div \nclass=\"Fromto-col padding-left-10 padding-right-10 mt-10\" flex=\"50\" layout=\"column\" layout-align=\"start start\">\n<md-input-container class=\"md-block tax-inputs no-margin full-width\"><md-icon class=\"margin-left-5\" \nmd-font-icon=\"icon-human-male-female\"></md-icon><label class=\"lbl-width margin-left-20\">Adult</label><md-select \nplaceholder=\"Select Adults\" ng-model=\"vm.data.adult\" class=\"input-with-icons1\" \nng-change=\"vm.manageAdultChild(\'adult\')\"><md-option ng-value=\"n\" ng-repeat=\"n in vm.adultRange\">{{n}}</md-option>\n</md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"Fromto-col padding-left-10 padding-right-10 mt-10\" flex=\"50\" layout=\"column\" layout-align=\"start start\">\n<md-input-container class=\"md-block tax-inputs no-margin full-width\"><md-icon class=\"margin-left-5\" \nmd-font-icon=\"icon-human-child\"></md-icon><label class=\"lbl-width margin-left-20\">Child</label><md-select \nplaceholder=\"Select Children\" ng-model=\"vm.data.child\" class=\"input-with-icons1\" \nng-change=\"vm.manageAdultChild(\'child\')\"><md-option ng-value=\"i\" ng-repeat=\"i in vm.childRange\">{{i}}</md-option>\n</md-select><div class=\"md-errors-spacer\"></div></md-input-container></div></div><div class=\"\" flex=\"100\" layout=\"row\" \nlayout-wrap \nng-if=\"vm.showRateUI() && vm.pageType == \'room\' && vm.data.type_of_reservation == \'hold\' && !vm.onlyAllowHoldBlock\">\n<div class=\"Fromto-col padding-left-10 padding-right-10 mt-10\" flex=\"50\" layout=\"column\" layout-align=\"start start\">\n<div class=\"hold-date-promo full-width\"><div class=\"hold-promo-entry full-width\" ng-if=\"!vm.holdPromoApplied\">\n<md-input-container class=\"md-block tax-inputs no-margin no-error-spacer\"><md-icon class=\"margin-left-5\" \nmd-font-icon=\"icon-sale\"></md-icon><label class=\"lbl-width margin-left-20\">Promo Code</label><input \nclass=\"input-with-icons1\" ng-model=\"vm.holdPromoCode\" name=\"hold_promocode\" type=\"text\" autocomplete=\"off\" \nng-change=\"vm.holdPromoCode = (vm.holdPromoCode || \'\').toUpperCase()\" \nng-keydown=\"$event.keyCode === 13 && vm.holdPromoCode && vm.applyQuotePromo(\'applied\')\" \nng-disabled=\"vm.holdDiscountApplied\"><div class=\"md-errors-spacer\"></div></md-input-container><md-button \nclass=\"md-raised hold-promo-apply\" ng-click=\"vm.applyQuotePromo(\'applied\')\" \nng-disabled=\"!vm.holdPromoCode || vm.promoRequestGoing || vm.holdDiscountApplied\"><span>Apply</span>\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.promoRequestGoing\">\n</md-progress-circular></md-button></div><div class=\"hold-promo-applied-row\" ng-if=\"vm.holdPromoApplied\" layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"hold-promo-applied-icon\" md-font-icon=\"icon-sale\"></md-icon><div \nclass=\"hold-promo-applied-card\" flex><div class=\"hold-promo-applied-text\"><label>Promo Code</label><p>\n{{vm.holdPromoCode}}</p></div><p class=\"hold-promo-remove-link\" ng-click=\"vm.askRemoveHoldPromo($event)\"><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"red-A800-fg\"></md-icon>Remove</p></div></div></div></div></div></md-content>\n<md-content class=\"md-padding\" style=\"max-width:1200px;overflow: visible\" \nng-class=\"{\'hold-quote-body\': vm.data.type_of_reservation == \'hold\'}\"><div class=\"row-block-new\" layout=\"column\" \nlayout-gt-xs=\"{{vm.data.type_of_reservation == \'hold\' ? \'column\' : \'row\'}}\" layout-align=\"start start\" flex \nlayout-wrap><div class=\"layout-colo-block padding-left-10 padding-right-10 full-width\" flex=\"100\" \nflex-gt-sm=\"{{vm.data.type_of_reservation == \'hold\' ? 100 : 50}}\" ng-if=\"vm.showRateUI()\" \nng-class=\"{\'no-rate-plan1\': vm.onlyAllowHoldBlock, \'hold-selected-room-box\': vm.data.type_of_reservation == \'hold\'}\">\n<div class=\"hold-change-room-wrap\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.data.type_of_reservation == \'hold\'\"><h4 class=\"hold-section-heading\">Selected Room</h4></div><div \nclass=\"room-repeatblk relative-block\" layout=\"column\" flex=\"100\" \nng-if=\"vm.show_result || (vm.data.type_of_reservation == \'hold\' && vm.data.product_name)\"><div class=\"room-listing\" \nng-if=\"vm.data.type_of_reservation == \'hold\' && !vm.hasHoldRoomLoaded() && !vm.isloading\"><div \nclass=\"room-block-listing\"><div class=\"Reservation-outer-block hold-room-detail-line margin-top-5 margin-bottom-5\"><h5 \nclass=\"hold-inline-room-name\"><span>{{vm.data.product_name}}</span></h5></div></div></div><div class=\"room-listing\" \nng-class=\"{\'is-open\': vm.showHoldDiscountPanel}\"><div class=\"img-block-room\" \nng-if=\"vm.data.type_of_reservation != \'hold\'\"><img \nng-src=\"{{vm.proImage ? (vm.baseUrl+\'assets/uploads/hotels/thumbnail/\'+vm.proImage) : (vm.baseUrl+\'assets/uploads/product/room-service.svg\')}}\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\"></div><div class=\"room-block-listing\"><div \nclass=\"aprt-name aprt-name-lt mls-product\" ng-if=\"vm.data.type_of_reservation != \'hold\'\"><h5><span>\n{{vm.data.product_name}}</span></h5><span class=\"readmoreblock readmoreBlockmainlt1\" \nid=\"readmoreblock_{{vm.data.product_id}}\" ng-click=\"vm.readDescription(vm.data.product_id)\" \nng-if=\"!vm.onlyAllowHoldBlock\">{{vm.readText}}</span></div><div class=\"no-rate-paln-section\" \nng-if=\"vm.onlyAllowHoldBlock\"><span ng-bind-html=\"vm.noRateAssociatedMsg\"></span></div><div \nclass=\"aprt-name aprt-name-lt mls-product hold-room-title\" \nng-if=\"vm.data.type_of_reservation == \'hold\' && !vm.showHoldGuestStep && vm.data.product_name && vm.hasHoldRoomLoaded()\">\n<h5><span>{{vm.data.product_name}}</span></h5><span class=\"readmoreblock readmoreBlockmainlt1\" \nid=\"readmoreblock_hold_{{vm.data.product_id}}\" ng-click=\"vm.readDescription(vm.data.product_id)\" \nng-if=\"!vm.onlyAllowHoldBlock\">{{vm.readText}}</span></div><div class=\"policy-outer\" \nng-class=\"{\'hold-policy-pick\': vm.data.type_of_reservation == \'hold\' && !vm.showHoldGuestStep}\" \nng-if=\"!vm.onlyAllowHoldBlock\"><md-input-container class=\"mb-10 mt-0 md-input-has-value mb-0 row\" flex=\"100\" \nlayout-wrap layout=\"row\"><div class=\"rate-div\" ng-repeat=\"(policykey,eachpolicy) in vm.policiesDetail\" \nng-if=\"vm.showHoldPolicyRow(policykey)\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\" layout=\"column\"><md-radio-group \nclass=\"row no-margin\" flex=\"100\" layout-wrap layout=\"row\" ng-model=\"vm.selectedRoom[vm.data.product_id]\" \nng-change=\"vm.buildHoldNightlyRows()\" ng-click=\"vm.data.type_of_reservation == \'hold\' || $event.stopPropagation()\">\n<span flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\" layout=\"column\" \nclass=\"policy-blk no-margin space-block-inline pr-10 pb-15\" ng-value=\"policykey\"><div \nclass=\"Reservation-outer-block margin-top-5 margin-bottom-5\" \nng-class=\"{\'hold-room-detail-line\': vm.data.type_of_reservation == \'hold\' && vm.showHoldGuestStep && !vm.onlyAllowHoldBlock}\" \nng-click=\"vm.data.type_of_reservation == \'hold\' && vm.showHoldGuestStep && !vm.onlyAllowHoldBlock && vm.toggleHoldDiscountPanel($event)\">\n<h5 class=\"hold-inline-room-name\" ng-if=\"vm.data.type_of_reservation == \'hold\' && vm.showHoldGuestStep\"><span>\n{{vm.data.product_name}}</span></h5><span class=\"aprt-nightly hold-detail-occ\" \nng-if=\"vm.data.type_of_reservation == \'hold\' && vm.showHoldGuestStep && vm.pageType == \'room\' && vm.maxOccupancy\">\nMax. Occupancy: {{vm.maxOccupancy}}</span><md-radio-button \nng-if=\"!(vm.data.type_of_reservation == \'hold\' && vm.showHoldGuestStep)\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\" \nlayout=\"column\" class=\"margin-top-0 margin-bottom-0 checkblock-ckeckbox single\" style=\"width:100%\" \nng-value=\"policykey\"><span class=\"aprt-nightly nt-policy\">{{eachpolicy.policy_name}}</span></md-radio-button><div \nclass=\"rate-plan-spans-block\"><span class=\"aprt-nightly rate-plan-anchor\" \nng-if=\"!vm.isDayCreateMode() && eachpolicy.ratePlanName\"><div class=\"rate-plan-txt\" \nng-init=\"vm.showRateDesc[policykey] = false\" ng-mouseenter=\"!vm.runClickEvent?vm.showDetailRateBlock(policykey):\'\'\" \nng-mouseleave=\"!vm.runClickEvent?vm.closeAllRateDetails(policykey):\'\'\" \nng-click=\"vm.data.type_of_reservation == \'hold\' || $event.stopPropagation(); vm.data.type_of_reservation != \'hold\' && vm.runClickEvent && vm.showDetailRateBlock(policykey)\">\nRate Plan: {{eachpolicy.ratePlanName}}<div class=\"total-amount-blk-section\" \nng-if=\"vm.showRateDesc[policykey] && eachpolicy.ratePlanDesc != \'\'\"><div class=\"total-amt-row\"><b>\n{{eachpolicy.ratePlanDesc}}</b></div></div></div></span><span class=\"aprt-nightly\" \nng-if=\"vm.pageType == \'room\' && !(vm.data.type_of_reservation == \'hold\' && vm.showHoldGuestStep)\">\nMax. Occupancy: {{vm.maxOccupancy}}</span> <span class=\"aprt-nightly\" \nng-if=\"vm.boat_length > 0 && vm.pageType != \'room\'\">Vessel Length: {{vm.boat_length}}</span> <span \nclass=\"aprt-nightly\" ng-if=\"vm.boat_width > 0 && vm.pageType != \'room\'\">Vessel Width: {{vm.boat_width}}</span> <span \nclass=\"aprt-nightly avg-rate\">{{vm.isDayCreateMode() ? \'Day rate\' : \'Nightly rate\'}}: <b \nclass=\"rate-color-add red-A800-fg cut-price-span\"><span \nng-if=\"((vm.holdPromoApplied && vm.holdPromoPolicy == policykey) || (vm.holdDiscountApplied && vm.holdDiscountPolicy == policykey)) && vm.displayNightlyRate\" \nclass=\"cut-price\">${{eachpolicy.nightlyRate}}</span> <span \nng-if=\"!((vm.holdPromoApplied && vm.holdPromoPolicy == policykey) || (vm.holdDiscountApplied && vm.holdDiscountPolicy == policykey)) && !vm.isDayCreateMode() && eachpolicy.highestAvgRate && eachpolicy.highestAvgRate !== eachpolicy.nightlyRate && eachpolicy.highestAvgRate > eachpolicy.nightlyRate\" \nclass=\"cut-price\">${{eachpolicy.highestAvgRate}}</span>\n ${{(((vm.holdPromoApplied && vm.holdPromoPolicy == policykey) || (vm.holdDiscountApplied && vm.holdDiscountPolicy == policykey)) && vm.displayNightlyRate) ? vm.displayNightlyRate : eachpolicy.nightlyRate}}\n</b></span></div><div class=\"total-price-block\" ng-init=\"vm.showBlock[policykey] = false\" \nng-mouseenter=\"!vm.runClickEvent?vm.showDetailBlock(policykey):\'\'\" \nng-mouseleave=\"!vm.runClickEvent?vm.closeAllDetails(policykey):\'\'\" \nng-click=\"vm.data.type_of_reservation == \'hold\' || $event.stopPropagation(); vm.data.type_of_reservation != \'hold\' && vm.runClickEvent && vm.showDetailBlock(policykey)\">\n<small>Total</small> <b>${{(vm.searchSummary[policykey] || {}).grandTotal}}</b><div class=\"total-amount-blk-section\" \nng-if=\"vm.showBlock[policykey]\"><div class=\"total-amt-row\"><span ng-if=\"vm.pageType == \'room\'\">Room Amount</span> <span\n ng-if=\"vm.pageType == \'boat\'\">Slip Amount</span> <span ng-if=\"vm.pageType == \'rent\'\">Residence Amount</span> <span>\n${{vm.searchSummary[policykey].subTotal}}</span></div><div class=\"total-amt-row\" ng-if=\"vm.extraPersonApplicable\">\n<span>Extra Person</span> <span>${{vm.searchSummary[policykey].extraPersonAmt}}</span></div><div class=\"total-amt-row\" \nng-if=\"vm.resortFeeApplicable\"><span>Resort fee</span> <span>${{vm.searchSummary[policykey].resortFee}}</span></div>\n<div class=\"total-amt-row\" ng-if=\"vm.searchSummary[policykey].surcharge != undefined\"><span>Surcharge</span> <span>\n${{vm.searchSummary[policykey].surcharge}}</span></div><div class=\"total-amt-row\" \nng-if=\"vm.holdPromoApplied && vm.holdPromoPolicy == policykey\"><span>Discount <span \nng-if=\"vm.holdPercentLabel(vm.holdPromoDiscount, vm.searchSummary[policykey].subTotal)\">\n({{vm.holdPercentLabel(vm.holdPromoDiscount, vm.searchSummary[policykey].subTotal)}}%)</span></span> <span \nclass=\"hold-promo-discount\">-${{vm.holdPromoDiscount}}</span></div><div class=\"total-amt-row\" \nng-if=\"vm.holdDiscountApplied && vm.holdDiscountPolicy == policykey\"><span>Discount <span \nng-if=\"vm.holdDiscountPercent > 0\">({{vm.holdDiscountPercent}}%)</span></span> <span class=\"hold-promo-discount\">\n-${{vm.holdTotalDiscount || vm.holdDiscountAmount}}</span></div><div class=\"total-amt-row\"><span>Taxes</span> <span>\n${{vm.searchSummary[policykey].taxes}}</span></div><div class=\"total-amt-row\"><span>Grand Total</span> <span>\n${{vm.searchSummary[policykey].grandTotal}}</span></div></div></div></div></span></md-radio-group></div>\n</md-input-container></div></div><p ng-if=\"vm.showDescription\" class=\"room_type_description\">\n{{vm.room_type_description}}</p></div><div class=\"hold-nightly-price nightly-price-heading\" \nng-if=\"vm.data.type_of_reservation == \'hold\' && !vm.onlyAllowHoldBlock && vm.showHoldDiscountPanel && vm.holdNightlyRows.length\">\nNightly-price<div class=\"nightlyscrollblk\"><div class=\"scroll-nightly-inner\"><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"row-block1-amount row-header-amount\"><div layout=\"column\" flex=\"20\" layout-align=\"center start\">Night</div><div \nlayout=\"column\" flex=\"20\" layout-align=\"center start\">Date</div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center start\" ng-if=\"vm.showHoldRatePlanCol()\">Rate Plan</div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center end\">Discount</div><div layout=\"column\" flex=\"20\" layout-align=\"center end\">Price</div></div><div \nng-repeat=\"night in vm.holdNightlyRows track by $index\" class=\"hold-nightly-row-wrap\"><div layout=\"row\" flex=\"100\" \nlayout-wrap class=\"row-nightly-amount row-block1-amount\"><div layout=\"column\" flex=\"20\" layout-align=\"center start\">\n<div class=\"charges\">Night {{night.nightNum}}</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center start\">\n<div class=\"charges\">{{night.date}}</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center start\" \nng-if=\"vm.showHoldRatePlanCol()\"><div class=\"charges\">{{night.ratePlan}}</div></div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center end\"><div class=\"amount discount\"><md-input-container class=\"md-block no-margin\"><i \nclass=\"icon icon-currency-usd s20\"></i> <span class=\"nightly-discount-value\" \nng-class=\"{\'hold-discount-locked\': vm.holdPromoApplied}\" \nng-click=\"!vm.holdPromoApplied && vm.openHoldNightDiscount($index, $event)\"><span class=\"nightly-discount-amount\">\n{{ night.amount | number:2 }}</span> <span class=\"nightly-discount-percent\" ng-if=\"night.percentLabel\">\n{{night.percentLabel}}%</span> </span><i ng-if=\"night.amount > 0\" class=\"icon icon-comment-outline discountcomment\" \nng-class=\"{\'onlycursorPointer\': !vm.holdPromoApplied}\" \nng-click=\"!vm.holdPromoApplied && vm.openHoldNightDiscount($index, $event)\"><md-tooltip ng-if=\"night.comment\">\n{{night.comment}}</md-tooltip></i></md-input-container></div></div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center end\"><div class=\"amount price\"><md-input-container class=\"md-block no-margin\"><i \nclass=\"icon icon-currency-usd s20\"></i> <span class=\"charges\">{{ night.rate | number:2 }}</span></md-input-container>\n</div></div></div></div></div></div></div></div><div class=\"norecordfound\" \nng-if=\"!vm.show_result && vm.occupancy_error !== \'\'\"><md-icon md-font-icon=\"icon-information-outline\" class=\"pr-5\">\n</md-icon>{{vm.occupancy_error}}</div></div><div class=\"layout-colo-block padding-left-10 padding-right-10 full-width\" \nflex=\"100\" flex-gt-sm=\"50\" ng-if=\"vm.data.type_of_reservation == \'block\' && vm.show_form\"><div ng-if=\"vm.show_result\">\n<md-input-container class=\"md-block m-b-0\" \nng-class=\"(vm.isCommentEmpty && openPlaceGantt.block_comment.$untouched) || (openPlaceGantt.block_comment.$touched && (vm.data.room_stay_comment == \'\' || vm.data.room_stay_comment == undefined)) ? \'md-input-invalid\' : \'\'\">\n<label translate=\"OPTIONS_CREATE.COMMENT\"></label><input name=\"block_comment\" type=\"text\" \nng-model=\"vm.data.room_stay_comment\"> <span \nng-show=\"(vm.isCommentEmpty && openPlaceGantt.block_comment.$untouched) || (openPlaceGantt.block_comment.$touched && (vm.data.room_stay_comment == \'\' || vm.data.room_stay_comment == undefined))\" \nclass=\"errornlk\">Please enter block comment.</span></md-input-container></div><div class=\"norecordfound\" \nng-if=\"!vm.show_result && vm.occupancy_error !== \'\'\"><md-icon md-font-icon=\"icon-information-outline\" class=\"pr-5\">\n</md-icon>{{vm.occupancy_error}}</div></div><div \nclass=\"layout-colo-block hold-quote-form hold-guest-details-box full-width\" flex=\"100\" \nng-if=\"vm.data.type_of_reservation == \'hold\' && vm.show_form && vm.showHoldGuestStep\"><h4 class=\"hold-section-heading\">\nCustomer Details</h4><div ng-if=\"vm.show_result\"><div flex=\"100\" layout=\"row\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10\" flex=\"50\" flex-xs=\"100\" layout=\"column\"><md-autocomplete \nmd-no-cache=\"vm.holdCustomerNoCache\" md-selected-item=\"vm.selectedHoldCustomer.first_name\" \nmd-selected-item-change=\"vm.selectHoldCustomer(item)\" \nmd-items=\"item in vm.queryHoldCustomer(vm.searchTextFn, \'cust.first_name\')\" md-search-text=\"vm.searchTextFn\" \nmd-search-text-change=\"vm.onHoldCustomerSearchChange(\'first_name\')\" md-item-text=\"item.first_name\" md-min-length=\"1\" \nmd-delay=\"500\" md-floating-label=\"{{ \'CREATE_RES.CUST_FN\' | translate }}\" md-dropdown-position=\"bottom\" \nmd-menu-class=\"hold-customer-suggest\" class=\"chooseCustomer full-width\" required><md-item-template><span \nmd-highlight-text=\"vm.searchTextFn\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template>\n</md-autocomplete></div><div class=\"padding-left-10 padding-right-10\" flex=\"50\" flex-xs=\"100\" layout=\"column\">\n<md-autocomplete md-no-cache=\"vm.holdCustomerNoCache\" md-selected-item=\"vm.selectedHoldCustomer.last_name\" \nmd-selected-item-change=\"vm.selectHoldCustomer(item)\" \nmd-items=\"item in vm.queryHoldCustomer(vm.searchTextLn, \'cust.last_name\')\" md-search-text=\"vm.searchTextLn\" \nmd-search-text-change=\"vm.onHoldCustomerSearchChange(\'last_name\')\" md-item-text=\"item.last_name\" md-min-length=\"1\" \nmd-delay=\"500\" md-floating-label=\"{{ \'CREATE_RES.CUST_LN\' | translate }}\" md-dropdown-position=\"bottom\" \nmd-menu-class=\"hold-customer-suggest\" class=\"chooseCustomer full-width\" required><md-item-template><span \nmd-highlight-text=\"vm.searchTextLn\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template>\n</md-autocomplete></div></div><div flex=\"100\" layout=\"row\" layout-wrap><div class=\"padding-left-10 padding-right-10\" \nflex=\"50\" flex-xs=\"100\" layout=\"column\"><md-autocomplete md-no-cache=\"vm.holdCustomerNoCache\" \nmd-selected-item=\"vm.selectedHoldCustomer.customer_email\" md-selected-item-change=\"vm.selectHoldCustomer(item)\" \nmd-items=\"item in vm.queryHoldCustomer(vm.searchTextEm, \'cust.customer_email\')\" md-search-text=\"vm.searchTextEm\" \nmd-search-text-change=\"vm.onHoldCustomerSearchChange(\'customer_email\')\" md-item-text=\"item.customer_email\" \nmd-min-length=\"1\" md-delay=\"500\" md-floating-label=\"{{ \'CREATE_RES.CUST_EMAIL\' | translate }}\" \nmd-dropdown-position=\"bottom\" md-menu-class=\"hold-customer-suggest\" class=\"chooseCustomer full-width\" required>\n<md-item-template><span md-highlight-text=\"vm.searchTextEm\" md-highlight-flags=\"^i\">{{item.customer_email}}</span>\n</md-item-template></md-autocomplete></div><div class=\"padding-left-10 padding-right-10\" flex=\"50\" flex-xs=\"100\" \nlayout=\"column\"><md-input-container class=\"md-block m-b-0 full-width hold-phone-container\" \nng-class=\"{\'md-input-has-value\': !!vm.data.phone_number, \'hold-phone-invalid md-input-invalid\': vm.holdPhoneInvalid}\">\n<label translate=\"CREATE_RES.CUST_CONT_NO\" class=\"phone-number-label\"></label><input required name=\"phone_number\" \ntype=\"tel\" class=\"intel-number-input hold-quote-phone\" intl-tel-input ng-model=\"vm.data.phone_number\" \nng-model-options=\"{debounce: 800}\" ng-change=\"vm.updateHoldPhone()\" autocomplete=\"off\"><div class=\"hold-phone-error\" \nng-if=\"vm.holdPhoneInvalid\">Not a valid number</div></md-input-container></div></div><div flex=\"100\" layout=\"row\" \nlayout-wrap><div class=\"padding-left-10 padding-right-10\" flex=\"50\" flex-xs=\"100\" layout=\"column\"><md-input-container \nclass=\"md-block m-b-0 full-width hold-expiry-date\" ng-class=\"{\'md-input-has-value\': !!vm.data.hold_duration}\"><label \ntranslate=\"OPTIONS_CREATE.EXPIRYDATE\"></label><md-datepicker md-open-on-focus ng-model=\"vm.data.hold_duration\" \nclass=\"full-width mdinput-block\"></md-datepicker></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" flex=\"50\" flex-xs=\"100\" layout=\"column\"><md-input-container \nclass=\"md-block m-b-0 full-width hold-expiry-time\" ng-class=\"{\'md-input-has-value\': !!vm.hold_duration_time}\"><label \ntranslate=\"OPTIONS_CREATE.EXPIRYTIME\"></label><input type=\"time\" id=\"holdExpiryTime\" name=\"hold_duration_time\" \nng-model=\"vm.hold_duration_time\" min=\"00:00\" max=\"23:59\" step=\"1800\" autocomplete=\"off\"></md-input-container></div>\n</div><div class=\"padding-left-10 padding-right-10\" flex=\"100\"><md-input-container class=\"md-block m-b-0 full-width\" \nng-class=\"(vm.isCommentEmpty && openPlaceGantt.hold_comment.$untouched) || (openPlaceGantt.hold_comment.$touched && (vm.data.room_stay_comment == \'\' || vm.data.room_stay_comment == undefined)) ? \'md-input-invalid\' : \'\'\">\n<label translate=\"OPTIONS_CREATE.COMMENT\"></label><input name=\"hold_comment\" type=\"text\" \nng-model=\"vm.data.room_stay_comment\"> <span \nng-show=\"(vm.isCommentEmpty && openPlaceGantt.hold_comment.$untouched) || (openPlaceGantt.hold_comment.$touched && (vm.data.room_stay_comment == \'\' || vm.data.room_stay_comment == undefined))\" \nclass=\"errornlk\">Please enter hold comment.</span></md-input-container></div></div><div class=\"norecordfound\" \nng-if=\"!vm.show_result && vm.occupancy_error !== \'\'\"><md-icon md-font-icon=\"icon-information-outline\" class=\"pr-5\">\n</md-icon>{{vm.occupancy_error}}</div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nflex=\"100\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"end center\" flex=\"100\"><md-button \naria-label=\"next\" ng-if=\"vm.data.type_of_reservation == \'hold\' && !vm.showHoldGuestStep\" type=\"button\" \nng-click=\"vm.goToHoldGuestStep()\" \nng-class=\"!vm.show_result || (!vm.onlyAllowHoldBlock && !vm.selectedRoom[vm.data.product_id])?\'submit-button md-accent md-raised white-fg\':\'submit-button md-green-500-bg md-raised white-fg\'\" \nng-disabled=\"!vm.show_result || (!vm.onlyAllowHoldBlock && !vm.selectedRoom[vm.data.product_id])\">Next</md-button>\n<md-button ng-if=\"vm.data.type_of_reservation == \'hold\' && vm.showHoldGuestStep\" type=\"button\" \nng-click=\"vm.backToHoldRooms()\" class=\"md-raised\" aria-label=\"Back\">Back</md-button><md-button class=\"hold-send-btn\" \naria-label=\"{{vm.data.type_of_reservation == \'hold\' ? \'Send\' : \'Save\'}}\" \nng-if=\"(vm.data.type_of_reservation == \'hold\' && vm.showHoldGuestStep) || vm.data.type_of_reservation == \'block\'\" \ntype=\"button\" ng-click=\"vm.saveTypeofRes()\" \nng-class=\"(vm.data.type_of_reservation == \'hold\' ? vm.isHoldCreateDisabled() : (openPlaceGantt.$invalid || !vm.showSaveBtn))?\'submit-button md-accent md-raised white-fg\':\'submit-button md-green-500-bg md-raised white-fg\'\" \nng-disabled=\"vm.data.type_of_reservation == \'hold\' ? vm.isHoldCreateDisabled() : (openPlaceGantt.$invalid || !vm.showSaveBtn)\">\n<span ng-if=\"vm.data.type_of_reservation == \'hold\'\">Send</span> <span ng-if=\"vm.data.type_of_reservation != \'hold\'\" \ntranslate=\"OPTIONS_CREATE.SAVE\">Save</span></md-button><md-button aria-label=\"continue\" ng-if=\"vm.isCreateMode()\" \ntype=\"button\" ng-click=\"vm.saveTypeofRes()\" \nng-class=\"openPlaceGantt.$invalid || (vm.selectedRoom[vm.data.product_id]==\'\' && vm.isCreateMode()) || !vm.showSaveBtn?\'submit-button md-accent md-raised white-fg\':\'submit-button md-green-500-bg md-raised white-fg\'\" \nng-disabled=\"openPlaceGantt.$invalid || !vm.showSaveBtn || (vm.selectedRoom[vm.data.product_id]==\'\' && vm.isCreateMode())\" \ntranslate=\"OPTIONS_CREATE.CONT\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/dashboards/gantt-chart/dialogs/add-comment.html","<md-dialog class=\"contact-dialog ganttpolicyChoice\" aria-label=\"New Task\"><form name=\"addcommentInRes\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Add note for {{vm.data.name}}-#{{vm.data.confirmation_number}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll style=\"max-width:800px;max-height:1000px\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><md-content class=\"md-padding\"><div class=\"row-block-new\" layout=\"row\" layout-align=\"start start\" \nflex=\"100\" layout-wrap><md-input-container \nng-if=\"vm.data.type_of_reservation == \'reservation\' || vm.data.type_of_reservation == \'day_reservation\'\" \nclass=\"md-block mb-0 md-input-has-value mb-0\" layout=\"column\" flex=\"100\"><md-radio-group class=\"no-margin\" \nng-model=\"vm.note_type\" ng-change=\"vm.type_changed()\"><md-radio-button class=\"space-block-inline\" value=\"comment\">\nComment</md-radio-button><md-radio-button class=\"space-block-inline margin-left-30\" value=\"special_request\">\nSpecial Request</md-radio-button></md-radio-group></md-input-container><div \nclass=\"layout-colo-block padding-left-10 padding-right-10 full-width\" flex=\"100\" flex-gt-sm=\"100\"><md-input-container \nclass=\"md-block m-b-0\"><label>{{vm.label}}</label><input name=\"block_comment\" type=\"text\" ng-model=\"vm.comment\" \nrequired></md-input-container></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" flex=\"100\">\n<div layout=\"column\" flex=\"100\" layout-align=\"end end\"><md-button type=\"button\" ng-click=\"vm.savecommentofRes()\" \nng-class=\"addcommentInRes.$invalid || vm.savingcomment?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"addcommentInRes.$invalid || vm.savingcomment\" translate=\"OPTIONS_CREATE.SAVE\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/dashboards/gantt-chart/dialogs/option-place-on-gantt.html","<md-dialog class=\"contact-dialog contact-dialog-wide ganttpolicyChoice openPlaceGantt\" style=\"max-width: 1200px\" \naria-label=\"New Task\"><div class=\"hold-send-overlay\" ng-if=\"vm.holdSending\"></div><form name=\"openPlaceGantt\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts customized-radio\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" ng-if=\"vm.mode_of_call != \'add\' && vm.mode_of_call != \'edit\'\">\n{{vm.data.product_name}}</span><md-input-container class=\"md-block md-datepicker\" \nng-if=\"vm.mode_of_call == \'add\' || vm.mode_of_call == \'edit\'\" data-ng-animate=\"1\"><md-radio-group class=\"no-margin\" \nng-change=\"vm.type_changed()\" ng-model=\"vm.data.type_of_reservation\" ng-model-options=\"{debounce: 500}\" required>\n<md-radio-button class=\"space-block-inline\" value=\"create\" ng-disabled=\"vm.mode_of_call == \'edit\'\">\n{{ \'OPTIONS_CREATE.CREATE_RES\' | translate }}</md-radio-button><md-radio-button \nclass=\"space-block-inline margin-left-15\" value=\"create_day\" ng-if=\"vm.isDayReservationHotel\" \nng-disabled=\"vm.mode_of_call == \'edit\'\">{{ \'OPTIONS_CREATE.CREATE_DAY_RES\' | translate }}</md-radio-button>\n<md-radio-button class=\"space-block-inline margin-left-15\" value=\"hold\" \nng-if=\"(vm.location!=\'hold\' && vm.location!=\'block\') || vm.mode_of_call == \'edit\'\" ng-click=\"vm.closeAllDetails()\">\n{{ \'OPTIONS_CREATE.HOLD\' | translate }}</md-radio-button><md-radio-button class=\"space-block-inline margin-left-15\" \nvalue=\"block\" ng-if=\"vm.location!=\'hold\' && vm.location!=\'block\'\" ng-click=\"vm.closeAllDetails()\" \nng-disabled=\"vm.mode_of_call == \'edit\'\">{{ \'OPTIONS_CREATE.BLOCK\' | translate }}</md-radio-button></md-radio-group>\n</md-input-container><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon>\n</md-button></div></md-toolbar><md-progress-linear class=\"hold-dialog-loader\" md-mode=\"indeterminate\" \nng-show=\"vm.isloading || vm.promoRequestGoing || (vm.data.type_of_reservation == \'hold\' && !vm.hasHoldRoomLoaded())\">\n</md-progress-linear><md-dialog-content ms-scroll style=\"max-width:1200px;max-height:1000px\"><md-content \nclass=\"md-padding mb-15 datepickermain-block-container\" ng-if=\"vm.mode_of_call == \'add\' || vm.mode_of_call == \'edit\'\">\n<div flex=\"100\" layout=\"row\" layout-wrap><div class=\"row-block-new block-datepicker-main mb-0\" flex=\"50\" flex-xs=\"100\" \nlayout=\"column\" layout-align=\"start start\" flex><md-input-container class=\"md-block full-width mb-0\"><label \ntranslate=\"CREATE_RES.CHECKIN\"></label><md-datepicker md-open-on-focus ng-model=\"vm.original_room_stay_from\" \nng-change=\"vm.checkinSlected()\" class=\"full-width mdinput-block\"></md-datepicker></md-input-container></div><div \nclass=\"row-block-new block-datepicker-main\" flex=\"50\" flex-xs=\"100\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block full-width mb-0\"><label translate=\"CREATE_RES.CHECKOUT\"></label><md-datepicker \nng-disabled=\"vm.isDayCreateMode()\" md-open-on-focus ng-model=\"vm.original_room_stay_to\" \nmd-min-date=\"vm.isDayCreateMode() ? null : vm.minDateCheckout\" ng-change=\"vm.checkoutSelected()\" \nclass=\"full-width mdinput-block\"></md-datepicker></md-input-container></div></div><div class=\"\" flex=\"100\" \nlayout=\"row\" layout-wrap ng-if=\"vm.showRateUI() && (vm.pageType == \'room\' || !vm.pageType)\"><div \nclass=\"Fromto-col padding-left-10 padding-right-10 mt-10\" flex=\"50\" layout=\"column\" layout-align=\"start start\">\n<md-input-container class=\"md-block tax-inputs no-margin full-width\"><md-icon class=\"margin-left-5\" \nmd-font-icon=\"icon-human-male-female\"></md-icon><label class=\"lbl-width margin-left-20\">Adult</label><md-select \nplaceholder=\"Select Adults\" ng-model=\"vm.data.adult\" class=\"input-with-icons1\" \nng-change=\"vm.manageAdultChild(\'adult\')\"><md-option ng-value=\"n\" ng-repeat=\"n in vm.adultRange\">{{n}}</md-option>\n</md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"Fromto-col padding-left-10 padding-right-10 mt-10\" flex=\"50\" layout=\"column\" layout-align=\"start start\">\n<md-input-container class=\"md-block tax-inputs no-margin full-width\"><md-icon class=\"margin-left-5\" \nmd-font-icon=\"icon-human-child\"></md-icon><label class=\"lbl-width margin-left-20\">Child</label><md-select \nplaceholder=\"Select Children\" ng-model=\"vm.data.child\" class=\"input-with-icons1\" \nng-change=\"vm.manageAdultChild(\'child\')\"><md-option ng-value=\"i\" ng-repeat=\"i in vm.childRange\">{{i}}</md-option>\n</md-select><div class=\"md-errors-spacer\"></div></md-input-container></div></div><div class=\"\" flex=\"100\" layout=\"row\" \nlayout-wrap \nng-if=\"vm.showRateUI() && (vm.pageType == \'room\' || !vm.pageType) && vm.data.type_of_reservation == \'hold\' && !vm.onlyAllowHoldBlock\">\n<div class=\"Fromto-col padding-left-10 padding-right-10 mt-10\" flex=\"50\" layout=\"column\" layout-align=\"start start\">\n<div class=\"hold-date-promo full-width\"><div class=\"hold-promo-entry full-width\" ng-if=\"!vm.holdPromoApplied\">\n<md-input-container class=\"md-block tax-inputs no-margin no-error-spacer\"><md-icon class=\"margin-left-5\" \nmd-font-icon=\"icon-sale\"></md-icon><label class=\"lbl-width margin-left-20\">Promo Code</label><input \nclass=\"input-with-icons1\" ng-model=\"vm.holdPromoCode\" name=\"hold_promocode\" type=\"text\" autocomplete=\"off\" \nng-change=\"vm.holdPromoCode = (vm.holdPromoCode || \'\').toUpperCase()\" \nng-keydown=\"$event.keyCode === 13 && vm.holdPromoCode && vm.applyQuotePromo(\'applied\')\" \nng-disabled=\"vm.holdDiscountApplied\"><div class=\"md-errors-spacer\"></div></md-input-container><md-button \nclass=\"md-raised hold-promo-apply\" ng-click=\"vm.applyQuotePromo(\'applied\')\" \nng-disabled=\"!vm.holdPromoCode || vm.promoRequestGoing || vm.holdDiscountApplied\"><span>Apply</span>\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.promoRequestGoing\">\n</md-progress-circular></md-button></div><div class=\"hold-promo-applied-row\" ng-if=\"vm.holdPromoApplied\" layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"hold-promo-applied-icon\" md-font-icon=\"icon-sale\"></md-icon><div \nclass=\"hold-promo-applied-card\" flex><div class=\"hold-promo-applied-text\"><label>Promo Code</label><p>\n{{vm.holdPromoCode}}</p></div><p class=\"hold-promo-remove-link\" ng-click=\"vm.askRemoveHoldPromo($event)\"><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"red-A800-fg\"></md-icon>Remove</p></div></div></div></div></div></md-content>\n<md-content class=\"md-padding\" style=\"max-width: 1200px;overflow: visible\" \nng-class=\"{\'hold-quote-body\': vm.data.type_of_reservation == \'hold\'}\"><div class=\"row-block-new\" layout=\"column\" \nlayout-gt-xs=\"{{vm.data.type_of_reservation == \'hold\' ? \'column\' : \'row\'}}\" layout-align=\"start start\" flex \nlayout-wrap><div class=\"layout-colo-block padding-left-10 padding-right-10 full-width hold-available-rooms-box\" \nflex=\"100\" ng-if=\"vm.data.type_of_reservation == \'hold\' && vm.showHoldAvailableRooms\"><div class=\"custom-mat-tab\" \nng-if=\"vm.subHotel.length > 0\"><div class=\"custom-mat-tab-block\"><div class=\"custom-mat-tab-header\"><div \nclass=\"mat-tab-cell\" ng-class=\"vm.selectedSubHotelId == value.hotel_id ? \'active\' : \'\'\" \nng-repeat=\"value in vm.subHotel\" ng-click=\"vm.showHoldSubHotel(value.hotel_id)\">{{value.hotel_title}}</div></div><div \nclass=\"custom-mat-tab-content\"><div class=\"tabAddroomConent\"><div class=\"form-title no-padding mb-15\" \nng-if=\"vm.subHotelcount[vm.selectedSubHotelId] > 0\">Available Rooms <span>({{vm.subHotelcount[vm.selectedSubHotelId]}})\n</span></div><div class=\"norecordfound\" ng-if=\"vm.subHotelcount[vm.selectedSubHotelId] == 0\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"pr-5\"></md-icon>No rooms available</div><div layout=\"row\" flex=\"100\" \nlayout-wrap><div layout=\"column\" flex=\"100\" class=\"room-repeatblk relative-block\" \nng-repeat=\"(roomkey,room) in vm.available_rooms\" ng-if=\"room.sub_hotel_id == vm.selectedSubHotelId\"><div \nclass=\"room-listing\"><div class=\"img-block-room\"><img \nng-src=\"{{room.image ? (vm.baseUrl+\'assets/uploads/hotels/thumbnail/\'+room.image) : (vm.baseUrl+\'assets/uploads/product/room-service.svg\')}}\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\"></div><div class=\"room-block-listing\"><div \nclass=\"aprt-name aprt-name-lt mls-product\"><h5>{{room.product_name}}</h5></div><div class=\"policy-outer\" \nng-if=\"!room.onlyAllowHoldBlock\"><md-input-container class=\"mb-10 mt-0 md-input-has-value mb-0 row\" flex=\"100\" \nlayout-wrap layout=\"row\"><div class=\"rate-div\" ng-repeat=\"(policykey,eachpolicy) in room.policy_name\" flex=\"100\" \nlayout=\"column\"><div class=\"Reservation-outer-block margin-top-5 margin-bottom-5\"><md-checkbox \nclass=\"checkblock-ckeckbox margin-top-0 margin-bottom-0\" ng-model=\"vm.temp[room.product_id][policykey]\" \nng-change=\"vm.pickHoldAvailableRoom(room, policykey)\"><span class=\"aprt-nightly nt-policy\">{{eachpolicy}}</span> <span \nclass=\"aprt-nightly rate-plan-anchor\" ng-if=\"room.rateNameDesc && room.rateNameDesc[policykey].ratePlanName\"><div \nclass=\"rate-plan-txt\">Rate Plan: {{room.rateNameDesc[policykey].ratePlanName}}</div></span><span class=\"aprt-nightly\" \nng-if=\"room.max_occupancy\">Max. Occupancy: {{room.max_occupancy}}</span> <span class=\"aprt-nightly avg-rate\">\nNightly rate: <b class=\"rate-color-add red-A800-fg cut-price-span\"><span ng-if=\"room.anyPromoApplied\" \nclass=\"cut-price\">${{(room.nightlyRate || {})[policykey]}}</span>\n ${{room.anyPromoApplied ? (room.displayNightlyRate || {})[policykey] : (room.nightlyRate || {})[policykey]}}</b>\n</span></md-checkbox><div class=\"total-price-block\"><small>Total</small> <b>\n${{((room.searchSummary || {})[policykey] || {}).grandTotal}}</b></div></div></div></md-input-container></div></div>\n</div></div></div></div></div></div></div><div class=\"without-tab-block\" ng-if=\"!vm.subHotel.length\"><div \nclass=\"form-title no-padding mb-15\">Available Rooms <span ng-if=\"vm.available_rooms.length\">\n({{vm.available_rooms.length}})</span></div><div class=\"norecordfound\" \nng-if=\"!vm.isloading && !vm.available_rooms.length\"><md-icon md-font-icon=\"icon-information-outline\" class=\"pr-5\">\n</md-icon>No rooms available</div><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" \nclass=\"room-repeatblk relative-block\" ng-repeat=\"(roomkey,room) in vm.available_rooms\"><div class=\"room-listing\"><div \nclass=\"img-block-room\"><img \nng-src=\"{{room.image ? (vm.baseUrl+\'assets/uploads/hotels/thumbnail/\'+room.image) : (vm.baseUrl+\'assets/uploads/product/room-service.svg\')}}\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\"></div><div class=\"room-block-listing\"><div \nclass=\"aprt-name aprt-name-lt mls-product\"><h5>{{room.product_name}}</h5></div><div class=\"policy-outer\" \nng-if=\"!room.onlyAllowHoldBlock\"><md-input-container class=\"mb-10 mt-0 md-input-has-value mb-0 row\" flex=\"100\" \nlayout-wrap layout=\"row\"><div class=\"rate-div\" ng-repeat=\"(policykey,eachpolicy) in room.policy_name\" flex=\"100\" \nlayout=\"column\"><div class=\"Reservation-outer-block margin-top-5 margin-bottom-5\"><md-checkbox \nclass=\"checkblock-ckeckbox margin-top-0 margin-bottom-0\" ng-model=\"vm.temp[room.product_id][policykey]\" \nng-change=\"vm.pickHoldAvailableRoom(room, policykey)\"><span class=\"aprt-nightly nt-policy\">{{eachpolicy}}</span> <span \nclass=\"aprt-nightly rate-plan-anchor\" ng-if=\"room.rateNameDesc && room.rateNameDesc[policykey].ratePlanName\"><div \nclass=\"rate-plan-txt\">Rate Plan: {{room.rateNameDesc[policykey].ratePlanName}}</div></span><span class=\"aprt-nightly\" \nng-if=\"room.max_occupancy\">Max. Occupancy: {{room.max_occupancy}}</span> <span class=\"aprt-nightly avg-rate\">\nNightly rate: <b class=\"rate-color-add red-A800-fg cut-price-span\"><span ng-if=\"room.anyPromoApplied\" \nclass=\"cut-price\">${{(room.nightlyRate || {})[policykey]}}</span>\n ${{room.anyPromoApplied ? (room.displayNightlyRate || {})[policykey] : (room.nightlyRate || {})[policykey]}}</b>\n</span></md-checkbox><div class=\"total-price-block\"><small>Total</small> <b>\n${{((room.searchSummary || {})[policykey] || {}).grandTotal}}</b></div></div></div></md-input-container></div></div>\n</div></div></div></div></div><div class=\"layout-colo-block padding-left-10 padding-right-10 full-width\" flex=\"100\" \nflex-gt-sm=\"{{vm.data.type_of_reservation == \'hold\' ? 100 : 50}}\" \nng-if=\"vm.showRateUI() && !vm.showHoldAvailableRooms\" \nng-class=\"{\'no-rate-plan1\': vm.onlyAllowHoldBlock, \'hold-selected-room-box\': vm.data.type_of_reservation == \'hold\'}\">\n<div class=\"hold-change-room-wrap\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.data.type_of_reservation == \'hold\'\"><h4 class=\"hold-section-heading\">Selected Room</h4><md-button \nclass=\"md-raised hold-change-room-btn\" type=\"button\" ng-if=\"vm.mode_of_call == \'edit\' && vm.hasHoldRoomLoaded()\" \nng-click=\"vm.backToHoldRooms()\" aria-label=\"Change Room\">Change Room</md-button></div><div \nclass=\"room-repeatblk relative-block\" layout=\"column\" flex=\"100\" \nng-if=\"vm.show_result || (vm.data.type_of_reservation == \'hold\' && vm.data.product_name)\"><div class=\"room-listing\" \nng-if=\"vm.data.type_of_reservation == \'hold\' && !vm.hasHoldRoomLoaded() && !vm.isloading\"><div \nclass=\"room-block-listing\"><div class=\"Reservation-outer-block hold-room-detail-line margin-top-5 margin-bottom-5\"><h5 \nclass=\"hold-inline-room-name\"><span>{{vm.data.product_name}}</span></h5></div></div></div><div class=\"room-listing\" \nng-class=\"{\'is-open\': vm.showHoldDiscountPanel}\"><div class=\"img-block-room\" \nng-if=\"vm.data.type_of_reservation != \'hold\'\"><img \nng-src=\"{{vm.proImage ? (vm.baseUrl+\'assets/uploads/hotels/thumbnail/\'+vm.proImage) : (vm.baseUrl+\'assets/uploads/product/room-service.svg\')}}\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\"></div><div class=\"room-block-listing\"><div \nclass=\"aprt-name aprt-name-lt mls-product\" ng-if=\"vm.data.type_of_reservation != \'hold\'\"><h5><span>\n{{vm.data.product_name}}</span></h5><span class=\"readmoreblock readmoreBlockmainlt1\" \nid=\"readmoreblock_{{vm.data.product_id}}\" ng-click=\"vm.readDescription()\" ng-if=\"!vm.onlyAllowHoldBlock\">\n{{vm.readText}}</span></div><div class=\"no-rate-paln-section\" ng-if=\"vm.onlyAllowHoldBlock\"><span \nng-bind-html=\"vm.noRateAssociatedMsg\"></span></div><div class=\"aprt-name aprt-name-lt mls-product hold-room-title\" \nng-if=\"vm.data.type_of_reservation == \'hold\' && !vm.showHoldGuestStep && vm.data.product_name && vm.hasHoldRoomLoaded()\">\n<h5><span>{{vm.data.product_name}}</span></h5><span class=\"readmoreblock readmoreBlockmainlt1\" \nid=\"readmoreblock_hold_{{vm.data.product_id}}\" ng-click=\"vm.readDescription()\" ng-if=\"!vm.onlyAllowHoldBlock\">\n{{vm.readText}}</span></div><div class=\"policy-outer\" \nng-class=\"{\'hold-policy-pick\': vm.data.type_of_reservation == \'hold\' && !vm.showHoldGuestStep}\" \nng-if=\"!vm.onlyAllowHoldBlock\"><md-input-container class=\"mb-10 mt-0 md-input-has-value mb-0 row\" flex=\"100\" \nlayout-wrap layout=\"row\"><div class=\"rate-div\" ng-repeat=\"(policykey,eachpolicy) in vm.policiesDetail\" \nng-if=\"vm.showHoldPolicyRow(policykey)\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\" layout=\"column\"><md-radio-group \nclass=\"row no-margin\" flex=\"100\" layout-wrap layout=\"row\" ng-model=\"vm.selectedRoom[vm.data.product_id]\" \nng-change=\"vm.buildHoldNightlyRows()\" ng-click=\"vm.data.type_of_reservation == \'hold\' || $event.stopPropagation()\">\n<span flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\" layout=\"column\" \nclass=\"policy-blk no-margin space-block-inline pr-10 pb-15\" ng-value=\"policykey\"><div \nclass=\"Reservation-outer-block margin-top-5 margin-bottom-5\" \nng-class=\"{\'hold-room-detail-line\': vm.data.type_of_reservation == \'hold\' && vm.showHoldGuestStep && !vm.onlyAllowHoldBlock}\" \nng-click=\"vm.data.type_of_reservation == \'hold\' && vm.showHoldGuestStep && !vm.onlyAllowHoldBlock && vm.toggleHoldDiscountPanel($event)\">\n<h5 class=\"hold-inline-room-name\" ng-if=\"vm.data.type_of_reservation == \'hold\' && vm.showHoldGuestStep\"><span>\n{{vm.data.product_name}}</span></h5><span class=\"aprt-nightly hold-detail-occ\" \nng-if=\"vm.data.type_of_reservation == \'hold\' && vm.showHoldGuestStep && vm.pageType == \'room\' && vm.maxOccupancy\">\nMax. Occupancy: {{vm.maxOccupancy}}</span><md-radio-button \nng-if=\"!(vm.data.type_of_reservation == \'hold\' && vm.showHoldGuestStep)\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\" \nlayout=\"column\" class=\"margin-top-0 margin-bottom-0 checkblock-ckeckbox single\" style=\"width:100%\" \nng-value=\"policykey\"><span class=\"aprt-nightly nt-policy\">{{eachpolicy.policy_name}}</span></md-radio-button><div \nclass=\"rate-plan-spans-block\"><span class=\"aprt-nightly rate-plan-anchor\" \nng-if=\"!vm.isDayCreateMode() && eachpolicy.ratePlanName\"><div class=\"rate-plan-txt\" \nng-init=\"vm.showRateDesc[policykey] = false\" ng-mouseenter=\"!vm.runClickEvent?vm.showDetailRateBlock(policykey):\'\'\" \nng-mouseleave=\"!vm.runClickEvent?vm.closeAllRateDetails(policykey):\'\'\" \nng-click=\"vm.data.type_of_reservation == \'hold\' || $event.stopPropagation(); vm.data.type_of_reservation != \'hold\' && vm.runClickEvent && vm.showDetailRateBlock(policykey)\">\nRate Plan: {{eachpolicy.ratePlanName}}<div class=\"total-amount-blk-section\" \nng-if=\"vm.showRateDesc[policykey] && eachpolicy.ratePlanDesc != \'\'\"><div class=\"total-amt-row\"><b>\n{{eachpolicy.ratePlanDesc}}</b></div></div></div></span><span class=\"aprt-nightly\" \nng-if=\"vm.pageType == \'room\' && !(vm.data.type_of_reservation == \'hold\' && vm.showHoldGuestStep)\">\nMax. Occupancy: {{vm.maxOccupancy}}</span> <span class=\"aprt-nightly\" \nng-if=\"vm.boat_length > 0 && vm.pageType != \'room\'\">Vessel Length: {{vm.boat_length}}</span> <span \nclass=\"aprt-nightly\" ng-if=\"vm.boat_width > 0 && vm.pageType != \'room\'\">Vessel Width: {{vm.boat_width}}</span> <span \nclass=\"aprt-nightly avg-rate\">{{vm.isDayCreateMode() ? \'Day rate\' : \'Nightly rate\'}}: <b \nclass=\"rate-color-add red-A800-fg cut-price-span\"><span \nng-if=\"((vm.holdPromoApplied && vm.holdPromoPolicy == policykey) || (vm.holdDiscountApplied && vm.holdDiscountPolicy == policykey)) && vm.displayNightlyRate\" \nclass=\"cut-price\">${{eachpolicy.nightlyRate}}</span> <span \nng-if=\"!((vm.holdPromoApplied && vm.holdPromoPolicy == policykey) || (vm.holdDiscountApplied && vm.holdDiscountPolicy == policykey)) && !vm.isDayCreateMode() && eachpolicy.highestAvgRate && eachpolicy.highestAvgRate !== eachpolicy.nightlyRate && eachpolicy.highestAvgRate > eachpolicy.nightlyRate\" \nclass=\"cut-price\">${{eachpolicy.highestAvgRate}}</span>\n ${{(((vm.holdPromoApplied && vm.holdPromoPolicy == policykey) || (vm.holdDiscountApplied && vm.holdDiscountPolicy == policykey)) && vm.displayNightlyRate) ? vm.displayNightlyRate : eachpolicy.nightlyRate}}\n</b></span></div><div class=\"total-price-block\" ng-init=\"vm.showBlock[policykey] = false\" \nng-mouseenter=\"!vm.runClickEvent?vm.showDetailBlock(policykey):\'\'\" \nng-mouseleave=\"!vm.runClickEvent?vm.closeAllDetails(policykey):\'\'\" \nng-click=\"vm.data.type_of_reservation == \'hold\' || $event.stopPropagation(); vm.data.type_of_reservation != \'hold\' && vm.runClickEvent && vm.showDetailBlock(policykey)\">\n<small>Total</small> <b>${{(vm.searchSummary[policykey] || {}).grandTotal}}</b><div class=\"total-amount-blk-section\" \nng-if=\"vm.showBlock[policykey]\"><div class=\"total-amt-row\"><span ng-if=\"vm.pageType == \'room\'\">Room Amount</span> <span\n ng-if=\"vm.pageType == \'boat\'\">Slip Amount</span> <span ng-if=\"vm.pageType == \'rent\'\">Residence Amount</span> <span>\n${{vm.searchSummary[policykey].subTotal}}</span></div><div class=\"total-amt-row\" ng-if=\"vm.extraPersonApplicable\">\n<span>Extra Person</span> <span>${{vm.searchSummary[policykey].extraPersonAmt}}</span></div><div class=\"total-amt-row\" \nng-if=\"vm.resortFeeApplicable\"><span>Resort fee</span> <span>${{vm.searchSummary[policykey].resortFee}}</span></div>\n<div class=\"total-amt-row\" ng-if=\"vm.searchSummary[policykey].surcharge != undefined\"><span>Surcharge</span> <span>\n${{vm.searchSummary[policykey].surcharge}}</span></div><div class=\"total-amt-row\" \nng-if=\"vm.holdPromoApplied && vm.holdPromoPolicy == policykey\"><span>Discount <span \nng-if=\"vm.holdPercentLabel(vm.holdPromoDiscount, vm.searchSummary[policykey].subTotal)\">\n({{vm.holdPercentLabel(vm.holdPromoDiscount, vm.searchSummary[policykey].subTotal)}}%)</span></span> <span \nclass=\"hold-promo-discount\">-${{vm.holdPromoDiscount}}</span></div><div class=\"total-amt-row\" \nng-if=\"vm.holdDiscountApplied && vm.holdDiscountPolicy == policykey\"><span>Discount <span \nng-if=\"vm.holdDiscountPercent > 0\">({{vm.holdDiscountPercent}}%)</span></span> <span class=\"hold-promo-discount\">\n-${{vm.holdTotalDiscount || vm.holdDiscountAmount}}</span></div><div class=\"total-amt-row\"><span>Taxes</span> <span>\n${{vm.searchSummary[policykey].taxes}}</span></div><div class=\"total-amt-row\"><span>Grand Total</span> <span>\n${{vm.searchSummary[policykey].grandTotal}}</span></div></div></div></div></span></md-radio-group></div>\n</md-input-container></div></div><p ng-if=\"vm.showDescription\" class=\"room_type_description\">\n{{vm.room_type_description}}</p></div><div class=\"hold-nightly-price nightly-price-heading\" \nng-if=\"vm.data.type_of_reservation == \'hold\' && !vm.onlyAllowHoldBlock && vm.showHoldDiscountPanel && vm.holdNightlyRows.length\">\nNightly-price<div class=\"nightlyscrollblk\"><div class=\"scroll-nightly-inner\"><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"row-block1-amount row-header-amount\"><div layout=\"column\" flex=\"20\" layout-align=\"center start\">Night</div><div \nlayout=\"column\" flex=\"20\" layout-align=\"center start\">Date</div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center start\" ng-if=\"vm.showHoldRatePlanCol()\">Rate Plan</div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center end\">Discount</div><div layout=\"column\" flex=\"20\" layout-align=\"center end\">Price</div></div><div \nng-repeat=\"night in vm.holdNightlyRows track by $index\" class=\"hold-nightly-row-wrap\"><div layout=\"row\" flex=\"100\" \nlayout-wrap class=\"row-nightly-amount row-block1-amount\"><div layout=\"column\" flex=\"20\" layout-align=\"center start\">\n<div class=\"charges\">Night {{night.nightNum}}</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center start\">\n<div class=\"charges\">{{night.date}}</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center start\" \nng-if=\"vm.showHoldRatePlanCol()\"><div class=\"charges\">{{night.ratePlan}}</div></div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center end\"><div class=\"amount discount\"><md-input-container class=\"md-block no-margin\"><i \nclass=\"icon icon-currency-usd s20\"></i> <span class=\"nightly-discount-value\" \nng-class=\"{\'hold-discount-locked\': vm.holdPromoApplied}\" \nng-click=\"!vm.holdPromoApplied && vm.openHoldNightDiscount($index, $event)\"><span class=\"nightly-discount-amount\">\n{{ night.amount | number:2 }}</span> <span class=\"nightly-discount-percent\" ng-if=\"night.percentLabel\">\n{{night.percentLabel}}%</span> </span><i ng-if=\"night.amount > 0\" class=\"icon icon-comment-outline discountcomment\" \nng-class=\"{\'onlycursorPointer\': !vm.holdPromoApplied}\" \nng-click=\"!vm.holdPromoApplied && vm.openHoldNightDiscount($index, $event)\"><md-tooltip ng-if=\"night.comment\">\n{{night.comment}}</md-tooltip></i></md-input-container></div></div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center end\"><div class=\"amount price\"><md-input-container class=\"md-block no-margin\"><i \nclass=\"icon icon-currency-usd s20\"></i> <span class=\"charges\">{{ night.rate | number:2 }}</span></md-input-container>\n</div></div></div></div></div></div></div></div><div class=\"norecordfound\" \nng-if=\"!vm.show_result && vm.occupancy_error !== \'\'\"><md-icon md-font-icon=\"icon-information-outline\" class=\"pr-5\">\n</md-icon>{{vm.occupancy_error}}</div></div><div class=\"norecordfound\" ng-if=\"!vm.isCreateMode() && !vm.show_form\">\n<md-icon md-font-icon=\"icon-information-outline\" class=\"pr-5\"></md-icon>{{vm.availability_error}}</div><div \nclass=\"layout-colo-block padding-left-10 padding-right-10 full-width\" flex=\"100\" flex-gt-sm=\"50\" \nng-if=\"vm.data.type_of_reservation == \'block\' && vm.show_form\"><md-input-container class=\"md-block m-b-0\" \nng-class=\"(vm.isCommentEmpty && openPlaceGantt.block_comment.$untouched) || (openPlaceGantt.block_comment.$touched && (vm.data.room_stay_comment == \'\' || vm.data.room_stay_comment == undefined)) ? \'md-input-invalid\' : \'\'\">\n<label translate=\"OPTIONS_CREATE.COMMENT\"></label><input name=\"block_comment\" type=\"text\" \nng-model=\"vm.data.room_stay_comment\"> <span \nng-show=\"(vm.isCommentEmpty && openPlaceGantt.block_comment.$untouched) || (openPlaceGantt.block_comment.$touched && (vm.data.room_stay_comment == \'\' || vm.data.room_stay_comment == undefined))\" \nclass=\"errornlk\">Please enter block comment.</span></md-input-container></div><div \nclass=\"layout-colo-block hold-quote-form hold-guest-details-box full-width\" flex=\"100\" \nng-if=\"vm.data.type_of_reservation == \'hold\' && vm.show_form && (vm.mode_of_call == \'edit\' || vm.showHoldGuestStep) && !vm.showHoldAvailableRooms\">\n<h4 class=\"hold-section-heading\">Customer Details</h4><div flex=\"100\" layout=\"row\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10\" flex=\"50\" flex-xs=\"100\" layout=\"column\"><md-autocomplete \nmd-no-cache=\"vm.holdCustomerNoCache\" md-selected-item=\"vm.selectedHoldCustomer.first_name\" \nmd-selected-item-change=\"vm.selectHoldCustomer(item)\" \nmd-items=\"item in vm.queryHoldCustomer(vm.searchTextFn, \'cust.first_name\')\" md-search-text=\"vm.searchTextFn\" \nmd-search-text-change=\"vm.onHoldCustomerSearchChange(\'first_name\')\" md-item-text=\"item.first_name\" md-min-length=\"1\" \nmd-delay=\"500\" md-floating-label=\"{{ \'CREATE_RES.CUST_FN\' | translate }}\" md-dropdown-position=\"bottom\" \nmd-menu-class=\"hold-customer-suggest\" class=\"chooseCustomer full-width\" required><md-item-template><span \nmd-highlight-text=\"vm.searchTextFn\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template>\n</md-autocomplete></div><div class=\"padding-left-10 padding-right-10\" flex=\"50\" flex-xs=\"100\" layout=\"column\">\n<md-autocomplete md-no-cache=\"vm.holdCustomerNoCache\" md-selected-item=\"vm.selectedHoldCustomer.last_name\" \nmd-selected-item-change=\"vm.selectHoldCustomer(item)\" \nmd-items=\"item in vm.queryHoldCustomer(vm.searchTextLn, \'cust.last_name\')\" md-search-text=\"vm.searchTextLn\" \nmd-search-text-change=\"vm.onHoldCustomerSearchChange(\'last_name\')\" md-item-text=\"item.last_name\" md-min-length=\"1\" \nmd-delay=\"500\" md-floating-label=\"{{ \'CREATE_RES.CUST_LN\' | translate }}\" md-dropdown-position=\"bottom\" \nmd-menu-class=\"hold-customer-suggest\" class=\"chooseCustomer full-width\" required><md-item-template><span \nmd-highlight-text=\"vm.searchTextLn\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template>\n</md-autocomplete></div></div><div flex=\"100\" layout=\"row\" layout-wrap><div class=\"padding-left-10 padding-right-10\" \nflex=\"50\" flex-xs=\"100\" layout=\"column\"><md-autocomplete md-no-cache=\"vm.holdCustomerNoCache\" \nmd-selected-item=\"vm.selectedHoldCustomer.customer_email\" md-selected-item-change=\"vm.selectHoldCustomer(item)\" \nmd-items=\"item in vm.queryHoldCustomer(vm.searchTextEm, \'cust.customer_email\')\" md-search-text=\"vm.searchTextEm\" \nmd-search-text-change=\"vm.onHoldCustomerSearchChange(\'customer_email\')\" md-item-text=\"item.customer_email\" \nmd-min-length=\"1\" md-delay=\"500\" md-floating-label=\"{{ \'CREATE_RES.CUST_EMAIL\' | translate }}\" \nmd-dropdown-position=\"bottom\" md-menu-class=\"hold-customer-suggest\" class=\"chooseCustomer full-width\" required>\n<md-item-template><span md-highlight-text=\"vm.searchTextEm\" md-highlight-flags=\"^i\">{{item.customer_email}}</span>\n</md-item-template></md-autocomplete></div><div class=\"padding-left-10 padding-right-10\" flex=\"50\" flex-xs=\"100\" \nlayout=\"column\"><md-input-container class=\"md-block m-b-0 full-width hold-phone-container\" \nng-class=\"{\'md-input-has-value\': !!vm.data.phone_number, \'hold-phone-invalid md-input-invalid\': vm.holdPhoneInvalid}\">\n<label translate=\"CREATE_RES.CUST_CONT_NO\" class=\"phone-number-label\"></label><input required name=\"phone_number\" \ntype=\"tel\" class=\"intel-number-input hold-quote-phone\" intl-tel-input ng-model=\"vm.data.phone_number\" \nng-model-options=\"{debounce: 800}\" ng-change=\"vm.updateHoldPhone()\" autocomplete=\"off\"><div class=\"hold-phone-error\" \nng-if=\"vm.holdPhoneInvalid\">Not a valid number</div></md-input-container></div></div><div flex=\"100\" layout=\"row\" \nlayout-wrap><div class=\"padding-left-10 padding-right-10\" flex=\"50\" flex-xs=\"100\" layout=\"column\"><md-input-container \nclass=\"md-block m-b-0 full-width hold-expiry-date\" ng-class=\"{\'md-input-has-value\': !!vm.data.hold_duration}\"><label \ntranslate=\"OPTIONS_CREATE.EXPIRYDATE\"></label><md-datepicker md-open-on-focus ng-model=\"vm.data.hold_duration\" \nng-change=\"vm.markHoldEdited()\" class=\"full-width mdinput-block\"></md-datepicker></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" flex=\"50\" flex-xs=\"100\" layout=\"column\"><md-input-container \nclass=\"md-block m-b-0 full-width hold-expiry-time\" ng-class=\"{\'md-input-has-value\': !!vm.hold_duration_time}\"><label \ntranslate=\"OPTIONS_CREATE.EXPIRYTIME\"></label><input type=\"time\" id=\"holdExpiryTime\" name=\"hold_duration_time\" \nng-model=\"vm.hold_duration_time\" ng-change=\"vm.markHoldEdited()\" autocomplete=\"off\"></md-input-container></div></div>\n<div class=\"padding-left-10 padding-right-10\" flex=\"100\"><md-input-container class=\"md-block m-b-0 full-width\" \nng-class=\"(vm.isCommentEmpty && openPlaceGantt.hold_comment.$untouched) || (openPlaceGantt.hold_comment.$touched && (vm.data.room_stay_comment == \'\' || vm.data.room_stay_comment == undefined)) ? \'md-input-invalid\' : \'\'\">\n<label translate=\"OPTIONS_CREATE.COMMENT\"></label><input name=\"hold_comment\" type=\"text\" \nng-model=\"vm.data.room_stay_comment\" ng-change=\"vm.markHoldEdited()\"> <span \nng-show=\"(vm.isCommentEmpty && openPlaceGantt.hold_comment.$untouched) || (openPlaceGantt.hold_comment.$touched && (vm.data.room_stay_comment == \'\' || vm.data.room_stay_comment == undefined))\" \nclass=\"errornlk\">Please enter hold comment.</span></md-input-container></div></div></div></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\" flex=\"100\" layout-align=\"end center\"><div layout=\"row\" \nlayout-align=\"end center\" flex=\"100\"><md-button \nng-if=\"vm.data.type_of_reservation == \'hold\' && (vm.showHoldAvailableRooms || (vm.mode_of_call != \'edit\' && !vm.showHoldGuestStep))\" \ntype=\"button\" ng-click=\"vm.goToHoldGuestStep()\" \nng-class=\"(vm.showHoldAvailableRooms ? !vm.hasHoldAvailablePick() : (!vm.show_result || (!vm.onlyAllowHoldBlock && !vm.selectedRoom[vm.data.product_id])))?\'submit-button md-accent md-raised white-fg\':\'submit-button md-green-500-bg md-raised white-fg\'\" \nng-disabled=\"vm.showHoldAvailableRooms ? !vm.hasHoldAvailablePick() : (!vm.show_result || (!vm.onlyAllowHoldBlock && !vm.selectedRoom[vm.data.product_id]))\" \naria-label=\"Next\">Next</md-button><md-button \nng-if=\"vm.data.type_of_reservation == \'hold\' && vm.showHoldGuestStep && !vm.showHoldAvailableRooms\" type=\"button\" \nng-click=\"vm.backToHoldRooms()\" class=\"md-raised\" aria-label=\"Back\">Back</md-button><md-button class=\"hold-send-btn\" \nng-if=\"((vm.data.type_of_reservation == \'hold\' && (vm.mode_of_call == \'edit\' || vm.showHoldGuestStep) && !vm.showHoldAvailableRooms) || vm.data.type_of_reservation == \'block\')\" \ntype=\"button\" ng-click=\"vm.saveTypeofRes()\" \nng-class=\"(vm.isHoldEdit() ? (vm.isHoldEditLoading() || vm.holdEditSaveDisabled() || vm.holdSending) : (vm.data.type_of_reservation == \'hold\' ? vm.isHoldCreateDisabled() : (openPlaceGantt.$invalid || !vm.showSaveBtn)))?\'submit-button md-accent md-raised white-fg\':\'submit-button md-green-500-bg md-raised white-fg\'\" \nng-disabled=\"vm.isHoldEdit() ? (vm.isHoldEditLoading() || vm.holdEditSaveDisabled() || vm.holdSending) : (vm.data.type_of_reservation == \'hold\' ? vm.isHoldCreateDisabled() : (openPlaceGantt.$invalid || !vm.showSaveBtn))\" \naria-label=\"{{vm.data.type_of_reservation == \'hold\' ? \'Send\' : \'Save\'}}\"><span \nng-if=\"vm.data.type_of_reservation == \'hold\'\">Send</span> <span ng-if=\"vm.data.type_of_reservation != \'hold\'\" \ntranslate=\"OPTIONS_CREATE.SAVE\">Save</span></md-button><md-button ng-if=\"vm.isCreateMode() && !vm.onlyAllowHoldBlock\" \ntype=\"button\" ng-click=\"vm.saveTypeofRes()\" \nng-class=\"openPlaceGantt.$invalid || (vm.selectedRoom[vm.data.product_id]==\'\' && vm.isCreateMode()) || !vm.showSaveBtn?\'submit-button md-accent md-raised white-fg\':\'submit-button md-green-500-bg md-raised white-fg\'\" \nng-disabled=\"openPlaceGantt.$invalid || !vm.showSaveBtn || (vm.selectedRoom[vm.data.product_id]==\'\' && vm.isCreateMode())\" \ntranslate=\"OPTIONS_CREATE.CONT\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/dashboards/housekeeping/views/floor-1.html","<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" \ny=\"0px\" width=\"1000px\" height=\"1564px\" viewBox=\"0 0 1000 1564\" enable-background=\"new 0 0 1000 1564\" \nxml:space=\"preserve\"><metadata><?xpacket begin=\"﻿\" id=\"W5M0MpCehiHzreSzNTczkc9d\"?> <x:xmpmeta xmlns:x=\"adobe:ns:meta/\" \nx:xmptk=\"Adobe XMP Core 5.3-c011 66.145661, 2012/02/06-14:56:27        \"><rdf:RDF \nxmlns:rdf=\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\"><rdf:Description rdf:about=\"\" \nxmlns:xmp=\"http://ns.adobe.com/xap/1.0/\" xmlns:xmpGImg=\"http://ns.adobe.com/xap/1.0/g/img/\"><xmp:CreatorTool>\nAdobe Illustrator CS6 (Windows)</xmp:CreatorTool><xmp:CreateDate>2019-01-24T16:10:16+05:30</xmp:CreateDate>\n<xmp:Thumbnails><rdf:Alt><rdf:li rdf:parseType=\"Resource\"><xmpGImg:width>160</xmpGImg:width><xmpGImg:height>256\n</xmpGImg:height><xmpGImg:format>JPEG</xmpGImg:format><xmpGImg:image>\n/9j/4AAQSkZJRgABAgEASABIAAD/7QAsUGhvdG9zaG9wIDMuMAA4QklNA+0AAAAAABAASAAAAAEA&#xA;AQBIAAAAAQAB/+4ADkFkb2JlAGTAAAAAAf/bAIQABgQEBAUEBgUFBgkGBQYJCwgGBggLDAoKCwoK&#xA;DBAMDAwMDAwQDA4PEA8ODBMTFBQTExwbGxscHx8fHx8fHx8fHwEHBwcNDA0YEBAYGhURFRofHx8f&#xA;Hx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8f/8AAEQgBAACgAwER&#xA;AAIRAQMRAf/EAaIAAAAHAQEBAQEAAAAAAAAAAAQFAwIGAQAHCAkKCwEAAgIDAQEBAQEAAAAAAAAA&#xA;AQACAwQFBgcICQoLEAACAQMDAgQCBgcDBAIGAnMBAgMRBAAFIRIxQVEGE2EicYEUMpGhBxWxQiPB&#xA;UtHhMxZi8CRygvElQzRTkqKyY3PCNUQnk6OzNhdUZHTD0uIIJoMJChgZhJRFRqS0VtNVKBry4/PE&#xA;1OT0ZXWFlaW1xdXl9WZ2hpamtsbW5vY3R1dnd4eXp7fH1+f3OEhYaHiImKi4yNjo+Ck5SVlpeYmZ&#xA;qbnJ2en5KjpKWmp6ipqqusra6voRAAICAQIDBQUEBQYECAMDbQEAAhEDBCESMUEFURNhIgZxgZEy&#xA;obHwFMHR4SNCFVJicvEzJDRDghaSUyWiY7LCB3PSNeJEgxdUkwgJChgZJjZFGidkdFU38qOzwygp&#xA;0+PzhJSktMTU5PRldYWVpbXF1eX1RlZmdoaWprbG1ub2R1dnd4eXp7fH1+f3OEhYaHiImKi4yNjo&#xA;+DlJWWl5iZmpucnZ6fkqOkpaanqKmqq6ytrq+v/aAAwDAQACEQMRAD8A9FweePL9xBHPCbx4ZVV4&#xA;3FhfUZWFQR+57jFV/wDjHRf5bz/pAvv+qOKu/wAY6L/Lef8ASBff9UcVd/jHRf5bz/pAvv8Aqjir&#xA;v8Y6L/Lef9IF9/1RxVZL530CIKZPrih3SNT+j77d5GCIP7j9pmAxVE/4l07/AHzff9w++/6o4q4+&#xA;ZtNAqYb/AOjTr4/qhxV575dh/Lg+X9MM0ej+qbSD1Oa23Pl6S15V3r41xSmH1f8ALP8A33ov/A2m&#xA;Ko3yVrPlPTn12CK+sLO2bUFe3iSWGJCpsbUFkUECnMNuO9cUMl/xZ5W/6vNj/wBJMP8AzViq2Pzh&#xA;5SkQPHrdg6NurLdQkEexDYqu/wAWeVv+rzY/9JMP/NWKu/xZ5W/6vNj/ANJMP/NWKu/xZ5W/6vNj&#xA;/wBJMP8AzVirv8WeVv8Aq82P/STD/wA1Yq7/ABZ5W/6vNj/0kw/81Yqtfzh5SjUvJrdgiDqzXUIG&#xA;+3Utiq+HzV5YnmSGDWLKWaVgkcSXMTMzMaBVUNUknFUg8rkHy1pJG4Nlb/8AJpcUpnirsVdirsVQ&#xA;Or/3Fr/zH2H/AFGw4qy7FDsVSryn/wAoto3/ADA23/JlcVTXFXYq7FUg8gf8obpP/GAfrOKp/irs&#xA;VdirsVdiqT+b/wDlHL3/AFV/4muKpTq/9xa/8x9h/wBRsOKXeVvKWjP5Y0hybsFrK3JAvrxRvEvQ&#xA;CYAfRihNP8H6L43n/Sfe/wDVbFUv1PyxpkN7pEccl6qXF20Uw+v3vxILSeQD++/njU4qmH+D9F8b&#xA;z/pPvf8Aqtirv8H6L43n/Sfe/wDVbFW08o6IsschW5cwyJKiyXl3InONg6Eo8rKaMoO4xVOcVdiq&#xA;VeU/+UW0b/mBtv8AkyuKprirsVdiqQeQP+UN0n/jAP1nFU/xV2KuxV2KuxVJ/N//ACjl7/qr/wAT&#xA;XFUp1f8AuLX/AJj7D/qNhxSoalqmo6V+VFtqGnXtpp15BYWRjvL9HlgQH0lYGOMq7sykqiqalyBi&#xA;hB/l35p1LV9WuLe88zW+q+nbmQacdDvdEuR8aj11+uzO0ka14njHSpHxDoVWWaz/AMdHQv8AmOf/&#xA;AKgbnFURrd7JY6ReXkQDSwRO8YPTkBtX2r1yrPk4IGXcGzDEGYB5EhiHlXz7f6nq9vZXgVGmM6Mq&#xA;RMq80ClQjcnY0AYmoFPHMDT6yc5gGqN/or9Lt9X2R4MJSB4gOE92xvn5/Sln/KwvOctxe6PFFp0e&#xA;tN5ll0LTrho53tY7eLSl1T1J19WNnk4ck+F0FaGmxrtHSI/yj+YOta9r/l2N7a3g0fX/AC02uogE&#xA;huY7hJLRWQuSqenS7NPgqaVr2xV6BirB7vzJeaD5F0C4tIklkktbdWEgJUKLcMTRSu+3jmHrNScQ&#xA;BHU052g0g1EzAnhNbHnv5hW0jzhqeqaNq8tqsI1KzhWW2WeOSOP4ouQaRVZzxLAkAPUjwwaPUSyX&#xA;xVtX3frtnr9AcAie/i+yR/RTGLT82vMdxbeX736raC2l03y5fa8npzeo8nmS4+qotn+8+FYHUueQ&#xA;k5D4ag75muuZj5H8xa1rFx5lt9WS2SXRdYk063NqJArQC0trlC5kZiX/ANJIJAA26YqifIH/AChu&#xA;k/8AGAfrOKp8zBVLHooqfowEqx/TfPOi6lPFFarK3qyrCjlVA5MrNuvLnQcNzx8Mw466EiAL3NfY&#xA;T+hzcugy474hVC/eNuVf1vvQd/8AmXotje6/Zz2l6J9AFh6i+mg+tPqkrwWsdrykHJnmj4VfitSN&#xA;6VIzXCdY/mVo15d+X7WOzvUk8wz3lpCzxoFtrnT1ma4guWEhAdTayL+75io603xVluKpP5v/AOUc&#xA;vf8AVX/ia4qlOr/3Fr/zH2H/AFGw4pQetLA35SWvrafe6mEs9OeK10xlS89ZHhaGaB2ZFVoJAstS&#xA;aDj36YoQf5e6Vr6eYZL7X9O1/wCtR2kkFpqeuXmkXCRxyyxNJBFFpjLQytEjFmj/AGKchsCqzHWf&#xA;+OjoX/Mc/wD1A3OKpjc20Nzby2868oZlMci1IqrChFRQ9MjOAlExPIsoyMSCOiU6Z5N8u6Zei9s7&#xA;Yx3CV9NjLKwUMvFgAzEUPXfMbFosWMgxFcPLc/rc3P2nnyw4Jm4+4fqUdQ8g+VNQt76C5smKajej&#xA;Urp4554ZDdrCluJo5YpEkiPoxKh9NlBFa/aauW4COt/LWh21/ZX1taJDc6dZPptiYyyrFaSNEzQr&#xA;GDwpW3jptUU274qmWKsd0nRtO1fyZottfxetCtnbOq8mWjegFr8JHZjlGfTwyipix+O5uwaieKXF&#xA;A0fh+lGaR5W0XSbae3s4WC3KhLlnd3aQKCBWp22Y9KYcWnhjsx6tuq1uXOQZm65bAIJPy78nRyaN&#xA;Imn0bQIILXSx6s3FIbWn1dZF58Z/RI5RmUMVb4hRt8ucRVt7ryXod9qQS+s7K81C5+ualHJcqHa4&#xA;MMcPMpI/wfuoUFAANq9ScVWfl66P5K0d0YMjW6lWBqCCSQQRiqfyIskbRsKq4KkHuCKYCLCvPtN/&#xA;LG8tdWiuJLm3a1hmhn5Kjes/pH7FeiAjrQ75qNP2bPHQ4hQPc9Fk7cEsRjUuLhMee2/X3/cmGv8A&#xA;5cLquqa1qS6h9XudSj0g2RMIkFtdaJdTXcEx+NfUVpJVDJ8OwI5fFtuHnXab+XC2beXJm1D1brRd&#xA;S1DV72UQhRd3OpxXSz0XmfSUSXpZd3oqhd/tYqzPFUn83/8AKOXv+qv/ABNcVSnV/wC4tf8AmPsP&#xA;+o2HFLjqM2nfl1pd5HK8PpWdkJJI+BYI6IhIDq4P2vDMXWSlHGTE18v0guRpMfHkEeHivbr+ghJv&#xA;y71vWr3X5ory6nnje3kmlimYFUk9RByQDoD2Wg412zA0Op48xHEZek/o/Hxd72vpsMMIMREHiA9P&#xA;UUef697q2Zaz/wAdHQv+Y5/+oG5zcvMprirsVdirsVS268zeW7S4ktrrVbO3uYiqywS3ESOjMAyh&#xA;lZgQSrAivjirXlZHTyxpCOpV1srcMpFCCIlBBBxVM8VdirE7H/erVP8AmNl/UuKU08okHy5ZEGoK&#xA;tQ/7NsUJxirsVdirsVdiqT+b/wDlHL3/AFV/4muKpTq/9xa/8x9h/wBRsOKU38rxRy+U9HSRFdDY&#xA;21VYAj+5XscBiDsVEiOSY29lZ2y8baCOBdzSNFQb9egHWmCMAOQQFLUdMgv1hEjyRvbyerDLExR1&#xA;fg0ZIPukjDJKxPSob+4sY5ZdVvS7FwT6oHRyB0XwGKUX9Ruv+rpe/wDI0f8ANOKu+o3X/V0vf+Ro&#xA;/wCacVd9Ruv+rpe/8jR/zTiqFvLJLWCMiSSWS41LT5ZpZW5OzC6t4wSfZUUYqzbFDsVSG+1/VI9T&#xA;uLKysYJ0t1jLyzXLwkmQE0CrBNsKda4qgdOhu0FzLdpHHNczvOY4naRVDUAHNkjJ6fy4pX+WPLPl&#xA;yfQrWabSrOWVw5eR7eJmYl23JK1OKE0/wn5V/wCrNY/9I0P/ADTiqE1Pyb5SvLC5sRptjA91E8Ky&#xA;rbw8lMiMAyig3HUfLBxBNFF/VvNP/Vxsf+kGb/srwod9W80/9XGx/wCkGb/srxV31bzT/wBXGx/6&#xA;QZv+yvFUq8023mT9AXfrX9m0VF5qlnKjU5r0Y3Lgf8CcVU9X/uLX/mPsP+o2HFKc+U/+UW0b/mBt&#xA;v+TK4oTXFUkTzloUiK8bXUkbgMkiWV4ysDuCrCEgg9iMVSrQeX6KgLI8Zbm3CRWjcBnJHJHAZdj0&#xA;IxSmGKuxV2Koa/tXubcJG4jlSWGeJ2XmoeCVZV5KCpI5IKio274qq6X5wi+qFdUjuFvo5ZopfRsL&#xA;302EczojpRJRR0UNs564oRf+L9F8Lz/pAvf+qOKpVbXcd7rGo3UKTLA/oqjTQywFiqb0WVUY0r1p&#xA;ilHYqifKX/KO2f8Aqt/xNsUJpOHMMgQ8XKkKfA02wS5K8f8ALen+YbXXLSNbGeNVuYZJDLbP8CsC&#xA;jO8gCvTdqDlTx2Gc5pYzuJlGQPEOh8x3cqPuet1EdOcJkTHj4DfCY2TYP6BZ3td5u8r6kPMPnm4s&#xA;9OuZdP1KLyzNfrFHJIb22t765bUoIevqP9U+Fo1qSpC0+IZ0jyTvL/lbUY738vL5tNuIo7HWdca3&#xA;R45Vay0m5g1BrGOZD/cj03hQBgpX4U6imKvYcVSjzb/yjt5/qr/xNcVSjV/7i1/5j7D/AKjYcUpz&#xA;5T/5RbRv+YG2/wCTK4oTXFWG+Wv+Ud0r/mDt/wDk0uKUyxV2KuxVD314LS39b0nmZpIokij482ea&#xA;RYkA5si/acdTiq31ta/6sV5/yMsv+ynFXetrX/VivP8AkZZf9lOKu9bWv+rFef8AIyy/7KcVd62t&#xA;f9WK8/5GWX/ZTirvW1r/AKsV5/yMsv8AspxVS0rXNT0iw0/Trvy9qH1iZ3giKSaeVZ+Mk1AfrYp+&#xA;7jY74oTC78031pazXdx5d1KO3t0aWZ+enniiAsxot2SaAdsVRX6Z1H/qxX3/AAdj/wBlOKu/TOo/&#xA;9WK+/wCDsf8AspxV36Z1H/qxX3/B2P8A2U4q79M6j/1Yr7/g7H/spxVL9fvNYvtIuLWDQb0yyhQv&#xA;KSxA2cE1P1nwGKoO4h1y8a2h/Q11Aou7SV5pZLPgqQ3Mcrk8J3b7KHopxSnnlP8A5RbRv+YG2/5M&#xA;rihNcVYb5a/5R3Sv+YO3/wCTS4pTLFXYq7FUDq/9za/8x1h/1Gw4qy7FDGrP8wNCvLpLaFZizypA&#xA;rEIB6jsFApz5e9aUpmCO0MZIFHeh83Oydn5YbyG1WD0Iq9kPqv5l6HpWpa1p99bXkUui29pdO/pK&#xA;VuRfzNb26WtH5O7zp6fxBRy75nOCo2n5paPPfadYSadqFteX+ozaNNFLHCRaXsNubr0rl45ZI/jh&#xA;HNDEzgjFWZ4qlGuf8dPy9/20JP8AqAusVXebP+UW1n/mBuf+TLYqmuKuxV2KuxV2KuxVKvKf/KLa&#xA;N/zA23/JlcVTXFWF6At3bWiaVeQiG602GCGQq4dG/dgBlIp4dxilNMVdirsVQOr/ANza/wDMdYf9&#xA;RsOKsuxQ84j/ACquk1DmLyH6pyRweDGakbEiMGuwI6mvbNNj7NnDYSFXf7HosfbcY4hARlYFc/Ib&#xA;nbmmnmn8t49f1TVNQa/NvJf2GnWluoiD+jPpd9Lfwzmrj1AZZFrHQbL1323LzqjZ/lrMk1je3mqL&#xA;PqUWvt5j1CaK3MUU8zWEmnrDFE0sphRYmTcu5+H/ACqhVnOKpRrn/HT8vf8AbQk/6gLrFV3mz/lF&#xA;tZ/5gbn/AJMtiqa4q7FXYq7FXYq7FUq8p/8AKLaN/wAwNt/yZXFU1xVjEn/KRap/q2//ABA4pV8V&#xA;dirsVS3XmnWygaBFkmF9YemjsUUn67DTkwVyB78Tiqe/WfNP/Vusf+k6b/skxQ76z5p/6t1j/wBJ&#xA;03/ZJirvrPmn/q3WP/SdN/2SYq76z5p/6t1j/wBJ03/ZJirvrPmn/q3WP/SdN/2SYql2oTa22s+X&#xA;lvbS2hhN/JR4LmSZuX1C6pVWghFPfl9GKpj5s/5RbWf+YG5/5Mtiqa4q7FXYq7FXYq7FUq8p/wDK&#xA;LaN/zA23/JlcVTXFWMSf8pFqn+rb/wDEDilXxV2KuxVA6v8A3Nr/AMx1h/1Gw4qy7FDArH80Uub1&#xA;IJLZII2ljQszsT6bsAZieIRVoehauaqHaJkRQ2sD9fydzLsefDxxPFEgkVz5XVfq8u/Z+v8A5nS6&#xA;JrGu6ddaQzDS7XTrnT5UnUm7fVLt7GGMrw/cj6wnEsWbbembV0yjafmhqL6pp2mXehrDPNrU3l7V&#xA;JIrv1Yre6SyN/E0JMMbzpJDTcrHx74q9AxVKNc/46fl7/toSf9QF1iq7zZ/yi2s/8wNz/wAmWxVN&#xA;cVdirsVdirsVdiqVeU/+UW0b/mBtv+TK4qmuKsYk/wCUi1T/AFbf/iBxSr4q7FXYqgdX/ubX/mOs&#xA;P+o2HFWXYoYkv5aaCt59Y9a5Keosv1csnpF0JKniE7cjTNdHszGOsud9P1O2j2xljj4AI1Vdbru5&#xA;+Svr35faHrl9qN7eSXAn1KytLFzG6qIhYXMl3bzRVUkSpPNyq1R8K7da7F1KlZ/lxo9v9Rkku7u7&#xA;vLPVm12W9maES3N69rJZ8pxHFHHxEMvELGiU4r71VZXiqUa5/wAdPy9/20JP+oC6xVd5s/5RbWf+&#xA;YG5/5Mtiqa4q7FXYq7FXYq7FXnXlryz5cby5pTNpVmzNZ25ZjbxEkmJdz8OKUXpflfT38zzS2B/R&#xA;MlhawtG1jDaoWNy8yyczJDISKQrQYoR7aD5lttUu7iCWHUoblYqSXkwglVowVI429qUK9Kd8VVfq&#xA;Xmv/AJY7D/pMm/7JcUqVjc3ckt5b3cMcNxZzCFxFI0qHlDHMCGZIj0lp9nFUXiqXa8JzZwCBlSY3&#xA;tgI3dS6hvrkNCyhkJA8OQxVPPq3mn/q42P8A0gzf9leKHfVvNP8A1cbH/pBm/wCyvFXfVvNP/Vxs&#xA;f+kGb/srxV31bzT/ANXGx/6QZv8AsrxV31bzT/1cbH/pBm/7K8VS+/i1tNZ8vm9uraeE30gCw28k&#xA;LBvqF1Q8mnmBHtT6cVTDzZ/yi2s/8wNz/wAmWxVNcVdirsVdirsVdirDPLH/ACjWk/8AMHb/APJp&#xA;cUpjoX/KRan/AMwdl/ydusUIXVvzT8maVrF3o93NetqFj6Yu4rbTNRu1QyxiVKyW1vLGaowOzfji&#xA;rJrK8hvbOC8g5+hcxpNF6kbxPwkUMvKOQJIjUO6soI6EVxVjcP8Ax2td/wCYyP8A6grbFKKxVA6v&#xA;/c2v/MdYf9RsOKsuxQ85sPzQu5rtEuIoY4DNGjlY5DxjkYfGX5nelfh49c0+PtGcqIAqwD+l3h7H&#xA;uInA3GUSQNgeV/EeY7wt81fmL5j0HXvMGnm2s5obWz0ifRjSUN6urag+nD603KjIkqh6IoPHatc3&#xA;Do1G0/MLzeut6dpd3Hp8qp5jm8t6tcRRTxmU/o06jBPbRtLJ6Xw0V1d336Yq9OxVKNc/46fl7/to&#xA;Sf8AUBdYqu82f8otrP8AzA3P/JlsVTXFXYq7FXYq7FXYqwzyx/yjWk/8wdv/AMmlxSmOhf8AKRan&#xA;/wAwdl/ydusUMT83xfmSvme9k09dXFhJ6Q0d9C/QgiPGEchqB1MetX1TJTh8PDjT4q4q9C0b9K/o&#xA;ex/S/pfpb6vF+kfq9fR+scB63pct+HOvGvbFUhh/47Wu/wDMZH/1BW2KUViqB1f+5tf+Y6w/6jYc&#xA;VZdihjS/l75bW++uBJeXJZPS9RhH6iksr8R3FT3pmBHs7ELq9zfPq7IdrZxDgscPLkOXcjdU8n+W&#xA;9UuL64v7ITzalaRWF45eQc7e3kkmiUBWAQpJM7B1o1e+wpnutUbPyN5Xs4bGKG0YjTr1tTtpZZ55&#xA;pTeyRSQtPLLLI8kzmOZ1/es34CiqfYqlGuf8dPy9/wBtCT/qAusVXebP+UW1n/mBuf8Aky2Kprir&#xA;sVdirsVdirsVee+Wdd0seW9KHqttZ2/SOQ/7qXwXFKeeWLiK51zU54eRh+rWaCQoygsslySByArQ&#xA;MPvxQx3zXo3lRfMV9fav5l123luTDTTrLUtQtYIOMQUmOK2kRAHChm2+0a98xp6vHGRiT6g5mn7P&#xA;zZvoDPNG+qfomzFnLJParDGsE07vLK6KoCtJJKWkdiBUsxqTucux5BOIkORcbJjMJGMuYSGH/jta&#xA;7/zGR/8AUFbZNiisVS7Xo3ks4EjkaF2vbACVOJZa3kPxLyDLUdqgjFU8/Q2o/wDV9vv+Asf+ybFD&#xA;v0NqP/V9vv8AgLH/ALJsVd+htR/6vt9/wFj/ANk2Ku/Q2o/9X2+/4Cx/7JsVd+htR/6vt9/wFj/2&#xA;TYql+oafeW+s+Xnl1K4vEN/IpinW3Cj/AEC6PIejDE1du5piqYebP+UW1n/mBuf+TLYqmuKuxV2K&#xA;uxV2KuxVKvKf/KLaN/zA23/JlcVTXFWCebPJWv6prLXdlcxx2zMrqpkZGV/TWNm2Rtiq0zV6vS5Z&#xA;yJgQL7yXb6DtDHp4EcHFOR8vh+u/gyry9pZ0vRbTT2PJrdOLEEkciSTSvap2zO02MwxiMuYcDV5v&#xA;Fyyn/OKTQ/8AHa13/mMj/wCoK2y5oRWKoHV/7m1/5jrD/qNhxVl2KHlWn/mJ5gN6n1tmMAnhSREj&#xA;iHwO+44kBy5CkbHNDi1+SVG6AkAeXxelPY+OUBOB+qJNG9th1r7+93nXzj5t0LzF5mtbbUFe1TT9&#xA;En09Xgi42TalqcunzzVpyk9ONPV/eHjUeFc3zzSjZ+avOUWvaZYyay11Z23myfy9cySW9sJL22Ol&#xA;NfI8rxxoivDKpjPoqleO/cYq9bxVKNc/46fl7/toSf8AUBdYqu82f8otrP8AzA3P/JlsVTXFXYq7&#xA;FXYq7FXYqlXlP/lFtG/5gbb/AJMriqa4q07oiM7sFRQSzE0AA6knFUN+ltK/5bIP+Rqf1xVjlpND&#xA;Nq+uSQuskZvI6OhDDaytu4xSjcVQOr/3Nr/zHWH/AFGw4qy7FCUDyl5bF59d/R8X1nrzoaVrWvGv&#xA;Gte9K5jDRYv5o73L/P5+Hh45cPvRlxo+k3MlxJc2VvPJdwC1u3kiRzLbqWKwyFgecYMrkKdviPic&#xA;yXEUrTy55es7WztLPS7S2tdPkM1hbwwRRx28pVkMkKKoWNisjiq0NGPicVTDFUo1z/jp+Xv+2hJ/&#xA;1AXWKrvNn/KLaz/zA3P/ACZbFU1xV2KuxV2KuxV2KpV5T/5RbRv+YG2/5Mriqa4qlPm8A+UtbBFQ&#xA;bC6BB/4wtiqWfo3Tv+WWH/kWv9MUq0UMMK8Io1jWteKAKK/IYqvxVLdehWezghYsqve2CsUZkahv&#xA;Ya0dCrKfcHFU9/w1p3+/r7/uIX3/AFWxQ7/DWnf7+vv+4hff9VsVd/hrTv8Af19/3EL7/qtirv8A&#xA;DWnf7+vv+4hff9VsVd/hrTv9/X3/AHEL7/qtiqXaho9rZ6z5elhluWb6/IpE11czrQ2F1+zNI6g+&#xA;9K4qmPmz/lFtZ/5gbn/ky2KprirsVdirsVdirsVSryn/AMoto3/MDbf8mVxVNcVUb2zt72zns7le&#xA;dvcxvDMgJWqSKVYclIYVB6g4qxbSo/Ra+t1eR44LuWOL1ZHlYKKEDnIWY9e5xSj8VdiqB1f+5tf+&#xA;Y6w/6jYcVZdih4/Yec/Maamgu55JeM8KGH1OLFOfxRCMDdvhoWP09c5zFrJy3MuUgD8D+n8c3rD2&#xA;VinjGSIMTKBJsbch57e7fqi/OvnHzboXmLzNa22oK9qmn6JPp6vBFxsm1LU5dPnmrTlJ6caer+8P&#xA;Go8K50byajZ+avOUWvaZYyay11Z23myfy9cySW9sJL22OlNfI8rxxoivDKpjPoqleO/cYq9bxVKN&#xA;c/46fl7/ALaEn/UBdYqu82f8otrP/MDc/wDJlsVTXFXYq7FXYq7FXYqlXlP/AJRbRv8AmBtv+TK4&#xA;qmuKuxVidj/vVqn/ADGy/qXFKMxV2KoHV/7m1/5jrD/qNhxVl2KEINH0kT/WBZW4uOnrCJOf/BUr&#xA;lXgw/mj5Nvj5KriNe91xo+k3MlxJc2VvPJdwC1u3kiRzLbqWKwyFgecYMrkKdviPictalK08ueXr&#xA;O1s7Sz0u0trXT5DNYW8MEUcdvKVZDJCiqFjYrI4qtDRj4nFUwxVKNc/46fl7/toSf9QF1iq7zZ/y&#xA;i2s/8wNz/wAmWxVNcVdirsVdirsVdirFvKvlywfyxo7vNe82srYtxvr1BUxLWirMAB7DFU0/w1p3&#xA;+/r7/uIX3/VbFXf4a07/AH9ff9xC+/6rYqkWjWq202qRI7vGL6Xh6rvIwHFNi8hZm333OKUyxV2K&#xA;oe+sxd2/peq8JWSKVJY+PJXhkWVCOauv2kHUYqt9LWv+r5ef8i7L/smxV3pa1/1fLz/kXZf9k2Ku&#xA;9LWv+r5ef8i7L/smxV3pa1/1fLz/AJF2X/ZNirvS1r/q+Xn/ACLsv+ybFVukaJqOq6Ro2pXmvX7X&#xA;QhivEKpYqqzS25RiALXpxmYUOKEde+W7q4sri3u/MF+1rNG8dwCtgoMbKQ4LC1BHwnrXATW5SBew&#xA;XpZyvMYE8y3TTKaGIfo8sDStOP1avbI+JG6sWoBItW/Q2o/9X2+/4Cx/7Jsmh36G1H/q+33/AAFj&#xA;/wBk2Ku/Q2o/9X2+/wCAsf8AsmxVL9fs9YsdIuLqDXr0SxBSvKOxI3cA1H1bwOKoS4m1u0a2m/TN&#xA;zOpu7SJ4ZY7TgyTXMcTg8IEb7LnowxSnflP/AJRbRv8AmBtv+TK4oTXFXYqxOx/3q1T/AJjZf1Li&#xA;lGYq7FXYqp3Fxb28LTXEqQwpu8kjBVHbcmgGKoC11WbVL2e20P6nfC1jikuJWuiij1mkVVX0op6n&#xA;90Sa07YqjPqXmz/lisP+k2b/ALJMVW6deC90+1vAvAXMMcwStePqKGpX2riqJxVF+Uv+UV0b/mBt&#xA;v+TK4oRWrwyz6TewQmk0sEqRnr8TIQPxyvMCYSA7iygakCHmPk/RvMtnrtmv1S5hgt52aQzRcYli&#xA;dOLUanxsakDei/Tmj0eLIJQMom73+6/k9V2hn02TFKVx4zHpzu+vT7N90t1jyrcWuseYeekXM/la&#xA;bzZY32rWSW810t5ZNo8YmdYFWR7mMX7I0iorbqdjxIzoHk0V5C8q6tY+Y/Jmo3Gn3MLJpvmCCeWV&#xA;ZKwWb6hBLpdtNyqImW2eiod9iP2cVew4qlHm3/lHbz/VX/ia4qlGr/3Nr/zHWH/UbDilB65d3Fr+&#xA;UlpLbajc6Vcmz06K3u7KFLi59WV4Y44YYpAyM87OIlr05VxQg/y9vL1fMMllql95oS9ltJJrbTfM&#xA;a6X6UkUUsSyzwvp0f2omlRSGk6P9k7EKvRsVYNbazp0V7qivIa/XpxUI7CqkI1CFI2ZSPnilE/p7&#xA;S/8Afrf8i5P+acVd+ntL/wB+t/yLk/5pxV36e0v/AH63/IuT/mnFUJqOsafOtnFFIxdr+w4gpIP+&#xA;PyE9SoGKs7xQ7FWLWHlbzBZWNvZx6raMltEkKM1lJUiNQoJpde2KrdJvGvdLs71lCNdQRzMg3AMi&#xA;BiB9+KUZ5U1PTU8r6Oj3cKutjbBlMiAgiFagiuKE1/S2lf8ALZB/yNT+uKoXVPMWmWOmXd6txDM1&#xA;rDJMsIlQFzGhbjX4qVpTpiqz615u/wCrbp//AEnzf9keKu+tebv+rZp//SfN/wBkeKu+tebv+rZp&#xA;/wD0nzf9keKpV5oufNB0G69bT7FIqJzZL2V2A5r0U2iAn/ZDFVur/wBza/8AMdYf9RsOKVHUbW8u&#xA;/wAqLa2s9Ih124m0+yRdLuZTBFICIuRMoV2QxrWRSorVRTfFCC/LryZrOh6tcXWoaRp1qssBiW+g&#xA;1fU9Xuqh1Pog6jCvpxGhZuD/AGgPhPUKsm1Wxsr7zFp1te28d1b/AFS8k9GZFkTmstqFbiwIqA5A&#xA;PucVTWzsrOyt1trOCO2t0JKQwosaAsxZqKoAFWJJ98VVsVdirsVSrzL/AMc6H/mO0/8A6jocVTXF&#xA;XYq7FWGeWP8AlG9J/wCYO3/5NLilNPKel6Y3lbRma0gLGxtiSY0qT6K+2KE1/ROlf8scH/IpP6Yq&#xA;4aVpYNRZwAj/AIrT+mKorFXYq7FUn83/APKOXv8Aqr/xNcVSnV/7m1/5jrD/AKjYcUttJPH+W2ny&#xA;QRvLItlZExRmQM68Yw6j0ir7pXvmLrL8M1+kfdRb9LHiyAbbnrVV1+qxy/Zuxz8tLfV/8QS3MyOs&#xA;UkMpuZpBIfUcyKftNt6laV9vfNZ2fIyzE1L6Tub7w7/tfPhlgEYS4iJD+bsKPd0+TO7n/lKdO/5g&#xA;b7/k9aZvXmETqur6dpVr9b1CYQW4YKXIZtz0FFBOV5MsYC5NuLDPIagLNWho/NGivaXd2JmEFjH6&#xA;10WikDKnxb+mV5mvA0AWpyGLUQyEiJ5InilEAnqlcn5oeRY7TTLxtTra6tbpeWcywXDKLaVlRJ5+&#xA;MZ+rxF3C85uC12rXL2tNdF8z6Hrc+owaZc+vLpNybPUF9OSP05wivx/eKvIcXB5LUe+KteZf+OdD&#xA;/wAx2n/9R0OKprirsVdirE9N8u+ZbHTrWyE1lILWGOEOVlHL01C1pXvTFKa+TzXyloh8bC1P/JFc&#xA;UJszKqlmIVVFWY7AAdzgJpIFqa3lo0xgWeNpgaGIMpYGlaca17YOON1e6gEiwq5JDsVdiqT+b/8A&#xA;lHL3/VX/AImuKpTq/wDc2v8AzHWH/UbDilOfKf8Ayi2jf8wNt/yZXFCa4qlVz/ylOnf8wN9/yetM&#xA;VUPOOg3Ot6SLS2ZFmWVZAZSQlArKQeKsejZha/Tyy4+GFcV3u5eizRxZROV0O7+0JR5C8oatolxN&#xA;PeOiRywrELaKRmBdTvI4IALGm2+wNMjpNPOEiZVRH46Ow7W7RxZwBAG+K7IHy5/2sMX8mvNUXle1&#xA;0OK5sX+veWrTyxrkzSTL6C2ssrm4tAIW9YlbmReMnp9FNeozPdI9F8u+XbzTfMfmrU55I2g1y9t7&#xA;q0RCxdUh0+3tWElQAGMkDEUJ2p32CqM8y/8AHOh/5jtP/wCo6HFWHefte1nTvMdtHBcNFZtHExj9&#xA;Vo4yebVdmTcAUow8PozS6zUyjnELoEA/a7/svQ49RhlxA8QuiOfLlz38u4oTXtV1a58l+VNTS9u7&#xA;W4XzBpME5hmZBcRS6lFbyLNx4l43RiOJ2PeubDRT4sQN35uu7RwDFnlEH9CU6FqWvaj5p1ywk1W9&#xA;F29vrw120juJAunm3vo49GNupqsDTWZdlKKpkFX3IzKcF6F+WV3dXn5beU7y8mkubu50bT5ri4mY&#xA;vJJI9rGzu7sSzMzGpJ64qjvJ3/KI6H/2z7X/AJMriqM1eCWfSr2CE0mlglSM9aMyEDp75XmiTCQH&#xA;UFlAkSBDzHyfo/mSz12zX6pcww287GUzRcYlidOLUbYux5EDei/Tmj0ePIJQMonivf7req7Qz6bJ&#xA;jlK48Uo9OZN9en2b7pbrHlW4tdY8w89IuZ/K03myxvtWskt5rpbyybR4xM6wKsj3MYv2RpFRW3U7&#xA;HiRnQPJoryF5V1ax8x+TNRuNPuYWTTfMEE8sqyVgs31CCXS7ablURMts9FQ77Efs4q9hxVJ/N/8A&#xA;yjl7/qr/AMTXFUp1f+5tf+Y6w/6jYcUqPlfzHqi+WdIVdIZlFlbhWM8akj0l3p2xQmf+JNW/6s7f&#xA;9JEf9MVQTeYZ18xWdzf6fPbW0dpdx+rEr3fxyS2zKpFujlaiNuuKpr/i/RfC8/6QL3/qjirv8X6L&#xA;4Xn/AEgXv/VHFUbpusWGpLKbRnJhYLKksUsLqSKj4JVRtx3piqMxVKvMv/HOh/5jtP8A+o6HFUfc&#xA;2NldAC5t45wCCBIivuNx9oHIyhE8wyjOUeRpVVVRQqgKo6ACgwgUgm28KHYqlHk7/lEdD/7Z9r/y&#xA;ZXFU3xV2KuxV2KuxVJ/N/wDyjl7/AKq/8TXFUp1f+5tf+Y6w/wCo2HFKl5Y/5RrSf+YO3/5NLiqZ&#xA;4q7FXYq7FW/Ln/HU1b/Wg/5NnFCf4qlXmX/jnQ/8x2n/APUdDiqa4q7FXYq7FUo8nf8AKI6H/wBs&#xA;+1/5Mriqb4q7FXYq7FXYqk/m/wD5Ry9/1V/4muKpTq/9za/8x1h/1Gw4pTZfJvlBFCJoenqqgBVF&#xA;rCAAOgA44ob/AMH+Uv8AqyWH/SLD/wA04q7/AAf5S/6slh/0iw/804q7/B/lL/qyWH/SLD/zTirv&#xA;8H+Uv+rJYf8ASLD/AM04q2vlDympJXRLAE9SLWHt/scVb/wn5W/6s1j/ANI0P/NOKuPlLyoRQ6LY&#xA;Edd7aHqNx+zirzzy7P8AluPL+mCWTRxL9Vh9TkbXlz9McuVd6164pTAz/lkQQZNFIPWptKUxVMfJ&#xA;vl/yfdpqsltpun3Fqt6Ft2jggeML9VgLBCFK05lq071xQyL/AAn5W/6s1j/0jQ/804q0vlHyoqhV&#xA;0WwVVFFUWsIAA7D4cVb/AMJ+Vv8AqzWP/SND/wA04q7/AAn5W/6s1j/0jQ/804q7/Cflb/qzWP8A&#xA;0jQ/804q7/Cflb/qzWP/AEjQ/wDNOKu/wn5W/wCrNY/9I0P/ADTiqybyd5SljMb6NZcTT7NvGp2N&#xA;RQqoIxVfD5V8vwzRzR2SCSJleMks1GU1VqEkVBFRir//2Q==\n</xmpGImg:image></rdf:li></rdf:Alt></xmp:Thumbnails></rdf:Description><rdf:Description rdf:about=\"\" \nxmlns:xmpTPg=\"http://ns.adobe.com/xap/1.0/t/pg/\" xmlns:stDim=\"http://ns.adobe.com/xap/1.0/sType/Dimensions#\" \nxmlns:stFnt=\"http://ns.adobe.com/xap/1.0/sType/Font#\" xmlns:xmpG=\"http://ns.adobe.com/xap/1.0/g/\"><xmpTPg:MaxPageSize \nrdf:parseType=\"Resource\"><stDim:w>1000.000000</stDim:w><stDim:h>1564.000000</stDim:h><stDim:unit>Pixels</stDim:unit>\n</xmpTPg:MaxPageSize><xmpTPg:NPages>1</xmpTPg:NPages><xmpTPg:HasVisibleTransparency>False\n</xmpTPg:HasVisibleTransparency><xmpTPg:HasVisibleOverprint>False</xmpTPg:HasVisibleOverprint><xmpTPg:Fonts><rdf:Bag>\n<rdf:li rdf:parseType=\"Resource\"><stFnt:fontName>MyriadPro-Regular</stFnt:fontName><stFnt:fontFamily>Myriad Pro\n</stFnt:fontFamily><stFnt:fontFace>Regular</stFnt:fontFace><stFnt:fontType>Open Type</stFnt:fontType>\n<stFnt:versionString>Version 2.102;PS 2.000;hotconv 1.0.67;makeotf.lib2.5.33168</stFnt:versionString><stFnt:composite>\nFalse</stFnt:composite><stFnt:fontFileName>MyriadPro-Regular_0.otf</stFnt:fontFileName></rdf:li></rdf:Bag>\n</xmpTPg:Fonts><xmpTPg:PlateNames><rdf:Seq><rdf:li>Cyan</rdf:li><rdf:li>Magenta</rdf:li><rdf:li>Yellow</rdf:li><rdf:li>\nBlack</rdf:li></rdf:Seq></xmpTPg:PlateNames><xmpTPg:SwatchGroups><rdf:Seq><rdf:li rdf:parseType=\"Resource\">\n<xmpG:groupName>Default Swatch Group</xmpG:groupName><xmpG:groupType>0</xmpG:groupType></rdf:li></rdf:Seq>\n</xmpTPg:SwatchGroups></rdf:Description><rdf:Description rdf:about=\"\" xmlns:dc=\"http://purl.org/dc/elements/1.1/\">\n<dc:format>image/svg+xml</dc:format></rdf:Description></rdf:RDF></x:xmpmeta> <?xpacket end=\"w\"?> </metadata><rect x=\"101\" \ny=\"280\" fill=\"#E8E6E6\" stroke=\"#020202\" stroke-width=\"3\" stroke-miterlimit=\"10\" width=\"546\" height=\"1054\"/><path \nfill=\"#FFFFFF\" stroke=\"#020202\" stroke-width=\"3\" stroke-miterlimit=\"10\" \nd=\"M51,703.443l-0.15-553.11h131.085V334.7h9.7\n	v82.481H143.14v126.151l14.548-0.147v179.666h-35.946V708.3H55.85\"/><path \nfill=\"#E8E6E6\" stroke=\"#020202\" stroke-width=\"3\" stroke-miterlimit=\"10\" d=\"M51,698.593h72.742v179.519H51V698.593z\"/>\n<path fill=\"#FFFFFF\" stroke=\"#020202\" stroke-width=\"3\" stroke-miterlimit=\"10\" \nd=\"M51,1125.561V873.26h63.043V713.148h43.645v9.699\n	h87.29V970.3h-63.043v53.374h14.549v101.891H51V1125.561z\"/><path \nfill=\"#FFFFFF\" stroke=\"#020202\" stroke-width=\"3\" stroke-miterlimit=\"10\" \nd=\"M51,1416.67h126.086v-160.109h19.4V1115.85H51\n	V1416.67L51,1416.67z\"/><path fill=\"#E8E6E6\" stroke=\"#020202\" \nstroke-width=\"3\" stroke-miterlimit=\"10\" d=\"M298.172,1474.04v-62.229l-9.7-4.851H50.85v66.73\n	L298.172,1474.04z\"/><path \nfill=\"#FFFFFF\" stroke=\"#020202\" stroke-width=\"3\" stroke-miterlimit=\"10\" \nd=\"M414.71,1474.04v-236.89H194.484v9.699h-27.1\n	v169.82h126.089v57.37H414.71L414.71,1474.04z\"/><path fill=\"#FFFFFF\" \nstroke=\"#020202\" stroke-width=\"3\" stroke-miterlimit=\"10\" \nd=\"M405.011,1193.63h29.101v-14.56h72.74v38.819\n	H550.5v92.181h48.946v164.119H502V1513h-82.441v-38.811h-14.548V1193.63z\"/>\n<path fill=\"#E8E6E6\" stroke=\"#020202\" stroke-width=\"3\" stroke-miterlimit=\"10\" \nd=\"M904.505,101.815V457.7h43.646V101.815H904.505z\"/><path fill=\"#FFFFFF\" stroke=\"#020202\" stroke-width=\"3\" \nstroke-miterlimit=\"10\" d=\"M907.2,456.7H599.839V330.556h136.603v19.407\n	H907.2V456.7z\"/><path fill=\"#FFFFFF\" \nstroke=\"#020202\" stroke-width=\"3\" stroke-miterlimit=\"10\" d=\"M623.237,456v664.7h58.192V456H623.237z\"/><path \nfill=\"#FFFFFF\" stroke=\"#020202\" stroke-width=\"3\" stroke-miterlimit=\"10\" d=\"M358.215,456h266.721v140.7H358.215V456z\"/>\n<path id=\"Shape_8_copy\" fill=\"#FFFFFF\" stroke=\"#020202\" stroke-width=\"3\" stroke-miterlimit=\"10\" \nd=\"M358.215,587h266.721v140.7\n	H358.215V587z\"/><path id=\"Shape_8_copy_2\" fill=\"#FFFFFF\" stroke=\"#020202\" \nstroke-width=\"3\" stroke-miterlimit=\"10\" d=\"M358.215,718h266.721v140.7\n	H358.215V718z\"/><path id=\"Shape_8_copy_3\" \nfill=\"#FFFFFF\" stroke=\"#020202\" stroke-width=\"3\" stroke-miterlimit=\"10\" d=\"M358.215,849h266.721v140.7\n	H358.215V849z\"/>\n<path id=\"Shape_8_copy_4\" fill=\"#FFFFFF\" stroke=\"#020202\" stroke-width=\"3\" stroke-miterlimit=\"10\" \nd=\"M358.215,980h266.721v140.7\n	H358.215V980z\"/><path fill=\"#FFFFFF\" stroke=\"#020202\" stroke-width=\"3\" \nstroke-miterlimit=\"10\" d=\"M599.839,102.519h306.666v251.444h-177v-19.407\n	H599.839V102.519z\"/><path id=\"Shape_5_copy\" \nfill=\"#E8E6E6\" stroke=\"#020202\" stroke-width=\"3\" stroke-miterlimit=\"10\" \nd=\"M904.388,1475v-355.98h43.606\n	V1475H904.388z\"/><path id=\"Shape_6_copy\" fill=\"#FFFFFF\" stroke=\"#020202\" \nstroke-width=\"3\" stroke-miterlimit=\"10\" d=\"M907.084,1119.02H597V1245.2\n	h137.808v-19.42h172.276V1119.02z\"/><path \nid=\"Shape_4_copy\" fill=\"#FFFFFF\" stroke=\"#020202\" stroke-width=\"3\" stroke-miterlimit=\"10\" \nd=\"M597,1474.29h309.386v-251.51\n	H727.814v19.42H597V1474.29z\"/><path fill=\"#FFFFFF\" stroke=\"#020202\" stroke-width=\"3\" \nstroke-miterlimit=\"10\" \nd=\"M405.011,96.963v300.815l14.548,0.147v19.26\n	H521.4v-58.223h38.8v-72.778H599v-184.37h-82.452V63h-92.139v33.963h-19.4H405.011z\"/>\n<path fill=\"#FFFFFF\" stroke=\"#020202\" stroke-width=\"3\" stroke-miterlimit=\"10\" \nd=\"M172.237,150.333v194.074h208.525v-14.555h33.947\n	V96.963H303.172v53.37H172.237z\"/><rect x=\"50.844\" y=\"96.969\" \nfill=\"#E8E6E6\" stroke=\"#020202\" stroke-width=\"3\" stroke-miterlimit=\"10\" width=\"262.031\" height=\"63.063\"/><rect \nx=\"414.844\" y=\"62.635\" fill=\"#E8E6E6\" stroke=\"#020202\" stroke-width=\"3\" stroke-miterlimit=\"10\" width=\"102.03\" \nheight=\"39.396\"/><rect x=\"414.844\" y=\"1474.065\" fill=\"#E8E6E6\" stroke=\"#020202\" stroke-width=\"3\" \nstroke-miterlimit=\"10\" width=\"102.03\" height=\"39.395\"/><g \nng-class=\"(vm.floorPlan.room_1.room_status == \'clean\') ? \'cleanblock\' : ((vm.floorPlan.room_1.room_status == \'dirty\') ? \'dirtyblock\' : \'lightcleanblock\')\">\n<text transform=\"matrix(1 0 0 1 732.0781 267.6187)\" font-family=\"\'MyriadPro-Regular\'\" font-size=\"57\">\n{{ vm.floorPlan.room_1.room_num }}</text><path class=\"icon-clean\" fill=\"#46AD4B\" \nd=\"M695.789,244.209l-2.8,2.8l9,9l20-20l-2.8-2.8l-17.2,17.2L695.789,244.209z M719.989,248.009\n		c0,8.8-7.2,16-16,16s-16-7.2-16-16s7.2-16,16-16c1.6,0,3,0.2,4.4,0.6l3.199-3.2c-2.399-0.8-5-1.4-7.6-1.4c-11,0-20,9-20,20\n		s9,20,20,20s20-9,20-20H719.989z\"/>\n<g class=\"light-clean\"><polygon fill=\"#F58220\" \npoints=\"684.333,264.5 684.333,266.827 724.333,266.827 724.333,264.583 723.125,264.583 724.25,260.021 \n			721.667,260 720.125,264.583 717.667,264.583 719.333,259.667 716,259.667 714.333,264.5 711.938,264.5 713.333,260 709.833,260 \n			708.375,264.667 705.167,264.667 705.167,250 701.833,250 687.333,264.167 		\"/>\n<polygon fill=\"#F58220\" points=\"687.5,260.5 687.5,249.667 693.833,249.667 695,254.333 		\"/><polygon fill=\"#F58220\" \npoints=\"696,249.667 696.813,252.896 699.938,249.833 698.333,249.833 		\"/><rect x=\"684.5\" y=\"242.833\" fill=\"#F58220\" \nwidth=\"23.667\" height=\"4.833\"/><path fill=\"#F58220\" \nd=\"M686.833,240.833h18.334c0,0-3.5-7.333-8.667-7.333C696.5,233.5,691.999,232.833,686.833,240.833z\"/><path \nfill=\"#F58220\" \nd=\"M710.333,253.167v4.5h14.334v-4.667H721.5c0,0-0.499-3-4.333-3c0,0-3.604,0.02-4.167,3.145\n			L710.333,253.167z\"/><rect\n x=\"714.667\" y=\"226.667\" fill=\"#F58220\" width=\"5.333\" height=\"21\"/><circle fill=\"#F58220\" cx=\"685.75\" cy=\"235.584\" \nr=\"1.75\"/><circle fill=\"#F58220\" cx=\"689.333\" cy=\"232.001\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"686.167\" cy=\"228.501\" \nr=\"1.75\"/><circle fill=\"#F58220\" cx=\"706.332\" cy=\"235.584\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"702.749\" cy=\"232.001\" \nr=\"1.75\"/><circle fill=\"#F58220\" cx=\"705.915\" cy=\"228.501\" r=\"1.75\"/></g><path class=\"dirty\" fill=\"#FF555B\" \nd=\"M687.526,230.829c0.922-0.924,2.418-0.924,3.342,0l12.862,12.876l2.318-2.321\n		c0.772-0.773,2.024-0.773,2.797,0l1.395,1.396c3.375,0.805,6.75,1.61,10.126,2.416l5.394,1.287\n		c0.451,0.108,0.819,0.435,0.979,0.872c0.16,0.436,0.091,0.924-0.185,1.298c-5.969,8.122-13.109,15.269-21.222,21.244\n		c-0.242,0.178-0.53,0.27-0.821,0.27c-0.16,0-0.321-0.028-0.477-0.085c-0.436-0.16-0.763-0.528-0.87-0.98l-1.61-6.763\n		c-0.696-2.924-1.393-5.848-2.089-8.772l-1.394-1.396c-0.772-0.773-0.772-2.027,0-2.8l2.317-2.32l-12.862-12.876\n		C686.603,233.25,686.604,231.752,687.526,230.829z M705.368,266.4c1.125-0.867,2.229-1.76,3.313-2.674l-1.823-5.146l3.604,3.608\n		c1.298-1.148,2.563-2.332,3.797-3.548l-1.812-2.865l2.87,1.804c1.13-1.148,2.23-2.325,3.302-3.529l-3.619-3.622l5.172,1.837\n		c0.99-1.168,1.953-2.361,2.889-3.578l-12.33-2.942l-8.303,8.311L705.368,266.4z\"/>\n</g><g \nng-class=\"(vm.floorPlan.room_2.room_status == \'clean\') ? \'cleanblock\' : ((vm.floorPlan.room_2.room_status == \'dirty\') ? \'dirtyblock\' : \'lightcleanblock\')\">\n<text transform=\"matrix(1 0 0 1 732.0781 418.6187)\" font-family=\"\'MyriadPro-Regular\'\" font-size=\"57\">\n{{ vm.floorPlan.room_2.room_num }}</text><path class=\"icon-clean\" fill=\"#46AD4B\" \nd=\"M695.789,395.209l-2.8,2.8l9,9l20-20l-2.8-2.8l-17.2,17.2L695.789,395.209z M719.989,399.009\n		c0,8.8-7.2,16-16,16s-16-7.2-16-16s7.2-16,16-16c1.6,0,3,0.2,4.4,0.6l3.199-3.2c-2.399-0.8-5-1.4-7.6-1.4c-11,0-20,9-20,20\n		s9,20,20,20s20-9,20-20H719.989z\"/>\n<g class=\"light-clean\"><polygon fill=\"#F58220\" \npoints=\"684.333,415.5 684.333,417.827 724.333,417.827 724.333,415.583 723.125,415.583 724.25,411.021 \n			721.667,411 720.125,415.583 717.667,415.583 719.333,410.667 716,410.667 714.333,415.5 711.938,415.5 713.333,411 709.833,411 \n			708.375,415.667 705.167,415.667 705.167,401 701.833,401 687.333,415.167 		\"/>\n<polygon fill=\"#F58220\" points=\"687.5,411.5 687.5,400.667 693.833,400.667 695,405.333 		\"/><polygon fill=\"#F58220\" \npoints=\"696,400.667 696.813,403.896 699.938,400.833 698.333,400.833 		\"/><rect x=\"684.5\" y=\"393.833\" fill=\"#F58220\" \nwidth=\"23.667\" height=\"4.833\"/><path fill=\"#F58220\" \nd=\"M686.833,391.833h18.334c0,0-3.5-7.333-8.667-7.333C696.5,384.5,691.999,383.833,686.833,391.833z\"/><path \nfill=\"#F58220\" \nd=\"M710.333,404.167v4.5h14.334v-4.667H721.5c0,0-0.499-3-4.333-3c0,0-3.604,0.02-4.167,3.145\n			L710.333,404.167z\"/><rect\n x=\"714.667\" y=\"377.667\" fill=\"#F58220\" width=\"5.333\" height=\"21\"/><circle fill=\"#F58220\" cx=\"685.75\" cy=\"386.584\" \nr=\"1.75\"/><circle fill=\"#F58220\" cx=\"689.333\" cy=\"383.001\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"686.167\" cy=\"379.501\" \nr=\"1.75\"/><circle fill=\"#F58220\" cx=\"706.332\" cy=\"386.584\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"702.749\" cy=\"383.001\" \nr=\"1.75\"/><circle fill=\"#F58220\" cx=\"705.915\" cy=\"379.501\" r=\"1.75\"/></g><path class=\"dirty\" fill=\"#FF555B\" \nd=\"M687.526,381.829c0.922-0.924,2.418-0.924,3.342,0l12.862,12.876l2.318-2.321\n		c0.772-0.773,2.024-0.773,2.797,0l1.395,1.396c3.375,0.805,6.75,1.61,10.126,2.416l5.394,1.287\n		c0.451,0.108,0.819,0.435,0.979,0.872c0.16,0.436,0.091,0.924-0.185,1.298c-5.969,8.122-13.109,15.269-21.222,21.244\n		c-0.242,0.178-0.53,0.27-0.821,0.27c-0.16,0-0.321-0.028-0.477-0.085c-0.436-0.16-0.763-0.528-0.87-0.98l-1.61-6.763\n		c-0.696-2.924-1.393-5.848-2.089-8.772l-1.394-1.396c-0.772-0.773-0.772-2.027,0-2.8l2.317-2.32l-12.862-12.876\n		C686.603,384.25,686.604,382.752,687.526,381.829z M705.368,417.4c1.125-0.867,2.229-1.76,3.313-2.674l-1.823-5.146l3.604,3.608\n		c1.298-1.148,2.563-2.332,3.797-3.548l-1.812-2.865l2.87,1.804c1.13-1.148,2.23-2.325,3.302-3.529l-3.619-3.622l5.172,1.837\n		c0.99-1.168,1.953-2.361,2.889-3.578l-12.33-2.942l-8.303,8.311L705.368,417.4z\"/>\n</g><g \nng-class=\"(vm.floorPlan.room_3.room_status == \'clean\') ? \'cleanblock\' : ((vm.floorPlan.room_3.room_status == \'dirty\') ? \'dirtyblock\' : \'lightcleanblock\')\">\n<text transform=\"matrix(1 0 0 1 462.0781 539.6187)\" font-family=\"\'MyriadPro-Regular\'\" font-size=\"57\">\n{{ vm.floorPlan.room_3.room_num }}</text><path class=\"icon-clean\" fill=\"#46AD4B\" \nd=\"M425.789,516.209l-2.8,2.8l9,9l20-20l-2.8-2.8l-17.2,17.2L425.789,516.209z M449.989,520.009\n		c0,8.8-7.2,16-16,16s-16-7.2-16-16s7.2-16,16-16c1.6,0,3,0.2,4.4,0.6l3.199-3.2c-2.399-0.8-5-1.4-7.6-1.4c-11,0-20,9-20,20\n		s9,20,20,20s20-9,20-20H449.989z\"/>\n<g class=\"light-clean\"><polygon fill=\"#F58220\" \npoints=\"414.333,536.5 414.333,538.827 454.333,538.827 454.333,536.583 453.125,536.583 454.25,532.021 \n			451.667,532 450.125,536.583 447.667,536.583 449.333,531.667 446,531.667 444.333,536.5 441.938,536.5 443.333,532 439.833,532 \n			438.375,536.667 435.167,536.667 435.167,522 431.833,522 417.333,536.167 		\"/>\n<polygon fill=\"#F58220\" points=\"417.5,532.5 417.5,521.667 423.833,521.667 425,526.333 		\"/><polygon fill=\"#F58220\" \npoints=\"426,521.667 426.813,524.896 429.938,521.833 428.333,521.833 		\"/><rect x=\"414.5\" y=\"514.833\" fill=\"#F58220\" \nwidth=\"23.667\" height=\"4.833\"/><path fill=\"#F58220\" \nd=\"M416.833,512.833h18.334c0,0-3.5-7.333-8.667-7.333C426.5,505.5,421.999,504.833,416.833,512.833z\"/><path \nfill=\"#F58220\" \nd=\"M440.333,525.167v4.5h14.334v-4.667H451.5c0,0-0.499-3-4.333-3c0,0-3.604,0.02-4.167,3.145\n			L440.333,525.167z\"/><rect\n x=\"444.667\" y=\"498.667\" fill=\"#F58220\" width=\"5.333\" height=\"21\"/><circle fill=\"#F58220\" cx=\"415.75\" cy=\"507.584\" \nr=\"1.75\"/><circle fill=\"#F58220\" cx=\"419.333\" cy=\"504.001\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"416.167\" cy=\"500.501\" \nr=\"1.75\"/><circle fill=\"#F58220\" cx=\"436.332\" cy=\"507.584\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"432.749\" cy=\"504.001\" \nr=\"1.75\"/><circle fill=\"#F58220\" cx=\"435.915\" cy=\"500.501\" r=\"1.75\"/></g><path class=\"dirty\" fill=\"#FF555B\" \nd=\"M417.526,502.829c0.922-0.924,2.418-0.924,3.342,0l12.862,12.876l2.318-2.321\n		c0.772-0.773,2.024-0.773,2.797,0l1.395,1.396c3.375,0.805,6.75,1.61,10.126,2.416l5.394,1.287\n		c0.451,0.108,0.819,0.435,0.979,0.872c0.16,0.436,0.091,0.924-0.185,1.298c-5.969,8.122-13.109,15.269-21.222,21.244\n		c-0.242,0.178-0.53,0.27-0.821,0.27c-0.16,0-0.321-0.028-0.477-0.085c-0.436-0.16-0.763-0.528-0.87-0.98l-1.61-6.763\n		c-0.696-2.924-1.393-5.848-2.089-8.772l-1.394-1.396c-0.772-0.773-0.772-2.027,0-2.8l2.317-2.32l-12.862-12.876\n		C416.603,505.25,416.604,503.752,417.526,502.829z M435.368,538.4c1.125-0.867,2.229-1.76,3.313-2.674l-1.823-5.146l3.604,3.608\n		c1.298-1.148,2.563-2.332,3.797-3.548l-1.812-2.865l2.87,1.804c1.13-1.148,2.23-2.325,3.302-3.529l-3.619-3.622l5.172,1.837\n		c0.99-1.168,1.953-2.361,2.889-3.578l-12.33-2.942l-8.303,8.311L435.368,538.4z\"/>\n</g><g \nng-class=\"(vm.floorPlan.room_4.room_status == \'clean\') ? \'cleanblock\' : ((vm.floorPlan.room_4.room_status == \'dirty\') ? \'dirtyblock\' : \'lightcleanblock\')\">\n<text transform=\"matrix(1 0 0 1 462.0781 667.6187)\" font-family=\"\'MyriadPro-Regular\'\" font-size=\"57\">\n{{ vm.floorPlan.room_4.room_num }}</text><path class=\"icon-clean\" fill=\"#46AD4B\" \nd=\"M425.789,644.209l-2.8,2.8l9,9l20-20l-2.8-2.8l-17.2,17.2L425.789,644.209z M449.989,648.009\n		c0,8.8-7.2,16-16,16s-16-7.2-16-16s7.2-16,16-16c1.6,0,3,0.2,4.4,0.6l3.199-3.2c-2.399-0.8-5-1.4-7.6-1.4c-11,0-20,9-20,20\n		s9,20,20,20s20-9,20-20H449.989z\"/>\n<g class=\"light-clean\"><polygon fill=\"#F58220\" \npoints=\"414.333,664.5 414.333,666.827 454.333,666.827 454.333,664.583 453.125,664.583 454.25,660.021 \n			451.667,660 450.125,664.583 447.667,664.583 449.333,659.667 446,659.667 444.333,664.5 441.938,664.5 443.333,660 439.833,660 \n			438.375,664.667 435.167,664.667 435.167,650 431.833,650 417.333,664.167 		\"/>\n<polygon fill=\"#F58220\" points=\"417.5,660.5 417.5,649.667 423.833,649.667 425,654.333 		\"/><polygon fill=\"#F58220\" \npoints=\"426,649.667 426.813,652.896 429.938,649.833 428.333,649.833 		\"/><rect x=\"414.5\" y=\"642.833\" fill=\"#F58220\" \nwidth=\"23.667\" height=\"4.833\"/><path fill=\"#F58220\" \nd=\"M416.833,640.833h18.334c0,0-3.5-7.333-8.667-7.333C426.5,633.5,421.999,632.833,416.833,640.833z\"/><path \nfill=\"#F58220\" \nd=\"M440.333,653.167v4.5h14.334v-4.667H451.5c0,0-0.499-3-4.333-3c0,0-3.604,0.02-4.167,3.145\n			L440.333,653.167z\"/><rect\n x=\"444.667\" y=\"626.667\" fill=\"#F58220\" width=\"5.333\" height=\"21\"/><circle fill=\"#F58220\" cx=\"415.75\" cy=\"635.584\" \nr=\"1.75\"/><circle fill=\"#F58220\" cx=\"419.333\" cy=\"632.001\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"416.167\" cy=\"628.501\" \nr=\"1.75\"/><circle fill=\"#F58220\" cx=\"436.332\" cy=\"635.584\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"432.749\" cy=\"632.001\" \nr=\"1.75\"/><circle fill=\"#F58220\" cx=\"435.915\" cy=\"628.501\" r=\"1.75\"/></g><path class=\"dirty\" fill=\"#FF555B\" \nd=\"M417.526,630.829c0.922-0.924,2.418-0.924,3.342,0l12.862,12.876l2.318-2.321\n		c0.772-0.773,2.024-0.773,2.797,0l1.395,1.396c3.375,0.805,6.75,1.61,10.126,2.416l5.394,1.287\n		c0.451,0.108,0.819,0.435,0.979,0.872c0.16,0.436,0.091,0.924-0.185,1.298c-5.969,8.122-13.109,15.269-21.222,21.244\n		c-0.242,0.178-0.53,0.27-0.821,0.27c-0.16,0-0.321-0.028-0.477-0.085c-0.436-0.16-0.763-0.528-0.87-0.98l-1.61-6.763\n		c-0.696-2.924-1.393-5.848-2.089-8.772l-1.394-1.396c-0.772-0.773-0.772-2.027,0-2.8l2.317-2.32l-12.862-12.876\n		C416.603,633.25,416.604,631.752,417.526,630.829z M435.368,666.4c1.125-0.867,2.229-1.76,3.313-2.674l-1.823-5.146l3.604,3.608\n		c1.298-1.148,2.563-2.332,3.797-3.548l-1.812-2.865l2.87,1.804c1.13-1.148,2.23-2.325,3.302-3.529l-3.619-3.622l5.172,1.837\n		c0.99-1.168,1.953-2.361,2.889-3.578l-12.33-2.942l-8.303,8.311L435.368,666.4z\"/>\n</g><g \nng-class=\"(vm.floorPlan.room_5.room_status == \'clean\') ? \'cleanblock\' : ((vm.floorPlan.room_5.room_status == \'dirty\') ? \'dirtyblock\' : \'lightcleanblock\')\">\n<text transform=\"matrix(1 0 0 1 462.0781 800.6191)\" font-family=\"\'MyriadPro-Regular\'\" font-size=\"57\">\n{{ vm.floorPlan.room_5.room_num }}</text><path class=\"icon-clean\" fill=\"#46AD4B\" \nd=\"M425.789,777.209l-2.8,2.8l9,9l20-20l-2.8-2.8l-17.2,17.199L425.789,777.209z M449.989,781.009\n		c0,8.8-7.2,16-16,16s-16-7.2-16-16s7.2-16,16-16c1.6,0,3,0.2,4.4,0.6l3.199-3.2c-2.399-0.8-5-1.4-7.6-1.4c-11,0-20,9-20,20\n		s9,20,20,20s20-9,20-20H449.989z\"/>\n<g class=\"light-clean\"><polygon fill=\"#F58220\" \npoints=\"414.333,797.5 414.333,799.827 454.333,799.827 454.333,797.584 453.125,797.584 454.25,793.021 \n			451.667,793 450.125,797.584 447.667,797.584 449.333,792.667 446,792.667 444.333,797.5 441.938,797.5 443.333,793 439.833,793 \n			438.375,797.667 435.167,797.667 435.167,783 431.833,783 417.333,797.167 		\"/>\n<polygon fill=\"#F58220\" points=\"417.5,793.5 417.5,782.667 423.833,782.667 425,787.334 		\"/><polygon fill=\"#F58220\" \npoints=\"426,782.667 426.813,785.896 429.938,782.834 428.333,782.834 		\"/><rect x=\"414.5\" y=\"775.833\" fill=\"#F58220\" \nwidth=\"23.667\" height=\"4.833\"/><path fill=\"#F58220\" \nd=\"M416.833,773.833h18.334c0,0-3.5-7.333-8.667-7.333C426.5,766.5,421.999,765.833,416.833,773.833z\"/><path \nfill=\"#F58220\" \nd=\"M440.333,786.168v4.5h14.334v-4.667H451.5c0,0-0.499-3-4.333-3c0,0-3.604,0.021-4.167,3.146\n			L440.333,786.168z\"/>\n<rect x=\"444.667\" y=\"759.667\" fill=\"#F58220\" width=\"5.333\" height=\"21\"/><circle fill=\"#F58220\" cx=\"415.75\" \ncy=\"768.584\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"419.333\" cy=\"765.001\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"416.167\" \ncy=\"761.501\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"436.332\" cy=\"768.584\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"432.749\" \ncy=\"765.001\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"435.915\" cy=\"761.501\" r=\"1.75\"/></g><path class=\"dirty\" \nfill=\"#FF555B\" \nd=\"M417.526,763.829c0.922-0.924,2.418-0.924,3.342,0l12.862,12.876l2.318-2.321\n		c0.772-0.773,2.024-0.773,2.797,0l1.395,1.396c3.375,0.805,6.75,1.61,10.126,2.416l5.394,1.287\n		c0.451,0.108,0.819,0.435,0.979,0.872c0.16,0.436,0.091,0.924-0.185,1.298c-5.969,8.122-13.109,15.269-21.222,21.244\n		c-0.242,0.178-0.53,0.27-0.821,0.27c-0.16,0-0.321-0.027-0.477-0.084c-0.436-0.16-0.763-0.528-0.87-0.98l-1.61-6.763\n		c-0.696-2.925-1.393-5.849-2.089-8.772l-1.394-1.396c-0.772-0.772-0.772-2.026,0-2.799l2.317-2.32l-12.862-12.876\n		C416.603,766.25,416.604,764.752,417.526,763.829z M435.368,799.4c1.125-0.867,2.229-1.76,3.313-2.674l-1.823-5.146l3.604,3.608\n		c1.298-1.148,2.563-2.332,3.797-3.549l-1.812-2.864l2.87,1.804c1.13-1.148,2.23-2.324,3.302-3.528l-3.619-3.622l5.172,1.837\n		c0.99-1.169,1.953-2.36,2.889-3.578l-12.33-2.942l-8.303,8.312L435.368,799.4z\"/>\n</g><g \nng-class=\"(vm.floorPlan.room_6.room_status == \'clean\') ? \'cleanblock\' : ((vm.floorPlan.room_6.room_status == \'dirty\') ? \'dirtyblock\' : \'lightcleanblock\')\">\n<text transform=\"matrix(1 0 0 1 462.0781 931.6191)\" font-family=\"\'MyriadPro-Regular\'\" font-size=\"57\">\n{{ vm.floorPlan.room_6.room_num }}</text><path class=\"icon-clean\" fill=\"#46AD4B\" \nd=\"M425.789,908.209l-2.8,2.8l9,9l20-20l-2.8-2.8l-17.2,17.199L425.789,908.209z M449.989,912.009\n		c0,8.8-7.2,16-16,16s-16-7.2-16-16s7.2-16,16-16c1.6,0,3,0.2,4.4,0.601l3.199-3.201c-2.399-0.799-5-1.399-7.6-1.399\n		c-11,0-20,9-20,20s9,20,20,20s20-9,20-20H449.989z\"/>\n<g class=\"light-clean\"><polygon fill=\"#F58220\" \npoints=\"414.333,928.5 414.333,930.827 454.333,930.827 454.333,928.584 453.125,928.584 454.25,924.021 \n			451.667,924 450.125,928.584 447.667,928.584 449.333,923.667 446,923.667 444.333,928.5 441.938,928.5 443.333,924 439.833,924 \n			438.375,928.667 435.167,928.667 435.167,914 431.833,914 417.333,928.167 		\"/>\n<polygon fill=\"#F58220\" points=\"417.5,924.5 417.5,913.667 423.833,913.667 425,918.334 		\"/><polygon fill=\"#F58220\" \npoints=\"426,913.667 426.813,916.896 429.938,913.834 428.333,913.834 		\"/><rect x=\"414.5\" y=\"906.834\" fill=\"#F58220\" \nwidth=\"23.667\" height=\"4.833\"/><path fill=\"#F58220\" \nd=\"M416.833,904.834h18.334c0,0-3.5-7.334-8.667-7.334C426.5,897.5,421.999,896.834,416.833,904.834z\"/><path \nfill=\"#F58220\" \nd=\"M440.333,917.168v4.5h14.334v-4.667H451.5c0,0-0.499-3-4.333-3c0,0-3.604,0.021-4.167,3.146\n			L440.333,917.168z\"/>\n<rect x=\"444.667\" y=\"890.668\" fill=\"#F58220\" width=\"5.333\" height=\"21\"/><circle fill=\"#F58220\" cx=\"415.75\" \ncy=\"899.584\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"419.333\" cy=\"896.001\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"416.167\" \ncy=\"892.501\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"436.332\" cy=\"899.584\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"432.749\" \ncy=\"896.001\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"435.915\" cy=\"892.501\" r=\"1.75\"/></g><path class=\"dirty\" \nfill=\"#FF555B\" \nd=\"M417.526,894.828c0.922-0.924,2.418-0.924,3.342,0.001l12.862,12.876l2.318-2.32\n		c0.772-0.773,2.024-0.773,2.797,0l1.395,1.396c3.375,0.806,6.75,1.61,10.126,2.416l5.394,1.287\n		c0.451,0.108,0.819,0.435,0.979,0.872c0.16,0.436,0.091,0.924-0.185,1.297c-5.969,8.122-13.109,15.27-21.222,21.244\n		c-0.242,0.178-0.53,0.27-0.821,0.27c-0.16,0-0.321-0.027-0.477-0.084c-0.436-0.16-0.763-0.528-0.87-0.98l-1.61-6.763\n		c-0.696-2.925-1.393-5.849-2.089-8.772l-1.394-1.396c-0.772-0.772-0.772-2.026,0-2.799l2.317-2.32l-12.862-12.877\n		C416.603,897.25,416.604,895.752,417.526,894.828z M435.368,930.4c1.125-0.867,2.229-1.76,3.313-2.674l-1.823-5.146l3.604,3.608\n		c1.298-1.148,2.563-2.332,3.797-3.549l-1.812-2.864l2.87,1.804c1.13-1.148,2.23-2.324,3.302-3.528l-3.619-3.622l5.172,1.837\n		c0.99-1.169,1.953-2.36,2.889-3.577l-12.33-2.942l-8.303,8.312L435.368,930.4z\"/>\n</g><g \nng-class=\"(vm.floorPlan.room_7.room_status == \'clean\') ? \'cleanblock\' : ((vm.floorPlan.room_7.room_status == \'dirty\') ? \'dirtyblock\' : \'lightcleanblock\')\">\n<text transform=\"matrix(1 0 0 1 462.0781 1063.6191)\" font-family=\"\'MyriadPro-Regular\'\" font-size=\"57\">\n{{ vm.floorPlan.room_7.room_num }}</text><path class=\"icon-clean\" fill=\"#46AD4B\" \nd=\"M425.789,1040.209l-2.8,2.8l9,9l20-20l-2.8-2.8l-17.2,17.199L425.789,1040.209z M449.989,1044.009\n		c0,8.8-7.2,16-16,16s-16-7.2-16-16s7.2-16,16-16c1.6,0,3,0.2,4.4,0.601l3.199-3.201c-2.399-0.799-5-1.399-7.6-1.399\n		c-11,0-20,9-20,20s9,20,20,20s20-9,20-20H449.989z\"/>\n<g class=\"light-clean\"><polygon fill=\"#F58220\" \npoints=\"414.333,1060.5 414.333,1062.827 454.333,1062.827 454.333,1060.584 453.125,1060.584 \n			454.25,1056.021 451.667,1056 450.125,1060.584 447.667,1060.584 449.333,1055.667 446,1055.667 444.333,1060.5 441.938,1060.5 \n			443.333,1056 439.833,1056 438.375,1060.667 435.167,1060.667 435.167,1046 431.833,1046 417.333,1060.167 		\"/>\n<polygon fill=\"#F58220\" points=\"417.5,1056.5 417.5,1045.667 423.833,1045.667 425,1050.334 		\"/><polygon fill=\"#F58220\" \npoints=\"426,1045.667 426.813,1048.896 429.938,1045.834 428.333,1045.834 		\"/><rect x=\"414.5\" y=\"1038.834\" \nfill=\"#F58220\" width=\"23.667\" height=\"4.833\"/><path fill=\"#F58220\" \nd=\"M416.833,1036.834h18.334c0,0-3.5-7.334-8.667-7.334C426.5,1029.5,421.999,1028.834,416.833,1036.834z\"/><path \nfill=\"#F58220\" \nd=\"M440.333,1049.168v4.5h14.334v-4.667H451.5c0,0-0.499-3-4.333-3c0,0-3.604,0.021-4.167,3.146\n			L440.333,1049.168z\"/>\n<rect x=\"444.667\" y=\"1022.668\" fill=\"#F58220\" width=\"5.333\" height=\"21\"/><circle fill=\"#F58220\" cx=\"415.75\" \ncy=\"1031.584\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"419.333\" cy=\"1028.001\" r=\"1.75\"/><circle fill=\"#F58220\" \ncx=\"416.167\" cy=\"1024.501\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"436.332\" cy=\"1031.584\" r=\"1.75\"/><circle \nfill=\"#F58220\" cx=\"432.749\" cy=\"1028.001\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"435.915\" cy=\"1024.501\" r=\"1.75\"/></g>\n<path class=\"dirty\" fill=\"#FF555B\" \nd=\"M417.526,1026.828c0.922-0.924,2.418-0.924,3.342,0.001l12.862,12.876l2.318-2.32\n		c0.772-0.773,2.024-0.773,2.797,0l1.395,1.396c3.375,0.806,6.75,1.61,10.126,2.416l5.394,1.287\n		c0.451,0.108,0.819,0.435,0.979,0.872c0.16,0.436,0.091,0.924-0.185,1.297c-5.969,8.122-13.109,15.27-21.222,21.244\n		c-0.242,0.178-0.53,0.27-0.821,0.27c-0.16,0-0.321-0.027-0.477-0.084c-0.436-0.16-0.763-0.528-0.87-0.98l-1.61-6.763\n		c-0.696-2.925-1.393-5.849-2.089-8.772l-1.394-1.396c-0.772-0.772-0.772-2.026,0-2.799l2.317-2.32l-12.862-12.877\n		C416.603,1029.25,416.604,1027.752,417.526,1026.828z M435.368,1062.4c1.125-0.867,2.229-1.76,3.313-2.674l-1.823-5.146\n		l3.604,3.608c1.298-1.148,2.563-2.332,3.797-3.549l-1.812-2.864l2.87,1.804c1.13-1.148,2.23-2.324,3.302-3.528l-3.619-3.622\n		l5.172,1.837c0.99-1.169,1.953-2.36,2.889-3.577l-12.33-2.942l-8.303,8.312L435.368,1062.4z\"/>\n</g><g \nng-class=\"(vm.floorPlan.room_8.room_status == \'clean\') ? \'cleanblock\' : ((vm.floorPlan.room_8.room_status == \'dirty\') ? \'dirtyblock\' : \'lightcleanblock\')\">\n<text transform=\"matrix(1 0 0 1 729.0781 1188.6191)\" font-family=\"\'MyriadPro-Regular\'\" font-size=\"57\">\n{{ vm.floorPlan.room_8.room_num }}</text><path class=\"icon-clean\" fill=\"#46AD4B\" \nd=\"M692.789,1165.209l-2.8,2.8l9,9l20-20l-2.8-2.8l-17.2,17.199L692.789,1165.209z M716.989,1169.009\n		c0,8.8-7.2,16-16,16s-16-7.2-16-16s7.2-16,16-16c1.6,0,3,0.2,4.4,0.601l3.199-3.201c-2.399-0.799-5-1.399-7.6-1.399\n		c-11,0-20,9-20,20s9,20,20,20s20-9,20-20H716.989z\"/>\n<g class=\"light-clean\"><polygon fill=\"#F58220\" \npoints=\"681.333,1185.5 681.333,1187.827 721.333,1187.827 721.333,1185.584 720.125,1185.584 \n			721.25,1181.021 718.667,1181 717.125,1185.584 714.667,1185.584 716.333,1180.667 713,1180.667 711.333,1185.5 708.938,1185.5 \n			710.333,1181 706.833,1181 705.375,1185.667 702.167,1185.667 702.167,1171 698.833,1171 684.333,1185.167 		\"/>\n<polygon fill=\"#F58220\" points=\"684.5,1181.5 684.5,1170.667 690.833,1170.667 692,1175.334 		\"/><polygon fill=\"#F58220\" \npoints=\"693,1170.667 693.813,1173.896 696.938,1170.834 695.333,1170.834 		\"/><rect x=\"681.5\" y=\"1163.834\" \nfill=\"#F58220\" width=\"23.667\" height=\"4.833\"/><path fill=\"#F58220\" \nd=\"M683.833,1161.834h18.334c0,0-3.5-7.334-8.667-7.334C693.5,1154.5,688.999,1153.834,683.833,1161.834z\"/><path \nfill=\"#F58220\" \nd=\"M707.333,1174.168v4.5h14.334v-4.667H718.5c0,0-0.499-3-4.333-3c0,0-3.604,0.021-4.167,3.146\n			L707.333,1174.168z\"/>\n<rect x=\"711.667\" y=\"1147.668\" fill=\"#F58220\" width=\"5.333\" height=\"21\"/><circle fill=\"#F58220\" cx=\"682.75\" \ncy=\"1156.584\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"686.333\" cy=\"1153.001\" r=\"1.75\"/><circle fill=\"#F58220\" \ncx=\"683.167\" cy=\"1149.501\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"703.332\" cy=\"1156.584\" r=\"1.75\"/><circle \nfill=\"#F58220\" cx=\"699.749\" cy=\"1153.001\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"702.915\" cy=\"1149.501\" r=\"1.75\"/></g>\n<path class=\"dirty\" fill=\"#FF555B\" \nd=\"M684.526,1151.828c0.922-0.924,2.418-0.924,3.342,0.001l12.862,12.876l2.318-2.32\n		c0.772-0.773,2.024-0.773,2.797,0l1.395,1.396c3.375,0.806,6.75,1.61,10.126,2.416l5.394,1.287\n		c0.451,0.108,0.819,0.435,0.979,0.872c0.16,0.436,0.091,0.924-0.185,1.297c-5.969,8.122-13.109,15.27-21.222,21.244\n		c-0.242,0.178-0.53,0.27-0.821,0.27c-0.16,0-0.321-0.027-0.477-0.084c-0.436-0.16-0.763-0.528-0.87-0.98l-1.61-6.763\n		c-0.696-2.925-1.393-5.849-2.089-8.772l-1.394-1.396c-0.772-0.772-0.772-2.026,0-2.799l2.317-2.32l-12.862-12.877\n		C683.603,1154.25,683.604,1152.752,684.526,1151.828z M702.368,1187.4c1.125-0.867,2.229-1.76,3.313-2.674l-1.823-5.146\n		l3.604,3.608c1.298-1.148,2.563-2.332,3.797-3.549l-1.812-2.864l2.87,1.804c1.13-1.148,2.23-2.324,3.302-3.528l-3.619-3.622\n		l5.172,1.837c0.99-1.169,1.953-2.36,2.889-3.577l-12.33-2.942l-8.303,8.312L702.368,1187.4z\"/>\n</g><g \nng-class=\"(vm.floorPlan.room_9.room_status == \'clean\') ? \'cleanblock\' : ((vm.floorPlan.room_9.room_status == \'dirty\') ? \'dirtyblock\' : \'lightcleanblock\')\">\n<text transform=\"matrix(1 0 0 1 729.0781 1370.6191)\" font-family=\"\'MyriadPro-Regular\'\" font-size=\"57\">\n{{ vm.floorPlan.room_9.room_num }}</text><path class=\"icon-clean\" fill=\"#46AD4B\" \nd=\"M692.789,1347.209l-2.8,2.8l9,9l20-20l-2.8-2.8l-17.2,17.199L692.789,1347.209z M716.989,1351.009\n		c0,8.8-7.2,16-16,16s-16-7.2-16-16s7.2-16,16-16c1.6,0,3,0.2,4.4,0.601l3.199-3.201c-2.399-0.799-5-1.399-7.6-1.399\n		c-11,0-20,9-20,20s9,20,20,20s20-9,20-20H716.989z\"/>\n<g class=\"light-clean\"><polygon fill=\"#F58220\" \npoints=\"681.333,1367.5 681.333,1369.827 721.333,1369.827 721.333,1367.584 720.125,1367.584 \n			721.25,1363.021 718.667,1363 717.125,1367.584 714.667,1367.584 716.333,1362.667 713,1362.667 711.333,1367.5 708.938,1367.5 \n			710.333,1363 706.833,1363 705.375,1367.667 702.167,1367.667 702.167,1353 698.833,1353 684.333,1367.167 		\"/>\n<polygon fill=\"#F58220\" points=\"684.5,1363.5 684.5,1352.667 690.833,1352.667 692,1357.334 		\"/><polygon fill=\"#F58220\" \npoints=\"693,1352.667 693.813,1355.896 696.938,1352.834 695.333,1352.834 		\"/><rect x=\"681.5\" y=\"1345.834\" \nfill=\"#F58220\" width=\"23.667\" height=\"4.833\"/><path fill=\"#F58220\" \nd=\"M683.833,1343.834h18.334c0,0-3.5-7.334-8.667-7.334C693.5,1336.5,688.999,1335.834,683.833,1343.834z\"/><path \nfill=\"#F58220\" \nd=\"M707.333,1356.168v4.5h14.334v-4.667H718.5c0,0-0.499-3-4.333-3c0,0-3.604,0.021-4.167,3.146\n			L707.333,1356.168z\"/>\n<rect x=\"711.667\" y=\"1329.668\" fill=\"#F58220\" width=\"5.333\" height=\"21\"/><circle fill=\"#F58220\" cx=\"682.75\" \ncy=\"1338.584\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"686.333\" cy=\"1335.001\" r=\"1.75\"/><circle fill=\"#F58220\" \ncx=\"683.167\" cy=\"1331.501\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"703.332\" cy=\"1338.584\" r=\"1.75\"/><circle \nfill=\"#F58220\" cx=\"699.749\" cy=\"1335.001\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"702.915\" cy=\"1331.501\" r=\"1.75\"/></g>\n<path class=\"dirty\" fill=\"#FF555B\" \nd=\"M684.526,1333.828c0.922-0.924,2.418-0.924,3.342,0.001l12.862,12.876l2.318-2.32\n		c0.772-0.773,2.024-0.773,2.797,0l1.395,1.396c3.375,0.806,6.75,1.61,10.126,2.416l5.394,1.287\n		c0.451,0.108,0.819,0.435,0.979,0.872c0.16,0.436,0.091,0.924-0.185,1.297c-5.969,8.122-13.109,15.27-21.222,21.244\n		c-0.242,0.178-0.53,0.27-0.821,0.27c-0.16,0-0.321-0.027-0.477-0.084c-0.436-0.16-0.763-0.528-0.87-0.98l-1.61-6.763\n		c-0.696-2.925-1.393-5.849-2.089-8.772l-1.394-1.396c-0.772-0.772-0.772-2.026,0-2.799l2.317-2.32l-12.862-12.877\n		C683.603,1336.25,683.604,1334.752,684.526,1333.828z M702.368,1369.4c1.125-0.867,2.229-1.76,3.313-2.674l-1.823-5.146\n		l3.604,3.608c1.298-1.148,2.563-2.332,3.797-3.549l-1.812-2.864l2.87,1.804c1.13-1.148,2.23-2.324,3.302-3.528l-3.619-3.622\n		l5.172,1.837c0.99-1.169,1.953-2.36,2.889-3.577l-12.33-2.942l-8.303,8.312L702.368,1369.4z\"/>\n</g><g \nng-class=\"(vm.floorPlan.room_10.room_status == \'clean\') ? \'cleanblock\' : ((vm.floorPlan.room_10.room_status == \'dirty\') ? \'dirtyblock\' : \'lightcleanblock\')\">\n<text transform=\"matrix(1 0 0 1 477.0781 1380.6191)\" font-family=\"\'MyriadPro-Regular\'\" font-size=\"57\">\n{{ vm.floorPlan.room_10.room_num }}</text><path class=\"icon-clean\" fill=\"#46AD4B\" \nd=\"M440.789,1357.209l-2.8,2.8l9,9l20-20l-2.8-2.8l-17.2,17.199L440.789,1357.209z M464.989,1361.009\n		c0,8.8-7.2,16-16,16s-16-7.2-16-16s7.2-16,16-16c1.6,0,3,0.2,4.4,0.601l3.199-3.201c-2.399-0.799-5-1.399-7.6-1.399\n		c-11,0-20,9-20,20s9,20,20,20s20-9,20-20H464.989z\"/>\n<g class=\"light-clean\"><polygon fill=\"#F58220\" \npoints=\"429.333,1377.5 429.333,1379.827 469.333,1379.827 469.333,1377.584 468.125,1377.584 \n			469.25,1373.021 466.667,1373 465.125,1377.584 462.667,1377.584 464.333,1372.667 461,1372.667 459.333,1377.5 456.938,1377.5 \n			458.333,1373 454.833,1373 453.375,1377.667 450.167,1377.667 450.167,1363 446.833,1363 432.333,1377.167 		\"/>\n<polygon fill=\"#F58220\" points=\"432.5,1373.5 432.5,1362.667 438.833,1362.667 440,1367.334 		\"/><polygon fill=\"#F58220\" \npoints=\"441,1362.667 441.813,1365.896 444.938,1362.834 443.333,1362.834 		\"/><rect x=\"429.5\" y=\"1355.834\" \nfill=\"#F58220\" width=\"23.667\" height=\"4.833\"/><path fill=\"#F58220\" \nd=\"M431.833,1353.834h18.334c0,0-3.5-7.334-8.667-7.334C441.5,1346.5,436.999,1345.834,431.833,1353.834z\"/><path \nfill=\"#F58220\" \nd=\"M455.333,1366.168v4.5h14.334v-4.667H466.5c0,0-0.499-3-4.333-3c0,0-3.604,0.021-4.167,3.146\n			L455.333,1366.168z\"/>\n<rect x=\"459.667\" y=\"1339.668\" fill=\"#F58220\" width=\"5.333\" height=\"21\"/><circle fill=\"#F58220\" cx=\"430.75\" \ncy=\"1348.584\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"434.333\" cy=\"1345.001\" r=\"1.75\"/><circle fill=\"#F58220\" \ncx=\"431.167\" cy=\"1341.501\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"451.332\" cy=\"1348.584\" r=\"1.75\"/><circle \nfill=\"#F58220\" cx=\"447.749\" cy=\"1345.001\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"450.915\" cy=\"1341.501\" r=\"1.75\"/></g>\n<path class=\"dirty\" fill=\"#FF555B\" class=\"dirty\" \nd=\"M432.526,1343.828c0.922-0.924,2.418-0.924,3.342,0.001l12.862,12.876l2.318-2.32\n		c0.772-0.773,2.024-0.773,2.797,0l1.395,1.396c3.375,0.806,6.75,1.61,10.126,2.416l5.394,1.287\n		c0.451,0.108,0.819,0.435,0.979,0.872c0.16,0.436,0.091,0.924-0.185,1.297c-5.969,8.122-13.109,15.27-21.222,21.244\n		c-0.242,0.178-0.53,0.27-0.821,0.27c-0.16,0-0.321-0.027-0.477-0.084c-0.436-0.16-0.763-0.528-0.87-0.98l-1.61-6.763\n		c-0.696-2.925-1.393-5.849-2.089-8.772l-1.394-1.396c-0.772-0.772-0.772-2.026,0-2.799l2.317-2.32l-12.862-12.877\n		C431.603,1346.25,431.604,1344.752,432.526,1343.828z M450.368,1379.4c1.125-0.867,2.229-1.76,3.313-2.674l-1.823-5.146\n		l3.604,3.608c1.298-1.148,2.563-2.332,3.797-3.549l-1.812-2.864l2.87,1.804c1.13-1.148,2.23-2.324,3.302-3.528l-3.619-3.622\n		l5.172,1.837c0.99-1.169,1.953-2.36,2.889-3.577l-12.33-2.942l-8.303,8.312L450.368,1379.4z\"/>\n</g><g \nng-class=\"(vm.floorPlan.room_11.room_status == \'clean\') ? \'cleanblock\' : ((vm.floorPlan.room_11.room_status == \'dirty\') ? \'dirtyblock\' : \'lightcleanblock\')\">\n<text transform=\"matrix(1 0 0 1 264.0781 1361.6191)\" font-family=\"\'MyriadPro-Regular\'\" font-size=\"57\">\n{{ vm.floorPlan.room_11.room_num }}</text><path class=\"icon-clean\" fill=\"#46AD4B\" \nd=\"M227.789,1338.209l-2.8,2.8l9,9l20-20l-2.8-2.8l-17.2,17.199L227.789,1338.209z M251.989,1342.009\n		c0,8.8-7.2,16-16,16s-16-7.2-16-16s7.2-16,16-16c1.6,0,3,0.2,4.4,0.601l3.199-3.201c-2.399-0.799-5-1.399-7.6-1.399\n		c-11,0-20,9-20,20s9,20,20,20s20-9,20-20H251.989z\"/>\n<g class=\"light-clean\"><polygon fill=\"#F58220\" \npoints=\"216.333,1358.5 216.333,1360.827 256.333,1360.827 256.333,1358.584 255.125,1358.584 \n			256.25,1354.021 253.667,1354 252.125,1358.584 249.667,1358.584 251.333,1353.667 248,1353.667 246.333,1358.5 243.938,1358.5 \n			245.333,1354 241.833,1354 240.375,1358.667 237.167,1358.667 237.167,1344 233.833,1344 219.333,1358.167 		\"/>\n<polygon fill=\"#F58220\" points=\"219.5,1354.5 219.5,1343.667 225.833,1343.667 227,1348.334 		\"/><polygon fill=\"#F58220\" \npoints=\"228,1343.667 228.813,1346.896 231.938,1343.834 230.333,1343.834 		\"/><rect x=\"216.5\" y=\"1336.834\" \nfill=\"#F58220\" width=\"23.667\" height=\"4.833\"/><path fill=\"#F58220\" \nd=\"M218.833,1334.834h18.334c0,0-3.5-7.334-8.667-7.334C228.5,1327.5,223.999,1326.834,218.833,1334.834z\"/><path \nfill=\"#F58220\" \nd=\"M242.333,1347.168v4.5h14.334v-4.667H253.5c0,0-0.499-3-4.333-3c0,0-3.604,0.021-4.167,3.146\n			L242.333,1347.168z\"/>\n<rect x=\"246.667\" y=\"1320.668\" fill=\"#F58220\" width=\"5.333\" height=\"21\"/><circle fill=\"#F58220\" cx=\"217.75\" \ncy=\"1329.584\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"221.333\" cy=\"1326.001\" r=\"1.75\"/><circle fill=\"#F58220\" \ncx=\"218.167\" cy=\"1322.501\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"238.332\" cy=\"1329.584\" r=\"1.75\"/><circle \nfill=\"#F58220\" cx=\"234.749\" cy=\"1326.001\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"237.915\" cy=\"1322.501\" r=\"1.75\"/></g>\n<path class=\"dirty\" fill=\"#FF555B\" \nd=\"M219.526,1324.828c0.922-0.924,2.418-0.924,3.342,0.001l12.862,12.876l2.318-2.32\n		c0.772-0.773,2.024-0.773,2.797,0l1.395,1.396c3.375,0.806,6.75,1.61,10.126,2.416l5.394,1.287\n		c0.451,0.108,0.819,0.435,0.979,0.872c0.16,0.436,0.091,0.924-0.185,1.297c-5.969,8.122-13.109,15.27-21.222,21.244\n		c-0.242,0.178-0.53,0.27-0.821,0.27c-0.16,0-0.321-0.027-0.477-0.084c-0.436-0.16-0.763-0.528-0.87-0.98l-1.61-6.763\n		c-0.696-2.925-1.393-5.849-2.089-8.772l-1.394-1.396c-0.772-0.772-0.772-2.026,0-2.799l2.317-2.32l-12.862-12.877\n		C218.603,1327.25,218.604,1325.752,219.526,1324.828z M237.368,1360.4c1.125-0.867,2.229-1.76,3.313-2.674l-1.823-5.146\n		l3.604,3.608c1.298-1.148,2.563-2.332,3.797-3.549l-1.812-2.864l2.87,1.804c1.13-1.148,2.23-2.324,3.302-3.528l-3.619-3.622\n		l5.172,1.837c0.99-1.169,1.953-2.36,2.889-3.577l-12.33-2.942l-8.303,8.312L237.368,1360.4z\"/>\n</g><g \nng-class=\"(vm.floorPlan.room_12.room_status == \'clean\') ? \'cleanblock\' : ((vm.floorPlan.room_12.room_status == \'dirty\') ? \'dirtyblock\' : \'lightcleanblock\')\">\n<text transform=\"matrix(1 0 0 1 272.0781 253.6187)\" font-family=\"\'MyriadPro-Regular\'\" font-size=\"57\">\n{{ vm.floorPlan.room_12.room_num }}</text><path class=\"icon-clean\" fill=\"#46AD4B\" \nd=\"M235.789,230.209l-2.8,2.8l9,9l20-20l-2.8-2.8l-17.2,17.199L235.789,230.209z M259.989,234.009\n		c0,8.8-7.2,16-16,16s-16-7.2-16-16s7.2-16,16-16c1.6,0,3,0.2,4.4,0.601l3.199-3.201c-2.399-0.799-5-1.399-7.6-1.399\n		c-11,0-20,9-20,20s9,20,20,20s20-9,20-20H259.989z\"/>\n<g class=\"light-clean\"><polygon fill=\"#F58220\" \npoints=\"224.333,250.5 224.333,252.827 264.333,252.827 264.333,250.584 263.125,250.584 264.25,246.021 \n			261.667,246 260.125,250.584 257.667,250.584 259.333,245.667 256,245.667 254.333,250.5 251.938,250.5 253.333,246 249.833,246 \n			248.375,250.667 245.167,250.667 245.167,236 241.833,236 227.333,250.167 		\"/>\n<polygon fill=\"#F58220\" points=\"227.5,246.5 227.5,235.667 233.833,235.667 235,240.334 		\"/><polygon fill=\"#F58220\" \npoints=\"236,235.667 236.813,238.896 239.938,235.834 238.333,235.834 		\"/><rect x=\"224.5\" y=\"228.834\" fill=\"#F58220\" \nwidth=\"23.667\" height=\"4.833\"/><path fill=\"#F58220\" \nd=\"M226.833,226.834h18.334c0,0-3.5-7.334-8.667-7.334C236.5,219.5,231.999,218.834,226.833,226.834z\"/><path \nfill=\"#F58220\" \nd=\"M250.333,239.168v4.5h14.334v-4.667H261.5c0,0-0.499-3-4.333-3c0,0-3.604,0.021-4.167,3.146\n			L250.333,239.168z\"/>\n<rect x=\"254.667\" y=\"212.668\" fill=\"#F58220\" width=\"5.333\" height=\"21\"/><circle fill=\"#F58220\" cx=\"225.75\" \ncy=\"221.584\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"229.333\" cy=\"218.001\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"226.167\" \ncy=\"214.501\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"246.332\" cy=\"221.584\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"242.749\" \ncy=\"218.001\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"245.915\" cy=\"214.501\" r=\"1.75\"/></g><path class=\"dirty\" \nfill=\"#FF555B\" \nd=\"M227.526,216.828c0.922-0.924,2.418-0.924,3.342,0.001l12.862,12.876l2.318-2.32\n		c0.772-0.773,2.024-0.773,2.797,0l1.395,1.396c3.375,0.806,6.75,1.61,10.126,2.416l5.394,1.287\n		c0.451,0.108,0.819,0.435,0.979,0.872c0.16,0.436,0.091,0.924-0.185,1.297c-5.969,8.122-13.109,15.27-21.222,21.244\n		c-0.242,0.178-0.53,0.27-0.821,0.27c-0.16,0-0.321-0.027-0.477-0.084c-0.436-0.16-0.763-0.528-0.87-0.98l-1.61-6.763\n		c-0.696-2.925-1.393-5.849-2.089-8.772l-1.394-1.396c-0.772-0.772-0.772-2.026,0-2.799l2.317-2.32l-12.862-12.877\n		C226.603,219.25,226.604,217.752,227.526,216.828z M245.368,252.4c1.125-0.867,2.229-1.76,3.313-2.674l-1.823-5.146l3.604,3.608\n		c1.298-1.148,2.563-2.332,3.797-3.549l-1.812-2.864l2.87,1.804c1.13-1.148,2.23-2.324,3.302-3.528l-3.619-3.622l5.172,1.837\n		c0.99-1.169,1.953-2.36,2.889-3.577l-12.33-2.942l-8.303,8.312L245.368,252.4z\"/>\n</g><g \nng-class=\"(vm.floorPlan.room_13.room_status == \'clean\') ? \'cleanblock\' : ((vm.floorPlan.room_13.room_status == \'dirty\') ? \'dirtyblock\' : \'lightcleanblock\')\">\n<text transform=\"matrix(1 0 0 1 488.0781 254.6187)\" font-family=\"\'MyriadPro-Regular\'\" font-size=\"57\">\n{{ vm.floorPlan.room_13.room_num }}</text><path class=\"icon-clean\" fill=\"#46AD4B\" \nd=\"M451.789,231.209l-2.8,2.8l9,9l20-20l-2.8-2.8l-17.2,17.199L451.789,231.209z M475.989,235.009\n		c0,8.8-7.2,16-16,16s-16-7.2-16-16s7.2-16,16-16c1.6,0,3,0.2,4.4,0.601l3.199-3.201c-2.399-0.799-5-1.399-7.6-1.399\n		c-11,0-20,9-20,20s9,20,20,20s20-9,20-20H475.989z\"/>\n<g class=\"light-clean\"><polygon fill=\"#F58220\" \npoints=\"440.333,251.5 440.333,253.827 480.333,253.827 480.333,251.584 479.125,251.584 480.25,247.021 \n			477.667,247 476.125,251.584 473.667,251.584 475.333,246.667 472,246.667 470.333,251.5 467.938,251.5 469.333,247 465.833,247 \n			464.375,251.667 461.167,251.667 461.167,237 457.833,237 443.333,251.167 		\"/>\n<polygon fill=\"#F58220\" points=\"443.5,247.5 443.5,236.667 449.833,236.667 451,241.334 		\"/><polygon fill=\"#F58220\" \npoints=\"452,236.667 452.813,239.896 455.938,236.834 454.333,236.834 		\"/><rect x=\"440.5\" y=\"229.834\" fill=\"#F58220\" \nwidth=\"23.667\" height=\"4.833\"/><path fill=\"#F58220\" \nd=\"M442.833,227.834h18.334c0,0-3.5-7.334-8.667-7.334C452.5,220.5,447.999,219.834,442.833,227.834z\"/><path \nfill=\"#F58220\" \nd=\"M466.333,240.168v4.5h14.334v-4.667H477.5c0,0-0.499-3-4.333-3c0,0-3.604,0.021-4.167,3.146\n			L466.333,240.168z\"/>\n<rect x=\"470.667\" y=\"213.668\" fill=\"#F58220\" width=\"5.333\" height=\"21\"/><circle fill=\"#F58220\" cx=\"441.75\" \ncy=\"222.584\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"445.333\" cy=\"219.001\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"442.167\" \ncy=\"215.501\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"462.332\" cy=\"222.584\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"458.749\" \ncy=\"219.001\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"461.915\" cy=\"215.501\" r=\"1.75\"/></g><path class=\"dirty\" \nfill=\"#FF555B\" \nd=\"M443.526,217.828c0.922-0.924,2.418-0.924,3.342,0.001l12.862,12.876l2.318-2.32\n		c0.772-0.773,2.024-0.773,2.797,0l1.395,1.396c3.375,0.806,6.75,1.61,10.126,2.416l5.394,1.287\n		c0.451,0.108,0.819,0.435,0.979,0.872c0.16,0.436,0.091,0.924-0.185,1.297c-5.969,8.122-13.109,15.27-21.222,21.244\n		c-0.242,0.178-0.53,0.27-0.821,0.27c-0.16,0-0.321-0.027-0.477-0.084c-0.436-0.16-0.763-0.528-0.87-0.98l-1.61-6.763\n		c-0.696-2.925-1.393-5.849-2.089-8.772l-1.394-1.396c-0.772-0.772-0.772-2.026,0-2.799l2.317-2.32l-12.862-12.877\n		C442.603,220.25,442.604,218.752,443.526,217.828z M461.368,253.4c1.125-0.867,2.229-1.76,3.313-2.674l-1.823-5.146l3.604,3.608\n		c1.298-1.148,2.563-2.332,3.797-3.549l-1.812-2.864l2.87,1.804c1.13-1.148,2.23-2.324,3.302-3.528l-3.619-3.622l5.172,1.837\n		c0.99-1.169,1.953-2.36,2.889-3.577l-12.33-2.942l-8.303,8.312L461.368,253.4z\"/>\n</g><g \nng-class=\"(vm.floorPlan.room_14.room_status == \'clean\') ? \'cleanblock\' : ((vm.floorPlan.room_14.room_status == \'dirty\') ? \'dirtyblock\' : \'lightcleanblock\')\">\n<text transform=\"matrix(-4.371139e-008 -1 1 -4.371139e-008 122.623 288.7051)\" font-family=\"\'MyriadPro-Regular\'\" \nfont-size=\"57\">{{ vm.floorPlan.room_14.room_num }}</text><path class=\"icon-clean\" fill=\"#46AD4B\" \nd=\"M99.214,324.994l2.8,2.8l9-9l-20-20l-2.8,2.8l17.199,17.2L99.214,324.994z M103.014,300.793\n		c8.8,0,16,7.2,16,16s-7.2,16-16,16s-16-7.2-16-16c0-1.6,0.2-3,0.601-4.4l-3.201-3.199c-0.799,2.399-1.399,5-1.399,7.6\n		c0,11,9,20,20,20s20-9,20-20s-9-20-20-20V300.793z\"/>\n<g class=\"light-clean\"><polygon fill=\"#F58220\" \npoints=\"119.505,336.45 121.832,336.45 121.832,296.45 119.589,296.45 119.589,297.658 115.026,296.533 \n			115.005,299.116 119.589,300.658 119.589,303.116 114.672,301.45 114.672,304.783 119.505,306.45 119.505,308.845 115.005,307.45 \n			115.005,310.95 119.672,312.408 119.672,315.616 105.005,315.616 105.005,318.95 119.172,333.45 		\"/>\n<polygon fill=\"#F58220\" points=\"115.505,333.283 104.672,333.283 104.672,326.95 109.339,325.783 		\"/><polygon \nfill=\"#F58220\" points=\"104.672,324.783 107.901,323.97 104.839,320.845 104.839,322.45 		\"/><rect x=\"97.839\" y=\"312.616\" \nfill=\"#F58220\" width=\"4.833\" height=\"23.667\"/><path fill=\"#F58220\" \nd=\"M95.839,333.95v-18.334c0,0-7.334,3.5-7.334,8.667C88.505,324.283,87.839,328.784,95.839,333.95z\"/><path \nfill=\"#F58220\" \nd=\"M108.173,310.45h4.5v-14.334h-4.667v3.167c0,0-3,0.499-3,4.333c0,0,0.021,3.604,3.146,4.167\n			L108.173,310.45z\"/><rect\n x=\"81.673\" y=\"300.783\" fill=\"#F58220\" width=\"21\" height=\"5.333\"/><circle fill=\"#F58220\" cx=\"90.589\" cy=\"335.033\" \nr=\"1.75\"/><circle fill=\"#F58220\" cx=\"87.006\" cy=\"331.45\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"83.506\" cy=\"334.616\" \nr=\"1.75\"/><circle fill=\"#F58220\" cx=\"90.589\" cy=\"314.451\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"87.006\" cy=\"318.034\" \nr=\"1.75\"/><circle fill=\"#F58220\" cx=\"83.506\" cy=\"314.868\" r=\"1.75\"/></g><path class=\"dirty\" fill=\"#FF555B\" \nd=\"M85.833,333.256c-0.924-0.922-0.924-2.418,0.001-3.342l12.876-12.862l-2.32-2.318\n		c-0.773-0.772-0.773-2.024,0-2.797l1.396-1.395c0.806-3.375,1.61-6.75,2.416-10.126l1.287-5.394\n		c0.108-0.451,0.435-0.819,0.872-0.979c0.436-0.16,0.924-0.091,1.297,0.185c8.122,5.969,15.27,13.109,21.244,21.222\n		c0.178,0.242,0.27,0.53,0.27,0.821c0,0.16-0.027,0.321-0.084,0.477c-0.16,0.436-0.528,0.763-0.98,0.87l-6.763,1.61\n		c-2.925,0.696-5.849,1.393-8.772,2.089l-1.396,1.394c-0.772,0.772-2.026,0.772-2.799,0l-2.32-2.317l-12.877,12.862\n		C88.255,334.18,86.757,334.179,85.833,333.256z M121.405,315.415c-0.867-1.125-1.76-2.229-2.674-3.313l-5.146,1.823l3.608-3.604\n		c-1.148-1.298-2.332-2.563-3.549-3.797l-2.864,1.812l1.804-2.87c-1.148-1.13-2.324-2.23-3.528-3.302l-3.622,3.619l1.837-5.172\n		c-1.169-0.99-2.36-1.953-3.577-2.889l-2.942,12.33l8.312,8.303L121.405,315.415z\"/>\n</g><g \nng-class=\"(vm.floorPlan.room_15.room_status == \'clean\') ? \'cleanblock\' : ((vm.floorPlan.room_15.room_status == \'dirty\') ? \'dirtyblock\' : \'lightcleanblock\')\">\n<text transform=\"matrix(-4.371139e-008 -1 1 -4.371139e-008 192.623 859.7051)\" font-family=\"\'MyriadPro-Regular\'\" \nfont-size=\"57\">{{ vm.floorPlan.room_15.room_num }}</text><path class=\"icon-clean\" fill=\"#46AD4B\" \nd=\"M169.214,895.994l2.8,2.799l9-9l-20-20l-2.8,2.801l17.199,17.199L169.214,895.994z M173.014,871.793\n		c8.8,0,16,7.201,16,16c0,8.801-7.2,16-16,16s-16-7.199-16-16c0-1.6,0.2-3,0.601-4.4l-3.201-3.199c-0.799,2.4-1.399,5-1.399,7.6\n		c0,11,9,20,20,20s20-9,20-20s-9-20-20-20V871.793z\"/>\n<g class=\"light-clean\"><polygon fill=\"#F58220\" \npoints=\"189.505,907.449 191.832,907.449 191.832,867.449 189.589,867.449 189.589,868.658 \n			185.026,867.533 185.005,870.115 189.589,871.658 189.589,874.115 184.672,872.449 184.672,875.783 189.505,877.449 \n			189.505,879.846 185.005,878.449 185.005,881.949 189.672,883.408 189.672,886.615 175.005,886.615 175.005,889.949 \n			189.172,904.449 		\"/>\n<polygon fill=\"#F58220\" points=\"185.505,904.283 174.672,904.283 174.672,897.949 179.339,896.783 		\"/><polygon \nfill=\"#F58220\" points=\"174.672,895.783 177.901,894.971 174.839,891.846 174.839,893.449 		\"/><rect x=\"167.839\" \ny=\"883.615\" fill=\"#F58220\" width=\"4.833\" height=\"23.668\"/><path fill=\"#F58220\" \nd=\"M165.839,904.949v-18.334c0,0-7.334,3.5-7.334,8.668C158.505,895.283,157.839,899.783,165.839,904.949z\"/><path \nfill=\"#F58220\" \nd=\"M178.173,881.449h4.5v-14.334h-4.667v3.168c0,0-3,0.498-3,4.332c0,0,0.021,3.605,3.146,4.168\n			L178.173,881.449z\"/>\n<rect x=\"151.673\" y=\"871.783\" fill=\"#F58220\" width=\"21\" height=\"5.332\"/><circle fill=\"#F58220\" cx=\"160.589\" \ncy=\"906.033\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"157.006\" cy=\"902.449\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"153.506\" \ncy=\"905.615\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"160.589\" cy=\"885.451\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"157.006\" \ncy=\"889.033\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"153.506\" cy=\"885.867\" r=\"1.75\"/></g><path class=\"dirty\" \nfill=\"#FF555B\" \nd=\"M155.833,904.256c-0.924-0.922-0.924-2.418,0.001-3.342l12.876-12.861l-2.32-2.318\n		c-0.773-0.773-0.773-2.025,0-2.797l1.396-1.395c0.806-3.375,1.61-6.75,2.416-10.127l1.287-5.393\n		c0.108-0.451,0.435-0.82,0.872-0.979c0.436-0.16,0.924-0.092,1.297,0.184c8.122,5.969,15.27,13.109,21.244,21.223\n		c0.178,0.242,0.27,0.529,0.27,0.82c0,0.16-0.027,0.322-0.084,0.477c-0.16,0.436-0.528,0.764-0.98,0.871l-6.763,1.609\n		c-2.925,0.697-5.849,1.393-8.772,2.09l-1.396,1.393c-0.772,0.773-2.026,0.773-2.799,0l-2.32-2.316l-12.877,12.861\n		C158.255,905.18,156.757,905.18,155.833,904.256z M191.405,886.414c-0.867-1.125-1.76-2.229-2.674-3.313l-5.146,1.822l3.608-3.604\n		c-1.148-1.299-2.332-2.564-3.549-3.797l-2.864,1.811l1.804-2.869c-1.148-1.131-2.324-2.23-3.528-3.303l-3.622,3.619l1.837-5.172\n		c-1.169-0.99-2.36-1.953-3.577-2.889l-2.942,12.33l8.312,8.303L191.405,886.414z\"/>\n</g><g \nng-class=\"(vm.floorPlan.room_16.room_status == \'clean\') ? \'cleanblock\' : ((vm.floorPlan.room_16.room_status == \'dirty\') ? \'dirtyblock\' : \'lightcleanblock\')\">\n<text transform=\"matrix(-4.371139e-008 -1 1 -4.371139e-008 123.623 1281.7051)\" font-family=\"\'MyriadPro-Regular\'\" \nfont-size=\"57\">{{ vm.floorPlan.room_16.room_num }}</text><path class=\"icon-clean\" fill=\"#46AD4B\" \nd=\"M100.214,1317.994l2.8,2.799l9-9l-20-20l-2.8,2.801l17.199,17.199L100.214,1317.994z M104.014,1293.793\n		c8.8,0,16,7.201,16,16c0,8.801-7.2,16-16,16s-16-7.199-16-16c0-1.6,0.2-3,0.601-4.4l-3.201-3.199c-0.799,2.4-1.399,5-1.399,7.6\n		c0,11,9,20,20,20s20-9,20-20s-9-20-20-20V1293.793z\"/>\n<g class=\"light-clean\"><polygon fill=\"#F58220\" \npoints=\"120.505,1329.449 122.832,1329.449 122.832,1289.449 120.589,1289.449 120.589,1290.658 \n			116.026,1289.533 116.005,1292.115 120.589,1293.658 120.589,1296.115 115.672,1294.449 115.672,1297.783 120.505,1299.449 \n			120.505,1301.846 116.005,1300.449 116.005,1303.949 120.672,1305.408 120.672,1308.615 106.005,1308.615 106.005,1311.949 \n			120.172,1326.449 		\"/>\n<polygon fill=\"#F58220\" points=\"116.505,1326.283 105.672,1326.283 105.672,1319.949 110.339,1318.783 		\"/><polygon \nfill=\"#F58220\" points=\"105.672,1317.783 108.901,1316.971 105.839,1313.846 105.839,1315.449 		\"/><rect x=\"98.839\" \ny=\"1305.615\" fill=\"#F58220\" width=\"4.833\" height=\"23.668\"/><path fill=\"#F58220\" \nd=\"M96.839,1326.949v-18.334c0,0-7.334,3.5-7.334,8.668C89.505,1317.283,88.839,1321.783,96.839,1326.949z\"/><path \nfill=\"#F58220\" \nd=\"M109.173,1303.449h4.5v-14.334h-4.667v3.168c0,0-3,0.498-3,4.332c0,0,0.021,3.605,3.146,4.168\n			L109.173,1303.449z\"/>\n<rect x=\"82.673\" y=\"1293.783\" fill=\"#F58220\" width=\"21\" height=\"5.332\"/><circle fill=\"#F58220\" cx=\"91.589\" \ncy=\"1328.033\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"88.006\" cy=\"1324.449\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"84.506\" \ncy=\"1327.615\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"91.589\" cy=\"1307.451\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"88.006\" \ncy=\"1311.033\" r=\"1.75\"/><circle fill=\"#F58220\" cx=\"84.506\" cy=\"1307.867\" r=\"1.75\"/></g><path class=\"dirty\" \nfill=\"#FF555B\" \nd=\"M86.833,1326.256c-0.924-0.922-0.924-2.418,0.001-3.342l12.876-12.861l-2.32-2.318\n		c-0.773-0.773-0.773-2.025,0-2.797l1.396-1.395c0.806-3.375,1.61-6.75,2.416-10.127l1.287-5.393\n		c0.108-0.451,0.435-0.82,0.872-0.979c0.436-0.16,0.924-0.092,1.297,0.184c8.122,5.969,15.27,13.109,21.244,21.223\n		c0.178,0.242,0.27,0.529,0.27,0.82c0,0.16-0.027,0.322-0.084,0.477c-0.16,0.436-0.528,0.764-0.98,0.871l-6.763,1.609\n		c-2.925,0.697-5.849,1.393-8.772,2.09l-1.396,1.393c-0.772,0.773-2.026,0.773-2.799,0l-2.32-2.316l-12.877,12.861\n		C89.255,1327.18,87.757,1327.18,86.833,1326.256z M122.405,1308.414c-0.867-1.125-1.76-2.229-2.674-3.313l-5.146,1.822l3.608-3.604\n		c-1.148-1.299-2.332-2.564-3.549-3.797l-2.864,1.811l1.804-2.869c-1.148-1.131-2.324-2.23-3.528-3.303l-3.622,3.619l1.837-5.172\n		c-1.169-0.99-2.36-1.953-3.577-2.889l-2.942,12.33l8.312,8.303L122.405,1308.414z\"/>\n</g></svg>");
$templateCache.put("app/main/apps/dashboards/housekeeping/views/housekeepingDashboard.html","<div class=\"scrolldivtaboutermain\" ms-scroll><div layout=\"row\" class=\"salescontainer\" flex=\"100\" layout-wrap=\"wrap\" \nlayout-align=\"start start\"><div flex=\"100\" flex-sm=\"100\" layout=\"column\"><div layout=\"row\" class=\"salescontainer\" \nflex=\"100\" layout-wrap ng-if=\"vm.showPortlets\"><md-card><md-progress-linear class=\"dashboard-lin\" md-mode=\"query\">\n</md-progress-linear><md-card-title flex=\"100\" layout-wrap=\"wrap\" layout=\"row\"><div flex=\"30\" flex-sm=\"35\" \nflex-xs=\"100\" layout=\"column\" class=\"shift-scheduleouter\"><div class=\"shift-schedule\"><span class=\"md-headline\">\nShift Schedule</span><div class=\"timingouterblock\"><div class=\"timingrowblock active\"><h2>Early <small>7.00 AM</small>\n</h2></div><div class=\"timingrowblock\"><h2>Morning <small>10.00 AM</small></h2></div><div class=\"timingrowblock\"><h2>\nAfternoon <small>1.00 AM</small></h2></div><div class=\"timingrowblock\"><h2>Night <small>8.00 AM</small></h2></div>\n</div></div></div><div flex=\"70\" flex-sm=\"65\" flex-xs=\"100\" layout=\"column\"><div class=\"housekeepingdashboardcalender\">\n<img src=\"assets/images/Minerva-Dashboard.png\"></div></div></md-card-title></md-card></div></div><div flex=\"50\" \nflex-sm=\"100\" layout=\"column\"><div layout=\"row\" class=\"cardblock_dash\" flex=\"100\" layout-wrap><div flex=\"50\" \nflex-gt-sm=\"50\" flex-xs=\"50\" layout=\"column\" class=\"coldblock_dash\" ng-repeat=\"value in vm.checkInCheckout\"><md-card \nclass=\"dash-card onlycursorPointer\" md-theme-watch layout=\"row\" flex=\"100\" layout-wrap=\"wrap\" \nlayout-align=\"start start\" ng-click=\"vm.checkInCheckoutClicket(value,vm.pageFor)\"><md-card-title layout=\"column\" \nflex=\"100\" layout-align=\"start start\"><md-card-title-text layout=\"row\" flex=\"100\" layout-align=\"start start\" \nclass=\"no-paddingheading\"><span class=\"md-headline\">{{value}}</span></md-card-title-text><md-card-title-media \nlayout=\"row\" flex=\"100\" layout-align=\"center center\" layout-wrap=\"wrap\"><div class=\"md-media-lg card-media blue\" \nlayout=\"column\" flex=\"100\" layout-align=\"center center\" ng-bind=\"vm.dashboardData.todayCheckInRemaining\" \nng-if=\"vm.dashboardData.todayCheckInRemaining > 0 && value == \'Check In\'\"></div><img class=\"achievement-icon\" \nsrc=\"assets/icons/check-mark-button.svg\" alt=\"Achievement\" \nng-if=\"vm.dashboardData.todayCheckInRemaining <= 0 && value == \'Check In\'\"><div class=\"md-media-lg card-media blue\" \nlayout=\"column\" flex=\"100\" layout-align=\"center center\" ng-bind=\"vm.dashboardData.todayCheckOutRemaining\" \nng-if=\"vm.dashboardData.todayCheckOutRemaining > 0 && value == \'Check Out\'\"></div><img class=\"achievement-icon\" \nsrc=\"assets/icons/check-mark-button.svg\" alt=\"Achievement\" \nng-if=\"vm.dashboardData.todayCheckOutRemaining <= 0 && value == \'Check Out\'\"></md-card-title-media><slider-range \nmin=\"10\" max=\"200\" value-min=\"search.price_min\" value-max=\"search.price_max\" class=\"rangefilter\" \nng-if=\"value == \'Check In\'\"><div class=\"slidercir\" \nstyle=\"left:{{((vm.dashboardData.todayCheckIn/vm.dashboardData.todayCheckInExpected)*100).toFixed(2)}}%;background:#43bdd4\">\n</div><div class=\"bar blue\" \nstyle=\"width:{{((vm.dashboardData.todayCheckIn/vm.dashboardData.todayCheckInExpected)*100).toFixed(2)}}%;background:#43bdd4\">\n</div></slider-range><slider-range min=\"10\" max=\"200\" value-min=\"search.price_min\" value-max=\"search.price_max\" \nclass=\"rangefilter\" ng-if=\"value == \'Check Out\'\"><div class=\"slidercir\" \nstyle=\"left:{{((vm.dashboardData.todayCheckOut/vm.dashboardData.todayCheckOutExpected)*100).toFixed(2)}}%;background:#43bdd4\">\n</div><div class=\"bar blue\" \nstyle=\"width:{{((vm.dashboardData.todayCheckOut/vm.dashboardData.todayCheckOutExpected)*100).toFixed(2)}}%;background:#43bdd4\">\n</div></slider-range></md-card-title><md-card-actions layout=\"row\" flex=\"100\" layout-align=\"start center\" \nclass=\"expectedvalues\"><div layout=\"column\" layout-align=\" center start\" flex=\"50\"><div>Remaining : &nbsp; <span \nng-if=\"value == \'Check In\'\">{{vm.dashboardData.todayCheckInRemaining}} / {{vm.dashboardData.todayCheckInExpected}} \n</span><span ng-if=\"value == \'Check Out\'\">\n{{vm.dashboardData.todayCheckOutRemaining}} / {{vm.dashboardData.todayCheckOutExpected}}</span></div></div><span \nlayout=\"column\" layout-align=\" center end\" flex=\"50\">{{vm.dashboardData.date}}</span></md-card-actions></md-card></div>\n</div><div layout=\"row\" class=\"salescontainer checkincontent\" flex=\"100\" layout-wrap=\"wrap\" layout-align=\"start start\" \nng-if=\"vm.loadRemHtml\"><md-card class=\"fullcardblockRoomstatus\"><md-progress-linear class=\"dashboard-lin\" \nmd-mode=\"query\" ng-if=\"vm.roomStatusLoader\"></md-progress-linear><md-card-title flex=\"100\" layout-wrap=\"wrap\" \nlayout=\"row\"><md-card-title-text flex=\"100\" layout=\"column\"><span class=\"md-headline\">Room Status</span>\n</md-card-title-text><md-card-title-media flex=\"100\" layout=\"column\"><div class=\"card-middlesection\"><div flex=\"100\" \nlayout=\"row\"><div flex=\"60\" layout=\"column\"><highchart id=\"chart11\" class=\"loads-tracking\" config=\"roomStatusConfig\" \nclass=\"span9\" ng-show=\"vm.roomStatusExist && !vm.roomStatusLoader\"></highchart><div ng-if=\"!vm.roomStatusExist\" \nclass=\"text-center\">No Data Found</div></div><div flex=\"40\" layout=\"column\"><ul class=\"print-listing chart-color\"><li \nng-click=\"vm.showRoomStatus(\'In Cleaning\', vm.roomStatusPieChart.inCleaning)\" class=\"onlycursorPointer\"><span \nstyle=\"background:#24BCD1\"></span><p>In Cleaning <b>{{vm.roomStatusPieChart.inCleaning}}</b></p></li><li \nng-click=\"vm.showRoomStatus(\'Available\', vm.roomStatusPieChart.available)\" class=\"onlycursorPointer\"><span \nstyle=\"background:#303540\"></span><p>Available <b>{{vm.roomStatusPieChart.available}}</b></p></li><li \nng-click=\"vm.showRoomStatus(\'Out of Service\', vm.roomStatusPieChart.outOfService)\" class=\"onlycursorPointer\"><span \nstyle=\"background:#FF5861\"></span><p>Out of Service <b>{{vm.roomStatusPieChart.outOfService}}</b></p></li><li \nclass=\"totalval\"><p>Total <b>{{ vm.roomStatusPieChart.totalRooms }}</b></p></li></ul></div></div></div>\n</md-card-title-media></md-card-title></md-card></div><div layout=\"row\" class=\"salescontainer checkincontent\" \nflex=\"100\" layout-wrap=\"wrap\" layout-align=\"start start\"><div flex=\"100\" flex-sm=\"100\" flex-xs=\"100\" layout=\"column\">\n<md-card><md-progress-linear class=\"dashboard-lin\" md-mode=\"query\" ng-show=\"vm.resDetailsLoader\"></md-progress-linear>\n<md-card-title flex=\"100\" layout-wrap=\"wrap\" layout=\"row\"><md-card-title-media flex=\"100\" layout=\"column\"><div \nclass=\"card-middlesection\"><div class=\"card-inside-tab checkin-checkout-tab\"><md-tabs md-dynamic-height \nmd-border-bottom class=\"tabmainsections\"><md-tab label=\"{{tabs.tabName}}\" ng-repeat=\"tabs in vm.portletTabs\" \nng-click=\"vm.getReservationDetails(tabs.value)\"><div class=\"checkininnercontent\"><div layout=\"row\" flex=\"100\" \nlayout-wrap=\"wrap\" layout-align=\"start stretch\"><div layout=\"column\" flex=\"45\" class=\"listcol-left\"><div \nclass=\"checkin-listing\" ms-scroll><div class=\"checkin-listing-row\" \nng-repeat=\"(res_key, reservation) in vm.currentReservations\" \nng-click=\"vm.showReservationDetails(reservation, res_key)\" ng-class=\"(vm.activeRes[res_key]) ? \'active\' : \'\'\"><div \nclass=\"checkin-listing-img\"><span class=\"in-house-text-img\"><b><i>{{reservation.first_room}}</i> <i \nng-if=\"reservation.second_room != \'\'\">{{reservation.second_room}}</i></b></span></div><div \nclass=\"checkin-listing-content\"><h2>{{ reservation.customer_name }}</h2><p>{{ reservation.product_name }}</p></div>\n</div></div></div><div layout=\"column\" flex=\"55\"><div class=\"checkin-listing-form\"><h2>\n{{ vm.detailedRes.customer_name }}</h2><p>{{ vm.detailedRes.product_name }}</p><p>\n{{ vm.detailedRes.confirmation_number }}</p><div class=\"roomcontentrow\"><div class=\"roomcontentcol half\"><p>Room Status\n</p><h2>{{ vm.detailedRes.clean_status }}</h2></div><div class=\"roomcontentcol half\"><p>Task Status</p><h2>\n{{ vm.detailedRes.task_status }}</h2></div></div><div class=\"roomcontentrow\"><div class=\"roomcontentcol onrthird\"><p>\nCheck In</p><h2>{{ vm.detailedRes.room_stay_from }}</h2></div><div class=\"roomcontentcol onrthird\"><p>Check Out</p><h2>\n{{ vm.detailedRes.room_stay_to }}</h2></div><div class=\"roomcontentcol small\"><p>Night</p><h2>\n{{ vm.detailedRes.totalNights }}</h2></div></div><div class=\"roomcontentrow\"><div class=\"roomcontentcol half\"><p>\nNightly</p><h2>{{ vm.detailedRes.nightly_average | currency : $ }}</h2></div><div class=\"roomcontentcol half\"><p>\nTotal for stay</p><h2>{{ vm.detailedRes.grand_total | currency : $ }}</h2></div></div></div><div class=\"assigntoblock\" \nlayout=\"row\" flex=\"100\" layout-wrap=\"wrap\" layout-align=\"start center\"><div layout=\"column\" \nlayout-align=\"start center\" class=\"assigntoleft\" flex=\"100\"><div class=\"assigntobtnouter\" \nng-if=\"vm.detailedRes.assigned_to != \'\' && vm.detailedRes.task_to_user != 0\"><md-button \nclass=\"md-button md-raised md-accent white-fg assigntobutton\" ng-click=\"vm.assignTask(vm.detailedRes.task_id)\">\nAssigned To : {{ vm.detailedRes.assigned_to }}</md-button></div><div class=\"assigntobtnouter\" \nng-if=\"vm.detailedRes.assigned_to == \'\' || vm.detailedRes.task_to_user == 0\"><md-button \nclass=\"md-button md-raised md-accent white-fg assigntobutton\" \nng-disabled=\"vm.detailedRes.product_is_clean == \'1\' || vm.detailedRes.task_id == \'\'\" \nng-click=\"vm.assignTask(vm.detailedRes.task_id)\">Assign To</md-button></div></div></div></div></div></div></md-tab>\n</md-tabs></div></div></md-card-title-media></md-card-title></md-card></div></div><div layout=\"row\" \nclass=\"salescontainer checkincontent\" flex=\"100\" layout-wrap=\"wrap\" layout-align=\"start start\"><div flex=\"100\" \nflex-sm=\"100\" flex-xs=\"100\" layout=\"column\"><md-card ng-if=\"vm.loadRemHtml\" class=\"hk-outlook-card\"><md-progress-linear\n class=\"dashboard-lin hk-outlook-loader\" md-mode=\"query\" ng-if=\"vm.portletloader\"></md-progress-linear><md-card-title \nflex=\"100\" layout-wrap=\"wrap\" layout=\"row\"><md-card-title-text flex=\"100\" layout=\"row\" layout-align=\"start center\" \nclass=\"hk-outlook-header\"><span class=\"md-headline\">Housekeeping Outlook</span> <span flex></span><div \nclass=\"hk-outlook-date-nav\"><i class=\"icon-chevron-left arrow datePickerIcon datePreviousIcon\" \nng-class=\"{\'disabled-icon\': vm.portletloader || vm.outlookStartDate <= vm.minDate}\" \nng-click=\"vm.navigateOutlookDates(\'prev\')\"><md-tooltip><span>Previous</span></md-tooltip></i><md-datepicker \nclass=\"hk-outlook-datepicker\" ng-model=\"vm.outlookStartDate\" md-min-date=\"vm.minDate\" \nmd-is-open=\"vm.outlookDatePickerOpen\" ng-change=\"vm.onOutlookDateChange()\" ng-model-options=\"{debounce: 500}\">\n</md-datepicker><i class=\"icon-chevron-right arrow datePickerIcon gantt-dateNextIcon\" \nng-class=\"{\'disabled-icon\': vm.portletloader}\" ng-click=\"vm.navigateOutlookDates(\'next\')\"><md-tooltip><span>Next</span>\n</md-tooltip></i></div></md-card-title-text><md-card-title-media flex=\"100\" layout=\"column\" \nng-class=\"{\'hk-outlook-loading\': vm.portletloader}\"><div \nclass=\"card-middlesection availability-portlet-cls roomactionblock\"><div class=\"roomsinfoblock\"><div layout=\"row\" \nlayout-align=\"start stretch\" class=\"dateouterrow headingdateblk firstrowheader\"><div \nclass=\"roomNamecolsm roomactioncol nameblkcol no-right-border\" layout=\"column\" layout-align=\"center start\"><div \nclass=\"txtinnercontent\">Actions</div></div><div class=\"rowactioncol\" style=\"border:none\" layout=\"column\" \nlayout-align=\"center center\" ng-repeat=\"dat in vm.DatesData\"><div class=\"innercontentdate\">{{dat.date}} <span>\n{{dat.day}}</span></div></div></div></div><div ng-repeat=\"(oldkey,value) in vm.productData\"><div layout=\"row\" \nlayout-align=\"start stretch\" class=\"dateouterrow roomactioncolcolor\"><div \nclass=\"roomNamecolsm roomactioncol nameblkcol product_wrapper\" layout=\"column\" style=\"background: #7cdfd8\" \nlayout-align=\"center start\"><div class=\"txtinnercontent\">{{value.hotel_name}}</div></div><div \nclass=\"roomNamecolsm rowactioncol actiondatacol\" style=\"background: #7cdfd8\" layout=\"column\" \nng-repeat=\"(key,data) in value.occupancy\" layout-align=\"center center\"><div class=\"innercontentdate\" \nstyle=\"color:#222 !important\">{{data}}%</div></div></div><div layout=\"row\" layout-align=\"start stretch\" \nclass=\"dateouterrow\"><div class=\"roomNamecolsm roomactioncol nameblkcol\" layout=\"column\" layout-align=\"center start\">\n<div class=\"txtinnercontent\">Arrival</div></div><div class=\"roomNamecolsm rowactioncol actiondatacol\" \nng-click=\"vm.showInhouseCustomers(\'arrival\',key,oldkey)\" layout=\"column\" layout-align=\"center center\" \nng-repeat=\"(key,data) in value.arrivals\"><div class=\"innercontentdate\">{{data.length}}</div></div></div><div \nlayout=\"row\" layout-align=\"start stretch\" class=\"dateouterrow\"><div class=\"roomNamecolsm roomactioncol nameblkcol\" \nlayout=\"column\" layout-align=\"center start\"><div class=\"txtinnercontent\">Departure</div></div><div \nclass=\"roomNamecolsm rowactioncol actiondatacol\" ng-click=\"vm.showInhouseCustomers(\'departure\',key,oldkey)\" \nlayout=\"column\" layout-align=\"center center\" ng-repeat=\"(key,data) in value.departures\"><div class=\"innercontentdate\">\n{{data.length}}</div></div></div><div layout=\"row\" layout-align=\"start stretch\" class=\"dateouterrow\"><div \nclass=\"roomNamecolsm roomactioncol nameblkcol\" layout=\"column\" layout-align=\"center start\"><div \nclass=\"txtinnercontent\">Stayover</div></div><div class=\"roomNamecolsm rowactioncol actiondatacol\" layout=\"column\" \nlayout-align=\"center center\" ng-click=\"vm.showInhouseCustomers(\'stayover\',key,oldkey)\" \nng-repeat=\"(key,data) in value.stayovers\"><div class=\"innercontentdate\">{{data.length}}</div></div></div></div></div>\n</md-card-title-media></md-card-title></md-card></div></div><div layout=\"row\" class=\"salescontainer checkincontent\" \nflex=\"100\" layout-wrap=\"wrap\" layout-align=\"start start\" ng-if=\"vm.showPortlets\"><div flex=\"50\" layout=\"column\">\n<md-card><md-progress-linear class=\"dashboard-lin\" md-mode=\"query\" ng-if=\"vm.roomStatusLoader1\"></md-progress-linear>\n<md-card-title flex=\"100\" layout-wrap=\"wrap\" layout=\"row\"><md-card-title-text flex=\"100\" layout=\"column\"><span \nclass=\"md-headline\">My Staff reviews</span></md-card-title-text><md-card-title-media flex=\"100\" layout=\"column\"><div \nclass=\"reviewsclients\"><div class=\"left clientimg\"><div class=\"clientimgblockouter\"><img \nsrc=\"assets/images/avatars/Abbott.jpg\"></div><h2>25%</h2></div><div class=\"mid clientimg\"><div \nclass=\"clientimgblockouter\"><img src=\"assets/images/avatars/Josefina.jpg\"></div><h2>50%</h2></div><div \nclass=\"right clientimg\"><div class=\"clientimgblockouter\"><img src=\"assets/images/avatars/andrew.jpg\"></div><h2>New</h2>\n</div></div></md-card-title-media></md-card-title></md-card></div><div flex=\"50\" flex-xs=\"50\" layout=\"column\" \nng-if=\"vm.showPortlets\"><md-card><md-progress-linear class=\"dashboard-lin\" md-mode=\"query\" ng-if=\"vm.roomStatusLoader\">\n</md-progress-linear><md-card-title flex=\"100\" layout-wrap=\"wrap\" layout=\"row\"><md-card-title-text flex=\"100\" \nlayout=\"column\"><div class=\"floorouterblock\"><span class=\"md-headline\">Room Housekeep</span><md-input-container>\n<md-select ng-model=\"vm.selectedFloor\" ng-change=\"vm.selectFloor(vm.selectedFloor)\"><md-option value=\"1\">Floor 1\n</md-option><md-option value=\"2\">Floor 2</md-option><md-option value=\"3\">Floor 3</md-option><md-option value=\"4\">\nFloor 4</md-option></md-select></md-input-container></div></md-card-title-text><md-card-title-media flex=\"100\" \nlayout=\"column\"><div class=\"clean-dirty-dryclean-block\"><div class=\"clean blocktxtroom\"><i \nclass=\"icon-check-circle right-hotel_gant green-500-fg\"></i> Clean</div><div class=\"clean blocktxtroom\"><i \nclass=\"icon-broom iocncommoncolor red-A800-fg\"></i> Dirty</div><div class=\"clean blocktxtroom\"><i \nclass=\"icon-light-cleaning iocncommoncolor\"></i> Light Clean</div></div></md-card-title-media><md-card-title-media \nflex=\"100\" layout=\"column\"><div class=\"hotelmapblock\"><div \nng-include=\"\'app/main/apps/dashboards/housekeeping/views/floor-1.html\'\"></div></div></md-card-title-media>\n</md-card-title></md-card></div></div></div><div flex=\"50\" flex-sm=\"100\" layout=\"column\"><div layout=\"row\" \nclass=\"cardblock_dash\" flex=\"100\" layout-wrap><div flex=\"100\" flex-sm=\"100\" layout=\"column\"><md-card \nclass=\"hk-inhouse-card\"><md-progress-linear class=\"dashboard-lin\" md-mode=\"query\" ng-if=\"vm.inHouseCustomerLoader\">\n</md-progress-linear><md-card-title><md-card-title-text><span class=\"md-headline\">In House</span></md-card-title-text>\n</md-card-title><md-card-content class=\"hk-inhouse-table-wrap\"><table class=\"simple tableofuserouter tbwidthcheckin\">\n<thead><tr><th class=\"namewidth\" ng-click=\"vm.sortCustom(\'name\', vm.nameSortType)\"><span class=\"arrow-icon-top\">Name\n<md-icon md-font-icon=\"{{ (vm.nameSortType == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedColumn == \'name\') ? \'sortCol\' : \'\'\"></md-icon></span></th><th class=\"width10per\" \nng-click=\"vm.sortCustom(\'cleaning_status\', vm.cleanSortType)\"><span class=\"arrow-icon-top\"><div class=\"roomno\">\nCleaning Status</div><md-icon md-font-icon=\"{{ (vm.cleanSortType == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedColumn == \'cleaning_status\') ? \'sortCol\' : \'\'\"></md-icon></span></th><th class=\"width10per\" \nng-click=\"vm.sortCustom(\'room_stay_from\', vm.checkInSortType)\"><span class=\"arrow-icon-top\"><div class=\"roomno\">Chk In\n</div><md-icon md-font-icon=\"{{ (vm.checkInSortType == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedColumn == \'room_stay_from\') ? \'sortCol\' : \'\'\"></md-icon></span></th><th class=\"width10per\" \nng-click=\"vm.sortCustom(\'room_stay_to\', vm.checkOutSortType)\"><span class=\"arrow-icon-top\"><div class=\"roomno\">Chk Out\n</div><md-icon md-font-icon=\"{{ (vm.checkOutSortType == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedColumn == \'room_stay_to\') ? \'sortCol\' : \'\'\"></md-icon></span></th><th class=\"width10per\" \nng-click=\"vm.sortCustom(\'guests\', vm.guestSortType)\"><span class=\"arrow-icon-top\"><div class=\"guest\">guests</div>\n<md-icon md-font-icon=\"{{ (vm.guestSortType == \'DESC\') ? \'icon-arrow-down\' : \'icon-arrow-up\' }}\" \nng-class=\"(vm.selectedColumn == \'guests\') ? \'sortCol\' : \'\'\"></md-icon></span></th><th class=\"width21per\">last purchase\n</th></tr></thead><tbody><tr ng-repeat=\"value in vm.todayInHouseCustomers\" \nng-click=\"vm.openReservationPage(value.reservation_id)\" style=\"cursor: pointer\"><td \nstyle=\"background-color:#dedede;padding: 10px\" colspan=\"6\" \nng-if=\"value.hotel_name != undefined && value.hotel_name != \'\'\"><b>{{value.hotel_name}}</b></td><td class=\"namewidth\" \nng-if=\"value.hotel_name == undefined\"><div class=\"imgouterblkmain\"><div class=\"imgusertb\"><span \nclass=\"in-house-text-img\"><b><i>{{value.first_room}}</i> <i ng-if=\"value.second_room != \'\'\">{{value.second_room}}</i>\n</b></span></div>{{value.first_name}} {{value.last_name}}</div></td><td class=\"width10per badgescenter badgestxt\" \nng-if=\"value.hotel_name == undefined\"><span style=\"width:100%;text-align:center\" \nng-click=\"vm.toggleCleaningStatus($event, $index)\"><i class=\"icon-check-circle green-500-fg\" \nng-if=\"value.product_is_clean == \'1\'\"></i> <i class=\"icon-broom iocncommoncolor red-A800-fg\" \nng-if=\"value.product_is_clean == \'0\'\"></i> <i class=\"icon-light-cleaning iocncommoncolor\" \nng-if=\"value.product_is_clean == \'2\'\"></i></span></td><td class=\"width10per\" ng-if=\"value.hotel_name == undefined\"><div\n class=\"roomno\">{{value.room_stay_from}}</div></td><td class=\"width10per\" ng-if=\"value.hotel_name == undefined\"><div \nclass=\"roomno\">{{value.room_stay_to}}</div></td><td class=\"width10per\" ng-if=\"value.hotel_name == undefined\"><div \nclass=\"guest\">{{value.guests}}</div></td><td class=\"width21per\" ng-if=\"value.hotel_name == undefined\">\n{{value.lastItemPurchased}}</td></tr><tr ng-if=\"vm.todayInHouseCustomers.length == 0\"><td class=\"text-center\" \ncolspan=\"6\">No Customer Found</td></tr></tbody></table></md-card-content></md-card></div></div></div></div></div>");
$templateCache.put("app/main/apps/dashboards/housekeeping/views/resources.html","Resources");
$templateCache.put("app/main/apps/dashboards/modified-gantt-chart/dialogs/add-comment.html","<md-dialog class=\"contact-dialog ganttpolicyChoice\" aria-label=\"New Task\"><form name=\"addcommentInRes\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Add note for {{vm.data.name}}-#{{vm.data.confirmation_number}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll style=\"max-width:800px;max-height:1000px\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><md-content class=\"md-padding\"><div class=\"row-block-new\" layout=\"row\" layout-align=\"start start\" \nflex=\"100\" layout-wrap><md-input-container class=\"md-block mb-0 md-input-has-value mb-0\" layout=\"column\" flex=\"100\">\n<md-radio-group class=\"no-margin\" ng-model=\"vm.note_type\" ng-change=\"vm.type_changed()\"><md-radio-button \nclass=\"space-block-inline\" value=\"comment\">Comment</md-radio-button><md-radio-button \nclass=\"space-block-inline margin-left-30\" value=\"special_request\">Special Request</md-radio-button></md-radio-group>\n</md-input-container><div class=\"layout-colo-block padding-left-10 padding-right-10 full-width\" flex=\"100\" \nflex-gt-sm=\"100\"><md-input-container class=\"md-block m-b-0\"><label>{{vm.label}}</label><input name=\"block_comment\" \ntype=\"text\" ng-model=\"vm.comment\" required></md-input-container></div></div></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"100\" layout-align=\"end end\"><md-button \ntype=\"button\" ng-click=\"vm.savecommentofRes()\" \nng-class=\"addcommentInRes.$invalid || vm.savingcomment?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"addcommentInRes.$invalid || vm.savingcomment\" translate=\"OPTIONS_CREATE.SAVE\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/dialogs/key-card/key-card-dialog.html","<md-dialog class=\"role-dialog key-card-dialog\" aria-label=\"Key card\"><md-toolbar class=\"md-accent white-fg\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Check-In</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeKeyCardDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><md-content class=\"md-padding\"><div class=\"form-title no-padding mb-15\">Booking Details</div><div \nclass=\"key-card-info-panel\" layout=\"row\" layout-wrap><div class=\"key-card-info-row\" flex=\"50\" flex-xs=\"100\"><span \nclass=\"key-card-info-label\">Room Name:</span> <span class=\"key-card-info-value\">{{vm.order.product_name || \'—\'}}</span>\n</div><div class=\"key-card-info-row\" flex=\"50\" flex-xs=\"100\"><span class=\"key-card-info-label\">Room No.:</span> <span \nclass=\"key-card-info-value\">{{vm.order.product_room_number || \'—\'}}</span></div><div class=\"key-card-info-row\" \nflex=\"50\" flex-xs=\"100\"><span class=\"key-card-info-label\">Nights:</span> <span class=\"key-card-info-value\">\n{{vm.keyCardNights != null ? vm.keyCardNights : \'—\'}}</span></div><div class=\"key-card-info-row\" flex=\"50\" \nflex-xs=\"100\"><span class=\"key-card-info-label\">Guest Name:</span> <span class=\"key-card-info-value\">\n{{(vm.order.first_name + \' \' + vm.order.last_name).trim() || vm.order.customer_name || \'—\'}}</span></div></div><div \nclass=\"key-card-schedule-panel\" layout=\"row\" layout-wrap><div class=\"key-card-schedule-col\" flex=\"50\" flex-xs=\"100\">\n<div class=\"key-card-schedule-heading\">Check-In</div><div layout=\"row\" layout-align=\"end end\" \nclass=\"key-card-schedule-fields\"><md-input-container class=\"md-block m-b-0 key-card-date-container\" flex=\"58\" \nlayout=\"column\"><label>Date</label><md-datepicker md-open-on-focus ng-model=\"vm.keyCardCheckin\" \nng-change=\"vm.keyCardCheckinModified()\" class=\"full-width mdinput-block\"></md-datepicker><div class=\"md-errors-spacer\">\n</div></md-input-container><div class=\"key-card-time-container\" flex=\"42\" layout=\"column\"><label \nclass=\"key-card-time-label\">Time</label><div class=\"key-card-time-selects\" layout=\"row\" layout-align=\"start end\">\n<md-select class=\"key-card-time-hour\" md-container-class=\"key-card-time-select-menu\" ng-model=\"vm.keyCardCheckinHour\" \nng-change=\"vm.keyCardDatesChanged()\" aria-label=\"Check-in hour\"><md-option ng-value=\"hourOption\" \nng-repeat=\"hourOption in vm.keyCardHourOptions track by hourOption\">{{hourOption}}</md-option></md-select><span \nclass=\"key-card-time-separator\" aria-hidden=\"true\">:</span><md-select class=\"key-card-time-minute\" \nmd-container-class=\"key-card-time-select-menu\" ng-model=\"vm.keyCardCheckinMinute\" ng-change=\"vm.keyCardDatesChanged()\" \naria-label=\"Check-in minute\"><md-option ng-value=\"minuteOption\" \nng-repeat=\"minuteOption in vm.keyCardMinuteOptions track by minuteOption\">{{minuteOption}}</md-option></md-select>\n</div><div class=\"md-errors-spacer\"></div></div></div></div><div class=\"key-card-schedule-col\" flex=\"50\" flex-xs=\"100\">\n<div class=\"key-card-schedule-heading\">Check-Out</div><div layout=\"row\" layout-align=\"end end\" \nclass=\"key-card-schedule-fields\"><md-input-container class=\"md-block m-b-0 key-card-date-container\" flex=\"58\" \nlayout=\"column\"><label>Date</label><md-datepicker md-open-on-focus ng-model=\"vm.keyCardCheckout\" \nmd-min-date=\"vm.keyCardMinCheckout\" ng-change=\"vm.keyCardDatesChanged()\" class=\"full-width mdinput-block\">\n</md-datepicker><div class=\"md-errors-spacer\"></div></md-input-container><div class=\"key-card-time-container\" \nflex=\"42\" layout=\"column\"><label class=\"key-card-time-label\">Time</label><div class=\"key-card-time-selects\" \nlayout=\"row\" layout-align=\"start end\"><md-select class=\"key-card-time-hour\" \nmd-container-class=\"key-card-time-select-menu\" ng-model=\"vm.keyCardCheckoutHour\" ng-change=\"vm.keyCardDatesChanged()\" \naria-label=\"Check-out hour\"><md-option ng-value=\"hourOption\" \nng-repeat=\"hourOption in vm.keyCardHourOptions track by hourOption\">{{hourOption}}</md-option></md-select><span \nclass=\"key-card-time-separator\" aria-hidden=\"true\">:</span><md-select class=\"key-card-time-minute\" \nmd-container-class=\"key-card-time-select-menu\" ng-model=\"vm.keyCardCheckoutMinute\" \nng-change=\"vm.keyCardDatesChanged()\" aria-label=\"Check-out minute\"><md-option ng-value=\"minuteOption\" \nng-repeat=\"minuteOption in vm.keyCardMinuteOptions track by minuteOption\">{{minuteOption}}</md-option></md-select>\n</div><div class=\"md-errors-spacer\"></div></div></div></div></div><div class=\"key-card-options-row\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"key-card-toggle-col\" flex=\"none\" layout=\"row\" \nlayout-align=\"start center\"><md-switch class=\"no-margin old-card-toggle\" ng-model=\"vm.keyCardOverrideOldCard\" \nng-change=\"vm.keyCardOverrideOldCardChanged()\" aria-label=\"Override old card\">Override old card</md-switch></div>\n<md-input-container class=\"md-block m-b-0 key-card-system-container\" flex=\"45\" flex-xs=\"100\"><label>Encoder #</label>\n<md-select ng-model=\"vm.keyCardEncoderSystem\" ng-change=\"vm.keyCardEncoderSystemChanged()\" \nclass=\"key-card-system-option\" aria-label=\"System\"><md-option ng-value=\"systemOption.value\" \nng-repeat=\"systemOption in vm.keyCardEncoderSystemOptions\">{{systemOption.label}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></md-content></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><md-button \nng-class=\"vm.keyCardBtnClass(vm.keyCardIssueLoading, \'md-green-500-bg\')\" ng-click=\"vm.keyCardIssue()\" \nng-disabled=\"vm.keyCardIssueLoading\"><span class=\"key-card-btn-content\" ng-hide=\"vm.keyCardIssueLoading\"><md-icon \nmd-font-icon=\"icon-key-plus\" class=\"white-fg s18\"></md-icon>Issue Card</span><md-progress-circular \nclass=\"md-accent md-hue-1 key-card-btn-spinner\" md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"vm.keyCardIssueLoading\"></md-progress-circular></md-button><md-button \nng-class=\"vm.keyCardBtnClass(vm.keyCardVerifyLoading, \'md-accent\')\" ng-click=\"vm.keyCardOpenVerify($event)\" \nng-disabled=\"vm.keyCardVerifyLoading\"><span class=\"key-card-btn-content\" ng-hide=\"vm.keyCardVerifyLoading\"><md-icon \nmd-font-icon=\"icon-check-circle\" class=\"white-fg s18\"></md-icon>Verify Card</span><md-progress-circular \nclass=\"md-accent md-hue-1 key-card-btn-spinner\" md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"vm.keyCardVerifyLoading\"></md-progress-circular></md-button><md-button ng-click=\"vm.closeKeyCardDialog()\">\nClose</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/dialogs/key-card/key-card-verify-dialog.html","<md-dialog class=\"role-dialog key-card-dialog\" aria-label=\"Verify revoke card\"><md-toolbar class=\"md-accent white-fg\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Verify/Revoke Card</span><md-button type=\"button\" class=\"md-icon-button\" \nng-click=\"vm.closeKeyCardVerifyDialog($event)\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\" \nclass=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class=\"md-padding\"><div \nclass=\"form-title no-padding mb-15\">Card Content</div><div class=\"key-card-info-panel key-card-info-panel--verify\"><div\n class=\"key-card-empty-message\" ng-if=\"!vm.hasKeyCardContent()\">This card does not contain any information.</div><div \nng-if=\"vm.hasKeyCardContent()\"><div layout=\"row\" layout-wrap><div class=\"key-card-info-row\" flex=\"50\" flex-xs=\"100\">\n<span class=\"key-card-info-label\">Card Type:</span> <span class=\"key-card-info-value\">{{vm.keyCard.card_type}}</span>\n</div><div class=\"key-card-info-row\" flex=\"50\" flex-xs=\"100\"><span class=\"key-card-info-label\">Building:</span> <span \nclass=\"key-card-info-value\">{{vm.keyCard.building}}</span></div><div class=\"key-card-info-row\" flex=\"50\" flex-xs=\"100\">\n<span class=\"key-card-info-label\">Room No.:</span> <span class=\"key-card-info-value\">{{vm.keyCard.room}}</span></div>\n<div class=\"key-card-info-row\" flex=\"50\" flex-xs=\"100\" ng-if=\"vm.keyCard.floor\"><span class=\"key-card-info-label\">\nFloor:</span> <span class=\"key-card-info-value\">{{vm.keyCard.floor}}</span></div><div class=\"key-card-info-row\" \nflex=\"50\" flex-xs=\"100\"><span class=\"key-card-info-label\">Room Name:</span> <span class=\"key-card-info-value\">\n{{vm.keyCard.room_name}}</span></div><div class=\"key-card-info-row\" flex=\"50\" flex-xs=\"100\"><span \nclass=\"key-card-info-label\">Guest Name:</span> <span class=\"key-card-info-value\">{{vm.keyCard.name}}</span></div><div \nclass=\"key-card-info-row\" flex=\"50\" flex-xs=\"100\"><span class=\"key-card-info-label\">Check-In Date:</span> <span \nclass=\"key-card-info-value\">{{vm.keyCard.begin_date}}</span></div><div class=\"key-card-info-row\" flex=\"50\" \nflex-xs=\"100\"><span class=\"key-card-info-label\">Check-Out Date:</span> <span class=\"key-card-info-value\">\n{{vm.keyCard.expired_date}}</span></div><div class=\"key-card-info-row key-card-info-row--full\" \nng-if=\"vm.keyCard.common_doors.length\" flex=\"100\" flex-xs=\"100\"><span class=\"key-card-info-label\">Common Doors:</span> \n<span class=\"key-card-info-value\">{{ vm.keyCard.common_doors.join(\', \') }}</span></div><div \nclass=\"key-card-info-row key-card-info-row--full\" flex=\"100\" flex-xs=\"100\"><span class=\"key-card-info-label\">Card No.:\n</span> <span class=\"key-card-info-value\">{{vm.keyCard.card_no}}</span></div></div><div \nclass=\"key-card-toggle-row--in-panel\"><md-switch class=\"no-margin old-card-toggle\" \nng-model=\"vm.keyCard.override_old_card\" ng-disabled=\"true\" aria-label=\"Override old card\">Override old card</md-switch>\n</div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button\n type=\"button\" ng-class=\"vm.keyCardBtnClass(vm.keyCardVerifyLoading, \'md-accent\')\" \nng-click=\"vm.keyCardVerifyAgain($event)\" ng-disabled=\"vm.keyCardVerifyLoading\"><span class=\"key-card-btn-content\" \nng-hide=\"vm.keyCardVerifyLoading\"><md-icon md-font-icon=\"icon-check-circle\" class=\"white-fg s18\"></md-icon>Verify\n</span><md-progress-circular class=\"md-accent md-hue-1 key-card-btn-spinner\" md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"vm.keyCardVerifyLoading\"></md-progress-circular></md-button><md-button type=\"button\" \nng-class=\"vm.keyCardBtnClass(vm.keyCardRevokeLoading, \'md-red-500-bg\')\" ng-click=\"vm.keyCardRevoke($event)\" \nng-disabled=\"vm.keyCardRevokeLoading\"><span class=\"key-card-btn-content\" ng-hide=\"vm.keyCardRevokeLoading\"><md-icon \nmd-font-icon=\"icon-key-remove\" class=\"white-fg s18\"></md-icon>Revoke</span><md-progress-circular \nclass=\"md-accent md-hue-1 key-card-btn-spinner\" md-mode=\"indeterminate\" md-diameter=\"20\" \nng-show=\"vm.keyCardRevokeLoading\"></md-progress-circular></md-button><md-button type=\"button\" \nng-click=\"vm.closeKeyCardVerifyDialog($event)\">Close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/directives/ms-new-note/ms-new-note.html","<ms-note-form note-type=\"\'new\'\"></ms-note-form><div ms-new-note-button class=\"new-note-button\"><span \ntranslate=\"NOTES.TAKE_A_NOTE\">Take a note..</span></div>");
$templateCache.put("app/main/apps/e-commerce/directives/ms-note-form/ms-note-form.html","<form ng-submit=\"MsNoteForm.submit()\" ng-class=\"MsNoteForm.note.color\"><div ng-if=\"MsNoteForm.note.image\" \nclass=\"image-wrapper\"><img class=\"md-card-image\" ng-src=\"{{MsNoteForm.note.image}}\"><md-button \nclass=\"md-fab md-mini delete-image-button\" ng-click=\"MsNoteForm.deleteImage()\" aria-label=\"delete image\" translate \ntranslate-attr-aria-label=\"NOTES.DELETE_IMAGE\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><input \ntype=\"text\" class=\"note-title-input\" placeholder=\"Title\" ng-model=\"MsNoteForm.note.title\" \nng-class=\"MsNoteForm.note.color\"><md-input-container md-no-float ng-class=\"MsNoteForm.note.color\"><textarea \ntype=\"text\" class=\"note-description-textarea\" placeholder=\"Take a note..\" translate \ntranslate-attr-placeholder=\"NOTES.TAKE_A_NOTE\" ng-model=\"MsNoteForm.note.description\">\n    </textarea>\n</md-input-container><md-list class=\"checklist\" ng-if=\"MsNoteForm.note.checklist.length > 0\"><md-divider></md-divider>\n<md-list-item ng-repeat=\"item in MsNoteForm.note.checklist\"><md-checkbox ng-model=\"item.checked\" \naria-label=\"toggle check\"></md-checkbox><p ng-class=\"{\'text-strike md-secondary-text\':item.checked}\">{{item.text}}</p>\n<md-icon ng-click=\"$event.preventDefault();$event.stopPropagation();MsNoteForm.deleteCheckItem(item)\" \nclass=\"md-secondary\" md-font-icon=\"icon-close-circle\" aria-label=\"remove\"></md-icon><md-divider></md-divider>\n</md-list-item></md-list><div class=\"checklist-form\" \nng-if=\"MsNoteForm.note.checklist.length > 0 || MsNoteForm.checkListForm\" layout=\"row\" layout-align=\"space-between end\">\n<md-input-container class=\"\" md-no-float flex><input id=\"new-checklist-item-input\" type=\"text\" placeholder=\"List item\" \nng-model=\"MsNoteForm.newCheckListItem\" \nng-keydown=\"$event.keyCode === 13 ? $event.preventDefault() + MsNoteForm.addChecklistItem():\'\';\"></md-input-container>\n<md-button class=\"md-icon-button\" ng-click=\"MsNoteForm.addChecklistItem()\" aria-label=\"add\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"labels\" ng-if=\"MsNoteForm.note.labels.length > 0\" \nlayout=\"row\" layout-wrap layout-align=\"end start\"><div class=\"label\" ng-repeat=\"labelId in MsNoteForm.note.labels\" \nng-class=\"MsNoteForm.labels.getById(labelId).color\">{{MsNoteForm.labels.getById(labelId).name}}</div></div><div \nng-if=\"MsNoteForm.type ===\'edit\'\" class=\"date text-right p-16\">{{MsNoteForm.note.time | altDate}}</div><div \nclass=\"footer\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"actions\" layout=\"row\" layout-align=\"center center\" layout-wrap><div \nid=\"image-uploader\" flow-init=\"MsNoteForm.ngFlowOptions\" flow-name=\"MsNoteForm.ngFlow.flow\" \nflow-files-submitted=\"MsNoteForm.upload()\" flow-file-success=\"MsNoteForm.imageSuccess($file, $message)\" \nflow-complete=\"MsNoteForm.uploadComplete()\" flow-file-added=\"!!{svg:1,png:1,gif:1,jpg:1,jpeg:1}[$file.getExtension()]\">\n<md-button flow-btn class=\"add-img-button md-icon-button\" aria-label=\"Add image\" translate \ntranslate-attr-aria-label=\"NOTES.ADD_IMAGE\"><md-icon md-font-icon=\"icon-file-image-box\" class=\"s20\"></md-icon>\n</md-button></div><md-button class=\"md-icon-button\" aria-label=\"checklist\" ng-click=\"MsNoteForm.checklistFormToggle()\">\n<md-icon md-font-icon=\"icon-checkbox-multiple-marked\" class=\"s20\"></md-icon></md-button><md-menu class=\"label-menu\">\n<md-button class=\"md-icon-button\" aria-label=\"Label\" translate translate-attr-aria-label=\"NOTES.LABEL\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin md-font-icon=\"icon-label\" class=\"s20\"></md-icon></md-button>\n<md-menu-content class=\"notes-labels-menu-content\" width=\"4\" ms-scroll><md-menu-item><md-input-container \nclass=\"no-errors-spacer\" md-no-float><input placeholder=\"Search labels...\" type=\"text\" \nng-model=\"MsNoteForm.labelSearchText\" autocomplete=\"off\" translate-attr-palceholder=\"NOTES.SEARCH_LABELS\">\n</md-input-container></md-menu-item><md-menu-item class=\"label\" \nng-repeat=\"label in MsNoteForm.labels | filter: MsNoteForm.labelSearchText\"><md-button class=\"label-toggle-button\" \nmd-prevent-menu-close ng-class=\"label.color\" ng-click=\"MsNoteForm.toggleInArray(label.id, MsNoteForm.note.labels)\" \naria-label=\"Toggle Label\" translate translate-attr-aria-label=\"NOTES.TOGGLE_LABEL\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><span>{{label.name}}</span> <i \nng-if=\"MsNoteForm.exists(label.id, MsNoteForm.note.labels)\" class=\"icon-check s16\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu><md-button class=\"md-icon-button\" ng-click=\"MsNoteForm.toggleArchive()\" \naria-label=\"archive\"><md-icon md-font-icon=\"icon-archive\" class=\"s20\"></md-icon></md-button><ms-material-color-picker \nng-model=\"MsNoteForm.note.color\"><md-button class=\"md-icon-button\" aria-label=\"color\"><md-icon \nmd-font-icon=\"icon-palette\" class=\"s20\"></md-icon></md-button></ms-material-color-picker><md-datepicker \nclass=\"reminder\" ng-model=\"MsNoteForm.note.reminder\" md-placeholder=\"Add reminder\" ms-datepicker-fix></md-datepicker>\n</div><div layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"MsNoteForm.type ===\'edit\'\" \nng-click=\"MsNoteForm.deleteNote()\" class=\"md-icon-button\" aria-label=\"delete note\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button><md-button ng-if=\"MsNoteForm.type ===\'edit\'\" type=\"submit\" translate=\"NOTES.SAVE\" \nng-disabled=\"MsNoteForm.isNotValid()\">Save</md-button><md-button ng-if=\"MsNoteForm.type ===\'new\'\" type=\"submit\" \ntranslate=\"NOTES.ADD\" ng-disabled=\"MsNoteForm.isNotValid()\">Add</md-button></div></div></form>");
$templateCache.put("app/main/apps/e-commerce/directives/ms-note-item/ms-note-item.html","<md-card ng-class=\"MsNoteItem.note.color\"><img ng-if=\"MsNoteItem.note.image\" class=\"md-card-image\" \nng-src=\"{{MsNoteItem.note.image}}\"><md-card-content><md-card-title ng-if=\"MsNoteItem.note.title\"><md-card-title-text \nng-bind-html=\"MsNoteItem.note.title\"></md-card-title-text></md-card-title><md-description \nng-if=\"MsNoteItem.note.description\"><span>{{MsNoteItem.note.description}}</span></md-description><div \nng-if=\"MsNoteItem.note.checklist.length > 0\" class=\"checklist\"><div class=\"checklist-item\" \nng-repeat=\"checkItem in  MsNoteItem.note.checklist\" layout=\"row\" layout-align=\"start center\"><md-checkbox \nng-model=\"checkItem.checked\" ng-click=\"$event.preventDefault();$event.stopPropagation()\" \naria-label=\"{{checkItem.text}}\"></md-checkbox><span class=\"text-truncate\" \nng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\" flex>{{checkItem.text}}</span></div></div><div \nclass=\"labels\" ng-if=\"MsNoteItem.note.labels.length > 0\" layout=\"row\" layout-wrap layout-align=\"end start\"><div \nclass=\"label\" ng-repeat=\"labelId in MsNoteItem.note.labels\" \nng-click=\"$event.preventDefault();$event.stopPropagation();vm.filterChange(vm.labels.getById(labelId))\" \nng-class=\"vm.labels.getById(labelId).color\">{{vm.labels.getById(labelId).name}}</div></div><div \nng-if=\"vm.noteListType ===\'reminders\' && MsNoteItem.note.reminder\" class=\"reminder secondary-text text-right\"><md-icon \nmd-font-icon=\"icon-bell\" class=\"s16 mr-8\"></md-icon><span>{{MsNoteItem.note.reminder | altDate}}</span></div>\n</md-card-content></md-card>");
$templateCache.put("app/main/apps/e-commerce/views/activities/activities.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"activity-icon-service\" \nmd-svg-src=\"assets/angular-material-assets/img/icons/room-service.svg\"></md-icon><span translate=\"POS_TYPE.HEADING\">\n</span></div><div class=\"product-count secondary-text\"><span translate=\"POS_TYPE.TOTAL_ACTIVITIES\"></span> <span>\n{{vm.totalActivities}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{\'SEARCH\' | translate}}\" ng-model=\"filterText\" flex></div><div \nclass=\"logo\" layout=\"row\" layout-align=\"center end\" ng-if=\"vm.userPermissions.indexOf(\'add_product\')!=-1\"><md-button \nlayout=\"row\" class=\"md-raised md-cornered\" ng-click=\"vm.goToAddProduct(vm.pageType)\" \nng-if=\"vm.userPermissions.indexOf(\'add_product\')!=-1\"><i class=\"icon-plus icon-plus-main\"></i>\n {{\'POS_TYPE.ACTIVITY\' | translate}}</md-button></div></div></div></div></div><div class=\"content\"><div \nclass=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main RowClick\" ms-scroll><mdt-table \npaginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" selectable-rows=\"vm.isDeleteAllowed\" \nalternate-headers=\"\'contextual\'\" selected-row-callback=\"selectedRowCallback(rows)\" \ndelete-row-callback=\"deleteSelectedItem()\" mdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n			\'table-row-id-key\': \'product_id\',\n			\'column-keys\': [\n			\'product_name\',\n			\'product_pos_type\',\n			\'pos_type_name\',\n			\'product_price\',\n			\'product_status\',\n			\'product_id\'\n			],\n		}\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{\'POS_TYPE.TITLE\' | translate}}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{\'POS_TYPE.PRODUCT_TYPE\' | translate}}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{\'POS_TYPE.POSTYPE\' | translate}}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"false\"><span>{{\'POS_TYPE.PRICE\' | translate}}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{\'POS_TYPE.STATUS\' | translate}}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span></span></mdt-column></mdt-header-row>\n<mdt-custom-cell html-content=\"true\" column-key=\"product_status\"><i \nng-class=\"value==1?\'icon-checkbox-marked-circle green-500-fg\':\'icon-cancel red-500-fg\'\" class=\"\"></i></mdt-custom-cell>\n<mdt-custom-cell html-content=\"true\" column-key=\"product_id\"><a style=\"cursor:pointer\" \nng-click=\"clientScope.editActivity(value)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s16 ng-scope md-default-theme md-font material-icons icon-pencil\" role=\"img\" aria-label=\"icon-cog\"></md-icon>\n</a></mdt-custom-cell></mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/e-commerce/views/amenities/amenities.html","<div id=\"category\" class=\"page-layout simple fullwidth doc-page element-doc-page amenity_page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><md-progress-linear \nmd-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon white-fg fontSizeTopHeading\"><md-icon \nmd-font-icon=\"icon-hotel\"></md-icon></span><span class=\"capitalize logo-text white-fg ng-scope fontSizeTopHeading\">\n{{vm.mainHeading}}</span></div></div></div><div class=\"content\"><div class=\"content\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"main RowClick prop-amen-con\" flex=\"100\" layout=\"column\" ms-scroll><div \nid=\"amenity_data\"></div></div></div></div></div>");
$templateCache.put("app/main/apps/e-commerce/views/attribute/attribute.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" \ntranslate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span><span class=\"logo-text white-fg\">Attributes</span></div>\n</div></div><div ng-show=\"vm.selectedContacts.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedContacts =[]\">\n<md-button layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon>\n<span translate=\"CONTACTS.BACK\" class=\"white-fg\">Back</span></md-button></div></div><div class=\"content\"><div \nclass=\"main\" ms-scroll><div class=\"white-bg md-whiteframe-4dp\"><md-toolbar \nclass=\"demo-toolbar md-primary _md md-default-theme _md-toolbar-transitions\"><div class=\"md-toolbar-tools\"><h3 \nclass=\"ng-binding\">Attribute Management</h3><span flex=\"\" class=\"flex\"></span></div></md-toolbar><md-divider>\n</md-divider><form name=\"contactForm\" class=\"md-inline-form\" novalidate><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\"><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Category\" \nclass=\"first-contact-tab\"><md-content class=\"md-padding margin-top\"><md-input-container class=\"md-icon-float md-block\">\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label translate=\"EC.ATCODE\">\nAttribute Code (required)</label><md-icon></md-icon><input ng-blur=\"vm.checkUniqueCode()\" \nng-model=\"vm.attribute.attribute_code\" type=\"text\" ng-blur=\"vm.checkUniqueName()\" required><div ng-if=\"vm.uniqueCode\" \nrole=\"alert\"><div style=\"font-size:12px;color:#d60606\"><span>Code already exists.</span></div></div>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label translate=\"EC.ATTHEADING\">\nAttribute Heading (required)</label><md-icon></md-icon><input ng-blur=\"vm.checkUniqueHeading()\" \nng-model=\"vm.attribute.attribute_heading\" type=\"text\" \nng-blur=\"vm.checkUniqueSKU(vm.category.category_sku,\'category_sku\')\" required><div ng-if=\"vm.uniqueHeading\" \nrole=\"alert\"><div style=\"font-size:12px;color:#d60606\"><span>Attribute Heading already exists.</span></div></div>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><md-icon></md-icon><label \ntranslate=\"EC.FIELDTYPE\">Field Type</label><md-select ng-model=\"vm.attribute.field_type\" \nng-change=\"vm.cehckFieldType()\"><md-option value=\"text\" \nng-selected=\"!vm.category.field_type || \'text\' == vm.category.field_type\">Text</md-option><md-option value=\"textarea\" \nng-selected=\"\'textarea\'==vm.category.is_active\">Textarea</md-option><md-option value=\"dropdown\" \nng-selected=\"\'dropdown\'==vm.category.is_active\">Dropdown</md-option><md-option value=\"multiselect\" \nng-selected=\"\'multiselect\'==vm.category.is_active\">Multiselect</md-option></md-select></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" ng-if=\"vm.showOption\"><md-icon></md-icon><label \ntranslate=\"EC.ADDOPTION\">Add Option(eg: Option1, option2, option3 etc)</label><input \nng-model=\"vm.attribute.field_options\" type=\"text\" required></md-input-container><div layout=\"column\" \nlayout-gt-xs=\"row\" flex=\"\" class=\"layout-gt-xs-row layout-column flex\"><md-input-container flex=\"100\" flex-gt-xs=\"33\" \nclass=\"md-icon-float md-default-theme flex-gt-xs-33 flex-100 ng-animate md-input-invalid\" data-ng-animate=\"2\"><md-icon>\n</md-icon><label translate=\"EC.GLOBAL\">Global</label><md-select ng-model=\"vm.attribute.is_global\"><md-option value=\"1\" \nng-selected=\"!vm.category.is_active || 1==vm.category.is_active\">Yes</md-option><md-option value=\"0\" \nng-selected=\"0==vm.category.is_active\">No</md-option></md-select></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"33\" class=\"md-icon-float md-default-theme flex-gt-xs-33 flex-100 ng-animate md-input-invalid\" \ndata-ng-animate=\"2\"><md-icon></md-icon><label translate=\"EC.PRODUCTTYPE\">Product Type</label><md-select \nng-model=\"vm.category.product_type_id\"><md-option value=\"1\" \nng-selected=\"!vm.attribute.product_type_id || 1==vm.attribute.product_type_id\">All</md-option><md-option value=\"2\" \nng-selected=\"2==vm.attribute.product_type_id\">Bookable Room</md-option><md-option value=\"3\" \nng-selected=\"3==vm.attribute.product_type_id\">Bookable POS</md-option><md-option value=\"4\" \nng-selected=\"4==vm.attribute.product_type_id\">POS</md-option></md-select></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"33\" class=\"md-icon-float md-default-theme flex-gt-xs-33 flex-100 ng-animate md-input-invalid\" \ndata-ng-animate=\"2\"><md-icon></md-icon><label translate=\"EC.STATUS\">Status</label><md-select \nng-model=\"vm.category.is_active\"><md-option value=\"1\" \nng-selected=\"!vm.attribute.is_active || 1==vm.attribute.is_active\">Active</md-option><md-option value=\"0\" \nng-selected=\"0==vm.attribute.is_active\">Inactive</md-option></md-select></md-input-container></div></md-content>\n</md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newCat\" ng-click=\"vm.saveAttribute()\" \nclass=\"send-button md-accent md-raised white-fg\" ng-disabled=\"contactForm.$invalid || contactForm.$pristine\" \naria-label=\"SAVE\">SAVE</md-button><md-button type=\"submit\" ng-if=\"vm.newCat\" ng-click=\"vm.saveAttribute()\" \nclass=\"send-button md-accent md-raised white-fg\" ng-disabled=\"contactForm.$invalid || contactForm.$pristine\" \naria-label=\"Add Task\">ADD ATTRIBUTE</md-button></div></md-dialog-actions></form></div></div></div></div>");
$templateCache.put("app/main/apps/e-commerce/views/attributes/attribute.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span \ntranslate=\"EC.ATTRIBUTE\">Attribute</span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"EC.TOTAL_ATTRIBUTE\">Total Attributes:</span> <span>{{vm.products.length}}</span></div></div><div><a \nui-sref=\"app.e-commerce.attribute.add\"><md-button class=\"md-raised md-background\"><span translate=\"\">Add Attribute\n</span></md-button></a></div></div><div ng-show=\"vm.selectedContacts.length > 0\" \nclass=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"close-button-wrapper\" ng-click=\"vm.selectedContacts =[]\"><md-button layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span translate=\"CONTACTS.BACK\" class=\"white-fg\">Back\n</span></md-button></div><div flex layout=\"row\" layout-align=\"space-between center\"><div class=\"multi-select-actions\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.deleteSelectedContacts($event)\" aria-label=\"delete selected\" translate \ntranslate-attr-label=\"CONTACTS.DELETE_SELECTED\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div>\n</div><div class=\"content\"><div layout-margin><div class=\"mdt-header-alternate\" ng-show=\"vm.checkDelete\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"alternate-text\" flex>{{vm.getNumberOfSelectedRows}} item selected</span>\n<md-button class=\"md-icon-button md-primary\" ng-click=\"vm.deleteSelectedContacts($event)\" \naria-label=\"Delete selected rows\"><ng-md-icon icon=\"delete\" size=\"24\"></ng-md-icon></md-button><md-button \nclass=\"md-icon-button md-primary\" aria-label=\"More options\"><ng-md-icon icon=\"more_vert\" size=\"24\"></ng-md-icon>\n</md-button></div><md-card style=\"margin:0px\"><md-input-container style=\"margin:15px\"><label>Filter by search</label>\n<input type=\"text\" ng-model=\"filterText\"></md-input-container></md-card><mdt-table \npaginated-rows=\"{isEnabled: true,rowsPerPageValues: [20 ,50]}\" selectable-rows=\"true\" alternate-headers=\"\'contextual\'\" \nselected-row-callback=\"selectedRowCallback(rows)\" selected-row-callback=\"selectedRowCallback(rows)\" \ndelete-row-callback=\"deleteSelectedItem()\" mdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n        \'table-row-id-key\': \'attribute_id\',\n        \'column-keys\': [\n        \'attribute_heading\',\n        \'attribute_code\',\n        \'default_value\',\n        \'field_options\',\n        \'field_type\',\n        \'attribute_id\'\n\n        ],\n    }\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>Heading</span></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><span>Code</span></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\">\n<span>Default Value</span></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>Field Option</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>Field Type</span></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><span>Action</span></mdt-column></mdt-header-row><mdt-custom-cell \nhtml-content=\"true\" column-key=\"attribute_id\"><a ui-sref=\"app.e-commerce.attribute({id:value})\"><md-icon \nmd-font-icon=\"icon-icon-border-color\" ng-click=\"clientScope.addmodel($event, value)\" class=\"icon icon-border-color\" \nrole=\"img\" aria-label=\"icon-cog\"></md-icon></a></mdt-custom-cell></mdt-table></div></div></div>");
$templateCache.put("app/main/apps/e-commerce/views/bundlerooms/bundlerooms.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hotel\"></md-icon><span \ntranslate=\"{{bundletype}}.HEADING\"></span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"{{bundletype}}.TOTAL\"></span> <span>{{vm.totalbundleRooms}}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{\'SEARCH\' | translate}}\" ng-model=\"filterText\" flex></div><div class=\"logo\" layout=\"row\" \nlayout-align=\"center end\"><md-button layout=\"row\" class=\"md-raised md-cornered\" ng-click=\"vm.GotoAddUpdatePage()\" \nng-if=\"vm.userPermissions.indexOf(\'add_bundle\')!=-1\"><i class=\"icon-plus icon-plus-main\"></i> <span \ntranslate=\"{{bundletype}}.BUNDLE\"></span></md-button></div></div></div></div></div><div class=\"content\"><div \nclass=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main RowClick\" ms-scroll><mdt-table \nclass=\"condencedTableText\" paginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" \nselectable-rows=\"vm.isDeleteAllowed\" alternate-headers=\"\'contextual\'\" \nselected-row-callback=\"selectedRowCallback(rows)\" delete-row-callback=\"deleteSelectedItem()\" \nmdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n			\'table-row-id-key\': \'bundle_id\',\n			\'column-keys\': [\n			\'bundle_room\',\n			\'group_rooms\',\n			\'bundle_id\'\n			],\n		}\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ bundletype+\'.ROOM\' | translate}}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ bundletype+\'.GROUP\' | translate}}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span></span></mdt-column></mdt-header-row>\n<mdt-custom-cell html-content=\"true\" column-key=\"bundle_id\"><a style=\"cursor:pointer\" \nng-click=\"clientScope.editBundle(value)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s16 ng-scope md-default-theme md-font material-icons icon-pencil\" role=\"img\" aria-label=\"icon-cog\"></md-icon>\n</a></mdt-custom-cell></mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/e-commerce/views/dashboard/dashboard.html","<div id=\"dashboard-ecommerce\" class=\"page-layout blank\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"content\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" \nng-model=\"vm.widget1.currentRange\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget1.ranges\" \nvalue=\"{{key}}\">{{range}}</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{vm.widget1.data.count[vm.widget1.currentRange]}}%</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget1.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget1.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget1.data.extra.count[vm.widget1.currentRange]}}</span></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget2.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">${{vm.widget2.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget2.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget2.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">${{vm.widget2.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget3.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">{{vm.widget3.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget3.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget3.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget3.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget4.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">${{vm.widget4.data.count}}</div><div\n class=\"h3 secondary-text font-weight-500\">{{vm.widget4.data.label}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">{{vm.widget4.data.extra.label}}:</span> <span class=\"h4 ml-8\">\n${{vm.widget4.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div \nclass=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">{{vm.widget5.title}}</div><div class=\"pv-8\" \nlayout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" \nng-repeat=\"(key, range) in vm.widget5.ranges\" ng-click=\"vm.widget5.changeRange(key)\" \nng-disabled=\"vm.widget5.currentRange == key\">{{range}}</md-button></div></div><div class=\"p-16\"><nvd3 \nclass=\"h-420 remove-x-lines\" config=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" \ndata=\"vm.widget5.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.widget6.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget6.currentRange\" \nng-change=\"vm.widget6.changeRange(vm.widget6.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\"><nvd3 class=\"h-400\" config=\"vm.widget6.mainChart.config\" options=\"vm.widget6.mainChart.options\" \ndata=\"vm.widget6.mainChart.data\"></nvd3></div><div class=\"pv-8 mh-16 border-top\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" \nflex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">{{vm.widget6.footerLeft.count[vm.widget6.currentRange]}}</span> \n<span class=\"h4\">{{vm.widget6.footerLeft.title}}</span></div><div class=\"pv-8\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">\n{{vm.widget6.footerRight.count[vm.widget6.currentRange]}}</span> <span class=\"h4\">{{vm.widget6.footerRight.title}}\n</span></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front\n class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.widget7.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget7.currentRange\" \naria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget7.ranges\" value=\"{{key}}\">{{range}}\n</md-option></md-select></div></div><div class=\"p-16\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"customer in vm.widget7.customers[vm.widget7.currentRange]\"><div><div class=\"h3\">{{customer.name}}</div><span\n ng-if=\"customer.location\">{{customer.location}}</span></div><md-button class=\"md-icon-button\" \naria-label=\"More information\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div></ms-widget-front>\n</ms-widget></div></div></div></div>");
$templateCache.put("app/main/apps/e-commerce/views/gcadmin/gcadmin.html","<div id=\"gift-card-admin\" class=\"page-layout simple tabbed md-datepicker\" layout=\"column\"><form id=\"gcAdminForm\" \nname=\"gcAdminForm\" ng-submit=\"gcAdminForm.$valid && vm.addGiftCard(vm.giftCardData)\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\"><md-icon md-font-icon=\"icon-arrow-left\" ui-sref=\"app.e-commerce.gcadmins\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\">\n<div class=\"h2\" ng-if=\"vm.flag == \'add\'\">{{ \'ADMIN_GIFTCARD.NEW_GIFT_CARD\' | translate }}</div><div class=\"h2\" \nng-if=\"vm.flag != \'add\'\">{{vm.pagetitle}}</div><div class=\"subtitle secondary-text\" ng-if=\"vm.flag == \'edit\'\"><span \ntranslate=\"ADMIN_GIFTCARD.SUB_HEADER\"></span></div></div></div></div><div ng-show=\"vm.flag == \'add\'\"><md-button \nclass=\"md-raised md-background\" ng-class=\"{\'md-blue-grey-A100-bg\': gcAdminForm.$invalid || gcAdminForm.$pristine}\" \nng-disabled=\"gcAdminForm.$invalid || gcAdminForm.$pristine\" type=\"submit\"><span translate=\"GROUPS.SAVE\"></span>\n</md-button><md-button class=\"md-raised md-background\"><span ui-sref=\"app.e-commerce.gcadmins\" \ntranslate=\"GROUPS.CANCEL\"></span></md-button></div></div><div class=\"content content-scroll\"><div \nclass=\"product-detail-form-container md-whiteframe-1dp height\"><div class=\"role-list-outer height-main\"><div \nclass=\"role-list-out white-bg relative-block\"><div class=\"form-title margin-left-10\" \ntranslate=\"ADMIN_GIFTCARD.GIFT_CARD_DETAILS\"></div><div class=\"content\"><div class=\"row-block\" flex-gt-xs=\"100\" \nlayout=\"row\" layout-align=\"start start\" layout-wrap><div class=\"row-col padding-right-10 padding-left-10\" \nflex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" flex><md-input-container \nclass=\"md-block tax-inputs no-margin\"><label ng-class=\"vm.flag == \'edit\'?\'infoLabel\':\'\'\">\nCustomer Name : {{vm.flag == \'edit\'?vm.giftCardData.gift_card_sender_name:\'\'}}</label><input \nng-model=\"vm.giftCardData.gift_card_sender_name\" ng-if=\"vm.flag != \'edit\'\" name=\"gift_card_sender_name\" type=\"text\" \nrequired \nng-change=\"vm.flag == \'edit\' && gcAdminForm.gift_card_sender_name.$valid && vm.saveEachField(vm.giftCardData.gift_card_sender_name, \'gift_card_sender_name\')\" \nng-model-options=\"{ debounce: 1000 }\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div class=\"md-error-spacer\">\n</div></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10 datepicker-block\" \nflex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" flex><md-input-container \nclass=\"md-block tax-inputs no-margin\"><label ng-class=\"vm.flag == \'edit\'?\'infoLabel\':\'\'\">\nCustomer Email : {{vm.flag == \'edit\'?vm.giftCardData.gift_card_sender_email:\'\'}}</label><input \nng-model=\"vm.giftCardData.gift_card_sender_email\" ng-if=\"vm.flag != \'edit\'\" name=\"gift_card_sender_email\" type=\"text\" \nrequired \nng-change=\"vm.flag == \'edit\' && gcAdminForm.gift_card_sender_email.$valid && vm.saveEachField(vm.giftCardData.gift_card_sender_email, \'gift_card_sender_email\')\" \nng-model-options=\"{ debounce: 1000 }\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div class=\"md-error-spacer\">\n</div></md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" \nlayout-wrap><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" \nlayout-align=\"end start\" flex><md-input-container class=\"md-block tax-inputs no-margin\"><label \nng-class=\"vm.flag == \'edit\'?\'infoLabel\':\'\'\">\nRecipient Name : {{ vm.flag == \'edit\'?vm.giftCardData.gift_card_receiver_name:\'\' }}</label><input \nng-model=\"vm.giftCardData.gift_card_receiver_name\" ng-if=\"vm.flag != \'edit\'\" name=\"gift_card_receiver_name\" \ntype=\"text\" required \nng-change=\"vm.flag == \'edit\' && gcAdminForm.gift_card_receiver_name.$valid && vm.saveEachField(vm.giftCardData.gift_card_receiver_name, \'gift_card_receiver_name\')\" \nng-model-options=\"{ debounce: 1000 }\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div class=\"md-error-spacer\">\n</div></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10 datepicker-block\" \nflex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" flex><md-input-container \nclass=\"md-block tax-inputs no-margin\"><label ng-class=\"vm.flag == \'edit\'?\'infoLabel\':\'\'\">\nRecipient Email : {{ vm.flag == \'edit\'?vm.giftCardData.gift_card_receiver_name:\'\' }}</label><input \nng-model=\"vm.giftCardData.gift_card_receiver_email\" ng-if=\"vm.flag != \'edit\'\" name=\"gift_card_receiver_email\" \ntype=\"text\" required \nng-change=\"vm.flag == \'edit\' && gcAdminForm.gift_card_receiver_email.$valid && vm.saveEachField(vm.giftCardData.gift_card_receiver_email, \'gift_card_receiver_email\')\" \nng-model-options=\"{ debounce: 1000 }\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div class=\"md-error-spacer\">\n</div></md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" \nflex></div><div class=\"row-block margin-top-30\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap>\n<div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" \nlayout-align=\"end start\"><md-input-container class=\"md-block tax-inputs mb-10\"><label \ntranslate=\"ADMIN_GIFTCARD.GIFT_CARD_PRICE\"></label><input ng-model=\"vm.giftCardData.gift_card_price\" \nname=\"gift_card_price\" type=\"text\" allow-decimal-numbers required \nng-change=\"vm.flag == \'edit\' && gcAdminForm.gift_card_price.$valid && vm.saveEachField(vm.giftCardData.gift_card_price, \'gift_card_price\')\" \nng-model-options=\"{ debounce: 1000 }\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div class=\"md-error-spacer\">\n</div></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10 block-datepicker-main\" \nflex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\"><md-input-container \nclass=\"md-block tax-inputs mb-10 full-width\"><label translate=\"ADMIN_GIFTCARD.GIFT_CARD_EXPIRY\"></label><md-datepicker \nng-model=\"vm.giftCardData.gift_card_expiration\" md-min-date=\"vm.minDate\" class=\"full-width mdinput-block\" \nng-change=\"vm.flag == \'edit\' &&\n											!gcAdminForm.gift_card_state.$invalid &&\n											vm.saveEachField(\n												vm.giftCardData.gift_card_expiration,\n												\'gift_card_expiration\'\n											)\">\n</md-datepicker></md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" layout-wrap><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" \nflex=\"100\" layout=\"column\" layout-align=\"end start\"><md-switch class=\"no-margin\" md-no-ink aria-label=\"Switch No Ink\" \nng-model=\"vm.giftCardData.gift_card_status\" flex ng-model-options=\"{debounce: 500}\" \nng-change=\"vm.flag == \'edit\' && !gcAdminForm.gift_card_status.$invalid && vm.saveEachField(vm.giftCardData.gift_card_status, \'gift_card_status\')\">\n{{vm.getcardStatus(vm.giftCardData.gift_card_expiration)}}</md-switch></div></div></div></div><div \nclass=\"role-list-out white-bg relative-block\" ng-if=\"vm.flag == \'edit\'\"><div class=\"form-title margin-left-10\" \ntranslate=\"ADMIN_GIFTCARD.GIFT_CARD_HISTORY\"></div><div class=\"content shadow\"><div \nclass=\"ms-responsive-table-wrapper\"><table class=\"simple\" ms-responsive-table><thead><tr><th>\n{{\"ADMIN_GIFTCARD.HISTORY_DELTA\" | translate}}</th><th>{{\"ADMIN_GIFTCARD.HISTORY_AMOUNT\" | translate}}</th><th>\n{{\"ADMIN_GIFTCARD.HISTORY_DATE\" | translate}}</th><th>{{\"ADMIN_GIFTCARD.HISTORY_COMMENT\" | translate}}</th></tr>\n</thead><tbody><tr ng-repeat=\"card in vm.giftCardData.cardHistory\"><td ng-bind=\"card.gc_history_delta\"></td><td \nng-bind=\"card.gc_history_amount\"></td><td ng-bind=\"(card.created_date | limitTo:10 | date:\'MM/dd/yyyy\')\"></td><td \nclass=\"gs-comment-out\"><span class=\"gs-comment\">{{card.gc_history_comment}}</span></td></tr></tbody></table></div>\n</div></div></div></div></div></form></div>");
$templateCache.put("app/main/apps/e-commerce/views/gcadmins/gcadmins.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-wallet-giftcard\"></md-icon><span \ntranslate=\"ADMIN_GIFTCARD.HEADING\"></span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"ADMIN_GIFTCARD.TOTAL_GIFTCARDS\"></span> <span>{{vm.totalgiftCards}}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{\'SEARCH\' | translate}}\" ng-model=\"filterText\" flex></div><div class=\"logo\" layout=\"row\" \nlayout-align=\"center end\"><md-button class=\"md-raised md-cornered\" ng-click=\"vm.exportCsvData()\" \nng-disabled=\"vm.exportInProgress || !vm.currentFilter\" aria-label=\"Export as CSV\"><span>Export as CSV</span>\n</md-button><md-button layout=\"row\" class=\"md-raised md-cornered\" ui-sref=\"app.checkout({showaddDialog: true})\" \nng-if=\"vm.userPermissions.indexOf(\'retail\')!=-1\"><i class=\"icon-plus icon-plus-main\"></i> Add Gift Card</md-button>\n</div></div></div></div></div><div class=\"content\"><div class=\"content\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"main RowClick\" ms-scroll><mdt-table \npaginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" selectable-rows=\"vm.isDeleteAllowed\" \nalternate-headers=\"\'contextual\'\" selected-row-callback=\"selectedRowCallback(rows)\" \ndelete-row-callback=\"deleteSelectedItem()\" mdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n			\'table-row-id-key\': \'gift_card_id\',\n			\'column-keys\': [\n			\'gift_card_code\',\n			\'gift_card_sender_name\',\n			\'gift_card_sender_email\',\n			\'gift_card_receiver_name\',\n			\'gift_card_receiver_email\',\n			\'gift_card_price\',\n			\'gift_card_expiration\',\n			\'gift_card_status\',\n			\'gift_card_id\'\n			],\n		}\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>{{\'ADMIN_GIFTCARD.GIFT_CARD_CODE\' | translate}}\n</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>Customer Name</h5></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><h5>Customer Email</h5></mdt-column><mdt-column align-rule=\"left\" \ncolumn-sort=\"true\"><h5>Recipient Name</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\nRecipient Email</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\n{{ \'ADMIN_GIFTCARD.GIFT_CARD_PRICE\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\">\n<h5>Expiration</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\" \ncolumn-filter=\"{\'valuesProviderCallback\': statusValuesCallback, \'valuesTransformerCallback\': statusValuesTransformer, \'placeholderText\': \'Select a status\', \'filterType\': \'dropdown\'}\">\n<h5>{{ \'ADMIN_GIFTCARD.GIFT_CARD_STATUS\' | translate }}</h5></mdt-column><mdt-column><h5></h5></mdt-column>\n</mdt-header-row><mdt-custom-cell html-content=\"true\" column-key=\"gift_card_id\"><a style=\"cursor:pointer\" \nng-click=\"clientScope.editGiftCard(value)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s16 ng-scope md-default-theme md-font material-icons icon-pencil\" role=\"img\" aria-label=\"icon-cog\"></md-icon>\n</a></mdt-custom-cell></mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/e-commerce/views/giftcards/giftcard.html","<div id=\"gift-card\" class=\"page-layout simple tabbed\" layout=\"column\"><form id=\"giftCardForm\" name=\"giftCardForm\" \nng-submit=\"giftCardForm.$valid && vm.addGiftCard(vm.giftCardData)\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"logo-icon white-fg fontSizeTopHeading mr-10\"><md-icon md-font-icon=\"icon-wallet-giftcard\"></md-icon></span><span\n class=\"logo-text white-fg ng-scope fontSizeTopHeading\">{{vm.giftCardData.product_name}}</span></div></div></div><div \nng-show=\"vm.flag == \'add\'\"><md-button class=\"md-raised md-background\" \nng-class=\"{\'md-blue-grey-A100-bg\': giftCardForm.$invalid || giftCardForm.$pristine}\" \nng-disabled=\"giftCardForm.$invalid || giftCardForm.$pristine\" type=\"submit\"><span translate=\"SAVE\"></span></md-button>\n</div></div><div class=\"content content-scroll\"><div class=\"product-detail-form-container md-whiteframe-1dp height\">\n<div class=\"role-list-outer height-main\"><div class=\"role-list-out white-bg relative-block giftcardrightblock\"><div \nclass=\"form-title margin-left-10\" translate=\"GIFTCARD.CARD_DETAIL\"></div><div layout=\"row\" layout-wrap \nlayout-align=\"start start\" class=\"top-box-container\"><div class=\"row-block padding-right-10 padding-left-10\" \nflex=\"100\" flex-gt-xs=\"35\" layout=\"column\"><md-input-container \nclass=\"overflow-hidden md-block tax-inputs-img-uploade image-container new-img-pop margin-top-10 margin-bottom-20 giftcardimgblk\" \nflex-gt-xs=\"50\"><img ngf-src=\"vm.pictures\" ng-show=\"vm.pictures\"> <img ngf-src=\"vm.previousPicture\" \nng-show=\"vm.imageStatus\"><choose-file class=\"md-fab md-mini full-row-block md-profile-icon-1\" flex-gt-xs=\"100\" \nlayout=\"row\" layout-align=\"start start\" flex><input type=\"file\" id=\"pictures\" name=\"pictures\" \nngf-select=\"upload($file,$invalidFiles)\" ng-model=\"vm.pictures\" accept=\"image/*\" class=\"ng-hide\" \nng-model-options=\"{debounce: 500}\" ngf-pattern=\"\'.jpg,.jpeg,.png,.gif\'\" ngf-accept=\"\'.jpg,.jpeg,.png,.gif\'\" \nng-change=\"vm.flag == \'edit\' && giftCardForm.product_name.$valid && vm.saveCardDetail(\'file\',vm.giftCardData.catalog_product_media_id)\">\n<div class=\"inline-block-txt\" layout=\"row\" layout-align=\"start start\" flex-gt-xs=\"8\"><md-button id=\"uploadButton\" \nclass=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-upload\" class=\"white-fg\"></md-icon></md-button></div>\n<md-input-container flex class=\"md-block inline-block-txt\" flex-gt-xs=\"92\"><input type=\"hidden\" ng-model=\"fileName\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div class=\"hint\"></div></md-input-container></choose-file>\n</md-input-container></div><div class=\"row-block\" layout=\"column\" flex-gt-xs=\"65\" flex=\"100\" flex><div layout=\"row\" \nflex=\"100\"><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" layout-align=\"start start\">\n<md-input-container class=\"md-block tax-inputs mb-5\" layout=\"column\" flex=\"100\"><label translate=\"GIFTCARD.NAME\">\n</label><input type=\"text\" name=\"product_name\" ng-model=\"vm.giftCardData.product_name\" required \nng-model-options=\"{debounce: 500}\" \nng-change=\"vm.flag == \'edit\' && giftCardForm.product_name.$valid && vm.saveCardDetail(\'product_name\',vm.giftCardData.product_name)\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" flex><div\n class=\"row-col padding-right-10 padding-left-10\" layout=\"column\" layout-align=\"start start\" flex=\"100\">\n<md-input-container class=\"md-block tax-inputs\"><label translate=\"GIFTCARD.GIFT_CARD_DESCRIPTION\"></label><input \ntype=\"text\" name=\"product_description\" ng-model=\"vm.giftCardData.product_description\" required \nng-model-options=\"{debounce: 500}\" \nng-change=\"vm.flag == \'edit\' && giftCardForm.product_description.$valid && vm.saveCardDetail(\'product_description\',vm.giftCardData.product_description)\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-wrap><div class=\"md-block tax-inputs padding-right-10 padding-left-10 margin-bottom-5\" flex-gt-xs=\"50\" \nflex-gt-sm=\"50\" flex=\"100\" layout=\"column\"><md-input-container><label translate=\"GIFTCARD.TAX\"></label><md-select \nmultiple=\"multiple\" name=\"tax_id\" ng-model=\"vm.giftCardData.product_tax\" \nplaceholder=\"{{ \'GIFTCARD.SELECT_TAX\' | translate }}\" md-no-asterisk=\"false\" \nng-change=\"vm.flag == \'edit\' && giftCardForm.tax_id.$valid && vm.saveCardDetail(\'product_tax\',vm.giftCardData.product_tax)\" \nng-model-options=\"{debounce: 500}\" required><md-option value=\"0\" \nmd-selected=\"vm.giftCardData.product_tax == 0 ? \'selected\' : \'\';\">{{ \'GIFTCARD.NONE\' | translate}}</md-option>\n<md-option class=\"capitalize\" value=\"{{tax.tax_id}}\" ng-repeat=\"tax in vm.taxData\">{{tax.tax_name+\'@\'+tax.tax_value}}\n</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"md-block tax-inputs padding-right-10 padding-left-10 margin-bottom-5\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" \nflex=\"100\" layout=\"column\"><md-input-container><label translate=\"GIFTCARD.GIFT_CARD_STATUS\"></label><md-select \nname=\"product_status\" ng-model=\"vm.giftCardData.product_status\" \nplaceholder=\"{{ \'GIFTCARD.GIFT_CARD_STATUS\' | translate }}\" md-no-asterisk=\"false\" ng-model-options=\"{debounce: 500}\" \nng-change=\"vm.flag == \'edit\' && giftCardForm.product_status.$valid && vm.saveCardDetail(\'product_status\',vm.giftCardData.product_status)\">\n<md-option value=\"1\" translate=\"GIFTCARD.GIFT_CARD_ACTIVE\"></md-option><md-option value=\"0\" \ntranslate=\"GIFTCARD.GIFT_CARD_INACTIVE\"></md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container></div></div></div></div></div><div class=\"role-list-out white-bg relative-block iconRoomType\"><div\n class=\"form-title margin-left-10\"><span translate=\"GIFTCARD.CARD_PRICE\"></span><div class=\"form-title-div\"><a \nng-click=\"vm.addPrice()\" class=\"custom-pull-right\"><i class=\"icon-plus-circle\"></i></a></div></div><div \nclass=\"content\"><div class=\"row-block\" flex-gt-xs=\"100\" layout-wrap layout=\"row\" layout-align=\"start start\" flex><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex=\"100\" layout=\"column\" flex \nng-repeat=\"(key, price) in vm.giftCardData.prices\"><md-input-container class=\"md-block tax-inputs\"><input \nlayout=\"column\" flex=\"90\" type=\"text\" name=\"price\" ng-model=\"vm.giftCardData.prices[key].price\" required \nng-model-options=\"{debounce: 500}\" placeholder=\"{{ \'GIFTCARD.PRICE_LABEL\' | translate }}\" valid-number \nvalue=\"{{vm.roomTypeData.additional_guest_amounts | number:2 }}\" \nng-blur=\"vm.flag == \'edit\' && vm.giftCardData.prices[key].price != \'\' && vm.saveEachPrice(vm.giftCardData.prices[key].price, price.p_gc_id, key)\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div layout=\"column\" flex=\"10\" layout-align=\"end end\"><a \nng-click=\"vm.deletePrice(key, vm.giftCardData.prices[key].price, vm.giftCardData.prices[key].new, $event)\" \nng-if=\"vm.flag == \'edit\' && vm.giftCardData.prices.length > 1 && vm.submittedPriceCount > 1  && price.new == 0\" \nclass=\"padding-top-5 red-A800-fg\"><i class=\"icon-delete\"></i> </a><a \nng-click=\"vm.deletePrice(key, vm.giftCardData.prices[key].price, vm.giftCardData.prices[key].new, $event)\" \nng-if=\"vm.flag == \'edit\' && vm.giftCardData.prices.length > 1 && price.new == 1\" class=\"padding-top-5 red-A800-fg\"><i \nclass=\"icon-delete\"></i></a></div></md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" \nlayout=\"row\" layout-align=\"start start\" flex layout-wrap><div class=\"row-col padding-right-10 padding-left-10\" \nflex-gt-xs=\"33\" flex-gt-sm=\"33\" flex=\"100\" layout=\"column\" layout-align=\"start start\" class=\"padding-5\" flex>\n<md-input-container class=\"md-block tax-inputs margin-bottom-5\"><label translate=\"GIFTCARD.ALLOW_OPEN_AMOUNT\"></label>\n<md-select name=\"status\" ng-model=\"vm.giftCardData.p_gc_open_price\" \nplaceholder=\"{{ \'GIFTCARD.ALLOW_OPEN_AMOUNT\' | translate }}\" md-no-asterisk=\"false\" ng-model-options=\"{debounce: 500}\" \nng-change=\"vm.flag == \'edit\' && vm.giftCardData.p_gc_open_price != \'\' && vm.UpdatePriceDetail(vm.giftCardData.p_gc_open_price)\">\n<md-option value=\"1\" translate=\"GIFTCARD.ALLOW_OPEN_AMOUNT_YES\"></md-option><md-option value=\"0\" \ntranslate=\"GIFTCARD.ALLOW_OPEN_AMOUNT_NO\"></md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"33\" flex-gt-sm=\"33\" \nflex=\"100\" layout=\"column\" layout-align=\"start start\" class=\"padding-5\" flex \nng-if=\"vm.giftCardData.p_gc_open_price == 1\"><md-input-container class=\"md-block tax-inputs margin-bottom-5\"><label \ntranslate=\"GIFTCARD.ALLOW_OPEN_AMOUNT_MIN_VALUE\"></label><input type=\"text\" name=\"description\" \nng-model=\"vm.giftCardData.p_gc_open_price_min\" required ng-model-options=\"{debounce: 500}\" allow-decimal-numbers \nng-blur=\"vm.flag == \'edit\' && vm.giftCardData.p_gc_open_price_min != \'\' && vm.UpdatePriceDetail(vm.giftCardData.p_gc_open_price)\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"33\" flex-gt-sm=\"33\" flex=\"100\" layout=\"column\" \nlayout-align=\"start start\" class=\"padding-5\" flex ng-if=\"vm.giftCardData.p_gc_open_price == 1\"><md-input-container \nclass=\"md-block tax-inputs margin-bottom-5\"><label translate=\"GIFTCARD.ALLOW_OPEN_AMOUNT_MAX_VALUE\"></label><input \ntype=\"text\" name=\"name\" ng-model=\"vm.giftCardData.p_gc_open_price_max\" required ng-model-options=\"{debounce: 500}\" \nallow-decimal-numbers \nng-blur=\"vm.flag == \'edit\' && vm.giftCardData.p_gc_open_price_max != \'\' && vm.UpdatePriceDetail(vm.giftCardData.p_gc_open_price)\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div class=\"md-errors-spacer\"></div></md-input-container></div></div>\n</div></div></div></div></div></form></div>");
$templateCache.put("app/main/apps/e-commerce/views/orders/orders.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar-text\"></md-icon><span>\n{{vm.title}}</span></div><div class=\"product-count secondary-text\"><span translate=\"EC.TOTAL_ORDERS\"></span> <span>\n{{vm.totalReservations}}</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" \nclass=\"search-input\" type=\"text\" placeholder=\"{{ \'SEARCH\' | translate }}\" ng-model=\"filterText\" flex></div><div \nclass=\"reservation-header-actions\" layout=\"row\" layout-align=\"end center\"><div class=\"reservation-type-filter\" \nng-if=\"vm.isDailyRentalsAvailable() && (!vm.pageType || (vm.pageType != \'boat\' && vm.pageType != \'rent\'))\"><md-select \nclass=\"propertyFilterSelect\" ng-model=\"vm.reservationFilter\" ng-change=\"vm.onReservationFilterChange()\" \naria-label=\"Reservation type filter\"><md-option ng-value=\"\'all\'\">All</md-option><md-option ng-value=\"\'night\'\">\nReservations</md-option><md-option ng-value=\"\'daily\'\">Daily Rentals</md-option></md-select></div><div \nclass=\"content-block-total\"><md-button type=\"submit\" id=\"add_Gift_Card\" ng-click=\"vm.exportCsvData()\" \nng-disabled=\"vm.exportInProgress\" class=\"md-raised md-cornered\" aria-label=\"custom sale\" \nng-if=\"(vm.currentHotel != \'126\') || (vm.currentUser == \'198\')\"><span>Export as CSV</span></md-button></div></div>\n</div></div></div></div><div class=\"content\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"main RowClick\" ms-scroll><mdt-table table-card=\"{visible: true, title: \'Customers\', columnSelector: true}\" \npaginated-rows=\"{isEnabled: true,rowsPerPageValues: [20,50]}\" selectable-rows=\"vm.canDelete\" \nselected-row-callback=\"selectedRowCallback(rows)\" mdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" \ndelete-row-callback=\"deleteSelectedItem()\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback, goToFirstPage)\" \nmdt-row=\"{\n					\'table-row-id-key\': \'confirmation_number\',\n					\'column-keys\': [\'itinerary_number\',\n									\'confirmation_number\',\n									\'product_name\',\n									\'created_date\',\n									\'customer_name\',\n									\'traveler\',\n									\'grand_total\',\n									\'paid_amount\',\n									\'remaining_amount\',\n									\'room_stay_status\',\n									\'room_stay_from\',\n									\'room_stay_to\',\n									\'source_of_creation\',\n									\'created_by_user\',\n									\'editId\' ]}\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>{{ \'EC.ITIN\' | translate }}</h5></mdt-column>\n<mdt-column align-rule=\"left\" column-sort=\"true\"><h5>{{ \'EC.CONF\' | translate }}</h5></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><h5>{{ \'EC.PROD\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" \ncolumn-sort=\"true\" \ncolumn-filter=\"{\'valuesProviderCallback\': createdValuesCallback,\'valuesTransformerCallback\': statusValuesTransformer,\'placeholderText\': \'Select date\',\'filterType\': \'checkbox\'}\">\n<h5>{{ \'EC.CREATED\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\n{{ \'EC.CUSTOMER\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\n{{ \'EC.TRAVELER\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\n{{ \'EC.TOTAL\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\n{{ \'EC.PAID\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\n{{ \'EC.REMAIN\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"false\" \ncolumn-filter=\"{\'valuesProviderCallback\': statusValuesCallback, \'valuesTransformerCallback\': statusValuesTransformer,\'placeholderText\': \'Select a status\',\'filterType\': \'dropdown\'}\">\n<h5>{{ \'EC.STATUS\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"false\" \ncolumn-filter=\"{ \'valuesProviderCallback\': checkinValuesCallback,\'valuesTransformerCallback\': statusValuesTransformer,\'placeholderText\': \'Select date\',\'filterType\': \'checkbox\' }\">\n<h5>{{ \'EC.CHECKIN\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"false\" \ncolumn-filter=\"{ \'valuesProviderCallback\': checkoutValuesCallback,  \'valuesTransformerCallback\': statusValuesTransformer,\'placeholderText\': \'Select date\', \'filterType\': \'checkbox\'}\">\n<h5>{{ \'EC.CHECKOUT\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\n{{ \'EC.SOURCE\' | translate }}</h5></mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><h5>\n{{ \'EC.BYUSER\' | translate }}</h5></mdt-column><mdt-column align-rule=\"right\" class=\"action-right-icons\"><h5></h5>\n</mdt-column></mdt-header-row><mdt-custom-cell html-content=\"true\" column-key=\"editId\"><a style=\"cursor:pointer\" \nng-click=\"clientScope.goToEditPage(value)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s16 ng-scope md-default-theme md-font material-icons icon-pencil\" role=\"img\" aria-label=\"icon-cog\"></md-icon>\n</a></mdt-custom-cell></mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/e-commerce/views/products/products.html","<div id=\"category\" class=\"lastcolumn_custom_three_icons page-layout simple fullwidth element-doc-page\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"content top-head\"><div class=\"content\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"main\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-hotel\"></md-icon><span translate=\"ROOMS.ROOMS\"></span></div><div \nclass=\"product-count secondary-text\"><span translate=\"ROOMS.TOTAL_ROOMS\"></span> <span>{{vm.totalProducts}}</span>\n</div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{\'SEARCH\' | translate}}\" ng-model=\"filterText\" flex></div><div class=\"logo\" layout=\"row\" \nlayout-align=\"center end\"><md-button ng-if=\"vm.userPermissions.indexOf(\'add_room\') != -1\" layout=\"row\" \nclass=\"md-raised md-cornered\" ng-click=\"openAddProductDialog(event,\'add\')\"><i class=\"icon-plus icon-plus-main\"></i>\n {{\"ROOMS.ROOM\" | translate}}</md-button></div></div></div></div></div><div class=\"content\"><div class=\"content\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"main RowClick\" ms-scroll><mdt-table \npaginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" selectable-rows=\"delete_product\" \nalternate-headers=\"\'contextual\'\" selected-row-callback=\"selectedRowCallback(rows)\" \ndelete-row-callback=\"deleteSelectedItem()\" mdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n					\'table-row-id-key\': \'product_id\',\n					\'column-keys\': [\n					\'product_name\',\n					\'room_type_name\',\n					\'product_status\',\n					\'product_id\'\n					],\n				}\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{\'ROOMS.ROOM_NAME\' | translate}}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{\'ROOMS.ROOM_TYPE\' | translate}}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{\'ROOMS.STATUS\' | translate}}</span></mdt-column>\n<mdt-column align-rule=\"left\"><span></span></mdt-column></mdt-header-row><mdt-custom-cell html-content=\"true\" \ncolumn-key=\"product_status\"><i ng-class=\"value==1?\'icon-checkbox-marked-circle green-500-fg\':\'icon-cancel red-500-fg\'\" \nclass=\"\"></i></mdt-custom-cell><mdt-custom-cell html-content=\"true\" column-key=\"product_id\"><a \nclass=\"cursorPointer action-icon-size\" ng-click=\"clientScope.openAddProductDialog($event, value)\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"md-font material-icons icon-cog\" role=\"img\" aria-label=\"icon-cog\"></md-icon></a>\n</mdt-custom-cell></mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/e-commerce/views/roomtype/roomtype.html","<div id=\"room-type\" class=\"page-layout simple tabbed\" layout=\"column\"><form id=\"roomTypeForm\" name=\"roomTypeForm\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" ng-click=\"vm.goBack()\"><md-icon\n md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\" ng-if=\"vm.flag == \'add\'\">\n{{ addtype+\".NEW_ROOM_TYPE\" | translate }}</div><div class=\"h2\" ng-if=\"vm.flag != \'add\'\">{{vm.pagetitle}}</div><div \nclass=\"subtitle secondary-text\" ng-if=\"vm.flag == \'edit\'\"><span translate=\"{{addtype}}.SUB_HEADER\"></span></div></div>\n</div></div><div ng-show=\"vm.flag == \'add\'\"><md-button class=\"md-raised md-background\" \nng-class=\"{\'md-blue-grey-A100-bg\': roomTypeForm.$invalid || roomTypeForm.$pristine || vm.uniqueError || (vm.roomTypeData.nbr_of_bedrooms==1 && vm.nameError) || (vm.roomTypeData.nbr_of_bedrooms > 1 && vm.nameRoomError) || vm.guestAmountError || vm.roomCodeExists}\" \nng-disabled=\"roomTypeForm.$invalid || roomTypeForm.$pristine || vm.uniqueError || (vm.roomTypeData.nbr_of_bedrooms==1 && vm.nameError) || (vm.roomTypeData.nbr_of_bedrooms > 1 && vm.nameRoomError) || vm.guestAmountError || vm.roomCodeExists\" \ntype=\"button\" ng-click=\"vm.addRoomType(vm.roomTypeData)\"><span translate=\"GROUPS.SAVE\"></span></md-button><md-button \nclass=\"md-raised md-background\" \nui-sref=\"{{vm.pageType == \'Boats\' ? \'app.e-commerce.boattypes\' : \'app.e-commerce.roomtypes\'}}\"><span \ntranslate=\"GROUPS.CANCEL\"></span></md-button></div></div><div class=\"content content-scroll\"><md-progress-linear \nmd-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><div \nclass=\"product-detail-form-container md-whiteframe-1dp height\"><div class=\"role-list-outer height-main\"><div \nclass=\"role-list-out white-bg relative-block featured-block-main\"><div class=\"div-outer-simple-block\"><div \nclass=\"form-title\" translate=\"{{addtype}}.UPLOAD_PICTURES\"></div><div class=\"errorDiv\" \nng-if=\"vm.failedFiles.length > 0\"><div class=\"error-li\" ng-repeat=\"error in vm.failedFiles\"><p \nng-bind=\"error.filename\"></p><p ng-bind-html=\"error.message\"></p></div></div><div id=\"product-image-uploader\"><div \nlayout=\"row\" flex layout-align=\"start center\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"65\" \nlayout-align=\"start center\" ngf-select ngf-drop ngf-drag-over-class=\"\'dragover\'\" ng-model=\"picFile\" \nngf-max-size=\"20MB\" accept=\"image/*\" id=\"my\" ngf-pattern=\"image/*\" class=\"cropArea my-3\" ngf-multiple=\"true\" \nmultiple=\"multiple\" style=\"cursor: pointer;height:226px;background: none\" multiple=\"multiple\" ngf-multiple=\"true\"><div \nclass=\"drop-text hint-text padding-10\"><span translate=\"{{addtype}}.DROP_TO_UPLOAD\"></span></div><div \nclass=\"upload-button margin-top-10 upload-img-blk-drag padding-10\" layout=\"column\" layout-align=\"center center\" flex>\n<div layout=\"row\" layout-align=\"center center\"><div layout=\"column\"><div class=\"uplodetxt-drop\"><div \nclass=\"uplode-btn-main-block\"><md-icon class=\"md-accent md-raised\" \nmd-svg-src=\"{{vm.feBaseUrl+\'angular-material-assets/img/icons/upload1.svg\'}}\" style=\"cursor: pointer\"></md-icon></div>\n<p class=\"no-margin padding-top-15\"><span translate=\"{{addtype}}.DRAG_IMG_HEADING\"></span></p><div \nstyle=\"overflow: hidden;width: 100%;height: 100%;top: 0;position: absolute;left: 0\"><ui-cropper image=\"picFile[0]\" \narea-type=\"rectangle\" result-image=\"croppedDataUrl\" aspect-ratio=\"2\" on-load-done=\"uploadFxn()\" \nresult-image-quality=\"1.0\" result-image-size=\"{w: 1130,h: 552}\" init-max-area=\"true\" style=\"opacity:0\"></ui-cropper>\n</div></div></div><span id=\"progressBar\" class=\"progress loading-process\" ng-show=\"vm.progress || vm.processing\"><div \nid=\"progress\" style=\"width:{{vm.progressnum}}%\" ng-bind=\"vm.progressnum + \'%\'\" ng-show=\"vm.progress\"></div><div \nid=\"processing\" ng-show=\"vm.processing\">Processing upload <img src=\"{{vm.feBaseUrl+\'images/ecommerce/loader.gif\'}}\">\n</div></span><button id=\"uploadImg\" ng-click=\"vm.uploadProductImages(picFile, $invalidFiles,croppedDataUrl)\" \nstyle=\"display: none\" data-dismiss=\"modal\" class=\"btn btn-primary\">Save changes</button></div></div></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"35\" class=\"padding-left-15 padding-right-15\"><div class=\"note\"><p \ntranslate=\"{{addtype}}.IMAGE_NOTE\" class=\"no-margin padding-bottom-10\"></p><span \ntranslate=\"{{addtype}}.DROP_IMG_HEADING\"></span></div></div></div><div class=\"images images-uploded-block\"><ul \nui-sortable=\"sortableOptions\" ng-model=\"vm.uploadedFiles\" class=\"list\"><li ng-repeat=\"image in vm.uploadedFiles\" \nstyle=\"background: none\"><div class=\"cross-icons\"><a ng-click=\"vm.deleteAddImage(image.filename)\" \nng-if=\"vm.flag == \'add\'\"><md-icon md-font-icon=\"icon-close \" class=\"close-icon1 white-fg font-size-12\"></md-icon></a><a\n ng-click=\"vm.deleteUploadedImage(image.catalog_product_media_id, image.type_id,image.filename,$event)\" \nng-if=\"vm.flag == \'edit\'\"><md-icon md-font-icon=\"icon-close\" class=\"close-icon1 white-fg font-size-12\"></md-icon></a>\n</div><div class=\"imageBox\" \nng-click=\"vm.imageViewer($event,image.filename,image.catalog_product_media_id,$index,image.cover_photo)\" \nstyle=\"cursor: pointer\"><img ng-src=\"{{image.url}}\"></div></li></ul></div><h3 \nstyle=\"font-weight: 500;color: #2d323e;padding:3px 10px\">Cover Photo</h3><div class=\"images images-uploded-block\"><ul \nui-sortable=\"sortableOptions\" class=\"list\" style=\"min-height: 50px\"><li ng-repeat=\"image in vm.uploadedFiles\" \nng-if=\"image.is_featured==\'1\' || (vm.flag == \'add\' && $index == vm.setIndex)\" \nstyle=\"min-height: 130px;min-width: 198px;background: none\"><div class=\"imageBox\" ng-click=\"vm.imageCropper()\" \nstyle=\"cursor: pointer;background: none\"><img ngf-select=\"vm.handleFileSelect($event)\" \nngf-drop=\"vm.handleFileSelect($event)\" ng-model=\"newPicFile\" ngf-max-size=\"2MB\" accept=\"image/*\" id=\"my\" \nngf-pattern=\"image/*\" class=\"cropArea my-3\" style=\"cursor: pointer\" id=\"fileInputImage\" ngf-multiple=\"false\" \nng-src=\"{{image.cover_photo ? image.cover_photo : image.url}}\"></div></li><h3 \nstyle=\"padding: 10px 34px;background: whitesmoke;width: 50%\" ng-if=\"vm.uploadedFiles.length == 0\">\nPlease upload product image to set cover picture.</h3></ul></div></div></div></div><div \nclass=\"role-list-out white-bg relative-block\"><div class=\"div-outer-simple-block\"><div class=\"form-title\" \ntranslate=\"{{addtype}}.MANAGE_ROOMS_DETAILS\"></div></div><div class=\"content\"><div class=\"row-block\" flex-gt-xs=\"100\" \nlayout=\"row\" layout-align=\"start start\" layout-wrap><div class=\"row-col padding-right-10 padding-left-10\" \nflex-gt-xs=\"100\" flex=\"100\" layout=\"column\" layout-align=\"end start\" flex ng-if=\"vm.roomType.childHotels.length>0\">\n<md-input-container class=\"md-block tax-inputs\"><label translate=\"{{addtype}}.OF_HOTEL\"></label><md-select \nname=\"of_hotel\" required ng-model=\"vm.roomTypeData.sub_hotel_id\" \nng-disabled=\"vm.roomTypeData.sub_hotel_id>0 && vm.flag == \'edit\'\" placeholder=\"{{ addtype+\'.OF_HOTEL\' | translate }}\" \nng-change=\"vm.getRoomsOfSubHotel(vm.roomTypeData.sub_hotel_id)\" md-no-asterisk=\"false\" \nng-model-options=\"{debounce: 500}\"><md-option value=\"{{item.hotel_id}}\" ng-repeat=\"item in vm.roomType.childHotels\">\n{{item.hotel_title}}</md-option></md-select><div class=\"md-error-spacer\"></div></md-input-container></div></div><div \nclass=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" \nflex ng-if=\"vm.roomType.childHotels.length>0 && vm.pageType == \'Rooms\'\"><md-input-container \nclass=\"md-block tax-inputs\"><label translate=\"{{addtype}}.ROOM_NUMBER\"></label><md-select multiple=\"multiple\" \nname=\"room_number\" ng-model=\"vm.roomTypeData.product_room_number\" \nplaceholder=\"{{ addtype+\'.ROOM_NUMBER\' | translate }}\" required \nng-change=\"vm.changeBedrooms();vm.flag == \'edit\' && vm.roomTypeData.product_name != \'\' && vm.saveEachProduct(vm.roomTypeData.product_name, room.product_id, key, vm.roomTypeData.product_room_number)\" \nng-model-options=\"{debounce: 500}\"><md-option ng-value=\"key\" \nng-repeat=\"(key, room_numbers) in vm.roomType.room_numbers\">{{room_numbers.room_no}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" \nflex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" flex \nng-if=\"vm.roomType.childHotels.length==0  && vm.pageType == \'Rooms\'\"><md-input-container class=\"md-block tax-inputs\">\n<label translate=\"{{addtype}}.ROOM_NUMBER\"></label><md-select multiple=\"multiple\" name=\"tax_id\" \nng-model=\"vm.roomTypeData.product_room_number\" placeholder=\"{{ addtype+\'.ROOM_NUMBER\' | translate }}\" required \nng-change=\"vm.changeBedrooms();vm.flag == \'edit\' && vm.roomTypeData.product_name != \'\' && vm.saveEachProduct(vm.roomTypeData.product_name, room.product_id, key, vm.roomTypeData.product_room_number)\" \nng-model-options=\"{debounce: 500}\"><md-option ng-value=\"key\" \nng-repeat=\"(key, room_numbers) in vm.roomType.room_numbers\">{{room_numbers.room_no}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" \nflex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" flex \nng-if=\"vm.roomType.childHotels.length>0  && vm.pageType == \'Boats\'\"><md-input-container class=\"md-block tax-inputs\">\n<label translate=\"{{addtype}}.ROOM_NUMBER\"></label><md-select multiple=\"multiple\" name=\"room_number\" \nng-model=\"vm.roomTypeData.product_room_number\" placeholder=\"{{ addtype+\'.ROOM_NUMBER\' | translate }}\" required \nng-change=\"vm.changeBedrooms();vm.flag == \'edit\' && vm.roomTypeData.product_name != \'\' && vm.saveEachProduct(vm.roomTypeData.product_name, room.product_id, key, vm.roomTypeData.product_room_number)\" \nng-model-options=\"{debounce: 500}\"><md-option ng-value=\"key\" \nng-repeat=\"(key, room_numbers) in vm.roomType.room_numbers\">{{room_numbers.boat_no}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" \nflex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" flex \nng-if=\"vm.roomType.childHotels.length==0 && vm.pageType == \'Boats\'\"><md-input-container class=\"md-block tax-inputs\">\n<label translate=\"{{addtype}}.ROOM_NUMBER\"></label><md-select multiple=\"multiple\" name=\"tax_id\" \nng-model=\"vm.roomTypeData.product_room_number\" placeholder=\"{{ addtype+\'.ROOM_NUMBER\' | translate }}\" required \nng-change=\"vm.changeBedrooms();vm.flag == \'edit\' && vm.roomTypeData.product_name != \'\' && vm.saveEachProduct(vm.roomTypeData.product_name, room.product_id, key, vm.roomTypeData.product_room_number)\" \nng-model-options=\"{debounce: 500}\"><md-option ng-value=\"key\" \nng-repeat=\"(key, room_numbers) in vm.roomType.room_numbers\">{{room_numbers.boat_no}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" \nflex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" flex \nng-if=\"vm.roomTypeData.nbr_of_bedrooms > 1 && vm.pageType == \'Rooms\'\"><md-input-container class=\"md-block tax-inputs\">\n<label translate=\"{{addtype}}.ROOM_TYPE_NAME\"></label><input ng-model=\"vm.roomTypeData.room_type_name\" \nname=\"room_type_name\" type=\"text\" required \nng-change=\"roomTypeForm.room_type_name.$valid && vm.saveEachField(vm.roomTypeData.room_type_name, \'room_type_name\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div ng-if=\"vm.nameRoomError\" \nclass=\"emailError\"><span translate=\"{{addtype}}.NAME_EXISTS\"></span></div></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" \nflex ng-if=\"vm.roomTypeData.nbr_of_bedrooms > 1 && vm.pageType == \'Boats\'\"><md-input-container \nclass=\"md-block tax-inputs\"><label translate=\"{{addtype}}.ROOM_TYPE_NAME\"></label><input \nng-model=\"vm.roomTypeData.room_type_name\" name=\"room_type_name\" type=\"text\" required \nng-change=\"roomTypeForm.room_type_name.$valid && vm.saveEachBoatField(vm.roomTypeData.room_type_name, \'room_type_name\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div ng-if=\"vm.nameRoomError\" \nclass=\"emailError\"><span translate=\"{{addtype}}.NAME_EXISTS\"></span></div></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" \nflex ng-if=\"vm.roomTypeData.nbr_of_bedrooms == 1 && vm.pageType == \'Rooms\'\"><md-input-container \nclass=\"md-block tax-inputs\"><label translate=\"{{addtype}}.ROOM_TYPE_TEXT_DYNAMIC\"></label><input \nng-model=\"vm.roomTypeData.product_name\" name=\"product_name\" type=\"text\" required \nng-change=\"vm.roomTypeData.product_name != \'\' && vm.roomTypeData.product_room_number != \'\'; vm.roomTypeData.product_name != \'\' && vm.uniqueProductName(vm.roomTypeData.product_name, vm.roomTypeData.roomData[0].product_id,vm.roomTypeData.sub_hotel_id);\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div ng-if=\"vm.nameError\" \nclass=\"emailError\"><span translate=\"{{addtype}}.NAME_EXISTS\"></span></div></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" \nflex ng-if=\"vm.roomTypeData.nbr_of_bedrooms == 1 && vm.pageType == \'Boats\'\"><md-input-container \nclass=\"md-block tax-inputs\"><label translate=\"{{addtype}}.ROOM_TYPE_TEXT_DYNAMIC\"></label><input \nng-model=\"vm.roomTypeData.product_name\" name=\"product_name\" type=\"text\" required \nng-change=\"vm.roomTypeData.product_name != \'\' && vm.roomTypeData.product_room_number != \'\'; vm.roomTypeData.product_name != \'\' && vm.saveBoatProductName(vm.roomTypeData.product_name, vm.roomTypeData.roomData[0].product_id,vm.roomTypeData.sub_hotel_id);\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div ng-if=\"vm.nameError\" \nclass=\"emailError\"><span translate=\"{{addtype}}.NAME_EXISTS\"></span></div></md-input-container></div></div><div \nclass=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" \nflex><md-input-container class=\"md-block tax-inputs\"><label translate=\"{{addtype}}.ROOM_DISPLAY_NAME\"></label><input \nng-model=\"vm.roomTypeData.room_display_name\" name=\"room_display_name\" type=\"text\" \nng-change=\"roomTypeForm.room_display_name.$valid && vm.saveEachField(vm.roomTypeData.room_display_name, \'room_display_name\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div ng-if=\"vm.nameRoomError\" \nclass=\"emailError\"><span translate=\"{{addtype}}.NAME_EXISTS\"></span></div></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" \nflex><md-input-container class=\"md-block tax-inputs\"><label translate=\"{{addtype}}.SELECT_TAX\"></label><md-select \nmultiple=\"multiple\" name=\"tax_id\" ng-model=\"vm.roomTypeData.tax_id\" \nplaceholder=\"{{ addtype+\'.SELECT_TAX\' | translate }}\" md-no-asterisk=\"false\" \nng-change=\"vm.flag == \'edit\' && roomTypeForm.tax_id.$valid && vm.saveEachField(vm.roomTypeData.tax_id, \'tax_id\')\" \nng-model-options=\"{debounce: 500}\" required><md-option class=\"capitalize\" value=\"{{tax.tax_id}}\" \nng-repeat=\"tax in vm.roomType.roomTaxData\" \nng-selected=\"vm.tax_id.indexOf((tax.tax_id)) != -1 && vm.flag == \'edit\'? \'selected\':\'\';\">\n{{tax.tax_name+\'@\'+tax.tax_value}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container>\n</div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"start start\" \nflex><md-input-container class=\"md-block tax-inputs\" ng-if=\"vm.pageType == \'Rooms\'\"><label \ntranslate=\"{{addtype}}.MAX_OCCUPANCY\"></label><md-select name=\"max_occupancy\" ng-model=\"vm.roomTypeData.max_occupancy\" \nplaceholder=\"{{ addtype+\'.MAX_OCCUPANCY\' | translate }}\" md-no-asterisk=\"false\" \nng-change=\"vm.flag == \'edit\' && roomTypeForm.max_occupancy.$valid && vm.saveEachField(vm.roomTypeData.max_occupancy, \'max_occupancy\')\" \nng-model-options=\"{debounce: 500}\"><md-option value=\"{{n + 1}}\" ng-repeat=\"n in [] | range:10\">{{n + 1}}</md-option>\n</md-select><div class=\"md-error-spacer\"></div></md-input-container><md-input-container class=\"md-block tax-inputs\" \nng-if=\"vm.pageType == \'Boats\'\"><label translate=\"{{addtype}}.BOAT_LENGTH\"></label><input type=\"text\" \nname=\"boat_length\" ng-model=\"vm.roomTypeData.boat_length\" \nng-change=\"roomTypeForm.boat_length.$valid && vm.saveEachField(vm.roomTypeData.boat_length, \'boat_length\')\" \nallow-decimal-numbers required ng-model-options=\"{debounce: 500}\" value=\"{{vm.roomTypeData.boat_length }}\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" \nflex><md-input-container class=\"md-block tax-inputs\" ng-if=\"vm.pageType == \'Rooms\'\"><label \ntranslate=\"{{addtype}}.NORMAL_OCCUPANCY\"></label><md-select name=\"max_occupancy\" \nng-model=\"vm.roomTypeData.normal_occupancy\" placeholder=\"{{ addtype+\'.NORMAL_OCCUPANCY\' | translate }}\" \nng-change=\"vm.flag == \'edit\' && roomTypeForm.max_occupancy.$valid && vm.saveEachField(vm.roomTypeData.normal_occupancy, \'normal_occupancy\')\" \nmd-no-asterisk=\"false\" ng-model-options=\"{debounce: 500}\"><md-option value=\"{{n + 1}}\" ng-repeat=\"n in [] | range:10\">\n{{n + 1}}</md-option></md-select><div class=\"md-error-spacer\"></div></md-input-container><md-input-container \nclass=\"md-block tax-inputs\" ng-if=\"vm.pageType == \'Boats\'\"><label translate=\"{{addtype}}.BOAT_WIDTH\"></label><input \ntype=\"text\" name=\"boat_width\" ng-model=\"vm.roomTypeData.boat_width\" \nng-change=\"roomTypeForm.boat_width.$valid && vm.saveEachField(vm.roomTypeData.boat_width, \'boat_width\')\" \nallow-decimal-numbers required ng-model-options=\"{debounce: 500}\" value=\"{{vm.roomTypeData.boat_width }}\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"start start\" \nclass=\"padding-5\" flex><md-input-container class=\"md-block tax-inputs\"><label translate=\"{{addtype}}.DESCRIPTION\">\n</label><textarea required ng-model=\"vm.roomTypeData.room_type_description\" name=\"room_type_description\" class=\"pb-32\" \nng-change=\"vm.flag == \'edit\' && roomTypeForm.room_type_description.$valid && vm.saveEachField(vm.roomTypeData.room_type_description, \'room_type_description\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></textarea></md-input-container>\n</div><div class=\"row-col padding-right-10 padding-left-10 checkboxalignlabel\" flex-gt-xs=\"50\" flex=\"100\" \nlayout=\"column\" layout-align=\"start start\" class=\"padding-5\" flex ng-if=\"vm.pageType == \'Rooms\'\"><md-input-container \nclass=\"md-block tax-inputs\"><md-checkbox md-no-ink aria-label=\"Checkbox No Ink\" class=\"pb-32\" ng-model=\"vm.rentType\">\nYearly rental System</md-checkbox></md-input-container></div></div></div></div><div \nclass=\"role-list-out white-bg relative-block\"><div class=\"div-outer-simple-block\"><div class=\"form-title\" \ntranslate=\"{{addtype}}.MANAGE_ROOMS_SETTINGS\"></div></div><div class=\"content\"><div class=\"row-block\" flex-gt-xs=\"100\" \nlayout=\"row\" layout-align=\"start start\" layout-wrap><div class=\"row-col padding-right-10 padding-left-10\" \nflex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"start start\" class=\"padding-5\" flex \nng-if=\"vm.loggedInUserRole  == 1\"><md-input-container class=\"md-block tax-inputs\"><label \ntranslate=\"{{addtype}}.ROOM_TYPE_CODE\"></label><input ng-model=\"vm.roomTypeData.room_type_code\" name=\"room_type_code\" \ntype=\"text\" required ng-change=\"vm.checkIfRoomTypeCodeExists();\" ng-model-options=\"{debounce: 500}\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"> <span ng-if=\"vm.roomCodeExists\" class=\"emailError\">Code already exists.</span>\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" \nlayout=\"column\" layout-align=\"start start\" class=\"padding-5\"><md-input-container class=\"md-block tax-inputs\" \nng-if=\"vm.pageType == \'Rooms\'\"><label translate=\"{{addtype}}.GUEST_AMOUNT\"></label><input type=\"text\" \nname=\"additional_guest_amounts\" ng-model=\"vm.roomTypeData.additional_guest_amounts\" \nng-change=\"roomTypeForm.additional_guest_amounts.$valid && vm.saveEachField(vm.roomTypeData.additional_guest_amounts, \'additional_guest_amounts\')\" \nallow-decimal-numbers ng-model-options=\"{debounce: 500}\" \nvalue=\"{{vm.roomTypeData.additional_guest_amounts | number:2 }}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div \nng-messages=\"roomTypeForm.roomTypeData.additional_guest_amounts.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-if=\"vm.guestAmountError == true\" class=\"emailError\"><span translate=\"{{addtype}}.MAX_GUEST_AMOUNT\"></span></div>\n</div></md-input-container><md-input-container class=\"md-block tax-inputs md-input-has-value\" \nng-init=\"vm.roomTypeData.non_smoking_ind == 0\" ng-if=\"vm.pageType == \'Boats\'\"><label translate=\"{{addtype}}.SMOKING\">\n</label><md-radio-group class=\"no-margin\" ng-model=\"vm.roomTypeData.non_smoking_ind\" \nng-checked=\"vm.roomTypeData.non_smoking_ind\" \nng-change=\"vm.flag == \'edit\' && vm.saveEachField(vm.roomTypeData.non_smoking_ind, \'non_smoking_ind\')\" \nng-model-options=\"{debounce: 500}\"><md-radio-button class=\"space-block-inline\" value=\"1\">Yes</md-radio-button>\n<md-radio-button class=\"space-block-inline margin-left-15\" value=\"0\">No</md-radio-button></md-radio-group>\n</md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" \nlayout-wrap ng-if=\"vm.pageType == \'Rooms\'\"><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" \nflex=\"100\" layout=\"column\" layout-align=\"start start\"><md-input-container class=\"md-block tax-inputs\"><label \ntranslate=\"{{addtype}}.MAX_INFANT_OCCUPANCY\"></label><md-select name=\"max_infant_occupancy\" \nng-model=\"vm.roomTypeData.max_infant_occupancy\" placeholder=\"{{ addtype+\'.MAX_INFANT_OCCUPANCY\' | translate }}\" \nmd-no-asterisk=\"false\" \nng-change=\"vm.flag == \'edit\' && roomTypeForm.max_infant_occupancy.$valid && vm.saveEachField(vm.roomTypeData.max_infant_occupancy, \'max_infant_occupancy\')\" \nng-model-options=\"{debounce: 500}\"><md-option value=\"{{n + 1}}\" ng-repeat=\"n in [] | range:2\">{{n + 1}}</md-option>\n</md-select><div class=\"md-error-spacer\"></div></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" \nclass=\"padding-5\"><md-input-container class=\"md-block tax-inputs\"><label translate=\"{{addtype}}.MAX_CHILD_OCCUPANCY\">\n</label><md-select name=\"max_child_occupancy\" ng-model=\"vm.roomTypeData.max_child_occupancy\" \nplaceholder=\"{{ addtype+\'.MAX_CHILD_OCCUPANCY\' | translate }}\" md-no-asterisk=\"false\" \nng-change=\"vm.flag == \'edit\' && roomTypeForm.max_child_occupancy.$valid && vm.saveEachField(vm.roomTypeData.max_child_occupancy, \'max_child_occupancy\')\" \nng-model-options=\"{debounce: 500}\"><md-option value=\"{{n + 1}}\" ng-repeat=\"n in [] | range:4\">{{n + 1}}</md-option>\n</md-select><div class=\"md-error-spacer\"></div></md-input-container></div></div><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap ng-if=\"vm.pageType == \'Rooms\'\"><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"start start\" \nclass=\"padding-5\"><md-input-container class=\"md-block tax-inputs md-input-has-value\" \nng-init=\"vm.roomTypeData.non_smoking_ind == 0\"><label translate=\"{{addtype}}.SMOKING\"></label><md-radio-group \nclass=\"no-margin\" ng-model=\"vm.roomTypeData.non_smoking_ind\" ng-checked=\"vm.roomTypeData.non_smoking_ind\" \nng-change=\"vm.flag == \'edit\' && vm.saveEachField(vm.roomTypeData.non_smoking_ind, \'non_smoking_ind\')\" \nng-model-options=\"{debounce: 500}\"><md-radio-button class=\"space-block-inline\" value=\"1\">Yes</md-radio-button>\n<md-radio-button class=\"space-block-inline margin-left-15\" value=\"0\">No</md-radio-button></md-radio-group>\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" \nlayout=\"column\" layout-align=\"end start\" class=\"padding-5\" data-ng-init=\"init()\"><md-input-container \nclass=\"md-block tax-inputs md-input-has-value\" ng-init=\"vm.roomTypeData.accessible_ind == \'0\'\"><label \ntranslate=\"{{addtype}}.ACCESSIBLE_INDICATOR\"></label><md-radio-group class=\"no-margin\" \nng-model=\"vm.roomTypeData.accessible_ind\" ng-checked=\"vm.roomTypeData.accessible_ind\" \nng-change=\"vm.flag == \'edit\' && vm.saveEachField(vm.roomTypeData.accessible_ind, \'accessible_ind\')\" \nng-model-options=\"{debounce: 500}\"><md-radio-button class=\"space-block-inline\" value=\"1\">Yes</md-radio-button>\n<md-radio-button class=\"space-block-inline margin-left-10\" value=\"0\">No</md-radio-button></md-radio-group>\n</md-input-container></div></div><div class=\"row-block\" flex=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap>\n<div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" \nlayout-align=\"start start\"><md-input-container class=\"md-block tax-inputs\"><label translate=\"{{addtype}}.STATUS\">\n</label><md-select placeholder=\"{{ addtype+\'.SELECT_STATUS\' | translate }}\" ng-model=\"vm.roomTypeData.status_type\" \nrequired \nng-change=\"vm.flag == \'edit\' && roomTypeForm.status_type.$valid && vm.saveEachField(vm.roomTypeData.status_type, \'status_type\')\" \nname=\"status_type\" ng-model-options=\"{debounce: 500}\"><md-option ng-value=\"stat.value\" ng-repeat=\"stat in vm.status\" \nng-selected=\"stat.value == vm.roomTypeData.status_type\">{{stat.name}}</md-option></md-select><div \nclass=\"md-error-spacer\"></div></md-input-container></div><div ng-if=\"vm.userPermissions.indexOf(\'bundle_rooms\') != -1\" \nng-show=\"vm.roomTypeData.product_room_number.length > 1\" class=\"row-col padding-right-10 padding-left-10\" \nflex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" class=\"padding-5\"><md-input-container \nclass=\"md-block md-input-has-value\"><md-switch class=\"no-margin\" ng-model=\"vm.roomTypeData.is_bundle\" \naria-label=\"Switch 1\"><span translate=\"{{addtype}}.BUNDLE\" ng-if=\"vm.roomTypeData.is_bundle\"></span> <span \ntranslate=\"{{addtype}}.NO_BUNDLE\" ng-if=\"!vm.roomTypeData.is_bundle\"></span></md-switch><div class=\"md-errors-spacer\">\n</div></md-input-container><md-input-container class=\"md-block tax-inputs\" \nng-if=\"vm.roomTypeData.is_bundle && vm.pageType == \'Rooms\'\"><label translate=\"{{addtype}}.ROOM_NUMBER\"></label>\n<md-select multiple=\"multiple\" ng-model=\"vm.roomTypeData.product_room_bundle\" \nplaceholder=\"{{ addtype+\'.ROOM_NUMBER\' | translate }}\" ng-change=\"vm.flag == \'edit\' && vm.saveEachBundleProduct()\" \nng-required=\"vm.roomTypeData.is_bundle\" ng-model-options=\"{debounce: 500}\"><md-option ng-value=\"key\" \nng-if=\"vm.roomTypeData.product_room_number.indexOf(key) != -1\" \nng-repeat=\"(key, room_numbers) in vm.roomType.room_numbers\">{{room_numbers.room_no}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container class=\"md-block tax-inputs\" \nng-if=\"vm.roomTypeData.is_bundle && vm.pageType == \'Boats\'\"><label translate=\"{{addtype}}.ROOM_NUMBER\"></label>\n<md-select multiple=\"multiple\" ng-model=\"vm.roomTypeData.product_room_bundle\" \nplaceholder=\"{{ addtype+\'.ROOM_NUMBER\' | translate }}\" ng-change=\"vm.flag == \'edit\' && vm.saveEachBundleProduct()\" \nng-required=\"vm.roomTypeData.is_bundle\" ng-model-options=\"{debounce: 500}\"><md-option ng-value=\"key\" \nng-if=\"vm.roomTypeData.product_room_number.indexOf(key) != -1\" \nng-repeat=\"(key, room_numbers) in vm.roomType.room_numbers\">{{room_numbers.boat_no}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div \nng-if=\"vm.userPermissions.indexOf(\'bundle_rooms\') != -1\" ng-show=\"vm.roomTypeData.product_room_number.length == 1\" \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" \nclass=\"padding-5\"><md-input-container class=\"md-block md-input-has-value\"><md-switch class=\"no-margin\" \nng-model=\"vm.roomTypeData.is_bundle\" aria-label=\"Switch 1\" \nng-change=\"vm.saveEachField(vm.roomTypeData.is_bundle, \'is_bundle\')\"><span translate=\"{{addtype}}.BUNDLE\" \nng-if=\"vm.roomTypeData.is_bundle\"></span> <span translate=\"{{addtype}}.NO_BUNDLE\" ng-if=\"!vm.roomTypeData.is_bundle\">\n</span></md-switch><div class=\"md-errors-spacer\"></div></md-input-container></div></div><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap ng-if=\"vm.pageType == \'Rooms\'\"><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"start start\" \nclass=\"padding-5\"><md-input-container class=\"md-block tax-inputs\"><label>Room Surcharge</label><input type=\"text\" \nname=\"surcharge\" ng-model=\"vm.roomTypeData.surcharge\" \nng-change=\"vm.saveEachField(vm.roomTypeData.surcharge, \'surcharge\')\" allow-decimal-numbers \nng-model-options=\"{debounce: 500}\" value=\"{{vm.roomTypeData.surcharge | number:2 }}\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" \nflex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" class=\"padding-5\" data-ng-init=\"init()\">\n<md-input-container class=\"md-block tax-inputs\"><label>Surcharge Description</label><input \nng-model=\"vm.roomTypeData.surcharge_description\" name=\"surcharge_description\" \nng-change=\"vm.saveEachField(vm.roomTypeData.surcharge_description, \'surcharge_description\')\" type=\"text\" \nng-model-options=\"{debounce: 800}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div>\n<div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" \nflex><md-input-container class=\"md-block tax-inputs\"><label translate=\"Additional Free Products\"></label><md-select \nmultiple=\"multiple\" name=\"tax_id\" ng-model=\"vm.roomTypeData.additional_products\" \nng-change=\"vm.saveAdditionalProducts(vm.roomTypeData.additional_products, \'additional_products\')\" \nplaceholder=\"Additional Free Products\" md-no-asterisk=\"false\" ng-model-options=\"{debounce: 500}\" required><md-option \nclass=\"capitalize\" value=\"{{additionalProducts}}\" ng-repeat=\"additionalProducts in vm.roomType.additionalProducts\">\n{{additionalProducts}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div></div>\n</div></div><div class=\"role-list-out white-bg relative-block\" ng-if=\"vm.roomTypeData.accessible_ind == true\"><div \nclass=\"div-outer-simple-block\"><div class=\"form-title\" translate=\"{{addtype}}.ACCESSIBLE_DETAILS\"></div></div><div \nclass=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"start start\" \nclass=\"padding-5\"><md-input-container class=\"md-block tax-inputs\"><label translate=\"{{addtype}}.ACCESSIBLE_FRONT_DOOR\">\n</label><input type=\"text\" name=\"accessible_front_door\" ng-model=\"vm.roomTypeData.accessible_front_door\" \nng-change=\"roomTypeForm.accessible_front_door.$valid && vm.saveEachField(vm.roomTypeData.accessible_front_door, \'accessible_front_door\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\">\n<md-input-container class=\"md-block tax-inputs\"><label translate=\"{{addtype}}.ACCESSIBLE_FRONT_DOOR_STEP\"></label>\n<input type=\"text\" name=\"accessible_front_door_step\" ng-model=\"vm.roomTypeData.accessible_front_door_step\" \nng-change=\"roomTypeForm.accessible_front_door_step.$valid && vm.saveEachField(vm.roomTypeData.accessible_front_door_step, \'accessible_front_door_step\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div>\n<div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"start start\" \nclass=\"padding-5\"><md-input-container class=\"md-block tax-inputs\"><label \ntranslate=\"{{addtype}}.ACCESSIBLE_BATHROOM_DOOR\"></label><input type=\"text\" name=\"accessible_bathroom_door\" \nng-model=\"vm.roomTypeData.accessible_bathroom_door\" \nng-change=\"roomTypeForm.accessible_bathroom_door.$valid && vm.saveEachField(vm.roomTypeData.accessible_bathroom_door, \'accessible_bathroom_door\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\">\n<md-input-container class=\"md-block tax-inputs\"><label translate=\"{{addtype}}.ACCESSIBLE_CLOSET_COUNTER\"></label><input\n type=\"text\" name=\"accessible_closet_to_counter\" ng-model=\"vm.roomTypeData.accessible_closet_to_counter\" \nng-change=\"roomTypeForm.accessible_closet_to_counter.$valid && vm.saveEachField(vm.roomTypeData.accessible_closet_to_counter, \'accessible_closet_to_counter\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div>\n<div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"start start\" \nclass=\"padding-5\"><md-input-container class=\"md-block tax-inputs\"><label \ntranslate=\"{{addtype}}.ACCESSIBLE_SHOWER_HANDLE\"></label><input type=\"text\" name=\"accessible_shower_handle\" \nng-model=\"vm.roomTypeData.accessible_shower_handle\" \nng-change=\"roomTypeForm.accessible_shower_handle.$valid && vm.saveEachField(vm.roomTypeData.accessible_shower_handle, \'accessible_shower_handle\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\">\n<md-input-container class=\"md-block tax-inputs\"><label translate=\"{{addtype}}.ACCESSIBLE_TOILET_HANDLE\"></label><input \ntype=\"text\" name=\"accessible_toilet_handle\" ng-model=\"vm.roomTypeData.accessible_toilet_handle\" \nng-change=\"roomTypeForm.accessible_toilet_handle.$valid && vm.saveEachField(vm.roomTypeData.accessible_toilet_handle, \'accessible_toilet_handle\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div>\n<div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"start start\" \nclass=\"padding-5\"><md-input-container class=\"md-block tax-inputs\"><label \ntranslate=\"{{addtype}}.ACCESSIBLE_SINK_HEIGHT\"></label><input type=\"text\" name=\"accessible_sink_height\" \nng-model=\"vm.roomTypeData.accessible_sink_height\" \nng-change=\"roomTypeForm.accessible_sink_height.$valid && vm.saveEachField(vm.roomTypeData.accessible_sink_height, \'accessible_sink_height\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"start start\" \nclass=\"padding-5\"><md-input-container class=\"md-block tax-inputs\"><label \ntranslate=\"{{addtype}}.ACCESSIBLE_TOILET_SEAT_HEIGHT\"></label><input type=\"text\" name=\"accessible_toilet_seat_height\" \nng-model=\"vm.roomTypeData.accessible_toilet_seat_height\" \nng-change=\"roomTypeForm.accessible_toilet_seat_height.$valid && vm.saveEachField(vm.roomTypeData.accessible_toilet_seat_height, \'accessible_toilet_seat_height\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div>\n</div><div class=\"role-list-out white-bg relative-block\"><div class=\"div-outer-simple-block\"><div class=\"form-title\" \ntranslate=\"{{addtype}}.MANAGE_DISPLAY_SETTINGS\"></div></div><div class=\"content\"><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10 relativeClass\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" \nlayout-align=\"start start\"><md-input-container class=\"md-block tax-inputs\"><label \ntranslate=\"{{addtype}}.SRP_COLOR_CODE\"></label><input ng-model=\"vm.roomTypeData.srp_card_color\" name=\"srp_card_color\" \ntype=\"text\" \nng-change=\"roomTypeForm.srp_card_color.$valid && vm.saveEachField(vm.roomTypeData.srp_card_color, \'srp_card_color\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container><color-picker \nng-model=\"vm.roomTypeData.srp_card_color\" options=\"vm.options\" api=\"api\" event-api=\"eventApi\"></color-picker></div><div\n class=\"row-col padding-right-10 padding-left-10 relativeClass\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" \nlayout-align=\"end start\" class=\"padding-5\"><md-input-container class=\"md-block tax-inputs\"><label \ntranslate=\"{{addtype}}.SRP_COLOR_CODE_SEC\"></label><input ng-model=\"vm.roomTypeData.srp_card_color_sec\" \nname=\"srp_card_color_sec\" type=\"text\" \nng-change=\"roomTypeForm.srp_card_color_sec.$valid && vm.saveEachField(vm.roomTypeData.srp_card_color_sec, \'srp_card_color_sec\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container><color-picker \nng-model=\"vm.roomTypeData.srp_card_color_sec\" options=\"vm.sec_color_options\" api=\"api1\" event-api=\"eventApi1\">\n</color-picker></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap>\n<div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" \nlayout-align=\"start start\" class=\"padding-5\" ng-if=\"vm.pageType == \'Rooms\'\"><md-input-container \nclass=\"md-block tax-inputs\"><label translate=\"{{addtype}}.BED_TYPE_CODE\"></label><md-select name=\"bed_type_id\" \nng-model=\"vm.roomTypeData.bed_type_id\" placeholder=\"{{ addtype+\'.BED_TYPE_CODE\' | translate }}\" md-no-asterisk=\"false\" \nng-change=\"vm.flag == \'edit\' && roomTypeForm.bed_type_id.$valid && vm.saveEachField(vm.roomTypeData.bed_type_id, \'bed_type_id\')\" \nng-model-options=\"{debounce: 500}\"><md-option value=\"{{bed.bed_type_id}}\" ng-repeat=\"bed in vm.roomType.bedTypeData\" \nng-bind=\"bed.bed_code_name\"></md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div\n class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" \nlayout-align=\"start start\" class=\"padding-5\" ng-if=\"vm.pageType == \'Boats\'\"><md-input-container \nclass=\"md-block tax-inputs\"><label translate=\"{{addtype}}.BED_TYPE_CODE\"></label><md-select name=\"boat_type_id\" \nng-model=\"vm.roomTypeData.bed_type_id\" placeholder=\"{{ addtype+\'.BED_TYPE_CODE\' | translate }}\" md-no-asterisk=\"false\" \nng-change=\"vm.flag == \'edit\' && roomTypeForm.boat_type_id.$valid && vm.saveEachField(vm.roomTypeData.bed_type_id, \'bed_type_id\')\" \nng-model-options=\"{debounce: 500}\"><md-option value=\"{{boat.boat_type_id}}\" \nng-repeat=\"boat in vm.roomType.bedTypeData\" ng-bind=\"boat.boat_code_name\"></md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" \nflex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" class=\"padding-5\" ng-if=\"vm.pageType == \'Rooms\'\">\n<md-input-container class=\"md-block tax-inputs\"><label translate=\"{{addtype}}.ROOM_LOCATION\"></label><md-select \nname=\"room_location_id\" ng-model=\"vm.roomTypeData.room_location_id\" \nplaceholder=\"{{ addtype+\'.ROOM_LOCATION\' | translate }}\" md-no-asterisk=\"false\" \nng-change=\"vm.flag == \'edit\' && roomTypeForm.room_location_id.$valid && vm.saveEachField(vm.roomTypeData.room_location_id, \'room_location_id\')\" \nng-model-options=\"{debounce: 500}\"><md-option ng-repeat=\"room in vm.roomType.roomLocationData\" \nvalue=\"{{room.room_location_id}}\" ng-bind=\"room.room_location_code_name\"></md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" layout-wrap><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" \nflex=\"100\" layout=\"column\" layout-align=\"start start\" ng-if=\"vm.pageType == \'Rooms\'\"><md-input-container \nclass=\"md-block tax-inputs\"><label translate=\"{{addtype}}.ROOM_VIEW\"></label><md-select name=\"room_view_id\" \nng-model=\"vm.roomTypeData.room_view_id\" placeholder=\"{{ addtype+\'.ROOM_VIEW\' | translate}}\" md-no-asterisk=\"false\" \nng-change=\"vm.flag == \'edit\' && roomTypeForm.room_view_id.$valid && vm.saveEachField(vm.roomTypeData.room_view_id, \'room_view_id\')\" \nng-model-options=\"{debounce: 500}\"><md-option ng-repeat=\"view in vm.roomType.roomViewData\" \nvalue=\"{{view.room_view_id}}\" ng-bind=\"view.room_view_code_name\">Select</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" \nflex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" class=\"padding-5\" ng-if=\"vm.pageType == \'Rooms\'\">\n<md-input-container class=\"md-block tax-inputs\"><label translate=\"{{addtype}}.ROOM_QUALITY\"></label><md-select \nname=\"guest_room_id\" ng-model=\"vm.roomTypeData.guest_room_id\" placeholder=\"{{ addtype+\'.ROOM_QUALITY\' | translate }}\" \nmd-no-asterisk=\"false\" \nng-change=\"vm.flag == \'edit\' && roomTypeForm.guest_room_id.$valid && vm.saveEachField(vm.roomTypeData.guest_room_id, \'guest_room_id\')\" \nng-model-options=\"{debounce: 500}\"><md-option value=\"{{quality.guest_room_id}}\" \nng-repeat=\"quality in vm.roomType.roomQualityData\" ng-bind=\"quality.guest_room_code_name\"></md-option></md-select><div \nclass=\"md-error-spacer\"></div></md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" layout-wrap ng-if=\"vm.pageType == \'Rooms\'\"><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"start start\" \nclass=\"padding-5\"><md-input-container class=\"md-block tax-inputs\"><label translate=\"{{addtype}}.ROOM_TYPE\"></label>\n<md-select name=\"bedroom_room_type\" ng-model=\"vm.roomTypeData.bedroom_room_type\" \nplaceholder=\"{{ addtype+\'.ROOM_DESC\' | translate }}\" md-no-asterisk=\"false\" \nng-change=\"roomTypeForm.bedroom_room_type.$valid && vm.saveEachField(vm.roomTypeData.bedroom_room_type, \'bedroom_room_type\')\" \nng-model-options=\"{debounce: 500}\"><md-option value=\"{{item}}\" ng-repeat=\"item in  vm.roomType.RoomTypeData\" \nng-bind=\"item\"></md-option></md-select><div class=\"md-error-spacer\"></div></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10 outer-block\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" \nlayout-align=\"start start\" class=\"padding-5\"><md-input-container class=\"md-block tax-inputs\"><label \ntranslate=\"{{addtype}}.ROOM_LENGTH\"></label><input ng-model=\"vm.roomTypeData.boat_length\" \nplaceholder=\"{{ addtype+\'.ROOM_LENGTH\' | translate }}\" name=\"boat_length\" type=\"text\" \nng-change=\"roomTypeForm.boat_length.$valid && vm.saveEachField(vm.roomTypeData.boat_length, \'boat_length\')\" \nallow-decimal-numbers ng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"> <span>FT\n</span></md-input-container><md-input-container class=\"md-block tax-inputs\"><label translate=\"{{addtype}}.ROOM_WIDTH\">\n</label><input ng-model=\"vm.roomTypeData.boat_width\" placeholder=\"{{ addtype+\'.ROOM_WIDTH\' | translate }}\" \nname=\"boat_width\" type=\"text\" \nng-change=\"roomTypeForm.boat_width.$valid && vm.saveEachField(vm.roomTypeData.boat_width, \'boat_width\')\" \nallow-decimal-numbers ng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"> <span>FT\n</span></md-input-container></div></div></div></div><div class=\"role-list-out white-bg relative-block\"><div \nclass=\"div-outer-simple-block\"><div class=\"form-title\" translate=\"{{addtype}}.GOOGLE_SEE_INSIDE\"></div></div><div \nclass=\"content\"><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"start start\" \nclass=\"padding-5\"><md-input-container class=\"md-block tax-inputs\"><label translate=\"{{addtype}}.INSIDE_VIEW_LONGITUDE\">\n</label><input ng-model=\"vm.roomTypeData.inside_view_longitude\" name=\"inside_view_longitude\" type=\"text\" \nng-change=\"roomTypeForm.inside_view_longitude.$valid && vm.saveEachField(vm.roomTypeData.inside_view_longitude, \'inside_view_longitude\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" \nclass=\"padding-5\"><md-input-container class=\"md-block tax-inputs\"><label translate=\"{{addtype}}.INSIDE_VIEW_LATITUDE\">\n</label><input ng-model=\"vm.roomTypeData.inside_view_latitude\" name=\"inside_view_latitude\" type=\"text\" \nng-change=\"roomTypeForm.inside_view_latitude.$valid && vm.saveEachField(vm.roomTypeData.inside_view_latitude, \'inside_view_latitude\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div>\n<div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"start start\" \nclass=\"padding-5\"><md-input-container class=\"md-block tax-inputs\"><label translate=\"{{addtype}}.INSIDE_VIEW_HEIGHT\">\n</label><input ng-model=\"vm.roomTypeData.inside_view_height\" name=\"inside_view_height\" type=\"text\" \nng-change=\"roomTypeForm.inside_view_height.$valid && vm.saveEachField(vm.roomTypeData.inside_view_height, \'inside_view_height\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" layout=\"column\" layout-align=\"end start\" \nclass=\"padding-5\"><md-input-container class=\"md-block tax-inputs\"><label translate=\"{{addtype}}.INSIDE_VIEW_PANO_ID\">\n</label><input ng-model=\"vm.roomTypeData.inside_view_pano_id\" name=\"inside_view_pano_id\" type=\"text\" \nng-change=\"roomTypeForm.inside_view_pano_id.$valid && vm.saveEachField(vm.roomTypeData.inside_view_pano_id, \'inside_view_pano_id\')\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div>\n</div></div></div></div></div></form></div><span postrender-action=\"vm.updateStatus()\"></span>");
$templateCache.put("app/main/apps/e-commerce/views/roomtypes/roomtypes.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-hotel\"></md-icon><span>\n{{vm.pageType == \'Boats\'?\'Slips\':vm.pageType}}</span></div><div class=\"product-count secondary-text\"><span>\n{{vm.pageType == \'Rooms\'? \'Total rooms\':\'Total slips\'}}</span> <span>{{vm.totalRoomTypes}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{\'SEARCH\' | translate}}\" ng-model=\"filterText\" flex></div><div class=\"logo\" layout=\"row\" \nlayout-align=\"center end\"><md-button layout=\"row\" class=\"md-raised md-cornered\" ng-click=\"vm.GotoAddUpdatePage()\" \nng-if=\"vm.userPermissions.indexOf(\'add_room\')!=-1\"><i class=\"icon-plus icon-plus-main\"></i>\n {{vm.pageType == \'Rooms\'? \'Room\':\'Slip\'}}</md-button></div></div></div></div></div><div class=\"content\"><div \nclass=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main RowClick\" ms-scroll><mdt-table \nclass=\"condencedTableText\" paginated-rows=\"{isEnabled: true, rowsPerPageValues: [20,50]}\" \nselectable-rows=\"vm.isDeleteAllowed\" alternate-headers=\"\'contextual\'\" \nselected-row-callback=\"selectedRowCallback(rows)\" delete-row-callback=\"deleteSelectedItem()\" \nmdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" mdt-row=\"headers\"><mdt-header-row><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><span>{{ addtype+\'.TITLE\' | translate}}</span></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><span>{{ addtype+\'.MAXOCCUPANCY\' | translate}}</span></mdt-column><mdt-column \nalign-rule=\"left\" column-sort=\"true\"><span class=\"condenced-desc\">{{ addtype+\'.DESCRIPTION\' | translate}}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{addtype+\'.STATUS\' | translate}}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span></span></mdt-column></mdt-header-row>\n<mdt-custom-cell html-content=\"true\" column-key=\"status_type\"><i \nng-class=\"value==\'active\'?\'icon-checkbox-marked-circle green-500-fg\':\'icon-cancel red-500-fg\'\" class=\"\"></i>\n</mdt-custom-cell><mdt-custom-cell html-content=\"true\" column-key=\"room_type_id\"><a style=\"cursor:pointer\" \nng-click=\"clientScope.editRoomType(value)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s16 ng-scope md-default-theme md-font material-icons icon-pencil\" role=\"img\" aria-label=\"icon-cog\"></md-icon>\n</a></mdt-custom-cell></mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/e-commerce/views/tax/tax-dialog.html","<md-dialog class=\"tax-dialog\" aria-label=\"New Task\"><form name=\"taxForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-tall white-fg\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon>\n</md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" \nlayout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\" class=\"middletoolbar\"><div \nclass=\"role-name\">{{vm.contact.name}}</div></div></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\"><md-content class=\"md-padding margin-top\"><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"TAXES.TAX_TYPE\"></label><md-icon md-font-icon=\"icon-currency-usd\">\n</md-icon><md-select ng-change=\"vm.checkTaxExists()\" placeholder=\"{{ \'TAXES.SELECT_TAX_TYPE\' | translate}}\" \nng-model=\"vm.tax.tax_name\" required><md-option class=\"capitalize\" ng-value=\"tax_val\" \nng-repeat=\"tax_val in vm.defaultTax\">{{tax_val}}</md-option></md-select><div ng-if=\"vm.tax_exists\" role=\"alert\"><div \nclass=\"emailError\"><span translate=\"TAXES.TAX_EXISTS\" class=\"pl-10\"></span></div></div><div class=\"md-errors-spacer\">\n</div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label translate=\"TAXES.TAX_VALUE\">\n</label><md-icon md-font-icon=\"icon-percent\" \nclass=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100 md-input-invalid1\"></md-icon><input required \ntype=\"number\" step=\"0.01\" name=\"rate\" ng-model=\"vm.tax.tax_value\" max=\"100\" min=\"0\" \nng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div ng-if=\"vm.notGoodPercent\" \nrole=\"alert\"><div class=\"emailError\"><span translate=\"TAXES.VALID_PERCENTAGE\"></span></div></div></md-input-container>\n</md-content></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end end\" flex=\"100\"><div layout=\"column\"><md-button type=\"submit\" ng-if=\"vm.taxButton\" \nng-click=\"vm.saveTax()\" class=\"send-button md-accent md-raised\" ng-disabled=\"taxForm.$invalid || taxForm.$pristine\" \naria-label=\"SAVE\" ng-class=\"taxForm.$invalid || taxForm.$pristine?\'md-blue-grey-A100-bg\':\'md-green-500-bg\'\" \ntranslate=\"SAVE\"></md-button><md-button type=\"submit\" ng-if=\"!vm.taxButton\" ng-click=\"vm.addNewTax()\" \nclass=\"send-button md-accent md-raised white-fg\" ng-disabled=\"taxForm.$invalid || taxForm.$pristine || vm.tax_exists\" \naria-label=\"Add Task\" \nng-class=\"taxForm.$invalid || taxForm.$pristine || vm.tax_exists?\'md-blue-grey-A100-bg\':\'md-green-500-bg\'\" \ntranslate=\"SAVE\"></md-button></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/taxes/taxes.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"logo-icon white-fg fontSizeTopHeading\"><md-icon md-font-icon=\"icon-currency-usd\"></md-icon></span><span \nclass=\"logo-text white-fg ng-scope fontSizeTopHeading\" translate=\"TAXES.TAXES\"></span></div></div><div \nng-if=\"vm.loggedinUserRole==1\"><md-button class=\"md-raised md-background\" ng-click=\"vm.addNewTax()\"><span \nstyle=\"text-transform:none\"><i class=\"icon-plus icon-plus-main\"></i> {{ \'TAXES.TAX_TYPE\' | translate}}</span>\n</md-button></div></div><div class=\"content scroll-height-sm\"><div class=\"main sm-hearder-top scroll-full-height\" \nms-scroll><div class=\"white-bg md-whiteframe-4dp white-scroll relative-block\" layout-align=\"center center\" \nlayout-padding><form name=\"TaxForm\" class=\"md-inline-form scroll-height\" novalidate><md-progress-linear \nmd-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><div layout=\"row\" layout-wrap \nng-repeat=\"taxInfo in vm.tax.currenttaxdata\"><md-input-container flex-gt-xs=\"33\" flex=\"100\" layout=\"column\" \nclass=\"md-block tax-inputs mb-0\" data-ng-animate=\"2\"><label class=\"ng-scope md-required\" role=\"button\" for=\"input_128\">\n{{taxInfo[0].tax_name}}</label><input \nng-change=\"vm.updateTax(taxInfo[0].tax_id,taxInfo[0].tax_value,taxInfo[0].tax_name,taxInfo[0].hotel_id)\" type=\"text\" \nname=\"taxInfo[0].tax_id\" ng-model=\"taxInfo[0].tax_value\" required=\"\" id=\"input_128\" aria-invalid=\"true\" \nng-model-options=\"{debounce: 700}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff \"><div \nng-if=\"vm.notGoodPercent[taxInfo[0].tax_id]\" role=\"alert\"><div style=\"font-size:12px;color:#d60606\"><span \ntranslate=\"TAXES.VALID_PERCENTAGE\"></span></div></div></md-input-container><md-input-container flex-gt-xs=\"33\" \nflex=\"100\" layout=\"column\" class=\"md-block tax-inputs mb-0\" data-ng-animate=\"2\" ng-if=\"taxInfo[1].tax_name\"><label \nclass=\"ng-scope md-required\" role=\"button\" for=\"input_128\">{{taxInfo[1].tax_name}}</label><input type=\"text\" \nname=\"taxInfo[1].tax_id\" ng-model=\"taxInfo[1].tax_value\" required=\"\" id=\"input_128\" aria-invalid=\"true\" \nng-change=\"vm.updateTax(taxInfo[1].tax_id,taxInfo[1].tax_value,taxInfo[1].tax_name,taxInfo[1].hotel_id)\" \nng-model-options=\"{debounce: 700}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff \"><div \nng-if=\"vm.notGoodPercent[taxInfo[1].tax_id]\" role=\"alert\"><div style=\"font-size:12px;color:#d60606\"><span \ntranslate=\"TAXES.VALID_PERCENTAGE\"></span></div></div></md-input-container><md-input-container flex-gt-xs=\"33\" \nflex=\"100\" layout=\"column\" class=\"md-block tax-inputs mb-0\" data-ng-animate=\"2\" ng-if=\"taxInfo[2].tax_name\"><label \nclass=\"ng-scope md-required\" role=\"button\" for=\"input_128\">{{taxInfo[2].tax_name}}</label><input type=\"text\" \nname=\"taxInfo[2].tax_id\" ng-model=\"taxInfo[2].tax_value\" required=\"\" id=\"input_128\" aria-invalid=\"true\" \nng-change=\"vm.updateTax(taxInfo[2].tax_id,taxInfo[2].tax_value,taxInfo[2].tax_name,taxInfo[2].hotel_id)\" \nng-model-options=\"{debounce: 700}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff \"><div \nng-if=\"vm.notGoodPercent[taxInfo[2].tax_id]\" role=\"alert\"><div style=\"font-size:12px;color:#d60606\"><span \ntranslate=\"TAXES.VALID_PERCENTAGE\"></span></div></div></md-input-container></div></form><h3 \nng-if=\"vm.tax.currenttaxdata.length == 0\"></h3></div></div></div></div>");
$templateCache.put("app/main/apps/guest-message-center/dialogs/media-preview/media-preview.dialog.html","<md-dialog class=\"gmc-media-preview-dialog contact-dialog\" aria-label=\"Message media\" \nstyle=\"overflow:visible;max-width:90vw;max-height:85vh;width:auto;height:auto;background:#fff;border-radius:4px;padding:0\">\n<md-dialog-content class=\"gmc-media-preview-content no-padding\" \nstyle=\"overflow:visible;position:relative;padding:12px\"><div class=\"cross-icons cross-icons-dilog\" \nng-click=\"vm.closeDialog()\"><a href=\"\" ng-click=\"vm.closeDialog(); $event.preventDefault();\"><md-icon \nmd-font-icon=\"icon-close\" class=\"close-icon1 white-fg font-size-12\"></md-icon></a></div><div \nclass=\"gmc-media-preview-body\" \nstyle=\"overflow:hidden;display:flex;align-items:center;justify-content:center;max-height:80vh\"><img \nclass=\"gmc-media-preview-img\" ng-src=\"{{vm.image}}\" alt=\"Message media\" \nstyle=\"display:block;max-width:86vw;max-height:78vh;width:auto;height:auto;object-fit:contain\"></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/guest-message-center/group-messages/dialogs/group-message-log-dialog.html","<md-dialog class=\"gmc-broadcast-log-dialog\" aria-label=\"Group message details\"><md-toolbar \nclass=\"md-accent-bg gmc-broadcast-log-toolbar\"><div class=\"md-toolbar-tools\"><div \nclass=\"gmc-broadcast-log-toolbar-title\"><md-icon md-font-icon=\"icon-bullhorn\" class=\"gmc-broadcast-log-toolbar-icon\">\n</md-icon><div><h2>Group message details</h2><div class=\"gmc-broadcast-log-toolbar-sub\" ng-if=\"vm.log && !vm.loading\">\n{{vm.formatSentAt(vm.log.created_at)}}</div></div></div><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"Close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"gmc-broadcast-log-dialog-content\"><div ng-if=\"vm.loading\" class=\"gmc-broadcast-log-loading\" \nlayout=\"column\" layout-align=\"center center\"><md-progress-circular md-diameter=\"36\" md-mode=\"indeterminate\">\n</md-progress-circular><span>Loading details...</span></div><div ng-if=\"!vm.loading && vm.errorMessage\" \nclass=\"gmc-broadcast-log-error\"><md-icon md-font-icon=\"icon-alert-circle\"></md-icon><span>{{vm.errorMessage}}</span>\n</div><div ng-if=\"!vm.loading && vm.log\"><div class=\"gmc-broadcast-log-message-card\"><div \nclass=\"gmc-broadcast-log-message-label\">Message</div><div class=\"gmc-broadcast-log-message\">{{vm.log.message}}</div>\n<div class=\"gmc-broadcast-log-chips\" ng-if=\"vm.propertyLabels.length\"><span class=\"gmc-broadcast-log-chip is-property\" \nng-repeat=\"hotel in vm.propertyLabels track by $index\">{{hotel}}</span></div></div><div \nclass=\"gmc-broadcast-log-stats\" layout=\"row\" layout-wrap><div class=\"gmc-broadcast-log-stat\"><span class=\"value\">\n{{vm.log.requested || 0}}</span> <span class=\"label\">Requested</span></div><div class=\"gmc-broadcast-log-stat is-sent\">\n<span class=\"value\">{{vm.log.sent || 0}}</span> <span class=\"label\">Sent</span></div><div \nclass=\"gmc-broadcast-log-stat is-skipped\"><span class=\"value\">{{vm.log.skipped || 0}}</span> <span class=\"label\">\nSkipped</span></div><div class=\"gmc-broadcast-log-stat is-failed\"><span class=\"value\">{{vm.log.failed || 0}}</span> \n<span class=\"label\">Failed</span></div></div><div class=\"gmc-broadcast-log-filters\" ng-if=\"vm.results.length\"><button \ntype=\"button\" class=\"gmc-broadcast-log-filter\" ng-class=\"{\'is-active\': vm.statusFilter === \'all\'}\" \nng-click=\"vm.setStatusFilter(\'all\')\">All <span>{{vm.results.length}}</span></button> <button type=\"button\" \nclass=\"gmc-broadcast-log-filter\" ng-class=\"{\'is-active\': vm.statusFilter === \'sent\'}\" \nng-click=\"vm.setStatusFilter(\'sent\')\">Sent <span>{{vm.counts.sent}}</span></button> <button type=\"button\" \nclass=\"gmc-broadcast-log-filter\" ng-class=\"{\'is-active\': vm.statusFilter === \'skipped\'}\" \nng-click=\"vm.setStatusFilter(\'skipped\')\">Skipped <span>{{vm.counts.skipped}}</span></button> <button type=\"button\" \nclass=\"gmc-broadcast-log-filter\" ng-class=\"{\'is-active\': vm.statusFilter === \'failed\'}\" \nng-click=\"vm.setStatusFilter(\'failed\')\">Failed <span>{{vm.counts.failed}}</span></button></div><div \nclass=\"gmc-broadcast-log-table-wrap\" ng-if=\"vm.filteredResults.length\"><table class=\"gmc-broadcast-log-table\"><thead>\n<tr><th>Confirmation</th><th>Channel</th><th>Status</th><th>Detail</th></tr></thead><tbody><tr \nng-repeat=\"row in vm.filteredResults track by $index\" ng-class=\"\'status-\' + row.status\"><td><div \nclass=\"gmc-broadcast-log-conf\">{{row.confirmation_number || \'—\'}}</div></td><td><span \nclass=\"gmc-broadcast-log-channel-badge\" ng-class=\"\'is-\' + (row.channel || \'unknown\')\">\n{{vm.getChannelLabel(row.channel)}}</span></td><td><span class=\"gmc-broadcast-log-status-badge\" \nng-class=\"\'is-\' + row.status\">{{vm.getStatusLabel(row.status)}}</span></td><td class=\"gmc-broadcast-log-detail\">\n{{vm.getDetailLabel(row)}}</td></tr></tbody></table></div><div ng-if=\"vm.results.length && !vm.filteredResults.length\" \nclass=\"gmc-broadcast-log-empty\">No recipients in this filter.</div><div ng-if=\"!vm.results.length\" \nclass=\"gmc-broadcast-log-empty\">No recipient details.</div></div></md-dialog-content><md-dialog-actions \nclass=\"gmc-broadcast-log-actions\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.close()\">Close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/guest-message-center/templates/message-templates/message-templates.html","<div id=\"message-templates\" class=\"page-layout simple tabbed full-height\" layout=\"column\"><div \nclass=\"header md-accent-bg relative-block\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"md-icon-button\" aria-label=\"Message Templates\"><md-icon\n md-font-icon=\"icon-message-text\"></md-icon></md-button><div class=\"h2\">Message Templates</div></div></div><div \nclass=\"gmc-main mt-main\" layout=\"row\" flex><div class=\"gmc-card mt-card\" layout=\"row\" flex><div \nclass=\"mt-column mt-template-types\" layout=\"column\" \nng-class=\"{\n                     \'is-empty-types\':\n                         !vm.loading &&\n                         !vm.templateTypes.length,\n                     \'is-page-loading\': vm.loading\n                 }\">\n<div class=\"mt-column-header\" ng-if=\"!vm.loading\"><span>Message Templates</span></div><div \nclass=\"mt-empty-state mt-page-loading\" flex ng-if=\"vm.loading\"><md-progress-circular md-diameter=\"48\" \nclass=\"mt-loading-spinner\" md-mode=\"indeterminate\"></md-progress-circular><p>Loading...</p></div><div class=\"mt-list\" \nng-if=\"!vm.loading && vm.templateTypes.length\"><div class=\"mt-list-item\" \nng-repeat=\"\n                            type in vm.templateTypes\n                            track by $index\n                        \" \nng-click=\"vm.selectTemplateType(type)\" \nng-class=\"{\n                            \'is-active\':\n                                vm.selectedTemplateType &&\n                                vm.selectedTemplateType.template_type ==\n                                type.template_type\n                        }\">\n<span>{{type.name}}</span></div></div><div class=\"mt-empty-state\" flex \nng-if=\"\n                         !vm.loading &&\n                         !vm.templateTypes.length\n                     \">\n<div class=\"mt-empty-icon-wrap mt-empty-icon-wrap-large\"><md-icon md-font-icon=\"icon-message-text\" \nclass=\"mt-empty-icon\"></md-icon></div><h3>No template types found</h3><p>No message template types are available.</p>\n</div></div><div class=\"mt-column mt-categories\" layout=\"column\" ng-if=\"vm.selectedTemplateType\"><div \nclass=\"mt-column-header add-category\"><md-button class=\"md-raised md-cornered mt-new-add-btn\" \nng-click=\"vm.openAddCategory($event)\" aria-label=\"Add Category\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"mt-new-add-icon\"></md-icon><span>New Category</span></md-button></div><div class=\"mt-empty-state\" flex \nng-if=\"vm.categoryLoading\"><md-progress-circular md-diameter=\"32\" class=\"mt-loading-spinner\" md-mode=\"indeterminate\">\n</md-progress-circular><p>Loading categories...</p></div><div class=\"mt-list\" \nng-if=\"!vm.categoryLoading && vm.categories.length\"><div class=\"mt-list-item\" \nng-repeat=\"\n                            category in vm.categories\n                            track by $index\n                        \" \nng-click=\"vm.selectCategory(category)\" \nng-class=\"{\n                            \'is-active\':\n                                vm.selectedCategory &&\n                                vm.selectedCategory.id ==\n                                category.id\n                        }\">\n<span class=\"mt-list-item-label\" flex>{{category.name}}</span><div class=\"mt-list-item-actions\" \nng-click=\"$event.stopPropagation()\"><span class=\"mt-row-action-btn\" data-tooltip=\"Edit Category\" \nng-click=\"vm.openEditCategory($event, category)\" aria-label=\"Edit category\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"mt-row-action-icon\"></md-icon></span></div></div></div><div class=\"mt-empty-state\" flex \nng-if=\"\n                         !vm.categoryLoading &&\n                         !vm.categories.length\n                     \">\n<div class=\"mt-empty-icon-wrap\"><md-icon md-font-icon=\"icon-folder-outline\" class=\"mt-empty-icon\"></md-icon></div><h3>\nNo categories found</h3><p>No categories are available for this template type.</p></div></div><div \nclass=\"mt-column mt-messages\" layout=\"column\" ng-if=\"vm.selectedCategory\"><div class=\"mt-column-header add-template\">\n<md-button class=\"md-raised md-cornered mt-new-add-btn\" ng-click=\"vm.openAddTemplate($event)\" \naria-label=\"Add Category\"><md-icon md-font-icon=\"icon-plus\" class=\"mt-new-add-icon\"></md-icon><span>New Template</span>\n</md-button></div><div class=\"mt-empty-state mt-message-loading\" ng-if=\"vm.templateLoading\"><md-progress-circular \nmd-diameter=\"48\" class=\"mt-loading-spinner\" md-mode=\"indeterminate\"></md-progress-circular><p>Loading messages...</p>\n</div><div class=\"mt-message-list\" \nng-if=\"\n                         !vm.templateLoading &&\n                         vm.templates.length\n                     \">\n<div class=\"mt-message-item\" \nng-repeat=\"\n                                template in vm.templates\n                                track by $index\n                            \">\n<div class=\"mt-message-row mt-message-name-row\"><div class=\"mt-message-value\">{{template.name}}</div><div \nclass=\"mt-list-item-actions mt-message-actions\" ng-click=\"$event.stopPropagation()\"><span class=\"mt-row-action-btn\" \ndata-tooltip=\"Edit Template\" ng-click=\"vm.openEditTemplate($event, template)\" aria-label=\"Edit template\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"mt-row-action-icon\"></md-icon></span><span \nclass=\"mt-row-action-btn mt-row-action-delete\" data-tooltip=\"Delete Template\" \nng-click=\"vm.deleteTemplate($event, template)\" aria-label=\"Delete template\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"mt-row-action-icon\"></md-icon></span></div></div><div class=\"mt-message-row mt-message-body-row\"><div \nclass=\"mt-message-value mt-message-body\">{{template.body}}</div></div></div></div><div class=\"mt-empty-state\" \nng-if=\"\n                        !vm.templateLoading &&\n                        !vm.templates.length\n                    \">\n<div class=\"mt-empty-icon-wrap mt-empty-icon-wrap-large\"><md-icon md-font-icon=\"icon-message-text\" \nclass=\"mt-empty-icon\"></md-icon></div><h3>No message templates available</h3><p>\nNo message templates are available in this category.</p></div></div><div class=\"mt-column mt-messages mt-dummy-column\" \nlayout=\"column\" \nng-if=\"\n                    !vm.loading &&\n                    !vm.selectedTemplateType &&\n                    vm.templateTypes.length\n                \">\n<div class=\"mt-dummy-content\"><div class=\"mt-empty-icon-wrap mt-empty-icon-wrap-large\"><md-icon \nmd-font-icon=\"icon-message-text\" class=\"mt-empty-icon\"></md-icon></div><h3>Select a template type</h3><p>\nChoose a template type to view categories.</p></div></div><div class=\"mt-column mt-messages mt-dummy-column\" \nlayout=\"column\" ng-if=\"!vm.selectedCategory && vm.selectedTemplateType\"><div class=\"mt-dummy-content\"><div \nclass=\"mt-empty-icon-wrap mt-empty-icon-wrap-large\"><md-icon md-font-icon=\"icon-message-text\" class=\"mt-empty-icon\">\n</md-icon></div><h3>Select a category</h3><p>Choose a template category to view messages.</p></div></div></div></div>\n</div>");
$templateCache.put("app/main/apps/rateRule/negotiatedRateRule/dialogs/nego-bulk-update-dialog.html","<md-dialog class=\"role-dialog bulkRateForm\" aria-label=\"New Task\" style=\"max-width:850px\"><form name=\"bulkRateForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"dialogbulkupdate\" ms-scroll style=\"background: rgb(245, 244, 244);width:100%\"><md-progress-linear \nmd-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><md-content class=\"md-padding\"><div \nclass=\"row-block margin-top-10\" layout=\"row\" layout-align=\"start start\" flex=\"100\" layout-wrap><div \nclass=\"role-list-outer height-main\" layout=\"row\" layout=\"row\" layout-wrap flex=\"100\"><div \nclass=\"role-list-out white-bg relative-block\" layout=\"row\" layout-wrap flex=\"100\" ng-if=\"vm.showRoomBoatsBulk\"><div \nclass=\"form-title mb-0 autowid mr-20\" flex=\"100\" layout=\"column\">Bulk update type?</div><md-input-container \nclass=\"padding-right-10 md-block tax-inputs mt-5 mb-0\" flex=\"100\" flex-xs=\"100\" layout=\"column\"><md-radio-group \nclass=\"no-margin\" ng-model=\"vm.type\" ng-click=\"vm.showRooms()\" required><md-radio-button class=\"space-block-inline\" \nvalue=\"rooms\">Rooms</md-radio-button><md-radio-button class=\"space-block-inline margin-left-10\" value=\"boats\">Marina\n</md-radio-button></md-radio-group></md-input-container></div><div class=\"role-list-out white-bg relative-block pv-20\" \nflex=\"100\" layout=\"row\" layout-wrap><md-input-container \nclass=\"padding-left-10 padding-right-10 md-block tax-inputs mb-0 mt-20\" flex=\"50\" flex-xs=\"100\" layout=\"column\"><label \nclass=\"margin-left-10\" translate=\"RATERULE.SET\">SET</label><md-select ng-model=\"vm.optionsSel\" name=\"status\" \nng-change=\"vm.changeView()\"><md-option value=\"{{key}}\" ng-repeat=\"(key,optionAvail) in vm.optionsAvail\">{{optionAvail}}\n</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container><md-input-container \nclass=\"padding-left-10 padding-right-10 md-block tax-inputs mb-30 mt-20\" flex=\"50\" flex-xs=\"100\" layout=\"column\" \nng-if=\"vm.optionsSel==1\"><md-radio-group class=\"no-margin\" ng-model=\"vm.selectRate\"><md-radio-button \nclass=\"space-block-inline\" value=\"new\">New Rate</md-radio-button><md-radio-button \nclass=\"space-block-inline margin-left-10\" value=\"derived\">Derived from Current</md-radio-button></md-radio-group>\n</md-input-container><div flex=\"{{vm.selectRate == \'new\' ? 50 : 33}}\" flex-xs=\"100\" layout=\"column\"><md-input-container\n class=\"padding-left-10 padding-right-10 mb-0 mt-20 md-icon-float md-block\" ng-if=\"vm.optionsSel==1\"><label \nclass=\"margin-left-10\" translate=\"RATERULE.RATE_TITLE\" ng-if=\"vm.selectRate == \'new\'\">Rate</label><label \nclass=\"margin-left-10\" translate=\"RATERULE.RATE_VALUE\" ng-if=\"vm.selectRate == \'derived\' && vm.optionsSel==1\">Value\n</label><input type=\"text\" name=\"room_type_price\" ng-model=\"vm.ratebulk.room_type_price\" \nng-change=\"bulkRateForm.room_type_price.$valid\" ng-model-options=\"{debounce: 500}\" required \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div ng-messages=\"bulkRateForm.room_type_price.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-if=\"vm.rateMaxError\" class=\"emailError\"><span translate=\"RATERULE.MAX_PRICE\"></span></div>\n</div></md-input-container></div><div class=\"row-block\" layout=\"row\" layout-align=\"start start\" flex=\"66\" layout-wrap \nng-if=\"vm.selectRate == \'derived\' && vm.optionsSel==1\"><md-input-container \nclass=\"padding-left-10 padding-right-10 md-block tax-inputs mb-0 mt-20\" flex=\"50\" flex-xs=\"100\" layout=\"column\"><label \nclass=\"margin-left-10\"></label><md-select name=\"rate_plan_adjust_indicator\" ng-model=\"vm.rate_plan_adjust_indicator\" \nng-change=\"vm.changeView()\"><md-option value=\"1\"><span><div class=\"md-text\">Increase by</div></span></md-option>\n<md-option value=\"0\"><span><div class=\"md-text\">Decrease by</div></span></md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container><md-input-container \nclass=\"padding-left-10 padding-right-10 md-block tax-inputs mb-0 mt-20\" flex=\"50\" flex-xs=\"100\" layout=\"column\"><label \nclass=\"margin-left-10\"></label><md-select name=\"rate_plan_percentage\" ng-model=\"vm.rate_plan_percentage\" \nng-change=\"vm.changeView()\"><md-option value=\"0\"><span><div class=\"md-text\">$</div></span></md-option><md-option \nvalue=\"1\"><span><div class=\"md-text\">%</div></span></md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container></div></div><div class=\"role-list-out white-bg relative-block\" flex=\"100\" layout=\"row\" \nlayout-wrap><div class=\"row-block datepiker-block-main\" layout=\"row\" layout-wrap flex=\"100\"><div layout=\"column\" \nflex-gt-xs=\"50\" flex=\"100\"><md-input-container class=\"mb-0 md-block tax-inputs full-width datepickerinput\" \ndata-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\" translate=\"RATERULE.FROM\">From</label><md-datepicker \nflex-gt-xs=\"100\" ng-model=\"vm.from_range\" md-open-on-focus required md-min-date=\"\" md-max-date=\"vm.to_range\">\n</md-datepicker></md-input-container></div><div layout=\"column\" flex-gt-xs=\"50\" flex=\"100\"><md-input-container \nclass=\"mb-0 md-block tax-inputs full-width datepickerinput\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"RATERULE.TO\">To</label><md-datepicker flex-gt-xs=\"100\" ng-model=\"vm.to_range\" md-open-on-focus required \nmd-min-date=\"vm.from_range\"></md-datepicker></md-input-container></div><div class=\"row-block daynamedilog\" \nlayout=\"row\" layout-xs=\"column\" flex=\"50\"><md-input-container class=\"mt-0 md-icon-float md-block margin-left-15\" \nng-repeat=\"(key, dayWeek) in vm.daysWeek\"><md-checkbox class=\"no-margin\" checklist-model=\"vm.daysWeek\" \nchecklist-value=\"key\" ng-click=\"vm.addSelectedDays(key)\" ng-checked=\"vm.ratebulk.selectedDays.indexOf(key)!=-1\">\n&nbsp; {{dayWeek}}</md-checkbox></md-input-container></div></div></div><div class=\"row-block\" flex=\"100\"><div \nclass=\"role-list-out white-bg relative-block\" ng-if=\"vm.optionsSel <= 1\"><div flex=\"100\" layout=\"row\" layout-wrap><div \nlayout=\"column\" flex=\"100\" layout-align=\"start start\"><div class=\"full-width\"><div \nclass=\"form-title mb-0 autowid mr-20\">Which rates?</div></div></div></div><div flex=\"100\" layout=\"row\" layout-wrap><div\n class=\"md-icon-float md-block\"><md-input-container class=\"capitalize no-margin padding-top-10 padding-bottom-10\">\n<md-checkbox class=\"no-margin\" ng-model=\"vm.selectAll[\'rate\']\" \nng-click=\"vm.selectall(\'rate\',vm.ratesData,\'rate_plan_id\')\">&nbsp; Select All</md-checkbox></md-input-container></div>\n<div class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\" ng-repeat=\"rates in vm.ratesData\"><md-input-container \nclass=\"capitalize no-margin padding-top-10 padding-bottom-10\"><md-checkbox class=\"no-margin\" \nng-click=\"vm.addSelectedData(\'rate\',rates.rate_plan_id,vm.ratesData,\'\',$event)\" \nng-checked=\"vm.ratebulk.seleRates.rate.indexOf(rates.rate_plan_id)!==-1\">&nbsp; {{rates.name}}</md-checkbox>\n</md-input-container></div></div></div></div><div class=\"role-list-out white-bg relative-block\" style=\"width: 100%\">\n<div flex=\"100\" layout=\"row\" layout-wrap><div layout=\"column\" flex=\"100\" layout-align=\"start start\"><div \nclass=\"full-width\"><div class=\"form-title mb-0 autowid mr-20\">Which Negotiated Type?</div></div></div></div><div \nflex=\"100\" layout=\"row\" layout-wrap><div class=\"md-icon-float md-block\"><md-input-container \nclass=\"capitalize no-margin padding-top-10 padding-bottom-10\"><md-checkbox class=\"no-margin\" \nng-model=\"vm.selectAll[\'negotiatedRates\']\" ng-click=\"vm.selectall(\'negotiatedRates\',vm.negotiatedRates,\'id\')\">\n&nbsp; Select All</md-checkbox></md-input-container></div><div class=\"md-icon-float md-block\" layout=\"row\" flex=\"100\" \nng-repeat=\"roomRate in vm.negotiatedRates\"><md-input-container \nclass=\"capitalize no-margin padding-top-10 padding-bottom-10\"><md-checkbox class=\"no-margin\" \nng-click=\"vm.addSelectedData(\'negotiatedRates\',roomRate.id,vm.negotiatedRates,\'\',$event)\" \nng-checked=\"vm.ratebulk.seleRates.negotiatedRates.indexOf(roomRate.id)!==-1\">&nbsp; {{roomRate.name}}</md-checkbox>\n</md-input-container></div></div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" \nng-click=\"vm.saveBulkPrice()\" \nng-class=\"bulkRateForm.$invalid || bulkRateForm.$pristine || vm.rateMaxError || vm.queryRunning || !vm.ratebulk.seleRates.rate || vm.ratebulk.seleRates.rate.length<=0 || !vm.ratebulk.seleRates.channels || vm.ratebulk.seleRates.channels.length<=0 || !vm.ratebulk.seleRates.rooms || vm.ratebulk.seleRates.rooms.length<=0 ?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"bulkRateForm.$invalid || bulkRateForm.$pristine || vm.rateMaxError || vm.queryRunning || (vm.optionsSel == 1 && (!vm.ratebulk.seleRates.rate || vm.ratebulk.seleRates.rate.length<=0)) || !vm.ratebulk.seleRates.negotiatedRates || vm.ratebulk.seleRates.negotiatedRates.length<=0\" \naria-label=\"SAVE\">Save<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.showLoader\"></md-progress-circular></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/rateRule/negotiatedRateRule/dialogs/rate-dialog.html","<md-dialog class=\"role-dialog\" aria-label=\"New Task\"><form name=\"rateRuleForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><md-content class=\"md-padding\"><md-input-container class=\"md-icon-float md-block\" \nng-if=\"vm.optionsSel==1\"><label translate=\"RATERULE.RATE_TITLE\"></label><md-icon md-font-icon=\"icon-currency-usd\" \nclass=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100 md-input-invalid\"></md-icon><input type=\"text\" \nname=\"room_type_price\" ng-model=\"vm.raterule.room_type_price\" required ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n<div ng-messages=\"rateRuleForm.room_type_price.$error\" role=\"alert\" multiple=\"multiple\"><div ng-if=\"vm.rateMaxError\" \nclass=\"emailError\"><span translate=\"RATERULE.MAX_PRICE\"></span></div></div></md-input-container><div \nclass=\"row-block datepiker-block-main\" layout=\"row\" layout-xs=\"column\"><md-input-container \nclass=\"md-block tax-inputs full-width\" data-ng-animate=\"1\" flex style=\"margin-left:-10px\"><label class=\"ng-scope\" \nrole=\"button\" translate=\"RATERULE.FROM\">From</label><md-datepicker ng-model=\"vm.from_range\" md-open-on-focus required \nflex style=\"width:80%\" md-min-date=\"vm.currentDateValue\" md-max-date=\"vm.to_range\"></md-datepicker>\n</md-input-container><md-input-container class=\"md-block tax-inputs full-width\" data-ng-animate=\"1\" flex><label \nclass=\"ng-scope\" role=\"button\" translate=\"RATERULE.TO\">To</label><md-datepicker ng-model=\"vm.to_range\" \nmd-open-on-focus required style=\"width:80%\" md-min-date=\"vm.from_range\"></md-datepicker></md-input-container></div><div\n class=\"row-block\" layout=\"row\" layout-xs=\"column\"><md-input-container class=\"no-margin md-icon-float md-block\" \nng-repeat=\"(key, dayWeek) in vm.daysWeek\" flex><md-checkbox class=\"no-margin no-padding\" type=\"checkbox\" \nchecklist-model=\"vm.daysWeek\" checklist-value=\"key\" ng-click=\"vm.addSelectedDays(key)\" \nng-checked=\"vm.selectedDays.indexOf(key)!=-1\">&nbsp;<span>{{dayWeek}}</span></md-checkbox></md-input-container></div>\n</md-content></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" ng-click=\"vm.saveRowPrice()\" \nng-class=\"!rateRuleForm.$invalid && !rateRuleForm.$pristine && !vm.rateMaxError && !vm.requestProgressing?\'md-raised md-green-500-bg submit-button white-fg\':\'md-raised md-accent submit-button grey-100-fg\'\" \nng-disabled=\"rateRuleForm.$invalid || rateRuleForm.$pristine || vm.rateMaxError || vm.requestProgressing \" \naria-label=\"SAVE\">Save<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.showLoader\"></md-progress-circular></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/restaurant/settings/dialog/addEdit.html","<md-dialog class=\"restauran\" aria-label=\"New Task\" style=\"max-width:500px;width:100%\"><form name=\"settingForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent-bg white-fg\" style=\"background:rgb(0,188,212)\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" \nflex=\"100\"><md-input-container class=\"md-block mb-0\"><label>Name</label><input name=\"name\" \nng-model=\"vm.settings.field_name\" required md-autofocus ng-change=\"vm.checkSameNameExist()\" \nng-model-options=\"{debounce: 600}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div \nng-if=\"vm.showAlreadyExistError\" role=\"alert\"><span class=\"errortxt\">Same field name already exist</span></div>\n</md-input-container></div><div layout=\"column\" flex=\"100\"><md-input-container class=\"md-block mb-0\"><md-select \nng-model=\"vm.settings.field_type\" placeholder=\"Select Type\" required><md-option ng-value=\"type.id\" \nng-repeat=\"type in vm.optionTypes\">{{ type.name }}</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div layout=\"column\" flex=\"100\"><md-checkbox ng-model=\"vm.settings.has_cost\" \naria-label=\"No Ink Effects\">Has Cost</md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" \nng-click=\"vm.saveTask()\" \nng-class=\"(settingForm.$invalid || vm.showAlreadyExistError) ?\'md-accent md-button ng-scope md-ink-ripple md-raised submit-button white-fg\' : \'md-green-500-bg md-button ng-scope md-ink-ripple md-raised submit-button white-fg\'\" \nng-disabled=\"settingForm.$invalid || vm.showAlreadyExistError\" aria-label=\"SAVE\" translate=\"TODO.SAVE\" \ntranslate-attr-aria-label=\"TODO.SAVE\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/settings/emails/configuration/config.html","<div id=\"simple-table\" class=\"config-page page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"s24\"></md-icon></span><span class=\"logo-text white-fg\" translate=\"SETTINGS.EMAILSET\">Configuration</span></div>\n</div></div><div class=\"content\"><div class=\"main sm-hearder-top\" ms-scroll><md-progress-linear \nmd-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><div class=\"white-bg md-whiteframe-4dp\" \nlayout-align=\"center center\" layout-padding><form name=\"generalSettingsForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"row\" layout-align=\"start\" flex class=\"padding-left-10 padding-right-10\" layout-wrap><div \nng-repeat=\"(key, setting) in vm.showSettings\" class=\"ph-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\">\n<md-input-container class=\"mb-25\"><label>{{setting.setting_title}}</label><md-select ng-change=\"vm.saveGeneral(key)\" \nng-model-options=\"{debounce: 500}\" ng-model=\"vm.showSettings[key].value\"><md-option ng-value=\"0\" \nng-selected=\"{{template.template_id == 0}}\">No Email</md-option><md-option ng-value=\"template.template_id\" \nng-selected=\"{{template.template_id == setting.value}}\" ng-repeat=\"template in vm.templates\">{{template.template_name}}\n</md-option></md-select></md-input-container></div></div></form></div></div></div></div>");
$templateCache.put("app/main/apps/settings/emails/templates/templates.html","<div id=\"category\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"content top-head\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-email\"></md-icon><span \ntranslate=\"SETTINGS.TEMP\"></span></div><div class=\"product-count secondary-text\"><span \ntranslate=\"SETTINGS.TOTAL_TEMPLATES\"></span> <span>{{vm.totalTemplates}}</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"{{ \'SEARCH\' | translate }}\" ng-model=\"filterText\" flex></div><div class=\"logo\" layout=\"row\" \nlayout-align=\"center end\" ng-if=\"vm.userPermissions.indexOf(\'add_email_template\') != -1\"><md-button \nclass=\"md-raised md-cornered\" id=\"add-contact-button\" ng-click=\"vm.gotoAddEditTemplate($event)\" \naria-label=\"add Template\" translate translate-attr-aria-label=\"SETTINGS.ADD_NEW_PRODUCT\"><i \nclass=\"icon-plus icon-plus-main\"></i> {{ \'SETTINGS.TEMPLATE\' | translate }}</md-button></div></div></div></div></div>\n<div class=\"content\"><div class=\"content\" layout=\"row\" layout-align=\"space-between center\"><div class=\"main RowClick\" \nms-scroll><mdt-table table-card=\"{visible: false, title: \'Customers\'}\" \npaginated-rows=\"{isEnabled: true,rowsPerPageValues: [20,50]}\" selectable-rows=\"vm.isDeletedAllowed\" \nalternate-headers=\"\'contextual\'\" selected-row-callback=\"selectedRowCallback(rows)\" \nmdt-row-paginator=\"paginatorCallback(page, pageSize, options)\" delete-row-callback=\"deleteSelectedItem()\" \nmdt-row-paginator-error-message=\"Ooops!  Looks like we had a hiccup.  Try refreshing your page.\" \nmdt-trigger-request=\"getLoadResultsCallback(loadPageCallback)\" \nmdt-row=\"{\n				\'table-row-id-key\': \'template_id\',\n				\'column-keys\': [\'template_name\', \'template_subject\', \'template_trigger\', \'EditId\' ]}\">\n<mdt-header-row><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'SETTINGS.PRODUCT_NAME\' | translate }}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'SETTINGS.TEMP_SUBJ\' | translate }}</span>\n</mdt-column><mdt-column align-rule=\"left\" column-sort=\"true\"><span>{{ \'Triggers At\' | translate }}</span></mdt-column>\n<mdt-column align-rule=\"right\" class=\"action-right-icons\"><span></span></mdt-column></mdt-header-row><mdt-custom-cell \ncolumn-key=\"EditId\"><a class=\"cursorPointer action-icon-size\" ng-click=\"clientScope.addmodel($event, value)\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"md-font material-icons icon-cog\" role=\"img\" aria-label=\"icon-cog\"></md-icon></a>\n</mdt-custom-cell></mdt-table></div></div></div></div>");
$templateCache.put("app/main/apps/settings/triggers/dialogs/trigger-delete-dialog.html","<md-dialog class=\"gmc-trigger-dialog gmc-trigger-delete-dialog\" aria-label=\"Delete trigger\"><header \nclass=\"gmc-trigger-toolbar\"><div class=\"gmc-trigger-toolbar-inner\"><div class=\"gmc-trigger-toolbar-title\" \ntranslate=\"MESSAGE_CENTER_TRIGGERS.DELETE_TITLE\">Delete Trigger</div></div></header><md-dialog-content><div \nclass=\"md-padding custom-common-dailog gmc-trigger-delete-body\"><p class=\"gmc-trigger-delete-message\" \ntranslate=\"MESSAGE_CENTER_TRIGGERS.DELETE_CONFIRM\">Are you sure you want to delete this trigger?</p></div>\n</md-dialog-content><md-dialog-actions class=\"gmc-trigger-delete-actions\" layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-raised md-primary gmc-trigger-delete-cancel\" ng-click=\"vm.cancel()\" \ntranslate=\"MESSAGE_CENTER_TRIGGERS.DELETE_CANCEL\">CANCEL</md-button><md-button \nclass=\"md-raised md-primary gmc-trigger-delete-confirm\" ng-click=\"vm.confirm()\" \ntranslate=\"MESSAGE_CENTER_TRIGGERS.DELETE\">DELETE</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/settings/triggers/trigger/trigger.html","<div id=\"room-type\" class=\"page-layout simple tabbed trigger-detail\" layout=\"column\"><form id=\"triggerForm\" \nname=\"triggerForm\" novalidate><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" \nng-click=\"vm.gotoTriggers()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\" ng-if=\"!vm.isEdit\">\nNew Trigger</div><div class=\"h2\" ng-if=\"vm.isEdit\">{{vm.form.name || \'Edit Trigger\'}}</div><div \nclass=\"subtitle secondary-text\" ng-if=\"vm.isEdit\"><span>Trigger Detail</span></div></div></div></div><div><md-button \nclass=\"md-raised md-background\" ng-class=\"{\'md-blue-grey-A100-bg\': !vm.canSave()}\" ng-disabled=\"!vm.canSave()\" \ntype=\"button\" ng-click=\"vm.save()\"><span>Save</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"vm.gotoTriggers()\"><span>Cancel</span></md-button></div></div><div class=\"content content-scroll\">\n<md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isLoading\"></md-progress-linear><div \nclass=\"product-detail-form-container md-whiteframe-1dp height\"><div class=\"role-list-outer height-main\"><div \nclass=\"trigger-card\"><div class=\"trigger-card-header\"><md-icon md-font-icon=\"icon-cog\"></md-icon><div \nclass=\"form-title\">Trigger Configuration</div></div><div class=\"trigger-card-content\"><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" \nflex><md-input-container class=\"md-block tax-inputs\"><label>Trigger Name</label><input type=\"text\" name=\"name\" \nng-model=\"vm.form.name\" required autocomplete=\"off\"></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" \nflex ng-if=\"vm.subHotels.length > 0\"><md-input-container class=\"md-block tax-inputs\"><label>Property</label><md-select \nng-model=\"vm.form.sub_hotel_id\" placeholder=\"All Hotels\"><md-option ng-value=\"null\">All Hotels</md-option><md-option \nng-repeat=\"sub in vm.subHotels\" ng-value=\"sub.id\">{{sub.name}}</md-option></md-select></md-input-container></div></div>\n<div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" \nflex><md-input-container class=\"md-block tax-inputs\"><label>When This Happens</label><md-select \nng-model=\"vm.form.event_type\" required><md-option ng-repeat=\"option in vm.eventOptions\" ng-value=\"option.id\">\n{{option.label}}</md-option></md-select></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" \nflex><md-input-container class=\"md-block tax-inputs\"><label>Timing</label><md-select \nng-model=\"vm.form.timing_relation\" required><md-option ng-repeat=\"option in vm.timingOptions\" ng-value=\"option.id\">\n{{option.label}}</md-option></md-select></md-input-container></div></div></div></div><div class=\"trigger-card\" \nng-if=\"vm.form.timing_relation !== \'at\'\"><div class=\"trigger-card-header\"><md-icon md-font-icon=\"icon-calendar-clock\">\n</md-icon><div class=\"form-title\">Timing</div></div><div class=\"trigger-card-content\"><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"100\" layout=\"column\" layout-align=\"end start\" \nflex><md-input-container class=\"md-block tax-inputs\"><label>Schedule Type</label><md-select \nng-model=\"vm.form.timing_type\" required><md-option ng-repeat=\"option in vm.scheduleTypes\" ng-value=\"option.id\">\n{{option.label}}</md-option></md-select></md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" \nlayout=\"row\" layout-align=\"start start\" layout-wrap ng-if=\"vm.form.timing_type === \'relative\'\"><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" \nflex><md-input-container class=\"md-block tax-inputs\"><label>Time Offset</label><input type=\"number\" min=\"1\" step=\"1\" \nng-model=\"vm.form.offsetValue\" required autocomplete=\"off\"></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" \nflex><md-input-container class=\"md-block tax-inputs\"><label>Unit</label><md-select ng-model=\"vm.form.offsetUnit\" \nrequired><md-option ng-repeat=\"option in vm.unitOptions\" ng-value=\"option.id\">{{option.label}}</md-option></md-select>\n</md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" \nlayout-wrap ng-if=\"vm.form.timing_type === \'fixed_time\'\"><div class=\"row-col padding-right-10 padding-left-10\" \nflex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" flex><md-input-container \nclass=\"md-block tax-inputs\"><label>{{vm.getFixedTimeDayLabel()}}</label><md-select ng-model=\"vm.form.offsetValue\" \nrequired><md-option ng-repeat=\"option in vm.getFixedTimeDayOptions()\" ng-value=\"option.id\">{{option.label}}</md-option>\n</md-select></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" \nflex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" flex><md-input-container class=\"md-block tax-inputs mt-15\">\n<label>Send At</label><input type=\"time\" ng-model=\"vm.form.timing_fixed_time_model\" required autocomplete=\"off\" \nplaceholder=\"HH:mm\"></md-input-container></div></div></div></div><div class=\"trigger-card\"><div \nclass=\"trigger-card-header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-filter-outline\"></md-icon><div class=\"form-title\">Conditions\n</div></div><md-button class=\"md-raised btn-add-condition\" ng-click=\"vm.addCondition()\" aria-label=\"Add Condition\">\n<md-icon md-font-icon=\"icon-plus\" class=\"icon-add-condition\"></md-icon>Add Condition</md-button></div><div \nclass=\"trigger-card-content\"><div ng-if=\"!vm.form.conditions || vm.form.conditions.length === 0\" \nclass=\"empty-conditions\">No conditions added.</div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" layout-wrap ng-repeat=\"cond in vm.form.conditions track by $index\" class=\"condition-row\">\n<div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"25\" layout=\"column\" \nlayout-align=\"end start\" flex><md-input-container class=\"md-block tax-inputs\"><label>Only If</label><md-select \nng-model=\"cond.condition_type\" required ng-change=\"vm.onConditionTypeChange(cond)\"><md-option \nng-repeat=\"type in vm.conditionTypes\" ng-value=\"type.id\">{{type.label}}</md-option></md-select></md-input-container>\n</div><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"25\" layout=\"column\" \nlayout-align=\"end start\" flex><md-input-container class=\"md-block tax-inputs\"><label>Rule</label><md-select \nng-model=\"cond.operator\" required><md-option ng-repeat=\"op in vm.getConditionOperators(cond.condition_type)\" \nng-value=\"op.id\">{{op.label}}</md-option></md-select></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"25\" layout=\"column\" layout-align=\"end start\" \nflex><md-input-container class=\"md-block tax-inputs\"><label>Value</label><input type=\"text\" ng-model=\"cond.value\" \nrequired autocomplete=\"off\"></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" \nflex=\"100\" flex-gt-xs=\"15\" layout=\"column\" layout-align=\"end start\" flex ng-if=\"cond.operator === \'between\'\">\n<md-input-container class=\"md-block tax-inputs\"><label>To Value</label><input type=\"text\" ng-model=\"cond.value_to\" \nrequired autocomplete=\"off\"></md-input-container></div><div class=\"row-col\" layout=\"column\" \nlayout-align=\"center center\" style=\"margin-top: 20px; padding-left: 10px; padding-right: 10px\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"red-A800-fg onlycursorPointer\" ng-click=\"vm.removeCondition($index)\"></md-icon></div>\n</div></div></div><div class=\"trigger-card\"><div class=\"trigger-card-header\"><md-icon md-font-icon=\"icon-message-text\">\n</md-icon><div class=\"form-title\">Message</div></div><div class=\"trigger-card-content\"><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start center\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" layout=\"row\" layout-align=\"start center\" flex><span \nclass=\"msg-src-label\">Message Source:</span><md-radio-group ng-model=\"vm.form.messageSource\" layout=\"row\">\n<md-radio-button value=\"template\" class=\"msg-src-radio md-primary\">Message Template</md-radio-button><md-radio-button \nvalue=\"custom\" class=\"md-primary\">Custom Message</md-radio-button></md-radio-group></div></div><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap ng-if=\"vm.form.messageSource === \'template\'\" \nclass=\"mt-15\"><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" layout=\"column\" \nlayout-align=\"start start\" flex><div layout=\"row\" layout-align=\"space-between center\" class=\"mt-10\" \nstyle=\"width: 100%\"><div layout=\"column\"><strong class=\"template-label\">Template</strong> <span \nng-if=\"vm.form.template_id\" class=\"md-accent-fg template-selected\">{{vm.getTemplateName(vm.form.template_id)}}</span> \n<span ng-if=\"!vm.form.template_id\" class=\"template-unselected\">No template selected</span></div><div layout=\"row\" \nlayout-align=\"end center\"><div class=\"gmc-quick-reply gmc-promote-reply mr-15\"><button type=\"button\" \nclass=\"gmc-quick-reply-toggle\" ng-class=\"{\'is-open\': vm.promoteReplyOpen}\" \nng-click=\"vm.togglePromoteReplyPicker($event)\" aria-haspopup=\"true\" aria-expanded=\"{{vm.promoteReplyOpen}}\">\nPromote Reply<md-icon md-font-icon=\"icon-chevron-down\" class=\"gmc-quick-reply-caret\"></md-icon></button><div \nclass=\"gmc-quick-reply-menu\" ng-if=\"vm.promoteReplyOpen\" ng-click=\"$event.stopPropagation()\"><div \nclass=\"gmc-quick-reply-search\"><input type=\"text\" ng-model=\"vm.promoteReplySearch\" \nng-change=\"vm.filterPromoteReplies()\" placeholder=\"Search templates\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n</div><div class=\"gmc-quick-reply-list\"><div class=\"gmc-quick-reply-empty\" ng-if=\"vm.promoteReplyLoading\">Loading...\n</div><div class=\"gmc-quick-reply-empty\" ng-if=\"!vm.promoteReplyLoading && !vm.promoteReplyFiltered.length\">\nNo templates</div><div class=\"gmc-quick-reply-group\" \nng-repeat=\"category in vm.promoteReplyFiltered track by category.id\"><div class=\"gmc-quick-reply-category\">\n{{category.name}}</div><button type=\"button\" class=\"gmc-quick-reply-item\" \nng-repeat=\"template in category.templates track by template.id\" ng-click=\"vm.applyPromoteReply(template)\">\n{{template.name}}</button></div></div></div></div><div class=\"gmc-quick-reply\"><button type=\"button\" \nclass=\"gmc-quick-reply-toggle\" ng-class=\"{\'is-open\': vm.quickReplyOpen}\" ng-click=\"vm.toggleQuickReplyPicker($event)\" \naria-haspopup=\"true\" aria-expanded=\"{{vm.quickReplyOpen}}\"><md-icon md-font-icon=\"icon-timer\" \nclass=\"gmc-quick-reply-icon\"></md-icon><span>Quick Reply</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"gmc-quick-reply-caret\"></md-icon></button><div class=\"gmc-quick-reply-menu\" ng-if=\"vm.quickReplyOpen\" \nng-click=\"$event.stopPropagation()\"><div class=\"gmc-quick-reply-search\"><input type=\"text\" \nng-model=\"vm.quickReplySearch\" ng-change=\"vm.filterQuickReplies()\" placeholder=\"Search templates\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></div><div class=\"gmc-quick-reply-list\"><div class=\"gmc-quick-reply-empty\" \nng-if=\"vm.quickReplyLoading\">Loading...</div><div class=\"gmc-quick-reply-empty\" \nng-if=\"!vm.quickReplyLoading && !vm.quickReplyFiltered.length\">No templates</div><div class=\"gmc-quick-reply-group\" \nng-repeat=\"category in vm.quickReplyFiltered track by category.id\"><div class=\"gmc-quick-reply-category\">\n{{category.name}}</div><button type=\"button\" class=\"gmc-quick-reply-item\" \nng-repeat=\"template in category.templates track by template.id\" ng-click=\"vm.applyQuickReply(template)\">\n{{template.name}}</button></div></div></div></div></div></div><div class=\"mt-15\" ng-if=\"vm.form.template_id\" \nstyle=\"width: 100%\"><strong class=\"template-preview-label\">Preview:</strong><div class=\"template-preview-box\">\n{{vm.getTemplatePreview(vm.form.template_id)}}</div></div></div></div><div class=\"row-block\" flex-gt-xs=\"100\" \nlayout=\"row\" layout-align=\"start start\" layout-wrap ng-if=\"vm.form.messageSource === \'custom\'\" \nclass=\"custom-msg-block\" style=\"margin-top: 10px\"><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" \nlayout=\"column\" layout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs\"><label>Message</label>\n<textarea id=\"gmc-trigger-body-input\" ng-model=\"vm.form.custom_message\" rows=\"2\" required class=\"custom-msg-textarea\">\n</textarea></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" layout=\"column\" \nlayout-align=\"start start\" flex><strong class=\"available-tags-label\">Personalization Tags (Click to insert)</strong>\n<div layout=\"row\" layout-wrap><div class=\"gmc-trigger-tag\" ng-repeat=\"token in vm.tokens track by token\" \nng-click=\"vm.insertToken(token)\">{{token}}</div></div></div></div></div></div><div class=\"trigger-card\"><div \nclass=\"trigger-card-header\"><md-icon md-font-icon=\"icon-telegram\"></md-icon><div class=\"form-title\">Delivery</div>\n</div><div class=\"trigger-card-content\"><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" layout-wrap><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" \nflex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" flex><md-input-container class=\"md-block tax-inputs\"><label>\nSend Via</label><md-select ng-model=\"vm.form.channel_type\" required><md-option ng-repeat=\"option in vm.channelOptions\" \nng-value=\"option.id\">{{option.label}}</md-option></md-select></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" \nflex><md-input-container class=\"md-block tax-inputs\"><label>Send To</label><md-select \nng-model=\"vm.form.recipient_type\" required><md-option ng-repeat=\"option in vm.recipientTypeOptions\" \nng-value=\"option.id\">{{option.label}}</md-option></md-select></md-input-container></div></div><div \nng-if=\"vm.form.recipient_type === \'user\'\" class=\"mt-15\"><div class=\"recipient-label\" \nng-if=\"vm.form.channel_type === \'email\'\">Recipient (Email Addresses)</div><div class=\"recipient-label\" \nng-if=\"vm.form.channel_type === \'sms\' || vm.form.channel_type === \'whatsapp\'\">Recipient (Phone Numbers)</div><div \nng-if=\"vm.form.channel_type === \'email\'\"><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" layout-wrap><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" \nflex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" flex \nng-repeat=\"(idx, email) in vm.recipientEmails track by $index\"><div layout=\"row\" layout-align=\"start center\" \nstyle=\"width: 100%\"><md-input-container class=\"md-block tax-inputs\" flex \nng-class=\"{\'has-custom-error\': vm.isEmailDuplicate(\'to\', idx) || vm.isEmailInvalid(\'to\', idx)}\"><label>Send Email To\n</label><input type=\"email\" name=\"triggerEmail_to_{{idx}}\" ng-model=\"vm.recipientEmails[idx]\" \nautocomplete=\"new-password\" ng-pattern=\"/^.+@.+\\..+$/\"></md-input-container><md-icon md-font-icon=\"icon-plus-circle\" \nclass=\"md-accent-fg onlycursorPointer mdplusiconmain\" ng-click=\"vm.addEmail(\'to\')\" \nng-if=\"$last && vm.canAddEmail(\'to\')\" class=\"ml-10\"></md-icon><md-icon md-font-icon=\"icon-delete\" \nclass=\"red-A800-fg onlycursorPointer\" ng-click=\"vm.removeEmail(\'to\', idx)\" \nng-if=\"vm.recipientEmails.length > 1 || vm.recipientEmails[0]\" class=\"ml-10\"></md-icon></div></div></div><div \nclass=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" \nflex ng-repeat=\"(idx, email) in vm.recipientCcEmails track by $index\"><div layout=\"row\" layout-align=\"start center\" \nstyle=\"width: 100%\"><md-input-container class=\"md-block tax-inputs\" flex \nng-class=\"{\'has-custom-error\': vm.isEmailDuplicate(\'cc\', idx) || vm.isEmailInvalid(\'cc\', idx)}\"><label>CC Email</label>\n<input type=\"email\" name=\"triggerEmail_cc_{{idx}}\" ng-model=\"vm.recipientCcEmails[idx]\" autocomplete=\"new-password\" \nng-pattern=\"/^.+@.+\\..+$/\"></md-input-container><md-icon md-font-icon=\"icon-plus-circle\" \nclass=\"md-accent-fg onlycursorPointer mdplusiconmain\" ng-click=\"vm.addEmail(\'cc\')\" \nng-if=\"$last && vm.canAddEmail(\'cc\')\" class=\"ml-10\"></md-icon><md-icon md-font-icon=\"icon-delete\" \nclass=\"red-A800-fg onlycursorPointer\" ng-click=\"vm.removeEmail(\'cc\', idx)\" \nng-if=\"vm.recipientCcEmails.length > 1 || vm.recipientCcEmails[0]\" class=\"ml-10\"></md-icon></div></div></div><div \nclass=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" \nflex ng-repeat=\"(idx, email) in vm.recipientBccEmails track by $index\"><div layout=\"row\" layout-align=\"start center\" \nstyle=\"width: 100%\"><md-input-container class=\"md-block tax-inputs\" flex \nng-class=\"{\'has-custom-error\': vm.isEmailDuplicate(\'bcc\', idx) || vm.isEmailInvalid(\'bcc\', idx)}\"><label>BCC Email\n</label><input type=\"email\" name=\"triggerEmail_bcc_{{idx}}\" ng-model=\"vm.recipientBccEmails[idx]\" \nautocomplete=\"new-password\" ng-pattern=\"/^.+@.+\\..+$/\"></md-input-container><md-icon md-font-icon=\"icon-plus-circle\" \nclass=\"md-accent-fg onlycursorPointer mdplusiconmain\" ng-click=\"vm.addEmail(\'bcc\')\" \nng-if=\"$last && vm.canAddEmail(\'bcc\')\" class=\"ml-10\"></md-icon><md-icon md-font-icon=\"icon-delete\" \nclass=\"red-A800-fg onlycursorPointer\" ng-click=\"vm.removeEmail(\'bcc\', idx)\" \nng-if=\"vm.recipientBccEmails.length > 1 || vm.recipientBccEmails[0]\" class=\"ml-10\"></md-icon></div></div></div></div>\n<div ng-if=\"vm.form.channel_type === \'sms\' || vm.form.channel_type === \'whatsapp\'\"><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" \nflex ng-repeat=\"(idx, phone) in vm.recipientPhones track by $index\"><div layout=\"row\" layout-align=\"start center\" \nstyle=\"width: 100%\"><md-input-container class=\"md-block tax-inputs\" flex \nng-class=\"{\'has-custom-error\': vm.isPhoneDuplicate(idx)}\"><label class=\"phone-number-label\">Phone Number</label><input \ntype=\"tel\" class=\"intel-number-input\" intl-tel-input name=\"triggerPhone_{{idx}}\" ng-model=\"vm.recipientPhones[idx]\" \nng-change=\"vm.updatePhoneWithCountryCode(\'triggerPhone_\' + idx, idx)\" autocomplete=\"off\"></md-input-container><md-icon \nmd-font-icon=\"icon-plus-circle\" class=\"md-accent-fg onlycursorPointer mdplusiconmain\" ng-click=\"vm.addPhone()\" \nng-if=\"$last && vm.canAddPhone()\" class=\"ml-10\"></md-icon><md-icon md-font-icon=\"icon-delete\" \nclass=\"red-A800-fg onlycursorPointer\" ng-click=\"vm.removePhone(idx)\" \nng-if=\"vm.recipientPhones.length > 1 || vm.recipientPhones[0]\" class=\"ml-10\"></md-icon></div></div></div></div></div>\n</div></div><div class=\"trigger-card\"><div class=\"trigger-card-content trigger-status-card-content\"><div \nclass=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start center\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" layout=\"row\" layout-align=\"start center\" flex><md-switch \nng-model=\"vm.form.is_active\" aria-label=\"Enable trigger\" class=\"m-0 md-primary\"></md-switch><div layout=\"column\" \nclass=\"ml-16\"><strong class=\"trigger-status-title\">Status</strong><div ng-if=\"vm.form.is_active\" \nclass=\"trigger-status-desc\">\nEnabled &mdash; The trigger is active and will run based on the configured schedule and conditions.</div><div \nng-if=\"!vm.form.is_active\" class=\"trigger-status-desc\">Disabled &mdash; The trigger is inactive and will not run.</div>\n</div></div></div></div></div></div></div></div></form></div>");
$templateCache.put("app/main/apps/todo/dialogs/confirmhousekeeper/confirmhousekeeper.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent-bg white-fg\" style=\"background:rgb(0,188,212)\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"outer_wrapper\"><div class=\"form-title no-padding mb-15\">\nDo you want to make this change in other rooms of this floor?</div><div class=\"inner_wrapper\" \nng-if=\"vm.roomsData.length > 1\"><md-radio-group><md-checkbox ng-model=\"vm.selectAllRooms\" aria-label=\"Checkbox 1\" \nng-true-value=\"true\" ng-false-value=\"false\" class=\"md-align-top-left space-checkbox-block\" flex \nng-change=\"vm.selectAllRoomsCategory(vm.selectAllRooms)\">Select All</md-checkbox></md-radio-group></div><div \nclass=\"inner_wrapper\" ng-repeat=\"room in vm.roomsData\"><md-radio-group><md-checkbox ng-model=\"vm.roomTask[$index]\" \naria-label=\"Checkbox 2\" ng-true-value=\"true\" ng-false-value=\"false\" class=\"md-align-top-left space-checkbox-block\" \nflex ng-change=\"vm.selectRoomsForUpdate(room, vm.roomTask[$index])\">\n{{room.initials}} {{room.room_number}} - {{room.task_title}}</md-checkbox></md-radio-group></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end end\" flex=\"100\"><md-button type=\"button\" ng-click=\"vm.closeDialog()\" \nclass=\"md-button ng-scope md-ink-ripple md-raised md-red-500-bg submit-button white-fg\" translate=\"TODO.NO\" \ntranslate-attr-aria-label=\"TODO.NO\"></md-button><md-button type=\"button\" ng-click=\"vm.saveHouskeeperData()\" \nclass=\"md-button ng-scope md-ink-ripple md-raised md-green-500-bg submit-button white-fg\" \nng-disabled=\"vm.selectedRoom.length == 0\" translate=\"TODO.YES\" translate-attr-aria-label=\"TODO.YES\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/todo/dialogs/task/housekeep-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent-bg white-fg\" style=\"background:rgb(0,188,212)\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog(\'close\')\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div class=\"btnsacceptreject\" \nng-if=\"vm.modeType == \'edit\' && vm.task.task_status == \'done\' && vm.task.task_inspected != \'accepted\' && vm.taskCategory == \'housekeeping\'\">\n<button type=\"button\" class=\"accept\" ng-click=\"vm.acceptRejectTasks(vm.task.task_id, \'accepted\')\"><span \naria-hidden=\"true\">✓</span> {{\'accept\' | translate}}</button> <button type=\"button\" class=\"reject\" \nng-click=\"vm.acceptRejectTasks(vm.task.task_id, \'rejected\')\"><span aria-hidden=\"true\">✕</span> {{\'reject\' | translate}}\n</button></div><div layout=\"row\" flex=\"100\" layout-wrap ng-if=\"vm.modeType == \'add\'\"><div layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" class=\"ph-10\"><md-input-container class=\"md-block mb-0\"><label translate=\"TODO.TITLE\">Title</label>\n<textarea ng-model=\"vm.task.task_title\" required ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></textarea>\n</md-input-container><div ng-messages=\"taskForm.title.$error\" ng-show=\"taskForm.title.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"TODO.ERRORS.TITLE_REQUIRED\">Title Field is Required</span></div></div></div><div\n layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" class=\"ph-10\"><md-input-container class=\"md-block mb-0\" \nng-if=\"vm.hotelID != 122\"><label>Room Number</label><md-select ng-model=\"vm.task.task_product_id\" \nplaceholder=\"Select a Room\" required><md-option ng-value=\"room.product_id\" ng-repeat=\"room in vm.rooms\">\n{{ room.product_name }}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container>\n<md-input-container class=\"md-block mb-0\" ng-if=\"vm.hotelID == 122\"><label>Room Number</label><md-select \nng-model=\"vm.task.task_product_id\" ng-change=\"vm.selectedUser(vm.task.task_product_id)\" required><md-optgroup \nlabel=\"{{roomtype}}\" ng-repeat=\"roomtype in vm.roomsKey\"><md-option ng-value=\"room.product_id\" \nng-repeat=\"room in vm.rooms[roomtype]\">{{room.product_name}}</md-option></md-optgroup></md-select></md-input-container>\n</div></div><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" class=\"ph-10\">\n<md-input-container class=\"md-block mb-0\"><label>Select Priority</label><md-select ng-model=\"vm.task.task_priority\" \nplaceholder=\"Select a Priority\" required><md-option value=\"lower\">Lower</md-option><md-option value=\"medium\">Medium\n</md-option><md-option value=\"higher\">Higher</md-option></md-select><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" class=\"ph-10\"><div \nclass=\"date-container taskdilogdatepicker\"><md-datepicker style=\"padding-right: 0px\" ng-model=\"vm.task.task_due_date\" \nmd-open-on-focus md-placeholder=\"Due Date\" required></md-datepicker><div class=\"md-errors-spacer\"></div></div></div>\n</div><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" class=\"ph-10\"><md-input-container>\n<label>Select Users</label><md-select ng-model=\"vm.task.task_to_user\" multiple=\"multiple\" placeholder=\"Select users\" \nng-change=\"vm.selectUserHousekeeper(vm.task.task_to_user)\"><md-option ng-value=\"user\" ng-repeat=\"user in vm.users\">\n{{ user.display }}</md-option></md-select></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.modeType == \'edit\' && vm.task.task_status != \'done\' && vm.task.task_inspected != \'accepted\' && (vm.hotelID != 126 || (vm.hotelID == 126 && vm.taskCategory == \'housekeeping\'))\">\n<div layout=\"column\" flex=\"100\" class=\"ph-10\"><md-input-container class=\"md-block mb-0\"><label>Inspection</label>\n<md-select ng-model=\"vm.task.inspection\" placeholder=\"inspection\"><md-option value=\"accepted\">Accept</md-option>\n<md-option value=\"rejected\">Reject</md-option><md-option value=\"notInspected\">Not Inspected</md-option></md-select><div\n class=\"md-errors-spacer\"></div></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.modeType == \'edit\' && vm.task.task_status != \'done\' && vm.task.task_inspected != \'accepted\' && vm.hotelID == 126 && vm.taskCategory == \'maintainance\'\">\n<div layout=\"column\" flex=\"100\" class=\"ph-10\"><md-input-container class=\"md-block mb-0\"><label>Inspection</label>\n<md-select ng-model=\"vm.task.inspection\" placeholder=\"inspection\"><md-option value=\"start\">Start</md-option><md-option \nvalue=\"finish\">Finish</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" class=\"ph-10\"><md-input-container><label>\nDescription</label><textarea name=\"description\" ng-model=\"vm.task.task_note\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\"></textarea></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-wrap><div \nlayout=\"column\" flex=\"100\" class=\"ph-10\"><div class=\"commentsection\"><h2 class=\"commonheading\">\n{{\'Comments\' | translate}}</h2><div class=\"chatsectionblock\"><div id=\"commentThread\" class=\"expeandableBlock\" \nng-class=\"{\'is-empty\': !vm.comments.length && !vm.uploading}\"><div class=\"comment-empty\" \nng-if=\"!vm.comments.length && !vm.uploading\">No comments yet</div><div class=\"chatrowblock\" \nng-class=\"vm.loggedUserId == comment.comment_by ? \'right\' : \'\'\" ng-repeat=\"comment in vm.comments\"><div \nclass=\"chatblock1\" \nng-class=\"{\'is-audio\': comment.type == \'audio\' || (comment.media_type && comment.media_type.indexOf(\'audio\') > -1)}\">\n<div class=\"chatby\" ng-if=\"vm.loggedUserId != comment.comment_by\" style=\"color:#43bdd4\">{{comment.username}}</div><div \nclass=\"chat-audio\" ng-if=\"comment.type == \'audio\' || (comment.media_type && comment.media_type.indexOf(\'audio\') > -1)\" \nng-init=\"vm.ensureAudioState($index)\"><button type=\"button\" class=\"chat-audio-btn\" \nng-click=\"vm.toggleCommentAudio($index, $event)\" aria-label=\"Play audio\"><span ng-if=\"!vm.audioState[$index].playing\">\n&#9654;</span> <span ng-if=\"vm.audioState[$index].playing\">&#10074;&#10074;</span></button><div \nclass=\"chat-audio-track\" ng-click=\"vm.seekCommentAudio($index, $event)\"><div class=\"chat-audio-fill\" \nng-style=\"{width: (vm.audioState[$index].progress || 0) + \'%\'}\"></div></div><span class=\"chat-audio-time\">\n{{ vm.audioState[$index].label || \'0:00\' }}</span><audio id=\"audio_{{$index}}\" data-index=\"{{$index}}\" \nng-src=\"{{ vm.audioPath + comment.media }}\" preload=\"metadata\" \nonloadedmetadata=\"angular.element(this).scope().vm.onAudioMeta(this)\" \nontimeupdate=\"angular.element(this).scope().vm.onAudioTick(this)\" \nonended=\"angular.element(this).scope().vm.onAudioEnded(this)\"></audio></div><div class=\"chatContent chatContentimg\" \nng-if=\"comment.media_type && comment.media_type.indexOf(\'image\') > -1 && comment.media_url\"><a \nng-href=\"{{ comment.media_url }}\" target=\"_blank\" rel=\"noopener\"><img ng-src=\"{{ comment.media_url }}\" width=\"150\" \nalt=\"{{ comment.media || \'attachment\' }}\"></a></div><div class=\"chatContent\" \nng-if=\"comment.comment && comment.type != \'audio\' && !(comment.media_type && (comment.media_type.indexOf(\'image\') > -1 || comment.media_type.indexOf(\'audio\') > -1))\">\n{{comment.comment}}</div><div class=\"chattimedate\">{{comment.created_time}}</div></div></div><div ng-if=\"vm.uploading\" \nclass=\"chatrowblock right\"><div class=\"chatblock1\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\" \nmd-diameter=\"30px\"></md-progress-circular></div></div></div><div class=\"sendblockinput\"><input type=\"text\" \nng-keypress=\"$event.keyCode === 13 && vm.saveComments()\" ng-model=\"vm.commentInput\" class=\"inputsend\" \nplaceholder=\"Write a comment\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"> <button type=\"button\" \nclass=\"buttonsend no-blink\" ng-click=\"vm.startRecording()\" ng-if=\"vm.commentInput == \'\' && vm.record == \'stop\'\" \naria-label=\"Record comment\"><img src=\"assets/icons/microphone-white.svg\" alt=\"\"></button> <button type=\"button\" \nclass=\"buttonsend blink stop\" ng-click=\"vm.stopRecording()\" ng-if=\"vm.commentInput == \'\' && vm.record == \'start\'\" \naria-label=\"Stop recording\"><img src=\"assets/icons/stop.svg\" alt=\"\"></button> <button type=\"button\" class=\"buttonsend\" \nng-click=\"vm.saveComments()\" ng-if=\"vm.commentInput != \'\'\" aria-label=\"Send comment\"><img \nsrc=\"assets/icons/sendicon.png\" alt=\"\"></button></div></div><div class=\"micError\" ng-show=\"vm.showMicErr\">\nMic Not found.</div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button type=\"button\" \nng-click=\"vm.updateTask($event)\" \nng-class=\"taskForm.$invalid || vm.updateRequest ? \'md-button md-ink-ripple md-raised md-accent submit-button white-fg\' : \'md-button md-ink-ripple md-raised hk-save-btn submit-button white-fg\'\" \nng-disabled=\"taskForm.$invalid || vm.updateRequest\" aria-label=\"Save\">Save<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-if=\"vm.updateRequest\"></md-progress-circular>\n</md-button></div><div layout=\"row\"><md-button class=\"md-icon-button\" ng-if=\"vm.modeType == \'edit\'\" \nng-click=\"vm.deleteTask()\" aria-label=\"Delete\" translate translate-attr-aria-label=\"TODO.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"TODO.DELETE\">Delete</span></md-tooltip></md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/todo/dialogs/task/task-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate \nng-if=\"vm.subType != \'priority\'\"><md-toolbar class=\"md-accent-bg white-fg\" style=\"background:rgb(0,188,212)\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" \nflex=\"100\" layout-wrap ng-if=\"vm.type != \'houseKeep\'\"><div layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" class=\"ph-10\">\n<md-input-container class=\"md-block mb-0\"><label translate=\"TODO.TITLE\">Title</label><textarea \nng-model=\"vm.task.task_title\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></textarea></md-input-container><div \nng-messages=\"taskForm.title.$error\" ng-show=\"taskForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TODO.ERRORS.TITLE_REQUIRED\">Title Field is Required</span></div></div></div><div layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" class=\"ph-10\"><md-input-container class=\"md-block mb-0\"><md-select ng-model=\"vm.task.task_product_id\" \nplaceholder=\"Select a Room\" required><md-option ng-value=\"room.product_id\" ng-repeat=\"room in vm.rooms\">\n{{ room.product_name }}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div></div>\n<div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" class=\"ph-10\" \nng-if=\"vm.type != \'houseKeep\'\"><md-input-container class=\"md-block mb-0\"><md-select ng-model=\"vm.task.task_priority\" \nplaceholder=\"Select a Priority\" required><md-option ng-value=\"pri.value\" ng-repeat=\"pri in vm.priority\">{{pri.name}}\n</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" class=\"ph-10\"><md-autocomplete flex md-input-name=\"autocompleteField\" md-input-minlength=\"2\" \nmd-input-maxlength=\"18\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedItem\" md-search-text=\"vm.searchText\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.display\" md-require-match \nmd-floating-label=\"Select User\" class=\"autocomplete-input\"><md-item-template><span md-highlight-text=\"vm.searchText\">\n{{item.display}}</span></md-item-template></md-autocomplete></div></div><div layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.type != \'houseKeep\'\"><div layout=\"column\" flex=\"100\" flex-gt-xs=\"100\" class=\"ph-10\"><div \nclass=\"tags no-margin\"><md-content class=\"ph-0 pv-5 mb-20\" layout=\"column\"><md-chips ng-model=\"vm.selectedTag\" \nmd-autocomplete-snap=\"\" md-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"vm.autocompleteDemoRequireMatch\" \nrequired><md-autocomplete md-selected-item=\"vm.selectedTags\" md-search-text=\"vm.searchTags\" \nmd-items=\"item in vm.querySearchTags(vm.searchTags)\" md-item-text=\"item.name\" placeholder=\"Search for a Tags\"><span \nmd-highlight-text=\"vm.searchTags\">{{item.name}}</span><md-not-found><div class=\"chip-not-found\" \nng-click=\"vm.notFound(vm.searchTags)\"><span translate=\"TODO.NOT_FOUND\">Not found. Please enter to add.</span></div>\n</md-not-found></md-autocomplete><md-chip-template><span><strong>{{$chip.name}}</strong></span></md-chip-template>\n</md-chips></md-content></div></div></div><div layout=\"row\" flex=\"100\" layout-wrap ng-if=\"vm.type != \'houseKeep\'\"><div \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" class=\"ph-10\"><div class=\"date-container\"><md-datepicker flex \nng-model=\"vm.task.task_start\" md-open-on-focus md-min-date=\"vm.minDate\" md-max-date=\"vm.task.task_due_date\" \nmd-placeholder=\"Start Date\" required></md-datepicker><div class=\"md-errors-spacer\"></div></div></div><div \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" class=\"ph-10\"><div class=\"date-container\"><md-datepicker \nng-model=\"vm.task.task_due_date\" md-open-on-focus md-placeholder=\"Due Date\" md-min-date=\"vm.task.task_start\" required>\n</md-datepicker><div class=\"md-errors-spacer\"></div></div></div></div><div layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.type != \'houseKeep\'\"><div layout=\"column\" flex=\"100\" flex-gt-xs=\"100\" class=\"ph-10\"><div class=\"notes\"><label\n translate=\"TODO.NOTES\">Notes</label><text-angular ng-model=\"vm.task.task_note\" required></text-angular></div></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" ng-if=\"!vm.newTask\" ng-click=\"vm.saveTask()\" \nng-class=\"taskForm.$invalid || taskForm.$pristine?\'md-accent md-button ng-scope md-ink-ripple md-raised submit-button white-fg\':\'md-green-500-bg md-button ng-scope md-ink-ripple md-raised submit-button white-fg\' \" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"SAVE\" translate=\"TODO.SAVE\" \ntranslate-attr-aria-label=\"TODO.SAVE\"></md-button><md-button type=\"submit\" ng-if=\"vm.newTask\" \nng-click=\"vm.addNewTask()\" \nng-class=\"taskForm.$invalid || taskForm.$pristine?\'md-button ng-scope md-ink-ripple md-raised md-accent submit-button white-fg\':\'md-button ng-scope md-ink-ripple md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"Add Task\" translate=\"TODO.SAVE\" \ntranslate-attr-aria-label=\"TODO.SAVE\"></md-button></div><div layout=\"row\" ng-if=\"vm.type != \'houseKeep\'\"><md-button \nclass=\"md-icon-button\" ng-if=\"vm.pageStatus == \'edit\'\" ng-click=\"vm.deleteTask()\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"TODO.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"TODO.DELETE\">Delete</span></md-tooltip></md-button></div></md-dialog-actions></form><div \nclass=\"priortyoutertable priortymain1\" ng-if=\"vm.subType == \'priority\'\"><div class=\"prioritycontent\"><div \nclass=\"heading-priority\">Select priority</div><div class=\"prioritybody\"><div class=\"assigntaskdropdown\" flex=\"100\" \nlayout=\"row\" layout-wrap><div flex=\"33\" class=\"prioritycol lp\" ng-click=\"vm.prioritySelected(\'lower\')\"><div \nclass=\"priortyimg\"><img src=\"assets/icons/lp.svg\"></div><div class=\"Priorityblk\">Low Priority</div></div><div \nflex=\"33\" class=\"prioritycol mp\" ng-click=\"vm.prioritySelected(\'medium\')\"><div class=\"priortyimg\"><img \nsrc=\"assets/icons/mp.svg\"></div><div class=\"Priorityblk\">Medium Priority</div></div><div flex=\"33\" \nclass=\"prioritycol hp\" ng-click=\"vm.prioritySelected(\'higher\')\"><div class=\"priortyimg\"><img src=\"assets/icons/hp.svg\">\n</div><div class=\"Priorityblk\">High Priority</div></div></div></div></div></div></md-dialog>");
$templateCache.put("app/main/apps/todo/dialogs/task-logs/task-logs-dialog.html","<md-dialog class=\"task-logs-dialog\" aria-label=\"Task Logs\"><header class=\"tld-toolbar\"><div class=\"tld-toolbar-inner\">\n<div class=\"tld-brand\"><div class=\"tld-brand-icon\"><md-icon md-font-icon=\"icon-history\" class=\"white-fg\"></md-icon>\n</div><div class=\"tld-toolbar-title\">Task Logs</div></div><span flex></span><md-button \nclass=\"md-icon-button tld-close\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\"><md-icon md-font-icon=\"icon-close\" \nclass=\"white-fg\"></md-icon></md-button></div></header><md-dialog-content class=\"tld-body\" ms-scroll><div \nclass=\"tld-loading\" ng-if=\"vm.loading\" layout=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"36\"></md-progress-circular><p>Loading history…</p></div><div ng-if=\"!vm.loading\">\n<p class=\"tld-subtitle\" ng-if=\"vm.taskTitle\">{{vm.taskTitle}}</p><section class=\"tld-section\" \nng-if=\"vm.workflow.length\"><div class=\"tld-section-head\"><h3>Workflow</h3><span class=\"tld-count\">\n{{vm.doneCount}}/{{vm.workflow.length}}</span></div><div class=\"tld-rail\"><div class=\"tld-step\" \nng-repeat=\"step in vm.workflow\" \nng-class=\"{\'is-done\': step.done, \'is-pending\': !step.done, \'is-current\': step.isCurrent, \'is-rejected\': step.status == \'rejected\'}\">\n<div class=\"tld-step-track\"><span class=\"tld-step-dot\"><svg ng-if=\"step.done && step.status != \'rejected\'\" \nviewBox=\"0 0 24 24\" width=\"11\" height=\"11\" focusable=\"false\" aria-hidden=\"true\"><path fill=\"currentColor\" \nd=\"M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z\"/></svg> <svg ng-if=\"step.done && step.status == \'rejected\'\" \nviewBox=\"0 0 24 24\" width=\"11\" height=\"11\" focusable=\"false\" aria-hidden=\"true\"><path fill=\"currentColor\" \nd=\"M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12z\"/></svg> </span><span \nclass=\"tld-step-line\" ng-if=\"!$last\"></span></div><div class=\"tld-step-label\">{{step.shortLabel || step.label}}</div>\n<div class=\"tld-step-meta\" ng-if=\"step.done && step.displayAt\">{{step.displayAt}}</div><div \nclass=\"tld-step-meta is-pending\" ng-if=\"!step.done\">Pending</div><div class=\"tld-step-person\" \nng-if=\"step.done && step.by_name\" title=\"{{step.by_name}}\">{{step.by_name}}</div></div></div></section><section \nclass=\"tld-section\"><div class=\"tld-section-head\"><h3>Activity</h3><span class=\"tld-count\" ng-if=\"vm.activity.length\">\n{{vm.activity.length}}</span></div><div class=\"tld-empty\" ng-if=\"!vm.activity.length\"><p>\nNo activity available for this task yet.</p></div><ul class=\"tld-feed\" ng-if=\"vm.activity.length\"><li \nclass=\"tld-feed-item\" ng-repeat=\"item in vm.activity\" \nng-class=\"{\'is-lifecycle\': item.type == \'lifecycle\', \'is-log\': item.type == \'log\'}\"><div class=\"tld-feed-marker\" \naria-hidden=\"true\"><span class=\"tld-feed-dot\"></span> <span class=\"tld-feed-line\" ng-if=\"!$last\"></span></div><div \nclass=\"tld-card\"><div class=\"tld-card-top\"><span class=\"tld-badge\" \nng-class=\"{\'is-lifecycle\': item.type == \'lifecycle\', \'is-log\': item.type == \'log\'}\">\n{{item.type == \'log\' ? \'Update\' : \'Status\'}} </span><span class=\"tld-time\" ng-if=\"item.displayAt\">{{item.displayAt}}\n</span></div><p class=\"tld-card-text\">{{item.data}}</p><div class=\"tld-card-user\" \nng-if=\"item.createdByLabel && item.type == \'log\'\"><span class=\"tld-avatar\">{{item.createdByInitials}}</span> <span>\n{{item.createdByLabel}}</span></div></div></li></ul></section></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/todo/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"s24\"></md-icon>\n</span><span class=\"logo-text\" translate=\"TODO.TO_DO\">To-Do</span></div><md-select \nclass=\"project-selection1 simplified1 no-margin white-fg\" ng-model=\"vm.selectedProject\" placeholder=\"Select type\" \nng-change=\"vm.changeTaskCategory()\"><md-option value=\"maintainance\" translate=\"TODO.MAINTAINANCE\">Maintainance\n</md-option><md-option value=\"housekeeping\" translate=\"TODO.HOUSE_KEEPING\">House Keeping</md-option><md-option \nvalue=\"special_requests\" translate=\"TODO.SPECIAL_REQUEST\">Special Request</md-option></md-select></div><md-content \nclass=\"content\" flex ms-scroll><div class=\"add-task-button\"><md-button \nclass=\"md-button ng-scope md-ink-ripple md-raised md-accent submit-button white-fg\" \nng-click=\"vm.openTaskDialog($event)\" aria-label=\"ADD TASK\"><i class=\"icon-plus icon-plus-main ng-scope\"></i> Task\n</md-button></div><div class=\"navigation-simple\" layout=\"column\"><div class=\"item subheader\" translate=\"TODO.FILTERS\">\nFilters</div><md-select class=\"selecthousekeepermain\" ng-model=\"vm.selectedUser\" placeholder=\"All users\" \nng-change=\"vm.filterBySelectedUser(vm.selectedUser)\" ng-if=\"vm.selectedProject == \'housekeeping\'\"><md-option \nvalue=\"all\">All Housekeepers</md-option><md-option ng-value=\"users.value\" ng-repeat=\"users in vm.adminUsers\">\n{{ users.display }}</md-option></md-select><md-button class=\"item\" aria-label=\"All Tasks\" translate \ntranslate-attr-aria-label=\"TODO.ALL_TASKS\" ng-click=\"vm.resetFilters()\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-view-headline\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.ALL_TASKS\">\nAll Tasks</span></div></md-button><md-button class=\"item partition-class\" aria-label=\"Priority\" translate \ntranslate-attr-aria-label=\"TODO.PRIORITY\" ng-click=\"vm.filterData(\'task_priority\', \'lower\')\" \nng-class=\"{\'selected\':vm.taskPriority == \'lower\'}\" ng-if=\"vm.selectedProject != \'housekeeping\'\"><md-icon \nmd-font-icon=\"icon-alert-circle\" \nclass=\"is-important green-600-fg ng-scope md-default-theme md-font material-icons icon-alert-circle s16\" role=\"img\" \naria-label=\"icon-alert-circle\"></md-icon><span class=\"title\" translate=\"TODO.LOW_PRIORITY\">Low Priority</span>\n</md-button><md-button class=\"item\" aria-label=\"Priority\" translate translate-attr-aria-label=\"TODO.PRIORITY\" \nng-click=\"vm.filterData(\'task_priority\', \'medium\')\" ng-class=\"{\'selected\':vm.taskPriority == \'medium\'}\" \nng-if=\"vm.selectedProject != \'housekeeping\'\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"is-important yellow-600-fg ng-scope md-default-theme md-font material-icons icon-alert-circle s16\" role=\"img\" \naria-label=\"icon-alert-circle\"></md-icon><span class=\"title\" translate=\"TODO.MEDIUM_PRIORITY\">Medium Priority</span>\n</md-button><md-button class=\"item\" aria-label=\"Priority\" translate translate-attr-aria-label=\"TODO.PRIORITY\" \nng-click=\"vm.filterData(\'task_priority\', \'higher\')\" ng-class=\"{\'selected\':vm.taskPriority == \'higher\'}\" \nng-if=\"vm.selectedProject != \'housekeeping\'\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"is-important red-600-fg ng-scope md-default-theme md-font material-icons icon-alert-circle s16\" role=\"img\" \naria-label=\"icon-alert-circle\"></md-icon><span class=\"title\" translate=\"TODO.HIGH_PRIORITY\">High Priority</span>\n</md-button><md-button class=\"item partition-class\" aria-label=\"Today\" translate \ntranslate-attr-aria-label=\"TODO.TODAY\" ng-click=\"vm.filterData(\'task_start\', vm.Today)\" \nng-class=\"{\'selected\': vm.selectedFilterParams.indexOf(\'task_start\') == -1 ? false:true}\" \nng-if=\"vm.selectedProject != \'housekeeping\'\"><md-icon md-font-icon=\"icon-calendar-today\" class=\"s16\"></md-icon><span \nclass=\"title\" translate=\"TODO.TODAY\">Today</span></md-button><md-button class=\"item\" aria-label=\"Done\" translate \ntranslate-attr-aria-label=\"TODO.DONE\" ng-click=\"vm.filterData(\'task_status\', \'done\')\" \nng-class=\"{\'selected\': vm.selectedFilterParams.indexOf(\'task_status\') == -1 ? false:true}\" \nng-if=\"vm.selectedProject != \'housekeeping\'\"><md-icon md-font-icon=\"icon-check\" class=\"s16\"></md-icon><span \nclass=\"title\" translate=\"TODO.DONE\">Done</span></md-button><md-button class=\"item partition-class\" aria-label=\"Status\" \nng-click=\"vm.filterByCleaningStatus(\'dirty\')\" ng-class=\"{\'selected\':vm.roomCleaningStatus == \'dirty\'}\" \nng-if=\"vm.selectedProject == \'housekeeping\'\"><i class=\"icon-broom iocncommoncolor icontodoCommon red-A800-fg\"></i> \n<span class=\"title\">Full Cleaning</span></md-button><md-button class=\"item\" aria-label=\"Status\" \nng-click=\"vm.filterByCleaningStatus(\'light_clean\')\" ng-class=\"{\'selected\':vm.roomCleaningStatus == \'light_clean\'}\" \nng-if=\"vm.selectedProject == \'housekeeping\'\"><i class=\"icon-light-cleaning iocncommoncolor icontodoCommon\"></i> <span \nclass=\"title\">Light Cleaning</span></md-button><div class=\"item subheader\" translate=\"TODO.TAGS\" \nng-if=\"vm.selectedProject != \'housekeeping\'\">Tags</div><md-button class=\"tag item\" aria-label=\"tag Unassigned\" \nng-click=\"vm.toggleTagFilter(\'0\')\" \nng-class=\"{\'selected\':vm.selectedFilterTags.indexOf(\'0\') == -1 ? false:true, \'partition-class\': vm.selectedProject == \'housekeeping\' ? true:false}\">\n<md-icon md-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : \'#4c0000\'}\"></md-icon><span class=\"title\">\nUnassigned</span></md-button><md-button class=\"tag item\" aria-label=\"tag {{tag.label}}\" ng-repeat=\"tag in vm.tags\" \nng-click=\"vm.toggleTagFilter(tag.id)\" ng-class=\"{\'selected\':vm.selectedFilterTags.indexOf(tag.id) == -1 ? false:true}\">\n<md-icon md-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : tag.tag_color}\"></md-icon><span \nclass=\"title capitalize\">{{tag.name}}</span></md-button><md-button class=\"item partition-class\" aria-label=\"Status\" \nng-click=\"vm.filterByRoomStatus(\'in_progress\')\" ng-class=\"{\'selected\':vm.roomFilterStatus == \'in_progress\'}\" \nng-if=\"vm.selectedProject == \'housekeeping\'\"><md-icon md-font-icon=\"icon-square-inc\" \nclass=\"is-important yellow-600-fg ng-scope md-default-theme md-font material-icons icon-alert-circle s20\" role=\"img\" \naria-label=\"icon-square-inc\"></md-icon><span class=\"title\">In Progress</span></md-button><md-button class=\"item\" \naria-label=\"Status\" ng-click=\"vm.filterByRoomStatus(\'qa\')\" ng-class=\"{\'selected\':vm.roomFilterStatus == \'qa\'}\" \nng-if=\"vm.selectedProject == \'housekeeping\'\"><md-icon md-font-icon=\"icon-check-circle\" \nclass=\"is-important gray-600-fg ng-scope md-default-theme md-font material-icons icon-alert-circle s20\" role=\"img\" \naria-label=\"icon-check-circle\"></md-icon><span class=\"title\">Waiting Inspection</span></md-button><md-button \nclass=\"item\" aria-label=\"Status\" ng-click=\"vm.filterByRoomStatus(\'closed\')\" \nng-class=\"{\'selected\':vm.roomFilterStatus == \'closed\'}\" ng-if=\"vm.selectedProject == \'housekeeping\'\"><md-icon \nmd-font-icon=\"icon-check-all\" \nclass=\"is-important green-600-fg ng-scope md-default-theme md-font material-icons icon-alert-circle s20\" role=\"img\" \naria-label=\"icon-check-all\"></md-icon><span class=\"title\">Inspected</span></md-button></div></md-content>");
$templateCache.put("app/main/apps/todo/views/list/list-view.html","<div class=\"todo-items\" ng-sortable=\"vm.sortableOptions\" ng-model=\"vm.tasks\" \nng-class=\"{\'sortable\': vm.taskOrder === \'\'}\"><div class=\"todo-item\" md-ink-ripple layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.openTaskDialog($event, task)\" ng-repeat=\"(task_key, task) in vm.tasks\" \nng-class=\"{\'starred\': task.starred, \'selected\': task.selected, \'completed\': task.task_status == \'done\'}\"><div \nclass=\"handle\" ng-click=\"vm.preventDefault($event)\"><md-icon md-font-icon=\"icon-drag-vertical\" class=\"icon\"></md-icon>\n</div><md-checkbox class=\"no-label\" ng-checked=\"task.task_status == \'done\'\" \nng-click=\"vm.toggleCompleted(task, $event, task_key)\" \naria-label=\"{{task.task_status != \'done\'? \'Not completed\' : \'Completed\'}}\"></md-checkbox><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex><div class=\"title\">{{task.task_title}}</div><div class=\"notes\" \nbind-html-compile=\"task.task_note\"></div><div class=\"tags\" layout=\"row\" layout-align=\"start center\" layout-wrap \nng-init=\"\n               tagId = task.tag_id.indexOf(\',\') != -1 ? task.tag_id.split(\',\'):[task.tag_id];tagName = task.tag_title.indexOf(\',\') != -1 ?task.tag_title.split(\',\'):[task.tag_title]; tagColor = task.tag_color.indexOf(\',\') != -1 ?task.tag_color.split(\',\'):[task.tag_color]; \">\n<div class=\"tag\" layout=\"row\" layout-align=\"start center\" data-ng-repeat=\"(tag_key, tag) in tagId\"><div \nclass=\"tag-color\" ng-style=\"{\'background-color\': tagColor[tagId.indexOf(tag)]}\"></div><div class=\"tag-label\">\n{{tagName[tagId.indexOf(tag)]}}</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\">\n<md-icon class=\"yellow-fg\" md-font-icon=\"icon-checkbox-marked-circle\" class=\"s18\" \nng-if=\"task.task_status == \'in_progress\'\"></md-icon><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" \ntranslate translate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item \nng-if=\"task.task_status == \'undone\' || task.task_status ==\'in_progress\'\"><md-button \nng-click=\"vm.upDateTaskStatus(\'done\', task_key)\" aria-label=\"Toggle done\" translate-attr-aria-label=\"TODO.TOGGLE_DONE\">\n<md-icon class=\"green-fg\" md-font-icon=\"icon-checkbox-marked-circle\" class=\"s18\"></md-icon><span translate=\"TODO.DONE\">\nMark as Done</span></md-button></md-menu-item><md-menu-item \nng-if=\"task.task_status == \'done\' || task.task_status == \'in_progress\'\"><md-button \nng-click=\"vm.upDateTaskStatus(\'undone\', task_key)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"TODO.TOGGLE_DONE\"><md-icon class=\"grey-fg\" md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"s18\"></md-icon><span translate=\"TODO.UNDONE\">Mark as Undone</span></md-button></md-menu-item><md-menu-item \nng-if=\"task.task_status == \'done\' || task.task_status == \'undone\'\"><md-button \nng-click=\"vm.upDateTaskStatus(\'in_progress\', task_key)\" aria-label=\"Toggle done\" \ntranslate-attr-aria-label=\"TODO.TOGGLE_DONE\"><md-icon class=\"yellow-fg\" md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"s18\"></md-icon><span translate=\"TODO.INPROGRESS\">Mark as in Progress</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div><div class=\"pagination main-paination\" ng-if=\"vm.totalCount > vm.limit\">\n<p class=\"row-per-page\" translate=\"TODO.ROWS_PER_PAGE\">Rows Per Page :</p><md-select ng-model=\"vm.limit\" \nng-change=\"vm.filterTheList()\" placeholder=\"No. of data\" class=\"select-main11 mv-0\"><md-option ng-value=\"10\">10\n</md-option><md-option ng-value=\"20\">20</md-option><md-option ng-value=\"50\">50</md-option></md-select><p \nclass=\"row-per-page pagesof\">\n{{ ((vm.curPage*vm.limit)-(vm.limit-1))+\'-\'+ (vm.tasks.length + ((vm.curPage*vm.limit)-(vm.limit))) }} of {{vm.totalCount}}\n</p><div class=\"pagination-custom-block\"><a href=\"#\" ng-click=\"vm.loadPage(vm.curPage, \'pre\')\"><ng-md-icon \nicon=\"keyboard_arrow_left\" size=\"24\" class=\"ng-scope\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" \nwidth=\"24\" height=\"24\"><path d=\"M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z\"></path></svg></ng-md-icon></a><a \nhref=\"#\" ng-click=\"vm.loadPage(vm.curPage, \'next\')\"><ng-md-icon icon=\"keyboard_arrow_right\" size=\"24\" class=\"ng-scope\">\n<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\"><path \nd=\"M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z\"></path></svg></ng-md-icon></a></div></div></div><div \nng-if=\"vm.tasks.length == 0\" class=\"padding-15\">No Task Found.</div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-1.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Lastname</span> field to reveal the conditional step!\n</p><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"firstname\" ng-model=\"vm.verticalStepper.step1.firstname\" placeholder=\"Firstname\" required><div \nng-messages=\"verticalStep1.firstname.$error\" ng-show=\"verticalStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.verticalStepper.step1.lastname\" \nplaceholder=\"Lastname\"><div ng-messages=\"verticalStep1.lastname.$error\" ng-show=\"verticalStep1.lastname.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container></div>\n</div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-2.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Birthplace</span>\n field to reveal another conditional step! Conditional step-ception!</p><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"birthplace\" \nng-model=\"vm.verticalStepper.step2.birthplace\" placeholder=\"Birthplace\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-3.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"ssn\" ng-model=\"vm.verticalStepper.step3.ssn\" \nplaceholder=\"Social Security Number\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-4.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><label>Address\n</label><textarea ng-model=\"vm.verticalStepper.step4.address\" md-maxlength=\"150\" max-rows=\"5\"></textarea><div \nng-messages=\"verticalStep4.address.$error\" ng-show=\"verticalStep4.address.$touched\" role=\"alert\"></div>\n</md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-5.html","<div class=\"md-inline-form\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"cardholder\" \nng-model=\"vm.verticalStepper.step5.cardholder\" placeholder=\"Card Holder\" required><div \nng-messages=\"step5.cardholder.$error\" role=\"alert\"><div ng-message=\"required\"><span>Card holder field is required.\n</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" \nflex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" ng-model=\"vm.verticalStepper.step5.cardnumber\" \nplaceholder=\"Card Number\" required><div ng-messages=\"verticalStep5.cardnumber.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Card number field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"CC2\" ng-model=\"vm.verticalStepper.step5.cc2\" placeholder=\"CC2\" \nmd-maxlength=\"3\" required><div ng-messages=\"verticalStep5.cc2.$error\" role=\"alert\" multipl><div ng-message=\"required\">\n<span>CC2 field is required.</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" \nname=\"expirationDate\" ng-model=\"vm.verticalStepper.step5.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"verticalStep5.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-1.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Lastname</span> field to reveal the conditional step!\n</p><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"firstname\" ng-model=\"vm.horizontalStepper.step1.firstname\" placeholder=\"Firstname\" required><div \nng-messages=\"horizontalStep1.firstname.$error\" ng-show=\"horizontalStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.horizontalStepper.step1.lastname\" \nplaceholder=\"Lastname\"><div ng-messages=\"horizontalStep1.lastname.$error\" ng-show=\"horizontalStep1.lastname.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container></div>\n</div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-2.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Birthplace</span>\n field to reveal another conditional step! Conditional step-ception!</p><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"birthplace\" \nng-model=\"vm.horizontalStepper.step2.birthplace\" placeholder=\"Birthplace\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-3.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"ssn\" ng-model=\"vm.horizontalStepper.step3.ssn\" \nplaceholder=\"Social Security Number\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-4.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><label>Address\n</label><textarea ng-model=\"vm.horizontalStepper.step4.address\" md-maxlength=\"150\" max-rows=\"5\"></textarea><div \nng-messages=\"horizontalStep4.address.$error\" ng-show=\"horizontalStep4.address.$touched\" role=\"alert\"></div>\n</md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-5.html","<div class=\"md-inline-form\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"cardholder\" \nng-model=\"vm.horizontalStepper.step5.cardholder\" placeholder=\"Card Holder\" required><div \nng-messages=\"horizontalStep5.cardholder.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard holder field is required.</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" \nng-model=\"vm.horizontalStepper.step5.cardnumber\" placeholder=\"Card Number\" required><div \nng-messages=\"horizontalStep5.cardnumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard number field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\">\n<input type=\"text\" name=\"CC2\" ng-model=\"vm.horizontalStepper.step5.cc2\" placeholder=\"CC2\" md-maxlength=\"3\" required>\n<div ng-messages=\"horizontalStep5.cc2.$error\" role=\"alert\" multipl><div ng-message=\"required\"><span>\nCC2 field is required.</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.</span>\n</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" \nname=\"expirationDate\" ng-model=\"vm.horizontalStepper.step5.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"horizontalStep5.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/fullwidth/fullwidth.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\"><span class=\"h2 white-fg\">Fullwidth with independent scroll</span></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span>\nContent toolbar</span></div><md-content class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/fullwidth-ii/fullwidth-ii.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><span class=\"h2 white-fg\">Fullwidth with page scroll</span></div><div \nclass=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span>Content toolbar</span></div>\n<md-content class=\"content\" ms-scroll><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/left-sidenav/left-sidenav.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav \nclass=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nclass=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">\nLeft sidenav with independent scroll</span></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><p>Content toolbar</p></div><md-content class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/left-sidenav-ii/left-sidenav-ii.html","<div class=\"page-layout carded left-sidenav single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div class=\"center\" \nflex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">Left sidenav with page scroll</span></div></div>\n<div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><p>\nContent toolbar</p></div><md-content class=\"content\" ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/right-sidenav/right-sidenav.html","<div class=\"page-layout carded right-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">\nRight sidenav with independent scroll</span></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><p>Content toolbar</p><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle right pane\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content class=\"content\" flex ms-scroll>\n<div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll flex><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/carded/right-sidenav-ii/right-sidenav-ii.html","<div class=\"page-layout carded right-sidenav single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">Right sidenav with page scroll\n</span></div></div><div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><p>\nContent toolbar</p><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle right pane\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content \nclass=\"content\" ms-scroll><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div>\n</div><md-sidenav class=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" \nms-scroll ms-sidenav-helper><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/fullwidth/fullwidth.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\"><span class=\"h2\">Fullwidth</span></div><div \nclass=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav/left-sidenav.html","<div class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><div><span class=\"h2\">Left sidenav with independent scroll</span></div></div><div \nclass=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>\n</div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav-ii/left-sidenav-ii.html","<div class=\"page-layout simple left-sidenav single-scroll\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><div><span class=\"h2\">Left sidenav with page scroll</span></div></div><div \nclass=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>\n</div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav-iii/left-sidenav-iii.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><span class=\"h2\">Inner Left Sidenav</span></div>\n<div class=\"content\" md-background-bg layout=\"row\" ms-scroll><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"header\"><p>\nSidenav header</p></div><md-content class=\"content\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div flex \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav/right-sidenav.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div><span class=\"h2\">\nRight sidenav with independent scroll</span></div><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><div class=\"content md-background-bg\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav-ii/right-sidenav-ii.html","<div class=\"page-layout simple right-sidenav single-scroll\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div><span class=\"h2\">\nRight sidenav with page scroll</span></div><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><div class=\"content md-background-bg\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav-iii/right-sidenav-iii.html","<div class=\"page-layout simple right-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><span class=\"h2\">Inner Right Sidenav</span></div>\n<div class=\"content\" md-background-bg layout=\"row\" ms-scroll><div flex \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div><md-sidenav class=\"sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"header\"><p>\nSidenav header</p></div><md-content class=\"content\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/tabbed/tabbed.html","<div class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\"><span class=\"h2\">Tabbed</span>\n</div><div class=\"content\"><md-tabs md-dynamic-height><md-tab label=\"Tab 1\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab><md-tab label=\"Tab 2\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab><md-tab label=\"Tab 3\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/ui/theme-colors/dialogs/custom-theme/custom-theme-dialog.html","<md-dialog class=\"custom-theme-dialog\" aria-label=\"Custom Theme\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nCustom Theme Generator</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nlayout=\"row\" ng-repeat=\"type in [\'primary\', \'accent\', \'warn\', \'background\']\"><h3 class=\"type\">{{type}}</h3>\n<md-input-container><label>Palette</label><md-select ng-model=\"vm.theme[type].name\" \nng-style=\"{\'background-color\': vm.rgba(vm.palettes[vm.theme[type].name][\'500\'].value), \'color\': vm.rgba(vm.palettes[vm.theme[type].name][\'500\'].contrast, 1)}\">\n<md-option ng-value=\"palette\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\">{{palette}}\n</md-option></md-select></md-input-container><div layout=\"row\" \nng-repeat=\"hueType in [\'default\', \'hue-1\', \'hue-2\', \'hue-3\']\"><md-input-container><label>{{hueType}}</label><md-select \nng-model=\"vm.theme[type].hues[hueType]\" \nng-style=\"{\'background-color\': vm.rgba(vm.palettes[vm.theme[type].name][vm.theme[type].hues[hueType]].value), \'color\': vm.rgba(vm.palettes[vm.theme[type].name][vm.theme[type].hues[hueType]].contrast, 1)}\">\n<md-option ng-value=\"hue\" ng-repeat=\"(hue, opt) in vm.palettes[vm.theme[type].name]\" \nng-style=\"{\'background-color\': vm.rgba(opt.value), \'color\': vm.rgba(opt.contrast, 1)}\">{{hue}}</md-option></md-select>\n</md-input-container></div></div><md-divider></md-divider><div layout=\"row\"><p>\nTo make this theme permanent, copy the below code and add it into the \"fuseThemes\" object in \"core/theming/fuse-themes.constant.js\" file. You can also replace the \"CUSTOM_THEME_NAME\" with your theme name.\n</p></div><div layout=\"row\"><textarea readonly=\"readonly\" class=\"theme-object\">\"CUSTOM_THEME_NAME\" : {{vm.theme}}\n</textarea></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.setTheme()\">Set Theme</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/ui/theme-colors/tabs/accent/accent.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-accent-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.accent.color}}</div><div flex>\n.md-accent-bg</div></div><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div>\n<div flex>{{vm.themes.active.theme.accent.contrast1}}</div><div flex>.md-accent-bg</div></div><div \nclass=\"md-accent-bg\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>\nSecondary Text / Icon</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.accent.contrast2}}</div><div \nclass=\"secondary-text\" flex>.md-accent-bg .secondary-text</div></div><div class=\"md-accent-bg\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.accent.contrast3}}</div><div class=\"hint-text\" flex>\n.md-accent-bg .hint-text</div></div><div class=\"md-accent-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding>\n<div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .divider</div></div><div \nflex=\"100\" class=\"md-accent-fg\" layout=\"row\" layout-padding><div flex>As foreground color</div><div flex>\n{{vm.themes.active.theme.accent.color}}</div><div flex>.md-accent-fg</div></div></div><div class=\"color\" layout=\"row\" \nlayout-wrap layout-align=\"center center\"><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div\n flex>Hue 1</div><div flex>{{vm.themes.active.theme.accent.hue1.color}}</div><div flex>.md-accent-bg .md-hue-1</div>\n</div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.accent.hue1.contrast1}}</div><div flex>.md-accent-bg</div></div><div \nclass=\"md-accent-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.accent.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-accent-bg .md-hue-1 .secondary-text</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.accent.hue1.contrast3}}</div><div class=\"hint-text\" flex>.md-accent-bg .md-hue-1 .hint-text\n</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.hue1.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .md-hue-1 .divider\n</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-1\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.accent.hue1.color}}</div><div flex>.md-accent-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-accent-bg md-hue-2\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 2</div><div flex>{{vm.themes.active.theme.accent.hue2.color}}</div><div flex>\n.md-accent-bg .md-hue-2</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nPrimary Text</div><div flex>{{vm.themes.active.theme.accent.hue2.contrast1}}</div><div flex>.md-accent-bg</div></div>\n<div class=\"md-accent-bg md-hue-2\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.accent.hue2.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-accent-bg .md-hue-2 .secondary-text</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.accent.hue2.contrast3}}</div><div class=\"hint-text\" flex>.md-accent-bg .md-hue-2 .hint-text\n</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.hue2.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .md-hue-2 .divider\n</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-2\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.accent.hue2.color}}</div><div flex>.md-accent-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-accent-bg md-hue-3\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 3</div><div flex>{{vm.themes.active.theme.accent.hue3.color}}</div><div flex>\n.md-accent-bg .md-hue-3</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nPrimary Text</div><div flex>{{vm.themes.active.theme.accent.hue3.contrast1}}</div><div flex>.md-accent-bg</div></div>\n<div class=\"md-accent-bg md-hue-3\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.accent.hue3.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-accent-bg .md-hue-3 .secondary-text</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.accent.hue3.contrast3}}</div><div class=\"hint-text\" flex>.md-accent-bg .md-hue-3 .hint-text\n</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.hue3.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .md-hue-3 .divider\n</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-3\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.accent.hue3.color}}</div><div flex>.md-accent-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/background/background.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-background-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.background.color}}</div><div \nflex>.md-background-bg</div></div><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nPrimary Text</div><div flex>{{vm.themes.active.theme.background.contrast1}}</div><div flex>.md-background-bg</div>\n</div><div class=\"md-background-bg\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.contrast2}}</div><div class=\"secondary-text\" flex>.md-background-bg .secondary-text\n</div></div><div class=\"md-background-bg\" flex=\"100\" class=\"hint-text\" layout=\"row\" layout-padding><div \nclass=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.background.contrast3}}</div><div class=\"hint-text\" flex>.md-background-bg .hint-text</div>\n</div><div class=\"md-background-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" flex>\nFade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.background.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-background-bg .divider</div></div><div flex=\"100\" class=\"md-primary-bg md-background-fg\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.background.color}}\n</div><div flex>.md-background-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap \nlayout-align=\"center center\"><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nHue 1</div><div flex>{{vm.themes.active.theme.background.hue1.color}}</div><div flex>.md-background-bg .md-hue-1</div>\n</div><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div \nflex>{{vm.themes.active.theme.background.hue1.contrast1}}</div><div flex>.md-background-bg</div></div><div \nclass=\"md-background-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-background-bg .md-hue-1 .secondary-text</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.background.hue1.contrast3}}</div><div class=\"hint-text\" flex>\n.md-background-bg .md-hue-1 .hint-text</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" class=\"divider\" \nlayout=\"row\" layout-padding><div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.background.hue1.contrast4}}</div><div class=\"fade-text\" flex>\n.md-background-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding><div \nflex class=\"md-background-fg md-hue-1\">As foreground color</div><div flex class=\"md-background-fg md-hue-1\">\n{{vm.themes.active.theme.background.hue1.color}}</div><div flex class=\"md-background-fg md-hue-1\">.md-background-fg\n</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div \nclass=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 2</div><div flex>\n{{vm.themes.active.theme.background.hue2.color}}</div><div flex>.md-background-bg .md-hue-2</div></div><div \nclass=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.background.hue2.contrast1}}</div><div flex>.md-background-bg</div></div><div \nclass=\"md-background-bg md-hue-2\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.hue2.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-background-bg .md-hue-2 .secondary-text</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.background.hue2.contrast3}}</div><div class=\"hint-text\" flex>\n.md-background-bg .md-hue-2 .hint-text</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" class=\"divider\" \nlayout=\"row\" layout-padding><div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.background.hue2.contrast4}}</div><div class=\"fade-text\" flex>\n.md-background-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding><div \nflex class=\"md-background-fg md-hue-2\">As foreground color</div><div flex class=\"md-background-fg md-hue-2\">\n{{vm.themes.active.theme.background.hue2.color}}</div><div flex class=\"md-background-fg md-hue-2\">.md-background-fg\n</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div \nclass=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 3</div><div flex>\n{{vm.themes.active.theme.background.hue3.color}}</div><div flex>.md-background-bg .md-hue-3</div></div><div \nclass=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.background.hue3.contrast1}}</div><div flex>.md-background-bg</div></div><div \nclass=\"md-background-bg md-hue-3\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.hue3.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-background-bg .md-hue-3 .secondary-text</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.background.hue3.contrast3}}</div><div class=\"hint-text\" flex>\n.md-background-bg .md-hue-3 .hint-text</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" class=\"divider\" \nlayout=\"row\" layout-padding><div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.background.hue3.contrast4}}</div><div class=\"fade-text\" flex>\n.md-background-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding><div \nflex class=\"md-background-fg md-hue-3\">As foreground color</div><div flex class=\"md-background-fg md-hue-3\">\n{{vm.themes.active.theme.background.hue3.color}}</div><div flex class=\"md-background-fg md-hue-3\">.md-background-fg\n</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/primary/primary.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.primary.color}}</div><div flex>\n.md-primary-bg</div></div><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text\n</div><div flex>{{vm.themes.active.theme.primary.contrast1}}</div><div flex>.md-primary-bg</div></div><div \nclass=\"md-primary-bg\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>\nSecondary Text / Icon</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.primary.contrast2}}</div><div \nclass=\"secondary-text\" flex>.md-primary-bg .secondary-text</div></div><div class=\"md-primary-bg\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.primary.contrast3}}</div><div class=\"hint-text\" flex>\n.md-primary-bg .hint-text</div></div><div class=\"md-primary-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding>\n<div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .divider</div></div><div \nflex=\"100\" class=\"md-primary-fg\" layout=\"row\" layout-padding><div flex>As foreground color</div><div flex>\n{{vm.themes.active.theme.primary.color}}</div><div flex>.md-primary-fg</div></div></div><div class=\"color\" \nlayout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" \nlayout-padding><div flex>Hue 1</div><div flex>{{vm.themes.active.theme.primary.hue1.color}}</div><div flex>\n.md-primary-bg .md-hue-1</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div \nflex>Primary Text</div><div flex>{{vm.themes.active.theme.primary.hue1.contrast1}}</div><div flex>.md-primary-bg</div>\n</div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.primary.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-primary-bg .md-hue-1 .secondary-text</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.primary.hue1.contrast3}}</div><div class=\"hint-text\" flex>.md-primary-bg .md-hue-1 .hint-text\n</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.hue1.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .md-hue-1 .divider\n</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-1\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.primary.hue1.color}}</div><div flex>.md-primary-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg md-hue-2\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 2</div><div flex>{{vm.themes.active.theme.primary.hue2.color}}</div><div \nflex>.md-primary-bg .md-hue-2</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding>\n<div flex>Primary Text</div><div flex>{{vm.themes.active.theme.primary.hue2.contrast1}}</div><div flex>.md-primary-bg\n</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.primary.hue2.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-primary-bg .md-hue-2 .secondary-text</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.primary.hue2.contrast3}}</div><div class=\"hint-text\" flex>.md-primary-bg .md-hue-2 .hint-text\n</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.hue2.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .md-hue-2 .divider\n</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-2\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.primary.hue2.color}}</div><div flex>.md-primary-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg md-hue-3\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 3</div><div flex>{{vm.themes.active.theme.primary.hue3.color}}</div><div \nflex>.md-primary-bg .md-hue-3</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding>\n<div flex>Primary Text</div><div flex>{{vm.themes.active.theme.primary.hue3.contrast1}}</div><div flex>.md-primary-bg\n</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.primary.hue3.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-primary-bg .md-hue-3 .secondary-text</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.primary.hue3.contrast3}}</div><div class=\"hint-text\" flex>.md-primary-bg .md-hue-3 .hint-text\n</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.hue3.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .md-hue-3 .divider\n</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-3\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.primary.hue3.color}}</div><div flex>.md-primary-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/warn/warn.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-warn-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.warn.color}}</div><div flex>\n.md-warn-bg</div></div><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div \nflex>{{vm.themes.active.theme.warn.contrast1}}</div><div flex>.md-warn-bg</div></div><div class=\"md-warn-bg\" \nflex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>Secondary Text / Icon\n</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.warn.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-warn-bg .secondary-text</div></div><div class=\"md-warn-bg\" flex=\"100\" class=\"hint-text\" layout=\"row\" \nlayout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .hint-text</div></div><div \nclass=\"md-warn-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" flex>\nFade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .divider</div></div><div flex=\"100\" class=\"md-warn-fg\" layout=\"row\" layout-padding>\n<div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.color}}</div><div flex>.md-warn-fg</div>\n</div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-warn-bg md-hue-1\" \nflex=\"100\" layout=\"row\" layout-padding><div flex>Hue 1</div><div flex>{{vm.themes.active.theme.warn.hue1.color}}</div>\n<div flex>.md-warn-bg .md-hue-1</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div\n flex>Primary Text</div><div flex>{{vm.themes.active.theme.warn.hue1.contrast1}}</div><div flex>.md-warn-bg</div></div>\n<div class=\"md-warn-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.warn.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-warn-bg .md-hue-1 .secondary-text</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.hue1.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .md-hue-1 .hint-text</div>\n</div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" \nflex>Fade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.hue1.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-1\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.hue1.color}}\n</div><div flex>.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\">\n<div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 2</div><div flex>\n{{vm.themes.active.theme.warn.hue2.color}}</div><div flex>.md-warn-bg .md-hue-2</div></div><div \nclass=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.warn.hue2.contrast1}}</div><div flex>.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-2\" \nflex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>Secondary Text / Icon\n</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.warn.hue2.contrast2}}</div><div class=\"secondary-text\" \nflex>.md-warn-bg .md-hue-2 .secondary-text</div></div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.hue2.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .md-hue-2 .hint-text</div>\n</div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" \nflex>Fade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.hue2.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-2\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.hue2.color}}\n</div><div flex>.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\">\n<div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 3</div><div flex>\n{{vm.themes.active.theme.warn.hue3.color}}</div><div flex>.md-warn-bg .md-hue-3</div></div><div \nclass=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.warn.hue3.contrast1}}</div><div flex>.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-3\" \nflex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>Secondary Text / Icon\n</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.warn.hue3.contrast2}}</div><div class=\"secondary-text\" \nflex>.md-warn-bg .md-hue-3 .secondary-text</div></div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.hue3.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .md-hue-3 .hint-text</div>\n</div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" \nflex>Fade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.hue3.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-3\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.hue3.color}}\n</div><div flex>.md-warn-fg</div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" layout=\"row\" layout-align=\"start center\"><div class=\"step\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">\nOptional</div></div></md-button><div class=\"ms-stepper-step-content\" ng-transclude></div><div \nclass=\"ms-stepper-controls\" layout=\"row\" layout-align=\"start center\" \nng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button class=\"md-accent md-raised\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/apps/create-res/dialogs/pos-options-overlay/partials/pos-options-footer.html","<div class=\"pos-products-footer-inner\" layout=\"row\" layout-align=\"space-between center\"><p class=\"pos-footer-hint\" \nng-if=\"vm.footerStep === \'pos\' && vm.getReviewCartCount() > 0\"><span class=\"pos-footer-avatar\"><md-icon \nmd-font-icon=\"icon-cart\"></md-icon><span class=\"pos-footer-avatar-badge\">{{vm.getReviewCartCount()}}</span> </span>\n<span>{{vm.getReviewCartCount()}} POS item<span ng-if=\"vm.getReviewCartCount() !== 1\">s</span>\n selected for this reservation.</span></p><span flex \nng-if=\"vm.footerStep === \'insurance\' || (vm.footerStep === \'pos\' && vm.getReviewCartCount() === 0)\"></span><div \nclass=\"pos-pagination\" ng-if=\"vm.footerStep === \'pos\' && vm.totalProduct > vm.dataPerPage\"><md-button \nclass=\"md-icon-button pos-page-btn\" md-no-ink ng-click=\"vm.switchPage(\'back\')\" ng-disabled=\"vm.curPage <= 1\" \naria-label=\"Previous page\"><md-icon md-font-icon=\"icon-chevron-left\" class=\"pos-page-arrow\"></md-icon></md-button><span\n class=\"pos-pagination-label\">{{vm.curPage}} / {{vm.totalPages}}</span><md-button class=\"md-icon-button pos-page-btn\" \nmd-no-ink ng-click=\"vm.switchPage(\'forward\')\" ng-disabled=\"vm.curPage >= vm.totalPages\" aria-label=\"Next page\"><md-icon\n md-font-icon=\"icon-chevron-right\" class=\"pos-page-arrow\"></md-icon></md-button></div><div class=\"pos-footer-actions\" \nlayout=\"row\" layout-align=\"end center\" ng-animate-disabled><md-button class=\"pos-btn-ghost\" md-no-ink \nng-show=\"vm.footerStep === \'insurance\'\" ng-click=\"vm.goBackToPos()\">Back</md-button><md-button \nclass=\"md-raised pos-btn-primary\" md-no-ink ng-click=\"vm.handlePrimaryFooterClick()\" \nng-disabled=\"vm.isPrimaryFooterDisabled()\">{{vm.getPrimaryFooterLabel()}}</md-button></div></div>");
$templateCache.put("app/main/apps/create-res/dialogs/pos-options-overlay/partials/pos-options-search.html","<div class=\"pos-search-bar\"><md-icon md-font-icon=\"icon-magnify\" class=\"pos-search-icon\"></md-icon><input \nid=\"posSearch\" type=\"search\" class=\"pos-search-input\" name=\"posSearch\" ng-model=\"vm.search\" placeholder=\"Search\" \nng-model-options=\"{ debounce: 400 }\" ng-change=\"vm.filterProducts()\" ng-focus=\"vm.autoFillOff = false\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><md-button class=\"md-icon-button pos-search-clear\" \nng-if=\"vm.getSearchText()\" ng-click=\"vm.clearSearch()\" aria-label=\"Clear search\"><md-icon \nmd-font-icon=\"icon-close-circle\"></md-icon></md-button></div>");
$templateCache.put("app/main/apps/create-res/dialogs/pos-options-overlay/partials/pos-options-sidebar.html","<div class=\"pos-sidebar\"><div class=\"pos-sidebar-upper\"><div class=\"pos-cart-strip\" layout=\"row\" \nlayout-align=\"space-between start\" ng-class=\"{\'has-items\': vm.getReviewCartCount() > 0}\"><div \nclass=\"pos-cart-strip-stat\"><span class=\"pos-cart-strip-label\">Selected</span> <span class=\"pos-cart-strip-value\">\n{{vm.getReviewCartCount()}} item<span ng-if=\"vm.getReviewCartCount() !== 1\">s</span></span></div><div \nclass=\"pos-cart-strip-stat pos-cart-strip-stat--end\" ng-if=\"vm.getReviewCartCount() > 0\"><span \nclass=\"pos-cart-strip-label\">POS subtotal</span> <span class=\"pos-cart-strip-value\">\n{{vm.getSelectedPosSubtotal() | currency:$:2}}</span></div></div><header class=\"pos-review-header\" layout=\"row\" \nlayout-align=\"space-between center\"><h4 class=\"pos-review-title\">Review additions</h4><md-button class=\"pos-text-btn\" \nng-click=\"vm.emptyCart()\" ng-disabled=\"!vm.hasVisibleCartItems()\">Clear all</md-button></header><div \nclass=\"pos-selected-panel\" ms-scroll><div class=\"pos-selected-list\" ng-class=\"{\'is-loading\': vm.isloading}\"><div \nclass=\"pos-sidebar-skeleton\" ng-if=\"vm.isloading\"><div class=\"pos-sidebar-skeleton-row\" \nng-repeat=\"n in vm.skeletonReviewSlots track by $index\"><div class=\"pos-sidebar-skeleton-thumb\"></div><div \nclass=\"pos-sidebar-skeleton-lines\"><div class=\"pos-sidebar-skeleton-line\"></div><div \nclass=\"pos-sidebar-skeleton-line short\"></div></div></div></div><div class=\"pos-selected-empty\" \nng-if=\"!vm.isloading && !vm.hasVisibleCartItems()\"><div class=\"pos-empty-illustration pos-empty-illustration--small\">\n<md-icon md-font-icon=\"icon-cursor-pointer\"></md-icon></div><p class=\"pos-empty-title\">Nothing selected yet</p><p \nng-if=\"vm.step === \'pos\'\">Tap a product on the left to add it to this reservation.</p><p \nng-if=\"vm.step === \'insurance\'\">Selected add-ons from the previous step appear here.</p></div><div \nclass=\"pos-selected-item\" ng-repeat=\"(cartKey, cart) in vm.cartItem track by $index\" \nng-if=\"vm.isSelectablePosLine(cart)\"><div class=\"pos-selected-item-media\"><img \nng-src=\"{{vm.getProductImageUrl(cart)}}\" alt=\"\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\"></div><div class=\"pos-selected-item-body\"><div \nclass=\"pos-selected-item-name\">{{cart.product_name}}</div><div class=\"pos-selected-item-meta pos-selected-item-dates\" \nng-if=\"cart.product_is_timebound == 1\"><md-icon md-font-icon=\"icon-calendar-blank\"></md-icon><span \nclass=\"pos-selected-item-dates-text\">{{cart.from | date:\'MM/dd/yyyy\'}} – {{cart.to | date:\'MM/dd/yyyy\'}}</span></div>\n</div><div class=\"pos-selected-item-side\" ng-click=\"$event.stopPropagation();\"><div class=\"pos-selected-item-price\">\n{{(cart.particularCustomPrice != 0 ? (cart.particularCustomPrice * cart.quantity) : (cart.customPrice * cart.quantity)) | currency:$:2}}\n</div><div class=\"pos-selected-item-qty\" ng-if=\"vm.canAdjustCartQuantity(cart)\"><md-button \nclass=\"md-icon-button pos-qty-btn\" ng-click=\"vm.decrementCartItem(cartKey)\" aria-label=\"Decrease quantity\"><md-icon \nmd-font-icon=\"icon-minus\"></md-icon></md-button><span class=\"pos-qty-value\">{{cart.quantity}}</span><md-button \nclass=\"md-icon-button pos-qty-btn\" ng-click=\"vm.incrementCartItem(cartKey)\" aria-label=\"Increase quantity\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><md-button class=\"md-icon-button pos-selected-item-remove\" \nng-if=\"!vm.canAdjustCartQuantity(cart)\" md-ink-ripple=\"#ff5a60\" \nng-click=\"vm.removeCartItem(cartKey); $event.stopPropagation();\" aria-label=\"Remove\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></div></div></div></div><div class=\"pos-summary-panel\"><div \nclass=\"pos-summary-body reservation-summary-readonly-wrap\"><div \nng-include=\"\'app/main/apps/create-res/partials/reservation-summary-readonly.html\'\"></div></div><div \nclass=\"pos-summary-totals\"><div class=\"pos-summary-row pos-summary-row--grand\"><strong>Grand total</strong> <strong>\n{{overlaySummaryTotals.grand_total | currency:$:2}}</strong></div><div class=\"pos-summary-row\"><span>Paid Deposit\n</span> <span>{{overlaySummaryTotals.deposit_amount | currency:$:2}}</span></div><div \nclass=\"pos-summary-row pos-summary-row--due\"><span>Due at Check-In</span> <strong>\n{{overlaySummaryTotals.remaining_amount | currency:$:2}}</strong></div></div></div></div>");
$templateCache.put("app/main/apps/create-res/dialogs/pos-options-overlay/partials/pos-options-stepper.html","<nav class=\"pos-overlay-stepper pos-overlay-stepper--inline\" aria-label=\"Add-ons and insurance progress\"><div \nclass=\"pos-stepper-track\"><div class=\"pos-stepper-step\" \nng-class=\"{\n				\'is-active\': vm.isStepperStepActive(1),\n				\'is-complete\': vm.isStepperStepComplete(1),\n				\'is-clickable\': vm.isStepperStepClickable(1)\n			}\" \nng-click=\"vm.onStepperStepClick(1)\" \nng-keypress=\"vm.isStepperStepClickable(1) && ($event.keyCode === 13 || $event.keyCode === 32) ? vm.onStepperStepClick(1) : null\" \nng-attr-role=\"{{vm.isStepperStepClickable(1) ? \'button\' : undefined}}\" \nng-attr-tabindex=\"{{vm.isStepperStepClickable(1) ? 0 : undefined}}\" \nng-attr-aria-label=\"{{vm.isStepperStepClickable(1) ? \'Go to choose add-ons\' : undefined}}\"><div \nclass=\"pos-stepper-node\"><md-icon md-font-icon=\"icon-check\" ng-if=\"vm.isStepperStepComplete(1)\"></md-icon><span \nng-if=\"!vm.isStepperStepComplete(1)\">01</span></div><span class=\"pos-stepper-label\">{{vm.getStepperLabel(1)}}</span>\n</div><div class=\"pos-stepper-connector\" aria-hidden=\"true\"></div><div class=\"pos-stepper-step\" \nng-class=\"{\n				\'is-active\': vm.isStepperStepActive(2),\n				\'is-pending\': vm.footerStep === \'pos\',\n				\'is-clickable\': vm.isStepperStepClickable(2)\n			}\" \nng-click=\"vm.onStepperStepClick(2)\" \nng-keypress=\"vm.isStepperStepClickable(2) && ($event.keyCode === 13 || $event.keyCode === 32) ? vm.onStepperStepClick(2) : null\" \nng-attr-role=\"{{vm.isStepperStepClickable(2) ? \'button\' : undefined}}\" \nng-attr-tabindex=\"{{vm.isStepperStepClickable(2) ? 0 : undefined}}\" \nng-attr-aria-label=\"{{vm.isStepperStepClickable(2) ? \'Go to add insurance\' : undefined}}\"><div \nclass=\"pos-stepper-node\"><span>02</span></div><span class=\"pos-stepper-label\">{{vm.getStepperLabel(2)}}</span></div>\n</div></nav>");
$templateCache.put("app/main/apps/dashboards/gantt-chart/sidenavs/settings/settings-sidenav.html","<md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Settings\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><h2><span>Settings</span></h2></div>\n</md-toolbar><md-content class=\"content\" layout-padding><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"GANTT.EDIT\">Edit</span></md-subheader><md-list-item><md-icon md-font-icon=\"icon-pencil\"></md-icon><p \ntranslate=\"GANTT.DRAW\">Draw</p><md-checkbox class=\"md-secondary\" ng-model=\"vm.options.draw\"></md-checkbox>\n</md-list-item><md-list-item><md-icon md-font-icon=\"icon-lock\"></md-icon><p translate=\"GANTT.READ_ONLY\">Read only</p>\n<md-checkbox class=\"md-secondary\" ng-model=\"vm.options.readOnly\"></md-checkbox></md-list-item><md-divider></md-divider>\n<md-subheader class=\"md-no-sticky\"><span translate=\"GANTT.SNAP\">Snap</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-magnet\"></md-icon><p translate=\"GANTT.SNAP_AREA\">Snap area</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.columnMagnet\" placeholder=\"Snap area\"><md-option value=\"column\" \ntranslate=\"GANTT.COLUMN\">Column</md-option><md-option value=\"1 second\" translate=\"GANTT.1_SECOND\">1 second</md-option>\n<md-option value=\"1 minute\" translate=\"GANTT.1_MINUTE\">1 minute</md-option><md-option value=\"5 minutes\" \ntranslate=\"GANTT.5_MINUTES\">5 minutes</md-option><md-option value=\"15 minutes\" translate=\"GANTT.15_MINUTES\">15 minutes\n</md-option><md-option value=\"1 hour\" translate=\"GANTT.1_HOUR\">1 hour</md-option><md-option value=\"1 day\" \ntranslate=\"GANTT.1_DAY\">1 day</md-option><md-option value=\"5 days\" translate=\"GANTT.5_DAYS\">5 days</md-option>\n</md-select></md-list-item><md-list-item><md-icon md-font-icon=\"icon-view-day\"></md-icon><p translate=\"GANTT.DAILY\">\nDaily</p><md-checkbox class=\"md-secondary\" ng-model=\"vm.options.daily\"></md-checkbox></md-list-item><md-list-item>\n<md-icon md-font-icon=\"icon-lock\"></md-icon><p translate=\"GANTT.TIME_FRAMES\">Time frames</p><md-checkbox \nclass=\"md-secondary\" ng-model=\"vm.options.timeFramesMagnet\"></md-checkbox></md-list-item><md-divider></md-divider>\n<md-subheader class=\"md-no-sticky\"><span translate=\"GANTT.SIDEBAR\">Sidebar</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><p translate=\"GANTT.SHOW_SIDEBAR\">Show Sidebar</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.options.labelsEnabled\"></md-checkbox></md-list-item><md-list-item><md-icon md-font-icon=\"icon-code-tags\">\n</md-icon><p translate=\"GANTT.RESIZABLE\">Resizable</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.options.allowSideResizing\"></md-checkbox></md-list-item><md-list-item><md-icon \nmd-font-icon=\"icon-view-headline\"></md-icon><p translate=\"GANTT.LIST_MODE\">List Mode</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.sideMode\" placeholder=\"List\"><md-option value=\"Tree\" \ntranslate=\"GANTT.TREE\">Tree</md-option><md-option value=\"Table\" translate=\"GANTT.TABLE\">Table</md-option><md-option \nvalue=\"TreeTable\" translate=\"GANTT.TREE_TABLE\">TreeTable</md-option><md-option value=\"Disabled\" \ntranslate=\"GANTT.DISABLED\">Disabled</md-option></md-select></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\"><span translate=\"GANTT.TIMELINE\">Timeline</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-view-headline\"></md-icon><p translate=\"GANTT.GROUPS\">Groups</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.groupDisplayMode\" placeholder=\"Groups\"><md-option value=\"group\" \ntranslate=\"GANTT.GROUP\">Group</md-option><md-option value=\"overview\" translate=\"GANTT.OVERVIEW\">Overview</md-option>\n<md-option value=\"promote\" translate=\"GANTT.PROMOTE\">Promote</md-option><md-option value=\"Disabled\" \ntranslate=\"GANTT.DISABLED\">Disabled</md-option></md-select></md-list-item><md-divider></md-divider><md-list-item>\n<md-icon md-font-icon=\"icon-calendar-today\"></md-icon><p translate=\"GANTT.TODAY\">Today</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.currentDate\" placeholder=\"Today\"><md-option value=\"none\" \ntranslate=\"GANTT.NONE\">None</md-option><md-option value=\"line\" translate=\"GANTT.LINE\">Line</md-option><md-option \nvalue=\"column\" translate=\"GANTT.COLUMN\">Column</md-option></md-select></md-list-item><md-divider></md-divider>\n<md-list-item><md-icon md-font-icon=\"icon-arrow-expand\"></md-icon><p translate=\"GANTT.EXPAND\">Expand</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.autoExpand\" placeholder=\"Today\"><md-option value=\"none\" \ntranslate=\"GANTT.NONE\">None</md-option><md-option value=\"both\" translate=\"GANTT.BOTH\">Both</md-option><md-option \nvalue=\"left\" translate=\"GANTT.LEFT\">Left</md-option><md-option value=\"right\" translate=\"GANTT.RIGHT\">Right</md-option>\n</md-select></md-list-item><md-divider></md-divider><md-list-item><md-icon md-font-icon=\"icon-content-cut\"></md-icon><p\n translate=\"GANTT.OUT_OF_RANGE\">Out of range</p><md-select class=\"simplified md-secondary\" \nng-model=\"vm.options.taskOutOfRange\" placeholder=\"Out of range\"><md-option value=\"expand\" translate=\"GANTT.EXPAND\">\nEXPAND</md-option><md-option value=\"truncate\" translate=\"GANTT.TRUNCATE\">Truncate</md-option></md-select>\n</md-list-item><md-divider></md-divider></md-list></md-content>");
$templateCache.put("app/main/apps/dashboards/modified-gantt-chart/dialogs/borrowed-items/borrowed-items.html","<md-dialog class=\"borrowed-items-dialog\" aria-label=\"Borrowed Items\"><md-toolbar class=\"borrowed-items-toolbar\"><div \nclass=\"md-toolbar-tools\"><div class=\"borrowed-items-title\"><span>Borrowed Items</span> <small>\n{{vm.value.first_name}} {{vm.value.last_name}}</small></div><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"Close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"borrowed-items-loading\" ng-if=\"vm.isLoading\" layout=\"row\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></div><div \nclass=\"borrowed-items-empty\" ng-if=\"!vm.isLoading && !vm.items.length\">No borrowable products available right now.\n</div><div class=\"borrowed-item-row\" ng-if=\"!vm.isLoading\" ng-repeat=\"item in vm.items track by item.key\"><div \nclass=\"borrowed-item-info\"><div class=\"borrowed-item-icon\"><img ng-src=\"{{item.image}}\" alt=\"{{item.name}}\" \nclass=\"towel-icon-img\" ng-class=\"{\'default-product-image\': item.isDefaultImage}\"></div><div \nclass=\"borrowed-item-details\"><div class=\"borrowed-item-name\">{{item.name}}</div></div></div><div \nclass=\"borrowed-item-actions\"><div class=\"borrowed-item-quantity\"><md-button class=\"md-icon-button borrowed-qty-btn\" \nng-click=\"vm.changeCount(item, -1)\" ng-disabled=\"item.remaining <= 0 || vm.addingProductId\" aria-label=\"Return one\">\n<md-icon md-font-icon=\"icon-minus\"></md-icon></md-button><span class=\"borrowed-qty-value\">{{item.remaining}}</span>\n<md-button class=\"md-icon-button borrowed-qty-btn\" ng-click=\"vm.changeCount(item, 1)\" ng-disabled=\"vm.addingProductId\" \naria-label=\"Borrow one more\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><md-button \nclass=\"md-raised md-primary borrowed-add-btn\" ng-click=\"vm.addToReservation(item)\" \nng-disabled=\"item.remaining <= 0 || vm.addingProductId || vm.isSaving\" aria-label=\"Add to reservation\">\n<md-progress-circular ng-if=\"vm.addingProductId === item.product_id\" class=\"borrowed-add-spinner\" \nmd-mode=\"indeterminate\" md-diameter=\"16\"></md-progress-circular><span ng-if=\"vm.addingProductId !== item.product_id\">\nAdd</span><md-tooltip ng-if=\"item.remaining > 0 && !vm.isSaving && !vm.addingProductId\">Add to reservation</md-tooltip>\n</md-button></div></div><div class=\"borrowed-items-note\" ng-if=\"!vm.isLoading && vm.items.length\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-information-outline\" class=\"borrowed-items-note-icon\"></md-icon>\n<span><strong>Note:</strong> <strong>Save</strong> updates the existing borrowed item quantity. Click <strong>Add\n</strong> to add the selected item to the guest\'s reservation.</span></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><md-button ng-if=\"!vm.isLoading && !vm.items.length\" \nclass=\"md-raised md-primary borrowed-ok-btn\" ng-click=\"vm.ok()\">OK</md-button><md-button ng-if=\"vm.items.length\" \nng-click=\"vm.cancel()\">Cancel</md-button><md-button ng-if=\"vm.items.length\" \nclass=\"md-raised md-primary borrowed-save-btn\" ng-click=\"vm.save()\" \nng-disabled=\"vm.isLoading || !vm.hasChanges() || vm.isSaving || vm.addingProductId\"><md-progress-circular \nng-if=\"vm.isSaving\" class=\"borrowed-save-spinner\" md-mode=\"indeterminate\" md-diameter=\"18\"></md-progress-circular><span\n ng-if=\"!vm.isSaving\">Save</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/dashboards/modified-gantt-chart/dialogs/edit/edit-dialog.html","<md-dialog class=\"gantt-chart-add-edit-dialog\" aria-label=\"Edit Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title white-fg\">Edit</h2><span \nflex></span></div></md-toolbar><md-dialog-content ms-scroll style=\"max-width:800px;max-height:1000px\"><md-content \nclass=\"md-padding\"><div class=\"task\" layout=\"column\"><div layout=\"row\" flex=\"100\" class=\"padding-bottom-10\">\nYou are about to change reservation for {{vm.currentTask.model.name}}</div><div layout=\"row\" flex=\"100\" layout-wrap \nlayout-align=\"center start\"><div layout=\"column\" flex=\"100\" class=\"margin-top-5\"><p class=\"no-margin\">From: <b>\n{{vm.orderModifying.old_product_name}}: {{vm.orderModifying.old_room_stay_from}}</b> to <b>\n{{vm.orderModifying.old_room_stay_to}}</b></p></div><div layout=\"column\" flex=\"100\" class=\"margin-top-5\"><p \nclass=\"no-margin\">To: <b>{{vm.orderModifying.new_product_name}}: {{vm.orderModifying.new_room_stay_from}}</b> to <b>\n{{vm.orderModifying.new_room_stay_to}}</b></p></div></div><div layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"100\">\n<md-checkbox ng-disabled=\"vm.is_walk\" ng-checked=\"true\" ng-model=\"vm.keepSameRates\" class=\"mv-20\"><span>Keep same rates\n</span></md-checkbox></div></div><div layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"100\" class=\"mb-10\">\nDo you want to continue?</div></div></div></md-content></md-dialog-content><md-dialog-actions \nclass=\"grey-100-bg edit-dialog\" layout=\"row\" flex=\"100\" flex-wrap layout-align=\"center\"><md-button \nstyle=\"max-width:130px\" class=\"md-accent md-raised white-fg mv-0 md-green-500-bg\" ng-click=\"vm.saveReservation();\" \naria-label=\"Save\" ng-disabled=\"vm.isloading\"><span>Yes</span></md-button><md-button style=\"max-width:130px\" \nclass=\"md-accent md-raised white-fg mv-0 md-red-500-bg\" ng-click=\"vm.closeDialog();vm.reloadGantt();\" aria-label=\"No\">\n<span>No</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/dashboards/modified-gantt-chart/sidenavs/settings/settings-sidenav.html","<md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Settings\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><h2><span>Settings</span></h2></div>\n</md-toolbar><md-content class=\"content\" layout-padding><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"GANTT.EDIT\">Edit</span></md-subheader><md-list-item><md-icon md-font-icon=\"icon-pencil\"></md-icon><p \ntranslate=\"GANTT.DRAW\">Draw</p><md-checkbox class=\"md-secondary\" ng-model=\"vm.options.draw\"></md-checkbox>\n</md-list-item><md-list-item><md-icon md-font-icon=\"icon-lock\"></md-icon><p translate=\"GANTT.READ_ONLY\">Read only</p>\n<md-checkbox class=\"md-secondary\" ng-model=\"vm.options.readOnly\"></md-checkbox></md-list-item><md-divider></md-divider>\n<md-subheader class=\"md-no-sticky\"><span translate=\"GANTT.SNAP\">Snap</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-magnet\"></md-icon><p translate=\"GANTT.SNAP_AREA\">Snap area</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.columnMagnet\" placeholder=\"Snap area\"><md-option value=\"column\" \ntranslate=\"GANTT.COLUMN\">Column</md-option><md-option value=\"1 second\" translate=\"GANTT.1_SECOND\">1 second</md-option>\n<md-option value=\"1 minute\" translate=\"GANTT.1_MINUTE\">1 minute</md-option><md-option value=\"5 minutes\" \ntranslate=\"GANTT.5_MINUTES\">5 minutes</md-option><md-option value=\"15 minutes\" translate=\"GANTT.15_MINUTES\">15 minutes\n</md-option><md-option value=\"1 hour\" translate=\"GANTT.1_HOUR\">1 hour</md-option><md-option value=\"1 day\" \ntranslate=\"GANTT.1_DAY\">1 day</md-option><md-option value=\"5 days\" translate=\"GANTT.5_DAYS\">5 days</md-option>\n</md-select></md-list-item><md-list-item><md-icon md-font-icon=\"icon-view-day\"></md-icon><p translate=\"GANTT.DAILY\">\nDaily</p><md-checkbox class=\"md-secondary\" ng-model=\"vm.options.daily\"></md-checkbox></md-list-item><md-list-item>\n<md-icon md-font-icon=\"icon-lock\"></md-icon><p translate=\"GANTT.TIME_FRAMES\">Time frames</p><md-checkbox \nclass=\"md-secondary\" ng-model=\"vm.options.timeFramesMagnet\"></md-checkbox></md-list-item><md-divider></md-divider>\n<md-subheader class=\"md-no-sticky\"><span translate=\"GANTT.SIDEBAR\">Sidebar</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><p translate=\"GANTT.SHOW_SIDEBAR\">Show Sidebar</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.options.labelsEnabled\"></md-checkbox></md-list-item><md-list-item><md-icon md-font-icon=\"icon-code-tags\">\n</md-icon><p translate=\"GANTT.RESIZABLE\">Resizable</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.options.allowSideResizing\"></md-checkbox></md-list-item><md-list-item><md-icon \nmd-font-icon=\"icon-view-headline\"></md-icon><p translate=\"GANTT.LIST_MODE\">List Mode</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.sideMode\" placeholder=\"List\"><md-option value=\"Tree\" \ntranslate=\"GANTT.TREE\">Tree</md-option><md-option value=\"Table\" translate=\"GANTT.TABLE\">Table</md-option><md-option \nvalue=\"TreeTable\" translate=\"GANTT.TREE_TABLE\">TreeTable</md-option><md-option value=\"Disabled\" \ntranslate=\"GANTT.DISABLED\">Disabled</md-option></md-select></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\"><span translate=\"GANTT.TIMELINE\">Timeline</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-view-headline\"></md-icon><p translate=\"GANTT.GROUPS\">Groups</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.groupDisplayMode\" placeholder=\"Groups\"><md-option value=\"group\" \ntranslate=\"GANTT.GROUP\">Group</md-option><md-option value=\"overview\" translate=\"GANTT.OVERVIEW\">Overview</md-option>\n<md-option value=\"promote\" translate=\"GANTT.PROMOTE\">Promote</md-option><md-option value=\"Disabled\" \ntranslate=\"GANTT.DISABLED\">Disabled</md-option></md-select></md-list-item><md-divider></md-divider><md-list-item>\n<md-icon md-font-icon=\"icon-calendar-today\"></md-icon><p translate=\"GANTT.TODAY\">Today</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.currentDate\" placeholder=\"Today\"><md-option value=\"none\" \ntranslate=\"GANTT.NONE\">None</md-option><md-option value=\"line\" translate=\"GANTT.LINE\">Line</md-option><md-option \nvalue=\"column\" translate=\"GANTT.COLUMN\">Column</md-option></md-select></md-list-item><md-divider></md-divider>\n<md-list-item><md-icon md-font-icon=\"icon-arrow-expand\"></md-icon><p translate=\"GANTT.EXPAND\">Expand</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.autoExpand\" placeholder=\"Today\"><md-option value=\"none\" \ntranslate=\"GANTT.NONE\">None</md-option><md-option value=\"both\" translate=\"GANTT.BOTH\">Both</md-option><md-option \nvalue=\"left\" translate=\"GANTT.LEFT\">Left</md-option><md-option value=\"right\" translate=\"GANTT.RIGHT\">Right</md-option>\n</md-select></md-list-item><md-divider></md-divider><md-list-item><md-icon md-font-icon=\"icon-content-cut\"></md-icon><p\n translate=\"GANTT.OUT_OF_RANGE\">Out of range</p><md-select class=\"simplified md-secondary\" \nng-model=\"vm.options.taskOutOfRange\" placeholder=\"Out of range\"><md-option value=\"expand\" translate=\"GANTT.EXPAND\">\nEXPAND</md-option><md-option value=\"truncate\" translate=\"GANTT.TRUNCATE\">Truncate</md-option></md-select>\n</md-list-item><md-divider></md-divider></md-list></md-content>");
$templateCache.put("app/main/apps/e-commerce/views/activities/activity/activity.html","<div id=\"activity\" class=\"page-layout simple tabbed\" layout=\"column\"><form id=\"activityForm\" name=\"activityForm\" \nng-submit=\"activityForm.$valid && vm.addActivity(vm.activityData)\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-products-button md-icon-button\" ng-click=\"vm.goBack()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button><div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h2\" ng-if=\"vm.flag == \'add\'\">{{ \'POS_TYPE.NEW_ACTIVITY\' | translate }}</div><div class=\"h2\" \nng-if=\"vm.flag != \'add\'\">{{vm.activityData.product_name}}</div><div class=\"subtitle secondary-text\" \nng-if=\"vm.flag == \'edit\'\"><span translate=\"POS_TYPE.SUB_HEADER\"></span></div></div></div></div><div \nng-show=\"vm.flag == \'add\'\"><md-button class=\"md-raised md-background\" \nng-class=\"{\'md-blue-grey-A100-bg\': activityForm.$invalid || activityForm.$pristine || vm.nameError}\" \nng-disabled=\"activityForm.$invalid || activityForm.$pristine || vm.nameError\" type=\"submit\"><span \ntranslate=\"GROUPS.SAVE\"></span></md-button><md-button class=\"md-raised md-background\"><span \nui-sref=\"app.e-commerce.activities\" translate=\"GROUPS.CANCEL\"></span></md-button></div></div><div \nclass=\"content content-scroll\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear>\n<div class=\"product-detail-form-container md-whiteframe-1dp height\"><div class=\"role-list-outer height-main\"><div \nclass=\"role-list-out white-bg relative-block featured-block-main\"><div class=\"div-outer-simple-block\"><div \nclass=\"form-title\" translate=\"ROOM_TYPE.UPLOAD_PRODUCT_PICTURES\"></div><div class=\"errorDiv\" \nng-if=\"vm.failedFiles.length > 0\"><div class=\"error-li\" ng-repeat=\"error in vm.failedFiles\"><p \nng-bind=\"error.filename\"></p><p ng-bind-html=\"error.message\"></p></div></div><div id=\"product-image-uploader\"><div \nlayout=\"row\" flex layout-align=\"start center\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"65\" \nlayout-align=\"start center\"><div class=\"drop-text hint-text padding-10\"><span translate=\"ROOM_TYPE.DROP_TO_UPLOAD\">\n</span></div><div class=\"upload-button margin-top-10 upload-img-blk-drag padding-10\" layout=\"column\" \nlayout-align=\"center center\" flex><div layout=\"row\" layout-align=\"center center\" layout-wrap><div layout=\"column\" \nflex=\"100\"><div class=\"uplodetxt-drop\"><div class=\"uplode-btn-main-block\"><md-icon class=\"md-accent md-raised\" \nmd-svg-src=\"{{vm.feBaseUrl+\'angular-material-assets/img/icons/upload1.svg\'}}\" style=\"cursor: pointer\"></md-icon></div>\n<p class=\"no-margin padding-top-15\"><span translate=\"ROOM_TYPE.DRAG_IMG_HEADING\"></span></p><div \nngf-drop=\"vm.uploadProductImages($files, $invalidFiles)\" class=\"drop-box secondary-text mt-8 drag-drop-area\" \nngf-drag-over-class=\"\'dragover\'\" ngf-multiple=\"true\" ngf-pattern=\"\'.jpg,.jpeg,.png,.gif\'\" \nngf-accept=\"\'.jpg,.jpeg,.png,.gif\'\" ngf-select=\"vm.uploadProductImages($files, $invalidFiles)\" multiple=\"multiple\">\n</div></div></div><span class=\"progress loading-process\" ng-show=\"vm.progress || vm.processing\"><div \nstyle=\"width:{{vm.progressnum}}%\" ng-bind=\"vm.progressnum + \'%\'\" ng-show=\"vm.progress\"></div><div \nng-show=\"vm.processing\">Processing upload <img src=\"{{vm.feBaseUrl+\'images/ecommerce/loader.gif\'}}\"></div></span></div>\n</div></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"35\" class=\"padding-left-15 padding-right-15\"><div class=\"note\">\n<p translate=\"ROOM_TYPE.IMAGE_NOTE\" class=\"no-margin padding-bottom-10\"></p><span \ntranslate=\"ROOM_TYPE.DROP_IMG_HEADING\"></span></div></div></div><div class=\"images images-uploded-block\"><ul \nui-sortable=\"sortableOptions\" ng-model=\"vm.uploadedFiles\" class=\"list\"><li ng-repeat=\"image in vm.uploadedFiles\"><div \nclass=\"cross-icons\"><a ng-click=\"vm.deleteAddImage(image.filename)\" ng-if=\"vm.flag == \'add\'\"><md-icon \nmd-font-icon=\"icon-close \" class=\"close-icon1 white-fg font-size-12\"></md-icon></a><a \nng-click=\"vm.deleteUploadedImage(image.catalog_product_media_id, image.type_id,image.filename,$event)\" \nng-if=\"vm.flag == \'edit\'\"><md-icon md-font-icon=\"icon-close\" class=\"close-icon1 white-fg font-size-12\"></md-icon></a>\n</div><div class=\"imageBox\" ng-click=\"vm.imageViewer($event,image.filename)\" style=\"cursor: pointer\"><img \nng-src=\"{{image.url}}\"></div></li></ul></div></div></div></div><div class=\"role-list-out white-bg relative-block\"><div \nclass=\"form-title margin-left-10\" translate=\"POS_TYPE.ACT_DETAILS\"></div><div class=\"row-block\" flex-gt-xs=\"100\" \nlayout=\"row\" layout-align=\"start start\" layout-wrap><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" \nflex-gt-md=\"50\" flex-gt-xs=\"100\" layout=\"column\" layout-align=\"start start\"><md-input-container \nclass=\"md-block tax-inputs\" flex=\"90\" flex-xs=\"80\"><label translate=\"POS_TYPE.PRODUCT_TYPE\"></label><md-select \nplaceholder=\"{{ \'POS_TYPE.PRODUCT_TYPE\' | translate }}\" ng-model=\"vm.activityData.product_pos_type\" \nng-change=\" !activityForm.product_pos_type.$invalid && vm.loadTypesPos(vm.activityData.product_pos_type);vm.saveEachField(vm.activityData.product_pos_type, \'product_pos_type\'); vm.checkIfRestaurant()\" \nng-model-options=\"{debounce: 500}\" multiple=\"multiple\" required><md-option ng-value=\"posproducttype.hidename\" \nng-repeat=\"posproducttype in vm.posProductTypes\">{{posproducttype.showname}}</md-option></md-select><div \nclass=\"md-error-spacer\"></div></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" \nflex=\"100\" flex-gt-md=\"50\" flex-gt-xs=\"100\" layout=\"column\" layout-align=\"start start\"><md-input-container \nclass=\"md-block tax-inputs\"><label translate=\"POS_TYPE.DISPLAY_NAME\"></label><input type=\"text\" \nname=\"fe_display_product_name\" ng-model=\"vm.activityData.fe_display_product_name\" \nng-change=\" activityForm.fe_display_product_name.$valid && vm.saveEachField(vm.activityData.fe_display_product_name, \'fe_display_product_name\')\" \nrequired ng-model-options=\"{debounce: 500}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div \nng-messages=\"activityForm.room_type_name.$error\" role=\"alert\" multiple=\"multiple\"><div ng-if=\"vm.nameError\" \nclass=\"emailError\"><span translate=\"POS_TYPE.NAME_EXISTS\"></span></div></div></md-input-container></div></div><div \nclass=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex><div class=\"row-col\" layout=\"row\" \nlayout-align=\"start start\" flex layout-wrap><div class=\"row-row-col padding-right-10 padding-left-10\" flex=\"100\" \nflex-gt-xs=\"50\" layout=\"column\"><div class=\"row-col\" layout=\"row\" layout-align=\"start start\" flex layout-wrap>\n<md-input-container class=\"md-block tax-inputs\" flex=\"90\" flex-xs=\"80\"><label translate=\"POS_TYPE.POS_TYPE\"></label>\n<md-select ng-model=\"vm.activityData.type_id\" multiple=\"multiple\" \nng-change=\"vm.onChangeProductType(vm.activityData.type_id, \'type_id\')\" name=\"type_id\"><md-optgroup \nng-repeat=\"(posKey, postype) in vm.posTypes\" label=\"{{posKey}}\"><md-option ng-value=\"postypeData.pos_type_id\" \nng-repeat=\"postypeData in postype\">{{postypeData.pos_type_name}}</md-option></md-optgroup></md-select><div \nng-if=\"vm.productTypeError\" class=\"md-error-spacer\" style=\"font-size: 12px; color: #d60606\"><span>\n{{vm.productTypeName}} already exists.</span></div></md-input-container><div flex=\"10\" flex-xs=\"20\"><md-button \ntitle=\"{{ \'POS_TYPE.NEW_POS_TYPE\' | translate }}\" class=\"md-fab md-mini md-button md-default-theme md-ink-ripple\" \nng-click=\"vm.addNewPosType()\"><i class=\"icon-plus icon-plus-main md-default-theme white-fg\"></i></md-button></div>\n</div></div><div class=\"row-row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\">\n<md-input-container class=\"md-block tax-inputs\"><label translate=\"POS_TYPE.ROOM_NAME\"></label><input type=\"text\" \nname=\"product_name\" ng-model=\"vm.activityData.product_name\" \nng-change=\" activityForm.product_name.$valid && vm.saveEachField(vm.activityData.product_name, \'product_name\')\" \nrequired ng-model-options=\"{debounce: 500}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div \nng-if=\"vm.nameError == true\" class=\"emailError\"><span translate=\"POS_TYPE.NAME_EXISTS\"></span></div>\n</md-input-container></div></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" \nlayout-wrap><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\"><md-input-container class=\"md-block tax-inputs\"><label translate=\"ROOM_TYPE.SELECT_TAX\">\n</label><md-select multiple=\"multiple\" name=\"product_tax\" ng-model=\"vm.activityData.product_tax\" \nplaceholder=\"{{ \'ROOM_TYPE.SELECT_TAX\' | translate }}\" md-no-asterisk=\"false\" \nng-change=\"vm.flag == \'edit\' && activityForm.product_tax.$valid && vm.saveEachField(vm.activityData.product_tax, \'product_tax\')\" \nng-model-options=\"{debounce: 500}\" required><md-option value=\"0\" \nmd-selected=\"vm.activityData.product_tax == 0 ? \'selected\' : \'\';\">{{ \'POS_TYPE.NONE\' | translate}}</md-option>\n<md-option class=\"capitalize\" value=\"{{tax.tax_id}}\" ng-repeat=\"tax in vm.actTaxData\">\n{{tax.tax_name+\'@\'+tax.tax_value}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container>\n</div><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"row\" \nlayout-align=\"end start\" ng-if=\"!vm.isResortFeeProduct && !vm.isExtraPersonProduct\"><md-input-container \nclass=\"md-block tax-inputs\"><label>{{ vm.getSetting(\'price_type\').label }}</label><md-select \nng-model=\"vm.activityData.extra_settings.price_type\" \nng-change=\"vm.updateExtraSetting(\'price_type\', vm.activityData.extra_settings.price_type)\"><md-option \nng-repeat=\"option in vm.getSetting(\'price_type\').values\" ng-value=\"option.value\">{{ option.label }}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block tax-inputs\"><label>Price Value</label><input \ntype=\"text\" name=\"product_price\" ng-model=\"vm.activityData.product_price\" \nng-change=\"activityForm.product_price.$valid && vm.saveEachField(vm.activityData.product_price, \'product_price\')\" \nng-model-options=\"{debounce: 500}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\" allow-decimal-numbers><div \nng-messages=\"activityForm.product_price.$error\" role=\"alert\" multiple=\"multiple\"></div><div class=\"md-error-spacer\">\n</div></md-input-container><md-input-container class=\"md-block tax-inputs\" \nng-if=\"vm.activityData.extra_settings.price_type === \'percentage\'\"><label>{{ vm.getSetting(\'percentage_of\').label }}\n</label><md-select ng-model=\"vm.activityData.extra_settings.percentage_of\" \nng-change=\"vm.updateExtraSetting(\'percentage_of\', vm.activityData.extra_settings.percentage_of)\"><md-option \nng-repeat=\"opt in vm.getSetting(\'percentage_of\').values\" ng-value=\"opt.value\">{{ opt.label }}</md-option></md-select>\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" \nlayout=\"column\" layout-align=\"end start\" ng-if=\"vm.isResortFeeProduct || vm.isExtraPersonProduct\"><md-input-container \nclass=\"md-block tax-inputs\" ng-if=\"vm.isResortFeeProduct\"><label>{{vm.resortFeeType}}</label><input type=\"text\" \nlayout=\"column\" flex=\"90\" ng-change=\"vm.saveEachField(vm.activityData.product_price,\'product_price\')\" required \nname=\"extra_attribute_value\" ng-model=\"vm.activityData.product_price\" allow-decimal-numbers \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container><md-input-container class=\"md-block tax-inputs\" \nng-if=\"vm.isExtraPersonProduct\"><label translate=\"POS_TYPE.PRICE\"></label><input type=\"text\" layout=\"column\" flex=\"90\" \nng-change=\"vm.saveEachField(vm.activityData.product_price,\'product_price\')\" required name=\"extra_attribute_value\" \nng-model=\"vm.activityData.product_price\" allow-decimal-numbers ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container><div class=\"md-errors-spacer\"></div></div></div><div class=\"row-block\" flex-gt-xs=\"100\" \nlayout=\"row\" layout-align=\"start start\" layout-wrap><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" \nflex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\"><md-input-container class=\"md-block tax-inputs\"><label \ntranslate=\"POS_TYPE.DESCRIPTION\"></label><textarea required ng-model=\"vm.activityData.product_description\" \nname=\"product_description\" class=\"pb-32\" \nng-change=\"vm.flag == \'edit\' && activityForm.product_description.$valid && vm.saveEachField(vm.activityData.product_description, \'product_description\')\" \nng-model-options=\"{debounce: 500}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></textarea></md-input-container>\n</div><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"end start\"><md-input-container class=\"md-block tax-inputs\"><label translate=\"POS_TYPE.STATUS\"></label>\n<md-select placeholder=\"{{ \'POS_TYPE.SELECT_STATUS\' | translate }}\" ng-model=\"vm.activityData.product_status\" required \nng-change=\"vm.flag == \'edit\' && !activityForm.product_status.$invalid && vm.saveEachField(vm.activityData.product_status, \'product_status\')\" \nng-model-options=\"{debounce: 500}\"><md-option ng-value=\"stat.value\" ng-repeat=\"stat in vm.status\" ng-bind=\"stat.name\">\n</md-option></md-select><div class=\"md-error-spacer\"></div></md-input-container></div></div><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap ng-if=\"vm.showResAtrribs\"><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\">\n<md-input-container class=\"md-block tax-inputs\"><label translate=\"POS_TYPE.RESTAURANT_ATTRIBUTES\"></label><md-select \nmultiple=\"multiple\" placeholder=\"{{ \'POS_TYPE.SELECT_RES_ATTRIBUTES\' | translate }}\" \nng-model=\"vm.activityData.restaurant_attributes\" \nng-change=\"vm.flag == \'edit\' && !activityForm.restaurantAttributes.$invalid && vm.saveEachField(vm.activityData.restaurant_attributes, \'restaurant_attributes\')\" \nng-model-options=\"{debounce: 500}\" name=\"restaurantAttributes\"><md-option ng-value=\"item.field_id\" \nng-repeat=\"item in vm.restaurantAttributes\">{{item.field_name}}</md-option></md-select><div class=\"md-error-spacer\">\n</div></md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" \nlayout-wrap ng-if=\"vm.showResAtrribs\"><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" layout=\"column\" \nlayout-align=\"end start\"><md-chips class=\"full-width-chips mb-20\" ng-model=\"vm.activityData.selectedTags\" \nmd-autocomplete-snap=\"\" md-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"vm.autocompleteDemoRequireMatch\" \nmd-on-add=\"vm.updateIngredients()\" md-on-remove=\"vm.updateIngredients()\" required><md-autocomplete \nmd-selected-item=\"vm.activityData.selectedTag\" md-search-text=\"vm.searchTags\" \nmd-items=\"item in vm.querySearchTags(vm.searchTags)\" md-item-text=\"item.name\" placeholder=\"Search for an ingredient\">\n<span md-highlight-text=\"vm.searchTags\">{{item.name}}</span><md-not-found><div class=\"chip-not-found\" \nng-click=\"vm.notFound(vm.searchTags)\"><span>Not found. Please enter to add.</span></div></md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{$chip.name}}</strong></span></md-chip-template></md-chips></div>\n</div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" layout=\"column\" flex \nlayout-align=\"end start\" ng-if=\"vm.isResortFeeProduct == true\"><md-input-container class=\"md-block tax-inputs\">\n<md-switch class=\"no-margin\" name=\"extra_attribute_type\" ng-model=\"vm.resort_fee_type\" aria-label=\"Switch 1\" \nng-change=\"vm.saveEachField(vm.resort_fee_type,\'extra_attribute_type\')\"><span ng-if=\"!vm.resort_fee_type\">Flat Rate\n</span> <span ng-if=\"vm.resort_fee_type\">Percentage</span></md-switch><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" \nlayout=\"column\" flex layout-align=\"end start\" ng-if=\"vm.isResortFeeProduct == true\"><md-input-container \nclass=\"md-block tax-inputs\"><md-switch class=\"no-margin\" name=\"ota_value_same\" \nng-model=\"vm.activityData.is_ota_value_same\" aria-label=\"Switch 1\" \nng-change=\"vm.saveEachField(vm.activityData.is_ota_value_same,\'is_ota_value_same\')\"><span \nng-if=\"vm.activityData.is_ota_value_same\">Not Same for OTAs</span> <span ng-if=\"!vm.activityData.is_ota_value_same\">\nSame for OTAs</span></md-switch><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" layout=\"column\" flex \nlayout-align=\"end start\" ng-if=\"vm.isResortFeeProduct == true && vm.activityData.is_ota_value_same\"><md-input-container\n class=\"md-block tax-inputs\"><input type=\"number\" layout=\"column\" flex=\"90\" \nng-change=\"vm.saveEachField(vm.activityData.extra_attribute_ota_value,\'extra_attribute_ota_value\')\" required \nname=\"extra_attribute_ota_value\" ng-model=\"vm.activityData.extra_attribute_ota_value\" \nplaceholder=\"Resort Fees for OTAs\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container><div \nclass=\"md-errors-spacer\"></div></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" layout-wrap><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" \nflex-gt-sm=\"33\" layout=\"column\" layout-align=\"end start\"><md-input-container \nclass=\"md-block md-input-has-value infocontainor\"><md-switch class=\"no-margin\" name=\"product_is_timebound\" \nng-model=\"vm.activityData.product_is_timebound\" aria-label=\"Switch 1\" \nng-change=\" vm.saveEachField(vm.activityData.product_is_timebound,\'product_is_timebound\')\"><span \ntranslate=\"POS_TYPE.TIMEBOUND\" ng-if=\"vm.activityData.product_is_timebound\"></span> <span \ntranslate=\"POS_TYPE.NON-TIMEBOUND\" ng-if=\"!vm.activityData.product_is_timebound\"></span></md-switch><div \nclass=\"md-errors-spacer\"></div><span class=\"icon-information info-icon\"><md-tooltip>\nIf set, you\'ll have to pay for the product, daily basis.</md-tooltip></span></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" layout=\"column\" layout-align=\"end start\">\n<md-input-container class=\"md-block md-input-has-value infocontainor\"><md-switch class=\"no-margin\" \nname=\"pos_display_tax_indicator\" ng-model=\"vm.activityData.pos_display_tax_indicator\" aria-label=\"Switch 1\" \nng-change=\"vm.saveEachField(vm.activityData.pos_display_tax_indicator,\'pos_display_tax_indicator\')\"><span \ntranslate=\"POS_TYPE.DISPLAY_PRICE_INCLUDING_TAX\" ng-if=\"vm.activityData.pos_display_tax_indicator\"></span> <span \ntranslate=\"POS_TYPE.DISPLAY_PRICE_EXCLUDING_TAX\" ng-if=\"!vm.activityData.pos_display_tax_indicator\"></span></md-switch>\n<div class=\"md-errors-spacer\"></div><span class=\"icon-information info-icon\"><md-tooltip>\nIf set, you\'ll see total amount in retail/bar section(incl. tax).</md-tooltip></span></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" layout=\"column\" layout-align=\"end start\">\n<md-input-container class=\"md-block md-input-has-value infocontainor\"><md-switch class=\"no-margin\" \nname=\"available_on_fe\" ng-model=\"vm.activityData.available_on_fe\" aria-label=\"Switch 1\" \nng-change=\"vm.updateDependentFields();vm.saveEachField(vm.activityData.available_on_fe,\'available_on_fe\')\"><span \ntranslate=\"POS_TYPE.DISPLAY_ON_FE\" ng-if=\"vm.activityData.available_on_fe\"></span> <span \ntranslate=\"POS_TYPE.NOT_DISPLAY_ON_FE\" ng-if=\"!vm.activityData.available_on_fe\"></span></md-switch><div \nclass=\"md-errors-spacer\"></div><span class=\"icon-information info-icon\"><md-tooltip>\nIf set, you\'ll see the product in SRP of FE.</md-tooltip></span></md-input-container></div></div><div \nclass=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" layout=\"column\" layout-align=\"end start\">\n<md-input-container class=\"md-block md-input-has-value infocontainor\"><md-switch class=\"no-margin\" \nname=\"display_on_cart\" ng-model=\"vm.activityData.display_on_cart\" aria-label=\"Switch 1\" \nng-change=\"vm.updateDependentFields();vm.saveEachField(vm.activityData.display_on_cart,\'display_on_cart\')\"><span \ntranslate=\"POS_TYPE.DISPLAY_ON_CART\" ng-if=\"vm.activityData.display_on_cart\"></span> <span \ntranslate=\"POS_TYPE.NOT_DISPLAY_ON_CART\" ng-if=\"!vm.activityData.display_on_cart\"></span></md-switch><div \nclass=\"md-errors-spacer\"></div><span class=\"icon-information info-icon\"><md-tooltip>\nIf set, you\'ll see the product in Cart</md-tooltip></span></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" layout=\"column\" layout-align=\"end start\" \nng-if=\"!vm.activityData.isParkingProduct && !vm.isResortFeeProduct && !vm.isExtraPersonProduct\"><md-input-container \nclass=\"md-block md-input-has-value\"><md-switch class=\"no-margin\" ng-model=\"vm.activityData.pos_auto_sync_dates\" \naria-label=\"Switch 1\" ng-change=\" vm.saveEachField(vm.activityData.pos_auto_sync_dates,\'pos_auto_sync_dates\')\"><span \nng-if=\"vm.activityData.pos_auto_sync_dates\">Updated with Product</span> <span \nng-if=\"!vm.activityData.pos_auto_sync_dates\">Not Update with Product</span></md-switch><div class=\"md-errors-spacer\">\n</div></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" \nlayout=\"column\" layout-align=\"end start\" ng-if=\"!vm.isResortFeeProduct && !vm.isExtraPersonProduct\"><md-input-container\n class=\"md-block md-input-has-value infocontainor\"><md-switch class=\"no-margin\" name=\"associate_with_other_pos\" \nng-model=\"vm.activityData.associate_with_other_pos\" aria-label=\"Switch 1\" \nng-change=\"vm.getPosTypes(vm.activityData.associate_with_other_pos,vm.activityData.product_id);vm.saveEachField(vm.activityData.associate_with_other_pos,\'associate_with_other_pos\')\">\n<span ng-if=\"vm.activityData.associate_with_other_pos\">Associate with Other POS</span> <span \nng-if=\"!vm.activityData.associate_with_other_pos\">Not Associate with Other POS</span></md-switch><div \nclass=\"md-errors-spacer\"></div><span class=\"icon-information info-icon\"><md-tooltip>\nIf set, you can associate item with other POS.</md-tooltip></span></md-input-container></div></div><div \nclass=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap \nng-if=\"vm.activityData.product_is_timebound == true\"><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" \nflex-gt-sm=\"33\" layout=\"column\" layout-align=\"end start\"><md-input-container class=\"md-block md-input-has-value\">\n<md-switch class=\"no-margin\" name=\"is_timebound_with_availability\" \nng-model=\"vm.activityData.is_timebound_with_availability\" aria-label=\"Switch 1\" \nng-change=\" vm.saveEachField(vm.activityData.is_timebound_with_availability,\'is_timebound_with_availability\')\"><span \ntranslate=\"POS_TYPE.TIMEBOUND_WITH_AVAILABILITY\" ng-if=\"vm.activityData.is_timebound_with_availability\"></span> <span \ntranslate=\"POS_TYPE.TIMEBOUND_WITHOUT_AVAILABILITY\" ng-if=\"!vm.activityData.is_timebound_with_availability\"></span>\n</md-switch><div class=\"md-errors-spacer\"></div></md-input-container></div></div><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap ng-if=\"vm.activityData.display_on_cart == true\">\n<div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" layout=\"column\" \nlayout-align=\"end start\"><md-input-container class=\"md-block md-input-has-value infocontainor\"><md-switch \nclass=\"no-margin\" ng-model=\"vm.activityData.allowed_for_all_rooms\" aria-label=\"Switch 1\" \nng-change=\"vm.getRoomsTypes(vm.activityData.allowed_for_all_rooms); vm.saveEachField(vm.activityData.allowed_for_all_rooms,\'allowed_for_all_rooms\')\">\n<span translate=\"{{posType}}.ALLOWED_FOR_ALL\" ng-if=\"vm.activityData.allowed_for_all_rooms\"></span> <span \ntranslate=\"{{posType}}.SELECT_ROOM\" ng-if=\"!vm.activityData.allowed_for_all_rooms\"></span></md-switch><div \nclass=\"md-errors-spacer\"></div><span class=\"icon-information info-icon\"><md-tooltip>\nIf set, you can add the product with all rooms in Cart.</md-tooltip></span></md-input-container></div></div><div \nclass=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap \nng-if=\"vm.activityData.allowed_for_all_rooms == false && vm.activityData.display_on_cart == true\"><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" layout=\"column\" layout-align=\"end start\" \nng-if=\"vm.pageType == \'Rooms\'\"><md-input-container class=\"md-block tax-inputs\"><label \ntranslate=\"{{posType}}.ASSOCIATED_ROOM\"></label><md-select multiple=\"multiple\" name=\"associate_with_rooms\" \nng-model=\"vm.activityData.associate_with_rooms\" aria-label=\"Switch 1\" \nplaceholder=\"{{ \'POS_TYPE.ASSOCIATED_ROOM\' | translate }}\" \nng-change=\"vm.flag == \'edit\' && activityForm.associate_with_rooms.$valid && vm.saveEachField(vm.activityData.associate_with_rooms, \'associate_with_rooms\')\" \nng-model-options=\"{debounce: 500}\" required><md-option class=\"capitalize\" ng-value=\"{{rooms.room_type_id}}\" \nng-repeat=\"rooms in vm.RoomData\" \nng-selected=\"vm.associated_room_id.indexOf((rooms.room_type_id)) != -1 && vm.flag == \'edit\'? \'selected\':\'\';\">\n{{rooms.room_type_name}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" layout=\"column\" layout-align=\"end start\" \nng-if=\"vm.pageType == \'Boats\'\"><md-input-container class=\"md-block tax-inputs\"><label \ntranslate=\"{{posType}}.ASSOCIATED_ROOM\"></label><md-select multiple=\"multiple\" name=\"associate_with_rooms\" \nng-model=\"vm.activityData.associate_with_rooms\" aria-label=\"Switch 1\" \nplaceholder=\"{{ \'POS_TYPE.ASSOCIATED_ROOM\' | translate }}\" \nng-change=\"vm.flag == \'edit\' && activityForm.associate_with_rooms.$valid && vm.saveEachField(vm.activityData.associate_with_rooms, \'associate_with_rooms\')\" \nng-model-options=\"{debounce: 500}\" required><md-option class=\"capitalize\" ng-value=\"{{rooms.product_id}}\" \nng-repeat=\"rooms in vm.RoomData\" \nng-selected=\"vm.associated_room_id.indexOf((rooms.product_id)) != -1 && vm.flag == \'edit\'? \'selected\':\'\';\">\n{{rooms.product_name}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div></div><div\n class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap \nng-if=\"vm.activityData.associate_with_other_pos == true\"><div class=\"row-col padding-right-10 padding-left-10\" \nflex=\"100\" flex-gt-sm=\"33\" layout=\"column\" layout-align=\"end start\"><md-input-container class=\"md-block tax-inputs\">\n<label translate=\"POS_TYPE.ASSOCIATED_POS\"></label><md-select multiple=\"multiple\" name=\"associate_with_pos\" \nng-model=\"vm.activityData.associate_with_pos\" aria-label=\"Switch 1\" \nplaceholder=\"{{ \'POS_TYPE.ASSOCIATED_POS\' | translate }}\" \nng-change=\"vm.flag == \'edit\' && activityForm.associate_with_pos.$valid && vm.saveEachField(vm.activityData.associate_with_pos, \'associate_with_pos\')\" \nng-model-options=\"{debounce: 500}\" required><md-option class=\"capitalize\" ng-value=\"{{pos.product_id}}\" \nng-repeat=\"pos in vm.PosData\" \nng-selected=\"vm.associated_pos_id.indexOf((pos.product_id)) != -1 && vm.flag == \'edit\'? \'selected\':\'\';\">\n{{pos.product_name}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div></div><div \nclass=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10 addattributedynamic\" flex=\"100\" flex-gt-sm=\"33\" layout=\"column\" \nlayout-align=\"end start\" ng-if=\"!vm.isResortFeeProduct && !vm.isExtraPersonProduct\"><md-input-container \nclass=\"md-block md-input-has-value\"><md-switch name=\"dynamic_attribute\" class=\"no-margin\" \nng-model=\"vm.activityData.dynamic_attribute\" aria-label=\"Switch 1\" \nng-change=\"vm.flag == \'edit\' && vm.saveEachField(vm.activityData.dynamic_attribute,\'dynamic_attribute\')\"><span \nng-if=\"vm.activityData.dynamic_attribute\">Dynamic Attributes</span> <span ng-if=\"!vm.activityData.dynamic_attribute\">\nNo Dynamic Attributes</span></md-switch><div class=\"md-errors-spacer\"></div></md-input-container><div \nclass=\"form-title margin-left-10 plusiconouter\" ng-if=\"vm.activityData.dynamic_attribute == true\"><div \nclass=\"form-title-div\"><a ng-click=\"vm.addField()\" class=\"custom-pull-right\"><i class=\"icon-plus-circle\"></i></a></div>\n</div></div><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" layout=\"column\" \nlayout-align=\"end start\"><md-input-container class=\"md-block md-input-has-value infocontainor\"><md-switch \nname=\"send_external_email\" class=\"no-margin\" ng-model=\"vm.activityData.send_external_email\" aria-label=\"Switch 1\" \nng-change=\"vm.flag == \'edit\' && vm.saveEachField(vm.activityData.send_external_email,\'send_external_email\')\"><span \nng-if=\"vm.activityData.send_external_email\">Send Email</span> <span ng-if=\"!vm.activityData.send_external_email\">\nDo not Send Email</span></md-switch><div class=\"md-errors-spacer\"></div><span class=\"icon-information info-icon\">\n<md-tooltip>If set, you can send email to the customer, when customer requests for the following product.</md-tooltip>\n</span></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" \nlayout=\"column\" layout-align=\"end start\"><md-input-container class=\"md-block md-input-has-value infocontainor\">\n<md-switch name=\"happy_hours\" class=\"no-margin\" ng-model=\"vm.activityData.happy_hours\" aria-label=\"Switch 1\" \nng-change=\"vm.flag == \'edit\' && !activityForm.external_email_receiver.$invalid && vm.saveEachField(vm.activityData.happy_hours,\'happy_hours\')\">\n<span ng-if=\"vm.activityData.happy_hours\">Happy Hour Active</span> <span ng-if=\"!vm.activityData.happy_hours\">\nHappy Hour Inactive</span></md-switch><div class=\"md-errors-spacer\"></div><span class=\"icon-information info-icon\">\n<md-tooltip>If set, the you can make happy hours as active.</md-tooltip></span></md-input-container></div></div><div \nclass=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap \nng-if=\"vm.activityData.dynamic_attribute == true\"><div class=\"row-col padding-right-10 padding-left-10 md-inp-dynamic\" \nflex=\"100\" flex-gt-sm=\"33\" layout=\"column\" flex ng-repeat=\"(key, field) in vm.activityData.dynamicAttributes\" \nlayout-align=\"end start\"><md-input-container class=\"md-block tax-inputs\"><input layout=\"column\" flex=\"90\" required \ntype=\"text\" name=\"field_name\" ng-model=\"vm.activityData.dynamicAttributes[key].field\" \nplaceholder=\"{{ \'POS_TYPE.FIELD_NAME\' | translate }}\" \nng-blur=\"vm.flag == \'edit\' && vm.activityData.dynamicAttributes[key].field!=\'\' && !activityForm.field_name.$invalid && !activityForm.field_type.$invalid && vm.saveEachField(vm.activityData.dynamicAttributes, \'dynamic_attributes\')\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container><md-input-container><md-select name=\"field_type\" \nrequired placeholder=\"{{\'POS_TYPE.FIELD_TYPE\' | translate }}\" ng-model=\"vm.activityData.dynamicAttributes[key].type\" \nng-change=\"vm.flag == \'edit\' && vm.activityData.dynamicAttributes[key].field!=\'\' && !activityForm.field_type.$invalid && !activityForm.field_name.$invalid && vm.saveEachField(vm.activityData.dynamicAttributes, \'dynamic_attributes\')\" \nrequired><md-option ng-value=\"\'text\'\">Text</md-option><md-option ng-value=\"\'number\'\">Number</md-option><md-option \nng-value=\"\'date\'\">Date</md-option></md-select></md-input-container><div layout=\"column\" class=\"edit-block-del\" \nflex=\"10\" layout-align=\"end end\" ng-if=\"vm.flag == \'edit\'\"><a \nng-click=\"vm.deleteField(key,vm.activityData.dynamicAttributes[key].field, vm.activityData.dynamicAttributes[key].field, $event)\" \nclass=\"padding-top-5 red-A800-fg\"><i class=\"icon-delete\"></i></a></div><div layout=\"column\" flex=\"10\" \nlayout-align=\"end end\" ng-if=\"vm.flag != \'edit\'\"><a \nng-click=\"vm.deleteField(key,vm.activityData.dynamicAttributes[key].field, vm.activityData.dynamicAttributes[key].new, $event)\" \nclass=\"padding-top-5 red-A800-fg\"><i class=\"icon-delete\"></i></a></div></div></div><div class=\"row-block\" \nflex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap \nng-if=\"vm.activityData.send_external_email == true\"><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" \nflex-gt-sm=\"33\" layout=\"column\" flex layout-align=\"end start\"><md-input-container class=\"md-block tax-inputs\"><input \nlayout=\"column\" flex=\"90\" required type=\"email\" name=\"external_email_receiver\" \nng-model=\"vm.activityData.external_email_receiver\" \nng-change=\"vm.flag == \'edit\' && !activityForm.external_email_receiver.$invalid && vm.saveEachField(vm.activityData.external_email_receiver,\'external_email_receiver\')\" \nplaceholder=\"{{ \'POS_TYPE.TO_WHOM\' | translate }}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\">\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" \nlayout=\"column\" flex layout-align=\"end start\"><md-input-container class=\"md-block tax-inputs\"><label \ntranslate=\"POS_TYPE.TEMPLATE\"></label><md-select name=\"external_email_template_id\" required \nng-model=\"vm.activityData.external_email_template_id\" placeholder=\"{{ \'POS_TYPE.SELECT_TEMPLATE\' | translate }}\" \nng-change=\"vm.flag == \'edit\' && vm.saveEachField(vm.activityData.external_email_template_id,\'external_email_template_id\')\" \nng-model-options=\"{debounce: 500}\" required><md-option class=\"capitalize\" ng-value=\"{{template.template_id}}\" \nng-repeat=\"template in vm.templates\">{{template.template_name}}</md-option></md-select></md-input-container></div>\n</div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap \nng-if=\"vm.activityData.happy_hours == true\"><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" \nflex-gt-sm=\"33\" layout=\"column\" flex layout-align=\"end start\"><label>Discount Percentage</label><md-input-container \nclass=\"md-block tax-inputs\"><input layout=\"column\" flex=\"90\" \nng-change=\"vm.calculateHappyHoursPrice(\'per\');vm.flag == \'edit\' && !activityForm.external_email_receiver.$invalid && vm.saveEachField(vm.activityData.happyhour_price,\'happyhour_price\')\" \nrequired type=\"number\" name=\"external_email_receiver\" ng-model=\"vm.happyHoursPercentage\" placeholder=\"Percentage\" \nng-max=\"100\" ng-min=\"0\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" layout=\"column\" flex \nlayout-align=\"end start\"><label>Flat Rate</label><md-input-container class=\"md-block tax-inputs\"><input \nlayout=\"column\" flex=\"90\" required type=\"number\" \nng-change=\"vm.calculateHappyHoursPrice(\'amt\');vm.flag == \'edit\' && !activityForm.external_email_receiver.$invalid && vm.saveEachField(vm.activityData.happyhour_price,\'happyhour_price\')\" \nname=\"external_email_receiver\" ng-model=\"vm.happyHoursAmount\" placeholder=\"Flat Rate\" \nng-max=\"vm.activityData.product_price\" ng-min=\"0\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container>\n</div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" layout=\"column\" layout-align=\"end start\">\n<md-input-container class=\"md-block md-input-has-value infocontainor\"><md-switch class=\"no-margin\" \nname=\"display_on_pms\" ng-model=\"vm.activityData.display_on_pms\" aria-label=\"Switch 1\" \nng-change=\"vm.saveEachField(vm.activityData.display_on_pms,\'display_on_pms\')\"><span \ntranslate=\"POS_TYPE.DISPLAY_ON_PMS\" ng-if=\"vm.activityData.display_on_pms\"></span><span \ntranslate=\"POS_TYPE.NOT_DISPLAY_ON_PMS\" ng-if=\"!vm.activityData.display_on_pms\"></span></md-switch><div \nclass=\"md-errors-spacer\"></div><span class=\"icon-information info-icon\"><md-tooltip>\nIf set, the product will be displayed on PMS.</md-tooltip></span></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" layout=\"column\" layout-align=\"end start\">\n<md-input-container class=\"md-block md-input-has-value infocontainor\"><md-switch class=\"no-margin\" \nname=\"add_pos_comment\" ng-model=\"vm.activityData.addPosComment\" aria-label=\"Switch 1\" \nng-change=\"vm.saveEachField(vm.activityData.addPosComment,\'add_pos_comment\')\"><span \nng-if=\"vm.activityData.addPosComment\">Auto Add POS Comment on Reservation</span> <span \nng-if=\"!vm.activityData.addPosComment\">Do Not Auto Add POS Comment on Reservation</span></md-switch><div \nclass=\"md-errors-spacer\"></div><span class=\"icon-information info-icon\"><md-tooltip>\nIf enabled, this product will automatically add a POS comment when reservation is created from FE.</md-tooltip></span>\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" \nlayout=\"column\" layout-align=\"end start\"><md-input-container class=\"md-block md-input-has-value infocontainor\">\n<md-switch class=\"no-margin\" name=\"applied_by_default\" ng-model=\"vm.activityData.extra_settings.applied_by_default\" \nng-change=\"vm.updateExtraSetting(\'applied_by_default\', vm.activityData.extra_settings.applied_by_default)\"><span \nng-if=\"vm.activityData.extra_settings.applied_by_default\">Applied by Default</span> <span \nng-if=\"!vm.activityData.extra_settings.applied_by_default\">Not Applied by Default</span></md-switch><div \nclass=\"md-errors-spacer\"></div><span class=\"icon-information info-icon\"><md-tooltip>\nIf enabled, this product will be automatically applied to reservations.</md-tooltip></span></md-input-container></div>\n</div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" layout=\"column\" layout-align=\"end start\">\n<md-input-container class=\"md-block md-input-has-value infocontainor\"><md-switch class=\"no-margin\" \nname=\"separate_card\" ng-model=\"vm.activityData.extra_settings.separate_card\" \nng-change=\"vm.updateExtraSetting(\'separate_card\', vm.activityData.extra_settings.separate_card)\"><span \nng-if=\"vm.activityData.extra_settings.separate_card\">Make Separate Card</span> <span \nng-if=\"!vm.activityData.extra_settings.separate_card\">Do Not Make Separate Card</span></md-switch><div \nclass=\"md-errors-spacer\"></div><span class=\"icon-information info-icon\"><md-tooltip>\nIf enabled, this product will be charged on a separate card instead of the main reservation card.</md-tooltip></span>\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" \nlayout=\"column\" layout-align=\"end start\"><md-input-container class=\"md-block md-input-has-value infocontainor\">\n<md-switch class=\"no-margin\" name=\"quantity_locked\" ng-model=\"vm.activityData.extra_settings.is_quantity_locked\" \nng-change=\"vm.updateExtraSetting(\'is_quantity_locked\', vm.activityData.extra_settings.is_quantity_locked)\"><span \nng-if=\"vm.activityData.extra_settings.is_quantity_locked\">Quantity Locked</span> <span \nng-if=\"!vm.activityData.extra_settings.is_quantity_locked\">Quantity Not Locked</span></md-switch><div \nclass=\"md-errors-spacer\"></div><span class=\"icon-information info-icon\"><md-tooltip>\nIf enabled, the quantity of this product cannot be changed.</md-tooltip></span></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" layout=\"column\" layout-align=\"end start\">\n<md-input-container class=\"md-block md-input-has-value infocontainor\"><md-switch class=\"no-margin\" \nname=\"is_non_cancellable\" ng-model=\"vm.activityData.extra_settings.is_non_cancellable\" \nng-change=\"vm.updateExtraSetting(\'is_non_cancellable\', vm.activityData.extra_settings.is_non_cancellable)\"><span \nng-if=\"vm.activityData.extra_settings.is_non_cancellable\">Non Cancellable</span> <span \nng-if=\"!vm.activityData.extra_settings.is_non_cancellable\">Cancellable</span></md-switch><div class=\"md-errors-spacer\">\n</div><span class=\"icon-information info-icon\"><md-tooltip>If enabled, this product can not be cancelled by the user.\n</md-tooltip></span></md-input-container></div></div><div class=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" \nlayout-align=\"start start\" layout-wrap><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" \nflex-gt-sm=\"33\" layout=\"column\" layout-align=\"end start\"><md-input-container \nclass=\"md-block md-input-has-value infocontainor\"><md-switch class=\"no-margin\" name=\"for_early_checkin\" \nng-model=\"vm.activityData.extra_settings[\'for_early_check-in\']\" \nng-change=\"vm.updateExtraSetting(\'for_early_check-in\', vm.activityData.extra_settings[\'for_early_check-in\'])\"><span \nng-if=\"vm.activityData.extra_settings[\'for_early_check-in\']\">For Early Check-in</span> <span \nng-if=\"!vm.activityData.extra_settings[\'for_early_check-in\']\">Not For Early Check-in</span></md-switch><div \nclass=\"md-errors-spacer\"></div><span class=\"icon-information info-icon\"><md-tooltip>\nIf enabled, this product is available for early check-in.</md-tooltip></span></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" layout=\"column\" layout-align=\"end start\">\n<md-input-container class=\"md-block md-input-has-value infocontainor\"><md-switch class=\"no-margin\" \nname=\"for_late_checkout\" ng-model=\"vm.activityData.extra_settings[\'for_late_check-out\']\" \nng-change=\"vm.updateExtraSetting(\'for_late_check-out\', vm.activityData.extra_settings[\'for_late_check-out\'])\"><span \nng-if=\"vm.activityData.extra_settings[\'for_late_check-out\']\">For Late Check-out</span> <span \nng-if=\"!vm.activityData.extra_settings[\'for_late_check-out\']\">Not For Late Check-out</span></md-switch><div \nclass=\"md-errors-spacer\"></div><span class=\"icon-information info-icon\"><md-tooltip>\nIf enabled, this product is available for late check-out.</md-tooltip></span></md-input-container></div><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" layout=\"column\" layout-align=\"end start\">\n<md-input-container class=\"md-block md-input-has-value infocontainor\"><md-switch class=\"no-margin\" \nname=\"is_borrowable\" ng-model=\"vm.activityData.extra_settings.is_borrowable\" \nng-change=\"vm.updateExtraSetting(\'is_borrowable\', vm.activityData.extra_settings.is_borrowable)\"><span \nng-if=\"vm.activityData.extra_settings.is_borrowable\">Borrowable</span> <span \nng-if=\"!vm.activityData.extra_settings.is_borrowable\">Not Borrowable</span></md-switch><div class=\"md-errors-spacer\">\n</div><span class=\"icon-information info-icon\"><md-tooltip>If enabled, this product can be borrowed.</md-tooltip>\n</span></md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-sm=\"33\" \nlayout=\"column\" layout-align=\"end start\" ng-if=\"vm.isDailyRentalsAvailable()\"><md-input-container \nclass=\"md-block md-input-has-value infocontainor\"><md-switch class=\"no-margin\" name=\"is_available_with_daily_rentals\" \nng-model=\"vm.activityData.extra_settings.is_available_with_daily_rentals\" \nng-change=\"vm.updateExtraSetting(\'is_available_with_daily_rentals\', vm.activityData.extra_settings.is_available_with_daily_rentals)\">\n<span ng-if=\"vm.activityData.extra_settings.is_available_with_daily_rentals\">Available with Daily Rentals</span> <span \nng-if=\"!vm.activityData.extra_settings.is_available_with_daily_rentals\">Not Available with Daily Rentals</span>\n</md-switch><div class=\"md-errors-spacer\"></div><span class=\"icon-information info-icon\"><md-tooltip>\nIf enabled, this product is available with daily rentals.</md-tooltip></span></md-input-container></div></div></div>\n</div></div></div></form></div>");
$templateCache.put("app/main/apps/e-commerce/views/amenities/property_amenities/property_amenities.html","<div id=\"category\" class=\"page-layout simple fullwidth doc-page element-doc-page propert_amenity_page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><md-progress-linear \nmd-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon white-fg fontSizeTopHeading\"><md-icon \nmd-font-icon=\"icon-hotel\"></md-icon></span><span class=\"capitalize logo-text white-fg ng-scope fontSizeTopHeading\">\nProperty Amenities</span></div></div></div><div class=\"content\"><div class=\"content\" layout=\"row\" \nlayout-align=\"space-between center\" ng-init=\"my_id = 1\"><div class=\"main RowClick prop-amen-con\" flex=\"100\" \nflex-gt-md=\"100\" flex-gt-sm=\"100\" layout=\"column\" ms-scroll><ang-accordion one-at-a-time=\"true\" icon-position=\"right\" \nclose-icon-url=\"{{vm.feBaseUrl+\'angular-material-assets/img/icons/right-arrow.svg\'}}\" op \nen-icon-url=\"{{vm.feBaseUrl+\'angular-material-assets/img/icons/bottom-arrow.svg\'}}\"><collapsible-item \nitem-title=\"{{parent}}\" class=\"{{parent.split(\' \').join(\'_\')}} capitalize\" id=\"{{parent.split(\' \').join(\'_\')}}\" \nng-click=\"vm.focus(parent)\" ng-repeat=\"(parent, amenities) in vm.amenities track by $index\" class=\"font-size-14\" \nng-init=\"my_id = my_id + 1\"><div flex=\"100\" layout-wrap layout=\"row\"><md-checkbox flex=\"100\" flex-gt-md=\"33\" \nflex-gt-lg=\"25\" flex-gt-sm=\"33\" layout=\"column\" ng-click=\"vm.saveAssignedAmenity(amenity.id,amenity.hotel_amenity_id)\" \nng-repeat=\"amenity in amenities\" ng-value=\"{{amenity.id}}\" ng-model=\"vm.assignedAmenities[amenity.id]\" \naria-label=\"{{amenity.name}}\" ng-checked=\"amenity.selected == 1\" class=\"padding-left-15 margin-bottom-10 mr-0\"><span \nclass=\"font-size-13 capitalize\">{{amenity.name}}</span></md-checkbox></div></collapsible-item></ang-accordion></div>\n</div></div></div>");
$templateCache.put("app/main/apps/e-commerce/views/bundlerooms/bundleroom/bundleroom.html","<div id=\"room-type\" class=\"page-layout simple tabbed\" layout=\"column\"><form id=\"bundleForm\" name=\"bundleForm\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" ng-click=\"vm.goBack()\"><md-icon\n md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\" ng-if=\"vm.flag == \'add\'\">{{ bundletype+\'.NEW\' | translate }}\n</div><div class=\"h2\" ng-if=\"vm.flag != \'add\'\">Bundle - {{vm.bundle.page_title}}</div></div></div></div><div \nng-show=\"vm.flag == \'add\'\"><md-button class=\"md-raised md-background\" \nng-class=\"{\'md-blue-grey-A100-bg\': bundleForm.$invalid || bundleForm.$pristine || vm.bundle.group_rooms.length < 2 || vm.isloading || vm.uniqueError}\" \nng-disabled=\"vm.isloading || bundleForm.$invalid || bundleForm.$pristine || vm.bundle.group_rooms.length < 2 || vm.uniqueError\" \ntype=\"button\" ng-click=\"vm.addBundleRoom()\"><span translate=\"GROUPS.SAVE\"></span></md-button><md-button \nclass=\"md-raised md-background\"><span ui-sref=\"app.e-commerce.bundlerooms\" translate=\"GROUPS.CANCEL\"></span>\n</md-button></div></div><div class=\"content content-scroll\"><md-progress-linear md-mode=\"indeterminate\" \nng-show=\"vm.isloading\"></md-progress-linear><div class=\"product-detail-form-container md-whiteframe-1dp height\"><div \nclass=\"role-list-outer height-main\"><div class=\"role-list-out white-bg relative-block\"><div class=\"content\"><div \nclass=\"row-block\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"row-col padding-right-10 padding-left-10\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" layout-align=\"end start\" \nflex><md-input-container class=\"md-block tax-inputs\"><label translate=\"{{bundletype}}.ROOM\"></label><md-select \nname=\"tax_id\" ng-model=\"vm.bundle.product_id\" required ng-change=\"vm.uniqueBundle();\" ng-disabled=\"vm.flag != \'add\'\" \nng-model-options=\"{debounce: 500}\"><md-option ng-if=\"rooms.is_bundle == 1\" ng-value=\"rooms.product_id\" \nng-repeat=\"rooms in vm.roomslist\">{{rooms.product_name}}</md-option></md-select><div ng-if=\"vm.uniqueError\" \nclass=\"emailError\"><span translate=\"{{bundletype}}.BUNDLE_EXIST\"></span></div><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"50\" flex=\"100\" \nlayout=\"column\" layout-align=\"end start\" flex><md-input-container class=\"md-block tax-inputs\"><label \ntranslate=\"{{bundletype}}.GROUP\"></label><md-select ng-model=\"vm.bundle.group_rooms\" multiple=\"multiple\" required \nng-change=\"vm.updateBundleRoom();\"><md-option ng-if=\"rooms.is_bundle == 0\" ng-value=\"rooms.product_id\" \nng-repeat=\"rooms in vm.roomslist\">{{rooms.product_name}}</md-option></md-select><div \nng-if=\"vm.bundle.group_rooms.length < 2\" class=\"emailError\"><span translate=\"{{bundletype}}.GROUP_2\"></span></div><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></div></div></div></div></div></div></form></div><span \npostrender-action=\"vm.updateStatus()\"></span>");
$templateCache.put("app/main/apps/e-commerce/views/orders/order/order.html","<div class=\"page-layout simple tabbed view-order new-page\" layout=\"column\" id=\"create-res\" \nngf-drop=\"vm.uploadDoc($files, $invalidFiles)\" ngf-drag-over-class=\"\'dragover\'\" ng-model=\"vm.fileDrop\" name=\"fileDrop\" \nid=\"fileDrop\" ngf-max-size=\"10MB\" ngf-pattern=\"vm.allowedFiles\" ngf-accept=\"vm.allowedFiles\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex flex-gt-sm=\"70\"><md-button class=\"goto-products-button md-icon-button\" \nng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2 smsizeres\"><span>\n{{vm.itinerary_number}}</span> <span ng-if=\"vm.headerPart\">| {{vm.headerPart}}</span> <span>| </span><span \nclass=\"customer-header-name onlycursorPointer\" ng-class=\"{\'is-open\': vm.customerCardExpanded}\" \nng-click=\"vm.order && vm.toggleCustomerCard($event)\" role=\"button\" aria-expanded=\"{{!!vm.customerCardExpanded}}\" \ntitle=\"{{vm.order ? (vm.customerCardExpanded ? \'Hide traveller\' : \'Show traveller\') : \'\'}}\">\n{{vm.order.first_name}} {{vm.order.last_name}}<md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"customer-header-name__chevron white-fg\" ng-if=\"vm.order\" ng-class=\"{\'is-rotated\': vm.customerCardExpanded}\">\n</md-icon></span></div><div class=\"subtitle secondary-text\" ng-if=\"vm.flag == \'edit\'\"><span \ntranslate=\"CREATE_RES.SUB_HEADER\"></span></div></div></div></div><div layout=\"row\" flex layout-align=\"center end\"><div \nlayout=\"column\" flex=\"100\" layout-align=\"center end\"><div class=\"md-iconheader\"><md-icon \nmd-font-icon=\"icon-table-edit\" class=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5 top_align\" \nng-click=\"vm.consolidateButtons()\" ng-if=\"vm.roomCount > 0\"><md-tooltip>{{\'CREATE_RES.CONSOLIDATE_ACTION\' | translate}}\n</md-tooltip></md-icon><md-icon md-svg-src=\"assets/images/room_key_icon.svg\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5 top_align key-card-icon\" \nng-if=\"vm.isRoomLockEncoderVisible()\" ng-click=\"vm.openKeyCardDialog($event)\"><md-tooltip>Generate Room Key\n</md-tooltip></md-icon><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/confirmation.svg\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" ng-if=\"vm.order.room_stay_status !== \'Canceled\'\" \nng-click=\"vm.sendConfirmationEmail()\"><md-tooltip>{{\'CREATE_RES.SEND_CONFIRMATION_MAIL\' | translate}}</md-tooltip>\n</md-icon><md-icon md-font-icon=\"icon-email\" class=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" \nng-click=\"vm.sendinvoice()\" ng-if=\"!vm.allRoomCancelled\"><md-tooltip>{{\'CREATE_RES.SEND_INVOICE\' | translate}}\n</md-tooltip></md-icon><md-icon md-font-icon=\"icon-email\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" ng-click=\"vm.sendinvoice(\'canceled_order\')\" \nng-if=\"vm.allRoomCancelled && vm.tabs_data.length == 1 && vm.tabs_data[0].tab_name != \'Pos\'\"><md-tooltip>\n{{\'CREATE_RES.SEND_INVOICE\' | translate}}</md-tooltip></md-icon><md-icon md-font-icon=\"icon-printer\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" ng-click=\"vm.printinvoice(vm.reservation_id)\">\n<md-tooltip>{{\'CREATE_RES.PRINT\' | translate}}</md-tooltip></md-icon><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/room-service.svg\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" ng-click=\"vm.gotoCheckoutFromEditOrder()\" \nng-if=\"vm.roomCount == 0\"><md-tooltip>{{\'CREATE_RES.ADD_SERVICE\' | translate}}</md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-attachment\" class=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" \nngf-select=\"vm.uploadDoc($files, $invalidFiles)\" ng-model=\"vm.file\" name=\"file\" id=\"file\" ngf-max-size=\"10MB\" \nngf-pattern=\"vm.allowedFiles\" ngf-accept=\"vm.allowedFiles\"><md-tooltip>Add File</md-tooltip></md-icon></div></div>\n</div></div><div class=\"customer-card-backdrop\" ng-class=\"{\'is-visible\': vm.customerCardExpanded}\" ng-if=\"vm.order\" \nng-click=\"vm.toggleCustomerCard($event)\" aria-hidden=\"{{!vm.customerCardExpanded}}\"></div><div \nclass=\"customer-stay-card customer-stay-card--header\" ng-class=\"{\'is-expanded\': vm.customerCardExpanded}\" \nng-if=\"vm.order\" ng-cloak><div class=\"customer-stay-card__shell\"><div class=\"customer-stay-card__bar\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"customer-stay-card__avatar\" aria-hidden=\"true\">{{vm.customerCardInitials()}}\n</div><div class=\"customer-stay-card__identity\" flex layout=\"column\" layout-align=\"center start\"><div \nclass=\"customer-stay-card__name-row\" layout=\"row\" layout-align=\"start center\"><span class=\"customer-stay-card__name\">\n{{vm.order.first_name}} {{vm.order.last_name}} </span><span class=\"customer-stay-card__tag-pill\" \nng-repeat=\"tag in vm.assignedTags track by $index\" ng-if=\"$index < 3\" \nng-style=\"vm.getCustomerTagStyle(tag.colour_code)\">{{tag.name}} </span><span class=\"customer-stay-card__tag-pill\" \nng-if=\"vm.assignedTags.length > 3\">+{{vm.assignedTags.length - 3}} </span><button class=\"customer-tag-action-btn\" \nng-if=\"vm.assignedTags.length > 0\" ng-click=\"vm.openCustomerTags($event)\">Edit Tags</button> <button \nclass=\"customer-tag-action-btn customer-tag-action-btn--add\" ng-if=\"vm.assignedTags.length == 0\" \nng-click=\"vm.openCustomerTags($event)\">Add Tags</button></div><div class=\"customer-stay-card__meta\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><span class=\"customer-stay-card__meta-item\" \nng-if=\"vm.phoneDisplay.traveller_phone\"><md-icon md-font-icon=\"icon-cellphone\" class=\"customer-stay-card__meta-icon\">\n</md-icon><a href=\"tel:{{vm.phoneDisplay.traveller_phone}}\">{{vm.formatPhoneNumber(vm.phoneDisplay.traveller_phone)}}\n</a> </span><span class=\"customer-stay-card__meta-item\" ng-if=\"vm.order.customer_email\"><md-icon \nmd-font-icon=\"icon-email\" class=\"customer-stay-card__meta-icon\"></md-icon><a href=\"mailto:{{vm.order.customer_email}}\">\n{{vm.order.customer_email}}</a> </span><span class=\"customer-stay-card__meta-item\" ng-if=\"vm.customerCardLocation()\">\n<md-icon md-font-icon=\"icon-map-marker\" class=\"customer-stay-card__meta-icon\"></md-icon>{{vm.customerCardLocation()}}\n</span></div></div></div><div class=\"customer-stay-card__panel\" aria-hidden=\"{{!vm.customerCardExpanded}}\"><div \nclass=\"customer-stay-card__panel-inner\"><md-tabs class=\"customer-stay-card__tabs\" \nmd-selected=\"vm.customerCardTabIndex\" md-border-bottom md-dynamic-height><md-tab label=\"Profile\"><div \nclass=\"customer-stay-card__tab-body\"><div class=\"customer-stay-card__profile-toolbar\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button customer-stay-card__edit\" \nng-if=\"!vm.editingCustomerProfile\" ng-class=\"vm.modify_request ? \'canceled_order\' : \'\'\" \nng-click=\"vm.enableCustomerProfileEdit()\" aria-label=\"{{ \'CONTACTS.EDIT_CONTACT\' | translate }}\" \ntitle=\"{{ \'CONTACTS.EDIT_CONTACT\' | translate }}\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><div \nng-if=\"vm.editingCustomerProfile\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" \nng-disabled=\"vm.isSavingCustomerProfile\" ng-click=\"vm.cancelCustomerProfileEdit()\">Cancel</md-button><md-button \nclass=\"md-raised md-accent white-fg customer-save-button\" ng-disabled=\"vm.isSavingCustomerProfile\" \nng-click=\"vm.saveCustomerProfileEdit()\"><span ng-if=\"!vm.isSavingCustomerProfile\">Save</span><md-progress-circular \nng-if=\"vm.isSavingCustomerProfile\" class=\"customer-save-spinner\" md-mode=\"indeterminate\" md-diameter=\"16\">\n</md-progress-circular></md-button></div></div><div class=\"customer-stay-card__profile-grid\" \nng-class=\"{\'is-editing\': vm.editingCustomerProfile}\"><div class=\"customer-stay-card__row\" layout=\"row\" layout-wrap><div\n class=\"customer-stay-card__field\" flex=\"100\" flex-gt-xs=\"50\" ng-class=\"{\'editing-field\': vm.editingCustomerProfile}\">\n<label>FIRST NAME</label><div ng-show=\"!vm.editingCustomerProfile\">{{vm.order.first_name || \'—\'}}</div><input \nng-show=\"vm.editingCustomerProfile\" type=\"text\" class=\"customer-inline-input\" \nng-model=\"vm.editableCustomerProfile.first_name\" aria-label=\"First name\"></div><div class=\"customer-stay-card__field\" \nflex=\"100\" flex-gt-xs=\"50\" ng-class=\"{\'editing-field\': vm.editingCustomerProfile}\"><label>LAST NAME</label><div \nng-show=\"!vm.editingCustomerProfile\">{{vm.order.last_name || \'—\'}}</div><input ng-show=\"vm.editingCustomerProfile\" \ntype=\"text\" class=\"customer-inline-input\" ng-model=\"vm.editableCustomerProfile.last_name\" aria-label=\"Last name\"></div>\n</div><div class=\"customer-stay-card__row\" layout=\"row\" layout-wrap><div class=\"customer-stay-card__field\" flex=\"100\" \nflex-gt-xs=\"50\" ng-class=\"{\'editing-field\': vm.editingCustomerProfile}\"><label>EMAIL</label><div \nng-show=\"!vm.editingCustomerProfile\">{{vm.order.customer_email || \'—\'}}</div><input \nng-show=\"vm.editingCustomerProfile\" type=\"email\" class=\"customer-inline-input\" \nng-model=\"vm.editableCustomerProfile.customer_email\"></div><div class=\"customer-stay-card__field\" flex=\"100\" \nflex-gt-xs=\"50\" ng-class=\"{\'editing-field\': vm.editingCustomerProfile}\"><label>PHONE</label><div \nng-show=\"!vm.editingCustomerProfile\">\n{{vm.formatPhoneNumber(vm.phoneDisplay.traveller_phone || vm.order.phone_number || \'—\')}}</div><md-input-container \nng-show=\"vm.editingCustomerProfile\" class=\"md-block m-0 customer-phone-container\"><input id=\"travellerPhoneNumber\" \ntype=\"tel\" name=\"phone_number[vm.selectedIndex]\" ng-model=\"vm.editableCustomerProfile.phone_number\" \nclass=\"intel-number-input\" intl-tel-input autocomplete=\"off\" \nng-change=\"vm.updatePhoneWithCountryCode(\n                                \'phone_number[vm.selectedIndex]\',\n                                $event\n                              );\" \nstyle=\"border-bottom: none !important\"></md-input-container></div></div><div class=\"customer-stay-card__row\" \nlayout=\"row\" layout-wrap><div class=\"customer-stay-card__field\" flex=\"100\" flex-gt-xs=\"50\" \nng-class=\"{\'editing-field\': vm.editingCustomerProfile}\"><label>SECONDARY PHONE</label><div \nng-show=\"!vm.editingCustomerProfile\">\n{{vm.formatPhoneNumber(vm.phoneDisplay.traveller_secondary_phone || vm.order.secondary_phone_number || \'—\')}}</div>\n<md-input-container ng-show=\"vm.editingCustomerProfile\" class=\"md-block m-0 customer-phone-container\"><input \nid=\"travellerSecondaryPhoneNumber\" type=\"tel\" name=\"secondary_phone_number[vm.selectedIndex]\" \nng-model=\"vm.editableCustomerProfile.secondary_phone_number\" ng-model-options=\"{debounce: 800}\" \nclass=\"intel-number-input\" intl-tel-input autocomplete=\"off\" \nng-change=\"vm.updatePhoneWithCountryCode(\n                                \'secondary_phone_number[vm.selectedIndex]\',\n                                $event\n                              );\" \nstyle=\"border-bottom: none !important\"></md-input-container></div><div class=\"customer-stay-card__field\" flex=\"100\" \nflex-gt-xs=\"50\" ng-class=\"{\'editing-field\': vm.editingCustomerProfile}\"><label>GENDER</label><md-select \nng-show=\"vm.editingCustomerProfile\" ng-model=\"vm.editableCustomerProfile.customer_gender\" placeholder=\"Select Gender\" \nclass=\"customer-inline-select\"><md-option value=\"Male\">Male</md-option><md-option value=\"Female\">Female</md-option>\n<md-option value=\"Other\">Other</md-option><md-option value=\"Prefer not to say\">Prefer not to say</md-option>\n</md-select><div ng-show=\"!vm.editingCustomerProfile\">{{vm.customerCardGender()}}</div></div></div><div \nclass=\"customer-stay-card__row\" layout=\"row\" layout-wrap><div class=\"customer-stay-card__field\" flex=\"100\" \nflex-gt-xs=\"50\" ng-class=\"{\'editing-field\': vm.editingCustomerProfile}\"><label>DATE OF BIRTH</label><div \nng-show=\"!vm.editingCustomerProfile\">{{vm.customerCardDateOfBirth()}}</div><div ng-show=\"vm.editingCustomerProfile\" \nclass=\"customer-inline-datepicker\"><md-datepicker ng-model=\"vm.editableCustomerProfile.date_of_birth\" md-open-on-focus \nmd-placeholder=\"Select date of birth\" md-max-date=\"vm.maxDateOfBirth\" aria-label=\"Date of birth\"></md-datepicker></div>\n</div><div class=\"customer-stay-card__field\" flex=\"100\" flex-gt-xs=\"50\" \nng-class=\"{\'editing-field\': vm.editingCustomerProfile}\"><label>ABOUT</label><div ng-show=\"!vm.editingCustomerProfile\">\n{{vm.customerCardAbout()}}</div><textarea ng-show=\"vm.editingCustomerProfile\" \nclass=\"customer-inline-input customer-inline-textarea\" ng-model=\"vm.editableCustomerProfile.about\" \nplaceholder=\"Write here\" rows=\"1\" aria-label=\"About\"></textarea></div></div><div class=\"customer-stay-card__row\" \nlayout=\"row\" layout-wrap><div class=\"customer-stay-card__field\" flex=\"100\" flex-gt-xs=\"100\" \nng-class=\"{\'editing-field\': vm.editingCustomerProfile}\"><label>ADDRESS</label><div \nng-show=\"!vm.editingCustomerProfile\">{{vm.order.address || \'—\'}}</div><input ng-show=\"vm.editingCustomerProfile\" \ntype=\"text\" class=\"customer-inline-input customer-profile-address-input\" ng-model=\"vm.editableCustomerProfile.address\" \nid=\"autocompleteCustomerProfile\" autocomplete=\"off\" aria-label=\"Address\"></div></div><div \nclass=\"customer-stay-card__row\" layout=\"row\" layout-wrap><div class=\"customer-stay-card__field\" flex=\"100\" \nflex-gt-xs=\"50\" ng-class=\"{\'editing-field\': vm.editingCustomerProfile}\"><label>CITY</label><div \nng-show=\"!vm.editingCustomerProfile\">{{vm.order.city || \'—\'}}</div><input ng-show=\"vm.editingCustomerProfile\" \ntype=\"text\" class=\"customer-inline-input\" ng-model=\"vm.editableCustomerProfile.city\" aria-label=\"City\"></div><div \nclass=\"customer-stay-card__field\" flex=\"100\" flex-gt-xs=\"50\" ng-class=\"{\'editing-field\': vm.editingCustomerProfile}\">\n<label>STATE</label><div ng-show=\"!vm.editingCustomerProfile\">{{vm.order.state || \'—\'}}</div><input \nng-show=\"vm.editingCustomerProfile\" type=\"text\" class=\"customer-inline-input\" \nng-model=\"vm.editableCustomerProfile.state\" aria-label=\"State\"></div></div><div \nclass=\"customer-stay-card__row customer-stay-card__row--last\" layout=\"row\" layout-wrap><div \nclass=\"customer-stay-card__field\" flex=\"100\" flex-gt-xs=\"50\" ng-class=\"{\'editing-field\': vm.editingCustomerProfile}\">\n<label>ZIP CODE</label><div ng-show=\"!vm.editingCustomerProfile\">{{vm.order.zip_code || \'—\'}}</div><input \nng-show=\"vm.editingCustomerProfile\" type=\"text\" class=\"customer-inline-input\" \nng-model=\"vm.editableCustomerProfile.zip_code\" id=\"autocompletezipCustomerProfile\" autocomplete=\"off\" \naria-label=\"Zip code\"></div><div class=\"customer-stay-card__field\" flex=\"100\" flex-gt-xs=\"50\" \nng-class=\"{\'editing-field\': vm.editingCustomerProfile}\"><label>COUNTRY</label><div \nng-show=\"!vm.editingCustomerProfile\">{{vm.order.country || \'—\'}}</div><input ng-show=\"vm.editingCustomerProfile\" \ntype=\"text\" class=\"customer-inline-input\" ng-model=\"vm.editableCustomerProfile.country\" aria-label=\"Country\"></div>\n</div></div></div></md-tab><md-tab label=\"Reservations\"><div class=\"customer-stay-card__tab-body\"><div \nng-if=\"vm.customerCardReservations.isloading\"><div class=\"customer-stay-card__empty\"><div \nclass=\"customer-stay-card__empty-inner\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"28\"></md-progress-circular><p>Loading reservations…</p></div></div></div><div \nng-if=\"!vm.customerCardReservations.isloading && (!vm.customerCardReservations.data || !vm.customerCardReservations.data.length)\">\n<div class=\"customer-stay-card__empty\"><div class=\"customer-stay-card__empty-inner\"><md-icon \nmd-font-icon=\"icon-calendar\"></md-icon><p>No reservations found for this traveller</p></div></div></div><div \nclass=\"customer-stay-card__res-table-wrap\" \nng-if=\"!vm.customerCardReservations.isloading && vm.customerCardReservations.data.length\"><div \nclass=\"customer-stay-card__res-table-title\">Reservations <span>({{vm.customerCardReservations.totalResv}})</span></div>\n<div class=\"customer-stay-card__res-table\"><table><thead><tr><th \nng-repeat=\"heading in vm.customerCardReservations.heading\">{{heading}}</th></tr></thead><tbody><tr \nng-repeat=\"reservation in vm.customerCardReservations.data\" \nng-click=\"reservation.confirmation_number && vm.goToCustomerCardReservation(reservation)\"><td>\n{{reservation.product_name || reservation.fe_display_product_name || \'—\'}}</td><td>\n{{reservation.room_stay_from_formatted || \'—\'}}</td><td>{{reservation.room_stay_to_formatted || \'—\'}}</td><td>\n{{reservation.total_amount ? (\'$\' + reservation.total_amount) : \'—\'}}</td><td>\n{{reservation.average_daily_rate ? (\'$\' + reservation.average_daily_rate) : \'—\'}}</td><td>\n{{reservation.reservation_created_date_formatted || \'—\'}}</td><td>{{reservation.source_of_creation || \'—\'}}</td></tr>\n</tbody></table></div></div></div></md-tab><md-tab label=\"Notes\" md-on-select=\"vm.loadCustomerCardNotes()\"><div \nclass=\"customer-stay-card__tab-body\"><div ng-if=\"vm.customerCardNotes.isloading\"><div \nclass=\"customer-stay-card__empty\"><div class=\"customer-stay-card__empty-inner\"><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"28\"></md-progress-circular><p>Loading notes…</p></div></div></div><div \nng-if=\"!vm.customerCardNotes.isloading && (!vm.customerCardNotes.data || !vm.customerCardNotes.data.length)\"><div \nclass=\"customer-stay-card__empty\"><div class=\"customer-stay-card__empty-inner\"><md-icon md-font-icon=\"icon-note-text\">\n</md-icon><p>No notes found for this customer</p></div></div></div><div \nng-if=\"!vm.customerCardNotes.isloading && vm.customerCardNotes.data && vm.customerCardNotes.data.length\" \nclass=\"customer-stay-card__notes-wrap\"><ul class=\"customer-stay-card__notes-list\"><li \nclass=\"customer-stay-card__note-item\" ng-repeat=\"note in vm.customerCardNotes.data\" \nng-class=\"{\'is-editing\': note.isEditing}\"><div class=\"customer-stay-card__note-header\"><div \nclass=\"customer-stay-card__note-meta\"><span>{{note.created_by_user_name || \'System\'}}</span>\n • {{note.created_date | date:\'MM-dd-yyyy h:mm a\' || \'—\'}}</div><div class=\"customer-stay-card__note-actions\" \nng-if=\"!note.isEditing\"><md-switch class=\"customer-stay-card__note-share-toggle\" \nng-checked=\"note.post_to_all_reservation == 1\" ng-click=\"vm.togglePostToAllReservations(note)\" \naria-label=\"Post to all reservations\" \ntitle=\"{{note.post_to_all_reservation == 1 ? \'Posted to all reservations\' : \'Post to all reservations\'}}\"></md-switch>\n<md-button class=\"md-icon-button\" ng-click=\"vm.editCustomerNote(note)\" aria-label=\"Edit note\" title=\"Edit note\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button note-delete-btn\" \nng-click=\"vm.deleteCustomerNote($event, note)\" aria-label=\"Delete note\" title=\"Delete note\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></div><div class=\"customer-stay-card__note-content\" \nng-if=\"!note.isEditing\">{{note.note}}</div><div class=\"customer-stay-card__note-edit-form\" ng-if=\"note.isEditing\" \nlayout=\"column\"><md-input-container class=\"md-block\"><textarea ng-model=\"note.editText\" rows=\"1\" \naria-label=\"Edit note content\"></textarea></md-input-container><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-raised\" ng-disabled=\"note.isSaving\" ng-click=\"vm.cancelEditCustomerNote(note)\">Cancel</md-button><md-button \nclass=\"md-raised md-accent white-fg\" ng-disabled=\"!note.editText || note.editText.trim() === \'\' || note.isSaving\" \nng-click=\"vm.updateCustomerNote(note)\"><md-progress-circular ng-if=\"note.isSaving\" class=\"white-fg\" \nmd-mode=\"indeterminate\" md-diameter=\"16\" style=\"display:inline-block;vertical-align:middle;margin-right:6px\">\n</md-progress-circular><span>{{note.isSaving ? \'Saving...\' : \'Save\'}}</span></md-button></div></div></li></ul></div>\n<div class=\"customer-stay-card__note-form\"><div layout=\"row\" layout-align=\"start center\" layout-gap=\"12px\">\n<md-input-container class=\"md-block\" flex><label>Add a note about this customer</label><textarea \nng-model=\"vm.newCustomerNoteText\" placeholder=\"Write something...\" rows=\"1\" class=\"md-input-textarea\">\n                        </textarea></md-input-container><md-button class=\"md-raised md-accent white-fg\" \nng-disabled=\"!vm.newCustomerNoteText || vm.newCustomerNoteText.trim() === \'\'\" ng-click=\"vm.addCustomerNote()\">Add Note\n</md-button></div><md-checkbox ng-model=\"vm.postNoteToAllReservations\" aria-label=\"Post to all reservations\">\nPost to all reservation</md-checkbox></div></div></md-tab><md-tab label=\"Family Members\" \nmd-on-select=\"vm.loadCustomerFamilyMembers(); vm.getRelationshipTypes();\"><div class=\"customer-stay-card__tab-body\">\n<div ng-if=\"vm.customerFamilyMembers.isloading && !vm.showFamilyMemberForm\"><div class=\"customer-stay-card__empty\"><div\n class=\"customer-stay-card__empty-inner\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"28\"></md-progress-circular><p>Loading family members…</p></div></div></div><div \nclass=\"customer-stay-card__res-table-wrap\" \nng-if=\"!vm.customerFamilyMembers.isloading && vm.customerFamilyMembers.data && vm.customerFamilyMembers.data.length && !vm.showFamilyMemberForm\">\n<div class=\"customer-stay-card__res-table-title\"><span>Family Members ({{vm.customerFamilyMembers.data.length}})</span>\n<div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-raised md-accent white-fg customer-family-members__add-btn\" ng-click=\"vm.openAddFamilyMemberForm()\" \naria-label=\"Add family member\">Add</md-button><button class=\"md-button md-icon-button\" \nng-click=\"vm.loadCustomerFamilyMembers()\" aria-label=\"Refresh family members\" title=\"Refresh\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon></button></div></div><div \nclass=\"customer-stay-card__res-table customer-family-members__res-table\"><table><thead><tr><th>NAME</th><th>\nRELATIONSHIP</th><th>EMAIL</th><th>PHONE</th><th>DATE OF BIRTH</th><th>ACTIONS</th></tr></thead><tbody><tr \nng-repeat=\"member in vm.customerFamilyMembers.data track by member.customer_id\" \nng-class=\"{\'customer-family-members__row--editing\':vm.editingFamilyMember && vm.editingFamilyMember.customer_id === member.customer_id}\" \nng-click=\"vm.goToFamilyMember(member.customer_id)\"><td><div class=\"customer-family-members__name\"><div \nclass=\"customer-family-members__avatar\">{{(member.first_name || \'?\').charAt(0).toUpperCase()}}</div><div \nclass=\"customer-family-members__member-name\">{{member.first_name || \'—\'}} {{member.last_name || \'\'}}</div></div></td>\n<td><span class=\"customer-family-members__relationship\">{{member.relationship_status || \'—\'}}</span></td><td>\n{{member.customer_email || \'—\'}}</td><td>{{vm.formatPhoneNumber(member.phone_number) || \'—\'}}</td><td>\n{{vm.formatDateOfBirth(member.date_of_birth) || \'—\'}}</td><td class=\"customer-family-members__actions\"><md-button \nclass=\"md-icon-button\" ng-click=\"$event.stopPropagation(); vm.editFamilyMember(member)\" \nng-disabled=\"vm.isUpdatingFamilyMember\" aria-label=\"Edit family member\" title=\"Edit\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button family-member-delete-btn\" \nng-click=\"$event.stopPropagation(); vm.deleteFamilyMember($event, member)\" aria-label=\"Delete family member\" \ntitle=\"Delete\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div><div \nng-if=\"!vm.customerFamilyMembers.isloading && (!vm.customerFamilyMembers.data || !vm.customerFamilyMembers.data.length) && !vm.showFamilyMemberForm\">\n<div class=\"customer-stay-card__empty\"><div class=\"customer-stay-card__empty-inner\"><md-icon \nmd-font-icon=\"icon-account-multiple\"></md-icon><p>No family members added yet</p><md-button \nclass=\"md-raised md-accent white-fg customer-family-members__add-btn\" ng-click=\"vm.openAddFamilyMemberForm()\" \naria-label=\"Add family member\">Add Family Member</md-button></div></div></div><div \nclass=\"customer-family-member-profile\" ng-if=\"vm.showFamilyMemberForm\"><div \nclass=\"customer-stay-card__profile-toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" \nng-disabled=\"vm.isSavingFamilyMember || vm.isUpdatingFamilyMember\" ng-click=\"vm.cancelEditFamilyMember()\">Cancel\n</md-button><md-button class=\"md-raised md-accent white-fg customer-save-button\" \nng-disabled=\"\n                              vm.isSavingFamilyMember ||\n                              vm.isUpdatingFamilyMember ||\n                              !vm.familyMemberForm.first_name ||\n                              !vm.familyMemberForm.relationship_id ||\n                              !vm.familyMemberForm.customer_email ||\n                              !vm.isValidEmail(vm.familyMemberForm.customer_email)\n                          \" \nng-click=\"\n                              vm.editingFamilyMember\n                                  ? vm.updateFamilyMember()\n                                  : vm.saveFamilyMember()\n                          \">\n<span ng-if=\"!vm.isSavingFamilyMember && !vm.isUpdatingFamilyMember\">{{vm.editingFamilyMember ? \'Update\' : \'Save\'}}\n</span><md-progress-circular ng-if=\"vm.isSavingFamilyMember || vm.isUpdatingFamilyMember\" \nclass=\"customer-save-spinner\" md-mode=\"indeterminate\" md-diameter=\"16\"></md-progress-circular></md-button></div><div \nclass=\"customer-stay-card__profile-grid is-editing\"><div class=\"customer-stay-card__row\" layout=\"row\" layout-wrap><div \nclass=\"customer-stay-card__field editing-field\" flex=\"100\" flex-gt-xs=\"50\"><label>FIRST NAME</label><md-autocomplete \nname=\"familyFirstName\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedFamilyMemberSearch.first_name\" \nmd-selected-item-change=\"vm.selectFamilyMemberCustomer(item)\" md-search-text=\"vm.familyMemberSearch.first_name\" \nmd-search-text-change=\"vm.familyMemberForm.first_name = vm.familyMemberSearch.first_name\" \nmd-items=\"item in vm.queryFamilyMemberSearch(vm.familyMemberSearch.first_name, \'cust.first_name\')\" \nmd-item-text=\"item.first_name\" md-min-length=\"1\" md-max-length=\"18\" md-delay=\"500\" placeholder=\"First Name\" \nclass=\"family-member-autocomplete-loading customer-profile-autocomplete\"><md-item-template><span \nmd-highlight-text=\"vm.familyMemberSearch.first_name\" md-highlight-flags=\"^i\">{{item.display || item.first_name}}</span>\n</md-item-template></md-autocomplete></div><div class=\"customer-stay-card__field editing-field\" flex=\"100\" \nflex-gt-xs=\"50\"><label>LAST NAME</label><md-autocomplete name=\"familyLastName\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedFamilyMemberSearch.last_name\" \nmd-selected-item-change=\"vm.selectFamilyMemberCustomer(item)\" md-search-text=\"vm.familyMemberSearch.last_name\" \nmd-search-text-change=\"vm.familyMemberForm.last_name = vm.familyMemberSearch.last_name\" \nmd-items=\"item in vm.queryFamilyMemberSearch(vm.familyMemberSearch.last_name, \'cust.last_name\')\" \nmd-item-text=\"item.last_name\" md-min-length=\"1\" md-max-length=\"18\" md-delay=\"500\" placeholder=\"Last Name\" \nclass=\"family-member-autocomplete-loading customer-profile-autocomplete\"><md-item-template><span \nmd-highlight-text=\"vm.familyMemberSearch.last_name\" md-highlight-flags=\"^i\">\n{{item.display || item.first_name + \' \' + item.last_name}}</span></md-item-template></md-autocomplete></div></div><div \nclass=\"customer-stay-card__row\" layout=\"row\" layout-wrap><div class=\"customer-stay-card__field editing-field\" \nflex=\"100\" flex-gt-xs=\"50\"><label>EMAIL</label><md-autocomplete name=\"familyEmail\" md-no-cache=\"vm.noCache\" \nmd-selected-item=\"vm.selectedFamilyMemberSearch.customer_email\" \nmd-selected-item-change=\"vm.selectFamilyMemberCustomer(item)\" md-search-text=\"vm.familyMemberSearch.customer_email\" \nmd-search-text-change=\"vm.familyMemberForm.customer_email = vm.familyMemberSearch.customer_email\" \nmd-items=\"item in vm.queryFamilyMemberSearch(vm.familyMemberSearch.customer_email, \'cust.customer_email\')\" \nmd-item-text=\"item.customer_email\" md-min-length=\"1\" md-max-length=\"100\" md-delay=\"500\" placeholder=\"Email\" \nclass=\"family-member-autocomplete-loading customer-profile-autocomplete\" \nng-class=\"{\n                                  \'email-invalid\':\n                                  vm.familyMemberSearch.customer_email &&\n                                  !vm.isValidEmail(vm.familyMemberSearch.customer_email)\n                              }\">\n<md-item-template><span md-highlight-text=\"vm.familyMemberSearch.customer_email\" md-highlight-flags=\"^i\">\n{{item.customer_email}}</span></md-item-template></md-autocomplete></div><div \nclass=\"customer-stay-card__field editing-field\" flex=\"100\" flex-gt-xs=\"50\"><label>PHONE</label><md-input-container \nclass=\"md-block m-0 customer-phone-container\"><input ng-model=\"vm.familyMemberForm.phone_number\" \nname=\"family_member_phone\" type=\"tel\" id=\"familyMemberPhoneNumber\" class=\"intel-number-input\" intl-tel-input \nautocomplete=\"off\" aria-label=\"Phone number\" ng-change=\"vm.updatePhoneWithCountryCode(\'family_member_phone\', $event);\" \nng-blur=\"vm.updatePhoneWithCountryCode(\'family_member_phone\', $event);\" style=\"border-bottom: none !important\">\n</md-input-container></div></div><div class=\"customer-stay-card__row customer-stay-card__row--last\" layout=\"row\" \nlayout-wrap><div class=\"customer-stay-card__field editing-field\" flex=\"100\" flex-gt-xs=\"50\"><label>DATE OF BIRTH\n</label><div class=\"customer-inline-datepicker\"><md-datepicker name=\"familyDateOfBirth\" \nng-model=\"vm.familyMemberForm.date_of_birth\" md-open-on-focus md-placeholder=\"Select date of birth\" \nmd-max-date=\"vm.maxDateOfBirth\" aria-label=\"Member date of birth\"></md-datepicker></div></div><div \nclass=\"customer-stay-card__field editing-field\" flex=\"100\" flex-gt-xs=\"50\"><label>RELATIONSHIP</label><md-select \nng-model=\"vm.familyMemberForm.relationship_id\" name=\"familyRelationship\" placeholder=\"Select Relationship\" \nclass=\"customer-inline-select\" aria-label=\"Relationship\"><md-option ng-repeat=\"relationship in vm.relationshipTypes\" \nng-value=\"relationship.id\">{{relationship.relationship_name}}</md-option></md-select></div></div></div></div></div>\n</md-tab><md-tab label=\"Pets\" md-on-select=\"vm.loadCustomerPets(); vm.loadPetTypes();\"><div \nclass=\"customer-stay-card__tab-body\"><div ng-if=\"vm.customerPets.isloading\"><div class=\"customer-stay-card__empty\"><div\n class=\"customer-stay-card__empty-inner\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"28\"></md-progress-circular><p>Loading pets…</p></div></div></div><div \nclass=\"customer-stay-card__res-table-wrap\" \nng-if=\"\n                      !vm.customerPets.isloading &&\n                      vm.customerPets.data &&\n                      vm.customerPets.data.length\n                    \">\n<div class=\"customer-stay-card__res-table-title\"><span>Pets ({{vm.customerPets.data.length}}) </span><button \nclass=\"md-button md-icon-button\" ng-click=\"vm.loadCustomerPets()\" aria-label=\"Refresh pets\" title=\"Refresh\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon></button></div><div \nclass=\"customer-stay-card__res-table customer-pets__res-table\"><table><thead><tr><th>NAME</th><th>PET TYPE</th><th>\nDATE OF BIRTH</th><th>ACTIONS</th></tr></thead><tbody><tr ng-repeat=\"pet in vm.customerPets.data track by pet.id\" \nng-class=\"{\n                              \'customer-pets__row--editing\':\n                                vm.editingCustomerPet &&\n                                vm.editingCustomerPet.id === pet.id\n                            }\">\n<td><div class=\"customer-pets__name\"><div class=\"customer-pets__avatar\">{{(pet.name || \'?\').charAt(0).toUpperCase()}}\n</div><div class=\"customer-pets__member-name\">{{pet.name || \'—\'}}</div></div></td><td><span \nclass=\"customer-pets__type\">{{pet.pet_type === \'Other\' && pet.other_pet_type ? pet.other_pet_type : pet.pet_type}}\n</span></td><td>{{vm.formatDateOfBirth(pet.date_of_birth) || \'—\'}}</td><td class=\"customer-pets__actions\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.editCustomerPet(pet)\" ng-disabled=\"vm.isUpdatingCustomerPet\" aria-label=\"Edit pet\" \ntitle=\"Edit\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button \nclass=\"md-icon-button customer-pet-delete-btn\" ng-click=\"vm.deleteCustomerPet($event, pet)\" aria-label=\"Delete pet\" \ntitle=\"Delete\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></td></tr></tbody></table></div></div><div \nng-if=\"\n                      !vm.customerPets.isloading &&\n                      (!vm.customerPets.data ||\n                      !vm.customerPets.data.length)\n                    \">\n<div class=\"customer-stay-card__empty\"><div class=\"customer-stay-card__empty-inner\"><md-icon md-font-icon=\"icon-cat\">\n</md-icon><p>No pets added yet</p></div></div></div><div \nclass=\"customer-stay-card__family-member-form customer-stay-card__pet-form\"><div \nclass=\"customer-stay-card__family-member-form-grid\"><md-input-container class=\"md-block\"><label>Pet Name</label><input \ntype=\"text\" name=\"petName\" ng-model=\"vm.customerPetForm.name\" aria-label=\"Pet name\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Pet Type</label><md-select name=\"petType\" \nng-model=\"vm.customerPetForm.pet_type_id\" aria-label=\"Pet type\" ng-disabled=\"vm.petTypes.isloading\"><md-option \nng-repeat=\"petType in vm.petTypes.data track by petType.id\" ng-value=\"petType.id\">{{petType.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" \nng-if=\"vm.customerPetForm.pet_type_id == vm.otherPetTypeId\"><label>Other Pet Type</label><input type=\"text\" \nname=\"otherPetType\" ng-model=\"vm.customerPetForm.other_pet_type\" placeholder=\"Enter pet type\" \naria-label=\"Other pet type\"></md-input-container><md-input-container \nclass=\"md-block family-member-datepicker pet-dob-datepicker\"><label>Date of Birth</label><md-datepicker name=\"petDob\" \nng-model=\"vm.customerPetForm.date_of_birth\" md-open-on-focus md-max-date=\"vm.maxDateOfBirth\" \naria-label=\"Pet date of birth\"></md-datepicker></md-input-container></div><div \nclass=\"customer-stay-card__family-member-form-actions\" layout=\"row\" layout-align=\"end center\"><md-button \nng-if=\"vm.editingCustomerPet\" class=\"md-raised\" ng-disabled=\"vm.isUpdatingCustomerPet\" \nng-click=\"vm.cancelEditCustomerPet()\">Cancel</md-button><md-button class=\"md-raised md-accent white-fg\" \nng-disabled=\"\n                          vm.isSavingCustomerPet ||\n                          vm.isUpdatingCustomerPet ||\n                          !vm.customerPetForm.name ||\n                          !vm.customerPetForm.pet_type_id ||\n                          (\n                            vm.customerPetForm.pet_type_id === vm.otherPetTypeId &&\n                            !vm.customerPetForm.other_pet_type\n                          )\n                        \" \nng-click=\"\n                          vm.editingCustomerPet\n                            ? vm.updateCustomerPet()\n                            : vm.saveCustomerPet()\n                        \">\n<md-progress-circular \nng-if=\"\n                            vm.isSavingCustomerPet ||\n                            vm.isUpdatingCustomerPet\n                          \" \nclass=\"white-fg\" md-mode=\"indeterminate\" md-diameter=\"16\" \nstyle=\"display:inline-block;\n                            vertical-align:middle;\n                            margin-right:6px\">\n</md-progress-circular><span ng-if=\"!vm.editingCustomerPet\">{{vm.isSavingCustomerPet ? \'Adding...\' : \'Add\'}} </span>\n<span ng-if=\"vm.editingCustomerPet\">{{vm.isUpdatingCustomerPet ? \'Updating...\' : \'Update\'}}</span></md-button></div>\n</div></div></md-tab></md-tabs></div></div></div><div class=\"customer-stay-card__collapse-footer\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button customer-stay-card__toggle\" \nng-click=\"vm.toggleCustomerCard($event)\" aria-label=\"Collapse customer card\"><md-icon md-font-icon=\"icon-chevron-down\" \nng-class=\"{\'is-rotated\': vm.customerCardExpanded}\"></md-icon></md-button></div><div style=\"visibility: hidden\"><div \nclass=\"md-dialog-container\" id=\"myCustomerTags\"><md-dialog class=\"tax-dialog act-dialog\" style=\"width:650px\">\n<md-toolbar class=\"md-accent md-tall white-fg\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Manage Customer Tags</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll style=\"max-height:1000px\" class=\"dilog-lable\"><md-progress-linear \nmd-mode=\"indeterminate\" ng-show=\"vm.isSavingCustomerTags\"></md-progress-linear><md-content \nclass=\"md-padding no-margin\"><div><div layout=\"row\" layout-align=\"start center\" class=\"customer-info\"><div \nclass=\"customer-avatar\">{{vm.getTagDialogPersonInitials()}}</div><div class=\"ml-10\"><h3 class=\"no-margin\">\n{{vm.getTagDialogPersonName()}}</h3><div class=\"color-grey\">{{vm.getTagDialogPersonEmail()}}</div></div></div>\n<md-divider class=\"margin-vertical-15\"></md-divider><div class=\"tags-wrapper\"><div><div class=\"tag-section\"><div \nclass=\"section-header\"><div><h4>Available Tags</h4><p>Click a tag to assign it</p></div></div><div layout=\"row\" \nlayout-wrap ng-if=\"vm.systemTags.length\"><md-button class=\"tag-chip\" \nng-repeat=\"tag in vm.systemTags | filter:vm.systemTagSearch | filter:vm.unassignedTagsFilter\" \nng-click=\"vm.assignTag(tag,\'system\')\">{{tag.name}}</md-button></div><div class=\"empty-state\" \nng-if=\"(vm.systemTags | filter:vm.systemTagSearch | filter:vm.unassignedTagsFilter).length == 0\">No system tags found.\n</div></div><div class=\"tag-section\"><div class=\"section-header\"><div><h4>Assigned Tags <span class=\"tag-count\">\n({{vm.tempAssignedTags.length}})</span></h4><p>Currently assigned to this customer</p></div><md-button \nng-if=\"vm.tempAssignedTags.length\" class=\"clear-tags-btn\" ng-click=\"vm.clearAllTags()\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"mr-5\"></md-icon>Remove All</md-button></div><div class=\"assigned-tags\" \nng-if=\"vm.tempAssignedTags.length\"><div class=\"assigned-chip\" ng-repeat=\"tag in vm.tempAssignedTags\">{{tag.name}}\n<md-icon md-font-icon=\"icon-close\" class=\"material-icons icon-close\" ng-click=\"vm.removeAssignedTag(tag)\"></md-icon>\n</div></div><div class=\"empty-state\" ng-if=\"!vm.tempAssignedTags.length\">No tags have been assigned to this customer.\n</div></div></div></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.closeDialog()\" ng-disabled=\"vm.isSavingCustomerTags\" \nclass=\"md-raised md-background md-button md-default-theme md-ink-ripple\">Cancel</md-button><md-button \nclass=\"md-raised md-green-500-bg submit-button white-fg\" ng-click=\"vm.saveCustomerTags()\" \nng-disabled=\"vm.isSavingCustomerTags\">Save</md-button></md-dialog-actions></md-dialog></div></div></div><div \nclass=\"content content-scroll relative-block tab-container-section\"><md-progress-linear md-mode=\"indeterminate\" \nng-show=\"vm.isloading || vm.isCustomerTagsLoading\"></md-progress-linear><div class=\"md-whiteframe-1dp height\"><div \nclass=\"role-list-outer height-main\"><div flex=\"100\" layout=\"row\"><div ng-show=\"vm.showSliderControlls\" \nclass=\"arr-leftblk arrcomn onlycursorPointer\" ng-click=\"vm.slideLeft();\" layout=\"column\" flex layout-align=\"center\">\n<md-icon md-font-icon=\"icon-chevron-left\" class=\"white-fg\"></md-icon></div><div class=\"labels-blockclick-outer\" \nlayout=\"column\" flex><div layout=\"row\" flex><div class=\"labels-blockclick ph-5 onlycursorPointer\" \nng-class=\"vm.order.confirmation_number == singleorder.confirmation_number ? \'active\':\'\'\" \nng-repeat=\"(orderIndex,singleorder) in vm.tabs_data\" \nng-click=\"vm.mainTabChanged($event,orderIndex);vm.fetchOrder(singleorder.confirmation_number)\" layout=\"column\" flex \nlayout-align=\"center center\"><label ng-if=\"singleorder.product_room_number != null\" \nclass=\"lbltablatest onlycursorPointer\"><b ng-if=\"singleorder.is_walk == 1\">{{singleorder.product_name}}</b> <b \nng-if=\"singleorder.is_walk == 0\">{{singleorder.product_room_number}}</b><br>{{singleorder.tab_date}}</label><label \nng-if=\"singleorder.product_room_number == null\" class=\"lbltablatest onlycursorPointer\"><b>{{singleorder.tab_name}}</b>\n<br>{{singleorder.tab_date}}</label></div></div></div><div ng-show=\"vm.showSliderControlls\" \nclass=\"arr-rightblk arrcomn onlycursorPointer\" layout=\"column\" ng-click=\"vm.slideRight();\" layout-align=\"center\" flex>\n<md-icon md-font-icon=\"icon-chevron-right\" class=\"white-fg\"></md-icon></div><div class=\"reservation-color-picker\" \nng-if=\"vm.tabs_data.length > 1\"><md-tooltip>Assign color code</md-tooltip><color-picker ng-model=\"vm.order.color_code\" \noptions=\"vm.options\" api=\"vm.colorPickerApi\" event-api=\"vm.eventApi\"></color-picker></div></div><div \nclass=\"heightless45\"><div class=\"md-padding\" style=\"height:100%\" class=\"md-tabs-inner\"><md-tabs class=\"inner-tabs\" \nid=\"current-tab-{{vm.selectedIndex}}\" md-selected=\"vm.innerSlectedIndex\"><md-tab label=\"Booking Details\"><div \nclass=\"genral-block-top-outer\"><div layout=\"row\" layout-wrap flex=\"100\" \nng-class=\"vm.order.source_of_creation ? \'mt-10\' : \'mt-20\'\"><div layout=\"column\" flex=\"100\" flex-gt-xs=\"100\" \nclass=\"ph-15\"><div layout-align=\"center end\" layout=\"column\" flex=\"100\"><div><div class=\"channel_info ml-10\" \nng-if=\"vm.order.siteminder_id!=\'\'\"><span><img \nsrc=\"{{vm.baseUrl}}assets/uploads/channels/{{vm.order.source_of_creation}}.png\" class=\"block_nav_img\" alt=\"\">\n<md-tooltip>{{vm.order.source_of_creation}}</md-tooltip></span><div class=\"channal-content-l1\"><span \nng-if=\"vm.order.source_of_creation == \'Expedia\' && vm.order.collect_which == \'channel_collect\'\">Expedia Collect</span> \n<span ng-if=\"vm.order.source_of_creation != \'Expedia\' && vm.order.collect_which == \'channel_collect\'\">Channel Collect\n</span> <span class=\"red-A800-fg\">{{vm.order.siteminder_id}}</span></div></div><div class=\"channel_info ml-10\" \nng-if=\"vm.order.room_moved_from != null && vm.order.room_moved_from != \'\' && vm.order.room_moved_from != \'undefined\'\">\nRoom moved from {{vm.order.room_moved_from}}</div><div class=\"channel_info ml-10\" \nng-if=\"(vm.order.room_moved_from != null && vm.order.room_moved_from != \'\') && (vm.order.room_moved_to != null && vm.order.room_moved_to != \'\')\">\n-</div><div class=\"channel_info ml-10\" ng-if=\"vm.order.room_moved_to != null && vm.order.room_moved_to != \'\'\">\nRoom moved to {{vm.order.room_moved_to}}</div></div></div></div><div layout=\"column\" flex=\"100\"><div layout=\"row\" \nflex=\"100\" layout-align=\"space-between stretch\" class=\"ph-15\"><div layout=\"column\" class=\"halfblockinfo\" \nng-class=\"vm.order.currentBilling == \'customer\' && !vm.order.customerTravelSame ? \'current-billing\' : \'\'\"><div \nclass=\"section-right-genral role-list-out featured-rol-block\" style=\"padding:0px\"><div class=\"roomName ph-15 pb-10\" \nlayout=\"row\" flex><div class=\"room-col\" layout=\"column\" flex=\"100\"><div layout=\"row\" flex layout-wrap><div \nlayout=\"column\" flex=\"100\" layout-align=\"center start\"><div class=\"row-containerstaus\"><strong \nng-click=\"vm.changeBillingOption(\'customer\')\"><img \nng-if=\"vm.order.currentBilling == \'customer\' && !vm.order.customerTravelSame\" class=\"bill-customer\" \nsrc=\"assets/images/bill.svg\"> {{ \'CREATE_RES.BILL_INFO\' | translate }}<p class=\"default-bill\" \nng-if=\"vm.order.currentBilling == \'customer\' && !vm.order.customerTravelSame\">(default billing)</p></strong><i \nng-class=\"vm.modify_request ? \'canceled_order\' : \'\'\" \nclass=\"icon-account-multiple-plus s30 onlycursorPointer onlyFloatRight\" ng-click=\"vm.triggerdiv($event, \'Customer\')\">\n<md-tooltip>{{ \'CONTACTS.EDIT_CONTACT\' | translate }}</md-tooltip></i></div></div></div></div></div><div \nclass=\"white-bg padding-15\"><div><div class=\"detailmain\"><div class=\"title\" layout=\"row\" layout-align=\"start center\" \nlayout-wrap><span>{{vm.reservation_customer.first_name}} {{vm.reservation_customer.last_name}}</span> <span \nclass=\"customer-stay-card__tag-pill\" ng-repeat=\"tag in vm.billingAssignedTags track by $index\" ng-if=\"$index < 3\" \nng-style=\"vm.getCustomerTagStyle(tag.colour_code)\" style=\"margin-left:6px\">{{tag.name}} </span><span \nclass=\"customer-stay-card__tag-pill\" ng-if=\"vm.billingAssignedTags.length > 3\" style=\"margin-left:6px\">\n+{{vm.billingAssignedTags.length - 3}} </span><button class=\"customer-tag-action-btn\" \nng-if=\"vm.billingAssignedTags.length > 0\" ng-click=\"vm.openBillingTags($event)\" style=\"margin-left:6px\">Edit Tags\n</button> <button class=\"customer-tag-action-btn customer-tag-action-btn--add\" \nng-if=\"vm.billingAssignedTags.length == 0\" ng-click=\"vm.openBillingTags($event)\" style=\"margin-left:6px\">Add Tags\n</button></div><div class=\"address\"><span>Address</span>: {{vm.reservation_customer.address}}</div><div class=\"city\">\n<span>City</span>: {{vm.reservation_customer.city}}</div><div class=\"state\"><span>State</span>\n: {{vm.reservation_customer.state}}</div><div class=\"zip_code\"><span>Zip code</span>\n: {{vm.reservation_customer.zip_code}}</div><div class=\"country\"><span>Country</span>\n: {{vm.reservation_customer.country}}</div><div class=\"phone\"><span>Phone</span>: <a \nhref=\"tel:{{vm.phoneDisplay.customer_phone}}\">{{vm.formatPhoneNumber(vm.phoneDisplay.customer_phone)}}</a></div><div \nclass=\"phone\" ng-if=\"vm.phoneDisplay.customer_secondary_phone\"><span>Secondary phone</span>: <a \nhref=\"tel:{{vm.phoneDisplay.customer_secondary_phone}}\">\n{{vm.formatPhoneNumber(vm.phoneDisplay.customer_secondary_phone)}}</a></div><div class=\"email\"><span>Email</span>: <a \nhref=\"mailto:{{vm.reservation_customer.customer_email}}\">{{vm.reservation_customer.customer_email}}</a></div></div>\n</div></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"myCustomer\"><md-dialog \nclass=\"tax-dialog tax-dialog-new1 act-dialog addcusform\"><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"row\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Billing Information</span><md-button class=\"md-icon-button\" \nng-class=\"vm.modify_request ? \'canceled_order\' : \'\'\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-height:1000px\" class=\"dilog-lable\"><md-content class=\"md-padding no-margin\"><div \nclass=\"display-inline-block role-list-out white-bg top-sp-main no-margin\"><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center \"><md-input-container class=\"md-block no-margin\"><input \nng-model=\"vm.reservation_customer.customer_id\" name=\"customer_id\" type=\"hidden\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"CREATE_RES.CUST_FN\"></label><input ng-model=\"vm.reservation_customer.first_name\" \nng-change=\"vm.updateCustomer(\'first_name\', \'\', \'customer\')\" name=\"reservation_customer_fn\" type=\"text\" \nng-model-options=\"{debounce: 400}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block\"><label translate=\"CREATE_RES.CUST_LN\"></label><input \nng-model=\"vm.reservation_customer.last_name\" name=\"reservation_customer_ln\" \nng-change=\"vm.updateCustomer(\'last_name\', \'\', \'customer\')\" type=\"text\" ng-model-options=\"{debounce: 400}\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center \"><md-input-container class=\"md-block\" style=\"margin-bottom:0px\"><label \ntranslate=\"CREATE_RES.CUST_EMAIL\"></label><input ng-model=\"vm.reservation_customer.customer_email\" \nname=\"reservation_customer_email\" type=\"text\" \nng-blur=\"vm.saveEmailCustomer(vm.reservation_customer.customer_id,vm.reservation_customer.customer_email,\'customer\')\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block\" style=\"margin-bottom:0px\"><label translate=\"CREATE_RES.CUST_CONT_NO\" \nclass=\"phone-number-label\"></label><input ng-model=\"vm.reservation_customer.phone_number\" \nng-change=\"vm.updatePhoneWithCountryCode(\'reservation_phone_number\', $event); vm.updateCustomer(\'phone_number\', \'\', \'customer\');\" \nname=\"reservation_phone_number\" class=\"intel-number-input\" intl-tel-input type=\"text\" \nng-model-options=\"{debounce: 800}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div>\n<div layout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"50\" layout-align=\"center start\"><md-switch ng-model=\"vm.reservation_customer.send_email_indicator\" \naria-label=\"Switch 1\" \nng-change=\"vm.updateEmailSatus(vm.reservation_customer.customer_id,vm.reservation_customer.send_email_indicator,\'customer\')\" \nclass=\"mt-0 mb-20\">{{ vm.reservation_customer.send_email_indicator?\'Send email\':\'Do not send email\'}}</md-switch></div>\n<div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"50\" layout-align=\"center start\"><div \nclass=\"switch-block-outer\"><md-switch ng-model=\"vm.order.customerTaxExempt\" aria-label=\"Switch 1\" \nng-change=\"vm.updateTaxExemptStatus(\'customerTaxExempt\', \'\', \'customer\')\" class=\"mt-0 mb-20\" \nng-disabled=\"vm.taxExemptRequest\">\n{{ vm.order.customerTaxExempt ? \'Customer is tax exempt\' : \'Customer in not tax emempt\'}}</md-switch><div \nclass=\"progress-bar-main-overlay\" ng-if=\"vm.taxExemptRequest\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\" md-diameter=\"20px\"></md-progress-circular></div></div></div></div><div layout=\"row\" \nflex=\"100\" layout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block\"><label \ntranslate=\"CREATE_RES.CUST_SEC_CONT_NO\" class=\"phone-number-label\"></label><input \nng-model=\"vm.reservation_customer.secondary_phone_number\" \nng-change=\"vm.updatePhoneWithCountryCode(\'reservation_secondary_phone_number\', $event); vm.updateCustomer(\'secondary_phone_number\', \'\', \'customer\');\" \nname=\"reservation_secondary_phone_number\" class=\"intel-number-input\" intl-tel-input type=\"text\" \nng-model-options=\"{debounce: 800}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-gt-xs=\"50\" flex=\"100\" layout-align=\"center \">\n<md-input-container class=\"md-block margin-bottom-0\"><label translate=\"CREATE_RES.CUST_ADD\"></label><input \nng-model=\"vm.reservation_customer.address\" ng-change=\"vm.updateCustomer(\'address\', \'\', \'customer\')\" \nname=\"reservation_address\" type=\"text\" ng-model-options=\"{debounce: 400}\" id=\"autocomplete\" autocomplete=\"off\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center \"><md-input-container class=\"md-block margin-bottom-0\"><label translate=\"CREATE_RES.CUST_CITY\">\n</label><input ng-model=\"vm.reservation_customer.city\" name=\"reservation_customer_city\" type=\"text\" \nng-change=\"vm.updateCustomer(\'city\', \'\', \'customer\')\" ng-model-options=\"{debounce: 400}\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block margin-bottom-0\"><md-autocomplete\n ng-disabled=\"vm.isStateDisabled\" md-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedState\" \nmd-search-text-change=\"vm.searchState(vm.searchTxtState)\" md-search-text=\"vm.searchTxtState\" \nmd-selected-item-change=\"vm.selectedItemChangeState(item)\" md-items=\"item in vm.queryStateSearch(vm.searchTxtState)\" \nmd-item-text=\"item.name\" md-min-length=\"0\" md-floating-label=\"State\"><md-item-template><span \nmd-highlight-text=\"vm.searchTxtState\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>\n{{ vm.searchTxtCountry.length > 0? \'No states matching \'+vm.searchTxtState+\' were found.\' : \'Please select country first\'}}\n</md-not-found></md-autocomplete></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center \"><md-input-container class=\"md-block margin-bottom-0\"><label \ntranslate=\"CREATE_RES.CUST_ZIP_CODE\"></label><input ng-model=\"vm.reservation_customer.zip_code\" \nng-change=\"vm.updateCustomer(\'zip_code\', \'\', \'customer\')\" name=\"reservation_zip_code\" type=\"text\" id=\"autocompletezip\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\" ng-model-options=\"{debounce: 400}\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block margin-bottom-0\"><md-autocomplete ng-disabled=\"vm.isCountryDisabled\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedCountry\" \nmd-search-text-change=\"vm.searchCountry(vm.searchTxtCountry)\" md-search-text=\"vm.searchTxtCountry\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-items=\"item in vm.queryCountrySearch(vm.searchTxtCountry)\" \nmd-item-text=\"item.display\" md-min-length=\"0\" md-floating-label=\"Country\" md-require-match class=\"full-width\">\n<md-item-template><span md-highlight-text=\"vm.searchTxtCountry\" md-highlight-flags=\"^i\">{{item.display}}</span>\n</md-item-template><md-not-found>No country matching \"{{vm.searchTxtCountry}}\" were found.</md-not-found>\n</md-autocomplete></md-input-container></div></div><div class=\"row-col\" flex=\"100\" layout=\"column\" \nlayout-align=\"start start\"><md-input-container \nclass=\"md-block tax-inputs padding-right-10 padding-left-10 padding-bottom-20\" flex-gt-xs=\"100\" \nng-hide=\"vm.pageType == \'boat\'\"><md-checkbox ng-change=\"vm.updateTravellerSameAsCustomer()\" \nng-model=\"vm.travelCustSame\" aria-label=\"select traveller\" class=\"md-align-top-left no-margin\" flex><span \nclass=\"ipsum\">Traveller same as customer</span></md-checkbox></md-input-container></div></div></md-content>\n</md-dialog-content></md-dialog></div></div></div></div><div layout=\"column\" class=\"halfblockinfo\" \nng-class=\"vm.order.currentBilling == \'traveller\' && !vm.order.customerTravelSame ? \'current-billing\' : \'\'\" \nng-if=\"vm.order.type_of_reservation == \'reservation\' || vm.order.type_of_reservation == \'rent\' || vm.order.type_of_reservation == \'day_reservation\'\">\n<div class=\"section-right-genral role-list-out featured-rol-block\" style=\"padding:0px\"><div \nclass=\"roomName ph-15 pb-10\" layout=\"row\" flex><div class=\"room-col\" layout=\"column\" flex=\"100\"><div layout=\"row\" flex \nlayout-wrap><div layout=\"column\" flex=\"100\" layout-align=\"center start\"><div class=\"row-containerstaus\"><strong \nng-click=\"vm.changeBillingOption(\'traveller\')\"><img \nng-if=\"vm.order.currentBilling == \'traveller\' && !vm.order.customerTravelSame\" class=\"bill-customer\" \nsrc=\"assets/images/bill.svg\"> {{ \'CREATE_RES.TRAVEL_INFO\' | translate }}<p class=\"default-bill\" \nng-if=\"vm.order.currentBilling == \'traveller\' && !vm.order.customerTravelSame\">(default billing)</p></strong><i \nng-class=\"vm.modify_request ? \'canceled_order\' : \'\'\" \nclass=\"icon-account-multiple-plus s30 onlycursorPointer onlyFloatRight white-fg\" \nng-click=\"vm.triggerdiv($event, \'Traveller\')\"><md-tooltip>{{ \'CONTACTS.EDIT_CONTACT\' | translate }}</md-tooltip></i>\n</div></div></div></div></div><div class=\"white-bg padding-15\"><div><div class=\"detailmain\"><div class=\"title\" \nlayout=\"row\" layout-align=\"start center\" layout-wrap><span>{{vm.order.first_name}} {{vm.order.last_name}}</span> <span \nclass=\"customer-stay-card__tag-pill\" ng-repeat=\"tag in vm.travellerAssignedTags track by $index\" ng-if=\"$index < 3\" \nng-style=\"vm.getCustomerTagStyle(tag.colour_code)\" style=\"margin-left:6px\">{{tag.name}} </span><span \nclass=\"customer-stay-card__tag-pill\" ng-if=\"vm.travellerAssignedTags.length > 3\" style=\"margin-left:6px\">\n+{{vm.travellerAssignedTags.length - 3}} </span><button class=\"customer-tag-action-btn\" \nng-if=\"vm.travellerAssignedTags.length > 0\" ng-click=\"vm.openTravellerTags($event)\" style=\"margin-left:6px\">Edit Tags\n</button> <button class=\"customer-tag-action-btn customer-tag-action-btn--add\" \nng-if=\"vm.travellerAssignedTags.length == 0\" ng-click=\"vm.openTravellerTags($event)\" style=\"margin-left:6px\">Add Tags\n</button></div><div class=\"address\"><span>Address</span>: {{vm.order.address}}</div><div class=\"city\"><span>City</span>\n: {{vm.order.city}}</div><div class=\"state\"><span>State</span>: {{vm.order.state}}</div><div class=\"zip_code\"><span>\nZip code</span>: {{vm.order.zip_code}}</div><div class=\"country\"><span>Country</span>: {{vm.order.country}}</div><div \nclass=\"phone\"><span>Phone</span>: <a href=\"tel:{{vm.phoneDisplay.traveller_phone}}\">\n{{vm.formatPhoneNumber(vm.phoneDisplay.traveller_phone)}}</a></div><div class=\"phone\" \nng-if=\"vm.phoneDisplay.traveller_secondary_phone\"><span>Secondary phone</span>: <a \nhref=\"tel:{{vm.phoneDisplay.traveller_secondary_phone}}\">\n{{vm.formatPhoneNumber(vm.phoneDisplay.traveller_secondary_phone)}}</a></div><div class=\"email\"><span>Email</span>: <a \nhref=\"mailto:{{vm.order.customer_email}}\">{{vm.order.customer_email}}</a></div></div></div></div><div \nstyle=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"myTraveller\"><md-dialog \nclass=\"tax-dialog tax-dialog-new1 act-dialog addcusform\"><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"row\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Traveler Information</span><md-button class=\"md-icon-button\" \nng-class=\"vm.modify_request ? \'canceled_order\' : \'\'\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-height:1000px\" class=\"dilog-lable\"><md-content class=\"md-padding no-margin\"><div \nclass=\"display-inline-block role-list-out white-bg top-sp-main no-margin\"><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center \"><md-input-container class=\"md-block no-margin\"><input ng-model=\"vm.order.customer_id\" \nname=\"customer_id[vm.selectedIndex]\" type=\"hidden\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"CREATE_RES.CUST_FN\"></label><input \nng-model=\"vm.order.first_name\" name=\"customer_fn[vm.selectedIndex]\" type=\"text\" \nng-change=\"vm.updateCustomer(\'first_name\', vm.order.confirmation_number, \'traveller\')\" \nng-model-options=\"{debounce: 400}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block margin-bottom-0\"><label translate=\"CREATE_RES.CUST_LN\"></label><input \nng-model=\"vm.order.last_name\" name=\"customer_ln[vm.selectedIndex]\" type=\"text\" \nng-change=\"vm.updateCustomer(\'last_name\', vm.order.confirmation_number, \'traveller\')\" \nng-model-options=\"{debounce: 400}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div>\n<div layout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block\" style=\"margin-bottom:0px\"><label\n translate=\"CREATE_RES.CUST_EMAIL\"></label><input ng-model=\"vm.order.customer_email\" \nname=\"customer_email[vm.selectedIndex]\" type=\"text\" \nng-blur=\"vm.saveEmailCustomer(vm.order.customer_id,vm.order.customer_email,\'traveler\')\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block\" style=\"margin-bottom:0px\"><label\n translate=\"CREATE_RES.CUST_CONT_NO\" class=\"phone-number-label\"></label><input ng-model=\"vm.order.phone_number\" \nname=\"phone_number[vm.selectedIndex]\" type=\"tel\" class=\"intel-number-input\" intl-tel-input \nng-change=\"vm.updatePhoneWithCountryCode(\'phone_number[vm.selectedIndex]\', $event); vm.updateCustomer(\'phone_number\', vm.order.confirmation_number, \'traveller\');\" \nng-model-options=\"{debounce: 800}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div>\n<div layout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"50\" flex-gt-xs=\"50\" layout-align=\"center start \"><md-switch ng-model=\"vm.order.send_email_indicator\" \naria-label=\"Switch 1\" ng-change=\"vm.updateEmailSatus(vm.order.customer_id,vm.order.send_email_indicator, \'traveller\')\" \nclass=\"mt-0 mb-20\">{{vm.order.send_email_indicator?\'Send email\':\'Do not send email\'}}</md-switch></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"50\" layout-align=\"center start\" \nng-if=\"!vm.order.customerTravelSame\"><md-switch ng-model=\"vm.order.travellerTaxExempt\" aria-label=\"Switch 1\" \nng-change=\"vm.updateTaxExemptStatus(\'travellerTaxExempt\', vm.order.confirmation_number, \'traveller\')\" \nclass=\"mt-0 mb-20\" ng-disabled=\"vm.taxExemptRequest\">\n{{ vm.order.travellerTaxExempt ? \'Traveller is tax exempt\' : \'Traveller is not tax emempt\'}}</md-switch></div></div>\n<div layout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block\"><label \ntranslate=\"CREATE_RES.CUST_SEC_CONT_NO\" class=\"phone-number-label\"></label><input \nng-model=\"vm.order.secondary_phone_number\" name=\"secondary_phone_number[vm.selectedIndex]\" type=\"tel\" \nclass=\"intel-number-input\" intl-tel-input \nng-change=\"vm.updatePhoneWithCountryCode(\'secondary_phone_number[vm.selectedIndex]\', $event); vm.updateCustomer(\'secondary_phone_number\', vm.order.confirmation_number, \'traveller\');\" \nng-model-options=\"{debounce: 400}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block margin-bottom-0\"><label translate=\"CREATE_RES.CUST_ADD\"></label><input \nng-model=\"vm.order.address\" name=\"address[vm.selectedIndex]\" type=\"text\" \nng-change=\"vm.updateCustomer(\'address\', vm.order.confirmation_number, \'traveller\')\" ng-model-options=\"{debounce: 800}\" \nid=\"autocompleteTraveller\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block margin-bottom-0\"><label \ntranslate=\"CREATE_RES.CUST_CITY\"></label><input ng-model=\"vm.order.city\" name=\"city[vm.selectedIndex]\" type=\"text\" \nng-change=\"vm.updateCustomer(\'city\', vm.order.confirmation_number, \'traveller\')\" ng-model-options=\"{debounce: 400}\" \nng-model-options=\"{debounce: 400}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block margin-bottom-0\"><md-autocomplete ng-disabled=\"vm.isStateDisabled\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedStateForTraveller\" \nmd-search-text-change=\"vm.searchStateForTraveller(vm.searchTxtStateForTraveller)\" \nmd-search-text=\"vm.searchTxtStateForTraveller\" md-selected-item-change=\"vm.selectedItemChangeStateForTraveller(item)\" \nmd-items=\"item in vm.queryStateSearchForTraveller(vm.searchTxtStateForTraveller)\" md-item-text=\"item.name\" \nmd-min-length=\"0\" md-floating-label=\"State\"><md-item-template><span md-highlight-text=\"vm.searchTxtStateForTraveller\" \nmd-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>\n{{ vm.searchTxtCountry.length > 0? \'No states matching \'+vm.searchTxtState+\' were found.\' : \'Please select country first\'}}\n</md-not-found></md-autocomplete></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center \"><md-input-container class=\"md-block margin-bottom-0\"><label \ntranslate=\"CREATE_RES.CUST_ZIP_CODE\"></label><input ng-model=\"vm.order.zip_code\" name=\"reservation_zip_code\" \ntype=\"text\" ng-change=\"vm.updateCustomer(\'zip_code\', vm.order.confirmation_number)\" ng-model-options=\"{debounce: 400}\" \nid=\"autocompletezipTraveller\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block margin-bottom-0\"><md-autocomplete ng-disabled=\"vm.isCountryDisabled\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedCountryForTraveller\" \nmd-search-text-change=\"vm.searchCountry(vm.searchTxtCountryForTraveller)\" \nmd-search-text=\"vm.searchTxtCountryForTraveller\" md-selected-item-change=\"vm.selectedItemChangeForTraveller(item)\" \nmd-items=\"item in vm.queryCountrySearch(vm.searchTxtCountryForTraveller)\" md-item-text=\"item.display\" \nmd-min-length=\"0\" md-floating-label=\"Country\" md-require-match class=\"full-width\"><md-item-template><span \nmd-highlight-text=\"vm.searchTxtCountryForTraveller\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template>\n<md-not-found>No country matching \"{{vm.searchTxtCountryForTraveller}}\" were found.</md-not-found></md-autocomplete>\n</md-input-container></div></div></div></md-content></md-dialog-content></md-dialog></div></div></div></div><div \nlayout=\"column\" class=\"halfblockinfo\" layout-align=\"start start\" ng-if=\"vm.order.type_of_reservation == \'boat\'\"><div \nclass=\"full-width\"><div class=\"section-right-genral role-list-out featured-rol-block no-padding\"><div \nclass=\"roomName font-sizeroom ph-15 pv-10\"><strong>{{ \'CREATE_RES.VESSEL_INFO\' | translate }} </strong><i \nng-class=\"vm.modify_request ? \'canceled_order\' : \'\'\" \nclass=\"icon-account-multiple-plus s30 onlycursorPointer onlyFloatRight white-fg\" \nng-click=\"vm.triggerdiv($event, \'Boat\')\"><md-tooltip>{{ \'CONTACTS.EDIT_VESSEL\' | translate }}</md-tooltip></i></div>\n<div class=\"white-bg padding-15\"><div><div class=\"detailmain\"><div class=\"address\"><span>Vessel type</span>\n: {{vm.boatData.boat_type}}</div><div class=\"phone\"><span>Vessel name</span>: {{vm.boatData.boat_name}}</div><div \nclass=\"city\"><span>Vessel model</span>: {{vm.boatData.boat_model}}</div><div class=\"city\"><span>Vessel make</span>\n: {{vm.boatData.boat_make}}</div><div class=\"state\"><span>Vessel length</span>: {{vm.boatData.boat_length}}</div><div \nclass=\"zip_code\"><span>Beam</span>: {{vm.boatData.beam}}</div><div class=\"country\"><span>Draft</span>\n: {{vm.boatData.draft}}</div></div></div></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" \nid=\"myBoat\"><md-dialog class=\"tax-dialog tax-dialog-new1 act-dialog addcusform\"><md-toolbar \nclass=\"md-accent md-tall white-fg\" layout=\"row\"><div class=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Vessel Information</span><md-button \nclass=\"md-icon-button\" ng-class=\"vm.modify_request?\'canceled_order\':\'\'\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"max-height:1000px\" class=\"dilog-lable\"><md-content class=\"md-padding no-margin\">\n<div class=\"display-inline-block role-list-out white-bg top-sp-main no-margin\"><div layout=\"row\" flex=\"100\" \nlayout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center \" style=\"margin-bottom: 23px\"><md-input-container class=\"md-block tax-inputs full-width\"><label \nclass=\"ng-scope\" role=\"button\" translate=\"ADD_BOAT_DATA.BOAT_TYPE\"></label><md-select required \nplaceholder=\"Vessel Type\" ng-model=\"vm.boatData.boat_type\" class=\"\" \nng-change=\"vm.updateReservationValues(vm.order.confirmation_number,\'boat_data\',vm.boatData)\"><md-option \nng-value=\"boat.value\" ng-repeat=\"boat in vm.boatType\">{{boat.name}}</md-option></md-select></md-input-container></div>\n<div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"ADD_BOAT_DATA.BOAT_NAME\"></label><input type=\"text\" name=\"boat_name\" ng-model=\"vm.boatData.boat_name\" \naria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" ui-options=\"{addDefaultPlaceholder:false}\" \nng-change=\"vm.updateReservationValues(vm.order.confirmation_number,\'boat_data\',vm.boatData)\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"><div ng-messages=\"contactForm.boat_name.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span translate=\"ADD_BOAT_DATA.VALID_PHONE\"></span></div></div></md-input-container></div></div>\n<div layout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block tax-inputs full-width\"><label \nclass=\"ng-scope\" role=\"button\" translate=\"ADD_BOAT_DATA.BOAT_MODEL\"></label><input type=\"text\" name=\"boat_model\" \nng-model=\"vm.boatData.boat_model\" aria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" \nng-change=\"vm.updateReservationValues(vm.order.confirmation_number,\'boat_data\',vm.boatData)\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"><div ng-messages=\"contactForm.boat_model.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span translate=\"ADD_BOAT_DATA.VALID_PHONE\"></span></div></div></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center\">\n<md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"ADD_BOAT_DATA.BOAT_MAKE\"></label><input type=\"text\" name=\"boat_make\" ng-model=\"vm.boatData.boat_make\" \naria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" ui-options=\"{addDefaultPlaceholder:false}\" \nng-change=\"vm.updateReservationValues(vm.order.confirmation_number,\'boat_data\',vm.boatData)\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"><div ng-messages=\"contactForm.boat_make.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span translate=\"ADD_BOAT_DATA.VALID_PHONE\"></span></div></div></md-input-container></div></div>\n<div layout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block tax-inputs full-width\"><label \nclass=\"ng-scope\" role=\"button\" translate=\"ADD_BOAT_DATA.BOAT_LENGTH\"></label><input ng-model=\"vm.boatData.boat_length\" \ntype=\"text\" name=\"boat_length\" ng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\" \nng-change=\"vm.updateReservationValues(vm.order.confirmation_number,\'boat_data\',vm.boatData)\" \nallow-vm.boat_data-numbers></md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block tax-inputs full-width\"><label \nclass=\"ng-scope\" role=\"button\" translate=\"ADD_BOAT_DATA.BOAT_BEAM\"></label><input ng-model=\"vm.boatData.beam\" \ntype=\"text\" name=\"beam\" ng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\" \nng-change=\"vm.updateReservationValues(vm.order.confirmation_number,\'boat_data\',vm.boatData)\" allow-only-numbers>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\"><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"ADD_BOAT_DATA.BOAT_DRAFT\"></label><input ng-model=\"vm.boatData.draft\" type=\"text\" name=\"draft\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\" \nng-change=\"vm.updateReservationValues(vm.order.confirmation_number,\'boat_data\',vm.boatData)\" allow-only-numbers>\n</md-input-container></div></div></div></md-content></md-dialog-content></md-dialog></div></div><div \nclass=\"display-inline-block1 role-list-out1 white-bg top-sp-main no-padding no-margin\"><div layout=\"row\" flex=\"100\" \nlayout-wrap></div></div></div></div></div></div></div></div><div layout=\"row\" layout-wrap flex=\"100\" class=\"mt-20\"><div\n layout=\"column\" flex=\"100\" flex-sm=\"100\" flex-xs=\"100\"><div class=\"left-section-genral-infomation\"><div \nclass=\"genereal-div\"><div \nclass=\"role-list-out white-bg relative-block featured-block-main no-padding featured-rol-block\"><div \nng-class=\"\'roomName\'+vm.order.show_status+\' ph-15 pv-10\'\" layout=\"row\" flex \nng-if=\"vm.roomCount > 0 && !vm.isPassOnlyDayShell()\"><div class=\"room-col\" layout=\"column\" flex=\"100\"><div \nlayout=\"row\" flex layout-wrap><div layout=\"column\" flex-gt-md=\"55\" flex-gt-xs=\"50\" flex-sm-xs=\"50\" flex=\"100\" \nlayout-align=\"center start\"><div class=\"row-containerstaus\"><strong>{{vm.order.product_name}}<span \nng-if=\"vm.order.type_of_reservation == \'day_reservation\' && vm.order.product_name.indexOf(\'Day Room\') === -1\">\n (Day Room)</span></strong><div class=\"fromToInfo\" \nng-class=\"vm.order.show_status == \'Canceled\' || vm.order.show_status == \'No Show\' || vm.modify_request?\'canceled_order\':\'\'\">\n<div class=\"fromInfo\"><img src=\"assets/images/ecommerce/from.svg\">{{vm.order.room_stay_from}}</div><div class=\"toInfo\" \nng-if=\"vm.order.type_of_reservation != \'day_reservation\' && vm.order.room_stay_from != vm.order.room_stay_to\"><img \nsrc=\"assets/images/ecommerce/to.svg\"> {{vm.order.room_stay_to}}</div></div><div class=\"room_move_text\">\n{{vm.order.confirmation_number}}</div></div></div><div layout=\"column\" flex-gt-md=\"45\" flex-gt-xs=\"50\" flex=\"100\" \nflex-gt-sm=\"50\" layout-align=\"center end\" class=\"pr-0\"><div class=\"wrapactions\"><div class=\"cc-fee-toggle\" \nstyle=\"pointer-events:auto\" \nng-if=\"vm.isCcProcessingFeeApplicable(vm.order) && (vm.order.show_status || \'\').toLowerCase() != \'canceled\' && (vm.order.room_stay_status || \'\').toLowerCase() != \'canceled\'\">\n<md-checkbox class=\"no-margin\" ng-model=\"vm.removeCcProcessingFeeRoom\" ng-disabled=\"vm.ccProcessingFeeRemovingRoom\" \nng-change=\"vm.toggleRemoveCcProcessingFee(\'room\', null, vm.order.confirmation_number)\">\n{{ vm.removeCcProcessingFeeRoom ? \'CC processing fee removed.\' : \'Remove CC processing fee\' }}</md-checkbox>\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.ccProcessingFeeRemovingRoom\"></md-progress-circular></div><div class=\"input-block-status\">\n<md-input-container class=\"md-block mb-0 no-margin\"><md-select placeholder=\"status\" ng-model=\"vm.room_stay_status\" \nng-init=\"vm.room_stay_status=vm.getDisplayStatus(vm.order)\" \nng-change=\"vm.changeStatus(event,vm.selectedIndex,vm.order.room_stay_id,vm.order.confirmation_number,vm.getDisplayStatus(vm.order),vm.room_stay_status,vm.order.overalltotals.remaining_amount,vm.order.overalltotals.paid_amount,vm.order.policy_id,vm.order.room_stay_from,vm.order.first_name,vm.order.customer_email,vm.order.total_amount)\">\n<md-option ng-value=\"key\" ng-repeat=\"(key, value) in vm.statuses\">{{value}}</md-option></md-select>\n</md-input-container></div><div class=\"mdmenusRoomWise\"><md-icon md-font-icon=\"icon-message-text\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer\" ng-click=\"vm.messageGuest(vm.order.confirmation_number)\" \nng-if=\"vm.canMessageGuest() && vm.order.confirmation_number && vm.roomCount > 0 && vm.room_stay_status != \'Canceled\'\">\n<md-tooltip>{{\'CREATE_RES.MESSAGE_CENTER\' | translate}}</md-tooltip></md-icon><md-icon md-font-icon=\"icon-email\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer\" \nng-click=\"vm.sendorderinvoice(vm.order.confirmation_number)\" ng-if=\"vm.tabs_data.length > 1\"><md-tooltip>\n{{\'CREATE_RES.SEND_INVOICE\' | translate}}</md-tooltip></md-icon><md-icon md-font-icon=\"icon-printer\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer\" \nng-click=\"vm.printorderinvoice(vm.order.confirmation_number)\" \nng-if=\"vm.tabs_data.length > 1 && vm.room_stay_status != \'Canceled\'\"><md-tooltip>{{\'CREATE_RES.PRINT\' | translate}}\n</md-tooltip></md-icon><md-icon ng-if=\"vm.room_stay_status != \'Canceled\'\" \nmd-svg-src=\"assets/angular-material-assets/img/icons/room-service.svg\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer\" ng-click=\"vm.gotoCheckoutFromEditOrder()\"><md-tooltip>\n{{\'CREATE_RES.ADD_SERVICE\' | translate}}</md-tooltip></md-icon><md-icon \nng-if=\"vm.parking_access && vm.room_stay_status != \'Canceled\'\" md-font-icon=\"icon-parking\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer\" \nng-click=\"vm.addParking(event,vm.order.room_stay_from,vm.order.room_stay_to,vm.order.confirmation_number)\"><md-tooltip>\n{{\'CREATE_RES.ADD_PARKING\' | translate}}</md-tooltip></md-icon><md-icon \nng-if=\"vm.order.type_of_reservation == \'boat\' && vm.room_stay_status != \'Canceled\'\" md-font-icon=\"icon-parking\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer\" \nng-click=\"vm.addBoatPos(event,vm.order.room_stay_from,vm.order.room_stay_to,vm.order.confirmation_number)\"><md-tooltip>\n{{\'CREATE_RES.ADD_BOAT\' | translate}}</md-tooltip></md-icon><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/boarding-pass.svg\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer\" ng-click=\"vm.printRegistrationCard()\" \nng-if=\"vm.print_registration && vm.roomCount > 0 && vm.room_stay_status != \'Canceled\'\"><md-tooltip>\nPrint Registration Card</md-tooltip></md-icon><span class=\"order-towel-icon-wrap onlycursorPointer\" \nng-if=\"vm.roomCount > 0 && (vm.order.type_of_reservation == \'reservation\' || vm.order.type_of_reservation == \'rent\') && vm.isBorrowedItemsEnabled()\" \nng-click=\"vm.openBorrowedItems($event)\"><img src=\"assets/icons/borrowed.svg\" alt=\"Borrowed Items\" \nclass=\"order-towel-icon\"> <span class=\"order-towel-count\" ng-if=\"(vm.order.borrowed_count || 0) > 0\">\n{{vm.order.borrowed_count}}</span><md-tooltip>Borrowed Items</md-tooltip></span><md-icon ng-click=\"vm.getOTADetails()\" \nmd-font-icon=\"icon-wallet-travel\" class=\"white-fg close-icon1 font-size-12 onlycursorPointer\" \nng-if=\"vm.superAdmin && vm.order.type_of_reservation != \'boat\' && vm.order.type_of_reservation != \'rent\'\"><md-tooltip>\nLink To OTA</md-tooltip></md-icon><md-icon ng-if=\"vm.canShowPrecheckinIcon()\" \nmd-svg-src=\"assets/angular-material-assets/img/icons/pre-checkin-email.svg\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer\" ng-click=\"vm.openPrecheckinDialog($event)\"><md-tooltip>\n{{\'CREATE_RES.SEND_PRECHECKIN_LINK\' | translate}}</md-tooltip></md-icon></div></div></div></div></div></div><div \nclass=\"display-inline-block scroll-sm-blk-311\"><div class=\"room-detail-block\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"!vm.isPassOnlyDayShell() && vm.roomCount > 0 &&  (vm.order.type_of_reservation == \'reservation\' || vm.order.type_of_reservation == \'rent\' || vm.order.type_of_reservation == \'day_reservation\')\">\n<div class=\"R-D-col-left padding-20\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.order.type_of_reservation != \'rent\'\"><div class=\"adlt-child-block ph-10\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"33\" layout-align=\"start start\"><div class=\"full-width\"><div class=\"sm-section-aldult\"><div \nclass=\"arrival-am-txt\">Adult</div><div class=\"adult-input-block\"><md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.order.show_status == \'No Show\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"md-block mb-0 no-margin\"><md-select required ng-model-options=\"{debounce: 400}\" \nng-change=\"vm.manageAdultChild(\'adult\');vm.setShowModifyBtn(\'Adults\',\'room_stay_guest_count\',vm.order.room_stay_id);vm.setAdults()\" \nng-model=\"vm.order.room_stay_guest_count\" name=\"adults[vm.selectedIndex]\"><md-option ng-value=\"n\" \nng-repeat=\"n in vm.adultRange\">{{n}}</md-option></md-select></md-input-container></div></div><div \nclass=\"sm-section-aldult\"><div class=\"arrival-am-txt\">Child</div><div class=\"adult-input-block\"><md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.order.show_status == \'No Show\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"md-block mb-0 no-margin\"><md-select required placeholder=\"Children\" ng-model-options=\"{debounce: 400}\" \nng-change=\"vm.manageAdultChild(\'child\');vm.setShowModifyBtn(\'Children\',\'room_stay_child_count\',vm.order.room_stay_id);vm.setAdults();\" \nng-model=\"vm.order.room_stay_child_count\" name=\"child[vm.selectedIndex]\"><md-option ng-value=\"i\" \nng-repeat=\"i in vm.childRange\">{{i}}</md-option></md-select></md-input-container></div></div></div></div><div \nclass=\"adlt-child-block ph-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" layout-align=\"start start\">\n<div class=\"full-width\"><div class=\"sm-section-aldult\"><div class=\"arrival-am-txt\" translate=\"CREATE_RES.ARRIVAL_TIME\">\nArrival time</div><div class=\"adult-input-block no-margin\"><md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.order.show_status == \'No Show\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"md-block mb-0 no-margin\"><md-select ng-model=\"vm.order.arrival_time\" ng-model-options=\"{debounce: 400}\" \nng-change=\"vm.setShowModifyBtn(\'Arrival time\',\'arrival_time\',vm.order.room_stay_id, \'date\');vm.updateReservationValues(vm.order.confirmation_number,\'arrival_time\',vm.order.arrival_time)\">\n<md-option ng-value=\"key\" ng-repeat=\"(key,arrival_dep) in vm.arrival_departure_time\">{{arrival_dep}}</md-option>\n</md-select><div class=\"md-errors-spacer\"></div></md-input-container></div></div><div class=\"sm-section-aldult\"><div \nclass=\"arrival-am-txt\" translate=\"CREATE_RES.DEPARTURE_TIME\">Departure time</div><div \nclass=\"adult-input-block no-margin\"><md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.order.show_status == \'No Show\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"md-block no-margin\"><md-select ng-model=\"vm.order.departure_time\" ng-model-options=\"{debounce: 400}\" \nng-change=\"vm.setShowModifyBtn(\'Departure time\',\'departure_time\',vm.order.room_stay_id, \'date\');vm.updateReservationValues(vm.order.confirmation_number,\'departure_time\',vm.order.departure_time)\">\n<md-option ng-value=\"key\" ng-repeat=\"(key,arrival_dep) in vm.arrival_departure_time\">{{arrival_dep}}</md-option>\n</md-select><div class=\"md-errors-spacer\"></div></md-input-container></div></div></div></div><div \nclass=\"adlt-child-block ph-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"33\" layout-align=\"start start\">\n<div class=\"full-width\"><div class=\"sm-section-aldult\"><md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.order.show_status == \'No Show\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"md-block mb-0 md-input-has-value mb-0\"><label translate=\"CREATE_RES.DO_NOT_MOVE\"></label><md-radio-group \nclass=\"no-margin\" ng-model=\"vm.order.room_number_locked_indicator\" ng-model-options=\"{debounce: 400}\" \nng-change=\"vm.updateReservationValues(vm.order.confirmation_number,\'room_number_locked_indicator\',vm.order.room_number_locked_indicator, vm.order.room_number_locked_indicator == 1\n                                          ? \'Do Not Move = Enabled\'\n                                          : \'Do Not Move = Disabled\')\">\n<md-radio-button class=\"space-block-inline\" value=\"1\">Yes</md-radio-button><md-radio-button \nclass=\"space-block-inline margin-left-30\" value=\"0\">No</md-radio-button></md-radio-group></md-input-container></div>\n</div></div></div></div><div class=\"lowest-price-content\" ng-if=\"vm.order.prices.dates.length > 31\"><div \nclass=\"accordian-cover\"><div class=\"accordian-row\"><div class=\"accordian-content\" \nng-repeat=\"(monthName,monthData) in vm.boatArrayFinal\"><h5 \nclass=\"accordian-title months{{monthName}} accordian-title-minus\" ng-click=\"vm.toggle(monthName,\'month\', \'boat\', \'\')\">\n<span class=\"monthname\">{{monthName}}</span> <span class=\"priceblockmain\"><span class=\"pricemaininner\"><b \nclass=\"discount\">${{vm.monthOverallTotal[monthName][\'discount\']}}</b> <small class=\"totalblk\">Discount</small> </span>\n<span class=\"pricemaininner\">${{vm.monthOverallTotal[monthName][\'price\'] }} <small class=\"totalblk\">Total </small>\n</span></span><span class=\"paidamount\"><span><b class=\"paidmain\">${{vm.PaidValues[monthName]}}</b> <small \nclass=\"totalblk\">Paid</small> </span><span><b class=\"owe\">${{vm.owesValues[monthName]}}</b> <small class=\"totalblk\">\nOwes</small></span></span></h5><div class=\"accordian-inner-content dropdown-container\" style=\"display: none\"><div \nclass=\"accordian-content weekContainer weekafter\" ng-repeat=\"(weekName,items) in monthData\"><h5 \nclass=\"accordian-title weeks{{weekName}}{{monthName}} accordian-title-minus\" \nng-click=\"vm.toggle(weekName+monthName,\'week\', \'boat\', \'\')\"><span class=\"newhtmlappend monthsblock\" \nng-bind-html=\"vm.getWeekHeaderName(items,monthName+weekName)\"></span> <span class=\"priceblockouter\"><span \nclass=\"pricemaininner\"><b class=\"discount\">${{vm.weekOverallTotal[monthName+weekName][\'discount\']}}</b> <small \nclass=\"totalblk\">Discount</small> </span><span class=\"pricemaininner\">\n${{vm.weekOverallTotal[monthName+weekName][\'price\']}} <small class=\"totalblk\">Total </small></span></span><span \nclass=\"paidamount\"><span><b class=\"paidmain\">${{vm.weekPaidValues[monthName+weekName]}}</b> <small class=\"totalblk\">\nPaid</small> </span><span><b class=\"owe\">${{vm.weekOwesValues[monthName+weekName]}}</b> <small class=\"totalblk\">Owes\n</small></span></span></h5><div class=\"accordian-inner-content dropdown-container1\" style=\"display: none\"><div \nclass=\"nightlyscrollblk\"><div class=\"scroll-nightly-inner\"><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"row-block1-amount row-header-amount\"><div layout=\"column\" flex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" \nlayout-align=\"center start\">{{vm.getStayUnitLabel()}}</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\" ng-if=\"vm.order.showOtaPmsNightsFlag\">\nSource</div><div layout=\"column\" flex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\">Date\n</div><div layout=\"column\" flex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\">Rate Plan\n</div><div layout=\"column\" flex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center end\">Discount</div>\n<div layout=\"column\" flex=\"20\" layout-align=\"center end\">Price</div></div><div layout=\"row\" \nng-repeat=\"(eachKey, eachnight) in items\" flex=\"100\" layout-wrap class=\"row-nightly-amount row-block1-amount\"><div \nlayout=\"column\" flex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\"><div \nclass=\"minusiconouter\"><div class=\"charges directOta\" \nng-if=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) < 0\">\n{{vm.getStayUnitLabel()}} {{vm.order.prices.nightcount[eachKey]}}</div><div class=\"charges strikethrough\" \nng-if=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) >= 0\">Canceled {{vm.getStayUnitLabel()}}</div><div \nng-class=\"vm.order.show_status == \'Canceled\' || vm.order.show_status == \'No Show\' || vm.modify_request?\'canceled_order\':\'\'\">\n<span \nng-class=\"vm.isloading?\'pointer_events_disabled onlycursorPointer minusiconred1\':\'onlycursorPointer minusiconred1\'\" \nng-click=\"vm.cancelThisNight(items[eachKey])\" \nng-if=\"(vm.order.prices.nightcount[eachKey]==1 || vm.order.prices.nightcount[eachKey]==vm.order.nights) && vm.order.nights>1 && vm.order.prices.canceled_nights.indexOf(items[eachKey]) < 0\">\n<md-button class=\"md-raised md-accent submit-button white-fg no-show-button\" aria-label=\"No Show\">No Show</md-button>\n</span><span \nng-class=\"vm.isloading?\'pointer_events_disabled onlycursorPointer minusiconred1\':\'onlycursorPointer minusiconred1\'\" \nng-click=\"vm.undoCancelThisNight(items[eachKey])\" \nng-if=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) >= 0 && vm.order.prices.canUndoNights.indexOf(items[eachKey]) >= 0 && (vm.order.prices.nightcancelledCount[eachKey]==1 || vm.order.prices.nightcancelledCount[eachKey]==vm.order.prices.canceled_nights.length || (vm.order.prices.nightcancelledCount[eachKey + 1 ] == -1) ||(vm.order.prices.nightcancelledCount[eachKey + 1 ] != -1))\">\n<md-button class=\"md-raised md-accent submit-button white-fg no-show-button\" aria-label=\"Undo\">Undo</md-button></span>\n</div></div></div><div layout=\"column\" flex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\" \nng-if=\"vm.order.showOtaPmsNightsFlag\"><div class=\"charges otapms\">{{vm.order.prices.otaDirectNight[eachKey]}}</div>\n</div><div layout=\"column\" flex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\"><div \nng-class=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) < 0?\'charges\':\'charges strikethrough\'\">\n{{vm.order.prices.dates[eachKey]}}</div></div><div layout=\"column\" flex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" \nlayout-align=\"center start\"><div \nng-class=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) < 0?\'charges\':\'charges strikethrough\'\">\n{{vm.order.prices.rate_plan[eachKey] ? vm.order.prices.rate_plan[eachKey] : \'---\'}}</div></div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center end\"><div class=\"amount discount\">\n<md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.order.show_status == \'No Show\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <span class=\"nightly-discount-value\" \nng-click=\"(vm.order.prices.canceled_nights.indexOf(items[eachKey]) >= 0 || vm.order.resvStrikeThrough == 1) ? \'\' : vm.opencommentboxNight(vm.selectedIndex,eachKey, \'nightly_discount\');\">\n<span class=\"nightly-discount-amount\">{{vm.order.prices.nightlydiscount[eachKey]}}</span><span \nclass=\"nightly-discount-percent\" ng-if=\"vm.order.prices.nightlydiscount[eachKey] > 0\">\n{{vm.getNightlyDiscountPercent(vm.order.prices.nightlydiscount[eachKey], vm.order.prices.rates[eachKey])}}%</span> \n</span><i ng-if=\"vm.order.prices.nightlydiscount[eachKey]>0\" \nclass=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.opencommentboxNight(vm.selectedIndex,eachKey, \'nightly_discount\');\"><md-tooltip \nng-if=\"vm.order.prices.nightlydiscountcomment[$index]!=\'\' && vm.order.promotion_applied == 0\">\n{{vm.order.prices.nightlydiscountcomment[eachKey]}}</md-tooltip><md-tooltip ng-if=\"vm.order.promotion_applied == 1\">\n{{vm.order.promoTooltip}}</md-tooltip></i></md-input-container></div></div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center end\"><div class=\"amount\"><md-input-container \nng-class=\"(vm.order.prices.canceled_nights.indexOf(items[eachKey]) >= 0 || vm.order.resvStrikeThrough == 1) && vm.order.prices.rates[$index] > 0 ? \'strikeinputbigWid\' : \'\'\" \nclass=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <input ng-model-options=\"{updateOn: \'blur\'}\" \nng-change=\"vm.setShowModifyBtn(\'Night-{{eachKey}}\',\'prices\',vm.order.room_stay_id);vm.sumNights({{eachKey}})\" \nng-model=\"vm.order.prices.rates[eachKey]\" name=\"rate_plan[vm.selectedIndex][eachKey]\" type=\"text\" \nallow-decimal-numbers autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\" \nng-disabled=\"(vm.order.prices.canceled_nights.indexOf(items[eachKey]) >= 0 || vm.order.resvStrikeThrough == 1 || vm.isloading) ? true : false\">\n</md-input-container></div></div></div></div></div></div></div></div></div></div></div></div><div \nclass=\"lowest-price-content\" ng-if=\"vm.order.prices.dates.length >= 7 && vm.order.prices.dates.length <= 31\"><div \nclass=\"accordian-cover\"><div class=\"accordian-row\"><div class=\"accordian-content onlyWeekdata\"><div \nclass=\"accordian-inner-content dropdown-container weekcontent\"><div class=\"accordian-content weekContainer\" \nng-repeat=\"(weekName,items) in  vm.boatArrayFinal\"><h5 \nclass=\"accordian-title weeks{{weekName}}{{key}} accordian-title-minus\" \nng-click=\"vm.toggle(weekName+key,\'week\', \'boat\', \'\')\"><span class=\"newhtmlappend monthsblock\" \nng-bind-html=\"vm.getWeekHeaderName(items,monthName+weekName)\"></span> <span class=\"priceblockouter\"><span \nclass=\"pricemaininner\"><b class=\"discount\">${{vm.weekOverallTotal[weekName][\'discount\']}} </b><small class=\"totalblk\">\nDiscount</small> </span><span class=\"pricemaininner\">${{vm.weekOverallTotal[weekName][\'price\']}} <small \nclass=\"totalblk\">Total</small> </span></span><span class=\"paidamount\"><span><b class=\"paidmain\">\n${{vm.weekPaidValues[monthName+weekName]}}</b> <small class=\"totalblk\">Paid</small> </span><span><b class=\"owe\">\n${{vm.weekOwesValues[monthName+weekName]}}</b> <small class=\"totalblk\">Owes</small></span></span></h5><div \nclass=\"accordian-inner-content dropdown-container1\" style=\"display: none\"><div class=\"nightlyscrollblk\"><div \nclass=\"scroll-nightly-inner\"><div layout=\"row\" flex=\"100\" layout-wrap class=\"row-block1-amount row-header-amount\"><div \nlayout=\"column\" flex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\">\n{{vm.getStayUnitLabel()}}</div><div layout=\"column\" flex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" \nlayout-align=\"center start\" ng-if=\"vm.order.showOtaPmsNightsFlag\">Source</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\">Date</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\">Rate Plan</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center end\">Discount</div><div layout=\"column\" \nflex=\"20\" layout-align=\"center end\">Price</div></div><div layout=\"row\" ng-repeat=\"(eachKey, eachnight) in items\" \nflex=\"100\" layout-wrap class=\"row-nightly-amount row-block1-amount\"><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\"><div class=\"minusiconouter\"><div \nclass=\"charges directOta\" ng-if=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) < 0\">\n{{vm.getStayUnitLabel()}} {{vm.order.prices.nightcount[eachKey]}}</div><div class=\"charges strikethrough\" \nng-if=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) >= 0\">Canceled {{vm.getStayUnitLabel()}}</div><div \nng-class=\"vm.order.show_status == \'Canceled\' || vm.order.show_status == \'No Show\' || vm.modify_request?\'canceled_order\':\'\'\">\n<span \nng-class=\"vm.isloading?\'pointer_events_disabled onlycursorPointer minusiconred1\':\'onlycursorPointer minusiconred1\'\" \nng-click=\"vm.cancelThisNight(items[eachKey])\" \nng-if=\"(vm.order.prices.nightcount[eachKey]==1 || vm.order.prices.nightcount[eachKey]==vm.order.nights) && vm.order.nights>1 && vm.order.prices.canceled_nights.indexOf(items[eachKey]) < 0\">\n<md-button class=\"md-raised md-accent submit-button white-fg no-show-button\" aria-label=\"No Show\">No Show</md-button>\n</span><span \nng-class=\"vm.isloading?\'pointer_events_disabled onlycursorPointer minusiconred1\':\'onlycursorPointer minusiconred1\'\" \nng-click=\"vm.undoCancelThisNight(items[eachKey])\" \nng-if=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) >= 0 && vm.order.prices.canUndoNights.indexOf(items[eachKey]) >= 0 && (vm.order.prices.nightcancelledCount[eachKey]==1 || vm.order.prices.nightcancelledCount[eachKey]==vm.order.prices.canceled_nights.length || (vm.order.prices.nightcancelledCount[eachKey + 1 ] == -1) ||(vm.order.prices.nightcancelledCount[eachKey + 1 ] != -1))\">\n<md-button class=\"md-raised md-accent submit-button white-fg no-show-button\" aria-label=\"Undo\">Undo</md-button></span>\n</div></div></div><div layout=\"column\" flex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\" \nng-if=\"vm.order.showOtaPmsNightsFlag\"><div class=\"charges otapms\">{{vm.order.prices.otaDirectNight[eachKey]}}</div>\n</div><div layout=\"column\" flex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\"><div \nng-class=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) < 0?\'charges\':\'charges strikethrough\'\">\n{{vm.order.prices.dates[eachKey]}}</div></div><div layout=\"column\" flex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" \nlayout-align=\"center start\"><div \nng-class=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) < 0?\'charges\':\'charges strikethrough\'\">\n{{vm.order.prices.rate_plan[eachKey]}}</div></div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center end\"><div class=\"amount discount\">\n<md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.order.show_status == \'No Show\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <span class=\"nightly-discount-value\" \nng-click=\"(vm.order.prices.canceled_nights.indexOf(items[eachKey]) >= 0 || vm.order.resvStrikeThrough == 1) ? \'\' : vm.opencommentboxNight(vm.selectedIndex,eachKey, \'nightly_discount\')\">\n<span class=\"nightly-discount-amount\">{{vm.order.prices.nightlydiscount[eachKey]}}</span><span \nclass=\"nightly-discount-percent\" ng-if=\"vm.order.prices.nightlydiscount[eachKey] > 0\">\n{{vm.getNightlyDiscountPercent(vm.order.prices.nightlydiscount[eachKey], vm.order.prices.rates[eachKey])}}%</span> \n</span><i ng-if=\"vm.order.prices.nightlydiscount[eachKey]>0\" \nclass=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.opencommentboxNight(vm.selectedIndex,eachKey, \'nightly_discount\')\"><md-tooltip \nng-if=\"vm.order.prices.nightlydiscountcomment[$index]!=\'\' && vm.order.promotion_applied == 0\">\n{{vm.order.prices.nightlydiscountcomment[eachKey]}}</md-tooltip><md-tooltip ng-if=\"vm.order.promotion_applied == 1\">\n{{vm.order.promoTooltip}}</md-tooltip></i></md-input-container></div></div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center end\"><div class=\"amount\"><md-input-container \nng-class=\"(vm.order.prices.canceled_nights.indexOf(items[eachKey]) >= 0 || vm.order.resvStrikeThrough == 1) && vm.order.prices.rates[$index] > 0 ? \'strikeinputbigWid\' : \'\'\" \nclass=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <input ng-model-options=\"{updateOn: \'blur\'}\" \nng-change=\"vm.setShowModifyBtn(\'Night-{{eachKey}}\',\'prices\',vm.order.room_stay_id);vm.sumNights({{eachKey}})\" \nng-model=\"vm.order.prices.rates[eachKey]\" name=\"rate_plan[vm.selectedIndex][eachKey]\" type=\"text\" \nallow-decimal-numbers autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\" \nng-disabled=\"(vm.order.prices.canceled_nights.indexOf(items[eachKey]) >= 0 || vm.order.resvStrikeThrough == 1 || vm.isloading) ? true : false\">\n</md-input-container></div></div></div></div></div></div></div></div></div></div></div></div><div \nclass=\"nightly-price-heading\" \nng-if=\"!vm.isPassOnlyDayShell() && vm.order.prices.dates.length > 0 && vm.order.prices.dates.length < 7\">\n{{vm.getStayPriceHeading()}}<div class=\"nightlyscrollblk\"><div class=\"scroll-nightly-inner\"><div layout=\"row\" \nflex=\"100\" layout-wrap class=\"row-block1-amount row-header-amount\"><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\">{{vm.getStayUnitLabel()}}</div><div \nlayout=\"column\" flex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\" \nng-if=\"vm.order.showOtaPmsNightsFlag\">Source</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\">Date</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\">Rate Plan</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center end\">Discount</div><div layout=\"column\" \nflex=\"20\" layout-align=\"center end\">Price</div></div><div layout=\"row\" ng-repeat=\"eachnight in vm.order.prices.dates\" \nflex=\"100\" layout-wrap class=\"row-nightly-amount row-block1-amount\"><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\"><div class=\"minusiconouter\"><div \nclass=\"charges directOta\" ng-if=\"vm.order.prices.canceled_nights.indexOf(vm.order.prices.dates[$index]) < 0\">\n{{vm.getStayUnitLabel()}} {{vm.order.prices.nightcount[$index]}}</div><div class=\"charges strikethrough\" \nng-if=\"vm.order.prices.canceled_nights.indexOf(vm.order.prices.dates[$index]) >= 0\">Canceled {{vm.getStayUnitLabel()}}\n</div><div \nng-class=\"vm.order.show_status == \'Canceled\' || vm.order.show_status == \'No Show\' || vm.modify_request?\'canceled_order\':\'\'\">\n<span \nng-class=\"vm.isloading?\'pointer_events_disabled onlycursorPointer minusiconred1\':\'onlycursorPointer minusiconred1\'\" \nng-click=\"vm.cancelThisNight(vm.order.prices.dates[$index])\" \nng-if=\"(vm.order.prices.nightcount[$index]==1 || vm.order.prices.nightcount[$index]==vm.order.nights) && vm.order.nights>1 && vm.order.prices.canceled_nights.indexOf(vm.order.prices.dates[$index]) < 0\">\n<md-button class=\"md-raised md-accent submit-button white-fg no-show-button\" aria-label=\"No Show\">No Show</md-button>\n</span><span \nng-class=\"vm.isloading?\'pointer_events_disabled onlycursorPointer minusiconred1\':\'onlycursorPointer minusiconred1\'\" \nng-click=\"vm.undoCancelThisNight(vm.order.prices.dates[$index])\" \nng-if=\"vm.order.prices.canceled_nights.indexOf(vm.order.prices.dates[$index]) >= 0 && vm.order.prices.canUndoNights.indexOf(vm.order.prices.dates[$index]) >= 0 && (vm.order.prices.nightcancelledCount[$index]==1 || vm.order.prices.nightcancelledCount[$index]==vm.order.prices.canceled_nights.length || (vm.order.prices.nightcancelledCount[$index + 1 ] == -1) ||(vm.order.prices.nightcancelledCount[$index + 1 ] != -1))\">\n<md-button class=\"md-raised md-accent submit-button white-fg no-show-button\" aria-label=\"Undo\">Undo</md-button></span>\n</div></div></div><div layout=\"column\" flex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\" \nng-if=\"vm.order.showOtaPmsNightsFlag\"><div class=\"charges otapms\">{{vm.order.prices.otaDirectNight[$index]}}</div>\n</div><div layout=\"column\" flex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center start\"><div \nng-class=\"vm.order.prices.canceled_nights.indexOf(vm.order.prices.dates[$index]) < 0?\'charges\':\'charges strikethrough\'\">\n{{vm.order.prices.dates[$index]}}</div></div><div layout=\"column\" flex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" \nlayout-align=\"center start\"><div \nng-class=\"vm.order.prices.canceled_nights.indexOf(vm.order.prices.dates[$index]) < 0?\'charges\':\'charges strikethrough\'\">\n{{vm.order.prices.rate_plan[$index]}}</div></div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag ? 15 : 20}}\" layout-align=\"center end\"><div class=\"amount discount\">\n<md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.order.show_status == \'No Show\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <span class=\"nightly-discount-value\" \nng-click=\"(vm.order.prices.canceled_nights.indexOf(vm.order.prices.dates[$index]) >= 0 || vm.order.resvStrikeThrough == 1) ? \'\' : vm.opencommentboxNight(vm.selectedIndex,$index,\'nightly_discount\');\">\n<span class=\"nightly-discount-amount\">{{ vm.order.prices.nightlydiscount[$index] }}</span><span \nclass=\"nightly-discount-percent\" ng-if=\"vm.order.prices.nightlydiscount[$index] > 0\">\n{{vm.getNightlyDiscountPercent(vm.order.prices.nightlydiscount[$index], vm.order.prices.rates[$index])}}%</span></span>\n <i ng-if=\"vm.order.prices.nightlydiscount[$index]>0\" \nclass=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.opencommentboxNight(vm.selectedIndex,$index,\'nightly_discount\');\"><md-tooltip \nng-if=\"vm.order.prices.nightlydiscountcomment[$index] != \'\' && vm.order.promotion_applied == 0\">\n{{vm.order.prices.nightlydiscountcomment[$index]}}</md-tooltip><md-tooltip ng-if=\"vm.order.promotion_applied == 1\">\n{{vm.order.promoTooltip}}</md-tooltip></i></md-input-container></div></div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center end\"><div class=\"amount price\"><md-input-container class=\"md-block no-margin\" \nng-class=\"(vm.order.prices.canceled_nights.indexOf(vm.order.prices.dates[$index]) >= 0 || vm.order.resvStrikeThrough == 1) && vm.order.prices.rates[$index] > 0 ? \'strikeinputbigWid\' : \'\'\">\n<i class=\"icon icon-currency-usd s20\"></i> <input ng-model-options=\"{updateOn: \'blur\'}\" \nng-change=\"vm.setShowModifyBtn(\'Night-{{$index}}\',\'prices\',vm.order.room_stay_id);vm.sumNights({{$index}})\" \nng-model=\"vm.order.prices.rates[$index]\" name=\"rate_plan[vm.selectedIndex][$index]\" type=\"text\" allow-decimal-numbers \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\" \nng-disabled=\"(vm.order.prices.canceled_nights.indexOf(vm.order.prices.dates[$index]) >= 0 || vm.order.resvStrikeThrough == 1 || vm.isloading)  ? true : false\">\n</md-input-container></div></div></div></div></div></div><div class=\"pos_general_div\" \nng-repeat=\"(poskey, posValue) in vm.order.pos track by $index\"><div \nclass=\"nightly-price-latest padding-20 border-space-top\" ng-if=\"posValue.product_is_timebound != 1\" \nstyle=\"padding:0px !important\"><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"row-nightly-header-amount row-block1-amount\" \nng-class=\"{roomNameCanceled: posValue.room_stay_status == \'Canceled\', roomNameActive: posValue.room_stay_status == \'Active\'}\">\n<div layout=\"column\" flex-gt-md=\"70\" flex-gt-xs=\"60\" flex=\"100\" layout-align=\"center start\"><div \nstyle=\"display:flex;align-items:center;flex-wrap:wrap\"><div class=\"cc-fee-toggle\" \nstyle=\"pointer-events:auto;margin-right:8px\" \nng-if=\"vm.isRoundUpForCharityPos(posValue) && (posValue.room_stay_status || \'\').toLowerCase() != \'canceled\' && !vm.isPosNonCancellable(posValue)\">\n<md-button class=\"md-icon-button md-primary\" ng-click=\"vm.deleteRoundUpForCharityPos(posValue, poskey, $event)\" \nng-disabled=\"vm.roundUpForCharityDeletingPos[poskey]\" aria-label=\"Delete Round Up For Charity\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"red-A800-fg\"></md-icon></md-button><md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.roundUpForCharityDeletingPos[poskey]\">\n</md-progress-circular></div><div class=\"big-txt-night capitalize\">{{posValue.product_name}}</div><div \nclass=\"fromToInfo\" ng-if=\"vm.isDailyPassPos(posValue) && vm.getDailyPassDate(posValue)\" \nstyle=\"margin-left:14px;margin-top:0\"><div class=\"fromInfo\"><img src=\"assets/images/ecommerce/from.svg\">\n{{vm.getDailyPassDate(posValue)}}</div></div></div><div ng-if=\"posValue.is_gift_card == 1\"><span class=\"gcinfo\"><b>\nCustomer:</b> {{posValue.gc_sender_name}} (<a href=\"mailto:{{posValue.gc_sender_email}}\">{{posValue.gc_sender_email}}\n</a>) </span><span class=\"gcinfo gcinfo1\"><b>Recipient:</b> {{posValue.gc_recipient_name}} (<a \nhref=\"mailto:{{posValue.gc_recipient_email}}\">{{posValue.gc_recipient_email}}</a>)</span><br><span \nclass=\"gcinfo gcinfo1\"><b>Message:</b> {{posValue.gc_message}}</span><br><span class=\"gcinfo gcinfo1\"><b>Code:</b>\n {{posValue.gc_code}}</span></div><div ng-if=\"posValue.product_attribute_fields.length>0\"><span class=\"gcinfo\" \nng-repeat=\"(key, value) in posValue.product_attribute_fields\"><b>{{posValue.product_attribute_fields[key]}}</b>\n {{posValue.product_attribute_values[key]}}</span></div><div \nng-class=\"posValue.room_stay_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"fromToInfo fromto-info-color datepickerfromtoorder no-margin\" \nng-if=\"posValue.product_is_timebound == 1 && posValue.is_timebound_with_availability == 0\"><div \nclass=\"fromInfo onlycursorPointer\"><md-input-container class=\"md-block full-width\"><label \ntranslate=\"CREATE_RES.CHECKIN\"></label><md-datepicker ng-disabled=\"posValue.auto_added == 1\" md-open-on-focus \nng-model=\"posValue.room_stay_from\" md-min-date=\"vm.minDate\" ng-model-options=\"{debounce: 400}\" \nng-change=\"vm.startDateModified(poskey);vm.setShowModifyBtn(\'Start Date\',\'room_stay_from\',posValue.room_stay_id,\'pos\',poskey);vm.datesChanged(poskey)\" \nclass=\"full-width mdinput-block\" changecheckout></md-datepicker><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div class=\"toInfo onlycursorPointer\"><md-input-container class=\"md-block full-width mb-0\">\n<label translate=\"CREATE_RES.CHECKOUT\"></label><md-datepicker ng-disabled=\"posValue.auto_added == 1\" md-open-on-focus \nng-model-options=\"{debounce: 400}\" ng-model=\"posValue.room_stay_to\" md-min-date=\"vm.endDateMin\" \nng-change=\"vm.endDateModified(posValue.room_stay_to,poskey,$event);vm.setShowModifyBtn(\'End Date\',\'room_stay_to\',posValue.room_stay_id,\'pos\',poskey);vm.datesChanged(poskey)\" \nclass=\"full-width mdinput-block\"></md-datepicker><div class=\"md-errors-spacer\"></div></md-input-container></div></div>\n<div class=\"fromToInfo fromto-info-color datepickerfromtoorder no-margin\" \nng-if=\"posValue.product_is_timebound == 1 && posValue.is_timebound_with_availability == 1\" \nng-click=\"vm.editParkingDates(event,posValue.room_stay_from,posValue.room_stay_to,0,0,posValue.confirmation_number,posValue.product_id,posValue.product_name,posValue.policy_id ,posValue, poskey);\">\n<div ng-class=\"posValue.room_stay_status != \'Canceled\'? \'fromInfo onlycursorPointer\':\'fromInfo\'\"><img \nsrc=\"assets/images/ecommerce/from-black.svg\"> {{posValue.room_stay_from}}</div><div \nng-class=\"posValue.room_stay_status != \'Canceled\'? \'toInfo onlycursorPointer\':\'toInfo\'\"><img \nsrc=\"assets/images/ecommerce/to-black.svg\">{{posValue.room_stay_to}}</div></div></div><div layout=\"column\" \nflex-gt-md=\"30\" flex-gt-xs=\"40\" flex=\"100\" layout-align=\"center center\" class=\"wrapactions\"><div \nclass=\"active-input-block\" ng-if=\"posValue.product_is_timebound != 1\"><div class=\"cc-fee-toggle\" \nstyle=\"pointer-events:auto\" \nng-if=\"posValue.product_is_timebound != 1 && vm.isCcProcessingFeeApplicable(posValue) && !vm.isRoundUpForCharityPos(posValue) && (posValue.room_stay_status || \'\').toLowerCase() != \'canceled\' && !vm.isPosNonCancellable(posValue)\">\n<md-checkbox class=\"no-margin\" ng-model=\"vm.removeCcProcessingFeePos[poskey]\" \nng-disabled=\"vm.ccProcessingFeeRemovingPos[poskey]\" \nng-change=\"vm.toggleRemoveCcProcessingFee(\'pos\', poskey, posValue.confirmation_number)\">\n{{ vm.removeCcProcessingFeePos[poskey] ? \'CC processing fee removed.\' : \'Remove CC processing fee\' }}</md-checkbox>\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.ccProcessingFeeRemovingPos[poskey]\"></md-progress-circular></div><div class=\"input-block-status\" \nng-if=\"!vm.isRoundUpForCharityPos(posValue) && !vm.isPosNonCancellable(posValue)\"><md-input-container \nclass=\"md-block mb-0 no-margin\"><md-select placeholder=\"status\" ng-model=\"vm.pos_status[poskey]\" \nng-init=\"vm.pos_status[poskey]=posValue.room_stay_status\" \nng-change=\"vm.changeStatusForService(event,posValue.confirmation_number,posValue.room_stay_status,vm.pos_status[poskey],poskey,posValue.grand_total,posValue.room_confirmation_number,posValue.overalltotals.paid_amount,posValue.total_amount,\'pos\', posValue)\">\n<md-option ng-value=\"key\" ng-repeat=\"(key, value) in vm.statusesPos[poskey]\">{{value}}</md-option></md-select>\n</md-input-container></div><div class=\"amount\"><span \nng-class=\"(posValue.room_stay_status.toLowerCase() == \'canceled\') ? \'strike\' : \'\'\">\n{{posValue.grand_total | currency : $}}</span></div></div></div></div><div class=\"pv-5 ph-20\"><div layout=\"row\" \nflex=\"100\" layout-wrap class=\"row-nightly-amount row-block1-amount\" ng-if=\"!vm.isPosQuantityLocked(posValue)\"><div \nlayout=\"column\" flex=\"55\" layout-align=\"center start\"><div class=\"charges\">Quantity</div></div><div layout=\"column\" \nflex=\"15\" layout-align=\"center center\"></div><div layout=\"column\" flex=\"30\" layout-align=\"center end\"><div \nclass=\"amount\"><md-input-container class=\"md-block no-margin\" \nng-class=\"(posValue.room_stay_status == \'Canceled\') ? \'canceled_order strikeinputbigWid\' : (vm.modify_request ? \'canceled_order\':\'\')\">\n<input ng-model=\"posValue.quantity\" name=\"nightlySum[$index]\" type=\"text\" \nng-change=\"vm.checValue(posValue.quantity, \'pos\',poskey, $event, \'quantity\');vm.setShowModifyBtn(\'Quantitypos{{$index}}\',\'quantity\',posValue.room_stay_id,\'pos\',poskey);vm.calculatePOSTotals(poskey,\'call\')\" \nng-model-options=\"{updateOn: \'blur\'}\" allow-decimal-numbers autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\" \nng-disabled=\"vm.order.current_billing != posValue.customer_traveller_id\"></md-input-container></div></div></div><div \nlayout=\"row\" flex=\"100\" layout-wrap class=\"row-nightly-amount row-block1-amount\" \nng-if=\"posValue.product_is_timebound != 1\"><div layout=\"column\" flex=\"55\" layout-align=\"center start\"><div \nclass=\"charges\">Rate</div></div><div layout=\"column\" flex=\"15\" layout-align=\"center center\"></div><div layout=\"column\" \nflex=\"30\" layout-align=\"center end\"><div class=\"amount\"><md-input-container class=\"md-block mb-0 no-margin\" \nng-class=\"(posValue.room_stay_status == \'Canceled\' && posValue.nightlySum > 0) ? \'canceled_order strikeinputbigWid\' : (vm.modify_request ? \'canceled_order\':\'\')\">\n<i class=\"icon icon-currency-usd s20\"></i> <input ng-model=\"posValue.nightlySum\" name=\"nightlySum[$index]\" type=\"text\" \nng-change=\"vm.checValue(posValue.nightlySum, \'pos\',poskey, $event, \'nightlySum\');vm.setShowModifyBtn(\'nightlySumpos{{$index}}\',\'subtotal\',posValue.room_stay_id,\'pos\',poskey);vm.calculatePOSTotals(poskey,\'call\')\" \nng-model-options=\"{updateOn: \'blur\'}\" allow-decimal-numbers autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\" \nng-disabled=\"vm.order.current_billing != posValue.customer_traveller_id || vm.order.resvStrikeThrough == 1 || posValue.room_stay_status == \'Canceled\' ||  vm.isPosQuantityLocked(posValue)\">\n</md-input-container></div></div></div><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"row-nightly-amount row-block1-amount\" ng-if=\"posValue.product_is_timebound != 1\"><div layout=\"column\" flex=\"55\" \nlayout-align=\"center start\"><div class=\"charges\">Discount</div></div><div layout=\"column\" flex=\"15\" \nlayout-align=\"center center\"></div><div layout=\"column\" flex=\"30\" layout-align=\"center end\"><div class=\"amount\">\n<md-input-container class=\"md-block mb-0 no-margin\" \nng-class=\"(posValue.room_stay_status == \'Canceled\' && posValue.nightlySum > 0) ? \'canceled_order strikeinputbigWid\' : (vm.modify_request ? \'canceled_order\':\'\')\">\n<i class=\"icon icon-currency-usd s20\"></i> <input ng-model=\"posValue.product_discount\" name=\"productDiscount[$index]\" \ntype=\"text\" \nng-change=\"vm.checValue(posValue.product_discount, \'pos\',poskey, $event, \'product_discount\'); vm.setShowModifyBtn(\'Discount\',\'product_discount\',posValue.room_stay_id,\'pos\',poskey);vm.changeProductDiscount(poskey,\'call\')\" \nng-model-options=\"{updateOn: \'blur\'}\" allow-decimal-numbers autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\" \nng-disabled=\"vm.order.current_billing != posValue.customer_traveller_id || vm.order.resvStrikeThrough == 1 || posValue.room_stay_status == \'Canceled\' || posValue.promotion_applied == 1\">\n <i ng-if=\"posValue.product_discount>0\" class=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"posValue.promotion_applied == 0 ? vm.opencommentbox(poskey) : \'\';\"><md-tooltip \nng-if=\"posValue.product_discount_commen!=\'\' && posValue.promotion_applied == 0\">{{posValue.product_discount_comment}}\n</md-tooltip><md-tooltip ng-if=\"posValue.promotion_applied == 1\">{{vm.order.promoTooltip}}</md-tooltip></i>\n</md-input-container></div></div></div></div></div><div \nng-class=\"(posValue.room_stay_status == \'Canceled\' || (posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' && !vm.order.resortFeeApplied)) ? \'roomNameCanceled\' : \'roomNameActive\'\" \nlayout=\"row\" flex class=\"border-space-top ph-15 pv-10 timebound-header pos-height-header\" \nng-if=\"posValue.product_is_timebound == 1\"><div class=\"room-col\" layout=\"column\" flex=\"100\"><div layout=\"row\" flex \nlayout-wrap><div layout=\"column\" flex-gt-md=\"60\" flex-gt-xs=\"50\" flex-sm-xs=\"50\" flex=\"100\" \nlayout-align=\"center start\"><div class=\"row-containerstaus\"><strong>{{posValue.product_name}}</strong><div \nclass=\"fromToInfo\"><div class=\"fromToInfo\"><div class=\"fromInfo onlycursorPointer\" \nng-click=\"vm.editPosDates($event,posValue.room_stay_from,posValue.room_stay_to, poskey, \'pos\',posValue.room_stay_id);\" \nng-class=\"posValue.auto_added == 1 ? \'pos-disabled\' : \'\'\"><img src=\"assets/images/ecommerce/from.svg\">\n{{posValue.room_stay_from}}</div><div class=\"toInfo onlycursorPointer\" \nng-click=\"vm.editPosDates($event,posValue.room_stay_from,posValue.room_stay_to, poskey, \'pos\',posValue.room_stay_id);\" \nng-class=\"posValue.auto_added == 1 ? \'pos-disabled\' : \'\'\"><img src=\"assets/images/ecommerce/to.svg\">\n {{posValue.room_stay_to}}</div></div></div></div></div><div layout=\"column\" flex-gt-md=\"40\" flex-gt-xs=\"50\" \nflex=\"100\" flex-gt-sm=\"50\" layout-align=\"center end\" class=\"pr-0\"><div class=\"wrapactions\"><div class=\"cc-fee-toggle\" \nstyle=\"pointer-events:auto\" \nng-if=\"vm.isCcProcessingFeeApplicable(posValue) && !vm.isRoundUpForCharityPos(posValue) && (posValue.room_stay_status || \'\').toLowerCase() != \'canceled\' && !vm.isPosNonCancellable(posValue)\">\n<md-checkbox class=\"no-margin\" ng-model=\"vm.removeCcProcessingFeePos[poskey]\" \nng-disabled=\"vm.ccProcessingFeeRemovingPos[poskey]\" \nng-change=\"vm.toggleRemoveCcProcessingFee(\'pos\', poskey, posValue.confirmation_number)\">\n{{ vm.removeCcProcessingFeePos[poskey] ? \'CC processing fee removed.\' : \'Remove CC processing fee\' }}</md-checkbox>\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.ccProcessingFeeRemovingPos[poskey]\"></md-progress-circular></div><div class=\"cc-fee-toggle\" \nstyle=\"pointer-events:auto\" \nng-if=\"vm.isRoundUpForCharityPos(posValue) && (posValue.room_stay_status || \'\').toLowerCase() != \'canceled\'\"><md-button\n class=\"md-icon-button md-primary\" ng-click=\"vm.deleteRoundUpForCharityPos(posValue, poskey, $event)\" \nng-disabled=\"vm.roundUpForCharityDeletingPos[poskey]\" aria-label=\"Delete Round Up For Charity\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"red-A800-fg\"></md-icon></md-button><md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.roundUpForCharityDeletingPos[poskey]\">\n</md-progress-circular></div><div class=\"input-block-status\" \nng-if=\"!vm.isRoundUpForCharityPos(posValue) && !vm.isPosNonCancellable(posValue)\"><md-input-container \nclass=\"md-block mb-0 no-margin\" \nng-if=\"posValue.extra_attribute == undefined || posValue.extra_attribute != \'resort_fee\'\"><md-select \nplaceholder=\"status\" ng-model=\"vm.pos_status[poskey]\" ng-init=\"vm.pos_status[poskey]=posValue.room_stay_status\" \nng-change=\"vm.changeStatusForService(event,posValue.confirmation_number,posValue.room_stay_status,vm.pos_status[poskey],poskey,posValue.grand_total,posValue.room_confirmation_number,posValue.overalltotals.paid_amount,posValue.total_amount,\'pos\', posValue)\" \nng-class=\"vm.order.show_status == \'Canceled\' || vm.order.show_status == \'No Show\' ? \'canceled_order\' : \'\'\"><md-option \nng-value=\"key\" ng-repeat=\"(key, value) in vm.statusesPos[poskey]\">{{value}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block mb-0 no-margin\" \nng-if=\"posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\'\"><md-select \nplaceholder=\"status\" ng-model=\"vm.pos_status[poskey]\" \nng-change=\"vm.changeStatusForService(event,posValue.confirmation_number,posValue.room_stay_status,vm.pos_status[poskey],poskey,posValue.grand_total,posValue.room_confirmation_number,posValue.overalltotals.paid_amount,posValue.total_amount,\'pos\', posValue)\" \nng-class=\"vm.order.show_status == \'Canceled\' || vm.order.show_status == \'No Show\' ? \'canceled_order\' : \'\'\"><md-option \nng-value=\"key\" ng-repeat=\"(key, value) in vm.statusesResort[poskey]\">{{value == \'Removed\' ? \'Cancel\' : value}}\n</md-option></md-select></md-input-container></div><div class=\"amountstatusblock ml-10\"><div class=\"amount\"><span \nng-class=\"(posValue.room_stay_status.toLowerCase() == \'canceled\' || (posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' && !vm.order.resortFeeApplied)) ? \'strike\' : \'\'\">\n{{posValue.grand_total | currency : $ }}</span></div></div><div class=\"mdmenusRoomWise ml-15 mr-10\"><img \nsrc=\"assets/images/ecommerce/parking-wt.svg\" class=\"parking-ic\" \nng-if=\"posValue.is_timebound_with_availability == 1 && vm.parking_access && posValue.room_stay_status != \'Canceled\'\" \nng-click=\"$event.stopPropagation();vm.printParkingPass(posValue);\"></div></div></div></div></div></div><div \nclass=\"nightly-price-heading\" ng-if=\"posValue.product_is_timebound == 1\"><div class=\"boat-post-div-wrapper\"><div \nclass=\"progress_circular\" ng-if=\"vm.loader[poskey] == \'true\'\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent md-hue-1\"></md-progress-circular></div><div class=\"lowest-price-content\" \nng-if=\"posValue.prices.dates.length > 31 && vm.loader[poskey].toString() == \'false\'\"><div class=\"accordian-cover\"><div \nclass=\"accordian-row\"><div class=\"accordian-content\" ng-repeat=\"(monthName,monthData) in vm.posArrayFinal[poskey][0]\">\n<h5 class=\"accordian-title posmonths{{monthName}}{{poskey}} accordian-title-minus\" \nng-click=\"vm.toggle(monthName,\'month\',\'pos\', poskey)\"><span class=\"monthname\">{{monthName}}</span> <span \nclass=\"priceblockmain\"><span class=\"pricemaininner\"><b class=\"discount\" \nng-class=\"(posValue.room_stay_status == \'Canceled\') ? \'strike\':\'\'\">\n${{vm.posmonthOverallTotalArray[poskey][monthName][\'discount\']}}</b> <small class=\"totalblk\">Discount</small> </span>\n<span class=\"pricemaininner\"><b ng-class=\"(posValue.room_stay_status == \'Canceled\') ? \'strike\':\'\'\">\n${{vm.posmonthOverallTotalArray[poskey][monthName][\'price\']}}</b> <small class=\"totalblk\">Total </small></span></span>\n<span class=\"paidamount\"><span><b class=\"paidmain\">${{vm.posmonthOverallTotalArray[poskey][monthName][\'paid\']}}</b> \n<small class=\"totalblk\">Paid</small> </span><span><b class=\"owe\">\n${{vm.posmonthOverallTotalArray[poskey][monthName][\'owes\']}}</b> <small class=\"totalblk\">Owes</small></span></span>\n</h5><div class=\"accordian-inner-content dropdown-container\" style=\"display: none\"><div \nclass=\"accordian-content weekContainer weekafter\" ng-repeat=\"(weekName,items) in monthData\"><h5 \nclass=\"accordian-title posweeks{{weekName}}{{key}}{{poskey}} accordian-title-minus\" \nng-click=\"vm.toggle(weekName+key,\'week\',\'pos\', poskey)\"><span class=\"newhtmlappend monthsblock\" \nng-bind-html=\"vm.getWeekHeaderName(items,monthName+weekName)\"></span> <span class=\"priceblockouter\"><span \nclass=\"pricemaininner\"><b class=\"discount\" ng-class=\"(posValue.room_stay_status == \'Canceled\') ? \'strike\':\'\'\">\n${{vm.posweekOverallTotalArray[poskey][monthName+$index][\'discount\']}}</b> <small class=\"totalblk\">Discount</small> \n</span><span class=\"pricemaininner\"><b ng-class=\"(posValue.room_stay_status == \'Canceled\') ? \'strike\':\'\'\">\n${{vm.posweekOverallTotalArray[poskey][monthName+$index][\'price\']}}</b> <small class=\"totalblk\">Total </small></span>\n</span><span class=\"paidamount\"><span><b class=\"paidmain\">${{vm.posweekPaidValuesArray[poskey][monthName+$index]}}</b> \n<small class=\"totalblk\">Paid</small> </span><span><b class=\"owe\">\n${{vm.posweekOwesValuesArray[poskey][monthName+$index]}}</b> <small class=\"totalblk\">Owes</small></span></span></h5>\n<div class=\"accordian-inner-content dropdown-container1\" style=\"display: none\"><div class=\"nightlyscrollblk\"><div \nclass=\"scroll-nightly-inner\"><div layout=\"row\" flex=\"100\" layout-wrap class=\"row-block1-amount row-header-amount\"><div \nlayout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center start\">{{vm.getStayUnitLabel()}}</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center start\" \nng-if=\"vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\'\">\nSource</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center start\">Date</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center end\">Discount</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center end\">Price</div></div><div layout=\"row\" ng-repeat=\"(eachKey, eachnight) in items\" flex=\"100\" \nlayout-wrap class=\"row-nightly-amount row-block1-amount\"><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center start\"><div class=\"minusiconouter\"><div class=\"charges directOta\" \nng-if=\"posValue.prices.canceled_nights.indexOf(items[eachKey]) < 0\">\n{{vm.getStayUnitLabel()}} {{posValue.prices.nightcount[eachKey]}}</div><div class=\"charges strikethrough\" \nng-if=\"posValue.prices.canceled_nights.indexOf(items[eachKey]) >= 0\">Canceled {{vm.getStayUnitLabel()}}</div></div>\n</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center start\" \nng-if=\"vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\'\">\n<div class=\"charges otapms\">{{vm.order.prices.otaDirectNight[eachKey]}}</div></div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center start\"><div \nng-class=\"posValue.prices.canceled_nights.indexOf(items[eachKey]) < 0?\'charges\':\'charges strikethrough\'\">\n{{posValue.prices.dates[eachKey]}}</div></div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center end\"><div class=\"amount discount\"><md-input-container \nng-class=\"(posValue.room_stay_status == \'Canceled\' || (posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' && !vm.order.resortFeeApplied)) ? \'canceled_order strikeinputbigWid\' : (vm.modify_request ? \'canceled_order\':\'\')\" \nclass=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <span class=\"nightly-discount-value\" \nng-click=\"posValue.prices.canceled_nights.indexOf(items[eachKey]) >= 0 ? \'\' : vm.discountCommentPopUp(eachKey, poskey, \'nightly_discount\', datekey, mykey);\">\n<span class=\"nightly-discount-amount\">{{ posValue.prices.nightlydiscount[eachKey] }}</span><span \nclass=\"nightly-discount-percent\" ng-if=\"posValue.prices.nightlydiscount[eachKey] > 0\">\n{{vm.getNightlyDiscountPercent(posValue.prices.nightlydiscount[eachKey], posValue.prices.rates[eachKey])}}%</span>\n</span> <i ng-if=\"posValue.prices.nightlydiscount[eachKey]>0\" \nclass=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.discountCommentPopUp(eachKey, poskey, \'nightly_discount\', datekey, mykey);\"><md-tooltip \nng-if=\"posValue.prices.nightlydiscountcomment[eachKey]!=null && posValue.promotion_applied == 0\">\n{{posValue.prices.nightlydiscountcomment[eachKey]}}</md-tooltip><md-tooltip ng-if=\"posValue.promotion_applied == 1\">\n{{vm.order.promoTooltip}}</md-tooltip></i></md-input-container></div></div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center end\"><div class=\"amount\"><md-input-container \nng-class=\"(posValue.room_stay_status == \'Canceled\' || (posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' && !vm.order.resortFeeApplied)) ? \'canceled_order strikeinputbigWid\' : (vm.modify_request ? \'canceled_order\':\'\')\" \nclass=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <input ng-model-options=\"{updateOn: \'blur\'}\" \nng-change=\"vm.setShowModifyBtn(\'night-{{eachKey}}\',\'prices\',posValue.room_stay_id,\'pos\',poskey);vm.sumNightsPOS(poskey,\'call\')\" \nng-model=\"posValue.prices.rates[eachKey]\" name=\"rate_plan[vm.selectedIndex][eachKey]\" type=\"text\" \nallow-decimal-numbers \nng-disabled=\"(posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\') || (posValue.prices.canceled_nights.indexOf(items[eachKey]) >= 0)\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\" \nng-class=\"posValue.prices.canceled_nights.indexOf(items[eachKey]) >= 0 && posValue.prices.rates[eachKey] > 0 ? \'strikethrough\' : \'\'\">\n</md-input-container></div></div></div></div></div></div></div></div></div></div></div></div><div \nclass=\"lowest-price-content\" \nng-if=\"posValue.prices.dates.length >= 7 && posValue.prices.dates.length <= 31 && vm.loader[poskey].toString() == \'false\'\">\n<div class=\"accordian-cover\"><div class=\"accordian-row\"><div class=\"accordian-content onlyWeekdata\"><div \nclass=\"accordian-inner-content dropdown-container weekcontent\"><div class=\"accordian-content weekContainer\" \nng-repeat=\"(weekName,items) in vm.posArrayFinal[poskey][0]\"><h5 \nclass=\"accordian-title posweeks{{weekName}}{{key}}{{poskey}} accordian-title-minus\" \nng-click=\"vm.toggle(weekName+key,\'week\',\'pos\', poskey)\"><span class=\"newhtmlappend monthsblock\" \nng-bind-html=\"vm.getWeekHeaderName(items,monthName+weekName)\"></span> <span class=\"priceblockouter\"><span \nclass=\"pricemaininner\"><b class=\"discount\" ng-class=\"(posValue.room_stay_status == \'Canceled\') ? \'strike\':\'\'\">\n${{vm.posweekOverallTotalArray[poskey][$index][\'discount\']}}</b> <small class=\"totalblk\">Discount</small> </span><span \nclass=\"pricemaininner\"><b ng-class=\"(posValue.room_stay_status == \'Canceled\') ? \'strike\':\'\'\">\n${{vm.posweekOverallTotalArray[poskey][$index][\'price\']}}</b> <small class=\"totalblk\">Total</small> </span></span><span\n class=\"paidamount\"><span><b class=\"paidmain\">${{vm.posweekPaidValuesArray[poskey][$index]}}</b> <small \nclass=\"totalblk\">Paid</small> </span><span><b class=\"owe\">${{vm.posweekOwesValuesArray[poskey][$index]}}</b> <small \nclass=\"totalblk\">Owes</small></span></span></h5><div class=\"accordian-inner-content dropdown-container1\" \nstyle=\"display: none\"><div class=\"nightlyscrollblk\"><div class=\"scroll-nightly-inner\"><div layout=\"row\" flex=\"100\" \nlayout-wrap class=\"row-block1-amount row-header-amount\"><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center start\">{{vm.getStayUnitLabel()}}</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center start\" \nng-if=\"vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\'\">\nSource</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center start\">Date</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center end\">Discount</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center end\">Price</div></div><div layout=\"row\" ng-repeat=\"(eachKey, eachnight) in items\" flex=\"100\" \nlayout-wrap class=\"row-nightly-amount row-block1-amount\"><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center start\"><div class=\"minusiconouter\"><div class=\"charges directOta\" \nng-if=\"posValue.prices.canceled_nights.indexOf(items[eachKey]) < 0\">\n{{vm.getStayUnitLabel()}} {{posValue.prices.nightcount[eachKey]}}</div><div class=\"charges strikethrough\" \nng-if=\"posValue.prices.canceled_nights.indexOf(items[eachKey]) >= 0\">Canceled {{vm.getStayUnitLabel()}}</div></div>\n</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center start\" \nng-if=\"vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\'\">\n<div class=\"charges otapms\">{{vm.order.prices.otaDirectNight[eachKey]}}</div></div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center start\"><div \nng-class=\"posValue.prices.canceled_nights.indexOf(items[eachKey]) < 0?\'charges\':\'charges strikethrough\'\">\n{{posValue.prices.dates[eachKey]}}</div></div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center end\"><div class=\"amount discount\"><md-input-container \nng-class=\"(posValue.room_stay_status == \'Canceled\' || (posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' && !vm.order.resortFeeApplied)) ? \'canceled_order strikeinputbigWid\' : (vm.modify_request ? \'canceled_order\':\'\')\" \nclass=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <span class=\"nightly-discount-value\" \nng-click=\"(posValue.prices.canceled_nights.indexOf(items[eachKey]) >= 0) ? \'\' : vm.discountCommentPopUp(eachKey, poskey, \'nightly_discount\', datekey, mykey);\">\n<span class=\"nightly-discount-amount\">{{ posValue.prices.nightlydiscount[eachKey] }}</span><span \nclass=\"nightly-discount-percent\" ng-if=\"posValue.prices.nightlydiscount[eachKey] > 0\">\n{{vm.getNightlyDiscountPercent(posValue.prices.nightlydiscount[eachKey], posValue.prices.rates[eachKey])}}%</span>\n</span> <i ng-if=\"posValue.prices.nightlydiscount[eachKey]>0\" \nclass=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.discountCommentPopUp(eachKey, poskey, \'nightly_discount\', datekey, mykey);\"><md-tooltip \nng-if=\"posValue.prices.nightlydiscountcomment[eachKey]!=null && posValue.promotion_applied == 0\">\n{{posValue.prices.nightlydiscountcomment[eachKey]}}</md-tooltip><md-tooltip ng-if=\"posValue.promotion_applied == 1\">\n{{vm.order.promoTooltip}}</md-tooltip></i></md-input-container></div></div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center end\"><div class=\"amount\"><md-input-container \nng-class=\"(posValue.room_stay_status == \'Canceled\' || (posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' && !vm.order.resortFeeApplied)) ? \'canceled_order strikeinputbigWid\' : (vm.modify_request ? \'canceled_order\':\'\')\" \nclass=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <input ng-model-options=\"{updateOn: \'blur\'}\" \nng-change=\"vm.setShowModifyBtn(\'night-{{eachKey}}\',\'prices\',posValue.room_stay_id,\'pos\',poskey);vm.sumNightsPOS(poskey,\'call\')\" \nng-model=\"posValue.prices.rates[eachKey]\" name=\"rate_plan[vm.selectedIndex][eachKey]\" type=\"text\" \nallow-decimal-numbers \nng-disabled=\"(posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\') || (posValue.prices.canceled_nights.indexOf(items[eachKey]) >= 0)\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\" \nng-class=\"posValue.prices.canceled_nights.indexOf(items[eachKey]) >= 0 && posValue.prices.rates[eachKey] > 0 ? \'strikethrough\' : \'\'\">\n</md-input-container></div></div></div></div></div></div></div></div></div></div></div></div><div \nclass=\"nightly-price-heading\" \nng-if=\"posValue.prices.dates.length > 0 && posValue.prices.dates.length < 7 && posValue.product_is_timebound == 1 && vm.loader[poskey].toString() == \'false\'\">\n{{vm.getStayPriceHeading()}}<div class=\"nightlyscrollblk\"><div class=\"scroll-nightly-inner\"><div layout=\"row\" \nflex=\"100\" layout-wrap class=\"row-block1-amount row-header-amount\"><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center start\">{{vm.getStayUnitLabel()}}</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center start\" \nng-if=\"vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\'\">\nSource</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center start\">Date</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center end\">Discount</div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center end\">Price</div></div><div layout=\"row\" ng-repeat=\"eachnight in posValue.prices.dates\" flex=\"100\" \nlayout-wrap class=\"row-nightly-amount row-block1-amount\"><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center start\"><div class=\"minusiconouter\"><div class=\"charges directOta\" \nng-if=\"posValue.prices.canceled_nights.indexOf(posValue.prices.dates[$index]) < 0\">\n{{vm.getStayUnitLabel()}} {{posValue.prices.nightcount[$index]}}</div><div class=\"charges strikethrough\" \nng-if=\"posValue.prices.canceled_nights.indexOf(posValue.prices.dates[$index]) >= 0\">Canceled {{vm.getStayUnitLabel()}}\n</div></div></div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center start\" \nng-if=\"vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\'\">\n<div class=\"charges otapms\">{{vm.order.prices.otaDirectNight[$index]}}</div></div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center start\"><div \nng-class=\"posValue.prices.canceled_nights.indexOf(posValue.prices.dates[$index]) < 0?\'charges\':\'charges strikethrough\'\">\n{{posValue.prices.dates[$index]}}</div></div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center end\"><div class=\"amount discount\"><md-input-container \nng-class=\"(posValue.room_stay_status == \'Canceled\' || (posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' && !vm.order.resortFeeApplied)) ? \'canceled_order strikeinputbigWid\' : (vm.modify_request ? \'canceled_order\':\'\')\" \nclass=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <span class=\"nightly-discount-value\" \nng-click=\"posValue.prices.canceled_nights.indexOf(posValue.prices.dates[$index]) >= 0 ? \'\' : vm.discountCommentPopUp($index, poskey, \'nightly_discount\', datekey, mykey);\">\n<span class=\"nightly-discount-amount\">{{ posValue.prices.nightlydiscount[$index] }}</span><span \nclass=\"nightly-discount-percent\" ng-if=\"posValue.prices.nightlydiscount[$index] > 0\">\n{{vm.getNightlyDiscountPercent(posValue.prices.nightlydiscount[$index], posValue.prices.rates[$index])}}%</span></span>\n <i ng-if=\"posValue.prices.nightlydiscount[$index]>0\" \nclass=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.discountCommentPopUp($index, poskey, \'nightly_discount\', datekey, mykey);\"><md-tooltip \nng-if=\"posValue.prices.nightlydiscountcomment[$index]!=\'\' && posValue.promotion_applied == 0\">\n{{posValue.prices.nightlydiscountcomment[$index]}}</md-tooltip><md-tooltip ng-if=\"posValue.promotion_applied == 1\">\n{{vm.order.promoTooltip}}</md-tooltip></i></md-input-container></div></div><div layout=\"column\" \nflex=\"{{vm.order.showOtaPmsNightsFlag && posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' ? 20 : 25}}\" \nlayout-align=\"center end\"><div class=\"amount price\"><md-input-container \nng-class=\"(posValue.room_stay_status == \'Canceled\' || (posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\' && !vm.order.resortFeeApplied)) ? \'canceled_order strikeinputbigWid\' : (vm.modify_request ? \'canceled_order\':\'\')\" \nclass=\"md-block no-margin\"><i class=\"icon icon-currency-usd s20\"></i> <input ng-model-options=\"{updateOn: \'blur\'}\" \nng-change=\"vm.setShowModifyBtn(\'night-{{$index+1}}\',\'prices\',posValue.room_stay_id,\'pos\',poskey);vm.sumNightsPOS(poskey,\'call\')\" \nng-model=\"posValue.prices.rates[$index]\" name=\"rate_plan[vm.selectedIndex][$index]\" type=\"text\" allow-decimal-numbers \nng-disabled=\"(posValue.extra_attribute != undefined && posValue.extra_attribute == \'resort_fee\') || (posValue.prices.canceled_nights.indexOf(posValue.prices.dates[$index]) >= 0) || vm.isloading\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\" \nng-class=\"posValue.prices.canceled_nights.indexOf(posValue.prices.dates[$index]) >= 0 && posValue.prices.rates[$index] > 0 ? \'strikethrough\' : \'\'\">\n</md-input-container></div></div></div></div></div></div></div></div><div class=\"nightly-price-heading\" \nng-if=\"vm.pageType == \'boat\' && posValue.product_is_timebound == 0 && posValue.prices.dates.length > 0\"><div \nclass=\"nightly-price-heading\"><div layout=\"row\" ng-repeat=\"(datekey ,eachDate) in posValue.prices.dates\" flex=\"100\" \nlayout-wrap class=\"row-nightly-amount row-block1-amount\"><div layout=\"column\" flex=\"30\" layout-align=\"center start\">\n<div class=\"minusiconouter\"><div class=\"charges\" ng-if=\"posValue.prices.canceled_nights.indexOf(eachDate) < 0\">\nNight {{$index+1}}</div><span class=\"onlycursorPointer\" ng-click=\"vm.cancelThisNightPOS(eachDate,posValue)\" \nng-if=\"vm.posNoRefundCancel(datekey,posValue)\"><md-icon md-font-icon=\"icon-minus-circle-outline\" \nclass=\"s15 red-A800-fg\"><md-tooltip>No refund cancel</md-tooltip></md-icon></span><span \nclass=\"onlycursorPointer minusiconred1\" ng-click=\"vm.undoCancelThisNightPOS(eachDate,posValue)\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\" class=\"s15 md-accent\"><md-tooltip>Undo no refund cancel</md-tooltip></md-icon>\n</span><div class=\"charges strikethrough\" ng-if=\"posValue.prices.canceled_nights.indexOf(eachDate) >= 0\">Canceled Night\n</div><div ng-class=\"posValue.show_status == \'Canceled\'?\'canceled_order\':\'\'\"><span \nng-class=\"vm.isloading?\'pointer_events_disabled onlycursorPointer minusiconred1\':\'onlycursorPointer minusiconred1\'\" \nng-click=\"vm.cancelThisNightPOS(eachDate,posValue)\" \nng-if=\"(posValue.prices.nightcount[datekey]==1 || posValue.prices.nightcount[datekey]==posValue.nights) && posValue.nights>1 && posValue.prices.canceled_nights.indexOf(eachDate) < 0\">\n<md-icon md-font-icon=\"icon-minus-circle-outline\" class=\"s15 red-A800-fg\"><md-tooltip>No refund cancel</md-tooltip>\n</md-icon></span><span \nng-class=\"vm.isloading?\'pointer_events_disabled onlycursorPointer minusiconred1\':\'onlycursorPointer minusiconred1\'\" \nng-click=\"vm.undoCancelThisNightPOS(eachDate,posValue)\" \nng-if=\"posValue.prices.canceled_nights.indexOf(eachDate) >= 0 && posValue.prices.canUndoNights.indexOf(eachDate) >= 0 && (posValue.prices.nightcancelledCount[datekey]==1 || posValue.prices.nightcancelledCount[datekey]==(posValue.prices.canceled_nights.length) || (posValue.prices.nightcancelledCount[datekey + 1 ] == -1) ||(posValue.prices.nightcancelledCount[datekey + 1 ] != -1))\">\n<md-icon md-font-icon=\"icon-plus-circle-outline\" class=\"s15 md-accent\"><md-tooltip>Undo no refund cancel</md-tooltip>\n</md-icon></span></div></div></div><div layout=\"column\" flex=\"30\" layout-align=\"center start\"><div \nng-class=\"posValue.prices.canceled_nights.indexOf(eachDate) < 0? \'charges\':\'charges strikethrough\'\">{{eachDate}}</div>\n</div><div layout=\"column\" flex=\"20\" layout-align=\"center end\"><div class=\"amount\"><md-input-container \nng-class=\"posValue.room_stay_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" class=\"md-block no-margin\">\n<i class=\"icon icon-currency-usd s20\"></i> <span class=\"nightly-discount-input-wrap\"><input \nng-model=\"posValue.prices.nightlydiscount[$index]\" name=\"nightly_discount_pos[$parent.$index][$index]\" type=\"text\" \nrequired \nng-change=\"vm.setShowModifyBtn(\'night-{{$index+1}}\',\'nightlydiscount\',posValue.room_stay_id,\'pos\',poskey);vm.sumnightlyDiscPOS(mykey,poskey,datekey,\'call\',$index)\" \nng-model-options=\"{updateOn: \'blur\'}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"> <span \nclass=\"nightly-discount-percent\" ng-if=\"posValue.prices.nightlydiscount[$index] > 0\">\n{{vm.getNightlyDiscountPercent(posValue.prices.nightlydiscount[$index], posValue.prices.rates[$index])}}%</span> \n</span><i ng-if=\"posValue.prices.nightlydiscount[$index]>0\" \nclass=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.opencommentboxNightPOS(poskey,datekey,\'call\',$index);\"><md-tooltip \nng-if=\"posValue.prices.nightlydiscountcomment[$index]!=\'\' && posValue.promotion_applied == 0\">\n{{posValue.prices.nightlydiscountcomment[$index]}}</md-tooltip><md-tooltip ng-if=\"posValue.promotion_applied == 1\">\n{{vm.order.promoTooltip}}</md-tooltip></i></md-input-container></div></div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center end\"><div class=\"amount\"><md-input-container class=\"md-block no-margin\" \nng-class=\"posValue.room_stay_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\"><i \nclass=\"icon icon-currency-usd s20\"></i> <input ng-model=\"posValue.prices.rates[datekey]\" \nname=\"rate_plan[$parent.$index][$index]\" type=\"text\" \nng-change=\"vm.setShowModifyBtn(\'night-{{$index+1}}\',\'prices\',posValue.room_stay_id,\'pos\',poskey);vm.sumNightsPOS(poskey,\'call\')\" \nng-model-options=\"{updateOn: \'blur\'}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div>\n</div></div></div></div></div></div></div></div></div></div><div layout=\"row\" flex=\"100\" class=\"mt-20\"><div \nlayout=\"column\" flex=\"100\" flex-sm=\"100\" flex-xs=\"100\" class=\"ph-15 pb-20 mb-40\"><div layout=\"row\" flex=\"100\" \nclass=\"white-bg\" layout-wrap><div layout=\"column\" flex-gt-md=\"70\" flex-gt-sm=\"60\" flex=\"100\"><div \nclass=\"gry-block-tab pv-0 paymentblocktab no-padding\" id=\"data-table-{{vm.selectedIndex}}\"><form \nname=\"EditResPaymentForm\" ng-attr-id=\"{{ \'EditResPaymentForm\' }}\"><div class=\"role-list-out white-bg\"><div \nclass=\"form-title mb-20 payment-font\">Payment Information</div><div ng-if=\"vm.showPaymentsLoader\" \nclass=\"relative-block pt-15\"><md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\">\n</md-progress-circular></div><div ng-if=\"!vm.showPaymentsLoader\"><div class=\"roomTable\" layout=\"row\" flex layout-wrap>\n<div class=\"room-col\" layout=\"column\" flex=\"100\"><table class=\"dataTable row-border no-padding\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsForPayment\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Transaction Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Paid Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Agent</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Payment</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Customer name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Action</span></div></th><th class=\"secondary-text\" ng-hide=\"true\"><div class=\"table-header\"><span \nclass=\"column-title\">Installment id</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key,installment) in vm.installments\" ng-if=\"key != \'remaining\' && installment.amount>0\"><td>\n{{installment.transaction_id}}</td><td>{{installment.paid_date}}</td><td><span \nng-class=\"installment.status == \'declined\'?\'red-A800-fg\':\'\'\" class=\"refundreason\">{{installment.status}}<md-icon \nmd-font-icon=\"icon-information\" class=\"s18 onlycursorPointer\" ng-if=\"installment.status == \'declined\'\"><md-tooltip \nclass=\"tooltippaymentrefund\">{{installment.txn_reason_desc}}</md-tooltip></md-icon><i \nng-if=\" installment.reason != \'\' \" class=\"icon icon-comment-outline onlycursorPointer discountcomment\"><md-tooltip \nclass=\"tooltippaymentrefund\">{{ installment.reason }}</md-tooltip></i></span></td><td>{{installment.agent}}</td><td>\n{{installment.payment}}</td><td>{{installment.cust_name}}</td><td><span \nng-if=\"installment.status == \'paid\' || installment.status == \'declined\'\">{{installment.amount | currency : $ : 2}}\n</span> <span ng-if=\"installment.status == \'refunded\' && !installment.refund_voided\" class=\"red-A800-fg\">\n-{{installment.amount | currency : $ : 2}}</span> <span \nng-if=\"installment.status == \'refunded\' && installment.refund_voided\">{{installment.amount | currency : $ : 2}}</span>\n</td><td><md-button style=\"max-width:100px;max-height:35px;opacity: 1;pointer-events: all\" \nclass=\"md-raised md-accent submit-button white-fg\" ng-click=\"vm.refundInstallment(installment,\'refund\')\" \naria-label=\"Refund\" \nng-if=\"(installment.transaction_status == \'Settled Successfully\' || installment.transaction_status == \'\') && (installment.installment_amount != 0) && installment.status == \'paid\' && !installment.payment.toLowerCase().includes(\'airbnb\')\">\nRefund</md-button><md-button style=\"max-width:100px;max-height: 35px;opacity: 1;pointer-events: all\" \nclass=\"md-raised md-accent submit-button white-fg md-red-500-bg\" ng-click=\"vm.refundInstallment(installment,\'void\')\" \naria-label=\"Refund\" \nng-if=\"!installment.hide_void && (installment.transaction_status == \'capturedPendingSettlement\') && installment.installment_amount != 0 && installment.rm_adjustment_indicator == 0 && installment.status == \'paid\'\">\nVoid</md-button><md-button style=\"max-width:100px;max-height: 35px;opacity: 1;pointer-events: all\" \nclass=\"md-raised md-accent submit-button white-fg md-red-500-bg\" \nng-click=\"vm.refundInstallment(installment,\'void-refunded\')\" aria-label=\"Refund\" \nng-if=\"!installment.hide_void && (installment.transaction_status == \'Refund/Pending Settlement\') && installment.installment_amount != 0 && installment.status == \'refunded\'\">\nVoid</md-button><md-button style=\"max-width:100px;max-height: 35px;opacity: 1;pointer-events: all\" \nclass=\"md-raised md-accent submit-button white-fg md-red-500-bg\" \nng-click=\"vm.refundInstallment(installment,\'void-giftCard\')\" aria-label=\"Refund\" \nng-if=\"installment.payment.indexOf(\'Gift Card\') > -1 && installment.installment_amount != 0 && installment.status == \'refunded\' && installment.parentId != 0 && installment.parentId != \'\'\">\nVoid Gift card</md-button><md-button style=\"max-width:100px;max-height:35px;opacity: 1;pointer-events: all\" \nclass=\"md-raised md-accent submit-button white-fg black-background\" \nng-click=\"vm.transferAmount(vm.tabs_data[vm.selectedIndex][\'confirmation_number\'], installment.installment_id)\" \naria-label=\"Refund\" \nng-if=\"vm.tabs_data[vm.selectedIndex][\'transferAmount\'] && installment.status != \'refunded\' && installment.transaction_status != \'voided\' && installment.isTransferable && vm.order.overalltotals.remaining_amount != 0\">\nTransfer</md-button><span ng-if=\"installment.transaction_status == \'voided\'\">Voided</span> <span \nng-if=\"installment.transaction_status != \'voided\' && (installment.transaction_status != \'Settled Successfully\' || (installment.transaction_status == \'Settled Successfully\' && installment.installment_amount == 0)) && installment.transaction_status != \'capturedPendingSettlement\'\">\n{{installment.transaction_status}}</span> <span \nng-if=\"installment.payment.indexOf(\'Gift Card\') > -1 && installment.refund_voided\">Voided</span></td><td \nng-hide=\"true\">{{installment.installment_id}}</td></tr></tbody></table></div></div><div layout=\"row\" layout-wrap \nflex=\"100\" class=\"margin-top-25 padding-left-10 padding-right-10\" layout-align=\"start center\"><md-input-container \nstyle=\"min-width:150px\" class=\"md-block mb-0 no-error-spacer\" layout=\"column\" flex=\"20\" layout-align=\"center \" \nid=\"focus-cccode\" ng-if=\"vm.installments[\'remaining\'].balance > 0 && vm.showPaymentOptions\"><input type=\"text\" \nng-init=\"vm.installment_amount=vm.installments[\'remaining\'].balance\" ng-model=\"vm.installment_amount\" \nng-change=\"vm.checkremainingAmount(vm.selectedIndex)\" allow-decimal-numbers autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"> <input type=\"hidden\" ng-model=\"vm.installments[\'remaining\'].origremainingamt\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container><md-button \nstyle=\"max-width:100px;max-height: 35px\" \nng-class=\"((EditResPaymentForm.$invalid && !vm.fieldsIsReadOnly) || !vm.installment_amount || !vm.payment_method.payment_method) || vm.paymentrequestGoing || vm.not_incidental || vm.incidentalrequestGoing?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-accent submit-button white-fg\'\" \nng-disabled=\"((EditResPaymentForm.$invalid && !vm.fieldsIsReadOnly) || !vm.installment_amount || !vm.payment_method.payment_method || vm.exp_date_err) || vm.paymentrequestGoing || vm.not_incidental || vm.incidentalrequestGoing || vm.installment_amount == 0 || (vm.payment_method.payment_method==\'Check\' && !vm.payment_method.check_number)\" \nng-click=\"vm.payInstallment(vm.order.confirmation_number,vm.selectedIndex,vm.order.first_name,vm.order.last_name)\" \naria-label=\"Pay now\" ng-if=\"vm.installments[\'remaining\'].balance > 0 && vm.showPaymentOptions\">Pay now\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.paymentrequestGoing\">\n</md-progress-circular></md-button><div class=\"padding-right-10 promoinput\" \nng-class=\"vm.installments[\'remaining\'].balance>0 && vm.showPaymentOptions ? \'padding-left-30\' : \'padding-left-0\'\" \nlayout=\"column\" flex=\"40\" layout-align=\"center start\" ng-if=\"!vm.order.anyPromoApplied\"><div layout=\"row\" flex \nlayout-align=\"center\"><md-input-container class=\"md-block mb-0 mb-0\"><label>Promo Code</label><input \nng-model=\"vm.order.promoCodeName\" name=\"promocode\" type=\"text\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\">\n</md-input-container><md-button style=\"max-height:40px\" class=\"md-raised\" \nng-click=\"vm.applyRemoveValidPromoCode(\'applied\')\" ng-disabled=\"vm.order.promoCodeName == \'\' || vm.promoRequestGoing\">\n<span>Apply</span><md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.promoRequestGoing\"></md-progress-circular></md-button></div></div><div class=\"padding-right-10 promo-div\" \nng-class=\"vm.installments[\'remaining\'].balance>0 && vm.showPaymentOptions ? \'padding-left-30\' : \'padding-left-0\'\" \nlayout=\"column\" flex=\"40\" layout-align=\"center\" ng-if=\"vm.order.anyPromoApplied\"><div class=\"promocode-row\"><div \nclass=\"promocodeleft\"><label>Promo Code</label><p>{{vm.order.promoCodeName}}</p></div><div class=\"promocoderight\">\n<label>{{vm.order.promoCodeDiscount | currency : $ : 2}}</label><p ng-click=\"vm.applyRemoveValidPromoCode(\'remove\')\">\n<md-icon md-font-icon=\"icon-close-circle\" class=\"red-A800-fg\" style=\"font-size:17px\"></md-icon>Remove</p></div></div>\n</div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"20\" layout-align=\"center\" \nng-if=\"vm.payingFromGC.price>0\"><span layout=\"column\" flex=\"100\" layout-align=\"start \" class=\"gcPayNow\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s15 red-A800-fg\"></md-icon><span class=\"payingFFc\">\n${{vm.payingFromGC.price}} from gift card</span></span></div></div><div class=\"form-title mt-15\" \nng-if=\"vm.showPaymentOptions\">Payment Methods</div><div layout=\"row\" flex=\"100\" \nclass=\"margin-bottom-15 margin-top-20 padding-left-10 padding-right-10 margin-bottom-30\" layout-wrap>\n<md-input-container class=\"md-block mb-0 md-input-has-value no-margin\" layout=\"column\" flex=\"100\" flex-gt-md=\"80\" \nflex-gt-sm=\"60\" layout-align=\"center \"><md-radio-group class=\"\" ng-model=\"vm.payment_method.payment_method\" required \nlayout=\"row\" flex=\"100\" layout-wrap ng-change=\"vm.onPaymentMethodSelect(vm.payment_method.payment_method)\">\n<md-radio-button layout=\"column\" flex=\"50\" flex-gt-md=\"25\" flex-gt-xs=\"50\" layout-align=\"center \" \nclass=\"space-block-inline margin-right-0\" ng-repeat=\"paymentMethod in vm.all_payment_methods\" \nng-value=\"paymentMethod.heading\" ng-click=\"vm.onPaymentMethodClick(paymentMethod.heading)\">{{paymentMethod.heading}}\n</md-radio-button></md-radio-group></md-input-container><md-input-container \nclass=\"md-block mb-0 md-input-has-value no-margin padding-top-8\" layout=\"column\" flex=\"100\" flex-gt-md=\"20\" \nflex-gt-sm=\"40\" layout-align=\"center \" ng-if=\"vm.showPaymentOptions\"><md-checkbox type=\"checkbox\" \nng-model=\"vm.giftCard\" class=\"no-margin\"></md-checkbox>&nbsp;<span class=\"padding-left-10\" \ntranslate=\"CREATE_RES.GIFT_CARD\"></span></md-input-container></div><div ng-if=\"vm.giftCard\" ng-disabled=\"!vm.giftCard\">\n<div layout=\"row\" flex=\"100\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" \nlayout-align=\"center\"><div layout=\"row\" flex><md-input-container class=\"md-block mb-0 mb-0\"><label>Apply Gift Card\n</label><input ng-model=\"vm.giftCardCode\" name=\"giftCard\" type=\"text\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\">\n<div class=\"emailError\">{{vm.giftCardErrro}}</div></md-input-container><md-button style=\"max-height:40px\" \nclass=\"md-raised\" ng-click=\"vm.validateGCCode(vm.selectedIndex)\" \nng-disabled=\"vm.giftCardCode==\'\' || vm.gcrequestGoing\">Add<md-progress-circular \nclass=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.gcrequestGoing\"></md-progress-circular>\n</md-button></div></div></div></div><div ng-if=\"vm.payment_method.payment_method===\'Check\'\" \nng-disabled=\"vm.payment_method.payment_method!=\'Check\'\"><div layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"50\" flex-xs=\"100\" layout-align=\"center\">\n<md-input-container class=\"md-block mb-0 mb-0\"><label translate=\"CREATE_RES.CHECK_NO\"></label><input \nng-model=\"vm.payment_method.check_number\" name=\"check_number[vm.selectedIndex]\" type=\"text\" required \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div></div><div \nng-if=\"vm.payment_method.payment_method===\'Other\'\" ng-disabled=\"vm.payment_method.payment_method!=\'Other\'\"><div \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"50\" \nflex-xs=\"100\" layout-align=\"center\"><md-input-container class=\"md-block mb-0 mb-0\"><label \ntranslate=\"CREATE_RES.OTHER_COMMENT\"></label><textarea ng-model=\"vm.payment_method.other_comment\" \nname=\"other_comment[vm.selectedIndex]\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></textarea></md-input-container>\n</div></div></div><div ng-if=\"vm.payment_method.payment_method === \'Credit Card\'\" \nng-disabled=\"vm.payment_method.payment_method!=\'Credit Card\'\" ng-attr-id=\"{{ \'paymentccblock-\' + vm.selectedIndex }}\" \nclass=\"fontsize-15\"><div ng-if=\"vm.addNewCard || vm.allcardsInfo.length == 0\"><label style=\"color:red\" \nid=\"authorizenet-swiper-status\" ng-click=\"vm.swipeNow()\" for=\"authorizenetswiper-data\" class=\"ph-10\">{{vm.swipeText}}\n</label><input type=\"text\" style=\"height: 1px; width: 1px; border: 0 none; color: #FFF; font-size: 1px\" title=\"Swiper\" \ncode=\"authorizenet\" class=\"input-text webpos_swiper_input\" ng-model=\"vm.ccinfo_a\" ng-focus=\"vm.readySwipe()\" \nng-blur=\"vm.resetSwipe()\" ng-keyup=\"vm.keyupfunction($event)\" id=\"authorizenet-swiper-data\" \nname=\"authorizenet-swiper-data\" value=\"    \" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></div><div layout=\"row\" \nflex layout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"50\" \nlayout-align=\"center \" ng-if=\"vm.allcardsInfo.length>0\"><md-input-container class=\"md-block mb-0\" layout=\"column\" \nflex=\"100\" flex-gt-md=\"50\" flex-gt-xs=\"50\" layout-align=\"center \"><label translate=\"CREATE_RES.USE_EXISTINGCARD\">\n</label><md-select ng-model=\"vm.use_existingcard\" ng-change=\"vm.changeActiveCard(vm.selectedIndex,vm.selectedIndex)\">\n<md-option ng-value=\"key\" ng-repeat=\"(key,cardData) in vm.allcardsInfo\">\nxxxx-{{cardData.cc_number}}({{cardData.cc_type}}){{cardData.cc_is_incidental==0?\'\':\'*Incidentals\'}}</md-option>\n</md-select><div class=\"md-errors-spacer\" style=\"display:block\"></div></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"50\" layout-align=\"start\"><div><md-button \nstyle=\"max-height:40px;max-width:150px\" class=\"md-raised mt-15\" ng-click=\"vm.emptythisPayment(vm.selectedIndex)\" \nng-if=\"vm.allcardsInfo.length > 0 && !vm.addNewCard\">Add New Card</md-button><md-button \nstyle=\"max-height:40px;max-width:150px\" class=\"md-raised mt-15\" \nng-click=\"vm.setasincidental(vm.order.confirmation_number,vm.selectedIndex,vm.order.first_name,vm.order.last_name, \'not_incidental\')\" \nng-if=\"vm.allcardsInfo.length == 0 || vm.addNewCard\" \nng-disabled=\"(EditResPaymentForm.$invalid && !vm.fieldsIsReadOnly) || vm.not_incidental || vm.paymentrequestGoing || vm.incidentalrequestGoing\">\nSave New Card<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.not_incidental\"></md-progress-circular></md-button><md-button \nng-if=\"vm.payment_method.cc_is_incidental!=1 && !vm.addNewCard\" style=\"max-height:40px;max-width:150px\" \nclass=\"md-raised mt-15\" \nng-click=\"vm.setasincidental(vm.order.confirmation_number,vm.selectedIndex,vm.order.first_name,vm.order.last_name, \'is_incidental\')\" \nng-disabled=\"(EditResPaymentForm.$invalid && !vm.fieldsIsReadOnly) || vm.incidentalrequestGoing\">Set as Incidental\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.incidentalrequestGoing\">\n</md-progress-circular></md-button></div></div></div><div ng-class=\"vm.fieldsIsReadOnly?\'pointer_events_disabled\':\'\'\">\n<div layout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10 orange-500-fg mb-10\" \nlayout=\"column\" flex=\"50\" flex-xs=\"100\" layout-align=\"center\" ng-if=\"vm.payment_method.cc_is_incidental==1\">\n*Incidental Card</div></div><div layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10 datepicker-block\" layout=\"column\" flex-xs=\"100\" flex=\"100\" \nlayout-align=\"center \"><div layout=\"row\" flex=\"100\" layout-wrap><md-input-container class=\"md-block mb-0\" \nlayout=\"column\" flex=\"80\"><label translate=\"CREATE_RES.CC_NUMBER\"></label><input \nng-model=\"vm.payment_method.cc_number_mask\" name=\"cc_number_mask\" type=\"text\" required \nng-keyup=\"vm.creditCardChanged($event,EditResPaymentForm[\'cc_number\'].$ccEagerType,vm.payment_method)\" maxlength=\"16\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div \nng-show=\"!vm.fieldsIsReadOnly && EditResPaymentForm[\'cc_number_mask\'].$touched\"><div \nng-show=\"!EditResPaymentForm[\'cc_number\'].$valid\" ng-hide=\"EditResPaymentForm[\'cc_number\'].$valid\" class=\"emailError\">\n{{ \'CREATE_RES.CR_NOT_VALID\' | translate }}</div></div><div ng-show=\"vm.notCardType\" ng-hide=\"!vm.notCardType\" \nclass=\"emailError\">{{ \'CREATE_RES.CR_NOT_ALOWD\' | translate }}</div></md-input-container><input \nng-model=\"vm.payment_method.cc_number\" name=\"cc_number\" type=\"hidden\" cc-number cc-eager-type autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"> <input type=\"hidden\" ng-model=\"vm.payment_method.customer_profile_id\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"> <input type=\"hidden\" ng-model=\"vm.payment_method.payment_profile_id\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"><div cc_type=\"{{vm.payment_method.cc_type?vm.payment_method.cc_type:vm.ct }}\" \nclass=\"{{vm.payment_method.cc_type? vm.payment_method.cc_type:vm.ct}}\" layout=\"column\" flex=\"20\"></div></div></div>\n</div><div layout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"33\" layout-align=\"center\"><md-input-container class=\"md-block mb-0\"><label \ntranslate=\"CREATE_RES.EXP_MONTH\"></label><md-select name=\"cc_exp_date\" ng-model=\"vm.payment_method.cc_exp_month\" \nng-change=\"vm.checkValidExpDate()\" required><md-option ng-value=\"key\" ng-repeat=\"(key,months) in vm.dates_option\">\n{{months}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-gt-xs=\"33\" flex=\"100\" layout-align=\"center\">\n<md-input-container class=\"md-block mb-0\"><label translate=\"CREATE_RES.EXP_YEAR\"></label><md-select name=\"cc_exp_year\" \nng-model=\"vm.payment_method.cc_exp_year\" ng-change=\"vm.checkValidExpDate()\" required><md-option ng-value=\"year\" \nng-repeat=\"year in vm.yrs_option\">{{year}}</md-option></md-select><div ng-show=\"vm.exp_date_err\" \nng-hide=\"!vm.exp_date_err\" class=\"emailError\">{{ \'CREATE_RES.EX_DATE_NOT_VALID\' | translate }}</div><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div class=\"padding-left-10 padding-right-10\" \nlayout=\"column\" flex-gt-xs=\"33\" flex=\"100\" layout-align=\"center \"><md-input-container class=\"md-block mb-0\"><label \ntranslate=\"CREATE_RES.CC_CVN\"></label><input ng-model=\"vm.payment_method.cc_cid\" name=\"cc_cvv{{vm.selectedIndex}}\" \ntype=\"text\" ng-required=\"!vm.fieldsIsReadOnly && vm.currentHotelId != 128 && vm.currentHotelId != 129\" cc-cvc \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div \nng-show=\"EditResPaymentForm[\'cc_cvv\' + vm.selectedIndex].$touched\"><div \nng-show=\"!EditResPaymentForm[\'cc_cvv\' + vm.selectedIndex].$valid && !EditResPaymentForm[\'cc_cvv\' + vm.selectedIndex].$error.required\" \nclass=\"emailError\">{{ \'CREATE_RES.CVN_NOT_VALID\' | translate }}</div></div></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" \nflex=\"33\" layout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0\"><label \ntranslate=\"CREATE_RES.CUST_FN_CC\"></label><input ng-model=\"vm.payment_method.cc_fname\" name=\"cc_fn[vm.selectedIndex]\" \ntype=\"text\" required autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"33\" layout-align=\"center \">\n<md-input-container class=\"md-block mb-0 mb-0\"><label translate=\"CREATE_RES.CUST_MN_CC\"></label><input \nng-model=\"vm.payment_method.cc_mname\" name=\"cc_mn[vm.selectedIndex]\" type=\"text\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"33\" flex-xs=\"100\" layout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0\"><label \ntranslate=\"CREATE_RES.CUST_LN_CC\"></label><input ng-model=\"vm.payment_method.cc_lname\" name=\"cc_ln[vm.selectedIndex]\" \ntype=\"text\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div></div></div><div \nng-if=\"vm.payment_method.payment_method === \'E-Check\'\" ng-disabled=\"vm.payment_method.payment_method!=\'E-Check\'\" \nng-attr-id=\"{{ \'paymentccblock-\' + vm.selectedIndex }}\" class=\"fontsize-15\"><div><div layout=\"row\" flex=\"100\" \nlayout-wrap><div class=\"padding-left-10 padding-right-10 datepicker-block\" layout=\"column\" flex-xs=\"100\" flex=\"100\" \nlayout-align=\"center \"><div layout=\"row\" flex=\"100\" layout-wrap><md-input-container class=\"md-block mb-0\" \nlayout=\"column\" flex=\"100\"><label>Name Of Bank</label><input ng-model=\"vm.payment_method.bankName\" name=\"bankName\" \ntype=\"text\" required autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container><input type=\"hidden\" \nng-model=\"vm.payment_method.payment_profile_id\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></div></div></div><div \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"33\" layout-align=\"center\"><md-input-container class=\"md-block mb-0\"><label>Account Type</label><md-select \nname=\"accountType\" ng-model=\"vm.payment_method.accountType\" required><md-option value=\"checking\">Checking</md-option>\n<md-option value=\"saving\">Saving</md-option><md-option value=\"businessChecking\">Bisiness Checking</md-option>\n</md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-gt-xs=\"33\" flex=\"100\" layout-align=\"center \">\n<md-input-container class=\"md-block mb-0\"><label>Account Number</label><input \nng-model=\"vm.payment_method.accountNumber\" name=\"accountNumber\" type=\"text\" ng-required=\"true\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex-gt-xs=\"33\" flex=\"100\" layout-align=\"center \"><md-input-container class=\"md-block mb-0\"><label>Routing Number\n</label><input ng-model=\"vm.payment_method.routingNumber\" name=\"routingNumber\" type=\"text\" ng-required=\"true\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"33\" \nlayout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0\"><label>Name On Account</label><input \nng-model=\"vm.payment_method.nameOnAccount\" name=\"nameOnAccount\" type=\"text\" required autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex-xs=\"100\" flex=\"33\" layout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0 mt-0\"><label>E-Check Type\n</label><md-select name=\"accountType\" ng-model=\"vm.payment_method.echeckType\" required><md-option value=\"PPD\">\nPrearranged Payment And Deposit Entry</md-option><md-option value=\"WEB\">Internet-Initiated Entry</md-option>\n</md-select></md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"33\" \nflex-xs=\"100\" layout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0\"><label>Check Number</label><input \nng-model=\"vm.payment_method.checkNumber\" name=\"checkNumber\" type=\"text\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div></div></div></div></div></div></form></div></div><div \nlayout=\"column\" flex-gt-md=\"30\" flex-gt-sm=\"40\" flex=\"100\" class=\"subtotalborder-left pv-20\"><div \nclass=\"section-right-genral role-list-out featured-rol-block\"><div \nclass=\"display-inline-block role-list-out white-bg top-sp-main no-padding\"><div layout=\"row\" flex=\"100\" layout-wrap>\n<div class=\"sub-total-section\" ng-if=\"!vm.extraPersonPos && !vm.order.boat_data\" layout=\"row\" flex=\"100\" layout-wrap \nng-class=\"vm.order.show_status == \'Canceled\' || vm.order.show_status == \'No Show\' || vm.modify_request?\'canceled_order\':\'\'\">\n<div class=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\" center start\">\n{{ vm.pageType == \'rent\' ? \'Application Fee\':\'Extra Person Charges\'}}{{$index}}</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" flex=\"35\" \nlayout-align=\"center end \"><div class=\"amount\"><md-input-container class=\"md-block mb-0 no-margin\"><i \nclass=\"icon icon-currency-usd s20\"></i> <input ng-model-options=\"{updateOn: \'blur\'}\" \nng-change=\"vm.setShowModifyBtn(\'ExtraCharges\',\'additional_guest_amounts\',vm.order.room_stay_id);vm.calculateOrderTotals();\" \nng-model=\"vm.order.additional_guest_amounts\" name=\"additional_guest_amounts[vm.selectedIndex]\" type=\"text\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div></div><div class=\"sub-total-section\" \nlayout=\"row\" flex=\"100\" layout-wrap \nng-if=\" vm.order.extraPersonProduct != undefined &&  vm.order.extraPersonProduct.extra_attribute != undefined && vm.order.extraPersonProduct.extra_attribute == \'extra_person\'\">\n<div class=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && mykey>0)?\'70\':\'50\'}}\" \nlayout-align=\"{{(vm.multOrSinglePayment && mykey>0)?\'center end\':\'center start\'}}\">\n{{ vm.order.extraPersonProduct.product_name }}</div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && mykey>0)?\'5\':\'15\'}}\" layout-align=\" center center\">:</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && mykey>0)?\'25\':\'35\'}}\" \nlayout-align=\"center end \" ng-if=\"vm.order.extraPersonProduct.room_stay_status != \'Canceled\' \">\n{{vm.order.extraPersonProduct.nightlySum | currency : $ : 2}}</div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && mykey>0)?\'25\':\'35\'}}\" layout-align=\"center end \" \nng-if=\"vm.order.extraPersonProduct.room_stay_status == \'Canceled\' \">{{ 0 | currency : $ : 2}}</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap><div class=\"sub-total-col\" layout=\"column\" flex=\"50\" \nlayout-align=\"center start\"><div flex=\"100\" layout-align=\"center center\" layout=\"row\"><span layout=\"column\">Subtotal\n</span></div></div><div class=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end\" \nng-if=\"vm.order.collect_which == \'airbnb_collect\'\">\n{{(vm.subtractSubtotal(vm.order.overalltotals.subtotal, vm.order.extraPersonProduct.nightlySum, vm.order.resortFeePos.nightlySum) - vm.order.overalltotals.product_discount) | currency : $ : 2}}\n</div><div class=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end\" \nng-if=\"vm.order.commision_charges>0 && (vm.order.collect_which==\'channel_collect\' && vm.order.collect_which != \'airbnb_collect\')\">\n{{ vm.subtractSubtotal(vm.sumOfVals(vm.order.overalltotals.subtotal,vm.order.commision_charges), vm.order.extraPersonProduct.nightlySum, vm.order.resortFeePos.nightlySum) | currency : $ : 2}}\n</div><div class=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end\" \nng-if=\"vm.order.commision_charges<=0 || (vm.order.collect_which!=\'channel_collect\' && vm.order.collect_which!=\'airbnb_collect\')\">\n{{ vm.subtractSubtotal(vm.order.overalltotals.subtotal, vm.order.extraPersonProduct.nightlySum, vm.order.resortFeePos.nightlySum) | currency : $ : 2}}\n</div></div><div class=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"(vm.order.commision_charges>0 || vm.order.ota_service_fee_amount > 0) && (vm.order.collect_which == \'channel_collect\' || vm.order.collect_which == \'airbnb_collect\')\">\n<div class=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\" center start\"><div flex=\"100\" \nlayout-align=\"center center\" layout=\"row\"><span layout=\"column\" ng-if=\"vm.order.collect_which != \'airbnb_collect\'\">OTA\n</span><p layout=\"column\" ng-if=\"vm.order.collect_which == \'airbnb_collect\'\" class=\"m-0\">Airbnb Hotel Fees <small>\n15.5% + Payout</small><small class=\"airbnb-summary\">Paid by Hotel to Airbnb</small></p></div></div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div \nclass=\"sub-total-col sub-total-col-ota\" layout=\"column\" flex=\"35\" layout-align=\"center end\">\n{{vm.order.commision_charges | currency : $ : 2}} + {{vm.subtractSubtotal(vm.order.overalltotals.subtotal, vm.order.extraPersonProduct.nightlySum) | currency : $ : 2}}\n</div></div><div class=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.order.ota_service_fee_amount > 0 && vm.order.collect_which == \'airbnb_collect\'\"><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"50\" layout-align=\" center start\"><div flex=\"100\" layout-align=\"center center\" layout=\"row\"><p \nclass=\"m-0\">Airbnb Service Fee <small>12% </small><small class=\"airbnb-summary\">Paid by Customer to Airbnb</small></p>\n</div></div><div class=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end\">\n{{vm.order.ota_service_fee_amount | currency : $ : 2}}</div></div><div class=\"sub-total-section\" layout=\"row\" \nflex=\"100\" layout-wrap><div class=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\" center start\">Discount</div>\n<div class=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"35\" layout-align=\"center end \">({{vm.order.normalDiscount | currency : $ : 2}})</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.order.promoCodeDiscount != undefined && vm.order.promoCodeDiscount > 0\"><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"50\" layout-align=\" center start\">Promo code Discount</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" flex=\"35\" \nlayout-align=\"center end \">({{vm.order.promoCodeDiscount | currency : $ : 2}})</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"(vm.order.overalltotals.product_discount>0 || vm.order.commision_charges>0) && (vm.order.collect_which == \'channel_collect\' || vm.order.collect_which == \'airbnb_collect\')\">\n<div class=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\" center start\"><div flex=\"100\" \nlayout-align=\"center center\" layout=\"row\"><span layout=\"column\">New Subtotal</span></div></div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"35\" layout-align=\"center end \">\n{{(vm.sumOfVals(vm.order.commision_charges, vm.order.overalltotals.subtotal) - vm.sumOfVals(vm.order.resortFeePos.nightlySum, vm.order.normalDiscount, vm.order.extraPersonProduct.nightlySum) | currency : $ : 2)}}\n</div></div><div class=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.order.resortFeeApplied && vm.order.resortFeePos != undefined && vm.order.resortFeePos.extra_attribute == \'resort_fee\'\">\n<div class=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && mykey>0)?\'70\':\'50\'}}\" \nlayout-align=\"{{(vm.multOrSinglePayment && mykey>0)?\'center end\':\'center start\'}}\">\n{{ vm.order.resortFeePos.product_name }}</div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"{{(vm.multOrSinglePayment && mykey>0)?\'5\':\'15\'}}\" layout-align=\" center center\">:</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"{{(vm.multOrSinglePayment && mykey>0)?\'25\':\'35\'}}\" \nlayout-align=\"center end \">{{vm.order.resortFeePos.nightlySum | currency : $ : 2}}</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap \nng-repeat=\"(taxKey,taxValue) in vm.order.overalltotals.tax_names track by $index\" \nng-if=\"(vm.order.overalltotals.tax_names.length > 0 && vm.order.overalltotals.tax_amounts[taxKey] > 0) || (vm.order.overalltotals.tax_names.length > 0 && taxValue == \'Long Term Stay\')\">\n<div class=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\" center start\" \nng-if=\"vm.order[\'taxes\'][taxKey][\'applied_on_field\'] == \'timebound_static\'\"><p class=\"m-0\">{{taxValue}} <small>\n${{vm.order[\'allTaxes\'][taxValue]+\' per night\'}}</small></p></div><div class=\"sub-total-col\" layout=\"column\" flex=\"50\" \nlayout-align=\" center start\" ng-if=\"vm.order[\'taxes\'][taxKey][\'applied_on_field\'] != \'timebound_static\'\"><p \nclass=\"m-0\" ng-if=\"vm.order[\'taxes\'][taxKey][\'temp_perc\'] !== undefined\">{{taxValue}} <small class=\"airbnb-summary\">\nPaid by Customer to Airbnb {{vm.order[\'allTaxes\'][taxValue]+\'%\'}}</small></p><p class=\"m-0\" \nng-if=\"taxValue.indexOf(\'Paid by Customer to Hotel\') > -1 && vm.order.collect_which == \'airbnb_collect\'\">Lodging Tax\n<small class=\"airbnb-summary\">{{taxValue}}</small></p><p class=\"m-0\" \nng-if=\"vm.order.overalltotals.tax_abb_subHeading !== undefined && vm.order.collect_which == \'airbnb_collect\'\">\n{{taxValue}}<small class=\"airbnb-summary\">{{vm.order.overalltotals.tax_abb_subHeading[taxKey]}}</small></p><p \nclass=\"m-0\" \nng-if=\"(vm.order.overalltotals.tax_abb_subHeading == undefined || vm.order.collect_which != \'airbnb_collect\') && taxValue.indexOf(\'Paid by Customer to Hotel\') < 0\">\n{{taxValue}} <small>{{vm.order[\'allTaxes\'][taxValue]+\'%\'}}</small></p></div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" flex=\"35\" \nlayout-align=\"center end \">{{vm.order.overalltotals.tax_amounts[taxKey] | currency : $ : 2}}</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.order.customerTaxExempt || vm.order.travellerTaxExempt\"><div class=\"sub-total-col\" layout=\"column\" flex=\"50\" \nlayout-align=\" center start\"><p class=\"m-0\" \nng-if=\"(vm.order.customerTaxExempt && vm.order.travellerTaxExempt) || vm.order.customerTaxExempt\">Customer Tax Exempt\n</p><p class=\"m-0\" ng-if=\"vm.order.travellerTaxExempt && !vm.order.customerTaxExempt\">Traveller Tax Exempt</p></div>\n<div class=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"35\" layout-align=\"center end \">{{ 0 | currency : $ : 2}}</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.order.overalltotals.surcharge && vm.order.overalltotals.surcharge > 0\"><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"{{(vm.multOrSinglePayment && $index>0)?\'70\':\'50\'}}\" \nlayout-align=\"{{(vm.multOrSinglePayment && $index>0)?\'center end\':\'center start\'}}\"><div class=\"Surchargetxt\"><span>\nSurcharge</span> <span class=\"icon-information info-icon info-icon-tax-report\" role=\"button\" \nstyle=\"position: absolute; left: 76px; font-size: 19px\" ng-mouseenter=\"vm.showSurchargeTooltip(true);\" \nng-mouseleave=\"vm.showSurchargeTooltip(false);\" ng-if=\"vm.order.surchargeDesc != \'\'\"></span><div class=\"infoTooltip\" \nng-if=\"vm.showSurchargeDescTooltip\"><div class=\"tooltip-block-main\">{{vm.order.surchargeDesc}}</div></div></div></div>\n<div class=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"{{(vm.multOrSinglePayment && $index>0)?\'25\':\'35\'}}\" layout-align=\"center end \">\n{{vm.order.overalltotals.surcharge | currency : $ : 2}}</div></div><div class=\"sub-total-section\" layout=\"row\" \nflex=\"100\" layout-wrap><div class=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\" center start\">Grand Total\n</div><div class=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end \">\n{{vm.order.overalltotals.grand_total | currency : $ : 2}}</div></div><div class=\"sub-total-section\" layout=\"row\" \nflex=\"100\" layout-wrap ng-if=\"vm.isRoundUpEnable() && vm.getRoundUpForCharityAmount() > 0\"><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"50\" layout-align=\" center start\">Round Up Amount</div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" flex=\"35\" \nlayout-align=\"center end \">{{vm.getRoundUpForCharityAmount() | currency : $ : 2}}</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap><div class=\"sub-total-col\" layout=\"column\" flex=\"50\" \nlayout-align=\" center start\">Paid Amount</div><div class=\"sub-total-col\" layout=\"column\" flex=\"15\" \nlayout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end \">\n{{vm.order.overalltotals.paid_amount | currency : $ : 2}}</div></div><div class=\"sub-total-section\" layout=\"row\" \nflex=\"100\" layout-wrap><div class=\"sub-total-col md-accent-fg\" layout=\"column\" flex=\"50\" layout-align=\" center start\">\nRemaining Amount</div><div class=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end \"><div layout=\"row\" layout-align=\"end center\">\n<span>{{vm.order.overalltotals.remaining_amount | currency : $ : 2}}</span></div><span \nng-if=\"vm.isRoundUpEnable() && !vm.autoFillOff && vm.order.overalltotals.remaining_amount > 0.01 && vm.shouldShowRoundUp()\" \nng-click=\"!(vm.modify_request || vm.isloading) && vm.applyRemainingRoundUp()\" class=\"round-up-action md-accent-fg\" \nng-class=\"{\'is-disabled\': vm.modify_request || vm.isloading}\">Round Up</span></div></div></div></div></div></div></div>\n</div></div></div></md-tab><md-tab label=\"Notes\" \nng-click=\"vm.fetchOrderCommentsRequests(vm.order.confirmation_number)\" style=\"height:100%\"><div \nclass=\"gry-block-tab spInfo comments_section\"><div class=\"white-bg mh-10 width-calc\" style=\"height:100%\" layout=\"row\" \nflex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-xs=\"100\"><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"mt-30\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-md=\"40\" flex-gt-sm=\"50\" \nlayout-align=\"start end \"><md-input-container class=\"md-block mb-0 mt-0 full-width\"><label translate=\"CREATE_RES.NOTE\">\n</label><textarea ng-model=\"vm.comm_req_value\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></textarea>\n</md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-md=\"30\" \nflex-gt-sm=\"50\" layout-align=\"center start \"><md-input-container class=\"md-block mb-0 mt-0\"><md-radio-group \nclass=\"no-margin\" ng-init=\"vm.comm_req_type = \'comment\'\" ng-model=\"vm.comm_req_type\"><md-radio-button \nclass=\"space-block-inline\" value=\"comment\">{{ \'CREATE_RES.COMMENT\' | translate }}</md-radio-button><md-radio-button \nclass=\"space-block-inline margin-left-15\" value=\"special_request\">{{ \'CREATE_RES.SPECIAL_RQST\' | translate }}\n</md-radio-button><md-radio-button class=\"space-block-inline margin-left-15\" value=\"pos_comment\">\n{{ \'CREATE_RES.POS_COMMENT\' | translate }}</md-radio-button></md-radio-group></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-md=\"30\" flex-gt-sm=\"100\" \nlayout-align=\"start start\"><md-button style=\"max-width:100px\" \nng-class=\"!vm.comm_req_value?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-accent submit-button white-fg\'\" \nng-disabled=\"!vm.comm_req_value\" ng-click=\"vm.saveCommentReq(vm.selectedIndex,vm.order.confirmation_number)\" \naria-label=\"add comment\">Submit</md-button></div></div></div><div class=\"no-results text-center full-width\" \nng-if=\"vm.commentsSpecial.special_request.length === 0 && vm.commentsSpecial.posComment.length === 0 && vm.commentsSpecial.comment.length === 0\">\n<div class=\"message\"><div class=\"message-text\" translate=\"EC.NO_SPE_REQ\"></div></div></div></div><div \nclass=\"messanary-block\"><div class=\"messnary-row-block threeCols\"><div class=\"messanary-col-block notes request-blk\" \nng-repeat=\"note in vm.commentsSpecial.special_request\"><div class=\"note special_note\"><div class=\"title\" \nng-bind-html=\"note.title\"></div><div class=\"dateblock\">{{note.description}}</div></div></div></div></div><div \nclass=\"messanary-block\"><div class=\"messnary-row-block threeCols\"><div \nclass=\"messanary-col-block notes pos-request-blk\" ng-repeat=\"note in vm.commentsSpecial.posComment\"><div \nclass=\"note special_note\"><div class=\"title\" ng-bind-html=\"note.title\"></div><div class=\"dateblock\">\n{{note.description}}</div></div></div></div></div><div class=\"messanary-block\"><div class=\"messnary-row-block\"><div \nclass=\"messanary-col-block notes\" ng-repeat=\"note in vm.commentsSpecial.comment\"><div class=\"note special_note\"><div \nclass=\"title\" ng-bind-html=\"note.title\"></div><div class=\"dateblock\">{{note.description}}</div></div></div></div></div>\n</div></md-tab><md-tab label=\"History\" ng-click=\"vm.fetchOrderHistory(vm.order.confirmation_number)\"><div \nclass=\"gry-block-tab listorderblock\"><div class=\"mh-10 width-calc\"><div ng-if=\"!vm.no_found\" \nclass=\"role-list-out white-bg relative-block featured-block-main\" ng-repeat=\"order_history in vm.order.order_history\">\n<div layout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10 pb-10\" layout=\"column\" flex=\"50\" \nlayout-align=\"center\"><p class=\"form-title no-padding no-margin\">{{order_history.confirmation_number}}</p></div><div \nclass=\"padding-left-10 padding-right-10 pb-10\" layout=\"column\" flex=\"50\" layout-align=\"center end\"><p \nclass=\"no-padding no-margin\">{{order_history.created_date}}</p></div></div><div \nclass=\"Fromto padding-left-10 padding-right-10 pv-10\" layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"30\" flex-gt-xs=\"20\"><strong class=\"order-history-name pv-5\">{{order_history.product_name}}\n</strong></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"35\" flex-gt-xs=\"40\" \nng-if=\"order_history.type_of_reservation == \'reservation\' || order_history.type_of_reservation == \'day_reservation\' || posValue.product_is_timebound == 1\">\n<div layout=\"row\" flex=\"100\"><div class=\"Fromto-col\" layout=\"column\" flex=\"45\" layout-align=\"start center\"><div \nlayout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"100\" layout-align=\"center\">From : {{order_history.room_stay_from}}\n</div></div></div><div class=\"Fromto-col\" layout=\"column\" flex=\"45\" layout-align=\"start center\"><div layout=\"row\" \nflex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" layout-align=\"center\">To : {{order_history.room_stay_to}}</div>\n</div></div></div></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"35\" flex-gt-xs=\"40\" \nng-if=\"order_history.type_of_reservation == \'reservation\' || order_history.type_of_reservation == \'day_reservation\'\">\n<div layout=\"row\" flex=\"100\"><div class=\"Fromto-col\" layout=\"column\" flex=\"20\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account-multiple\"></md-icon></div><div class=\"Fromto-col padding-left-10 padding-right-10\" \nlayout=\"column\" flex=\"50\"><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex-gt-sm=\"50\" flex=\"40\" \nlayout-align=\" center\"><label>Adult</label></div><div layout=\"column\" flex-gt-sm=\"50\" flex=\"60\" layout-align=\"center\">\n{{order_history.room_stay_guest_count}}</div></div></div><div class=\"Fromto-col padding-left-10 padding-right-10\" \nlayout=\"column\" flex=\"50\"><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex-gt-sm=\"50\" flex=\"40\" \nlayout-align=\"center\"><label>Child</label></div><div layout=\"column\" flex-gt-sm=\"50\" flex=\"60\" layout-align=\" center\">\n{{order_history.room_stay_child_count}}</div></div></div></div></div></div><div \nclass=\"roomTable simple-table-container\" layout=\"row\" flex layout-wrap><div class=\"room-col Housekeepingtable\" \nlayout=\"column\" flex=\"100\"><table class=\"row-border no-padding tablemain-ordersimple\" cellpadding=\"0\" cellspacing=\"0\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Qty/Night(s)</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Extra Person Charges</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Rate($)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Subtotal($)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Discount($)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Grand Total</span></div></th></tr></thead>\n<tbody><tr><td>\n{{order_history.qty || (order_history.type_of_reservation == \'day_reservation\' ? 1 : order_history.qty)}}</td><td>\n{{order_history.additional_guest_amounts}}</td><td>{{order_history.subtotal | currency : $ : 2}}</td><td \nng-if=\"order_history.type_of_reservation == \'reservation\' || order_history.type_of_reservation == \'boat\' || order_history.type_of_reservation == \'day_reservation\'\">\n{{vm.calculatesubtotal(order_history.additional_guest_amounts,order_history.subtotal)}}</td><td \nng-if=\"(order_history.type_of_reservation == \'service\' || order_history.type_of_reservation == \'boat_service\') && order_history.product_is_timebound!=1\">\n{{vm.calculatesubtotalPos(order_history.qty,order_history.subtotal)}}</td><td \nng-if=\"(order_history.type_of_reservation == \'service\' || order_history.type_of_reservation == \'boat_service\') && order_history.product_is_timebound==1\">\n{{order_history.subtotal}}</td><td>{{order_history.product_discount | currency : $ : 2}}</td><td>\n{{order_history.grand_total | currency : $ : 2}}</td></tr></tbody></table></div></div><div class=\"nightly-price\" \nlayout=\"row\" flex layout-wrap \nng-if=\"order_history.type_of_reservation == \'reservation\' || posValue.product_is_timebound == 1\"><div \nclass=\"padding-right-20 padding-top-10 padding-bottom-10\" layout=\"column\" flex=\"50\" flex-gt-sm=\"25\" flex-gt-xs=\"50\" \nlayout-align=\" center\" ng-repeat=\"eachnight in order_history.prices.dates\"><span class=\"padding-bottom-5 weight\">\nNight {{$index+1}} </span><span>{{order_history.prices.dates[$index]}} - {{order_history.prices.rate_plan[$index]}}\n</span> <span>{{order_history.prices.rates[$index]}}</span></div></div><div class=\"order_history_cmnt padding-15\" \nlayout=\"row\" flex ng-if=\"order_history.order_history_comment != null\"><div class=\"room-col\" layout=\"column\" flex=\"100\">\n<div layout=\"row\" flex layout-wrap><span translate=\"HISTORY.{{order_history.order_history_comment}}\"></span></div>\n</div></div></div><div ng-if=\"vm.no_found\" \nclass=\"role-list-out white-bg relative-block featured-block-main no-padding\"><div class=\"roomName padding-15\" \nlayout=\"row\" flex><div class=\"room-col\" layout=\"column\" flex=\"100\"><div layout=\"row\" flex layout-wrap><strong \nlayout=\"column\" flex-gt-md=\"80\" flex-gt-md=\"70\" flex-gt-xs=\"60\" flex=\"100\" layout-align=\"center start\" class=\"pv-10\" \ntranslate=\"HISTORY.NOFOUND\"></strong></div></div></div></div></div></div></md-tab><md-tab label=\"Documents\" \nng-click=\"vm.fetchDocs(vm.order.confirmation_number)\"><div class=\"gry-block-tab listorderblock\"><div \nclass=\"images images-uploded-block\" ng-if=\"!vm.emptyDocs\"><div class=\"document-row-block\"><div \nclass=\"ducument-col-block\" ng-repeat=\"document in vm.documents\"><div class=\"pdf-cover\" \nng-click=\"vm.documentViewer($event,document.doc_name,document.type)\" style=\"cursor: pointer\"><img \nng-if=\"document.type == \'image\' || document.type == \'pdf\'\" \nsrc=\"{{vm.baseUrl}}assets/uploads/documents/thumbnail/{{document.thumbnail}}\"> <img ng-if=\"document.type == \'other\'\" \nsrc=\"assets/icons/file.svg\" class=\"iconimg\"></div><div class=\"pdf-content-cover-blk\"><div class=\"img-blockcardname\">\n{{ document.doc_name }}</div><div class=\"img-block-cardAddon\">Added {{ document.created_on }}</div><div \nclass=\"img-block-cardbutton\"><md-button ng-click=\"vm.downloadDocuments(document, $index)\">Download</md-button>\n<md-button ng-click=\"vm.deleteDocument(document, $index, $event)\" class=\"delete\">Delete</md-button></div></div></div>\n<div class=\"ducument-col-block\" ng-if=\"vm.uploading\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"loader-pdfmain md-accent\" md-diameter=\"30px\"></md-progress-circular></div></div></div><div ng-if=\"vm.emptyDocs\" \nclass=\"role-list-out white-bg relative-block featured-block-main no-padding\"><div class=\"roomName padding-15\" \nlayout=\"row\" flex><div class=\"room-col\" layout=\"column\" flex=\"100\"><div layout=\"row\" flex layout-wrap><strong \nlayout=\"column\" flex-gt-md=\"80\" flex-gt-md=\"70\" flex-gt-xs=\"60\" flex=\"100\" layout-align=\"center start\" class=\"pv-10\">\nNo documents.</strong></div></div></div></div></div></md-tab></md-tabs></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/e-commerce/views/orders/order/precheckin-dialog.html","<md-dialog class=\"contact-dialog precheckin-link-dialog\" aria-label=\"Pre-Check-in Link\" style=\"min-width: 420px\"><form \nname=\"precheckinForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Pre-Check-in Link</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll class=\"fullcontent\" style=\"padding: 16px 0px 16px 0px\"><div class=\"outer_wrapper\">\n<md-content class=\"md-padding\"><p class=\"form-title-small mt-0 mb-10\">Select how you want to send the pre-checkin link:\n</p><md-radio-group ng-model=\"selectedChannel\" class=\"pre-checkin-link-options\" ng-change=\"onChannelChange()\">\n<md-radio-button ng-if=\"availableChannels.indexOf(\'email\') > -1\" value=\"email\" class=\"mb-5\">Email</md-radio-button>\n<md-radio-button ng-if=\"availableChannels.indexOf(\'ota_message\') > -1\" value=\"ota_message\" class=\"mb-5\">OTA Message\n</md-radio-button><md-radio-button ng-if=\"availableChannels.indexOf(\'message\') > -1\" value=\"message\" class=\"mb-5\">\nText Message</md-radio-button><md-radio-button ng-if=\"availableChannels.indexOf(\'copy_link\') > -1\" value=\"copy_link\" \nclass=\"mb-5\">Copy Link</md-radio-button></md-radio-group><div class=\"pre-checkin-sms-phone\" \nng-if=\"selectedChannel === \'email\' && askEmailChoice\"><div class=\"pre-checkin-send-to-label\">Send email to</div><div \nclass=\"pre-checkin-send-to-options\" role=\"radiogroup\" aria-label=\"Send email to\"><button type=\"button\" \nclass=\"pre-checkin-send-to-option\" role=\"radio\" ng-if=\"emailOptions.traveler\" \nng-class=\"{\'is-active\': emailSource === \'traveler\'}\" ng-click=\"setEmailSource(\'traveler\')\" \naria-checked=\"{{emailSource === \'traveler\'}}\"><span class=\"pre-checkin-send-to-option-label\">Traveler</span> <span \nclass=\"pre-checkin-send-to-option-phone\">{{emailOptions.traveler}}</span></button> <button type=\"button\" \nclass=\"pre-checkin-send-to-option\" role=\"radio\" ng-if=\"emailOptions.customer\" \nng-class=\"{\'is-active\': emailSource === \'customer\'}\" ng-click=\"setEmailSource(\'customer\')\" \naria-checked=\"{{emailSource === \'customer\'}}\"><span class=\"pre-checkin-send-to-option-label\">Billing</span> <span \nclass=\"pre-checkin-send-to-option-phone\">{{emailOptions.customer}}</span></button></div></div></md-content></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end end\" flex=\"100\"><md-button type=\"button\" ng-click=\"closeDialog()\" \nclass=\"md-raised md-accent submit-button grey-100-fg md-red-500-bg\">Cancel</md-button><md-button type=\"button\" \nng-click=\"sendNotification()\" ng-disabled=\"!canSend()\" \nclass=\"md-raised md-accent submit-button grey-100-fg md-green-500-bg\">\n{{selectedChannel === \'copy_link\' ? \'Copy\' : \'Send\'}}</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/products/dialogs/product-dialog.html","<md-dialog class=\"role-dialog\" aria-label=\"New Task\"><form name=\"productForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" ng-if=\"vm.title == \'add\'\">{{ \'ROOMS.NEW_ROOM\' | translate }}</span> <span class=\"title\" \nng-if=\"vm.title != \'add\'\">{{vm.product.product_name}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll style=\"max-width:800px;max-height:1000px\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><md-content class=\"md-padding\"><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"ROOMS.ROOM_NAME\"></label><md-icon md-font-icon=\"icon-hotel\" \nclass=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100 md-input-invalid\"></md-icon><input \nng-change=\"vm.checkUniqueNameWithCheck()\" ng-model-options=\"{debounce: 500}\" ng-model=\"vm.product.product_name\" \nname=\"role_title\" type=\"text\" ng-blur=\"vm.checkUniqueName()\" required autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\">\n<div ng-if=\"vm.uniqueName\" role=\"alert\"><div style=\"font-size:12px;color:#d60606\"><span translate=\"ROOMS.NAME_EXISTS\">\n</span></div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"ROOM_TYPE.ROOM_TYPE\"></label><md-icon md-font-icon=\"icon-hotel\" \nclass=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100 md-input-invalid\"></md-icon><md-select \nng-change=\"vm.updateProduct()\" ng-model-options=\"{debounce: 500}\" placeholder=\"{{\'ROOMS.SELECT_TYPE\' | translate}}\" \nng-model=\"vm.product.type_id\"><md-option ng-value=\"type.room_type_id\" ng-repeat=\"type in vm.types\">\n{{type.room_type_name}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container>\n<md-input-container class=\"md-icon-float md-block padding-bottom-15\"><md-icon><i class=\"icon s20 icon-checkbox-marked\">\n</i></md-icon><md-radio-group class=\"padding-left-35\" ng-change=\"vm.updateProduct()\" \nng-model-options=\"{debounce: 500}\" ng-model=\"vm.product.product_status\" required><md-radio-button value=\"1\">Enabled\n</md-radio-button><md-radio-button value=\"0\" class=\"md-primary margin-left-10\">Disabled</md-radio-button>\n</md-radio-group></md-input-container><md-input-container ng-model-options=\"{debounce: 500}\" \nclass=\"md-icon-float md-block\"><label translate=\"ROOMS.GRAPH_SORT_ORDER\"></label><md-icon md-font-icon=\"icon-sort\">\n</md-icon><input ng-change=\"vm.updateProduct()\" ng-model=\"vm.product.product_sort_order\" name=\"role_title\" type=\"text\" \nng-pattern=\"/^[0-9]{1,4}$/\" required><div ng-messages=\"productForm.role_title.$error\" role=\"alert\" multiple=\"multiple\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div ng-message=\"pattern\"><span translate=\"ROOMS.NUMERIC_ONLY\"></span>\n</div></div></md-input-container><input type=\"hidden\" ng-model=\"vm.product.product_type\" value=\"room\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.newproduct\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-click=\"vm.saveProduct()\" \nng-class=\"!productForm.$invalid && !productForm.$pristine && !vm.uniqueName?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-accent submit-button\'\" \nng-disabled=\"productForm.$invalid || productForm.$pristine || vm.uniqueName\" aria-label=\"SAVE\" translate=\"SAVE\">\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/guest-message-center/direct/dialogs/new-sms-conversation/new-sms-conversation.dialog.html","<md-dialog class=\"gmc-new-sms-dialog\" aria-label=\"{{\'DIRECT_MESSAGE_CENTER.NEW_CONVERSATION\' | translate}}\"><header \nclass=\"gmc-new-sms-toolbar\"><div class=\"gmc-new-sms-toolbar-inner\"><div class=\"gmc-new-sms-brand\"><div \nclass=\"gmc-new-sms-brand-icon\"><md-icon md-font-icon=\"icon-message-text\" class=\"white-fg\"></md-icon></div><div \nclass=\"gmc-new-sms-toolbar-title\" translate=\"DIRECT_MESSAGE_CENTER.NEW_CONVERSATION\">New conversation</div></div><span \nflex></span><md-button class=\"md-icon-button gmc-new-sms-close\" ng-click=\"vm.close()\" aria-label=\"Close\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></header><md-dialog-content><div \nclass=\"gmc-new-sms-dialog-body\"><div ng-if=\"vm.step === \'list\'\"><p class=\"gmc-new-sms-subtitle\" \ntranslate=\"DIRECT_MESSAGE_CENTER.IN_HOUSE_GUESTS\">In-house &amp; upcoming reservations</p><div \nclass=\"gmc-new-sms-channel-group\" role=\"radiogroup\" aria-label=\"Channel\" ng-if=\"vm.smsEnabled || vm.whatsappEnabled\">\n<button type=\"button\" class=\"gmc-new-sms-channel-option\" role=\"radio\" ng-if=\"vm.smsEnabled\" \nng-class=\"{\'is-active\': vm.channel === \'sms\'}\" ng-click=\"vm.setChannel(\'sms\')\" aria-checked=\"{{vm.channel === \'sms\'}}\">\n<span class=\"gmc-new-sms-channel-radio\" aria-hidden=\"true\"></span> <span class=\"gmc-new-sms-channel-text\"><span \nclass=\"gmc-new-sms-channel-name\">SMS</span> <span class=\"gmc-new-sms-channel-hint\" \ntranslate=\"DIRECT_MESSAGE_CENTER.CHANNEL_SMS_HINT\">Text message</span></span></button> <button type=\"button\" \nclass=\"gmc-new-sms-channel-option is-whatsapp\" role=\"radio\" ng-if=\"vm.whatsappEnabled\" \nng-class=\"{\'is-active\': vm.channel === \'whatsapp\'}\" ng-click=\"vm.setChannel(\'whatsapp\')\" \naria-checked=\"{{vm.channel === \'whatsapp\'}}\"><span class=\"gmc-new-sms-channel-radio\" aria-hidden=\"true\"></span> <span \nclass=\"gmc-new-sms-channel-text\"><span class=\"gmc-new-sms-channel-name\">WhatsApp</span> <span \nclass=\"gmc-new-sms-channel-hint\" translate=\"DIRECT_MESSAGE_CENTER.CHANNEL_WHATSAPP_HINT\">WhatsApp message</span></span>\n</button></div><div class=\"gmc-new-sms-search-bar\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"gmc-new-sms-search-icon\"></md-icon><input type=\"search\" class=\"gmc-new-sms-search-input\" \nng-model=\"vm.searchText\" ng-model-options=\"{ debounce: 400 }\" ng-change=\"vm.onSearchChange()\" \nplaceholder=\"{{\'DIRECT_MESSAGE_CENTER.SEARCH_RESERVATIONS\' | translate}}\"></div><div class=\"gmc-new-sms-error\" \nng-if=\"vm.errorMessage\">{{vm.errorMessage}}</div><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\">\n</md-progress-linear><div class=\"gmc-new-sms-empty\" ng-if=\"!vm.loading && !vm.reservations.length\"><md-icon \nmd-font-icon=\"icon-account-search\" class=\"gmc-new-sms-empty-icon\"></md-icon><span \ntranslate=\"DIRECT_MESSAGE_CENTER.NO_RESERVATIONS\">No matching reservations found</span></div><div \nclass=\"gmc-new-sms-list\" ng-if=\"vm.reservations.length\"><button type=\"button\" class=\"gmc-new-sms-item\" \nng-repeat=\"reservation in vm.reservations track by reservation.confirmation_number\" \nng-click=\"vm.selectReservation(reservation)\"><div class=\"gmc-new-sms-item-avatar\" aria-hidden=\"true\">\n{{vm.getGuestInitials(reservation)}}</div><div class=\"gmc-new-sms-item-body\"><div class=\"gmc-new-sms-item-top\"><span \nclass=\"gmc-new-sms-guest\">{{vm.getGuestName(reservation)}}</span> <span class=\"gmc-new-sms-status\" \nng-if=\"reservation.room_stay_status\" ng-class=\"vm.getStatusClass(reservation.room_stay_status)\">\n{{reservation.room_stay_status}}</span></div><div class=\"gmc-new-sms-conf\">{{reservation.confirmation_number}} <span \nng-if=\"reservation.guest_phone\">· {{vm.formatPhoneNumber(reservation.guest_phone)}}</span> <span \nng-if=\"reservation.product_room_number\">· Room {{reservation.product_room_number}}</span></div><div \nclass=\"gmc-new-sms-dates\" ng-if=\"vm.formatStayDateRange(reservation.room_stay_from, reservation.room_stay_to)\">\n{{vm.formatStayDateRange(reservation.room_stay_from, reservation.room_stay_to)}}</div></div><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"gmc-new-sms-item-chevron\"></md-icon></button></div></div><div \nng-if=\"vm.step === \'phone\'\" class=\"gmc-new-sms-phone-step\"><button type=\"button\" class=\"gmc-new-sms-back\" \nng-click=\"vm.backToList()\" ng-disabled=\"!!vm.creatingConfirmation\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n<span translate=\"DIRECT_MESSAGE_CENTER.BACK\">Back</span></button><div class=\"gmc-new-sms-selected\"><div \nclass=\"gmc-new-sms-item-avatar\" aria-hidden=\"true\">{{vm.getGuestInitials(vm.selectedReservation)}}</div><div><div \nclass=\"gmc-new-sms-guest\">{{vm.getGuestName(vm.selectedReservation)}}</div><div class=\"gmc-new-sms-conf\">\n{{vm.selectedReservation.confirmation_number}} <span ng-if=\"vm.selectedReservation.product_room_number\">\n· Room {{vm.selectedReservation.product_room_number}}</span></div><div class=\"gmc-new-sms-channel-badge\" \nng-class=\"{\'is-whatsapp\': vm.channel === \'whatsapp\'}\">{{vm.channel === \'whatsapp\' ? \'WhatsApp\' : \'SMS\'}}</div></div>\n</div><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingPhoneOptions\"></md-progress-linear><div \nclass=\"gmc-send-to\" ng-if=\"!vm.loadingPhoneOptions\"><div class=\"gmc-send-to-label\" \ntranslate=\"GUEST_MESSAGE_CENTER.SEND_TO\">Send to</div><div class=\"gmc-send-to-options gmc-send-to-options--stack\">\n<button type=\"button\" class=\"gmc-send-to-option\" ng-if=\"vm.phoneOptions.customer\" \nng-class=\"{\'is-active\': vm.sendToSource === \'customer\'}\" ng-click=\"vm.setSendToSource(\'customer\')\"><span \nclass=\"gmc-send-to-option-label\" translate=\"GUEST_MESSAGE_CENTER.PHONE_CUSTOMER\">Customer</span> <span \nclass=\"gmc-send-to-option-phone\">{{vm.formatPhoneNumber(vm.phoneOptions.customer)}}</span></button> <button \ntype=\"button\" class=\"gmc-send-to-option\" ng-if=\"vm.phoneOptions.traveler\" \nng-class=\"{\'is-active\': vm.sendToSource === \'traveler\'}\" ng-click=\"vm.setSendToSource(\'traveler\')\"><span \nclass=\"gmc-send-to-option-label\" translate=\"GUEST_MESSAGE_CENTER.PHONE_TRAVELER\">Traveler</span> <span \nclass=\"gmc-send-to-option-phone\">{{vm.formatPhoneNumber(vm.phoneOptions.traveler)}}</span></button> <button \ntype=\"button\" class=\"gmc-send-to-option\" ng-class=\"{\'is-active\': vm.sendToSource === \'custom\'}\" \nng-click=\"vm.setSendToSource(\'custom\')\"><span class=\"gmc-send-to-option-label\" \ntranslate=\"GUEST_MESSAGE_CENTER.PHONE_CUSTOM\">Custom number</span></button></div><div \nclass=\"gmc-new-sms-search-bar gmc-new-sms-phone-input gmc-phone-iti-field\" ng-if=\"vm.sendToSource === \'custom\'\"><input \ntype=\"tel\" name=\"gmc_new_sms_custom_phone\" class=\"gmc-new-sms-search-input intel-number-input\" \nng-model=\"vm.customPhone\" intl-tel-input autocomplete=\"off\" aria-label=\"Custom phone number\" \nng-change=\"vm.updatePhoneWithCountryCode(\'gmc_new_sms_custom_phone\', $event)\"></div></div><div \nclass=\"gmc-new-sms-error\" ng-if=\"vm.errorMessage\">{{vm.errorMessage}}</div><div class=\"gmc-new-sms-phone-actions\" \nlayout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.backToList()\" ng-disabled=\"!!vm.creatingConfirmation\" \ntranslate=\"GUEST_MESSAGE_CENTER.CANCEL\">Cancel</md-button><md-button class=\"md-raised gmc-new-sms-continue\" \nng-class=\"{\'is-loading\': !!vm.creatingConfirmation}\" ng-click=\"vm.startConversation()\" ng-disabled=\"!vm.canStart()\">\n<span class=\"gmc-new-sms-continue-content\" ng-class=\"{\'is-loading\': !!vm.creatingConfirmation}\"><md-progress-circular \nng-if=\"vm.creatingConfirmation\" class=\"gmc-new-sms-continue-spinner\" md-mode=\"indeterminate\" md-diameter=\"18\">\n</md-progress-circular><span ng-if=\"!vm.creatingConfirmation\" translate=\"DIRECT_MESSAGE_CENTER.START_CONVERSATION\">\nStart conversation </span><span ng-if=\"vm.creatingConfirmation\" \ntranslate=\"DIRECT_MESSAGE_CENTER.CREATING_CONVERSATION\">Starting…</span></span></md-button></div></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/guest-message-center/direct/dialogs/phone-picker/phone-picker.dialog.html","<md-dialog class=\"gmc-phone-picker-dialog\" aria-label=\"{{\'GUEST_MESSAGE_CENTER.SEND_TO\' | translate}}\"><md-toolbar><div\n class=\"md-toolbar-tools\"><h2><span translate=\"GUEST_MESSAGE_CENTER.SEND_TO\">Send to</span> <span ng-if=\"vm.channel\">\n· {{vm.channel === \'whatsapp\' ? \'WhatsApp\' : \'SMS\'}}</span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"Close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"gmc-phone-picker-body\"><p class=\"gmc-phone-picker-subtitle\" \nng-if=\"vm.confirmationNumber\">{{vm.confirmationNumber}}</p><div class=\"gmc-send-to-options\"><button type=\"button\" \nclass=\"gmc-send-to-option\" ng-if=\"vm.phoneOptions.customer\" ng-class=\"{\'is-active\': vm.sendToSource === \'customer\'}\" \nng-click=\"vm.setSendToSource(\'customer\')\"><span class=\"gmc-send-to-option-label\" \ntranslate=\"GUEST_MESSAGE_CENTER.PHONE_CUSTOMER\">Customer</span> <span class=\"gmc-send-to-option-phone\">\n{{vm.formatPhoneNumber(vm.phoneOptions.customer)}}</span></button> <button type=\"button\" class=\"gmc-send-to-option\" \nng-if=\"vm.phoneOptions.traveler\" ng-class=\"{\'is-active\': vm.sendToSource === \'traveler\'}\" \nng-click=\"vm.setSendToSource(\'traveler\')\"><span class=\"gmc-send-to-option-label\" \ntranslate=\"GUEST_MESSAGE_CENTER.PHONE_TRAVELER\">Traveler</span> <span class=\"gmc-send-to-option-phone\">\n{{vm.formatPhoneNumber(vm.phoneOptions.traveler)}}</span></button> <button type=\"button\" class=\"gmc-send-to-option\" \nng-class=\"{\'is-active\': vm.sendToSource === \'custom\'}\" ng-click=\"vm.setSendToSource(\'custom\')\"><span \nclass=\"gmc-send-to-option-label\" translate=\"GUEST_MESSAGE_CENTER.PHONE_CUSTOM\">Custom number</span></button></div><div \nclass=\"gmc-phone-iti-field gmc-phone-picker-custom\" ng-if=\"vm.sendToSource === \'custom\'\"><input type=\"tel\" \nname=\"gmc_phone_picker_custom\" class=\"intel-number-input\" ng-model=\"vm.customPhone\" intl-tel-input autocomplete=\"off\" \naria-label=\"Custom phone number\" ng-change=\"vm.updatePhoneWithCountryCode(\'gmc_phone_picker_custom\', $event)\"></div>\n<div class=\"gmc-phone-picker-error\" ng-if=\"vm.errorMessage\">{{vm.errorMessage}}</div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\" \ntranslate=\"GUEST_MESSAGE_CENTER.CANCEL\">Cancel</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.confirm()\" ng-disabled=\"!vm.canConfirm()\" translate=\"GUEST_MESSAGE_CENTER.CONTINUE\">Continue</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/guest-message-center/staff-messages/dialogs/new-staff-conversation/new-staff-conversation.dialog.html","<md-dialog class=\"gmc-new-sms-dialog\" aria-label=\"Add Staff\"><header class=\"gmc-new-sms-toolbar\"><div \nclass=\"gmc-new-sms-toolbar-inner\"><div class=\"gmc-new-sms-brand\"><div class=\"gmc-new-sms-brand-icon\"><md-icon \nmd-font-icon=\"icon-account-plus\" class=\"white-fg\"></md-icon></div><div class=\"gmc-new-sms-toolbar-title\">Add Staff\n</div></div><span flex></span><md-button class=\"md-icon-button gmc-new-sms-close\" ng-click=\"vm.close()\" \naria-label=\"Close\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></header>\n<md-dialog-content><div class=\"gmc-new-sms-dialog-body\"><div ng-if=\"vm.step === \'list\'\"><p \nclass=\"gmc-new-sms-subtitle\">Staff members</p><div class=\"gmc-new-sms-channel-group\" role=\"radiogroup\" \naria-label=\"Channel\" ng-if=\"vm.smsEnabled || vm.whatsappEnabled\"><button type=\"button\" \nclass=\"gmc-new-sms-channel-option\" role=\"radio\" ng-if=\"vm.smsEnabled\" ng-class=\"{\'is-active\': vm.channel === \'sms\'}\" \nng-click=\"vm.setChannel(\'sms\')\" aria-checked=\"{{vm.channel === \'sms\'}}\"><span class=\"gmc-new-sms-channel-radio\" \naria-hidden=\"true\"></span> <span class=\"gmc-new-sms-channel-text\"><span class=\"gmc-new-sms-channel-name\">SMS</span> \n<span class=\"gmc-new-sms-channel-hint\">Text message</span></span></button> <button type=\"button\" \nclass=\"gmc-new-sms-channel-option is-whatsapp\" role=\"radio\" ng-if=\"vm.whatsappEnabled\" \nng-class=\"{\'is-active\': vm.channel === \'whatsapp\'}\" ng-click=\"vm.setChannel(\'whatsapp\')\" \naria-checked=\"{{vm.channel === \'whatsapp\'}}\"><span class=\"gmc-new-sms-channel-radio\" aria-hidden=\"true\"></span> <span \nclass=\"gmc-new-sms-channel-text\"><span class=\"gmc-new-sms-channel-name\">WhatsApp</span> <span \nclass=\"gmc-new-sms-channel-hint\">WhatsApp message</span></span></button></div><div class=\"gmc-new-sms-search-bar\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"gmc-new-sms-search-icon\"></md-icon><input type=\"search\" \nclass=\"gmc-new-sms-search-input\" ng-model=\"vm.searchText\" ng-model-options=\"{ debounce: 400 }\" \nng-change=\"vm.onSearchChange()\" placeholder=\"Search staff by name, email or phone\"></div><div \nclass=\"gmc-new-sms-error\" ng-if=\"vm.errorMessage\">{{vm.errorMessage}}</div><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loading\"></md-progress-linear><div class=\"gmc-new-sms-empty\" ng-if=\"!vm.loading && !vm.staffMembers.length\">\n<md-icon md-font-icon=\"icon-account-search\" class=\"gmc-new-sms-empty-icon\"></md-icon><span>\nNo matching staff members found</span></div><div class=\"gmc-new-sms-list\" ng-if=\"vm.staffMembers.length\"><button \ntype=\"button\" class=\"gmc-new-sms-item\" ng-repeat=\"staff in vm.staffMembers track by (staff.user_id || $index)\" \nng-click=\"vm.selectStaff(staff)\"><div class=\"gmc-new-sms-item-avatar\" aria-hidden=\"true\">{{vm.getStaffInitials(staff)}}\n</div><div class=\"gmc-new-sms-item-body\"><div class=\"gmc-new-sms-item-top\"><span class=\"gmc-new-sms-guest\">\n{{vm.getStaffName(staff)}}</span> <span class=\"gmc-new-sms-status is-active\" ng-if=\"staff.role\">{{staff.role}}</span>\n</div><div class=\"gmc-new-sms-conf\"><span ng-if=\"staff.email\">{{staff.email}}</span> <span \nng-if=\"staff.existing_phone || staff.phone_number\">\n· {{vm.formatPhoneNumber(staff.existing_phone || staff.phone_number)}}</span></div></div><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"gmc-new-sms-item-chevron\"></md-icon></button></div></div><div \nng-if=\"vm.step === \'phone\'\" class=\"gmc-new-sms-phone-step\"><button type=\"button\" class=\"gmc-new-sms-back\" \nng-click=\"vm.backToList()\" ng-disabled=\"!!vm.creatingId\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><span>Back\n</span></button><div class=\"gmc-new-sms-selected\"><div class=\"gmc-new-sms-item-avatar\" aria-hidden=\"true\">\n{{vm.getStaffInitials(vm.selectedStaff)}}</div><div><div class=\"gmc-new-sms-guest\">\n{{vm.getStaffName(vm.selectedStaff)}}</div><div class=\"gmc-new-sms-conf\"><span ng-if=\"vm.selectedStaff.email\">\n{{vm.selectedStaff.email}}</span></div></div></div><div class=\"gmc-new-sms-channel-group\" role=\"radiogroup\" \naria-label=\"Channel\" ng-if=\"!vm.creatingId && (vm.smsEnabled || vm.whatsappEnabled)\"><button type=\"button\" \nclass=\"gmc-new-sms-channel-option\" role=\"radio\" ng-if=\"vm.smsEnabled\" ng-class=\"{\'is-active\': vm.channel === \'sms\'}\" \nng-click=\"vm.setChannel(\'sms\')\" aria-checked=\"{{vm.channel === \'sms\'}}\"><span class=\"gmc-new-sms-channel-radio\" \naria-hidden=\"true\"></span> <span class=\"gmc-new-sms-channel-text\"><span class=\"gmc-new-sms-channel-name\">SMS</span> \n<span class=\"gmc-new-sms-channel-hint\">Text message</span></span></button> <button type=\"button\" \nclass=\"gmc-new-sms-channel-option is-whatsapp\" role=\"radio\" ng-if=\"vm.whatsappEnabled\" \nng-class=\"{\'is-active\': vm.channel === \'whatsapp\'}\" ng-click=\"vm.setChannel(\'whatsapp\')\" \naria-checked=\"{{vm.channel === \'whatsapp\'}}\"><span class=\"gmc-new-sms-channel-radio\" aria-hidden=\"true\"></span> <span \nclass=\"gmc-new-sms-channel-text\"><span class=\"gmc-new-sms-channel-name\">WhatsApp</span> <span \nclass=\"gmc-new-sms-channel-hint\">WhatsApp message</span></span></button></div><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.creatingId\"></md-progress-linear><div class=\"gmc-send-to\" ng-if=\"!vm.creatingId\"><div\n class=\"gmc-send-to-label\">Staff phone number</div><div \nclass=\"gmc-new-sms-search-bar gmc-new-sms-phone-input gmc-phone-iti-field\"><input type=\"tel\" \nname=\"gmc_new_staff_phone\" class=\"gmc-new-sms-search-input intel-number-input\" ng-model=\"vm.customPhone\" \nintl-tel-input autocomplete=\"off\" aria-label=\"Staff phone number\" \nng-change=\"vm.updatePhoneWithCountryCode(\'gmc_new_staff_phone\', $event)\"></div></div><div class=\"gmc-new-sms-error\" \nng-if=\"vm.errorMessage\">{{vm.errorMessage}}</div><div class=\"gmc-new-sms-phone-actions\" layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.backToList()\" ng-disabled=\"!!vm.creatingId\">Cancel</md-button>\n<md-button class=\"md-raised gmc-new-sms-continue\" ng-class=\"{\'is-loading\': !!vm.creatingId}\" \nng-click=\"vm.startConversation()\" ng-disabled=\"!vm.canStart()\"><span class=\"gmc-new-sms-continue-content\" \nng-class=\"{\'is-loading\': !!vm.creatingId}\"><md-progress-circular ng-if=\"vm.creatingId\" \nclass=\"gmc-new-sms-continue-spinner\" md-mode=\"indeterminate\" md-diameter=\"18\"></md-progress-circular><span \nng-if=\"!vm.creatingId\">Start conversation </span><span ng-if=\"vm.creatingId\">Starting…</span></span></md-button></div>\n</div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/guest-message-center/templates/message-templates/dialogs/category-dialog.html","<md-dialog class=\"gmc-qr-dialog gmc-qr-template-dialog\" aria-label=\"{{vm.isEdit ? \'Edit category\' : \'Add category\'}}\">\n<header class=\"gmc-qr-toolbar\"><div class=\"gmc-qr-toolbar-inner\"><div class=\"gmc-qr-toolbar-title\"><span \nng-if=\"!vm.isEdit\" translate=\"GUEST_MESSAGE_CENTER.ADD_CATEGORY\">Add Category </span><span ng-if=\"vm.isEdit\" \ntranslate=\"GUEST_MESSAGE_CENTER.EDIT_CATEGORY\">Edit Category</span></div><span flex></span><md-button \nclass=\"md-icon-button gmc-qr-close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></header><md-dialog-content><div class=\"gmc-qr-dialog-body\"><p class=\"gmc-qr-subtitle\">\nCategory details</p><div class=\"gmc-qr-field\"><label class=\"gmc-qr-label\" \ntranslate=\"GUEST_MESSAGE_CENTER.CATEGORY_NAME\">Category name</label><div class=\"gmc-qr-input-wrap\"><input \nclass=\"gmc-qr-input\" type=\"text\" ng-model=\"vm.form.name\" ng-change=\"vm.validateCategoryName()\" \nplaceholder=\"{{ \'GUEST_MESSAGE_CENTER.CATEGORY_NAME\' | translate }}\" required md-autofocus></div><div \nclass=\"gmc-qr-inline-error\" ng-if=\"vm.duplicateCategoryName\">Category already exists.</div></div><div \nclass=\"gmc-qr-field gmc-qr-active-field\"><md-checkbox ng-model=\"vm.form.is_active\" ng-true-value=\"1\" \nng-false-value=\"0\"><span translate=\"GUEST_MESSAGE_CENTER.ACTIVE\">Active</span></md-checkbox></div><div \nclass=\"gmc-qr-error\" ng-if=\"vm.errorMessage\">{{vm.errorMessage}}</div></div></md-dialog-content><md-dialog-actions \nclass=\"gmc-qr-actions\" layout=\"row\" layout-align=\"end center\"><md-button class=\"gmc-qr-cancel\" ng-click=\"vm.cancel()\" \ntranslate=\"GUEST_MESSAGE_CENTER.CANCEL\">Cancel</md-button><md-button class=\"md-raised gmc-qr-save\" \nng-click=\"vm.save()\" ng-disabled=\"vm.saving || !vm.form.name || vm.duplicateCategoryName\"><span ng-if=\"!vm.saving\" \ntranslate=\"GUEST_MESSAGE_CENTER.SAVE\">Save</span><md-progress-circular ng-if=\"vm.saving\" md-mode=\"indeterminate\" \nmd-diameter=\"20\"></md-progress-circular></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/guest-message-center/templates/message-templates/dialogs/template-dialog.html","<md-dialog class=\"gmc-qr-dialog gmc-qr-template-dialog\" aria-label=\"{{vm.isEdit ? \'Edit template\' : \'Add template\'}}\">\n<header class=\"gmc-qr-toolbar\"><div class=\"gmc-qr-toolbar-inner\"><div class=\"gmc-qr-toolbar-title\"><span \nng-if=\"!vm.isEdit\" translate=\"GUEST_MESSAGE_CENTER.ADD_TEMPLATE\">Add Template </span><span ng-if=\"vm.isEdit\" \ntranslate=\"GUEST_MESSAGE_CENTER.EDIT_TEMPLATE\">Edit Template</span></div><span flex></span><md-button \nclass=\"md-icon-button gmc-qr-close\" ng-click=\"vm.cancel()\" aria-label=\"Close\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></header><md-dialog-content><div class=\"gmc-qr-dialog-body\"><p class=\"gmc-qr-subtitle\" \ntranslate=\"GUEST_MESSAGE_CENTER.TEMPLATE_DETAILS\">Template details</p><div class=\"gmc-qr-field\"><label \nclass=\"gmc-qr-label\" translate=\"GUEST_MESSAGE_CENTER.TEMPLATE_NAME_LABEL\">Template name</label><div \nclass=\"gmc-qr-input-wrap\"><input class=\"gmc-qr-input\" type=\"text\" ng-model=\"vm.form.name\" \nng-change=\"vm.validateTemplateName()\" placeholder=\"{{ \'GUEST_MESSAGE_CENTER.TEMPLATE_NAME_LABEL\' | translate }}\" \nrequired md-autofocus></div><div class=\"gmc-qr-inline-error\" ng-if=\"vm.duplicateTemplateName\">\nTemplate name already exists in this category.</div></div><div class=\"gmc-qr-field\"><label class=\"gmc-qr-label\" \ntranslate=\"GUEST_MESSAGE_CENTER.TEMPLATE_BODY_LABEL\">Message body</label><div \nclass=\"gmc-qr-input-wrap gmc-qr-textarea-wrap\"><textarea id=\"gmc-qr-body-input\" class=\"gmc-qr-input gmc-qr-textarea\" \nng-model=\"vm.form.body\" rows=\"6\" placeholder=\"{{ \'GUEST_MESSAGE_CENTER.TYPE_MESSAGE\' | translate }}\" required>\n                    </textarea></div></div><div class=\"gmc-qr-tokens\"><p class=\"gmc-qr-subtitle gmc-qr-tokens-title\" \ntranslate=\"GUEST_MESSAGE_CENTER.INSERT_TOKEN\">Available tags</p><div class=\"gmc-qr-tokens-hint\" \ntranslate=\"GUEST_MESSAGE_CENTER.INSERT_TOKEN_HINT\">Click a tag to insert it into the message body.</div><div \nclass=\"gmc-qr-tokens-list\"><button type=\"button\" class=\"gmc-qr-token\" ng-repeat=\"token in vm.tokens track by token\" \nng-click=\"vm.insertToken(token)\">{{token}}</button></div></div><div class=\"gmc-qr-error\" ng-if=\"vm.errorMessage\">\n{{vm.errorMessage}}</div></div></md-dialog-content><md-dialog-actions class=\"gmc-qr-actions\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"gmc-qr-cancel\" ng-click=\"vm.cancel()\" \ntranslate=\"GUEST_MESSAGE_CENTER.CANCEL\">Cancel</md-button><md-button class=\"md-raised gmc-qr-save\" \nng-click=\"vm.save()\" ng-disabled=\"vm.saving || !vm.canSave()\"><span ng-if=\"!vm.saving\" \ntranslate=\"GUEST_MESSAGE_CENTER.SAVE\">Save</span><md-progress-circular ng-if=\"vm.saving\" md-mode=\"indeterminate\" \nmd-diameter=\"20\"></md-progress-circular></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/permissions/adminusers/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{vm.user.avatar}}\" \nclass=\"md-avatar avatar mr-16\" alt=\"{{vm.user.name}}\"> <span class=\"font-weight-500 font-size-14\">{{vm.user.name}}\n</span></div><md-divider></md-divider><div ms-scroll class=\"content\"><md-list><md-list-item \nng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p translate=\"CONTACTS.ALL_CONTACTS\">\nAll Contacts</p></md-list-item><md-list-item ng-click=\"vm.filterChange(\'frequent\')\" \nng-class=\"{\'selected\':vm.listType ===\'frequent\'}\"><p translate=\"CONTACTS.FREQUENTLY_CONTACTED\">Frequently Contacted</p>\n</md-list-item><md-list-item ng-click=\"vm.filterChange(\'starred\')\" ng-class=\"{\'selected\':vm.listType ===\'starred\'}\"><p \ntranslate=\"CONTACTS.STARRED_CONTACTS\">Starred Contacts</p></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\">Groups</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.filterChange(group)\" ng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">\n{{group.name}}</p></md-list-item><md-list-item class=\"new-group-form\" ng-show=\"newListForm.$visible\"><p class=\"pl-8\" \neditable-text=\"vm.newGroupName\" e-form=\"newListForm\" onaftersave=\"vm.addNewGroup()\"></p></md-list-item><md-list-item \nclass=\"\" ng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\"><p class=\"pl-8 md-accent-fg\" \ntranslate=\"CONTACTS.NEW_GROUP\">New Group</p></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/permissions/organizations/dialogs/organization/organization-dialog.html","<md-dialog class=\"organization-dialog\" aria-label=\"New Organization\"><form name=\"organizationForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editorganizations\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"ORGANIZATIONS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\"><md-content class=\"md-padding margin-top\"><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"ORGANIZATIONS.NAME_REQUIRED\">\nOrganisation Name (required) {{vm.columnError}}</label><md-icon md-font-icon=\"icon-domain\" class=\"name\"></md-icon>\n<input ng-blur=\"vm.uniqueOrgName(vm.organization.hotel_title,\'hotel_title\')\" ng-model=\"vm.organization.hotel_title\" \nname=\"hotel_title\" type=\"text\" md-autofocus required ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div \nng-show=\"vm.uniqueName\" role=\"alert\"><div style=\"font-size:12px;color:#d60606\"><span>Hotel already exists.</span></div>\n</div></md-input-container></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"vm.newOrganization ==false\" ng-click=\"vm.saveOrganization()\" class=\"send-button md-accent md-raised white-fg\" \nng-disabled=\"organizationForm.$invalid || organizationForm.$pristine || vm.uniqueError\" aria-label=\"SAVE\" \ntranslate=\"ORGANIZATIONS.SAVE\" translate-attr-aria-label=\"ORGANIZATIONS.SAVE\">SAVE</md-button><md-button type=\"submit\" \nng-if=\"vm.newOrganization\" ng-click=\"vm.addNewOrganization()\" class=\"send-button md-accent md-raised white-fg\" \nng-disabled=\"organizationForm.$invalid || organizationForm.$pristine || vm.uniqueError\" aria-label=\"Add Task\" \ntranslate=\"ORGANIZATIONS.ADD_ORGANIZATION\" translate-attr-aria-label=\"ORGANIZATIONS.ADD_ORGANIZATION\">Add</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/permissions/organizations/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{vm.user.avatar}}\" \nclass=\"md-avatar avatar mr-16\" alt=\"{{vm.user.name}}\"> <span class=\"font-weight-500 font-size-14\">{{vm.user.name}}\n</span></div><md-divider></md-divider><div ms-scroll class=\"content\"><md-list><md-list-item \nng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p translate=\"CONTACTS.ALL_CONTACTS\">\nAll contacts</p></md-list-item><md-list-item ng-click=\"vm.filterChange(\'frequent\')\" \nng-class=\"{\'selected\':vm.listType ===\'frequent\'}\"><p translate=\"CONTACTS.FREQUENTLY_CONTACTED\">Frequently contacted</p>\n</md-list-item><md-list-item ng-click=\"vm.filterChange(\'starred\')\" ng-class=\"{\'selected\':vm.listType ===\'starred\'}\"><p \ntranslate=\"CONTACTS.STARRED_CONTACTS\">Starred contacts</p></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\">Groups</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.filterChange(group)\" ng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">\n{{group.name}}</p></md-list-item><md-list-item class=\"new-group-form\" ng-show=\"newListForm.$visible\"><p class=\"pl-8\" \neditable-text=\"vm.newGroupName\" e-form=\"newListForm\" onaftersave=\"vm.addNewGroup()\"></p></md-list-item><md-list-item \nclass=\"\" ng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\"><p class=\"pl-8 md-accent-fg\" \ntranslate=\"CONTACTS.NEW_GROUP\">New Group</p></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/permissions/roles/dialogs/contact/role-dialog.html","<md-dialog class=\"role-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\" class=\"middletoolbar\"><div class=\"role-name\">{{vm.contact.name}}</div>\n</div></div></md-toolbar><md-dialog-content ms-scroll style=\"max-width:800px;max-height:1000px\"><md-content \nclass=\"md-padding margin-top\"><md-input-container class=\"md-icon-float md-block\"><label>Name</label><md-icon \nmd-font-icon=\"icon-account\" class=\"md-icon-float md-default-theme flex-gt-xs-50 flex-100 md-input-invalid\"></md-icon>\n<input ng-model=\"vm.contact.role_name\" name=\"role_name\" type=\"text\" required autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>Hotel\n</label><md-icon></md-icon><md-select multiple=\"{{false}}\" placeholder=\"Hotel\" ng-model=\"vm.contact.role_websites\" \nng-model-options=\"{trackBy: \'$value.hotel_id\'}\" required><md-option ng-value=\"website\" \nng-repeat=\"website in vm.websites\">{{website.hotel_title}}</md-option></md-select></md-input-container></md-content>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newContact\" ng-click=\"vm.saveContact()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"contactForm.$invalid || contactForm.$pristine \" aria-label=\"SAVE\">\nSave</md-button><md-button type=\"submit\" ng-if=\"vm.newContact\" ng-click=\"vm.addNewRole()\" \nclass=\"send-button md-accent md-raised white-fg\" ng-disabled=\"contactForm.$invalid || contactForm.$pristine\" \naria-label=\"Add Task\">Add role</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/permissions/roles/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{vm.user.avatar}}\" \nclass=\"md-avatar avatar mr-16\" alt=\"{{vm.user.name}}\"> <span class=\"font-weight-500 font-size-14\">{{vm.user.name}}\n</span></div><md-divider></md-divider><div ms-scroll class=\"content\"><md-list><md-list-item \nng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p translate=\"CONTACTS.ALL_CONTACTS\">\nAll contacts</p></md-list-item><md-list-item ng-click=\"vm.filterChange(\'frequent\')\" \nng-class=\"{\'selected\':vm.listType ===\'frequent\'}\"><p translate=\"CONTACTS.FREQUENTLY_CONTACTED\">Frequently contacted</p>\n</md-list-item><md-list-item ng-click=\"vm.filterChange(\'starred\')\" ng-class=\"{\'selected\':vm.listType ===\'starred\'}\"><p \ntranslate=\"CONTACTS.STARRED_CONTACTS\">Starred contacts</p></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\">Groups</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.filterChange(group)\" ng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">\n{{group.name}}</p></md-list-item><md-list-item class=\"new-group-form\" ng-show=\"newListForm.$visible\"><p class=\"pl-8\" \neditable-text=\"vm.newGroupName\" e-form=\"newListForm\" onaftersave=\"vm.addNewGroup()\"></p></md-list-item><md-list-item \nclass=\"\" ng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\"><p class=\"pl-8 md-accent-fg\" \ntranslate=\"CONTACTS.NEW_GROUP\">New Group</p></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/settings/emails/templates/template/template.html","<div id=\"template-setting\" class=\"page-layout simple fullwidth doc-page element-doc-page main-simple-table-1\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" \nng-click=\"vm.gotoTemplates()\" translate translate-attr-aria-label=\"SETTINGS.GO_TO_TEMP\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"column\" layout-align=\"start start\" flex><div class=\"h2\">{{vm.title}}</div><div class=\"subtitle secondary-text\" \nng-show=\"vm.actionType != \'add\'\"><span translate=\"SETTINGS.PRODUCT_DETAIL\">Template Detail</span></div></div><div \nng-hide=\"vm.actionType != \'add\'\"><md-button class=\"md-raised md-background\" ng-click=\"vm.saveTemplate();\" \nng-disabled=\"emailTemplatesForm.$invalid || emailTemplatesForm.$pristine || vm.uniqueError\" \nng-class=\"{\'md-blue-grey-A100-bg\': emailTemplatesForm.$invalid || emailTemplatesForm.$pristine || vm.uniqueError}\">\n<span translate=\"SETTINGS.SAVE\">Save</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"vm.gotoTemplates();\"><span>Cancel</span></md-button></div></div></div></div><div class=\"content\"><div \nclass=\"main sm-hearder-top\" ms-scroll><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><div class=\"white-bg md-whiteframe-4dp white-scroll\" layout-align=\"center center\" layout-padding>\n<form name=\"emailTemplatesForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container class=\"md-block mb-0\" flex=\"100\" flex-gt-xs=\"100\"><label translate=\"SETTINGS.PRODUCT_NAME\">Name\n</label><input required name=\"name\" type=\"text\" ng-model=\"vm.template.template_name\" \nng-change=\"vm.updateTemplate(vm.template.template_name)\" ng-model-options=\"{debounce: 500}\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div ng-if=\"vm.uniqueError\" role=\"alert\"><div \nstyle=\"font-size:12px;color:#d60606\"><span>Template name already exists.</span></div></div></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container class=\"md-block mb-0\" flex=\"100\" flex-gt-xs=\"100\">\n<label translate=\"SETTINGS.TEMP_SUBJ\">Subject</label><input required name=\"subject\" type=\"text\" \nng-model=\"vm.template.template_subject\" ng-change=\"vm.updateTemplate(vm.template.template_subject)\" \nng-model-options=\"{debounce: 500}\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"><div \nng-messages=\"emailTemplatesForm.subject.$error\"><div ng-message=\"required\">Please Enter Template subject.</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><h3 class=\"secondary-text template_content\" \ntranslate=\"SETTINGS.PRODUCT_DESCRIPTION\" flex=\"60\" layout=\"column\" flex-gt-xs=\"70\">Content</h3><div flex=\"60\" \nlayout=\"column\" flex-gt-xs=\"70\" layout-align=\" center end\"><md-button \nclass=\"no-margin no-padding template_icon md-accent mb-10\" aria-label=\"Variables Information\" layout=\"column\">\n<md-tooltip>Variables Information</md-tooltip><md-icon md-font-icon=\"icon-information\" class=\"showinfo\" \nng-click=\"vm.showInfo()\"></md-icon></md-button></div></div><div layout=\"column\" layout-gt-xs=\"row\" flex \nflass=\"chkdescblk\" id=\"area\"><textarea name=\"desc\" id=\"desc\" class=\"\" flex=\"100\" flex-gt-xs=\"100\" \nng-model-options=\"{debounce: 500}\" required ng-model=\"vm.template.template_content\" ng-readonly=\"vm.autoFillOff\" \nautocomplete=\"off\">\n						</textarea></div></form></div></div></div></div>");
$templateCache.put("app/main/apps/e-commerce/views/activities/activity/dialog/posttype-dialog.html","<md-dialog class=\"tax-dialog act-dialog\" aria-label=\"New Task\"><form name=\"posTypeForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"row\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\"><md-button class=\"goto-products-button md-icon-button\" ng-if=\"vm.show_listing\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"white-fg\" ng-click=\"vm.hideListing()\"></md-icon></md-button><md-button \nclass=\"goto-products-button md-icon-button\" ng-if=\"vm.pos_flag == \'edit\'\"><md-icon md-font-icon=\"icon-arrow-left\" \nclass=\"white-fg\" ng-click=\"vm.showListing()\"></md-icon></md-button>{{ vm.pop_header }}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\" \nclass=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\"><md-content class=\"relative-block md-padding no-margin\" \nng-hide=\"vm.show_listing || vm.delete_popup\"><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.isloading\">\n</md-progress-linear><div layout=\"row\" layout-align=\" end start\"><md-button \nclass=\"md-raised md-accent white-fg md-button md-default-theme md-ink-ripple no-margin\" \nng-click=\"vm.showListing($event)\" aria-label=\"Close dialog\" ng-if=\"vm.pos_flag == \'add\'\">\n{{ \'POS_TYPE.VIEW_ALL\' | translate }}</md-button></div><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" \nflex><div class=\"row-block mt-15 mb-10\" flex-gt-xs=\"40\"><div \nclass=\"row-col padding-right-10 padding-left-10 margin-top-10\" flex-gt-xs=\"100\"><md-input-container \nclass=\"overflow-hidden md-block tax-inputs-img-uploade image-container no-margin new-img-pop\" flex-gt-xs=\"50\"><img \nngf-src=\"vm.pictures\" ng-show=\"vm.pictures\"> <img ngf-src=\"vm.previousPicture\" ng-show=\"vm.imageStatus\"><choose-file \nclass=\"md-fab md-mini full-row-block md-profile-icon-1\" flex-gt-xs=\"100\" layout=\"row\" layout-align=\"start start\" flex>\n<input type=\"file\" id=\"pictures\" name=\"pictures\" ngf-select=\"upload($file,$invalidFiles)\" ng-model=\"vm.pictures\" \naccept=\"image/*\" class=\"ng-hide\" ng-model-options=\"{debounce: 500}\" ngf-pattern=\"\'.jpg,.jpeg,.png,.gif,.svg\'\" \nngf-accept=\"\'.jpg,.jpeg,.png,.gif,.svg\'\"><div class=\"inline-block-txt\" layout=\"row\" layout-align=\"start start\" \nflex-gt-xs=\"8\"><md-button id=\"uploadButton\" class=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-upload\" \nclass=\"white-fg\"></md-icon></md-button></div><md-input-container flex class=\"md-block inline-block-txt\" \nflex-gt-xs=\"92\"><input type=\"hidden\" ng-model=\"fileName\" autocomplete=\"off\" ng-readonly=\" vm.autoFillOff\"><div \nclass=\"hint\"></div></md-input-container></choose-file></md-input-container></div></div><div \nclass=\"row-block mt-15 mb-10\" flex-gt-xs=\"60\" flex><div class=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs margin-top-10 bottom-margin-0\" \nflex-gt-xs=\"100\"><label translate=\"POS_TYPE.PRODUCT_TYPE\"></label><md-select \nplaceholder=\"{{ \'POS_TYPE.PRODUCT_TYPE\' | translate}}\" ng-model=\"vm.pos_types.pos_type\" required \nng-change=\"vm.updateParentData()\"><md-option ng-value=\"posproducttype.hidename\" \nng-repeat=\"posproducttype in vm.posProductTypes\">{{posproducttype.showname}}</md-option></md-select>\n</md-input-container></div></div><div class=\"row-block\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex>\n<div class=\"row-col padding-right-10 padding-left-10 margin-bottom-10\" flex-gt-xs=\"100\" flex-gt-sm=\"100\" \nlayout-align=\"start start\" flex><md-input-container flex-gt-xs=\"100\" class=\"md-block tax-inputs bottom-margin-0\" \ndata-ng-animate=\"1\"><label translate=\"POS_TYPE.NAME\"></label><input required type=\"text\" name=\"pos_type_name\" \nng-model=\"vm.pos_types.pos_type_name\" ng-change=\"vm.checkPosUniqueName()\" autocomplete=\"off\" \nng-readonly=\" vm.autoFillOff\"><div ng-if=\"vm.nameError\" role=\"alert\"><div class=\"emailError\"><span \ntranslate=\"POS_TYPE.NAME_EXISTS\"></span></div></div></md-input-container></div></div><div class=\"row-block\" \nlayout=\"column\" layout-gt-xs=\"row\" layout-align=\"start\" flex><div class=\"row-col padding-right-10 padding-left-10\" \nflex-gt-xs=\"100\" layout-align=\"start start\" flex><md-input-container \nclass=\"md-block tax-inputs margin-top-10 bottom-margin-0\" flex-gt-xs=\"100\"><label>Parent</label><md-select \nng-model=\"vm.pos_types.pos_parent_id\"><md-option ng-value=\"item.pos_type_id\" ng-repeat=\"item in vm.parentPosTypes\">\n{{item.pos_type_name}}</md-option></md-select></md-input-container></div></div><div class=\"row-block\" layout=\"column\" \nlayout-gt-xs=\"row\" layout-align=\"start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs margin-top-10 bottom-margin-0\" \nflex-gt-xs=\"100\"><label translate=\"POS_TYPE.DESCRIPTION\"></label><input required type=\"text\" \nname=\"pos_type_description\" ng-model=\"vm.pos_types.pos_type_description\" autocomplete=\"off\" \nng-readonly=\" vm.autoFillOff\"></md-input-container></div></div><div class=\"row-block\" layout=\"column\" \nlayout-gt-xs=\"row\" layout-align=\"start\" flex><div class=\"row-col padding-right-10 padding-left-10\" flex-gt-xs=\"100\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs margin-top-10 bottom-margin-0\" \nflex-gt-xs=\"100\"><label translate=\"POS_TYPE.STATUS\"></label><md-select \nplaceholder=\"{{ \'POS_TYPE.SELECT_STATUS\' | translate}}\" ng-model=\"vm.pos_types.pos_type_status\" required><md-option \nclass=\"capitalize\" value=\"{{status.value}}\" ng-repeat=\"status in vm.status\" ng-bind=\"status.name\"></md-option>\n</md-select></md-input-container></div></div></div></div></md-content><md-content class=\"no-margin shadow\" \nng-if=\"vm.show_listing\"><div class=\"ms-responsive-table-wrapper\"><table class=\"simple\" ms-responsive-table><thead><tr>\n<th>{{ \'POS_TYPE.NAME\' | translate }}</th><th>{{ \'POS_TYPE.POS_TYPE\' | translate }}</th><th><span class=\"tabl-sp\">\n{{ \'ACTION\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"posType in vm.PosTypes\"><tr \nng-repeat=\"SubposType in posType\"><td>{{ SubposType.pos_type_name }}</td><td>{{ SubposType.pos_type }}</td><td><span \nclass=\"tabl-sp\"><md-button class=\"md-icon-button\" ng-click=\"vm.getPosType(SubposType.pos_type_id)\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.deltePosType(SubposType.pos_type_id,$event)\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button>\n</span></td></tr></tbody></table></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\" ng-hide=\"vm.show_listing\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-click=\"vm.addNewPosType()\" class=\"send-button md-accent md-raised white-fg\" \nng-disabled=\"posTypeForm.$invalid || posTypeForm.$pristine \" aria-label=\"Add Task\" \nng-class=\"{\'md-blue-grey-A100-bg\': posTypeForm.$invalid || posTypeForm.$pristine || vm.nameError}\" translate=\"SAVE\">\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/activities/activity/dialog/postype-image.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\" style=\"overflow: visible\"><md-dialog-content \nclass=\"no-padding\" style=\"overflow: visible\"><md-content class=\"md-padding margin-top\" style=\"overflow: visible\"><div \nclass=\"cross-icons cross-icons-dilog\"><a ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close \" \nclass=\"close-icon1 white-fg font-size-12\"></md-icon></a></div><div class=\"content-scrol-block no-margin\" ms-scroll \nstyle=\"overflow: hidden\"><div class=\"scroll-pop-block1\" \nstyle=\"max-height: 500px;overflow: auto;display: flex;justify-content: center\"><md-input-container \nclass=\"no-margin md-icon-float md-block\"><img src=\"{{vm.image}}\"></md-input-container></div></div></md-content>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/orders/dialogs/document-viewer/document-viewer.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\" style=\"overflow: visible\"><md-dialog-content \nclass=\"no-padding\" style=\"overflow: visible\"><md-content class=\"md-padding margin-top\" style=\"overflow: visible\"><div \nclass=\"cross-icons cross-icons-dilog\"><a ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close \" \nclass=\"close-icon1 white-fg font-size-12\"></md-icon></a></div><div class=\"content-scrol-block no-margin\" ms-scroll \nstyle=\"overflow: hidden\"><div class=\"slider11\"><div class=\"sliderepeat\" ng-repeat=\"document in vm.documents\" \nng-if=\"document.type != \'other\'\"><div class=\"scroll-pop-block1\"><md-input-container \nclass=\"no-margin md-icon-float md-block\" ng-if=\"document.type == \'image\'\"><img class=\"imgdiglogfullblock\" \nsrc=\"{{vm.baseUrl}}assets/uploads/documents/{{document.doc_name}}\"></md-input-container><iframe \nng-if=\"document.type == \'pdf\'\" ng-src=\"{{trustSrc(document.doc_name)}}\" width=\"100%\" class=\"iframepdfpath\"></iframe>\n</div></div></div></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/orders/dialogs/OTA/ota.html","<md-dialog class=\"contact-dialog edit-dates-dailog\" aria-label=\"New Task\"><form name=\"openPlaceGantt\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">OTA Details</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\" class=\"main-dilog-1\"><md-content class=\"md-padding\"><div flex=\"100\" \nlayout=\"row\" layout-wrap><div class=\"row-block-new\" flex=\"100\" flex-gt-xs=\"100\" layout=\"column\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block tax-inputs\" data-ng-animate=\"1\"><label>Channel\n</label><md-select ng-model=\"vm.orderData.source_of_creation\"><md-option ng-repeat=\"channels in vm.channels\" \nng-value=\"channels\">{{ channels}}</md-option></md-select></md-input-container></div><div class=\"row-block-new\" \nflex=\"100\" flex-gt-xs=\"100\" layout=\"column\" layout-align=\"start start\" flex><md-input-container \nclass=\"md-block tax-inputs\" data-ng-animate=\"1\"><label>Payment Collector</label><md-select \nng-model=\"vm.orderData.collect_which\"><md-option><em>None</em></md-option><md-option \nng-repeat=\"(key, value) in vm.paymentType\" ng-value=\"key\">{{value}}</md-option></md-select></md-input-container></div>\n<div class=\"row-block-new\" flex=\"100\" flex-gt-xs=\"100\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block tax-inputs\" data-ng-animate=\"1\"><label class=\"ng-scope\" role=\"button\">Siteminder Id\n</label><input type=\"text\" name=\"SiteminderId\" ng-model=\"vm.orderData.siteminder_id\" aria-invalid=\"true\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></div></div></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" flex=\"100\"><div flex=\"100\" layout=\"column\" layout-align=\"end end\"><div \nclass=\"Fromto-col padding-left-10 padding-right-10\"><md-button type=\"submit\" ng-click=\"vm.saveOTADetails()\" \nclass=\"md-raised md-green-500-bg submit-button white-fg\" aria-label=\"ADD\">Save</md-button></div></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/orders/dialogs/edit-dates/edit-dates.html","<md-dialog class=\"contact-dialog edit-dates-dailog\" ng-style=\"{\'max-width\' : vm.show_rooms?\'1200px\':\'800px\'} \" \naria-label=\"New Task\"><form name=\"openPlaceGantt\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-tall white-fg\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"EC.EDIT_TITLE\"></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll style=\"max-height: 1000px\" \nng-style=\"{\'max-width\' : vm.show_rooms?\'1200px\':\'800px\'} \" class=\"main-dilog-1\"><md-content class=\"md-padding\"><div \nflex=\"100\" layout=\"row\" layout-wrap><div class=\"row-block-new\" flex=\"50\" layout=\"column\" layout-align=\"start start\" \nflex><md-input-container class=\"md-block full-width\"><label translate=\"CREATE_RES.CHECKIN\"></label><md-datepicker \nmd-open-on-focus ng-model=\"vm.checkin\" ng-change=\"vm.checkinModified()\" class=\"full-width mdinput-block\" \nchangecheckout></md-datepicker><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"row-block-new\" flex=\"50\" layout=\"column\" layout-align=\"start start\" flex><md-input-container \nclass=\"md-block full-width mb-0\"><label translate=\"CREATE_RES.CHECKOUT\"></label><md-datepicker md-open-on-focus \nng-model=\"vm.checkout\" md-min-date=\"vm.isDayReservation ? null : vm.minDateCheckout\" ng-disabled=\"vm.isDayReservation\" \nclass=\"full-width mdinput-block\"></md-datepicker><div class=\"md-errors-spacer\"></div></md-input-container></div></div>\n</md-content><md-content class=\"\"><div class=\"row-block-new room-availabe\" ng-if=\"vm.show_rooms\" layout=\"column\" \nlayout-gt-xs=\"row\" layout-align=\"start start\" flex><div ng-if=\"vm.show_rooms\" class=\"full-width-100 md-padding\"><div \nclass=\"norecordfound\" ng-if=\"vm.available_rooms.length == 0\"><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"mb-15\"></md-icon>{{\'EC.NO_ROOMS\' | translate}}</div><div class=\"norecordfound\" \nng-if=\"vm.available_rooms.length > 0\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon>\n{{\'EC.NO_AVAILABILTY\' | translate}}</div><div ng-if=\"vm.available_rooms.length !== 0\" class=\"mb-15\"><div \nclass=\"form-title no-padding\" translate=\"ADD_ROOM.AVAILABLE_ROOMS\" ng-if=\"vm.requestFor == \'reservation\'\"></div><div \nclass=\"form-title no-padding\" translate=\"ADD_ROOM.AVAILABLE_BOAT\" ng-if=\"vm.requestFor == \'boat\'\"></div><div \nclass=\"room-listing room-repeatblk\" ng-repeat=\"(roomkey,room) in vm.available_rooms\"><div class=\"img-block-room\"><img \nng-if=\"!room.image\" ng-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\" class=\"erroeimg-1\"> <img \nng-if=\"room.image\" ng-src=\"{{vm.baseUrl+\'/assets/uploads/product/\'+room.image}}\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\" class=\"erroeimg-1\"></div><div \nclass=\"room-block-listing\"><div class=\"product_name_blk\" flex=\"100\" layout-wrap layout=\"row\"><span \nclass=\"aprt-name aprt-name-lt mb-5\">{{room.product_name}}</span><div class=\"policy-outer\"><div \nclass=\"Reservation-outer-block\" ng-repeat=\"(policykey,eachpolicy) in vm.available_rooms[$index].policy_name\">\n<md-radio-group ng-model=\"vm.selectedRoom\"><md-radio-button value=\"{{roomkey}}\" \nclass=\"checkblock-ckeckbox margin-top-0 margin-bottom-0 room-repeatblk single\"><span class=\"aprt-nightly nt-policy\">\n{{eachpolicy}}</span></md-radio-button><div class=\"rate-plan-spans-block\"><span class=\"aprt-nightly rate-plan-anchor\">\n<div class=\"rate-plan-txt\" ng-init=\"vm.showRateDesc[roomkey][policykey] = false\" \nng-mouseenter=\"!vm.runClickEvent?vm.showDetailRateBlock(roomkey,policykey):\'\'\" \nng-mouseleave=\"!vm.runClickEvent?vm.closeAllRateDetails(roomkey,policykey):\'\'\" \nng-click=\"vm.runClickEvent?vm.showDetailRateBlock(roomkey,policykey):\'\'\">\nRate Plan: {{room.rateNameDesc[policykey].ratePlanName}}<div class=\"total-amount-blk-section\" \nng-if=\"vm.showRateDesc[roomkey][policykey] && room.rateNameDesc[policykey].ratePlanDesc != \'\'\"><div \nclass=\"total-amt-row\"><b>{{room.rateNameDesc[policykey].ratePlanDesc}}</b></div></div></div></span><span \nclass=\"aprt-nightly\" ng-if=\"vm.requestFor == \'reservation\'\">Max Occupancy: {{room.max_occupancy}} </span><span \nclass=\"aprt-nightly\" ng-if=\"room.boat_length > 0 && vm.requestFor == \'boat\'\">Boat Length: {{room.boat_length}}</span> \n<span class=\"aprt-nightly\" ng-if=\"room.boat_width > 0 && vm.requestFor == \'boat\'\">Boat Width: {{room.boat_width}}\n</span> <span class=\"aprt-nightly\">Nightly rate: <b class=\"rate-color-add red-A800-fg\">${{room.nightlyRate[policykey]}}\n</b></span></div></md-radio-group><div class=\"total-price-block top0blk\" \nng-init=\"vm.showBlock[roomkey][policykey] = false\" \nng-mouseenter=\"!vm.runClickEvent?vm.showDetailBlock(roomkey,policykey):\'\'\" \nng-mouseleave=\"!vm.runClickEvent?vm.closeAllDetails(roomkey,policykey):\'\'\" \nng-click=\"vm.runClickEvent?vm.showDetailBlock(roomkey,policykey):\'\'\"><small>Total</small> <b>\n${{room.searchSummary[policykey].grandTotal}}</b><div class=\"total-amount-blk-section\" \nng-if=\"vm.showBlock[roomkey][policykey]\"><div class=\"total-amt-row\"><span ng-if=\"vm.requestFor == \'reservation\'\">\nRoom Amount</span> <span ng-if=\"vm.requestFor == \'boat\'\">Boat Amount</span> <span>\n${{room.searchSummary[policykey].subTotal}}</span></div><div class=\"total-amt-row\" ng-if=\"vm.extraPersonApplicable\">\n<span>Extra Person</span> <span>${{room.searchSummary[policykey].extraPersonAmt}}</span></div><div \nclass=\"total-amt-row\" ng-if=\"vm.resortFeeApplicable\"><span>Resort fee</span> <span>\n${{room.searchSummary[policykey].resortFee}}</span></div><div class=\"total-amt-row\" \nng-if=\"room.searchSummary[policykey].surcharge != undefined\"><span>Surcharge</span> <span>\n${{room.searchSummary[policykey].surcharge}}</span></div><div class=\"total-amt-row\"><span>Taxes</span> <span>\n${{room.searchSummary[policykey].taxes}}</span></div><div class=\"total-amt-row\"><span>Grand Total</span> <span>\n${{room.searchSummary[policykey].grandTotal}}</span></div></div></div></div></div></div></div><p \nclass=\"room_type_description\" id=\"description_{{room.product_id}}\">{{room.room_type_description}}</p></div></div></div>\n</div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" flex=\"100\"><div \nng-if=\"!vm.show_rooms || (vm.show_rooms && vm.available_rooms.length == 0)\" flex=\"100\" layout=\"column\" \nlayout-align=\"end end\"><div class=\"Fromto-col padding-left-10 padding-right-10\"><md-checkbox class=\"no-margin\" \nng-checked=\"true\" ng-model=\"vm.keepSameRates\"><span>Keep same rates</span></md-checkbox><md-button \nng-class=\"vm.isloading?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-click=\"vm.changeDatesForRes()\" ng-disabled=\"vm.isloading\" aria-label=\"Show Rooms\">Save</md-button></div></div><div \nng-if=\"vm.show_rooms && vm.available_rooms.length > 0\" flex=\"100\" layout=\"column\" layout-align=\"end end\"><div \nclass=\"Fromto-col padding-left-10 padding-right-10\"><md-checkbox class=\"no-margin\" ng-model=\"vm.keepSameRates\"><span>\nKeep same rates</span></md-checkbox><md-button type=\"submit\" ng-click=\"vm.changeRoomForRes()\" \nng-class=\"vm.selectedRoom == \'\'?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"vm.selectedRoom == \'\'\" aria-label=\"ADD\" translate=\"Save\">SAVE</md-button></div></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/orders/dialogs/edit-pos-dates/edit-pos-dates.html","<md-dialog class=\"contact-dialog edit-dates-dailog\" aria-label=\"New Task\"><form name=\"openPlaceGantt\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"EC.EDIT_TITLE_POS\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\" class=\"main-dilog-1\"><md-content class=\"md-padding\"><div flex=\"100\" \nlayout=\"row\" layout-wrap><div class=\"row-block-new\" flex=\"50\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block full-width\"><label translate=\"CREATE_RES.CHECKIN\"></label><md-datepicker \nmd-open-on-focus ng-model=\"vm.checkin\" ng-change=\"vm.checkinModified()\" class=\"full-width mdinput-block\" \nchangecheckout></md-datepicker><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"row-block-new\" flex=\"50\" layout=\"column\" layout-align=\"start start\" flex><md-input-container \nclass=\"md-block full-width mb-0\"><label translate=\"CREATE_RES.CHECKOUT\"></label><md-datepicker md-open-on-focus \nng-model=\"vm.checkout\" md-min-date=\"vm.minDateCheckout\" class=\"full-width mdinput-block\"></md-datepicker><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></div></md-content></md-dialog-content><md-dialog-actions \nlayout=\"row\" flex=\"100\"><div flex=\"100\" layout=\"column\" layout-align=\"end end\"><div \nclass=\"Fromto-col padding-left-10 padding-right-10\"><md-button \nng-class=\"vm.isloading?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-click=\"vm.changeDatesForPos()\" ng-disabled=\"vm.isloading\" aria-label=\"Show Rooms\">Save</md-button></div></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/orders/dialogs/get-csv/getcsv.html","<md-dialog class=\"contact-dialog edit-dates-dailog\" aria-label=\"New Task\"><form name=\"openPlaceGantt\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"{{vm.title}}\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\" class=\"main-dilog-1\"><md-content class=\"md-padding\"><div flex=\"100\" \nlayout=\"row\" layout-wrap><div class=\"row-block-new\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block full-width\"><label translate=\"CREATE_RES.CHECKIN\">\n</label><md-datepicker md-open-on-focus ng-model=\"vm.startDate\" class=\"full-width mdinput-block\" changecheckout>\n</md-datepicker><div class=\"md-errors-spacer\"></div></md-input-container></div><div class=\"row-block-new\" flex=\"100\" \nflex-gt-xs=\"50\" layout=\"column\" layout-align=\"start start\" flex><md-input-container class=\"md-block full-width mb-0\">\n<label translate=\"CREATE_RES.CHECKOUT\"></label><md-datepicker md-open-on-focus ng-model=\"vm.endDate\" \nclass=\"full-width mdinput-block\"></md-datepicker><div class=\"md-errors-spacer\"></div></md-input-container></div></div>\n</md-content></md-dialog-content><md-dialog-actions layout=\"row\" flex=\"100\"><div flex=\"100\" layout=\"column\" \nlayout-align=\"end end\"><div class=\"Fromto-col padding-left-10 padding-right-10\"><md-button type=\"submit\" \nng-click=\"vm.getselectedDAteRange()\" class=\"md-raised md-green-500-bg submit-button white-fg\" aria-label=\"Download\">\nDownload</md-button></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/orders/dialogs/parking/parking.html","<md-dialog class=\"contact-dialog edit-dates-dailog\" aria-label=\"New Task\"><form name=\"openPlaceGantt\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"{{vm.title}}\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nstyle=\"max-width:800px;max-height:1000px\" class=\"main-dilog-1\"><md-content class=\"md-padding\"><div flex=\"100\" \nlayout=\"row\" layout-wrap><div class=\"row-block-new\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block full-width\"><label translate=\"CREATE_RES.CHECKIN\">\n</label><md-datepicker md-open-on-focus ng-model=\"vm.checkin\" ng-change=\"vm.checkinModified()\" \nclass=\"full-width mdinput-block\" changecheckout></md-datepicker><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div class=\"row-block-new\" flex=\"100\" flex-gt-xs=\"50\" layout=\"column\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block full-width mb-0\"><label \ntranslate=\"CREATE_RES.CHECKOUT\"></label><md-datepicker md-open-on-focus ng-model=\"vm.checkout\" \nmd-min-date=\"vm.minDateCheckout\" class=\"full-width mdinput-block\"></md-datepicker><div class=\"md-errors-spacer\"></div>\n</md-input-container></div></div><div class=\"\" flex=\"100\" layout=\"row\"><div \nclass=\"Fromto-col padding-left-10 padding-right-10\" flex=\"100\" flex-gt-sm=\"100\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"end start\"><md-button type=\"submit\" ng-click=\"vm.searchParkingProducts()\" \nclass=\"md-raised md-green-500-bg submit-button white-fg\"><md-icon md-font-icon=\"icon-magnify\" class=\"white-fg\">\n</md-icon>Search</md-button></div></div></md-content><md-content class=\"mt-15\"><div \nclass=\"row-block-new room-availabe\" ng-if=\"vm.show_rooms\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start start\" flex><div ng-if=\"vm.show_rooms\" class=\"full-width md-padding\"><div \nclass=\"norecordfound mb-15\" ng-if=\"vm.available_rooms.length == 0 && vm.adding\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"mb-15\"></md-icon>{{\'EC.NO_PARK\' | translate}}</div><div \nclass=\"norecordfound mb-15\" ng-if=\"vm.available_rooms.length > 0 && !vm.adding && !vm.productIsAvailable\"><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon>{{vm.no_avail | translate}}</div><div \nng-if=\"vm.available_rooms.length !== 0\" class=\"mb-15 full-width\"><div ng-if=\"vm.adding\" \nclass=\"form-title no-padding mb-15\" translate=\"ADD_ROOM.{{vm.type}}\"></div><md-radio-group ng-if=\"vm.editing\" \nng-model=\"vm.selectedRoom\" flex=\"100\" layout=\"row\" class=\"full-width\" layout-wrap><md-radio-button layout=\"column\" \nflex-gt-xs=\"45\" value=\"{{$index}}\" ng-repeat=\"(roomkey,room) in vm.available_rooms\" \nclass=\"room-repeatblk no-borderroomparking repaetingradio\"><div class=\"room-listing\"><div class=\"img-block-room\"><img \nng-if=\"!room.image && !vm.adding\" ng-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\" class=\"erroeimg-1\">\n <img ng-if=\"room.image\" ng-src=\"{{vm.baseUrl+vm.media_path+room.image}}\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\" class=\"erroeimg-1\"></div><div \nclass=\"room-block-listing\"><div class=\"policy-outer\"><div class=\"row no-margin\" flex=\"100\" layout-wrap layout=\"row\">\n<span class=\"aprt-name mb-5\">{{room.product_name}} </span><span class=\"aprt-nightly\">Nightly rate: <b \nclass=\"rate-color-add red-A800-fg\">${{room.product_price}}</b></span></div></div></div></div></md-radio-button>\n</md-radio-group><div ng-if=\"!vm.editing\" layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex-gt-xs=\"50\" \nflex=\"100\" ng-repeat=\"(roomkey,room) in vm.available_rooms\" \nclass=\"room-repeatblk relative-block pl-40 no-borderroomparking\" class=\"hold_block_rooms\"><div><md-checkbox \nclass=\"checkabslefttop\" ng-change=\"vm.selectingroom()\" ng-model=\"vm.selectedRoomAdd[roomkey]\"><div \nclass=\"room-listing\"><div class=\"img-block-room\"><img ng-src=\"{{vm.baseUrl+vm.media_path+room.image}}\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\" class=\"erroeimg-1\"></div><div \nclass=\"room-block-listing\"><div class=\"policy-outer\"><div class=\"row no-margin\" flex=\"100\" layout-wrap layout=\"row\">\n<span class=\"aprt-name mb-5\">{{room.product_name}}</span> <span class=\"aprt-nightly\" ng-if=\"vm.searchType != \'boat\'\">\nNightly rate: <b class=\"rate-color-add red-A800-fg\">${{room.product_price}}</b> </span><span class=\"aprt-nightly\" \nng-if=\"vm.searchType == \'boat\'\">Price: <b class=\"rate-color-add red-A800-fg\">${{room.subtotal}}</b></span></div></div>\n</div></div></md-checkbox></div></div></div></div></div></div></md-content></md-dialog-content><md-dialog-actions \nlayout=\"row\" flex=\"100\"><div ng-if=\"!vm.show_rooms && !vm.adding\" flex=\"100\" layout=\"column\" layout-align=\"end end\">\n<div class=\"Fromto-col padding-left-10 padding-right-10\"><md-checkbox ng-if=\"!vm.create_parking && !vm.parking\" \nclass=\"no-margin\" ng-checked=\"true\" ng-model=\"vm.keepSameRates\"><span>Keep same rates</span></md-checkbox><md-button \nng-if=\"!vm.create_parking\" \nng-class=\"vm.isloading?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"vm.isloading\" ng-click=\"vm.changeDatesForRes()\" aria-label=\"Show Rooms\">Save</md-button></div></div><div \nng-if=\"vm.show_rooms\" flex=\"100\" layout=\"column\" layout-align=\"end end\"><div \nclass=\"Fromto-col padding-left-10 padding-right-10\"><md-checkbox \nng-if=\"!vm.adding && !vm.create_parking && !vm.parking\" class=\"no-margin\" ng-model=\"vm.keepSameRates\"><span>\nKeep same rates</span></md-checkbox><md-button ng-if=\"!vm.adding && !vm.create_parking\" type=\"submit\" \nng-click=\"vm.changeRoomForRes()\" \nng-class=\"vm.selectedRoom == \'\' || vm.isloading?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"vm.selectedRoom == \'\'\" aria-label=\"ADD\">Save</md-button><md-button \nng-if=\"vm.create_parking || vm.addParkingView\" type=\"submit\" ng-click=\"vm.addParkingProduct()\" \nng-disabled=\" !vm.enableAdd && vm.selectedRoom == \'\' \" \nng-class=\"true?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \naria-label=\"Save\">Save</md-button></div></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/orders/dialogs/payments/refund.html","<md-dialog class=\"role-dialog refund-dailog\"><md-toolbar class=\"md-accent white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nRefund</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><md-content class=\"md-padding checkin-checkout-dialog\"><p \nng-show=\"refund_by_check\" class=\"pb-15 m-0\">\nThis payment is older than 120 days and cannot be automatically refunded via the payment gateway. Please enter a check or gift card refund instead.\n</p><md-input-container class=\"md-block mb-0 mt-15\"><label translate=\"EC.AMOUNT\"></label><input \nng-disabled=\"type == \'void\'\" type=\"text\" ng-model=\"refund_amount\" ng-change=\"checkRefundAmount()\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container><md-input-container class=\"md-block mb-0 mt-30\">\n<label translate=\"CREATE_RES.CHECK_NO\"></label><input required type=\"text\" ng-model=\"check_number\" \nng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></md-input-container></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\" \nclass=\"layout-align-space-between-center layout-row\"><div layout=\"column\" layout-align=\"end end\" flex=\"100\"><div flex>\n<md-button ng-show=\"!refund_by_check\" \nng-class=\"vm.refundStart ||  giftCardExpiry?\'md-raised md-accent grey-100-fg\':\'md-raised md-green-500-bg white-fg\'\" \nclass=\"mv-15 mh-0\" ng-click=\"vm.refundInstallmentFinally(installment_id,refund_amount,\'original\',\'\')\" \nng-disabled=\"vm.refundStart || giftCardExpiry\" aria-label=\"YES\">{{payment}}</md-button><md-button \nng-class=\"vm.refundStart || check_number == \'\' || !check_number?\'md-raised md-accent grey-100-fg\':\'md-raised md-green-500-bg white-fg\'\" \nclass=\"mv-15 mh-0\" ng-click=\"vm.refundInstallmentFinally(installment_id,refund_amount,\'check\',check_number)\" \nng-disabled=\"vm.refundStart || check_number == \'\' || !check_number\" aria-label=\"YES\">Check</md-button><md-button \nng-class=\"vm.refundStart?\'md-raised md-accent grey-100-fg\':\'md-raised md-green-500-bg white-fg\'\" class=\"mv-15 mh-0\" \nng-click=\"vm.refundInstallmentFinally(installment_id,refund_amount,\'giftcard\',\'\')\" ng-disabled=\"vm.refundStart\" \naria-label=\"NO\">Gift Card</md-button></div></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/orders/dialogs/payments/refundEmail.html","<md-dialog class=\"role-dialog\"><md-toolbar class=\"md-accent white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nRefund Email</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog(idx,oldStatus)\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class=\"md-padding checkin-checkout-dialog\"><div\n layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"50\" layout-align=\"center start\"><h1 class=\"balancedue\">\nRefund Confirmed.</h1></div><div layout=\"column\" flex=\"50\" layout-align=\"center end\"><h3 class=\"processPayment\">\nSend guest confirmation email?</h3></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\" class=\"layout-align-space-between-center layout-row\"><div layout=\"column\" \nlayout-align=\"center end\" flex=\"100\" flex-gt-xs=\"100\"><div flex><md-button \nclass=\"mv-15 mh-0 md-red-500-bg white-fg md-raised\" ng-click=\"closeDialog()\" aria-label=\"NO\">No</md-button><md-button \nng-class=\"isProcessing ? \'md-raised md-accent submit-button grey-100-fg\' : \'mv-15 mh-0 white-fg md-green-500-bg md-raised\'\" \nng-click=\"vm.refundEmail(payment_info_email,refund_amount)\" aria-label=\"YES\" ng-disabled=\"isProcessing\">Yes</md-button>\n</div></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/orders/dialogs/payments/refundReason.html","<md-dialog class=\"role-dialog refund-dailog\"><md-toolbar class=\"md-accent white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nRefund Reason</span></div></md-toolbar><md-dialog-content><md-content class=\"md-padding checkin-checkout-dialog\">\n<md-input-container class=\"md-block mb-0 mt-10\"><label translate=\"CREATE_RES.REASON\"></label><input required \ntype=\"text\" ng-model=\"voidReason\"></md-input-container></md-content></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\" class=\"layout-align-space-between-center layout-row\"><div \nlayout=\"column\" layout-align=\"end end\" flex=\"100\"><div flex><md-button \nng-class=\"vm.refundStart || voidReason == \'\' || !voidReason?\'md-raised md-accent grey-100-fg\':\'md-raised md-green-500-bg white-fg\'\" \nclass=\"mv-15 mh-0\" ng-click=\"submitReason(voidReason,type)\" \nng-disabled=\"vm.refundStart || voidReason == \'\' || !voidReason\" aria-label=\"YES\">Submit</md-button></div></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/orders/dialogs/room-move/room-move.html","<md-dialog class=\"contact-dialog room-move-dialog\" \nstyle=\"max-width:1200px;max-height:1000px; padding:0px; width: 100%\" aria-label=\"New Task\"><form name=\"openPlaceGantt\" \nclass=\"md-inline-form\" novalidate><md-dialog-content ms-scroll style=\"max-width:1200px;max-height:1000px; padding:0px\" \nclass=\"main-dilog-1 blue-tabheader\"><div ng-cloak><md-button class=\"md-icon-button crossicon\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button><md-tabs md-dynamic-height md-border-bottom>\n<md-tab label=\"Split Reservation\" ng-click=\"vm.changeTab(\'split\')\" ng-if=\"vm.pageType == \'split\'\"><div \nclass=\"content-select-check-in scroll-radio-block\"><div class=\"form-title mb-10 no-padding\">\nSelect check-in and check-out for new {{(vm.page==\'boat\')?\'slip\':vm.page}}</div><div class=\"checkin-inner-content\"><div\n flex=\"100\" layout=\"row\" layout-wrap><div class=\"row-block-new block-datepicker-main\" flex=\"50\" flex-xs=\"100\" \nlayout=\"column\" layout-align=\"start start\" flex><md-input-container class=\"md-block full-width mb-0\"><label \ntranslate=\"CREATE_RES.CHECKIN\"></label><md-datepicker md-open-on-focus ng-model=\"vm.checkin\" \nmd-min-date=\"vm.minCheckInDate\" md-max-date=\"vm.maxdateforcheckin\" ng-change=\"vm.checkinModified()\" \nclass=\"mdinput-block\"></md-datepicker><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"row-block-new block-datepicker-main\" flex=\"50\" flex-xs=\"100\" layout=\"column\" layout-align=\"start start\" flex>\n<md-input-container class=\"md-block mb-0 full-width\"><label translate=\"CREATE_RES.CHECKOUT\"></label><md-datepicker \nmd-open-on-focus ng-model=\"vm.checkout\" md-min-date=\"vm.minCheckOutDate\" md-max-date=\"vm.maxdateforcheckout\" \nng-change=\"vm.checkoutModified()\" class=\"mdinput-block\"></md-datepicker><div class=\"md-errors-spacer\"></div>\n</md-input-container></div></div><div class=\"\" flex=\"100\" layout=\"row\"><div \nclass=\"Fromto-col padding-left-10 padding-right-10\" flex=\"100\" flex-gt-sm=\"100\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"end start\"><md-button class=\"mh-0 white-fg md-green-500-bg md-raised\" ng-click=\"vm.getAvailableRooms()\" \naria-label=\"Show Rooms\"><md-icon md-font-icon=\"icon-magnify\" class=\"white-fg\"></md-icon>Search</md-button></div></div>\n<div class=\"\" flex=\"100\" layout=\"row\"><div class=\"Fromto-col padding-left-10 padding-right-10\" flex=\"100\" \nflex-gt-sm=\"100\" layout=\"column\" layout-gt-xs=\"row\" layout-align=\"end start\"><div class=\"norecordfound\" \nng-if=\"vm.dateError\"><md-icon md-font-icon=\"icon-information-outline\" class=\"pr-5\"></md-icon>{{vm.dateErrorMsg}}</div>\n</div></div></div><div class=\"form-title mt-20 no-padding\" ng-if=\"vm.show_rooms\">{{\'Available \'+vm.pagetitle}}</div>\n<div class=\"room-listing-block\" ng-if=\"vm.show_rooms\"><div class=\"row-block-new room-availabe\" layout=\"column\" \nlayout-gt-xs=\"row\" layout-align=\"start start\" flex><div ng-if=\"vm.show_rooms\" class=\"full-width-100 md-padding\"><div \nclass=\"norecordfound\" ng-if=\"vm.available_rooms.length == 0\"><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"pr-5\"></md-icon>{{ vm.page == \'boat\'?\'EC.NO_BOATS\':\'EC.NO_ROOMS\' | translate}}</div><div \nng-if=\"vm.available_rooms.length !== 0\" class=\"mb-15\"><div class=\"room-listing room-repeatblk\" \nng-repeat=\"(roomkey,room) in vm.available_rooms\"><div class=\"img-block-room\"><img ng-if=\"!room.image\" \nng-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\" class=\"erroeimg-1\"> <img ng-if=\"room.image\" \nng-src=\"{{vm.baseUrl+\'/assets/uploads/product/\'+room.image}}\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\" class=\"erroeimg-1\"></div><div \nclass=\"room-block-listing\"><div class=\"product_name_blk\" flex=\"100\" layout-wrap layout=\"row\"><span \nclass=\"aprt-name aprt-name-lt mb-5\">{{room.product_name}}</span><div class=\"policy-outer\"><div \nclass=\"Reservation-outer-block\" ng-repeat=\"(policykey,eachpolicy) in vm.available_rooms[$index].policy_name\">\n<md-radio-group ng-model=\"vm.selectedRoom\"><md-radio-button value=\"{{roomkey}}\" \nclass=\"checkblock-ckeckbox margin-top-0 margin-bottom-0 room-repeatblk single\"><span class=\"aprt-nightly nt-policy\">\n{{eachpolicy}}</span></md-radio-button><div class=\"rate-plan-spans-block\"><span class=\"aprt-nightly rate-plan-anchor\">\n<div class=\"rate-plan-txt\" ng-init=\"vm.showRateDesc[roomkey][policykey] = false\" \nng-mouseenter=\"!vm.runClickEvent?vm.showDetailRateBlock(roomkey,policykey):\'\'\" \nng-mouseleave=\"!vm.runClickEvent?vm.closeAllRateDetails(roomkey,policykey):\'\'\" \nng-click=\"vm.runClickEvent?vm.showDetailRateBlock(roomkey,policykey):\'\'\">\nRate Plan: {{room.rateNameDesc[policykey].ratePlanName}}<div class=\"total-amount-blk-section\" \nng-if=\"vm.showRateDesc[roomkey][policykey] && room.rateNameDesc[policykey].ratePlanDesc != \'\'\"><div \nclass=\"total-amt-row\"><b>{{room.rateNameDesc[policykey].ratePlanDesc}}</b></div></div></div></span><span \nclass=\"aprt-nightly\" ng-if=\"vm.page == \'room\'\">Max Occupancy: {{room.max_occupancy}} </span><span class=\"aprt-nightly\" \nng-if=\"room.boat_length > 0 && vm.page != \'room\'\">Vessel Length: {{room.boat_length}}</span> <span \nclass=\"aprt-nightly\" ng-if=\"room.boat_width > 0 && vm.page != \'room\'\">Vessel Width: {{room.boat_width}}</span> <span \nclass=\"aprt-nightly\">Nightly rate: <b class=\"rate-color-add red-A800-fg\">${{room.nightlyRate[policykey]}}</b></span>\n</div></md-radio-group><div class=\"total-price-block top0blk\" ng-init=\"vm.showBlock[roomkey][policykey] = false\" \nng-mouseenter=\"!vm.runClickEvent?vm.showDetailBlock(roomkey,policykey):\'\'\" \nng-mouseleave=\"!vm.runClickEvent?vm.closeAllDetails(roomkey,policykey):\'\'\" \nng-click=\"vm.runClickEvent?vm.showDetailBlock(roomkey,policykey):\'\'\"><small>Total</small> <b>\n${{room.searchSummary[policykey].grandTotal}}</b><div class=\"total-amount-blk-section\" \nng-if=\"vm.showBlock[roomkey][policykey]\"><div class=\"total-amt-row\"><span ng-if=\"vm.page == \'room\'\">Room Amount</span> \n<span ng-if=\"vm.page == \'boat\'\">Slip Amount</span> <span>${{room.searchSummary[policykey].subTotal}}</span></div><div \nclass=\"total-amt-row\" ng-if=\"vm.extraPersonApplicable\"><span>Extra Person</span> <span>\n${{room.searchSummary[policykey].extraPersonAmt}}</span></div><div class=\"total-amt-row\" \nng-if=\"vm.resortFeeApplicable\"><span>Resort fee</span> <span>${{room.searchSummary[policykey].resortFee}}</span></div>\n<div class=\"total-amt-row\" ng-if=\"room.searchSummary[policykey].surcharge != undefined\"><span>Surcharge</span> <span>\n${{room.searchSummary[policykey].surcharge}}</span></div><div class=\"total-amt-row\"><span>Taxes</span> <span>\n${{room.searchSummary[policykey].taxes}}</span></div><div class=\"total-amt-row\"><span>Grand Total</span> <span>\n${{room.searchSummary[policykey].grandTotal}}</span></div></div></div></div></div></div></div><p \nclass=\"room_type_description\" id=\"description_{{room.product_id}}\">{{room.room_type_description}}</p></div></div></div>\n</div></div></div></md-tab><md-tab label=\"{{vm.page==\'boat\'?\'Slip Change\':\'Room Change\'}}\" \nng-click=\"vm.changeTab(\'roomChange\')\" ng-if=\"vm.pageType == \'roomChange\'\"><div \nclass=\"content-select-check-in scroll-radio-block\"><div class=\"checkin-inner-content\"><div flex=\"100\" layout=\"row\" \nlayout-wrap><div class=\"row-block-new block-datepicker-main\" flex=\"50\" flex-xs=\"100\" layout=\"column\" \nlayout-align=\"start start\" flex><md-input-container class=\"md-block full-width mb-0\"><label \ntranslate=\"CREATE_RES.CHECKIN\"></label><md-datepicker md-open-on-focus ng-model=\"vm.checkin\" \nng-change=\"vm.checkinModified()\" class=\"full-width mdinput-block\" changecheckout></md-datepicker><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div class=\"row-block-new block-datepicker-main\" flex=\"50\" \nflex-xs=\"100\" layout=\"column\" layout-align=\"start start\" flex><md-input-container class=\"md-block mb-0 full-width\">\n<label translate=\"CREATE_RES.CHECKOUT\"></label><md-datepicker md-open-on-focus ng-model=\"vm.checkout\" \nmd-min-date=\"vm.isDayReservation ? null : vm.minDateCheckout\" ng-disabled=\"vm.isDayReservation\" \nclass=\"full-width mdinput-block\"></md-datepicker><div class=\"md-errors-spacer\"></div></md-input-container></div></div>\n</div><div class=\"form-title no-padding mt-20\" translate=\"ADD_ROOM.AVAILABLE_ROOMS\" \nng-if=\"vm.show_rooms_for_room_move\"></div><div class=\"room-listing-block\" ng-if=\"vm.show_rooms_for_room_move\"><div \nclass=\"row-block-new room-availabe\" ng-if=\"vm.show_rooms_for_room_move\" layout=\"column\" layout-gt-xs=\"row\" \nlayout-align=\"start start\" flex><div ng-if=\"vm.show_rooms_for_room_move\" class=\"full-width-100\"><div \nclass=\"norecordfound mb-15\" ng-if=\"vm.available_rooms_for_room_move.length == 0\"><md-icon \nmd-font-icon=\"icon-information-outline\"></md-icon>{{\'EC.NO_ROOMS\' | translate}}</div><div \nng-if=\"vm.available_rooms_for_room_move.length !== 0\" class=\"mb-15\"><div class=\"room-listing room-repeatblk\" \nng-repeat=\"(roomkey,room) in vm.available_rooms_for_room_move\"><div class=\"img-block-room\"><img ng-if=\"!room.image\" \nng-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\" class=\"erroeimg-1\"> <img ng-if=\"room.image\" \nng-src=\"{{vm.baseUrl+\'/assets/uploads/product/\'+room.image}}\" \non-error-src=\"{{vm.baseUrl+\'assets/uploads/product/room-service.svg\'}}\" class=\"erroeimg-1\"></div><div \nclass=\"room-block-listing\"><div class=\"product_name_blk\" flex=\"100\" layout-wrap layout=\"row\"><span \nclass=\"aprt-name aprt-name-lt mb-5\">{{room.product_name}}</span><div class=\"policy-outer\"><div \nclass=\"Reservation-outer-block\" \nng-repeat=\"(policykey,eachpolicy) in vm.available_rooms_for_room_move[$index].policy_name\"><md-radio-group \nng-model=\"vm.selectedRoom\"><md-radio-button value=\"{{roomkey}}\" \nclass=\"checkblock-ckeckbox margin-top-0 margin-bottom-0 room-repeatblk single\"><span class=\"aprt-nightly nt-policy\">\n{{eachpolicy}}</span></md-radio-button><div class=\"rate-plan-spans-block\"><span class=\"aprt-nightly rate-plan-anchor\">\n<div class=\"rate-plan-txt\" ng-init=\"vm.showRateDesc[roomkey][policykey] = false\" \nng-mouseenter=\"!vm.runClickEvent?vm.showDetailRateBlock(roomkey,policykey):\'\'\" \nng-mouseleave=\"!vm.runClickEvent?vm.closeAllRateDetails(roomkey,policykey):\'\'\" \nng-click=\"vm.runClickEvent?vm.showDetailRateBlock(roomkey,policykey):\'\'\">\nRate Plan: {{room.rateNameDesc[policykey].ratePlanName}}<div class=\"total-amount-blk-section\" \nng-if=\"vm.showRateDesc[roomkey][policykey] && room.rateNameDesc[policykey].ratePlanDesc != \'\'\"><div \nclass=\"total-amt-row\"><b>{{room.rateNameDesc[policykey].ratePlanDesc}}</b></div></div></div></span><span \nclass=\"aprt-nightly\" ng-if=\"vm.page == \'room\'\">Max Occupancy: {{room.max_occupancy}} </span><span class=\"aprt-nightly\" \nng-if=\"room.boat_length > 0 && vm.page != \'room\'\">Vessel Length: {{room.boat_length}}</span> <span \nclass=\"aprt-nightly\" ng-if=\"room.boat_width > 0 && vm.page != \'room\' \">Vessel Width: {{room.boat_width}}</span> <span \nclass=\"aprt-nightly\">Nightly rate: <b class=\"rate-color-add red-A800-fg\">${{room.nightlyRate[policykey]}}</b></span>\n</div></md-radio-group><div class=\"total-price-block top0blk\" ng-init=\"vm.showBlock[roomkey][policykey] = false\" \nng-mouseenter=\"!vm.runClickEvent?vm.showDetailBlock(roomkey,policykey):\'\'\" \nng-mouseleave=\"!vm.runClickEvent?vm.closeAllDetails(roomkey,policykey):\'\'\" \nng-click=\"vm.runClickEvent?vm.showDetailBlock(roomkey,policykey):\'\'\"><small>Total</small> <b>\n${{room.searchSummary[policykey].grandTotal}}</b><div class=\"total-amount-blk-section\" \nng-if=\"vm.showBlock[roomkey][policykey]\"><div class=\"total-amt-row\"><span ng-if=\"vm.page == \'room\'\">Room Amount</span> \n<span ng-if=\"vm.page == \'boat\'\">Slip Amount</span> <span>${{room.searchSummary[policykey].subTotal}}</span></div><div \nclass=\"total-amt-row\" ng-if=\"vm.extraPersonApplicable\"><span>Extra Person</span> <span>\n${{room.searchSummary[policykey].extraPersonAmt}}</span></div><div class=\"total-amt-row\" \nng-if=\"vm.resortFeeApplicable\"><span>Resort fee</span> <span>${{room.searchSummary[policykey].resortFee}}</span></div>\n<div class=\"total-amt-row\" ng-if=\"room.searchSummary[policykey].surcharge != undefined\"><span>Surcharge</span> <span>\n${{room.searchSummary[policykey].surcharge}}</span></div><div class=\"total-amt-row\"><span>Taxes</span> <span>\n${{room.searchSummary[policykey].taxes}}</span></div><div class=\"total-amt-row\"><span>Grand Total</span> <span>\n${{room.searchSummary[policykey].grandTotal}}</span></div></div></div></div></div></div></div></div></div></div></div>\n</div></div></md-tab></md-tabs></div></md-dialog-content><md-dialog-actions layout=\"row\" flex=\"100\" \nng-if=\"vm.pageType == \'split\'\"><div class=\"row-block-new padding-left-10 pv-10\" ng-if=\"vm.show_rooms\" layout=\"column\" \nflex=\"100\" layout-align=\"end end\"><div><md-checkbox class=\"no-margin\" ng-checked=\"true\" ng-model=\"vm.keepSameRates\">\n<span>Keep same rates</span></md-checkbox><md-button type=\"submit\" ng-click=\"vm.roomMoveFinally()\" \nng-class=\"vm.selectedRoom == \'\'?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"vm.selectedRoom == \'\' || !vm.show_continue\" aria-label=\"ADD\" translate=\"Continue\">Continue</md-button>\n</div></div></md-dialog-actions><md-dialog-actions layout=\"row\" flex=\"100\" ng-if=\"vm.pageType == \'roomChange\'\"><div \nng-if=\"!vm.show_rooms_for_room_move || (vm.show_rooms_for_room_move && vm.available_rooms_for_room_move.length == 0)\" \nflex=\"100\" layout=\"column\" layout-align=\"end end\"><div class=\"Fromto-col padding-left-10 padding-right-10\"><md-checkbox\n class=\"no-margin\" ng-checked=\"true\" ng-model=\"vm.keepSameRates\"><span>Keep same rates</span></md-checkbox><md-button \nng-class=\"vm.isloading?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-click=\"vm.changeDatesForRes()\" ng-disabled=\"vm.isloading\" aria-label=\"Show Rooms\">Search</md-button></div></div><div\n ng-if=\"vm.show_rooms_for_room_move && vm.available_rooms_for_room_move.length > 0\" flex=\"100\" layout=\"column\" \nlayout-align=\"end end\"><div class=\"Fromto-col padding-left-10 padding-right-10\"><md-checkbox class=\"no-margin\" \nng-model=\"vm.keepSameRates\"><span>Keep same rates</span></md-checkbox><md-button type=\"submit\" \nng-click=\"vm.changeRoomForRes()\" \nng-class=\"vm.selectedRoom == \'\'?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-green-500-bg submit-button white-fg\'\" \nng-disabled=\"vm.selectedRoom == \'\'\" aria-label=\"ADD\" translate=\"Save\">SAVE</md-button></div></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/orders/dialogs/status/cancel.html","<md-dialog class=\"cancel-dailog role-dialog\"><md-toolbar class=\"md-accent white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{titleContent}} Reservation</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog(idx,oldStatus)\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content \nclass=\"md-padding\"><p ng-if=\"days_free_cancellation != 0 && show_refund_type == 0\">\nThis booking is less than {{days_free_cancellation}} days from the arrival date and does not qualify for a refund.</p>\n<p ng-if=\"policy_name == \'Non-refundable\'\">This booking is booked for Non refundable rate plan.</p><md-radio-group \nclass=\"no-margin\" ng-model=\"refund_type\"><md-radio-button value=\"1\">Refund using original payment method\n</md-radio-button><div style=\"display: inline-block\" class=\"refundblock\" \nng-if=\"refund_type == 1 && ((if_cancelled_period == 0 && cancellation_charges > 0) || ((if_cancelled_period == 1 || !vm.keepCancelCharges) && payments.length>0))\">\n<div ng-if=\"if_cancelled_period == 0 && cancellation_charges > 0\" class=\"refundcancelesection\"><md-checkbox \nclass=\"no-margin check1design\" ng-model=\"vm.keepCancelCharges\"><span>\nKeep ${{cancellation_charges}} cancellation fees. {{}}</span></md-checkbox><span \nclass=\"aprt-nightly check1desig2 width-float\" ng-if=\"vm.keepCancelCharges && payments.length > 1\" \nng-repeat=\"payment in payments\"><md-checkbox class=\"no-margin\" ng-checked=\"payment.keep_charges\" \nng-model=\"takeChargesInstallment[payment.installment_id]\" ng-click=\"changeKeepCharges($index,payment.keep_charges)\">\n<span>{{payment.payment_method}}-{{payment.installment_amount | currency : $ : 2}}</span> <span \nng-if=\"payment.preference == 2\" class=\"installment-line\">\nThis installment is not settled yet. So amount will get refunded within next 24-hours.</span></md-checkbox></span><span\n class=\"aprt-nightly check1desig2 width-float\" ng-if=\"vm.keepCancelCharges && payments.length == 1\" \nng-repeat=\"payment in payments\" ng-init=\"takeChargesInstallment[payment.installment_id] = true\">\n{{payment.payment_method}}-{{payment.installment_amount | currency : $ : 2}} <span ng-if=\"payment.preference == 2\" \nclass=\"installment-line\">This installment is not settled yet. So amount will get refunded within next 24-hours.</span>\n</span></div><div class=\"notrefundblock\" \nng-if=\"(if_cancelled_period == 1 || !vm.keepCancelCharges) && payments.length>0\"><span \nclass=\"aprt-nightly width-float\" ng-repeat=\"payment in payments\">\n{{payment.payment_method}}-{{payment.installment_amount | currency : $ : 2}}</span></div></div><md-radio-button \nng-if=\"payment_exists\" value=\"2\">Issue Gift Certificate</md-radio-button><div class=\"refundblock\"><div \nng-if=\"refund_type == 2\" style=\"display: inline-block\" class=\"refundcancelesection refund2block\"><span \nng-if=\"if_cancelled_period == 0 && cancellation_charges > 0\" class=\"check1desig2 aprt-nightly\"><md-checkbox \nclass=\"no-margin\" ng-model=\"vm.keepCancelCharges\"><span>Keep ${{cancellation_charges}} cancellation fees.</span>\n</md-checkbox></span><div class=\"plaintxt\"><span class=\"aprt-nightly width-float\">\nBalance - {{paidAmount - insurance_amount | currency : $ : 2}}</span> <span class=\"aprt-nightly width-float\">\nName - {{customer_name}}</span> <span class=\"aprt-nightly width-float\">Email - {{customer_email}}</span></div></div>\n</div><md-radio-button value=\"0\">No Refund</md-radio-button></md-radio-group><div><md-input-container \nclass=\"md-block tax-inputs mb-0\"><label translate=\"EC.CANCEL_COMMENT\"></label><textarea \nng-model=\"cancel_order_comment\" ng-readonly=\"vm.autoFillOff\" autocomplete=\"off\"></textarea></md-input-container></div>\n</md-content></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end center\" flex=\"100\"><md-checkbox class=\"no-margin\" ng-model=\"send_email_indicator\"><span>Send Email\n</span></md-checkbox><md-button \nng-class=\"!showSubmit ? \'md-raised md-accent submit-button grey-100-fg\' : \'mv-15 mh-0 white-fg md-green-500-bg md-raised\'\" \nng-disabled=\"!showSubmit\" ng-click=\"cancelFinally(send_email_indicator)\" aria-label=\"Submit\">Submit</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/orders/dialogs/status/checkin-out.html","<md-dialog class=\"role-dialog\"><md-toolbar class=\"md-accent white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nChange status: {{showStatus}}</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog(idx,oldStatus)\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-content \nclass=\"md-padding checkin-checkout-dialog\"><div layout=\"row\" flex=\"100\"><div layout=\"column\" flex=\"50\" \nlayout-align=\"center start\"><h1 class=\"balancedue\">Balance Due: <span>{{remainingBalance | currency : $ : 2}}</span>\n</h1></div><div layout=\"column\" flex=\"50\" layout-align=\"center end\"><h3 class=\"processPayment\">Process Payment ?</h3>\n</div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\" \nclass=\"layout-align-space-between-center layout-row\"><div layout=\"column\" layout-align=\"center end\" flex=\"100\" \nflex-gt-xs=\"100\"><div flex><md-checkbox class=\"no-margin\" ng-model=\"send_email_indicator\"><span>Send Email</span>\n</md-checkbox><md-button class=\"mv-15 mh-0 md-red-500-bg white-fg md-raised\" \nng-click=\"vm.changeStatusWithoutPayment()\" aria-label=\"NO\">No</md-button><md-button \nclass=\"mv-15 mh-0 md-green-500-bg white-fg md-raised\" \nng-click=\"vm.changeStatusAfterPayment(idx,confirmation_number,oldStatus,newStatus,send_email_indicator)\" \naria-label=\"YES\">Yes</md-button></div></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/orders/dialogs/status/pos-confirm.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"ploicyForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{conTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"closePosDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"fullcontent\"><div class=\"outer_wrapper\"><md-content class=\"md-padding\"><p class=\"form-title-small mt-0 mb-0\" \nbind-html-compile=\"conHtmlContent\"></p></md-content></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end end\" flex=\"100\"><md-checkbox class=\"no-margin\" \nng-model=\"conSendEmailIndicator\"><span>Send Email</span></md-checkbox><md-button type=\"submit\" \nng-if=\"CancelbtnTxt != \'none\'\" ng-click=\"closePosDialog()\" \nng-class=\"\'md-raised md-accent submit-button grey-100-fg md-red-500-bg\'\">{{CancelbtnTxt}}</md-button><md-button \ntype=\"submit\" ng-if=\"OkbtnTxt != \'none\'\" ng-disabled=\"onGoingRequest\" ng-click=\"!onGoingRequest?confirmPosAction():\'\'\" \nng-class=\"\'md-raised md-accent submit-button grey-100-fg md-green-500-bg\'\">{{OkbtnTxt}}</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/orders/dialogs/transfer/refundEmail.html","<md-dialog class=\"role-dialog\"><md-toolbar class=\"md-accent white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nRefund Email</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog(idx,oldStatus)\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><md-content class=\"md-padding checkin-checkout-dialog\"><div\n layout=\"row\" flex=\"\"><div layout=\"column\" flex=\"50\" layout-align=\"center start\"><h1 class=\"balancedue\">\nRefund Confirmed.</h1></div><div layout=\"column\" flex=\"50\" layout-align=\"center end\"><h3 class=\"processPayment\">\nSend guest confirmation email?</h3></div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\" class=\"layout-align-space-between-center layout-row\"><div layout=\"column\" \nlayout-align=\"center end\" flex=\"100\" flex-gt-xs=\"100\"><div flex><md-button \nclass=\"mv-15 mh-0 md-red-500-bg white-fg md-raised\" ng-click=\"closeDialog()\" aria-label=\"NO\">No</md-button><md-button \nng-class=\"isProcessing ? \'md-raised md-accent submit-button grey-100-fg\' : \'mv-15 mh-0 white-fg md-green-500-bg md-raised\'\" \nng-click=\"vm.refundEmail(payment_info_email,refund_amount)\" aria-label=\"YES\" ng-disabled=\"isProcessing\">Yes</md-button>\n</div></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/orders/dialogs/transfer/refundReason.html","<md-dialog class=\"role-dialog refund-dailog\"><md-toolbar class=\"md-accent white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nRefund Reason</span></div></md-toolbar><md-dialog-content><md-content class=\"md-padding checkin-checkout-dialog\">\n<md-input-container class=\"md-block mb-0 mt-10\"><label translate=\"CREATE_RES.REASON\"></label><input required \ntype=\"text\" ng-model=\"voidReason\"></md-input-container></md-content></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\" class=\"layout-align-space-between-center layout-row\"><div \nlayout=\"column\" layout-align=\"end end\" flex=\"100\"><div flex><md-button \nng-class=\"vm.refundStart || voidReason == \'\' || !voidReason?\'md-raised md-accent grey-100-fg\':\'md-raised md-green-500-bg white-fg\'\" \nclass=\"mv-15 mh-0\" ng-click=\"submitReason(voidReason,type)\" \nng-disabled=\"vm.refundStart || voidReason == \'\' || !voidReason\" aria-label=\"YES\">Submit</md-button></div></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/orders/dialogs/transfer/transfer.html","<md-dialog class=\"role-dialog refund-dailog tranferamountblock\"><md-toolbar class=\"md-accent white-fg\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Transfer Amount</span><md-button class=\"md-icon-button\" ng-click=\"closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"padding: 15px 24px 10px 24px\"><md-content class=\"checkin-checkout-dialog tranferamountblock-content\"><form \nname=\"transfer\" class=\"md-inline-form no-padding\" novalidate><p class=\"headingamount-transfer\" \nng-if=\"automaticTransfer\">Do you want to adjust the amount automatically by the system ?</p><div \nclass=\"roomDataTransferTo\" ng-if=\"hasInstallment\" layout=\"row\" layout-align=\" space-between stretch \"><div \nclass=\"tranferhalf-block\" layout=\"column\" layout-align=\" center center \"><div class=\"tranferamountinnerblk\"><div \nclass=\"tranferamountinnerblk-repeat mb-10\"><div class=\"heading-of-tranfer\">{{roomDataTransferFrom.product_name }}</div>\n<div class=\"pending-amount\"><span class=\"owes\">\nOwes: {{ roomDataTransferFrom[\'total_remaining_amount\'] | currency : $ : 2}}</span> <span>\nPaid: {{ roomDataTransferFrom[\'total_paid_amount\'] | currency : $ : 2 }}</span></div><span class=\"dateblktransfer\">\nCheck-In: {{ roomDataTransferFrom.room_stay_from}}</span><br><span class=\"dateblktransfer\">\nCheck-Out: {{ roomDataTransferFrom.room_stay_to }}</span><md-input-container \nclass=\"md-block mb-0 mt-20 amount-tranfer-input\"><label>Excess Paid Amount</label><input type=\"text\" \nng-model=\"roomDataTransferFrom[\'total_remaining_amount\']\" ng-disabled=\"true\" autocomplete=\"off\" \nreadonly=\"vm.autoFillOff\"></md-input-container></div></div></div><div class=\"tranferhalf-block\" layout=\"column\"><div \nclass=\"tranferamountinnerblk\"><div class=\"tranferamountinnerblk-repeat mb-10\" ng-repeat=\"row in roomDataTransferTo\">\n<div class=\"img-outer-class\"><img src=\"assets/images/bills-of-dollars.svg\" class=\"money_transfer_icon\"></div><div \nclass=\"heading-of-tranfer\">{{row.product_name }}</div><div class=\"pending-amount\"><span class=\"owes\">\nOwes: {{ row[\'total_remaining_amount\'] | currency : $ : 2}}</span> <span>\nPaid: {{ row[\'total_paid_amount\'] | currency : $ : 2 }}</span></div><span class=\"dateblktransfer\">\nCheck-In: {{ row.room_stay_from}}</span><br><span class=\"dateblktransfer\">Check-Out: {{ row.room_stay_to}}</span>\n<md-input-container class=\"md-block mb-0 mt-20 amount-tranfer-input\"><label>Amount to transfer</label><input \ntype=\"number\" ng-model=\"amountToTransfer[row.confirmation_number]\" ng-change=\"updateAmount(row.confirmation_number)\" \nng-max=\"row[\'total_remaining_amount\']\"></md-input-container></div></div></div></div><div class=\"roomDataTransferTo\" \nng-if=\"!hasInstallment\" layout=\"row\" layout-align=\" space-between stretch \"><div class=\"tranferhalf-block\" \nlayout=\"column\" layout-align=\" center center \"><div class=\"tranferamountinnerblk\"><div \nclass=\"tranferamountinnerblk-repeat mb-10\" ng-repeat=\"transfer_from in roomDataTransferTo\" \nng-if=\"transfer_from.confirmation_number == roomDataTransferFrom.confirmation_number\"><div class=\"heading-of-tranfer\">\n{{transfer_from.product_name }}</div><div class=\"pending-amount\"><span class=\"owes\">\nOwes: {{ transfer_from[\'total_remaining_amount\'] | currency : $ : 2}}</span> <span>\nPaid: {{ transfer_from[\'total_paid_amount\'] | currency : $ : 2 }}</span> <span class=\"amount-transfer\">\nAmount Transferable: {{ (roomDataTransferFrom[\'total_paid_amount\'] - transfer_from[\'total_paid_amount\']) | currency : $ : 2 }}\n</span></div><span class=\"dateblktransfer\">Check-In: {{ transfer_from.room_stay_from }}</span><br><span \nclass=\"dateblktransfer\">Check-Out: {{ transfer_from.room_stay_to }}</span></div></div></div><div \nclass=\"tranferhalf-block\" layout=\"column\"><div class=\"tranferamountinnerblk\"><div \nclass=\"tranferamountinnerblk-repeat mb-10\" ng-repeat=\"transfer_to in roomDataTransferTo\" \nng-if=\"transfer_to.confirmation_number != roomDataTransferFrom.confirmation_number\"><div class=\"img-outer-class\"><img \nsrc=\"assets/images/bills-of-dollars.svg\" class=\"money_transfer_icon\"></div><div class=\"heading-of-tranfer\">\n{{transfer_to.product_name }}</div><div class=\"pending-amount\"><span class=\"owes\">\nOwes: {{ transfer_to[\'total_remaining_amount\'] | currency : $ : 2}}</span> <span>\nPaid: {{ transfer_to[\'total_paid_amount\'] | currency : $ : 2 }}</span> <span class=\"amount-transfer\">\nAmount Transferred: {{ transfer_to[\'total_paid_amount\'] | currency : $ : 2 }}</span></div><span \nclass=\"dateblktransfer\">Check-In: {{ transfer_to.room_stay_from }}</span><br><span class=\"dateblktransfer\">\nCheck-Out: {{ transfer_to.room_stay_to}}</span></div></div></div></div></form></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\" \nclass=\"layout-align-space-between-center layout-row\" ng-if=\"hasInstallment\"><div layout=\"column\" \nlayout-align=\"center start\" flex=\"50\"><p class=\"pb-15 m-0 Transaction-amount\">Total Transaction Amount: <span>\n{{ vm.staticTotalTransferableAmount | currency : $ : 2}}</span></p></div><div layout=\"column\" layout-align=\"end end\" \nflex=\"50\"><div flex><md-button \nng-class=\"(transfer.$invalid || transfer.$pristine || roomDataTransferFrom[\'total_remaining_amount\'] > 0 ) || !validEntries ?\'md-raised md-accent grey-100-fg\':\'md-raised md-green-500-bg white-fg\'\" \nclass=\"mv-15 mh-0\" ng-click=\"vm.initiateTransfer()\" aria-label=\"NO\" \nng-disabled=\"transfer.$invalid || transfer.$pristine || roomDataTransferFrom[\'total_remaining_amount\'] > 0 || !validEntries\">\nTransfer Amount</md-button></div></div></md-dialog-actions><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\" class=\"layout-align-space-between-center layout-row\" ng-if=\"!hasInstallment\"><div \nlayout=\"column\" layout-align=\"center start\" flex=\"50\"><p class=\"pb-15 m-0 Transaction-amount\"></p></div><div \nlayout=\"column\" layout-align=\"end end\" flex=\"50\"><div flex><md-button type=\"submit\" ng-if=\"vm.CancelbtnTxt != \'none\'\" \nng-click=\"vm.closeDialog(\'no\')\" ng-class=\"\'md-raised md-accent submit-button grey-100-fg md-red-500-bg\'\">No</md-button>\n<md-button type=\"submit\" ng-if=\"vm.OkbtnTxt != \'none\'\" ng-click=\"vm.closeDialog(\'ok\')\" \nng-class=\"\'md-raised md-accent submit-button grey-100-fg md-green-500-bg\'\">Yes</md-button></div></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/e-commerce/views/orders/order/oldorder/order.html","<div class=\"page-layout simple tabbed view-order new-page\" layout=\"column\" id=\"create-res\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex flex-gt-sm=\"70\"><md-button class=\"goto-products-button md-icon-button\" \nng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2 smsizeres\">\n{{vm.itinerary_number +\" | \"+vm.reservation_customer.first_name+\" \"+vm.reservation_customer.last_name + vm.headerPart}}\n</div><div class=\"subtitle secondary-text\" ng-if=\"vm.flag == \'edit\'\"><span translate=\"CREATE_RES.SUB_HEADER\"></span>\n</div></div></div></div><div layout=\"row\" flex layout-align=\"center end\"><div layout=\"column\" flex=\"100\" \nlayout-align=\"center end\"><div class=\"md-iconheader\"><md-icon md-font-icon=\"icon-email\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" ng-click=\"vm.sendinvoice()\" \nng-if=\"!vm.allRoomCancelled\"><md-tooltip>{{\'CREATE_RES.SEND_INVOICE\' | translate}}</md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-email\" class=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" \nng-click=\"vm.sendinvoice(\'canceled_order\')\" \nng-if=\"vm.allRoomCancelled && vm.tabs_data.length == 1 && vm.tabs_data[0].tab_name != \'Pos\'\"><md-tooltip>\n{{\'CREATE_RES.SEND_INVOICE\' | translate}}</md-tooltip></md-icon><md-icon md-font-icon=\"icon-printer\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" ng-click=\"vm.printinvoice(vm.reservation_id)\" \nng-if=\"!vm.allRoomCancelled\"><md-tooltip>{{\'CREATE_RES.PRINT\' | translate}}</md-tooltip></md-icon><md-icon \nmd-font-icon=\"icon-calendar-plus\" class=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" \nng-click=\"vm.addroomincart()\" ng-if=\"vm.roomCount > 0\"><md-tooltip>{{\'CREATE_RES.\'+vm.title | translate}}</md-tooltip>\n</md-icon><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/room-service.svg\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" ng-click=\"vm.gotoCheckoutFromEditOrder()\" \nng-if=\"vm.roomCount == 0\"><md-tooltip>{{\'CREATE_RES.ADD_SERVICE\' | translate}}</md-tooltip></md-icon></div></div></div>\n</div><div class=\"content content-scroll relative-block tab-container-section\"><md-progress-linear \nmd-mode=\"indeterminate\" ng-show=\"vm.isloading\"></md-progress-linear><div class=\"md-whiteframe-1dp height\"><div \nclass=\"role-list-outer height-main\"><div flex=\"100\" layout=\"row\"><div ng-show=\"vm.showSliderControlls\" \nclass=\"arr-leftblk arrcomn onlycursorPointer\" ng-click=\"vm.slideLeft();\" layout=\"column\" flex layout-align=\"center\">\n<md-icon md-font-icon=\"icon-chevron-left\" class=\"white-fg\"></md-icon></div><div class=\"labels-blockclick-outer\" \nlayout=\"column\" flex><div layout=\"row\" flex><div class=\"labels-blockclick ph-5 onlycursorPointer\" \nng-class=\"vm.order.confirmation_number == singleorder.confirmation_number ? \'active\':\'\'\" \nng-repeat=\"(orderIndex,singleorder) in vm.tabs_data\" \nng-click=\"vm.mainTabChanged($event,orderIndex);vm.fetchOrder(singleorder.confirmation_number)\" layout=\"column\" flex \nlayout-align=\"center center\"><label ng-if=\"singleorder.product_room_number != null\" \nclass=\"lbltablatest onlycursorPointer\"><b>{{singleorder.product_room_number}}</b><br>{{singleorder.tab_date}}</label>\n<label ng-if=\"singleorder.product_room_number == null\" class=\"lbltablatest onlycursorPointer\"><b>\n{{singleorder.tab_name}}</b><br>{{singleorder.tab_date}}</label></div></div></div><div \nng-show=\"vm.showSliderControlls\" class=\"arr-rightblk arrcomn onlycursorPointer\" layout=\"column\" \nng-click=\"vm.slideRight();\" layout-align=\"center\" flex><md-icon md-font-icon=\"icon-chevron-right\" class=\"white-fg\">\n</md-icon></div></div><div class=\"heightless45\"><div class=\"md-padding\" style=\"height:100%\" class=\"md-tabs-inner\">\n<md-tabs class=\"inner-tabs\" id=\"current-tab-{{vm.selectedIndex}}\" md-selected=\"vm.innerSlectedIndex\"><md-tab \nlabel=\"Booking Details\"><div class=\"genral-block-top-outer\"><div layout=\"row\" layout-wrap flex=\"100\" \nng-class=\"vm.order.source_of_creation ? \'mt-10\' : \'mt-20\'\"><div layout=\"column\" flex=\"100\" flex-gt-xs=\"100\" \nclass=\"ph-15\"><div layout-align=\"center end\" layout=\"column\" flex=\"100\"><div><div class=\"channel_info ml-10\" \nng-if=\"vm.order.siteminder_id!=\'\'\"><span><img \nsrc=\"{{vm.baseUrl}}assets/uploads/channels/{{vm.order.source_of_creation}}.png\" class=\"block_nav_img\" alt=\"\">\n<md-tooltip>{{vm.order.source_of_creation}}</md-tooltip></span><div class=\"channal-content-l1\"><span \nng-if=\"vm.order.source_of_creation == \'Expedia\' && vm.order.collect_which == \'channel_collect\'\">Expedia Collect</span> \n<span class=\"red-A800-fg\">{{vm.order.siteminder_id}}</span></div></div><div class=\"channel_info ml-10\" \nng-if=\"vm.order.room_moved_from != null\">Room moved from {{vm.order.room_moved_from}}</div><div \nclass=\"channel_info ml-10\" \nng-if=\"(vm.order.room_moved_from != null && vm.order.room_moved_from != \'\') && (vm.order.room_moved_to != null && vm.order.room_moved_to != \'\')\">\n-</div><div class=\"channel_info ml-10\" ng-if=\"vm.order.room_moved_to != null && vm.order.room_moved_to != \'\'\">\nRoom moved to {{vm.order.room_moved_to}}</div></div></div></div><div layout=\"column\" flex=\"100\"><div layout=\"row\" \nflex=\"100\" layout-align=\"space-between stretch\" class=\"ph-15\"><div layout=\"column\" class=\"halfblockinfo\" \nng-if=\"vm.pageType == \'rent\'\" style=\"width: 100%\"><div class=\"section-right-genral role-list-out featured-rol-block\" \nstyle=\"padding:0px\"><div class=\"roomName ph-15 pb-10\" layout=\"row\" flex><div class=\"room-col\" layout=\"column\" \nflex=\"100\"><div layout=\"row\" flex layout-wrap><div layout=\"column\" flex=\"100\" layout-align=\"center start\"><div \nclass=\"row-containerstaus\" flex=\"100\" layout=\"row\"><div flex=\"60\" layout=\"column\"><strong>\n{{ \'CREATE_RES.BILL_INFO\' | translate }}</strong></div><div flex=\"40\" layout=\"column\" layout-align=\"center end\"><div>\n<md-icon md-font-icon=\"icon-email\" class=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" \nng-click=\"vm.sendorderinvoice(vm.order.confirmation_number)\"><md-tooltip>{{\'CREATE_RES.SEND_INVOICE\' | translate}}\n</md-tooltip></md-icon><md-icon md-font-icon=\"icon-parking\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" \nng-click=\"vm.addParking(event,vm.order.room_stay_from,vm.order.room_stay_to,vm.order.confirmation_number)\"><md-tooltip>\n{{\'CREATE_RES.ADD_PARKING\' | translate}}</md-tooltip></md-icon><md-icon ng-if=\"vm.room_stay_status != \'Canceled\'\" \nmd-svg-src=\"assets/angular-material-assets/img/icons/room-service.svg\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" ng-click=\"vm.gotoCheckoutFromEditOrder()\"><md-tooltip>\n{{\'CREATE_RES.ADD_SERVICE\' | translate}}</md-tooltip></md-icon><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/boarding-pass.svg\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" ng-click=\"vm.printRegistrationCard()\" \nng-if=\"vm.print_registration && vm.room_stay_status != \'Canceled\'\"><md-tooltip>Print Registration Card</md-tooltip>\n</md-icon></div></div></div></div></div></div></div><div class=\"white-bg padding-15\"><div><div class=\"detailmain\" \nflex=\"100\" layout=\"row\" layout-wrap><div class=\"title\" layout=\"column\" flex=\"33\" flex-xs=\"100\" flex-sm=\"50\"><div \nclass=\"deatilinnerblk\"><span><b>{{vm.reservation_customer.first_name}} </b></span>{{vm.reservation_customer.last_name}}\n</div></div><div class=\"address\" layout=\"column\" flex=\"33\" flex-xs=\"100\" flex-sm=\"50\"><div class=\"deatilinnerblk\">\n<span><b>Address</b></span>: {{vm.reservation_customer.address}}</div></div><div class=\"city\" layout=\"column\" \nflex=\"33\" flex-xs=\"100\" flex-sm=\"50\"><div class=\"deatilinnerblk\"><span><b>City</b></span>\n: {{vm.reservation_customer.city}}</div></div><div class=\"state\" layout=\"column\" flex=\"33\" flex-xs=\"100\" flex-sm=\"50\">\n<div class=\"deatilinnerblk\"><span><b>State</b></span>: {{vm.reservation_customer.state}}</div></div><div \nclass=\"zip_code\" layout=\"column\" flex=\"33\" flex-xs=\"100\" flex-sm=\"50\"><div class=\"deatilinnerblk\"><span><b>Zip code</b>\n</span>: {{vm.reservation_customer.zip_code}}</div></div><div class=\"country\" layout=\"column\" flex=\"33\" flex-xs=\"100\" \nflex-sm=\"50\"><div class=\"deatilinnerblk\"><span><b>Country</b></span>: {{vm.reservation_customer.country}}</div></div>\n<div class=\"phone\" layout=\"column\" flex=\"33\" flex-xs=\"100\" flex-sm=\"50\"><div class=\"deatilinnerblk\"><span><b>Phone</b>\n</span>: <a href=\"tel:{{vm.reservation_customer.phone_number}}\">{{vm.reservation_customer.phone_number}}</a></div>\n</div><div class=\"phone\" layout=\"column\" flex=\"33\" flex-xs=\"100\" flex-sm=\"50\"><div class=\"deatilinnerblk\"><span><b>\nSecondary phone</b></span>: <a href=\"tel:{{vm.reservation_customer.secondary_phone_number}}\">\n{{vm.reservation_customer.secondary_phone_number}}</a></div></div><div class=\"email\" layout=\"column\" flex=\"33\" \nflex-xs=\"100\" flex-sm=\"50\"><div class=\"deatilinnerblk\"><span><b>Email</b></span>: <a \nhref=\"mailto:{{vm.reservation_customer.customer_email}}\">{{vm.reservation_customer.customer_email}}</a></div></div>\n</div></div></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"myCustomer\"><md-dialog \nclass=\"tax-dialog tax-dialog-new1 act-dialog addcusform\"><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"row\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Billing Information</span><md-button class=\"md-icon-button\" \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"max-height:1000px\" class=\"dilog-lable\"><md-content class=\"md-padding no-margin\">\n<div class=\"display-inline-block role-list-out white-bg top-sp-main no-margin\"><div layout=\"row\" flex=\"100\" \nlayout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center \"><md-input-container class=\"md-block no-margin\"><input \nng-model=\"vm.reservation_customer.customer_id\" name=\"customer_id\" type=\"hidden\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"CREATE_RES.CUST_FN\"></label><input ng-model=\"vm.reservation_customer.first_name\" \nng-change=\"vm.updateCustomer(\'first_name\', \'\', \'customer\')\" name=\"reservation_customer_fn\" type=\"text\" \nng-model-options=\"{debounce: 400}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block\"><label translate=\"CREATE_RES.CUST_LN\"></label><input \nng-model=\"vm.reservation_customer.last_name\" name=\"reservation_customer_ln\" \nng-change=\"vm.updateCustomer(\'last_name\', \'\', \'customer\')\" type=\"text\" ng-model-options=\"{debounce: 400}\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center \"><md-input-container class=\"md-block\"><label translate=\"CREATE_RES.CUST_EMAIL\"></label><input \nng-model=\"vm.reservation_customer.customer_email\" name=\"reservation_customer_email\" type=\"text\" \nng-blur=\"vm.saveEmailCustomer(vm.reservation_customer.customer_id,vm.reservation_customer.customer_email,\'customer\')\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block\"><label translate=\"CREATE_RES.CUST_CONT_NO\"></label><input \nng-model=\"vm.reservation_customer.phone_number\" ng-change=\"vm.updateCustomer(\'phone_number\', \'\', \'customer\')\" \nname=\"reservation_phone_number\" type=\"text\" ng-model-options=\"{debounce: 400}\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\">\n<div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" layout-align=\"center \"><md-switch \nng-model=\"vm.reservation_customer.send_email_indicator\" aria-label=\"Switch 1\" \nng-change=\"vm.updateEmailSatus(vm.reservation_customer.customer_id,vm.reservation_customer.send_email_indicator,\'customer\')\" \nclass=\"mt-0 mb-30\">{{ vm.reservation_customer.send_email_indicator?\'Send email\':\'Do not send email\'}}</md-switch></div>\n</div><div layout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block\"><label \ntranslate=\"CREATE_RES.CUST_SEC_CONT_NO\"></label><input ng-model=\"vm.reservation_customer.secondary_phone_number\" \nng-change=\"vm.updateCustomer(\'secondary_phone_number\', \'\', \'customer\')\" name=\"reservation_secondary_phone_number\" \ntype=\"text\" ng-model-options=\"{debounce: 400}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container>\n</div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-gt-xs=\"50\" flex=\"100\" layout-align=\"center \">\n<md-input-container class=\"md-block margin-bottom-0\"><label translate=\"CREATE_RES.CUST_ADD\"></label><input \nng-model=\"vm.reservation_customer.address\" ng-change=\"vm.updateCustomer(\'address\', \'\', \'customer\')\" \nname=\"reservation_address\" type=\"text\" ng-model-options=\"{debounce: 400}\" id=\"autocomplete\" autocomplete=\"off\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center \"><md-input-container class=\"md-block margin-bottom-0\"><label translate=\"CREATE_RES.CUST_CITY\">\n</label><input ng-model=\"vm.reservation_customer.city\" name=\"reservation_customer_city\" type=\"text\" \nng-change=\"vm.updateCustomer(\'city\', \'\', \'customer\')\" ng-model-options=\"{debounce: 400}\" autocomplete=\"off\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block margin-bottom-0\"><md-autocomplete ng-disabled=\"vm.isStateDisabled\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedState\" md-search-text-change=\"vm.searchState(vm.searchTxtState)\" \nmd-search-text=\"vm.searchTxtState\" md-selected-item-change=\"vm.selectedItemChangeState(item)\" \nmd-items=\"item in vm.queryStateSearch(vm.searchTxtState)\" md-item-text=\"item.name\" md-min-length=\"0\" \nmd-floating-label=\"State\"><md-item-template><span md-highlight-text=\"vm.searchTxtState\" md-highlight-flags=\"^i\">\n{{item.name}}</span></md-item-template><md-not-found>\n{{ vm.searchTxtCountry.length > 0? \'No states matching \'+vm.searchTxtState+\' were found.\' : \'Please select country first\'}}\n</md-not-found></md-autocomplete></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center \"><md-input-container class=\"md-block margin-bottom-0\"><label \ntranslate=\"CREATE_RES.CUST_ZIP_CODE\"></label><input ng-model=\"vm.reservation_customer.zip_code\" \nng-change=\"vm.updateCustomer(\'zip_code\', \'\', \'customer\')\" name=\"reservation_zip_code\" type=\"text\" id=\"autocompletezip\" \nautocomplete=\"off\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block margin-bottom-0\"><md-autocomplete ng-disabled=\"vm.isCountryDisabled\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedCountry\" \nmd-search-text-change=\"vm.searchCountry(vm.searchTxtCountry)\" md-search-text=\"vm.searchTxtCountry\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-items=\"item in vm.queryCountrySearch(vm.searchTxtCountry)\" \nmd-item-text=\"item.display\" md-min-length=\"0\" md-floating-label=\"Country\" md-require-match class=\"full-width\">\n<md-item-template><span md-highlight-text=\"vm.searchTxtCountry\" md-highlight-flags=\"^i\">{{item.display}}</span>\n</md-item-template><md-not-found>No country matching \"{{vm.searchTxtCountry}}\" were found.</md-not-found>\n</md-autocomplete></md-input-container></div></div></div></md-content></md-dialog-content></md-dialog></div></div>\n</div></div><div layout=\"column\" class=\"halfblockinfo\" ng-if=\"vm.pageType != \'rent\'\"><div \nclass=\"section-right-genral role-list-out featured-rol-block\" style=\"padding:0px\"><div class=\"roomName ph-15 pb-10\" \nlayout=\"row\" flex><div class=\"room-col\" layout=\"column\" flex=\"100\"><div layout=\"row\" flex layout-wrap><div \nlayout=\"column\" flex=\"100\" layout-align=\"center start\"><div class=\"row-containerstaus\"><strong>\n{{ \'CREATE_RES.BILL_INFO\' | translate }} </strong><i \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"icon-account-multiple-plus s30 onlycursorPointer onlyFloatRight\" ng-click=\"vm.triggerdiv($event, \'Customer\')\">\n<md-tooltip>{{ \'CONTACTS.EDIT_CONTACT\' | translate }}</md-tooltip></i></div></div></div></div></div><div \nclass=\"white-bg padding-15\"><div><div class=\"detailmain\"><div class=\"title\">\n{{vm.reservation_customer.first_name}} {{vm.reservation_customer.last_name}}</div><div class=\"address\"><span>Address\n</span>: {{vm.reservation_customer.address}}</div><div class=\"city\"><span>City</span>: {{vm.reservation_customer.city}}\n</div><div class=\"state\"><span>State</span>: {{vm.reservation_customer.state}}</div><div class=\"zip_code\"><span>\nZip code</span>: {{vm.reservation_customer.zip_code}}</div><div class=\"country\"><span>Country</span>\n: {{vm.reservation_customer.country}}</div><div class=\"phone\"><span>Phone</span>: <a \nhref=\"tel:{{vm.reservation_customer.phone_number}}\">{{vm.reservation_customer.phone_number}}</a></div><div \nclass=\"phone\"><span>Secondary phone</span>: <a href=\"tel:{{vm.reservation_customer.secondary_phone_number}}\">\n{{vm.reservation_customer.secondary_phone_number}}</a></div><div class=\"email\"><span>Email</span>: <a \nhref=\"mailto:{{vm.reservation_customer.customer_email}}\">{{vm.reservation_customer.customer_email}}</a></div></div>\n</div></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"myCustomer\"><md-dialog \nclass=\"tax-dialog tax-dialog-new1 act-dialog addcusform\"><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"row\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Billing Information</span><md-button class=\"md-icon-button\" \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"max-height:1000px\" class=\"dilog-lable\"><md-content class=\"md-padding no-margin\">\n<div class=\"display-inline-block role-list-out white-bg top-sp-main no-margin\"><div layout=\"row\" flex=\"100\" \nlayout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center \"><md-input-container class=\"md-block no-margin\"><input \nng-model=\"vm.reservation_customer.customer_id\" name=\"customer_id\" type=\"hidden\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"CREATE_RES.CUST_FN\"></label><input ng-model=\"vm.reservation_customer.first_name\" \nng-change=\"vm.updateCustomer(\'first_name\', \'\', \'customer\')\" name=\"reservation_customer_fn\" type=\"text\" \nng-model-options=\"{debounce: 400}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block\"><label translate=\"CREATE_RES.CUST_LN\"></label><input \nng-model=\"vm.reservation_customer.last_name\" name=\"reservation_customer_ln\" \nng-change=\"vm.updateCustomer(\'last_name\', \'\', \'customer\')\" type=\"text\" ng-model-options=\"{debounce: 400}\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center \"><md-input-container class=\"md-block\"><label translate=\"CREATE_RES.CUST_EMAIL\"></label><input \nng-model=\"vm.reservation_customer.customer_email\" name=\"reservation_customer_email\" type=\"text\" \nng-blur=\"vm.saveEmailCustomer(vm.reservation_customer.customer_id,vm.reservation_customer.customer_email,\'customer\')\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block\"><label translate=\"CREATE_RES.CUST_CONT_NO\"></label><input \nng-model=\"vm.reservation_customer.phone_number\" ng-change=\"vm.updateCustomer(\'phone_number\', \'\', \'customer\')\" \nname=\"reservation_phone_number\" type=\"text\" ng-model-options=\"{debounce: 400}\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\">\n<div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" layout-align=\"center \"><md-switch \nng-model=\"vm.reservation_customer.send_email_indicator\" aria-label=\"Switch 1\" \nng-change=\"vm.updateEmailSatus(vm.reservation_customer.customer_id,vm.reservation_customer.send_email_indicator,\'customer\')\" \nclass=\"mt-0 mb-30\">{{ vm.reservation_customer.send_email_indicator?\'Send email\':\'Do not send email\'}}</md-switch></div>\n</div><div layout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block\"><label \ntranslate=\"CREATE_RES.CUST_SEC_CONT_NO\"></label><input ng-model=\"vm.reservation_customer.secondary_phone_number\" \nng-change=\"vm.updateCustomer(\'secondary_phone_number\', \'\', \'customer\')\" name=\"reservation_secondary_phone_number\" \ntype=\"text\" ng-model-options=\"{debounce: 400}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container>\n</div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-gt-xs=\"50\" flex=\"100\" layout-align=\"center \">\n<md-input-container class=\"md-block margin-bottom-0\"><label translate=\"CREATE_RES.CUST_ADD\"></label><input \nng-model=\"vm.reservation_customer.address\" ng-change=\"vm.updateCustomer(\'address\', \'\', \'customer\')\" \nname=\"reservation_address\" type=\"text\" ng-model-options=\"{debounce: 400}\" id=\"autocomplete\" autocomplete=\"off\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div><div layout=\"row\" flex=\"100\" \nlayout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center \"><md-input-container class=\"md-block margin-bottom-0\"><label translate=\"CREATE_RES.CUST_CITY\">\n</label><input ng-model=\"vm.reservation_customer.city\" name=\"reservation_customer_city\" type=\"text\" \nng-change=\"vm.updateCustomer(\'city\', \'\', \'customer\')\" ng-model-options=\"{debounce: 400}\" autocomplete=\"off\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block margin-bottom-0\"><md-autocomplete ng-disabled=\"vm.isStateDisabled\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedState\" md-search-text-change=\"vm.searchState(vm.searchTxtState)\" \nmd-search-text=\"vm.searchTxtState\" md-selected-item-change=\"vm.selectedItemChangeState(item)\" \nmd-items=\"item in vm.queryStateSearch(vm.searchTxtState)\" md-item-text=\"item.name\" md-min-length=\"0\" \nmd-floating-label=\"State\"><md-item-template><span md-highlight-text=\"vm.searchTxtState\" md-highlight-flags=\"^i\">\n{{item.name}}</span></md-item-template><md-not-found>\n{{ vm.searchTxtCountry.length > 0? \'No states matching \'+vm.searchTxtState+\' were found.\' : \'Please select country first\'}}\n</md-not-found></md-autocomplete></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center \"><md-input-container class=\"md-block margin-bottom-0\"><label \ntranslate=\"CREATE_RES.CUST_ZIP_CODE\"></label><input ng-model=\"vm.reservation_customer.zip_code\" \nng-change=\"vm.updateCustomer(\'zip_code\', \'\', \'customer\')\" name=\"reservation_zip_code\" type=\"text\" id=\"autocompletezip\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block margin-bottom-0\"><md-autocomplete ng-disabled=\"vm.isCountryDisabled\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedCountry\" \nmd-search-text-change=\"vm.searchCountry(vm.searchTxtCountry)\" md-search-text=\"vm.searchTxtCountry\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-items=\"item in vm.queryCountrySearch(vm.searchTxtCountry)\" \nmd-item-text=\"item.display\" md-min-length=\"0\" md-floating-label=\"Country\" md-require-match class=\"full-width\">\n<md-item-template><span md-highlight-text=\"vm.searchTxtCountry\" md-highlight-flags=\"^i\">{{item.display}}</span>\n</md-item-template><md-not-found>No country matching \"{{vm.searchTxtCountry}}\" were found.</md-not-found>\n</md-autocomplete></md-input-container></div></div></div></md-content></md-dialog-content></md-dialog></div></div>\n</div></div><div layout=\"column\" class=\"halfblockinfo\" ng-if=\"vm.order.type_of_reservation == \'reservation\'\"><div \nclass=\"section-right-genral role-list-out featured-rol-block\" style=\"padding:0px\"><div class=\"roomName ph-15 pb-10\" \nlayout=\"row\" flex><div class=\"room-col\" layout=\"column\" flex=\"100\"><div layout=\"row\" flex layout-wrap><div \nlayout=\"column\" flex=\"100\" layout-align=\"center start\"><div class=\"row-containerstaus\"><strong>\n{{ \'CREATE_RES.TRAVEL_INFO\' | translate }} </strong><i \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"icon-account-multiple-plus s30 onlycursorPointer onlyFloatRight white-fg\" \nng-click=\"vm.triggerdiv($event, \'Traveller\')\"><md-tooltip>{{ \'CONTACTS.EDIT_CONTACT\' | translate }}</md-tooltip></i>\n</div></div></div></div></div><div class=\"white-bg padding-15\"><div><div class=\"detailmain\"><div class=\"title\">\n{{vm.order.first_name}} {{vm.order.last_name}}</div><div class=\"address\"><span>Address</span>: {{vm.order.address}}\n</div><div class=\"city\"><span>City</span>: {{vm.order.city}}</div><div class=\"state\"><span>State</span>\n: {{vm.order.state}}</div><div class=\"zip_code\"><span>Zip code</span>: {{vm.order.zip_code}}</div><div class=\"country\">\n<span>Country</span>: {{vm.order.country}}</div><div class=\"phone\"><span>Phone</span>: <a \nhref=\"tel:{{vm.order.phone_number}}\">{{vm.order.phone_number}}</a></div><div class=\"phone\"><span>Secondary phone</span>\n: <a href=\"tel:{{vm.order.secondary_phone_number}}\">{{vm.order.secondary_phone_number}}</a></div><div class=\"email\">\n<span>Email</span>: <a href=\"mailto:{{vm.order.customer_email}}\">{{vm.order.customer_email}}</a></div></div></div>\n</div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"myTraveller\"><md-dialog \nclass=\"tax-dialog tax-dialog-new1 act-dialog addcusform\"><md-toolbar class=\"md-accent md-tall white-fg\" layout=\"row\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Traveler Information</span><md-button class=\"md-icon-button\" \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll style=\"max-height:1000px\" class=\"dilog-lable\"><md-content class=\"md-padding no-margin\">\n<div class=\"display-inline-block role-list-out white-bg top-sp-main no-margin\"><div layout=\"row\" flex=\"100\" \nlayout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center \"><md-input-container class=\"md-block no-margin\"><input ng-model=\"vm.order.customer_id\" \nname=\"customer_id[vm.selectedIndex]\" type=\"hidden\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\">\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"CREATE_RES.CUST_FN\"></label><input \nng-model=\"vm.order.first_name\" name=\"customer_fn[vm.selectedIndex]\" type=\"text\" \nng-change=\"vm.updateCustomer(\'first_name\', vm.order.confirmation_number, \'traveller\')\" \nng-model-options=\"{debounce: 400}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block margin-bottom-0\"><label translate=\"CREATE_RES.CUST_LN\"></label><input \nng-model=\"vm.order.last_name\" name=\"customer_ln[vm.selectedIndex]\" type=\"text\" \nng-change=\"vm.updateCustomer(\'last_name\', vm.order.confirmation_number, \'traveller\')\" \nng-model-options=\"{debounce: 400}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div>\n<div layout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block\"><label \ntranslate=\"CREATE_RES.CUST_EMAIL\"></label><input ng-model=\"vm.order.customer_email\" \nname=\"customer_email[vm.selectedIndex]\" type=\"text\" \nng-blur=\"vm.saveEmailCustomer(vm.order.customer_id,vm.order.customer_email,\'traveler\')\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block\"><label \ntranslate=\"CREATE_RES.CUST_CONT_NO\"></label><input ng-model=\"vm.order.phone_number\" \nname=\"phone_number[vm.selectedIndex]\" type=\"text\" \nng-change=\"vm.updateCustomer(\'phone_number\', vm.order.confirmation_number, \'traveller\')\" \nng-model-options=\"{debounce: 400}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div>\n<div layout=\"row\" flex=\"100\" layout-wrap class=\"mb-0 switchclass\"><div class=\"padding-left-10 padding-right-10\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block\"><md-switch \nng-model=\"vm.order.send_email_indicator\" aria-label=\"Switch 1\" \nng-change=\"vm.updateEmailSatus(vm.order.customer_id,vm.order.send_email_indicator, \'traveller\')\">\n{{vm.order.send_email_indicator?\'Send email\':\'Do not send email\'}}</md-switch></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block\"><label \ntranslate=\"CREATE_RES.CUST_SEC_CONT_NO\"></label><input ng-model=\"vm.order.secondary_phone_number\" \nname=\"secondary_phone_number[vm.selectedIndex]\" type=\"text\" \nng-change=\"vm.updateCustomer(\'secondary_phone_number\', vm.order.confirmation_number, \'traveller\')\" \nng-model-options=\"{debounce: 400}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block margin-bottom-0\"><label translate=\"CREATE_RES.CUST_ADD\"></label><input \nng-model=\"vm.order.address\" name=\"address[vm.selectedIndex]\" type=\"text\" \nng-change=\"vm.updateCustomer(\'address\', vm.order.confirmation_number, \'traveller\')\" ng-model-options=\"{debounce: 400}\" \nid=\"autocompleteTraveller\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block margin-bottom-0\"><label \ntranslate=\"CREATE_RES.CUST_CITY\"></label><input ng-model=\"vm.order.city\" name=\"city[vm.selectedIndex]\" type=\"text\" \nng-change=\"vm.updateCustomer(\'city\', vm.order.confirmation_number, \'traveller\')\" ng-model-options=\"{debounce: 400}\" \nng-model-options=\"{debounce: 400}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block margin-bottom-0\"><md-autocomplete ng-disabled=\"vm.isStateDisabled\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedStateForTraveller\" \nmd-search-text-change=\"vm.searchStateForTraveller(vm.searchTxtStateForTraveller)\" \nmd-search-text=\"vm.searchTxtStateForTraveller\" md-selected-item-change=\"vm.selectedItemChangeStateForTraveller(item)\" \nmd-items=\"item in vm.queryStateSearchForTraveller(vm.searchTxtStateForTraveller)\" md-item-text=\"item.name\" \nmd-min-length=\"0\" md-floating-label=\"State\"><md-item-template><span md-highlight-text=\"vm.searchTxtStateForTraveller\" \nmd-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>\n{{ vm.searchTxtCountry.length > 0? \'No states matching \'+vm.searchTxtState+\' were found.\' : \'Please select country first\'}}\n</md-not-found></md-autocomplete></md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nlayout-align=\"center \"><md-input-container class=\"md-block margin-bottom-0\"><label \ntranslate=\"CREATE_RES.CUST_ZIP_CODE\"></label><input ng-model=\"vm.order.zip_code\" name=\"reservation_zip_code\" \ntype=\"text\" ng-change=\"vm.updateCustomer(\'zip_code\', vm.order.confirmation_number)\" ng-model-options=\"{debounce: 400}\" \nid=\"autocompletezipTraveller\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block margin-bottom-0\"><md-autocomplete ng-disabled=\"vm.isCountryDisabled\" \nmd-no-cache=\"vm.noCache\" md-selected-item=\"vm.selectedCountryForTraveller\" \nmd-search-text-change=\"vm.searchCountry(vm.searchTxtCountryForTraveller)\" \nmd-search-text=\"vm.searchTxtCountryForTraveller\" md-selected-item-change=\"vm.selectedItemChangeForTraveller(item)\" \nmd-items=\"item in vm.queryCountrySearch(vm.searchTxtCountryForTraveller)\" md-item-text=\"item.display\" \nmd-min-length=\"0\" md-floating-label=\"Country\" md-require-match class=\"full-width\"><md-item-template><span \nmd-highlight-text=\"vm.searchTxtCountryForTraveller\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template>\n<md-not-found>No country matching \"{{vm.searchTxtCountryForTraveller}}\" were found.</md-not-found></md-autocomplete>\n</md-input-container></div></div></div></md-content></md-dialog-content></md-dialog></div></div></div></div><div \nlayout=\"column\" class=\"halfblockinfo\" layout-align=\"start start\" ng-if=\"vm.order.type_of_reservation == \'boat\'\"><div \nclass=\"full-width\"><div class=\"section-right-genral role-list-out featured-rol-block no-padding\"><div \nclass=\"roomName font-sizeroom ph-15 pv-10\"><strong>{{ \'CREATE_RES.VESSEL_INFO\' | translate }} </strong><i \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"icon-account-multiple-plus s30 onlycursorPointer onlyFloatRight white-fg\" \nng-click=\"vm.triggerdiv($event, \'Boat\')\"><md-tooltip>{{ \'CONTACTS.EDIT_VESSEL\' | translate }}</md-tooltip></i></div>\n<div class=\"white-bg padding-15\"><div><div class=\"detailmain\"><div class=\"address\"><span>Vessel type</span>\n: {{vm.boatData.boat_type}}</div><div class=\"phone\"><span>Vessel name</span>: {{vm.boatData.boat_name}}</div><div \nclass=\"city\"><span>Vessel model</span>: {{vm.boatData.boat_model}}</div><div class=\"city\"><span>Vessel make</span>\n: {{vm.boatData.boat_make}}</div><div class=\"state\"><span>Vessel length</span>: {{vm.boatData.boat_length}}</div><div \nclass=\"zip_code\"><span>Beam</span>: {{vm.boatData.beam}}</div><div class=\"country\"><span>Draft</span>\n: {{vm.boatData.draft}}</div></div></div></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" \nid=\"myBoat\"><md-dialog class=\"tax-dialog tax-dialog-new1 act-dialog addcusform\"><md-toolbar \nclass=\"md-accent md-tall white-fg\" layout=\"row\"><div class=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Vessel Information</span><md-button \nclass=\"md-icon-button\" ng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll style=\"max-height:1000px\" class=\"dilog-lable\"><md-content \nclass=\"md-padding no-margin\"><div class=\"display-inline-block role-list-out white-bg top-sp-main no-margin\"><div \nlayout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \" style=\"margin-bottom: 23px\"><md-input-container \nclass=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" role=\"button\" translate=\"ADD_BOAT_DATA.BOAT_TYPE\">\n</label><md-select required placeholder=\"Vessel Type\" ng-model=\"vm.boatData.boat_type\" class=\"\" \nng-change=\"vm.updateReservationValues(vm.order.confirmation_number,\'boat_data\',vm.boatData)\"><md-option \nng-value=\"boat.value\" ng-repeat=\"boat in vm.boatType\">{{boat.name}}</md-option></md-select></md-input-container></div>\n<div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"ADD_BOAT_DATA.BOAT_NAME\"></label><input type=\"text\" name=\"boat_name\" ng-model=\"vm.boatData.boat_name\" \naria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" ui-options=\"{addDefaultPlaceholder:false}\" \nng-change=\"vm.updateReservationValues(vm.order.confirmation_number,\'boat_data\',vm.boatData)\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"><div ng-messages=\"contactForm.boat_name.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span translate=\"ADD_BOAT_DATA.VALID_PHONE\"></span></div></div></md-input-container></div></div>\n<div layout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block tax-inputs full-width\"><label \nclass=\"ng-scope\" role=\"button\" translate=\"ADD_BOAT_DATA.BOAT_MODEL\"></label><input type=\"text\" name=\"boat_model\" \nng-model=\"vm.boatData.boat_model\" aria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" \nng-change=\"vm.updateReservationValues(vm.order.confirmation_number,\'boat_data\',vm.boatData)\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"><div ng-messages=\"contactForm.boat_model.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span translate=\"ADD_BOAT_DATA.VALID_PHONE\"></span></div></div></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center\">\n<md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"ADD_BOAT_DATA.BOAT_MAKE\"></label><input type=\"text\" name=\"boat_make\" ng-model=\"vm.boatData.boat_make\" \naria-invalid=\"true\" ng-model-options=\"{debounce: 500}\" ui-options=\"{addDefaultPlaceholder:false}\" \nng-change=\"vm.updateReservationValues(vm.order.confirmation_number,\'boat_data\',vm.boatData)\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"><div ng-messages=\"contactForm.boat_make.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span translate=\"ADD_BOAT_DATA.VALID_PHONE\"></span></div></div></md-input-container></div></div>\n<div layout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block tax-inputs full-width\"><label \nclass=\"ng-scope\" role=\"button\" translate=\"ADD_BOAT_DATA.BOAT_LENGTH\"></label><input ng-model=\"vm.boatData.boat_length\" \ntype=\"text\" name=\"boat_length\" ng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\" \nng-change=\"vm.updateReservationValues(vm.order.confirmation_number,\'boat_data\',vm.boatData)\" \nallow-vm.boat_data-numbers></md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \"><md-input-container class=\"md-block tax-inputs full-width\"><label \nclass=\"ng-scope\" role=\"button\" translate=\"ADD_BOAT_DATA.BOAT_BEAM\"></label><input ng-model=\"vm.boatData.beam\" \ntype=\"text\" name=\"beam\" ng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\" \nng-change=\"vm.updateReservationValues(vm.order.confirmation_number,\'boat_data\',vm.boatData)\" allow-only-numbers>\n</md-input-container></div></div><div layout=\"row\" flex=\"100\" layout-wrap class=\"mb-0\"><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center \">\n<md-input-container class=\"md-block tax-inputs full-width\"><label class=\"ng-scope\" role=\"button\" \ntranslate=\"ADD_BOAT_DATA.BOAT_DRAFT\"></label><input ng-model=\"vm.boatData.draft\" type=\"text\" name=\"draft\" \nng-model-options=\"{debounce: 500}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\" \nng-change=\"vm.updateReservationValues(vm.order.confirmation_number,\'boat_data\',vm.boatData)\" allow-only-numbers>\n</md-input-container></div></div></div></md-content></md-dialog-content></md-dialog></div></div><div \nclass=\"display-inline-block1 role-list-out1 white-bg top-sp-main no-padding no-margin\"><div layout=\"row\" flex=\"100\" \nlayout-wrap></div></div></div></div></div></div></div></div><div layout=\"row\" layout-wrap flex=\"100\" class=\"mt-20\"><div\n layout=\"column\" flex=\"100\" flex-sm=\"100\" flex-xs=\"100\"><div class=\"left-section-genral-infomation\"><div \nclass=\"genereal-div\" ng-if=\"vm.pageType != \'rent\'\"><div \nclass=\"role-list-out white-bg relative-block featured-block-main no-padding featured-rol-block\"><div \nng-class=\"\'roomName\'+vm.order.show_status+\' ph-15 pv-10\'\" layout=\"row\" flex ng-if=\"vm.roomCount > 0\"><div \nclass=\"room-col\" layout=\"column\" flex=\"100\"><div layout=\"row\" flex layout-wrap><div layout=\"column\" flex-gt-md=\"60\" \nflex-gt-xs=\"50\" flex-sm-xs=\"50\" flex=\"100\" layout-align=\"center start\"><div class=\"row-containerstaus\"><strong>\n{{vm.order.product_name}}</strong><div class=\"fromToInfo\" \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\"><div \nclass=\"fromInfo onlycursorPointer\" \nng-click=\"vm.editOrderDates(event,vm.order.room_stay_from,vm.order.room_stay_to,vm.order.room_stay_guest_count,vm.order.room_stay_child_count,vm.order.confirmation_number,vm.order.product_id,vm.order.product_name,vm.order.policy_id);\">\n<img src=\"assets/images/ecommerce/from.svg\">{{vm.order.room_stay_from}}</div><div class=\"toInfo onlycursorPointer\" \nng-click=\"vm.editOrderDates(event,vm.order.room_stay_from,vm.order.room_stay_to,vm.order.room_stay_guest_count,vm.order.room_stay_child_count,vm.order.confirmation_number,vm.order.product_id,vm.order.product_name,vm.order.policy_id,\'room\');\">\n<img src=\"assets/images/ecommerce/to.svg\"> {{vm.order.room_stay_to}}</div></div><div class=\"room_move_text\">\n{{vm.order.confirmation_number}}</div></div></div><div layout=\"column\" flex-gt-md=\"40\" flex-gt-xs=\"50\" flex=\"100\" \nflex-gt-sm=\"50\" layout-align=\"end end\" class=\"pr-0\"><div class=\"wrapactions\"><div class=\"input-block-status\">\n<md-input-container class=\"md-block mb-0 no-margin\"><md-select placeholder=\"status\" ng-model=\"vm.room_stay_status\" \nng-init=\"vm.room_stay_status=vm.order.room_stay_status\" \nng-change=\"vm.changeStatus(event,vm.selectedIndex,vm.order.room_stay_id,vm.order.confirmation_number,vm.order.room_stay_status,vm.room_stay_status,vm.order.overalltotals.remaining_amount,vm.order.overalltotals.paid_amount,vm.order.policy_id,vm.order.room_stay_from,vm.order.first_name,vm.order.customer_email,vm.order.total_amount)\">\n<md-option ng-value=\"key\" ng-repeat=\"(key, value) in vm.statuses\">{{value}}</md-option></md-select>\n</md-input-container></div><div class=\"mdmenusRoomWise\"><md-icon md-font-icon=\"icon-email\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" \nng-click=\"vm.sendorderinvoice(vm.order.confirmation_number)\" ng-if=\"vm.tabs_data.length > 1\"><md-tooltip>\n{{\'CREATE_RES.SEND_INVOICE\' | translate}}</md-tooltip></md-icon><md-icon md-font-icon=\"icon-printer\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" \nng-click=\"vm.printorderinvoice(vm.order.confirmation_number)\" \nng-if=\"vm.tabs_data.length > 1 && vm.room_stay_status != \'Canceled\'\"><md-tooltip>{{\'CREATE_RES.PRINT\' | translate}}\n</md-tooltip></md-icon><md-icon md-font-icon=\"icon-border-vertical\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" \nng-click=\"vm.roomMoveStart(event,vm.order.room_stay_from,vm.order.room_stay_to,vm.order.room_stay_guest_count,vm.order.room_stay_child_count,vm.order.room_stay_id,vm.order.product_id,vm.order.product_name,vm.order.policy_id,vm.order.confirmation_number,vm.reservation_id,vm.itinerary_number);\" \nng-if=\"(vm.order.show_status == \'Active\' || vm.order.show_status == \'Checked-In\') && vm.order.room_moved_to == null && vm.room_stay_status != \'Canceled\'\">\n<md-tooltip>{{\'CREATE_RES.RUMMOVE\' | translate}}</md-tooltip></md-icon><md-icon \nng-if=\"vm.room_stay_status != \'Canceled\'\" md-svg-src=\"assets/angular-material-assets/img/icons/room-service.svg\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" ng-click=\"vm.gotoCheckoutFromEditOrder()\"><md-tooltip>\n{{\'CREATE_RES.ADD_SERVICE\' | translate}}</md-tooltip></md-icon><md-icon \nng-if=\"vm.parking_access && vm.room_stay_status != \'Canceled\'\" md-font-icon=\"icon-parking\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" \nng-click=\"vm.addParking(event,vm.order.room_stay_from,vm.order.room_stay_to,vm.order.confirmation_number)\"><md-tooltip>\n{{\'CREATE_RES.ADD_PARKING\' | translate}}</md-tooltip></md-icon><md-icon \nng-if=\"vm.order.type_of_reservation == \'boat\' && vm.room_stay_status != \'Canceled\'\" md-font-icon=\"icon-parking\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" \nng-click=\"vm.addBoatPos(event,vm.order.room_stay_from,vm.order.room_stay_to,vm.order.confirmation_number)\"><md-tooltip>\n{{\'CREATE_RES.ADD_BOAT\' | translate}}</md-tooltip></md-icon><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/boarding-pass.svg\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" ng-click=\"vm.printRegistrationCard()\" \nng-if=\"vm.print_registration && vm.roomCount > 0 && vm.room_stay_status != \'Canceled\'\"><md-tooltip>\nPrint Registration Card</md-tooltip></md-icon><md-icon ng-click=\"vm.getOTADetails()\" md-font-icon=\"icon-wallet-travel\" \nclass=\"white-fg close-icon1 font-size-12 onlycursorPointer mh-5\" \nng-if=\"vm.superAdmin && vm.order.type_of_reservation != \'boat\'\"><md-tooltip>Link To OTA</md-tooltip></md-icon></div>\n</div></div></div></div></div>{{}}<div class=\"display-inline-block scroll-sm-blk-311\"><div class=\"room-detail-block\" \nlayout=\"row\" flex=\"100\" layout-wrap ng-if=\"vm.roomCount > 0 && vm.order.type_of_reservation == \'reservation\'\"><div \nclass=\"R-D-col-left padding-20\" layout=\"row\" flex=\"100\" layout-wrap><div class=\"adlt-child-block ph-10\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" layout-align=\"start start\"><div class=\"full-width\"><div \nclass=\"sm-section-aldult\"><div class=\"arrival-am-txt\">Adult</div><div class=\"adult-input-block\"><md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" class=\"md-block mb-0 no-margin\">\n<md-select required ng-model-options=\"{debounce: 400}\" \nng-change=\"vm.manageAdultChild(\'adult\');vm.setShowModifyBtn(\'Adults\',\'room_stay_guest_count\',vm.order.room_stay_id);vm.setAdults()\" \nng-model=\"vm.order.room_stay_guest_count\" name=\"adults[vm.selectedIndex]\"><md-option ng-value=\"n\" \nng-repeat=\"n in vm.adultRange\">{{n}}</md-option></md-select></md-input-container></div></div><div \nclass=\"sm-section-aldult\"><div class=\"arrival-am-txt\">Child</div><div class=\"adult-input-block\"><md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" class=\"md-block mb-0 no-margin\">\n<md-select required placeholder=\"Children\" ng-model-options=\"{debounce: 400}\" \nng-change=\"vm.manageAdultChild(\'child\');vm.setShowModifyBtn(\'Children\',\'room_stay_child_count\',vm.order.room_stay_id);vm.setAdults();\" \nng-model=\"vm.order.room_stay_child_count\" name=\"child[vm.selectedIndex]\"><md-option ng-value=\"i\" \nng-repeat=\"i in vm.childRange\">{{i}}</md-option></md-select></md-input-container></div></div></div></div><div \nclass=\"adlt-child-block ph-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\" layout-align=\"start start\">\n<div class=\"full-width\"><div class=\"sm-section-aldult\"><div class=\"arrival-am-txt\" translate=\"CREATE_RES.ARRIVAL_TIME\">\nArrival time</div><div class=\"adult-input-block no-margin\"><md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" class=\"md-block mb-0 no-margin\">\n<md-select ng-model=\"vm.order.arrival_time\" ng-model-options=\"{debounce: 400}\" \nng-change=\"vm.setShowModifyBtn(\'Arrival time\',\'arrival_time\',vm.order.room_stay_id, \'date\');vm.updateReservationValues(vm.order.confirmation_number,\'arrival_time\',vm.order.arrival_time)\">\n<md-option ng-value=\"key\" ng-repeat=\"(key,arrival_dep) in vm.arrival_departure_time\">{{arrival_dep}}</md-option>\n</md-select><div class=\"md-errors-spacer\"></div></md-input-container></div></div><div class=\"sm-section-aldult\"><div \nclass=\"arrival-am-txt\" translate=\"CREATE_RES.DEPARTURE_TIME\">Departure time</div><div \nclass=\"adult-input-block no-margin\"><md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" class=\"md-block no-margin\">\n<md-select ng-model=\"vm.order.departure_time\" ng-model-options=\"{debounce: 400}\" \nng-change=\"vm.setShowModifyBtn(\'Departure time\',\'departure_time\',vm.order.room_stay_id, \'date\');vm.updateReservationValues(vm.order.confirmation_number,\'departure_time\',vm.order.departure_time)\">\n<md-option ng-value=\"key\" ng-repeat=\"(key,arrival_dep) in vm.arrival_departure_time\">{{arrival_dep}}</md-option>\n</md-select><div class=\"md-errors-spacer\"></div></md-input-container></div></div></div></div><div \nclass=\"adlt-child-block ph-10\" layout=\"column\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"33\" layout-align=\"start start\">\n<div class=\"full-width\"><div class=\"sm-section-aldult\"><md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"md-block mb-0 md-input-has-value mb-0\"><label translate=\"CREATE_RES.DO_NOT_MOVE\"></label><md-radio-group \nclass=\"no-margin\" ng-model=\"vm.order.room_number_locked_indicator\" ng-model-options=\"{debounce: 400}\" \nng-change=\"vm.updateReservationValues(vm.order.confirmation_number,\'room_number_locked_indicator\',vm.order.room_number_locked_indicator)\">\n<md-radio-button class=\"space-block-inline\" value=\"1\">Yes</md-radio-button><md-radio-button \nclass=\"space-block-inline margin-left-30\" value=\"0\">No</md-radio-button></md-radio-group></md-input-container></div>\n<div class=\"sm-section-aldult\" ng-if=\"vm.order.promotion_applied == 1\"><div class=\"arrival-am-txt\">Promotion Code :\n</div><div class=\"adult-input-block promocode\">{{vm.order.promotion_code}}</div></div></div></div></div></div><div \nclass=\"lowest-price-content\" ng-if=\"vm.order.type_of_reservation == \'boat\' && vm.order.prices.dates.length > 31\"><div \nclass=\"accordian-cover\"><div class=\"accordian-row\"><div class=\"accordian-content\" \nng-repeat=\"(monthName,monthData) in vm.newArray\"><h5 class=\"accordian-title months{{monthName}} accordian-title-minus\" \nng-click=\"vm.toggle(monthName,\'month\')\"><span class=\"monthname\">{{monthName}}</span> <span class=\"priceblockmain\"><span\n class=\"pricemaininner\"><b class=\"discount\">${{vm.monthOverallTotal[monthName][\'discount\']}}</b> <small \nclass=\"totalblk\">Discount</small> </span><span class=\"pricemaininner\">${{vm.monthOverallTotal[monthName][\'price\'] }} \n<small class=\"totalblk\">Total </small></span></span><span class=\"paidamount\"><span><b class=\"paidmain\">\n${{vm.PaidValues[monthName]}}</b> <small class=\"totalblk\">Paid</small> </span><span><b class=\"owe\">\n${{vm.owesValues[monthName]}}</b> <small class=\"totalblk\">Owes</small></span></span></h5><div \nclass=\"accordian-inner-content dropdown-container\" style=\"display: none\"><div \nclass=\"accordian-content weekContainer weekafter\" ng-repeat=\"(weekName,items) in monthData\"><h5 \nclass=\"accordian-title weeks{{weekName}}{{key}} accordian-title-minus\" ng-click=\"vm.toggle(weekName+key,\'week\')\"><span \nclass=\"newhtmlappend monthsblock\" ng-bind-html=\"vm.getWeekHeaderName(items,monthName+weekName)\"></span> <span \nclass=\"priceblockouter\"><span class=\"pricemaininner\"><b class=\"discount\">\n${{vm.weekOverallTotal[monthName+weekName][\'discount\']}}</b> <small class=\"totalblk\">Discount</small> </span><span \nclass=\"pricemaininner\">${{vm.weekOverallTotal[monthName+weekName][\'price\']}} <small class=\"totalblk\">Total </small>\n</span></span><span class=\"paidamount\"><span><b class=\"paidmain\">${{vm.weekPaidValues[monthName+weekName]}}</b> <small \nclass=\"totalblk\">Paid</small> </span><span><b class=\"owe\">${{vm.weekOwesValues[monthName+weekName]}}</b> <small \nclass=\"totalblk\">Owes</small> </span></span></h5><div class=\"accordian-inner-content dropdown-container1\" \nstyle=\"display: none\"><div class=\"nightlyscrollblk\"><div class=\"scroll-nightly-inner\"><div layout=\"row\" flex=\"100\" \nlayout-wrap class=\"row-block1-amount row-header-amount\"><div layout=\"column\" flex=\"20\" layout-align=\"center start\">\nNight</div><div layout=\"column\" flex=\"20\" layout-align=\"center start\">Date</div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center start\">Rate Plan</div><div layout=\"column\" flex=\"20\" layout-align=\"center end\">Discount</div><div \nlayout=\"column\" flex=\"20\" layout-align=\"center end\">Price</div></div><div layout=\"row\" \nng-repeat=\"(eachKey, eachnight) in items\" flex=\"100\" layout-wrap class=\"row-nightly-amount row-block1-amount\"><div \nlayout=\"column\" flex=\"20\" layout-align=\"center start\"><div class=\"minusiconouter\"><div class=\"charges\" \nng-if=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) < 0\">Night {{vm.order.prices.nightcount[eachKey]}}</div>\n<div class=\"charges strikethrough\" ng-if=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) >= 0\">Canceled Night\n</div><div ng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\"><span \nng-class=\"vm.isloading?\'pointer_events_disabled onlycursorPointer minusiconred1\':\'onlycursorPointer minusiconred1\'\" \nng-click=\"vm.cancelThisNight(items[eachKey])\" \nng-if=\"(vm.order.prices.nightcount[eachKey]==1 || vm.order.prices.nightcount[eachKey]==vm.order.nights) && vm.order.nights>1 && vm.order.prices.canceled_nights.indexOf(items[eachKey]) < 0\">\n<md-icon md-font-icon=\"icon-minus-circle-outline\" class=\"s15 red-A800-fg\"><md-tooltip>No refund cancel</md-tooltip>\n</md-icon></span><span \nng-class=\"vm.isloading?\'pointer_events_disabled onlycursorPointer minusiconred1\':\'onlycursorPointer minusiconred1\'\" \nng-click=\"vm.undoCancelThisNight(items[eachKey])\" \nng-if=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) >= 0 && vm.order.prices.canUndoNights.indexOf(items[eachKey]) >= 0 && (vm.order.prices.nightcancelledCount[eachKey]==1 || vm.order.prices.nightcancelledCount[eachKey]==vm.order.prices.canceled_nights.length || (vm.order.prices.nightcancelledCount[eachKey + 1 ] == -1) ||(vm.order.prices.nightcancelledCount[eachKey + 1 ] != -1))\">\n<md-icon md-font-icon=\"icon-plus-circle-outline\" class=\"s15 md-accent\"><md-tooltip>Undo no refund cancel</md-tooltip>\n</md-icon></span></div></div></div><div layout=\"column\" flex=\"20\" layout-align=\"center start\"><div \nng-class=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) < 0?\'charges\':\'charges strikethrough\'\">\n{{vm.order.prices.dates[eachKey]}}</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center start\"><div \nng-class=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) < 0?\'charges\':\'charges strikethrough\'\">\n{{vm.order.prices.rate_plan[eachKey]}}</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center end\"><div \nclass=\"amount\"><md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" class=\"md-block no-margin\"><i \nclass=\"icon icon-currency-usd s20\"></i> <input ng-model-options=\"{updateOn: \'blur\'}\" \nng-change=\"vm.setShowModifyBtn(\'Night-{{eachKey}}\',\'nightlydiscount\',vm.order.room_stay_id);vm.sumnightlyDisc({{eachKey}})\" \nng-model=\"vm.order.prices.nightlydiscount[eachKey]\" name=\"nightly_discount[vm.selectedIndex][eachKey]\" type=\"text\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"> <i ng-if=\"vm.order.prices.nightlydiscount[eachKey]>0\" \nclass=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.opencommentboxNight(vm.selectedIndex,eachKey);\"><md-tooltip \nng-if=\"vm.order.prices.nightlydiscountcomment[eachKey]!=\'\'\">{{vm.order.prices.nightlydiscountcomment[eachKey]}}\n</md-tooltip></i></md-input-container></div></div><div layout=\"column\" flex=\"20\" layout-align=\"center end\"><div \nclass=\"amount\"><md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" class=\"md-block no-margin\"><i \nclass=\"icon icon-currency-usd s20\"></i> <input ng-model-options=\"{updateOn: \'blur\'}\" \nng-change=\"vm.setShowModifyBtn(\'Night-{{eachKey}}\',\'prices\',vm.order.room_stay_id);vm.sumNights({{eachKey}})\" \nng-model=\"vm.order.prices.rates[eachKey]\" name=\"rate_plan[vm.selectedIndex][eachKey]\" type=\"text\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div></div></div></div></div></div></div></div></div></div></div>\n</div><div class=\"lowest-price-content\" \nng-if=\"vm.order.type_of_reservation == \'boat\' && (vm.order.prices.dates.length >= 7 && vm.order.prices.dates.length <= 31)\">\n<div class=\"accordian-cover\"><div class=\"accordian-row\"><div class=\"accordian-content onlyWeekdata\"><div \nclass=\"accordian-inner-content dropdown-container weekcontent\"><div class=\"accordian-content weekContainer\" \nng-repeat=\"(weekName,items) in  vm.newArray\"><h5 \nclass=\"accordian-title weeks{{weekName}}{{key}} accordian-title-minus\" ng-click=\"vm.toggle(weekName+key,\'week\')\"><span \nclass=\"newhtmlappend monthsblock\" ng-bind-html=\"vm.getWeekHeaderName(items,monthName+weekName)\"></span> <span \nclass=\"priceblockouter\"><span class=\"pricemaininner\"><b class=\"discount\">\n${{vm.weekOverallTotal[weekName][\'discount\']}} </b><small class=\"totalblk\">Discount</small> </span><span \nclass=\"pricemaininner\">${{vm.weekOverallTotal[weekName][\'price\']}} <small class=\"totalblk\">Total</small> </span></span>\n<span class=\"paidamount\"><span><b class=\"paidmain\">${{vm.weekPaidValues[monthName+weekName]}}</b> <small \nclass=\"totalblk\">Paid</small> </span><span><b class=\"owe\">${{vm.weekOwesValues[monthName+weekName]}}</b> <small \nclass=\"totalblk\">Owes</small></span></span></h5><div class=\"accordian-inner-content dropdown-container1\" \nstyle=\"display: none\"><div class=\"nightlyscrollblk\"><div class=\"scroll-nightly-inner\"><div layout=\"row\" flex=\"100\" \nlayout-wrap class=\"row-block1-amount row-header-amount\"><div layout=\"column\" flex=\"20\" layout-align=\"center start\">\nNight</div><div layout=\"column\" flex=\"20\" layout-align=\"center start\">Date</div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center start\">Rate Plan</div><div layout=\"column\" flex=\"20\" layout-align=\"center end\">Discount</div><div \nlayout=\"column\" flex=\"20\" layout-align=\"center end\">Price</div></div><div layout=\"row\" \nng-repeat=\"(eachKey, eachnight) in items\" flex=\"100\" layout-wrap class=\"row-nightly-amount row-block1-amount\"><div \nlayout=\"column\" flex=\"20\" layout-align=\"center start\"><div class=\"minusiconouter\"><div class=\"charges\" \nng-if=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) < 0\">Night {{vm.order.prices.nightcount[eachKey]}}</div>\n<div class=\"charges strikethrough\" ng-if=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) >= 0\">Canceled Night\n</div><div ng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\"><span \nng-class=\"vm.isloading?\'pointer_events_disabled onlycursorPointer minusiconred1\':\'onlycursorPointer minusiconred1\'\" \nng-click=\"vm.cancelThisNight(items[eachKey])\" \nng-if=\"(vm.order.prices.nightcount[eachKey]==1 || vm.order.prices.nightcount[eachKey]==vm.order.nights) && vm.order.nights>1 && vm.order.prices.canceled_nights.indexOf(items[eachKey]) < 0\">\n<md-icon md-font-icon=\"icon-minus-circle-outline\" class=\"s15 red-A800-fg\"><md-tooltip>No refund cancel</md-tooltip>\n</md-icon></span><span \nng-class=\"vm.isloading?\'pointer_events_disabled onlycursorPointer minusiconred1\':\'onlycursorPointer minusiconred1\'\" \nng-click=\"vm.undoCancelThisNight(items[eachKey])\" \nng-if=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) >= 0 && vm.order.prices.canUndoNights.indexOf(items[eachKey]) >= 0 && (vm.order.prices.nightcancelledCount[eachKey]==1 || vm.order.prices.nightcancelledCount[eachKey]==vm.order.prices.canceled_nights.length || (vm.order.prices.nightcancelledCount[eachKey + 1 ] == -1) ||(vm.order.prices.nightcancelledCount[eachKey + 1 ] != -1))\">\n<md-icon md-font-icon=\"icon-plus-circle-outline\" class=\"s15 md-accent\"><md-tooltip>Undo no refund cancel</md-tooltip>\n</md-icon></span></div></div></div><div layout=\"column\" flex=\"20\" layout-align=\"center start\"><div \nng-class=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) < 0?\'charges\':\'charges strikethrough\'\">\n{{vm.order.prices.dates[eachKey]}}</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center start\"><div \nng-class=\"vm.order.prices.canceled_nights.indexOf(items[eachKey]) < 0?\'charges\':\'charges strikethrough\'\">\n{{vm.order.prices.rate_plan[eachKey]}}</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center end\"><div \nclass=\"amount\"><md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" class=\"md-block no-margin\"><i \nclass=\"icon icon-currency-usd s20\"></i> <input ng-model-options=\"{updateOn: \'blur\'}\" \nng-change=\"vm.setShowModifyBtn(\'Night-{{eachKey}}\',\'nightlydiscount\',vm.order.room_stay_id);vm.sumnightlyDisc({{eachKey}})\" \nng-model=\"vm.order.prices.nightlydiscount[eachKey]\" name=\"nightly_discount[vm.selectedIndex][eachKey]\" type=\"text\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"> <i ng-if=\"vm.order.prices.nightlydiscount[eachKey]>0\" \nclass=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.opencommentboxNight(vm.selectedIndex,eachKey);\"><md-tooltip \nng-if=\"vm.order.prices.nightlydiscountcomment[eachKey]!=\'\'\">{{vm.order.prices.nightlydiscountcomment[eachKey]}}\n</md-tooltip></i></md-input-container></div></div><div layout=\"column\" flex=\"20\" layout-align=\"center end\"><div \nclass=\"amount\"><md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" class=\"md-block no-margin\"><i \nclass=\"icon icon-currency-usd s20\"></i> <input ng-model-options=\"{updateOn: \'blur\'}\" \nng-change=\"vm.setShowModifyBtn(\'Night-{{eachKey}}\',\'prices\',vm.order.room_stay_id);vm.sumNights({{eachKey}})\" \nng-model=\"vm.order.prices.rates[eachKey]\" name=\"rate_plan[vm.selectedIndex][eachKey]\" type=\"text\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div></div></div></div></div></div></div></div></div></div></div>\n</div><div class=\"nightly-price-heading\" \nng-if=\"(vm.roomCount > 0 && vm.order.prices.dates.length > 0 && vm.order.type_of_reservation == \'reservation\') || (vm.order.type_of_reservation == \'boat\' && vm.order.prices.dates.length < 7) \">\nNightly-price<div class=\"nightlyscrollblk\"><div class=\"scroll-nightly-inner\"><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"row-block1-amount row-header-amount\"><div layout=\"column\" flex=\"20\" layout-align=\"center start\">Night</div><div \nlayout=\"column\" flex=\"20\" layout-align=\"center start\">Date</div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center start\">Rate Plan</div><div layout=\"column\" flex=\"20\" layout-align=\"center end\">Discount</div><div \nlayout=\"column\" flex=\"20\" layout-align=\"center end\">Price</div></div><div layout=\"row\" \nng-repeat=\"eachnight in vm.order.prices.dates\" flex=\"100\" layout-wrap class=\"row-nightly-amount row-block1-amount\"><div\n layout=\"column\" flex=\"20\" layout-align=\"center start\"><div class=\"minusiconouter\"><div class=\"charges\" \nng-if=\"vm.order.prices.canceled_nights.indexOf(vm.order.prices.dates[$index]) < 0\">\nNight {{vm.order.prices.nightcount[$index]}}</div><div class=\"charges strikethrough\" \nng-if=\"vm.order.prices.canceled_nights.indexOf(vm.order.prices.dates[$index]) >= 0\">Canceled Night</div><div \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\"><span \nng-class=\"vm.isloading?\'pointer_events_disabled onlycursorPointer minusiconred1\':\'onlycursorPointer minusiconred1\'\" \nng-click=\"vm.cancelThisNight(vm.order.prices.dates[$index])\" \nng-if=\"(vm.order.prices.nightcount[$index]==1 || vm.order.prices.nightcount[$index]==vm.order.nights) && vm.order.nights>1 && vm.order.prices.canceled_nights.indexOf(vm.order.prices.dates[$index]) < 0\">\n<md-icon md-font-icon=\"icon-minus-circle-outline\" class=\"s15 red-A800-fg\"><md-tooltip>No refund cancel</md-tooltip>\n</md-icon></span><span \nng-class=\"vm.isloading?\'pointer_events_disabled onlycursorPointer minusiconred1\':\'onlycursorPointer minusiconred1\'\" \nng-click=\"vm.undoCancelThisNight(vm.order.prices.dates[$index])\" \nng-if=\"vm.order.prices.canceled_nights.indexOf(vm.order.prices.dates[$index]) >= 0 && vm.order.prices.canUndoNights.indexOf(vm.order.prices.dates[$index]) >= 0 && (vm.order.prices.nightcancelledCount[$index]==1 || vm.order.prices.nightcancelledCount[$index]==vm.order.prices.canceled_nights.length || (vm.order.prices.nightcancelledCount[$index + 1 ] == -1) ||(vm.order.prices.nightcancelledCount[$index + 1 ] != -1))\">\n<md-icon md-font-icon=\"icon-plus-circle-outline\" class=\"s15 md-accent\"><md-tooltip>Undo no refund cancel</md-tooltip>\n</md-icon></span></div></div></div><div layout=\"column\" flex=\"20\" layout-align=\"center start\"><div \nng-class=\"vm.order.prices.canceled_nights.indexOf(vm.order.prices.dates[$index]) < 0?\'charges\':\'charges strikethrough\'\">\n{{vm.order.prices.dates[$index]}}</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center start\"><div \nng-class=\"vm.order.prices.canceled_nights.indexOf(vm.order.prices.dates[$index]) < 0?\'charges\':\'charges strikethrough\'\">\n{{vm.order.prices.rate_plan[$index]}}</div></div><div layout=\"column\" flex=\"20\" layout-align=\"center end\"><div \nclass=\"amount discount\"><md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" class=\"md-block no-margin\"><i \nclass=\"icon icon-currency-usd s20\"></i> <span \nng-click=\"vm.opencommentboxNight(vm.selectedIndex,$index,\'nightly_discount\');\">\n{{ vm.order.prices.nightlydiscount[$index] }}</span><i ng-if=\"vm.order.prices.nightlydiscount[$index]>0\" \nclass=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.opencommentboxNight(vm.selectedIndex,$index,\'nightly_discount\');\"><md-tooltip \nng-if=\"vm.order.prices.nightlydiscountcomment[$index]!=\'\'\">{{vm.order.prices.nightlydiscountcomment[$index]}}\n</md-tooltip></i></md-input-container></div></div><div layout=\"column\" flex=\"20\" layout-align=\"center end\"><div \nclass=\"amount price\"><md-input-container \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" class=\"md-block no-margin\"><i \nclass=\"icon icon-currency-usd s20\"></i> <input ng-model-options=\"{updateOn: \'blur\'}\" \nng-change=\"vm.setShowModifyBtn(\'Night-{{$index}}\',\'prices\',vm.order.room_stay_id);vm.sumNights({{$index}})\" \nng-model=\"vm.order.prices.rates[$index]\" name=\"rate_plan[vm.selectedIndex][$index]\" type=\"text\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div></div></div></div></div></div><div class=\"pos_general_div\" \nng-repeat=\"(poskey, posValue) in vm.order.pos track by $index\"><div class=\"nightly-price-latest padding-20\"><div \nlayout=\"row\" flex=\"100\" layout-wrap class=\"row-nightly-header-amount row-block1-amount\"><div layout=\"column\" \nflex-gt-md=\"70\" flex-gt-xs=\"60\" flex=\"100\" layout-align=\"center start\"><div class=\"big-txt-night pb-10 capitalize\">\n{{posValue.product_name}}</div><div ng-if=\"posValue.is_gift_card == 1\"><span class=\"gcinfo\"><b>Customer:</b>\n {{posValue.gc_sender_name}} (<a href=\"mailto:{{posValue.gc_sender_email}}\">{{posValue.gc_sender_email}}</a>) </span>\n<span class=\"gcinfo\"><b>Recipient:</b> {{posValue.gc_recipient_name}} (<a \nhref=\"mailto:{{posValue.gc_recipient_email}}\">{{posValue.gc_recipient_email}}</a>) </span><span class=\"gcinfo\"><b>\nMessage:</b> {{posValue.gc_message}} </span><span class=\"gcinfo\"><b>Code:</b> {{posValue.gc_code}}</span></div><div \nng-if=\"posValue.product_attribute_fields.length>0\"><span class=\"gcinfo\" \nng-repeat=\"(key, value) in posValue.product_attribute_fields\"><b>{{posValue.product_attribute_fields[key]}}</b>\n {{posValue.product_attribute_values[key]}}</span></div><div \nng-class=\"posValue.room_stay_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" \nclass=\"fromToInfo fromto-info-color datepickerfromtoorder no-margin\" \nng-if=\"(posValue.product_is_timebound == 1 && posValue.is_timebound_with_availability == 0) || posValue.type_of_reservation== \'boat_service\'\">\n<div class=\"fromInfo onlycursorPointer\"><md-input-container class=\"md-block full-width\"><label \ntranslate=\"CREATE_RES.CHECKIN\"></label><md-datepicker ng-disabled=\"posValue.auto_added == 1\" md-open-on-focus \nng-model=\"posValue.room_stay_from\" md-min-date=\"vm.minDate\" ng-model-options=\"{debounce: 400}\" \nng-change=\"vm.startDateModified(poskey);vm.setShowModifyBtn(\'Start Date\',\'room_stay_from\',posValue.room_stay_id,\'pos\',poskey);vm.datesChanged(poskey)\" \nclass=\"full-width mdinput-block\" changecheckout></md-datepicker><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div class=\"toInfo onlycursorPointer\"><md-input-container class=\"md-block full-width mb-0\">\n<label translate=\"CREATE_RES.CHECKOUT\"></label><md-datepicker ng-disabled=\"posValue.auto_added == 1\" md-open-on-focus \nng-model-options=\"{debounce: 400}\" ng-model=\"posValue.room_stay_to\" md-min-date=\"vm.endDateMin\" \nng-change=\"vm.endDateModified(posValue.room_stay_to,poskey,$event);vm.setShowModifyBtn(\'End Date\',\'room_stay_to\',posValue.room_stay_id,\'pos\',poskey);vm.datesChanged(poskey)\" \nclass=\"full-width mdinput-block\"></md-datepicker><div class=\"md-errors-spacer\"></div></md-input-container></div></div>\n<div class=\"fromToInfo fromto-info-color datepickerfromtoorder no-margin\" \nng-if=\"posValue.product_is_timebound == 1 && posValue.is_timebound_with_availability == 1\" \nng-click=\"vm.editParkingDates(event,posValue.room_stay_from,posValue.room_stay_to,0,0,posValue.confirmation_number,posValue.product_id,posValue.product_name,vm.order.policy_id ,posValue);\">\n<div ng-class=\"posValue.room_stay_status != \'Canceled\'? \'fromInfo onlycursorPointer\':\'fromInfo\'\"><img \nsrc=\"assets/images/ecommerce/from-black.svg\"> {{posValue.room_stay_from}}</div><div \nng-class=\"posValue.room_stay_status != \'Canceled\'? \'toInfo onlycursorPointer\':\'toInfo\'\"><img \nsrc=\"assets/images/ecommerce/to-black.svg\">{{posValue.room_stay_to}}</div></div></div><div layout=\"column\" \nflex-gt-md=\"30\" flex-gt-xs=\"40\" flex=\"100\" layout-align=\"center center\"><div class=\"active-input-block\"><div \nclass=\"parkingPass onlycursorPointer\" \nng-if=\"posValue.is_timebound_with_availability == 1 && vm.parking_access && posValue.room_stay_status != \'Canceled\'\">\n<img class=\"classSize\" src=\"assets/images/ecommerce/parking.svg\" \nng-click=\"$event.stopPropagation();vm.printParkingPass(posValue);\"><md-tooltip>Print Parking Pass</md-tooltip></div>\n<div class=\"input-block-status\"><md-input-container class=\"md-block mb-0 no-margin\"><md-select \nng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" placeholder=\"status\" \nng-model=\"vm.pos_status[poskey]\" ng-init=\"vm.pos_status[poskey]=posValue.room_stay_status\" \nng-change=\"vm.changeStatusForService(event,posValue.confirmation_number,posValue.room_stay_status,vm.pos_status[poskey],poskey,posValue.grand_total,vm.order.confirmation_number,vm.order.overalltotals.paid_amount,vm.order.total_amount,\'pos\', posValue)\">\n<md-option ng-value=\"key\" ng-repeat=\"(key, value) in vm.statusesPos[poskey]\">{{value}}</md-option></md-select>\n</md-input-container></div><div class=\"amount\">\n{{posValue.type_of_reservation== \'boat_service\' ? posValue.subtotal : posValue.grand_total}}</div></div></div></div>\n<div layout=\"row\" flex=\"100\" layout-wrap class=\"row-nightly-amount row-block1-amount\" \nng-if=\"posValue.product_is_timebound != 1\"><div layout=\"column\" flex=\"55\" layout-align=\"center start\"><div \nclass=\"charges\">Quantity</div></div><div layout=\"column\" flex=\"15\" layout-align=\"center center\"></div><div \nlayout=\"column\" flex=\"30\" layout-align=\"center end\"><div class=\"amount\"><md-input-container class=\"md-block no-margin\" \nng-class=\"posValue.room_stay_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\"><input \nng-model=\"posValue.quantity\" name=\"nightlySum[$index]\" type=\"text\" \nng-change=\"vm.checValue(posValue.quantity, \'pos\',poskey, $event, \'quantity\');vm.setShowModifyBtn(\'Quantitypos{{$index}}\',\'quantity\',posValue.room_stay_id,\'pos\',poskey);vm.calculatePOSTotals(poskey,\'call\')\" \nng-model-options=\"{updateOn: \'blur\'}\" numbers-only autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\">\n</md-input-container></div></div></div><div layout=\"row\" flex=\"100\" layout-wrap \nclass=\"row-nightly-amount row-block1-amount\" ng-if=\"posValue.product_is_timebound != 1\"><div layout=\"column\" flex=\"55\" \nlayout-align=\"center start\"><div class=\"charges\">Rate</div></div><div layout=\"column\" flex=\"15\" \nlayout-align=\"center center\"></div><div layout=\"column\" flex=\"30\" layout-align=\"center end\"><div class=\"amount\">\n<md-input-container class=\"md-block mb-0 no-margin\" \nng-class=\"posValue.room_stay_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\"><i \nclass=\"icon icon-currency-usd s20\"></i> <input ng-model=\"posValue.nightlySum\" name=\"nightlySum[$index]\" type=\"text\" \nng-change=\"vm.checValue(posValue.nightlySum, \'pos\',poskey, $event, \'nightlySum\');vm.setShowModifyBtn(\'nightlySumpos{{$index}}\',\'subtotal\',posValue.room_stay_id,\'pos\',poskey);vm.calculatePOSTotals(poskey,\'call\')\" \nng-model-options=\"{updateOn: \'blur\'}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div>\n</div><div layout=\"row\" flex=\"100\" layout-wrap class=\"row-nightly-amount row-block1-amount\" \nng-if=\"posValue.product_is_timebound != 1\"><div layout=\"column\" flex=\"55\" layout-align=\"center start\"><div \nclass=\"charges\">Discount</div></div><div layout=\"column\" flex=\"15\" layout-align=\"center center\"></div><div \nlayout=\"column\" flex=\"30\" layout-align=\"center end\"><div class=\"amount\"><md-input-container \nclass=\"md-block mb-0 no-margin\" \nng-class=\"posValue.room_stay_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\"><i \nclass=\"icon icon-currency-usd s20\"></i> <input ng-model=\"posValue.product_discount\" name=\"productDiscount[$index]\" \ntype=\"text\" \nng-change=\"vm.checValue(posValue.product_discount, \'pos\',poskey, $event, \'product_discount\'); vm.setShowModifyBtn(\'Discount\',\'product_discount\',posValue.room_stay_id,\'pos\',poskey);vm.changeProductDiscount(poskey,\'call\')\" \nng-model-options=\"{updateOn: \'blur\'}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"> <i \nng-if=\"posValue.product_discount>0\" class=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.opencommentbox(poskey);\"><md-tooltip ng-if=\"posValue.product_discount_comment!=\'\'\">\n{{posValue.product_discount_comment}}</md-tooltip></i></md-input-container></div></div></div></div><div \nclass=\"nightly-price-heading\" \nng-if=\"posValue.product_is_timebound == 1 && posValue.type_of_reservation == \'boat_service\'\">Nightly-price<div \nlayout=\"row\" flex=\"100\" layout-wrap class=\"row-block1-amount row-header-amount\"><div layout=\"column\" flex=\"30\" \nlayout-align=\"center start\">Night</div><div layout=\"column\" flex=\"30\" layout-align=\"center start\">Date</div><div \nlayout=\"column\" flex=\"20\" layout-align=\"center end\">Discount</div><div layout=\"column\" flex=\"20\" \nlayout-align=\"center end\">Price</div></div><div layout=\"row\" ng-repeat=\"(datekey ,eachDate) in posValue.prices.dates\" \nflex=\"100\" layout-wrap class=\"row-nightly-amount row-block1-amount\"><div layout=\"column\" flex=\"30\" \nlayout-align=\"center start\"><div class=\"minusiconouter\"><div class=\"charges\" \nng-if=\"posValue.prices.canceled_nights.indexOf(eachDate) < 0\">Night {{$index+1}}</div><div \nclass=\"charges strikethrough\" ng-if=\"posValue.prices.canceled_nights.indexOf(eachDate) >= 0\">Canceled Night</div><div \nng-class=\"posValue.show_status == \'Canceled\'?\'canceled_order\':\'\'\"><span \nng-class=\"vm.isloading?\'pointer_events_disabled onlycursorPointer minusiconred1\':\'onlycursorPointer minusiconred1\'\" \nng-click=\"vm.cancelThisNightPOS(eachDate,posValue)\" \nng-if=\"(posValue.prices.nightcount[datekey]==1 || posValue.prices.nightcount[datekey]==posValue.nights) && posValue.nights>1 && posValue.prices.canceled_nights.indexOf(eachDate) < 0\">\n<md-icon md-font-icon=\"icon-minus-circle-outline\" class=\"s15 red-A800-fg\"><md-tooltip>No refund cancel</md-tooltip>\n</md-icon></span><span \nng-class=\"vm.isloading?\'pointer_events_disabled onlycursorPointer minusiconred1\':\'onlycursorPointer minusiconred1\'\" \nng-click=\"vm.undoCancelThisNightPOS(eachDate,posValue)\" \nng-if=\"posValue.prices.canceled_nights.indexOf(eachDate) >= 0 && posValue.prices.canUndoNights.indexOf(eachDate) >= 0 && (posValue.prices.nightcancelledCount[datekey]==1 || posValue.prices.nightcancelledCount[datekey]==(posValue.prices.canceled_nights.length) || (posValue.prices.nightcancelledCount[datekey + 1 ] == -1) ||(posValue.prices.nightcancelledCount[datekey + 1 ] != -1))\">\n<md-icon md-font-icon=\"icon-plus-circle-outline\" class=\"s15 md-accent\"><md-tooltip>Undo no refund cancel</md-tooltip>\n</md-icon></span></div></div></div><div layout=\"column\" flex=\"30\" layout-align=\"center start\"><div \nng-class=\"posValue.prices.canceled_nights.indexOf(eachDate) < 0? \'charges\':\'charges strikethrough\'\">{{eachDate}}</div>\n</div><div layout=\"column\" flex=\"20\" layout-align=\"center end\"><div class=\"amount\"><md-input-container \nng-class=\"posValue.room_stay_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\" class=\"md-block no-margin\">\n<i class=\"icon icon-currency-usd s20\"></i> <input ng-model=\"posValue.prices.nightlydiscount[$index]\" \nname=\"nightly_discount_pos[$parent.$index][$index]\" type=\"text\" required \nng-change=\"vm.setShowModifyBtn(\'night-{{$index+1}}\',\'nightlydiscount\',posValue.room_stay_id,\'pos\',poskey);vm.sumnightlyDiscPOS(mykey,poskey,datekey,\'call\',$index)\" \nng-model-options=\"{updateOn: \'blur\'}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"> <i \nng-if=\"posValue.prices.nightlydiscount[$index]>0\" class=\"icon icon-comment-outline onlycursorPointer discountcomment\" \nng-click=\"vm.opencommentboxNightPOS(poskey,datekey,\'call\',$index);\"><md-tooltip \nng-if=\"posValue.prices.nightlydiscountcomment[$index]!=\'\'\">{{posValue.prices.nightlydiscountcomment[$index]}}\n</md-tooltip></i></md-input-container></div></div><div layout=\"column\" flex=\"20\" layout-align=\"center end\"><div \nclass=\"amount\"><md-input-container class=\"md-block no-margin\" \nng-class=\"posValue.room_stay_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\"><i \nclass=\"icon icon-currency-usd s20\"></i> <input ng-model=\"posValue.prices.rates[datekey]\" \nname=\"rate_plan[$parent.$index][$index]\" type=\"text\" \nng-change=\"vm.setShowModifyBtn(\'night-{{$index+1}}\',\'prices\',posValue.room_stay_id,\'pos\',poskey);vm.sumNightsPOS(poskey,\'call\')\" \nng-model-options=\"{updateOn: \'blur\'}\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div>\n</div></div></div></div></div></div></div></div></div><div layout=\"row\" flex=\"100\" class=\"mt-20\"><div layout=\"column\" \nflex=\"100\" flex-sm=\"100\" flex-xs=\"100\" class=\"ph-15 pb-20 mb-40\"><div layout=\"row\" flex=\"100\" class=\"white-bg\" \nlayout-wrap><div layout=\"column\" flex-gt-md=\"70\" flex-gt-sm=\"60\" flex=\"100\"><div \nclass=\"gry-block-tab pv-0 paymentblocktab no-padding\" id=\"data-table-{{vm.selectedIndex}}\"><form \nname=\"EditResPaymentForm\" ng-attr-id=\"{{ \'EditResPaymentForm\' }}\"><div class=\"role-list-out white-bg\"><div \nclass=\"form-title mb-20 payment-font\">Payment Information</div><div ng-if=\"vm.showPaymentsLoader\" \nclass=\"relative-block pt-15\"><md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\">\n</md-progress-circular></div><div ng-if=\"!vm.showPaymentsLoader\"><div class=\"roomTable\" layout=\"row\" flex layout-wrap>\n<div class=\"room-col\" layout=\"column\" flex=\"100\"><table class=\"dataTable row-border no-padding\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsForPayment\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Transaction Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Paid Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Agent</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Payment</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Customer name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Action</span></div></th><th class=\"secondary-text\" ng-hide=\"true\"><div class=\"table-header\"><span \nclass=\"column-title\">Installment id</span></div></th></tr></thead><tbody><tr \nng-repeat=\"(key,installment) in vm.installments\" ng-if=\"key != \'remaining\' && installment.amount>0\"><td>\n{{installment.transaction_id}}</td><td>{{installment.paid_date}}</td><td><span \nng-class=\"installment.status == \'declined\'?\'red-A800-fg\':\'\'\" class=\"refundreason\">{{installment.status}}<md-icon \nmd-font-icon=\"icon-information\" class=\"s18 onlycursorPointer\" ng-if=\"installment.status == \'declined\'\"><md-tooltip \nclass=\"tooltippaymentrefund\">{{installment.txn_reason_desc}}</md-tooltip></md-icon><i \nng-if=\" installment.reason != \'\' \" class=\"icon icon-comment-outline onlycursorPointer discountcomment\"><md-tooltip \nclass=\"tooltippaymentrefund\">{{ installment.reason }}</md-tooltip></i></span></td><td>{{installment.agent}}</td><td>\n{{installment.payment}}</td><td>{{installment.cust_name}}</td><td><span \nng-if=\"installment.status == \'paid\' || installment.status == \'declined\'\">{{installment.amount | currency : $ : 2}}\n</span> <span ng-if=\"installment.status == \'refunded\'\" class=\"red-A800-fg\">-{{installment.amount | currency : $ : 2}}\n</span></td><td><md-button style=\"max-width:100px;max-height:35px;opacity: 1;pointer-events: all\" \nclass=\"md-raised md-accent submit-button white-fg\" ng-click=\"vm.refundInstallment(installment,\'refund\')\" \naria-label=\"Refund\" \nng-if=\"(installment.transaction_status == \'Settled Successfully\' || installment.transaction_status == \'\') && (installment.installment_amount != 0) && (installment.status == \'paid\')\">\nRefund</md-button><md-button style=\"max-width:100px;max-height: 35px;opacity: 1;pointer-events: all\" \nclass=\"md-raised md-accent submit-button white-fg md-red-500-bg\" ng-click=\"vm.refundInstallment(installment,\'void\')\" \naria-label=\"Refund\" \nng-if=\"(installment.transaction_status == \'capturedPendingSettlement\') && installment.installment_amount != 0 && installment.rm_adjustment_indicator == 0 && installment.status == \'paid\'\">\nVoid</md-button><span ng-if=\"installment.transaction_status == \'voided\'\">Voided</span> <span \nng-if=\"installment.transaction_status != \'voided\' && (installment.transaction_status != \'Settled Successfully\' || (installment.transaction_status == \'Settled Successfully\' && installment.installment_amount == 0)) && installment.transaction_status != \'capturedPendingSettlement\'\">\n{{installment.transaction_status}}</span></td><td ng-hide=\"true\">{{installment.installment_id}}</td></tr></tbody>\n</table></div></div><div layout=\"row\" layout-wrap flex=\"100\" class=\"margin-top-25 padding-left-10 padding-right-10\" \nng-if=\"vm.installments[\'remaining\'].balance>0\"><md-input-container style=\"min-width:150px\" \nclass=\"md-block mb-0 mt-15 no-error-spacer\" layout=\"column\" flex=\"20\" layout-align=\"center \" id=\"focus-cccode\"><input \ntype=\"text\" ng-init=\"vm.installment_amount=vm.installments[\'remaining\'].balance\" ng-model=\"vm.installment_amount\" \nng-change=\"vm.checkremainingAmount(vm.selectedIndex)\" allow-decimal-numbers autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"> <input type=\"hidden\" ng-model=\"vm.installments[\'remaining\'].origremainingamt\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container><md-button \nstyle=\"max-width:100px;max-height: 35px\" \nng-class=\"((EditResPaymentForm.$invalid && !vm.fieldsIsReadOnly) || !vm.installment_amount || !vm.payment_method.payment_method) || vm.paymentrequestGoing?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-accent submit-button white-fg\'\" \nng-disabled=\"((EditResPaymentForm.$invalid && !vm.fieldsIsReadOnly) || !vm.installment_amount || !vm.payment_method.payment_method || vm.exp_date_err) || vm.paymentrequestGoing || vm.installment_amount == 0 || (vm.payment_method.payment_method==\'Check\' && !vm.payment_method.check_number)\" \nng-click=\"vm.payInstallment(vm.order.confirmation_number,vm.selectedIndex,vm.order.first_name,vm.order.last_name)\" \naria-label=\"Pay now\">Pay now<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" \nng-show=\"vm.paymentrequestGoing\"></md-progress-circular></md-button><span layout=\"column\" flex=\"100\" \nlayout-align=\"start \" class=\"gcPayNow\" ng-if=\"vm.payingFromGC.price>0\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s15 red-A800-fg\"></md-icon><span class=\"payingFFc\">${{vm.payingFromGC.price}} from gift card</span></span></div>\n<div class=\"form-title mt-15\">Payment Methods</div><div layout=\"row\" flex=\"100\" \nclass=\"margin-bottom-15 margin-top-20 padding-left-10 padding-right-10 margin-bottom-30\" layout-wrap>\n<md-input-container class=\"md-block mb-0 md-input-has-value no-margin\" layout=\"column\" flex=\"100\" flex-gt-md=\"80\" \nflex-gt-sm=\"60\" layout-align=\"center \"><md-radio-group class=\"\" ng-model=\"vm.payment_method.payment_method\" required \nlayout=\"row\" flex=\"100\" layout-wrap ng-change=\"vm.onPaymentMethodSelect(vm.payment_method.payment_method)\">\n<md-radio-button layout=\"column\" flex=\"50\" flex-gt-md=\"25\" flex-gt-xs=\"50\" layout-align=\"center \" \nclass=\"space-block-inline margin-right-0\" ng-repeat=\"paymentMethod in vm.all_payment_methods\" \nng-value=\"paymentMethod.heading\">{{paymentMethod.heading}}</md-radio-button></md-radio-group></md-input-container>\n<md-input-container class=\"md-block mb-0 md-input-has-value no-margin padding-top-8\" layout=\"column\" flex=\"100\" \nflex-gt-md=\"20\" flex-gt-sm=\"40\" layout-align=\"center \"><md-checkbox type=\"checkbox\" ng-model=\"vm.giftCard\" \nclass=\"no-margin\"></md-checkbox>&nbsp;<span class=\"padding-left-10\" translate=\"CREATE_RES.GIFT_CARD\"></span>\n</md-input-container></div><div ng-if=\"vm.giftCard\" ng-disabled=\"!vm.giftCard\"><div layout=\"row\" flex=\"100\"><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" layout-align=\"center\"><div layout=\"row\" flex>\n<md-input-container class=\"md-block mb-0 mb-0\"><label>Apply Gift Card</label><input ng-model=\"vm.giftCardCode\" \nname=\"giftCard\" type=\"text\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div class=\"emailError\">\n{{vm.giftCardErrro}}</div></md-input-container><md-button style=\"max-height:40px\" class=\"md-raised\" \nng-click=\"vm.validateGCCode(vm.selectedIndex)\" ng-disabled=\"vm.giftCardCode==\'\' || vm.gcrequestGoing\">Add\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.gcrequestGoing\">\n</md-progress-circular></md-button></div></div></div></div><div ng-if=\"vm.payment_method.payment_method===\'Check\'\" \nng-disabled=\"vm.payment_method.payment_method!=\'Check\'\"><div layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"50\" flex-xs=\"100\" layout-align=\"center\">\n<md-input-container class=\"md-block mb-0 mb-0\"><label translate=\"CREATE_RES.CHECK_NO\"></label><input \nng-model=\"vm.payment_method.check_number\" name=\"check_number[vm.selectedIndex]\" type=\"text\" required \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div></div><div \nng-if=\"vm.payment_method.payment_method===\'Other\'\" ng-disabled=\"vm.payment_method.payment_method!=\'Other\'\"><div \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"50\" \nflex-xs=\"100\" layout-align=\"center\"><md-input-container class=\"md-block mb-0 mb-0\"><label \ntranslate=\"CREATE_RES.OTHER_COMMENT\"></label><textarea ng-model=\"vm.payment_method.other_comment\" \nname=\"other_comment[vm.selectedIndex]\"></textarea></md-input-container></div></div></div><div \nng-if=\"vm.payment_method.payment_method === \'Credit Card\'\" \nng-disabled=\"vm.payment_method.payment_method!=\'Credit Card\'\" ng-attr-id=\"{{ \'paymentccblock-\' + vm.selectedIndex }}\" \nclass=\"fontsize-15\"><div ng-if=\"vm.addNewCard || vm.allcardsInfo.length == 0\"><label style=\"color:red\" \nid=\"authorizenet-swiper-status\" ng-click=\"vm.swipeNow()\" for=\"authorizenetswiper-data\" class=\"ph-10\">{{vm.swipeText}}\n</label><input type=\"text\" style=\"height: 1px; width: 1px; border: 0 none; color: #FFF; font-size: 1px\" title=\"Swiper\" \ncode=\"authorizenet\" class=\"input-text webpos_swiper_input\" ng-model=\"vm.ccinfo_a\" ng-focus=\"vm.readySwipe()\" \nng-blur=\"vm.resetSwipe()\" ng-keyup=\"vm.keyupfunction($event)\" id=\"authorizenet-swiper-data\" \nname=\"authorizenet-swiper-data\" value=\"    \" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></div><div layout=\"row\" \nflex layout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"50\" \nlayout-align=\"center \" ng-if=\"vm.allcardsInfo.length>0\"><md-input-container class=\"md-block mb-0\" layout=\"column\" \nflex=\"100\" flex-gt-md=\"50\" flex-gt-xs=\"50\" layout-align=\"center \"><label translate=\"CREATE_RES.USE_EXISTINGCARD\">\n</label><md-select ng-model=\"vm.use_existingcard\" ng-change=\"vm.changeActiveCard(vm.selectedIndex,vm.selectedIndex)\">\n<md-option ng-value=\"key\" ng-repeat=\"(key,cardData) in vm.allcardsInfo\">\nxxxx-{{cardData.cc_number}}({{cardData.cc_type}}){{cardData.cc_is_incidental==0?\'\':\'*Incidentals\'}}</md-option>\n</md-select><div class=\"md-errors-spacer\" style=\"display:block\"></div></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"50\" layout-align=\"start\"><div><md-button \nstyle=\"max-height:40px;max-width:150px\" class=\"md-raised mt-15\" ng-click=\"vm.emptythisPayment(vm.selectedIndex)\" \nng-if=\"vm.allcardsInfo.length > 0 && !vm.addNewCard\">Add New Card</md-button><md-button \nstyle=\"max-height:40px;max-width:150px\" class=\"md-raised mt-15\" \nng-click=\"vm.setasincidental(vm.order.confirmation_number,vm.selectedIndex,vm.order.first_name,vm.order.last_name, \'not_incidental\')\" \nng-if=\"vm.allcardsInfo.length == 0 || vm.addNewCard\" \nng-disabled=\"(EditResPaymentForm.$invalid && !vm.fieldsIsReadOnly) || vm.not_incidental\">Save New Card\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.not_incidental\">\n</md-progress-circular></md-button><md-button ng-if=\"vm.payment_method.cc_is_incidental!=1 && !vm.addNewCard\" \nstyle=\"max-height:40px;max-width:150px\" class=\"md-raised mt-15\" \nng-click=\"vm.setasincidental(vm.order.confirmation_number,vm.selectedIndex,vm.order.first_name,vm.order.last_name, \'is_incidental\')\" \nng-disabled=\"(EditResPaymentForm.$invalid && !vm.fieldsIsReadOnly) || vm.incidentalrequestGoing\">Set as Incidental\n<md-progress-circular class=\"md-accent md-hue-1 payNowProgress\" md-diameter=\"20px\" ng-show=\"vm.incidentalrequestGoing\">\n</md-progress-circular></md-button></div></div></div><div ng-class=\"vm.fieldsIsReadOnly?\'pointer_events_disabled\':\'\'\">\n<div layout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10 orange-500-fg mb-10\" \nlayout=\"column\" flex=\"50\" flex-xs=\"100\" layout-align=\"center\" ng-if=\"vm.payment_method.cc_is_incidental==1\">\n*Incidental Card</div></div><div layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10 datepicker-block\" layout=\"column\" flex-xs=\"100\" flex=\"100\" \nlayout-align=\"center \"><div layout=\"row\" flex=\"100\" layout-wrap><md-input-container class=\"md-block mb-0\" \nlayout=\"column\" flex=\"80\"><label translate=\"CREATE_RES.CC_NUMBER\"></label><input \nng-model=\"vm.payment_method.cc_number_mask\" name=\"cc_number_mask\" type=\"text\" required \nng-keyup=\"vm.creditCardChanged($event,EditResPaymentForm[\'cc_number\'].$ccEagerType,vm.payment_method)\" maxlength=\"16\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div \nng-show=\"!vm.fieldsIsReadOnly && EditResPaymentForm[\'cc_number_mask\'].$touched\"><div \nng-show=\"!EditResPaymentForm[\'cc_number\'].$valid\" ng-hide=\"EditResPaymentForm[\'cc_number\'].$valid\" class=\"emailError\">\n{{ \'CREATE_RES.CR_NOT_VALID\' | translate }}</div></div><div ng-show=\"vm.notCardType\" ng-hide=\"!vm.notCardType\" \nclass=\"emailError\">{{ \'CREATE_RES.CR_NOT_ALOWD\' | translate }}</div></md-input-container><input \nng-model=\"vm.payment_method.cc_number\" name=\"cc_number\" type=\"hidden\" cc-number cc-eager-type autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"> <input type=\"hidden\" ng-model=\"vm.payment_method.customer_profile_id\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"> <input type=\"hidden\" ng-model=\"vm.payment_method.payment_profile_id\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"><div cc_type=\"{{vm.payment_method.cc_type?vm.payment_method.cc_type:vm.ct }}\" \nclass=\"{{vm.payment_method.cc_type? vm.payment_method.cc_type:vm.ct}}\" layout=\"column\" flex=\"20\"></div></div></div>\n</div><div layout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"33\" layout-align=\"center\"><md-input-container class=\"md-block mb-0\"><label \ntranslate=\"CREATE_RES.EXP_MONTH\"></label><md-select name=\"cc_exp_date\" ng-model=\"vm.payment_method.cc_exp_month\" \nng-change=\"vm.checkValidExpDate()\" required><md-option ng-value=\"key\" ng-repeat=\"(key,months) in vm.dates_option\">\n{{months}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-gt-xs=\"33\" flex=\"100\" layout-align=\"center\">\n<md-input-container class=\"md-block mb-0\"><label translate=\"CREATE_RES.EXP_YEAR\"></label><md-select name=\"cc_exp_year\" \nng-model=\"vm.payment_method.cc_exp_year\" ng-change=\"vm.checkValidExpDate()\" required><md-option ng-value=\"year\" \nng-repeat=\"year in vm.yrs_option\">{{year}}</md-option></md-select><div ng-show=\"vm.exp_date_err\" \nng-hide=\"!vm.exp_date_err\" class=\"emailError\">{{ \'CREATE_RES.EX_DATE_NOT_VALID\' | translate }}</div><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div class=\"padding-left-10 padding-right-10\" \nlayout=\"column\" flex-gt-xs=\"33\" flex=\"100\" layout-align=\"center \"><md-input-container class=\"md-block mb-0\"><label \ntranslate=\"CREATE_RES.CC_CVN\"></label><input ng-model=\"vm.payment_method.cc_cid\" name=\"cc_cvv{{vm.selectedIndex}}\" \ntype=\"text\" ng-required=\"!vm.fieldsIsReadOnly\" cc-cvc autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"><div \nng-show=\"EditResPaymentForm[\'cc_cvv\' + vm.selectedIndex].$touched\"><div \nng-show=\"!EditResPaymentForm[\'cc_cvv\' + vm.selectedIndex].$valid && !EditResPaymentForm[\'cc_cvv\' + vm.selectedIndex].$error.required\" \nclass=\"emailError\">{{ \'CREATE_RES.CVN_NOT_VALID\' | translate }}</div></div></md-input-container></div></div><div \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" \nflex=\"33\" layout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0\"><label \ntranslate=\"CREATE_RES.CUST_FN_CC\"></label><input ng-model=\"vm.payment_method.cc_fname\" name=\"cc_fn[vm.selectedIndex]\" \ntype=\"text\" required autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div><div \nclass=\"padding-left-10 padding-right-10\" layout=\"column\" flex-xs=\"100\" flex=\"33\" layout-align=\"center \">\n<md-input-container class=\"md-block mb-0 mb-0\"><label translate=\"CREATE_RES.CUST_MN_CC\"></label><input \nng-model=\"vm.payment_method.cc_mname\" name=\"cc_mn[vm.selectedIndex]\" type=\"text\" autocomplete=\"off\" \nng-readonly=\"vm.autoFillOff\"></md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"33\" flex-xs=\"100\" layout-align=\"center \"><md-input-container class=\"md-block mb-0 mb-0\"><label \ntranslate=\"CREATE_RES.CUST_LN_CC\"></label><input ng-model=\"vm.payment_method.cc_lname\" name=\"cc_ln[vm.selectedIndex]\" \ntype=\"text\" autocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div></div></div></div></div>\n</form></div></div><div layout=\"column\" flex-gt-md=\"30\" flex-gt-sm=\"40\" flex=\"100\" class=\"subtotalborder-left pv-20\">\n<div class=\"section-right-genral role-list-out featured-rol-block\"><div \nclass=\"display-inline-block role-list-out white-bg top-sp-main no-padding\"><div layout=\"row\" flex=\"100\" layout-wrap>\n<div class=\"sub-total-section\" layout=\"row\" flex=\"100\" ng-if=\"vm.resortFeeAppliedVisible && vm.pageType != \'rent\'\"><div\n class=\"sub-total-col md-accent-fg\" layout=\"column\" flex=\"50\" \nlayout-align=\"{{(vm.multOrSinglePayment && vm.selectedIndex > 0)?\'center end\':\'center start\'}}\">\n{{vm.resortFeeApplied[vm.selectedIndex]?\'Resort Fee Applied\':\'Resort Fee Removed\'}}</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"50\" layout-align=\" end end\"><md-switch ng-change=\"vm.updateResortFee(vm.selectedIndex)\" \nclass=\"m-0\" md-no-ink aria-label=\"Switch No Ink\" ng-model=\"vm.resortFeeApplied[vm.selectedIndex]\"></md-switch></div>\n</div><div class=\"sub-total-section\" ng-if=\"!vm.extraPersonPos && !vm.order.boat_data\" layout=\"row\" flex=\"100\" \nlayout-wrap ng-class=\"vm.order.show_status == \'Canceled\' || vm.modify_request?\'canceled_order\':\'\'\"><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\" center start\">\n{{ vm.pageType == \'rent\' ? \'Application Fee\':\'Extra Person Charges\'}}{{$index}}</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" flex=\"35\" \nlayout-align=\"center end \"><div class=\"amount\"><md-input-container class=\"md-block mb-0 no-margin\"><i \nclass=\"icon icon-currency-usd s20\"></i> <input ng-model-options=\"{updateOn: \'blur\'}\" \nng-change=\"vm.setShowModifyBtn(\'ExtraCharges\',\'additional_guest_amounts\',vm.order.room_stay_id);vm.calculateOrderTotals();\" \nng-model=\"vm.order.additional_guest_amounts\" name=\"additional_guest_amounts[vm.selectedIndex]\" type=\"text\" \nautocomplete=\"off\" ng-readonly=\"vm.autoFillOff\"></md-input-container></div></div></div><div class=\"sub-total-section\" \nlayout=\"row\" flex=\"100\" layout-wrap><div class=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\"center start\">\n<div flex=\"100\" layout-align=\"center center\" layout=\"row\"><span layout=\"column\">Subtotal</span></div></div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"35\" layout-align=\"center end\" \nng-if=\"vm.order.commision_charges>0 && vm.order.collect_which==\'channel_collect\'\">\n{{vm.sumOfVals(vm.order.overalltotals.subtotal,vm.order.commision_charges) | currency : $ : 2}}</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end\" \nng-if=\"vm.order.commision_charges<=0 || vm.order.collect_which!=\'channel_collect\'\">\n{{vm.order.overalltotals.subtotal | currency : $ : 2}}</div></div><div class=\"sub-total-section\" layout=\"row\" \nflex=\"100\" layout-wrap ng-if=\"vm.order.commision_charges>0 && vm.order.collect_which==\'channel_collect\'\"><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"40\" layout-align=\" center start\"><div flex=\"100\" \nlayout-align=\"center center\" layout=\"row\"><span layout=\"column\">OTA</span></div></div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"60\" layout-align=\"center end \">\n${{vm.order.commision_charges}} + {{vm.order.overalltotals.subtotal | currency : $ : 2}}</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap><div class=\"sub-total-col\" layout=\"column\" flex=\"50\" \nlayout-align=\" center start\">Discount</div><div class=\"sub-total-col\" layout=\"column\" flex=\"15\" \nlayout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end \">\n({{vm.order.overalltotals.product_discount | currency : $ : 2}})</div></div><div class=\"sub-total-section\" \nlayout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.order.overalltotals.product_discount>0 || vm.order.commision_charges>0 && vm.order.collect_which==\'channel_collect\'\">\n<div class=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\" center start\"><div flex=\"100\" \nlayout-align=\"center center\" layout=\"row\"><span layout=\"column\">New Subtotal</span></div></div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"35\" layout-align=\"center end \">\n{{(vm.order.overalltotals.subtotal-vm.order.overalltotals.product_discount) | currency : $ : 2}}</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap \nng-repeat=\"(taxKey,taxValue) in vm.order.overalltotals.tax_names\" \nng-if=\"(vm.order.overalltotals.tax_names.length > 0 && vm.order.overalltotals.tax_amounts[taxKey] > 0) || (vm.order.overalltotals.tax_names.length > 0 && taxValue == \'Long Term Stay\')\">\n<div class=\"sub-total-col\" layout=\"column\" flex=\"50\" layout-align=\" center start\">{{taxValue}}</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"35\" layout-align=\"center end \">{{vm.order.overalltotals.tax_amounts[taxKey] | currency : $ : 2}}\n</div></div><div class=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap><div class=\"sub-total-col\" \nlayout=\"column\" flex=\"50\" layout-align=\" center start\">Grand Total</div><div class=\"sub-total-col\" layout=\"column\" \nflex=\"15\" layout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" flex=\"35\" \nlayout-align=\"center end \">{{vm.order.overalltotals.grand_total | currency : $ : 2}}</div></div><div \nclass=\"sub-total-section\" layout=\"row\" flex=\"100\" layout-wrap><div class=\"sub-total-col\" layout=\"column\" flex=\"50\" \nlayout-align=\" center start\">Paid Amount</div><div class=\"sub-total-col\" layout=\"column\" flex=\"15\" \nlayout-align=\" center center\">:</div><div class=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end \">\n{{vm.order.overalltotals.paid_amount | currency : $ : 2}}</div></div><div class=\"sub-total-section\" layout=\"row\" \nflex=\"100\" layout-wrap><div class=\"sub-total-col md-accent-fg\" layout=\"column\" flex=\"50\" layout-align=\" center start\">\nRemaining Amount</div><div class=\"sub-total-col\" layout=\"column\" flex=\"15\" layout-align=\" center center\">:</div><div \nclass=\"sub-total-col\" layout=\"column\" flex=\"35\" layout-align=\"center end \">\n{{vm.order.overalltotals.remaining_amount | currency : $ : 2}}</div></div></div></div></div></div></div></div></div>\n</div></md-tab><md-tab label=\"Notes\" ng-click=\"vm.fetchOrderCommentsRequests(vm.order.confirmation_number)\" \nstyle=\"height:100%\"><div class=\"gry-block-tab spInfo comments_section\"><div class=\"white-bg mh-10 width-calc\" \nstyle=\"height:100%\" layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-xs=\"100\"><div \nlayout=\"row\" flex=\"100\" layout-wrap class=\"mt-30\"><div class=\"padding-left-10 padding-right-10\" layout=\"column\" \nflex=\"100\" flex-gt-md=\"40\" flex-gt-sm=\"50\" layout-align=\"start end \"><md-input-container \nclass=\"md-block mb-0 mt-0 full-width\"><label translate=\"CREATE_RES.NOTE\"></label><textarea \nng-model=\"vm.comm_req_value\"></textarea></md-input-container></div><div class=\"padding-left-10 padding-right-10\" \nlayout=\"column\" flex=\"100\" flex-gt-md=\"30\" flex-gt-sm=\"50\" layout-align=\"center start \"><md-input-container \nclass=\"md-block mb-0 mt-0\"><md-radio-group class=\"no-margin\" ng-init=\"vm.comm_req_type = \'comment\'\" \nng-model=\"vm.comm_req_type\"><md-radio-button class=\"space-block-inline\" value=\"comment\">\n{{ \'CREATE_RES.COMMENT\' | translate }}</md-radio-button><md-radio-button class=\"space-block-inline margin-left-15\" \nvalue=\"special_request\">{{ \'CREATE_RES.SPECIAL_RQST\' | translate }}</md-radio-button></md-radio-group>\n</md-input-container></div><div class=\"padding-left-10 padding-right-10\" layout=\"column\" flex=\"100\" flex-gt-md=\"30\" \nflex-gt-sm=\"100\" layout-align=\"start start\"><md-button style=\"max-width:100px\" \nng-class=\"!vm.comm_req_value?\'md-raised md-accent submit-button grey-100-fg\':\'md-raised md-accent submit-button white-fg\'\" \nng-disabled=\"!vm.comm_req_value\" ng-click=\"vm.saveCommentReq(vm.selectedIndex,vm.order.confirmation_number)\" \naria-label=\"add comment\">Submit</md-button></div></div></div><div class=\"no-results text-center full-width\" \nng-if=\"vm.commentsSpecial.special_request.length === 0 && vm.commentsSpecial.comments.length === 0\"><div \nclass=\"message\"><div class=\"message-text\" translate=\"EC.NO_SPE_REQ\"></div></div></div></div><div \nclass=\"messanary-block\"><ms-masonry class=\"notes\" options=\'{\"columnCount\":3}\' flex=\"100\" layout-wrap><ms-masonry-item \nclass=\"note special_note\" ng-repeat=\"note in vm.commentsSpecial.special_request\" ms-note-item=\"note\"></ms-masonry-item>\n<ms-masonry-item class=\"note\" ng-repeat=\"note in vm.commentsSpecial.comment\" ms-note-item=\"note\"></ms-masonry-item>\n</ms-masonry></div></div></md-tab><md-tab label=\"History\" \nng-click=\"vm.fetchOrderHistory(vm.order.confirmation_number)\"><div class=\"gry-block-tab listorderblock\"><div \nclass=\"mh-10 width-calc\"><div ng-if=\"!vm.no_found\" class=\"role-list-out white-bg relative-block featured-block-main\" \nng-repeat=\"order_history in vm.order.order_history\"><div layout=\"row\" flex=\"100\" layout-wrap><div \nclass=\"padding-left-10 padding-right-10 pb-10\" layout=\"column\" flex=\"50\" layout-align=\"center\"><p \nclass=\"form-title no-padding no-margin\">{{order_history.confirmation_number}}</p></div><div \nclass=\"padding-left-10 padding-right-10 pb-10\" layout=\"column\" flex=\"50\" layout-align=\"center end\"><p \nclass=\"no-padding no-margin\">{{order_history.created_date}}</p></div></div><div \nclass=\"Fromto padding-left-10 padding-right-10 pv-10\" layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"30\" flex-gt-xs=\"20\"><strong class=\"order-history-name pv-5\">{{order_history.product_name}}\n</strong></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"35\" flex-gt-xs=\"40\" \nng-if=\"order_history.type_of_reservation == \'reservation\' || posValue.product_is_timebound == 1\"><div layout=\"row\" \nflex=\"100\"><div class=\"Fromto-col\" layout=\"column\" flex=\"45\" layout-align=\"start center\"><div layout=\"row\" flex=\"100\">\n<div layout=\"column\" flex=\"100\" layout-align=\"center\">From : {{order_history.room_stay_from}}</div></div></div><div \nclass=\"Fromto-col\" layout=\"column\" flex=\"45\" layout-align=\"start center\"><div layout=\"row\" flex=\"100\" layout-wrap><div \nlayout=\"column\" flex=\"100\" layout-align=\"center\">To : {{order_history.room_stay_to}}</div></div></div></div></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"35\" flex-gt-xs=\"40\" ng-if=\"order_history.type_of_reservation == \'reservation\'\">\n<div layout=\"row\" flex=\"100\"><div class=\"Fromto-col\" layout=\"column\" flex=\"20\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account-multiple\"></md-icon></div><div class=\"Fromto-col padding-left-10 padding-right-10\" \nlayout=\"column\" flex=\"50\"><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex-gt-sm=\"50\" flex=\"40\" \nlayout-align=\" center\"><label>Adult</label></div><div layout=\"column\" flex-gt-sm=\"50\" flex=\"60\" layout-align=\"center\">\n{{order_history.room_stay_guest_count}}</div></div></div><div class=\"Fromto-col padding-left-10 padding-right-10\" \nlayout=\"column\" flex=\"50\"><div layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex-gt-sm=\"50\" flex=\"40\" \nlayout-align=\"center\"><label>Child</label></div><div layout=\"column\" flex-gt-sm=\"50\" flex=\"60\" layout-align=\" center\">\n{{order_history.room_stay_child_count}}</div></div></div></div></div></div><div \nclass=\"roomTable simple-table-container\" layout=\"row\" flex layout-wrap><div class=\"room-col Housekeepingtable\" \nlayout=\"column\" flex=\"100\"><table class=\"row-border no-padding tablemain-ordersimple\" cellpadding=\"0\" cellspacing=\"0\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Qty/Night(s)</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Extra Person Charges</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Rate($)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Subtotal($)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Discount($)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Grand Total</span></div></th></tr></thead>\n<tbody><tr><td>{{order_history.qty}}</td><td>{{order_history.additional_guest_amounts}}</td><td>\n{{order_history.subtotal | currency : $ : 2}}</td><td \nng-if=\"order_history.type_of_reservation == \'reservation\' || order_history.type_of_reservation == \'boat\'\">\n{{vm.calculatesubtotal(order_history.additional_guest_amounts,order_history.subtotal)}}</td><td \nng-if=\"(order_history.type_of_reservation == \'service\' || order_history.type_of_reservation == \'boat_service\') && order_history.product_is_timebound!=1\">\n{{vm.calculatesubtotalPos(order_history.qty,order_history.subtotal)}}</td><td \nng-if=\"(order_history.type_of_reservation == \'service\' || order_history.type_of_reservation == \'boat_service\') && order_history.product_is_timebound==1\">\n{{order_history.subtotal}}</td><td>{{order_history.product_discount | currency : $ : 2}}</td><td>\n{{order_history.grand_total | currency : $ : 2}}</td></tr></tbody></table></div></div><div class=\"nightly-price\" \nlayout=\"row\" flex layout-wrap \nng-if=\"order_history.type_of_reservation == \'reservation\' || posValue.product_is_timebound == 1\"><div \nclass=\"padding-right-20 padding-top-10 padding-bottom-10\" layout=\"column\" flex=\"50\" flex-gt-sm=\"25\" flex-gt-xs=\"50\" \nlayout-align=\" center\" ng-repeat=\"eachnight in order_history.prices.dates\"><span class=\"padding-bottom-5 weight\">\nNight {{$index+1}} </span><span>{{order_history.prices.dates[$index]}} - {{order_history.prices.rate_plan[$index]}}\n</span> <span>{{order_history.prices.rates[$index]}}</span></div></div><div class=\"order_history_cmnt padding-15\" \nlayout=\"row\" flex ng-if=\"order_history.order_history_comment != null\"><div class=\"room-col\" layout=\"column\" flex=\"100\">\n<div layout=\"row\" flex layout-wrap><span translate=\"HISTORY.{{order_history.order_history_comment}}\"></span></div>\n</div></div></div><div ng-if=\"vm.no_found\" \nclass=\"role-list-out white-bg relative-block featured-block-main no-padding\"><div class=\"roomName padding-15\" \nlayout=\"row\" flex><div class=\"room-col\" layout=\"column\" flex=\"100\"><div layout=\"row\" flex layout-wrap><strong \nlayout=\"column\" flex-gt-md=\"80\" flex-gt-md=\"70\" flex-gt-xs=\"60\" flex=\"100\" layout-align=\"center start\" class=\"pv-10\" \ntranslate=\"HISTORY.NOFOUND\"></strong></div></div></div></div></div></div></md-tab></md-tabs></div></div></div></div>\n</div></div>");
$templateCache.put("app/main/apps/e-commerce/views/orders/order/printInvoice/printInvoice.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"printInvoice\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall white-fg\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top editcontacts\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" ng-if=\"vm.typePrint == \'invoice\'\">Invoice</span> <span class=\"title\" \nng-if=\"vm.typePrint == \'registrationcard\'\">Registration Card</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\" class=\"white-fg\"></md-icon></md-button></div></md-toolbar><md-dialog-content>\n<md-content class=\"md-padding\"><div class=\"row-block\"><div class=\"consolidate_wrapper\"><span \nng-if=\"vm.typePrint == \'invoice\'\">Print Invoice For</span> <span ng-if=\"vm.typePrint == \'registrationcard\'\">\nPrint Registration Card For</span><md-input-container class=\"md-block tax-inputs padding-right-10 padding-left-10\" \nflex-gt-xs=\"100\"><md-checkbox ng-model=\"vm.customer\" aria-label=\"room\" class=\"md-align-top-left no-margin\" flex \nng-change=\"vm.changeOption(\'customer\')\"><span class=\"ipsum\">Billing Customer</span></md-checkbox></md-input-container>\n<md-input-container class=\"md-block tax-inputs padding-right-10 padding-left-10\" flex-gt-xs=\"100\"><md-checkbox \nng-model=\"vm.traveller\" aria-label=\"ancilaries\" class=\"md-align-top-left no-margin\" flex \nng-change=\"vm.changeOption(\'traveller\')\"><span class=\"ipsum\">Traveler/Guest</span></md-checkbox></md-input-container>\n<div class=\"travellsInfo\"><md-input-container class=\"md-block tax-inputs padding-right-10 padding-left-10\" \nflex-gt-xs=\"100\" ng-repeat=\"(key, value) in vm.travellerInfo\"><md-checkbox \nng-model=\"vm.subTravellers[\'_\'+value.travellerId]\" aria-label=\"ancilaries\" class=\"md-align-top-left no-margin\" flex \nng-change=\"vm.changeSubTravellers()\"><span class=\"ipsum\">{{value.name}}</span></md-checkbox></md-input-container></div>\n</div></div></md-content></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"end end\" flex=\"100\"><md-button type=\"submit\" ng-click=\"vm.printInvoice()\" \nng-disabled=\"vm.disableButton\" \nng-class=\"vm.disableButton ? \'md-raised md-accent submit-button grey-100-fg \': \'md-raised md-accent submit-button grey-100-fg md-green-500-bg\'\">\nPrint</md-button></div></md-dialog-actions></form></md-dialog><style type=\"text/css\">.travellsInfo {margin-left: 40px;}\n</style>");
$templateCache.put("app/main/apps/e-commerce/views/roomtype/dialogs/roomtype/roomtype-dialog.html","<style type=\"text/css\">.cropArea {\n  background: #E4E4E4;\n  overflow: hidden;\n  width:500px;\n  height:350px;\n}</style>\n<md-dialog class=\"contact-dialog crop-image-area\" ng-class=\"vm.requestType == \'viewImg\' ? \'crop-image-area-sm\' : \'\'\" \naria-label=\"New Task\" style=\"overflow: visible\"><md-dialog-content class=\"no-padding\" style=\"overflow: visible\" \nng-class=\"vm.requestType == \'viewImg\' ? \'coverphotorotate\' : \'\'\"><md-content class=\"md-padding margin-top\" \nstyle=\"overflow: visible\"><div class=\"cross-icons cross-icons-dilog\"><a ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close \" class=\"close-icon1 white-fg font-size-12\"></md-icon></a></div><div \nclass=\"content-scrol-block no-margin\" style=\"overflow: hidden\" ng-if=\"vm.requestType == \'viewImg\'\"><div \nclass=\"scroll-pop-block1\"><img id=\"imageForRotation\" src=\"{{vm.image}}\"><div \nstyle=\"bottom: 4%;text-align: center;position: fixed;left:45%\"><button ng-disabled=\"vm.imageRotation\" \nng-click=\"counterclockwise()\" style=\"cursor: pointer\"><i id=\"counterclockwise\" class=\"icon icon-rotate-left s40\" \nstyle=\"background: rgba(0, 0, 0, 0.54);color:white\"></i></button> <button ng-disabled=\"vm.imageRotation\" \nng-click=\"clockwise()\" style=\"cursor: pointer\"><i id=\"clockwise\" class=\"icon icon-rotate-right s40\" \nstyle=\"background: rgba(0, 0, 0, 0.54);color:white\"></i></button></div></div></div><div \nclass=\"content-scrol-block no-margin\" ms-scroll style=\"overflow: hidden\" ng-if=\"vm.requestType == \'cropImg\'\"><div \nclass=\"scroll-pop-block1\"><div class=\"cropArea\" id=\"cropArea\"><ui-cropper image=\"myImage\" ng-disabled \narea-type=\"rectangle\" aspect-ratio=\"2\" result-image=\"myCroppedImage\" result-image-size=\"{w: 1130,h: 552}\" \nresult-image-quality=\"1.0\" init-max-area=\"false\" live-view=\"blockingObject\" area-min-size=\"{w:500,h:330}\"></ui-cropper>\n<span id=\"progressBar1\" class=\"progress loading-process\" ng-show=\"vm.imageCropping || vm.progress1\" \nstyle=\"bottom: 23%\"><div id=\"progress1\" style=\"width:{{vm.progressnum1}}%\" ng-bind=\"vm.progressnum1+ \'%\'\" \nng-show=\"vm.progress1\"></div><div id=\"processing1\" ng-show=\"vm.imageCropping\">Processing upload <img \nsrc=\"{{vm.feBaseUrl+\'images/ecommerce/loader.gif\'}}\"></div></span></div><div class=\"btn-group btn-group-justified\" \nstyle=\"text-align: center;padding: 10px\"><a data-ng-click=\"saveCropImage()\" class=\"btn btn-success\" \nstyle=\"color:white\"><md-button class=\"md-raised md-background\"><span translate=\"GROUPS.SAVE\"></span></md-button></a><a \nng-click=\"vm.closeDialog()\" class=\"btn btn-info\" style=\"color:white\"><md-button class=\"md-raised md-background\"><span \ntranslate=\"GROUPS.CANCEL\"></span></md-button></a></div></div></div><iframe ng-if=\"vm.type == \'pdf\'\" \nng-src=\"{{trustSrc(vm.pdfPath)}}\" width=\"100%\" class=\"iframepdfpath\"></iframe></md-content></md-dialog-content>\n</md-dialog>");}]);